/* bitwise: true */
'use strict';

/**
 * Main module of the application.
 */
angular
.module('paycircleApp', [
	'angular.filter',
	'angular-growl',							// Growl - Message Provider
	'ngMessages', 								// Angular messages
	'angularUtils.directives.dirPagination',	// Pagination
	'ui.router', 								// Advanced Angular Routing
	'angularFileUpload',                    	// File Upload component
	'ui.validate',								// Custom validator
	'monospaced.qrcode',						// QR code generator
	'ngAria',									// Provides support for ARIA attributes
	'ngSanitize'								// Sanitizes HTML bindings
])

/* Routing */
.config(['$urlRouterProvider', function ($urlRouterProvider) {

	$urlRouterProvider.otherwise('/login');
}])

/* Location */
.config(['$locationProvider', function ($locationProvider) {

	$locationProvider.html5Mode(true);
}])

/* Messaging */
.config(['growlProvider', function (growlProvider) {

	growlProvider.globalTimeToLive(5000);
	growlProvider.globalDisableCountDown(true);
	growlProvider.globalDisableIcons(true);
}])

/* Ajax Calls */
.config(['$httpProvider', function ($httpProvider) {

	// Set HTTP Defaults
	$httpProvider.defaults.withCredentials = true;
	$httpProvider.defaults.cache = true;
	$httpProvider.useApplyAsync(true);

	// HTTP Interceptor
	$httpProvider.interceptors.push(['$injector', function ($injector) {
		return $injector.get('httpInterceptor');
	}]);
}])

/* Q Provider */
.config(['$qProvider', function ($qProvider) {

	$qProvider.errorOnUnhandledRejections(false);
}])

/* Localisation */
.config(['config', function (config) {

	moment.locale('en-gb', {
		months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
		monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
		weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
		weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
		weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
		longDateFormat : {
			LT : 'HH:mm',
			LTS : 'HH:mm:ss',
			L : 'DD/MM/YYYY',
			LL : 'D MMMM YYYY',
			LLL : 'D MMMM YYYY LT',
			LLLL : 'dddd, D MMMM YYYY LT'
		},
		calendar : {
			sameDay : '[Today]',
			nextDay : '[Tomorrow]',
			nextWeek : 'dddd',
			lastDay : '[Yesterday]',
			lastWeek : '[Last] dddd',
			sameElse : 'ddd D MMM'
		},
		relativeTime : {
			future : 'in %s',
			past : '%s ago',
			s : 'a few seconds',
			m : 'a minute',
			mm : '%d minutes',
			h : 'an hour',
			hh : '%d hours',
			d : 'a day',
			dd : '%d days',
			M : 'a month',
			MM : '%d months',
			y : 'a year',
			yy : '%d years'
		},
		ordinalParse: /\d{1,2}(st|nd|rd|th)/,
		ordinal : function (number) {
			var b = number % 10,
				output = (~~(number % 100 / 10) === 1) ? 'th' :
				(b === 1) ? 'st' :
				(b === 2) ? 'nd' :
				(b === 3) ? 'rd' : 'th';
			return number + output;
		},
		week : {
			dow : 1, // Monday is the first day of the week.
			doy : 4  // The week that contains Jan 4th is the first week of the year.
		}
	});

	// Set default timezone to match server
	moment.tz.setDefault(config.defaultTimeZone);
}])

.config(['$compileProvider', function ($compileProvider) {
	$compileProvider.debugInfoEnabled(true); // enable tests
}])

/* Run App */
.run([
	'$http',
	'$rootScope',
	'config',
	'growl',
	'intercomService',
	'securityService',
	'session',
	'utilities',
	'DEMO_TASKS',
	'REGEX',
	'URLS',
	'PLACEHOLDERS',
	function (
		$http,
		$rootScope,
		config,
		growl,
		intercomService,
		securityService,
		session,
		utilities,
		DEMO_TASKS,
		REGEX,
		URLS,
		PLACEHOLDERS
	) {

	$rootScope.CONFIG 			= config;
	$rootScope.DEMO_TASKS		= DEMO_TASKS;
	$rootScope.PLACEHOLDERS 	= PLACEHOLDERS;
	$rootScope.REGEX 			= REGEX;
	$rootScope.URLS 			= URLS;
	$rootScope.isDevelopment	= utilities.isDevelopment();

	// Functions
	function paycircleMessage (message, messageType) {

		// Prefix any string only messages
		if (angular.isString(message)) {
			message = 'Paycircle: ' + message;
		}

		switch (messageType) {
			case 'alert':
				window.alert(message);
				break;
			case 'error':
				console.error(message);
				break;
			case 'info':
				console.info(message);
				break;
			case 'warn':
				console.warn(message);
				break;
			default:
				console.log(message);
		}

		return;
	}

	function openSupportTab () {

		intercomService.showNewMessage();
	}

	function userHasRole (roles) {

		var user = session.user;

		if (roles === undefined) {
			return false;
		}

		return utilities.userHasRole(user, roles);
	}

	$rootScope.openHelpAndSupportPanel = function (helpAndSupportOptions) {

		$rootScope.$broadcast('open-help-and-support-panel', helpAndSupportOptions);
	};

	$rootScope.openSlideInForm = function (formOptions) {

		$rootScope.$broadcast('open-slide-in-form', formOptions);
	};

	$rootScope.openSupportTab = function () {

		openSupportTab();
	};

	$rootScope.paycircleMessage = function (message, mesageType) {

		paycircleMessage(message, mesageType);
	};

	$rootScope.print = function () {
		window.print();
	};

	$rootScope.userHasRole = function (roles) {

		return userHasRole(roles);
	};

}]);

'use strict';

angular.module('paycircleApp')
.constant('ACCOUNTING_INTEGRATION_TYPES', {
	xero: 0,
	accessFinancials: 1
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_BEHAVIOUR_STATES', {
	off: 0,
	on: 1,
	offLocked: 2,
	onLocked: 3
});

'use strict';

angular.module('paycircleApp')
.constant('AGENCY_ADJUSTMENT_RATE_TYPES', {
	none: 0,
	calculatedHourly: 1,
	calculatedDaily: 2,
	overtimeHourly: 3,
	overtimeDaily: 4
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_CATEGORY_TYPES', {
	allowances: 0,
	bonuses: 1,
	expenses: 2,
	additions: 3,
	deductions: 4,
	cis: 5,
	salarySacrifice: 6,
	bik: 7,
	statutoryPayment: 8,
	system: 9,
	custom: 10,
	occupational: 11
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_DETAIL_STATES', {
	normal: 0,
	readonly: 1,
	hidden: 2
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_DETAIL_TYPES', {
	childcareVouchers: '25433c7d-1b10-4971-a9eb-10800de3a8b6'
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_PAYMENT_TYPES', {
	notPayAfterLeaving: 0,
	regular: 1,
	irregular: 2
});
'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_SPECIAL_TYPES', {
	none: 0,
	backPay: 1,
	hasteePay: 2,
	cis: 3,
	accruedHoliday: 4,
	niCorrection: 5,
	backdatedSalary: 6,
	systemValue: 7,
	vanilla: 8,
	backdatedSalaryForStarter: 9,
	niRefund: 10,
	foreignTaxCredit: 11,
	shift: 12,
	eeni: 13,
	backdatedSalaryForPolicy: 14,
	rolledUpHolidayPay: 15
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_TYPES', {
	attachmentOrder: 'd4b6f233-5d4b-41a2-aea0-bf78a2e6e84b',
	cisPayment: '00000000-0000-0000-0000-000000000000',
	costOfMaterials: '5ba6bab2-53b1-43b1-8093-2d304c2aae09',
	deemedPayment: '5e7561dd-8fd0-40d8-9523-7f05ef8624c4',
	expenses: '55b41a53-1b8a-47ba-9934-0fc5af33d19c',

	// Statutory adjustments
	adoptionPay: '4e202de1-af6e-47c3-a331-5aa48860358f',
	bereavementPay: '70d0f22d-7f56-4dd0-a8af-cbd33082e241',
	maternityPay: 'b83d78a4-5e87-4912-ae74-eecafe96e89b',
	neonatalCarePay: '4c19448a-638c-4864-8ac6-6338b1cbc11c',
	paternityPay: '6a2c254f-4fc8-414a-9c72-6f38efc1e748',
	sharedParentalPay: '14161bb4-eb1d-4327-aa7d-b7e8092d2b1a',
	sickPay: '6b8f5c66-c218-43b2-986e-ffefdfa8724f',

	// Occupational adjustments
	occupationalAdoptionPay: '5350a6c7-4f68-4f4f-8091-bca932513aaf',
	occupationalBereavementPay: 'bfae6893-c154-4cbb-935f-166ef439d8ce',
	occupationalMaternityPay: '45271210-89da-4e32-b200-f0b11ef65bcd',
	occupationalNeonatalCarePay: '58c7e9ad-de34-4583-b206-3b51033a7c4c',
	occupationalPaternityPay: '00afc5d5-1f0c-40ec-b29e-c406d2497dcd',
	occupationalSharedParentalPay: 'ba253b27-59b1-42bf-9dc9-d5d8194b9086',
	occupationalSickPay: 'bb971890-1d33-4136-af4b-6aae72c3ce67',
});

'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_VALIDATION_RESULT_TYPES', {
    none: 0,
    adjustment: 1,
    user: 2
});
'use strict';

angular.module('paycircleApp')
.constant('ADJUSTMENT_VALUE_TYPES', {
	absolute: 0,
	unit: 1,
	percentage: 2,
	linked: 4
});

'use strict';

angular.module('paycircleApp')
.constant('ADMIN_INVITE_STATES', {
    uninvited: 0,
    invited: 1,
    registered: 2
});

'use strict';

angular.module('paycircleApp')
.constant('AGE_VALIDATION', {
    noAssessment: 0,
    under13: 1,
    between13And15: 2,
    between16AndPension: 3,
    overPension: 4,
});
'use strict';

angular.module('paycircleApp')
.constant('ANIMATION_STATES', {
	'visible': 0,
	'animateIn': 1,
	'animateOut': 2,
	'hidden': 3
});

'use strict';

/**
 * The variation of interface types used in Paycircle
 */
angular.module('paycircleApp')
.constant('AOE_ORDER_STATES', {
	complete: 0,
	active: 1,
	cancelled: 2
});

'use strict';

angular.module('paycircleApp')
.constant('AOE_ORDER_TYPES', {
	aeo: '3e2f2004-13c4-4cb2-b483-6039dfe22acc',
	cmaScotland: '761595ab-e087-4f92-9868-cdd672618cd4',
	ctaeo: '7aa6134d-12ea-40d0-98a5-2728beb2136d',
	deaHigh: '2429c0b2-18f3-4588-86ce-79ca04707672',
	deaStandard: 'a8e0e29b-8d6b-4245-b765-a57694633359',
	deo: '372dd84f-4901-4ef8-bcea-4c342e3ddbe1'
});

'use strict';

angular.module('paycircleApp')
.constant('ARCHIVE_OPTIONS', [
	{
		name: 'Company is closing',
		id: 0
	},
	{
		name: 'Company sold or merged',
		id: 1
	},
	{
		name: 'Moved to another service provider',
		id: 2
	},
	{
		name: 'Other',
		id: 3
	}
])
.constant('ARCHIVE_REASONS', {
	0: 'Company is closing',
	1: 'Company sold or merged',
	2: 'Moved to another service provider',
	3: 'Other'
})
.constant('ARCHIVE_REASON_KEYS', {
	companyClosing: 0,
	companySoldOrMerged: 1,
	movedServiceProvider: 2,
	other: 3
});
'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.AUTH_EVENTS
 * @description
 * # AUTH_EVENTS
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('AUTH_EVENTS', {
	loginSuccess: 'auth-login-success',				// Logged in successfully
	loginFailed: 'auth-login-failed',				// Login failed
	logoutSuccess: 'auth-logout-success',			// Logged out successfully
	sessionCreate: 'auth-session-create',			// Session created successfully
	sessionDestroy: 'auth-session-destroy',			// Session created successfully
	sessionTimeout: 'auth-session-timeout',			// Session has timed out
	sessionTimeoutWarning: 'auth-session-warning',	// Session timeout warning
	notAuthenticated: 'auth-not-authenticated', 	// User is not authenticated
	notAuthorised: 'auth-not-authorised' 			// User is not authorised
});

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.AUTH_ERRORS
 * @description
 * # AUTH_ERRORS
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('AUTH_ERRORS', {
	impersonationNotSupported: 'ImpersonationNotSupported',				// Impersonation not supported
	accountNotLinkedToIdentity: 'AccountNotLinkedToIdentity',		   // Account not linked to identity
	signInFailed: 'SignInFailed',									   // Sign in failed
	accountNotFound: 'AccountNotFound',								 // Account not found			
	accountNotVerified: 'AccountNotVerified',						   // Account not verified
	identityAccountHasNoLinks: 'IdentityAccountHasNoLinks',			 // Identity account has no links
	accountLinkedNotVerified: 'AccountLinkedNotVerified',			   // Account linked not verified
	userNotExisting: 'UserNotExisting',								 // User not existing
	sessionExpired: 'SessionExpired',								   // Session expired
	evoMigrationRequired: 'EvoMigrationRequired',					   // Evo migration required
	unknown: 'Unknown'												  // Unknown error
});

'use strict';

angular.module('paycircleApp')
.constant('AUTH_ERROR_MESSAGES', {
	SignInFailed: {
		title: 'Sign-in failed',
		message: 'Your email or password is incorrect. Please check your credentials and try again.'
	},
	AccountNotFound: {
		title: 'Account not found',
		message: 'We couldn\'t find an account with these details. Please contact your administrator for assistance.'
	},
	AccountNotVerified: {
		title: 'Account not verified',
		message: 'Your account hasn\'t been verified yet. Please check your email for a verification link.'
	},
	IdentityAccountHasNoLinks: {
		title: 'Account setup incomplete',
		message: 'Your Access Identity account isn\'t linked to any products. Please contact your administrator to complete your account setup.'
	},
	AccountNotLinkedToIdentity: {
		title: 'Account not linked',
		message: 'Your account isn\'t linked to Access Identity. Please contact your administrator to link your account.'
	},
	AccountLinkedNotVerified: {
		title: 'Account link not verified',
		message: 'Your account link to Access Identity hasn\'t been verified. Please check your email for a verification link.'
	},
	UserNotExisting: {
		title: 'User not found',
		message: 'This user doesn\'t exist. Please check your email address or contact support for assistance.'
	},
	SessionExpired: {
		title: 'Session expired',
		message: 'Your session has expired. Please sign in again.'
	},
	ImpersonationNotSupported: {
		title: 'Impersonation not supported',
		message: 'User impersonation isn\'t supported for this account. Please sign in with your own credentials.'
	},
	EvoMigrationRequired: {
		title: 'Migration required',
		message: 'Your account needs to be migrated to Access Evo. Please contact your administrator for assistance with the migration process.'
	},
	fallback: {
		title: 'We couldn\'t sign you in',
		message: 'Unable to sign in. Please try again or contact support if the problem persists.'
	}
});

'use strict';

/**
 * Rate types for the 52-week Average Holiday Pay report settings.
 * Values mirror the C# AverageHolidayPayRateType enum (ReportUtility) and the
 * AverageHolidayPayRateType column stored in PayElementReportSetting.
 */
angular.module('paycircleApp')
.constant('AVERAGE_HOLIDAY_PAY_RATE_TYPES', {
	other: 0,
	hourly: 1,
	daily: 2
});

'use strict';

angular.module('paycircleApp')
.constant('BACKDATED_SALARY_CALCULATION_METHODS', {

	applyToCurrentPeriod: 0,
	applyAsBackdatedCalculation: 1
});

'use strict';

angular.module('paycircleApp')
.constant('BACS_FILE_TYPES', {
	payPeriod: 0,
	disbursement: 1,
	supplementaryPayment: 2
});

'use strict';

angular.module('paycircleApp')
.constant('BACS_PAYMENT_TYPES', {
	none: 0,
	aoe: 1 << 0, // 1
	childcare: 1 << 1, // 2
	hmrc: 1 << 2, // 4
	pension1: 1 << 3, // 8
	pension2: 1 << 4, // 16
	pension3: 1 << 5 // 32
});



'use strict';

angular.module('paycircleApp')
.constant('BANK_IDS', {
	access: '5e35602f-6b6e-4b0e-a64c-1a621c123bd3',
	bacsBureau: '16563528-4af4-4150-ae21-068be85ec902',
	bancoSabadell: '25be6427-d730-407d-8371-8d30d029edac',
	bankline: 'f9c2d9db-7cc1-4d1b-abc5-5b9c85f7a573',
	bankOfAmericaMerrillLynch: 'b5efa73a-a082-4a21-a4ba-edb710ed1b4b',
	bankOfIreland: '30b566b2-5e65-415f-9f2a-37e902b0a9da',
	bankOfScotland: '81163d2d-283e-44b2-8fca-38e0d8edf072',
	barclays: '71097571-4e94-4beb-8688-6b663d85e618',
	citiDirect: '7566474f-e23c-4930-a916-8c4220cd1fd8',
	cooperative: 'c838c1b4-0397-42d7-9f27-6c4b60ebc428',
	coutts: '8d6f9722-2ff7-4fe3-8360-c31fafdf70e3',
	credec: 'e2abe721-31b2-4dbc-b1aa-c68bcf2934b6',
	globalAch: 'de4ea625-d099-48aa-bed2-d690a3939e2f',
	hsbc: 'e9d9bc68-1a60-4323-9611-c3847382d3c1',
	hsbcLowValue: 'b45362a6-a8fc-454d-bb89-f4be306b82d8',
	lloyds: '42ee9dde-858a-446f-9c54-6edaff92a7de',
	lloydsAscii: '77c1f3e6-7c93-4c18-86f6-b8f07f785d61',
	metroCsv: '4d73ce91-53d6-4959-afb8-f0ba33d6d879',
	metroTxt: '886034af-8f6b-46ca-b7be-f797b68d01e8',
	modulr: 'ac02d209-8983-499f-86e2-6b975ee7baf6',
	natwest: '57a8b41c-459e-4497-ae51-8052b5231c74',
	natwestAdHoc: '0de5d70f-1065-4f29-8667-159791d0f4cd',
    openBanking: '27144cd9-b516-4496-9948-d31ddea6bb0f',
	paycircle: '4c4ec072-da95-4c9e-aecf-d53acb7bfd21',
    paygate: '7c8d5144-f8be-46bd-a84f-cce1e82b7ffb',
	rbs: '0ab086f7-6aad-4df2-920e-b155837f5a18',
	rbsBanklineBulk: '0394679f-c51a-480f-b04f-9ed9870a7cb7',
	santander: 'a5ce72f9-e756-4a48-bba9-0a1af5c1fb1a',
    telleroo: 'f7dce26a-3e17-45eb-baf9-63b5129739e4',
    ulsterBank: '5fc85e1a-2b4a-434a-be0b-7b60f475eb6b',
    yorkshireBank: '0c280010-baf9-4651-89e8-6e1205238a03',
    handelsbanken: 'ad6f8f9a-4baa-43d8-aa5e-15026060d7ee',
});

'use strict';

angular.module('paycircleApp')
.constant('BANK_FILE_FORMATS', {
	bacs: 0,
	fps: 1
});



'use strict';

angular.module('paycircleApp')
.constant('BENEFIT_CANCELATION_REASONS', {
	none: 0,
	benefitWithdrawn: 1,
	workerLeaving: 2,
	workerRedundant: 3,
	workerLeft: 4,
	paused: 5
});

'use strict';

// A list of compatibile browsers for Paycircle
angular.module('paycircleApp')
.constant('BROWSER_COMPATIBILITY_LIST', [
	/*
		The order here is significant, since many non-Chrome browsers report 'Chrome/x.y.z' in their UserAgent strings.
		So Chrome goes last.
	 */
	{
		homePageUrl: 'https://www.mozilla.org/en-GB/firefox/new',
		id: 'firefox',
		minVersion: 68,
		name: 'Firefox',
		userAgentNames: ['firefox'],
		userAgentNamesMustNotInclude: ['seamonkey']
	},
	{
		homePageUrl: 'https://www.apple.com/uk/safari',
		id: 'safari',
		minVersion: 11,
		name: 'Safari',
		userAgentNames: ['safari'],
		userAgentNamesMustNotInclude: ['chrome', 'chromium', 'edge', 'edg']
	},
	{
		homePageUrl: 'https://www.microsoft.com/en-gb/windows/microsoft-edge',
		id: 'edge',
		minVersion: 42, // Chromium-based versions will start at 79
		name: 'Edge',
		userAgentNames: ['edg', 'edge']
	},
	{
		homePageUrl: 'https://www.google.com/chrome',
		id: 'chrome',
		minVersion: 75,
		name: 'Chrome',
		recommended: true,
		// crios ('CriOS') is Chrome on iOS devices
		userAgentNames: ['chrome', 'crios'],
		userAgentNamesMustNotInclude: ['edge', 'edg', 'seamonkey', 'opr', 'samsungbrowser', 'ucbrowser']
	}
]);
'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_CATEGORY_TYPE_OPTIONS', [
	{ value: 0, description: 'Custom' },
	{ value: 1, description: 'Role' },
	{ value: 2, description: 'Department' },
	{ value: 3, description: 'Branch' },
	{ value: 4, description: 'Cost Centre' },
	{ value: 5, description: 'Sector' }
]);

'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_CATEGORY_TYPES', {
	custom: 0,
	role: 1,
	department: 2,
	branch: 3,
	costCentre: 4,
	sector: 5
});

'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_CATEGORY_SORT_BY_OPTIONS', [
	{
		id: 0,
		key: 'none',
		name: 'None'
	},
	{
		id: 1,
		key: 'branch',
		name: 'Branch'
	},
	{
		id: 2,
		key: 'cost-centre',
		name: 'Cost Centre'
	},
	{
		id: 3,
		key: 'department',
		name: 'Department'
	},
	{
		id: 4,
		key: 'sector',
		name: 'Sector'
	},
	{
		id: 5,
		key: 'role',
		name: 'Role'
	}
]);

'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_CODE_FORM_STATES', {
	cannotDelete: 'cannot-delete',
	create: 'create',
	created: 'created',
	delete: 'delete',
	deleted: 'deleted',
	edit: 'edit',
	error: 'error',
	loading: 'loading',
	manageTeamMembers: 'manage-team-members',
	manageVisibility: 'manage-visibility',
	teamUpdated: 'team-updated',
	visibilityUpdated: 'visibility-updated'
});

'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_SECTORS', {
	agriculture: 0,
	fisheriesAqua: 1,
	roadTransport: 2,
	industrial: 3,
	none: 4
});

'use strict';

angular.module('paycircleApp')
.constant('BUSINESS_TYPES', {
	soletrader: 0,
	partnership: 1,
	trust: 2,
	company: 3
});

'use strict';

angular.module('paycircleApp')
.constant('CALCULATION_METHODS', [
	{
		description: 'Not set',
		key: -1
	},
	{
		description: '260 working days per year',
		isDefault: true,
		key: 0,
		showForCompaniesOnly: true
	},
	{
		description: 'Use work pattern',
		key: 1,
		showForCompaniesOnly: true
	},
	{
		description: '261 working days per year',
		key: 2,
		showForCompaniesOnly: true
	},
	{
		description: '253 working days per year',
		key: 3,
		showForCompaniesOnly: true
	},
	{
		description: '365 days per year',
		key: 4,
		showForCompaniesOnly: true
	},
	{
		description: '366 days per year',
		key: 5,
		showForCompaniesOnly: true
	},
	{
		description: 'Calendar days',
		key: 6,
		showForCompaniesOnly: true
	},
	{
		description: '195 working days per year',
		key: 7,
		showForCompaniesOnly: true
	},
	{
		description: '(Annual salary/Annual hours) * Contracted daily hours',
		key: 8,
		showForCompaniesOnly: true,
		isCalculation: true
	},
	{
		description: '(Annual salary/Annual hours) * Full time daily hours',
		key: 9,
		showForCompaniesOnly: true,
		isCalculation: true
	},
	/*
		Note the key jump here. Some of these calculation methods were deemed redundant.
		https://www.notion.so/paycircle/Can-we-remove-the-bottom-3-day-rate-methods-5a4c59bfb8dc4e20abb3e952bfc35649
	 */
	{
		description: '104 working days per year',
		key: 13,
		showForCompaniesOnly: true
	},
	{
		description: '156 working days per year',
		key: 14,
		showForCompaniesOnly: true
	},
	{
		description: '208 working days per year',
		key: 15,
		showForCompaniesOnly: true
	},
	{
		description: 'Annualised days',
		key: 16,
		showForCompaniesOnly: true
	}
]);

'use strict';

/**
 * The variation of holiday policy types used in Paycircle
 */
angular.module('paycircleApp')
.constant('COMPANY_HOLIDAY_POLICY_TYPES', {
	none: 1,
	rollup: 2,
	accrue: 3,
	addon: 4,
	accrueanddisplay: 5
});

'use strict';

angular.module('paycircleApp')
.constant('COMPANY_MAIL_STATES', {
	allOn: 0,
	allOff: 1,
	partial: 2
});

'use strict';

angular.module('paycircleApp')
.constant('COMPANY_STATES', {
	live: 0,
	readyToRun: 1,
	demo: 2,
	onboarding: 3,
	firstPeriod: 4
});

'use strict';

angular.module('paycircleApp')
.constant('COMPANY_STATE_DATA_TYPES', {
	profile: 0,
	company: 1,
	team: 2,
	payroll: 3,
	pension: 4
});

'use strict';

/**
 * The variation of interface types used in Paycircle
 */
angular.module('paycircleApp')
.constant('COMPANY_TYPES', {
	company: 1,
	bureau: 2,
	group: 3
});

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.config
 * @description
 * # config
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('config', {

	appTitle: 			'Paycircle Payroll',
	appKey: 			'payroll',
	coralogixEnabled:	true,
	coralogixPublicKey: 'cxtp_Opv2zN1lyg0vxtRBjG47Un0y8DkaMp',
	version: 			'18.46.0', // x.y.z = major.minor.patch

	allowedRoles: 		['bureau', 'bureaumanager', 'companyadministrator', 'companyadministratorlite', 'companyadministratorsme', 'departmentadmin', 'group', 'groupadmin', 'groupadminlite', 'optimalcompliance', 'paycircle'],
	restrictedRoles: ['payrollworker', 'worker'],
	animationSpeed: 250, // milliseconds > Needs to match paycircle.scss : $animation-speed
	apprenticeshipLevyPaidToDateMin: 0,
	apprenticeshipLevyPaidToDateMax: 999999999,
	apprenticeshipLevyThreshold: '£3 million',
	appTimeoutMessage: 'Paycircle is undergoing maintenance on Monday 13 January between 20:00-23:59 GMT. We ask that you are logged out of the system between these hours.',
	appTimeoutMessageTimeConstraint: {
		hasTimeConstraint: true,
		timeConstraintEnd: new Date('2025-01-13T23:59:00')
	},
	apprenticeshipLevy: 15000,
	appSubdomains: {
		localhost: 'localhost',
		development: 'payrolldev',
		demo: 'payrolldemo',
		beta: 'payrollbeta',
		staging: 'payrollstaging',
		preview: 'preview',
		preproduction: 'payrollpreproduction',
		production: 'payroll'
	},
	baseDomainName: 'paycircle.co.uk',
	evoNativeDomainName: 'paycircle.accessacloud.com',
	blogUrl: 			'https://paycircle.co.uk/blog',
	bugReportEmail: 	'bug@paycircle.co.uk?subject=Enter a title for the bug...&body=Enter any further information and attach any files that you think may be useful...',
	companyAddress: 	'Pinnacle Building, 20 Tudor Road, Reading, RG1 1NH',
	companyEmail: 		'help@paycircle.co.uk',
	companyName: 		'Paycircle Limited',
	companyPhoneNumber: '+44 20 3640 7788',
	currentPeriodTeamCountThreshold: 50,
	dataProtectionStatement: 'Any personal information given will be processed in accordance with UK GDPR and the Data Protection Act 2018.',
	dateFormatPrimary:	'DD/MM/YYYY',
	dateFormatISO: 		'YYYY-MM-DDT00:00:00',
	dateTimeFormatPrimary: 'DD/MM/YYYY HH:mm',
	defaultEmptyText: 	'Unknown',
	defaultFPSLateReason: 'G',
	defaultPage: 		'company-dashboard',
	defaultTimeZone: 	'GMT Standard Time',
	demoCompanyTrialLength: 30,
	externalUrls: {
		accessIdentityUrls: {
			migrateAccount1: 'https://help-paycircle.theaccessgroup.com/en/articles/11123135-access-identity-admin-linking',
			migrateAccount2: 'https://accessgroup.my.salesforce.com/sfc/p/#58000000Z4gm/a/Tl000000bpGT/QDAaL9NOjtNSSyTpYtY.4T.sgZJVElYelP2kJXs3wjE',
			configureSSO: 'https://help-paycircle.theaccessgroup.com/en/articles/10394023-configure-access-identity-single-sign-on',
			overview: 'https://help-paycircle.theaccessgroup.com/en/articles/10394033-access-identity-overview'
		},
		accessEvoUrls: {
			whatIsEvo: 'https://help-paycircle.theaccessgroup.com/en/articles/11332928-access-evo-integration'
		},
		policyUrls:{
			cookiePolicy: 'https://help-paycircle.theaccessgroup.com/en/articles/12891612-cookie-policy'
		}
	},
	parentalDueDateMaxWeeksInFuture: 22,
	exportMaxLength: 	209700,
	fontFamilyAlpha: `'Source Sans Pro', 'Open Sans', Helvetica, Arial, sans-serif`,
	furlough: {
		maxDate: '2021-09-30T00:00:00',
		monthlyPayCapPercent: 80,
		annualPayCap: 30000,
		payCapByPeriodType: {
			0: 576.92,
			1: 1153.84,
			2: 2307.69,
			3: 2500,
			4: 7500,
			8: 15000,
			5: 30000,
		}
	},
	fsbAdminEmail: 'admin@fsbpayrollservices.co.uk',
	intercomAppId: 		'gf454brc', // Live
	intercomAppIdTest: 	'i5k4o2fh', // Test
	isCacheBustEnabled: false,
	trackingEnabled: 	true,
	googleAnalyticsId:	'UA-49548057-8',
	guidEmpty: 			'00000000-0000-0000-0000-000000000000',
	hmrcUsernameMaxLength: 12,
	hmrcLoginUrl: 		'https://www.tax.service.gov.uk/gg/sign-in',
	hmrcWebsiteUrl: 	'https://www.gov.uk/government/organisations/hm-revenue-customs',
	hmrcPhoneNumber: 	'0300 200 3300',
	hmrcSortCode: 		'083210',
	hmrcAccountNumber: 	'12001039',
	hmrcAccountName: 	'HMRC Cumbernauld',
	hourlyRateMin: 		0.01,
	idealPostcodesKey:  'ak_ilu1f90rC7FZme2EfUDu6b5i51ELh',
	idealLookupLimit:	40,
	maxSessionDuration: 30, // Minutes
	nestLoginUrl: 		'https://www.nestpensions.org.uk/schemeweb/NestWeb/faces/public/MUA/pages/loginPage.xhtml',
	nestWebsiteUrl: 	'https://www.nestpensions.org.uk/',
	nestLandingPageUrl: 'https://paycircle.co.uk/workplace-pension/why-nest/',
	nestPaycircleDelegateId: 'TPAR003177455',
	numberMin			 : 0,
	number4Digits		 : 9999,
	number4Digits2Decimal: 9999.99,
	number5Digits		 : 99999,
	number5Digits2Decimal: 99999.99,
	number6Digits2Decimal: 999999.99,
	number7Digits2Decimal: 9999999.99,
	number7Digits4Decimal: 9999999.9999,
	number8Digits2Decimal: 99999999.99,
	number9Digits2Decimal: 999999999.99,
	number10Digits2Decimal: 9999999999.99,
	paycircleOnboardingId: '670ad5b1-0fa0-4ee9-ba40-b2afb43414e7',
	paycircleBureauId: 'f88a021e-5a89-45a8-9bb3-278a42dc30b2',
	personalAllowanceNumber: 	'1257',
	personalAllowanceLetter: 	'L',
	/* Help and support contexts for roles. Users with specified primary role will have access only to the specific
	   category. Other roles will either have full access or no access, controlled via the visibility of the help and
	   support icon in app header */
	supportRoleContexts: [
		{
			primaryRole: 'companyadministratorlite',
			supportContext: 'employer-pack-private'
		}
	],
	isPayroll: 			true,
	isInDebugMode: 		false,
	localhostServer: 	'live',
	maxHoursPerWeek: 	168,
	maxDocumentUploadSize: 20971520, // 20mb in bytes
	occupationalPoliciesMaxSalary: 9999999.9999,
	salaryMaxLength:	12,
	scheduledTimePayslips: '9am',
	standardReportTemplateGroupId: '22222222-2222-2222-2222-222222222222',
	startDateMaxMonthsInFuture: 6,
	startDateMaxMonthsInPast: 3,
	supportUrl: 		'https://paycircle.co.uk/support',
	taxCodeNumberMaxLength: 6,
	// Bounds used when expanding two digit tax years (e.g. '25') from imported files into full tax years (2025)
	taxYear: {
		centuryBase: 2000,
		min: 2000,
		max: 2099
	},
	timeFormatPrimary: 	'HH:mm',
	timeToPoll: 		5, // Seconds
	timeToPollForNotifications: 5, // Minutes
	tokenExpiryHours: 	8,
	tokenStorageName: 	'VEF2',
	twitterHandle: 		'@paycircleUK',
	twitterUrl: 		'https://twitter.com/paycircleuk',
	userMaxAge: 		130,
	userPortalUrl: 		'https://my.paycircle.co.uk/#/login/',
	w1m1Label: 			'W1/M1',

	// Precision (decimal places) for assorted types
	precision: {
		salaryRates: 4,
		contractedWorkingTimes: 4
	},

	screenPixelMaxWidths: {
		phone: 740,
		tablet: 1200,
		laptop: 1440,
		monitor: 3000,
	},

	momentDays: {
		sunday: 0,
		monday: 1,
		tuesday: 2,
		wednesday: 3,
		thursday: 4,
		friday: 5,
		saturday: 6
	},

	// Hostnames that will use dev
	useDevDbFor: [
		'localhost',
		// 'payrollbeta.paycircle.co.uk',
		'payrolldev.paycircle.co.uk',
		'payrolldev.paycircle.accessacloud.com'
		// 'payrollstaging.paycircle.co.uk',
		// 'payrollpreproduction.paycircle.co.uk',
		// 'demo'
	],

	// Hostnames that will use beta
	useBetaDbFor: [
		//'localhost',
		'payrollbeta.paycircle.co.uk'
	],

	// Hostnames that will use preproduction
	usePreproductionDbFor: [
		'payrollpreproduction.paycircle.co.uk',
	],

	// Pensions Auto Enrolment - http://www.thepensionsregulator.gov.uk/automatic-enrolment-earnings-threshold.aspx
	aeAgeThreshold: 					22,
	aeSalaryThreshold: 					10000,
	aeSalaryThresholdMonthly: 			833,
	lowerEarningsLimit: 				6136,
	lowerEarningsLimitMonthly: 			512,
	lowerEarningsLimitWeekly: 			118,
	upperEarningsLimit: 				50000,
	lowerAgeThreshold: 					16,

	// Work times max / min (for input and number selectors) and step (specifically for number selectors)
	workTimeLimits: {
		hoursPerWeek: {
			min: 1,
			max: 168,		// The number of hours in a week
			step: 0.25
		},
		weeksPerYear: {
			min: 1,
			max: 52.143, 	// The number of weeks in a year (365 / 7). This precise value is used by some.
			step: 1
		}
	},

	pensionMinimumContributionEmployee: 5,
	pensionMinimumContributionEmployer: 3,
	pensionMaximumPercentageContribution: 99.99,

	policyDefaults: {
		holiday: {
			policyDays: 28,
			policyRolloverDays: 0
		},
		sickness: {
			policyDays: 25,
		}
	},

	maxCountOfNILetterCodeCorrectionalUpdates: 4,

	sentiment: {
		test: {
			accountToken: 'eo83m5wfgzv2nc2xg3ttviau04c9ccf7',
			apiHost: 'https://api-staging.sentiment.accessacloud.com',
			reDisplayAfterDays: 0
		},
		production: {
			// TODO: Replace with production token once available
			accountToken: 'ah0rtuadbfi5frdveb1f9efide30b7cc',
			apiHost: 'https://api.sentiment.accessacloud.com',
			reDisplayAfterDays: 30
		}
	},

	wootric: {
		test: {
			enable: true,
			accountToken: 'NPS-8a385e4e',
			product_name: 'Access Paycircle (Test)',
			product_code: 570,
			test_mode: false,
			excluded_domains: ['theaccessgroup.com']
		},
		production: {
			enable: true,
			accountToken: 'NPS-78e2e02c',
			product_name: 'Access Paycircle',
			product_code: 570,
			test_mode: false,
			excluded_domains: ['theaccessgroup.com']
		}
	}
});

'use strict';

angular.module('paycircleApp')
.constant('CONTACT_EXTERNAL_CATEGORIES', {
	none: 0,
	payrollEmailRecipient: 1 << 0, // 1
	p32EmailRecipient: 1 << 1, // 2
	newEmailRecipient: 1 << 2, // 4
});

'use strict';

angular.module('paycircleApp')
.constant('CONTRIBUTION_BASIS', {
	qualifyingEarnings: 0,
	basicPay: 1,
	totalPay: 2,
	tierTwo: 3
})
.constant('CONTRIBUTION_BASIS_OPTIONS', [
	{
		text: 'Qualifying earnings',
		value: 0
	},
	{
		text: 'Basic pay',
		value: 1
	},
	{
		text: 'Total pay',
		value: 2
	},
	{
		text: 'Tier 2',
		value: 3
	}
]);
angular.module('paycircleApp')

/* Copilot feature identifiers used for feedback submission and telemetry tracking.
   These values are used in copilot-feedback components to identify which feature
   the user is providing feedback on. */
.constant('COPILOT_FEATURES', {

	smartView: 'SmartView',
	payrollErrorTranslation: 'PayrollErrorTranslation'
});

'use strict';

angular.module('paycircleApp')

/**
 * Cookie consent keys used throughout the application
 */
.constant('COOKIE_CONSENT_KEYS', {
	categories: {
		essential: 'essential',
		analytics: 'analytics'
	},
	essential: {
		cf: 'cf',
		intercom: 'intercom'
	},
	analytics: {
		ga: 'ga',
		cx: 'cx'
	}
});

'use strict';

angular.module('paycircleApp')

/**
 * Cookie policy configuration
 */
.constant('COOKIE_POLICY_CONFIG', {
	policyVersion: '2025-01',
	FOR_ACCESS_SDK: {
		config: {
			applicationId: '',
			policyVersion: '',
			policyUrl: '',
			policies: ['essential', 'analytics'],
			parties: [
				{
					policy: 'essential',
					vendors: [
						{
							name: 'Cloudflare',
							key: 'cf',
							description: 'Used to identify and block automated, unauthorized traffic.',
							vendorUrl: 'https://www.cloudflare.com/privacypolicy/',
							partyType: 'First Party'
						},
						{
							name: 'Intercom',
							key: 'intercom',
							description: 'Tracks the current browser session for the Messenger.',
							vendorUrl: 'https://www.intercom.com/legal/privacy',
							partyType: 'First Party'
						}
					]
				},
				{
					policy: 'analytics',
					vendors: [
						{
							name: 'Google Analytics',
							key: 'ga',
							description: 'Distinguishes unique users for usage analytics.',
							vendorUrl: 'https://policies.google.com/privacy',
							partyType: 'First Party'
						},
						{
							name: 'Coralogix',
							key: 'cx',
							description: 'Application performance monitoring, error tracking, and user session analytics.',
							vendorUrl: 'https://coralogix.com/privacy-policy',
							partyType: 'First Party'
						}
					]
				}
			]
		}
	}
});

'use strict';

angular.module('paycircleApp')
.constant('COOKIE_KEYS', {
	sessionId: 'sessionId',
	cookieConsent: 'cookieConsent'
});

'use strict';

angular.module('paycircleApp')
.constant('CORRECTIONAL_SUBMISSION_TYPES', {
	EYU: 0,
	YTDFPS: 1
});

'use strict';

angular.module('paycircleApp')

.constant('COUNTRY_UK',
	{
		name: 'United Kingdom',
		value: 'United Kingdom'
	}
)

.factory('COUNTRIES', [
	'COUNTRY_UK',
function (
	COUNTRY_UK
) {
	return [
		{
			name: 'Afghanistan',
			value: 'Afghanistan'
		},
		{
			name: 'Albania',
			value: 'Albania'
		},
		{
			name: 'Algeria',
			value: 'Algeria'
		},
		{
			name: 'American Samoa',
			value: 'American Samoa'
		},
		{
			name: 'Andorra',
			value: 'Andorra'
		},
		{
			name: 'Angola',
			value: 'Angola'
		},
		{
			name: 'Anguilla',
			value: 'Anguilla'
		},
		{
			name: 'Antarctica',
			value: 'Antarctica'
		},
		{
			name: 'Antigua and Barbuda',
			value: 'Antigua and Barbuda'
		},
		{
			name: 'Argentina',
			value: 'Argentina'
		},
		{
			name: 'Armenia',
			value: 'Armenia'
		},
		{
			name: 'Aruba',
			value: 'Aruba'
		},
		{
			name: 'Australia',
			value: 'Australia'
		},
		{
			name: 'Austria',
			value: 'Austria'
		},
		{
			name: 'Azerbaijan',
			value: 'Azerbaijan'
		},
		{
			name: 'Bahamas',
			value: 'Bahamas'
		},
		{
			name: 'Bahrain',
			value: 'Bahrain'
		},
		{
			name: 'Bangladesh',
			value: 'Bangladesh'
		},
		{
			name: 'Barbados',
			value: 'Barbados'
		},
		{
			name: 'Belarus',
			value: 'Belarus'
		},
		{
			name: 'Belgium',
			value: 'Belgium'
		},
		{
			name: 'Belize',
			value: 'Belize'
		},
		{
			name: 'Benin',
			value: 'Benin'
		},
		{
			name: 'Bermuda',
			value: 'Bermuda'
		},
		{
			name: 'Bhutan',
			value: 'Bhutan'
		},
		{
			name: 'Bolivia',
			value: 'Bolivia'
		},
		{
			name: 'Bosnia and Herzegovina',
			value: 'Bosnia and Herzegovina'
		},
		{
			name: 'Botswana',
			value: 'Botswana'
		},
		{
			name: 'Bouvet Island',
			value: 'Bouvet Island'
		},
		{
			name: 'Brazil',
			value: 'Brazil'
		},
		{
			name: 'British Indian Ocean Territory',
			value: 'British Indian Ocean Territory'
		},
		{
			name: 'Brunei',
			value: 'Brunei'
		},
		{
			name: 'Bulgaria',
			value: 'Bulgaria'
		},
		{
			name: 'Burkina Faso',
			value: 'Burkina Faso'
		},
		{
			name: 'Burundi',
			value: 'Burundi'
		},
		{
			name: 'Cambodia',
			value: 'Cambodia'
		},
		{
			name: 'Cameroon',
			value: 'Cameroon'
		},
		{
			name: 'Canada',
			value: 'Canada'
		},
		{
			name: 'Cape Verde',
			value: 'Cape Verde'
		},
		{
			name: 'Cayman Islands',
			value: 'Cayman Islands'
		},
		{
			name: 'Central African Republic',
			value: 'Central African Republic'
		},
		{
			name: 'Chad',
			value: 'Chad'
		},
		{
			name: 'Channel Islands',
			value: 'Channel Islands'
		},
		{
			name: 'Chile',
			value: 'Chile'
		},
		{
			name: 'China',
			value: 'China'
		},
		{
			name: 'Christmas Island',
			value: 'Christmas Island'
		},
		{
			name: 'Cocos (Keeling) Islands',
			value: 'Cocos (Keeling) Islands'
		},
		{
			name: 'Colombia',
			value: 'Colombia'
		},
		{
			name: 'Comoros',
			value: 'Comoros'
		},
		{
			name: 'Congo',
			value: 'Congo'
		},
		{
			name: 'The Democratic Republic of Congo',
			value: 'The Democratic Republic of Congo'
		},
		{
			name: 'Cook Islands',
			value: 'Cook Islands'
		},
		{
			name: 'Costa Rica',
			value: 'Costa Rica'
		},
		{
			name: 'Ivory Coast',
			value: 'Ivory Coast'
		},
		{
			name: 'Croatia',
			value: 'Croatia'
		},
		{
			name: 'Cuba',
			value: 'Cuba'
		},
		{
			name: 'Cyprus',
			value: 'Cyprus'
		},
		{
			name: 'Czech Republic',
			value: 'Czech Republic'
		},
		{
			name: 'Denmark',
			value: 'Denmark'
		},
		{
			name: 'Djibouti',
			value: 'Djibouti'
		},
		{
			name: 'Dominica',
			value: 'Dominica'
		},
		{
			name: 'Dominican Republic',
			value: 'Dominican Republic'
		},
		{
			name: 'East Timor',
			value: 'East Timor'
		},
		{
			name: 'Ecuador',
			value: 'Ecuador'
		},
		{
			name: 'Egypt',
			value: 'Egypt'
		},
		{
			name: 'England',
			value: 'England'
		},
		{
			name: 'El Salvador',
			value: 'El Salvador'
		},
		{
			name: 'Equatorial Guinea',
			value: 'Equatorial Guinea'
		},
		{
			name: 'Eritrea',
			value: 'Eritrea'
		},
		{
			name: 'Estonia',
			value: 'Estonia'
		},
		{
			name: 'Ethiopia',
			value: 'Ethiopia'
		},
		{
			name: 'Falkland Islands',
			value: 'Falkland Islands'
		},
		{
			name: 'Faroe Islands',
			value: 'Faroe Islands'
		},
		{
			name: 'Fiji Islands',
			value: 'Fiji Islands'
		},
		{
			name: 'Finland',
			value: 'Finland'
		},
		{
			name: 'France',
			value: 'France'
		},
		{
			name: 'French Guiana',
			value: 'French Guiana'
		},
		{
			name: 'French Polynesia',
			value: 'French Polynesia'
		},
		{
			name: 'French Southern territories',
			value: 'French Southern territories'
		},
		{
			name: 'Gabon',
			value: 'Gabon'
		},
		{
			name: 'Gambia',
			value: 'Gambia'
		},
		{
			name: 'Georgia',
			value: 'Georgia'
		},
		{
			name: 'Germany',
			value: 'Germany'
		},
		{
			name: 'Ghana',
			value: 'Ghana'
		},
		{
			name: 'Gibraltar',
			value: 'Gibraltar'
		},
		{
			name: 'Greece',
			value: 'Greece'
		},
		{
			name: 'Greenland',
			value: 'Greenland'
		},
		{
			name: 'Grenada',
			value: 'Grenada'
		},
		{
			name: 'Guadeloupe',
			value: 'Guadeloupe'
		},
		{
			name: 'Guam',
			value: 'Guam'
		},
		{
			name: 'Guatemala',
			value: 'Guatemala'
		},
		{
			name: 'Guernsey',
			value: 'Guernsey'
		},
		{
			name: 'Guinea',
			value: 'Guinea'
		},
		{
			name: 'Guinea-Bissau',
			value: 'Guinea-Bissau'
		},
		{
			name: 'Guyana',
			value: 'Guyana'
		},
		{
			name: 'Haiti',
			value: 'Haiti'
		},
		{
			name: 'Heard Island and McDonald Islands',
			value: 'Heard Island and McDonald Islands'
		},
		{
			name: 'Holy See (Vatican City State)',
			value: 'Holy See (Vatican City State)'
		},
		{
			name: 'Honduras',
			value: 'Honduras'
		},
		{
			name: 'Hong Kong',
			value: 'Hong Kong'
		},
		{
			name: 'Hungary',
			value: 'Hungary'
		},
		{
			name: 'Iceland',
			value: 'Iceland'
		},
		{
			name: 'India',
			value: 'India'
		},
		{
			name: 'Indonesia',
			value: 'Indonesia'
		},
		{
			name: 'Iran',
			value: 'Iran'
		},
		{
			name: 'Iraq',
			value: 'Iraq'
		},
		{
			name: 'Ireland',
			value: 'Ireland'
		},
		{
			name: 'Isle of Man',
			value: 'Isle of Man'
		},
		{
			name: 'Israel',
			value: 'Israel'
		},
		{
			name: 'Italy',
			value: 'Italy'
		},
		{
			name: 'Jamaica',
			value: 'Jamaica'
		},
		{
			name: 'Japan',
			value: 'Japan'
		},
		{
			name: 'Jersey',
			value: 'Jersey'
		},
		{
			name: 'Jordan',
			value: 'Jordan'
		},
		{
			name: 'Kazakhstan',
			value: 'Kazakhstan'
		},
		{
			name: 'Kenya',
			value: 'Kenya'
		},
		{
			name: 'Kiribati',
			value: 'Kiribati'
		},
		{
			name: 'Kuwait',
			value: 'Kuwait'
		},
		{
			name: 'Kyrgyzstan',
			value: 'Kyrgyzstan'
		},
		{
			name: 'Laos',
			value: 'Laos'
		},
		{
			name: 'Latvia',
			value: 'Latvia'
		},
		{
			name: 'Lebanon',
			value: 'Lebanon'
		},
		{
			name: 'Lesotho',
			value: 'Lesotho'
		},
		{
			name: 'Liberia',
			value: 'Liberia'
		},
		{
			name: 'Libyan Arab Jamahiriya',
			value: 'Libyan Arab Jamahiriya'
		},
		{
			name: 'Liechtenstein',
			value: 'Liechtenstein'
		},
		{
			name: 'Lithuania',
			value: 'Lithuania'
		},
		{
			name: 'Luxembourg',
			value: 'Luxembourg'
		},
		{
			name: 'Macao',
			value: 'Macao'
		},
		{
			name: 'North Macedonia',
			value: 'North Macedonia'
		},
		{
			name: 'Madagascar',
			value: 'Madagascar'
		},
		{
			name: 'Malawi',
			value: 'Malawi'
		},
		{
			name: 'Malaysia',
			value: 'Malaysia'
		},
		{
			name: 'Maldives',
			value: 'Maldives'
		},
		{
			name: 'Mali',
			value: 'Mali'
		},
		{
			name: 'Malta',
			value: 'Malta'
		},
		{
			name: 'Marshall Islands',
			value: 'Marshall Islands'
		},
		{
			name: 'Martinique',
			value: 'Martinique'
		},
		{
			name: 'Mauritania',
			value: 'Mauritania'
		},
		{
			name: 'Mauritius',
			value: 'Mauritius'
		},
		{
			name: 'Mayotte',
			value: 'Mayotte'
		},
		{
			name: 'Mexico',
			value: 'Mexico'
		},
		{
			name: 'Micronesia, Federated States of',
			value: 'Micronesia, Federated States of'
		},
		{
			name: 'Moldova',
			value: 'Moldova'
		},
		{
			name: 'Monaco',
			value: 'Monaco'
		},
		{
			name: 'Mongolia',
			value: 'Mongolia'
		},
		{
			name: 'Montserrat',
			value: 'Montserrat'
		},
		{
			name: 'Montenegro',
			value: 'Montenegro'
		},
		{
			name: 'Morocco',
			value: 'Morocco'
		},
		{
			name: 'Mozambique',
			value: 'Mozambique'
		},
		{
			name: 'Myanmar',
			value: 'Myanmar'
		},
		{
			name: 'Namibia',
			value: 'Namibia'
		},
		{
			name: 'Nauru',
			value: 'Nauru'
		},
		{
			name: 'Nepal',
			value: 'Nepal'
		},
		{
			name: 'Netherlands',
			value: 'Netherlands'
		},
		{
			name: 'Netherlands Antilles',
			value: 'Netherlands Antilles'
		},
		{
			name: 'New Caledonia',
			value: 'New Caledonia'
		},
		{
			name: 'New Zealand',
			value: 'New Zealand'
		},
		{
			name: 'Nicaragua',
			value: 'Nicaragua'
		},
		{
			name: 'Niger',
			value: 'Niger'
		},
		{
			name: 'Nigeria',
			value: 'Nigeria'
		},
		{
			name: 'Niue',
			value: 'Niue'
		},
		{
			name: 'Norfolk Island',
			value: 'Norfolk Island'
		},
		{
			name: 'North Korea',
			value: 'North Korea'
		},
		{
			name: 'Northern Ireland',
			value: 'Northern Ireland'
		},
		{
			name: 'Northern Mariana Islands',
			value: 'Northern Mariana Islands'
		},
		{
			name: 'Norway',
			value: 'Norway'
		},
		{
			name: 'Oman',
			value: 'Oman'
		},
		{
			name: 'Pakistan',
			value: 'Pakistan'
		},
		{
			name: 'Palau',
			value: 'Palau'
		},
		{
			name: 'Palestine',
			value: 'Palestine'
		},
		{
			name: 'Panama',
			value: 'Panama'
		},
		{
			name: 'Papua New Guinea',
			value: 'Papua New Guinea'
		},
		{
			name: 'Paraguay',
			value: 'Paraguay'
		},
		{
			name: 'Peru',
			value: 'Peru'
		},
		{
			name: 'Philippines',
			value: 'Philippines'
		},
		{
			name: 'Pitcairn',
			value: 'Pitcairn'
		},
		{
			name: 'Poland',
			value: 'Poland'
		},
		{
			name: 'Portugal',
			value: 'Portugal'
		},
		{
			name: 'Puerto Rico',
			value: 'Puerto Rico'
		},
		{
			name: 'Qatar',
			value: 'Qatar'
		},
		{
			name: 'Reunion',
			value: 'Reunion'
		},
		{
			name: 'Romania',
			value: 'Romania'
		},
		{
			name: 'Russian Federation',
			value: 'Russian Federation'
		},
		{
			name: 'Rwanda',
			value: 'Rwanda'
		},
		{
			name: 'Saint Helena',
			value: 'Saint Helena'
		},
		{
			name: 'Saint Kitts and Nevis',
			value: 'Saint Kitts and Nevis'
		},
		{
			name: 'Saint Lucia',
			value: 'Saint Lucia'
		},
		{
			name: 'Saint Pierre and Miquelon',
			value: 'Saint Pierre and Miquelon'
		},
		{
			name: 'Saint Vincent and the Grenadines',
			value: 'Saint Vincent and the Grenadines'
		},
		{
			name: 'Samoa',
			value: 'Samoa'
		},
		{
			name: 'San Marino',
			value: 'San Marino'
		},
		{
			name: 'Sao Tome and Principe',
			value: 'Sao Tome and Principe'
		},
		{
			name: 'Saudi Arabia',
			value: 'Saudi Arabia'
		},
		{
			name: 'Scotland',
			value: 'Scotland'
		},
		{
			name: 'Senegal',
			value: 'Senegal'
		},
		{
			name: 'Serbia',
			value: 'Serbia'
		},
		{
			name: 'Seychelles',
			value: 'Seychelles'
		},
		{
			name: 'Sierra Leone',
			value: 'Sierra Leone'
		},
		{
			name: 'Singapore',
			value: 'Singapore'
		},
		{
			name: 'Slovakia',
			value: 'Slovakia'
		},
		{
			name: 'Slovenia',
			value: 'Slovenia'
		},
		{
			name: 'Solomon Islands',
			value: 'Solomon Islands'
		},
		{
			name: 'Somalia',
			value: 'Somalia'
		},
		{
			name: 'South Africa',
			value: 'South Africa'
		},
		{
			name: 'South Georgia and the South Sandwich Islands',
			value: 'South Georgia and the South Sandwich Islands'
		},
		{
			name: 'South Korea',
			value: 'South Korea'
		},
		{
			name: 'South Sudan',
			value: 'South Sudan'
		},
		{
			name: 'Spain',
			value: 'Spain'
		},
		{
			name: 'SriLanka',
			value: 'SriLanka'
		},
		{
			name: 'Sudan',
			value: 'Sudan'
		},
		{
			name: 'Suriname',
			value: 'Suriname'
		},
		{
			name: 'Svalbard and Jan Mayen',
			value: 'Svalbard and Jan Mayen'
		},
		{
			name: 'Swaziland',
			value: 'Swaziland'
		},
		{
			name: 'Sweden',
			value: 'Sweden'
		},
		{
			name: 'Switzerland',
			value: 'Switzerland'
		},
		{
			name: 'Syria',
			value: 'Syria'
		},
		{
			name: 'Tajikistan',
			value: 'Tajikistan'
		},
		{
			name: 'Tanzania',
			value: 'Tanzania'
		},
		{
			name: 'Thailand',
			value: 'Thailand'
		},
		{
			name: 'Timor-Leste',
			value: 'Timor-Leste'
		},
		{
			name: 'Togo',
			value: 'Togo'
		},
		{
			name: 'Tokelau',
			value: 'Tokelau'
		},
		{
			name: 'Tonga',
			value: 'Tonga'
		},
		{
			name: 'Trinidad and Tobago',
			value: 'Trinidad and Tobago'
		},
		{
			name: 'Tunisia',
			value: 'Tunisia'
		},
		{
			name: 'Turkey',
			value: 'Turkey'
		},
		{
			name: 'Turkmenistan',
			value: 'Turkmenistan'
		},
		{
			name: 'Turks and Caicos Islands',
			value: 'Turks and Caicos Islands'
		},
		{
			name: 'Tuvalu',
			value: 'Tuvalu'
		},
		{
			name: 'Uganda',
			value: 'Uganda'
		},
		{
			name: 'Ukraine',
			value: 'Ukraine'
		},
		{
			name: 'United Arab Emirates',
			value: 'United Arab Emirates'
		},
		COUNTRY_UK,
		{
			name: 'United States',
			value: 'United States'
		},
		{
			name: 'United States Minor Outlying Islands',
			value: 'United States Minor Outlying Islands'
		},
		{
			name: 'Uruguay',
			value: 'Uruguay'
		},
		{
			name: 'Uzbekistan',
			value: 'Uzbekistan'
		},
		{
			name: 'Vanuatu',
			value: 'Vanuatu'
		},
		{
			name: 'Venezuela',
			value: 'Venezuela'
		},
		{
			name: 'Vietnam',
			value: 'Vietnam'
		},
		{
			name: 'Virgin Islands, British',
			value: 'Virgin Islands, British'
		},
		{
			name: 'Virgin Islands, U.S.',
			value: 'Virgin Islands, U.S.'
		},
		{
			name: 'Wales',
			value: 'Wales'
		},
		{
			name: 'Wallis and Futuna',
			value: 'Wallis and Futuna'
		},
		{
			name: 'Western Sahara',
			value: 'Western Sahara'
		},
		{
			name: 'Yemen',
			value: 'Yemen'
		},
		{
			name: 'Yugoslavia',
			value: 'Yugoslavia'
		},
		{
			name: 'Zambia',
			value: 'Zambia'
		},
		{
			name: 'Zimbabwe',
			value: 'Zimbabwe'
		}
	];
}]);

'use strict';

angular.module('paycircleApp')

.constant('CUSTOMISATION_FEATURE_KEYS', {
	login: 'login',
	appHeader: 'app-header',
	systemEmails: 'system-emails',
	onlinePayslips: 'online-payslips',
	intercom: 'intercom',
	employeePortal: 'employee-portal'
})

.factory('CUSTOMISATION_FEATURES', [
	'CUSTOMISATION_FEATURE_KEYS',
function (
	CUSTOMISATION_FEATURE_KEYS
) {
	return 	[
		{
			actionText: null,
			imageUrl: 'customisation-features/0.png',
			theme: null,
			title: 'Sign in page',
			description: 'Brand your sign in page and choose which contact information to show',
			key: CUSTOMISATION_FEATURE_KEYS.login
		},
		{
			actionText: null,
			imageUrl: 'customisation-features/1.png',
			theme: null,
			title: 'App header',
			description: 'Upload an app icon and add your brand colours',
			key: CUSTOMISATION_FEATURE_KEYS.appHeader
		},
		{
			actionText: null,
			imageUrl: 'customisation-features/2.png',
			theme: null,
			title: 'System Emails',
			description: 'Display your logo at the top of emails and your company details in the footer',
			key: CUSTOMISATION_FEATURE_KEYS.systemEmails
		},
		{
			actionText: null,
			imageUrl: 'customisation-features/3.png',
			theme: 'fifty',
			title: 'Online payslips',
			description: 'Brand your online payslips and add support contact details',
			key: CUSTOMISATION_FEATURE_KEYS.onlinePayslips
		},
		{
			actionText: 'Connect',
			imageUrl: 'customisation-features/4.png',
			theme: 'fifty',
			title: 'Intercom live chat',
			description: 'Add your Intercom App ID to provide live chat support to your clients',
			isBureauOnly: true,
			key: CUSTOMISATION_FEATURE_KEYS.intercom
		},
		{
			actionText: null,
			imageUrl: 'customisation-features/5.png',
			theme: 'fifty',
			title: 'Sidebar logo',
			description: 'Display your logo in the sidebar and portal switcher',
			key: CUSTOMISATION_FEATURE_KEYS.employeePortal
		}
	];
}]);
'use strict';

angular.module('paycircleApp')
.constant('CUSTOMISATION_TYPES', {
	company: 'Company',
	email: 'Email',
	icon: 'Icon',
	login: 'Login',
	payslip: 'Payslip',
	sidebar: 'SideBar'
})
.constant('CUSTOMISATION_TYPE_IDS', {
	Email: 0,
	Login: 1,
	Payslip: 2,
	Icon: 3,
	Company: 4,
	SideBar: 5
})
.constant('CUSTOMISATION_SHADES', {
	dark: 'dark',
	light: 'light'
});


'use strict';

angular.module('paycircleApp')
.constant('DATE_STATUSES', {
	present: 'present',
	future: 'future',
	past: 'past'
});

'use strict';

angular.module('paycircleApp')
.constant('DAYS_OF_WEEK', {
	Monday: 1 << 0,		// 0
	Tuesday: 1 << 1,	// 1
	Wednesday: 1 << 2,	// 2
	Thursday: 1 << 3,	// 4
	Friday: 1 << 4,		// 8
	Saturday: 1 << 5,	// 16
	Sunday: 1 << 6		// 32
});



'use strict';

angular.module('paycircleApp')
.constant('DEMO_TASKS', {
	team: {
		editSalary: '73a82a6e-dbaf-47e8-b95c-fed8648f866e',
		makeLeaver: 'b5e08041-edfc-4419-aa74-8fc7372483c7',
		editTaxCode: 'bb969319-24c8-4827-a618-7d580f70f5a5'
	},
	payroll: {
		addPayslipNote: '82aa7e6e-abea-460d-80db-d6dc5ad71172',
		addBonus: 'f19503b4-7355-43ae-bec6-bcde5c605435',
		addExpense: '0e718083-53f0-4bc8-8627-bc547e1380de'
	},
	cis: {
		addSubcontractorGrossPay: '9583efaa-6653-4f34-9815-4b90b945c79d',
		addSubcontractorCostOfMaterials: 'b8d2fc48-d0b2-4aac-9a92-e8f43a2bb133',
		validateNewSubcontractor: '82c35322-880b-4b7d-8a01-99eca2a9f0d5'
	},
	companySettings: {
		uploadCompanyPayslipLogo: 'b3b34828-1f34-4d15-8ea6-4c598e62f1db',
		changePayrollProcessingDate: '83f260a2-fb30-419b-9514-4dd64ea86a7f',
		switchToAutoRun: '27f072f9-f099-467b-9b64-7e518fd86cb9'
	},
	workplacePension: {
		updateEmployeePensionContributions: '87a7a9a8-be4d-44be-946d-fe38c7bf3077',
		updateTeamPostponementSettings: '67483eef-38cf-4dda-ab18-02c804c43878',
		updateEmployeesPensionState: '9462bd89-d4af-4e1e-96f9-a23b275b51f7'
	},
	holidayAndSickness: {
		addHoliday: '933e6081-e0d7-477d-aae6-63e0e441a92a',
		addSickness: 'cc5d309f-b8ef-496c-addc-62059589f446',
		editHoliday: 'ac225cf9-e654-44a1-9948-c5dac0e37a22'
	},
	approvePayroll: {
		calculatePayroll: '3816c589-41e0-4f61-9de0-55834c99e69c1',
		runPayroll: '3816c589-41e0-4f61-9de0-55834c99e69c2',
		checkPayroll: '3816c589-41e0-4f61-9de0-55834c99e69c3'
	}
})
.constant('DEMO_TASKS_SHORT', {
	'73a82a6e-dbaf-47e8-b95c-fed8648f866e': 'editSalary',
	'b5e08041-edfc-4419-aa74-8fc7372483c7': 'makeLeaver',
	'bb969319-24c8-4827-a618-7d580f70f5a5': 'editTaxCode',

	'f19503b4-7355-43ae-bec6-bcde5c605435': 'addBonus',
	'0e718083-53f0-4bc8-8627-bc547e1380de': 'addExpense',
	'82aa7e6e-abea-460d-80db-d6dc5ad71172': 'addPayslipNote',

	'9583efaa-6653-4f34-9815-4b90b945c79d': 'addSubcontractorGrossPay',
	'b8d2fc48-d0b2-4aac-9a92-e8f43a2bb133': 'addSubcontractorCostOfMaterials',
	'82c35322-880b-4b7d-8a01-99eca2a9f0d5': 'validateNewSubcontractor',

	'b3b34828-1f34-4d15-8ea6-4c598e62f1db': 'uploadCompanyPayslipLogo',
	'83f260a2-fb30-419b-9514-4dd64ea86a7f': 'changePayrollProcessingDate',
	'27f072f9-f099-467b-9b64-7e518fd86cb9': 'switchToAutoRun',

	'87a7a9a8-be4d-44be-946d-fe38c7bf3077': 'updateEmployeePensionContributions',
	'67483eef-38cf-4dda-ab18-02c804c43878': 'updateTeamPostponementSettings',
	'9462bd89-d4af-4e1e-96f9-a23b275b51f7': 'updateEmployeesPensionState',

	'933e6081-e0d7-477d-aae6-63e0e441a92a': 'addHoliday',
	'cc5d309f-b8ef-496c-addc-62059589f446': 'addSickness',
	'ac225cf9-e654-44a1-9948-c5dac0e37a22': 'editHoliday',

	'3816c589-41e0-4f61-9de0-55834c99e69c1': 'calculatePayroll',
	'3816c589-41e0-4f61-9de0-55834c99e69c2': 'runPayroll',
	'3816c589-41e0-4f61-9de0-55834c99e69c3': 'checkPayroll'
})
.constant('DEMO_QUESTION_GROUPS', {
	approvePayroll: '3816c589-41e0-4f61-9de0-55834c99e69c',
	cis: '1690bef5-871a-470e-99e0-55c9df96b667',
	companySettings: 'ee6bdb17-ba66-4ee3-9cf5-9116360c131c',
	holidayAndSickness: 'a44ae5c3-10e4-4664-84fa-c8a23758af12',
	payroll: '49cf23c3-3d8f-4e19-9d58-87e61ed751c3',
	pension: 'e256ccbc-ba8a-41e9-b4de-d17945cdafae',
	team: '92adb583-56ac-406f-b36d-ffde585c1b2f',
	workplacePension: '0a3f3f00-2b85-4aae-b22e-caa8b4f4e4ee'
});

'use strict';

angular.module('paycircleApp')

.constant('DISBURSEMENT_CONTEXT_TYPES', {
	dayOfMonth: 0, // 1st, 2nd, etc...
	noSeparateBacsFile: 1,
	paymentDates: 2, // Quarterly, Bi-annual, Annual payments
	relativeDays: 3, // 0 = On pay day, 1+ = After pay day
});

'use strict';

angular.module('paycircleApp')
.constant('DOCUMENT_STATES', {
	unchecked: 0,
	checked: 1,
	available: 2,
	pending: 3,
	processed: 4
});

'use strict';

angular.module('paycircleApp')
.constant('DOCUMENT_TYPE_IDS', {
	adjustmentImport: '1A191048-4C01-4FAE-99AF-50CC1A5F4F5B',
	bureauMappingTemplate: '1bd28a96-4660-4062-a090-ea03fcaf2838',
	fixedDataImport: 'a803f1ba-8f35-448f-96a1-5f182eb50f6c',
	cisPayStatement: '77363db0-b5f5-4884-8be4-2932f142376d',
	epsImport: '99ED7828-747D-4723-BB9C-F7D1633DACCE',
	fpsImport: '0fca9e85-af0d-42d4-9956-4f89808a3318',
	import: '1A191048-4C01-4FAE-99AF-50CC1A5F4F5B',
	message: '132214fc-aea4-4b47-aaf3-8c4a6d1f8f57',
	teamImport: 'AF48BC80-CEB0-4716-A617-6AD8C4D91FCD',
	workerImport: '816dbdca-18a9-4233-aec1-9d2f085328c2',
	genericUpload: '74cf48dd-5354-4cad-a080-ee7c496891e5',
	payslipManagerFullRun: 'f8c4bc32-e8f5-4ea2-af8b-f74486af8bdd',
	payslipManagerSupplementaryPayRun: '49933c50-ea69-42c2-b1e8-c5e2b37b5384',
	payrollCompanyImport: '3a5d0e6c-0f72-42ee-ae5b-d4e9e871b0c7'
});

'use strict';

angular.module('paycircleApp')
.constant('DOCUMENT_TYPES', {
	bureauMappingTemplate: 999,
	periodImport: 0,
	teamImport: 1,
	permissionsReport: 2,
	nominalCodeReport: 3,
	payrollRtiAutoNilEps: 4,
	genericUpload: 5,
	fpsImport: 6,
	payslipManagerFullRun: 7,
	payslipManagerSupplementaryRun: 8,
	businessCategories: 9,
	nominalCodes: 10,
	xeroNominalCodes: 11,
	policyImport: 12,
	accessFinancialsNominalAccountsImport: 13,
	accessFinancialsBusinessCategoriesImport: 14
});

'use strict';

/**
 * The variation of draft payslip task states
 */
angular.module('paycircleApp')
.constant('DRAFT_PAYSLIP_TASK_STATES', {
	none: -1,
	pending: 0,
	processing: 1,
	complete: 2,
	failed: 3,
	recallPending: 4,
	recallProcessing: 5,
	recallComplete: 6,
	recallFailed: 7,
	error: 8,
	cancelPending: 9,
	cancelProcessing: 10,
	retryPending: 11,
	retryProcessing: 12,
	noTeamMembers: -2
});

'use strict';

angular.module('paycircleApp')
.constant('DPS_STATES', {
	invalidCredentials: 1,
	unauthorised: 2,
	hmrcFault: 3
});

'use strict';

angular.module('paycircleApp')
.constant('EMAIL_PREVIEW_TYPES', {
	standard: '0',
	notificationSettingsPreview: '1'
});
'use strict';

angular.module('paycircleApp')
.constant('EMAIL_UNIQUENESS_ERROR_CODES', {
	none: 0,
	inUseIdentity: 1,
	inUseOtherUser: 2,
	unexpectedError: 3
});
'use strict';

angular.module('paycircleApp')
.constant('EMOJIS', [
	{
		code: '1F600',
		char: '😀'
	},
	{
		code: '1F601',
		char: '😁'
	},
	{
		code: '1F602',
		char: '😂'
	},
	{
		code: '1F923',
		char: '🤣'
	},
	{
		code: '1F603',
		char: '😃'
	},
	{
		code: '1F604',
		char: '😄'
	},
	{
		code: '1F605',
		char: '😅'
	},
	{
		code: '1F606',
		char: '😆'
	},
	{
		code: '1F609',
		char: '😉'
	},
	{
		code: '1F60A',
		char: '😊'
	},
	{
		code: '1F60B',
		char: '😋'
	},
	{
		code: '1F60E',
		char: '😎'
	},
	{
		code: '1F60D',
		char: '😍'
	},
	{
		code: '1F618',
		char: '😘'
	},
	{
		code: '1F617',
		char: '😗'
	},
	{
		code: '1F619',
		char: '😙'
	},
	{
		code: '1F61A',
		char: '😚'
	},
	{
		code: '1F642',
		char: '🙂'
	},
	{
		code: '1F917',
		char: '🤗'
	},
	{
		code: '1F914',
		char: '🤔'
	},
	{
		code: '1F610',
		char: '😐'
	},
	{
		code: '1F611',
		char: '😑'
	},
	{
		code: '1F636',
		char: '😶'
	},
	{
		code: '1F644',
		char: '🙄'
	},
	{
		code: '1F60F',
		char: '😏'
	},
	{
		code: '1F623',
		char: '😣'
	},
	{
		code: '1F625',
		char: '😥'
	},
	{
		code: '1F62E',
		char: '😮'
	},
	{
		code: '1F910',
		char: '🤐'
	},
	{
		code: '1F62F',
		char: '😯'
	},
	{
		code: '1F62A',
		char: '😪'
	},
	{
		code: '1F62B',
		char: '😫'
	},
	{
		code: '1F634',
		char: '😴'
	},
	{
		code: '1F60C',
		char: '😌'
	},
	{
		code: '1F913',
		char: '🤓'
	},
	{
		code: '1F61B',
		char: '😛'
	},
	{
		code: '1F61C',
		char: '😜'
	},
	{
		code: '1F61D',
		char: '😝'
	},
	{
		code: '1F924',
		char: '🤤'
	},
	{
		code: '1F612',
		char: '😒'
	},
	{
		code: '1F613',
		char: '😓'
	},
	{
		code: '1F614',
		char: '😔'
	},
	{
		code: '1F615',
		char: '😕'
	},
	{
		code: '1F643',
		char: '🙃'
	},
	{
		code: '1F911',
		char: '🤑'
	},
	{
		code: '1F632',
		char: '😲'
	},
	{
		code: '1F641',
		char: '🙁'
	},
	{
		code: '1F616',
		char: '😖'
	},
	{
		code: '1F61E',
		char: '😞'
	},
	{
		code: '1F61F',
		char: '😟'
	},
	{
		code: '1F624',
		char: '😤'
	},
	{
		code: '1F622',
		char: '😢'
	},
	{
		code: '1F62D',
		char: '😭'
	},
	{
		code: '1F626',
		char: '😦'
	},
	{
		code: '1F627',
		char: '😧'
	},
	{
		code: '1F628',
		char: '😨'
	},
	{
		code: '1F629',
		char: '😩'
	},
	{
		code: '1F62C',
		char: '😬'
	},
	{
		code: '1F630',
		char: '😰'
	},
	{
		code: '1F631',
		char: '😱'
	},
	{
		code: '1F633',
		char: '😳'
	},
	{
		code: '1F635',
		char: '😵'
	},
	{
		code: '1F621',
		char: '😡'
	},
	{
		code: '1F620',
		char: '😠'
	},
	{
		code: '1F607',
		char: '😇'
	},
	{
		code: '1F920',
		char: '🤠'
	},
	{
		code: '1F921',
		char: '🤡'
	},
	{
		code: '1F925',
		char: '🤥'
	},
	{
		code: '1F637',
		char: '😷'
	},
	{
		code: '1F912',
		char: '🤒'
	},
	{
		code: '1F915',
		char: '🤕'
	},
	{
		code: '1F922',
		char: '🤢'
	},
	{
		code: '1F927',
		char: '🤧'
	},
	{
		code: '1F608',
		char: '😈'
	},
	{
		code: '1F47F',
		char: '👿'
	},
	{
		code: '1F479',
		char: '👹'
	},
	{
		code: '1F47A',
		char: '👺'
	},
	{
		code: '1F480',
		char: '💀'
	},
	{
		code: '2620',
		char: '☠'
	},
	{
		code: '1F47B',
		char: '👻'
	},
	{
		code: '1F47D',
		char: '👽'
	},
	{
		code: '1F47E',
		char: '👾'
	},
	{
		code: '1F916',
		char: '🤖'
	},
	{
		code: '1F4A9',
		char: '💩'
	},
	{
		code: '1F63A',
		char: '😺'
	},
	{
		code: '1F638',
		char: '😸'
	},
	{
		code: '1F639',
		char: '😹'
	},
	{
		code: '1F63B',
		char: '😻'
	},
	{
		code: '1F63C',
		char: '😼'
	},
	{
		code: '1F63D',
		char: '😽'
	},
	{
		code: '1F640',
		char: '🙀'
	},
	{
		code: '1F63F',
		char: '😿'
	},
	{
		code: '1F63E',
		char: '😾'
	},
	{
		code: '1F648',
		char: '🙈'
	},
	{
		code: '1F649',
		char: '🙉'
	},
	{
		code: '1F64A',
		char: '🙊'
	},
	{
		code: '1F466',
		char: '👦'
	},
	{
		code: '1F467',
		char: '👧'
	},
	{
		code: '1F468',
		char: '👨'
	},
	{
		code: '1F469',
		char: '👩'
	},
	{
		code: '1F474',
		char: '👴'
	},
	{
		code: '1F475',
		char: '👵'
	},
	{
		code: '1F476',
		char: '👶'
	},
	{
		code: '1F47C',
		char: '👼'
	},
	{
		code: '1F46E',
		char: '👮'
	},
	{
		code: '1F575',
		char: '🕵'
	},
	{
		code: '1F482',
		char: '💂'
	},
	{
		code: '1F477',
		char: '👷'
	},
	{
		code: '1F473',
		char: '👳'
	},
	{
		code: '1F471',
		char: '👱'
	},
	{
		code: '1F385',
		char: '🎅'
	},
	{
		code: '1F936',
		char: '🤶'
	},
	{
		code: '1F478',
		char: '👸'
	},
	{
		code: '1F934',
		char: '🤴'
	},
	{
		code: '1F470',
		char: '👰'
	},
	{
		code: '1F935',
		char: '🤵'
	},
	{
		code: '1F930',
		char: '🤰'
	},
	{
		code: '1F472',
		char: '👲'
	},
	{
		code: '1F64D',
		char: '🙍'
	},
	{
		code: '1F64E',
		char: '🙎'
	},
	{
		code: '1F645',
		char: '🙅'
	},
	{
		code: '1F646',
		char: '🙆'
	},
	{
		code: '1F481',
		char: '💁'
	},
	{
		code: '1F64B',
		char: '🙋'
	},
	{
		code: '1F647',
		char: '🙇'
	},
	{
		code: '1F926',
		char: '🤦'
	},
	{
		code: '1F937',
		char: '🤷'
	},
	{
		code: '1F486',
		char: '💆'
	},
	{
		code: '1F487',
		char: '💇'
	},
	{
		code: '1F6B6',
		char: '🚶'
	},
	{
		code: '1F3C3',
		char: '🏃'
	},
	{
		code: '1F483',
		char: '💃'
	},
	{
		code: '1F57A',
		char: '🕺'
	},
	{
		code: '1F46F',
		char: '👯'
	},
	{
		code: '1F574',
		char: '🕴'
	},
	{
		code: '1F5E3',
		char: '🗣'
	},
	{
		code: '1F464',
		char: '👤'
	},
	{
		code: '1F465',
		char: '👥'
	},
	{
		code: '1F46B',
		char: '👫'
	},
	{
		code: '1F46C',
		char: '👬'
	},
	{
		code: '1F46D',
		char: '👭'
	},
	{
		code: '1F48F',
		char: '💏'
	},
	{
		code: '1F491',
		char: '💑'
	},
	{
		code: '1F46A',
		char: '👪'
	},
	{
		code: '1F4AA',
		char: '💪'
	},
	{
		code: '1F933',
		char: '🤳'
	},
	{
		code: '1F448',
		char: '👈'
	},
	{
		code: '1F449',
		char: '👉'
	},
	{
		code: '1F446',
		char: '👆'
	},
	{
		code: '1F595',
		char: '🖕'
	},
	{
		code: '1F447',
		char: '👇'
	},
	{
		code: '1F91E',
		char: '🤞'
	},
	{
		code: '1F596',
		char: '🖖'
	},
	{
		code: '1F918',
		char: '🤘'
	},
	{
		code: '1F919',
		char: '🤙'
	},
	{
		code: '1F590',
		char: '🖐'
	},
	{
		code: '270B',
		char: '✋'
	},
	{
		code: '1F44C',
		char: '👌'
	},
	{
		code: '1F44D',
		char: '👍'
	},
	{
		code: '1F44E',
		char: '👎'
	},
	{
		code: '270A',
		char: '✊'
	},
	{
		code: '1F44A',
		char: '👊'
	},
	{
		code: '1F91B',
		char: '🤛'
	},
	{
		code: '1F91C',
		char: '🤜'
	},
	{
		code: '1F91A',
		char: '🤚'
	},
	{
		code: '1F44B',
		char: '👋'
	},
	{
		code: '1F44F',
		char: '👏'
	},
	{
		code: '270D',
		char: '✍'
	},
	{
		code: '1F450',
		char: '👐'
	},
	{
		code: '1F64C',
		char: '🙌'
	},
	{
		code: '1F64F',
		char: '🙏'
	},
	{
		code: '1F91D',
		char: '🤝'
	},
	{
		code: '1F485',
		char: '💅'
	},
	{
		code: '1F442',
		char: '👂'
	},
	{
		code: '1F443',
		char: '👃'
	},
	{
		code: '1F463',
		char: '👣'
	},
	{
		code: '1F440',
		char: '👀'
	},
	{
		code: '1F441',
		char: '👁'
	},
	{
		code: '1F445',
		char: '👅'
	},
	{
		code: '1F444',
		char: '👄'
	},
	{
		code: '1F48B',
		char: '💋'
	},
	{
		code: '1F498',
		char: '💘'
	},
	{
		code: '1F493',
		char: '💓'
	},
	{
		code: '1F494',
		char: '💔'
	},
	{
		code: '1F495',
		char: '💕'
	},
	{
		code: '1F496',
		char: '💖'
	},
	{
		code: '1F497',
		char: '💗'
	},
	{
		code: '1F499',
		char: '💙'
	},
	{
		code: '1F49A',
		char: '💚'
	},
	{
		code: '1F49B',
		char: '💛'
	},
	{
		code: '1F49C',
		char: '💜'
	},
	{
		code: '1F5A4',
		char: '🖤'
	},
	{
		code: '1F49D',
		char: '💝'
	},
	{
		code: '1F49E',
		char: '💞'
	},
	{
		code: '1F49F',
		char: '💟'
	},
	{
		code: '2763',
		char: '❣'
	},
	{
		code: '1F48C',
		char: '💌'
	},
	{
		code: '1F4A4',
		char: '💤'
	},
	{
		code: '1F4A2',
		char: '💢'
	},
	{
		code: '1F4A3',
		char: '💣'
	},
	{
		code: '1F4A5',
		char: '💥'
	},
	{
		code: '1F4A6',
		char: '💦'
	},
	{
		code: '1F4A8',
		char: '💨'
	},
	{
		code: '1F4AB',
		char: '💫'
	},
	{
		code: '1F4AC',
		char: '💬'
	},
	{
		code: '1F5E8',
		char: '🗨'
	},
	{
		code: '1F5EF',
		char: '🗯'
	},
	{
		code: '1F4AD',
		char: '💭'
	},
	{
		code: '1F573',
		char: '🕳'
	},
	{
		code: '1F453',
		char: '👓'
	},
	{
		code: '1F576',
		char: '🕶'
	},
	{
		code: '1F454',
		char: '👔'
	},
	{
		code: '1F455',
		char: '👕'
	},
	{
		code: '1F456',
		char: '👖'
	},
	{
		code: '1F457',
		char: '👗'
	},
	{
		code: '1F458',
		char: '👘'
	},
	{
		code: '1F459',
		char: '👙'
	},
	{
		code: '1F45A',
		char: '👚'
	},
	{
		code: '1F45B',
		char: '👛'
	},
	{
		code: '1F45C',
		char: '👜'
	},
	{
		code: '1F45D',
		char: '👝'
	},
	{
		code: '1F6CD',
		char: '🛍'
	},
	{
		code: '1F392',
		char: '🎒'
	},
	{
		code: '1F45E',
		char: '👞'
	},
	{
		code: '1F45F',
		char: '👟'
	},
	{
		code: '1F460',
		char: '👠'
	},
	{
		code: '1F461',
		char: '👡'
	},
	{
		code: '1F462',
		char: '👢'
	},
	{
		code: '1F451',
		char: '👑'
	},
	{
		code: '1F452',
		char: '👒'
	},
	{
		code: '1F3A9',
		char: '🎩'
	},
	{
		code: '1F393',
		char: '🎓'
	},
	{
		code: '26D1',
		char: '⛑'
	},
	{
		code: '1F4FF',
		char: '📿'
	},
	{
		code: '1F484',
		char: '💄'
	},
	{
		code: '1F48D',
		char: '💍'
	},
	{
		code: '1F48E',
		char: '💎'
	},
	{
		code: '1F435',
		char: '🐵'
	},
	{
		code: '1F412',
		char: '🐒'
	},
	{
		code: '1F98D',
		char: '🦍'
	},
	{
		code: '1F436',
		char: '🐶'
	},
	{
		code: '1F415',
		char: '🐕'
	},
	{
		code: '1F429',
		char: '🐩'
	},
	{
		code: '1F43A',
		char: '🐺'
	},
	{
		code: '1F98A',
		char: '🦊'
	},
	{
		code: '1F431',
		char: '🐱'
	},
	{
		code: '1F408',
		char: '🐈'
	},
	{
		code: '1F981',
		char: '🦁'
	},
	{
		code: '1F42F',
		char: '🐯'
	},
	{
		code: '1F405',
		char: '🐅'
	},
	{
		code: '1F406',
		char: '🐆'
	},
	{
		code: '1F434',
		char: '🐴'
	},
	{
		code: '1F40E',
		char: '🐎'
	},
	{
		code: '1F98C',
		char: '🦌'
	},
	{
		code: '1F984',
		char: '🦄'
	},
	{
		code: '1F42E',
		char: '🐮'
	},
	{
		code: '1F402',
		char: '🐂'
	},
	{
		code: '1F403',
		char: '🐃'
	},
	{
		code: '1F404',
		char: '🐄'
	},
	{
		code: '1F437',
		char: '🐷'
	},
	{
		code: '1F416',
		char: '🐖'
	},
	{
		code: '1F417',
		char: '🐗'
	},
	{
		code: '1F43D',
		char: '🐽'
	},
	{
		code: '1F40F',
		char: '🐏'
	},
	{
		code: '1F411',
		char: '🐑'
	},
	{
		code: '1F410',
		char: '🐐'
	},
	{
		code: '1F42A',
		char: '🐪'
	},
	{
		code: '1F42B',
		char: '🐫'
	},
	{
		code: '1F418',
		char: '🐘'
	},
	{
		code: '1F98F',
		char: '🦏'
	},
	{
		code: '1F42D',
		char: '🐭'
	},
	{
		code: '1F401',
		char: '🐁'
	},
	{
		code: '1F400',
		char: '🐀'
	},
	{
		code: '1F439',
		char: '🐹'
	},
	{
		code: '1F430',
		char: '🐰'
	},
	{
		code: '1F407',
		char: '🐇'
	},
	{
		code: '1F43F',
		char: '🐿'
	},
	{
		code: '1F987',
		char: '🦇'
	},
	{
		code: '1F43B',
		char: '🐻'
	},
	{
		code: '1F428',
		char: '🐨'
	},
	{
		code: '1F43C',
		char: '🐼'
	},
	{
		code: '1F43E',
		char: '🐾'
	},
	{
		code: '1F983',
		char: '🦃'
	},
	{
		code: '1F414',
		char: '🐔'
	},
	{
		code: '1F413',
		char: '🐓'
	},
	{
		code: '1F423',
		char: '🐣'
	},
	{
		code: '1F424',
		char: '🐤'
	},
	{
		code: '1F425',
		char: '🐥'
	},
	{
		code: '1F426',
		char: '🐦'
	},
	{
		code: '1F427',
		char: '🐧'
	},
	{
		code: '1F54A',
		char: '🕊'
	},
	{
		code: '1F985',
		char: '🦅'
	},
	{
		code: '1F986',
		char: '🦆'
	},
	{
		code: '1F989',
		char: '🦉'
	},
	{
		code: '1F438',
		char: '🐸'
	},
	{
		code: '1F40A',
		char: '🐊'
	},
	{
		code: '1F422',
		char: '🐢'
	},
	{
		code: '1F98E',
		char: '🦎'
	},
	{
		code: '1F40D',
		char: '🐍'
	},
	{
		code: '1F432',
		char: '🐲'
	},
	{
		code: '1F409',
		char: '🐉'
	},
	{
		code: '1F433',
		char: '🐳'
	},
	{
		code: '1F40B',
		char: '🐋'
	},
	{
		code: '1F42C',
		char: '🐬'
	},
	{
		code: '1F41F',
		char: '🐟'
	},
	{
		code: '1F420',
		char: '🐠'
	},
	{
		code: '1F421',
		char: '🐡'
	},
	{
		code: '1F988',
		char: '🦈'
	},
	{
		code: '1F419',
		char: '🐙'
	},
	{
		code: '1F41A',
		char: '🐚'
	},
	{
		code: '1F980',
		char: '🦀'
	},
	{
		code: '1F990',
		char: '🦐'
	},
	{
		code: '1F991',
		char: '🦑'
	},
	{
		code: '1F98B',
		char: '🦋'
	},
	{
		code: '1F40C',
		char: '🐌'
	},
	{
		code: '1F41B',
		char: '🐛'
	},
	{
		code: '1F41C',
		char: '🐜'
	},
	{
		code: '1F41D',
		char: '🐝'
	},
	{
		code: '1F41E',
		char: '🐞'
	},
	{
		code: '1F577',
		char: '🕷'
	},
	{
		code: '1F578',
		char: '🕸'
	},
	{
		code: '1F982',
		char: '🦂'
	},
	{
		code: '1F490',
		char: '💐'
	},
	{
		code: '1F338',
		char: '🌸'
	},
	{
		code: '1F4AE',
		char: '💮'
	},
	{
		code: '1F3F5',
		char: '🏵'
	},
	{
		code: '1F339',
		char: '🌹'
	},
	{
		code: '1F940',
		char: '🥀'
	},
	{
		code: '1F33A',
		char: '🌺'
	},
	{
		code: '1F33B',
		char: '🌻'
	},
	{
		code: '1F33C',
		char: '🌼'
	},
	{
		code: '1F337',
		char: '🌷'
	},
	{
		code: '1F331',
		char: '🌱'
	},
	{
		code: '1F332',
		char: '🌲'
	},
	{
		code: '1F333',
		char: '🌳'
	},
	{
		code: '1F334',
		char: '🌴'
	},
	{
		code: '1F335',
		char: '🌵'
	},
	{
		code: '1F33E',
		char: '🌾'
	},
	{
		code: '1F33F',
		char: '🌿'
	},
	{
		code: '2618',
		char: '☘'
	},
	{
		code: '1F340',
		char: '🍀'
	},
	{
		code: '1F341',
		char: '🍁'
	},
	{
		code: '1F342',
		char: '🍂'
	},
	{
		code: '1F343',
		char: '🍃'
	},
	{
		code: '1F347',
		char: '🍇'
	},
	{
		code: '1F348',
		char: '🍈'
	},
	{
		code: '1F349',
		char: '🍉'
	},
	{
		code: '1F34A',
		char: '🍊'
	},
	{
		code: '1F34B',
		char: '🍋'
	},
	{
		code: '1F34C',
		char: '🍌'
	},
	{
		code: '1F34D',
		char: '🍍'
	},
	{
		code: '1F34E',
		char: '🍎'
	},
	{
		code: '1F34F',
		char: '🍏'
	},
	{
		code: '1F350',
		char: '🍐'
	},
	{
		code: '1F351',
		char: '🍑'
	},
	{
		code: '1F352',
		char: '🍒'
	},
	{
		code: '1F353',
		char: '🍓'
	},
	{
		code: '1F95D',
		char: '🥝'
	},
	{
		code: '1F345',
		char: '🍅'
	},
	{
		code: '1F951',
		char: '🥑'
	},
	{
		code: '1F346',
		char: '🍆'
	},
	{
		code: '1F954',
		char: '🥔'
	},
	{
		code: '1F955',
		char: '🥕'
	},
	{
		code: '1F33D',
		char: '🌽'
	},
	{
		code: '1F336',
		char: '🌶'
	},
	{
		code: '1F952',
		char: '🥒'
	},
	{
		code: '1F344',
		char: '🍄'
	},
	{
		code: '1F95C',
		char: '🥜'
	},
	{
		code: '1F330',
		char: '🌰'
	},
	{
		code: '1F35E',
		char: '🍞'
	},
	{
		code: '1F950',
		char: '🥐'
	},
	{
		code: '1F956',
		char: '🥖'
	},
	{
		code: '1F95E',
		char: '🥞'
	},
	{
		code: '1F9C0',
		char: '🧀'
	},
	{
		code: '1F356',
		char: '🍖'
	},
	{
		code: '1F357',
		char: '🍗'
	},
	{
		code: '1F953',
		char: '🥓'
	},
	{
		code: '1F354',
		char: '🍔'
	},
	{
		code: '1F35F',
		char: '🍟'
	},
	{
		code: '1F355',
		char: '🍕'
	},
	{
		code: '1F32D',
		char: '🌭'
	},
	{
		code: '1F32E',
		char: '🌮'
	},
	{
		code: '1F32F',
		char: '🌯'
	},
	{
		code: '1F959',
		char: '🥙'
	},
	{
		code: '1F95A',
		char: '🥚'
	},
	{
		code: '1F373',
		char: '🍳'
	},
	{
		code: '1F958',
		char: '🥘'
	},
	{
		code: '1F372',
		char: '🍲'
	},
	{
		code: '1F957',
		char: '🥗'
	},
	{
		code: '1F37F',
		char: '🍿'
	},
	{
		code: '1F371',
		char: '🍱'
	},
	{
		code: '1F358',
		char: '🍘'
	},
	{
		code: '1F359',
		char: '🍙'
	},
	{
		code: '1F35A',
		char: '🍚'
	},
	{
		code: '1F35B',
		char: '🍛'
	},
	{
		code: '1F35C',
		char: '🍜'
	},
	{
		code: '1F35D',
		char: '🍝'
	},
	{
		code: '1F360',
		char: '🍠'
	},
	{
		code: '1F362',
		char: '🍢'
	},
	{
		code: '1F363',
		char: '🍣'
	},
	{
		code: '1F364',
		char: '🍤'
	},
	{
		code: '1F365',
		char: '🍥'
	},
	{
		code: '1F361',
		char: '🍡'
	},
	{
		code: '1F366',
		char: '🍦'
	},
	{
		code: '1F367',
		char: '🍧'
	},
	{
		code: '1F368',
		char: '🍨'
	},
	{
		code: '1F369',
		char: '🍩'
	},
	{
		code: '1F36A',
		char: '🍪'
	},
	{
		code: '1F382',
		char: '🎂'
	},
	{
		code: '1F370',
		char: '🍰'
	},
	{
		code: '1F36B',
		char: '🍫'
	},
	{
		code: '1F36C',
		char: '🍬'
	},
	{
		code: '1F36D',
		char: '🍭'
	},
	{
		code: '1F36E',
		char: '🍮'
	},
	{
		code: '1F36F',
		char: '🍯'
	},
	{
		code: '1F37C',
		char: '🍼'
	},
	{
		code: '1F95B',
		char: '🥛'
	},
	{
		code: '2615',
		char: '☕'
	},
	{
		code: '1F375',
		char: '🍵'
	},
	{
		code: '1F376',
		char: '🍶'
	},
	{
		code: '1F37E',
		char: '🍾'
	},
	{
		code: '1F377',
		char: '🍷'
	},
	{
		code: '1F378',
		char: '🍸'
	},
	{
		code: '1F379',
		char: '🍹'
	},
	{
		code: '1F37A',
		char: '🍺'
	},
	{
		code: '1F37B',
		char: '🍻'
	},
	{
		code: '1F942',
		char: '🥂'
	},
	{
		code: '1F943',
		char: '🥃'
	},
	{
		code: '1F37D',
		char: '🍽'
	},
	{
		code: '1F374',
		char: '🍴'
	},
	{
		code: '1F944',
		char: '🥄'
	},
	{
		code: '1F52A',
		char: '🔪'
	},
	{
		code: '1F3FA',
		char: '🏺'
	},
	{
		code: '1F30D',
		char: '🌍'
	},
	{
		code: '1F30E',
		char: '🌎'
	},
	{
		code: '1F30F',
		char: '🌏'
	},
	{
		code: '1F310',
		char: '🌐'
	},
	{
		code: '1F5FA',
		char: '🗺'
	},
	{
		code: '1F5FE',
		char: '🗾'
	},
	{
		code: '1F3D4',
		char: '🏔'
	},
	{
		code: '26F0',
		char: '⛰'
	},
	{
		code: '1F30B',
		char: '🌋'
	},
	{
		code: '1F5FB',
		char: '🗻'
	},
	{
		code: '1F3D5',
		char: '🏕'
	},
	{
		code: '1F3D6',
		char: '🏖'
	},
	{
		code: '1F3DC',
		char: '🏜'
	},
	{
		code: '1F3DD',
		char: '🏝'
	},
	{
		code: '1F3DE',
		char: '🏞'
	},
	{
		code: '1F3DF',
		char: '🏟'
	},
	{
		code: '1F3DB',
		char: '🏛'
	},
	{
		code: '1F3D7',
		char: '🏗'
	},
	{
		code: '1F3D8',
		char: '🏘'
	},
	{
		code: '1F3D9',
		char: '🏙'
	},
	{
		code: '1F3DA',
		char: '🏚'
	},
	{
		code: '1F3E0',
		char: '🏠'
	},
	{
		code: '1F3E1',
		char: '🏡'
	},
	{
		code: '1F3E2',
		char: '🏢'
	},
	{
		code: '1F3E3',
		char: '🏣'
	},
	{
		code: '1F3E4',
		char: '🏤'
	},
	{
		code: '1F3E5',
		char: '🏥'
	},
	{
		code: '1F3E6',
		char: '🏦'
	},
	{
		code: '1F3E8',
		char: '🏨'
	},
	{
		code: '1F3E9',
		char: '🏩'
	},
	{
		code: '1F3EA',
		char: '🏪'
	},
	{
		code: '1F3EB',
		char: '🏫'
	},
	{
		code: '1F3EC',
		char: '🏬'
	},
	{
		code: '1F3ED',
		char: '🏭'
	},
	{
		code: '1F3EF',
		char: '🏯'
	},
	{
		code: '1F3F0',
		char: '🏰'
	},
	{
		code: '1F492',
		char: '💒'
	},
	{
		code: '1F5FC',
		char: '🗼'
	},
	{
		code: '1F5FD',
		char: '🗽'
	},
	{
		code: '26EA',
		char: '⛪'
	},
	{
		code: '1F54C',
		char: '🕌'
	},
	{
		code: '1F54D',
		char: '🕍'
	},
	{
		code: '26E9',
		char: '⛩'
	},
	{
		code: '1F54B',
		char: '🕋'
	},
	{
		code: '26F2',
		char: '⛲'
	},
	{
		code: '26FA',
		char: '⛺'
	},
	{
		code: '1F301',
		char: '🌁'
	},
	{
		code: '1F303',
		char: '🌃'
	},
	{
		code: '1F304',
		char: '🌄'
	},
	{
		code: '1F305',
		char: '🌅'
	},
	{
		code: '1F306',
		char: '🌆'
	},
	{
		code: '1F307',
		char: '🌇'
	},
	{
		code: '1F309',
		char: '🌉'
	},
	{
		code: '1F30C',
		char: '🌌'
	},
	{
		code: '1F3A0',
		char: '🎠'
	},
	{
		code: '1F3A1',
		char: '🎡'
	},
	{
		code: '1F3A2',
		char: '🎢'
	},
	{
		code: '1F488',
		char: '💈'
	},
	{
		code: '1F3AA',
		char: '🎪'
	},
	{
		code: '1F3AD',
		char: '🎭'
	},
	{
		code: '1F5BC',
		char: '🖼'
	},
	{
		code: '1F3A8',
		char: '🎨'
	},
	{
		code: '1F3B0',
		char: '🎰'
	},
	{
		code: '1F682',
		char: '🚂'
	},
	{
		code: '1F683',
		char: '🚃'
	},
	{
		code: '1F684',
		char: '🚄'
	},
	{
		code: '1F685',
		char: '🚅'
	},
	{
		code: '1F686',
		char: '🚆'
	},
	{
		code: '1F687',
		char: '🚇'
	},
	{
		code: '1F688',
		char: '🚈'
	},
	{
		code: '1F689',
		char: '🚉'
	},
	{
		code: '1F68A',
		char: '🚊'
	},
	{
		code: '1F69D',
		char: '🚝'
	},
	{
		code: '1F69E',
		char: '🚞'
	},
	{
		code: '1F68B',
		char: '🚋'
	},
	{
		code: '1F68C',
		char: '🚌'
	},
	{
		code: '1F68D',
		char: '🚍'
	},
	{
		code: '1F68E',
		char: '🚎'
	},
	{
		code: '1F690',
		char: '🚐'
	},
	{
		code: '1F691',
		char: '🚑'
	},
	{
		code: '1F692',
		char: '🚒'
	},
	{
		code: '1F693',
		char: '🚓'
	},
	{
		code: '1F694',
		char: '🚔'
	},
	{
		code: '1F695',
		char: '🚕'
	},
	{
		code: '1F696',
		char: '🚖'
	},
	{
		code: '1F697',
		char: '🚗'
	},
	{
		code: '1F698',
		char: '🚘'
	},
	{
		code: '1F699',
		char: '🚙'
	},
	{
		code: '1F69A',
		char: '🚚'
	},
	{
		code: '1F69B',
		char: '🚛'
	},
	{
		code: '1F69C',
		char: '🚜'
	},
	{
		code: '1F6B2',
		char: '🚲'
	},
	{
		code: '1F6F4',
		char: '🛴'
	},
	{
		code: '1F6F5',
		char: '🛵'
	},
	{
		code: '1F3CE',
		char: '🏎'
	},
	{
		code: '1F3CD',
		char: '🏍'
	},
	{
		code: '1F68F',
		char: '🚏'
	},
	{
		code: '1F6E3',
		char: '🛣'
	},
	{
		code: '1F6E4',
		char: '🛤'
	},
	{
		code: '26FD',
		char: '⛽'
	},
	{
		code: '1F6A8',
		char: '🚨'
	},
	{
		code: '1F6A5',
		char: '🚥'
	},
	{
		code: '1F6A6',
		char: '🚦'
	},
	{
		code: '1F6A7',
		char: '🚧'
	},
	{
		code: '1F6D1',
		char: '🛑'
	},
	{
		code: '2693',
		char: '⚓'
	},
	{
		code: '26F5',
		char: '⛵'
	},
	{
		code: '1F6F6',
		char: '🛶'
	},
	{
		code: '1F6A4',
		char: '🚤'
	},
	{
		code: '1F6F3',
		char: '🛳'
	},
	{
		code: '26F4',
		char: '⛴'
	},
	{
		code: '1F6E5',
		char: '🛥'
	},
	{
		code: '1F6A2',
		char: '🚢'
	},
	{
		code: '2708',
		char: '✈'
	},
	{
		code: '1F6E9',
		char: '🛩'
	},
	{
		code: '1F6EB',
		char: '🛫'
	},
	{
		code: '1F6EC',
		char: '🛬'
	},
	{
		code: '1F4BA',
		char: '💺'
	},
	{
		code: '1F681',
		char: '🚁'
	},
	{
		code: '1F69F',
		char: '🚟'
	},
	{
		code: '1F6A0',
		char: '🚠'
	},
	{
		code: '1F6A1',
		char: '🚡'
	},
	{
		code: '1F680',
		char: '🚀'
	},
	{
		code: '1F6F0',
		char: '🛰'
	},
	{
		code: '1F6CE',
		char: '🛎'
	},
	{
		code: '1F6AA',
		char: '🚪'
	},
	{
		code: '1F6CC',
		char: '🛌'
	},
	{
		code: '1F6CF',
		char: '🛏'
	},
	{
		code: '1F6CB',
		char: '🛋'
	},
	{
		code: '1F6BD',
		char: '🚽'
	},
	{
		code: '1F6BF',
		char: '🚿'
	},
	{
		code: '1F6C0',
		char: '🛀'
	},
	{
		code: '1F6C1',
		char: '🛁'
	},
	{
		code: '231B',
		char: '⌛'
	},
	{
		code: '23F3',
		char: '⏳'
	},
	{
		code: '231A',
		char: '⌚'
	},
	{
		code: '23F0',
		char: '⏰'
	},
	{
		code: '23F1',
		char: '⏱'
	},
	{
		code: '23F2',
		char: '⏲'
	},
	{
		code: '1F570',
		char: '🕰'
	},
	{
		code: '1F55B',
		char: '🕛'
	},
	{
		code: '1F567',
		char: '🕧'
	},
	{
		code: '1F550',
		char: '🕐'
	},
	{
		code: '1F55C',
		char: '🕜'
	},
	{
		code: '1F551',
		char: '🕑'
	},
	{
		code: '1F55D',
		char: '🕝'
	},
	{
		code: '1F552',
		char: '🕒'
	},
	{
		code: '1F55E',
		char: '🕞'
	},
	{
		code: '1F553',
		char: '🕓'
	},
	{
		code: '1F55F',
		char: '🕟'
	},
	{
		code: '1F554',
		char: '🕔'
	},
	{
		code: '1F560',
		char: '🕠'
	},
	{
		code: '1F555',
		char: '🕕'
	},
	{
		code: '1F561',
		char: '🕡'
	},
	{
		code: '1F556',
		char: '🕖'
	},
	{
		code: '1F562',
		char: '🕢'
	},
	{
		code: '1F557',
		char: '🕗'
	},
	{
		code: '1F563',
		char: '🕣'
	},
	{
		code: '1F558',
		char: '🕘'
	},
	{
		code: '1F564',
		char: '🕤'
	},
	{
		code: '1F559',
		char: '🕙'
	},
	{
		code: '1F565',
		char: '🕥'
	},
	{
		code: '1F55A',
		char: '🕚'
	},
	{
		code: '1F566',
		char: '🕦'
	},
	{
		code: '1F311',
		char: '🌑'
	},
	{
		code: '1F312',
		char: '🌒'
	},
	{
		code: '1F313',
		char: '🌓'
	},
	{
		code: '1F314',
		char: '🌔'
	},
	{
		code: '1F315',
		char: '🌕'
	},
	{
		code: '1F316',
		char: '🌖'
	},
	{
		code: '1F317',
		char: '🌗'
	},
	{
		code: '1F318',
		char: '🌘'
	},
	{
		code: '1F319',
		char: '🌙'
	},
	{
		code: '1F31A',
		char: '🌚'
	},
	{
		code: '1F31B',
		char: '🌛'
	},
	{
		code: '1F31C',
		char: '🌜'
	},
	{
		code: '1F321',
		char: '🌡'
	},
	{
		code: '1F31D',
		char: '🌝'
	},
	{
		code: '1F31E',
		char: '🌞'
	},
	{
		code: '2B50',
		char: '⭐'
	},
	{
		code: '1F31F',
		char: '🌟'
	},
	{
		code: '1F320',
		char: '🌠'
	},
	{
		code: '26C5',
		char: '⛅'
	},
	{
		code: '26C8',
		char: '⛈'
	},
	{
		code: '1F324',
		char: '🌤'
	},
	{
		code: '1F325',
		char: '🌥'
	},
	{
		code: '1F326',
		char: '🌦'
	},
	{
		code: '1F327',
		char: '🌧'
	},
	{
		code: '1F328',
		char: '🌨'
	},
	{
		code: '1F329',
		char: '🌩'
	},
	{
		code: '1F32A',
		char: '🌪'
	},
	{
		code: '1F32B',
		char: '🌫'
	},
	{
		code: '1F32C',
		char: '🌬'
	},
	{
		code: '1F300',
		char: '🌀'
	},
	{
		code: '1F308',
		char: '🌈'
	},
	{
		code: '1F302',
		char: '🌂'
	},
	{
		code: '26F1',
		char: '⛱'
	},
	{
		code: '26C4',
		char: '⛄'
	},
	{
		code: '2604',
		char: '☄'
	},
	{
		code: '1F525',
		char: '🔥'
	},
	{
		code: '1F4A7',
		char: '💧'
	},
	{
		code: '1F30A',
		char: '🌊'
	},
	{
		code: '1F383',
		char: '🎃'
	},
	{
		code: '1F384',
		char: '🎄'
	},
	{
		code: '1F386',
		char: '🎆'
	},
	{
		code: '1F387',
		char: '🎇'
	},
	{
		code: '2728',
		char: '✨'
	},
	{
		code: '1F388',
		char: '🎈'
	},
	{
		code: '1F389',
		char: '🎉'
	},
	{
		code: '1F38A',
		char: '🎊'
	},
	{
		code: '1F38B',
		char: '🎋'
	},
	{
		code: '1F38D',
		char: '🎍'
	},
	{
		code: '1F38E',
		char: '🎎'
	},
	{
		code: '1F38F',
		char: '🎏'
	},
	{
		code: '1F390',
		char: '🎐'
	},
	{
		code: '1F391',
		char: '🎑'
	},
	{
		code: '1F380',
		char: '🎀'
	},
	{
		code: '1F381',
		char: '🎁'
	},
	{
		code: '1F397',
		char: '🎗'
	},
	{
		code: '1F39F',
		char: '🎟'
	},
	{
		code: '1F3AB',
		char: '🎫'
	},
	{
		code: '1F396',
		char: '🎖'
	},
	{
		code: '1F3C6',
		char: '🏆'
	},
	{
		code: '1F3C5',
		char: '🏅'
	},
	{
		code: '1F947',
		char: '🥇'
	},
	{
		code: '1F948',
		char: '🥈'
	},
	{
		code: '1F949',
		char: '🥉'
	},
	{
		code: '26BD',
		char: '⚽'
	},
	{
		code: '26BE',
		char: '⚾'
	},
	{
		code: '1F3C0',
		char: '🏀'
	},
	{
		code: '1F3D0',
		char: '🏐'
	},
	{
		code: '1F3C8',
		char: '🏈'
	},
	{
		code: '1F3C9',
		char: '🏉'
	},
	{
		code: '1F3BE',
		char: '🎾'
	},
	{
		code: '1F3B1',
		char: '🎱'
	},
	{
		code: '1F3B3',
		char: '🎳'
	},
	{
		code: '1F3CF',
		char: '🏏'
	},
	{
		code: '1F3D1',
		char: '🏑'
	},
	{
		code: '1F3D2',
		char: '🏒'
	},
	{
		code: '1F3D3',
		char: '🏓'
	},
	{
		code: '1F3F8',
		char: '🏸'
	},
	{
		code: '1F94A',
		char: '🥊'
	},
	{
		code: '1F94B',
		char: '🥋'
	},
	{
		code: '1F945',
		char: '🥅'
	},
	{
		code: '1F3AF',
		char: '🎯'
	},
	{
		code: '26F3',
		char: '⛳'
	},
	{
		code: '26F8',
		char: '⛸'
	},
	{
		code: '1F3A3',
		char: '🎣'
	},
	{
		code: '1F3BD',
		char: '🎽'
	},
	{
		code: '1F3BF',
		char: '🎿'
	},
	{
		code: '1F93A',
		char: '🤺'
	},
	{
		code: '1F3C7',
		char: '🏇'
	},
	{
		code: '26F7',
		char: '⛷'
	},
	{
		code: '1F3C2',
		char: '🏂'
	},
	{
		code: '1F3CC',
		char: '🏌'
	},
	{
		code: '1F3C4',
		char: '🏄'
	},
	{
		code: '1F6A3',
		char: '🚣'
	},
	{
		code: '1F3CA',
		char: '🏊'
	},
	{
		code: '26F9',
		char: '⛹'
	},
	{
		code: '1F3CB',
		char: '🏋'
	},
	{
		code: '1F6B4',
		char: '🚴'
	},
	{
		code: '1F6B5',
		char: '🚵'
	},
	{
		code: '1F938',
		char: '🤸'
	},
	{
		code: '1F93C',
		char: '🤼'
	},
	{
		code: '1F93D',
		char: '🤽'
	},
	{
		code: '1F93E',
		char: '🤾'
	},
	{
		code: '1F939',
		char: '🤹'
	},
	{
		code: '1F3AE',
		char: '🎮'
	},
	{
		code: '1F579',
		char: '🕹'
	},
	{
		code: '1F3B2',
		char: '🎲'
	},
	{
		code: '1F0CF',
		char: '🃏'
	},
	{
		code: '1F004',
		char: '🀄'
	},
	{
		code: '1F3B4',
		char: '🎴'
	},
	{
		code: '1F507',
		char: '🔇'
	},
	{
		code: '1F508',
		char: '🔈'
	},
	{
		code: '1F509',
		char: '🔉'
	},
	{
		code: '1F50A',
		char: '🔊'
	},
	{
		code: '1F4E2',
		char: '📢'
	},
	{
		code: '1F4E3',
		char: '📣'
	},
	{
		code: '1F4EF',
		char: '📯'
	},
	{
		code: '1F514',
		char: '🔔'
	},
	{
		code: '1F515',
		char: '🔕'
	},
	{
		code: '1F3BC',
		char: '🎼'
	},
	{
		code: '1F3B5',
		char: '🎵'
	},
	{
		code: '1F3B6',
		char: '🎶'
	},
	{
		code: '1F399',
		char: '🎙'
	},
	{
		code: '1F39A',
		char: '🎚'
	},
	{
		code: '1F39B',
		char: '🎛'
	},
	{
		code: '1F3A4',
		char: '🎤'
	},
	{
		code: '1F3A7',
		char: '🎧'
	},
	{
		code: '1F4FB',
		char: '📻'
	},
	{
		code: '1F3B7',
		char: '🎷'
	},
	{
		code: '1F3B8',
		char: '🎸'
	},
	{
		code: '1F3B9',
		char: '🎹'
	},
	{
		code: '1F3BA',
		char: '🎺'
	},
	{
		code: '1F3BB',
		char: '🎻'
	},
	{
		code: '1F941',
		char: '🥁'
	},
	{
		code: '1F4F1',
		char: '📱'
	},
	{
		code: '1F4F2',
		char: '📲'
	},
	{
		code: '1F4DE',
		char: '📞'
	},
	{
		code: '1F4DF',
		char: '📟'
	},
	{
		code: '1F4E0',
		char: '📠'
	},
	{
		code: '1F50B',
		char: '🔋'
	},
	{
		code: '1F50C',
		char: '🔌'
	},
	{
		code: '1F4BB',
		char: '💻'
	},
	{
		code: '1F5A5',
		char: '🖥'
	},
	{
		code: '1F5A8',
		char: '🖨'
	},
	{
		code: '1F5B1',
		char: '🖱'
	},
	{
		code: '1F5B2',
		char: '🖲'
	},
	{
		code: '1F4BD',
		char: '💽'
	},
	{
		code: '1F4BE',
		char: '💾'
	},
	{
		code: '1F4BF',
		char: '💿'
	},
	{
		code: '1F4C0',
		char: '📀'
	},
	{
		code: '1F3A5',
		char: '🎥'
	},
	{
		code: '1F39E',
		char: '🎞'
	},
	{
		code: '1F4FD',
		char: '📽'
	},
	{
		code: '1F3AC',
		char: '🎬'
	},
	{
		code: '1F4FA',
		char: '📺'
	},
	{
		code: '1F4F7',
		char: '📷'
	},
	{
		code: '1F4F8',
		char: '📸'
	},
	{
		code: '1F4F9',
		char: '📹'
	},
	{
		code: '1F4FC',
		char: '📼'
	},
	{
		code: '1F50D',
		char: '🔍'
	},
	{
		code: '1F50E',
		char: '🔎'
	},
	{
		code: '1F52C',
		char: '🔬'
	},
	{
		code: '1F52D',
		char: '🔭'
	},
	{
		code: '1F4E1',
		char: '📡'
	},
	{
		code: '1F56F',
		char: '🕯'
	},
	{
		code: '1F4A1',
		char: '💡'
	},
	{
		code: '1F526',
		char: '🔦'
	},
	{
		code: '1F3EE',
		char: '🏮'
	},
	{
		code: '1F4D4',
		char: '📔'
	},
	{
		code: '1F4D5',
		char: '📕'
	},
	{
		code: '1F4D6',
		char: '📖'
	},
	{
		code: '1F4D7',
		char: '📗'
	},
	{
		code: '1F4D8',
		char: '📘'
	},
	{
		code: '1F4D9',
		char: '📙'
	},
	{
		code: '1F4DA',
		char: '📚'
	},
	{
		code: '1F4D3',
		char: '📓'
	},
	{
		code: '1F4D2',
		char: '📒'
	},
	{
		code: '1F4C3',
		char: '📃'
	},
	{
		code: '1F4DC',
		char: '📜'
	},
	{
		code: '1F4C4',
		char: '📄'
	},
	{
		code: '1F4F0',
		char: '📰'
	},
	{
		code: '1F5DE',
		char: '🗞'
	},
	{
		code: '1F4D1',
		char: '📑'
	},
	{
		code: '1F516',
		char: '🔖'
	},
	{
		code: '1F3F7',
		char: '🏷'
	},
	{
		code: '1F4B0',
		char: '💰'
	},
	{
		code: '1F4B4',
		char: '💴'
	},
	{
		code: '1F4B5',
		char: '💵'
	},
	{
		code: '1F4B6',
		char: '💶'
	},
	{
		code: '1F4B7',
		char: '💷'
	},
	{
		code: '1F4B8',
		char: '💸'
	},
	{
		code: '1F4B3',
		char: '💳'
	},
	{
		code: '1F4B9',
		char: '💹'
	},
	{
		code: '1F4B1',
		char: '💱'
	},
	{
		code: '1F4B2',
		char: '💲'
	},
	{
		code: '1F4E7',
		char: '📧'
	},
	{
		code: '1F4E8',
		char: '📨'
	},
	{
		code: '1F4E9',
		char: '📩'
	},
	{
		code: '1F4E4',
		char: '📤'
	},
	{
		code: '1F4E5',
		char: '📥'
	},
	{
		code: '1F4E6',
		char: '📦'
	},
	{
		code: '1F4EB',
		char: '📫'
	},
	{
		code: '1F4EA',
		char: '📪'
	},
	{
		code: '1F4EC',
		char: '📬'
	},
	{
		code: '1F4ED',
		char: '📭'
	},
	{
		code: '1F4EE',
		char: '📮'
	},
	{
		code: '1F5F3',
		char: '🗳'
	},
	{
		code: '1F58B',
		char: '🖋'
	},
	{
		code: '1F58A',
		char: '🖊'
	},
	{
		code: '1F58C',
		char: '🖌'
	},
	{
		code: '1F58D',
		char: '🖍'
	},
	{
		code: '1F4DD',
		char: '📝'
	},
	{
		code: '1F4BC',
		char: '💼'
	},
	{
		code: '1F4C1',
		char: '📁'
	},
	{
		code: '1F4C2',
		char: '📂'
	},
	{
		code: '1F5C2',
		char: '🗂'
	},
	{
		code: '1F4C5',
		char: '📅'
	},
	{
		code: '1F4C6',
		char: '📆'
	},
	{
		code: '1F5D2',
		char: '🗒'
	},
	{
		code: '1F5D3',
		char: '🗓'
	},
	{
		code: '1F4C7',
		char: '📇'
	},
	{
		code: '1F4C8',
		char: '📈'
	},
	{
		code: '1F4C9',
		char: '📉'
	},
	{
		code: '1F4CA',
		char: '📊'
	},
	{
		code: '1F4CB',
		char: '📋'
	},
	{
		code: '1F4CC',
		char: '📌'
	},
	{
		code: '1F4CD',
		char: '📍'
	},
	{
		code: '1F4CE',
		char: '📎'
	},
	{
		code: '1F587',
		char: '🖇'
	},
	{
		code: '1F4CF',
		char: '📏'
	},
	{
		code: '1F4D0',
		char: '📐'
	},
	{
		code: '1F5C3',
		char: '🗃'
	},
	{
		code: '1F5C4',
		char: '🗄'
	},
	{
		code: '1F5D1',
		char: '🗑'
	},
	{
		code: '1F512',
		char: '🔒'
	},
	{
		code: '1F513',
		char: '🔓'
	},
	{
		code: '1F50F',
		char: '🔏'
	},
	{
		code: '1F510',
		char: '🔐'
	},
	{
		code: '1F511',
		char: '🔑'
	},
	{
		code: '1F5DD',
		char: '🗝'
	},
	{
		code: '1F528',
		char: '🔨'
	},
	{
		code: '26CF',
		char: '⛏'
	},
	{
		code: '1F6E0',
		char: '🛠'
	},
	{
		code: '1F5E1',
		char: '🗡'
	},
	{
		code: '1F3F9',
		char: '🏹'
	},
	{
		code: '1F6E1',
		char: '🛡'
	},
	{
		code: '1F527',
		char: '🔧'
	},
	{
		code: '1F529',
		char: '🔩'
	},
	{
		code: '1F5DC',
		char: '🗜'
	},
	{
		code: '1F517',
		char: '🔗'
	},
	{
		code: '26D3',
		char: '⛓'
	},
	{
		code: '1F5FF',
		char: '🗿'
	},
	{
		code: '1F6E2',
		char: '🛢'
	},
	{
		code: '1F52E',
		char: '🔮'
	},
	{
		code: '1F6D2',
		char: '🛒'
	},
	{
		code: '1F3E7',
		char: '🏧'
	},
	{
		code: '1F6AE',
		char: '🚮'
	},
	{
		code: '1F6B0',
		char: '🚰'
	},
	{
		code: '1F6B9',
		char: '🚹'
	},
	{
		code: '1F6BA',
		char: '🚺'
	},
	{
		code: '1F6BB',
		char: '🚻'
	},
	{
		code: '1F6BC',
		char: '🚼'
	},
	{
		code: '1F6BE',
		char: '🚾'
	},
	{
		code: '1F6C2',
		char: '🛂'
	},
	{
		code: '1F6C3',
		char: '🛃'
	},
	{
		code: '1F6C4',
		char: '🛄'
	},
	{
		code: '1F6C5',
		char: '🛅'
	},
	{
		code: '1F6B8',
		char: '🚸'
	},
	{
		code: '26D4',
		char: '⛔'
	},
	{
		code: '1F6AB',
		char: '🚫'
	},
	{
		code: '1F6B3',
		char: '🚳'
	},
	{
		code: '1F6AD',
		char: '🚭'
	},
	{
		code: '1F6AF',
		char: '🚯'
	},
	{
		code: '1F6B1',
		char: '🚱'
	},
	{
		code: '1F6B7',
		char: '🚷'
	},
	{
		code: '1F4F5',
		char: '📵'
	},
	{
		code: '1F51E',
		char: '🔞'
	},
	{
		code: '1F503',
		char: '🔃'
	},
	{
		code: '1F504',
		char: '🔄'
	},
	{
		code: '1F519',
		char: '🔙'
	},
	{
		code: '1F51A',
		char: '🔚'
	},
	{
		code: '1F51B',
		char: '🔛'
	},
	{
		code: '1F51C',
		char: '🔜'
	},
	{
		code: '1F51D',
		char: '🔝'
	},
	{
		code: '1F6D0',
		char: '🛐'
	},
	{
		code: '269B',
		char: '⚛'
	},
	{
		code: '1F549',
		char: '🕉'
	},
	{
		code: '1F54E',
		char: '🕎'
	},
	{
		code: '1F52F',
		char: '🔯'
	},
	{
		code: '1F4DB',
		char: '📛'
	},
	{
		code: '1F530',
		char: '🔰'
	},
	{
		code: '1F531',
		char: '🔱'
	},
	{
		code: '2B55',
		char: '⭕'
	},
	{
		code: '2705',
		char: '✅'
	},
	{
		code: '274C',
		char: '❌'
	},
	{
		code: '274E',
		char: '❎'
	},
	{
		code: '2795',
		char: '➕'
	},
	{
		code: '2796',
		char: '➖'
	},
	{
		code: '2797',
		char: '➗'
	},
	{
		code: '27B0',
		char: '➰'
	},
	{
		code: '27BF',
		char: '➿'
	},
	{
		code: '2753',
		char: '❓'
	},
	{
		code: '2754',
		char: '❔'
	},
	{
		code: '2755',
		char: '❕'
	},
	{
		code: '2757',
		char: '❗'
	},
	{
		code: '26CE',
		char: '⛎'
	},
	{
		code: '1F500',
		char: '🔀'
	},
	{
		code: '1F501',
		char: '🔁'
	},
	{
		code: '1F502',
		char: '🔂'
	},
	{
		code: '23E9',
		char: '⏩'
	},
	{
		code: '23ED',
		char: '⏭'
	},
	{
		code: '23EF',
		char: '⏯'
	},
	{
		code: '23EA',
		char: '⏪'
	},
	{
		code: '23EE',
		char: '⏮'
	},
	{
		code: '1F53C',
		char: '🔼'
	},
	{
		code: '23EB',
		char: '⏫'
	},
	{
		code: '1F53D',
		char: '🔽'
	},
	{
		code: '23EC',
		char: '⏬'
	},
	{
		code: '23F8',
		char: '⏸'
	},
	{
		code: '23F9',
		char: '⏹'
	},
	{
		code: '23FA',
		char: '⏺'
	},
	{
		code: '1F3A6',
		char: '🎦'
	},
	{
		code: '1F505',
		char: '🔅'
	},
	{
		code: '1F506',
		char: '🔆'
	},
	{
		code: '1F4F6',
		char: '📶'
	},
	{
		code: '1F4F3',
		char: '📳'
	},
	{
		code: '1F4F4',
		char: '📴'
	},
	{
		code: '1F51F',
		char: '🔟'
	},
	{
		code: '1F4AF',
		char: '💯'
	},
	{
		code: '1F520',
		char: '🔠'
	},
	{
		code: '1F521',
		char: '🔡'
	},
	{
		code: '1F522',
		char: '🔢'
	},
	{
		code: '1F523',
		char: '🔣'
	},
	{
		code: '1F524',
		char: '🔤'
	},
	{
		code: '1F18E',
		char: '🆎'
	},
	{
		code: '1F191',
		char: '🆑'
	},
	{
		code: '1F192',
		char: '🆒'
	},
	{
		code: '1F193',
		char: '🆓'
	},
	{
		code: '1F194',
		char: '🆔'
	},
	{
		code: '1F195',
		char: '🆕'
	},
	{
		code: '1F196',
		char: '🆖'
	},
	{
		code: '1F197',
		char: '🆗'
	},
	{
		code: '1F198',
		char: '🆘'
	},
	{
		code: '1F199',
		char: '🆙'
	},
	{
		code: '1F19A',
		char: '🆚'
	},
	{
		code: '1F201',
		char: '🈁'
	},
	{
		code: '1F236',
		char: '🈶'
	},
	{
		code: '1F22F',
		char: '🈯'
	},
	{
		code: '1F250',
		char: '🉐'
	},
	{
		code: '1F239',
		char: '🈹'
	},
	{
		code: '1F21A',
		char: '🈚'
	},
	{
		code: '1F232',
		char: '🈲'
	},
	{
		code: '1F251',
		char: '🉑'
	},
	{
		code: '1F238',
		char: '🈸'
	},
	{
		code: '1F234',
		char: '🈴'
	},
	{
		code: '1F233',
		char: '🈳'
	},
	{
		code: '1F23A',
		char: '🈺'
	},
	{
		code: '1F235',
		char: '🈵'
	},
	{
		code: '2B1B',
		char: '⬛'
	},
	{
		code: '2B1C',
		char: '⬜'
	},
	{
		code: '1F536',
		char: '🔶'
	},
	{
		code: '1F537',
		char: '🔷'
	},
	{
		code: '1F538',
		char: '🔸'
	},
	{
		code: '1F539',
		char: '🔹'
	},
	{
		code: '1F53A',
		char: '🔺'
	},
	{
		code: '1F53B',
		char: '🔻'
	},
	{
		code: '1F4A0',
		char: '💠'
	},
	{
		code: '26AA',
		char: '⚪'
	},
	{
		code: '26AB',
		char: '⚫'
	},
	{
		code: '1F534',
		char: '🔴'
	},
	{
		code: '1F535',
		char: '🔵'
	},
	{
		code: '1F3C1',
		char: '🏁'
	},
	{
		code: '1F6A9',
		char: '🚩'
	},
	{
		code: '1F3F4',
		char: '🏴'
	},
	{
		code: '1F3F3',
		char: '🏳'
	},
]);

'use strict';

angular.module('paycircleApp')

.constant('EMPLOYEE_PORTAL_PERMISSIONS_FLAGS', {
	personalInformation: 	1 << 0,
	addresses: 				1 << 1,
	bankDetails: 			1 << 2,
	pensionStatus: 			1 << 3,	// This setting is redundant. See https://www.notion.so/paycircle/Employee-Portal-Control-ability-to-edit-information-903f98c768c0446db0dd00bff0ba7b25
	employeeOptInOut: 		1 << 4,
	manageContributions: 	1 << 5,
	holidayAndSickness: 	1 << 6,
	gender: 				1 << 7,
})

.constant('EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS', {
	profile: 				'profile',
	documents: 				'documents',
	pensions:				'pensions',
	holidayAndSickness:		'holidayAndSickness'
});

'use strict';

angular.module('paycircleApp')
.constant('EMPLOYMENT_CALCULATION_TYPES', {
	workPattern: 0,
	annualSalary: 1
});

'use strict';

angular.module('paycircleApp')
.constant('EMPLOYMENT_PAYMENT_TYPES', {
	annualSalary: 0,
	rate: 1
});

'use strict';

angular.module('paycircleApp')
.constant('EMPLOYMENT_PAYROLL_TYPES', {
	paye: 0,
	offPayroll: 1
});
'use strict';

angular.module('paycircleApp')
.constant('EMPLOYMENT_RATE_TYPES', {
	hourly: 0,
	daily: 1
});

'use strict';

angular.module('paycircleApp')
.constant('EMPLOYMENT_TYPES', {
	standard: 0,
	nonStandard: 1,
	netPay: 2,
	paidHourly: 3,
	payPolicy: 4
});

'use strict';

angular.module('paycircleApp')
.constant('EVO_MESSAGE_TYPES', {
    RequestReauthentication: 'RequestReauthentication',
    LocationChanged: 'LocationChanged'
});

'use strict';

angular.module('paycircleApp')
.constant('FEATURE_FLAGS', {
	ACCESS_FINANCIALS_INTEGRATION: 'ACCESS_FINANCIALS_INTEGRATION',
	ADMIN_LINKING: 'ADMIN_LINKING',
	AVERAGE_HOLIDAY_PAY: 'AVERAGE_HOLIDAY_PAY',
	COOKIE_POLICY: 'COOKIE_POLICY',
	EVO_FEED: 'EVO_FEED',
	EVO_NATIVE: 'EVO_NATIVE',
	GROUP_CREATION_ENABLED: 'GROUP_CREATION_ENABLED',
	IMPORT_ABSENCES_SICKNESS: 'IMPORT_ABSENCES_SICKNESS',
	ROTAREADY_GROUPED_UPDATES: 'ROTAREADY_GROUPED_UPDATES',
	ROTAREADY_INTEGRATION: 'ROTAREADY_INTEGRATION',
	ROTAREADY_REALM_SEGMENTATION: 'ROTAREADY_REALM_SEGMENTATION',
	SMART_VIEW: 'SMART_VIEW'
});

'use strict';

angular.module('paycircleApp')
.constant('FILTER_KEYS', {
	admins: {
		account: {
			isRegistered: 'admins-account-is-registered',
			notRegistered: 'admins-account-not-registered'
		},
		payroll: {
			excludedFromPayroll: 'admins-payroll-excluded-from-payroll',
			includedInPayroll: 'admins-payroll-included-in-payroll'
		}
	},
	apiReferences: {
		library: 'api-references-library',
		project: 'api-references-project',
		referenceCount: 'api-references-reference-count'
	},
	archivedTeamMembers: {
		date: {
			oneMonth: 'archived-team-members-date-one-month',
			threeMonths: 'archived-team-members-date-three-months',
			sixMonths: 'archived-team-members-date-six-months',
			twelveMonths: 'archived-team-members-date-twelve-months'
		}
	},
	averageHolidayPay: {
		rateType: {
			hourly: 'average-holiday-pay-rate-type-hourly',
			daily: 'average-holiday-pay-rate-type-daily',
			other: 'average-holiday-pay-rate-type-other'
		},
		inclusion: {
			included: 'average-holiday-pay-inclusion-included',
			excluded: 'average-holiday-pay-inclusion-excluded'
		}
	},
	companyPayElementOverrides: {
		element: 'company-pay-element-overrides-element'
	},
	bacsDownloads: {
		date: {
			oneWeek: 'bacs-downloads-date-one-week',
			twoWeeks: 'bacs-downloads-date-two-weeks',
			oneMonth: 'bacs-downloads-date-one-month',
			threeMonths: 'bacs-downloads-date-three-months',
			sixMonths: 'bacs-downloads-date-six-months',
			specificDate: 'bacs-downloads-date-specific-date'
		},
		fileType: {
			payPeriod: 'bacs-downloads-file-type-pay-period',
			disbursement: 'bacs-downloads-file-type-disbursement',
			supplementaryPayment: 'bacs-downloads-file-type-supplementary-payment'
		}
	},
	billing: {
		status: {
			paid: 'billing-status-paid',
			failed: 'billing-status-failed',
			refunded: 'billing-status-refunded',
			cancelled: 'billing-status-cancelled'
		}
	},
	bureauWorkflowTasks: {
		payFrequency: {
			weekly: 'workflow-tasks-pay-frequency-weekly',
			fortnightly: 'workflow-tasks-pay-frequency-fortnightly',
			fourWeekly: 'workflow-tasks-pay-frequency-four-weekly',
			monthly: 'workflow-tasks-pay-frequency-monthly',
			quarterly: 'workflow-tasks-pay-frequency-quarterly',
			annually: 'workflow-tasks-pay-frequency-annually'
		},
		status: {
			isOverdue: 'workflow-tasks-status-overdue',
			isDueToday: 'workflow-tasks-status-due-today',
			isDueWithinTwoDays: 'workflow-tasks-status-due-within-two-days',
			isDueWithinThreeDays: 'workflow-tasks-status-due-within-three-days',
			isQueried: 'workflow-tasks-status-queried',
			isDraft: 'workflow-tasks-status-draft',
			isPayrollFailed: 'workflow-tasks-status-payroll-failed'
		},
		step: {
			payrollInformation: 'workflow-tasks-step-payroll-information',
			payrollCalculation: 'workflow-tasks-step-payroll-calculation',
			payrollConfirmation: 'workflow-tasks-step-payroll-confirmation',
			runPayroll: 'workflow-tasks-step-run-payroll'
		},
		teamMember: {
			assignee: 'workflow-tasks-team-member-assignee',
			client: 'workflow-tasks-team-member-client'
		}
	},
	currentPeriod: {
		status: {
			hasChanges: 'current-period-status-has-changes',
			incomplete: 'current-period-status-incomplete',
			noChanges: 'current-period-status-no-changes',
			hasSalaryChange: 'current-period-status-has-salary-change',
			payslipNoteAdded: 'current-period-status-payslip-note-added',
			noPayslipNote: 'current-period-status-no-payslip-note',
			rejoiner: 'current-period-status-rejoiner',
			advancing: 'current-period-status-advancing',
			isExcludedFromRti: 'current-period-status-excluded-from-rti'
		},
		salary: {
			paidSalary: 'current-period-salary-paid-salary',
			paidHourly: 'current-period-salary-paid-hourly',
			paidNet: 'current-period-salary-paid-net',
			offPayroll: 'current-period-salary-off-payroll'
		},
		pension: {
			pensionEnrolled: 'current-period-pension-enrolled',
			pensionWillBeEnrolled: 'current-period-pension-will-be-enrolled',
			pensionReassessment: 'current-period-pension-reassessment',
			pensionJoined: 'current-period-pension-joined',
			pensionCanJoin: 'current-period-pension-can-join',
			pensionCanOptIn: 'current-period-pension-can-opt-in',
			pensionPostponed: 'current-period-pension-postponed',
			pensionOptedIn: 'current-period-pension-opted-in',
			pensionOptedOut: 'current-period-pension-opted-out'
		}
	},
	currentPeriodImports: {
		importState: {
			imported: 'current-period-imports-import-state-imported',
			undone: 'current-period-imports-import-state-undone'
		},
		importType: {
			changes: 'current-period-imports-import-type-changes',
			timesheets: 'current-period-imports-import-type-timesheets',
			payElements: 'current-period-imports-import-type-pay-elements',
			payElementsRecurring: 'current-period-imports-import-type-pay-elements-recurring',
			payElementsFixed: 'current-period-imports-import-type-pay-elements-fixed',
			payElementsRatedUnitsVertical: 'current-period-imports-import-type-pay-elements-rated-units-vertical',
			payElementsRatedUnitsHorizontal: 'current-period-imports-import-type-pay-elements-rated-units-horizontal',
			payElementsHourlyRate: 'current-period-imports-import-type-pay-elements-hourly-rate',
			payElementsDailyRate: 'current-period-imports-import-type-pay-elements-daily-rate',
			payElementsFixedCIS: 'current-period-imports-import-type-pay-elements-fixed-cis',
			payElementsFixedCISHorizontal: 'current-period-imports-import-type-pay-elements-fixed-cis-horizontal',
			payElementsOffPayroll: 'current-period-imports-import-type-pay-elements-off-payroll',
			payElementsOffPayrollHorizontal: 'current-period-imports-import-type-pay-elements-off-payroll-horizontal',
			payElementsOffPayrollRecurring: 'current-period-imports-import-type-pay-elements-off-payroll-recurring',
			payElementsOffPayrollRecurringHorizontal: 'current-period-imports-import-type-pay-elements-off-payroll-recurring-horizontal'
		}
	},
	customerCodes: {
		codeAdded: {
			codeAdded: 'customer-code-is-added',
			codeNotAdded: 'customer-code-not-added'
		}
	},
	currentPeriodTaxUpdates: {
		updateType: {
			automatic: 'current-period-tax-updates-update-type-automatic',
			manual: 'current-period-tax-updates-update-type-manual'
		}
	},
	companies: {
		autoRun: {
			on: 'companies-auto-run-on',
			off: 'companies-auto-run-off'
		},
		bacs: {
			on: 'companies-bacs-on',
			off: 'companies-bacs-off',
		},
		mode: {
			live: 'companies-mode-live',
			test: 'companies-mode-test',
			setup: 'companies-mode-setup'
		},
		modules: {
			cis: 'companies-modules-cis',
			hr: 'companies-modules-hr',
			payroll: 'companies-modules-payroll',
			pension: 'companies-modules-pension',
			workflow: 'companies-modules-workflow',
			payslipOnly: 'companies-modules-payslip-only',
			expats: 'companies-modules-expats',
			offPayroll: 'companies-modules-off-payroll',
			genderPayGapReport: 'companies-modules-gender-pay-gap-report',
		},
		payPeriods: {
			hourly: 'companies-pay-periods-hourly',
			daily: 'companies-pay-periods-daily',
			weekly: 'companies-pay-periods-weekly',
			fortnightly: 'companies-pay-periods-two-weekly',
			fourweekly: 'companies-pay-periods-four-weekly',
			monthly: 'companies-pay-periods-monthly',
			quarterly: 'companies-pay-periods-quarterly',
			annually: 'companies-pay-periods-annually',
			biannually: 'companies-pay-periods-biannually'
		},
		payroll: {
			dueSoon: 'companies-payroll-due-soon',
			failed: 'companies-payroll-failed',
			firstLivePeriod: 'companies-payroll-first-live-period',
			open: 'companies-payroll-open',
			overdue: 'companies-payroll-overdue',
			ready: 'companies-payroll-ready',
			waitingForApproval: 'companies-waiting-for-approval',
			ceased: 'companies-waiting-ceased'
		},
		pension: {
			docSubmissionDue: 'companies-pension-doc-submission-due',
			submissionFailed: 'companies-pension-submission-failed',
			unauthorised: 'companies-pension-unauthorised',
			submissionPending: 'companies-pension-submission-pending'
		},
		setup: {
			hasRunPayroll: 'companies-setup-has-run-payroll',
			hasNotRunPayroll: 'companies-setup-has-not-run-payroll'
		},
		team: {
			activeOnPayroll: 'companies-team-active-on-payroll',
			readyForPayroll: 'companies-team-ready-for-payroll',
			newStarter: 'companies-team-new-starter',
			incomplete: 'companies-team-incomplete',
			leaver: 'companies-team-leaver',
			cis: 'companies-team-cis'
		},
		workflow: {
			payrollInformation: 'companies-workflow-payroll-information',
			calculation: 'companies-workflow-calculation',
			confirmation: 'companies-workflow-confirmation',
			runPayroll: 'companies-workflow-run-payroll',
			overdue: 'companies-workflow-overdue',
			dueToday: 'companies-workflow-due-today',
			dueInTwoDays: 'companies-workflow-due-in-two-days',
			dueInThreeDays: 'companies-workflow-due-in-three-days',
			draft: 'companies-workflow-draft'
		}
	},
	bureausArchived: {
		date: {
			oneMonth: 'bureaus-archived-date-one-month',
			threeMonths: 'bureaus-archived-date-three-months',
			sixMonths: 'bureaus-archived-date-six-months',
			twelveMonths: 'bureaus-archived-date-twelve-months'
		}
	},
	companiesArchived: {
		date: {
			oneMonth: 'companies-archived-date-one-month',
			threeMonths: 'companies-archived-date-three-months',
			sixMonths: 'companies-archived-date-six-months',
			twelveMonths: 'companies-archived-date-twelve-months'
		},
		reason: {
			companyClosing: 'companies-archived-reason-company-closing',
			companySoldOrMerged: 'companies-archived-reason-moved-payroll',
			movedServiceProvider: 'companies-archived-reason-moved-service-provider',
			other: 'companies-archived-reason-other'
		}
	},
	dataImporterValidate: {
		validationState: {
			invalid: 'data-importer-invalid',
			all: 'data-importer-all'
		}
	},
	documents: {
		fileType: {
			fps: 'documents-file-type-fps',
			csv: 'documents-file-type-csv',
			pdf: 'documents-file-type-pdf',
			docx: 'documents-file-type-docx',
			xlsx: 'documents-file-type-xlsx',
			other: 'documents-file-type-other',
		},
		status: {
			validated: 'documents-status-validated',
			notValidated: 'documents-status-not-validated'
		}
	},
	futureChanges: {
		period: {
			threeMonths: 'future-changes-period-three-months',
			sixMonths: 'future-changes-period-six-months',
			oneYear: 'future-changes-period-one-year'
		},
		types: {
			additions: 'future-changes-types-additions',
			deductions: 'future-changes-types-deductions'
		}
	},
	genderPayGapOverrides: {
		employeeType: {
			relevant: 'gender-pay-gap-overrides-employee-type-relevant',
			fullPayRelevant: 'gender-pay-gap-overrides-employee-type-full-pay-relevant',
		},
		payAndHours: {
			zeroOrdinaryPay: 'gender-pay-gap-overrides-pay-and-hours-zero-ordinary-pay',
			zeroBonusPayPeriod: 'gender-pay-gap-overrides-pay-and-hours-zero-bonus-pay-period',
			zeroBonusPayYear: 'gender-pay-gap-overrides-pay-and-hours-zero-bonus-pay-year',
			zeroWeeklyHours: 'gender-pay-gap-overrides-pay-and-hours-zero-weekly-hours'
		}
	},
	history: {
		types: {
			manual: 'history-types-manual',
			autoRun: 'history-types-auto-run',
			compulsory: 'history-types-compulsory',
			testRun: 'history-types-test-run',
			historic: 'history-types-historic'
		}
	},
	importMappings: {
		payroll: {
			users: 'import-mapping-payroll-users',
			payElementsRecurring: 'import-mapping-payroll-pay-elements-recurring',
			payElementsFixed: 'import-mapping-payroll-pay-elements-fixed',
			payElementsRatedUnitsVertical: 'import-mapping-payroll-pay-elements-rated-units-vertical',
			payElementsRatedUnitsHorizontal: 'import-mapping-payroll-pay-elements-rated-units-horizontal',
			payElementsHourlyRate: 'import-mapping-payroll-pay-elements-hourly-rate',
			payElementsDailyRate: 'import-mapping-payroll-pay-elements-daily-rate',
			payElementsFixedCIS: 'import-mapping-payroll-pay-elements-fixed-cis',
			payElementsFixedCISHorizontal: 'import-mapping-payroll-pay-elements-fixed-cis-horizontal',
			payElementsOffPayroll: 'import-mapping-payroll-pay-elements-off-payroll',
			payElementsOffPayrollHorizontal: 'import-mapping-payroll-pay-elements-off-payroll-horizontal',
			payElementsOffPayrollRecurring: 'import-mapping-payroll-pay-elements-off-payroll-recurring',
			payElementsOffPayrollRecurringHorizontal: 'import-mapping-payroll-pay-elements-off-payroll-recurring-horizontal'
		},
		team: {
			team: 'import-mapping-team-team',
			fps: 'import-mapping-team-fps',
			profile: 'import-mapping-team-profile',
			address: 'import-mapping-team-address',
			ytd: 'import-mapping-team-ytd',
			company: 'import-mapping-team-company',
			bank: 'import-mapping-team-bank',
			tax: 'import-mapping-team-tax',
			salary: 'import-mapping-team-salary',
			pension: 'import-mapping-team-pension',
			cis: 'import-mapping-team-cis',
			expats: 'import-mapping-team-expats',
			all: 'import-mapping-team-all',
		},
		managed: {
			bureau: 'import-mapping-managed-bureau',
			company: 'import-mapping-managed-company'
		}
	},
	journals: {
		importType: {
			nominalCodes: 'import-journals-nominal-codes',
			businessCategories: 'import-journals-business-categories',
		},
		importState: {
			imported: 'import-journals-import-state-imported',
			undone: 'import-journals-import-state-undone',
		}
	},
	leavers: {
		date: {
			oneMonth: 'leavers-date-one-month',
			threeMonths: 'leavers-date-three-months',
			sixMonths: 'leavers-date-six-months',
			twelveMonths: 'leavers-date-twelve-months'
		}
	},
	linkElements: {
		changeType: {
			addition: 'link-element-change-type-addition',
			deduction: 'link-element-change-type-deduction'
		}
	},
	linkRates: {
		changeType: {
			addition: 'link-rate-change-type-addition',
			deduction: 'link-rate-change-type-deduction'
		}
	},
	onboarding: {
		status: {
			demo: 'onboarding-status-demo',
			onboarding: 'onboarding-status-onboarding',
			firstPeriod: 'onboarding-status-first-period',
			ready: 'onboarding-status-ready',
			expired: 'onboarding-status-expired',
			notExpired: 'onboarding-status-not-expired'
		}
	},
	payPolicies: {
		type: {
			annualSalary: 'policy-type-annual-salary',
			annualAllowance: 'policy-type-annual-allowance'
		}
	},
	payrollAlerts: {
		priority: {
			errors: 'payroll-alerts-priority-errors',
			warnings: 'payroll-alerts-priority-warnings',
			notices: 'payroll-alerts-priority-notices'
		}
	},
	payslipLabels: {
		types: {
			additions: 'payslip-labels-types-additions',
			deductions: 'payslip-labels-types-deductions'
		}
	},
	pensionCommunications: {
		email: {
			hasEmail: 'pension-communications-email-has-email',
			noEmail: 'pension-communications-email-no-email'
		}
	},
	pensionTeam: {
		enrolmentDate: {
			oneMonth: 'pension-team-enrolment-date-one-month',
			threeMonths: 'pension-team-enrolment-date-three-months',
			sixMonths: 'pension-team-enrolment-date-six-months',
			twelveMonths: 'pension-team-enrolment-date-twelve-months'
		},
		joinedDate: {
			oneMonth: 'pension-team-joined-date-one-month',
			threeMonths: 'pension-team-joined-date-three-months',
			sixMonths: 'pension-team-joined-date-six-months',
			twelveMonths: 'pension-team-joined-date-twelve-months'
		},
		status: {
			enrolled: 'current-period-pension-enrolled',
			willBeEnrolled: 'current-period-pension-will-be-enrolled',
			reassessment: 'current-period-pension-reassessment',
			joined: 'current-period-pension-joined',
			canJoin: 'current-period-pension-can-join',
			canOptIn: 'current-period-pension-can-opt-in',
			postponed: 'current-period-pension-postponed',
			optedIn: 'current-period-pension-opted-in',
			optedOut: 'current-period-pension-opted-out'
		}
	},
	profileDocuments: {
		type: {
			payStatement: 'profile-documents-type-pay-statement',
			p60: 'profile-documents-type-p60',
			p45: 'profile-documents-type-p45',
			p11d: 'profile-documents-type-p11d',
			matb1: 'profile-documents-type-matb1'
		}
	},
	profileHistory: {
		type: {
			personal: 'history-type-personal',
			company: 'history-type-company',
			payroll: 'history-type-payroll',
			hr: 'history-type-hr'
		}
	},
	profileHoliday: {
		type: {
			annualLeave: 'profile-holiday-type-annual-leave',
			specialLeave: 'profile-holiday-type-special-leave',
			unpaidLeave: 'profile-holiday-type-unpaid-leave'
		},
		status: {
			taken: 'profile-holiday-status-taken',
			untaken: 'profile-holiday-status-untaken'
		}
	},
	profileSickness: {
		status: {
			taken: 'profile-sickness-status-taken',
			untaken: 'profile-sickness-status-untaken'
		}
	},
	reports: {
		reportType: {
			payroll: 'reports-report-type-payroll',
			pension: 'reports-report-type-pension',
			team: 'reports-report-type-team',
			company: 'reports-report-type-company',
			audit: 'reports-report-type-audit',
			p32: 'reports-report-type-p32'
		}
	},
	schedules: {
		type: {
			attachmentOfEarnings: 'schedules-type-attachment-of-earnings',
			carBenefitInKind: 'schedules-type-company-car-bik',
			childcareVouchers: 'schedules-type-childcare-vouchers',
			companyLoan: 'schedules-type-company-loan',
			covid19SickPay: 'schedules-type-covid-sick-pay',
			cycleToWorkScheme: 'schedules-type-cycle-to-work-scheme',
			furlough: 'schedules-type-furlough',
			healthcare: 'schedules-type-healthcare',
			maternityPay: 'schedules-type-maternity-pay',
			paternityPay: 'schedules-type-paternity-pay',
			seasonTicketLoan: 'schedules-type-season-ticket-loan',
			sharedParentalPay: 'schedules-type-shared-parental-pay',
			sickPay: 'schedules-type-sick-pay'
		},
		status: {
			cancelled: 'schedules-status-cancelled',
			complete: 'schedules-status-complete',
			inProgress: 'schedules-status-in-progress',
			paused: 'schedules-status-paused',
			pending: 'schedules-status-pending',
			stopped: 'schedules-status-stopped'
		}
	},
	tasks: {
		status: {
			incomplete: 'tasks-status-incomplete',
			complete: 'tasks-status-complete'
		},
		due: {
			overdue: 'tasks-status-overdue',
			notoverdue: 'tasks-status-notoverdue',
		}
	},
	taxUpdates: {
		effectiveDate: {
			oneMonth: 'tax-updates-effective-date-one-month',
			threeMonths: 'tax-updates-effective-date-three-months',
			sixMonths: 'tax-updates-effective-date-six-months',
			twelveMonths: 'tax-updates-effective-date-twelve-months'
		}
	},
	team: {
		status: {
			activeOnPayroll: 'team-status-active-on-payroll',
			onHold: 'team-status-on-hold',
			hasAdvancedFuturePeriods: 'has-advanced-future-periods',
			isAdvancingFuturePeriods: 'is-advancing-future-periods',
			isApprentice: 'team-status-is-apprentice',
			isDirector: 'team-status-is-director',
			isFurloughed: 'team-status-is-furloughed',
			readyForPayroll: 'team-status-ready-for-payroll',
			newStarter: 'team-status-new-starter',
			incomplete: 'team-status-incomplete',
			leaving: 'team-status-leaving',
			cis: 'team-status-cis',
			cisInactive: 'team-status-cis-inactive',
			missingBankDetails: 'team-status-missing-bank-details',
			rejoiner: 'team-status-rejoiner',
			isExcludedFromRti: 'team-status-excluded-from-rti'
		},
		employmentType: {
			standard: 'team-employment-type-standard',
			nonStandard: 'team-employment-type-nonstandard',
			netPay: 'team-employment-type-net-pay',
			paidHourly: 'team-employment-type-paid-hourly',
			payPolicy: 'team-employment-type-pay-policy'
		},
		account: {
			registered: 'team-account-registered',
			notRegistered: 'team-account-not-registered',
			isAdmin: 'team-account-is-admin'
		},
		cis: {
			soleTrader: 'team-cis-sole-trader',
			partnership: 'team-cis-partnership',
			limited: 'team-cis-limited',
			trust: 'team-cis-trust'
		}
	},
	teamHistory: {
		status: {
			leavers: 'team-history-status-leavers',
			newStarters: 'team-history-status-new-starters'
		},
		payment: {
			bacs: 'team-history-payment-bacs',
			manual: 'team-history-payment-manual'
		}
	},
	teamImports: {
		importType: {
			address: 'team-imports-import-type-address',
			bank: 'team-imports-import-type-bank',
			changes: 'team-imports-import-type-changes',
			cis: 'team-imports-import-type-cis',
			company: 'team-imports-import-type-company',
			expats: 'team-imports-import-type-expats',
			fps: 'team-imports-import-type-fps',
			leavers: 'team-imports-import-type-leavers',
			payElements: 'team-imports-import-type-pay-elements',
			pension: 'team-imports-import-type-pension',
			postsPayPolicies: 'team-imports-import-type-posts-pay-policies',
			profile: 'team-imports-import-type-profile',
			salary: 'team-imports-import-type-salary',
			salaryUpdates: 'team-imports-import-type-salary-updates',
			sickness: 'team-imports-import-type-sickness',
			tax: 'team-imports-import-type-tax',
			timesheets: 'team-imports-import-type-timesheets',
			ytd: 'team-imports-import-type-ytd'
		}
	},
	teamPension: {
		status: {
			inPension: 'team-pension-status-in-pension',
			notInPension: 'team-pension-status-not-in-pension',
			pensionEnrolled: 'team-pension-status-pension-enrolled',
			pensionWillBeEnrolled: 'team-pension-status-pension-will-be-enrolled',
			pensionJoined: 'team-pension-status-pension-joined',
			pensionCanJoin: 'team-pension-status-pension-can-join',
			pensionCanOptIn: 'team-pension-status-pension-can-opt-in',
			pensionPostponed: 'team-pension-status-pension-postponed',
			pensionOptedOut: 'team-pension-status-pension-opted-out'
		}
	},
	teamPeopleHrUpdates: {
		status: {
			new: 'team-people-hr-updates-status-new',
			completed: 'team-people-hr-updates-status-completed',
			failed: 'team-people-hr-updates-status-failed',
			rejected: 'team-people-hr-updates-status-rejected'
		},
		severity: {
			info: 'team-people-hr-updates-severity-info',
			warning: 'team-people-hr-updates-severity-warning',
			error: 'team-people-hr-updates-severity-error'
		},
		type: {
			deductionCreated: 'team-people-hr-updates-type-deduction-created',
			deductionDeleted: 'team-people-hr-updates-type-deduction-deleted',
			deductionUpdated: 'team-people-hr-updates-type-deduction-updated',
			employeeBankDetailsUpdated: 'team-people-hr-updates-type-employee-bank-details-updated',
			employeeContactDetailsUpdated: 'team-people-hr-updates-type-employee-contact-details-updated',
			employeeCreated: 'team-people-hr-updates-type-employee-created',
			employeeDetailsUpdated: 'team-people-hr-updates-type-employee-details-updated',
			employeeLeaver: 'team-people-hr-updates-type-employee-leaver',
			entitlementCreated: 'team-people-hr-updates-type-entitlement-created',
			entitlementDeleted: 'team-people-hr-updates-type-entitlement-deleted',
			entitlementUpdated: 'team-people-hr-updates-type-entitlement-updated',
			oneOffDeductionCreated: 'team-people-hr-updates-type-one-off-deduction-created',
			oneOffDeductionDeleted: 'team-people-hr-updates-type-one-off-deduction-deleted',
			oneOffDeductionUpdated: 'team-people-hr-updates-type-one-off-deduction-updated',
			oneOffPaymentCreated: 'team-people-hr-updates-type-one-off-payment-created',
			oneOffPaymentDeleted: 'team-people-hr-updates-type-one-off-payment-deleted',
			oneOffPaymentUpdated: 'team-people-hr-updates-type-one-off-payment-updated',
			salaryCreated: 'team-people-hr-updates-type-salary-created',
			salaryUpdated: 'team-people-hr-updates-type-salary-updated'
		}
	},
	teamRotareadyUpdates: {
		status: {
			new: 'team-rotaready-updates-status-new',
			processing: 'team-rotaready-updates-status-processing',
			completed: 'team-rotaready-updates-status-completed',
			completedWithWarnings: 'team-rotaready-updates-status-completed-with-warnings',
			failed: 'team-rotaready-updates-status-failed',
			failedWithCritical: 'team-rotaready-updates-status-failed-with-critical',
			skipped: 'team-rotaready-updates-status-skipped',
			held: 'team-rotaready-updates-status-held'
		},
		severity: {
			info: 'team-rotaready-updates-severity-info',
			warning: 'team-rotaready-updates-severity-warning',
			error: 'team-rotaready-updates-severity-error',
			critical: 'team-rotaready-updates-severity-critical',
			criticalDismissed: 'team-rotaready-updates-severity-critical-dismissed'
		},
		type: {
			absenceRequested: 'team-rotaready-updates-type-absence-requested',
			absenceCancelled: 'team-rotaready-updates-type-absence-cancelled',
			absenceApproved: 'team-rotaready-updates-type-absence-approved',
			absenceRejected: 'team-rotaready-updates-type-absence-rejected',
			rotaMarkedForApproval: 'team-rotaready-updates-type-rota-marked-for-approval',
			rotaPublished: 'team-rotaready-updates-type-rota-published',
			rotaRevertedToDraft: 'team-rotaready-updates-type-rota-reverted-to-draft',
			signOffWeek: 'team-rotaready-updates-type-sign-off-week',
			userNeedsApproval: 'team-rotaready-updates-type-user-needs-approval',
			userApproved: 'team-rotaready-updates-type-user-approved',
			shiftSwapRequested: 'team-rotaready-updates-type-shift-swap-requested',
			shiftSwapAccepted: 'team-rotaready-updates-type-shift-swap-accepted',
			shiftSwapApproved: 'team-rotaready-updates-type-shift-swap-approved',
			shiftSwapRejected: 'team-rotaready-updates-type-shift-swap-rejected',
			shiftSwapCancelled: 'team-rotaready-updates-type-shift-swap-cancelled',
			userDocumentExpiring: 'team-rotaready-updates-type-user-document-expiring',
			userDocumentExpired: 'team-rotaready-updates-type-user-document-expired',
			userCreated: 'team-rotaready-updates-type-user-created',
			userUpdated: 'team-rotaready-updates-type-user-updated',
			shiftUpdated: 'team-rotaready-updates-type-shift-updated',
			userAppointmentCreated: 'team-rotaready-updates-type-user-appointment-created',
			userAppointmentUpdated: 'team-rotaready-updates-type-user-appointment-updated',
			userAppointmentDeleted: 'team-rotaready-updates-type-user-appointment-deleted',
			userPayCreated: 'team-rotaready-updates-type-user-pay-created',
			userPayUpdated: 'team-rotaready-updates-type-user-pay-updated',
			userPayDeleted: 'team-rotaready-updates-type-user-pay-deleted',
			shiftBroadcastCreated: 'team-rotaready-updates-type-shift-broadcast-created',
			shiftBroadcastAccepted: 'team-rotaready-updates-type-shift-broadcast-accepted',
			shiftBroadcastRejected: 'team-rotaready-updates-type-shift-broadcast-rejected',
			shiftBroadcastFilled: 'team-rotaready-updates-type-shift-broadcast-filled',
			shiftBroadcastPaused: 'team-rotaready-updates-type-shift-broadcast-paused',
			shiftBroadcastStopped: 'team-rotaready-updates-type-shift-broadcast-stopped',
			shiftBroadcastResumed: 'team-rotaready-updates-type-shift-broadcast-resumed',
			signOffWeekReversed: 'team-rotaready-updates-type-sign-off-week-reversed',
			signOffDay: 'team-rotaready-updates-type-sign-off-day',
			signOffDayReversed: 'team-rotaready-updates-type-sign-off-day-reversed',
			integrationSettingsUpdate: 'team-rotaready-updates-type-integration-settings-update',
			userDocumentCreated: 'team-rotaready-updates-type-user-document-created',
			userDocumentDeleted: 'team-rotaready-updates-type-user-document-deleted',
			userEmploymentCreated: 'team-rotaready-updates-type-user-employment-created',
			userEmploymentUpdated: 'team-rotaready-updates-type-user-employment-updated',
			userEmploymentDeleted: 'team-rotaready-updates-type-user-employment-deleted',
			documentPreSignatureCreated: 'team-rotaready-updates-type-document-pre-signature-created',
			documentPreSignatureUpdated: 'team-rotaready-updates-type-document-pre-signature-updated',
			documentPreSignatureCancelled: 'team-rotaready-updates-type-document-pre-signature-cancelled',
			userDocumentUpdated: 'team-rotaready-updates-type-user-document-updated',
			absenceUpdated: 'team-rotaready-updates-type-absence-updated',
			userEmploymentEndDateSet: 'team-rotaready-updates-type-user-employment-end-date-set',
			allowanceUpdated: 'team-rotaready-updates-type-allowance-updated'
		}
	},
	teamEdpUpdates: {
		status: {
			new: 'team-edp-updates-status-new',
			processing: 'team-edp-updates-status-processing',
			completed: 'team-edp-updates-status-completed',
			failed: 'team-edp-updates-status-failed',
			skipped: 'team-edp-updates-status-skipped'
		},
		severity: {
			info: 'team-edp-updates-severity-info',
			warning: 'team-edp-updates-severity-warning',
			error: 'team-edp-updates-severity-error'
		},
		type: {
			sicknessCreated: 'team-edp-updates-type-sickness-created',
			sicknessEdited: 'team-edp-updates-type-sickness-edited',
			sicknessDeleted: 'team-edp-updates-type-sickness-deleted',
			holidayCreated: 'team-edp-updates-type-holiday-created',
			holidayEdited: 'team-edp-updates-type-holiday-edited',
			holidayDeleted: 'team-edp-updates-type-holiday-deleted',
			maternityCreated: 'team-edp-updates-type-maternity-created',
			maternityEdited: 'team-edp-updates-type-maternity-edited',
			maternityDeleted: 'team-edp-updates-type-maternity-deleted',
			paternityCreated: 'team-edp-updates-type-paternity-created',
			paternityEdited: 'team-edp-updates-type-paternity-edited',
			paternityDeleted: 'team-edp-updates-type-paternity-deleted'
		}
	},
	workflowTasks: {
		payFrequency: {
			weekly: 'workflow-tasks-pay-frequency-weekly',
			fortnightly: 'workflow-tasks-pay-frequency-fortnightly',
			fourWeekly: 'workflow-tasks-pay-frequency-four-weekly',
			monthly: 'workflow-tasks-pay-frequency-monthly',
			quarterly: 'workflow-tasks-pay-frequency-quarterly',
			annually: 'workflow-tasks-pay-frequency-annually'
		},
		status: {
			isOverdue: 'workflow-tasks-status-overdue',
			isDueToday: 'workflow-tasks-status-due-today',
			isDueWithinTwoDays: 'workflow-tasks-status-due-within-two-days',
			isDueWithinThreeDays: 'workflow-tasks-status-due-within-three-days',
			isQueried: 'workflow-tasks-status-queried',
			isDraft: 'workflow-tasks-status-draft',
			isPayrollFailed: 'workflow-tasks-status-payroll-failed'
		},
		step: {
			payrollInformation: 'workflow-tasks-step-payroll-information',
			payrollCalculation: 'workflow-tasks-step-payroll-calculation',
			payrollConfirmation: 'workflow-tasks-step-payroll-confirmation',
			runPayroll: 'workflow-tasks-step-run-payroll'
		}
	}
});

'use strict';

angular.module('paycircleApp')
.constant('FILTER_OPTION_SPECIAL_TYPES', {
	date: 'date',
	dateRange: 'dateRange',
});

'use strict';

angular.module('paycircleApp')
.constant('FILE_TYPES', {
	csv: 0,
	xls: 1,
	pdf: 2,
	zip: 3,
	txt: 4,
	xml: 5,
	dynamic: 6,
});

'use strict';

/**
 * Form specific options
 */
angular.module('paycircleApp')
.constant('FORM_OPTIONS', {
	'add-a-change': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Payroll.canUpdateAdjustments']
	},
	'add-leave': {
		requiredPermissions: ['HR.canManageTeamHR']
	},
	'add-new-adjustment-group': {
		requiredPermissions: ['Admin.canManagePayElementPacks']
	},
	'add-new-bureau': {
		availableInPlayground: false
	},
	'add-new-company': {
		requiredPermissions: ['Admin.canManageCompanies']
	},
	'add-new-company-group': {
		requiredPermissions: ['Admin.canManageCompanyGroups']
	},
	'add-pay-policy-update': {
		title: 'Add policy update'
	},
	'add-period-note': {
		title: 'Add note'
	},
	'add-period-task': {
		title: 'Add task'
	},
	'add-tax-update': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		isPayPeriodCurrentRequired: true,
		title: 'Add update',
		requiredPermissions: ['Team.canEditTaxStatus']
	},
	'additional-post-form': {
		isPayPeriodCurrentRequired: true
	},
	'address': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Address',
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'advance-future-periods': {
		isPayPeriodCurrentRequired: true
	},
	'advance-maternity-funding': {
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
	},
	'align-team-member-mappings-integration': {
		title: 'Align team member mappings'
	},
	'apply-tax-refund': {
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableInPlayground: false
	},
	'archive-company': {
		availableWhenCompanyPAYESchemeCeased: true,
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false
	},
	'attachment-of-earnings': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		isPayPeriodCurrentRequired: true,
		requiredPermissions: ['Payroll.canUpdateAOE'],
		title: 'Attachment of Earnings'
	},
	'auto-create-company': {
		title: 'Auto-create company',
		requiredPermissions: ['Admin.canManageCompanies']
	},
	'auto-run-test': {
		title: 'Test Payroll Auto run'
	},
	'average-holiday-pay-options': {
		availableWhenCompanyIsClone: false,
		requiredPermissions: ['CompanySettings.canAccessReports'],
		title: 'Manage options'
	},
	'bacs-penny-test': {
		title: 'BACS penny test'
	},
	'cancel-leaving-additional-post': {
		title: 'Cancel leaving post'
	},
	'cancel-pay-elements-import': {
		title: 'Cancel import'
	},
	'childcare-vouchers': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableWhenTeamMemberOnHold: false
	},
	'cis-business-type': {
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Business details',
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'cis-company-contact': {
		title: 'Company contact',
		showContext: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'cis-company-details': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Company details',
		showContext: false,
		requiredPermissions: ['Team.canEditCompanyDetails']
	},
	'cis-suffered': {
		title: 'Submit CIS deductions'
	},
	'cis-vat': {
		availableWhenPayrollPartiallySubmitted: false,
		title: 'VAT registration',
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'cis-verification': {
		availableWhenCompanyIsClone: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		isPayPeriodMinimumRequired: true,
		requiredPermissions: ['Team.canEditPersonalDetails'],
		title: 'Verification'
	},
	'company-details': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Company details',
		requiredPermissions: ['Team.canEditCompanyDetails']
	},
	'company-modules': {
		title: 'Modules'
	},
	'company-pension-connector': {
		title: 'Pension set up'
	},
	'company-settings-add-nominal-codes': {
		availableWhenCompanyIsClone: false,
	},
	'company-settings-authentication-session': {
		title: 'Manage session timeout',
		requiredPermissions: ['Admin.canManageAccess']
	},
	'company-settings-authentication-tfa': {
		title: 'Two-factor authentication',
		requiredPermissions: ['Admin.canManageAccess']
	},
	'company-settings-auto-apply-tax-refunds': {
		availableWhenCompanyIsClone: false,
		availableWhenCompanyIsPensionOnly: false,
		title: 'Auto apply tax refunds'
	},
	'company-settings-bacs': {
		availableInPlayground: false,
		title: 'BACS file creation'
	},
	'company-settings-bacs-downloads': {
		title: 'Download BACS file'
	},
	'company-settings-basic': {
		availableInPlayground: true,
		availableWhenCompanyIsClone: false,
		title: 'Basic information'
	},
	'company-settings-calculation-method': {
		title: 'Day rate calculation method'
	},
	'company-settings-cease-paye': {
		availableWhenCompanyIsClone: false,
		title: 'Close PAYE scheme'
	},
	'company-settings-currencies': {
		title: 'Currencies'
	},
	'company-settings-customer-codes':{
		title: 'Customer code'
	},
	'company-settings-delete-business-category': {
		title: 'Delete business category'
	},
	'company-settings-delete-nominal-code': {
		title: 'Delete nominal code'
	},
	'company-settings-department-sub-code-overrides': {
		title: 'Department sub-code overrides'
	},
	'company-settings-directors-ni': {
		title: 'Directors NI'
	},
	'company-settings-email-notifications': {
		availableWhenCompanyIsClone: false,
		title: 'Email notification settings'
	},
	'company-settings-employer': {
		availableInPlayground: true,
		availableWhenCompanyIsPensionOnly: false,
		title: 'Employer status'
	},
	'company-settings-eps': {
		availableInPlayground: true, // TODO: Set false before releasing live
		availableWhenCompanyIsClone: false,
		availableWhenCompanyIsPensionOnly: false,
		title: 'Auto submit EPS'
	},
	'company-settings-calculation-settings': {
		title: 'Calculation settings'
	},
	'company-settings-gender-pay-gap-delete': {
		title: 'Delete gender pay gap report'
	},
	'company-settings-gender-pay-gap-enabled': {
		title: 'Gender pay gap reporting'
	},
	'company-settings-holiday-policy': {
		title: 'New holiday policy',
	},
	'company-settings-pdf-download-sorting': {
		title: 'PDF download sorting'
	},
	'company-settings-pension-communications': {
		title: 'Communications'
	},
	'company-settings-pension-submissions': {
		title: 'Submissions'
	},
	'company-settings-pension-sup-runs': {
		title: 'Supplementary pay runs'
	},
	'company-settings-period-display-title': {
		title: 'Period display title'
	},
	'company-settings-references': {
		availableInPlayground: true,
		availableWhenCompanyPAYESchemeCeased: true,
		title: 'References and updates'
	},
	'company-settings-rti-submissions': {
		availableWhenCompanyPayrollModuleOff: false,
		title: 'RTI submissions'
	},
	'company-settings-inactive-period': {
		availableWhenCompanyIsClone: false,
		title: 'Report a period of inactivity'
	},
	'company-settings-p11db-submission-delete': {
		title: 'P11D(b) submission'
	},
	'company-settings-p11d-submission': {
		title: 'P11D(b) submission'
	},
	'company-settings-p32-payment': {
		availableWhenCompanyIsClone: false,
		title: 'P32 payment'
	},
	'company-settings-p60-notifications': {
		title: 'Send next P60 notifications'
	},
	'company-settings-payslip-additional-note': {
		title: 'Display Healthcare Levy notice'
	},
	'company-settings-payslip-display-period': {
		title: 'Display pay period'
	},
	'company-settings-hmrc': {
		availableInPlayground: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyIsPensionOnly: false,
		title: 'Electronic updates'
	},
	'company-settings-nmw-calculation': {
		title: 'National minimum wage calculation'
	},
	'company-settings-ni-updates': {
		availableWhenCompanyIsClone: false,
		availableWhenCompanyIsPensionOnly: false,
		title: 'Auto-accept NI Category updates'
	},
	'company-settings-paydashboard-settings': {
		availableWhenCompanyIsClone: false,
		title: 'PayDashboard file creation'
	},
	'company-settings-payroll-settings': {
		availableInPlayground: true,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Payroll settings'
	},
	'company-settings-payroll-auto': {
		availableInPlayground: false,
		availableWhenCompanyIsClone: false,
		title: 'Payroll settings'
	},
	'company-settings-backdated-salary-elements': {
		availableWhenCompanyIsClone: false,
		title: 'Backdated salary derived elements'
	},
	'company-settings-skip-pay-periods': {
		title: 'Skip pay periods'
	},
	'company-settings-sub-code-overrides': {
		title: 'Sub-code overrides'
	},
	'company-settings-work-durations': {
		title: 'Work patterns'
	},
	'company-settings-work-hours': {
		title: 'Edit work pattern'
	},
	'company-vehicle': {
		activeStep: 1,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		showProgressBar: true,
		totalSteps: 4,
		requiredPermissions: ['Payroll.canUpdateRepaymentSchedules']
	},
	'company-vehicle-view': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		title: 'Company vehicle'
	},
	'continuous-employment': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canAddDeleteTeamMembers', 'Team.canEditContinuousEmployment']
	},
	'correctional-submission': {
		availableWhenCompanyPAYESchemeCeased: true,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Payroll.canMakePreviousYearUpdates']
	},
	'customisation': {
		initCallbackOnClose: true
	},
	'delete-job-grade': {
		requiredPermissions: ['HR.canManageJobGrades']
	},
	'delete-pay-policy': {
		requiredPermissions: ['HR.canManagePolicies']
	},
	'delete-adjustment-group': {
		title: 'Delete element pack',
		requiredPermissions: ['Admin.canManagePayElementPacks']
	},
	'delete-change': {
		requiredPermissions: ['Payroll.canUpdateAdjustments']
	},
	'delete-payroll-alert': {
		title: 'Dismiss warning'
	},
	'delete-period-note': {
		title: 'Delete note'
	},
	'delete-period-task': {
		title: 'Delete task'
	},
	'delete-report-template': {
		showContext: false,
		title: 'Delete template'
	},
	'delete-tax-update': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		isPayPeriodCurrentRequired: false,
		title: 'Delete update',
		requiredPermissions: ['Team.canEditTaxStatus']
	},
	'delete-team-member': {
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canAddDeleteTeamMembers']
	},
	'direct-debit': {
		title: 'Direct Debit set up with Paycircle Ltd'
	},
	'download-reports': {
		availableWhenCompanyPAYESchemeCeased: true
	},
	'edit-accounting-integration': {
		title: 'Connect to accounting software'
	},
	'edit-admin': {
		title: 'Edit admin details'
	},
	'edit-bureau-bun': {
		title: 'Edit BUN',
		requiredPermissions: ['Admin.canManageBacsDownloads']
	},
	'edit-deemed-payment': {
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		isPayPeriodCurrentRequired: true
	},
	'edit-holiday-policy': {
		requiredPermissions: ['HR.canManageTeamHR']
	},
	'edit-rotaready-integration': {
		isPayPeriodCurrentRequired: true
	},
	'edit-pay-experian-integration': {
		title: 'Experian Work Report™'
	},
	'edit-edp-integration': {
		title: 'Event-Driven Processing'
	},
	'edit-people-hr-integration': {
		availableWhenCompanyPAYESchemeCeased: true,
		title: 'PeopleHR Integration'
	},
	'edit-repayment-schedule-for-period': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		title: 'Edit change',
		requiredPermissions: ['Payroll.canUpdateRepaymentSchedules']
	},
	'edit-repayment-schedule-fixed-for-period': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		title: 'Edit change',
		requiredPermissions: ['Payroll.canUpdateRepaymentSchedules']
	},
	'edit-sickness-policy': {
		requiredPermissions: ['HR.canManageTeamHR']
	},
	'edit-team-imports': {
		title: 'Team imports',
	},
	'email-address': {
		availableInPlayground: true,
		availableWhenCompanyPAYESchemeCeased: true,
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Email address',
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'exclude-from-payroll': {
		availableWhenNotUnsubmitted: false
	},
	'finished-adding-team-member' : {
		initCallbackOnClose: false
	},
	'furlough': {
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
	},
	'generate-p45': {
		title: 'Generate P45'
	},
	'healthcare': {
		activeStep: 1,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		showProgressBar: true,
		totalSteps: 3,
		requiredPermissions: ['Payroll.canUpdateRepaymentSchedules']
	},
	'healthcare-view': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		title: 'Healthcare'
	},
	'holiday-sickness': {
		requiredPermissions: ['HR.canManageTeamHR']
	},
	'hourly-totals': {
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Payroll.canAddHourlyTotals'],
		title: 'Add hourly totals'
	},
	'invite-to-register': {
		availableInPlayground: false,
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true,
		requiredPermissions: ['Team.canInviteTeamMembersToRegister']
	},
	'invite-sso-admin-to-fully-register': {
		availableInPlayground: false,
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true,
		requiredPermissions: ['Team.canInviteTeamMembersToRegister']
	},
	'job-grade-team-members': {
		requiredPermissions: ['HR.canManageJobGrades']
	},
	'journal-code-financials': {
		title: 'Journal code format'
	},
	'journal-post-temporal-data': {
		title: 'Add new post'
	},
	'leave-additional-post': {
		title: 'Leave post'
	},
	'link-element': {
		title: 'Add link element',
	},
	'link-rates': {
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Payroll.canAddLinkRates']
	},
	'manage-admins': {
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true,
	},
	'manage-company-groups': {
		availableWhenCompanyIsClone: false
	},
	'manage-pay-elements': {
		availableWhenCompanyIsClone: false
	},
	'manage-pay-elements-pension': {
		availableWhenCompanyIsClone: false,
		title: 'Manage pay elements'
	},
	'manage-permissions': {
		availableInPlayground: false,
		availableWhenCompanyIsClone: false
	},
	'manage-report-packs': {
		availableWhenCompanyIsClone: false,
		title: 'Manage reports'
	},
	'manage-visibility': {
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true
	},
	'mapping-template': {
		title: 'Save mapping'
	},
	'maternity-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableWhenTeamMemberOnHold: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'maternity-pay-view': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false
	},
	'move-payrolls-form': {
		availableWhenTeamMemberIsAdvancingOrAdvanced: false
	},
	'new-admin': {
		availableInPlayground: false,
		availableWhenCompanyIsClone: false,
		requiredPermissions: ['CompanySettings.canAccessPermissions']
	},
	'ni-category-updates': {
		title: 'National Insurance category updates'
	},
	'onboarding-bureau-new-company': {
		title: 'Onboard new company',
	},
	'onboarding-wizard-company': {
		title: 'Company',
		showProgressBar: true
	},
	'onboarding-wizard-profile': {
		title: 'Profile',
		showProgressBar: true
	},
	'on-hold': {
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Team.canEditPayInformation']
	},
	'p11Db-submissions': {
		title: 'P11D(b) submission',
	},
	'password-reset': {
		availableInPlayground: false,
		availableWhenCompanyIsClone: false,
		title: 'Send password reset link'
	},
	'paternity-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableWhenTeamMemberOnHold: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'pay-element-net-to-gross': {
		title: 'Select net or gross treatment'
	},
	'pay-element-rate-type': {
		title: 'Select rate type'
	},
	'pay-element-matching': {
		title: 'Resolve pay element match'
	},
	'pay-information': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Pay information',
		requiredPermissions: ['Team.canEditPayInformation']
	},
	'payment-details': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Payment details',
		requiredPermissions: ['Team.canEditPayInformation']
	},
	'payments-to-date': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		isPayPeriodCurrentRequired: true,
		title: 'Payments to date',
		requiredPermissions: ['Team.canUpdateYTDsPostSetup']
	},
	'pension-scheme-authorise-nest': {
		showPensionContext: true,
		initCallbackOnClose: true,
		title: 'Authorise Nest'
	},
	'pension-scheme-authorise-peoples-pension': {
		showPensionContext: true,
		title: 'Authorise Peoples Pension'
	},
	'pension-scheme-authorise-smart': {
		showPensionContext: true,
		initCallbackOnClose: true,
		title: 'Authorise Smart Pension',
		requiredPermissions: ['isCompanySettingsVisible']
	},
	'pension-scheme-automation': {
		showPensionContext: true,
		title: 'Pension automation options',
		availableWhenCompanyPAYESchemeCeased: true
	},
	'pension-scheme-failed-pension-manually-submit-warning': {
		showPensionContext: true,
		title: 'Manually submit'
	},
	'pension-scheme-queued-pension-cancel-warning': {
		showPensionContext: true,
		title: 'Cancel queue'
	},
	'pension-scheme-groups': {
		showPensionContext: true,
		title: 'Pension groups'
	},
	'pension-scheme-postponement': {
		showPensionContext: true,
		title: 'Pension team postponement'
	},
	'pension-scheme-provider': {
		showPensionContext: true,
		title: 'Pension provider'
	},
	'pension-scheme-delete': {
		showPensionContext: true,
		title: 'Delete pension'
	},
	'pension-scheme-team': {
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		showPensionContext: true,
		title: 'Add team members'
	},
	'pension-scheme-staging': {
		title: 'Pension staging and re-enrolment'
	},
	'pension-scheme-period': {
		title: 'Edit pension period'
	},
	'pension-scheme-period-alignment': {
		title: 'Edit pension period alignment'
	},
	'pension-scheme-settings': {
		availableWhenPayrollCalculated: false,
		showPensionContext: true,
		title: 'Pension settings'
	},
	'pension-team-contributions-ae': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Pension contributions',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		showPensionContext: true
	},
	'pension-team-contributions-non-ae': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Pension contributions',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		showPensionContext: true
	},
	'pension-team-groups': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		title: 'Pension group',
		showPensionContext: true
	},
	'pension-team-bands': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		title: 'Pension band',
		showPensionContext: true
	},
	'pension-team-remove': {
		availableWhenPayrollPartiallySubmitted: false,
		showPensionContext: true,
		title: 'Remove from pension',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings']
	},
	'pension-team-manage-pensions': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Manage pensions',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings']
	},
	'pension-team-postponement': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		showPensionContext: true,
		title: 'Postponement',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings']
	},
	'pension-team-salary-sacrifice': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		showPensionContext: true,
		title: 'Salary sacrifice',
		requiredPermissions: ['Team.canUpdateTeamPensionSettings']
	},
	'pension-team-scheme-ae': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Add to pension',
		showPensionContext: false
	},
	'pension-team-scheme-non-ae': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Add to pension',
		showPensionContext: false
	},
	'pension-team-status': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		showPensionContext: true,
		requiredPermissions: ['Team.canUpdateTeamPensionSettings'],
		title: 'Pension status'
	},
	'people-hr-updates-data': {
		title: 'Review data'
	},
	'personal': {
		availableWhenCompanyPAYESchemeCeased: true,
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canEditPersonalDetails'],
		title: 'Personal details'
	},
	'personal-overview': {
		title: 'Summary'
	},
	'passport': {
		title: 'Passport and Visa details',
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'post-to-financials': {
		title: 'Post to Access Financials'
	},
	'post-to-xero': {
		title: 'Post to Xero'
	},
	'refresh-selected-changes': {
		title: 'Refresh changes',
		primaryButtonText: 'Refresh'
	},
	'remove-admin-access': {
		availableInPlayground: false,
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true,
		requiredPermissions: ['CompanySettings.canAccessPermissions'],
		title: 'Remove admin access'
	},
	'remove-payslip-notes': {
		requiredPermissions: ['Payroll.canUpdatePayslipNotes']
	},
	'repayment-schedules': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableWhenTeamMemberOnHold: false,
		title: 'Repayment schedule',
		requiredPermissions: ['Payroll.canUpdateRepaymentSchedules']
	},
	'resolve-pay-period-dates': {
		title: 'Resolve pay period dates',
		requiredPermissions: ['Payroll.canUpdateImports']
	},
	'reset-auth-access': {
		availableWhenCompanyIsClone: false,
		title: 'Reset access',
		requiredPermissions: ['Admin.canManageAccess']
	},
	'run-payroll': {
		availableWhenNotUnsubmitted: false,
		isPayPeriodCurrentRequired: true,
		requiredPermissions: ['Payroll.canRunPayroll']
	},
	'run-payroll-bulk': {
		requiredPermissions: ['Payroll.canRunPayroll']
	},
	'reversed-hmrc-tax-updates': {
		title: 'Tax Updates'
	},
	'salary-change': {
		title: 'Salary change'
	},
	'sick-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		availableWhenTeamMemberOnHold: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'company-settings-sick-pay-default-work-pattern': {
		title: 'Default work pattern for sick pay',
	},
	'company-settings-sickness-pro-ration-method': {
		title: 'Pro-ration method',
	},
	'starter-information': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Starter information'
	},
	'submit-eps': {
		requiredPermissions: [
			'Payroll.canRunPayroll'
		]
	},
	'supplementary-pay-run': {
		activeStep: 1,
		contextType: 'none',
		showProgressBar: true,
		totalSteps: 4
	},
	'switch-to-live': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Switch to Live Mode'
	},
	'tax-status': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		isPayPeriodCurrentRequired: true,
		title: 'Tax status',
		requiredPermissions: ['Team.canEditTaxStatus']
	},
	'telephone': {
		availableWhenPayrollPartiallySubmitted: false,
		title: 'Contact details',
		requiredPermissions: ['Team.canEditPersonalDetails']
	},
	'tax-updates': {
		title: 'Tax updates'
	},
	'tax-updates-confirmation': {
		availableWhenCompanyIsClone: false,
		title: 'Tax updates'
	},
	'undo-import-company-data': {
		title: 'Undo import',
		requiredPermissions: ['Team.canImportTeamData']
	},
	'undo-import-team': {
		title: 'Undo import',
		requiredPermissions: ['Team.canImportTeamData']
	},
	'undo-import-pay-element': {
		title: 'Undo import'
	},
	'undo-import-pay-policy': {
		title: 'Undo import'
	},
	'undo-import-posts-pay-policies': {
		title: 'Undo import',
		requiredPermissions: ['Team.canImportTeamData']
	},
	'unlink-access-account': {
		availableInPlayground: false,
		availableWhenCompanyArchived: true,
		availableWhenCompanyIsClone: false,
		availableWhenCompanyPAYESchemeCeased: true,
		title: 'Unlink access account'	
	},
	'unregister-user': {
		availableWhenCompanyArchived: true,
		availableWhenCompanyPAYESchemeCeased: true,
		requiredPermissions: ['Team.canInviteTeamMembersToRegister'],
		title: 'Unregister'
	},
	'update-gross-pay': {
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		title: 'Update salary for period'
	},
	'update-job-grade': {
		requiredPermissions: ['HR.canManageJobGrades']
	},
	'update-leaver-status': {
		availableWhenNotUnsubmitted: false,
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Team.canManageLeavers']
	},
	'user-documents': {
		contextType: 'user',
		title: 'Upload documents'
	},
	'view-attachment-of-earnings': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Payroll.canUpdateAOE']
	},
	'view-changes': {
		isPayPeriodMinimumRequired: true
	},
	'view-maternity-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'view-paternity-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'view-sick-pay': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		availableWhenTeamMemberIsAdvancingOrAdvanced: false,
		requiredPermissions: ['Payroll.canUpdateStatutoryPayments']
	},
	'work-pattern-delete': {
		title: 'Delete work pattern'
	},
	'workflow-deadlines': {
		title: 'Edit deadlines'
	},
	'workplace-information': {
		availableWhenPayrollCalculated: false,
		availableWhenPayrollPartiallySubmitted: false,
		requiredPermissions: ['Team.canAddDeleteTeamMembers', 'Team.canEditCompanyDetails']
	}
});

'use strict';

angular.module('paycircleApp')
.constant('FORM_WIZARD_KEYS', {
	cisCompany: 'cis-company',
	cisSubcontractor: 'cis-subcontractor',
	company: 'company',
	companyHR: 'company-hr',
	companyPayroll: 'company-payroll',
	teamMemberAdd: 'team-member-add',
	teamMemberEditAEPension: 'team-member-edit-ae-pension',
	teamMemberEditEmployment: 'team-member-edit-employment',
	teamMemberEditNonAEPension: 'team-member-edit-non-ae-pension',
	teamMemberEditPersonal: 'team-member-edit-personal'
});

'use strict';

angular.module('paycircleApp')
.constant('FULL_SCREEN_MODAL_KEYS', {
	addressBook: 'address-book',
	changesTable: 'changes-table',
	error: 'error',
	genderPayGapReport: 'gender-pay-gap-report',
	payrollAssistant: 'payroll-assistant',
	payslipNotes: 'payslip-notes',
	payslipPreview: 'payslip-preview',
	report: 'report',
	reportTemplateCreator: 'report-template-creator'
})

.constant('FULL_SCREEN_MODAL_OPTIONS', {
	'address-book': {
		showClose: false,
		styles: 'has-no-padding is-small',
		title: 'Manage email recipients'
	},
	'changes-table': {
		title: 'Changes table',
		styles: 'has-no-padding',
		showClose: false
	},
	'gender-pay-gap-report': {
		showClose: false,
		styles: 'has-no-padding',
		title: 'Gender pay gap'
	},
	'payslip-notes': {
		title: 'Edit payslip notes',
		styles: 'has-no-padding is-medium',
	},
	'payslip-preview': {
		styles: 'has-no-padding is-medium',
	},
	'payroll-assistant': {
		showClose: true,
		styles: 'has-no-padding',
		title: 'Payroll Assistant'
	},
	'report-template-creator': {
		showClose: false
	},
	'report': {
		title: 'Preview report'
	}
});

'use strict';

const GENDER_PAY_GAP_EMPLOYEE_TYPES = {
	fullPayRelevant: 0,
	relevant: 1,
};

const GENDER_PAY_GAP_EXCLUSION_REASONS = {
	none: 0,
	other: 1,
	notRelevantEmployee: 2,
	genderWithheld: 3,
	llpMember: 4,
	salariedPartner: 5,
};

angular.module('paycircleApp')
.constant('GENDER_PAY_GAP_EMPLOYEE_TYPES', GENDER_PAY_GAP_EMPLOYEE_TYPES)
.constant('GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS', [
	{
		label: 'Relevant',
		value: GENDER_PAY_GAP_EMPLOYEE_TYPES.relevant
	},
	{
		label: 'Full-pay relevant',
		value: GENDER_PAY_GAP_EMPLOYEE_TYPES.fullPayRelevant
	}
])
.constant('GENDER_PAY_GAP_EXCLUSION_REASONS', GENDER_PAY_GAP_EXCLUSION_REASONS)
.constant('GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS', [
	{
		label: 'Other',
		value: GENDER_PAY_GAP_EXCLUSION_REASONS.other
	},
	{
		label: 'Not relevant employee',
		value: GENDER_PAY_GAP_EXCLUSION_REASONS.notRelevantEmployee
	},
	{
		label: 'Gender withheld',
		value: GENDER_PAY_GAP_EXCLUSION_REASONS.genderWithheld
	},
	{
		label: 'LLP member',
		value: GENDER_PAY_GAP_EXCLUSION_REASONS.llpMember
	},
	{
		label: 'Salaried partner',
		value: GENDER_PAY_GAP_EXCLUSION_REASONS.salariedPartner
	}
]);

'use strict';

angular.module('paycircleApp')
.constant('HMRC_PAYMENT_ACCOUNTS_IDS', {
	uk: 0,
	overseas: 1
})
.constant('HMRC_PAYMENT_ACCOUNTS', [
	{
		accountName: 'HMRC Cumbernauld',
		accountNumber: '12001039',
		displayLong: 'HMRC Cumbernauld (UK), Sort: 083210, A/C: 12001039',
		displayShort: 'HMRC (UK)',
		id: 0,
		sortCode: '083210',
	},
	{
		accountName: 'HMRC Cumbernauld',
		accountNumber: '(IBAN) GB62BARC20114770297690',
		displayLong: 'HMRC Cumbernauld (Overseas), Sort: (BIC) BARCGB22, A/C: (IBAN) GB62BARC20114770297690',
		displayShort: 'HMRC (Overseas)',
		id: 1,
		sortCode: '(BIC) BARCGB22',
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.HTTP_EVENTS
 * @description
 * # HTTP_EVENTS - Events that occur when making ajax calls using the angular $http function
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('HTTP_EVENTS', {
	badRequest: 		'bad-request',
	notAuthenticated: 	'not-authenticated',
	notAuthorised: 		'not-authorised',
	notFound: 			'not-found',
	sessionTimeout: 	'session-timeout',
	unreachable: 		'unreachable'
});
'use strict';

/**
 * The variation of submission states used in Paycircle
 */
angular.module('paycircleApp')
.constant('HTTP_STATUS_CODES', {
	unauthorized: 401,
	internalServerError: 500,
	notImplemented: 501,
	badGateway: 502,
	serviceUnavailable: 503,
	gatewayTimeout: 504,
	httpVersionNotSupported: 505,
	variantAlsoNegotiates: 506,
	insufficientStorage: 507,
	loopDetected: 508,
	notExtended: 510,
	networkAuthenticationRequired: 511
});

'use strict';

/**
 * The variation of interface types used in Paycircle
 */
angular.module('paycircleApp')
.constant('JOURNAL_CODE_DELIMITER_TYPES', {
	none: 0,
	dash: 1,
	space: 2,
	forwardSlash: 3
});

'use strict';

angular.module('paycircleApp')

.constant('GROUP_ENTRY_CATEGORIES', {
	calculated: {
		id: 'calculated',
		key: 'System',
		name: 'Calculated',
		singular: 'calculated'
	},
	additions: {
		id: 'additions',
		key: 'Additions',
		name: 'Additions',
		singular: 'addition'
	},
	deductions: {
		id: 'deductions',
		key: 'Deductions',
		name: 'Deductions',
		singular: 'deduction'
	}
});

'use strict';

angular.module('paycircleApp')
.constant('IDENTITY_STATE', {
	accessIdentity: 'AccessIdentity',
	accessIdentityMigrate: 'AccessIdentityMigrate',
	accessIdentityVerify: 'AccessIdentityVerify',
	paycircle: 'Paycircle'
});
'use strict';

angular.module('paycircleApp')
.constant('IMPORT_CONTEXT_TYPES', {
	companyData: 'company-data',
	employeeData: 'employee-data'
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_ELEMENT_STATUS_TYPES', {
	unverified: 0,
	hasError: 1,
	verified: 2,
	skipped: 3
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_MAPPING_IDS', {
	adjustmentType: '6805aa2e-a371-482b-9c59-283df6e87e48'
});
'use strict';

angular.module('paycircleApp')
.constant('IMPORT_MAPPING_COLUMN_TYPES', {
	value: 0,
	userId: 1,
	payElementId: 2,
	payElementLabel: 3,
	rate: 4,
	unit: 5,
	payElementNetToGross: 6,
	postIdentifier: 7,
	businessCategoryRole: 8,
	businessCategoryDepartment: 9,
	businessCategoryBranch: 10,
	businessCategoryCostCentre: 11,
	businessCategorySector: 12,
	numberOfPeriodsRecurring: 13,
	recurringEndDate: 14
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_MAPPING_TYPES', {
	users: 0,
	payElements: 1,
	team: 2,
	salaryUpdates: 3,
	leavers: 4,
	cis: 5,
	profile: 6,
	fps: 7,
	address: 8,
	changesTable: 9,
	ytd: 10,
	company: 11,
	bank: 12,
	tax: 13,
	salary: 14,
	pension: 15,
	all: 16,
	payElementsRecurring: 17,
	payElementsFixed: 18,
	payElementsFixedRecurring: 19,
	payElementsRatedUnitsVertical: 20,
	payElementsRatedUnitsHorizontal: 21,
	payElementsHourlyRate: 22,
	payElementsDailyRate: 23,
	linkedElements: 24,
	payElementsFixedCIS: 25,
	payElementsOffPayroll: 26,
	payslipManager: 27,
	nominalCodes: 29,
	businessCategories: 30,
	linkRateUnits: 31,
	payElementsOffPayrollRecurring: 32,
	payslipNotes: 33,
	xeroNominalCodes: 34,
	shifts: 35,
	policyImport: 36,
	expatDetails: 37,
	accessFinancialsNominalAccounts: 38,
	accessFinancialsBusinessCategories: 39,
	payElementsOffPayrollHorizontal: 40,
	payElementsOffPayrollRecurringHorizontal: 41,
	payElementsFixedCISHorizontal: 42,
	sickness: 43,
	postsPayPolicies: 45,
	calculatedPayHistoryImport: 49
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_MAPPING_COLUMN_SALARY', {
	salaryAnnual: 0,
	salaryPeriod: 1,
	partTimeDailyRate: 2,
	partTimeHourlyRate: 3,
	netPayAnnual: 4,
	netPayPeriod: 5,
	standardRate: 6,
	standardHours: 7,
	overtimeRate: 8,
	overtimeHours: 9,
	effectiveDateSalary: 10,
	workPattern : 11,
	workPatternEffectiveDate : 12,
	totalWorkHoursPerWeek : 13
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_MAPPING_COLUMN_SICKNESS', {
	sicknessStartDate: 0,
	sicknessEndDate: 1,
	waitingDaysUsed: 2,
	relevantPeriodEarnings: 3,
	scheduleCalculationBasis: 4,
	totalPaymentsMade: 5,
	schedulePaidInFull: 6,
	entitlementUsedInCurrentSicknessYear: 7,
	entitlementBand: 8,
	workPattern: 9
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_RATE_TYPES', {
	none: 0,
	calculatedHourly: 1,
	calculatedDaily: 2,
	overtimeHourly: 3,
	overtimeDaily: 4
});

'use strict';

angular.module('paycircleApp')
.constant('IMPORT_TYPES', {
	eps: 'ae74f199-43c9-459e-a977-3c1ae87258b4',
	fps: '816DBDCA-18A9-4233-AEC1-9D2F085328C2'
});
'use strict';

angular.module('paycircleApp')
.constant('IMPORT_WARNING_TYPES', {
	ageWarning: 0,
	phrWarning: 1,
	recurringElementImportWorking: 2
});

'use strict';

/**
 * The variation of interface types used in Paycircle
 */
angular.module('paycircleApp')
.constant('INTERFACE_TYPES', {
	agency: 1,
	dual: 2,
	hypoonly: 3,
	pensiononly: 4,
	actualonly: 5,
	test: 6,
	bureau: 7,
	group: 8,
	cisonly: 9
});

'use strict';

angular.module('paycircleApp')
.constant('JOB_STATUSES', {
	pending: 0,
	booked: 1,
	worked: 2,
	approved: 3,
	paid: 4,
	creating: 5,
	rejected: 6,
	workedApproved: 7,
	unassigned: 8
})
.constant('JOB_STATUS_LABELS', {
	0: 'Pending',
	1: 'Booked',
	2: 'Worked',
	3: 'Approved',
	4: 'Paid',
	5: 'Creating',
	6: 'Rejected',
	7: 'Work Approved',
	8: 'Unassigned'
});

'use strict';

angular.module('paycircleApp')
.constant('KEY_CODES', {
	backspace: 8,
	enter: 13,
	escape: 27,
	leftArrow: 37,
	upArrow: 38,
	rightArrow: 39,
	downArrow: 40,
	tab: 9
});

'use strict';

angular.module('paycircleApp')
.constant('LEAVE_TYPES', {
	holiday: [
		{
			id: 0,
			name: 'Annual Leave'
		},
		{
			id: 1,
			name: 'Special Leave'
		},
		{
			id: 3,
			name: 'Unpaid Leave'
		}
	],
	sickness: [
		{
			id: 2,
			name: 'Sick Leave'
		}
	]
})
.constant('LEAVE_TYPE_DESCRIPTIONS', {
	annualLeave: 0,
	specialLeave: 1,
	sickLeave: 2,
	unpaidLeave: 3
});

'use strict';

angular.module('paycircleApp')
.constant('LEAVING_REASONS', [
	{
		name: 'None',
		id: 0,
		prompt: 'No reason given'
	},
	{
		name: 'Dismissal',
		id: 2,
		prompt: 'They are being dismissed'
	},
	{
		name: 'Resigned',
		id: 1,
		prompt: 'They are resigning'
	},
	{
		name: 'Redundancy',
		id: 3,
		prompt: 'They are being made redundant'
	},
	{
		name: 'Deceased',
		id: 5,
		prompt: 'They have died'
	},
	{
		name: 'TUPE',
		id: 4,
		prompt: 'TUPE'
	},
	{
		name: 'Other',
		id: 6,
		prompt: 'Other'
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.LOADER_EVENTS
 * @description
 * # LOADER_EVENTS
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('LOADER_EVENTS', {
	show: 'show',
	hide: 'hide',
	loaderText: ''
});

angular.module('paycircleApp')
.constant('LOAN_DEDUCTION_TYPES', {
	'FIXED': 0,
	'SPLIT': 1
});
'use strict';

/**
 * Local storage keys used by the Payroll application
 */
angular.module('paycircleApp')
.constant('LOCAL_STORAGE_KEYS', {
	brandId: 'brandId',
	closedModals: 'closedModals',
	closedTooltips: 'closedTooltips',
	companiesStorage: 'companiesStorage',
	companyGroupId: 'companyGroupId',
	companyGroupName: 'companyGroupName',
	currentCompany: 'currentCompany',
	dismissedNotes: 'dismissedNotes',
	hasVisitedPlayground: 'hasVisitedPlayground',
	loginType: 'loginType',
	nonce: 'nonce',
	savedFilters: 'savedFilters',
	sessionData: 'sessionData',
	showPensionCommsDisclaimerBox: 'showPensionCommsDisclaimerBox',
	tempPermissions: 'tempPermissions',
	testCaseNumber: 'testCaseNumber',
	testCompany: 'testCompany',
	useTestData: 'useTestData'
});

angular.module('paycircleApp')
.constant('LOG_ACTIONED_BY_TYPES', {
	manual: 0,
	automatic: 1,
	paycircle: 2
});
'use strict';

angular.module('paycircleApp')
.constant('LOG_CATEGORIES', {
	bacs: 'ae93f7f7-446f-45d4-9d7a-50cee16b411d',
	billing: '6bda4811-859d-4eea-91d4-03432fc540c8',
	cis: '3c870bb4-c3e2-4efa-9bfa-025a4e44be97',
	company: '879bcd8e-74fc-4917-9a27-02ba8a76c800',
	eps: 'e691611b-16c5-4140-a33d-5abfe9c29ab4',
	eyu: '8b439d6c-6a50-496b-9498-37f081ae590c',
	fps: '751bb835-1afc-43df-8fd0-9a6b41841f20',
	import: '9b7e47c8-b65a-4d36-8a62-b8590808f494',
	payroll: 'f6aa7d62-82c1-4f92-b0b7-ac78d7cfb06d',
	pension: '669b26c8-4c1e-4b19-8b25-1a6d84fe932e',
	rti: '751bb835-1afc-43df-8fd0-9a6b41841f20',
	security: '6bad6079-c4de-41b9-b5e0-342fb1b87b5e',
	system: '70222124-8c4a-4af9-bdfd-b1e70d22205c',
	user: 'c3cbd8bf-6f26-4367-b085-fb9345fc4500',
	userTax: 'e7b2051b-7078-469f-8e73-f1684b2014a4',
	workflow: '5a1b32db-2992-46d0-ae2b-f8baae62e2a3'
});

angular.module('paycircleApp')
.constant('LOG_CATEGORY_TYPES', {
	company: 0,
	personal: 1,
	payroll: 2,
	pension: 3,
	hr: 4,
	system: 5
})
.constant('LOG_CATEGORY_NAMES', {
	0: 'Company',
	1: 'Team',
	2: 'Payroll',
	3: 'Pension',
	4: 'HR',
	5: 'System'
});
angular.module('paycircleApp')
.constant('LOG_DATA_TYPES', {
	none: -1,
	absolute: 0,
	fromTo: 1,
});
angular.module('paycircleApp')
.constant('LOG_TYPES', {
	'DEFAULT': {
		icon: null,
		id: -1,
		description: '',
		theme: null,
		apostrophise: false
	},
	'TAXCODE_UPDATED': {
		icon: 'tax-code-change',
		id: 0,
		description: 'tax code was updated',
		theme: null,
		apostrophise: true
	},
	'TAXOFFICE_UPDATED': {
		icon: 'reference-number',
		id: 1,
		description: 'PAYE Reference updated',
		theme: null,
		apostrophise: true
	},
	'ACCOUNTSOFFICE_UPDATED': {
		icon: 'reference-number',
		id: 2,
		description: 'Account Office Reference was updated',
		theme: null,
		apostrophise: true
	},
	'AGENCYEMPLOYERSENDER_UPDATED': {
		icon: 'padlock',
		id: 3,
		description: 'HMRC Sign in Credentials were updated',
		theme: null,
		apostrophise: true
	},
	'ADJUSTMENT_ADDED': {
		icon: 'add',
		id: 4,
		description: 'had a change added',
		theme: null,
		apostrophise: false
	},
	'SALARY_UPDATED': {
		icon: null,
		id: 5,
		description: 'salary details were updated',
		theme: null,
		apostrophise: true
	},
	'CONTRIBUTION_UPDATED': {
		icon: null,
		id: 6,
		description: 'pension contribution rates were updated',
		theme: null,
		apostrophise: true
	},
	'CEASE_PENSION': {
		icon: null,
		id: 7,
		description: 'pension contributions were ceased',
		theme: null,
		apostrophise: true
	},
	'OPTIN_PENSION': {
		icon: null,
		id: 8,
		description: 'opted in to the pension',
		theme: null,
		apostrophise: false
	},
	'POSTPONE_PENSION': {
		icon: null,
		id: 9,
		description: 'pension asessment was postponed',
		theme: null,
		apostrophise: true
	},
	'OPTOUT_PENSION': {
		icon: null,
		id: 10,
		description: 'opted out of the pension',
		theme: null,
		apostrophise: false
	},
	'USER_REGISTERED': {
		icon: null,
		id: 11,
		description: 'registered their account',
		theme: null,
		apostrophise: false
	},
	'USER_UNREGISTERED': {
		icon: null,
		id: 12,
		description: 'account was unregistered',
		theme: null,
		apostrophise: true
	},
	'USER_PERMISSIONS': {
		icon: null,
		id: 13,
		description: 'permissions were updated',
		theme: null,
		apostrophise: true
	},
	'INVITE_SENT': {
		icon: null,
		id: 14,
		description: 'has been invited to register',
		theme: null,
		apostrophise: false
	},
	'USER_LOGGEDIN': {
		icon: null,
		id: 15,
		description: 'logged in to their account',
		theme: null,
		apostrophise: false
	},
	'USER_UNLOCKED': {
		icon: null,
		id: 16,
		description: 'account was unlocked',
		theme: null,
		apostrophise: true
	},
	'PASSWORD_RESET': {
		icon: null,
		id: 17,
		description: 'password was reset',
		theme: null,
		apostrophise: true
	},
	'PASSWORD_CHANGE': {
		icon: null,
		id: 18,
		description: 'password was changed',
		theme: null,
		apostrophise: true
	},
	'ADDRESS_UPDATED': {
		icon: 'settings',
		id: 19,
		description: 'address was updated',
		theme: null,
		apostrophise: true
	},
	'USER_CREATED': {
		icon: 'add-user',
		id: 20,
		description: 'has been added to the team',
		theme: 'positive',
		apostrophise: false
	},
	'USER_MERGED': {
		icon: null,
		id: 21,
		description: 'account was merged',
		theme: null,
		apostrophise: true
	},
	'NINUMBER_UPDATED': {
		icon: null,
		id: 22,
		description: 'NI number was updated',
		theme: null,
		apostrophise: true
	},
	'HASTEEPAY_IMPORT': {
		icon: null,
		id: 23,
		description: 'Completed HasteePay import',
		theme: null,
		apostrophise: true
	},
	'HMRC_REJECTED': {
		icon: 'warning',
		id: 24,
		description: 'Unable to connect to HMRC',
		theme: 'assertive',
		apostrophise: true
	},
	'HMRC_UNAUTHORISED': {
		icon: 'warning',
		id: 25,
		description: 'Unable to connect to HMRC',
		theme: 'assertive',
		apostrophise: true
	},
	'HMRC_DPSFAIL': {
		icon: null,
		id: 26,
		description: 'Failed to connect to HMRC',
		theme: null,
		apostrophise: true
	},
	'IMPORT_FAIL': {
		icon: null,
		id: 27,
		description: 'Failed to complete import',
		theme: 'assertive',
		apostrophise: true
	},
	'USERCOMPANYDETAILS_UPDATED': {
		icon: null,
		id: 28,
		description: '',
		theme: null,
		apostrophise: true
	},
	'REGISTERED': {
		icon: null,
		id: 29,
		description: 'registered their account',
		theme: null,
		apostrophise: false
	},
	'ADJUSTMENT_REMOVED': {
		icon: 'minus',
		id: 30,
		description: 'had a change removed',
		theme: 'assertive',
		apostrophise: false
	},
	'BANKDETAILS_UPDATED': {
		icon: 'settings',
		id: 31,
		description: 'bank details were updated',
		theme: null,
		apostrophise: true
	},
	'MANDATE_UPDATED': {
		icon: null,
		id: 32,
		description: 'Billing details were updated',
		theme: null,
		apostrophise: true
	},
	'HISTORY_UPDATED': {
		icon: null,
		id: 33,
		description: 'History details were updated',
		theme: null,
		apostrophise: true
	},
	'CISVERIFY_UPDATED': {
		icon: null,
		id: 34,
		description: 'CIS verification was updated',
		theme: null,
		apostrophise: true
	},
	'PAYE_SCHEME_CLOSED': {
		icon: null,
		id: 35,
		description: 'PAYE scheme has been closed',
		theme: null,
		apostrophise: true
	},
	'PENSION_AUTHORISATION_UPDATED': {
		icon: 'connection',
		id: 36,
		description: 'Pension connection was authorised',
		theme: null,
		apostrophise: true
	},
	'PENSION_AUTOMATION_UPDATED': {
		icon: 'settings',
		id: 37,
		description: 'Pension automation settings were updated',
		theme: null,
		apostrophise: true
	},
	'PENSION_COMMS_UPDATED': {
		icon: 'settings',
		id: 38,
		description: 'Pension communications settings were updated',
		theme: null,
		apostrophise: true
	},
	'FPS_IMPORTED': {
		icon: null,
		id: 40,
		description: 'FPS was imported successfully',
		theme: null,
		apostrophise: true
	},
	'FPS_FAILED_TO_IMPORT': {
		icon: null,
		id: 41,
		description: 'Import from FPS failed',
		theme: 'assertive',
		apostrophise: true
	},
	'EPS_IMPORTED': {
		icon: null,
		id: 42,
		description: 'Imported EPS successfully',
		theme: null,
		apostrophise: true
	},
	'EPS_FAILED_TO_IMPORT': {
		icon: null,
		id: 43,
		description: 'Import from EPS failed',
		theme: null,
		apostrophise: true
	},
	'EPS_ELEMENT_IMPORTED': {
		icon: null,
		id: 44,
		description: 'Imported data from EPS successfully',
		theme: null,
		apostrophise: true
	},
	'EPS_ELEMENT_FAILED_TO_IMPORT': {
		icon: null,
		id: 45,
		description: 'Failed to import data from EPS',
		theme: null,
		apostrophise: true
	},
	'PENSION_SETTINGS_UPDATED': {
		icon: 'settings',
		id: 46,
		description: '',
		theme: null,
		apostrophise: true
	},
	'PENSION_STATUS_UPDATED': {
		icon: null,
		id: 47,
		description: 'pension status was updated',
		theme: null,
		apostrophise: true
	},
	'YTD_FIGURES_UPDATED': {
		icon: null,
		id: 48,
		description: 'Year to date figures were updated',
		theme: null,
		apostrophise: true
	},
	'BILLINGDETAILS_UPDATED': {
		icon: null,
		id: 49,
		description: 'billing details were updated',
		theme: null,
		apostrophise: true
	},
	'COMPANY_MODULES': {
		icon: null,
		id: 50,
		description: 'Company modules were updated',
		theme: null,
		apostrophise: true
	},
	'DEPARTMENT_UPDATED': {
		icon: null,
		id: 51,
		description: 'Department details were updated',
		theme: null,
		apostrophise: true
	},
	'NICODE_UPDATED': {
		icon: null,
		id: 52,
		description: 'NI Code was updated',
		theme: null,
		apostrophise: true
	},
	'STUDENTLOAN_UPDATED': {
		icon: null,
		id: 53,
		description: 'student loan details were updated',
		theme: null,
		apostrophise: true
	},
	'POSTGRADUATELOAN_UPDATED': {
		icon: null,
		id: 54,
		description: 'post graduate loan details were updated',
		theme: null,
		apostrophise: true
	},
	'COMPANY_DELETED': {
		icon: null,
		id: 55,
		description: '',
		theme: null,
		apostrophise: true
	},
	'ADMIN_ACCESS_ASSIGNED': {
		icon: null,
		id: 56,
		description: 'been given admin access',
		theme: null,
		apostrophise: true
	},
	'ADMIN_ACCESS_REMOVED': {
		icon: null,
		id: 57,
		description: 'admin access has been revoked',
		theme: null,
		apostrophise: true
	},
	'USER_ON_HOLD': {
		icon: null,
		id: 58,
		description: 'was marked as ‘On hold’',
		theme: null,
		apostrophise: false
	},
	'USER_OFF_HOLD': {
		icon: null,
		id: 59,
		description: 'was marked as ‘Active on payroll’',
		theme: null,
		apostrophise: false
	},
	'USER_DETAILS_UPDATED': {
		icon: null,
		id: 60,
		description: 'personal details were updated',
		theme: null,
		apostrophise: true
	},
	'USER_TAXREFUND_ADDED': {
		icon: 'user',
		id: 63,
		description: 'had a tax refund applied',
		theme: null,
		apostrophise: false
	},
	'USER_TAXREFUND_REMOVED': {
		icon: 'user',
		id: 64,
		description: 'tax refund was removed',
		theme: null,
		apostrophise: true
	},
	'USER_REJOINED_PAYROLL': {
		icon: null,
		id: 72,
		description: 'was set to rejoin payroll',
		theme: null,
		apostrophise: false
	},
	'WORKFLOW_STATE_UPDATED': {
		icon: 'setup',
		id: 80,
		description: '',
		theme: 'primary',
		apostrophise: false
	},
	'WORKFLOWENTRY_STATE_UPDATED': {
		icon: 'setup',
		id: 81,
		description: '',
		theme: 'primary',
		apostrophise: false
	},
	'WORKFLOW_QUERIED': {
		icon: 'undo',
		id: 82,
		description: '',
		theme: 'indifferent',
		apostrophise: false
	},
	'USER_STARTDATE_UPDATED': {
		icon: null,
		id: 89,
		description: 'start date was updated',
		theme: null,
		apostrophise: true
	},
	'USER_LEAVEDATE_UPDATED': {
		icon: null,
		id: 90,
		description: 'leave date was updated',
		theme: null,
		apostrophise: true
	},
	'TAXCODE_REJECTED': {
		icon: null,
		id: 115,
		description: 'Tax update rejected',
		theme: null,
		apostrophise: false
	},
	'STUDENTLOAN_REJECTED': {
		icon: null,
		id: 116,
		description: 'Student loan update rejected',
		theme: null,
		apostrophise: false

	},
	'POSTGRADUATELOAN_REJECTED': {
		icon: null,
		id: 117,
		description: 'Postgraduate loan update rejected',
		theme: null,
		apostrophise: false
	},
	'USER_FURLOUGHPARTTIME_CHANGED': {
		icon: null,
		id: 133,
		description: 'Changed to part-time furlough',
		theme: null,
		apostrophise: false
	},
	'PAYROLL_APPROVED': {
		icon: 'tick',
		id: 166,
		description: 'payroll approved',
		theme: 'tertiary',
		apostrophise: false
	},
	'ROLLBACK_PERFORMED': {
		icon: 'roll-back',
		id: 167,
		description: 'rollback performed',
		theme: 'quarternary',
		apostrophise: false
	},
	'DRAFT_BACS_DOWNLOADED': {
		icon: 'tick',
		id: 212,
		description: '',
		theme: 'tertiary',
		apostrophise: false
	},
})

.constant('LOG_TYPE_KEYS', {
	0: 'TAXCODE_UPDATED',
	1: 'TAXOFFICE_UPDATED',
	2: 'ACCOUNTSOFFICE_UPDATED',
	3: 'AGENCYEMPLOYERSENDER_UPDATED',
	4: 'ADJUSTMENT_ADDED',
	5: 'SALARY_UPDATED',
	6: 'CONTRIBUTION_UPDATED',
	7: 'CEASE_PENSION',
	8: 'OPTIN_PENSION',
	9: 'POSTPONE_PENSION',
	10: 'OPTOUT_PENSION',
	11: 'USER_REGISTERED',
	12: 'USER_UNREGISTERED',
	13: 'USER_PERMISSIONS',
	14: 'INVITE_SENT',
	15: 'USER_LOGGEDIN',
	16: 'USER_UNLOCKED',
	17: 'PASSWORD_RESET',
	18: 'PASSWORD_CHANGE',
	19: 'ADDRESS_UPDATED',
	20: 'USER_CREATED',
	21: 'USER_MERGED',
	22: 'NINUMBER_UPDATED',
	23: 'HASTEEPAY_IMPORT',
	24: 'HMRC_REJECTED',
	25: 'HMRC_UNAUTHORISED',
	26: 'HMRC_DPSFAIL',
	27: 'IMPORT_FAIL',
	28: 'USERCOMPANYDETAILS_UPDATED',
	29: 'REGISTERED',
	30: 'ADJUSTMENT_REMOVED',
	31: 'BANKDETAILS_UPDATED',
	32: 'MANDATE_UPDATED',
	33: 'HISTORY_UPDATED',
	34: 'CISVERIFY_UPDATED',
	35: 'PAYE_SCHEME_CLOSED',
	36: 'PENSION_AUTHORISATION_UPDATED',
	37: 'PENSION_AUTOMATION_UPDATED',
	38: 'PENSION_COMMS_UPDATED',
	39: 'PENSION_SUBMISSION',
	40: 'FPS_IMPORTED',
	41: 'FPS_FAILED_TO_IMPORT',
	42: 'EPS_IMPORTED',
	43: 'EPS_FAILED_TO_IMPORT',
	44: 'EPS_ELEMENT_IMPORTED',
	45: 'EPS_ELEMENT_FAILED_TO_IMPORT',
	46: 'PENSION_SETTINGS_UPDATED',
	47: 'PENSION_STATUS_UPDATED',
	48: 'YTD_FIGURES_UPDATED',
	49: 'BILLINGDETAILS_UPDATED',
	50: 'COMPANY_MODULES',
	51: 'DEPARTMENT_UPDATED',
	52: 'NICODE_UPDATED',
	53: 'STUDENTLOAN_UPDATED',
	54: 'POSTGRADUATELOAN_UPDATED',
	55: 'COMPANY_DELETED',
	56: 'ADMIN_ACCESS_ASSIGNED',
	57: 'ADMIN_ACCESS_REMOVED',
	58: 'USER_ON_HOLD',
	59: 'USER_OFF_HOLD',
	60: 'USER_DETAILS_UPDATED',
	61: 'EMPLOYMENTALLOWANCE_UPDATED',
	62: 'HMRC_SETTINGS_UPDATED',
	63: 'USER_TAXREFUND_ADDED',
	64: 'USER_TAXREFUND_REMOVED',
	65: 'PERIOD_INACTIVITY_UPDATED',
	66: 'COMPANY_ARCHIVE',
	67: 'BACS_FILE_CREATION',
	68: 'BACS_BANKDETAILS_UPDATED',
	69: 'BACS_PAYMENT_INCLUSION_UPDATED',
	70: 'ATTACHMENTORDER_UPDATED',
	71: 'PENSION_SETUP_UPDATED',
	72: 'USER_REJOINED_PAYROLL',
	73: 'PERIOD_SKIPPED_UPDATED',
	74: 'FAILED_PAY_PERIOD_RESET',
	75: 'PAYDASHBOARD_FILE_CREATION_UPDATED',
	76: 'AUTORUNFAIL_PREVIOUSPERIODINCOMPLETE',
	77: 'REPORT_PACK_UPDATED',
	78: 'REPORT_TEMPLATE_UPDATED',
	79: 'REPORT_PACK_ENTRY_UPDATED',
	80: 'WORKFLOW_STATE_UPDATED',
	81: 'WORKFLOWENTRY_STATE_UPDATED',
	82: 'WORKFLOW_QUERIED',
	83: 'PAYMENTSCHEDULE_UPDATED',
	84: 'P45_REGENERATED',
	85: 'P60_REGENERATED',
	86: 'PAY_STATEMENT_REGENERATED',
	87: 'WORKPATTERN_UPDATED',
	88: 'PENSION_REENROLMENT',
	89: 'USER_STARTDATE_UPDATED',
	90: 'USER_LEAVEDATE_UPDATED',
	91: 'SUPPLEMENTARY_PAYMENT_SUBMITTED',
	92: 'SALARY_DAILY_OVERTIME_ADDED',
	93: 'SALARY_DAILY_OVERTIME_DELETED',
	94: 'SALARY_DAILY_OVERTIME_UPDATED',
	95: 'SALARY_HOURLY_OVERTIME_ADDED',
	96: 'SALARY_HOURLY_OVERTIME_DELETED',
	97: 'SALARY_HOURLY_OVERTIME_UPDATED',
	98: 'NINUMBER_IMPORT_DISMISS',
	99: 'CHANGES_TABLE_IMPORTED',
	100: 'CHANGES_TABLE_DELETED',
	101: 'CHANGES_TABLE_SAVED',
	102: 'DIRECTOR_APPOINTED_ADDED',
	103: 'DIRECTOR_APPOINTED_UPDATED',
	104: 'DIRECTOR_ENDED_ADDED',
	105: 'DIRECTOR_ENDED_UPDATED',
	106: 'REPORT_TEMPLATE_OVERRIDDEN',
	107: 'PAYPERIODS_UPDATED',
	108: 'BACSDOWNLOAD_STATE_UPDATED',
	109: 'PAYROLL_OVERRIDE_UPDATED',
	110: 'DISBURSEMENT_ADDED',
	111: 'DISBURSEMENT_UPDATED',
	112: 'DISBURSEMENT_DELETED',
	113: 'BACS_FILE_REGENERATED',
	115: 'TAXCODE_REJECTED',
	116: 'STUDENTLOAN_REJECTED',
	117: 'POSTGRADUATELOAN_REJECTED',
	133: 'USER_FURLOUGHPARTTIME_CHANGED',
	166: 'PAYROLL_APPROVED',
	167: 'ROLLBACK_PERFORMED',
	212: 'DRAFT_BACS_DOWNLOADED'
});

'use strict';

angular.module('paycircleApp')
.constant('LOGIN_TYPES', {
	accessIdentity: 'accessIdentity',
	workspaceMigrate: 'workspaceMigrate',
	accessIdentityMigrate: 'accessIdentityMigrate',
	accessIdentityVerify: 'accessIdentityVerify',
	created: 'created',
	confirmEmail: 'confirmEmail',
	paycircle: 'paycircle',
	sso: 'sso',
	start: 'start'
});

'use strict';

angular.module('paycircleApp')
.constant('LOGIN_OIDC_TYPES', {
	// No error
	Success: 0,
	// User not setup for SSO
	NotEnabled: 1,
	// User is blocked as using identity
	BlockedForIdentity: 2,
	// An unexpected error occurred
	UnexpectedError: 3
});

'use strict';

angular.module('paycircleApp')
.constant('MAIL_TYPES', {
	assessmentStatus: 'ea341e5d-290e-4030-83ca-1747dbccacea',
	ceaseActiveMembershipNotice: '36798792-5BC2-4F5B-BAF5-AA0FF728E655',
	complianceFollowUp: 'ca623209-757f-407f-b765-bd4e6f5575cb',
	employeeGuide: 'ca623209-757f-407f-b765-bd4e6f5575cb',
	optInJoinNotice: 'D80A8A2C-DADD-46FD-AB42-61B6DB2C95DE',
	optOutNotice: 'B8EE0C90-83C7-4A2C-B1B0-BC0ADA86889D',
	pensionIntroduction: 'e76442cc-4de7-4976-8315-24b9b2eca8b2',
	postponeEligible: 'b05a4c22-7317-49f8-a869-0d3285b6482f',
	postponementNotice: '4cc7e3fe-b4d6-4bb6-9e1b-236727052837',
	postponeNewStarter: '55bf1435-6883-4b23-9c87-640e56fca1e5',
	resumeActiveMembershipNotice: 'B21904F9-A2F8-4526-B148-CD21587FD24C',
	resetPasswordUserPortal: 'bc3c853c-e7b7-4789-b37f-b0951397a29d',
	resetPasswordPayroll: '2caa5b2a-2fb5-4d68-a819-b045ce54912d'
})

.constant('MAIL_GROUP_TYPES', {
	none: 0,
	payroll: 1,
	pension: 2,
	system: 3
})

.constant('MAIL_SUBGROUP_TYPES', {
	none: 0,
	companyAdmins: 1,
	teamMembers: 2,
	invitation: 3,
	pension: 4,
	security: 5,
	onboarding: 6,
	workflow: 7,
	notes: 8,
	company: 9
});

'use strict';

angular.module('paycircleApp')
.constant('MANDATE_STATES', {
	unsubmitted: 0,
	pendingCustomerApproval: 1,
	pendingSubmission: 2,
	submitted: 3,
	active: 4,
	failed: 5,
	cancelled: 6,
	expired: 7,
	invalidBankDetails: 8
});
'use strict';

angular.module('paycircleApp')
.constant('MEDIA_TYPES', {
	phone: 'phone',
	tablet: 'tablet',
	laptop: 'laptop',
	monitor: 'monitor',
	tv: 'tv'
})
.constant('MEDIA_TYPES_SIZES', {
	phone: 740,
	tablet: 1200,
	laptop: 1440,
	monitor: 1770,
	tv: 99999999
});
'use strict';

angular.module('paycircleApp')
.constant('MENTION_OPTIONS', {
	bracketCharacter: ['[', ']'],
	hiddenClass: 'mention-input_hidden',
	mentionCharacter: '@',
	mentionClass: 'mention',
	popoutMaxTextLength: 100,
	popoutWidth: 400,
	selectionClass: 'mention-input_selection',
	selectionElementType: 'span',
	selectionIdPrefix: 'mention',
});

'use strict';

angular.module('paycircleApp')
.constant('MESSAGE_TYPES', {
	notes: 0,
	tasks: 1,
	warning: 2
})

.constant('MESSAGE_STATUS', {
	unread: 0,
	read: 1,
	complete: 2,
	incomplete: 3,
	deleted: 4
})

.constant('MESSAGE_SUBJECT_TYPES', {
	none: 0,
	query: 1
});

'use strict';

angular.module('paycircleApp')
.constant('MIGRATION_ERROR_CODES', {
	none: 0,
	unexpectedError: 1,
	cannotLinkMultipleUsers: 2,
	userAlreadyMigratedToAnotherAccount: 3,
	emailAddressNotUnique: 4
});
'use strict';

angular.module('paycircleApp')
.constant('MIME_FORMATS', {
	bmp: 'BMP',
	csv: 'CSV',
	doc: 'DOC',
	docx: 'DOCX',
	fps: 'FPS',
	gif: 'GIF',
	jpeg: 'JPEG',
	jpg: 'JPG',
	json: 'JSON',
	mov: 'MOV',
	pdf: 'PDF',
	png: 'PNG',
	ppt: 'PPT',
	pptx: 'PPTX',
	rtf: 'RTF',
	tif: 'TIF',
	txt: 'TXT',
	xls: 'XLS',
	xlsx: 'XLSX',
	xml: 'XML',
	zip: 'ZIP'
});

'use strict';

angular.module('paycircleApp')

/**
 * Generic modal types. Each of these is similar enough to be handled by a single component.
 */
 .constant('MODAL_GENERIC_TYPES', {
	information: 'information',
})

.factory('MODAL_OPTIONS', [
	'config',
	'MODAL_GENERIC_TYPES',
function (
	config,
	MODAL_GENERIC_TYPES
) {
	return {
		/**
		 * Generic modals.
		 */
		 'company-invalid-payroll-states': {
			title: 'Unable to run bulk payroll',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'Some of the companies you have selected are either processing payroll or are not quite ready to run payroll at this moment. Please review and try again.'
				}
			],
			closeButtonLabel: 'Go back'
		},
		'pension-scheme-contributions-since-date': {
			title: 'Contributions',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: [
						'This is the date that your pension data was first run through the Paycircle platform.',
						'If this was your original staging date then this amount will be correct from the start of your Workplace Pension.',
						'If you joined the platform later, the number shown will be from that date.',
						'The total contributions include both employer and employee contributions, it\'s the total amount contributed to your workplace pension to date.'
					]
				}
			],
			closeButtonLabel: 'OK, thanks'
		},
		'pension-above-age-limit': {
			title: 'Not eligible',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: `This means the individual is not eligible for a workplace pension usually because they are younger than ${config.lowerAgeThreshold} or older than state pension age.`
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-can-join': {
			title: 'Can join',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual can join a workplace pension but the employer doesn\'t have to contribute.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-can-opt-in': {
			title: 'Can opt in',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual will not be automatically enrolled but they can opt into a workplace pension if they wish.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-ceased': {
			title: 'Payment Holiday',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has chosen to stop their payments into a pension. They can choose to come out of the payment holiday at any time.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-enrolled': {
			title: 'Enrolled',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual is enrolled in a workplace pension and both the company\'s contributions and their individual contributions will be calculated and added to their pension pot each payroll.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-excluded': {
			title: 'Excluded',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has been excluded from the workplace pension. This is usually because they already have a pension that complies with the workplace pension regulations.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-joined': {
			title: 'Joined',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has joined a workplace pension.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-not-assessed': {
			title: 'Not Assessed',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual hasn\'t been assessed to join the workplace pension yet. This will happen when the Workplace Pension takes effect. The values shown are based on what they are likely to contribute.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-opted-in': {
			title: 'Opted in',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has opted into a workplace pension.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-opted-out': {
			title: 'Opted out',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has chosen to opt out of the workplace pension.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-postponed': {
			title: 'Postponed',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means that an individual\'s assessment for automatic enrolment has been postponed. This can be for a maximum of 3 months from:'
				},
				{
					type: 'list',
					content: [
						'A company\'s start date',
						'An individual\'s start date',
						'The date someone\'s circumstances change and they meet the criteria for enrolment, where they haven\'t before'
					]
				},
				{
					type: 'text',
					content: 'An individual can be postponed for any and all of these reasons and postponement is managed in the pensions settings area.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-joined-voluntarily': {
			title: 'Joined voluntarily',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has joined a workplace pension voluntarily while the company has decided to postpone its start date or has decided to start contributing early.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-re-assessment' : {
			title: 'Re-assessment',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual has left the workplace pension, but is being re-assessed this period based on the company\'s re-enrolment date. If they are eligible, they will be automatically enrolled into the workplace pension, and both the company\'s contributions and their individual contributions will be contributed each payroll.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-will-be-enrolled': {
			title: 'Will be automatically enrolled',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means, based on their current situation, the individual will be automatically enrolled into the workplace pension on the next assessment and both the company\'s contributions and their individual contributions will be contributed each payroll.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'pension-not-enrolled': {
			title: 'Not enrolled',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'This means the individual is not enrolled in a workplace pension.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'smart-view-gross-pay': {
			template: 'smart-view-info',
			theme: 'is-primary',
			title: 'Gross pay',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'Gross pay refers to the amount paid to an employee before any deductions are made, such as tax, National Insurance, pension contributions, or any other deductions. This is the total earnings that an employee receives based on their salary, wages, bonuses, or commissions before any reductions. It must be included in payslips issued to employees.'
				},
				{
					type: 'text',
					content: 'For example, if an employee earns £2,000 per month and has not yet had any deductions, this figure is their gross pay.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'smart-view-net-pay': {
			template: 'smart-view-info',
			theme: 'is-primary',
			title: 'Net pay',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'Net pay, often referred to as "take-home pay," is the amount an employee receives after all deductions have been made from their gross pay. Deductions may include Income Tax, National Insurance contributions, pension contributions, and other deductions like student loan repayments. Net pay is what is left after these deductions and is the actual amount deposited into the employee\'s bank account.'
				},
				{
					type: 'text',
					content: 'For example, if an employee\'s gross pay is £2,000 and deductions amount to £500, their net pay will be £1,500.'
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},
		'smart-view-paye': {
			template: 'smart-view-info',
			theme: 'is-primary',
			title: 'PAYE (Pay As You Earn)',
			type: MODAL_GENERIC_TYPES.information,
			information: [
				{
					type: 'text',
					content: 'PAYE is the system used by HMRC to collect Income Tax and National Insurance contributions from employees\' earnings. Employers are responsible for operating PAYE and deducting the appropriate amounts from employees\' salaries before paying them. The deducted amounts are then reported and paid to HMRC.'
				},
				{
					type: 'text',
					content: 'Key points about PAYE:'
				},
				{
					type: 'list',
					content: [
						'Employers must calculate deductions such as Income Tax and National Insurance contributions.',
						'PAYE is reported to HMRC through Real-Time Information (RTI) submissions.',
						'Employers may also need to send Employer Payment Summaries (EPS) to claim reductions for statutory pay or other adjustments.',
						'PAYE operates for all employees unless they fall outside its conditions.'
					]
				}
			],
			closeButtonLabel: 'Ok, thanks'
		},

		/**
		 * Special modals. Each has its own component or embedded <modal>
		 */
		'app-browser-compatibility-warning': {
			title: 'Browser update required'
		},
		'imports-duplicate-mapping-headers': {
			title: 'Duplicate headers'
		},
		'imports-leavers': {
			title: 'Leavers'
		},
		'imports-nothing-to-import': {
			title: 'Nothing to import'
		},
		'leave-date-expired': {
			title: 'Leave date has expired'
		},
		'payroll-reset-period': {
			title: 'Reset payroll'
		},
		'session-timed-out': {
			theme: 'is-primary align-footer-center',
			title: 'Session timeout'
		},
		'session-timeout-warning': {
			isEntireScreen: true,
			showHeader: false,
			title: 'Session timeout'
		},
		'settings-journal-nominal-codes-allocation-report': {
			title: 'Allocation report',
			size: 'is-large'
		},
		'settings-journal-code-preview-info': {
			title: 'Full code journal format'
		},
		'settings-pay-element-type': {
			title: 'Pay element settings'
		},
		'team-advance-pay-periods': {
			title: 'Advance future periods'
		},
		'team-bulk-delete-summary': {
			title: 'Delete team members'
		},
		'team-correctional-submission': {
			title: 'Earlier year update'
		},
		'team-excluded-from-rti': {
			title: 'Supplementary pay run'
		},
		'team-furlough': {
			title: 'Furlough'
		},
		'team-invite-to-register': {
			title: 'Invite to register'
		},
		'team-supplementary-pay-run': {
			title: 'Supplementary pay run'
		},
		'team-manage-rolled-up-holiday': {
			title: 'Manage rolled up holiday'
		},
		'team-mark-as-on-hold-or-active': {
			/* Dual purpose modal, title defined at runtime depending on context. All other options are default.
			   Nevertheless this entry needs to be here so it can be determined that this is a modal that has been
			   refactored into the new modal-cabinet structure. */
		},
		'team-unmark-as-advancing': {
			title: 'Unmark as advancing'
		},
		'workflow-payroll-information': {
			title: 'Payroll information'
		},
		'workflow-draft-reports': {
			title: 'Payroll information'
		},
		'smart-view-feedback': {
			title: 'Share your feedback'
		},
		'cookie-preferences': {
			title: 'Cookie Preferences',
			size: 'is-large',
			canClose: false
		}
	};
}]);

'use strict';
// https://gist.github.com/tiveor/5444753e9919ffe74b41
angular.module('paycircleApp')
.constant('NATIONALITIES', [
   'Afghan',
   'Albanian',
   'Algerian',
   'American',
   'Andorran',
   'Angolan',
   'Antiguans',
   'Argentinean',
   'Armenian',
   'Australian',
   'Austrian',
   'Azerbaijani',
   'Bahamian',
   'Bahraini',
   'Bangladeshi',
   'Barbadian',
   'Barbudans',
   'Batswana',
   'Belarusian',
   'Belgian',
   'Belizean',
   'Beninese',
   'Bhutanese',
   'Bolivian',
   'Bosnian',
   'Brazilian',
   'British',
   'Bruneian',
   'Bulgarian',
   'Burkinabe',
   'Burmese',
   'Burundian',
   'Cambodian',
   'Cameroonian',
   'Canadian',
   'Cape Verdean',
   'Central African',
   'Chadian',
   'Chilean',
   'Chinese',
   'Colombian',
   'Comoran',
   'Congolese',
   'Costa Rican',
   'Croatian',
   'Cuban',
   'Cypriot',
   'Czech',
   'Danish',
   'Djibouti',
   'Dominican',
   'Dutch',
   'East Timorese',
   'Ecuadorean',
   'Egyptian',
   'Emirian',
   'Equatorial Guinean',
   'Eritrean',
   'Estonian',
   'Ethiopian',
   'Fijian',
   'Filipino',
   'Finnish',
   'French',
   'Gabonese',
   'Gambian',
   'Georgian',
   'German',
   'Ghanaian',
   'Greek',
   'Grenadian',
   'Guatemalan',
   'Guinea-Bissauan',
   'Guinean',
   'Guyanese',
   'Haitian',
   'Herzegovinian',
   'Honduran',
   'Hungarian',
   'I-Kiribati',
   'Icelander',
   'Indian',
   'Indonesian',
   'Iranian',
   'Iraqi',
   'Irish',
   'Israeli',
   'Italian',
   'Ivorian',
   'Jamaican',
   'Japanese',
   'Jordanian',
   'Kazakhstani',
   'Kenyan',
   'Kittian and Nevisian',
   'Kuwaiti',
   'Kyrgyz',
   'Laotian',
   'Latvian',
   'Lebanese',
   'Liberian',
   'Libyan',
   'Liechtensteiner',
   'Lithuanian',
   'Luxembourger',
   'Macedonian',
   'Malagasy',
   'Malawian',
   'Malaysian',
   'Maldivan',
   'Malian',
   'Maltese',
   'Marshallese',
   'Mauritanian',
   'Mauritian',
   'Mexican',
   'Micronesian',
   'Moldovan',
   'Monacan',
   'Mongolian',
   'Moroccan',
   'Mosotho',
   'Motswana',
   'Mozambican',
   'Namibian',
   'Nauruan',
   'Nepalese',
   'New Zealander',
   'Nicaraguan',
   'Nigerian',
   'Nigerien',
   'North Korean',
   'Northern Irish',
   'Norwegian',
   'Omani',
   'Pakistani',
   'Palauan',
   'Panamanian',
   'Papua New Guinean',
   'Paraguayan',
   'Peruvian',
   'Polish',
   'Portuguese',
   'Qatari',
   'Romanian',
   'Russian',
   'Rwandan',
   'Saint Lucian',
   'Salvadoran',
   'Samoan',
   'San Marinese',
   'Sao Tomean',
   'Saudi',
   'Scottish',
   'Senegalese',
   'Serbian',
   'Seychellois',
   'Sierra Leonean',
   'Singaporean',
   'Slovakian',
   'Slovenian',
   'Solomon Islander',
   'Somali',
   'South African',
   'South Korean',
   'Spanish',
   'Sri Lankan',
   'Sudanese',
   'Surinamer',
   'Swazi',
   'Swedish',
   'Swiss',
   'Syrian',
   'Taiwanese',
   'Tajik',
   'Tanzanian',
   'Thai',
   'Togolese',
   'Tongan',
   'Trinidadian or Tobagonian',
   'Tunisian',
   'Turkish',
   'Tuvaluan',
   'Ugandan',
   'Ukrainian',
   'Uruguayan',
   'Uzbekistani',
   'Venezuelan',
   'Vietnamese',
   'Welsh',
   'Yemenite',
   'Zambian',
   'Zimbabwean'
]);

'use strict';

angular.module('paycircleApp')
.constant('NEST_AUTHORISATION_RESPONSES', {
	successful: 0,
	generalError: -1,
	invalidCredentials: -2,
	noAccess: -3,
	accountLocked: -4,
	invalidEmployerReference: -5,
});
'use strict';
angular.module('paycircleApp')
.constant('NI_CATEGORY_LETTER', {
	a: 'A',
	b: 'B',
	c: 'C',
	f: 'F',
	h: 'H',
	i: 'I',
	j: 'J',
	l: 'L',
	m: 'M',
	s: 'S',
	v: 'V',
	x: 'X',
	z: 'Z'
});

'use strict';

angular.module('paycircleApp')
.constant('NMW_CALCULATION_METHODS', {
	period: 0,
	annually: 1
});

'use strict';

angular.module('paycircleApp')
.constant('NMW_CATEGORIES', {
	notApplicable: -1,
	over22: 0,
	over21: 1,
	over18: 2,
	under18: 3,
	apprentice: 4
});

'use strict';

angular.module('paycircleApp')
.constant('OIDC_SYSTEMS', {
	azure: 0,
	okta: 1,
	xero: 2
})

.factory('OIDC_OPTIONS', [
	'OIDC_SYSTEMS',
function (
	OIDC_SYSTEMS
) {

	const oidcSystemImagePath = 'images/oidc-logo';
	const oidcKeys = Object.keys(OIDC_SYSTEMS);

	let oidcOptions = [
		{
			key: oidcKeys[OIDC_SYSTEMS.azure],
			name: 'Microsoft Azure',
			value: OIDC_SYSTEMS.azure,
			isImplemented: true // Remove when all implemented along with ng-if controlling option visibility in companySettingsAuthenticationSsoForm.html
		},
		{
			key: oidcKeys[OIDC_SYSTEMS.okta],
			name: 'OKTA',
			value: OIDC_SYSTEMS.okta,
			isImplemented: true // Remove when all implemented.
		},
		{
			key: oidcKeys[OIDC_SYSTEMS.xero],
			name: 'xero',
			value: OIDC_SYSTEMS.xero,
			isImplemented: false // Remove when implemented. Until then this option won't be available.
		}
	];

	oidcOptions.forEach(oidcOption => {
		oidcOption.logo = `${oidcSystemImagePath}/${oidcOption.key}.png`;
	});

	return oidcOptions;
}]);
'use strict';

angular.module('paycircleApp')
.constant('ONBOARDING_BUREAUS', {
	paycircle: 0,
	fsb: 1
});

'use strict';

angular.module('paycircleApp')
.constant('ONBOARDING_QUESTION_GROUPS', {
	company: '17e23f95-77e4-47a6-b972-fdb9308d2ee9',
	payroll: '86efa921-6cf0-4a1d-a749-a5367ada57a4',
	profile: 'be17498e-0ee9-4a52-8d15-07fe900b1dfd',
	team: 'eb5be77a-4800-46bf-b4f8-9ee922ebbfc9',
	workplacePension: 'e256ccbc-ba8a-41e9-b4de-d17945cdafae'
})
.constant('ONBOARDING_QUESTIONS', {
	company: {
		companyType: 'f590715f-b761-4518-ba47-20debe157d5e',
		companyNumber: 'db14d87b-db18-4f36-a2c3-9a59c3b8cd79',
		numberOfDirectors: 'd001e02f-5dda-4ec9-bc0e-d7442387abbc',
		employmentTypes: 'b7ffeacd-9885-4440-a8bf-e48018c29ff7',
		salaryTypes: '101d553b-c2ac-4224-b576-ded2e5fcc478',
		accountsOfficeReference: '6245637c-52a7-45f8-82e3-515033b63cc1',
		payeReference: '3415f7e5-db57-49d4-b26c-4c38ca619c99',
		electronicUpdates: '3bee2570-71cc-4485-bcda-55778cfe3461',
		hmrcCredentials: '9403a4f6-8d9a-47ef-9949-a6c7b2752040'
	},
	payroll: {
		payPeriods: 'd8e33183-2050-4e7a-93f0-38620587333c',
		payPeriodsMonth: '172ecc31-ab1e-4a23-9d50-d71c8681887f',
		payslipDeliveryMethod: 'c3231a38-e461-4e85-ad98-e0212886e091',
		payslipLogo: '58fbfee7-cc80-427f-8bb9-29981026082e',
		payrollContactDetails: '1518f41a-644b-40ea-86a6-089322240f9b',
		companyWorkWeekHours: '2e505f50-e624-4066-adcf-3c1b192c7cfd',
		smallEmployer: '37fe46a8-6925-4cc6-9f34-61c4c298b4bc',
		dayRateCalculationMethod: '47cb492d-df04-4f38-8cb9-e93045e0d37a',
		employmentAllowance: '83af4e4d-d4a1-4679-a887-013d18aef846',
		directorsNiCalculationMethod: '59510fe2-ef24-4361-b962-a352f851658c',
	},
	pension: {
		selectProvider: 'e8cac604-371b-4f1b-829a-add5c161e421',
		automationOptions: '39606914-7f09-4458-aa68-6dda58bc53f1',
		pensionStartDate: 'fea4782a-37fc-4fdf-8434-8232e72f4989',
		reEnrolment: '41bf24d4-fe54-490d-81dd-f2aedfb44483',
		pensionSettings: '0bbde858-3ecb-4b46-b710-9ccf7adbecfd',
		declarationOfCompliance: 'd5759422-82e9-4a76-80f0-f60572303b3b',
		pensionGroups: '39c659db-db1c-4905-98bf-66c469ed3fb5'
	},
	profile: {
		payrollExperience: 'dcfed53a-8e74-4c60-813c-ea2a686f7aca',
		payrollInvolvement: 'a7095a7d-3a7a-46a7-b37c-a1cc645bed38',
		relationshipToCompany: 'c22f780d-d243-4987-a0ba-c3097150bdb8',
		existingPayrollSoftware: '5cb4f636-bc83-4ebb-bd77-bb92651a34bf',
		payrollComplexityRating: 'b6ad4a1a-c216-4c75-b684-98428b665b56',
		hasExternalAdvisor: '619704a1-291d-45b4-b977-5b0410b8dfab',
		externalAdvisorInvolvement: 'd133fd8e-8e6c-4fb7-a59a-057dcaae49d8',
		preferredGoLiveDate: '083f240a-b51a-4468-9aa8-f87ad7bfd702',
		activeModules: '98b8ead2-6ffe-4e47-b0ff-06b031072f6b'
	}
});

angular.module('paycircleApp')
	.constant('VALIDATION_WARNINGS', {
		none : 0,
		missingTaxOfficeReference : 1,
		missingAccountsOfficeReference : 2,
		rtiSubmissionsDisabled : 3,
		payrollModuleDisabled : 4,
		submissionInProgress : 5,
		existingDraftSubmission : 6,
		noTaxYearsAvailable : 7,
		p11DbAlreadyExistsForTaxYear : 8,
		outsideSubmissionWindowForTaxYear : 9
	});

'use strict';

angular.module('paycircleApp')
.constant('P32_EMAIL_FREQUENCIES', {
	none: 0,
	monthly: 1,
	quarterly: 2,
	annually: 3
});

'use strict';

angular.module('paycircleApp')
.constant('PAY_ELEMENT_PACKS', {
	base: '4F82101A-C5DA-4CC5-9A90-34F1734AFDF8',
	cis: '9b3d3c56-c658-4c01-bb53-a38e9bf98f88'
});


'use strict';

angular.module('paycircleApp')
.constant('PAY_ELEMENTS', {
	accommodationExpenses: '09b14c38-3bfa-4fed-a2c1-254e8efc8cf4',
	annualBonus: '7863131a-52ea-4a2c-816e-fbf6db40685a',
	annualBonusPercent: '1169ed94-394a-40e9-8529-11369bfec62e',
	bonus: '8ffbd6ca-973a-440b-85ed-5c9f9e6c63d6',
	bonusPercent: '8ffbd6ca-973a-440b-85ed-5c9f9e6c63d6',
	christmasBonus: '325ab928-ac56-44ab-acb3-d33040dedc9b',
	christmasBonusPercent: 'a97a304c-b610-466d-864c-da59475e340b',
	commission: 'c16c8067-1b71-4e38-9c59-255370c57e91',
	eeNiAndErNi: '6fc38879-fd30-44c9-bf9d-a4f6d9c70ca1',
	eeNiAndErNiDeduction: 'a36d1dcd-4135-4e05-b9cb-a73a5ab75ca2',
	employersPension: 'f48f2018-7310-4ab8-a3bb-ad074c3a886f',
	employersPensionPercent: '14f55398-dac9-434b-85d3-83145d033c12',
	expenses: 'c24ff00b-da82-4e67-bfb6-c95f0a6e7194',
	internetExpenses: '8739f935-deb9-41de-9c30-0acad384b36b',
	mileageExpenses: 'dd1317e3-eb90-4883-a1ee-85a4fb49e41d',
	mobilePhoneExpenses: 'bb24f793-e27d-4a46-83a4-3ea999a67c4e',
	netToGross: 'e646964f-e31f-4938-99cf-1aa463e31123',
	netToGrossDeduction: '7af0d636-c665-449a-9924-754873f60e25',
	netToGrossUnits: 'ac6837d2-6265-47e5-85f5-030bd9d0f441',
	pension: '827d4578-50c4-48a8-9f93-2fd94b2d9d58',
	pensionNet: 'd7083891-88e1-4bae-a284-92f247d7b316',
	pensionPercent: '167f548d-97ff-4cdf-9d62-c4df9c5a76e1',
	pensionSalarySacrifice: '9720a3d4-8e02-4944-82e6-22ebc4628d29',
	profitShare: 'ef960151-150d-4598-b1ae-7558fa25eac6',
	referralBonus: 'c9a8a9f4-8aed-4617-a05f-87424db1d4c4',
	referralBonusPercent: 'c8cb9ecd-a2e0-4258-b801-d5a8e8572850',
	signOnBonus: '1c92b10c-3a9f-4289-964b-2dc0a0496e42',
	signOnBonusPercent: '6b2ace91-c06c-475c-a3ee-b0cc43848b7c',
	subsistenceExpenses: '980c6766-5e91-49e5-9af5-0d98baa809f1',
	travelExpenses: '4d766503-cc78-41ed-b814-dcffc311d954'
});

'use strict';

/**
 * Failure codes returned by the platform ResolvePayPeriodDates endpoint. Values must match the
 * PayPeriodResolutionFailureCode enum in AgencyLibrary, as WCF serialises enums as their numeric value.
 */
angular.module('paycircleApp')
	.constant('PAY_PERIOD_RESOLUTION_FAILURE_CODES', {
		unknown: 1,
		noCurrentPayPeriod: 2,
		frequencyNotSupported: 3,
		periodNumberInvalidForFrequency: 4,
		taxYearInvalid: 5,
		periodNotAvailableForFrequency: 6,
		periodBeforeAnchor: 7,
		periodRunTooLong: 8,
		startDateInvalid: 9,
		noPeriodsRequested: 10,
		companyIDNotProvided: 11
	})

	/**
	 * User facing copy for each failure code, keyed by the numeric code so a response maps directly.
	 * The Message returned alongside the code is diagnostic only and is never shown to the user.
	 * Where the failure identifies the pay period at fault, the copy contains the PERIOD token, which
	 * payPeriodDateResolutionService replaces with a description of that period (e.g. 'Period 3 of 2025').
	 */
	.constant('PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES', {
		1: 'We couldn\'t work out the dates for these pay periods. Please check the start date and try again.',
		2: 'This company doesn\'t have a current pay period yet, so pay period dates can\'t be worked out. Please set up the company\'s pay periods first.',
		3: 'Pay period dates can\'t be worked out for a daily payroll.',
		4: 'PERIOD isn\'t a valid period number for this company\'s pay frequency.',
		5: 'PERIOD isn\'t in a valid tax year.',
		6: 'PERIOD doesn\'t exist for this company\'s pay frequency.',
		7: 'PERIOD falls before the start date you\'ve entered.',
		8: 'These pay periods are too far apart to work out dates for. Please check the period numbers and tax years.',
		9: 'Please enter a valid start date.',
		10: 'There are no pay periods to work out dates for.',
		11: 'CompanyID must be provided to determine pay frequency'
	});

'use strict';

/**
 * The variation of pay period types used in Paycircle
 */
angular.module('paycircleApp')

// Pay period types use a slightly different enum to the usual PAY_PERIOD_TYPES enum 🤷
.constant('PAY_PERIOD_SETUP_TYPES_OPTIONS', [
	{
		id: 0,
		name: 'Weekly',
		maxPayPeriodProcessingDayOffset: 6
	},
	{
		id: 1,
		name: 'Two weekly',
		maxPayPeriodProcessingDayOffset: 13
	},
	{
		id: 2,
		name: 'Four weekly',
		maxPayPeriodProcessingDayOffset: 27
	},
	{
		id: 3,
		name: 'Monthly',
		maxPayPeriodProcessingDayOffset: 25
	},
	{
		id: 4,
		name: 'Quarterly'
	},
	{
		id: 7,
		name: 'Biannually'
	},
	{
		id: 5,
		name: 'Annually'
	}
])
.constant('PAY_PERIOD_SETUP_TYPES', {
	weekly: 0,
	twoWeekly: 1,
	fourWeekly: 2,
	monthly: 3,
	quarterly: 4,
	annually: 5,
	daily: 6,
	biAnnually: 7
})
.constant('PAY_PERIOD_SETUP_TYPES_DESCRIPTIONS', {
	0: 'Weekly',
	1: 'Two weekly',
	2: 'Four weekly',
	3: 'Monthly',
	4: 'Quarterly',
	5: 'Annually',
	6: 'Daily',
	7: 'Biannually'
})

// Arrears
.constant('PAY_PERIOD_ARREARS_OPTIONS', [
	{
		description: '1',
		value: 1
	},
	{
		description: '2',
		value: 2
	}
])
.constant('PAY_PERIOD_ARREARS_TYPES', {
	samePeriod: 0,
	custom: 1
})

// Offsetting
.constant('PAY_PERIOD_OFFSET_OPTIONS', [
	{
		description: 'Don\'t move it',
		value: 0
	},
	{
		description: 'Move it to the last working day prior',
		value: 1
	},
	{
		description: 'Move it to the next working day',
		value: 2
	}
])

// Payslips
.constant('PAY_PERIOD_PAYSLIP_DATE_TYPES', {
	afterPayDay: 'after-pay-day',
	beforePayDay: 'before-pay-day',
	payday: 'payday',
	processingDay: 'processing-day'
})

// Processing
.constant('PAY_PERIOD_PROCESSING_DATE_TYPES', {
	payday: 'payday',
	custom: 'custom'
})

// Quarterly/Bi-annual active period options
.constant('QBA_OPTIONS', {
	none: 0,
	payDateOne: 1,
	payDateTwo: 2,
	payDateThree: 3,
	payDateFour: 4
})

.constant('WEEK_NUMBER_OPTIONS_TWO_WEEKLY', [
	{
		description: 'Week 1',
		value: 1
	},
	{
		description: 'Week 2',
		value: 2
	}
])
.constant('WEEK_NUMBER_OPTIONS_FOUR_WEEKLY', [
	{
		description: 'Week 1',
		value: 1
	},
	{
		description: 'Week 2',
		value: 2
	},
	{
		description: 'Week 3',
		value: 3
	},
	{
		description: 'Week 4',
		value: 4
	}
]);

'use strict';

angular.module('paycircleApp')
.constant('PAY_PERIOD_STATES', {
	dataCollection: 0,
	calculate: 1,
	approval: 2,
	run: 3,
	closePeriod: 4
});

'use strict';

/**
 * The variation of pay period types used in Paycircle
 */
angular.module('paycircleApp')
	.constant('PAY_PERIOD_TYPES', {
		weekly: 0,
		fortnightly: 1,
		fourweekly: 2,
		monthly: 3,
		quarterly: 4,
		annually: 5,
		daily: 6,
		biannually: 7
	})
	.constant('PAY_PERIOD_TYPES_OPTIONS', [
		{
			id: 0,
			name: 'Weekly'
		},
		{
			id: 1,
			name: 'Two weekly'
		},
		{
			id: 2,
			name: 'Four weekly'
		},
		{
			id: 3,
			name: 'Monthly'
		},
		{
			id: 4,
			name: 'Quarterly'
		},
		{
			id: 5,
			name: 'Annually'
		},
		/*
			Note no option for 'Daily' here. It can't be selected as a pay period type in the UI, but
			is nevertheless part of the platform PayPeriodType constant.
		 */
		{
			id: 7,
			name: 'Biannually'
		}
	])
	.constant('PAY_PERIOD_TYPES_DESCRIPTIONS', {
		0: 'Weekly',
		1: 'Two weekly',
		2: 'Four weekly',
		3: 'Monthly',
		4: 'Quarterly',
		5: 'Annually',
		6: 'Daily',
		7: 'Biannually'
	}
);

'use strict';

angular.module('paycircleApp')
.constant('PAY_DATE_OPTIONS', {
	weekly: [
		{
			id: 1,
			name: 'Monday',
			order: 0
		},
		{
			id: 2,
			name: 'Tuesday',
			order: 1
		},
		{
			id: 3,
			name: 'Wednesday',
			order: 2
		},
		{
			id: 4,
			name: 'Thursday',
			order: 3
		},
		{
			id: 5,
			name: 'Friday',
			order: 4
		},
		{
			id: 6,
			name: 'Saturday',
			order: 5
		},
		{
			id: 0,
			name: 'Sunday',
			order: 6
		}
	],
	twoweekly: [
		{
			id: 1,
			name: 'Monday',
			order: 0
		},
		{
			id: 2,
			name: 'Tuesday',
			order: 1
		},
		{
			id: 3,
			name: 'Wednesday',
			order: 2
		},
		{
			id: 4,
			name: 'Thursday',
			order: 3
		},
		{
			id: 5,
			name: 'Friday',
			order: 4
		},
		{
			id: 6,
			name: 'Saturday',
			order: 5
		},
		{
			id: 0,
			name: 'Sunday',
			order: 6
		}
	],
	fourweekly: [
		{
			id: 1,
			name: 'Monday',
			order: 0
		},
		{
			id: 2,
			name: 'Tuesday',
			order: 1
		},
		{
			id: 3,
			name: 'Wednesday',
			order: 2
		},
		{
			id: 4,
			name: 'Thursday',
			order: 3
		},
		{
			id: 5,
			name: 'Friday',
			order: 4
		},
		{
			id: 6,
			name: 'Saturday',
			order: 5
		},
		{
			id: 0,
			name: 'Sunday',
			order: 6
		}
	],
	monthly: [
		{
			id: -1,
			name: 'Last day of the month',
			order: -12
		},
		{
			id: -4,
			name: 'Last Monday of the month',
			order: -11
		},
		{
			id: -8,
			name: 'Last Tuesday of the month',
			order: -10
		},
		{
			id: -9,
			name: 'Last Wednesday of the month',
			order: -9
		},
		{
			id: -5,
			name: 'Last Thursday of the month',
			order: -8
		},
		{
			id: -2,
			name: 'Last Friday of the month',
			order: -7
		},
		{
			id: -10,
			name: 'Last Saturday of the month',
			order: -6
		},
		{
			id: -11,
			name: 'Last Sunday of the month',
			order: -5
		},
		{
			id: -3,
			name: 'Last working day of the month',
			order: -4
		},
		{
			id: -6,
			name: '2nd from last working day of the month',
			order: -3
		},
		{
			id: -7,
			name: '3rd from last working day of the month',
			order: -2
		},
		{
			id: -12,
			name: '2nd from last Friday of the month',
			order: -1
		},
		{
			id: 1,
			name: '1st'
		},
		{
			id: 2,
			name: '2nd'
		},
		{
			id: 3,
			name: '3rd'
		},
		{
			id: 4,
			name: '4th'
		},
		{
			id: 5,
			name: '5th'
		},
		{
			id: 6,
			name: '6th'
		},
		{
			id: 7,
			name: '7th'
		},
		{
			id: 8,
			name: '8th'
		},
		{
			id: 9,
			name: '9th'
		},
		{
			id: 10,
			name: '10th'
		},
		{
			id: 11,
			name: '11th'
		},
		{
			id: 12,
			name: '12th'
		},
		{
			id: 13,
			name: '13th'
		},
		{
			id: 14,
			name: '14th'
		},
		{
			id: 15,
			name: '15th'
		},
		{
			id: 16,
			name: '16th'
		},
		{
			id: 17,
			name: '17th'
		},
		{
			id: 18,
			name: '18th'
		},
		{
			id: 19,
			name: '19th'
		},
		{
			id: 20,
			name: '20th'
		},
		{
			id: 21,
			name: '21st'
		},
		{
			id: 22,
			name: '22nd'
		},
		{
			id: 23,
			name: '23rd'
		},
		{
			id: 24,
			name: '24th'
		},
		{
			id: 25,
			name: '25th'
		},
		{
			id: 26,
			name: '26th'
		},
		{
			id: 27,
			name: '27th'
		},
		{
			id: 28,
			name: '28th'
		},
		{
			id: 29,
			name: '29th'
		},
		{
			id: 30,
			name: '30th'
		},
		{
			id: 31,
			name: '31st'
		}
	],
	quarterly: [
		{
			id: -5,
			name: 'Last Thursday of the quarter'
		},
		{
			id: -4,
			name: 'Last Monday of the quarter'
		},
		{
			id: -3,
			name: 'Last working day of the quarter'
		},
		{
			id: -2,
			name: 'Last Friday of the quarter'
		},
		{
			id: -1,
			name: 'Last day of the quarter'
		},
		{
			id: 1,
			name: '1st'
		},
		{
			id: 2,
			name: '2nd'
		},
		{
			id: 3,
			name: '3rd'
		},
		{
			id: 4,
			name: '4th'
		},
		{
			id: 5,
			name: '5th'
		},
		{
			id: 6,
			name: '6th'
		},
		{
			id: 7,
			name: '7th'
		},
		{
			id: 8,
			name: '8th'
		},
		{
			id: 9,
			name: '9th'
		},
		{
			id: 10,
			name: '10th'
		},
		{
			id: 11,
			name: '11th'
		},
		{
			id: 12,
			name: '12th'
		},
		{
			id: 13,
			name: '13th'
		},
		{
			id: 14,
			name: '14th'
		},
		{
			id: 15,
			name: '15th'
		},
		{
			id: 16,
			name: '16th'
		},
		{
			id: 17,
			name: '17th'
		},
		{
			id: 18,
			name: '18th'
		},
		{
			id: 19,
			name: '19th'
		},
		{
			id: 20,
			name: '20th'
		},
		{
			id: 21,
			name: '21st'
		},
		{
			id: 22,
			name: '22nd'
		},
		{
			id: 23,
			name: '23rd'
		},
		{
			id: 24,
			name: '24th'
		},
		{
			id: 25,
			name: '25th'
		},
		{
			id: 26,
			name: '26th'
		},
		{
			id: 27,
			name: '27th'
		},
		{
			id: 28,
			name: '28th'
		}
	],
	annually: [
		{
			id: -5,
			name: 'Last Thursday of the year'
		},
		{
			id: -4,
			name: 'Last Monday of the year'
		},
		{
			id: -3,
			name: 'Last working day of the year'
		},
		{
			id: -2,
			name: 'Last Friday of the year'
		},
		{
			id: -1,
			name: 'Last day of the year'
		},
		{
			id: 1,
			name: '1st'
		},
		{
			id: 2,
			name: '2nd'
		},
		{
			id: 3,
			name: '3rd'
		},
		{
			id: 4,
			name: '4th'
		},
		{
			id: 5,
			name: '5th'
		},
		{
			id: 6,
			name: '6th'
		},
		{
			id: 7,
			name: '7th'
		},
		{
			id: 8,
			name: '8th'
		},
		{
			id: 9,
			name: '9th'
		},
		{
			id: 10,
			name: '10th'
		},
		{
			id: 11,
			name: '11th'
		},
		{
			id: 12,
			name: '12th'
		},
		{
			id: 13,
			name: '13th'
		},
		{
			id: 14,
			name: '14th'
		},
		{
			id: 15,
			name: '15th'
		},
		{
			id: 16,
			name: '16th'
		},
		{
			id: 17,
			name: '17th'
		},
		{
			id: 18,
			name: '18th'
		},
		{
			id: 19,
			name: '19th'
		},
		{
			id: 20,
			name: '20th'
		},
		{
			id: 21,
			name: '21st'
		},
		{
			id: 22,
			name: '22nd'
		},
		{
			id: 23,
			name: '23rd'
		},
		{
			id: 24,
			name: '24th'
		},
		{
			id: 25,
			name: '25th'
		},
		{
			id: 26,
			name: '26th'
		},
		{
			id: 27,
			name: '27th'
		},
		{
			id: 28,
			name: '28th'
		}
	]
})
.constant('PAY_DATE_OPTIONS_IDS', {
	lastDay: -1,
	lastFriday: -2,
	lastWorkingDay: -3,
	lastMonday: -4,
	lastThursday: -5,
	penultimateWorkingDay: -6,
	thirdFromLastWorkingDay: -7,
	lastTuesday: -8,
	lastWednesday: -9,
	lastSaturday: -10,
	lastSundau: -11
});

'use strict';

angular.module('paycircleApp')
.constant('PAYMENT_SCHEDULE_CATEGORIES', {
	statutory: 0,
	repayment: 1,
	childcare: 2,
	car: 3,
	health: 4
});
'use strict';

angular.module('paycircleApp')
.constant('PAYMENT_SCHEDULE_PENSION_OPTIONS', {
	both: 0,
	employee: 1,
	employer: 2
});

'use strict';

angular.module('paycircleApp')
.constant('PAYMENT_STATES', {
	scheduled: 0,
	pending: 1,
	payingOut: 2,
	paid: 3,
	failed: 4,
	resubmitted: 5,
	refunded: 6,
	refundCancelled: 7,
	cancelled: 8,
	freePeriod: 9,
	estimate: 10
});
'use strict';

angular.module('paycircleApp')
.constant('PAYMENT_TYPES', {
	salary: 0,
	hourly: 1,
	net: 2,
	casual: 3
});

'use strict';

angular.module('paycircleApp')
.constant('ALERT_ACTIONS', {
	none: 0,
	submitPension: 2,
	pending: 3,
	goToProfile: 4,
	dismiss: 5,
	goToPensions: 6,
	goToTeam: 7,
	goToBilling: 8,
	goToCompany: 9,
	goToPension: 10,
	viewChanges: 11,
	goToPensionSettings: 12,
	dismissBulk: 13,
	goToHistory: 14,
	goToPendingChanges: 15,
	goToNIUpdates: 16,
	goToSupplementaryPayRuns: 17,
	goToPeopleHrUpdates: 18,
	viewReversedHMRCTaxUpdates: 19,
	goToRotareadyUpdates: 20,
	goToEdpUpdates: 21
})

.constant('ALERT_CATEGORIES', {
	team: 0,
	payroll: 1,
	pension: 2
})

.constant('ALERT_LEVELS', {
	notices: 0,
	warnings: 1,
	errors: 2,
})

.constant('ALERT_TYPES', {
	incompleteProfileGroup: 'e098a502-6b1b-4054-88e6-4965f3dfc547',
	markedAsLeavingGroup: '8e6b2d4a-8bbe-436b-9eff-70388887c435',
	markedAsOnHoldGroup: '718f6207-5859-43a4-8bdc-bd7f8a6f1216',
	missingBankDetailsGroup: '164aba4f-7e3a-4257-83b2-8b9183f82e1c',
	newStarterGroup: '2f74dc83-fefd-473b-8eb3-91c1610ef063',
	omittedFromRTIGroup: '73537791-d64a-4572-a532-dff613c9fe20',
	pendingTaxCodeUpdates: 'b9aced2b-548c-4d23-a3e9-8afd3da40198',
	pensionReenrolment: 'b6c1d487-68b5-4f16-89c1-5ea9275a7a1c'
});

'use strict';

/**
 * Various types of company error states that prevent payroll from being run
 */
angular.module('paycircleApp')
.constant('PAYROLL_ERROR_STATES', {
	none: 0,
	noTeamMembers: 1,
	pensionUnauthorized: 2,
	pensionSubmissionFailure: 3,
	outsideDateRange: 4,
	paymentProcessing: 5,
	paymentOverdue: 6,
	payeSchemeClosed: 7,
	payeCessationDateInFuture: 8,
	pensionSubmissionPending: 9,
	companyArchived: 10,
	pensionNotActive: 11,
	retrospectivePensionIncomplete: 12,
	payeCessationDateInPast: 13,
	demoIncomplete: 14,
	reportsGenerating: 15,
	payslipsGenerating: 16,
	rotareadyCriticalErrors: 17
});

'use strict';

angular.module('paycircleApp')
.constant('PAYROLL_MOVE_STATUSES', {
	None: 0,
	Outward: 1,
	InwardPending: 2,
	InwardComplete: 3
});

'use strict';

angular.module('paycircleApp')
.constant('PAYROLL_MOVE_VALID_STATUSES', {
	IsValid: 0,

	// Payroll related reasons:
	InvalidAsPayrollsOnDifferentPAYESchemes: 1,
	InvalidAsPayrollsInDifferentTaxMonths: 2,
	InvalidAsSamePayroll: 3,

	// Team member related reasons:
	InvalidAsUserHasPaymentScheduleInProgress: 4,
	InvalidAsUserIsLeaver: 5,
	InvalidAsUserIsCIS: 6,
	InvalidAsUserIncomplete: 7,
	InvalidAsUserHasNoNINumber: 8,
	InvalidIsAlreadyPendingMover: 9,
	InvalidAsUserIsExcluded: 10,
	InvalidAsUserHasAOEInProgress: 11,
	InvalidAsUserAlreadyExistsOnTargetPayroll: 12,
	InvalidAsUserNeverPaidOnOriginalPayroll: 13,

	// Cancellation related reasons
	InvalidAsNoPendingMoveToCancel: 14,
	InvalidAsCannotCancelAfterPaymentsMade: 15
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_DELIVERY_METHODS', {
	portal: 1,
	emailPdf: 2,
	print: 4
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_MANAGER_STATE', {
	awaitingUpload: 0,
	notificationsNotSent: 1,
	notificationsSent: 2
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_NOTE_OPTIONS', {
	tags: [
		{
			optionLabel: 'first name',
			optionTheme: 'indifferent',
			optionOutput: 'firstname'
		},
		{
			optionLabel: 'surname',
			optionTheme: 'secondary',
			optionOutput: 'surname'
		},
		{
			optionLabel: 'first name',
			optionTheme: 'indifferent',
			optionOutput: 'first name'
		},
	],
	emoji: [
		{
			optionLabel: '👍',
		    optionOutput: '1F44D'
		},
		{
			optionLabel: '😁',
			optionOutput: '1F600',
		},
		{
			optionLabel: '😎',
			optionOutput: '1F60E'
		},
		{
			optionLabel: '🔥',
			optionOutput: '1F525'
		},
		{
			optionLabel: '👏',
			optionOutput: '1F44F'
		},
		{
			optionLabel: '🚀',
			optionOutput: '1F680'
		},
		{
			optionLabel: '😍',
			optionOutput: '1F60D'
		},
		{
			optionLabel: '👊',
			optionOutput: '1F44A'
		},
		{
			optionLabel: '🍻',
			optionOutput: '1F37B'
		},
		{
			optionLabel: '💜',
			optionOutput: '1F49C'
		},
		{
			optionLabel: '🎂',
			optionOutput: '1F382'
		}
	],
	favourites: [
		{
			optionLabel: 'Happy pay day!',
			optionOutput: 'Happy pay day!'
		},
		{
			optionLabel: 'Thanks for your hard work',
			optionOutput: 'Thanks for your hard work'
		},
		{
			optionLabel: 'You\'ve been paid!',
			optionOutput: 'You\'ve been paid!'
		}
	]
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_PAGINATION', {
	maxLinesFirstPage: 14,
	maxLinesPerPage: 18,
	charsPerLine: 35
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_ADDITIONAL_NOTE_VISIBLE', {
	none: 0,
	all: 1,
	pdfOnly: 2,
	onlineOnly: 4
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_PERIOD_VISIBLE', {
	none: 0,
	all: 1,
	pdfOnly: 2,
	onlineOnly: 4
});

'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_SORT_BY_OPTIONS', [
	{
		id: 0,
		name: 'Payroll ID'
	},
	{
		id: 1,
		name: 'Forename'
	},
	{
		id: 2,
		name: 'Surname'
	}
]);
'use strict';

angular.module('paycircleApp')
.constant('PAYSLIP_TOOLTIPS', {
    onlineView: {
        heading: 'The Online Payslip',
        copy: 'View your payslip in a clear and modern way on any device.',
        buttonText: 'Next',
        showTooltip: true,
        position: 'bottom-far-right tooltip--white-text',
        neverOpenAgain: 'payslipOnlineView',
        footnote: '1 of 2'
    },
    printableView: {
        heading: 'The Formal Payslip',
        copy: 'A standard payslip, ideal for printing or saving as a PDF.',
        buttonText: 'Got it!',
        showTooltip: true,
        position: 'bottom-far-right tooltip--white-text',
        neverOpenAgain: 'payslipPrintableView',
        footnote: '2 of 2'
    },
    download: {
        heading: 'Want to save or print this payslip?',
        copy: 'In the print window select ‘Save as PDF’ or ‘Print to PDF’ depending on the web browser you are using.',
        buttonText: 'Got it!',
        showTooltip: true,
        position: 'bottom-left tooltip--white-text',
        neverOpenAgain: 'payslipDownload'
    }
});

'use strict';

angular.module('paycircleApp')
.constant('PENSION_ENROLMENT_STATES', {
	aboveAgeLimit: 'above age limit',
	canJoin: 'can join',
	canOptIn: 'can opt in',
	ceased: 'ceased',
	deleted: 'deleted',
	eligible: 'eligible',
	enrolled: 'enrolled',
	excluded: 'excluded',
	joined: 'joined',
	notAssessed: 'not assessed',
	notEnrolled: 'not enrolled',
	optedIn: 'opted in',
	optedOut: 'opted out',
	others: 'others',
	postponed: 'postponed',
	reAssessment: 're-assessment',
	rejoined: 'rejoined',
	removed: 'removed',
	voluntary: 'voluntary',
	willBeEnrolled: 'will be enrolled'
});

'use strict';

angular.module('paycircleApp')
.constant('PENSION_GROUP_EARNINGS_LIMITS', {
	notSet: 0,
	lowerEarningsLimit: 1,
	upperEarningsLimit: 2
})
.constant('PENSION_GROUP_EARNINGS_LIMIT_OPTIONS', [
	{
		description: 'Please select...',
		value: 0
	},
	{
		description: 'Lower earnings limit',
		value: 1
	},
	{
		description: 'Upper earnings limit',
		value: 2
	}
]);

'use strict';

angular.module('paycircleApp')
.constant('PENSION_PROVIDER_APIS', {
	none: 0,
	pensionSync: 1,
	nest: 2,
	smart: 3,
	peoplesPension: 4
});
'use strict';

angular.module('paycircleApp')
.constant('PENSION_PROVIDER_IDS', {
	ascotLloyd: '8a096e80-b3f6-4057-ab39-1b4c0dde77e3',
	aviva: '5b3f8939-be0b-4c49-acdf-68d38d818fa0',
	bluesky: 'ec688ece-af54-4761-94ad-12e24b55cf5c',
	corporatePensionsTrust: 'b25bcacd-091c-4e6d-a856-58f442571850',
	creative: 'f1f37d71-9567-4002-bd59-67cf3b912062',
	legalAndGeneral: '02a755ff-90c0-4918-a056-bcc596405d90',
	lgps: 'bb371559-428a-4c4e-bd00-ef1a972f9421',
	nest: '7fe3f4bb-ee03-4bf7-b299-d61e7ff1c36d',
	nhs: 'f7962e3c-77e7-4bca-8018-7ef582093919',
	now: '271d6eb6-06a6-4d4a-bb56-58b57ce3cb4d',
	royalLondon: '37b3a812-b642-405d-a3bd-da8bad58454c',
	scottishWidowsStandard: '826da00e-3187-4b2c-b73e-453715b8c2aa',
	smartPension: '183bc812-620b-49b6-a6ed-b5ce912aa6a6',
	standardLife: 'e94098d8-0902-45d5-9919-bb3ee2ddc844',
	teachersPension: 'b9a68be9-4ebb-4050-8ef6-6aad42d9eb9d',
	theLewisWorkplacePension: 'cbd45ac2-7980-4ddc-b242-2138c198ef8b',
	thePeoplesPension: '0247ca13-bd41-4da8-bafc-effc66ca267f',
	truePotentialInvestment: 'cd6fa448-8eba-493a-a4b1-3e971520561f',
	welplanPensions: '00f67a80-3776-4a67-9b0e-eaf06d5d4047',
	workersPensionTrust: '397e328d-3629-4356-8073-0afbfbf9d79d',
});

'use strict';

angular.module('paycircleApp')
.constant('PENSION_SCHEME_REFERENCE_DISPLAY_TYPES', {
	employerReference: 0,
	educationEmployerNumber: 1
})

.factory('PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS', [
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
function (
	PENSION_SCHEME_REFERENCE_DISPLAY_TYPES
) {
	return [
		{
			id: PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference,
			description: 'Employer pension scheme reference'
		},
		{
			id: PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber,
			description: 'Education employer number'
		}
	];
}]);
'use strict';

angular.module('paycircleApp')
.constant('PENSION_STATES', {
	unauthorised: 'Unauthorised',
	creating: 'Creating',
	pending: 'Pending',
	active: 'Active',
	rejected: 'Rejected',
	inactive: 'Inactive',
	reassessment: 'Reassessment',
	reenrolment: 'Reenrolment'
})
.constant('PENSION_SUBMISSION_STATES', {
	unsubmitted: 0,
	submitting: 1,
	submitted: 2,
	failed: 3,
	pending: 4,
	requesting: 5,
	queued: 6
});

'use strict';

angular.module('paycircleApp')
.constant('PENSION_STATUSES', {
	canJoin: 'can join',
	canOptIn: 'can opt in',
	ceased: 'ceased',
	enrolled: 'enrolled',
	excluded: 'excluded',
	joined: 'joined',
	notEnrolled: 'not enrolled',
	optedIn: 'opted in',
	optedOut: 'opted out',
	postponed: 'postponed',
	reAssessment: 're-assessment',
	willBeEnrolled: 'will be enrolled',
});

'use strict';

angular.module('paycircleApp')
.constant('PENSION_TYPES', {
	// UI-only constant to indicate 'all'
	all: -1,
	// Real, platform-aware types
	autoEnrolment: 0,
	nonAutoEnrolment: 1
});

'use strict';

angular.module('paycircleApp')
	.constant('PEOPLE_HR_UPDATES_EVENT_NAMES', {
		deductionCreated: 'DeductionCreated',
		deductionDeleted: 'DeductionDeleted',
		deductionUpdated: 'DeductionUpdated',
		employeeBankDetailsUpdated: 'EmployeeBankDetailsUpdated',
		employeeContactDetailsUpdated: 'EmployeeContactDetailsUpdated',
		employeeCreated: 'EmployeeCreated',
		employeeDetailsUpdated: 'EmployeeDetailsUpdated',
		employeeLeaver: 'EmployeeLeaver',
		entitlementCreated: 'EntitlementCreated',
		entitlementDeleted: 'EntitlementDeleted',
		entitlementUpdated: 'EntitlementUpdated',
		oneOffDeductionCreated: 'OneOffDeductionCreated',
		oneOffDeductionDeleted: 'OneOffDeductionDeleted',
		oneOffDeductionUpdated: 'OneOffDeductionUpdated',
		oneOffPaymentCreated: 'OneOffPaymentCreated',
		oneOffPaymentDeleted: 'OneOffPaymentDeleted',
		oneOffPaymentUpdated: 'OneOffPaymentUpdated',
		salaryCreated: 'SalaryCreated',
		salaryUpdated: 'SalaryUpdated'
});

'use strict';

angular.module('paycircleApp')
	.constant('PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS', {
		active: 0,
		paused: 1
});
'use strict';

angular.module('paycircleApp')
	.constant('PEOPLE_HR_UPDATES_EVENT_STATUS', {
		// A new event awaiting processing.
		new: 0,
		// The event has caused a failure during processing.
		failed: 2,
		// The event has been successfully processed.
		complete: 3,
		// The event is currently being processed.
		processing: 4,
		// The event was skipped and not processed.
		skipped: 5
});
'use strict';

angular.module('paycircleApp')
	.constant('PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS', {
		// Maps filter keys to backend IntegrationEventStatus enum names
		status: {
			'team-people-hr-updates-status-new': 'New',
			'team-people-hr-updates-status-completed': 'Complete',
				'team-people-hr-updates-status-failed': 'Failed',
			// Retained for forward-compatibility - no UI filter currently renders this key
			'team-people-hr-updates-status-rejected': 'Rejected'
		},
		// Maps filter keys to backend event severity names
		severity: {
			'team-people-hr-updates-severity-info': 'Info',
			'team-people-hr-updates-severity-warning': 'Warning',
			'team-people-hr-updates-severity-error': 'Error'
		},
		// Maps filter keys to backend event Name strings
		type: {
			'team-people-hr-updates-type-deduction-created': 'DeductionCreated',
			'team-people-hr-updates-type-deduction-deleted': 'DeductionDeleted',
			'team-people-hr-updates-type-deduction-updated': 'DeductionUpdated',
			'team-people-hr-updates-type-employee-bank-details-updated': 'EmployeeBankDetailsUpdated',
			'team-people-hr-updates-type-employee-contact-details-updated': 'EmployeeContactDetailsUpdated',
			'team-people-hr-updates-type-employee-created': 'EmployeeCreated',
			'team-people-hr-updates-type-employee-details-updated': 'EmployeeDetailsUpdated',
			'team-people-hr-updates-type-employee-leaver': 'EmployeeLeaver',
			'team-people-hr-updates-type-entitlement-created': 'EntitlementCreated',
			'team-people-hr-updates-type-entitlement-deleted': 'EntitlementDeleted',
			'team-people-hr-updates-type-entitlement-updated': 'EntitlementUpdated',
			'team-people-hr-updates-type-one-off-deduction-created': 'OneOffDeductionCreated',
			'team-people-hr-updates-type-one-off-deduction-deleted': 'OneOffDeductionDeleted',
			'team-people-hr-updates-type-one-off-deduction-updated': 'OneOffDeductionUpdated',
			'team-people-hr-updates-type-one-off-payment-created': 'OneOffPaymentCreated',
			'team-people-hr-updates-type-one-off-payment-deleted': 'OneOffPaymentDeleted',
			'team-people-hr-updates-type-one-off-payment-updated': 'OneOffPaymentUpdated',
			'team-people-hr-updates-type-salary-created': 'SalaryCreated',
			'team-people-hr-updates-type-salary-updated': 'SalaryUpdated'
		}
	});

'use strict';

// Action group names need to match returned value from server for Permissions to map correctly
const PERMISSION_ACTIONS = {
	Admin: {
		canManageCompanies: 1, // 1
		// 1 << 1 - Moved to Company Settings
		// 1 << 2 - Moved to Company Settings
		canManageCompanyGroups: 1 << 3, // 8
		canManageCompanyGroupAdmins: 1 << 4, // 16
		canManageCompanyGroupSettings: 1 << 5, // 32
		canManageBureauAdmins: 1 << 6, // 64
		canManageBureauSettings: 1 << 7, // 128
		canManageEmailNotifications: 1 << 8, // 256
		canManageAccess: 1 << 9,  // 512
		canManageBacsDownloads: 1 << 10, // 1024,
		canManageMentionsAccess: 1 << 12, // 4096
		canDuplicatePayElements: 1 << 13, // 8192
		canDeleteDuplicatedPayElements: 1 << 14, // 16384
		canManagePayElementPacks: 1 << 15, // 32768
	},
	History: {},
	Payroll: {
		canUpdateAdjustments: 1, // 1
		// 1 << 1 - Moved to Team 256
		canCalculatePayroll: 1 << 2, // 4
		canRunPayroll: 1 << 3, // 8
		canUpdatePayslipNotes: 1 << 4, // 16
		canUpdateStatutoryPayments: 1 << 5, // 32
		canMakePreviousYearUpdates: 1 << 6, // 64
		canUpdateAOE: 1 << 7, // 128
		canUpdateRepaymentSchedules: 1 << 8, // 256
		// 1 << 9 - Moved to Team 32
		canRollbackPayroll: 1 << 10, // 1024
		canUpdateTaxUpdates: 1 << 11, // 2048
		canManageAlerts: 1 << 12, // 4096
		canUpdateNotes: 1 << 13, // 8192
		canUpdateTasks: 1 << 14, // 16384
		canUpdateImports: 1 << 15, // 32768
		canEditChangesTable: 1 << 16, // 65536,
		canEditPayStatementPreviewFigures: 1 << 17, // 131072
		canAddHourlyTotals: 1 << 18, // 262144
		canAddLinkRates: 1 << 19, // 524288
		canViewChanges: 1 << 20, // 1048576
	},
	Pension: {
		// 1 - Moved to Team 1024
		canUpdateTeamPensionComms: 1 << 1, // 2
	},
	Reports: {},
	Team: {
		canAddDeleteTeamMembers: 1, // 1
		// 2 - Moved to HR 4
		canInviteTeamMembersToRegister: 1 << 2, // 4
		canManageLeavers: 1 << 3, // 8,
		canEditPersonalDetails: 1 << 4, // 16
		canUpdateYTDsPostSetup: 1 << 5,  // 32
		canEditTaxStatus: 1 << 6, // 64,
		canEditCompanyDetails: 1 << 7,  // 128,
		canEditPayInformation: 1 << 8, // 256,
		canEditContinuousEmployment: 1 << 9, // 512
		canUpdateTeamPensionSettings: 1 << 10, // 1024
		canEditNewStarterInformation: 1 << 11, // 2048
		canImportTeamData: 1 << 12, // 4096
	},
	CompanySettings: {
		canAccessGeneral: 1, // 1,
		canAccessPayroll: 1 << 1, // 2
		canAccessPermissions: 1 << 2, // 4,
		canAccessReports: 1 << 3, // 8,
		canAccessModules: 1 << 4, // 16,
		canAccessNotifications: 1 << 5, // 32
		canAccessPensionSettings : 1 << 6, // 64
		canAccessEmployeePortal : 1 << 7, // 128
		canAccessImports : 1 << 8, // 256
		canAccessFiles : 1 << 9, // 512
		canAccessInternational  : 1 << 10, // 1024
	},
	HR: {
		canManageJobGrades: 1, // 1,
		canManagePolicies: 1 << 1, // 2
		canManageTeamHR: 1 << 2, // 4
	}
};

const PERMISSION_ROLE_IDS = {
	superUser: 0,
	teamMember: 1,
	companyAdmin: 2,
	groupAdmin: 3,
	companyadministratorlite: 4,
	departmentadmin: 5,
	groupAdminLite: 6
};

const PERMISSION_GROUP_KEYS = {
	Payroll: 0,
	Pension: 1,
	Team: 2,
	Reports: 3,
	Admin: 4,
	History: 5,
	CompanySettings: 6,
	HR: 7
};

angular.module('paycircleApp')

.constant('PERMISSION_ACTIONS', PERMISSION_ACTIONS)

.constant('PERMISSION_GROUP_KEYS', PERMISSION_GROUP_KEYS)

.constant('PERMISSION_ACTION_GROUPS', [
	{
		groupKey: PERMISSION_GROUP_KEYS.Payroll,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'Payroll',
		GroupPermissionActions: [
			{
				Description: 'Add, edit and delete changes',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateAdjustments,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Calculate and preview payroll',
				Value: PERMISSION_ACTIONS.Payroll.canCalculatePayroll,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Run payroll',
				Value: PERMISSION_ACTIONS.Payroll.canRunPayroll,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'View and update payslip notes',
				Value: PERMISSION_ACTIONS.Payroll.canUpdatePayslipNotes,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Update statutory payments',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateStatutoryPayments,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Make previous year updates',
				Value: PERMISSION_ACTIONS.Payroll.canMakePreviousYearUpdates,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Manage Attachment of Earnings',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateAOE,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Manage repayment schedules',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateRepaymentSchedules,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Roll back pay periods',
				Value: PERMISSION_ACTIONS.Payroll.canRollbackPayroll,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'View and get tax updates',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateTaxUpdates,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'View and manage alerts',
				Value: PERMISSION_ACTIONS.Payroll.canManageAlerts,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'View and edit notes',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateNotes,
				lockedFor: [PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite]
			},
			{
				Description: 'View and edit tasks',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateTasks,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Add, edit and delete imports',
				Value: PERMISSION_ACTIONS.Payroll.canUpdateImports,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Edit changes table',
				Value: PERMISSION_ACTIONS.Payroll.canEditChangesTable,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite]
			},
			{
				Description: 'Edit pay statement preview figures',
				Value: PERMISSION_ACTIONS.Payroll.canEditPayStatementPreviewFigures,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Add hourly totals',
				Value: PERMISSION_ACTIONS.Payroll.canAddHourlyTotals,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite]
			},
			{
				Description: 'Add link rates',
				Value: PERMISSION_ACTIONS.Payroll.canAddLinkRates,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite]
			},
			{
				Description: 'View changes tab',
				Value: PERMISSION_ACTIONS.Payroll.canViewChanges,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite]
			}
		]
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.Pension,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'Pension',
		GroupPermissionActions: [
			// {
			// 	Description: 'Update team member pensions',
			// 	Value: PERMISSION_ACTIONS.Pension.canUpdateTeamPensionSettings,
			// 	showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			// },
			{
				Description: 'Manage team pension communications',
				Value: PERMISSION_ACTIONS.Pension.canUpdateTeamPensionComms,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			}
		]
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.Team,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'Team',
		GroupPermissionActions: [
			{
				Description: 'Add and delete team members',
				Value: PERMISSION_ACTIONS.Team.canAddDeleteTeamMembers,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			// {
			// 	Description: 'Manage holiday and sickness',
			// 	Value: PERMISSION_ACTIONS.Team.canManageTeamHR,
			// 	showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			// },
			{
				Description: 'Send registration invites, unregister team members',
				Value: PERMISSION_ACTIONS.Team.canInviteTeamMembersToRegister,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Update leavers',
				Value: PERMISSION_ACTIONS.Team.canManageLeavers,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit personal details post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditPersonalDetails,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit Year to Dates post-setup',
				Value: PERMISSION_ACTIONS.Team.canUpdateYTDsPostSetup,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit tax status post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditTaxStatus,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit company details post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditCompanyDetails,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit pay information post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditPayInformation,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit continuous employment post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditContinuousEmployment,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Update team member pensions post-setup',
				Value: PERMISSION_ACTIONS.Team.canUpdateTeamPensionSettings,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Edit new starter information post-setup',
				Value: PERMISSION_ACTIONS.Team.canEditNewStarterInformation,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			},
			{
				Description: 'Import team data',
				Value: PERMISSION_ACTIONS.Team.canImportTeamData,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.departmentadmin]
			}
		]
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.Reports,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
		GroupName: 'Reports',
		GroupPermissionActions: []
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.Admin,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'Admins',
		GroupPermissionActions: [
			{
				Description: 'Add, edit and delete companies',
				Value: PERMISSION_ACTIONS.Admin.canManageCompanies,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin]
			},
			// {
			// 	Description: 'Manage company admins',
			// 	Value: PERMISSION_ACTIONS.Admin.canManageCompanyAdmins,
			// 	showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.groupAdmin]
			// },
			// {
			// 	Description: 'Manage company settings',
			// 	Value: PERMISSION_ACTIONS.Admin.canManageCompanySettings,
			// 	showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.groupAdmin]
			// },
			{
				Description: 'Add, edit and delete company groups',
				Value: PERMISSION_ACTIONS.Admin.canManageCompanyGroups,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Manage company group admins',
				Value: PERMISSION_ACTIONS.Admin.canManageCompanyGroupAdmins,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Update company group settings',
				Value: PERMISSION_ACTIONS.Admin.canManageCompanyGroupSettings,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Manage bureau team',
				Value: PERMISSION_ACTIONS.Admin.canManageBureauAdmins,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Update bureau settings',
				Value: PERMISSION_ACTIONS.Admin.canManageBureauSettings,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Manage email notifications',
				Value: PERMISSION_ACTIONS.Admin.canManageEmailNotifications,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Manage bureau access',
				Value: PERMISSION_ACTIONS.Admin.canManageAccess,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Manage BACS downloads',
				Value: PERMISSION_ACTIONS.Admin.canManageBacsDownloads,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Manage mentions access',
				Value: PERMISSION_ACTIONS.Admin.canManageMentionsAccess,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Duplicate pay elements',
				Value: PERMISSION_ACTIONS.Admin.canDuplicatePayElements,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Delete duplicated pay elements',
				Value: PERMISSION_ACTIONS.Admin.canDeleteDuplicatedPayElements,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			},
			{
				Description: 'Manage pay element packs',
				Value: PERMISSION_ACTIONS.Admin.canManagePayElementPacks,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember]
			}
		]
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.History,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin, PERMISSION_ROLE_IDS.groupAdminLite, PERMISSION_ROLE_IDS.companyadministratorlite],
		GroupName: 'History',
		GroupPermissionActions: []
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.CompanySettings,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'Company Settings',
		GroupPermissionActions: [
			{
				Description: 'General',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessGeneral,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Payroll',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessPayroll,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Access & Permissions',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessPermissions,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Reports & Journals',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessReports,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Modules & Integrations',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessModules,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Notifications',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessNotifications,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Pension Settings',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessPensionSettings,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Employee Portal',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessEmployeePortal,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Imports',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessImports,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'Files',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessFiles,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
			{
				Description: 'International',
				Value: PERMISSION_ACTIONS.CompanySettings.canAccessInternational,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin]
			},
		]
	},
	{
		groupKey: PERMISSION_GROUP_KEYS.HR,
		showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		showVisibilityToggleFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
		GroupName: 'HR',
		GroupPermissionActions: [
			{
				Description: 'Manage job grades',
				Value: PERMISSION_ACTIONS.HR.canManageJobGrades,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
			},
			{
				Description: 'Manage policies',
				Value: PERMISSION_ACTIONS.HR.canManagePolicies,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
			},{
				Description: 'Manage holiday and sickness',
				Value: PERMISSION_ACTIONS.HR.canManageTeamHR,
				showFor: [PERMISSION_ROLE_IDS.superUser, PERMISSION_ROLE_IDS.teamMember, PERMISSION_ROLE_IDS.companyAdmin, PERMISSION_ROLE_IDS.groupAdmin],
			}
		]
	}
])

.constant('PERMISSION_ROLES', {
	[PERMISSION_ROLE_IDS.superUser]: 'Super user',
	[PERMISSION_ROLE_IDS.teamMember]: 'Team member',
	[PERMISSION_ROLE_IDS.companyAdmin]: 'Company admin',
	[PERMISSION_ROLE_IDS.groupAdmin]: 'Group admin',
	[PERMISSION_ROLE_IDS.groupAdminLite]: 'Group admin lite',
	[PERMISSION_ROLE_IDS.companyadministratorlite]: 'Company admin lite',
	[PERMISSION_ROLE_IDS.departmentadmin]: 'Department admin'
})

.constant('PERMISSION_ROLES_ORDER', {
	[PERMISSION_ROLE_IDS.superUser]: 0,
	[PERMISSION_ROLE_IDS.teamMember]: 1,
	[PERMISSION_ROLE_IDS.groupAdmin]: 2,
	[PERMISSION_ROLE_IDS.groupAdminLite]: 3,
	[PERMISSION_ROLE_IDS.companyAdmin]: 4,
	[PERMISSION_ROLE_IDS.companyadministratorlite]: 5,
	[PERMISSION_ROLE_IDS.departmentadmin]: 6
})

.constant('PERMISSION_ROLES_DESCRIPTIONS', {
	[PERMISSION_ROLE_IDS.superUser]: 'This role has the highest permission level settings. Super users are account owners and have access to everything including managing other admins and their permission levels.',
	[PERMISSION_ROLE_IDS.teamMember]: 'This role has high permission level settings. Bureau team members have access to everything except managing other bureau admins and their permission levels.',
	[PERMISSION_ROLE_IDS.companyAdmin]: 'This role has medium permission level settings. Company admins can perform basic payroll actions but cannot authorise payroll or submit payroll data to HMRC unless given permission to do so.',
	[PERMISSION_ROLE_IDS.groupAdmin]: 'This role has medium permission level settings. Group admins can perform all viewing actions and basic payroll actions. Specific permissions for group admins can be set by Super users.',
	[PERMISSION_ROLE_IDS.groupAdminLite]: 'This role has low permission level settings.',
	[PERMISSION_ROLE_IDS.companyadministratorlite]: 'This role has low permission level settings.',
	[PERMISSION_ROLE_IDS.departmentadmin]: 'This role has low permission level settings. Department admins can only view the Team area and view and edit team member profiles for payroll departments they’ve been given access to. They don’t have access to payroll.'
})

.constant('PERMISSION_ROLE_IDS', PERMISSION_ROLE_IDS)

.constant('PERMISSION_TYPES', {
	all: 0,
	hasAddTaskPermission: 1
});

'use strict';

angular.module('paycircleApp')
    .constant('PLACEHOLDERS', {
        email: 'user@domain.com',
        vatNumber: 'GB999999973'
    });
'use strict';

angular.module('paycircleApp')
.constant('PLAYGROUND_CREDENTIALS', {
	accountsOffice: '635PC00000000',
	taxOffice: '867',
	taxOfficeReference: 'A867',
	utr: '4325648151'
});

'use strict';

angular.module('paycircleApp')

.constant('POLICY_BAND_ASSIGNMENTS', {
	none: 0,
	manually: 1,
	dynamically: 2,
	fteSalary: 3
})

.constant('POLICY_BAND_CALCULATION_TYPES', {
	none: 0,
	pensionablePayForPeriod: 1,
	pensionablePayAnnualisedForPeriod: 2,
	fteSalary: 3,
	manual: 4
})

.factory('POLICY_BAND_CALCULATION_TYPE_OPTIONS', [
	'POLICY_BAND_CALCULATION_TYPES',
	function (
		POLICY_BAND_CALCULATION_TYPES
	) {

	return {
		[POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod]: 'Based on pensionable pay for period',
		[POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod]: 'Based on annualised pensionable pay for period',
		[POLICY_BAND_CALCULATION_TYPES.fteSalary]: 'Based on full-time equivalent salary',
		[POLICY_BAND_CALCULATION_TYPES.manual]: 'Manually',
	};
}])

.factory('POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS', [
	'POLICY_BAND_CALCULATION_TYPES',
	function (
		POLICY_BAND_CALCULATION_TYPES
	) {

	return {
		[POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod]: 'Pensionable pay for period',
		[POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod]: 'Annualised pensionable pay for period',
		[POLICY_BAND_CALCULATION_TYPES.fteSalary]: 'Full-time equivalent salary',
		[POLICY_BAND_CALCULATION_TYPES.manual]: 'Manual',
	};
}])

.constant('POLICY_BAND_PAY_LIMIT_TYPES', {
	none: 0,
	fullPay: 1,
	fullPayCombined: 2
})

.factory('POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS', [
	'POLICY_BAND_PAY_LIMIT_TYPES',
	function (
		POLICY_BAND_PAY_LIMIT_TYPES
	) {

	return [
		{ value: POLICY_BAND_PAY_LIMIT_TYPES.none, label: 'No cap' },
		{ value: POLICY_BAND_PAY_LIMIT_TYPES.fullPay, label: 'Cap occupational pay at full pay' },
		{ value: POLICY_BAND_PAY_LIMIT_TYPES.fullPayCombined, label: 'Cap combined pay at full pay' }
	];
}])

.constant('POLICY_BAND_RATE_SCOPES', {
	none: 0,
	employee: 1,
	employer: 2,
	both: 3
})

.constant('POLICY_BAND_RATE_TYPES', {
	none: 0,
	percentage: 1,
	fixedValue: 2
})

.constant('POLICY_BAND_STAT_PAYMENT_TYPES', {
	none: 0,
	only: 1,
	additional: 2,
	included: 3
})

/* Policy categories to group together policy types that belong in the same category; e.g. 'Parental' policy group type
   includes both maternity and paternity policy types. */
.constant('POLICY_CATEGORIES', {
	pay: 'pay',
	parental: 'parental',
	pension: 'pension',
	sickness: 'sickness'
})

.constant('POLICY_PAY_BASES', {
	none: 0,
	annualSalary: 1,
	annualAllowance: 2,
	averageWeeklyPercent: 3,
	annualSalaryPercent: 4,
	fixedAmount: 5
})

.constant('POLICY_PENSION_STATES', {
	notSet: 0,
	active: 1,
	inactive : 2
})

.constant('POLICY_QUALIFY_CRITERIA', {
	none: 0,
	smpRequired: 1
})

.constant('POLICY_SERVICE_ENTITLEMENTS', {
	none: 0,
	serviceFromStartDate: 1,
	serviceContinuous: 2
})

.constant('POLICY_STATES', {
	all: -1,
	active: 0,
	inactive: 1,
	update: 2
})

.constant('POLICY_TYPES', {
	all: -1,
	pay: 0,
	maternity: 1,
	paternity: 2,
	adoption: 3,
	sickness: 4,
	pension: 5,
	holiday: 6
})

// Map policy types to categories.
.factory('POLICY_CATEGORY_TYPES', [
	'POLICY_TYPES',
	'POLICY_CATEGORIES',
function (
	POLICY_TYPES,
	POLICY_CATEGORIES
) {
	return {
		[POLICY_CATEGORIES.pay]: [POLICY_TYPES.pay],
		[POLICY_CATEGORIES.parental]: [POLICY_TYPES.maternity, POLICY_TYPES.paternity],
		[POLICY_CATEGORIES.pension]: [POLICY_TYPES.pension],
		[POLICY_CATEGORIES.sickness]: [POLICY_TYPES.sickness]
	};
}])

.factory('POLICY_TYPE_NAMES', [
	'POLICY_TYPES',
function (
	POLICY_TYPES
) {
	return {
		[POLICY_TYPES.pay]: 'Pay',
		[POLICY_TYPES.maternity]: 'Maternity',
		[POLICY_TYPES.paternity]: 'Paternity',
		[POLICY_TYPES.adoption]: 'Adoption',
		[POLICY_TYPES.sickness]: 'Sickness',
		[POLICY_TYPES.pension]: 'Pension',
		[POLICY_TYPES.holiday]: 'Holiday'
	};
}])

.constant('POLICY_YEAR_BASES', {
	none: 0,
	taxYear: 1,
	calendarYear: 2,
	rollingYear: 3
})

.factory('POLICY_PAY_BASES_DESCRIPTIONS', [
	'POLICY_PAY_BASES',
function (
	POLICY_PAY_BASES
) {
	return {
		[POLICY_PAY_BASES.none]: 'None',
		[POLICY_PAY_BASES.annualSalary]: 'Annual salary',
		[POLICY_PAY_BASES.annualAllowance]: 'Annual allowance',
		[POLICY_PAY_BASES.averageWeeklyPercent]: 'Percentage of average weekly earnings',
		[POLICY_PAY_BASES.annualSalaryPercent]: 'Percentage of annual salary',
		[POLICY_PAY_BASES.fixedAmount]: 'Fixed amount',
	};
}])

.factory('POLICY_YEAR_BASES_DESCRIPTIONS', [
	'POLICY_YEAR_BASES',
function (
	POLICY_YEAR_BASES
) {
	return {
		[POLICY_YEAR_BASES.none]: 'None',
		[POLICY_YEAR_BASES.taxYear]: 'Fixed year (1 Apr - 31 Mar)',
		[POLICY_YEAR_BASES.calendarYear]: 'Fixed year (1 Jan - 31 Dec)',
		[POLICY_YEAR_BASES.rollingYear]: 'Rolling year'
	};
}]);

'use strict';

angular.module('paycircleApp')
.constant('PRESET_FILTER_KEYS', {
	company: {
		livePayrollsDueThisWeek: 'live-payrolls-due-this-week',
		livePayrollsOverdue: 'live-payrolls-overdue',
		livePayrollsFailed: 'live-payrolls-failed',
		livePensionSubmissionsFailed: 'live-pension-submissions-failed'
	},
	team: {
		incompleteProfiles: 'incomplete-profiles',
		missingBankDetails: 'missing-bank-details',
		markedAsLeaving: 'marked-as-leaving',
		newStarters: 'new-starters',
		markedAsOnHold: 'marked-as-on-hold',
		isExcludedFromRti: 'team-status-excluded-from-rti'
	}
});

'use strict';

angular.module('paycircleApp')
.constant('PRO_RATION_METHODS', {
	companySetting: 0,
	period: 1,
	manual: 2
});

'use strict';

angular.module('paycircleApp')
.constant('REFERENCE_PERIOD_OFFSET_ANCHORS', {
	payDate: 1,
	payPeriodStartDate: 2,
	payPeriodEndDate: 3
})
.constant('REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY', {
	1: 'Pay date',
	2: 'Start date',
	3: 'End date'
})
.factory('REFERENCE_PERIOD_OFFSET_ANCHOR_OPTIONS', [
	'REFERENCE_PERIOD_OFFSET_ANCHORS',
	'REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY',
function (
	REFERENCE_PERIOD_OFFSET_ANCHORS,
	REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY
) {
	return [
		{
			id: REFERENCE_PERIOD_OFFSET_ANCHORS.payDate,
			description: REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY[REFERENCE_PERIOD_OFFSET_ANCHORS.payDate]
		},
		{
			id: REFERENCE_PERIOD_OFFSET_ANCHORS.payPeriodStartDate,
			description: REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY[REFERENCE_PERIOD_OFFSET_ANCHORS.payPeriodStartDate]
		},
		{
			id: REFERENCE_PERIOD_OFFSET_ANCHORS.payPeriodEndDate,
			description: REFERENCE_PERIOD_OFFSET_ANCHORS_DISPLAY[REFERENCE_PERIOD_OFFSET_ANCHORS.payPeriodEndDate]
		}
	];
}]);

'use strict';

angular.module('paycircleApp')
.constant('REFERENCE_PERIOD_OFFSET_TARGETS', {
	end: 1,
	start: 2
})
.constant('REFERENCE_PERIOD_OFFSET_TARGETS_DISPLAY', {
	1: 'End date',
	2: 'Start date'
})
.factory('REFERENCE_PERIOD_OFFSET_TARGET_OPTIONS', [
	'REFERENCE_PERIOD_OFFSET_TARGETS',
	'REFERENCE_PERIOD_OFFSET_TARGETS_DISPLAY',
function (
	REFERENCE_PERIOD_OFFSET_TARGETS,
	REFERENCE_PERIOD_OFFSET_TARGETS_DISPLAY
) {
	return [
		{
			id: REFERENCE_PERIOD_OFFSET_TARGETS.end,
			description: REFERENCE_PERIOD_OFFSET_TARGETS_DISPLAY[REFERENCE_PERIOD_OFFSET_TARGETS.end]
		},
		{
			id: REFERENCE_PERIOD_OFFSET_TARGETS.start,
			description: REFERENCE_PERIOD_OFFSET_TARGETS_DISPLAY[REFERENCE_PERIOD_OFFSET_TARGETS.start]
		}
	];
}]);

'use strict';

angular.module('paycircleApp')
.constant('REFERENCE_PERIODS_PATTERNS', {
	none: 0,
	fourFourFive: 1,
	fourFiveFour: 2,
	fiveFourFour: 3,
	offset: 4
})
.constant('REFERENCE_PERIODS_PATTERNS_DISPLAY', {
	0: 'None',
	1: '4-4-5',
	2: '4-5-4',
	3: '5-4-4',
	4: 'Offset'
});


'use strict';

angular.module('paycircleApp')
.constant('REGEX', {

	accountsOfficeRef:				/^[0-9]{3}P[A-Z]\d{7}[0-9X]$/,
	bacsBun: 						/^(B[(0-9)]{5})$/i,
	bic:							/^([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)$/, // https://www.regextester.com/98275
	businessCodeNarrative: 			/^[\A-Za-z0-9&'@.()%,-\s]*$/, // Same as description, without forward slash
	carMakeModel: 					/^[A-Za-z0-9 \(\)\-\./]*$/,
	cisVerification: 				/^V[0-9]{10}[A-HJ-NP-Z]{0,2}$/,
	companyName: 					/^[\A-Za-z0-9&@$£€()./'-\s]*$/,
	companyNumber: 					/^([1-9]\d{6,7}|\d{6,7}|(SC|NI|AC|FC|GE|GN|GS|IC|IP|LP|NA|NF|NL|NO|NP|NR|NZ|OC|R|RC|SA|SF|SI|SL|SO|SP|SR|SZ|ZC|)\d{6,8})$/,
	customerCode: 					/^.{1,15}$/,
	date: 							/^(3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4}$/,
	dateDay: 						/^(3[01]|[12][0-9]|0[1-9])$/,
	dateIso:						/^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}Z$/,
	dateMonth: 						/^(1[0-2]|0[1-9])$/,
	dateMonthYear: 					/^(1[0-2]|0[1-9])\/[0-9]{4}$/,
	dateYear: 						/^[0-9]{4}$/,
	decimal: 						/^(?:\d*\.\d{1,2}|\d+)$/,
	decimalFourPlaces:				/^(?:\d*\.\d{1,4}|\d+)$/,
	description: 					/^[\A-Za-z0-9&'@.()%,/-\s]*$/,
	genericCharacter:				/^[\x20-\xFF]+$/,
	email: 							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // Variation: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	emojis: 						/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g,
	fileExtension: 					/(?:\.([^.]+))?$/,
	guid: 							/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
	hex: 							/^#(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/,
	intercomAppId: 					/^[A-Za-z0-9]{8}$/,
	integersOnly:					/^[-+]?\d+$/,
	ipAddress:                      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
	lettersAndNumbers: 				/^[\A-Za-z0-9\s]*$/,
    lettersOnly: 					/^[\A-Za-z\s]*$/,
    lettersNumbersAndSymbols:       /^[\A-Za-z0-9\-\+\&\s]+$/,       // Letters, numbers and +,-,&
	mention: 						/\[@(.*?)\]/g,
	name:                   		/^[\A-Za-z'-\s\u00C0-\u017F]+$/, // Letters, apostrophes (e.g. O'Reilly), hyphens (e.g. Thompson-Smith) and accents (e.g. Zoë François)
	NI: 							/^$|\s|(([ACEHJLMOPRSWXY][A-CEGHJ-NPR-TW-Z])|(B[A-CEHJ-NPR-TW-Z])|(G[ACEGHJ-NPR-TWZ])|([KT][A-CEGHJ-MPR-TW-Z])|(N[A-CEGHJL-NPR-SW-Z])|(Z[A-CEGHJ-NPR-TW-Y]))[0-9]{6}[A-D]?$/i,
	number:							/\d+/,
	numberMax100:					/^[1-9][0-9]?$|^100$/,
	number4Digits:					/^\d{0,4}$/,
	number4Digits2Decimal:			/^0*\d{0,4}(\.\d{1,2})?$/,
	number5Digits:					/^\d{0,5}$/,
	number5Digits2Decimal:			/^0*\d{0,5}(\.\d{1,2})?$/,
	number6Digits2Decimal:			/^0*\d{0,6}(\.\d{1,2})?$/,
	number6Digits2DecimalAllowNegative:			/^-?0*\d{0,6}(\.\d{1,2})?$/,
	number7Digits2Decimal:			/^0*\d{0,7}(\.\d{1,2})?$/,
	number7Digits4Decimal:			/^0*\d{0,7}(\.\d{1,4})?$/,
	number8Digits2Decimal:			/^0*\d{0,8}(\.\d{1,2})?$/,
	number9Digits2Decimal:			/^0*\d{0,9}(\.\d{1,2})?$/,
	number9Digits2DecimalAllowNegative:			/^-?0*\d{0,9}(\.\d{1,2})?$/,
	number9DigitsAllowNegative:		/^-?\d{0,9}$/,
	number10Digits2Decimal:			/^0*\d{0,10}(\.\d{1,2})?$/,
	numbersOnly: 					/^-?\d*(\.\d+)?$/,
	numbersPositive: 				/^([.]\d+|\d+[.]?\d*){1,}$/,
	numbersPositiveWhole: 			/^(\d+|\d+?\d*){1,}$/,
	passwordStrengthMedium: 		/^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
	passwordStrengthStrong: 		/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
	payeRefA: 						/^[0-9]{3}$/,
	payeRefB: 						/^[0-9a-zA-Z]+$/,
	postcode: 						/^(GIR ?0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?)|[0-9][A-HJKPS-UW]) ?[0-9][ABD-HJLNP-UW-Z]{2})$/i,
	passport: 						/^[\A-Za-z0-9]{9}$/,
	sortcode: 						/^[0-9]{6}?$/,
	taxcodenumber: 					/^[s S 0-9]*$/,
	telephone: 						/^[0-9 ]+$/,
	tprLetterCode: 					/^1([0-9])\d{8}$/,
	utr:							/^[0-9]{10}$/,
	vat: 							/^([GB])*(([1-9]\d{8})|([1-9]\d{11})|(GD[1-9]\d{2})|(HA[1-9]\d{2}))$/,
	verificationCode:				/^[A-Za-z0-9]{6}$/,
	webAddress:						/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
});

'use strict';

angular.module('paycircleApp')
.constant('REGISTRATION_INVITATION_STATUSES', {
	ok: 0,
	notFound: 1,
	expired: 2,
	revoked: 3,
	attemptsExceeded: 4
});

'use strict';

angular.module('paycircleApp')
.constant('REPAYMENT_SCHEDULE_TYPES', {
	carBenefitInKind: '61c4e5dd-7682-4a68-86fe-9c655803b9f5',
	childcareVouchers: '25433c7d-1b10-4971-a9eb-10800de3a8b6',
	companyLoan: 'b00c5f48-4a23-4d54-9932-cec4049723a0',
	cycleToWorkScheme: '4fb9214c-e66b-4ae0-9245-27b7fb412281',
	healthcare: 'dd4869bb-22a5-4293-96cc-06bdaafc97ae',
	seasonTicketLoan: 'b36c3ba5-2925-4515-b7d3-cc871362b101',

	// Statutory adjustments
	adoptionPay: '56fab1b5-7c08-4c27-8ec3-3f4dedb3a7c9',
	bereavementPay: '744ff0ab-4cd0-4a6f-b25f-3afb3501f305',
	maternityPay: '4ce404cf-785d-49fb-9ae8-5b0eaaf83869',
	neonatalCarePay: 'cece435c-4a81-4424-a23d-76b57e47d570',
	paternityPay: 'e978d04f-8498-4145-9d24-524fa94922c0',
	sharedParentalPay: '2fe4cab5-3583-4959-a019-f9f1d7d54846',
	sickPay: '9dbc2615-3556-4328-aaa1-52b8643a2aca',

	// Occupational adjustments
	occupationalAdoptionPay: '2769b255-50a7-49c5-92d6-0788eead794f',
	occupationalBereavementPay: '8fff1195-e56b-4816-bfe8-ab713075adb1',
	occupationalMaternityPay: 'a6889a55-8dd5-429d-8533-c692ead2b052',
	occupationalNeonatalCarePay: 'a7a68824-4949-4bc5-9828-1917d4cc6c92',
	occupationalPaternityPay: '9f7ec3b1-359c-4429-a741-87cacb171033',
	occupationalSharedParentalPay: '9b683370-0e12-429f-b098-1ac6f0a7f46d',
	occupationalSickPay: 'ae9ec2a6-a3b7-4fc0-a608-032cb8fbc9f1'
});

'use strict';

const REPORT_CELL_TYPE = {
	string: 0,
	decimal: 1,
	currency: 2,
	person: 3,
	date: 4,
	dateTime: 5
};

const REPORT_CLASSIC_CATEGORY_IDS = {
	p32Report: 'dd6e3df6-c4db-4afb-99a2-9e8aa5401261',
	payrollSummary: '17ec186d-d607-4bba-a86b-1e9666254d2c',
	pensionReport: 'ba90229d-0c78-4340-a13c-a6f21e64009c',
	payslip: '4b582a96-4167-420f-b8af-5abaed06dd40',
	cisStatement: '92fd7bcc-15b8-4e7b-965c-fa3f6f64ea91',
	p60: '4e00e6fe-1f61-4407-9d4d-1903587f9280',
	payDashboard: 'd41384c0-3b9c-469a-8e02-75b307527d65',
	employeeDetails: 'c8e9c440-8c96-4123-93b5-f2431f3543df',
	ytdExport: '87245a37-bd58-4c3e-bfd3-6cd6a3850c67',
	pensionPAPDIS: 'c6600649-ed19-4609-8934-2af4a952ee9e',
	cjrsReport: 'b0a1c348-e596-485d-991d-8b32e0df4dec',
};

const REPORT_TEMPLATE_IDS = {
	averagePayReport: '4d421660-5c91-4c1d-8be4-c81c75b37d62',
	bacs: 'b71fd66f-6eac-40ce-b626-bee2d3fd694d',
	comparisonReport: 'bca5ecee-f47e-4aa4-94dd-a9157970da99',
	employeeDetails: '107fabbd-8626-441d-ba2f-4b5891af0b9d',
	eps: '82f445cc-9001-4872-bd41-cef209f688a5',
	journalXeroReport: '3b7e20cc-af9a-4700-9e6e-4e66fe930a99',
	manualPayments: '3e646a84-b2a1-48c1-8789-cd39ba755389',
	p32Report: '51227cb5-cbff-452d-8ac9-fa0c6a049919',
	paymentReport: '2cbe2b8b-92cf-4962-8e7a-d27dd0de5465',
	payrollJournal: '1a869080-43ca-46c7-a4cb-c73702c7d90d',
	payrollSummary: '9483fd52-ad7f-43df-97e1-b04c29e92eaf',
	pensionReport: '0bf0ba41-fa40-4595-bfd6-15eff6df2832',
	ytdReport: '9d3b934f-bc67-4408-a269-45d977a11a7a'
};

angular.module('paycircleApp')

.constant('REPORT_CELL_TYPE', REPORT_CELL_TYPE)

.constant('REPORT_CLASSIC_CATEGORY_IDS', REPORT_CLASSIC_CATEGORY_IDS)

.constant('REPORT_CLASSIC_VIEW_OPTIONS', {
	[REPORT_TEMPLATE_IDS.p32Report]: {
		contentTypeDefault: REPORT_CELL_TYPE.decimal,
		contentTypes: [
			REPORT_CELL_TYPE.date,
			REPORT_CELL_TYPE.string
		]
	},

	[REPORT_TEMPLATE_IDS.payrollSummary]: {
		contentTypeDefault: REPORT_CELL_TYPE.decimal,
		contentTypes: [
		    REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.person,
			REPORT_CELL_TYPE.string
		]
	},

	[REPORT_TEMPLATE_IDS.pensionReport]: {
		contentTypeDefault: REPORT_CELL_TYPE.decimal,
		contentTypes: [
		    REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.person,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
		]
	},

	[REPORT_TEMPLATE_IDS.manualPayments]: {
		contentTypes: [
		    REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.person,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.decimal
		]
	},

	[REPORT_TEMPLATE_IDS.paymentReport]: {
		contentTypes: [
		    REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.date,
			REPORT_CELL_TYPE.date
		]
	},

	[REPORT_TEMPLATE_IDS.comparisonReport]: {
		contentTypeDefault: REPORT_CELL_TYPE.decimal,
		contentTypes: [
			REPORT_CELL_TYPE.date
		]
	},

	[REPORT_TEMPLATE_IDS.employeeDetails]: {
		contentTypes: [
            REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.decimal,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.decimal
		]
	},

	[REPORT_TEMPLATE_IDS.ytdReport]: {
		contentTypeDefault: REPORT_CELL_TYPE.decimal,
		contentTypes: [
			REPORT_CELL_TYPE.string,
		    REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.string,
			REPORT_CELL_TYPE.decimal,
			REPORT_CELL_TYPE.date,
		]
	},

	[REPORT_TEMPLATE_IDS.payrollJournal]: {
		contentTypes: [
			REPORT_CELL_TYPE.string,
		    REPORT_CELL_TYPE.date,
		    REPORT_CELL_TYPE.string,
		    REPORT_CELL_TYPE.string,
		    REPORT_CELL_TYPE.string,
		    REPORT_CELL_TYPE.decimal
		]
	},
	[REPORT_TEMPLATE_IDS.eps]: {
		canIgnoreCompletedPeriods: true
	}
})

.constant('REPORT_PERIOD_FILTER_KEYS', {
	singlePeriod: '[SinglePeriod]',
	periodRange: '[PeriodRange]',
	singleSupplementaryPayment: '[SingleSupplementaryPayment]',
	singleTaxMonth: '[SingleTaxMonth]',
	singleTaxYear: '[SingleTaxYear]',
	dateRange: '[DateRange]',
	useTemporalJournalData: '[UseTemporalJournalData]',
	includePaymentsInYtd: '[IncludePaymentsInYtd]',
	temporalDataReferenceDate: '[TemporalDataReferenceDate]',
})

.constant('REPORT_PERIOD_OPTION_TYPE', {
	radioButton: 0,
	singleDropDownList: 1,
	rangeDropDownLists: 2,
	rangeCalendarDatePickers: 3
})

.constant('REPORT_OBJECT_PROPERTIES', [
	{
		standard: {
			rowArrName: 'TitleRows',
			rowCellArrName: 'Titles',
		},
		custom: {
			rowArrName: 'TitleRow',
			rowCellArrName: 'TitleRowCells'
		}
	},
	{
		hasContentTypes: true,
		standard: {
			rowArrName: 'ReportRows',
			rowCellArrName: 'Values',
		},
		custom: {
			rowArrName: 'ReportRows',
			rowCellArrName: 'ReportRowCells',
			isArray: true
		}
	},
	{
		hasContentTypes: true,
		standard: {
			rowArrName: 'TotalRows',
			rowCellArrName: 'Totals',
		},
		custom: {
			rowArrName: 'TotalRow',
			rowCellArrName: 'TotalRowCells'
		}
	}
])

.constant('REPORT_ROW_STYLE', {
	none: 0,
	muted: 1
})

.constant('REPORT_TEMPLATE_IDS', REPORT_TEMPLATE_IDS)

.constant('REPORT_FILTER_KEYS', {
	additional: 'additional',
	columns: 'columns',
	companies: 'companies',
	periods: 'periods',
})

.constant('RTI_SUBMISSION_REPORT_TYPE_BITWISE', {
	fps: 1,
	eps: 2,
	cis300: 4,
	p11db: 8
});


'use strict';

const REPORT_TEMPLATE_FILTER_CONDITION = {
	isEqualTo: 0,
	isNotEqualTo: 1,
	isGreaterThan: 2,
	isGreaterThanOrEqualTo: 3,
	isLessThan:4,
	isLessThanOrEqualTo: 5,
	contains: 6,
	doesNotContain: 7,
	isEmpty: 8,
	isNotEmpty: 9
};

const REPORT_TEMPLATE_FILTER_OPERATOR = {
	and: 0,
	or: 1
};

angular.module('paycircleApp')

.constant('REPORT_TEMPLATE_ACCESSIBILITY', {
	none: 0,
	final: 1,
	draft: 2,
	finalAndDraft: 3
})

.constant('REPORT_TEMPLATE_CATEGORIES', {
	audit: 'daa724bc-50bf-4a05-93b8-b5e8408d9bca',
	company: '9e881ef7-b2d5-44ee-af3e-894558ae90e9',
	journals: '8cba7074-ff3f-4c34-bd37-0b39f16fe6bb',
	p32: 'be1159b0-9329-467c-997a-8ab98a5bf7b1',
	payroll: '552722c7-1452-42a6-a80e-e6896619f530',
	pension: 'd081fa19-ff3f-4e5d-a6bd-6ab0e48ed809',
	standardReports: '3cdb70c4-97f4-4c32-ac9a-ad731d3507c9',
	team: 'aa013024-a2a2-416d-a7f3-e06b9daa068b'
})

.constant('REPORT_TEMPLATE_FILTER_CONDITION', REPORT_TEMPLATE_FILTER_CONDITION)

.constant('REPORT_TEMPLATE_FILTER_CONDITIONS', [
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isEqualTo,
		label: 'Is'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isNotEqualTo,
		label: 'Is not'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isGreaterThan,
		label: '>'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isGreaterThanOrEqualTo,
		label: '>='
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isLessThan,
		label: '<'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isLessThanOrEqualTo,
		label: '<='
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.contains,
		label: 'Contains'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.doesNotContain,
		label: 'Does not contain'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isEmpty,
		label: 'Is empty'
	},
	{
		value: REPORT_TEMPLATE_FILTER_CONDITION.isNotEmpty,
		label: 'Is not empty'
	}
])

.constant('REPORT_TEMPLATE_FILTER_OPERATOR', REPORT_TEMPLATE_FILTER_OPERATOR)

.constant('REPORT_TEMPLATE_FILTER_OPERATORS', [
	{
		value: REPORT_TEMPLATE_FILTER_OPERATOR.and,
		label: 'And',
	},
	{
		value: REPORT_TEMPLATE_FILTER_OPERATOR.or,
		label: 'Or'
	}
])

.constant('REPORT_TEMPLATE_TOTALS_TYPE', {
	none: 0,
	sum: 1,
	differenceDecimal: 2,
	differencePercentage: 3
});

'use strict';

angular.module('paycircleApp')
.constant('ROLLBACK_STATES', {
	canRollback: 0,
	noAlreadyRolledBack: 1,
	noDoubleRollback: 2,
	noUnsubmittedPeriod: 3,
	noNotLastSubmittedPeriod: 4,
	noIsAnAgency: 5,
	noHasSupplementaryPayment: 6,
	noHasAdvancingTeamMembers: 7,
	noIsClone: 8,
	noIsPayPolicyActive: 9,
	noHasRejoiners: 10,
	noHasPartiallySubmittedCurrentPeriod: 11,
	noHasDraftPayslips: 12,
	noPayPolicyWasUpdated: 13
});

'use strict';

angular.module('paycircleApp')
.constant('ROTAREADY_ENTITY_NAMING_STRATEGIES', {
	ENTITY_NAME: 'entityName',
	ENTITY_NAME_AND_CALENDAR: 'entityNameAndCalendar',
	PREFIX: 'prefix',
	PREFIX_AND_CALENDAR: 'prefixAndCalendar'
});

'use strict';

angular.module('paycircleApp')
	.constant('ROTAREADY_UPDATES_EVENT_TYPES', {
		absenceRequested: 1,
		absenceCancelled: 2,
		absenceApproved: 3,
		absenceRejected: 4,
		rotaMarkedForApproval: 5,
		rotaPublished: 6,
		rotaRevertedToDraft: 7,
		signOffWeek: 8,
		userNeedsApproval: 9,
		userApproved: 10,
		shiftSwapRequested: 11,
		shiftSwapAccepted: 12,
		shiftSwapApproved: 13,
		shiftSwapRejected: 14,
		shiftSwapCancelled: 15,
		userDocumentExpiring: 16,
		userDocumentExpired: 17,
		userCreated: 18,
		userUpdated: 19,
		// 20 no longer exists
		shiftUpdated: 21,
		// 22 no longer exists
		userAppointmentCreated: 23,
		userAppointmentUpdated: 24,
		userAppointmentDeleted: 25,
		userPayCreated: 26,
		userPayUpdated: 27,
		userPayDeleted: 28,
		shiftBroadcastCreated: 29,
		shiftBroadcastAccepted: 30,
		shiftBroadcastRejected: 31,
		shiftBroadcastFilled: 32,
		shiftBroadcastPaused: 33,
		shiftBroadcastStopped: 34,
		shiftBroadcastResumed: 35,
		signOffWeekReversed: 36,
		signOffDay: 37,
		signOffDayReversed: 38,
		integrationSettingsUpdate: 39,
		userDocumentCreated: 40,
		userDocumentDeleted: 41,
		userEmploymentCreated: 42,
		userEmploymentUpdated: 43,
		userEmploymentDeleted: 44,
		documentPreSignatureCreated: 45,
		documentPreSignatureUpdated: 46,
		documentPreSignatureCancelled: 47,
		userDocumentUpdated: 48,
		absenceUpdated: 49,
		// 50 no longer exists
		userEmploymentEndDateSet: 51,
		// 52-57 no longer exist
		allowanceUpdated: 58
});

'use strict';

angular.module('paycircleApp')
	.constant('ROTAREADY_UPDATES_EVENT_SERVICE_STATUS', {
		active: 0,
		paused: 1
});

'use strict';

angular.module('paycircleApp')
	.constant('ROTAREADY_UPDATES_EVENT_STATUS', {
		new: 0,
		processing: 1,
		complete: 2,
		failed: 3,
		skipped: 4,
		held: 5
	});

'use strict';

angular.module('paycircleApp')
	.constant('ROTAREADY_UPDATES_EXPORT_FILTER_MAPS', {
		// Maps filter keys to backend enum names for Status
		status: {
			'team-rotaready-updates-status-new': 'New',
			'team-rotaready-updates-status-processing': 'Processing',
			'team-rotaready-updates-status-completed': 'Complete',
			'team-rotaready-updates-status-completed-with-warnings': 'CompleteWithWarnings',
			'team-rotaready-updates-status-failed': 'Failed',
			'team-rotaready-updates-status-failed-with-critical': 'FailedWithCritical',
			'team-rotaready-updates-status-skipped': 'Skipped',
			'team-rotaready-updates-status-held': 'Held'
		},
		// Maps filter keys to backend enum names for Severity (RotareadyWebhookEventMessageLevel)
		severity: {
			'team-rotaready-updates-severity-info': 'Info',
			'team-rotaready-updates-severity-warning': 'Warning',
			'team-rotaready-updates-severity-error': 'Error',
			'team-rotaready-updates-severity-critical': 'Critical',
			// Note: 'CriticalDismissed' is not a backend message level, it selects critical
			// messages that have been dismissed, which 'Critical' excludes.
			'team-rotaready-updates-severity-critical-dismissed': 'CriticalDismissed'
		},
		// Maps filter keys to backend enum names for EventType
		type: {
			'team-rotaready-updates-type-user-approved': 'UserApproved',
			'team-rotaready-updates-type-user-updated': 'UserUpdated',
			'team-rotaready-updates-type-sign-off-day': 'SignOffDay',
			'team-rotaready-updates-type-sign-off-day-reversed': 'SignOffDayReversed',
			'team-rotaready-updates-type-user-employment-created': 'UserEmploymentCreated',
			'team-rotaready-updates-type-user-employment-updated': 'UserEmploymentUpdated',
			'team-rotaready-updates-type-user-employment-deleted': 'UserEmploymentDeleted',
			'team-rotaready-updates-type-user-appointment-created': 'UserAppointmentCreated',
			'team-rotaready-updates-type-user-appointment-updated': 'UserAppointmentUpdated',
			'team-rotaready-updates-type-user-appointment-deleted': 'UserAppointmentDeleted'
		}
	});

'use strict';

// Keys use canonical status values: new=0, failed=2, complete=3, processing=4, skipped=5
angular.module('paycircleApp')
	.constant('EDP_UPDATES_EVENT_TEXT_MAP', {
		'AbsenceSickness.Created@1.0': {
			0: 'Sickness creation received',
			2: 'Sickness creation failed',
			3: 'Sickness created',
			4: 'Sickness creation processing',
			5: 'Sickness creation skipped'
		},
		'AbsenceSickness.Edited@1.0': {
			0: 'Sickness update received',
			2: 'Sickness update failed',
			3: 'Sickness updated',
			4: 'Sickness update processing',
			5: 'Sickness update skipped'
		},
		'AbsenceSickness.Deleted@1.0': {
			0: 'Sickness deletion received',
			2: 'Sickness deletion failed',
			3: 'Sickness deleted',
			4: 'Sickness deletion processing',
			5: 'Sickness deletion skipped'
		},
		'smb.suite.absence.sickness.created@1.0': {
			0: 'Sickness creation received',
			2: 'Sickness creation failed',
			3: 'Sickness created',
			4: 'Sickness creation processing',
			5: 'Sickness creation skipped'
		},
		'AbsenceHoliday.Created@1.0': {
			0: 'Holiday creation received',
			2: 'Holiday creation failed',
			3: 'Holiday created',
			4: 'Holiday creation processing',
			5: 'Holiday creation skipped'
		},
		'AbsenceHoliday.Edited@1.0': {
			0: 'Holiday update received',
			2: 'Holiday update failed',
			3: 'Holiday updated',
			4: 'Holiday update processing',
			5: 'Holiday update skipped'
		},
		'AbsenceHoliday.Deleted@1.0': {
			0: 'Holiday deletion received',
			2: 'Holiday deletion failed',
			3: 'Holiday deleted',
			4: 'Holiday deletion processing',
			5: 'Holiday deletion skipped'
		},
		'smb.suite.absence.holiday.created@1.0': {
			0: 'Holiday creation received',
			2: 'Holiday creation failed',
			3: 'Holiday created',
			4: 'Holiday creation processing',
			5: 'Holiday creation skipped'
		},
		'AbsenceMaternity.Created@1.0': {
			0: 'Maternity creation received',
			2: 'Maternity creation failed',
			3: 'Maternity created',
			4: 'Maternity creation processing',
			5: 'Maternity creation skipped'
		},
		'AbsenceMaternity.Edited@1.0': {
			0: 'Maternity update received',
			2: 'Maternity update failed',
			3: 'Maternity updated',
			4: 'Maternity update processing',
			5: 'Maternity update skipped'
		},
		'AbsenceMaternity.Deleted@1.0': {
			0: 'Maternity deletion received',
			2: 'Maternity deletion failed',
			3: 'Maternity deleted',
			4: 'Maternity deletion processing',
			5: 'Maternity deletion skipped'
		},
		'smb.suite.absence.maternity.created@1.0': {
			0: 'Maternity creation received',
			2: 'Maternity creation failed',
			3: 'Maternity created',
			4: 'Maternity creation processing',
			5: 'Maternity creation skipped'
		},
		'AbsencePaternity.Created@1.0': {
			0: 'Paternity creation received',
			2: 'Paternity creation failed',
			3: 'Paternity created',
			4: 'Paternity creation processing',
			5: 'Paternity creation skipped'
		},
		'AbsencePaternity.Edited@1.0': {
			0: 'Paternity update received',
			2: 'Paternity update failed',
			3: 'Paternity updated',
			4: 'Paternity update processing',
			5: 'Paternity update skipped'
		},
		'AbsencePaternity.Deleted@1.0': {
			0: 'Paternity deletion received',
			2: 'Paternity deletion failed',
			3: 'Paternity deleted',
			4: 'Paternity deletion processing',
			5: 'Paternity deletion skipped'
		},
		'smb.suite.absence.paternity.created@1.0': {
			0: 'Paternity creation received',
			2: 'Paternity creation failed',
			3: 'Paternity created',
			4: 'Paternity creation processing',
			5: 'Paternity creation skipped'
		}
	});

'use strict';

angular.module('paycircleApp')
	.constant('EDP_UPDATES_EVENT_TITLE_MAP', {
		'AbsenceSickness.Created@1.0': 'Sickness absence',
		'AbsenceSickness.Edited@1.0': 'Sickness absence',
		'AbsenceSickness.Deleted@1.0': 'Sickness absence',
		'smb.suite.absence.sickness.created@1.0': 'Sickness absence',
		'AbsenceHoliday.Created@1.0': 'Holiday absence',
		'AbsenceHoliday.Edited@1.0': 'Holiday absence',
		'AbsenceHoliday.Deleted@1.0': 'Holiday absence',
		'smb.suite.absence.holiday.created@1.0': 'Holiday absence',
		'AbsenceMaternity.Created@1.0': 'Maternity absence',
		'AbsenceMaternity.Edited@1.0': 'Maternity absence',
		'AbsenceMaternity.Deleted@1.0': 'Maternity absence',
		'smb.suite.absence.maternity.created@1.0': 'Maternity absence',
		'AbsencePaternity.Created@1.0': 'Paternity absence',
		'AbsencePaternity.Edited@1.0': 'Paternity absence',
		'AbsencePaternity.Deleted@1.0': 'Paternity absence',
		'smb.suite.absence.paternity.created@1.0': 'Paternity absence'
	});

'use strict';

angular.module('paycircleApp')
	.constant('EDP_UPDATES_EVENT_TYPES', {
		sicknessCreated: 'AbsenceSickness.Created@1.0',
		sicknessEdited: 'AbsenceSickness.Edited@1.0',
		sicknessDeleted: 'AbsenceSickness.Deleted@1.0',
		holidayCreated: 'AbsenceHoliday.Created@1.0',
		holidayEdited: 'AbsenceHoliday.Edited@1.0',
		holidayDeleted: 'AbsenceHoliday.Deleted@1.0',
		maternityCreated: 'AbsenceMaternity.Created@1.0',
		maternityEdited: 'AbsenceMaternity.Edited@1.0',
		maternityDeleted: 'AbsenceMaternity.Deleted@1.0',
		paternityCreated: 'AbsencePaternity.Created@1.0',
		paternityEdited: 'AbsencePaternity.Edited@1.0',
		paternityDeleted: 'AbsencePaternity.Deleted@1.0',
		// smb.suite.* Created variants are the same absence "created" events under the newer type
		// string; the text/title maps already key on both, so the type filters below match either.
		smbSicknessCreated: 'smb.suite.absence.sickness.created@1.0',
		smbHolidayCreated: 'smb.suite.absence.holiday.created@1.0',
		smbMaternityCreated: 'smb.suite.absence.maternity.created@1.0',
		smbPaternityCreated: 'smb.suite.absence.paternity.created@1.0'
	});

'use strict';

angular.module('paycircleApp')
	.constant('EDP_UPDATES_EXPORT_FILTER_MAPS', {
		status: {
			'team-edp-updates-status-new': 'New',
			'team-edp-updates-status-processing': 'Processing',
			'team-edp-updates-status-completed': 'Complete',
			'team-edp-updates-status-failed': 'Failed',
			'team-edp-updates-status-skipped': 'Skipped'
		},
		severity: {
			'team-edp-updates-severity-info': 'Info',
			'team-edp-updates-severity-warning': 'Warning',
			'team-edp-updates-severity-error': 'Error'
		},
		type: {
			'team-edp-updates-type-sickness-created': 'AbsenceSickness.Created@1.0',
			'team-edp-updates-type-sickness-edited': 'AbsenceSickness.Edited@1.0',
			'team-edp-updates-type-sickness-deleted': 'AbsenceSickness.Deleted@1.0',
			'team-edp-updates-type-holiday-created': 'AbsenceHoliday.Created@1.0',
			'team-edp-updates-type-holiday-edited': 'AbsenceHoliday.Edited@1.0',
			'team-edp-updates-type-holiday-deleted': 'AbsenceHoliday.Deleted@1.0',
			'team-edp-updates-type-maternity-created': 'AbsenceMaternity.Created@1.0',
			'team-edp-updates-type-maternity-edited': 'AbsenceMaternity.Edited@1.0',
			'team-edp-updates-type-maternity-deleted': 'AbsenceMaternity.Deleted@1.0',
			'team-edp-updates-type-paternity-created': 'AbsencePaternity.Created@1.0',
			'team-edp-updates-type-paternity-edited': 'AbsencePaternity.Edited@1.0',
			'team-edp-updates-type-paternity-deleted': 'AbsencePaternity.Deleted@1.0'
		}
	});

'use strict';

angular.module('paycircleApp')
	.constant('EDP_UPDATES_FRIENDLY_ERROR_MAP', {
		'Internal match not found': 'No matching team member found in Paycircle',
		'EDP integration disabled: Sickness': 'EDP sickness integration is disabled',
		'Topic disabled: Sickness': 'Sickness updates are disabled'
	});

'use strict';

angular.module('paycircleApp')
	.constant('ROTAREADY_UPDATES_MAX_RETRY_COUNT', 250);

'use strict';

angular.module('paycircleApp')
.constant('SALARY_RATE_TYPES', {
	daily: 0,
	hourly: 1
});
'use strict';

angular.module('paycircleApp')
.constant('SALARY_TYPES', {
	grossPay: 0,
	hourlyPay: 1,
	netPay: 2,
	casual: 3,
	variable: 4,
    payPolicy: 5
});

'use strict';

/**
 * Salary interval types. Distinct from pay period types, these are used for salary breakdown calculations.
 */
angular.module('paycircleApp')
.constant('SALARY_INTERVAL_TYPES', {
	weekly: 0,
	fortnightly: 1,
	fourweekly: 2,
	monthly: 3,
	quarterly: 4,
	annually: 5,
	hourly: 6,
	daily: 7
});

'use strict';

/**
 * The variation of salutations used in Paycircle
 */
angular.module('paycircleApp')
.constant('SALUTATIONS', [
	'Mr',
	'Mrs',
	'Miss',
	'Ms',
	'Dr',
	'Lord',
	'Mx',
	'Lady',
	'Sir',
	'Father',
	'Professor'
]);

'use strict';

angular.module('paycircleApp')
.constant('SEARCH_BAR_ACTIONS', {
	currentPeriodChanges: {
		refresh: 'refresh'
	},
	customerCodes: {
		editCustomerCode: 'editCustomerCode'
	},
	jobGrades: {
		addJobGrade: 'addJobGrade'
	},
	policies: {
		addPayPolicy: 'addPolicy'
	},
	reportTemplates: {
		addNewTemplate: 'addNewTemplate'
	}
});

'use strict';

angular.module('paycircleApp')
.constant('SCHEDULE_UPDATE_REASONS', {
    IsLeaving: 1,
    ReturnToWork: 2,
    Redundancy: 3,
    SharedParentalLeave: 4,
    SalaryUpdate: 5,
    CorrectGrossPay: 6,
    CorrectStartDate: 7,
    CorrectEndDate: 8,
    EmployeeIsDeceased: 9
});

'use strict';

angular.module('paycircleApp')
.constant('SECONDED_STATES', {
	notSeconded: -1,
	none: 0,
	stay183DaysOrMore: 1,
	stayLessThan183Days: 2,
	inOutUk: 3,
	notEnoughInformation: 4
});

'use strict';

/**
 * @name paycircleApp.servers
 * @description a list of all the servers Paycircle application uses
 * # servers
 */
angular.module('paycircleApp')
.constant('servers', {
	beta: {
		amalthea: 	'//amaltheapaycirclebeta.paycircle.co.uk/',
		callisto: 	'//callistopaycirclebeta.paycircle.co.uk/',
		ganymede: 	'//ganymedepaycirclebeta.paycircle.co.uk/',
		phobos: 	'//phobospaycirclebeta.paycircle.co.uk/',
		thebe: 		'//thebepaycirclebeta.paycircle.co.uk/',
		wordPress:	'//paycircle2020s.wpengine.com/'
	},
	dev: {
		amalthea: 	'//amaltheadevelopment.paycircle.co.uk/',
		callisto: 	'//callistodevelopment.paycircle.co.uk/',
		ganymede: 	'//ganymededevelopment.paycircle.co.uk/',
		phobos: 	'//phobosdevelopment.paycircle.co.uk/',
		thebe:		'//thebedevelopment.paycircle.co.uk/',
		wordPress:	'//paycircle2020s.wpengine.com/'
	},
	live: {
		amalthea: 	'//amalthealive.paycircle.co.uk/',
		callisto: 	'//callistolive.paycircle.co.uk/',
		ganymede: 	'//ganymedelive.paycircle.co.uk/',
		phobos: 	'//phoboslive.paycircle.co.uk/',
		thebe:		'//thebelive.paycircle.co.uk/',
		wordPress:	'//wordpress.paycircle.co.uk/'
	},
	preproduction: {
		amalthea: 	'//amaltheapreproduction.paycircle.co.uk/',
		callisto: 	'//callistopreproduction.paycircle.co.uk/',
		ganymede: 	'//ganymedepreproduction.paycircle.co.uk/',
		phobos: 	'//phobospreproduction.paycircle.co.uk/',
		thebe:		'//thebepreproduction.paycircle.co.uk/',
		wordPress:	'//wordpress.paycircle.co.uk/'
	}
});

'use strict';

angular.module('paycircleApp')
.constant('SICK_PAY_TYPES', {
	standard: 0,
	covid19: 1
});

'use strict';

angular.module('paycircleApp')
.constant('SICKNESS_TYPES', {
	payAllSickness: 0,
	statutory: 1,
	custom: 2
});

'use strict';

angular.module('paycircleApp')
	.constant('SIMPLE_WORK_PATTERN_DAYS', {
		monday: 'Mon',
		tuesday: 'Tue',
		wednesday: 'Wed',
		thursday: 'Thu',
		friday: 'Fri',
		saturday: 'Sat',
		sunday: 'Sun'
	});

'use strict';

angular.module('paycircleApp')
.constant('SMART_PENSION_ROLES', {
	employer: 0,
	advisor: 1
});
'use strict';

angular.module('paycircleApp')
.constant('SPLASH_STATES', {
	inactive: 0,
	active: 1,
	complete: 2
});

'use strict';

angular.module('paycircleApp')
.constant('STAT_PAYMENT_SCHEDULE_STATES', {
	ready: 0,
	dateDetailsMissing: 1,
	payeDetailsMissing: 2,
	earningsInsufficient: 3,
	duplicatePaymentSchedule: 4,
	employmentDetailsInsufficient: 5,
	payrollHasRun: 6,
	continuousEmploymentInsufficient: 7,
	scheduleLengthError: 8,
	earningsPartiallyInsufficient: 9,
	partialScheduleLengthError: 10
});

'use strict';

angular.module('paycircleApp')
.constant('STATE_STORAGE_KEYS', {
	searchFilterId: 'search-filter',
	searchString: 'search',
	pageNumber: 'page',
	filterAdditionalData: 'filter-additional-data',
	filterKeys: 'filters'
})

/*
	State storage config. Some values need to be stored as arrays; for example, filter keys, of which there can be
	any number selected. The storage service will deal with these according to the config below.
 */
.factory('STATE_STORAGE_CONFIG', [
	'STATE_STORAGE_KEYS',
function (
	STATE_STORAGE_KEYS
) {
	return {
		[STATE_STORAGE_KEYS.searchFilterId]: {
			isArray: false
		},
		[STATE_STORAGE_KEYS.searchString]: {
			isArray: false
		},
		[STATE_STORAGE_KEYS.pageNumber]: {
			isArray: false
		},
		[STATE_STORAGE_KEYS.filterAdditionalData]: {
			isArray: false
		},
		[STATE_STORAGE_KEYS.filterKeys]: {
			isArray: true
		}
	};
}]);

'use strict';

/**
 * The variation of state types used in Paycircle
 */
angular.module('paycircleApp')
.constant('STATE_TYPES', {
	report: 0,
	confirm: 1,
	payslip: 2,
	ae: 3,
	fps: 4,
	eps: 5,
	finalise: 6,
	dataimport: 7,
	workerimport: 8,
	pensionimport: 9,
	ytdimport: 10,
	updateae: 11,
	updateaecontributions: 12,
	aeenrol: 13,
	datadeletion: 14,
	undefined: 15,
	cisVerify: 16,
	cis300: 17,
	payElementImport: 18,
	taxUpdates: 20,
	periodChanges: 21
});

'use strict';

angular.module('paycircleApp')
.constant('STATIC_REPORT_STATUS', {
	pending: 0,
	processing: 1,
	complete: 2,
    failed: 3,
    notfound: 4
});

'use strict';

angular.module('paycircleApp')
.constant('STATIC_REPORT_TEMPLATES', {
	templates:[{
		template:{
			name: 'Average Pay Report',
			noticeTitle: 'Report Notice',
			notice: 'The average holiday report can only be generated when the current payroll period has been finalised.<br>Figures shown reflect our interpretation of average holiday pay legislation and may differ from other views.<br>We\'ve taken care to ensure accuracy, but please refer to the support article for exclusions and calculation details.<br>If you\'re unsure, we recommend seeking professional advice, as we can\'t accept responsibility for decisions made based on this report.'
		}
	}]
});

'use strict';

angular.module('paycircleApp')
.constant('STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS', {
	totalAmount: 0,
	periodSplit: 1
});

'use strict';

angular.module('paycircleApp')
.constant('STATUTORY_PAY_CALCULATION_METHODS', {
	periodDates: 0,
	weekly: 1
});

'use strict';

angular.module('paycircleApp')
.constant('STUDENT_LOAN_PLANS', {
	plan1: 'plan1',
	plan2: 'plan2',
	plan1and2: 'plan1and2',
	plan4: 'plan4',
	plan5: 'plan5'
});

'use strict';

angular.module('paycircleApp')
.constant('SUBMISSION_LOG_TYPE', {
	cisSuffered: 'cis-suffered',
	p11dbSubmission: 'p11db-submission',
	payPeriod: 'pay-period',
	supplementaryPayRun: 'supplementary-pay-run'
})
.constant('SUBMISSION_LOG_ENTRY_TYPES', {
	fps: 0,
	eps: 1,
	cis300: 2,
	cisVerify: 3,
	eyu: 4,
	p11db: 5
});

'use strict';

/**
 * The variation of submission states used in Paycircle
 */
angular.module('paycircleApp')
.constant('SUBMISSION_STATES', {
	unsubmitted: 0,
	submitting: 1,
	submitted: 2,
	failed: 3,
	haserrors1: 4,
	verified: 5,
	processing1: 6,
	haserrors2: 7,
	processing2: 8,
	finished: 9,
	resubmit: 10,
	requesting: 11
})

.constant('SUBMISSION_TYPES', {
	unspecified: 0,
	fps: 1,
	eps: 2,
	cis: 3
})

.constant('SUBMISSION_STATES_RTI', {
	unspecified: 0,
	success: 1,
	failure: 2
});

'use strict';

/**
 * The variation of submission states used in Paycircle
 */
angular.module('paycircleApp')
.constant('SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES', {
	justSupplementaryChanges: 0,
	combineWithPreviousPayslip: 1,
	createBothTypesOfPayslip: 2
});

'use strict';

/*
	Keys for each tab set
 */
angular.module('paycircleApp')
.constant('TAB_KEYS', {
	payroll: {
		currentPeriod: {
			id: 'tab-bar-current-period',
			tabs: {
				alerts: 'tab-bar-current-period-alerts',
				changes: 'tab-bar-current-period-changes',
				imports: 'tab-bar-current-period-imports',
				notes: 'tab-bar-current-period-notes',
				pensions: 'tab-bar-current-period-pensions',
				tasks: 'tab-bar-current-period-tasks',
				taxUpdates: 'tab-bar-current-period-tax-updates',
				team: 'tab-bar-current-period-team'
			}
		},
		history: {
			id: 'tab-bar-history',
			tabs: {
				payPeriods: 'tab-bar-history-pay-periods',
				supplementaryPayRuns: 'tab-bar-history-supplementary-pay-runs'
			}
		},
		supplementaryPayRun: {
			id: 'tab-bar-period',
			tabs: {
				changes: 'tab-bar-period-changes',
				receipts: 'tab-bar-period-receipts',
				reports: 'tab-bar-period-reports'
			}
		}
	},
	settings: {
		access: {
			id: 'tab-bar-settings-access',
			tabs: {
				ipManagement: 'tab-bar-settings-access-ip-management',
				authentication: 'tab-bar-settings-access-authentication'
			}
		},
		bacsDownloads: {
			id: 'tab-bar-settings-bacs-downloads',
			tabs: {
				available: 'tab-bar-settings-bacs-downloads-available',
				pending: 'tab-bar-settings-bacs-downloads-pending',
				processed: 'tab-bar-settings-bacs-downloads-processed'
			}
		},
		businessCategories: {
			id: 'tab-bar-settings-business-categories',
			tabs: {
				imports: 'tab-bar-settings-business-categories-imports'
			}
		},
		customisation: {
			id: 'tab-bar-settings-customisation',
			tabs: {
				system: 'tab-bar-settings-customisation-system',
				employeePortal: 'tab-bar-settings-customisation-employee-portal'
			}
		},
		imports: {
			id: 'tab-bar-settings-imports',
			tabs: {
				mappings: 'tab-bar-settings-imports-mappings',
				settings: 'tab-bar-settings-imports-settings'
			}
		},
		journals: {
			id: 'tab-bar-settings-journals',
			tabs: {
				businessCategories: 'tab-bar-settings-journals-business-categories',
				imports: 'tab-bar-settings-journals-imports',
				nominalCodes: 'tab-bar-settings-journals-nominal-codes',
				posts: 'tab-bar-settings-journals-posts'
			}
		},
		payElements: {
			id: 'tab-bar-settings-pay-elements',
			tabs: {
				coreElements: 'tab-bar-settings-pay-elements-core-elements',
				bik: 'tab-bar-settings-pay-elements-bik',
				cis: 'tab-bar-settings-pay-elements-cis',
				elementPacks: 'tab-bar-settings-pay-elements-packs',
				additions: 'tab-bar-settings-pay-elements-additions',
				deductions: 'tab-bar-settings-pay-elements-deductions',
				linkElements: 'tab-bar-settings-pay-elements-link-elements',
				payslipLabels: 'tab-bar-settings-pay-elements-payslip-labels',
				disbursements: 'tab-bar-settings-pay-elements-disbursements'
			}
		},
		reports: {
			id: 'tab-bar-settings-reports',
			tabs: {
				custom: 'tab-bar-settings-reports-custom',
				standard: 'tab-bar-settings-reports-standard',
				packs: 'tab-bar-settings-reports-packs'
			}
		},
		genderPayGap: {
			id: 'tab-bar-settings-gender-pay-gap',
			tabs: {
				hourlyBonusPay: 'tab-bar-settings-gender-pay-gap-hourly-bonus-pay',
				teamMembers: 'tab-bar-settings-gender-pay-gap-team-members'
			}
		}
	},
	team: {
		archivedProfile: {
			id: 'tab-bar-profile-archived',
			tabs: {
				information: 'tab-bar-archived-information',
				pension: 'tab-bar-profile-archived-pension',
				documents: 'tab-bar-profile-archived-documents',
				history: 'tab-bar-profile-archived-history'
			}
		},
		profile: {
			id: 'tab-bar-team-profile',
			tabs: {
				overview: 'tab-bar-team-profile-overview',
				schedules: 'tab-bar-team-profile-schedules',
				account: 'tab-bar-team-profile-account',
				information: 'tab-bar-team-profile-information',
				pension: 'tab-bar-team-profile-pension',
				holiday: 'tab-bar-team-profile-holiday',
				sickness: 'tab-bar-team-profile-sickness',
				documents: 'tab-bar-team-profile-documents',
				payments: 'tab-bar-team-profile-payments',
				history: 'tab-bar-team-profile-history',
				linkRates: 'tab-bar-team-profile-link-rates',
				taxStatus: 'tab-bar-team-profile-tax-status'
			}
		}
	}
});

'use strict';

/**
 * The variation of fixed tax codes used in Paycircle
 */
angular.module('paycircleApp')
.constant('TAX_CODES_FIXED', [
	'0T',
	'BR',
	'D0',
	'D1',
	'D2',
	'D3',
	'NT'
]);

'use strict';

/**
 * The variation of variable tax codes used in Paycircle
 */
angular.module('paycircleApp')
.constant('TAX_CODES_VARIABLE', [
	'L',
	'T',
	'K',
	'M',
	'N'
]);

'use strict';

/**
 * The list of tax codes available in Paycircle
 */
angular.module('paycircleApp')
.constant('TAX_CODES', [
	'L',
	'T',
	'0T',
	'BR',
	'D0',
	'D1',
	'D2',
	'D3',
	'NT',
	'K',
	'M',
	'N'
]);

'use strict';

angular.module('paycircleApp')
.constant('TAX_RELIEF_TYPES', [
	{
		id: 0,
		description: 'Relief at source',
		key: 'RAS',
	},
	{
		id: 1,
		description: 'Net pay',
		key: 'NPA'
	}
]);

'use strict';

angular.module('paycircleApp')
.constant('TAX_TREATMENT_VALUES', {
	30: {
		id: 0,
		name: 'Higher rate 30%'
	},
	20: {
		id: 2,
		name: 'Standard rate 20%'
	}
})
.constant('TAX_TREATMENT_OPTIONS', [
	{
		id: 0,
		name: 'Higher rate 30%'
	},
	{
		id: 1,
		name: 'Gross'
	},
	{
		id: 2,
		name: 'Standard rate 20%'
	},
])
.constant('TAX_TREATMENTS', {
	higher: 0,
	gross: 1,
	standard: 2
});

'use strict';

/**
 * The list of tax codes available in Paycircle
 */
angular.module('paycircleApp')
.constant('TEAM_MEMBER_SETUP_STATES', {
	userCreated: 0,
	userMismatch: 1,
	userExistsForCompany: 2,
	userExistsInPaycircle: 3,
	userIsLeaverForCompany: 4
})
.constant('TEAM_MEMBER_COMPANY_STATES', {
	userCreated: 0,
	notProvided: 1,
	shortIdInUse: 2,
	payrollIdInUse: 3
});

'use strict';

angular.module('paycircleApp')
.constant('TELEMETRY_PROJECT_INFO', {
    projectReportingCode: '572'
});

angular.module('paycircleApp')
.constant('TELEMETRY_TRACKED_FEATURES', {
	loaded: 'loaded',
	helpAndSupport: '1552931',
	imports: '1603412',
	averagePayReport: '1592506',
	rolledUpHolidayPay: '1484814',
	feedbackCopilot: '1766753'
});


'use strict';

angular.module('paycircleApp')
.constant('TEST_COMPANY_IDS', {
	'paycircleSmeDemo': 'bbd4d8e7-153c-4b04-9853-45fcb2cfa4f5'
});

'use strict';

angular.module('paycircleApp')
.constant('TFA_STATES', {
	off: 0,
	login: 1,
	timePeriod: 2
});

'use strict';

angular.module('paycircleApp')
.constant('TOOLTIPS', {
	demo: {
		editSalary: {
			heading: 'Change a team member’s salary',
			copy: 'Click this Salary ‘Edit’ link then edit the annual salary and save the form to update it.',
			completed: 'You’ve updated {{firstname}}’s salary!',
			position: 'top-far-left'
		},
		makeLeaver: {
			heading: 'Mark a team member as a leaver',
			copy: 'Click on this actions link then choose the ‘Mark as leaver’ option in the menu. Choose ‘Yes’ then set a leave date and save.',
			position: 'bottom-left',
			completed: 'You’ve marked {{firstname}} as a leaver!'
		},
		editTaxCode: {
			heading: 'Change a team member’s tax code',
			copy: 'Click this Tax status ‘Edit’ link then change the tax code and save the form to update it.',
			completed: 'You’ve updated {{firstname}}’s tax code!',
			position: 'top-far-left'
		},

		addBonus: {
			heading: 'Add a bonus for a team member',
			copy: 'Click on the actions link then choose the ‘Add a change’ option in the menu. Choose ‘Bonus’ as the type of change then add the amount.',
			completed: 'You’ve added a bonus for {{firstname}}!',
			position: 'bottom-left'
		},
		addExpense: {
			heading: 'Add an expense with custom payslip label',
			copy: 'Click on the actions link then choose the ‘Add a change’ option in the menu. Choose ‘Expenses’ as the type of change then add the amount and a payslip label.',
			completed: 'You’ve added an expense for {{firstname}}!',
			position: 'bottom-left'
		},
		addPayslipNote: {
			heading: 'Add a note to a payslip',
			copy: 'Click on the actions link then choose the ‘Add payslip note’ option in the menu. You can then add your note (including emojis!) and save it so it appears on the payslip.',
			completed: 'You’ve added a payslip note for {{firstname}}!',
			position: 'bottom-left'
		},

		uploadCompanyPayslipLogo: {
			heading: 'Upload your company logo for payslips',
			copy: 'Click on ‘Choose file’ to choose your logo from your computer then use the preview links to see it on online and PDF payslips.',
			completed: 'You’ve uploaded your company logo!'
		},
		changePayrollProcessingDate: {
			heading: 'Change your payroll processing day',
			copy: 'Click on this ‘Edit’ link in payroll settings then edit the payroll processing day/date and save the form to update.',
			completed: 'You’ve updated your payroll processing date!',
			position: 'top-far-left'
		},
		switchToAutoRun: {
			heading: 'Switch your payroll to auto run',
			copy: 'Click on this ‘Edit’ link in payroll settings then toggle the ‘Auto run payroll’ switch to ‘ON’. Save the form and your payroll will automatically run on your processing day/date.',
			completed: 'You’ve switched your payroll to auto run!',
			position: 'top-far-left'
		},

		addHoliday: {
			heading: 'Add annual leave for a team member',
			copy: 'Click on a day in the calendar, choose ‘Annual leave’ then drag handles on either side of the entry to cover as many days as required.',
			completed: 'You’ve added annual leave for {{firstname}}'
		},
		addSickness: {
			heading: 'Add sickness for a team member',
			copy: 'Click on a day in the calendar, choose ‘Sick leave’ then drag either side of the entry to cover as many days as required.',
			completed: 'You’ve added sick leave for {{firstname}}'
		},
		editHoliday: {
			heading: 'Edit annual leave for a team member',
			copy: 'Click on this annual leave entry then use the handles to drag left or right to change the number of days.',
			position: 'bottom',
			completed: 'You’ve updated annual leave for {{firstname}}'
		},

		updateEmployeePensionContributions: {
			heading: 'Update pension contribution percentage',
			copy: 'Click on the action icon then choose the ‘Pension contributions’ link. Select ‘Customise contribution rates’ in the form then adjust the percentages and save to update.',
			completed: 'You’ve updated {{firstname}}’s contributions!',
			position: 'bottom-left'
		},
		updateTeamPostponementSettings: {
			heading: 'Update team postponement settings',
			copy: 'Click this ‘Edit’ link and change the postponement options for new joiners, team member threshold changes and then save to update.',
			completed: 'You’ve updated team postponement settings',
			position: 'top-far-left'
		},
		updateEmployeesPensionState: {
			heading: 'Update pension status',
			copy: 'Click on this action link then choose the ‘Pension status’ link. Change the status, add the respective date if required and save to update.',
			completed: 'You’ve updated {{firstname}}’s pension status',
			position: 'bottom-left'
		},

		calculatePayroll: {
			heading: 'Calculate payroll',
			copy: 'You first calculate your payroll, to check you’re happy with everything, and then run it to complete the approval process.',
			position: 'bottom-left bottom-left--more-right'
		},
		runPayroll: {
			heading: 'Run payroll',
			copy: 'Once you’re happy that everything is correct with your payroll click the ‘Run payroll’ button.',
			position: 'bottom-left bottom-left--more-right'
		},
		checkPayroll: {
			heading: 'A final check',
			copy: 'Check a few final details and confirm when you’d like to notify your employees. Click ‘Run payroll’ once you’re ready.',
			completed: 'Hurrah, you’ve successfully approved payroll!',
			link: 'Go to your dashboard to start onboarding',
			position: 'top-far-left top-far-left--more-right'
		}
	},
	onboarding: {
		willAdminBeOnPayroll: {
			heading: 'Will you be on payroll?',
			copy: 'We’ve assumed you’ll be on payroll but you may only need admin access. Click ‘Admin only’ and you won’t need to add any more info for yourself. You can always add yourself to payroll later.',
			buttonText: 'Admin only',
			position: 'bottom-far-right',
			showTooltip: true,
			neverOpenAgain: 'willAdminBeOnPayroll'
		}
	},
	changesTable: {
		addingChanges: {
			heading: 'Adding changes',
			copy: 'Click the ‘Add’ button for the team member and change you wish to add, then type in the figures and hit return to save.',
			buttonText: 'Next',
			showTooltip: true,
			position: 'bottom-far-right tooltip--white-text',
			neverOpenAgain: 'changesTableAddingChanges',
			footnote: '1 of 2'
		},
		markAsComplete: {
			heading: 'Indicate that you’ve finished',
			copy: 'Once you’ve added all your changes, toggle this switch to ‘I’ve finished’.',
			buttonText: 'Got it',
			showTooltip: true,
			position: 'bottom-far-right tooltip--white-text',
			neverOpenAgain: 'changesTableMarkAsComplete'
		}
	}
});

'use strict';

angular.module('paycircleApp')
.constant('TRACKING_EVENTS', {
	bulkPayrollsRan: 'bulk-payrolls-ran',
	completedDemo: 'completed-demo',
	errorBlock: 'error-block',
	fastSearchQuery: 'fast-search-query',
	onboardingCompanyCompleted: 'onboarding-company-completed',
	onboardingMovedToFirstPayPeriod: 'onboarding-moved-to-first-pay-period',
	onboardingPayrollCompleted: 'onboarding-payroll-completed',
	onboardingProfileCompleted: 'onboarding-profile-completed',
	onboardingTeamCompleted: 'onboarding-team-completed',
	registeredForFreeTrial: 'registered-for-free-trial',
	registeredForOnboarding: 'registered-for-onboarding',
	requestedActivationCodeDemo: 'requested-demo-activation-code',
	requestedActivationCodeOnboarding: 'requested-onboarding-activation-code',
	runLivePayroll: 'run-live-payroll',
	runTestPayroll: 'run-test-payroll',
	slideInFormOpened: 'slide-in-form-opened',
	userSessionTimedOut: 'user-session-timed-out',
	reporting: {
		additionalFilterUsed: 'reporting-additional-filter-used',
		columnFilterAddedToTemplate: 'column-filter-added-to-template',
		columnFilterUsed: 'reporting-column-filter-used',
		companyFilterUsed: 'reporting-company-filter-used',
		periodFilterUsed: 'reporting-period-filter-used',
		reportExported: 'reporting-report-exported',
		reportLoaded: 'reporting-report-loaded',
		reportTemplateCreated: 'reporting-template-created',
	}
})

.constant('TRACKING_EVENT_CATEGORIES', {
	authentication: 'Authentication',
	errors: 'Errors',
	search: 'Search',
	forms: 'Forms',
	reporting: 'Reporting'
});


angular.module('paycircleApp')

// Set of schedule statuses used for homogeneous list of schedules for sorting
.constant('UI_SCHEDULE_STATUSES', {

	// Numeric constants define the sort order of schedules in the UI
	inProgress: 0,
	paused: 1,
	pending: 2,
	complete: 3,
	stopped: 4,
	cancelled: 5
});

angular.module('paycircleApp')

/* Set of schedule types used for homogeneous list of schedules for display, filtering and searching.
   ** Where applicable these need to match the name of the array corresponding to the schedule type in
   a statutory pay object */
.constant('UI_SCHEDULE_TYPES', {

	adoptionPay: 'AdoptionPay',						// **
	attachmentOfEarnings: 'attachmentOfEarnings',
	carBenefitInKind: 'carBenefitInKind', 			// Part of ScheduledPayments in statutory pay object (see below)
	childcareVouchers: 'childcareVouchers',			// Part of ScheduledPayments in statutory pay object (see below)
	companyLoan: 'companyLoan',						// Part of ScheduledPayments in statutory pay object (see below)
	covid19SickPay: 'Covid19SicknessPay',			// **
	cycleToWorkScheme: 'cycleToWorkScheme',			// Part of ScheduledPayments in statutory pay object (see below)
	furlough: 'furlough',
	healthcare: 'healthcare', 						// Part of ScheduledPayments in statutory pay object (see below)
	maternityPay: 'MaternityPay',					// **
	paternityPay: 'PaternityPay',					// **
	seasonTicketLoan: 'seasonTicketLoan',			// Part of ScheduledPayments in statutory pay object (see below)
	sharedParentalPay: 'sharedParentalPay',
	sickPay: 'SicknessPay',							// **

	/* Catch-all for schedules cycleToWorkScheme, companyLoan, seasonTicketLoan, childcareVouchers.
	   Represented separately here since repayment schedules of those types are grouped in the
	   ScheduledPayments array property of the statutory pay object */
	scheduledPayments: 'ScheduledPayments' 			// *
});
'use strict';

angular.module('paycircleApp')

.constant('UPDATE_POLICY_MODES', {
	create: 'create',
	duplicate: 'duplicate',
	edit: 'edit',
	import: 'import',
	view: 'view'
});

'use strict';

angular.module('paycircleApp')
.constant('URLS', {
	directDebit: {
		website: 'https://www.directdebit.co.uk/DirectDebitExplained/Pages/DirectDebitGuarantee.aspx'
	},
	goCardless: {
		privacyNotice: 'https://gocardless.cdn.prismic.io/gocardless%2F7771e6dc-9885-4a69-8361-513e747a6f28_privacy-notice-v0518-0.pdf',
		website: 'https://gocardless.com'
	},
	gov: {
		directorsNi: 'https://www.gov.uk/employee-directors',
		scottishIncomeTax: 'https://www.gov.uk/scottish-rate-income-tax',
		smp1Form: 'https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/401639/smp1.pdf',
		spp1Form: 'https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/473512/SPP1_10_15.pdf',
		welshIncomeTax: 'https://www.gov.uk/welsh-income-tax'
	},
	intercom: {
		website: 'https://www.intercom.com/'
	},
	nest: {
		login: 'https://www.nestpensions.org.uk/schemeweb/NestWeb/faces/public/MUA/pages/loginPage.xhtml'
	},
	paycircle: {
		images: {
			attachentOfEarningsExample: 'https://wordpress.paycircle.co.uk/wp-content/uploads/2020/11/dea-duplex.jpg',
		},
		communityForum: {
			aha: 'https://paycircle.ideas.aha.io/',
			home: 'https://paycircle.tribeplatform.com/'
		},
		dataImportTemplates: {
			teamImport: 'https://paycircle.blob.core.windows.net/$root/ImportTemplate.csv'
		},
		support: {
			accessTfa: 'how-to-set-up-two-factor-authentication-2fa-for-your-bureau',
			accountsOfficeReference: 'accounts-office-reference',
			amIEligible: 'who-is-eligible-auto-enrolment',
			autorun: 'setting-your-company-payroll-to-auto-run',
			automaticTaxCodeUpdates: 'turning-on-electronic-updates-in-paycircle',
			bulkPayrollRun: 'bureaus-performing-bulk-or-batch-processes',
			closingPayeScheme: 'how-to-close-a-paye-scheme-on-paycircle',
			dataMisalignment: 'switching-payroll-why-data-can-sometimes-misalign-with-hmrc-paye-records',
			dayRateCalculation: 'an-overview-of-day-rate-calculation-methods',
			declarationOfCompliance: 'declaration-compliance',
			earlierYearUpdate: 'performing-an-earlier-year-update-on-paycircle',
			futureChanges: 'how-to-add-changes-to-future-payroll-periods',
			holidayAndSickness: 'how-to-track-holidays-and-sick-days-for-companies',
			howAreContributionsCalculated: 'employee-pension-contributions-calculated',
			howDoIPostpone: 'i-postpone-staging-date-2',
			howToAdvanceFuturePeriodsForTeamMembers: 'how-to-advance-future-periods-for-team-members',
			howToEnableElectronicHMRCNotices: 'how-to-add-hmrc-credentials-to-a-company-and-enable-electronic-updates',
			letterCodes: 'letter-code',
			maternityParternityPayEligibilityCriteria: 'am-i-eligible-for-statutory-maternity-or-paternity-pay',
			missedStagingDate: 'ive-missed-companys-workplace-pension-staging-date',
			netToGross: 'paycircles-net-to-gross-calculation-feature',
			payElementsCustomisation: 'how-to-customise-pay-elements-for-pension-calculations',
			payeReferenceNumber: 'paye-reference-number',
			payPeriods: 'setting-changing-pay-periods-paycircle',
			pensionAuthorisation: 'how-to-authorise-an-automated-pension-scheme',
			pensionConnection: 'troubleshooting-connecting-a-workplace-pension-to-paycircle',
			pensionProviders: 'pensions-that-paycircle-connects-to',
			pensionReEnrolment: 'pension-re-enrolment',
			pensionSetup: 'set-up-your-pension-with-your-provider-before-you-connect-it-to-paycircle',
			pensionStartDate: 'your-workplace-pension-start-date',
			pensionSubmissionTroubleshooting: 'how-to-troubleshoot-pension-submission-failures',
			periodOfInactivity: 'how-to-submit-a-period-of-inactivity-to-hmrc-on-paycircle',
			repaymentSchedules: 'setting-up-a-loan-repayment-on-paycircle',
			runningNilPayroll: 'submitting-a-nil-payroll-to-hmrc',
			statutorySickPay: 'statutory-sick-pay',
			taxCodeUpdates: 'troubleshooting-your-automatic-hmrc-updates-connection' ,
			tprPensionProviders: 'the-pension-regulators-list-of-workplace-pension-providers',
			updatingMaternitySchedule: 'updating-a-statutory-maternity-pay-schedule',
			whatAreTheContributions: 'auto-enrolment-contribution',
			whatDoBusinessOwnersNeedToDo: 'pension-assessment',
			whatIsADOC: 'declaration-compliance',
			whatIsAe: 'already-pension-auto-enrolment',
			whatIsW1M1: 'w1-m1-tax-code',
			whatToSendAndWhen: 'pension-communications-send-send-2',
			whoIsEligibleForAe: 'who-is-eligible-auto-enrolment',
			whyIsAeBeingIntroduced: 'employees-guide-workplace-pensions-automatic-enrolment'
		},
		help: {
			pensionGroupDatesMismatch: 'https://help-paycircle.theaccessgroup.com/en/articles/10385949-how-to-troubleshoot-a-pension-submission-failure',
		},
		userPortal: 'https://my.paycircle.co.uk/',
		website: {
			privacy: 'https://www.theaccessgroup.com/en-gb/privacy-notice/',
			terms: 'https://paycircle.co.uk/terms/'
		}
	},
	tpr: {
		declarationOfCompliance: 'https://www.autoenrol.tpr.gov.uk/',
		dutiesChecker: 'http://www.thepensionsregulator.gov.uk/en/employers/duties-checker',
		pensionProviders: 'https://www.thepensionsregulator.gov.uk/en/business-advisers/automatic-enrolment-guide-for-business-advisers/6-choosing-a-pension-scheme/find-a-new-pension-scheme-for-clients',
		registration: 'http://www.thepensionsregulator.gov.uk/en/employers/',
		website: 'http://www.thepensionsregulator.gov.uk',
		letterCode: 'https://automation.thepensionsregulator.gov.uk/LetterCode'
	}
});

'use strict';

angular.module('paycircleApp')
.constant('USER_CREDENTIALS_RESPONSE_ERROR_CODES', {
	none: 0,
	invalidToken: 1,
	invalidCredentials: 2,
	accountLocked: 3,
	passwordExpired: 4
});

'use strict';

angular.module('paycircleApp')
.constant('USER_DOCUMENT_IDS', {
	cisPayStatement: '1f17ac96-8f65-459a-8766-c6ea506cdc0b',
	combinedSupplementaryRunPayStatement: '69c40f77-0bf0-4cba-b1b6-7b9e92036384',
	manualPayStatement: '7e6324c4-38b6-45f1-a669-9d342e184dc1',
	matb1: '014343a5-afd2-49d2-a89e-ac4228c014f8',
	other: '92b337bd-e85b-4265-9391-93bb602811ff',
	p11d: '80943b01-bad0-4358-8ad3-2d3e181df759',
	p45: 'fd09b6f6-a71f-467e-abdd-a21813b5b7a4',
	p60: '699ff729-da31-4edd-9748-fba36714b633',
	payrollCisStatement: '77363db0-b5f5-4884-8be4-2932f142376d',
	payrollP45: '59a7a4ee-3d88-47d1-99df-250f1a05235d',
	payrollP60: '9f8e2ce6-ecc9-4047-bc1a-10f8ca0c00e5',
	payStatement: 'f6ba62d8-5281-4e96-b2ce-8d99e0b0b25e',
	supplementaryPayStatement: 'e646359f-0a20-4ab9-b249-b7414077605b'
})
.constant('USER_DOCUMENT_STATES', {
	visibleInUserPortal: 0,
	hiddenInUserPortal: 1
});

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.config
 * @description
 * # config
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.constant('USER_GUIDES', {
	template: {
		title: '',
		theme: '',
		readTime: '',
		url: '',
	},
	declarationOfCompliance: {
		title: '',
		theme: '',
		readTime: '',
		url: '',
	},
	employerResponsibilities: {
		title: 'Pension Auto Enrolment: Your responsibilities as an employer',
		theme: 'theme-3',
		readTime: '10 mins',
		url: 'https://paycircle.co.uk/user-guide/pension-auto-enrolment-responsibilities-employer/',
	},
	ensuringCompliancy: {
		title: 'How Paycircle ensures workplace pension compliance',
		theme: 'theme-2',
		readTime: '10 mins',
		url: 'https://paycircle.co.uk/user-guide/paycircle-ensures-workplace-pension-compliance/',
	},
	placeholder: {
		title: 'How Paycircle ensures workplace pension compliance',
		theme: 'theme-2',
		readTime: '10 mins',
		url: 'http://paycircle.co.uk/404',
	},
	tenStepsToSetupPension: {
		title: '10 easy steps to set up your workplace pension with Paycircle',
		theme: 'theme-4',
		readTime: '10 mins',
		url: 'https://paycircle.co.uk/user-guide/how-to-set-up-a-workplace-pension/',
	},
	setupPension: {
		title: 'How to set up a Workplace Pension with Paycircle',
		theme: 'theme-2',
		readTime: '8 mins',
		url: 'https://paycircle.co.uk/user-guide/how-to-set-up-a-workplace-pension/',
	},
	setupPensionInformation: {
		title: 'Information required to set up a new pension with Paycircle',
		theme: 'theme-1',
		readTime: '2 mins',
		url: 'https://paycircle.co.uk/user-guide/information-required-set-workplace-pension-paycircle/',
	}

});

'use strict';

angular.module('paycircleApp')
.constant('USER_IMPORT_GROUP_STATES', {
	complete: 0,
	incomplete: 1,
	approved: 2
});

'use strict';

angular.module('paycircleApp')
.constant('USER_PAY_ELEMENT_COMPONENT_UNIT_TYPES', {
	default: 0,
	hourly: 1,
	daily: 2
});

'use strict';

/**
 * User roles supported by the Payroll application
 */
angular.module('paycircleApp')
.constant('USER_ROLE_IDS', {
	superUser: 0,
	teamMember: 1,
	companyAdmin: 2,
	groupAdmin: 3,
	worker: 4,
	companyAdminSME: 5,
	intermediaryAdmin: 6, // unused
	companyadministratorlite: 7,
	departmentadmin: 8,
	groupAdminLite: 9
})
.constant('USER_ROLE_DESCRIPTIONS', {
	0: 'Super user',
	1: 'Team member',
	2: 'Company admin',
	3: 'Group admin',
	4: 'Employee',
	5: 'Company admin',
	6: 'Intermediary admin',
	7: 'Company admin lite',
	8: 'Department admin',
	9: 'Group admin lite'
})
.constant('USER_ROLES', {
	bureau: 'bureau',
	bureaumanager: 'bureaumanager',
	companyadministrator: 'companyadministrator',
	companyadministratorlite: 'companyadministratorlite',
	companyadmin: 'companyadmin', // Will become 'sme'
	groupadmin: 'groupadmin',
	groupadminlite: 'groupadminlite',
	groupuser: 'group',
	optimalcompliance: 'optimalcompliance',
	paycircle: 'paycircle',
	payrollworker: 'payrollworker',
	sme: 'companyadministratorsme',
	departmentadmin: 'departmentadmin'
});

'use strict';

angular.module('paycircleApp')
.constant('USER_TAX_INFO_STATES', {
	active: 	0,
	pending: 	1,
	rejected: 	2
});

'use strict';

/**
 * Specialised columns used in the Data Importer to determine what column specific data is saved when using a Horizontal mapping layout
 */
angular.module('paycircleApp')
.constant('VALIDATION_COLUMN_TYPES', {
	adjustmentId: 'efc02ca0-c681-478d-9550-eb491a598739',
	adjustmentLabel: '156e4f3a-d5bb-474a-9575-3882d88b0a52',
	adjustmentRateType: 'f4e09f77-1839-483a-864c-6ffdaa9fcef5',
	netToGross: '0aae8bcf-94bc-48ab-89b1-e6f00475521d',
	policyEffectiveDate: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
	policyHoursPerWeek: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
	policyIsPensionable: 'e5f6a7b8-c9d0-1234-efab-345678901234',
	policyPayBasis: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
	policyWeeksPerYear: 'd4e5f6a7-b8c9-0123-defa-234567890123',
	userId: 'ca3080f4-eceb-45f8-ba42-bd46bcee7984'
})
.constant('VALIDATION_COLUMN_TYPES_NAMES', {
	'efc02ca0-c681-478d-9550-eb491a598739': 'Adjustment Type ID',
	'156e4f3a-d5bb-474a-9575-3882d88b0a52': 'Adjustment Label ID',
	'f4e09f77-1839-483a-864c-6ffdaa9fcef5': 'Adjustment Rate Type ID',
	'0aae8bcf-94bc-48ab-89b1-e6f00475521d': 'Net to Gross',
	'a1b2c3d4-e5f6-7890-abcd-ef1234567890': 'Policy Pay Basis',
	'b2c3d4e5-f6a7-8901-bcde-f12345678901': 'Policy Effective Date',
	'c3d4e5f6-a7b8-9012-cdef-123456789012': 'Policy Hours Per Week',
	'd4e5f6a7-b8c9-0123-defa-234567890123': 'Policy Weeks Per Year',
	'e5f6a7b8-c9d0-1234-efab-345678901234': 'Policy Is Pensionable',
	'ca3080f4-eceb-45f8-ba42-bd46bcee7984': 'User ID'
});

'use strict';

/**
 * The variation of validation field types used in Paycircle
 */
angular.module('paycircleApp')
.constant('VALIDATION_FIELD_TYPES', {
	address: '3265426A-8F5E-4B5D-B5FF-C20DAB4EAC88',
	bankAccountNumber: 'b073cfa2-0469-4b70-a678-e49cf9278bcc',
	niNumber: 'e8eaaaa1-9b4c-4df0-be1a-b2cf79f9610f'
});

'use strict';

/**
 * The variation of validation field types used in Paycircle
 */
angular.module('paycircleApp')
.constant('VALIDATION_HIGH_PRIORITY_FIELDS', [
	'UserImportGender',
	'UserImportEmail',
	'UserImportNINumber',
	'UserImportDOB'
]);

'use strict';

/**
 * The variation of validation field types used in Paycircle
 */
angular.module('paycircleApp')
.constant('VALIDATION_IGNORE_FIELDS', [
	'UserImportID',
	'UserImportRowNumber',
	'UserPayYTDID',
	'AgencyProfileID',
	'AgencyDocumentID',
	'UserImportOwnerID',
	'UserImportDateCreated',
	'UserImportStatus',
	'ValidationResults'
]);

'use strict';

/**
 * The variation of validation field types used in Paycircle
 */
angular.module('paycircleApp')
.constant('VALIDATION_TYPES', {
	dobInWrongFormat: '90cf7880-1a9f-4597-b3be-0853d683fe59',

	nominalCodeNarrativeExists: '084eaa25-9717-4396-86a6-7c876f07d318',
	nominalCodeNarrativeIsBlank: '726c013d-8608-48cd-a93b-99476fb44d03',
		
	branchNameExists: 'cc5d7d34-a7b1-4065-949e-897577787cc7',
	branchNameIsBlank: 'b2a27260-d6e0-4c83-b895-9f5fe1870998',
	costCentreNameExists: '53710b5e-738e-4dfb-8de2-d6f148f1e667',
	costCentreNameIsBlank: '5c1d5f77-66b5-4813-ad8b-30c710987c26',
	departmentNameExists: '46131386-29bb-4217-bcfb-39b23c86b7df',
	departmentNameIsBlank: 'ade23762-962a-46cc-9fdb-6f1580bf0af0',
	roleNameExists: '37a8feb1-6b29-4755-983a-c3e0bf1a8504',
	roleNameIsBlank: '5ee0ace6-54d1-41b3-8ff9-ec40093efc43',
	sectorNameExists: 'c6ef1d6b-0fbb-4542-9b51-c63beefcb60a',
	sectorNameIsBlank: 'fffb3248-04c9-40ee-a2b9-19dd93ea4452',

	userDoesNotExist: '6212dbf5-01a6-4afa-a4b1-166d13972d22',
	userUnchanged: '00b83f9f-3b6f-468f-9124-fb1e63672377',
	userWithPayrollIDAlreadyExists: '38e667be-587e-499e-b51b-0070349fc8cf',
	userWithSubmissionIDAlreadyExists: '7968f36a-4b0a-4468-a721-36970f39dac5',
	userSubmissionIDLockedAfterPayroll: '7729c9d9-3624-4f04-8656-6c8148f5dc43',
	userWithNINumberAlreadyExists: '44ddb1fa-4c05-4504-b579-8349c2ad3509',
	userWithNINumberAlreadyExistsInPaycircle: '4278e40b-b3b9-4980-bca1-367b2cc6f56b',
	userWithNINumberAlreadyExistsOnPayeScheme: 'ae70f5ac-24f7-4f59-9bdf-429c98504a96',
	payElementWillBeUpdated: 'a0121b02-b776-4c2f-a99c-2cd1bf2b73ac',
	payElementHasMultipleMatches: '8d612ff1-a0ee-4354-8ba2-6bcf5148fd67',
	payElementWillBeCreated: '23e6b2cc-ff45-417b-8655-ae0f9040b08d',
})
.constant('VALIDATION_TYPE_LEVELS', {
	unchanged: 0,
	warning: 1,
	new: 2,
	update: 3,
});

'use strict';

angular.module('paycircleApp')
.constant('WORKFLOW_CALENDAR_TYPES', {
	calendarDays: 0,
	workingDays: 1
});

'use strict';

angular.module('paycircleApp')
.constant('WORKFLOW_OFFSET_TYPES', {
	none: 0,
	lastWorkingDay: 1,
	nextWorkingDay: 2
});

'use strict';

angular.module('paycircleApp')
.constant('WORKFLOW_TEMPLATE_STATES', {
	incomplete: 0,
	complete: 1,
	inactive: 2,
	active: 3
})

.constant('WORKFLOW_EMAIL_STATES', {
	none: 0,
	admins: 1
})

.constant('WORKFLOW_TEMPLATE_ENTRY_STATES', {
	inactive: 0,
	active: 1,
	complete: 2,
	current: 3
})

.constant('WORKFLOW_ENTRY_SPLASH_STATES', {
	inactive: 0,
	active: 1,
	complete: 2
})

.constant('WORKFLOW_CHANGES_TABLE_STATES', {
	incomplete: 0,
	submitted: 1,
	complete: 2
});

'use strict';

angular.module('paycircleApp')
.constant('WORKFLOW_STEPS', {
	payrollInformation: 1,
	payrollCalculation: 2,
	payrollConfirmation: 3,
	runPayroll: 4
});
'use strict';

angular.module('paycircleApp')
.constant('WORKFLOW_TEMPLATE_ENTRY_STATES', {
	inactive: 0,
	active: 1,
	complete: 2,
	current: 3
});

'use strict';

angular.module('paycircleApp')
.constant('WORK_PATTERN_BASIS', {
	weekly: 0,
	daily: 1
});

'use strict';

angular.module('paycircleApp')
.constant('WORK_PATTERN_DAY_TYPES', {
	working: 0,
	nonWorking: 1
})
.constant('WORK_PATTERN_DAY_TYPES_DESCRIPTIONS', {
	0: 'WD',
	1: 'NWD'
});

'use strict';

angular.module('paycircleApp')
.constant('WORK_PATTERN_GROUPS', {
	standard: 0,
	nonStandard: 1
});

'use strict';

/**
 * @ngdoc function
 * @name paycircleApp.controller:ApplicationCtrl
 * @description
 * # ApplicationCtrl
 * Controller of the paycircleApp
 */
angular.module('paycircleApp')
.controller('ApplicationCtrl', [
	'$location',
	'$rootScope',
	'$scope',
	'$q',
	'$state',
	'$timeout',
	'$window',
	'applicationService',
	'base',
	'companyData',
	'config',
	'cookieConsentService',
	'growl',
	'iframeDetectionService',
	'intercomService',
	'locationChangeService',
	'loggedUserService',
	'modalService',
	'coralogixService',
	'onboardingService',
	'payrollData',
	'pendoService',
	'securityData',
	'session',
	'silentAuthService',
	'stateService',
	'storageService',
	'telemetryLoadedEventState',
	'tracking',
	'userData',
	'utilities',
	'workflowService',
	'AUTH_EVENTS',
	'BROWSER_COMPATIBILITY_LIST',
	'COMPANY_STATES',
	'DEMO_TASKS',
	'HTTP_EVENTS',
	'INTERFACE_TYPES',
	'LOCAL_STORAGE_KEYS',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	'USER_MESSAGE_BAR_STATES',
	function (
		$location,
		$rootScope,
		$scope,
		$q,
		$state,
		$timeout,
		$window,
		applicationService,
		base,
		companyData,
		config,
		cookieConsentService,
		growl,
		iframeDetectionService,
		intercomService,
		locationChangeService,
		loggedUserService,
		modalService,
		coralogixService,
		onboardingService,
		payrollData,
		pendoService,
		securityData,
		session,
		silentAuthService,
		stateService,
		storageService,
		telemetryLoadedEventState,
		tracking,
		userData,
		utilities,
		workflowService,
		AUTH_EVENTS,
		BROWSER_COMPATIBILITY_LIST,
		COMPANY_STATES,
		DEMO_TASKS,
		HTTP_EVENTS,
		INTERFACE_TYPES,
		LOCAL_STORAGE_KEYS,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS,
		USER_MESSAGE_BAR_STATES
	) {

	function checkBrowserCompatibility () {

		if (!utilities.isBrowserCompatible()) {

			if (sessionStorage.getItem('browserWarning')) {
				// User has previously dismissed the browser warning, add tag to any following errors
				coralogixService.setCustomAttribute('user_dismissed_browser_warning', true);

			} else {
				// Show the warning as there's a browser compatibility problem
				openModalDialog('app-browser-compatibility-warning');
			}
		}
	}

	function closeAllModals () {

		// Application modals
		let modalOptions = $rootScope.modalOptions;
		let modalKeys = utilities.getKeysFromObject(modalOptions);

		for (let modalKey of modalKeys) {
			modalOptions[modalKey].isOpen = false;
		}

		// Any other modal that might be currently open
		closeModalDialog();
	}

	function canModelOpen (modalId) {
		return !utilities.checkStoredArray(LOCAL_STORAGE_KEYS.closedModals, modalId, getGuid());
	}

	function closeImageFocusPanel () {
		if (angular.isDefined($scope.imageFocus)) {
			$scope.imageFocus.isOpen = false;
		}
	}

	function changeCompanyState (currentCompanyObj) {

		let newState = onboardingService.getNextCompanyState(currentCompanyObj.State);
		let onboardingId;

		companyData.updateOnboardingState(onboardingId, currentCompanyObj.AgencyProfileID, newState).then(() => {

			// Tracking
			if (newState === COMPANY_STATES.firstPeriod) {
				tracking.trackEvent(TRACKING_EVENTS.onboardingMovedToFirstPayPeriod);
			}

			// Reload
			window.location.reload();
		})
		.catch(error => {
			console.error(error);
			growl.error('Paycircle Error: Unable to move to First pay period');
		});
	}

	function closeModal (modalOptionsObj, modalId) {

		modalOptionsObj.isOpen = false;

		utilities.addToStoredArray(LOCAL_STORAGE_KEYS.closedModals, modalId, getGuid());
	}

	function closeOverlays () {
		angular.merge($scope, {
			demoTaskComplete: null,
			formCabinet: null,
			formWizard: null,
			fullScreenModalOptions: null,
			helpAndSupportPanel: null,
			sideBarOptions: {
				activeMenu: null,
				isOpen: false
			}
		});

		// Reset app overlay
		$scope.appOverlayCount = 0;

		$rootScope.isNavOpenMobile = false;

		// Close tooltip card
		$rootScope.$broadcast('toggle-tooltip-card');
	}

	function extendCompanyTrial (currentCompanyObj, modalOptionsObj) {

		let onboardingId; // Undefined

		modalOptionsObj.canClose = false;
		modalOptionsObj.modalState = 'loading';

		// Move to onboarding
		companyData.updateOnboardingTrialExpiryDate(onboardingId, currentCompanyObj.AgencyProfileID).then(() => {

			modalOptionsObj.modalState = 'trial-extended';
		})
		.catch(error => {
			console.error(error);
			growl.error('We were unable to extend your trial. Please contact support');

			$timeout(() => {
				modalOptionsObj.savingState = 'error';
				modalOptionsObj.canClose = true;
				modalOptionsObj.isOpen = 'error';
			}, 1000);
		});
	}

	function extendCompanyTrialComplete (currentCompanyObj, modalOptionsObj) {

		stateService.setCompany(currentCompanyObj.AgencyProfileID).then(() => {

			// Close modal
			modalOptionsObj.isOpen = false;

			$state.go('company-dashboard', { agencyProfileId: currentCompanyObj.AgencyProfileID }, { reload: true });
		});
	}

	function getCurrentPeriodForCompany () {

		payrollData.getPayPeriodMinimum($rootScope.currentCompany.AgencyProfileID).then(payPeriodObj => {
			$rootScope.currentPeriod = payPeriodObj;
		})
		.catch(error => {
			growl.warning('Error loading pay period details');
			throw (error);
		});
	}

	function getGuid () {
		return $scope.currentCompany ? $scope.currentCompany.AgencyProfileID : config.guidEmpty;
	}

	function goToRequestACallback (modalOptionsObj) {
		modalOptionsObj.modalState = 'request-callback';
	}

	function hideAppOverlay () {
		// State changes which hide the overlay can reset the app overlay, so ensure it isn't already at zero before decrementing
		if ($scope.appOverlayCount > 0) {
			$scope.appOverlayCount--;
		}
	}

	function loadDemoModals (companyObj) {

		// Trial expired > Show modal
		if (companyObj.TrialDaysLeft <= 0) {
			$rootScope.modalOptions.moveToOnboarding = {
				title: 'Your 30-day free trial has ended!',
				canClose: false,
				modalState: 'expired',
				isOpen: true
			};
		}

		// In trial
		else {
			if (canModelOpen('demoLanding')) {
				companyData.getAgencyProfileCompanyOverview(companyObj.AgencyProfileID).then(modalDataObj => {

					modalDataObj.moduleList = modalDataObj.ModuleList.join(', ');
					modalDataObj.hasPensionModule = modalDataObj.ModuleList.includes('Pension') ? true : false;

					$rootScope.modalOptions.demoLanding.companyDetails = modalDataObj;
					$rootScope.modalOptions.demoLanding.isOpen = true;
				})
				.catch(error => {
					growl.error('Error loading demo modal');
					console.error(error);
				});
			}
		}
	}

	function logout (specificLogoutOptions) {

		let logoutOptions = {
			emptySessionTimeoutHeaderTitle: false,
			showSessionTimeout: false
		};

		const isAccessIdentityAccount = $rootScope.currentUser && $rootScope.currentUser.IsAccessIdentityAccount;
		const accountEmailAddress = $rootScope.currentUser && $rootScope.currentUser.AccountEmailAddress;

		// This will contain the access identity signout URL
		let accessIdentityUrl = null;

		angular.extend(logoutOptions, specificLogoutOptions);

		securityData.signOut()
			.then((data) => {
				accessIdentityUrl = data.IdentityUrl;
			})
			.finally(() => {
				// Destroy session
				$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);

				// Destroy state session data
				storageService.clearStateSessionStorage();

				// Update state
				angular.extend($rootScope, {
					isLoggedIn: false
				});

				if (isAccessIdentityAccount && accessIdentityUrl && !logoutOptions.showSessionTimeout) {
					// This is an access identity user, sign out using the URL
					window.open(accessIdentityUrl, '_self');

				} else {

					$state.go('login', {
						accountEmailAddress: accountEmailAddress,
						emptySessionTimeoutHeaderTitle: logoutOptions.emptySessionTimeoutHeaderTitle,
						isAccessIdentityAccount: isAccessIdentityAccount,
						showSessionTimeout: logoutOptions.showSessionTimeout
					});
				}
			});

	}

	function logoutFromModal () {

		logout();
	}

	function moveCompanyToOnboarding (modalOptionsObj, currentCompanyObj) {

		modalOptionsObj.canClose = false;
		modalOptionsObj.savingState = 'saving';

		// Move to onboarding
		securityData.onboardingConversion(currentCompanyObj.AgencyProfileID).then(() => {

			// Reload page
			$state.go('company-dashboard', { 'agencyProfileId': $rootScope.currentCompany.AgencyProfileID }, { reload: true });
		})
		.catch(error => {
			modalOptionsObj.savingState = null;
			console.error(error);
		});
	}

	function onStateChangeComplete (companyObj) {

		// If different company
		if (angular.isDefined(companyObj)) {
			setupCompany(companyObj);

		} else {
			// Hide loading mask
			setApplicationState('ready');
		}

		// Google Analytics
		if (!utilities.isEnvironmentLocalhost) {
			$window.gtag('set', 'page_path', $location.path());
			$window.gtag('event', 'page_view');
		}
	}

	function onStateChangeError () {

		// User is not logged in and cookie does not exist
		$rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);

		logout();
	}

	function openFormWizard (specificFormWizardOptions) {

		if (!specificFormWizardOptions) {
			console.error('Wizard options need to be provided for a form wizard to work.');
			return;
		}

		let formWizardOptions = {
			animationSpeed: 0.5,
			canCloseForm: true,
			hasOverlay: true, 						// Whether to show the full page overlay (if false, be sure that any 'in-page' changes are handled)
			size: 'medium', 						// 'small' || 'medium' (default) || 'large'
			state: 'loading',
			title: null, 							// Form title
			isWizard: true, 						// Is this form part of a wizard
			isWizardOpen: true, 					// Is this form part of a wizard
			availableInPlayground: true, 			// Can this form be seen in 'playground' mode (true) default
			availableWhenCompanyIsPensionOnly: true, // Can this form be seen when company is Pension only
			availableWhenCompanyPayrollModuleOff: true, // Can this form be seen when company is Pension only
			availableWhenPayrollPartiallySubmitted: true, // Can this form be seen when payroll has been partially submitted
			availableWhenPeriodInRollback: true, 	// Can this form be seen when the current period is in rollback
		};

		angular.extend(formWizardOptions, specificFormWizardOptions);

		// Increment app overlay count if required
		$scope.appOverlayCount += formWizardOptions.hasOverlay ? 1 : 0;

		$scope.formWizard = angular.copy(formWizardOptions);
	}

	function closeModalDialog () {

		if ($rootScope.modalDialogOptions && $rootScope.modalDialogOptions.isOpen) {
			hideAppOverlay();
			$rootScope.modalDialogOptions.isOpen = false;
			$rootScope.modalDialogOptions = null;
		}
	}

	/**
	 * Open a modal, either using modalOptions object or a modal key
	 * @param {Object | string} modalDialogOptionsObjOrKey - either a full modal options object (including
	 * modalKey property) or just the modalKey as a string (typically for simple informational modals)
	 */
	function openModalDialog (modalDialogOptionsObjOrKey) {

		// If there's a modal (of the modal-cabinet kind, with closeModal function attached) already open, close it
		if ($rootScope.modalDialogOptions && angular.isFunction($rootScope.modalDialogOptions.closeModal)) {
			$rootScope.modalDialogOptions.closeModal();
		}

		// Clear out modal dialog options regardless
		$rootScope.modalDialogOptions = null;

		$timeout(() => {
			showAppOverlay();
			// If modalDialogOptionsObjOrKey is an object, use that for modal options, otherwise create options object with single modalKey property
			const modalDialogOptions = angular.isObject(modalDialogOptionsObjOrKey) ? modalDialogOptionsObjOrKey : { modalKey: modalDialogOptionsObjOrKey };
			$rootScope.modalDialogOptions = modalService.getModalOptions(modalDialogOptions);
			$rootScope.modalDialogOptions.isOpen = true;
		});
	}

	function setIsFastSearchOpen (isFastSearchOpen) {

		$scope.isFastSearchOpen = isFastSearchOpen;
	}

	function openSideBar (sideBarOptionsObj) {

		if ($scope.sideBarOptions.isOpen) {

			//  If this sidebar is already open then close it
			if ($scope.sideBarOptions.activeMenu === sideBarOptionsObj.activeMenu) {
				angular.extend($scope.sideBarOptions, {
					activeMenu: null,
					isOpen: false
				});
				// Or display different side bar type
			} else {
				$scope.sideBarOptions.activeMenu = sideBarOptionsObj.activeMenu;
			}

		} else {

			closeOverlays();

			// Attach company and open side bar
			angular.extend(sideBarOptionsObj, {
				currentCompany: $rootScope.currentCompany,
				isOpen: true
			});

			if (!sideBarOptionsObj.currentCompany) {
				$rootScope.paycircleMessage('Side bar > Company object is missing');
				return;
			}

			angular.extend($scope.sideBarOptions, sideBarOptionsObj);
		}
	}

	function openFullScreenModal (modalOptionsObj) {

		if ($scope.appOverlayCount > 1) {
			closeOverlays();
		}

		let defaultModalOptions = {
			previewIsOpen: true,
			showClose: true
		};

		angular.extend(defaultModalOptions, modalOptionsObj);

		$timeout(() => {
			$scope.fullScreenModalOptions = defaultModalOptions;
		});
	}

	function openMoveToOnboardingModal (modalOptionsObj, currentCompanyObj) {

		modalOptionsObj.title = 'Start onboarding';
		modalOptionsObj.isOpen = true;

		// Show expired message
		if (currentCompanyObj.TrialDaysLeft <= 0) {
			modalOptionsObj.modalState = 'expired';
		}
	}

	function openRequestCallbackModal (modalOptionsObj) {

		modalOptionsObj.title = 'Request callback';
		modalOptionsObj.isOpen = true;
		modalOptionsObj.modalState = 'request-callback';
	}

	function openSlideInForm (specificFormOptions) {

		if (!specificFormOptions) {
			console.error('Form options need to be provided for a slide in form to work.');
			return;
		}

		let formDefaults = {
			agencyProfileId: null, 				// ID of the agency profile
			agencyProfileParentId: null,		// AgencyProfileID of the parent company (e.g. bureau)
			animationSpeed: 0.5, 				// Speed of the animation for the window to slide in (if updated the CSS needs to be updated to match)
			availableInPlayground: true, 		// Can this form be seen in 'playground' mode (true) default
			availableWhenCompanyArchived: false, // Can this form be seen when the company has been archived
			availableWhenCompanyIsClone: true, // Can this form be seen when company is a clone
			availableWhenCompanyPAYESchemeCeased: false, // Can this form be seen when PAYE scheme has been ceased
			availableWhenCompanyPAYESchemeCeasedPending: true, // Can this form be seen when PAYE scheme is pending
			availableWhenCompanyIsPensionOnly: true, // Can this form be seen when company is Pension only
			availableWhenCompanyPayrollModuleOff: true, // Can this form be seen when company has no payrol;
			availableWhenNotUnsubmitted: true, 	// Can this form be seen when payroll is not unsubmitted
			availableWhenPayrollPartiallySubmitted: true, // Can this form be seen when payroll has been partially submitted
			availableWhenPayrollCalculated: true, // Can this form be seen when payroll has been calculated / locked
			availableWhenPeriodInRollback: true,// Can this form be seen when the current period is in rollback
			availableWhenTeamMemberOnHold: true, // Can this form be seen when the team member is marked as 'On hold'
			availableWhenTeamMemberIsAdvancingOrAdvanced: true, // Can this form be seen when the team member is marked as 'Advancing' or 'Advanced'
			canCloseForm: true, 				// Can the form be closed
			closeIcon: null, 					// 'close' (default) || 'right'
			contextType: null,					// 'user' || 'company'
			currentPayPeriod: null,
			hasOverlay: true, 					// Whether to show the full page overlay (if false, be sure that any 'in-page' changes are handled)
			initCallbackOnClose: false, 		// Force the callback when the form closes, if supplied
			isCloseFormDisabled: false,			// Allows disabling of close icon
			isOpen: true, 						// Is the form open or not
			isPayPeriodCurrentRequired: false, 	// Option to load the full pay period object. If passed into the form options, the formOptions.currentPeriod object will be used
			isPayPeriodMinimumRequired: false,  // If the form needs the minimum pay period obj, it can be fetched at the form cabinet level. If available, the $rootScope.currentPeriod will be used
			payPeriodServiceType: null, 		// Option to switch between pay period services, in trying to deprecate GetPayPeriodCurrent 'current' || 'minimum'
			requiredPermissions: null, 			// Does the form require any permissions to be used (set in form-options.js)
			showContext: true, 					// Option to hide the context bar
			showHeader: true, 					// Options to hide the header bar
			showPensionContext: false,			// Option to show pension context
			showProgressBar: false, 			// Show a progress bar above the form
			size: 'medium', 					// 'small' || 'medium' (default) || 'large'
			title: null, 						// Form title
			userId: null, 						// User ID
			wizard: false 						// Is this form part of a wizard
		};

		let formOptions = angular.merge({}, formDefaults, specificFormOptions);

		// Increment the app overlay count if required.
		if (formOptions.hasOverlay) {
			showAppOverlay();
		}

		$scope.formCabinet = {
			options: angular.copy(formOptions),
			visible: true
		};

		utilities.focusOnFirstChild('slideInFormContent');
	}

	function openImageFocusPanel (imageFocus) {
		$scope.imageFocus = angular.extend(imageFocus, {
			isOpen: true
		});
	}

	/**
	 * Open the help and support panel
	 * @param {} helpAndSupportOptions structure:
	 * {
	 * 		articleKey?: string (key for specific article. No default, its presence implies the article view
	 * 			in help and support). If present, this trumps category and / or searchTerm.
	 * 		categoryId?: ID of category to display. If present, this trumps searchTerm.
	 * 		supportContext?: Support context if applicable. This will be a category slug and, when specified, Help and Support will be limited to this single category.
	 * 		isOpen?: boolean (is panel open or closed - default to open)
	 * 		position?: string ('left' or 'right' - position on screen, defaults to 'left')
	 * 		refresh?: boolean (forces refresh if the panel is already open - defaults to true)
	 *		searchTerm?: string. Search term to initiate a search, its presence implies the search view.
		*		showBreadcrumb?: boolean. Show or hide breadcrumb. Defaults to true.
		*		showLinkToFullPage?: boolean. Show or hide the link to open the article full page (applies to inline only). Defaults to false.
		*		showRelated?: boolean. Show or hide related articles. Defaults to true.
		* 		tags?: string[] (set of category tags to initiate category viewing, used in contextual help, no default.
		*			Its presence implies the category view in help and support). If present, this trumps searchTerm.
		* }
		* If specific help and support info isn't specified (i.e. no tags or articleKey), the panel will default to
		* the home screen to initiate browsing.
		*/
	function openHelpAndSupportPanel (helpAndSupportOptions) {

		// Close modal, in case one is open (some have help and support links)
		closeModalDialog();

		// Try determining help and support options if they haven't been specified
		if (!angular.isDefined(helpAndSupportOptions)) {

			/* Determine support context if there is one. There should be *EITHER* a single context for the whole app,
				*OR* role-specific contexts *OR* neither. In the latter case, there's no restriction on Help and Support
				where the option is available in the app header */
			let supportContext;
			if (angular.isDefined(config.supportContext)) {
				// There's a support context in config. This would be an app-wide context for Help and Support.
				supportContext = config.supportContext;
			}
			else if (angular.isDefined(config.supportRoleContexts) && config.supportRoleContexts.length) {
				// There are role based support contexts. This would limit Help and Support based on role.
				const userPrimaryRole = utilities.getPrimaryRole(session.user.UserResponseRoles);
				config.supportRoleContexts.forEach(supportRoleContext => {
					if (userPrimaryRole === supportRoleContext.primaryRole) {
						supportContext = supportRoleContext.supportContext;
					}
				});
			}

			/* If a Help and Support context has been established, set the options accordingly. Options are restricted when a support context
				is present. If not, look for contextual help and support. */
			if (angular.isDefined(supportContext)) {
				helpAndSupportOptions = {
					supportContext,
					showBreadcrumb: false,
					showLinkToFullPage: false,
					showRelated: false
				};
			}
			else {
				if (angular.isDefined($state.current.data) && angular.isDefined($state.current.data.helpAndSupportOptions)) {
					helpAndSupportOptions = $state.current.data.helpAndSupportOptions;

					// If this is contextual (dependent on company type), there should be a specific entry for the current company type
					if (helpAndSupportOptions.isContextual) {
						helpAndSupportOptions = helpAndSupportOptions[$rootScope.currentCompany.CompanyType];
					}
				}
			}
		}

		// Default options
		const defaultOptions = {
			isOpen: true,
			position: 'left',
			// Used only to force a refresh if the Help and Support panel is already open
			refresh: true,
			showBreadcrumb: true,
			showLinkToFullPage: true,
			showRelated: true,
		};

		// Show overlay if required (i.e. if the Help and Support panel isn't already open). See initialisation comments below.
		if ($scope.helpAndSupportPanel === null || !$scope.helpAndSupportPanel.options.isOpen) {
			showAppOverlay();
		}

		// Hide Intercom launcher while this is open
		intercomService.hideIntercomLauncher();

		// Show help and support panel
		$scope.helpAndSupportPanel = {
			options: angular.merge({}, defaultOptions, helpAndSupportOptions)
		};
	}

	function openTemplateForm () {

		openSlideInForm({
			formKey: 'template'
		});
	}

	function requestCallBack (modalOptionsObj, currentCompanyObj, currentUserObj, redirectModalKey) {

		// Attach telephone number onto UserObj
		currentUserObj.telephoneNumber = modalOptionsObj.telephoneNumber;

		// Get mailTo object for company state
		let mailToObj = onboardingService.getRequestCallbackObjectForCompany(currentUserObj, currentCompanyObj);

		// Open mail
		utilities.openMailToFromObj(mailToObj);

		modalOptionsObj.modalState = redirectModalKey !== undefined ? redirectModalKey : 'expired';
	}

	function setApplicationModals () {

		let modalOptionsObj = {
			addingTeamMembers: {
				title: 'Adding team members',
				isOpen: false,
				size: 'm',
			},
			demoLanding: {
				isOpen: false,
				canClose: false,
				size: 'l',
				title: 'Your 30-day free trial has started!',
			},
			moveToOnboarding: {
				isOpen: false,
				modalState: 'onboard',
				size: 'm',
				telephoneNumber: '',
				title: 'Start onboarding now'
			}
		};

		$rootScope.modalOptions = modalOptionsObj;

		checkBrowserCompatibility();
	}

	function setApplicationState (newApplicationState) {
		$rootScope.applicationState = newApplicationState;
	}

	function setDemoTaskAsComplete (demoTaskShort, firstName) {

		let activeDemo = session.getActiveDemo();

		if (activeDemo && activeDemo.demoTask === demoTaskShort) {
			if (!activeDemo.next) {
				if (!activeDemo.onboardingQuestionID) {
					companyData.updateOnboardingQuestionGroupComplete(activeDemo.onboardingId, activeDemo.onboardingQuestionGroupId, true).then(() => {

						session.resetActiveDemo();
						$rootScope.demoTaskComplete = {
							demoShortId: demoTaskShort,
							groupId: activeDemo.onboardingQuestionGroupID
						};
					})
					.catch(error => {
						console.error(error);
						growl.error('Error completing task');
					});
				} else {

					companyData.updateOnboardingQuestionComplete(activeDemo.onboardingQuestionID, true).then(() => {

						session.resetActiveDemo();
						if (!firstName) {
							firstName = 'unknown';
						}
						$rootScope.demoTaskComplete = {
							demoShortId: demoTaskShort,
							firstName: firstName,
							groupId: activeDemo.onboardingQuestionGroupID
						};
					})
					.catch(error => {
						console.error(error);
						growl.error('Error completing task');
					});
				}
			} else {

				session.resetActiveDemo();
				session.setActiveDemo(activeDemo.next);
			}
		}
	}

	function setIsNavActive (isNavActive) {
		$rootScope.isNavActive = isNavActive;
	}

	function setSession (sessionObj) {
		$rootScope.session = angular.isObject(sessionObj) ? sessionObj : null;
	}

	function setupAppFromStorage (sessionDataObj) {

		// Set company breadcrumbs
		stateService.setCompaniesStorageFromSessionStorage(sessionDataObj.app.companiesStorage);

		// Go to saved state
		if (sessionDataObj.state.name) {
			$state.go(sessionDataObj.state.name, sessionDataObj.state.params);
		}

		setupCompany($rootScope.currentCompany);
	}

	function setupCompany (companyObj) {

		// Set defaults
		resetPageForCompany();

		// Set company on Coralogix
		coralogixService.setCompany(companyObj);

		// Set company on Pendo
		pendoService.setCompany(companyObj);

		/* Kick off retrieval of workflow and payroll tasks. This is done in advance so a count can be ascertained. This
			is only applicable to users with bureau (and paycircle) roles */
		if (companyObj.CompanyType === INTERFACE_TYPES.bureau) {
			workflowService.refreshUserTasks(companyObj.AgencyProfileID, $rootScope.currentUser.UserResponseUserID);
		}
		else {
			workflowService.removeStoredTasks();
		}

		// Demo companies - free trial expired
		if (companyObj.State === COMPANY_STATES.demo) {
			loadDemoModals(companyObj);
		}

		// Set navigation active state
		if (companyObj.State !== COMPANY_STATES.onboarding) {
			setIsNavActive(true);
		} else {
			setIsNavActive(false);
		}

		// Load minimum pay period object for app header > Not applicable for bureau/company group
		if (companyObj.isPayrollCompany) {
			getCurrentPeriodForCompany();
		}
		else {
			resetCurrentPeriod();
		}

		// Hide loading mask
		setApplicationState('ready');
	}

	function showAppOverlay () {
		// To be safe, ensure the app overlay count is set to 1 if it's already at zero or below. This shouldn't really happen.
		if ($scope.appOverlayCount <= 0) {
			$scope.appOverlayCount = 1;
		}
		else {
			$scope.appOverlayCount++;
		}
	}

	function resetCurrentPeriod () {
		$rootScope.currentPeriod = null;
	}

	function resetPageForCompany () {

		// Clear current period
		resetCurrentPeriod();

		// Close all modals when switching company
		closeAllModals();

		// Reset saved filters
		utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.savedFilters);
	}

	function toggleModalIsOpen (modalOptions) {

		if (modalOptions === undefined) {
			$rootScope.paycircleMessage('Modal is not registered', 'error');
			return;
		}

		modalOptions.isOpen = !modalOptions.isOpen;
	}

	function togglePlayground () {

		setApplicationState('loading');

		const currentUserObj = $rootScope.currentUser;

		userData.updateUserProfileIsInPlaygroundMode(currentUserObj.UserResponseUserID, !currentUserObj.AgencyProfileDummy).then(() => {

			securityData.isUserLoggedIn().then(userObj => {

				// Remove playground action box
				$rootScope.showPaycircleTools = false;

				if (userObj.Session2FARequired) {

					// User required two-factor authentication
					$state.go('authentication', { user: userObj });
				} else {

					window.location = '/';

					// Reset app state
					stateService.onSessionDestroy();
				}
			});
		})
		.catch(error => {
			console.error(error);
			$rootScope.paycircleMessage(`togglePlayground: Unable to switch to ${currentUserObj.AgencyProfileDummy ? 'Test' : 'Live'} Mode`, 'error');
		});
	}

	function trySilentAuth (userResponseUserId) {
		return silentAuthService.silentAuthenticateUser(userResponseUserId)
			.catch(function (err) {
				console.error('trySilentAuth failed:', err);
				return $q.reject(err);
			});
	}

	// Setup defaults
	setApplicationState('loading');
	setApplicationModals();
	setSession(session);
	stateService.setupDefaults();
	tryEnableAnalytics();

	// Root Scope
	angular.extend($rootScope, {
		closeModalDialog,
		openModalDialog,
		setDemoTaskAsComplete,
		toggleModalIsOpen,

		isNavOpen: true,
		isNavOpenMobile: false,
		isFullScreenEnabled: utilities.isFullScreenEnabled(),

		loadingMaskOptions: {
			showMask: false,
			message: ''
		},
		modalDialogOptions: null,
		userMessageBarState: ''
	});

	// Scope
	angular.extend($scope, {
		BROWSER_COMPATIBILITY_LIST,
		COMPANY_STATES,
		config,
		DEMO_TASKS,
		INTERFACE_TYPES,

		formCabinet: null,
		formWizard: null,
		helpAndSupportPanel: null,

		isDevelopment: utilities.isDevelopment(),

		modal: [],
		showFastSearch: false,

		sideBarOptions: {
			activeMenu: null,
			currentCompany: null,
			isOpen: false
		},

		/* The app overlay count allows a single overlay to be displayed for multiple components; e.g. if both the Help and
			Support panel and a slide in form panel are visible at the same time, only one overlay will be displayed. Similarly it
			will ensure that the overlay remains when only one of the panels is closed. */
		appOverlayCount: 0,
		changeCompanyState,
		closeImageFocusPanel,
		closeModal,
		extendCompanyTrial,
		extendCompanyTrialComplete,
		goToRequestACallback,
		initTimeoutWarningCountdown: session.initTimeoutWarningCountdown,
		isFastSearchOpen: false,
		isStateActive: applicationService.isStateActive,
		logout,
		logoutFromModal,
		moveCompanyToOnboarding,
		openFormWizard,
		openImageFocusPanel,
		openHelpAndSupportPanel,
		openMoveToOnboardingModal,
		openRequestCallbackModal,
		openSlideInForm,
		openTemplateForm,
		requestCallBack,
		userHasRole: applicationService.userHasRole
	});

	function checkCookieConsent(userObj) {

		if (loggedUserService.isEvoEnabled() && $rootScope.currentUser.IsEvoNative) {
			cookieConsentService.initAccessSdk()
				.then(tryEnableAnalytics);
		}
		else{
			if (!cookieConsentService.hasShownBanner()) {
				base.isFeatureEnabled(userObj.AgencyProfileID, 'COOKIE_POLICY').then(function(isFeatureEnabled) {
					
					if (isFeatureEnabled) {
						// Immediately show modal without delay to prevent bypass
						openModalDialog({
							modalKey: 'cookie-preferences'
						});
					}
				}).catch(function(error) {
					console.warn('Cookie policy feature flag check failed:', error);
				});
			}
		}
	}

	function tryEnableAnalytics(){
		coralogixService.initCoralogix();
		tracking.enableGoogleAnalytics();
	}

	function handlePostMessage(event) {
		const ALLOWED_ORIGINS = [
			'http://localhost:4792',
			'https://preprodgo.accessacloud.com',
			'https://demogo.accessacloud.com',
			'https://go.accessacloud.com'
		];
		
		const MESSAGE_TYPES = {
			CHECK_SESSION: 'paycircle:check-session'
		};

		// Origin validation
		if (!ALLOWED_ORIGINS.includes(event.origin)) {
			console.warn('Rejected message from unauthorized origin:', event.origin);
			return false;
		}

		// Parse and validate data
		const parsedData = parseMessageData(event.data);
		if (!parsedData) {
			return false;
		}

		// Handle different message types
		switch (parsedData.type) {
			case MESSAGE_TYPES.CHECK_SESSION:
				handleSessionCheck(parsedData.userId);
				break;
			default:
				console.warn('Unknown message type:', parsedData.type);
				return false;
		}

		return true;
	}

	function parseMessageData(rawData) {
		let data = rawData;
		
		if (typeof data === 'string') {
			try {
				data = JSON.parse(data);
			} catch (e) {
				console.warn('Invalid JSON in message data:', e);
				return null;
			}
		}

		if (!data || typeof data !== 'object' || Array.isArray(data)) {
			console.warn('Invalid message data format');
			return null;
		}

		return data;
	}

	function handleSessionCheck(userId) {
		const currentUserId = $rootScope.currentUser && $rootScope.currentUser.UserResponseUserID;
		const targetUserId = userId || null;

		// Use explicit userId if provided (new flow)
		if (targetUserId && currentUserId && String(targetUserId) !== String(currentUserId)) {
			return trySilentAuth(targetUserId);
		}

		// Normal session extension
		$rootScope.$applyAsync(function() {
			$rootScope.$broadcast('check-user-session', angular.noop, targetUserId);

			if ($rootScope.isLoggedIn && session) {
				session.extend();
			}
		});
	}

	$window.addEventListener('message', handlePostMessage, false);

	// AUTH Events
	// Create session
	$rootScope.$on(AUTH_EVENTS.sessionCreate, function (event, userObj, agencyProfileId, slackToken) {

		setApplicationState('loading');

		const sessionDataObj = storageService.getObjectFromSessionStorage(LOCAL_STORAGE_KEYS.sessionData, false);

		stateService.onAuthenticatedLogin(userObj).then(sessionUserObj => {

			telemetryLoadedEventState.setState(true, userObj.primaryRole, userObj.UserResponseLastLoggedInDateISO, userObj.AccountSessionAuthenticationTimeISO);

			if (sessionDataObj && sessionDataObj.hasTimedOut && sessionDataObj.user.userId === userObj.UserResponseUserID) {
				setupAppFromStorage(sessionDataObj);

			} else {
				applicationService.redirectToDefaultPage(sessionUserObj, agencyProfileId, slackToken);
			}

			// Check cookie consent immediately after session setup
			checkCookieConsent(userObj);
		});
	});

	// Destroy session
	$rootScope.$on(AUTH_EVENTS.sessionDestroy, function () {

		// Delete token
		utilities.deleteToken();

		// Clear temp roles/permissions
		if ($rootScope.currentUser && $rootScope.currentUser.hasTempPermissions) {
			utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.tempPermissions);
		}

		// Clear app message bar
		applicationService.setUserMessageState(null);

		// Remove users session
		session.destroy();

		// Remove current period
		resetCurrentPeriod();

		// Remove app state data
		stateService.onSessionDestroy();

		// Make navigation inactive
		setIsNavActive(false);

		// Reset workflow tasks
		workflowService.removeStoredTasks();

		// Close intercom
		intercomService.shutdownIntercom();

		// Destroy Pendo
		pendoService.destroy();
	});

	// Not Authenticated
	$rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {

		// Show user a message that they're not logged in
		growl.warning('You\'re not logged in. Please sign in to continue.');
	});

	// Not Authorised
	$rootScope.$on(AUTH_EVENTS.notAuthorised, function () {

		if (iframeDetectionService.isRunningInIframe()) {
			const userId = $rootScope.currentUser && $rootScope.currentUser.UserResponseUserID;
			trySilentAuth(userId);
		} else {
			growl.warning('You do not have the necessary role or permissions to view that page.');
		}
		// Show user a message that they're not authorised to view the current page
	
	});

	// Session timeout warning
	$rootScope.$on(AUTH_EVENTS.sessionTimeoutWarning, function (event, timeoutPeriodMs) {

		const timeoutPeriodSeconds = utilities.convertMillisecondsToSeconds(timeoutPeriodMs);

		if (!iframeDetectionService.isRunningInIframe()) {
			openModalDialog({
				callback: logoutFromModal.bind(this),
				modalKey: 'session-timeout-warning',
				modalData: {
					timeoutPeriodSeconds
				}
			});
		}
	});

	// Session timeout
	$rootScope.$on(AUTH_EVENTS.sessionTimeout, function (event, data) {

		/* Need to ensure application level legacy modals are closed. This can be removed
			when all modals have been refactored to the new modal-cabinet structure.
			(The subsequent openModalDialog call to show the session timed out modal will
			close the session timeout warning modal) */
		closeAllModals();

		// Save data to session storage to use later
		session.updateSessionData({
			hasTimedOut: true
		});

		// Track number of timeouts
		tracking.trackEvent(TRACKING_EVENTS.userSessionTimedOut, {
			event_category: TRACKING_EVENT_CATEGORIES.authentication,
			event_label: 'User session timed out'
		});

		const logoutObj = {
			showSessionTimeout: true
		};

		if (data && data.emptySessionTimeoutHeaderTitle) {
			logoutObj.emptySessionTimeoutHeaderTitle = data.emptySessionTimeoutHeaderTitle;
		}

		if (iframeDetectionService.isRunningInIframe()) {
			const userId = $rootScope.currentUser && $rootScope.currentUser.UserResponseUserID;
			trySilentAuth(userId);
		} else {
			logout(logoutObj);
		}
	});

	// HTTP Events
	// Show growl message for 400 server errors: Bad requests
	$rootScope.$on(HTTP_EVENTS.badRequest, function () {
		growl.warning('Something appears to have gone wrong. If this continues to happen please contact our support team.');
		$rootScope.paycircleMessage('400: Bad Request', 'warn');
	});

	// Show growl message for 403 server errors: Forbidden requests
	$rootScope.$on(HTTP_EVENTS.notAuthorised, function (event, response) {
		const isHolidayDelete = response && response.config && response.config.url && response.config.url.indexOf('DeleteHolidayDetail') !== -1;
		let message = 'You do not have access to some services on this page so things might not work correctly. If this appears incorrect please contact our support team.';

		if (isHolidayDelete) {
			message = 'This holiday is managed by a source system and cannot be deleted in Paycircle. Delete it in the source system instead.';
		}

		growl.warning(message);
		$rootScope.paycircleMessage('403: Forbidden', 'warn');

		coralogixService.noticeError('403: Forbidden', { requestUrl: response.config.url });
	});

	// Show growl message for 404 server errors: Not found
	$rootScope.$on(HTTP_EVENTS.notFound, function () {
		growl.warning('Some services on this page cannot be found. If this continues please contact our support team.');
		$rootScope.paycircleMessage('404: Not found', 'warn');
	});

	// Show growl message for 0 server errors: Unreachable - Firewalls etc
	$rootScope.$on(HTTP_EVENTS.unreachable, function () {
		growl.warning('We were unable to connect to Paycircle. Try again in a moment. If this continues please contact our support team.');
		$rootScope.paycircleMessage('0: Unreachable', 'warn');
	});

	// Custom Events
	$rootScope.$on('check-user-logged-in', function () {
		// Previously this call was fire-and-forget. If the service returns 401 the
		// $http interceptor broadcasts a not-authenticated event but the returned
		// promise was not observed by the caller. That left failures hidden and
		// prevented attempts to silently re-authenticate in iframe contexts.
		securityData.isUserLoggedIn()
			.then(() => {
				// nothing to do when signed in
			})
			.catch(() => {
				// If inside an iframe, attempt silent authentication. If that fails
				// or we're not in an iframe, trigger the session timeout flow.
				if (iframeDetectionService.isRunningInIframe()) {
					const userId = $rootScope.currentUser && $rootScope.currentUser.UserResponseUserID;
					trySilentAuth(userId);
				} else {
					$rootScope.$broadcast(AUTH_EVENTS.sessionTimeout, { emptySessionTimeoutHeaderTitle: true });
				}
			});
	});

	$rootScope.$on('check-user-session', function (event, onComplete, targetUserId) {

		function onSessionTimeout (data) {
			// Show timeout modal
			$rootScope.$broadcast(AUTH_EVENTS.sessionTimeout, data);
		}

		securityData.isUserLoggedInMinimal()
		.then(isLoggedIn => {
			if (!isLoggedIn) {
				if (iframeDetectionService.isRunningInIframe()) {
					const userId = targetUserId || ($rootScope.currentUser && $rootScope.currentUser.UserResponseUserID);
					return trySilentAuth(userId);
				} else {
					onSessionTimeout();
				}
			}
		})
		.catch(() => {
			// Session has timed out - try silent auth if in iframe context
			if (iframeDetectionService.isRunningInIframe()) {
				const userId = targetUserId || ($rootScope.currentUser && $rootScope.currentUser.UserResponseUserID);
				return trySilentAuth(userId);
			} else {
				onSessionTimeout({ emptySessionTimeoutHeaderTitle: true });
			}
		})
		.finally(() => {
			// Always complete promise after any attempted silent auth or session timeout handling
			onComplete();
		});
	});

	$rootScope.$on('close-fast-search', function () {
		setIsFastSearchOpen(false);
	});

	$rootScope.$on('close-image-focus', function () {
		$scope.closeImageFocusPanel();
	});

	$rootScope.$on('set-current-company', function (event, companyId, onComplete) {
		stateService.setCompany(companyId)
			.then(onStateChangeComplete)
			.then(onComplete);
	});

	$rootScope.$on('open-help-and-support-panel', function (_event, helpAndSupportOptions) {
		$scope.openHelpAndSupportPanel(helpAndSupportOptions);
	});

	$rootScope.$on('close-help-and-support-panel', function () {
		// Reinstate the Intercom launcher
		intercomService.showIntercomLauncher();
		// Reduce app overlay count
		hideAppOverlay();
	});

	$rootScope.$on('open-image-focus', function (_event, imageFocus) {
		$scope.openImageFocusPanel(imageFocus);
	});

	$rootScope.$on('open-fast-search', function () {
		setIsFastSearchOpen(true);
	});

	$rootScope.$on('open-form-wizard', function (event, wizardOptions) {
		$scope.openFormWizard(wizardOptions);
	});

	$rootScope.$on('open-side-bar', function (event, sidebarOptions) {
		openSideBar(sidebarOptions);
	});

	$rootScope.$on('open-slide-in-form', function (event, formOptions) {
		$scope.openSlideInForm(formOptions);
	});

	$rootScope.$on('close-slide-in-form', function () {
		// Reduce app overlay count
		hideAppOverlay();
	});

	$rootScope.$on('open-full-screen-modal', function (event, modalOptionsObj) {
		openFullScreenModal(modalOptionsObj);
	});

	$rootScope.$on('log-out', function () {
		logout();
	});

	$rootScope.$on('refresh-current-period', getCurrentPeriodForCompany);

	$rootScope.$on('reassign-stored-companies', function (event, storedCompaniesObj) {
		stateService.setCompaniesStorageFromSessionStorage(storedCompaniesObj);
	});

	// Reset stored companies in breadcrumbs
	$rootScope.$on('reset-company-storage', stateService.resetCompanyStorage);

	$rootScope.$on('toggle-playground', togglePlayground);

	$rootScope.$on('cookieConsentChanged', function () {
		// Reload tracking services when consent changes
		tryEnableAnalytics();
	});

	$rootScope.$on('showCookiePreferences', function () {
		openModalDialog({
			modalKey: 'cookie-preferences'
		});
	});

	// Global page initialisation
	$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {

		let cancelRequestOnStateChange = toState.data && angular.isDefined(toState.data.cancelRequestOnStateChange) ? toState.data.cancelRequestOnStateChange : true;

		// Cancel any pending XMR requests (can set options at state level and service level)
		if (cancelRequestOnStateChange) {
			applicationService.cancelFlaggedPendingRequests();
		}

		const params = $location.search();
		const isEvoButtonNav = params.userid && params.email;

		// Check for iframe context and attempt silent authentication
		if ((iframeDetectionService.isRunningInIframe() || isEvoButtonNav) && toState.name === 'login') {
			trySilentAuth();
		}

		setIsFastSearchOpen(false);
		closeOverlays();
		
		// Don't close cookie preferences modal during state changes
		if ($rootScope.modalDialogOptions && $rootScope.modalDialogOptions.modalKey !== 'cookie-preferences') {
			closeModalDialog();
		}

		// Check cookie consent on every state change for logged in users
		if ($rootScope.currentUser && !cookieConsentService.hasShownBanner()) {
			checkCookieConsent($rootScope.currentUser);
		}

		// showSessionTimeout is set exclusively by the AUTH_EVENTS.sessionTimeout event, when moving to the login state after session timeout
		if (toParams.showSessionTimeout) {

			const openModalDialogObj = {
				modalKey: 'session-timed-out'
			};

			if (toParams.emptySessionTimeoutHeaderTitle) {
				openModalDialogObj.title = '';
			}

			openModalDialog(openModalDialogObj);
		}

		stateService.onStateChange(event, toState, toParams)
			.then(onStateChangeComplete)
			.catch(onStateChangeError);
	});

	$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {

		// Check cookie consent again after successful state change
		if ($rootScope.currentUser && !cookieConsentService.hasShownBanner()) {
			checkCookieConsent($rootScope.currentUser);
		}

		// Check when the timeoutWarning must show
		if (config.appTimeoutMessage !== '' && !toState.data.hideUserMessageBar && [USER_MESSAGE_BAR_STATES.timeoutWarning, '', null].includes($rootScope.userMessageBarState)) {
			applicationService.setUserMessageState(USER_MESSAGE_BAR_STATES.timeoutWarning);
		}

		if (locationChangeService.shouldTrackLocation()) {
			locationChangeService.trackLocationChange(toState, toParams, $rootScope.currentUser.UserResponseUserID);
		}
	});
}]);

'use strict';

angular.module('paycircleApp')
.service('accessButtonService', ['$q', '$window', '$rootScope', 'utilities', 'securityData',
	function ($q, $window, $rootScope, utilities, securityData) {
		
	let accessButton;
	let initializing = false;

	let service = {
		getInstance: getInstance,
		initialize: initialize,
		sendTelemetry: sendTelemetry, 
		sendImportsTelemetry: sendImportsTelemetry
	};

	let workItemQueue = loadQueueFromStorage();

	function saveQueueToStorage() {
		try {
			$window.localStorage.setItem('accessButtonQueue', JSON.stringify(workItemQueue));
		} catch (e) {
			console.error('Failed to save queue to localStorage:', e);
		}
	}

	function loadQueueFromStorage() {
		try {
			const data = $window.localStorage.getItem('accessButtonQueue');
			return data ? JSON.parse(data) : [];
		} catch (e) {
			console.error('Failed to load queue from localStorage:', e);
			return [];
		}
	}

	function clearQueueFromStorage() {
		try {
			$window.localStorage.removeItem('accessButtonQueue');
		} catch (e) {
			console.error('Failed to clear queue from localStorage:', e);
		}
	}

	function processQueue () {
		if (!accessButton || workItemQueue.length === 0){ 
			return;
		}
		setTimeout(() => {
			workItemQueue.forEach(item => {
				try {
					accessButton.trackWorkItem({
						ticketId: item.ticketId,
						productReportingCode: item.productReportingCode,
						payload: { correlationId: item.correlationId },
					});
				} catch (error) {
					console.error('Failed to process work item:', error);
				}
			});
			workItemQueue = [];
			clearQueueFromStorage();
		}, 1000);
	}

	function getInstance () {

		let deferred = $q.defer();

		if (accessButton) {
			deferred.resolve(accessButton);
		}
		else if (!initializing) {
			initialize()
				.then(deferred.resolve)
				.catch(deferred.reject);
		}

		return deferred.promise;
	}

	function initialize () {

		let deferred = $q.defer();

		if ($rootScope.currentUser.IsAccessWorkspaceAccount && $rootScope.currentUser.IsApplicationProvisioned && !$rootScope.currentUser.IsEvoNative) {
			initializing = true;

			$window.initialiseAccessButton({
				overrideNavigationType: true,
				positions: {
					parentElement: '.access-button'
				},
				closedZIndex: 999,
				environment: utilities.getButtonEnvironmentKey(),
				getToken: () => getAccessButtonToken($rootScope.currentUser.AgencyProfileID)
			})
				.then((result) => {
					accessButton = result;
					initializing = false;
					processQueue();
					deferred.resolve(accessButton);
				})
				.catch((error) => {
					initializing = false;
					console.error(error);
					deferred.reject(error);
				});
		}

		return deferred.promise;
	}

	function getAccessButtonToken (agencyProfileId) {

		let deferred = $q.defer();

		securityData.getAccessButtonToken(agencyProfileId)
			.then(tokenResponse => {
				try {
					const buttonResponse = {
						access_token: tokenResponse.access_token,
						expires_in: tokenResponse.expires_in,
						token_type: tokenResponse.token_type
					};

					const response = new Response(JSON.stringify(buttonResponse), {
						status: 200,
						headers: {
							'Content-Type': 'application/json',
						},
					});

					deferred.resolve(response);
				} catch (error) {
					deferred.reject(error);
				}
			})
			.catch(error => {
				deferred.reject(error);
			});

		return deferred.promise;
	}

	function sendImportsTelemetry(ticketId, productReportingCode, correlationId)
	{
		if (!($rootScope.currentUser.IsAccessWorkspaceAccount && $rootScope.currentUser.IsApplicationProvisioned)) {
			return;
		}

		workItemQueue.push({
			ticketId,
			productReportingCode,
			correlationId
		});
		saveQueueToStorage();
	}

	function sendTelemetry (ticketId, productReportingCode, correlationId) {

		getInstance()
			.then((button) => {
				button.trackWorkItem({
					ticketId: ticketId,
					productReportingCode: productReportingCode,
					payload: { correlationId: correlationId },
				});
		})
		.catch((error) => {
			console.error('Failed to get access button instance:', error);
		});
	}
	

	return service;
	
	}
]);


'use strict';

angular.module('paycircleApp')
.service('dependencyLoaderService', [
	'$q',
	'$timeout',
	'$document',
function (
	$q,
	$timeout,
	$document
) {

	const DEFAULT_TIMEOUT_MS = 10000;

	const scriptStates = {};

	const service = {
		loadScript
	};

	function loadScript (url, options) {
		options = options || {};
		const timeoutMs = options.timeout || DEFAULT_TIMEOUT_MS;

		if (!scriptStates[url]) {
			scriptStates[url] = {
				loaded: false,
				loadPromise: null
			};
		}

		const state = scriptStates[url];

		if (state.loaded) {
			return $q.resolve();
		}

		if (state.loadPromise) {
			return state.loadPromise;
		}

		state.loadPromise = $q(function (resolve, reject) {
			const script = $document[0].createElement('script');
			script.src = url;
			script.async = true;

			const timeoutPromise = $timeout(function () {
				state.loadPromise = null;
				reject(new Error('Script load timed out after ' + timeoutMs + 'ms: ' + url));
			}, timeoutMs);

			script.onload = function () {
				$timeout.cancel(timeoutPromise);
				state.loaded = true;
				resolve();
			};

			script.onerror = function () {
				$timeout.cancel(timeoutPromise);
				state.loadPromise = null;
				reject(new Error('Failed to load script: ' + url));
			};

			$document[0].head.appendChild(script);
		});

		return state.loadPromise;
	}

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('mfeService', ['$q', '$window', '$rootScope', 'dependencyLoaderService', 'utilities',
	function ($q, $window, $rootScope, dependencyLoaderService, utilities) {

	let mfesInitialized = false;
	let initializing = false;
	let mfeInstances = {};

	let service = {
		addMfe,
		initialize,
		isInitialized,
		removeMfe
	};

	function getMfeHostUrl () {
		if (utilities.isEnvironmentProduction || utilities.isEnvironmentPreProduction) {
			return 'https://app-framework.workspace.accessacloud.com/prod/mfes';
		}

		return 'https://app-framework.workspace.accessacloud.com/test/mfes';
	}

	function loadHostScript () {
		return dependencyLoaderService.loadScript(getMfeHostUrl());
	}

	function getEnvironment () {
		if (utilities.isEnvironmentProduction || utilities.isEnvironmentPreProduction) {
			return 'prod';
		}

		return 'preprod';
	}

	function getGeography () {
		return 'uk';
	}

	function getEvoUser () {
		const currentUser = $rootScope.currentUser;
		return {
			id: currentUser.UserResponseUserID,
			emailAddress: currentUser.UserResponseContactEmail,
			organisation: {
				id: currentUser.AgencyProfileParentID
			}
		};
	}

	function getAccessToken () {
		try {
			return '';
		} catch (e) {
			console.warn('mfeService: Failed to retrieve access token', e);
			return '';
		}
	}

	// Provides full user details to the MFE framework, bypassing its default GraphQL user fetch
	function getDetailedEvoUser () {
		const currentUser = $rootScope.currentUser;

		if (!currentUser) {
			console.warn('mfeService: currentUser is not available');
			return Promise.resolve({});
		}

		return Promise.resolve({
			id: currentUser.UserResponseUserID || '',
			firstName: currentUser.UserResponseFirstName || '',
			lastName: currentUser.UserResponseLastName || '',
			emailAddress: currentUser.UserResponseContactEmail || '',
			telephoneNumber: '',
			avatar: currentUser.UserResponseImageUrl || null,
			organisation: {
				id: currentUser.AgencyProfileParentID || '',
				name: currentUser.AgencyProfileName || ''
			}
		});
	}

	function isInitialized () {
		return mfesInitialized;
	}

	function initialize () {
		const deferred = $q.defer();

		if (mfesInitialized) {
			deferred.resolve();
			return deferred.promise;
		}

		if (initializing) {
			console.error('MFE initialization already in progress');
			deferred.reject('MFE initialization already in progress');
			return deferred.promise;
		}

		initializing = true;

		loadHostScript()
			.then(function () {
				if (!$window.AccessEvo || !$window.AccessEvo.initialiseMfes) {
					console.error('MFE init failed: MFE host script loaded but AccessEvo not available', {
						AccessEvo: !!$window.AccessEvo,
						initialiseMfes: !!($window.AccessEvo && $window.AccessEvo.initialiseMfes)
					});
					initializing = false;
					deferred.reject('MFE host script loaded but AccessEvo not available');
					return;
				}

				try {
					const cleanup = $window.AccessEvo.initialiseMfes({
						hostName: 'paycircle-payroll',
						environment: getEnvironment(),
						geography: getGeography(),
						getEvoUser: getEvoUser,
						getAccessToken: getAccessToken,
						getUser: getDetailedEvoUser
					});

					mfesInitialized = true;
					initializing = false;
					deferred.resolve(cleanup);
				} catch (error) {
					initializing = false;
					console.error('Failed to initialize MFEs:', error);
					deferred.reject(error);
				}
			})
			.catch(function (error) {
				initializing = false;
				console.error('Failed to load MFE host script:', error);
				deferred.reject(error);
			});

		return deferred.promise;
	}

	function addMfe (options) {
		const deferred = $q.defer();

		if (!mfesInitialized) {
			initialize()
				.then(() =>	addMfeInternal(options, deferred))
				.catch(error =>	deferred.reject(error));
		} else {
			addMfeInternal(options, deferred);
		}

		return deferred.promise;
	}

	function addMfeInternal (options, deferred) {
		if (!$window.AccessEvo || !$window.AccessEvo.mfes || !$window.AccessEvo.mfes.add) {
			console.error('MFE API not available', {
				AccessEvo: !!$window.AccessEvo,
				mfes: !!($window.AccessEvo && $window.AccessEvo.mfes),
				add: !!($window.AccessEvo && $window.AccessEvo.mfes && $window.AccessEvo.mfes.add)
			});
			deferred.reject('MFE API not available');
			return;
		}

		try {
			const mfe = $window.AccessEvo.mfes.add({
				instanceId: options.instanceId,
				name: options.name,
				container: options.container,
				shell: options.shell || 'none',
				parameters: options.parameters || {},
				onRemove: options.onRemove
			});

			mfeInstances[options.instanceId] = mfe;
			deferred.resolve(mfe);
		} catch (error) {
			console.error('Failed to add MFE:', error);
			deferred.reject(error);
		}
	}

	function removeMfe (instanceId) {
		if (mfeInstances[instanceId]) {
			delete mfeInstances[instanceId];
		}
	}

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('addressService', [
	'$rootScope',
	'COUNTRY_UK',
	function (
		$rootScope,
		COUNTRY_UK
	) {

	const service = {

		convertPostcodeLookupAddressToPaycircleAddress: (lookupAddressObj, IS_UK_ONLY) => {

			let paycircleAddressObj = {
				AddressCity: '',
				AddressCountry: '',
				AddressCounty: '',
				AddressName: '',
				AddressNumber: '',
				AddressPostcode: '',
				AddressStreet: ''
			};

			/* Populate county if it's different from city. In some cases, city and county are the same. This seems to happen when
			   the county is actually a metropolitan area, like 'London', wherever that is. */
			angular.extend(paycircleAddressObj, {
				AddressCity: lookupAddressObj.post_town,
				AddressCountry: IS_UK_ONLY ? COUNTRY_UK.name : lookupAddressObj.country,
				AddressCounty: lookupAddressObj.post_town.toUpperCase() !== lookupAddressObj.postal_county.toUpperCase() ? lookupAddressObj.postal_county : '',
				AddressName: service.getAddressNameFromLookupAddress(lookupAddressObj),
				AddressNumber: lookupAddressObj.building_number,
				AddressPostcode: lookupAddressObj.postcode,
				AddressStreet: service.getAddressStreetFromLookupAddress(lookupAddressObj)
			});

			return paycircleAddressObj;
		},

		convertPostcodeLookupAddressToPaycircleAddressForUserImport: (lookupAddressObj) => {

			let paycircleAddressObj = {
				UserImportAddressLine1: '',
				UserImportAddressLine2: '',
				UserImportAddressLine3: '',
				UserImportAddressLine4: '',
				UserImportPostcode: '',
				UserImportCountry: ''
			};

			angular.extend(paycircleAddressObj, {
				UserImportAddressLine1: lookupAddressObj.line_1,
				UserImportAddressLine2: lookupAddressObj.line_2,
				UserImportAddressLine3: lookupAddressObj.line_3,
				UserImportAddressLine4: lookupAddressObj.post_town,
				UserImportPostcode: lookupAddressObj.postcode,
				UserImportCountry: lookupAddressObj.country,
			});

			return paycircleAddressObj;
		},

		getAddressNameFromLookupAddress: lookupAddressObj => {
			
			// Build address name based on assorted attributes of the Ideal Postcodes address. Usually these things will be empty.
			let buildingName = service.getBuildingNameFromLookupAddress(lookupAddressObj);
			const organisationName = service.getOrganisationNameFromLookupAddress(lookupAddressObj);

			// Put the building name in parentheses after the address name if both exist.
			if (organisationName && buildingName) {
				buildingName = `, ${buildingName}`;
			}

			return `${organisationName}${buildingName}`;
		},

		getAddressStreetFromLookupAddress: lookupAddressObj => {

			if (lookupAddressObj.dependant_thoroughfare !== '') {
				return lookupAddressObj.dependant_thoroughfare + ', ' + lookupAddressObj.thoroughfare;
			}

			return lookupAddressObj.thoroughfare + (!lookupAddressObj.building_name && lookupAddressObj.dependant_locality ? ', ' + lookupAddressObj.dependant_locality : '');
		},

		getBuildingNameFromLookupAddress: lookupAddressObj => {
			
			let buildingName = '';
			let separator = '';

			if (lookupAddressObj.sub_building_name) {
				/* Sometimes the sub_building_name is a number/letter combo, which could be '1', '13', '13a', 'A9' etc.
				   In which case, if separating it from the building_name itself, don't use a comma, so you get '13a Discovery Tower',
				   for example, rather than '13a, Discovery Tower' which just doesn't look right */
				if (/^[A-Za-z]*[0-9*]+[A-Za-z]*$/.test(lookupAddressObj.sub_building_name)) {
					separator = ' ';
				}
				else {
					separator = ', ';
				}
				buildingName = lookupAddressObj.sub_building_name;
			}
			if (lookupAddressObj.building_name) {
				buildingName = `${buildingName}${separator}${lookupAddressObj.building_name}`;
			}

			return buildingName;
		},

		getOrganisationNameFromLookupAddress: lookupAddressObj => {

			if (lookupAddressObj.organisation_name) {
				return lookupAddressObj.organisation_name;
			}

			return '';
		}
	};

	return service;
}]);
'use strict';

angular.module('paycircleApp')
.service('iframeDetectionService', ['$window',
	function ($window) {

	const service = {

		isRunningInIframe: () => {
			return $window.self !== $window.top;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('applicationService', [
	'$filter',
	'$http',
	'$rootScope',
	'$state',
	'config',
	'coralogixService',
	'session',
	'utilities',
	'FORM_OPTIONS',
	'INTERFACE_TYPES',
	'USER_ROLES',
	function (
		$filter,
		$http,
		$rootScope,
		$state,
		config,
		coralogixService,
		session,
		utilities,
		FORM_OPTIONS,
		INTERFACE_TYPES,
		USER_ROLES
	) {

	const PAYROLL_HISTORY_STATES = [
		'payroll.history',
		'payroll.supplementary-pay-run',
		'payroll.pay-period'
	];

	const service = {
		PAYROLL_HISTORY_STATES,
		cancelPendingRequests: () => {

			$http.pendingRequests.forEach((request) => {
				if (request.cancel) {
					request.cancel.resolve();
				}
			});
		},

		cancelFlaggedPendingRequests: () => {
			$http.pendingRequests.forEach(request => {
				if (request.cancel && request.cancelRequestOnStateChange) {
					request.cancel.resolve();
				}
			});
		},

		displaySecondaryLoader: message => {

			angular.extend($rootScope.loadingMaskOptions, {
				showMask: true,
				message: message
			});
		},

		getCompaniesPageForCompany: companyObj => {

			switch (companyObj.CompanyType) {
				case INTERFACE_TYPES.bureau:

					// Archived
					if (companyObj.IsArchived) {
						return 'bureaus-archived';
					}

					return 'bureaus';

				case INTERFACE_TYPES.group:
					return 'company-groups';
				default:

					// Archived
					if (companyObj.IsArchived) {
						return 'companies-archived';
					}

					// Cloned
					if (companyObj.IsClone) {
						return 'companies-cloned';
					}

					return 'companies';
			}
		},

		getDefaultPageForCompany: companyObj => {

			if (companyObj.IsPayslipManagerActive) {
				return 'payslip-manager';
			}

			return config.defaultPage;
		},

		getNgHrefForCompany: (companyObj, stateType, isCompanyLiteAdmin) => {

			// Payslip manager
			if (companyObj.IsPayslipManagerActive) {
				return $state.href(service.getDefaultPageForCompany(companyObj), {
					agencyProfileId: companyObj.AgencyProfileID
				});
			}

			// Company Admin Lite
			if (angular.isDefined(isCompanyLiteAdmin) && isCompanyLiteAdmin)  {
				return $state.href(utilities.getRoleUrl(USER_ROLES.companyadministratorlite), {agencyProfileId: companyObj.AgencyProfileID});
			}

			switch (stateType) {
				case 'payroll':

					// Has permission to view Payroll
					if (!companyObj.IsArchived && session.user.Permissions.isPayrollVisible) {

						// If company has < 20 team members navigate to Team page
						if (companyObj.TeamMemberCount <= config.currentPeriodTeamCountThreshold && session.user.Permissions.isTeamVisible) {
							return $state.href('payroll.current-period.team', {agencyProfileId: companyObj.AgencyProfileID});
						}

						return $state.href('payroll.current-period.changes', {agencyProfileId: companyObj.AgencyProfileID});
					}

					// No permission to view Payroll
					else {

						// Has permission to view Payroll History
						if (session.user.Permissions.isHistoryVisible) {
							return $state.href('payroll.history.pay-periods', {agencyProfileId: companyObj.AgencyProfileID});
						}

						// else: No permission to view Payroll History > Not visible
					}
			}

			return;
		},

		getNgHrefFunctionForUser: (userResponseObj, stateType) => {

			let state;
			switch (stateType) {
				case 'current-period': {

					if (utilities.userHasRole(userResponseObj, ['groupadminlite', 'companyadministratorlite'])) {
						state = 'payroll.current-period.notes';
					}
					else {
						state = 'payroll.current-period.changes';
					}
					break;
				}
			}

			if (state) {
				return function (agencyProfileId) {
					return $state.href(state, { agencyProfileId: agencyProfileId });
				};
			}

			return;
		},

		getRedirectDetail: (agencyProfileId, slackToken) => {

			const redirectObj = {};

			// Validate agency profile id returned
			if (agencyProfileId !== undefined && !utilities.isValidGuid(agencyProfileId)) {
				$rootScope.paycircleMessage('Slack token provided but Company ID is not valid. Defaulting to role redirect', 'warn');
				redirectObj.redirectType = 'role';
			}

			// If company id is provided go to page
			if (agencyProfileId !== undefined) {

				angular.extend(redirectObj, {
					agencyProfileId: agencyProfileId,
					redirectType: 'company-redirect',
					toState: 'settings.company.integrations',
					params: {
						agencyProfileId: agencyProfileId
					}
				});

				if (slackToken !== undefined) {
					redirectObj.params.code = slackToken;
				}
			}

			// Go to role specific landing page
			else {
				redirectObj.redirectType = 'role';
			}

			return redirectObj;
		},

		getStateTitle: (toState, companyObj) => {

			// Begin with the default "Paycirle Payroll"
			let stateTitle = config.appTitle;

			// Attach current company name
			if (companyObj) {
				stateTitle += ` - ${companyObj.Name}`;
			}

			// Attach state title if defined
			if (service.isStateDataPropertyDefined(toState, 'title')) {
				stateTitle += ` - ${toState.data.title}`;
			}

			return stateTitle;
		},

		goToDefaultLandingPageForUser (userObj) {

			// Navigate to default landing page
			if (userObj.viewingAs) {
				$state.go(userObj.defaultLandingPage, {agencyProfileId: userObj.viewingAs.company});
			} else {
				$state.go(userObj.defaultLandingPage, {agencyProfileId: userObj.AgencyProfileID});
			}
		},

		hideSecondaryLoader: () => {
			$rootScope.loadingMaskOptions.showMask = false;
		},

		isAnyStateActive: statesArr => {

			for (let stateString of statesArr) {
				if (service.isStateActive(stateString)) {
					return true;
				}
			}

			return false;
		},

		isStateDataPropertyDefined: (toState, propertyName) => {

			// No data object on state
			if (angular.isUndefined(toState.data)) {
				if (config.isInDebugMode && utilities.isDevelopment()) {
					$rootScope.paycircleMessage('There is no data object on the current state', 'info');
					console.info(toState);
				}
				return false;
			}

			// Property doesn't exist
			if (angular.isUndefined(toState.data[propertyName])) {
				if (config.isInDebugMode && utilities.isDevelopment()) {
					$rootScope.paycircleMessage('The property ' + propertyName + ' is not provided on the current state', 'info');
					console.info(toState);
				}
				return false;
			}

			return true;
		},

		isStateCompanyMessageBarActive: toState => {
			return service.isStateDataPropertyDefined(toState, 'isCompanyBarActive') ? toState.data.isCompanyBarActive : true;
		},

		isStateDocument: (toState) => {

			return service.isStateDataPropertyDefined(toState, 'document') ? toState.data.document : false;
		},

		isStateFullPage: (toState) => {

			return service.isStateDataPropertyDefined(toState, 'fullPage') ? toState.data.fullPage : false;
		},

		isStateLoginPage: (toState) => {

			return ['login', 'sso-login'].includes(toState.name);
		},

		isStatePublic: (toState) => {

			return service.isStateDataPropertyDefined(toState, 'isPublic') ? toState.data.isPublic : false;
		},

		isStateActive: (state) => {

			return $state.includes(state);
		},

		userHasRole (roles) {

			if (roles === undefined) {
				return false;
			}

			return utilities.userHasRole(session.user, roles);
		},

		redirectToDefaultPage: (userObj, agencyProfileId, slackToken) => {

			const redirectObj = service.getRedirectDetail(agencyProfileId, slackToken);

			switch (redirectObj.redirectType) {

				// Redirect to role home page
				case 'role':
					service.goToDefaultLandingPageForUser(userObj);
					break;

				// Redirect to specific company
				case 'company-redirect':
					$rootScope.$broadcast('set-current-company', redirectObj.agencyProfileId, () => {
						$state.go(redirectObj.toState , redirectObj.params);
					});

					break;
			}
		},

		refreshCompany: () => {
			$filter('companyDetails')($rootScope.currentCompany, $rootScope.currentUser.isPaycircleAdmin);
		},

		refreshUser: () => {
			$filter('userResponse')($rootScope.currentUser);
		},

		setupFormOptions: formOptionsObj => {

			const formKey = formOptionsObj.formKey;
			const defaultFormOptionsObj = FORM_OPTIONS[formKey];
			const requiredPermissionsArr = angular.copy(formOptionsObj.requiredPermissions);

			// If there are specific form options, use them by default
			if (defaultFormOptionsObj !== undefined) {

				const updatedFormOptionsObj = {};

				// Merge formOptions with any defaultFormOptions options (formOptions takes priority as this is feature specific)
				angular.merge(updatedFormOptionsObj, formOptionsObj, defaultFormOptionsObj);

				// Title is an exception to the hierarchy of options (todo: need to move the setup of default form options into this controller)
				if (!formOptionsObj.isWizard && formOptionsObj.title) {
					updatedFormOptionsObj.title = formOptionsObj.title;
				}

				// Add Coralogix trace
				coralogixService.addToTrace({
					message: 'Form opened: ' + updatedFormOptionsObj.title,
					category: 'action'
				});

				// Extend the original formOptions
				angular.extend(formOptionsObj, updatedFormOptionsObj);

				// Overwrite requiredPermissions array
				if (requiredPermissionsArr && defaultFormOptionsObj.requiredPermissions) {
					formOptionsObj.requiredPermissions = requiredPermissionsArr.concat(defaultFormOptionsObj.requiredPermissions);
				}
			}

			// Add default title if not provided
			formOptionsObj.title = formOptionsObj.title ? formOptionsObj.title : formKey.replace(/-/g, ' ');

		},

		setUserMessageState: messageBarState => {
			$rootScope.userMessageBarState = messageBarState;
		},

		stateRequiresCustomisation: (toState) => {
			return toState.name !== 'sso-login';
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('authErrorLoggingService', [
	'coralogixService',
	function (coralogixService) {

	const service = {

		buildUserContext: userObj => {
			if (!userObj) {
				return null;
			}
			
			return {
				userId: userObj.UserResponseUserID,
				username: userObj.UserResponseUsername,
				agencyProfileId: userObj.AgencyProfileID || userObj.agencyProfileId,
				agencyProfileName: userObj.AgencyProfileName
			};
		},

		buildErrorUserContext: error => {
			if (!error || !error.data) {
				return null;
			}
		
			const context = {};
		
			if (error.data.UserID) {
				context.userId = error.data.UserID;
			}
			if (error.data.AccountID) {
				context.accountId = error.data.AccountID;
			}
			if (error.data.Username) {
				context.username = error.data.Username;
			}
			if (error.data.EmailAddress) {
				context.emailAddress = error.data.EmailAddress;
			}
			if (error.data.AgencyProfileID) {
				context.agencyProfileId = error.data.AgencyProfileID;
			}
		
			return Object.keys(context).length > 0 ? context : null;
		},

		logAuthError: (reason, error, userContext, additionalContext, authData) => {
			try {
				const logPayload = {
					controller: 'identitySigninOidcCtrl',
					flow: 'oidc_sign_in',
					reason: reason,
					status: error && error.status,
					statusText: error && error.statusText,
					errorCode: error && error.data && error.data.Error,
					errorMessage: (error && error.message) || (error && error.data && error.data.Message),
					authContext: {
						hasCode: !!(authData && authData.Code),
						hasState: !!(authData && authData.State),
						hasNonce: !!(authData && authData.Nonce)
					}
				};

				if (userContext) {
					logPayload.user = userContext;
				} else {
					const errorUserContext = service.buildErrorUserContext(error);
					if (errorUserContext) {
						logPayload.user = errorUserContext;
					}
				}

				if (error && error.data) {
					logPayload.errorData = error.data;
				}

				if (additionalContext) {
					logPayload.additionalContext = additionalContext;
				}

				const errorObj = new Error('Paycircle: OIDC sign-in failed - ' + reason);
			
				coralogixService.noticeError(errorObj, logPayload);
			} catch (loggingError) {
				try {
					coralogixService.noticeError(new Error('Paycircle: Failed to log auth error'), { reason: reason });
				} catch (e) {
				}
			}
		}
	};

	return service;
}]);

'use strict';
angular.module('paycircleApp')

.factory('AuthResolverCompany', ['$q', '$rootScope', '$state',
	function ($q, $rootScope, $state) {

	return {
		resolve: function () {
			return $q((resolve, reject) => {

				$rootScope.$watch('[currentCompany, session]', function ([currentCompanyObj, sessionObj]) {

					if (!sessionObj) {
						reject();

						$state.go('login');
					}

					if (currentCompanyObj && angular.isDefined(currentCompanyObj) && !currentCompanyObj.isLoading) {
						resolve(currentCompanyObj);
					}

				});

			});
		}
	};
}])

.factory('CustomisationResolver', ['$q', '$rootScope',
	function ($q, $rootScope) {

	return {
		resolve: () => {
			return $q(resolve => {

				$rootScope.$watch('session.customisation', customisationObj => {

					if (customisationObj) {
						resolve();
					}
				});
			});
		}
	};
}]);


'use strict';

angular.module('paycircleApp')
.service('bankService', [
	'BANK_FILE_FORMATS',
	function (
		BANK_FILE_FORMATS
	) {

	const service = {

		getBankFileFormat: (selectedBankFile, currentBankFileFormat) => {

			if (service.isBankFileFormatAllowed(selectedBankFile, currentBankFileFormat)) {
				return currentBankFileFormat;
			}

			return service.getDefaultBankFileFormat(selectedBankFile);
		},

		getDefaultBankFileFormat: (selectedBankFile) => {

			return (selectedBankFile && !selectedBankFile.IsBACSAvailable && selectedBankFile.IsFPSAvailable) ? BANK_FILE_FORMATS.fps : BANK_FILE_FORMATS.bacs;
		},

		isBankFileFormatAllowed: (selectedBankFile, currentBankFileFormat) => {

			if (!selectedBankFile) {
				return false;
			}

			if (currentBankFileFormat === BANK_FILE_FORMATS.bacs) {
				return selectedBankFile.IsBACSAvailable;
			}

			if (currentBankFileFormat === BANK_FILE_FORMATS.fps) {
				return selectedBankFile.IsFPSAvailable;
			}

			return false;
		},

		isSunNumberApplicable: (selectedBankFile, bankFileContext) => {

			if (!selectedBankFile || !bankFileContext) {
				return false;
			}

			if (bankFileContext.isGdffAvailable) {
				return selectedBankFile.ShowSunNumberForGdff;
			}

			switch (bankFileContext.bankFileFormat) {
				case BANK_FILE_FORMATS.fps:
					return selectedBankFile.ShowSunNumberForFPS;
				default:
					return selectedBankFile.ShowSunNumberForBACS;
			}
		},

		isSunNumberRequired: (selectedBankFile, bankFileContext) => {

			if (!selectedBankFile || !bankFileContext) {
				return false;
			}

			if (bankFileContext.isGdffAvailable) {
				return selectedBankFile.IsSunNumberForGdffRequired;
			}

			switch (bankFileContext.bankFileFormat) {
				case BANK_FILE_FORMATS.fps:
					return selectedBankFile.IsSunNumberForFPSRequired;
				default:
					return selectedBankFile.IsSunNumberForBACSRequired;
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('bulkService', [function () {

	var service = {

		getBulkItemsObj: function (bulkItemsArr) {

			return {
				all: bulkItemsArr,
				filtered: [],
				total: 0,
				totalSelected: 0
			};
		},

		getFilteredItemsSelectedCount: function (bulkItemsObj) {

			var selectedItemsCount = 0;

			bulkItemsObj.filtered.forEach(function (bulkItemObj) {
				if (bulkItemObj.isSelected) {
					selectedItemsCount++;
				}
			});

			return selectedItemsCount;
		},

		getSelectedIdsForDataType: function (filteredCompaniesArr, dataType) {

			switch (dataType) {
				case 'companies':
					return service.getValuesFromArray(filteredCompaniesArr.filter(service.selectedItemFilter), 'AgencyProfileID', 'Company');
			}
		},

		// Returns array of items where isSelected = true
		getSelectedItems: function (bulkItemsArr) {

			var selectedItems = [];

			bulkItemsArr.forEach(function (item) {
				if (item.isSelected) {
					selectedItems.push(item);
				}
			});

			return selectedItems;
		},

		// Returns array of UserID/AgencyProfileID from array of team members/companies
		getValuesFromArray: function (bulkItemsArr, key, nestedObj) {

			return bulkItemsArr.map(item => nestedObj ? item[nestedObj][key] : item[key]);
		},

		// Called when running bulk updates
		getValuesFromSelectedItems: function (bulkItemsArr, key, nestedObj) {

			var selectedItems = this.getSelectedItems(bulkItemsArr);

			return this.getValuesFromArray(selectedItems, key, nestedObj);
		},

		selectedItemFilter: function (item) {

			return item.isSelected;
		},

		// Called from card checkbox click
		updateBulkItemTotals: function (bulkItemsObj) {

			var filteredItemsArray = bulkItemsObj.filtered;

			bulkItemsObj.totalSelected = service.getFilteredItemsSelectedCount(bulkItemsObj);
			bulkItemsObj.total = filteredItemsArray.length;

			return bulkItemsObj;
		},

		// Called from bulk update checkbox
		updateItemsSelectedState: function (bulkItemsObj) {

			var filteredItems = bulkItemsObj.filtered.filter(item => !item.cannotBeSelected);
			var allSelected = filteredItems.length === bulkItemsObj.totalSelected;
			var selectState = bulkItemsObj.totalSelected === 0 && !allSelected;

			for (var item of filteredItems) {
				item.isSelected = selectState;
			}

			service.updateBulkItemTotals(bulkItemsObj);

			return selectState ? filteredItems.length : 0;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('companyService', [
	'$filter',
	'BUSINESS_SECTORS',
	'COMPANY_TYPES',
	'INTERFACE_TYPES',
	function (
		$filter,
		BUSINESS_SECTORS,
		COMPANY_TYPES,
		INTERFACE_TYPES
	) {

	const service = {

		decorateCompanyInformationDetailedObj: companyObj => {

			companyObj.companyType = service.getCompanyTypeByInterfaceType(companyObj.CompanyType);

			return companyObj;
		},

		getBusinessSectorOptions: () => {

			return [
				{			
					description: $filter('businessSectorDescription')(BUSINESS_SECTORS.agriculture),
					value: BUSINESS_SECTORS.agriculture
				},
				{			
					description: $filter('businessSectorDescription')(BUSINESS_SECTORS.fisheriesAqua),
					value: BUSINESS_SECTORS.fisheriesAqua
				},
				{			
					description: $filter('businessSectorDescription')(BUSINESS_SECTORS.roadTransport),
					value: BUSINESS_SECTORS.roadTransport
				},
				{			
					description: $filter('businessSectorDescription')(BUSINESS_SECTORS.industrial),
					value: BUSINESS_SECTORS.industrial
				},
				{			
					description: $filter('businessSectorDescription')(BUSINESS_SECTORS.none),
					value: BUSINESS_SECTORS.none
				}
			];
		},

		getCompanyTypeByInterfaceType: interfaceType => {

			switch (interfaceType) {
				case INTERFACE_TYPES.bureau:
					return COMPANY_TYPES.bureau;
				case INTERFACE_TYPES.group:
					return COMPANY_TYPES.group;
				default:
					return COMPANY_TYPES.company;
			}
		},

		getEmailRecipientsArrays: () => {
			return {
				contactsExternalNew: [],
				contactsExternalOld: [],
			};
		},

		isPayrollCompany: companyObj => {

			switch (companyObj.CompanyType) {
				case INTERFACE_TYPES.bureau:
				case INTERFACE_TYPES.group:
					return false;
				default:
					return true;
			}
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('cookieConsentService', [
	'$rootScope',
	'$q',
	'$window',
	'config',
	'loggedUserService',
	'utilities',
	'COOKIE_KEYS',
	'COOKIE_POLICY_CONFIG',
	'COOKIE_CONSENT_KEYS',
	function ($rootScope, $q, $window, config, loggedUserService, utilities, COOKIE_KEYS, COOKIE_POLICY_CONFIG, COOKIE_CONSENT_KEYS) {

		const service = {

			hasConsent: function(category, key) {
				const preferences = service.getConsentPreferences();
				
				if (loggedUserService.isEvoEnabled() && $rootScope.currentUser.IsEvoNative) {
					if(!key){
						return false;
					}

					if (category === COOKIE_CONSENT_KEYS.categories.essential){
						return true;
					}
					return preferences && preferences[category + '.' + key] === true;
				}

				if (category === COOKIE_CONSENT_KEYS.categories.essential) {
					return true;
				}
				return preferences && preferences[category] === true;
			},

			setConsent: function(category, granted, key) {
				const preferences = service.getConsentPreferences() || {};

				if (loggedUserService.isEvoEnabled() && $rootScope.currentUser.IsEvoNative) {
					if(!key){
						return;
					}

					preferences[category + '.' + key] = granted;
				}
				else{
					preferences[category] = granted;
				}

				utilities.createCookie(COOKIE_KEYS.cookieConsent, JSON.stringify(preferences), 2160);
			},

			getConsentPreferences: function() {

				const consentCookie = utilities.readCookie(COOKIE_KEYS.cookieConsent);
				return consentCookie ? JSON.parse(consentCookie) : null;
			},

			resetConsent: function() {

				utilities.deleteCookie(COOKIE_KEYS.cookieConsent);
			},

			hasShownBanner: function() {

				const preferences = service.getConsentPreferences();
				return preferences !== null && preferences.bannerShown === COOKIE_POLICY_CONFIG.policyVersion;
			},

			acceptAll: function() {

				service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, true);
				service.setBannerShown();
			},
			rejectAll: function() {

				service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, false);
				service.setBannerShown();
			},

			setBannerShown: function() {

				const preferences = service.getConsentPreferences() || {};
				preferences.bannerShown = COOKIE_POLICY_CONFIG.policyVersion;
				utilities.createCookie(COOKIE_KEYS.cookieConsent, JSON.stringify(preferences), 2160);
			},

			initAccessSdk: function() {
				if(!$window.AccessCookiePolicies || !$window.AccessCookiePolicies.SDK){
					$rootScope.paycircleMessage('Access Cookie Policies SDK not found!','alert');

					return $q.reject();
				}

				angular.extend(COOKIE_POLICY_CONFIG.FOR_ACCESS_SDK.config, {
					applicationId: loggedUserService.getAccessWorkspaceProductID(),
					policyUrl: config.externalUrls.policyUrls.cookiePolicy,
					policyVersion: COOKIE_POLICY_CONFIG.policyVersion
				});
				return $window.AccessCookiePolicies.SDK.tabInitialise(COOKIE_POLICY_CONFIG.FOR_ACCESS_SDK).then(service.onAccessSdkResponse);
			},

			onAccessSdkResponse: function(accessSdkConsent){
				const consent = (accessSdkConsent && accessSdkConsent.consent) ? accessSdkConsent.consent : [];

				if(consent === '*'){
						service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, true, COOKIE_CONSENT_KEYS.analytics.ga);
						service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, true, COOKIE_CONSENT_KEYS.analytics.cx);
					}
					else{
						const analyticsConsent = consent.find(function (p){ return p.policy.contains(COOKIE_CONSENT_KEYS.categories.analytics); });
						if(analyticsConsent){
							let hasConsentGranted = analyticsConsent.vendors.includes(COOKIE_CONSENT_KEYS.analytics.ga);
							service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, hasConsentGranted, COOKIE_CONSENT_KEYS.analytics.ga);
							hasConsentGranted = analyticsConsent.vendors.includes(COOKIE_CONSENT_KEYS.analytics.cx);
							service.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, hasConsentGranted, COOKIE_CONSENT_KEYS.analytics.cx);
						}
					}
			}
		};

		return service;
	}
]);

'use strict';

angular.module('paycircleApp')
.service('customisationService', [
	'$rootScope',
	'$state',
	'companyData',
	'config',
	'session',
	'utilities',
	'validationService',
	'CUSTOMISATION_FEATURES',
	'INTERFACE_TYPES',
	'LOCAL_STORAGE_KEYS',
function (
	$rootScope,
	$state,
	companyData,
	config,
	session,
	utilities,
	validationService,
	CUSTOMISATION_FEATURES,
	INTERFACE_TYPES,
	LOCAL_STORAGE_KEYS
) {

	const service = {

		getBrandId: stateParam => {

			const brandId = utilities.getFromStorage(LOCAL_STORAGE_KEYS.brandId);

			if (stateParam !== undefined && validationService.isValidGuid(stateParam)) {
				return stateParam;
			}

			if (brandId && validationService.isValidGuid(brandId)) {
				return brandId;
			}

			return config.guidEmpty;
		},

		getCustomisationFeatureByFeatureKey: featureKey => {

			return CUSTOMISATION_FEATURES.find(featureObj => featureObj.key === featureKey);
		},

		getCustomisationFeatures: companyType => {

			const customisationFeatures = angular.copy(CUSTOMISATION_FEATURES);

			// Remove 'isBureauOnly' features for non-bureaus
			if (companyType !== INTERFACE_TYPES.bureau) {
				customisationFeatures.filter(customisationFeature => !customisationFeature.isBureauOnly);
			}

			return customisationFeatures;
		},

		loadCustomisationPublic: toParams => {

			let brandId = service.getBrandId(toParams.brand);
			let bureauKey = toParams.bureauKey;
			let companyKey = toParams.companyKey;

			let customisationConfigObj = {
				agencyProfileId: config.guidEmpty,
				bureauKey: undefined,
				isDefault: false
			};

			// Bureau Key
			if (bureauKey !== undefined) {

				if (!utilities.isValidBureauKey(bureauKey)) {
					$rootScope.paycircleMessage('Customisation: Bureau key is incorrect', 'error');
				}

				customisationConfigObj.bureauKey = parseInt(bureauKey);
			}

			// Company key
			else if (companyKey !== undefined) {

				if (!utilities.isValidCompanyKey(companyKey)) {
					$rootScope.paycircleMessage('Customisation: Company key is incorrect', 'error');
				}

				customisationConfigObj.bureauKey = utilities.getBureauIdByCompanyKey(companyKey);
			}

			// Brand ID
			else {
				customisationConfigObj.agencyProfileId = brandId;
			}

			// Load customisation
			companyData.getCompanyCustomisationPublic(customisationConfigObj.agencyProfileId, customisationConfigObj.bureauKey).then((customisationObj) => {

				customisationObj.isDefault = customisationConfigObj.isDefault;

				session.setCustomisation(customisationObj);
			})
			.catch((error) => {
				console.error(error);
				$rootScope.paycircleMessage('Failed to load customisation', 'error');
			});
		},

		setupSlackAuthentication: toParams => {

			let slackToken = toParams.code;
			let slackState = toParams.state;

			let stateParams = {
				agencyProfileId: slackState
			};

			// Slack integration
			if (slackToken !== undefined) {
				stateParams.state = slackState;
				stateParams.code = slackToken;
			}

			$state.go('settings.company.integrations', stateParams);
		},

		saveBrandId: function (brandId) {

			utilities.addToStorage(LOCAL_STORAGE_KEYS.brandId, brandId);
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('customerCodeService',
	['companyData',
	function (companyData) {

		function verifyCustomerCode(customerCode, agencyProfileID) {
			if (!customerCode) {
				return Promise.resolve(null);
			}

			return companyData.getCompaniesForCustomerCode(customerCode, agencyProfileID)
				.then(function(response) {
					if (response && response.length > 0) {
						return {
							status: 'valid',
							data: response[0].name
						};
					} else {
						return { status: 'invalid' };
					}
				})
				.catch(function() {
					return { status: 'error' };
				});
		}

		let service = {
			verifyCustomerCode: verifyCustomerCode
		};

		return service;
	}
]);

'use strict';

angular.module('paycircleApp')
.service('dataTransfer', [
	'$filter',
	'$http',
	'$q',
	'$window',
	'FileUploader',
	'growl',
	'libraries',
	'session',
	'utilities',
	'REGEX',
	function (
		$filter,
		$http,
		$q,
		$window,
		FileUploader,
		growl,
		libraries,
		session,
		utilities,
		REGEX
	) {

		const service = {

			downloadBlob: (responseData, filename) => {

				const blob = new Blob([responseData]);
				const link = document.createElement('a');

				link.href = $window.URL.createObjectURL(blob);

				link.download = filename;

				link.click();
			},

			downloadFileContent: (fileContentObj) => {

				return fetch('data:' + fileContentObj.ContentType + ';base64,' + fileContentObj.Content)
					.then((res) => res.blob())
					.then((res) => service.downloadBlob(res, fileContentObj.FileName));
			},

			downloadFile: (downloadUrl, fallbackFileName) => {

				return $q((onComplete, onError) => {

					growl.success('Downloading file…');

					service.getDataFromURL(downloadUrl, 'blob')
						.then(response => {

							service.onFileDownload(response, fallbackFileName)
								.then(onComplete)
								.catch(onError);

						})
						.catch(onError);

				});
			},

			downloadReport: (reportRequestObj, formatType, reportName) => {

				return $q((onComplete, onError) => {

					growl.success('Downloading report…');

					const bodyObj = {
						AuthString: utilities.getToken(),
						FormatType: formatType,
						ReportRequest: reportRequestObj
					};

					service.getData(libraries.httpHandler.download.report, bodyObj, 'blob')
						.then(response => {

							service.onFileDownload(response, reportName, true)
								.then(onComplete)
								.catch(onError);

						})
						.catch(onError);
				});
			},

			getBlobDownloadUrl: (documentId, ownerId, filename) => {

				// Used in file downloads

				let url = 'https://' + libraries.httpHandler.download.blob;

				url += `?documentid=${documentId}`;
				url += `&owner=${ownerId}`;
				url += '&user=true';

				if (filename) {
					url += `&filename=${encodeURI(filename)}`;
				}

				return url;
			},

			getBlobBasicDownloadUrl: (blobContainerName, blobName) => {

				let url = 'https://' + libraries.httpHandler.download.blobBasic;

				url += `?blobContainerName=${blobContainerName}`;
				url += `&blobName=${encodeURI(blobName)}`;

				return url;
			},

			getDataFromURL: (url, requestResponseType) => {

				// Makes a POST request to URL, passing in any URL parameters in through the request body

				return $q((onComplete, onError) => {

					const urlObj = service.getURLDetailFromURL(url);
					const bodyObj = service.getRequestBodyDetailFromURL(urlObj);

					service.getData(urlObj.origin + urlObj.pathname, bodyObj, requestResponseType)
						.then(onComplete)
						.catch(onError);
				});
			},

			getData: (url, bodyObj, requestResponseType) => {

				// Make a POST request to URL, passing in an object into the request body

				const configObj = service.getRequestConfigDetail(requestResponseType);

				return $q((onComplete, onError) => {
					$http.post(url, bodyObj, configObj)
						.then(onComplete)
						.catch(onError);
				});
			},

			getFileNameFromResponse: response => {

				// Returns file name as a string from response headers

				// "Content-Disposition" header needs to be exposed to the UI using the "Access-Control-Expose-Headers" header in the handler
				const headersArr = response.headers();
				const contentDispositionHeader = headersArr['content-disposition']; // "attachment; filename="FILENAME.pdf""

				if (contentDispositionHeader) {

					// Get filename from string
					return contentDispositionHeader.split('"')[1];

				} else {
					return null;
				}
			},

			getNewFileUploader: fileUploadOptionsObj => {

				const requestObj = service.getRequestConfigDetail();

				// Attach parameters to formData
				requestObj.formData = [service.getRequestBodyDetailDefault()];

				const combinedFileOptionsObj = angular.merge({}, requestObj, fileUploadOptionsObj);

				return new FileUploader(combinedFileOptionsObj);
			},

			getRequestBodyDetailDefault: paramsObj => {

				// Returns an object with AuthString (token) attached

				paramsObj = angular.isDefined(paramsObj) && angular.isObject(paramsObj) ? paramsObj : {};

				paramsObj.token = utilities.getToken();

				return paramsObj;
			},

			getRequestBodyDetailFromURL: url => {

				/*
					Iterates through parameters in a url and create object from them
					eg: http://paycircle.co.uk?token=authstring -> { token: 'authstring' }
				*/

				const requestBody = service.getRequestBodyDetailDefault();

				for (let parameterArr of url.searchParams.entries()) {
					requestBody[parameterArr[0]] = encodeURIComponent(parameterArr[1]);
				}

				return requestBody;
			},

			getRequestConfigDetail: responseType => {

				// Returns object default config options for requests, including SessionID header

				const configObj = {
					responseType: responseType,
					headers: {}
				};

				// Attach SessionID
				const sessionId = session.getSessionId();
				if (sessionId) {
					configObj.headers.SessionID = sessionId;
				}

				return configObj;
			},

			getURLDetailFromURL: downloadUrl => {

				if (!downloadUrl.match(/http(s):\/\//g)) {
					downloadUrl = 'https://' + downloadUrl;
				}

				const url = new URL(downloadUrl);

				const searchParams = new URLSearchParams(url.search);
				for (let [key, value] of searchParams.entries()) {
					if (!value) {
						searchParams.delete(key);
					}
				}

				url.search = searchParams.toString();

				return url;
			},

			getURLRedirect: redirectUrl => {

				/*
					Will get link from a page to redirect the user to
					 - Used for PensionSync "Authorise" links
				*/

				return $q((onComplete, onError) => {

					growl.success('Fetching URL…');

					service.getDataFromURL(redirectUrl)
						.then(response => {

							const responseData = response.data;

							if (responseData.match(REGEX.webAddress)) {
								$window.open(responseData, '_blank');

							} else {
								growl.error(responseData);
							}

						})
						.catch(onError);

				});

			},

			onFileDownload: (response, fallbackFileName, useFallBackByDefault) => {

				return $q((onComplete, onError) => {

					const fileNameFromResponse = service.getFileNameFromResponse(response);

					// 1. Use given file name, but take file extension from response
					if (useFallBackByDefault) {

						const fileNameArr = fileNameFromResponse.split('.');
						const fileFormat = fileNameArr[fileNameArr.length-1];

						service.downloadBlob(response.data, fallbackFileName + '.' + fileFormat);
						onComplete();


					// 2. Use the filename from the header
					} else if (fileNameFromResponse) {

						service.downloadBlob(response.data, fileNameFromResponse);
						onComplete();

					// 3. Use fallback file name if it exists
					} else if (angular.isDefined(fallbackFileName)) {

						service.downloadBlob(response.data, fallbackFileName);
						onComplete();

					// 4. Display error if we don't know the name of the file, as we need the file extension to download the file properly
					} else {

						growl.error('There was an error downloading your file');
						onError();
					}
				});
			}

		};

		return service;
	}
]);

'use strict';

angular.module('paycircleApp')
.service('dateService', ['$filter', 'config', 'WORK_PATTERN_BASIS', 'WORK_PATTERN_GROUPS', function ($filter, config, WORK_PATTERN_BASIS, WORK_PATTERN_GROUPS) {

	const DATE_DIVISIONS = {
		days: 'days',
		hours: 'hours',
		minutes: 'minutes'
	};

	var service = {
		
		getCalendarDatesForWorkPatterns: function (workPatternsArr, payPeriodObj, calendarDatesArr) {

			const dateRangeFromM = moment(calendarDatesArr[0].dateISO);
			const dateRangeToM = moment(calendarDatesArr[calendarDatesArr.length - 1].dateISO);
			const wpStartDate = moment(new Date(1900, 0, 1));

			let calendarDateIndex = 0;

			// Loop over work patterns
			workPatternsArr.forEach((workPatternObj, workPatternIndex) => {

				const nextWorkPatternObj = workPatternsArr[workPatternIndex + 1];
				const wpEffectiveDateFromM = workPatternObj.EffectiveDateISO !== '' ? moment(workPatternObj.EffectiveDateISO) : moment(payPeriodObj.StartDateISO); //service.getFirstMondayOfCurrentMonth();
				const wpEffectiveDateToM = angular.isDefined(nextWorkPatternObj) ? moment(nextWorkPatternObj.EffectiveDateISO).subtract(1, 'day') : moment().add(1, 'year');

				// Effective date is in range
				if (wpEffectiveDateFromM.isBetween(dateRangeFromM, dateRangeToM, null, '[]')) {

					// Align effective date with calendar date
					while (angular.isDefined(calendarDatesArr[calendarDateIndex]) && !wpEffectiveDateFromM.isSame(moment(calendarDatesArr[calendarDateIndex].dateISO))) {
						calendarDateIndex++;
					}
				}

				// Effective date before range (apply to entire period)
				else if (wpEffectiveDateFromM.isSameOrBefore(dateRangeFromM)) {

					// Align effective date with calendar date
					while (wpEffectiveDateFromM.day() !== moment(calendarDatesArr[calendarDateIndex].dateISO).day()) {
						calendarDateIndex++;
					}
				}

				// Effective date in future, break early
				else {
					console.warn('Effective date after range: display nothing');
					return;
				}

				// Loop over Days while incrementing dates too and map until days loop ends, until dates loop ends
				const numberOfWorkPatternDays = workPatternObj.Days.length;
				const numberOfCalendarDates = calendarDatesArr.length;

				let j = 0;

				// Align days if weekly work pattern
				if (workPatternObj.Group === WORK_PATTERN_GROUPS.standard || workPatternObj.Basis === WORK_PATTERN_BASIS.weekly) {
					while (service.getMomentDayForDayIndex(workPatternObj.Days[j].DayNumber) !== moment(calendarDatesArr[calendarDateIndex].dateISO).day()) {
						j++;
					}
				}

				// Align work pattern days from wpStartDate with calendar dates if no effective date is set
				if (workPatternObj.EffectiveDateISO === '') {
					const numberofDays = moment(dateRangeFromM).diff(wpStartDate, 'day');
					const dayPatternIndex = Math.floor(numberofDays % numberOfWorkPatternDays);
					j += dayPatternIndex;
				}

				for (calendarDateIndex; calendarDateIndex < numberOfCalendarDates; calendarDateIndex++) {

					let calendarDateObj = calendarDatesArr[calendarDateIndex];

					// Only applies to dates within the effective date range
					if (!moment(calendarDateObj.dateISO).isBetween(wpEffectiveDateFromM, wpEffectiveDateToM, null, '[]')) {
						break;
					}

					// Loop back to first Work Pattern day
					if (j === numberOfWorkPatternDays) {
						j = 0;
					}

					const dayObj = workPatternObj.Days[j];

					calendarDateObj.isHighlighted = workPatternIndex > 0;

					switch (workPatternObj.Group) {
						case WORK_PATTERN_GROUPS.standard:
							calendarDateObj.entries.push({
								isActive: true,
								theme: dayObj.DayType === 0 ? 'quarternary' : 'quarternary-lightest',
								value: dayObj.DayType === 0 ? 'WD' : 'NWD'
							});
							break;
						case WORK_PATTERN_GROUPS.nonStandard:
							calendarDateObj.entries.push({
								isActive: dayObj.Hours > 0,
								theme: dayObj.Hours > 0 ? 'secondary' : 'secondary-lightest',
								value: dayObj.Hours
							});
							break;
					}

					/*/ Pay Period Start Date
					if (calendarDateObj.dateISO === payPeriodObj.StartDateISO) {
						calendarDateObj.labels.push({
							theme: 'tertiary',
							value: 'Period start'
						});
					}

					/* Pay Period Start Date
					if (calendarDateObj.dateISO === payPeriodObj.EndDateISO) {
						calendarDateObj.labels.push({
							theme: 'tertiary',
							value: 'Period end'
						});
					}*/

					// Pay Date
					if (calendarDateObj.dateISO === payPeriodObj.PayDateISO) {
						calendarDateObj.labels.push({
							theme: 'tertiary',
							value: 'Pay day'
						});
					}

					// Today
					if (moment(calendarDateObj.dateISO).isSame(moment())) {
						calendarDateObj.labels.push({
							theme: 'positive',
							value: 'Today'
						});
					}

					/* Payslip Date
					if (calendarDateObj.dateISO === payPeriodObj.PayslipDateISO) {
						calendarDateObj.labels.push({
							theme: 'tertiary',
							value: 'Payslips'
						});
					}*/

					j++;
				}
			});


			return calendarDatesArr;
		},

		getDateRange: function (startDateIso, endDateIso, includePlaceholder) {

			includePlaceholder = includePlaceholder !== undefined ? includePlaceholder : true;

			var returnDatesArray = [];
			var returnDateModel = {
				description: 'Please select...',
				dateISO: null,
				dayName: null,
				dayOfMonth: null,
				month: undefined,
				monthNumber: null,
				labels: [],
				tags: ['Payday']
			};

			var dateMoment = moment(startDateIso);
			var dateToMoment = moment(endDateIso);

			if (includePlaceholder) {
				returnDatesArray.push(returnDateModel); // Add 'Please select' option
			}

			while (dateMoment.isBefore(dateToMoment)) {

				var newDateObj = angular.copy(returnDateModel);

				newDateObj.dateISO = dateMoment.format(config.dateFormatISO);
				newDateObj.dayName = dateMoment.format('dd');
				newDateObj.dayOfMonth = dateMoment.format('D');
				newDateObj.description = $filter('dateformat')(dateMoment);
				newDateObj.month = dateMoment.format('MMMM');
				newDateObj.monthNumber = dateMoment.format('M');
				newDateObj.entries = []; //service.getTagsForDate(newDateObj.dateISO, calendarDatesArr);
				newDateObj.labels = [];

				returnDatesArray.push(newDateObj);

				dateMoment = dateMoment.add(1, 'day');
			}

			return returnDatesArray;
		},
		
		getDateRangeForWeeklyCalendar: function (startDateIso, endDateIso) {

			startDateIso = moment(startDateIso).startOf('week').format();
			endDateIso = moment(endDateIso).endOf('week').format();

			return service.getDateRange(startDateIso, endDateIso, false);
		},

		getDecoratedMinutes: minutesInt => {

			if (minutesInt === 1) {
				return '1 minute';

			} else {
				return `${minutesInt} minutes`;
			}
		},

		getDecoratedTimePeriodFromDurationDetail: durationObj => {

			if (durationObj.days > 0) {
				return `${durationObj.days}d ${durationObj.hours}h ${durationObj.minutes}m`;

			} else if (durationObj.hours > 0) {
				return `${durationObj.hours}h ${durationObj.minutes}m`;

			} else {
				return `${durationObj.minutes}m`;
			}
		},

		getDivisions: function () {

			return DATE_DIVISIONS;
		},

		getDurationDetailFromMinutes: minutesInt => {

			const UPPER_LIMITS = {
				minutes: 60,
				hours: 24
			};

			const durationObj = {
				minutes: 0,
				hours: 0,
				days: 0
			};

			if (angular.isUndefined(minutesInt) || minutesInt === 0) {
				return durationObj;
			}

			// Days
			const daysFromMinutes = moment.duration(minutesInt, 'minutes').asDays();

			durationObj.days = Math.floor(daysFromMinutes);

			// Hours
			const hoursFromMinutes = moment.duration(minutesInt, 'minutes').asHours();
			const remainingHoursInLastDay = hoursFromMinutes % UPPER_LIMITS.hours;

			durationObj.hours = Math.floor(remainingHoursInLastDay);

			// Minutes
			const remainingMinutesInLastDay = minutesInt % UPPER_LIMITS.minutes;

			durationObj.minutes = remainingMinutesInLastDay;

			return durationObj;
		},

		getDurationWithDivisionsFromMinutes: (minutesInt, showDivisions) => {

			const UPPER_LIMITS = {
				minutes: 60,
				hours: 24
			};

			const durationObj = {
				minutes: 0,
				hours: 0,
				days: 0
			};

			if (angular.isUndefined(minutesInt) || minutesInt === 0) {
				return durationObj;
			}

			if (showDivisions.some(division => division === DATE_DIVISIONS.days)) {
				// Days
				const daysFromMinutes = moment.duration(minutesInt, 'minutes').asDays();

				durationObj.days = Math.floor(daysFromMinutes);
			}

			if (showDivisions.some(division => division === DATE_DIVISIONS.hours)) {
				// Hours
				var hoursFromMinutes = moment.duration(minutesInt, 'minutes').asHours();

				if (durationObj.days > 0) {
					hoursFromMinutes = hoursFromMinutes % UPPER_LIMITS.hours;
				}

				durationObj.hours = Math.floor(hoursFromMinutes);
			}

			if (showDivisions.some(division => division === DATE_DIVISIONS.minutes)) {
				// Minutes
				var remainingMinutesInLastDay = minutesInt;

				if (durationObj.hours > 0 || durationObj.days > 0) {
					remainingMinutesInLastDay = minutesInt % UPPER_LIMITS.minutes;
				}

				durationObj.minutes = remainingMinutesInLastDay;
			}

			return durationObj;
		},

		getEndOfMonthIso: (startDateIso, maxDayOfMonth) => {

			if (angular.isDefined(maxDayOfMonth)) {

				const monthMaxDate = moment(startDateIso).date(maxDayOfMonth);

				if (moment(monthMaxDate).isBefore(moment(startDateIso))) {
					return moment(startDateIso).add(1, 'months').date(maxDayOfMonth).format(config.dateFormatISO);

				} else {
					return monthMaxDate.format(config.dateFormatISO);
				}

			} else {
				return moment(startDateIso).add(1, 'months').subtract(1, 'days').format(config.dateFormatISO);
			}
		},

		getFirstMondayOfCurrentMonth: function () {

			let returnDateM = moment().startOf('month');

			while (returnDateM.day() !== 1) {
				returnDateM = returnDateM.add(1, 'day');
			}

			return returnDateM;
		},

		getHours: function () {

			let hoursArr = [];

			for (let hour = 0; hour < 24; hour++) {

				let hourString = hour.toString();
				hourString = hourString.length === 1 ? `0${hourString}` : hourString;

				hoursArr.push({
					hourDisplay: hourString,
					hour: hour
				});
			}

			return hoursArr;
		},

		// Takes a date and works back until a working day (ISO) is returned
		getLastWorkingDayFromDateIso: function (dateIso) {

			let dateIsoMoment = moment(dateIso);

			while (!service.getIsWorkingDayFromDateMoment(dateIsoMoment)) {

				dateIsoMoment.subtract(1, 'day');
			}

			return dateIsoMoment.format(config.dateFormatISO);
		},

		// Takes a date and works back until a working day (ISO) is returned
		getLastSpecificDayFromDateIso: function (dateIso, day) {

			let dateIsoMoment = moment(dateIso);

			while (!service.getIsSpecificDayFromDateMoment(dateIsoMoment, day)) {

				dateIsoMoment.subtract(1, 'day');
			}

			return dateIsoMoment.format(config.dateFormatISO);
		},

		// Takes a Paycircle DayIndex (Monday to Sunday, 1-7) and matches up to Moment .day() result (Sunday to Monday, 0-6). The difference being that Sunday = 0, not 7
		getMomentDayForDayIndex: (dayIndex) => {

			switch (dayIndex) {

				case 7:
					return 0;
			}

			return dayIndex;
		},

		// Takes a moment date obj and returns a bool of whether the provided date is a specific day (0 > 6, Sun > Sat)
		getIsSpecificDayFromDateMoment: function (dateMoment, day) {

			return dateMoment.day() === day;
		},

		// Takes a moment date obj and returns a bool of whether the provided date is a working day (Mon-Fri)
		getIsWorkingDayFromDateMoment: function (dateMoment) {

			switch (dateMoment.day()) {
				case config.momentDays.saturday:
				case config.momentDays.sunday:
					return false;
				default:
					return true;
			}
		},

		getMinutes: function () {

			let minutesArr = [];

			for (let minute of ['00', '15', '30', '45']) {

				minutesArr.push({
					minuteDisplay: minute,
					minute: parseInt(minute)
				});
			}

			return minutesArr;
		},

		getTagsForDate: function (dateISO, calendarDateArr) {

			var i = 0;
			var numberOfCalendarDates = calendarDateArr.length;
			var returnTags = [];

			for (i; i < numberOfCalendarDates; i++) {

				var calendarDateObj = calendarDateArr[i];

				if (calendarDateObj.dateISO === dateISO) {
					returnTags.push(calendarDateObj.tags);
				}
			}

			return returnTags;
		},

		parseIsoDate: function (dateISO) {
			return new Date(dateISO);
		},

		areDatesSameDay: function (date1, date2) {
			const momentDate1 = moment(date1);
			const momentDate2 = moment(date2);
			
			return momentDate1.isSame(momentDate2, 'day');
		},

		/**
		 * Parse an ASP.NET /Date(ms)/ formatted string into a YYYY-MM-DD date string.
		 * Falls back to returning the first 10 characters of the input when the format
		 * is already ISO-like. Returns null when the input is falsy or unrecognised.
		 *
		 * @param {string} dateString - Date value in /Date(ms)/ or ISO format
		 * @returns {string|null} YYYY-MM-DD date string, or null if input is invalid
		 */
		parseAspNetDate: function (dateString) {

			if (!dateString) {
				return null;
			}

			var msMatch = dateString.match(/\/Date\((\d+)/);

			if (msMatch) {
				return new Date(parseInt(msMatch[1], 10)).toISOString().substring(0, 10);
			}

			if (dateString.length >= 10) {
				return dateString.substring(0, 10);
			}

			return null;
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('disbursementService', ['$filter', 'utilities', 'DISBURSEMENT_CONTEXT_TYPES', function ($filter, utilities, DISBURSEMENT_CONTEXT_TYPES) {

	var service = {

		// There are four dates, Date1ISO -> Date4ISO -> Check how many are set and attach them to the disbursement obj as a readable array
		setupBACSDefinedDates: (disbursementObj) => {

			disbursementObj.paymentDates = [];

			let i = 0;
			let numberOfDates = 4;

			for (i; i <= numberOfDates; i++) {

				// Set property name for date
				let dateProperty = `Date${i}ISO`;

				// If that property exists, format it to something readable add it to the array of payment dates
				if (!utilities.isDateUndefined(disbursementObj[dateProperty])) {
					disbursementObj.paymentDates.push($filter('dateformat')(disbursementObj[dateProperty], 'dayMonthYear'));
				}
			}
		},

		getBACSPaymentContext: (disbursementObj) => {

			service.setupBACSDefinedDates(disbursementObj);

			// No separate BACS file
			if (!disbursementObj.SeparateBACS) {
				return DISBURSEMENT_CONTEXT_TYPES.noSeparateBacsFile;
			}

			// Payment dates
			if (disbursementObj.paymentDates.length) {
				return DISBURSEMENT_CONTEXT_TYPES.paymentDates;
			}

			// Day of month (1st, 2nd, etc...)
			if (disbursementObj.DayOfMonth) {
				return DISBURSEMENT_CONTEXT_TYPES.dayOfMonth;
			}

			// Relative days
			return DISBURSEMENT_CONTEXT_TYPES.relativeDays;
		},

		getBACSPaymentTypeDescription: (disbursementObj, isSummary) => {

			let responsePre;

			disbursementObj.paymentContext = service.getBACSPaymentContext(disbursementObj);

			if (disbursementObj.SeparateBACS) {
				responsePre = 'A separate BACS file will be created for these payments each time payroll is run, and the';
			}

			switch (disbursementObj.paymentContext) {

				// Day of month
				case DISBURSEMENT_CONTEXT_TYPES.dayOfMonth:

					const ordinalDate = moment().date(disbursementObj.DayOfMonth).format('Do');

					return isSummary ? `${ordinalDate} of the month` : `${responsePre} payment date is set to the ${ordinalDate} of the month`;

				// Payment date
				case DISBURSEMENT_CONTEXT_TYPES.paymentDates:

					const datesList = utilities.formatArrayAsReadableList(disbursementObj.paymentDates);

					return isSummary ? `${datesList}` : `${responsePre} payment date${disbursementObj.paymentDates.length > 1 ? 's are' : ' is'} set to ${datesList}`;

				// Relative days
				case DISBURSEMENT_CONTEXT_TYPES.relativeDays:

					const relativeDaysString = service.getMessageForRelativeDays(disbursementObj);

					return isSummary ? `${relativeDaysString}` : `${responsePre} payment date is set to ${relativeDaysString}`;

				// No separate BACS file
				case DISBURSEMENT_CONTEXT_TYPES.noSeparateBacsFile:

					return isSummary ? 'Included in main BACS file' : 'Payments will be included in your main BACS file';
			}
		},

		/**
		 * Get the payment info text for a specified disbursement object. This will provide information about the timing(s)
		 * of the generation of a BACS file, or if no separate BACS file is configured, generic text.
		 */
		getBACSPaymentInfoText: disbursementObj => {

			let paymentInfoText;

			if (disbursementObj.SeparateBACS) {
				paymentInfoText = 'A separate BACS file will be created for these payments each time payroll is run, and the ';

				// Get dates if they exist. Magic numbers - there are up to four dates, Date1ISO -> Date4ISO
				let paymentDates = [];
				for (let i = 1; i <= 4; i++) {
					// Set property name for date
					let dateProperty = `Date${i}ISO`;
					// If that property exists, format it to something readable add it to the array of payment dates
					if (!utilities.isDateUndefined(disbursementObj[dateProperty])) {
						paymentDates.push($filter('dateformat')(disbursementObj[dateProperty], 'dayMonthYear'));
					}
				}

				// Anything come out of that?
				if (paymentDates.length) {
					// Aye, so that's what going to get displayed
					paymentInfoText += 'payment date';
					paymentInfoText += (paymentDates.length > 1 ? 's are' : ' is') + ' set to ';
					paymentInfoText += utilities.formatArrayAsReadableList(paymentDates);
				}
				else if (disbursementObj.DayOfMonth) {
					// There are no specific dates. So as a day of the month has been set, show that.
					paymentInfoText += 'payment date is set to the ';
					paymentInfoText += moment().date(disbursementObj.DayOfMonth).format('Do');
					paymentInfoText += ' of the month';
				}
				else {
					// Relative days it is then.
					paymentInfoText += 'payment date is set to ';
					let relativeDays = disbursementObj.RelativeDays;

					if (relativeDays > 0) {
						// After
						if (relativeDays === 1) {
							paymentInfoText += ' the day';
						}
						else {
							paymentInfoText += `${relativeDays} days`;
						}
						paymentInfoText += ' after pay day';
					}
					else {
						// Must be same day
						paymentInfoText += 'pay day';
					}
				}
			}
			else {
				// No separate BACS file
				paymentInfoText = 'Payments will be added to your main BACS file';
			}

			return paymentInfoText;
		},

		getMessageForRelativeDays: (disbursementObj) => {

			if (disbursementObj.RelativeDays === 0 ) {
				return 'pay day';

			} else {
				return `${Math.abs(disbursementObj.RelativeDays)} days after pay day`;
			}
		},

		resetDisbursementBankInfo: disbursementObj => {

			angular.extend(disbursementObj.BankInfo, {
				BankBranchName: '',
				BankAccountNumber: '',
				BankAccountName: '',
				SortCode: ''
			});

			return disbursementObj;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('documentsService', [
	'$filter',
	function (
		$filter
	) {

	const service = {

		decorateDocument: documentObj => {

			angular.extend(documentObj, {
				theme: $filter('userDocumentTypeTheme')(documentObj.UserDocumentTypeID)
			});
		},

		decorateDocuments: documentsArr => {

			documentsArr.forEach(service.decorateDocument);
		},

		getDecoratedDocuments: documentsArr => {

			service.decorateDocuments(documentsArr);

			return documentsArr;
		}
	};

	return service;
}]);
'use strict';

angular.module('paycircleApp')
.service('edpTopicService', ['$q', '$rootScope', 'companyData', function ($q, $rootScope, companyData) {

	// EDP integration topic keys. These mirror the backend EdpTopicKey constants and the
	// EdpIntegrationTopicKey column. Held lower-case for case-insensitive comparison.
	const TOPIC_KEYS = {
		sickness: '5a374b92-e2ee-429d-80bd-c6ec94da49ba',
		holiday: 'a8f3c7d1-4e9a-4f5b-9c2d-3e8f1a7b6d9c',
		maternity: 'f5f7e9b5-c5ce-4e62-9ea2-680c46138db2',
		paternity: '2308459b-212f-4562-9ec5-8e4812dab2d1'
	};

	const TOPIC_MESSAGES = {
		[TOPIC_KEYS.holiday]: 'Holiday is managed by a source system and cannot be edited here.',
		[TOPIC_KEYS.sickness]: 'Sickness is managed by a source system and cannot be edited here.'
	};

	const PAYMENT_SCHEDULE_MESSAGES = {
		[TOPIC_KEYS.sickness]: 'Some sickness pay fields are managed by a source system and cannot be edited here.',
		[TOPIC_KEYS.maternity]: 'Some maternity pay fields are managed by a source system and cannot be edited here.',
		[TOPIC_KEYS.paternity]: 'Some paternity pay fields are managed by a source system and cannot be edited here.'
	};

	// Cache the topics request per company so repeated look-ups (for example one per team
	// card on the team list) do not each make a separate API call.
	let topicsCache = {};

	function getTopics (agencyProfileId) {

		if (!agencyProfileId) {
			return $q.resolve([]);
		}

		if (!topicsCache[agencyProfileId]) {
			topicsCache[agencyProfileId] = companyData.getEdpIntegrationTopics(agencyProfileId)
			.then(topics => topics || [])
			.catch(() => []);
		}

		return topicsCache[agencyProfileId];
	}

	// True unless the master EDP integration for the active company is known to be off.
	// The per-topic preferences are intentionally preserved when the integration is switched
	// off (see the EDP integration form: "Topic preferences will be preserved"), so a topic
	// can still be flagged enabled even though no events are being processed. An absence is
	// only integration-managed when BOTH the master integration and the topic are enabled.
	// The master flag is only known client-side for the current company, so apply it when the
	// requested company is the current one and otherwise fall back to the per-topic value.
	function isEdpIntegrationEnabled (agencyProfileId) {

		const currentCompany = $rootScope.currentCompany;

		if (currentCompany && currentCompany.AgencyProfileID && agencyProfileId &&
			currentCompany.AgencyProfileID.toLowerCase() === agencyProfileId.toLowerCase()) {
			return !!currentCompany.IsEdpIntegrationEnabled;
		}

		return true;
	}

	const service = {

		TOPIC_KEYS: TOPIC_KEYS,

		// Returns the user-facing integration message for the given topic key.
		getTopicMessage (topicKey) {

			return TOPIC_MESSAGES[(topicKey || '').toLowerCase()] || 'This schedule is managed by a source system and cannot be edited here.';
		},

		getPaymentScheduleMessage (topicKey) {

			return PAYMENT_SCHEDULE_MESSAGES[(topicKey || '').toLowerCase()] || 'Some payment schedule fields are managed by a source system and cannot be edited here.';
		},

		// Resolves to true when the given EDP topic is enabled (subscribed) for the company,
		// which means that absence type is managed by the integration and manual create/edit
		// in Paycircle must be blocked. Resolves to false on any error, or when no integration
		// or topic is configured, so controls behave normally by default.
		isTopicEnabled (agencyProfileId, topicKey) {

			if (!agencyProfileId || !topicKey) {
				return $q.resolve(false);
			}

			// When the master EDP integration is off the absence is no longer managed by the
			// integration (topic preferences are only preserved, not active), so it must not
			// be treated as read-only regardless of the lingering per-topic flag.
			if (!isEdpIntegrationEnabled(agencyProfileId)) {
				return $q.resolve(false);
			}

			const key = topicKey.toLowerCase();

			return getTopics(agencyProfileId).then(topics => {

				const topic = topics.find(topicObj => topicObj.EdpIntegrationTopicKey && topicObj.EdpIntegrationTopicKey.toLowerCase() === key);

				return !!(topic && topic.EdpIntegrationTopicIsEnabled);
			});
		},

		// Clears the cached topics (call when integration settings may have changed).
		clearCache (agencyProfileId) {

			if (agencyProfileId) {
				delete topicsCache[agencyProfileId];
			} else {
				topicsCache = {};
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('fileUploadService', [
	'REGEX',
	function (
		REGEX
	) {

	const service = {

		getAllowedFileTypesForUpload: (fuAllowedFileTypes, fuAllowedFileTypesKey) => {

			// Manually define file types
			if (angular.isDefined(fuAllowedFileTypes)) {
				return fuAllowedFileTypes;
			}

			// Define file types by key
			if (angular.isDefined(fuAllowedFileTypesKey)) {

				switch (fuAllowedFileTypesKey) {
					case 'all':
						return '.csv,.doc,.docx,.due,.eml,.jpeg,.jpg,.json,.mov,.msg,.pdf,.png,.pptx,.txt,.xml,.xlsx,.xls,.zip';
					default:
						console.info('The provided fuAllowedFileTypesKey parameter is not recognised, therefore the default set is being used.');
				}
			}

			// Default
			return '.xls,.xlsx,.pdf,.csv,.doc,.docx,.zip';
		},

		getAllowedFileTypesAsArray: (fileTypesStr) => {

			return fileTypesStr.split(',').map(item => item.trim());
		},

		getFileExtensionFromFileName: fileName => {

			// Get file extension from string
			const fileExtensionRegexArr =  REGEX.fileExtension.exec(fileName);
			const fileExtension = fileExtensionRegexArr[0];

			if (!fileExtension) {
				throw new Error('Incorrect file name entered');
			}

			// Return lowercase extension
			return fileExtension.toLowerCase();
		},

		isUploadValidFileFormat: (fileObj, allowedFormatsStr) => {

			const allowedFormatsArr = service.getAllowedFileTypesAsArray(allowedFormatsStr);
			const fileExtension = service.getFileExtensionFromFileName(fileObj.file.name);

			return allowedFormatsArr.some(fileFormat => {
				return fileExtension.includes(fileFormat);
			});
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('filterService', [
	'$filter',
	'config',
	'pensionService',
	'utilities',
	'ALERT_LEVELS',
	'ARCHIVE_REASON_KEYS',
	'ARCHIVE_REASONS',
	'AVERAGE_HOLIDAY_PAY_RATE_TYPES',
	'BACS_FILE_TYPES',
	'BUSINESS_TYPES',
	'COMPANY_STATES',
	'DOCUMENT_STATES',
	'EDP_UPDATES_EVENT_TYPES',
	'FILTER_KEYS',
	'FILTER_OPTION_SPECIAL_TYPES',
	'GENDER_PAY_GAP_EMPLOYEE_TYPES',
	'IMPORT_MAPPING_TYPES',
	'INTERFACE_TYPES',
	'LEAVE_TYPE_DESCRIPTIONS',
	'LOG_CATEGORIES',
	'MIME_FORMATS',
	'PAY_PERIOD_TYPES',
	'PEOPLE_HR_UPDATES_EVENT_NAMES',
	'PEOPLE_HR_UPDATES_EVENT_STATUS',
	'POLICY_PAY_BASES',
	'PAYMENT_STATES',
	'PENSION_STATES',
	'PENSION_STATUSES',
	'PENSION_TYPES',
	'PRESET_FILTER_KEYS',
	'REPORT_CLASSIC_CATEGORY_IDS',
	'REPORT_TEMPLATE_CATEGORIES',
	'ROTAREADY_UPDATES_EVENT_TYPES',
	'ROTAREADY_UPDATES_EVENT_STATUS',
	'SALARY_TYPES',
	'SUBMISSION_STATES',
	'UI_SCHEDULE_STATUSES',
	'UI_SCHEDULE_TYPES',
	'USER_DOCUMENT_IDS',
	function (
		$filter,
		config,
		pensionService,
		utilities,
		ALERT_LEVELS,
		ARCHIVE_REASON_KEYS,
		ARCHIVE_REASONS,
		AVERAGE_HOLIDAY_PAY_RATE_TYPES,
		BACS_FILE_TYPES,
		BUSINESS_TYPES,
		COMPANY_STATES,
		DOCUMENT_STATES,
		EDP_UPDATES_EVENT_TYPES,
		FILTER_KEYS,
		FILTER_OPTION_SPECIAL_TYPES,
		GENDER_PAY_GAP_EMPLOYEE_TYPES,
		IMPORT_MAPPING_TYPES,
		INTERFACE_TYPES,
		LEAVE_TYPE_DESCRIPTIONS,
		LOG_CATEGORIES,
		MIME_FORMATS,
		PAY_PERIOD_TYPES,
		PEOPLE_HR_UPDATES_EVENT_NAMES,
		PEOPLE_HR_UPDATES_EVENT_STATUS,
		POLICY_PAY_BASES,
		PAYMENT_STATES,
		PENSION_STATES,
		PENSION_STATUSES,
		PENSION_TYPES,
		PRESET_FILTER_KEYS,
		REPORT_CLASSIC_CATEGORY_IDS,
		REPORT_TEMPLATE_CATEGORIES,
		ROTAREADY_UPDATES_EVENT_TYPES,
		ROTAREADY_UPDATES_EVENT_STATUS,
		SALARY_TYPES,
		SUBMISSION_STATES,
		UI_SCHEDULE_STATUSES,
		UI_SCHEDULE_TYPES,
		USER_DOCUMENT_IDS
	) {

	/**
	 * Checks whether an ISO date string falls within an inclusive date range.
	 * Boundaries are inclusive by day (time portion is ignored).
	 * If a boundary is empty/null, that side is unbounded.
	 *
	 * @param {string} itemIso - ISO date string of the item to check
	 * @param {string} fromIso - ISO date string for range start (inclusive)
	 * @param {string} toIso - ISO date string for range end (inclusive)
	 * @returns {boolean}
	 */
	function isWithinDateRange (itemIso, fromIso, toIso) {

		if (!itemIso) {
			return false;
		}

		var itemDate = moment(itemIso).startOf('day');

		if (fromIso && itemDate.isBefore(moment(fromIso).startOf('day'))) {
			return false;
		}

		if (toIso && itemDate.isAfter(moment(toIso).startOf('day'))) {
			return false;
		}

		return true;
	}

	var service = {
		archivedTeamMembers: {
			filterGroups: [
				{
					name: 'Archived date',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last month',
							key: FILTER_KEYS.archivedTeamMembers.date.oneMonth,
							filterExp: value => moment(value.PayrollMoveDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.archivedTeamMembers.date.threeMonths,
							filterExp: value => moment(value.PayrollMoveDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.archivedTeamMembers.date.sixMonths,
							filterExp: value => moment(value.PayrollMoveDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Within last year',
							key: FILTER_KEYS.archivedTeamMembers.date.twelveMonths,
							filterExp: value => moment(value.PayrollMoveDateISO).isAfter(moment().subtract(1, 'year'))
						}
					]
				},
			]
		},
		bacsDownloads: {
			filterGroups: [
				{
					name: 'Payment date',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last week',
							key: FILTER_KEYS.bacsDownloads.date.oneWeek,
							filterExp: value => moment(value.PaymentDateISO).isAfter(moment().subtract(1, 'week'))
						},
						{
							name: 'Within last 2 weeks',
							key: FILTER_KEYS.bacsDownloads.date.twoWeeks,
							filterExp: value => moment(value.PaymentDateISO).isAfter(moment().subtract(2, 'weeks'))
						},
						{
							name: 'Within last month',
							key: FILTER_KEYS.bacsDownloads.date.oneMonth,
							filterExp: value => moment(value.PaymentDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.bacsDownloads.date.threeMonths,
							filterExp: value => moment(value.PaymentDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.bacsDownloads.date.sixMonths,
							filterExp: value => moment(value.PaymentDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Select date',
							key: FILTER_KEYS.bacsDownloads.date.specificDate,
							inputType: FILTER_OPTION_SPECIAL_TYPES.date,
							inputLabel: 'Payment date',
							filterExp: (value, dateIso) => moment(value.PaymentDateISO).isSame(moment(dateIso))
						}
					]
				},
				{
					name: 'File type',
					filterOptions: [
						{
							name: 'Pay period',
							key: FILTER_KEYS.bacsDownloads.fileType.payPeriod,
							filterExp: value => value.Type === BACS_FILE_TYPES.payPeriod
						},
						{
							name: 'Disbursement',
							key: FILTER_KEYS.bacsDownloads.fileType.disbursement,
							filterExp: value => value.Type === BACS_FILE_TYPES.disbursement
						},
						{
							name: 'Supplementary payment',
							key: FILTER_KEYS.bacsDownloads.fileType.supplementaryPayment,
							filterExp: value => value.Type === BACS_FILE_TYPES.supplementaryPayment
						}
					]
				}
			]
		},
		billing: {
			filterGroups: [
				{
					name: 'Status',
					filterOptions: [
						{
							name: 'Paid',
							key: FILTER_KEYS.billing.status.paid,
							filterExp: value => value.PaymentStatus === PAYMENT_STATES.paid
						},
						{
							name: 'Failed',
							key: FILTER_KEYS.billing.status.failed,
							filterExp: value => value.PaymentStatus === PAYMENT_STATES.failed
						},
						{
							name: 'Refunded',
							key: FILTER_KEYS.billing.status.refunded,
							filterExp: value => value.PaymentStatus === PAYMENT_STATES.refunded
						},
						{
							name: 'Cancelled',
							key: FILTER_KEYS.billing.status.cancelled,
							filterExp: value => value.PaymentStatus === PAYMENT_STATES.cancelled
						}
					]
				}
			]
		},
		bureausArchived: {
			filterGroups: [
				{
					name: 'Date',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last month',
							key: FILTER_KEYS.bureausArchived.date.oneMonth,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.bureausArchived.date.threeMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.bureausArchived.date.sixMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Within last year',
							key: FILTER_KEYS.bureausArchived.date.twelveMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(1, 'year'))
						}
					]
				}
			]
		},
		bureauWorkflowTasks: {
			filterGroups: [
				{
					name: 'Pay frequency',
					filterOptions: [
						{
							name: 'Weekly',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.weekly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.weekly
						},
						{
							name: 'Two weekly',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.fortnightly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.fortnightly
						},
						{
							name: 'Four weekly',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.fourWeekly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.fourweekly
						},
						{
							name: 'Monthly',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.monthly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.monthly
						},
						{
							name: 'Quarterly',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.quarterly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.quarterly
						},
						{
							name: 'Annually',
							key: FILTER_KEYS.bureauWorkflowTasks.payFrequency.annually,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.weekly
						}
					]
				},
				{
					name: 'Team Member',
					filterOptions: [
						{
							name: 'Client',
							key: FILTER_KEYS.bureauWorkflowTasks.teamMember.client,
							filterExp: value => value.IsClientActioner
						}
						// Filter options for specific team members are added dynamically.
					]
				},
				{
					name: 'Status',
					filterOptions: [
						{
							name: 'Overdue',
							key: FILTER_KEYS.bureauWorkflowTasks.status.isOverdue,
							filterExp: value => value.IsOverdue
						},
						{
							name: 'Due today',
							key: FILTER_KEYS.bureauWorkflowTasks.status.isDueToday,
							filterExp: value => moment(value.DueDateISO).isSame(moment(), 'day')
						},
						{
							name: 'Due in next 2 days',
							key: FILTER_KEYS.bureauWorkflowTasks.status.isDueWithinTwoDays,
							filterExp: value => moment(value.DueDateISO).isBetween(moment(), moment().add(2, 'day'), 'day', '[]')
						},
						{
							name: 'Due in next 3 days',
							key: FILTER_KEYS.bureauWorkflowTasks.status.isDueWithinThreeDays,
							filterExp: value => moment(value.DueDateISO).isBetween(moment(), moment().add(3, 'day'), 'day', '[]')
						},
						{
							name: 'Queried',
							key: FILTER_KEYS.bureauWorkflowTasks.status.isQueried,
							filterExp: value => value.IsPayrollQueried
						},
						{
							name: 'Payroll failed',
							key: FILTER_KEYS.bureauWorkflowTasks,
							filterExp: value => value.IsPayrollFailed
						}
					]
				},
				{
					name: 'Step',
					filterOptions: [
						{
							name: 'Payroll information',
							key: FILTER_KEYS.bureauWorkflowTasks.step.payrollInformation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL INFORMATION'
						},
						{
							name: 'Payroll calculation',
							key: FILTER_KEYS.bureauWorkflowTasks.step.payrollCalculation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL CALCULATION'
						},
						{
							name: 'Payroll confirmation',
							key: FILTER_KEYS.bureauWorkflowTasks.step.payrollConfirmation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL CONFIRMATION'
						},
						{
							name: 'Run payroll',
							key: FILTER_KEYS.bureauWorkflowTasks.step.runPayroll,
							filterExp: value => value.Title.toUpperCase().trim() === 'RUN PAYROLL'
						}
					]
				}
			]
		},
		companiesArchived: {
			filterGroups: [
				{
					name: 'Date',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last month',
							key: FILTER_KEYS.companiesArchived.date.oneMonth,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.companiesArchived.date.threeMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.companiesArchived.date.sixMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Within last year',
							key: FILTER_KEYS.companiesArchived.date.twelveMonths,
							filterExp: value => moment(value.Company.ArchiveDateISO).isAfter(moment().subtract(1, 'year'))
						}
					]
				},
				{
					name: 'Reason',
					filterOptions: [
						{
							name: ARCHIVE_REASONS[0],
							key: FILTER_KEYS.companiesArchived.reason.companyClosing,
							filterExp: value => value.Company.ArchiveReason === ARCHIVE_REASONS[ARCHIVE_REASON_KEYS.companyClosing]
						},
						{
							name: ARCHIVE_REASONS[1],
							key: FILTER_KEYS.companiesArchived.reason.companySoldOrMerged,
							filterExp: value => value.Company.ArchiveReason === ARCHIVE_REASONS[ARCHIVE_REASON_KEYS.companySoldOrMerged]
						},
						{
							name: ARCHIVE_REASONS[2],
							key: FILTER_KEYS.companiesArchived.reason.movedServiceProvider,
							filterExp: value => value.Company.ArchiveReason === ARCHIVE_REASONS[ARCHIVE_REASON_KEYS.movedServiceProvider]
						},
						{
							name: ARCHIVE_REASONS[3],
							key: FILTER_KEYS.companiesArchived.reason.other,
							filterExp: value => value.Company.ArchiveReason === ARCHIVE_REASONS[ARCHIVE_REASON_KEYS.other]
						}
					]
				}
			]
		},
		currentPeriodTaxUpdates: {
			filterGroups: [
				{
					name: 'Update type',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Automatic',
							key: FILTER_KEYS.currentPeriodTaxUpdates.updateType.automatic,
							filterExp: value => value.automaticUpdate
						},
						{
							name: 'Manual',
							key: FILTER_KEYS.currentPeriodTaxUpdates.updateType.manual,
							filterExp: value => !value.automaticUpdate
						}
					]
				}
			]
		},
		customerCodes:{
			filterGroups:[
				{
					name: 'Code added',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Yes',
							key: FILTER_KEYS.customerCodes.codeAdded.codeAdded,
							filterExp: value => value.CustomerCode !==''
						},
						{
							name: 'No',
							key: FILTER_KEYS.customerCodes.codeAdded.codeNotAdded,
							filterExp: value => value.CustomerCode ===''
						}
					]
				}
			]
		},


		dataImporterValidate: {
			filterGroups: [
				{
					name: 'Validation state',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'All',
							key: FILTER_KEYS.dataImporterValidate.validationState.all,
							filterExp: null
						},
						{
							name: 'Invalid',
							key: FILTER_KEYS.dataImporterValidate.validationState.invalid,
							filterExp: value => value.isInvalid
						}
					]
				}
			]
		},
		documents: {
			filterGroups: [
				{
					name: 'File type',
					filterOptions: [
						{
							name: 'FPS',
							key: FILTER_KEYS.documents.fileType.fps,
							filterExp: value => value.MIMEFormat === MIME_FORMATS.fps
						},
						{
							name: 'CSV',
							key: FILTER_KEYS.documents.fileType.csv,
							filterExp: value => value.MIMEFormat === MIME_FORMATS.csv
						},
						{
							name: 'PDF',
							key: FILTER_KEYS.documents.fileType.pdf,
							filterExp: value => value.MIMEFormat === MIME_FORMATS.pdf
						},
						{
							name: 'DOCX',
							key: FILTER_KEYS.documents.fileType.docx,
							filterExp: value => [MIME_FORMATS.docx, MIME_FORMATS.doc].includes(value.MIMEFormat)
						},
						{
							name: 'XLSX',
							key: FILTER_KEYS.documents.fileType.xlsx,
							filterExp: value => [MIME_FORMATS.xls, MIME_FORMATS.xlsx].includes(value.MIMEFormat)
						},
						{
							name: 'Other',
							key: FILTER_KEYS.documents.fileType.other,
							filterExp: value => ![MIME_FORMATS.fps, MIME_FORMATS.csv, MIME_FORMATS.pdf, MIME_FORMATS.docx, MIME_FORMATS.doc, MIME_FORMATS.xls, MIME_FORMATS.xlsx].includes(value.MIMEFormat)
						}
					]
				},
				{
					name: 'Status',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Validated',
							key: FILTER_KEYS.documents.status.validated,
							filterExp: value => value.DocumentState === DOCUMENT_STATES.checked
						},
						{
							name: 'Not validated',
							key: FILTER_KEYS.documents.status.notValidated,
							filterExp: value => value.DocumentState === DOCUMENT_STATES.unchecked
						}
					]
				}
			]
		},
		emailTriggers: {
			filterGroups: [
				{
					name: 'Status',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Active',
							key: 'email-template-active',
							filterExp: value => value.MailTypeNumTemplates > 0
						},
						{
							name: 'Not active',
							key: 'email-template-not-active',
							filterExp: value => value.MailTypeNumTemplates === 0
						}
					]
				}
			]
		},
		futureChanges: {
			filterGroups: [
				{
					name: 'Period',
					filterAction: 'or',
					filterOptions: [
						{
							name: '3 months',
							key: FILTER_KEYS.futureChanges.period.threeMonths,
							filterExp: value => moment(value.PeriodStartDateISO).isBefore(moment().add(3, 'months'))
						},
						{
							name: '6 months',
							key: FILTER_KEYS.futureChanges.period.sixMonths,
							filterExp: value => moment(value.PeriodStartDateISO).isBefore(moment().add(6, 'months'))
						},
						{
							name: '1 year',
							key: FILTER_KEYS.futureChanges.period.oneYear,
							filterExp: value => moment(value.PeriodStartDateISO).isBefore(moment().add(1, 'year'))
						}
					]
				},
				{
					name: 'Types',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Additions',
							key: FILTER_KEYS.futureChanges.types.additions,
							filterExp: value => !value.Deduction
						},
						{
							name: 'Deductions',
							key: FILTER_KEYS.futureChanges.types.deductions,
							filterExp: value => value.Deduction
						}
					]
				}
			]
		},
		history: {
			filterGroups: [
				{
					name: 'Types',
					filterOptions: [
						{
							name: 'Manual',
							key: FILTER_KEYS.history.types.manual,
							filterExp: value => value.IsRunManual
						},
						{
							name: 'Auto run',
							key: FILTER_KEYS.history.types.autoRun,
							filterExp: value => value.IsRunAutoRun
						},
						{
							name: 'Compulsory',
							key: FILTER_KEYS.history.types.compulsory,
							filterExp: value => value.IsRunCompulsory
						},
						{
							name: 'Test run',
							key: FILTER_KEYS.history.types.testRun,
							filterExp: value => value.IsRunTest
						},
						{
							name: 'Historic',
							key: FILTER_KEYS.history.types.historic,
							filterExp: value => value.isHistoric
						}
					]
				}
			]
		},
		leavers: {
			filterGroups: [
				{
					name: 'Leave date',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last month',
							key: FILTER_KEYS.leavers.date.oneMonth,
							filterExp: value => moment(value.LeaveDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.leavers.date.threeMonths,
							filterExp: value => moment(value.LeaveDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.leavers.date.sixMonths,
							filterExp: value => moment(value.LeaveDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Within last year',
							key: FILTER_KEYS.leavers.date.twelveMonths,
							filterExp: value => moment(value.LeaveDateISO).isAfter(moment().subtract(1, 'year'))
						}
					]
				},
			]
		},
		linkElements: {
			filterGroups: [
				{
					name: 'Change type',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Addition',
							key: FILTER_KEYS.linkElements.changeType.addition,
							filterExp: value => !value.IsDeduction
						},
						{
							name: 'Deduction',
							key: FILTER_KEYS.linkElements.changeType.deduction,
							filterExp: value => value.IsDeduction
						}
					]
				},
			]
		},
		linkRates: {
			filterGroups: [
				{
					name: 'Change type',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Addition',
							key: FILTER_KEYS.linkRates.changeType.addition,
							filterExp: value => !value.linkElement.IsDeduction
						},
						{
							name: 'Deduction',
							key: FILTER_KEYS.linkRates.changeType.deduction,
							filterExp: value => value.linkElement.IsDeduction
						}
					]
				},
			]
		},
		onboarding: {
			filterGroups: [
				{
					name: 'Status',
					filterOptions: [
						{
							name: 'Demo',
							key: FILTER_KEYS.onboarding.status.demo,
							filterExp: value => value.State === COMPANY_STATES.demo
						},
						{
							name: 'Onboarding',
							key: FILTER_KEYS.onboarding.status.onboarding,
							filterExp: value => value.State === COMPANY_STATES.onboarding
						},
						{
							name: 'First period',
							key: FILTER_KEYS.onboarding.status.firstPeriod,
							filterExp: value => value.State === COMPANY_STATES.firstPeriod
						},
						{
							name: 'Ready to run',
							key: FILTER_KEYS.onboarding.status.ready,
							filterExp: value => value.State === COMPANY_STATES.readyToRun
						},
						{
							name: 'Expired',
							key: FILTER_KEYS.onboarding.status.expired,
							filterExp: value => value.IsExpired
						},
						{
							name: 'Not expired',
							key: FILTER_KEYS.onboarding.status.notExpired,
							filterExp: value => !value.IsExpired
						}
					]
				}
			]
		},
		payPolicies: {
			filterGroups: [
				{
					name: 'Policy type',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Annual salary',
							key: FILTER_KEYS.payPolicies.type.annualSalary,
							filterExp: value => value.PolicyPayBasis === POLICY_PAY_BASES.annualSalary
						},
						{
							name: 'Annual allowance',
							key: FILTER_KEYS.payPolicies.type.annualAllowance,
							filterExp: value => value.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance
						}
					]
				}
			]
		},
		payrollAlerts: {
			filterGroups: [
				{
					name: 'Priority',
					filterOptions: [
						{
							name: 'Error',
							key: FILTER_KEYS.payrollAlerts.priority.errors,
							filterExp: value => value.level === ALERT_LEVELS.errors
						},
						{
							name: 'Warning',
							key: FILTER_KEYS.payrollAlerts.priority.warnings,
							filterExp: value => value.level === ALERT_LEVELS.warnings
						},
						{
							name: 'Notice',
							key: FILTER_KEYS.payrollAlerts.priority.notices,
							filterExp: value => value.level === ALERT_LEVELS.notices
						}
					]
				}
			]
		},
		payslipLabels: {
			filterGroups: [
				{
					name: 'Types',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Additions',
							key: FILTER_KEYS.payslipLabels.types.additions,
							filterExp: value => value.Addition
						},
						{
							name: 'Deductions',
							key: FILTER_KEYS.payslipLabels.types.deductions,
							filterExp: value => !value.Addition
						}
					]
				}
			]
		},
		pensionCommunications: {
			filterGroups: [
				{
					name: 'Email',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Has email',
							key: FILTER_KEYS.pensionCommunications.email.hasEmail,
							filterExp: value => value.Email !== ''
						},
						{
							name: 'No email',
							key: FILTER_KEYS.pensionCommunications.email.noEmail,
							filterExp: value => value.Email === ''
						}
					]
				}
			]
		},
		getPeopleHrUpdatesFilterBarOptions: options => {

			const opts = options || {};
			const hasEdp = !!opts.hasEdp;
			const hasPeopleHr = !!opts.hasPeopleHr;

			// The list is a merge of PeopleHR and EDP events. Each event carries its own
			// source-specific fields, so resolve the value being filtered per event.
			const statusOf = value => (value && value.EdpEventID) ? value.EdpEventStatus : value.Status;
			const severityOf = value => (value && value.EdpEventID) ? value.EdpEventSeverity : value.Severity;
			const dateOf = value => (value && value.EdpEventID) ? value.EdpEventReceivedTime : value.ReceivedTimeISO;

			// Statuses are unified onto one canonical contract, so a single set covers both
			// sources. Processing/Skipped only ever apply to EDP events.
			const statusOptions = [
				{
					name: 'Successful',
					key: FILTER_KEYS.teamPeopleHrUpdates.status.completed,
					filterExp: value => statusOf(value) === PEOPLE_HR_UPDATES_EVENT_STATUS.complete
				},
				{
					name: 'Failed',
					key: FILTER_KEYS.teamPeopleHrUpdates.status.failed,
					filterExp: value => statusOf(value) === PEOPLE_HR_UPDATES_EVENT_STATUS.failed
				},
				{
					name: 'Pending',
					key: FILTER_KEYS.teamPeopleHrUpdates.status.new,
					filterExp: value => statusOf(value) === PEOPLE_HR_UPDATES_EVENT_STATUS.new
				}
			];

			if (hasEdp) {
				statusOptions.push(
					{
						name: 'Processing',
						key: FILTER_KEYS.teamEdpUpdates.status.processing,
						filterExp: value => statusOf(value) === PEOPLE_HR_UPDATES_EVENT_STATUS.processing
					},
					{
						name: 'Skipped',
						key: FILTER_KEYS.teamEdpUpdates.status.skipped,
						filterExp: value => statusOf(value) === PEOPLE_HR_UPDATES_EVENT_STATUS.skipped
					}
				);
			}

			const edpTypeOptions = [
				{
					name: 'Sickness created',
					key: FILTER_KEYS.teamEdpUpdates.type.sicknessCreated,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.sicknessCreated ||
						value.EdpEventType === EDP_UPDATES_EVENT_TYPES.smbSicknessCreated
				},
				{
					name: 'Sickness edited',
					key: FILTER_KEYS.teamEdpUpdates.type.sicknessEdited,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.sicknessEdited
				},
				{
					name: 'Sickness deleted',
					key: FILTER_KEYS.teamEdpUpdates.type.sicknessDeleted,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.sicknessDeleted
				},
				{
					name: 'Holiday created',
					key: FILTER_KEYS.teamEdpUpdates.type.holidayCreated,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.holidayCreated ||
						value.EdpEventType === EDP_UPDATES_EVENT_TYPES.smbHolidayCreated
				},
				{
					name: 'Holiday edited',
					key: FILTER_KEYS.teamEdpUpdates.type.holidayEdited,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.holidayEdited
				},
				{
					name: 'Holiday deleted',
					key: FILTER_KEYS.teamEdpUpdates.type.holidayDeleted,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.holidayDeleted
				},
				{
					name: 'Maternity created',
					key: FILTER_KEYS.teamEdpUpdates.type.maternityCreated,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.maternityCreated ||
						value.EdpEventType === EDP_UPDATES_EVENT_TYPES.smbMaternityCreated
				},
				{
					name: 'Maternity edited',
					key: FILTER_KEYS.teamEdpUpdates.type.maternityEdited,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.maternityEdited
				},
				{
					name: 'Maternity deleted',
					key: FILTER_KEYS.teamEdpUpdates.type.maternityDeleted,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.maternityDeleted
				},
				{
					name: 'Paternity created',
					key: FILTER_KEYS.teamEdpUpdates.type.paternityCreated,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.paternityCreated ||
						value.EdpEventType === EDP_UPDATES_EVENT_TYPES.smbPaternityCreated
				},
				{
					name: 'Paternity edited',
					key: FILTER_KEYS.teamEdpUpdates.type.paternityEdited,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.paternityEdited
				},
				{
					name: 'Paternity deleted',
					key: FILTER_KEYS.teamEdpUpdates.type.paternityDeleted,
					filterExp: value => value.EdpEventType === EDP_UPDATES_EVENT_TYPES.paternityDeleted
				}
			];

			const peopleHrTypeOptions = [
				{
					name: 'Bank details updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.employeeBankDetailsUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.employeeBankDetailsUpdated
				},
				{
					name: 'Contact details updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.employeeContactDetailsUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.employeeContactDetailsUpdated
				},
				{
					name: 'Mark as leaver',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.employeeLeaver,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.employeeLeaver
				},
				{
					name: 'Pay information added',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.salaryCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.salaryCreated
				},
				{
					name: 'Pay information updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.salaryUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.salaryUpdated
				},
				{
					name: 'Team member created',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.employeeCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.employeeCreated
				},
				{
					name: 'Team member details updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.employeeDetailsUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.employeeDetailsUpdated
				},
				// group all pay elements together
				{
					name: 'One-off addition created',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffPaymentCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentCreated
				},
				{
					name: 'One-off addition deleted',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffPaymentDeleted,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentDeleted
				},
				{
					name: 'One-off addition updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffPaymentUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentUpdated
				},
				{
					name: 'One-off deduction created',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffDeductionCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionCreated
				},
				{
					name: 'One-off deduction deleted',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffDeductionDeleted,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionDeleted
				},
				{
					name: 'One-off deduction updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.oneOffDeductionUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionUpdated
				},
				{
					name: 'Recurring addition created',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.entitlementCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementCreated
				},
				{
					name: 'Recurring addition deleted',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.entitlementDeleted,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementDeleted
				},
				{
					name: 'Recurring addition updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.entitlementUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementUpdated
				},
				{
					name: 'Recurring deduction created',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.deductionCreated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.deductionCreated
				},
				{
					name: 'Recurring deduction deleted',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.deductionDeleted,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.deductionDeleted
				},
				{
					name: 'Recurring deduction updated',
					key: FILTER_KEYS.teamPeopleHrUpdates.type.deductionUpdated,
					filterExp: value => value.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.deductionUpdated
				}
			];

			const severityOptions = [
				{
					name: 'Info',
					key: FILTER_KEYS.teamPeopleHrUpdates.severity.info,
					filterExp: value => severityOf(value) === 'Info'
				},
				{
					name: 'Warning',
					key: FILTER_KEYS.teamPeopleHrUpdates.severity.warning,
					filterExp: value => severityOf(value) === 'Warning'
				},
				{
					name: 'Error',
					key: FILTER_KEYS.teamPeopleHrUpdates.severity.error,
					filterExp: value => severityOf(value) === 'Error'
				}
			];

			const filterGroups = [
				{
					name: 'Status',
					filterOptions: statusOptions
				},
				{
					name: 'Type',
					filterOptions: [].concat(
						hasPeopleHr ? peopleHrTypeOptions : [],
						hasEdp ? edpTypeOptions : []
					)
				}
			];

			// The severity filter was introduced for EDP; only surface it when EDP is enabled so
			// PeopleHR-only companies keep their original filter set.
			if (hasEdp) {
				filterGroups.push({
					name: 'Severity',
					filterOptions: severityOptions
				});
			}

			// The date range is always offered: the controller defaults it to a recent window
			// and refetches when it changes, which bounds the query sent to the API.
			filterGroups.push({
				name: 'Date',
				filterAction: 'dateRange',
				dateField: 'ReceivedTimeISO',
				fromDateIso: '',
				toDateIso: '',
				storageKeyFrom: 'team-people-hr-updates-date-from',
				storageKeyTo: 'team-people-hr-updates-date-to',
				filterExp: function (value, fromIso, toIso) {
					return isWithinDateRange(dateOf(value), fromIso, toIso);
				},
				filterOptions: [] // Intentionally empty - dateRange uses fromDateIso/toDateIso instead of individual filter options
			});

			return {
				id: 'people-hr-updates',
				filterGroups: filterGroups
			};
		},
		rotareadyUpdates: {
			id: 'rotaready-updates',
			filterGroups: [
				{
					name: 'Status',
					filterOptions: [
						{
							name: 'Successful',
							key: FILTER_KEYS.teamRotareadyUpdates.status.completed,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.complete
						},
						{
							name: 'Successful (with warnings)',
							key: FILTER_KEYS.teamRotareadyUpdates.status.completedWithWarnings,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.complete && value.WarningMessagesCount > 0
						},
						{
							name: 'Failed',
							key: FILTER_KEYS.teamRotareadyUpdates.status.failed,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.failed
						},
						{
							name: 'Failed (with critical)',
							key: FILTER_KEYS.teamRotareadyUpdates.status.failedWithCritical,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.failed && value.CriticalMessagesCount > 0
						},
						{
							name: 'Processing',
							key: FILTER_KEYS.teamRotareadyUpdates.status.processing,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.processing
						},
						{
							name: 'Pending',
							key: FILTER_KEYS.teamRotareadyUpdates.status.new,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.new
						},
						{
							name: 'Skipped',
							key: FILTER_KEYS.teamRotareadyUpdates.status.skipped,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.skipped
						},
						{
							name: 'Held',
							key: FILTER_KEYS.teamRotareadyUpdates.status.held,
							filterExp: value => value.Status === ROTAREADY_UPDATES_EVENT_STATUS.held
						}
					]
				},
				{
					name: 'Type',
					filterOptions: [
						{
							name: 'User approved',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userApproved,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userApproved
						},
						{
							name: 'User updated',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userUpdated,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userUpdated
						},
						{
							name: 'Sign off day',
							key: FILTER_KEYS.teamRotareadyUpdates.type.signOffDay,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.signOffDay
						},
						{
							name: 'Sign off day reversed',
							key: FILTER_KEYS.teamRotareadyUpdates.type.signOffDayReversed,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.signOffDayReversed
						},
						{
							name: 'User employment created',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userEmploymentCreated,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentCreated
						},
						{
							name: 'User employment updated',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userEmploymentUpdated,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentUpdated
						},
						{
							name: 'User employment deleted',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userEmploymentDeleted,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentDeleted
						},
						{
							name: 'User appointment created',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userAppointmentCreated,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentCreated
						},
						{
							name: 'User appointment updated',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userAppointmentUpdated,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentUpdated
						},
						{
							name: 'User appointment deleted',
							key: FILTER_KEYS.teamRotareadyUpdates.type.userAppointmentDeleted,
							filterExp: value => value.EventType === ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentDeleted
						}
					]
				},
				{
					name: 'Severity',
					filterOptions: [
						{
							name: 'Info',
							key: FILTER_KEYS.teamRotareadyUpdates.severity.info,
							filterExp: value => value.InfoMessagesCount > 0
						},
						{
							name: 'Warning',
							key: FILTER_KEYS.teamRotareadyUpdates.severity.warning,
							filterExp: value => value.WarningMessagesCount > 0
						},
						{
							name: 'Error',
							key: FILTER_KEYS.teamRotareadyUpdates.severity.error,
							filterExp: value => value.ErrorMessagesCount > 0
						},
						{
							name: 'Critical',
							key: FILTER_KEYS.teamRotareadyUpdates.severity.critical,
							filterExp: value => value.CriticalMessagesCount > 0
						},
						{
							name: 'Critical (dismissed)',
							key: FILTER_KEYS.teamRotareadyUpdates.severity.criticalDismissed,
							filterExp: value => value.DismissedCriticalMessagesCount > 0
						}
					]
				},
				{
					name: 'Date',
					filterAction: 'dateRange',
					dateField: 'ReceivedTimeISO',
					fromDateIso: '',
					toDateIso: '',
					storageKeyFrom: 'team-rotaready-updates-date-from',
					storageKeyTo: 'team-rotaready-updates-date-to',
					filterServerSide: true, // Date range filtering is applied by the API (refetch), not filtered in the UI
					filterOptions: [] // Intentionally empty - dateRange uses fromDateIso/toDateIso instead of individual filter options
				}
			]
		},
		profileDocuments: {
			filterGroups: [
				{
					name: 'Type',
					filterOptions: [
						{
							name: 'Pay Statement',
							key: FILTER_KEYS.profileDocuments.type.payStatement,
							filterExp: value => [USER_DOCUMENT_IDS.payStatement, USER_DOCUMENT_IDS.supplementaryPayStatement, USER_DOCUMENT_IDS.manualPayStatement, USER_DOCUMENT_IDS.cisPayStatement].includes(value.UserDocumentTypeID)
						},
						{
							name: 'P60',
							key: FILTER_KEYS.profileDocuments.type.p60,
							filterExp: value => value.UserDocumentTypeID === USER_DOCUMENT_IDS.p60 || value.UserDocumentTypeID === USER_DOCUMENT_IDS.payrollP60
						},
						{
							name: 'P45',
							key: FILTER_KEYS.profileDocuments.type.p45,
							filterExp: value => value.UserDocumentTypeID === USER_DOCUMENT_IDS.p45 || value.UserDocumentTypeID === USER_DOCUMENT_IDS.payrollP45
						},
						{
							name: 'P11D',
							key: FILTER_KEYS.profileDocuments.type.p11d,
							filterExp: value => value.UserDocumentTypeID === USER_DOCUMENT_IDS.p11d
						},
						{
							name: 'MATB1',
							key: FILTER_KEYS.profileDocuments.type.matb1,
							filterExp: value => value.UserDocumentTypeID === USER_DOCUMENT_IDS.matb1
						}
					]
				}
			]
		},
		profileHistory: {
			filterGroups: [
				{
					name: 'Type',
					filterOptions: [
						{
							name: 'Personal',
							key: FILTER_KEYS.profileHistory.type.personal,
							filterExp: value => value.CategoryID === LOG_CATEGORIES.user
						},
						{
							name: 'Company',
							key: FILTER_KEYS.profileHistory.type.company,
							filterExp: value => value.CategoryID === LOG_CATEGORIES.company
						},
						{
							name: 'Payroll',
							key: FILTER_KEYS.profileHistory.type.payroll,
							filterExp: value => value.CategoryID === LOG_CATEGORIES.payroll
						}
					]
				}
			]
		},
		genderPayGapOverrides: {
			filterGroups: [
				{
					name: 'Employee type',
					filterOptions: [
						{
							name: 'Relevant',
							key: FILTER_KEYS.genderPayGapOverrides.employeeType.relevant,
							filterExp: value => value.Category === GENDER_PAY_GAP_EMPLOYEE_TYPES.relevant
						},
						{
							name: 'Full-pay relevant',
							key: FILTER_KEYS.genderPayGapOverrides.employeeType.fullPayRelevant,
							filterExp: value => value.Category === GENDER_PAY_GAP_EMPLOYEE_TYPES.fullPayRelevant
						}
					]
				},
				{
					name: 'Pay and hours',
					filterOptions: [
						{
							name: 'Zero ordinary pay',
							key: FILTER_KEYS.genderPayGapOverrides.payAndHours.zeroOrdinaryPay,
							filterExp: value => value.OrdinaryPaySnapshot === 0
						},
						{
							name: 'Zero bonus pay (period)',
							key: FILTER_KEYS.genderPayGapOverrides.payAndHours.zeroBonusPayPeriod,
							filterExp: value => value.BonusPaySnapshot === 0
						},
						{
							name: 'Zero bonus pay (12 mos)',
							key: FILTER_KEYS.genderPayGapOverrides.payAndHours.zeroBonusPayYear,
							filterExp: value => value.BonusPayAnnual === 0
						},
						{
							name: 'Zero weekly hours',
							key: FILTER_KEYS.genderPayGapOverrides.payAndHours.zeroWeeklyHours,
							filterExp: value => value.WeeklyWorkingHours === 0
						}
					]
				}
			]
		},
		profileHoliday: {
			filterGroups: [
				{
					name: 'Types',
					filterOptions: [
						{
							name: 'Annual Leave',
							key: FILTER_KEYS.profileHoliday.type.annualLeave,
							filterExp: value => value.HolidayType === LEAVE_TYPE_DESCRIPTIONS.annualLeave
						},
						{
							name: 'Special Leave',
							key: FILTER_KEYS.profileHoliday.type.specialLeave,
							filterExp: value => value.HolidayType === LEAVE_TYPE_DESCRIPTIONS.specialLeave
						},
						{
							name: 'Unpaid Leave',
							key: FILTER_KEYS.profileHoliday.type.unpaidLeave,
							filterExp: value => value.HolidayType === LEAVE_TYPE_DESCRIPTIONS.unpaidLeave
						}
					]
				},
				{
					name: 'Status',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Taken',
							key: FILTER_KEYS.profileHoliday.status.taken,
							filterExp: value => value.isTaken
						},
						{
							name: 'Untaken',
							key: FILTER_KEYS.profileHoliday.status.untaken,
							filterExp: value => !value.isTaken
						}
					]
				}
			],
		},
		profileSickness: {
			filterGroups: [
				{
					name: 'Status',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Taken',
							key: FILTER_KEYS.profileSickness.status.taken,
							filterExp: value => value.isTaken
						},
						{
							name: 'Untaken',
							key: FILTER_KEYS.profileSickness.status.untaken,
							filterExp: value => !value.isTaken
						},
					]
				}
			]
		},
		reports: {
			filterGroups: [
				{
					name: 'Report type',
					filterOptions: [
						{
							name: 'Payroll',
							key: FILTER_KEYS.reports.reportType.payroll,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.payroll, REPORT_CLASSIC_CATEGORY_IDS.payrollSummary].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						},
						{
							name: 'Pension',
							key: FILTER_KEYS.reports.reportType.pension,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.pension, REPORT_CLASSIC_CATEGORY_IDS.pensionReport, REPORT_CLASSIC_CATEGORY_IDS.pensionPAPDIS].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						},
						{
							name: 'Team',
							key: FILTER_KEYS.reports.reportType.team,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.team, REPORT_CLASSIC_CATEGORY_IDS.employeeDetails].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						},
						{
							name: 'Company',
							key: FILTER_KEYS.reports.reportType.company,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.company].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						},
						{
							name: 'Audit',
							key: FILTER_KEYS.reports.reportType.audit,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.audit].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						},
						{
							name: 'P32',
							key: FILTER_KEYS.reports.reportType.p32,
							filterExp: value => [REPORT_TEMPLATE_CATEGORIES.p32, REPORT_CLASSIC_CATEGORY_IDS.p32Report].includes(value.ReportTemplate.Category.ReportTemplateCategoryID)
						}
					]
				}
			]
		},
		schedules: {
			filterGroups: [
				{
					name: 'Type',
					filterAction: 'and',
					filterOptions: [
						{
							name: 'Adoption pay',
							key: FILTER_KEYS.schedules.type.adoptionPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.adoptionPay
						},
						{
							name: 'Attachment of Earnings',
							key: FILTER_KEYS.schedules.type.attachmentOfEarnings,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.attachmentOfEarnings
						},
						{
							name: 'Childcare vouchers',
							key: FILTER_KEYS.schedules.type.childcareVouchers,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.childcareVouchers
						},
						{
							name: 'Company loan',
							key: FILTER_KEYS.schedules.type.companyLoan,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.companyLoan
						},
						{
							name: 'Company vehicle BIK',
							key: FILTER_KEYS.schedules.type.carBenefitInKind,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.carBenefitInKind
						},
						{
							name: 'Covid-19 sick pay',
							key: FILTER_KEYS.schedules.type.covid19SickPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.covid19SickPay
						},
						{
							name: 'Cycle to Work scheme',
							key: FILTER_KEYS.schedules.type.cycleToWorkScheme,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.cycleToWorkScheme
						},
						{
							name: 'Healthcare BIK',
							key: FILTER_KEYS.schedules.type.healthcare,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.healthcare
						},
						{
							name: 'Maternity pay',
							key: FILTER_KEYS.schedules.type.maternityPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.maternityPay
						},
						{
							name: 'Paternity pay',
							key: FILTER_KEYS.schedules.type.paternityPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.paternityPay
						},
						{
							name: 'Season ticket loan',
							key: FILTER_KEYS.schedules.type.seasonTicketLoan,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.seasonTicketLoan
						},
						{
							name: 'Shared parental pay',
							key: FILTER_KEYS.schedules.type.sharedParentalPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.sharedParentalPay
						},
						{
							name: 'Sick pay',
							key: FILTER_KEYS.schedules.type.sickPay,
							filterExp: value => value.type === UI_SCHEDULE_TYPES.sickPay
						}
					]
				},
				{
					/* The schedule status filter uses statuses derived from assorted flags in each
					   schedule object. These were added for sorting, but have been used here too because
					   they're there and it's simpler. See schedule.service.js -> decorateSchedule */
					name: 'Status',
					filterAction: 'and',
					filterOptions: [
						{
							name: 'In progress',
							key: FILTER_KEYS.schedules.status.inProgress,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.inProgress
						},
						{
							name: 'Pending',
							key: FILTER_KEYS.schedules.status.pending,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.pending
						},
						{
							name: 'Complete',
							key: FILTER_KEYS.schedules.status.complete,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.complete
						},
						{
							name: 'Paused',
							key: FILTER_KEYS.schedules.status.paused,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.paused
						},
						{
							name: 'Cancelled',
							key: FILTER_KEYS.schedules.status.cancelled,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.cancelled
						},
						{
							name: 'Stopped',
							key: FILTER_KEYS.schedules.status.stopped,
							filterExp: value => value.status === UI_SCHEDULE_STATUSES.stopped
						}
					]
				}
			]
		},
		tasks: {
			filterGroups: [
				{
					name: 'Status',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Incomplete',
							key: FILTER_KEYS.tasks.status.incomplete,
							filterExp: value => !value.IsComplete
						},
						{
							name: 'Complete',
							key: FILTER_KEYS.tasks.status.complete,
							filterExp: value => value.IsComplete
						}
					]
				},
				{
					name: 'Due',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Overdue',
							key: FILTER_KEYS.tasks.due.overdue,
							filterExp: value => value.IsOverdue && !value.IsComplete
						},
						{
							name: 'Not overdue',
							key: FILTER_KEYS.tasks.due.notoverdue,
							filterExp: value => !value.IsOverdue
						}
					]
				}
			]
		},
		taxUpdates: {
			filterGroups: [
				{
					name: 'Effective',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Within last month',
							key: FILTER_KEYS.taxUpdates.effectiveDate.oneMonth,
							filterExp: value => moment(value.EffectiveDateISO).isAfter(moment().subtract(1, 'month'))
						},
						{
							name: 'Within last 3 months',
							key: FILTER_KEYS.taxUpdates.effectiveDate.threeMonths,
							filterExp: value => moment(value.EffectiveDateISO).isAfter(moment().subtract(3, 'months'))
						},
						{
							name: 'Within last 6 months',
							key: FILTER_KEYS.taxUpdates.effectiveDate.sixMonths,
							filterExp: value => moment(value.EffectiveDateISO).isAfter(moment().subtract(6, 'months'))
						},
						{
							name: 'Within last year',
							key: FILTER_KEYS.taxUpdates.effectiveDate.twelveMonths,
							filterExp: value => moment(value.EffectiveDateISO).isAfter(moment().subtract(1, 'year'))
						}
					]
				},
			]
		},
		workflowTasks: {
			filterGroups: [
				{
					name: 'Pay frequency',
					filterOptions: [
						{
							name: 'Weekly',
							key: FILTER_KEYS.workflowTasks.payFrequency.weekly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.weekly
						},
						{
							name: 'Two weekly',
							key: FILTER_KEYS.workflowTasks.payFrequency.fortnightly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.fortnightly
						},
						{
							name: 'Four weekly',
							key: FILTER_KEYS.workflowTasks.payFrequency.fourWeekly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.fourweekly
						},
						{
							name: 'Monthly',
							key: FILTER_KEYS.workflowTasks.payFrequency.monthly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.monthly
						},
						{
							name: 'Quarterly',
							key: FILTER_KEYS.workflowTasks.payFrequency.quarterly,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.quarterly
						},
						{
							name: 'Annually',
							key: FILTER_KEYS.workflowTasks.payFrequency.annually,
							filterExp: value => value.CurrentPeriodType === PAY_PERIOD_TYPES.weekly
						}
					]
				},
				{
					name: 'Status',
					filterOptions: [
						{
							name: 'Overdue',
							key: FILTER_KEYS.workflowTasks.status.isOverdue,
							filterExp: value => value.IsOverdue
						},
						{
							name: 'Due today',
							key: FILTER_KEYS.workflowTasks.status.isDueToday,
							filterExp: value => moment(value.DueDateISO).isSame(moment(), 'day')
						},
						{
							name: 'Due in next 2 days',
							key: FILTER_KEYS.workflowTasks.status.isDueWithinTwoDays,
							filterExp: value => moment(value.DueDateISO).isBetween(moment(), moment().add(2, 'day'), 'day', '[]')
						},
						{
							name: 'Due in next 3 days',
							key: FILTER_KEYS.workflowTasks.status.isDueWithinThreeDays,
							filterExp: value => moment(value.DueDateISO).isBetween(moment(), moment().add(3, 'day'), 'day', '[]')
						},
						{
							name: 'Queried',
							key: FILTER_KEYS.workflowTasks.status.isQueried,
							filterExp: value => value.IsPayrollQueried
						},
						{
							name: 'Draft',
							key: FILTER_KEYS.workflowTasks.status.isDraft,
							filterExp: value => value.IsComplete // @todo ???
						},
						{
							name: 'Payroll failed',
							key: FILTER_KEYS.tasks,
							filterExp: value => value.IsPayrollFailed
						}
					]
				},
				{
					name: 'Step',
					filterOptions: [
						{
							name: 'Payroll information',
							key: FILTER_KEYS.workflowTasks.step.payrollInformation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL INFORMATION'
						},
						{
							name: 'Payroll calculation',
							key: FILTER_KEYS.workflowTasks.step.payrollCalculation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL CALCULATION'
						},
						{
							name: 'Payroll confirmation',
							key: FILTER_KEYS.workflowTasks.step.payrollConfirmation,
							filterExp: value => value.Title.toUpperCase().trim() === 'PAYROLL CONFIRMATION'
						},
						{
							name: 'Run payroll',
							key: FILTER_KEYS.workflowTasks.step.runPayroll,
							filterExp: value => value.Title.toUpperCase().trim() === 'RUN PAYROLL'
						}
					]
				}
			]
		},

		getDepartmentFilterGroup: (returnObj, departmentsArr) => {

			if (departmentsArr.length > 0) {

				const departmentFilterGroupObj = {
					filterOptions: [],
					name: 'Department'
				};

				for (let departmentObj of departmentsArr) {

					if (!departmentObj.UnallocatedDepartment) {
						departmentFilterGroupObj.filterOptions.push({
							name: departmentObj.AgencyDepartmentName,
							key: departmentObj.AgencyDepartmentID,
							filterExp: value => value.AgencyDepartmentID === departmentObj.AgencyDepartmentID
						});
					}
				}

				returnObj.filterGroups.push(departmentFilterGroupObj);
			}
		},

		getFilterBarOptionsByKey: function (filterOptionsKey, companyObj, currentUserObj) {

			switch (filterOptionsKey) {

				case 'companies':
					return service.getFilterBarOptionsCompanies(currentUserObj);
				case 'currentPeriod':
					return service.currentPeriod;
				case 'team':
					return service.getFilterBarOptionsTeam(companyObj);
				case 'team-pension':
					return service.getFilterBarOptionsTeamPension(companyObj);
			}
		},

		getFilterBarOptionsAverageHolidayPay: function () {
			const filterGroups = [
				{
					name: 'Rate type',
					filterOptions: [
						{
							name: 'Hourly',
							key: FILTER_KEYS.averageHolidayPay.rateType.hourly,
							filterExp: value => value.RateType === AVERAGE_HOLIDAY_PAY_RATE_TYPES.hourly
						},
						{
							name: 'Daily',
							key: FILTER_KEYS.averageHolidayPay.rateType.daily,
							filterExp: value => value.RateType === AVERAGE_HOLIDAY_PAY_RATE_TYPES.daily
						},
						{
							name: 'Other',
							key: FILTER_KEYS.averageHolidayPay.rateType.other,
							filterExp: value => value.RateType === AVERAGE_HOLIDAY_PAY_RATE_TYPES.other
						}
					]
				},
				{
					name: '52-week average',
					filterOptions: [
						{
							name: 'Included in 52-week ave.',
							key: FILTER_KEYS.averageHolidayPay.inclusion.included,
							filterExp: value => value.IncludeIn52WeekAverage
						},
						{
							name: 'Excl. from 52-week ave.',
							key: FILTER_KEYS.averageHolidayPay.inclusion.excluded,
							filterExp: value => !value.IncludeIn52WeekAverage
						}
					]
				}
			];

			return { filterGroups };
		},

		// One chip per pay element the bureau selected, so a bureau with many affected companies can
		// narrow the push-down list down to a single element (SMBST-161-4).
		getFilterBarOptionsCompanyPayElementOverrides: function (selectedPayElements) {
			const elementFilterGroup = {
				name: 'Pay element',
				filterOptions: []
			};

			selectedPayElements.forEach(payElement => {
				elementFilterGroup.filterOptions.push({
					name: payElement.ElementName,
					key: `${FILTER_KEYS.companyPayElementOverrides.element}.${payElement.AgencyAdjustmentGroupEntryID}`,
					filterExp: company => company.overrides.some(overrideObj => overrideObj.AgencyAdjustmentGroupEntryID === payElement.AgencyAdjustmentGroupEntryID)
				});
			});

			return { filterGroups: [elementFilterGroup] };
		},

		getFilterBarOptionsAdmins: function (companyObj) {
			const filterGroups = [
				{
					name: 'Account',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Registered',
							key: FILTER_KEYS.admins.account.isRegistered,
							filterExp: value => value.IsRegistered
						},
						{
							name: 'Not registered',
							key: FILTER_KEYS.admins.account.notRegistered,
							filterExp: value => !value.IsRegistered
						}
					]
				}
			];

			// Add Payroll filter for payroll companies
			if (companyObj.isPayrollCompany) {
				filterGroups.push({
					name: 'Payroll',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Included in payroll',
							key: FILTER_KEYS.admins.payroll.includedInPayroll,
							filterExp: value => !value.ExcludeFromPayroll
						},
						{
							name: 'Excluded from payroll',
							key: FILTER_KEYS.admins.payroll.excludedFromPayroll,
							filterExp: value => value.ExcludeFromPayroll
						}
					]
				});
			}

			return { filterGroups };
		},

		getFilterBarOptionsApiReferences: apiReferences => {

			const filterGroups = [];

			// Library filter
			const libraryFilterGroup = {
				name: 'Library',
				filterAction: 'and',
				filterOptions: []
			};
			filterGroups.push(libraryFilterGroup);

			// Project filter
			const projectFilterGroup = {
				name: 'Project',
				filterAction: 'and',
				filterOptions: []
			};
			filterGroups.push(projectFilterGroup);

			// Get distinct list of libraries and projects
			const libraries = [];
			const projects = [];
			apiReferences.forEach(apiReference => {
				if (!libraries.includes(apiReference.library)) {
					libraries.push(apiReference.library);
				}
				if (!projects.includes(apiReference.project)) {
					projects.push(apiReference.project);
				}
			});

			// Put them in a sensible order and add a filter for each
			libraries.sort();
			libraries.forEach(library => {
				libraryFilterGroup.filterOptions.push({
					name: library,
					key: `${FILTER_KEYS.apiReferences.library}.${library}`,
					filterExp: value => value.library === library
				});
			});
			projects.sort();
			projects.forEach(project => {
				projectFilterGroup.filterOptions.push({
					name: project,
					key: `${FILTER_KEYS.apiReferences.project}.${project}`,
					filterExp: value => value.project === project
				});
			});

			const referenceCountFilterGroup = {
				name: 'Reference count',
				filterAction: 'and',
				filterOptions: []
			};
			filterGroups.push(referenceCountFilterGroup);
			// Get max reference count
			let maxReferenceCount = (apiReferences.reduce((apiReferenceA, apiReferenceB) => apiReferenceB.referenceCount > apiReferenceA.referenceCount ? apiReferenceB : apiReferenceA)).referenceCount;
			// Use that to build a set of options in blocks of ten
			maxReferenceCount -= (maxReferenceCount % 10);
			while (maxReferenceCount >= 0) {
				// Copy max reference count, otherwise all filter options will be using the same, final value of maxReferenceCount in this loop
				let count = maxReferenceCount;
				referenceCountFilterGroup.filterOptions.push({
					name: `${maxReferenceCount} - ${maxReferenceCount + 10}`,
					key: `${FILTER_KEYS.apiReferences.referenceCount}.${maxReferenceCount}`,
					filterExp: value => {
						return value.referenceCount >= count && value.referenceCount <= (count + 10);
					}
				});
				maxReferenceCount -= 10;
			}

			return { filterGroups };
		},

		getFilterBarOptionsCurrentPeriod: (companyPensionsArr, departmentsArr) => {

			const returnObj = {
				filterGroups: [
					{
						name: 'Status',
						filterOptions: [
							{
								name: 'Incomplete',
								key: FILTER_KEYS.currentPeriod.status.incomplete,
								filterExp: value => !value.IsComplete
							},
							{
								name: 'Changes added',
								key: FILTER_KEYS.currentPeriod.status.hasChanges,
								filterExp: value => value.Adjustments.length > 0
							},
							{
								name: 'No changes',
								key: FILTER_KEYS.currentPeriod.status.noChanges,
								filterExp: value => value.Adjustments.length === 0
							},
							{
								name: 'Has salary change',
								key: FILTER_KEYS.currentPeriod.status.hasSalaryChange,
								filterExp: value => value.HasSalaryChange
							},
							{
								name: 'Payslip note added',
								key: FILTER_KEYS.currentPeriod.status.payslipNoteAdded,
								filterExp: value => value.HasPayslipNote
							},
							{
								name: 'No payslip note',
								key: FILTER_KEYS.currentPeriod.status.noPayslipNote,
								filterExp: value => !value.HasPayslipNote
							},
							{
								name: 'Is rejoiner',
								key: FILTER_KEYS.currentPeriod.status.rejoiner,
								filterExp: value => value.PersonalDetails.IsRestarting
							},
							{
								name: 'Is advancing',
								key: FILTER_KEYS.currentPeriod.status.advancing,
								filterExp: value => value.PersonalDetails.IsAdvancingFuturePeriods
							},
							{
								name: 'Omitted from RTI',
								key: FILTER_KEYS.currentPeriod.status.isExcludedFromRti,
								filterExp: value => value.IsExcludedFromRTI
							}
						]
					},
					{
						name: 'Salary type',
						filterOptions: [
							{
								name: 'Paid salary',
								key: FILTER_KEYS.currentPeriod.salary.paidSalary,
								filterExp: value => [SALARY_TYPES.grossPay, SALARY_TYPES.payPolicy].includes(value.PersonalDetails.SalaryType) && !value.PersonalDetails.IsOffPayrollWorker
							},
							{
								name: 'Paid hourly',
								key: FILTER_KEYS.currentPeriod.salary.paidHourly,
								filterExp: value => value.PersonalDetails.SalaryType === SALARY_TYPES.hourlyPay && !value.PersonalDetails.IsOffPayrollWorker
							},
							{
								name: 'Paid net',
								key: FILTER_KEYS.currentPeriod.salary.paidNet,
								filterExp: value => value.PersonalDetails.SalaryType === SALARY_TYPES.netPay && !value.PersonalDetails.IsOffPayrollWorker
							},
							{
								name: 'Off payroll',
								key: FILTER_KEYS.currentPeriod.salary.offPayroll,
								filterExp: value => value.PersonalDetails.IsOffPayrollWorker
							}
						]
					}
				]
			};

			// Pension companies only
			if (companyPensionsArr && companyPensionsArr.length > 0) {

				// Pension Status
				returnObj.filterGroups.push({
					name: 'Pension status',
					filterOptions: [
						{
							name: 'Enrolled',
							key: FILTER_KEYS.currentPeriod.pension.pensionEnrolled,
							filterExp: value => value.PensionState === PENSION_STATUSES.enrolled
						},
						{
							name: 'Will be enrolled',
							key: FILTER_KEYS.currentPeriod.pension.pensionWillBeEnrolled,
							filterExp: value => value.PensionState === PENSION_STATUSES.willBeEnrolled
						},
						{
							name: 'Re-assessment',
							key: FILTER_KEYS.currentPeriod.pension.pensionReassessment,
							filterExp: value => value.PensionState === PENSION_STATUSES.reAssessment
						},
						{
							name: 'Joined',
							key: FILTER_KEYS.currentPeriod.pension.pensionJoined,
							filterExp: value => value.PensionState === PENSION_STATUSES.joined
						},
						{
							name: 'Can join',
							key: FILTER_KEYS.currentPeriod.pension.pensionCanJoin,
							filterExp: value => value.PensionState === PENSION_STATUSES.canJoin
						},
						{
							name: 'Can opt in',
							key: FILTER_KEYS.currentPeriod.pension.pensionCanOptIn,
							filterExp: value => value.PensionState === PENSION_STATUSES.canOptIn
						},
						{
							name: 'Postponed',
							key: FILTER_KEYS.currentPeriod.pension.pensionPostponed,
							filterExp: value => value.PensionState === PENSION_STATUSES.postponed
						},
						{
							name: 'Opted in',
							key: FILTER_KEYS.currentPeriod.pension.pensionOptedIn,
							filterExp: value => value.PensionState === PENSION_STATUSES.optedIn
						},
						{
							name: 'Opted out',
							key: FILTER_KEYS.currentPeriod.pension.pensionOptedOut,
							filterExp: value => value.PensionState === PENSION_STATUSES.optedOut
						}
					]
				});


				// Pensions
				const pensionFilterGroup = {
					name: 'Pension',
					filterOptions: [{
						name: 'No pension',
						key: 'no-pension',
						filterExp: value => value.Pensions.length === 0
					}]
				};

				companyPensionsArr.forEach(companyPensionObj => {

					pensionFilterGroup.filterOptions.unshift(
						{
							name: `${companyPensionObj.PensionProviderName} (${companyPensionObj.EmployerReference})`,
							key: 'team-pension-' + companyPensionObj.AgencyEmployerPensionID,
							filterExp: value => value.Pensions.length > 0 && value.Pensions.find(pensionObj => pensionObj.AgencyEmployerPensionID === companyPensionObj.AgencyEmployerPensionID)
						}
					);
				});

				returnObj.filterGroups.push(pensionFilterGroup);
			}

			// Departments
			service.getDepartmentFilterGroup(returnObj, departmentsArr);

			return returnObj;
		},

		getFilterBarOptionsCurrentPeriodImports: function (companyObj) {

			var returnObj = {
				filterGroups: [
					{
						name: 'Import type',
						filterOptions: [
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRecurring),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsRecurring,
								filterExp: value => [IMPORT_MAPPING_TYPES.payElementsRecurring, IMPORT_MAPPING_TYPES.payElementsFixedRecurring].includes(value.ImportType)
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixed),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsFixed,
								filterExp: value => [IMPORT_MAPPING_TYPES.payElements, IMPORT_MAPPING_TYPES.payElementsFixed].includes(value.ImportType)
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsRatedUnitsVertical,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsRatedUnitsHorizontal,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsHourlyRate),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsHourlyRate,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsHourlyRate
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsDailyRate),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsDailyRate,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsDailyRate
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayroll),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsOffPayroll,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsOffPayroll
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring),
								key: FILTER_KEYS.currentPeriodImports.importType.payElementsOffPayrollRecurring,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring
							}
						]
					},
					{
						name: 'Import state',
						filterAction: 'or',
						filterOptions: [
							{
								name: 'Imported',
								key: FILTER_KEYS.currentPeriodImports.importState.imported,
								filterExp: value => !value.Undone
							},
							{
								name: 'Undone',
								key: FILTER_KEYS.currentPeriodImports.importState.undone,
								filterExp: value => value.Undone
							}
						]
					}
				]
			};

			// Agencies only
			if (companyObj.CompanyType === INTERFACE_TYPES.agency) {
				returnObj.filterGroups[0].filterOptions.push({
					name: 'Timesheets',
					key: FILTER_KEYS.currentPeriodImports.importType.timesheets,
					filterExp: value => value.ImportType === 1
				});
			}

			return returnObj;
		},

		getFilterBarOptionsImportMappingColumns: mappingColumnsArr => {

			let lettersArr = [];
			let returnArr = [];

			mappingColumnsArr.forEach((mappingColumnObj) => {
				lettersArr.push(mappingColumnObj.ImportMappingColumnText[0].toLowerCase());
			});

			lettersArr = $filter('orderBy', 'name')(utilities.removeDuplicatesFromArrayOfStrings(lettersArr));

			lettersArr.forEach(letter => {
				returnArr.push({
					name: letter,
					key: letter,
					filterExp: value => {
						return value.ImportMappingColumnText[0].toLowerCase() === letter;
					}
				});
			});

			// Additions
			/*
			returnArr.push({
				name: 'Additions',
				key: 'additions',
				filterExp: (value) => {
					return !value.IsDeduction;
				}
			});

			// Deductions
			returnArr.push({
				name: 'Deductions',
				key: 'deductions',
				filterExp: (value) => {
					return value.IsDeduction;
				}
			});
			*/

			// All
			returnArr.push({
				name: 'ALL',
				key: 'all',
				filterExp: _ => { return _; }
			});

			return returnArr;
		},

		getFilterBarOptionsJournalImports: () => {

			var returnObj = {
				filterGroups: [
					{
						name: 'Import status',
						filterAction: 'or',
						filterOptions: [
							{
								name: 'Imported',
								key: FILTER_KEYS.journals.importState.imported,
								filterExp: value => !value.Undone
							},
							{
								name: 'Undone',
								key: FILTER_KEYS.journals.importState.undone,
								filterExp: value => value.Undone
							}
						]
					}
				]
			};

			return returnObj;
		},

		getFilterBarOptionsOnboardingStats: monthStr => {
			return {
				filterGroups: [
					{
						name: 'Total Onboarded',
						filterAction: 'or',
						filterOptions: [
							{
								name: '0-99',
								key: 'onboarding.totalOnboarded.zerotoonehundred',
								filterExp: value => {
									return value[monthStr] < 100;
								}
							},
							{
								name: '100-499',
								key: 'onboarding.totalOnboarded.onehundredtofivehundres',
								filterExp: value => {
									return value[monthStr] >= 100 && value[monthStr] < 500;
								}
							},
							{
								name: '500+',
								key: 'onboarding.totalOnboarded.morethanfivehundred',
								filterExp: value => {
									return value[monthStr] >= 500;
								}
							}
						]
					}
				]
			};
		},

		getFilterBarOptionsImportMapping: companyObj => {

			let returnObj = {
				filterGroups: [
					{
						name: 'Payroll',
						filterOptions: [
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.users),
								key: FILTER_KEYS.importMappings.payroll.users,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.users
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRecurring),
								key: FILTER_KEYS.importMappings.payroll.payElementsRecurring,
								filterExp: value => [IMPORT_MAPPING_TYPES.payElementsRecurring, IMPORT_MAPPING_TYPES.payElementsFixedRecurring].includes(value.MappingType)
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixed),
								key: FILTER_KEYS.importMappings.payroll.payElementsFixed,
								filterExp: value => [IMPORT_MAPPING_TYPES.payElements, IMPORT_MAPPING_TYPES.payElementsFixed].includes(value.MappingType)
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical),
								key: FILTER_KEYS.importMappings.payroll.payElementsRatedUnitsVertical,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal),
								key: FILTER_KEYS.importMappings.payroll.payElementsRatedUnitsHorizontal,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsHourlyRate),
								key: FILTER_KEYS.importMappings.payroll.payElementsHourlyRate,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.payElementsHourlyRate
							},
							// {
							// 	name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsDailyRate),
							// 	key: FILTER_KEYS.importMappings.payroll.payElementsDailyRate,
							// 	filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.payElementsDailyRate
							// },
							// {
							// 	name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.cis),
							// 	key: FILTER_KEYS.importMappings.payroll.cis,
							// 	filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.cis
							// },
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixedCIS),
								key: FILTER_KEYS.importMappings.payroll.payElementsFixedCIS,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.payElementsFixedCIS
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayroll),
								key: FILTER_KEYS.importMappings.payroll.payElementsOffPayroll,
								filterExp: value =>  value.MappingType === IMPORT_MAPPING_TYPES.payElementsOffPayroll
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring),
								key: FILTER_KEYS.importMappings.payroll.payElementsOffPayrollRecurring,
								filterExp: value =>  value.MappingType === IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring
							},
						]
					},
					{
						name: 'Team',
						filterOptions: [
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.team),
								key: FILTER_KEYS.importMappings.team.team,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.team
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.profile),
								key: FILTER_KEYS.importMappings.team.profile,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.profile
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.address),
								key: FILTER_KEYS.importMappings.team.address,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.address
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.ytd),
								key: FILTER_KEYS.importMappings.team.ytd,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.ytd
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.company),
								key: FILTER_KEYS.importMappings.team.company,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.company
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.bank),
								key: FILTER_KEYS.importMappings.team.bank,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.bank
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.tax),
								key: FILTER_KEYS.importMappings.team.tax,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.tax
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.salary),
								key: FILTER_KEYS.importMappings.team.salary,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.salary
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.pension),
								key: FILTER_KEYS.importMappings.team.pension,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.pension
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.cis),
								key: FILTER_KEYS.importMappings.team.cis,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.cis
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.expatDetails),
								key: FILTER_KEYS.importMappings.team.expats,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.expatDetails
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.all),
								key: FILTER_KEYS.importMappings.team.all,
								filterExp: value => value.MappingType === IMPORT_MAPPING_TYPES.all
							}
						]
					}
				]
			};

			// Add managed filter group at company level
			if (companyObj.isPayrollCompany) {

				returnObj.filterGroups.push({
					name: 'Managed',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'Bureau mappings',
							key: FILTER_KEYS.importMappings.managed.bureau,
							filterExp: value => value.IsGlobalTemplate
						},
						{
							name: 'Company mappings',
							key: FILTER_KEYS.importMappings.managed.company,
							filterExp: value => !value.IsGlobalTemplate
						}
					]
				});
			}

			return returnObj;
		},

		getFilterBarOptionsPeriodNotes: adminsArr => {

			const periodNotesFilterObj = {
				filterGroups: []
			};

			const authorFilterObj = {
				name: 'Author',
				filterOptions: []
			};

			const mentionedFilterObj = {
				name: '@Mentioned',
				filterOptions: []
			};

			for (let adminObj of adminsArr) {

				const adminFullname = `${adminObj.Forename} ${adminObj.Surname}`;
				const adminNameToken = utilities.guid();

				authorFilterObj.filterOptions.push({
					name: adminFullname,
					key: 'peroid-notes-author-' + adminNameToken,
					filterExp: value => value.Sender === adminFullname
				});

				mentionedFilterObj.filterOptions.push({
					name: adminFullname,
					key: 'peroid-notes-mention-' + adminNameToken,
					filterExp: value => value.MentionList.includes(adminObj.UserID)
				});
			}

			if (authorFilterObj.filterOptions.length > 0) {
				periodNotesFilterObj.filterGroups.push(authorFilterObj);
			}

			if (mentionedFilterObj.filterOptions.length > 0) {
				periodNotesFilterObj.filterGroups.push(mentionedFilterObj);
			}


			return periodNotesFilterObj;
		},

		getFilterBarOptionsPensionTeam: (companyPensionGroupsArr, pensionObj) => {

			const returnObj = {
				filterGroups: []
			};

			switch (pensionObj.PensionType) {
				case PENSION_TYPES.autoEnrolment:
					returnObj.filterGroups.push(
						{
							name: 'Enrolment date',
							filterAction: 'or',
							filterOptions: [
								{
									name: 'Within last month',
									key: FILTER_KEYS.pensionTeam.enrolmentDate.oneMonth,
									filterExp: value => moment(value.Pension.PensionEnrolledDateISO).isAfter(moment().subtract(1, 'month'))
								},
								{
									name: 'Within last 3 months',
									key: FILTER_KEYS.pensionTeam.enrolmentDate.threeMonths,
									filterExp: value => moment(value.Pension.PensionEnrolledDateISO).isAfter(moment().subtract(3, 'months'))
								},
								{
									name: 'Within last 6 months',
									key: FILTER_KEYS.pensionTeam.enrolmentDate.sixMonths,
									filterExp: value => moment(value.Pension.PensionEnrolledDateISO).isAfter(moment().subtract(6, 'months'))
								},
								{
									name: 'Within last year',
									key: FILTER_KEYS.pensionTeam.enrolmentDate.twelveMonths,
									filterExp: value => moment(value.Pension.PensionEnrolledDateISO).isAfter(moment().subtract(1, 'year'))
								}
							]
						},
						{
							name: 'Status',
							filterOptions: [
								{
									name: 'Enrolled',
									key: FILTER_KEYS.pensionTeam.status.enrolled,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.enrolled
								},
								{
									name: 'Will be enrolled',
									key: FILTER_KEYS.pensionTeam.status.willBeEnrolled,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.willBeEnrolled
								},
								{
									name: 'Re-assessment',
									key: FILTER_KEYS.pensionTeam.status.reassessment,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.reAssessment
								},
								{
									name: 'Joined',
									key: FILTER_KEYS.pensionTeam.status.joined,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.joined
								},
								{
									name: 'Can join',
									key: FILTER_KEYS.pensionTeam.status.canJoin,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.canJoin
								},
								{
									name: 'Can opt in',
									key: FILTER_KEYS.pensionTeam.status.canOptIn,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.canOptIn
								},
								{
									name: 'Postponed',
									key: FILTER_KEYS.pensionTeam.status.postponed,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.postponed
								},
								{
									name: 'Opted out',
									key: FILTER_KEYS.pensionTeam.status.optedOut,
									filterExp: value => value.Pension.PensionState === PENSION_STATUSES.optedOut
								},
								{
									name: 'Incomplete',
									key: 'incomplete',
									filterExp: value => !value.IsComplete
								}
							]
						}
					);
					break;

				case PENSION_TYPES.nonAutoEnrolment:
					returnObj.filterGroups.push(
						{
							name: 'Joined date',
							filterAction: 'or',
							filterOptions: [
								{
									name: 'Within last month',
									key: FILTER_KEYS.pensionTeam.joinedDate.oneMonth,
									filterExp: value => moment(value.Pension.PensionJoinedDateISO).isAfter(moment().subtract(1, 'month'))
								},
								{
									name: 'Within last 3 months',
									key: FILTER_KEYS.pensionTeam.joinedDate.threeMonths,
									filterExp: value => moment(value.Pension.PensionJoinedDateISO).isAfter(moment().subtract(3, 'months'))
								},
								{
									name: 'Within last 6 months',
									key: FILTER_KEYS.pensionTeam.joinedDate.sixMonths,
									filterExp: value => moment(value.Pension.PensionJoinedDateISO).isAfter(moment().subtract(6, 'months'))
								},
								{
									name: 'Within last year',
									key: FILTER_KEYS.pensionTeam.joinedDate.twelveMonths,
									filterExp: value => moment(value.Pension.PensionJoinedDateISO).isAfter(moment().subtract(1, 'year'))
								}
							]
						}
					);
					break;
			}

			// Groups / band filter for non-policy-based pensions
			if (!pensionObj.UsePensionPolicy) {

				const pensionFilterGroup = {
					name: pensionService.isAEPension(pensionObj) ? 'Group' : 'Band',
					filterOptions: []
				};

				companyPensionGroupsArr.forEach(function (companyPensionGroupObj) {

					pensionFilterGroup.filterOptions.push(
						{
							name: companyPensionGroupObj.PensionGroupName,
							key: 'team-pension-group-' + companyPensionGroupObj.PensionGroupID,
							filterExp: value => value.Pension && value.Pension.PensionGroupID === companyPensionGroupObj.PensionGroupID
						}
					);
				});

				returnObj.filterGroups.push(pensionFilterGroup);
			}

			return returnObj;
		},

		getFilterBarOptionsCompanies: currentUserObj => {

			const companiesModulesFilterObj = {
				name: 'Modules',
				count: 0,
				filterOptions: [
					{
						name: 'Payroll',
						key: FILTER_KEYS.companies.modules.payroll,
						filterExp: value => value.Company.IsPayrollActive
					},
					{
						name: 'Pension',
						key: FILTER_KEYS.companies.modules.pension,
						filterExp: value => value.Company.IsPensionActive
					},
					{
						name: 'CIS',
						key: FILTER_KEYS.companies.modules.cis,
						filterExp: value => value.Company.IsCISActive
					},
					{
						name: 'HR',
						key: FILTER_KEYS.companies.modules.hr,
						filterExp: value => value.Company.IsHRActive
					},
					{
						name: 'Workflow',
						key: FILTER_KEYS.companies.modules.workflow,
						filterExp: value => value.Company.IsWorkflowEnabled
					},
					{
						name: 'Payslip manager',
						key: FILTER_KEYS.companies.modules.payslipOnly,
						filterExp: value => value.Company.IsPayslipManagerActive
					},
					{
						name: 'Expats',
						key: FILTER_KEYS.companies.modules.expats,
						filterExp: value => value.Company.IsExpatActive
					},
					{
						name: 'Off-payroll workers',
						key: FILTER_KEYS.companies.modules.offPayroll,
						filterExp: value => value.Company.IsOffPayrollActive
					},
					{
						name: 'Gender pay gap reporting',
						key: FILTER_KEYS.companies.modules.genderPayGapReport,
						filterExp: value => value.Company.IsGenderPayGapReportingActive
					}
				]
			};

			let returnObj = {
				filterGroups: [
					{
						name: 'Status',
						filterOptions: [
							{
								name: 'First live period',
								key: FILTER_KEYS.companies.payroll.firstLivePeriod,
								filterExp: value => !value.Company.IsInTestMode && !value.Company.AgencyProfileDummy && value.Company.CanBeMadeTest
							},
							{
								name: 'Due this week',
								key: FILTER_KEYS.companies.payroll.dueSoon,
								filterExp: value => value.PayPeriod.PayDayDaysAway < 7
							},
							{
								name: 'Overdue',
								key: FILTER_KEYS.companies.payroll.overdue,
								filterExp: value => value.PayPeriod.PayDayDaysOverdue > 0
							},
							{
								name: 'Failed',
								key: FILTER_KEYS.companies.payroll.failed,
								filterExp: value => value.PayPeriod.PayrollState === SUBMISSION_STATES.failed
							},
							{
								name: 'Ceased',
								key: FILTER_KEYS.companies.payroll.ceased,
								filterExp: value => value.Company.PAYECeaseDateISO !== ''
							}
						]
					},
					{
						name: 'Payroll',
						count: 0,
						filterAction: 'or',
						filterOptions: [
							{
								name: 'Has run payroll',
								key: FILTER_KEYS.companies.setup.hasRunPayroll,
								filterExp: value => value.Company.HasRunPayroll
							},
							{
								name: 'Hasn\'t run payroll',
								key: FILTER_KEYS.companies.setup.hasNotRunPayroll,
								filterExp: value => !value.Company.HasRunPayroll
							}
						]
					},
					{
						name: 'Pension',
						filterOptions: [
							{
								name: 'Submission failed',
								key: FILTER_KEYS.companies.pension.submissionFailed,
								filterExp: value => value.PayPeriod.PensionSubmitState === SUBMISSION_STATES.failed
							},
							{
								name: 'Submission pending',
								key: FILTER_KEYS.companies.pension.submissionPending,
								filterExp: value =>  value.PayPeriod.PensionSubmitState === SUBMISSION_STATES.submitting
							},
							{
								name: 'Unauthorised',
								key: FILTER_KEYS.companies.pension.unauthorised,
								filterExp: value => value.Pension.ProviderName && value.Pension.State === PENSION_STATES.unauthorised
							},
							/* TODO: Not currently available in data
							{
								name: 'DoC submission due',
								key: FILTER_KEYS.companies.pension.docSubmissionDue,
								filterExp: value => value.Pension.IsAuthorised
							}
							*/
						]
					},
					{
						name: 'Setup',
						count: 0,
						filterAction: 'or',
						filterOptions: [
							{
								name: 'Live',
								key: FILTER_KEYS.companies.mode.live,
								filterExp: value => !value.Company.IsInTestMode
							},
							{
								name: 'Test',
								key: FILTER_KEYS.companies.mode.test,
								filterExp: value => value.Company.IsInTestMode
							}
						]
					},
					companiesModulesFilterObj,
					{
						name: 'BACS',
						count: 0,
						filterAction: 'or',
						filterOptions: [
							{
								name: 'On',
								key: FILTER_KEYS.companies.bacs.on,
								filterExp: value => value.Company.IsBACSEnabled
							},
							{
								name: 'Off',
								key: FILTER_KEYS.companies.bacs.off,
								filterExp: value => !value.Company.IsBACSEnabled
							}
						]
					},
					{
						name: 'Pay frequency',
						count: 0,
						filterOptions: [
							{
								name: 'Weekly',
								key: FILTER_KEYS.companies.payPeriods.weekly,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly
							},
							{
								name: 'Fortnightly',
								key: FILTER_KEYS.companies.payPeriods.fortnightly,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.fortnightly
							},
							{
								name: '4 weekly',
								key: FILTER_KEYS.companies.payPeriods.fourweekly,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.fourweekly
							},
							{
								name: 'Monthly',
								key: FILTER_KEYS.companies.payPeriods.monthly,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.monthly
							},
							{
								name: 'Quarterly',
								key: FILTER_KEYS.companies.payPeriods.quarterly,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.quarterly
							},
							{
								name: 'Biannually',
								key: FILTER_KEYS.companies.payPeriods.biannually,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.biannually
							},
							{
								name: 'Annually',
								key: FILTER_KEYS.companies.payPeriods.annually,
								filterExp: value => value.PayPeriod.PayPeriodType === PAY_PERIOD_TYPES.annually
							}
						]
					},
					{
						name: 'Workflow step',
						count: 0,
						filterOptions: [
							{
								name: 'Payroll information',
								key: FILTER_KEYS.companies.workflow.payrollInformation,
								filterExp: value => value.Company.WorkflowStage === 'Payroll information'
							},
							{
								name: 'Payroll calculation',
								key: FILTER_KEYS.companies.workflow.calculation,
								filterExp: value => value.Company.WorkflowStage === 'Payroll calculation'
							},
							{
								name: 'Payroll confirmation',
								key: FILTER_KEYS.companies.workflow.confirmation,
								filterExp: value => value.Company.WorkflowStage === 'Payroll confirmation'
							},
							{
								name: 'Run Payroll',
								key: FILTER_KEYS.companies.workflow.runPayroll,
								filterExp: value => value.Company.WorkflowStage === 'Run Payroll'
							}
						]
					},
					{
						name: 'Workflow status',
						count: 0,
						filterOptions: [
							{
								name: 'Overdue',
								key: FILTER_KEYS.companies.workflow.overdue,
								filterExp: value => value.Company.IsWorkflowEnabled && moment(value.Company.WorkflowDueDateISO).isBefore(moment())
							},
							{
								name: 'Due today',
								key: FILTER_KEYS.companies.workflow.dueToday,
								filterExp: value => value.Company.IsWorkflowEnabled && moment(value.Company.WorkflowDueDateISO).isSame(moment())
							},
							{
								name: 'Due in next 2 days',
								key: FILTER_KEYS.companies.workflow.dueInTwoDays,
								filterExp: value => value.Company.IsWorkflowEnabled && moment(value.Company.WorkflowDueDateISO).isAfter(moment()) && moment(value.Company.WorkflowDueDateISO).isBefore(moment().add(2, 'days'))
							},
							{
								name: 'Due in next 3 days',
								key: FILTER_KEYS.companies.workflow.dueInThreeDays,
								filterExp: value => value.Company.IsWorkflowEnabled && moment(value.Company.WorkflowDueDateISO).isAfter(moment()) && moment(value.Company.WorkflowDueDateISO).isBefore(moment().add(3, 'days'))
							}
							/*
							{
								name: 'Draft',
								key: FILTER_KEYS.companies.workflow.draft,
								filterExp: value => moment(value.Company.WorkflowDueDateISO).isAfter(moment().subtract(1, 'month'))
							}
							*/
						]
					}
				]
			};

			if (currentUserObj.canSeeAutoRun) {

				returnObj.filterGroups.splice(5, 0, {
					name: 'Auto run',
					count: 0,
					filterAction: 'or',
					filterOptions: [
						{
							name: 'On',
							key: FILTER_KEYS.companies.autoRun.on,
							filterExp: value => value.Company.IsAutoRun
						},
						{
							name: 'Off',
							key: FILTER_KEYS.companies.autoRun.off,
							filterExp: value => !value.Company.IsAutoRun
						}
					]
				});

			}

			return returnObj;
		},

		getFilterBarOptionsTeam: (companyObj, departmentsArr) => {

			const returnObj = {
				filterGroups: [
					{
						name: 'Status',
						filterOptions: [
							{
								name: 'Incomplete',
								key: FILTER_KEYS.team.status.incomplete,
								filterExp: value => !value.IsComplete
							},
							{
								name: 'Active on payroll',
								key: FILTER_KEYS.team.status.activeOnPayroll,
								filterExp: value => !value.IsInSetupMode && !value.IsLeaver
							},
							{
								name: 'Is advancing future periods',
								key: FILTER_KEYS.team.status.isAdvancingFuturePeriods,
								filterExp: value => value.IsAdvancingFuturePeriods
							},
							{
								name: 'Has advanced future periods',
								key: FILTER_KEYS.team.status.hasAdvancedFuturePeriods,
								filterExp: value => value.HasAdvancedFuturePeriods
							},
							{
								name: 'On hold',
								key: FILTER_KEYS.team.status.onHold,
								filterExp: value => value.IsOnHold
							},
							{
								name: 'Omitted from RTI',
								key: FILTER_KEYS.team.status.isExcludedFromRti,
								filterExp: value => value.IsExcludedFromRTI
							},
							{
								name: 'Furloughed',
								key: FILTER_KEYS.team.status.isFurloughed,
								filterExp: value => value.IsFurloughed
							},
							{
								name: 'Ready for payroll',
								key: FILTER_KEYS.team.status.readyForPayroll,
								filterExp: value => value.IsInSetupMode && value.IsComplete
							},
							{
								name: 'New starter',
								key: FILTER_KEYS.team.status.newStarter,
								filterExp: value => value.IsStarter
							},
							{
								name: 'Is a director',
								key: FILTER_KEYS.team.status.IsDirectorInTaxYear,
								filterExp: value => value.IsDirectorInTaxYear
							},
							{
								name: 'Is an apprentice',
								key: FILTER_KEYS.team.status.isApprentice,
								filterExp: value => value.IsApprentice
							},
							{
								name: 'CIS inactive',
								key: FILTER_KEYS.team.status.cisInactive,
								filterExp: value => value.IsCISInactive
							},
							{
								name: 'Is leaving',
								key: FILTER_KEYS.team.status.leaving,
								filterExp: value => value.IsLeaving
							},
							{
								name: 'Missing bank details',
								key: FILTER_KEYS.team.status.missingBankDetails,
								filterExp: value => !value.HasBankDetails
							},
							{
								name: 'Is rejoiner',
								key: FILTER_KEYS.team.status.rejoiner,
								filterExp: value => value.IsRestarter
							}
						]
					},
					/*
						Employment type filter will be added at some later date.
						See comments at https://www.notion.so/paycircle/Education-Sector-Team-Member-Pay-e14279f1c11545d8b5be81741cee932b
					 */
					// {
					// 	name: 'Employment type',
					// 	filterOptions: [
					// 		{
					// 			name: 'Standard work pattern',
					// 			key: FILTER_KEYS.team.employmentType.standard,
					// 			filterExp: value => value.EmploymentType === EMPLOYMENT_TYPES.standard
					// 		},
					// 		{
					// 			name: 'Non-standard work pattern',
					// 			key: FILTER_KEYS.team.employmentType.nonStandard,
					// 			filterExp: value => value.EmploymentType === EMPLOYMENT_TYPES.nonStandard
					// 		},
					// 		{
					// 			name: 'Hourly paid',
					// 			key: FILTER_KEYS.team.employmentType.netPay,
					// 			filterExp: value => value.EmploymentType === EMPLOYMENT_TYPES.netPay
					// 		},
					// 		{
					// 			name: 'Net pay',
					// 			key: FILTER_KEYS.team.employmentType.paidHourly,
					// 			filterExp: value => value.EmploymentType === EMPLOYMENT_TYPES.paidHourly
					// 		},
					// 		{
					// 			name: 'Pay policy',
					// 			key: FILTER_KEYS.team.employmentType.payPolicy,
					// 			filterExp: value => value.EmploymentType === EMPLOYMENT_TYPES.payPolicy
					// 		}
					// 	]
					// },
					{
						name: 'Account',
						filterOptions: [
							{
								name: 'Registered',
								key: FILTER_KEYS.team.account.registered,
								filterExp: value => value.IsRegistered
							},
							{
								name: 'Not registered',
								key: FILTER_KEYS.team.account.notRegistered,
								filterExp: value => !value.IsRegistered
							},
							{
								name: 'Admin',
								key: FILTER_KEYS.team.account.isAdmin,
								filterExp: value => value.IsAdmin
							}
						]
					}
				]
			};

			// CIS companies only
			if (companyObj !== undefined && companyObj.IsCISActive) {

				// Add status filter option
				returnObj.filterGroups[0].filterOptions.push({
					name: 'CIS',
					key: FILTER_KEYS.team.status.cis,
					filterExp: value => value.IsCISSubcontractor
				});

				// Add CIS filter group
				returnObj.filterGroups.push({
					name: 'Subcontractor type',
					filterOptions: [
						{
							name: 'Sole trader',
							key: FILTER_KEYS.team.cis.soleTrader,
							filterExp: value => value.IsCISSubcontractor && value.BusinessDetails.BusinessType === BUSINESS_TYPES.soletrader
						},
						{
							name: 'Partnership',
							key: FILTER_KEYS.team.cis.partnership,
							filterExp: value => value.IsCISSubcontractor && value.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership
						},
						{
							name: 'Limited company',
							key: FILTER_KEYS.team.cis.limited,
							filterExp: value => value.IsCISSubcontractor && value.BusinessDetails.BusinessType === BUSINESS_TYPES.company
						},
						{
							name: 'Trust',
							key: FILTER_KEYS.team.cis.trust,
							filterExp: value => value.IsCISSubcontractor && value.BusinessDetails.BusinessType === BUSINESS_TYPES.trust
						}
					]
				});
			}

			// Departments
			service.getDepartmentFilterGroup(returnObj, departmentsArr);

			return returnObj;
		},

		getFilterBarOptionsTeamHistory: function (companyObj) {

			var returnObj = {
				filterGroups: [
					{
						name: 'Status',
						filterOptions: [
							{
								name: 'Leavers',
								key: FILTER_KEYS.teamHistory.status.leavers,
								filterExp: value => value.LeaveDateISO
							}
						]
					}
				]
			};

			if (companyObj.IsBACSEnabled) {
				returnObj.filterGroups.push({
					name: 'Payment',
					filterAction: 'or',
					filterOptions: [
						{
							name: 'BACS',
							key: FILTER_KEYS.teamHistory.payment.bacs,
							filterExp: value => value.HasBankDetails
						},
						{
							name: 'Manual',
							key: FILTER_KEYS.teamHistory.payment.manual,
							filterExp: value => !value.HasBankDetails
						}
					]
				});
			}

			return returnObj;
		},

		getFilterBarOptionsTeamImports: function (companyObj) {

			var returnObj = {
				filterGroups: [
					{
						name: 'Import type',
						filterOptions: [
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.team),
								key: FILTER_KEYS.teamImports.importType.changes,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.team
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElements),
								key: FILTER_KEYS.teamImports.importType.payElements,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.payElements
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.salaryUpdates),
								key: FILTER_KEYS.teamImports.importType.salaryUpdates,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.salaryUpdates
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.leavers),
								key: FILTER_KEYS.teamImports.importType.leavers,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.leavers
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.cis),
								key: FILTER_KEYS.teamImports.importType.cis,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.cis
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.profile),
								key: FILTER_KEYS.teamImports.importType.profile,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.profile
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.fps),
								key: FILTER_KEYS.teamImports.importType.fps,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.fps
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.address),
								key: FILTER_KEYS.teamImports.importType.address,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.address
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.ytd),
								key: FILTER_KEYS.teamImports.importType.ytd,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.ytd
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.company),
								key: FILTER_KEYS.teamImports.importType.company,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.company
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.bank),
								key: FILTER_KEYS.teamImports.importType.bank,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.bank
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.tax),
								key: FILTER_KEYS.teamImports.importType.tax,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.tax
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.salary),
								key: FILTER_KEYS.teamImports.importType.salary,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.salary
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.pension),
								key: FILTER_KEYS.teamImports.importType.pension,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.pension
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.expatDetails),
								key: FILTER_KEYS.teamImports.importType.expats,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.expatDetails
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.sickness),
								key: FILTER_KEYS.teamImports.importType.sickness,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.sickness
							},
							{
								name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.postsPayPolicies),
								key: FILTER_KEYS.teamImports.importType.postsPayPolicies,
								filterExp: value => value.ImportType === IMPORT_MAPPING_TYPES.postsPayPolicies
							}
						]
					}
				]
			};

			// Agencies only
			if (companyObj.CompanyType === INTERFACE_TYPES.agency) {
				returnObj.filterGroups[0].filterOptions.push({
					name: 'Timesheets',
					key: FILTER_KEYS.teamImports.importType.timesheets,
					filterExp: value => value.ImportType === 1
				});
			}

			return returnObj;
		},

		getFilterKeysByPresetFilterKey: function (presetFilterKey) {

			switch (presetFilterKey) {

				// Live payrolls due this week
				case PRESET_FILTER_KEYS.company.livePayrollsDueThisWeek:
					return [FILTER_KEYS.companies.mode.live, FILTER_KEYS.companies.payroll.dueSoon];

				// Live payrolls that are overdue
				case PRESET_FILTER_KEYS.company.livePayrollsOverdue:
					return [FILTER_KEYS.companies.mode.live, FILTER_KEYS.companies.payroll.overdue];

				// Live payrolls that have failed
				case PRESET_FILTER_KEYS.company.livePayrollsFailed:
					return [FILTER_KEYS.companies.mode.live, FILTER_KEYS.companies.payroll.failed];

				// Live payrolls with failed pension submissions
				case PRESET_FILTER_KEYS.company.livePensionSubmissionsFailed:
					return [FILTER_KEYS.companies.mode.live, FILTER_KEYS.companies.pension.submissionFailed];

				case PRESET_FILTER_KEYS.team.incompleteProfiles:
					return [FILTER_KEYS.team.status.incomplete];

				case PRESET_FILTER_KEYS.team.missingBankDetails:
					return [FILTER_KEYS.team.status.missingBankDetails];

				case PRESET_FILTER_KEYS.team.markedAsLeaving:
					return [FILTER_KEYS.team.status.leaver];

				case PRESET_FILTER_KEYS.team.newStarters:
					return [FILTER_KEYS.team.status.newStarter];

				case PRESET_FILTER_KEYS.team.markedAsOnHold:
					return [FILTER_KEYS.team.status.onHold];

				case PRESET_FILTER_KEYS.team.isExcludedFromRti:
					return [FILTER_KEYS.team.status.isExcludedFromRti];

				default:
					return null;
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('holidaySicknessService', ['config', 'utilities', 'LEAVE_TYPE_DESCRIPTIONS', function (config, utilities, LEAVE_TYPE_DESCRIPTIONS) {

	const halfDayLength =  0.5;

	const service = {

		addHalfDayFrom: leaveItemObj => {

			if (leaveItemObj.halfDayFrom) {
				leaveItemObj.leaveDays -= halfDayLength;
			} else {
				leaveItemObj.leaveDays += halfDayLength;
			}
		},

		addHalfDayTo: leaveItemObj => {

			if (leaveItemObj.halfDayTo) {
				leaveItemObj.leaveDays -= halfDayLength;
			} else {
				leaveItemObj.leaveDays += halfDayLength;
			}
		},

		calculateLeaveLength (leaveObj) {

			let leaveStartDate = utilities.offsetDateForDST(leaveObj.startDateIso);
			let leaveEndDate = utilities.offsetDateForDST(leaveObj.endDateIso);
			let leaveDays = Math.abs(moment(leaveStartDate).diff(moment(leaveEndDate), 'days'))+1;

			leaveDays = service.checkForHalfDayLeave(leaveObj, leaveDays);

			angular.extend(leaveObj, {leaveStartDate, leaveEndDate, leaveDays});
		},

		checkForHalfDayLeave: (leaveObj, leaveLength) => {

			service.checkForZeroDayLeave(leaveLength, leaveObj);

			if (leaveObj.halfDayFrom) {
				leaveLength -= halfDayLength;
			}

			if (leaveObj.halfDayTo) {
				leaveLength -= halfDayLength;
			}

			return leaveLength;
		},

		checkForZeroDayLeave: (leaveLength, leaveObj) => {
			if (leaveLength === 1 && (leaveObj.halfDayFrom || leaveObj.halfDayTo)) {
				leaveObj.halfDayFrom = false;
				leaveObj.halfDayTo = false;
			}
		},

		decorateHolidayDetails (holidayObj) {

			if (angular.isArray(holidayObj.Holidays)) {
				if (holidayObj.Holidays.length > 0) {
					holidayObj.Holidays = holidayObj.Holidays[0];

				} else {
					return angular.merge(holidayObj, {
						daysTaken: 0,
						daysTakenPercent: 0,
						Holidays: {
							TotalHoliday: 0
						}
					});
				}
			}

			holidayObj.taken = [];
			holidayObj.upcoming = [];

			const hasHolidayYear = holidayObj.HolidayYearFromISO && holidayObj.HolidayYearToISO;

			let daysOfHolidayTaken = holidayObj.Holidays.HolidayDetails.reduce((daysTaken, holidayDetailObj) => {

				if (moment(holidayDetailObj.HolidayDateToISO).isBefore(moment())) {

			holidayDetailObj.isTaken = true;

			// Only leave starting in the current holiday year counts towards days taken
			if (hasHolidayYear && !moment(holidayDetailObj.HolidayDateFromISO).isBetween(holidayObj.HolidayYearFromISO, holidayObj.HolidayYearToISO, 'day', '[]')) {
				return daysTaken;
			}

			holidayObj.taken.push(holidayDetailObj);
			return daysTaken += holidayDetailObj.HolidayDays;
				} else {
					holidayObj.upcoming.push(holidayDetailObj);
					return daysTaken;
				}
			}, 0);

			holidayObj.daysTaken = daysOfHolidayTaken;
			holidayObj.daysTakenPercent = Math.round((daysOfHolidayTaken/holidayObj.Holidays.TotalHoliday)*100);

			return holidayObj;
		},

		decorateSicknessDetails: sicknessObj => {

			if (sicknessObj.Sickness.length > 0) {
				sicknessObj.Sickness = sicknessObj.Sickness[0];

			} else {
				return sicknessObj;
			}

			sicknessObj.all = sicknessObj.Sickness.SicknessDetails.reduce((returnArr, sicknessDetailObj) => {
				
				sicknessDetailObj.isTaken = moment(sicknessDetailObj.SicknessDateToISO).isBefore(moment());
				
				if (sicknessDetailObj.SicknessPolicyYearID !== config.guidEmpty) {
					return returnArr.concat(sicknessDetailObj);
				}
			}, []);

			return sicknessObj;
		},

		decorateNewHolidayDetail: (emptyLeaveObj, leaveObj) => {
			return angular.extend(emptyLeaveObj, {
				HolidayDateFromHalfDay: leaveObj.halfDayFrom,
				HolidayDateFromISO: leaveObj.leaveStartDate,
				HolidayDateToHalfDay: leaveObj.halfDayTo,
				HolidayDateToISO: leaveObj.leaveEndDate,
				HolidayDays: leaveObj.leaveDays,
				HolidayType: leaveObj.selectedLeaveType.id,
			});
		},

		decorateNewSicknessDetail: (emptyLeaveObj, leaveObj) => {
			return angular.extend(emptyLeaveObj, {
				SicknessDateFromISO: leaveObj.leaveStartDate,
				SicknessDateToISO: leaveObj.leaveEndDate,
				SicknessDays: leaveObj.leaveDays,
				SicknessType: LEAVE_TYPE_DESCRIPTIONS.sickLeave,
				SicknessDateFromHalfDay: leaveObj.halfDayFrom,
				SicknessDateToHalfDay: leaveObj.halfDayTo,
			});
		},

		getEmptyLeave: () => {
			return {
				endDateIso: null,
				halfDayFrom: false,
				halfDayTo: false,
				leaveDays: 1,
				selectedLeaveType: null,
				startDateIso: null,
			};
		}
	};

	return service;
}]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.authInterceptor
 * @description
 * # authInterceptor
 * Factory in the paycircleApp.
 */
angular.module('paycircleApp')
.factory('httpInterceptor', ['$q', '$rootScope', 'config', 'utilities', 'HTTP_EVENTS', function ($q, $rootScope, config, utilities, HTTP_EVENTS) {
	return {
		request: function (config) {

			if (!config.timeout) {
				config.cancel  = $q.defer();
				config.timeout = config.cancel.promise;
			}

			return config;
		},
		response: function (response) {

			// Return the response or promise.
			return response || $q.when(response);
		},
		responseError: function (response) {

			$rootScope.$broadcast({
				0: HTTP_EVENTS.unreachable,
				400: HTTP_EVENTS.badRequest,
				401: HTTP_EVENTS.notAuthenticated,
				403: HTTP_EVENTS.notAuthorised,
				404: HTTP_EVENTS.notFound,
				419: HTTP_EVENTS.sessionTimeout,
				440: HTTP_EVENTS.sessionTimeout
			}[response.status], response);

			return $q.reject(response);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.service('importService', [
	'$filter',
	'$q',
	'$rootScope',
	'$state',
	'base',
	'config',
	'utilities',
	'DOCUMENT_STATES',
	'DOCUMENT_TYPE_IDS',
	'DOCUMENT_TYPES',
	'FEATURE_FLAGS',
	'FILE_TYPES',
	'IMPORT_CONTEXT_TYPES',
	'IMPORT_MAPPING_COLUMN_TYPES',
	'IMPORT_MAPPING_TYPES',
	'IMPORT_RATE_TYPES',
	'INTERFACE_TYPES',
	'MIME_FORMATS',
	'PAY_ELEMENTS',
	'SUBMISSION_STATES',
	'VALIDATION_IGNORE_FIELDS',
	'VALIDATION_TYPE_LEVELS',
	'VALIDATION_TYPES',
	function (
		$filter,
		$q,
		$rootScope,
		$state,
		base,
		config,
		utilities,
		DOCUMENT_STATES,
		DOCUMENT_TYPE_IDS,
		DOCUMENT_TYPES,
		FEATURE_FLAGS,
		FILE_TYPES,
		IMPORT_CONTEXT_TYPES,
		IMPORT_MAPPING_COLUMN_TYPES,
		IMPORT_MAPPING_TYPES,
		IMPORT_RATE_TYPES,
		INTERFACE_TYPES,
		MIME_FORMATS,
		PAY_ELEMENTS,
		SUBMISSION_STATES,
		VALIDATION_IGNORE_FIELDS,
		VALIDATION_TYPE_LEVELS,
		VALIDATION_TYPES
	) {

	// Ordered to favor en-gb date formats
	const DATA_IMPORTER_ALLOWED_DATE_FORMATS = [
		'DD/MM/YYYY', // 13/09/2022
		'DD-MMM-Y', // 13-SEP-{ANY}
		'DD-MM-YYYY', // 13-09-2022
		'DD.MM.YYYY', // 13.09.2022
		'DD.MMM.Y', // 13.SEP.{ANY}
		'YYYY-MM-DD', // 2022-09-13
		'YYYY-MM-DDTHH:mm:ss', // 2022-09-13T10:34:56
		'YYYY.MM.DD', // 2022.09.13
		'YYYY.MM.DDTHH:mm:ss', // 2022.09.13T10:34:56
		'M/D/YY', // 9/13/22
		'M/D/YYYY', // 9/13/2022
		'MM/DD/YYYY' // 09/13/2022
	];

	const IMPORT_MAPPING_TYPE_FEATURE_FLAGS = {};
	IMPORT_MAPPING_TYPE_FEATURE_FLAGS[IMPORT_MAPPING_TYPES.calculatedPayHistoryImport] = FEATURE_FLAGS.AVERAGE_HOLIDAY_PAY;

	function getImportMappingTypeFeatureFlag (importMappingType) {

		return IMPORT_MAPPING_TYPE_FEATURE_FLAGS[importMappingType];
	}

	function filterValidationResults (workerObj, propertyNames) {

		function decorateValidationResultsWithWorkerObj (validationResult) {

			var cleansedWorkerObj = angular.copy(workerObj);
			var validationTypeText = validationResult.ValidationType.ValidationTypeText;

			// Delete validation results
			delete cleansedWorkerObj.ValidationResults;

			// Attach original worker object onto ValidationResult object
			validationResult.worker = cleansedWorkerObj;

			// Split validation copy
			if (validationTypeText.indexOf('|') > -1) {

				var validationTextArray = validationTypeText.split('|');

				validationResult.ValidationType.validationTitle 		= validationTextArray[0];
				validationResult.ValidationType.validationDescription 	= validationTextArray[1];
				validationResult.ValidationType.ValidationTypeID 		= validationResult.ValidationType.ValidationTypeID.toUpperCase();
			}
			else {
				validationResult.ValidationType.validationTitle = validationTypeText;
			}

			validationResult.validationPropertyKey = propertyNames[validationResult.ValidationResultColNumber];

			return validationResult;
		}

		workerObj.ValidationResults.filter(decorateValidationResultsWithWorkerObj);

		return workerObj.ValidationResults;
	}

	const service = {
		areRowCellsValid: rowObj => {

			const numberOfCells = rowObj.cells.length;

			let i = 0;

			for (i; i < numberOfCells; i++) {

				const cellObj = rowObj.cells[i];

				if (!cellObj.isValid) {
					return false;
				}
			}

			return true;
		},

		checkForColumnCountMismatch: fileDataObj => {

			const numberOfFileColumns = fileDataObj.Columns.length;

			// If there are more header columns than the row data then add in empty cells until all rows are the same length
			for (let fileRowObj of fileDataObj.Rows) {
				while (fileRowObj.Values.length < numberOfFileColumns) {
					fileRowObj.Values.push('');
				}
			}
		},

		/* jshint ignore:start */
		csvToArray: (text) => {

			var reValid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
			var reValue = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
			// Return NULL if input string is not well formed CSV string.
			if (!reValid.test(text)) { return null; }
			var a = [];                     // Initialize array to receive values.
			text.replace(reValue, // "Walk" the string using replace with callback.
				function (m0, m1, m2, m3) {
					// Remove backslash from \' in single quoted values.
					if (m1 !== undefined) {
						a.push(m1.replace(/\\'/g, "'"));
					}
					// Remove backslash from \" in double quoted values.
					else if (m2 !== undefined) {
						a.push(m2.replace(/\\"/g, '"'));
					}
					else if (m3 !== undefined) {
						a.push(m3);
					}
					return ''; // Return empty string.
				});
			// Handle special case of empty last value.
			if (/,\s*$/.test(text)) {
				a.push('');
			}
			return a;
		},
		/* jshint ignore:end */

		decorateDocumentUploads: (agencyDocumentType, showDocumentStateIcon) => {

			function getThemeForDocumentState (documentState) {

				switch (documentState) {
					case DOCUMENT_STATES.unchecked:
						return 'is-tertiary';
					case DOCUMENT_STATES.checked:
						return 'is-primary';
				}
			}

			return (documentObj) => {

				// Trim MIME format to add back on save
				const documentName = documentObj.DocumentName;
				const trimmedDocumentName = documentName.split('.').slice(0, -1).join('.');

				angular.extend(documentObj, {
					createdDateISOUnix: moment(documentObj.CreatedDateISO).format('x'),
					DocumentName: trimmedDocumentName ? trimmedDocumentName : documentName,
					documentNameOriginal: documentName,
					fileExtensionOriginal: trimmedDocumentName ? '.'+utilities.getMimeFormatFromDocumentName(documentName).toLowerCase() : '',
					icon: service.getIconForMimeFormat(documentObj.MIMEFormat, documentObj.DocumentState, showDocumentStateIcon),
					mappingType: service.getMappingTypeForDocumentState(documentObj.DocumentState, agencyDocumentType),
					theme: getThemeForDocumentState(documentObj.DocumentState)
				});

				return documentObj;
			};
		},

		decorateFileColumnObj: (fileColumnObj, fileColumnIndex, importMappingType) => {

			angular.extend(fileColumnObj, {
				adjustmentType: null,
				cellCountNotEmpty: -1,
				isInUse: false,
				isLinked: false, // Is this file column part of a group,
				isPayElementNetable: service.getIsMappingColumnNetable(fileColumnObj),
				isPayElementRateTypeEditable: service.getIsMappingColumnRateTypeEditable(importMappingType, fileColumnObj),
				mappingColumnGroupId: null,
				mappingHeader: null,
				originalIndex: fileColumnIndex,
				state: null
			});
		},

		decorateFileDataObj: (fileDataObj, importMappingType, importMappingDataString) => {

			// Attach empty row columns to rows if there are more header columns than row columns
			service.checkForColumnCountMismatch(fileDataObj);

			fileDataObj.Columns.forEach((fileRowObj, rowIndex) => {
				service.decorateFileColumnObj(fileRowObj, rowIndex, importMappingType);
			});
			fileDataObj.Rows.forEach((fileRowObj, rowIndex) => {
				service.decorateFileRowObj(fileRowObj, rowIndex, importMappingType);
			});
			fileDataObj.columnsFiltered = [];
			fileDataObj.rowsFiltered = [];

			// Attach mapping data if it exists
			if (importMappingDataString) {
				fileDataObj.ImportMappingData = service.getImportMappingDataArrayFromString(importMappingDataString);
			}

			return fileDataObj;
		},

		decorateFileRowObj: (fileRowObj, rowIndex, importMappingType) => {

			/**
			 * Rows are automatically ignored if the team member isn't valid, but applicable
			**/
			function getIgnoreValue (fileRowObj, isTeamMemberValid) {

				// Not applicable to validation mapping types
				if (!service.isTeamMemberApplicableForMapping(importMappingType)) {
					return fileRowObj.Ignore;
				}

				// Team member is not valid, so Ignore the row
				if (!isTeamMemberValid) {
					return true;
				}

				if (importMappingType === IMPORT_MAPPING_TYPES.payElementsRecurring || 
				   importMappingType === IMPORT_MAPPING_TYPES.payElementsFixedRecurring)
				{
					return fileRowObj.Ignore;
				}

				return false;
			}

			/**
			 * If the rows TeamMember property is null, then that team member record cannot be matched
			 * This implies they've been deleted since the file was imported
			**/
			function isTeamMemberValidForRow (fileRowObj) {

				// Not applicable to validation mapping types
				if (!service.isTeamMemberApplicableForMapping(importMappingType)) {
					return true;
				}

				// If no team member defined, they've been deleted since uploading
				if (!fileRowObj.TeamMember) {
					return false;
				}

				// If no forename & surname, presume deleted too
				if (fileRowObj.TeamMember.Forename === '' && fileRowObj.TeamMember.Surname === '') {
					return false;
				}

				return true;
			}

			/**
			 * If the rows TeamMember property is applicable, but null, then that team member record cannot be matched so is disabled
			**/
			function isTeamMemberDisabledForRow (fileRowObj) {

				// Not applicable to validation mapping
				if (!service.isTeamMemberApplicableForMapping(importMappingType)) {
					return false;
				}

				// If no team member defined, they've been deleted since uploading
				if (!fileRowObj.TeamMember) {
					return true;
				}

				return false;
			}

			// Check if team member is valid (otherwise they've been deleted since validating the imported file)
			const isTeamMemberDisabled = isTeamMemberDisabledForRow(fileRowObj);
			const isTeamMemberValid = isTeamMemberValidForRow(fileRowObj);

			angular.extend(fileRowObj, {
				Ignore: getIgnoreValue(fileRowObj, isTeamMemberValid),
				adjustmentLabel: '',
				adjustmentType: null,
				cells: [],
				originalIndex: rowIndex,
				isDisabled: isTeamMemberDisabled,
				isInvalid: false,
				isTeamMemberValid
			});

			// Create new 'cells' array of objects for validation (TODO: Move to platform?)
			fileRowObj.Values.forEach((value, index) => {

				fileRowObj.cells.push({
					isEditing: false,
					isHidden: false,
					isIgnored: false,
					isValid: true,
					originalIndex: index,
					value: value
				});
			});
		},

		decorateImportGroup: importGroupObj => {

			importGroupObj.importedDateUnix = $filter('isoUnix')(importGroupObj.ImportedDateISO);

			return importGroupObj;
		},

		getDocumentTypeIdForAgencyDocumentType: agencyDocumentType => {

			switch (agencyDocumentType) {
				case DOCUMENT_TYPES.businessCategories:
				case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
				case DOCUMENT_TYPES.nominalCodes:
					return DOCUMENT_TYPE_IDS.fixedDataImport;
				case DOCUMENT_TYPES.payslipManagerFullRun:
				case DOCUMENT_TYPES.payslipManagerSupplementaryRun:
					return DOCUMENT_TYPE_IDS.payslipManagerFullRun;
				case DOCUMENT_TYPES.bureauMappingTemplate:
					return DOCUMENT_TYPE_IDS.bureauMappingTemplate;
				case DOCUMENT_TYPES.periodImport:
					return DOCUMENT_TYPE_IDS.adjustmentImport;
				case DOCUMENT_TYPES.teamImport:
				case DOCUMENT_TYPES.xeroNominalCodes:
				case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
					return DOCUMENT_TYPE_IDS.teamImport;
				case DOCUMENT_TYPES.policyImport:
					return DOCUMENT_TYPE_IDS.payrollCompanyImport;
			}

			$rootScope.paycircleMessage('importService:getDocumentTypeIdForAgencyDocumentType: No document type defined', 'error');
			return;
		},

		getFileTypeAcceptForDocumentType: agencyDocumentType => {

			switch (agencyDocumentType) {
				case DOCUMENT_TYPES.payslipManagerFullRun:
				case DOCUMENT_TYPES.payslipManagerSupplementaryRun:
					return {
						fileExtension: '.xml',
						key: FILE_TYPES.xml
					};

				default:
					return {
						fileExtension: '.csv',
						key: FILE_TYPES.csv
					};
			}
		},

		getFirstFilterWithResults: validationResultFiltersArr => {

			const numberOfValidationResultFilters = validationResultFiltersArr.length;

			let i = 0;

			for (i; i < numberOfValidationResultFilters; i++) {

				if (validationResultFiltersArr[i].total > 0) {
					return validationResultFiltersArr[i];
				}
			}

			// Default to first filter
			return validationResultFiltersArr[0];
		},

		getLeavers: (fileDataObj, importContext, importMappingType) => {

			let leaversArr = [];

			// Not applicable to validation phase
			if (service.getIsValidationMappingType(importMappingType)) {
				return leaversArr;
			}

			// Only applies to employee specific import types
			if (importContext !== IMPORT_CONTEXT_TYPES.employeeData) {
				return leaversArr;
			}

			// Only applies to pay element imports
			if (!service.getIsAdjustmentImportMappingType(importMappingType)) {
				return leaversArr;
			}

			fileDataObj.Rows.forEach(rowObj => {

				// In case team member has been deleted
				if (!rowObj.TeamMember) {
					return;
				}

				if (rowObj.TeamMember.IsLeaver) {
					leaversArr.push(`${rowObj.TeamMember.Forename} ${rowObj.TeamMember.Surname}`);
				}
			});

			return [...new Set(leaversArr)];
		},

		getHiddenColumnsArr: fileDataObj => {

			let returnArr = [];

			fileDataObj.Columns.forEach((columnObj) => {
				if (columnObj.ImportMappingColumnHidden) {
					returnArr.push(columnObj.ImportMappingColumnNumber);
				}
			});

			return returnArr;
		},

		getIconForMimeFormat: (mimeFormat, documentState, showDocumentStateIcon) => {

			switch (mimeFormat.toUpperCase()) {
				case MIME_FORMATS.csv:

					if (showDocumentStateIcon && documentState === DOCUMENT_STATES.checked) {
						return 'icon-tick';

					} else {
						return 'icon-csv';
					}

					break;

				case MIME_FORMATS.xls:
				case MIME_FORMATS.xlsx:
					return 'icon-excel';

				case MIME_FORMATS.pdf:
					return 'icon-document-1';

				default:
					return 'icon-document';
			}
		},

		getImportBackHrefForAgencyDocumentType: (agencyDocumentType, agencyProfileId, backState) => {

			if (angular.isDefined(backState)) {
				return $state.href(backState, {agencyProfileId: agencyProfileId});
			}

			switch (agencyDocumentType) {
				case DOCUMENT_TYPES.businessCategories:
				case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
					return $state.href('settings.company.business-categories.category', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.nominalCodes:
				case DOCUMENT_TYPES.xeroNominalCodes:
				case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
					return $state.href('settings.company.journals.nominal-codes', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.payslipManagerFullRun:
				case DOCUMENT_TYPES.payslipManagerSupplementaryRun:
					return $state.href('payslip-manager', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.bureauMappingTemplate:
					return $state.href('settings.bureau.imports.mappings', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.periodImport:
					return $state.href('payroll.current-period.team', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.teamImport:
					return $state.href('team.members', {agencyProfileId: agencyProfileId});
				case DOCUMENT_TYPES.policyImport:
					return $state.href('hr.policies.pay', {agencyProfileId: agencyProfileId});
				default:
					return $state.href('company-dashboard', {agencyProfileId: agencyProfileId});
			}
		},

		getImportContextForImportMappingType: importMappingType => {

			switch (importMappingType) {

				// Company Data
				case IMPORT_MAPPING_TYPES.businessCategories:
				case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
				case IMPORT_MAPPING_TYPES.nominalCodes:
				case IMPORT_MAPPING_TYPES.xeroNominalCodes:
				case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:
				case IMPORT_MAPPING_TYPES.policyImport:
					return IMPORT_CONTEXT_TYPES.companyData;

				// Employee data
				default:
					return IMPORT_CONTEXT_TYPES.employeeData;

			}
		},

		getImportMappingDataArrayFromString: importMappingDataString => {

			const serialisedDataArr = JSON.parse(decodeURIComponent(importMappingDataString));

			// Convert each property in array to a string
			for (let index = 0; index < serialisedDataArr.length; index++) {
				serialisedDataArr[index] = serialisedDataArr[index].toString();
			}

			return serialisedDataArr;
		},

		getHasImportSummaryToDisplay: importSummaryObj => {

			if (importSummaryObj.Created > 0) {
				return true;
			}

			if (importSummaryObj.Creations.length > 0 && importSummaryObj.Creations.some(createdObj => createdObj.Created > 0)){
				return true;
			}

			if (importSummaryObj.Skips.length > 0 && importSummaryObj.Skips.some(skippedObj => skippedObj.Skipped > 0)){
				return true;
			}

			if (importSummaryObj.Updates.length > 0 && importSummaryObj.Updates.some(updateObj => updateObj.Updated > 0)){
				return true;
			}

			if (importSummaryObj.Warnings.length > 0) {
				return true;
			}

			return false;
		},

		getImportMappingOptionsForPeriodImport: (isVertical, isCisActive) => {

			let periodImportTypes;

			// Vertical
			if (isVertical) {

				periodImportTypes = [
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixed),
						id: IMPORT_MAPPING_TYPES.payElementsFixed,
						description: 'Import fixed amount changes to the current pay period',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical),
						id: IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical,
						description: 'Import hourly/daily units using rates saved for team members',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsHourlyRate),
						id: IMPORT_MAPPING_TYPES.payElementsHourlyRate,
						description: 'Import both rates and units from your file',
						icon: 'fixed-value'
					},
					/* TODO: Not being included in initial release but will be coming later
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal,
						description: 'Import daily units using the daily rates saved in team member profiles',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal,
						description: 'Import both daily rates and units from your file',
						icon: 'fixed-value'
					},
					*/
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixedRecurring),
						id: IMPORT_MAPPING_TYPES.payElementsFixedRecurring,
						description: 'Import changes that you wish to recur every pay period',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.linkedElements),
						id: IMPORT_MAPPING_TYPES.linkedElements,
						description: 'Auto-match link element headers and import units',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayroll),
						id: IMPORT_MAPPING_TYPES.payElementsOffPayroll,
						description: 'Import deemed payments for off-payroll workers',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring),
						id: IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring,
						description: 'Import recurring deemed payments for off-payroll workers',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payslipNotes),
						id: IMPORT_MAPPING_TYPES.payslipNotes,
						description: 'Import payslip notes for the current pay period',
						icon: 'chat'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.shifts),
						id: IMPORT_MAPPING_TYPES.shifts,
						description: 'Import shift data for the current pay period',
						icon: 'fixed-value'
					}
				];

				if (isCisActive) {
					periodImportTypes.push({
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixedCIS),
						id: IMPORT_MAPPING_TYPES.payElementsFixedCIS,
						description: 'Import fixed value or unit based CIS changes for the current pay period',
						icon: 'cis'
					});
				}
			}

			// Horizontal
			else {

				periodImportTypes = [
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElements),
						id: IMPORT_MAPPING_TYPES.payElements,
						description: 'Import fixed value or unit based changes for the current pay period',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal,
						description: 'Import hourly/daily units using rates saved for team members',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsRecurring),
						id: IMPORT_MAPPING_TYPES.payElementsRecurring,
						description: 'Import changes that you wish to recur every pay period',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal,
						description: 'Import deemed payments for off-payroll workers',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal,
						description: 'Import recurring deemed payments for off-payroll workers',
						icon: 'fixed-value'
					},
					{
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.linkRateUnits),
						id: IMPORT_MAPPING_TYPES.linkRateUnits,
						description: 'Auto-match link element headers and import units',
						icon: 'fixed-value'
					}
				];

				if (isCisActive) {
					periodImportTypes.push({
						name: $filter('importMappingTypeDescription')(IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal),
						id: IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal,
						description: 'Import fixed value or unit based CIS changes for the current pay period',
						icon: 'cis'
					});
				}
			}

			return periodImportTypes;
		},

		getImportMappingOptionsForTeamImport: (isCisActive, isExpatsActive, isPensionActive, isImportSicknessEnabled, hasHRModule, hasPayPolicies) => {
			let teamImportTypes = [
				{
					name: 'Personal information',
					id: IMPORT_MAPPING_TYPES.profile,
					description: 'Name, DOB, gender and email address',
					icon: 'setup-user',
				},
				{
					name: 'Address details',
					id: IMPORT_MAPPING_TYPES.address,
					description: 'House name/number, street, city, county/state and country',
					icon: 'team-alt'
				},
				{
					name: 'Company details',
					id: IMPORT_MAPPING_TYPES.company,
					description: 'Job title, department, start date and payroll ID',
					icon: 'company'
				},
				{
					name: 'Pay information',
					id: IMPORT_MAPPING_TYPES.salary,
					description: 'Type of employment, work pattern and salary details',
					icon: 'wallet'
				},
				{
					name: 'Tax details',
					id: IMPORT_MAPPING_TYPES.tax,
					description: 'New starter info, Tax code, NI category and student loan details',
					icon: 'tax-code-change'
				},
				{
					name: 'Year to dates',
					id: IMPORT_MAPPING_TYPES.ytd,
					description: `Pay and tax payments that have been made in the current tax year`,
					icon: 'calendar'
				},
				{
					name: 'Calculated pay history',
					id: IMPORT_MAPPING_TYPES.calculatedPayHistoryImport,
					description: 'Historic pay and work information used for average pay calculations',
					icon: 'history',
					availableWhenPayrollCalculated: false,
					unavailableDescription: 'Historic pay data cannot be imported while payroll is calculated'
				},
				{
					name: 'Bank details',
					id: IMPORT_MAPPING_TYPES.bank,
					description: 'Bank or building society account number and sort code',
					icon: 'bank'
				}
			];

			if (isPensionActive) {
				teamImportTypes.push({
					name: 'Pension details',
					id: IMPORT_MAPPING_TYPES.pension,
					description: 'Pension provider, group and contribution levels',
					icon: 'money'
				});
			}

			if (isImportSicknessEnabled) {
				teamImportTypes.push({
					name: 'Sick pay schedules',
					id: IMPORT_MAPPING_TYPES.sickness,
					description: 'Import sick pay schedules for team members',
					icon: 'sick'
				});
			}

			if (isCisActive) {
				teamImportTypes.push({
					name: 'CIS information',
					id: IMPORT_MAPPING_TYPES.cis,
					description: 'UTR, trading name, VAT registration number, verification number',
					icon: 'money'
				});
			}

			if (isExpatsActive) {
				teamImportTypes.push({
					name: 'Expat details',
					id: IMPORT_MAPPING_TYPES.expatDetails,
					description: 'Expat status and new starter info for secondments',
					icon: 'international'
				});
			}

			// Only show the Posts & pay policies card when the HR module is active and the
			// company has at least one pay policy to assign team members to.
			if (hasHRModule && hasPayPolicies) {
				teamImportTypes.push({
					name: 'Posts & pay policies',
					id: IMPORT_MAPPING_TYPES.postsPayPolicies,
					description: 'Post details, pay policies, pay points and contracted hours',
					icon: 'company'
				});
			}

			return teamImportTypes;
		},

		getImportMappingTypeForAgencyDocumentType: agencyDocumentType => {

			switch (agencyDocumentType) {
				case DOCUMENT_TYPES.periodImport:
					return IMPORT_MAPPING_TYPES.payElements;
				case DOCUMENT_TYPES.genericUpload:
				case DOCUMENT_TYPES.teamImport:
					return IMPORT_MAPPING_TYPES.team;
			}

			$rootScope.paycircleMessage('importService:getImportMappingTypeForAgencyDocumentType: No document type defined', 'error');
			return;
		},

		/**
		 * Is the mapping type used to import pay period adjustments
		**/
		getIsAdjustmentImportMappingType: (importMappingType) => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.linkedElements:
				case IMPORT_MAPPING_TYPES.linkRateUnits:
				case IMPORT_MAPPING_TYPES.payElements:
				case IMPORT_MAPPING_TYPES.payElementsDailyRate:
				case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsFixed:
				case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsRecurring:
				case IMPORT_MAPPING_TYPES.shifts:
					return true;
			}

			return false;
		},

		getIsCellDateValueValid: dateStr => {

			// Value can be empty
			if (dateStr === '') {
				return true;
			}

			return moment(dateStr, DATA_IMPORTER_ALLOWED_DATE_FORMATS, true).isValid();
		},

		getIsCellTotalHoursValid: (hoursStr, maxHours) => {

			// Value can be empty
			if (hoursStr === '') {
				return true;
			}

			const hours = parseFloat(hoursStr);

			if (isNaN(hours)) {
				return false;
			}

			return hours <= maxHours;
		},

		getIsCellWorkPatternEffectiveDateValid: (dateStr, periodStartDateISO, periodEndDateISO) => {

			// Value can be empty
			if (dateStr === '') {
				return true;
			}

			const effectiveDate = moment(dateStr, DATA_IMPORTER_ALLOWED_DATE_FORMATS, true);
			
			// Invalid date format
			if (!effectiveDate.isValid()) {
				return false;
			}

			// Effective date must be within the current pay period (on or after start, on or before end)
			return effectiveDate.isSameOrAfter(moment(periodStartDateISO, true), 'day') &&
				effectiveDate.isSameOrBefore(moment(periodEndDateISO, true), 'day');
		},

		filterImportMappingTypesByFeature: (agencyProfileId, importMappingTypes) => {

			const featureEnabledPromises = importMappingTypes.map(importMappingType => service.getIsImportMappingTypeFeatureEnabled(agencyProfileId, importMappingType.id));

			return $q.all(featureEnabledPromises).then(featureEnabledStates => {
				return importMappingTypes.filter((importMappingType, index) => importMappingType && featureEnabledStates[index]);
			});
		},

		getIsCellWorkPatternValid: (workPatternStr) => {

			// Value can be empty
			if (workPatternStr === '') {
				return true;
			}

			// Work pattern must contain at least one Y (working day), case-insensitive
			// NNNNNNN is invalid as it means no working days
			return workPatternStr.toUpperCase().indexOf('Y') !== -1;
		},

		getIsCISActiveForCompany: companyObj => {

			// Show CIS for all Bureaus
			if (companyObj.CompanyType === INTERFACE_TYPES.bureau) {
				return true;
			}

			return companyObj.IsCISActive;
		},

		getIsExpatsActiveForCompany: companyObj => {

			// Show Expats for all Bureaus
			if (companyObj.CompanyType === INTERFACE_TYPES.bureau) {
				return true;
			}

			return companyObj.IsExpatActive;
		},

		getIsHrActiveForCompany: companyObj => companyObj.IsHRActive,

		getIsImportComplete: (payPeriodObj) => {

			// Not submitted
			if (payPeriodObj.DataImportState !== SUBMISSION_STATES.submitted) {
				return false;
			}

			// Data deletion processing
			if (payPeriodObj.DataDeletionState !== SUBMISSION_STATES.unsubmitted && payPeriodObj.DataDeletionState !== SUBMISSION_STATES.submitted) {
				return false;
			}

			return true;
		},

		// Linked elements behave slightly differently where the import file headers MUST match the provided headers and are auto mapped (and manual mapping is not available)
		getIsImportMappingTypeAutoMapped: importMappingType => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.linkedElements:
					return true;
				default:
					return false;
			}
		},

		getIsImportMappingTypeFeatureEnabled: (agencyProfileId, importMappingType) => {

			const featureFlag = getImportMappingTypeFeatureFlag(importMappingType);

			return featureFlag ? base.isFeatureEnabled(agencyProfileId, featureFlag) : $q.resolve(true);
		},

		getIsLinkRatesApplicableForImportMappingType: importMappingType => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.linkRateUnits:
					return true;
			}

			return false;
		},

		getIsMappingColumnNetable: mappingColumnObj => {

			switch (mappingColumnObj.AgencyAdjustmentID) {
				case PAY_ELEMENTS.annualBonus:
				case PAY_ELEMENTS.bonus:
				case PAY_ELEMENTS.christmasBonus:
				case PAY_ELEMENTS.commission:
				case PAY_ELEMENTS.eeNiAndErNi:
				case PAY_ELEMENTS.eeNiAndErNiDeduction:
				case PAY_ELEMENTS.profitShare:
				case PAY_ELEMENTS.referralBonus:
				case PAY_ELEMENTS.signOnBonus:
					return true;
				default:
					return false;
			}
		},

		getIsMappingColumnRateTypeEditable: (importMappingType, mappingColumnObj) => {

			// Unsupported import type
			if (!service.getIsPayElementsRatedUnitsApplicableForImportMappingType(importMappingType)) {
				return false;
			}
			
			// Mapped column is pay element
			return angular.isDefined(mappingColumnObj.AgencyAdjustmentID) && mappingColumnObj.AgencyAdjustmentID !== config.guidEmpty;
		},

		/**
		 * Determines whether to allow the column to be selected multiple times
		**/
		getIsMappingColumnReuseable: mappingColumnObj => {

			switch (mappingColumnObj.ImportMappingColumnType) {
				case IMPORT_MAPPING_COLUMN_TYPES.postIdentifier:
					return false;
				default:
					return !service.getIsImportMappingColumnTypeBusinessCategory(mappingColumnObj.ImportMappingColumnType);
			}
		},

		/**
		 * Determines whether an import mapping column type is a business category
		 * @param {string} importMappingColumnType - The import mapping column type
		**/
		getIsImportMappingColumnTypeBusinessCategory: importMappingColumnType => {

			switch (importMappingColumnType) {
				case IMPORT_MAPPING_COLUMN_TYPES.businessCategoryRole:
				case IMPORT_MAPPING_COLUMN_TYPES.businessCategoryDepartment:
				case IMPORT_MAPPING_COLUMN_TYPES.businessCategoryBranch:
				case IMPORT_MAPPING_COLUMN_TYPES.businessCategoryCostCentre:
				case IMPORT_MAPPING_COLUMN_TYPES.businessCategorySector:
					return true;
				default:
					return false;
			}
		},

		/**
		 * Determines whether to load the core set of pay element object to map data to pay elements
		**/
		getIsPayElementsApplicableForImportMappingType: (importMappingType) => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.payElements:
				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsRecurring:
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
					return true;
			}

			return false;
		},

		getIsPayElementsRatedUnitsApplicableForImportMappingType: (importMappingType) => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
					return true;
			}

			return false;
		},

		getIsPayElementsCISApplicableForImportMappingType: importMappingType => {

			switch (importMappingType) {

				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
					return true;
				default:
					return false;
			}
		},

		/**
		 * Import mapping types that require CIS Pay Elements
		**/
		getIsPayElementsDeemedApplicableForImportMappingType: importMappingType => {

			switch (importMappingType) {

				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
					return true;
				default:
					return false;
			}
		},

		getIsPayElementImportMappingTypeWithElementLabel: (importMappingType) => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.payElementsFixed:
				case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
				case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
				case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
					return true;
			}

			return false;
		},

		getIsPensionActiveForCompany: companyObj => {

			// Show Pension for all Bureaus
			if (companyObj.CompanyType === INTERFACE_TYPES.bureau) {
				return true;
			}

			return companyObj.IsPensionActive;
		},

		getIsRatesUnitsImportMappingType: (importMappingType) => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
					return true;
			}

			return false;
		},

		getIsValidationMappingType: importMappingType => {

			switch (importMappingType) {
				case IMPORT_MAPPING_TYPES.users:
				case IMPORT_MAPPING_TYPES.team:
					return true;
				default:
					return false;
			}
		},

		getIsVerticalLayout: (companyLayoutTypeIsVertical, layoutTypeUrlParam) => {

			// URL param is prioritised
			if (angular.isDefined(layoutTypeUrlParam)) {

				switch (layoutTypeUrlParam) {

					case 'vertical':
						return true;

					case 'horizontal':
						return false;
				}
			}

			return companyLayoutTypeIsVertical;
		},

		getMappingOptionsForDocumentType: (documentType, isVertical, isCisActive, isExpatsActive, isPensionActive, isImportSicknessEnabled, hasHRModule, hasPayPolicies) => {

			switch (documentType) {
				case DOCUMENT_TYPES.periodImport:
					return service.getImportMappingOptionsForPeriodImport(isVertical, isCisActive);
				case DOCUMENT_TYPES.teamImport:
					return service.getImportMappingOptionsForTeamImport(isCisActive, isExpatsActive, isPensionActive, isImportSicknessEnabled, hasHRModule, hasPayPolicies);
			}
		},

		getMappingTypeForDocumentState: (documentState, agencyDocumentType) => {

			switch (agencyDocumentType) {

				// Period imports
				case DOCUMENT_TYPES.periodImport:

					// Validation required
					if (documentState === DOCUMENT_STATES.unchecked) {
						return IMPORT_MAPPING_TYPES.users;
					}

					// No validation required
					return service.getImportMappingTypeForAgencyDocumentType(agencyDocumentType);

				case DOCUMENT_TYPES.teamImport:

					return IMPORT_MAPPING_TYPES.team;

			}
		},

		getMappingTypes: () => {

			return [
				{
					description: 'Used for validating your file against existing team members when importing team data.',
					icon: 'tick',
					id: DOCUMENT_TYPES.teamImport,
					importMappingType: IMPORT_MAPPING_TYPES.team,
					isValidation: true,
					layoutType: null,
					name: 'Team validation (Team)',
				},
				{
					description: 'Used for importing team data for both new and existing team members, including CIS and pension information.',
					icon: 'team',
					id: DOCUMENT_TYPES.teamImport,
					isValidation: false,
					layoutType: null,
					name: 'Team data',
				},
				{
					description: 'Used for importing payroll changes where there\'s a row for every element, for every team member.',
					icon: 'clock',
					id: DOCUMENT_TYPES.periodImport,
					isValidation: false,
					layoutType: 'horizontal',
					name: 'Payroll data (Horizontal)',
				},
				{
					description: 'Used for validating your file against existing team members when importing payroll data.',
					icon: 'tick',
					id: DOCUMENT_TYPES.teamImport,
					importMappingType: IMPORT_MAPPING_TYPES.users,
					isValidation: true,
					layoutType: 'vertical',
					name: 'Team validation (Payroll)',
				},
				{
					description: 'Used for importing payroll changes where there\'s (normally) a single row for each team member.',
					icon: 'clock',
					id: DOCUMENT_TYPES.periodImport,
					isValidation: false,
					layoutType: 'vertical',
					name: 'Payroll data (Vertical)',
				}
			];
		},

		getRateForRatedUnits: (payElementRateType, defaultPayElementRateType) => {

			return angular.isDefined(payElementRateType) && payElementRateType !== IMPORT_RATE_TYPES.none ? payElementRateType : defaultPayElementRateType;
		},

		// Loop over all workers and return the validation results (with worker info attached) - Workers can have multiple validation results
		getValidationResults: (invalidWorkers) => {

			var i 						= 0;
			var numberOfInvalidWorkers 	= invalidWorkers.length;
			var propertyNames 			= service.getValidationResultsPropertyNamesFull(invalidWorkers[0]);
			var validationResults 		= [];

			for (i; i < numberOfInvalidWorkers; i++) {

				var invalidWorker = invalidWorkers[i];

				// Attach worker information onto all Validation Results
				var validationResultsWithWorkerInfo = filterValidationResults(invalidWorker, propertyNames);

				// Push to new array with just Validation Results
				validationResults = validationResults.concat(validationResultsWithWorkerInfo);
			}

			return validationResults;
		},

		// Returns a list of property names to display for a worker
		getValidationResultsPropertyNamesFull: (validationResult) => {

			if (validationResult === undefined) {
				return [];
			}

			var propertyList = Object.keys(validationResult);

			return propertyList;
		},

		// Returns a filter list of property names to display for a worker
		getValidationResultsPropertyNamesVisible: (validationResults) => {

			if (!validationResults.length) {
				return [];
			}

			var validationResult 	= validationResults[0].worker;
			var propertyList 		= Object.keys(validationResult);

			return propertyList.filter(function (propertyName) {

				if (VALIDATION_IGNORE_FIELDS.indexOf(propertyName) === -1 && propertyName.indexOf('UserImport') > -1) {
					return propertyName;
				}
				return;
			});
		},

		getNumberOfSkippedResults: (validationResults) => {

			var i = 0;
			var numberOfResults = validationResults.length;
			var totalIgnored = 0;

			for (i; i < numberOfResults; i++) {

				validationResults[i].ValidationResultIgnore ? totalIgnored++ : '';
			}

			return totalIgnored;
		},

		getNumberOfNewStarters: (validationResults) => {

			var i = 0;
			var numberOfResults = validationResults.length;
			var totalNewStarters = 0;

			for (i; i < numberOfResults; i++) {

				var isNewStarter = validationResults[i].worker.UserImportStarter.toLowerCase() === 'true';

				isNewStarter ? totalNewStarters++ : null;
			}

			return totalNewStarters;
		},

		goToDataImporterForDocumentType: (documentObj, documentType, agencyProfileId) => {

			const importerParams = {
				agencyDocumentId: documentObj.AgencyDocumentID,
				agencyDocumentType: documentType,
				agencyProfileId: agencyProfileId,
				backState: 'settings.company.file-uploads',
				endOnValidate: true,
				importMappingType: service.getMappingTypeForDocumentState(documentObj.DocumentState, documentType),
				payPeriodId: $rootScope.currentPeriod.PayPeriodID
			};

			if (documentObj.DocumentState === DOCUMENT_STATES.checked) {
				$state.go('data-importer.select-import-type', importerParams);
			} else {
				$state.go('data-importer.validate-file', importerParams);
			}
		},

		hasInvalidValidationResults: validationResultsArr => {

			const numberOfValidationResults = validationResultsArr.length;

			let i = 0;

			for (i; i < numberOfValidationResults; i++) {

				const validationResultObj = validationResultsArr[i];

				if (validationResultObj.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.warning && validationResultObj.ValidationResultColNumber > -1) {
					return true;
				}
			}

			return false;
		},

		hasUserImportedElements: userImportGroupObj => {
			return userImportGroupObj.NumberImported > 0 || userImportGroupObj.UserImportGroupID !== config.guidEmpty;
		},

		isRowDataValid: (fileDataObj, importMappingType, IS_BUREAU_MAPPING) => {

			const numberOfRows = fileDataObj.Rows.length;

			angular.extend(fileDataObj, {
				ignoreRowCount: 0,
				invalidRowCount: 0,
				validRowCount: 0
			});

			let i = 0;

			for (i; i < numberOfRows; i++) {

				const rowObj = fileDataObj.Rows[i];

				// All ignored rows are valid (for Bureau's; ignore all rows as validation isn't required)
				if (rowObj.Ignore || IS_BUREAU_MAPPING) {
					fileDataObj.ignoreRowCount++;
					rowObj.isInvalid = false;
					continue;
				}

				// Mapping type specific validation
				switch (importMappingType) {

					// Changes > User validation
					case IMPORT_MAPPING_TYPES.users:

						// Only applies to the 2nd phase of validation, when ValidationResults are populated
						if (angular.isDefined(rowObj.validationResult) && rowObj.validationResult.ValidationType.ValidationTypeID !== VALIDATION_TYPES.userUnchanged && !rowObj.TeamMember) {
							rowObj.isInvalid = true;
							fileDataObj.invalidRowCount++;
							continue;
						}

						break;

					// Journals > Business Categories & Nominal Codes
					case IMPORT_MAPPING_TYPES.businessCategories:
					case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
					case IMPORT_MAPPING_TYPES.nominalCodes:
					case IMPORT_MAPPING_TYPES.xeroNominalCodes:
					case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:

						// Only applies to the 2nd phase of validation, when ValidationResults are populated
						if (angular.isDefined(rowObj.validationResults)) {

							// All validationResults need to be updated in order for the row to be valid
							rowObj.isInvalid = rowObj.validationResults.some(validationResultObj => {

								// Only applies to warning validation types
								if (validationResultObj.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.warning) {
									return !validationResultObj.isUpdated;
								}
							});

							if (rowObj.isInvalid) {
								fileDataObj.invalidRowCount++;
							} else {
								fileDataObj.validRowCount++;
							}

							continue;
						}

						break;

					// Pay Elements > Recurring Pay Elements
					case IMPORT_MAPPING_TYPES.payElementsRecurring:
					case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
					case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
					case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:

						// Only applies to the 2nd phase of validation, when ValidationResults are populated
						if (angular.isDefined(rowObj.validationResults)) {

							// All validationResults need to be updated in order for the row to be valid
							rowObj.isInvalid = rowObj.validationResults.some(validationResultObj => {

								// Only applies to warning validation types
								if (validationResultObj.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.warning) {
									return !validationResultObj.isUpdated;
								}
							});

							if (rowObj.isInvalid) {
								fileDataObj.invalidRowCount++;
							} else {
								fileDataObj.validRowCount++;
							}

							continue;
						}

						break;
				}

				// Invalid
				if (!service.areRowCellsValid(rowObj)) {
					rowObj.isInvalid = true;
					fileDataObj.invalidRowCount++;
					continue;
				}

				// Valid
				rowObj.isInvalid = false;
				fileDataObj.validRowCount++;
			}

			return fileDataObj.invalidRowCount === 0;
		},

		getValidationTypeOverrides: (validationResultObj, activeRowObj) => {

			switch (validationResultObj.ValidationType.ValidationTypeID) {

				// Nominal code narratives
				case VALIDATION_TYPES.nominalCodeNarrativeExists:
					return {
						actionMessage: 'Nominal code narrative already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.nominalCodeNarrativeIsBlank:
					return {
						actionMessage: 'Nominal code narrative is blank',
						isInvalid: true
					};

				// Business categories
				case VALIDATION_TYPES.branchNameExists:
					return {
						actionMessage: 'Branch name already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.branchNameIsBlank:
					return {
						actionMessage: 'Branch name is blank',
						isInvalid: true
					};
				case VALIDATION_TYPES.costCentreNameExists:
					return {
						actionMessage: 'Cost centre name already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.costCentreNameIsBlank:
					return {
						actionMessage: 'Cost centre name is blank',
						isInvalid: true
					};
				case VALIDATION_TYPES.departmentNameExists:
					return {
						actionMessage: 'Department name already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.departmentNameIsBlank:
					return {
						actionMessage: 'Department name is blank',
						isInvalid: true
					};
				case VALIDATION_TYPES.roleNameExists:
					return {
						actionMessage: 'Role name already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.roleNameIsBlank:
					return {
						actionMessage: 'Role name is blank',
						isInvalid: true
					};
				case VALIDATION_TYPES.sectorNameExists:
					return {
						actionMessage: 'Sector name already exists',
						isInvalid: true
					};
				case VALIDATION_TYPES.sectorNameIsBlank:
					return {
						actionMessage: 'Sector name is blank',
						isInvalid: true
					};

				// Update > User does not exist
				case VALIDATION_TYPES.userDoesNotExist:
					return {
						actionMessage: 'Click to match',
						isInvalid: true
					};

				// Update > User unchanged
				case VALIDATION_TYPES.userUnchanged:
					return {
						actionMessage: 'User unchanged',
						isInvalid: false,
						teamMember: {
							name: validationResultObj.ValidationResultImportValue
						}
					};

				// Add > DOB in wrong format
				case VALIDATION_TYPES.dobInWrongFormat:
					return {
						actionMessage: 'Invalid DOB',
						isInvalid: true
					};

				// Add > HMRC Submission ID already exists in Paycircle
				case VALIDATION_TYPES.userWithSubmissionIDAlreadyExists:

					service.removeValidationFieldForValidationType(validationResultObj, activeRowObj);

					return {
						actionMessage: 'HMRC Submission ID already in use',
						isInvalid: false
					};

				// Update > HMRC Submission ID can only be imported before the team member has been processed on payroll
				case VALIDATION_TYPES.userSubmissionIDLockedAfterPayroll:
					return {
						actionMessage: 'HMRC Submission ID cannot be changed once processed on payroll',
						isInvalid: true
					};

				// Add > User already exists in PAYE scheme
				case VALIDATION_TYPES.userWithPayrollIDAlreadyExists:

					service.removeValidationFieldForValidationType(validationResultObj, activeRowObj);

					return {
						actionMessage: 'Payroll ID already in use',
						isInvalid: false
					};

				// Add > User already exists with NI number for company
				case VALIDATION_TYPES.userWithNINumberAlreadyExists:
				// Add > User already exists with NI number in Paycircle
				case VALIDATION_TYPES.userWithNINumberAlreadyExistsInPaycircle:

					service.removeValidationFieldForValidationType(validationResultObj, activeRowObj);

					return {
						actionMessage: 'NI Number already in use',
						isInvalid: false
					};

				// Add > User already exists with NI number for PAYE scheme within bureau
				case VALIDATION_TYPES.userWithNINumberAlreadyExistsOnPayeScheme:
					return {
						actionMessage: 'NI Number already in use on PAYE scheme',
						isInvalid: false
					};
			}
		},

		isTeamMemberApplicableForMapping: importMappingType => {

			switch (importMappingType) {

				// Payroll (team)
				case IMPORT_MAPPING_TYPES.linkedElements:
				case IMPORT_MAPPING_TYPES.linkRateUnits:
				case IMPORT_MAPPING_TYPES.payElements:
				case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsFixed:
				case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
				case IMPORT_MAPPING_TYPES.payElementsRecurring:
				case IMPORT_MAPPING_TYPES.payslipNotes:
				case IMPORT_MAPPING_TYPES.shifts:

				// Team
				case IMPORT_MAPPING_TYPES.address:
				case IMPORT_MAPPING_TYPES.calculatedPayHistoryImport:
				case IMPORT_MAPPING_TYPES.bank:
				case IMPORT_MAPPING_TYPES.cis:
				case IMPORT_MAPPING_TYPES.company:
				case IMPORT_MAPPING_TYPES.pension:
				case IMPORT_MAPPING_TYPES.profile:
				case IMPORT_MAPPING_TYPES.salary:
				case IMPORT_MAPPING_TYPES.salaryUpdates:
				case IMPORT_MAPPING_TYPES.tax:
				case IMPORT_MAPPING_TYPES.ytd:
				case IMPORT_MAPPING_TYPES.expatDetails:
				{
					return true;
				}
				default:
				{
					return false;
				}
			}
		},

		mapValidationErrors: (validationResultsArr, fileRowsArr) => {

			validationResultsArr.forEach(validationResultObj => {

				try {

					let activeRowObj = fileRowsArr[validationResultObj.ValidationResultRowNumber - 1];

					// Only initiate if not already populated
					if (angular.isUndefined(activeRowObj.validationResults)) {

						angular.extend(activeRowObj, {
							actionMessage: null,
							teamMember: null,
							validationResults: [],
							validationResultTypes: [] // Used for filtering results by validation result type
						});
					}

					const validationTypeOverridesObj = service.getValidationTypeOverrides(validationResultObj, activeRowObj);

					angular.extend(validationResultObj, validationTypeOverridesObj);

					activeRowObj.validationResultTypes.push(validationResultObj.ValidationType.ValidationTypeLevel);

					activeRowObj.validationResults.push(validationResultObj);
				}
				catch (err) {

					$rootScope.paycircleMessage('Unable to map validation result to file data:' + err, 'error');
				}
			});
		},

		parseToRowsAndCols: (fileText) => {

			var lines = fileText.split('\n');
			var rows = [];

			for (var row = 0; row < lines.length; row++) {

				var cols = lines[row].split(',');
				cols = service.csvToArray(lines[row]);

				rows.push([]);
				rows[row].cols = [];

				if (cols !== null) {

					for (var col = 0; col < cols.length; col++) {

						var content = { text: cols[col], isValid: true };

						rows[row].cols.push(content);
					}
				}
			}

			return rows;
		},

		reMapValues: rowsArr => {
			rowsArr.forEach(service.reMapRowObj);
		},

		reMapRowObj: rowObj => {

			// Create new 'cells' array of objects for validation (TODO: Move to platform?)
			rowObj.cells.forEach((cellObj, index) => {

				if (!cellObj.isIgnored) {
					rowObj.Values[index] = cellObj.value;
				}
			});
		},

		removeValidationFieldForValidationType: (validationResultObj, activeRowObj) => {

			activeRowObj.Values[validationResultObj.ValidationResultColNumber] = '';

			// Column number is not defined so unable to blank out value
			if (validationResultObj.ValidationResultColNumber === -1) {
				$rootScope.paycircleMessage('dataImporterValidateFileController.js > removeValidationFieldForValidationType > Column number is not defined so unable to blank out value', 'error');
				return;
			}

			activeRowObj.cells[validationResultObj.ValidationResultColNumber].isIgnored = true;
		},

		parseCSV: fileContents => {

			/*
			Validate CSV using PapaParse:
			- Excel can produce an empty line when exporting CSV, ignore those and remove empty row
			- Check for special characters (commas / apostrophes) or carriage returns in header
			- Incorrect number of columns; check for carriage returns
			- Check body contains no commas, apostrophes or quotes
			*/

			const parsedCsvObj = window.Papa.parse(fileContents, {
				skipEmptyLines: true
			});

			const headerColumnCount = parsedCsvObj.data[0].length;

			parsedCsvObj.data.forEach((columnArr, rowIndex) => {

				const rowNumber = rowIndex + 1;

				// 1. Make sure all rows have same number of columns
				if (columnArr.length !== headerColumnCount) {
					parsedCsvObj.errors.push({
						type: 'MisalignedColumnCount',
						code: 'MisalignedColumnCount',
						message: `Mismatched column count (header:${headerColumnCount}, row:${columnArr.length})`, 						// Human-readable details
						row: rowNumber
					});
				}

				// Review cell values
				columnArr.forEach((cellValue, cellIndex) => {

					// 2. No carriage returns allowed
					if (cellValue.indexOf('\n') > -1) {

						const columnNumber = cellIndex + 1;

						parsedCsvObj.errors.push({
							code: 'NoCarriageReturns',
							column: columnNumber,
							data: cellValue,
							message: 'Line break',
							row: rowNumber,
							type: 'NoCarriageReturns'
						});
					}

					// 3. No commas allowed
					if (cellValue.indexOf(',') > -1) {

						const columnNumber = cellIndex + 1;

						parsedCsvObj.errors.push({
							code: 'NoCommas',
							column: columnNumber,
							data: cellValue,
							message: 'Contains a comma',
							row: rowNumber,
							type: 'NoCommas'
						});
					}

					// 4. No quotes allowed (Quotation marks are exported to CSV differently in Numbers / Excel / Google Sheets)
					if (cellValue.indexOf('“') > -1 || cellValue.indexOf('"') > -1) {

						const columnNumber = cellIndex + 1;

						parsedCsvObj.errors.push({
							code: 'NoQuotes',
							column: columnNumber,
							data: cellValue,
							message: 'Contains a quotation mark',
							row: rowNumber,
							type: 'NoQuotes'
						});
					}
				});
			});

			return parsedCsvObj;
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('recurringPayElementImportService', [
	'config',
	'importService',
	'IMPORT_MAPPING_COLUMN_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		config,
		importService,
		IMPORT_MAPPING_COLUMN_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const RECURRING_GROUP_NONE = -1;

	const service = {
		RECURRING_GROUP_NONE,

		/**
		 * Decorates mapping columns for vertical recurring imports
		 * Groups columns by AgencyAdjustmentGroupEntryID and adds properties
		 * @param {Array} mappingColumnsArr - Array of mapping column objects
		 * @returns {Array} Decorated mapping columns array
		 */
		decorateVerticalRecurringImportMappingColumns: (mappingColumnsArr) => {
			let mappingColumnGroupId = 0;
			const groupedColumns = Map.groupBy(mappingColumnsArr.filter(x => x.AgencyAdjustmentGroupEntryID !== config.guidEmpty), ({AgencyAdjustmentGroupEntryID}) => AgencyAdjustmentGroupEntryID);

			groupedColumns.forEach((columnGroup) => {
				const columnGroupElementName = columnGroup.find(x => !service.assessIsRecurringMappingSettingColumn(x)).ImportMappingColumnText;

				columnGroup.forEach(mappingColumnObj => {
					angular.extend(mappingColumnObj, {
						isPayElementNetable: importService.getIsMappingColumnNetable(mappingColumnObj),
						isReusable: false,
						mappingColumnGroupId: mappingColumnGroupId
					});

					if (service.assessIsRecurringMappingSettingColumn(mappingColumnObj)) {
						angular.extend(mappingColumnObj, {
							ImportMappingColumnText: mappingColumnObj.ImportMappingColumnText + ' ('+columnGroupElementName+')',
							isPayElementNetable: false,
							disableLabelAssignment: true
						});
					}
				});

				mappingColumnGroupId++;
			});
			
			return mappingColumnsArr;
		},

		/**
		 * Decorates mapping columns for horizontal recurring imports
		 * Adds properties to recurring setting columns
		 * @param {Array} mappingColumnArray - Array of mapping column objects
		 * @returns {Array} Decorated mapping columns array
		 */
		decorateHorizontalRecurringImportMappingColumns: (mappingColumnArray) => {
			mappingColumnArray.forEach((mappingColumnObj) => {
				if (service.assessIsRecurringMappingSettingColumn(mappingColumnObj)) {
					angular.extend(mappingColumnObj, {
						isPayElementNetable: false,
						disableLabelAssignment: true,
						mappingColumnGroupId: RECURRING_GROUP_NONE
					});
				}

				if (mappingColumnObj.ImportMappingColumnText && mappingColumnObj.ImportMappingColumnText === 'Type') {
					angular.extend(mappingColumnObj, {
						mappingColumnGroupId: RECURRING_GROUP_NONE
					});
				}
			});

			return mappingColumnArray;
		},

		/**
		 * Determines if an importtype is a recurring pay element import
		 * @param {Object} importMappingType - Mapping type object
		 * @returns {Boolean} True if import is payElementsRecurring or payElementsFixedRecurring
		*/
		assessIsRecurringImportType: (importMappingType) => {
			return importMappingType === IMPORT_MAPPING_TYPES.payElementsRecurring || 
				   importMappingType === IMPORT_MAPPING_TYPES.payElementsFixedRecurring;
		},

		/**
		 * Determines if a mapping column is a recurring setting column
		 * @param {Object} mappingColumnObj - Mapping column object
		 * @returns {Boolean} True if column is numberOfPeriodsRecurring or recurringEndDate
		 */
		assessIsRecurringMappingSettingColumn: (mappingColumnObj) => {
			return mappingColumnObj.ImportMappingColumnType === IMPORT_MAPPING_COLUMN_TYPES.numberOfPeriodsRecurring || 
				   mappingColumnObj.ImportMappingColumnType === IMPORT_MAPPING_COLUMN_TYPES.recurringEndDate;
		},

		/**
		 * Filters recurring element options based on the current selected recurring group
		 * @param {Object} mappingColumnObj - Mapping column object
		 * @param {Number} currentSelectedRecurringGroup - Currently selected recurring group ID
		 * @returns {Boolean} True if column should be displayed
		 */
		filterRecurringElementOptions: (mappingColumnObj, currentSelectedRecurringGroup) => {
			if (service.assessIsRecurringMappingSettingColumn(mappingColumnObj)) {
				return mappingColumnObj.mappingColumnGroupId === currentSelectedRecurringGroup;
			}

			return true;
		},

		/**
		 * Sets the active recurring column group on the view model
		 * @param {Object} vmObj - View model object
		 * @param {Number} mappingColumnGroupId - Mapping column group ID to set as active
		 */
		setActiveRecurringColumnGroup: (vmObj, mappingColumnGroupId) => {
			angular.extend(vmObj, {
				currentSelectedRecurringGroup: mappingColumnGroupId
			});
		},

		/**
		 * Resets the active recurring column group to none
		 * @param {Object} vmObj - View model object
		 */
		resetActiveRecurringColumnGroup: (vmObj) => {
			angular.extend(vmObj, {
				currentSelectedRecurringGroup: RECURRING_GROUP_NONE
			});
		}
	};

	return service;
}]);

/*jshint camelcase:false */
'use strict';

angular.module('paycircleApp')
.service('intercomService', ['$rootScope', '$timeout', 'config',
	function ($rootScope, $timeout, config) {

	const intercomService = {

		bootIntercom: (userResponseObj, customisationObj) => {

			if (!customisationObj.Intercom.HashKey) {
				$rootScope.paycircleMessage('Unable to boot Intercom as no User Hash is available');
				return;
			}

			const intercomDataObj = {
				app_id: intercomService.getAppId(customisationObj),
				app_key: config.appKey,
				app_type: config.appTitle,
				email: userResponseObj.UserResponseContactEmail,
				last_logged_in: moment().unix(),
				name: userResponseObj.UserResponseFirstName + ' ' + userResponseObj.UserResponseLastName,
				payroll: config.isPayroll,
				user_hash: customisationObj.Intercom.HashKey,
				user_id: userResponseObj.UserResponseUserID,
				z_index: 99980,
				company: {
					company_id: userResponseObj.AgencyProfileID,
					name: userResponseObj.AgencyProfileName
				}
			};

			// Attach BureauName to intercom data
			if (userResponseObj.BureauName) {
				intercomDataObj.associated_bureau = userResponseObj.BureauName;
			}

			// Update user info
			if (userResponseObj.metaData !== undefined) {
				angular.merge(intercomDataObj, userResponseObj.metaData);
			}

			if (intercomService.isIntercomAvailable()) {

				// Boot Intercom
				window.Intercom('boot', intercomDataObj);

				// Update Intercom settings
				intercomService.updateIntercomSettings();
			}
		},

		bootIntercomPublic: customisationObj => {

			if (!customisationObj) {
				$rootScope.paycircleMessage('Unable to boot Intercom. No customisation object available', 'warn');
				return;
			}

			if (intercomService.isIntercomAvailable()) {
				window.Intercom('boot', {
					app_id: intercomService.getAppId(customisationObj),
					app_key: config.appKey,
					app_type: config.appTitle,
					email: null,
					user_id: null
				});

				intercomService.updateIntercomSettings();
			}
		},

		createLead: (emailAddress, metaDataObj) => {

			if (intercomService.isIntercomAvailable()) {

				const intercomData = {
					anonymous_email: emailAddress
				};

				if (metaDataObj !== undefined) {
					angular.merge(intercomData, metaDataObj);
				}

				window.Intercom('update', intercomData);
			}
		},

		getAppId: customisationObj => {
			return customisationObj.Intercom.AppID;
		},

		hideIntercomLauncher: () => {
			intercomService.showHideIntercomLauncher(false);
		},

		isIntercomAvailable: () => {

			if (window.Intercom !== undefined) {
				return true;

			} else {
				$rootScope.paycircleMessage('Intercom is not available', 'warn');
				return false;
			}
		},

		loadIntercom: (userObj, customisationObj) => {

			if (userObj.IsIntercomEnabled) {
				intercomService.bootIntercom(userObj, customisationObj);

			} else {
				intercomService.shutdownIntercom();
			}
		},

		resetIntercom: (userObj, customOptionObj) => {

			intercomService.shutdownIntercom();

			$timeout(() => {
				intercomService.bootIntercom(userObj, customOptionObj);
			}, 200);
		},

		/**
		 * Show (default) or hide the Intercom launcher
		 */
		showHideIntercomLauncher: (show) => {
			if (intercomService.isIntercomAvailable()) {
				// Show by default
				show = angular.isDefined(show) ? show : true;
				// Need to also hide the message window if hiding the launcher
				if (!show) {
					window.Intercom('hide');
				}
				// Show / hide the launcher
				window.Intercom('update', {
					hide_default_launcher: !show
				});
			}
		},

		showIntercomLauncher: () => {
			intercomService.showHideIntercomLauncher(true);
		},

		showNewMessage: () => {
			if (intercomService.isIntercomAvailable()) {
				window.Intercom('showNewMessage');
			}
		},

		shutdownIntercom: () => {
			if (intercomService.isIntercomAvailable()) {
				window.Intercom('shutdown');
			}
		},

		switchIntercomApps: (intercomAppId, userHash) => {
			intercomService.shutdownIntercom();
			intercomService.bootIntercom(intercomAppId, userHash);
		},

		trackEvent: (eventKey, metadata) => {

			if (!config.trackingEnabled) {
				return;
			}

			if (intercomService.isIntercomAvailable()) {
				window.Intercom('trackEvent', eventKey, metadata); // https://developers.intercom.io/reference#event-model
			}
		},

		updateCompanyData: (agencyProfileId, companyData) => {

			if (!config.trackingEnabled) {
				return;
			}

			if (typeof companyData !== 'object') {
				$rootScope.paycircleMessage('intercomService.updateCompanyData: data needs to be an object');
				return;
			}

			if (agencyProfileId === undefined) {
				$rootScope.paycircleMessage('intercomService.updateCompanyData: agencyProfileId needs to be provided');
				return;
			}

			if (intercomService.isIntercomAvailable()) {

				var companyObj = {
					company: {
						company_id: agencyProfileId
					}
				};

				companyObj.company = angular.merge(companyObj.company, companyData);

				window.Intercom('update', companyObj);
			}
		},

		updateData: dataObj => {

			if (!config.trackingEnabled) {
				return;
			}

			if (typeof dataObj !== 'object') {
				$rootScope.paycircleMessage('intercomService.updateData: data needs to be an object');
				return;
			}

			if (intercomService.isIntercomAvailable()) {
				window.Intercom('update', dataObj);
			}
		},

		updateIntercomSettings: () => {

			if (intercomService.isIntercomAvailable()) {

				window.intercomSettings = {
					alignment: 'left',
					horizontal_padding: 20,
					vertical_padding: 20
				};
			}
		}
	};

	return intercomService;
}]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.libraries
 * @description a list of all the data libraries and services within the Paycircle application
 * # libraries
 * Constant in the paycircleApp.
 */
angular.module('paycircleApp')
.factory('libraries', ['$location', 'config', 'servers', function ($location, config, servers) {

	var server = null;
	var serverType = 'live'; // 'live' or 'beta' or 'dev' or 'preproduction'

	// Beta?
	if (config.useBetaDbFor.indexOf($location.$$host) > -1) {
		serverType = 'beta';
	}

	// Development?
	if (config.useDevDbFor.indexOf($location.$$host) > -1) {
		serverType = 'dev';
	}

	// Preproduction?
	if (config.usePreproductionDbFor.indexOf($location.$$host) > -1) {
		serverType = 'preproduction';
	}

	server = servers[serverType];

	if (!server || server === undefined) {
		console.error('Unable to create the server location. Please check server library configuration.');
		return;
	}

	return {
		aiServices:				server.ganymede		+ 'AiServicesUtilityApi.svc/',
		agency: 				server.thebe 		+ 'AgencyLibraryAPI.svc/',
		base: 					server.callisto 	+ 'BaseLibraryAPI.svc/',
		booking: 				server.thebe 		+ 'Booking.svc/',
		client: 				server.ganymede 	+ 'ClientLibraryAPI.svc/',
		dto:        			server.thebe        + 'DTOLibraryAPI.svc/',
		fiveStar: 	'',
		httpHandler: {
			download: {
				blob: 			server.phobos + 'IHttpHandlerBlobDownload.ashx/',
				blobBasic: 		server.phobos + 'IHttpHandlerBlobBasicDownload.ashx/',
				report: 		server.phobos + 'IHttpHandlerReportExport.ashx/',
			},
			upload: {
				customisation: 	server.phobos + 'IHttpHandlerCustomisationUpload.ashx/',
				userDocument: 	server.phobos + 'IHttpHandlerUserDocumentUpload.ashx/',
            	importFile: 	server.phobos + 'IHttpHandlerImportUpload.ashx/'
			},
		},
    	importLib: 				server.ganymede 	+ 'DataImportLibraryAPI.svc/',
		integration:			server.ganymede     + 'IntegrationLibraryApi.svc/',
		mail: 					server.amalthea 	+ 'MailLibraryAPI.svc/',
		message: 				server.callisto 	+ 'MessageLibraryAPI.svc/',
		oc: 					server.callisto 	+ 'OCLibraryAPI.svc/',
		payroll: 				server.amalthea 	+ 'PayrollLibraryAPI.svc/',
		payrollWorker: 			server.amalthea 	+ 'PayrollLibraryWorkerAPI.svc/',
		pension: 				server.amalthea 	+ 'PensionLibraryAPI.svc/',
		project: 				server.thebe 		+ 'ProjectLibraryAPI.svc/',
		ptr: 					server.amalthea 	+ 'PTRLibraryAPI.svc/',
		report: 				server.ganymede 	+ 'ReportLibraryAPI.svc/',
		security: 				server.phobos 		+ 'SecurityLibraryAPI.svc/',
		survey: 				server.ganymede 	+ 'SurveyLibraryAPI.svc/',
		travel: 				server.thebe 		+ 'TravelLibraryAPI.svc/',
		user: 					server.callisto 	+ 'UserLibraryAPI.svc/',
		venue: 					server.ganymede 	+ 'VenueLibraryAPI.svc/',
		wordPressAPI:			server.wordPress    + 'wp-json/wp/v2/',
		paycircleWordPressAPI:	server.wordPress	+ 'wp-json/paycircle/'
	};

}]);

'use strict';

angular.module('paycircleApp')
.service('locationChangeService', [
	'$location',
	'$rootScope',
	'iframeDetectionService',
	'utilities',
	'EVO_MESSAGE_TYPES',
	function (
		$location,
		$rootScope,
		iframeDetectionService,
		utilities,
		EVO_MESSAGE_TYPES
	) {

	const service = {

		isParentAccessible: () => {
			try {
				return window.parent && typeof window.parent.postMessage === 'function';
			} catch (e) {
				return false;
			}
		},

		shouldTrackLocation: () => {
			return iframeDetectionService.isRunningInIframe() && service.isParentAccessible();
		},

		getFeatureNameFromState: (stateName) => {
			const stateMapping = {
				'team': 'Team',
				'team.members': 'Team',
				'team.leavers': 'Leavers',
				'team.manager': 'Team Manager',
				'team.profile': 'Employee Profile',
				'team.imports': 'Team Imports',
				'payroll': 'Payroll',
				'payroll.current-period': 'Current Period',
				'payroll.previous-period': 'Previous Period',
				'payroll.history': 'Payroll History',
				'company-dashboard': 'Dashboard',
				'settings': 'Settings',
				'reporting': 'Reporting',
				'pensions': 'Pensions',
				'hr': 'HR',
				'hr.imports': 'Policy Imports',
			};

			for (const [statePrefix, featureName] of Object.entries(stateMapping)) {
				if (stateName.startsWith(statePrefix)) {
					return featureName;
				}
			}

			return stateName.split('.')[0] || 'Unknown';
		},

		getEntityNameFromState: (toState, toParams) => {
			if (toState.name.includes('team.profile') && toParams.userId) {
				return 'Employee';
			}
			
			if (toState.name.includes('company') && $rootScope.currentCompany) {
				return $rootScope.currentCompany.Name;
			}

			return null;
		},

		getInstanceNameFromCompany: () => {
			if ($rootScope.currentCompany) {
				return $rootScope.currentCompany.Name;
			}
			return null;
		},

		generateBreadcrumbTitle: (toState) => {
			const breadcrumb = [];

			if ($rootScope.companies && $rootScope.companies.length > 1) {
				breadcrumb.push($rootScope.companies[0].Name);
			}

			if ($rootScope.currentCompany) {
				breadcrumb.push($rootScope.currentCompany.Name);
			}

			const featureName = service.getFeatureNameFromState(toState.name);
			if (featureName) {
				breadcrumb.push(featureName);
			}

			if (toState.data && toState.data.title) {
				breadcrumb.push(toState.data.title);
			}

			return {
				instanceName: service.getInstanceNameFromCompany(),
				breadcrumb: breadcrumb.filter(item => item && item.trim() !== '')
			};
		},

		generateStructuredTitle: (toState, toParams) => {
			const featureName = service.getFeatureNameFromState(toState.name);
			const entityName = service.getEntityNameFromState(toState, toParams);
			const instanceName = service.getInstanceNameFromCompany();

			return {
				featureName: featureName,
				entityName: entityName,
				instanceName: instanceName
			};
		},

		generateTitle: (toState, toParams, useBreadcrumb = false) => {
			if (useBreadcrumb) {
				return service.generateBreadcrumbTitle(toState);
			} else {
				return service.generateStructuredTitle(toState, toParams);
			}
		},

		sendLocationMessage: (url, title, instanceId) => {
			if (!service.shouldTrackLocation()) {
				return;
			}

			// Only add instanceId if it's not already present in the URL
			let finalUrl = url;
			if (instanceId && !url.includes('instanceId=')) {
				
				finalUrl = url + '?instanceId=' + instanceId;
			}

			const message = {
				type: EVO_MESSAGE_TYPES.LocationChanged,
				url: finalUrl,
				title: title
			};

			try {
				const messageString = JSON.stringify(message);
				window.parent.postMessage(messageString, utilities.getIframeParentURL());
				
				if (utilities.isDevelopment()) {
					console.info('Location change sent to parent:', message);
				}
			} catch (error) {
				if (utilities.isDevelopment()) {
					console.warn('Failed to send location change to parent:', error);
				}
			}
		},

		trackLocationChange: (toState, toParams, instanceId) => {
			if (!service.shouldTrackLocation()) {
				return;
			}

			const currentUrl = $location.absUrl();
			const title = service.generateTitle(toState, toParams);

			service.sendLocationMessage(currentUrl, title, instanceId);
		}

	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
	.service('loggedUserService', ['$rootScope', function ($rootScope) {

		const service = {
			isEvoEnabled: function () {
				if(!$rootScope.isLoggedIn || !$rootScope.currentUser){
					return false;
				}

				return $rootScope.currentUser.IsAccessWorkspaceAccount && $rootScope.currentUser.IsApplicationProvisioned;
			},

			getAccessWorkspaceProductID: function () {
				if(!service.isEvoEnabled()){
					return null;
				}

				return $rootScope.currentUser.AccessWorkspaceProductID;
			}
		};

		return service;
	}]);

'use strict';

angular.module('paycircleApp')
.service('logService', ['$rootScope', '$filter', 'config', 'utilities', 'LOG_CATEGORY_NAMES', 'LOG_CATEGORIES', 'LOG_CATEGORY_TYPES', 'LOG_DATA_TYPES', 'LOG_TYPE_KEYS', 'LOG_TYPES', function ($rootScope, $filter, config, utilities, LOG_CATEGORY_NAMES, LOG_CATEGORIES, LOG_CATEGORY_TYPES, LOG_DATA_TYPES, LOG_TYPE_KEYS, LOG_TYPES) {

	var service = {

		decorateLogAddress: function (address) {

			if (!address) {
				return address;
			}

			return address.split('|');
		},

		decorateLogEntries: function (logEntriesArray) {

			if (!logEntriesArray) {
				return;
			}

			return service.logEntriesFilter(logEntriesArray);
		},

		getLogCategoriesArray: function (logEntriesArray) {

			var i = 0;
			var numberOfLogEntries = logEntriesArray.length;
			var returnArray = [];

			for (i; i < numberOfLogEntries; i++) {

				var logEntryObj = logEntriesArray[i];

				if (returnArray.indexOf(logEntryObj.CategoryID) === -1) {
					returnArray.push(logEntryObj.CategoryID);
				}
			}

			return service.getLogCategoriesArrayByCategoryIds(returnArray);
		},

		getLogCategoryNameByCategoryId: function (categoryId) {

			switch (categoryId) {

				case LOG_CATEGORIES.billing:
					return 'Billing';
				case LOG_CATEGORIES.bacs:
					return 'BACS';
				case LOG_CATEGORIES.cis:
					return 'CIS';
				case LOG_CATEGORIES.company:
					return 'Company';
				case LOG_CATEGORIES.eps:
					return 'EPS';
				case LOG_CATEGORIES.eyu:
					return 'Earlier Year Updates';
				case LOG_CATEGORIES.fps:
					return 'FPS';
				case LOG_CATEGORIES.import:
					return 'Import';
				case LOG_CATEGORIES.pension:
					return 'Pension';
				case LOG_CATEGORIES.payroll:
					return 'Payroll';
				case LOG_CATEGORIES.rti:
					return 'RTI';
				case LOG_CATEGORIES.security:
					return 'Security';
				case LOG_CATEGORIES.system:
					return 'System';
				case LOG_CATEGORIES.user:
					return 'Team';
				case LOG_CATEGORIES.userTax:
					return 'Tax Updates';
				case LOG_CATEGORIES.workflow:
					return 'Workflow';
			}

			return null;
		},

		getLogCategoriesArrayByCategoryIds: function (categoryIdsArray) {

			var i = 0;
			var numberOfCategoryIds = categoryIdsArray.length;
			var returnArray = [{
				name: 'All',
				id: ''
			}];

			for (i; i < numberOfCategoryIds; i++) {

				var categoryId = categoryIdsArray[i];
				var categoryName = service.getLogCategoryNameByCategoryId(categoryId);

				returnArray.push({
					name: categoryName,
					id: categoryId
				});
			}

			return returnArray;
		},

		getLogIconByCategoryId: function (categoryId) {

			switch (categoryId) {
				case LOG_CATEGORIES.personal:
					return 'user';
				case LOG_CATEGORIES.payroll:
					return 'clock';
				case LOG_CATEGORIES.hr:
					return 'user-profile';
				case LOG_CATEGORIES.pension:
					return 'money';
				case LOG_CATEGORIES.system:
					return 'cog';
				case LOG_CATEGORIES.bacs:
				case LOG_CATEGORIES.company:
					return 'company';
				case LOG_CATEGORIES.userTax:
					return 'tax-code-change';
				default:
					return 'information';
			}
		},

		getLogKeyByLogType: function (logType) {

			var logKey = LOG_TYPE_KEYS[logType];

			return logKey;
		},

		getLogMetaForLogEntry: function (logEntryObj) {

			const logKey = service.getLogKeyByLogType(logEntryObj.LogType);
			let logMetaObj;

			// Log key is not defined in LOG_TYPE_KEYS > Use default
			if (angular.isUndefined(logKey)) {
				logMetaObj = angular.copy(LOG_TYPES['DEFAULT']);
			}

			// Use the LOG_TYPE_KEYS object
			else {
				logMetaObj = angular.copy(LOG_TYPES[logKey]);
			}

			// No object defined
			if (angular.isUndefined(logMetaObj)) {
				return;
			}

			logMetaObj.icon = logMetaObj.icon ? logMetaObj.icon : service.getLogIconByCategoryId(logEntryObj.CategoryID);
			logMetaObj.theme = logMetaObj.theme ? logMetaObj.theme : service.getLogThemeByCategoryId(logEntryObj.CategoryID);

			return logMetaObj;
		},

		getLogMetaForWorkflowStepLogEntry: function (workflowStepLogEntry) {

			/* Get some specific icon info corresponding to a workflow step. Uses value entry and log ID from workflow step
			   activity log entry to do its best to come up with something meaningful, defaulting to whatever getLogMetaForLogEntry
			   returns */
			let logMetaObj = service.getLogMetaForLogEntry(workflowStepLogEntry);

			// Get ValueTo, or failing that, ValueFrom, from the workflow step.
			let value = workflowStepLogEntry.ValueTo ? workflowStepLogEntry.ValueTo : workflowStepLogEntry.ValueFrom;

			if (value) {
				if (value.toUpperCase().indexOf('COMPLETED') !== -1) {
					// Step is 'completed', so a green tick is in order
					angular.extend(logMetaObj, {
						icon: 'tick',
						theme: 'secondary'
					});
				}
				// Add other specific overrides here ...
			}

			return logMetaObj;
		},

		getLogThemeByCategoryId: function (categoryId) {

			switch (categoryId) {
				case LOG_CATEGORIES.personal:
				case LOG_CATEGORIES.payroll:
					return 'primary';
				case LOG_CATEGORIES.hr:
					return 'quarternary';
				case LOG_CATEGORIES.pension:
					return 'secondary';
				case LOG_CATEGORIES.company:
					return 'quarternary';
				case LOG_CATEGORIES.system:
					return 'indifferent';
				case LOG_CATEGORIES.bacs:
					return 'assertive';
				default:
					return 'primary';
			}
		},

		logEntryFilter: function (logEntryObj) {

			// Decorate with log meta data
			logEntryObj.dateUnix = moment(logEntryObj.LogDateISO).format('X');
			logEntryObj.logMeta = service.getLogMetaForLogEntry(logEntryObj);
			logEntryObj.logKey = LOG_TYPE_KEYS[logEntryObj.LogType];
			logEntryObj.showContent = (logEntryObj.ValueFrom);

			// Log not set up, use default
			if (angular.isUndefined(logEntryObj.logMeta)) {
				logEntryObj.logMeta = angular.copy(LOG_TYPES['DEFAULT']);
			}

			// Use log description if no description is given
			if (logEntryObj.logMeta.description === '') {
				logEntryObj.logMeta.description = logEntryObj.LogEntryTitle;
			}

			// Format log
			switch (logEntryObj.LogType) {
				case LOG_TYPES.ADDRESS_UPDATED.id:
					logEntryObj.ValueFrom = service.decorateLogAddress(logEntryObj.ValueFrom);
					logEntryObj.ValueTo = service.decorateLogAddress(logEntryObj.ValueTo);
					break;
				case LOG_TYPES.USER_ON_HOLD.id:
				case LOG_TYPES.USER_OFF_HOLD.id:
					logEntryObj.showContent = false;
					break;
			}

			// Decorate
			logEntryObj.logMeta.icon = logEntryObj.logMeta.icon ? logEntryObj.logMeta.icon : service.getLogIconByCategoryId(logEntryObj.CategoryID);
			logEntryObj.logMeta.theme = logEntryObj.logMeta.theme ? logEntryObj.logMeta.theme : service.getLogThemeByCategoryId(logEntryObj.CategoryID);

			return logEntryObj;
		},

		logEntriesFilter: function (logEntriesArray) {

			var numberOfLogEntries = logEntriesArray.length;
			var i = numberOfLogEntries - 1;
			var previousLogEntry = null;

			for (i; i >= 0; i--) {

				var logEntryObj = service.logEntryFilter(logEntriesArray[i]);

				previousLogEntry = logEntryObj;
			}

			return logEntriesArray;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('modalService', [
	'MODAL_OPTIONS',
	'$rootScope',
	function (
		MODAL_OPTIONS,
		$rootScope
	) {

	const service = {

		getDefaultModalOptions: () => {

			return {
				// Animation used on modal display
				animation: 'fadeIn',
				// Callback for any specific action the modal can perform
				callback: null,
				// Can the modal be closed from the title bar? Irrelevant if showHeader == false.
				canClose: true,
				// Close the modal when callback is invoked?
				closeOnCallback: true,
				// Does the modal take up the entirety of the browser window?
				isEntireScreen: false,
				// Is the modal open?
				isOpen: false,
				// Unique key for the modal. Used by modal cabinet to find specific modal component.
				modalKey: null,
				// Function to call on close
				onClose: null,
				// Show the header (title bar)?
				showHeader: true,
				// Size. Irrelevant if isEntireScreen == true
				size: 'is-medium',
				template: 'basic',
				// Theme
				theme: 'is-primary',
				// Title to show in header. Irrelevant if isEntireScreen == true
				title: 'Modal title',

				/**
				 * Close the modal
				 */
				 closeModal: function () {

					// If onClose callback specified, call it
					if (angular.isFunction(this.onClose)) {
						this.onClose();
					}

					// Close modal at application level
					$rootScope.closeModalDialog();
				},

				/**
				 * Open the modal
				 */
				 openModal: function () {

					$rootScope.openModalDialog(this);
				}
			};
		},

		// Get modal type defaults + specific instance options
		getModalOptions: specificModalOptionsObj => {

			// Default modal options + modal type defaults
			let modalOptions = service.getDefaultModalOptionsByKey(specificModalOptionsObj.modalKey);

			// Apply any specific options
			angular.extend(modalOptions, specificModalOptionsObj);

			// If closeOnCallback is set, modify the behaviour of the callback function if there is one
			if (modalOptions.closeOnCallback && angular.isFunction(modalOptions.callback)) {
				const baseCallback = modalOptions.callback;
				// New callback is callback + closeModal
				modalOptions.callback = (() => {
					baseCallback();
					modalOptions.closeModal();
				});
			}

			return modalOptions;
		},

		// Get default modal options + modal type defaults
		getDefaultModalOptionsByKey: modalKey => {

			let modalOptions = service.getDefaultModalOptions();
			let modalTypeOptions = service.getSpecificModalOptionsByKey(modalKey);

			angular.extend(modalOptions, modalTypeOptions);

			return modalOptions;
		},

		getSpecificModalOptionsByKey: modalKey => {

			const specificModalOptionsObj = MODAL_OPTIONS[modalKey];

			if (!specificModalOptionsObj) {
				throw('Paycircle: Unable to open modal as modal options are not defined');
			}

			return specificModalOptionsObj;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('adjustmentsService', [
	'$filter',
	'$rootScope',
	'config',
	'tooltipsService',
	'salaryService',
	'utilities',
	'validationService',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'ADJUSTMENT_TYPES',
	'ADJUSTMENT_VALUE_TYPES',
	'IMPORT_MAPPING_TYPES',
	'PAYMENT_TYPES',
	'PAYSLIP_PAGINATION',
	'REPAYMENT_SCHEDULE_TYPES',
	'USER_PAY_ELEMENT_COMPONENT_UNIT_TYPES',
	function (
		$filter,
		$rootScope,
		config,
		tooltipsService,
		salaryService,
		utilities,
		validationService,
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_TYPES,
		ADJUSTMENT_VALUE_TYPES,
		IMPORT_MAPPING_TYPES,
		PAYMENT_TYPES,
		PAYSLIP_PAGINATION,
		REPAYMENT_SCHEDULE_TYPES,
		USER_PAY_ELEMENT_COMPONENT_UNIT_TYPES
	) {

	var service = {

		createAdjustmentsForPrintablePayslip: (payslip) => {

			// Positions for adjustments as defined on platform. Left hand side (lhs) or right hand side (rhs)
			const PAYSLIP_ADJUSTMENT_POSITIONS = {
				lhs: 1,
				rhs: 2
			};

			// Separate adjustments into left and right bits
			payslip.lhs = {
				// List of adjustments for this side
				payslipAdjustments: [],
				// Overall 'has BIK' flag to control visibility of '* = Benefit in kind' indicator on payslip
				hasBIK: false,
				// Total of adjustments in this list
				totalValue: 0
			};
			// Do the same for the other side
			payslip.rhs = angular.copy(payslip.lhs);

			/* Sneakily add in 'special' LHS and RHS 'adjustments' that aren't classed as separate adjustments,
			   but nevertheless form part of the payslip adjustments lists and are involved in total calculations */
			// LHS standard adjustments - Pay. Alter description for partnerships and off-payroll workers
			// Show this when Pay is non-zero and there are no jobs (for agency workers)
			if (payslip.SalaryGrossPay !== 0 || (payslip.Jobs && payslip.Jobs.length === 0)) {
				let payDescription = 'Salary';
				if (payslip.PayPeriod.IsPartnership) {
					payDescription = 'Profit Share';
				}
				else if (payslip.Personal.IsOffPayrollWorker) {
					payDescription = 'Deemed Payment';
				}
				// Currency info if applicable
				if (payslip.Salary.SalaryHasCurrency) {
					// Build salary detail
					payDescription += ` (${payslip.Salary.SalaryForeignValue} ${payslip.Salary.CurrencyLabel} (Ex. ${payslip.Salary.CurrencyValue}))`;
				}
				payslip.lhs.payslipAdjustments.push({
					description: payDescription,
					displayValue: payslip.SalaryGrossPay,
					value: payslip.SalaryGrossPay
				});
			}

			// Additional post pay points
			if (payslip.PayPointAdjustments) {
				payslip.PayPointAdjustments.forEach(adjustment => {
					const adjustmentValue = adjustment.AdjustmentDeduction ? -adjustment.AdjustmentValue : adjustment.AdjustmentValue;
					let sideOfCurrentInterest;
					if (adjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.lhs) {
						sideOfCurrentInterest = payslip.lhs;
					}
					else if (adjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.rhs) {
						sideOfCurrentInterest = payslip.rhs;
					}
					if (angular.isDefined(sideOfCurrentInterest)) {
						sideOfCurrentInterest.payslipAdjustments.push({
							description: adjustment.AdjustmentLabel || adjustment.AdjustmentDescription,
							displayValue: adjustmentValue.toFixed(2),
							value: adjustmentValue
						});
					}
				});
			}

			// Jobs (for agency workers)
			if (payslip.Jobs) {

				// Job expenses total for printable payslip
				let jobExpensesTotal = 0;

				payslip.Jobs.forEach(job => {
					payslip.lhs.payslipAdjustments.push({
						description: job.JobRoleName,
						displayValue: job.JobWorksheetsTotalGross.toFixed(2),
						value: job.JobWorksheetsTotalGross
					});

					jobExpensesTotal += job.JobExpensesTotal;
				});

				// Update total
				if (jobExpensesTotal > 0) {
					payslip.rhs.payslipAdjustments.push({
						description: 'Job Expenses',
						displayValue: jobExpensesTotal.toFixed(2),
						value: jobExpensesTotal
					});
				}
			}

			// Pensions (could be more than one here) ... these can end up on the left or right depending on net / gross
			payslip.Pensions.forEach(pension => {
				let sideOfCurrentInterest;
				if (pension.PensionPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.lhs) {
					sideOfCurrentInterest = payslip.lhs;
				}
				else if (pension.PensionPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.rhs) {
					sideOfCurrentInterest = payslip.rhs;
				}
				// sideOfCurrentInterest may remain undefined. In which case, do nothing with the adjustment.
				if (angular.isDefined(sideOfCurrentInterest)) {
					// Decide whether this is a deduction based on IsEmployeePensionRefund
					const adjustmentValue = pension.IsEmployeePensionRefund ? pension.EmployeesPensionPayment : -pension.EmployeesPensionPayment;
					sideOfCurrentInterest.payslipAdjustments.push({
						description: pension.PrintablePensionPayslipDescription,
						displayValue: adjustmentValue.toFixed(2),
						value: adjustmentValue
					});
				}
			});

			// Pension adjustments.
			payslip.PensionAdjustments.forEach(pensionAdjustment => {
				let sideOfCurrentInterest;
				if (pensionAdjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.lhs) {
					sideOfCurrentInterest = payslip.lhs;
				}
				else if (pensionAdjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.rhs) {
					sideOfCurrentInterest = payslip.rhs;
				}
				// sideOfCurrentInterest may remain undefined. In which case, do nothing with the adjustment.
				if (angular.isDefined(sideOfCurrentInterest)) {
					// Use the deduction flag like regular adjustments - refunds have AdjustmentDeduction=false
					const adjustmentValue = pensionAdjustment.AdjustmentDeduction ? -pensionAdjustment.AdjustmentValue : pensionAdjustment.AdjustmentValue;
					sideOfCurrentInterest.payslipAdjustments.push({
						description: pensionAdjustment.AdjustmentDescription,
						displayValue: adjustmentValue.toFixed(2),
						value: adjustmentValue
					});
				}
			});

			payslip.Adjustments.forEach(adjustment => {

				/* Create a very slender payslip adjustment type for display purposes, stripped of all additional info.
				   This also allows addition of other items from the payslip (pay, pension) as adjustments, since they
				   appear in the same lists on the payslip. */
				let payslipAdjustment = {
					// Start with just the BIK flag, plucked directly from the adjustment
					isBIK: adjustment.AdjustmentIsBIK,
					Components: adjustment.Components || []
				};

				// Decimalise and sign the adjustment value for display
				let adjustmentDisplayValue;
				// The original number for totalling
				let adjustmentValue;
				if (adjustment.AdjustmentValue === 0) {
					// Show nowt as a single, very round number
					adjustmentDisplayValue = '0';
					adjustmentValue = 0;
				}
				else {
					// Make the value negative if it's a deduction
					adjustmentValue = adjustment.AdjustmentDeduction ? -adjustment.AdjustmentValue : adjustment.AdjustmentValue;
					// Fix to two decimal places
					adjustmentDisplayValue = adjustmentValue.toFixed(2);
				}
				payslipAdjustment.displayValue = adjustmentDisplayValue;
				payslipAdjustment.value = adjustmentValue;

				// Description for payslip. Use the label if one is available, otherwise description
				let adjustmentDescriptionPayslip = adjustment.AdjustmentLabel ? adjustment.AdjustmentLabel : adjustment.AdjustmentDescription;
				if (adjustment.adjustmentDetail) {
					adjustmentDescriptionPayslip = `${adjustmentDescriptionPayslip} (${adjustment.adjustmentDetail})`;
				}
				payslipAdjustment.description = adjustmentDescriptionPayslip;

				// Determine where to stick this adjustment, depending on position indicator returned from platform
				let sideOfCurrentInterest;
				if (adjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.lhs) {
					sideOfCurrentInterest = payslip.lhs;
				}
				else if (adjustment.AdjustmentPayslipPosition === PAYSLIP_ADJUSTMENT_POSITIONS.rhs) {
					sideOfCurrentInterest = payslip.rhs;
				}

				// sideOfCurrentInterest may remain undefined. In which case, do nothing with the adjustment.
				if (angular.isDefined(sideOfCurrentInterest)) {

					/* Set flag to indicate there is at least one BIK amongst the adjustments on this side. BIKs are probably
						only applicable to one or other of these lists, but you never know. */
					if (adjustment.AdjustmentIsBIK)	{
						sideOfCurrentInterest.hasBIK = true;
					}

					// Finally add the adjustment to the list
					sideOfCurrentInterest.payslipAdjustments.push(payslipAdjustment);
				}
			});

			// Gross up adjustments
			payslip.grossUpAdjustments.forEach(adjustmentObj => {
				payslip.lhs.payslipAdjustments.push({
					description: adjustmentObj.label,
					displayValue: adjustmentObj.value.toFixed(2),
					value: adjustmentObj.value
				});
			});

			// Total up lhs and rhs numbers
			payslip.lhs.totalValue = payslip.lhs.payslipAdjustments.reduce((total, payslipAdjustment) => total + payslipAdjustment.value, 0);
			payslip.rhs.totalValue = payslip.rhs.payslipAdjustments.reduce((total, payslipAdjustment) => total + payslipAdjustment.value, 0);

			return payslip;
		},

		createPaginatedPayslipPages: (payslip, maxLinesFirstPage, maxLinesPerPage) => {
			maxLinesPerPage = maxLinesPerPage || PAYSLIP_PAGINATION.maxLinesPerPage;
			maxLinesFirstPage = maxLinesFirstPage || PAYSLIP_PAGINATION.maxLinesFirstPage;
			var charsPerLine = PAYSLIP_PAGINATION.charsPerLine;

			var estimateLineCount = function(text) {
				if (!text) {
					return 1;
				}
				return Math.max(1, Math.ceil(text.length / charsPerLine));
			};

			var getRowLabel = function(row) {
				if (row.type === 'component') {
					return (row.component.Label || '');
				}
				return row.description || '';
			};

			var flattenToRows = function(adjustments) {
				var rows = [];
				adjustments.forEach(function(adj) {
					rows.push({
						type: 'adjustment',
						adjustment: adj,
						description: adj.description,
						displayValue: adj.displayValue,
						isBIK: adj.isBIK
					});
					if (adj.Components && adj.Components.length > 0) {
						adj.Components.forEach(function(comp) {
							rows.push({
								type: 'component',
								component: comp,
								parentAdjustment: adj
							});
						});
					}
				});
				return rows;
			};

			var chunkRowsByLines = function(rows, firstPageMaxLines, subsequentMaxLines) {
				var chunks = [];
				if (rows.length === 0) {
					return [[]];
				}
				var currentChunk = [];
				var currentLines = 0;
				var maxLines = firstPageMaxLines;

				for (var i = 0; i < rows.length; i++) {
					var row = rows[i];
					var rowLines = estimateLineCount(getRowLabel(row));

					if (currentLines + rowLines > maxLines && currentChunk.length > 0) {
						chunks.push(currentChunk);
						currentChunk = [];
						currentLines = 0;
						maxLines = subsequentMaxLines;
					}

					currentChunk.push(row);
					currentLines += rowLines;
				}

				if (currentChunk.length > 0) {
					chunks.push(currentChunk);
				}

				return chunks.length > 0 ? chunks : [[]];
			};

			var lhsRows = flattenToRows(payslip.lhs.payslipAdjustments);
			var rhsRows = flattenToRows(payslip.rhs.payslipAdjustments);

			var lhsChunks = chunkRowsByLines(lhsRows, maxLinesFirstPage, maxLinesPerPage);
			var rhsChunks = chunkRowsByLines(rhsRows, maxLinesFirstPage, maxLinesPerPage);

			var totalPages = Math.max(lhsChunks.length, rhsChunks.length, 1);

			var pages = [];
			for (var i = 0; i < totalPages; i++) {
				var lhsPageRows = lhsChunks[i] || [];
				var rhsPageRows = rhsChunks[i] || [];

				pages.push({
					pageNumber: i + 1,
					totalPages: totalPages,
					lhsRows: lhsPageRows,
					rhsRows: rhsPageRows,
					isLastPage: i === totalPages - 1,
					lhsHasBIK: lhsPageRows.some(function(row) { return row.isBIK; }),
					rhsHasBIK: rhsPageRows.some(function(row) { return row.isBIK; })
				});
			}

			return {
				pages: pages,
				totalPages: totalPages,
				lhsTotalValue: payslip.lhs.totalValue,
				rhsTotalValue: payslip.rhs.totalValue,
				lhsHasBIK: payslip.lhs.hasBIK,
				rhsHasBIK: payslip.rhs.hasBIK
			};
		},

		decorateAdjustments: (adjustmentsArr) => {

			// Adjustments that have additional information to peruse
			const toggleEnabledAdjustments = [
				ADJUSTMENT_TYPES.attachmentOrder,
				ADJUSTMENT_TYPES.costOfMaterials,
				ADJUSTMENT_TYPES.expenses,
				REPAYMENT_SCHEDULE_TYPES.adoptionPay,
				REPAYMENT_SCHEDULE_TYPES.bereavementPay,
				REPAYMENT_SCHEDULE_TYPES.carBenefitInKind,
				REPAYMENT_SCHEDULE_TYPES.companyLoan,
				REPAYMENT_SCHEDULE_TYPES.cycleToWorkScheme,
				REPAYMENT_SCHEDULE_TYPES.healthcare,
				REPAYMENT_SCHEDULE_TYPES.maternityPay,
				REPAYMENT_SCHEDULE_TYPES.neonatalCarePay,
				REPAYMENT_SCHEDULE_TYPES.paternityPay,
				REPAYMENT_SCHEDULE_TYPES.seasonTicketLoan,
				REPAYMENT_SCHEDULE_TYPES.sharedParentalPay,
				REPAYMENT_SCHEDULE_TYPES.sickPay,
			];

			adjustmentsArr.forEach(adjustmentObj => {

				adjustmentObj.adjustmentTooltips = service.getTooltipsForAdjustment(adjustmentObj);
				adjustmentObj.adjustmentDetail = service.getDetailForAdjustment(adjustmentObj);
				adjustmentObj.attributes = [];
				adjustmentObj.icon = service.getIconForAdjustment(adjustmentObj);
				adjustmentObj.isToggleEnabled = toggleEnabledAdjustments.indexOf(adjustmentObj.AdjustmentDetailID) > -1;
				adjustmentObj.AdjustmentLabel = adjustmentObj.AdjustmentLabel !== '' ? adjustmentObj.AdjustmentLabel : adjustmentObj.AdjustmentDescription;

				if (adjustmentObj.IsAdditionalPost) {
					adjustmentObj.AdjustmentOnlineLabel = adjustmentObj.AdjustmentLabel;
					adjustmentObj.AdjustmentLabel = adjustmentObj.SalaryPolicyPostTitle + ' - ' + adjustmentObj.AdjustmentLabel;
				}
				else {
					adjustmentObj.AdjustmentOnlineLabel = adjustmentObj.AdjustmentLabel;
				}

				if (adjustmentObj.Components && adjustmentObj.Components.length > 0) {
					adjustmentObj.isToggleEnabled = true;

					// Determine rate type from each component's UnitType enum (set by backend)
					adjustmentObj.Components.forEach(component => {
						component.isDailyRate = component.UnitType === USER_PAY_ELEMENT_COMPONENT_UNIT_TYPES.daily;
						component.unitLabel = component.isDailyRate ? 'day' : 'hrs';
						component.rateLabel = component.isDailyRate ? '/day' : '/hr';
					});
				}

				// Benefit In Kind (BIK)
				if (adjustmentObj.AdjustmentIsBIK) {
					adjustmentObj.attributes.push({
						label: 'benefitinkind',
						tooltip: 'This payment is a benefit in kind'
					});
				}

				// Notional
				if (adjustmentObj.AdjustmentIsNotional) {
					adjustmentObj.attributes.push({
						label: 'notional',
						tooltip: 'This payment is notional'
					});
				}

				// Pensionable
				if (adjustmentObj.WorkplacePensionID !== config.guidEmpty) {
					adjustmentObj.attributes.push({
						icon: 'icon-money',
						tooltip: 'Pensionable'
					});
				}

				// Additional post
				if (adjustmentObj.IsAdditionalPost) {
					adjustmentObj.attributes.push({
						icon: 'icon-setup-user',
						tooltip: adjustmentObj.SalaryPolicyPostTitle
					});
				}
			});

			return adjustmentsArr;
		},

		decorateAdjustmentTypes: adjustmentTypesArr => {

			adjustmentTypesArr.forEach(adjustmentTypeObj => {

				adjustmentTypeObj.tooltip = tooltipsService.getTooltipForAdjustmentType(adjustmentTypeObj);
			});

			return adjustmentTypesArr;
		},

		decorateLabelsWithAdjustmentTypes: (adjustmentLabelsArr, adjustmentTypesArr) => {

			return adjustmentLabelsArr.filter((adjustmentLabelObj) => {

				adjustmentLabelObj.adjustmentType = service.getAdjustmentTypeById('AgencyAdjustmentGroupEntryID', adjustmentLabelObj.AgencyAdjustmentGroupEntryID, adjustmentTypesArr);

				if (!adjustmentLabelObj.adjustmentType) {
					return;
				}

				return adjustmentLabelObj;
			});
		},

		decorateNewAdjustmentObj: (newAdjustmentObj) => {

			// Set to set preselected option and avoid empty select box selection
			newAdjustmentObj.RecurringPeriodCount = newAdjustmentObj.RecurringPeriodCount !== 0 ? newAdjustmentObj.RecurringPeriodCount : 1;

			return newAdjustmentObj;
		},

		getAdjustmentBehaviourForBool: bool => {

			return bool ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		getAdjustmentPercentageValue: adjustmentObj => {

			if (!adjustmentObj.Units || !adjustmentObj.UnitValue) {
				return;
			}

			return (adjustmentObj.Units * adjustmentObj.UnitValue) / 100;
		},

		getAdjustmentsFilterByKey: function (filterKey) {

			switch (filterKey) {
				case 'deductions':
					return function (value) {
						return value.IsDeduction;
					};
				case 'additions':
					return function (value) {
						return !value.IsDeduction;
					};
				default:
					return function (value) {
						return value;
					};
			}
		},

		getAdjustmentTypeById: (propertyName, adjustmentId, adjustmentTypesArray) => {

			var index = utilities.getArrayItemIndexByPropertyName(adjustmentTypesArray, propertyName, adjustmentId);

			// Fallback to Parent ID
			if (index === null || index === undefined) {
				index = utilities.getArrayItemIndexByPropertyName(adjustmentTypesArray, 'AgencyAdjustmentParentGroupEntryID', adjustmentId);
			}

			if (index === null || index === undefined) {
				$rootScope.paycircleMessage('Adjustments Service > Unable to load adjustment type by ID, label removed from array', 'info');
				return null;
			}

			return angular.copy(adjustmentTypesArray[index]);
		},

		getAdjustmentTypesForImportMappingType: function (adjustmentTypesArr, importMappingType) {

			switch (importMappingType) {

				// Absolute / Unit / Linked adjustments
				case IMPORT_MAPPING_TYPES.payElements:
				case IMPORT_MAPPING_TYPES.payElementsRecurring:
				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
					return adjustmentTypesArr.filter(_ => {
						return _.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.absolute || _.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.unit || _.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.linked;
					});

				// Unit adjustments only
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
					return adjustmentTypesArr.filter(_ => {
						return _.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.unit;
					});

				// Linked adjustments only
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
					return adjustmentTypesArr.filter(_ => {
						return _.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.linked;
					});

				default:
					$rootScope.paycircleMessage('adjustmentsService.getAdjustmentTypesForImportMappingType: Import mapping type is not defined so no pay elements are returned', 'warn');
					return [];
			}
		},

		getAdjustmentTypesFromAdjustmentGroups: function (adjustmentGroupEntries) {

			var i = 0;
			var numberOfGroupEntries = adjustmentGroupEntries.length;
			var returnArray = [];

			for (i; i < numberOfGroupEntries; i++) {
				returnArray = returnArray.concat(adjustmentGroupEntries[i].GroupEntries);
			}

			return returnArray;
		},

		getAdjustmentTypesCounts: function (adjustmentTypes) {

			var returnObj = {
				totalAdditions: 0,
				totalDeductions: 0
			};

			adjustmentTypes.forEach(function (adjustmentTypeObj) {
				adjustmentTypeObj.IsDeduction ? returnObj.totalDeductions++ : returnObj.totalAdditions++;
			});

			return returnObj;
		},

		getAdjustmentTypesByContextKey: (adjustmentGroupObj, companyObj, contextKey) => {

			let adjustmentTypesArr = service.getAdjustmentTypesForCompany(adjustmentGroupObj, companyObj);

			switch (contextKey) {

				// Absolute & Units
				case 'link-elements':
					return adjustmentTypesArr.filter(_ => [ADJUSTMENT_VALUE_TYPES.absolute, ADJUSTMENT_VALUE_TYPES.unit].includes(_.AgencyAdjustmentValueType));

				// Units only
				case 'link-element-imports':
					return adjustmentTypesArr.filter(_ => [ADJUSTMENT_VALUE_TYPES.unit].includes(_.AgencyAdjustmentValueType));

				// None
				default:
					return [];
			}
		},

		getAdjustmentTypesForCompany: function (adjustmentGroupObj, companyObj) {

			let returnArr = [];

			var adjustmentTypesPayrollArr = service.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntries);
			var adjustmentTypesCISArr = service.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntriesCIS);

			// Payroll or Pension
			if (companyObj.IsPayrollActive || companyObj.IsPensionActive) {
				returnArr = returnArr.concat(adjustmentTypesPayrollArr);
			}

			// CIS
			if (companyObj.IsCISActive) {
				returnArr = returnArr.concat(adjustmentTypesCISArr);
			}

			return service.decorateAdjustmentTypes(returnArr);
		},

		getAdjustmentUnitValue: adjustmentObj => {

			if (adjustmentObj.Units <= 0 || adjustmentObj.UnitValue <= 0) {
				return;
			}

			const value = (adjustmentObj.Units * adjustmentObj.UnitValue) * adjustmentObj.UnitValueMultiplier;

			return Math.round(value * 100) / 100;
		},

		getAgencyAdjustmentGroupEntryId: adjustmentTypeObj => {

			// Use parent group ID if empty guid (= top level adjustment type)
			return adjustmentTypeObj.AgencyAdjustmentGroupEntryID !== config.guidEmpty ? adjustmentTypeObj.AgencyAdjustmentGroupEntryID : adjustmentTypeObj.AgencyAdjustmentParentGroupEntryID;
		},

		// Convert adjustment types into single array
		getAllAdjustmentTypesFromAdjustmentGroup: (adjustmentGroupObj, adjustmentTypesKey) => {

			let adjustmentTypesPAYEArr = service.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntries);
			let adjustmentTypesCISArr = service.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntriesCIS);
			let adjustmentTypesDeemedArr = service.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntriesDeemed);

			switch (adjustmentTypesKey) {

				// Deemed only
				case 'deemed':
					return adjustmentTypesDeemedArr;

				// CIS only
				case 'cis':
					return adjustmentTypesCISArr;

				// PAYE only
				case 'paye':
					return adjustmentTypesPAYEArr;

				// CIS & PAYE
				default:
					return adjustmentTypesPAYEArr.concat(adjustmentTypesCISArr);
			}
		},

		/**
		 * Build a breakdown string for an adjustment, (typically used for display on a payslip)
		 * This will include stuff like a multiplier, a base value, an exchange rate, where applicable.
		 * @param {Adjustment} adjustmentObj - adjustment from which to derive breakdown
		 */
		getDetailForAdjustment: (adjustmentObj) => {

			let breakdown = '';
			let adjustmentValue = '';
			let adjustmentUnitValue = '';

			// Build currency info for insertion if required
			if (adjustmentObj.AdjustmentHasCurrency) {
				const currencyInfo = ` ${adjustmentObj.AdjustmentCurrencyLabel} (Ex. ${adjustmentObj.AdjustmentCurrencyValue})`;
				// Values are in a foreign currency
				adjustmentValue = `${adjustmentObj.AdjustmentForeignValue} ${currencyInfo}`;
				adjustmentUnitValue = `${adjustmentObj.AdjustmentForeignUnitValue} ${currencyInfo}`;
			}
			else {
				// Values are in GBP
				adjustmentValue = `${$filter('monetise')(adjustmentObj.AdjustmentValue)}`;
				adjustmentUnitValue = `${$filter('monetise')(adjustmentObj.AdjustmentUnitValue)}`;
			}

			if (adjustmentObj.AdjustmentDisplayUnits) {
				breakdown += `${adjustmentObj.AdjustmentUnits}`;
				breakdown += ` @ ${adjustmentUnitValue}`;
				if (adjustmentObj.AdjustmentUnitValueMultiplier !== 1) {
					breakdown += ` x ${adjustmentObj.AdjustmentUnitValueMultiplier}`;
				}
			}
			else if (adjustmentObj.ValueType === ADJUSTMENT_VALUE_TYPES.percentage) {
				breakdown = `${adjustmentUnitValue} @ ${adjustmentObj.AdjustmentUnits}%`;
			}
			else if (adjustmentObj.AdjustmentHasCurrency) {
				breakdown = adjustmentValue;
			}

			return breakdown;
		},

		getChangeCreatorVm: (overrideOptionsObj) => {

			const SEARCH_RESULTS_INCREMENT_COUNT = 20;
			const SEARCH_RESULTS_LIMIT = 20;
			const SEARCH_TERM_MIN_COUNT = 3;

			return angular.extend({
				ADJUSTMENT_VALUE_TYPES: ADJUSTMENT_VALUE_TYPES,
				CAN_ADD_DEPARTMENT_CHANGES: false,
				CAN_APPLY_TO_ALL: false, // Displays a toggle whether to apply the adjustment to all team members in context
				CAN_ATTACH_PENSION_SCHEME: false,
				CAN_EDIT_ADJUSTMENT: true,
				CAN_MANAGE_TEAM_MEMBERS: true, // Once a team member is selected (or pre-selected) they cannot be removed
				IS_ADJUSTMENT_AMOUNT_APPLICABLE: true,
				IS_ADJUSTMENT_PREVIEW_ENABLED: true,
				IS_APPLICABLE_TO_TEAM_MEMBERS: true,
				IS_PAYSLIP_LABEL_ENABLED: true,
				IS_PENSION_SUBMITTED: false,
				IS_RECURRING_ENABLED: false,
				IS_SET_TO_SALARY_ENABLED: false,
				IS_TAX_TREATMENT_ENABLED: true,
				MAX_TEAM_MEMBERS: 1,
				PAY_ELEMENT_LABEL: 'Type of change',
				PAY_ELEMENT_LABEL_PLACEHOLDER: 'Search for a change or payslip label',
				PAYMENT_TYPES,
				SEARCH_RESULTS_LIMIT: SEARCH_RESULTS_LIMIT,
				SEARCH_RESULTS_LIMIT_ADJUSTMENT_TYPES: SEARCH_RESULTS_LIMIT,
				SEARCH_RESULTS_LIMIT_DEPARTMENT: SEARCH_RESULTS_LIMIT,
				SEARCH_RESULTS_LIMIT_TEAM: SEARCH_RESULTS_LIMIT,
				SEARCH_RESULTS_INCREMENT_COUNT: SEARCH_RESULTS_INCREMENT_COUNT,
				SEARCH_TERM_MIN_COUNT: SEARCH_TERM_MIN_COUNT,
				adjustmentLabels: [],

				adjustmentTypes: [],
				adjustmentTypesCategories: [],
				adjustmentTypesCategoryKey: '',
				adjustmentTypesFiltered: [],
				adjustmentTypesOriginal: [],

				adjustmentTypeSearchFilter: (v) => { return v; },
				calculationViewState: 'calculated',
				departments: [],
				departmentsFiltered: [],
				labelFilter: null,
				newAdjustment: null,
				payPeriod: null,
				payPeriods: [],
				recurForXPayPeriods: false,
				recurringPayPeriodDisplay: '',
				saveLabel: false,
				searchTermAdjustmentLabels: '',
				searchTermAdjustmentLabelsFocused: false,
				searchTermAdjustmentTypes: '',
				searchTermAdjustmentTypesFocused: false,
				searchTermTeamMembers: '',
				searchTermTeamMembersFocused: false,
				selectedAdjustmentLabel: null,
				selectedAdjustmentLabelSave: false,
				selectedAdjustmentType: null,
				selectedAdjustmentTypeName: null,
				selectedPayPeriodId: null,
				selectedTeamMembers: [],
				showPayslipLabelResults: false,
				showTaxTreatment: false,
				teamDescriptionLabel: '',
				teamMembers: [],
				teamMembersFiltered: [],
				userId: null
			}, overrideOptionsObj);
		},

		getGrossUpAdjustmentsForPayslip: payslipObj => {

			const grossUpAdjustmentsArr = [
				{
					label: 'Gross up for Tax',
					value: payslipObj.GrossUpTax
				},
				{
					label: 'Gross up for NI',
					value: payslipObj.GrossUpNI
				},
				{
					label: 'Gross up for Student Loan',
					value: payslipObj.GrossUpStudentLoan
				},
				{
					label: 'Gross up for Postgraduate Loan',
					value: payslipObj.GrossUpPostgraduateLoan
				},
				{
					label: 'Gross up for Pension',
					value: payslipObj.GrossUpPension
				},
				{
					label: 'Gross up for Attachment of Earnings',
					value: payslipObj.GrossUpAoE
				},
			];

			return grossUpAdjustmentsArr.filter(adjustmentObj => adjustmentObj.value !== 0);
		},

		getIconForAdjustment: adjustment => {

			switch (adjustment.AdjustmentDetailID) {
				case ADJUSTMENT_TYPES.cisPayment:
				case ADJUSTMENT_TYPES.costOfMaterials:
					return 'wallet';
				case ADJUSTMENT_TYPES.expenses:
					return 'receipt';
				case ADJUSTMENT_TYPES.adoptionPay:
				case ADJUSTMENT_TYPES.maternityPay:
				case ADJUSTMENT_TYPES.occupationalAdoptionPay:
				case ADJUSTMENT_TYPES.occupationalMaternityPay:
				case ADJUSTMENT_TYPES.occupationalPaternityPay:
				case ADJUSTMENT_TYPES.occupationalSharedParentalPay:
				case ADJUSTMENT_TYPES.paternityPay:
				case ADJUSTMENT_TYPES.sharedParentalPay:
				case REPAYMENT_SCHEDULE_TYPES.adoptionPay:
				case REPAYMENT_SCHEDULE_TYPES.maternityPay:
				case REPAYMENT_SCHEDULE_TYPES.occupationalAdoptionPay:
				case REPAYMENT_SCHEDULE_TYPES.occupationalMaternityPay:
				case REPAYMENT_SCHEDULE_TYPES.occupationalPaternityPay:
				case REPAYMENT_SCHEDULE_TYPES.occupationalSharedParentalPay:
				case REPAYMENT_SCHEDULE_TYPES.paternityPay:
				case REPAYMENT_SCHEDULE_TYPES.sharedParentalPay:
					return 'maternity';
				case ADJUSTMENT_TYPES.occupationalSickPay:
				case ADJUSTMENT_TYPES.sickPay:
				case REPAYMENT_SCHEDULE_TYPES.occupationalSickPay:
				case REPAYMENT_SCHEDULE_TYPES.sickPay:
					return 'sick';
				case REPAYMENT_SCHEDULE_TYPES.carBenefitInKind:
					return 'company-vehicle';
				case REPAYMENT_SCHEDULE_TYPES.companyLoan:
					return 'company';
				case REPAYMENT_SCHEDULE_TYPES.cycleToWorkScheme:
					return 'cycle-to-work';
				case REPAYMENT_SCHEDULE_TYPES.healthcare:
					return 'healthcare';
				case REPAYMENT_SCHEDULE_TYPES.seasonTicketLoan:
					return 'season-ticket';
				default:
					return adjustment.AdjustmentDeduction ? 'minus' : 'add';
			}
		},

		getIsAdjustmentBehaviourOffLocked: value => {

			switch (value) {
				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
					return true;
			}

			return false;
		},

		getIsAdjustmentBehaviourLocked: value => {

			switch (value) {
				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		getIsAdjustmentBehaviourOn: value => {

			switch (value) {
				case ADJUSTMENT_BEHAVIOUR_STATES.on:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		getTooltipsForAdjustment: adjustmentObj => {

			const returnArr = [];

			// Pension Adjustment
			if (adjustmentObj.AgencyEmployerPensionID !== config.guidEmpty && adjustmentObj.AdjustmentTooltip) {
				returnArr.push({
					text: adjustmentObj.AdjustmentTooltip,
					icon: 'icon-money'
				});
			}

			return returnArr;
		},

		/**
		 * Group adjustments according to SalaryPolicyPostID. Used for multiple posts, to distinguish them in the UI.
		 * @param {Adjustment[]} adjustmentsArr
		 * @return {adjustmentGroup[]} - group adjustments. The adjustmentGroup type is a simple UI constuct:
		 * 	adjustmentGroup: {
		 * 		name: {string} - the name of the group
		 * 		adjustments: {Adjustment[]} - the adjustments in this group
		 * 	}
		 */
		 groupAdjustmentsForMultiplePosts: adjustmentsArr => {
			const adjustmentGroups = [];
			adjustmentsArr.forEach(adjustment => {
				/* Create group object if it doesn't already exist. Use IsAdditionalPost to determine grouping:
				   non-additional-post adjustments are grouped together (main post), regardless of their raw SalaryPolicyPostID,
				   which may differ between pension and non-pension elements. */
				const postId = adjustment.IsAdditionalPost ? adjustment.SalaryPolicyPostID : config.guidEmpty;
				const postName = adjustment.IsAdditionalPost ? adjustment.SalaryPolicyPostTitle : '';

				let adjustmentGroup = adjustmentGroups.find(adjustmentGroup => adjustmentGroup.id === postId);
				if (angular.isUndefined(adjustmentGroup)) {
					adjustmentGroup = {
						id: postId,
						name: postName,
						adjustments: []
					};
					adjustmentGroups.push(adjustmentGroup);
				}

				// Add the adjustment to the group adjustments array
				adjustmentGroup.adjustments.push(adjustment);
			});

			return adjustmentGroups;
		},

		/**
		 * Validate associated adjustment object to make sure it is available to the user
		 * - Adjustment type might have been deleted
		 * - Adjustment type might not be available to the user
		**/
		isAdjustmentTypeValid: (adjustmentGroupEntryId, adjustmentTypesArr, propertyName) => {

			if (!validationService.isEmptyGuid(adjustmentGroupEntryId)) {

				const selectedAdjustmentTypeObj = service.getAdjustmentTypeById(propertyName, adjustmentGroupEntryId, adjustmentTypesArr);

				if (!selectedAdjustmentTypeObj) {
					return false;
				}
			}

			return true;
		},

		resetNewAdjustmentValues: newAdjustmentObj => {

			newAdjustmentObj.Units = newAdjustmentObj.Units !== '' ? newAdjustmentObj.Units : 0;
			newAdjustmentObj.Value = newAdjustmentObj.Value !== '' ? newAdjustmentObj.Value : 0;
			newAdjustmentObj.UnitValue = newAdjustmentObj.UnitValue !== '' ? newAdjustmentObj.UnitValue : 0;

			return newAdjustmentObj;
		},

		selectSalaryRate: (adjustmentTypeObj, newAdjustmentObj) => {

			if (!newAdjustmentObj.selectedRate) {
				return;
			}

			newAdjustmentObj.Units = angular.copy(newAdjustmentObj.selectedRate.SalaryRateHours);
			newAdjustmentObj.UnitValue = angular.copy(newAdjustmentObj.selectedRate.SalaryRateValue);
			newAdjustmentObj.UnitValueMultiplier = angular.copy(adjustmentTypeObj.Multiplier);
			newAdjustmentObj.UserPayElementIsSalaryDerivedRatedElement = false;		
			newAdjustmentObj.RateType = newAdjustmentObj.selectedRate.RateType;

			if (newAdjustmentObj.selectedRate && salaryService.getSalaryRateTypeIsSalaryDerivedRate(newAdjustmentObj.selectedRate)) {
				newAdjustmentObj.UserPayElementIsSalaryDerivedRatedElement = true;
			}
		},

		setDefaultAdjustmentValues: (adjustmentTypeObj, newAdjustmentObj) => {

			switch (adjustmentTypeObj.AgencyAdjustmentValueType) {
				case ADJUSTMENT_VALUE_TYPES.unit:
					newAdjustmentObj.Units = '';
					newAdjustmentObj.UnitValue = '';
					newAdjustmentObj.UnitValueMultiplier = 1;
					newAdjustmentObj.Value = 0;
					break;
				case ADJUSTMENT_VALUE_TYPES.absolute:
					newAdjustmentObj.Units = 0;
					newAdjustmentObj.UnitValue = '';
					newAdjustmentObj.UnitValueMultiplier = 1;
					newAdjustmentObj.Value = '';
					break;
				case ADJUSTMENT_VALUE_TYPES.percentage:
					newAdjustmentObj.Units = '';
					newAdjustmentObj.UnitValue = '';
					newAdjustmentObj.UnitValueMultiplier = 1;
					newAdjustmentObj.Value = 0;
					break;
				case ADJUSTMENT_VALUE_TYPES.linked:
					newAdjustmentObj.Units = '';
					newAdjustmentObj.UnitValue = '';
					newAdjustmentObj.UnitValueMultiplier = '';
					newAdjustmentObj.Value = 0;
					break;
			}

			angular.extend(newAdjustmentObj, {
				selectedRate: null
			});
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('journalsService', [
	'$filter',
	'$rootScope',
	'config',
	'utilities',
	'JOURNAL_CODE_DELIMITER_TYPES',
	function (
		$filter,
		$rootScope,
		config,
		utilities,
		JOURNAL_CODE_DELIMITER_TYPES
	) {

	var service = {

		decorateBusinessCategories: (businessCategoriesArr, userAgencyProfileBusinessCodes, businessCodeCostSplit) => {

			// Start by setting all selected business categories to null; if they're not set, they will remain as such.
			businessCategoriesArr.forEach(businessCategory => {
				businessCategory.selectedBusinessCode = null;
				businessCategory.originalSelectedBusinessCodeId = config.guidEmpty;
				businessCategory.originalSelectedBusinessCodes = [];
			});

			// Get all business codes and match them with the selected business codes for this team member
			const businessCodesAllArr = service.getAllBusinessCodesForCategories(businessCategoriesArr);

			if (userAgencyProfileBusinessCodes) {

				userAgencyProfileBusinessCodes.forEach(teamMemberBusinessCodeObj => {

					// Find the source business code object
					const selectedBusinessCodeObj = businessCodesAllArr.find(businessCodeObj => businessCodeObj.BusinessCodeID === teamMemberBusinessCodeObj.BusinessCodeID);

					// Find the business category to attach to
					const businessCategory = businessCategoriesArr.find(businessCategoryObj => businessCategoryObj.BusinessCategoryID === selectedBusinessCodeObj.BusinessCategoryID);

					// Attach selected to the business category.
					businessCategory.selectedBusinessCode = selectedBusinessCodeObj;

					// Also attach the user business codes from the cost splits (which will include the primary business code) so that they can be archived if necessary
					if (angular.isDefined(businessCodeCostSplit) && businessCodeCostSplit.BusinessCategoryID === businessCategory.BusinessCategoryID) {
						businessCategory.originalSelectedBusinessCodes.push(...businessCodeCostSplit.UserAgencyProfileBusinessCodes);
						businessCategory.hasCostSplit = true;
					} else {
						businessCategory.originalSelectedBusinessCodes.push(teamMemberBusinessCodeObj);
						businessCategory.hasCostSplit = false;
					}

					/* Hang on to a copy of the selected business code if there is one. This is required since, if changed, the old needs to be archived,
					rather than deleted */
					if (angular.isDefined(selectedBusinessCodeObj)) {
						businessCategory.originalSelectedBusinessCodeId = selectedBusinessCodeObj.BusinessCodeID;
					} else {
						businessCategory.originalSelectedBusinessCodeId = config.guidEmpty;
					}

					/* Include unique ID for this company business code, for updates. Also hold onto the department ID. This needs to be maintained for data integrity when changing 'Department' from
					a selected business code to '-- None --'. */
					businessCategory.UserAgencyProfileBusinessCodeID = teamMemberBusinessCodeObj.UserAgencyProfileBusinessCodeID;
					businessCategory.UserAgencyProfileDepartmentID = teamMemberBusinessCodeObj.UserAgencyProfileDepartmentID;
				});
			}

			return businessCategoriesArr.filter(businessCategory => businessCategory.BusinessCodes.length > 0);
		},

		decorateBusinessCodesWithBusinessCategories: (businessCodesArr, businessCategoriesArr) => {

			const businessCodesAllArr = service.getAllBusinessCodesForCategories(businessCategoriesArr);

			businessCodesArr.forEach(businessCodeObj => {

				businessCodeObj.businessCodeDetail = service.getBusinessCodeDetailForTeamMemberBusinessCode(businessCodesAllArr, businessCodeObj.BusinessCodeID);

				businessCategoriesArr.forEach(businessCategoryObj => {

					if (businessCodeObj.BusinessCategoryID === businessCategoryObj.BusinessCategoryID) {
						businessCodeObj.businessCategory = angular.copy(businessCategoryObj);
					}
				});
			});
		},

		getOnlySelectedBusinessCodesFromBusinessCategories: (businessCategoriesArr, emptyUserAgencyProfileBusinessCode) => {

			let returnArr = [];

			if (angular.isDefined(businessCategoriesArr) && businessCategoriesArr !== null) {
	
				businessCategoriesArr.forEach(businessCategoryObj => {

					if (businessCategoryObj.selectedBusinessCode) {

						// Create a new record for the business code
						const newUserAgencyProfileBusinessCode = angular.copy(emptyUserAgencyProfileBusinessCode);

						angular.extend(newUserAgencyProfileBusinessCode, {
							BusinessCategoryID: businessCategoryObj.BusinessCategoryID,
							BusinessCodeID: businessCategoryObj.selectedBusinessCode.BusinessCodeID,
							UserAgencyProfileBusinessCodeArchived: false,		// New business code allocation
							UserAgencyProfileBusinessCodePrimary: true,
							// This will create a new record. The platform will archive any existing code for this category automagically.
							UserAgencyProfileBusinessCodeID: config.guidEmpty
						});

						// Add to array for return
						returnArr.push(newUserAgencyProfileBusinessCode);
					}
				});
			}

			return returnArr;
		},

		decorateEmptyUserAgencyProfileBusinessCode: (emptyUserAgencyProfileBusinessCodeRet, agencyProfileId, userId, salaryPolicyPostId) => {

			return angular.extend({}, emptyUserAgencyProfileBusinessCodeRet, {
				AgencyProfileID: agencyProfileId,
				SalaryPolicyPostID: salaryPolicyPostId,
				UserID: userId,
				UserAgencyProfileBusinessCodeArchived: false,
				UserAgencyProfileBusinessCodePercent: 0
			});
		},

		decorateJournalCodeFormat: journalCodeFormatObj => {

			let delimiterChar = '';

			switch (journalCodeFormatObj.JournalCodeFormatDelimiter) {
				case JOURNAL_CODE_DELIMITER_TYPES.dash:
					delimiterChar = '-';
					break;
				case JOURNAL_CODE_DELIMITER_TYPES.space:
					delimiterChar =  '\xa0'; // Non-breakable space is char 0xa0 (160 dec)
					break;
				case JOURNAL_CODE_DELIMITER_TYPES.forwardSlash:
					delimiterChar = '/';
					break;
			}

			angular.extend(journalCodeFormatObj, {
				isDelimited: journalCodeFormatObj.JournalCodeFormatDelimiter !== JOURNAL_CODE_DELIMITER_TYPES.none,
				delimiterChar
			});

			return journalCodeFormatObj;
		},

		decorateJournalCodeFormats (journalCodeFormatObj, journalCodesArr) {

			journalCodesArr.forEach((journalCodeFormatItemObj, $index) => {

				const journalCodeFormatItemValue = journalCodeFormatObj[journalCodeFormatItemObj.key];

				angular.extend(journalCodeFormatItemObj, {
					isActive: journalCodeFormatItemValue > -1,
					isHidden: journalCodeFormatItemValue === -1,
					originalIndex: $index,
					value: journalCodeFormatItemValue
				});
			});

			return service.sortJournalCodesByValue(journalCodesArr);
		},

		generateFullJournalCodePreview: (journalCodesActiveArr) => {

			journalCodesActiveArr.forEach(journalCodeObj => {
				journalCodeObj.preview = service.getJournalCodeObjPreview(journalCodeObj);
			});
		},

		getAllBusinessCodesForCategories: (businessCategoriesArr) => {

			let returnArr = [];

			businessCategoriesArr.forEach(businessCategoryObj => {
				returnArr = returnArr.concat(businessCategoryObj.BusinessCodes);
			});

			return returnArr;
		},

		getBusinessCategoryObjById: (businessCategoriesArr, businessCategoryId) => {

			return businessCategoriesArr.find(businessCategoryObj => businessCategoryObj.BusinessCategoryID === businessCategoryId);
		},

		getBusinessCategoryValueById: (businessCategoriesArr, businessCategoryId) => {

			const businessCategoryObj = service.getBusinessCategoryObjById(businessCategoriesArr, businessCategoryId);

			if (angular.isUndefined(businessCategoryObj)) {
				return 'xx';
			}

			if (businessCategoryObj.BusinessCodes.length) {
				return businessCategoryObj.BusinessCodes[0].BusinessCodeValue;
			}

			return 'xx';
		},

		getBusinessCodeDetailForTeamMemberBusinessCode: (businessCodesAllArr, businessCodeId) => {

			const activeBusinessCodeObj = businessCodesAllArr.find(businessCodeObj => businessCodeObj.BusinessCodeID === businessCodeId);

			if (!activeBusinessCodeObj) {
				$rootScope.paycircleMessage('Unable to get business code narrative for business code');
				return;
			}

			return activeBusinessCodeObj;
		},

		getBusinessCodesFromBusinessCategories: (businessCategoriesArr, emptyUserAgencyProfileBusinessCode, businessCodeCostSplit) => {

			let returnArr = [];
			let costSplitBusinessCategoryId = null;

			// Map cost split
			if (angular.isDefined(businessCodeCostSplit) && angular.isDefined(businessCodeCostSplit.UserAgencyProfileBusinessCodes) && businessCodeCostSplit.UserAgencyProfileBusinessCodes !== null) {

				costSplitBusinessCategoryId = businessCodeCostSplit.BusinessCategoryID;

				for (let costSplitBusinessCode of businessCodeCostSplit.UserAgencyProfileBusinessCodes) {

					if (costSplitBusinessCode.UserAgencyProfileBusinessCodeID !== config.guidEmpty) {
						continue;
					}

					costSplitBusinessCode.UserAgencyProfileBusinessCodePercent = parseFloat(costSplitBusinessCode.UserAgencyProfileBusinessCodePercent) || 0;

					returnArr.push(costSplitBusinessCode);
				}
			}

			businessCategoriesArr.forEach(businessCategoryObj => {

				const userAgencyProfileBusinessCodes = [];

				// Has this business code changed in any way?
				if (service.hasBusinessCodeChanged(businessCategoryObj)) {

					// If the business code has changed, we need to archive the old records
					businessCategoryObj.originalSelectedBusinessCodes.forEach(originalSelectedBusinessCode => {
						// Create a blank business code record for amending
						const userAgencyProfileBusinessCode = angular.copy(emptyUserAgencyProfileBusinessCode);

						angular.extend(userAgencyProfileBusinessCode, originalSelectedBusinessCode, {
							UserAgencyProfileBusinessCodeArchived: true
						});

						userAgencyProfileBusinessCodes.push(userAgencyProfileBusinessCode);
					});

					if(businessCategoryObj.selectedBusinessCode) {

						const userAgencyProfileBusinessCode = returnArr.find(businessCode => businessCode.BusinessCodeID === businessCategoryObj.selectedBusinessCode.BusinessCodeID);

						// Add the new business code to the array if it isn't already in it (ie. part of a new cost split)
						if (!angular.isDefined(userAgencyProfileBusinessCode) || userAgencyProfileBusinessCode === null) {

							// create a new record for the new business code
							const newUserAgencyProfileBusinessCode = angular.copy(emptyUserAgencyProfileBusinessCode);

							angular.extend(newUserAgencyProfileBusinessCode, {
								BusinessCategoryID: businessCategoryObj.BusinessCategoryID,
								BusinessCodeID: businessCategoryObj.selectedBusinessCode.BusinessCodeID,
								UserAgencyProfileBusinessCodeArchived: false,		// New business code allocation
								UserAgencyProfileBusinessCodePrimary: true,
								// This will create a new record. The platform will archive any existing code for this category automagically.
								UserAgencyProfileBusinessCodeID: config.guidEmpty
							});

							userAgencyProfileBusinessCodes.push(newUserAgencyProfileBusinessCode);
						}
					}
				}
				else if (businessCategoryObj.hasCostSplit && businessCategoryObj.BusinessCategoryID !== costSplitBusinessCategoryId && businessCategoryObj.selectedBusinessCode) {
					// If a business category had a cost split but not longer has one AND it is keeping the same business code, we need to create a new record

					// Create a blank business code record
					const userAgencyProfileBusinessCode = angular.copy(emptyUserAgencyProfileBusinessCode);

					angular.extend(userAgencyProfileBusinessCode, {
						BusinessCategoryID: businessCategoryObj.BusinessCategoryID,
						BusinessCodeID: businessCategoryObj.selectedBusinessCode.BusinessCodeID,
						UserAgencyProfileBusinessCodeArchived: false,		// New business code allocation
						UserAgencyProfileBusinessCodePrimary: true,
						// This will create a new record. The platform will archive any existing code for this category automagically.
						UserAgencyProfileBusinessCodeID: config.guidEmpty
					});

					userAgencyProfileBusinessCodes.push(userAgencyProfileBusinessCode);
				}

				// Add to array for return
				returnArr.push(...userAgencyProfileBusinessCodes);
			});

			return returnArr;
		},

		getEmptyUserAgencyProfileBusinessCode: (agencyProfileID, userID, businessCategoryObj) => {
			return {
				AgencyProfileID: agencyProfileID,
				BusinessCategoryID: businessCategoryObj.BusinessCategoryID,
				BusinessCodeID: null,
				SalaryPolicyPostID: config.guidEmpty,
				UserAgencyProfileBusinessCodeArchived: false,
				UserAgencyProfileBusinessCodeID: config.guidEmpty,
				UserAgencyProfileBusinessCodePercent: 0,
				UserAgencyProfileBusinessCodePrimary: false,
				UserAgencyProfileDepartmentID: businessCategoryObj.UserAgencyProfileDepartmentID,
				UserID: userID
			};
		},

		getEmptyUserAgencyProfileBusinessCodes: userId => {

			return {
				BusinessCodeCostSplit: {
					BusinessCategoryID: config.guidEmpty,
					UserAgencyProfileBusinessCodes: []
				},
				UserAgencyProfileBusinessCodes: [],
				UserID: userId,
			};
		},

		getFirstNominalCodeValue: nominalCodesArr => {

			if (nominalCodesArr.length > 0) {
				return nominalCodesArr[0].NominalCodeValue;
			}

			return 'xx';
		},

		getJournalCodeObjPreview: (journalCodeObj) => {

			return journalCodeObj.abbr;
		},

		getJournalCodesByFormat: journalCodeFormatObj => {

			let journalCodesArr = [
				{
					name: 'Nominal code',
					abbr: 'NC',
					key: 'JournalCodeFormatNominalCodePosition'
				},
				{
					name: 'Branch',
					abbr: 'BR',
					key: 'JournalCodeFormatBranchPosition'
				},
				{
					name: 'Cost Centre',
					abbr: 'CC',
					key: 'JournalCodeFormatCostCentrePosition'
				},
				{
					name: 'Department',
					abbr: 'DPT',
					key: 'JournalCodeFormatDepartmentPosition'
				},
				{
					name: 'Sector',
					abbr: 'SEC',
					key: 'JournalCodeFormatSectorPosition'
				},
				{
					name: 'Role',
					abbr: 'ROLE',
					key: 'JournalCodeFormatRolePosition'
				},
				{
					name: 'Payroll ID',
					abbr: 'PID',
					key: 'JournalCodeFormatEmployeeIDPosition'
				}
			];

			return service.decorateJournalCodeFormats(journalCodeFormatObj, journalCodesArr);
		},

		hasBusinessCodeChanged: businessCategoryObj => {

			return (
				(
					!businessCategoryObj.selectedBusinessCode &&
					businessCategoryObj.originalSelectedBusinessCodeId !== config.guidEmpty
				) ||
				(
					businessCategoryObj.selectedBusinessCode &&
					businessCategoryObj.selectedBusinessCode.BusinessCodeID !== businessCategoryObj.originalSelectedBusinessCodeId
				)
			);
		},

		isBusinessCategoriesInvalid: (adjustment) => {

			// Check if overrideBusinessCategories set to true
			const hasOverrideBusinessCategories = adjustment.overrideBusinessCategories === true;
	
			// Check if there are no Business Codes set
			const allBusinessCategoriesHaveNoBusinessCodes = adjustment.businessCategories.every(businessCategory => businessCategory.BusinessCodes.length === 0);
	
			// Check based on the toggle if at least 1 business code has been set
			const allBusinessCodesNotSet = adjustment.businessCategories.every(businessCategory => !businessCategory.selectedBusinessCode);
	
			return hasOverrideBusinessCategories && (allBusinessCategoriesHaveNoBusinessCodes || allBusinessCodesNotSet);
		},

		sortJournalCodesByValue: journalCodesArr => {

			return $filter('orderBy')(journalCodesArr, 'value');
		},

		sortNominalCodes: (nominalCodesArr) => {

			return nominalCodesArr.sort(utilities.comparator('NominalCodeValue', true));
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('onboardingService', ['$rootScope', 'config', 'utilities', 'COMPANY_STATES', 'DEMO_QUESTION_GROUPS', 'ONBOARDING_QUESTION_GROUPS', 'ONBOARDING_QUESTIONS', function ($rootScope, config, utilities, COMPANY_STATES, DEMO_QUESTION_GROUPS, ONBOARDING_QUESTION_GROUPS, ONBOARDING_QUESTIONS) {

	var service = {

		decorateCompanyOnboardingQuestions: function (onboardingQuestionObj) {

			onboardingQuestionObj.formStep = 0;
			onboardingQuestionObj.showBlock = true;
			onboardingQuestionObj.QuestionName = onboardingQuestionObj.QuestionName.replace(' ?', '?');

			// Company
			switch (onboardingQuestionObj.TaskID) {

				// Step 1
				case ONBOARDING_QUESTIONS.company.companyType:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.company.companyNumber:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 2;
					break;
				case ONBOARDING_QUESTIONS.company.numberOfDirectors:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 3;
					break;

				// Step 2
				case ONBOARDING_QUESTIONS.company.employmentTypes:
					onboardingQuestionObj.formStep = 2;
					onboardingQuestionObj.order = 4;
					break;
				case ONBOARDING_QUESTIONS.company.salaryTypes:
					onboardingQuestionObj.formStep = 2;
					onboardingQuestionObj.order = 5;
					break;

				// Step 3
				case ONBOARDING_QUESTIONS.company.accountsOfficeReference:
					onboardingQuestionObj.formStep = 3;
					onboardingQuestionObj.order = 6;
					break;
				case ONBOARDING_QUESTIONS.company.payeReference:
					onboardingQuestionObj.formStep = 3;
					onboardingQuestionObj.order = 7;
					break;

				// Step 4
				case ONBOARDING_QUESTIONS.company.electronicUpdates:
					onboardingQuestionObj.formStep = 4;
					onboardingQuestionObj.order = 8;
					onboardingQuestionObj.valueType = 'boolean';
					break;
				case ONBOARDING_QUESTIONS.company.hmrcCredentials:
					onboardingQuestionObj.formStep = 4;
					onboardingQuestionObj.order = 8;
					onboardingQuestionObj.valueType = 'hmrc-credentials';
					break;
			}

			// Profile
			switch (onboardingQuestionObj.TaskID) {

				// Step 1
				case ONBOARDING_QUESTIONS.profile.relationshipToCompany:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.profile.payrollExperience:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 2;
					break;

				// Step 2
				case ONBOARDING_QUESTIONS.profile.payrollInvolvement:
					onboardingQuestionObj.formStep = 2;
					onboardingQuestionObj.order = 3;
					break;

				// Step 3
				case ONBOARDING_QUESTIONS.profile.existingPayrollSoftware:
					onboardingQuestionObj.formStep = 3;
					onboardingQuestionObj.order = 4;
					break;
				case ONBOARDING_QUESTIONS.profile.payrollComplexityRating:
					onboardingQuestionObj.formStep = 3;
					onboardingQuestionObj.order = 5;
					break;

				// Step 4
				case ONBOARDING_QUESTIONS.profile.activeModules:
					onboardingQuestionObj.formStep = 4;
					onboardingQuestionObj.order = 6;
					break;

				// Step 5
				case ONBOARDING_QUESTIONS.profile.hasExternalAdvisor:
					onboardingQuestionObj.formStep = 5;
					onboardingQuestionObj.order = 7;
					break;
				case ONBOARDING_QUESTIONS.profile.externalAdvisorInvolvement:
					onboardingQuestionObj.formStep = 5;
					onboardingQuestionObj.order = 8;
					break;
				case ONBOARDING_QUESTIONS.profile.preferredGoLiveDate:
					onboardingQuestionObj.formStep = 5;
					onboardingQuestionObj.order = 9;
					break;
			}

			// Payroll
			switch (onboardingQuestionObj.TaskID) {
				case ONBOARDING_QUESTIONS.payroll.payPeriods:
					onboardingQuestionObj.formStep = 0;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.payPeriodsMonth:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.payslipDeliveryMethod:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 1;
					onboardingQuestionObj.valueType = 'payslip-delivery-method';
					break;
				case ONBOARDING_QUESTIONS.payroll.payslipLogo:
					onboardingQuestionObj.formStep = 1;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.payrollContactDetails:
					onboardingQuestionObj.formStep = 3;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.companyWorkWeekHours:
					onboardingQuestionObj.formStep = 4;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.smallEmployer:
					onboardingQuestionObj.formStep = 6;
					onboardingQuestionObj.order = 1;
					onboardingQuestionObj.valueType = 'boolean';
					break;
				case ONBOARDING_QUESTIONS.payroll.dayRateCalculationMethod:
					onboardingQuestionObj.formStep = 5;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.employmentAllowance:
					onboardingQuestionObj.formStep = 6;
					onboardingQuestionObj.order = 1;
					break;
				case ONBOARDING_QUESTIONS.payroll.directorsNiCalculationMethod:
					onboardingQuestionObj.formStep = 7;
					onboardingQuestionObj.order = 1;
					break;
			}

			return onboardingQuestionObj;
		},

		decorateOnboardingQuestionGroup: function (onboardingDashboardObj) {

			return function (onboardingQuestionGroup) {

				var numberOfQuestions = onboardingQuestionGroup.Questions.length;

				onboardingQuestionGroup.percentageComplete = 0;
				onboardingQuestionGroup.onboardingId = onboardingDashboardObj.OnboardingID;
				onboardingQuestionGroup.userId = onboardingDashboardObj.UserID;
				onboardingQuestionGroup.totalMandatoryQuestions = 0;
				onboardingQuestionGroup.groupSize = Math.ceil(numberOfQuestions / 2);
				onboardingQuestionGroup.totalQuestionsComplete = 0;
				onboardingQuestionGroup.totalQuestionsRemaining = numberOfQuestions;
				onboardingQuestionGroup.questionCountCopy = {
					'1': '1 question',
					'other': '{} questions'
				};

				// Calculate total complete/remaining
				onboardingQuestionGroup.Questions.forEach(function (onboardingQuestionObj) {

					if (onboardingQuestionObj.Mandatory) {
						onboardingQuestionGroup.totalMandatoryQuestions++;

						if (onboardingQuestionObj.Complete) {
							onboardingQuestionGroup.totalQuestionsComplete++;
							onboardingQuestionGroup.totalQuestionsRemaining--;
						}
					}
				});

				onboardingQuestionGroup.percentageComplete = Math.round((100 / onboardingQuestionGroup.QuestionsCount) * onboardingQuestionGroup.QuestionsComplete);
				onboardingQuestionGroup.isComplete = onboardingQuestionGroup.percentageComplete === 100;

				if (onboardingQuestionGroup.percentageComplete === 0) {
					onboardingQuestionGroup.buttonCopy = 'Get started';
				} else if (onboardingQuestionGroup.percentageComplete < 100 && onboardingQuestionGroup.percentageComplete > 0) {
					onboardingQuestionGroup.buttonCopy = 'Continue';
				} else {
					onboardingQuestionGroup.buttonCopy = 'Review';
				}

				onboardingQuestionGroup.Questions.filter(service.decorateCompanyOnboardingQuestions);

				switch (onboardingQuestionGroup.OnboardingQuestionGroupID) {

					// Onboarding
					case ONBOARDING_QUESTION_GROUPS.company:
						onboardingQuestionGroup.description = 'Add a couple of useful reference numbers for your company';
						onboardingQuestionGroup.icon = 'company';
						onboardingQuestionGroup.theme = 'assertive';
						onboardingQuestionGroup.timeToComplete = '4 mins';
						break;
					case ONBOARDING_QUESTION_GROUPS.payroll:
						onboardingQuestionGroup.copy = 'Add payroll changes and submit the data every pay period';
						onboardingQuestionGroup.description = 'Tell us how you like to run your payroll and pay your team';
						onboardingQuestionGroup.icon = 'clock';
						onboardingQuestionGroup.theme = 'quarternary';
						onboardingQuestionGroup.timeToComplete = '20 mins';
						break;
					case ONBOARDING_QUESTION_GROUPS.profile:
						onboardingQuestionGroup.description = 'Add basic info about you and your existing payroll set up';
						onboardingQuestionGroup.icon = 'setup-user';
						onboardingQuestionGroup.theme = 'tertiary';
						onboardingQuestionGroup.timeToComplete = '3 mins';
						break;
					case ONBOARDING_QUESTION_GROUPS.workplacePension:
						onboardingQuestionGroup.copy = 'Manage team assessment and contributions';
						onboardingQuestionGroup.description = 'Add your workplace pension and auto-enrolment settings';
						onboardingQuestionGroup.icon = 'money';
						onboardingQuestionGroup.theme = 'secondary';
						onboardingQuestionGroup.timeToComplete = '15 mins';
						break;


					// Demo
					case DEMO_QUESTION_GROUPS.cis:
						onboardingQuestionGroup.description = 'Add a couple of useful reference numbers for your company';
						onboardingQuestionGroup.hide = true;
						onboardingQuestionGroup.icon = 'cis';
						onboardingQuestionGroup.theme = 'primary';
						onboardingQuestionGroup.timeToComplete = '5 mins';
						break;
					case DEMO_QUESTION_GROUPS.companySettings:
						onboardingQuestionGroup.copy = 'Manage your company, payroll and workplace pension settings';
						onboardingQuestionGroup.description = 'Add a couple of useful reference numbers for your company';
						onboardingQuestionGroup.icon = 'company';
						onboardingQuestionGroup.theme = 'assertive';
						onboardingQuestionGroup.timeToComplete = '5 mins';
						break;
					case DEMO_QUESTION_GROUPS.holidayAndSickness:
						onboardingQuestionGroup.copy = 'Set up your policies and track your team’s leave';
						onboardingQuestionGroup.description = 'Add a couple of useful reference numbers for your company';
						onboardingQuestionGroup.icon = 'holiday';
						onboardingQuestionGroup.theme = 'indifferent';
						onboardingQuestionGroup.timeToComplete = '5 mins';
						break;
					case DEMO_QUESTION_GROUPS.payroll:
						onboardingQuestionGroup.copy = 'Add payroll changes and submit the data every pay period';
						onboardingQuestionGroup.description = 'Tell us how you like to run your payroll and pay your team';
						onboardingQuestionGroup.icon = 'clock';
						onboardingQuestionGroup.theme = 'quarternary';
						onboardingQuestionGroup.timeToComplete = '5 mins';
						break;
					case DEMO_QUESTION_GROUPS.team:
						onboardingQuestionGroup.copy = 'Manage your team’s personal and employment info';
						onboardingQuestionGroup.description = 'Add personal and employment info for your team members';
						onboardingQuestionGroup.icon = 'team-alt';
						onboardingQuestionGroup.questionCountCopy = {
							'1': '1 question / team member',
							'other': '{} questions / team member'
						};
						onboardingQuestionGroup.theme = 'primary';
						onboardingQuestionGroup.timeToComplete = '5 mins / team member';
						break;
					case DEMO_QUESTION_GROUPS.workplacePension:
						onboardingQuestionGroup.copy = 'Manage team assessment and contributions';
						onboardingQuestionGroup.description = 'Add your workplace pension and auto-enrolment settings';
						onboardingQuestionGroup.icon = 'money';
						onboardingQuestionGroup.theme = 'secondary';
						onboardingQuestionGroup.timeToComplete = '5 mins';

				}

				return onboardingQuestionGroup;
			};
		},

		decorateOnboardingDashboardObj: function (onboardingDashboardObj) {

			onboardingDashboardObj.Questions.QuestionGroups = onboardingDashboardObj.Questions.QuestionGroups.filter(service.decorateOnboardingQuestionGroup(onboardingDashboardObj));

			onboardingDashboardObj.demoTasksComplete = onboardingDashboardObj.DemoPercentComplete === 100 ? true : false;
			onboardingDashboardObj.isProfileIncomplete = service.getIsProfileIncomplete(onboardingDashboardObj);
			onboardingDashboardObj.questionGroupPairs = onboardingDashboardObj.Questions.QuestionGroups.reduce(function (result, value, index, array) {
				if (index % 2 === 0) {
					result.push(array.slice(index, index + 2));
				}
				return result;
			}, []);

			return onboardingDashboardObj;
		},

		getAllQuestions: function (onboardingDashboardObj) {

			var returnArray = [];

			onboardingDashboardObj.Questions.QuestionGroups.forEach(function (onboardingQuestionGroupObj) {

				// Attach group name to questions
				var onboardingQuestionsArray = onboardingQuestionGroupObj.Questions.filter(function (onboardingQuestionObj) {
					onboardingQuestionObj.questionGroupName = onboardingQuestionGroupObj.GroupName;
					return onboardingQuestionObj;
				});

				returnArray = returnArray.concat(onboardingQuestionsArray);
			});

			return returnArray;
		},

		getAreTeamMembersComplete: function (teamMembersArray) {

			var i = 0;
			var numberOfTeamMembers = teamMembersArray.length;

			if (numberOfTeamMembers === 0) {
				return false;
			}

			for (i; i < numberOfTeamMembers; i++) {

				if (parseInt(teamMembersArray[i].PercentComplete) < 100) {
					return false;
				}
			}

			return true;
		},

		getCompanyQuestionValueForQuestionKey: function (questionsArray, questionKey, valueIfEmpty) {

			var questionId = ONBOARDING_QUESTIONS.company[questionKey];

			return service.getQuestionValueForQuestionId(questionsArray, questionId, valueIfEmpty);
		},

		getIsProfileIncomplete: function (onboardingDashboardObj) {

			// Show profile wizard if percent complete = 0
			for (var group of onboardingDashboardObj.Questions.QuestionGroups) {
				if (group.OnboardingQuestionGroupID === ONBOARDING_QUESTION_GROUPS.profile && group.percentageComplete < 100) {
					return true;
				}
			}

			return false;
		},

		getMailToFromSkippedQuestions: function (onboardingDashboardObj, forename) {

			var returnMessage = '?subject=REF:Can you help?&body=';

			returnMessage += service.getMessageFromSkippedQuestions(onboardingDashboardObj, forename);

			return encodeURI(returnMessage);
		},

		getMessageFromSkippedQuestions: function (onboardingDashboardObj, forename) {

			var skippedQuestions = service.getSkippedQuestions(onboardingDashboardObj);
			var i = 0;
			var numberOfSkippedQuestions = skippedQuestions.length;
			var returnMessage = 'Hi there,\n\n';

			if (numberOfSkippedQuestions > 0) {

				returnMessage += 'Do you happen to have any of the below info you can send over to me so I can pop it into Paycircle please?\n\n';

				for (i; i < numberOfSkippedQuestions; i++) {

					var skippedQuestion = skippedQuestions[i];

					returnMessage += '- ' + skippedQuestion.QuestionName + '\n';
				}
			}
			else {
				returnMessage += '{{enter your message here}}';
			}

			returnMessage += '\nThanks,\n' + forename;

			return returnMessage;
		},

		getNextCompanyState: currentCompanyState => {

			switch (currentCompanyState) {
				case COMPANY_STATES.onboarding:
					return COMPANY_STATES.firstPeriod;
				case COMPANY_STATES.firstPeriod:
					return COMPANY_STATES.readyToRun;
				case COMPANY_STATES.readyToRun:
					return COMPANY_STATES.live;
			}
		},

		getOnboardingQuestionsForQuestionGroupKey: function (onboardingDashboardObj, questionGroupKey) {

			var i = 0;
			var numberOfQuestionGroups = onboardingDashboardObj.Questions.QuestionGroups.length;

			for (i; i < numberOfQuestionGroups; i++) {

				var onboardingQuestionGroupObj = onboardingDashboardObj.Questions.QuestionGroups[i];

				if (onboardingQuestionGroupObj.OnboardingQuestionGroupID === ONBOARDING_QUESTION_GROUPS[questionGroupKey]) {
					return onboardingQuestionGroupObj.Questions.filter(service.decorateCompanyOnboardingQuestions);
				}
			}
		},

		getPayrollQuestionObjForQuestionKey: function (questionsArray, questionKey) {

			var questionId = ONBOARDING_QUESTIONS.payroll[questionKey];

			return service.getQuestionObjForQuestionId(questionsArray, questionId);
		},

		getPayrollQuestionValueForQuestionKey: function (questionsArray, questionKey, valueIfEmpty) {

			var questionId = ONBOARDING_QUESTIONS.payroll[questionKey];

			return service.getQuestionValueForQuestionId(questionsArray, questionId, valueIfEmpty);
		},

		getProfileQuestionValueForQuestionKey: function (questionsArray, questionKey, valueIfEmpty) {

			var questionId = ONBOARDING_QUESTIONS.profile[questionKey];

			return service.getQuestionValueForQuestionId(questionsArray, questionId, valueIfEmpty);
		},

		getQuestionGroupForQuestionGroupKey: function (onboardingDashboardObj, groupKey) {

			var questionGroupId = ONBOARDING_QUESTION_GROUPS[groupKey];

			var questionGroupObj = utilities.getArrayItemByPropertyName(onboardingDashboardObj.Questions.QuestionGroups, 'OnboardingQuestionGroupID', questionGroupId);

			if (!questionGroupObj) {
				$rootScope.paycircleMessage('Unable to get question group for question group key: ' + groupKey, 'error');
				return;
			}

			return questionGroupObj;
		},

		getQuestionObjForQuestionId: function (questionsArray, questionId) {

			var activeQuestionObj = utilities.getArrayItemByPropertyName(questionsArray, 'TaskID', questionId);

			if (!activeQuestionObj || activeQuestionObj === undefined) {
				$rootScope.paycircleMessage('1. Unable to get question for question ID: ' + questionId, 'error');
				return;
			}

			return activeQuestionObj;
		},

		getQuestionValueForQuestionId: function (questionsArray, questionId, valueIfEmpty) {

			var activeQuestionObj = service.getQuestionObjForQuestionId(questionsArray, questionId, valueIfEmpty);

			if (activeQuestionObj === undefined || (valueIfEmpty !== undefined && activeQuestionObj.Value === '')) {
				return valueIfEmpty;
			}

			return activeQuestionObj.Value;
		},

		getRequestCallbackObjectForCompany: function (currentUserObj, currentCompanyObj) {

			var returnObj = {
				body: null,
				subject: null,
				toAddress: config.fsbAdminEmail
			};

			switch (currentCompanyObj.State) {
				case COMPANY_STATES.onboarding:
					returnObj.subject = `Data review request - ${currentCompanyObj.Name}`,
					returnObj.body =
`Hi there,

I've completed onboarding and I would like to request a data review with FSB. My details are as follows:

Name: ${currentUserObj.UserResponseFirstName} ${currentUserObj.UserResponseLastName}
Company name: ${currentCompanyObj.Name}
Telephone: ${currentUserObj.telephoneNumber}

Thank you!`;
					break;
				case COMPANY_STATES.demo:
					returnObj.subject = `Demo - ${currentCompanyObj.Name}`;
					returnObj.body =
`Hi there,

My free trial demo account has expired and I’d like to talk to someone at FSB as I have questions to ask and/or feedback to give you about my experience.

Name: ${currentUserObj.UserResponseFirstName} ${currentUserObj.UserResponseLastName}
Company name: ${currentCompanyObj.Name}
Telephone: ${currentUserObj.telephoneNumber}

Thank you!`;
			}

			return returnObj;
		},

		getSkippedQuestions: function (onboardingDashboardObj) {

			var allQuestionsArray = service.getAllQuestions(onboardingDashboardObj);

			return allQuestionsArray.filter(service.decorateCompanyOnboardingQuestions).filter(function (questionObj) {
				return questionObj.Skipped;
			});
		},

		getSkippedQuestionsByQuestionGroupKey: function (onboardingDashboardObj, questionGroupKey) {

			var questionsArray = service.getOnboardingQuestionsForQuestionGroupKey(onboardingDashboardObj, questionGroupKey);

			return questionsArray.filter(function (questionObj) {
				return questionObj.Skipped;
			});
		},

		getTeamMemberStatsObj: function (teamMembersArray) {

			var numberOfTeamMembers = teamMembersArray.length;
			var teamMembersComplete = 0;
			var teamMembersIncomplete = 0;
			var totalPercentageComplete = 0;

			teamMembersArray.forEach(function (teamMemberObj) {

				teamMemberObj.PercentComplete === 100 ? teamMembersComplete++ : teamMembersIncomplete++;
				totalPercentageComplete += teamMemberObj.PercentComplete;
			});

			totalPercentageComplete = totalPercentageComplete / numberOfTeamMembers;

			return {
				numberOfTeamMembers: numberOfTeamMembers,
				teamMembersComplete: teamMembersComplete,
				teamMembersIncomplete: teamMembersIncomplete,
				totalPercentageComplete: totalPercentageComplete
			};
		},

		setQuestionCompleteForQuestionId: function (questionsArray, questionId) {

			var activeQuestionObj = utilities.getArrayItemByPropertyName(questionsArray, 'TaskID', questionId);

			if (!activeQuestionObj) {
				$rootScope.paycircleMessage('2. Unable to get question for question ID: ' + questionId, 'error');
				return;
			}

			activeQuestionObj.Complete = true;
			activeQuestionObj.Skipped = false;

			return activeQuestionObj;
		},

		setQuestionSkippedForQuestionId: function (questionsArray, questionId) {

			var activeQuestionObj = utilities.getArrayItemByPropertyName(questionsArray, 'TaskID', questionId);

			if (!activeQuestionObj) {
				$rootScope.paycircleMessage('3. Unable to get question for question ID: ' + questionId, 'error');
				return;
			}

			activeQuestionObj.Complete = true;
			activeQuestionObj.Skipped = true;
			activeQuestionObj.Value = '';

			return activeQuestionObj;
		},

		setQuestionCompleteForPayrollQuestionKey: function (questionsArray, questionKey) {

			return service.setQuestionCompleteForQuestionId(questionsArray, ONBOARDING_QUESTIONS.payroll[questionKey]);
		},

		setQuestionSkippedForPayrollQuestionKey: function (questionsArray, questionKey) {

			return service.setQuestionSkippedForQuestionId(questionsArray, ONBOARDING_QUESTIONS.payroll[questionKey]);
		},

		setQuestionsCompleteForQuestionKeys: function (questionsArray, questionKeys, onboardingGroupKey) {

			var updatedQuestionsArray = [];

			questionKeys.forEach(function (questionKey) {

				var updatedQuestionObj;

				switch (onboardingGroupKey) {
					case 'payroll':
						updatedQuestionObj = service.setQuestionCompleteForPayrollQuestionKey(questionsArray, questionKey);
						break;
				}

				updatedQuestionsArray.push(updatedQuestionObj);
			});

			return updatedQuestionsArray;
		},

		setQuestionsSkippedForQuestionKeys: function (questionsArray, questionKeys, onboardingGroupKey) {

			var updatedQuestionsArray = [];

			questionKeys.forEach(function (questionKey) {

				var updatedQuestionObj;

				switch (onboardingGroupKey) {
					case 'payroll':
						updatedQuestionObj = service.setQuestionSkippedForPayrollQuestionKey(questionsArray, questionKey);
						break;
				}

				updatedQuestionsArray.push(updatedQuestionObj);
			});

			return updatedQuestionsArray;
		},

		setQuestionsCompleteForPayrollQuestionKeys: function (questionsArray, questionKeys) {

			return service.setQuestionsCompleteForQuestionKeys(questionsArray, questionKeys, 'payroll');
		},

		setQuestionsSkippedForPayrollQuestionKeys: function (questionsArray, questionKeys) {

			return service.setQuestionsSkippedForQuestionKeys(questionsArray, questionKeys, 'payroll');
		},

		setQuestionValueForQuestionId: function (questionsArray, questionId, questionValue, questionSkipped) {

			var activeQuestionObj = utilities.getArrayItemByPropertyName(questionsArray, 'TaskID', questionId);

			if (!activeQuestionObj) {
				$rootScope.paycircleMessage('4. Unable to get question for question ID: ' + questionId, 'error');
				return;
			}

			activeQuestionObj.Complete = true;

			// Skipped
			if (questionSkipped !== undefined && questionSkipped) {
				activeQuestionObj.Value = '';
				activeQuestionObj.Skipped = true;
			}

			else {
				activeQuestionObj.Value = questionValue;
				activeQuestionObj.Skipped = false;
			}

			return activeQuestionObj;
		},

		setQuestionValueForPayrollQuestionKey: function (questionsArray, questionKey, questionValue, questionSkipped) {

			var questionId = ONBOARDING_QUESTIONS.payroll[questionKey];

			return service.setQuestionValueForQuestionId(questionsArray, questionId, questionValue, questionSkipped);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('paycircleService', [
	'$document',
	'$filter',
	'$state',
	'PERMISSION_ACTION_GROUPS',
	'PERMISSION_ACTIONS',
	'PERMISSION_GROUP_KEYS',
	function (
		$document,
		$filter,
		$state,
		PERMISSION_ACTION_GROUPS,
		PERMISSION_ACTIONS,
		PERMISSION_GROUP_KEYS
	) {

	const service = {

		permissionTracking: {

			RECORD_STORE: [],

			isTrackingEnabled: false,

			disableTracking: () => {

				service.permissionTracking.isTrackingEnabled = false;

				$document.unbind('click', service.permissionTracking.onClick);
			},

			enableTracking: () => {

				service.permissionTracking.isTrackingEnabled = true;

				$document.bind('click', service.permissionTracking.onClick);
			},

			getIsTrackingEnabled: () => {
				return service.permissionTracking.isTrackingEnabled;
			},

			getStoredPermissions: () => {
				return angular.copy(service.permissionTracking.RECORD_STORE);
			},

			getOrganisedStoredPermissions: () => {

				const recordedChecksArr = service.permissionTracking.getStoredPermissions();
				const recordedPermissionsArr = recordedChecksArr.filter(recordObj => recordObj.type === 'permission');
				const recordedRolesArr = recordedChecksArr.filter(recordObj => recordObj.type === 'role');

				return {
					raw: recordedChecksArr,
					permissionsOnly: {
						raw: recordedPermissionsArr,
						values: recordedPermissionsArr.map(recordObj => recordObj.data.value)
					},
					roleOnly: recordedRolesArr.filter(recordObj => recordObj.type === 'role').map(recordObj => recordObj.data.description)
				};
			},

			getStoredPermissionLength: () => {
				return service.permissionTracking.RECORD_STORE.length;
			},

			onRoleCheck: rolesToCheck => {

				if (!service.permissionTracking.isTrackingEnabled) {
					return;
				}

				for (let roleKey of rolesToCheck) {

					let roleId = 'role.' + roleKey;

					if (service.permissionTracking.RECORD_STORE.findIndex(recordObj => recordObj.id === roleId) === -1) {
						service.permissionTracking.RECORD_STORE.push({
							data: {
								key: roleKey,
								description: $filter('prettifyRole')(roleKey)
							},
							id: roleId,
							type: 'role'
						});
					}
				}
			},

			onPermisisonCheck: (permissionToCheck, checkType) => {

				function getBitwiseValueForPermission (permissionKeySplit) {
					return PERMISSION_ACTIONS[permissionKeySplit[0]][permissionKeySplit[1]];
				}

				function getPermissionGroupKeyForPermission (permissionKeySplit) {
					return PERMISSION_GROUP_KEYS[permissionKeySplit[0]];
				}

				function getDescriptionForPermission (permissionDataObj) {

					const permissionGroupDataObj = PERMISSION_ACTION_GROUPS.find(permissionGroupObj => permissionGroupObj.groupKey === permissionDataObj.groupKey);
					const permissionGroupName = permissionGroupDataObj.GroupName;
					const permissionActionDescription = permissionGroupDataObj.GroupPermissionActions.find(permissionActionObj => permissionActionObj.Value === permissionDataObj.value).Description;

					return `${permissionGroupName} > ${permissionActionDescription}`;
				}

				if (!service.permissionTracking.isTrackingEnabled) {
					return;
				}

				if (!angular.isArray(permissionToCheck)) {
					permissionToCheck = [permissionToCheck];
				}

				for (let permissionKey of permissionToCheck) {

					const recordId = `permission.${checkType}.${permissionKey}`.toLowerCase().replace(/-/g, '.');

					if (service.permissionTracking.RECORD_STORE.findIndex(recordObj => recordObj.id === recordId) === -1) {

						const recordObj = {
							data: {
								key: permissionKey,
							},
							id: recordId,
							source: {
								type: checkType,
								route: $state.current.name,
							},
							type: 'permission'
						};

						const permissionKeySplit = permissionKey.split('.');

						if (permissionKeySplit.length > 1) {
							angular.extend(recordObj.data, {
								value: getBitwiseValueForPermission(permissionKeySplit),
								groupKey: getPermissionGroupKeyForPermission(permissionKeySplit)
							});

							recordObj.data.description = getDescriptionForPermission(recordObj.data);
						}

						service.permissionTracking.RECORD_STORE.push(recordObj);
					}

				}
			},

			resetStore: () => {
				service.permissionTracking.RECORD_STORE = [];
			},

			onClick: $event => {

				const permissionGroupString = '.Permissions.';

				function getClickedElement (targetElement) {

					if (targetElement.tagName === 'A') {
						return targetElement;
					}
					else if (targetElement.tagName === 'BUTTON') {
						return targetElement;

					} else if (targetElement.parentElement) {
						return getClickedElement(targetElement.parentElement);

					} else {
						return null;
					}
				}

				function getPermissionsUsedFromString (ngIfString) {

					const permissionsUsed = [];
					const trimmedString = ngIfString.replace(/\s+/g, ' ').trim();

					const conditionsInStringArr = trimmedString.split(' ').filter(string => string.includes(permissionGroupString));

					for (let fullPermissionString of conditionsInStringArr) {
						permissionsUsed.push(fullPermissionString.slice(fullPermissionString.indexOf(permissionGroupString)+permissionGroupString.length));
					}

					return permissionsUsed;
				}

				const clickedElement = getClickedElement($event.target);

				if (clickedElement && clickedElement.hasAttribute('ng-if')) {

					const ngIfString = clickedElement.getAttribute('ng-if');

					if (ngIfString.includes(permissionGroupString)) {

						const permissionUsed = getPermissionsUsedFromString(ngIfString);

						if (permissionUsed.length > 0) {
							service.permissionTracking.onPermisisonCheck(permissionUsed, 'click');
						}
					}
				}

			},
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('payElementsService', [
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'ADJUSTMENT_DETAIL_STATES',
	'ADJUSTMENT_VALUE_TYPES',
	'companyService',
	'utilities',
function (
	ADJUSTMENT_BEHAVIOUR_STATES,
	ADJUSTMENT_DETAIL_STATES,
	ADJUSTMENT_VALUE_TYPES,
	companyService,
	utilities
) {

	var service = {

		decorateUserPayElements: (userPayElementsArr) => {
			userPayElementsArr.forEach(teamMemberObj => {
				// Set pay element label to description if label is empty.
				teamMemberObj.PayElements.forEach(payElement => {
					payElement.Label = payElement.Label ? payElement.Label : payElement.Description;
				});
				// Now we have labels for everything, sort by Label
				teamMemberObj.PayElements.sort(utilities.comparator('Label'));
			});

			return userPayElementsArr;
		},

		filterUserPayElementsByValueType: (userPayElementsArr, adjustmentValueKey) => {

			const adjustmentValueType = ADJUSTMENT_VALUE_TYPES[adjustmentValueKey];

			if (!adjustmentValueType) {
				throw('payElementsService:filterUserPayElementsByType: adjustmentValueType not defined');
			}

			// Filter pay elements by type
			userPayElementsArr.forEach(teamMemberObj => {
				teamMemberObj.PayElements = teamMemberObj.PayElements.filter(adjustmentObj => {
					return adjustmentObj.ValueType === adjustmentValueType;
				});
			});

			// Only return team members that have pay elements
			return userPayElementsArr.filter(_ => {
				return _.PayElements.length > 0;
			});
		},

		isPayElementNetPayReadOnly: (payElementObj) => {

			switch (payElementObj.AgencyAdjustmentGroupEntryNetPayBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		isPayElementPensionableReadOnly: (payElementObj, companyObj) => {

			// Read only
			if (payElementObj.PensionState === ADJUSTMENT_DETAIL_STATES.readonly) {
				return true;
			}

			// Companies that do not have a pension set up
			if (companyObj && companyService.isPayrollCompany(companyObj) && !companyObj.HasPension) {
				return true;
			}

			// Locked
			switch (payElementObj.AgencyAdjustmentGroupEntryPensionBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		isPayElementSalarySacrificeReadOnly: (payElementObj) => {

			switch (payElementObj.AgencyAdjustmentGroupEntrySalarySacrificeBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		isPayElementPayrollBIKReadOnly: (payElementObj) => {

			switch (payElementObj.AgencyAdjustmentGroupEntryPayrollBIKBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		isPayElementHolidayReadOnly: (payElementObj) => {

			switch (payElementObj.AgencyAdjustmentGroupEntryHolidayBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		isPayElementProrateReadOnly: (payElementObj) => {

			switch (payElementObj.AgencyAdjustmentGroupEntryProrateBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
					return true;
			}

			return false;
		},

		reviewPayElementNetPay: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntryNetPayBehaviour = payElementObj.AgencyAdjustmentGroupEntryNetPayState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		reviewPayElementPension: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntryPensionBehaviour = payElementObj.AgencyAdjustmentGroupEntryPensionState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		reviewPayElementSalarySacrifice: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntrySalarySacrificeBehaviour = payElementObj.AgencyAdjustmentGroupEntrySalarySacrificeState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		reviewPayElementPayrollBIK: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntryPayrollBIKBehaviour = payElementObj.AgencyAdjustmentGroupEntryPayrollBIKState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		reviewPayElementHoliday: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntryHolidayBehaviour = payElementObj.AgencyAdjustmentGroupEntryHolidayState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		reviewPayElementProrate: (payElementObj) => {

			payElementObj.AgencyAdjustmentGroupEntryProrateBehaviour = payElementObj.AgencyAdjustmentGroupEntryProrateState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		}
	};

	return service;
}]);

'use strict';

/**
 * A service for the pay period object
 */
angular.module('paycircleApp')
.service('payPeriodService', ['$filter', '$q','$timeout', 'base', 'config', 'dateService', 'growl', 'payrollData', 'payrollWorker', 'utilities', 'ALERT_LEVELS', 'ALERT_TYPES', 'PAY_DATE_OPTIONS', 'PAY_PERIOD_TYPES', 'PRESET_FILTER_KEYS', 'SUBMISSION_STATES',
	function ($filter, $q, $timeout, base, config, dateService, growl, payrollData, payrollWorker, utilities, ALERT_LEVELS, ALERT_TYPES, PAY_DATE_OPTIONS, PAY_PERIOD_TYPES, PRESET_FILTER_KEYS, SUBMISSION_STATES) {

	var service = {

		getDivisorForPayPeriodType: payPeriodType => {

			switch (payPeriodType) {
				case PAY_PERIOD_TYPES.weekly:
					return 52;
				case PAY_PERIOD_TYPES.fortnightly:
					return 26;
				case PAY_PERIOD_TYPES.fourweekly:
					return 13;
				case PAY_PERIOD_TYPES.monthly:
					return 12;
				case PAY_PERIOD_TYPES.quarterly:
					return 4;
				case PAY_PERIOD_TYPES.biannually:
					return 2;
				case PAY_PERIOD_TYPES.annually:
					return 1;
			}
		},

		getPaymentOptionById: function (payPeriodTypeId, payPeriodDayId) {

			var paymentOptions = service.getPaymentOptionsByPayPeriodTypeId(payPeriodTypeId);

			const selectedPaymentOptionsArr = paymentOptions.filter((paymentOption) => {
				return paymentOption.id === payPeriodDayId;
			});

			if (!selectedPaymentOptionsArr.length) {
				return null;
			}

			return selectedPaymentOptionsArr[0].name;
		},

		getPaymentOptionsByPayPeriodTypeId: function (payPeriodTypeId) {

			switch (payPeriodTypeId) {
				case PAY_PERIOD_TYPES.annually:
					return PAY_DATE_OPTIONS.annually;
				case PAY_PERIOD_TYPES.quarterly:
					return PAY_DATE_OPTIONS.quarterly;
				case PAY_PERIOD_TYPES.monthly:
					return PAY_DATE_OPTIONS.monthly;
				default:
					return PAY_DATE_OPTIONS.weekly;
			}
		},

		getPaymentOptionsDaysByPeriodType: payPeriodTypeId => {

			let paymentOptionsArr = service.getPaymentOptionsByPayPeriodTypeId(payPeriodTypeId);

			// Remove special payment options
			return paymentOptionsArr.reduce((paymentOptionsDaysArr, paymentOptionObj) => {
				return (paymentOptionObj.id > 0) ? paymentOptionsDaysArr.concat(paymentOptionObj) : paymentOptionsDaysArr;
			}, []);
		},

		getPayPeriodById: (payPeriodsArray, payPeriodId) => {

			let returnPayPeriod = utilities.getArrayItemByPropertyName(payPeriodsArray, 'PayPeriodID', payPeriodId);

			return returnPayPeriod ? returnPayPeriod : payPeriodsArray[payPeriodsArray.length - 1];
		},

		getPayPeriodsAfterDateIso: (payPeirodsArr, dateIso) => {

			let startPayPeriodEndDateMoment = moment(dateIso);

			return payPeirodsArr.reduce((newPayPeriodsArr, originalPayPeriodObj) => {

				let originalPayPeriodStartDateMoment = moment(originalPayPeriodObj.StartDateISO);

				if (originalPayPeriodStartDateMoment.isAfter(startPayPeriodEndDateMoment)) {
					newPayPeriodsArr.push(originalPayPeriodObj);
				}

				return newPayPeriodsArr;
			}, []);
		},

		getPayPeriodsDateValidation: (date1Iso, isQuarterlyPeriodType, maxDayOfMonth) => {

			/*
				Date 2
				↳ Min - 3 months after pay date
				↳ Max = Date 2 Min + 1 month - 1 day

				Date 3
				↳ Min - 6 months after pay date
				↳ Max = Date 3 Min + 1 month - 1 day

				Date 4
				↳ Min - 9 months after pay date
				↳ Max = Date 4 Min + 1 month - 1 day
			*/

			const date1Monent = moment(date1Iso);

			const threeMonthsAfterDate1Iso = date1Monent.add(3, 'months').format(config.dateFormatISO);
			const sixMonthsAfterDate1Iso = date1Monent.add(3, 'months').format(config.dateFormatISO);
			const nineMonthsAfterDate1Iso = date1Monent.add(3, 'months').format(config.dateFormatISO);

			const date2MinIso = isQuarterlyPeriodType ? threeMonthsAfterDate1Iso : sixMonthsAfterDate1Iso;

			return {
				date2: {
					minIso: date2MinIso,
					maxIso: dateService.getEndOfMonthIso(date2MinIso, maxDayOfMonth)
				},
				date3: {
					minIso: sixMonthsAfterDate1Iso,
					maxIso: dateService.getEndOfMonthIso(sixMonthsAfterDate1Iso, maxDayOfMonth)
				},
				date4: {
					minIso: nineMonthsAfterDate1Iso,
					maxIso: dateService.getEndOfMonthIso(nineMonthsAfterDate1Iso, maxDayOfMonth)
				},
			};
		},

		getPayrollAlertDetails: alertObj => {

			alertObj.alertTheme = service.getPayrollAlertTheme(alertObj.AlertTypeID); // Separate theme for certain alerts
			alertObj.alertPresetKey = service.getPayrollAlertPresetKey(alertObj.AlertTypeID); // Preset key for action page filters

			return alertObj;
		},

		getPayrollAlertLevelsFromAlerts: alertsArr => {

			var alerts = alertsArr.filter(service.getPayrollAlertDetails);
			var alertsLevels = {
				errors: alerts.filter(alert => alert.Level === ALERT_LEVELS.errors),
				warnings: alerts.filter(alert => alert.Level === ALERT_LEVELS.warnings),
				notices: alerts.filter(alert => alert.Level === ALERT_LEVELS.notices),
			};

			return {
				alertsCount: alertsArr.length,
				hasErrors: alertsLevels.errors.length > 0,
				levels: [
					{
						level: ALERT_LEVELS.errors,
						title: 'error',
						icon: 'icon-warning',
						theme: 'is-assertive',
						alerts: alertsLevels.errors,
						filteredAlerts: []
					},
					{
						level: ALERT_LEVELS.warnings,
						title: 'warning',
						icon: 'icon-warning',
						theme: 'is-tertiary',
						alerts: alertsLevels.warnings,
						filteredAlerts: []
					},
					{
						level: ALERT_LEVELS.notices,
						title: 'notice',
						icon: 'icon-information',
						theme: 'is-primary',
						alerts: alertsLevels.notices,
						filteredAlerts: []
					},
				],
				filteredLevels: []
			};
		},

		getPayrollAlertPresetKey: alertGuid => {

			switch (alertGuid) {
				case ALERT_TYPES.incompleteProfileGroup:
					return PRESET_FILTER_KEYS.team.incompleteProfiles;

				case ALERT_TYPES.missingBankDetailsGroup:
					return PRESET_FILTER_KEYS.team.missingBankDetails;

				case ALERT_TYPES.markedAsLeavingGroup:
					return PRESET_FILTER_KEYS.team.markedAsLeaving;

				case ALERT_TYPES.newStarterGroup:
					return PRESET_FILTER_KEYS.team.newStarters;

				case ALERT_TYPES.markedAsOnHoldGroup:
					return PRESET_FILTER_KEYS.team.markedAsOnHold;

				case ALERT_TYPES.omittedFromRTIGroup:
					return PRESET_FILTER_KEYS.team.isExcludedFromRti;
			}
		},

		getPayrollAlertTheme: alertGuid => {

			switch (alertGuid) {
				case ALERT_TYPES.pensionReenrolment:
					return 'indifferent is-light';
			}
		},

		getPostponementOptions: function (payPeriodType, postponementLength) {

			var postponementOptions = [];
			var periodSuffix = $filter('payPeriodTypeDescription')(payPeriodType, 'months');

			for (let periodValue = 0; periodValue < postponementLength + 1; periodValue++) {

				let postponementPeriod = {
					key: periodValue ? `${periodValue} ${periodValue === 1 ? periodSuffix.slice(0, -1) : periodSuffix}` : 'No postponement',
					value: periodValue
				};

				postponementOptions.push(postponementPeriod);
			}

			return postponementOptions;
		},

		pollForSubmissionState: function (payPeriod, stateType, propertyKey, agencyProfileId) {

			return $q(onComplete => {
				var timeToPoll = config.timeToPoll;

				payrollData.getAgencyPayPeriodState(payPeriod.PayPeriodID, stateType).then(function (submissionState) {

					var timer;

					// Update company object
					payPeriod[propertyKey] = submissionState;

					switch (submissionState) {
						case SUBMISSION_STATES.processing1:
						case SUBMISSION_STATES.processing2:
						case SUBMISSION_STATES.submitting:

							// Poll
							timer = $timeout(function () {
								service.pollForSubmissionState(payPeriod, stateType, propertyKey, agencyProfileId)
									.then(onComplete);
							}, timeToPoll * 1000);
							break;

						case SUBMISSION_STATES.failed:
							// Failure, so check and set errors.
							service.checkAndSetPayrollErrors(payPeriod, agencyProfileId);
							// Cancel timout
							$timeout.cancel(timer);
							break;

						case SUBMISSION_STATES.haserrors1:
						case SUBMISSION_STATES.haserrors2:
						case SUBMISSION_STATES.resubmit:
						case SUBMISSION_STATES.unsubmitted:

							// Cancel timout
							$timeout.cancel(timer);
							break;

						case SUBMISSION_STATES.verified:
						case SUBMISSION_STATES.finished:
						case SUBMISSION_STATES.submitted:

							// Cancel timout
							$timeout.cancel(timer);

							// Fire callback
							onComplete();
							break;

						default:

							// Cancel timout
							$timeout.cancel(timer);
					}

					return timer;
				});
			});
		},

		getPeriodEndDateFromStartDate: (dateISO, payPeriodType) => {

			const momentPeriodOptions = [
				{
					type: PAY_PERIOD_TYPES.weekly,
					key: 'w',
				},
				{
					type: PAY_PERIOD_TYPES.fortnightly,
					key: 'w',
					multiplyBy: 2
				},
				{
					type: PAY_PERIOD_TYPES.fourweekly,
					key: 'w',
					multiplyBy: 4
				},
				{
					type: PAY_PERIOD_TYPES.monthly,
					key: 'M',
				},
				{
					type: PAY_PERIOD_TYPES.quarterly,
					key: 'Q',
				},
				{
					type: PAY_PERIOD_TYPES.annually,
					key: 'y',
				},
				{
					type: PAY_PERIOD_TYPES.biannually,
					key: 'M',
					multiplyBy: 6
				}
			];

			var periodOption = momentPeriodOptions.find(periodOptionsObj => periodOptionsObj.type === payPeriodType);
			return moment(dateISO)
					.add(1 * (periodOption.multiplyBy || 1), periodOption.key)
					.subtract(1, 'd')
					.format(config.dateFormatISO);
		},

		getSuccessfulSubmissionsDisplayForPayPeriod: currentPayPeriodObj => {

			// List which submissions were submitted
			const submittedSubmissons = [];

			if (currentPayPeriodObj.FPSState === SUBMISSION_STATES.submitted) {
				submittedSubmissons.push('FPS');
			}
			if (currentPayPeriodObj.EPSState === SUBMISSION_STATES.submitted) {
				submittedSubmissons.push('EPS');
			}
			if (currentPayPeriodObj.CIS300State === SUBMISSION_STATES.submitted) {
				submittedSubmissons.push('CIS300');
			}

			return {
				submittedSubmissonsDisplay: utilities.formatArrayAsReadableList(submittedSubmissons),
				submittedSubmissons: submittedSubmissons
			};
		}
	};

	return service;
}]);

'use strict';

/**
 * Handles the resolution of pay period start and end dates for a set of period numbers and tax years.
 * Normalises and orders the requested periods for the platform, calls the resolution endpoint and
 * maps any failure onto user facing copy.
 */
angular.module('paycircleApp')
.service('payPeriodDateResolutionService', [
	'$q',
	'companyData',
	'config',
	'PAY_PERIOD_RESOLUTION_FAILURE_CODES',
	'PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES',
	function (
		$q,
		companyData,
		config,
		PAY_PERIOD_RESOLUTION_FAILURE_CODES,
		PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES
	) {

	// Token within the failure copy that is replaced with a description of the period at fault
	const PERIOD_TOKEN = 'PERIOD';

	// Tax years at or below this value are treated as two digit years and expanded to four digits (e.g. '25' → 2025)
	const TWO_DIGIT_YEAR_MAX = 99;

	/**
	 * Orders periods by tax year, then period number
	 * @param {object} periodObj period being compared
	 * @param {object} comparisonPeriodObj period being compared against
	 * @returns {number} negative when the first period falls earlier
	 */
	function comparePeriods (periodObj, comparisonPeriodObj) {

		if (periodObj.PeriodYear !== comparisonPeriodObj.PeriodYear) {
			return periodObj.PeriodYear - comparisonPeriodObj.PeriodYear;
		}

		return periodObj.PeriodNumber - comparisonPeriodObj.PeriodNumber;
	}

	/**
	 * Rejects with a consistent failure object so consumers always have user facing copy to display
	 * @param {object} failureObj platform failure, or a locally built failure of the same shape
	 * @param {object} error underlying error to log, if there is one
	 * @returns {object} rejected promise
	 */
	function createFailure (failureObj, error) {

		return $q.reject({
			code: failureObj.Code,
			error: error || failureObj.Message,
			message: service.getFailureMessage(failureObj)
		});
	}

	/**
	 * Expands a two digit tax year into a full tax year, as the platform only accepts four digit tax
	 * years. The expanded year is checked against the configured century so this quietly stops working
	 * rather than silently mis-resolving if Paycircle outlives it.
	 * @param {number} periodYear tax year to expand
	 * @returns {number} expanded tax year, or null when it falls outside the configured century
	 */
	function expandPeriodYear (periodYear) {

		if (periodYear === null) {
			return null;
		}

		const expandedYear = periodYear <= TWO_DIGIT_YEAR_MAX ? config.taxYear.centuryBase + periodYear : periodYear;

		return expandedYear >= config.taxYear.min && expandedYear <= config.taxYear.max ? expandedYear : null;
	}

	/**
	 * Indexes resolved periods so a consumer can look up dates for a period without scanning the list
	 * @param {Array} resolvedPeriodsArr resolved periods
	 * @returns {object} resolved periods keyed by period key
	 */
	function getPeriodsByKey (resolvedPeriodsArr) {

		const resolvedPeriodsByKey = {};

		resolvedPeriodsArr.forEach(resolvedPeriodObj => {

			const periodKey = service.getPeriodKey(resolvedPeriodObj.PeriodNumber, resolvedPeriodObj.PeriodYear);

			resolvedPeriodsByKey[periodKey] = resolvedPeriodObj;
		});

		return resolvedPeriodsByKey;
	}

	/**
	 * @param {*} value value to parse
	 * @returns {number} parsed integer, or null when the value isn't a number
	 */
	function parseInteger (value) {

		const parsedValue = parseInt(value, 10);

		return isNaN(parsedValue) ? null : parsedValue;
	}

	const service = {

		/**
		 * The period the start date belongs to. The platform anchors the run of periods to the first
		 * period it is sent, so this is the earliest of the requested periods.
		 * @param {Array} periodsArr normalised periods
		 * @returns {object} anchor period
		 */
		getAnchorPeriod: periodsArr => {

			return periodsArr && periodsArr.length ? periodsArr[0] : null;
		},

		/**
		 * @param {object} failureObj platform failure
		 * @returns {string} user facing copy for the failure
		 */
		getFailureMessage: failureObj => {

			const unknownCode = PAY_PERIOD_RESOLUTION_FAILURE_CODES.unknown;
			const failureCode = failureObj && failureObj.Code ? failureObj.Code : unknownCode;
			const message = PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES[failureCode] || PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES[unknownCode];

			if (message.indexOf(PERIOD_TOKEN) === -1) {
				return message;
			}

			// The copy describes a specific period, so fall back to the generic copy without one
			if (!failureObj.PeriodNumber) {
				return PAY_PERIOD_RESOLUTION_FAILURE_MESSAGES[unknownCode];
			}

			return message.replace(PERIOD_TOKEN, service.getPeriodLabel(failureObj));
		},

		/**
		 * @param {number} periodNumber period number
		 * @param {number} periodYear tax year
		 * @returns {string} key uniquely identifying the period
		 */
		getPeriodKey: (periodNumber, periodYear) => {

			return `${periodYear}:${periodNumber}`;
		},

		/**
		 * @param {object} periodObj period to describe
		 * @returns {string} description of the period, e.g. 'Period 3 of 2025'
		 */
		getPeriodLabel: periodObj => {

			return `Period ${periodObj.PeriodNumber} of ${periodObj.PeriodYear}`;
		},

		/**
		 * Prepares requested periods for the platform by removing duplicates, coercing period numbers
		 * and tax years, and ordering them so the earliest period is first
		 * @param {Array} periodsArr requested periods
		 * @returns {object} normalised periods, alongside any that couldn't be understood
		 */
		normalisePeriods: periodsArr => {

			const invalidPeriodsArr = [];
			const normalisedPeriodsArr = [];
			const seenPeriodKeys = {};

			(periodsArr || []).forEach(periodObj => {

				const periodNumber = parseInteger(periodObj.PeriodNumber);
				const periodYear = expandPeriodYear(parseInteger(periodObj.PeriodYear));

				if (periodNumber === null || periodNumber < 1 || periodYear === null) {
					invalidPeriodsArr.push(periodObj);
					return;
				}

				const periodKey = service.getPeriodKey(periodNumber, periodYear);

				// The same period can appear multiple times in the input
				if (seenPeriodKeys[periodKey]) {
					return;
				}

				seenPeriodKeys[periodKey] = true;

				normalisedPeriodsArr.push({
					PeriodNumber: periodNumber,
					PeriodYear: periodYear
				});
			});

			normalisedPeriodsArr.sort(comparePeriods);

			return {
				invalidPeriods: invalidPeriodsArr,
				periods: normalisedPeriodsArr
			};
		},

		/**
		 * Resolves the start and end dates of each requested period
		 * @param {string} startDateIso start date of the anchor period
		 * @param {string} agencyProfileId company the periods belong to
		 * @param {Array} periodsArr normalised periods
		 * @returns {object} promise resolving the resolved periods, an index of them and the pay frequency used
		 */
		resolvePayPeriodDates: (startDateIso, agencyProfileId, periodsArr) => {

			if (!periodsArr || !periodsArr.length) {
				return createFailure({Code: PAY_PERIOD_RESOLUTION_FAILURE_CODES.noPeriodsRequested});
			}

			if (!startDateIso) {
				return createFailure({Code: PAY_PERIOD_RESOLUTION_FAILURE_CODES.startDateInvalid});
			}

			// Only the period identifiers are sent, so any decoration a consumer has added is dropped
			const requestPeriodsArr = periodsArr.map(periodObj => {

				return {
					PeriodNumber: periodObj.PeriodNumber,
					PeriodYear: periodObj.PeriodYear
				};
			});

			return companyData.resolvePayPeriodDates(startDateIso, agencyProfileId, requestPeriodsArr)
				.catch(error => {
					return createFailure({Code: PAY_PERIOD_RESOLUTION_FAILURE_CODES.unknown}, error);
				})
				.then(responseObj => {

					// The platform returns an empty response if it fails before a result can be built
					if (!responseObj) {
						return createFailure({Code: PAY_PERIOD_RESOLUTION_FAILURE_CODES.unknown}, responseObj);
					}

					if (responseObj.Failure) {
						return createFailure(responseObj.Failure);
					}

					const resolvedPeriodsArr = responseObj.ResolvedPeriods;

					if (!resolvedPeriodsArr || !resolvedPeriodsArr.length) {
						return createFailure({Code: PAY_PERIOD_RESOLUTION_FAILURE_CODES.unknown}, responseObj);
					}

					return {
						maximumPeriodNumber: responseObj.MaximumPeriodNumber,
						payPeriodType: responseObj.PayPeriodType,
						resolvedPeriods: resolvedPeriodsArr,
						resolvedPeriodsByKey: getPeriodsByKey(resolvedPeriodsArr)
					};
				});
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('payPeriodSetupService', ['config', 'payPeriodService', 'utilities', 'PAY_DATE_OPTIONS_IDS', 'PAY_PERIOD_ARREARS_TYPES', 'PAY_PERIOD_PAYSLIP_DATE_TYPES', 'PAY_PERIOD_PROCESSING_DATE_TYPES', 'PAY_PERIOD_SETUP_TYPES', 'QBA_OPTIONS',
	function (config, payPeriodService, utilities, PAY_DATE_OPTIONS_IDS, PAY_PERIOD_ARREARS_TYPES, PAY_PERIOD_PAYSLIP_DATE_TYPES, PAY_PERIOD_PROCESSING_DATE_TYPES, PAY_PERIOD_SETUP_TYPES, QBA_OPTIONS) {

	var service = {

		decoratePayPeriodDetails: (periodDetailsObj) => {

			periodDetailsObj.PayPeriodOffsetType = periodDetailsObj.PayPeriodOffsetType < 0 || periodDetailsObj.PayPeriodOffsetType > 2 ? 0 : periodDetailsObj.PayPeriodOffsetType;
			periodDetailsObj.PayPeriodPayslipDayOffset = periodDetailsObj.PayPeriodPayslipDayOffset !== -1 ? periodDetailsObj.PayPeriodPayslipDayOffset : 0;

			periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay = periodDetailsObj.PayPeriodPayslipDayOffset < 0 ? Math.abs(periodDetailsObj.PayPeriodPayslipDayOffset) : 0;
			periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay = periodDetailsObj.PayPeriodPayslipDayOffset > 0 ? Math.abs(periodDetailsObj.PayPeriodPayslipDayOffset) : 0;
			periodDetailsObj.payPeriodArrearsType = service.getPayPeriodArrearsType(periodDetailsObj);
			periodDetailsObj.payPeriodPaymentDayDisplay = service.getPayPeriodPaymentDayDisplay(periodDetailsObj);
			periodDetailsObj.payPeriodPayslipDayType = service.getPayPeriodPayslipDayType(periodDetailsObj);
			periodDetailsObj.payPeriodProcessingDayType = service.getPayPeriodProcessingDayType(periodDetailsObj);
			periodDetailsObj.payPeriodProcessingDayOffsetDisplay = periodDetailsObj.PayPeriodProcessingDayOffset === 0 ? null : angular.copy(periodDetailsObj.PayPeriodProcessingDayOffset);
			periodDetailsObj.periodEndDateISO = service.getEndDateForPeriodType(periodDetailsObj);
			periodDetailsObj.weekNumber = service.getPayPeriodPaymentDayWeekNumber(periodDetailsObj.PayPeriodPaymentDay);

			service.reviewPayslipDay(periodDetailsObj);

			return periodDetailsObj;
		},

		getDescriptionForArrears: (periodDetailsObj) => {

			switch (periodDetailsObj.PayPeriodArrearsCount) {
				case 0:
					return 'No';
				case 1:
					return '1 period';
				case 2:
					return '2 periods';
			}
		},

		getDescriptionForPayDate: (periodDetailsObj) => {

			periodDetailsObj.payPeriodPaymentDayDisplay = service.getPayPeriodPaymentDayDisplay(periodDetailsObj);

			const paymentDay = payPeriodService.getPaymentOptionById(periodDetailsObj.PayPeriodType, periodDetailsObj.payPeriodPaymentDayDisplay);

			switch (periodDetailsObj.PayPeriodType) {

				case PAY_PERIOD_SETUP_TYPES.weekly:

					return paymentDay;

				case PAY_PERIOD_SETUP_TYPES.twoWeekly:
				case PAY_PERIOD_SETUP_TYPES.fourWeekly:

					const weekNumber = service.getPayPeriodPaymentDayWeekNumber(periodDetailsObj.PayPeriodPaymentDay);

					return `${paymentDay}, Week ${weekNumber}`;

				default:

					return paymentDay;

			}
		},

		getDescriptionForProcessingDate: (periodDetailsObj) => {

			switch (periodDetailsObj.PayPeriodArrearsCount) {
				case 0:
					return 'No';
				case 1:
					return '1 period';
				case 2:
					return '2 periods';
			}
		},

		getDescriptionForPayNotifications: (periodDetailsObj) => {

			periodDetailsObj.payPeriodPayslipDayType = service.getPayPeriodPayslipDayType(periodDetailsObj);
			periodDetailsObj.payPeriodPayslipDayOffsetDisplay = Math.abs(periodDetailsObj.PayPeriodPayslipDayOffset);

			switch (periodDetailsObj.payPeriodPayslipDayType) {

				// On payday
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.payday:
					return 'On payday';

				// On payday
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.processingDay:
					return 'On the processing day';

				// After pay day
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay:
					return periodDetailsObj.payPeriodPayslipDayOffsetDisplay > 1 ? `${periodDetailsObj.payPeriodPayslipDayOffsetDisplay} days after payday` : `${periodDetailsObj.payPeriodPayslipDayOffsetDisplay} day after payday`;

				// Before pay day
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay:
					return periodDetailsObj.payPeriodPayslipDayOffsetDisplay > 1 ? `${periodDetailsObj.payPeriodPayslipDayOffsetDisplay} days before payday` : `${periodDetailsObj.payPeriodPayslipDayOffsetDisplay} day before payday`;
			}
		},

		getDescriptionForPayProcessingDate: (periodDetailsObj) => {

			// Offset applied > Custom
			if (periodDetailsObj.PayPeriodProcessingDayOffset > 0) {
				return periodDetailsObj.PayPeriodProcessingDayOffset > 1 ? `${periodDetailsObj.PayPeriodProcessingDayOffset} days before payday` : `${periodDetailsObj.PayPeriodProcessingDayOffset} day before payday`;
			}

			return 'On payday';
		},

		getEndDateForPeriodType: (periodDetailsObj) => {

			if (periodDetailsObj.PeriodStartDateISO === '') {
				return '';
			}

			let startDateMoment = moment(periodDetailsObj.PeriodStartDateISO);

			switch (periodDetailsObj.PayPeriodType) {
				case PAY_PERIOD_SETUP_TYPES.weekly:
					startDateMoment.add(1, 'week');
					break;
				case PAY_PERIOD_SETUP_TYPES.twoWeekly:
					startDateMoment.add(2, 'weeks');
					break;
				case PAY_PERIOD_SETUP_TYPES.fourWeekly:
					startDateMoment.add(4, 'weeks');
					break;
				case PAY_PERIOD_SETUP_TYPES.monthly:
					startDateMoment.add(1, 'month');
					break;
				case PAY_PERIOD_SETUP_TYPES.quarterly:
					startDateMoment.add(3, 'months');
					break;
				case PAY_PERIOD_SETUP_TYPES.annually:
					startDateMoment.add(1, 'year');
					break;
			}

			return startDateMoment.subtract(1, 'day').format(config.dateFormatISO);
		},

		getPayPeriodArrearsType: (periodDetailsObj) => {

			if (periodDetailsObj.PayPeriodArrearsCount > 0) {
				return PAY_PERIOD_ARREARS_TYPES.custom;
			}

			return PAY_PERIOD_ARREARS_TYPES.samePeriod;
		},

		getPayPeriodPaymentDay: (periodDetailsObj) => {

			switch (periodDetailsObj.PayPeriodType) {

				case PAY_PERIOD_SETUP_TYPES.weekly:
				case PAY_PERIOD_SETUP_TYPES.twoWeekly:
				case PAY_PERIOD_SETUP_TYPES.fourWeekly:

					// Handle 'Please select...' state > Has to be a null check otherwise 0 falls into here
					if (periodDetailsObj.payPeriodPaymentDayDisplay === null) {
						return null;
					}


					return periodDetailsObj.payPeriodPaymentDayDisplay + ((periodDetailsObj.weekNumber - 1) * 7);

				default:

					// Handle 'Please select...' state > Has to be a null check otherwise 0 falls into here
					if (periodDetailsObj.PayPeriodPaymentDay === null) {
						return null;
					}

					return periodDetailsObj.PayPeriodPaymentDay;

			}
		},

		getPayPeriodPaymentDayDisplay: (periodDetailsObj) => {

			// Validate value for weeklies
			switch (periodDetailsObj.PayPeriodType) {
				case PAY_PERIOD_SETUP_TYPES.weekly:
				case PAY_PERIOD_SETUP_TYPES.twoWeekly:
				case PAY_PERIOD_SETUP_TYPES.fourWeekly:

					if (periodDetailsObj.PayPeriodPaymentDay < 0) {
						periodDetailsObj.PayPeriodPaymentDay = null;
						return null;
					}
					break;
			}

			switch (periodDetailsObj.PayPeriodType) {

				// Two weekly
				case PAY_PERIOD_SETUP_TYPES.twoWeekly:

					// Second week
					if (periodDetailsObj.PayPeriodPaymentDay > 6) {
						return periodDetailsObj.PayPeriodPaymentDay - 7;
					}

					// First week
					return periodDetailsObj.PayPeriodPaymentDay;

				// Four weekly
				case PAY_PERIOD_SETUP_TYPES.fourWeekly:

					// First week
					if (periodDetailsObj.PayPeriodPaymentDay < 7) {
						return periodDetailsObj.PayPeriodPaymentDay;
					}

					// Second week
					if (periodDetailsObj.PayPeriodPaymentDay < 14) {
						return periodDetailsObj.PayPeriodPaymentDay - 7;
					}

					// Third week
					if (periodDetailsObj.PayPeriodPaymentDay < 21) {
						return periodDetailsObj.PayPeriodPaymentDay - 14;
					}

					// Fourth week
					if (periodDetailsObj.PayPeriodPaymentDay < 28) {
						return periodDetailsObj.PayPeriodPaymentDay - 21;
					}
			}

			return periodDetailsObj.PayPeriodPaymentDay;
		},

		getPayPeriodPaymentDayWeekNumber: payPeriodPaymentDay => {

			// First week
			if (!payPeriodPaymentDay || payPeriodPaymentDay < 7) {
				return 1;
			}

			// Second week
			if (payPeriodPaymentDay < 14) {
				return 2;
			}

			// Third week
			if (payPeriodPaymentDay < 21) {
				return 3;
			}

			// Fourth week
			if (payPeriodPaymentDay < 28) {
				return 4;
			}
		},

		getPayPeriodPayslipDayType: (periodDetailsObj) => {

			if (periodDetailsObj.PayPeriodPayslipOnPayDay) {
				return PAY_PERIOD_PAYSLIP_DATE_TYPES.payday;
			}

			if (periodDetailsObj.PayPeriodPayslipOnProcessingDay) {
				return PAY_PERIOD_PAYSLIP_DATE_TYPES.processingDay;
			}

			if (periodDetailsObj.PayPeriodPayslipDayOffset > 0) {
				return PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay;

			} else {
				return PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay;
			}
		},

		getPayPeriodProcessingDayType: (periodDetailsObj) => {

			// Custom if offset is not defined
			if (periodDetailsObj.PayPeriodProcessingDayOffset !== 0) {
				return PAY_PERIOD_PROCESSING_DATE_TYPES.custom;
			}

			// Payday
			if (periodDetailsObj.PayPeriodProcessingOnPayDay) {
				return PAY_PERIOD_PROCESSING_DATE_TYPES.payday;
			}

			// Custom
			return PAY_PERIOD_PROCESSING_DATE_TYPES.custom;
		},

		reviewActivePeriod: periodDetailsObj => {

			switch (periodDetailsObj.PayPeriodType) {
				case PAY_PERIOD_SETUP_TYPES.biAnnually:
				case PAY_PERIOD_SETUP_TYPES.quarterly:
					periodDetailsObj.ActivePeriodQBA = QBA_OPTIONS.payDateOne;
					break;

				default:
					periodDetailsObj.ActivePeriodQBA = QBA_OPTIONS.none;
					break;
			}
		},

		reviewPayPeriodDetails: (periodDetailsObj) => {

			// Notification / Payslip date
			periodDetailsObj = service.reviewPayslipDay(periodDetailsObj);

			// Payment day
			periodDetailsObj = service.reviewPayPeriodPaymentDay(periodDetailsObj);

			// Processing day
			periodDetailsObj = service.reviewProcessingDay(periodDetailsObj);

			// Period Types
			switch (periodDetailsObj.PayPeriodType) {

				case PAY_PERIOD_SETUP_TYPES.twoWeekly:
					if (periodDetailsObj.weekNumber === 2) {
						periodDetailsObj.PayPeriodPaymentDay = periodDetailsObj.payPeriodPaymentDayDisplay + 7;
					}
					break;
			}

			// Make sure there are no nulls
			if (periodDetailsObj.PayPeriodPaymentDay === null) {
				periodDetailsObj.PayPeriodPaymentDay = 0;
			}
			if (periodDetailsObj.PayPeriodPayslipDay === null) {
				periodDetailsObj.PayPeriodPayslipDay = 0;
			}
			if (periodDetailsObj.PayPeriodProcessingDay === null) {
				periodDetailsObj.PayPeriodProcessingDay = 0;
			}

			return periodDetailsObj;
		},

		reviewPayPeriodPaymentDay: (periodDetailsObj) => {

			periodDetailsObj.PayPeriodPaymentDay = service.getPayPeriodPaymentDay(periodDetailsObj);

			return periodDetailsObj;
		},

		reviewPayslipDay: (periodDetailsObj) => {

			periodDetailsObj.PayPeriodPayslipOnPayDay = false;
			periodDetailsObj.PayPeriodPayslipOnProcessingDay = false;

			// If payslip day is set to 'same as payday', set it to the payday
			switch (periodDetailsObj.payPeriodPayslipDayType) {

				// On payday
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.payday:
					periodDetailsObj.PayPeriodPayslipDay = angular.copy(periodDetailsObj.PayPeriodPaymentDay);
					periodDetailsObj.PayPeriodPayslipDayOffset = 0;
					periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay = null;
					periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay = null;
					periodDetailsObj.PayPeriodPayslipOnPayDay = true;
					break;

				// On processing day
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.processingDay:
					periodDetailsObj.PayPeriodPayslipDay = angular.copy(periodDetailsObj.PayPeriodProcessingDay);
					periodDetailsObj.PayPeriodPayslipDayOffset = 0;
					periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay = null;
					periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay = null;
					periodDetailsObj.PayPeriodPayslipOnProcessingDay = true;
					break;

				// After pay day
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay:

					if (periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay <= 0 || periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay === null) {
						periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay = 1;
					}

					periodDetailsObj.PayPeriodPayslipDay = -1;
					periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay = null;
					periodDetailsObj.PayPeriodPayslipDayOffset = -Math.abs(periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay);
					break;

				// Before pay day
				case PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay:

					if (periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay <= 0 || periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay === null) {
						periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay = 1;
					}

					periodDetailsObj.PayPeriodPayslipDay = -1;
					periodDetailsObj.payPeriodPayslipDayAfterOffsetDisplay = null;
					periodDetailsObj.PayPeriodPayslipDayOffset = Math.abs(periodDetailsObj.payPeriodPayslipDayBeforeOffsetDisplay);
			}

			return periodDetailsObj;
		},

		reviewProcessingDay: (periodDetailsObj) => {

			switch (periodDetailsObj.payPeriodProcessingDayType) {

				case PAY_PERIOD_PROCESSING_DATE_TYPES.custom:

					periodDetailsObj.payPeriodProcessingDayOffsetDisplay = periodDetailsObj.payPeriodProcessingDayOffsetDisplay < 1 ? 1 : periodDetailsObj.payPeriodProcessingDayOffsetDisplay;
					periodDetailsObj.PayPeriodProcessingDay = 0;
					periodDetailsObj.PayPeriodProcessingDayOffset = angular.copy(periodDetailsObj.payPeriodProcessingDayOffsetDisplay);
					periodDetailsObj.PayPeriodProcessingOnPayDay = false;

					break;

				case PAY_PERIOD_PROCESSING_DATE_TYPES.payday:

					periodDetailsObj.payPeriodProcessingDayOffsetDisplay = null;
					periodDetailsObj.PayPeriodProcessingDay = angular.copy(periodDetailsObj.PayPeriodPaymentDay);
					periodDetailsObj.PayPeriodProcessingDayOffset = 0;
					periodDetailsObj.PayPeriodProcessingOnPayDay = true;

					break;
			}

			return periodDetailsObj;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('payslipService', [
	'PAYSLIP_ADDITIONAL_NOTE_VISIBLE',
	'PAYSLIP_PERIOD_VISIBLE',
	function (
		PAYSLIP_ADDITIONAL_NOTE_VISIBLE,
		PAYSLIP_PERIOD_VISIBLE
	) {

		const service = {

			getAdditionalNoteVisibilityBoolFromEnum: payslipPeriodVisibleEnum => {
				return [
					PAYSLIP_ADDITIONAL_NOTE_VISIBLE.all,
					PAYSLIP_ADDITIONAL_NOTE_VISIBLE.pdfOnly,
					PAYSLIP_ADDITIONAL_NOTE_VISIBLE.onlineOnly,
				].includes(payslipPeriodVisibleEnum);
			},

			getAdditionalNoteVisibilityBoolFromEnumForOnlinePayslip: payslipPeriodVisibleEnum => {
				return [
					PAYSLIP_ADDITIONAL_NOTE_VISIBLE.all,
					PAYSLIP_ADDITIONAL_NOTE_VISIBLE.onlineOnly
				].includes(payslipPeriodVisibleEnum);
			},

			getPeriodVisiblityBoolFromEnum: payslipPeriodVisibleEnum => {
				return [
					PAYSLIP_PERIOD_VISIBLE.all,
					PAYSLIP_PERIOD_VISIBLE.pdfOnly,
					PAYSLIP_PERIOD_VISIBLE.onlineOnly,
				].includes(payslipPeriodVisibleEnum);
			},

			getPeriodVisiblityBoolFromEnumForOnlinePayslip: payslipPeriodVisibleEnum => {
				return [
					PAYSLIP_PERIOD_VISIBLE.all,
					PAYSLIP_PERIOD_VISIBLE.onlineOnly
				].includes(payslipPeriodVisibleEnum);
			},

		};

		return service;
	}
]);

'use strict';

angular.module('paycircleApp')
.service('paymentScheduleService', ['adjustmentsService', function (adjustmentsService) {

	const service = {

		decoratePaymentScheduleGroup: paymentScheduleGroupObj => {

			paymentScheduleGroupObj.hasPaidScheduleEntry = service.getHasPaidScheduleEntry(paymentScheduleGroupObj.ScheduleEntries);

			paymentScheduleGroupObj.canDelete = !paymentScheduleGroupObj.hasPaidScheduleEntry;
			paymentScheduleGroupObj.canEdit = !paymentScheduleGroupObj.hasPaidScheduleEntry;
			paymentScheduleGroupObj.isBIKBehaviourApplicable = !adjustmentsService.getIsAdjustmentBehaviourOffLocked(paymentScheduleGroupObj.PaymentScheduleGroupPayrollBIKBehaviour); // Not enabled at company settings level
			paymentScheduleGroupObj.paymentScheduleGroupPayrollBIKBehaviourLocked = adjustmentsService.getIsAdjustmentBehaviourLocked(paymentScheduleGroupObj.PaymentScheduleGroupPayrollBIKBehaviour);
			paymentScheduleGroupObj.payslipLabelSave = false;

			return paymentScheduleGroupObj;
		},

		getCanEditPaymentSchedule: paymentScheduleGroupObj => {

			if (paymentScheduleGroupObj.ScheduleEntries.length === 0) {
				return true;
			}

			return service.getHasPaidScheduleEntry(paymentScheduleGroupObj.ScheduleEntries) ? false : true;
		},

		getHasPaidScheduleEntry: scheduleEntriesArr => {

			const numberOfEntries = scheduleEntriesArr.length;
			let i = 0;

			for (i; i < numberOfEntries; i++) {

				let scheduledEntryObj = scheduleEntriesArr[i];

				if (scheduledEntryObj.IsPaid) {
					return true;
				}
			}

			return false;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('pensionService', [
	'$filter',
	'$state',
	'config',
	'MAIL_TYPES',
	'PENSION_ENROLMENT_STATES',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS',
	'PENSION_SUBMISSION_STATES',
	'PENSION_TYPES',
	function (
		$filter,
		$state,
		config,
		MAIL_TYPES,
		PENSION_ENROLMENT_STATES,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SUBMISSION_STATES,
		PENSION_TYPES
	) {

	const service = {

		decoratePensionGroup: pensionGroupObj => {

			pensionGroupObj.totalPercent = pensionGroupObj.EmployeePercent + pensionGroupObj.EmployerPercent;

			return pensionGroupObj;
		},

		decorateNewPensionGroup: (pensionGroupObj, payeDetailsObj) => {

			return angular.extend(pensionGroupObj, {
				CanBeDeleted: true,
				CanUpdateContributionBasis: true,
				CanUpdatePensionGroupName: true,
				CanUpdatePercentages: true,
				CanUpdateSalarySacrifice: true,
				EmployeePercent: payeDetailsObj.PensionEmployeePercentMinimum,
				EmployerPercent: payeDetailsObj.PensionEmployerPercentMinimum,
				PensionGroupName: ''
			});
		},

		filterDirectConnectionProvidersOnly: pensionProviderObj => {
			return pensionProviderObj.PensionProviderHasAPI;
		},

		/**
		 * Get AE pensions from pensions list. Sort them according to additional post status and job title
		 * @param {Array<any>} pensionObjArr - array of pensions, or objects including pensions (in the latter case,
		 * pensionPropertyName should be specified) of any mixed types
		 * @param {PENSION_TYPES} pensionType - pension type to filter on. Optional. If not specified, the list will
		 * be sorted only, not filtered. PENSION_TYPES.all can be used here to avoid an ugly 'undefined' in the function call.
		 * @param {string} pensionPropertyName - use to reference the pension object in the array. For example, certain API
		 * calls will return a pension payment history, with the pension object under 'PensionDetails' in each array item.
		 * Optional. If not specified, the top level objects in the array will be treated as Pension objects
		 */
		filterAndSortPensions: (pensionObjArr, pensionType, pensionPropertyName) => {

			// Filter on pension type if specified.
			if (angular.isDefined(pensionType) && pensionType !== PENSION_TYPES.all) {
				pensionObjArr = pensionObjArr.filter(pensionObj => {
					if (angular.isDefined(pensionPropertyName)) {
						return pensionObj[pensionPropertyName].PensionType === pensionType;
					}
					else {
						return pensionObj.PensionType === pensionType;
					}
				});
			}

			/* Order these so that the main post pension (IsAdditionalPost == false) comes first, then subsequent pensions
			   for additional posts are in job title order */
			pensionObjArr.sort((pensionObjA, pensionObjB) => {

				// Get dereferenced pension object for comparison, depending on pensionPropertyName
				if (angular.isDefined(pensionPropertyName)) {
					pensionObjA = pensionObjA[pensionPropertyName];
					pensionObjB = pensionObjB[pensionPropertyName];
				}

				// Ensure pension objects have the correct attributes for sorting
				if (angular.isUndefined(pensionObjA.IsAdditionalPost) ||
					angular.isUndefined(pensionObjB.IsAdditionalPost) ||
					angular.isUndefined(pensionObjA.SalaryPolicyPostTitle) ||
					angular.isUndefined(pensionObjB.SalaryPolicyPostTitle)) {

					// These can't be sorted, assume they're equal in that case
					return 0;
				}

				if (!pensionObjA.IsAdditionalPost && pensionObjB.IsAdditionalPost) {
					// A is for main post, B for additional. A comes first.
					return -1;
				}
				else if (pensionObjA.IsAdditionalPost && !pensionObjB.IsAdditionalPost) {
					// A is for additional post, B for main. B comes first.
					return 1;
				}
				else if (pensionObjA.IsAdditionalPost && pensionObjB.IsAdditionalPost) {
					// Both are additional post pensions, sort by post title
					const salaryPolicyPostTitleA = pensionObjA.SalaryPolicyPostTitle.toLowerCase();
					const salaryPolicyPostTitleB = pensionObjB.SalaryPolicyPostTitle.toLowerCase();
					if (salaryPolicyPostTitleA > salaryPolicyPostTitleB) {
						return 1;
					}
					else if (salaryPolicyPostTitleA < salaryPolicyPostTitleB) {
						return -1;
					}
					else {
						return 0;
					}
				}
				else {
					/* Main post AE pensions are treated equally, but there will be just one*
					   *(All information correct at time of writing) */
					return 0;
				}
			});

			return pensionObjArr;
		},

		getCanSwitchAEPension: (teamMemberObj, pensionsArr) => {

			/*
				Omit from RTI -
				If company has multiple AE schemes, and the team member has been in one of them while omitted,
				the radio options should be disabled when editing the scheme from the green Pension block in their setup profile (i.e. you can't switch AE schemes)
			*/
			const isTeamMemberIncludedInRTIAfterBeingOmitted = (
				teamMemberObj.IsInRetrospectivePayrollSetupMode &&
				teamMemberObj.CanSwitchToOmitFromRTI &&
				pensionsArr.length > 0 &&
				angular.isDefined(teamMemberObj.Pensions.find(service.isAEPension))
			);

			return !isTeamMemberIncludedInRTIAfterBeingOmitted;
		},

		getDeadlinesArray: () => {
			return [
				{
					id: 'pension-introduction',
					auto: true,
					canPreview: true,
					canSendManually: true,
					name: 'Pension Introduction',
					mailTypeId: MAIL_TYPES.pensionIntroduction,
					popupPosition: 'left',
					description: 'This is an email that gets automatically sent to your team on your company\'s Start Date, providing that you are set up on Paycircle and your team all have email addresses. This communication outlines what the workplace pension is about and what people can expect. If you would like this to go out before your Start Date or if you set up your Paycircle account after your Start Date then you can send this manually. You can send it anytime up until you run your first payroll after your Start Date has passed.',
					date: 'Start date'
				},
				{
					id: 'postponement-notice',
					auto: false,
					canPreview: true,
					canSendManually: false,
					name: 'Postponement Notice',
					mailTypeId: MAIL_TYPES.postponementNotice,
					popupPosition: null,
					description: 'You can postpone the initial assessment of your team by up to three months. If you choose to postpone then your team must receive a communication within 6 weeks of your company’s Start Date. Paycircle will automatically send this communication when you run your first payroll after you elect to postpone your team.',
					date: 'First payday after start date'
				},
				{
					id: 'assessment-status',
					auto: false,
					canPreview: false,
					canSendManually: false,
					name: 'Assessment Status',
					mailTypeId: MAIL_TYPES.assessmentStatus,
					popupPosition: null,
					description: 'Your team must be sent a communication every time they are assessed, particularly someone’s status changes. Paycircle will automatically send this communication when payroll is run and when a person is assessed for the first time or reassessed due to a status change.',
					date: 'First payday after start date'
				},
				{
					id: 'pension-summary',
					auto: false,
					canPreview: true,
					canSendManually: true,
					name: 'Pension Summary',
					mailTypeId: MAIL_TYPES.complianceFollowUp,
					popupPosition: 'right',
					description: 'Even though it\'s not compulsory, we think it\'s a good idea to give everyone access to comprehensive information regarding the workplace pension, regardless of their status or eligibility. We have compiled a full, easy to understand, Guide for Employees and this will automatically be sent to all team members 5 weeks after your Start Date.',
					date: '5 weeks after original start date'
				},
				{
					id: 'postponement-notice-individual',
					auto: false,
					canPreview: true,
					canSendManually: false,
					name: 'Individual postponement notice',
					mailTypeId: MAIL_TYPES.postponeEligible,
					popupPosition: 'right',
					description: 'You can postpone the initial assessment of any new team member for up to 3 months, you can also postpone an individual when they become eligible for the first time. If you choose to postpone individuals, you need to send them a communication to let them know. Paycircle does this automatically whenever you select to postpone someone.',
					date: 'First payday after joining'
				}
			];
		},

		getDefaultPensionForAdjustment: pensionsArr => {

			if (pensionsArr.length === 0) {
				return;
			}

			// If list contains a record where IsGhostPension == true, default to a pension where PensionType == 1
			// If list does not contain a record where IsGhostPension == true, default to a pension where PensionType == 0

			const defaultPensionType = pensionsArr.some(pensionObj => pensionObj.IsGhostPension) ? PENSION_TYPES.nonAutoEnrolment : PENSION_TYPES.autoEnrolment;
			const defaultPensionObj = pensionsArr.find(pensionObj => pensionObj.PensionType === defaultPensionType);

			return angular.isObject(defaultPensionObj) ? defaultPensionObj : pensionsArr[0];
		},

		getDefaultPensionGroup: (pensionObj, payeDetailsObj) => {

			const pensionGroupObj = angular.copy(pensionObj.PensionGroups[0]);

			return service.decorateNewPensionGroup(pensionGroupObj, payeDetailsObj);
		},

		getIsPensionSubmittedForPeriod: payPeriodObj => {

			switch (payPeriodObj.PensionSubmitState) {
				case PENSION_SUBMISSION_STATES.submitted:
				case PENSION_SUBMISSION_STATES.submitting:
				case PENSION_SUBMISSION_STATES.queued: {
					return true;
				}
			}

			return false;
		},

		getOrderedPensionsArray: pensionsArr => {

			if (pensionsArr.length === 0) {
				return pensionsArr;
			}

			const aePensionIndex = pensionsArr.findIndex(pensionObj => pensionObj.PensionType === PENSION_TYPES.autoEnrolment);
			const aePensionObj = angular.copy(pensionsArr[aePensionIndex]);

			if (aePensionIndex > -1) {

				// Remove AE pension from array
				pensionsArr.splice(aePensionIndex, 1);

				// Move excluded pension to end of array
				if (aePensionObj.PensionState === PENSION_ENROLMENT_STATES.excluded) {
					pensionsArr.push(aePensionObj);

				} else {

					// Bring non-excluded pension to beginning of array
					pensionsArr.unshift(aePensionObj);
				}
			}

			return pensionsArr;
		},

		getPostponementDateBoundaries: stagingDateIso => {

			if (stagingDateIso) {
				return {
					postponedDateMaxISO: moment(stagingDateIso).add(3, 'months').format(),
					postponedDateMinISO: moment(stagingDateIso).add(1, 'days').format()
				};

			} else {
				return null;
			}
		},

		getSchemeReferenceFormatDescription: (pensionDetailsObj) => {
			const schemeReferenceFormatDescription = PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS.find(pensionSchemeReferenceDisplayType => {
				return pensionDetailsObj.PensionSettingDetails.SchemeReferenceDisplayType === pensionSchemeReferenceDisplayType.id;
			});
			if (angular.isDefined(schemeReferenceFormatDescription)) {
				return schemeReferenceFormatDescription.description;
			}
			else {
				return '';
			}
		},

		getStagingDateBoundaries: () => {
			return {
				stagingDateISOMax: moment().add(1, 'years').format()
			};
		},

		getStyleForPension: (teamMemberObj, currentCompanyObj, pensionObj) => {

			if (teamMemberObj.IsInPensionSetupMode) {

				if (currentCompanyObj.HasPension) {
					return 'secondary';

				} else {
					return 'greyscale';
				}

			} else {

				if (service.isAEPension(pensionObj)) {
					// If this is an additional post pension that is in setup mode, or pension not selected, colour it secondary
					if (pensionObj.IsAdditionalPost && (pensionObj.IsInPensionSetupMode || !pensionObj.PensionSchemeSetupComplete)) {
						return 'secondary';
					}
					else {
						return $filter('pensionStateClass')(pensionObj.PensionState);
					}

				} else {
					return 'secondary';
				}

			}
		},

		getTeamMemberPensionById: (teamMemberPensionsArr, agencyEmployerPensionId) => {
			return teamMemberPensionsArr.find(pensionObj => pensionObj.AgencyEmployerPensionID === agencyEmployerPensionId);
		},

		/**
		 * Get a team member AE pension. Once non-AEs are filtered from the list, this is identified by two IDs. If no identifying properties are provided,
		 * the first AE pension is returned by default.
		 * Main post pension (set up): agencyEmployePensionId === empty guid, pensionAdditionalPostId === empty guid
		 * Additional post pension (set up): agencyEmployePensionId === empty guid, pensionAdditionalPostId !== empty guid
		 * Main post pension (post set up): agencyEmployePensionId !== empty guid, pensionAdditionalPostId === empty guid
		 * Additional post pension (post set up): agencyEmployePensionId !== empty guid, pensionAdditionalPostId !== empty guid
		 * @param {Array<Pension>} teamMemberPensionsArr - array of pensions attached to team member
		 * @param {Guid} agencyEmployerPensionId - pension ID of pension. Could be empty Guid if pension not set up yet.
		 * 										   If falsy, this will be set to empty Guid.
		 * @param {Guid} pensionAdditionalPostId - additional post ID (SalaryPolicyPostID) of pension. Could be empty guid if pension is associated to main post.
		 * 										   If falsy, this will be set to empty Guid.
		 * @returns {Pension} - The pension. Either as identified by the IDs, or the first AE pension if no IDs provided.
		 */
		getTeamMemberAEPension: (teamMemberPensionsArr, agencyEmployerPensionId, pensionAdditionalPostId) => {

			// If no identifying properties have been specified, there's been no pension assignment, so just return the first AE pension
			if (angular.isUndefined(agencyEmployerPensionId) && angular.isUndefined(pensionAdditionalPostId)) {
				return teamMemberPensionsArr.find(service.isAEPension);
			}
			else {
				// Default identifiers to empty guids. Both shouldn't be undefined at this point
				agencyEmployerPensionId = agencyEmployerPensionId || config.guidEmpty;
				pensionAdditionalPostId = pensionAdditionalPostId || config.guidEmpty;

				// Find the AE pension with the corresponding IDs
				return teamMemberPensionsArr.find(pension => {
					return service.isAEPension(pension) &&
						   pension.AgencyEmployerPensionID === agencyEmployerPensionId &&
						   pension.SalaryPolicyPostID === pensionAdditionalPostId;
				});
			}
		},

		getTeamMemberSelectedPensionGroup: (pensionGroupArr, teamMemberPensionObj) => {
			return pensionGroupArr
					.filter(service.decoratePensionGroup)
					.find(pensionGroupObj => pensionGroupObj.PensionGroupID === teamMemberPensionObj.PensionGroupID);
		},

		goToGhostPensionSettings: (pensionSummaryObj, agencyProfileId) => {

			const ghostPensionObj = pensionSummaryObj.Pensions.find(pensionObj => pensionObj.IsGhostPension);

			$state.go('pensions.scheme.settings', {
				agencyEmployerPensionId: ghostPensionObj.AgencyEmployerPensionID,
				agencyProfileId
			});
		},

		isAEPension: pensionObj => {
			return pensionObj.PensionType === PENSION_TYPES.autoEnrolment;
		},

		isNonAEPension: pensionObj => {
			return pensionObj.PensionType === PENSION_TYPES.nonAutoEnrolment;
		},

		resetTeamMemberEmployeePercent: (teamMemberPensionObj, selectedPensionGroupObj) => {
			teamMemberPensionObj.PensionEmployeePercent = selectedPensionGroupObj.EmployeePercent;
		},

		resetTeamMemberEmployerPercent: (teamMemberPensionObj, selectedPensionGroupObj) => {
			teamMemberPensionObj.PensionEmployerPercent = selectedPensionGroupObj.EmployerPercent;
		},

		resetTeamMemberPensionToGroup: (teamMemberPensionObj, selectedPensionGroupObj) => {

			service.resetTeamMemberEmployeePercent(teamMemberPensionObj, selectedPensionGroupObj);
			service.resetTeamMemberEmployerPercent(teamMemberPensionObj, selectedPensionGroupObj);

			angular.extend(teamMemberPensionObj, {
				HasFixedEmployeeContribution: false,
				HasFixedEmployerContribution: false,
			});
		},

		setDefaultsForNonAEPension: pensionObj => {

			angular.extend(pensionObj, {
				PensionType: PENSION_TYPES.nonAutoEnrolment,
				IsGhostPension: false,
				SchemeReferenceDisplayType: PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference
			});

			// Set first pension group as default
			for (let pensionGroupObj of pensionObj.PensionGroups) {
				pensionGroupObj.IsDefault = false;
			}

			pensionObj.PensionGroups[0].IsDefault = true;
		},

		setTeamMemberPensionValuesToGroup: (teamMemberPensionObj, selectedPensionGroupObj) => {

			angular.extend(teamMemberPensionObj, {
				// Set percentage amounts back to group
				PensionEmployeePercent: selectedPensionGroupObj.EmployeePercent,
				PensionEmployerPercent: selectedPensionGroupObj.EmployerPercent,

				// Reset fixed amounts
				PensionEmployeeFixedAmount: 0,
				PensionEmployerFixedAmount: 0,

				// Reset group
				PensionGroupID: selectedPensionGroupObj.PensionGroupID,

				// Reset salary sacrifice
				IsSalarySacrifice: selectedPensionGroupObj.IsSalarySacrifice
			});
		},

		toggleTeamMemberCustomEmployeeContributionType: (teamMemberPensionObj, selectedPensionGroupObj) => {

			teamMemberPensionObj.HasFixedEmployeeContribution = !teamMemberPensionObj.HasFixedEmployeeContribution;

			// Reset employee percent to group default
			if (teamMemberPensionObj.HasFixedEmployeeContribution) {
				teamMemberPensionObj.PensionEmployeeFixedAmount = null;
				service.resetTeamMemberEmployeePercent(teamMemberPensionObj, selectedPensionGroupObj);
			}

			// Reset employee fixed amount to 0
			else {
				teamMemberPensionObj.PensionEmployeeFixedAmount = 0;
			}
		},

		toggleTeamMemberCustomEmployerContributionType: (teamMemberPensionObj, selectedPensionGroupObj) => {

			teamMemberPensionObj.HasFixedEmployerContribution = !teamMemberPensionObj.HasFixedEmployerContribution;

			// Reset employer percent to group default
			if (teamMemberPensionObj.HasFixedEmployerContribution) {
				teamMemberPensionObj.PensionEmployerFixedAmount = null;
				service.resetTeamMemberEmployerPercent(teamMemberPensionObj, selectedPensionGroupObj);
			}

			// Reset employer fixed amount to 0
			else {
				teamMemberPensionObj.PensionEmployerFixedAmount = 0;
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('pendoService', [
	'$window',
	'utilities',
	function (
		$window,
		utilities
	) {

	const pendoService = {

		initialize: (userObj) => {

			if (!pendoService.isPendoInitialized() ||
				!userObj.IsAccessWorkspaceAccount ||
				!userObj.AccessWorkspaceUserID ||
				!userObj.AccessWorkspaceOrganisationApplicationSubscriptionID) {
				return;
			}

			$window.pendo.initialize({
				visitor: {
					id: userObj.AccessWorkspaceUserID, // REQUIRED: unique user ID
					email: userObj.AccountEmailAddress, // Optional metadata
					role: utilities.getPrimaryRole(userObj.UserResponseRoles), // Optional metadata
					parentCompanyName: userObj.AgencyProfileName // Optional metadata
				},
				parentAccount: {
					id: userObj.AccessWorkspaceOrganisationApplicationSubscriptionID // REQUIRED: unique org/customer ID of user
				},
				localStorageOnly: true
			});
		},

		destroy: () => {

			if (!pendoService.isPendoInitialized()) {
				return;
			}

			$window.pendo.teardown();
		},

		isPendoInitialized: () => {
			
			if ($window.location.hostname === 'localhost') {
				return false;
			}

			if (!$window.pendo) {
				return false;
			}
			
			return true;
		},

		setCompany: (companyObj) => {

			if (!pendoService.isPendoInitialized()) {
				return;
			}

			$window.pendo.updateOptions({
				account: {
					id: companyObj.AgencyProfileID, // REQUIRED: unique ID of payroll company
					currentCompanyName: companyObj.Name, // Optional metadata
					currentCompanyHasPeopleHRIntegration: companyObj.IsPeopleHRIntegrationEnabled, // Optional metadata
					currentCompanyHasRotareadyIntegration: companyObj.IsRotareadyIntegrationEnabled // Optional metadata
				}
			});
		}
	};

	return pendoService;
}]);

'use strict';

angular.module('paycircleApp')
	.factory('PEOPLE_HR_UPDATES', [
		'$filter',
		'PEOPLE_HR_UPDATES_EVENT_NAMES',
		'PEOPLE_HR_UPDATES_EVENT_STATUS',
		function (
			$filter,
			PEOPLE_HR_UPDATES_EVENT_NAMES,
			PEOPLE_HR_UPDATES_EVENT_STATUS
	) {

		return {
			buildEventText: function(eventName, eventStatus, dateAndTime) {

				const mapObj = {
					[PEOPLE_HR_UPDATES_EVENT_NAMES.deductionCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring deduction created',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring deduction creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring deduction creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.deductionDeleted]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring deduction deleted',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring deduction deletion failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring deduction deletion received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.deductionUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring deduction updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring deduction update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring deduction update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.employeeBankDetailsUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Bank details updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Bank details update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Bank details update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.employeeContactDetailsUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Contact details updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Contact details update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Contact details update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.employeeCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Team Member created',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Team Member creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Team Member creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.employeeDetailsUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Team member details updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Team member details update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Team member details update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.employeeLeaver]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Team member leaver details updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Team member leaver details update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Team member leaver details update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring addition created',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring addition creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring addition creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementDeleted]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring addition deleted',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring addition deletion failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring addition deletion received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.entitlementUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Recurring addition updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Recurring addition update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Recurring addition update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off addition created',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One-off addition creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off addition creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentDeleted]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off addition deleted',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One-off addition deletion failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off addition deletion received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off addition updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One-off addition update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off addition update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off deduction created',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One=off deduction creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off deduction creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionDeleted]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off deduction deleted',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One-off deduction deletion failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off deduction deletion received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'One-off deduction updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'One-off deduction update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'One-off deduction update received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.salaryCreated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Pay information added',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Pay information creation failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Pay information creation received'
					},
					[PEOPLE_HR_UPDATES_EVENT_NAMES.salaryUpdated]: {
						[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'Pay information updated',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'Pay information update failed',
						[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'Pay information update received'
					}
			};

			return mapObj[eventName][eventStatus] + ' at ' +  $filter('dateformat')(dateAndTime, 'timeDayDate');
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.service('permissionsService', [
	'$filter',
	'$rootScope',
	'$state',
	'$timeout',
	'applicationService',
	'config',
	'paycircleService',
	'utilities',
	'workflowService',
	'INTERFACE_TYPES',
	'LOCAL_STORAGE_KEYS',
	'PERMISSION_ACTION_GROUPS',
	'PERMISSION_GROUP_KEYS',
	'PERMISSION_ROLE_IDS',
	'PERMISSION_ROLES_ORDER',
	'SUBMISSION_STATES',
	'USER_MESSAGE_BAR_STATES',
	'USER_ROLE_IDS',
	'USER_ROLES',
	function (
		$filter,
		$rootScope,
		$state,
		$timeout,
		applicationService,
		config,
		paycircleService,
		utilities,
		workflowService,
		INTERFACE_TYPES,
		LOCAL_STORAGE_KEYS,
		PERMISSION_ACTION_GROUPS,
		PERMISSION_GROUP_KEYS,
		PERMISSION_ROLE_IDS,
		PERMISSION_ROLES_ORDER,
		SUBMISSION_STATES,
		USER_MESSAGE_BAR_STATES,
		USER_ROLE_IDS,
		USER_ROLES
	) {

	const service = {

		attachTempPermissionsForUser: userResponseObj => {

			// Temporary Permissions
			const tempPermissionsObj = utilities.getObjectFromStorage(LOCAL_STORAGE_KEYS.tempPermissions, null);

			if (tempPermissionsObj) {

				// Merge data with user response
				angular.merge(userResponseObj, tempPermissionsObj);

				// Show app user message
				if (tempPermissionsObj.viewingAs.name) {
					applicationService.setUserMessageState(USER_MESSAGE_BAR_STATES.viewingUserPermissions);
				} else {
					applicationService.setUserMessageState(USER_MESSAGE_BAR_STATES.viewingRolePermisisons);
				}
			}

			// Used in app message bar
			userResponseObj.hasTempPermissions = angular.isObject(tempPermissionsObj);
		},

		calculateActiveActionsCount: groupObj => {
			groupObj.groupTotalActive = groupObj.GroupVisible ? groupObj.GroupPermissionActions.filter(permissionActionObj => permissionActionObj.IsActive).length : 0;
		},

		calculateRoleActiveActionsCount: roleObj => {
			return roleObj.Groups.reduce((roleActiveActionsCount, groupObj) => groupObj.GroupVisible ? roleActiveActionsCount += groupObj.groupTotalActive+1 : roleActiveActionsCount, 0);
		},

		decoratePermissionActionGroup: (roleType) => {

			return permissionActionGroupObj => {

				const permissionActionGroupMeta = service.getPermissionActionGroupById(permissionActionGroupObj.GroupType);

				if (!permissionActionGroupMeta) {
					$rootScope.paycircleMessage('Unable to map permission group meta to permission action group', 'warn');
					return;
				}

				// Decorate groups with titles and actions
				angular.merge(permissionActionGroupObj, permissionActionGroupMeta);

				service.mapPermissions(permissionActionGroupObj, roleType);

				service.calculateActiveActionsCount(permissionActionGroupObj);

				return permissionActionGroupObj;
			};
		},

		decorateRole: roleObj => {

			const roleName = $filter('roleTypeMeta')(roleObj.RoleType, 'name');

			// Don't return role if it's not setup in the UI
			if (!roleName) {
				return false;
			}

			roleObj.Groups = roleObj.Groups.filter(service.decoratePermissionActionGroup(roleObj.RoleType));

			return angular.extend(roleObj, {
				roleActiveActionsCount: service.calculateRoleActiveActionsCount(roleObj),
				roleDescription: $filter('roleTypeMeta')(roleObj.RoleType, 'description'),
				roleName: roleName,
				roleOrder: $filter('roleTypeMeta')(roleObj.RoleType, 'order')
			});
		},

		disableAdminViewMode: () => {

			// Show loader
			applicationService.displaySecondaryLoader('Changing roles and permissions');

			// Get and clear temp role data
			const exitDataObj = angular.copy($rootScope.currentUser.adminViewExitData);
			utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.tempPermissions);

			// Allow for message to be viewed
			$timeout(() => {

				// Hide app user bar
				applicationService.setUserMessageState(null);

				// Remove overwritten user data
				angular.merge($rootScope.currentUser, exitDataObj.userResponse);

				// Delete temp role data from user
				delete $rootScope.currentUser.viewingAs;
				delete $rootScope.currentUser.adminViewExitData;

				// Return saved companies
				$rootScope.$broadcast('reassign-stored-companies', exitDataObj.companiesStorage);

				// Refresh $rootScope.currentUser
				applicationService.refreshUser();

				// Refresh $rootScope.currentCompany
				applicationService.refreshCompany();

				// Take user to saved state
				$state.go(exitDataObj.state.name, exitDataObj.state.params);

				applicationService.hideSecondaryLoader();
			}, 3000);
		},

		enableAdminViewMode: (permissionRoleDetailObj, viewingAsCompanyId, viewingAsCompanyName, viewingAsName, viewingAsUserId) => {

			// Show loader
			applicationService.displaySecondaryLoader('Changing roles and permissions');

			// Get role key from permission role
			const roleKey = service.getRoleKeyForRoleType(permissionRoleDetailObj.RoleType);

			utilities.addObjectToStorage(LOCAL_STORAGE_KEYS.tempPermissions, {

				// User data to overwrite current data
				Access: service.getPermissionSetForRole(permissionRoleDetailObj),
				AgencyProfileName: viewingAsCompanyName,
				IsMultipleCompanyAdmin: [USER_ROLES.bureaumanager, USER_ROLES.bureau, USER_ROLES.groupuser, USER_ROLES.groupadminlite].includes(roleKey),
				UserResponseRoles: [roleKey],
				defaultLandingPage: utilities.getRoleUrl(roleKey),

				// Store date to use when exiting admin view
				adminViewExitData: {
					companiesStorage: {
						companies: angular.copy($rootScope.companies),
						currentCompany: angular.copy($rootScope.currentCompany)
					},
					state: {
						params: angular.copy($state.params),
						name: $state.current.name
					},
					userResponse: {
						Access: angular.copy($rootScope.currentUser.Access),
						AgencyProfileName: $rootScope.currentUser.AgencyProfileName,
						IsMultipleCompanyAdmin: $rootScope.currentUser.IsMultipleCompanyAdmin,
						UserResponseRoles: angular.copy($rootScope.currentUser.UserResponseRoles),
						defaultLandingPage: $rootScope.currentUser.defaultLandingPage
					}
				},

				// Attach company and admin details
				viewingAs: {
					company: viewingAsCompanyId,
					name: viewingAsName,
					userId: viewingAsUserId,
					roleType: permissionRoleDetailObj.RoleType
				}
			});

			// Allow for message to be viewed
			$timeout(() => {

				// Refresh $rootScope.currentUser
				applicationService.refreshUser();

				// Refresh $rootScope.currentCompany
				applicationService.refreshCompany();

				// Reset app header
				$rootScope.$broadcast('reset-company-storage');

				// Take user to default page
				$state.go(utilities.getRoleUrl(roleKey), {
					agencyProfileId: viewingAsCompanyId,
				});

				applicationService.hideSecondaryLoader();
			}, 3000);
		},

		getCanEditAdminPermissionForCompany: companyObj => {

			switch (companyObj.CompanyType) {
				case INTERFACE_TYPES.bureau:
					return service.getPermissionValueByString($rootScope.currentUser, 'Admin.canManageBureauAdmins', 'edit-admin-permission');

				case INTERFACE_TYPES.group:
					return service.getPermissionValueByString($rootScope.currentUser, 'Admin.canManageCompanyGroupAdmins', 'edit-admin-permission');

				default:
					return service.getPermissionValueByString($rootScope.currentUser, 'CompanySettings.canAccessPermissions', 'edit-admin-permission');
			}
		},

		getIsPermissionRoleVisibleForCompany: (roleType, companyObj) => {

			switch (companyObj.CompanyType) {
				case INTERFACE_TYPES.bureau:
					return roleType === PERMISSION_ROLE_IDS.teamMember;

				case INTERFACE_TYPES.group:
					return [
						PERMISSION_ROLE_IDS.groupAdmin,
						PERMISSION_ROLE_IDS.groupAdminLite
					].includes(roleType);

				case INTERFACE_TYPES.actualonly:
				case INTERFACE_TYPES.pensiononly:
				case INTERFACE_TYPES.agency:
				case INTERFACE_TYPES.cisonly:
					return [
						PERMISSION_ROLE_IDS.companyAdmin,
						PERMISSION_ROLE_IDS.companyadministratorlite,
						PERMISSION_ROLE_IDS.departmentadmin
					].includes(roleType);
			}
		},

		getPermissionActionGroupById: permissionGroupId => {

			const permissionGroupObj = utilities.getArrayItemByPropertyName(PERMISSION_ACTION_GROUPS, 'groupKey', permissionGroupId);

			return angular.copy(permissionGroupObj);
		},

		getPermissionSetForRole: permissionRoleObj => {
			return permissionRoleObj.Groups.map(permissionRoleGroupObj => permissionRoleGroupObj.GroupValue);
		},

		getPermissionsForStateCurrentPeriod: loggedInUserObj => {

			const isLiteAdminRole = $rootScope.userHasRole(['groupadminlite', 'companyadministratorlite']);

			let permissionsObj = {
				isAddChangeVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canUpdateAdjustments', 'current-period'),
				isAlertsVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canManageAlerts', 'current-period'),
				isCalculateVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canCalculatePayroll', 'current-period'),
				isChangesVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canViewChanges', 'current-period'),
				isChangesTableVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canEditChangesTable', 'current-period'),
				isFinishPeriodStateVisible: false,
				isHourlyTotalsVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canAddHourlyTotals', 'current-period'),
				isImportsVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canUpdateImports', 'current-period'),
				isLinkRatesVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canAddLinkRates', 'current-period'),
				isNotesVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canUpdateNotes', 'current-period'),
				isPensionVisible: !isLiteAdminRole,
				isTasksVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canUpdateTasks', 'current-period'),
				isTaxUpdatesVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canUpdateTaxUpdates', 'current-period'),
				isTeamVisible: service.getPermissionValueByString(loggedInUserObj, 'isTeamVisible', 'current-period')
			};

			return permissionsObj;
		},

		getPermissionsForStateSupplementaryPayRun: (loggedInUserObj, supplementaryPaymentObj) => {

			const isSmeLiteRole = $rootScope.userHasRole('companyadministratorlite');
			const isGroupAdminLiteRole = $rootScope.userHasRole('groupadminlite');

			let permissionsObj = {
				isChangesVisible: service.getPermissionValueByString(loggedInUserObj, 'Payroll.canViewChanges', 'supp-run'),
				isReceiptsVisible: !isSmeLiteRole && !isGroupAdminLiteRole && supplementaryPaymentObj.SupplementaryPaymentState === SUBMISSION_STATES.submitted,
				isReportsVisible: service.getPermissionValueByString(loggedInUserObj, 'isReportingVisible', 'supp-run')
			};

			return permissionsObj;
		},

		getPermissionsForStateRunPayroll: (payPeriodObj, companyObj, loggedInUserObj, workflowTemplatesArr) => {

			const isSmeLiteRole = $rootScope.userHasRole(['groupadminlite', 'companyadministratorlite']);
			const canCalculatePayroll = service.getPermissionValueByString(loggedInUserObj, 'Payroll.canCalculatePayroll', 'run-payroll');
			const isWorkflowActive = workflowService.isWorkflowActive(companyObj, workflowTemplatesArr);

			let isPayrollLockedVisible = false;
			let isRunPayrollVisible = true;
			let isUnlockPayrollVisible = false;

			// Workflow
			if (isWorkflowActive && workflowTemplatesArr.length > 0) {

				const workflowTemplateObj = workflowTemplatesArr[0];

				isPayrollLockedVisible = workflowTemplateObj.IsPayrollLocked && !isSmeLiteRole;
				isRunPayrollVisible = false;
				isUnlockPayrollVisible = workflowTemplateObj.IsPayrollLocked && canCalculatePayroll && !isSmeLiteRole && workflowTemplateObj.TemplateEntryCurrent.Number === 2;
			}
			else if (!isWorkflowActive) {
				isPayrollLockedVisible = payPeriodObj.IsPayrollLocked && !isSmeLiteRole;
				isRunPayrollVisible = payPeriodObj.IsPayrollLocked;
				// User can unlock if the payroll is locked and they have the canCalculatePayroll permission
				isUnlockPayrollVisible = isPayrollLockedVisible && canCalculatePayroll;
			}

			let permissionsObj = {
				isPayrollLockedVisible: isPayrollLockedVisible,
				isRunPayrollVisible: isRunPayrollVisible && service.getPermissionValueByString(loggedInUserObj, 'Payroll.canRunPayroll', 'run-payroll'),
				isUnlockPayrollVisible: isUnlockPayrollVisible,
			};

			return permissionsObj;
		},

		getPermissionRoleIdForUserRoleId: userRoleId => {

			switch (userRoleId) {
				case USER_ROLE_IDS.companyadministratorlite:
					return PERMISSION_ROLE_IDS.companyadministratorlite;
				case USER_ROLE_IDS.departmentadmin:
					return PERMISSION_ROLE_IDS.departmentadmin;
				case USER_ROLE_IDS.groupAdminLite:
					return PERMISSION_ROLE_IDS.groupAdminLite;
				default:
					return userRoleId;
			}
		},

		getPermissionRoleOrderForUserRoleId: userRoleId => {
			return PERMISSION_ROLES_ORDER[userRoleId];
		},


		
		getPermissionValueByString: (userObj, permissionString, checkType) => {

			if (!permissionString) {
				return false;
			}

			paycircleService.permissionTracking.onPermisisonCheck(permissionString, checkType);

			if (permissionString.indexOf('.') > -1) {

				const permissionPartsArr = permissionString.split('.');

				return userObj.Permissions[permissionPartsArr[0]][permissionPartsArr[1]];
			}

			return userObj.Permissions[permissionString];
		},

		getRoleKeyForRoleType: roleType => {

			switch (roleType) {
				case PERMISSION_ROLE_IDS.superUser:
					return USER_ROLES.bureaumanager;

				case PERMISSION_ROLE_IDS.teamMember:
					return USER_ROLES.bureau;

				case PERMISSION_ROLE_IDS.companyAdmin:
					return USER_ROLES.companyadministrator;

				case PERMISSION_ROLE_IDS.groupAdmin:
					return USER_ROLES.groupuser;

				case PERMISSION_ROLE_IDS.groupAdminLite:
					return USER_ROLES.groupadminlite;

				case PERMISSION_ROLE_IDS.companyadministratorlite:
					return USER_ROLES.companyadministratorlite;

				case PERMISSION_ROLE_IDS.departmentadmin:
					return USER_ROLES.departmentadmin;
			}
		},

		getRoleTypeForRoleKey: roleKey => {

			switch (roleKey) {
				case USER_ROLES.paycircle:
				case USER_ROLES.bureaumanager:
					return PERMISSION_ROLE_IDS.superUser;

				case USER_ROLES.bureau:
					return PERMISSION_ROLE_IDS.teamMember;

				case USER_ROLES.companyadministrator:
					return PERMISSION_ROLE_IDS.companyAdmin;

				case USER_ROLES.groupuser:
					return PERMISSION_ROLE_IDS.groupAdmin;

				case USER_ROLES.groupadminlite:
					return PERMISSION_ROLE_IDS.groupAdminLite;

				case USER_ROLES.companyadministratorlite:
					return PERMISSION_ROLE_IDS.companyadministratorlite;

				case USER_ROLES.departmentadmin:
					return PERMISSION_ROLE_IDS.departmentadmin;
			}
		},

		getRoleForTeamMember: (permissionRolesArray, propertyId) => {

			const roleObj = angular.copy(utilities.getArrayItemByPropertyName(permissionRolesArray, 'RoleType', propertyId));

			roleObj.IsDefault = true;

			return service.decorateRole(roleObj);
		},

		getRoleForCompanyTypeId: (permissionRolesArray, companyTypeId) => {

			const roleTypeId = service.getRoleIdForCompanyTypeId(companyTypeId);

			return service.getRoleForTeamMember(permissionRolesArray, roleTypeId);
		},

		getRoleForRoleTypeId: (permissionRolesArray, roleTypeId) => {

			const permissionRoleTypeId = service.getPermissionRoleIdForUserRoleId(roleTypeId);

			return service.getRoleForTeamMember(permissionRolesArray, permissionRoleTypeId);
		},

		getRoleIdForCompanyTypeId: companyTypeId => {

			switch (companyTypeId) {
				case INTERFACE_TYPES.group:
					return USER_ROLE_IDS.groupAdmin;
				case INTERFACE_TYPES.bureau:
					return USER_ROLE_IDS.teamMember;
				default:
					return USER_ROLE_IDS.companyAdmin;
			}
		},

		isAutoRunVisibleForUser: userResponseObj => {

			return !utilities.userHasRole(userResponseObj, [
				'companyadministrator',
				'companyadministratorlite',
				'groupadminlite',
				'departmentadmin',
				'groupadmin',
				'group'
			]);
		},

		mapPermissions: (permissionGroupObj, roleType) => {

			permissionGroupObj.GroupVisible = (permissionGroupObj.GroupValue >= 0);

			// Save defaults to reset if not updated
			angular.extend(permissionGroupObj, {
				originalGroupVisible: permissionGroupObj.GroupVisible,
				originalGroupValue: permissionGroupObj.GroupValue,
			});

			permissionGroupObj.GroupPermissionActions.filter(permissionActionObj => {

				const permissionActionValueBit = angular.copy(permissionActionObj.Value).toString();
				const permissionRoleValueBit = permissionGroupObj.GroupValue.toString();

				/* jshint eqeqeq:false */
				permissionActionObj.IsActive = permissionActionObj.Value == (permissionActionValueBit & permissionRoleValueBit);
				/* jshint eqeqeq:true */

				angular.extend(permissionActionObj, {
					isLocked: angular.isDefined(permissionActionObj.lockedFor) && permissionActionObj.lockedFor.includes(roleType),
					originalIsActive: permissionActionObj.IsActive
				});

				return permissionActionObj;
			});
		},

		setupPermissionsForUser: userResponseObj => {

			function getPermissionValueForUser (userResponseObj, groupKey) {
				// Disable permission group if platform access key isn't returned
				return angular.isNumber(userResponseObj.Access[groupKey]) ? userResponseObj.Access[groupKey] : -1;
			}

			// Setup temporary permissions
			service.attachTempPermissionsForUser(userResponseObj);

			// Attach permissions array to user
			if (userResponseObj.Access.length > 0) {

				userResponseObj.Permissions = {
					Payroll: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.Payroll),
					Pension: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.Pension),
					Team: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.Team),
					Reports: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.Reports),
					Admin: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.Admin),
					History: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.History),
					CompanySettings: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.CompanySettings),
					HR: getPermissionValueForUser(userResponseObj, PERMISSION_GROUP_KEYS.HR)
				};

			} else {
				$rootScope.paycircleMessage('No permissions have been assigned to the logged in user.', 'error');
			}

			// Set up action permissions
			userResponseObj.Permissions = $filter('permissions')(userResponseObj.Permissions);

			if (utilities.isDevelopment() && config.isInDebugMode) {
				console.info(userResponseObj.Permissions);
			}
		}

	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('policyService', [
	'$filter',
	'$q',
	'agency',
	'companyData',
	'config',
	'payrollData',
	'utilities',
	'POLICY_BAND_CALCULATION_TYPE_OPTIONS',
	'POLICY_BAND_CALCULATION_TYPES',
	'POLICY_BAND_RATE_TYPES',
	'POLICY_BAND_STAT_PAYMENT_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_CATEGORY_TYPES',
	'POLICY_PAY_BASES',
	'POLICY_PENSION_STATES',
	'POLICY_SERVICE_ENTITLEMENTS',
	'POLICY_STATES',
	'POLICY_TYPES',
	'POLICY_YEAR_BASES_DESCRIPTIONS',
	'POLICY_YEAR_BASES',
function (
	$filter,
	$q,
	agency,
	companyData,
	config,
	payrollData,
	utilities,
	POLICY_BAND_CALCULATION_TYPE_OPTIONS,
	POLICY_BAND_CALCULATION_TYPES,
	POLICY_BAND_RATE_TYPES,
	POLICY_BAND_STAT_PAYMENT_TYPES,
	POLICY_CATEGORIES,
	POLICY_CATEGORY_TYPES,
	POLICY_PAY_BASES,
	POLICY_PENSION_STATES,
	POLICY_SERVICE_ENTITLEMENTS,
	POLICY_STATES,
	POLICY_TYPES,
	POLICY_YEAR_BASES_DESCRIPTIONS,
	POLICY_YEAR_BASES
) {

	const service = {

		// Used as a template to create a new policy. Retrieved from platfrom API on first use
		emptyPolicyObj: undefined,
		emptyPolicyBandObj: undefined,
		emptyPolicyBandEntitlementPeriodObj: undefined,

		/**
		 * Create a new policy for the specified group, with a new band. Returns a promise as a platform call may be required.
		 * @param {POLICY_CATEGORIES} policyCategory - policy group to which the policy belongs
		 * @param {Company} companyObj - company for which the policy is being created. Required for default policy attributes,
		 * only applicable to pay policies (contracted work times), otherwise it'll be ignored.
		 * @returns {Promise} - resolves with new policy object
		 */
		 createPolicy: (policyCategory, companyObj) => {

			let getEmptyPolicy;

			// If not yet set, get the empty policy object from the API, otherwise used cached copy
			getEmptyPolicy = angular.isUndefined(service.emptyPolicyObj) ? companyData.getEmptyPolicy() : $q.when(service.emptyPolicyObj);

			return $q((resolve, reject) => {
				getEmptyPolicy.then(emptyPolicyObj => {

					service.emptyPolicyObj = emptyPolicyObj;

					// Copy empty policy and decorate it.
					let newPolicy = angular.copy(emptyPolicyObj);
					newPolicy = service.decoratePolicy(newPolicy, policyCategory, true);

					// If this is a new pay policy, set its contracted times based on those defined at company level.
					if (policyCategory === POLICY_CATEGORIES.pay) {
						angular.extend(newPolicy, {
							PolicyHoursPerWeek: companyObj.WorkHoursPerWeek,
							PolicyWeeksPerYear: companyObj.WorkWeeksPerYear
						});
					}

					// Add a band
					service.createPolicyBand(newPolicy).then(newPolicyObj => {
						resolve(newPolicyObj);
					});
				})
				.catch (error => {
					reject(error);
				});
			});
		},

		/**
		 * Create a new policy band and add it to a policy. Returns a promise as a platform call may be required.
		 * This will set 'isNew' = true on the band so the UI knows it can remove it without having to update the policy via the API.
		 * @param {Policy} policyObj  - Policy for new band
		 * @param {PolicyBand} emptyPolicyBandObj - empty PolicyBand to add to the policy
		 * @returns {Promise} - resolves with policy, with new band added
		 */
		createPolicyBand: (policyObj) => {

			let getEmptyPolicyBand;
			// If not yet set, get the empty band object from the API, otherwise used cached copy
			getEmptyPolicyBand = angular.isUndefined(service.emptyPolicyBandObj) ? companyData.getEmptyPolicyBand() : $q.when(service.emptyPolicyBandObj);

			return $q((resolve, reject) => {
				getEmptyPolicyBand.then(emptyPolicyBandObj => {

					// Set empty band on service so retrieval is once-only. Might already be set but doesn't matter.
					service.emptyPolicyBandObj = emptyPolicyBandObj;

					// Create new band from the empty band and add to policy
					const newPolicyBand = angular.copy(emptyPolicyBandObj);
					newPolicyBand.isNew = true;
					policyObj.PolicyBands.push(newPolicyBand);

					// *After* it's been added, decorate the bands list so they're all in sync. See comments there.
					policyObj = service.decoratePolicyBands(policyObj);

					// Slap in an entitlement band if this is a sickness policy
					if (policyObj.policyCategory === POLICY_CATEGORIES.sickness) {
						// This will add the entitlement period to the band, no need to do anything with the response
						service.createPolicyBandEntitlementPeriod(newPolicyBand).then(() => resolve(policyObj));
					}
					else {
						resolve(policyObj);
					}
				})
				.catch (error => {
					reject(error);
				});
			});
		},

		/**
		 * Create a new entitlement period and add it to a policy band. Returns a promise as a platform call may be required.
		 * Mark as 'isNew' to give the UI a clue as to whether it can delete it without causing undue harm.
		 * @param {PolicyBand} policyBandObj - Policy band for new entitlement period
		 */
		createPolicyBandEntitlementPeriod: (policyBandObj) => {

			let getEmptyPolicyBandEntitlementPeriod;
			// If not set yet, get an empty entitlement period object from the API, otherwise used cached copy
			getEmptyPolicyBandEntitlementPeriod = angular.isUndefined(service.emptyPolicyBandEntitlementPeriodObj) ? companyData.getEmptyPolicyBandEntitlementPeriod() : $q.when(service.emptyPolicyBandEntitlementPeriodObj);

			return $q((resolve, reject) => {
				getEmptyPolicyBandEntitlementPeriod.then(emptyPolicyBandEntitlementPeriodObj => {

					// Set empty entitlement period on service so retrieval is once-only. Might already be set, doesn't matter.
					service.emptyPolicyBandEntitlementPeriodObj = emptyPolicyBandEntitlementPeriodObj;

					// Create new entitlement period from the empty template and add to band
					const newPolicyBandEntitlementPeriod = angular.copy(emptyPolicyBandEntitlementPeriodObj);
					newPolicyBandEntitlementPeriod.isNew = true;
					policyBandObj.PolicyBandEntitlementPeriods.push(newPolicyBandEntitlementPeriod);

					// *After* it's been added, decorate the bands list so they're all in sync. See comments there.
					policyBandObj = service.decoratePolicyBandEntitlementPeriods(policyBandObj);

					resolve(policyBandObj);
				})
				.catch (error => {
					reject(error);
				});
			});
		},

		/**
		 * Decorate policy according to its type / group
		 * @param {Policy} policyObj - the untainted policy object from the platform
		 * @param {POLICY_CATEGORIES} policyCategory - category of policy
		 * @param {boolean} isNew - set to indicate this is a new policy for decoration
		 * @returns {Policy} - decorated policy
		 */
		decoratePolicy: (policyObj, policyCategory, isNew) => {

			// Assume isNew = false if not specified
			isNew = angular.isUndefined(isNew) ? false : isNew;

			/* New or existing policies, set useful attributes on policy to preserve the fragile sanity of the beleaguered UI
			   Note that the policy band description will be pluralised by adding an 's' in the UI. Happily, at the time of
			   writing this, that's OK. */
			// Default. Bland 'bands'. Document icon.
			let policyBandDescription = 'band';
			let policyIcon = 'icon-document';
			if (policyCategory === POLICY_CATEGORIES.parental) {
				policyBandDescription = 'payment band';
				policyIcon = 'icon-maternity';
			}
			else if (policyCategory === POLICY_CATEGORIES.pay) {
				policyBandDescription = 'pay point';
				policyIcon = 'icon-wallet';
			}
			else if (policyCategory === POLICY_CATEGORIES.pension) {
				policyBandDescription = 'contribution band';
				policyIcon = 'icon-money';
			}
			else if (policyCategory === POLICY_CATEGORIES.sickness) {
				policyBandDescription = 'entitlement band';
				policyIcon = 'icon-sick';
			}
			angular.extend(policyObj, {
				policyCategory,
				policyBandDescription,
				policyIcon,
				policyTheme: 'is-primary',
				// This is here so that it can be substituted in legacy policies
				policyUpdateForm: 'update-policy'
			});

			if (isNew) {
				// PolicyPayBasis should be undefined to force selection in the UI
				delete(policyObj.PolicyPayBasis);

				// New policy not in use
				policyObj.policyInUse = false;

				// Set policy type if that can be ascertained.
				if (POLICY_CATEGORY_TYPES[policyCategory].length === 1) {
					// Only one policy type in this group, so can be safely set. The user doesn't have a choice.
					policyObj.PolicyType = POLICY_CATEGORY_TYPES[policyCategory][0];
				}
				else {
					// This is a new policy that belongs to a group with more than one type. Therefore the user must decide.
					delete(policyObj.PolicyType);
				}

				// Type-specific decoration for new policies
				switch (policyCategory) {

					case POLICY_CATEGORIES.parental: {

						// Default policy pay basis selection
						policyObj.PolicyPayBasis = POLICY_PAY_BASES.averageWeeklyPercent;
						break;
					}
					case POLICY_CATEGORIES.pay: {

						// Force selection of policy pay basis
						delete(policyObj.PolicyPayBasis);
						// Default pensionable to 'active' (though only applicable to annual allowance policies)
						policyObj.PolicyPensionActive = POLICY_PENSION_STATES.active;
						// No effective date by default
						policyObj.hasEffectiveDate = false;
						break;
					}
					case POLICY_CATEGORIES.pension: {

						angular.extend(policyObj, {

							// Use same rate switch. Initially off.
							useSameEmployerContributionRateForAllBands: false,

							// Contribution rates type for new pension policy - default to %. Needed for both EE and ER
							PolicyBandRateTypeEmployee: POLICY_BAND_RATE_TYPES.percentage,
							PolicyBandRateTypeEmployer: POLICY_BAND_RATE_TYPES.percentage,

							// Set any relevant 'none' attributes to undefined, so the UI doesn't think they're valid and forces selection
							PolicyBandCalculation: policyObj.PolicyBandCalculation === 0 ? undefined : policyObj.PolicyBandCalculation
						});

						break;
					}
					case POLICY_CATEGORIES.sickness: {

						angular.extend(policyObj, {
							// Service entitlement switch. Initially off.
							baseBandsOnLengthOfService: false,

							// Default to no option selected
							PolicyDailyRateCalculationMethod: undefined,

							// Default policy pay basis selection
							PolicyPayBasis: POLICY_PAY_BASES.averageWeeklyPercent,

							// Set any relevant 'none' attributes to undefined, so the UI doesn't think they're valid and forces selection
							PolicyYearBasis: policyObj.PolicyYearBasis === 0 ? undefined : policyObj.PolicyYearBasis
						});

						break;
					}
				}
			}
			else {
				// Type-specific decoration for existing policies
				switch (policyCategory) {
					case POLICY_CATEGORIES.parental: {

						break;
					}
					case POLICY_CATEGORIES.pay: {
						angular.extend(policyObj, {

							// Policy in use if there are any associated team members
							policyInUse: policyObj.TeamMembers.length !== 0,

							/* Translate PolicyPensionActive.NotSet to Active. It's a checkbox in the UI, but is an enumeration with more than two values:
							   https://www.notion.so/Occupational-Policies-Pay-de82942cdc064feaad34da7b24eb3891?d=bf83a51fd8bc4e3392cf886c4844dc2e#ab160500981f4c4ca6268867d3507460
							 */
							PolicyPensionActive: policyObj.PolicyPensionActive === POLICY_PENSION_STATES.notSet ? POLICY_PENSION_STATES.active : policyObj.PolicyPensionActive,

							// Has effective date
							hasEffectiveDate: policyObj.PolicyEffectiveDateISO !== ''
						});

						break;
					}
					case POLICY_CATEGORIES.pension: {
						/* If all of the >1 bands have the same PolicyBandEmployerAmount, assume the 'same amount for all'
						option was selected, since this isn't persisted in the DB */
						if (policyObj.PolicyBands.length > 1) {
							policyObj.useSameEmployerContributionRateForAllBands = policyObj.PolicyBands.every((policyBandObj, i, policyBandsArr) =>
								policyBandObj.PolicyBandEmployerAmount === policyBandsArr[0].PolicyBandEmployerAmount);

							// Put the fixed amount in the policy if necessary
							if (policyObj.useSameEmployerContributionRateForAllBands) {
								policyObj.fixedEmployerContribution = policyObj.PolicyBands[0].PolicyBandEmployerAmount;
							}
						}

						angular.extend(policyObj, {
							// Policy in use if there are any associated pension schemes
							policyInUse: policyObj.PensionSchemes.length !== 0
						});

						break;
					}
					case POLICY_CATEGORIES.sickness: {
						angular.extend(policyObj, {
							// Service entitlement switch. 'On' when a valid service entitlement option has been selected
							baseBandsOnLengthOfService: ([POLICY_SERVICE_ENTITLEMENTS.serviceFromStartDate, POLICY_SERVICE_ENTITLEMENTS.serviceContinuous].includes(policyObj.PolicyServiceEntitlement)),
						});

						break;
					}
				}

				// Set bands count. This can change after deleting bands. Deleted bands will still be in the PolicyBands array, just marked as for deletion.
				policyObj.bandsCount = policyObj.PolicyBands.length;

				// Decorate the policy bands for an existing policy, so they're in sync
				policyObj = service.decoratePolicyBands(policyObj);
			}

			return policyObj;
		},

		/**
		 * Decorate policy bands according to parent policy type. This marks the last,
		 * which can have an infinite 'to' value (-1), and resets the others if any of those are set to infinite.
		 * @param {Policy} policyObj - policy to which the bands belong
		 * @returns {Policy} - policy with decorated bands
		 */
		decoratePolicyBands: (policyObj) => {

			// Sync bands before decorating. The important thing here is that the last band is marked for special consideration
			service.syncPolicyBands(policyObj);

			policyObj.PolicyBands.forEach((policyBand, i) => {

				// Give the band a unique id (in the context of its parent policy). Just for UI.
				policyBand.id = `Band${i}`;

				// Parental policy bands - SMP / SPP default
				if (policyObj.policyCategory === POLICY_CATEGORIES.parental) {
					// If stat pay setting isn't valid, set to default
					if (![POLICY_BAND_STAT_PAYMENT_TYPES.included, POLICY_BAND_STAT_PAYMENT_TYPES.additional].includes(policyBand.PolicyBandStatutoryPay)) {
						policyBand.PolicyBandStatutoryPay = POLICY_BAND_STAT_PAYMENT_TYPES.included;
					}
				}

				// Pay policy bands - description for dropdowns, isInUse flag if TeamMembers isn't empty
				if (policyObj.policyCategory === POLICY_CATEGORIES.pay) {
					const salaryValue = policyObj.PolicyPayBasis === POLICY_PAY_BASES.annualSalary ? policyBand.PolicyBandAnnualSalary : policyBand.PolicyBandAnnualAllowance;
					policyBand.description = `${policyBand.PolicyBandName} (${$filter('monetise')(salaryValue)})`;
					policyBand.isInUse = policyBand.TeamMembers.length !== 0;
				}

				// Last pension or sickness policy band - set upper range infinite flag depending on 'to' value
				if ([POLICY_CATEGORIES.pension, POLICY_CATEGORIES.sickness].includes(policyObj.policyCategory) && policyBand.isLast) {
					// Set 'isUpperRangeInfinite' according to 'to' value
					policyBand.isUpperRangeInfinite = policyBand.PolicyBandValueTo === -1;
				}
				else {
					// Any others can't be infinite. Not applicable to some policy types, but it does no harm.
					policyBand.isUpperRangeInfinite = false;
					if (policyBand.PolicyBandValueTo === -1) {
						policyBand.PolicyBandValueTo = 0;
					}
				}

				// Sickness policy bands
				if (policyObj.policyCategory === POLICY_CATEGORIES.sickness) {
					// Sickness policy has entitlement periods, so decorate those too.
					policyBand = service.decoratePolicyBandEntitlementPeriods(policyBand);
				}
			});

			return policyObj;
		},

		/**
		 * Decorate policy band entitlement periods
		 * @param {PolicyBand} policyBandObj - policy band to which the entitlement periods belong
		 * @returns {PolicyBand} - policy band with decorated entitlement periods
		 */
		decoratePolicyBandEntitlementPeriods: (policyBandObj) => {

			policyBandObj.PolicyBandEntitlementPeriods.forEach((policyBandEntitlementPeriod, i) => {

				// SSP default for entitlement bands
				if (![POLICY_BAND_STAT_PAYMENT_TYPES.included, POLICY_BAND_STAT_PAYMENT_TYPES.additional].includes(policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay)) {
					policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay = POLICY_BAND_STAT_PAYMENT_TYPES.included;
				}

				angular.extend(policyBandEntitlementPeriod, {
					// Mark last
					isLast: i === policyBandObj.PolicyBandEntitlementPeriods.length - 1,
					// Give a unique id (in the context of its parent band)
					id: `${policyBandObj.id}EP${i}`
				});
			});

			return policyBandObj;
		},

		/**
		 * Delete policy band. If for a new policy, properly remove it. For an existing policy, mark the band for deletion,
		 * 'cause that's what the platform wants. (Band merely marked for deletion should be hidden in the UI).
		 * @param {Policy} policyObj - parent policy. Required to resync the bands.
		 * @param {PolicyBand} policyBandObj - band to delete.
		 */
		deletePolicyBand: (policyObj, policyBandObj) => {

			if (policyObj.PolicyID === config.guidEmpty) {
				// This is a new policy. Remove the band.
				policyObj.PolicyBands.splice(policyObj.PolicyBands.indexOf(policyBandObj), 1);
			}
			else {
				// This is an existing policy. Mark band for deletion.
				policyBandObj.PolicyBandDelete = true;
			}
			// Re-sync band numbers and names
			service.syncPolicyBands(policyObj);
		},

		/**
		 * Delete policy band entitlement period. If for a new policy, properly remove it. For an existing policy, mark it for deletion.
		 * @param {Policy} policyObj - parent policy. Required to resync bands.
		 * @param {PolicyBand} policyBandObj - parent policy band.
		 * @param {PolicyBandEntitlementPeriod} policyBandEntitlementPeriodObj - entitlement period to delete.
		 */
		deletePolicyBandEntitlementPeriod: (policyObj, policyBandObj, policyBandEntitlementPeriodObj) => {

			if (policyObj.PolicyID === config.guidEmpty) {
				// This is a new policy. Remove the entitlement period.
				policyBandObj.PolicyBandEntitlementPeriods.splice(policyBandObj.PolicyBandEntitlementPeriods.indexOf(policyBandEntitlementPeriodObj), 1);
			}
			else {
				// This is an existing policy. Mark entitlement period for deletion.
				policyBandEntitlementPeriodObj.PolicyBandEntitlementPeriodDelete = true;
			}
			// Re-sync band numbers and names
			service.syncPolicyBands(policyObj);
		},

		/**
		 * Copy a policy. Duplicate policy and clear out team members and any IDs
		 * @param {Policy} policy - policy to copy
		 * @param {boolean} forPolicyUpdate - set to true to indicate that this copy is for an update, not a simple duplication.
		 * 									  When set this will retain identifying attributes of the original policy. Optional,
		 * 									  defaults to false.
		 * @returns {Policy} - clean policy copy
		 */
		copyPolicy: (policy, forPolicyUpdate) => {

			// forPolicyUpdate false by default
			if (!angular.isDefined(forPolicyUpdate)) {
				forPolicyUpdate = false;
			}

			// Create copy
			const policyCopy = angular.copy(policy);

			// Clear out team members
			policyCopy.TeamMembers = [];
			// Reset its ID, unless this is for a policy update
			if (!forPolicyUpdate) {
				policyCopy.PolicyID = config.guidEmpty;
			}

			// Reset IDs of policy bands
			policyCopy.PolicyBands.forEach(policyBand => {
				policyBand.OriginalPolicyBandID = policyBand.PolicyBandID;
				policyBand.PolicyBandID = config.guidEmpty;
				// Reset IDs of policy band entitlements, applicable to sickness policies but should be empty otherwise
				policyBand.PolicyBandEntitlementPeriods.forEach(policyBandEntitlementPeriod => {
					policyBandEntitlementPeriod.PolicyBandEntitlementPeriodID = config.guidEmpty;
				});
			});

			return policyCopy;
		},

		/**
		 * Creates a duplicate policy with a new, unique name. Original name will be retained in originalPolicyName
		 * for any UI that needs it. The new name will be appended with '(copy)' if  Wrapped in a promise so it behaves like an API call.
		 * @param {Policy} policy - policy for duplication
		 * @param {Policy[]} policiesArr - policies from which the policy for duplication is obtained.
		 * 								   Needed to ensure uniqueness of duplicate name.
		 * @param {string} suffix - suffix for policy. This will be lovingly wrapped in parentheses.
		 * 							Optional. If not specified, '(copy)' will be appended.
		 * @returns {Promise} - resolves with duplicated policy.
		 */
		duplicatePolicy: (policy, policiesArr, suffix) => {

			return $q(resolve => {
				// Default suffix
				if (angular.isUndefined(suffix)) {
					suffix = 'copy';
				}

				// Create duplicate. Use service method to create a clean copy.
				const duplicatePolicy = service.copyPolicy(policy);

				/* Append '(copy)' or '(<suffix>)' to the name. Needs to be a little contrived,
				   because there could be an existing policy with this name, as unlikely as that may be. Also a nice excuse
				   for a variable named 'appendage'. */
				let duplicatePolicyName;
				let duplicatePolicyCode;
				let appendage = 0;
				let nameExists;
				do {
					let numberSuffix = '';
					if (appendage !== 0) {
						numberSuffix = `(${appendage})`;
					}
					duplicatePolicyName = `${policy.PolicyName} (${suffix}) ${numberSuffix}`;
					duplicatePolicyCode = `${policy.PolicyCode} ${suffix} ${numberSuffix}`;
					nameExists = policiesArr.some(policy => policy.PolicyName === duplicatePolicyName);
					if (nameExists) {
						appendage++;
					}
				}
				while (nameExists);

				// Keep the original for any UI that needs it
				duplicatePolicy.originalPolicyName = policy.PolicyName;
				// Update the name for the copy
				duplicatePolicy.PolicyName = duplicatePolicyName;
				// Update the code for the copy
				if (duplicatePolicy.PolicyCode) {
					duplicatePolicy.PolicyCode = duplicatePolicyCode;
				}

				// Resolve with duplicated policy
				resolve(duplicatePolicy);
			});
		},

		/**
		 * Get 'current' policies, optionally depending on policy pay basis, for selection from a list that may include updates. This list is
		 * required for user selection. So, for example, if Policy A has an update, Policy B doesn't, the list will contain
		 * [PoilcyA, PolicyAUpdate, PolicyB]. This function will determine that PolicyAUpdate is an update of PolicyA and should be
		 * selectable in preference to the original, returning [PolicyAUpdate, PolicyB]. This is used to populate a Policy selection
		 * dropdown.
		 * @param {Array<Policy>} policiesArr - the source array of all policies
		 * @param {POLICY_PAY_BASES} policyPayBasis - the policy pay basis. Optional. If not specified, all policies are included regardless of basis.
		 */
		getPoliciesForSelection: (policiesArr, policyPayBasis) => {
			const policiesForSelection = [];

			// Filter out any policies not of basis if specified.
			if (angular.isDefined(policyPayBasis)) {
				policiesArr = policiesArr.filter(payPolicy => payPolicy.PolicyPayBasis === policyPayBasis);
			}

			// From that, get list of active policies and list of updates. This just makes the next bit cleaner.
			const policiesActiveArr = policiesArr.filter(policyObj => policyObj.PolicyState === POLICY_STATES.active);
			const policiesUpdateArr = policiesArr.filter(policyObj => policyObj.PolicyState === POLICY_STATES.update);

			// For each active policy, see if there's an update. If there is one, add that to the selection, otherwise add the original.
			policiesActiveArr.forEach(policyActiveObj => {
				// Idenfity (potential) update for this active policy by PolicyGroupID
				let policyForSelection = policiesUpdateArr.find(policyUpdateObj => policyUpdateObj.PolicyGroupID === policyActiveObj.PolicyGroupID);
				// If no update, use the original for selection
				if (angular.isUndefined(policyForSelection)) {
					policyForSelection = policyActiveObj;
				}
				// Add to array for selection
				policiesForSelection.push(policyForSelection);
			});

			// Sort those by name for the UI
			policiesForSelection.sort(utilities.comparator('PolicyName'));
			return policiesForSelection;
		},

		/**
		 * Get a specific policy, decorated
		 * @param {Guid} agencyProfileId
		 * @param {Guid} policyId
		 */
		getPolicy: (agencyProfileId, policyId) => {

			return $q((resolve, reject) => {
				companyData.getPolicy(agencyProfileId, policyId).then(policyObj => {
					// Determine policy category
					const policyCategory = service.getPolicyCategory(policyObj);
					// Decorate based on category and resolve
					policyObj = service.decoratePolicy(policyObj, policyCategory);
					resolve(policyObj);
				})
				.catch(error => {
					reject(error);
				});
			});
		},

		/**
		 * Get policy band calculation types for use in a <select> element, excluding the 'None' option
		 * @returns {Array<{POLICY_BAND_CALCULATION_TYPES, string}>} Array of items for selection
		 */
		getPolicyBandCalculationTypesForSelection: () => {

			// Array of calculation types for selection
			const policyBandCalculationTypes = [];

			// For each calculation type except 'None', add identifier and description to array
			Object.values(POLICY_BAND_CALCULATION_TYPES).forEach(policyBandCalculation => {
				if (policyBandCalculation !== POLICY_BAND_CALCULATION_TYPES.none) {
					policyBandCalculationTypes.push({
						policyBandCalculation,
						description: POLICY_BAND_CALCULATION_TYPE_OPTIONS[policyBandCalculation]
					});
				}
			});

			return policyBandCalculationTypes;
		},

		/**
		 * Get the category for a specified policy
		 * @param {Policy} policyObj Policy
		 * @returns {POLICY_CATEGORIES} Policy category for policy
		 */
		getPolicyCategory: (policyObj) => {

			return service.getPolicyCategoryForType(policyObj.PolicyType);
		},

		/**
		 * Get the category for a specified policy type
		 * @param {POLICY_TYPE} policyType Policy type
		 * @returns {POLICY_CATEGORIES} Policy category for policy
		 */
		getPolicyCategoryForType: (policyType) => {

			let policyCategoryForPolicyType;
			Object.values(POLICY_CATEGORIES).forEach(policyCategory => {
				if (POLICY_CATEGORY_TYPES[policyCategory].includes(policyType)) {
					// This should happen once; a policy type belongs to a single category
					policyCategoryForPolicyType = policyCategory;
				}
			});
			return policyCategoryForPolicyType;
		},

		/**
		 * Get policies for a specified type, all nicely decorated for the UI. This should only be used for types that are part of
		 * a multiple set; e.g. maternity or paternity, which belong to the parental category.
		 * @param {Guid} agencyProfileId - agency profile ID
		 * @param {POLICY_TYPES} policyType - specific policy type. One of a multiple set of subtypes belonging to a category.
		 * @returns {Promise} - resolves to array of policies
		 */
		getPoliciesForType: (agencyProfileId, policyType) => {

			return $q((resolve, reject) => {
				companyData.getPolicies(agencyProfileId, policyType).then(policiesArr => {

					// Decorate each policy and resolve
					policiesArr.forEach(policy => policy = service.decoratePolicy(policy, service.getPolicyCategoryForType(policyType)));
					resolve(policiesArr);
				})
				.catch(error => {
					reject(error);
				});
			});
		},

		/**
		 * Get policies for a specified group, all decorated for the UI. This enables the retrieval of policies of differing
		 * types that belong to the same category in the app. For example, 'parental' policies need to include maternity and
		 * paternity type policies. If the group contains just a single policy type, get that directly using the API, otherwise
		 * get all and filter. For pay policies, this will also retrieve any policy updates and attach them to the originals.
		 * These are required if a user decides to edit a salary change that has been automatically created by the platform
		 * due to a pending policy update.
		 * @param {Guid} agencyProfileId - agency profile ID
		 * @param {POLICY_CATEGORIES} policyCategory - policy category
		 * @param {boolean} includeLegacyPolicies - true to include legacy policies in the array. Applicable only to sickness policies.
		 * 										    Optional, defaults to false.
		 * @param {boolean} includeUpdates - true to include policy updates (applicable to pay policies). Optional, defaults to false.
		 * @returns {Promise} - resolves to array of policies
		 */
		 getPoliciesForCategory: (agencyProfileId, policyCategory, includeLegacyPolicies, includeUpdates) => {

			// Defaults
			includeLegacyPolicies = angular.isDefined(includeLegacyPolicies) ? includeLegacyPolicies : false;
			includeUpdates = angular.isDefined(includeUpdates) ? includeUpdates : false;

			return $q((resolve, reject) => {

				// If the group contains just a single policy type, get that directly, otherwise get all and filter
				const singleType = POLICY_CATEGORY_TYPES[policyCategory].length === 1;
				const policyType = singleType ? POLICY_CATEGORY_TYPES[policyCategory][0] : POLICY_TYPES.all;

				const getPolicies = [companyData.getPolicies(agencyProfileId, policyType, includeUpdates)];

				// If the policy category is 'sickness' and flag is set, get legacy sickness policies for display alongside the new
				if (policyCategory === POLICY_CATEGORIES.sickness && includeLegacyPolicies) {
					getPolicies.push(agency.getSicknessPolicies(agencyProfileId));
				}

				$q.all(getPolicies).then(([policiesArr, sicknessPoliciesArr]) => {

					// Filter by required type(s) for multiple types
					if (!singleType) {
						policiesArr = policiesArr.filter(policy => POLICY_CATEGORY_TYPES[policyCategory].includes(policy.PolicyType));
					}

					// Decorate each policy
					policiesArr.forEach(policy => policy = service.decoratePolicy(policy, policyCategory));

					/* Add the legacy sickness policy cunningly disguised as one of the new types. The legacy sickness policy ... it exists if the ID isn't empty.
						There's an array here but there should only be one. */
					if (angular.isDefined(sicknessPoliciesArr) && sicknessPoliciesArr.length !== 0 && sicknessPoliciesArr[0].SicknessPolicyID !== config.guidEmpty) {
						// There should only be one ... but who knows?
						sicknessPoliciesArr.forEach(sicknessPolicy => {
							// Make the UI believe this is just another policy, with some subtle differences to change appearance and behaviour
							angular.extend(sicknessPolicy, {
								PolicyID: sicknessPolicy.SicknessPolicyID,
								PolicyName: sicknessPolicy.SicknessPolicyName,
								policyCategory: POLICY_CATEGORIES.sickness,
								// Marker for the UI. Otherwise it won't have a clue what's happening
								isLegacyPolicy: true,
								// Legacy policies should look different, so they can be marginalised and ridiculed
								policyTheme: 'is-quarternary',
								policyIcon: 'icon-sick',
							});
						});
						// Append those to the 'new' policies array
						policiesArr = policiesArr.concat(sicknessPoliciesArr);
					}

					resolve(policiesArr);
				})
				.catch(error => {
					reject(error);
				});
			});
		},

		/**
		 * Get policy year bases types for use in a <select> element, excluding the 'None' option
		 * @returns {Array<{POLICY_YEAR_BASES, string}>} Array of items for selection
		 */
		getPolicyYearBasesTypesForSelection: () => {

			// Array of basis types for selection
			const policyYearBasesTypes = [];

			// For each basis type except 'None', add identifier and description to array
			Object.values(POLICY_YEAR_BASES).forEach(policyYearBasis => {
				if (policyYearBasis !== POLICY_YEAR_BASES.none) {
					policyYearBasesTypes.push({
						policyYearBasis,
						description: POLICY_YEAR_BASES_DESCRIPTIONS[policyYearBasis]
					});
				}
			});

			return policyYearBasesTypes;
		},

		/**
		 * Set pay policy band hourly rate based on band annual salary and contracted times defined on the policy.
		 * @param {Policy} payPolicyObj Pay policy object, source of work hours per week and work weeks per year.
		 * @param {PolicyBand} payPolicyBandObj Pay policy band object, source of annual salary and target for hourly rate calculation.
		 * PolicyBandHourlyRate will be updated on this object.
		 */
		setPayPolicyBandHourlyRate: (payPolicyObj, payPolicyBandObj) => {

			// Calculate hourly rate
			const hourlyRate = payPolicyBandObj.PolicyBandAnnualSalary / (payPolicyObj.PolicyWeeksPerYear * payPolicyObj.PolicyHoursPerWeek);

			// Set hourly rate on band, rounding to required precision
			payPolicyBandObj.PolicyBandHourlyRate = parseFloat(hourlyRate.toFixed(config.precision.salaryRates));
		},

		/**
		 * Set pay policy band hourly rate for all bands in a pay policy, based on contracted times defined on the policy.
		 * @param {*} payPolicyObj Pay policy object. Source of work hours per week and work weeks per year. All band hourly
		 * rates for this policy will be calculated and set.
		 */
		setAllPayPolicyBandHourlyRates: (payPolicyObj) => {
			payPolicyObj.PolicyBands.forEach(payPolicyBandObj => {
				service.setPayPolicyBandHourlyRate(payPolicyObj, payPolicyBandObj);
			});
		},

		/**
		 * Sync policy bands (and policy entitlement bands) for a policy. Number them starting from 1, name them according to band
		 * description + number (e.g. 'Payment Band 1' ..), ignoring any that are marked for deletion. This can be used priod to
		 * saving an updated policy, or when deleting bands, etc. just to get everything (including bands count) in sync.
		 * Also marks the last band, ignoring any marked for deletion. Needed fot 'and above' option where applicable.
		 * @param {} policyObj
		 */
		 syncPolicyBands: (policyObj) => {

			// Refresh bands count on parent policy. Count those that aren't marked for deletion.
			policyObj.bandsCount = policyObj.PolicyBands.reduce((count, policyBand) => (!policyBand.PolicyBandDelete ? count + 1 : count), 0);

			let policyBandNumber = 1;
			let lastBand;
			policyObj.PolicyBands.forEach(policyBand => {

				// Clear out 'isLast' decorator. This will get applied to the proper last band later
				policyBand.isLast = false;

				// Grab what might be the last bonafide, not marked for deletion, band
				if (!policyBand.PolicyBandDelete) {
					lastBand = policyBand;
				}

				// If not being deleted, assign and increment the band number, otherwise just set it to 0. Shouldn't matter.
				policyBand.PolicyBandNumber = !policyBand.PolicyBandDelete ? policyBandNumber++ : 0;
				// Also update the band name if applicable, based on number just assigned. For pay policies, this is editable so shouldn't be set.
				if (policyObj.policyCategory !== POLICY_CATEGORIES.pay && policyBand.PolicyBandNumber !== 0) {
					policyBand.PolicyBandName = `${utilities.toSentenceCase(policyObj.policyBandDescription)} ${policyBand.PolicyBandNumber}`;
				}

				// Do the same for policy band entitlement periods if there are any - numbers only
				if (angular.isDefined(policyBand.PolicyBandEntitlementPeriods) && policyBand.PolicyBandEntitlementPeriods.length !== 0) {
					let policyBandEntitlementPeriodNumber = 1;
					policyBand.PolicyBandEntitlementPeriods.forEach(policyBandEntitlementPeriod => {
						policyBandEntitlementPeriod.PolicyBandEntitlementPeriodNumber = !policyBandEntitlementPeriod.PolicyBandEntitlementPeriodDelete ? policyBandEntitlementPeriodNumber++ : 0;
					});
				}
			});

			// Mark the last band, also attach it to the policy. The 'and above' status of the last band needs to be known in the UI.
			if (angular.isDefined(lastBand)) {
				lastBand.isLast = true;
				policyObj.lastBand = lastBand;
			}
		},

		/**
		 * Update a policy. Effectively wraps the corresponding API call, first syncing all band numbers in the policy.
		 * Since things are deleted using flags, not being removed from the policy object at this point, this wrapped
		 * API call will ensure all band and entitlement period numbers (when applicable) are numbered correctly before
		 * blatting off to the platform.
		 * @param {Guid} agencyProfileId - agency profile ID of policy owner
		 * @param {Policy} policyObj - policy to save
		 * @returns {Promise} - resolves on success
		 */
		updatePolicy: (agencyProfileId, policyObj) => {

			return $q((resolve, reject) => {

				// Grab the policy category for convenience, readability and harmony
				const policyCategory = policyObj.policyCategory;

				// Sync bands
				service.syncPolicyBands(policyObj);

				/* For pension and sickness policies, stick the 'to' value + 0.01 (1p, pensions) or 1 (1 month, sickness)
				   from the previous policy band into each policy band. Ensure that the 'previous' value corresponds to a
				   band that isn't marked for deletion */
				if ([POLICY_CATEGORIES.pension, POLICY_CATEGORIES.sickness].includes(policyCategory)) {
					const addAmount = policyCategory === POLICY_CATEGORIES.pension ? 0.01 : 1;
					policyObj.PolicyBands.forEach((policyBand, i, policyBands) => {
						// Get previous band that isn't marked for deletion
						let previousPolicyBandValueTo = 0;
						if (i !== 0) {
							// Go backwards from current index until a band is found that isn't deleted
							for (let j = i - 1; j >= 0; j--) {
								if (!policyBands[j].PolicyBandDelete) {
									previousPolicyBandValueTo = policyBands[j].PolicyBandValueTo;
									// Found previous, get out
									break;
								}
							}
							// Set 'from' amount on band based on previous (undeleted) 'to' amount
							policyBand.PolicyBandValueFrom = previousPolicyBandValueTo + addAmount;
						}
						else {
							// First band starts at zero
							policyBand.PolicyBandValueFrom = 0;
						}
					});
				}

				// For pension policies, if 'useSameEmployerContributionRateForAllBands' is set, copy the value to all bands
				if (policyCategory === POLICY_CATEGORIES.pension && policyObj.useSameEmployerContributionRateForAllBands) {
					policyObj.PolicyBands.forEach(policyBand => policyBand.PolicyBandEmployerAmount = policyObj.fixedEmployerContribution);
				}

				payrollData.updatePolicy(agencyProfileId, policyObj).then(() => {
					resolve();
				})
				.catch(error => {
					reject(error);
				});
			});
		}
	};

	return service;
}]);


'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.pay
 * @description
 * # pay
 * Service in the paycircleApp.
 */
angular.module('paycircleApp')
.service('promise', [
	'$q',
	'$http',
	'$rootScope',
	'$timeout',
	'coralogixService',
	'session',
	'testPromise',
	'utilities',
	function (
		$q,
		$http,
		$rootScope,
		$timeout,
		coralogixService,
		session,
		testPromise,
		utilities
	) {

	const service = {

		getHttpPromise: function (url, data, config) {

			// Add authorisation token to all service calls
			data = utilities.tokenise(data);

			return $http.post(url, data, config);
		},
		getRequestPromise: function (url, data, configObj) {

			var deferred = $q.defer();
			var request = {};
			var config = {
				cacheName: null,
				cache: true
			};

			// Overwrite default config options with configObj
			angular.extend(config, configObj);

			// Wrap data in request object and add authorisation token
			request.request = utilities.tokenise(data);

			// Is cache enabled and there's a cached version?
			if (config.cacheName && config.cache) {

				// Check local storage
				var cachedData = sessionStorage.getItem(config.cacheName);

				// Load cached data if exists
				if (cachedData !== null) {
					deferred.resolve(JSON.parse(cachedData));
					return deferred.promise;
				}

			}

			$http.post(url, request, config).then(function (response) {

				if (!response.Success) {
					deferred.reject(response.Message);
				}

				else {

					// Is cache enabled?
					if (config.cacheName && config.cache) {

						// Check local storage
						sessionStorage.setItem(config.cacheName, JSON.stringify(response.Data));
					}

					deferred.resolve(response.Data);
				}

			})
			.catch(function (error) {
				deferred.reject(utilities.stripError(error));
			});

			return deferred.promise;
		},

		getPromise: function (url, data, svcConfig) {

			// Copy data, with decorators removed
			data = utilities.removeDecorators(data);

			const config = {
				cacheName: null,
				cache: true,
				cancelRequestOnStateChange: true,
				checkUserSessionOnFail: true,
				errorOnEmptyResponse: true,
				hasTestData: true,
				includeToken: true,
				mockResponse: false,
				retries: 3,
				retryDelay: 2000, // milliseconds
				useTestData: false
			};
			const deferred = $q.defer();

			let retryCounter = 0;

			// Overwrite default config options with configObj
			angular.extend(config, svcConfig);

			// Check service specific config
			if (!config.hasTestData) {
				config.useTestData = false;
			}

			// If it's not a get function then return an OK
			if (config.mockResponse) {
				return testPromise.returnSuccess();
			}

			// Use test data
			if (config.useTestData) {
				return testPromise.getTestPromise(url);
			}

			// Add authorisation token to all service calls
			if (config.includeToken) {
				data = utilities.tokenise(data);
			}

			// Attach SessionID
			const sessionId = session.getSessionId();
			if (sessionId) {
				config.headers = {
					'SessionID': sessionId
				};
			}

			// Is cache enabled and there's a cached version?
			if (config.cacheName && config.cache) {

				// Check local storage
				var cachedData = sessionStorage.getItem(config.cacheName);

				// Load cached data if exists
				if (cachedData !== null) {
					deferred.resolve(JSON.parse(cachedData));
					return deferred.promise;
				}
			}

			config.request = () => {

				$http.post(url, data, config).then(responseObj => {

					// Error
					if (utilities.isError(responseObj.data, responseObj.config)) {

						// Retries, if set and not business logic failure response
						if (retryCounter < config.retries && !utilities.isBusinessLogicError(responseObj.data, config)) {

							$timeout(() => {
								config.request();
								retryCounter++;
							}, config.retryDelay);
						}

						// Reject
						else {
							service.onFailedServiceCall(deferred, config, responseObj.data);
						}
					}

					// Success
					else {

						// Is cache enabled?
						if (config.cacheName && config.cache) {

							// Save to session storage
							sessionStorage.setItem(config.cacheName, JSON.stringify(responseObj.data));
						}

						deferred.resolve(responseObj.data);
					}
				})
				.catch(error => {

					if (!utilities.isBusinessLogicError(error.status, config)) {

						// Retries, if set
						if (retryCounter < config.retries) {

							$timeout(() => {
								config.request();
								retryCounter++;
							}, config.retryDelay);
						}

						else {

							// Trigger Coralogix error report
							if (!config.cancelRequestOnStateChange) {
								coralogixService.logMessage(`Request failed: ${url}`);
							}

							service.onFailedServiceCall(deferred, config, error);
						}
					}
				});
			};

			config.request();

			return deferred.promise;
		},

		onFailedServiceCall: (deferred, config, data) => {

			const errorMessage = data ? utilities.stripError(data) : '';

			// Check if session has timed out, continue if it hasn't
			if (session.user && config.checkUserSessionOnFail) {
				$rootScope.$broadcast('check-user-session', function () {
					deferred.reject(errorMessage);
				});

			} else {
				deferred.reject(errorMessage);
			}
		}

	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')

// Service for dynamic regular expressions based on config
.service('regexService', [
	'config',
	function(
		config
	) {

	const service = {

		/**
		 * Generate a regexp for a number with a specified number of decimal places
		 * @param {number} decimalPlaces
		 */
		getRegExpForDecimalPlaces: function (decimalPlaces) {
			return new RegExp(`^(?:\\d*\\.\\d{1,${decimalPlaces}}|\\d+)$`);
		}
	};

	angular.extend(service, {
		salaryRatesRegEx: service.getRegExpForDecimalPlaces(config.precision.salaryRates),
		contractedWorkingTimesRegEx: service.getRegExpForDecimalPlaces(config.precision.contractedWorkingTimes)
	});

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('reportsService', [
	'$filter',
	'$q',
	'$rootScope',
	'config',
	'dataTransfer',
	'growl',
	'importService',
	'libraries',
	'coralogixService',
	'payrollData',
	'reportData',
	'utilities',
	'FULL_SCREEN_MODAL_KEYS',
	'REPORT_CELL_TYPE',
	'REPORT_CLASSIC_CATEGORY_IDS',
	'REPORT_CLASSIC_VIEW_OPTIONS',
	'REPORT_FILTER_KEYS',
	'REPORT_PERIOD_OPTION_TYPE',
	'REPORT_ROW_STYLE',
	'REPORT_TEMPLATE_ACCESSIBILITY',
	'REPORT_TEMPLATE_CATEGORIES',
	'REPORT_TEMPLATE_GROUP_FORM_VIEWS',
	'REPORT_TEMPLATE_IDS',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$filter,
		$q,
		$rootScope,
		config,
		dataTransfer,
		growl,
		importService,
		libraries,
		coralogixService,
		payrollData,
		reportData,
		utilities,
		FULL_SCREEN_MODAL_KEYS,
		REPORT_CELL_TYPE,
		REPORT_CLASSIC_CATEGORY_IDS,
		REPORT_CLASSIC_VIEW_OPTIONS,
		REPORT_FILTER_KEYS,
		REPORT_PERIOD_OPTION_TYPE,
		REPORT_ROW_STYLE,
		REPORT_TEMPLATE_ACCESSIBILITY,
		REPORT_TEMPLATE_CATEGORIES,
		REPORT_TEMPLATE_GROUP_FORM_VIEWS,
		REPORT_TEMPLATE_IDS,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const service = {

		decorateReportDTO: reportDtoObj => {

			function getExportName () {

				// Add format suffix if format type isn't already in report display name, eg "Report Summary" instead of "Report Summart (PDF)"
				if (!reportDtoObj.DisplayName.match(/\([A-Z]{1,}\)/)) {
					return `${reportDtoObj.DisplayName} (${reportDtoObj.FormatTypeDisplayName})`;
				}

				return reportDtoObj.DisplayName;
			}

			angular.extend(reportDtoObj, {
				exportIcon: importService.getIconForMimeFormat(reportDtoObj.FormatTypeDisplayName),
				exportName: getExportName(),
				icon: service.getReportIconByReportTemplateCategory(reportDtoObj.ReportTemplate.Category.ReportTemplateCategoryID),
				theme: service.getReportThemeByReportTemplateCategory(reportDtoObj.ReportTemplate.Category.ReportTemplateCategoryID)
			});
		},

		decorateReportTemplatesInGroups: (reportTemplateGroupObj) => {

			return reportTemplateObj => {

				angular.extend(reportTemplateObj, {
					hasChanged: false,
					isActiveInGroup: angular.isDefined(reportTemplateGroupObj) ? !reportTemplateGroupObj.IsOrphanTemplateGroup : false,
					originalIsActiveInGroup: angular.isDefined(reportTemplateGroupObj) ? !reportTemplateGroupObj.IsOrphanTemplateGroup : false,
				});

				return reportTemplateObj;
			};
		},

		exportReportDTO: (reportDtoObj, reportRequestObj, reportRequestOptionsObj) => {

			return $q(onComplete => {

				function onExportError () {
					growl.error('Error downloading the report, please try again later.');
					$rootScope.paycircleMessage('Reporting > Failed to export report', 'error');
				}

				// Download 1: Download from URL
				if (reportDtoObj.CanDownload) {
					dataTransfer.downloadFile(reportDtoObj.DownloadURL)
						.then(onComplete)
						.catch(onExportError);
					return;
				}

				// Download 2: Download from handler
				if (reportDtoObj.CanExport && reportRequestObj && reportRequestOptionsObj) {

					const reportName = service.getReportExportName(reportDtoObj, reportRequestObj, reportRequestOptionsObj);

					dataTransfer.downloadReport(reportRequestObj, reportDtoObj.FormatType, reportName)
						.then(onComplete)
						.catch(onExportError);

					return;
				}

				// Fallback 1: Preview report
				if (reportDtoObj.CanView) {
					service.openReport(reportDtoObj, {
						agencyProfileId: $rootScope.currentCompany.AgencyProfileID
					});
					return;
				}

				// Fallback 2: Show error
				onExportError();
			});

		},

		generateCostingsReportCrossPeriodXLS: (startPayPeriodId, endPayPeriodId, fileFormat) => {

			function getFormatId (fileFormat) {
				switch (fileFormat) {
					case 'csv':
						return 'E955366C-B208-4B6E-A0FC-0C6E126BA4D7';
					case 'excel':
						return '1ED51650-3412-498C-BBED-6AD3B74A4CDE';
					default:
						return null;
				}
			}

			return $q((onComplete, onError) => {

				const formatId = getFormatId(fileFormat);

				if (!formatId) {
					onError('Unable to generate report as format not specified.');
				}

				if (!startPayPeriodId || !endPayPeriodId) {
					onError('Missing start or end pay period ID');
				}

				const downloadUrl = `https://${libraries.httpHandler.download.blob}?documenttype=${formatId}&payperiod=${startPayPeriodId}&endperiod=${endPayPeriodId}`;

				onComplete(downloadUrl);
			});
		},

		getAccessibilityForReport: reportObj => {

			let {accessibilityIsDraft, accessibilityIsFinal} = reportObj;

			if (accessibilityIsDraft && accessibilityIsFinal) {
				return REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft;
			} else if (accessibilityIsDraft) {
				return REPORT_TEMPLATE_ACCESSIBILITY.draft;
			} else if (accessibilityIsFinal) {
				return REPORT_TEMPLATE_ACCESSIBILITY.final;
			} else {
				return REPORT_TEMPLATE_ACCESSIBILITY.none;
			}
		},

		getAccessibilityForReportTemplate: reportTemplateObj => {
			angular.extend(reportTemplateObj, {
				accessibilityIsDraft: (reportTemplateObj.Accessibility === REPORT_TEMPLATE_ACCESSIBILITY.draft || reportTemplateObj.Accessibility === REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft),
				accessibilityIsFinal: (reportTemplateObj.Accessibility === REPORT_TEMPLATE_ACCESSIBILITY.final || reportTemplateObj.Accessibility === REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft)
			});
		},

		getAdditionalDataForReport: (agencyProfileId, reportTemplateId) => {

			switch (reportTemplateId) {

				// Get historic periods for P32 report so that they can be styled accordingly
				case REPORT_TEMPLATE_IDS.p32Report:
					return payrollData.getAgencyPaymentsHistorical(agencyProfileId);
			}

			return null;
		},

		getAssignableReportsFilter: reportTemplateObj => reportTemplateObj.CanAssignTemplate,

		getCustomReportFromClassicReport: (reportObj, reportDtoObj, reportOptionsObj) => {

			// Converts standard report object into custom report object

			const REPORT_OBJECT_PROPERTIES = [
				{
					standard: {
						rowArrName: 'TitleRows',
						rowCellArrName: 'Titles'
					},
					custom: {
						rowArrName: 'TitleRow',
						rowCellArrName: 'TitleRowCells'
					}
				},
				{
					hasContentTypes: true,
					standard: {
						rowArrName: 'ReportRows',
						rowCellArrName: 'Values'
					},
					custom: {
						rowArrName: 'ReportRows',
						rowCellArrName: 'ReportRowCells',
						isArray: true
					}
				},
				{
					hasContentTypes: true,
					standard: {
						rowArrName: 'TotalRows',
						rowCellArrName: 'Totals'
					},
					custom: {
						rowArrName: 'TotalRow',
						rowCellArrName: 'TotalRowCells'
					}
				}
			];

			const customReportObj = {
				CustomReportEntries: [],
				CustomReportName: reportDtoObj.DisplayName
			};

			function getContentTypeForReportCell (reportRowValueIndex) {

				// Use cell type if set in options
				if (reportOptionsObj.contentTypes && angular.isDefined(reportOptionsObj.contentTypes[reportRowValueIndex])) {
					return reportOptionsObj.contentTypes[reportRowValueIndex];
				}

				// Use default if set in options
				if (reportOptionsObj.contentTypeDefault) {
					return reportOptionsObj.contentTypeDefault;
				}

				// Fallback to a string (no formatting)
				return REPORT_CELL_TYPE.string;
			}

			function getCustomReportEntryFromReport (reportObj) {

				const customReportEntryObj = {
					CustomReportEntryLabel: '',
					CustomReportEntryTable: {}
				};

				// Set table label (for comparison reports)
				if (reportObj.Contact) {
					customReportEntryObj.CustomReportEntryLabel = `${reportObj.Contact.Forename} ${reportObj.Contact.Surname}`;
				}

				for (let tableAreaObj of REPORT_OBJECT_PROPERTIES) {

					// Create array to store report rows
					customReportEntryObj.CustomReportEntryTable[tableAreaObj.custom.rowArrName] = tableAreaObj.custom.isArray ? [] : {};

					const reportRowsArr = reportObj[tableAreaObj.standard.rowArrName];

					if (reportRowsArr.length > 0) {
						for (let reportRowIndex = 0; reportRowIndex < reportRowsArr.length; reportRowIndex ++) {

							let reportRowObj = reportRowsArr[reportRowIndex];
							let reportRowValuesArr = reportRowObj[tableAreaObj.standard.rowCellArrName];

							// Create array inside report row to store cells
							const customReportRowObj = {
								[tableAreaObj.custom.rowCellArrName]: [],
								RowStyle: REPORT_ROW_STYLE.none
							};

							for (let reportRowValueIndex = 0; reportRowValueIndex < reportRowValuesArr.length; reportRowValueIndex ++) {

								let reportRowValue = reportRowValuesArr[reportRowValueIndex];

								// Push standard report cell data to new custom report row array
								customReportRowObj[tableAreaObj.custom.rowCellArrName].push({
									ColumnNumber: reportRowValueIndex,
									ContentType: getContentTypeForReportCell(reportRowValueIndex),
									RowNumber: reportRowIndex,
									Value: reportRowValue
								});
							}

							if (tableAreaObj.custom.isArray) {
								customReportEntryObj.CustomReportEntryTable[tableAreaObj.custom.rowArrName].push(customReportRowObj);
							} else {
								customReportEntryObj.CustomReportEntryTable[tableAreaObj.custom.rowArrName] = customReportRowObj;
							}
						}
					} else {
						if (!tableAreaObj.custom.isArray) {
							customReportEntryObj.CustomReportEntryTable[tableAreaObj.custom.rowArrName][tableAreaObj.custom.rowCellArrName] = [];
						}
					}
				}

				return customReportEntryObj;
			}

			switch (reportDtoObj.ReportTemplate.ReportTemplateID) {
				case REPORT_TEMPLATE_IDS.comparisonReport:

						for (let comparisonReportDetailObj of reportObj.ComparisonReportDetails) {

							const customReportEntryObj = getCustomReportEntryFromReport(comparisonReportDetailObj);

							customReportObj.CustomReportEntries.push(customReportEntryObj);
						}
					break;

				default:

					const customReportEntryObj = getCustomReportEntryFromReport(reportObj);

					customReportObj.CustomReportEntries.push(customReportEntryObj);

					break;
			}

			return customReportObj;
		},

		getCostingsReportCrossPeriodReportName: (fromPeriodObj, toPeriodObj, companyObj, format) => {
			// Generate download fallback file name
			return `${companyObj.Name} Costings Report ${$filter('dateformat')(fromPeriodObj.StartDateISO, 'custom', 'DD-MM-YYYY')} - ${$filter('dateformat')(toPeriodObj.EndDateISO, 'custom', 'DD-MM-YYYY')}.${format === 'excel' ? 'xlsx' : 'csv'}`;
		},

		getDefaultReportViewerOptions: (specifiedReportOptionsObj, reportDTOObj, reportRequestOptionsObj) => {

			// Object of properties to pass down to child components

			function getShowFilterBar () {

				/*
					Show filter bar if:
						- Bulk report (if a report request hasn't already been passed in)
				*/

				return reportRequestOptionsObj.CompanyOptions.length > 1 &&
					(
						!specifiedReportOptionsObj.reportRequest ||
						(
							specifiedReportOptionsObj.reportRequest &&
							specifiedReportOptionsObj.reportRequest.CompanyIDs.length === 0
						)
					);
			}

			// Get classic report options defined in the UI if there are any
			if (reportDTOObj.ReportTemplate.IsClassicReport && REPORT_CLASSIC_VIEW_OPTIONS[reportDTOObj.ReportTemplate.ReportTemplateID]) {
				angular.extend(specifiedReportOptionsObj, REPORT_CLASSIC_VIEW_OPTIONS[reportDTOObj.ReportTemplate.ReportTemplateID]);
			}

			return angular.extend(specifiedReportOptionsObj, {

				// Company filter would appear if the report is a bulk report
				activeFilterKey: REPORT_FILTER_KEYS.companies,

				// Define visibility options here to allow for the filter bar to be hidden if it's not needed
				filtersVisibilityDetail: service.getIsReportViewerFiltersVisibilityDetail(reportDTOObj.ReportTemplate, reportRequestOptionsObj),

				// Display the report filter selector for activeFilterKey
				isReportFilterBarActive: getShowFilterBar(),

				// Changes the colours of various components within the report
				reportTheme: service.getReportThemeByReportTemplateCategory(reportDTOObj.ReportTemplate.Category.ReportTemplateCategoryID)
			});
		},

		getIsReportViewerFiltersAdditionalFilterVisible: additionalOptionsArr => {
			return additionalOptionsArr.length > 0 &&
				   additionalOptionsArr.some(additionalOptionObj => additionalOptionObj.Items.length > 1);
		},

		getIsReportViewerFiltersColumnFilterVisible: (reportTemplateObj, isTemplateCreation, reportRequestOptionsObj) => {

			if (isTemplateCreation) {
				return reportTemplateObj.ReportTemplateColumns.some(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnCanApplyFilter);
			}
			else {
				return reportRequestOptionsObj.CanApplyFilters && reportTemplateObj.ReportTemplateColumns.some(reportTemplateColumnObj => reportTemplateColumnObj.CanApplyFilter);
			}
		},

		getIsReportViewerFiltersCompanyFilterVisible: companyOptionsArr => {
			return companyOptionsArr.length > 1;
		},

		getIsReportViewerFiltersPeriodFilterVisible: (reportTemplateObj, periodOptionsArr) => {

			if (!reportTemplateObj.Category.ReportTemplateCategoryIsDateBased) {
				return false;
			}

			if (periodOptionsArr.length > 1) {
				return true;
			}

			if (periodOptionsArr[0].Items.length > 1) {
				return true;
			}
		},

		getIsReportViewerFiltersVisibilityDetail: (reportTemplateObj, reportRequestOptionsObj) => {

			const visibilityObj = {
				isColumnFilterVisible: service.getIsReportViewerFiltersColumnFilterVisible(reportTemplateObj, false, reportRequestOptionsObj),
				isPeriodFilterVisible: service.getIsReportViewerFiltersPeriodFilterVisible(reportTemplateObj, reportRequestOptionsObj.PeriodOptions),
				isCompanyFilterVisible: service.getIsReportViewerFiltersCompanyFilterVisible(reportRequestOptionsObj.CompanyOptions),
				isAdditionalFilterVisible: service.getIsReportViewerFiltersAdditionalFilterVisible(reportRequestOptionsObj.AdditionalOptions)
			};

			// If any filter type is visible then show the filter bar
			visibilityObj.isReportViewerFiltersVisible = Object.values(visibilityObj).some(visibilityBool => visibilityBool);

			return visibilityObj;
		},

		getNewFilterFromExistingFilter: reportTemplateFilterObj => {

			function clearIDsFromFilterClause (reportFilterClauseObj) {
				angular.extend(reportFilterClauseObj, {
					ReportTemplateFilterClauseID: config.guidEmpty,
					ReportTemplateFilterGroupID: config.guidEmpty,
					ReportTemplateFilterID: config.guidEmpty
				});
			}

			function clearIDsFromFilterGroup (reportFilterGroupObj) {

				angular.extend(reportFilterGroupObj, {
					ReportTemplateFilterGroupID: config.guidEmpty,
					ReportTemplateFilterID: config.guidEmpty,
					ReportTemplateFilterParentGroupID: config.guidEmpty
				});

				// Clear IDs from child groups and clauses
				reportFilterGroupObj.ChildReportTemplateFilterClauses.forEach(clearIDsFromFilterClause);
				reportFilterGroupObj.ChildReportTemplateFilterGroups.forEach(clearIDsFromFilterGroup);
			}

			clearIDsFromFilterGroup(reportTemplateFilterObj.ReportTemplateFilterGroup);

			angular.extend(reportTemplateFilterObj, {
				ReportTemplateFilterID: config.guidEmpty,
				ReportTemplateID: config.guidEmpty
			});
		},

		getPreviousPeriodReportsViewType: userObj => {

			if (utilities.userHasRole(userObj, [USER_ROLES.groupadminlite, USER_ROLES.companyadministratorlite])) {
				return 'downloads-minimum';

			} else {
				return 'downloads';
			}
		},

		getProcessedAdditionalDataForReport: (reportDtoObj, additionalData, reportObj) => {

			function getProcessedDataForReportEntry (customReportEntryObj) {

				// Return object of data, so we can add more data sources in the future
				const processedDataObj = {};

				switch (reportDtoObj.ReportTemplate.ReportTemplateID) {

					// Get historic periods for P32 report so that they can be styled accordingly
					case REPORT_TEMPLATE_IDS.p32Report:
						processedDataObj.historicPeriods = service.getProcessedHistoricPeriodsForP32ReportEntry(customReportEntryObj, additionalData);
						break;
				}

				return processedDataObj;
			}

			// Return nothing if this report has no additional data supplied
			if (!additionalData) {
				return;
			}

			for (let customReportEntryObj of reportObj.CustomReportEntries) {
				customReportEntryObj.processedData = getProcessedDataForReportEntry(customReportEntryObj);
			}
		},

		getProcessedHistoricPeriodsForP32ReportEntry: (customReportEntryObj, historicPayPeriodsArr) => {

			function getColumnIndexForHeaderValue (headerValue) {
				return customReportEntryObj.CustomReportEntryTable.TitleRow.TitleRowCells.findIndex(titleCellObj => titleCellObj.Value === headerValue);
			}

			function getHistoricPeriodsInReportEntry () {

				// Find index of "Tax Year" column in this entry
				const taxYearColumnIndex = getColumnIndexForHeaderValue('Tax Year');

				if (taxYearColumnIndex >= 0 && customReportEntryObj.CustomReportEntryTable.ReportRows.length > 0) {

					// Get range of years in this report. eg 2018, 2019
					const taxYearRangeArr = customReportEntryObj.CustomReportEntryTable.ReportRows[0].ReportRowCells[taxYearColumnIndex].Value.split('/');

					// Only show return historical periods within the tax year
					return historicPayPeriodsArr.filter(getHistoricPeriodsInTaxYear(taxYearRangeArr));
				}
			}

			function getHistoricPeriodsInTaxYear (taxYearRangeArr) {

				// Get tax year start and end dates
				const startYearIso = moment(taxYearRangeArr[0], 'YYYY').format(config.dateFormatISO);
				const endYearIso = moment(taxYearRangeArr[1], 'YYYY').format(config.dateFormatISO);
				const startDateIso = utilities.getTaxYearStartDateForDate(startYearIso, false);
				const endDateIso = utilities.getTaxYearEndDateForDate(false, false, endYearIso);

				return historicPayPeriodObj => {
					return moment(historicPayPeriodObj.TaxMonth, 'MMMM Y').endOf('month').isBetween(startDateIso, endDateIso);
				};
			}

			function getPeriodNumberStringForTaxMonth (historicPayPeriodObj) {

				// The tax month needs to be a string for comparison purposes (all report values are strings)
				return utilities.getTaxMonthForMonth(moment(historicPayPeriodObj.TaxMonth, 'MMMM YYYY').month()).toString();
			}

			function getRowIndexForColumnCellValue (columnIndex, cellValue) {
				return customReportEntryObj.CustomReportEntryTable.ReportRows.findIndex(reportRowObj => reportRowObj.ReportRowCells[columnIndex].Value === cellValue);
			}

			// Find index of "Tax Month" column in this entry
			const taxMonthColumnIndex = getColumnIndexForHeaderValue('Tax Month');
			const historicPeriodsInReportEntryArr = getHistoricPeriodsInReportEntry();

			// Return nothing if historic tax month doesn't appear in report
			if (!historicPeriodsInReportEntryArr || taxMonthColumnIndex === -1) {
				return;
			}

			// Return array of row indexes where each row needs to be highlighted
			const reportRowHighlightArr = [];

			for (let historicPeriod of historicPeriodsInReportEntryArr) {

				const historicPeriodValue = getPeriodNumberStringForTaxMonth(historicPeriod);
				const historicPeriodRowIndex = getRowIndexForColumnCellValue(taxMonthColumnIndex, historicPeriodValue);

				if (historicPeriodRowIndex !== -1) {
					reportRowHighlightArr.push(historicPeriodRowIndex);
				}
			}

			return reportRowHighlightArr;
		},

		getReportExportName (reportDtoObj, reportRequestObj, reportRequestOptionsObj) {

			const NAME_SPACER = ' - ';
			const RANGE_SPACER = ' – '; // en dash

			function getPeriodOptionExportName (reportDtoObj, reportRequestObj, reportRequestOptionsObj) {

				const requestPeriodOptionObj = reportRequestObj.PeriodOptions[0];
				const requestOptionsPeriodOptionObj = service.getReportRequestOptionsTypeOptionForKey(reportRequestOptionsObj.PeriodOptions, requestPeriodOptionObj.Key);

				switch (requestOptionsPeriodOptionObj.Type) {

					// 3a. Single value
					case REPORT_PERIOD_OPTION_TYPE.singleDropDownList:

						const requestSingleValueOptionObj = service.getReportRequestOptionsValueFromTypeOption(requestOptionsPeriodOptionObj.Items, requestPeriodOptionObj.Value);

						// Comparison report - Show comparison report period names if they're different
						if (reportDtoObj.ReportTemplate.ReportTemplateID === REPORT_TEMPLATE_IDS.comparisonReport) {

							if (requestSingleValueOptionObj && reportRequestOptionsObj.comparisonReportCurrentPeriod.Value !== requestSingleValueOptionObj.Value) {
								return `${NAME_SPACER}${requestSingleValueOptionObj.Name}${RANGE_SPACER}${reportRequestOptionsObj.comparisonReportCurrentPeriod.Name}`;
							} else {
								return '';
							}

						} else {
							return `${NAME_SPACER}${requestSingleValueOptionObj.Name}`;
						}

						break;

					// 3b. Range
					case REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists:

						const requestValueOneOptionObj = service.getReportRequestOptionsValueFromTypeOption(requestOptionsPeriodOptionObj.Items, requestPeriodOptionObj.Values[0]);
						const requestValueTwoOptionObj = service.getReportRequestOptionsValueFromTypeOption(requestOptionsPeriodOptionObj.Items, requestPeriodOptionObj.Values[1]);

						return `${NAME_SPACER}${requestValueOneOptionObj.Name}${RANGE_SPACER}${requestValueTwoOptionObj.Name}`;

					// 3c. Dates
					case REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers:

						return `${NAME_SPACER}${$filter('dateformat')(requestPeriodOptionObj.Values[0])}${RANGE_SPACER}${$filter('dateformat')(requestPeriodOptionObj.Values[1])}`;
				}
			}

			let reportExportName = '';

			// 1. Company Name (Single company report only)
			if (reportRequestObj.CompanyIDs.length === 1) {

				const requestCompanyObj = reportRequestOptionsObj.CompanyOptions.find(companyObj => companyObj.CompanyID === reportRequestObj.CompanyIDs[0]);

				if (requestCompanyObj) {
					reportExportName += requestCompanyObj.CompanyName + NAME_SPACER;
				}
			}

			// 2. Report Name
			reportExportName += reportDtoObj.DisplayName;

			// 3. Period Options
			if (reportRequestObj.PeriodOptions.length > 0) {
				reportExportName += getPeriodOptionExportName(reportDtoObj, reportRequestObj, reportRequestOptionsObj);
			}

			// 4. Additional Options
			if (reportRequestObj.AdditionalOptions.length > 0) {

				for (let additionalOptionObj of reportRequestObj.AdditionalOptions) {

					const requestOptionsAdditionalOptionObj = service.getReportRequestOptionsTypeOptionForKey(reportRequestOptionsObj.AdditionalOptions, additionalOptionObj.Key);
					const requestValueOptionObj = service.getReportRequestOptionsValueFromTypeOption(requestOptionsAdditionalOptionObj.Items, additionalOptionObj.Value);

					reportExportName += NAME_SPACER + `${requestOptionsAdditionalOptionObj.Title}${RANGE_SPACER}${requestValueOptionObj.Name}`;
				}
			}

			return reportExportName;
		},

		getReportIconByReportTemplateCategory: reportCategoryId => {

			switch (reportCategoryId) {
				case REPORT_TEMPLATE_CATEGORIES.journals:
					return 'icon-excel';

				case REPORT_TEMPLATE_CATEGORIES.payroll:
				case REPORT_CLASSIC_CATEGORY_IDS.payrollSummary:
					return 'icon-clock';

				case REPORT_CLASSIC_CATEGORY_IDS.p32Report:
				case REPORT_TEMPLATE_CATEGORIES.p32:
				case REPORT_TEMPLATE_CATEGORIES.ytdReport:
					return 'icon-payslip';

				case REPORT_TEMPLATE_CATEGORIES.pension:
				case REPORT_CLASSIC_CATEGORY_IDS.pensionPAPDIS:
				case REPORT_CLASSIC_CATEGORY_IDS.pensionReport:
					return 'icon-money';

				case REPORT_TEMPLATE_CATEGORIES.team:
				case REPORT_CLASSIC_CATEGORY_IDS.employeeDetails:
				case REPORT_CLASSIC_CATEGORY_IDS.ytdExport:
					return 'icon-team-alt';

				case REPORT_TEMPLATE_CATEGORIES.company:
					return 'icon-company';

				case REPORT_TEMPLATE_CATEGORIES.audit:
					return 'icon-clipboard';

				default:
					return 'icon-csv';
			}
		},

		getReportsForPayPeriod: reportsArr => {

			// Filter out certain classic reports based on the user's role
			const reportsViewType = service.getPreviousPeriodReportsViewType($rootScope.currentUser);

			return $filter('reportCategories')(reportsArr, reportsViewType);
		},

		getReportOptionsForPreview: (reportOptionsObj, payPeriodObj, reportTemplateFilterObj) => {

			// Attach override filter
			if (angular.isDefined(reportTemplateFilterObj)) {
				reportOptionsObj.reportTemplateFilter = reportTemplateFilterObj;
			}

			// View a specific period
			if (angular.isDefined(payPeriodObj)) {
				angular.extend(reportOptionsObj, {
					agencyPayPeriodId: payPeriodObj.PayPeriodID || payPeriodObj.AgencyPayPeriodID,
					isPayPeriodUnsubmitted: angular.isDefined(payPeriodObj.PayrollState) && payPeriodObj.PayrollState === SUBMISSION_STATES.unsubmitted
				});
			}

			return reportOptionsObj;
		},

		getReportOptionsForReportTemplate: (reportTemplateObj, reportOptionsObj, reportTemplateFilterObj) => {

			// Copy object and clear RepottTemplateID so latest version of report is displayed
			const reportTemplateForPreviewObj = angular.copy(reportTemplateObj);
			reportTemplateForPreviewObj.ReportTemplateID = config.guidEmpty;

			// No need for a ReportDTO, a basic one will be created
			reportOptionsObj.reportTemplate = reportTemplateForPreviewObj;

			// Set default options
			service.getReportOptionsForPreview(reportOptionsObj, undefined, reportTemplateFilterObj);

			// ReportRequest is sometimes saved, attach template and filters to that to use when reopening report preview
			if (reportOptionsObj.reportRequest) {
				reportOptionsObj.reportRequest.ReportTemplate = reportTemplateForPreviewObj;

				if (reportTemplateFilterObj) {
					reportOptionsObj.reportRequest.ReportTemplateFilter = reportTemplateFilterObj;
				}
			}

			return reportOptionsObj;
		},

		getReportRequest: (reportOptionsObj, reportDtoObj, reportRequestOptionsObj) => {

			function getAdditionalOptions () {

				if (reportRequestOptionsObj.AdditionalOptions.length > 0) {

					const reportRequestAdditionalOptionsArr = [];

					// Default to set additional option to the first item's value
					for (let additionalOptionObj of reportRequestOptionsObj.AdditionalOptions) {

						const additionalOptionRequestItem = {
							Key: additionalOptionObj.Key,
							Value: additionalOptionObj.Items[0].Value
						};

						reportRequestAdditionalOptionsArr.push(additionalOptionRequestItem);
					}

					return reportRequestAdditionalOptionsArr;
				}

				return [];
			}

			function getCompanyIDs () {

				// Leave empty by default for bulk
				if (reportRequestOptionsObj.CompanyOptions.length !== 1) {
					return [];
				}

				// Attach single company
				return [reportRequestOptionsObj.CompanyOptions[0].CompanyID];
			}

			function getPeriodOptions () {

				if (reportDtoObj.ReportTemplate.Category.ReportTemplateCategoryIsDateBased && reportRequestOptionsObj.PeriodOptions.length > 0) {

					// Get first PeriodOption by default
					const firstPeriodOptionObj = reportRequestOptionsObj.PeriodOptions[0];

					// Create RequestItem
					const reportRequestItemObj = {
						Key: firstPeriodOptionObj.Key
					};

					if (firstPeriodOptionObj.Items.length > 0) {

						const lastItemIndex = firstPeriodOptionObj.Items.length-1;

						// For mutliple options, attach second Item's Value
						if ([REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists, REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers].includes(firstPeriodOptionObj.Type)) {
							reportRequestItemObj.Values = [firstPeriodOptionObj.Items[lastItemIndex].Value, firstPeriodOptionObj.Items[lastItemIndex-1].Value];

						// Attach single value for everything else
						} else {

							if (reportDtoObj.ReportTemplate.ReportTemplateID === REPORT_TEMPLATE_IDS.comparisonReport) {

								// Save first period option to use as current period display in Comparison Report
								reportRequestOptionsObj.comparisonReportCurrentPeriod = angular.copy(firstPeriodOptionObj.Items[lastItemIndex]);

								if (firstPeriodOptionObj.Items.length > 1) {

									// Compare against the previous period
									reportRequestItemObj.Value = firstPeriodOptionObj.Items[lastItemIndex-1].Value;

									// Remove current period as you wouldn't need to compare against it
									firstPeriodOptionObj.Items.pop();

								} else {
									// Compare against current period if there's only one
									reportRequestItemObj.Value = firstPeriodOptionObj.Items[lastItemIndex].Value;
								}

							} else {
								reportRequestItemObj.Value = firstPeriodOptionObj.Items[lastItemIndex].Value;
							}
						}
					}

					// Set default dates to today and a month ago today
					if (firstPeriodOptionObj.Type === REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers) {
						reportRequestItemObj.Values = [moment().subtract(1, 'M').format(config.dateFormatISO), moment().format(config.dateFormatISO)];
					}

					return [reportRequestItemObj];
				}

				return [];
			}

			function getRequestingCompanyId () {

				// Use user's company for bulk report
				if (reportRequestOptionsObj.CompanyOptions.length !== 1) {
					return $rootScope.currentUser.AgencyProfileID;
				}

				// Use single company AgencyProfileId
				return reportRequestOptionsObj.CompanyOptions[0].CompanyID;
			}

			// Use passed in report request if that exists
			if (reportOptionsObj.reportRequest) {
				return reportOptionsObj.reportRequest;
			}

			// Create object to pass into report-viewer
			return {
				AdditionalOptions: getAdditionalOptions(),
				CompanyIDs: getCompanyIDs(),
				FileID: reportDtoObj.FileID !== config.guidEmpty ? reportDtoObj.FileID : config.guidEmpty,
				PeriodOptions: getPeriodOptions(),
				ReportTemplateFilter: reportOptionsObj.reportTemplateFilter || reportRequestOptionsObj.ReportTemplateFilter,
				ReportTemplate: reportOptionsObj.reportTemplate,
				ReportTemplateID: reportDtoObj.ReportTemplate.ReportTemplateID,
				RequestingCompanyID: getRequestingCompanyId()
			};
		},

		getReportRequestOptionsTypeOptionForKey: (optionsArr, key) => {
			return optionsArr.find(periodOptionObj => periodOptionObj.Key === key);
		},

		getReportRequestOptionsValueFromTypeOption: (itemsArr, value) => {
			return itemsArr.find(itemObj => itemObj.Value === value);
		},

		getReportTemplateFilter: filterOptionsObj => {

			return $q((onComplete, onError) => {

				if (!filterOptionsObj.reportTemplate || filterOptionsObj.forceEmptyReportTemplateFilter) {

					reportData.getEmptyReportTemplateFilter()
						.then(onComplete)
						.catch(onError);

				} else {
					reportData.getReportTemplateFilter(filterOptionsObj.reportTemplate.ReportTemplateID)
						.then(reportTemplateFilterObj => {

							// If filter doesn't exist then load in an empty one
							if (!reportTemplateFilterObj) {
								service.getReportTemplateFilter({
									forceEmptyReportTemplateFilter: true
								})
								.then(onComplete)
								.catch(onError);
								return;
							}

							// Clear out GUIDs from existing template when duplicating
							if (filterOptionsObj.isDuplicateTemplate) {
								service.getNewFilterFromExistingFilter(reportTemplateFilterObj);
							}

							onComplete(reportTemplateFilterObj);
						})
						.catch(onError);
				}

			});
		},

		getReportTemplateGroupFormTitleForView: formViewKey => {

			switch (formViewKey) {
				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete:
					return 'Delete report pack';

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.duplicate:
					return 'Duplicate report pack';

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.new:
					return 'New report pack';

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.update:
					return 'Update report back';

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies:
					return 'View companies';

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups:
					return 'View company groups';
			}
		},

		getReportTemplateSelectedColumnEditModeDisplayLabel: columnObj => {

			// Duplicate label
			if (columnObj.isDuplicatedColumn && !columnObj.isDuplicatedColumnSaved) {
				return 'Unique column name required';
			}

			// Override name
			if (columnObj.columnNameOverride) {
				return columnObj.columnNameOverride;
			}

			// Default column name
			return columnObj.ReportColumnName;
		},

		getReportTemplatesForBureau: (reportTemplateGroupsArr, customReportsArr) => {

			reportTemplateGroupsArr = service.getReportTemplatesFromOrphanGroup(reportTemplateGroupsArr);

			let reportsArr = service.getTemplatesFromReportCategories(reportTemplateGroupsArr.concat(customReportsArr));

			return reportsArr.filter(service.getAssignableReportsFilter);
		},

		getReportTemplatesFromOrphanGroup: reportTemplateGroupsArr => {

			let orphanRpeortTemplateGroup = reportTemplateGroupsArr.find(reportTemplateGroupObj => reportTemplateGroupObj.IsOrphanTemplateGroup);

			return orphanRpeortTemplateGroup ? orphanRpeortTemplateGroup.ReportTemplates : [];
		},

		getReportThemeByReportTemplateCategory: reportTemplateCategoryId => {

			switch (reportTemplateCategoryId) {
				case REPORT_TEMPLATE_CATEGORIES.pension:
				case REPORT_CLASSIC_CATEGORY_IDS.pensionPAPDIS:
				case REPORT_CLASSIC_CATEGORY_IDS.pensionReport:
					return 'is-secondary';
				case REPORT_TEMPLATE_CATEGORIES.team:
				case REPORT_CLASSIC_CATEGORY_IDS.employeeDetails:
				case REPORT_CLASSIC_CATEGORY_IDS.ytdExport:
					return 'is-quarternary';
				case REPORT_TEMPLATE_CATEGORIES.company:
					return 'is-tertiary';
				case REPORT_TEMPLATE_CATEGORIES.audit:
					return 'is-assertive';
				default:
					return 'is-primary';
			}
		},

		getTemplatesFromReportCategories: reportCategoriesArr => {

			function decorateReportTemplate (reportTemplateObj) {

				angular.extend(reportTemplateObj, {
					hasGroupBy: reportTemplateObj.ReportTemplateColumns.some(reportTemplateColumnObj => reportTemplateColumnObj.IsGrouped),
					hasSplitBy: reportTemplateObj.ReportTemplateColumns.some(reportTemplateColumnObj => reportTemplateColumnObj.IsSplit),
					icon: service.getReportIconByReportTemplateCategory(reportTemplateObj.Category.ReportTemplateCategoryID),
					theme: service.getReportThemeByReportTemplateCategory(reportTemplateObj.Category.ReportTemplateCategoryID)
				});

				return reportTemplateObj;
			}

			function decorateReportCategory (reportCategoryObj) {

				angular.extend(reportCategoryObj, {
					icon: service.getReportIconByReportTemplateCategory(reportCategoryObj.Category.ReportTemplateCategoryID),
					theme: service.getReportThemeByReportTemplateCategory(reportCategoryObj.Category.ReportTemplateCategoryID)
				});

				reportCategoryObj.Templates.forEach(decorateReportTemplate);

				return reportCategoryObj;
			}

			reportCategoriesArr.forEach(decorateReportCategory);

			return reportCategoriesArr.map(reportCategoryObj => reportCategoryObj.Templates).flat();
		},

		loadTemplatesIntoGroups: (reportTemplateGroupsArr, reportsArr) => {

			function placeTemplatesInAllGroups (selectedGroupTemplatesArr, reportTemplateGroupsArr) {

				for (let selectedTemplateObj of selectedGroupTemplatesArr) {
					for (let reportTemplateGroupObj of reportTemplateGroupsArr) {
						if (!reportTemplateGroupObj.ReportTemplates.find(reportTemplateGroupObj => reportTemplateGroupObj.ReportTemplateID === selectedTemplateObj.ReportTemplateID)) {

							reportTemplateGroupObj.ReportTemplates.push(selectedTemplateObj);
						}
					}
				}

				return reportTemplateGroupsArr;
			}

			// Get Report templates from Orphan group and place them into non-readonly groups that the report doesn't already exist in
			let orphanTemplatesArr = service.getReportTemplatesFromOrphanGroup(reportTemplateGroupsArr);

			// Get assignable base reports anxd add them to all groups
			let assignableReportTemplatesArr = reportsArr.filter(service.getAssignableReportsFilter).filter(service.decorateReportTemplatesInGroups());

			placeTemplatesInAllGroups(orphanTemplatesArr.concat(assignableReportTemplatesArr), reportTemplateGroupsArr);

			return reportTemplateGroupsArr.filter(reportTemplateGroupObj => !reportTemplateGroupObj.IsOrphanTemplateGroup);
		},

		openGenderPayGapReportCreator: (genderPayGapReportOptionsObj, reportObj) => {

			const defaulGenderPayGapReportOptionsObj = {
				modalKey: FULL_SCREEN_MODAL_KEYS.genderPayGapReport,
				hasModalHeaderElement: true,
				report: angular.copy(reportObj),
				steps: {
					activeStep: 1,
					stepCount: 5
				}
			};

			// Bulk reports have 3 steps
			if (!$rootScope.currentCompany.isPayrollCompany) {
				defaulGenderPayGapReportOptionsObj.steps.stepCount = 3;
			}

			// If report has been created then skip to the last step
			if (angular.isDefined(reportObj) && reportObj.GenderPayGapReportCreationComplete) {
				defaulGenderPayGapReportOptionsObj.steps.activeStep = defaulGenderPayGapReportOptionsObj.steps.stepCount;
			}

			$rootScope.$broadcast('open-full-screen-modal',
				angular.extend({},
					genderPayGapReportOptionsObj,
					defaulGenderPayGapReportOptionsObj
				)
			);
		},

		openReport: (reportObj, reportOptionsObj, payPeriodObj, reportTemplateFilterObj) => {

			service.getReportOptionsForPreview(reportOptionsObj, payPeriodObj, reportTemplateFilterObj);

			// Attach ReportDTO
			reportOptionsObj.reportDTO = reportObj;

			service.openReportPreview(reportOptionsObj);
		},

		openReportFromCustomService: (reportOptionsObj, reportDTOService, reportCreationService, payPeriodObj) => {

			service.getReportOptionsForPreview(reportOptionsObj, payPeriodObj);

			// Attach custom services
			angular.extend(reportOptionsObj, {
				reportDTOService: reportDTOService,
				reportCreationService: reportCreationService
			});

			service.openReportPreview(reportOptionsObj);
		},

		openReportFromReportTemplateId: (reportTemplateId, reportOptionsObj) => {

			service.getReportOptionsForPreview(reportOptionsObj);

			// Attach selected ReportTemplateID
			reportOptionsObj.reportTemplateId = reportTemplateId;

			service.openReportPreview(reportOptionsObj);
		},

		openReportTemplateCreator: (reportTemplateCreatorOptionsObj, reportTemplateObj) => {

			function getReportTemplateCreatorTitle () {

				if (reportTemplateObj) {
					if (reportTemplateCreatorOptionsObj.isDuplicateTemplate) {
						return 'Duplicate report template';
					} else {
						return 'Edit report template';
					}
				}

				return 'New template';
			}

			const defaultReportTemplateCreatorOptionsObj = {
				modalKey: FULL_SCREEN_MODAL_KEYS.reportTemplateCreator,
				title: getReportTemplateCreatorTitle(),
				reportTemplate: angular.copy(reportTemplateObj)
			};

			coralogixService.addToTrace({
				message: `Report wizard: ${defaultReportTemplateCreatorOptionsObj.title} opened`,
				category: 'reporting'
			});

			$rootScope.$broadcast('open-full-screen-modal', angular.extend({}, reportTemplateCreatorOptionsObj, defaultReportTemplateCreatorOptionsObj));
		},

		openReportPreview: (reportOptionsObj) => {

			reportOptionsObj.modalKey = FULL_SCREEN_MODAL_KEYS.report;

			$rootScope.$broadcast('open-full-screen-modal', reportOptionsObj);
		}

	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.factory('reportDataGrid', [
	'$filter',
	'REPORT_CELL_TYPE',
	function (
		$filter,
		REPORT_CELL_TYPE
	) {

	let REPORT_INSTANCE;

	const REPORT_SETTINGS = {
		isDevelopmentMode: false,
		frozenColumnMax: 3,
		selectors: {
			grid: '[data-pc="report-entry-data-grid"]',
			headers: '.tui-grid-rside-area [data-pc="report-entry-freeze"]',
			wrapper: '[data-pc="report-entry-wrapper"]'
		},
		tableDimensions: {
			bodyRowHeight: 41,
			headerRowHeight: 33,
			summaryRowHeight: 38
		}
	};

	class ReportInstance {
		constructor () {
			angular.extend(this, {
				dataGridCollection: [],
				frozenColumnCount: 0,
				frozenColumnStorage: {}
			});
		}
	}

	function getDataGridColumnsArray ($element, customReportEntryTableObj) {

		function getAlignmentForColumn (columnNumber) {

			const firstRowObj = customReportEntryTableObj.ReportRows[0];

			if (!firstRowObj) {
				return 'left';
			}

			switch (firstRowObj.ReportRowCells[columnNumber].ContentType) {
				case REPORT_CELL_TYPE.decimal:
				case REPORT_CELL_TYPE.currency:
				case REPORT_CELL_TYPE.date:
				case REPORT_CELL_TYPE.dateTime:
					return 'right';

				default:
					return 'left';
			}
		}

		function getColumnsWidthsArray () {

			/*
				The data grid needs to know what the width of each column will be for scrolling and pagination to work properly
				This will create a invisible HTML table with just the header and longest possible value for each column
				This will give us the widest width to expect, we then delete that table before anything loads
			*/

			// Hidden table element to append to template
			const tableElement = document.createElement('table');

			if (!REPORT_SETTINGS.isDevelopmentMode) {
				tableElement.style.visibility = 'hidden';
			}

			// thead>tr element for headers
			const tableHeaderRowElement = tableElement
											.createTHead()
											.insertRow();

			// tbody>tr element for longest values
			const tableBodyRowElement = tableElement
											.createTBody()
											.insertRow();

			// Fill table with header values and body content
			setColumnValuesFromReport(tableHeaderRowElement, tableBodyRowElement);

			// Return array of column widths
			return getColumnWidthsArrayFromTableElement(tableElement, tableHeaderRowElement);
		}

		function getColumnWidthsArrayFromTableElement (tableElement, tableHeaderRowElement) {

			// Place table element in template
			const reportTableElement = $element.querySelector(REPORT_SETTINGS.selectors.wrapper);
			reportTableElement.appendChild(tableElement);

			// Get width of each column in table
			const columnWidthsArr = Array.from(tableHeaderRowElement.getElementsByTagName('td'))
										.map(tableColumnHeaderElement => tableColumnHeaderElement.clientWidth);

			if (!REPORT_SETTINGS.isDevelopmentMode) {
				// Remove table element from template
				reportTableElement.removeChild(tableElement);
			}

			return columnWidthsArr;
		}

		function getLongestValueInColumnByIndex (columnIndex) {

			let longest = customReportEntryTableObj.ReportRows
						// Create array of each cell in current column
						.map(rowObj => rowObj.ReportRowCells[columnIndex].Value)

						// Remove everything that isn't a string
						.filter(angular.isString)

						// Sort array by length of it's value
						.sort((a, b) => b.length - a.length)

						// Return the longest value
						[0];

			// Ensure the width of whitespace is preserved when this becomes HTML innerText
			return longest.replaceAll(' ', '-');
		}

		function setColumnValuesFromReport (tableHeaderRowElement, tableBodyRowElement) {

			// Having the header and longest value within a column would give us the widest possible width for a column
			// We need this to tell the data grid what to expect with this column

			for (let columnIndex = 0; columnIndex < customReportEntryTableObj.TitleRow.TitleRowCells.length; columnIndex++) {

				const reportTitleCellObj = customReportEntryTableObj.TitleRow.TitleRowCells[columnIndex];

				// Add header
				tableHeaderRowElement
					.insertCell()
					.innerText = reportTitleCellObj.Value;

				// Get longest value within column
				tableBodyRowElement
					.insertCell()
					.innerText = getLongestValueInColumnByIndex(columnIndex);
			}
		}

		const columnWidthsArr = getColumnsWidthsArray();

		const dataGridColumnsArr = [];

		for (let columnIndex = 0; columnIndex < customReportEntryTableObj.TitleRow.TitleRowCells.length; columnIndex++) {

			const reportTitleCellObj = customReportEntryTableObj.TitleRow.TitleRowCells[columnIndex];

			dataGridColumnsArr.push({
				// Column alignments, left or right based on ContentType from first row cells
				align: getAlignmentForColumn(columnIndex),

				// Sets the display value
				header: reportTitleCellObj.Value,

				// Sets the ID of the column, needs to match the data array
				name: columnIndex,

				// Width of each column needs to be known for infinite scrolling to work
				width: columnWidthsArr[columnIndex],

				// Spaces are preserved and cell text is broken by new line characters
				whiteSpace: 'pre'
			});
		}

		return dataGridColumnsArr;
	}

	function getDataGridCustomHeaders (dataGridColumnsArr) {

		// Override the default headers to show a freeze/unfreeze button within header

		class ColumnHeader {

			constructor (propsObj) {

				// Create wrapper
				const headerWrapperElement = getHeaderActionWrapper();

				// Place action button in wrapper
				const headerActionElement = getHeaderActionButtonForColumn(propsObj.columnInfo);
				headerWrapperElement.appendChild(headerActionElement);

				// Add column display name before the button
				headerActionElement.parentNode.insertBefore(document.createTextNode(propsObj.columnInfo.header), headerActionElement);

				angular.extend(this, {
					headerAction: headerActionElement,
					headerWrapper: headerWrapperElement
				});
			}

			getElement () {
				// Overwrite default header with our new one
				return this.headerWrapper;
			}

			render () {
				// Required to be here but unused
			}
		}

		function getHeaderActionButtonForColumn (columnInfoObj) {

			const isColumnFrozen = getDataGridFrozenColumn(columnInfoObj.name);

			// Create button
			const headerActionElement = document.createElement('button');
			headerActionElement.classList.add('report-entry_header-action', 'is-clear');
			headerActionElement.setAttribute('type', 'button');
			headerActionElement.setAttribute('data-pc', 'report-entry-freeze');
			headerActionElement.setAttribute('aria-label', `Toggle column freeze: ${columnInfoObj.header}`);

			// Place icon within button
			const headerActionIconElement = getHeaderActionButtonIconForColumn(isColumnFrozen);
			headerActionElement.appendChild(headerActionIconElement);

			// Attach click event to toggle column freeze
			headerActionElement.onclick = event => {
				event.preventDefault();

				onColumnHeaderFreezeToggle(columnInfoObj);
			};

			return headerActionElement;
		}

		function getHeaderActionButtonIconForColumn (isColumnFrozen) {

			// Create icon element
			const headerActionIconElement = document.createElement('i');

			// If column is frozen show cross icon, or show pin
			headerActionIconElement.classList.add('is-small', isColumnFrozen ? 'icon-cross' : 'icon-pin');

			return headerActionIconElement;
		}

		function getHeaderActionWrapper () {

			const headerWrapperElement = document.createElement('div');
			headerWrapperElement.classList.add('report-entry_header');

			return headerWrapperElement;
		}

		const dataGridHeadersArr = [];

		for (let dataGridHeaderObj of dataGridColumnsArr) {
			dataGridHeadersArr.push({
				name: dataGridHeaderObj.name,
				renderer: ColumnHeader
			});
		}

		return dataGridHeadersArr;
	}

	function getDataGridDataArray (customReportEntryTableObj) {

		/*
			Returns array of rows from the report entry table
			eg:
			[
				{
					0: 'Row 1 - Column 1',
					1: 'Row 1 - Column 2
				},
				{
					0: 'Row 2 - Column 1',
					1: 'Row 2 - Column 2
				}
			]
		*/

		const dataArr = [];

		for (let reportRowObj of customReportEntryTableObj.ReportRows) {

			const reportRowDataObj = {};

			for (let reportRowCellObj of reportRowObj.ReportRowCells) {
				reportRowDataObj[reportRowCellObj.ColumnNumber] = reportRowCellObj.Value;
			}

			dataArr.push(reportRowDataObj);
		}

		return dataArr;
	}

	function getDataGridForReportEntryTable ($element, customReportEntryTableObj) {

		const dataGridColumnsArr = getDataGridColumnsArray($element, customReportEntryTableObj);
		const dataGridDataArr = getDataGridDataArray(customReportEntryTableObj);

		const tuiDataGridInstance = new tui.Grid({
			columnOptions: {
				frozenCount: REPORT_INSTANCE.frozenColumnCount
			},
			bodyHeight: dataGridDataArr.length > 6 ? 500 : 'auto',
			columns: dataGridColumnsArr,
			data: dataGridDataArr,
			el: $element.querySelector(REPORT_SETTINGS.selectors.grid),
			header: {
				align: 'left',
				columns: getDataGridCustomHeaders(dataGridColumnsArr),
				height: REPORT_SETTINGS.tableDimensions.headerRowHeight
			},
			minBodyHeight: REPORT_SETTINGS.tableDimensions.bodyRowHeight,
			rowHeight: REPORT_SETTINGS.tableDimensions.bodyRowHeight,

			contextMenu: () => [
				[
					{
						name: 'copy',
						label: 'Copy',
						action: 'copy',
					},
					{
						name: 'copyColumns',
						label: 'Copy Columns',
						action: 'copyColumns',
					},
					{
						name: 'copyRows',
						label: 'Copy Rows',
						action: 'copyRows',
					},
					{
						name: 'exportCsv',
						label: 'Export CSV',
						action: 'csvExport',
					}
				],
			],
			summary: getDataGridSummary(customReportEntryTableObj),
			usageStatistics: false,
			width: 'auto'
		});

		// Store original data to use in search
		tuiDataGridInstance.originalData = dataGridDataArr;

		return tuiDataGridInstance;
	}

	function getDataGridSummary (customReportEntryTableObj) {

		function getClassForTotalRowCellValue (value) {

			if (value > 0) {
				return 'is-positive';
			}
			else if (value < 0) {
				return 'is-assertive';
			}

			return 'is-greyscale';
		}

		function getColumnHeaderForColumnNumber (columnNumber) {
			return customReportEntryTableObj.TitleRow.TitleRowCells.find(reportTitleCellObj => reportTitleCellObj.ColumnNumber === columnNumber).Value;
		}

		// Hide summary row if there are no totals in report entry
		if (customReportEntryTableObj.TotalRow.TotalRowCells.every(reportTotalCellObj => reportTotalCellObj.Value === '')) {
			return;
		}

		const summaryContentObj = {};

		for (let reportTotalCellObj of customReportEntryTableObj.TotalRow.TotalRowCells) {
			summaryContentObj[reportTotalCellObj.ColumnNumber] = {
				template: () => {

					const columnHeader = getColumnHeaderForColumnNumber(reportTotalCellObj.ColumnNumber);
					const cellClass = getClassForTotalRowCellValue(reportTotalCellObj.Value);

					return `<div class='report-entry_summary ${cellClass}'>
								<div class='report-entry_summary-content'>
									<div class='report-entry_summary-heading'>
										${columnHeader}
									</div>

									<div class='report-entry_summary-value'>
										${reportTotalCellObj.Value}
									<div>
								</div>
							</div>`;
				}
			};
		}

		return {
			height: REPORT_SETTINGS.tableDimensions.summaryRowHeight,
			position: 'bottom',
			columnContent: summaryContentObj
		};
	}

	function getDataGridFrozenColumn (name) {
		return REPORT_INSTANCE.frozenColumnStorage[name];
	}

	function onColumnHeaderFreezeToggle (columnInfoObj) {

		const storedFrozenColumnObj = getDataGridFrozenColumn(columnInfoObj.name);

		// Unfreeze frozen column
		if (storedFrozenColumnObj) {

			// Decrease count of frozen columns
			REPORT_INSTANCE.frozenColumnCount--;

			// Update the data grid for each entry
			for (let reportEntryDataGridInstance of REPORT_INSTANCE.dataGridCollection) {

				// Move column back to original position
				reportEntryDataGridInstance.moveColumn(columnInfoObj.name, storedFrozenColumnObj.originalIndex);

				// Set count of frozen columns
				reportEntryDataGridInstance.setFrozenColumnCount(REPORT_INSTANCE.frozenColumnCount);
			}

			// Delete column from storage
			delete REPORT_INSTANCE.frozenColumnStorage[columnInfoObj.name];

		}

		// Freeze column
		else {

			// Get original column index to store later
			const originalColumnIndex = REPORT_INSTANCE.dataGridCollection[0].getIndexOfColumn(columnInfoObj.name);
			const newColumnIndex = REPORT_INSTANCE.frozenColumnCount;

			// Increase count of frozen columns
			REPORT_INSTANCE.frozenColumnCount++;

			// Update the data grid for each entry
			for (let reportEntryDataGridInstance of REPORT_INSTANCE.dataGridCollection) {

				// Move column to beginning of grid
				reportEntryDataGridInstance.moveColumn(columnInfoObj.name, newColumnIndex);

				// Set count of frozen columns
				reportEntryDataGridInstance.setFrozenColumnCount(REPORT_INSTANCE.frozenColumnCount);

				// Forcing table to recalculate the right side width after moving the column to the left side
				let gridRsideArea = document.querySelector('.tui-grid-rside-area');
				if (gridRsideArea) {
					gridRsideArea.style.width = '0px';
				}
			}

			REPORT_INSTANCE.frozenColumnStorage[columnInfoObj.name] = {
				originalIndex: originalColumnIndex
			};
		}

		// Show/hide column freeze action if frozen column count is over pre defined limit
		const columnHeaderActionElementsArr = document.querySelectorAll(REPORT_SETTINGS.selectors.headers);
		const columnHeaderActionVisibilityStyle = REPORT_INSTANCE.frozenColumnCount === REPORT_SETTINGS.frozenColumnMax ? 'hidden' : '';
		for (let columnHeaderActionElement of columnHeaderActionElementsArr) {
			columnHeaderActionElement.style.visibility = columnHeaderActionVisibilityStyle;
		}
	}

	function onCreateDataGrid ($element, customReportEntryObj) {

		// Create instance of report if it hasn't already been done
		if (!REPORT_INSTANCE) {
			resetReportInstance();
		}

		// Get ToastUI data grid
		const tuiDataGridInstance = getDataGridForReportEntryTable($element, customReportEntryObj.CustomReportEntryTable);

		// Apply highlighting to grid where applicable
		if (customReportEntryObj.processedData) {
			setGridStylesFromProcessedData(tuiDataGridInstance, customReportEntryObj.processedData);
		}

		// Store instance to use for freezing all columns within a report
		REPORT_INSTANCE.dataGridCollection.push(tuiDataGridInstance);

		return tuiDataGridInstance;
	}

	function onDataGridSearch (searchString) {

		// Only search when there is one entry in report eg. not multi datagrid report which are handled by filter in report-viewer-component
		if (REPORT_INSTANCE.dataGridCollection.length > 1) {
			return;
		}

		for (let reportEntryDataGridInstance of REPORT_INSTANCE.dataGridCollection) {

			if (searchString)  {

				const currentData = angular.copy(reportEntryDataGridInstance.originalData);

				const filteredData = $filter('filter')(currentData, searchString);

				reportEntryDataGridInstance.resetData(filteredData);

			}
			else {
				// Reset data to original
				reportEntryDataGridInstance.resetData(reportEntryDataGridInstance.originalData);
			}
		}
	}

	function resetReportInstance () {
		REPORT_INSTANCE = new ReportInstance();
	}

	function setGridStylesFromProcessedData (gridInstance, processedDataObj) {

		// Historic Periods
		if (processedDataObj.historicPeriods) {
			for (let historicPeriodRowIndex of processedDataObj.historicPeriods) {
				gridInstance.addRowClassName(historicPeriodRowIndex, 'has-highlight');
			}
		}
	}

	return {
		createNewReport: resetReportInstance,
		createDataGrid: onCreateDataGrid,
		onSearch: onDataGridSearch
	};
}]);

'use strict';

angular.module('paycircleApp')
.factory('rotareadyTeamMembersDataFactory',
	function () {
		let teamMembersData = {
			teamMembersMatched: [],
			teamMembersUnmatchedRotaready: [],
			teamMembersUnmatchedPaycircle: [],
			teamMembersReceivedFromRotaready: 0,

			teamMemberMappingsUpdated: [],
			createInPaycircle: []
		};

		return {
			getTeamMembersData: function () {
				return teamMembersData;
			},
			getTeamMembersReceivedFromRotaready: function () {
				return teamMembersData.teamMembersReceivedFromRotaready;
			},
			setTeamMembersData: function (teamMapping) {
				teamMembersData.teamMembersMatched = teamMapping.filter(t => t.Paycircle && t.Rotaready);
				teamMembersData.teamMembersUnmatchedRotaready = teamMapping.filter(t => !t.Paycircle);
				teamMembersData.teamMembersUnmatchedPaycircle = teamMapping.filter(t => !t.Rotaready);
				teamMembersData.teamMembersReceivedFromRotaready = teamMapping.filter(t => t.Rotaready).length;
				teamMembersData.teamMemberMappingsUpdated = [];
				teamMembersData.createInPaycircle = [];
			},
			getTeamMembersUnmatchedPaycircle: function () {
				return teamMembersData.teamMembersUnmatchedPaycircle;
			},
			getTeamMembersUnmatchedRotaready: function () {
				return teamMembersData.teamMembersUnmatchedRotaready;
			},
			setTeamMembersMatched: function (teamMembersMatched) {
				teamMembersData.teamMembersMatched = teamMembersMatched;
			},
			getTeamMembersMatched: function () {
				return teamMembersData.teamMembersMatched;
			},
			setCreateInPaycircle: function (createInPaycircle) {
				teamMembersData.createInPaycircle = createInPaycircle;
			},
			getCreateInPaycircle: function () {
				return teamMembersData.createInPaycircle;
			},
			clearTeamMembersData : function () {
				teamMembersData = [];
			},
			matchTeamMembers: function (teamMember) {
				teamMembersData.teamMembersUnmatchedRotaready = [...teamMembersData.teamMembersUnmatchedRotaready.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id)];
				teamMembersData.teamMembersUnmatchedPaycircle = teamMembersData.teamMembersUnmatchedPaycircle.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
				teamMembersData.teamMemberMappingsUpdated.push(teamMember);
			},
			unmatchTeamMembers: function (teamMember) {

				teamMembersData.teamMemberMappingsUpdated = teamMembersData.teamMemberMappingsUpdated.filter(x => x.Paycircle === null || x.Paycircle.Id !== teamMember.Paycircle.Id);

				teamMembersData.teamMembersUnmatchedRotaready.push(Object.assign({}, teamMember, { Paycircle: null }));
				teamMembersData.teamMembersUnmatchedPaycircle.push(Object.assign({}, teamMember, { Rotaready: null }));
			},
			getTeamMembersMappings: function () {
				return teamMembersData.teamMemberMappingsUpdated;
			},
			addNewPaycircleTeamMember: function (teamMember) {
				teamMembersData.teamMembersUnmatchedRotaready = teamMembersData.teamMembersUnmatchedRotaready.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
				teamMembersData.teamMemberMappingsUpdated.push(teamMember);
				teamMembersData.createInPaycircle.push(teamMember);
			},
			cancelNewPaycircleTeamMember: function (teamMember) {
				teamMembersData.teamMemberMappingsUpdated = teamMembersData.teamMemberMappingsUpdated.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
				teamMembersData.teamMembersUnmatchedRotaready.push(teamMember);
				teamMembersData.createInPaycircle = teamMembersData.createInPaycircle.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
			}
		};
});

'use strict';

angular.module('paycircleApp')
	.service('rotareadyTeamMembersService', [
		'$q',
		'companyData',
		'rotareadyTeamMembersDataFactory',
		function (
			$q,
			companyData,
			rotareadyTeamMembersDataFactory
		) {

			const service = {

				getAccessRotareadyUserMapping: (agencyProfileId) => {
					return companyData.getAccessRotareadyUserMapping(agencyProfileId).then(teamMapping => {

						teamMapping.forEach(teamMember => {
							if(teamMember.Rotaready && teamMember.Rotaready.Nino === null) {
								teamMember.Rotaready.Nino = '';
							}
						});

						rotareadyTeamMembersDataFactory.setTeamMembersData(teamMapping);
					});
				},

				saveTeamMembersChanges: (agencyProfileId, teamMemberMappingsUpdated, rotareadyIds, callback, onError) => {
					const saveTeamMemberMappings = companyData.updateAccessRotareadyUserMapping(agencyProfileId, teamMemberMappingsUpdated);
					const createAccessRotareadyUsers = rotareadyIds.length > 0 ? companyData.createAccessRotareadyUsers(agencyProfileId, rotareadyIds) : null;

					$q.all([
						saveTeamMemberMappings,
						createAccessRotareadyUsers
					]).then(
					([
						_,
						createAccessRotareadyUsersArr
					]) => {

						callback(createAccessRotareadyUsersArr);
					})
					.catch(onError);
				},
			};

			return service;
}]);

'use strict';

angular.module('paycircleApp')
	.factory('ROTAREADY_UPDATES', [
		'$filter',
		'ROTAREADY_UPDATES_EVENT_TYPES',
		'ROTAREADY_UPDATES_EVENT_STATUS',
		function (
			$filter,
			ROTAREADY_UPDATES_EVENT_TYPES,
			ROTAREADY_UPDATES_EVENT_STATUS
	) {

		return {
			buildEventText: function(eventType, eventStatus, dateAndTime) {

				const mapObj = {
					[ROTAREADY_UPDATES_EVENT_TYPES.absenceRequested]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Absence requested',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Absence request failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Absence request received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Absence request processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Absence request skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Absence request held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.absenceCancelled]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Absence cancelled',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Absence cancellation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Absence cancellation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Absence cancellation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Absence cancellation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Absence cancellation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.absenceApproved]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Absence approved',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Absence approval failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Absence approval received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Absence approval processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Absence approval skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Absence approval held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.absenceprocessing]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Absence processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Absence rejection failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Absence rejection received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Absence rejection processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Absence rejection skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Absence rejection held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.rotaMarkedForApproval]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Rota marked for approval',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Rota marking for approval failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Rota marking for approval received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Rota marking for approval processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Rota marking for approval skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Rota marking for approval held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.rotaPublished]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Rota published',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Rota publishing failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Rota publishing received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Rota publishing processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Rota publishing skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Rota publishing held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.rotaRevertedToDraft]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Rota reverted to draft',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Rota reversion to draft failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Rota reversion to draft received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Rota reversion to draft processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Rota reversion to draft skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Rota reversion to draft held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.signOffWeek]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Week signed off',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Week sign-off failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Week sign-off received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Week sign-off processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Week sign-off skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Week sign-off held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userNeedsApproval]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User needs approval',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User approval need failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User approval need received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User approval need processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User approval need skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User approval need held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userApproved]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User approved',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User approval failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User approval received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User approval processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User approval skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User approval held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftSwapRequested]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift swap requested',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift swap request failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift swap request received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift swap request processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift swap request skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift swap request held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftSwapAccepted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift swap accepted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift swap acceptance failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift swap acceptance received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift swap acceptance processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift swap acceptance skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift swap acceptance held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftSwapApproved]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift swap approved',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift swap approval failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift swap approval received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift swap approval processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift swap approval skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift swap approval held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftSwapprocessing]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift swap processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift swap rejection failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift swap rejection received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift swap rejection processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift swap rejection skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift swap rejection held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftSwapCancelled]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift swap cancelled',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift swap cancellation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift swap cancellation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift swap cancellation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift swap cancellation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift swap cancellation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userDocumentExpiring]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User document expiring',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User document expiring notification failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User document expiring notification received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User document expiring notification processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User document expiring notification skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User document expiring notification held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userDocumentExpired]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User document expired',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User document expired notification failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User document expired notification received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User document expired notification processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User document expired notification skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User document expired notification held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User appointment created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User appointment creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User appointment creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User appointment creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User appointment creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User appointment creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User appointment updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User appointment update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User appointment update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User appointment update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User appointment update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User appointment update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userAppointmentDeleted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User appointment deleted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User appointment deletion failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User appointment deletion received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User appointment deletion processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User appointment deletion skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User appointment deletion held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userPayCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User pay created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User pay creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User pay creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User pay creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User pay creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User pay creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userPayUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User pay updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User pay update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User pay update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User pay update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User pay update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User pay update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userPayDeleted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User pay deleted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User pay deletion failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User pay deletion received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User pay deletion processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User pay deletion skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User pay deletion held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastAccepted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast accepted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast acceptance failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast acceptance received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast acceptance processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast acceptance skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast acceptance held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastprocessing]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast rejection failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast rejection received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast rejection processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast rejection skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast rejection held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastFilled]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast filled',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast filling failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast filling received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast filling processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast filling skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast filling held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastPaused]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast paused',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast pausing failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast pausing received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast pausing processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast pausing skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast pausing held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastStopped]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast stopped',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast stopping failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast stopping received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast stopping processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast stopping skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast stopping held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.shiftBroadcastResumed]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Shift broadcast resumed',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Shift broadcast resuming failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Shift broadcast resuming received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Shift broadcast resuming processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Shift broadcast resuming skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Shift broadcast resuming held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.signOffWeekReversed]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Week sign-off reversed',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Week sign-off reversal failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Week sign-off reversal received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Week sign-off reversal processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Week sign-off reversal skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Week sign-off reversal held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.signOffDay]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Day signed off',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Day sign-off failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Day sign-off received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Day sign-off processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Day sign-off skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Day sign-off held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.signOffDayReversed]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Day sign-off reversed',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Day sign-off reversal failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Day sign-off reversal received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Day sign-off reversal processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Day sign-off reversal skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Day sign-off reversal held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.integrationSettingsUpdate]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Integration settings updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Integration settings update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Integration settings update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Integration settings update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Integration settings update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Integration settings update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userDocumentCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User document created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User document creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User document creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User document creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User document creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User document creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userDocumentDeleted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User document deleted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User document deletion failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User document deletion received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User document deletion processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User document deletion skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User document deletion held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User employment created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User employment creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User employment creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User employment creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User employment creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User employment creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User employment updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User employment update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User employment update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User employment update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User employment update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User employment update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentDeleted]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User employment deleted',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User employment deletion failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User employment deletion received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User employment deletion processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User employment deletion skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User employment deletion held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.documentPreSignatureCreated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Document pre-signature created',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Document pre-signature creation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Document pre-signature creation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Document pre-signature creation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Document pre-signature creation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Document pre-signature creation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.documentPreSignatureUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Document pre-signature updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Document pre-signature update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Document pre-signature update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Document pre-signature update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Document pre-signature update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Document pre-signature update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.documentPreSignatureCancelled]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Document pre-signature cancelled',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Document pre-signature cancellation failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Document pre-signature cancellation received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Document pre-signature cancellation processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Document pre-signature cancellation skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Document pre-signature cancellation held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userDocumentUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User document updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User document update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User document update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User document update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User document update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User document update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.absenceUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Absence updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Absence update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Absence update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Absence update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Absence update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Absence update held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.userEmploymentEndDateSet]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'User employment end date set',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'User employment end date setting failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'User employment end date setting received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'User employment end date setting processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'User employment end date setting skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'User employment end date setting held'
					},
					[ROTAREADY_UPDATES_EVENT_TYPES.allowanceUpdated]: {
						[ROTAREADY_UPDATES_EVENT_STATUS.complete]: 'Allowance updated',
						[ROTAREADY_UPDATES_EVENT_STATUS.failed]: 'Allowance update failed',
						[ROTAREADY_UPDATES_EVENT_STATUS.new]: 'Allowance update received',
						[ROTAREADY_UPDATES_EVENT_STATUS.processing]: 'Allowance update processing',
						[ROTAREADY_UPDATES_EVENT_STATUS.skipped]: 'Allowance update skipped',
						[ROTAREADY_UPDATES_EVENT_STATUS.held]: 'Allowance update held'
					}
			};

			return mapObj[eventType][eventStatus] + ' at ' +  $filter('dateformat')(dateAndTime, 'timeDayDate');
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.service('salaryService', [
	'$filter', 
	'config', 
	'utilities',
	'AGENCY_ADJUSTMENT_RATE_TYPES',
	'SALARY_TYPES', 
	function (
		$filter, 
		config, 
		utilities,
		AGENCY_ADJUSTMENT_RATE_TYPES,
		SALARY_TYPES) {

	const service = {

		addSalaryRateCustom: salaryObj => {

			const customRate = service.getCustomRate();
			
			if (!salaryObj.SalaryRatesWithCalculated.find(salaryRate => salaryRate.SalaryRateID === customRate.SalaryRateID)) {

				salaryObj.SalaryRatesWithCalculated.push(customRate);
			}
		},

		addSalaryRateLinkElementGlobalRate: (salaryObj, linkElementObj) => {

			if (linkElementObj.LinkElementRate > 0) {

				salaryObj.SalaryRatesWithCalculated.push(service.getGlobalRateForLinkElement(linkElementObj));
			}
		},

		addSalaryRates: (salaryObj) => {

			service.decorateSalaryRates(salaryObj);
			
			service.addSalaryRateCustom(salaryObj);
		},

		decorateSalaryRates: (salaryObj) => {

			salaryObj.SalaryRatesWithCalculated.forEach(salaryRateObj => {

				if (salaryRateObj.SalaryRateID === config.guidEmpty) {

					salaryRateObj.SalaryRateID = service.getSalaryRateKey(salaryRateObj);
				}
			});

			return salaryObj;
		},
		/**
		 * @description This function maps backdated salary derived element values to the correct sign for display when they are a deduction Adjustment.
		 * A salary decrease affects a deduction with a positive increase in gross pay so a backdated salary element 
		 * that is a deduction type, with a negative sign is an addition and should be displayed as such.
		 * @param {Object} backdatedElementObj UserPayElement.UserPayElementMinimal
		 */
		getBackdatedSalaryDerivedElementValueForDisplay: (backdatedElementObj) => {
			let normalisedValue = backdatedElementObj.Value;

			if (backdatedElementObj.Deduction) {
				normalisedValue = -backdatedElementObj.Value;
			} 

			return normalisedValue;
		},

		getCustomRate: () => {

			const rateLabel = 'Custom rate';

			return {
				SalaryRateDescription: rateLabel,
				SalaryRateDisplay: rateLabel,
				SalaryRateHours: 1,
				SalaryRateID: 'custom',
				SalaryRateValue: ''
			};
		},

		getGlobalRateForLinkElement: linkElementObj => {

			// Monetise value
			linkElementObj.linkElementRateDisplay = $filter('monetise')(linkElementObj.LinkElementRate, config.precision.salaryRates);

			const rateLabel = `${linkElementObj.LinkElementName} global rate (${linkElementObj.linkElementRateDisplay})`;

			return {
				SalaryRateDescription: rateLabel,
				SalaryRateDisplay: rateLabel,
				SalaryRateHours: 1,
				SalaryRateID: 'global-rate',
				SalaryRateValue: linkElementObj.LinkElementRate
			};
		},

		getHasValidGrossSalary: salaryObj => {

			// Doesn't apply to people with a Net Pay salary
			if (salaryObj.SalaryType !== SALARY_TYPES.grossPay) {
				return false;
			}

			if (angular.isUndefined(salaryObj.SalaryYearly)) {
				return false;
			}

			if (salaryObj.SalaryYearly === 0) {
				return false;
			}

			return true;
		},

		getSalaryDetailsWithRatesForPost (salariesObj, salaryPolicyPostId) {

			var salaryObj = salariesObj.find(function (salary) {
				return salary.SalaryPolicyPostID === salaryPolicyPostId;
			});

			if (angular.isUndefined(salaryObj)) {
				/* Salary may not exist for additional post, use main post as template instead */
				salaryObj = angular.copy(salariesObj.find(function (salary) {
					return salary.SalaryPolicyPostID === config.guidEmpty;
				}));

				salaryObj.SalaryRates = [];
				salaryObj.SalaryRatesWithCalculated = [];
				salaryObj.SalaryYearly = 0;
			}

			service.addSalaryRates(salaryObj);

			return salaryObj;
		},

		/* As salary rates are dynamically created, the only way to match these is based on the value defined */
		getSalaryRateForUserPayElement (salaryObj, userPayElementObj) {

			const numberOfSalaryRates = salaryObj.SalaryRatesWithCalculated.length;
			let i = 0;

			for (i; i < numberOfSalaryRates; i++) {

				const salaryRateObj = salaryObj.SalaryRatesWithCalculated[i];

				if (salaryRateObj.SalaryRateValue === userPayElementObj.UnitValue) {
					return angular.copy(salaryRateObj);
				}
			}

			return null;
		},

		/**
		 * Checks if a salary rate is a derived rate from a calculated salary
		 * @param {SalaryRate} salaryRate 
		 * @returns 
		 */
		getSalaryRateTypeIsSalaryDerivedRate(salaryRate) {
			return salaryRate.RateType === AGENCY_ADJUSTMENT_RATE_TYPES.calculatedDaily || salaryRate.RateType === AGENCY_ADJUSTMENT_RATE_TYPES.calculatedHourly;
		},

		getSalaryRateKey: salaryRateObj => {

			let items = [salaryRateObj.SalaryRateDescription, salaryRateObj.SalaryRateHours, salaryRateObj.SalaryRateValue];		
			return utilities.snakeCase(items.join(' '));
			//eg: daily-rate-0-123.00
		},
		
		getUnitValueForSalaryRateType: (salaryCalculationObj, salaryRateId) => {

			switch (salaryRateId) {

				case 'calculated-daily':
					return salaryCalculationObj.Daily;

				case 'calculated-hourly':
					return salaryCalculationObj.Hourly;

				default:
					return 0;
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('scheduleService', ['$filter', 'AOE_ORDER_STATES', 'REPAYMENT_SCHEDULE_TYPES', 'UI_SCHEDULE_TYPES', 'UI_SCHEDULE_STATUSES', function ($filter, AOE_ORDER_STATES, REPAYMENT_SCHEDULE_TYPES, UI_SCHEDULE_TYPES, UI_SCHEDULE_STATUSES) {

	const service = {

		/*
			Normalise all schedules into a single list for display, filtering and searching. These are represented in various
			guises as part of the statutoryPay object and teamMember object.
		 */
		createNormalisedSchedules: (statutoryPayObj, aoeInfoObj) => {

			let schedules = [];

			// Start by extracting various schedules from the statutory pay
			for (let key of Object.keys(statutoryPayObj)) {

				const objectPropertyValue = statutoryPayObj[key];

				// Extract array property representing the schedule
				if (angular.isArray(objectPropertyValue)) {

					// Add schedules one at a time, to ensure they have valid types set
					objectPropertyValue.forEach(schedule => {

						// Attempt to get the schedule type
						const scheduleType = service.getScheduleUIType(key, schedule);

						// If a type was determined, this is a bonafide schedule
						if (angular.isDefined(scheduleType)) {
							schedule.type = scheduleType;
							schedules.push(schedule);
						}
					});
				}
			}

			// Now add attachment of earnings schedules, normalising them to match generic schedule structure
			aoeInfoObj.AttachmentOrders.filter(service.decorateAttachmentOrder);

			if (angular.isDefined(aoeInfoObj.AttachmentOrders)) {
				aoeInfoObj.AttachmentOrders.forEach(aoeObj => {
					schedules.push(service.getScheduleForAoe(aoeObj));
				});
			}

			// Finally decorate each schedule
			schedules.forEach(scheduleObj => {
				scheduleObj = service.decorateSchedule(scheduleObj);
			});

			return schedules;
		},

		decorateAttachmentOrder: attachmentOrderObj => {

			return angular.extend(attachmentOrderObj, {
				orderStateIcon: service.getAoeOrderStateIcon(attachmentOrderObj.OrderState),
				orderStateTheme: service.getAoeOrderStateTheme(attachmentOrderObj.OrderState),
			});
		},

		decorateSchedule: (scheduleObj) => {

			const DEFAULT_DECORATION = {
				description: scheduleObj.PaymentScheduleTypeDescription,
				hasProgressRing: true,
				iconType: 'icon-money',
				overviewLabel: `${$filter('dateformat')(scheduleObj.StartDateISO, 'medium')} - ${$filter('dateformat')(scheduleObj.EndDateISO, 'medium')}`,
				overviewRemainingLabel: '',
				overviewRemainingValue: '',
				showRemaining: true,
				showEditPrompt: false,
				theme: 'is-primary'
			};

			let decoration = service.decorateScheduleType(scheduleObj);

			angular.extend(scheduleObj, DEFAULT_DECORATION, decoration);

			/* Schedule objects need to be adorned with a single status based on assorted flags present. This is simply for
			   ordering purposes (see UI_SCHEDULE_STATUSES), but since they're here, they're also used in the schedules filter.
			   Status info for UI cheese (text + theme) also added here The order of these is important, since statuses aren't
			   mutually exclusive. For example, stopping a payment will mark is 'HasStopped' *and* 'HasEnded' (certainly for
			   Childcare Vouchers). In that case the 'stopped' status is probably more significant. Similarly for paused
			   schedules, they can be marked as both 'HasPaused' and 'IsInProgress', in which case the paused status takes
			   precedence. */
			if (scheduleObj.HasStopped) {
				scheduleObj.status = UI_SCHEDULE_STATUSES.stopped;
				scheduleObj.statusDisplay = 'PAYMENTS STOPPED';
				scheduleObj.statusTheme = 'is-tertiary';
			}
			else if (scheduleObj.HasCancelled) {
				scheduleObj.status = UI_SCHEDULE_STATUSES.cancelled;
				scheduleObj.statusDisplay = 'CANCELLED';
				scheduleObj.statusTheme = 'is-tertiary';
			}
			else if (scheduleObj.HasPaused) {
				scheduleObj.status = UI_SCHEDULE_STATUSES.paused;
				scheduleObj.statusDisplay = 'PAUSED';
				scheduleObj.statusTheme = 'is-tertiary';
			}
			else if (scheduleObj.IsPending) {
				if (!angular.isDefined(scheduleObj.overviewRemainingLabel)) {
					scheduleObj.overviewRemainingLabel = 'pending';
				}
				scheduleObj.status = UI_SCHEDULE_STATUSES.pending;
				scheduleObj.statusDisplay = 'PENDING';
				scheduleObj.statusTheme = 'is-indifferent-lighter';
			}
			else if ((scheduleObj.IsInProgress || (scheduleObj.HasStarted) && !scheduleObj.IsPaidInFull)) {
				// Only update the overview remaining label if it hasn't already been set by decorateScheduleType
				if (!angular.isDefined(scheduleObj.overviewRemainingLabel)) {
					scheduleObj.overviewRemainingLabel = 'remaining';
				}
				scheduleObj.status = UI_SCHEDULE_STATUSES.inProgress;
				// 'In progress' is implied when no other status is applicable, so no cheese for this
			}
			else if (scheduleObj.IsPaidInFull || scheduleObj.HasEnded) {
				scheduleObj.status = UI_SCHEDULE_STATUSES.complete;
				scheduleObj.statusDisplay = 'COMPLETE';
				scheduleObj.statusTheme = 'is-secondary';
			}

			return scheduleObj;
		},

		decorateScheduleType: scheduleObj => {

			switch (scheduleObj.type) {

				// Adoption pay
				case UI_SCHEDULE_TYPES.adoptionPay: {
					return {
						hasProgressRing: true,
						iconType: 'icon-paternity',
						theme: 'is-tertiary'
					};
				}

				// AOE
				case UI_SCHEDULE_TYPES.attachmentOfEarnings: {
					let overviewLabel = '';
					if (scheduleObj.aoe.DisbursementDetail.ManualPayment) {
						overviewLabel = 'This order is set to be paid manually';
					}
					else if (scheduleObj.aoe.DisbursementDetail.BankInfo.BankAccountName) {
						overviewLabel = scheduleObj.aoe.DisbursementDetail.BankInfo.BankAccountName;
					}
					else {
						overviewLabel = 'Missing bank details';
					}
					return {
						description: 'Attachment of Earnings',
						hasProgressRing: true,
						iconType: `icon-${scheduleObj.aoe.orderStateIcon}`,
						overviewLabel,
						overviewRemainingLabel: scheduleObj.aoe.AmountRemaining !== 0 || scheduleObj.aoe.OrderState === AOE_ORDER_STATES.complete ? 'still to pay' : 'fixed amount',
						overviewRemainingValue: scheduleObj.aoe.AmountRemaining !== 0 || scheduleObj.aoe.OrderState === AOE_ORDER_STATES.complete ? $filter('monetise')(scheduleObj.aoe.AmountRemaining) : $filter('monetise')(scheduleObj.aoe.FixedAmountValue),
						theme: scheduleObj.aoe.orderStateTheme
					};
				}

				// Car BIK
				case UI_SCHEDULE_TYPES.carBenefitInKind: {
					return {
						description: scheduleObj.Label !== '' ? scheduleObj.Label : scheduleObj.PaymentScheduleTypeDescription,
						iconType: `icon-${$filter('paymentScheduleTypeIcon')(scheduleObj.PaymentScheduleTypeID)}`,
						overviewLabel: 'Benefit cost: ' + $filter('monetise')(scheduleObj.AmountOutstanding + scheduleObj.AmountPaid + scheduleObj.AmountBroughtForward),
						overviewRemainingLabel: 'per period',
						overviewRemainingValue: $filter('monetise')(scheduleObj.ValueForPeriod),
						pausedTag: 'PAUSED',
						stoppedTag: 'STOPPED'
					};
				}

				// Childcare vouchers
				case UI_SCHEDULE_TYPES.childcareVouchers: {
					return {
						hasProgressRing: false,
						iconType: 'icon-maternity',
						overviewIcon: 'icon-loading',
						overviewLabel: $filter('monetise')(scheduleObj.ValueForPeriod),
						overviewRemainingLabel: scheduleObj.HasStopped ? 'payments stopped' : scheduleObj.HasStarted ? 'payments started' : 'pending',
						overviewRemainingValue: scheduleObj.PayPeriodDisplay,
						theme: 'quarternary'
					};
				}

				// Company loan
				case UI_SCHEDULE_TYPES.companyLoan: {
					return {
						hasProgressRing: true,
						iconType: 'icon-company',
						overviewRemainingLabel: 'still to pay',
						overviewRemainingValue: $filter('monetise')(scheduleObj.AmountOutstanding),
						theme: 'primary'
					};
				}

				// Covid 19 Sick Pay
				case UI_SCHEDULE_TYPES.covid19SickPay: {
					return {
						hasProgressRing: true,
						iconType: 'icon-virus',
						overviewRemainingLabel: '',
						theme: 'secondary'
					};
				}

				// Cycle to Work scheme
				case UI_SCHEDULE_TYPES.cycleToWorkScheme: {
					return {
						HasEnded: scheduleObj.IsPaidInFull,
						hasProgressRing: true,
						iconType: 'icon-cycle-to-work',
						overviewIcon: 'icon-loading',
						overviewLabel: $filter('monetise')(scheduleObj.ValueForPeriod),
						overviewRemainingLabel: 'still to pay',
						overviewRemainingValue: $filter('monetise')(scheduleObj.AmountOutstanding),
						theme: 'primary'
					};
				}

				// Furlough
				case UI_SCHEDULE_TYPES.furlough: {
					return {
						hasProgressRing: false,
						iconType: 'icon-wallet',
						showEditPrompt: true,
						showRemaining: false,
						theme: 'assertive'
					};
				}

				// Healthcare
				case UI_SCHEDULE_TYPES.healthcare: {
					return {
						description: scheduleObj.Label !== '' ? scheduleObj.Label : scheduleObj.PaymentScheduleTypeDescription,
						iconType: `icon-${$filter('paymentScheduleTypeIcon')(scheduleObj.PaymentScheduleTypeID)}`,
						overviewLabel: 'Benefit cost: ' + $filter('monetise')(scheduleObj.AmountOutstanding + scheduleObj.AmountPaid + scheduleObj.AmountBroughtForward),
						overviewRemainingLabel: 'per period',
						overviewRemainingValue: $filter('monetise')(scheduleObj.ValueForPeriod),
						pausedTag: 'PAUSED',
						stoppedTag: 'STOPPED'
					};
				}

				// Maternity pay
				case UI_SCHEDULE_TYPES.maternityPay: {
					return {
						hasProgressRing: true,
						iconType: 'icon-maternity',
						showRemaining: false,
						theme: scheduleObj.HasEnded ? 'secondary' : 'tertiary'
					};
				}

				// Paternity pay
				case UI_SCHEDULE_TYPES.paternityPay: {
					return {
						hasProgressRing: true,
						iconType: 'icon-maternity',
						showRemaining: false,
						theme: scheduleObj.HasEnded ? 'secondary' : 'tertiary'
					};
				}

				// Season ticket loan
				case UI_SCHEDULE_TYPES.seasonTicketLoan: {
					return {
						hasProgressRing: true,
						iconType: 'icon-season-ticket',
						overviewRemainingLabel: 'still to pay',
						overviewRemainingValue: $filter('monetise')(scheduleObj.AmountOutstanding),
						theme: 'primary'
					};
				}

				// ShPP
				case UI_SCHEDULE_TYPES.sharedParentalPay: {
					return {
						hasProgressRing: true,
						iconType: 'icon-paternity',
						theme: scheduleObj.HasEnded ? 'secondary' : 'tertiary'
					};
				}

				// Sick pay
				case UI_SCHEDULE_TYPES.sickPay: {
					// Calculate sickness days, adding 1 to include the initial day
					const overviewRemainingValue = moment(scheduleObj.EndDateISO).diff(scheduleObj.StartDateISO, 'days') + 1;
					return {
						hasProgressRing: true,
						iconType: 'icon-sick',
						overviewRemainingLabel: `${overviewRemainingValue === 1 ? 'day' : 'days'} sickness`,
						overviewRemainingValue,
						theme: 'secondary'
					};
				}
			}
		},

		getAoeOrderStateTheme: aoeOrderState => {

			switch (aoeOrderState) {
				case AOE_ORDER_STATES.cancelled:
					return 'tertiary complete';
				case AOE_ORDER_STATES.complete:
					return 'secondary';
				default:
					return 'assertive';
			}
		},

		getAoeOrderStateIcon: aoeOrderState => {

			switch (aoeOrderState) {
				case AOE_ORDER_STATES.cancelled:
					return 'cross';
				case AOE_ORDER_STATES.complete:
					return 'tick';
				default:
					return 'document';
			}
		},

		getScheduleForAoe: aoeObj => {

			return {
				type: UI_SCHEDULE_TYPES.attachmentOfEarnings,
				HasCancelled: aoeObj.OrderState === AOE_ORDER_STATES.cancelled,
				HasEnded: aoeObj.OrderState === AOE_ORDER_STATES.complete,
				HasPaused: aoeObj.IsPaused,
				IsInProgress: aoeObj.OrderState === AOE_ORDER_STATES.active,
				IsPaidInFull: aoeObj.OrderState === AOE_ORDER_STATES.complete,
				IsPending: aoeObj.IsPending,
				PaymentScheduleTypeDescription: 'Attachment of Earnings',
				ProgressPercentage: aoeObj.ProgressPercentage,

				// Attach the AOE to the generic schedule object (for decoration purposes, below)
				aoe: aoeObj
			};
		},

		getScheduleForFurlough: (teamMemberObj) => {

			// Add 'special' schedules. These don't look like the other schedules, but they are
			let scheduleObj = {
				type: UI_SCHEDULE_TYPES.furlough,
				IsPaidInFull: teamMemberObj.Company.IsFurloughedEnded,
				PaymentScheduleTypeDescription: `Furloughed ${teamMemberObj.Company.IsFurloughedPartTime ? 'part-time' : 'full-time'}`,
				StartDateISO: teamMemberObj.Company.FurloughedStartDateISO,
				EndDateISO: teamMemberObj.Company.FurloughedEndDateISO
			};

			return service.decorateSchedule(scheduleObj);
		},

		getScheduleUIType: (scheduleKey, scheduleObj) => {

			let scheduleType;

			// Is there a type identifier available?
			if (scheduleObj.hasOwnProperty('PaymentScheduleTypeID')) {
				// If the schedule is part of scheduled payments, get its type based on PaymentScheduleTypeID
				if (scheduleKey === UI_SCHEDULE_TYPES.scheduledPayments) {
					scheduleType = service.getScheduleUITypeForPaymentSchedule(scheduleObj);
				}
				else {
					// Check the key against the UI_SCHEDULE_TYPES. If there's a match, the key === the schedule type
					const uiScheduleTypes = Object.values(UI_SCHEDULE_TYPES);
					if (uiScheduleTypes.includes(scheduleKey)) {
						scheduleType = scheduleKey;
					}
				}
			}

			// This could remain undefined
			return scheduleType;
		},

		getScheduleUITypeForPaymentSchedule: scheduleObj => {

			switch (scheduleObj.PaymentScheduleTypeID) {
				case REPAYMENT_SCHEDULE_TYPES.carBenefitInKind: {
					return UI_SCHEDULE_TYPES.carBenefitInKind;
				}
				case REPAYMENT_SCHEDULE_TYPES.companyLoan: {
					return UI_SCHEDULE_TYPES.companyLoan;
				}
				case REPAYMENT_SCHEDULE_TYPES.childcareVouchers: {
					return UI_SCHEDULE_TYPES.childcareVouchers;
				}
				case REPAYMENT_SCHEDULE_TYPES.cycleToWorkScheme: {
					return UI_SCHEDULE_TYPES.cycleToWorkScheme;
				}
				case REPAYMENT_SCHEDULE_TYPES.healthcare: {
					return UI_SCHEDULE_TYPES.healthcare;
				}
				case REPAYMENT_SCHEDULE_TYPES.seasonTicketLoan: {
					return UI_SCHEDULE_TYPES.seasonTicketLoan;
				}
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')

.service('searchService', [
	'utilities',
	'SEARCH_BAR_ACTIONS',
	function (
		utilities,
		SEARCH_BAR_ACTIONS
	) {

	const service = {

		changeCustom: (optionsObj, customOptionObj) => {

			let storageKeys = optionsObj.storageKeys;

			// Update scope
			service.updateCustom(optionsObj, customOptionObj);

			service.hideMenus(optionsObj);

			// Save to storage
			if (storageKeys && storageKeys.custom) {
				utilities.addToStorage(storageKeys.custom, customOptionObj.key);
			}
		},

		changeItemsPerPage: (optionsObj, itemsPerPageObj) => {

			let storageKeys = optionsObj.storageKeys;

			// Update scope
			service.updateItemsPerPage(optionsObj, itemsPerPageObj);

			service.hideMenus(optionsObj);

			// Save to storage
			if (storageKeys && storageKeys.itemsPerPage) {
				utilities.addToStorage(storageKeys.itemsPerPage, itemsPerPageObj.key);
			}
		},

		changeLayout: (optionsObj, layoutOptionObj) => {

			let storageKeys = optionsObj.storageKeys;

			// Update scope
			service.updateLayout(optionsObj, layoutOptionObj);

			// Save to storage
			if (storageKeys && storageKeys.layout) {
				utilities.addToStorage(storageKeys.layout, layoutOptionObj.key);
			}
		},

		changeOrderBy: (optionsObj, orderByOptionObj) => {

			let storageKeys = optionsObj.storageKeys;

			// Update order by param
			service.updateOrderBy(optionsObj, orderByOptionObj);

			service.hideMenus(optionsObj);

			// Save to storage
			if (storageKeys && (storageKeys.orderBy)) {
				if (storageKeys.reverse) {
					utilities.addToStorage(storageKeys.orderBy, orderByOptionObj.key);
					utilities.addToStorage(storageKeys.reverse, orderByOptionObj.reverse.toString());
				}
			}
		},

		createSearchFilter: optionsObj => {

			if (!angular.isUndefined(optionsObj.search.filterOptions)) {

				const searchSettingsObj = service.getSearchSettingsForSelectedOption(optionsObj.search.filterOption, optionsObj);

				angular.extend(optionsObj.search, searchSettingsObj);
			}
		},

		getFilterOptionById: optionsObj => {

			const defaultFilterOption = angular.copy(optionsObj.search.filterOptions[0]);

			// Filter option id can be passed via URL
			if (angular.isDefined(optionsObj.search.filterOptionId)) {

				const activeFilterOption = optionsObj.search.filterOptions.find(filterOption => {
					return filterOption.id === optionsObj.search.filterOptionId;
				});

				return angular.isDefined(activeFilterOption) ? activeFilterOption : defaultFilterOption;
			}

			return defaultFilterOption;
		},

		getItemsPerPageOptions: (searchOptionsObj, itemCount) => {

			// Only applies if property is set
			if (angular.isUndefined(searchOptionsObj.results.canChangeItemsPerPage)) {
				return [];
			}

			const maxOptionsCount = 6;
			let itemsPerPageOptionsArr = [];
			let amountOverMaxCount;

			for (let optionIndex = 1; optionIndex <= maxOptionsCount; optionIndex++) {

				const amount = optionIndex * searchOptionsObj.results.itemsPerPage;

				if (!amountOverMaxCount && amount > itemCount) {
					amountOverMaxCount = optionIndex;
				}

				itemsPerPageOptionsArr.push({
					display: `Show ${amount}`,
					key: `items-per-page-${amount}`,
					value: amount
				});
			}

			// If max page option is more than item count, then remove it from returned array
			if (amountOverMaxCount) {
				itemsPerPageOptionsArr = itemsPerPageOptionsArr.splice(0, amountOverMaxCount);
			}

			return itemsPerPageOptionsArr;
		},

		getOptionsWithDefaults: (optionsObj) => {

			const SEARCH_FIELD_GUID = utilities.guid();
			const SEARCH_FIELD_ID_PREFIX = 'search-bar-search-field';

			const defaultOptions = {

				// ID for search field, so we can set focus to it as required
				id: `${SEARCH_FIELD_ID_PREFIX}_${SEARCH_FIELD_GUID}`,

				// Custom Menu
				custom: null,
				customObj: null,
				customOptions: null,
				showCustomMenu: false,

				// Items per page
				itemsPerPageOption: null,
				itemsPerPageOptions: null,
				showItemsPerPageMenu: false,

				// Layout
				layout: null,
				layoutObj: null,
				layoutOptions: null,
				showLayoutOption: false,

				// OrderBy
				orderBy: null,
				orderByObj: null,
				orderByOptions: null,
				showOrderByMenu: false,

				// Search
				search: {
					string: '',
					terms: {
						placeholder: 'Search...',
						noResults: 'No results',
						singular: '1 result',
						plural: '{} results'
					}
				},

				// Results
				results: {
					itemsPerPage: 15,
					reverse: false
				},

				// Storage Keys
				storageKeys: null,

				// Mobile
				showMobileCustom: false,
				showMobileItemsPerPage: false,
				showMobileSearch: false,
				showMobileSort: false
			};

			return angular.merge(defaultOptions, optionsObj);
		},

		getSearchSettingsForSelectedOption: (filterOption, optionsObj) => {

			let settingsObj = {};

			// Searches across entire object (default)
			if (filterOption.id === 'all') {

				angular.extend(settingsObj, {
					isExactMatch: false,
					searchFilter: {
						$: optionsObj.search.string
					}
				});

				return settingsObj;
			}

			const isExactMatch = optionsObj.search.string !== '' && angular.isDefined(filterOption.isExactMatch) ? filterOption.isExactMatch : false;

			let filterObj = {};
			let loop = 0;
			let i = 0;
			let numberOfFilterKeys = filterOption.filterKeys.length;

			// Single level obj
			if (numberOfFilterKeys === 1) {

				filterObj[filterOption.filterKeys[i]] = optionsObj.search.string;

				angular.extend(settingsObj, {
					isExactMatch,
					searchFilter: filterObj
				});

				return settingsObj;
			}

			// Multi level obj
			for (i; i < numberOfFilterKeys; i++) {

				const filterKey = filterOption.filterKeys[i];

				loop++;

				// First level
				if (loop === 1) {
					filterObj[filterKey] = {};
				}

				// Other
				else {

					const prop = filterOption.filterKeys[i - 1];

					// Last level
					if (loop === numberOfFilterKeys) {
						filterObj[prop] = {
							[filterKey]: optionsObj.search.string
						};
					}

					// Middle level
					else {
						filterObj[prop] = {};
					}
				}
			}

			angular.extend(settingsObj, {
				isExactMatch,
				searchFilter: filterObj
			});

			return settingsObj;
		},

		hideMenus: optionsObj => {

			optionsObj.showCustomMenu = false;
			optionsObj.showItemsPerPageMenu = false;
			optionsObj.showMobileCustom = false;
			optionsObj.showMobileItemsPerPage = false;
			optionsObj.showMobileSort = false;
			optionsObj.showOrderByMenu = false;
		},

		loadDefaultFilterOptions: optionsObj => {

			// Custom
			if (optionsObj.customOptions) {

				// Get from storage
				let storedCustomKey = utilities.getFromStorage(optionsObj.storageKeys.custom);

				// Check if stored value exists in array
				service.updateCustom(optionsObj, utilities.getObjectFromArrayByKey(optionsObj.customOptions, storedCustomKey));
			}

			// Layout
			if (optionsObj.layoutOptions) {

				if (!optionsObj.storageKeys || !optionsObj.storageKeys.layout) {
					service.updateLayout(optionsObj, null);

				} else {

					// Get from storage
					let storedLayoutKey = utilities.getFromStorage(optionsObj.storageKeys.layout);

					// Check if stored value exists in array
					service.updateLayout(optionsObj, utilities.getObjectFromArrayByKey(optionsObj.layoutOptions, storedLayoutKey));
				}
			}

			// Items per page
			if (optionsObj.itemsPerPageOptions.length) {

				if (!optionsObj.storageKeys || !optionsObj.storageKeys.itemsPerPage) {
					service.updateItemsPerPage(optionsObj, null);

				} else {

					// Get from storage
					let storedItemsPerPageKey = utilities.getFromStorage(optionsObj.storageKeys.itemsPerPage);

					// Check if stored value exists in array
					service.updateItemsPerPage(optionsObj, utilities.getObjectFromArrayByKey(optionsObj.itemsPerPageOptions, storedItemsPerPageKey));
				}
			}

			// Order By
			if (optionsObj.orderByOptions) {

				if (!optionsObj.storageKeys || !optionsObj.storageKeys.orderBy) {
					service.updateOrderBy(optionsObj, null);

				} else {

					// Get from storage
					let storedOrderByKey = utilities.getFromStorage(optionsObj.storageKeys.orderBy);

					// Check if stored value exists in array
					service.updateOrderBy(optionsObj, utilities.getObjectFromArrayByKey(optionsObj.orderByOptions, storedOrderByKey));
				}
			}
		},

		getHasSearchFilterAll: optionsObj => {

			for (const filterOption of optionsObj.search.filterOptions) {

				if (filterOption.id === 'all') {
					return true;
				}
            }

            return false;
		},

		loadDefaultSearchFilterOptions: optionsObj => {

			// Only applies if filter options are provided
			if (!angular.isUndefined(optionsObj.search.filterOptions)) {

				const hasSearchFilterAll = service.getHasSearchFilterAll(optionsObj);

				/**
				 * A search filter with { id: 'all' } will override the default one below
				 * A specific 'all' filterOption can be provided supplying a list of properties to search against, avoiding search the entire object and improving search performance
				**/
				if (!hasSearchFilterAll) {
					optionsObj.search.filterOptions.unshift({
						description: 'All',
						id: 'all'
					});
				}

				optionsObj.search.filterOption = service.getFilterOptionById(optionsObj);

				service.createSearchFilter(optionsObj);
			}
		},

		updateCustom: (optionsObj, customOptionObj) => {

			// If not provided default to first in array
			customOptionObj = customOptionObj ? customOptionObj : optionsObj.customOptions[0];

			optionsObj.custom = customOptionObj.key;
			optionsObj.customObj = customOptionObj;
		},

		updateItemsPerPage: (optionsObj, itemsPerPageObj) => {

			// If not provided default to first in array
			itemsPerPageObj = itemsPerPageObj ? itemsPerPageObj : optionsObj.itemsPerPageOptions[0];

			optionsObj.itemsPerPageOption = itemsPerPageObj;
			optionsObj.results.itemsPerPage = itemsPerPageObj.value;
		},

		updateLayout (optionsObj, layoutOptionObj) {

			// If not provided default to first in array
			layoutOptionObj = layoutOptionObj ? layoutOptionObj : optionsObj.layoutOptions[0];

			optionsObj.layout = layoutOptionObj.key;
			optionsObj.layoutObj = layoutOptionObj;
		},

		updateOrderBy: (optionsObj, orderByOptionObj) => {

			// If not provided default to first in array
			orderByOptionObj = orderByOptionObj ? orderByOptionObj : optionsObj.orderByOptions[0];

			optionsObj.orderBy = orderByOptionObj.field;
			optionsObj.orderByObj = orderByOptionObj;
			optionsObj.results.reverse = orderByOptionObj.reverse;
		}
	};

	const options = {
		accessFinancialsTenants: {
			id: 'access-financials-tenants',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search organisations...',
					singular: '1 organisation',
					noResults: '0 organisations',
					plural: '{} organisations'
				}
			}
		},
		admins: {
			id: 'admins',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search admins...',
					singular: '1 admin',
					plural: '{} admins'
				}
			},
			storageKeys: {
				orderBy: 'adminsOrderBy',
				reverse: 'adminsOrderReverse'
			}
		},
		apiReferences: {
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'name',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'library-asc',
					field: 'library',
					reverse: false,
					title: 'UI library A-Z'
				},
				{
					key: 'library-desc',
					field: 'library',
					reverse: true,
					title: 'UI library Z-A'
				},
				{
					key: 'project-asc',
					field: 'project',
					reverse: false,
					title: 'Project A-Z'
				},
				{
					key: 'project-desc',
					field: 'project',
					reverse: true,
					title: 'Project Z-A'
				},
				{
					key: 'reference-count-asc',
					field: 'referenceCount',
					reverse: false,
					title: 'Reference Count (asc)'
				},
				{
					key: 'reference-count-desc',
					field: 'referenceCount',
					reverse: true,
					title: 'Reference Count (desc)'
				}
			],
			search: {
				terms: {
					placeholder: 'Search API references...',
					singular: '1 API reference',
					plural: '{} API references'
				}
			},
			storageKeys: {
				orderBy: 'apiReferencessOrderBy',
				reverse: 'apiReferencesReverse'
			}
		},
		archivedTeamMembers: {
			id: 'archived-team-members',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search archived team members...',
					singular: '1 archived team member',
					plural: '{} archived team members'
				}
			},
			storageKeys: {
				layout: 'archivedTeamMembersLayout',
				orderBy: 'archivedTeamMembersOrderBy',
				reverse: 'archivedTeamMemebrsOrderReverse'
			}
		},
		bacsDownloads: {
			id: 'bacs-downloads',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'CompanyName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'CompanyName',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'payment-date-asc',
					field: 'PaymentDateISO',
					reverse: false,
					title: 'Payment date Asc'
				},
				{
					key: 'payment-date-desc',
					field: 'PaymentDateISO',
					reverse: true,
					title: 'Payment date Desc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search files...',
					singular: '1 file',
					plural: '{} files'
				}
			},
			storageKeys: {
				filterBy: 'bacsCompaniesFilterBy',
				orderBy: 'bacsCompaniesOrderBy',
				reverse: 'bacsCompaniesOrderByReverse'
			}
		},
		billing: {
			search: {
				terms: {
					placeholder: 'Search invoices...',
					singular: '1 invoice',
					plural: '{} invoices'
				}
			}
		},
		bureaus: {
			id: 'bureaus',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Z-A'
				},
				{
					key: 'company-count-desc',
					field: 'Company.CompanyCount',
					reverse: true,
					title: 'Companies Desc'
				},
				{
					key: 'company-count-asc',
					field: 'Company.CompanyCount',
					reverse: false,
					title: 'Companies Asc'
				}
			],
			results: {
				itemsPerPage: 100
			},
			search: {
				terms: {
					placeholder: 'Search bureaus...',
					singular: '1 bureau',
					plural: '{} bureaus'
				}
			},
			storageKeys: {
				layout: 'bureausLayout',
				orderBy: 'bureausOrderBy',
				reverse: 'bureausOrderReverse'
			}
		},
		bureausArchived: {
			id: 'bureaus-archived',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search bureaus...',
					singular: '1 bureau',
					plural: '{} bureaus'
				}
			},
			storageKeys: {
				layout: 'bureausArchivedLayout',
				orderBy: 'bureausArchivedOrderBy',
				reverse: 'bureausArchivedOrderByReverse'
			}
		},
		bureauWorkflowActivityLog: {
			id: 'bureau-workflow-activity-log',
			search: {
				terms: {
					placeholder: 'Search activity...',
					singular: '1 entry',
					plural: '{} entries'
				}
			}
		},
		bureauWorkflowTasks: {
			id: 'bureau-workflow-tasks',
			orderByOptions: [
				{
					key: 'due-date-asc',
					field: 'DueDateISO',
					reverse: false,
					title: 'Due date (old - new)'
				},
				{
					key: 'due-date-desc',
					field: 'DueDateISO',
					reverse: true,
					title: 'Due date (new - old)'
				}
			],
			search: {
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			storageKeys: {
				orderBy: 'bureauWorkflowOrderBy',
				reverse: 'bureauWorkflowOrderReverse'
			}
		},
		businessCategories: {
			id: 'business-categories',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'BusinessCodeNarrative',
					reverse: false,
					title: 'Name (A - Z)'
				},
				{
					key: 'name-desc',
					field: 'BusinessCodeNarrative',
					reverse: true,
					title: 'Name (Z - A)'
				}
			],
			search: {
				terms: {
					placeholder: 'Search categories...',
					singular: '1 category',
					plural: '{} categories'
				}
			}
		},
		changesTable: {
			id: 'changes-table',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID Desc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				orderBy: 'changesTableTeamOrderBy',
				reverse: 'changesTableTeamOrderReverse'
			}
		},
		companies: {
			id: 'companies',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'payment-date-asc',
					field: 'PayPeriod.payDateUnix',
					reverse: false,
					title: 'Payment date Asc'
				},
				{
					key: 'payment-date-desc',
					field: 'PayPeriod.payDateUnix',
					reverse: true,
					title: 'Payment date Desc'
				},
				{
					key: 'team-count-asc',
					field: 'Company.TeamMemberCount',
					reverse: false,
					title: 'Team count Asc'
				},
				{
					key: 'team-count-desc',
					field: 'Company.TeamMemberCount',
					reverse: true,
					title: 'Team count Desc'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'Company.Name',
							'Company.ClientReference',
							'Company.PAYERef'
						],
						id: 'all',
					},
					{
						description: 'Name',
						filterKeys: [
							'Company.Name'
						],
						id: 'name',
					},
					{
						description: 'Client reference',
						filterKeys: [
							'Company.ClientReference'
						],
						id: 'client-reference'
					},
					{
						description: 'PAYE reference',
						filterKeys: [
							'Company.PAYERef'
						],
						id: 'paye-reference'
					}
				],
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			storageKeys: {
				itemsPerPage: 'companiesItemsPerPage',
				layout: 'companiesLayout',
				orderBy: 'companiesOrderBy',
				reverse: 'companiesOrderByReverse'
			}
		},
		companiesArchived: {
			id: 'companies-archived',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			storageKeys: {
				itemsPerPage: 'companiesArchivedItemsPerPage',
				layout: 'companiesArchivedLayout',
				orderBy: 'companiesArchivedOrderBy',
				reverse: 'companiesArchivedOrderByReverse'
			}
		},
		companyGroups: {
			id: 'search-company-groups',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Z-A'
				},
				{
					key: 'company-count-desc',
					field: 'Company.CompanyCount',
					reverse: true,
					title: 'Companies Desc'
				},
				{
					key: 'company-count-asc',
					field: 'Company.CompanyCount',
					reverse: false,
					title: 'Companies Asc'
				}
			],
			results: {
				itemsPerPage: 100
			},
			search: {
				terms: {
					placeholder: 'Search company groups...',
					singular: '1 company group',
					plural: '{} company groups'
				}
			},
			storageKeys: {
				layout: 'companyGroupsLayout',
				orderBy: 'companyGroupsOrderBy',
				reverse: 'companyGroupsOrderReverse'
			}
		},
		currentPeriod: {
			id: 'current-period',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'PersonalDetails.Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'PersonalDetails.Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'PersonalDetails.Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'PersonalDetails.Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PersonalDetails.PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PersonalDetails.PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID Desc'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'PersonalDetails.Forename',
							'PersonalDetails.Fullname',
							'PersonalDetails.HMRCID',
							'PersonalDetails.NINumber',
							'PersonalDetails.PayrollID',
							'PersonalDetails.PolicyGradeName',
							'PersonalDetails.Surname',
							'PersonalDetails.UserID',
							'PersonalDetails.UTR'
						],
						id: 'all',
					},
					{
						description: 'Name',
						filterKeys: [
							'PersonalDetails.Fullname'
						],
						id: 'fullname',
					},
					{
						description: 'Payroll ID',
						filterKeys: [
							'PersonalDetails.PayrollID'
						],
						id: 'payrollid',
						isExactMatch: true
					},
					{
						description: 'HMRC ID',
						filterKeys: [
							'PersonalDetails.HMRCID'
						],
						id: 'hmrcId',
						isExactMatch: true
					},
					{
						description: 'NI Number',
						filterKeys: [
							'PersonalDetails.NINumber'
						],
						id: 'ninumber',
					},
					{
						description: 'UTR',
						filterKeys: [
							'PersonalDetails.UTR'
						],
						id: 'utr',
					},
					{
						description: 'Job Grade',
						filterKeys: [
							'PersonalDetails.PolicyGradeName'
						],
						id: 'jobGrade',
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				itemsPerPage: 'payrollItemsPerPage',
				layout: 'payrollLayout',
				orderBy: 'payrollOrderBy',
				reverse: 'payrollOrderReverse'
			}
		},
		currentPeriodChanges: {
			id: 'current-period-changes',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'UserForename',
					reverse: false,
					title: 'Forename A-Z'
				},
				{
					key: 'forename-desc',
					field: 'UserForename',
					reverse: true,
					title: 'Forename Z-A'
				},
				{
					key: 'surname-asc',
					field: 'UserSurname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'UserSurname',
					reverse: true,
					title: 'Surname Z-A'
				},
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				filterOptions: [
					{
						description: 'Name',
						filterKeys: ['UserFullname'],
						id: 'fullname',
					},
					{
						description: 'Payroll ID',
						filterKeys: ['ID'],
						id: 'payrollid',
						isExactMatch: true
					},
					{
						description: 'HMRC ID',
						filterKeys: ['HMRCID'],
						id: 'hmrcid',
						isExactMatch: true
					},
					{
						description: 'NI Number',
						filterKeys: ['NINumber'],
						id: 'ninumber',
					},
					{
						description: 'UTR',
						filterKeys: ['UTR'],
						id: 'utr',
					},
					{
						description: 'Job Grade',
						filterKeys: ['PolicyGradeName'],
						id: 'jobGrade',
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			actions: [
				{
					// disabled + tooltipText are set at runtime (refresh-in-progress state + last-updated timestamp)
					icon: 'icon-loading',
					label: 'Refresh changes',
					key: SEARCH_BAR_ACTIONS.currentPeriodChanges.refresh,
					theme: 'is-white'
				}
			],
			storageKeys: {
				itemsPerPage: 'currentPeriodChangesPerPage',
				orderBy: 'currentPeriodChangesOrderBy',
				reverse: 'currentPeriodChangesOrderReverse'
			}
		},
		currentPeriodImports: {
			id: 'current-period-imports',
			orderByOptions: [
				{
					key: 'imported-date-desc',
					field: 'importedDateUnix',
					reverse: true,
					title: 'New-old'
				},
				{
					key: 'imported-date-asc',
					field: 'importedDateUnix',
					reverse: false,
					title: 'Old-new'
				},
				{
					key: 'imported-status',
					field: 'Undone',
					reverse: false,
					title: 'Status'
				},
				{
					key: 'filename-asc',
					field: 'ImportedFileName',
					reverse: false,
					title: 'Filename A-Z'
				},
				{
					key: 'filename-desc',
					field: 'ImportedFileName',
					reverse: true,
					title: 'Filename Z-A'
				},
				{
					key: 'imported-by-asc',
					field: 'ImportedBy',
					reverse: false,
					title: 'Imported by A-Z'
				},
				{
					key: 'imported-by-desc',
					field: 'ImportedBy',
					reverse: true,
					title: 'Imported by Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search imports...',
					singular: '1 import',
					plural: '{} imports'
				}
			}
		},
		currentPeriodTaxUpdates: {
			id: 'current-period-tax-updates',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'PersonalDetails.Forename',
					reverse: false,
					title: 'First name A-Z'
				}
			],
			search: {
				terms: {
					placeholder: 'Search tax updates...',
					singular: '1 tax update',
					plural: '{} tax updates'
				}
			}
		},
		customerCodes: {
			id: 'customer-codes',
			orderByOptions: [
				{
					key: 'companyname-asc',
					field: 'CompanyName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'companyname-desc',
					field: 'CompanyName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			results: {
				itemsPerPage: 12
			},
			search: {
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			actions: [
				{
					label: 'Edit codes',
					key: SEARCH_BAR_ACTIONS.customerCodes.editCustomerCode,
					theme: 'is-primary',
				}
			],
			storageKeys: {
				filterBy: 'customerCodesFilterBy',
				itemsPerPage: 'customerCodesItemsPerPage',
				orderBy: 'customerCodesOrderBy',
				reverse: 'customerCodesReverse'
			}
		},
		customerCodesForm: {
			id: 'customer-codes-form',
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			}
		},
		disbursements: {
			id: 'disbursements',
			results: {
				itemsPerPage: 12
			},
			search: {
				terms: {
					placeholder: 'Search disbursements...',
					singular: '1 disbursement',
					plural: '{} disbursements'
				}
			}
		},

		documents: {
			id: 'documents',
			orderByOptions: [
				{
					key: 'createdDate-asc',
					field: 'createdDateISOUnix',
					reverse: true,
					title: 'New-old'
				},
				{
					key: 'createdDate-desc',
					field: 'createdDateISOUnix',
					reverse: false,
					title: 'Old-New'
				},
				{
					key: 'document-name-asc',
					field: 'DocumentName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'document-name-desc',
					field: 'DocumentName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search documents...',
					singular: '1 document',
					plural: '{} documents'
				}
			},
			storageKeys: {
				orderBy: 'documentsOrderBy',
				reverse: 'documentsOrderReverse'
			}
		},
		emailContactsAdmins: {
			id: 'email-contacts-admins',
			search: {
				hide: true,
				terms: {
					singular: '1 admin',
					plural: '{} admins'
				}
			}
		},
		emailContactsExternal: {
			id: 'email-contacts-external',
			search: {
				hide: true,
				terms: {
					singular: '1 external recipient',
					plural: '{} external recipients'
				}
			}
		},
		emailTriggers: {
			id: 'email-triggers',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'MailTypeDescription',
					reverse: false,
					title: 'Name Asc'
				},
				{
					key: 'name-desc',
					field: 'MailTypeDescription',
					reverse: true,
					title: 'Name Desc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search email triggers...',
					singular: '1 email trigger',
					plural: '{} email triggers'
				}
			},
			results: {
				itemsPerPage: 50
			}
		},
		futureChanges: {
			id: 'future-changes',
			orderByOptions: [
				{
					key: 'date-asc',
					field: 'startDateUnix',
					reverse: false,
					title: 'Date Asc'
				},
				{
					key: 'date-desc',
					field: 'startDateUnix',
					reverse: true,
					title: 'Date Desc'
				},
				{
					key: 'forename-asc',
					field: 'UserForename',
					reverse: false,
					title: 'Forename A-Z'
				},
				{
					key: 'forename-desc',
					field: 'UserForename',
					reverse: true,
					title: 'Forename Z-A'
				},
				{
					key: 'surname-asc',
					field: 'UserSurname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'UserSurname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'total-asc',
					field: 'Value',
					reverse: false,
					title: 'Total Asc'
				},
				{
					key: 'total-desc',
					field: 'Value',
					reverse: true,
					title: 'Total Desc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search future changes...',
					singular: '1 future change',
					plural: '{} future changes'
				}
			},
			storageKeys: {
				orderBy: 'futureChangesOrderBy',
				reverse: 'futureChangesOrderReverse'
			}
		},
		averageHolidayPay: {
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					noResults: 'No pay elements',
					placeholder: 'Search pay elements...',
					singular: '1 pay element',
					plural: '{} pay elements'
				}
			},
			storageKeys: {
				filterBy: 'averageHolidayPayFilterBy',
				itemsPerPage: 'averageHolidayPayPerPage',
				layout: 'averageHolidayPayLayout',
				orderBy: 'averageHolidayPayOrderBy',
				reverse: 'averageHolidayPayOrderReverse'
			}
		},
		companyPayElementOverrides: {
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'CompanyName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'CompanyName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				// This search is scoped to a single push-down run - never persist it across drawer
				// opens or bleed into/from the underlying list's own (differently-scoped) search.
				disablePersistedSearch: true,
				terms: {
					noResults: 'No companies',
					placeholder: 'Search...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			results: {
				// Small default so pagination is actually exercised for the company counts this
				// step typically deals with, rather than defaulting to the site-wide 15.
				itemsPerPage: 4
			},
			storageKeys: {
				filterBy: 'companyPayElementOverridesFilterBy',
				itemsPerPage: 'companyPayElementOverridesPerPage',
				layout: 'companyPayElementOverridesLayout',
				orderBy: 'companyPayElementOverridesOrderBy',
				reverse: 'companyPayElementOverridesOrderReverse'
			}
		},
		genderPayGap: {
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'GenderPayGapReportName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'GenderPayGapReportName',
					reverse: true,
					title: 'Name Z-A'
				},
			],
			search: {
				terms: {
					placeholder: 'Search reports...',
					singular: '1 report',
					plural: '{} reports'
				}
			},
			storageKeys: {
				filterBy: 'genderPayGapFilterBy',
				itemsPerPage: 'genderPayGapPerPage',
				layout: 'genderPayGapLayout',
				orderBy: 'genderPayGapOrderBy',
				reverse: 'genderPayGapOrderReverse'
			}
		},
		history: {
			id: 'history',
			orderByOptions: [
				{
					key: 'pay-period-desc',
					field: 'PayDateISO',
					reverse: true,
					title: 'New to old'
				},
				{
					key: 'pay-period-asc',
					field: 'PayDateISO',
					reverse: false,
					title: 'Old to new'
				}
			],
			results: {
				itemsPerPage: 12
			},
			search: {
				terms: {
					placeholder: 'Search pay periods...',
					singular: '1 pay period',
					plural: '{} pay periods'
				}
			},
			storageKeys: {
				orderBy: 'payPeriodOrderBy',
				reverse: 'payPeriodOrderReverse'
			}
		},
		hourlyTotals: {
			id: 'hourly-totals',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID desc'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				filterBy: 'hourlyTotalsFilterBy',
				itemsPerPage: 'hourlyItemsPerPage',
				layout: 'hourlyTotalsLayout',
				orderBy: 'hourlyTotalsOrderBy',
				reverse: 'hourlyTotalsOrderReverse'
			}
		},
		importMappings: {
			id: 'import-mappings',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search templates...',
					singular: '1 template',
					plural: '{} templates'
				}
			},
			storageKeys: {
				orderBy: 'importMappingOrderBy',
				reverse: 'importMappingReverse'
			}
		},
		jobGrades: {
			id: 'job-grades',
			actions: [
				{
					icon: 'icon-plus',
					label: 'Add job grade',
					key: SEARCH_BAR_ACTIONS.jobGrades.addJobGrade,
					theme: 'is-primary',
					requiredPermissions: ['HR.canManageJobGrades']
				}
			],
			orderByOptions: [
				{
					key: 'job-grades-name-asc',
					field: 'PolicyGradeName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'job-grades-name-desc',
					field: 'PolicyGradeName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search job grades...',
					singular: '1 job grade',
					plural: '{} job grades'
				}
			},
			storageKeys: {
				orderBy: 'jobGradesOrderBy',
				reverse: 'jobGradesReverse'
			}
		},
		jobGradeTeamMembers: {
			id: 'job-grade-team-members',
			orderByOptions: [
				{
					key: 'job-grade-team-members-first-name-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'job-grade-team-members-first-name-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'job-grade-team-members-surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'job-grade-team-members-surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search team members...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				orderBy: 'jobGradeTeamMembersOrderBy',
				reverse: 'jobGradeTeamMembersReverse'
			}
		},
		journalImports: {
			id: 'journals-imports',
			orderByOptions: [
				{
					key: 'imported-date-desc',
					field: 'importedDateUnix',
					reverse: true,
					title: 'New-old'
				},
				{
					key: 'imported-date-asc',
					field: 'importedDateUnix',
					reverse: false,
					title: 'Old-new'
				},
				{
					key: 'imported-status',
					field: 'Undone',
					reverse: false,
					title: 'Status'
				},
				{
					key: 'filename-asc',
					field: 'ImportedFileName',
					reverse: false,
					title: 'Filename A-Z'
				},
				{
					key: 'filename-desc',
					field: 'ImportedFileName',
					reverse: true,
					title: 'Filename Z-A'
				},
				{
					key: 'imported-by-asc',
					field: 'ImportedBy',
					reverse: false,
					title: 'Imported by A-Z'
				},
				{
					key: 'imported-by-desc',
					field: 'ImportedBy',
					reverse: true,
					title: 'Imported by Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search imports...',
					singular: '1 import',
					plural: '{} imports'
				}
			}
		},
		journalPosts: {
			id: 'journal-posts',
			search: {
				terms: {
					placeholder: 'Search pay runs...',
					singular: '1 pay run',
					plural: '{} pay runs'
				}
			},
			orderByOptions: [
				{
					key: 'post-date-desc',
					field: 'journalPostActionDateUnix',
					reverse: true,
					title: 'Post date (New-old)'
				},
				{
					key: 'post-date-asc',
					field: 'journalPostActionDateUnix',
					reverse: false,
					title: 'Post date (Old-new)'
				},
				{
					key: 'run-date-desc',
					field: 'journalPostRunDateUnix',
					reverse: true,
					title: 'Run date (New-old)'
				},
				{
					key: 'run-date-asc',
					field: 'journalPostRunDateUnix',
					reverse: false,
					title: 'Run date (Old-new)'
				}
			]
		},
		leavers: {
			id: 'leavers',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'IDNumeric',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'IDNumeric',
					reverse: true,
					title: 'Payroll ID Desc'
				},
				{
					key: 'leave-date-asc',
					field: 'leaveDateUnix',
					reverse: false,
					title: 'Leave date Asc'
				},
				{
					key: 'leave-date-desc',
					field: 'leaveDateUnix',
					reverse: true,
					title: 'Leave date Desc'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				terms: {
					placeholder: 'Search leavers...',
					singular: '1 leaver',
					plural: '{} leavers'
				}
			},
			storageKeys: {
				itemsPerPage: 'leaverItemsPerPage',
				layout: 'leaverLayout',
				orderBy: 'leaverOrderBy',
				reverse: 'leaverOrderReverse'
			}
		},
		linkElements: {
			id: 'link-elements',
			search: {
				terms: {
					placeholder: 'Search link elements...',
					singular: '1 link element',
					plural: '{} link elements'
				}
			},
		},
		linkRates: {
			id: 'link-rates',
			search: {
				terms: {
					placeholder: 'Search link rates...',
					singular: '1 link rate',
					plural: '{} link rates'
				}
			},
		},
		managePayElementPacks: {
			id: 'manage-pay-element-packs',
			search: {
				hide: true,
				terms: {
					singular: '1 element enabled',
					plural: '{} elements enabled'
				}
			}
		},
		managePayElements: {
			id: 'manage-pay-elements',
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search pay elements...',
					singular: '1 pay element',
					plural: '{} pay elements'
				}
			},
			storageKeys: {
				itemsPerPage: 'managePayElementsItemsPerPage',
				layout: 'managePayElementsLayout',
				orderBy: 'managePayElementsOrderBy',
				reverse: 'managePayElementsOrderReverse'
			}
		},
		rotareadyLinkedSites: {
			id: 'rotaready-linked-sites',
			search: {
				disablePersistedSearch: true,
				terms: {
					noResults: 'No sites',
					placeholder: 'Search sites...',
					singular: '1 site',
					plural: '{} sites'
				}
			}
		},
		nominalCodes: {
			id: 'nominal-codes',
			search: {
				terms: {
					placeholder: 'Search nominal codes...',
					singular: '1 code',
					plural: '{} codes'
				}
			}
		},
		notes: {
			id: 'notes',
			orderByOptions: [
				{
					key: 'new-old',
					field: 'DateSentISO',
					reverse: true,
					title: 'New - Old'
				},
				{
					key: 'old-new',
					field: 'DateSentISO',
					reverse: false,
					title: 'Old - New'
				}
			],
			search: {
				terms: {
					placeholder: 'Search notes...',
					singular: '1 note',
					plural: '{} notes'
				}
			},
			storageKeys: {
				orderBy: 'notesOrderBy'
			}
		},
		onboarding: {
			id: 'onboarding',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'Name',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'Name',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'newest-companies',
					field: 'CreatedDateISO',
					reverse: true,
					title: 'Company New-Old'
				},
				{
					key: 'oldest-companies',
					field: 'CreatedDateISO',
					reverse: false,
					title: 'Company Old-New'
				},
				{
					key: 'company-type',
					field: 'State',
					reverse: true,
					title: 'Company Type'
				},
				{
					key: 'days-to-expiry',
					field: 'DaysToExpiry',
					reverse: true,
					title: 'Days to expiry'
				},
				{
					key: 'period-type',
					field: 'PeriodType',
					reverse: true,
					title: 'Period type'
				}
			],
			search: {
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			storageKeys: {
				layout: 'companiesOnboardingLayout',
				orderBy: 'companiesOnboardingOrderBy',
				reverse: 'companiesOnboardingOrderByReverse'
			}
		},
		payElementsAdditions: {
			id: 'pay-elements-additions',
			search: {
				terms: {
					placeholder: 'Search additions...',
					singular: '1 addition',
					plural: '{} additions'
				}
			}
		},
		payElementsBIK: {
			id: 'pay-elements-bik',
			search: {
				terms: {
					placeholder: 'Search elements...',
					singular: '1 element',
					plural: '{} elements'
				}
			}
		},
		payElementsDeductions: {
			id: 'pay-elements-deductions',
			search: {
				terms: {
					placeholder: 'Search deductions...',
					singular: '1 deduction',
					plural: '{} deductions'
				}
			}
		},
		payrollAlerts: {
			id: 'payroll-alerts',
			search: {
				terms: {
					placeholder: 'Search alerts...',
					singular: '1 alert',
					plural: '{} alerts'
				}
			}
		},
		payrollDepartments: {
			id: 'payroll-departments',
			orderByOptions: [
				{
					key: 'department-name-asc',
					field: 'AgencyDepartmentName',
					reverse: false,
					title: 'Name (A-Z)'
				},
				{
					key: 'department-name-desc',
					field: 'AgencyDepartmentName',
					reverse: true,
					title: 'Name (Z-A)'
				},
				{
					key: 'department-team-count-desc',
					field: 'DepartmentMemberCount',
					reverse: true,
					title: 'Team member count Desc'
				},
				{
					key: 'department-team-count-asc',
					field: 'DepartmentMemberCount',
					reverse: false,
					title: 'Team member count Asc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search payroll departments...',
					singular: '1 payroll department',
					plural: '{} payroll departments'
				}
			},
			storageKeys: {
				orderBy: 'payrollDepartmentsOrderBy',
				reverse: 'payrollDepartmentsOrderReverse'
			}
		},
		payslipLabels: {
			id: 'payslip-labels',
			orderByOptions: [
				{
					key: 'label-name-asc',
					field: 'AgencyAdjustmentLabelText',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'label-name-desc',
					field: 'AgencyAdjustmentLabelText',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'created-date-asc',
					field: 'createdDateUnix',
					reverse: false,
					title: 'Created date Asc'
				},
				{
					key: 'created-date-desc',
					field: 'createdDateUnix',
					reverse: true,
					title: 'Created date Desc'
				},
				{
					key: 'element-type-asc',
					field: 'AdjustmentText',
					reverse: false,
					title: 'Element Type A-Z'
				},
				{
					key: 'element-type-desc',
					field: 'AdjustmentText',
					reverse: true,
					title: 'Element Type Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search payslip labels...',
					singular: '1 payslip label',
					plural: '{} payslip labels'
				}
			}
		},
		payslipManager: {
			id: 'payslip-manager',
			orderByOptions: [
				{
					key: 'pay-period-desc',
					field: 'PayDateISO',
					reverse: true,
					title: 'New to old'
				},
				{
					key: 'pay-period-asc',
					field: 'PayDateISO',
					reverse: false,
					title: 'Old to new'
				}
			],
			results: {
				itemsPerPage: 12
			},
			search: {
				terms: {
					placeholder: 'Search pay periods...',
					singular: '1 pay period',
					plural: '{} pay periods'
				}
			},
			storageKeys: {
				orderBy: 'payslipManagerOrderBy',
				reverse: 'payslipManagerOrderReverse'
			}
		},
		peopleHrUpdates: {
			id:'people-hr-updates',
			orderByOptions: [
				{
					key: 'people-hr-updates-events-received-date-asc',
					field: 'receivedTimeISOUnix',
					reverse: false,
					title: 'Date received Asc'
				},
				{
					key: 'people-hr-updates-events-received-date-desc',
					field: 'receivedTimeISOUnix',
					reverse: true,
					title: 'Date received Desc'
				},
				{
					key: 'people-hr-updates-events-person-forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'people-hr-updates-events-person-forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'people-hr-updates-events-surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'people-hr-updates-events-surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: ['teamMemberFullname', 'EmployeeID', 'EdpEventSubject', 'EdpEventType'],
						id: 'all',
					},
					{
						description: 'Name',
						filterKeys: ['teamMemberFullname'],
						id: 'teamMemberFullname',
					},
					{
						description: 'Employee ID',
						filterKeys: ['EmployeeID'],
						id: 'employeeid',
					}
				],
				terms: {
					placeholder: 'Search updates',
					singular: '1 event',
					plural: '{} events'
				}
			},
			storageKeys: {
				itemsPerPage: 'people-hr-updates-events-items-per-page',
				orderBy: 'people-hr-updates-events-order-by',
				reverse: 'people-hr-updates-events-reverse'
			},
			results: {
				canChangeItemsPerPage: true
			},
		},
		rotareadyUpdates: {
			id: 'rotaready-updates',
			orderByOptions: [
				{
					key: 'rotaready-updates-events-received-date-asc',
					field: 'receivedTimeISOUnix',
					reverse: false,
					title: 'Date received Asc'
				},
				{
					key: 'rotaready-updates-events-received-date-desc',
					field: 'receivedTimeISOUnix',
					reverse: true,
					title: 'Date received Desc'
				},
				{
					key: 'rotaready-updates-events-name-asc',
					field: 'TargetName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'rotaready-updates-events-name-desc',
					field: 'TargetName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: ['TargetName', 'MessageText'],
						id: 'all'
					}
				],
				terms: {
					placeholder: 'Search by name or message',
					singular: '1 event',
					plural: '{} events'
				}
			},
			storageKeys: {
				itemsPerPage: 'rotaready-updates-events-items-per-page',
				orderBy: 'rotaready-updates-events-order-by',
				reverse: 'rotaready-updates-events-reverse'
			},
			results: {
				canChangeItemsPerPage: true
			},
		},
		pensionCommunications: {
			id: 'pension-communications',
			customOptions: [
				{
					key: 'sent',
					title: 'Sent'
				},
				{
					key: 'received',
					title: 'Received'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				custom: 'commsCustom',
				orderBy: 'commsOrderBy',
				type: 'commsType'
			}
		},
		pensionHistory: {
			id: 'pension-history',
			orderByOptions: [
				{
					key: 'history-date-asc',
					field: 'DateISO',
					reverse: true,
					title: 'New-old'
				},
				{
					key: 'history-date-desc',
					field: 'DateISO',
					reverse: false,
					title: 'Old-new'
				}
			],
			search: {
				terms: {
					placeholder: 'Search history...',
					singular: '1 entry',
					plural: '{} entries'
				}
			},
			storageKeys: {
				orderBy: 'pensionHistoryOrderBy',
			}
		},
		pensionTeam: {
			id: 'pension-team',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID Desc'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				filterOptions: [
					{
						description: 'Name',
						filterKeys: ['Fullname'],
						id: 'fullname',
					},
					{
						description: 'Payroll ID',
						filterKeys: ['ID'],
						id: 'payrollid',
						isExactMatch: true
					},
					{
						description: 'HMRC ID',
						filterKeys: ['HMRCID'],
						id: 'hmrcId',
						isExactMatch: true
					},
					{
						description: 'NI Number',
						filterKeys: ['NINumber'],
						id: 'ninumber',
					},
					{
						description: 'UTR',
						filterKeys: ['UTR'],
						id: 'utr',
					},
					{
						description: 'Job Grade',
						filterKeys: ['PolicyGradeName'],
						id: 'jobGrade',
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				itemsPerPage: 'pensionTeamItemsPerPage',
				layout: 'pensionTeamLayout',
				orderBy: 'pensionTeamOrderBy'
			}
		},
		policies: {
			id: 'policies',
			search: {
				terms: {
					placeholder: 'Search policies...',
					singular: '1 policy',
					plural: '{} policies',
					noResults: '0 policies'
				}
			},
			actions: [
				{
					icon: 'icon-plus',
					label: 'Add policy',
					key: SEARCH_BAR_ACTIONS.policies.addPolicy,
					theme: 'is-primary',
                    requiredPermissions: ['HR.canManagePolicies']
				}
			],
			orderByOptions: [
				{
					key: 'policy-name-asc',
					field: 'PolicyName',
					reverse: false,
					title: 'Name (A-Z)'
				},
				{
					key: 'policy-name-desc',
					field: 'PolicyName',
					reverse: true,
					title: 'Name (Z-A)'
				}
			]
		},
		policyPensionSchemes: {
			id: 'policy-pension-scheme',
			orderByOptions: [
				{
					key: 'pension-provider-asc',
					field: 'PensionProviderName',
					reverse: false,
					title: 'Provider A-Z'
				},
				{
					key: 'pension-provider-desc',
					field: 'PensionProviderName',
					reverse: true,
					title: 'Provider Z-A'
				},
				{
					key: 'pension-name-asc',
					field: 'PensionName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'pension-name-desc',
					field: 'PensionName',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'er-reference-asc',
					field: 'EmployerReference',
					reverse: false,
					title: 'Employer ref A-Z'
				},
				{
					key: 'er-reference-desc',
					field: 'EmployerReference',
					reverse: true,
					title: 'Employer ref Z-A'
				},
			],
			search: {
				terms: {
					placeholder: 'Search pension schemes...',
					singular: '1 pension scheme',
					plural: '{} pension schemes'
				}
			}
		},
		policyTeamMembers: {
			id: 'policy-team-members',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search team members...',
					singular: '1 team member',
					plural: '{} team members'
				}
			}
		},
		profileDocuments: {
			id: 'profile-documents',
			search: {
				terms: {
					placeholder: 'Search documents...',
					singular: '1 document',
					plural: '{} documents'
				}
			}
		},
		profileHistory: {
			id: 'profile-history',
			orderByOptions: [
				{
					key: 'history-date-asc',
					field: 'DateISO',
					reverse: true,
					title: 'New-old'
				},
				{
					key: 'history-date-desc',
					field: 'DateISO',
					reverse: false,
					title: 'Old-new'
				}
			],
			search: {
				terms: {
					placeholder: 'Search history...',
					singular: '1 entry',
					plural: '{} entries'
				}
			},
			storageKeys: {
				orderBy: 'profileHistoryOrderBy',
			}
		},
		profileHoliday: {
			id: 'profile-holiday',
			layoutOptions: [
				{
					key: 'rows',
					title: 'Rows'
				},
				{
					key: 'cards',
					title: 'Cards'
				}
			],
			orderByOptions: [
				{
					key: 'from-date-desc',
					field: 'HolidayDateFromISO',
					reverse: true,
					title: 'Date Desc'
				},
				{
					key: 'from-date-asc',
					field: 'HolidayDateFromISO',
					reverse: false,
					title: 'Date Asc'
				},
				{
					key: 'length-asc',
					field: 'HolidayDays',
					reverse: false,
					title: 'Length Asc'
				},
				{
					key: 'length-desc',
					field: 'HolidayDays',
					reverse: true,
					title: 'Length Desc'
				},
				{
					key: 'type',
					field: 'HolidayType',
					reverse: false,
					title: 'Type'
				},
			],
			search: {
				hide: true,
				terms: {
					placeholder: 'Search holiday...',
					singular: '1 holiday entry',
					plural: '{} holiday entries'
				}
			},
			storageKeys: {
				layout: 'profileHolidayLayout',
				orderBy: 'profileHolidayOrderBy',
				reverse: 'profileHolidayOrderReverse'
			}
		},
		profilePayments: {
			id: 'profile-payments',
			orderByOptions: [
				{
					key: 'payment-date-desc',
					field: 'userPaymentDateDisplayUnix',
					reverse: true,
					title: 'Payment date Desc'
				},
				{
					key: 'payment-date-asc',
					field: 'userPaymentDateDisplayUnix',
					reverse: false,
					title: 'Payment date Asc'
				}
			],
			search: {
				hide: true,
				terms: {
					placeholder: 'Search payments...',
					singular: '1 payment',
					plural: '{} payments'
				}
			},
			storageKeys: {
				orderBy: 'profilePaymentsOrderBy',
				reverse: 'profilePaymentsOrderReverse'
			}
		},
		profileSickness: {
			id: 'profile-sickness',
			layoutOptions: [
				{
					key: 'rows',
					title: 'Rows'
				},
				{
					key: 'cards',
					title: 'Cards'
				}
			],
			orderByOptions: [
				{
					key: 'from-date-desc',
					field: 'SicknessDateFromISO',
					reverse: true,
					title: 'Date Desc'
				},
				{
					key: 'from-date-asc',
					field: 'SicknessDateFromISO',
					reverse: false,
					title: 'Date Asc'
				},
				{
					key: 'length-asc',
					field: 'SicknessDays',
					reverse: false,
					title: 'Length Asc'
				},
				{
					key: 'length-desc',
					field: 'SicknessDays',
					reverse: true,
					title: 'Length Desc'
				},
				{
					key: 'type',
					field: 'SicknessType',
					reverse: false,
					title: 'Type'
				},
			],
			search: {
				hide: true
			},
			storageKeys: {
				layout: 'profileSicknessLayout',
				orderBy: 'profileSicknessOrderBy',
				reverse: 'profileSicknessOrderReverse'
			}
		},
		remoteLocations: {
			id: 'remote-locations',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
			],
			search: {
				terms: {
					placeholder: 'Search admins...',
					singular: '1 admin',
					plural: '{} admins'
				}
			},
			storageKeys: {
				layout: 'remoteLocationsLayout',
				orderBy: 'remoteLocationsOrderBy',
				reverse: 'remoteLocationsOrderReverse'
			}
		},
		reports: {
			id: 'reports',
			search: {
				terms: {
					placeholder: 'Search reports...',
					singular: '1 report',
					plural: '{} reports'
				}
			}
		},
		reportViewer: {
			id: 'report-viewer',
			search: {
				terms: {
					placeholder: 'Search results...',
					singular: '1 result',
					plural: '{} results'
				}
			}
		},
		reportTemplates: {
			id: 'report-templates',
			search: {
				disablePersistedSearch : true,
				terms: {
					placeholder: 'Search templates...',
					singular: '1 template',
					plural: '{} templates',
					noResults: '0 templates'
				}
			},
			actions: [
				{
					icon: 'icon-plus',
					label: 'New template',
					key: SEARCH_BAR_ACTIONS.reportTemplates.addNewTemplate,
					theme: 'is-primary'
				}
			]
		},
		reportSettings: {
			id: 'report-settings',
			search: {
				terms: {
					placeholder: 'Search reports...',
					singular: '1 report',
					plural: '{} reports'
				}
			},
			orderByOptions: [
				{
					key: 'report-creation-date-desc',
					field: 'ReportCreationDateISO',
					reverse: true,
					title: 'Date created (new-old)'
				},
				{
					key: 'report-creation-date-asc',
					field: 'ReportCreationDateISO',
					reverse: false,
					title: 'Date created (old-new)'
				}
			],
			storageKeys: {
				orderBy: 'reportSettingsOrderBy',
				reverse: 'reportSettingsOrderReverse'
			}
		},
		schedules: {
			id: 'schedules',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'description',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'description',
					reverse: true,
					title: 'Name Z-A'
				},
				{
					key: 'startdate-asc',
					field: 'StartDateISO',
					reverse: false,
					title: 'Start Date (asc)'
				},
				{
					key: 'startdate-desc',
					field: 'StartDateISO',
					reverse: true,
					title: 'Start Date (desc)'
				},
				{
					key: 'enddate-asc',
					field: 'EndDateISO',
					reverse: false,
					title: 'End Date (asc)'
				},
				{
					key: 'enddate-desc',
					field: 'EndDateISO',
					reverse: true,
					title: 'End Date (desc)'
				},
				{
					key: 'status-asc',
					field: 'status',
					reverse: false,
					title: 'Status'
				},
				{
					key: 'status-desc',
					field: 'status',
					reverse: true,
					title: 'Status (desc)'
				}
			],
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search schedules...',
					singular: '1 schedule',
					plural: '{} schedules'
				}
			},
			storageKeys: {
				orderBy: 'schedulesOrderBy',
				reverse: 'schedulesOrderReverse'
			}
		},
		supplementaryPayRuns: {
			id: 'supplementary-pay-runs',
			search: {
				terms: {
					placeholder: 'Search pay runs...',
					singular: '1 pay run',
					plural: '{} pay runs'
				}
			},
			orderByOptions: [
				{
					key: 'supplementary-payments-last-updated-desc',
					field: 'supplementaryPaymentLastUpdatedDateUnix',
					reverse: true,
					title: 'New to old'
				},
				{
					key: 'supplementary-payments-last-updated-asc',
					field: 'supplementaryPaymentLastUpdatedDateUnix',
					reverse: false,
					title: 'Old to new'
				},
				{
					key: 'supplementary-payments-pay-date-desc',
					field: 'supplementaryPaymentPayDateUnix',
					reverse: true,
					title: 'Payment date (desc)'
				},
				{
					key: 'supplementary-payments-pay-date-asc',
					field: 'supplementaryPaymentPayDateUnix',
					reverse: false,
					title: 'Payment date (asc)'
				}
			]
		},
		tasks: {
			id: 'tasks',
			search: {
				terms: {
					placeholder: 'Search tasks...',
					singular: '1 task',
					plural: '{} tasks'
				}
			},
			storageKeys: {
				reverse: 'tasksOrderReverse'
			}
		},
		taxUpdates: {
			orderByOptions: [
				{
					key: 'effective-date-desc',
					field: 'EffectiveDateISO',
					reverse: false,
					title: 'Effective Desc'
				},
				{
					key: 'effective-date-asc',
					field: 'EffectiveDateISO',
					reverse: true,
					title: 'Effective Asc'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'Postgraduate loan',
						filterKeys: ['PostGraduateLoan'],
						id: 'tax-update-postgraduate-loan'
					},
					{
						description: 'Student loan',
						filterKeys: ['StudentLoan'],
						id: 'tax-update-student-loan'
					},
					{
						description: 'Tax code',
						filterKeys: ['taxCode'],
						id: 'tax-update-tax-code'
					},
					{
						description: 'Period',
						filterKeys: ['title'],
						id: 'tax-update-period-title'
					}
				],
				terms: {
					placeholder: 'Search tax updates...',
					singular: '1 tax update',
					plural: '{} tax updates'
				}
			},
			storageKeys: {
				layout: 'taxUpdatesLayout',
				orderBy: 'taxUpdatesOrderBy',
				reverse: 'taxUpdatesOrderReverse'
			}
		},
		team: {
			id: 'team',
			layoutOptions: [
				{
					key: 'cards',
					title: 'Cards'
				},
				{
					key: 'rows',
					title: 'Rows'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID Desc'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'Forename',
							'Fullname',
							'HMRCID',
							'ID',
							'NINumber',
							'PolicyGradeName',
							'Surname',
							'UserID',
							'UTR'
						],
						id: 'all',
					},
					{
						description: 'Name',
						filterKeys: [
							'Fullname'
						],
						id: 'fullname',
					},
					{
						description: 'Payroll ID',
						filterKeys: [
							'ID'
						],
						id: 'payrollid',
						isExactMatch: true
					},
					{
						description: 'HMRC ID',
						filterKeys: [
							'HMRCID'
						],
						id: 'hmrcId',
						isExactMatch: true
					},
					{
						description: 'NI Number',
						filterKeys: [
							'NINumber'
						],
						id: 'ninumber',
					},
					{
						description: 'UTR',
						filterKeys: [
							'UTR'
						],
						id: 'utr',
					},
					{
						description: 'Job grade',
						filterKeys: [
							'PolicyGradeName'
						],
						id: 'policygradename'
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				itemsPerPage: 'teamItemsPerPage',
				layout: 'teamLayout',
				orderBy: 'teamOrderBy',
				reverse: 'teamOrderReverse'
			}
		},
		teamGeneric: {
			id: 'team-generic',
			search: {
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			}
		},
		teamHistory: {
			id: 'team-history',
			layoutOptions: [
				{
					key: 'rows',
					title: 'Rows'
				},
				{
					key: 'cards',
					title: 'Cards'
				}
			],
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				},
				{
					key: 'payroll-id-asc',
					field: 'PayrollIDSequence',
					reverse: false,
					title: 'Payroll ID Asc'
				},
				{
					key: 'payroll-id-desc',
					field: 'PayrollIDSequence',
					reverse: true,
					title: 'Payroll ID Desc'
				}
			],
			search: {
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				layout: 'payrollHistoryTeamLayout',
				orderBy: 'payrollHistoryTeamOrderBy',
				reverse: 'payrollHistoryTeamOrderReverse'
			}
		},
		teamManager: {
			id: 'team-manager',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'Forename',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'Forename',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surname-asc',
					field: 'Surname',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surname-desc',
					field: 'Surname',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'Forename',
						filterKeys: ['Forename'],
						id: 'forename',
					},
					{
						description: 'Surname',
						filterKeys: ['Surname'],
						id: 'surname',
					},
					{
						description: 'NI Number',
						filterKeys: ['NINumber'],
						id: 'ninumber',
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				orderBy: 'teamManagerOrderBy',
				reverse: 'teamManagerOrderReverse'
			}
		},
		teamReport: {
			id: 'team-report',
			orderByOptions: [
				{
					key: 'forename-asc',
					field: 'forenameSearch',
					reverse: false,
					title: 'First name A-Z'
				},
				{
					key: 'forename-desc',
					field: 'forenameSearch',
					reverse: true,
					title: 'First name Z-A'
				},
				{
					key: 'surename-asc',
					field: 'surnameSearch',
					reverse: false,
					title: 'Surname A-Z'
				},
				{
					key: 'surename-desc',
					field: 'surnameSearch',
					reverse: true,
					title: 'Surname Z-A'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				itemsPerPage: 'teamReportItemsPerPage',
				layout: 'teamReportLayout',
				orderBy: 'teamReportOrderBy',
				reverse: 'teamReportOrderReverse'
			}
		},
		teamRotaready: {
			id: 'team-rota-ready',
			orderByOptions: [
				{
					key: 'fullname-asc',
					field: 'Rotaready.FullName',
					reverse: false,
					title: 'Full name A-Z'
				},
				{
					key: 'fullname-desc',
					field: 'Rotaready.FullName',
					reverse: true,
					title: 'Full name Z-A'
				},
				{
					key: 'nino-asc',
					field: 'Rotaready.Nino',
					reverse: false,
					title: 'NI Number Asc'
				},
				{
					key: 'nino-desc',
					field: 'Rotaready.Nino',
					reverse: true,
					title: 'NI Number Desc'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'Rotaready.FullName',
							'Rotaready.Nino'
						],
						id: 'all',
					},
					{
						description: 'Name',
						filterKeys: [
							'Rotaready.FullName'
						],
						id: 'fullname',
					},
					{
						description: 'NI Number',
						filterKeys: [
							'Rotaready.Nino'
						],
						id: 'nino',
						isExactMatch: true
					}
				],
				terms: {
					placeholder: 'Search team...',
					singular: '1 team member',
					plural: '{} team members'
				}
			},
			storageKeys: {
				itemsPerPage: 'teamItemsPerPage',
				layout: 'teamLayout',
				orderBy: 'teamOrderBy',
				reverse: 'teamOrderReverse'
			}
		},
		entityRotaready: {
			id: 'entity-rota-ready',
			orderByOptions: [
				{
					key: 'entity-name-asc',
					field: 'EntityName',
					reverse: false,
					title: 'Site/Department name A-Z'
				},
				{
					key: 'entity-name-desc',
					field: 'EntityName',
					reverse: true,
					title: 'Site/Department name Z-A'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'EntityName'
						],
						id: 'all',
					}
				],
				terms: {
					placeholder: 'Search sites/departments...',
					noResults: 'No results',
					singular: '1 site/department',
					plural: '{} sites/departments'
				}
			},
			storageKeys: {
				itemsPerPage: 'entityItemsPerPage',
				layout: 'entityLayout',
				orderBy: 'entityOrderBy',
				reverse: 'entityOrderReverse'
			}
		},
		entityRotareadyMatched: {
			id: 'entity-rota-ready-matched',
			orderByOptions: [
				{
					key: 'entity-name-asc',
					field: 'EntityName',
					reverse: false,
					title: 'Site/Department name A-Z'
				},
				{
					key: 'entity-name-desc',
					field: 'EntityName',
					reverse: true,
					title: 'Site/Department name Z-A'
				}
			],
			search: {
				filterOptions: [
					{
						description: 'All',
						filterKeys: [
							'EntityName'
						],
						id: 'all',
					}
				],
				terms: {
					placeholder: 'Search sites/departments...',
					noResults: 'No results',
					singular: '1 site/department',
					plural: '{} sites/departments'
				}
			},
			storageKeys: {
				itemsPerPage: 'entityMatchedItemsPerPage',
				layout: 'entityMatchedLayout',
				orderBy: 'entityMatchedOrderBy',
				reverse: 'entityMatchedOrderReverse'
			}
		},
		companiesReport: {
			id: 'company-report',
			orderByOptions: [
				{
					key: 'companyName-asc',
					field: 'AgencyProfileName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'companyName-desc',
					field: 'AgencyProfileName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			results: {
				canChangeItemsPerPage: true
			},
			search: {
				disablePersistedSearch: true,
				terms: {
					placeholder: 'Search companies...',
					singular: '1 company',
					plural: '{} companies'
				}
			},
			storageKeys: {
				itemsPerPage: 'companiesReportItemsPerPage',
				layout: 'companiesReportLayout',
				orderBy: 'companiesReportOrderBy',
				reverse: 'companiesReportOrderReverse'
			}
		},
		workflowTasks: {
			id: 'workflow-tasks',
			orderByOptions: [
				{
					key: 'due-date-asc',
					field: 'DueDateISO',
					reverse: false,
					title: 'Due date (old - new)'
				},
				{
					key: 'due-date-desc',
					field: 'DueDateISO',
					reverse: true,
					title: 'Due date (new - old)'
				}
			],
			search: {
				terms: {
					placeholder: 'Search tasks...',
					singular: '1 task',
					plural: '{} tasks'
				}
			},
			storageKeys: {
				reverse: 'workflowTasksOrderReverse'
			}
		},
		xeroTenants: {
			id: 'xero-tenants',
			orderByOptions: [
				{
					key: 'xero-tenant-name-asc',
					field: 'tenantName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'xero-tenant-name-desc',
					field: 'tenantName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: 'Search organisations...',
					singular: '1 organisation',
					plural: '{} organisations'
				}
			}
		},
		getSearchOptionsForOnboardingStats: monthStr => {
			return {
				id: 'onboarding-stats',
				orderByOptions: [
					{
						key: 'name-asc',
						field: 'Bureau',
						reverse: false,
						title: 'Name A-Z'
					},
					{
						key: 'name-desc',
						field: 'Bureau',
						reverse: true,
						title: 'Name Z-A'
					},
					{
						key: 'total-onboarded-asc',
						field: monthStr,
						reverse: false,
						title: 'Total Asc'
					},
					{
						key: 'total-onboarded-desc',
						field: monthStr,
						reverse: true,
						title: 'Total Desc'
					}
				],
				search: {
					terms: {
						placeholder: 'Search bureaus...',
						singular: '1 bureau',
						plural: '{} bureaus'
					}
				}
			};
		}
	};

	return angular.extend(service, options);
}]);

'use strict';

angular.module('paycircleApp')
.service('securityService', [
	'$rootScope',
	'config',
	'permissionsService',
	'session',
	'utilities',
	'COMPANY_TYPES',
	'USER_ROLES',
	function (
		$rootScope,
		config,
		permissionsService,
		session,
		utilities,
		COMPANY_TYPES,
		USER_ROLES
	) {

	var service = {

		isUserAllowedAccess: function (userObj) {

			var allowedRoles = config.allowedRoles;

			// If allowed roles aren't defined presume ok
			if (!allowedRoles) {
				return true;
			}

			// User has no roles set
			if (userObj.UserResponseRoles === undefined) {
				$rootScope.paycircleMessage('The user has no roles defined', 'error');
				return false;
			}

			var primaryRole = utilities.getPrimaryRole(userObj.UserResponseRoles);

			// Unable to get primary role
			if (!primaryRole) {
				console.warn('Paycircle: Unable to set a primary role');
				return false;
			}

			return allowedRoles.indexOf(primaryRole) > -1;
		},
		isUserAuthenticated: function () {

			return session.user !== undefined && session.user !== null;
		},
		isUserAuthorised: function (toState, userObj) {

			// If no page data default to allow all role types
			if (angular.isUndefined(toState.data)) {
				return true;
			}

			return service.isUserAuthorisedForStateRoles(toState.data, userObj.UserResponseRoles) && service.isUserAuthorisedFromPermissionArray(userObj, toState.data.permissions, 'route');
		},

		isUserAuthorisedFromPermissionArray: (userObj, permissionsArr, checkType) => {

			// If no array defined default to authorised
			if (angular.isUndefined(permissionsArr)) {
				return true;
			}

			return permissionsArr.some(permission => permissionsService.getPermissionValueByString(userObj, permission, checkType));
		},

		isUserAuthorisedForStateRoles: function (stateDataObj, userRolesArray) {

			// If no authorised roles or unauthorised roles defined, authorise by default
			if (angular.isUndefined(stateDataObj.authorisedRoles) && angular.isUndefined(stateDataObj.unauthorisedRoles)) {
				return true;
			}

			// Authorised roles
			if (!angular.isUndefined(stateDataObj.authorisedRoles)) {

				// Validate to make sure unauthorised roles is an array
				if (!angular.isArray(stateDataObj.authorisedRoles)) {
					$rootScope.paycircleMessage('Authorised roles need to be an array', 'error');
					return false;
				}

				// No user in session
				if (angular.isUndefined(userRolesArray) || !userRolesArray) {
					$rootScope.paycircleMessage('There are no user roles', 'error');
					return false;
				}

				// Validate authorised roles
				return service.isUserAuthorisedForStateRolesAuthorised(stateDataObj.authorisedRoles, userRolesArray);
			}

			// Unauthorised roles
			if (!angular.isUndefined(stateDataObj.unauthorisedRoles)) {

				// Validate to make sure unauthorised roles is an array
				if (!angular.isArray(stateDataObj.unauthorisedRoles)) {
					$rootScope.paycircleMessage('Unauthorised roles need to be an array', 'error');
					return false;
				}

				// No user in session
				if (angular.isUndefined(userRolesArray) || !userRolesArray) {
					$rootScope.paycircleMessage('There are no user roles', 'error');
					return false;
				}

				// Validate authorised roles
				return service.isUserAuthorisedForStateRolesUnauthorised(stateDataObj.unauthorisedRoles, userRolesArray);
			}
		},
		isUserAuthorisedForStateRolesAuthorised: function (authorisedRolesArray, userRolesArray) {

			var numberOfAuthorisedRoles = authorisedRolesArray.length;
			var i = 0;

			for (i; i < numberOfAuthorisedRoles; i++) {

				var role = authorisedRolesArray[i];

				if (userRolesArray.indexOf(role) > -1) {
					return true;
				}
			}

			return false;
		},
		isUserAuthorisedForStateRolesUnauthorised: function (unauthorisedRolesArray, userRolesArray) {

			var numberOfUnauthorisedRoles = unauthorisedRolesArray.length;
			var i = 0;

			for (i; i < numberOfUnauthorisedRoles; i++) {

				var role = unauthorisedRolesArray[i];

				if (userRolesArray.indexOf(role) > -1) {
					return false;
				}
			}

			return true;
		},

		isUserPermitted: (permissionsToCheck, checkType) => {

			if (!angular.isArray(permissionsToCheck)) {
				permissionsToCheck = [permissionsToCheck];
			}

			return service.isUserAuthorisedFromPermissionArray($rootScope.currentUser, permissionsToCheck, checkType);
		},

		isUserAuthorisedForIdentityAdmin: () => {
			return utilities.userHasRole(session.user, [
				USER_ROLES.bureaumanager,
				USER_ROLES.bureau,
				USER_ROLES.groupuser,
				USER_ROLES.groupadmin,
				USER_ROLES.companyadmin,
				USER_ROLES.companyadministrator,
				USER_ROLES.sme,
				USER_ROLES.paycircle,
				USER_ROLES.departmentadmin]);
		},

		getRequiredPermissionsForAccountManagement: (companyType, managingAdmin) => {
			if (managingAdmin) {
				switch (companyType) {
					case COMPANY_TYPES.bureau: return ['Admin.canManageAccess','Admin.canManageBureauAdmins'];
					case COMPANY_TYPES.group: return ['Admin.canManageCompanyGroupAdmins'];
					case COMPANY_TYPES.company: return ['CompanySettings.canAccessPermissions'];
					default: throw new Error('Invalid company type for admin account management permissions');
				}
			}

			if (companyType === COMPANY_TYPES.company) {
				return ['Team.canAddDeleteTeamMembers','Team.canInviteTeamMembersToRegister'];
			}

			throw new Error('Invalid company type for account management permissions');
		},
	
		canUserManageAccountsForCompanyType: (companyType, managingAdmin) => {
			return service.isUserAuthorisedFromPermissionArray(session.user, service.getRequiredPermissionsForAccountManagement(companyType, managingAdmin), 'account-management');
		},

		storeToken: function (token) {

			if (typeof(Storage) !== 'undefined') {
				localStorage.setItem(config.tokenStorageName, token);
			}
			else {
				utilities.createCookie(config.tokenStorageName, token, config.tokenExpiryHours);
			}
		},
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('session', [
	'$location',
	'$rootScope',
	'$timeout',
	'config',
	'utilities',
	'storageService',
	'AUTH_EVENTS',
	'COOKIE_KEYS',
	'LOCAL_STORAGE_KEYS',
	function (
		$location,
		$rootScope,
		$timeout,
		config,
		utilities,
		storageService,
		AUTH_EVENTS,
		COOKIE_KEYS,
		LOCAL_STORAGE_KEYS
	) {

	function create (userObj) {

		const timeoutWarningDifferenceInMinutes = userObj.SessionTimeout - userObj.SessionTimeoutWarning;

		angular.extend(SESSION, {
			timeoutPeriodMs: utilities.convertMinutesToMilliseconds(userObj.SessionTimeoutWarning),
			timeoutWarningPeriodMs: utilities.convertMinutesToMilliseconds(timeoutWarningDifferenceInMinutes),
			user: userObj
		});

		initTimeoutWarningCountdown();

		setSessionID(userObj);

		setupSessionData(userObj);
	}

	function destroy () {

		angular.extend(SESSION, {
			activeDemo: null,
			canResetTimeout: true,
			timeoutPeriodMs: null,
			timeoutWarningPeriodMs: null,
			user: null,
		});

		$timeout.cancel(SESSION.timeoutCountdown);
		$timeout.cancel(SESSION.timeoutWarningCountdown);

		// Remove SessionID from storage and headers
		utilities.deleteCookie(COOKIE_KEYS.sessionId);
	}

	function extend () {

		$timeout.cancel(SESSION.timeoutCountdown);

		SESSION.canResetTimeout = true;

		initTimeoutWarningCountdown();

		// This is used to extend the Identity session
		$rootScope.$broadcast('check-user-logged-in');
	}

	function getActiveDemo () {
		return SESSION.activeDemo;
	}

	function getActiveDemoTaskId () {
		return SESSION.activeDemo ? SESSION.activeDemo.demoTaskId : '';
	}

	function getAgencyProfileParentId () {
		return SESSION.user.AgencyProfileParentID;
	}

	function getCookieTimeoutInHours (userObj) {

		// Add an extra minute as a buffer for cookie creation timing, to avoid it expiring before the timeout warning modal is displayed
		const cookieTimeoutMinutes = userObj.SessionTimeout + 1;

		// Convert to hours
		return cookieTimeoutMinutes / 60;
	}

	function getCustomisation () {
		return SESSION.customisation;
	}

	function getSessionData () {
		return storageService.getObjectFromSessionStorage(LOCAL_STORAGE_KEYS.sessionData, null);
	}

	function getUserId () {
		return SESSION.user.UserResponseUserID;
	}

	function initTimeoutWarningCountdown () {

		if (SESSION.user && SESSION.canResetTimeout) {

			// Reset timer
			if (SESSION.timeoutWarningCountdown) {
				$timeout.cancel(SESSION.timeoutWarningCountdown);

				// Reset SessionID cookie expiry
				setSessionID(SESSION.user);
			}

			SESSION.timeoutWarningCountdown = $timeout(() => {

				// Don't reset timer unless session is extended
				SESSION.canResetTimeout = false;

				// Show modal
				$rootScope.$broadcast(AUTH_EVENTS.sessionTimeoutWarning, SESSION.timeoutPeriodMs);

				SESSION.timeoutCountdown = $timeout(() => {

					// Show modal & logout
					$rootScope.$broadcast(AUTH_EVENTS.sessionTimeout);

				}, SESSION.timeoutPeriodMs);

			}, SESSION.timeoutWarningPeriodMs);
		}
	}

	function isInPlayground () {
		return SESSION.user.AgencyProfileDummy;
	}

	function resetActiveDemo () {
		SESSION.activeDemo = null;
	}

	function saveSessionData (sessionDataObj) {
		storageService.addObjectToSessionStorage(LOCAL_STORAGE_KEYS.sessionData, sessionDataObj);
	}

	function setActiveDemo (demoObj) {
		SESSION.activeDemo = demoObj;
	}

	function setCustomisation (customisationObj) {
		SESSION.customisation = customisationObj;
	}

	function setupSessionData (userObj) {

		const sessionDataObj = {
			hasTimedOut: false,
			user: {
				userId: userObj.UserResponseUserID,
			},
			state: {},
			app: {}
		};

		saveSessionData(sessionDataObj);
	}

	function setSessionID (userObj) {

		const sessionCookieTimeoutInHours = getCookieTimeoutInHours(userObj);

		utilities.createCookie(COOKIE_KEYS.sessionId, userObj.SessionID, sessionCookieTimeoutInHours);
	}

	function getSessionId () {
		return utilities.readCookie(COOKIE_KEYS.sessionId);
	}

	function updateSessionData (updateObj) {

		const sessionDataObj = getSessionData();

 		if (sessionDataObj) {
 			angular.extend(sessionDataObj, updateObj);

	 		saveSessionData(sessionDataObj);
 		}
	}

	const SESSION = {
		customisation: null,
		user: null,
		activeDemo: null,
		canResetTimeout: true,

		create,
		destroy,
		extend,
		getActiveDemo,
		getActiveDemoTaskId,
		getAgencyProfileParentId,
		getCustomisation,
		getSessionId,
		getUserId,
		initTimeoutWarningCountdown,
		isInPlayground,
		resetActiveDemo,
		setActiveDemo,
		setCustomisation,
		setSessionID,
		updateSessionData
	};

	return SESSION;
}]);

'use strict';

angular.module('paycircleApp')
.service('settingsService', [
	'$rootScope',
	'$state',
	'securityService',
	'COMPANY_TYPES',
	'USER_ROLES',
	function (
		$rootScope,
		$state,
		securityService,
		COMPANY_TYPES,
		USER_ROLES
	) {

	const service = {

		getNgHrefForSettingsState: (state, companyObj) => {

			state = service.getSettingsStateForCompanyType(state, companyObj);

			return $state.href(state, { agencyProfileId: companyObj.AgencyProfileID });
		},

		getSettingsStateForCompanyType: (state, companyObj) => {

			switch (companyObj.companyType) {

				case COMPANY_TYPES.bureau:
					return `settings.bureau.${state}`;
				case COMPANY_TYPES.group:
					return `settings.group.${state}`;
				default:
					return `settings.company.${state}`;

			}
		},

		getSettingsOverviewCardsForBureau: (companyObj, loggedInUserObj, isCustomerCodeEnabled, isAverageHolidayPayEnabled) => {

			let overviewModulesArr = [
				{
					title: 'General settings',
					icon: 'settings',
					settingsGroups: [
						{
							key: 'information',
							name: 'Information',
							theme: 'is-secondary'
						},
						{
							availableInPlayground: false,
							isActive: loggedInUserObj.CanCustomise,
							key: 'customisation',
							name: 'Customisation',
						},
						{
							isActive: companyObj.IsCustomerCodesEnabled || isCustomerCodeEnabled,
							key: 'customer-codes',
							name: 'Customer codes'
						}
					]
				},
				{
					title: 'Payroll settings',
					icon: 'clock',
					settingsGroups: [
						{
							key: 'payroll-settings',
							name: 'Payroll settings',
						},
						{
							availableInPlayground: false,
							key: 'bacs-downloads',
							name: 'BACS downloads',
							requiredPermissions: [
								'Admin.canManageBacsDownloads'
							]
						},
						{
							key: 'pay-elements.core',
							name: 'Pay elements',
						}
					]
				},
				{
					title: 'Access & Permissions',
					icon: 'remote-access',
					settingsGroups: [
						{
							key: 'roles',
							name: 'Roles',
							requiredPermissions: [
								'Admin.canManageBureauAdmins'
							]
						},
						{
							key: 'admins',
							name: 'Admins',
							requiredPermissions: [
								'Admin.canManageBureauAdmins'
							]
						},
						{
							key: 'access.ip-management',
							availableInPlayground: false,
							name: 'Access',
							requiredPermissions: [
								'Admin.canManageAccess'
							]
						}
					]
				},
				{
					title: 'Reports',
					icon: 'csv',
					settingsGroups: [
						{
							key: 'reports.custom',
							name: 'Report templates',
						}
					]
				},
				{
					title: 'Imports',
					icon: 'upload',
					settingsGroups: [
						{
							key: 'imports.mappings',
							name: 'Mapping templates',
						}
					]
				},
				{
					title: 'Employee portal',
					icon: 'user',
					settingsGroups: [
						{
							key: 'employee-portal-settings',
							name: 'Employee portal settings'
						}
					]
				},
				{
					title: 'Notifications',
					icon: 'notification',
					requiredPermissions: [
						'Admin.canManageEmailNotifications'
					],
					settingsGroups: [
						{
							key: 'email-notifications',
							name: 'Email notifications',
							theme: 'is-positive'
						}
					]
				}
			];

			if (isAverageHolidayPayEnabled) {

				overviewModulesArr[3].settingsGroups.push(
					{
						key: 'average-holiday-pay',
						name: 'Average holiday pay'
					}
				);
			}

			if ($rootScope.userHasRole(USER_ROLES.paycircle)) {

				// If the user is a Paycircle super user, insert the 'Modules & Integrations' block after 'Imports'
				overviewModulesArr.splice(4, 0,{
					title: 'Modules & Integrations',
					icon: 'connection',
					settingsGroups: [
						{
							key: 'modules',
							name: 'Modules'
						}
					]
				});
			}

			return service.getOverviewModulesForCompany(overviewModulesArr, companyObj, loggedInUserObj);
		},

		getSettingsOverviewCardsForCompany: (companyObj, loggedInUserObj, isAverageHolidayPayEnabled) => {

			let overviewModulesArr = [
				{
					title: 'General settings',
					icon: 'settings',
					requiredPermissions: [
						'CompanySettings.canAccessGeneral'
					],
					settingsGroups: [
						{
							key: 'information',
							name: 'Information',
							theme: 'is-secondary'
						},
						{
							isActive: companyObj.isBillingEnabled && companyObj.MandateState > 0,
							key: 'billing',
							name: 'Billing'
						},
						{
							isActive: companyObj.isBillingEnabled,
							key: 'upgrade',
							name: 'Upgrade'
						},
						{
							availableInPlayground: false,
							isActive: loggedInUserObj.CanCustomise,
							key: 'customisation',
							name: 'Customisation',
						}
					]
				},
				{
					title: 'Payroll settings',
					icon: 'clock',
					requiredPermissions: [
						'CompanySettings.canAccessPayroll'
					],
					settingsGroups: [
						{
							key: 'payroll-settings',
							name: 'Payroll settings'
						},
						{
							key: 'payslips',
							name: 'Payslips'
						},{
							key: 'p11db-submissions',
							name: 'P11D(b) submissions'
						},
						{
							key: 'work-patterns',
							name: 'Work Patterns'
						},
						{
							key: 'pay-elements.additions',
							name: 'Pay elements'
						},
						{
							key: 'workflow',
							name: 'Workflow'
						}
					]
				},
				{
					title: 'Access & Permissions',
					icon: 'remote-access',
					requiredPermissions: [
						'CompanySettings.canAccessPermissions'
					],
					settingsGroups: [
						{
							key: 'roles',
							name: 'Roles'
						},
						{
							key: 'admins',
							name: 'Admins'
						}
					]
				},
				{
					title: 'Reports & Journals',
					icon: 'csv',
					requiredPermissions: [
						'CompanySettings.canAccessReports'
					],
					settingsGroups: [
						{
							key: 'reports.custom',
							name: 'Report templates',
						},
						{
							key: 'business-categories.category',
							name: 'Business Categories',
						},
						{
							key: 'journals.nominal-codes',
							name: 'Journals',
						}
					]
				},
				{
					title: 'Employee portal',
					icon: 'user',
					requiredPermissions: [
						'CompanySettings.canAccessEmployeePortal'
					],
					settingsGroups: [
						{
							key: 'employee-portal-settings',
							name: 'Employee portal settings'
						}
					]
				},
				{
					title: 'Modules & Integrations',
					icon: 'connection',
					requiredPermissions: [
						'CompanySettings.canAccessModules'
					],
					settingsGroups: [
						{
							key: 'modules',
							name: 'Modules',
						},
						{
							key: 'integrations',
							name: 'Integrations',
						}
					]
				},
				{
					title: 'Imports',
					icon: 'upload',
					requiredPermissions: [
						'CompanySettings.canAccessImports'
					],
					settingsGroups: [
						{
							key: 'imports.mappings',
							name: 'Imports',
						}
					]
				},
				{
					title: 'Notifications',
					icon: 'notification',
					requiredPermissions: [
						'CompanySettings.canAccessNotifications'
					],
					settingsGroups: [
						{
							key: 'email-notifications',
							name: 'Email notifications',
							theme: 'is-positive',
						}
					]
				},
				{
					title: 'Files',
					icon: 'document',
					requiredPermissions: [
						'CompanySettings.canAccessFiles'
					],
					settingsGroups: [
						{
							key: 'file-uploads',
							name: 'File uploads',
						}
					]
				},
				{
					isActive: companyObj.IsExpatActive,
					title: 'International',
					icon: 'international',
					requiredPermissions: [
						'CompanySettings.canAccessInternational'
					],
					settingsGroups: [
						{
							key: 'currencies',
							name: 'Currencies',
						}
					]
				}
			];

			if (companyObj.IsGenderPayGapReportingActive) {

				overviewModulesArr[3].settingsGroups.push(
					{
						key: 'gender-pay-gap',
						name: 'Gender pay gap'
					}
				);
			}

			if (isAverageHolidayPayEnabled) {

				overviewModulesArr[3].settingsGroups.push(
					{
						key: 'average-holiday-pay',
						name: 'Average holiday pay'
					}
				);
			}

			if (companyObj.Employer.IsPensionActive) {

				overviewModulesArr.splice(2, 0, {
					title: 'Pension settings',
					icon: 'money',
					requiredPermissions: [
						'CompanySettings.canAccessPensionSettings'
					],
					settingsGroups: [
						{
							key: 'pension-settings',
							name: 'Pension settings'
						}
					]
				});
			}

			return service.getOverviewModulesForCompany(overviewModulesArr, companyObj, loggedInUserObj);
		},

		getSettingsOverviewCardsForGroup: (companyObj, loggedInUserObj) => {

			let overviewModulesArr = [
				{
					title: 'General settings',
					icon: 'settings',
					settingsGroups: [
						{
							key: 'information',
							name: 'Information',
							theme: 'is-secondary'
						},
						{
							availableInPlayground: false,
							isActive: loggedInUserObj.CanCustomise,
							key: 'customisation',
							name: 'Customisation',
						}
					]
				},
				{
					title: 'Access & Permissions',
					icon: 'remote-access',
					settingsGroups: [
						{
							key: 'admins',
							name: 'Admins',
							requiredPermissions: [
								'Admin.canManageCompanyGroupAdmins'
							]
						},
					]
				},
				{
					title: 'Reports',
					icon: 'csv',
					settingsGroups: [
						{
							key: 'reports.custom',
							name: 'Report templates',
						}
					]
				},
				{
					title: 'Modules & Integrations',
					icon: 'connection',
					settingsGroups: [
						{
							key: 'modules',
							name: 'Modules',
						}
					]
				},
				{
					title: 'Notifications',
					icon: 'notification',
					requiredPermissions: [
						'Admin.canManageEmailNotifications'
					],
					settingsGroups: [
						{
							key: 'email-notifications',
							name: 'Email notifications',
							theme: 'is-positive'
						}
					]
				}
			];

			if (companyObj.IsGenderPayGapReportingActive) {

				overviewModulesArr[2].settingsGroups.push(
					{
						key: 'gender-pay-gap',
						name: 'Gender pay gap'
					}
				);
			}

			return service.getOverviewModulesForCompany(overviewModulesArr, companyObj, loggedInUserObj);
		},

		getSettingsOverviewCardsForCompanyType: (companyObj, loggedInUserObj, isCustomerCodeEnabled, isAverageHolidayPayEnabled) => {

			switch (companyObj.companyType) {
				case COMPANY_TYPES.bureau:
					return service.getSettingsOverviewCardsForBureau(companyObj, loggedInUserObj, isCustomerCodeEnabled, isAverageHolidayPayEnabled);
				case COMPANY_TYPES.group:
					return service.getSettingsOverviewCardsForGroup(companyObj, loggedInUserObj);
				case COMPANY_TYPES.company:
					return service.getSettingsOverviewCardsForCompany(companyObj, loggedInUserObj, isAverageHolidayPayEnabled);
			}
		},

		getIsOverviewItemActive: (overviewItemObj, companyObj, loggedInUserObj) => {

			// Available in playground
			if (angular.isDefined(overviewItemObj.availableInPlayground)) {
				if (!overviewItemObj.availableInPlayground && loggedInUserObj.IsInPlayground) {
					return false;
				}
			}

			// Feature toggle
			if (angular.isDefined(overviewItemObj.isActive) && !overviewItemObj.isActive) {
				return false;
			}

			// Permissions
			if (angular.isArray(overviewItemObj.requiredPermissions)) {
				return securityService.isUserAuthorisedFromPermissionArray(loggedInUserObj, overviewItemObj.requiredPermissions, 'settings-link');

			} else {
				return true;
			}
		},

		getOverviewModulesForCompany: (overviewModulesArr, companyObj, loggedInUserObj) => {

			return overviewModulesArr.filter(overviewModuleObj => {

				overviewModuleObj.settingsGroups = overviewModuleObj.settingsGroups.filter(settingsGroupObj => {

					settingsGroupObj.ngHref = service.getNgHrefForSettingsState(settingsGroupObj.key, companyObj);

					settingsGroupObj.isActive = service.getIsOverviewItemActive(settingsGroupObj, companyObj, loggedInUserObj);

					return settingsGroupObj.isActive;
				});

				overviewModuleObj.isActive = overviewModuleObj.settingsGroups.length && service.getIsOverviewItemActive(overviewModuleObj, companyObj, loggedInUserObj);

				return overviewModuleObj.isActive;
			});
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('silentAuthService', [
	'$location',
	'$state',
	'$window',
	'securityData',
	'utilities',
	'EVO_MESSAGE_TYPES',
	'LOCAL_STORAGE_KEYS',
	function (
		$location,
		$state,
		$window,
		securityData,
		utilities,
		EVO_MESSAGE_TYPES,
		LOCAL_STORAGE_KEYS
	) {

	const service = {

		getURLParameters: () => {
			return $location.search();
		},

		silentAuthenticateUser: (userResponseUserId) => {
			const params = service.getURLParameters();

			return service.proceedWithSilentAuth(params, userResponseUserId);
		},

		proceedWithSilentAuth: (params, userResponseUserId) => {

			// EVO Button flow - only uses URL parameters (userid + email)
			if (params.userid && params.email) {
				return service.silentAuthEvoButton(params);
			}

			// EVO Native flow
			if (params.instanceId) {
				return service.silentAuthEvoNative({ userId: params.instanceId });
			}
			
			// If userResponseUserId is provided (app-triggered), use EVO Native flow
			if (userResponseUserId) {
				return service.silentAuthEvoNative({ userId: userResponseUserId });
			}
			
			// Log warning for debugging when no valid parameters are found
			console.warn('proceedWithSilentAuth: no valid parameters for silent auth');
			
			// Return a rejected promise when no valid auth parameters are found
			return Promise.reject(new Error('No valid silent auth parameters found'));
		},

		silentAuthEvoButton: (params) => {

			// Return the promise so the caller can await or handle errors
			return securityData.getSigninStartType(params.email, params.userid)
				.then((identityData) => {
					service.identityRedirect(identityData);
					return {isLoggedIn: true};
				})
				.catch((error) => {
					console.error('Silent Auth for EVO Button failed:', error);
					$state.go('login');
					throw error;
				});
		},

		silentAuthEvoNative: ({ userId }) => {

			// Return the promise so the caller can await or handle errors
			return securityData.getSigninStartTypeNative(userId)
				.then((identityData) => {
					service.identityRedirect(identityData);
					return {isLoggedIn: true};
				})
				.catch((error) => {
					console.error('Silent Auth for Native failed:', error);
					service.requestReauthenticationFromParent();
					throw error;
				});
		},

		goToEvoMigration: (identityUrl) => {

			$state.go('login', {
				isEvoMigrationRequired: true,
				evoMigrationUrl: identityUrl
			});
		},

		identityRedirect: (accessIdentityData) => {

			utilities.addToStorage(LOCAL_STORAGE_KEYS.nonce, accessIdentityData.Nonce);
			$window.open(accessIdentityData.IdentityUrl, '_self');
		},

		requestReauthenticationFromParent: () => {
			const message = {
				type: EVO_MESSAGE_TYPES.RequestReauthentication,
				url: $window.location.href,
			};
			$window.parent.postMessage(JSON.stringify(message), utilities.getIframeParentURL());
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('stateService', [
	'$filter',
	'$q',
	'$rootScope',
	'$state',
	'applicationService',
	'config',
	'companyData',
	'customisationService',
	'edpTopicService',
	'intercomService',
	'coralogixService',
	'pendoService',
	'securityData',
	'securityService',
	'session',
	'storageService',
	'tracking',
	'utilities',
	'validationService',
	'AUTH_EVENTS',
	'COMPANY_TYPES',
	'LOCAL_STORAGE_KEYS',
	function (
		$filter,
		$q,
		$rootScope,
		$state,
		applicationService,
		config,
		companyData,
		customisationService,
		edpTopicService,
		intercomService,
		coralogixService,
		pendoService,
		securityData,
		securityService,
		session,
		storageService,
		tracking,
		utilities,
		validationService,
		AUTH_EVENTS,
		COMPANY_TYPES,
		LOCAL_STORAGE_KEYS
	) {

	const COMPANIES_STORAGE = getStoredCompanies();

	function assessCompanyRedirect (companyObj, event, companyStateRedirect) {

		return $q(onComplete => {

			if (!angular.isObject(companyStateRedirect)) {
				onComplete(companyObj);
			}

			for (let redirectArr of Object.entries(companyStateRedirect)) {

				const property = redirectArr[0];
				const redirectToState = redirectArr[1];

				if (companyObj[property]) {

					event.preventDefault();

					$state.go(redirectToState, {agencyProfileId: companyObj.AgencyProfileID});
				}
			}

			onComplete(companyObj);

		});
	}

	function assessRoleRedirect (companyObj, event, roleStateRecirect) {

		return $q(onComplete => {

			if (!angular.isObject(roleStateRecirect)) {
				onComplete(companyObj);
			}

			for (let redirectArr of Object.entries(roleStateRecirect)) {

				const roleType = redirectArr[0];
				const redirectToState = redirectArr[1];

				if ($rootScope.userHasRole(roleType)) {

					event.preventDefault();

					$state.go(redirectToState, {agencyProfileId: companyObj.AgencyProfileID});
				}
			}

			onComplete(companyObj);

		});
	}

	function addCompanyToStorage (companyObj) {

		/*
			Function is called when a new company is loaded in to the app

			Outcomes:
			1. Company exists in array
				a. Within the same company
					- Replace object
				b. A higher level company
					- Splice array to have company a the end
			2. Company doesn't exist in array
				a. Company of same type exists in array
					- Push company to array and clear all but top level companies
				b. No company of same type exists in array
					- Push company to array
		*/

		// Reduce object down to avoid storing sensitive looking info in local storage
		const newCompanyObj = reduceCompanyObj(companyObj);

		// Does new already exist in array
		const newCompanyIndex = COMPANIES_STORAGE.companies.findIndex(storedCompanyObj => storedCompanyObj.AgencyProfileID === newCompanyObj.AgencyProfileID);
		const isNewCompanyInStorage = (newCompanyIndex > -1);

		// Are we already in the same company
		const isUserWithinNewCompany = COMPANIES_STORAGE.currentCompany && COMPANIES_STORAGE.currentCompany.AgencyProfileID === newCompanyObj.AgencyProfileID;

		// Company exists in storage
		if (isNewCompanyInStorage) {

			// CurrentCompany is the same as selected company - Update it in storage
			if (isUserWithinNewCompany) {
				COMPANIES_STORAGE.companies[newCompanyIndex] = newCompanyObj;
			}
			// Remove companies that precede selected company
			else {
				COMPANIES_STORAGE.companies.splice(newCompanyIndex + 1);
			}

		}

		// Company doesn't exist in storage yet
		else {

			// Multiple bureaus are allowed, (eg: Paycircle -> Bureau 1), but not multiple groups/companies
			const isCompanyTypeNotRepeatable = ![COMPANY_TYPES.bureau].includes(newCompanyObj.companyType);
			const isCompanyOfSameTypeInStorage = (isCompanyTypeNotRepeatable && COMPANIES_STORAGE.companies.findIndex(storedCompanyObj => storedCompanyObj.companyType === newCompanyObj.companyType) > -1);

			// If two of the same CompanyTypes exist, then keep top level company and clear the rest
			if (isCompanyOfSameTypeInStorage) {
				COMPANIES_STORAGE.companies = [COMPANIES_STORAGE.companies[0], companyObj];
			}

			// Push company to array otherwise
			else {
				COMPANIES_STORAGE.companies.push(newCompanyObj);
			}

		}

		// Load state (AuthResolverCompany)
		companyObj.isLoading = false;

		COMPANIES_STORAGE.currentCompany = newCompanyObj;

		saveCompaniesStorage();
	}

	function checkUserLogin (stateObj) {

		return $q((onStateSetupComplete, onUserUnauthenticated) => {

			const userAuthString = utilities.getToken();

			// Take user straight to the login page if AuthString is missing
			if (!userAuthString) {
				setupState(stateObj)
					.then(onStateSetupComplete)
					.catch(onUserUnauthenticated);
				return;
			}

			// Check if user is already logged in
			securityData.isUserLoggedIn(userAuthString).then(userObj => {

				if (userObj.RequiresAccessMigration && !userObj.IsSSOLogin) {
					if (utilities.getToken() !== null) {
						securityData.signOut();
					}
					$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);
					$state.go('login', {RequiresAccessMigration: userObj.RequiresAccessMigration});

					setupState(stateObj)
						.then(onStateSetupComplete)
						.catch(onUserUnauthenticated);
					return;
				} else if (userObj.RequiresAccessMigration && userObj.IsSSOLogin && !userObj.IsRegistered) {
					$state.go('ssoRegisterUser', {user: userObj});
					setupState(stateObj)
						.then(onStateSetupComplete)
						.catch(onUserUnauthenticated);
					return;
				} else if (userObj.RequiresAccessMigration && userObj.IsSSOLogin && userObj.IsRegistered) {
					if (utilities.getToken() !== null) {
						securityData.signOut();
					}
					$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);
					$state.go('login', {RequiresAccessMigration: userObj.RequiresAccessMigration});

					setupState(stateObj)
						.then(onStateSetupComplete)
						.catch(onUserUnauthenticated);
					return;
				}
				// Set authenticated flag
				stateObj.authenticated = securityService.isUserAllowedAccess(userObj);

				if (stateObj.authenticated) {

					onAuthenticatedLogin(userObj).then(() => {
						reviewCurrentCompany(stateObj.toParams).then(companyObj => {

							setupState(stateObj, companyObj)
								.then(onStateSetupComplete)
								.catch(onUserUnauthenticated);
						});
					});

				} else {
					onUserUnauthenticated();
				}
			})
			.catch(() => {

				// Show timeout modal and clear existing session
				$rootScope.$broadcast(AUTH_EVENTS.sessionTimeout);
				$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);

				// Load login page
				setupState(stateObj)
					.then(onStateSetupComplete)
					.catch(onUserUnauthenticated);

			});
		});
	}

	function getCompanyFromAgencyProfileId (agencyProfileId) {

		return $q(onComplete => {

			companyData.getAgencyProfileCompanyDetails(agencyProfileId)
				.then(companyDetailsObj => {

					// Decorate company
					$filter('companyDetails')(companyDetailsObj, $rootScope.currentUser.isPaycircleAdmin);

					// Return company
					onComplete(companyDetailsObj);
				})
				.catch(error => {
					$rootScope.paycircleMessage('application.js > setCompany: Unable to load company details - current company details reset', 'info');
					console.error(error);
				});
		});
	}

	function getPreviousCompanyObj () {

		let appLevelsArr = COMPANIES_STORAGE.companies;

		return appLevelsArr[appLevelsArr.length-2];
	}

	function getStoredCompanies () {

		const storedCompaniesObj = utilities.getFromStorage(LOCAL_STORAGE_KEYS.companiesStorage, {
			companies: [],
			currentCompany: null
		});

		// Object from local storage comes back as a string
		const companiesStorageObj = angular.isObject(storedCompaniesObj) ? storedCompaniesObj : JSON.parse(storedCompaniesObj);

		// Remove duplicates if they exist
		const initialCompanyStorageLengthInt = companiesStorageObj.companies.length;
		if (initialCompanyStorageLengthInt > 0) {

			companiesStorageObj.companies = utilities.removeDuplicatesFromArrayByObjectProperty(companiesStorageObj.companies, 'AgencyProfileID');

			// Monitor if there have been duplicates in the array
			if (initialCompanyStorageLengthInt !== companiesStorageObj.companies.length) {
				coralogixService.logMessage('State > Duplicates in company storage');
			}
		}

		return companiesStorageObj;
	}

	function goToPreviousCompany () {

		const previousCompanyObj = getPreviousCompanyObj();
		const previousCompanyState = applicationService.getCompaniesPageForCompany(COMPANIES_STORAGE.currentCompany);

		$state.go(previousCompanyState, {agencyProfileId: previousCompanyObj.AgencyProfileID});
	}

	function loadCustomisation (userObj) {
        return $q(onComplete => {
            // Load customisation
            companyData.getCompanyCustomisationToUseForSignin(userObj.AgencyProfileID ,userObj.AgencyProfileCustomisationID)
                .then(onComplete)
                .catch(error => {
                    console.error(error);
                    $rootScope.paycircleMessage('Unable to load customisation', 'warn');
                });
        });
    }

	function onAuthenticatedLogin (userObj) {

		return $q(onComplete => {
			setupUser(userObj).then(userObj => {
				loadCustomisation(userObj).then(customisationObj => {
					setupApp(userObj, customisationObj)
						.then(onComplete);
					});
				});
			});
	}

	function onSessionDestroy () {

		setupDefaults();

		angular.extend(COMPANIES_STORAGE, {
			currentCompany: null,
			companies: []
		});

		utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.companiesStorage);
	}

	function onStateChange (event, toState, toParams) {

		// Called on $stateChangeStart

		const stateObj = {
			authenticated: securityService.isUserAuthenticated(), // Check if there's already a user session
			isLoginPage: applicationService.isStateLoginPage(toState),
			isStatePublic: applicationService.isStatePublic(toState),
			toParams,
			toState,
			event
		};

		return $q((onStateSetupComplete, onUserUnauthenticated) => {

			// If already authorised or page is public and not a login page then no authentication/authorisation is required.
			if (stateObj.authenticated || (stateObj.isStatePublic && !stateObj.isLoginPage)) {
				reviewCurrentCompany(stateObj.toParams).then(companyObj => {
					setupState(stateObj, companyObj)
						.then(onStateSetupComplete)
						.catch(onUserUnauthenticated);
				});

				return;
			}

			// The ability to pass an Auth string in the URL to allow logging-in externally
			if (angular.isDefined(toParams.authstring)) {
				securityService.storeToken(toParams.authstring);
			}

			if (toParams.RequiresAccessMigration) {
				onStateSetupComplete();
				return;
			}
			// Check user login and continue with app setup
			checkUserLogin(stateObj)
				.then(onStateSetupComplete)
				.catch(onUserUnauthenticated);
		});
	}

	function reduceCompanyObj (companyObj) {

		let reducedCompanyObj = angular.copy(companyObj);

		delete reducedCompanyObj.CompanyP32Management;
		delete reducedCompanyObj.HMRCDisbursement;
		delete reducedCompanyObj.PensionDisbursements;

		return reducedCompanyObj;
	}

	function resetCompanyStorage () {

		angular.extend(COMPANIES_STORAGE, {
			currentCompany: null,
			companies: []
		});

		saveCompaniesStorage();
	}

	function reviewCurrentCompany (toParamsObj) {

		// Assess if the currentCompany has changed

		return $q(onComplete => {

			let agencyProfileId = toParamsObj.agencyProfileId;

			// Setup app
			if (!angular.isDefined(agencyProfileId)) {
				onComplete();
				return;
			}

			// Do nothing if within same company
			if ($rootScope.currentCompany && $rootScope.currentCompany.AgencyProfileID === agencyProfileId) {
				onComplete($rootScope.currentCompany);
				return;
			}

			// Mark company as loading for AuthResolverCompany
			if (angular.isObject($rootScope.currentCompany)) {
				$rootScope.currentCompany.isLoading = true;
			}

			// If user is missing root company then get those details first
			if (
				!COMPANIES_STORAGE.companies[0] &&
				agencyProfileId !== $rootScope.currentUser.AgencyProfileID &&
				!$rootScope.currentUser.hasTempPermissions
			) {

				coralogixService.logMessage('State > Root company missing');

				getCompanyFromAgencyProfileId($rootScope.currentUser.AgencyProfileID)
					.then(userCompanyObj => {

						COMPANIES_STORAGE.companies.push(userCompanyObj);

						// Continue with current company
						setCompany(agencyProfileId, toParamsObj)
							.then(onComplete);
					});

				return;
			}

			// Setup current company before continuing
			setCompany(agencyProfileId, toParamsObj)
				.then(onComplete);
		});
	}

	function saveCompaniesStorage () {

		angular.extend($rootScope, COMPANIES_STORAGE);

		// Save to SessionStorage
		session.updateSessionData({
			app: {
				companiesStorage: COMPANIES_STORAGE
			}
		});

		const companiesStorageString = JSON.stringify(COMPANIES_STORAGE);

		utilities.addToStorage(LOCAL_STORAGE_KEYS.companiesStorage, companiesStorageString);
	}

	function setCompany (companyAgencyProfileId, toParamsObj) {

		return $q(onComplete => {

			// Validation
			if (!validationService.isValidGuid(companyAgencyProfileId)) {
				$rootScope.paycircleMessage('application.js > setCompany: Invalid company id or company name provided', 'warn');
				return;
			}

			getCompanyFromAgencyProfileId(companyAgencyProfileId)
				.then(companyObj => {

				edpTopicService.clearCache(companyObj.AgencyProfileID);

				// Store company in state storage
				addCompanyToStorage(companyObj, toParamsObj);

				// Load company
				onComplete(companyObj);
			});
		});
	}

	function setCompaniesStorageFromSessionStorage (storedCompaniesObj) {

		angular.extend(COMPANIES_STORAGE, storedCompaniesObj);

		saveCompaniesStorage();
	}

	function setupApp (userObj, customisationObj) {

		return $q(onComplete => {

			// Attach customisation to session
			session.setCustomisation($filter('customisation')(customisationObj));

			// Warn in case user is not associated to a parent company
			if (userObj.AgencyProfileID === config.guidEmpty) {
				$rootScope.paycircleMessage('Paycircle: User is not associated to a parent company', 'warn');
			}

			angular.extend($rootScope, {
				isLoggedIn: true,
				currentUser: userObj
			});

			// Load Intercom
			intercomService.loadIntercom(userObj, customisationObj);

			// Setup user for Coralogix
			coralogixService.setUser(userObj);

			// Initialise Pendo
			pendoService.initialize(userObj);

			// Optional tracking
			if (userObj.trackingEvent !== undefined) {
				tracking.trackEvent(userObj.trackingEvent);
			}

			onComplete(userObj);
		});
	}

	function setupDefaults () {
		angular.extend($rootScope, {
			companies: [],
			currentCompany: null,
			currentUser: null,
			isCompanyMessageBarActive: false,
			isDocument: false,
			isLoggedIn: false,
			isPaycircleAdmin: false,
			isStateFullPage: false,
			isStatePublic: true,
			showPaycircleTools: true,
			stateClasses: [],
			stateTitle: config.appTitle,
		});
	}

	function setupState (stateObj, companyObj) {

		return $q((onStateSetupComplete, onUserUnauthenticated) => {

			let {event, toState, toParams, authenticated, isLoginPage, isStatePublic} = stateObj;

			let authorised = false;

			angular.merge($rootScope, {
				isDocument: applicationService.isStateDocument(toState),
				isLoggedIn: authenticated,
				isStateFullPage: applicationService.isStateFullPage(toState),
				isCompanyMessageBarActive: applicationService.isStateCompanyMessageBarActive(toState),
				isStatePublic: isStatePublic,
				stateTitle: applicationService.getStateTitle(toState, companyObj),
			});

			// Save state tag in Coralogix
			coralogixService.setState(toState);

			// Checks for non-public pages only
			if (!isStatePublic) {

				// Only check authorised if logged in
				if (authenticated) {

					// Set authorised flag
					authorised = securityService.isUserAuthorised(toState, session.user);
				}

				// Actions for unauthenticated user
				if (!authenticated && !isLoginPage) {

					// Prevent unauthenticated page from loading
					event.preventDefault();

					// Go to login page
					onUserUnauthenticated();
				}

				// Actions for unauthorised user
				if (authenticated && !authorised) {

					// Prevent unauthorised page from loading
					event.preventDefault();

					// Broadcast that user is not authorised
					$rootScope.$broadcast(AUTH_EVENTS.notAuthorised);

					// Log user out if they don't have access to the default page
					if (toState.name === session.user.defaultLandingPage) {
						onUserUnauthenticated();
						return;
					}

					// Forward to default page for user
					applicationService.goToDefaultLandingPageForUser(session.user);
				}

				// Add state to sessionstorage
				if (authenticated && authorised) {
					session.updateSessionData({
						state: {
							name: toState.name,
							params: angular.copy(toParams)
						}
					});
				}

			} else {

				// Setup customisation for public pages
				if (!session.customisation && !authenticated) {
					customisationService.loadCustomisationPublic(toParams);
				}
			}

			// If login page navigate to user roles default page
			if (authenticated && isLoginPage) {

				// Prevent unauthorised page from loading
				event.preventDefault();

				// Slack integration
				if (utilities.isValidGuid(toParams.state)) {
					customisationService.setupSlackAuthentication(toParams);
					return;
				}

				// Forward to default landing page for user
				applicationService.goToDefaultLandingPageForUser(session.user);
			}

			if (companyObj && toState.data) {

				// Redirect to different state based on a flag on the company
				if (toState.data.companyFlagRedirect) {
					assessCompanyRedirect(companyObj, event, toState.data.companyFlagRedirect)
						.then(onStateSetupComplete);
				}

				// Redirect to different state based on the users role
				if (toState.data.userRoleRedirect) {
					assessRoleRedirect(companyObj, event, toState.data.userRoleRedirect)
						.then(onStateSetupComplete);
				}
			}

			// Setup page for company
			onStateSetupComplete(companyObj);
		});
	}

	function setupUser (userObj) {

		return $q(onComplete => {

			// Store fallback token
			securityService.storeToken(userObj.UserResponseAuthString);

			// Store customisation id
			utilities.addToStorage(LOCAL_STORAGE_KEYS.brandId, userObj.AgencyProfileCustomisationID);

			// Store login type when updated
			if (userObj.loginType) {
				utilities.addToStorage(LOCAL_STORAGE_KEYS.loginType, userObj.loginType);
			}

			// Setup user object
			userObj = $filter('userResponse')(userObj);

			// Create users session
			session.create(userObj);

			onComplete(userObj);
		});
	}

	return {
		getPreviousCompanyObj,
		goToPreviousCompany,
		onAuthenticatedLogin,
		onSessionDestroy,
		onStateChange,
		resetCompanyStorage,
		setCompany,
		setCompaniesStorageFromSessionStorage,
		setupDefaults
	};
}]);

'use strict';

angular.module('paycircleApp')
.service('statutoryPaymentService', [
	'utilities',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'STAT_PAYMENT_SCHEDULE_STATES',
	'STATUTORY_PAY_CALCULATION_METHODS',
	'SCHEDULE_UPDATE_REASONS',
	function (
		utilities,
		ADJUSTMENT_BEHAVIOUR_STATES,
		STAT_PAYMENT_SCHEDULE_STATES,
		STATUTORY_PAY_CALCULATION_METHODS,
		SCHEDULE_UPDATE_REASONS
	) {

	const service = {

		convertAdvanceFundingPaymentsToZeroIfNull: statPaymentObj => {

			if (statPaymentObj.AdvanceFunding && statPaymentObj.AdvanceFunding.length) {
				statPaymentObj.AdvanceFunding.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfNull(paymentObj.PaymentAmount);
				});
			}
		},

		convertAdvanceFundingPaymentsToEmptyIfZero: statPaymentObj => {

			if (statPaymentObj.AdvanceFunding && statPaymentObj.AdvanceFunding.length) {
				statPaymentObj.AdvanceFunding.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentObj.PaymentAmount);
				});
			}
		},

		convertBroughtForwardPaymentsToEmptyIfZero: statPaymentObj => {

			if (statPaymentObj.PaymentsBroughtForward && statPaymentObj.PaymentsBroughtForward.length) {
				statPaymentObj.PaymentsBroughtForward.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentObj.PaymentAmount);
				});
			}
		},

		convertBroughtForwardPaymentsToZeroIfEmpty: statPaymentObj => {

			if (statPaymentObj.PaymentsBroughtForward && statPaymentObj.PaymentsBroughtForward.length) {
				statPaymentObj.PaymentsBroughtForward.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfEmpty(paymentObj.PaymentAmount);
				});
			}
		},

		convertSalaryPaymentsToEmptyIfZero: statPaymentObj => {

			if (statPaymentObj.SalaryPayments && statPaymentObj.SalaryPayments.length) {
				statPaymentObj.SalaryPayments.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentObj.PaymentAmount);
				});
			}
		},

		convertSalaryPaymentsToZeroIfEmpty: statPaymentObj => {

			if (statPaymentObj.SalaryPayments && statPaymentObj.SalaryPayments.length) {
				statPaymentObj.SalaryPayments.forEach(paymentObj => {
					paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfEmpty(paymentObj.PaymentAmount);
				});
			}
		},

		filterCancelledPayments: (paymentObj) => {

			return !paymentObj.IsCancelled;
		},

		getIsStatPaymentSalarySacrificeReadOnly: sicknessPayObj => {

			switch (sicknessPayObj.SalarySacrificeBehaviour) {

				case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
				case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
					return true;
			}

			return false;
		},

		getPageStateForStatus (statPaymentStatus) {

			switch (statPaymentStatus) {
				case STAT_PAYMENT_SCHEDULE_STATES.ready:
					return 'ready';
				case STAT_PAYMENT_SCHEDULE_STATES.dateDetailsMissing:
					return 'date-details-missing';
				case STAT_PAYMENT_SCHEDULE_STATES.payeDetailsMissing:
					return 'paye-details-missing';
				case STAT_PAYMENT_SCHEDULE_STATES.duplicatePaymentSchedule:
					return 'duplicate-payment-schedule';
				case STAT_PAYMENT_SCHEDULE_STATES.earningsInsufficient:
				case STAT_PAYMENT_SCHEDULE_STATES.earningsPartiallyInsufficient:
				case STAT_PAYMENT_SCHEDULE_STATES.partialScheduleLengthError:
				case STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient:
				case STAT_PAYMENT_SCHEDULE_STATES.continuousEmploymentInsufficient:
					return 'not-eligible';
				case STAT_PAYMENT_SCHEDULE_STATES.payrollHasRun:
					return 'payroll-has-run';
				default:
					return 'error';
			}
		},

		getIsEligibilityIndependentOfEarnings (statPaymentStatus) {

			// Employment-based ineligibility (missing/insufficient employment details) can't be
			// resolved by entering earnings, unlike earningsInsufficient/earningsPartiallyInsufficient.
			switch (statPaymentStatus) {
				case STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient:
				case STAT_PAYMENT_SCHEDULE_STATES.continuousEmploymentInsufficient:
					return true;
			}

			return false;
		},

		getPayPeriodIdForUpdateReasonType (statPayObj) {

			switch (statPayObj.updateReason) {
				case SCHEDULE_UPDATE_REASONS.IsLeaving:
				case SCHEDULE_UPDATE_REASONS.Redundancy:
					return statPayObj.lastPaymentPeriodId;
				default:
					return;
			}
		},

		getPendingPaymentsForSchedule: (maternityPayObj) => {

			let pendingPaymentsArr = [];

			pendingPaymentsArr = maternityPayObj.SchedulePayments.filter(_ => !_.HasBeenPaid);

			// Filter duplicates if weekly calculation method
			if (maternityPayObj.CalculationMethod === STATUTORY_PAY_CALCULATION_METHODS.weekly) {
				pendingPaymentsArr = utilities.removeDuplicatesFromArrayByObjectProperty(pendingPaymentsArr, 'AgencyPayPeriodID');
			}

			return pendingPaymentsArr;
		},

		getScheduleUpdateOptions: (scheduleType, teamMemberObj) => {

			const optionsObj = {
				isLeaving: {
					label: `${teamMemberObj.Forename} is leaving the company`,
					value: SCHEDULE_UPDATE_REASONS.IsLeaving
				},
				redundancy: {
					label: `${teamMemberObj.Forename} is being made redundant`,
					value: SCHEDULE_UPDATE_REASONS.Redundancy
				},
				returnToWork: {
					label: `${teamMemberObj.Forename} is returning to work early`,
					value: SCHEDULE_UPDATE_REASONS.ReturnToWork
				},
				sharedParentalLeave: {
					label: `${teamMemberObj.Forename} is sharing parental leave with their partner`,
					value: SCHEDULE_UPDATE_REASONS.SharedParentalLeave
				},
				correctGrossPay: {
					label: `Re-enter ${teamMemberObj.Forename}'s gross payments`,
					value: SCHEDULE_UPDATE_REASONS.CorrectGrossPay
				},
				correctStartDate: {
					label: `Re-enter ${teamMemberObj.Forename}'s ${scheduleType} leave start date`,
					value: SCHEDULE_UPDATE_REASONS.CorrectStartDate
				},
				salaryUpdate: {
					label: `${teamMemberObj.Forename}'s pay has changed`,
					value: SCHEDULE_UPDATE_REASONS.SalaryUpdate
				},
				correctEndDate: {
					label: `${teamMemberObj.Forename}'s ${scheduleType} leave is being extended`,
					value: SCHEDULE_UPDATE_REASONS.CorrectEndDate
				},
				isDeceased: {
					label: `${teamMemberObj.Forename} has died`,
					value: SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased
				}
			};

			// Build up a set of schedule change reasons for dropdown selection, using API constants
			switch (scheduleType) {
				case 'maternity':
					return [
						optionsObj.isLeaving,
						optionsObj.redundancy,
						optionsObj.returnToWork,
						optionsObj.sharedParentalLeave,
						optionsObj.correctGrossPay,
						optionsObj.correctStartDate,
						optionsObj.salaryUpdate,
						optionsObj.isDeceased
					];

				case 'paternity':
					return [
						optionsObj.isLeaving,
						optionsObj.redundancy,
						optionsObj.returnToWork,
						optionsObj.correctGrossPay,
						optionsObj.correctStartDate,
						optionsObj.salaryUpdate,
						optionsObj.isDeceased
					];

				case 'sick':
					return [
						optionsObj.isLeaving,
						optionsObj.returnToWork,
						optionsObj.correctGrossPay,
						optionsObj.correctEndDate,
						optionsObj.isDeceased
					];
			}
		},

		reviewEmptyValues: statPayObj => {

			service.convertAdvanceFundingPaymentsToZeroIfNull(statPayObj);
			service.convertBroughtForwardPaymentsToZeroIfEmpty(statPayObj);
			service.convertSalaryPaymentsToZeroIfEmpty(statPayObj);

			statPayObj.TotalBroughtForward = utilities.setPropertyValueToZeroIfEmpty(statPayObj.TotalBroughtForward);
		},

		reviewStatPaymentSalarySacrifice: statPayObj => {

			statPayObj.SalarySacrificeBehaviour = statPayObj.SalarySacrificeState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;
		},

		/*
			Transform schedule payments data for display, depending on the calculation method
			used to get them. For weekly payment schedules, insert a monthly summary payment.
			For each, also calculate the totals of week count and payment amount. Note that no
			hierarchy is created here (payments under parent monthly summary). This is purely
			for display purposes in a flat table.
		 */
		transformStatutoryPaymentsForCalculationMethod: (paymentsArr, calculationMethod) => {

			if (calculationMethod === STATUTORY_PAY_CALCULATION_METHODS.weekly) {

				let returnArr = [];

				paymentsArr.forEach((paymentObj) => {

					let lastPaymentGroupObj = returnArr[returnArr.length > 0 ? returnArr.length - 1 : 0];

					// Add payment to existing payment group
					if (angular.isDefined(lastPaymentGroupObj) && lastPaymentGroupObj.agencyPayPeriodId === paymentObj.AgencyPayPeriodID) {
						lastPaymentGroupObj.payments.push(paymentObj);
						lastPaymentGroupObj.hasBeenPaid &= paymentObj.HasBeenPaid;
						lastPaymentGroupObj.totalPaymentAmount += paymentObj.PaymentAmount;
						lastPaymentGroupObj.totalOccupationalPaymentAmount += paymentObj.OccupationalPaymentAmount;
						lastPaymentGroupObj.payPeriodsCount++;
						return;
					}

					// Create new payment group
					returnArr.push({
						agencyPayPeriodId: paymentObj.AgencyPayPeriodID,
						hasBeenPaid: paymentObj.HasBeenPaid,
						payPeriodDisplay: paymentObj.PayPeriodDisplay,
						totalPaymentAmount: paymentObj.PaymentAmount,
						totalOccupationalPaymentAmount: paymentObj.OccupationalPaymentAmount,
						payPeriodsCount: 1,
						payments: [paymentObj]
					});
				});

				// Now mark payment groups that have any historical payments as historical themselves
				returnArr.forEach(paymentGroup => {
					paymentGroup.IsHistorical = paymentGroup.payments.reduce((accIsHistorical, nextPayment) => {
					  return accIsHistorical || nextPayment.IsHistorical;
					}, false);
				});

				// Payments now grouped by month
				return returnArr;
			}

			// Return payments unmolested
			return paymentsArr;
		}
	};

	return service;

}]);

/*jshint camelcase:false */
 /*jshint camelcase:false */
'use strict';

angular.module('paycircleApp')
.service('storageService', [
	'$rootScope',
	'$state',
	'STATE_STORAGE_CONFIG',
function (
	$rootScope,
	$state,
	STATE_STORAGE_CONFIG
) {

	/* Key for storage of state-specific data - search, etc. This will contain other objects,
       one per state, for holding this information. It's all held in its own object structure
	   so it can be cleared independently of any other session data */
	const STATE_SESSION_KEY = 'stateData';

	const service = {

		addObjectToSessionStorage: (key, obj, hours) => {

			if (service.isStorageAvailable) {
				service.addToSessionStorage(key, JSON.stringify(obj), hours);
			}
		},
		addToSessionStorage: (key, value) => {

			if (service.isStorageAvailable) {
				sessionStorage.setItem(key, value);
			}
		},
		addToSessionStorageForCurrentState: (key, value) => {

			if (service.isStorageAvailable) {

				// Get state storage object
				const stateStorageObj = service.getStateSessionStorage();
				const currentStateName = $state.current.name;

				if (angular.isUndefined(stateStorageObj)) {
					return;
				}

				// Create object for current state if it doesn't exist
				if (angular.isUndefined(stateStorageObj[currentStateName])) {
					stateStorageObj[currentStateName] = {};
				}

				/* If the storage config for the key tells us this is an array, add it to the array stored against this key if it's
				   not already in there */
				if (STATE_STORAGE_CONFIG[key].isArray) {
					// Get the storage array or create new if it doesn't already exist
					let storageArray = angular.isDefined(stateStorageObj[currentStateName][key]) ? stateStorageObj[currentStateName][key] : [];
					// If the value isn't already in there, add it.
					if (!storageArray.includes(value)) {
						storageArray.push(value);
					}
					// Attach the array to the storage object in case it's just been created
					stateStorageObj[currentStateName][key] = storageArray;
				}
				else {
					// Add / replace the data on the the state-specific storage object
					stateStorageObj[currentStateName][key] = value;
				}

				// Finally add the whole state object to session storage
				service.addObjectToSessionStorage(STATE_SESSION_KEY, stateStorageObj);
			}
		},
		clearSessionStorage: () => {

			if (service.isStorageAvailable) {
				sessionStorage.clear();
			}
		},
		clearStateSessionStorage: () => {

			if (service.isStorageAvailable) {
				sessionStorage.removeItem(STATE_SESSION_KEY);
			}
		},
		deleteFromSessionStorage: (key) => {

			if (service.isStorageAvailable) {
				sessionStorage.removeItem(key);
			}
		},
		deleteFromSessionStorageForCurrentState: (key, value) => {

			if (service.isStorageAvailable) {

				// Get state storage object
				const stateStorageObj = service.getStateSessionStorage();
				const currentStateName = $state.current.name;

				// Nothing to do if there's no state storage
				if (angular.isUndefined(stateStorageObj) || angular.isUndefined(stateStorageObj[currentStateName])) {
					return;
				}

				/* If the storage config for the key tells us this is an array, remove it from the array stored against this key if it's
				   not already in there. If value not specified, remove the entire key (whether or not it's an array) */
				if (STATE_STORAGE_CONFIG[key].isArray && angular.isDefined(value)) {
					// Get the storage array or create new if it doesn't already exist
					let storageArray = angular.isDefined(stateStorageObj[currentStateName][key]) ? stateStorageObj[currentStateName][key] : [];
					// If the value isn't already in there, add it.
					const itemIndex = storageArray.indexOf(value);
					if (itemIndex !== -1) {
						storageArray.splice(itemIndex, 1);
					}
					// Attach the array to the storage object in case it's just been created
					stateStorageObj[currentStateName][key] = storageArray;
				}
				else {
					// Remove the data on the the state-specific storage object
					stateStorageObj[currentStateName][key] = undefined;
				}

				// Finally add the whole state object to session storage
				service.addObjectToSessionStorage(STATE_SESSION_KEY, stateStorageObj);
			}
		},
		getFromSessionStorage: (key, defaultObj) => {

			let item = null;

			if (service.isStorageAvailable) {
				item = sessionStorage.getItem(key);
			}

			return item ? item : defaultObj;
		},
		getFromSessionStorageForCurrentState: (key, defaultValue) => {

			let item = null;
			if (service.isStorageAvailable) {

				// Get the storage object for the current state
				const stateStorageObj = service.getStateSessionStorage();
				const currentStateName = $state.current.name;

				if (angular.isDefined(stateStorageObj) && angular.isDefined(stateStorageObj[currentStateName])) {
					item = stateStorageObj[currentStateName][key];
				}
			}

			return item ? item : defaultValue;
		},
		getObjectFromSessionStorage: (key, defaultObj) => {

			defaultObj = angular.isObject(defaultObj) ? JSON.stringify(defaultObj) : defaultObj;

			if (service.isStorageAvailable) {
				return JSON.parse(service.getFromSessionStorage(key, defaultObj));
			}
		},
		/*
			Get session state object. Create it if it doesn't exist. Wipe it if context has changed.
		 */
		getStateSessionStorage: () => {

			if (service.isStorageAvailable) {
				// Get state storage object if there is one. Default to empty object.
				let stateStorageObj = service.getObjectFromSessionStorage(STATE_SESSION_KEY, {});


				if (!$rootScope.currentCompany) {
					return;
				}

				// Get current company context
				const currentContext = $rootScope.currentCompany.AgencyProfileID;
				// If no context (i.e. it's just been created), or context has changed, wipe it out with new context
				if (!stateStorageObj.context || stateStorageObj.context !== currentContext) {
					// New context, new state storage
					stateStorageObj = {
						context: currentContext
					};
					service.addObjectToSessionStorage(STATE_SESSION_KEY, stateStorageObj);
				}

				// Return the overall state object
				return stateStorageObj;
			}
		},
		isStorageAvailable: () => {

			if (angular.isUndefined(typeof(Storage))) {
				$rootScope.paycircleMessage('isStorageAvailable: Unable to add to session storage as storage is not available', 'error');
				return false;
			}

			return true;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('coralogixService', [
	'$filter',
	'$window',
	'config',
	'cookieConsentService',
	'utilities',
	'COOKIE_CONSENT_KEYS',
	'REGEX',
	function (
		$filter,
		$window,
		config,
		cookieConsentService,
		utilities,
		COOKIE_CONSENT_KEYS,
		REGEX
	) {

	let CoralogixRum = $window.CoralogixRum;
	let isInitialised = false;

	const service = {

		initCoralogix: () => {

			if (!config.coralogixEnabled || isInitialised) {
				return;
			}

			// Re-fetch if not yet captured (SDK may load asynchronously)
			if (!angular.isDefined(CoralogixRum)) {
				CoralogixRum = $window.CoralogixRum;
			}

			if (!angular.isDefined(CoralogixRum)) {
				return;
			}

			try {
				CoralogixRum.init({
					public_key: config.coralogixPublicKey,
					application: 'Paycircle-Payroll',
					version: config.version,
					coralogixDomain: 'EU2',
					environment: utilities.getAppEnvironmentKey(),
					instrumentations: {
						resources: false,
						long_tasks: false,
						interactions: false,
						web_vitals: {
							metrics: {
								tbt: true
							}
						}
					}
				});
				isInitialised = true;
			} catch (e) {
				console.error('Coralogix initCoralogix error:', e);
			}
		},

		noticeError: (error, customAttributes) => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				CoralogixRum.log(error.message || String(error), 'error', customAttributes);
			} catch (e) {
				console.error('Coralogix noticeError error:', e);
			}
		},

		logMessage: (message, options) => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				const level = (options && options.level) ? options.level : 'info';
				CoralogixRum.log(message, level);
			} catch (e) {
				console.error('Coralogix logMessage error:', e);
			}
		},

		isCoralogixActive: () => {

			if (!config.coralogixEnabled) {
				return false;
			}

			if (!cookieConsentService.hasConsent(COOKIE_CONSENT_KEYS.categories.analytics, COOKIE_CONSENT_KEYS.analytics.cx)) {
				return false;
			}

			if (!angular.isDefined(CoralogixRum)) {
				CoralogixRum = $window.CoralogixRum;
			}
			if (!angular.isDefined(CoralogixRum)) {
				return false;
			}

			// Active for all environments except localhost
			return !utilities.isEnvironmentLocalhost;
		},

		setCompany: currentCompanyObj => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				const companyTypeDescription = $filter('companyTypeDescription')(currentCompanyObj.CompanyType);

				CoralogixRum.setLabels({
					company_id: currentCompanyObj.AgencyProfileID,
					company_name: currentCompanyObj.Name,
					company_size: String(currentCompanyObj.TeamMemberCount),
					company_type: companyTypeDescription
				});
			} catch (e) {
				console.error('Coralogix setCompany error:', e);
			}
		},

		setState: toStateObj => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				CoralogixRum.setLabels({
					state: toStateObj.name,
					state_parent: toStateObj.name.split('.')[0]
				});
			} catch (e) {
				console.error('Coralogix setState error:', e);
			}
		},

		setCustomAttribute: (tagName, tagValue) => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				var labels = {};
				labels[tagName] = String(tagValue);
				CoralogixRum.setLabels(labels);
			} catch (e) {
				console.error('Coralogix setCustomAttribute error:', e);
			}
		},

		addToTrace: (traceObj) => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				const message = traceObj.message || '';
				const labels = {};
				if (traceObj.category) {
					labels.category = traceObj.category;
				}
				CoralogixRum.log(message, 'info', labels);
			} catch (e) {
				console.error('Coralogix addToTrace error:', e);
			}
		},

		setUser: currentUserObj => {

			if (!service.isCoralogixActive()) {
				return;
			}

			try {
				const isUsernameEmail = REGEX.email.test(currentUserObj.UserResponseUsername);

				CoralogixRum.setUserContext({
					user_id: currentUserObj.UserResponseUserID,
					user_name: currentUserObj.UserResponseUsername,
					user_email: isUsernameEmail ? currentUserObj.UserResponseUsername : ''
				});

				CoralogixRum.setLabels({
					user_id: currentUserObj.UserResponseUserID,
					user_username: currentUserObj.UserResponseUsername,
					user_email: isUsernameEmail ? currentUserObj.UserResponseUsername : '',
					user_session_start: moment().format(config.dateTimeFormatPrimary),
					user_company: currentUserObj.AgencyProfileName,
					user_is_logged_in: 'true',
					user_is_paycircle_admin: String(currentUserObj.isPaycircleAdmin),
					user_primary_role: utilities.getPrimaryRole(currentUserObj.UserResponseRoles)
				});
			} catch (e) {
				console.error('Coralogix setUser error:', e);
			}
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('supportService', ['$filter', function ($filter) {

	const service = {

		// Normalise categories and add 'special' categories
		decorateSupportCategories: (categoriesArr) => {

			const HELP_AND_SUPPORT_CATEGORY_ID = 0;

			/* Sum up article counts for each category, including those in subcategories. Wordpress provides counts for each category
			without taking into account subcategories and their subcategories and their subcategories and ... etc. */
			const countSupportArticlesForCategory = (categoriesArr, categoryId) => {

				// Find the category with the specified ID
				const category = categoriesArr.find(category => category.id === categoryId);

				// Find all child categories
				const childCategories = categoriesArr.filter(childCategory => childCategory.parentId === category.id);

				// For each child category, recall this, so the child counts are up-to-date before the parent sum them
				childCategories.forEach(childCategory => {
					// Recall this function for each child category
					countSupportArticlesForCategory(categoriesArr, childCategory.id);
				});

				// Now the child counts have been updated, sum up the article counts for this category
				childCategories.forEach(childCategory => {
					category.articleCount += childCategory.articleCount;
				});
			};

			// Start by creating the implicit top-level 'Help and Support' category to form the parent of all top-level categories
			const supportCategories = [{
				description: 'All Help and Support Categories',
				icon: 'icon-help',
				id: HELP_AND_SUPPORT_CATEGORY_ID,
				name: 'Help and Support',
				// This will be updated shortly
				articleCount: 0
			}];

			// Add categories retrieved from WordPress, after 'normalising' them so they're a little more palatable.
			categoriesArr.forEach(category => {
				// Normalise the support category. This will return nothing if the category is marked as 'private'
				const normalisedSupportCategory = service.normaliseSupportCategory(category);
				if (angular.isDefined(normalisedSupportCategory)) {
					supportCategories.push(normalisedSupportCategory);
				}
			});

			// Get complete article counts for each category, starting at the top
			countSupportArticlesForCategory(supportCategories, HELP_AND_SUPPORT_CATEGORY_ID);

			return supportCategories;
		},

		// Get support article tags for a specified form key
		getHelpAndSupportTagsForSlideInForm: (slideInFormKey) => {

			// Map form keys to article tags here. @todo - decide on (slide in form key -> help and support tags) mappings
			switch (slideInFormKey) {
				case 'company-settings-authentication-tfa':
					return ['bureau-access'];
			}

			return undefined;
		},

		getMetaTagsForSupportArticle: (articleObj) => {
			const metaTags = [];

			// Reading time
			if (articleObj.readingTime) {
				metaTags.push({
					icon: 'icon-clock',
					theme: 'is-primary-400',
					text: articleObj.readingTime
				});
			}
			// Support video running time
			if (articleObj.supportVideoRunningTime) {
				metaTags.push({
					icon: 'icon-play',
					theme: 'is-primary-300',
					text: articleObj.supportVideoRunningTime
				});
			}

			return metaTags;
		},

		// Get metatags for different post types (articles and guides)
		getMetaTagsForPost: (postObj, isDateIncluded) => {

			isDateIncluded = angular.isDefined(isDateIncluded) ? isDateIncluded : false;

			let returnArr = [];

			// Reading time
			if (angular.isDefined(postObj.readingTime)) {

				returnArr.push({
					icon: 'icon-clock',
					theme: 'is-primary-400',
					text: postObj.readingTime
				});
			}

			if (angular.isDefined(postObj.videoId) && postObj.supportVideoId !== '') {

				// Demo Video ...
				returnArr.push({
					icon: 'icon-play',
					theme: 'is-primary-300',
					text: postObj.supportVideoRunningTime
				});
			}
			else if (angular.isDefined(postObj.videoCount)) {

				// If no demo video, see if there's a video count
				returnArr.push({
					icon: 'icon-play',
					theme: 'is-primary-300',
					text: postObj.videoCount === 1 ? '1 video' : `${postObj.videoCount} videos`
				});
			}

			// Date
			if (isDateIncluded) {

				returnArr.push({
					icon: null,
					theme: null,
					text: $filter('dateformat')(postObj.date, 'long')
				});
			}

			return returnArr;
		},

		getTotalArticleCountForCategories: (categoriesArr) => {

			let totalCount = 0;

			categoriesArr.forEach(categoryObj => {
				totalCount += categoryObj.count;
			});

			return totalCount;
		},

		groupAndSortSupportArticlesByLastUpdated: (supportArticlesArr) => {

			// Sort articles by last updated, most recent first
			supportArticlesArr.sort((articleA, articleB) => {
				return moment(articleA.lastUpdated).isBefore(moment(articleB.lastUpdated)) ? 1 : -1;
			});

			// Top level object including the overall count
			const supportArticlesGrouped = {
				articleCount: supportArticlesArr.length,
				articleGroups: []
			};

			// Group latest support articles by month
			supportArticlesArr.forEach(article => {
				// Get the published date as a date
				const lastUpdated = moment(article.lastUpdated);
				// See if there's already a group for the month of this update
				let articleGroup = supportArticlesGrouped.articleGroups.find(articleGroup => {
					return lastUpdated.month() === articleGroup.month && lastUpdated.year() === articleGroup.year;
				});
				// Greate new group as necessary
				if (!articleGroup) {
					articleGroup = {
						articles: [],
						month: lastUpdated.month(),
						year: lastUpdated.year(),
						title: lastUpdated.format('MMM YYYY')
					};
					supportArticlesGrouped.articleGroups.push(articleGroup);
				}
				// Add the article to the group
				articleGroup.articles.push(article);
			});

			return supportArticlesGrouped;
		},

		sortSupportArticles: (supportArticlesArr) => {

			// Sort the articles, then 'normalise' each
			supportArticlesArr = supportArticlesArr.sort((supportArticleA, supportArticleB) => {
				/* Sort the posts by video ID; null equates to '' and '' goes to the end of the list. So articles with
				   videos are at the top of the list. If there's an easy, non-convoluted and reliable way to do this in
				   WordPress, it's yet to be discovered. */
				const supportVideoA = supportArticleA.supportVideoId ? supportArticleA.supportVideoId : '';
				const supportVideoB = supportArticleB.supportVideoId ? supportArticleB.supportVideoId : '';
				if (supportVideoA > supportVideoB) {
					return -1;
				}
				else if (supportVideoA < supportVideoB) {
					return 1;
				}
				else {
					return 0;
				}
			});

			return supportArticlesArr;
		},

		normaliseSupportCategory: (category) => {

			// Get flag to determine if this is a private category. Default to false.
			const isPrivate = angular.isDefined(category.acf.is_private_category) ? category.acf.is_private_category : false;

			// Get flag to determine if this has been defined as a headline category in WordPress. Default to false.
			const isHeadline = angular.isDefined(category.acf.is_headline_category) ?  category.acf.is_headline_category : false;

			// Get stuff for headline articles, default if not available
			let headlineItemSingular;
			let headlineItemPlural;
			let headlineImageName;
			if (isHeadline) {
				headlineItemSingular = category.acf.headline_item_description_singular ? category.acf.headline_item_description_singular.toLowerCase() : 'article';
				headlineItemPlural = category.acf.headline_item_description_plural ? category.acf.headline_item_description_plural.toLowerCase() : 'articles';
				headlineImageName = category.acf.headline_category_image ? category.acf.headline_category_image : 'default_headline';
			}

			return {
				articleCount: category.count,
				description: category.description,
				headlineImageName,
				headlineItemPlural,
				headlineItemSingular,
				icon: angular.isDefined(category.acf.category_icon) ? category.acf.category_icon : 'icon-question-mark',
				id: category.id,
				isHeadline,
				isPrivate,
				name: category.name,
				// Override any parent category for headline categories, just in case. Headline categories should sit under the top level 'Help and Support' pseudo-category
				parentId: isHeadline ? 0 : category.parent,
				slug: category.slug,
				theme: angular.isDefined(category.acf.category_theme) ? category.acf.category_theme : 'is-primary',
				url: category.link
			};
		},

		normaliseSupportGuide: (supportGuide) => {

			let videoCount = 0;
			let supportGuideSections;
			if (supportGuide.acf.user_guide_content) {
				supportGuideSections = [];
				videoCount = supportGuide.acf.user_guide_content.length;
				supportGuide.acf.user_guide_content.forEach(userGuideContent => {
					// if (userGuideContent.user_guide_item.acf) {

					// }
					supportGuideSections.push({
						title: userGuideContent.user_guide_item_title,
						subtitle: userGuideContent.user_guide_item_subtitle,
						videoID: userGuideContent.user_guide_item_video_id
					});
				});
			}

			return {
				date: supportGuide.date,
				icon: supportGuide.acf.user_guide_icon,
				id: supportGuide.id,
				readingTime: supportGuide.acf.reading_time,
				slug: supportGuide.slug,
				supportGuideSections,
				theme: supportGuide.acf.user_guide_theme,
				title: supportGuide.title.rendered,
				videoCount
			};
		},

		normaliseSupportGuides: (supportGuidesArr) => {

			let supportGuidesNormalised = [];
			supportGuidesArr.forEach(supportGuide => {
				supportGuidesNormalised.push(service.normaliseSupportGuide(supportGuide));
			});
			return supportGuidesNormalised;
		},
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('supplementaryPayRunService', [
	'$rootScope',
	'utilities',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$rootScope,
		utilities,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const service = {

		decorateSupplementaryPaymentObj: supplementaryPaymentObj => {

			function getSupplementaryPaymentThemeForState (supplementaryPaymentState) {


				switch (supplementaryPaymentState) {
					case SUBMISSION_STATES.submitted:
						return 'is-primary';
					case SUBMISSION_STATES.failed:
						return 'is-assertive';
					default:
						return 'is-indifferent';
				}
			}

			const distinctUserIds = service.getDistinctUserIdsForSupplementaryPaymentObj(supplementaryPaymentObj);

			angular.extend(supplementaryPaymentObj, {
				canEdit: service.getCanEditPayment(supplementaryPaymentObj),
				/* Attach an array of distinct user IDs for team member count display, as well as for editing. The supplementary pay
				   run form needs to behave according to whether the payment is a bulk payment, or for a single user. In the former case,
				   there will be a number of adjustments for different users, in the latter, one or more adjustments for
				   a single user (singleton userIDs array). In addition, the payment card needs to show a count of distinct users
				   for the supplementary payment. The attached count from the platform represents the total number of adjustments. */
				distinctUserIds,
				showMenu: false,
				theme: getSupplementaryPaymentThemeForState(supplementaryPaymentObj.SupplementaryPaymentState)
			});

			return supplementaryPaymentObj;
		},

		filterSupplementaryPayments: supplementaryPaymentObj => {

			supplementaryPaymentObj = service.decorateSupplementaryPaymentObj(supplementaryPaymentObj);

			// Only show Submitted pay runs for CAL or GAL roles
			if ($rootScope.userHasRole([
				USER_ROLES.companyadministratorlite,
				USER_ROLES.groupadminlite
			])) {

				if (supplementaryPaymentObj.SupplementaryPaymentState !== SUBMISSION_STATES.submitted) {
					return;
				}
			}

			return supplementaryPaymentObj;
		},

		getCanEditPayment: supplementaryPaymentObj => {

			// Submitted
			if (supplementaryPaymentObj.SupplementaryPaymentState === SUBMISSION_STATES.submitted) {
				return false;
			}

			return true;
		},

		getDistinctUserIdsForSupplementaryPaymentObj: supplementaryPaymentObj => {

			let returnUserIds = supplementaryPaymentObj.SupplementaryPaymentElements.map(adjustment => adjustment.UserID);

			returnUserIds = returnUserIds.concat(supplementaryPaymentObj.StartersToSubmit, supplementaryPaymentObj.LeaversToSubmit);

			// Remove duplicate user ID's, as the same user can be in payments and starters or leavers
			return utilities.removeDuplicatesFromArrayOfStrings(returnUserIds);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('tabService', [
	'$filter',
	'$rootScope',
	'securityService',
	'utilities',
	'INTERFACE_TYPES',
	'PAYROLL_MOVE_STATUSES',
	'TAB_KEYS',
	function (
		$filter,
		$rootScope,
		securityService,
		utilities,
		INTERFACE_TYPES,
		PAYROLL_MOVE_STATUSES,
		TAB_KEYS
	) {

	const service = {

		/* Convenience function for tidiness. sref is optional, since some tabs don't change state, they invoke functions instead.
		   landingPriority is optional: when set it ranks the tab for default-landing selection (see getDefaultTab); it has no
		   bearing on display order, which is simply the order tabs are added. */
		addTab: (tabs, id, label, sref, landingPriority) => {

			const tab = { id, label, sref };

			if (angular.isDefined(landingPriority)) {
				tab.landingPriority = landingPriority;
			}

			tabs.push(tab);
		},

		addTabWithCondition: (tabs, id, label, sref, condition, landingPriority) => {
			if (condition) {
				service.addTab(tabs, id, label, sref, landingPriority);
			}
		},

		/* Choose which tab to land on by default: the highest-priority (lowest landingPriority number) tab out of those
		   present/visible in the given tab bar def. Tabs added without a landingPriority are ignored. Non-mutating, so the
		   display order of tabBarDef.tabs is preserved. Returns undefined when no prioritised tab is available. */
		getDefaultTab: (tabBarDef) => {

			return tabBarDef.tabs
				.filter(tab => angular.isDefined(tab.landingPriority))
				.reduce((highest, tab) => (!highest || tab.landingPriority < highest.landingPriority) ? tab : highest, null);
		},

		// Check context for specified attributes. Report any that are missing and return false in that case.
		checkContext: (tabKey, context, attributes) => {

			// Start out with a distinct air of optimism
			let allPresentAndCorrect = true;

			// Get set of attributes in the context object and check against expected attributes
			const contextAttributes = Object.keys(context);
			attributes.forEach(attribute => {

				// Is the required attribute in the context?
				if (!contextAttributes.includes(attribute)) {
					$rootScope.paycircleMessage(`tabService.js > : missing context attribute ${attribute} for ${tabKey} tab key`, 'warn');
					allPresentAndCorrect = false;
				}
			});
			return allPresentAndCorrect;
		},

		// Get tabs for specified TAB_KEYS constant. Include optional context for checking visibility of individual tabs.
		getTabsForKey: (tabKey, context) => {

			let tabBarDef = {
				id: tabKey
			};
			let tabs;

			switch (tabKey) {
				case TAB_KEYS.payroll.currentPeriod.id: {
					tabs = service.getTabsForCurrentPeriod(context);
					break;
				}
				case TAB_KEYS.payroll.history.id: {
					tabs = service.getTabsForHistory();
					break;
				}
				case TAB_KEYS.payroll.supplementaryPayRun.id: {
					tabs = service.getTabsForSupplementaryPayRun(context);
					break;
				}
				case TAB_KEYS.settings.access.id: {
					tabs = service.getTabsForSettingsAccess();
					break;
				}
				case TAB_KEYS.settings.bacsDownloads.id: {
					tabs = service.getTabsForSettingsBacsDownloads();
					break;
				}
				case TAB_KEYS.settings.businessCategories.id: {
					tabs = service.getTabsForSettingsBusinessCategories(context);
					break;
				}
				case TAB_KEYS.settings.customisation.id: {
					tabs = service.getTabsForSettingsEmployeePortal();
					break;
				}
				case TAB_KEYS.settings.imports.id: {
					tabs = service.getTabsForSettingsImports();
					break;
				}
				case TAB_KEYS.settings.journals.id: {
					tabs = service.getTabsForSettingsJournals(context);
					break;
				}
				case TAB_KEYS.settings.payElements.id: {
					tabs = service.getTabsForSettingsPayElements(context);
					break;
				}
				case TAB_KEYS.settings.reports.id: {
					tabs = service.getTabsForSettingsReports();
					break;
				}
				case TAB_KEYS.team.profile.id: {
					tabs = service.getTabsForTeamProfile(context);
					break;
				}
				case TAB_KEYS.team.archivedProfile.id: {
					tabs = service.getTabsForTeamArchivedProfile(context);
					break;
				}
				case TAB_KEYS.settings.genderPayGap.id: {
					tabs = service.getTabsForReportingGenderPayGap();
					break;
				}
				default: {
					// Tabs not found
					tabs = [];
				}
			}

			// Add tabs to tab bar def and return
			angular.extend(tabBarDef, { tabs });
			return tabBarDef;
		},

		getTabsForCurrentPeriod: (context) => {

			let tabs = [];
			if (service.checkContext(TAB_KEYS.payroll.currentPeriod, context, ['permissions'])) {
				const permissions = context.permissions;
				const currentCompany = $rootScope.currentCompany;

				/* The order below is the display order. The 6th argument is the landing priority (1 = highest) used to pick
				   the default tab to land on: Changes, then Team, then the remaining tabs in display order. */
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.changes, 'Changes', 'payroll.current-period.changes',
					permissions.isChangesVisible, 1);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.notes, 'Notes', 'payroll.current-period.notes',
					permissions.isNotesVisible, 3);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.tasks, 'Tasks', 'payroll.current-period.tasks',
					permissions.isTasksVisible, 4);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.team, 'Team', 'payroll.current-period.team',
					permissions.isTeamVisible, 2);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.pensions, 'Pensions', 'payroll.current-period.pensions',
					permissions.isPensionVisible && currentCompany.IsPensionActive, 5);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.imports, 'Imports', 'payroll.current-period.imports',
					permissions.isImportsVisible, 6);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.taxUpdates, 'Tax Updates', 'payroll.current-period.tax-updates',
					permissions.isTaxUpdatesVisible, 7);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.currentPeriod.tabs.alerts, 'Alerts', 'payroll.current-period.alerts',
					permissions.isAlertsVisible, 8);
			}
			return tabs;
		},

		getTabsForHistory: () => {

			const currentCompany = $rootScope.currentCompany;

			const agencyProfileId = currentCompany.AgencyProfileID;

			let tabs = [];

			service.addTab(tabs, TAB_KEYS.payroll.history.tabs.payPeriods, 'History', `payroll.history.pay-periods({agencyProfileId: '${agencyProfileId}'})`);
			service.addTab(tabs, TAB_KEYS.payroll.history.tabs.supplementaryPayRuns, 'Supplementary pay runs', `payroll.history.supplementary-pay-runs({agencyProfileId: '${agencyProfileId}'})`);

			return tabs;
		},

		getTabsForReportingGenderPayGap: () => {

			let tabs = [];
			// These tabs invoke functions, not state changes.
			service.addTab(tabs, TAB_KEYS.settings.genderPayGap.tabs.hourlyBonusPay, 'Hourly/Bonus pay', '');
			service.addTab(tabs, TAB_KEYS.settings.genderPayGap.tabs.teamMembers, 'Team members', '');
			return tabs;
		},

		getTabsForSupplementaryPayRun: (context) => {

			let tabs = [];

			if (service.checkContext(TAB_KEYS.payroll.supplementaryPayRun, context, ['permissions'])) {

				const permissions = context.permissions;
				const currentCompany = $rootScope.currentCompany;

				const agencyProfileId = currentCompany.AgencyProfileID;

				service.addTabWithCondition(tabs, TAB_KEYS.payroll.supplementaryPayRun.tabs.reports, 'Reports', `payroll.supplementary-pay-run.reports({agencyProfileId: '${agencyProfileId}'})`,
					permissions.isReportsVisible, 1);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.supplementaryPayRun.tabs.changes, 'Changes', `payroll.supplementary-pay-run.changes({agencyProfileId: '${agencyProfileId}'})`,
					permissions.isChangesVisible, 2);
				service.addTabWithCondition(tabs, TAB_KEYS.payroll.supplementaryPayRun.tabs.receipts, 'Receipts', `payroll.supplementary-pay-run.receipts({agencyProfileId: '${agencyProfileId}'})`,
					permissions.isReceiptsVisible, 3);
			}
			return tabs;
		},

		getTabsForSettingsAccess: () => {

			const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

			let tabs = [];
			service.addTab(tabs, TAB_KEYS.settings.access.tabs.ipManagement, 'IP Management', `settings.bureau.access.ip-management({agencyProfileId: '${agencyProfileId}'})`);
			service.addTab(tabs, TAB_KEYS.settings.access.tabs.authentication, 'Authentication', `settings.bureau.access.authentication({agencyProfileId: '${agencyProfileId}'})`);
			return tabs;
		},

		getTabsForSettingsBacsDownloads: () => {

			let tabs = [];
			// These tabs invoke functions, not state changes.
			service.addTab(tabs, TAB_KEYS.settings.bacsDownloads.tabs.available, 'Available', '');
			service.addTab(tabs, TAB_KEYS.settings.bacsDownloads.tabs.pending, 'Pending', '');
			service.addTab(tabs, TAB_KEYS.settings.bacsDownloads.tabs.processed, 'Processed', '');
			return tabs;
		},

		getTabsForSettingsEmployeePortal: () => {

			let tabs = [];
			// These tabs invoke functions, not state changes.
			service.addTab(tabs, TAB_KEYS.settings.customisation.tabs.system, 'Payroll', '');
			service.addTab(tabs, TAB_KEYS.settings.customisation.tabs.employeePortal, 'Employee portal', '');
			return tabs;
		},

		getTabsForSettingsBusinessCategories: (contextObj) => {

			const currentCompany = $rootScope.currentCompany;
			const agencyProfileId = currentCompany.AgencyProfileID;

			let tabs = [];

			// Make sure categories are in a consistent order
			contextObj.businessCategories.sort(utilities.comparator('BusinessCategoryNumber'));

			contextObj.businessCategories.forEach(businessCategoryObj => {

				service.addTab(
					tabs,
					businessCategoryObj.BusinessCategoryID,
					businessCategoryObj.BusinessCategoryName,
					`settings.company.business-categories.category({agencyProfileId: '${agencyProfileId}', categoryId: '${businessCategoryObj.BusinessCategoryID}'})`
				);
			});

			service.addTab(tabs, TAB_KEYS.settings.businessCategories.tabs.imports, 'Imports', `settings.company.business-categories.imports({agencyProfileId: '${agencyProfileId}'})`);

			return tabs;
		},

		getTabsForSettingsJournals: contextObj => {

			const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

			let tabs = [];

			service.addTab(tabs, TAB_KEYS.settings.journals.tabs.nominalCodes, 'Nominal codes', `settings.company.journals.nominal-codes({agencyProfileId: '${agencyProfileId}'})`);
			service.addTab(tabs, TAB_KEYS.settings.journals.tabs.businessCategories, 'Business categories', `settings.company.journals.business-categories({agencyProfileId: '${agencyProfileId}'})`);
			service.addTab(tabs, TAB_KEYS.settings.journals.tabs.imports, 'Imports', `settings.company.journals.imports({agencyProfileId: '${agencyProfileId}'})`);

			service.addTabWithCondition(tabs, TAB_KEYS.settings.journals.tabs.posts, 'Posts', `settings.company.journals.posts({agencyProfileId: '${agencyProfileId}'})`,
					contextObj.accountingIntegrationConnection.IsConnected);

			return tabs;
		},

		getTabsForSettingsImports: () => {

			const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

			let tabs = [];
			service.addTab(tabs, TAB_KEYS.settings.imports.tabs.mappings, 'Mappings', `settings.company.imports.mappings({agencyProfileId: '${agencyProfileId}'})`);
			service.addTab(tabs, TAB_KEYS.settings.imports.tabs.settings, 'Settings', `settings.company.imports.settings({agencyProfileId: '${agencyProfileId}'})`);
			return tabs;
		},

		/*
			Get tabs for settings / pay elements.
			context must include:
				adjustmentGroup: associated adjustment group
		 */
		getTabsForSettingsPayElements: (context) => {

			const currentCompany = $rootScope.currentCompany;

			let tabs = [];
			if (service.checkContext(TAB_KEYS.settings.payElements, context, ['adjustmentGroup'])) {
				const adjustmentGroup = context.adjustmentGroup;
				const agencyProfileId = currentCompany.AgencyProfileID;

				// Different tab set for bureau
				if (currentCompany.CompanyType === INTERFACE_TYPES.bureau) {
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.coreElements, 'Core elements', `settings.bureau.pay-elements.core({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.bik, 'Benefits in Kind', `settings.bureau.pay-elements.bik({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.cis, 'CIS', `settings.bureau.pay-elements.cis({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.elementPacks, 'Element packs', `settings.bureau.pay-elements.element-packs({agencyProfileId: '${agencyProfileId}'})`);
				}
				else {
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.additions, 'Additions', `settings.company.pay-elements.additions({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.deductions, 'Deductions', `settings.company.pay-elements.deductions({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.bik, 'Benefits in Kind', `settings.company.pay-elements.bik({agencyProfileId: '${agencyProfileId}'})`);
					// CIS tab is conditional
					service.addTabWithCondition(tabs, TAB_KEYS.settings.payElements.tabs.cis, 'CIS', `settings.company.pay-elements.cis({agencyProfileId: '${agencyProfileId}'})`,
						adjustmentGroup.GroupEntriesCIS.length !== 0 && currentCompany.IsCISActive);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.linkElements, 'Link elements', `settings.company.pay-elements.link-elements({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.payslipLabels, 'Payslip labels', `settings.company.pay-elements.payslip-labels({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.payElements.tabs.disbursements, 'Disbursements', `settings.company.pay-elements.disbursements({agencyProfileId: '${agencyProfileId}'})`);
				}
			}
			return tabs;
		},

		getTabsForSettingsReports: () => {

			const currentCompany = $rootScope.currentCompany;
			const agencyProfileId = currentCompany.AgencyProfileID;

			let tabs = [];
			switch (currentCompany.CompanyType) {
				case INTERFACE_TYPES.bureau: {
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.custom, 'Custom', `settings.bureau.reports.custom({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.standard, 'Standard', `settings.bureau.reports.standard({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.packs, 'Packs', `settings.bureau.reports.packs({agencyProfileId: '${agencyProfileId}'})`);
					break;
				}
				case INTERFACE_TYPES.group: {
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.custom, 'Custom', `settings.group.reports.custom({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.standard, 'Standard', `settings.group.reports.standard({agencyProfileId: '${agencyProfileId}'})`);
					break;
				}
				default: {
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.custom, 'Custom', `settings.company.reports.custom({agencyProfileId: '${agencyProfileId}'})`);
					service.addTab(tabs, TAB_KEYS.settings.reports.tabs.standard, 'Standard', `settings.company.reports.standard({agencyProfileId: '${agencyProfileId}'})`);
					break;
				}
			}
			return tabs;
		},

		getTabsForTeamArchivedProfile: context => {

			const currentCompany = $rootScope.currentCompany;

			let tabs = [];
			if (service.checkContext(TAB_KEYS.team.archivedProfile, context, ['teamMember'])) {
				const teamMember = context.teamMember;
				service.addTab(tabs, TAB_KEYS.team.archivedProfile.tabs.information, 'Information', 'team.profile.information');

				service.addTabWithCondition(tabs, TAB_KEYS.team.archivedProfile.tabs.pension, 'Pension', 'team.profile.pension',
					currentCompany.HasPension && !currentCompany.IsPayslipManagerActive && !teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker);

				service.addTab(tabs, TAB_KEYS.team.archivedProfile.tabs.documents, 'Documents', 'team.profile.documents');
				service.addTabWithCondition(tabs, TAB_KEYS.team.archivedProfile.tabs.history, 'History', 'team.profile.history',
					!currentCompany.IsPayslipManagerActive);
			}
			return tabs;
		},

		getTabsForTeamProfile: (context) => {

			const currentCompany = $rootScope.currentCompany;

			let tabs = [];
			if (service.checkContext(TAB_KEYS.team.profile, context, ['teamMember'])) {
				const teamMember = context.teamMember;
				if (teamMember.IsInSetupMode) {
					let isOnPayrollAndSetupComplete  = teamMember.TeamMemberSetupComplete && !teamMember.Company.IsOffPayrollWorker;

					service.addTab(tabs, TAB_KEYS.team.profile.tabs.overview, 'Setup', 'team.profile.overview');
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.history, 'History', 'team.profile.history',
						!currentCompany.IsPayslipManagerActive);
					service.addTab(tabs, TAB_KEYS.team.profile.tabs.documents, 'Documents', 'team.profile.documents');
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.linkRates, 'Tax Status', 'team.profile.tax-status',
						teamMember.TeamMemberSetupComplete && !teamMember.Company.IsCISSubcontractor);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.linkRates, 'Link rates', 'team.profile.link-rates',
						!currentCompany.IsPayslipManagerActive && isOnPayrollAndSetupComplete);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.schedules, 'Schedules', 'team.profile.schedules',
						!currentCompany.IsPayslipManagerActive && isOnPayrollAndSetupComplete);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.account, 'Account', 'team.profile.account',
						teamMember.Company.IsRegistered);
				}
				else {
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.overview, 'Overview', 'team.profile.overview',
						!currentCompany.IsPayslipManagerActive);
					service.addTab(tabs, TAB_KEYS.team.profile.tabs.information, 'Information', 'team.profile.information');
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.pension, 'Pension', 'team.profile.pension',
						currentCompany.HasPension && !currentCompany.IsPayslipManagerActive && !teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.holiday, 'Holiday', 'team.profile.holiday',
						currentCompany.HasHR && securityService.isUserPermitted('HR.canManageTeamHR', 'tabs') && !currentCompany.IsPayslipManagerActive && !teamMember.Company.IsOffPayrollWorker);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.sickness, 'Sickness', 'team.profile.sickness',
						currentCompany.HasHR && securityService.isUserPermitted('HR.canManageTeamHR', 'tabs') && !currentCompany.IsPayslipManagerActive && !teamMember.Company.IsOffPayrollWorker);
					service.addTab(tabs, TAB_KEYS.team.profile.tabs.documents, 'Documents', 'team.profile.documents');
					service.addTab(tabs, TAB_KEYS.team.profile.tabs.payments, 'Payments', 'team.profile.payments');
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.taxStatus, 'Tax status', 'team.profile.tax-status',
						!teamMember.Company.IsCISSubcontractor && teamMember.Company.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.Outward);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.history, 'History', 'team.profile.history',
						!currentCompany.IsPayslipManagerActive);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.linkRates, 'Link rates', 'team.profile.link-rates',
						!currentCompany.IsPayslipManagerActive && !teamMember.Company.IsOffPayrollWorker);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.schedules, 'Schedules', 'team.profile.schedules',
						!currentCompany.IsPayslipManagerActive && !teamMember.Company.IsOffPayrollWorker);
					service.addTabWithCondition(tabs, TAB_KEYS.team.profile.tabs.account, 'Account', 'team.profile.account',
						teamMember.Company.IsRegistered);
				}
			}
			return tabs;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('taxUpdatesService', [
	'$filter',
	'config',
	'STUDENT_LOAN_PLANS',
	function (
		$filter,
		config,
		STUDENT_LOAN_PLANS
	) {

	const service = {

		/**
		 * Check if Postgraduate Loan option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Postgraduate Loan should be shown
		 */
		canShowPostgraduateLoan: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddPostgraduateLoan || taxObj.PostGraduateLoan;
		},

		/**
		 * Check if Student Loan option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Student Loan should be shown
		 */
		canShowStudentLoan: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddStudentLoan || taxObj.StudentLoan;
		},

		/**
		 * Check if Plan 1 option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Plan 1 should be shown
		 */
		canShowStudentLoanPlan1: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddStudentLoan1 || taxObj.StudentLoanPlan1;
		},

		/**
		 * Check if Plan 2 option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Plan 2 should be shown
		 */
		canShowStudentLoanPlan2: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddStudentLoan2 || taxObj.StudentLoanPlan2;
		},

		/**
		 * Check if Plan 1 and 2 combined option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Plan 1 and 2 should be shown
		 */
		canShowStudentLoanPlan1and2: (teamMemberObj, taxObj) => {
			return service.canShowStudentLoanPlan1(teamMemberObj, taxObj) && service.canShowStudentLoanPlan2(teamMemberObj, taxObj);
		},

		/**
		 * Check if Plan 4 option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Plan 4 should be shown
		 */
		canShowStudentLoanPlan4: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddStudentLoan4 || taxObj.StudentLoanPlan4;
		},

		/**
		 * Check if Plan 5 option should be visible
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxObj - Tax object from teamMember.Tax or similar
		 * @returns {boolean} - true if Plan 5 should be shown
		 */
		canShowStudentLoanPlan5: (teamMemberObj, taxObj) => {
			return teamMemberObj.CanAddStudentLoan5 || taxObj.StudentLoanPlan5;
		},

		/**
		 * Check if Postgraduate Loan option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Postgraduate Loan should be shown
		 */
		canShowPostgraduateLoanForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowPostgraduateLoan(teamMemberObj, { PostGraduateLoan: taxUpdateObj.HasPostGraduateLoan }),

		/**
		 * Check if Student Loan option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Student Loan should be shown
		 */
		canShowStudentLoanForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoan(teamMemberObj, { StudentLoan: taxUpdateObj.HasStudentLoan }),

		/**
		 * Check if Plan 1 option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Plan 1 should be shown
		 */
		canShowStudentLoanPlan1ForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoanPlan1(teamMemberObj, { StudentLoanPlan1: taxUpdateObj.HasStudentLoanPlan1 }),

		/**
		 * Check if Plan 2 option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Plan 2 should be shown
		 */
		canShowStudentLoanPlan2ForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoanPlan2(teamMemberObj, { StudentLoanPlan2: taxUpdateObj.HasStudentLoanPlan2 }),

		/**
		 * Check if Plan 1 and 2 combined option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Plan 1 and 2 should be shown
		 */
		canShowStudentLoanPlan1and2ForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoanPlan1ForTaxUpdate(teamMemberObj, taxUpdateObj) && service.canShowStudentLoanPlan2ForTaxUpdate(teamMemberObj, taxUpdateObj),

		/**
		 * Check if Plan 4 option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Plan 4 should be shown
		 */
		canShowStudentLoanPlan4ForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoanPlan4(teamMemberObj, { StudentLoanPlan4: taxUpdateObj.HasStudentLoanPlan4 }),

		/**
		 * Check if Plan 5 option should be visible for tax updates
		 * @param {object} teamMemberObj - Team member object
		 * @param {object} taxUpdateObj - Tax update object
		 * @returns {boolean} - true if Plan 5 should be shown
		 */
		canShowStudentLoanPlan5ForTaxUpdate: (teamMemberObj, taxUpdateObj) =>
			service.canShowStudentLoanPlan5(teamMemberObj, { StudentLoanPlan5: taxUpdateObj.HasStudentLoanPlan5 }),

		decorateTaxUpdateLog: (taxUpdateLog) => {

			const isAutomaticUpdate = taxUpdateLog.ActionActor === 'HMRC';

			angular.extend(taxUpdateLog, {
				isAutomaticUpdate,
				theme: isAutomaticUpdate ? 'is-secondary' : 'is-primary',
				titleHTML: service.getTaxUpdateLogTitleHtml(taxUpdateLog)
			});
		},

		decorateTaxUpdatesLogs: (taxUpdatesObj) => {

			taxUpdatesObj.LogEntries.forEach(service.decorateTaxUpdateLog);
		},

		getStudentLoanPlanOption (hasPlan1, hasPlan2, hasPlan4, hasPlan5) {

			if (hasPlan1 && hasPlan2) {
				return STUDENT_LOAN_PLANS.plan1and2;
			}
			else if (hasPlan1) {
				return STUDENT_LOAN_PLANS.plan1;
			}
			else if (hasPlan2) {
				return STUDENT_LOAN_PLANS.plan2;
			}
			else if (hasPlan4) {
				return STUDENT_LOAN_PLANS.plan4;
			}
			else if (hasPlan5) {
				return STUDENT_LOAN_PLANS.plan5;
			}
			else {
				return null;
			}
		},

		getTaxUpdateLogTitleHtml: (taxUpdateLog) => {

			/* Build a title for a tax update using the fields indicated. Look away if you're easily offended.
				This is just to embolden the from and to values */
			let titleHTMLParts = [];

			// Title
			if (taxUpdateLog.LogEntryTitle) {
				titleHTMLParts.push(taxUpdateLog.LogEntryTitle);
			}

			// 'From' value
			if (taxUpdateLog.ValueFrom) {
				titleHTMLParts.push(`from <span class="strong">${taxUpdateLog.ValueFrom}</span>`);
			}

			// 'To' value
			if (taxUpdateLog.ValueTo) {

				// Assume the 'to' value includes the effective date in (...) if no effective date field supplied
				let effectiveDateIndex = taxUpdateLog.ValueTo.lastIndexOf('(');
				if (effectiveDateIndex !== -1) {
					titleHTMLParts.push(`to <span class="strong">${taxUpdateLog.ValueTo.substr(0, effectiveDateIndex).trim()}</span>`);
					titleHTMLParts.push(taxUpdateLog.ValueTo.substr(effectiveDateIndex).trim());
				}
				else {
					titleHTMLParts.push(`to <span class="strong">${taxUpdateLog.ValueTo}</span>`);
				}
			}

			// Slap the bits together for the template
			return titleHTMLParts.join(' ');
		},

		decorateTaxUpdate: (taxUpdateObj) => {

			let actionDate = $filter('dateformat')(taxUpdateObj.ActionDateISO, 'custom', 'ddd D MMM, YYYY');
		
			const footerText  = taxUpdateObj.IsAutomaticUpdate ?
				`Received from HMRC on ${actionDate} - Event Sequence No: ${taxUpdateObj.HMRCSequenceNumber}` :
				`Added manually on ${actionDate}`;

			const label = taxUpdateObj.EffectiveDateISO ?
				`Effective: ${$filter('dateformat')(taxUpdateObj.EffectiveDateISO, 'numeric')}` :
				'Setup status';

			const niCode = taxUpdateObj.HasBackdatedNI ?
				`${taxUpdateObj.NICode} (Backdated to ${$filter('dateformat')(taxUpdateObj.BackdatedDateEffectiveISO, 'numericShortYear')})` :
				taxUpdateObj.NICode;

			angular.extend(taxUpdateObj, {
				footerText,
				icon: taxUpdateObj.IsPeriodFinalised ? 'icon-calendar' : 'icon-clock',
				iconTheme: taxUpdateObj.IsPeriodFinalised ? 'is-primary is-light' : 'is-tertiary',
				label,
				niCode,
				taxCode: taxUpdateObj.TaxCode + (taxUpdateObj.TaxCodeW1M1 ? ' ' + config.w1m1Label : '')
			});

			return taxUpdateObj;
		},

		decorateTaxUpdateForCurrentPeriod: (taxUpdateObj) => {

			taxUpdateObj = service.decorateTaxUpdate(taxUpdateObj);
			taxUpdateObj.title = taxUpdateObj.Fullname;

			return taxUpdateObj;
		},

		decorateTaxUpdateForProfile: (taxUpdateObj) => {

			taxUpdateObj = service.decorateTaxUpdate(taxUpdateObj);
			taxUpdateObj.title = taxUpdateObj.EffectiveAgencyPayPeriodDisplay;

			return taxUpdateObj;
		},

		getLatestManualTaxUpdate: (taxUpdates) => {

			const manualTaxUpdates = taxUpdates.filter(taxUpdate => !taxUpdate.IsAutomaticUpdate);
	
			return service.getLatestTaxUpdate(manualTaxUpdates);
		},
	
		getLatestTaxUpdate: (taxUpdates) => {
	
			const sortedTaxUpdates = taxUpdates.sort((dateOne, dateTwo) => {

				if (!dateOne.EffectiveDateISO) {
					return 1;
				}
	
				if (!dateTwo.EffectiveDateISO) {
					return -1;
				}
	
				moment(dateOne.EffectiveDateISO).format('X') - moment(dateTwo.EffectiveDateISO).format('X');
			});

			return sortedTaxUpdates[0];
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('testPromise', ['$http', '$q', '$timeout', 'utilities', 'LOCAL_STORAGE_KEYS', function promise($http, $q, $timeout, utilities, LOCAL_STORAGE_KEYS) {


	function getFileNameFromServiceUrl (serviceName) {

		var words = serviceName.split('/');

		return words[words.length - 1];
	}

	function returnOk (reject) {

		var deferred = $q.defer();

		$timeout(function () {

			if (utilities.getFromStorage(LOCAL_STORAGE_KEYS.testCaseNumber) === -1 || reject === true) {
				deferred.reject('Error');
			}

			deferred.resolve('OK');
		}, 1000);

		return deferred.promise;
	}

	return {

		getTestPromise: function (serviceCall) {

			var deferred = $q.defer();
			var fileName = getFileNameFromServiceUrl(serviceCall);

			// If it's not a get function then return an OK
			if (fileName.toLowerCase().indexOf('get') < 0) {
				deferred.resolve(returnOk());
				return deferred.promise;
			}

			var directory = '/scripts/services/testData/';
			var url = directory + fileName + '.json';

			$timeout(function () {

				$http.get(url).then(function (result) {

					deferred.resolve(result.data);
				})
				.catch(function (error) {
					console.error('Exception in getTestPromise, serviceCall:' + serviceCall + ', error: ' + error);
					deferred.reject(error);
				});

			}, 600);

			return deferred.promise;
		},
		returnSuccess: function (reject) {
			var deferred = $q.defer();

			$timeout(function () {

				if (utilities.getFromStorage(LOCAL_STORAGE_KEYS.testCaseNumber) === -1 || reject === true) {
					deferred.reject('Error');
				}

				deferred.resolve('OK');
			}, 1000);

			return deferred.promise;
		}
	};
}]);

'use strict';

/**
 * @ngdoc Team Service
 * @name paycircleApp.teamService
 * @description
 * # Team Service
 */
angular.module('paycircleApp')
.service('teamService', [
	'$filter',
	'config',
	'pensionService',
	'session',
	'utilities',
	'BUSINESS_TYPES',
	function (
		$filter,
		config,
		pensionService,
		session,
		utilities,
		BUSINESS_TYPES
	) {

	var loggedInUserId = session.getUserId();

	var service = {

		adminFilter: function (adminObj) {

			adminObj.isLoggedInUser = adminObj.UserID === loggedInUserId;

			return adminObj;
		},

		convertTeamMembeAdminsToArray: adminGroupsObj => {
			return Object.entries(adminGroupsObj).reduce((adminGroupsArr, adminGroupObj) => {
				return adminGroupsArr.concat({
					title: adminGroupObj[0].replace('Admins', ' Admins'),
					teamMembers: adminGroupObj[1]
				});
			}, []);
		},

		/**
		 * Decorate an array of team members
		 * @param {array} teamMembersArr - team members array to decorate
		 * @param {object} excludeOptions - set of name / value pairs to check for. All team member objects with at least one matching attribute
		 * 									will be filtered out. Optional.
		 * @param {boolean} expandAdditionalPosts - set to true to expand team members array to include entries for additional posts. Optional. Defaults to false.
		 */
		decorateAndFilterTeamMembers: (teamMembersArr, excludeOptions, expandAdditionalPosts) => {

			// Defaults
			expandAdditionalPosts = angular.isDefined(expandAdditionalPosts) ? expandAdditionalPosts : false;

			// Expand array to create pseudo team member records for additional posts
			if (expandAdditionalPosts) {
				// New array of team members + additional posts
				const teamMembersArrWithAdditionalPosts = [];
				teamMembersArr.forEach(teamMember => {
					/* Adorn team member with target ID and job title (leave empty), for main post (empty guid). Also a unique ID
					   for the post, composite UserID + SalaryPolicyPostID (the latter being empty guid for main post, of course) */
					angular.extend(teamMember, {
						jobTitle: '',
						postId: teamMember.UserID + config.guidEmpty,
						salaryPolicyPostId: config.guidEmpty
					});
					// Push the team member - corresponding to the main post
					teamMembersArrWithAdditionalPosts.push(teamMember);
					// Sort additional posts by job title
					teamMember.AdditionalPosts.sort(utilities.comparator('JobTitle'));
					// Add team member for each additional post, with salary policy post ID in each case set to SalaryPolicyPostID for the post
					teamMember.AdditionalPosts.forEach(additionalPost => {
						const teamMemberForAdditionalPost = angular.copy(teamMember);
						angular.extend(teamMemberForAdditionalPost, {
							jobTitle: additionalPost.JobTitle,
							postId: teamMember.UserID + additionalPost.SalaryPolicyPostID,
							salaryPolicyPostId: additionalPost.SalaryPolicyPostID
						});
						teamMembersArrWithAdditionalPosts.push(teamMemberForAdditionalPost);
					});
				});
				// Finally swap out the team members array with the additional posts version
				teamMembersArr = teamMembersArrWithAdditionalPosts;
			}

			// Do the decoration
			teamMembersArr.forEach(service.decorateTeamMember);

			// Do the filtering
			return utilities.arrayFilterByAttributes(teamMembersArr, excludeOptions);
		},

		decorateTeamMember: teamMemberObj => {

			angular.extend(teamMemberObj, {
				fullname: `${teamMemberObj.Forename} ${teamMemberObj.Surname}`,
				isCompany: teamMemberObj.IsCISSubcontractor && (teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.trust),
				leaveDateUnix: $filter('isoUnix')(teamMemberObj.LeaveDateISO)
			});

			// CIS Companies
			if (teamMemberObj.isCompany) {
				angular.extend(teamMemberObj, {
					cisIconType: teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.trust ? 'rosette' : 'company',
					Forename: teamMemberObj.BusinessDetails.TradingName,
					Surname: ''
				});
			}

		},

		getGenderForTitle: title => {

			switch (title) {

				// Male
				case 'Mr':
				case 'Lord':
				case 'Sir':
				case 'Father':

					return 'Male';

				// Female
				case 'Mrs':
				case 'Miss':
				case 'Ms':
				case 'Lady':
					return 'Female';

				// Don't set
				default:

					return null;
			}
		},

		getTeamMemberEarliestStartDateIso: teamMemberObj => {

			if (teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO === '') {
				return teamMemberObj.Company.StartDateISO;
			}

			const startDateMoment = moment(teamMemberObj.Company.StartDateISO);
			const continuousEmploymentStartDateMoment = moment(teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO);

			if (continuousEmploymentStartDateMoment.isBefore(startDateMoment)) {
				return teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO;
			}

			return teamMemberObj.Company.StartDateISO;
		},

		getPercentComplete: function (teamMember, currentPayPeriod, companyObj) {

			var totalCompletedSteps = 0;
			var totalSteps = 0;

			if (teamMember.Company.IsCISSubcontractor && teamMember.isCompany) {
				totalSteps = 4;
				if (teamMember.CISCompanyDetailsComplete) { totalCompletedSteps++; }
				if (teamMember.CISCompanyContactComplete) { totalCompletedSteps++; }
				if (teamMember.BankSetupComplete) { totalCompletedSteps++; }
				if (teamMember.VerificationSetupComplete) { totalCompletedSteps++; }

			} else {
				totalSteps = currentPayPeriod.IsYTDInformationRequired && !teamMember.Company.IsStarter ? 9 : 8;

				if (teamMember.PersonalSetupComplete) { totalCompletedSteps++; }
				if (teamMember.EmailSetupComplete) { totalCompletedSteps++; }
				if (teamMember.AddressSetupComplete) { totalCompletedSteps++; }
				if (teamMember.TelephoneSetupComplete) {totalCompletedSteps++; }
				if (teamMember.BankSetupComplete) { totalCompletedSteps++; }

				if (teamMember.CompanySetupComplete) { totalCompletedSteps++; }
				if (teamMember.SalarySetupComplete) { totalCompletedSteps++; }
				if (teamMember.StarterSetupComplete && teamMember.Company.IsStarter) { totalCompletedSteps++; }
				if (teamMember.YTDSetupComplete && currentPayPeriod.IsYTDInformationRequired && !teamMember.Company.IsStarter) { totalCompletedSteps++; }
				if (teamMember.TaxSetupComplete && ((teamMember.Company.IsStarter && teamMember.Tax.IsP45Available) || !teamMember.Company.IsStarter)) { totalCompletedSteps++; }

				if (teamMember.Company.IsCISSubcontractor) {
					if (teamMember.BusinessSetupComplete) { totalCompletedSteps++; }
					if (teamMember.VATSetupComplete) { totalCompletedSteps++; }
					if (teamMember.VerificationSetupComplete) { totalCompletedSteps++; }
				}

				if ((companyObj.IsPensionActive && companyObj.HasPension) && !teamMember.Company.IsCISSubcontractor) {

					teamMember.Pensions
						.filter(teamMemberPensionObj =>
							pensionService.isAEPension(teamMemberPensionObj) &&
							!teamMemberPensionObj.PensionIsExcluded &&
							!teamMemberPensionObj.IsGhostPension)
						.forEach(teamMemberPensionObj => {

							totalSteps = totalSteps + 4;

							if (teamMemberPensionObj.CanBeSalarySacrifice) {
								totalSteps++;
							}

							if (teamMemberPensionObj.PensionSchemeSetupComplete) { totalCompletedSteps++; }
							if (teamMemberPensionObj.PensionSetupComplete) { totalCompletedSteps++; }
							if (teamMemberPensionObj.PensionGroupSetupComplete) {

								// Included contributions
								totalCompletedSteps = totalCompletedSteps + 2;

								// Salary Sacrifice
								if (teamMemberPensionObj.CanBeSalarySacrifice) {
									totalCompletedSteps++;
								}
							}
						});
				}
			}

			return ((totalCompletedSteps / totalSteps) * 100);
		}

	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('telemetryLoadedEventState',
function () {
	let state = {
		userLoggedIn: false,
		correlationId: null,
		userLastLoginDate: null,
		userCurrentLoginDate: null
	};

	return {
			
		setState: function (userLoggedIn, correlationId, userLastLoginDate, userCurrentLoginDate) {
			state.userLoggedIn = userLoggedIn;
			state.correlationId = correlationId;
			state.userLastLoginDate = userLastLoginDate;
			state.userCurrentLoginDate = userCurrentLoginDate;
		},
			
		getState: function () {
			return state;
		},

		clearState: function () {
			state.userLoggedIn = false;
			state.correlationId = null;
			state.userLastLoginDate = null;
			state.userCurrentLoginDate = null;
		}
	};
});


'use strict';

angular.module('paycircleApp')
.service('timedCache', [
function () {

	const values = {};
	const timeouts = {};

	const service = {

		add: function (name, value, expirySeconds) {

			// Clear any existing timeout for this name
			if (timeouts[name]) {
				clearTimeout(timeouts[name]);
			}

			// Store the value
			values[name] = value;

			// Set up automatic removal after expiry
			timeouts[name] = setTimeout(function () {
					delete values[name];
					delete timeouts[name];
				}, expirySeconds * 1000);

			// If value is a promise, remove from cache on rejection
			if (value && typeof value.then === 'function') {
				value.catch(function () {
					service.remove(name);
				});
			}
		},

		get: function (name) {

			return values[name];
		},

		remove: function (name) {

			// Clear the timeout if it exists
			if (timeouts[name]) {
				clearTimeout(timeouts[name]);
				delete timeouts[name];
			}

			// Remove the value
			delete values[name];
		},

		getOrFetch: function (name, apiCallFn, expirySeconds) {

			const cachedValue = service.get(name);

			if (cachedValue) {
				return cachedValue;
			}

			const apiResponse = apiCallFn();
			service.add(name, apiResponse, expirySeconds);

			return apiResponse;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('tooltipsService', [
	'$filter',
	'utilities',
	function (
		$filter,
		utilities
	) {

	// Tooltips for import columns, map keyed against import mapping type. Each entry is a map of tooltips for the mapping type.
	const importMappingColumnTooltipsCache = new Map();

	const service = {

		getImportMappingColumnKey: mappingColumnObj => {

			let items = [mappingColumnObj.ImportMappingColumnText, mappingColumnObj.ImportMappingColumnProperty];		
			return utilities.snakeCase(items.join(' '));
		},
		
		getTooltipForAdjustmentType: adjustmentTypeObj => {

			return {
				description: adjustmentTypeObj.AgencyAdjustmentGroupEntryText,
				size: 'is-large',
				tooltipHtml: service.getAdjustmentTypeTreatmentHtmlTemplate(adjustmentTypeObj)
			};
		},

		getTooltipForImportMappingTypeColumn: (mappingColumnsArr, importMappingType, importMappingColumnObj) => {

			// Turn the column text into a key.
			const importMappingColumnKey = service.getImportMappingColumnKey(importMappingColumnObj);

			// Get cached set if available
			let importMappingColumnTooltips;
			if (importMappingColumnTooltipsCache.has(importMappingType)) {
				importMappingColumnTooltips = importMappingColumnTooltipsCache.get(importMappingType);
			}
			else {
				// Build the tooltip map for this mapping type
				importMappingColumnTooltips = new Map();
				mappingColumnsArr.forEach(mappingColumnObj => {
					// Create a key for this mapping column
					const mappingColumnKey = service.getImportMappingColumnKey(mappingColumnObj);

					// Initialise the tooltip
					let importMappingToolip = {
						description: mappingColumnObj.ImportMappingColumnText,
						formats: '',
						notes: ''
					};

					// Use platform formatting if it exists
					if (angular.isDefined(mappingColumnObj.ImportMappingColumnFormat) && mappingColumnObj.ImportMappingColumnFormat !== '') {
						importMappingToolip.formats = mappingColumnObj.ImportMappingColumnFormat;
					}

					// Use platform formatting if it exists
					if (angular.isDefined(mappingColumnObj.ImportMappingColumnNote) && mappingColumnObj.ImportMappingColumnNote !== '') {
						importMappingToolip.notes = mappingColumnObj.ImportMappingColumnNote;
					}

					// Add that to the set of tooltips using the key, if found
					if (angular.isDefined(importMappingToolip)) {
						importMappingColumnTooltips.set(mappingColumnKey, importMappingToolip);
					}
				});
				// Add the whole lot to the cached set so it's available next time without having to go through this rigmarole
				importMappingColumnTooltipsCache.set(importMappingType, importMappingColumnTooltips);
			}

			// Now we have a set, one way or another, so pluck out the required tooltip
			const tooltipObj = importMappingColumnTooltips.get(importMappingColumnKey);

			if (angular.isUndefined(tooltipObj)) {
				return null;
			}

			// No notes or formats
			if (tooltipObj.formats === '' && tooltipObj.notes === '') {
				return null;
			}

			// Generate HTML specifically for imports tooltips
			tooltipObj.tooltipHtml = service.getImportsHtmlTemplate(tooltipObj);

			return tooltipObj;
		},

		getAdjustmentTypeTreatmentHtmlTemplate: adjustmentTypeObj => {

			const fieldList = [
				{
					description: 'Taxable',
					key: 'Taxable'
				},
				{
					description: 'National Insurance',
					key: 'IsNIable'
				},
				{
					description: 'Notional payment',
					key: 'IsNotional'
				},
				{
					description: 'Benefit in kind',
					key: 'IsBIK'
				},
				{
					description: 'Salary sacrifice',
					key: 'IsSalarySacrifice'
				},
				{
					description: 'Net Pay calculation',
					key: 'AgencyAdjustmentGroupEntryNetPayState'
				},
				{
					description: 'Payrolled benefit',
					key: 'AgencyAdjustmentGroupEntryPayrollBIKState'
				},
				{
					description: 'Holiday Pay',
					key: 'AgencyAdjustmentGroupEntryHolidayState'
				},
				{
					description: 'Prorate',
					key: 'AgencyAdjustmentGroupEntryProrateState'
				}
			];

			let returnHtml = '';

			returnHtml += '<div class="tooltip-template is-adjustment-type-treatment" data-cy="tooltips-tooltip-template">';
				returnHtml += '<div class="tooltip-template_section" data-cy="tooltips-tooltip-template-section">';
					returnHtml += '<div class="tag-list is-dark" data-cy="tooltips-tag-list">';

						fieldList.forEach(fieldObj => {

							const propertyBool = adjustmentTypeObj[fieldObj.key];

							const boolActive = propertyBool ? 'is-active' : '';
							const boolTheme = propertyBool ? 'is-indifferent is-alt' : 'is-senary';
							const boolYesNo = $filter('yesNo')(propertyBool);

							returnHtml += `
								<div class="tag-list_item ${boolActive}" data-cy="tooltips-tag-list-item">
									<h6 class="tag-list_item-title" data-cy="tooltips-tag-list-item-title">${fieldObj.description}</h6>
									<div class="tag s ${boolTheme}" data-cy="tooltips-tag">${boolYesNo}</div>
								</div>
							`;
						});

					returnHtml += '</div>';
				returnHtml += '</div>';
				returnHtml += '<div class="tooltip-template_section">';
					returnHtml += '<em class="is-small tooltip-template_text">You can review pension treatment for pay elements by clicking the ‘Manage pay elements’ action in your pension schemes. </em>';
				returnHtml += '</div>';
			returnHtml += '</div>';

			return returnHtml;
		},

		getImportsHtmlTemplate: tooltipObj => {

			let returnHtml = '';

			returnHtml += '<div class="tooltip-template is-import">';

			if (tooltipObj.formats !== '') {
				returnHtml += `
					<div class="tooltip-template_section">
						<p class="tooltip-template_label">Accepted values/format:</p>
						<p class="tooltip-template_text">${tooltipObj.formats}</p>
					</div>
				`;
			}

			if (tooltipObj.notes !== '') {
				returnHtml += `
					<div class="tooltip-template_section">
						<p class="tooltip-template_label">Notes:</p>
						<p class="tooltip-template_text">${tooltipObj.notes}</p>
					</div>
				`;
			}

			returnHtml += '</div>';

			return returnHtml;
		}

	};

	return service;

}]);

/* globals gtag */
/* jshint camelcase:false */
'use strict';

angular.module('paycircleApp')
.service('tracking', [
	'$window',
	'config',
	'cookieConsentService',
	'intercomService',
	'utilities',
	'COOKIE_CONSENT_KEYS',
	function (
		$window,
		config,
		cookieConsentService,
		intercomService,
		utilities,
		COOKIE_CONSENT_KEYS
	) {

	var trackingService = {

		trackCustomData: function (data) {

			if (!config.trackingEnabled || 
				!cookieConsentService.hasConsent(COOKIE_CONSENT_KEYS.categories.essential, COOKIE_CONSENT_KEYS.essential.intercom)) {
				return;
			}

			if (typeof data !== 'object') {
				console.error('trackCustomData: data needs to be an object');
				return;
			}

			intercomService.updateData(data);
		},

		trackEvent: (eventKey, metaDataObj) => {

			if (!config.trackingEnabled) {
				return;
			}

			if (cookieConsentService.hasConsent(COOKIE_CONSENT_KEYS.categories.essential, COOKIE_CONSENT_KEYS.essential.intercom)) {
					intercomService.trackEvent(eventKey, metaDataObj);
				}

			/**
			 * See: https://developers.google.com/analytics/devguides/collection/gtagjs/events
			**/
			if (angular.isDefined(window.gtag) && cookieConsentService.hasConsent(COOKIE_CONSENT_KEYS.categories.analytics, COOKIE_CONSENT_KEYS.analytics.ga)) {

				metaDataObj = angular.extend({
					'event_category': null,
					'event_label': null
				}, metaDataObj);

				gtag('event', eventKey, metaDataObj);

				utilities.debug('Tracking event sent:');
				utilities.debug(metaDataObj, 'log');
			}
		},

		enableGoogleAnalytics: function ()	{
			if (angular.isDefined($window.gtag) && cookieConsentService.hasConsent(COOKIE_CONSENT_KEYS.categories.analytics, COOKIE_CONSENT_KEYS.analytics.ga)) {
				$window.allowGtagCookies();
			}
		}
	};

	return trackingService;
}]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.utilities
 * @description
 * # utilities
 * Service in the paycircleApp.
 */
angular.module('paycircleApp')
.service('utilities', [
	'$document',
	'$filter',
	'$location',
	'$q',
	'$rootScope',
	'$timeout',
	'$window',
	'config',
	'growl',
	'libraries',
	'BROWSER_COMPATIBILITY_LIST',
	'INTERFACE_TYPES',
	'MAIL_TYPES',
	'MEDIA_TYPES',
	'MEDIA_TYPES_SIZES',
	'ONBOARDING_BUREAUS',
	'REGEX',
	'USER_ROLES',
	function (
		$document,
		$filter,
		$location,
		$q,
		$rootScope,
		$timeout,
		$window,
		config,
		growl,
		libraries,
		BROWSER_COMPATIBILITY_LIST,
		INTERFACE_TYPES,
		MAIL_TYPES,
		MEDIA_TYPES,
		MEDIA_TYPES_SIZES,
		ONBOARDING_BUREAUS,
		REGEX,
		USER_ROLES
	) {

	var service = {
		addObjectToStorage: function (key, obj, hours) {

			if (!angular.isObject(obj)) {
				console.warn('Paycircle: Utilities: addObjectToStorage: object not provided');
				return;
			}

			service.addToStorage(key, JSON.stringify(obj), hours);
		},
		addToStorage: function (name, value, hours) {

			hours = hours !== undefined ? hours : config.cookieExpiryHours;

			// Local Storage
			if (typeof(Storage) !== 'undefined') {
				localStorage.setItem(name, value);
			}

			// Cookie
			else {
				service.createCookie(name, value, hours);
			}
		},
		addToStoredArray: function (arrKey, itemKey, guid, hours) {

			// This will remove the item if it already exists
			service.removeFromStoredArray(arrKey, itemKey, guid);

			hours = hours ? hours : null;
			let array = this.getStoredArray(arrKey);

			if (angular.isDefined(guid)) {
				array.push(`${itemKey}-${guid}`);
			}
			else {
				array.push(itemKey);
			}

			this.addToStorage(arrKey, array.join(','), hours);
		},
	    /* Compare basic arrays only */
		areArraysEqual: function (arr1, arr2) {

		    return JSON.stringify(arr1) === JSON.stringify(arr2);
		},
		/**
		 * Filter an array based on object properties. For example:
		 * 	arrayFilterByAttributes(arr, { value: 5, someFlag: false }) - filter out objects in the array that have value === 5 OR someFlag === false
		 * 	arrayFilterByAttributes(arr, { value: 5, someFlag: false }, true) - filter out objects in the array that have value === 5 AND someFlag === false
		 * 	arrayFilterByAttributes(arr, { value: [5, 6], someFlag: false }) - filter out objects in the array that have value === 5 OR 6, OR someFlag === false
		 * 	arrayFilterByAttributes(arr, { value: [5, 6], someFlag: false }, true) - filter out objects in the array that have value === 5 OR 6, AND someFlag === false
		 * @param {Array} arr Array to filter
		 * @param {Object} excludeOptions Set of attribute name / value pairs representing criteria for filtering out elements. Values can be arrays, in which case
		 *                each value will be checked.
		 * @param {boolean} applyAll Set to true to filter out objects that match all excludeOptions, false to filter out those
		 *                that match at least one. Defaults to false.
		 * @param {boolean} filterOut Set to true to filter out matching objects. False to keep matching objects and throw out all others. Defaults to true.
		 */
		arrayFilterByAttributes: function (arr, excludeOptions, applyAll, filterOut) {

			// Defaults. Coerce applyAll and filterOut into boolean types, just in case.
			applyAll = angular.isDefined(applyAll) ? !!applyAll : false;
			filterOut = angular.isDefined(filterOut) ? !!filterOut : true;

			// Return the array unchanged by default
			let filteredArr = arr;

			// Do the filtering
			if (angular.isDefined(excludeOptions) && Array.isArray(arr)) {
				const excludeAttributeNames = Object.keys(excludeOptions);
				filteredArr = filteredArr.filter(obj => {

					/* Start off with the applyAll flag for retain. If we're 'AND'-ing checks, we should start with true, then any
					   single false will negate that. The opposite for 'OR'-ing. */
					let retain = applyAll;
					// Go through each attribute name to check
					excludeAttributeNames.forEach(excludeAttributeName => {

						/* Update retain with multiple attribute values flag. If there are multiple attributes, retain should be negated since
						   those values have to be 'OR-ed'. It makes littles sense to check that attribute A has two different values at the same time */
						const multipleAttributeValues = Array.isArray(excludeOptions[excludeAttributeName]);
						retain = retain && !multipleAttributeValues;

						// If the attribute doesn't contain multiple values, make a singleton array
						const excludeValues = multipleAttributeValues ? excludeOptions[excludeAttributeName] : [excludeOptions[excludeAttributeName]];
						// Go through exclude values and decide whether any of them mean keeping the object
						excludeValues.forEach(excludeValue => {
							const attributeMatch = (obj[excludeAttributeName] === excludeValue);
							if (applyAll && !multipleAttributeValues) {
								retain = attributeMatch && retain;
							}
							else {
								retain = attributeMatch || retain;
							}
						});
					});
					// Filter out / in those that should not be / should be retained
         		    return filterOut !== retain;
				});
			}

			return filteredArr;
		},

		checkStoredArray: function (arrKey, itemKey, guid) {

			let array = this.getStoredArray(arrKey);

			// Company specific
			if (angular.isDefined(guid)) {
				return array.includes(`${itemKey}-${guid}`);
			}

			return array.includes(`${itemKey}`);
		},
		/*
			Compare date to today (times ignored).
			Return 0 if dates are the same, -1 if date is before today, 1 if date is after today
		 */
		compareDateToToday: function (isoDate) {
			// Get current date without time info
			let today = moment().startOf('day');

			if (moment(isoDate).isSame(today, 'day')) {
				return 0;
			}
			else if (moment(isoDate).isBefore(today)) {
				return -1;
			}
			else {
				return 1;
			}
		},
		/*
			Create and return a comparator function for an array of objects, using a property name.
			Use with sort and an array of objects, e.g. personList.sort(utilities.comparator('surname'))
			Optionally specify undefinedLast to put undefined items at the end of the array.
		 */
		comparator: function (fieldName, undefinedLast) {
			return function(a, b) {
				let valueA = angular.isDefined(a[fieldName]) ? a[fieldName] : undefined;
				let valueB = angular.isDefined(b[fieldName]) ? b[fieldName] : undefined;

				// Ensure strings are sorted case insensitive
				valueA = typeof(valueA) === 'string' ? valueA.toLowerCase() : valueA;
				valueB = typeof(valueB) === 'string' ? valueB.toLowerCase() : valueB;

				if (undefinedLast && !valueA && valueB) {
					return 1;
				}
				else if (undefinedLast && valueA && !valueB) {
					return -1;
				}
				else if (undefinedLast && !valueA && !valueB) {
					return 0;
				}
				else if (valueA > valueB) {
					return 1;
				}
				else if (valueA < valueB) {
					return -1;
				}
				else {
					return 0;
				}
			};
		},
		/*
			Compare IP addresses (for range validation). Return -1 if A < B, 0 if A === B, 1 if A > B.
			Return undefined if either IP address is invalid.
		 */
		compareIPAddresses: function (ipAddressA, ipAddressB) {
			// Convert to integer equivalents for direct comparison
			const ipAddressAInt = this.convertIPAddressToInteger(ipAddressA);
			const ipAddressBInt = this.convertIPAddressToInteger(ipAddressB);

			if (ipAddressAInt === -1 || ipAddressBInt === -1) {
				return undefined;
			}
			else if (ipAddressAInt < ipAddressBInt) {
				return -1;
			}
			else if (ipAddressAInt > ipAddressBInt) {
				return 1;
			}
			else {
				// They must be the same ...
				return 0;
			}
		},
		convertHoursToMilliseconds: hours => {

			return hours * 60 * 60 * 1000;
		},
		convertMillisecondsToSeconds: milliseconds => {

			return milliseconds / 1000;
		},
		convertMinutesToHours: minutes => {

			return minutes / 60;
		},
		convertMinutesToMilliseconds: minutes => {

			return minutes * 60 * 1000;
		},
		convertSecondsToMilliseconds: seconds => {

			return seconds * 1000;
		},
		/*
			Convert IP address to integer equivalent. Return -1 for invalid IP address.
		 */
		convertIPAddressToInteger: function (ipAddress) {
			if (angular.isDefined(ipAddress) && ipAddress !== null) {
				const ipAddressParts = this.separateIPv4Address(ipAddress);
				if (ipAddressParts) {
					// Convert to signed 32-bit signed int (<<) then back to unsigned 64-bit int (>>> 0)
					return (parseInt(ipAddressParts[0]) << 24) +
						   (parseInt(ipAddressParts[1]) << 16) +
						   (parseInt(ipAddressParts[2]) << 8) +
						   (parseInt(ipAddressParts[3])) >>> 0;
				}
			}
			return -1;
		},
		copyToClipboard: (value, successMessage) => {
			navigator.clipboard.writeText(value).then(
				() => {
					growl.success(successMessage);
				},
				() => {
				  growl.error('An error occurred when copying to clipboard');
				}
			);
		},
		createCookie: function (name, value, hours) {

			var expires = '';

			if (hours) {
				var date = new Date();
				const milliseconds = service.convertHoursToMilliseconds(hours);
				date.setTime(date.getTime() + milliseconds);
				expires = '; expires=' + date.toGMTString();
			}
			else {
				expires = '';
			}
			document.cookie = name + '=' + value + expires + '; path=/;secure';
		},
		debug: (debugDetail, debugType) => {

			// Check if debugging is applicable
			if (!service.isDebugging()) {
				return;
			}

			switch (debugType) {

				// If code needs to be debugged
				case 'log':
					$rootScope.paycircleMessage(debugDetail);
					break;

				// Basic text debugging
				default:
					$rootScope.paycircleMessage(debugDetail, 'info');
			}
		},
		decimalize (amount, round) {

			// Return zero if whaever was passed in ain't a number
			const amountFloat = parseFloat(amount);
			if (isNaN(amountFloat)) {
				return 0;
			}
			// Get an adjusted value based on round. Ensure it's a string for later manipulation.
			let amountString;
			if (round === 'up') {
				amountString = Math.ceil(amountFloat).toString();
			}
			else if (round === 'down') {
				amountString = Math.floor(amountFloat).toString();
			}
			else if (round !== undefined && round && !isNaN(round)) {
				/* If a specific number of decimal places have been specified, assume that trailing zeroes should be stripped.
				   The toString() method will do this free of charge */
				amountString = parseFloat(amountFloat.toFixed(round)).toString();
			}
			else {
				/* Default behaviour is to effectively monetise the value, i.e. two decimal places, even if the last is not significant;
				   e.g. convert 10.2 to '10.20' as opposed to '10.2' */
				amountString = amountFloat.toFixed(2);
			}

			// Finally, split out the number into it's whole and fractional parts. The whole part will have thousand separators inserted
			const decimalPoint = amountString.indexOf('.');
			let wholePart;
			let fractionalPart;
			if (decimalPoint === -1) {
				// No decimal point, no fractional part. The whole part is the entire number.
				wholePart = amountString;
				fractionalPart = '';
			}
			else {
				wholePart = amountString.substr(0, decimalPoint);
				fractionalPart = amountString.substr(decimalPoint);
				/* If the fractional part is a single digit (length === 2 for the decimal point and the single digit),
				   assume that this is a normal monetary value and should be shown as such, so insert a padding zero.
				   So, for example, 10.2 rounded to 4 decimal places will return '10.20' */
				if (fractionalPart.length === 2) {
					fractionalPart += '0';
				}
			}

			// Add the commas to the whole part
			wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			// Reassemble and return. The fractional part will include the decimal point if there was one
			return `${wholePart}${fractionalPart}`;
		},
		deleteCookie: function (name) {

			service.createCookie(name, '', -1);
		},
		deleteFromStorage: function (name) {

			// Get from local storage, if available
			if (typeof(Storage) !== 'undefined') {
				localStorage.removeItem(name);
			}

			// Fallback cookie storage
			else {
				service.deleteCookie(name);
			}
		},
		deleteToken: function () {
			if (typeof(Storage) !== 'undefined') {
				localStorage.removeItem(config.tokenStorageName);
			} else {
				service.deleteCookie(config.tokenStorageName);
			}
		},
		focusOn: (elementId, selectAll, delay) => {

			selectAll = angular.isDefined(selectAll) ? selectAll : false;
			delay = angular.isDefined(delay) ? delay : config.animationSpeed; // Default buffer for css animations (in milliseconds)

			if (!elementId) {
				return;
			}

			$timeout(() => {

				const input = document.getElementById(elementId);

				if (input) {
					input.focus();
				}
				else {
					$rootScope.paycircleMessage(`Unable to apply element focus to #${elementId} as it could not be found.`, 'warn');
				}

				if (selectAll) {
					input.select();
				}
			}, delay);
		},
		/**
		 * Set focus to first focusable element of the children of a specified element.
		 * @param {string} elementId - id of element. Its children will be searched.
		 * @param {number} delay - delay to operation, to allow the DOM to catch up or whatever. Optional, defaults to
		 * config.animationSpeed
		 */
		focusOnFirstChild: (elementId, delay) => {

			// Default delay to animation speed
			delay = delay || config.animationSpeed;

			// Do nothing if element ID not specified.
			if (!elementId) {
				return;
			}

			$timeout(() => {

				// Elements that can receive focus
				let focusableElementSelectors = [
					'button',
					'[href]',
					'input',
					'select',
					'textarea'
				];

				// Ensure none of those are disabled
				focusableElementSelectors = focusableElementSelectors.map(
					focusableElementSelector => `${focusableElementSelector}:not([disabled])`
				);

				// Find the specified element
				const element = document.getElementById(elementId);

				// If found ...
				if (element) {
					// .. find the first focusable child of that
					const firstFocusableElement = element.querySelector(focusableElementSelectors.join());
					// Focus on it if found
					if (firstFocusableElement) {
						firstFocusableElement.focus();
					}
				}
			}, delay);
		},
		formatArrayAsReadableList: function (array, itemsInQuotes) {

			// Copy the array, so as not to upset the original. While here put items in quotes if specified
			let mapFunction;
			if (angular.isDefined(itemsInQuotes) && itemsInQuotes) {
				mapFunction = item => `'${item}'`;
			}
			else {
				// Do nothing, just copy the array
				mapFunction = item => item;
			}
			let	arrayCopy = array.map(mapFunction);

			if (arrayCopy.length > 1) {
				// Convert ['one', 'two', 'three', four'] to 'one, two, three and four'
				let last = arrayCopy.pop();
				let penultimate = arrayCopy.pop();
				arrayCopy.push(`${penultimate} and ${last}`);
				return arrayCopy.join(', ');
			}
			else {
				// Just a single item. In the land of Geekdom, a single item is also a list.
				return arrayCopy[0];
			}
		},
		/**
		 * @param {number} number - number to format
		 * @param {number} precision - number of decimal places to show.
		 * @param {boolean} hideMantissaInsignificant - hide insignificant digits in the mantissa part of the decimal. For example:
		 * @returns {string} formatted number
		 * number = 12.222, precision = 4 => 12.2220
		 * number = 12.22, precision = 4, hideMantissaInsignificant = true => 12.22
		 * number = 12.22, precision = 4, hideMantissaInsignificant = false => 12.2200
		 */
		formatDecimal: function (number, precision, hideMantissaInsignificant) {

			// If number or precision ain't a number, return 0.
			if (isNaN(parseFloat(number) || isNaN(parseFloat(precision)))) {
				return '0';
			}

			// Get decimal to required precision
			let decimal = number.toFixed(precision);

			/* If insignificance mantissa digits (trailing zeroes after decimal point) need to be removed,
			   do that in batches of 2. */
			if (hideMantissaInsignificant) {
				while (decimal.endsWith('00')) {
					// Chop off the two trailing zeroes
					decimal = decimal.slice(0, -2);
				}
			}

			/* If all mantissa digits are zeroes, and all have been removed, what's left will end in a decimal point,
			   so remove it */
			if (decimal.endsWith('.')) {
				// Chop off the trailing, bare decimal point
				decimal = decimal.slice(0, -1);
			}

			return decimal;
		},
		/**
		 * Get the height of the app header
		 * @returns app header height.
		 */
		getAppHeaderHeight: function () {

			// Query to get app header, by class ...
			const appHeaderClassQuery = document.getElementsByClassName('app-header');

			// ... there should be one, and one only, of these
			if (appHeaderClassQuery && appHeaderClassQuery.length === 1) {
				const appHeader = appHeaderClassQuery[0];
				return appHeader.clientHeight;
			}
			else {
				// Default value for height. This is what it should be.
				return 113;
			}
		},
		getArrayBySize: function (num) {
			return new Array(num + 1);
		},
		getArrayFromStorage: function (storageKey, defaultValue) {

			var storageValueStr = service.getFromStorage(storageKey);

			// Ability to set permissions against a test role
			if (angular.isDefined(storageValueStr)) {

				var storageValueArr = JSON.parse(storageValueStr);

				if (angular.isArray(storageValueArr)) {
					return storageValueArr;
				}
				else {
					service.deleteFromStorage(storageKey);
				}
			}

			return angular.isDefined(defaultValue) ? defaultValue : null;
		},
		getArrayItemByPropertyName: function (array, propertyName, value, childPropertyName) {

			var itemIndex = service.getArrayItemIndexByPropertyName(array, propertyName, value, childPropertyName);

			return array[itemIndex];
		},
		getArrayItemIndexByPropertyName: function (array, propertyName, value, childPropertyName) {

			var i = 0;
			var arrayLength = array.length;

			for (i; i < arrayLength; i++) {

				var property = array[i];

				property = propertyName ? property[propertyName] : property;

				if (childPropertyName) {
					property = property[childPropertyName];
				}

				if (property === value) {
					return i;
				}
			}
			return null;
		},

		getClipboardTextFromEvent: eventObj => {

			// Stop data actually being pasted into div
			eventObj.stopPropagation();
			eventObj.preventDefault();

			// Get pasted data via clipboard API
			const clipboardData = eventObj.clipboardData || window.clipboardData;
			const pastedData = clipboardData.getData('Text');

			return pastedData ? pastedData :  null;
		},

		getCurrentTaxMonth () {
			// Get the current tax month, from April (1) -> March (12)
			return this.getTaxMonthForMonth(moment().month);
		},
		getMonthForTaxMonth (taxMonth) {
			// Convert tax month (1 = Apr -> 12 = Mar) to month (0 = Jan -> 11 = Dec)
			return (taxMonth + 2) % 12;
		},
		getNormalisedPath (path) {
			const pathParts = path.split('/');
			let normalisedPath = '';
			pathParts.forEach(pathPart => {
				if (!REGEX.guid.test(pathPart) && pathPart !== '') {
					normalisedPath += `/${pathPart}`;
				}
			});
			return normalisedPath;
		},
		getTaxMonthForMonth (month) {
			// Convert month (0 = Jan -> 11 = Dec) to tax month (1 = Apr -> 12 = Mar)
			return (month + 10) % 12;
		},
		getTaxYearStartDateForDate: (dateIso, checkCurrentYear) => {

			const startOfTaxYear = moment(dateIso).month(3).date(6);

			if (checkCurrentYear) {
				// If the determined tax year start date is after the specified date, subtract a year
				if (startOfTaxYear.isAfter(dateIso)) {
					startOfTaxYear.subtract(1, 'years');
				}
			}

			return startOfTaxYear.format(config.dateFormatISO);
		},
		getTaxYearEndDateForDate: (nextTaxYear, checkCurrentYear, dateIso) => {

			const endOfTaxCurrentYear = moment(dateIso).month(3).date(5);
			const today = moment();

			// If in the current
			if (checkCurrentYear) {
				if (endOfTaxCurrentYear.isBefore(today)) {
					endOfTaxCurrentYear.add(1, 'years');
				}
			}

			if (nextTaxYear) {
				endOfTaxCurrentYear.add(1, 'years');
			}

			return endOfTaxCurrentYear.format(config.dateFormatISO);
		},
		getIsPreviousTaxYearSubmission: (selectedTaxYear, currentTaxYear) => {

			return selectedTaxYear < currentTaxYear;
		},
		getTimeToPoll: units => {

			switch (units) {

				case 'milliseconds':
					return config.timeToPoll * 1000;

				// Seconds
				default:
					return config.timeToPoll;
			}
		},
		isBrowserCompatible: function () {

			const getBrowserVersionInfo = function (userAgentString) {
				// Get user agent string and split it based on ' '. This will include some crap, but that will be stripped out.
				const browserInfoItems = userAgentString.split(' ');
				const browserVersionInfoItems = [];

				/* Regex to match 'BrowserIdentifier/MajorVersion.MinorVersion.PatchVersion.Whatever.Etc'.
				   BrowserIdentifier and MajorVersion are matching groups for extraction. */
				const browserVersionInfoRegex = /(\w*)\/(\w+)[\.\w+]*/;

				// Convenience function to get major version based on browser identifier
				const getMajorVersionForInfoItem = function (browserIdentifier) {
					const browserVersionInfoItem =  browserVersionInfoItems.find(item => item.identifier === browserIdentifier);
					// Return major version if found, undefined otherwise
					return angular.isDefined(browserVersionInfoItem) ? browserVersionInfoItem.majorVersion : undefined;
				};

				// Remove crap and parse items of form according to regex, extracting browser identifier and major version
				browserInfoItems.forEach(browserInfoItem => {
					const matches = browserVersionInfoRegex.exec(browserInfoItem);
					if (matches !== null) {
						browserVersionInfoItems.push({
							identifier: matches[1].toLowerCase(),
							majorVersion: matches[2]
						});
					}
				});

				// Cycle through browser compatibility list
				for (let i = 0, ii = BROWSER_COMPATIBILITY_LIST.length; i < ii; i++) {
					const browserInfo = BROWSER_COMPATIBILITY_LIST[i];
					for (let j = 0, jj = browserInfo.userAgentNames.length; j < jj; j++) {
						let browserVersionIdentifier = browserInfo.userAgentNames[j];
						if (browserVersionIdentifier === 'safari') {
							browserVersionIdentifier = 'version';
						}
						const browserMajorVersion = getMajorVersionForInfoItem(browserVersionIdentifier);
						if (angular.isDefined(browserMajorVersion)) {
							/* Check for 'must not include' user agent names. For example, if 'opr' is in there
							   somewhere, it's Opera, it ain't Chrome in spite of the presence of 'Chrome/x.y.z'
							   elsewhere in the user agent string. */
							let hasMustNotInclude = false;
							// If no 'userAgentsMustNotInclude' property for current browser info, do nothing
							if (angular.isArray(browserInfo.userAgentNamesMustNotInclude)) {
								browserInfo.userAgentNamesMustNotInclude.forEach(userAgentName => {
									// Tru-ify the flag when at least one 'must not include' user agent name is present
									hasMustNotInclude |= browserVersionInfoItems.some(browserVersionInfoItem => browserVersionInfoItem.identifier === userAgentName);
								});
							}
							if (!hasMustNotInclude) {
								return {
									browserId: browserInfo.id,
									majorVersion: browserMajorVersion
								};
							}
						}
					}
				}
			};

			/* Get browser info for current browser. Put this in a try/catch for safety purposes. UserAgent is a bit of a free-for-all and parsing might fail.
			   If this call fails, assume the browser can't be identified and is invalid */
			let currentBrowserInfo;
			try {
				currentBrowserInfo = getBrowserVersionInfo(navigator.userAgent);
			}
			catch (error) {}

			// If found, check the version. Otherwise assume this isn't a compatible browser.
			let browserCompatible = false;
			if (angular.isDefined(currentBrowserInfo)) {

				// Edge versions (pre-Chromium) need version mapping to browser version
				if (currentBrowserInfo.browserId === 'edge') {
					// https://en.wikipedia.org/wiki/Microsoft_Edge#Release_History
					const edgeVersionMap = {
						'12': '20',
						'13': '25',
						'14': '38',
						'15': '40',
						'16': '41',
						'17': '42',
						'18': '44'
					};
					if (edgeVersionMap[currentBrowserInfo.majorVersion]) {
						currentBrowserInfo.majorVersion = edgeVersionMap[currentBrowserInfo.majorVersion];
					}
				}

				const browserCompatibilityInfo = BROWSER_COMPATIBILITY_LIST.find(browserItem => browserItem.id === currentBrowserInfo.browserId);
				if (angular.isDefined(browserCompatibilityInfo)) {
					// The browser type is OK, but the version may not be ...
					browserCompatible = currentBrowserInfo.majorVersion >= browserCompatibilityInfo.minVersion;
				}
			}

			return browserCompatible;
		},
		isDateUndefined: function (dateISO) {
			// Dates are 'undefined' if empty or set to '1900-01-01T00:00:00'
			return angular.isUndefined(dateISO) || dateISO === '' || dateISO === '1900-01-01T00:00:00';
		},
		getBureauIdByCompanyKey: function (companyKey) {

			switch (companyKey) {
				case 'fsb':
					return ONBOARDING_BUREAUS.fsb;
				default:
					return ONBOARDING_BUREAUS.paycircle;
			}
		},
		getFileExtension: function (filename) {
			const extensionStartIndex = filename.lastIndexOf('.');
			if (extensionStartIndex !== -1 && extensionStartIndex !== filename.length - 1) {
				return filename.substr(extensionStartIndex + 1);
			}
			else {
				return undefined;
			}
 		},
		getIsDemonstrationActiveByCompanyKey: function (companyKey) {

			switch (companyKey) {
				case 'fsb':
					return true;
				default:
					return true;
			}
		},
		getIsWhitelabelByBureauKey: function (bureauKey) {

			switch (parseInt(bureauKey)) {
				case ONBOARDING_BUREAUS.fsb:
					return true;
				default:
					return false;
			}
		},
		getIsWhitelabelByCompanyKey: function (companyKey) {

			switch (companyKey) {
				case 'fsb':
					return true;
				default:
					return false;
			}
		},
		getKeysFromObject: function (object) {

			return Object.keys(object);
		},
		getLaterDateISO: function (date1ISO, date2ISO, date3ISO) {

			var returnDate;

			if (date1ISO === '' || date1ISO === undefined || date2ISO === '' || date2ISO === undefined) {
				console.warn('utilities.getLaterDateISO: no date defined');
				return;
			}

			if (date1ISO !== '' && date2ISO !== '') {

				var date1Moment = moment(date1ISO);
				var date2Moment = moment(date2ISO);

				returnDate = date1Moment.isAfter(date2Moment) ? date1ISO : date2ISO;
			}

			if (date3ISO !== '' && date3ISO !== undefined) {

				var date3Moment = moment(date3ISO);

				returnDate = returnDate.isAfter(date3Moment) ? returnDate : date3Moment;
			}

			return returnDate;
		},
		getObjectFromArray: function(array, id, isMatchFnc) {

			var arrayLength = array.length;
			var i = 0;

			for (i; i < arrayLength; i++) {
				var arrayObj = array[i];
				if (isMatchFnc(arrayObj, id)) {
					return arrayObj;
				}
			}

			return null;
		},
		getObjectFromArrayByKey: function (array, key) {

			var arrayLength = array.length;
			var i = 0;

			for (i; i < arrayLength; i++) {
				var arrayObj = array[i];
				if (key === arrayObj.key) {
					return arrayObj;
				}
			}

			return null;
		},
		getObjectFromStorage: function (name, defaultObj) {

			let storedObjectObj = JSON.parse(service.getFromStorage(name, null));

			return angular.isObject(storedObjectObj) ? storedObjectObj : defaultObj;
		},
		getPrimaryRole: function (roles) {

			if (roles.indexOf(USER_ROLES.paycircle) > -1) {
				return USER_ROLES.paycircle;
			}
			else if (roles.indexOf(USER_ROLES.bureaumanager) > -1) {
				return USER_ROLES.bureaumanager;
			}
			else if (roles.indexOf(USER_ROLES.bureau) > -1) {
				return USER_ROLES.bureau;
			}
			else if (roles.indexOf(USER_ROLES.groupadmin) > -1) {
				return USER_ROLES.groupadmin;
			}
			else if (roles.indexOf(USER_ROLES.groupuser) > -1) {
				return USER_ROLES.groupuser;
			}
			else if (roles.indexOf(USER_ROLES.groupadminlite) > -1) {
				return USER_ROLES.groupadminlite;
			}
			else if (roles.indexOf(USER_ROLES.companyadministrator) > -1) {
				return USER_ROLES.companyadministrator;
			}
			else if (roles.indexOf(USER_ROLES.companyadministratorlite) > -1) {
				return USER_ROLES.companyadministratorlite;
			}
			else if (roles.indexOf(USER_ROLES.departmentadmin) > -1) {
				return USER_ROLES.departmentadmin;
			}
			else if (roles.indexOf(USER_ROLES.sme) > -1) {
				return USER_ROLES.sme;
			}
			else {
				console.warn('Paycircle Warning: User does not have the correct role for this app');
				return null;
			}
		},

		getDifference: (startDateIso, endDateIso, format, alwaysPositive) => {

			function getDifferenceFormat (format) {

				switch (format) {
					case 'minutes':
						return fromMoment.diff(toMoment, 'minutes');
					case 'hours':
						return fromMoment.diff(toMoment, 'minutes') / 60;
					case 'months':
						return fromMoment.diff(toMoment, 'months');
				}
			}

			const fromMoment = moment(startDateIso);
			const toMoment = moment(endDateIso);

			const differenceInt = getDifferenceFormat(format);

			if (alwaysPositive) {
				return Math.abs(differenceInt);
			}

			return differenceInt;
		},
		getAppEnvironmentKey: function () {

			// Localhost
			if (service.isEnvironmentLocalhost) {
				return 'localhost';
			}

			// Development
			if (service.isEnvironmentDevelopment) {
				return 'development';
			}

			// Staging
			if (service.isEnvironmentStaging) {
				return 'staging';
			}

			// Beta
			if (service.isEnvironmentBeta) {
				return 'beta';
			}

			// Preproduction
			if (service.isEnvironmentPreProduction) {
				return 'preproduction';
			}

			return 'production';
		},

		getButtonEnvironmentKey: function () {

			// Localhost
			if (service.isEnvironmentLocalhost) {
				return 'preprod';
			}

			// Development
			if (service.isEnvironmentDevelopment) {
				return 'preprod';
			}

			// Demo
			if (service.isEnvironmentDemo) {
				return 'demo';
			}

			// Staging
			if (service.isEnvironmentStaging) {
				return 'staging';
			}

			// Beta
			if (service.isEnvironmentBeta) {
				return 'preprod';
			}

			// Preproduction
			if (service.isEnvironmentPreProduction) {
				return 'preprod';
			}

			return 'prod';
		},

		
		getIframeParentURL: function () {

			// Localhost
			if (service.isEnvironmentLocalhost) {
				return 'https://preprodgo.accessacloud.com';
			}

			// Development
			if (service.isEnvironmentDevelopment) {
				return 'https://preprodgo.accessacloud.com';
			}

			// Demo
			if (service.isEnvironmentDemo) {
				return 'https://demogo.accessacloud.com';
			}

			// Staging
			if (service.isEnvironmentStaging) {
				return 'https://staginggo.accessacloud.com';
			}

			// Beta
			if (service.isEnvironmentBeta) {
				return 'https://preprodgo.accessacloud.com';
			}

			// Preproduction
			if (service.isEnvironmentPreProduction) {
				return 'https://go.accessacloud.com';
			}

			return 'https://go.accessacloud.com';
		},

		// Get tax year start date for current date
		getTaxYearStartDate: function () {

			return moment(this.getTaxYearStartDateISO(moment())).format(config.dateFormatPrimary);
		},
		// Get tax year start date for specified moment date
		getTaxYearStartDateISO: function (dateMoment) {

			// Copy the date moment before manipulating so parameter isn't affected
			var startOfTaxYear = dateMoment.clone().month(3).date(6);

			// If in the current, go back a year
			if (startOfTaxYear.isAfter(dateMoment)) {
				startOfTaxYear.subtract(1, 'years');
			}

			return startOfTaxYear.format();
		},
		// Get text equivalent of number. Beyond 9, just return the number as string
		getNumberText: function (number) {

			switch (number) {
				case 1: return 'one';
				case 2: return 'two';
				case 3: return 'three';
				case 4: return 'four';
				case 5: return 'five';
				case 6: return 'six';
				case 7: return 'seven';
				case 8: return 'eight';
				case 9: return 'nine';
				default: return Number(number).toString();
			}
		},
		getRegistrationUrl: function (userId, agencyId, role) {

			var roleId = '';
			var registrationUrl = '';

			if (role === 'payrollworker') {
				roleId = '5DE31B27-BDA4-47E8-A376-780861F184EC';
				registrationUrl = 'https://my.paycircle.co.uk/#/user-registration';
			}
			if (role === 'companyadmin') {
				roleId = '2C9D135E-E5A9-4FF8-A0AC-B45A16C05EB9';
				registrationUrl = 'https://app.paycircle.co.uk/user-registration';
			}
			if (role === 'worker') {
				roleId = '9A176943-A78D-4BC3-99CB-3CE7B8FA9AB2';
				registrationUrl = 'https://my.paycircle.co.uk/#/user-registration';
			}

			return registrationUrl + '/' + userId + '/' + agencyId + '/' + roleId;
		},
		getResetPasswordMailType: function () {

			switch (config.appKey) {
				case 'user-portal':
					return MAIL_TYPES.resetPasswordUserPortal;
				case 'payroll':
					return MAIL_TYPES.resetPasswordPayroll;
				default:
					return MAIL_TYPES.resetPasswordUserPortal;
			}
		},
		getRoleUrl: function (role, companyType) {

			if (role === undefined) {
				return null;
			}

			switch (role) {
				case USER_ROLES.paycircle:
				case USER_ROLES.bureau:
				case USER_ROLES.bureaumanager:
				case USER_ROLES.groupadmin:
				case USER_ROLES.groupuser:
					return 'dashboard';
				case USER_ROLES.companyadmin:
				case USER_ROLES.companyadministrator:
				case USER_ROLES.payrollworker:
				case USER_ROLES.sme:
					return companyType === INTERFACE_TYPES.agency ? 'agency-dashboard' : 'company-dashboard';
				case USER_ROLES.companyadministratorlite:
					return 'payroll.current-period.notes';
				case USER_ROLES.departmentadmin:
					return 'team.members';
				case USER_ROLES.groupadminlite:
					return 'companies';
				default:
					return config.defaultPage;
			}
		},
		getItemsFromStoredArray: (arrKey, guid) => {

			let array = service.getStoredArray(arrKey);

			array.forEach((arrayItem, index) => {
				array[index] = arrayItem.replace(`-${guid}`, '');
			});

			return array;
		},
		getStoredArray: arrKey => {

			let array = service.getFromStorage(arrKey);

			return array ? array.split(',') : [];
		},
		getMimeFormatFromDocumentName: documentName => {
			return documentName.substr(documentName.lastIndexOf('.') + 1).toUpperCase();
		},
		getFromStorage: function (name, defaultObj) {

			var item = null;

			// Get from local storage, if available
			if (typeof(Storage) !== 'undefined') {
				item = localStorage.getItem(name);
			}

			// Fallback cookie storage
			else {
				item = service.readCookie(name);
			}

			return item ? item : defaultObj;
		},
		getTodaysDate: function () {

			return moment().format(config.dateFormatPrimary);
		},
		getToken: function () {

			// Local Storage
			if (typeof(Storage) !== 'undefined') {
				if (localStorage.getItem(config.tokenStorageName) !== 'undefined') {
					return localStorage.getItem(config.tokenStorageName);
				}
			}

			// Cookie fallback
			if (service.readCookie(config.tokenStorageName)) {
				return service.readCookie(config.tokenStorageName);
			}

			return null;
		},
		getUserGenderDescriptions: function (gender) {

			/*
			a: they, he, she
			b: their, his, her
			c: theirself, himself, herself
			*/

			var genderDescriptions = {
				a: 'they',
				b: 'their',
				c: 'themselves'
			};

			gender = gender.toLowerCase();

			// Male
			if (service.isMale(gender)) {
				genderDescriptions.a = 'he';
				genderDescriptions.b = 'his';
				genderDescriptions.c = 'himself';
			}

			// Female
			else if (service.isFemale(gender)) {
				genderDescriptions.a = 'she';
				genderDescriptions.b = 'her';
				genderDescriptions.c = 'herself';
			}

			return genderDescriptions;
		},
		getMailToFromMessage: function (mailToObj) {

			var returnMessage = 'mailto:' + mailToObj.toAddress;
			returnMessage += '?subject=' + mailToObj.subject;
			returnMessage += '&body=' + mailToObj.body;

			return encodeURI(returnMessage);
		},
		getRandomNumber: function (from, to) {

			return Math.floor(Math.random() * (to + 1) + from);
		},
		getWelcomeMessage: function (date, name) {

			var a = moment(date);
			var b = moment();
			var diff = b.diff(a, 'days');
			var message = '';

			name = name !== undefined ? ' ' + name : '';

			switch (diff) {
				case diff > 20 && diff < 50:
					message = 'Hey' + name + '. Good to see you again!';
					break;
				case diff > 50:
					message = 'Welcome back! It\'s been a while!';
					break;
				default:
					message = 'Hey' + name + '. Welcome back!';
					break;
			}

			return message;
		},

		goBack: () => {

			// Normal
			if (window.history.length > 1) {
				window.history.back();
			}

			// Popup
			else {
				window.close();
			}
		},

		groupArray: function (array, groupSize) {

			if (array === undefined) {
				console.warn('utilities:groupArray - No array information to group.');
				return [];
			}

			var x;
			var i = 0;
			var c = -1;
			var arrayLength = array.length;
			var n = [];

			for (i; i < arrayLength; i++) {
				(x = i % groupSize) ? n[c][x] = array[i] : n[++c] = [array[i]];
			}

			return angular.copy(n);
		},

		groupArrayByProperty: (array, propertyKey) => {

			return array.reduce((rv, x) => {
				(rv[x[propertyKey]] = rv[x[propertyKey]] || []).push(x);
				return rv;
			}, {});
		},

		guid: function () {

			var d = new Date().getTime();
			if (window.performance && typeof window.performance.now === 'function') {
				d += window.performance.now(); //use high-precision timer if available
			}
			var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = (d + Math.random()*16)%16 | 0;
				d = Math.floor(d/16);
				return (c==='x' ? r : (r&0x3|0x8)).toString(16);
			});
			return uuid;
		},

		/**
		 * This function will check the width of the element id that is in the DOM.
		 * - true:  has an x scroll
		 * - false: no x scroll
		 * @param {string} elmId : the DOM element id to test
		 * @returns boolean
		 */
		hasScrollWidth: function (elmId) {
			const elm = document.getElementById(elmId);
			const hasOverflow = elm.scrollWidth > elm.clientWidth;
			return hasOverflow;
		},

		isBusinessLogicError: function (response, config) {

			return response === -1 || (response === '' && config.errorOnEmptyResponse);
		},
		isDebugging: () => {

			// To show full debugging, 'isInDebugMode' config option needs to be enabled and needs to be a development environment
			return config.isInDebugMode && service.isDevelopment();
		},
		isDevelopment: function () {

			return $location.$$host.indexOf('localhost') !== -1 || $location.$$host.indexOf('payrolldev') !== -1 || $location.$$host.indexOf('staging') !== -1 || $location.$$host.indexOf('demo') !== -1 || config.isInDebugMode;
		},
		isEmpty: function (obj) {

			var hasOwnProperty = Object.prototype.hasOwnProperty;

			// null and undefined are "empty"
			if (obj === null) { return true; }
			if (obj === undefined) { return true; }

			// Assume if it has a length property with a non-zero value
			// that that property is correct.
			if (obj.length > 0) { return false; }
			if (obj.length === 0) { return true; }

			// Otherwise, does it have any properties of its own?
			// Note that this doesn't handle
			// toString and valueOf enumeration bugs in IE < 9
			for (var key in obj) {
				if (hasOwnProperty.call(obj, key)) { return false; }
			}

			return true;
		},
		isEmptyGuid: function (guid) {

			return guid === config.guidEmpty;
		},

		isEnvironmentBeta: ($location.host() === config.appSubdomains.beta + '.' + config.baseDomainName) || ( $location.host() === config.appSubdomains.beta + '.' + config.evoNativeDomainName),
		isEnvironmentDemo: ($location.host() === config.appSubdomains.demo + '.' + config.baseDomainName) || ($location.host() === config.appSubdomains.demo + '.' + config.evoNativeDomainName),
		isEnvironmentDevelopment: ($location.host() === config.appSubdomains.development + '.' + config.baseDomainName) || ( $location.host() === config.appSubdomains.development + '.' + config.evoNativeDomainName),
		isEnvironmentLocalhost: $location.host() === config.appSubdomains.localhost,
		isEnvironmentPreProduction: ($location.host() === config.appSubdomains.preproduction + '.' + config.baseDomainName) || ( $location.host() === config.appSubdomains.preproduction + '.' + config.evoNativeDomainName),
		isEnvironmentProduction: ($location.host() === config.appSubdomains.production + '.' + config.baseDomainName) || ( $location.host() === config.appSubdomains.production + '.' + config.evoNativeDomainName),
		isEnvironmentStaging: $location.host() === config.appSubdomains.staging + '.' + config.baseDomainName,

		isError: function (data, config) {

			if (data === undefined || data === true) {
				return false;
			}

			if (service.isBusinessLogicError(data, config)) {
				return true;
			}

			if (data === '') {
				if (config !== undefined) {

					if (config.logOnEmptyResponse === undefined) {
						console.info(config.url + ' - Service call returned an empty string.');
					}

					if (config.errorOnEmptyResponse !== undefined && !config.errorOnEmptyResponse) {
						return false;
					}
				}
				return true;
			}

			// Check if returned data object is a string that starts with 'ERROR'
			if (typeof data === 'string') {

				if (data.substring(0, 7) === '"ERROR:') {
					return true;
				}
				if (data.substring(0, 6) === 'ERROR:') {
					return true;
				}
				if (data.substring(0, 5) === 'ERROR') {
					return true;
				}
			}

			return false;
		},
		isFemale: function (gender) {

			gender = gender !== undefined ? gender.toLowerCase() : gender;

			return gender === 'f' || gender === 'female';
		},
		isFullScreenActive: () => {
			return $document[0].fullscreenElement ? true : false;
		},
		isFullScreenEnabled: () => {
			if (document.documentElement.requestFullScreen) {
				return true;
			}
			else if (document.documentElement.mozRequestFullScreen) {
				return true;
			}
			else if (document.documentElement.webkitRequestFullScreen) {
				return true;
			}
			else {
				return false;
			}
		},
		isFunction: function (functionToCheck) {

			var getType = {};

			return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
		},
		isLoginPage: function (state) {

			return state.name === 'login';
		},
		isMale: function (gender) {
			gender = gender !== undefined ? gender.toLowerCase() : gender;

			return gender === 'm' || gender === 'male';
		},
		getMediaType: function () {

			const windowWidth = window.innerWidth;

			// Phone
			if (windowWidth <= MEDIA_TYPES_SIZES.phone) {
				return MEDIA_TYPES.phone;
			}

			// Tablet
			if (windowWidth <= MEDIA_TYPES_SIZES.tablet) {
				return MEDIA_TYPES.tablet;
			}

			// Laptop
			if (windowWidth <= MEDIA_TYPES_SIZES.laptop) {
				return MEDIA_TYPES.laptop;
			}

			// Monitor
			if (windowWidth <= MEDIA_TYPES_SIZES.monitor) {
				return MEDIA_TYPES.monitor;
			}

			// TV
			return MEDIA_TYPES.tv;
		},
		isPopulatedGuid: guid => {

			// Guid is invalid format
			if (!service.isValidGuid(guid)) {
				return false;
			}

			// Guid is empty
			if (service.isEmptyGuid(guid)) {
				return false;
			}

			return true;
		},
		isValidBureauKey: function (bureauKey) {

			switch (bureauKey) {
				case '0':
				case '1':
					return true;
				default:
					return false;
			}
		},
		isValidCompanyKey: function (companyKey) {

			companyKey = String(companyKey);
			switch (companyKey) {
				case 'fsb':
				case '1':
				case 'paycircle':
				case '0':
					return true;
				default:
					return false;
			}
		},
		isValidDate: function (date, format) {
			format = format !== undefined ? format : REGEX.date;
			return format.test(date);
		},
		isValidEmail: function (email) {
			var regex = REGEX.email;
			return regex.test(email);
		},
		isValidGender: function (gender) {

			if (!gender || gender === undefined || gender === '') {
				return false;
			}

			if (gender !== 'Male' && gender !== 'Female') {
				return false;
			}

			return true;
		},
		isValidGuid: function (guid) {
			var regex = REGEX.guid;
			return regex.test(guid);
		},
		isValidIPv4Address: function (ipAddress) {
			// Convenience function to validate IP address by attempting to separate it
			return (angular.isDefined(this.separateIPv4Address(ipAddress)));
		},
		isValidIPv4AddressPart: function (ipAddressPart) {
			if (isNaN(parseInt(ipAddressPart))) {
				return false;
			}
			else {
				const ipAddressNumPart = parseInt(ipAddressPart);
				return ipAddressNumPart >=0 && ipAddressNumPart <= 255;
			}
		},
		isValidName: function (name) {
			var regex = REGEX.lettersOnly;
			return regex.test(name);
		},
		isValidNI: function (niNumber) {
			var regex = REGEX.NI;
			return regex.test(niNumber);
		},
		isValidPassword: function (password) {

			if (password === undefined || password === null) {
				return false;
			}

			if (password.length < 7) {
				return false;
			}

			return true;
		},
		isValidPostcode: function (toCheck) {

			// Permitted letters depend upon their position in the postcode.
			var alpha1 = '[abcdefghijklmnoprstuwyz]';                       // Character 1
			var alpha2 = '[abcdefghklmnopqrstuvwxy]';                       // Character 2
			var alpha3 = '[abcdefghjkpmnrstuvwxy]';                         // Character 3
			var alpha4 = '[abehmnprvwxy]';                                  // Character 4
			var alpha5 = '[abdefghjlnpqrstuwxyz]';                          // Character 5
			var BFPOa5 = '[abdefghjlnpqrst]';                               // BFPO alpha5
			var BFPOa6 = '[abdefghjlnpqrstuwzyz]';                          // BFPO alpha6

			// Array holds the regular expressions for the valid postcodes
			var pcexp = [];

			// BFPO postcodes
			pcexp.push (new RegExp ('^(bf1)(\\s*)([0-6]{1}' + BFPOa5 + '{1}' + BFPOa6 + '{1})$','i'));

			// Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}' + alpha2 + '?[0-9]{1,2})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Expression for postcodes: ANA NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}[0-9]{1}' + alpha3 + '{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Expression for postcodes: AANA  NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}' + alpha2 + '{1}' + '?[0-9]{1}' + alpha4 +'{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Exception for the special postcode GIR 0AA
			pcexp.push (/^(GIR)(\s*)(0AA)$/i);

			// Standard BFPO numbers
			pcexp.push (/^(bfpo)(\s*)([0-9]{1,4})$/i);

			// c/o BFPO numbers
			pcexp.push (/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

			// Overseas Territories
			pcexp.push (/^([A-Z]{4})(\s*)(1ZZ)$/i);

			// Anguilla
			pcexp.push (/^(ai-2640)$/i);

			// Load up the string to check
			var postCode = toCheck;

			// Assume we're not going to find a valid postcode
			var valid = false;

			// Check the string against the types of post codes
			for ( var i=0; i<pcexp.length; i++) {

				if (pcexp[i].test(postCode)) {

					// The post code is valid - split the post code into component parts
					pcexp[i].exec(postCode);

					// Copy it back into the original string, converting it to uppercase and inserting a space
					// between the inward and outward codes
					postCode = RegExp.$1.toUpperCase() + ' ' + RegExp.$3.toUpperCase();

					// If it is a BFPO c/o type postcode, tidy up the "c/o" part
					postCode = postCode.replace (/C\/O\s*/,'c/o ');

					// If it is the Anguilla overseas territory postcode, we need to treat it specially
					if (toCheck.toUpperCase() === 'AI-2640') {
						postCode = 'AI-2640';
					}

					// Load new postcode back into the form element
					valid = true;

					// Remember that we have found that the code is valid and break from loop
					break;
				}
			}

			// Return with either the reformatted valid postcode or the original invalid postcode
			return valid;
		},
		isValidTaxCode: function (toCheck) {

			// Convert given tax code to uppercase
			toCheck = toCheck.toUpperCase();

			// Remove spaces from the tax code to help validation
			while (toCheck.indexOf(' ') !== -1)  {
				toCheck = toCheck.slice (0,toCheck.indexOf(' ')) + toCheck.slice (toCheck.indexOf(' ')+1);
			}

			// Set up the regular expression for valid tax codes
			var exp = /(^[1-9]{1}[0-9]{0,5}[TLPVY]([MW]1){0,1}$)|(^K[1-9]{1}[0-9]{0,5}([MW]1){0,1}$)|(^((BR)|(OT)|(D0)|(NT)|(FT))([MW]1){0,1}$)/;

			// Check the code
			if (toCheck.match(exp)) {

				// Enforce a space before any M1 or W1
				exp = /^(.+)([MW]1)$/;
				if (toCheck.match (exp)) {
					var namelist = [];
					namelist [0] = toCheck.slice (0,-2);
					namelist [1] = toCheck.slice (-2);
					toCheck = namelist[0] + ' ' + namelist[1];
				}

				// Valid - return the tax code in uppercase with spaces removed
				return toCheck;
			}
			else {

				// Invalid - return false
				return false;
			}
		},
		jsonArrayToHtml: function (json) {

			var html = '';

			function iter (obj) {
				for (var key in obj) {
					if (typeof(obj[key]) === 'object') {
						html += '<h4>' + key + '</h4>';
						iter(obj[key]);
					} else {
						html += '<div class="row"><div class="col six key">' + key + '</div><div class="col six value">' + obj[key] + '</div></div>';
					}
				}
			}

			iter(json[0]);

			return html;
		},
		jsonObjToHtml: function (json) {

			var html = '';

			function iter (obj) {
				for (var key in obj) {
					if (typeof(obj[key]) === 'object') {
						html += '<h4>' + key + '</h4>';
						iter(obj[key]);
					} else {
						html += '<div><span class="key">' + key + '</span><span class="values">' + obj[key] + '</span></div>';
					}
				}
			}

			iter(json);

			return html;
		},
		lazyLoadScript: function (src, async) {

			var s = document.createElement('script'); // use global document since Angular's $document is weak
			var x = document.getElementsByTagName('script')[0];

			s.async = async === undefined;
			s.type = 'text/javascript';
			s.src = src;
			x.parentNode.insertBefore(s, x);
		},
		// Reference: https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
		moveItemInArray (arr, oldIndex, newIndex) {

			if (newIndex >= arr.length) {

				var k = newIndex - arr.length + 1;

				while (k--) {
					arr.push(undefined);
				}
			}

			arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

			return arr;
		},
		offsetDateForDST: function (dateISO) {

			return moment(dateISO).isDST() ? moment(dateISO).add(1, 'h').format(config.dateFormatISO) : moment(dateISO).format(config.dateFormatISO);
		},
		openMailToFromObj: function (mailToObj) {

			var mailToUri = service.getMailToFromMessage(mailToObj);

			window.location.href = mailToUri;
		},
		padZeroes: function (number, length) {

			var resultString = '' + number;

			while (resultString.length < length) {
				resultString = '0' + resultString;
			}
			return resultString;
		},
		parseIsoDate: function (isoDate) {

			// If undefined set to todays date
			if (isoDate === undefined || isoDate === '' || !moment(isoDate).isValid()) {

				if (config.isInDebugMode) {
					console.warn('ISO date is not defined or invalid, setting as undefined');
				}

				return undefined;
			}

			// Make sure date format is ISO string
			isoDate = moment(isoDate).format();

			// If valid ISO date, convert to JS date object
			if (isoDate.indexOf('T') > -1) {
				isoDate = isoDate.split('T')[0];
			}

			var parts = isoDate.split('-');
			var newDate = new Date(parts[0], parts[1]-1, parts[2]);

			// Get browser time
			newDate.setTime(newDate.getTime());

			return newDate;
		},
		paycircleDecodeEmail: function (string) {

			string = string.replace(/~/g, '+');
			string = string.replace(/%20/g, '+');
			string = string.replace(/ /g, '+');

			return string;
		},
		profilingEnd: (profileKey) => {

			if (service.isDevelopment()) {
				console.timeEnd(profileKey);
			}
		},
		profilingStart: (profileKey) => {

			if (service.isDevelopment()) {
				console.time(profileKey);
			}
		},
		readCookie: function (name) {

			var match = name + '=';
			var cookieList = document.cookie.split(';');
			var i;

			for (i = 0; i < cookieList.length; i++) {

				var cookie = cookieList[i];

				while (cookie.charAt(0) === ' ') {
					cookie = cookie.substring(1, cookie.length);
				}

				if (cookie.indexOf(match) === 0) {
					return cookie.substring(match.length, cookie.length);
				}
			}

			return null;
		},
		reloadPage: () => {
			$window.location.reload();
		},
		/**
		 * Create a copy of an object with all decorators removed.
		 * A decorator is identified as any property that doesn't begin with an uppercase letter.
		 * @param {Object} obj - object from which to strip decorators
		 * @returns - a copy of the object with decorators removed
		 */
		 removeDecorators: (obj) => {
			// If a simple type or null (typeof null === 'object'!), return it.
			if (typeof obj !== 'object' || obj === null) {
				return obj;
			}
			// Create copy for populating
			let objCopy = {};
			// Go through properties on object
			Object.keys(obj).forEach(propertyName => {
				// Get first character of property name
				const initChar = propertyName[0];
				// Only retain the property in the copy if it begins with an uppercase letter
				if (initChar >= 'A' && initChar <= 'Z') {
					// Get the property value for convienience
					const propertyValue = obj[propertyName];
					// Set property on copy depending on property value type
					if (Array.isArray(propertyValue)) {
						// It's an array, copy each item to a new array
						objCopy[propertyName] = [];
						propertyValue.forEach(item => {
							// Create copy of array item without decorators
							objCopy[propertyName].push(service.removeDecorators(item));
						});
					}
					else if (typeof propertyValue === 'object') {
						// The property is another object. Create a copy of it without decorators
						objCopy[propertyName] = service.removeDecorators(propertyValue);
					}
					else {
						// Simple non-reference value, just assign
						objCopy[propertyName] = propertyValue;
					}
				}
			});
			return objCopy;
		},
		removeDuplicatesFromArrayByObjectProperty: (myArr, propertyName) => {

		    return myArr.filter((obj, pos, arr) => {
		        return arr.map(mapObj => mapObj[propertyName]).indexOf(obj[propertyName]) === pos;
		    });
		},
		removeDuplicatesFromArrayOfStrings: array => {
			return Array.from(new Set(array));
		},
		removeFromStoredArray: (arrKey, itemKey, guid) => {

			let array = service.getStoredArray(arrKey);

			// Find item
			const itemIndex = array.findIndex(arrayItem => arrayItem === `${itemKey}-${guid}`);

			// Remove and reinstate in storage if found. If not found, nothing happens.
			if (itemIndex !== -1) {
				array.splice(itemIndex, 1);
				service.addToStorage(arrKey, array.join(','));
			}

		},
		removeHyphens: function (str) {

			return str.replace(/-/g, '');
		},
		removeSpaces: function (str) {

			return str.replace(/\s/g, '');
		},
		roundTo: function (n, digits) {

			var negative = false;

			// Default digits
			if (digits === undefined) {
				digits = 0;
			}

			// Negative numbers
			if (n < 0) {
				negative = true;
			  	n = n * -1;
			}

			var multiplicator = Math.pow(10, digits);

			n = parseFloat((n * multiplicator).toFixed(11));
			n = (Math.round(n) / multiplicator).toFixed(2);

			if (negative) {
				n = (n * -1).toFixed(2);
			}

			return parseFloat(n);
		},
		separateIPv4Address: function (ipAddress) {

			// Validate and split an IP address out into its constituent parts. Return nowt if it's invalid.
			if (!angular.isDefined(ipAddress) || ipAddress === null || !angular.isDefined(ipAddress.split)) {
				// No ip address or can't split it, no dice.
				return;
			}

			const ipAddressParts = ipAddress.split('.');
			if (ipAddressParts.length !== 4) {
				// Needs four parts
				return;
			}

			// Each part needs to be valid
			for (let i = 0, ii = ipAddressParts.length; i < ii; i++) {
				if (!this.isValidIPv4AddressPart(ipAddressParts[i])) {
					return;
				}
			}

			// All good.
			return ipAddressParts;
		},
		serialiseObj: function (obj) {

			var result = [];

			for (var property in obj) {
				if (obj[property] && obj[property] !== undefined && obj[property] !== '') {
					result.push(encodeURIComponent(property) + '=' + encodeURIComponent(obj[property]));
				}
			}

			return result.join('&');
		},
		setAnyPropertiesToEmptyIfZero: function (obj) {

			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					obj[key] = obj[key] !== 0 ? obj[key] : '';
				}
			}

			return obj;
		},
		setAnyPropertiesToZeroIfEmpty: function (obj) {

			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					obj[key] = obj[key] !== '' ? obj[key] : 0;
				}
			}

			return obj;
		},
		setAnyPropertiesToValueIfNull: (obj, value) => {

			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {

					// if array of objects then set those propterties too
					if (angular.isArray(obj[key])) {
						if (obj[key].length > 0 && angular.isObject(obj[key][0])) {
							for (let arrayObj of obj[key]) {
								service.setAnyPropertiesToValueIfNull(arrayObj, value);
							}
						}

					} else {
						obj[key] = obj[key] === null ? value : obj[key];
					}
				}
			}

			return obj;
		},
		setPropertiesValuesToEmptyIfZero: function (propertyObj, propertyKeysArr) {

			propertyKeysArr.forEach(propertyKey => {
				propertyObj[propertyKey] = service.setPropertyValueToEmptyIfZero(propertyObj[propertyKey]);
			});
		},
		setPropertiesValuesToZeroIfEmpty: function (propertyObj, propertyKeysArr) {

			propertyKeysArr.forEach(propertyKey => {
				propertyObj[propertyKey] = service.setPropertyValueToZeroIfEmpty(propertyObj[propertyKey]);
			});
		},
		setPropertiesValuesToZeroIfNull: function (propertyObj, propertyKeysArr) {

			propertyKeysArr.forEach(propertyKey => {
				propertyObj[propertyKey] = service.setPropertyValueToZeroIfNull(propertyObj[propertyKey]);
			});
		},
		setPropertyValueToEmptyIfZero: function (propertyValue) {

			return propertyValue === 0 ? '' : propertyValue;
		},
		setPropertyValueToNullIfEmptyGuid: function (propertyValue) {

			return propertyValue === config.guidEmpty ? null : propertyValue;
		},
		setPropertyValueToNullIfEmptyString: function (propertyValue) {

			return propertyValue === '' ? null : propertyValue;
		},
		setPropertyValueToNullIfZero: function (propertyValue) {

			return propertyValue === 0 ? null : propertyValue;
		},
		setPropertyValueToZeroIfEmpty: function (propertyValue) {

			return propertyValue === '' ? 0 : propertyValue;
		},
		setPropertyValueToZeroIfNull: function (propertyValue) {

			return propertyValue === null ? 0 : propertyValue;
		},
		shuffleArray: function (array) {

			var m = array.length, t, i;

			// While there remain elements to shuffle
			while (m) {
				// Pick a remaining element…
				i = Math.floor(Math.random() * m--);

				// And swap it with the current element.
				t = array[m];
				array[m] = array[i];
				array[i] = t;
			}

			return array;
		},
		slugify: function (string) {

			if (!string) {
				return '';
			}

			// Lowercase / trim
			var slug = string.toLowerCase().trim();

			// Replace invalid chars with spaces
			slug = slug.replace(/[^a-z0-9\s-]/g, ' ');

			// Replace multiple spaces or hyphens with a single hyphen
			slug = slug.replace(/[\s-]+/g, '-');

			return slug;
		},
		// Convert ' A string Like This ' to snake case, 'a-string-like-this'. (It gets trimmed too)
		snakeCase: function (string) {
			return string.toLowerCase().trim().split(' ').join('-');
		},
		stripError: function (error) {

			// Check if returned data object is a string that starts with 'ERROR'
			if (typeof error === 'string' && error.substring(0, 7) === '"ERROR:') {

				if (error.substring(error.length - 1) === '"') {
					error = error.substring(0, error.length - 1);
				}

				return error.substring(8);
			}
			if (typeof error === 'string' && error.substring(0, 6) === 'ERROR:') {
				return error.substring(7);
			}
			if (typeof error === 'string' && error.substring(0, 5) === 'ERROR') {
				return error.substring(6);
			}

			// Return the error intact if it hasn't been fiddled with
			return error;
		},
		stripCurrencySymbol: function (value) {

			// Check if returned data object is a string that starts with 'ERROR'
			if (typeof value === 'string' && value.substring(0, 1) === '£') {

				value = value.split();
				return value[0];

			}
		},
		toCamelCase: function (str) {

			if (!str || str === '' || str === undefined) {
				return '';
			}

			return str
				.replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
				.replace(/\s/g, '')
				.replace(/^(.)/, function($1) { return $1.toLowerCase(); });
		},
		toggleBrowserFullScreen: element => {

			element = element || document.documentElement;

			if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
				if (element.requestFullScreen) {
					element.requestFullScreen();
				}
				else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				}
				else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
				}
			}
			else {
				if (document.cancelFullScreen) {
					document.cancelFullScreen();
				}
				else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				}
				else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				}
			}
		},
		tokenise: function (data) {

			if (data === undefined || data === null) {
				data = {};
			}

			angular.extend(data, {
				'AuthString': service.getToken()
			});

			return data;
		},
		truncate: (string, length, includeQuotes) => {

			if (angular.isUndefined(string)) {
				return string;
			}

			if (string.length > length) {
				string = `${string.slice(0, length)}&#8230;`;
			}

			if (includeQuotes) {
				string = `&#8220;${string}&#8221;`;
			}

			return string;
		},
		userHasRole: function (user, roles) {

			if (!user) {
				return false;
			}

			// If multiple roles, only use primary role
			var userPrimaryRole = service.getPrimaryRole(user.UserResponseRoles);

			// User has no roles assigned
			if (!userPrimaryRole) {
				console.warn('User has no roles assigned');
				return false;
			}

			// Make authorised roles an array if it's a string - future proofing
			if (!angular.isArray(roles)) {
				roles = [roles];
			}

			var noRoles = roles.length;
			var i = 0;

			for (i; i < noRoles; i++) {

				// All other roles (get roles from set user roles)
				if (roles[i] === userPrimaryRole) {
					return true;
				}
			}

			return false;
		},
		toSentenceCase: function (str) {
			// Convert 'this sentence and so on and so forth' to 'This sentence and so on and so forth'
			return str.charAt(0).toUpperCase() + str.substr(1);
		},
		toTitleCase: function (str) {
			return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
		},
		/* For embedding fixed descriptions (in Sentence case) into other text where the Sentence case needs to be undone.
		   There might be a better name for this. All it does is loweer case the first character of a string. */
		toUnsentenceCase: function (str) {
			// Convert 'This sentence AND SO ON and So Forth' to 'this sentence AND SO ON and So Forth'
			return str.charAt(0).toLowerCase() + str.substr(1);
		}
	};

	return service;
}]);

'use strict';

/**
 * Service used for validation across the application
 */
angular.module('paycircleApp')
.service('validationService', ['config', 'REGEX', function (config, REGEX) {

	var service = {
		isEmpty: function (obj) {

			var hasOwnProperty = Object.prototype.hasOwnProperty;

			// null and undefined are "empty"
			if (obj === null) { return true; }
			if (obj === undefined) { return true; }

			// Assume if it has a length property with a non-zero value
			// that that property is correct.
			if (obj.length > 0) { return false; }
			if (obj.length === 0) { return true; }

			// Otherwise, does it have any properties of its own?
			// Note that this doesn't handle
			// toString and valueOf enumeration bugs in IE < 9
			for (var key in obj) {
				if (hasOwnProperty.call(obj, key)) { return false; }
			}

			return true;
		},
		isEmptyGuid: function (guid) {

			return guid === config.guidEmpty;
		},
		isNotDefined: function (property) {

			return property === '';
		},
		isValidDate: function (date) {

			return REGEX.date.test(date);
		},
		isValidEmail: function (email) {

			return REGEX.email.test(email);
		},
		isValidGender: function (gender) {

			if (!gender || gender === undefined || gender === '') {
				return false;
			}

			switch (gender) {
				case 'Male':
				case 'M':
				case 'm':
				case 'Female':
				case 'F':
				case 'f':
					return true;
				default:
					return false;
			}
		},
		isValidGuid: function (guid) {

			return REGEX.guid.test(guid);
		},
		isValidLettersAndNumbers: function (value) {

			return REGEX.lettersAndNumbers.test(value);
		},
		isValidName: function (name) {

			return REGEX.name.test(name);
		},
		isValidNI: function (niNumber) {

			return REGEX.NI.test(niNumber);
		},
		isValidPassword: function (password) {

			return REGEX.paycirclePasswordWeak.test(password);
		},
		isValidPostcode: function (toCheck) {

			// Permitted letters depend upon their position in the postcode.
			var alpha1 = '[abcdefghijklmnoprstuwyz]';                       // Character 1
			var alpha2 = '[abcdefghklmnopqrstuvwxy]';                       // Character 2
			var alpha3 = '[abcdefghjkpmnrstuvwxy]';                         // Character 3
			var alpha4 = '[abehmnprvwxy]';                                  // Character 4
			var alpha5 = '[abdefghjlnpqrstuwxyz]';                          // Character 5
			var BFPOa5 = '[abdefghjlnpqrst]';                               // BFPO alpha5
			var BFPOa6 = '[abdefghjlnpqrstuwzyz]';                          // BFPO alpha6

			// Array holds the regular expressions for the valid postcodes
			var pcexp = [];

			// BFPO postcodes
			pcexp.push (new RegExp ('^(bf1)(\\s*)([0-6]{1}' + BFPOa5 + '{1}' + BFPOa6 + '{1})$','i'));

			// Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}' + alpha2 + '?[0-9]{1,2})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Expression for postcodes: ANA NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}[0-9]{1}' + alpha3 + '{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Expression for postcodes: AANA  NAA
			pcexp.push (new RegExp ('^(' + alpha1 + '{1}' + alpha2 + '{1}' + '?[0-9]{1}' + alpha4 +'{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$','i'));

			// Exception for the special postcode GIR 0AA
			pcexp.push (/^(GIR)(\s*)(0AA)$/i);

			// Standard BFPO numbers
			pcexp.push (/^(bfpo)(\s*)([0-9]{1,4})$/i);

			// c/o BFPO numbers
			pcexp.push (/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

			// Overseas Territories
			pcexp.push (/^([A-Z]{4})(\s*)(1ZZ)$/i);

			// Anguilla
			pcexp.push (/^(ai-2640)$/i);

			// Load up the string to check
			var postCode = toCheck;

			// Assume we're not going to find a valid postcode
			var valid = false;

			// Check the string against the types of post codes
			for ( var i=0; i<pcexp.length; i++) {

				if (pcexp[i].test(postCode)) {

					// The post code is valid - split the post code into component parts
					pcexp[i].exec(postCode);

					// Copy it back into the original string, converting it to uppercase and inserting a space
					// between the inward and outward codes
					postCode = RegExp.$1.toUpperCase() + ' ' + RegExp.$3.toUpperCase();

					// If it is a BFPO c/o type postcode, tidy up the "c/o" part
					postCode = postCode.replace (/C\/O\s*/,'c/o ');

					// If it is the Anguilla overseas territory postcode, we need to treat it specially
					if (toCheck.toUpperCase() === 'AI-2640') {
						postCode = 'AI-2640';
					}

					// Load new postcode back into the form element
					valid = true;

					// Remember that we have found that the code is valid and break from loop
					break;
				}
			}

			// Return with either the reformatted valid postcode or the original invalid postcode
			return valid;
		},
		isValidTaxCode: function (toCheck) {

			// Convert given tax code to uppercase
			toCheck = toCheck.toUpperCase();

			// Remove spaces from the tax code to help validation
			while (toCheck.indexOf(' ') !== -1)  {
				toCheck = toCheck.slice(0,toCheck.indexOf(' ')) + toCheck.slice(toCheck.indexOf(' ') + 1);
			}

			// Set up the regular expression for valid tax codes
			var exp = /(^[1-9]{1}[0-9]{0,5}[TLPVY]([MW]1){0,1}$)|(^K[1-9]{1}[0-9]{0,5}([MW]1){0,1}$)|(^((BR)|(OT)|(D0)|(NT)|(FT))([MW]1){0,1}$)/;

			// Check the code
			if (toCheck.match(exp)) {

				// Enforce a space before any M1 or W1
				exp = /^(.+)([MW]1)$/;
				if (toCheck.match (exp)) {
					var namelist = [];
					namelist [0] = toCheck.slice (0,-2);
					namelist [1] = toCheck.slice (-2);
					toCheck = namelist[0] + ' ' + namelist[1];
				}

				// Valid - return the tax code in uppercase with spaces removed
				return toCheck;
			}
			else {

				// Invalid - return false
				return false;
			}
		}
	};

	return service;
}]);

'use strict';

/* global WootricSurvey */

angular.module('paycircleApp')
.service('wootricService', [
	'$rootScope',
	'$state',
	'$timeout',
	'$window',
	'config',
	'utilities',
	function (
		$rootScope,
		$state,
		$timeout,
		$window,
		config,
		utilities
	) {

	const wootricService = {

		getDeviceOS: () => {
			const userAgent = $window.navigator.userAgent.toLowerCase();
			const platform = $window.navigator.platform.toLowerCase();

			if (/iphone|ipad|ipod/.test(userAgent)) {
				return 'iOS';
			} else if (/android/.test(userAgent)) {
				return 'Android';
			} else if (/mac/.test(platform)) {
				return 'macOS';
			} else if (/win/.test(platform)) {
				return 'Windows';
			} else if (/linux/.test(platform)) {
				return 'Linux';
			} else {
				return 'Unknown';
			}
		},

		getPageName: () => {
			const stateName = $state.current.name;
			if (!stateName) {
				return 'unknown';
			}
			return stateName.replace(/\./g, '-');
		},

		isWootricAvailable: () => {
			if ($window.wootric !== undefined) {
				return true;
			} else {
				console.warn('Wootric SDK not loaded');
				return false;
			}
		},

		stopSurvey: () => {
			if (wootricService.isWootricAvailable()) {
				WootricSurvey.stop();
			}
		},

		triggerSurvey: () => {
			if (!$rootScope.isLoggedIn) {
				return;
			}

			const currentUser = $rootScope.currentUser;
			if (!currentUser || !currentUser.UserResponseUserID) {
				return;
			}

			const userId = currentUser.UserResponseUserID;
			const emailAddress = currentUser.UserResponseContactEmail;

			const wootricConfig = utilities.isEnvironmentProduction ? config.wootric.production : config.wootric.test;

			if (!wootricConfig.enable) {
				return;
			}

			if (emailAddress) {
				const excludedDomains = wootricConfig.excluded_domains;
				const emailIsExcluded = excludedDomains.some(function (domain) {
					return emailAddress.toLowerCase().indexOf(domain.toLowerCase()) > -1;
				});

				if (emailIsExcluded) {
					return;
				}
			}

			if (!wootricService.isWootricAvailable()) {
				return;
			}

			const pageName = wootricService.getPageName();
			const customerName = currentUser.AgencyProfileName || 'Unknown';
			const userRole = utilities.getPrimaryRole(currentUser.UserResponseRoles) || 'Unknown';
			const productName = wootricConfig.product_name;
			const deviceOS = wootricService.getDeviceOS();
			const accountToken = wootricConfig.accountToken;
			const testMode = wootricConfig.test_mode;

			if (testMode) {
				$window.wootric_no_surveyed_cookie = true;
				$window.wootric_survey_immediately = true;
			}

			$window.wootricSettings = {
				email: userId,
				modal_theme: 'Light',
				account_token: accountToken,
				properties: {
					pageName: pageName,
					product: productName,
					customerName: customerName,
					userRole: userRole,
					productReportingCode: wootricConfig.product_code,
					deviceOS: deviceOS
				},
				disclaimer: {
					text: 'Learn how we handle your feedback',
					link: 'https://www.theaccessgroup.com/en-gb/privacy-notice-for-access-products/',
					link_word: 'here'
				}
			};

			$window.wootric('run');
		}
	};

	return wootricService;
}]);

'use strict';

angular.module('paycircleApp')
.service('workflowService', ['$q', '$rootScope', 'config', 'logService', 'messageData', 'MESSAGE_TYPES', 'USER_ROLES', 'WORKFLOW_STEPS', 'WORKFLOW_TEMPLATE_STATES',
	function ($q, $rootScope, config, logService, messageData, MESSAGE_TYPES, USER_ROLES, WORKFLOW_STEPS, WORKFLOW_TEMPLATE_STATES) {

	var service = {

		decorateWorkflowTemplate: function (workflowTemplateObj) {

			if (!workflowTemplateObj) {
				return workflowTemplateObj;
			}

			workflowTemplateObj.TemplateEntries.forEach(service.decorateWorkflowTemplateEntry);

			service.decorateWorkflowTemplateEntry(workflowTemplateObj.TemplateEntryCurrent);

			workflowTemplateObj.changesTableIsEnabled = service.isChangesTableEnabled(workflowTemplateObj.TemplateEntryCurrent);
			workflowTemplateObj.showWorkflowActions = workflowTemplateObj.TemplateEntryCurrent ? workflowTemplateObj.TemplateEntryCurrent.BureauDisplay || workflowTemplateObj.TemplateEntryCurrent.ActionerID === $rootScope.currentUser.UserResponseUserID : false;

			return workflowTemplateObj;
		},

		decorateWorkflowTemplateEntry: function (workflowTemplateEntryObj) {

			if (!workflowTemplateEntryObj) {
				return;
			}

			function getBureauDisplayOption (workflowTemplateEntryObj) {

				if ($rootScope.currentUser.hasTempPermissions) {
					// BureauDisplay is based on the logged in user, so this is the same logic but for when we're viewing a different role
					return ![USER_ROLES.companyadministrator, USER_ROLES.companyadministratorlite, USER_ROLES.groupadminlite, USER_ROLES.groupuser].includes($rootScope.currentUser.primaryRole) || workflowTemplateEntryObj.ActionerID === $rootScope.currentUser.viewingAs.userId;
				}

				return workflowTemplateEntryObj.BureauDisplay;
			}

			workflowTemplateEntryObj.BureauDisplay = getBureauDisplayOption(workflowTemplateEntryObj);
			workflowTemplateEntryObj.primaryActionText = service.getWorkflowTemplateEntryPrimaryActionText(workflowTemplateEntryObj);
		},

		getWorkflowTemplateEntryPrimaryActionText: function (workflowTemplateEntryObj) {

			if (!workflowTemplateEntryObj) {
				return;
			}

			switch (workflowTemplateEntryObj.Number) {

				case WORKFLOW_STEPS.payrollInformation:
					return `I've added everything`;
				case WORKFLOW_STEPS.payrollCalculation:
					return 'Confirm calculation';
				case WORKFLOW_STEPS.payrollConfirmation:
					return 'Approve reports';
				case WORKFLOW_STEPS.runPayroll:
					return 'Run payroll';
			}
		},

		isChangesTableEnabled: workflowTemplateEntryObj => {

			if (!workflowTemplateEntryObj) {
				return false;
			}

			if ($rootScope.userHasRole([USER_ROLES.groupadminlite, USER_ROLES.companyadministratorlite])) {
				return (workflowTemplateEntryObj.Number === 1);
			} else {
				return (workflowTemplateEntryObj.Number === 1 || workflowTemplateEntryObj.Number === 2);
			}

			return false;
		},

		isWorkflowActive: function (companyObj, workflowTemplatesArr) {

			return companyObj.IsWorkflowEnabled && workflowTemplatesArr.length && workflowTemplatesArr[0].State === WORKFLOW_TEMPLATE_STATES.active;
		},

		decorateWorkflowActivityLogForGrouping: function (workflowActivityLogArr) {

			/* This is all about enforcing a hierarchical like structure over a list, in order to display appropriate
			   date dividers and item separators in the UI, whilst enabling the built-in search mechanism, which has to be
			   applied over a flat list. Create a group ID for each entry, as well as metadata for presentation. */
			workflowActivityLogArr.forEach(workflowActivityLogEntry => {
				workflowActivityLogEntry.groupID = moment(workflowActivityLogEntry.LogDateISO).format('YYYYMMDD');
				workflowActivityLogEntry.logMetadata = logService.getLogMetaForWorkflowStepLogEntry(workflowActivityLogEntry);
			});

			/* Decorate items with indicators for new group (i.e. a point where a date divider is required) and
			   last of group, to allow distinct styling to be applied to those. */
			let currentGroupName;
			let previousItem;
			workflowActivityLogArr.forEach(item => {
				let newGroup = (!currentGroupName || currentGroupName !== item.groupID);
				item.newGroup = newGroup;
				if (newGroup) {
					currentGroupName = item.groupID;
					if (previousItem) {
						previousItem.lastOfGroup = newGroup;
					}
				}
				previousItem = item;
			});
			/* The last thing of all should be considered the last of the group, but the above shennanigans
			   won't detect that */
			previousItem.lastOfGroup = true;
		},

		refreshUserTasks: (agencyProfileId, userId) => {

			$rootScope.userTasks = null;

			const getPayrollTasks = messageData.getMessagesForRecipient(agencyProfileId, userId);
			const getWorkflowTasks = messageData.getWorkflowTemplateCurrentEntriesForUser(agencyProfileId);

			return $q((onComplete, onError) => {
				$q.all([getPayrollTasks, getWorkflowTasks]).then(([payrollTasksArr, workflowTasksArr]) => {

					let userTasksObj = {
						payroll: payrollTasksArr,
						workflow: workflowTasksArr,
						count: payrollTasksArr.length + workflowTasksArr.length
					};

					$rootScope.userTasks = userTasksObj;
					service.updateUserTasksCount();

					onComplete(userTasksObj);
				})
				.catch(onError);
			});
		},

		removeStoredTasks: () => {
			$rootScope.userTasks = null;
		},

		updateUserTasksCount: () => {

			let userTasks = $rootScope.userTasks;

			// Count workflow tasks due today or overdue and payroll tasks that are incomplete
			let dueCount = 0;
			dueCount += userTasks.payroll.reduce((count, task) => {
				return (count + (task.IsComplete ? 0 : 1));
			}, 0);
			dueCount += userTasks.workflow.reduce((count, task) => {
				return (count + ((task.IsOverdue || moment(task.DueDateISO).isSame(moment(), 'day')) ? 1 : 0));
			}, 0);

			userTasks.dueCount = dueCount;
		}
	};

	return service;
}]);

'use strict';

/**
 * @ngdoc Wizard Service
 * @name paycircleApp.wizardService
 * @description
 * # Wizard Service
 */
angular.module('paycircleApp')
.service('wizardService', [
	'$q',
	'$rootScope',
	'teamData',
	'FORM_WIZARD_KEYS',
	function (
		$q,
		$rootScope,
		teamData,
		FORM_WIZARD_KEYS
	) {

	const service = {

		getRedundantCompanyPensionSetupForms: pensionObj => {

			if (pensionObj.IsGhostPension) {
				return ['add-new-company-pension-provider', 'add-new-company-pension-settings', 'add-new-company-pension-groups'];

			} else {
				return [];
			}
		},

		getTeamMemberFinishedForm: formsArr => {
			formsArr.push(
				{
					formKey: 'finished-adding-team-member',
					state: 0
				}
			);
		},

		getTeamMemberInformation: formOptionsObj => {

			const deferred = $q.defer();

			// Use object set at form wizard level
			if (angular.isObject(formOptionsObj.teamMemberInformation)) {
				deferred.resolve(formOptionsObj.teamMemberInformation);
			}

			// Make call to service
			else {

				teamData.getTeamMemberInformation(formOptionsObj.userId, formOptionsObj.agencyProfileId).then(teamMemberObj => {
					deferred.resolve(teamMemberObj);
				})
				.catch(error => {
					deferred.reject(error);
				});
			}

			return deferred.promise;
		},

		getWizardLastFormIndex: wizardKey => {

			let formsArray;

			switch (wizardKey) {

				case FORM_WIZARD_KEYS.companyPayroll:
					formsArray = service.getWizardCompanyPayrollForms();
					break;
			}

			return formsArray.length - 1;
		},

		// Returns a list of forms for the company wizard
		getWizardCompanyForms: () => {

			// Basic company forms (inc. payroll)
			const forms = [
				{
					formKey: 'add-new-company',
					state: 0
				},
				{
					formKey: 'add-new-company-modules',
					state: 0
				},
				{
					formKey: 'add-new-company-payroll',
					state: 0
				},
				{
					formKey: 'add-new-company-pay-periods',
					state: 0
				},
				{
					formKey: 'add-new-company-additional-info',
					state: 0
				}
			];

			// If CIS only, or Pension only, remove last form
			if (service.newCompany &&
				!service.newCompany.IsPayrollActive &&
				(
					(service.newCompany.IsCISActive && !service.newCompany.IsPensionActive) ||
					(!service.newCompany.IsCISActive && service.newCompany.IsPensionActive)
				)
			) {
				forms.pop();
			}

			// If pension module, but pension deferred, just include the pension ghost form, where the deferred option lives
			if (service.newCompany && service.newCompany.IsPensionActive) {
				forms.push(
					{
						formKey: 'add-new-company-pension-ghost',
						state: 0
					}
				);
				if (!service.newCompany.isPensionSchemeSetupDeferred) {
					forms.push(
						{
							formKey: 'add-new-company-pension-provider',
							state: 0
						},
						{
							formKey: 'add-new-company-pension-automation',
							state: 0
						},
						{
							formKey: 'add-new-company-pension-staging',
							state: 0
						},
						{
							formKey: 'add-new-company-pension-settings',
							state: 0
						},
						{
							formKey: 'add-new-company-pension-postponement',
							state: 0
						},
						{
							formKey: 'add-new-company-pension-groups',
							state: 0
						}
					);
					// Removed redundant pension setup forms (based on setup)
					const unusedPensionWizardStepsArr = service.getRedundantCompanyPensionSetupForms(service.newPension);
					for (let unusedStep of unusedPensionWizardStepsArr) {
						forms.splice(forms.findIndex(wizardStep => wizardStep.formKey === unusedStep), 1);
					}
				}
			}

			// Finished state
			forms.push(
				{
					formKey: 'finished-adding-new-company',
					state: 0
				}
			);

			return forms;
		},

		// Returns a list of forms for the company wizard
		getWizardCompanyPayrollForms: () => {

			// Basic company forms (inc. payroll)
			return [
				{
					formKey: 'company-settings-payroll-settings',
					state: 0
				},
				{
					formKey: 'company-settings-support-contact',
					state: 0
				},
				{
					formKey: 'company-settings-work-durations',
					state: 0
				},
				{
					formKey: 'company-settings-calculation-method',
					state: 0
				},
				{
					formKey: 'company-settings-employer',
					state: 0
				},
				{
					formKey: 'company-settings-directors-ni',
					state: 0
				},
				{
					formKey: 'company-payroll-overview',
					state: 0
				}
			];
		},

		// Probably can be removed completely with its entire flow.
		// Returns list of forms for HR setup
		getHRSetupWizardForms: () => {
			return [
				{
					formKey: 'company-settings-holiday-policy',
					state: 0
				},
			];
		},

 		// Returns list of forms for team member setup
		getWizardTeamMemberForms: function (formGroupKey, teamMemberObj, currentPayPeriodObj, teamMemberWizardPensionObj) {

			switch (formGroupKey) {

				case 'cis-company':

					const cisCompanyFormsArr = [
						{
							formKey: 'cis-company-details',
							state: teamMemberObj.CISCompanyDetailsComplete ? 1 : 0
						},
						{
							formKey: 'cis-company-contact',
							state: teamMemberObj.CISCompanyContactComplete ? 1 : 0
						},
						{
							formKey: 'payment-details',
							state: teamMemberObj.BankSetupComplete ? 1 : 0
						},
						{
							formKey: 'finished-adding-team-member',
							state: 0
						}
					];

					service.getTeamMemberFinishedForm(cisCompanyFormsArr);

					return cisCompanyFormsArr;

				case 'cis-subcontractor':

					const cisSubcontractorFormsArr = [
						{
							formKey: 'cis-business-type',
							state: teamMemberObj.BusinessSetupComplete ? 1 : 0
						},
						{
							formKey: 'cis-vat',
							state: teamMemberObj.VATSetupComplete ? 1 : 0
						},
						{
							formKey: 'cis-verification',
							state: teamMemberObj.VerificationSetupComplete ? 1 : 0
						},
						{
							formKey: 'finished-adding-team-member',
							state: 0
						}
					];

					service.getTeamMemberFinishedForm(cisSubcontractorFormsArr);

					return cisSubcontractorFormsArr;

				case 'personal':

					const personalFormsArr = [];

					if (teamMemberObj !== undefined) { // Edit
						personalFormsArr.push(
							{
								formKey: 'personal',
								state: teamMemberObj.PersonalSetupComplete ? 1 : 0
							},
							{
								formKey: 'email-address',
								state: teamMemberObj.EmailSetupComplete ? 1 : 0
							},
							{
								formKey: 'address',
								state: teamMemberObj.AddressSetupComplete ? 1 : 0
							},
							{
								formKey: 'telephone',
								state: teamMemberObj.TelephoneSetupComplete ? 1 : 0
							},
							{
								formKey: 'payment-details',
								state: teamMemberObj.BankSetupComplete ? 1 : 0
							}
						);

					} else { // Add
						personalFormsArr.push(
							{
								formKey: 'personal',
								state: 0
							},
							{
								formKey: 'email-address',
								state: 0
							},
							{
								formKey: 'address',
								state: 0
							},
							{
								formKey: 'telephone',
								state: 0
							},
							{
								formKey: 'payment-details',
								state: 0
							}
						);
					}

					service.getTeamMemberFinishedForm(personalFormsArr);

					return personalFormsArr;
				case 'employment':

					const employmentFormsArr = [
						{
							formKey: 'company-details',
							state: teamMemberObj.CompanySetupComplete ? 1 : 0
						}
					];

					if (!teamMemberObj.Company.IsOffPayrollWorker) {
						employmentFormsArr.push(
							{
								formKey: 'pay-information',
								state: teamMemberObj.SalarySetupComplete ? 1 : 0
							}
						);
					}

					if (teamMemberObj.Company.IsStarter) {
						employmentFormsArr.push(
							{
								formKey: 'starter-information',
								state: teamMemberObj.StarterSetupComplete ? 1 : 0
							}
						);
					} else {
						if (currentPayPeriodObj.IsYTDInformationRequired) {
							employmentFormsArr.push(
								{
									formKey: 'payments-to-date',
									state: teamMemberObj.YTDSetupComplete ? 1 : 0
								}
							);
						}
					}

					if ((teamMemberObj.Company.IsStarter && teamMemberObj.Tax.IsP45Available) || !teamMemberObj.Company.IsStarter) {
						employmentFormsArr.push(
							{
								formKey: 'tax-status',
								state: teamMemberObj.TaxSetupComplete ? 1 : 0
							}
						);
					}

					service.getTeamMemberFinishedForm(employmentFormsArr);

					return employmentFormsArr;

				case 'ae-pension':

					const aePensionFormsArr = [
						{
							formKey: 'pension-team-scheme-ae',
							state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
						}
					];

					if (!teamMemberWizardPensionObj.IsGhostPension) {

						aePensionFormsArr.push({
							formKey: 'pension-team-status',
							state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
						});

						// Bands for pension policy based pension, groups otherwise
						if (teamMemberWizardPensionObj.UsePensionPolicy) {
							aePensionFormsArr.push({
								formKey: 'pension-team-bands',
								state: teamMemberWizardPensionObj.PensionGroupSetupComplete ? 1 : 0
							});
						}
						else {
							aePensionFormsArr.push({
								formKey: 'pension-team-groups',
								state: teamMemberWizardPensionObj.PensionGroupSetupComplete ? 1 : 0
							});
						}

						aePensionFormsArr.push({
							formKey: 'pension-team-contributions-ae',
							state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
						});

						if (teamMemberWizardPensionObj.CanBeSalarySacrifice) {
							aePensionFormsArr.push({
								formKey: 'pension-team-salary-sacrifice',
								state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
							});
						}
					}

					service.getTeamMemberFinishedForm(aePensionFormsArr);

					return aePensionFormsArr;

				case 'non-ae-pension':

					const nonAePensionFormsArr = [
						{
							formKey: 'pension-team-scheme-non-ae',
							state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
						},
						{
							formKey: 'pension-team-contributions-non-ae',
							state: teamMemberWizardPensionObj.PensionSetupComplete ? 1 : 0
						}
					];

					service.getTeamMemberFinishedForm(nonAePensionFormsArr);

					return nonAePensionFormsArr;

				default:
					$rootScope.paycircleMessage('Wizard Service: No form group key matched', 'error');
			}
		},

		resetCompany: function () {

			this.newCompany = null;
		},

		resetPension: function () {

			this.newPension = null;
		},

		saveCompany: function (companyObj) {

			service.newCompany = companyObj;
		},

		savePension: function (pensionObj) {

			service.newPension = pensionObj;
		},

		// The basic skeleton needed for the creation of companies
		newCompany: null,

		// The basic skeleton of the pension object used to create a new company/pension
		newPension: null
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('workPatternService', [
	'$filter',
	'utilities',
	'DAYS_OF_WEEK',
	'EMPLOYMENT_TYPES',
	'PAY_PERIOD_TYPES',
	'SIMPLE_WORK_PATTERN_DAYS',
	'WORK_PATTERN_BASIS',
	'WORK_PATTERN_DAY_TYPES',
	'WORK_PATTERN_GROUPS',
	function (
		$filter,
		utilities,
		DAYS_OF_WEEK,
		EMPLOYMENT_TYPES,
		PAY_PERIOD_TYPES,
		SIMPLE_WORK_PATTERN_DAYS,
		WORK_PATTERN_BASIS,
		WORK_PATTERN_DAY_TYPES,
		WORK_PATTERN_GROUPS
	) {

	var service = {

		convertDaysToWeeks: (workPatternDays) => {

			return utilities.groupArray(workPatternDays, 7);
		},

		decorateCompanyWorkPatterns: (companyWorkPatternsArray) => {

			companyWorkPatternsArray.forEach((workPatternObj) => {
				workPatternObj = service.decorateWorkPattern(workPatternObj);
			});

			return companyWorkPatternsArray;
		},

		decorateTeamMemberWorkPattern: (workPatternObj) => {

			workPatternObj = service.decorateWorkPattern(workPatternObj);

			return workPatternObj;
		},

		decorateTeamMemberWorkPatterns: (workPatternsArr) => {

			workPatternsArr.forEach((workPatternObj) => {
				workPatternObj = service.decorateWorkPattern(workPatternObj);
			});

			return workPatternsArr;
		},

		decorateWorkPattern: (workPatternObj) => {

			workPatternObj.theme = service.getWorkPatternTheme(workPatternObj);
			workPatternObj.weeks = service.convertDaysToWeeks(workPatternObj.Days);

			workPatternObj = service.updateDays(workPatternObj);

			return workPatternObj;
		},

		generateDaysForWeeks: (workPatternDays) => {

			// Make sure there are 7 days
			while (workPatternDays.length % 7 > 0) {
				workPatternDays.push(angular.copy(workPatternDays[0]));
			}

			return workPatternDays;
		},

		getCompanyWorkPatternsForEmploymentType: (companyWorkPatternsArr, employmentType) => {

			const workPatternGroup = service.getWorkPatternGroupForEmploymentType(employmentType);

			return angular.copy(companyWorkPatternsArr).filter((companyWorkPatternObj) => {

				return companyWorkPatternObj.Group === workPatternGroup;
			});
		},

		getDefaultWorkPatternForEmploymentType: (companyWorkPatternsArr, employmentType) => {

			const workPatternsArr = service.getCompanyWorkPatternsForEmploymentType(companyWorkPatternsArr, employmentType);

			return workPatternsArr[0];
		},

		getDefaultWorkPatternsArrForEmploymentType: (companyWorkPatternsArr, employmentType) => {

			const defaultWorkPatternObj = service.getDefaultWorkPatternForEmploymentType(companyWorkPatternsArr, employmentType);

			return [defaultWorkPatternObj];
		},

		getWorkPatternBasis: (workPatternObj) => {

			if (workPatternObj.Group === WORK_PATTERN_GROUPS.standard) {
				return WORK_PATTERN_BASIS.weekly;
			}

			return workPatternObj.Basis;
		},

		getWorkPatternDatesForSalariedWorkPattern: (workPatternObj, currentPayPeriodObj) => {

			var periodStartDateM = moment(currentPayPeriodObj.StartDateISO);
			var periodEndDateM = moment(currentPayPeriodObj.EndDateISO);
			var periodPayDateM = moment(currentPayPeriodObj.PayDateISO);
			var dateIterator = moment(currentPayPeriodObj.StartDateISO);

			var returnArr = [];

			while (dateIterator.isBefore(periodEndDateM)) {

				var dateObj = {
					dateISO: dateIterator.format(),
					dateTags: []
				};

				// Start date
				if (dateIterator.isSame(periodStartDateM, 'day')) {
					dateObj.dateTags.push('Start date');
				}

				// Pay date
				if (dateIterator.isSame(periodPayDateM, 'day')) {
					dateObj.dateTags.push('Pay date');
				}

				// End date
				if (dateIterator.isSame(periodEndDateM, 'day')) {
					dateObj.dateTags.push('End date');
				}

				returnArr.push(dateObj);

				dateIterator.add(1, 'day');
			}

			return returnArr;
		},

		getWorkPatternDatesForWorkPattern: (workPatternObj, currentPayPeriodObj) => {

			// Salary
			if (workPatternObj.Group === WORK_PATTERN_GROUPS.standard) {
				return service.getWorkPatternDatesForSalariedWorkPattern(workPatternObj);
			}

			// Flexi
			else {

				// Weekly
				if (workPatternObj.Basis === WORK_PATTERN_BASIS.weekly) {
					console.info(currentPayPeriodObj);
				}

				// Daily
				else {
					console.info(currentPayPeriodObj);
				}
			}
		},

		getWorkPatternGroupForEmploymentType: (employmentType) => {

			return employmentType === EMPLOYMENT_TYPES.standard ? WORK_PATTERN_GROUPS.standard : WORK_PATTERN_GROUPS.nonStandard;
		},

		getDefaultWorkDays: () => {

			// Default to Monday to Friday (5 days)
			return DAYS_OF_WEEK.Monday |
				   DAYS_OF_WEEK.Tuesday |
				   DAYS_OF_WEEK.Wednesday |
				   DAYS_OF_WEEK.Thursday |
				   DAYS_OF_WEEK.Friday;
		},

		getWorkPatternFromWorkDays: (workDays) => {

			if (angular.isUndefined(workDays) || workDays === null) {

				// Default to Monday to Friday (5 days)
				workDays = service.getDefaultWorkDays();
			}

			return [
				{ day: SIMPLE_WORK_PATTERN_DAYS.monday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Monday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.tuesday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Tuesday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.wednesday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Wednesday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.thursday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Thursday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.friday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Friday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.saturday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Saturday) },
				{ day: SIMPLE_WORK_PATTERN_DAYS.sunday, value: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Sunday) }
			];
		},

		getWorkDaysFromWorkPattern: (workPattern) => {

			const workPatternToDayOfWeek = {
				[SIMPLE_WORK_PATTERN_DAYS.monday]: DAYS_OF_WEEK.Monday,
				[SIMPLE_WORK_PATTERN_DAYS.tuesday]: DAYS_OF_WEEK.Tuesday,
				[SIMPLE_WORK_PATTERN_DAYS.wednesday]: DAYS_OF_WEEK.Wednesday,
				[SIMPLE_WORK_PATTERN_DAYS.thursday]: DAYS_OF_WEEK.Thursday,
				[SIMPLE_WORK_PATTERN_DAYS.friday]: DAYS_OF_WEEK.Friday,
				[SIMPLE_WORK_PATTERN_DAYS.saturday]: DAYS_OF_WEEK.Saturday,
				[SIMPLE_WORK_PATTERN_DAYS.sunday]: DAYS_OF_WEEK.Sunday
			};

			// Iterates over the workPattern array and checks if each day is selected (value is true).
			return workPattern.reduce((acc, day) => day.value ? acc | workPatternToDayOfWeek[day.day] : acc, 0);
		},

		getWorkDaysFromSicknessPay: (sicknessPayObj) => {

			// If no sickness pay object is provided, return 0 (no work days)
			if (angular.isUndefined(sicknessPayObj) || sicknessPayObj === null) {
				return 0;
			}

			const dayMappings = [
				{ property: 'WorksMonday', day: DAYS_OF_WEEK.Monday },
				{ property: 'WorksTuesday', day: DAYS_OF_WEEK.Tuesday },
				{ property: 'WorksWednesday', day: DAYS_OF_WEEK.Wednesday },
				{ property: 'WorksThursday', day: DAYS_OF_WEEK.Thursday },
				{ property: 'WorksFriday', day: DAYS_OF_WEEK.Friday },
				{ property: 'WorksSaturday', day: DAYS_OF_WEEK.Saturday },
				{ property: 'WorksSunday', day: DAYS_OF_WEEK.Sunday }
			];

			// Reduce the sicknessPayObj properties to a bitwise representation of work days
			// where each day is represented by its corresponding bit in the bitmask
			// If the property is true, the corresponding bit is set in the result
			return dayMappings.reduce((workDaysAcc, mapping) => {
				return sicknessPayObj[mapping.property] ? workDaysAcc | mapping.day : workDaysAcc;
			}, 0);
		},

		getWorkDaysDisplay: (workDays) => {

			// If no work days are provided, return 'None'
			if (angular.isUndefined(workDays) || workDays === null || workDays <= 0) {
				return 'None';
			}

			const workPattern = service.getWorkPatternFromWorkDays(workDays);

			return workPattern.filter(day => day.value).map(day => day.day).join(', ');
		},

		setSicknessPayWorkPatternFromWorkDays: (sicknessPayObj, workDays) => {

			if (angular.isUndefined(sicknessPayObj) || sicknessPayObj === null) {
				return sicknessPayObj;
			}

			if (angular.isUndefined(workDays) || workDays === null) {

				// Default to Monday to Friday (5 days)
				workDays = service.getDefaultWorkDays();
			}

			angular.extend(sicknessPayObj, {
				WorksMonday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Monday),
				WorksTuesday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Tuesday),
				WorksWednesday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Wednesday),
				WorksThursday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Thursday),
				WorksFriday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Friday),
				WorksSaturday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Saturday),
				WorksSunday: $filter('bitwiseCompare')(workDays, DAYS_OF_WEEK.Sunday)
			});

			return sicknessPayObj;
		},

		getWorkPatternTheme: (workPatternObj) => {

			return workPatternObj.Group === WORK_PATTERN_GROUPS.standard ? 'is-quarternary' : 'is-secondary';
		},

		indexDays: (workPatternDays) => {

			if (!workPatternDays.length) {
				console.error('No work pattern days are defined.');
				return;
			}

			// Make sure each day has a unique DayNumber (index) value
			workPatternDays.forEach((workPatternDayObj, index) => {
				workPatternDayObj.DayNumber = index + 1;
			});
		},

		isWorkPatternsApplicable: (payPeriodObj) => {

			// Work patterns is not applicable to companies set up with quarterly, bi-annual & annual pay periods
			switch (payPeriodObj.PeriodType) {

				case PAY_PERIOD_TYPES.quarterly:
				case PAY_PERIOD_TYPES.annually:
				case PAY_PERIOD_TYPES.biannually:

					return false;
			}

			return true;
		},

		recalculateTotals: (workPatternObj) => {

			let updatedTotalHours = 0;
			let updatedWorkingDays = 0;
			let updatedNonWorkingDays = 0;

			workPatternObj.Days.forEach(dayObj => {

				updatedTotalHours += dayObj.DayType === WORK_PATTERN_DAY_TYPES.working ? dayObj.Hours : 0;
				updatedWorkingDays += dayObj.DayType === WORK_PATTERN_DAY_TYPES.working ? 1 : 0;
				updatedNonWorkingDays += dayObj.DayType === WORK_PATTERN_DAY_TYPES.nonWorking ? 1 : 0;
			});

			workPatternObj.WorkingDays = updatedWorkingDays;
			workPatternObj.NonWorkingDays = updatedNonWorkingDays;

				// Only update total hours if non-standard, otherwise it's manually defined
			if (workPatternObj.Group === WORK_PATTERN_GROUPS.nonStandard) {
				// Round to 2 decimal places to prevent floating-point precision errors
				workPatternObj.TotalHours = Math.round(updatedTotalHours * 100) / 100;
			}
		},

		togglePatternBasis: (patternBasis) => {

			return patternBasis === WORK_PATTERN_BASIS.weekly ? WORK_PATTERN_BASIS.daily : WORK_PATTERN_BASIS.weekly;
		},

		updateDays: workPatternObj => {

			// Convert weeks into days when weekly pattern is used
			if (workPatternObj.Basis === WORK_PATTERN_BASIS.weekly) {
				workPatternObj.Days = angular.copy(workPatternObj.weeks.flat(1));
			}

			service.indexDays(workPatternObj.Days);
			service.recalculateTotals(workPatternObj);

			return workPatternObj;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('agency', ['libraries', 'promise', function agency (libraries, promise) {

	const lib = libraries.agency;
	let service = {};

	const agencyEmployer = {

		getDashboardData: function (agencyProfileId) {

			const url = lib + 'GetDashboardData';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyEmployerBUN: agencyProfileId => {

			const url = lib + 'GetAgencyEmployerBUN';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};
			const configObj = {
				errorOnEmptyResponse: false
			};

			return promise.getPromise(url, dataObj, configObj);
		},
		getAgencyEmployers: function (agencyProfileId) {

			const url = lib + 'GetAgencyEmployers';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise (url, data);
		},
		updateAgencyEmployerBUN: (agencyProfileId, bun) => {

			const url = lib + 'UpdateAgencyEmployerBUN';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				BUN: bun
			};

			return promise.getPromise(url, dataObj);
		}
	};

	const authentication = {

		getCompanyAuthenticationDetails: agencyProfileId => {

			const url = lib + 'GetCompanyAuthenticationDetails';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		updateCompanyAuthenticationDetails: authenticationDetails => {

			const url = lib + 'UpdateCompanyAuthenticationDetails';
			const dataObj = {
				AuthenticationDetails: authenticationDetails
			};

			return promise.getPromise(url, dataObj);
		},
		updateCompanyIdentityTwoFAPolicyConfirmationState: (agencyProfileId, identityConfirmTwoFAPolicyState) => {
			const url = lib + 'UpdateCompanyIdentityTwoFAPolicyConfirmationState';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				IsTwoFactorAuthenticationPolicyConfirmed: identityConfirmTwoFAPolicyState
			};

			return promise.getPromise(url, dataObj);
		}

	};

	const departments = {

		getAgencyDepartments: (agencyProfileId) => {

			const url = lib + 'GetAgencyDepartments';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyDepartmentVisible: (agencyProfileId, agencyDepartmentId) => {

			const url = lib + 'GetAgencyDepartmentVisible';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyDepartmentID: agencyDepartmentId
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyDepartmentVisible: (agencyProfileId, departmentList) => {

			const url = lib + 'UpdateAgencyDepartmentVisible';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				DepartmentList: departmentList
			};

			return promise.getPromise(url, dataObj);
		}
	};

	const goCardless = {

		createGoCardlessDirectDebit: function (agencyProfileId, newDirectDebitMandate) {

			const url = lib + 'CreateGoCardlessDirectDebit';
			const data = {
				AgencyProfileID: agencyProfileId,
				NewDirectDebitMandate: newDirectDebitMandate
			};

			return promise.getPromise(url, data);
		},
		getCompanyDirectDebitMandate: function (agencyProfileId) {

			const url = lib + 'GetCompanyDirectDebitMandate';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updateCompanyGoCardlessDetails: function (agencyProfileId, updatedCompanyDDMandate) {

			const url = lib + 'UpdateCompanyGoCardlessDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedCompanyDDMandate: updatedCompanyDDMandate
			};

			return promise.getPromise(url, data);
		}
	};


	const hr = {
		deleteHolidayDetail: function (userAgencyProfileHolidayID) {

			const url = lib + 'DeleteHolidayDetail';
			const data = {
				UserAgencyProfileHolidayID: userAgencyProfileHolidayID
			};

			return promise.getPromise(url, data);
		},
		deleteSicknessDetail: function (userAgencyProfileSicknessID) {

			const url = lib + 'DeleteSicknessDetail';
			const data = {
				UserAgencyProfileSicknessID: userAgencyProfileSicknessID
			};

			return promise.getPromise(url, data);
		},
		getEmptyHolidayDetail: function() {

			const url = lib + 'GetEmptyHolidayDetail';

			return promise.getPromise(url);
		},
		getEmptySicknessDetail: function () {

			const url = lib + 'GetEmptySicknessDetail';

			return promise.getPromise(url);
		},
		getHolidayPolicies: function (agencyProfileId) {

			const url = lib + 'GetHolidayPolicies';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getHolidayPolicy: function (holidayPolicyId) {

			const url = lib + 'GetHolidayPolicy';
			const data = {
				HolidayPolicyID: holidayPolicyId
			};

			return promise.getPromise(url, data);
		},
		getHolidaySummary: function (agencyProfileId, userId) {

			const url = lib + 'GetHolidaySummary';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
			};

			return promise.getPromise(url, data);
		},
		getSicknessPolicies: function (agencyProfileId) {

			const url = lib + 'GetSicknessPolicies';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getSicknessSummary: function (agencyProfileId, userId) {

			const url = lib + 'GetSicknessSummary';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateHolidayPolicy: function (agencyProfileId, updatedHolidayPolicy) {

			const url = lib + 'UpdateHolidayPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedHolidayPolicy: updatedHolidayPolicy
			};

			return promise.getPromise(url, data);
		},
		updateHolidayDetail: function (userId, agencyProfileId, updatedHolidayDetail) {

			const url = lib + 'UpdateHolidayDetail';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedHolidayDetail: updatedHolidayDetail
			};

			return promise.getPromise(url, data);
		},
		updateSicknessDetail: function (userId, agencyProfileId, updatedSicknessDetail) {

			const url = lib + 'UpdateSicknessDetail';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedSicknessDetail: updatedSicknessDetail
			};

			return promise.getPromise(url, data);
		},
		updateSicknessPolicy: function (agencyProfileId, updatedSicknessPolicy) {

			const url = lib + 'UpdateSicknessPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedSicknessPolicy: updatedSicknessPolicy
			};

			return promise.getPromise(url, data);
		}
	};

	const imports = {

		getAgencyProfileImportAutoComplete: agencyProfileId => {

			const url = lib + 'GetAgencyProfileImportAutoComplete';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileImportOrientationVertical: function (agencyProfileId) {

			const url = lib + 'GetAgencyProfileImportOrientationVertical';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileImportAutoComplete: (agencyProfileId, isImportAutoComplete) => {

			const url = lib + 'UpdateAgencyProfileImportAutoComplete';
			const data = {
				AgencyProfileID: agencyProfileId,
				ImportAutoComplete: isImportAutoComplete
			};

			return promise.getPromise(url, data);
		},

		updateCompanyImportOrientation: function (agencyProfileId, vertical) {

			const url = lib + 'UpdateCompanyImportOrientation';
			const data = {
				AgencyProfileID: agencyProfileId,
				Vertical: vertical
			};

			return promise.getPromise(url, data);
		}

	};

	const payPeriod = {
		getAgencyLogTaxUpdates: function (agencyProfileId, agencyPayPeriodId) {

			const url = lib + 'GetAgencyLogTaxUpdates';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getAgencyPayPeriodState: function (agencyPayPeriodId, agencyPayPeriodStateType) {

			const url = lib + 'GetAgencyPayPeriodState';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyPayPeriodStateType: agencyPayPeriodStateType
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodsForAdvancePeriods: function (agencyProfileId) {

			const url = lib + 'GetPayPeriodsForAdvancePeriods';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updateAgencyPayPeriodResetFailedState: function (agencyPayPeriodID) {

			const url = lib + 'UpdateAgencyPayPeriodResetFailedState';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodID
			};

			return promise.getPromise(url, data);
		}
	};

	const payrollRefresh = {
		getPayrollRefreshChangesOptions: function () {
			
			const url = lib + 'GetPayrollRefreshChangesOptions';
			
			return promise.getPromise(url);
		}
	};

	const profile =  {
		getNamesOfOtherCompaniesOnPAYEScheme: function (agencyProfileID, parentBureauAgencyProfileID, includeTargetProfile) {

			const url = lib + 'GetNamesOfOtherCompaniesOnPAYEScheme';
			const data = {
				AgencyProfileID: agencyProfileID,
				ParentBureauAgencyProfileID: parentBureauAgencyProfileID,
				IncludeTargetProfile: includeTargetProfile
			};

			return promise.getPromise(url, data);
		},
		updateAgencyProfile: function (updatedAgency) {

			const url = lib + 'UpdateAgencyProfile';
			const data = {
				UpdatedAgency: updatedAgency
			};

			return promise.getPromise(url, data);
		}
	};

	service = angular.extend(service, agencyEmployer);
	service = angular.extend(service, authentication);
	service = angular.extend(service, departments);
	service = angular.extend(service, goCardless);
	service = angular.extend(service, hr);
	service = angular.extend(service, imports);
	service = angular.extend(service, payPeriod);
	service = angular.extend(service, payrollRefresh);
	service = angular.extend(service, profile);

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('base', [
	'config',
	'libraries',
	'promise',
	'user',
	function (
		config,
		libraries,
		promise,
		user
	) {

	const lib = libraries.base;
	const service = {
		checkFeedbackExists: (agencyProfileId, agencyPayPeriodId, submissionLogEntryID, copilotFeature) => {

			const url = lib + 'CheckFeedbackExists';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SubmissionLogEntryID: submissionLogEntryID,
				CopilotFeature: copilotFeature
			};

			return promise.getPromise(url, dataObj);
		},
		deleteAgencyDocument: (agencyDocumentId) => {

			const url = lib + 'DeleteAgencyDocument';
			const data = {
				AgencyDocumentID: agencyDocumentId
			};

			return promise.getPromise(url, data);
		},
		deleteAgencyLog: (agencyLogKey, userId) => {

			const url = lib + 'DeleteAgencyLog';
			const data = {
				AgencyLogKey: agencyLogKey,
				UserID: user.getUserId(userId)
			};

			return promise.getPromise(url, data);
		},
		deleteDisbursement: disbursementId => {

			const url = lib + 'DeleteDisbursement';
			const data = {
				DisbursementID: disbursementId
			};

			return promise.getPromise(url, data);
		},
		disconnectXero: agencyProfileID => {

			const url = lib + 'DisconnectXero';
			const data = {
				AgencyProfileID: agencyProfileID
			};

			return promise.getPromise(url, data);
		},
		getAgencyDocumentsForType: (agencyProfileId, documentType) => {

			const url = lib + 'GetAgencyDocumentsForType';
			const data = {
				AgencyProfileID: agencyProfileId,
				DocumentType: documentType
			};

			return promise.getPromise(url, data);
		},
		getAgencyLogEntriesForArchivedEmployment: (agencyProfileId, userId, archivedEmploymentId) => {

			const url = lib + 'GetAgencyLogEntriesForArchivedEmployment';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ArchivedEmploymentID: archivedEmploymentId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);

		},
		getAgencyLogEntriesForLogCategoryList: (agencyProfileId, userId, categoryIdList, dateFrom, dateTo) => {

			const url = lib + 'GetAgencyLogEntriesForLogCategoryList';
			const data = {
				AgencyProfileID: agencyProfileId,
				CategoryIDList: categoryIdList,
				DateFrom: dateFrom,
				DateTo: dateTo,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getAgencyLogEntriesForPension: (agencyProfileId, agencyEmployerPensionId) => {

			const url = lib + 'GetAgencyLogEntriesForPension';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPensionID: agencyEmployerPensionId,
			};

			return promise.getPromise(url, data);
		},
		getBankDetailsCompany: (agencyProfileId, agencyEmployerId) => {

			const url = lib + 'GetBankDetailsCompany';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerID: agencyEmployerId
			};

			return promise.getPromise(url, data);
		},
		getBankFiles: () => {

			const url = lib + 'GetBankFiles';

			return promise.getPromise(url);
		},
		getCompanyDocument: agencyDocumentId => {

			const url = lib + 'GetCompanyDocument';
			const data = {
				AgencyDocumentID: agencyDocumentId
			};

			return promise.getPromise(url, data);
		},
		getDisbursement: (agencyProfileId, disbursementId) => {

			const url = lib + 'GetDisbursements';
			const data = {
				AgencyProfileID: agencyProfileId,
				DisbursementID: disbursementId
			};

			return promise.getPromise(url, data);
		},
		getDisbursements: (agencyProfileId, disbursementId) => {

			const url = lib + 'GetDisbursements';
			const data = {
				AgencyProfileID: agencyProfileId,
				DisbursementID: disbursementId
			};

			return promise.getPromise(url, data);
		},
		getDisbursementsForPayElements: agencyProfileId => {

			const url = lib + 'GetDisbursementsForPayElements';
			const data = {
				AgencyProfileID: agencyProfileId,
			};

			return promise.getPromise(url, data);
		},
		getEmptyBankDetails: () => {

			const url = lib + 'GetEmptyBankDetails';

			return promise.getPromise(url);
		},
		getEmptyDisbursement: () => {

			const url = lib + 'GetEmptyDisbursement';

			return promise.getPromise(url);
		},

		getEmptyTeamMemberBank: () => {

			const url = lib + 'GetEmptyTeamMemberBank';

			return promise.getPromise(url);
		},

		getNationalInsuranceLetters: () => {

			const url = lib + 'GetNationalInsuranceLetters';

			return promise.getPromise(url);
		},

		getPayrollAgencyLogEntriesForDashboard: agencyProfileId => {

			const url = lib + 'GetPayrollAgencyLogEntriesForDashboard';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getPensionAgencyLogEntriesForDashboard: agencyProfileId => {

			const url = lib + 'GetPensionAgencyLogEntriesForDashboard';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getPermissionRoleAsViewer: (agencyProfileId, userId) => {

			const url = lib + 'GetPermissionRoleAsViewer';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		getPermissionRoleDetail: (agencyProfileId, permissionRoleId, userId, roleType) => {

			const url = lib + 'GetPermissionRoleDetail';
			const data = {
				AgencyProfileID: agencyProfileId,
				PermissionRoleID: permissionRoleId !== undefined ? permissionRoleId : config.guidEmpty,
				RoleType: roleType,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getPermissionRoles: agencyProfileId => {

			const url = lib + 'GetPermissionRoles';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getSubmissionLogsForAgencyPayPeriod: (agencyProfileId, agencyPayPeriodId, includeDismissed, latestAttemptsOnly) => {

			const url = lib + 'GetSubmissionLogsForAgencyPayPeriod';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				IncludeDismissed: includeDismissed,
				LatestAttemptsOnly: latestAttemptsOnly
			};

			return promise.getPromise(url, dataObj);
		},
		getSubmissionLogsForEPSSubmission: (agencyProfileId, agencyPayPeriodId, includeDismissed, latestAttemptsOnly) => {

			const url = lib + 'GetSubmissionLogsForEPSSubmission';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				IncludeDismissed: includeDismissed,
				LatestAttemptsOnly: latestAttemptsOnly
			};

			return promise.getPromise(url, dataObj);
		},
		getSubmissionLogsForSupplementaryPayment: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId, includeDismissed, latestAttemptsOnly) => {

			const url = lib + 'GetSubmissionLogsForSupplementaryPayment';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				IncludeDismissed: includeDismissed,
				LatestAttemptsOnly: latestAttemptsOnly,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, dataObj);
		},
		getSubmissionLogsForP11DbSubmission: (agencyProfileId, agencyPayPeriodId, p11DbSubmissionID, includeDismissed, latestAttemptsOnly) => {

			const url = lib + 'GetSubmissionLogsForP11DbSubmission';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				IncludeDismissed: includeDismissed,
				LatestAttemptsOnly: latestAttemptsOnly,
				P11DbSubmissionID: p11DbSubmissionID
			};

			return promise.getPromise(url, dataObj);
		},
		getUserPayYTDHolidayAccrued: (agencyProfileId, userId) => {

			const url = lib + 'GetUserPayYTDHolidayAccrued';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: user.getUserId(userId)
			};

			return promise.getPromise(url, data);
		},
		getUsersAgencyLogEntriesForDashboard: agencyProfileId => {

			const url = lib + 'GetUsersAgencyLogEntriesForDashboard';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getXeroAccessToken: (agencyProfileId, code) => {

			const url = lib + 'GetXeroAccessToken';
			const data = {
				AgencyProfileID: agencyProfileId,
				Code: code
			};

			return promise.getPromise(url, data);
		},
		getXeroAuthUrl: (agencyProfileId, companyName) => {

			const url = lib + 'GetXeroAuthURL';
			const data = {
				AgencyProfileID: agencyProfileId,
				CompanyName: companyName
			};

			return promise.getPromise(url, data);
		},
		isFeatureEnabled: (targetId, featureKey) => {

			const url = lib + 'IsFeatureEnabled';
			const data = {
				TargetID: targetId,
				FeatureKey: featureKey
			};

			return promise.getPromise(url, data);
		},
		submitFeedbackForSubmissionLogEntry: (agencyProfileId, agencyPayPeriodId, submissionLogEntryID, copilotFeature, feedbackType, feedbackText, aiOutputContext) => {

			const url = lib + 'SubmitFeedbackForSubmissionLogEntry';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SubmissionLogEntryID: submissionLogEntryID,
				CopilotFeature: copilotFeature,
				FeedbackType: feedbackType,
				FeedbackText: feedbackText,
				AIOutputContext: aiOutputContext
			};

			return promise.getPromise(url, dataObj);
		},
		updateAgencyDocumentName: (agencyDocumentId, name) => {

			const url = lib + 'UpdateAgencyDocumentName';
			const dataObj = {
				AgencyDocumentID: agencyDocumentId,
				Name: name,
			};

			return promise.getPromise(url, dataObj);
		},
		updateAgencyDocumentRowCounts: (agencyDocumentId, titleRowCount, footerRowCount) => {

			const url = lib + 'UpdateAgencyDocumentRowCounts';
			const data = {
				AgencyDocumentID: agencyDocumentId,
				TitleRowCount: titleRowCount,
				FooterRowCount: footerRowCount
			};

			return promise.getPromise(url, data);
		},
	updateAgencyProfileCredentialTenantId: (agencyProfileId, credentialType, tenantId, tenantName) => {

		const url = lib + 'UpdateAgencyProfileCredentialTenantID';
		const data = {
			AgencyProfileID: agencyProfileId,
			CredentialType: credentialType,
			TenantID: tenantId,
			TenantName: tenantName
		};

		return promise.getPromise(url, data);
	},
		updateAlertArchived: (alertId, agencyLogId, archived) => {

			const url = lib + 'UpdateAlertArchived';
			const data = {
				AgencyLogID: agencyLogId,
				AlertID: alertId,
				Archived: archived
			};

			return promise.getPromise(url, data);
		},
		updateBankDetailsCompany: (agencyProfileId, agencyEmployerId, bankDetails, pensionDisbursements, hmrcDisbursement) => {

			const url = lib + 'UpdateBankDetailsCompany';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerID: agencyEmployerId,
				BankDetails: bankDetails,
				HMRCDisbursement: hmrcDisbursement,
				PensionDisbursements: pensionDisbursements
			};

			return promise.getPromise(url, data);
		},
		updateDisbursement: (agencyProfileId, disbursementDetails) => {

			const url = lib + 'UpdateDisbursement';
			const data = {
				AgencyProfileID: agencyProfileId,
				DisbursementDetails: disbursementDetails
			};

			return promise.getPromise(url, data);
		},
		updatePermissionRoleDetail: (agencyProfileId, updatedRoleDetail, userId) => {

			const url = lib + 'UpdatePermissionRoleDetail';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedRoleDetail: updatedRoleDetail,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateSubmissionLogEntryDismissed: (agencyProfileId, submissionLogEntryId) => {

			const url = lib + 'UpdateSubmissionLogEntryDismissed';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				SubmissionLogEntryID: submissionLogEntryId
			};

			return promise.getPromise(url, dataObj);
		},
		updateUserProfileAgencyProfilePermissionRole: (agencyProfileId, permissionRoleType, userId) => {

			const url = lib + 'UpdateUserProfileAgencyProfilePermissionRole';
			const data = {
				AgencyProfileID: agencyProfileId,
				PermissionRoleType: permissionRoleType,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateUserProfileAgencyProfileVisibleList: (agencyProfileId, userIdList, visible) => {

			const url = lib + 'UpdateUserProfileAgencyProfileVisibleList';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserIDList: userIdList,
				Visible: visible
			};

			return promise.getPromise(url, dataObj);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('dataImport', ['config', 'libraries', 'promise', function dataImport (config, libraries, promise) {

	const lib = libraries.importLib;
	const service = {

		cancelUserImport: function (userImportOwner) {

			const url = lib + 'CancelUserImport';
			const data = {
				AgencyPayPeriodID: userImportOwner
			};
			const svcConfig = {
				errorOnEmptyResponse: false,
				logOnEmptyResponse: false
			};

			return promise.getPromise(url, data, svcConfig);
		},
		deleteImportMapping: function (agencyProfileId, agencyDocumentTypeId, agencyDocumentId, importMappingId) {

			const url = lib + 'DeleteImportMapping';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyDocumentTypeID: agencyDocumentTypeId,
				AgencyDocumentID: agencyDocumentId,
				ImportMappingID: importMappingId
			};

			return promise.getPromise(url, data);
		},
		deleteImportMappingForCompanySettings: function (agencyProfileId, importMappingId) {

			const url = lib + 'DeleteImportMapping';
			const data = {
				AgencyDocumentID: config.guidEmpty,
				AgencyDocumentTypeID: config.guidEmpty,
				AgencyProfileID: agencyProfileId,
				ImportMappingID: importMappingId
			};

			return promise.getPromise(url, data);
		},
		deleteUserImportGroup: userImportGroupId => {

			const url = lib + 'DeleteUserImportGroup';
			const data = {
				UserImportGroupID: userImportGroupId
			};

			return promise.getPromise(url, data);
		},
		deleteUserPayElementImportGroup: function (userPayElementImportGroupId) {

			const url = lib + 'DeleteUserPayElementImportGroup';
			const data = {
				UserPayElementImportGroupID: userPayElementImportGroupId
			};

			return promise.getPromise(url, data);
		},
		generateUserImport (agencyProfileId, agencyPayPeriodId, agencyDocumentId, mappingDetails, mappingType) {

			const url = lib + 'GenerateUserImport';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				MappingDetails: mappingDetails,
				MappingType: mappingType,
			};

			return promise.getPromise(url, data);
		},
		getDefaultImportAgencyAdjustmentRateType: function (agencyProfileId, mappingType) {

			const url = lib + 'GetDefaultImportAgencyAdjustmentRateType';
			
			const data = {
				AgencyProfileID: agencyProfileId,
				MappingType: mappingType
			};

			return promise.getPromise(url, data);
		},
		getImportMappingDescription (importMappingType) {
			const url = lib + 'GetImportMappingDescription';
			const data = {
				ImportMappingType: importMappingType,
			};
			return promise.getPromise(url, data);
		},
		getImportMappingColumns2: function (agencyProfileId, mappingType) {

			const url = lib + 'GetImportMappingColumns2';
			const data = {
				AgencyProfileID: agencyProfileId,
				MappingType: mappingType
			};

			return promise.getPromise(url, data);
		},
		getImportMappingTemplates: function (agencyProfileId, mappingType) {

			// Set optional mappingType to -1 if not specified (to retrieve all templates)
			if (!angular.isDefined(mappingType)) {
				mappingType = -1;
			}

			const url = lib + 'GetImportMappingTemplates';
			const data = {
				AgencyProfileID: agencyProfileId,
				MappingType: mappingType
			};

			return promise.getPromise(url, data);
		},
		getNumberOfUserImportsByOwner: function (userImportOwnerId) {

			const url = lib + 'GetNumberOfUserImportsByOwner';
			const data = {
				UserImportOwnerID: userImportOwnerId
			};

			return promise.getPromise(url, data);
		},
		getPayPolicyImportUndoPreview: function (userImportGroupId) {

			const url = lib + 'GetPayPolicyImportUndoPreview';
			const data = {
				UserImportGroupID: userImportGroupId
			};

			return promise.getPromise(url, data);
		},
		getUserImportGroups: (agencyProfileId, agencyPayPeriodId, includeDeleted, teamImports, periodImports, importType) => {

			const url = lib + 'GetUserImportGroups';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				IncludeDeleted: includeDeleted,
				ImportType: importType,
				PeriodImports: periodImports,
				TeamImports: teamImports
			};

			return promise.getPromise(url, data);
		},
		getUserImportGroupsForDocument: agencyDocumentId => {

			const url = lib + 'GetUserImportGroupsForDocument';
			const dataObj = {
				AgencyDocumentID: agencyDocumentId
			};

			return promise.getPromise(url, dataObj);
		},
		getUserImportGroupForUser: (agencyPayPeriodId, userId, importType) => {

			const url = lib + 'GetUserImportGroupForUser';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId,
				ImportType: importType
			};

			return promise.getPromise(url, data);
		},
		getUserImportValidationResults: function (userImportOwnerId) {

			const url = lib + 'GetUserImportValidationResults';
			const data = {
				UserImportOwnerID: userImportOwnerId
			};

			return promise.getPromise(url, data);
		},
		importDataCheckFormat: function (agencyProfileId, agencyPayPeriodId, agencyDocumentTypeId, agencyDocumentId, mappingType, importMappingTemplateId) {

			const url = lib + 'ImportDataCheckFormat';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentTypeID: agencyDocumentTypeId,
				AgencyDocumentID: agencyDocumentId,
				MappingType: mappingType,
				ImportMappingTemplateID: importMappingTemplateId
			};

			return promise.getPromise(url, data);
		},
		resetUserImportGroup: function (agencyProfileId, userImportGroupId, mappingType) {

			const url = lib + 'ResetUserImportGroup';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserImportGroupID: userImportGroupId,
				MappingType: mappingType
			};

			return promise.getPromise(url, data);
		},
		resolvePayElementMatch: function (validationResult) {
			const url = lib + 'ResolvePayElementMatch';
			const data = {
				ValidationResult: validationResult
			};

			return promise.getPromise(url, data);
		},
		undoImport: function (agencyPayPeriodId) {

			const url = lib + 'UndoImport';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId
			};
			const config = {
				errorOnEmptyResponse: false,
				logOnEmptyResponse: false
			};

			return promise.getPromise(url, data, config);
		},
		updateAgencyPayPeriodImportWorkerStatus: function (agencyPayPeriodId, submissionState) {

			const url = lib + 'UpdateAgencyPayPeriodImportWorkerStatus';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				SubmissionState: submissionState
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingColumn: function (updatedImportMappingColumn) {

			const url = lib + 'UpdateImportMappingColumn';
			const data = {
				UpdatedImportMappingColumn: updatedImportMappingColumn
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingColumnBulk: updatedImportMappingColumnList => {

			const url = lib + 'UpdateImportMappingColumnBulk';
			const data = {
				UpdatedImportMappingColumnList: updatedImportMappingColumnList
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingFile: function (agencyProfileId, agencyPayPeriodId, agencyDocumentId, mapping, mappingType) {

			const url = lib + 'UpdateImportMappingFile';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				Mapping: mapping,
				MappingType: mappingType
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingTemplate: function (agencyProfileId, agencyDocumentId, importMappingId, name, isDefault) {

			const url = lib + 'UpdateImportMappingTemplate';
			const data = {
				AgencyDocumentID: agencyDocumentId,
				AgencyProfileID: agencyProfileId,
				ImportMappingID: importMappingId,
				Name: name,
				Default: isDefault
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingTemplateDefault: function (agencyProfileId, importMappingId, mappingType, isDefault) {

			const url = lib + 'UpdateImportMappingTemplateDefault';
			const data = {
				AgencyProfileID: agencyProfileId,
				ImportMappingID: importMappingId,
				MappingType: mappingType,
				Default: isDefault
			};

			return promise.getPromise(url, data);
		},
		updateImportMappingTemplateWithColumns: function (agencyProfileId, agencyDocumentId, name, columns, importMappingId, isDefault, update) {

			const url = lib + 'UpdateImportMappingTemplateWithColumns';
			const data = {
				AgencyDocumentID: agencyDocumentId,
				AgencyProfileID: agencyProfileId,
				Columns: columns,
				Default: isDefault,
				ImportMappingID: importMappingId,
				Name: name,
				Update: update
			};

			return promise.getPromise(url, data);
		},
		updateUserImportGroupState: (userImportGroupId, state) => {

			const url = lib + 'UpdateUserImportGroupState';
			const data = {
				UserImportGroupID: userImportGroupId,
				State: state
			};

			return promise.getPromise(url, data);
		},
		updateUserInImport: function (agencyProfileId, userImport, validationResultID) {

			const url = lib + 'UpdateUserInImport';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserImport: userImport,
				ValidationResultID: validationResultID
			};

			return promise.getPromise(url, data);
		},
		updateValidationResultIgnore: function (validationResultID, validationResultIgnore) {

			const url = lib + 'IngoreValidationResult';
			const data = {
				ValidationResultID: validationResultID,
				ValidationResultIgnore: validationResultIgnore
			};

			return promise.getPromise(url, data);
		},
		validatePayElementImportFile: function (agencyProfileId, agencyPayPeriodId, agencyDocumentId, mapping, mappingType, isSecondPassValidation) {

			const url = lib + 'ValidatePayElementImportFile';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				Mapping: mapping,
				MappingType: mappingType,
				IsSecondPassValidation: isSecondPassValidation
			};

			return promise.getPromise(url, data);
		},
		validatePayPolicyImportFile: function (agencyProfileId, agencyPayPeriodId, agencyDocumentId, mapping) {

			const url = lib + 'ValidatePayPolicyImportFile';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				Mapping: mapping
			};

			return promise.getPromise(url, data);
		},
		validateUserImport: function (userImportOwnerId) {

			const url = lib + 'ValidateUserImport';
			const data = {
				UserImportOwnerID: userImportOwnerId
			};
	        const config = {
				errorOnEmptyResponse: false,
				logOnEmptyResponse: false
			};

			return promise.getPromise(url, data, config);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('payrollWorker', ['libraries', 'promise', function (libraries, promise) {

	const lib = libraries.payrollWorker;
	const service = {

		payrollCreateReports: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'PayrollCreateReports';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		payrollCreatePayslips: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'PayrollCreatePayslips';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		payrollDataImport: function (agencyProfileId, agencyPayPeriodId, importType) {

			const url = lib + 'PayrollDataImport';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				ImportType: importType,
				Authorisation: 'CHET'
			};

			return promise.getPromise(url, data);
		},
		payrollMailP60s: (agencyProfileId, taxYear) => {

			const url = lib + 'PayrollMailP60s';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				TaxYear: taxYear
			};

			return promise.getPromise(url, dataObj);
		},
		payrollMailPayslips: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'PayrollMailPayslips';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		payrollResubmitAE: function (agencyProfileId, agencyEmployerPensionId) {

			const url = lib + 'PayrollResubmitAE';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPensionID: agencyEmployerPensionId
			};

			return promise.getPromise(url, data);
		},
		payrollStartWorkerImport: function (agencyProfileId, agencyPayPeriodId, setInternalId) {

			const url = lib + 'PayrollDataImport';
			const importType = '816DBDCA-18A9-4233-AEC1-9D2F085328C2'; //AgencyDocumentType table, UserImport Guid

			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				ImportType: importType,
				Authorisation: 'CHET',
				SetInternalID: setInternalId
			};

			return promise.getPromise(url, data);
		},
		payrollSubmitEYU: (agencyProfileId, agencyPayPeriodId, endOfYearUpdate) => {

			const url = lib + 'PayrollSubmitEYU';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				EndOfYearUpdate: endOfYearUpdate
			};

			return promise.getPromise(url, dataObj);
		},
		payrollSubmitManualEPS: function (manualEpsId, agencyProfileId) {

			const url = lib + 'PayrollSubmitManualEPS';
			const data = {
				ManualEPSID: manualEpsId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		payrollSubmitSupplementaryPayment: function (agencyProfileId, supplementaryPaymentId) {

			const url = lib + 'PayrollSubmitSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		payrollSubmitYearToDateFPS: (agencyProfileId, agencyPayPeriodId, endOfYearUpdate) => {

			const url = lib + 'PayrollSubmitYearToDateFPS';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				EndOfYearUpdate: endOfYearUpdate
			};

			return promise.getPromise(url, dataObj);
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('postcodeLookup', [
	'$http',
	'$q',
	'config',
function postcodeLookup (
	$http,
	$q,
	config
) {

	var service = {

		getAddressFromPostcode: function (postcode) {

			var url = 'https://api.ideal-postcodes.co.uk/v1/postcodes/' + postcode + '?api_key=' + config.idealPostcodesKey;
			var options = {
				withCredentials: false,
				broadcast:false
			};
			var data = {
				broadcast:false
			};

			return $http.get(url, options, data);
		},

		getAddressFromUrlPath: function (urlPath) {

			return $q((resolve, reject) => {
				const ipGetAddressUrl = `https://api.ideal-postcodes.co.uk${urlPath}?api_key=${config.idealPostcodesKey}`;
				const options = {
					withCredentials: false
				};
				$http.get(ipGetAddressUrl, options).then(ipResponse => {
					resolve(ipResponse.data.result);
				})
				.catch(error => {
					reject(error);
				});
			});
		},

		searchForAddress: function (query) {
			var url = 'https://api.ideal-postcodes.co.uk/v1/addresses?api_key=' + config.idealPostcodesKey + '&limit=' + config.idealLookupLimit + '&query=' + query;
			var options = {
				withCredentials: false,
				broadcast: false
			};
			var data = {
				broadcast: false
			};

			return $http.get(url, options, data);
		},

		autoCompleteAddress: function (partialAddressSearchString) {

			return $q((resolve, reject) => {

				// Ideal Postcodes autocomplete search https://docs.ideal-postcodes.co.uk/api#tag/Autocomplete
				const ipAutocompleteUrl = `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=${config.idealPostcodesKey}&limit=${config.idealLookupLimit}&query=${partialAddressSearchString}`;
				const options = {
					withCredentials: false
				};

				$http.get(ipAutocompleteUrl, options).then(ipResponse => {

					// Transform results into list for search results. Separate each suggestion into two parts, the second being the locale and partial postcode
					const addressResults = [];
					ipResponse.data.result.hits.forEach(hit => {
						// Separate address parts
						const addressParts = hit.suggestion.split(',');
						if (addressParts.length !== 0) {
							// Chop out spaces added between ', ' separators.
							addressParts.forEach(addressPart => addressPart.trim());
							let addressInfo;
							let localeInfo;
							// Addresses should typically have at least three parts, but just in case ...
							if (addressParts.length === 1) {
								addressInfo = addressParts[0];
								localeInfo = '-';
							}
							else if (addressParts.length === 2) {
								addressInfo = addressParts[0];
								localeInfo = addressParts[1];
							}
							else {
								// Address info is all but the last two items. Locale info is the last two items.
								addressInfo = addressParts.slice(0, -2).join(', ');
								localeInfo = addressParts.slice(-2).join(', ');
							}
							addressResults.push({
								addressInfo,
								localeInfo,
								suggestion: hit.suggestion,
								urlPath: hit.urls.udprn
							});
						}
					});
					resolve(addressResults);
				})
				.catch(error => {
					reject(error);
				});
			});
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('travel', [
	'libraries',
	'promise',
	'user',
function (
    libraries,
    promise,
    user
) {

	const lib = libraries.travel;
	const service = {

		deleteTeamMemberAddress: function (addressId, agencyProfileId) {
			const url = lib + 'DeleteTeamMemberAddress';
			const data = {
				AddressID: addressId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberAddressDetail: userId => {

			const url = lib + 'GetTeamMemberAddressDetail';
			const data = {
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getUserAddressRegister: userId => {

			const url = lib + 'GetUserAddressRegister';
			const data = {
				UserID: user.getUserId(userId)
			};

			return promise.getPromise(url, data);
		},
		updateUserAddress: (updatedAddress, userId, agencyProfileId, updatePercentComplete) => {

			const url = lib + 'UpdateUserAddress';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedAddress: updatedAddress,
				UpdatePercentComplete: updatePercentComplete !== undefined ? updatePercentComplete : false,
				UserID: user.getUserId(userId)
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberAddress: (addressDetails, userId, agencyProfileId) => {

			const url = lib + 'UpdateTeamMemberAddress';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				AddressDetails: addressDetails
			};

			return promise.getPromise(url, data);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('user', [
	'config',
	'libraries',
	'promise',
	function user (
		config,
		libraries,
		promise
	) {

	const lib = libraries.user;
	const service = {

		assessCanUndoBusinessCodeImport: function (agencyProfileId, userImportGroupID) {
			
			const url = lib + 'AssessCanUndoBusinessCodeImport';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserImportGroupID: userImportGroupID
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberHolidaySickness: function(userId, agencyProfileId) {

			const url = lib + 'GetTeamMemberHolidaySickness';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getUserAgencyProfileBusinessCodesForSalaryPolicyPost: function (userId, agencyProfileId, salaryPolicyPostId) {

			const url = lib + 'GetUserAgencyProfileBusinessCodesForSalaryPolicyPost';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryPolicyPostID: salaryPolicyPostId
			};

			return promise.getPromise(url, data);
		},
		getUserId: function (userId) {

			if (userId !== undefined) {
				return userId;
			}

			return config.guidEmpty;
		},
		updateTeamMemberHolidaySickness: function(userId, agencyProfileId, details) {

			const url = lib + 'UpdateTeamMemberHolidaySickness';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				Details: details
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileBusinessCodes: function (agencyProfileId, userBusinessCodes) {

			const url = lib + 'UpdateUserAgencyProfileBusinessCodes';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserBusinessCodes: userBusinessCodes
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileLeaveDetails: function(userId, agencyProfileId, leaveDateIso, leaveReason, leaveNote) {

			const url = lib + 'UpdateUserAgencyProfileLeaveDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				LeaveDateISO: leaveDateIso,
				LeaveReason: leaveReason,
				LeaveNote: leaveNote
			};

			return promise.getPromise(url, data);
		}
	};

	return service;
}]);

'use strict';

/**
 * @ngdoc service
 * @name paycircleApp.agency
 * @description
 * # agency
 * Service in the paycircleApp.
 */
angular.module('paycircleApp')
.service('userGuides', ['$http', function userGuides ($http) {

	//var lib = 'https://paycircle.co.uk/user-guide/';
	var lib = 'http://localhost/paycircle/';
	var service = {

		// Read
		getUserGuide: function (slug) {

			var config = {
				withCredentials: false
			};
			var url = lib + slug + '/';

			return $http.get(url, config);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('aiServices', [
	'$q',
	'$timeout',
	'libraries',
	'promise',
	function (
		$q,
		$timeout,
		libraries,
		promise
	) {

	const lib = libraries.aiServices;
	const service = {
		getSmartViewAnalysis: (agencyProfileId, agencyPayPeriodId, timeoutSeconds) => {

			const url = lib + 'GetSmartViewAnalysis';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};
			const config = {
				retries: 0
			};
			const httpPromise = promise.getPromise(url, dataObj, config);
			
			if (typeof timeoutSeconds === 'number' && timeoutSeconds > 0) {
				const timeoutPromise = $timeout(function () {
					return $q.reject(-1);
				}, timeoutSeconds * 1000);

				return $q.race([httpPromise, timeoutPromise]);
			} else {
				return httpPromise;
			}
		},
		getSubtitleForPayrollComparison: (agencyPayPeriodId) => {

			const url = lib + 'GetSubtitleForPayrollComparison';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		recallDraftPayslips: (agencyPayPeriodId) => {

			const url = lib + 'RecallDraftPayslips';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		getDraftPayslipsState: (agencyPayPeriodId) => {

			const url = lib + 'GetDraftPayslipsState';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		generateDraftPayslips: (agencyPayPeriodId) => {

			const url = lib + 'GenerateDraftPayslips';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		translateHMRCError: (agencyPayPeriodId, submissionLogId, errorMessage, submissionType) => {
			const url = lib + 'TranslateHMRCError';
			const dataObj = {
				AgencyPayPeriodID:agencyPayPeriodId,
				SubmissionLogID: submissionLogId,
				ErrorMessage: errorMessage,
				SubmissionType: submissionType
			};

			return promise.getPromise(url, dataObj);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('companyData', [
	'config',
	'libraries',
	'promise',
	function (
		config,
		libraries,
		promise
	) {

	const lib = libraries.agency;
	const integrationLib = libraries.integration;

	const service = {

		assessCanReopenSkippedOrInactivePeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = `${lib}AssessCanReopenSkippedOrInactivePeriod`;
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},

		assessCanRollbackAgencyPayPeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = `${lib}AssessCanRollbackAgencyPayPeriod`;
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};
			return promise.getPromise(url, data);
		},

		assessHasRunLivePeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = `${lib}AssessHasRunLivePeriod`;
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};
			return promise.getPromise(url, data);
		},

		checkActivationCode: (onboardingId, activationCode, email) => {

			const url = lib + 'CheckActivationCode';
			const data = {
				OnboardingID: onboardingId,
				ActivationCode: activationCode,
				Email: email
			};
			return promise.getPromise(url, data);
		},

		createAgencyPayPeriods2: (agencyProfileId, periodDetails) => {

			const url = lib + 'CreateAgencyPayPeriods2';
			const data = {
				AgencyProfileID: agencyProfileId,
				PeriodDetails: periodDetails
			};
			return promise.getPromise(url, data);
		},

		createAgencyPayPeriodsPreview: (periodDetails) => {

			const url = lib + 'CreateAgencyPayPeriodsPreview';
			const data = {
				PeriodDetails: periodDetails
			};
			return promise.getPromise(url, data);
		},

		createCompany: (setupDetails) => {

			const url = lib + 'CreateCompany';
			const data = {
				SetupDetails: setupDetails
			};

			return promise.getPromise(url, data);
		},

		createCompanyClone: agencyProfileId => {

			const url = lib + 'CreateCompanyClone';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		createOnboardingCompany: (agencyProfileId, companyName, forename, surname, emailAddress, delaySend, demonstration, telephone) => {

			const url = lib + 'CreateOnboardingCompany';
			const data = {
				AgencyProfileID: agencyProfileId,
				CompanyName: companyName,
				Forename: forename,
				Surname: surname,
				EmailAddress: emailAddress,
				DelaySend: delaySend,
				Demonstration: demonstration,
				Telephone: telephone
			};
			return promise.getPromise(url, data);
		},

		createOnboardingCompanyInvite: (bureau, emailAddress, demonstration) => {

			const url = lib + 'CreateOnboardingCompanyInvite';
			const data = {
				Bureau: bureau,
				EmailAddress: emailAddress,
				Demonstration: demonstration
			};
			return promise.getPromise(url, data);
		},

		createParentScheduledP60Notification: (agencyProfileId, taxYear, notificationDateIso, overwriteChildCompaniesSettings) => {

			const url = lib + 'CreateParentScheduledP60Notification';
			const dataObj = {
				AgencyProfileParentID: agencyProfileId,
				TaxYear: taxYear,
				NotificationDateISO: notificationDateIso,
				OverwriteChildAgencies: overwriteChildCompaniesSettings
			};

			return promise.getPromise(url, dataObj);
		},

		createAccessRotareadyUsers: (agencyProfileId, rotareadyIds) => {
			const url = integrationLib + 'CreateAccessRotareadyUsers';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				IDs: rotareadyIds
			};

			return promise.getPromise(url, dataObj);
		},

		createScheduledP60Notification: (agencyProfileId, taxYear, notificationDateIso) => {

			const url = lib + 'CreateScheduledP60Notification';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				TaxYear: taxYear,
				NotificationDateISO: notificationDateIso
			};

			return promise.getPromise(url, dataObj);
		},

		deleteAgencyProfile: (agencyProfileId) => {

			const url = lib + 'DeleteAgencyProfile';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		deleteAgencyProfileBLOBKey: (agencyProfileId, keyType) => {

			const url = lib + 'UpdateAgencyProfileBLOBKey'; // Uses alternative service call but hard codes BLOBKeyID
			const data = {
				AgencyProfileID: agencyProfileId,
				BLOBKeyID: config.guidEmpty,
				KeyType: keyType
			};

			return promise.getPromise(url, data);
		},

		deleteAgencyProfileDemo: (agencyProfileId) => {

			const url = lib + 'DeleteAgencyProfileDemo';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		deleteCompanyClone: agencyProfileId => {

			const url = lib + 'DeleteCompanyClone';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		deleteCurrency: (agencyProfileId, currencyId) => {

			const url = lib + 'DeleteCurrency';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				CurrencyID: currencyId
			};

			return promise.getPromise(url, dataObj);
		},

		deleteGroupCompany: (agencyProfileId, moveCompaniesToADifferentGroup, newAgencyProfileParentId) => {

			const url = lib + 'DeleteGroupCompany';
			const data = {
				AgencyProfileID: agencyProfileId,
				MoveCompaniesToADifferentGroup: moveCompaniesToADifferentGroup,
				NewAgencyProfileParentID: newAgencyProfileParentId
			};

			return promise.getPromise(url, data);
		},

		deletePolicy: (agencyProfileId, policyId) => {

			const url = lib + 'DeletePolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId
			};

			return promise.getPromise(url, data);
		},

		deletePolicyBand: (policyBandId) => {

			const url = lib + 'DeletePolicyBand';
			const data = {
				PolicyBandID: policyBandId
			};
			return promise.getPromise(url, data);
		},

		deletePolicyGrade: (policyGradeId) => {

			const url = lib + 'DeletePolicyGrade';
			const data = {
				PolicyGradeID: policyGradeId
			};

			return promise.getPromise(url, data);
		},

		deleteParentScheduledP60Notification: (agencyProfileParentID, scheduledDocumentNotificationId, overwriteChildCompaniesSettings) => {

			const url = lib + 'DeleteParentScheduledP60Notification';
			const dataObj = {
				ScheduledDocumentNotificationID: scheduledDocumentNotificationId,
				AgencyProfileParentID: agencyProfileParentID,
				OverwriteChildAgencies: overwriteChildCompaniesSettings
			};

			return promise.getPromise(url, dataObj);
		},

		deleteScheduledP60Notification: (agencyProfileId, scheduledDocumentNotificationId) => {

			const url = lib + 'DeleteScheduledP60Notification';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ScheduledDocumentNotificationID: scheduledDocumentNotificationId
			};

			return promise.getPromise(url, dataObj);
		},

		deleteWorkPattern: (workPatternId) => {

			const url = lib + 'DeleteWorkPattern';
			const data = {
				WorkPatternID: workPatternId
			};

			return promise.getPromise(url, data);
		},

		getAgencyCustomerCode: (agencyProfileId) => {

			const url = lib + 'GetAgencyCustomerCode';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyCustomerCodes: (agencyProfileId) => {

			const url = lib + 'GetAgencyCustomerCodesForParent';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyCustomerCodeEnabledState: (agencyProfileId) => {

			const url = lib + 'GetAgencyCustomerCodeEnabledState';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyDepartments: (agencyProfileId) => {

			const url = lib + 'GetAgencyDepartments';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyEmployerAutoRun: agencyProfileId => {

			const url = `${lib}GetAgencyEmployerAutoRun`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyEmployerInactivityDetails: agencyProfileId => {

			const url = `${lib}GetAgencyEmployerInactivityDetails`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyEmployerNetPayCalculationDetails: agencyProfileId => {

			const url = lib + 'GetAgencyEmployerNetPayCalculationDetails';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getAgencyProfileAgencyProfile: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileAgencyProfile';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileAgencyProfilesForChild: (agencyProfileId, interfaceType) => {

			const url = lib + 'GetAgencyProfileAgencyProfilesForChild';
			const data = {
				AgencyProfileID: agencyProfileId,
				InterfaceType: interfaceType !== undefined ? interfaceType : 0 // Defaults to everything
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileAgencyProfilesForParent: (userId, agencyProfileId, interfaceType, archived, cloned) => {

			const url = lib + 'GetAgencyProfileAgencyProfilesForParent';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				InterfaceType: interfaceType !== undefined ? interfaceType : 0, // Defaults to everything
				Archived: archived !== undefined ? archived : false,
				Cloned: cloned
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileCompanyDetails: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileCompanyDetails';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileCompanyDetailsUser: (userId, agencyProfileId) => {

			const url = lib + 'GetAgencyProfileCompanyDetailsUser';
			const data = {
				UserID: userId,
				AgencyProfileID:agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileCompanyInformationDetailed: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileCompanyInformationDetailed';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileCompanyOverview: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileCompanyOverview';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileEmployeePortalPermissionValue: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileEmployeePortalPermissionValue';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfilePensionSettings: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfilePensionSettings';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfilePostponementDates: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfilePostponementDates';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyClone: (agencyProfileId) => {

			const url = lib + 'GetCompanyClone';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyIntegrationDetails: (agencyProfileId) => {

			const url = lib + 'GetCompanyIntegrationDetails';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getEdpIntegrationTopics: (agencyProfileId) => {

			const url = lib + 'GetEdpIntegrationTopics';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getOnboardingStats: (agencyProfileId, state) => {

			const url = lib + 'GetOnboardingStats';
			const data = {
				AgencyProfileID: agencyProfileId,
				State: state
			};
			const svcConfig = {
				useTestData: true
			};

			return promise.getPromise(url, data, svcConfig);
		},

		getCompanyTilesBACS: (agencyProfileId, state) => {

			const url = lib + 'GetCompanyTilesBACS';
			const data = {
				AgencyProfileID: agencyProfileId,
				State: state
			};

			return promise.getPromise(url, data);
		},

		getCompanyCustomisation: (agencyProfileId) => {

			const url = lib + 'GetCompanyCustomisation';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyCustomisationPublic: (agencyProfileId, bureau) => {

			const url = lib + 'GetCompanyCustomisationPublic';
			const data = {
				AgencyProfileID: agencyProfileId,
				Bureau: bureau
			};

			return promise.getPromise(url, data);
		},

		getCompanyCustomisationToUse: (agencyProfileId) => {

			const url = lib + 'GetCompanyCustomisationToUse';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyCustomisationToUseForSignin: (agencyProfileId, agencyProfileCustomisationId) => {
            const url = lib + 'GetCompanyCustomisationToUseForSignin';
            const data = {
                AgencyProfileID: agencyProfileId,
                AgencyProfileCustomisationID: agencyProfileCustomisationId
            };
            return promise.getPromise(url, data);
        },

		getCompanyModuleDetails: (agencyProfileId) => {

			const url = lib + 'GetCompanyModuleDetails';

			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyP32Management: agencyProfileId => {

			const url = lib + 'GetCompanyP32Management';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getCompaniesForCustomerCode: (customerCode, agencyProfileId) => {

			const url = lib + 'GetCompaniesForCustomerCode';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyCustomerCode: customerCode,
			};

			return promise.getPromise(url, data);
		},

		getCurrencies: agencyProfileId => {

			const url = lib + 'GetCurrencies';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getDashboardDataMinimum: agencyProfileId => {

			const url = lib + 'GetDashboardDataMinimum';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getEmptyPolicyGrade: () => {

			const url = lib + 'GetEmptyPolicyGrade';
			return promise.getPromise(url);
		},

		getEmptyCurrency: agencyProfileId => {

			const url = lib + 'GetEmptyCurrency';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getIndustrySectors: () => {

			const url = lib + 'GetIndustrySectors';

			return promise.getPromise(url);
		},

		getIndustrySectorByAgencyProfileID: (agencyProfileId) => {

			const url = lib + 'GetIndustrySectorByAgencyProfileID';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getPayrollsOnSamePAYEScheme: (agencyProfileId, parentBureauAgencyProfileID, includeTargetProfile) => {

			const url = lib + 'GetPayrollsOnSamePAYEScheme';
			const data = {
				AgencyProfileID: agencyProfileId,
				ParentBureauAgencyProfileID: parentBureauAgencyProfileID,
				IncludeTargetProfile: includeTargetProfile
			};

			return promise.getPromise(url, data);
		},

		getPolicyGrades: (agencyProfileId) => {

			const url = lib + 'GetPolicyGrades';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getQBAPayDateRanges: (payDate, payPeriodType) => {

			const url = lib + 'GetQBAPayDateRanges';
			const data = {
				PayDateISO: payDate,
				PayPeriodType: payPeriodType
			};
			return promise.getPromise(url, data);
		},

		getWorkPattern: (workPatternId) => {

			const url = lib + 'GetWorkPattern';
			const data = {
				WorkPatternID: workPatternId
			};

			return promise.getPromise(url, data);
		},

		getWorkPatterns: (agencyProfileId, userId) => {

			const url = lib + 'GetWorkPatterns';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},

		getWorkPatternsForAgency: (agencyProfileId) => {

			const url = lib + 'GetWorkPatternsForAgency';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getWorkPatternUsers: (workPatternId) => {

			const url = lib + 'GetWorkPatternUsers';
			const data = {
				WorkPatternID: workPatternId
			};

			return promise.getPromise(url, data);
		},

		getEmptyCompanySetup: agencyProfileId => {

			const url = lib + 'GetEmptyCompanySetup';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getEmptyPolicy: () => {

			const url = lib + 'GetEmptyPolicy';
			return promise.getPromise(url);
		},

		getEmptyPolicyBand: () => {

			const url = lib + 'GetEmptyPolicyBand';
			return promise.getPromise(url);
		},

		getEmptyPolicyBandEntitlementPeriod: () => {

			const url = lib + 'GetEmptyPolicyBandEntitlementPeriod';
			return promise.getPromise(url);
		},

		getEmptyWorkPattern: () => {

			const url = lib + 'GetEmptyWorkPattern';

			return promise.getPromise(url);
		},

		getOnboardingCompanies: (agencyProfileId) => {

			const url = lib + 'GetOnboardingCompanies';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getOnboardingDashboard: (agencyProfileId) => {

			const url = lib + 'GetOnboardingDashboard';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getOnboardingQuestions: (onboardingId) => {

			const url = lib + 'GetOnboardingQuestions';
			const data = {
				OnboardingID: onboardingId
			};
			return promise.getPromise(url, data);
		},

		getOnboardingTeamMembers: (agencyProfileId) => {

			const url = lib + 'GetOnboardingTeamMembers';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getP60NotificationSettings: agencyProfileId => {

			const url = lib + 'GetP60NotificationSettings';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getPAYEDetails: (agencyProfileId) => {

			const url = lib + 'GetPAYEDetails';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getPAYEDetailsPreview: (payDateIso) => {

			const url = lib + 'GetPAYEDetailsPreview';
			const data = {
				PayDateISO: payDateIso
			};

			return promise.getPromise(url, data);
		},

		getPayPeriodCountsForDashboardView: (agencyProfileId) => {

			const url = lib + 'GetPayPeriodCountsForDashboardView';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodCountsForPeriodView: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'GetPayPeriodCountsForPeriodView';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodCountsForRunPayrollView: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'GetPayPeriodCountsForRunPayrollView';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodCountsForSettingsView: (agencyProfileId) => {

			const url = lib + 'GetPayPeriodCountsForSettingsView';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodMinimum: (agencyProfileId, previousPeriod) => {

			const url = lib + 'GetPayPeriodMinimum';
			const data = {
				AgencyProfileID: agencyProfileId,
				PreviousPeriod: previousPeriod
			};
			return promise.getPromise(url, data);
		},

		getPolicy: (agencyProfileId, policyId) => {

			const url = lib + 'GetPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId
			};
			return promise.getPromise(url, data);
		},

		getPolicyGroup: (agencyProfileId, policyGroupId) => {

			const url = lib + 'GetPolicyGroup';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyGroupID: policyGroupId
			};

			return promise.getPromise(url, data);
		},

		getPolicyNameUnique: (agencyProfileId, policyId, policyName, policyType) => {

			const url = lib + 'GetPolicyNameUnique';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId,
				PolicyName: policyName,
				PolicyType: policyType
			};
			return promise.getPromise(url, data);
		},

		getPolicyCodeUnique: (agencyProfileId, policyId, policyCode, policyType) => {

			const url = lib + 'GetPolicyCodeUnique';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId,
				PolicyCode: policyCode,
				PolicyType: policyType
			};
			return promise.getPromise(url, data);
		},

		getPolicies: (agencyProfileId, policyType, includeUpdates) => {

			const url = lib + 'GetPolicies';
			const data = {
				AgencyProfileID: agencyProfileId,
				Type: policyType,
				IncludeUpdates: includeUpdates
			};
			return promise.getPromise(url, data);
		},

		resolvePayPeriodDates: (startDateIso, agencyProfileId, periodsArr) => {

			const url = lib + 'ResolvePayPeriodDates';
			const data = {
				StartDateISO: startDateIso,
				AgencyProfileID: agencyProfileId,
				Periods: periodsArr
			};
			return promise.getPromise(url, data);
		},

		sendInvitationMail: (onboardingId, agencyProfileParentId, includeToken) => {

			const url = lib + 'SendInvitationMail';
			const data = {
				AgencyProfileParentID: agencyProfileParentId, // 0 = paycircle or 1 = FSB
				OnboardingID: onboardingId
			};
			const svcConfig = {
				includeToken: includeToken !== undefined ? includeToken : false
			};

			return promise.getPromise(url, data, svcConfig);
		},

		sendInvitationMailInternal: (onboardingId, agencyProfileParentId) => {

			const url = lib + 'SendInvitationMailInternal';
			const data = {
				AgencyProfileParentID: agencyProfileParentId, // GUID
				OnboardingID: onboardingId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyCustomerCode: (agencyProfileId, agencyCustomerCode) => {

			const url = lib + 'UpdateAgencyCustomerCode';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyCustomerCode: agencyCustomerCode
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyCustomerCodes: (agencyProfileId, agencyCustomerCodes) => {

			const url = lib + 'UpdateAgencyCustomerCodes';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyCustomerCodes: agencyCustomerCodes
			};

			return promise.getPromise(url, dataObj);
		},


		updateAgencyEmployerNetPayCalculationDetails: (agencyProfileId, calculationDetails) => {

			const url = lib + 'UpdateAgencyEmployerNetPayCalculationDetails';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				CalculationDetails: calculationDetails
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyEmployerReferences: (employerDetails) => {

			const url = lib + 'UpdateAgencyEmployerReferences';
			const data = {
				EmployerDetails: employerDetails
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerStatusDetails: (employerDetails) => {

			const url = lib + 'UpdateAgencyEmployerStatusDetails';
			const data = {
				EmployerDetails: employerDetails
			};

			return promise.getPromise(url, data);
		},

		updateAgencyPayPeriodCurrencyCheck: (agencyProfileId, agencyPayPeriodId, currencyCheck) => {

			const url = lib + 'UpdateAgencyPayPeriodCurrencyCheck';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				CurrencyCheck: currencyCheck
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyPayPeriodRollback: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'UpdateAgencyPayPeriodRollback';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileAgencyProfiles: (agencyProfileIdList, agencyProfileParentId, remove) => {

			const url = lib + 'UpdateAgencyProfileAgencyProfiles';
			const data = {
				AgencyProfileIDList: agencyProfileIdList,
				AgencyProfileParentID: agencyProfileParentId,
				Remove: remove
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileAgencyProfile: (agencyProfileId, agencyProfileParentId, remove) => {

			const url = lib + 'UpdateAgencyProfileAgencyProfile';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyProfileParentID: agencyProfileParentId,
				Remove: remove
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileCeasePAYEScheme: (agencyProfileId, dateToCancelIso, deleteCessationDetails) => {

			const url = lib + 'UpdateAgencyProfileCeasePAYEScheme';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				DateToCancelISO: dateToCancelIso,
				DeleteCessationDetails: deleteCessationDetails
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyProfilePayslipAdditionalNoticeVisible: (agencyProfileId, additionalNoteVisible) => {

			const url = lib + 'UpdateAgencyProfilePayslipAdditionalNoticeVisible';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AdditionalNoteVisible: additionalNoteVisible
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyProfilePayslipPeriodVisible: (agencyProfileId, periodVisible) => {

			const url = lib + 'UpdateAgencyProfilePayslipPeriodVisible';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				PeriodVisible: periodVisible
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyProfilePdfPayslipSorting: (agencyProfileId, businessCategorySorting, teamMemberSorting) => {

			const url = lib + 'UpdateAgencyProfilePDFPayslipSorting';
			const data = {
				AgencyProfileID: agencyProfileId,
				BusinessCategorySorting: businessCategorySorting,
				TeamMemberSorting: teamMemberSorting
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerAutoApplyNICodeChanges: (agencyProfileId, autoApplyNiCode) => {

			const url = lib + 'UpdateAgencyEmployerAutoApplyNICodeChanges';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AutoApplyNICode: autoApplyNiCode
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyProfileEmployeePortalPermissionValue: (agencyProfileId, permissionValue) => {

			const url = lib + 'UpdateAgencyProfileEmployeePortalPermissionValue';
			const data = {
				AgencyProfileID: agencyProfileId,
				PermissionValue: permissionValue
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerAutoRun: (agencyProfileId, autoRun) => {

			const url = lib + 'UpdateAgencyEmployerAutoRun';
			const data = {
				AgencyProfileID: agencyProfileId,
				AutoRun: autoRun
			};

			return promise.getPromise(url, data);
		},

		updateBackdatedSalaryDerivedElementsEnabled: (agencyProfileId, isEnabled) => {

			const url = lib + 'UpdateBackdatedSalaryDerivedElementsEnabled';
			const data = {
				AgencyProfileID: agencyProfileId,
				IsEnabled: isEnabled
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerDirectorNIStandard: (agencyProfileId, standardMethod) => {

			const url = lib + 'UpdateAgencyEmployerDirectorNIStandard';
			const data = {
				AgencyProfileID: agencyProfileId,
				StandardMethod: standardMethod
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerDisableRTISubmissions: (agencyProfileId, rtiDisabled) => {

			const url = lib + 'UpdateAgencyEmployerDisableRTISubmissions';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				RTIDisabled: rtiDisabled
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyEmployerInactivity: (agencyProfileId, startPeriodId, endPeriodId) => {

			const url = lib + 'UpdateAgencyEmployerInactivity';
			const data = {
				AgencyProfileID: agencyProfileId,
				StartPeriodID: startPeriodId,
				EndPeriodID: endPeriodId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerSkipped: (agencyProfileId, startPeriodId, endPeriodId) => {

			const url = lib + 'UpdateAgencyEmployerSkipped';
			const data = {
				AgencyProfileID: agencyProfileId,
				StartPeriodID: startPeriodId,
				EndPeriodID: endPeriodId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileArchive: (agencyProfileId, archive, reason) => {

			const url = lib + 'UpdateAgencyProfileArchive';
			const data = {
				AgencyProfileID: agencyProfileId,
				Archive: archive,
				Reason: reason
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileIsPayDashboardEnabled: (agencyProfileId, isPayDashboardEnabled) => {

			const url = lib + 'UpdateAgencyProfileIsPayDashboardEnabled';
			const data = {
				AgencyProfileID: agencyProfileId,
				IsPayDashboardEnabled: isPayDashboardEnabled
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileIsInTestMode: (agencyProfileId, isInTestMode) => {

			const url = lib + 'UpdateAgencyProfileIsInTestMode';
			const data = {
				AgencyProfileID: agencyProfileId,
				IsInTestMode: isInTestMode === undefined ? false : isInTestMode
			};

			return promise.getPromise(url, data);
		},
		updateAgencyProfileIsPayslipManagerSetupComplete: (agencyProfileId, isSetupComplete) => {

			const url = lib + 'UpdateAgencyProfileIsPayslipManagerSetupComplete';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				IsSetupComplete: isSetupComplete
			};

			return promise.getPromise(url, dataObj);
		},
		updateAgencyProfilePensionCommunicationSettings: (agencyProfileId, pensionCommunicationSettingsObj) => {

			const url = lib + 'UpdateAgencyProfilePensionCommunicationSettings';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				PensionCommunicationSettings: pensionCommunicationSettingsObj
			};

			return promise.getPromise(url, dataObj);
		},
		updateAgencyProfilePensionSubmissionSettings: (agencyProfileId, pensionSubmissionSettings) => {

			const url = lib + 'UpdateAgencyProfilePensionSubmissionSettings';
			const data = {
				AgencyProfileID: agencyProfileId,
				PensionSubmissionSettings: pensionSubmissionSettings
			};

			return promise.getPromise(url, data);
		},
		updateAgencyProfilePensionSupplementaryPaySettings: (agencyProfileId, pensionSupplementaryPaySettings) => {

			const url = lib + 'UpdateAgencyProfilePensionSupplementaryPaySettings';
			const data = {
				AgencyProfileID: agencyProfileId,
				PensionSupplementaryPaySettings: pensionSupplementaryPaySettings
			};

			return promise.getPromise(url, data);
		},
		updateAgencyEmployerPayrollBIK: (agencyProfileId, payrollBik, payrollBIKRegistrationDateISO) => {

			const url = lib + 'UpdateAgencyEmployerPayrollBIK';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayrollBIK: payrollBik,
				PayrollBIKRegistrationDateISO: payrollBIKRegistrationDateISO
			};

			return promise.getPromise(url, data);
		},
		updateCompanyCustomisationBranding: (agencyProfileId, brandingDetails) => {

			const url = lib + 'UpdateCompanyCustomisationBranding';
			const data = {
				AgencyProfileID: agencyProfileId,
				BrandingDetails: brandingDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyCustomisationEmail: (agencyProfileId, emailDetails) => {

			const url = lib + 'UpdateCompanyCustomisationEmail';
			const data = {
				AgencyProfileID: agencyProfileId,
				EmailDetails: emailDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyCustomisationIntercom: (agencyProfileId, intercomDetails) => {

			const url = lib + 'UpdateCompanyCustomisationIntercom';
			const data = {
				AgencyProfileID: agencyProfileId,
				IntercomDetails: intercomDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyCustomisationLogin: (agencyProfileId, loginDetails) => {

			const url = lib + 'UpdateCompanyCustomisationLogin';
			const data = {
				AgencyProfileID: agencyProfileId,
				LoginDetails: loginDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyCustomisationPayslip: (agencyProfileId, payslipDetails, contact) => {

			const url = lib + 'UpdateCompanyCustomisationPayslip';
			const data = {
				AgencyProfileID: agencyProfileId,
				Contact: contact,
				PayslipDetails: payslipDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyInformationBasic: (companyDetails) => {

			const url = lib + 'UpdateCompanyInformationBasic';
			const data = {
				CompanyDetails: companyDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyModules: (agencyProfileID, companyDetails) => {

			const url = lib + 'UpdateCompanyModules';
			const data = {
				AgencyProfileID: agencyProfileID,
				CompanyDetails: companyDetails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyP32Management: companyP32Management => {

			const url = lib + 'UpdateCompanyP32Management';
			const dataObj = {
				CompanyP32Management: companyP32Management
			};

			return promise.getPromise(url, dataObj);
		},

		updateCurrencies: (agencyProfileId, currencies) => {

			const url = lib + 'UpdateCurrencies';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				Currencies: currencies
			};

			return promise.getPromise(url, dataObj);
		},

		updateAgencyEmployerEPSDisabled: (agencyProfileId, EPSDisabled) => {

			const url = lib + 'UpdateAgencyEmployerEPSDisabled';
			const data = {
				AgencyProfileID: agencyProfileId,
				EPSDisabled: EPSDisabled
			};

			return promise.getPromise(url, data);
		},

		updateAgencyEmployerAutoApplyTaxRefund: (agencyProfileId, autoApplyTaxRefund) => {

			var url = lib + 'UpdateAgencyEmployerAutoApplyTaxRefund';
			var data = {
				AgencyProfileID: agencyProfileId,
				AutoApplyTaxRefund: autoApplyTaxRefund
			};

			return promise.getPromise(url, data);
		},

		updateCompanyIntegrations: (agencyProfileId, integrationData) => {

			const url = lib + 'UpdateCompanyIntegrations';
			const data = {
				AgencyProfileID: agencyProfileId,
				CompanyIntegrations: {
					IsEdpIntegrationEnabled: integrationData.isEdpIntegrationEnabled,
					IsPayExperianIntegrationEnabled: integrationData.isPayExperianIntegrationEnabled,
					IsPeopleHRIntegrationEnabled: integrationData.isPeopleHRIntegrationEnabled
				}
			};

			return promise.getPromise(url, data);
		},

		updateEdpIntegrationTopic: (agencyProfileId, edpIntegrationTopicId, edpIntegrationTopicKey, isEnabled) => {

			const url = lib + 'UpdateEdpIntegrationTopic';
			const data = {
				AgencyProfileID: agencyProfileId,
				EdpIntegrationTopicID: edpIntegrationTopicId,
				EdpIntegrationTopicKey: edpIntegrationTopicKey,
				IsEnabled: isEnabled
			};

			return promise.getPromise(url, data);
		},

		updateIsGenderPayGapEnabled: (agencyProfileId, isGenderPayGapEnabled) => {

			const url = lib + 'UpdateGenderPayGapReportingModule';
			const data = {
				AgencyProfileID: agencyProfileId,
				IsGenderPayGapReportingActive: isGenderPayGapEnabled
			};

			return promise.getPromise(url, data);
		},

		updateOnboardingActivationCode: (onboardingId, bureau) => {

			const url = lib + 'UpdateOnboardingActivationCode';
			const data = {
				OnboardingID: onboardingId,
				Bureau: bureau
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingCompany: (onboardingId, agencyProfileParentId, companyName, forename, surname, emailAddress, telephone, delaySend) => {

			const url = lib + 'UpdateOnboardingCompany';
			const data = {
				OnboardingID: onboardingId,
				AgencyProfileParentID: agencyProfileParentId,
				CompanyName: companyName,
				Forename: forename,
				Surname: surname,
				EmailAddress: emailAddress,
				Telephone: telephone,
				DelaySend: delaySend
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingGoLiveDate: (onboardingId, goLiveDateISO) => {

			const url = lib + 'UpdateOnboardingGoLiveDate';
			const data = {
				OnboardingID: onboardingId,
				GoLiveDateISO: goLiveDateISO
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingQuestions: (onboardingQuestions) => {

			const url = lib + 'UpdateOnboardingQuestions';
			const data = {
				OnboardingQuestions: onboardingQuestions
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingQuestionComplete: (onboardingQuestionID, complete) => {

			const url = lib + 'UpdateOnboardingQuestionComplete';
			const data = {
				OnboardingQuestionID: onboardingQuestionID,
				Complete: complete
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingQuestionGroupComplete: (onboardingId, onboardingQuestionGroupId, complete) => {

			const url = lib + 'UpdateOnboardingQuestionGroupComplete';
			const data = {
				OnboardingID: onboardingId,
				OnboardingQuestionGroupID: onboardingQuestionGroupId,
				Complete: complete
			};
			return promise.getPromise(url, data);
		},

		updateOnboardingState: (onboardingId, agencyProfileID, onboardingState) => {

			const url = lib + 'UpdateOnboardingState';
			const data = {
				OnboardingID: onboardingId,
				AgencyProfileID: agencyProfileID,
				OnboardingState: onboardingState
			};

			return promise.getPromise(url, data);
		},

		updateOnboardingTeamComplete: (onboardingId, agencyProfileID, teamComplete) => {

			const url = lib + 'UpdateOnboardingTeamComplete';
			const data = {
				OnboardingID: onboardingId,
				AgencyProfileID: agencyProfileID,
				TeamComplete: teamComplete
			};

			return promise.getPromise(url, data);
		},

		updateOnboardingTrialExpiryDate: (onboardingId, agencyProfileId) => {

			const url = lib + 'UpdateOnboardingTrialExpiryDate';
			const data = {
				OnboardingID: onboardingId,
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		updatePolicyGrade: (agencyProfileId, updatedPolicyGrade) => {

			const url = lib + 'UpdatePolicyGrade';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedPolicyGrade: updatedPolicyGrade
			};
			return promise.getPromise(url, data);
		},

		updateParentScheduledP60NotificationDate: (agencyProfileParentID, scheduledDocumentNotificationId, notificationDateIso, overwriteChildCompaniesSettings) => {

			const url = lib + 'UpdateParentScheduledP60NotificationDate';
			const dataObj = {
				AgencyProfileParentID: agencyProfileParentID,
				ScheduledDocumentNotificationID: scheduledDocumentNotificationId,
				NotificationDateISO: notificationDateIso,
				OverwriteChildAgencies: overwriteChildCompaniesSettings
			};

			return promise.getPromise(url, dataObj);
		},

		updateScheduledP60NotificationDate: (agencyProfileId, scheduledDocumentNotificationId, notificationDateIso) => {

			const url = lib + 'UpdateScheduledP60NotificationDate';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ScheduledDocumentNotificationID: scheduledDocumentNotificationId,
				NotificationDateISO: notificationDateIso
			};

			return promise.getPromise(url, dataObj);
		},

		updateWorkPatternForAgency: (agencyProfileId, pattern) => {

			const url = lib + 'UpdateWorkPatternForAgency';
			const data = {
				AgencyProfileID: agencyProfileId,
				Pattern: pattern
			};
			return promise.getPromise(url, data);
		},

		updateWorkPatterns: (agencyProfileId, updatedWorkPatterns, userId) => {

			const url = lib + 'UpdateWorkPatterns';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedWorkPatterns: updatedWorkPatterns,
				UserID: userId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodDetails: (agencyProfileId) => {

			const url = lib + 'GetPayPeriodDetails';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getPayPeriodDetails2: (agencyProfileId) => {

			const url = lib + 'GetPayPeriodDetails2';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		fetchOrganizations: function (agencyProfileId) {

			var url = lib + 'GetWorkspaceAssociatedOrganisations';
			var data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getLinkedCompanies: function (organisationID) {

			var url = lib + 'GetLinkedCompaniesByWorkspaceOrganisationID';
			var data = {
				AccessWorkspaceOrganisationID: organisationID
			};

			return promise.getPromise(url, data);
		},

		getOrganisationCustomerCode: function (organisationID) {

			var url = lib + 'GetOrganisationCustomerCodeByOrganisationID';
			var data = {
				AccessWorkspaceOrganisationID: organisationID
			};

			return promise.getPromise(url, data);
		},

		getCustomerCodeByAgencyProfileId: function (agencyProfileId) {

			var url = lib + 'GetCustomerCodeByAgencyProfileID';
			var data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAccessRotareadyConnection: (agencyProfileId) => {

			const url = integrationLib + 'GetAccessRotareadyConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		createAccessRotareadyConnection: (agencyProfileId, clientId, clientSecret, realm) => {

			const url = integrationLib + 'CreateAccessRotareadyConnection';
			const data = {
				AgencyProfileID: agencyProfileId,
				ClientId: clientId,
				ClientSecret: clientSecret,
				Realm: realm
			};
			return promise.getPromise(url, data);
		},

		deleteAccessRotareadyConnection: (agencyProfileId) => {

			const url = integrationLib + 'DeleteAccessRotareadyConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getAvailableAccessRotareadyEntities: (agencyProfileId) => {

			const url = integrationLib + 'GetAvailableAccessRotareadyEntities';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getRotareadyEntityMappingsForRealm: (agencyProfileId) => {

			const url = integrationLib + 'GetRotareadyEntityMappingsForRealm';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		updateAccessRotareadyEntities: (agencyProfileId, entities) => {

			const url = integrationLib + 'UpdateAccessRotareadyEntities';
			const data = {
				AgencyProfileID: agencyProfileId,
				Entities: entities
			};
			return promise.getPromise(url, data);
		},

		updateAccessRotareadyEntitySelection: (agencyProfileId, entities, removedRotareadyEntityIds) => {

			const url = integrationLib + 'UpdateAccessRotareadyEntitySelection';
			const data = {
				AgencyProfileID: agencyProfileId,
				Entities: entities,
				RemovedRotareadyEntityIDs: removedRotareadyEntityIds
			};
			return promise.getPromise(url, data);
		},

		getRotareadyEntityLinkedEmployeeCounts: (agencyProfileId, entityIds) => {

			const url = integrationLib + 'GetRotareadyEntityLinkedEmployeeCounts';
			const data = {
				AgencyProfileID: agencyProfileId,
				EntityIDs: entityIds
			};
			return promise.getPromise(url, data);
		},

		getAccessRotareadyUserMapping: (agencyProfileId) => {

			const url = integrationLib + 'GetAccessRotareadyUserMapping';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		updateAccessRotareadyUserMapping: (agencyProfileId, userMapping) => {

			const url = integrationLib + 'UpdateAccessRotareadyUserMapping';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserMapping: userMapping
			};
			return promise.getPromise(url, data);
		},

		getAccessRotareadyPayElementMapping: (agencyProfileId) => {

			const url = integrationLib + 'GetAccessRotareadyPayElementMapping';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getAgencyProfileSickPayDefaultWorkDays: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileSickPayDefaultWorkDays';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileSickPayDefaultWorkDays: (agencyProfileId, workDays) => {

			const url = lib + 'UpdateAgencyProfileSickPayDefaultWorkDays';
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkDays: workDays
			};

			return promise.getPromise(url, data);
		},

		getAgencyProfileSicknessProRationMethod: (agencyProfileId) => {

			const url = lib + 'GetAgencyProfileSicknessProRationMethod';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		updateAgencyProfileSicknessProRationMethod: (agencyProfileId, proRationMethod, displayLeaveDaysAsSeparateDeduction) => {

			const url = lib + 'UpdateAgencyProfileSicknessProRationMethod';
			const data = {
				AgencyProfileID: agencyProfileId,
				DisplayLeaveDaysAsSeparateDeduction: displayLeaveDaysAsSeparateDeduction,
				ProRationMethod: proRationMethod
			};

			return promise.getPromise(url, data);
		},

		getReferencePeriodConfigAtCurrentPeriod: function (agencyProfileId) {

			const url = integrationLib + 'GetReferencePeriodConfigAtCurrentPeriod';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		updateRotareadyReferencePeriodConfig: function (agencyProfileId, currentReferencePeriodStartDateISO, currentReferencePeriodPattern) {

			const url = integrationLib + 'UpdateRotareadyReferencePeriodConfig';
			const data = {
				AgencyProfileID: agencyProfileId,
				CurrentReferencePeriodStartDateISO: currentReferencePeriodStartDateISO,
				CurrentReferencePeriodPattern: currentReferencePeriodPattern
			};
			return promise.getPromise(url, data);
		},

		getRotaReadyReferencePeriodsPreview: function (agencyProfileId, currentReferencePeriodStartDateISO, currentReferencePeriodPattern) {

			const url = integrationLib + 'GetRotaReadyReferencePeriodsPreview';
			const data = {
				AgencyProfileID: agencyProfileId,
				CurrentReferencePeriodStartDateISO: currentReferencePeriodStartDateISO,
				CurrentReferencePeriodPattern: currentReferencePeriodPattern
			};
			return promise.getPromise(url, data);
		},

		getRotareadyEntityBusinessCodeMapping: (agencyProfileId) => {

			const url = integrationLib + 'GetRotareadyEntityBusinessCodeMapping';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		updateRotareadyEntityBusinessCodes: (agencyProfileId, entityBusinessCodes, newBusinessCodes) => {

			const url = integrationLib + 'UpdateRotareadyEntityBusinessCodes';
			const data = {
				AgencyProfileID: agencyProfileId,
				EntityBusinessCodes: entityBusinessCodes,
				NewBusinessCodes: newBusinessCodes
			};
			return promise.getPromise(url, data);
		},

		updateRotareadyReferencePeriodOffsetConfig: function (agencyProfileId, anchor, offsetDays, target) {

			const url = integrationLib + 'UpdateRotareadyReferencePeriodOffsetConfig';
			const data = {
				AgencyProfileID: agencyProfileId,
				Anchor: anchor,
				OffsetDays: offsetDays,
				Target: target
			};
			return promise.getPromise(url, data);
		},

		getRotareadyReferencePeriodsOffsetPreview: function (agencyProfileId, anchor, offsetDays, target) {

			const url = integrationLib + 'GetRotareadyReferencePeriodsOffsetPreview';
			const data = {
				AgencyProfileID: agencyProfileId,
				Anchor: anchor,
				OffsetDays: offsetDays,
				Target: target
			};
			return promise.getPromise(url, data);
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('dataImportData', ['libraries', 'promise', function (libraries, promise) {

	var lib	= libraries.importLib;
	var service = {

		createBureauCompany: function (companyName, playground) {

			var url = lib + 'CreateBureauCompany';
			var data = {
				CompanyName: companyName,
				Playground: playground !== undefined ? playground : false // default to false
			};

			return promise.getPromise(url, data);
		},

		createGroupCompany: function (agencyProfileParentId, companyName, organizationID) {

			var url = lib + 'CreateGroupCompany';
			var data = {
				AgencyProfileParentID: agencyProfileParentId,
				CompanyName: companyName,
				OrganizationID: organizationID
			};

			return promise.getPromise(url, data);
		},

		editGroupCompany: function (companyName, agencyProfileId, organisationID, previousOrganisationID, bureauAgencyProfileID) {

			var url = lib + 'EditGroupCompany';
			var data = {
				CompanyName: companyName,
				AgencyProfileID: agencyProfileId,
				OrganisationID: organisationID,
				PreviousOrganisationID: previousOrganisationID,
				BureauAgencyProfileID: bureauAgencyProfileID
			};

			return promise.getPromise(url, data);
		},

		editGroupName: function (agencyProfileId, companyName) {

			var url = lib + 'EditGroupName';
			var data = {
				AgencyProfileID: agencyProfileId,
				CompanyName: companyName
			};

			return promise.getPromise(url, data);
		},

		linkCompanyToOrganisation: function (companyName, organisationID) {

			var url = lib + 'LinkCompanyToOrganization';
			var data = {
				CompanyName: companyName,
				OrganizationID: organisationID
			};

			return promise.getPromise(url, data);
		},

		getLinkedOrganisationToGroupCompany: function (agencyProfileId) {
	
			var url = lib + 'GetLinkedOrganisationToGroupCompany';
			var data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getLinkedBureauAgencyProfileIdByGroupId: function (agencyProfileId) {
		
			var url = lib + 'GetLinkedBureauAgencyProfileIdByGroupId';
			var data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		createPlayground: function (agencyProfileId, companyName) {

			var url = lib + 'CreatePlayground';
			var data = {
				AgencyProfileID: agencyProfileId,
				CompanyName: companyName
			};

			return promise.getPromise(url, data);
		},

		getAreHMRCCredentialsValid: (agencyProfileId, senderId, value) => {

			const url = lib + 'GetAreHMRCCredentialsValid';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				SenderID: senderId,
				Value: value
			};

			return promise.getPromise(url, dataObj);
		},

		getAreHMRCCredentialsValidPreview: (senderId, value) => {

			const url = lib + 'GetAreHMRCCredentialsValidPreview';
			const dataObj = {
				SenderID: senderId,
				Value: value
			};

			return promise.getPromise(url, dataObj);
		},

		getImportMappingColumns: function (agencyDocumentTypeId) {

			var url = lib + 'GetImportMappingColumns';
			var data = {
				AgencyDocumentTypeID: agencyDocumentTypeId
			};

			return promise.getPromise(url, data);
		},

		updateImportMappingFile: function (agencyProfileId, agencyPayPeriodId, agencyDocumentId, mapping) {

			var url = lib + 'UpdateImportMappingFile';
			var data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				Mapping: mapping
			};

			return promise.getPromise(url, data);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('mailData', ['libraries', 'promise', function (libraries, promise) {

	var lib = libraries.mail;
	var service = {

		getCompanyEmailSettings: function (agencyProfileId) {

			let url = lib + 'GetCompanyEmailSettings';
			let data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getCompanyEmailFrameworkOptions: function (agencyProfileId) {

			let url = lib + 'GetCompanyEmailFrameworkOptions';
			let data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getMailLog: function (mailLogId) {

			let url = lib + 'GetMailLog';
			let data = {
				MailLogKey: mailLogId
			};

			return promise.getPromise(url, data);
		},

		getMailLogSummariesForUser: function (userID, agencyProfileId) {

			let url = lib + 'GetMailLogSummariesForUser';
			let data = {
				UserID: userID,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getMailLogSummariesForAgency: function (agencyProfileId, agencyEmployerPensionId) {

			let url = lib + 'GetMailLogSummariesForAgency';
			let data = {
				AgencyEmployerPensionID: agencyEmployerPensionId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getMailTemplateForMailType: function (mailTypeId) {

			let url = lib + 'GetMailTemplateForMailType';
			let data = {
				MailTypeID: mailTypeId
			};

			return promise.getPromise(url, data);
		},

		getTeamMemberPayslipNotes: function (userIds, agencyPayPeriodId, agencyProfileId) {

			var url = lib + 'GetTeamMemberPayslipNotes';
			var data = {
				UserIDs: userIds,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		sendMailTemplateForMailType: function (mailTypeId, userIDArray, agencyProfileId) {

			let url = lib + 'SendMailTemplateForMailType';
			let data = {
				MailTypeID: mailTypeId,
				UserIDList: userIDArray,
				AgencyProfileID: agencyProfileId,
				OverrideAddress: ''
			};

			return promise.getPromise(url, data);
		},

		sendMailTemplateForMailTypeToUser: function (mailTypeId, userId, agencyProfileId) {

			var userIdList = [];
			userIdList.push(userId);

			let url = lib + 'SendMailTemplateForMailType';
			let data = {
				MailTypeID: mailTypeId,
				UserIDList: userIdList,
				AgencyProfileID: agencyProfileId,
				OverrideAddress: ''
			};

			return promise.getPromise(url, data);
		},

		updateCompanyEmailSettings: function (agencyProfileId, updatedEmails) {

			let url = lib + 'UpdateCompanyEmailSettings';
			let data = {
				AgencyProfileID: agencyProfileId,
				UpdatedEmails: updatedEmails
			};

			return promise.getPromise(url, data);
		},

		updateCompanyEmailFramework: function (agencyProfileId, newCompanyEmailFramework) {

			let url = lib + 'UpdateCompanyEmailFramework';
			let data = {
				AgencyProfileID: agencyProfileId,
				NewCompanyEmailFramework: newCompanyEmailFramework
			};

			return promise.getPromise(url, data);
		},

		updateTeamMemberPayslipNotes: function (updatedPayslipNotes) {

			var url = lib + 'UpdateTeamMemberPayslipNotes';
			var data = {
				UpdatedPayslipNotes: updatedPayslipNotes
			};

			return promise.getPromise(url, data);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')
.service('messageData', ['config', 'libraries', 'promise', function (config, libraries, promise) {

	const lib = libraries.message;

	return {
		copyMessage: (agencyProfileId, messageId, messageType) => {

			let url = `${lib}CopyMessage`;
			let data = {
				AgencyProfileID: agencyProfileId,
				MessageID: messageId,
				MessageType: messageType
			};

			return promise.getPromise(url, data);
		},

		createMessage: (agencyProfileId, agencyPayPeriodId, newMessage, mentionList) => {

			const url = `${lib}CreateMessage`;
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				NewMessage: newMessage,
				MentionList: mentionList
			};

			return promise.getPromise(url, data);
		},

		getMessageNew: () => {

			const url = `${lib}GetMessageNew`;

			return promise.getPromise(url);
		},

		getMessageCountsPolling: userId => {

			const url = `${lib}GetMessageCountsPolling`;
			const dataObj = {
				UserID: userId
			};
			const configObj = {
				retries: 0
			};

			return promise.getPromise(url, dataObj, configObj);
		},

		getMessagesForRecipient: (agencyProfileId, messageRecipientId) => {

			let url = `${lib}GetMessagesForRecipient`;
			let data = {
				AgencyProfileID: agencyProfileId,
				MessageRecipientID: messageRecipientId
			};

			let config = {
				cancelRequestOnStateChange: false
			};

			return promise.getPromise(url, data, config);
		},

		getMessagesForPayPeriod: (agencyProfileId, agencyPayPeriodId, messageFormat) => {

			let url = `${lib}GetMessagesForPayPeriod`;
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				MessageFormat: messageFormat
			};

			let config = {
				cancelRequestOnStateChange: false
			};

			return promise.getPromise(url, data, config);
		},

		getMessageStatusCount: (agencyProfileId, messageStatus) => {

			let url = `${lib}GetMessageStatusCount`;
			let data = {
				AgencyProfileID: agencyProfileId,
				MessageStatus: messageStatus
			};

			return promise.getPromise(url, data);
		},

		getPensionLogEntriesForPeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = `${lib}GetPensionLogEntriesForPeriod`;
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},

		copyWorkflowTemplate: (agencyProfileId, workflowTemplateId, createTask) => {

			const url = `${lib}CopyWorkflowTemplate`;
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkflowTemplateID: workflowTemplateId,
				CreateTask: createTask
			};

			return promise.getPromise(url, data);
		},

		deleteWorkflowTemplate: (agencyProfileId, workflowTemplateId) => {

			const url = `${lib}DeleteWorkflowTemplate`;
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkflowTemplateID: workflowTemplateId
			};

			return promise.getPromise(url, data);
		},

		getMessageMentionsNew: userId => {

		    const url = `${lib}GetMessageMentionsNew`;
		    const data = {
		        UserID: userId
		    };

		    return promise.getPromise(url, data);
		},

		getMessagesForAlert: userId => {

			const url = `${lib}GetMessagesForAlert`;
			const dataObj = {
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		getMessagesForMention: (agencyProfileId, userId) => {

		    const url = `${lib}GetMessagesForMention`;
		    const data = {
		    	AgencyProfileID: agencyProfileId,
		        UserID: userId
		    };

		    return promise.getPromise(url, data);
		},

		getMessagesForUpdate: userId => {

		    const url = `${lib}GetMessagesForUpdate`;
		    const data = {
		        UserID: userId
		    };

		    return promise.getPromise(url, data);
		},

		getPeriodAlerts: (agencyProfileId, payPeriodId, calculated) => {

			const url = `${lib}GetPeriodAlerts`;
			const data = {
				AgencyProfileID: agencyProfileId,
				PayPeriodID: payPeriodId,
				Calculated: calculated
			};
			const config = {
				cancelRequestOnStateChange: false
			};

			return promise.getPromise(url, data, config);
		},

		getPeriodAlertCount: (agencyProfileId, agencyPayPeriodId) => {

			const url = `${lib}GetPeriodAlertCount`;
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				Calculated: true
			};

			return promise.getPromise(url, data);
		},

		getWorkflowLogEntries: (agencyProfileId) => {

			const url = `${lib}GetWorkflowLogEntries`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getWorkflowOverview: (agencyProfileId) => {

			const url = `${lib}GetWorkflowOverview`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getWorkflowTemplateCurrentEntries: (agencyProfileId) => {

			const url = `${lib}GetWorkflowTemplateCurrentEntries`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getWorkflowTemplateCurrentEntriesForUser: (agencyProfileId) => {

			const url = `${lib}GetWorkflowTemplateCurrentEntriesForUser`;
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getWorkflowTemplates: (agencyProfileId, workflowTemplateId) => {

			const url = `${lib}GetWorkflowTemplates`;
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkflowTemplateID: workflowTemplateId
			};

			return promise.getPromise(url, data);
		},

		markAllMentionsAsRead: (userId) => {

			const url = `${lib}MarkAllMentionsAsRead`;
			const data = {
				UserID: userId
			};

			return promise.getPromise(url, data);

		},

		markAllUpdatesAsRead: (userId) => {

			const url = `${lib}MarkAllUpdatesAsRead`;
			const data = {
				UserID: userId
			};

			return promise.getPromise(url, data);

		},

		messageDocumentDelete: (agencyProfileId, agencyDocumentId) => {

			let url = `${lib}MessageDocumentDelete`;
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyDocumentID: agencyDocumentId
			};

			return promise.getPromise(url, data);
		},

		messageDocumentTransfer: (agencyProfileId, agencyPayPeriodId, agencyDocumentId, agencyDocumentTypeId) => {

			let url = `${lib}MessageDocumentTransfer`;
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyDocumentID: agencyDocumentId,
				AgencyDocumentTypeID: agencyDocumentTypeId
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateChangesTableState: (agencyProfileId, changesTableState) => {

			const url = `${lib}UpdateWorkflowTemplateChangesTableState`;
			const data = {
				AgencyProfileID: agencyProfileId,
				ChangesTableState: changesTableState
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateEntrySplashState: (workflowTemplateEntryId, state) => {

			const url = `${lib}UpdateWorkflowTemplateEntrySplashState`;
			const data = {
				WorkflowTemplateEntryID: workflowTemplateEntryId,
				State: state
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateEntryState: (workflowTemplateEntryId, state) => {

			const url = `${lib}UpdateWorkflowTemplateEntryState`;
			const data = {
				WorkflowTemplateEntryID: workflowTemplateEntryId,
				State: state
			};

			return promise.getPromise(url, data);
		},

		updateMessage: updatedMessage => {

			let url = `${lib}UpdateMessage`;
			let data = {
				UpdatedMessage: updatedMessage
			};

			return promise.getPromise(url, data);
		},

		updateMessageStatus: (messageId, messageStatus) => {

			let url = `${lib}UpdateMessageStatus`;
			let data = {
				MessageID: messageId,
				MessageStatus: messageStatus
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplatePayrollLocked: (agencyProfileId, workflowTemplateId, isLocked) => {

			const url = `${lib}UpdateWorkflowTemplatePayrollLocked`;
			const data = {
				AgencyProfileID: agencyProfileId,
				/* This could be undefined, so substitute it with an empty Guid. This API functio n can be called for companies
				   that don't have workflow enabled. */
				WorkflowTemplateID: angular.isDefined(workflowTemplateId) ? workflowTemplateId : config.guidEmpty,
				IsLocked: isLocked
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateEntry: (agencyProfileId, updatedWorkflowTemplateEntry) => {

			const url = `${lib}UpdateWorkflowTemplateEntry`;
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedWorkflowTemplateEntry: updatedWorkflowTemplateEntry
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateEntryActioner: (agencyProfileId, workflowTemplateEntryIdList, actionerId) => {

			const url = `${lib}UpdateWorkflowTemplateEntryActioner`;
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkflowTemplateEntryIDList: workflowTemplateEntryIdList,
				ActionerID: actionerId
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateState: (workflowTemplateId, state) => {

			const url = `${lib}UpdateWorkflowTemplateState`;
			const data = {
				WorkflowTemplateID: workflowTemplateId,
				State: state
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateQueried: (workflowTemplateId, isQueried) => {

			const url = `${lib}UpdateWorkflowTemplateQueried`;
			const data = {
				WorkflowTemplateID: workflowTemplateId,
				IsQueried: isQueried
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateEntries: (agencyProfileId, updatedWorkflowTemplateEntries, offsetType, calendarType) => {

			const url = `${lib}UpdateWorkflowTemplateEntries`;
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedWorkflowTemplateEntries: updatedWorkflowTemplateEntries,
				OffsetType: offsetType,
				CalendarType: calendarType
			};

			return promise.getPromise(url, data);
		},

		updateWorkflowTemplateOffsetType: (workflowTemplateId, offsetType) => {

			const url = `${lib}UpdateWorkflowTemplateOffsetType`;
			const dataObj = {
				WorkflowTemplateID: workflowTemplateId,
				OffsetType: offsetType
			};

			return promise.getPromise(url, dataObj);
		},

		updateWorkflowTemplateCalendarType: (workflowTemplateId, calendarType) => {

			const url = `${lib}UpdateWorkflowTemplateCalendarType`;
			const dataObj = {
				WorkflowTemplateID: workflowTemplateId,
				CalendarType: calendarType
			};

			return promise.getPromise(url, dataObj);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.service('payrollData', ['$q', 'config', 'libraries', 'promise', 'timedCache', function ($q, config, libraries, promise, timedCache) {

	const libAgency			= libraries.agency;
	const libMessage		= libraries.message;
	const libPayroll		= libraries.payroll;
	const libPayrollWorker 	= libraries.payrollWorker;
	const libUser			= libraries.user;

	const API_RESPONSE_CACHE_TIME_SECONDS = 5;

	const service = {
		calculatePaymentScheduleGroup: scheduleGroup => {

			const url = libPayroll + 'CalculatePaymentScheduleGroup';
			const data = {
				ScheduleGroup: scheduleGroup
			};

			return promise.getPromise(url, data);
		},
		deleteAgencyAdjustmentGroup: agencyAdjustmentGroupId => {

			const url = libPayroll + 'DeleteAgencyAdjustmentGroup';
			const data = {
				AgencyAdjustmentGroupID: agencyAdjustmentGroupId
			};

			return promise.getPromise(url, data);
		},
		deleteAgencyAdjustmentGroupEntry: agencyAdjustmentGroupEntryId => {

			const url = libPayroll + 'DeleteAgencyAdjustmentGroupEntry';
			const data = {
				AgencyAdjustmentGroupEntryID: agencyAdjustmentGroupEntryId
			};

			return promise.getPromise(url, data);
		},
		deleteAgencyPaymentHistorical: agencyPaymentId => {

			const url = libPayroll + 'DeleteAgencyPaymentHistorical';
			const data = {
				AgencyPaymentID: agencyPaymentId
			};

			return promise.getPromise(url, data);
		},
		deleteLinkElement: (agencyProfileId, linkElementId) => {

			const url = libPayroll + 'DeleteLinkElement';
			const data = {
				AgencyProfileID: agencyProfileId,
				LinkElementID: linkElementId
			};

			return promise.getPromise(url, data);
		},
		deleteManualEPS: manualEpsId => {

			const url = libPayroll + 'DeleteManualEPS';
			const data = {
				ManualEPSID: manualEpsId
			};

			return promise.getPromise(url, data);
		},
		deleteP11DbSubmission : (agencyProfileId, p11DbSubmissionId) => {
			const url = libPayroll + 'DeleteP11DbSubmission';
			const data = {
				P11DbSubmissionID:p11DbSubmissionId,
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		deletePaymentScheduleGroup: (agencyProfileId, paymentScheduleGroupId, cancelledReason, benefitEndDateIso) => {

			const url = libPayroll + 'DeletePaymentScheduleGroup';
			const data = {
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: paymentScheduleGroupId,
				CancelledReason: cancelledReason,
				BenefitEndDateISO: benefitEndDateIso
			};

			return promise.getPromise(url, data);
		},
		deletePolicyPay: (agencyProfileId, policyId) => {

			const url = libPayroll + 'DeletePolicyPay';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId
			};

			return promise.getPromise(url, data);
		},
		deleteSalaryPolicy: (agencyProfileId, salaryPolicyId) => {

			const url = libPayroll + 'DeleteSalaryPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				SalaryPolicyID: salaryPolicyId
			};

			return promise.getPromise(url, data);
		},
		deleteSalaryPolicyPost: (agencyProfileId, salaryPolicyPostId) => {

			const url = libPayroll + 'DeleteSalaryPolicyPost';
			const data = {
				AgencyProfileID: agencyProfileId,
				SalaryPolicyPostID: salaryPolicyPostId
			};

			return promise.getPromise(url, data);
		},
		deleteSupplementaryPayment: (agencyProfileId, supplementaryPaymentId) => {

			const url = libPayroll + 'DeleteSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		deleteUserPayElement: (agencyProfileId, agencyPayPeriodId, userPayElementId, requestingUserId) => {

			const url = libPayroll + 'DeleteUserPayElement';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserPayElementID: userPayElementId,
				RequestingUserID: requestingUserId
			};

			return promise.getPromise(url, data);
		},
		createGoCardlessDirectDebit: (agencyProfileId, newDirectDebitMandate) => {

			const url = libAgency + 'CreateGoCardlessDirectDebit';
			const data = {
				AgencyProfileID: agencyProfileId,
				NewDirectDebitMandate: newDirectDebitMandate
			};

			return promise.getPromise(url, data);
		},
		createOrUpdateTeamMemberSalaryPolicyPost: (agencyProfileId, userId, teamMemberSalaryPolicyPost) => {
			const url = libPayroll + 'CreateOrUpdateTeamMemberSalaryPolicyPost';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				TeamMemberSalaryPolicyPost: teamMemberSalaryPolicyPost
			};

			return promise.getPromise(url, data);
		},
		createP11DbSubmission: (p11dSubmission, agencyProfileId) => {
			const url = libPayroll + 'CreateP11DbSubmission';
			const data = {
				P11DbSubmission: p11dSubmission,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroups: agencyProfileId => {

			const url = libPayroll + 'GetAgencyAdjustmentGroups';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombined: (agencyProfileId, includeAdminAccessEntries) => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupCombined';
			const data = {
				AgencyProfileID: agencyProfileId,
				IncludeAdminAccessEntries: includeAdminAccessEntries
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombinedForRatedUnits: (agencyProfileId) => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupCombinedForRatedUnits';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombinedForDisbursements: agencyProfileId => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupCombinedForDisbursements';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombinedForDisbursement: (agencyProfileID, disbursementID) => {
			const url = libPayroll + 'GetAgencyAdjustmentGroupCombinedForDisbursement';
			const data = {
				AgencyProfileID: agencyProfileID,
				DisbursementID: disbursementID
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombinedForPension: (agencyProfileId, agencyEmployerPensionGroupId) => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupCombinedForPension';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPensionGroupID: agencyEmployerPensionGroupId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupCombinedForSupplementaryPayment: agencyProfileId => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupCombinedForSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroup: agencyAdjustmentGroupId => {

			const url = libPayroll + 'GetAgencyAdjustmentGroup';
			const data = {
				AgencyAdjustmentGroupID: agencyAdjustmentGroupId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupsForPension: (agencyProfileId, agencyEmployerPensionId) => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupsForPension';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPensionID: agencyEmployerPensionId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentGroupsPackDetail: (agencyProfileId, agencyProfileParentId) => {

			const url = libPayroll + 'GetAgencyAdjustmentGroupsPackDetail';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyProfileParentID: agencyProfileParentId
			};

			return promise.getPromise(url, data);
		},
		getAgencyAdjustmentLabels: (agencyProfileId) => {

			const url = libPayroll + 'GetAgencyAdjustmentLabels';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyEmployerPensionPeriodAlignment: (agencyProfileId, agencyEmployerPayPeriodId) => {

			const url = libAgency + 'GetAgencyEmployerPensionPeriodAlignment';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPayPeriodID: agencyEmployerPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		getAgencyHasInProgressSupplementaryPayment: (agencyProfileId) => {

			const url = libPayroll + 'GetAgencyHasInProgressSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyPayment: agencyPaymentId => {

			const url = libPayroll + 'GetAgencyPayment';
			const data = {
				AgencyPaymentID: agencyPaymentId
			};

			return promise.getPromise(url, data);
		},
		getAgencyPaymentAdjustmentDetailList: (agencyProfileId, userId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetAgencyPaymentAdjustmentDetailList';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId, // Optional
				AgencyProfileID: agencyProfileId,
				UserID: userId // Optional
			};

			return promise.getPromise(url, data);
		},
		getAgencyPaymentEmpty: () => {

			const url = libPayroll + 'GetAgencyPaymentEmpty';

			return promise.getPromise(url);
		},
		getAgencyPaymentsHistorical: agencyProfileId => {

			const url = libPayroll + 'GetAgencyPaymentsHistorical';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAgencyPayPeriodState: (agencyPayPeriodId, agencyPayPeriodStateType) => {

			const url = libAgency + 'GetAgencyPayPeriodState';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyPayPeriodStateType: agencyPayPeriodStateType
			};

			return promise.getPromise(url, data);
		},
		getBillingPayments: agencyProfileId => {

			const url = libPayroll + 'GetBillingPayments';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getCanRunPayroll: agencyProfileId => {

			const url = libAgency + 'AssessCanRunPayroll';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getCarBenefit: (agencyProfileId, carBenefitId) => {

			const url = libPayroll + 'GetCarBenefit';
			const data = {
				AgencyProfileID: agencyProfileId,
				CarBenefitID: carBenefitId
			};

			return promise.getPromise(url, data);
		},
		getEmptyCarBenefit: (agencyProfileId) => {

			const url = libPayroll + 'GetEmptyCarBenefit';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getEmptyHealthBenefit: () => {

			const url = libPayroll + 'GetEmptyHealthBenefit';

			return promise.getPromise(url);
		},
		getEmptyEndOfYearUpdateNIDetail: () => {

			const url = libPayroll + 'GetEmptyEndOfYearUpdateNIDetail';

			return promise.getPromise(url);
		},
		getEmptySalaryPolicy: () => {

			const url = libPayroll + 'GetEmptySalaryPolicy';

			return promise.getPromise(url);
		},
		getEmptySupplementaryPayment: () => {

			const url = libPayroll + 'GetEmptySupplementaryPayment';

			return promise.getPromise(url);
		},
		getEmptyTeamMemberSalaryMinimum: () => {

			const url = libPayroll + 'GetEmptyTeamMemberSalaryMinimum';

			return promise.getPromise(url);
		},
		getEmptyTeamMemberSalaryPolicyPost: () => {

			const url = libPayroll + 'GetEmptyTeamMemberSalaryPolicyPost';

			return promise.getPromise(url);
		},
		getEmptyUserPayElementDetail: agencyProfileId => {

			const url = libPayroll + 'GetEmptyUserPayElementDetail';

			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getEndOfYearUpdateForTaxYear: (agencyProfileId, agencyPayPeriodID, endOfYearUpdateType, userIdList) => {

			const url = libPayroll + 'GetEndOfYearUpdateForTaxYear';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodID,
				EndOfYearUpdateType: endOfYearUpdateType,
				UserIDList: userIdList
			};

			return promise.getPromise(url, data);
		},
		getEndOfYearUpdateState: (agencyProfileId, endOfYearUpdateId) => {

			const url = libPayroll + 'GetEndOfYearUpdateState';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				EndOfYearUpdateID: endOfYearUpdateId
			};

			return promise.getPromise(url, dataObj);
		},
		getFTEEquivalentDetails: (userId, agencyProfileId, salaryValue, contractedHours, contractedWeeks, policyId, policyHours, policyWeeks) => {

			// Default policyId to empty Guid
			if (angular.isUndefined(policyId)) {
				policyId = config.guidEmpty;
			}

			const url = libPayroll + 'GetFTEEquivalentDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryValue: salaryValue,
				ContractedHours: contractedHours,
				ContractedWeeks: contractedWeeks,
				PolicyID: policyId,
				PolicyHours: policyHours,
				PolicyWeeks: policyWeeks
			};

			return promise.getPromise(url, data);
		},
		getEmptyUserPayElementDetailForLink: () => {

			const url = libPayroll + 'GetEmptyUserPayElementDetailForLink';

			return promise.getPromise(url);
		},
		getGrossForNetAdjustment: (agencyProfileId, agencyPayPeriodId, userId, net) => {

			const url = libPayroll + 'GetGrossForNetAdjustment';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId,
				Net: net
			};

			return promise.getPromise(url, data);
		},
		getHealthBenefit: (agencyProfileId, healthBenefitId) => {

			const url = libPayroll + 'GetHealthBenefit';
			const data = {
				AgencyProfileID: agencyProfileId,
				HealthBenefitID: healthBenefitId
			};

			return promise.getPromise(url, data);
		},
		getManualEPSForPeriod: agencyPayPeriodId => {

			const url = libPayroll + 'GetManualEPSForPeriod';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getP11DbSubmissionFinaliseState: (agencyProfileId, p11DbSubmissionID) => {

			const url = libPayroll + 'GetP11DbSubmissionFinaliseState';
			const data = {
				AgencyProfileID: agencyProfileId,
				P11DbSubmissionID: p11DbSubmissionID
			};

			return promise.getPromise(url, data);
		},
		getP11DbSubmissionForAgencyPayPeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetP11DbSubmissionForAgencyPayPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getP11DbSubmissionValidationWarnings: (agencyProfileId, agencyPayPeriodId, p11dbSubmissionId) => {

			const url = libPayroll + 'GetP11DbSubmissionValidationError';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				P11DbSubmissionID: p11dbSubmissionId
			};

			return promise.getPromise(url, data);
		},
		getPaymentScheduleGroup: (agencyProfileId, paymentScheduleGroupId, userId) => {

			const url = libPayroll + 'GetPaymentScheduleGroup';
			const data = {
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: paymentScheduleGroupId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getCompanyDirectDebitMandate: agencyProfileId => {

			const url = libAgency + 'GetCompanyDirectDebitMandate';
			const config = {
				logOnEmptyResponse: false
			};
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data, config);
		},
		getEmptyCompanyDirectDebitMandate: agencyProfileId => {

			const url = libAgency + 'GetEmptyCompanyDirectDebitMandate';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getEmptyP11DbSubmission: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetEmptyP11DbSubmission';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getEmptyLinkElement: () => {

			const url = libPayroll + 'GetEmptyLinkElement';

			return promise.getPromise(url);
		},
		getFPSLateReasons: () => {

			const url = libAgency + 'GetFpsLateReasons';

			return promise.getPromise(url);
		},
		getHistoricalTaxPeriods: agencyProfileId => {

			const url = libPayroll + 'GetHistoricalTaxPeriods';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getLinkElements: agencyProfileId => {

			const url = libPayroll + 'GetLinkElements';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getManualEPSSubmissionState: manualEpsId => {

			const url = libPayroll + 'GetManualEPSSubmissionState';
			const data = {
				ManualEPSID: manualEpsId
			};

			return promise.getPromise(url, data);
		},
		getPaymentScheduleTypes: (agencyProfileId, category) => {

			const url = libPayroll + 'GetPaymentScheduleTypes';
			const data = {
				AgencyProfileID: agencyProfileId,
				Category: category
			};

			return promise.getPromise(url, data);
		},
		getNextBillingPayment: agencyProfileId => {

			const url = libPayroll + 'GetNextBillingPayment';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getNotesForPayPeriod: (agencyProfileId, payPeriodId) => {

			const url = libMessage + 'GetNotesForPayPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayPeriodID: payPeriodId
			};

			const config = {
				useTestData: true
			};

			return promise.getPromise(url, data, config);
		},
		getP11DbSubmission: (p11DbSubmissionID, agencyProfileID) => {

			const url = libPayroll + 'GetP11DbSubmission';
			const dataObj = {
				P11DbSubmissionID: p11DbSubmissionID,
				AgencyProfileID: agencyProfileID
			};

			return promise.getPromise(url, dataObj);
		},
		getP11DbSubmissions: (agencyProfileId) => {

			const url = libPayroll + 'GetP11DbSubmissionsForAgency';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getPayPeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = libAgency + 'GetPayPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodForPeriodCount: (agencyProfileId, periodCount) => {

			const url = libAgency + 'GetPayPeriodForPeriodCount';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				PeriodCount: periodCount
			};

			return promise.getPromise(url, dataObj);
		},
		getPayPeriodSpecific: agencyPayPeriodId => {

			const url = libAgency + 'GetPayPeriodSpecific';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodCISDeductions: (agencyProfileId, agencyPayPeriodId) => {

			const url = libAgency + 'GetPayPeriodCISDeductions';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		getPayPeriodCurrent: (agencyProfileId, allDetails) => {

			const url = libAgency + 'GetPayPeriodCurrent';
			const data = {
				AgencyProfileID: agencyProfileId,
				AllDetails: allDetails
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodMinimum: (agencyProfileId, previousPeriod) => {

			const url = libAgency + 'GetPayPeriodMinimum';
			const data = {
				AgencyProfileID: agencyProfileId,
				PreviousPeriod: previousPeriod !== undefined ? previousPeriod : false
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodPrevious: agencyProfileId => {

			const url = libAgency + 'GetPayPeriodPrevious';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getPayPeriods: (agencyProfileId, payrollState) => {

			const url = libAgency + 'GetPayPeriods';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayrollState: payrollState
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodsForPayslipManager: agencyProfileId => {

			const url = libAgency + 'GetPayPeriodsForPayslipManager';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getPayPeriodsHistory: agencyProfileId => {

			const url = libAgency + 'GetPayPeriodsHistory';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getPayPeriodsMinimum: (agencyProfileId, startDateIso, isPayPeriodComplete, getPeriodsForTaxYear) => {

			const url = libAgency + 'GetPayPeriodsMinimum';
			const data = {
				AgencyProfileID: agencyProfileId,
				StartDateISO: startDateIso,
				IsPayPeriodComplete: isPayPeriodComplete,
				GetPeriodsForTaxYear: getPeriodsForTaxYear
			};

			return promise.getPromise(url, data);
		},
		getSalaryFutureChanges: (agencyProfileId, userId) => {

			const url = libPayroll + 'GetSalaryFutureChanges';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: angular.isDefined(userId) ? userId : config.guidEmpty,
			};

			return promise.getPromise(url, dataObj);
		},
		getSalaryFutureChangesForPolicy: (agencyProfileId, policyId) => {

			const url = libPayroll + 'GetSalaryFutureChangesForPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				PolicyID: policyId
			};

			return promise.getPromise(url, data);
		},
		getSalaryPolicyBackpayDisplay: (agencyProfileId, userId, amount, salaryPolicyId, effectiveDateIso, proRatingType) => {

			const url = libPayroll + 'GetSalaryPolicyBackpayDisplay';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				Amount: amount,
				CurrentSalaryPolicyID: salaryPolicyId,
				EffectiveDateISO: effectiveDateIso,
				ProRatingType: proRatingType
			};

			return promise.getPromise(url, data);
		},

		getSalaryPolicyPostReferenceUnique: (agencyProfileId, userId, salaryPolicyPostReference) => {

			const url = libPayroll + 'GetSalaryPolicyPostReferenceUnique';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				SalaryPolicyPostReference: salaryPolicyPostReference,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		getSupplementaryPaymentAgencyPaymentAdjustmentDetailList: (agencyProfileId, supplementaryPaymentId) => {

			const url = libPayroll + 'GetSupplementaryPaymentAgencyPaymentAdjustmentDetailList';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		getSupplementaryPayment: (agencyProfileId, supplementaryPaymentId) => {

			const url = libPayroll + 'GetSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		getSupplementaryPaymentDisbursements: (agencyProfileId, supplementaryPaymentId) => {

			if (angular.isUndefined(supplementaryPaymentId)) {
				return $q.resolve([]);
			}

			const url = libPayroll + 'GetSupplementaryPaymentDisbursements';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		getSupplementaryPaymentState: (agencyProfileId, supplementaryPaymentId) => {

			const url = libPayroll + 'GetSupplementaryPaymentState';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		getSupplementaryPaymentsForAgency: agencyProfileId => {

			const url = libPayroll + 'GetSupplementaryPaymentsForAgency';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getSupplementaryPaymentsForAgencyPayPeriod: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetSupplementaryPaymentsForAgencyPayPeriod';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTasksForPayPeriod: (agencyProfileId, payPeriodId) => {

			const url = libMessage + 'GetTasksForPayPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayPeriodID: payPeriodId
			};

			const config = {
				useTestData: true
			};

			return promise.getPromise(url, data, config);
		},
		getTaxYearsForEndOfYearUpdate: (agencyProfileId, endOfYearUpdateType) => {

			const url = libPayroll + 'GetTaxYearsForEndOfYearUpdate';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				EndOfYearUpdateType: endOfYearUpdateType
			};

			return promise.getPromise(url, dataObj);
		},
		getTaxYearsForP11DbSubmission: agencyProfileId => {
			const url = libPayroll + 'GetTaxYearsForP11DbSubmission';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberBackdatedNI: (userId, agencyProfileId, niCode, effectiveDateIso) => {

			const url = libPayroll + 'GetTeamMemberBackdatedNI';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				NICode: niCode,
				EffectiveDateISO: effectiveDateIso
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberBackdatedNIForAdjustment: (userId, agencyProfileId, adjustmentId) => {

			const url = libPayroll + 'GetTeamMemberBackdatedNIForAdjustment';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AdjustmentID: adjustmentId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberBackdatedSalary: (userId, agencyProfileId, salaryYearly, effectiveDateISO, calculationMethod, proRatingType, backdateSalaryDerivedPayElements, isPaidByPolicy, salaryPolicyPostId) => {

			const url = libPayroll + 'GetTeamMemberBackdatedSalary';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryYearly: salaryYearly,
				EffectiveDateISO: effectiveDateISO,
				CalculationMethod: calculationMethod,
				ProRatingType: proRatingType,
				BackdateSalaryDerivedPayElements: backdateSalaryDerivedPayElements,
				IsPaidByPolicy: isPaidByPolicy,
				SalaryPolicyPostID: salaryPolicyPostId
			};

			return promise.getPromise(url, data);
		},
		getPrimaryPolicyBackpayDisplay: (userId, agencyProfileId, amount, salaryPolicyId, effectiveDateISO, backdateSalaryDerivedPayElements) => {

			const url = libPayroll + 'GetPrimaryPolicyBackpayDisplay';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				Amount: amount,
				SalaryPolicyID: salaryPolicyId,
				EffectiveDateISO: effectiveDateISO,
				BackdateSalaryDerivedPayElements: backdateSalaryDerivedPayElements
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberBackdatedSalaryForAdjustment: (userId, agencyProfileId, adjustmentId) => {

			const url = libPayroll + 'GetTeamMemberBackdatedSalaryForAdjustment';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AdjustmentID: adjustmentId
			};

			return promise.getPromise(url, data);
		},
		removeBackdatedSalary: (userId, agencyProfileId, userPayElementId) => {

			const url = libPayroll + 'RemoveBackdatedSalary';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UserPayElementID: userPayElementId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberBackdatedSalaryNewStarter: (userId, agencyProfileId, salaryYearly, startDateIso, calculationMethod, proRatingType) => {

			const url = libPayroll + 'GetTeamMemberBackdatedSalaryNewStarter';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryYearly: salaryYearly,
				StartDateISO: startDateIso,
				CalculationMethod: calculationMethod,
				ProRatingType: proRatingType
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberPayroll: (agencyProfileId, userId, calculateTaxRefund) => {

			const url = libUser + 'GetTeamMemberPayroll';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId !== undefined ? userId : config.guidEmpty,
				CalculateTaxRefund: calculateTaxRefund
			};

			return promise.getPromise(url, data);
		},
		getTeamMembersPaymentHistory: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetTeamMembersPaymentHistory';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getTeamMembersPayroll: agencyProfileId => {

			const url = libUser + 'GetTeamMembersPayroll';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMembersPayrollCached: agencyProfileId => {

			const cacheKey = 'getTeamMembersPayroll_' + agencyProfileId;

			return timedCache.getOrFetch(cacheKey, () => service.getTeamMembersPayroll(agencyProfileId), API_RESPONSE_CACHE_TIME_SECONDS);
		},
		getTeamMemberSalary: (agencyProfileId, userId, includeSalaryEffectiveBeforePeriod) => {

			const url = libPayroll + 'GetTeamMemberSalary';
			const data = {
				AgencyProfileID: agencyProfileId,
				IncludeSalaryEffectiveBeforePeriod: angular.isUndefined(includeSalaryEffectiveBeforePeriod) ? true : includeSalaryEffectiveBeforePeriod,
				UserID: userId,
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSalaryForPeriod: (agencyProfileId, userId) => {

			const url = libPayroll + 'GetTeamMemberSalaryForPeriod';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberSalaryFurloughed: (agencyProfileId, userId) => {

			const url = libPayroll + 'GetTeamMemberSalaryFurloughed';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberSalariesForPeriod: (agencyProfileId, agencyPayPeriodId, userId) => {

			const url = libPayroll + 'GetTeamMemberSalariesForPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSalariesForPostsWithCalculatedRates: (agencyProfileId, agencyPayPeriodId, userId) => {

			const url = libPayroll + 'GetTeamMemberSalariesForPostsWithCalculatedRates';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSalariesHourlyPaid: (agencyProfileId, userId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetTeamMemberSalariesHourlyPaid';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMembersWithNICodeUpdates: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetTeamMembersWithNICodeUpdates';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		getReversedHmrcTaxUpdates: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetReversedHmrcTaxUpdates';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberTaxListForState: (agencyProfileId, state) => {

			const url = libPayroll + 'GetTeamMemberTaxListForState';
			const data = {
				AgencyProfileID: agencyProfileId,
				State: state
			};

			return promise.getPromise(url, data);
		},

		getUserPayElementDetail: (agencyProfileId, userPayElementId) => {

			const url = libPayroll + 'GetUserPayElementDetail';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserPayElementID: userPayElementId
			};

			return promise.getPromise(url, dataObj);
		},

		getUserPayElements: (agencyProfileId, agencyPayPeriodId, userId, futureAdjustments, userImportGroupId, linkElements) => {

			const url = libPayroll + 'GetUserPayElements';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				FutureAdjustments: futureAdjustments,
				LinkElements: linkElements,
				UserID: userId,
				UserImportGroupID: userImportGroupId
			};

			return promise.getPromise(url, data);
		},

		getUserPaymentsForDateRange: (userId, agencyProfileId, dateFrom, dateTo) => {

			const url = libPayroll + 'GetUserPaymentsForDateRange';
			const data = {
				AgencyProfileID: agencyProfileId,
				DateFrom: dateFrom,
				DateTo: dateTo,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getUserPayPeriodDetails: (agencyProfileId, agencyPayPeriodId, userId) => {

			const url = libPayroll + 'GetUserPayPeriodDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTaxInfoForPeriod: (userId, agencyProfileId, agencyPayPeriodId) => {

			const url = libPayroll + 'GetTaxInfoForPeriod';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		calculatePayPolicyUplift: (agencyProfileId, payPolicyId, percentage) => {

			const url = libAgency + 'CalculatePayPolicyUplift';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayPolicyID: payPolicyId,
				Percentage: percentage
			};

			return promise.getPromise(url, data);
		},
		overridePolicyPay: (agencyProfileId, updatedPolicy) => {

			const url = libPayroll + 'OverridePolicyPay';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedPolicy: updatedPolicy
			};

			return promise.getPromise(url, data);
		},
		overrideSalaryPolicy: (userId, agencyProfileId, annualSalaryPolicy) => {

			const url = libPayroll + 'OverrideSalaryPolicy';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AnnualSalaryPolicy: annualSalaryPolicy
			};

			return promise.getPromise(url, data);
		},
		payrollBulkRun: runDate => {

			const url = libPayrollWorker + 'PayrollBulkRun';
			const data = {
				RunDate: runDate
			};

			return promise.getPromise(url, data);
		},
		payrollDPSImport: agencyProfileId => {

			const url = libPayrollWorker + 'PayrollDPSImport';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		payrollRefreshChangesData: (agencyProfileId, agencyPayPeriodId, options) => {

			const url = libPayrollWorker + 'PayrollRefreshChangesData';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			// The options are designed to trigger specific refresh elements
			if (options) {
				data.Options = options;
			}

			return promise.getPromise(url, data);
		},
		payrollRunEasyEnrol: (agencyProfileId, agencyPayPeriodId, lateReason) => {

			const url = libPayrollWorker + 'PayrollRunEasyEnrol';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				LateReason: lateReason
			};

			return promise.getPromise(url, dataObj);
		},
		payrollRunEasyEnrolBulk: (userId, companiesAndPeriods) => {

			const url = libPayrollWorker + 'PayrollRunEasyEnrolBulk';
			const dataObj = {
				UserId: userId,
				CompaniesAndPeriods: companiesAndPeriods
			};

			return promise.getPromise(url, dataObj);
		},
		payrollSubmitEPS: (agencyProfileId, agencyPayPeriodId) => {

			const url = libPayrollWorker + 'PayrollSubmitEPS';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		payrollSubmitP11Db: (agencyProfileId, p11DbSubmissionID) => {

			const url = libPayrollWorker + 'PayrollSubmitP11Db';
			const data = {
				AgencyProfileID: agencyProfileId,
				P11DbSubmissionID: p11DbSubmissionID
			};

			return promise.getPromise(url, data);
		},
		payrollVerifySubcontractors: (agencyProfileId, agencyPayPeriodId, specificUserId) => {

			const url = libPayrollWorker + 'PayrollVerifySubcontractors';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SpecificUserID: specificUserId,
				VerifyAll: false // Ready to implement bulk verification later on
			};

			return promise.getPromise(url, data);
		},
		recalculatePaymentSchedule: (paymentScheduleGroupId, newPayment, storeResult) => {

			const url = libPayroll + 'RecalculatePaymentSchedule';
			const data = {
				PaymentScheduleGroupID: paymentScheduleGroupId,
				NewPayment: newPayment,
				StoreResult: storeResult
			};

			return promise.getPromise(url, data);
		},
		recalculatePaymentScheduleAllPeriods: (scheduleGroup, pauseCount, storeResult) => {

			const url = libPayroll + 'RecalculatePaymentScheduleAllPeriods';
			const data = {
				ScheduleGroup: scheduleGroup,
				PauseCount: pauseCount,
				StoreResult: storeResult
			};

			return promise.getPromise(url, data);
		},
		submitFeedbackForCurrentPeriod: (agencyProfileId, agencyPayPeriodID) => {

			const url = libAgency + 'SubmitFeedbackForCurrentPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodID
			};

			return promise.getPromise(url, data);
		},
		updateAgencyAdjustmentGroup: updatedAgencyAdjustmentGroup => {

			const url = libPayroll + 'UpdateAgencyAdjustmentGroup';
			const data = {
				UpdatedAgencyAdjustmentGroup: updatedAgencyAdjustmentGroup
			};

			return promise.getPromise(url, data);
		},
		updateAgencyAdjustmentGroupEntry: (updatedAgencyAdjustmentGroupEntry, coreElement) => {

			const url = libPayroll + 'UpdateAgencyAdjustmentGroupEntry';
			const data = {
				CoreElement: coreElement,
				UpdatedAgencyAdjustmentGroupEntry: updatedAgencyAdjustmentGroupEntry
			};

			return promise.getPromise(url, data);
		},

		updateAgencyAdjustmentGroupEntryForDisbursements: (updatedAgencyAdjustmentGroupEntry) => {

			const url = libPayroll + 'UpdateAgencyAdjustmentGroupEntryForDisbursements';
			const data = {
				UpdatedAgencyAdjustmentGroupEntry: updatedAgencyAdjustmentGroupEntry
			};

			return promise.getPromise(url, data);
		},
		updateAgencyAdjustmentGroupEntryPension: (agencyProfileId, agencyEmployerPensionGroupId, updatedAgencyAdjustmentGroupEntry) => {

			const url = libPayroll + 'UpdateAgencyAdjustmentGroupEntryPension';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPensionGroupID: agencyEmployerPensionGroupId,
				UpdatedAgencyAdjustmentGroupEntry: updatedAgencyAdjustmentGroupEntry
			};

			return promise.getPromise(url, data);
		},
		updateAgencyAdjustmentGroupEntryVisible: elements => {

			const url = libPayroll + 'UpdateAgencyAdjustmentGroupEntryVisible';
			const data = {
				Elements: elements
			};

			return promise.getPromise(url, data);
		},
		updateAgencyAdjustmentLabel: updatedAgencyAdjustmentLabel => {

			const url = libPayroll + 'UpdateAgencyAdjustmentLabel';
			const data = {
				UpdatedAgencyAdjustmentLabel: updatedAgencyAdjustmentLabel
			};

			return promise.getPromise(url, data);
		},
		updateAgencyPaymentHistorical: (agencyProfileId, agencyPayment) => {

			const url = libPayroll + 'UpdateAgencyPaymentHistorical';
			const data = {
				AgencyProfileID: agencyProfileId,
				Payment: agencyPayment
			};

			return promise.getPromise(url, data);
		},
		updateAgencyPayPeriodCISDeductions: (agencyProfileId, agencyPayPeriodId, cisDeductions) => {

			const url = libAgency + 'UpdateAgencyPayPeriodCISDeductions';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				CISDeductions: cisDeductions
			};

			return promise.getPromise(url, data);
		},
		updateAgencyPayPeriodPensionDates: (agencyProfileId, agencyPayPeriodId, pensionStartDate, pensionEndDate) => {

			const url = libAgency + 'UpdateAgencyPayPeriodPensionDates';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				PensionStartDateISO: pensionStartDate,
				PensionEndDateISO: pensionEndDate
			};

			return promise.getPromise(url, data);
		},
		updateAgencyPayPeriodPayslipDate: (agencyPayPeriodId, payslipDate, payDate, bacsDate) => {

			const url = libAgency + 'UpdateAgencyPayPeriodPayslipDate';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				PayslipDate: payslipDate,
				PayDate: payDate,
				BACSDate: bacsDate
			};

			return promise.getPromise(url, data);
		},
		updatePensionPeriodAlignmentDetails: (agencyProfileId, agencyEmployerPayPeriodId, updatedPensionPeriodAlignmentDetails) => {

			const url = libAgency + 'UpdatePensionPeriodAlignmentDetails';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyEmployerPayPeriodID: agencyEmployerPayPeriodId,
				UpdatedPensionPeriodAlignmentDetails: updatedPensionPeriodAlignmentDetails
			};

			return promise.getPromise(url, dataObj);
		},
		updateCarBenefit: (agencyProfileId, updatedCarBenefit) => {

			const url = libPayroll + 'UpdateCarBenefit';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedCarBenefit: updatedCarBenefit
			};

			return promise.getPromise(url, data);
		},
		updateCarBenefitTotals: (agencyProfileId, updatedCarBenefit) => {

			const url = libPayroll + 'UpdateCarBenefitTotals';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedCarBenefit: updatedCarBenefit
			};

			return promise.getPromise(url, data);
		},
		updateCompanyDirectDebitMandateBank: (agencyProfileId, updatedBankDetails) => {

			const url = libAgency + 'UpdateCompanyDirectDebitMandateBank';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedBankDetails: updatedBankDetails
			};

			return promise.getPromise(url, data);
		},
		updateCompanyGoCardlessDetails: (agencyProfileId, updatedDirectDebitMandate) => {

			const url = libAgency + 'UpdateCompanyGoCardlessDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedDirectDebitMandate: updatedDirectDebitMandate
			};

			return promise.getPromise(url, data);
		},
		updateCompanyNMWCalculationMethod: (agencyProfileId, nmwCalculationMethod) => {

			const url = libPayroll + 'UpdateCompanyNMWCalculationMethod';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				NMWCalculationMethod: nmwCalculationMethod
			};

			return promise.getPromise(url, dataObj);
		},
		updateCompanyMonthlyDisplayFormat: (agencyProfileId, displayFormat) => {

			const url = libAgency + 'UpdateCompanyMonthlyDisplayFormat';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				DisplayFormat: displayFormat
			};

			return promise.getPromise(url, dataObj);
		},
		updateCompanyWorkplacePatterns: (agencyProfileId, workHoursPerWeek, dayRateCalculationMethod, maximumWorkingDaysInMonth, calculatePatternOnYearlyBasis, workWeeksPerYear) => {

			const url = libPayroll + 'UpdateCompanyWorkplacePatterns';
			const data = {
				AgencyProfileID: agencyProfileId,
				WorkHoursPerWeek: workHoursPerWeek,
				DayRateCalculationMethod: dayRateCalculationMethod,
				MaximumWorkingDaysInMonth: maximumWorkingDaysInMonth,
				CalculatePatternOnYearlyBasis: calculatePatternOnYearlyBasis,
				WorkWeeksPerYear: workWeeksPerYear
			};

			return promise.getPromise(url, data);
		},
		updateGoCardlessDetailsBillingName: (agencyProfileId, billingName) => {

			const url = libAgency + 'UpdateGoCardlessDetailsBillingName';
			const data = {
				AgencyProfileID: agencyProfileId,
				BillingName: billingName
			};

			return promise.getPromise(url, data);
		},
		updateHealthBenefit: (agencyProfileId, updatedHealthBenefit) => {

			const url = libPayroll + 'UpdateHealthBenefit';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedHealthBenefit: updatedHealthBenefit
			};

			return promise.getPromise(url, data);
		},
		updateHealthBenefitTotals: (agencyProfileId, updatedHealthBenefit) => {

			const url = libPayroll + 'UpdateHealthBenefitTotals';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedHealthBenefit: updatedHealthBenefit
			};

			return promise.getPromise(url, data);
		},
		updateIsBillingEnabled: (agencyProfileId, isBillingEnabled) => {

			const url = libAgency + 'UpdateIsBillingEnabled';
			const data = {
				AgencyProfileID: agencyProfileId,
				IsBillingEnabled: isBillingEnabled
			};

			return promise.getPromise(url, data);
		},
		updateLinkElement: (linkElementGroupId, updatedLinkElement) => {

			const url = libPayroll + 'UpdateLinkElement';
			const data = {
				LinkElementGroupID: linkElementGroupId,
				UpdatedLinkElement: updatedLinkElement
			};

			return promise.getPromise(url, data);
		},
		updateManualEPS: manualEps => {

			const url = libPayroll + 'UpdateManualEPS';
			const data = {
				ManualEPS: manualEps
			};

			return promise.getPromise(url, data);
		},
		updateP11DbSubmission: (p11dSubmission, agencyProfileId) => {
			const url = libPayroll + 'UpdateP11DbSubmission';
			const data = {
				P11DbSubmission: p11dSubmission,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updatePaymentScheduleGroup: scheduleGroup => {

			const url = libPayroll + 'UpdatePaymentScheduleGroup';
			const data = {
				ScheduleGroup: scheduleGroup
			};

			return promise.getPromise(url, data);
		},
		updatePaymentScheduleGroupStart: paymentScheduleGroupId => {

			const url = libPayroll + 'UpdatePaymentScheduleGroupStart';
			const data = {
				PaymentScheduleGroupID: paymentScheduleGroupId
			};

			return promise.getPromise(url, data);
		},
		updatePaymentScheduleValue: (paymentScheduleId, value) => {

			const url = libPayroll + 'UpdatePaymentScheduleValue';
			const data = {
				PaymentScheduleID: paymentScheduleId,
				Value: value
			};

			return promise.getPromise(url, data);
		},
		updatePayPolicy: (agencyProfileId, originalPolicyId, updatedPolicy) => {

			const url = libPayroll + 'UpdatePayPolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				OriginalPolicyID: originalPolicyId,
				UpdatedPolicy: updatedPolicy
			};

			return promise.getPromise(url, data);
		},
		updatePolicy: function (agencyProfileId, updatedPolicy, duplicate) {

			duplicate = angular.isUndefined(duplicate) ? false : duplicate;

			const url = libPayroll + 'UpdatePolicy';
			const data = {
				AgencyProfileID: agencyProfileId,
				UpdatedPolicy: updatedPolicy,
				Duplicate: duplicate
			};
			return promise.getPromise(url, data);
		},
		updateSalaryPolicy: (userId, agencyProfileId, annualSalaryPolicy) => {

			const url = libPayroll + 'UpdateSalaryPolicy';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AnnualSalaryPolicy: annualSalaryPolicy
			};

			return promise.getPromise(url, data);
		},
		updateSalaryPolicyPostLeaveDate: (agencyProfileId, userId, salaryPolicyPostId, leaveDateISO, isLeaving) => {

			const url = libPayroll + 'UpdateSalaryPolicyPostLeaveDate';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				SalaryPolicyPostID: salaryPolicyPostId,
				LeaveDateISO: leaveDateISO,
				IsLeaving: isLeaving
			};

			return promise.getPromise(url, data);
		},
		updateSupplementaryPayment: (agencyProfileId, supplementaryPayment) => {

			const url = libPayroll + 'UpdateSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPayment: supplementaryPayment
			};

			return promise.getPromise(url, data);
		},
		updateSupplementaryPaymentDisbursements: (agencyProfileId, supplementaryPaymentId, supplementaryPaymentDisbursements) => {
			const url = libPayroll + 'UpdateSupplementaryPaymentDisbursements';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId,
				SupplementaryPaymentDisbursements: supplementaryPaymentDisbursements
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSalaryForPeriod: (agencyProfileId, userId, salaryDetails, isSalaryOnlyForPeriod) => {

			const url = libPayroll + 'UpdateTeamMemberSalaryForPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				SalaryDetails: salaryDetails,
				IsSalaryOnlyForPeriod: isSalaryOnlyForPeriod,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSalaryFurloughed: (agencyProfileId, userId, furloughedDetails, partTime) => {

			const url = libPayroll + 'UpdateTeamMemberSalaryFurloughed';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				FurloughedDetails: furloughedDetails,
				PartTime: angular.isDefined(partTime) ? partTime : false
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberSalaryFurloughedBulk: (agencyProfileId, userList, furloughStartDateIso, furloughEndDateIso, topUpAmount) => {

			const url = libPayroll + 'UpdateTeamMemberSalaryFurloughedBulk';
			const dataObj = {
				UserList: userList,
				AgencyProfileID: agencyProfileId,
				FurloughStartDateISO: furloughStartDateIso,
				FurloughEndDateISO: furloughEndDateIso,
				TopUpAmount: topUpAmount
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberSalaryFurloughedCancel: (agencyProfileId, userId) => {

			const url = libPayroll + 'UpdateTeamMemberSalaryFurloughedCancel';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberSalaryFurloughedInProgress: (agencyProfileId, userId, furloughedDetails) => {

			const url = libPayroll + 'UpdateTeamMemberSalaryFurloughedInProgress';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				FurloughedDetails: furloughedDetails
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMembersNICodes: (agencyProfileId, userNiCodeChanges) => {

			const url = libPayroll + 'UpdateTeamMembersNICodes';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserNICodeChanges: userNiCodeChanges
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberTaxListForState: (agencyProfileId, taxList) => {

			const url = libPayroll + 'UpdateTeamMemberTaxListForState';
			const data = {
				AgencyProfileID: agencyProfileId,
				TaxList: taxList
			};

			return promise.getPromise(url, data);
		},
		updateUserPayElements: (agencyProfileId, agencyPayPeriodId, updatedElements) => {

			const url = libPayroll + 'UpdateUserPayElements';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UpdatedElements: updatedElements
			};

			return promise.getPromise(url, data);
		},
		updateUserPayElementsBulk: (agencyProfileId, agencyPayPeriodId, element, workerList) => {

			const url = libPayroll + 'UpdateUserPayElementsBulk';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				Element: element,
				WorkerList: workerList
			};

			return promise.getPromise(url, data);
		},
		updateUserPayElementsForImportGroup: (agencyProfileId, agencyPayPeriodId, updatedElements, userImportGroupId) => {

			const url = libPayroll + 'UpdateUserPayElementsForImportGroup';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UpdatedElements: updatedElements,
				UserImportGroupID: userImportGroupId
			};

			return promise.getPromise(url, data);
		},
		updateUserPayElementsUnitsBulk: updatedElements => {

			const url = libPayroll + 'UpdateUserPayElementsUnitsBulk';
			const data = {
				UpdatedElements: updatedElements
			};

			return promise.getPromise(url, data);
		},
		updateUserPayPeriodDetails: (agencyProfileId, agencyPayPeriodId, periodDetails) => {

			const url = libPayroll + 'UpdateUserPayPeriodDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				PeriodDetails: periodDetails
			};

			return promise.getPromise(url, data);
		},
		updateUserTaxInfoStarterDetails: (userId, agencyProfileId, previousPay, previousTax, leaveDateISO, starterDeclaration) => {

			const url = libPayroll + 'UpdateUserTaxInfoStarterDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PreviousPay: previousPay,
				PreviousTax: previousTax,
				LeaveDateISO: leaveDateISO,
				StarterDeclaration: starterDeclaration
			};

			return promise.getPromise(url, data);
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')

	.service('pensionData', ['libraries', 'promise', function (libraries, promise) {

		const lib = libraries.pension;
		const libAgency = libraries.agency;
		const libImport = libraries.importLib;
		const libPayroll = libraries.payroll;
		const libUser = libraries.user;

		const service = {

			createAgencyEmployerPension: (agencyProfileId, agencyProfileParentId, updatedAgencyEmployerPension, agencyEmployerPensionId) => {

				const url = lib + 'CreateAgencyEmployerPension';
				const dataObj = {
					UpdatedAgencyEmployerPension: updatedAgencyEmployerPension,
					AgencyProfileID: agencyProfileId,
					AgencyProfileParentID: agencyProfileParentId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			deletePensionForAgency: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libPayroll + 'DeletePensionForAgency';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getAgencyEmployerPensionDetails: (agencyProfileId, agencyEmployerPensionId) => {

				const url = lib + 'GetAgencyEmployerPensionDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getAgencyEmployerPensionSummaries: agencyProfileId => {

				const url = libAgency + 'GetAgencyEmployerPensionSummaries';
				const dataObj = {
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getAgencyEmployerPensionSummary: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libAgency + 'GetAgencyEmployerPensionSummary';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getAreNestCredentialsValid: (agencyProfileId, agencyEmployerPensionId, senderId, value) => {

				const url = libImport + 'GetAreNestCredentialsValid';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					SenderID: senderId,
					Value: value
				};

				return promise.getPromise(url, dataObj);
			},

			getEmptyPensionSetup: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libAgency + 'GetEmptyPensionSetup';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionDashboardData: agencyProfileId => {

				const url = libAgency + 'GetPensionDashboardData';
				const dataObj = {
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionDetailsForAgency: agencyProfileId => {

				const url = libAgency + 'GetPensionDetailsForAgency';
				const dataObj = {
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionForAgency: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libAgency + 'GetPensionForAgency';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionGroupsForAgency: (agencyProfileId, agencyEmployerPensionId, userId) => {

				const url = lib + 'GetPensionGroupsForAgency';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UserID: userId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionPostponementForPension: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libAgency + 'GetPensionPostponementForPension';
				const dataObj = {
					AgencyEmployerPensionID: agencyEmployerPensionId,
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionProviderDetails: agencyProfileId => {

				const url = lib + 'GetPensionProviderDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionsForAgency: agencyProfileId => {

				const url = libAgency + 'GetPensionsForAgency';
				const dataObj = {
					AgencyProfileID: agencyProfileId
				};

				return promise.getPromise(url, dataObj);
			},

			getPensionsForTeamMember: (userId, agencyProfileId, includeInactive) => {

				const url = libUser + 'GetPensionsForTeamMember';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					IncludeInactive: includeInactive,
					UserID: userId
				};

				return promise.getPromise(url, dataObj);
			},

			getPeoplesPensionAuthoriseURI: (agencyProfileId, agencyEmployerPensionId, employerReference) => {

				const url = libImport + 'GetPeoplesPensionAuthoriseURI';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					EmployerReference: employerReference
				};

				return promise.getPromise(url, dataObj);
			},

			getSmartPensionAuthoriseURI: (agencyProfileId, agencyEmployerPensionId, role) => {

				const url = libImport + 'GetSmartPensionAuthoriseURI';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					Role: role
				};

				return promise.getPromise(url, dataObj);
			},

			getTeamMemberPension: (agencyProfileId, agencyEmployerPensionId, userId, salaryPolicyPostId) => {

				const url = lib + 'GetTeamMemberPension';
				const dataObj = {
					AgencyEmployerPensionID: agencyEmployerPensionId,
					AgencyProfileID: agencyProfileId,
					UserID: userId,
					SalaryPolicyPostID: salaryPolicyPostId
				};

				return promise.getPromise(url, dataObj);
			},

			getTeamMemberPensionWithFte: (agencyProfileId, agencyEmployerPensionId, userId, salaryPolicyPostId) => {

				const url = libPayroll + 'GetTeamMemberPensionWithFte';
				const dataObj = {
					AgencyEmployerPensionID: agencyEmployerPensionId,
					AgencyProfileID: agencyProfileId,
					UserID: userId,
					SalaryPolicyPostID: salaryPolicyPostId
				};

				return promise.getPromise(url, dataObj);
			},

			getTeamMemberPensionPaymentHistory: (agencyProfileId, userId) => {

				const url = libPayroll + 'GetTeamMemberPensionPaymentHistory';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					UserID: userId
				};

				return promise.getPromise(url, dataObj);
			},

			getTeamMembersNotInPension: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libUser + 'GetTeamMembersNotInPension';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getUserAgencyProfilesForWorkplacePension: (agencyProfileId, agencyEmployerPensionId) => {

				const url = libUser + 'GetUserAgencyProfilesForWorkplacePension';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			getUserAgencyProfileForWorkplacePension: (agencyProfileId, agencyEmployerPensionId, userId) => {

				const url = libUser + 'GetUserAgencyProfileForWorkplacePension';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UserID: userId
				};

				return promise.getPromise(url, dataObj);
			},

			getValidPostponementSettingsLength: payPeriodType => {

				const url = libAgency + 'GetValidPostponementSettingsLength';
				const dataObj = {
					PayPeriodType: payPeriodType
				};

				return promise.getPromise(url, dataObj);
			},

			isValidNestEmployerReference: employerReference => {

				const url = libAgency + 'IsValidNestEmployerReference';
				const dataObj = {
					EmployerReference: employerReference
				};

				return promise.getPromise(url, dataObj);
			},

			isValidPensionDates: (agencyProfileId, agencyPayPeriodId, payPeriodType, pensionStartDate, pensionEndDate) => {

				const url = libAgency + 'IsValidPensionDates';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyPayPeriodID: agencyPayPeriodId,
					PayPeriodType: payPeriodType,
					PensionStartDateISO: pensionStartDate,
					PensionEndDateISO: pensionEndDate,
				};

				return promise.getPromise(url, dataObj);
			},

			isValidReenrolmentDate: (agencyProfileId, stagingDateIso, reenrolmentDateISO, reenrolmentCompletionDateISO, payPeriodDateISO, payPeriodType) => {

				const url = libAgency + 'IsValidReenrolmentDate';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					PayPeriodDateISO: payPeriodDateISO,
					PayPeriodType: payPeriodType,
					ReenrolmentCompletionDateISO: reenrolmentCompletionDateISO,
					ReenrolmentDateISO: reenrolmentDateISO,
					StagingDateISO: stagingDateIso
				};

				return promise.getPromise(url, dataObj);
			},

			updateAgencyPayPeriodPensionDateOffset: (agencyProfileId, hasPensionDateOffset, isBeforePeriodDate, pensionDateOffset) => {

				const url = libAgency + 'UpdateAgencyPayPeriodPensionDateOffset';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					HasPensionDateOffset: hasPensionDateOffset,
					IsBeforePeriodDate: isBeforePeriodDate,
					PensionDateOffset: pensionDateOffset,
				};

				return promise.getPromise(url, dataObj);
			},

			isValidReenrolmentDatePreview: (stagingDateIso, reenrolmentDateISO, reenrolmentCompletionDateISO, payPeriodDateISO, payPeriodType) => {

				const url = libAgency + 'IsValidReenrolmentDatePreview';
				const dataObj = {
					PayPeriodDateISO: payPeriodDateISO,
					PayPeriodType: payPeriodType,
					ReenrolmentCompletionDateISO: reenrolmentCompletionDateISO,
					ReenrolmentDateISO: reenrolmentDateISO,
					StagingDateISO: stagingDateIso
				};
	
				return promise.getPromise(url, dataObj);
			},

			updatePensionAutomationDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionAutomationDetails) => {

				const url = lib + 'UpdatePensionAutomationDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionAutomationDetails: updatedPensionAutomationDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionGroupDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionGroupDetails) => {

				const url = lib + 'UpdatePensionGroupDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionGroupDetails: updatedPensionGroupDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionManualSubmission: (agencyProfileId, agencyEmployerPensionId) => {

				const url = lib + 'UpdatePensionManualSubmission';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionFailedSubmission: (agencyProfileId, agencyEmployerPensionId) => {

				const url = lib + 'UpdatePensionFailedSubmission';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionPostponementDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionPostponementDetails) => {

				const url = libPayroll + 'UpdatePensionPostponementDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionPostponementDetails: updatedPensionPostponementDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionProviderDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionProviderDetails) => {

				const url = lib + 'UpdatePensionProviderDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionProviderDetails: updatedPensionProviderDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionSettingDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionSettingDetails) => {

				const url = lib + 'UpdatePensionSettingDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionSettingDetails: updatedPensionSettingDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePensionStagingDetails: (agencyProfileId, agencyEmployerPensionId, updatedPensionStagingDetails) => {

				const url = lib + 'UpdatePensionStagingDetails';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					UpdatedPensionStagingDetails: updatedPensionStagingDetails
				};

				return promise.getPromise(url, dataObj);
			},

			updatePeoplesPensionAccessToken: (agencyProfileId, accessToken, agencyEmployerPensionId) => {

				const url = libImport + 'UpdatePeoplesPensionAccessToken';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AccessToken: accessToken,
					AgencyEmployerPensionID: agencyEmployerPensionId,
				};
				const svcConfigObj = {
					errorOnEmptyResponse: false,
					logOnEmptyResponse: false
				};

				return promise.getPromise(url, dataObj, svcConfigObj);
			},

			updateSmartPensionAccessToken: (agencyProfileId, accessToken, agencyEmployerPensionId) => {

				const url = libImport + 'UpdateSmartPensionAccessToken';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					AccessToken: accessToken,
					AgencyEmployerPensionID: agencyEmployerPensionId,
				};
				const svcConfigObj = {
					errorOnEmptyResponse: false,
					logOnEmptyResponse: false
				};

				return promise.getPromise(url, dataObj, svcConfigObj);
			},

			updateTeamMemberInPension: (agencyProfileId, agencyEmployerPensionId, userId, isInPension, salaryPolicyPostId) => {

				const url = libUser + 'UpdateTeamMemberInPension';
				const dataObj = {
					AgencyEmployerPensionID: agencyEmployerPensionId,
					AgencyProfileID: agencyProfileId,
					IsInPension: isInPension,
					UserID: userId,
					SalaryPolicyPostID: salaryPolicyPostId
				};

				return promise.getPromise(url, dataObj);
			},

			updateTeamMemberPension: (teamMemberPension, userId, agencyProfileId) => {

				const url = libUser + 'UpdateTeamMemberPension';
				const dataObj = {
					UserID: userId,
					AgencyProfileID: agencyProfileId,
					UpdatedTeamMemberPension: teamMemberPension
				};

				return promise.getPromise(url, dataObj);
			},

			updateTeamMemberPensionArchived: (agencyProfileId, agencyEmployerPensionId, userId, isArchived, salaryPolicyPostId) => {

				const url = libUser + 'UpdateTeamMemberPensionArchived';
				const dataObj = {
					AgencyEmployerPensionID: agencyEmployerPensionId,
					AgencyProfileID: agencyProfileId,
					IsArchived: isArchived,
					UserID: userId,
					SalaryPolicyPostID: salaryPolicyPostId
				};

				return promise.getPromise(url, dataObj);
			},

			updateTeamMemberPensionContributions: (teamMemberPension, userId, agencyProfileId) => {

				const url = lib + 'UpdateTeamMemberPensionContributions';
				const dataObj = {
					UserID: userId,
					AgencyProfileID: agencyProfileId,
					UpdatedTeamMemberPension: teamMemberPension
				};

				return promise.getPromise(url, dataObj);
			},

			updateTeamMemberPensionPostpone: (agencyProfileId, userId, updatedTeamMemberPension) => {

				const url = libUser + 'UpdateTeamMemberPensionPostpone';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					UserID: userId,
					UpdatedTeamMemberPension: updatedTeamMemberPension
				};

				return promise.getPromise(url, dataObj);
			},

			updateTeamMembersInPension: (agencyProfileId, userIds, agencyEmployerPensionId, isInPension) => {

				const url = libUser + 'UpdateTeamMembersInPension';
				const dataObj = {
					AgencyProfileID: agencyProfileId,
					UserIDs: userIds,
					AgencyEmployerPensionID: agencyEmployerPensionId,
					IsInPension: isInPension
				};

				return promise.getPromise(url, dataObj);
			}

		};

		return service;

	}]);

'use strict';

angular.module('paycircleApp')
.service('reportData', [
	'dataTransfer',
	'libraries',
	'promise',
	function (
		dataTransfer,
		libraries,
		promise
	) {

	const lib = libraries.report;

	const service = {

		addReportTemplatesToGroup: (reportTemplateGroupId, reportTemplates, agencyProfileId) => {

			let url = lib + 'AddReportTemplatesToGroup';
			let data = {
				ReportTemplateGroupID: reportTemplateGroupId,
				ReportTemplates: reportTemplates,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		assignReportTemplateGroup: (agencyProfileId, reportTemplateGroup) => {

			let url = lib + 'AssignReportTemplateGroup';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroup: reportTemplateGroup
			};

			return promise.getPromise(url, data);
		},

		createAlertReportDownload: (agencyProfileId, agencyPayPeriodId) => {

			let url = lib + 'CreateAlertReportDownload';
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				Calculated: true
			};

			return promise.getPromise(url, data);
		},

		createBACSDownloadFile: (agencyProfileId, agencyDocumentIds) => {

			const url = lib + 'CreateBACSDownloadFile';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyDocumentIDs: agencyDocumentIds
			};

			return promise.getPromise(url, dataObj);
		},

		createGenderPayGapReport: (agencyProfileId, reportName, snapshotDateIso) => {

			const url = lib + 'CreateGenderPayGapReport';
			const data = {
				AgencyProfileID: agencyProfileId,
				ReportName: reportName,
				SnapshotDateISO: snapshotDateIso
			};

			return promise.getPromise(url, data);
		},

		createNominalCodeReportDownload: function (agencyProfileId) {

			var url = lib + 'CreateNominalCodeReportDownload';
			var data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		createPeriodReportsZipDownload: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'CreatePeriodReportsZipDownload';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		createPermissionsReportDownload: agencyProfileId => {

			let url = lib + 'CreatePermissionsReportDownload';
			let data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		createReportTemplate: (agencyProfileId, reportTemplateObj, reportTemplateFilterObj) => {

			let url = lib + 'CreateReportTemplate';
			let data = {
				ReportTemplate: reportTemplateObj,
				AgencyProfileID: agencyProfileId,
				ReportTemplateFilter: reportTemplateFilterObj
			};

			return promise.getPromise(url, data);
		},

		createReportTemplateGroup: (agencyProfileId, reportTemplateGroup) => {

			let url = lib + 'CreateReportTemplateGroup';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroup: reportTemplateGroup
			};

			return promise.getPromise(url, data);
		},

		createSupplementaryPaymentReports: (agencyProfileId, supplementaryPaymentId) => {

			const url = lib + 'CreateSupplementaryPaymentReports';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, dataObj);
		},

		createUserDocumentZipDownload: (agencyProfileId, userIds, userDocumentTypeId, agencyPayPeriodFromId, agencyPayPeriodToId, password) => {

			const url = lib + 'CreateUserDocumentZipDownload';
			const dataObj = {
				AgencyPayPeriodFromID: agencyPayPeriodFromId,
				AgencyPayPeriodToID: agencyPayPeriodToId,
				AgencyProfileID: agencyProfileId,
				Password: password,
				UserDocumentTypeId: userDocumentTypeId,
				UserIDs: userIds
			};

			return promise.getPromise(url, dataObj);
		},

		deleteGenderPayGapReport: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'DeleteGenderPayGapReport';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		deleteReportTemplate: (reportTemplateId, agencyProfileId) => {

			let url = lib + 'DeleteReportTemplate';
			let data = {
				ReportTemplateID: reportTemplateId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		deleteReportTemplateGroup: (agencyProfileId, reportTemplateGroupObj) => {

			let url = lib + 'DeleteReportTemplateGroup';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroupID: reportTemplateGroupObj.ReportTemplateGroupID
			};

			return promise.getPromise(url, data);
		},

		duplicateReportTemplateGroup: (agencyProfileId, reportTemplateGroup) => {

			let url = lib + 'DuplicateReportTemplateGroup';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroup: reportTemplateGroup
			};

			return promise.getPromise(url, data);
		},

		generateTestPaymentFile: (agencyProfileId, companyBank, payeeBank, bacsDateIso, bankFileId) => {

			const url = lib + 'GenerateTestPaymentFile';
			const data = {
				AgencyProfileID: agencyProfileId,
				CompanyBank: companyBank,
				PayeeBank: payeeBank,
				BACSDateISO: bacsDateIso,
				BankFileID: bankFileId
			};
			return promise.getPromise(url, data);
		},

		getAccessFinancialsNominalCategories: agencyProfileId => {

			const url = lib + 'GetAccessFinancialsNominalCategories';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getAccessFinancialsJournalCodePreview: agencyProfileId => {

			const url = lib + 'GetAccessFinancialsJournalCodePreview';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		updateAccessFinancialsNominalCategoryMappings: (agencyProfileId, nominalCategories) => {

			const url = lib + 'UpdateAccessFinancialsNominalCategoryMappings';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				NominalCategories: nominalCategories
			};

			return promise.getPromise(url, dataObj);
		},

		getBulkDocumentDownloadDetails: (agencyProfileId, userIds) => {

			const url = lib + 'GetBulkDocumentDownloadDetails';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserIDs: userIds
			};

			return promise.getPromise(url, dataObj);
		},

		getBusinessCategoryListForAgency: (agencyProfileId, getUnallocatedCode) => {

			var url = lib + 'GetBusinessCategoryListForAgency';
			var data = {
				AgencyProfileID: agencyProfileId,
				GetUnallocatedCode: getUnallocatedCode
			};
			return promise.getPromise(url, data);
		},

		getBACSDownloads: agencyProfileId => {

			const url = lib + 'GetBACSDownloads';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getDocumentRegenerationDetails: (agencyProfileId, userId) => {
			let url = `${lib}GetDocumentRegenerationDetails`;
			let data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};
			return promise.getPromise(url, data);
		},

		getEmptyBusinessCode: function () {

			var url = lib + 'GetEmptyBusinessCode';
			return promise.getPromise(url);
		},
		getEmptyNominalCode: function () {

			var url = lib + 'GetEmptyNominalCode';
			return promise.getPromise(url);
		},
		getEmptyNominalCodeOverride: function () {

			const url = lib + 'GetEmptyNominalCodeOverride';
			return promise.getPromise(url);
		},
		getIsXeroFeatureBetaCustomer: agencyProfileId => {

			var url = lib + 'GetIsXeroFeatureBetaCustomer';
			var data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getJournalCodeFormatForAgency: agencyProfileId => {

			var url = lib + 'GetJournalCodeFormatForAgency';
			var data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getJournalFrameworkForAgency: function (agencyProfileId) {

			var url = lib + 'GetJournalFrameworkForAgency';
			var data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getJournalDataPreview: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId, journalPostId) => {

			const url = lib + 'GetJournalDataPreview';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				JournalPostID: journalPostId,
				SupplementaryPaymentID: supplementaryPaymentId
			};
			return promise.getPromise(url, data);
		},
		getJournalPostHistory: agencyProfileId => {

			const url = lib + 'GetJournalPostHistory';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getActiveJournalPost: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId) => {

			const url = lib + 'GetActiveJournalPost';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SupplementaryPaymentID: supplementaryPaymentId
			};
			return promise.getPromise(url, data);
		},

		getEmptyReportTemplate: () => {

			let url = lib + 'GetEmptyReportTemplate';

			return promise.getPromise(url);
		},

		getEmptyReportTemplateCollectionEntry: () => {

			const url = lib + 'GetEmptyReportTemplateCollectionEntry';

			return promise.getPromise(url);
		},

		getEmptyReportTemplateFilter: () => {

			const url = lib + 'GetEmptyReportTemplateFilter';

			return promise.getPromise(url);
		},

		getEmptyReportTemplateFilterClause: () => {

			const url = lib + 'GetEmptyReportTemplateFilterClause';

			return promise.getPromise(url);
		},

		getEmptyReportTemplateFilterGroup: () => {

			const url = lib + 'GetEmptyReportTemplateFilterGroup';

			return promise.getPromise(url);
		},

		getEmptyReportTemplateGroup: () => {

			let url = lib + 'GetEmptyReportTemplateGroup';

			return promise.getPromise(url);
		},

		getNominalCodeListForAgency: function (agencyProfileId) {

			var url = lib + 'GetNominalCodeListForAgency';
			var data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},

		getNominalCodeListForBusinessCode: (agencyProfileId, businessCodeId) => {

			const url = lib + 'GetNominalCodeListForBusinessCode';
			const data = {
				AgencyProfileID: agencyProfileId,
				BusinessCodeID: businessCodeId
			};
			return promise.getPromise(url, data);
		},
		getNominalCodeOverridesForBusinessCode: (agencyProfileId, businessCodeId) => {

			const url = lib + 'GetNominalCodeOverridesForBusinessCode';
			const data = {
				AgencyProfileID: agencyProfileId,
				BusinessCodeID: businessCodeId
			};
			return promise.getPromise(url, data);
		},

		getPayrollComparisonReport: (agencyProfileId, comparisonAgencyPayPeriodId) => {

			let url = lib + 'GetPayrollComparisonReport';
			let data = {
				AgencyProfileID: agencyProfileId,
				ComparisonAgencyPayPeriodID: comparisonAgencyPayPeriodId
			};
			return promise.getPromise(url, data);
		},

		getPayrollReportsMailReportTemplateCollection: agencyProfileId => {

			const url = lib + 'GetPayrollReportsMailReportTemplateCollection';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getPeriodReportsDownloadReportTemplateCollection: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'GetPeriodReportsDownloadReportTemplateCollection';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getReportRequestOptions: (agencyProfileId, reportTemplateId, reportTemplate, agencyPayPeriodId, supplementaryPaymentId, journalPostId) => {

			const url = lib + 'GetReportRequestOptions';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateID: reportTemplateId,
				ReportTemplate: reportTemplate,
				AgencyPayPeriodID: agencyPayPeriodId,
				SupplementaryPaymentID: supplementaryPaymentId,
				JournalPostID: journalPostId
			};

			return promise.getPromise(url, dataObj);
		},

		getRTISubmissionReports: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId, p11dbSubmissionId, rtiSubmissionReportType) => {

			const url = lib + 'GetRTISubmissionReports';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SupplementaryPaymentID: supplementaryPaymentId,
				P11DbSubmissionID: p11dbSubmissionId,
				RTISubmissionReportType: rtiSubmissionReportType
			};

			return promise.getPromise(url, dataObj);
		},

		getSOXReport: (agencyProfileId, agencyPayPeriodId) => {

			let url = lib + 'GetSOXReport';
			let data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getSupplementaryPaymentReports: (agencyProfileId, supplementaryPaymentId) => {

			let url = lib + 'GetSupplementaryPaymentReports';
			let data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		getCustomReport: reportRequest => {

			const url = lib + 'GetCustomReport';
			const data = {
				ReportRequest: reportRequest
			};

			return promise.getPromise(url, data);
		},

		getCustomReports: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId) => {

			const url = lib + 'GetCustomReports';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		getClassicReport: reportRequest => {

			const url = lib + 'GetClassicReport';
			const data = {
				ReportRequest: reportRequest
			};

			return promise.getPromise(url, data);
		},

		getClassicReports: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId) => {

			const url = lib + 'GetClassicReports';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapAnalytics: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'GetGenderPayGapAnalytics';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapAnalyticsForReportParent: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'GetGenderPayGapAnalyticsForReportParent';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapPayElementSettings: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'GetGenderPayGapPayElementSettings';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapReport: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'GetGenderPayGapReport';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapReportsForAgency: (agencyProfileId) => {

			const url = lib + 'GetGenderPayGapReportsForAgency';
			const data = {
				AgencyProfileID: agencyProfileId,
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapReportsForAgencyParent: (agencyProfileId, snapshotDateIso) => {

			const url = lib + 'GetGenderPayGapReportsForAgencyParent';
			const data = {
				AgencyProfileID: agencyProfileId,
				SnapshotDateISO: snapshotDateIso
			};

			return promise.getPromise(url, data);
		},

		getGenderPayGapUsers: (agencyProfileId, genderPayGapReportId) => {

			const url = lib + 'GetGenderPayGapUsers';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId
			};

			return promise.getPromise(url, data);
		},

		getReport: (agencyProfileId, agencyDocumentId, agencyPayPeriodId, reportTemplateId, supplementaryPaymentId) => {

			const url = lib + 'GetReport';
			const data = {
				AgencyDocumentID: agencyDocumentId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				ReportTemplateID: reportTemplateId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		getReportForJournalDataPreview: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId) => {

			const url = lib + 'GetReportForJournalDataPreview';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, dataObj);
		},

		getReports: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId) => {

			const url = lib + 'GetReports';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},

		getReportTemplateCategories: agencyProfileId => {

			let url = lib + 'GetReportTemplateCategories';
			let data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getReportTemplateFilter: reportTemplateId => {

			const url = lib + 'GetReportTemplateFilter';
			const dataObj = {
				ReportTemplateID: reportTemplateId
			};

			const configObj = {
				errorOnEmptyResponse: false
			};

			return promise.getPromise(url, dataObj, configObj);
		},

		getReportTemplateFilterClauseComponents: () => {

			const url = lib + 'GetReportTemplateFilterClauseComponents';

			return promise.getPromise(url);
		},

		getReportTemplateFormatTypes: () => {

			const url = lib + 'GetReportTemplateFormatTypes';

			return promise.getPromise(url);
		},

		getReportTemplateGroup: reportTemplateGroupId => {

			let url = lib + 'GetReportTemplateGroup';
			let data = {
				ReportTemplateGroupID: reportTemplateGroupId
			};

			return promise.getPromise(url, data);
		},

		getReportTemplateGroupInheritors: (agencyProfileId, reportTemplateGroupId) => {

			const url = lib + 'GetReportTemplateGroupInheritors';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroupID: reportTemplateGroupId
			};

			return promise.getPromise(url, dataObj);
		},

		getReportTemplateGroups: (agencyProfileId, reportTemplateGroupId) => {

			let url = lib + 'GetReportTemplateGroups';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroupID: reportTemplateGroupId
			};

			return promise.getPromise(url, data);
		},

		getReportTemplates: (agencyProfileId, reportTemplateGroupId, includeColumnDetails) => {

			let url = lib + 'GetReportTemplates';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroupID: reportTemplateGroupId,
				IncludeColumnDetails: includeColumnDetails
			};

			return promise.getPromise(url, data);
		},

		getReportTemplatesForAgencyPayPeriod: (agencyPayPeriodId, includeColumnDetails, hideInvisibleReports, includeClassicReports) => {

			const url = lib + 'GetReportTemplatesForAgencyPayPeriod';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				IncludeColumnDetails: includeColumnDetails,
				HideInvisibleReports: hideInvisibleReports,
				IncludeClassicReports: includeClassicReports
			};

			return promise.getPromise(url, dataObj);
		},

		getReportTemplatesForAgencyProfile: (agencyProfileId, includeColumnDetails, hideInvisibleReports, includeClassicReports) => {

			const url = lib + 'GetReportTemplatesForAgencyProfile';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				IncludeColumnDetails: includeColumnDetails,
				HideInvisibleReports: hideInvisibleReports,
				IncludeClassicReports: includeClassicReports
			};

			return promise.getPromise(url, dataObj);
		},

		getStaticReport: reportRequest => {

			const url = lib + 'GetStaticReport';
			const data = {
				ReportRequest: reportRequest
			};

			return promise.getPromise(url, data);
		},

		getStaticReportSupportsStorage: reportTemplateId => {

			const url = lib + 'GetStaticReportSupportsStorage';
			const data = {
				ReportTemplateID: reportTemplateId
			};

			return promise.getPromise(url, data);
		},

		getStaticReportStatus: documentId => {
			const url = lib + 'GetStaticReportStatus';
			const data = {
				DocumentID: documentId
			};

			return promise.getPromise(url, data);
		},

		startStaticReportGeneration: reportRequest => {
			const url = lib + 'StartStaticReportGeneration';
			const data = {
				ReportRequest: reportRequest
			};

			return promise.getPromise(url, data);
		},

		getStaticReportFromStorage: (documentId, reportRequest) => {
			const url = lib + 'GetStaticReportFromStorage';
			const data = {
				DocumentID: documentId,
				ReportRequest: reportRequest
			};
			
			return promise.getPromise(url, data);
		},

		getReportTemplatesForPayrollReportsMail: (agencyProfileId) => {

			const url = lib + 'GetReportTemplatesForPayrollReportsMail';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		getReportTemplatesForPeriodReportsZipDownload: (agencyProfileId, agencyPayPeriodId) => {

			const url = lib + 'GetReportTemplatesForPeriodReportsZipDownload';
			const dataObj = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		payrollRegenerateBACS: (agencyProfileId, agencyDocumentId) => {

			let url = `${lib}PayrollRegenerateBACS`;
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyDocumentID: agencyDocumentId
			};
			return promise.getPromise(url, data);
		},

		payrollRegenerateP45: (agencyProfileId, userId) => {

			let url = `${lib}PayrollRegenerateP45`;
			let data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};
			return promise.getPromise(url, data);
		},

		payrollRegenerateP60: (agencyProfileId, userId) => {

			let url = `${lib}PayrollRegenerateP60`;
			let data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};
			return promise.getPromise(url, data);
		},

		payrollRegeneratePayslip: (agencyProfileId, userId, payPeriodFromGuid, payPeriodToGuid) => {

			let url = `${lib}PayrollRegeneratePaySlip`;
			let data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodFrom: payPeriodFromGuid,
				AgencyPayPeriodTo: payPeriodToGuid,
				UserID: userId
			};
			return promise.getPromise(url, data);
		},

		payrollUpdateLeaveDateAndRegenerateP45: (agencyProfileId, userId, leaveDateISO, leaveReason, leaveNote, leaveSubmitted, leaveSubmit, noP45Generation, overrideLeaveSubmitted) => {

			let url = lib + 'PayrollUpdateLeaveDateAndRegenerateP45';
			let data = {
				AgencyProfileID: agencyProfileId,
				LeaveDateISO: leaveDateISO,
				LeaveNote: leaveNote,
				LeaveReason: leaveReason,
				LeaveSubmit: leaveSubmit,
				LeaveSubmitted: angular.isUndefined(leaveSubmitted) ? false : leaveSubmitted,
				NoP45Generation: angular.isUndefined(noP45Generation) ? true : noP45Generation,
				OverrideLeaveSubmitted: angular.isUndefined(overrideLeaveSubmitted) ? false : overrideLeaveSubmitted,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},

		getAccountingIntegrationConnection: agencyProfileId => {

			const url = lib + 'GetAccountingIntegrationConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getXeroConnection: agencyProfileId => {

			const url = lib + 'GetXeroConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAccessFinancialsConnection: agencyProfileId => {

			const url = lib + 'GetAccessFinancialsConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		createAccessFinancialsConnection: agencyProfileId => {

			const url = lib + 'CreateAccessFinancialsConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getAccessFinancialsTenants: agencyProfileId => {

			const url = lib + 'GetAccessFinancialsTenants';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		updateAccessFinancialsInstance: (agencyProfileId, tenantId, tenantName) => {

			const url = lib + 'UpdateAccessFinancialsInstance';
			const data = {
				AgencyProfileID: agencyProfileId,
				TenantID: tenantId,
				TenantName: tenantName
			};

			return promise.getPromise(url, data);
		},

		deleteAccessFinancialsConnection: agencyProfileId => {

			const url = lib + 'DeleteAccessFinancialsConnection';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		postJournal: (agencyProfileId, agencyPayPeriodId, supplementaryPaymentId, submitAsFinal) => {

			const url = lib + 'PostJournal';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				SubmitAsFinal: submitAsFinal,
				SupplementaryPaymentID: supplementaryPaymentId
			};

			return promise.getPromise(url, data);
		},
		removeReportTemplatesFromGroup: (reportTemplateGroupId, reportTemplates, agencyProfileId) => {

			let url = lib + 'RemoveReportTemplatesFromGroup';
			let data = {
				ReportTemplateGroupID: reportTemplateGroupId,
				ReportTemplates: reportTemplates,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updateBACSDownloadStates: (agencyProfileId, bacsDownloads, agencyDocumentState) => {

			const url = lib + 'UpdateBACSDownloadStates';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				BACSDownloads: bacsDownloads,
				AgencyDocumentState: agencyDocumentState
			};

			return promise.getPromise(url, dataObj);
		},
		updateBusinessCategory: function (agencyProfileId, businessCategory) {

			var url = lib + 'UpdateBusinessCategory';
			var data = {
				AgencyProfileID: agencyProfileId,
				BusinessCategory: businessCategory
			};

			return promise.getPromise(url, data);
		},
		updateBusinessCategoriesDefaultCodeValue: function (agencyProfileId, businessCategories) {

			var url = lib + 'UpdateBusinessCategoriesDefaultCodeValue';
			var data = {
				AgencyProfileID: agencyProfileId,
				BusinessCategories: businessCategories
			};

			return promise.getPromise(url, data);
		},

		updateGenderPayGapReport: (agencyProfileId, genderPayGapReport) => {

			const url = lib + 'UpdateGenderPayGapReport';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReport: genderPayGapReport
			};

			return promise.getPromise(url, data);
		},

		updateGenderPayGapReportCreationComplete: (agencyProfileId, genderPayGapReportId, creationComplete) => {

			const url = lib + 'UpdateGenderPayGapReportCreationComplete';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId,
				CreationComplete: creationComplete
			};

			return promise.getPromise(url, data);
		},

		updateGenderPayGapPayElementSettings: (agencyProfileId, genderPayGapReportId, payElementSettings) => {

			const url = lib + 'UpdateGenderPayGapPayElementSettings';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId,
				PayElementSettings: payElementSettings
			};

			return promise.getPromise(url, data);
		},

		updateGenderPayGapUsers: (agencyProfileId, genderPayGapReportId, users) => {

			const url = lib + 'UpdateGenderPayGapUsers';
			const data = {
				AgencyProfileID: agencyProfileId,
				GenderPayGapReportID: genderPayGapReportId,
				Users: users
			};

			return promise.getPromise(url, data);
		},

		updateJournalCodeFormat: (agencyProfileId, journalCodeFormat) => {

			const url = lib + 'UpdateJournalCodeFormat';
			const data = {
				AgencyProfileID: agencyProfileId,
				JournalCodeFormat: journalCodeFormat
			};

			return promise.getPromise(url, data);
		},
		updateJournalPost: (agencyProfileId, journalPost) => {

			const url = lib + 'UpdateJournalPost';
			const data = {
				AgencyProfileID: agencyProfileId,
				JournalPost: journalPost
			};

			return promise.getPromise(url, data);
		},
		updateNominalCodeList: function (agencyProfileId, nominalCodeList) {

			var url = lib + 'UpdateNominalCodeList';
			var data = {
				AgencyProfileID: agencyProfileId,
				NominalCodeList: nominalCodeList
			};

			return promise.getPromise(url, data);
		},
		updateNominalCodeOverrides: (agencyProfileId, nominalCodeOverrides) => {

			const url = lib + 'UpdateNominalCodeOverrides';
			const data = {
				AgencyProfileID: agencyProfileId,
				NominalCodeOverrides: nominalCodeOverrides
			};

			return promise.getPromise(url, data);
		},
		updateNominalCodeOverridesEnabled: (agencyProfileId, businessCategoryId) => {

			const url = lib + 'UpdateNominalCodeOverridesEnabled';
			const data = {
				AgencyProfileID: agencyProfileId,
				BusinessCategoryID: businessCategoryId
			};

			return promise.getPromise(url, data);
		},
		updateNominalEntryList: function (agencyProfileId, nominalEntryList) {

			var url = lib + 'UpdateNominalEntryList';
			var data = {
				AgencyProfileID: agencyProfileId,
				NominalEntryList: nominalEntryList
			};

			return promise.getPromise(url, data);
		},
		updateReportTemplate: (agencyProfileId, reportTemplateObj, reportTemplateFilterObj) => {

			let url = lib + 'UpdateReportTemplate';
			let data = {
				ReportTemplate: reportTemplateObj,
				AgencyProfileID: agencyProfileId,
				ReportTemplateFilter: reportTemplateFilterObj
			};

			return promise.getPromise(url, data);
		},

		updateReportTemplateCollection: (agencyProfileId, reportTemplateCollection) => {

			const url = lib + 'UpdateReportTemplateCollection';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateCollection: reportTemplateCollection
			};

			return promise.getPromise(url, dataObj);
		},

		updateReportTemplateGroup: (agencyProfileId, reportTemplateGroup) => {

			let url = lib + 'UpdateReportTemplateGroup';
			let data = {
				AgencyProfileID: agencyProfileId,
				ReportTemplateGroup: reportTemplateGroup
			};

			return promise.getPromise(url, data);
		},
		updateReportTemplateVisibilityDetailsForPack: (agencyProfileId, reportTemplateGroupId, reportTemplates) => {

			let url = lib + 'UpdateReportTemplateVisibilityDetailsForPack';
			let data = {
				ReportTemplateGroupID: reportTemplateGroupId,
				ReportTemplates: reportTemplates,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		getPayElementReportSettings: (agencyProfileId) => {

			const url = lib + 'GetPayElementReportSettings';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},

		updatePayElementReportSettings: (agencyProfileId, payElementSettings) => {

			const url = lib + 'UpdatePayElementReportSettings';
			const data = {
				AgencyProfileID: agencyProfileId,
				PayElementSettings: payElementSettings
			};

			return promise.getPromise(url, data);
		},

		getCompaniesWithOverriddenPayElements: (agencyProfileId, selectedElements) => {

			const url = lib + 'GetCompaniesWithOverriddenPayElements';
			const data = {
				AgencyProfileID: agencyProfileId,
				SelectedElements: selectedElements
			};

			return promise.getPromise(url, data);
		},

		getBureauAgencyAdjustmentGroupEntries: (agencyProfileId) => {
			const url = lib + 'GetBureauAgencyAdjustmentGroupEntries';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')

.service('securityData', [
	'libraries',
	'promise',
	function (
		libraries,
		promise
	) {

	const lib = libraries.security;

	const service = {

		authoriseUserForMigration: (credentials) => {
			const url = lib + 'AuthoriseUserForMigration';
			const dataObj = {
				UserName: credentials.username,
				Password: credentials.password
			};
			const config = {
				async: false,
				checkUserSessionOnFail: false,
				hasTestData: false,
				retries: 0
			};

			return promise.getPromise(url, dataObj, config);
		},

		createPasswordRequest: (username, redirectToPayPortal) => {

			const url = lib + 'CreatePasswordRequest2';
			const dataObj = {
				RedirectToPayPortal: redirectToPayPortal,
				Username: username
			};

			return promise.getPromise(url, dataObj);
		},

		createPasswordRequestInternal: (userId, email, redirectToPayPortal) => {

			const url = lib + 'CreatePasswordRequestInternal';
			const dataObj = {
				Email: email,
				RedirectToPayPortal: redirectToPayPortal,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		createSharedSecret: (userId, authString) => {

			const url = lib + 'CreateSharedSecret';
			const dataObj = {
				UserID: userId,
				AuthString: authString
			};

			const configObj = {
				includeToken: false
			};

			return promise.getPromise(url, dataObj, configObj);
		},

		createUsernameRequestInternal: (userId, email, redirectToPayPortal) => {

			const url = lib + 'CreateUsernameRequestInternal';
			const dataObj = {
				Email: email,
				RedirectToPayPortal: redirectToPayPortal,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		deleteIPAddress: ipAddressId => {

			const url = lib + 'DeleteIPAddress';
			const dataObj = {
				IPAddressID: ipAddressId
			};

			return promise.getPromise(url, dataObj);
		},

		getIPAddressEmpty: () => {

			const url = lib + 'GetIPAddressEmpty';

			return promise.getPromise(url);
		},

		getIPAddresses: agencyProfileId => {

			const url = lib + 'GetIPAddresses';
			const dataObj = {
				OwnerID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getOIDCUrl: (userEmail) => {

			const url = lib + 'GetOIDCURL';
			const data = {
				UserEmail: userEmail
			};

			return promise.getPromise(url, data);
		},
		getOIDCIDExists: (agencyProfileId, userId, ssoId) => {

			const url = lib + 'GetOIDCIDExists';
			const data = {
				AgencyProfileID: agencyProfileId,
				SSOID: ssoId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getSigninStartType: (userNameOrEmail, userId) => {
			const url = lib + 'GetSignInStartType';
			const data = {
				UserNameOrEmail: userNameOrEmail,
				UserID: userId
			};
			const configObj = {
				includeToken: false,
			};

			return promise.getPromise(url, data, configObj);
		},
		getSigninStartTypeNative: (userId) => {
			const url = lib + 'GetSignInStartTypeNative';
			const data = {
				UserID: userId
			};
			const configObj = {
				includeToken: false,
			};

			return promise.getPromise(url, data, configObj);
		},
		getTeamMemberAdminAccounts: (agencyProfileId, mentionsUserid) => {

			const url = lib + 'GetTeamMemberAdminAccounts';
			const data = {
				AgencyProfileID: agencyProfileId,
				MentionsUserID: mentionsUserid
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberAndAccountInformation: function (userId, agencyProfileId) {

			const url = lib + 'GetTeamMemberAndAccountInformation';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getUserRegistrationSummary: (userId, agencyProfileId) => {

			const url = lib + 'GetUserRegistrationSummary';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		HasIdentityMigratedUserProfile: (userId) => {

			const url = lib + 'HasIdentityMigratedUserProfile';
			const data = {
				UserID: userId,
			};

			return promise.getPromise(url, data);
		},
		signinStart: (userNameOrEmail, hasIdentityAccount)  => {

			const url = lib + 'SigninStart';
			const data = {
				UserNameOrEmail: userNameOrEmail,
				HasExistingIdentityAccount: hasIdentityAccount
			};

			return promise.getPromise(url, data);
		},
		signInAfterTimeout: (emailAddress) => {

			const url = lib + 'SignInAfterTimeout';
			const data = {
				EmailAddress: emailAddress
			};
			const configObj = {
				includeToken: false
			};

			return promise.getPromise(url, data, configObj);
		},
		isUserLoggedIn: () => {

			const url = lib + 'IsSignedIn';
			const dataObj = null;
			const config = {
				async: false,
				hasTestData: false,
				logOnEmptyResponse: false,
				checkUserSessionOnFail: false,
				retries: 0
			};

			return promise.getPromise(url, dataObj, config);
		},

		isUserLoggedInMinimal: () => {

			const url = lib + 'IsUserLoggedInMinimal';
			const dataObj = null;
			const config = {
				async: false,
				hasTestData: false,
				logOnEmptyResponse: false,
				checkUserSessionOnFail: false,
				retries: 0
			};

			return promise.getPromise(url, dataObj, config);
		},

		inviteUserToRegister: userId => {

			const url = lib + 'inviteUserToRegister';
			const dataObj = {
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		getAccountMinimalList: userId => {

			const url = lib + 'GetAccountMinimalList';
			const dataObj = {
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		getSwitchAccountMinimalList: userId => {

			const url = lib + 'GetSwitchAccountMinimalList';
			const dataObj = {
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		linkAccounts: (userId, linkedAccountUsername, linkedAccountPassword) => {

			const url = lib + 'LinkAccounts';
			const data = {
				UserID: userId,
				LinkedAccountUsername: linkedAccountUsername,
				LinkedAccountPassword: linkedAccountPassword
			};

			const configObj = {
				retries: 0
			};

			return promise.getPromise(url, data, configObj);
		},

		linkAccountToUserProfileAndSignIn : (code, state, nonce) => {
			const url = lib + 'LinkAccountToUserProfileAndSignIn';
			const data = {
					Code: code,
					State: state,
					Nonce: nonce
			};
			const configObj = {
					includeToken: false,
					retries: 0
			};
			return promise.getPromise(url, data, configObj);
		},
		onboardingConversion: agencyProfileId => {

			const url = lib + 'OnboardingConversion';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		onboardingRegistration: (company, autoLogin) => {

			const url = lib + 'OnboardingRegistration';
			const dataObj = {
				Company: company,
				AutoLogin: autoLogin
			};

			return promise.getPromise(url, dataObj);
		},

		onboardingToFirstPeriod: agencyProfileId => {

			const url = lib + 'OnboardingToFirstPeriod';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},

		reset2fa: (agencyProfileId, userId) => {

			const url = lib + 'Reset2FA';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
			};

			return promise.getPromise(url, dataObj);
		},

		resetLoginAttemptCount: (agencyProfileId, userId) => {

			const url = lib + 'ResetLoginAttemptCount';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
			};

			return promise.getPromise(url, dataObj);
		},
		requestRegistration: (userID, agencyProfileID) => {
			const url = lib + 'RequestRegistration';
			const dataObj = {
				UserID: userID,
				AgencyProfileID: agencyProfileID
			};

			const configObj = {
				retries: 0
			};

			return promise.getPromise(url, dataObj, configObj);
		},
		sendInvitationMailExternal: (agencyProfileId, emailAddress, fullName, role, telephone, ssoId) => {

			const url = lib + 'SendInvitationMailExternal';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				EmailAddress: emailAddress,
				FullName: fullName,
				Role: role,
				Telephone: telephone,
				SSOID: ssoId
			};

			return promise.getPromise(url, dataObj);
		},
		sendRegistrationEmailForSsoAdmin: (userID, agencyProfileID) => {
			const url = lib + 'SendRegistrationEmailForSsoAdmin';
			const dataObj = {
				AgencyProfileID: agencyProfileID,
				UserID: userID,
			};

			return promise.getPromise(url, dataObj);
		},
		sendInvitationMailInternal: function (userID, agencyProfileID, emailAddress, role) {

			const url = lib + 'SendInvitationMailInternal';
			const dataObj = {
				UserID: userID,
				AgencyProfileID: agencyProfileID,
				EmailAddress: emailAddress,
				Role: role
			};

			return promise.getPromise(url, dataObj);
		},

		sendInvitationMailInternalBulk: (agencyProfileId, userList) => {

			const url = lib + 'SendInvitationMailInternalBulk';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserList: userList
			};

			return promise.getPromise(url, dataObj);
		},

		switchProfile: (switchUserId) => {

			const url = lib + 'SwitchProfile';
			const dataObj = {
				SwitchUserID: switchUserId
			};
			const configObj = {
				checkUserSessionOnFail: false,
				retries: 0
			};

			return promise.getPromise(url, dataObj, configObj);
		},

		unlinkAccounts: (userId, linkedAccountUserId) => {

			const url = lib + 'UnlinkAccounts';
			const data = {
				UserID: userId,
				LinkedAccountUserID: linkedAccountUserId
			};

			return promise.getPromise(url, data);
		},
		
		unlinkAccessAccount: (userID, agencyProfileID) => {

			const url = lib + 'unlinkAccessAccount';
			const dataObj = {
				UserID: userID,
				AgencyProfileID: agencyProfileID
			};

			return promise.getPromise(url, dataObj);
		},

		updateIPAddresses: (agencyProfileId, ipAddresses) => {

			const url = lib + 'UpdateIPAddresses';
			const dataObj = {
				OwnerID: agencyProfileId,
				IPList: ipAddresses
			};

			return promise.getPromise(url, dataObj);
		},

		updateIPAddressAdmins: adminList => {

			const url = lib + 'UpdateIPAddressAdmins';
			const dataObj = {
				AdminList: adminList
			};

			return promise.getPromise(url, dataObj);
		},

		updateAccountUsername: (userId, password, oldUsername, newUsername) => {

			const url = lib + 'UpdateAccountUsername';
			const data = {
				UserID: userId,
				Password: password,
				OldUsername: oldUsername,
				NewUsername: newUsername
			};

			return promise.getPromise(url, data);
		},

		updateAccountPassword: (userId, password, newPassword) => {

			const url = lib + 'UpdateAccountPassword';
			const data = {
				UserID: userId,
				Password: password,
				NewPassword: newPassword
			};

			return promise.getPromise(url, data);
		},

		updateAccountRecoveryEmailAddress: (userId, password, oldRecoveryEmailAddress, newRecoveryEmailAddress) => {

			const url = lib + 'UpdateAccountRecoveryEmailAddress';
			const data = {
				UserID: userId,
				Password: password,
				OldRecoveryEmailAddress: oldRecoveryEmailAddress,
				NewRecoveryEmailAddress: newRecoveryEmailAddress
			};

			return promise.getPromise(url, data);
		},

		userChangePassword: (userId, passwordOld, passwordNew) => {

			const url = lib + 'UserChangePassword';
			const dataObj = {
				UserID: userId,
				PasswordOld : passwordOld,
				PasswordNew : passwordNew
			};

			return promise.getPromise(url, dataObj);
		},

		userChangePasswordByEmail: (username, password, hashedKey) => {

			const url = lib + 'UserChangePasswordByEmail2';
			const dataObj = {
				Username: username,
				PasswordNew: password,
				HashedKey: hashedKey
			};

			return promise.getPromise(url, dataObj);
		},

		userLogin: credentials => {

			const url = lib + 'UserLogin2';
			const dataObj = {
				UserName: credentials.username,
				UserPassword: credentials.password
			};
			const config = {
				async: false,
				checkUserSessionOnFail: false,
				errorOnEmptyResponse: false,
				hasTestData: false,
				retries: 0
			};

			return promise.getPromise(url, dataObj, config);
		},

		userLoginSSO: function (agencyProfileId, oidcSystem, token) {

			const url = lib + 'UserLoginSSO3';
			const data = {
				AgencyProfileID: agencyProfileId,
				System: oidcSystem,
				Token: token
			};

			return promise.getPromise(url, data);
		},

		// SignIn
		signIn: function (code, state, nonce) {

			const url = lib + 'SignIn';
			const data = {
				Code: code,
				State: state,
				Nonce: nonce
			};
			const configObj = {
				includeToken: false,
				retries: 0
			};

			return promise.getPromise(url, data, configObj);
		},

		getAccessButtonToken: function (agencyProfileId) {

			const url = lib + 'GetAccessButtonToken';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			const configObj = {
				includeToken: true,
				retries: 0
			};

			return promise.getPromise(url, data, configObj);
		},

		verifyUserCredentials: function (userID, password) {

			const url = lib + 'VerifyUserCredentials';
			const data = {
				UserID: userID,
				Password: password
			};
			const configObj = {
				includeToken: false
			};

			return promise.getPromise(url, data, configObj);
		},

		verifyAccountCode: function (accountID, code) {

			const url = lib + 'VerifyAccountCode';
			const data = {
				AccountID: accountID,
				Code: code
			};

			return promise.getPromise(url, data);
		},

		migrateUser: function (userID, emailAddress) {

			const url = lib + 'MigrateUser';
			const data = {
				UserID: userID,
				EmailAddress: emailAddress
			};

			return promise.getPromise(url, data);
		},

		startAccountVerification: function (accountID) {
			const url = lib + 'StartAccountVerification';
			const data = {
				AccountID: accountID
			};

			return promise.getPromise(url, data);
		},

		getUserAccountSettingsUrl: function () {

			const url = lib + 'GetUserAccountSettingsUrl';

			return promise.getPromise(url);
		},

		signOut: () => {

			const url = lib + 'SignOut';
			const config = {
				hasTestData: false,
				retries: 0,
				checkUserSessionOnFail: false
			};
			const dataObj = null;

			return promise.getPromise(url, dataObj, config);
		},

		userUnregister: (agencyProfileId, userId) => {

			const url = lib + 'UserUnregister';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},

		validate2FA: (userId, totp, authString) => {

			const url = lib + 'Validate2FA';
			const dataObj = {
				UserID: userId,
				TOTP: totp,
				AuthString: authString
			};

			const configObj = {
				includeToken: false
			};

			return promise.getPromise(url, dataObj, configObj);
		}
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.service('supportData', [
	'$http',
	'$q',
	'libraries',
	'supportService',
	'utilities',
function (
	$http,
	$q,
	libraries,
	supportService,
	utilities
) {

	const wordPressAPI = libraries.wordPressAPI;
	const paycircleWordPressAPI = libraries.paycircleWordPressAPI;

	/*
		Cache some of this stuff. Little point repeatedly getting them as they're going to be reasonably static,
		and will update in any case every time the app is relaunched.
	 */
	// Help and support categories and tags
	let supportCategories;
	let helpAndSupportTags;

	// 'latest' and 'popular' articles
	let popularSupportArticles;
	let latestSupportArticleGroups;

	const service = {

		getLatestSupportArticlesGrouped: () => {
			// Get latest support articles if the cached copy doesn't exist.
			if (angular.isUndefined(latestSupportArticleGroups)) {
				/* Use the custom Paycircle WordPress API to get latest posts. Latest posts are marked as 'latest'
				   and have an expiry date, when they stop being classed as 'latest' */
				return service.getWordPressData(paycircleWordPressAPI + 'support/latest').then(supportArticlesArr => {
				    latestSupportArticleGroups = supportService.groupAndSortSupportArticlesByLastUpdated(supportArticlesArr);
					return latestSupportArticleGroups;
				});
			}
			else {
				// Return promise-wrapped latest support articles
				return $q.when(latestSupportArticleGroups);
			}
		},

		getPopularSupportArticles: () => {
			// Get popular support articles if the cached copy doesn't exist
			if (angular.isUndefined(popularSupportArticles)) {
				/* Use the custom Paycircle WordPress API to get popular posts. Popular posts are current marked
				   as 'popular', until there's a better way of doing this. You'd think you could just ask WordPress
				   to provide most-read posts. That sounds like quite an easy thing to do. Hmmm. */
				return service.getWordPressData(paycircleWordPressAPI + 'support/popular').then(supportArticlesArr => {
					popularSupportArticles = supportService.sortSupportArticles(supportArticlesArr);
					return popularSupportArticles;
				});
			}
			else {
				// Return promise-wrapped popular support articles
				return $q.when(popularSupportArticles);
			}
		},

		getSupportArticlesForTags: (tagSlugs) => {

			// Join the slugs for the API request
			const tagList = tagSlugs.join();
			// Use the custom Paycircle WordPress API to get article info
			return service.getWordPressData(paycircleWordPressAPI + `support/tag/${tagList}`).then(supportArticlesArr => {
				return supportService.sortSupportArticles(supportArticlesArr);
			});
		},

		getSupportArticlesForCategory: (categorySlug) => {

			// Use the custom Paycircle WordPress API to get article info
			return service.getWordPressData(paycircleWordPressAPI + `support/category/${categorySlug}?per_page=200`).then(supportArticlesArr => {
				return supportService.sortSupportArticles(supportArticlesArr);
			});
		},

		getSupportArticleByKey: (articleKey) => {

			// This should return a singleton array, so just pluck out the first and only article in it
			return service.getWordPressData(paycircleWordPressAPI + `support/post/${articleKey}`).then(articleObjs => articleObjs[0]);
		},

		searchSupportArticles: (searchTerms) => {

			// Use the custom Paycircle WordPress API to get article info
			return service.getWordPressData(paycircleWordPressAPI + `support/search/${searchTerms}`).then(supportArticlesArr => {
				// The search API does the sorting here
				return supportArticlesArr;
			});
		},

		searchSupportArticlesForCategory: (categorySlug, searchTerms) => {

			// Use custom Paycircle WordPress API to search articles within a specific category
			return service.getWordPressData(paycircleWordPressAPI + `support/search-category/${categorySlug}/${searchTerms}`).then(supportArticlesArr => {
				return supportService.sortSupportArticles(supportArticlesArr);
			});
		},

		getAllCategories: () => {
			// Get all support article categories if the cached copy doesn't exist, otherwise return the promise-wrapped cached copy
			if (!angular.isDefined(supportCategories)) {
				/* Note the 'per-page' attribute. WordPress doesn't like giving up too much information unless you ask it to.
				   This'll be OK as long as there are never more than 100 categories. */
				return service.getWordPressData(wordPressAPI + 'support_type', { parent: 0, per_page: 100 }).then(categoriesArr => {
					// Sex up the categories
					supportCategories = supportService.decorateSupportCategories(categoriesArr);
					return supportCategories;
				});
			}
			else {
				// Return promise-wrapped cached value
				return $q.when(supportCategories);
			}
		},

		getAllTags: () => {
			// Get all support article tags if the cached copy doesn't exist, otherwise return the promise-wrapped cached copy
			if (!angular.isDefined(helpAndSupportTags)) {
				return service.getWordPressData(wordPressAPI + 'tags', { per_page: 100 }).then(tagsArr => {
					/* Transform categories as returned by the WordPress Rest API into something a little more palatable, removing
					   some of the seemingly irrelevant crap that it returns */
					helpAndSupportTags = [];
					tagsArr.forEach(tag => {
						helpAndSupportTags.push({
							description: tag.description,
							id: tag.id,
							name: tag.name,
							slug: tag.slug
						});
					});
					return helpAndSupportTags;
				});
			}
			else {
				// Return promise-wrapped cached value
				return $q.when(helpAndSupportTags);
			}
		},

		getSupportArticle: (articleId, paramsObj) => {

			return service.getWordPressData(wordPressAPI + `support/${articleId}`, paramsObj);
		},

		getSupportGuidesForTags: (tagSlugs) => {
			// Get the tag IDs for the tag slugs, get the guides for the tag IDs
			return service.getTags(tagSlugs).then(tagList => {
				const tagIdsForSearch = tagList.map(tag => tag.id).join();
				return service.getWordPressData(wordPressAPI + 'guides', { tags: tagIdsForSearch }).then(supportGuidesArr => {
					return supportService.normaliseSupportGuides(supportGuidesArr);
				});
			});
		},

		getSupportArticleCategory: (categoryId, paramsObj) => {

			return service.getWordPressData(wordPressAPI + `support_type/${categoryId}`, paramsObj);
		},

		/* Get an array of tags corresponding to a set of tag slugs. Returns a promise, since it could
		   (at least in principle) be called before the set of help and support tags has been retrieved from
		   WordPress. */
		getTags: (tagSlugs) => {
			return service.getAllTags().then(helpAndSupportTags => {
				let tagPropertyValues = [];
				tagSlugs.forEach(tagSlug => {
					let tag = helpAndSupportTags.find(helpAndSupportTag => {
						// Compare case-insensitive, just to add a little kindness and flexibility here
						return helpAndSupportTag.slug.toLowerCase() === tagSlug.toLowerCase();
					});
					if (tag) {
						tagPropertyValues.push(tag);
					}
				});
				return tagPropertyValues;
			});
		},

		getWordPressData: (url, dataObj) => {

			const config = {
				method: 'GET',
				url: angular.isDefined(dataObj) ? `${url}?${utilities.serialiseObj(dataObj)}` : url,
			};
			let deferred = $q.defer();

			/* Temporarily remove Session ID if it's there (otherwise multiple concurrent requests here could
			   obliterate it). WordPress doesn't like SessionID; we get CORS complaints. */
			const sessionId = $http.defaults.headers.common.SessionID;
			if (angular.isDefined(sessionId)) {
				$http.defaults.headers.common.SessionID = undefined;
			}

			$http(config).then(responseObj => {
				deferred.resolve(responseObj.data);
			})
			.catch(errorObj => {
				deferred.reject(errorObj);
			})
			.finally(() => {
				// Restore session ID if it was obliterated in the first place
				if (angular.isDefined(sessionId)) {
					$http.defaults.headers.common.SessionID = sessionId;
				}
			});

			return deferred.promise;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')

.service('teamData', [
    'libraries',
    'promise',
function (
    libraries,
    promise
) {

	const libBase = libraries.base;
	const libUser = libraries.user;
	const libPayroll = libraries.payroll;
	const libIntegration = libraries.integration;

	const service = {

		autoMapIncomingEmployees: function (agencyProfileId) {

			const url = libIntegration + 'AutoMapIncomingEmployees';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		cancelAttachmentOrder: function (attachmentOrderId, cancelledReasonState) {

			const url = libPayroll + 'CancelAttachmentOrder';
			const data = {
				AttachmentOrderID: attachmentOrderId,
				CancelledReasonState: cancelledReasonState,
			};

			return promise.getPromise(url, data);
		},
		createAttachmentOfEarnings: function (userId, agencyProfileId, agencyPayPeriodId, aoe) {

			const url = libPayroll + 'UpdateAttachmentOrderDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UpdatedOrderDetails: aoe
			};

			return promise.getPromise(url, data);
		},
		createNewTeamMember: function (agencyProfileID, niNumber, forename, middlename, surname, male, dob, isStarter, isSubcontractor, utr, cisDetails, cisCompanyAddress, title, isOffPayrollWorker) {

			const url = libUser + 'CreateNewTeamMember';
			const data = {
				AgencyProfileID: agencyProfileID,
				CISCompanyAddress: cisCompanyAddress,
				NewCISDetails: cisDetails,
				DOB: dob,
				Forename: forename,
				IsStarter: isStarter,
				Male: male,
				Middlename: middlename,
				NINumber: niNumber,
				Surname: surname,
				IsOffPayrollWorker: isOffPayrollWorker,
				IsSubcontractor: isSubcontractor,
				UTR: utr,
				Title: title
			};

			return promise.getPromise(url, data);
		},
		deleteAttachmentOrder: function (aoeId) {

			const url = libPayroll + 'DeleteAttachmentOrder';
			const data = {
				AttachmentOrderID: aoeId
			};

			return promise.getPromise(url, data);
		},
		deleteInternalMapping: function (agencyProfileId) {

			const url = libIntegration + 'DeleteInternalMapping';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			const config = {
				errorOnEmptyResponse: false
			};

			return promise.getPromise(url, data, config);
		},
		deleteTeamMemberAdmin: function (userId, agencyProfileId) {

			const url = libUser + 'DeleteTeamMemberAdmin';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		deleteTeamMemberStatutoryPay: function (agencyProfileId, paymentScheduleGroupId) {

			const url = libUser + 'DeleteTeamMemberSchedulePayments';
			const data = {
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: paymentScheduleGroupId
			};

			return promise.getPromise(url, data);
		},
		deleteUserDocument: (agencyDocumentId, agencyProfileId) => {

			const url = libBase + 'DeleteUserDocument';
			const dataObj = {
				AgencyDocumentID: agencyDocumentId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		deleteUserProfile: function (userId, agencyProfileId) {

			const url = libUser + 'DeleteUserProfile';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		deleteUserProfiles: (agencyProfileId, userIds) => {

			const url = libUser + 'DeleteUserProfiles';
			const data = {
				UserIDs: userIds,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		employeeMappingExport: function (agencyProfileId) {

			const url = libIntegration + 'EmployeeMappingExport';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		employeeMappingImport: function (agencyProfileId, fileName, contentType, content) {

			const url = libIntegration + 'EmployeeMappingImport';
			const data = {
				AgencyProfileID: agencyProfileId,
				ImportFile: {
					FileName: fileName,
					ContentType: contentType,
					// content must be base64
					Content: content 
					}
			};

			return promise.getPromise(url, data);
		},
		fullEventCleanup: function (agencyProfileId) {

			const url = libIntegration + 'FullEventCleanup';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			const config = {
				errorOnEmptyResponse: false
			};

			return promise.getPromise(url, data, config);
		},
		generateInternalMapping: function (agencyProfileId) {

			const url = libIntegration + 'GenerateInternalMapping';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			const config = {
				errorOnEmptyResponse: false
			};

			return promise.getPromise(url, data, config);
		},
		getAgeRange: function (dateOfBirth, gender, agencyProfileID) {

        	const url = libUser + 'GetAgeRange';
        	const data = {
            	DOBISO: dateOfBirth,
            	Gender: gender,
            	AgencyProfileID: agencyProfileID
         	};
			
		 	return promise.getPromise(url, data);
		},
		getAllUserDocumentsForArchivedEmployment: (userId, agencyProfileId, archivedEmploymentId, returnAll) => {

			const url = libBase + 'GetAllUserDocumentsForArchivedEmployment';
			const data = {
				AgencyProfileID: agencyProfileId,
				ArchivedEmploymentID: archivedEmploymentId,
				ReturnAll: returnAll !== undefined ? returnAll : false, // Returns both Actual & Hypo
				UserID: userId
			};

			return promise.getPromise(url, data);
		},

		getAllUserDocuments: function (userId, agencyProfileId, returnAll) {

			const url = libBase + 'GetAllUserDocuments';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				ReturnAll: returnAll !== undefined ? returnAll : false // Returns both Actual & Hypo
			};

			return promise.getPromise(url, data);
		},
		getAttachmentOrderDetails: function (aoeId) {

			const url = libPayroll + 'GetAttachmentOrderDetails';
			const data = {
				AttachmentOrderID: aoeId
			};

			return promise.getPromise(url, data);
		},
		getAttachmentOrderInformation: function (userId, agencyProfileId) {

			const url = libPayroll + 'GetAttachmentOrderInformation';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getAttachmentOrderPaymentHistory: function (attachmentOrderId) {

			const url = libPayroll + 'GetAttachmentOrderPaymentHistory';
			const data = {
				AttachmentOrderID: attachmentOrderId
			};

			return promise.getPromise(url, data);
		},
		getAttachmentOrderTypes: function () {

			const url = libPayroll + 'GetAttachmentOrderTypes';

			return promise.getPromise(url);
		},
		getCancelledReasonDetails: function () {

			const url = libPayroll + 'GetCancelledReasonDetails';

			return promise.getPromise(url);
		},
		getEmployeeMappingReport: function (agencyProfileId) {

			const url = libIntegration + 'GetEmployeeMappingReport';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getIncomingEmployeesReport: function (agencyProfileId) {

			const url = libIntegration + 'GetIncomingEmployeesReport';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		exportPeopleHrIntegrationEvents: function (agencyProfileId, fromDateIso, toDateIso, status, eventType, severity, format) {

			const url = libIntegration + 'ExportPeopleHrIntegrationEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null,
				Status: status || null,
				EventType: eventType || null,
				Severity: severity || null,
				Format: format || null
			};

			return promise.getPromise(url, data);
		},
		getIntegrationEvents: function (agencyProfileId, fromDateIso, toDateIso) {

			const url =  libIntegration + 'GetIntegrationEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null
			};

			return promise.getPromise(url, data);
		},
		getIntegrationEvent: function (agencyProfileId, messageId) {

			const url =  libIntegration + 'GetIntegrationEvent';
			const data = {
				AgencyProfileID: agencyProfileId,
				MessageID: messageId
			};

			return promise.getPromise(url, data);
		},
		getIntegrationServiceStatus: function (agencyProfileId) {

			const url =  libIntegration + 'GetIntegrationServiceStatus';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		retryIntegrationEvent: function (agencyProfileId, messageId) {

			const url =  libIntegration + 'RetryIntegrationEvent';
			const data = {
				AgencyProfileID: agencyProfileId,
				MessageID: messageId
			};

			return promise.getPromise(url, data);
		},
		retryMultipleIntegrationEvents: function (agencyProfileId, messageIds) {

			const url =  libIntegration + 'RetryMultipleIntegrationEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				MessageIDs: messageIds
			};

			return promise.getPromise(url, data);
		},
		getRetriedEvents : function (agencyProfileId, messageIds) {

			const url =  libIntegration + 'GetRetriedEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				MessageIDs: messageIds
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberCISCompanyDetails: function (agencyProfileId, userId) {

			const url = libUser + 'GetTeamMemberCISCompanyDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberCompanyDetails: function (userId, agencyProfileId) {

			const url = libUser + 'GetTeamMemberCompanyDetails';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberContact: function (agencyProfileId, userId) {

			const url = libUser + 'GetTeamMemberContact';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getSalaryForPeriodsCalculation: (userId, agencyProfileId, salaryValue, salaryIntervalType, proRating) => {

			const url = libPayroll + 'GetSalaryForPeriodsCalculation';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryValue: salaryValue,
				// Platform calls it SalaryPeriodType. But it's of type SalaryIntervalType.
				SalaryPeriodType: salaryIntervalType,
				ProRating: proRating
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberAdmins: (agencyProfileId, mentionsUserid) => {

			const url = libUser + 'GetTeamMemberAdmins';
			const data = {
				AgencyProfileID: agencyProfileId,
				MentionsUserID: mentionsUserid
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberAdminsExtended: (agencyProfileId, permissionType, restrictVisibility, excludeDepartmentAdmin) => {

			const url = libUser + 'GetTeamMemberAdminsExtended';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				PermissionType: angular.isDefined(permissionType) ? permissionType : 0,
				RestrictVisibility: restrictVisibility,
				ExcludeDepartmentAdmin: excludeDepartmentAdmin
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberAdminsVisibility: function (agencyProfileId, agencyProfileIDVisibility) {

			const url = libUser + 'GetTeamMemberAdminsVisibility';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyProfileIDVisibility: agencyProfileIDVisibility
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberCompanyContinuousEmployment: (userId, agencyProfileId) => {

			const url = libUser + 'GetTeamMemberCompanyContinuousEmployment';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberCompanyWorkplaceInformation: (userId, agencyProfileId) => {

			const url = libUser + 'GetTeamMemberCompanyWorkplaceInformation ';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberCompletionState: function (agencyProfileId) {

			const url = libUser + 'GetTeamMemberCompletionState';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getTeamMemberInformation: function (userId, agencyProfileId) {

			const url = libUser + 'GetTeamMemberInformation';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberInformationForArchivedEmployment: (userId, agencyProfileId, archivedEmploymentId) => {

			const url = libUser + 'GetTeamMemberInformationForArchivedEmployment';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ArchivedEmploymentID: archivedEmploymentId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberMaternityAdvanceFundingDetailsForSchedule: function (scheduleId, userId) {

			const url = libUser + 'GetTeamMemberMaternityAdvanceFundingDetailsForSchedule';
			const data = {
				ScheduleID: scheduleId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternityPay: function (userId, agencyProfileId, scheduleId) {

			const url = libUser + 'GetTeamMemberMaternityPay';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ScheduleID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternityDates: function (userId, agencyProfileId, maternityPay) {

			const url = libUser + 'GetTeamMemberMaternityDates';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternitySalaryPayments: function (userId, agencyProfileId, maternityPay) {

			const url = libUser + 'GetTeamMemberMaternitySalaryPayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternitySchedulePayments: function (userId, agencyProfileId, maternityPay) {

			const url = libUser + 'GetTeamMemberMaternitySchedulePayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternitySchedulePaymentsForSchedule: function (agencyProfileId, userId, scheduleId) {

			const url = libUser + 'GetTeamMemberMaternitySchedulePaymentsForSchedule';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternitySchedulePaymentsForScheduleUpdate: function (agencyProfileId, userId, maternityPay) {

			const url = libUser + 'GetTeamMemberMaternitySchedulePaymentsForScheduleUpdate';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternityPay: function (userId, agencyProfileId, scheduleId) {

			const url = libUser + 'GetTeamMemberPaternityPay';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ScheduleID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternityDates: function (userId, agencyProfileId, paternityPay) {

			const url = libUser + 'GetTeamMemberPaternityDates';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternitySalaryPayments: function (userId, agencyProfileId, paternityPay) {

			const url = libUser + 'GetTeamMemberPaternitySalaryPayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternitySchedulePayments: function (userId, agencyProfileId, paternityPay) {

			const url = libUser + 'GetTeamMemberPaternitySchedulePayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternitySchedulePaymentsForSchedule: function (agencyProfileId, userId, scheduleId) {

			const url = libUser + 'GetTeamMemberPaternitySchedulePaymentsForSchedule';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternitySchedulePaymentsForScheduleUpdate: function (agencyProfileId, userId, paternityPay) {

			const url = libUser + 'GetTeamMemberPaternitySchedulePaymentsForScheduleUpdate';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberRegisteredAdmins: agencyProfileId => {
 
			const url = libUser + 'GetTeamMemberRegisteredAdmins';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMembersForArchivedEmployments: agencyProfileId => {

			const url = libUser + 'GetTeamMembersForArchivedEmployments';
			const dataObj = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMembers: function (agencyProfileId, leavers) {

			const url = libUser + 'GetTeamMembers';
			const data = {
				AgencyProfileID: agencyProfileId,
				Leavers: leavers
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternityDetailsBroughtForward: function (userId, agencyProfileId, maternityPay) {

			const url = libUser + 'GetTeamMemberMaternityDetailsBroughtForward';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPaternityDetailsBroughtForward: function (userId, agencyProfileId, paternityPay) {

			const url = libUser + 'GetTeamMemberPaternityDetailsBroughtForward';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessDates: (agencyProfileId, userId, sicknessPay) => {

			const url = libUser + 'GetTeamMemberSicknessDates';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, dataObj);
		},
		getTeamMemberSicknessDetailsBroughtForward: function (userId, agencyProfileId, sicknessPay) {

			const url = libUser + 'GetTeamMemberSicknessDetailsBroughtForward';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessPay: function (userId, agencyProfileId, scheduleId) {

			const url = libUser + 'GetTeamMemberSicknessPay';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ScheduleID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessSalaryPayments: function (userId, agencyProfileId, sicknessPay) {

			const url = libUser + 'GetTeamMemberSicknessSalaryPayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessSchedulePayments: function (userId, agencyProfileId, sicknessPay) {

			const url = libUser + 'GetTeamMemberSicknessSchedulePayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessSchedulePaymentsForSchedule: function (agencyProfileId, userId, scheduleId) {

			const url = libUser + 'GetTeamMemberSicknessSchedulePaymentsForSchedule';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaymentScheduleGroupID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessSchedulePaymentsForScheduleUpdate: function (agencyProfileId, userId, sicknessPay) {

			const url = libUser + 'GetTeamMemberSicknessSchedulePaymentsForScheduleUpdate';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSicknessEntitlementUsed: function (agencyProfileId, userId, policyId, sicknessDateISO, paymentScheduleGroupId) {

			const url = libUser + 'GetTeamMemberSicknessEntitlementUsed';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				PolicyID: policyId,
				SicknessDateISO: sicknessDateISO,
				PaymentScheduleGroupID: paymentScheduleGroupId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberStatutoryPay: function (userId, agencyProfileId, futurePayments) {

			const url = libUser + 'GetTeamMemberStatutoryPay';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				FuturePayments: futurePayments !== undefined ? futurePayments : false
			};

			return promise.getPromise(url, data);
		},
		getUserAccruedHolidayPay: (userId, agencyProfileId) => {

			const url = libUser + 'GetUserAccruedHolidayPay';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, dataObj);
		},
		getUserAgencyProfileForAgencyNoBankDetails: function (agencyProfileId) {

			const url = libUser + 'GetUserAgencyProfileForAgencyNoBankDetails';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getUserAgencyProfileForAgencyTeamMember: function(userId, agencyProfileId){

			const url = libUser + 'GetUserAgencyProfileForAgencyTeamMember';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getUserAgencyProfileForAgencyTeamMemberMinimum: function (userId, agencyProfileId, email) {

			const url = libUser + 'GetUserAgencyProfileForAgencyTeamMemberMinimum';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				Email: email
			};

			return promise.getPromise(url, data);
		},
		getUserAgencyProfilesForAgencyTeamMemberMinimum: function (agencyProfileId, includeLeavers, ignoreFutureStarters, ignoreAdmins, includeIncomplete, includeBackpay, userId) {

			const url = libUser + 'GetUserAgencyProfilesForAgencyTeamMemberMinimum';
			const data = {
				AgencyProfileID: agencyProfileId,
				IncludeBackpay: includeBackpay,
				IncludeIncomplete: includeIncomplete,
				IncludeLeavers: includeLeavers,
				IgnoreAdmins: ignoreAdmins,
				IgnoreFutureStarters: ignoreFutureStarters,

				// UserID is optional. If specified this should return a single profile. Check for undefined, empty string and null.
				UserID: userId ? userId : undefined
			};

			return promise.getPromise(url, data);
		},
		getUserPaymentCountsIncludingDraftPayslips: function (agencyProfileId, userId) {
			
			const url = libUser + 'GetUserPaymentCountsIncludingDraftPayslips';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		mappedEmployeeBulkExportMappingEventsCleanUp: function (agencyProfileId) {

			const url = libIntegration + 'MappedEmployeeBulkExportMappingEventsCleanUp';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileLeaveDateNoP45: function (leaveDateISO, userId, agencyProfileId) {

			const url = libUser + 'UpdateUserAgencyProfileLeaveDateNoP45';
			const data = {
				LeaveDateISO: leaveDateISO,
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberIncludeInRTI: (userId, agencyProfileId, excludedFromRti) => {

			const url = libUser + 'UpdateTeamMemberIncludeInRTI';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				ExcludeFromRTI: excludedFromRti,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberMaternitySchedulePayments: function (userId, agencyProfileId, maternityPay) {

			const url = libUser + 'UpdateTeamMemberMaternitySchedulePayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				MaternityPay: maternityPay,
				Reason: maternityPay.updateReason ? maternityPay.updateReason : 0
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberNINumber: (newNINumber, userId, agencyProfileId) => {

			const url = libUser + 'UpdateTeamMemberNINumber';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				NewNINumber: newNINumber
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberPaternitySchedulePayments: function (userId, agencyProfileId, paternityPay, reason) {

			const url = libUser + 'UpdateTeamMemberPaternitySchedulePayments';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PaternityPay: paternityPay,
				Reason: reason
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSicknessSchedulePayments: (userId, agencyProfileId, sicknessPay, reason) => {

			const url = libUser + 'UpdateTeamMemberSicknessSchedulePayments';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				Reason: reason,
				SicknessPay: sicknessPay
			};

			return promise.getPromise(url, dataObj);
		},
		saveTeamMemberPermissions: function (teamMemberPermissions, userId) {

			/*
			{
				AgencyProfilePermissions: 99
			};
			*/

			const url = libUser + 'saveTeamMemberPermissions';
			const data = {
				UserID: userId,
				Permissions: teamMemberPermissions
			};

			return promise.getPromise(url, data);
		},
		updateAttachmentOrderPaused: (attachmentOrderId,  paused) => {

			const url = libPayroll + 'UpdateAttachmentOrderPaused';
			const dataObj = {
				AttachmentOrderID: attachmentOrderId,
				Paused: paused
			};

			return promise.getPromise(url, dataObj);
		},
		updateSalaryRates: (agencyProfileId, agencyPayPeriodId, rateDetailsArr) => {

			const url = libPayroll + 'UpdateSalaryRates';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				RateDetails: rateDetailsArr
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberMaternityScheduleInProgress: function (agencyProfileId, userId, maternityPayObj, agencyPayPeriodId, reason) {

			const url = libUser + 'UpdateTeamMemberMaternityScheduleInProgress';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				MaternityPay: maternityPayObj,
				Reason: reason
			};
			// Add agency pay period ID only if it's been specified
			if (agencyPayPeriodId) {
				data['AgencyPayPeriodID'] = agencyPayPeriodId;
			}

			return promise.getPromise(url, data);
		},
		updateTeamMemberMaternityScheduleInProgressReset: function (agencyProfileId, userId, scheduleId) {

			const url = libUser + 'UpdateTeamMemberMaternityScheduleInProgressReset';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				PaymentScheduleGroupID: scheduleId
			};
			return promise.getPromise(url, data);
		},
		updateTeamMemberPaternityScheduleInProgress: (agencyProfileId, userId, paternityPayObj, agencyPayPeriodId, reason) => {

			const url = libUser + 'UpdateTeamMemberPaternityScheduleInProgress';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				PaternityPay: paternityPayObj,
				Reason: reason
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberPaternityScheduleInProgressReset: (agencyProfileId, userId, scheduleId) => {

			const url = libUser + 'UpdateTeamMemberPaternityScheduleInProgressReset';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				PaymentScheduleGroupID: scheduleId
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSicknessScheduleInProgressReset: (agencyProfileId, userId, scheduleId) => {

			const url = libUser + 'UpdateTeamMemberSicknessScheduleInProgressReset';

			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				PaymentScheduleGroupID: scheduleId
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberBank: function (bankDetails, userId, agencyProfileId) {

			const url = libBase + 'UpdateTeamMemberBank';
			const data = {
				UserID: userId,
				UpdatedBank: bankDetails,
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCompany: function (companyDetails, userId, agencyProfileId) {

			const url = libUser + 'UpdateTeamMemberCompany';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				CompanyDetails: companyDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCompanyContinuousEmployment: (userId, agencyProfileId, continuousEmploymentDetailsObj) => {

			const url = libUser + 'UpdateTeamMemberCompanyContinuousEmployment';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ContinuousEmploymentDetails: continuousEmploymentDetailsObj
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberCompanyWorkplaceInformation: (userId, agencyProfileId, workplaceInformationDetailsObj) => {

			const url = libUser + 'UpdateTeamMemberCompanyWorkplaceInformation';
			const dataObj = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				WorkplaceInformationDetails: workplaceInformationDetailsObj
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberPersonal: function (teamMemberPersonal, userId, agencyProfileId) {

			const url = libUser + 'UpdateTeamMemberPersonal';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				PersonalDetails: teamMemberPersonal
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSalary: function (salaryDetails, userId, agencyProfileId, agencyPayPeriodId, updateBackpay) {

			const url = libPayroll + 'UpdateTeamMemberSalary';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				SalaryDetails: salaryDetails,
				UpdateBackpay: updateBackpay !== undefined ? updateBackpay : false
			};

			return promise.getPromise(url, data);
		},

		updateTeamMemberSicknessScheduleInProgress: (agencyProfileId, userId, sicknessPayObj, reason) => {

			const url = libUser + 'UpdateTeamMemberSicknessScheduleInProgress';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				SicknessPay: sicknessPayObj,
				Reason: reason
			};

			return promise.getPromise(url, dataObj);
		},

		updateTeamMemberTax: function (taxDetails, userId, agencyProfileId) {

			const url = libPayroll + 'UpdateTeamMemberTax';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				UpdatedTaxInfoTeamMember: taxDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberTaxExisting: function (taxDetails, userId, agencyProfileId) {

			const url = libPayroll + 'UpdateTeamMemberTaxExisting';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				UpdatedTaxInfoTeamMember: taxDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberYTD: function (ytd, userId, agencyProfileID) {

			const url = libBase + 'UpdateTeamMemberYTD';
			const data = {
				YTDDetails: ytd,
				UserID: userId,
				AgencyProfileID: agencyProfileID
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberYTDWithNICalculation: function (ytd, userId, agencyProfileID, hasYTDNILELs) {

			const url = libPayroll + 'UpdateTeamMemberYTDWithNICalculation';
			const data = {
				YTDDetails: ytd,
				UserID: userId,
				AgencyProfileID: agencyProfileID,
				HasYTDNILELs: hasYTDNILELs
			};

			return promise.getPromise(url, data);
		},
		updateUserContactEmail: function (email, dummyEmail, userId, agencyProfileID) {

			const url = libBase + 'UpdateUserContactEmail';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileID,
				ContactEmail: email,
				ContactDummyEmail: dummyEmail
			};

			return promise.getPromise(url, data);
		},
		updateUserDocument: (agencyProfileId, updatedDocument) => {

			const url = libBase + 'UpdateUserDocument';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UpdatedDocument: updatedDocument
			};

			return promise.getPromise(url, dataObj);
		},
		updateUserPayPeriodOverride: function (agencyPayPeriodID, userId, override) {

			const url = libUser + 'UpdateUserPayPeriodOverride';
			const data = {
				AgencyPayPeriodID: agencyPayPeriodID,
				UserID: userId,
				Override: override
			};

			return promise.getPromise(url, data);
		},
		updateUserProfileNINumber: function (newNINumber, userId, agencyProfileId) {

			const url = libUser + 'UpdateUserProfileNINumber';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				NewNINumber: newNINumber
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberMaternityAdvanceFunding: function (agencyProfileId, userId, advanceFunding) {

			const url = libUser + 'UpdateTeamMemberMaternityAdvanceFunding';
			const data = {
				AgencyProfileID: agencyProfileId,
				AdvanceFunding: advanceFunding,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISBusiness: function (userId, agencyProfileId, cisDetails) {

			const url = libUser + 'UpdateTeamMemberCISBusiness';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedCISDetails: cisDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISCompanyContact: function (agencyProfileId, userId, contactDetails) {

			const url = libUser + 'UpdateTeamMemberCISCompanyContact';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				ContactDetails: contactDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISCompanyDetails: function (agencyProfileId, userId, companyDetails) {

			const url = libUser + 'UpdateTeamMemberCISCompanyDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedCompanyDetails: companyDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISDetails: function (userId, agencyProfileId, cisDetails) {

			const url = libUser + 'UpdateTeamMemberCISDetails';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedCISDetails: cisDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISVAT: function (userId, agencyProfileId, cisDetails) {

			const url = libUser + 'UpdateTeamMemberCISVAT';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedCISDetails: cisDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberCISVerification: function (userId, agencyProfileId, cisDetails) {

			const url = libUser + 'UpdateTeamMemberCISVerification';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				UpdatedCISDetails: cisDetails
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberEmploymentType: function (userId, agencyProfileId, employmentType) {

			const url = libUser + 'UpdateTeamMemberEmploymentType';
			const data = {
				UserID: userId,
				AgencyProfileID: agencyProfileId,
				EmploymentType: employmentType
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberCISDetails: function (userId, agencyProfileId) {

			const url = libUser + 'GetTeamMemberCISDetails';
			const data = {
				UserID: userId,
				AgencyProfileID : agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPayrollDetailed: function (agencyProfileId , agencyPayPeriodId, userId) {

			const url = libUser + 'GetTeamMemberPayrollDetailed';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getAccessRotareadyEvents: function (agencyProfileId) {
			const url = libIntegration + 'GetAccessRotareadyEvents';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getAccessRotareadyEventsGrouped: function (agencyProfileId, fromDateIso, toDateIso) {
			const url = libIntegration + 'GetAccessRotareadyEventsGrouped';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null
			};
			return promise.getPromise(url, data, {
				errorOnEmptyResponse: false
			});
		},
		getAccessRotareadyEventsFiltered: function (agencyProfileId, fromDateIso, toDateIso) {
			const url = libIntegration + 'GetAccessRotareadyEventsFiltered';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null
			};
			return promise.getPromise(url, data, {
				errorOnEmptyResponse: false
			});
		},
		exportAccessRotareadyEvents: function (agencyProfileId, fromDateIso, toDateIso, status, eventType, severity, format) {
			const url = libIntegration + 'ExportAccessRotareadyEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null,
				Status: status || null,
				EventType: eventType || null,
				Severity: severity || null,
				Format: format || null
			};
			return promise.getPromise(url, data);
		},
		exportAccessRotareadyEventsGrouped: function (agencyProfileId, fromDateIso, toDateIso, status, eventType, severity, format) {
			const url = libIntegration + 'ExportAccessRotareadyEventsGrouped';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null,
				Status: status || null,
				EventType: eventType || null,
				Severity: severity || null,
				Format: format || null
			};
			return promise.getPromise(url, data);
		},
		getAccessRotareadyEvent: function (agencyProfileId, eventId) {
			const url = libIntegration + 'GetAccessRotareadyEvent';
			const data = {
				AgencyProfileID: agencyProfileId,
				EventID: eventId
			};
			return promise.getPromise(url, data);
		},
		getAccessRotareadyIntegrationStatus: function (agencyProfileId) {
			const url = libIntegration + 'GetAccessRotareadyIntegrationStatus';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		processPendingAccessRotareadyEvents: function (agencyProfileId) {
			const url = libIntegration + 'ProcessPendingAccessRotareadyEvents';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		processFailedAccessRotareadyEvents: function (agencyProfileId, eventIds) {
			const url = libIntegration + 'ProcessFailedAccessRotareadyEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				EventIDs: eventIds
			};
			return promise.getPromise(url, data);
		},
		dismissAccessRotareadyEventMessage: function (agencyProfileId, eventId, messageId) {
			const url = libIntegration + 'DismissAccessRotareadyEventMessage';
			const data = {
				AgencyProfileID: agencyProfileId,
				EventID: eventId,
				MessageID: messageId
			};
			return promise.getPromise(url, data);
		},
		dismissAccessRotareadyEventMessages: function (agencyProfileId, eventId) {
			const url = libIntegration + 'DismissAccessRotareadyEventMessages';
			const data = {
				AgencyProfileID: agencyProfileId,
				EventID: eventId
			};
			return promise.getPromise(url, data);
		},
		dismissAllAccessRotareadyEventMessages: function (agencyProfileId) {
			const url = libIntegration + 'DismissAllAccessRotareadyEventMessages';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		dismissMultipleAccessRotareadyEventMessages: function (agencyProfileId, eventIds) {
			const url = libIntegration + 'DismissMultipleAccessRotareadyEventMessages';
			const data = {
				AgencyProfileID: agencyProfileId,
				EventIDs: eventIds
			};
			return promise.getPromise(url, data);
		},
		getAccessRotareadyBlockingErrors: function (agencyProfileId) {
			const url = libIntegration + 'GetAccessRotareadyBlockingErrors';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		},
		getEdpEvents: function (agencyProfileId, status, fromDateIso, toDateIso, topic) {
			const url = libIntegration + 'GetEdpEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				Status: status || null,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null,
				Topic: topic || null
			};
			return promise.getPromise(url, data, {
				errorOnEmptyResponse: false
			});
		},
		getEdpEvent: function (agencyProfileId, eventId) {
			const url = libIntegration + 'GetEdpEvent';
			const data = {
				AgencyProfileID: agencyProfileId,
				EdpEventID: eventId
			};
			return promise.getPromise(url, data);
		},
		exportEdpEvents: function (agencyProfileId, fromDateIso, toDateIso, status, eventType, severity, format) {
			const url = libIntegration + 'ExportEdpEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				FromDateISO: fromDateIso || null,
				ToDateISO: toDateIso || null,
				Status: status || null,
				EventType: eventType || null,
				Severity: severity || null,
				Format: format || null
			};
			return promise.getPromise(url, data);
		},
		retryEdpEvents: function (agencyProfileId, eventIds) {
			const url = libIntegration + 'RetryEdpEvents';
			const data = {
				AgencyProfileID: agencyProfileId,
				EdpEventIDs: eventIds
			};
			return promise.getPromise(url, data);
		},
		getEdpEventStatusCounts: function (agencyProfileId) {
			const url = libIntegration + 'GetEdpEventStatusCounts';
			const data = {
				AgencyProfileID: agencyProfileId
			};
			return promise.getPromise(url, data);
		}

	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')

.service('userData', ['libraries', 'promise', function (libraries, promise) {

	const lib = libraries.user;

	const service = {
		assessIsValidPayrollMove: function (userId, oldAgencyProfileId, newAgencyProfileId) {

			const url = lib + 'AssessIsValidPayrollMove';
			const data = {
				UserID: userId,
				OldAgencyProfileID: oldAgencyProfileId,
				NewAgencyProfileID: newAgencyProfileId
			};

			return promise.getPromise(url, data);
		},
		assessIsValidCancelPayrollMove: function (userId, agencyProfileId) {

			const url = lib + 'AssessIsValidCancelPayrollMove';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		cancelUserAgencyProfileRestart: (agencyProfileId, userId) => {

			const url = lib + 'CancelUserAgencyProfileRestart';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},
		cancelUserPayrollMove: (userId, agencyProfileId) => {

			const url = lib + 'CancelUserPayrollMove';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		deleteUserTaxUpdate: (agencyProfileId, userId, userTaxInfoId) => {

			const url = lib + 'DeleteUserTaxUpdate';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				UserTaxInfoID: userTaxInfoId
			};

			return promise.getPromise(url, data);
		},
		getAllTeamMemberContactsExternal: agencyProfileId => {

			const url = lib + 'GetAllTeamMemberContactsExternal';
			const data = {
				AgencyProfileID: agencyProfileId,
			};

			return promise.getPromise(url, data);
		},
		getBusinessCodeMembers: (agencyProfileId, businessCategoryId, businessCodeId) => {

			const url = lib + 'GetBusinessCodeMembers';
			const data = {
				AgencyProfileID: agencyProfileId,
				BusinessCategoryID: businessCategoryId,
				BusinessCodeID: businessCodeId
			};

			return promise.getPromise(url, data);
		},
		getCISSubmissionState: function (agencyProfileId, userId) {

			const url = lib + 'GetCISSubmissionState';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getCompanyFastSearch: function (agencyProfileId) {

			const url = lib + 'GetCompanyFastSearch';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getCompanyTurboSearch: (agencyProfileId, searchCriteria) => {

			const url = lib + 'GetCompanyTurboSearch';
			const data = {
				AgencyProfileID: agencyProfileId,
				SearchCriteria: searchCriteria
			};

			return promise.getPromise(url, data);
		},
		getEmptyBusinessCodeMember: () => {

			const url = lib + 'GetEmptyBusinessCodeMember';

			return promise.getPromise(url);
		},
		getEmptyTeamMemberContact: function () {

			const url = lib + 'GetEmptyTeamMemberContact';

			return promise.getPromise(url);
		},
		getEmptyUserAgencyProfileBusinessCode () {

			const url = lib + 'GetEmptyUserAgencyProfileBusinessCode';

			return promise.getPromise(url);
		},
		getTeamMemberContactsExternal: function (agencyProfileId, categories) {

			const url = lib + 'GetTeamMemberContactsExternal';
			const data = {
				AgencyProfileID: agencyProfileId,
				Categories: categories
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberFastSearch: function (agencyProfileId) {

			const url = lib + 'GetTeamMemberFastSearch';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberTurboSearch: (agencyProfileId, searchCriteria) => {

			const url = lib + 'GetTeamMemberTurboSearch';
			const data = {
				AgencyProfileID: agencyProfileId,
				SearchCriteria: searchCriteria
			};

			return promise.getPromise(url, data);
		},
		getTeamMembersForMovedPayrolls: function (agencyProfileId) {

			const url = lib + 'GetTeamMembersForMovedPayrolls';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberIncomplete: function (agencyProfileId) {

			const url = lib + 'GetTeamMemberIncomplete';
			const data = {
				AgencyProfileID: agencyProfileId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberMaternityDetailsForAdvanceFunding: function (agencyProfileId, userId, maternityPay) {

			const url = lib + 'GetTeamMemberMaternityDetailsForAdvanceFunding';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				MaternityPay: maternityPay
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPayment: (agencyProfileId, userId, agencyPayPeriodId, userPaymentId, authString) => {

			const url = lib + 'GetTeamMemberPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				UserPaymentID: userPaymentId,
				AgencyPayPeriodID: agencyPayPeriodId,
				AuthString: authString
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPayStatement: (agencyProfileId, userId, agencyPayPeriodId, userPaymentId) => {

			const url = lib + 'GetTeamMemberPayStatement';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				UserPaymentID: userPaymentId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberPersonal: function (agencyProfileId, userId) {

			const url = lib + 'GetTeamMemberPersonal';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSupplementaryPayment: (userId, agencyProfileId, supplementaryPaymentId, userDocumentTypeId) => {

			const url = lib + 'GetTeamMemberSupplementaryPayment';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId,
				UserDocumentTypeID: userDocumentTypeId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberSupplementaryPayStatement: (userId, agencyProfileId, supplementaryPaymentId, userDocumentTypeId) => {

			const url = lib + 'GetTeamMemberSupplementaryPayStatement';
			const data = {
				AgencyProfileID: agencyProfileId,
				SupplementaryPaymentID: supplementaryPaymentId,
				UserDocumentTypeID: userDocumentTypeId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getTeamMemberWorkPatterns: function (workPatternId) {

			const url = lib + 'GetTeamMemberWorkPatterns';
			const data = {
				WorkPatternID: workPatternId
			};
			const config = {
				useTestData: true
			};

			return promise.getPromise(url, data, config);
		},
		getUsernameExists: function (username, contactId, userId) {

			const url = lib + 'GetUsernameExists';
			const data = {
				Username: username,
				ContactID: contactId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getUserTaxUpdates: function (agencyProfileId, userId) {

			const url = lib + 'GetUserTaxUpdates';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		getUserTaxUpdatesForPeriod: function (agencyProfileId, agencyPayPeriodId) {

			const url = lib + 'GetUserTaxUpdatesForPeriod';
			const data = {
				AgencyProfileID: agencyProfileId,
				AgencyPayPeriodID: agencyPayPeriodId
			};

			return promise.getPromise(url, data);
		},
		updateBusinessCodeMembers: (agencyProfileId, ExistingBusinessCodeId, businessCategoryId, businessCodeMembers) => {

			const url = lib + 'UpdateBusinessCodeMembers';
			const data = {
				AgencyProfileID: agencyProfileId,
				ExistingBusinessCodeID: ExistingBusinessCodeId,
				BusinessCategoryID: businessCategoryId,
				BusinessCodeMembers: businessCodeMembers
			};

			return promise.getPromise(url, data);
		},
		updateBusinessCodeMembersForBusinessCategory: (agencyProfileId, businessCategoryId, businessCodeMembers) => {

			const url = lib + 'UpdateBusinessCodeMembersForBusinessCategory';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				BusinessCategoryID: businessCategoryId,
				BusinessCodeMembers: businessCodeMembers
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberAdminMentions: (agencyProfileId, userId, adminsArr) => {

			const url = lib + 'UpdateTeamMemberAdminMentions';
			const dataObj = {
				AgencyProfileID: agencyProfileId,
				Admins: adminsArr,
				UserID: userId
			};

			return promise.getPromise(url, dataObj);
		},
		updateTeamMemberContactsExternalP32Mail: function (agencyProfileId, externalContacts, removal) {

			const url = lib + 'UpdateTeamMemberContactsExternalP32Mail';
			const data = {
				AgencyProfileID: agencyProfileId,
				ExternalContacts: externalContacts,
				Removal: removal
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberContactsExternalPayrollMail: function (agencyProfileId, externalContacts, removal) {

			const url = lib + 'UpdateTeamMemberContactsExternalPayrollMail';
			const data = {
				AgencyProfileID: agencyProfileId,
				ExternalContacts: externalContacts,
				Removal: removal
			};

			return promise.getPromise(url, data);
		},
		updateTeamMemberSchedulePaymentsProRatingMethod: (paymentScheduleGroupId, proRatingMethod, displayLeaveDaysAsSeparateDeduction) => {

			const url = lib + 'UpdateTeamMemberSchedulePaymentsProRatingMethod';
			const data = {
				DisplayLeaveDaysAsSeparateDeduction: displayLeaveDaysAsSeparateDeduction || false,
				PaymentScheduleGroupID: paymentScheduleGroupId,
				ProRatingMethod: proRatingMethod
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfilesAdvancePeriods: (agencyProfileId, userIds, advance, advancePeriodCount) => {

			// If being called for a single user, make sure it's passed in as an array
			if (!angular.isArray(userIds)) {
				userIds = [userIds];
			}

			const url = lib + 'UpdateUserAgencyProfilesAdvancePeriods';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserIDs: userIds,
				Advance: advance,
				AdvancePeriodCount: advancePeriodCount
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileExcludeFromPayroll: function (agencyProfileId, userId, excludeFromPayroll) {

			const url = lib + 'UpdateUserAgencyProfileExcludeFromPayroll';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				ExcludeFromPayroll: excludeFromPayroll
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfilesOnHold: (agencyProfileId, userIds, onHold, onHoldPeriodCount) => {

			const url = lib + 'UpdateUserAgencyProfilesOnHold';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserIDs: userIds,
				OnHold: onHold,
				OnHoldPeriodCount: onHoldPeriodCount
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfilesRolledUpHoliday: (agencyProfileId, userIds, isRolledUpHoliday, excludeSalaryFromRolledUpHoliday) => {

			const url = lib + 'UpdateTeamMembersRolledUpHoliday';
			const data = {
				AgencyProfileID: agencyProfileId,
				ExcludeSalaryFromRolledUpHoliday: excludeSalaryFromRolledUpHoliday,
				IsRolledUpHoliday: isRolledUpHoliday,
				UserIDs: userIds
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileRestart: function (agencyProfileId, userId) {

			const url = lib + 'UpdateUserAgencyProfileRestart';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId
			};

			return promise.getPromise(url, data);
		},
		updateUserAgencyProfileTaxRefund: function (agencyProfileId, userId, taxRefund) {

			const url = lib + 'UpdateUserAgencyProfileTaxRefund';
			const data = {
				AgencyProfileID: agencyProfileId,
				UserID: userId,
				TaxRefund: taxRefund
			};

			return promise.getPromise(url, data);
		},
		updateUserProfileIsInPlaygroundMode: function (userId, isInPlaygroundMode) {

			const url = lib + 'UpdateUserProfileIsInPlaygroundMode';
			const data = {
				UserID: userId,
				IsInPlaygroundMode: isInPlaygroundMode
			};

			return promise.getPromise(url, data);
		},
		userPayrollMove: function (userId, oldAgencyProfileId, newAgencyProfileId) {
			const url = lib + 'UserPayrollMove';
			const data = {
				UserID: userId,
				OldAgencyProfileID: oldAgencyProfileId,
				NewAgencyProfileID: newAgencyProfileId
			};

			return promise.getPromise(url, data);
		},
	};

	return service;

}]);

'use strict';

angular.module('paycircleApp')
.directive('capitalise', function () {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, modelCtrl) {

			function capitalise (inputValue) {

				if (inputValue === undefined) {
					inputValue = '';
				}

				var capitalised = inputValue.toUpperCase();

				if (capitalised !== inputValue) {
					modelCtrl.$setViewValue(capitalised);
					modelCtrl.$render();
				}
				return capitalised;
			}
			
			modelCtrl.$parsers.push(capitalise);
			capitalise(scope[attrs.ngModel]); // capitalise initial value
		}
	};
});

/* globals $ */
'use strict';

angular.module('paycircleApp')
.directive('clickAnywhereButHere', ['$document', function ($document) {
	return {
		link: function postLink (scope, element, attrs) {

			var onClick = function (event) {
				var isChild = $(element).has(event.target).length > 0;
				var isSelf = element[0] === event.target;
				var isInside = isChild || isSelf;

				if (!isInside) {
					scope.$applyAsync(attrs.clickAnywhereButHere);
				}
			};

			scope.$watch(attrs.isActive, function(newValue, oldValue) {
				if (newValue !== oldValue && newValue === true) {
					$document.bind('click', onClick);
				}
				else if (newValue !== oldValue && newValue === false) {
					$document.unbind('click', onClick);
				}
			});
		}
	};
}]);

'use strict';

/**
 * @ngdoc directive
 * @name paycircleApp.directive:decimal-mask
 * @description
 * # Parses the input into a float and formats it to the specified number of decimal places, only accepts numbers
 */
angular.module('paycircleApp')
	.directive('decimalMask', ['$filter', function ($filter) {
		return {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				decimals: '@decimalPlaces',
				max: '@?',
				allowZero: '<?'
			},
			link: function (scope, element, attrs, ngModelCtrl) {
				let decimalCount = parseInt(scope.decimals, 10);
				let maxValue = parseFloat(scope.max || 100);
				let zeroAllowed = scope.allowZero || true;

				function setViewValue() {

					if (angular.isUndefined(ngModelCtrl.$modelValue) || isNaN(ngModelCtrl.$modelValue)) {
						return;
					}

					const formatted = $filter('number')(parseFloat(ngModelCtrl.$modelValue), decimalCount);

					ngModelCtrl.$setViewValue(formatted);
					ngModelCtrl.$render();
				}

				function validateDecimal (modelValue, viewValue) {

					const value = modelValue || viewValue;

					return value !== parseFloat(0).toFixed(decimalCount);
				}

				if (zeroAllowed) {
					ngModelCtrl.$validators.decimalValidator = validateDecimal;
				}
			
				ngModelCtrl.$parsers.push(function (inputValue) {

					if (inputValue === null) {
						return null;
					}

					var transformedInput = inputValue.toString().replace(/[^0-9.]/g, '');

					if (transformedInput > maxValue) {
						transformedInput = parseFloat(maxValue).toFixed(decimalCount);
					}

					if (transformedInput !== inputValue.toString()) {
						ngModelCtrl.$setViewValue(transformedInput);
						ngModelCtrl.$render();
					}

					return transformedInput;
				});

				ngModelCtrl.$formatters.push(function (inputValue) {
					if (angular.isUndefined(inputValue) || isNaN(inputValue)) {
						return inputValue;
					}

					return $filter('number')(inputValue, decimalCount);
				});

				element.bind('blur', function () {

					setViewValue();
				});

				attrs.$observe('decimal-places', function (decimals) {

					decimalCount = parseInt(decimals, 10) || decimalCount;

					setViewValue();
				});
			}
		};

	}]);

'use strict';

angular.module('paycircleApp')
.directive('draggable', [function () {
	return {
		scope: {
			drop: '&', // parent
			itemData: '='
		},
		link: function ($scope, element) {

			// this gives us the native JS object
			var el = element[0];

			el.draggable = true;

			el.addEventListener('dragstart', function (event) {

				event.dataTransfer.effectAllowed = 'move';
				event.dataTransfer.setData('text/plain', JSON.stringify($scope.itemData));
				
				this.classList.add('dragging');

				return false;
			}, false);

			el.addEventListener('dragend', function () {
				
				this.classList.remove('dragging');

				return false;
			}, false);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('droppable', [function () {
	return {
		scope: {
			dataTypeKey: '@', // text || html || json || url
			onDrop: '=', // parent
			itemData: '=',
			itemMetaData: '=?' // Optional Meta data object
		},
		link: function ($scope, element) {

			var dataType;
			var dataTypeKey;

			switch (dataTypeKey) {
				case 'json':
					dataType = 'application/json';
					break;
				case 'html':
					dataType = 'text/html';
					break;
				case 'url':
					dataType = 'text/uri-list';
					break;
				default:
					dataType = 'text/plain';
			}

			// again we need the native object
			var el = element[0];

			el.addEventListener('dragover', function (event) {
				event.dataTransfer.dropEffect = 'dragmove'; // allows us to drop
				if (event.preventDefault) {
					event.preventDefault();
				}
				this.classList.add('dragover');
				return false;
			}, false);
			
			el.addEventListener('dragenter', function () {
				this.classList.add('dragover');
				return false;
			}, false);

			el.addEventListener('dragleave', function () {
				this.classList.remove('dragover');
				return false;
			}, false);

			el.addEventListener('drop', function (event) {
				   
				// Stops some browsers from redirecting.
				if (event.stopPropagation) {
					event.stopPropagation();
				}

				this.classList.remove('dragover');

				var dropData = JSON.parse(event.dataTransfer.getData('text/plain'));

				// call the drop passed drop function
				$scope.onDrop(dropData, $scope.itemData, $scope.itemMetaData);

				return false;
			}, false);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.config(['$provide', function ($provide) {

	$provide.decorator('growl', [
		'$delegate',
		'$sanitize',
		function growlDecorator(
			$delegate,
			$sanitize
		) {

		const warning = $delegate.warning;
		const error = $delegate.error;
		const info = $delegate.info;
		const success = $delegate.success;
		const general = $delegate.general;

		function sanitizedWarning(text, config) {
			text = $sanitize(text);
			warning.apply($delegate, [text, config]);
		}

		function sanitizedError(text, config) {
			text = $sanitize(text);
			error.apply($delegate, [text, config]);
		}

		function sanitizedInfo(text, config) {
			text = $sanitize(text);
			info.apply($delegate, [text, config]);
		}

		function sanitizedSuccess(text, config) {
			text = $sanitize(text);
			success.apply($delegate, [text, config]);
		}

		function sanitizedGeneral(text, config) {
			text = $sanitize(text);
			general.apply($delegate, [text, config]);
		}

		$delegate.warning = sanitizedWarning;
		$delegate.error = sanitizedError;
		$delegate.info = sanitizedInfo;
		$delegate.success = sanitizedSuccess;
		$delegate.general = sanitizedGeneral;

		return $delegate;
	}]);
}]);
'use strict';

angular.module('paycircleApp')
.directive('infoTooltip', [function () {
	return {
		restrict: 'A',
		templateUrl: 'scripts/directives/templates/info-tooltip.html',
		scope: {
			tooltipPosition: '=',
			tooltipInfoSource: '<',
			tooltipInfoType: '@'
		},
		transclude: true,
		link: function ($scope) {

			$scope.position = $scope.tooltipPosition ? $scope.tooltipPosition : undefined;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('errorField', ['$compile', function ($compile) {
	return {
		restrict: 'A',
		require: 'ngModel',
		scope: {
			errorMessages: '<',
			errorPosition: '@?'
		},
		link: function($scope, $element, $attrs, ngModel) {

			const errorMessagesObj = $scope.errorMessages;
			let errorMessageKeysArr;
			let tooltipElement;

			function appendTooltipNextToInput (tooltipText) {
				tooltipElement = getGetTooltip(tooltipText);
				$element[0].classList.add('has-error-tooltip');
		        $element.parent().append(tooltipElement);
			}

			function checkForErrors () {

				if (errorMessagesObj && Object.keys(ngModel.$error).length > 0) {
					checkIfErrorsHaveMessagesSet();

				} else if (angular.isDefined(tooltipElement)) {
					hideErrors();
				}
			}

			function checkIfErrorsHaveMessagesSet () {

				for (let errorMessageKey of errorMessageKeysArr) {
					if (ngModel.$error[errorMessageKey]) {
						setupTooltip(errorMessagesObj[errorMessageKey]);
					}
				}
			}

			function getGetTooltip (tooltipText) {
				return $compile( `<div tooltip role='alert' tooltip-text='${tooltipText}' tooltip-position='${angular.isDefined($scope.errorPosition) ? $scope.errorPosition : 'right'}'></div>` )( $scope );
			}

			function hideErrors () {
				tooltipElement[0].remove();
				$element[0].classList.remove('has-error-tooltip');
			}

			function init () {

				if (angular.isDefined(errorMessagesObj)) {

					errorMessageKeysArr = Object.keys(errorMessagesObj);

					// When ngModel value is empty (for required)
					$element.on('blur', checkForErrors);

					// When ngModel changes
					ngModel.$viewChangeListeners.push(checkForErrors);
				}
			}

			function setupTooltip (tooltipText) {

				if (angular.isDefined(tooltipElement)) {
					hideErrors();
					appendTooltipNextToInput(tooltipText);

				} else {
					appendTooltipNextToInput(tooltipText);
				}
			}

			init();
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('listSort', ['$timeout', function ($timeout) {
	return {
		scope: {
			listData: '=',
			listItemId: '@'
		},
		link: function ($scope, listElement) {

			const list = listElement[0];
			const GHOST_CLASS = 'is-ghost';
			const SORTING_CLASS = 'is-sorting';
			const LIST_ELEMENT = 'LI';
			const ITEM_ID = $scope.listItemId;
			let selectedListItem;
			let ghostListItem;
			let commentElement;

			function init () {

				let dragImage = new Image();
				dragImage.src = '../../images/header-drag.png';

				list.addEventListener('dragstart', function (event) {

					selectedListItem = event.target;

					commentElement = selectedListItem.nextSibling;

					event.dataTransfer.setData('text', selectedListItem.innerText);
					event.dataTransfer.setDragImage(dragImage, 10, 18);
					event.dataTransfer.effectAllowed = 'move';

					list.addEventListener('dragover', onDragOver, false);
					list.addEventListener('dragend', onDragEnd, false);

					// Place ghost item at original position
					ghostListItem = selectedListItem.cloneNode(true);
					ghostListItem.classList.add(GHOST_CLASS);
					list.insertBefore(ghostListItem, selectedListItem.nextSibling);

					$timeout(function () {
						selectedListItem.classList.remove('fadeInFast'); // remove animate class to fix flashing when sorting
						selectedListItem.classList.add(SORTING_CLASS);
					}, 0);

			   }, false);
			}

			function onDragEnd (event) {

				event.preventDefault();

				ghostListItem.remove();

				selectedListItem.classList.remove(SORTING_CLASS);
				list.removeEventListener('dragover', onDragOver, false);
				list.removeEventListener('dragend', onDragEnd, false);

				// Update list array
				updateListData();
			}

			function onDragOver (event) {

				event.preventDefault();
				event.dataTransfer.dropEffect = 'move';

				let hoveredOverListItem = event.target;

				// When dragging a list item, place the element above or below the list item it's currently hovered over
				if (hoveredOverListItem && hoveredOverListItem !== selectedListItem && hoveredOverListItem.nodeName === LIST_ELEMENT) {
					let rect = hoveredOverListItem.getBoundingClientRect();
					let next = (event.clientY - rect.top)/(rect.bottom - rect.top) > 0.5;

					list.insertBefore(selectedListItem, next && hoveredOverListItem.nextSibling || hoveredOverListItem);
					list.insertBefore(commentElement, selectedListItem.nextSibling);
				}
			}

			function updateListData () {

				let newItemIndex = Array.from(list.children).findIndex(listItemObj => listItemObj.getAttribute('list-item-id') === selectedListItem.getAttribute('list-item-id'));
				let oldItemIndex = $scope.listData.findIndex(listItemObj => listItemObj[ITEM_ID] === selectedListItem.getAttribute('list-item-id'));

				$scope.listData.splice(newItemIndex, 0, $scope.listData.splice(oldItemIndex, 1)[0]);
				$scope.$apply();
				$scope.$digest();
			}

			init();
		}
	};
}]);

'use strict';

/**
 * @ngdoc directive
 * @name paycircleApp.directive:next-input
 * @description
 * # Moves onto next input field when valid
 */
angular.module('paycircleApp')
.directive('nextInput', [function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function ($scope, $element, $attrs, $ngModel) {

			const forwardTargetId = $attrs.niForwardTarget;
			const backwardTargetId = $attrs.niBackwardTarget;

			$scope.$watch(function () {
				return $ngModel.$modelValue;
			}, function (newValue, oldValue) {

				if (newValue !== oldValue) {

					const isDirty = $ngModel.$dirty;
					const isValid = $attrs.required ? $ngModel.$valid : $ngModel.$viewValue.length === parseInt($attrs.maxlength);

					if (isDirty && isValid) {

						if (angular.isDefined(forwardTargetId)) {
							const forwardTargetElement = angular.element(document.getElementById(forwardTargetId));

							if (forwardTargetElement.length === 1) {
								forwardTargetElement[0].focus();
							}

						} else {
							const nextinput = $element.next('input');

							if (nextinput.length === 1) {
								nextinput[0].focus();
							}

						}

					}
				}
			});

			$element.on('beforeinput', function (event) {

				if (event.inputType === 'deleteContentBackward' && !$element[0].value.length) {

					if (angular.isDefined(backwardTargetId)) {
						const backwardTargetElement = angular.element(document.getElementById(backwardTargetId));

						if (backwardTargetElement.length === 1) {
							backwardTargetElement[0].focus();
						}

					} else {
						const prevInput = angular.element($element[0].previousElementSibling);

						if (prevInput.length === 1) {
							prevInput[0].focus();
						}

					}
				}
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('payslipNotes', [
	'growl',
	'$sanitize',
	'KEY_CODES',
	'PAYSLIP_NOTE_OPTIONS',
	function (
		growl,
		$sanitize,
		KEY_CODES,
		PAYSLIP_NOTE_OPTIONS
	) {

	return {
		restrict: 'A',
		require: 'ngModel',
		scope: {
			payslipNotesOptions: '='
		},
		link: function (scope, element, attrs, ngModel) {

			var tagCount = 0;

			function addTagToPayslipNote (tag, theme) {

				clearDefaultPayslipNote();
				var oldPayslipNote = scope.payslipNotesOptions.teamMember.payslipNote;
				var position = scope.payslipNotesOptions.input.currentPosition;
				var tagId = moment().valueOf();
				var html;

				if (getLengthOfPayslipNote(oldPayslipNote) > scope.payslipNotesOptions.input.maxLength) {
					scope.payslipNotesOptions.teamMember.isValid = false;
					return;
				} else {
					scope.payslipNotesOptions.teamMember.isValid = true;
				}

				switch (theme) {
					case 'emojis':
					case 'emoji':
						if (theme === 'emojis') {
							tag = {
								optionLabel: tag.char,
								optionOutput: tag.code
							};
						}
						html = tag.optionLabel;
						break;
					case 'tag':
						html = '<div data-type="tag" id="'+ tagId +'" contenteditable="false" class="payslip-notes_option-tag payslip-notes_option-tag-tag '+tag.optionTheme+'">' + tag.optionLabel + '</div> ';
						break;
					case 'pill':
						html = '<span id="'+ tagId +'">' + tag.optionLabel + '</span> ';
						break;
				}

				scope.payslipNotesOptions.teamMember.payslipNote = [oldPayslipNote.slice(0, position), html, oldPayslipNote.slice(position)].join('');

				setTimeout(function() {

					var containedTags = element[0].children;

					if (containedTags.length > 0 && tagCount !== containedTags.length) {
						var latestTag;
						for (var i = containedTags.length - 1; i >= 0; i--) {
							if (parseInt(containedTags[i].id) === tagId) {
								latestTag = containedTags[i];
							}
						}
						tagCount = containedTags.length;

						placeCursorAfterTag(latestTag);

						tagCount = containedTags.length;
					}
					updateLastPosition();
				},0);
			}

			function clearDefaultPayslipNote () {

				if (scope.payslipNotesOptions.teamMember.hasDefault) {
					scope.payslipNotesOptions.teamMember.payslipNote = '';
					scope.payslipNotesOptions.teamMember.hasDefault = false;
				}
			}

			function getLengthOfPayslipNote (message) {

				message = $sanitize(message);

				// Remove tags from message
				message = message.replace(/<span data-type="pill".*?>/g, '');
				message = message.replace(/<span data-type="tag".*?>/g, '');
				message = message.replace(/<\/span>/g, '');
				var numberOFEmojis = (message.match(/<span data-type="emoji"/g) || []).length;
				message = message.replace(/<span data-type="emoji".*?<\/i>/g, '');

				// Remove html surrounding emojis
				message = stripHTMLFromPayslipNote(message);
				return message.length+numberOFEmojis;
			}

			function placeCursorAfterTag (tag) {

				element[0].focus();
				var tagRange = document.createRange();
				if (tag) {
					tagRange.setStartAfter(tag);
					tagRange.collapse(true);
				} else {
			        tagRange.selectNodeContents(element[0]);
			        tagRange.collapse(false);
				}
				var inputSelection = window.getSelection();
				inputSelection.removeAllRanges();
				inputSelection.addRange(tagRange);
			}

			function stripHTMLFromPayslipNote (message) {

				message = $sanitize(message);

				var tempArea = document.createElement('DIV');
				tempArea.innerHTML = message;
				message = tempArea.textContent || tempArea.innerText || '';
				message = message.replace('  ', ' ');
				message = message.replace(/&nbsp;/g, '\u00a0');
				return message;
			}

			function updateLastPosition () {

				if (window.getSelection && window.getSelection().getRangeAt) {

					var selectedObj = window.getSelection();
					var childNodes;

					if (selectedObj.anchorNode.nodeType === 1) {
						childNodes = selectedObj.anchorNode.childNodes;
					} else {
						childNodes = selectedObj.anchorNode.parentNode.childNodes;
					}

					var range = window.getSelection().getRangeAt(0);
					var rangeCount = 0;

					for (var i = 0; i < childNodes.length; i++) {
						if (childNodes[i] === selectedObj.anchorNode) {
							break;
						}
						if (childNodes[i].outerHTML) {
							rangeCount += childNodes[i].outerHTML.length;
						} else if (childNodes[i].nodeType === 3) {
							rangeCount += childNodes[i].textContent.length;
						}
					}

					scope.payslipNotesOptions.input.currentPosition = range.startOffset + rangeCount;
				}
			}

			ngModel.$render = function () {

				var payslipNote = ngModel.$viewValue;
			    if (payslipNote && payslipNote.length > 1) {
			    	for (var x = 0; x < payslipNote.split('{{').length+1; x++) {
				    	for (var i = 0; i < PAYSLIP_NOTE_OPTIONS.tags.length; i++) {
				    		var tagId = moment().valueOf();
				    		var html = '<div data-type="tag" id="'+ tagId +'" contenteditable="false" class="payslip-notes_option-tag payslip-notes_option-tag-tag '+PAYSLIP_NOTE_OPTIONS.tags[i].optionTheme+'">' + PAYSLIP_NOTE_OPTIONS.tags[i].optionLabel + '</div>';
					        payslipNote = payslipNote.replace(new RegExp('\{\{(?:\\s+)?(' + PAYSLIP_NOTE_OPTIONS.tags[i].optionOutput + ')(?:\\s+)?\}\}'), html);
				    	}
			    	}
				}
				element.html($sanitize(payslipNote) || '');
			};

			scope.$on('payslip-notes-added-tag', function (event, options) {

				addTagToPayslipNote(options.tag, options.theme);
			});

			element.bind('input paste', function (event) {

				var lengthOfMessage = getLengthOfPayslipNote(element[0].textContent);
				if (lengthOfMessage > scope.payslipNotesOptions.input.maxLength) {
					scope.payslipNotesOptions.teamMember.isValid = false;
					if (event.which !== 8) {
						event.preventDefault();
					}
				} else {
					scope.payslipNotesOptions.teamMember.isValid = true;
					scope.payslipNotesOptions.teamMember.payslipNote = $sanitize(element.html());
					if (event.which !== 8) {
						scope.payslipNotesOptions.input.currentPosition++;
					} else {
						scope.payslipNotesOptions.input.currentPosition--;
					}
				}
			});

			element.bind('keydown', function (event) {

				const allowedKeys = [
					KEY_CODES.enter,
					KEY_CODES.leftArrow,
					KEY_CODES.upArrow,
					KEY_CODES.rightArrow,
					KEY_CODES.downArrow,
				];
				
				if (allowedKeys.includes(event.which)) {
					updateLastPosition();
				}
			});

			element.bind('click', function (event) {

				if (event.srcElement.dataset.type === 'tag') {
					placeCursorAfterTag(event.srcElement);

				} else {
					clearDefaultPayslipNote();
					updateLastPosition();
				}
			});

			scope.$watch('payslipNotesOptions.formState', function (formState) {

				if (formState === 'menu') {
					element[0].focus();
					placeCursorAfterTag(false);
					clearDefaultPayslipNote();
					updateLastPosition();
				}
			}, true);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('pcKeypress', ['KEY_CODES', function (KEY_CODES) {

	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {

			if (!angular.isDefined($attrs.pcKeypressKey)) {
				console.error('pc-keypress-key="" needs to be defined to enable keypress');
				return;
			}

			if (!angular.isDefined($attrs.pcKeypressAction)) {
				console.error('pc-keypress-action="" needs to be defined to enable keypress');
				return;
			}

			var keyCode = KEY_CODES[$attrs.pcKeypressKey];

			if (!angular.isDefined(keyCode)) {
				console.error('Key code provided was not recognised');
				return;
			}

			$element.bind('keydown keypress', function (event) {

				if (event.which === keyCode) {
					
					event.preventDefault();

					$scope.$apply(function () {
	                    $scope.$eval($attrs.pcKeypressAction);
	                });
				}
			});
		}
	};
}]);
'use strict';

/**
 * Exact same definition as ngSwitchWhen except for the link fn to allow expressions to be used
 */
angular.module('paycircleApp')
.directive('pcSwitchWhen', function () {

	return {
		priority: 1200,
		transclude: 'element',
		require: '^ngSwitch',
		link: function (scope, element, attrs, ctrl, $transclude) {

			var caseStms = scope.$eval(attrs.pcSwitchWhen);

			caseStms = angular.isArray(caseStms) ? caseStms : [caseStms];

			angular.forEach(caseStms, function (caseStm) {
				caseStm = '!' + caseStm;
				ctrl.cases[caseStm] = ctrl.cases[caseStm] || [];
				ctrl.cases[caseStm].push({ transclude: $transclude, element: element });
			});
		}
	};
});

'use strict';

angular.module('paycircleApp')
.directive('selectOnClick', ['$timeout', function($timeout) {
    return {
        link: function (scope, element) {
        	element.bind('click', function () {
                $timeout(function(){
                	element[0].select();
                },0);
            });
        }
    };
}]);

'use strict';

angular.module('paycircleApp')
.directive('tooltip', [function () {
	return {
		restrict: 'A',
		templateUrl: 'scripts/directives/templates/tooltip.html',
		scope: {
			tooltipIcon: '@?',
			tooltipIconTheme: '@?',
			tooltipPosition: '@',
			tooltipText: '@',
			tooltipTheme: '@'
		},
		transclude: true,
		link: function ($scope) {
			// TODO: move to components
			$scope.position = $scope.tooltipPosition ? $scope.tooltipPosition : undefined;
			$scope.tooltipText = $scope.tooltipText.replace('<br>', '/n');
			$scope.showTooltip = angular.isDefined($scope.tooltipText) && $scope.tooltipText !== '';
		}
	};
}]);

'use strict';

/**
 * @ngdoc directive
 * @name paycircleApp.directive:pc-inert
 * @description angularjs directive wrapper for inert.
 * When inert is set, child elements are unable to receive focus via mouse or keyboard. Used typically in conjunction with
 * an overlay to ensure background elements aren't interactive.
 */
angular.module('paycircleApp')
.directive('pcInert', [
	function () {

	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {

			// Watch pcInert expression and add / remove inert attribute on element as required
			$scope.$watch($attrs.pcInert, (setInert) => {
				if (setInert) {
					$element.attr('inert', true);
				}
				else {
					$element.removeAttr('inert');
				}
			});
		}
	};
}]);

'use strict';

/**
 * @ngdoc directive
 * @name paycircleApp.directive:comparedto
 * @description
 * Directive: compared-to.
 * Validate one field value against another. Optionally specify compared-to-mode (as one of the COMPARED_TO_MODES values) as follows:
 * checkEqual - ensure fields have the same values. Default.
 * checkNotEqual - ensure fields have different values.
 */
angular.module('paycircleApp')

.constant('COMPARED_TO_MODES', {
	checkEqual: 'checkEqual',
	checkNotEqual: 'checkNotEqual'
})

.directive('comparedTo', [
	'COMPARED_TO_MODES',
function(
	COMPARED_TO_MODES
) {
   return {
		require: 'ngModel',
		scope: {
			comparedTo: '=',
			comparedToMode: '=?'
		},
		link: function ($scope, _element, _attrs, $ctrl) {

			if (angular.isUndefined($scope.comparedToMode)) {
				$scope.comparedToMode = COMPARED_TO_MODES.checkEqual;
			}

			function compareValues (value1, value2, returnValue) {

				// Do check based on mode
				let compareToCheck;
				if ($scope.comparedToMode === COMPARED_TO_MODES.checkEqual) {
					compareToCheck = value1 === value2;
				}
				else {
					compareToCheck = value1 !== value2;
				}

				$ctrl.$setValidity('comparison', compareToCheck);
				/* There can be a lingering parse error when inputs match. This happens when the comparison input is
					changed to not match the original, then the original updated to be the same. Smells like a bug.
					Since, as long as the input matches, the comparison field *has* to be valid by virtue of any input
					restictions on the other field, this should be OK. */
				if (compareToCheck) {
					$ctrl.$setValidity('parse', true);
				}
				return returnValue;
			}

			// Allow empty compared-to for conditional comparison. If empty, no comparison.
			if (angular.isDefined($scope.comparedTo)) {

				$ctrl.$parsers.push(function (viewValue) {

					return compareValues(viewValue, $scope.comparedTo, viewValue);
				});

				$scope.$watch('comparedTo', function (newValue, oldValue) {

					if (newValue !== oldValue) {

						compareValues(newValue, $ctrl.$viewValue, $ctrl.$viewValue);
					}
				});
			}
		}
   };
}]);
'use strict';

angular.module('paycircleApp')
.directive('date', ['config', 'REGEX', function (config, REGEX) {
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {
			ctrl.$validators.date = function (modelValue) {

				var date = moment(modelValue, config.dateFormatPrimary);

				// // Ignore empty values
				// if (modelValue === undefined || modelValue === '') {
				// 	return true;
				// }

				// // Consider empty models to be valid
				// if (!date.isValid()) {
				// 	return false;
				// }

				// Regex pattern matching
				if (!REGEX.date.test(date._i)) {
					return false;
				}

				// // Minimum date
				// if (scope.mindate !== undefined && scope.mindate !== '') {

				// 	var minDate = moment(scope.mindate, config.dateFormatPrimary);

				// 	if (minDate.isValid() && date.isBefore(minDate)) {
				// 		return false;
				// 	}
				// }

				// // Maximum date
				// if (scope.maxdate !== undefined && scope.maxdate !== '') {

				// 	var maxDate = moment(scope.maxdate, config.dateFormatPrimary);

				// 	if (maxDate.isValid() && date.isAfter(maxDate)) {
				// 		return false;
				// 	}
				// }

				return true;
			};
		}
	};
}]);
'use strict';

/**
 * Directive: disable-autocomplete
 * Use: disable-autocomplete or disable-autocomplete="true" to disable autocomplete.
 * 		disable-autocomplete="false" to enable autocomplete.
 */
angular.module('paycircleApp')
.directive('disableAutocomplete', [
	'utilities',
function (
	utilities
) {
	return {

		link: function ($scope, $element, $attrs) {

			// Get disable-autocomplete attribute value
			const disableAutocomplete = $scope.$eval($attrs.disableAutocomplete);
			// Get disable-autocomplete input type attribute value
			const disableAutocompleteInputType = $attrs.type;

			/* If set, generate a unique autocomplete attribute, which should ensure the field isn't auto-filled.
			   Otherwise turn autocomplete on. */
			let disableAutocompleteAttr = '';
			// disable-autocomplete can be used without a value, which equates to 'true'
			if (angular.isUndefined(disableAutocomplete) || disableAutocomplete) {
				if (disableAutocompleteInputType === 'password') {
					disableAutocompleteAttr = 'new-password';
				}
				else {
					disableAutocompleteAttr = `nope-${utilities.guid()}`;
				}
			}
			else {
				disableAutocompleteAttr = 'on';
			}

			// Set autocomplate attribute on element
			$element.attr('autocomplete', disableAutocompleteAttr);
		}
	};
}]);
'use strict';

/**
 * @ngdoc directive
 * @name paycircleApp.directive:postcode
 * @description
 * # postcode
 */
angular.module('paycircleApp')
.directive('postcode', ['utilities', function (utilities) {
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {

			ctrl.$validators.postcode = function (modelValue) {
				
				// Consider empty models to be valid
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				// Is it a valid postcode?
				if (!utilities.isValidPostcode(modelValue)) {
					return false;
				}

				return true;
			};
		}
	};
}]);
'use strict';

/**
 * Attribute directive: not-empty-guid
 * Add to any input element or custom component bound to a model to ensure that an empty guid
 * isn't valid input. This is typically useful when an empty guid is returned by the API that
 * effectively represents a null value. Inputs marked as 'required' will behave as if an empty
 * guid is valid. This directive circumvents that problem. e.g:
 *
 * 	<extended-radio
 *		ng-model="$ctrl.group.GroupID"
 *		ng-repeat="group in $ctrl.groups"
 *	    ng-required="true"
 *		name="{{group.GroupID}}"
 *		value="group.GroupID"
 *		not-empty-guid
 *	>
 *  	...
 *  </extented-radio>
 */
angular.module('paycircleApp')
.directive('notEmptyGuid', [
	'config',
function (
	config
) {
	return {
		require: 'ngModel',
		link: function (_scope, _element, _attrs, ctrl) {

			ctrl.$validators.notemptyguid = function (modelValue) {

				if (modelValue === config.guidEmpty) {
					return false;
				}

				return true;
			};
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.directive('notzero', [function () {
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {
			ctrl.$validators.notzero = function (modelValue) {

				if (modelValue === 0) {
					return false;
				}

				return true;
			};
		}
	};
}]);
'use strict';

angular.module('paycircleApp')

.constant('POLICY_CODE_EXISTS', 'policy-code-exists')

.directive('policyCodeExists', [
	'$q',
	'$timeout',
	'companyData',
	'POLICY_CODE_EXISTS',
function (
	$q,
	$timeout,
	companyData,
	POLICY_CODE_EXISTS
) {

	return {
		require: 'ngModel',
		link: function (scope, _element, attrs, modelCtrl) {

			modelCtrl.$asyncValidators.policycodeexists = function (policyCode) {

				const agencyProfileId = scope.$eval(attrs.policyCodeExistsAgencyProfileId);
				const policyId = scope.$eval(attrs.policyCodeExistsPolicyId);
				const policyType = scope.$eval(attrs.policyCodeExistsPolicyType);

				// Keep reference to the original value, so 'changing' back to the original is OK
				if (!modelCtrl.originalPolicyCode) {
					modelCtrl.originalPolicyCode = scope.$eval(attrs.policyCodeExistsOriginal);
				}

				return $q((resolve, reject) => {

					// If original matches current, that's OK
					if (policyCode === modelCtrl.originalPolicyCode) {
						$timeout(() => {
							modelCtrl.$setValidity(POLICY_CODE_EXISTS, true);
						}, 0);
						resolve();
					}
					else {
						// Use API to check existence of policy code within the same policy type category
						companyData.getPolicyCodeUnique(agencyProfileId, policyId, policyCode, policyType).then(policyCodeUnique => {

							if (policyCodeUnique) {
								// Set valid on field and resolve
								$timeout(() => {
									modelCtrl.$setValidity(POLICY_CODE_EXISTS, true);
								}, 0);
								resolve();
							}
							else {
								// Set invalid on field and reject
								$timeout(() => {
									modelCtrl.$setValidity(POLICY_CODE_EXISTS, false);
								}, 0);
								reject();
							}
						});
					}
				});
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.constant('POLICY_NAME_EXISTS', 'policy-name-exists')

.constant('POLICY_NAME_TYPE_REQUIRED', 'policy-name-type-required')

.directive('policyNameExists', [
	'$q',
	'$timeout',
	'companyData',
	'POLICY_NAME_EXISTS',
	'POLICY_NAME_TYPE_REQUIRED',
function (
	$q,
	$timeout,
	companyData,
	POLICY_NAME_EXISTS,
	POLICY_NAME_TYPE_REQUIRED
) {

	return {
		require: 'ngModel',
		link: function (scope, _element, attrs, modelCtrl) {

			modelCtrl.$asyncValidators.policynameexists = function (policyName) {

				const agencyProfileId = scope.$eval(attrs.policyNameExistsAgencyProfileId);
				const policyId = scope.$eval(attrs.policyNameExistsPolicyId);
				const policyType = scope.$eval(attrs.policyNameExistsPolicyType);

				// Keep reference to the original value, so 'changing' back to the original is OK
				if (!modelCtrl.originalPolicyName) {
					modelCtrl.originalPolicyName = scope.$eval(attrs.policyNameExistsOriginal);
				}

				return $q((resolve, reject) => {

					// If original matches current, that's OK
					if (policyName === modelCtrl.originalPolicyName) {
						$timeout(() => {
							modelCtrl.$setValidity(POLICY_NAME_EXISTS, true);
							modelCtrl.$setValidity(POLICY_NAME_TYPE_REQUIRED, true);
						}, 0);
						resolve();
					}
					// If policy type is not yet selected, prompt user to select one
					else if (policyType === undefined || policyType === null) {
						$timeout(() => {
							modelCtrl.$setValidity(POLICY_NAME_EXISTS, true);
							modelCtrl.$setValidity(POLICY_NAME_TYPE_REQUIRED, false);
						}, 0);
						reject();
					}
					else {
						// Use API to check existence of policy name within the same policy type category
						companyData.getPolicyNameUnique(agencyProfileId, policyId, policyName, policyType).then(policyNameUnique => {

							if (policyNameUnique) {
								// Set valid on field and resolve
								$timeout(() => {
									modelCtrl.$setValidity(POLICY_NAME_EXISTS, true);
									modelCtrl.$setValidity(POLICY_NAME_TYPE_REQUIRED, true);
								}, 0);
								resolve();
							}
							else {
								// Set invalid on field and reject
								$timeout(() => {
									modelCtrl.$setValidity(POLICY_NAME_EXISTS, false);
									modelCtrl.$setValidity(POLICY_NAME_TYPE_REQUIRED, true);
								}, 0);
								reject();
							}
						});
					}
				});
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.constant('POST_IDENTIFIER_UNIQUE', 'post-identifier-unique')

.directive('postIdentifierUnique', [
	'$q',
	'$timeout',
	'payrollData',
	'POST_IDENTIFIER_UNIQUE',
function (
	$q,
	$timeout,
	payrollData,
	POST_IDENTIFIER_UNIQUE
) {

	return {
		require: 'ngModel',
		link: function (scope, _element, attrs, modelCtrl) {

			modelCtrl.$asyncValidators.postidentifierunique = function (postIdentifier) {

				const agencyProfileId = scope.$eval(attrs.postIdentifierUniqueAgencyProfileId);
				const userId = scope.$eval(attrs.postIdentifierUniqueUserId);

				// Keep reference to the original value, so 'changing' back to the original is OK
				if (!modelCtrl.originalPostIdentifierUnique) {
					modelCtrl.originalPostIdentifierUnique = scope.$eval(attrs.postIdentifierUniqueOriginal);
				}

				// Disable form
				$timeout(() => {
					modelCtrl.$setValidity(POST_IDENTIFIER_UNIQUE, false);
				}, 0);

				return $q((resolve, reject) => {

					// If original matches current, that's OK
					if (postIdentifier === modelCtrl.originalPostIdentifierUnique || postIdentifier === '') {
						$timeout(() => {
							modelCtrl.$setValidity(POST_IDENTIFIER_UNIQUE, true);
						}, 0);
						resolve();
					}
					else {

						// Use API to check existence of policy name
						payrollData.getSalaryPolicyPostReferenceUnique(agencyProfileId, userId, postIdentifier)
							.then(postIdentifierUnique => {

								if (postIdentifierUnique) {
									// Set valid on field and resolve
									$timeout(() => {
										modelCtrl.$setValidity(POST_IDENTIFIER_UNIQUE, true);
									}, 0);
									resolve();
								}
								else {
									// Set invalid on field and reject
									$timeout(() => {
										modelCtrl.$setValidity(POST_IDENTIFIER_UNIQUE, false);
									}, 0);
									reject();
								}
							});
					}
				});
			};
		}
	};
}]);

'use strict';


angular.module('paycircleApp')
.directive('ssoidExists', [
	'$q',
	'$timeout',
	'config',
	'securityData',
function (
	$q,
	$timeout,
	config,
	securityData
) {

	return {
		require: 'ngModel',
		link: function (scope, _element, attrs, ngModelCtrl) {

			ngModelCtrl.$asyncValidators.ssoidexists = function (ssoId) {

				const userId = angular.isDefined(attrs.ssoidExistsUserId) ? config.guidEmpty : scope.$eval(attrs.ssoidExistsUserId);
				const agencyProfileId = scope.$eval(attrs.ssoidExistsAgencyProfileId);
				const originalSsoId = scope.$eval(attrs.ssoidExistsOriginal);

				// Keep hold of the original value for comparison
				if (!ngModelCtrl.originalValue) {
					ngModelCtrl.originalValue = originalSsoId;
				}

				// Ignore if the 'new' SSO ID is the same as the original
				if (ssoId === ngModelCtrl.originalValue) {
					return $q.when();
				}

				const deferred = $q.defer();

				securityData.getOIDCIDExists(agencyProfileId, userId, ssoId).then(ssoidExists => {

					if (ssoidExists === 0) {
						// Set valid on field and resolve
						$timeout(() => {
							ngModelCtrl.$setValidity('ssoid-exists', true);
						}, 0);
						deferred.resolve();
					}
					else {
						// Set invalid on field and reject
						$timeout(() => {
							ngModelCtrl.$setValidity('ssoid-exists', false);
						}, 0);
						deferred.reject();
					}
				});

				return deferred.promise;
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('usernameexists', ['$q', 'userData', function ($q, userData) {
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {
			ctrl.$asyncValidators.usernameexists = function (username) {

				var contactId 			= scope.$eval(attrs.usernameexistsId);
				var originalUsername 	= scope.$eval(attrs.usernameexistsOriginal);
				var userId 				= scope.$eval(attrs.usernameexistsUserId);

				// Ignore if empty email
				if (ctrl.$isEmpty(username)) {
					return $q.when();
				}

				// Update stored original value
				if (!ctrl.originalValue) {
					ctrl.originalValue = originalUsername;
				}

				// Ignore if same as the original email
				if (username === ctrl.originalValue) {
					return $q.when();
				}

				var def = $q.defer();

				userData.getUsernameExists(username, contactId, userId).then(function (isUsernameInUse) {

					// Username already in use
					if (isUsernameInUse) {
						def.reject();
					}

					else {
						def.resolve();
					}
				});

				return def.promise;
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.constant('USERNAME_CHECK_TYPES', {
	failOnUsernameExists: 'failOnUsernameExists',
	failOnUsernameNotExists: 'failOnUsernameNotExists'
})

.directive('usernameCheck', [
	'$q',
	'userData',
	'USERNAME_CHECK_TYPES',
function (
	$q,
	userData,
	USERNAME_CHECK_TYPES
) {
	return {
		require: 'ngModel',
		scope: {
			/*
			 *	username-check-type: One of USER_NAME_CHECK_TYPES:
			 *		failOnUsernameExists: Valdation fails if the username exists.
			 *		failOnUsernameNotExists: Validation fails if the username doesn't exist.
			 *  Optional, defaults to failOnUsernameExists.
			 */
			usernameCheckType: '<?'
		},
		link: ($scope, _element, _attrs, $ngModelCtrl) => {
			$ngModelCtrl.$asyncValidators.usernameCheck = (username) => {

				// Ignore if empty username
				if ($ngModelCtrl.$isEmpty(username)) {
					return $q.when();
				}

				// Update stored previous value to shortcut check, attach to model controller
				if (!$ngModelCtrl.originalUsername) {
					$ngModelCtrl.originalUsername = username;
				}

				// Ignore if same as the previous
				if (username === $ngModelCtrl.originalUsername) {
					return $q.when();
				}

				return $q((resolve, reject) => {
					userData.getUsernameExists(
						username
					)
					.then(usernameExists => {
						// Resolve / reject based on whether username exists + check type
						if (usernameExists) {
							$scope.usernameCheckType === USERNAME_CHECK_TYPES.failOnUsernameNotExists ? resolve() : reject();
						}
						else {
							$scope.usernameCheckType === USERNAME_CHECK_TYPES.failOnUsernameNotExists ? reject() : resolve();
						}
					});
				});
			};
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('adjustmentGroupEntryDescription', [function () {

	return function (adjustmentGroupEntryObj) {

		if (adjustmentGroupEntryObj.IsSalarySacrifice) {
			return 'Salary Sacrifice';
		}

		return `${adjustmentGroupEntryObj.Taxable ? 'Taxable' : 'Non-taxable'} ${adjustmentGroupEntryObj.IsDeduction ? 'deduction' : 'addition'}`;

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('adjustmentValue', [
	'$filter',
	function (
		$filter
	) {

	return function (adjustmentObj, adjustmentOptionsObj, monetiseOptionsObj) {

		const FILTER_OPTIONS = angular.extend({
			IS_OVERRIDE_APPLICABLE: true
		}, adjustmentOptionsObj);

		// Unify response objects (Payroll > Current Period & Supplementary Pay Runs)
		function unifyAdjustmentObj (adjustmentObj) {

			// Deduction
			if (angular.isDefined(adjustmentObj.AdjustmentDeduction)) {
				adjustmentObj.Deduction = adjustmentObj.AdjustmentDeduction;
			}

			// Value
			if (angular.isDefined(adjustmentObj.AdjustmentValue)) {
				adjustmentObj.Value = adjustmentObj.AdjustmentValue;
			}
		}

		unifyAdjustmentObj(adjustmentObj);

		//..Values are monetised at their absolute value as we provide a prefix to indicate whether the adjustment is a positive or negative value.
		const monetisedValue = $filter('monetise')(Math.abs(adjustmentObj.Value), null, null, monetiseOptionsObj);
		const monetisedRecurringValue = $filter('monetise')(Math.abs(adjustmentObj.RecurringValue), null, null, monetiseOptionsObj);
		let prefix = adjustmentObj.Deduction ? '-' : '+';

		//..Some scenarios such as backdating can result in a deduction being a positive value or an addition being a negative value.
		//..In these scenarios, the prefix is reversed to ensure the adjustment value is displayed with the correct sign.
		if (adjustmentObj.Deduction) {
			prefix = adjustmentObj.Value < 0 ? '+' : '-';
		} else {
			prefix = adjustmentObj.Value > 0 ? '+' : '-';
		}

		if (FILTER_OPTIONS.IS_OVERRIDE_APPLICABLE && adjustmentObj.IsPeriodOverride) {
			return `${prefix}${monetisedRecurringValue}`;
		}

		return `${prefix}${monetisedValue}`;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('adjustmentValueTypeCalculation', ['$filter', 'config', 'utilities', 'ADJUSTMENT_VALUE_TYPES', function ($filter, config, utilities, ADJUSTMENT_VALUE_TYPES) {
	return function (adjustmentObj, adjustmentOptionsObj, monetiseOptionsObj) {

		const FILTER_OPTIONS = angular.extend({
			IS_OVERRIDE_APPLICABLE: true
		}, adjustmentOptionsObj);

		function getCurrencyConversionString (adjustmentObj) {

			if (!adjustmentObj.AdjustmentHasCurrency) {
				return '';
			}

			// Unit based
			switch (adjustmentObj.ValueType) {
				case ADJUSTMENT_VALUE_TYPES.linked:
				case ADJUSTMENT_VALUE_TYPES.percentage:
				case ADJUSTMENT_VALUE_TYPES.unit:
					return ` (${adjustmentObj.AdjustmentForeignUnitValue} ${adjustmentObj.AdjustmentCurrencyLabel} Ex. ${adjustmentObj.AdjustmentCurrencyValue})`;
			}

			// Everything else
			return ` (${adjustmentObj.AdjustmentForeignValue} ${adjustmentObj.AdjustmentCurrencyLabel} Ex. ${adjustmentObj.AdjustmentCurrencyValue})`;
		}

		// Unify response objects (Payroll > Current Period & Supplementary Pay Runs)
		function unifyAdjustmentObj (adjustmentObj) {

			// Units
			if (angular.isDefined(adjustmentObj.AdjustmentUnits)) {
				adjustmentObj.Units = adjustmentObj.AdjustmentUnits;
			}

			// Unit value
			if (angular.isDefined(adjustmentObj.AdjustmentUnitValue)) {
				adjustmentObj.UnitValue = adjustmentObj.AdjustmentUnitValue;
			}

			// Unit value multiplier
			if (angular.isDefined(adjustmentObj.AdjustmentUnitValueMultiplier)) {
				adjustmentObj.UnitValueMultiplier = adjustmentObj.AdjustmentUnitValueMultiplier;
			}

			// Net to gross
			if (angular.isDefined(adjustmentObj.AdjustmentNetToGross)) {
				adjustmentObj.NetToGross = adjustmentObj.AdjustmentNetToGross;
			}
		}

		unifyAdjustmentObj(adjustmentObj);

		const isPeriodOverride = FILTER_OPTIONS.IS_OVERRIDE_APPLICABLE && adjustmentObj.IsPeriodOverride;
		const monetisedUnitValue = $filter('monetise')(adjustmentObj.UnitValue, config.precision.salaryRates, null, monetiseOptionsObj);
		const monetisedRecurringUnitValue = $filter('monetise')(adjustmentObj.RecurringUnitValue, config.precision.salaryRates, null, monetiseOptionsObj);
		const currencyConversionString = getCurrencyConversionString(adjustmentObj);

		switch (adjustmentObj.ValueType) {

			// Absolute
			case ADJUSTMENT_VALUE_TYPES.absolute: {

				// Net to Gross
				if (adjustmentObj.NetToGross) {
					return `(Net)${currencyConversionString}`;
				}

				return currencyConversionString;
			}

			// Percentage
			case ADJUSTMENT_VALUE_TYPES.percentage: {

				if (isPeriodOverride) {
					return `(${adjustmentObj.RecurringUnits}% x ${monetisedRecurringUnitValue}${currencyConversionString})`;
				}

				return `(${adjustmentObj.Units}% x ${monetisedUnitValue}${currencyConversionString})`;
			}

			// Unit
			case ADJUSTMENT_VALUE_TYPES.unit: {

				if (isPeriodOverride) {
					return `(${adjustmentObj.RecurringUnits} x ${monetisedRecurringUnitValue})`;
				}

				return (adjustmentObj.Units > 0 && adjustmentObj.UnitValue > 0) ?`(${adjustmentObj.Units} x ${monetisedUnitValue}${currencyConversionString})` : '' ;
			}

			// Linked
			case ADJUSTMENT_VALUE_TYPES.linked: {

				if (isPeriodOverride) {
					return `(${adjustmentObj.RecurringUnits} @ ${monetisedRecurringUnitValue} x ${adjustmentObj.RecurringUnitValueMultiplier})`;
				}

				return (adjustmentObj.Units > 0 && adjustmentObj.UnitValue > 0) ? `(${adjustmentObj.Units} @ ${monetisedUnitValue} x ${adjustmentObj.UnitValueMultiplier}${currencyConversionString})` : '';
			}
		}

		return '';
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('bacsDisbursementPaymentDescription', ['disbursementService', function (disbursementService) {
	return function (disbursementObj, isSummary) {

		return disbursementService.getBACSPaymentTypeDescription(disbursementObj, isSummary);
	};
}]);

'use strict';

/**
 * Descriptor for backdated salary calculation method
 * Used in both pay information form, when applying backdated salary adjustments and when editing the applied adjustment in the adjustments list
 * Note: The calculation method value comes from 3 subtly different properties:
 * 
 * Pay Information form:
 * 	- CalculationMethod
 * 	- StarterCalculationMethod
 * 
 * Backdated salary form:
 * 	- BackdatedSalaryCalculationMethod
 * 
 **/

angular.module('paycircleApp')
.filter('backdatedSalaryCalculationDescription', [
	'BACKDATED_SALARY_CALCULATION_METHODS',
	function (
		BACKDATED_SALARY_CALCULATION_METHODS
	) {

	return function (calculationMethod, isNewStarter, forename) {

		// Default to false
		isNewStarter = angular.isDefined(isNewStarter) ? isNewStarter : false;

		// New starter
		if (isNewStarter) {

			switch (calculationMethod) {

				// Apply to current period
				case BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod: {
					return 'Calculations will be applied to the current period only, and added to your current period as a gross adjustment.';
				}

				// Apply as backdated calculation
				case BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation: {
					return 'Calculations will be applied to all affected pay periods, and added to your current period as a gross adjustment.';
				}
			}
		}

		// Active profile
		switch (calculationMethod) {

			// Apply to current period
			case BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod: {
				return 'The backdated correction will be added to your current period as a gross adjustment.';
			}

			// Apply as backdated calculation
			case BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation: {
				return `The backdated correction will alter ${forename}’s year to date position, and will be added to your current period as a net adjustment.`;
			}
		}

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('bacsIncludedPaymentsDescription', ['$filter', 'BACS_PAYMENT_TYPES', function ($filter, BACS_PAYMENT_TYPES) {
	return function (bacsIncludedPaymentsKey) {

		let descriptions = [];
		let pensionCount = 0;

		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.aoe)) { descriptions.push('AoE orders'); }
		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.childcare)) { descriptions.push('Childcare vouchers'); }
		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.hmrc)) { descriptions.push('HMRC'); }

		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.pension1)) { pensionCount++; }
		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.pension2)) { pensionCount++; }
		if ($filter('bitwiseCompare')(bacsIncludedPaymentsKey, BACS_PAYMENT_TYPES.pension3)) { pensionCount++; }

		if (pensionCount === 1) {
			descriptions.push('Pension');
		} else if (pensionCount > 1) {
			descriptions.push('Pensions');
		}

		if (descriptions.length) {
			return descriptions.join(', ');
		}

		return 'None';

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('bankFileFormatDescription', ['BANK_FILE_FORMATS', function (BANK_FILE_FORMATS) {
	return function (bankFileFormatKey) {

		switch (bankFileFormatKey) {
			case BANK_FILE_FORMATS.bacs:
				return 'BACS';
			case BANK_FILE_FORMATS.fps:
				return 'FPS';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('bankLogoUrl', [
	function () {

	return function (bankFile) {

		if (bankFile && bankFile.BankFileLogoUrl) {
			return bankFile.BankFileLogoUrl;
		}

		return 'images/graphics/empty.png';
	};
}]);

'use strict';

angular.module('paycircleApp')

.filter('yesNo', function () {

	return boolean => {

		if (boolean) {
			return 'Yes';
		}

		return 'No';
	};
});

'use strict';

angular.module('paycircleApp')
.filter('bitwiseCompare', function () {
	return (value, compareValue) => (value & compareValue) > 0;
});

'use strict';

angular.module('paycircleApp')
.filter('businessCategoryPlural', [function () {

	return function (businessCategoryName) {

		switch (businessCategoryName) {
			case 'Branch':
				return 'branches';
		}

		return `${businessCategoryName}s`;
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('businessCategorySortByDescription', [
	'BUSINESS_CATEGORY_SORT_BY_OPTIONS',
	function (
		BUSINESS_CATEGORY_SORT_BY_OPTIONS
	) {

	return function (sortByKey) {

		const sortByDescriptionObj = BUSINESS_CATEGORY_SORT_BY_OPTIONS.find(sortByOption => sortByOption.id === sortByKey);

		if (!angular.isObject(sortByDescriptionObj)) {
			throw('businessCategorySortByDescription: Unable to match sort by ID');
		}

		return sortByDescriptionObj.name;
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('businessSectorDescription', ['BUSINESS_SECTORS', function (BUSINESS_SECTORS) {
	return function (businessSector) {

		switch (businessSector) {
			case BUSINESS_SECTORS.agriculture:
				return 'Employer is in the agriculture sector';
			case BUSINESS_SECTORS.fisheriesAqua:
				return 'Employer is in the fisheries and aquaculture sector';
			case BUSINESS_SECTORS.roadTransport:
				return 'Employer is in the road transport sector';
			case BUSINESS_SECTORS.industrial:
				return 'Employer is in the industrial sector';
			case BUSINESS_SECTORS.none:
				return 'State aid rules do not apply to Employer';
		}

		return 'Undefined';
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('cacheBust', [
	'config',
	function (
		config
	) {

		return function (urlString) {

			if (
				!config.isCacheBustEnabled ||
				!urlString ||
				urlString === '' ||
				urlString === undefined
			) {
				return urlString;
			}

			// Adjust query separator if search query already exists in string
			const urlConstruct = new URL(urlString);
			let querySeparator = '?';
			if (urlConstruct && urlConstruct.search) {
				querySeparator = '&';
			}

			return urlString + querySeparator + new Date().getTime();
		};
}]);

'use strict';

angular.module('paycircleApp')
.filter('calculationMethodDescription', ['CALCULATION_METHODS', function (CALCULATION_METHODS) {
	return function (calculationMethodId) {

		const calculationMethodObj = CALCULATION_METHODS.find(calculationMethodObj => calculationMethodObj.key === calculationMethodId);

		return calculationMethodObj ? calculationMethodObj.description : 'Unknown';
	};
}]);

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:capitalise
 * @function
 * @description Takes a string and capitalises the first character
 * # capitalise
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('capitalise', [function () {
	return function (str) {
		return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('cemify', [function () {
	return function (theme) {

		switch (theme) {
			case 'primary':
				return 'is-primary';
			case 'primary-light':
				return 'is-primary-light';
			case 'secondary':
				return 'is-secondary';
			case 'tertiary':
				return 'is-tertiary';
			case 'quarternary':
				return 'is-quarternary';
			case 'greyscale':
				return 'is-greyscale';
			case 'positive':
				return 'is-positive';
			case 'indifferent':
				return 'is-indifferent';
			case 'assertive':
				return 'is-assertive';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('checkEmpty', ['config', function (config) {
	return function (property, text) {

		if (property === '') {
			return text !== undefined ? text : config.defaultEmptyText;
		}

		return property;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('cisBusinessType', ['BUSINESS_TYPES', function (BUSINESS_TYPES) {

	return function (cisBusinessTypeId) {

		switch (cisBusinessTypeId) {
			case BUSINESS_TYPES.soletrader:
				return 'Sole Trader';
			case BUSINESS_TYPES.partnership:
				return 'Partnership';
			case BUSINESS_TYPES.trust:
				return 'Trust';
			case BUSINESS_TYPES.company:
				return 'Limited Company';
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('companyDetails', ['applicationService', 'companyService', 'COMPANY_STATES', function (applicationService, companyService, COMPANY_STATES) {

	return function (companyObj, isPaycircleUser, isCompanyLiteAdmin) {

		const isPayrollCompany = companyService.isPayrollCompany(companyObj);

		angular.extend(companyObj, {
			companyType: companyService.getCompanyTypeByInterfaceType(companyObj.CompanyType),
			isBillingEnabled: (companyObj.IsBillingEnabled && companyObj.State === COMPANY_STATES.live) || (companyObj.AgencyProfileDummy && isPaycircleUser),
			isPayrollCompany: isPayrollCompany,
			isIntegrationsEnabled: isPayrollCompany && companyObj.State === COMPANY_STATES.live,
			ngHref: {
				payroll: applicationService.getNgHrefForCompany(companyObj, 'payroll', isCompanyLiteAdmin)
			}
		});

		return companyObj;
	};
}]);

'use strict';

/**
 * @description Takes a customisation object and cachebusts the logo urls
 */
angular.module('paycircleApp')
.filter('customisation', ['$filter', function ($filter) {
	return function (customisationObj) {

		customisationObj.Login.LogoURL = $filter('cacheBust')(customisationObj.Login.LogoURL);
		customisationObj.Emails.LogoURL = $filter('cacheBust')(customisationObj.Emails.LogoURL);
		customisationObj.LogoUrls.Icon = $filter('cacheBust')(customisationObj.LogoUrls.Icon);
		customisationObj.Payslips.LogoURL = $filter('cacheBust')(customisationObj.Payslips.LogoURL);
		customisationObj.SideBar.LogoURL = $filter('cacheBust')(customisationObj.SideBar.LogoURL);

		return customisationObj;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('desymbolise', function () {

	return function (value) {

		if (!value) {
			return;
		}

		// Replace % with string
		value = value.replace(/[%]/g, 'percent');

		// Remove brackets ()
		value = value.replace(/[()]/g, '');

		return value;
	};
});
'use strict';

angular.module('paycircleApp')
.filter('docDeadlineDate', [function () {

	return function (pensionStartDateIso) {

		var pensionStartDateMoment = moment(pensionStartDateIso);

		return pensionStartDateMoment.add(5, 'months').format();
	};
}]);

'use strict';

angular.module('paycircleApp')

.filter('agenextbirthday', function () {
	return function (date) {

		if (!date || date === undefined) {
			return 'unknown';
		}

		var dateFrom = moment(date).endOf('day'); // Date
		var dateTo = moment().endOf('day'); // today
		var differenceInYears = dateTo.diff(dateFrom, 'years');

		return differenceInYears > 0 ? differenceInYears + 1 : null;
	};
});

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:calendar
 * @function
 * @description Takes a date and passes it through moment.js to output a calendar format. E.g. Today, Tomorrow
 * # calendar
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('calendar', ['config', function (config) {
	return function (date) {
		return moment(date, config.dateFormatPrimary).calendar();
	};
}]);

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:dateformat
 * @function
 * @description Takes a date in ISO format yyyy-MM-DDTHH:MM:SS and can output in various formats
 * # custom
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('dateformat', function () {
	return function (date, format, customFormat) {

		if (date === '' || date === undefined || !date) {
			return '';
		}

		var momentDate = moment(date);

		if (format === 'custom') {
			return momentDate.format(customFormat);
		}

		switch (format) {
			case 'calendar':
				return momentDate.calendar();
			case 'dateTime':
				return momentDate.format('DD/MM/YY [ at ] h:mma');
			case 'dateTimeAlt':
				return momentDate.format('ddd D MMM [at] HH:mm');
			case 'day':
				return momentDate.format('D');
			case 'dayOfMonth':
				return momentDate.format('ddd');
			case 'dayMonth':
				return momentDate.format('D MMM');
			case 'dayMonthFull':
				return momentDate.format('D MMMM');
			case 'dayFullMonth':
				return momentDate.format('ddd Do MMM');
			case 'dayMonthYear':
				return momentDate.format('D MMM YYYY');
			case 'fromNow':
				return momentDate.fromNow(customFormat !== undefined ? customFormat : false);
			case 'full':
				return momentDate.format('D MMMM YYYY');
			case 'longWithShortMonth':
				return momentDate.format('dddd Do MMM YYYY');
			case 'long':
				return momentDate.format('dddd Do MMMM, YYYY');
			case 'monthDate':
				return momentDate.format('MMM D');
			case 'monthYear':
				return momentDate.format('MMMM YYYY');
			case 'numeric':
                return momentDate.format('DD/MM/YYYY');
            case 'numericShortYear':
				return momentDate.format('DD/MM/YY');
            case 'ordinal':
            	return momentDate.format('Do');
			case 'shortReadable':
				return momentDate.format('Do MMM YYYY');
			case 'time':
				return momentDate.format('h.mma');
			case 'timeDate':
				return momentDate.format('h.mma [ on ] D MMM YYYY');
			case 'timeDate24':
				return momentDate.format('HH:mm [ on ] D MMM YYYY');
			case 'timeDayDate':
				return momentDate.format('h:mma [on] ddd D MMM, YYYY');
			case 'unix':
				return momentDate.format('x');
			default:
				return momentDate.format('D MMM YYYY');
		}
	};
});

'use strict';

angular.module('paycircleApp')
.filter('datetimeformat', function () {
	return function (date, format, customFormat) {

		var momentDate = moment(date);

		if (format === 'custom') {
			return momentDate.format(customFormat);
		}

		switch (format) {
			case 'fromNow':
				return momentDate.fromNow();
			case 'time12':
				return momentDate.format('h:mma');
			case 'long':
				return momentDate.format('ddd D MMM @ HH:mm');
			case 'long-alt':
				return momentDate.format('D MMM [at] HH:mm');
			case 'readable':
				return momentDate.format('HH:mm on D MMM YYYY');
			case 'detailed':
				return momentDate.format('h:mma on ddd D MMM, YYYY');
			default:
				return momentDate.format('dddd Do MMMM, YYYY @ h:mma');
		}
	};
});

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:day
 * @function
 * @description Takes a date and passes it through moment.js to output a day format. E.g. Today, Tomorrow
 * # day
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('day', ['config', function (config) {
	return function (date) {
		return moment(date, config.dateFormatPrimary).format('D');
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('dayByIndex', function () {
	return function (index) {

		const DAY_LABELS = {
			0: 'Mon',
			1: 'Tue',
			2: 'Wed',
			3: 'Thu',
			4: 'Fri',
			5: 'Sat',
			6: 'Sun'
		};

		return DAY_LABELS[index];
	};
});

'use strict';

angular.module('paycircleApp')

.filter('daysaway', function () {
	return function (dateTo, dateFrom) {

		var a = moment(dateTo).endOf('day'); // Date to
		var b = dateFrom !== undefined ? moment(dateFrom).startOf('day') : moment().startOf('day'); // Date from

		return a.diff(b, 'days');
	};
});
'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:days
 * @function
 * @description Takes a date and returns the difference between now and then by days/weeks/months/years
 * # days
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')

.filter('diff', ['config', function (config) {
	return function (dateTo, dateFrom, type) {
		
		var a = dateFrom !== undefined ? moment(dateFrom, config.dateFormatPrimary).startOf('day') : moment().startOf('day'); // Now
		var b = moment(dateTo, config.dateFormatPrimary).endOf('day'); // Date

		type = type !== undefined ? type : 'days'; // Default to days

		return b.diff(a, type);
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('duration', ['dateService', function (dateService) {

	return function (minutes, useFullLabel) {

		const durationObj = dateService.getDurationDetailFromMinutes(minutes);

		function getLabelForTimePeriod (timePeriod, value) {

			if (value === 0) {
				return '';
			}

			switch (timePeriod) {
				case 'days':
					return `${value} ${useFullLabel ? `day${value > 1 ? 's' : ''}` : 'd'}`;

				case 'hours':
					return `${value} ${useFullLabel ? `hour${value > 1 ? 's' : ''}` : 'h'}`;

				case 'minutes':
					return `${value} ${useFullLabel ? `minute${value > 1 ? 's' : ''}` : 'm'}`;
			}
		}

		return `${getLabelForTimePeriod('days', durationObj.days)} ${getLabelForTimePeriod('hours', durationObj.hours)} ${getLabelForTimePeriod('minutes', durationObj.minutes)}`;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('isoUnix', ['config', function () {
	return function (date) {
		return moment(date).format('x');
	};
}]);

'use strict';


angular.module('paycircleApp')
.filter('period', ['PAY_PERIOD_TYPES', function (PAY_PERIOD_TYPES) {
	return function (date, periodType) {

		date = moment(date);
		switch (periodType) {
			case PAY_PERIOD_TYPES.weekly:
				date.add(1, 'w');
				break;
			case PAY_PERIOD_TYPES.fortnightly:
				date.add(2, 'w');
				break;
			case PAY_PERIOD_TYPES.fourweekly:
				date.add(4, 'w');
				break;
			case PAY_PERIOD_TYPES.monthly:
				date.add(1, 'M');
				break;
			case PAY_PERIOD_TYPES.quarterly:
				date.add(3, 'M');
				break;
			case PAY_PERIOD_TYPES.annually:
				date.add(1, 'Y');
				break;
			case PAY_PERIOD_TYPES.biannually:
				date.add(6, 'M');
				break;
		}

		return date.subtract(1, 'days').format();

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('simple', ['config', function (config) {
	return function (date, isoFormat) {
		return isoFormat ? moment(date).format('D MMM YYYY') : moment(date, config.dateFormatPrimary).format('D MMM YYYY');
	};
}]);

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:calendar
 * @function
 * @description Takes a date and passes it through moment.js to output a unix (milliseconds) format - good for sorting by date
 * # unix
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('unix', ['config', function (config) {
	return function (date) {
		return moment(date, config.dateFormatPrimary).format('x');
	};
}]);

'use strict';

// Accepts an ISO date and returns the difference from now in years (e.g. age)
angular.module('paycircleApp')

.filter('yearsold', function () {
	return function (date) {

		if (!date || date === undefined) {
			return 'unknown';
		}

		var dateFrom = moment(date).endOf('day'); // Date
		var dateTo = moment().startOf('day'); // today
		var differenceInYears = dateTo.diff(dateFrom, 'years');

		return differenceInYears > 0 ? differenceInYears : null;
	};
});

'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:abbrNum
 * @function
 * @description
 * # Abbreviates a number to a set number of decimal places - E.g. 10000.00 --> 10k
 * Filter in the paycircleApp.
 */
angular.module('paycircleApp')
.filter('abbrNum', [function () {

	return function (number, decPlaces) {

		decPlaces = decPlaces !== undefined ? decPlaces : 2;

		// 2 decimal places => 100, 3 => 1000, etc
		decPlaces = Math.pow(10,decPlaces);

		// Enumerate number abbreviations
		var abbrev = [ 'k', 'm', 'b', 't' ];

		// Go through the array backwards, so we do the largest first
		for (var i = abbrev.length-1; i >= 0; i--) {

			// Convert array index to "1000", "1000000", etc
			var size = Math.pow(10,(i+1)*3);

			// If the number is bigger or equal do the abbreviation
			if (size <= number) {
				 // Here, we multiply by decPlaces, round, and then divide by decPlaces.
				 // This gives us nice rounding to a particular decimal place.
				 number = Math.floor(number*decPlaces/size)/decPlaces;

				 // Handle special case where we round up to the next abbreviation
				 if ((number === 1000) && (i < abbrev.length - 1)) {
					 number = 1;
					 i++;
				 }

				 // Add the letter for the abbreviation
				 number += abbrev[i];

				 // We are done... stop
				 break;
			}
		}

		return number;
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('decimalise', ['utilities', function (utilities) {

	return function (number, precision) {

		if (angular.isUndefined(precision)) {
			precision = 2;
		}
		return utilities.decimalize(number, precision);
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('formatDecimal', [
	'utilities',
function (
	utilities
) {

	/**
	 * @param {number} number - number to format
	 * @param {number} precision - number of decimal places to show. Optional, defaults to 2.
	 * @param {boolean} hideMantissaInsignificant - hide insignificant digits in the mantissa part of the decimal. Optional,
	 * defaults to false.
	 * @param {boolean} applyDefaultCurrencyPrefix - apply default currency prefix (£). Optional. Defaults to false.
	 */
	return function (number, precision, hideMantissaInsignificant, applyDefaultCurrencyPrefix) {

		if (angular.isUndefined(precision)) {
			precision = 2;
		}
		if (angular.isUndefined(hideMantissaInsignificant)) {
			hideMantissaInsignificant = false;
		}
		let prefix = '';
		if (applyDefaultCurrencyPrefix) {
			prefix = '£';
		}

		// Behaviour documented in utilities.formatNumber
		return `${prefix}${utilities.formatDecimal(number, precision, hideMantissaInsignificant)}`;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('fixedLength', function () {
	return function (n, len) {

		var num = parseInt(n, 10);

		len = parseInt(len, 10);

		if (isNaN(num) || isNaN(len)) {
			return n;
		}

		num = '' + num;

		while (num.length < len) {
			num = '0' + num;
		}

		return num;
	};
});
'use strict';

angular.module('paycircleApp')
.filter('monetise', [
	'utilities',
	function (
		utilities
	) {
	return function (input, round, format, monetiseOptionsObj) {

		const DEFAULT_CURRENCY_LABEL = '£';

		const FILTER_OPTIONS = {
			CURRENCY_LABEL: monetiseOptionsObj && monetiseOptionsObj.CURRENCY_LABEL ? monetiseOptionsObj.CURRENCY_LABEL : DEFAULT_CURRENCY_LABEL,
			CURRENCY_VALUE: monetiseOptionsObj && monetiseOptionsObj.CURRENCY_VALUE ? monetiseOptionsObj.CURRENCY_VALUE : null,
			HIDE_CURRENCY_LABEL: monetiseOptionsObj && monetiseOptionsObj.HIDE_CURRENCY_LABEL ? monetiseOptionsObj.HIDE_CURRENCY_LABEL : false
		};

		// Attach space after custom label
		if (FILTER_OPTIONS.CURRENCY_LABEL !== DEFAULT_CURRENCY_LABEL) {
			FILTER_OPTIONS.CURRENCY_LABEL = FILTER_OPTIONS.CURRENCY_LABEL + ' ';
		}

		// Currency conversion
		if (FILTER_OPTIONS.CURRENCY_VALUE) {
			input = input / FILTER_OPTIONS.CURRENCY_VALUE;
		}

		// Hide current label (false by default)
		if (FILTER_OPTIONS.HIDE_CURRENCY_LABEL) {
			FILTER_OPTIONS.CURRENCY_LABEL = '';
		}

		switch (format) {
			case 'signed': {
				let prefix = '';
				if (input < 0) {
					prefix = '-';
				}
				else if (input > 0) {
					prefix = '+';
				}

				return `${prefix}${FILTER_OPTIONS.CURRENCY_LABEL}${utilities.decimalize(Math.abs(input), round)}`;
			}
			default:
				return `${FILTER_OPTIONS.CURRENCY_LABEL}${utilities.decimalize(input, round)}`;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('monetisedown', ['utilities', function (utilities) {
	return function (input) {
		return '£' + utilities.decimalize(input, 'down');
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('positive', [function () {
	return function(value) {
		if (!value) {
			return 0;
		}

		return Math.abs(value);
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('companyTypeDescription', ['INTERFACE_TYPES', function (INTERFACE_TYPES) {
	return function (companyTypeId) {

		switch (companyTypeId) {
			case INTERFACE_TYPES.agency:
				return 'agency';
			case INTERFACE_TYPES.bureau:
				return 'bureau';
			case INTERFACE_TYPES.group:
				return 'group';
			default:
				return 'company';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('documentTypeLabel', ['DOCUMENT_TYPES', function (DOCUMENT_TYPES) {
	return function (documentType) {

		switch (documentType) {
			case DOCUMENT_TYPES.payslipManagerFullRun:
			case DOCUMENT_TYPES.payslipManagerSupplementaryRun:
				return 'XML';
			default:
				return 'CSV';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('earningsLimitDisregardDescription', ['PENSION_GROUP_EARNINGS_LIMITS', function (PENSION_GROUP_EARNINGS_LIMITS) {
	return function (bankFileFormatKey) {

		switch (bankFileFormatKey) {
			case PENSION_GROUP_EARNINGS_LIMITS.notSet:
				return 'Not set';
			case PENSION_GROUP_EARNINGS_LIMITS.lowerEarningsLimit:
				return 'Lower earnings limit disregarded';
			case PENSION_GROUP_EARNINGS_LIMITS.upperEarningsLimit:
				return 'Upper earnings limit disregarded';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('emojify', ['REGEX', function (REGEX) {

	const EMOJI_PREFIX = 'emoji';
	const EMOJI_BRACKET = '%';
	const EMOJI_SPLIT = ',';

	function convertUnicodeToCharacter (unicodeString) {
		return String.fromCodePoint(parseInt(unicodeString, 16));
	}

	function convertCharacterToUnicode (character) {
		return character.codePointAt().toString(16);
	}

	function convertStringIntoEmojiString (string) {
		return EMOJI_PREFIX + EMOJI_BRACKET + string + EMOJI_BRACKET;
	}

	function getEmojiFromUnicode (unicodeString) {

		if (unicodeString.split(' ').length > 1) {

			let codeString = [];

			for (let emojiCode of unicodeString.split(' ')) {
				codeString.push(parseInt(emojiCode, 16));
			}

			return String.fromCodePoint(...codeString);

		} else {
			return String.fromCodePoint(parseInt(unicodeString.replace(/ /g, '-'), 16));
		}
	}

	function replaceEmojisWithEmojiString (string) { // Returns string from emoji. Eg "🙂" => emoji%1f642% and "👩‍👩‍👧" => emoji%1f469,200d,1f469,200d,1f467%

		let emojiArray = string.match(REGEX.emojis);

		if (!emojiArray || !emojiArray.length) {
			return string;
		}

		for (let emoji of emojiArray) {

			if (emoji.length <= 2) { // If emoji is single character, eg: "🙂"

				// Convert emoji to unicode
				let emojiUnicode = convertCharacterToUnicode(emoji);

				// Replace emoji in string with wrapped unicode. Eg: emoji%1f642%
				string = string.replace(emoji, convertStringIntoEmojiString(emojiUnicode));

			} else { // If emoji is group, eg: "👩‍👩‍👧"

				let emojiUnicodeArr = [];

				// Split emoji group out into separate emojis and convert each one to unicode. Eg: "👩‍👩‍👧" => ["1f469", "200d", "1f469", "200d", "1f467"]
 				for (let emojiUnicode of emoji) {
					emojiUnicodeArr.push(convertCharacterToUnicode(emojiUnicode));
				}

				// Replace emoji in string with wrapped unicode. Eg: emoji%1f469,200d,1f469,200d,1f467%
				string = string.replace(emoji, convertStringIntoEmojiString(emojiUnicodeArr.join(EMOJI_SPLIT)));
			}

		}

		return string;
	}

 	function replaceEmojiStringsWithEmojis (string) { // Returns string from emoji. Eg emoji%1f642% => "🙂" and emoji%1f469,200d,1f469,200d,1f467% => "👩‍👩‍👧"

 		if (!string.length || !string.includes(EMOJI_PREFIX+EMOJI_BRACKET)) {
 			return string;
 		}

 		// Create regex to find emoji strings in string using prefix and brackets
 		let regex = new RegExp(`${EMOJI_PREFIX}\\${EMOJI_BRACKET}+([\A-Za-z0-9,\s]+)${EMOJI_BRACKET}`, 'g');

 		for (let emojiString of string.match(regex)) {

 			// Remove prefix and brackers from string
 			let emojiUnicodeString = emojiString.replace(EMOJI_PREFIX, '').replace(new RegExp (EMOJI_BRACKET, 'g'), '');

 			if (emojiUnicodeString.indexOf(EMOJI_SPLIT) === -1) { // If emoji is single character, eg: "🙂"

 				// Convert unicode to emoji
	 			let emoji = convertUnicodeToCharacter(emojiUnicodeString);

	 			// Replace emoji string with emoji
	 			string = string.replace(emojiString, emoji);

 			} else { // If emoji is group, eg: "👩‍👩‍👧"

 				// Convert string of unicode characters to array
 				let emojiUnicodeArr = emojiUnicodeString.split(EMOJI_SPLIT);

 				// Convert each unicode item in array to an emoji
 				emojiUnicodeArr.forEach((emojiUnicode, index) => {
 					emojiUnicodeArr[index] = convertUnicodeToCharacter(emojiUnicode);
 				});

 				// Combine emojis to create group emoji. Eg: ["👨", "‍", "👩", "‍", "👧"] => "👨‍👩‍👧"
 				let emoji = emojiUnicodeArr.reduce((emojiOne, emojiTwo) => emojiOne + emojiTwo);

 				// Replace emoji string with emoji
	 			string = string.replace(emojiString, emoji);
 			}
 		}

 		return string;
 	}

	return function (string, format) {

		switch (format) {
			case 'codeToString':
				return getEmojiFromUnicode(string);

			case 'demojify':
				return replaceEmojisWithEmojiString(string);

			default:
				return replaceEmojiStringsWithEmojis(string);
		}
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('employmentTypeDescription', ['EMPLOYMENT_TYPES', function (EMPLOYMENT_TYPES) {
	return function (employmentType) {

		switch (employmentType) {
			case EMPLOYMENT_TYPES.standard:
				return 'Standard pattern';
			case EMPLOYMENT_TYPES.nonStandard:
				return 'Non-standard pattern';
			case EMPLOYMENT_TYPES.netPay:
				return 'Net pay';
			case EMPLOYMENT_TYPES.paidHourly:
				return 'Paid hourly';
			case EMPLOYMENT_TYPES.payPolicy:
				return 'Pay policy';
		}

		return 'Unknown payment type';
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('fileSize', function () {
	return function (fileSizeBytes, toFixedAmount) {

		// Set default for characters behind bullet points
		toFixedAmount = angular.isDefined(toFixedAmount) ? toFixedAmount : 1;

		if (isNaN(fileSizeBytes)) {
			fileSizeBytes = 0;
		}

		if (fileSizeBytes < 1024) {
			return fileSizeBytes + ' bytes';
		}

		fileSizeBytes /= 1024;

		if (fileSizeBytes < 1024) {
			return fileSizeBytes.toFixed(toFixedAmount) + 'Kb';
		}

		fileSizeBytes /= 1024;

		if (fileSizeBytes < 1024) {
			return fileSizeBytes.toFixed(toFixedAmount) + 'Mb';
		}

		fileSizeBytes /= 1024;

		if (fileSizeBytes < 1024) {
			return fileSizeBytes.toFixed(toFixedAmount) + 'Gb';
		}

		fileSizeBytes /= 1024;

		return fileSizeBytes.toFixed(toFixedAmount) + 'Tb';
	};

});

'use strict';

angular.module('paycircleApp')
.filter('nominalEntryCategoryTheme', [
	'GROUP_ENTRY_CATEGORIES',
	function (
		GROUP_ENTRY_CATEGORIES
	) {

	return function (category) {

		switch (category) {
			case GROUP_ENTRY_CATEGORIES.additions.key:
				return 'is-secondary';
			case GROUP_ENTRY_CATEGORIES.deductions.key:
				return 'is-assertive';
			case GROUP_ENTRY_CATEGORIES.calculated.key:
				return 'is-primary';
			default:
				return {};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('hmrcBankDetails', ['HMRC_PAYMENT_ACCOUNTS', function (HMRC_PAYMENT_ACCOUNTS) {
	return function (hmrcBankAccountInt) {
		return HMRC_PAYMENT_ACCOUNTS.find(paymentAccountObj => paymentAccountObj.id === hmrcBankAccountInt).displayLong;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('hmrcCredentials', [function () {

	return function (hmrcCredentials) {

		hmrcCredentials = hmrcCredentials.replace(/~/g, '/');

		return hmrcCredentials.replace(/~/g, '/');
	};
}]);

angular.module('paycircleApp')
/**
 * Returns a markedup string with <span> of specified class around matched substrings.
 * Substrings will be matched against each word of provided matching string.
 * If class is not specified, 'highlighted-text' class will be applied.
 */
.filter('highlight', [
() => (input, matcher, spanClass) => {
		let replacementText = `<span class="${spanClass || 'highlighted-text'}">$&</span>`;
		return input.replace(
			new RegExp(
				matcher
					.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&') // Escape special reg exp characters
					.replace(/(\s+)/, ' ') /* Replace any whitespace with a single 'normal' space.
											  This effectively removes any potential rogue unicode whitespace characters. */
					.split(' ') // Split search terms as entered
					.join('|'), // Combine to create regex search pattern that will match|on|each|word.
				'gi'
			),
			replacementText
		);
	}
]);

'use strict';

angular.module('paycircleApp')
.filter('hyphenate', [function () {
	return function (str) {
		return str.replace(/ /g, '-');
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('importMappingColumnTypeDescription', ['IMPORT_MAPPING_COLUMN_TYPES', function (IMPORT_MAPPING_COLUMN_TYPES) {
	return function (companyTypeId) {

		switch (companyTypeId) {
			case IMPORT_MAPPING_COLUMN_TYPES.unit:
				return 'units';
			case IMPORT_MAPPING_COLUMN_TYPES.rate:
				return 'rate';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('importMappingTypeDescription', ['IMPORT_MAPPING_TYPES', function (IMPORT_MAPPING_TYPES) {
	return function (importType, responseType) {

		/* Plural */
		function getImportMappingTypeDescriptionPlural () {
			switch (importType) {
				case IMPORT_MAPPING_TYPES.users:
					return 'Team validation (Payroll)';
				case IMPORT_MAPPING_TYPES.team:
					return 'Team validation (Team)';
				case IMPORT_MAPPING_TYPES.salaryUpdates:
					return 'Salary Updates';
				case IMPORT_MAPPING_TYPES.leavers:
					return 'Leavers';
				case IMPORT_MAPPING_TYPES.cis:
					return 'CIS information';
				case IMPORT_MAPPING_TYPES.profile:
					return 'Personal information';
				case IMPORT_MAPPING_TYPES.fps:
					return 'FPS';
				case IMPORT_MAPPING_TYPES.address:
					return 'Address details';
				case IMPORT_MAPPING_TYPES.changesTable:
					return 'Changes Table';
				case IMPORT_MAPPING_TYPES.ytd:
					return 'Year to dates';
				case IMPORT_MAPPING_TYPES.company:
					return 'Company details';
				case IMPORT_MAPPING_TYPES.bank:
					return 'Bank details';
				case IMPORT_MAPPING_TYPES.tax:
					return 'Tax details';
				case IMPORT_MAPPING_TYPES.salary:
					return 'Pay information';
				case IMPORT_MAPPING_TYPES.pension:
					return 'Pension details';
				case IMPORT_MAPPING_TYPES.all:
					return 'Import all data';
				case IMPORT_MAPPING_TYPES.payElementsRecurring:
					return 'Recurring';
				case IMPORT_MAPPING_TYPES.payElements:
				case IMPORT_MAPPING_TYPES.payElementsFixed:
					return 'Fixed amounts';
				case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
					return 'Recurring';
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
				case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
					return 'Units';
				case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
					return 'Rates & Units';
				case IMPORT_MAPPING_TYPES.payElementsDailyRate:
					return 'Daily rates & units';
				case IMPORT_MAPPING_TYPES.linkedElements:
					return 'Link rate units';
				case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
				case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
					return 'CIS fixed amounts';
				case IMPORT_MAPPING_TYPES.payslipManager:
					return 'Main pay run';
				case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
					return 'Off-payroll';
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
				case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
					return 'Off-payroll (recurring)';
				case IMPORT_MAPPING_TYPES.businessCategories:
					return 'Business categories';
				case IMPORT_MAPPING_TYPES.nominalCodes:
					return 'Nominal codes';
				case IMPORT_MAPPING_TYPES.xeroNominalCodes:
					return 'Xero nominal codes';
				case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:
					return 'Access Financials nominal accounts';
				case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
					return 'Access Financials nominal categories';
				case IMPORT_MAPPING_TYPES.linkRateUnits:
					return 'Link rate units';
				case IMPORT_MAPPING_TYPES.payslipNotes:
					return 'Payslip Notes';
				case IMPORT_MAPPING_TYPES.shifts:
					return 'Shifts';
				case IMPORT_MAPPING_TYPES.policyImport:
					return 'Pay policies';
				case IMPORT_MAPPING_TYPES.expatDetails:
					return 'Expat details';
				case IMPORT_MAPPING_TYPES.sickness:
					return 'Sick pay schedules';
				case IMPORT_MAPPING_TYPES.postsPayPolicies:
					return 'Posts & pay policies';
				case IMPORT_MAPPING_TYPES.calculatedPayHistoryImport:
					return 'Calculated pay history';
			}
		}

		/* Singular */
		function getImportMappingTypeDescriptionSingular () {
			switch (importType) {
				case IMPORT_MAPPING_TYPES.users:
					return 'Team validation (Payroll)';
				case IMPORT_MAPPING_TYPES.team:
					return 'Team validation (Team)';
				case IMPORT_MAPPING_TYPES.salaryUpdates:
					return 'Salary Update';
				case IMPORT_MAPPING_TYPES.leavers:
					return 'Leaver';
				case IMPORT_MAPPING_TYPES.cis:
					return 'CIS information';
				case IMPORT_MAPPING_TYPES.profile:
					return 'Personal information';
				case IMPORT_MAPPING_TYPES.fps:
					return 'FPS';
				case IMPORT_MAPPING_TYPES.address:
					return 'Address detail';
				case IMPORT_MAPPING_TYPES.ytd:
					return 'Year to date';
				case IMPORT_MAPPING_TYPES.company:
					return 'Company detail';
				case IMPORT_MAPPING_TYPES.bank:
					return 'Bank detail';
				case IMPORT_MAPPING_TYPES.tax:
					return 'Tax detail';
				case IMPORT_MAPPING_TYPES.salary:
					return 'Pay information';
				case IMPORT_MAPPING_TYPES.pension:
					return 'Pension detail';
				case IMPORT_MAPPING_TYPES.all:
					return 'Import all data';
				case IMPORT_MAPPING_TYPES.payslipManager:
					return 'Main pay run';
				case IMPORT_MAPPING_TYPES.businessCategories:
					return 'Business category';
				case IMPORT_MAPPING_TYPES.nominalCodes:
					return 'Nominal code';
				case IMPORT_MAPPING_TYPES.xeroNominalCodes:
					return 'Xero nominal code';
				case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:
					return 'Access Financials nominal account';
				case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
					return 'Access Financials nominal category';
				case IMPORT_MAPPING_TYPES.payslipNotes:
					return 'Payslip Note';
				case IMPORT_MAPPING_TYPES.shifts:
					return 'Shift';
				case IMPORT_MAPPING_TYPES.policyImport:
					return 'Pay policy';
				case IMPORT_MAPPING_TYPES.expatDetails:
					return 'Expat detail';
				case IMPORT_MAPPING_TYPES.sickness:
					return 'Sick pay schedule';
				case IMPORT_MAPPING_TYPES.postsPayPolicies:
					return 'Post & Pay Policy';
				case IMPORT_MAPPING_TYPES.calculatedPayHistoryImport:
					return 'Calculated pay history';
				default:
					return getImportMappingTypeDescriptionPlural();
			}
		}

		switch (responseType) {
			case 'singular':
				return getImportMappingTypeDescriptionSingular();
			default:
				return getImportMappingTypeDescriptionPlural();
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('importMappingTypeIcon', ['IMPORT_MAPPING_TYPES', function (IMPORT_MAPPING_TYPES) {
	return function (importType) {

		switch (importType) {
			case IMPORT_MAPPING_TYPES.profile:
				return 'icon-setup-user';
			case IMPORT_MAPPING_TYPES.address:
				return 'icon-team-alt';
			case IMPORT_MAPPING_TYPES.company:
				return 'icon-company';
			case IMPORT_MAPPING_TYPES.salary:
			case IMPORT_MAPPING_TYPES.salaryUpdates:
				return 'icon-wallet';
			case IMPORT_MAPPING_TYPES.tax:
				return 'icon-tax-code-change';
			case IMPORT_MAPPING_TYPES.ytd:
				return 'icon-calendar';
			case IMPORT_MAPPING_TYPES.bank:
				return 'icon-bank';
			case IMPORT_MAPPING_TYPES.pension:
				return 'icon-money';
			case IMPORT_MAPPING_TYPES.team:
				return 'icon-team-alt';
			case IMPORT_MAPPING_TYPES.cis:
				return 'icon-cis';
			case IMPORT_MAPPING_TYPES.changesTable:
			case IMPORT_MAPPING_TYPES.payElements:
			case IMPORT_MAPPING_TYPES.payElementsRecurring:
			case IMPORT_MAPPING_TYPES.payElementsFixed:
			case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
			case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
			case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
			case IMPORT_MAPPING_TYPES.payElementsDailyRate:
			case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
			case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
				return 'icon-fixed-value';
			case IMPORT_MAPPING_TYPES.payslipNotes:
				return 'icon-chat';
			case IMPORT_MAPPING_TYPES.payslipManager:
				return 'icon-payslip';
			case IMPORT_MAPPING_TYPES.businessCategories:
			case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
			case IMPORT_MAPPING_TYPES.nominalCodes:
			case IMPORT_MAPPING_TYPES.xeroNominalCodes:
			case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:
			case IMPORT_MAPPING_TYPES.policyImport:
				return 'icon-csv';
			case IMPORT_MAPPING_TYPES.expatDetails:
				return 'icon-international';
			case IMPORT_MAPPING_TYPES.sickness:
				return 'icon-sick';
			case IMPORT_MAPPING_TYPES.postsPayPolicies:
				return 'icon-company';
			case IMPORT_MAPPING_TYPES.calculatedPayHistoryImport:
				return 'icon-history';
			default:
				return 'icon-question-mark';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('importPayElementRateType', [
	'IMPORT_RATE_TYPES',
	function (
		IMPORT_RATE_TYPES
	) {

	return function (rateType, responseType) {

		/* Description */
		function getRateTypeDescription () {
			switch (rateType) {
				case IMPORT_RATE_TYPES.calculatedHourly:
					return 'This will use the calculated hourly rate for salaried team members, and the \'Standard hourly rate\' for hourly paid team members.';
				case IMPORT_RATE_TYPES.calculatedDaily:
					return 'This will use the calculated daily rate for salaried team members only. Hourly paid team members will be ignored.';
				case IMPORT_RATE_TYPES.overtimeHourly:
					return 'This will use the overtime hourly rate for salaried team members, and the \'Standard hourly rate\' for hourly paid team members.';
				case IMPORT_RATE_TYPES.overtimeDaily:
					return 'This will use the overtime daily rate for salaried team members only. Hourly paid team members will be ignored.';
			}
		}

		/* Label */
		function getRateTypeLabel () {
			switch (rateType) {
				case IMPORT_RATE_TYPES.calculatedHourly:
					return 'Calculated hourly rate';
				case IMPORT_RATE_TYPES.calculatedDaily:
					return 'Calculated daily rate';
				case IMPORT_RATE_TYPES.overtimeHourly:
					return 'Overtime hourly rate';
				case IMPORT_RATE_TYPES.overtimeDaily:
					return 'Overtime daily rate';
			}
		}

		switch (responseType) {
			case 'description':
				return getRateTypeDescription();
			default:
				return getRateTypeLabel();
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('isEmptyClass', function () {
	return function (property, className) {

		if (property === '') {
			return className !== undefined ? className : 'is-empty';
		}

		return '';
	};
});

'use strict';

angular.module('paycircleApp')
.filter('journalPostIcon', [
	'SUBMISSION_STATES',
	function (
		SUBMISSION_STATES
	) {
	return function (state) {

		switch (state) {
			case SUBMISSION_STATES.unsubmitted:
				return 'icon-minus-alt';
			case SUBMISSION_STATES.submitting:
				return 'icon-loading';
			case SUBMISSION_STATES.submitted:
				return 'icon-check';
			case SUBMISSION_STATES.failed:
				return 'icon-close';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('journalPostState', [
	'SUBMISSION_STATES',
	function (
		SUBMISSION_STATES
	) {
	return function (state) {

		switch (state) {
			case SUBMISSION_STATES.unsubmitted:
				return 'Not posted';
			case SUBMISSION_STATES.submitting:
				return 'Posting';
			case SUBMISSION_STATES.submitted:
				return 'Posted';
			case SUBMISSION_STATES.failed:
				return 'Failed';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('journalPostStateLabel', [
	'SUBMISSION_STATES',
	function (
		SUBMISSION_STATES
	) {
	return function (postObj) {

		switch (postObj.JournalPostState) {
			case SUBMISSION_STATES.unsubmitted:
				return 'Not posted yet';
			case SUBMISSION_STATES.failed:
				return 'Failed to post';
			default:
				return postObj.JournalPostSubmitAsFinal ? 'Posted to final' : 'Posted to draft';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('journalPostTheme', [
	'SUBMISSION_STATES',
	function (
		SUBMISSION_STATES
	) {
	return function (state) {

		switch (state) {
			case SUBMISSION_STATES.unsubmitted:
				return 'is-primary';
			case SUBMISSION_STATES.submitting:
				return 'is-indifferent';
			case SUBMISSION_STATES.submitted:
				return 'is-positive';
			case SUBMISSION_STATES.failed:
				return 'is-assertive inverse';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('leaveThemes', ['LEAVE_TYPE_DESCRIPTIONS', function (LEAVE_TYPE_DESCRIPTIONS) {
	return function (leaveType, isText) {

		if (isText) {
			switch (leaveType) {
				case LEAVE_TYPE_DESCRIPTIONS.annualLeave:
					return 'secondary-darkened';
				case LEAVE_TYPE_DESCRIPTIONS.specialLeave:
					return 'quarternary-dark';
				case LEAVE_TYPE_DESCRIPTIONS.sickLeave:
					return 'assertive-darkened';
				case LEAVE_TYPE_DESCRIPTIONS.unpaidLeave:
					return 'senary-darkened';
			}
		} else {
			switch (leaveType) {
				case LEAVE_TYPE_DESCRIPTIONS.annualLeave:
					return 'secondary';
				case LEAVE_TYPE_DESCRIPTIONS.specialLeave:
					return 'quarternary';
				case LEAVE_TYPE_DESCRIPTIONS.sickLeave:
					return 'assertive';
				case LEAVE_TYPE_DESCRIPTIONS.unpaidLeave:
					return 'tertiary';
			}
		}
	};
}]);

'use strict';

/**
 * @description Takes a string and makes sure it's a valid URL
 */
angular.module('paycircleApp')
.filter('linkify', [function () {
	return function (url) {

		if (url.indexOf('http://') === -1) {
			url = 'http://' + url;
		}

		return url;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('loremIpsum', [function () {
	return function (paragraphSize) {

		switch (paragraphSize) {
			case 'xs':
				return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';
			case 'small':
				return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
			case 'medium':
				return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';
			case 'long':
				return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
			default:
				return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('mailLogSummaries', ['config', '$filter', function (config, $filter) {

	return function (mailLogSummaries) {

		return mailLogSummaries.filter(function (mailLogSummary) {

			if (mailLogSummary.ContactExclude) {
				return;
			}

			// If bounced can they be resent?
			mailLogSummary.AssessmentStatusCanResend 	= false;
			mailLogSummary.ComplianceFollowUpCanResend 	= false;
			mailLogSummary.PensionIntroductionCanResend = false;
			mailLogSummary.PostponementNoticeCanResend 	= false;

			if (mailLogSummary.AssessmentStatus.length) {
				mailLogSummary.AssessmentStatus = $filter('mailLogs')(mailLogSummary.AssessmentStatus);

				if (mailLogSummary.AssessmentStatus[0].MailBounced) {
					mailLogSummary.AssessmentStatusCanResend = true;
				}
			}

			if (mailLogSummary.ComplianceFollowUp.length) {
				mailLogSummary.ComplianceFollowUp = $filter('mailLogs')(mailLogSummary.ComplianceFollowUp);

				if (mailLogSummary.ComplianceFollowUp[0].MailBounced) {
					mailLogSummary.ComplianceFollowUpCanResend = true;
				}
			}

			if (mailLogSummary.PensionIntroduction.length) {
				mailLogSummary.PensionIntroduction = $filter('mailLogs')(mailLogSummary.PensionIntroduction);

				if (mailLogSummary.PensionIntroduction[0].MailBounced) {
					mailLogSummary.PensionIntroductionCanResend = true;
				}
			}

			if (mailLogSummary.PostponementNotice.length) {
				mailLogSummary.PostponementNotice = $filter('mailLogs')(mailLogSummary.PostponementNotice);

				if (mailLogSummary.PostponementNotice[0].MailBounced) {
					mailLogSummary.PostponementNoticeCanResend = true;
				}
			}

			// nullable
			if (mailLogSummary.CeaseActiveMembershipNotice && mailLogSummary.CeaseActiveMembershipNotice.length) {
				mailLogSummary.CeaseActiveMembershipNotice = $filter('mailLogs')(mailLogSummary.CeaseActiveMembershipNotice);
			}

			if (mailLogSummary.OptOutNotice && mailLogSummary.OptOutNotice.length) {
				mailLogSummary.OptOutNotice = $filter('mailLogs')(mailLogSummary.OptOutNotice);
			}

			if (mailLogSummary.OptInJoinNotice && mailLogSummary.OptInJoinNotice.length) {
				mailLogSummary.OptInJoinNotice = $filter('mailLogs')(mailLogSummary.OptInJoinNotice);
			}

			if (mailLogSummary.ResumeActiveMembershipNotice && mailLogSummary.ResumeActiveMembershipNotice.length) {
				mailLogSummary.ResumeActiveMembershipNotice = $filter('mailLogs')(mailLogSummary.ResumeActiveMembershipNotice);
			}

			return mailLogSummary;
		});

	};

}]);
'use strict';

angular.module('paycircleApp')
.filter('mailLog', function () {

	return function (mailLog) {

		var logDateTime = moment(mailLog.MailSentDateDisplay, 'YYYY-MM-DD[T]HH:mm:ss');

		mailLog.date 			= logDateTime.format('DD/MM/YYYY');
		mailLog.dateFromNow 	= logDateTime.fromNow();
		mailLog.time 			= logDateTime.format('HH:mm');

		return mailLog;
	};
});

'use strict';

angular.module('paycircleApp')
.filter('mailLogs', ['$filter', function ($filter) {

	return function (mailLogs) {

		return mailLogs.filter(function (mailLog) {

			return $filter('mailLog')(mailLog);

		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('mailTemplate', ['MAIL_TYPES', function (MAIL_TYPES) {

	return function (mailTemplate) {

		mailTemplate.canSendManually = false;
		mailTemplate.paycircleSendsAutomatically = false;
		mailTemplate.paycircleAutomaticDate = null; // staging-date, wp-notification-date, doc-deadline

		switch (mailTemplate.MailTypeID) {
			case MAIL_TYPES.pensionIntroduction: // Pension Introduction
				mailTemplate.canSendManually = true;
				mailTemplate.paycircleSendsAutomatically = true;
				mailTemplate.paycircleAutomaticDate = 'wp-notification-date';
				break;
			case MAIL_TYPES.employeeGuide: // Employee Guide
				mailTemplate.paycircleSendsAutomatically = true;
				mailTemplate.paycircleAutomaticDate = 'wp-notification-date';
				break;
			case MAIL_TYPES.postponementNotice: // Postponement Notice
				mailTemplate.paycircleSendsAutomatically = true;
				mailTemplate.paycircleAutomaticDate = 'wp-notification-date';
				break;
			case MAIL_TYPES.assessmentStatus: // Assessment Status
				mailTemplate.paycircleSendsAutomatically = true;
				mailTemplate.paycircleAutomaticDate = 'wp-notification-date';
				break;
			case MAIL_TYPES.complianceFollowUp: // Compliance Follow-up
				mailTemplate.paycircleSendsAutomatically = true;
				mailTemplate.paycircleAutomaticDate = 'wp-notification-date';
				break;
		}

		return mailTemplate;
	};

}]);
'use strict';

angular.module('paycircleApp')
.filter('mentions', ['$filter', 'MENTION_OPTIONS', 'REGEX', function ($filter, MENTION_OPTIONS, REGEX) {

	return function (string, theme) {

		const mentionsArr = string.match(REGEX.mention);

		if (string.length > 0 && angular.isArray(mentionsArr)) {

			theme = angular.isDefined(theme) ? theme : 'is-greyscale';

	 		for (let mention of mentionsArr) {

	 			let mentionHTML = mention.replace(MENTION_OPTIONS.bracketCharacter[0], `<${MENTION_OPTIONS.selectionElementType} class="${MENTION_OPTIONS.mentionClass} ${theme}">`)
	 									 .replace(MENTION_OPTIONS.bracketCharacter[1], `</${MENTION_OPTIONS.selectionElementType}>`);

	 			string = string.replace(mention, mentionHTML);
			}
 		}

		return $filter('emojify')(string);
	};
}]);


'use strict';

angular.module('paycircleApp')
.filter('nextBirthday', function () {

	var currentYear 		= moment().format('YYYY');
	var todayM 				= moment();

	return function (dob) {

		var dobThisYearM = moment(dob).year(currentYear);

		if (dobThisYearM.isBefore(todayM)) {
			dobThisYearM.add(1, 'year');
		}

		return dobThisYearM.format();
	};

});

'use strict';

angular.module('paycircleApp')
.filter('nineMax', function () {

	return function (value) {

		return value > 9 ? '9+' : value;
	};

});

'use strict';

angular.module('paycircleApp')

.filter('nmwCalculationMethod', [
	'NMW_CALCULATION_METHODS',
	function (
		NMW_CALCULATION_METHODS
	) {

		return (nmwCalculationMethod) => {

			switch (nmwCalculationMethod) {
				case NMW_CALCULATION_METHODS.period:
					return 'Pay period';

				case NMW_CALCULATION_METHODS.annually:
					return 'Annually';
			}

			return 'Unknown NMW calculation method';
		};
}]);

'use strict';

angular.module('paycircleApp')
.filter('nmwWarning', ['$filter', 'NMW_CATEGORIES', function ($filter, NMW_CATEGORIES) {

	return function (category, amount) {

		switch (category) {
			case NMW_CATEGORIES.over22:
				return 'The National Living Wage for people over the age of 22 is ' + $filter('monetise')(amount);
			case NMW_CATEGORIES.over21:
				return 'The National Minimum Wage for people aged 21-22 is ' +  $filter('monetise')(amount);
			case NMW_CATEGORIES.over18:
				return 'The National Minimum Wage for people aged 18-20 is ' +  $filter('monetise')(amount);
			case NMW_CATEGORIES.under18:
				return 'The National Minimum Wage for people aged under 18 is ' +  $filter('monetise')(amount);
			case NMW_CATEGORIES.apprentice:
				return 'The National Minimum Wage for an apprentice is ' +  $filter('monetise')(amount);
			default:
				return null;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('p32EmailFrequency', ['P32_EMAIL_FREQUENCIES', function (P32_EMAIL_FREQUENCIES) {
	return function (paymentFrequencyInt) {

		switch (paymentFrequencyInt) {
			case P32_EMAIL_FREQUENCIES.monthly:
				return 'Monthly';

			case P32_EMAIL_FREQUENCIES.quarterly:
				return 'Quarterly';

			case P32_EMAIL_FREQUENCIES.annually:
				return 'Annually';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('payPeriodStateDescription', ['PAY_PERIOD_STATES', function (PAY_PERIOD_STATES) {
	return function (payPeriodState) {
		
		switch (payPeriodState) {
			case PAY_PERIOD_STATES.dataCollection:
				return 'Collect data';
			case PAY_PERIOD_STATES.calculate:
				return 'Calculate';
			case PAY_PERIOD_STATES.approval:
				return 'Approve';
			case PAY_PERIOD_STATES.run:
				return 'Run';
			case PAY_PERIOD_STATES.closePeriod:
				return 'Close period';
		}
	};
}]);


'use strict';

angular.module('paycircleApp')
.filter('payPeriodTypeDescription', ['PAY_PERIOD_TYPES', function (PAY_PERIOD_TYPES) {

	return function (payPeriodType, context) {

		// Validation
		var validContextValues = ['month', 'months', 'monthly'];

		// Default to first in list above
		context = context !== undefined ? context : validContextValues[0];

		// Validate
		if (!Number.isInteger(payPeriodType)) {
			return console.error('Pay period type is not an integer.');
		}

		if (validContextValues.indexOf(context) === -1) {
			console.error('Pay period type description value is not valid. Either "month", "months", "monthly" are allowed. "month" used as default');
			context = 'a';
		}

		// Turn context string into key
		switch (context) {
			case 'month':
				context = 'a';
				break;
			case 'months':
				context = 'b';
				break;
			case 'monthly':
				context = 'c';
				break;
		}

		var descriptions = {};

		switch (payPeriodType) {
			case PAY_PERIOD_TYPES.weekly:
				descriptions = {
					a: 'week',
					b: 'weeks',
					c: 'weekly'
				};
				break;
			case PAY_PERIOD_TYPES.fortnightly:
				descriptions = {
					a: 'two weeks',
					b: 'two weeks',
					c: 'two weekly'
				};
				break;
			case PAY_PERIOD_TYPES.fourweekly:
				descriptions = {
					a: 'four weeks',
					b: 'four weeks',
					c: 'four weekly'
				};
				break;
			case PAY_PERIOD_TYPES.quarterly:
				descriptions = {
					a: 'quarter',
					b: 'quarters',
					c: 'quarterly'
				};
				break;
			case PAY_PERIOD_TYPES.annually:
				descriptions = {
					a: 'year',
					b: 'years',
					c: 'yearly'
				};
				break;
			case PAY_PERIOD_TYPES.biannually:
				descriptions = {
					a: 'biannual',
					b: 'biannual',
					c: 'biannually'
				};
				break;
			default:
				descriptions = {
					a: 'month',
					b: 'months',
					c: 'monthly'
				};
		}

		return descriptions[context];
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('payPeriodsMessage', ['$filter', 'config', 'PAY_PERIOD_TYPES', function($filter, config, PAY_PERIOD_TYPES) {
	return function (string, periodDetails) {

		periodDetails = angular.copy(periodDetails);
		var periodStartDateISO = periodDetails.PeriodStartDateISO;
		var payPeriodPayslipDisplayDay = periodDetails.PayPeriodPayslipDisplayDay; // Pay date
		var payPeriodPayslipDay = periodDetails.PayPeriodPayslipDay; // Date to send pay notifications
		var payPeriodType = periodDetails.PayPeriodType;
		var payPeriodPayInArrears = periodDetails.PayPeriodPayInArrears;  // Payroll processing date in arrears
		var payPeriodPayslipDisplayDayInArrears = periodDetails.PayPeriodPayslipDisplayDayInArrears; // Pay date in arrears
		var payPeriodPayslipDayInArrears = periodDetails.PayPeriodPayslipDayInArrears; // Date to send pay notifications in arrears
		var specialOptions = periodDetails.specialOptions;
		var payDate;
		var payslipDate;
		var lastDayOfWeek;
		var stringOutput = [];

		if (!payPeriodPayslipDay || payPeriodPayslipDay === null) {
			return;
		}

		// Part 1
		if (periodDetails.hasRun) {
			stringOutput.push('Your next pay period will be');
		} else {
			stringOutput.push('Your first pay period will be');
		}
		var periodStartDate = $filter('dateformat')(periodStartDateISO, 'dayFullMonth');
		var periodEndDate = $filter('dateformat')($filter('period')(periodStartDateISO, payPeriodType), 'dayFullMonth');
		stringOutput.push('<span class="strong indifferent">' + periodStartDate + ' - ' + periodEndDate + '</span>');
		stringOutput.push('and the pay date will be');

		switch (payPeriodType) {
			case PAY_PERIOD_TYPES.monthly:
				// Part 2
				if (payPeriodPayslipDisplayDay >= -specialOptions && payPeriodPayslipDisplayDay < 0) {
					var ptTwoPeriodStartDateISO = angular.copy(periodStartDateISO);
					if (payPeriodPayslipDisplayDayInArrears) {
						ptTwoPeriodStartDateISO = moment(ptTwoPeriodStartDateISO).add(1, 'month').format(config.dateFormatISO);
					}
					switch (payPeriodPayslipDisplayDay) {
						case -5: // Last Thursday of the month
							lastDayOfWeek = moment(ptTwoPeriodStartDateISO).endOf('month').startOf('day');
							switch (lastDayOfWeek.day()) {
								case 5:
									payDate = lastDayOfWeek;
									break;
								case 6:
									payDate = lastDayOfWeek.subtract(2, 'days');
									break;
								case 5:
									payDate = lastDayOfWeek.subtract(1, 'days');
									break;
								default:
									payDate = lastDayOfWeek.subtract(lastDayOfWeek.day() + 3, 'days');
									break;
							}
							break;
						case -4: // Last Monday of the month
							payDate = moment(ptTwoPeriodStartDateISO).endOf('month').startOf('isoweek');
							break;
						case -3: // Last working day of the month
							lastDayOfWeek = moment(ptTwoPeriodStartDateISO).endOf('month');
							switch (lastDayOfWeek.day()) {
								case 0:
									payDate = lastDayOfWeek.subtract(2, 'd');
									break;
								case 6:
									payDate = lastDayOfWeek.subtract(1, 'd');
									break;
								default:
									payDate = lastDayOfWeek;
							}
							break;
						case -2: // Last Friday of the month
							lastDayOfWeek = moment(ptTwoPeriodStartDateISO).endOf('month').startOf('day');
							switch (lastDayOfWeek.day()) {
								case 6:
									payDate = lastDayOfWeek.subtract(1, 'days');
									break;
								case 5:
									payDate = lastDayOfWeek;
									break;
								default:
									payDate = lastDayOfWeek.subtract(lastDayOfWeek.day() + 2, 'days');
									break;
							}
							break;
						case -1: // Last day of the month
							payDate = moment(ptTwoPeriodStartDateISO).endOf('month');
							break;
					}
				} else {

					payDate = moment(periodStartDateISO).date(payPeriodPayslipDisplayDay);
					if (!payPeriodPayslipDisplayDayInArrears) {
						if (payDate.isBefore(periodStartDateISO)) {
							payDate.add(1, 'M');
						}
					} else {
						if (payDate.isBefore(periodStartDateISO)) {
							payDate.add(2, 'M');
						} else {
							payDate.add(1, 'M');
						}
					}
				}
				stringOutput.push('<span class="strong indifferent">' + $filter('dateformat')(payDate, 'dayFullMonth') + '</span>.');

				// Part 3
				stringOutput.push('Pay notifications will be sent to your team on');
				if (payPeriodPayslipDay >= -specialOptions && payPeriodPayslipDay < 0) {
					var ptThreePeriodStartDateISO = angular.copy(periodStartDateISO);
					if (payPeriodPayslipDayInArrears) {
						ptThreePeriodStartDateISO = moment(ptThreePeriodStartDateISO).add(1, 'month').format(config.dateFormatISO);
					}
					switch (payPeriodPayslipDay) {
						case -5: // Last Thursday of the month
							lastDayOfWeek = moment(ptThreePeriodStartDateISO).endOf('month').startOf('day');
							switch (lastDayOfWeek.day()) {
								case 5:
									payslipDate = lastDayOfWeek;
									break;
								case 6:
									payslipDate = lastDayOfWeek.subtract(2, 'days');
									break;
								case 5:
									payslipDate = lastDayOfWeek.subtract(1, 'days');
									break;
								default:
									payslipDate = lastDayOfWeek.subtract(lastDayOfWeek.day() + 3, 'days');
									break;
							}
							break;
						case -4: // last monday of the month
							payslipDate = moment(ptThreePeriodStartDateISO).endOf('month').startOf('isoweek');
							break;
						case -3: // Last working day of the month
							lastDayOfWeek = moment(ptThreePeriodStartDateISO).endOf('month');
							switch (lastDayOfWeek.day()) {
								case 0:
									payslipDate = lastDayOfWeek.subtract(2, 'd');
									break;
								case 6:
									payslipDate = lastDayOfWeek.subtract(1, 'd');
									break;
								default:
									payslipDate = lastDayOfWeek;
							}
							break;
						case -2: // Last Friday of the month
							lastDayOfWeek = moment(ptThreePeriodStartDateISO).endOf('month').startOf('day');
							switch (lastDayOfWeek.day()) {
								case 6:
									payslipDate = lastDayOfWeek.subtract(1, 'days');
									break;
								case 5:
									payslipDate = lastDayOfWeek;
									break;
								default:
									payslipDate = lastDayOfWeek.subtract(lastDayOfWeek.day() + 2, 'days');
									break;
							}
							break;
						case -1: // Last day of the mont
							payslipDate = moment(ptThreePeriodStartDateISO).endOf('month');
							break;
					}
				} else {
					payslipDate = moment(periodStartDateISO).date(payPeriodPayslipDay);
					if (payslipDate.isBefore(periodStartDateISO)) {
						payslipDate.add(1, 'M');
					}
					if (payPeriodPayInArrears || payPeriodPayslipDayInArrears) {
						payslipDate.add(1, 'M');
					}
				}
				stringOutput.push('<span class="strong indifferent">' + $filter('dateformat')(payslipDate, 'dayFullMonth') + '</span>.');

				return stringOutput.join().replace(/,/g,' ');

			case PAY_PERIOD_TYPES.weekly:

				// Part 2
				payPeriodPayslipDisplayDay = payPeriodPayslipDisplayDay === 0 ? 7 : payPeriodPayslipDisplayDay;
				payDate = moment(periodStartDateISO).day(payPeriodPayslipDisplayDay);
				if (!payPeriodPayslipDisplayDayInArrears) {
					if (payDate.isBefore(periodStartDateISO)) {
						payDate.add(1, 'w');
					}
				} else {
					if (payDate.isBefore(periodStartDateISO)) {
						payDate.add(2, 'w');
					} else {
						payDate.add(1, 'w');
					}
				}
				stringOutput.push('<span class="strong indifferent">' + $filter('dateformat')(payDate, 'dayFullMonth') + '</span>.');

				// Part 3
				stringOutput.push('Pay notifications will be sent to your team on');
				payslipDate = moment(periodStartDateISO).day(payPeriodPayslipDay);
				if (payslipDate.isBefore(periodStartDateISO)) {
					payslipDate.add(1, 'w');
				}
				if (payPeriodPayInArrears || payPeriodPayslipDayInArrears) {
					payslipDate.add(1, 'w');
				}
				stringOutput.push('<span class="strong indifferent">' + $filter('dateformat')(payslipDate, 'dayFullMonth') + '</span>.');

				return stringOutput.join().replace(/,/g,' ');
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('paymentOptionDescription', ['utilities', 'PAY_DATE_OPTIONS', 'PAY_PERIOD_TYPES', function (utilities, PAY_DATE_OPTIONS, PAY_PERIOD_TYPES) {

	function getPaymentOptionsByPayPeriodType (payPeriodType) {

		switch (payPeriodType) {
			case PAY_PERIOD_TYPES.weekly:
				return PAY_DATE_OPTIONS.weekly;
			case PAY_PERIOD_TYPES.fortnightly:
				return PAY_DATE_OPTIONS.twoweekly;
			case PAY_PERIOD_TYPES.fourweekly:
				return PAY_DATE_OPTIONS.fourweekly;
			case PAY_PERIOD_TYPES.monthly:
				return PAY_DATE_OPTIONS.monthly;
			case PAY_PERIOD_TYPES.quarterly:
				return PAY_DATE_OPTIONS.quarterly;
			case PAY_PERIOD_TYPES.annually:
				return PAY_DATE_OPTIONS.annually;
		}

		return null;
	}

	return function (payPeriodType, paymentOptionValue) {

		var paymentOptions = getPaymentOptionsByPayPeriodType(payPeriodType);

		if (!paymentOptions) {
			return 'unknown';
		}

		var paymentOptionObj = utilities.getArrayItemByPropertyName(paymentOptions, 'id', paymentOptionValue);
		
		return paymentOptionObj.name;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('paymentScheduleTypeIcon', ['REPAYMENT_SCHEDULE_TYPES', function (REPAYMENT_SCHEDULE_TYPES) {
	return function (paymentScheduleTypeId, defaultValue) {

		switch (paymentScheduleTypeId) {
			case REPAYMENT_SCHEDULE_TYPES.carBenefitInKind:
				return 'company-vehicle';
			case REPAYMENT_SCHEDULE_TYPES.healthcare:
				return 'healthcare';
			case REPAYMENT_SCHEDULE_TYPES.companyLoan:
				return 'company';
			case REPAYMENT_SCHEDULE_TYPES.cycleToWorkScheme:
				return 'cycle-to-work';
			case REPAYMENT_SCHEDULE_TYPES.healthcare:
				return 'healthcare';
			case REPAYMENT_SCHEDULE_TYPES.childcareVouchers:
			case REPAYMENT_SCHEDULE_TYPES.maternityPay:
			case REPAYMENT_SCHEDULE_TYPES.occupationalMaternityPay:
			case REPAYMENT_SCHEDULE_TYPES.occupationalPaternityPay:
			case REPAYMENT_SCHEDULE_TYPES.paternityPay:
				return 'maternity';
			case REPAYMENT_SCHEDULE_TYPES.seasonTicketLoan:
				return 'season-ticket';
			case REPAYMENT_SCHEDULE_TYPES.occupationalSickPay:
			case REPAYMENT_SCHEDULE_TYPES.sickPay:
				return 'sick';
			default:
				return angular.isDefined(defaultValue) ? defaultValue : 'question-mark';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('paymentState', ['PAYMENT_STATES', function (PAYMENT_STATES) {
	return function (paymentState, responseType) {

		/* Description */
		function getPaymentStateDescription () {

			switch (paymentState) {
				case PAYMENT_STATES.scheduled:
					return 'Scheduled';
				case PAYMENT_STATES.payingOut:
					return 'Paying Out';
				case PAYMENT_STATES.paid:
					return 'Paid';
				case PAYMENT_STATES.resubmitted:
					return 'Resubmitted';
				case PAYMENT_STATES.refunded:
					return 'Refunded';
				case PAYMENT_STATES.freePeriod:
					return 'Free';
				case PAYMENT_STATES.estimate:
					return 'Estimated';
				case PAYMENT_STATES.pending:
					return 'Pending';
				case PAYMENT_STATES.refundCancelled:
					return 'Refund Cancelled';
				case PAYMENT_STATES.cancelled:
					return 'Cancelled';
				case PAYMENT_STATES.failed:
					return 'Failed';
				default:
					return 'Unknown';
			}
		}

		/* Emoji */
		function getPaymentStateEmoji () {

			switch (paymentState) {
				case PAYMENT_STATES.failed:
					return '😩';
			}
		}

		/* Tag */
		function getPaymentStateTag () {

			switch (paymentState) {
				case PAYMENT_STATES.refundCancelled:
				case PAYMENT_STATES.cancelled:
				case PAYMENT_STATES.failed:
					return 'inverse';
			}
		}

		/* Theme */
		function getPaymentStateTheme () {

			switch (paymentState) {
				case PAYMENT_STATES.scheduled:
				case PAYMENT_STATES.payingOut:
				case PAYMENT_STATES.paid:
				case PAYMENT_STATES.resubmitted:
				case PAYMENT_STATES.refunded:
				case PAYMENT_STATES.freePeriod:
				case PAYMENT_STATES.estimate:
					return 'positive';
				case PAYMENT_STATES.pending:
					return 'indifferent';
				case PAYMENT_STATES.refundCancelled:
				case PAYMENT_STATES.cancelled:
				case PAYMENT_STATES.failed:
					return 'assertive';
			}
		}

		switch (responseType) {
			case 'emoji':
				return getPaymentStateEmoji();
			case 'tag':
				return getPaymentStateTag();
			case 'theme':
				return getPaymentStateTheme();
			default:
				return getPaymentStateDescription();
		}

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('paymentTypeDescription', ['PAYMENT_TYPES', function (PAYMENT_TYPES) {
	return function (paymentType) {

		switch (paymentType) {
			case PAYMENT_TYPES.salary:
				return 'Full Time';
			case PAYMENT_TYPES.hourly:
				return 'Hourly Pay';
			case PAYMENT_TYPES.net:
				return 'Net Pay';
			case PAYMENT_TYPES.variable:
				return 'Part Time';
		}

		return 'Unknown payment type';
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('payslipSortByDescription', [
	'PAYSLIP_SORT_BY_OPTIONS',
	function (
		PAYSLIP_SORT_BY_OPTIONS
	) {

	return function (sortByKey) {

		const sortByDescriptionObj = PAYSLIP_SORT_BY_OPTIONS.find(sortByOption => sortByOption.id === sortByKey);

		if (!angular.isObject(sortByDescriptionObj)) {
			throw('payslipSortByDescription: Unable to match sort by ID');
		}

		return sortByDescriptionObj.name;
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('pensionStateClass', ['PENSION_ENROLMENT_STATES', function (PENSION_ENROLMENT_STATES) {

	return function (pensionState) {

		switch (pensionState) {
			case PENSION_ENROLMENT_STATES.canJoin:
			case PENSION_ENROLMENT_STATES.canOptIn:
			case PENSION_ENROLMENT_STATES.willBeEnrolled:
				return 'primary';

			case PENSION_ENROLMENT_STATES.others:
			case PENSION_ENROLMENT_STATES.voluntary:
			case PENSION_ENROLMENT_STATES.optedIn:
			case PENSION_ENROLMENT_STATES.joined:
			case PENSION_ENROLMENT_STATES.enrolled:
				return 'secondary';

			case PENSION_ENROLMENT_STATES.eligible:
				return 'tertiary inverse';

			case PENSION_ENROLMENT_STATES.optedOut:
			case PENSION_ENROLMENT_STATES.ceased:
				return 'assertive';

			case PENSION_ENROLMENT_STATES.reAssessment:
				return 'indifferent-lighter';

			case PENSION_ENROLMENT_STATES.excluded:
			case PENSION_ENROLMENT_STATES.aboveAgeLimit:
			case PENSION_ENROLMENT_STATES.notAssessed:
			case PENSION_ENROLMENT_STATES.postponed:
				return 'greyscale';
		}
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('permissionRole', ['PERMISSION_ROLES', function (PERMISSION_ROLES) {
	return function (permissionRoleValue) {
		return PERMISSION_ROLES[permissionRoleValue];
	};
}]);
'use strict';

/**
* @ngdoc filter
* @name paycircleApp.filter:permissions
* @function
* @description Converts permission integer values into specific action flags
* # permissions
* Filter in the paycircleApp.
*/
angular.module('paycircleApp')
.filter('permissions', ['PERMISSION_ACTIONS', function (PERMISSION_ACTIONS) {

	return function (permissionsObj) {

		// No permissions assigned
		if (permissionsObj === undefined) {
			return null;
		}

		const permissionActionsObj = angular.copy(PERMISSION_ACTIONS);

		angular.extend(permissionActionsObj, {
			isPayrollVisible: permissionsObj.Payroll !== -1,
			isPensionVisible: permissionsObj.Pension !== -1,
			isHistoryVisible: permissionsObj.History !== -1,
			isTeamVisible: permissionsObj.Team !== -1,
			isReportingVisible: permissionsObj.Reports !== -1,
			isAdminVisible: permissionsObj.Admin !== -1,
			isCompanySettingsVisible: permissionsObj.CompanySettings !== -1,
			isHRVisible: permissionsObj.HR !== -1
		});

		// Loop over permission groups
		for (let permissionGroupObj in permissionActionsObj) {

			// Skip loop if the property is from prototype
			if (!permissionActionsObj.hasOwnProperty(permissionGroupObj)) {
				continue;
			}

			let permissionActionsGroupsArr = permissionActionsObj[permissionGroupObj];

			// Loop over permission actions
			for (let permissionActionObj in permissionActionsGroupsArr) {

				// Skip loop if the property is from prototype
				if (!permissionActionsGroupsArr.hasOwnProperty(permissionActionObj)) {
					continue;
				}

				const permissionActionsValue = angular.copy(permissionActionsGroupsArr[permissionActionObj]);
				const permissionActionValueBit = permissionActionsGroupsArr[permissionActionObj].toString();
				const permissionGroupValueBit = permissionsObj[permissionGroupObj].toString();

				// Any values below 0 have no permission
				if (permissionsObj[permissionGroupObj] <= 0) {
					permissionActionsGroupsArr[permissionActionObj] = false;
					continue;
				}

				// Update integer value to boolean
				/* jshint eqeqeq:false */
				permissionActionsGroupsArr[permissionActionObj] = permissionActionsValue == (permissionActionValueBit & permissionGroupValueBit);
				/* jshint eqeqeq:true */
			}
		}

		return permissionActionsObj;
	};

}]);

'use strict';

/**
 * @name paycircleApp.filter:personalise
 * @description A function which accepts a gender and returns a personalised description, e.g. 'he', 'his', 'himself'.
 * 				This will be returned with Title case if the context is presented in Title case.
 */
angular.module('paycircleApp')
.filter('personalise', ['utilities', function (utilities) {
	return function (gender, context) {

		// Validation
		const validContextValues = ['a', 'b', 'c', 'd', 'he', 'she', 'his', 'her', 'himself', 'herself', 'him'];

		// Default to 'a'
		context = context !== undefined ? context : 'a';

		// Keep hold of capitalisation before lowercasing context to allow case-insensitive switch below
		const isTitleCase = context.charAt(0) === context.charAt(0).toUpperCase();
		context = context.toLowerCase();

		// Allow use of 'he', 'his', 'himself' & 'him'
		switch (context) {
			case 'he':
			case 'she':
				context = 'a';
				break;
			case 'his':
			case 'her':
				context = 'b';
				break;
			case 'herself':
			case 'himself':
				context = 'c';
				break;
			case 'him':
				context = 'd';
				break;
		}

		// Validate
		if (validContextValues.indexOf(context) === -1) {
			console.error('Personalisation context value is not valid. Either "a", "b", "c", "d", "he", "his", "himself", "him" are allowed. "a" used as default');
			context = 'a';
		}

		/*
		a: they, he, she
		b: their, his, her
		c: theirself, himself, herself
		d: them, him, her
		*/
		const personalisation = {
			a: 'they',
			b: 'their',
			c: 'themselves',
			d: 'them'
		};

		// Male
		if (utilities.isMale(gender)) {
			personalisation.a = 'he';
			personalisation.b = 'his';
			personalisation.c = 'himself';
			personalisation.d = 'him';
		}

		// Female
		else if (utilities.isFemale(gender)) {
			personalisation.a = 'she';
			personalisation.b = 'her';
			personalisation.c = 'herself';
			personalisation.d = 'her';
		}

		// Capitalise the first letter if that's how the context has been presented
		if (isTitleCase) {
			Object.keys(personalisation).forEach(key => {
				personalisation[key] = personalisation[key].charAt(0).toUpperCase() + personalisation[key].substr(1);
			});
		}

		return personalisation[context];
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('prettifyRole', ['USER_ROLES', function (USER_ROLES) {

	return function (role) {

		switch (USER_ROLES[role]) {
			case USER_ROLES.bureau:
				return 'Super User';
			case USER_ROLES.bureaumanager:
				return 'Team Member';
			case USER_ROLES.groupadmin:
			case USER_ROLES.groupuser:
				return 'Group Admin';
			case USER_ROLES.groupadminlite:
				return 'Group Admin lite';
			case USER_ROLES.companyadministrator:
			case USER_ROLES.companyadmin:
			case USER_ROLES.sme:
				return 'Company Admin';
			case USER_ROLES.companyadministratorlite:
				return 'Company Admin Lite';
			case USER_ROLES.departmentadmin:
				return 'Department admin';

			case USER_ROLES.optimalcompliance:
				return 'Optimal Compliance';
			case USER_ROLES.payrollworker:
				return 'Employee';
			case USER_ROLES.paycircle:
				return 'Paycircle';
			default:
				return role;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
	.filter('removeUsedItemsById', function () {

		return function (
			optionsArr,
			objectsToCheckArr,
			objectProperty,
			currentValue
		) {

			// Returns array of options - Filtering out any that appear in existing objects more than once, unless item is the current value

			function getUsedOptions () {

				const returnArr = [];

				for (let object of objectsToCheckArr) {

					// Initial value is null, don't include that in this array
					if (object[objectProperty]) {
						returnArr.push(object[objectProperty]);
					}
				}

				return returnArr;
			}

			function getApplicableOptions () {

				function filterOutUsedOptions (option) {

					// Can only select the option onnce
					const isOptionNotAlreadyUsed = !usedOptionsArr.includes(option);

					// Keep the current value in the array as it would be removed from the dropdown otherwise
					const isOptionCurrentValue = option === currentValue;

					return isOptionNotAlreadyUsed || isOptionCurrentValue;
				}

				const usedOptionsArr = getUsedOptions();

				return optionsArr.filter(filterOutUsedOptions);
			}

			return getApplicableOptions();
		};
	});

'use strict';

angular.module('paycircleApp')
.filter('reportCategories', [
	'$rootScope',
	'REPORT_CLASSIC_CATEGORY_IDS',
	function
	(
		$rootScope,
		REPORT_CLASSIC_CATEGORY_IDS
	) {

	return function (reportsArr, filterKey) {

		function isReportCertainCategory (reportObj, reportCategory) {

			if (angular.isArray(reportCategory)) {
				return reportCategory.includes(reportObj.ReportTemplate.Category.ReportTemplateCategoryID);

			} else {
				return reportObj.ReportTemplate.Category.ReportTemplateCategoryID === reportCategory;
			}
		}

		const isCustomOrFilteredClassicReport = (reportObj, filterExp) => !reportObj.ReportTemplate.IsClassicReport || (reportObj.ReportTemplate.IsClassicReport && filterExp);

		const isCostingsReport = reportObj => isURLDownloadReport(reportObj) && isReportCertainCategory(reportObj, REPORT_CLASSIC_CATEGORY_IDS.payrollSummary);

		const isP32Report = reportObj => isURLDownloadReport(reportObj) && isReportCertainCategory(reportObj, REPORT_CLASSIC_CATEGORY_IDS.p32Report);

		const isP60Report = reportObj => isReportCertainCategory(reportObj, REPORT_CLASSIC_CATEGORY_IDS.p60);

		const isPayDashboardReport = reportObj => isReportCertainCategory(reportObj, REPORT_CLASSIC_CATEGORY_IDS.payDashboard);

		const isPayslipReport = reportObj => isReportCertainCategory(reportObj, [REPORT_CLASSIC_CATEGORY_IDS.payslip, REPORT_CLASSIC_CATEGORY_IDS.cisStatement]);

		const isPensionReport = reportObj => isURLDownloadReport(reportObj) && isReportCertainCategory(reportObj, [REPORT_CLASSIC_CATEGORY_IDS.pensionReport, REPORT_CLASSIC_CATEGORY_IDS.pensionPAPDIS]);

		const isPeriodDownloadReport = reportObj => isCustomOrFilteredClassicReport(reportObj, !isPayslipReport(reportObj) && (reportObj.CanView || reportObj.CanDownload));

		const isURLDownloadReport = reportObj => reportObj.CanDownload;

		const isPreviousPeriodDownloadReport = reportObj => isCustomOrFilteredClassicReport(reportObj, (isReportCertainCategory(reportObj, [REPORT_CLASSIC_CATEGORY_IDS.payrollSummary, REPORT_CLASSIC_CATEGORY_IDS.pensionReport]) && isPeriodDownloadReport(reportObj)));

		switch (filterKey) {
			case 'costings-url':
				return reportsArr.filter(isCostingsReport);
			case 'downloads':
				return reportsArr.filter(isPeriodDownloadReport);
			case 'downloads-minimum':
				return reportsArr.filter(isPreviousPeriodDownloadReport);
			case 'p32-url':
				return reportsArr.filter(isP32Report);
			case 'p60':
				return reportsArr.filter(isP60Report);
			case 'pay-dashboard':
				return reportsArr.filter(isPayDashboardReport);
			case 'payslip':
				return reportsArr.filter(isPayslipReport);
			case 'pension-url':
				return reportsArr.filter(isPensionReport);
			default:
				$rootScope.paycircleMessage('Report types: Missing filter key');
				return reportsArr;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('reportFilterPeriodDisplay', [
	'$filter',
	'reportsService',
	'REPORT_PERIOD_OPTION_TYPE',
	function (
		$filter,
		reportsService,
		REPORT_PERIOD_OPTION_TYPE
	) {

	return function (activePeriodOptionObj, reportRequestObj, reportRequestOptionsObj) {

		const SPACER = '&nbsp;<i class="icon-arrow-right is-normal"></i>&nbsp;';

		function getDateFromFromValue (value) {
			return $filter('dateformat')(value, 'dayMonthYear');
		}

		function getItemNameFromValue (itemsArr, value) {
			return reportsService.getReportRequestOptionsValueFromTypeOption(itemsArr, value).Name;
		}

		function getMessageForActivePeriodKey () {

			const reportRequestOptionsActivePeriodOptionObj = reportsService.getReportRequestOptionsTypeOptionForKey(reportRequestOptionsObj.PeriodOptions, activePeriodOptionObj.Key);

			switch (reportRequestOptionsActivePeriodOptionObj.Type) {

				// Single Dropdown List
				case REPORT_PERIOD_OPTION_TYPE.singleDropDownList:
					return getMessageForSingleDropdown(reportRequestOptionsActivePeriodOptionObj.Items);

				// Range Dropdown List
				case REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists:
					return getMessageForRangeDropdown(reportRequestOptionsActivePeriodOptionObj.Items);

				// Date Range
				case REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers:
					return getMessageForDateRange();
			}
		}

		function getMessageForDateRange () {

			const firstValue = activePeriodOptionObj.Values[0];
			const secondValue = activePeriodOptionObj.Values[1];

			// "1 Dec 2021 → 25 Jan 2022"
			return getDateFromFromValue(firstValue) + SPACER + getDateFromFromValue(secondValue);
		}

		function getMessageForRangeDropdown (itemsArr) {

			const firstValue = activePeriodOptionObj.Values[0];
			const secondValue = activePeriodOptionObj.Values[1];

			// "December 2021 → January 2022"
			return getItemNameFromValue(itemsArr, firstValue) + SPACER + getItemNameFromValue(itemsArr, secondValue);
		}

		function getMessageForSingleDropdown (itemsArr) {

			// "December 2021"
			let message = getItemNameFromValue(itemsArr, activePeriodOptionObj.Value);

			// Comparison Report
			if (reportRequestOptionsObj.comparisonReportCurrentPeriod) {

				// "December 2021 → January 2022"
				message += SPACER + reportRequestOptionsObj.comparisonReportCurrentPeriod.Name;
			}

			return message;
		}

		// Parse as HTML to include arrow icon
		return getMessageForActivePeriodKey();
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('reportFilterValueDisplay', [
	'reportsService',
	function (
		reportsService
	) {

	return function (reportRequestOptionsOptionObj, reportRequestOptionObj) {
		return reportsService.getReportRequestOptionsValueFromTypeOption(reportRequestOptionsOptionObj.Items, reportRequestOptionObj.Value).Name;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('reportFilterGroupClauseCount', [function () {

	return function (reportTemplateFilterGroupObj) {

		// Return count of child clauses in filter group

		let clauseCount = 0;

		function countChildClauses (reportFilterGroupObj) {

			clauseCount += reportFilterGroupObj.ChildReportTemplateFilterClauses.length;

			reportFilterGroupObj.ChildReportTemplateFilterGroups.forEach(countChildClauses);
		}

		countChildClauses(reportTemplateFilterGroupObj);

		return clauseCount;
	};
}]);

angular.module('paycircleApp')
.filter('reportTemplateApplicableColumns',
	function () {
	return function (reportColumnsArr) {

		function getApplicableColumns (currentColumnObj) {

			const columnsOfSameTypeArr = reportColumnsArr.filter(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnID === currentColumnObj.ReportColumnID);

			// When there are duplicates, just return the first of them only
			if (columnsOfSameTypeArr.length > 1) {
				return columnsOfSameTypeArr[0].ReportTemplateColumnEntryID === currentColumnObj.ReportTemplateColumnEntryID;
			}

			// Return normal columns
			return true;
		}

		return reportColumnsArr.filter(getApplicableColumns);
	};
});

'use strict';

angular.module('paycircleApp')
.filter('rolePermissions', [
	function (
	) {

	return function (permissionGroupsArr, roleType) {

		return permissionGroupsArr.filter(permissionGroupObj => {

			// If group is empty already
			if (permissionGroupObj.GroupPermissionActions.length === 0 && (!permissionGroupObj.showFor || permissionGroupObj.showFor.includes(roleType))) {
				return true;
			}

			permissionGroupObj.GroupPermissionActions = permissionGroupObj.GroupPermissionActions.filter(groupPermissionActionObj => (!groupPermissionActionObj.showFor || groupPermissionActionObj.showFor.includes(roleType)));

			return permissionGroupObj.GroupPermissionActions.length > 0 && permissionGroupObj.showFor.includes(roleType);
		});

	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('roleTypeMeta', [
	'PERMISSION_ROLES',
	'PERMISSION_ROLES_DESCRIPTIONS',
	'PERMISSION_ROLES_ORDER',
	function (
		PERMISSION_ROLES,
		PERMISSION_ROLES_DESCRIPTIONS,
		PERMISSION_ROLES_ORDER
	) {

	return function (roleTypeId, type) {

		switch (type) {
			case 'description':
				return PERMISSION_ROLES_DESCRIPTIONS[roleTypeId];
			case 'order':
				return PERMISSION_ROLES_ORDER[roleTypeId];
			default:
				return PERMISSION_ROLES[roleTypeId];
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('salaryRateDescription', ['$filter', 'EMPLOYMENT_PAYMENT_TYPES', 'EMPLOYMENT_RATE_TYPES', function ($filter, EMPLOYMENT_PAYMENT_TYPES, EMPLOYMENT_RATE_TYPES) {
	return function (salaryObj) {

		function getRateType (salaryObj) {

			switch (salaryObj.RateType) {

				// Daily rate
				case EMPLOYMENT_RATE_TYPES.daily:
					return $filter('monetise')(salaryObj.SalaryDailyRatePartTime) + '/day';

				// Hourly rate
				case EMPLOYMENT_RATE_TYPES.hourly:
					return $filter('monetise')(salaryObj.SalaryHourlyRatePartTime) + '/hr';
			}
		}

		switch (salaryObj.PaymentType) {

			case EMPLOYMENT_PAYMENT_TYPES.rate:
				return getRateType(salaryObj);

		}

		return null;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('secondedStateDescription', [
	'SECONDED_STATES',
	function (
		SECONDED_STATES
	) {

	return function (secondedState) {

		switch (secondedState) {

			case SECONDED_STATES.notSeconded: {
				return 'Not seconded';
			}
			case SECONDED_STATES.none: {
				return 'None';
			}
			case SECONDED_STATES.stay183DaysOrMore: {
				return 'A';
			}
			case SECONDED_STATES.stayLessThan183Days: {
				return 'B';
			}
			case SECONDED_STATES.inOutUk: {
				return 'C';
			}
			case SECONDED_STATES.notEnoughInformation: {
				return 'D';
			}
			default: {
				return 'Unknown';
			}
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('slugify', function () {

	return function (value) {

		if (!value) {
			return;
		}

		// Lowercase / trim
		var slug = value.toLowerCase().trim();

		// Replace invalid chars with spaces
		slug = slug.replace(/[^a-z0-9\s-]/g, ' ');

		// Replace multiple spaces or hyphens with a single hyphen
		slug = slug.replace(/[\s-]+/g, '-');

		return slug;
	};

});
'use strict';

/**
 * @ngdoc filter
 * @name paycircleApp.filter:splitPascalCase
 * @function
 * @description Inserts a space at each lower-to-upper case boundary so PascalCase names read as separate
 * words (e.g. 'StatutoryPayment' -> 'Statutory Payment'). Acronyms such as 'CIS' and 'BIK' are left
 * untouched. Non-string or empty values are returned unchanged.
 */
angular.module('paycircleApp')
.filter('splitPascalCase', [function () {

	return function (value) {

		if (!value || typeof value !== 'string') {
			return value;
		}

		return value.replace(/([a-z])([A-Z])/g, '$1 $2');
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('statutoryPayCalculationMethodDescription', ['STATUTORY_PAY_CALCULATION_METHODS', function (STATUTORY_PAY_CALCULATION_METHODS) {

	return function (calculationMethod) {

		switch (calculationMethod) {
			case STATUTORY_PAY_CALCULATION_METHODS.periodDates:
				return 'per period';
			case STATUTORY_PAY_CALCULATION_METHODS.weekly:
				return 'weekly';
			default:
				return 'unknown';
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('studentLoanPlanDescription', [function () {

	return function (hasStudentLoan, hasStudentLoanPlan1, hasStudentLoanPlan2, hasStudentLoanPlan4, hasStudentLoanPlan5) {

		if (!hasStudentLoan || !(hasStudentLoanPlan1 || hasStudentLoanPlan2 || hasStudentLoanPlan4 || hasStudentLoanPlan5)) {
			return '';
		}

		if (hasStudentLoanPlan1 && hasStudentLoanPlan2) {
			return 'plan 1 and plan 2';
		}

		if (hasStudentLoanPlan1) {
			return 'plan 1';
		}

		if (hasStudentLoanPlan2) {
			return 'plan 2';
		}

		if (hasStudentLoanPlan4) {
			return 'plan 4';
		}

		if (hasStudentLoanPlan5) {
			return 'plan 5';
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.filter('supplementaryPaymentStateLabel', [
	'SUBMISSION_STATES',
	function (
		SUBMISSION_STATES
	) {

	return function (supplementaryPaymentState) {

		switch (supplementaryPaymentState) {
			case SUBMISSION_STATES.submitted:
				return 'Submitted';
			case SUBMISSION_STATES.failed:
				return 'Submission failed';
			default:
				return 'In progress';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('tasksOrder', [function () {
	return function (tasksArr, showCompleteTasks) {

		// Sort array DateDueISO, most recent date at the top
		let sortedArr = tasksArr.sort((dateOne, dateTwo) => moment(dateOne.DateDueISO).format('X') - moment(dateTwo.DateDueISO).format('X'));

		// Split array into sections for Overdue, Incomplete and Complete
		let overdueTasks = sortedArr.filter(taskObj => taskObj.IsOverdue && !taskObj.IsComplete);
		let incompleteTasks = sortedArr.filter(taskObj => !taskObj.IsOverdue && !taskObj.IsComplete);
		let completeTasks = sortedArr.filter(taskObj => taskObj.IsComplete);

		// Join array together
		if (showCompleteTasks) {
			return overdueTasks.concat(incompleteTasks, completeTasks);

		} else {
			return overdueTasks.concat(incompleteTasks);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('taxPeriodDescription', ['$filter', 'PAY_PERIOD_TYPES', function ($filter, PAY_PERIOD_TYPES) {

	return function (taxPeriod, payPeriodType) {

		switch (payPeriodType) {

			case PAY_PERIOD_TYPES.weekly:
			case PAY_PERIOD_TYPES.monthly:

				const prefix = $filter('payPeriodTypeDescription')(payPeriodType);
				
				return `${prefix} ${taxPeriod}`;

			case PAY_PERIOD_TYPES.fortnightly:
			case PAY_PERIOD_TYPES.fourweekly:

				return `Week ${taxPeriod}`;

			default:

				return `Period ${taxPeriod}`;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('taxTreatment', ['$rootScope', 'TAX_TREATMENT_OPTIONS', 'TAX_TREATMENT_VALUES', function ($rootScope, TAX_TREATMENT_OPTIONS, TAX_TREATMENT_VALUES) {
	return function (taxTreatment) {

		var taxTreatmentOption = taxTreatment === 30 || taxTreatment === 20 ? TAX_TREATMENT_VALUES[taxTreatment] : TAX_TREATMENT_OPTIONS[taxTreatment];

		if (taxTreatmentOption === undefined) {
			$rootScope.paycircleMessage('Unable to get tax treatment option for tax treatment provided', 'error');
			return '';
		}

		return taxTreatmentOption.name;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('truncate', ['utilities', function (utilities) {
	return function (string, length, includeQuotes) {
		return utilities.truncate(string, length, includeQuotes);
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('uncemify', [function () {
	return function (theme) {

		switch (theme) {
			case 'is-primary':
				return 'primary';
			case 'is-primary-light':
				return 'primary-light';
			case 'is-secondary':
				return 'secondary';
			case 'is-tertiary':
				return 'tertiary';
			case 'is-tertiary-light':
				return 'tertiary-light';
			case 'is-quarternary':
				return 'quarternary';
			case 'is-greyscale':
				return 'greyscale';
			case 'is-positive':
				return 'positive';
			case 'is-indifferent':
				return 'indifferent';
			case 'is-assertive':
				return 'assertive';
			default:
				return theme;
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('userDocumentTypeTheme', ['USER_DOCUMENT_IDS', function (USER_DOCUMENT_IDS) {
	return function (documentTypeId) {

		switch (documentTypeId) {
			case USER_DOCUMENT_IDS.payStatement:
			case USER_DOCUMENT_IDS.manualPayStatement:
			case USER_DOCUMENT_IDS.cisPayStatement:
			case USER_DOCUMENT_IDS.supplementaryPayStatement:
				return 'is-primary';

			case USER_DOCUMENT_IDS.p60:
				return 'is-secondary';

			case USER_DOCUMENT_IDS.p45:
				return 'is-tertiary';

			default:
				return 'is-greyscale';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('userResponse', [
	'applicationService',
	'permissionsService',
	'utilities',
	'USER_ROLES',
	function (
		applicationService,
		permissionsService,
		utilities,
		USER_ROLES
	) {

	return function (userResponseObj) {

		// Setup permissions
		permissionsService.setupPermissionsForUser(userResponseObj);

		const PRIMARY_ROLE = utilities.getPrimaryRole(userResponseObj.UserResponseRoles);

		angular.extend(userResponseObj, {
			IsInPlayground: userResponseObj.AgencyProfileDummy,
			canSeeAutoRun: permissionsService.isAutoRunVisibleForUser(userResponseObj),
			defaultLandingPage: utilities.getRoleUrl(PRIMARY_ROLE, userResponseObj.CompanyInformation ? userResponseObj.CompanyInformation.CompanyType : undefined),
			isAppNavEnabled: !utilities.userHasRole(userResponseObj, [USER_ROLES.groupadminlite, USER_ROLES.companyadministratorlite]),
			isPaycircleAdmin: utilities.userHasRole(userResponseObj, 'paycircle'), // Set is admin flag before any potential manipulation with the user roles
			ngHrefFunctions: {
				currentPeriod: applicationService.getNgHrefFunctionForUser(userResponseObj, 'current-period')
			},
			primaryRole: PRIMARY_ROLE
		});

		return userResponseObj;
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('userRoleDescription', ['USER_ROLE_DESCRIPTIONS', function (USER_ROLE_DESCRIPTIONS) {
	return function (userRoleId) {

		return USER_ROLE_DESCRIPTIONS[userRoleId];
	};
}]);

'use strict';

angular.module('paycircleApp')
.filter('validationResultFieldPriority', ['VALIDATION_HIGH_PRIORITY_FIELDS', function (VALIDATION_HIGH_PRIORITY_FIELDS) {

	return function (fieldTitle) {

		return VALIDATION_HIGH_PRIORITY_FIELDS.indexOf(fieldTitle) > -1 ? 'high-priority' : 'low-priority';
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('validationResultFieldTitle', [function () {

	return function (fieldTitle) {

		fieldTitle = fieldTitle.slice(10).replace(/([a-z])([A-Z])/g, '$1 $2');

		fieldTitle = fieldTitle.replace('NI', 'NI ');
		fieldTitle = fieldTitle.replace('Plan1', 'Plan 1');
		fieldTitle = fieldTitle.replace('Plan2', 'Plan 2');
		fieldTitle = fieldTitle.replace('Plan4', 'Plan 4');
		fieldTitle = fieldTitle.replace('Plan5', 'Plan 5');
		fieldTitle = fieldTitle.replace('DOB', 'Date of Birth');
		fieldTitle = fieldTitle.replace('Line1', 'Line 1');
		fieldTitle = fieldTitle.replace('Line2', 'Line 2');
		fieldTitle = fieldTitle.replace('Line3', 'Line 3');
		fieldTitle = fieldTitle.replace('Line4', 'Line 4');

		return fieldTitle;
	};

}]);

'use strict';

angular.module('paycircleApp')
.filter('workPatternDayType', ['WORK_PATTERN_DAY_TYPES_DESCRIPTIONS', function (WORK_PATTERN_DAY_TYPES_DESCRIPTIONS) {

	return function (value) {

		return WORK_PATTERN_DAY_TYPES_DESCRIPTIONS[value];
	};

}]);
angular.module('paycircleApp')
.provider('filterWatcher', function () {

	this.$get = ['$window', '$rootScope', function ($window, $rootScope) {

		/**
		 * Cache storing
		 * @type {Object}
		 */
		var $$cache = {};

		/**
		 * Scope listeners container
		 * scope.$destroy => remove all cache keys
		 * bind to current scope.
		 * @type {Object}
		 */
		var $$listeners = {};

		/**
		 * $timeout without triggering the digest cycle
		 * @type {function}
		 */
		var $$timeout = $window.setTimeout;

		/**
		 * @description
		 * get `HashKey` string based on the given arguments.
		 * @param fName
		 * @param args
		 * @returns {string}
		 */
		function getHashKey (fName, args) {
			function replacerFactory () {
				var cache = [];
				return function (key, val) {
					if (angular.isObject(val) && val !== null) {
						if (~cache.indexOf(val)) {
							return '[Circular]';
						}
						cache.push(val);
					}
					if ($window === val) {
						return '$WINDOW';
					}
					if ($window.document === val) {
						return '$DOCUMENT';
					}
					if (isScope(val)) {
						return '$SCOPE';
					}
					return val;
				};
			}
			return [fName, JSON.stringify(args, replacerFactory())]
				.join('#')
				.replace(/"/g,'');
		}

		/**
		 * @description
		 * Test if given object is a Scope instance
		 * @param obj
		 * @returns {Boolean}
		 */
		function isScope (obj) {
			return obj && obj.$evalAsync && obj.$watch;
		}

		/**
		 * @description
		 * fir on $scope.$destroy,
		 * remove cache based scope from `$$cache`,
		 * and remove itself from `$$listeners`
		 * @param event
		 */
		function removeCache (event) {
			var id = event.targetScope.$id;
			angular.forEach($$listeners[id], function (key) {
				delete $$cache[key];
			});
			delete $$listeners[id];
		}

		/**
		 * @description
		 * for angular version that greater than v.1.3.0
		 * it clear cache when the digest cycle is end.
		 */
		function cleanStateless () {
			$$timeout(function () {
				if (!$rootScope.$$phase) {
					$$cache = {};
				}
			}, 2000);
		}

		/**
		 * @description
		 * Store hashKeys in $$listeners container
		 * on scope.$destroy, remove them all(bind an event).
		 * @param scope
		 * @param hashKey
		 * @returns {*}
		 */
		function addListener (scope, hashKey) {
			var id = scope.$id;
			if (angular.isUndefined($$listeners[id])) {
				scope.$on('$destroy', removeCache);
				$$listeners[id] = [];
			}
			return $$listeners[id].push(hashKey);
		}

		/**
		 * @description
		 * return the `cacheKey` or undefined.
		 * @param filterName
		 * @param args
		 * @returns {*}
		 */
		function $$isMemoized (filterName, args) {
			var hashKey = getHashKey(filterName, args);
			return $$cache[hashKey];
		}

		/**
		 * @description
		 * store `result` in `$$cache` container, based on the hashKey.
		 * add $destroy listener and return result
		 * @param filterName
		 * @param args
		 * @param scope
		 * @param result
		 * @returns {*}
		 */
		function $$memoize (filterName, args, scope, result) {
			var hashKey = getHashKey(filterName, args);
			//store result in `$$cache` container
			$$cache[hashKey] = result;
			// for angular versions that less than 1.3
			// add to `$destroy` listener, a cleaner callback
			if(isScope(scope)) {
				addListener(scope, hashKey);
			} else {
				cleanStateless();
			}
			return result;
		}

		return {
			isMemoized: $$isMemoized,
			memoize: $$memoize
		};
	}];
});
	
'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/account-settings/';
	$stateProvider

	.state('account-settings', {
		url: '/account-settings/:agencyProfileId/:userId',
		templateUrl: directory + 'account-settings.view.html',
		controller: 'accountSettingsCtrl',
		resolve: {
			auth: ['$q', '$rootScope', '$state', 'AuthResolverCompany', function ($q, $rootScope, $state, AuthResolverCompany) {

				if ($rootScope.currentUser.IsAccessIdentityAccount) {
					$state.go('login');
					console.error('Unable to access page, redirected to sign in');
					return $q.reject();
				}
				
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
		    title: 'Account Settings'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('accountSettingsCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$stateParams',
	'securityData',
	'session',
	'utilities',
	'ACCOUNT_SECURITY_TYPES',
	function (
		$filter,
		$rootScope,
		$scope,
		$stateParams,
		securityData,
		session,
		utilities,
		ACCOUNT_SECURITY_TYPES
	) {

	const agencyProfileId = session.getAgencyProfileParentId();
	const userId = $stateParams.userId;

	function init () {

		setPageState('loading');

		securityData.getAccountMinimalList(userId).then(accountMinimalListObj => {

			// Pluck out the non-linked, main account
			const accountMinimalObj = accountMinimalListObj.find(accountMinimalListItem => !accountMinimalListItem.IsLinkedAccount);

			angular.extend($scope, {

				vm: {
					accountDetails: {
						icon: 'padlock',
						title: 'Sign in',
						layout: 'inline',
						detailGroups: [
							{
								actionMenuItems: [
									{
										label: 'Change username',
										action: () => openChangeAccountSecurityItemForm(accountMinimalObj, ACCOUNT_SECURITY_TYPES.username)
									},
									{
										label: 'Change password',
										action: () => openChangeAccountSecurityItemForm(accountMinimalObj, ACCOUNT_SECURITY_TYPES.password)
									},
									{
										label: 'Change recovery email address',
										action: () => openChangeAccountSecurityItemForm(accountMinimalObj, ACCOUNT_SECURITY_TYPES.recoveryEmail)
									}
								],
								details: [
									{
										label: 'Username',
										value: accountMinimalObj.Username
									},
									{
										label: 'Password',
										value: `Last updated at ${$filter('dateformat')(accountMinimalObj.LastPasswordChangeDateISO, 'timeDate24')}`
									},
									{
										label: 'Recovery email address',
										value: accountMinimalObj.RecoveryEmailAddress
									}
								]
							}
						]
					}
				}
			});

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function openChangeAccountSecurityItemForm (accountMinimalObj, accountSecurityType) {

		function getChangeAccountSecurityFormTitle (accountSecurityType) {

			// Establish form title based on account security type
			switch (accountSecurityType) {
				case ACCOUNT_SECURITY_TYPES.password:
					return 'Change password';
				case ACCOUNT_SECURITY_TYPES.username:
					return 'Change username';
				case ACCOUNT_SECURITY_TYPES.recoveryEmail:
					return 'Change recovery email address';
			}
		}

		// Open generic form for changing an account security item (password | username | recovery email)
		$rootScope.openSlideInForm({
			accountMinimal: accountMinimalObj,
			accountSecurityType,
			agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'change-account-security-item',
			title: getChangeAccountSecurityFormTitle(accountSecurityType),
			userId
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		goBack: utilities.goBack
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/manage-linked-accounts/';

	$stateProvider
	.state('manage-linked-accounts', {
		url: '/manage-linked-accounts/:agencyProfileId/:userId',
		templateUrl: directory + 'manage-linked-accounts.view.html',
		controller: 'manageLinkedAccountsCtrl',
		resolve: {
			auth: ['$q', '$rootScope', '$state', 'AuthResolverCompany', function ($q, $rootScope, $state, AuthResolverCompany) {

				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			title: 'Manage linked accounts'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('manageLinkedAccountsCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$stateParams',
	'securityData',
	'utilities',
	function (
		$filter,
		$rootScope,
		$scope,
		$stateParams,
		securityData,
		utilities
	) {
		const userId = $stateParams.userId;

		function init() {

			$scope.vm = {
				goBack: utilities.goBack,
				linkAccount
			};
			setPageState('loading');

			securityData.getAccountMinimalList(userId).then((linkedAccountsArr) => {			

				const payrollLinkedAccountsDetailBlocks = getAdminLinkedAccountsDetailBlock(linkedAccountsArr);
				const payPortalLinkedAccountsDetailBlocks = getEmployeeLinkedAccountsDetailBlock(linkedAccountsArr);
				angular.extend($scope.vm,{
					linkedAccounts: linkedAccountsArr,
					payrollAccountDetails: payrollLinkedAccountsDetailBlocks,
					payPortalAccountDetails: payPortalLinkedAccountsDetailBlocks,
				});

				setPageState('ready');
			})
			.catch(error => {
				setPageState('error');
				console.error(error);
			});
		}

		function getAdminLinkedAccountsDetailBlock (linkedAccounts) {

			const adminLinkedAccountsBlock = {
				
				icon: 'admins',
				title: 'Payroll Portal',
				detailGroups: []
			};

			if (linkedAccounts.length > 0) {
				const adminAccounts = linkedAccounts.filter(account => account.AccountType !== '');

				if (adminAccounts.length > 0) {

					adminAccounts.forEach(account => {
						adminLinkedAccountsBlock.detailGroups.push({
							editAction: $rootScope.currentUser.UserResponseUserID === account.UserID ? null : () => unlinkAccount(account.UserID),
							groupCta: $rootScope.currentUser.UserResponseUserID !== account.UserID ? null : {
								copy: `You're currently signed into this account`,
								theme: 'indifferent',
							},
							details: [ 
								{
									label: 'Username',
									value: account.Username
								},
								{
									label: 'Email Address',
									value: account.AccountEmailAddress
								},
								{
									label: 'Account Type',
									value: false,
									labelFalse:  $filter('roleTypeMeta')(account.AccountDetails.RoleType, 'name'),
									type: 'switch-custom-purple',
								
								},
							]
						});
					});

					return adminLinkedAccountsBlock;
				}
			}
			return adminLinkedAccountsBlock;
		}

		function getEmployeeLinkedAccountsDetailBlock (linkedAccounts) {

			const employeeLinkedAccountsBlock = {
				
				icon: 'wallet',
				title: 'Pay Portal',
				detailGroups: []
			};

			if (linkedAccounts.length === 0) {
				return employeeLinkedAccountsBlock;
			}

			const employeeAccounts = linkedAccounts.filter(account => account.AccountType === '');
			if (employeeAccounts.length > 0) {
				employeeAccounts.forEach(account => {
					employeeLinkedAccountsBlock.detailGroups.push({
						editAction: () => unlinkAccount(account.UserID),
						details: [ 
							{
								label: 'Username',
								value: account.Username
							},
							{
								label: 'Email Address',
								value: account.AccountEmailAddress
							},
		
						]
					});
				});


				return employeeLinkedAccountsBlock;
			}
		}

		function unlinkAccount(linkedAccountUserId) {
		
			let linkedAccount = $scope.vm.linkedAccounts.filter(x=>x.UserID === linkedAccountUserId)[0];
			
			$rootScope.openSlideInForm({
				callback: init,
				formKey: 'unlink-accounts',
				title: 'Unlink account',
				userId,
				linkedAccount
			});
			
		}

		function setPageState(pageState) {

			$scope.pageState = pageState;
		}

		function linkAccount() {

			$rootScope.openSlideInForm({
				callback: init,
				formKey: 'link-accounts',
				title: 'Add linked account',
				userId
			});
		}

		init();

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/activate-account/';
	$stateProvider

	.state('activate-account', {
		url: '/activate/:onboardingId/:activationCode/:emailAddress/:bureauKey',
		templateUrl: directory + 'activateAccountView.html',
		controller: 'activateAccountCtrl',
		data: {
			isPublic: true,
			fullPage: true,
		    title: 'Activate Account'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('activateAccountCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', 'base', 'companyData', 'config', 'securityData', 'utilities', 'AUTH_EVENTS', 'ONBOARDING_BUREAUS', 'PAY_PERIOD_TYPES', 'PAY_PERIOD_TYPES_DESCRIPTIONS', 'PAY_PERIOD_TYPES_OPTIONS', 'TRACKING_EVENTS', function ($rootScope, $scope, $state, $stateParams, $timeout, base, companyData, config, securityData, utilities, AUTH_EVENTS, ONBOARDING_BUREAUS, PAY_PERIOD_TYPES, PAY_PERIOD_TYPES_DESCRIPTIONS, PAY_PERIOD_TYPES_OPTIONS, TRACKING_EVENTS) {

	const ACTIVATION_CODE_RESPONSES = {
		companyAlreadyCreated: -4,
		companyDeleted: -3,
		timedOut: -2,
		invalidCode: -1,
		successOnboarding: 0,
		successFreeTrial: 1
	};
	const COMPANY_TEMPLATES = {
		olympicStars: 0,
		movieStars: 1,
		historicalFigures: 2,
		musicalArtists: 3
	};
	const NUMBER_OF_EMPLOYEE_OPTIONS = [
		{
			name: '1-10',
			value: 10
		},
		{
			name: '11-20',
			value: 20
		},
		{
			name: '21-30',
			value: 30
		},
		{
			name: '31-50',
			value: 50
		},
		{
			name: '51-100',
			value: 100
		},
		{
			name: '101-200',
			value: 200
		},
		{
			name: '201-500',
			value: 500
		},
		{
			name: '501+',
			value: 501
		}
	];
	const EMPLOYEE_OPTION_DESCRIPTIONS = {
		10: '1-10',
		20: '11-20',
		30: '21-30',
		50: '31-50',
		100: '51-100',
		200: '101-200',
		500: '201-500',
		501: '501+'
	};

	var activationCode = $stateParams.activationCode;
	var bureauKey = $stateParams.bureauKey;
	var emailAddress = $stateParams.emailAddress;
	var onboardingId = $stateParams.onboardingId;

	function checkActivationCode (vmObj) {

		setActivationState('loading');

		// Give UI time to load before populating the code
		$timeout(function () {

			vmObj.ActivationCode = activationCode;

			// Give person time to digest
			$timeout(function () {

				companyData.checkActivationCode(vmObj.OnboardingID, vmObj.ActivationCode, vmObj.Email).then(function (activationObj) {

					vmObj.CompanyName = activationObj.CompanyName;
					vmObj.Forename = activationObj.Forename;
					vmObj.Surname = activationObj.Surname;

					switch (activationObj.ActivationState) {
						case ACTIVATION_CODE_RESPONSES.successOnboarding:
							vmObj.TotalOnboardingSteps = 2;
							setOnboardingStep(vmObj, 1);
							setOnboardingProgressStep(vmObj, 1);
							setPageState('registration');
							break;
						case ACTIVATION_CODE_RESPONSES.successFreeTrial:
							vmObj.Demonstration = true;
							vmObj.TotalOnboardingSteps = 5;
							setOnboardingStep(vmObj, 1);
							setOnboardingProgressStep(vmObj, 1);
							setPageState('registration');
							break;
					}

					setCommsByDemonstrationEnabled(vmObj);
					setActivationState(activationObj.ActivationState);
				})
				.catch(function () {
					setPageState('error');
				});
			}, 1000);
		}, 500);
	}

	function goToNextOnboardingStep (vmObj) {

		// Skip steps 2, 3 & 4 if not a demo
		if (!vmObj.Demonstration && vmObj.onboardingStep === 1) {
			goToOnboardingStep(vmObj, 5);
			setOnboardingProgressStep(vmObj, 2);
			return;
		}

		vmObj.onboardingStep = vmObj.onboardingStep + 1;
		vmObj.onboardingProgressStep = vmObj.onboardingProgressStep + 1;
	}

	function goToOnboardingStep (vmObj, onboardingStep) {

		vmObj.onboardingStep = onboardingStep;
		vmObj.onboardingProgressStep = onboardingStep;
	}

	function goToPreviousOnboardingStep (vmObj) {

		// Skip steps 2, 3 & 4 if not a demo
		if (!vmObj.Demonstration && vmObj.onboardingStep === 5) {
			goToOnboardingStep(vmObj, 1);
			return;
		}

		vmObj.onboardingStep = vmObj.onboardingStep - 1;
		vmObj.onboardingProgressStep = vmObj.onboardingProgressStep - 1;
	}

	function init () {

		setPageState('checking-activation');

		var vmObj = {
			ActivationCode: '',
			AutoLogin: true,
			BureauKey: parseInt(bureauKey),
			CompanyName: '',
			Customisation: COMPANY_TEMPLATES.olympicStars,
			Demonstration: false,
			Email: utilities.paycircleDecodeEmail(emailAddress),
			EmployeeCount: null,
			Forename: '',
			HasWorkplacePension: true,
			IsCISActive: false,
			IsNewCompany: false,
			IsPayrollActive: true,
			IsPensionActive: true,
			IsWhitelabel: utilities.getIsWhitelabelByBureauKey(bureauKey),
			Modules: 0,
			OnboardingID: onboardingId,
			onboardingStep: 1,
			PayrollFrequency: PAY_PERIOD_TYPES.monthly,
			Surname: '',
			TotalOnboardingSteps: 0,
			Value: '',
			ValueConfirm: ''
		};

		// Validate Onboarding ID
		if (!utilities.isValidGuid(vmObj.OnboardingID)) {
			setActivationState('invalid-url');
			return;
		}

		$scope.vm = vmObj;

		checkActivationCode(vmObj);
	}

	function onboardCompany (vmObj) {

		// Create bitwise
		if (vmObj.IsPayrollActive) {
			vmObj.Modules = vmObj.Modules + 1;
		}
		if (vmObj.IsPensionActive) {
			vmObj.Modules = vmObj.Modules + 2;
		}
		if (vmObj.IsCISActive) {
			vmObj.Modules = vmObj.Modules + 4;
		}

		// Loading state
		setOnboardingStep(vmObj, 0);

		$timeout(function () {

			securityData.onboardingRegistration(vmObj, vmObj.AutoLogin).then(function (userResponseObj) {

				// Attach meta data when session is created
				userResponseObj.metaData = {
					company: {
						created_at: moment().unix(),
						name: vmObj.CompanyName,
						size: vmObj.EmployeeCount,
						employee_count_bracket: EMPLOYEE_OPTION_DESCRIPTIONS[vmObj.EmployeeCount],
						onboarding_type: vmObj.Demonstration ? 'Demo' : 'Onboarding',
						bureau_name: parseInt(bureauKey) === 0 ? 'Paycircle' : 'FSB',
						has_workplace_pension: vmObj.HasWorkplacePension,
						is_cis_active: vmObj.IsCISActive,
						is_new_company: vmObj.IsNewCompany,
						is_payroll_active: vmObj.IsPayrollActive,
						is_pension_active: vmObj.IsPensionActive,
						pay_period_frequency: PAY_PERIOD_TYPES_DESCRIPTIONS[vmObj.PayrollFrequency]
					},
					name: vmObj.Forename + ' ' + vmObj.Surname,
					last_request_at: moment().unix()
				};

				// Attach tracking event to be fired after session is created
				userResponseObj.trackingEvent = vmObj.Demonstration ? TRACKING_EVENTS.registeredForFreeTrial : TRACKING_EVENTS.registeredForOnboarding;

				if (vmObj.AutoLogin) {
					$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, userResponseObj);
				}
				else {
					$state.go('login', {'username': vmObj.Email});
				}
			})
			.catch(function (error) {
				console.error(error);
				setOnboardingStep(vmObj, -1);
			});
		}, 2000);
	}

	function reviewWorkplacePension (vmObj) {

		vmObj.IsPensionActive = vmObj.HasWorkplacePension;
	}

	function sendInvitationMail (vmObj) {

		companyData.sendInvitationMail(vmObj.OnboardingID, vmObj.BureauKey).then(function () {

			setActivationState('invitation-resent');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setActivationState (activationState) {

		$scope.activationState = activationState;
	}

	function setCommsByDemonstrationEnabled (vmObj) {

		// Demo
		if (vmObj.Demonstration) {
			vmObj.pretitle = config.demoCompanyTrialLength + '-day free trial setup';
			vmObj.title = 'Activate your free trial';
		}

		// Onboarding
		else {
			vmObj.pretitle = 'Onboarding registration';
			vmObj.title = 'Activate your account';
		}

		return vmObj;
	}

	function setOnboardingProgressStep (vmObj, onboardingProgressStep) {

		vmObj.onboardingProgressStep = onboardingProgressStep;
	}

	function setOnboardingStep (vmObj, onboardingStep) {

		vmObj.onboardingStep = onboardingStep;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleModalIsOpen (modalOptions) {

		modalOptions.isOpen = !modalOptions.isOpen;
	}

	function updateOnboardingActivationCode (vmObj) {
		
		companyData.updateOnboardingActivationCode(vmObj.OnboardingID, vmObj.BureauKey).then(function () {

			setActivationState('invitation-resent');
		})
		.catch(function () {
			setPageState('error');
		});
	}
	
	init();

	$scope.ACTIVATION_CODE_RESPONSES = ACTIVATION_CODE_RESPONSES;
	$scope.COMPANY_TEMPLATES = COMPANY_TEMPLATES;
	$scope.NUMBER_OF_EMPLOYEE_OPTIONS = NUMBER_OF_EMPLOYEE_OPTIONS;
	$scope.PAY_PERIOD_TYPES_OPTIONS = PAY_PERIOD_TYPES_OPTIONS;

	$scope.modalOptions.newCompanyInfo = {
		isOpen: false,
		size: 'm',
		title: 'Brand new companies'
	};

	$scope.checkActivationCode = function (vmObj) {

		checkActivationCode(vmObj);
	};

	$scope.goToNextOnboardingStep = function (vmObj) {

		goToNextOnboardingStep(vmObj);
	};

	$scope.goToPreviousOnboardingStep = function (vmObj) {

		goToPreviousOnboardingStep(vmObj);
	};

	$scope.onboardCompany = function (vmObj) {

		onboardCompany(vmObj);
	};

	$scope.reviewWorkplacePension = function (vmObj) {

		reviewWorkplacePension(vmObj);
	};

	$scope.sendInvitationMail = function (vmObj) {

		sendInvitationMail(vmObj);
	};

	$scope.toggleModalIsOpen = function (modalOptions) {

		toggleModalIsOpen(modalOptions);
	};

	$scope.updateOnboardingActivationCode = function (vmObj) {

		updateOnboardingActivationCode(vmObj);
	};
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const directory = 'features/shared/help-and-support/';
	$stateProvider

	.state('help-and-support', {
		url: '/help-and-support/:agencyProfileId?articleKey&categoryId',
		templateUrl: directory + 'helpAndSupportView.html',
		controller: 'helpAndSupportCtrl',
		reloadOnSearch: false,
		data: {
			isCompanyBarActive: false,
			title: 'Help and Support'
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	})

	.state('help-and-support-full-page', {
		url: '/help-and-support-full-page/:agencyProfileId?articleKey&categoryId',
		templateUrl: directory + 'helpAndSupportView.html',
		controller: 'helpAndSupportCtrl',
		data: {
			fullPage: true
		},
		reloadOnSearch: false,
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('helpAndSupportCtrl', [
	'$scope',
	'$stateParams',
	'HELP_AND_SUPPORT_DISPLAY_OPTIONS',
function (
	$scope,
	$stateParams,
	HELP_AND_SUPPORT_DISPLAY_OPTIONS
) {

	function init () {

		// Options for full-screen help and support
		const helpAndSupportOptions = {
			showBreadcrumb: true,
			showRelated: true
		};

		if (angular.isDefined($stateParams.articleKey)) {
			helpAndSupportOptions.articleKey = $stateParams.articleKey;
		}
		if (angular.isDefined($stateParams.categoryId) && !Number.isNaN(Number($stateParams.categoryId))) {
			helpAndSupportOptions.categoryId = Number($stateParams.categoryId);
		}

		angular.extend($scope, {
			helpAndSupportOptions
		});
	}

	init();

	angular.extend($scope, {
		HELP_AND_SUPPORT_DISPLAY_OPTIONS
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/intercom/';
	$stateProvider

	.state('intercom', {
		url: '/intercom?state&code',
		templateUrl: directory + 'intercomView.html',
		controller: 'intercomCtrl',
		data: {
			isPublic: true,
			fullPage: true,
			title: 'Intercom'
		}
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('intercomCtrl', ['$scope', '$stateParams', function ($scope, $stateParams) {

	$scope.code = $stateParams.code;
	$scope.state = $stateParams.state;

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var templateDirectory = 'features/shared/login/';
	$stateProvider

	/* Login */
	.state('login', {
		url: '/login?brand&code&state&authstring',
		name: 'Paycircle - Sign in',
		templateUrl: templateDirectory + 'login.view.html',
		controller: 'loginCtrl',
		data: {
			isPublic: true,
			title: 'Sign in'
		},
		params: {
			accountEmailAddress: null,
			// This will clear the title text of the session timeout modal
			emptySessionTimeoutHeaderTitle: false,
			// This will be an object when there is an impersonation
			impersonationErrorData: null,
			// This will be an object when there is a migration error
			migrationErrorData: null,
			// This will be an object when the user has not completed migration but it is required
			RequiresAccessMigration: null,
			// This is set when we need to specifically control the default option in the migration flow
			hasIdentityAccountForMigration: undefined,
			signInErrorActiveSessionEmail: null,
			signInErrorCode: null,
			signInErrorIdentityUrl: null,
			isAccessIdentityAccount: false,
			showSessionTimeout: false,
			username: null,
			// True when the user has come into the app as an invalid identity user for the portal type (multiple identity accounts issue)
			identityNoAccess: false,
			isEvoMigrationRequired: false,
			evoMigrationUrl: null
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	})

	/* SSO login */
	.state('ssoLogin', {
		url: '/login/sso',
		name: 'Paycircle - SSO sign in',
		templateUrl: templateDirectory + 'login.view.html',
		controller: 'loginCtrl',
		data: {
			isPublic: true,
			isSSOLogin: true
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('loginCtrl', [
	'$filter',
	'$location',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'$window',
	'applicationService',
	'config',
	'growl',
	'securityData',
	'securityService',
	'session',
	'utilities',
	'AUTH_EVENTS',
	'AUTH_ERRORS',
	'AUTH_ERROR_MESSAGES',
	'EMAIL_UNIQUENESS_ERROR_CODES',
	'HTTP_STATUS_CODES',
	'IDENTITY_STATE',
	'LOCAL_STORAGE_KEYS',
	'LOGIN_TYPES',
	'LOGIN_OIDC_TYPES',
	'MIGRATION_ERROR_CODES',
	'USER_CREDENTIALS_RESPONSE_ERROR_CODES',
	'USER_MESSAGE_BAR_STATES',
	function (
		$filter,
		$location,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		$window,
		applicationService,
		config,
		growl,
		securityData,
		securityService,
		session,
		utilities,
		AUTH_EVENTS,
		AUTH_ERRORS,
		AUTH_ERROR_MESSAGES,
		EMAIL_UNIQUENESS_ERROR_CODES,
		HTTP_STATUS_CODES,
		IDENTITY_STATE,
		LOCAL_STORAGE_KEYS,
		LOGIN_TYPES,
		LOGIN_OIDC_TYPES,
		MIGRATION_ERROR_CODES,
		USER_CREDENTIALS_RESPONSE_ERROR_CODES,
		USER_MESSAGE_BAR_STATES
	) {

	const agencyProfileId = $stateParams.state; // Returned from Slack
	const customisationObj = session.getCustomisation();

	const slackToken = $stateParams.code; // Returned from Slack

	const REDIRECT_PLACEHOLDER = '<OIDCREDIRECTURL>';

	function decorateUserPostLogin (userObj, credentialsObj) {

		angular.extend(userObj, {
			// Todo: Temporary decorator, requires integration
			Customisation: customisationObj,

			loginType: credentialsObj.loginType
		});
	}

	function identityRedirect (data) {
		// Destroy the temp migration session/auth
		clearMigrationAuthState();
		// Save the nonce to the local storage
		utilities.addToStorage(LOCAL_STORAGE_KEYS.nonce, data.Nonce);
		// Redirect to identity
		if (angular.isDefined($stateParams.identityNoAccess) && $stateParams.identityNoAccess) {
			data.IdentityUrl += '&prompt=login'; //Force sign in to allow the user to select the correct identity account
		}
		$window.open(data.IdentityUrl, '_self');
	}

	function isUniqueEmailUniquenessResponse (identityData) {
		return identityData.EmailAddressUniqueness != null &&
			(identityData.EmailAddressUniqueness.IsUnique && identityData.EmailAddressUniqueness.ErrorCode === EMAIL_UNIQUENESS_ERROR_CODES.none);
	}

	function getSignInErrorMessage(errorCode) {

		if (errorCode && AUTH_ERROR_MESSAGES[errorCode]) {
			return AUTH_ERROR_MESSAGES[errorCode];
		}
		return AUTH_ERROR_MESSAGES.fallback;
	}

	function init () {

		// Is this the SSO Login state? If so, go straight to SSO login page, otherwise start login page is shown.
		let loginType = LOGIN_TYPES.start;

		const stateData = $state.$current.data;

		if (angular.isDefined($stateParams.identityNoAccess) && $stateParams.identityNoAccess) {
			growl.warning('Your sign in was not valid. Please try again.');
		}

		if (angular.isDefined(stateData) && angular.isDefined(stateData.isSSOLogin) && stateData.isSSOLogin) {
			loginType = LOGIN_TYPES.sso;
		}

		if (angular.isDefined($stateParams.isEvoMigrationRequired) && $stateParams.isEvoMigrationRequired) {
			loginType = LOGIN_TYPES.workspaceMigrate;
		}

		let hasAccessAccount = true;

		if (angular.isDefined($stateParams.hasIdentityAccountForMigration)) {
			hasAccessAccount = $stateParams.hasIdentityAccountForMigration;

		// Get has access account state from the location service when coming from registration portal
		} else if (angular.isDefined($location.search().hasAccessIdentityAccount)) {
			hasAccessAccount = $location.search().hasAccessIdentityAccount.toLowerCase() === 'true';
		}

		// Credentials obj; credential storage and login states
		let credentialsObj =  {
			// The accessIdentityData will begin as an empty object and will be populated by data from the SigninStart API,
			accessIdentityData: {},
			accountAlreadyExists: false,
			canAccess: true,
			connectionType: slackToken !== undefined && utilities.isValidGuid(agencyProfileId) ? 'slack' : 'normal',
			confirmEmail: '',
			email: '',
			hasAccessAccount: hasAccessAccount,
			loginFailed: false,
			loginState: '',
			loginType,
			loginUsernameOrEmailFailed: false,
			loginUsernameOrEmail: '',
			loginUsernameOrEmailState: '',
			loginConfirmEmailIsLoading: false,
			loginDuplicateEmail: false,
			loginVerificationIsLoading: false,
			loginVerificationInvalidOrExpired: false,
			loginVerificationRequestNewIsLoading: false,
			evoMigrationUrl: angular.isDefined($stateParams.evoMigrationUrl) ? $stateParams.evoMigrationUrl : null,
			migratingUser: {
				isMigrating: false,
				isCredentialsVerified: false
			},
			newLoginContinueClicked: false,
			password: '',
			resendVerificationCodeNotificationSuccess: false,
			resendVerificationCodeNotificationWarning: false,
			resendVerificationCodeTimerIsOn: false,
			resendVerificationCodeTimerObj: null,
			username: $stateParams.username,
			verificationCode: ''
		};

		// If there are search parameters, after '#' in the URL, this state has been hit from an SSO redirect
		let isSSORedirect = false;
		let ssoRedirectObj;
		if ($location.hash() !== '') {
			const searchParams = new $window.URLSearchParams($location.hash());
			const idToken = searchParams.get('id_token');
			const state = searchParams.get('state');
			const error = searchParams.get('error');
			const errorDescription = searchParams.get('error_description');

			// At least state and idToken, or state and error must be present. If not, proceed on the basis that this isn't an SSO redirect.
			if (angular.isDefined(state) && (angular.isDefined(idToken) || angular.isDefined(error))) {

				/* Separate 'state' into AgencyProfileID and OIDC system, delineated by an underscore, like this:
					AgencyProfileID_OIDCSystem. OIDCSystem is one of the OIDC_SYSTEMS values. */
				const stateItems = state.split('_');
				const agencyProfileId = stateItems[0];
				const oidcSystem = parseInt(stateItems[1]);

				isSSORedirect = true;
				ssoRedirectObj = {
					idToken,
					// State param holds the AgencyProfileID for the SSO login
					agencyProfileId,
					error,
					errorDescription,
					oidcSystem,
					ssoError: false
				};
				angular.extend(credentialsObj, {
					loginType: LOGIN_TYPES.sso,
					ssoRedirect: ssoRedirectObj,
					isSSORedirect
				});
			}
		}

		//..Clear any migration auth state that may be present from a previous migration attempt
		clearMigrationAuthState(credentialsObj);

		// Temporary timeout warning
		if (config.appTimeoutMessage !== '') {
			applicationService.setUserMessageState(USER_MESSAGE_BAR_STATES.timeoutWarning);
		}

		angular.extend($scope, {
			credentials: credentialsObj,
			loginAttempts: 0,
			loginAttemptsLeft: 5,
		});

		// Check for impersonation
		if ($stateParams.impersonationErrorData !== null) {
			setPageState('impersonation');

		// SSO Redirect
		} else if (isSSORedirect) {
			// If ID Token is available, SSO login was successful.
			if (angular.isDefined(ssoRedirectObj.idToken) && ssoRedirectObj.idToken !== null) {
				login(credentialsObj, customisationObj, isSSORedirect);
			}
			else {
				// No ID Token available, so SSO login failed. Set error flag and page state to redisplay SSO login with error.
				credentialsObj.ssoError = true;
				setPageState('ready');
			}
		} else if ($stateParams.migrationErrorData !== null) {
			setPageState('migrationError');
		} else if ($stateParams.signInErrorActiveSessionEmail) {
			$scope.activeSessionEmail = $stateParams.signInErrorActiveSessionEmail;
			setPageState('activeSession');
		} else if ($stateParams.signInErrorCode === AUTH_ERRORS.accountNotLinkedToIdentity && !$stateParams.signInErrorActiveSessionEmail) {
			$scope.activeSessionEmail = null;
			setPageState('activeSession');
		} else if ($stateParams.signInErrorCode === AUTH_ERRORS.evoMigrationRequired) {
			setPageState('ready');
		} else if ($stateParams.signInErrorCode !== null) {
			const signInErrorDetails = getSignInErrorMessage($stateParams.signInErrorCode);
			$scope.signInErrorTitle = signInErrorDetails.title;
			$scope.signInErrorMessage = signInErrorDetails.message;
			setPageState('error');
		} else if ($stateParams.RequiresAccessMigration !== null && $stateParams.RequiresAccessMigration === true) {
			// migration required but was not completed - alert the user they need to sign in again and migrate
			setPageState('migrationRequired');
		}
		else {
			// Standard interactive login
			setPageState('ready');
		}
	}

	function gotoImpersonationLogin () {
		identityRedirect($stateParams.impersonationErrorData);
	}

	function migrateUserToWorkspace (credentials) {
		if (credentials.evoMigrationUrl) {
			$window.open(credentials.evoMigrationUrl, '_self');
		}
	}

	function resendCode (credentials) {

		if (credentials.accessIdentityData.AccountID === null || credentials.accessIdentityData.AccountID === undefined) {
			securityData.signinStart(credentials.username, false)		//..Call sign in start to populate any further identity data required. This is now an AllowAuthenticated endpoint
				.then((identityData) => {

					saveAccessIdentityDataAndLoginType(identityData, credentials, utilities.toCamelCase(identityData.Type));
				})
				.then(() => {
					sendCodeForResend(credentials);
				})
				.catch((error) => onError(error, credentials));
		} else {
			sendCodeForResend(credentials);
		}
	}

	function sendCodeForResend (credentials){
		// Hide notification
		credentials.loginVerificationInvalidOrExpired = false;

		if (credentials.resendVerificationCodeTimerIsOn === false) {

			// Request a new verification code
			credentials.loginVerificationRequestNewIsLoading = true;
			securityData.startAccountVerification(credentials.accessIdentityData.AccountID)
			.then(() => {

				// Show the success notification
				credentials.resendVerificationCodeNotificationSuccess = true;
				// Start a timer that will hide the note after 3 seconds
				credentials.resendVerificationCodeTimerObj =  $timeout(() => {
					credentials.resendVerificationCodeNotificationSuccess = false;
				}, 3000);

				// Start a timer that will allow new code requests after 1 minute
				credentials.resendVerificationCodeTimerIsOn = true;
				$timeout(() => {
					// Hide the warning notification
					credentials.resendVerificationCodeNotificationWarning = false;
					// Turn the timer off after 1 minute
					credentials.resendVerificationCodeTimerIsOn = false;
				}, 60000);
			})
			.catch((error) => onError(error, credentials))
			.finally(() => {
				credentials.loginVerificationRequestNewIsLoading = false;
			});

		} else {
			// Cancel the success timer
			$timeout.cancel(credentials.resendVerificationCodeTimerObj);
			// Show the warning note
			credentials.resendVerificationCodeNotificationWarning = true;
			// Hide the success note
			credentials.resendVerificationCodeNotificationSuccess = false;
		}
	}

	function saveAccessIdentityDataAndLoginType (identityData, credentialsObj, loginType) {
		// Save the data
		credentialsObj.loginType = loginType;
		credentialsObj.accessIdentityData = identityData;

		if (isMigratingUser(credentialsObj)) {
			credentialsObj.migratingUser.isMigrating = true;
		}
	}

	function isMigratingUser (credentialsObj) {
		return [LOGIN_TYPES.accessIdentityMigrate, LOGIN_TYPES.accessIdentityVerify, LOGIN_TYPES.created, LOGIN_TYPES.confirmEmail].includes(credentialsObj.loginType);
	}

	function storeMigrationAuthTokenAndSessionId (userObj, credentialsObj) {
		// store the auth token and session ID for further migration api requests
		// set isCredentialsVerified flag true to skip the password input for further steps as we should have a valid auth token
		securityService.storeToken(userObj.UserResponseAuthString);
		session.setSessionID(userObj);
		credentialsObj.migratingUser.isCredentialsVerified = true;
	}

	function credentialsVerificationResponseHandler (response) {
		if (response.ErrorCode !== USER_CREDENTIALS_RESPONSE_ERROR_CODES.none) {

			// Set states
			angular.extend($scope.credentials, {
				loginFailed: true,
				loginState: '',
			});

			// Log the error
			console.error(response);

			if (response.ErrorCode === USER_CREDENTIALS_RESPONSE_ERROR_CODES.invalidCredentials || response.data.ErrorCode === USER_CREDENTIALS_RESPONSE_ERROR_CODES.invalidCredentials) {
				updateLoginAttempts();
			}

			// Other errors could be:
			// - accountLocked
			// - passwordExpired

			return false;
		}
		return true;
	}

	function clearMigrationAuthState (credentialsObj) {
		// Kill the session and clear verified flag so password reentry will be presented to the user
		if (utilities.getToken() !== null) {
			securityData.signOut();
		}

		if (arguments.length > 0) {
			credentialsObj.migratingUser.isCredentialsVerified = false;
		}

		// Destroy session
		$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);
	}

	/*
		Login. isSSORedirect === true when this state is being hit following an SSO login with a third party
		authentication provider (Azure, Xero, Okta, etc.). Note the distinction here between loginType (part
        of the credentials object) and isSSORedirect. The latter is an automated login following external SSO
		authentication. The former is the initial SSO login step with UI in which the user provides their email
		address.
	*/
	function login (credentialsObj, customisationObj, isSSORedirect) {
		if (credentialsObj.loginDisabled) {
			return; // Prevent multiple clicks
		}
		credentialsObj.loginDisabled = true; // Disable button when clicked

		// Reset states
		angular.extend(credentialsObj, {
			canAccess: true,
			ssoIdentityState: null,
			loginFailed: false,
			loginState: '',
			loginUsernameOrEmailFailed: false,
			loginUsernameOrEmailState: '',
			loginConfirmEmailIsLoading: false,
			loginDuplicateEmail: false,
			loginVerificationIsLoading: false,
			loginVerificationInvalidOrExpired: false,
			loginVerificationRequestNewIsLoading: false,
			role: null,
			ssoError: false,
			ssoErrorState: LOGIN_OIDC_TYPES.Success
		});

		// Check if this is the first login screen
		if (credentialsObj.loginType === LOGIN_TYPES.start) {		//..Get the sign in type

			credentialsObj.loginUsernameOrEmailState = 'processing';

			// Show an error when it is an empty string
			if (credentialsObj.loginUsernameOrEmail === '') {
				credentialsObj.loginUsernameOrEmailFailed = true;
				credentialsObj.loginUsernameOrEmailState = '';
				credentialsObj.loginDisabled = false;

			} else {
				// Call the API
				securityData.getSigninStartType(credentialsObj.loginUsernameOrEmail)
				.then((identityData) => {

					saveAccessIdentityDataAndLoginType(identityData, credentialsObj, utilities.toCamelCase(identityData.Type));
					
					if (credentialsObj.loginType === LOGIN_TYPES.accessIdentity) {
						// Redirect to identity
						identityRedirect(credentialsObj.accessIdentityData);
					} else {
						credentialsObj.username = credentialsObj.loginUsernameOrEmail;
						// Reset
						credentialsObj.loginUsernameOrEmailState = '';
					}
				})
				.catch((error) => onError(error, credentialsObj))
				.finally(() => {
					credentialsObj.loginDisabled = false;
				});
			}

		} else if (credentialsObj.migratingUser.isMigrating && !credentialsObj.migratingUser.isCredentialsVerified) {		//..Verify the user credentials to allow authenticated further api calls in the migration flow
			securityData.authoriseUserForMigration(credentialsObj)
				.then((authResponse) => {
					if (credentialsVerificationResponseHandler(authResponse)) {

						storeMigrationAuthTokenAndSessionId(authResponse.UserResponse, credentialsObj);
					}
				})
				.catch((authResponse) => {
					credentialsVerificationResponseHandler(authResponse);
				})
				.finally(() => {
					credentialsObj.loginDisabled = false;
				});

		} else if (credentialsObj.loginType === LOGIN_TYPES.accessIdentityMigrate && credentialsObj.migratingUser.isCredentialsVerified) {
			credentialsObj.loginSetupSigninIsLoading = true;

			securityData.signinStart(credentialsObj.username, credentialsObj.hasAccessAccount)				//..Call sign in start to populate any further identity data required. This is now an AllowAuthenticated endpoint
				.then((identityData) => {
					saveAccessIdentityDataAndLoginType(identityData, credentialsObj, utilities.toCamelCase(identityData.Type));
					if (credentialsObj.hasAccessAccount){
						if (identityData.IdentityUrl != null) {
							identityRedirect(credentialsObj.accessIdentityData);							//..Go off to sign in to existing identity account
							return;
						} else {
							onError('No identity URL returned');
							return;
						}
					}

					// Only go to confirm email if a further step is not returned from signinstart
					if (credentialsObj.loginType === LOGIN_TYPES.accessIdentityMigrate) {
						// Go to the confirm email address view
						credentialsObj.loginType = LOGIN_TYPES.confirmEmail;
						// Set the email address field in this view
						credentialsObj.confirmEmail = identityData.EmailAddress;
						if (credentialsObj.confirmEmail && !isUniqueEmailUniquenessResponse(identityData)) {
							// If the email is not empty and we have a uniqueness error code then it is a duplicate being used by another user
							credentialsObj.loginDuplicateEmail = true;
							if (identityData.EmailAddressUniqueness.ErrorCode === EMAIL_UNIQUENESS_ERROR_CODES.inUseIdentity) {
								credentialsObj.accountAlreadyExists = true;
							}
						}
					}
				})
				.catch((error) => onError(error, credentialsObj))
				.finally(() => {
					credentialsObj.loginSetupSigninIsLoading = false;
					credentialsObj.loginDisabled = false;
				});

		} else if (credentialsObj.loginType === LOGIN_TYPES.confirmEmail) {
			// Migrate the user
			credentialsObj.loginConfirmEmailIsLoading = true;

			securityData.migrateUser(credentialsObj.accessIdentityData.UserID, credentialsObj.confirmEmail)
				.then((identityData) => {

					if (identityData.ErrorCode === MIGRATION_ERROR_CODES.unexpectedError) {
						angular.extend($scope, {
							unexpectedError: true
						});
						init();
					} else if (!isUniqueEmailUniquenessResponse(identityData)) {					//..Email address is not unique
						credentialsObj.loginDuplicateEmail = true;

						if (identityData.ErrorCode === MIGRATION_ERROR_CODES.cannotLinkMultipleUsers) {			//..Multiple users cannot be linked through this method. Signin and link flow should be used
							credentialsObj.accountAlreadyExists = true;
						}
					} else {
						// The user is migrated.
						// Go to the verify code view
						saveAccessIdentityDataAndLoginType(identityData, credentialsObj, LOGIN_TYPES.accessIdentityVerify);
					}

				})
				.catch((error) => onError(error, credentialsObj))
				.finally(() => {
					credentialsObj.loginConfirmEmailIsLoading = false;
					credentialsObj.loginDisabled = false;
				});

		} else if (credentialsObj.loginType === LOGIN_TYPES.accessIdentityVerify) {

			credentialsObj.loginVerificationIsLoading = true;

			securityData.verifyAccountCode(credentialsObj.accessIdentityData.AccountID, credentialsObj.verificationCode)
				.then((identityData) => {

					if (identityData.Status === 'Invalid' || identityData.Status === 'Expired') {
							credentialsObj.loginVerificationInvalidOrExpired = true;
							credentialsObj.verificationCode = '';
					} else if (identityData.Status === 'AccountNotFound' && (credentialsObj.accessIdentityData.AccountID === null || credentialsObj.accessIdentityData.AccountID === undefined)) {
						credentialsObj.loginVerificationInvalidOrExpired = true;
						securityData.signinStart(credentialsObj.username)		//..Call sign in start to populate any further identity data required. This is now an AllowAuthenticated endpoint
							.then((identityData) => {
			
								saveAccessIdentityDataAndLoginType(identityData, credentialsObj, utilities.toCamelCase(identityData.Type));
							});
					} else if (identityData.Status === 'Verified') {
						saveAccessIdentityDataAndLoginType(identityData, credentialsObj, LOGIN_TYPES.created);
					} else {
						console.error('There is an issue using the code');
					}

				})
				.catch((error) => onError(error, credentialsObj))
				.finally(() => {
					credentialsObj.loginVerificationIsLoading = false;
					credentialsObj.loginDisabled = false;
				});

		} else if (credentialsObj.loginType === LOGIN_TYPES.created) {
			// Redirect to identity
			identityRedirect(credentialsObj.accessIdentityData);

		} else if (credentialsObj.loginType === LOGIN_TYPES.sso && !isSSORedirect) {
			/* If this is an SSO login (not redirect, see comments above), get the OIDC url and visit that.
			   Otherwise proceed with normal login or SSO redirect */
			// Get the OIDC URL for this user
			securityData.getOIDCUrl(credentialsObj.email).then(oidcResponse => {
				switch (oidcResponse.ErrorCode)
				{
					case LOGIN_OIDC_TYPES.Success:
						onGetOIDCSuccess(oidcResponse, credentialsObj);
						break;
					default: onGetOIDCFailure(oidcResponse, credentialsObj);
						break;
				}
			})
			.catch((error) => onError(error, credentialsObj))
			.finally(() => {
				credentialsObj.loginDisabled = false;
			});
		}
		else {

			// Login API dependent on whether this is an SSO redirect
			let userLogin;
			if (isSSORedirect) {
				// SSO Login - using ID token returned in redirect, and agency profile ID (from 'state' param in redirect)
				userLogin = securityData.userLoginSSO(credentialsObj.ssoRedirect.agencyProfileId,
													  credentialsObj.ssoRedirect.oidcSystem,
													  credentialsObj.ssoRedirect.idToken);
			}
			else {
				// Normal interactive login
				userLogin = securityData.userLogin(credentialsObj);
			}

			userLogin.then(userObj => {

				// Is user role type allowed in app
				if (securityService.isUserAllowedAccess(userObj)) {

					decorateUserPostLogin(userObj, credentialsObj);

					if (userObj.RequiresAccessMigration && userObj.IsSSOLogin && !userObj.IsRegistered) {
						// Handle scenario where we need to show them an option to fully register themselves
						createLiteSessionForSSORegistrationRequest(userObj);

					} else if (userObj.Session2FARequired) {
						// User required two-factor authentication
						$state.go('authentication', {user: userObj});

					} else {
						// Set up user session
						$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, userObj, agencyProfileId, slackToken);
					}

					// Set states
					angular.extend(credentialsObj, {
						canAccess: true,
						loginFailed: false,
						loginState: 'logged-in',
					});
				}

				// User role not permitted
				else {

					// Set states
					angular.extend(credentialsObj, {
						canAccess: false,
						loginState: '',
						role: userObj.UserResponseRoles[0],
					});

					// Show message
					console.warn('Paycircle: User is not allowed access');
				}

			})
			.catch(error => {

				if (error.status && error.status === HTTP_STATUS_CODES.serviceUnavailable) {
					// Whitelist checking failed
					setPageState('access-denied');
				} else if (isSSORedirect && error.status && (error.status === HTTP_STATUS_CODES.unauthorized || error.status === HTTP_STATUS_CODES.internalServerError)) {
					// Unauthorized or Internal Server Error

					// Set states
					angular.extend(credentialsObj, {
						loginFailed: true,
						loginState: 'ssologin-failed',
					});


					setPageState('error');
					
				} else {
					console.error(error);

					// Set states
					angular.extend(credentialsObj, {
						loginFailed: true,
						loginState: '',
					});

					updateLoginAttempts();

					// Set page state to show login screen with error
					setPageState('ready');
				}
			})
			.finally(() => {
				credentialsObj.loginDisabled = false;

				$timeout(() => {
					credentialsObj.loginState = credentialsObj.loginState === 'ssologin-failed' ? credentialsObj.loginState : '';
				}, 5000);
			});

		}
	}

	function createLiteSessionForSSORegistrationRequest (userObj) {
		securityService.storeToken(userObj.UserResponseAuthString);

		// Store customisation id
		utilities.addToStorage(LOCAL_STORAGE_KEYS.brandId, userObj.AgencyProfileCustomisationID);

		// Store login type when updated
		if (userObj.loginType) {
			utilities.addToStorage(LOCAL_STORAGE_KEYS.loginType, userObj.loginType);
		}

		// Setup user object
		userObj = $filter('userResponse')(userObj);

		// Create users session
		session.create(userObj);

		$state.go('ssoRegisterUser', {user: userObj});
	}

	function onGetOIDCSuccess (oidcResponse, credentialsObj) {
		// If the response includes the redirect placeholder, we're good to go ...
		if (oidcResponse.OidcUrl.includes(REDIRECT_PLACEHOLDER)) {
			oidcSuccessRedirect(oidcResponse.OidcUrl);
		} else {
			oidcResponse.ErrorCode = LOGIN_OIDC_TYPES.NotEnabled;
			onGetOIDCFailure(oidcResponse, credentialsObj);
		}
	}

	function oidcSuccessRedirect (oidcUrl)
	{
		// Determine the login redirect for the Azure redirect. This varies according to environment; dev, beta, localhost etc.
		let redirectUri = `${$location.protocol()}://${$location.host()}`;
		// Add the port if there is one
		if ($location.port()) {
			redirectUri += `:${$location.port()}`;
		}
		// Add the login state, which deals with the SSO redirect
		redirectUri += '/login';

		// Update redirect - replace placeholder with determined redirect
		oidcUrl = oidcUrl.replace(REDIRECT_PLACEHOLDER, redirectUri);

		// Redirect to that for user credentials.
		$window.open(oidcUrl, '_self');
	}

	function onGetOIDCFailure (oidcResponse, credentialsObj) {
		// SSO not enabled for this user
		angular.extend(credentialsObj, {
			loginState: '',
			ssoErrorState: oidcResponse.ErrorCode,
			ssoIdentityState: oidcResponse.IdentityState,
			userRegistrationState: oidcResponse.RegistrationState,
			oidcRedirectURL: oidcResponse.OidcUrl
		});
	}

	function getSSOMessageState (credentialsObj) {
		switch (credentialsObj.ssoErrorState) {
			case LOGIN_OIDC_TYPES.Success: 
				return 'Success';
			case (LOGIN_OIDC_TYPES.NotEnabled):
				return 'userNotFound';
			case (LOGIN_OIDC_TYPES.BlockedForIdentity):
				return getSSOMessageStateBlockedForIdentity(credentialsObj);
			case (LOGIN_OIDC_TYPES.UnexpectedError):
				return 'unexpectedError';
		}
	}

	function getSSOMessageStateBlockedForIdentity (credentialsObj) {
		if(credentialsObj.ssoIdentityState === IDENTITY_STATE.accessIdentity) {
			return 'identityMigratedUser';
		} else if (credentialsObj.ssoIdentityState === IDENTITY_STATE.accessIdentityMigrate || credentialsObj.ssoIdentityState === IDENTITY_STATE.accessIdentityVerify) {
			if (credentialsObj.userRegistrationState.IsRegistered) {
				return 'identityMigrationRequired';
			} else {
				return 'identityMigrationAndRegistrationRequired';
			}
		}
	}

	function continueSSOForRegistration (credentialsObj) {
		
		angular.extend(credentialsObj, {
			loginState: 'logging-in'
		});

		if (credentialsObj.oidcRedirectURL.includes(REDIRECT_PLACEHOLDER)) {
			oidcSuccessRedirect(credentialsObj.oidcRedirectURL);
		} else {
			setPageState('error');
		}
		
	}

	function onError (error, credentialsObj) {
		clearMigrationAuthState(credentialsObj);
		console.error(error);
		credentialsObj.loginDisabled = false;
	}

	function reset () {
		init();
	}

	function resetMigrationErrorWithDefaultNoAccessAccount () {
		$stateParams.hasIdentityAccountForMigration = false;
		$stateParams.migrationErrorData = null;
		reset();
	}

	function resetAfterActiveSession () {
		$stateParams.signInErrorActiveSessionEmail = null;
		$stateParams.signInErrorCode = null;
		$stateParams.signInErrorIdentityUrl = null;
		reset();
	}

	function resetAfterSignInError (credentialsObj) {

		if ($stateParams.signInErrorCode === AUTH_ERRORS.accountNotLinkedToIdentity && $stateParams.signInErrorIdentityUrl) {

			// This is an access identity user, sign out using the URL
			window.open($stateParams.signInErrorIdentityUrl, '_self');
		}

		$stateParams.signInErrorCode = null;
		$stateParams.signInErrorIdentityUrl = null;

		if (credentialsObj.loginState === 'ssologin-failed' || (credentialsObj.ssoRedirect !== null && credentialsObj.ssoRedirect !== undefined)) {
			angular.extend(credentialsObj, {
				loginState: ''
			});

			$state.go('login');
		}
		reset();
	}

	function resetAfterMigrationRequiredError () {
		$stateParams.RequiresAccessMigration = null;
		reset();
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateLoginAttempts () {
		$scope.loginAttempts++;
		$scope.loginAttemptsLeft--;
	}

	function getIdentityMigrateSignInTitleText () {
		if ($scope.credentials.migratingUser.isCredentialsVerified && !$scope.credentials.newLoginContinueClicked) {
			return 'A new way to sign in';
		} else if ($scope.credentials.migratingUser.isCredentialsVerified) {
			return 'Your Access account';
		} else {
			return 'Sign in to payroll';
		}
	}

	init();

	angular.extend($scope, {
		LOGIN_TYPES,
		LOGIN_OIDC_TYPES,
		customisation: customisationObj,
		externalUrls: config.externalUrls,
		continueSSOForRegistration,
		gotoImpersonationLogin,
		resetAfterActiveSession,
		migrateUserToWorkspace,
		getIdentityMigrateSignInTitleText,
		getSSOMessageState,
		login,
		onError,
		resendCode,
		reset,
		resetAfterMigrationRequiredError,
		resetAfterSignInError,
		resetMigrationErrorWithDefaultNoAccessAccount,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var templateDirectory = 'features/shared/logout/';
	$stateProvider

	/* Login */
	.state('logout', {
		url: '/logout',
		name: 'Paycircle - Logout',
		templateUrl: templateDirectory + 'logoutView.html',
		controller: 'LogoutCtrl',
		data: {
			isPublic: true,
			title: 'Sign out'
		}
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('LogoutCtrl', [
	'$rootScope',
	'$state',
	'securityData',
	'AUTH_EVENTS',
	function (
		$rootScope,
		$state,
		securityData,
		AUTH_EVENTS
	) {

	function init () {

		securityData.signOut().then(() => {

			$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);

			$state.go('login');
		})
		.catch(angular.noop);
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const templateDirectory = 'features/shared/auth/';
	$stateProvider

	.state('authentication', {
		url: '/auth',
		templateUrl: templateDirectory + 'authenticationView.html',
		controller: 'authenticationCtrl',
		data: {
			document: true,
			fullPage: true,
			isPublic: true,
			title: 'Authentication'
		},
		params: {
			user: null
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('authenticationCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'config',
	'securityData',
	'session',
	'AUTH_EVENTS',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		config,
		securityData,
		session,
		AUTH_EVENTS
	) {

	const userObj = $stateParams.user;

	const AUTH_STAGES = {
		app: 'app',
		authenticated: 'authenticated',
		code: 'code',
		loading: 'loading',
		qrCode: 'qr-code'
	};

	const CODE_STATES = {
		ready: 'ready',
		incorrect: 'incorrect',
		lockedOut: 'locked-out',
		success: 'success'
	};

	function clearResetTimeout (vmObj) {

		if (vmObj.resetTimeout) {
			$timeout.cancel(vmObj.resetTimeout);
		}
	}

	function getActiveStepIndex (activeStep) {

		switch (activeStep) {
			case AUTH_STAGES.app:
				return 1;
			case AUTH_STAGES.qrCode:
				return 2;
			case AUTH_STAGES.code:
				return 3;
			case AUTH_STAGES.authenticated:
				return 4;
		}
	}

	function getInitialActiveState () {

		if (userObj.Session2FAConfigured) {
			return AUTH_STAGES.code;

		} else {
			return AUTH_STAGES.app;
		}
	}

	function getInitialCodeState () {

		if (userObj.AttemptLockoutMinutes > 0 || userObj.AttemptLockoutSeconds > 0) {
			return CODE_STATES.lockedOut;

		} else {
			return CODE_STATES.ready;
		}
	}

	function getFailedValidationCodeState (tfaResponseObj) {

		if (tfaResponseObj.AttemptLockoutMinutes > 0 || tfaResponseObj.AttemptLockoutSeconds > 0) {
			return CODE_STATES.lockedOut;

		} else {
			return CODE_STATES.incorrect;
		}
	}

	function getOTPauthString (sharedSecret, vmObj) {
		return `otpauth://totp/${vmObj.issuerLabel}:${userObj.UserResponseUsername}?secret=${sharedSecret}&issuer=${vmObj.issuerLabel}`;
	}

	function getQRCode (vmObj) {

		resetTOTP(vmObj);

		vmObj.totp = '';

		setAuthStage(AUTH_STAGES.qrCode, vmObj);

		if (!vmObj.sharedSecret) {
			securityData.createSharedSecret(userObj.UserResponseUserID, userObj.UserResponseAuthString).then(sharedSecret => {

				angular.extend(vmObj, {
					qrCodeString: getOTPauthString(sharedSecret, vmObj),
					sharedSecret: sharedSecret.replace(/(.{4})/g, '$1 ')
				});

			})
			.catch(onError);
		}
	}

	function getResetTimeoutLength (failedValidationState, tfaResponseObj) {

		if (failedValidationState === CODE_STATES.incorrect) {
			return 3000;

		} else {
			const totalSecondsLockedOut = tfaResponseObj.AttemptLockoutSeconds+(tfaResponseObj.AttemptLockoutMinutes*60);

			return totalSecondsLockedOut*1000;
		}
	}

	function init () {

		if (!userObj) {
			$state.go('login');
			return;
		}

		// Set SessionID to use in later service calls
		session.setSessionID(userObj);

		const initCodeState = getInitialCodeState();

		const vmObj =  {
			activeStep: getInitialActiveState(),
			activeStepIndex: 1,
			codeState: initCodeState,
			isInSetupMode: !userObj.Session2FAConfigured,
			issuerLabel: encodeURIComponent(config.appTitle),
			maxVerifcationAttempts: 5,
			qrCodeString: null,
			resetTimeout: null,
			sharedSecret: null,
			showCodeFooter: false,
			showTroubleshooting: false,
			tfaResponse: null,
			totalSteps: 3,
			totp: '',
			user: userObj
		};

		// If user is locked out, disable the inputs
		if (initCodeState === CODE_STATES.lockedOut) {
			angular.extend(vmObj, {
				tfaResponse: userObj,
				showCodeFooter: true
			});
		}

		$scope.vm = vmObj;

		setPageState('ready');
	}

	function onError (errorMessage) {
		setPageState('error');
		console.error(errorMessage);
	}

	function redirectToLogin (vmObj) {

		$state.go('login', {username: userObj.UserResponseUsername });

		clearResetTimeout(vmObj);
	}

	function resetTOTP (vmObj) {

		angular.extend(vmObj, {
			codeState: CODE_STATES.ready,
			showCodeFooter: false
		});

		if (vmObj.TOTPForm) {
			vmObj.TOTPForm.state = null;
		}

		clearResetTimeout(vmObj);
	}

	function setAuthStage (newStep, vmObj) {

		angular.extend(vmObj, {
			activeStep: newStep,
			activeStepIndex: getActiveStepIndex(newStep),
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setNewSession () {

		userObj.Session2FARequired = false;

		$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, userObj);
	}

	function toggleTroubleshooting (vmObj) {
		vmObj.showTroubleshooting = !vmObj.showTroubleshooting;
	}

	function validate2FA (vmObj) {

		const formObj = vmObj.TOTPForm;

		formObj.state = 'saving';

		securityData.validate2FA(userObj.UserResponseUserID, vmObj.totp, userObj.UserResponseAuthString).then(tfaResponseObj => {

			if (tfaResponseObj.Authenticated) {

				if (vmObj.isInSetupMode) {
					setAuthStage(AUTH_STAGES.authenticated, vmObj);

				} else {
					angular.extend(vmObj, {
						codeState: CODE_STATES.success,
						showCodeFooter: true
					});

					formObj.state = 'saved';

					$timeout(() => {
						setNewSession();
					}, 1000);
				}

			} else {

				const failedValidationState = getFailedValidationCodeState(tfaResponseObj);

				angular.extend(vmObj, {
					codeState: failedValidationState,
					showCodeFooter: true,
					tfaResponse: tfaResponseObj,
					totp: ''
				});

				formObj.state = 'failed';

				vmObj.resetTimeout = $timeout(() => {
					resetTOTP(vmObj);
				}, getResetTimeoutLength(failedValidationState, tfaResponseObj));
			}
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		AUTH_STAGES,
		CODE_STATES,

		getQRCode,
		setNewSession,
		redirectToLogin,
		resetTOTP,
		setAuthStage,
		toggleTroubleshooting,
		validate2FA
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const templateDirectory = 'features/shared/auth/SSO/';
	$stateProvider

	.state('ssoRegisterUser', {
		url: '/get-registered',
		templateUrl: templateDirectory + 'sso-register-user.view.html',
		controller: 'ssoRegisterUserCtrl',
		data: {
			document: true,
			fullPage: true,
			isPublic: false,
			title: 'Complete Registration'
		},
		params: {
			user: null
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('ssoRegisterUserCtrl', [
		'$rootScope',
		'$scope',
		'$stateParams',
		'config',
		'securityData',
	function (
		$rootScope,
		$scope,
		$stateParams,
		config,
		securityData
	) {

	const userObj = $stateParams.user;

	function init() {
		setPageState('loading');

		if (userObj.UserResponseUserID === config.guidEmpty || userObj.AgencyProfileParentID === config.guidEmpty) {
			setContentState('error');
			setPageState('ready');
			return;
		}
		setPageState('ready');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setContentState (contentState) {
		$scope.contentState = contentState;
	}

	function requestRegistration () {
		setPageState('loading');

		securityData.requestRegistration(userObj.UserResponseUserID, userObj.AgencyProfileParentID)
		.then(response => {
			if(response.Invitation.InvitationVerificationCode !== null && response.Invitation.InvitationVerificationCode !== ''){
				$scope.registrationCode = response.Invitation.InvitationVerificationCode;
				setContentState('confirm-signout');
			} else {
				setContentState('error');
			}
		})
		.catch(() => {
			setContentState('error');
		});

		setPageState('ready');
	}

	function confirmSignout () {
		$rootScope.$broadcast('log-out');
	}

	init();

	angular.extend($scope, {
		contentState: 'request-registration',
		confirmSignout,
		requestRegistration
	});

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

    const templateDirectory = 'components/payslip/';

    $stateProvider

	/* Payslip */
	.state('payslip', {
		url: '/payslip/:agencyProfileId/:userId/:payPeriodId/:userPaymentId/:userDocumentTypeId/:supplementaryPaymentId?/',
		controller: 'PayslipCtrl',
		templateUrl: templateDirectory + 'payslip.view.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
            allowPDFDownload: true,
			document: true,
			fullPage: true,
			hideUserMessageBar: true,
			title: 'Payslip'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const directory = 'features/app/sox-report/';

    $stateProvider

	.state('sox-report', {
		controller: 'soxReportCtrl',
		data: {
	        allowPDFDownload: true,
			document: true,
			fullPage: true
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		templateUrl: directory + 'sox-report.view.html',
		url: '/sox-report/:agencyProfileId/:payPeriodId'
	});

}]);



'use strict';

angular.module('paycircleApp')

.controller('soxReportCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'$window',
	'applicationService',
	'reportData',
	'utilities',
	function (
		$rootScope,
		$scope,
		$stateParams,
		$window,
		applicationService,
		reportData,
		utilities
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const payPeriodId = $stateParams.payPeriodId;

	function init () {

		applicationService.setUserMessageState(null);

		setPageState('loading');

		reportData.getSOXReport(agencyProfileId, payPeriodId).then(soxReportObj => {

			angular.extend($scope, {
				breakdownItems: getBreakdownItems(soxReportObj),
				soxReport: soxReportObj
			});

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function getBreakdownItems (soxReportObj) {

		const defaultItemsArr = [
			{
				label: 'Total employee pay by BACS',
				value: soxReportObj.WorkerPaymentsBACS
			},
			{
				label: 'Total employee manual payments',
				value: soxReportObj.WorkerPaymentsManual
			},
			{
				label: 'Total due to HMRC',
				value: soxReportObj.TotalHMRCPayment
			},
			{
				label: 'Total pension costs',
				value: soxReportObj.TotalPensionPayments
			},
			{
				label: 'Total court orders',
				value: soxReportObj.TotalCourtOrderPayments
			}
		];

		// BACs Disbursements
		if (soxReportObj.Disbursements.length > 0) {
			for (let disbursementObj of soxReportObj.Disbursements) {
				defaultItemsArr.push({
					label: 'Total ' + disbursementObj.Name,
					value: disbursementObj.TotalPayment
				});
			}
		}

		return defaultItemsArr;
	}

	function openBrowserPrintDialog () {

		$window.print();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		goBack: utilities.goBack,
		openBrowserPrintDialog
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var templateDirectory = 'features/shared/reset-password/';

	$stateProvider

	/* Forgotten Password */
	.state('reset-password', {
		url: '/reset-password',
		templateUrl: templateDirectory + 'reset-password.view.html',
		controller: 'resetPasswordCtrl',
		data: {
			isPublic: true,
			title: 'Reset Password'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('resetPasswordCtrl', [
	'$scope',
	'$stateParams',
	'$timeout',
	'config',
	'growl',
	'securityData',
	'session',
	'utilities',
	function (
		$scope,
		$stateParams,
		$timeout,
		config,
		growl,
		securityData,
		session,
		utilities
	) {

	const customisationObj = session.getCustomisation();

	const PAGE_STATES = {
		error: 'error',
		invalidUsername: 'invalidUsername',
		resetPassword: 'resetPassword',
		resetPasswordConfirmation: 'resetPasswordConfirmation'
	};
	const REQUEST_STATES = {
		saving: 'saving',
		saved: 'saved'
	};
	const RESPONSE_CODES = {
		genericError: -1,
		usernameNotMatched: -2
	};

	function createPasswordRequest (userObj, formObj) {

		const REDIRECT_TO_PAYROLL = true;

		userObj.isInvalidUsername = false;

		formObj.state = REQUEST_STATES.saving;

		securityData.createPasswordRequest(userObj.username, REDIRECT_TO_PAYROLL).then(responseCode => {

			switch (responseCode) {

				// Username not matched
				case RESPONSE_CODES.usernameNotMatched: {
					userObj.isInvalidUsername = true;
					formObj.state = null;
					break;
				}

				// Success
				default: {
					formObj.state = REQUEST_STATES.saved;
					setPageState(PAGE_STATES.resetPasswordConfirmation);
				}
			}
		})
		.catch(error => {
			setPageState(PAGE_STATES.genericError);
			console.error(error);
		});
	}

	function init () {

		utilities.focusOn('username');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,
		createPasswordRequest,
		customisation: customisationObj,
		pageState: PAGE_STATES.resetPassword,
		user: {
			username: $stateParams.username
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const templateDirectory = 'features/shared/change-password/';

	$stateProvider

	.state('change-password', {
		url: '/change-password?token',
		templateUrl: templateDirectory + 'change-password.view.html',
		controller: 'changePasswordCtrl',
		data: {
			fullPage: true,
			isPublic: true,
			title: 'Change Password'
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('changePasswordCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'securityData',
	'session',
	'utilities',
	'AUTH_EVENTS',
	'INPUT_VALIDATION_TYPES',
	function (
		$rootScope,
		$scope,
		$stateParams,
		securityData,
		session,
		utilities,
		AUTH_EVENTS,
		INPUT_VALIDATION_TYPES
	) {

	const RESPONSE_CODES = {
		success: 0,
		genericError: -1,
		usernameNotMatched: -2,
		passwordPolicy: -3
	};

	const customisationObj = session.getCustomisation();

	function changePassword (credentialsObj, formObj) {

		formObj.state = 'saving';

		// Reset
		angular.extend(credentialsObj, {
			isGenericError: false,
			isInvalidPassword: false,
			isInvalidUsername: false
		});

		securityData.userChangePasswordByEmail(credentialsObj.username, credentialsObj.password, credentialsObj.token).then(responseCode => {

			switch (responseCode) {

				case RESPONSE_CODES.success: {

					formObj.state = 'saved';

					setPageState('success');

					// Destroy current session
					$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);

					break;
				}

				// Password policy rules not satisfied
				case RESPONSE_CODES.usernameNotMatched: {

					formObj.state = null;

					credentialsObj.isInvalidUsername = true;

					break;
				}

				// Password policy rules not satisfied
				case RESPONSE_CODES.passwordPolicy: {

					formObj.state = null;

					credentialsObj.isInvalidPassword = true;

					break;
				}

				default: {
					throw('Response code not recognised');
				}
			}
		})
		.catch(error => {

			formObj.state = null;

			credentialsObj.isGenericError = true;

			console.error(error);
		});
	}

	function init () {

		// No token
		if (angular.isUndefined($stateParams.token)) {
			setPageState('no-token');
			return;
		}

		setPageState('ready');
		utilities.focusOn('username');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		INPUT_VALIDATION_TYPES,

		changePassword,
		credentials: {
			state: '',
			password: '',
			passwordRepeated: '',
			username: '',
			token: $stateParams.token
		},
		customisation: customisationObj,
	});


}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const templateDirectory = 'features/shared/password-expired/';

	$stateProvider

	.state('password-expired', {
		url: '/password-expired',
		templateUrl: templateDirectory + 'password-expired.view.html',
		controller: 'passwordExpiredCtrl',
		data: {
			fullPage: true,
			isPublic: true,
			title: 'Password expiry'
		},
		params: {
			userResponse: null
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('passwordExpiredCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'securityData',
	'session',
	'utilities',
	'AUTH_EVENTS',
	'INPUT_VALIDATION_TYPES',
	function (
		$rootScope,
		$scope,
		$stateParams,
		securityData,
		session,
		utilities,
		AUTH_EVENTS,
		INPUT_VALIDATION_TYPES
	) {

	const RESPONSE_CODES = {
		success: 0,
		genericError: -1,
		userDoesNotExist: -2,
		incorrectExistingPassword: -3,
		passwordDoesNotSatisfyComplexityPolicy: -4,
		passwordChangedInPast24Hours: -5,
		passwordInHistory: -6
	};

	const customisationObj = session.getCustomisation();

	function changePassword (credentialsObj, formObj) {

		formObj.state = 'saving';

		// Reset response code
		angular.extend(credentialsObj, {
			responseCode: null
		});

		securityData.userChangePassword($stateParams.userResponse.UserResponseUserID, $stateParams.userResponse.passwordOriginal, credentialsObj.password).then(responseCode => {

			switch (responseCode) {

				case RESPONSE_CODES.success: {

					formObj.state = 'saved';

					setPageState('success');

					// Destroy current session
					$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);

					break;
				}

				// Password policy rules not satisfied
				case RESPONSE_CODES.userDoesNotExist:
				case RESPONSE_CODES.incorrectExistingPassword:
				case RESPONSE_CODES.passwordDoesNotSatisfyComplexityPolicy:
				case RESPONSE_CODES.passwordChangedInPast24Hours:
				case RESPONSE_CODES.passwordInHistory: {

					formObj.state = null;

					credentialsObj.responseCode = responseCode;

					break;
				}

				default: {
					console.error('Response code not recognised');
				}
			}
		})
		.catch(error => {

			formObj.state = null;

			credentialsObj.responseCode = RESPONSE_CODES.genericError;

			console.error(error);
		});
	}

	function init () {

		// No original password
		if (!$stateParams.userResponse || angular.isUndefined($stateParams.userResponse.passwordOriginal)) {
			setPageState('no-original-password');
			return;
		}

		angular.extend($scope, {

			INPUT_VALIDATION_TYPES,
			RESPONSE_CODES,

			changePassword,
			credentials: {
				password: '',
				passwordRepeated: '',
				responseCode: null
			},
			customisation: customisationObj
		});

		setPageState('ready');
		utilities.focusOn('new-password');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const directory = 'features/app/trial-signup/';
	
	$stateProvider
	.state('trial-signup', {
		url: '/trial-signup/:companyKey?emailAddress&state=sent',
		templateUrl: directory + 'trial-signup.view.html',
		controller: 'trialSignupCtrl',
		data: {
			isPublic: true,
			fullPage: true,
			title: 'Trial Sign-up'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('trialSignupCtrl', [
	'$scope',
	'$stateParams',
	'$timeout',
	'base',
	'companyData',
	'config',
	'intercomService',
	'tracking',
	'utilities',
	'TRACKING_EVENTS',
	function (
		$scope,
		$stateParams,
		$timeout,
		base,
		companyData,
		config,
		intercomService,
		tracking,
		utilities,
		TRACKING_EVENTS
	) {

	var pageState = $stateParams.state;
	var companyKey = $stateParams.companyKey;
	var emailAddress = $stateParams.emailAddress !== undefined ? $stateParams.emailAddress : '';

	function getPretitleByDemonstrationEnabled (isDemonstration) {
		
		if (isDemonstration) {
			return config.demoCompanyTrialLength + '-day free trial setup';
		}
		else {
			return 'Onboarding registration';
		}
	}

	function init () {

		var isDemonstration = utilities.getIsDemonstrationActiveByCompanyKey(companyKey);

		$scope.vm = {
			emailAddress: utilities.paycircleDecodeEmail(emailAddress),
			bureau: utilities.getBureauIdByCompanyKey(companyKey),
			demonstration: isDemonstration,
			pretitle: getPretitleByDemonstrationEnabled(isDemonstration)
		};

		switch (pageState) {
			case 'sent':
				
				setRequestState('request-sending');

				// Give user time to digest comms
				$timeout(function () {
					requestActivationCode($scope.vm);
				}, 2000);
				break;
			default:
				setRequestState('request');
		}

		setPageState('ready');
	}

	function requestActivationCode (vmObj) {

		vmObj.savingState = 'saving';

		companyData.createOnboardingCompanyInvite(vmObj.bureau, vmObj.emailAddress, vmObj.demonstration).then(() => {

			setRequestState('request-sent');

			vmObj.savingState = null;

			// Intercom
			intercomService.createLead(vmObj.emailAddress, {
				name: '',
				onboarding_activation_code_requested: true
			});
			tracking.trackEvent(vmObj.demonstration ? TRACKING_EVENTS.requestedActivationCodeDemo : TRACKING_EVENTS.requestedActivationCodeOnboarding);
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			vmObj.savingState = null;
		});
	}

	function resetPage () {

		setPageState('ready');
		setRequestState('request');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setRequestState (requestState) {

		$scope.requestState = requestState;
	}

	init();

	angular.extend($scope, {
		companyKey,
		isWhitelabel: utilities.getIsWhitelabelByCompanyKey(companyKey),
		requestActivationCode,
		resetPage,
		setRequestState
	});

}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function ($stateProvider) {

	$stateProvider.state('switch-account', {
		url: '/switch-account/:userId',
		templateUrl: 'features/app/switch-account/switch-account.view.html',
		controller: 'switchAccountCtrl',
		data: {
			fullPage: true,
			title: 'Accounts'
		},
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('switchAccountCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'securityData',
	'silentAuthService',
	'AUTH_ERRORS',
	'AUTH_EVENTS',
function (
	$rootScope,
	$scope,
	$state,
	$stateParams,
	securityData,
	silentAuthService,
	AUTH_ERRORS,
	AUTH_EVENTS
) {

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const userId = $stateParams.userId;

	function init () {
		setPageState(PAGE_STATES.loading);

		securityData.getSwitchAccountMinimalList(userId).then((data) => {
			angular.extend($scope, {
				accountsList: data,
			});

			setPageState(PAGE_STATES.ready);

		}).catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function onAccountCardClick (userID) {
		securityData.switchProfile(userID).then((data) => {

			if (data && data.Error === AUTH_ERRORS.evoMigrationRequired) {
				silentAuthService.goToEvoMigration(data.IdentityUrl);
				return;
			}

			$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);
			$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, data);
		}).catch(error => {
			if (error.data && error.data.Error === AUTH_ERRORS.evoMigrationRequired) {
				silentAuthService.goToEvoMigration(error.data.IdentityUrl);
			} else {
				setPageState(PAGE_STATES.error);
				console.error(error);
			}
		});
	}

	function goLinkAccounts(){
		$state.go('manage-linked-accounts', {
			userId: userId,
			agencyProfileId: $rootScope.currentUser.AgencyProfileParentID
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,
		onAccountCardClick,
		goLinkAccounts
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'INTERFACE_TYPES', 'USER_ROLES', function ($stateProvider, INTERFACE_TYPES, USER_ROLES) {

	var directory = 'features/app/bureau-dashboard/';
	$stateProvider

	.state('dashboard', {
		url: '/dashboard/:agencyProfileId',
		templateUrl: directory + 'bureau-dashboard.view.html',
		controller: 'bureauDashboardCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			helpAndSupportOptions: {
				isContextual: true,
				[INTERFACE_TYPES.bureau]: {
					tags: ['bureau-dashboard']
				},
				[INTERFACE_TYPES.group]: {
					tags: ['group-dashboard']
				}
			},
			title: 'Dashboard',
			unauthorisedRoles: [USER_ROLES.sme, USER_ROLES.companyadmin]
		}
   	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('bureauDashboardCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'$timeout',
	'agency',
	'session',
	'userData',
	'PRESET_FILTER_KEYS',
	function (
		$q,
		$scope,
		$stateParams,
		$timeout,
		agency,
		session,
		userData,
		PRESET_FILTER_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		const getDashboardData = agency.getDashboardData(agencyProfileId);
		const getTeamMemberIncomplete = userData.getTeamMemberIncomplete(agencyProfileId);

		$q.all([
			getDashboardData,
			getTeamMemberIncomplete
		]).then(([
			dashboardDataObj,
			incompleteTeamMembersObj
		]) => {

			dashboardDataObj.TeamMemberListIncomplete = incompleteTeamMembersObj.filter(teamMember => teamMember.IncludedInIncompleteDashboardCount);

			angular.extend($scope, {
				activeDashTile: '',
				dashboard: dashboardDataObj,
				previousMonth: moment().subtract(1, 'month'),
				thisMonth: moment()
			});

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleActiveDashTile (tileObj) {

		$scope.incomingDashTile = tileObj;

		if ($scope.activeDashTile !== '') {
			$scope.tileClosing = true;
			$scope.holdTheScroll = true;
			$timeout(() => {
				$scope.activeDashTile = $scope.activeDashTile === tileObj ? '' : tileObj;
				$scope.incomingDashTile = '';
				$scope.tileClosing = false;
				$timeout(() => {
					$scope.holdTheScroll = false;
				}, 300);
			}, 300);
		}
		else {
			$scope.activeDashTile = tileObj;
		}
	}

	init();

	angular.extend($scope, {
		PRESET_FILTER_KEYS,
		agencyProfileId,
		toggleActiveDashTile
	});
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const directory = 'features/app/bureaus-archived/';
	$stateProvider
		.state('bureaus-archived', {
			url: '/bureaus-archived/:agencyProfileId',
			templateUrl: directory + 'bureausArchivedView.html',
			controller: 'bureausArchivedCtrl',
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			},
			data: {
			    title: 'Bureaus - Archived'
			}
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('bureausArchivedCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'companyData',
	'filterService',
	'searchService',
	'session',
	'INTERFACE_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		companyData,
		filterService,
		searchService,
		session,
		INTERFACE_TYPES
	) {

	const agencyProfileParentId = $stateParams.agencyProfileId;
	const loggedInUserId = session.getUserId();

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function decorateArchivedBureaus (archivedBureausArr) {

		archivedBureausArr.forEach(archivedBureauObj => {
			// Make sure a date is provided to allow for filter (date = date Archiving was built)
			archivedBureauObj.Company.ArchiveDateISO = archivedBureauObj.Company.ArchiveDateISO !== '' ? archivedBureauObj.Company.ArchiveDateISO : moment('2019-08-01T00:00:00').format();
			// Default empty archive reason to 'Unknown'
			archivedBureauObj.Company.ArchiveReason = archivedBureauObj.Company.ArchiveReason !== '' ? archivedBureauObj.Company.ArchiveReason : 'Unknown';
		});

		return archivedBureausArr;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		const ARCHIVED = true;

		companyData.getAgencyProfileAgencyProfilesForParent(
			loggedInUserId,
			agencyProfileParentId,
			INTERFACE_TYPES.bureau,
			ARCHIVED
		)
		.then(archivedBureausArr => {
			$scope.vm = {
				archivedBureaus: decorateArchivedBureaus(archivedBureausArr),
			};

			setPageState(PAGE_STATES.ready);
		})
		.catch(function (error) {
			console.error(error);
			setPageState(PAGE_STATES.error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		PAGE_STATES,

		filterBarOptions: filterService.bureausArchived,
		refreshArchivedBureaus: init,
		searchBarOptions: searchService.bureausArchived
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	let directory = 'features/app/workflow';

	$stateProvider

	.state('workflow', {
		abstract: true,
		url: '/workflow/:agencyProfileId',
		templateUrl: directory + '/workflow.view.html',
		controller: 'workflowCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			helpAndSupportOptions: {
				tags: ['bureau-workflow']
			},
			unauthorisedRoles: [USER_ROLES.sme, USER_ROLES.companyadmin],
			title: 'Workflow'
		}
	})
		.state('workflow.activity', {
			url: '/activity',
			controller: 'workflowActivityCtrl',
			templateUrl: directory + '/activity/workflow-activity.view.html'
		})
		.state('workflow.companies', {
			url: '/companies?applyFilter',
			controller: 'workflowCompaniesCtrl',
			templateUrl: directory + '/companies/workflow-companies.view.html',
			data: {
				helpAndSupportOptions: {
					tags: ['company', 'workflow']
				}
			}
		})
		.state('workflow.overview', {
			url: '/overview',
			controller: 'workflowOverviewCtrl',
			templateUrl: directory + '/overview/workflow-overview.view.html'
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('workflowCtrl', ['$scope', '$stateParams', 'teamData', function($scope, $stateParams, teamData) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		// Get list of team member admins. Used for filters in tabs and srefs.
		teamData.getTeamMemberAdmins(agencyProfileId).then(teamMemberAdmins => {

			angular.extend($scope.vm, {
				teamMemberAdmins
			});

			setPageState('ready');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	$scope.vm = {
		agencyProfileId
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('workflowActivityCtrl', ['$scope', '$stateParams', 'bulkService', 'filterService', 'messageData', 'searchService', 'workflowService', function($scope, $stateParams, bulkService, filterService, messageData, searchService, workflowService) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		messageData.getWorkflowLogEntries(agencyProfileId).then(workflowActivityLogArr => {

			if (workflowActivityLogArr.length) {
				workflowService.decorateWorkflowActivityLogForGrouping(workflowActivityLogArr);
			}

			let workflowActivityLogEntries = bulkService.getBulkItemsObj(workflowActivityLogArr);
			angular.extend($scope.vm, {
				workflowActivityLogEntries
			});

			setPageState('ready');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	angular.extend($scope, {
		searchBarOptions: searchService.bureauWorkflowActivityLog
	});

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('workflowCompaniesCtrl', ['$rootScope', '$scope', '$stateParams', 'bulkService', 'config', 'filterService', 'messageData', 'searchService', 'session', 'FILTER_KEYS', function($rootScope, $scope, $stateParams, bulkService, config, filterService, messageData, searchService, session, FILTER_KEYS) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const applyFilter = $stateParams.applyFilter;

	// Courtesy of parent bureauWorkflowController
	const teamMemberAdmins = $scope.vm.teamMemberAdmins;

	function init () {

		setPageState('loading');

		messageData.getWorkflowTemplateCurrentEntries(agencyProfileId).then(workflowTasksArr => {

			// Create dynamic list of assignee filter options for the filter service.
			let assigneeFilterOptions = teamMemberAdmins.map((teamMemberAdmin, i) => {
				// Translate the current user in the admin list as 'You' with UserID = current user ID
				let teamMemberAdminName = '';
				let teamMemberAdminID = '';
				if (teamMemberAdmin.UserID === session.user.UserResponseUserID) {
					teamMemberAdminName = 'You';
				}
				else {
					teamMemberAdminName = `${teamMemberAdmin.Forename} ${teamMemberAdmin.Surname}`;
				}
				teamMemberAdminID = teamMemberAdmin.UserID;
				// Build the filter for this user
				return {
					name: teamMemberAdminName,
					// Generate a unique key for this filter
					key: `${FILTER_KEYS.bureauWorkflowTasks.teamMember.assignee}_${i}`,
					filterExp: value => value.ActionerID === teamMemberAdminID
				};
			});
			// Finally, insert filters. (The filter bar options have been copied, so this is safe).
			let teamMemberFilterGroup = $scope.filterBarOptions.filterGroups.find(filterGroup => filterGroup.name === 'Team Member');
			if (teamMemberFilterGroup) {
				if (assigneeFilterOptions.length > 0) {
					// Add specific team member filters to start of filter options
					teamMemberFilterGroup.filterOptions.unshift(...assigneeFilterOptions);
				}
			}

			let workflowTasks = bulkService.getBulkItemsObj(workflowTasksArr);
			$scope.vm = {
				workflowTasks
			};

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function openReassignWorkflowTaskForm (workflowTaskObjs) {

		$rootScope.openSlideInForm({
			callback: refreshView,
			formKey: 'reassign-workflow-task',
			showContext: false,
			workflowTasks: workflowTaskObjs,
			agencyProfileId: agencyProfileId
		});
	}

	function refreshView () {

		init();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	angular.extend($scope, {
		agencyProfileId,
		applyFilter,
		// Copy these so they can be manipulated. (Dynamic entries are made for team members).
		filterBarOptions: angular.copy(filterService.bureauWorkflowTasks),
		openReassignWorkflowTaskForm,
		refreshView,
		searchBarOptions: searchService.bureauWorkflowTasks
	});

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('workflowOverviewCtrl', ['$scope', '$stateParams', 'messageData', 'workflowService', function($scope, $stateParams, messageData, workflowService) {

	const agencyProfileId = $stateParams.agencyProfileId;

	// Courtesy of parent bureauWorkflowController
	const teamMemberAdmins = $scope.vm.teamMemberAdmins;

	function init () {

		setPageState('loading');

		messageData.getWorkflowOverview(agencyProfileId).then(workflowOverview => {

			if (workflowOverview.LogList.length) {
				workflowService.decorateWorkflowActivityLogForGrouping(workflowOverview.LogList);
			}

			angular.extend($scope.vm, {
				workflowOverview
			});

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope.vm, {
		agencyProfileId,
		teamMemberAdminCount: teamMemberAdmins.length
	});

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'INTERFACE_TYPES', function ($stateProvider, INTERFACE_TYPES) {

	var directory = 'features/app/companies/';
	$stateProvider
		.state('companies', {
			url: '/companies/:agencyProfileId?applyfilter&presetfilterkey',
			templateUrl: directory + 'companiesView.html',
			controller: 'companiesCtrl',
			data: {
				helpAndSupportOptions: {
					isContextual: true,
					[INTERFACE_TYPES.bureau]: {
						tags: ['bureau-companies']
					},
					[INTERFACE_TYPES.group]: {
						tags: ['group-companies']
					}
				},
				title: 'Companies'
			},
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			}
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('companiesCtrl', [
	'$filter',
	'$rootScope', 
	'$scope',
	'$stateParams',
	'bulkService', 
	'companyData', 
	'filterService', 
	'searchService',
	'FORM_WIZARD_KEYS', 
	'INTERFACE_TYPES', 
	'SUBMISSION_STATES', 
	'SUBMISSION_TYPES',
	function (
		$filter,
		$rootScope, 
		$scope,
		$stateParams,
		bulkService, 
		companyData, 
		filterService, 
		searchService, 
		FORM_WIZARD_KEYS,
		INTERFACE_TYPES,
		SUBMISSION_STATES,
		SUBMISSION_TYPES
	) {

	const agencyProfileParentId = $stateParams.agencyProfileId;
	const appliedFilters = $stateParams.appliedfilters;
	const presetFilterKey = $stateParams.presetfilterkey;
	const currentUserObj = $rootScope.currentUser;

	function areSelectedCompaniesValid (companies) {

		var companiesCount = companies.length;
		var i = 0;

		for (i; i < companiesCount; i++) {

			var company = companies[i];

			// Payroll is submitting or failed
			if (company.PayPeriod.PayrollState > SUBMISSION_STATES.unsubmitted) {
				return false;
			}
		}

		return true;
	}

	function companiesFilter (company) {

		// Filter out parent companies
		switch (company.Company.CompanyType) {
			case INTERFACE_TYPES.group:
			case INTERFACE_TYPES.bureau:
				return;
		}

		company.isSelected = false;

		// Attach pay date unix value for sorting
		if (company.PayPeriod) {
			company.PayPeriod.payDateUnix = '';

			if (company.PayPeriod.PayDateISO !== '') {
				company.PayPeriod.payDateUnix = $filter('isoUnix')(company.PayPeriod.PayDateISO);
			}
		}

		// Attach rti error type if applicable - used for retrieving the last RTI error when resetting payroll
		if (company.PayPeriod.FPSState === SUBMISSION_STATES.failed) {
			company.PayPeriod.rtiErrorType = SUBMISSION_TYPES.fps;
		}
		else if (company.PayPeriod.EPSState === SUBMISSION_STATES.failed) {
			company.PayPeriod.rtiErrorType = SUBMISSION_TYPES.eps;
		}
		else if (company.PayPeriod.CIS300State === SUBMISSION_STATES.failed) {
			company.PayPeriod.rtiErrorType = SUBMISSION_TYPES.cis;
		}
		else if (company.PayPeriod.PayrollState === SUBMISSION_STATES.failed) {
			company.PayPeriod.rtiErrorType = SUBMISSION_TYPES.unspecified;
		}

		return company;
	}

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileAgencyProfilesForParent(currentUserObj.UserResponseUserID, agencyProfileParentId).then(companiesArray => {

			$scope.agencyProfileParentId = agencyProfileParentId;
			$scope.companies = bulkService.getBulkItemsObj(companiesArray.filter(companiesFilter));

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
	    console.error(error);
	}

	function openAddCompaniesToCompanyGroupForm (filteredCompaniesArr) {

		$rootScope.openSlideInForm({
			agencyProfileIdList: bulkService.getSelectedIdsForDataType(filteredCompaniesArr, 'companies'),
			agencyProfileParentId,
			formKey: 'bulk-add-to-company-group',
			title: 'Add to group'
		});
	}

	function openAddCompanyWizard () {

		$rootScope.$broadcast('open-form-wizard', {
			title: 'Create company',
			wizardKey: FORM_WIZARD_KEYS.company,
			callback: init,
			showHeader: true,
			primaryButtonText: 'Next',
			agencyProfileParentId: agencyProfileParentId
		});
	}

	function openAutoCreateCompanyForm () {

		$rootScope.$broadcast('open-slide-in-form', {
			callback: init,
			formKey: 'auto-create-company',
			agencyProfileParentId: agencyProfileParentId
		});
	}

	function openRunBulkPayrollsForm (filteredCompaniesArr) {

		const selectedCompaniesArr = bulkService.getSelectedItems(filteredCompaniesArr);

		// Validate selected companies
		if (!areSelectedCompaniesValid(selectedCompaniesArr)) {
			$rootScope.openModalDialog('company-invalid-payroll-states');
			return;
		}

		const selectedCompaniesIdArray = bulkService.getValuesFromArray(selectedCompaniesArr, 'AgencyProfileID', 'Company');

		$rootScope.openSlideInForm({
			agencyProfiles: selectedCompaniesArr,
			agencyProfileId: agencyProfileParentId,
			agencyProfilesIdArray: selectedCompaniesIdArray,
			callback: updateCompaniesFromArray,
			formKey: 'run-payroll-bulk',
			title: 'Run payroll'
		});
	}

	function refreshCompanyInList (updatedCompanyObj) {

		let companyIndexAll = $scope.companies.all.findIndex(companyObj => companyObj.Company.AgencyProfileID === updatedCompanyObj.Company.AgencyProfileID);

		$scope.companies.all.splice(companyIndexAll, 1, companiesFilter(updatedCompanyObj));
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function reloadCompany (companyObj) {

		companyData.getAgencyProfileAgencyProfile(companyObj.Company.AgencyProfileID)
			.then(refreshCompanyInList)
			.catch(onError);
	}

	function updateCompaniesFromArray (companiesArray) {

		// Reset bulk select
		$scope.companies.totalSelected = 0;

		companiesArray.forEach(reloadCompany);
	}

	init();

	angular.extend($scope, {
		appliedFilters: appliedFilters,
		filterBarOptions: filterService.getFilterBarOptionsCompanies(currentUserObj),
		openAddCompanyWizard: openAddCompanyWizard,
		openAddCompaniesToCompanyGroupForm: openAddCompaniesToCompanyGroupForm,
		openAutoCreateCompanyForm: openAutoCreateCompanyForm,
		openRunBulkPayrollsForm: openRunBulkPayrollsForm,
		presetFilterKey: presetFilterKey,
		reloadCompanies: init,
		reloadCompany: reloadCompany,
		searchBarOptions: searchService.companies,
		updateSelectedCompaniesCount: bulkService.updateBulkItemTotals
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'INTERFACE_TYPES', function ($stateProvider, INTERFACE_TYPES) {

	var directory = 'features/app/companies-archived/';
	$stateProvider
		.state('companies-archived', {
			url: '/companies-archived/:agencyProfileId',
			templateUrl: directory + 'companiesArchivedView.html',
			controller: 'companiesArchivedCtrl',
			data: {
				helpAndSupportOptions: {
					isContextual: true,
					[INTERFACE_TYPES.bureau]: {
						tags: ['bureau-archive']
					},
					[INTERFACE_TYPES.group]: {
						tags: ['group-archive']
					}
				},
				title: 'Companies - Archived'
			},
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			}
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('companiesArchivedCtrl', ['$q', '$rootScope', '$scope', '$state', '$stateParams', 'applicationService', 'companyData', 'filterService', 'searchService', 'session', 'INTERFACE_TYPES', function ($q, $rootScope, $scope, $state, $stateParams, applicationService, companyData, filterService, searchService, session, INTERFACE_TYPES) {

	var agencyProfileParentId = $stateParams.agencyProfileId;
	var loggedInUserId = session.getUserId();

	function archivedCompanyFilter (archivedCompanyObj) {

		// Filter out parent companies
		switch (archivedCompanyObj.Company.CompanyType) {
			case INTERFACE_TYPES.group:
			case INTERFACE_TYPES.bureau:
				return;
		}

		archivedCompanyObj.Company.ArchiveDateISO = archivedCompanyObj.Company.ArchiveDateISO !== '' ? archivedCompanyObj.Company.ArchiveDateISO : moment('2019-08-01T00:00:00').format(); // Make sure a date is provided to allow for filter (date = date Archiving was built)
		archivedCompanyObj.Company.ArchiveReason = archivedCompanyObj.Company.ArchiveReason !== '' ? archivedCompanyObj.Company.ArchiveReason : 'Unknown';

		return archivedCompanyObj;
	}

	function init () {

		setPageState('loading');

		const ARCHIVED = true;
		var INTERFACE_TYPE; // Undefined to use default

		companyData.getAgencyProfileAgencyProfilesForParent(
			loggedInUserId,
			agencyProfileParentId,
			INTERFACE_TYPE,
			ARCHIVED
		)
		.then(archivedCompaniesArr => {

			$scope.vm = {
				archivedCompanies: archivedCompaniesArr.filter(archivedCompanyFilter)
			};

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		filterBarOptions: filterService.companiesArchived,
		refreshCompanies: init,
		searchBarOptions: searchService.companiesArchived
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/companies-cloned/';
	$stateProvider
		.state('companies-cloned', {
			url: '/companies-cloned/:agencyProfileId',
			templateUrl: directory + 'companies-cloned.view.html',
			controller: 'companiesClonedCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['bureau-cloned-companies']
				},
				title: 'Compaines - Cloned'
			},
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			}
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('companiesClonedCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	'filterService',
	'searchService',
	'session',
	'INTERFACE_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		companyData,
		filterService,
		searchService,
		session,
		INTERFACE_TYPES
	) {

	const agencyProfileParentId = $stateParams.agencyProfileId;
	const currentUserObj = $rootScope.currentUser;
	const loggedInUserId = session.getUserId();

	function clonedCompanyFilter (clonedCompanyObj) {

		// Filter out parent companies
		switch (clonedCompanyObj.Company.CompanyType) {
			case INTERFACE_TYPES.group:
			case INTERFACE_TYPES.bureau:
				return;
		}

		clonedCompanyObj.Company.ArchiveDateISO = clonedCompanyObj.Company.ArchiveDateISO !== '' ? clonedCompanyObj.Company.ArchiveDateISO : moment('2019-08-01T00:00:00').format(); // Make sure a date is provided to allow for filter (date = date Archiving was built)
		clonedCompanyObj.Company.ArchiveReason = clonedCompanyObj.Company.ArchiveReason !== '' ? clonedCompanyObj.Company.ArchiveReason : 'Unknown';

		return clonedCompanyObj;
	}

	function init () {

		setPageState('loading');

		const ARCHIVED = false;
		const CLONED = true;
		var INTERFACE_TYPE; // Undefined to use default

		companyData.getAgencyProfileAgencyProfilesForParent(
			loggedInUserId,
			agencyProfileParentId,
			INTERFACE_TYPE,
			ARCHIVED,
			CLONED
		)
		.then(clonedCompaniesArr => {

			$scope.vm = {
				clonedCompanies: clonedCompaniesArr.filter(clonedCompanyFilter)
			};

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		filterBarOptions: filterService.getFilterBarOptionsCompanies(currentUserObj),
		reloadCompanies: init,
		searchBarOptions: searchService.companiesArchived
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	var directory = 'features/app/company-groups/';
	$stateProvider
		.state('company-groups', {
			url: '/company-groups/:agencyProfileId',
			templateUrl: directory + 'companyGroupsView.html',
			controller: 'companyGroupsCtrl',
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			},
			data: {
				helpAndSupportOptions: {
					tags: ['bureau-company-groups']
				},
				unauthorisedRoles: [USER_ROLES.sme, USER_ROLES.companyadmin],
				title: 'Company Groups'
			}
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('companyGroupsCtrl', ['$rootScope', '$scope', '$stateParams', 'bulkService', 'companyData', 'searchService', 'session', 'INTERFACE_TYPES', function ($rootScope, $scope, $stateParams, bulkService, companyData, searchService, session, INTERFACE_TYPES) {

	var agencyProfileParentId = $stateParams.agencyProfileId;
	var userId = session.getUserId();

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileAgencyProfilesForParent(userId, agencyProfileParentId, INTERFACE_TYPES.group).then(function (companiesArray) {

			$scope.companyGroups = bulkService.getBulkItemsObj(companiesArray);

			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function openAddNewCompanyGroupForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileParentId,
			formKey: 'add-new-company-group',
			callback: init
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileParentId: agencyProfileParentId,
		openAddNewCompanyGroupForm: openAddNewCompanyGroupForm,
		refreshCompanyGroups: init,
		searchBarOptions: searchService.companyGroups
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	var directory = 'features/app/bureaus/';
	$stateProvider
		.state('bureaus', {
			url: '/bureaus/:agencyProfileId',
			templateUrl: directory + 'bureausView.html',
			controller: 'bureausCtrl',
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			},
			data: {
				authorisedRoles: [USER_ROLES.paycircle],
				title: 'Bureaus'
			}
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('bureausCtrl', ['$rootScope', '$scope', 'bulkService', 'companyData', 'searchService', 'session', 'INTERFACE_TYPES', function ($rootScope, $scope, bulkService, companyData, searchService, session, INTERFACE_TYPES) {

	var agencyProfileParentId = session.getAgencyProfileParentId();
	var interfaceType = INTERFACE_TYPES.bureau;
	var userId = session.getUserId();

	function init () {

		$scope.pageState = 'loading';

		companyData.getAgencyProfileAgencyProfilesForParent(userId, agencyProfileParentId, interfaceType).then(function (bureausArray) {

			// Assign to scope
			$scope.bureaus = bulkService.getBulkItemsObj(bureausArray);

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();

	// Scope variables
	$scope.searchBarOptions = searchService.bureaus;

	// Scope functions
	$scope.openAddNewBureauForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileParentId,
			formKey: 'add-new-bureau',
			callback: init
		});
	};

	$scope.refreshBureaus = function () {

		init();
	};
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	var directory = 'features/app/bureau-onboarding/';
	$stateProvider
		.state('bureau-onboarding', {
			url: '/bureau-onboarding/:agencyProfileId',
			templateUrl: directory + 'bureauOnboardingView.html',
			controller: 'bureauOnboardingCtrl',
			resolve: {
				auth: ['AuthResolverCompany', function (AuthResolverCompany) {
					return AuthResolverCompany.resolve();
				}]
			},
			data: {
				title: 'Onboarding',
				unauthorisedRoles: [USER_ROLES.sme, USER_ROLES.companyadmin]
			}
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('bureauOnboardingCtrl', ['$rootScope', '$scope', '$stateParams', 'bulkService', 'companyData', 'filterService', 'searchService', function ($rootScope, $scope, $stateParams, bulkService, companyData, filterService, searchService) {

	var agencyProfileParentId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		companyData.getOnboardingCompanies(agencyProfileParentId).then(function (companiesArray) {

			$scope.companies = bulkService.getBulkItemsObj(companiesArray.Companies);

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	// Scope variables
	$scope.agencyProfileParentId = agencyProfileParentId;
	$scope.filterBarOptions = filterService.onboarding;
	$scope.searchBarOptions = searchService.onboarding;

	init();

	$scope.openBureauNewCompanyForm = function (isDemonstration) {

		$rootScope.openSlideInForm({
			title: isDemonstration ? 'New demo company' : 'Onboard new company',
			agencyProfileParentId: agencyProfileParentId,
			callback: init,
			formKey: 'onboarding-bureau-new-company',
			isDemonstration: isDemonstration,
			showContext: false,
		});
	};

	$scope.reloadCompanies = function () {

		init();
	};
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	var directory = 'features/app/my-tasks/';

	$stateProvider

	.state('my-tasks', {
		abstract: true,
		url: '/my-tasks/:agencyProfileId',
		templateUrl: directory + 'myTasksView.html',
		controller: 'myTasksCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			helpAndSupportOptions: {
				tags: ['bureau-my-tasks']
			},
			unauthorisedRoles: [USER_ROLES.sme, USER_ROLES.companyadmin],
			title: 'My Tasks'
		}
	})

		.state('my-tasks.workflow', {
			url: '/workflow',
			controller: 'myTasksWorkflowCtrl',
			templateUrl: directory + 'myTasksWorkflowView.html'
		})

		.state('my-tasks.payroll', {
			url: '/payroll',
			controller: 'myTasksPayrollCtrl',
			templateUrl: directory + 'myTasksPayrollView.html'
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('myTasksCtrl', ['$scope', '$stateParams', 'applicationService', 'bulkService', 'config', 'messageData', 'session', 'workflowService',
	function ($scope, $stateParams, applicationService, bulkService, config, messageData, session, workflowService) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const userId = session.getUserId();

	function init() {

		// Get workflow tasks and payroll tasks for the tabs.
		workflowService.refreshUserTasks(agencyProfileId, userId).then(userTasksObj => {

			// Workflow tasks
			let workflowTasks = bulkService.getBulkItemsObj(userTasksObj.workflow);

			// Set all deselected. Also determine whether any are overdue.
			let workflowTasksOverdue = false;
			workflowTasks.all.forEach((workflowTask) => {
				workflowTask.isSelected = false;
				workflowTasksOverdue |= workflowTask.IsOverdue;
			});

			angular.extend($scope.vm.workflowTasks, {
				hasOverdueTasks: workflowTasksOverdue,
				taskCount: workflowTasks.all.length,
				tasks: workflowTasks
			});

			// Payroll tasks
			let payrollTasks = bulkService.getBulkItemsObj(userTasksObj.payroll);

			angular.extend($scope.vm.payrollTasks, {
				showComplete: true,
				showTaskCompany: true,
				taskCount: payrollTasks.all.length,
				tasks: payrollTasks
			});

			updatePayrollTasksCount($scope.vm.payrollTasks);

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function updatePayrollTasksCount (payrollTasksObj) {

		// Count incomplete tasks for UI counter in tab and determine whether any are overdue
		let payrollTasksIncompleteCount = 0;
		let payrollTasksOverdue = false;
		payrollTasksObj.tasks.all.forEach(payrollTask => {
			if (!payrollTask.IsComplete) {
				payrollTasksIncompleteCount++;
			}
			// Set overdue status only if any task is overdue *and* incomplete
			payrollTasksOverdue |= (payrollTask.IsOverdue && !payrollTask.IsComplete);
		});

		payrollTasksObj.hasOverdueTasks = payrollTasksOverdue;
		payrollTasksObj.incompleteTaskCount = payrollTasksIncompleteCount;

		// Do the same for the 'global' tasks count
		workflowService.updateUserTasksCount();
	}

	function setPageState (pageState) {

		$scope.vm.pageState = pageState;
	}

	$scope.vm = {
		agencyProfileId,
		isStateActive: applicationService.isStateActive,
		payrollTasks: {
			taskCount: 0
		},
		pageState: 'loading',
		workflowTasks: {
			taskCount: 0
		},
		refreshTasks: init,
		updatePayrollTasksCount,
		userId
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('myTasksWorkflowCtrl', ['$rootScope', '$scope', '$stateParams', 'filterService', 'searchService', function ($rootScope, $scope, $stateParams, filterService, searchService) {

	// From parent tab container controller
	const agencyProfileId = $stateParams.agencyProfileId;
	const refreshTasks = $scope.vm.refreshTasks;

	function openReassignWorkflowTaskForm (workflowTaskObjs) {

		// Get selected tasks
		let selectedTasks = workflowTaskObjs.filter(workflowTaskObj => workflowTaskObj.isSelected);

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshTasks,
			formKey: 'reassign-workflow-task',
			omitCurrentUser: true,
			showContext: false,
			title: 'Re-assign workflow step' + (selectedTasks.length > 1 ? 's' : ''),
			workflowTasks: selectedTasks
		});
	}

	angular.extend($scope, {
		filterBarOptions: filterService.workflowTasks,
		openReassignWorkflowTaskForm,
		searchBarOptions: searchService.workflowTasks
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('myTasksPayrollCtrl', ['$scope', 'filterService', 'searchService', function ($scope, filterService, searchService) {

	angular.extend($scope, {
		filterBarOptions: filterService.tasks,
		searchBarOptions: searchService.tasks
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {
	var directory = 'features/app/app-integrations/';
	$stateProvider

	.state('app-integrations', {
		url: '/app-integrations?code&state&error',
		templateUrl: directory + 'appIntegrationsView.html',
		controller: 'appIntegrationsCtrl',
		data: {
			isPublic: true,
			title: 'Integrations'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('appIntegrationsCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', 'companyData', 'session', 'utilities', function ($rootScope, $scope, $state, $stateParams, $timeout, companyData, session, utilities) {

	var agencyProfileId = $stateParams.state;
	var slackToken = $stateParams.code;

	function init () {

		setPageState('loading');

		// Slack integration cancelled
		if ($stateParams.error === 'access_denied') {
			$state.go('login', {state: agencyProfileId, sref: 'settings.company.integrations'});
			return;
		}
		
		// Incorrect URL
		if ($stateParams.code === undefined || !utilities.isValidGuid(agencyProfileId)) {
			setPageState('incorrect-url');
			return;
		}

		// Session exists
		if (session.user) {
			$state.go('settings.company.integrations', {agencyProfileId: agencyProfileId, state: agencyProfileId, code: slackToken});
			return;
		}
		
		$state.go('login', {state: agencyProfileId, code: slackToken});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);
'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {
	var directory = 'features/app/authorise-app/';
	$stateProvider

	.state('authorise-app', {
		url: '/authorise-app/:appKey?code&state&error',
		templateUrl: directory + 'authoriseAppView.html',
		controller: 'authoriseAppCtrl',
		data: {
			isPublic: true,
			title: 'Authorise App'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('authoriseAppCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'base',
	'companyData',
	'pensionData',
	'searchService',
	'session',
	'utilities',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		base,
		companyData,
		pensionData,
		searchService,
		session,
		utilities
	) {

	const LOADING_TIME = 5000;
	const CREDENTIAL_TYPE_XERO = 0;

	var appKey = $stateParams.appKey;
	var authorisationCode = $stateParams.code;
	var state = $stateParams.state;

	function closeWindow () {

		window.close();
	}

	function getMatchForCompanyName (xeroTenantData, agencyProfileName) {

		return xeroTenantData.tenants.find(tenantObj => tenantObj.tenantName.toLowerCase() === agencyProfileName.toLowerCase());
	}

	function init () {

		setPageState('connecting');

		let dataArray;
		let agencyProfileId;
		let agencyProfileName;
		let agencyEmployerPensionId;

		switch (appKey) {

			// Smart Pension
			case 'smart': {

				// Authorisation code not defined
				if (authorisationCode === undefined) {
					$rootScope.paycircleMessage('Authorisation code is not defined', 'error');
					setPageState('error');
					return;
				}

				// Check to make sure AgencyProfileId & AgencyEmployerPensionID are provided
				if (state.indexOf(',') === -1) {
					setPageState('error');
					return;
				}

				dataArray = state.split(','); // Smart do now allow any additional parameters on the return URI so this has been added to prepare for multiple pensions functionality

				agencyProfileId = dataArray[0];
				agencyEmployerPensionId = dataArray[1];

				// Incorrect URL
				if (!utilities.isValidGuid(agencyProfileId)) {
					$rootScope.paycircleMessage('Authorisation code is not defined', 'error');
					setPageState('error');
					return;
				}

				$timeout(() => {
					
					pensionData.updateSmartPensionAccessToken(agencyProfileId, authorisationCode, agencyEmployerPensionId).then(function () {
						setPageState('connected');
					})
					.catch(onError);
				}, LOADING_TIME);

				break;
			}

			// Peoples Pension
			case 'peoples': {

				// Authorisation code not defined
				if (authorisationCode === undefined) {
					$rootScope.paycircleMessage('Authorisation code is not defined', 'error');
					setPageState('error');
					return;
				}

				// Check to make sure AgencyProfileId & AgencyEmployerPensionID are provided
				if (state.indexOf(',') === -1) {
					setPageState('error');
					return;
				}

				dataArray = state.split(','); // Smart do now allow any additional parameters on the return URI so this has been added to prepare for multiple pensions functionality

				agencyProfileId = dataArray[0];
				agencyEmployerPensionId = dataArray[1];

				// Incorrect URL
				if (!utilities.isValidGuid(agencyProfileId)) {
					$rootScope.paycircleMessage('Authorisation code is not defined', 'error');
					setPageState('error');
					return;
				}

				$timeout(() => {
					
					pensionData.updatePeoplesPensionAccessToken(agencyProfileId, authorisationCode, agencyEmployerPensionId).then(function () {
						setPageState('connected');
					})
					.catch(onError);
				}, LOADING_TIME);

				break;
			}

			// Xero
			case 'xero': {

				if (state.indexOf('|') > -1) {
					dataArray = state.split('|'); // ?state param = {agencyProfileId|companyName}
					agencyProfileId = dataArray[0];
					agencyProfileName = dataArray[1];
				}
				else {
					agencyProfileId = state;
				}

				// Authorisation code not defined
				if (authorisationCode === undefined) {
					$rootScope.paycircleMessage('Authorisation code is not defined', 'error');
					setPageState('error');
					return;
				}

				// Incorrect URL
				if (!utilities.isValidGuid(agencyProfileId)) {
					$rootScope.paycircleMessage('Agency profile id is not provided or invalid', 'error');
					setPageState('error');
					return;
				}

				$timeout(() => {
					
					base.getXeroAccessToken(agencyProfileId, authorisationCode).then(xeroTenantData => {

						if (!xeroTenantData.status) {
							setPageState('xero-reauthorise');
							return;
						}

						angular.extend($scope, {
							agencyProfileId,
							searchBarOptions: searchService.xeroTenants,
							xeroTenantData
						});

						const tenantMatchObj = getMatchForCompanyName(xeroTenantData, agencyProfileName);

					// Check to automatically match tenant by name
					if (tenantMatchObj) {
						updateAgencyProfileXeroCredentialTenantId(agencyProfileId, tenantMatchObj);
					}

						// Unable to match tenant by name, manually select
						else {						
							setPageState('select-tenant');
						}
					})
					.catch(onError);
				}, LOADING_TIME);

				break;
			}
		}
		
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyProfileXeroCredentialTenantId (agencyProfileId, tenantObj) {

		base.updateAgencyProfileCredentialTenantId(agencyProfileId, CREDENTIAL_TYPE_XERO, tenantObj.tenantId, tenantObj.tenantName).then(() => {

			setPageState('connected');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		appKey,
		closeWindow,
		updateAgencyProfileXeroCredentialTenantId
	});
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	const directory = 'features/app/agency-dashboard/';

	$stateProvider
	.state('agency-dashboard', {
		url: '/agency-dashboard/:agencyProfileId?completedDemo',
		templateUrl: directory + 'agency-dashboard.view.html',
		controller: 'agencyDashboardCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			title: 'Dashboard'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('agencyDashboardCtrl', [
	'$scope',
	'$stateParams',
	'companyData',
	function (
		$scope,
		$stateParams,
		companyData
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function $onInit () {

		setPageState('loading');

		companyData.getAgencyProfileAgencyProfile(agencyProfileId).then(companyObj => {

			angular.extend($scope, {
				company: companyObj
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	angular.extend($scope, {
		agencyProfileId
	});

	$onInit();
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	'USER_ROLES',
	function (
		$stateProvider,
		USER_ROLES
	) {

	var directory = 'features/app/company-dashboard/';
	$stateProvider

	.state('company-dashboard', {
		url: '/company-dashboard/:agencyProfileId?completedDemo',
		templateUrl: directory + 'company-dashboard.view.html',
		controller: 'companyDashboardCtrl',
		data: {
			userRoleRedirect: {
				[USER_ROLES.groupadminlite]: 'payroll.current-period.notes'
			},
			companyFlagRedirect: {
				IsPayslipManagerActive: 'payslip-manager'
			},
			helpAndSupportOptions: {
				tags: ['company-dashboard']
			},
			title: 'Dashboard'
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('companyDashboardCtrl', [
	'COMPANY_STATES',
	'INTERFACE_TYPES',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'companyData',
	'messageData',
	'workflowService',
	'wootricService',
	function (
		COMPANY_STATES,
		INTERFACE_TYPES,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		companyData,
		messageData,
		workflowService,
		wootricService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompany = $rootScope.currentCompany;
	let wootricTimeout;

	function $onInit () {

		// Redirect agencies to their own dashboard
		if (currentCompany.CompanyType === INTERFACE_TYPES.agency) {

			$state.go('agency-dashboard', {
				agencyProfileId
			});

			return;
		}

		// Redirect onboarding / demo companies to their own dashboard
		switch (currentCompany.State) {

			case COMPANY_STATES.demo:
			case COMPANY_STATES.onboarding: {

				$state.go('onboarding-dashboard', {
					agencyProfileId,
					completedDemo: $stateParams.completedDemo
				});

				return;
			}
		}

		setPageState('loading');

		const getAgencyProfileAgencyProfile = companyData.getAgencyProfileAgencyProfile(agencyProfileId);
		const getPayPeriodCounts = companyData.getPayPeriodCountsForDashboardView(agencyProfileId);
		
		$q.all([
			getAgencyProfileAgencyProfile,
			getPayPeriodCounts
		]).then(([
			companyObj,
			countsObj
		]) => {

			angular.extend($scope, {
				company: companyObj,
				counts: countsObj,
				payPeriod: decoratePayPeriod(companyObj.PayPeriod)
			});

			setPageState('ready');

			// Workflow
			if (companyObj.Company.IsWorkflowEnabled) {
				loadWorkflow(companyObj.Company);
			}

			// Animate in
			$timeout(() => {
				$scope.payPeriod.percentageComplete = getPayPeriodPercentageComplete(companyObj.PayPeriod);
			}, 1000);

			wootricTimeout = $timeout(() => {
				wootricService.triggerSurvey();
			}, 1500);
		})
		.catch(onError);
	}

	function decoratePayPeriod (payPeriodObj) {

		angular.extend(payPeriodObj, {
			dayCountDescription: getDayCountForPayPeriod(payPeriodObj),
			icon: getIconForPayPeriod(payPeriodObj),
			iconTheme: getIconThemeForPayPeriod(payPeriodObj),
			payDateDescription: moment(payPeriodObj.PayDateISO).format('ddd D MMM'),
			processDateDescription: moment(payPeriodObj.ProcessDateISO).format('ddd D MMM'),
			payNotificationDateDescription: moment(payPeriodObj.PayslipDateISO).format('ddd D MMM'),
			percentageComplete: 0 // This gets set later to allow it to animate in
		});

		return payPeriodObj;
	}

	function getDayCountForPayPeriod (payPeriodObj) {

		// Overdue
		if (payPeriodObj.PayDayDaysOverdue > 0) {
			return 'overdue';
		}

		// 1 day until pay day
		if (payPeriodObj.PayDayDaysAway === 1) {
			return `${payPeriodObj.PayDayDaysAway} day to go`;
		}

		// x days until pay day
		return `${payPeriodObj.PayDayDaysAway} days to go`;
	}

	function getIconForPayPeriod (payPeriodObj) {

		// Overdue
		if (payPeriodObj.PayDayDaysOverdue > 0) {
			return 'warning';
		}

		return 'wallet';
	}

	function getIconThemeForPayPeriod (payPeriodObj) {

		// Overdue
		if (payPeriodObj.PayDayDaysOverdue > 0) {
			return 'is-tertiary';
		}

		return 'is-white-transparent';
	}

	function getPayPeriodPercentageComplete (payPeriodObj) {

		const startDateM = moment(payPeriodObj.StartDateISO);
		const endDateM = moment(payPeriodObj.EndDateISO);

		const numberOfDaysInPeriod = endDateM.diff(startDateM, 'days');

		return 100 - ((100 / numberOfDaysInPeriod) * payPeriodObj.PayDayDaysAway);
	}

	function loadWorkflow (currentCompanyObj) {

		setWorkflowState('loading');

		messageData.getWorkflowTemplates(agencyProfileId).then(workflowTemplatesArr => {

			const isWorkflowActive = workflowService.isWorkflowActive(currentCompanyObj, workflowTemplatesArr);

			if (!isWorkflowActive) {
				return;
			}

			let workflowTemplateObj = workflowTemplatesArr[0];

			workflowTemplateObj = workflowService.decorateWorkflowTemplate(workflowTemplateObj);

			angular.extend($scope, {
				isWorkflowActive,
				workflowTemplateEntryCurrent: workflowTemplateObj.TemplateEntryCurrent
			});

			setWorkflowState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setWorkflowState (workflowState) {

		$scope.workflowState = workflowState;
	}

	$scope.$on('$destroy', () => {
		$timeout.cancel(wootricTimeout);
		wootricService.stopSurvey();
	});

	angular.extend($scope, {
		agencyProfileId
	});

	$onInit();
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	function (
		$stateProvider
	) {

	var directory = 'features/app/onboarding-dashboard/';
	$stateProvider

	.state('onboarding-dashboard', {
		url: '/onboarding-dashboard/:agencyProfileId?completedDemo',
		templateUrl: directory + 'onboarding-dashboard.view.html',
		controller: 'onboardingDashboardCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			title: 'Dashboard'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('onboardingDashboardCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'base',
	'companyData',
	'growl',
	'intercomService',
	'logService',
	'onboardingService',
	'pensionData',
	'session',
	'tracking',
	'COMPANY_STATES',
	'COMPANY_STATE_DATA_TYPES',
	'DEMO_QUESTION_GROUPS',
	'DEMO_TASKS',
	'DOCUMENT_TYPES',
	'INTERFACE_TYPES',
	'LOG_CATEGORIES',
	'ONBOARDING_QUESTION_GROUPS',
	'TRACKING_EVENTS',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		base,
		companyData,
		growl,
		intercomService,
		logService,
		onboardingService,
		pensionData,
		session,
		tracking,
		COMPANY_STATES,
		COMPANY_STATE_DATA_TYPES,
		DEMO_QUESTION_GROUPS,
		DEMO_TASKS,
		DOCUMENT_TYPES,
		INTERFACE_TYPES,
		LOG_CATEGORIES,
		ONBOARDING_QUESTION_GROUPS,
		TRACKING_EVENTS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function approvePayroll () {

		var demo = {
			demoTaskId: DEMO_TASKS.approvePayroll.calculatePayroll,
			demoTask: 'calculatePayroll',
			next: {
				demoTaskId: DEMO_TASKS.approvePayroll.runPayroll,
				demoTask: 'runPayroll',
				next: {
					demoTaskId: DEMO_TASKS.approvePayroll.checkPayroll,
					demoTask: 'checkPayroll',
					onboardingId: $scope.onboardingDashboard.OnboardingID,
					onboardingQuestionGroupId: DEMO_QUESTION_GROUPS.approvePayroll
				}
			},
		};

		session.setActiveDemo(demo);
		$state.go('payroll.current-period.changes', {
			agencyProfileId: agencyProfileId,
		});
	}

	function closeAllTasks (onboardingDashboardObj) {

		$scope.vm.showTasksFor = null;
		for (var groupPair of onboardingDashboardObj.questionGroupPairs) {
			for (var group of groupPair) {
				group.isActive = false;
			}
		}
	}
	
	function completeDemoForMe (onboardingDashboardObj, setTo, ignoreApprovePayroll) {

		var groupIds = ['3816c589-41e0-4f61-9de0-55834c99e69c', 'ee6bdb17-ba66-4ee3-9cf5-9116360c131c', 'a44ae5c3-10e4-4664-84fa-c8a23758af12', '49cf23c3-3d8f-4e19-9d58-87e61ed751c3', 'e256ccbc-ba8a-41e9-b4de-d17945cdafae', '92adb583-56ac-406f-b36d-ffde585c1b2f', '0a3f3f00-2b85-4aae-b22e-caa8b4f4e4ee'];

		if (ignoreApprovePayroll) {
			groupIds.shift();
		}

		for (var group of groupIds) {
			companyData.updateOnboardingQuestionGroupComplete(onboardingDashboardObj.OnboardingID, group, setTo);
		}
	}

	function getStepImageFileName (step) {

		switch (step) {
			case 1:
				return 'add-team-members';
			case 2:
				return 'payroll-changes';
			case 3:
			case 4:
				return 'submit-for-approval';
		}
	}

	function goToStep (step) {

		$scope.options.step = step;
	}

	function init () {

		setPageState('loading');

		const getAgencyProfileAgencyProfile = companyData.getAgencyProfileAgencyProfile(agencyProfileId);
		const getPensionDashboardData = pensionData.getPensionDashboardData(agencyProfileId);

		$q.all([
			getAgencyProfileAgencyProfile,
			getPensionDashboardData
		]).then(([
			companyObj,
			pensionObj
		]) => {

			// Set default tab
			togglePensionTab(pensionObj, 'overview');

			// Decorate log entries
			pensionObj.LogEntries = logService.decorateLogEntries(pensionObj.LogEntries);

			const isAutoRunVisible = companyObj.Company.IsAutoRun && session.user.canSeeAutoRun;
			let step = 1;

			// Auto run
			if (companyObj.Company.IsAutoRun) {

				// Bureaus
				if (isAutoRunVisible) {					
					step = 4;
				}

				// Company admins
				else {
					step = 6;
				}
			}


			if (companyObj.PayPeriod.IsCompulsorySubmission) {
				step = 5;
			}

			angular.extend($scope, {
				company: companyObj,
				isAutoRunVisible,
				options: {
					step
				},
				pension: pensionObj
			});

			loadLogs();

			// Onboarding
			if (companyObj.Company.State !== COMPANY_STATES.live) {
				refreshOnboardingDashboard();
			}
			else {
				setPageState('ready');
			}
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function loadLogs () {

		const categoryIdList = [LOG_CATEGORIES.payroll];
		const dateFrom = moment().add(6, 'months').format();
		let userId;

		setLogsState('loading');

		base.getAgencyLogEntriesForLogCategoryList(agencyProfileId, userId, categoryIdList, dateFrom).then(logEntriesArr => {

			$scope.payrollLogs = logService.decorateLogEntries(logEntriesArr);

			setLogsState('ready');
		})
		.catch(error => {
			setLogsState('error');
			console.error(error);
		});
	}

	function onCloseAddTeamMembers (vmObj) {

		init();
		toggleShowAddTeamMembers(vmObj);
	}

	function openApprovePayrollForm (companyObj) {

		$rootScope.openSlideInForm({
			callback: refreshCompany,
			formKey: 'submit-for-approval',
			showContext: false,
			agencyProfileId: companyObj.Company.AgencyProfileID
		});
	}

	function openCancelTrialForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $scope.company.Company.AgencyProfileID,
			formKey: 'onboarding-cancel-trial',
			title: $scope.company.Company.State === COMPANY_STATES.demo ? 'Cancel free trial' : 'Cancel Onboarding',
			showContext: false
		});
	}

	function openOnboardingWizardProfile () {

		$rootScope.openSlideInForm({
			callback: refreshOnboardingDashboard,
			formKey: 'onboarding-wizard-profile',
			agencyProfileId: agencyProfileId,
			initCallbackOnClose: true,
			canCloseForm: false
		});
	}

	function openPayrollSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-payroll-settings'
		});
	}

	function openSwitchToLiveModal (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			callback: init,
			formKey: 'switch-to-live'
		});
	}

	function openSwitchToLiveForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			callback: init,
			formKey: 'switch-to-live'
		});
	}

	function openUnlockPayrollForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			callback: init,
			formKey: 'unlock-approve-payroll'
		});
	}

	function refreshCompany () {

		setPageState('loading');

		companyData.getAgencyProfileAgencyProfile(agencyProfileId).then(companyObj => {

			$scope.company = companyObj;
			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function openDemoTaskBlock (onboardingDashboardObj) {

		var taskBlockOpen = false;
		var questionGroup;

		if ($rootScope.session.activeDemo) { // 1 - If demo in progress, open that question block

			for (questionGroup of onboardingDashboardObj.Questions.QuestionGroups) {
				if ($rootScope.session.activeDemo.onboardingQuestionGroupID === questionGroup.OnboardingQuestionGroupID) {
					questionGroup.showTasks = true;
					taskBlockOpen = true;
				}
			}

		} else if ($stateParams.completedDemo) { // 2 - If demo task completed, open that block unless whole block is completed

			for (questionGroup of onboardingDashboardObj.Questions.QuestionGroups) {
				if ($stateParams.completedDemo === questionGroup.OnboardingQuestionGroupID && questionGroup.totalQuestionsRemaining !== 0) {
					questionGroup.showTasks = true;
					taskBlockOpen = true;
				}
			}

		} else if (onboardingDashboardObj.DemoPercentComplete === 0 ) { // 3 - Show first block if demo just started

			onboardingDashboardObj.Questions.QuestionGroups[0].showTasks = true;
			taskBlockOpen = true;

		}

		if (!taskBlockOpen) { // 4 - If nothing open, show first task group in progress or next empty one

			for (questionGroup of onboardingDashboardObj.Questions.QuestionGroups) {
				if (!taskBlockOpen && questionGroup.QuestionsComplete >= 0 && questionGroup.totalQuestionsRemaining !== 0) {
					questionGroup.showTasks = true;
					taskBlockOpen = true;
				}
			}

		}

		return onboardingDashboardObj;
	}

	function refreshOnboardingDashboard () {

		companyData.getOnboardingDashboard(agencyProfileId).then(onboardingDashboardObj => {

			onboardingDashboardObj = onboardingService.decorateOnboardingDashboardObj(onboardingDashboardObj);

			// Add team question block
			if ($scope.company.Company.State === COMPANY_STATES.onboarding || $scope.company.Company.State === COMPANY_STATES.firstPeriod) {

				companyData.getOnboardingTeamMembers(agencyProfileId).then(teamMembersArray => {

					onboardingDashboardObj.teamMembers = teamMembersArray;

					$scope.onboardingDashboard = onboardingDashboardObj;
					$scope.skippedQuestions = onboardingService.getSkippedQuestions(onboardingDashboardObj);
					$scope.teamStats = onboardingService.getTeamMemberStatsObj(teamMembersArray);
					$scope.areTeamMembersComplete = onboardingService.getAreTeamMembersComplete(teamMembersArray);

					// Force completion of Profile if not complete
					$timeout(() => {
						if (onboardingDashboardObj.isProfileIncomplete && !$rootScope.userHasRole(['paycircle', 'bureaumanager'])) {
							openOnboardingWizardProfile();
						}
					}, 500);

					setPageState('ready');
				})
				.catch(error => {
					setPageState('error');
					console.error(error);
				});
			} else {
				onboardingDashboardObj = openDemoTaskBlock(onboardingDashboardObj);
				$scope.onboardingDashboard = onboardingDashboardObj;
				setPageState('ready');
			}
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function refreshPage () {

		init();
	}

	function resetApprovePayroll () {

		companyData.updateOnboardingQuestionGroupComplete($scope.onboardingDashboard.OnboardingID, DEMO_QUESTION_GROUPS.approvePayroll, false).then(() => {

			refreshOnboardingDashboard();
		})
		.catch(error => {
			$scope.pageState = 'error';
			console.error(error);
		});
	}

	function setLogsState (pageState) {

		$scope.logsState = pageState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function switchCompanyToLiveMode (modalObj, companyObj) {

		// TODO: Hook up service to actually switch test mode flag
		companyObj.Company.IsInTestMode = !companyObj.Company.IsInTestMode;

		toggleModal(modalObj);
	}

	function toggleModal (modalObj) {

		modalObj.isOpen = !modalObj.isOpen;
	}

	function togglePensionTab (pensionObj, menuTab) {

		pensionObj.activeTab = menuTab;
	}

	function toggleShowAddTeamMembers (vmObj) {
		vmObj.showAddTeamMembers = !vmObj.showAddTeamMembers;

		if (!vmObj.showAddTeamMembers) {
			closeAllTasks($scope.onboardingDashboard);
			refreshOnboardingDashboard();
		}
	}

	function toggleShowCompanyOnboardingSummary (vmObj) {

		vmObj.showCompanyOnboardingSummary = !vmObj.showCompanyOnboardingSummary;
	}

	function toggleShowTeamPaymentInfo (vmObj) {

		vmObj.showTeamPaymentInfo = !vmObj.showTeamPaymentInfo;
	}

	function toggleShowTeamPensionInfo (vmObj) {

		vmObj.showTeamPensionInfo = !vmObj.showTeamPensionInfo;
	}

	function toggleTeamCompleteState (onboardingObj) {

		companyData.updateOnboardingTeamComplete(onboardingObj.OnboardingID, agencyProfileId, onboardingObj.IsTeamComplete).then(() => {

			// Feedback
			growl.success(onboardingObj.IsTeamComplete ? 'Your team has been marked as complete' : 'Your team has been re-opened for editing');

			// Tracking
			if (onboardingObj.IsTeamComplete) {
				tracking.trackEvent(TRACKING_EVENTS.onboardingTeamCompleted);
				intercomService.updateCompanyData(agencyProfileId, {
					size: onboardingObj.teamMembers.length
				});
			}
		});
	}

	angular.extend($scope, {
		COMPANY_STATES,
		COMPANY_STATE_DATA_TYPES,
		DOCUMENT_TYPES,
		INTERFACE_TYPES,
		ONBOARDING_QUESTION_GROUPS,
		agencyProfileId,
		approvePayroll,
		completeDemoForMe,
		getStepImageFileName,
		goToStep,
		onCloseAddTeamMembers,
		openApprovePayrollForm,
		openCancelTrialForm,
		openPayrollSettingsForm,
		openSwitchToLiveForm,
		openSwitchToLiveModal,
		openUnlockPayrollForm,
		modalOptions: {
			guideToAddingPensionInfo: {
				isOpen: false,
				template: 'video',
				title: 'A guide to adding pension info',
				videoUrl: 'https://www.youtube.com/embed/bGKx_Du_sUI'
			},
			moveToLive: {
				isOpen: false,
				title: 'It\'s time to get ready to go live'
			},
			switchToLiveMode: {
				isOpen: false,
				title: 'Switch to live mode'
			}
		},
		refreshCompany,
		refreshOnboardingDashboard,
		refreshPage,
		resetApprovePayroll,
		switchCompanyToLiveMode,
		toggleModal,
		togglePensionTab,
		toggleShowAddTeamMembers,
		toggleShowCompanyOnboardingSummary,
		toggleShowTeamPaymentInfo,
		toggleShowTeamPensionInfo,
		toggleTeamCompleteState,
		vm: {
			closeAllTasks,
			showAddTeamMembers: false,
			showCompanyOnboardingSummary: false,
			showTeamPaymentInfo: false,
			showTeamPensionInfo: false,
			showTasksFor: null,
			toggleShowAddTeamMembers,
			toggleShowCompanyOnboardingSummary,
			toggleShowTeamPaymentInfo,
			toggleShowTeamPensionInfo,
		}
	});

	init();

	$rootScope.$on('show-onboarding-add-team-members', () => {

		toggleShowAddTeamMembers($scope.vm);
	});
}]);

'use strict';


angular.module('paycircleApp')
	.config([
		'$stateProvider',
		function (
			$stateProvider
		) {

			const directory = 'features/app/p11db-report/';

			$stateProvider

				.state('p11db-report', {
					controller: 'p11dbReportCtrl',
					params:{
						openedFrom:''
					},
					data: {
						allowPDFDownload: true,
						document: true,
						fullPage: true
					},
					resolve: {
						auth: ['AuthResolverCompany', function (AuthResolverCompany) {
							return AuthResolverCompany.resolve();
						}]
					},
					templateUrl: directory + 'p11db-report.view.html',
					url: '/p11db-report/:agencyProfileId/:p11DbSubmissionID'
				});

		}]);

'use strict';

angular.module('paycircleApp')

	.controller('p11dbReportCtrl', [
		'$filter',
		'$rootScope',
		'$scope',
		'$stateParams',
		'$q',
		'$timeout',
		'$window',
		'companyData',
		'payrollData',
		'utilities',
		function (
			$filter,
			$rootScope,
			$scope,
			$stateParams,
			$q,
			$timeout,
			$window,
			companyData,
			payrollData,
			utilities
		) {

			const agencyProfileId = $stateParams.agencyProfileId;
			const p11DbSubmissionID = $stateParams.p11DbSubmissionID;

			function init () {
				setPageState('loading');

				$timeout(function (){
					payrollData.getP11DbSubmission(p11DbSubmissionID, agencyProfileId)
						.then(p11dSubmissionObj=>{
							setPageState('ready');
							angular.extend($scope, {
								breakdownItems: getBreakdownItems(p11dSubmissionObj),
								p11DbSubmission: p11dSubmissionObj,
							});
						}).catch(function (error) {
						console.error(error);
						setPageState('error');
					});
				},500);
			}

			function getBreakdownItems (p11dbSubmissionObj) {

				return  [
					{
						label: 'Class 1A NICs rate',
						value: p11dbSubmissionObj.P11DbSubmissionNICRate + '%'
					},
					{
						label: 'Total benefits liable to Class 1A NICs',
						value:  $filter('monetise')(p11dbSubmissionObj.P11DbSubmissionBenefitsLiable)
					},
					{
						label: 'Amounts not included in \'Total benefits\' on which Class 1A NICs are due',
						value:  $filter('monetise')(p11dbSubmissionObj.P11DbSubmissionAdjustmentDueAmount)
					},
					{
						label: 'Amounts included in \'Total benefits\' on which Class 1A NICs are not due',
						value:  $filter('monetise')(p11dbSubmissionObj.P11DbSubmissionAdjustmentNotDueAmount)
					},
					{
						label: 'Total benefits on which Class 1A NICs are due',
						value:  $filter('monetise')(p11dbSubmissionObj.P11DbSubmissionBenefitsLiableTotal)
					},
					{
						label: 'Class 1A NICs payable',
						value:  $filter('monetise')(p11dbSubmissionObj.P11DbSubmissionNICPayable)
					}
				];

			}

			function openBrowserPrintDialog () {

				$window.print();
			}

			function setPageState (pageState) {

				$scope.pageState = pageState;
			}

			function openP11DbForm(){
				$rootScope.openSlideInForm({
					agencyProfileId: $stateParams.agencyProfileId,
					p11dbSubmission: $scope.p11DbSubmission,
					agencyPayPeriodId: $scope.p11DbSubmission.AgencyPayPeriodID,
					callback: init,
					formKey: 'company-settings-p11d-submission'
				});
			}

			function cancel (){
				utilities.goBack();
				setTimeout(()=>{
					if($stateParams.openedFrom === 'form'){
						openP11DbForm();
					}
				}, 100);

			}

			init();

			angular.extend($scope, {
				agencyProfileId,
				goBack: cancel,
				openBrowserPrintDialog
			});
		}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	const directory = 'features/app/paycircle-dashboard/';
	const tabsDirectory = `${directory}tabs/`;

	$stateProvider

	.state('paycircle-dashboard', {
		abstract: true,
		url: '/paycircle-dashboard',
		templateUrl: directory + 'paycircle-dashboard.view.html',
		data: {
			authorisedRoles: [USER_ROLES.paycircle],
			title: 'Paycircle Dashboard'
		}
	})

		.state('paycircle-dashboard.onboarding-stats', {
			url: '',
			templateUrl: tabsDirectory + 'onboarding-stats.view.html',
			controller: 'paycircleDashboardOnboardingStatsCtrl'
		})

		.state('paycircle-dashboard.api-references', {
			url: '/api-references',
			templateUrl: tabsDirectory + 'api-references.view.html',
			controller: 'paycircleDashboardApiReferencesCtrl'
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('paycircleDashboardApiReferencesCtrl', ['$scope', '$http', 'filterService', 'searchService', function ($scope, $http, filterService, searchService) {

	function decorateApiReferences (apiReferences) {
		apiReferences.forEach(apiReference => {
			apiReference.referenceCount = apiReference.references.length;
			apiReference.showReferences = false;
		});
		return apiReferences;
	}

	function init () {

		setPageState('loading');

		var scanSourceUrl = '/scripts/services/testData/scansource/scansource.json';

		$http.get(scanSourceUrl).then(scansource => {

			const apiReferences = scansource.data;

			$scope.vm = {
				apiReferences: decorateApiReferences(apiReferences),
				filterBarOptions: filterService.getFilterBarOptionsApiReferences(apiReferences),
				searchBarOptions: searchService.apiReferences
			};

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleShowReferences (apiReference) {
		apiReference.showReferences = !apiReference.showReferences;
	}

	init();

	angular.extend($scope, {
		filterBarOptions: filterService.getFilterBarOptionsApiReferences,
		searchOptions: searchService.apiReferences,
		toggleShowReferences
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('paycircleDashboardOnboardingStatsCtrl', ['$rootScope', '$scope', '$stateParams', 'companyData', 'filterService', 'searchService', function ($rootScope, $scope, $stateParams, companyData, filterService, searchService) {

	const LATEST_MONTH_KEY = 'Jul';

	function init () {

		setPageState('loading');

		companyData.getOnboardingStats().then(onboardingStatsObj => {
			$scope.onboardingStats = onboardingStatsObj;
			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	// Scope
	$scope.filterBarOptions = filterService.getFilterBarOptionsOnboardingStats(LATEST_MONTH_KEY);
	$scope.searchBarOptions = searchService.getSearchOptionsForOnboardingStats(LATEST_MONTH_KEY);
}]);


'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {

	const directory = 'features/app/payroll';

	$stateProvider
	.state('payroll', {
		abstract: true,
		url: '/payroll/:agencyProfileId?applyfilter',
		templateUrl: directory + '/payroll.view.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			title: 'Payroll'
		}
	})
		// Pay Period
		.state('payroll.pay-period', {
			url: '/pay-period/:payPeriodId',
			templateUrl: directory + '/pay-period/pay-period.view.html',
			controller: 'payPeriodCtrl'
		})

		// Supplementary Pay Run
		.state('payroll.supplementary-pay-run', {
			abstract: true,
			url: '/supplementary-pay-run/:payPeriodId/:supplementaryPaymentId',
			templateUrl: directory + '/supplementary-pay-run/supplementary-pay-run.view.html',
			controller: 'supplementaryPayRunCtrl'
		})
			.state('payroll.supplementary-pay-run.changes', {
				url: '/changes',
				templateUrl: directory + '/supplementary-pay-run/changes/supplementary-pay-run-changes.view.html',
				controller: 'supplementaryPayRunChangesCtrl'
			})
			.state('payroll.supplementary-pay-run.receipts', {
				url: '/receipts',
				templateUrl: directory + '/supplementary-pay-run/receipts/supplementary-pay-run-receipts.view.html',
				data: {
				    unauthorisedRoles: [
				    	USER_ROLES.companyadministratorlite,
				    	USER_ROLES.groupAdminLite
				    ]
				}
			})
			.state('payroll.supplementary-pay-run.reports', {
				url: '/reports',
				templateUrl: directory + '/supplementary-pay-run/reports/supplementary-pay-run-reports.view.html'
			})

		// Previous Period
		.state('payroll.previous-period', {
			url: '/previous-period',
			templateUrl: directory + '/previous-period/payroll-previous-period.view.html',
			controller: 'payrollPreviousPeriodCtrl'
		})

		// Current Period
		.state('payroll.current-period', {
			abstract: true,
			url: '/current-period',
			templateUrl: directory + '/current-period/payroll-current-period.view.html',
			controller: 'payrollCurrentPeriodCtrl',
			data: {
				cancelRequestOnStateChange: false,
				helpAndSupportOptions: {
					tags: ['company-current-period']
				},
				permissions: [
					'isPayrollVisible'
				]
			}
		})
			.state('payroll.current-period.changes', {
				url: '',
				templateUrl: directory + '/current-period/changes/payroll-current-period-changes.view.html',
				controller: 'payrollCurrentPeriodChangesCtrl',
			})
			.state('payroll.current-period.team', {
				url: '/team',
				templateUrl: directory + '/current-period/team/payroll-current-period-team.view.html',
				controller: 'payrollCurrentPeriodTeamCtrl',
			})
			.state('payroll.current-period.imports', {
				url: '/imports',
				templateUrl: directory + '/current-period/imports/payroll-current-period-imports.view.html',
				controller: 'payrollCurrentPeriodImportsCtrl',
			})
			.state('payroll.current-period.tax-updates', {
				url: '/tax-updates',
				templateUrl: directory + '/current-period/tax-updates/payroll-current-period-tax-updates.view.html',
				controller: 'payrollCurrentPeriodTaxUpdatesCtrl',
			})
			.state('payroll.current-period.alerts', {
				url: '/alerts',
				templateUrl: directory + '/current-period/alerts/payroll-current-period-alerts.view.html',
				controller: 'payrollCurrentPeriodAlertsCtrl'
			})
			.state('payroll.current-period.notes', {
				url: '/notes',
				templateUrl: directory + '/current-period/notes/payroll-current-period-notes.view.html',
				controller: 'payrollCurrentPeriodNotesCtrl'
			})
			.state('payroll.current-period.tasks', {
				url: '/tasks',
				templateUrl: directory + '/current-period/tasks/payroll-current-period-tasks.view.html',
				controller: 'payrollCurrentPeriodTasksCtrl'
			})
			.state('payroll.current-period.pensions', {
				url: '/pensions',
				templateUrl: directory + '/current-period/pensions/payroll-current-period-pensions.view.html',
				controller: 'payrollCurrentPeriodPensionsCtrl'
			})

	// Future Changes
	.state('payroll.future-changes', {
		url: '/future-changes',
		controller: 'payrollFutureChangesCtrl',
		templateUrl: directory + '/future-changes/payroll-future-changes.view.html',
		data: {
			helpAndSupportOptions: {
				tags: ['company-future-changes']
			},
			permissions: [
				'isPayrollVisible'
			]
		}
	})

	// History
	.state('payroll.history', {
		abstract: true,
		controller: 'payrollHistoryCtrl',
		templateUrl: directory + '/history/payroll-history.view.html',
		url: '/history',
		data: {
			helpAndSupportOptions: {
				tags: ['company-history']
			},
			permissions: [
				'isHistoryVisible'
			]
		}
	})

		// Historic Pay Periods
		.state('payroll.history.pay-periods', {
			templateUrl: directory + '/history/pay-periods/payroll-history-pay-periods.view.html',
			url: '',
			controller: 'payrollHistoryPayPeriodsCtrl'
		})

		// Supplementary Pay Runs
		.state('payroll.history.supplementary-pay-runs', {
			url: '/supplementary-pay-runs',
			templateUrl: directory + '/history/supplementary-pay-runs/payroll-history-supplementary-pay-runs.view.html',
			controller: 'payrollHistorySupplementaryPayRunsCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-supplementary-pay-runs']
				}
			}
		})

	// Run Payroll
	.state('payroll.run-payroll', {
		url: '/run-payroll?activeTab',
		templateUrl: directory + '/run-payroll/payroll-run-payroll.view.html',
		controller: 'payrollRunPayrollCtrl',
		data: {
		    unauthorisedRoles: [USER_ROLES.employer],
			permissions: [
				'isPayrollVisible'
			]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollPreviousPeriodCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'config',
	'messageData',
	'payrollData',
	'reportData',
	'reportsService',
	'searchService',
	'supplementaryPayRunService',
	'MESSAGE_TYPES',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		config,
		messageData,
		payrollData,
		reportData,
		reportsService,
		searchService,
		supplementaryPayRunService,
		MESSAGE_TYPES,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const TABS = {
		notes: 'notes',
		reports: 'reports'
	};

	const agencyProfileId = $stateParams.agencyProfileId;
	const companyObj = $scope.currentCompany; // From root
	const currentUserObj = $scope.currentUser; // From root

	function init () {

		setPageState('loading');

		const IS_PREVIOUS_PERIOD = false;

		const getPayPeriodPrevious = payrollData.getPayPeriodPrevious(agencyProfileId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD);

		$q.all([
				getPayPeriodPrevious,
				getPayPeriodMinimum
			])
			.then(([
				payPeriodPreviousObj,
				payPeriodCurrentObj
			]) => {

				// Load notes
				const getReports = reportData.getReports(companyObj.AgencyProfileID, payPeriodPreviousObj.PayPeriodID);
				const getMessages = messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriodPreviousObj.PayPeriodID, MESSAGE_TYPES.notes);
				const getSupplementaryPaymentsForAgencyPayPeriod = payrollData.getSupplementaryPaymentsForAgencyPayPeriod(companyObj.AgencyProfileID, payPeriodPreviousObj.PayPeriodID);

				$q.all([
						getReports,
						getMessages,
						getSupplementaryPaymentsForAgencyPayPeriod
					])
					.then(([
						reportsArr,
						notesArr,
						supplementaryPaymentsArr
					]) => {

						$scope.vm = {
							activeTab: TABS.reports,
							company: companyObj,
							reports: reportsService.getReportsForPayPeriod(reportsArr),
							hasReportsPermissions: currentUserObj.Permissions.isReportingVisible,
							notes: notesArr,
							payPeriod: payPeriodPreviousObj,
							payPeriodCurrent: payPeriodCurrentObj,
							searchBarOptions: searchService.notes,
							showPaymentSummary: getShowPaymentSummary(payPeriodPreviousObj),
							supplementaryPayRuns: supplementaryPaymentsArr.filter(supplementaryPayRunService.filterSupplementaryPayments),
							TABS
						};

						setPageState('ready');
					})
					.catch(onError);
		})
		.catch(onError);
	}

	function getShowPaymentSummary (payPeriodPreviousObj) {

		// Show payment summary. Available only for particular roles in this context, and only when the payroll has been submitted (it should have been).
		return payPeriodPreviousObj.ReportState === SUBMISSION_STATES.submitted && $rootScope.userHasRole([
				USER_ROLES.paycircle,
				USER_ROLES.bureau,
				USER_ROLES.bureaumanager,
				USER_ROLES.groupadmin,
				USER_ROLES.groupadminlite,
				USER_ROLES.groupuser,
				USER_ROLES.payrollworker,
				USER_ROLES.companyadministrator,
				USER_ROLES.companyadministratorlite
			]);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function refreshNotes () {

		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, $scope.vm.payPeriod.PayPeriodID, MESSAGE_TYPES.notes).then(notesArr => {

			$scope.vm.notes = notesArr;
		})
		.catch(onError);
	}

	function setActiveTab (vmObj, tabKey) {

		vmObj.activeTab = tabKey;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		SUBMISSION_STATES,

		init,
		refreshNotes,
		setActiveTab,

		agencyProfileId: agencyProfileId
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollCurrentPeriodCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'agency',
	'applicationService',
	'bulkService',
	'companyData',
	'config',
	'dataImport',
	'filterService',
	'growl',
	'importService',
	'messageData',
	'payPeriodService',
	'payrollData',
	'permissionsService',
	'searchService',
	'tabService',
	'teamData',
	'utilities',
	'workflowService',
	'wootricService',
	'DOCUMENT_TYPES',
	'DPS_STATES',
	'FULL_SCREEN_MODAL_KEYS',
	'IMPORT_MAPPING_TYPES',
	'MESSAGE_TYPES',
	'PERMISSION_TYPES',
	'SEARCH_BAR_ACTIONS',
	'SPLASH_STATES',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'TAB_KEYS',
	'USER_IMPORT_GROUP_STATES',
	'WORKFLOW_CHANGES_TABLE_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		agency,
		applicationService,
		bulkService,
		companyData,
		config,
		dataImport,
		filterService,
		growl,
		importService,
		messageData,
		payPeriodService,
		payrollData,
		permissionsService,
		searchService,
		tabService,
		teamData,
		utilities,
		workflowService,
		wootricService,
		DOCUMENT_TYPES,
		DPS_STATES,
		FULL_SCREEN_MODAL_KEYS,
		IMPORT_MAPPING_TYPES,
		MESSAGE_TYPES,
		PERMISSION_TYPES,
		SEARCH_BAR_ACTIONS,
		SPLASH_STATES,
		STATE_TYPES,
		SUBMISSION_STATES,
		TAB_KEYS,
		USER_IMPORT_GROUP_STATES,
		WORKFLOW_CHANGES_TABLE_STATES
	) {

	const VIEW_TYPES = {
		payroll: 'payroll',
		import: 'import'
	};

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $scope.currentCompany;
	const currentUserObj = $scope.currentUser;
	const isLiteAdminRole = $rootScope.userHasRole(['groupadminlite', 'companyadministratorlite']);
	let wootricTimeout;

	// The parent controller outlives the individual tab controllers, so the changes-refresh poll lives here
	// and keeps running while the user is on any current-period tab.
	const CHANGES_POLL_INTERVAL = 3; // Seconds
	const CHANGES_MAX_POLLS = 20;
	let changesPollTimeout = null;
	let changesPollCounter = 0;
	let isChangesRefreshPolling = false;

	function getIsSplashScreenVisible (workflowTemplateObj) {

		// No current template
		if (!workflowTemplateObj.TemplateEntryCurrent) {
			return false;
		}

		// Only show if is actioner
		if (!workflowTemplateObj.TemplateEntryCurrent.IsActioner) {
			return false;
		}

		switch (workflowTemplateObj.TemplateEntryCurrent.SplashState) {
			case SPLASH_STATES.inactive:
			case SPLASH_STATES.complete:
				return false;
		}

		return true;
	}

	function getTabBarDefaultCounts () {

		// Create initial counts for applicable tabs. -1 means 'loading'
		const currentPeriodTabBarCounts = {};

		currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.notes] = { count: -1, theme: 'primary' };
		currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.tasks] = { count: -1, theme: 'primary' };
		currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.alerts] = { count: -1, theme: 'primary' };

		return currentPeriodTabBarCounts;
	}

	function getViewType (payPeriodObj,	companyObj) {

		// Imports
		if (companyObj.IsDataImportEnabled) {

			var isImportComplete = importService.getIsImportComplete(payPeriodObj);

			if (!isImportComplete) {
				return VIEW_TYPES.import;
			}
		}

		return VIEW_TYPES.payroll;
	}

	function init () {

		const IS_PREVIOUS_PERIOD = true;
		const ALL_DETAILS = true;

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId, ALL_DETAILS).then(currentPayPeriodObj => {

			// If payroll islocked, go straight to Run Payroll
			if (currentPayPeriodObj.IsPayrollLocked) {
				$state.go('payroll.run-payroll');
				return;
			}

			let vmObj = {
				currentPeriodTabBarCounts: getTabBarDefaultCounts(),
				payPeriod: currentPayPeriodObj
			};

			const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD);
			const getWorkflowTemplates = currentCompanyObj.IsWorkflowEnabled ? messageData.getWorkflowTemplates(agencyProfileId) : null;

			$q.all([
				getPayPeriodMinimum,
				getWorkflowTemplates
			]).then(([
				previousPayPeriodObj,
				workflowTemplatesArr
			]) => {

				const isWorkflowActive = workflowService.isWorkflowActive(currentCompanyObj, workflowTemplatesArr);

				loadPeriodNotes(vmObj);
				loadPeriodTasks(vmObj);

				// Get permissions object
				const permissions = permissionsService.getPermissionsForStateCurrentPeriod(currentUserObj);

				angular.extend(vmObj, {
					company: currentCompanyObj,
					currentPeriodTabBarDef: tabService.getTabsForKey(TAB_KEYS.payroll.currentPeriod.id, { permissions }),
					currentPeriodTabBarCounts: getTabBarDefaultCounts(),
					previousPayPeriod: previousPayPeriodObj,
					isImportComplete: importService.getIsImportComplete(vmObj.payPeriod),
					isWorkflowActive: isWorkflowActive,
					permissions,
					viewType: getViewType(vmObj.payPeriod, currentCompanyObj)
				});

				/* Only ever land on a tab the user can actually see. Changes is the default (empty-url) child state,
				   so hitting /current-period (or deep-linking a tab they can't access) resolves to a tab that may not
				   be visible; in that case send them to their highest-priority visible tab. When no tabs are visible
				   the view shows a no-access placeholder (getDefaultTab returns nothing, so no navigation happens). */
				const isCurrentTabVisible = vmObj.currentPeriodTabBarDef.tabs.some(tab => tab.sref === $state.current.name);

				if (!isCurrentTabVisible) {

					const defaultTab = tabService.getDefaultTab(vmObj.currentPeriodTabBarDef);

					if (defaultTab) {
						$state.go(defaultTab.sref, { agencyProfileId: agencyProfileId }, { location: 'replace' });
					}
				}

				// Pay period counts feed the header (e.g. the tax-updates badge), so load them for everyone.
				loadPayPeriodCounts(vmObj);

				/* Load the Team tab and the payroll alerts when the user can see them. loadTeam owns the single
				   team-members fetch and returns its promise, which gates the alerts freshness call (alerts must
				   be calculated after team payroll) > one shared call, in a fixed order. */
				let teamMembersPromise;

				if (permissions.isTeamVisible) {
					teamMembersPromise = loadTeam(vmObj);
				}

				if (permissions.isAlertsVisible) {
					loadPeriodAlerts(vmObj, teamMembersPromise);
				}

				// Workflow enabled
				if (isWorkflowActive) {

					let workflowTemplateObj = workflowTemplatesArr[0];

					workflowTemplateObj = workflowService.decorateWorkflowTemplate(workflowTemplateObj);

					if (workflowTemplateObj.TemplateEntryCurrent) {

						if (isLiteAdminRole && workflowTemplateObj.IsPayrollQueried) {
							$state.go('payroll.current-period.notes', {agencyProfileId: agencyProfileId});

						// Re-direct to 'Calculate'
						} else if (workflowTemplateObj.IsPayrollLocked || workflowTemplateObj.IsApproveAvailable || workflowTemplateObj.IsRunAvailable) {
							$state.go('payroll.run-payroll', {agencyProfileId: agencyProfileId});
							return;
						}

						// Load import group for changes table
						if (vmObj.permissions.isChangesTableVisible && workflowTemplateObj.changesTableIsEnabled) {
							loadImports(vmObj);
						}

						// Continue loading page
						angular.extend(vmObj, {
							workflowTemplate: workflowTemplateObj
						});

						$timeout(() => {

							const isSplashScreenVisible = getIsSplashScreenVisible(workflowTemplateObj);

							if (isSplashScreenVisible) {
								$rootScope.openModalDialog({
									modalData: {
										workflowTemplate: workflowTemplateObj
									},
									modalKey: 'workflow-payroll-information'
								});
							}
						}, 1200);
					}
				} else {

					// Load import group for changes table
					if (vmObj.permissions.isChangesTableVisible) {
						loadImports(vmObj);
					}

				}

				/* Establish whether, at least in principle, the changes table is editable. This can get overridden later if the
				   changes table has been imported. */
				vmObj.isChangesTableEditable = false;
				if (vmObj.permissions.isChangesTableVisible && (!isWorkflowActive || (isWorkflowActive && workflowTemplatesArr[0].changesTableIsEnabled))) {
					// In principle, the edit changes table functionality should be available ...
					if ($rootScope.userHasRole(['paycircle', 'bureau', 'bureaumanager']) && currentPayPeriodObj.ChangesTableState !== WORKFLOW_CHANGES_TABLE_STATES.complete) {
						// The table hasn't been imported and the user has the correct role to edit the changes table
						vmObj.isChangesTableEditable = true;
					}
					else if (currentPayPeriodObj.ChangesTableState === WORKFLOW_CHANGES_TABLE_STATES.incomplete) {
						// The table hasn't been submitted, so the changes table can still be edited
						vmObj.isChangesTableEditable = true;
					}
				}

				$scope.vm = vmObj;

				setPageState('ready');

				wootricTimeout = $timeout(function () {
					wootricService.triggerSurvey();
				}, 1500);
			})
			.catch(onError);
		})
		.catch(onError);

	}

	$scope.$on('$destroy', function () {
		$timeout.cancel(wootricTimeout);
		$timeout.cancel(changesPollTimeout);
		wootricService.stopSurvey();
	});

	function initiateDemoTask (teamMembersArr) {

		// Kick off demo tooltip for first team member, if applicable
		if (teamMembersArr.length > 0) {
			teamMembersArr[0].showDemo = true;
		}
	}

	function loadImports (vmObj) {

		const FUTURE_ADJUSTMENTS = false;
		const USER_ID = null;
		const IMPORT_TYPE = IMPORT_MAPPING_TYPES.changesTable;

		dataImport.getUserImportGroupForUser(vmObj.payPeriod.PayPeriodID, currentUserObj.UserResponseUserID, IMPORT_TYPE).then(userImportGroupObj => {

			if (userImportGroupObj.State === USER_IMPORT_GROUP_STATES.approved) {
				vmObj.isChangesTableEditable = false;
				return;
			}

			if (importService.hasUserImportedElements(userImportGroupObj)) {
				payrollData.getUserPayElements(agencyProfileId, vmObj.payPeriod.PayPeriodID, USER_ID, FUTURE_ADJUSTMENTS, userImportGroupObj.UserImportGroupID).then(payElementGroupArr => {

					angular.extend(vmObj, {
						userImportGroup: userImportGroupObj,
						userPayElements: payElementGroupArr
					});
				})
				.catch(onError);
			}
		})
		.catch(onError);
	}

	function loadPayPeriodCounts (vmObj) {

		// Pay period counts feed the header (e.g. the tax-updates badge).
		return companyData.getPayPeriodCountsForPeriodView(agencyProfileId, vmObj.payPeriod.PayPeriodID)
			.then(payPeriodCountsObj => {
				vmObj.payPeriodCounts = payPeriodCountsObj;
			})
			.catch(error => {
				console.error(error);
			});
	}

	/* Reload triggered from within the Alerts tab (e.g. after resolving an alert). Resolving an alert can
	   recalculate team figures and change the pending tax-updates count, so the Team tab and header counts are
	   refreshed alongside the alerts. The single team fetch is shared with the alerts freshness check. */
	function reloadAlerts (vmObj) {

		loadPayPeriodCounts(vmObj);

		const teamMembersPromise = refreshTeamData(vmObj);
		loadPeriodAlerts(vmObj, teamMembersPromise);
	}

	function loadPeriodAlerts (vmObj, teamMembersPromise) {

		vmObj.alertsLoadingState = 'loading';

		// The current period minimum gives the period ID (and currency check) needed for the alerts call.
		payrollData.getPayPeriodMinimum(agencyProfileId).then(payPeriodMinimumObj => {

			/* Alerts must be calculated after a team-members payroll fetch, which triggers the server recalc.
			   Reuse the caller's fetch when one is supplied (the initial load passes loadTeam's; an alert reload
			   passes refreshTeamData's) so there's a single shared call; otherwise fall back to the cached call. */
			const teamMembersFetch = teamMembersPromise || payrollData.getTeamMembersPayrollCached(currentCompanyObj.AgencyProfileID);

			teamMembersFetch.then(() => {

				const PERIOD_CALCULATED = false;

				messageData.getPeriodAlerts(agencyProfileId, payPeriodMinimumObj.PayPeriodID, PERIOD_CALCULATED).then(periodAlertsArr => {

					angular.extend(vmObj, {
						payrollAlerts: payPeriodService.getPayrollAlertLevelsFromAlerts(periodAlertsArr),
						alertsLoadingState: 'ready'
					});

					// Update tab bar counter for alerts
					angular.extend(vmObj.currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.alerts], {
						count: vmObj.payrollAlerts.alertsCount,
						theme: vmObj.payrollAlerts.hasErrors ? 'assertive inverse' : 'primary'
					});

					// Expats > Update currencies
					if (currentCompanyObj.IsExpatActive && payPeriodMinimumObj.CurrencyCheck) {
						openCompanySettingsCurrencyForm(payPeriodMinimumObj);
					}
				})
				.catch(error => {
					vmObj.alertsLoadingState = 'error';
					console.error(error);
				});
			})
			.catch(error => {
				// Alerts depend on the team-members call succeeding first
				vmObj.alertsLoadingState = 'error';
				console.error(error);
			});
		})
		.catch(onError);
	}

	function loadPeriodTasks (vmObj) {

		vmObj.tasksLoadingState = 'loading';

		messageData.getMessagesForPayPeriod(agencyProfileId, vmObj.payPeriod.PayPeriodID, MESSAGE_TYPES.tasks).then(tasksArr => {

			angular.extend(vmObj, {
				showComplete: true,
				tasks: bulkService.getBulkItemsObj(tasksArr)
			});

			updatePeriodTasksCount(vmObj, tasksArr);
			vmObj.tasksLoadingState = 'ready';
		})
		.catch(error => {
			vmObj.tasksLoadingState = 'error';
			console.error(error);
		});
	}

	function loadPeriodNotes (vmObj) {

		vmObj.notesLoadingState = 'loading';

		const getNotesForPeriod = messageData.getMessagesForPayPeriod(agencyProfileId, vmObj.payPeriod.PayPeriodID, MESSAGE_TYPES.notes);
		const getTeamMemberAdminsExtended = teamData.getTeamMemberAdminsExtended(agencyProfileId, PERMISSION_TYPES.all);

		$q.all([
			getNotesForPeriod,
			getTeamMemberAdminsExtended
		]).then(([
			notesArr,
			teamMemberAdminsObj
		]) => {

			const teamMemberAdmins = Object.values(teamMemberAdminsObj).flat();

			// Update tab bar counter for tasks
			angular.extend(vmObj.currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.notes], {
				count: notesArr.length
			});

			angular.extend(vmObj, {
				notes: notesArr,
				notesFilterBarOptions: filterService.getFilterBarOptionsPeriodNotes(teamMemberAdmins)
			});

			vmObj.notesLoadingState = 'ready';
		})
		.catch(error => {
			vmObj.notesLoadingState = 'error';
			console.error(error);
		});
	}

	function loadTeam (vmObj) {

		angular.extend(vmObj, {
			teamLoadingState: 'loading'
		});

		const teamMembersPromise = payrollData.getTeamMembersPayrollCached(currentCompanyObj.AgencyProfileID);

		teamMembersPromise
			.then(teamMembersArr => {

				angular.extend(vmObj, {
					teamLoadingState: 'ready',
					teamMembers: bulkService.getBulkItemsObj(teamMembersArr)
				});

				// Specifically for Team page
				initiateDemoTask(vmObj.teamMembers);
			})
			.catch(error => {
				vmObj.teamLoadingState = 'error';
				console.error(error);
			});

		return teamMembersPromise;
	}

	function onError (error) {

	    setPageState('error');
	    console.error(error);
	}

	function openAddAChangeForm (payPeriodObj, userId, redirectToTeam) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUserByUserId,
			contextType: angular.isDefined(userId) ? 'user' : 'company',
			formKey: 'add-a-change',
			ignoreFutureStarters: true,
			includeLeavers: angular.isDefined(userId),
			payPeriod: payPeriodObj,
			redirectToTeam,
			userId: angular.isDefined(userId) ? userId : null
		});
	}

	function openAddHourlyTotalsForm (payPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'hourly-totals',
			payPeriodId: payPeriodObj.PayPeriodID,
			callback: () => {
				redirectAndReload('hourly-totals');
			}
		});
	}

	function openAddLinkRatesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'link-rates'
		});
	}

	function openAddPeriodNoteForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'add-period-note',
			callback: () => {
				redirectAndReload('notes');
			}
		});
	}

	function openAddPeriodTaskForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'add-period-task',
			callback: () => {
				redirectAndReload('tasks');
			}
		});
	}

	function openCalculatePayrollForm (vmObj) {

		const formOptions = {
			agencyProfileId,
			callback: () => {
				$state.go('payroll.run-payroll', {
					agencyProfileId
				});
			},
			formKey: 'calculate-payroll',
			payPeriodId: vmObj.payPeriod.PayPeriodID,
			title: 'Calculate payroll'
		};

		// Add workflow template if this is happening in the context of a workflow
		if (vmObj.isWorkflowActive) {
			formOptions.workflowTemplateId = vmObj.workflowTemplate.WorkflowTemplateID;
		}

		$rootScope.openSlideInForm(formOptions);
	}

	function openChangesTable (payPeriodObj) {

		$rootScope.$broadcast('open-full-screen-modal', {
			agencyProfileId: agencyProfileId,
			callback: init,
			modalKey: FULL_SCREEN_MODAL_KEYS.changesTable,
			payPeriodId: payPeriodObj.PayPeriodID,
		});
	}

	function openCompanySettingsCurrencyForm (payPeriodObj) {

		$rootScope.openSlideInForm({
			agencyPayPeriodId: payPeriodObj.PayPeriodID,
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-currencies',
			isEditMode: true
		});
	}

	function openTaxUpdatesForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: taxUpdatesHandled,
			contextType: 'company',
			formKey: 'tax-updates-confirmation',
			payPeriodId: vmObj.payPeriod.PayPeriodID,
			title: 'Tax updates'
		});
	}

	function openUndoImportForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'undo-import'
		});
	}

	function redirectAndReload (redirectKey) {

		switch (redirectKey) {

			case 'hourly-totals':
				$state.go('payroll.current-period.team', {agencyProfileId: agencyProfileId}, {reload: 'payroll.current-period'});
				break;

			case 'notes':
				$state.go('payroll.current-period.notes', {agencyProfileId: agencyProfileId}, {reload: 'payroll.current-period'});
				break;

			case 'tasks':
				$state.go('payroll.current-period.tasks', {agencyProfileId: agencyProfileId}, {reload: 'payroll.current-period'});
				break;
		}
	}

	function refreshTeamMemberChangesByUserId (userId, payPeriodId) {

		// Changes have not been loaded
		if (!angular.isDefined($scope.vm.teamMemberChanges)) {
			return;
		}

		// No user ID
		if (!userId) {
			$rootScope.paycircleMessage('Current Period > Changes: User ID not provided when attempting to refresh team member', 'warn');
			return;
		}

		var index = utilities.getArrayItemIndexByPropertyName($scope.vm.teamMemberChanges, 'UserID', userId);

		if (index) {
			$scope.vm.teamMemberChanges[index].loadingState = 'loading';
		}
		else {
			$rootScope.paycircleMessage('Current Period > Changes: Unable to match team member by user ID to refresh', 'warn');
		}

		payrollData.getAgencyPaymentAdjustmentDetailList(agencyProfileId, userId, payPeriodId).then(teamMemberChangesArr => {

			if (teamMemberChangesArr.length > 0) {

				var updatedTeamMemberChangesObj = teamMemberChangesArr[0];

				updatedTeamMemberChangesObj.loadingState = 'ready';

				// Update
				if (index !== null && angular.isDefined(index)) {
					$scope.vm.teamMemberChanges[index] = updatedTeamMemberChangesObj;
				}

				// Add
				else {
					$scope.vm.teamMemberChanges.push(updatedTeamMemberChangesObj);
				}
			}

			// Remove
			else {
				$scope.vm.teamMemberChanges.splice(index, 1);
			}
		})
		.catch(onError);
	}

	function refreshTeamMemberByUserId (userId) {

		// Team has not been loaded
		if (!$scope.vm.teamMembers) {
			return;
		}

		// No user ID
		if (!userId) {
			$rootScope.paycircleMessage('Current Period > Team: User ID not provided when attempting to refresh team member', 'warn');
			return;
		}

		var index = utilities.getArrayItemIndexByPropertyName($scope.vm.teamMembers.all, 'PersonalDetails', userId, 'UserID');

		// No index
		if (index === null) {
			$rootScope.paycircleMessage('Current Period > Team: Unable to match team member by user ID to refresh', 'warn');
			return;
		}

		$scope.vm.teamMembers.all[index].loadingState = 'loading';

		// Save original PayrollIDSequence to add back to team member once updated
		// https://www.notion.so/paycircle/Team-Payroll-ID-sort-order-becomes-incorrect-when-adding-a-change-in-current-period-e413a8f6d40f424bb321cc0198116b41#b38b16d43cd0482689ccfb36cb29af15
		const originalPayrollIDSequence = $scope.vm.teamMembers.all[index].PersonalDetails.PayrollIDSequence;

		payrollData.getTeamMemberPayroll(currentCompanyObj.AgencyProfileID, userId).then(teamMemberObj => {

			// Reset PayrollIDSequence back original value
			if (teamMemberObj.PersonalDetails) {
				teamMemberObj.PersonalDetails.PayrollIDSequence = originalPayrollIDSequence;
			}

			$scope.vm.teamMembers.all[index] = teamMemberObj;
			$scope.vm.teamMembers.all[index].loadingState = 'ready';
		})
		.catch(error => {
			removeTeamMemberByUserId(userId);
			console.error(error);
		});
	}

	function refreshTeam () {

		loadTeam($scope.vm);
	}

	function removeTeamMemberByUserId (userId) {

		// Team has not been loaded
		if (!$scope.vm.teamMembers) {
			return;
		}

		// No user ID
		if (!userId) {
			$rootScope.paycircleMessage('Current Period > Team: User ID not provided when attempting to remove user', 'warn');
			return;
		}

		var index = utilities.getArrayItemIndexByPropertyName($scope.vm.teamMembers.all, 'PersonalDetails', userId, 'UserID');

		// No index
		if (index === null) {
			$rootScope.paycircleMessage('Current Period > Team: Unable to match user by user ID to remove', 'warn');
			return;
		}

		$scope.vm.teamMembers.all.splice(index, 1);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function taxUpdatesHandled () {

		init();
	}

	function toggleModal (modalKey) {

		$scope.modal[modalKey] = !$scope.modal[modalKey];
	}

	function toggleWorkflowActive (periodObj) {

		periodObj.IsWorkflowEnabled = !periodObj.IsWorkflowEnabled;
	}

	function updatePeriodTasksCount (vmObj, tasksArr) {

		// Count incomplete tasks, and establish whether any are overdue. Only count those as overdue *and* incomplete as overdue.
		let tasksIncompleteCount = 0;
		let tasksOverdue = false;
		tasksArr.forEach(taskObj => {
			if (!taskObj.IsComplete) {
				tasksIncompleteCount++;
			}
			tasksOverdue |= (taskObj.IsOverdue && !taskObj.IsComplete);
		});

		// Update tab bar counter for tasks
		angular.extend(vmObj.currentPeriodTabBarCounts[TAB_KEYS.payroll.currentPeriod.tabs.tasks], {
			count: tasksIncompleteCount,
			theme: tasksOverdue ? 'assertive' : 'primary'
		});
	}

	function updateUserByUserId (callbackObj) {

		callbackObj.REDIRECT_TO_TEAM = angular.isDefined(callbackObj.REDIRECT_TO_TEAM) ? callbackObj.REDIRECT_TO_TEAM : false;

		// Update team member changes card
		refreshTeamMemberChangesByUserId(callbackObj.userId, callbackObj.payPeriodId);

		// Update Team member in Parent > Team
		refreshTeamMemberByUserId(callbackObj.userId);

		// Redirect to team tab (used when changes are added without selecting team member)
		if (callbackObj.REDIRECT_TO_TEAM && $state.current.name !== 'payroll.current-period.changes') {
			$timeout(() => {
				$state.go('payroll.current-period.team', {agencyProfileId: agencyProfileId});
			}, 500);
		}
	}

	function updateWorkflow () {
		// Do a complete refresh
		init();
	}

	function reloadChangesData () {

		/* Show the Changes area as loading while it re-fetches (mirrors the Team tab during a refresh). Owns its
		   loading/ready/error state (like loadTeam/refreshTeamData) so it resolves even if the Changes tab is
		   unmounted when this settles; returns the raw promise so callers can layer on their own handling. */
		$scope.vm.changesLoadingState = 'loading';

		let userId; // No UserID specified to return entire team

		const changesPromise = payrollData.getAgencyPaymentAdjustmentDetailList(agencyProfileId, userId, $scope.vm.payPeriod.PayPeriodID);

		changesPromise
			.then(teamMembersChangesArr => {

				$scope.vm.teamMemberChanges = teamMembersChangesArr;

				if (teamMembersChangesArr.length !== 0) {
					setChangesRefreshTooltip(teamMembersChangesArr[0].AdjustmentDataLastRefreshedISO);
				}

				$scope.vm.changesLoadingState = 'ready';
			})
			.catch(error => {
				$scope.vm.changesLoadingState = 'error';
				console.error(error);
			});

		return changesPromise;
	}

	/* Re-fetch the full team-member objects (non-cached, to guarantee fresh figures) and update the Team tab,
	   shown as pending while it loads. Returns the fetch promise so a caller can also wait on it. Used whenever
	   a payroll operation recalculates team figures such as gross pay (a Changes refresh or an alert resolution). */
	function refreshTeamData (vmObj) {

		/* Only refresh the Team tab for users who can see it. Returning undefined (rather than a promise) when
		   Team isn't visible is deliberate: loadPeriodAlerts then falls back to the cached team fetch it needs for
		   the alert recalc, exactly as on the initial load when no team promise is supplied. */
		if (!vmObj.permissions.isTeamVisible) {
			return undefined;
		}

		vmObj.teamLoadingState = 'loading';

		const teamMembersPromise = payrollData.getTeamMembersPayroll(agencyProfileId);

		teamMembersPromise
			.then(teamMembersArr => {
				angular.extend(vmObj, {
					teamMembers: bulkService.getBulkItemsObj(teamMembersArr),
					teamLoadingState: 'ready'
				});
			})
			.catch(error => {
				vmObj.teamLoadingState = 'error';
				console.error(error);
			});

		return teamMembersPromise;
	}

	/* Completion handler for a Changes refresh. payrollRefreshChangesData is a single backend operation that
	   recalculates both the Changes list and Team-member figures, so this refreshes both tabs together. */
	function refreshChangesAndTeamData () {

		// Refresh the Changes list, then confirm success once the fresh data has actually loaded.
		reloadChangesData()
			.then(() => {
				growl.success('Changes refreshed successfully');
			})
			.catch(() => {
				changesRefreshButtonDisabled(false);
			});

		/* payrollRefreshChangesData recalculates both the Changes list and Team-member figures (e.g. gross pay),
		   so both are refreshed together. refreshTeamData itself no-ops when the Team tab isn't visible. */
		refreshTeamData($scope.vm);
	}

	// The Refresh changes button action. selectedChanges is optional (only when the user picked specific changes).
	function refreshChanges (selectedChanges) {

		// Disable the refresh button
		changesRefreshButtonDisabled(true);

		// Get the current refresh state on button click - in case it is currently being refreshed by another user, in which case we wait
		agency.getAgencyPayPeriodState($scope.vm.payPeriod.PayPeriodID, STATE_TYPES.periodChanges).then(state => {

			setChangesRefreshButtonState(state);

			if (state !== SUBMISSION_STATES.finished && state !== SUBMISSION_STATES.failed) {
				pollForChangesRefreshState(refreshChangesAndTeamData);
				return;
			}

			// Protection in case the button active logic doesn't stop a call getting here, or the state changed in a race since the button was clicked
			if (state === SUBMISSION_STATES.finished) {

				payrollData.payrollRefreshChangesData(agencyProfileId, $scope.vm.payPeriod.PayPeriodID, selectedChanges).then(function (data) {

					if (data === -1) {
						throw 'RefreshChangesData error';
					} else {
						pollForChangesRefreshState(refreshChangesAndTeamData);
					}
				})
				.catch(function (error) {
					console.error(error);
					showChangesRefreshError();
				});

			} else {
				showChangesRefreshError(1);
			}
		}).catch(error => {
			console.error(error);
			setChangesRefreshButtonState(SUBMISSION_STATES.failed);
			showChangesRefreshError();
		});
	}

	function pollForChangesRefreshState (onRefreshComplete) {

		isChangesRefreshPolling = true;
		changesPollCounter++;

		agency.getAgencyPayPeriodState($scope.vm.payPeriod.PayPeriodID, STATE_TYPES.periodChanges).then(state => {

			if (state === SUBMISSION_STATES.finished) {

				$timeout.cancel(changesPollTimeout);
				changesPollCounter = 0;
				isChangesRefreshPolling = false;
				setChangesRefreshButtonState(state);
				changesRefreshButtonDisabled(false);

				onRefreshComplete();

			} else if (state === SUBMISSION_STATES.failed || changesPollCounter >= CHANGES_MAX_POLLS) {

				throw 'GetAgencyPayPeriodState error';

			} else {
				// Keep polling
				changesPollTimeout = $timeout(() => {
					pollForChangesRefreshState(onRefreshComplete);
				}, CHANGES_POLL_INTERVAL * 1000);
			}
		})
		.catch(function (error) {
			console.error(error);
			changesPollCounter = 0;
			isChangesRefreshPolling = false;
			setChangesRefreshButtonState(SUBMISSION_STATES.failed);
			$timeout.cancel(changesPollTimeout);
			showChangesRefreshError();
		});
	}

	/* Called when the Changes tab is entered. If a refresh is already running (started in this session, in
	   another browser tab, or by another user), pick the poll back up so the data reload and success toast
	   fire when it completes. */
	function resumeChangesRefreshIfInProgress () {

		if (isChangesRefreshPolling) {
			return;
		}

		agency.getAgencyPayPeriodState($scope.vm.payPeriod.PayPeriodID, STATE_TYPES.periodChanges).then(state => {

			// Re-check after the async state call: a rapid re-entry to this tab, or the user clicking Refresh
			// changes, could have started the poll while this request was in flight > don't start a second one.
			if (isChangesRefreshPolling || state === SUBMISSION_STATES.finished || state === SUBMISSION_STATES.failed) {
				return;
			}

			// A refresh is in progress > reflect it on the button and resume polling
			changesRefreshButtonDisabled(true);
			pollForChangesRefreshState(refreshChangesAndTeamData);
		})
		.catch(angular.noop);
	}

	function openRefreshSelectedChangesForm (searchBarActionKey) {

		if (searchBarActionKey === SEARCH_BAR_ACTIONS.currentPeriodChanges.refresh) {

			$rootScope.openSlideInForm({
				agencyProfileId: agencyProfileId,
				callback: refreshChanges,
				formKey: 'refresh-selected-changes'
			});
		}
	}

	function showChangesRefreshError (errorType) {

		// The refresh isn't running > re-enable the button so the user can retry.
		changesRefreshButtonDisabled(false);

		switch (errorType) {
			// Not a failure > just currently unavailable as an action
			case 1: growl.error('Changes cannot currently be refreshed, please try again');
				break;
			default: growl.error('Changes failed to refresh, please try again');
		}
	}

	function setChangesRefreshButtonState (state) {

		angular.extend($scope.vm.payPeriod, {
			ChangesDataRefreshState: state
		});
	}

	/* Update the Changes 'Refresh' search-bar action. The search bar renders a per-visit copy of the options
	   (angular.merge in getOptionsWithDefaults), so update both the currently-bound options (live, while on the
	   Changes tab) and the searchService singleton (so a later re-render reflects the state). */
	function updateChangesRefreshAction (updateFn) {

		[searchService.currentPeriodChanges, $scope.vm.searchBarOptions].forEach(optionsObj => {

			if (!optionsObj || !optionsObj.actions) {
				return;
			}

			const index = optionsObj.actions.findIndex(item => item.key === SEARCH_BAR_ACTIONS.currentPeriodChanges.refresh);

			if (index > -1) {
				updateFn(optionsObj.actions[index]);
			}
		});
	}

	function changesRefreshButtonDisabled (isDisabled) {

		updateChangesRefreshAction(action => {
			action.disabled = isDisabled;
			action.label = isDisabled ? 'Refreshing changes' : 'Refresh changes';
			action.icon = isDisabled ? 'icon-loading spin' : 'icon-loading';
		});
	}

	function setChangesRefreshTooltip (dateItem) {

		const tooltipText = (dateItem === null || dateItem === '') ? '' : 'Last updated at ' + moment(dateItem).format(config.dateTimeFormatPrimary);

		updateChangesRefreshAction(action => {
			action.tooltipText = tooltipText;
		});
	}

	init();

	angular.extend($scope, {

		// Constants
		DOCUMENT_TYPES,
		DPS_STATES,
		VIEW_TYPES,

		// Variables
		agencyProfileId,
		modal: {},

		// Functions
		isStateActive: applicationService.isStateActive,
		loadPeriodAlerts,
		loadPeriodNotes,
		loadPeriodTasks,
		openAddAChangeForm,
		openAddHourlyTotalsForm,
		openAddLinkRatesForm,
		openAddPeriodNoteForm,
		openAddPeriodTaskForm,
		openCalculatePayrollForm,
		openChangesTable,
		openCompanySettingsCurrencyForm,
		openRefreshSelectedChangesForm,
		openTaxUpdatesForm,
		openUndoImportForm,
		refreshChanges,
		refreshPayroll: init,
		refreshTeam,
		refreshTeamMemberByUserId,
		reloadAlerts,
		reloadChangesData,
		resumeChangesRefreshIfInProgress,
		toggleModal,
		toggleWorkflowActive,
		updatePeriodTasksCount,
		updateUserByUserId,
		updateWorkflow
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollCurrentPeriodAlertsCtrl', ['$filter', '$scope', 'dataTransfer', 'filterService', 'reportData', 'searchService', function ($filter, $scope, dataTransfer, filterService, reportData, searchService) {

	const CALCULATED = false;

	var currentCompanyObj = $scope.currentCompany; // From root

	function createAlertReportDownload (vmObj) {

		vmObj.alertDownloadState = 'loading';

		reportData.createAlertReportDownload(currentCompanyObj.AgencyProfileID, vmObj.payPeriod.PayPeriodID, CALCULATED).then(alertReportUrl => {

			dataTransfer.downloadFile(alertReportUrl, 'alert-report.csv');

			vmObj.alertDownloadState = null;
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		// Extend parent vm obj
		$scope.vm.alertDownloadState = null;
		$scope.vm.filterBarOptions = filterService.payrollAlerts;
		$scope.vm.searchBarOptions = searchService.payrollAlerts;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.createAlertReportDownload = function (vmObj) {

	    createAlertReportDownload(vmObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollCurrentPeriodChangesCtrl', [
	'$scope',
	'searchService',
	function (
		$scope,
		searchService
	) {

	function init () {
		setup();
	}

	function setChangesLoadingState (state) {
		$scope.vm.changesLoadingState = state;
	}

	function setup () {

		setChangesLoadingState('loading');

		$scope.vm.searchBarOptions = searchService.currentPeriodChanges;

		// If a changes refresh is already running (this session, another tab, or another user), resume the poll.
		$scope.resumeChangesRefreshIfInProgress();

		/* The Changes list persists on the shared vm across tab visits and is kept in sync by targeted per-user
		   refreshes (updateUserByUserId) whenever a change is added, so only the first visit needs to fetch the
		   full list. A full reload can always be forced via the Refresh changes button. */
		if (angular.isDefined($scope.vm.teamMemberChanges)) {
			setChangesLoadingState('ready');
			return;
		}

		// reloadChangesData is provided by the parent controller (payrollCurrentPeriodCtrl)
		$scope.reloadChangesData();
	}

	init();
}]);
'use strict';

angular.module('paycircleApp')
.controller('payrollCurrentPeriodImportsCtrl', [
	'$filter',
	'$scope',
	'$stateParams',
	'dataImport',
	'filterService',
	'importService',
	'searchService',
	'IMPORT_MAPPING_TYPES',
	function (
		$filter,
		$scope,
		$stateParams,
		dataImport,
		filterService,
		importService,
		searchService,
		IMPORT_MAPPING_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $scope.currentCompany; // From root
	const payPeriodObj = $scope.vm.payPeriod;

	function init () {

		setSubPageState('loading');

		const INCLUDE_DELETED = true;
		const TEAM_IMPORTS = false;
		const PERIOD_IMPORTS = true;

		dataImport.getUserImportGroups(agencyProfileId, payPeriodObj.PayPeriodID, INCLUDE_DELETED, TEAM_IMPORTS, PERIOD_IMPORTS, IMPORT_MAPPING_TYPES.users).then(importHistoryArr => {

			$scope.vm = {
				filterBarOptions: filterService.getFilterBarOptionsCurrentPeriodImports(currentCompanyObj),
				filteredImportHistoryItems: [],
				importHistoryItems: importHistoryArr.filter(importService.decorateImportGroup),
				payPeriod: payPeriodObj,
				searchBarOptions: searchService.currentPeriodImports
			};

			setSubPageState('ready');
		})
		.catch(error => {
			setSubPageState('error');
			console.error(error);
		});
	}

	function setSubPageState (subPageState) {
		
		$scope.subPageState = subPageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollCurrentPeriodNotesCtrl', ['$rootScope', '$scope', '$stateParams', 'searchService',
	function ($rootScope, $scope, $stateParams, searchService) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function openAddPeriodNoteForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshNotes,
			formKey: 'add-period-note'
		});
	}

	function refreshNotes () {

		// loadPeriodNotes implemented in parent scope
		$scope.loadPeriodNotes($scope.vm);
	}

	function refreshTasks () {

		// loadPeriodTasks is implemented in parent scope. This is required since a task can be created from a note.
		$scope.loadPeriodTasks($scope.vm);
	}

	angular.extend($scope.vm, {

		// Variables
		agencyProfileId,
		notesSearchBarOptions: searchService.notes,

		// Functions
		openAddPeriodNoteForm,
		refreshNotes,
		refreshTasks
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('payrollCurrentPeriodPensionsCtrl', [
	'$scope',
	'$stateParams',
	'logService',
	'messageData',
	'searchService',
	function (
		$scope,
		$stateParams,
		logService,
		messageData,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const payPeriodObj = $scope.vm.payPeriod;

	function init () {

		setPageState('loading');

		messageData.getPensionLogEntriesForPeriod(agencyProfileId, payPeriodObj.PayPeriodID)
			.then(logEntriesArr => {

				angular.extend($scope.vm, {
					searchBarOptions: searchService.pensionHistory,
					logEntries: logService.decorateLogEntries(logEntriesArr)
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollCurrentPeriodTasksCtrl', ['$rootScope', '$scope', '$stateParams', 'filterService', 'searchService',
	function ($rootScope, $scope, $stateParams, filterService, searchService) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function openAddPeriodTaskForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshTasks,
			formKey: 'add-period-task'
		});
	}

	function refreshTasks () {

		// loadPeriodTasks implemented in parent scope
		$scope.loadPeriodTasks($scope.vm);
	}

	function updateTasksCount () {

		// updatePeriodTaskCount implemented in parent scope
		$scope.updatePeriodTasksCount($scope.vm, $scope.vm.tasks.all);
	}

	angular.extend($scope.vm, {

		// Variables
		agencyProfileId,
		filterBarOptions: filterService.tasks,
		searchBarOptions: searchService.tasks,

		// Functions
		openAddPeriodTaskForm,
		refreshTasks,
		updateTasksCount
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('payrollCurrentPeriodTaxUpdatesCtrl', [
	'$scope',
	'$stateParams',
	'$timeout',
	'agency',
	'payrollData',
	'searchService',
	'taxUpdatesService',
	'userData',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	function (
		$scope,
		$stateParams,
		$timeout,
		agency,
		payrollData,
		searchService,
		taxUpdatesService,
		userData,
		STATE_TYPES,
		SUBMISSION_STATES
	) {

	const PAYROLL_POLL_INTERVAL = 5;

	const agencyProfileId = $stateParams.agencyProfileId;
	const payPeriodObj = $scope.vm.payPeriod;

	function checkForTaxUpdates (vmObj) {

		setTaxUpdatesState(vmObj, 'loading');

		payrollData.payrollDPSImport(agencyProfileId).then(() => {

			$timeout(() => {
				pollPayrollState(vmObj);
			}, PAYROLL_POLL_INTERVAL * 1000);
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		userData.getUserTaxUpdatesForPeriod(agencyProfileId, payPeriodObj.PayPeriodID).then((taxUpdatesArray) => {

			$scope.vm = {
				payPeriod: payPeriodObj,
				searchBarOptions: searchService.taxUpdates,
				taxUpdates: taxUpdatesArray.map(taxUpdatesService.decorateTaxUpdateForCurrentPeriod),
				taxUpdatesFiltered: [],
				taxUpdatesState: 'ready'
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function pollPayrollState (vmObj) {

		agency.getAgencyPayPeriodState(payPeriodObj.PayPeriodID, STATE_TYPES.taxUpdates).then(payPeriodState => {

			switch (payPeriodState) {

				// Submitting
				case SUBMISSION_STATES.submitting:

					$timeout(() => {
						pollPayrollState(vmObj);
					}, PAYROLL_POLL_INTERVAL * 1000);
					break;

				// Submitted
				case SUBMISSION_STATES.submitted:

					init();
					break;

				// Failed
				default:

					setTaxUpdatesState(vmObj, 'failed');
					break;
			}
		})
		.catch(onError);
	}

	function refreshTaxUpdates () {

		// From parent controller
		$scope.refreshTeam();

		init();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setTaxUpdatesState (vmObj, taxUpdatesState) {

		vmObj.taxUpdatesState = taxUpdatesState;
	}

	init();

	angular.extend($scope, {
		checkForTaxUpdates,
		refreshTaxUpdates,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('payrollCurrentPeriodTeamCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'agency',
	'bulkService',
	'filterService',
	'pensionData',
	'searchService',
	'FULL_SCREEN_MODAL_KEYS',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		agency,
		bulkService,
		filterService,
		pensionData,
		searchService,
		FULL_SCREEN_MODAL_KEYS
	) {

	const applyfilter = $stateParams.applyfilter;
	const currentCompanyObj = $scope.currentCompany; // From root
	const payPeriodObj = $scope.vm.payPeriod; // From parent

	function init () {

		setPageState('loading');

		/* Departments/pensions are reference data that only feed the filter-bar options and don't change
		   during the session. Cache the raw data on the shared vm and reuse it across Team-tab visits >
		   avoids re-fetching GetAgencyDepartments/GetPensionsForAgency every time the tab is opened. */
		if (angular.isDefined($scope.vm.currentPeriodTeamFilterData)) {
			applyTeamFilters($scope.vm.currentPeriodTeamFilterData);
			setPageState('ready');
			return;
		}

		const getPensionsForAgency = currentCompanyObj.HasPension ? pensionData.getPensionsForAgency(currentCompanyObj.AgencyProfileID) : null;
		const getAgencyDepartments = agency.getAgencyDepartments(currentCompanyObj.AgencyProfileID);

		$q.all([getPensionsForAgency, getAgencyDepartments])
			.then(([pensionsArr, departmentsArr]) => {

				$scope.vm.currentPeriodTeamFilterData = { pensionsArr, departmentsArr };

				applyTeamFilters($scope.vm.currentPeriodTeamFilterData);

				setPageState('ready');
			})
			.catch(onError);
	}

	function applyTeamFilters (filterData) {

		angular.extend($scope.vm, {
			applyfilter: applyfilter,
			filterBarOptions: filterService.getFilterBarOptionsCurrentPeriod(filterData.pensionsArr, filterData.departmentsArr),
			searchBarOptions: searchService.currentPeriod
		});
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function openEditPayslipNotesForm (filteredTeamMembers) {

		const selectedTeamMembersUserIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID', 'PersonalDetails');

		if (!selectedTeamMembersUserIdsArr.length) {
			console.warn('Team members need to be selected to edit their payslip notes');
			return;
		}

		$rootScope.$broadcast('open-full-screen-modal', {
			modalKey: FULL_SCREEN_MODAL_KEYS.payslipNotes,
			userIds: selectedTeamMembersUserIdsArr,
			agencyProfileId: currentCompanyObj.AgencyProfileID,
			payPeriod: payPeriodObj,
			searchBarOptions: $scope.vm.searchBarOptions,
			callback: $scope.refreshTeam // From parent controller
		});
	}

	function openRemovePayslipNotesForm (filteredTeamMembers) {

		const selectedTeamMembersUserIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID', 'PersonalDetails');

		if (!selectedTeamMembersUserIdsArr.length) {
			console.warn('Team members need to be selected to remove their payslip notes');
			return;
		}

		$rootScope.openSlideInForm({
			userIds: selectedTeamMembersUserIdsArr,
			agencyProfileId: currentCompanyObj.AgencyProfileID,
			payPeriod: payPeriodObj,
			formKey: 'remove-payslip-notes',
			searchBarOptions: $scope.vm.searchBarOptions,
			callback: $scope.refreshTeam // From parent controller
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		refreshPayroll: init,
		openEditPayslipNotesForm,
		openRemovePayslipNotesForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('payPeriodCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'payrollData',
	'reportData',
	'supplementaryPayRunService',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		payrollData,
		reportData,
		supplementaryPayRunService,
		SUBMISSION_STATES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const payPeriodId = $stateParams.payPeriodId;
	const isReportingVisible = $rootScope.currentUser.Permissions.isReportingVisible;

	function editPayNotificationDate (payPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'edit-pay-notification-date',
			payPeriod: payPeriodObj
		});
	}

	function init () {

		setPageState('loading');

		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific(payPeriodId);
		// Only fetch reports when the user can view reporting; report generation is separate and still runs.
		const getReports = isReportingVisible ? reportData.getReports(agencyProfileId, payPeriodId) : $q.when([]);
		const getSupplementaryPaymentsForAgencyPayPeriod = payrollData.getSupplementaryPaymentsForAgencyPayPeriod(agencyProfileId, payPeriodId);

		$q.all([
			getPayPeriodSpecific,
			getReports,
			getSupplementaryPaymentsForAgencyPayPeriod
		]).then(([
			payPeriodObj,
			reportsArr,
			supplementaryPaymentsArr
		]) => {

			$scope.vm = {
				payPeriod: payPeriodObj,
				reports: reportsArr,
				supplementaryPayments: supplementaryPaymentsArr.filter(supplementaryPayRunService.filterSupplementaryPayments)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openReportsExportForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'download-reports',
			payPeriodId: payPeriodId
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope,  {
		agencyProfileId,

		init,
		editPayNotificationDate,
		openReportsExportForm,

		SUBMISSION_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('supplementaryPayRunCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'payrollData',
	'permissionsService',
	'reportData',
	'reportsService',
	'supplementaryPayRunService',
	'tabService',
	'SUBMISSION_STATES',
	'TAB_KEYS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		payrollData,
		permissionsService,
		reportData,
		reportsService,
		supplementaryPayRunService,
		tabService,
		SUBMISSION_STATES,
		TAB_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentUserObj = $scope.currentUser; // From root
	const payPeriodId = $stateParams.payPeriodId;
	const supplementaryPaymentId = $stateParams.supplementaryPaymentId;

	function init () {

		setPageState('loading');

		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific(payPeriodId);
		const getSupplementaryPayment = payrollData.getSupplementaryPayment(agencyProfileId, supplementaryPaymentId);
		const getReports = reportData.getReports(agencyProfileId, payPeriodId, supplementaryPaymentId);

		$q.all([
			getPayPeriodSpecific,
			getSupplementaryPayment,
			getReports
		]).then(([
			payPeriodSpecificObj,
			supplementaryPaymentObj,
			reportsArr
		]) => {

			const permissions = permissionsService.getPermissionsForStateSupplementaryPayRun(currentUserObj, supplementaryPaymentObj);
			const supplementaryPayRunTabBarDef = tabService.getTabsForKey(TAB_KEYS.payroll.supplementaryPayRun.id, { permissions });
			const isCurrentTabVisible = supplementaryPayRunTabBarDef.tabs.some(tab => tab.sref.indexOf($state.current.name) > -1);

			$scope.vm = {
				agencyProfileId,
				openDeleteSupplementaryRunForm,
				openEditSupplementaryPaymentForm,
				payPeriod: payPeriodSpecificObj,
				payslipReports: $filter('reportCategories')(reportsArr, 'payslip'),
				permissions,
				reports: reportsService.getReportsForPayPeriod(reportsArr),
				supplementaryPayment: supplementaryPayRunService.decorateSupplementaryPaymentObj(supplementaryPaymentObj),
				supplementaryPayRunTabBarDef
			};

			// Only ever land on a tab the user can see: entry links target reports, so redirect when it's hidden.
			if (!isCurrentTabVisible) {

				const defaultTab = tabService.getDefaultTab(supplementaryPayRunTabBarDef);

				if (defaultTab) {
					// The tab sref embeds its params (e.g. state({agencyProfileId: '...'})); $state.go needs them separate.
					$state.go(defaultTab.sref.split('(')[0], { agencyProfileId }, { location: 'replace' });
				}
			}

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openDeleteSupplementaryRunForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: () => {

				// Redirect back to sup runs page
				$state.go('payroll.history.supplementary-pay-runs', {agencyProfileId});
			},
			formKey: 'delete-supplementary-pay-run', // The specific form key (form to open)
			supplementaryPayment: vmObj.supplementaryPayment
		});
	}

	function openEditSupplementaryPaymentForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			continue: true,
			formKey: 'supplementary-pay-run',
			supplementaryPaymentId: vmObj.supplementaryPayment.SupplementaryPaymentID,
			userIds: vmObj.supplementaryPayment.distinctUserIds
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		SUBMISSION_STATES,
		agencyProfileId,
		init
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('supplementaryPayRunChangesCtrl', [
	'$scope',
	'$stateParams',
	'payrollData',
	'searchService',
	function (
		$scope,
		$stateParams,
		payrollData,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const supplementaryPaymentId = $stateParams.supplementaryPaymentId;

	function init () {

		setPageState('loading');

		payrollData.getSupplementaryPaymentAgencyPaymentAdjustmentDetailList(agencyProfileId, supplementaryPaymentId).then(teamMembersChangesArr => {

			angular.extend($scope.vm, {
				searchBarOptions: searchService.currentPeriodChanges,
				teamMemberChanges: teamMembersChangesArr
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollFutureChangesCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'edpTopicService',
	'filterService',
	'payrollData',
	'searchService',
	'session',
	'teamData',
	'REPAYMENT_SCHEDULE_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		edpTopicService,
		filterService,
		payrollData,
		searchService,
		session,
		teamData,
		REPAYMENT_SCHEDULE_TYPES
	) {

	const SCHEDULED_PAYMENT_TYPES = {
		change: 'change',
		maternityPay: 'smp',
		paternityPay: 'spp',
		salaryChange: 'salary-change',
		scheduledPayment: 'scheduled',
		sharedParentalPay: 'shpp',
		sicknessPay: 'ssp',
	};

	const agencyProfileId = $stateParams.agencyProfileId;
	const canUpdateAdjustments = $scope.$root.currentUser.Permissions.Payroll.canUpdateAdjustments;
	const loggedInUserId = session.getUserId();

	function deleteUserPayElement (payElementObj) {

		payrollData.deleteUserPayElement(agencyProfileId, payElementObj.PayPeriodID, payElementObj.UserPayElementID, loggedInUserId)
			.then(init)
			.catch(onError);
	}

	function getChangesForPaymentType (futureChangesArr, paymentsArr, paymentTypeKey, isEdpTopicEnabled) {

		function getStartDateForPaymentType (paymentObj) {

			switch (paymentTypeKey) {
				case SCHEDULED_PAYMENT_TYPES.salaryChange:
					return paymentObj.SalaryEffectiveDateChangeISO;

				case SCHEDULED_PAYMENT_TYPES.change:
					return paymentObj.PeriodStartDateISO;

				default:
					return paymentObj.StartDateISO;
			}
		}

		for (let paymentObj of paymentsArr) {

			// Maternity and adjustment rows use per-record provenance. Paternity and sickness continue to use
			// the current EDP topic state until their snapshot cutovers.
			const isLocked = angular.isDefined(isEdpTopicEnabled) ? isEdpTopicEnabled : paymentObj.IsFromIntegration;

			angular.extend(paymentObj, {
				paymentType: paymentTypeKey,
				startDateUnix: moment(getStartDateForPaymentType(paymentObj)).format('x'),
				canEdit: canUpdateAdjustments && paymentObj.CanBeUpdated && !isLocked,
				canDelete: canUpdateAdjustments && paymentObj.CanBeDeleted && !isLocked
			});

			futureChangesArr.push(paymentObj);
		}
	}

	function getCombinedFutureChanges (futureAdjustmentsArr, statutoryPaymentsObj, futureSalaryChangesArr, edpTopicEnabledMap) {

		const futureChangesArr = [];

		// Changes
		for (let teamMemberObj of futureAdjustmentsArr) {
			getChangesForPaymentType(futureChangesArr, teamMemberObj.PayElements, SCHEDULED_PAYMENT_TYPES.change);
		}

		// Schedule payments
		getChangesForPaymentType(futureChangesArr, statutoryPaymentsObj.MaternityPay, SCHEDULED_PAYMENT_TYPES.maternityPay);
		getChangesForPaymentType(futureChangesArr, statutoryPaymentsObj.PaternityPay, SCHEDULED_PAYMENT_TYPES.paternityPay, edpTopicEnabledMap[SCHEDULED_PAYMENT_TYPES.paternityPay]);
		getChangesForPaymentType(futureChangesArr, statutoryPaymentsObj.ScheduledPayments, SCHEDULED_PAYMENT_TYPES.scheduledPayment);
		getChangesForPaymentType(futureChangesArr, statutoryPaymentsObj.SharedParentalPay, SCHEDULED_PAYMENT_TYPES.sharedParentalPay);
		getChangesForPaymentType(futureChangesArr, statutoryPaymentsObj.SicknessPay, SCHEDULED_PAYMENT_TYPES.sicknessPay);

		// Future Salary Changes
		getChangesForPaymentType(futureChangesArr, futureSalaryChangesArr, SCHEDULED_PAYMENT_TYPES.salaryChange);

		return futureChangesArr;
	}

	function getFutureAdjustmentViewFormForPaymentType (adjustmentObj) {

		switch (adjustmentObj.paymentType) {

			case SCHEDULED_PAYMENT_TYPES.salaryChange:
				return openSalaryChangeForm;

			case SCHEDULED_PAYMENT_TYPES.change:
				return openEditChangeForm;

			case SCHEDULED_PAYMENT_TYPES.maternityPay:
				return openMaternityPayViewForm;

			case SCHEDULED_PAYMENT_TYPES.paternityPay:
				return openPaternityPayViewForm;

			case SCHEDULED_PAYMENT_TYPES.scheduledPayment:

				switch (adjustmentObj.PaymentScheduleTypeID) {

					case REPAYMENT_SCHEDULE_TYPES.childcareVouchers:
						return openChildcareVouchersForm;

					case REPAYMENT_SCHEDULE_TYPES.carBenefitInKind:
						return openCompanyVehicleViewForm;

					case REPAYMENT_SCHEDULE_TYPES.healthcare:
						return openHealthcareViewForm;

					default:
						return openRepaymentScheduleForm;
				}
				break;

			case SCHEDULED_PAYMENT_TYPES.sicknessPay:
				return openSickPayViewForm;
		}
	}

	function init () {

		setPageState('loading');

		const isFutureAdjustments = true;
		let agencyPayPeriodId;
		let userId;

		const getTeamMemberStatutoryPay = teamData.getTeamMemberStatutoryPay(userId, agencyProfileId, isFutureAdjustments);
		const getUserPayElements = payrollData.getUserPayElements(agencyProfileId, agencyPayPeriodId, userId, isFutureAdjustments);
		const getSalaryFutureChanges = payrollData.getSalaryFutureChanges(agencyProfileId);
		const getPaternityTopicEnabled = edpTopicService.isTopicEnabled(agencyProfileId, edpTopicService.TOPIC_KEYS.paternity);

		$q.all([
			getTeamMemberStatutoryPay,
			getUserPayElements,
			getSalaryFutureChanges,
			getPaternityTopicEnabled
		])
			.then(([
				statutoryPaymentsObj,
				futureAdjustmentsArray,
				futureSalaryChangesArr,
				isEdpPaternityTopicEnabled
			]) => {

				const edpTopicEnabledMap = {
					[SCHEDULED_PAYMENT_TYPES.paternityPay]: isEdpPaternityTopicEnabled
				};

				angular.extend($scope, {
					futureChanges: getCombinedFutureChanges(futureAdjustmentsArray, statutoryPaymentsObj, futureSalaryChangesArr, edpTopicEnabledMap),
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		throw new Error(error);
	}

	function openAddAChangeForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'add-a-change',
			isFutureAdjustment: true
		});
	}

	function openCompanyVehicleViewForm (adjustmentObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'company-vehicle-view',
			paymentScheduleGroupId: adjustmentObj.PaymentScheduleGroupID,
			userId: adjustmentObj.UserID
		});
	}

	function openChildcareVouchersForm (adjustmentObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'childcare-vouchers',
			paymentScheduleGroupId: adjustmentObj.PaymentScheduleGroupID,
			userId: adjustmentObj.UserID
		});
	}

	function openDeleteChangeForm (adjustmentObj) {

		$rootScope.openSlideInForm({
			adjustmentObj: adjustmentObj,
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'delete-change',
			userId: adjustmentObj.UserID
		});
	}

	function openEditChangeForm (adjustmentObj) {

		$rootScope.openSlideInForm({
			adjustmentId: adjustmentObj.UserPayElementID,
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'add-a-change',
			isFutureAdjustment: true,
			payPeriodId: adjustmentObj.PayPeriodID,
			title: 'Edit change',
			userId: adjustmentObj.UserID
		});
	}

	function openFutureAdjustmentViewForm (adjustmentObj) {
		getFutureAdjustmentViewFormForPaymentType(adjustmentObj)(adjustmentObj);
	}

	function openHealthcareViewForm (adjustmentObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'healthcare-view',
			paymentScheduleGroupId: adjustmentObj.PaymentScheduleGroupID,
			userId: adjustmentObj.UserID
		});
	}

	function openMaternityPayViewForm (maternityPayObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-maternity-pay',
			userId: maternityPayObj.UserID,
			scheduleID: maternityPayObj.PaymentScheduleGroupID
		});
	}

	function openPaternityPayViewForm (paternityPayObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-paternity-pay',
			userId: paternityPayObj.UserID,
			scheduleID: paternityPayObj.PaymentScheduleGroupID
		});
	}

	function openRepaymentScheduleForm (repaymentScheduleObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'repayment-schedules',
			paymentScheduleGroupId: repaymentScheduleObj.PaymentScheduleGroupID,
			userId: repaymentScheduleObj.UserID
		});
	}

	function openSalaryChangeForm (futureSalaryObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'salary-change',
			salaryChange: futureSalaryObj,
			useProvidedSalaryChange: true,
			userId: futureSalaryObj.UserID
		});
	}

	function openSickPayViewForm (sicknessPayObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-sick-pay',
			userId: sicknessPayObj.UserID,
			scheduleID: sicknessPayObj.PaymentScheduleGroupID
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		REPAYMENT_SCHEDULE_TYPES,
		SCHEDULED_PAYMENT_TYPES,

		agencyProfileId,
		filterBarOptions: filterService.futureChanges,
		searchBarOptions: searchService.futureChanges,

		deleteUserPayElement,
		openAddAChangeForm,
		openDeleteChangeForm,
		openEditChangeForm,
		openFutureAdjustmentViewForm,
		openSickPayViewForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollHistoryCtrl', [
	'$scope',
	'tabService',
	'TAB_KEYS',
	function (
		$scope,
		tabService,
		TAB_KEYS
	) {

	function init () {
		
		$scope.vm = {
			payrollHistoryTabBarDef: tabService.getTabsForKey(TAB_KEYS.payroll.history.id),
		};
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('payrollHistoryPayPeriodsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'bulkService',
	'filterService',
	'payrollData',
	'searchService',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		bulkService,
		filterService,
		payrollData,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function getCombinedPayPeriods (payPeriodsArr, historicPayPeriodsArr) {

		function payPeriodDecorator (isHistoricPeriod) {
			return payPeriodObj => {

				angular.extend(payPeriodObj, {
					payPeriodIsDisabled: (isHistoricPeriod || payPeriodObj.IsRunInactivity || payPeriodObj.IsRunSkipped),
					isHistoric: isHistoricPeriod
				});

				if (isHistoricPeriod) {
					angular.extend(payPeriodObj, {
						PayPeriodID: payPeriodObj.AgencyPayPeriodID,
						PayDateISO: payPeriodObj.AgencyPaymentDateISO,
						PayPeriodDisplay: payPeriodObj.TaxMonth,
					});
				}
			};
		}

		payPeriodsArr.forEach(payPeriodDecorator(false));
		historicPayPeriodsArr.forEach(payPeriodDecorator(true));

		// Put historic and contemporaneous pay periods together, so they're all in a single list, ordered by pay period date
		let payPeriodsCombinedArr = payPeriodsArr.concat(historicPayPeriodsArr);

		return bulkService.getBulkItemsObj(payPeriodsCombinedArr);
	}

	function init () {

		setPageState('loading');

		// Load pay periods for company, including any historical ones
		const getPayPeriodsHistory = payrollData.getPayPeriodsHistory(agencyProfileId);
		const getAgencyPaymentsHistorical = payrollData.getAgencyPaymentsHistorical(agencyProfileId);

		$q.all([
			getPayPeriodsHistory,
			getAgencyPaymentsHistorical
		]).then(([
			payPeriodsArr,
			historicPayPeriodsArr
		]) => {

			angular.extend($scope.vm, {
				payPeriods: getCombinedPayPeriods(payPeriodsArr, historicPayPeriodsArr)
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function openHistoricPayPeriodForm (payPeriodsArr) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			extantPayPeriods: payPeriodsArr,
			formKey: 'historic-tax-period',
			showContext: true,
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,

		filterBarOptions: filterService.history,
		searchBarOptions: searchService.history,

		init,
		openHistoricPayPeriodForm,
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('payrollHistorySupplementaryPayRunsCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'filterService',
	'payrollData',
	'searchService',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$rootScope,
		$scope,
		$stateParams,
		filterService,
		payrollData,
		searchService,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function decorateSupplementaryPayments (supplementaryPaymentObj) {

		// Date fields -> Unix timestamps for sorting
		supplementaryPaymentObj.supplementaryPaymentPayDateUnix = moment(supplementaryPaymentObj.SupplementaryPaymentPayDateISO).format('x');
		supplementaryPaymentObj.supplementaryPaymentLastUpdatedDateUnix = moment(supplementaryPaymentObj.SupplementaryPaymentLastUpdatedDateISO).format('x');

		// Only show Submitted pay runs for CAL or GAL roles
		if ($rootScope.userHasRole(USER_ROLES.companyadministratorlite) || $rootScope.userHasRole(USER_ROLES.groupadminlite)) {

			if (supplementaryPaymentObj.SupplementaryPaymentState !== SUBMISSION_STATES.submitted) {
				return;
			}
		}

		return supplementaryPaymentObj;
	}

	function init () {

		setPageState('loading');

		payrollData.getSupplementaryPaymentsForAgency(agencyProfileId).then(supplementaryPaymentsArr => {

			angular.extend($scope.vm, {
				searchBarOptions: searchService.supplementaryPayRuns,
				supplementaryPayments: supplementaryPaymentsArr.filter(decorateSupplementaryPayments),
				supplementaryPaymentsFiltered: []
			});

			setPageState('ready');
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
		});
	}

	function refresh () {

		init();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		refresh
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('payrollRunPayrollCtrl', [
	'$filter',
	'$location',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'agency',
	'applicationService',
	'config',
	'messageData',
	'payrollData',
	'payrollWorker',
	'permissionsService',
	'reportData',
	'workflowService',
	'wootricService',
	'ACCOUNTING_INTEGRATION_TYPES',
	'ANIMATION_STATES',
	'COMPANY_STATES',
	'SPLASH_STATES',
	'STATE_TYPES',
	'SUBMISSION_LOG_TYPE',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$filter,
		$location,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		agency,
		applicationService,
		config,
		messageData,
		payrollData,
		payrollWorker,
		permissionsService,
		reportData,
		workflowService,
		wootricService,
		ACCOUNTING_INTEGRATION_TYPES,
		ANIMATION_STATES,
		COMPANY_STATES,
		SPLASH_STATES,
		STATE_TYPES,
		SUBMISSION_LOG_TYPE,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const activeTab = $stateParams.activeTab;
	const AGENCY_PROFILE_ID = $stateParams.agencyProfileId;
	const POLL_INTERVAL_PAYROLL = 5; // seconds
	const POLL_INTERVAL_PAYSLIPS = 2; // seconds
	const POLL_INTERVAL_REPORTS = 2; // seconds
	const SUB_STATES_TOTAL = 5;
	const loggedInUserObj = $scope.currentUser;
	const isLiteAdminRole = $rootScope.userHasRole([USER_ROLES.groupadminlite, USER_ROLES.companyadministratorlite]);

	let currentCompanyObj = $scope.currentCompany; // From parent
	let payslipTimeout = null;
	let reportTimeout = null;
	let wootricTimeout = null;
	let POLL_COUNT = 0;

	function checkPayslipStatus (vmObj) {

		agency.getAgencyPayPeriodState(vmObj.payPeriod.PayPeriodID, STATE_TYPES.payslip).then(payslipState => {

			switch (payslipState) {
				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.submitting:

					// Update pay period
					vmObj.payPeriod.PayslipState = payslipState;

					payslipTimeout = $timeout(() => {
						checkPayslipStatus(vmObj);
					}, POLL_INTERVAL_PAYSLIPS * 1000);
					break;

				case SUBMISSION_STATES.failed:

					// Update pay period
					vmObj.payPeriod.PayslipState = payslipState;

					setPageState('error');
					console.error('Paycircle: Pay period reports were unable to be calculated');
					break;

				default:

					refreshReports(vmObj).then(() => {

						vmObj.payPeriod.PayslipState = payslipState;

						setPageState('ready');
					})
					.catch(onError);
			}
		})
		.catch(onError);
	}

	function checkReportStatus (vmObj) {

		agency.getAgencyPayPeriodState(vmObj.payPeriod.PayPeriodID, STATE_TYPES.report).then(reportState => {

			// Update pay period
			vmObj.payPeriod.ReportState = reportState;

			switch (reportState) {
				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.submitting:

					reportTimeout = $timeout(() => {
						checkReportStatus(vmObj);
					}, POLL_INTERVAL_REPORTS * 1000);
					break;

				case SUBMISSION_STATES.failed:

					setPageState('error');
					console.error('Paycircle: Pay period reports were unable to be calculated');
					break;

				default:

					refreshPayPeriod(vmObj);
			}
		})
		.catch(onError);
	}

	function createPayslips (vmObj) {

		vmObj.payPeriod.PayslipState = SUBMISSION_STATES.submitting;

		payrollWorker.payrollCreatePayslips(AGENCY_PROFILE_ID, vmObj.payPeriod.PayPeriodID).then(() => {

			vmObj.hasGeneratedPayslips = true;

			checkPayslipStatus(vmObj);
		})
		.catch(error => {
			$rootScope.paycircleMessage('Unable to generate your reports', 'error');
			console.error(error);
		});
	}

	function fireConfetti (vmObj) {

		vmObj.showConfetti = false;

		$timeout(() => {

			vmObj.showConfetti = true;
		});
	}

	function generateReports (vmObj) {

		payrollWorker.payrollCreateReports(AGENCY_PROFILE_ID, vmObj.payPeriod.PayPeriodID).then(() => {

			checkReportStatus(vmObj);
		})
		.catch(error => {
			console.error(error);
			$rootScope.paycircleMessage('Unable to generate your reports', 'error');
		});
	}

	function getIsSplashScreenVisible (workflowTemplateObj) {

		// No current template
		if (!workflowTemplateObj.TemplateEntryCurrent) {
			return false;
		}

		// Don't show if overdue
		if (workflowTemplateObj.TemplateEntryCurrent.IsOverdue) {
			return false;
		}

		// Only show if is actioner
		if (!workflowTemplateObj.TemplateEntryCurrent.IsActioner) {
			return false;
		}

		switch (workflowTemplateObj.TemplateEntryCurrent.SplashState) {
			case SPLASH_STATES.inactive:
			case SPLASH_STATES.complete:
				return false;
		}

		return true;
	}

	function init () {

		const IS_PREVIOUS_PERIOD = true;

		setPageState('loading');

		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(AGENCY_PROFILE_ID);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(AGENCY_PROFILE_ID, IS_PREVIOUS_PERIOD);
		const getWorkflowTemplates = currentCompanyObj.IsWorkflowEnabled ? messageData.getWorkflowTemplates(AGENCY_PROFILE_ID) : null;
		const getAccountingIntegrationConnection = reportData.getAccountingIntegrationConnection(AGENCY_PROFILE_ID);
		const getCanRunPayroll = payrollData.getCanRunPayroll(AGENCY_PROFILE_ID);

		$q.all([
			getPayPeriodCurrent,
			getPayPeriodMinimum,
			getWorkflowTemplates,
			getAccountingIntegrationConnection,
			getCanRunPayroll
		]).then(([
			currentPayPeriodObj,
			previousPayPeriodObj,
			workflowTemplatesArr,
			accountingIntegrationConnectionObj,
			canRunPayrollObj
		]) => {

			const isWorkflowActive = workflowService.isWorkflowActive(currentCompanyObj, workflowTemplatesArr);
			const permissions = permissionsService.getPermissionsForStateRunPayroll(currentPayPeriodObj, currentCompanyObj, loggedInUserObj, workflowTemplatesArr);

			accountingIntegrationConnectionObj.accountingIntegrationName = accountingIntegrationConnectionObj.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.accessFinancials ? 'Access Financials' : 'Xero';

			var vmObj = {
				accountingIntegrationConnection: accountingIntegrationConnectionObj,
				activeTab: activeTab,
				canRunPayroll: canRunPayrollObj,
				isPayslipButtonOpen: false,
				isWorkflowActive: isWorkflowActive,
				companyPayrollNgRef: applicationService.getNgHrefForCompany(currentCompanyObj, 'payroll', isLiteAdminRole),
				hasGeneratedPayslips: false,
				payPeriod: currentPayPeriodObj,
				payrollSuccessState: ANIMATION_STATES.visible,
				permissions,
				previousPayPeriod: previousPayPeriodObj,
				showPayrollSuccess: true,
				showConfetti: false
			};

			// Redirect user back to current-period in case they have some how got to this page without payroll being locked
			if (!currentPayPeriodObj.IsPayrollLocked) {
				$location.path(vmObj.companyPayrollNgRef);
				return;
			}

			// Workflow enabled
			if (isWorkflowActive) {

				let workflowTemplateObj = workflowTemplatesArr[0];

				// Re-direct to 'Calculate' if queried
				if (isLiteAdminRole && workflowTemplateObj.IsPayrollQueried) {
					$state.go('payroll.current-period.notes', {agencyProfileId: AGENCY_PROFILE_ID});
					return;
				}

				// Re-direct to Changes if person is being sneaky
				if (workflowTemplateObj.TemplateEntryCurrent.Number === 1) {
					$state.go('payroll.current-period.changes', {agencyProfileId: AGENCY_PROFILE_ID});
					return;
				}

				workflowTemplateObj = workflowService.decorateWorkflowTemplate(workflowTemplateObj);

				/* Decide whether or not to add additional text to the locked tooltip (copied from the template, since
				   this can also be displayed for non-workflow companies). Additionally check canCalcualtePayroll permission */
				const showAdditionalLockedTooltipText = workflowTemplateObj.TemplateEntryCurrent.Number === 2 && permissions.canCalculatePayroll;

				angular.extend(vmObj, {
					workflowTemplate: workflowTemplateObj,
					isRestrictedView: workflowTemplateObj.TemplateEntryCurrent.Number >= 3 && isLiteAdminRole,
					showAdditionalLockedTooltipText
				});

				// Splash screen
				const isSplashScreenVisible = getIsSplashScreenVisible(workflowTemplateObj);

				if (isSplashScreenVisible) {
					$rootScope.openModalDialog({
						modalData: {
							workflowTemplate: workflowTemplateObj
						},
						modalKey: 'workflow-draft-reports'
					});
				}
			}

			// Show the additional locked tooltip text if unlock payroll is visible
			vmObj.showAdditionalLockedTooltipText = permissions.isUnlockPayrollVisible;

			generateReports(vmObj);
		})
		.catch(onError);

		// Onboarding > Demo
		$rootScope.setDemoTaskAsComplete('calculatePayroll');
	}

	function openAddPeriodNoteForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: init,
			formKey: 'add-period-note'
		});
	}

	function openAddPeriodTaskForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: init,
			formKey: 'add-period-task'
		});
	}

	function openBACSFileCreationForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: init,
			formKey: 'company-settings-bacs'
		});
	}

	function openReportsExportForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: () => {

				vmObj.hasGeneratedPayslips = true;

				checkPayslipStatus(vmObj);
			},
			formKey: 'download-reports',
			hasGeneratedPayslips: vmObj.hasGeneratedPayslips,
			isHistoricPeriod: false,
			payPeriodId: vmObj.payPeriod.PayPeriodID
		});
	}

	function openRunPayrollForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: runPayrollCallback,
			formKey: 'run-payroll'
		});
	}

	function openUncalculatePayrollForm (vmObj, workflowTemplateObj) {

		$rootScope.openSlideInForm({
			actionType: 'uncalculate',
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: () => {
				$state.go('payroll.current-period.changes', {
					agencyProfileId: AGENCY_PROFILE_ID
				});
			},
			formKey: 'calculate-payroll',
			payPeriodId: vmObj.payPeriod.PayPeriodID,
			title: 'Undo calculation',
			workflowTemplate: workflowTemplateObj
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function pollPayrollState (vmObj, onComplete) {

		// Load Pay Period state
		agency.getAgencyPayPeriodState(vmObj.payPeriod.PayPeriodID, STATE_TYPES.finalise).then(payPeriodState => {

			switch (payPeriodState) {

				// Pending
				case SUBMISSION_STATES.requesting:
				case SUBMISSION_STATES.submitting:

					if (POLL_COUNT > 0 && POLL_COUNT < SUB_STATES_TOTAL + 1) {
						$scope.payPeriodSubState = $scope.payPeriodSubState + 1;
					}

					$timeout(function () {
						pollPayrollState(vmObj, onComplete);
					}, POLL_INTERVAL_PAYROLL * 1000);

					// Increase loop
					POLL_COUNT++;

					// Update scope
					vmObj.payPeriod.PayrollState = payPeriodState;

					break;

				// Complete
				case SUBMISSION_STATES.submitted:
				case SUBMISSION_STATES.failed:

					// Appear to complete sub states
					$scope.payPeriodSubState = SUB_STATES_TOTAL;

					// Give user time to digest state
					$timeout(function () {

						// Update scope
						vmObj.payPeriod.PayrollState = payPeriodState;

						// Callback
						onComplete(vmObj);

					}, 1500);

					break;

				default:

					// Update scope
					vmObj.payPeriod.PayrollState = payPeriodState;
			}

		})
		.catch(onError);
	}

	function refreshPayPeriod (vmObj) {

		const PAY_PERIOD_SUBMITTED = (vmObj.payPeriod && vmObj.payPeriod.PayrollState === SUBMISSION_STATES.submitted);

		const getPayPeriodCurrent = !vmObj.payPeriod || PAY_PERIOD_SUBMITTED ? payrollData.getPayPeriodCurrent(AGENCY_PROFILE_ID) : null;
		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific(vmObj.payPeriod.PayPeriodID);

		$q.all([getPayPeriodSpecific, getPayPeriodCurrent]).then(([updatedPayPeriodObj, nextPayPeriodObj]) => {

			/* Reports only feed the Payslips download and the Reports tab, both gated by isReportingVisible. Skip
			   the fetch when the user can't view reports (report generation still runs upstream, since its output
			   feeds the period figures); resolve with an empty list so the page still renders through this path. */
			const getReports = loggedInUserObj.Permissions.isReportingVisible ? reportData.getReports(AGENCY_PROFILE_ID, vmObj.payPeriod.PayPeriodID) : $q.when([]);

			getReports
				.then(reportsArr => {

					// Update app header
					if (nextPayPeriodObj) {
						$rootScope.currentPeriod = nextPayPeriodObj;
					}

					angular.extend(vmObj, {
						payPeriod: updatedPayPeriodObj ? updatedPayPeriodObj : null,
						nextPayPeriod: nextPayPeriodObj ? nextPayPeriodObj : null,
						payslipReports: $filter('reportCategories')(reportsArr, 'payslip'),
						reports: reportsArr
					});

					// Payroll is being processed
					if ([SUBMISSION_STATES.submitting, SUBMISSION_STATES.requesting].includes(vmObj.payPeriod.PayrollState)) {
						pollPayrollState(vmObj, refreshPayPeriod);
						return;
					}

					updateWorkflow(vmObj);

					$scope.vm = vmObj;

					setPageState('ready');

					// Confetti
					if (vmObj.payPeriod.PayrollState === SUBMISSION_STATES.submitted) {

						$timeout(function () {
							fireConfetti(vmObj);
						}, 1000);

						// Refresh current company to update HasRunPayroll state
						if (!currentCompanyObj.HasRunPayroll) {
							$rootScope.$broadcast('set-current-company', AGENCY_PROFILE_ID);
						}

						wootricTimeout = $timeout(function () {
							wootricService.triggerSurvey();
						}, 1500);
					}

					$rootScope.setDemoTaskAsComplete('checkPayroll');
				})
				.catch(onError);
		})
		.catch(onError);
	}

	function refreshReports (vmObj) {

		const deferred = $q.defer();

		reportData.getReports(AGENCY_PROFILE_ID, vmObj.payPeriod.PayPeriodID).then(reportsArr => {

			angular.extend(vmObj, {
				payslipReports: $filter('reportCategories')(reportsArr, 'payslip'),
				reports: reportsArr
			});

			deferred.resolve(vmObj);
		})
		.catch(error => {
			deferred.reject(error);
		});

		return deferred.promise;
	}

	function resetPeriod (payPeriodObj) {

		payPeriodObj.state = 'resetting';
		agency.updateAgencyPayPeriodResetFailedState(payPeriodObj.PayPeriodID).then(() => {
			init();
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function reviewPayslipState (vmObj) {

		vmObj.isPayslipButtonOpen = !vmObj.isPayslipButtonOpen;

		/*
		 * Force the generation of payslips the first time, regardless of PayslipState
		 * See ticket: https://www.notion.so/paycircle/Payslips-Load-payslips-on-demand-in-the-current-period-425be8e3fbf241ff97c57edfd7a02825?p=693539d49a0840d0bb4d8341882d1e5e
		**/
		if (!vmObj.hasGeneratedPayslips) {

			createPayslips(vmObj);

			return;
		}

		/**
		 * We only need to kick off the generation of payslips if they're unsubmitted.
		 * All other states will simply need to review the state and poll if necessary
		**/
		switch (vmObj.payPeriod.PayslipState) {

			case SUBMISSION_STATES.submitted: {

				// Do nothing
				break;
			}

			case SUBMISSION_STATES.unsubmitted: {

				createPayslips(vmObj);
				break;
			}

			default: {

				checkPayslipStatus(vmObj);
			}
		}
	}

	function runPayrollCallback (payPeriodObj) {

		payrollData.getPayPeriodSpecific(payPeriodObj.PayPeriodID).then(updatedPayPeriodObj => {

			$scope.vm.payPeriod = updatedPayPeriodObj;

			switch (updatedPayPeriodObj.PayrollState) {

				// Payroll still running > Poll
				case SUBMISSION_STATES.requesting:
				case SUBMISSION_STATES.submitting:
					pollPayrollState($scope.vm, refreshPayPeriod);
					break;

				// Load next pay period (now 'current')
				case SUBMISSION_STATES.submitted:
					refreshPayPeriod($scope.vm);
					break;

				default:
					setPageState('ready');
			}
		})
		.catch(onError);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleShowPayrollSuccess (vmObj) {

		// Animate in
		if (vmObj.payrollSuccessState === ANIMATION_STATES.hidden) {
			vmObj.payrollSuccessState = ANIMATION_STATES.animateIn;

			$timeout(function () {
				vmObj.payrollSuccessState = ANIMATION_STATES.visible;
			}, 500);
		}

		// Animate out
		else {
			vmObj.payrollSuccessState = ANIMATION_STATES.animateOut;

			$timeout(function () {
				vmObj.payrollSuccessState = ANIMATION_STATES.hidden;
			}, 500);
		}
	}

	function updateWorkflow (vmObj) {

		setPageState('loading');

		messageData.getWorkflowTemplates(AGENCY_PROFILE_ID).then((workflowTemplatesArr) => {

			vmObj.workflowTemplate = workflowService.decorateWorkflowTemplate(workflowTemplatesArr[0]);

			setPageState('ready');
		})
		.catch(onError);
	}

	function openPostJournalForm (vmObj) {

		reportData.getActiveJournalPost(AGENCY_PROFILE_ID, vmObj.payPeriod.PayPeriodID, config.guidEmpty).then((postObj) => {

			if (vmObj.accountingIntegrationConnection.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.xero) {
				openPostToXeroForm(postObj);
			} else {
				openPostToFinancialsForm(postObj);
			}
		})
		.catch(onError);
	}

	function openPostToXeroForm (postObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			formKey: 'post-to-xero',
			postObj
		});
	}

	function openPostToFinancialsForm (postObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			formKey: 'post-to-financials',
			postObj
		});
	}

	init();

	// Cancel any pending timeouts
	$scope.$on('$destroy', () => {
		$timeout.cancel(reportTimeout);
		$timeout.cancel(payslipTimeout);
		$timeout.cancel(wootricTimeout);
		wootricService.stopSurvey();
	});

	angular.extend($scope,  {
		COMPANY_STATES,
		ANIMATION_STATES,
		SUBMISSION_STATES,
		USER_ROLES,

		AGENCY_PROFILE_ID,
		payPeriodSubState: 0,
		submissionLogType: SUBMISSION_LOG_TYPE.payPeriod,

		createPayslips,
		fireConfetti,
		init,
		openAddPeriodNoteForm,
		openAddPeriodTaskForm,
		openBACSFileCreationForm,
		openPostJournalForm,
		openReportsExportForm,
		openRunPayrollForm,
		openUncalculatePayrollForm,
		refresh: init,
		resetPeriod,
		reviewPayslipState,
		runPayrollCallback,
		toggleShowPayrollSuccess,
		updateWorkflow
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/payslip-manager/';
	$stateProvider

	.state('payslip-manager', {
		url: '/payslip-manager/:agencyProfileId',
		templateUrl: directory + 'payslip-manager.view.html',
		data: {
			title: 'Payslip Manager'
		},
		controller: 'payslipManagerCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('payslipManagerCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'bulkService',
	'companyData',
	'config',
	'payrollData',
	'searchService',
	 function (
	 	$q,
	 	$rootScope,
 		$scope,
	 	$stateParams,
	 	bulkService,
	 	companyData,
	 	config,
		payrollData,
	 	searchService
 	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function decoratePayPeriods (payPeriodObj) {

		// Block access to pay period
		payPeriodObj.payPeriodIsDisabled = true;

		return payPeriodObj;
	}

	function getPayslipManagerFormTitle (formState) {

		switch (formState) {
			case 'bulk-import-skip':
				return 'Skip this step';
			case 'bulk-import-confirm':
				return 'Bulk import';
		}
	}

	function init () {

		setPageState('loading');

		const getDashboardDataMinimum = companyData.getDashboardDataMinimum(agencyProfileId);
		const getPayPeriodsForPayslipManager = payrollData.getPayPeriodsForPayslipManager(agencyProfileId);

		$q.all([getDashboardDataMinimum, getPayPeriodsForPayslipManager])
			.then(([dashboardDataObj, payPeriodsArr]) => {

				if (!dashboardDataObj.IsPayslipManagerSetupComplete) {
					angular.extend(dashboardDataObj, {
						UserCount: 0,
						UserCountRegistered: 0,
						UserCountUnregistered: 0
					});
				}

				$scope.vm = {
					dashboardData: dashboardDataObj,
					payPeriods: bulkService.getBulkItemsObj(payPeriodsArr.filter(decoratePayPeriods))
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}
	function openPayrollSettingsForm () {

		$rootScope.openSlideInForm({
			title: 'Manage Schedule',
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-payroll-settings'
		});
	}

	function openPayslipManagerForm (formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'payslip-manager',
			title: getPayslipManagerFormTitle(formState),
			payPeriodId: config.guidEmpty,
			formState: formState
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		searchBarOptions: searchService.payslipManager,

		init,
		openPayrollSettingsForm,
		openPayslipManagerForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/customisation/';

	$stateProvider
	.state('customisation', {
		url: '/customisation/:agencyProfileId?featureKey',
		templateUrl: directory + 'customisationView.html',
		controller: 'customisationCtrl',
		data: {
			fullPage: true,
			title: 'Customisation'
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('customisationCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'companyData',
	'customisationService',
	'settingsService',
	'INTERFACE_TYPES',
function (
	$filter,
	$q,
	$rootScope,
	$scope,
	$state,
	$stateParams,
	companyData,
	customisationService,
	settingsService,
	INTERFACE_TYPES
) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const featureKey = $stateParams.featureKey;
	let customisationObj;

	function getHrefForCompanyType (companyObj) {

		return settingsService.getNgHrefForSettingsState('customisation', companyObj);
	}

	function init () {

		$scope.pageState = 'loading';

		var getAgencyProfileCompanyDetails = companyData.getAgencyProfileCompanyDetails(agencyProfileId);
		var getCompanyCustomisationToUse = companyData.getCompanyCustomisationToUse(agencyProfileId);

		$q.all([getAgencyProfileCompanyDetails, getCompanyCustomisationToUse]).then(function (data) {

			var companyObj = data[0];
			var customisationToUseObj = data[1];

			customisationObj = $filter('customisation')(customisationToUseObj);

			$scope.company = companyObj;
			$scope.customisation = customisationObj;
			$scope.pageState = 'ready';

			$scope.openCustomisationForm(featureKey);
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	}

	function openCustomisationForm (featureKey) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCustomisation,
			closeIcon: 'right',
			customisationObj: $scope.customisation,
			hasOverlay: false,
			onFeatureSwitch: updateFeatureByFeatureKey,
			featureKey: featureKey,
			formKey: 'customisation',
			showContext: false,
			size: 'small'
		});
	}

	function refreshCustomisation (updatedCustomisationObj) {

		// Live updates
		if (updatedCustomisationObj !== null) {

			// If value set use it
			if (updatedCustomisationObj.updatedValue !== '') {

				customisationObj[updatedCustomisationObj.propertyKey][updatedCustomisationObj.subPropertyKey] = updatedCustomisationObj.updatedValue;

				$scope.customisation = customisationObj;
			}

			// Otherwise, re-fetch from server and only update unknown value
			else {
				companyData.getCompanyCustomisationToUse(agencyProfileId).then(function (latestCustomisationObj) {

					latestCustomisationObj = $filter('customisation')(latestCustomisationObj);

					customisationObj[updatedCustomisationObj.propertyKey][updatedCustomisationObj.subPropertyKey] = angular.copy(latestCustomisationObj[updatedCustomisationObj.propertyKey][updatedCustomisationObj.subPropertyKey]);

					$scope.customisation = customisationObj;
				})
				.catch(function () {

					$scope.pageState = 'error';
				});
			}
		}

		// Saved updates
		else {
			companyData.getCompanyCustomisationToUse(agencyProfileId).then(function (updatedCustomisationObj) {

				customisationObj = $filter('customisation')(updatedCustomisationObj);

				$scope.customisation = customisationObj;
			})
			.catch(function () {

				$scope.pageState = 'error';
			});
		}
	}

	function updateFeatureByFeatureKey (featureKey) {

		$scope.customisationFeature = customisationService.getCustomisationFeatureByFeatureKey(featureKey);
		$scope.featureKey = featureKey;

		// Update URL so back button stays in sync with selection
		$state.go('customisation', {agencyProfileId: agencyProfileId, featureKey: featureKey}, {notify: false});
	}

	init();

	angular.extend($scope, {
		INTERFACE_TYPES,

		agencyProfileId,

		customisationFeature: customisationService.getCustomisationFeatureByFeatureKey(featureKey),
		featureKey,
		getHrefForCompanyType,
		openCustomisationForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const pensionsDirectory = 'features/app/pensions';
	const pensionSummaryDirectory = pensionsDirectory + '/summary';
	const pensionSchemeDirectory = pensionsDirectory + '/scheme';

	$stateProvider

	.state('pensions', {
		abstract: true,
		data: {
			helpAndSupportOptions: {
				tags: ['company-pensions']
			},
			permissions: [
				'isPensionVisible'
			],
			title: 'Pensions'
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		templateUrl: pensionsDirectory + '/pensions.view.html',
		url: '/pensions/:agencyProfileId'
	})

		.state('pensions.summary', {
			controller: 'pensionsSummaryCtrl',
			templateUrl: pensionSummaryDirectory + '/pensions-summary.view.html',
			url: ''
		})

		.state('pensions.scheme', {
			abstract: true,
			controller: 'pensionsSchemeCtrl',
			templateUrl: pensionSchemeDirectory + '/pensions-scheme.view.html',
			url: '/:agencyEmployerPensionId'
		})

			.state('pensions.scheme.status', {
				controller: 'pensionsSchemeStatusCtrl',
				templateUrl: pensionSchemeDirectory + '/status/pensions-scheme-status.view.html',
				url: ''
			})

			.state('pensions.scheme.communications', {
				controller: 'pensionsSchemeCommunicationsCtrl',
				templateUrl: pensionSchemeDirectory + '/communications/pensions-scheme-communications.view.html',
				url: '/communications'
			})

			.state('pensions.scheme.history', {
				controller: 'pensionsSchemeHistoryCtrl',
				templateUrl: pensionSchemeDirectory + '/history/pensions-scheme-history.view.html',
				url: '/history'
			})

			.state('pensions.scheme.settings', {
				controller: 'pensionsSchemeSettingsCtrl',
				templateUrl: pensionSchemeDirectory + '/settings/pensions-scheme-settings.view.html',
				url: '/settings'
			})

			.state('pensions.scheme.team', {
				controller: 'pensionsSchemeTeamCtrl',
				templateUrl: pensionSchemeDirectory + '/team/pensions-scheme-team.view.html',
				url: '/team?applyfilter'
			});
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSummaryCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'pensionData',
	'pensionService',
	'wootricService',
	'PENSION_SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		pensionData,
		pensionService,
		wootricService,
		PENSION_SUBMISSION_STATES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $rootScope.currentCompany;
	let wootricTimeout;

	function init () {

		setPageState('loading');

		const getAgencyEmployerPensionSummaries = currentCompanyObj.HasPension ? pensionData.getAgencyEmployerPensionSummaries(agencyProfileId) : null;
		const getPensionProviderDetails = currentCompanyObj.HasPension ? null : pensionData.getPensionProviderDetails(agencyProfileId);

		$q.all([
			getAgencyEmployerPensionSummaries,
			getPensionProviderDetails
		])
		.then(([
			pensionSummaryObj,
			pensionProvidersArr
		]) => {

			$scope.vm = {
				pensionProviders: pensionProvidersArr ? pensionProvidersArr.filter(pensionService.filterDirectConnectionProvidersOnly) : [],
				pensionSummary: pensionSummaryObj
			};

			setPageState('ready');

			if (currentCompanyObj.HasPension && pensionSummaryObj) {
				wootricTimeout = $timeout(function () {
					wootricService.triggerSurvey();
				}, 1500);
			}
		})
		.catch(onError);
	}

	$scope.$on('$destroy', function () {
		$timeout.cancel(wootricTimeout);
		wootricService.stopSurvey();
	});

	function onAddPension () {

		currentCompanyObj.HasPension = true;

		init();
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function openCompanyPensionConnectorForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onAddPension,
			formKey: 'company-pension-connector'
		});
	}

	function openCompanyPensionStagingForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'pension-scheme-staging'
		});
	}

	function openCompanyPensionPeriodForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			agencyPayPeriodId: $scope.vm.pensionSummary.PayPeriodID,
			callback: init,
			formKey: 'pension-scheme-period'
		});
	}

	function openCompanyPensionAlignmentForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			hasPensionDateOffset: $scope.vm.pensionSummary.HasPensionDateOffset,
			isBeforePeriodDate: $scope.vm.pensionSummary.IsPensionDateOffsetBeforePeriodDate,
			pensionDateOffset: $scope.vm.pensionSummary.PensionDateOffset,
			callback: init,
			formKey: 'pension-scheme-period-alignment'
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function hasFailedPensions () {
		return $scope.vm && $scope.vm.pensionSummary && $scope.vm.pensionSummary.Pensions &&
			   $scope.vm.pensionSummary.Pensions.some(pension => pension.PensionSubmitState === PENSION_SUBMISSION_STATES.failed);
	}

	init();

	angular.extend($scope, {
		agencyProfileId,

		goToGhostPensionSettings: pensionService.goToGhostPensionSettings,
		hasFailedPensions,
		init,
		openCompanyPensionConnectorForm,
		openCompanyPensionStagingForm,
		openCompanyPensionPeriodForm,
		openCompanyPensionAlignmentForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSchemeCtrl', ['$scope', '$stateParams', 'pensionData', 'PENSION_PROVIDER_APIS', 'PENSION_STATES', 'PENSION_TYPES',
	function ($scope, $stateParams, pensionData, PENSION_PROVIDER_APIS, PENSION_STATES, PENSION_TYPES) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyEmployerPensionId = $stateParams.agencyEmployerPensionId;

	function init () {

		setPageState('loading');

		pensionData.getAgencyEmployerPensionSummary(agencyProfileId, agencyEmployerPensionId)
			.then(pensionObj => {

				$scope.pension = pensionObj;

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleModal (name) {
		$scope.modal[name] = !$scope.modal[name];
	}

	init();

	angular.extend($scope, {
		PENSION_PROVIDER_APIS,
		PENSION_STATES,
		PENSION_TYPES,

		agencyProfileId,
		agencyEmployerPensionId,
		refreshPension: init,
		toggleModal
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSchemeCommunicationsCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', 'filterService', 'growl', 'mailData', 'searchService', 'session', 'utilities', 'EMAIL_PREVIEW_TYPES', 'LOCAL_STORAGE_KEYS', 'MAIL_TYPES',
	function ($rootScope, $scope, $state, $stateParams, $timeout, filterService, growl, mailData, searchService, session, utilities, EMAIL_PREVIEW_TYPES, LOCAL_STORAGE_KEYS, MAIL_TYPES) {

	var agencyEmployerPensionId = $stateParams.agencyEmployerPensionId;
	var agencyProfileId = $stateParams.agencyProfileId;

	function hideDisclaimer () {

		// Add to storage
		utilities.addToStorage(LOCAL_STORAGE_KEYS.showPensionCommsDisclaimerBox, 'false');

		// Hide disclaimer
		$scope.options.showDisclaimer = false;
	}

	function init () {

		// Page state
		$scope.pageState = 'loading';

		mailData.getMailLogSummariesForAgency(agencyProfileId, agencyEmployerPensionId).then(function (mailLogSummariesArray) {

			// Scope
			$scope.mailLogSummaries = mailLogSummariesArray.filter(mailLogSummariesFilter);

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(onError);
	}

	function mailLogSummariesFilter (mailLogSummary) {

		mailLogSummary.hasEmailAddress = mailLogSummary.Email !== '';

		return mailLogSummary;
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openEmailAddressForm (userId) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshMailLogSummariesByUserId,
			contextType: 'user',
			formKey: 'email-address',
			userId: userId
		});
	}

	function refreshMailLogSummariesByUserId (userId) {

		var mailLogSummariesArr = $scope.mailLogSummaries;
		var mailLogSummaryObj = utilities.getArrayItemByPropertyName(mailLogSummariesArr, 'UserID', userId);

		updateMailLogSummary(mailLogSummaryObj, mailLogSummariesArr);
	}

	function sendAndPreviewMail (mailLogSummary, mailLogSummaries, mailTypeId) {

		// Loading state
		mailLogSummary.isLoadingMails = true;

		mailData.sendMailTemplateForMailTypeToUser(mailTypeId, mailLogSummary.UserID, agencyProfileId).then(function () {

			// Update team member
			updateMailLogSummary(mailLogSummary, mailLogSummaries, function (updatedMailLogSummaryObj) {

				if (updatedMailLogSummaryObj.PensionIntroduction.length > 0) {
					var mailLogKey 	= updatedMailLogSummaryObj['PensionIntroduction'][0].MailLogKey;
					var url 		= $state.href('sent-mail', {'agencyProfileId': agencyProfileId, 'maillogkey': mailLogKey});

					// Open sent mail in new window
					window.open(url, '_blank');

				} else {
					growl.error('There was a problem sending this email. Try again or get in touch');
				}
			});
		})
		.catch(function () {
			growl.error('There was a problem sending this email. Try again or get in touch');
		});
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	function toggleShowTimeline () {
		$scope.options.showTimeline = !$scope.options.showTimeline;
	}

	function updateMailLogSummary (mailLogSummary, mailLogSummaries, callback) {

		var index = mailLogSummaries.indexOf(mailLogSummary);

		// Loading state
		mailLogSummary.isLoading = true;

		// Update team member object
		mailData.getMailLogSummariesForUser(mailLogSummary.UserID, agencyProfileId).then(updatedMailLogSummaryObj => {

			// Fetch team member object
			mailLogSummaries[index] = updatedMailLogSummaryObj;

			// Callback
			if (callback !== undefined) {
				callback(updatedMailLogSummaryObj);
			}
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		EMAIL_PREVIEW_TYPES,
		MAIL_TYPES,
		agencyProfileId,
		agencyEmployerPensionId,
		filterBarOptions: filterService.pensionCommunications,
		options: {
			showTimeline: false,
			showDisclaimer: utilities.getFromStorage(LOCAL_STORAGE_KEYS.showPensionCommsDisclaimerBox) === 'false' ? false : true
		},
		searchBarOptions: searchService.pensionCommunications,

		hideDisclaimer,
		sendAndPreviewMail,
		openEmailAddressForm,
		toggleShowTimeline,
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('pensionsSchemeHistoryCtrl', ['$scope', '$stateParams', 'base', 'logService', 'searchService', function ($scope, $stateParams, base, logService, searchService) {

	var agencyEmployerPensionId = $stateParams.agencyEmployerPensionId;
	var agencyProfileId = $scope.agencyProfileId;

	function init () {

		setPageState('loading');

		base.getAgencyLogEntriesForPension(agencyProfileId, agencyEmployerPensionId).then(function (logEntriesArray) {

			if (!logEntriesArray.length) {
				setPageState('no-history');
				return;
			}

			$scope.logEntries = logService.decorateLogEntries(logEntriesArray);

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.searchBarOptions = searchService.pensionHistory;
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSchemeSettingsCtrl', [
	'$rootScope',
	'$scope',
	'pensionData',
	'pensionService',
	'DEMO_TASKS',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
	'PENSION_TYPES',
	function (
		$rootScope,
		$scope,
		pensionData,
		pensionService,
		DEMO_TASKS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES
	) {

	const agencyProfileId = $scope.agencyProfileId;
	const agencyEmployerPensionId = $scope.agencyEmployerPensionId;
	const callback = $scope.refreshPension;

	function getPensionProviderForm (pensionObj) {

		if (pensionObj.PensionProviderDetails.IsGhostPension) {
			openCompanyPensionConnectorForm(pensionObj);
		} else {
			if (pensionObj.PensionProviderDetails.PensionType === PENSION_TYPES.autoEnrolment) {
				openCompanyPensionProviderForm(pensionObj);
			} else {
				openCompanyPensionSettingsForm(pensionObj);
			}
		}
	}

	function init () {

		setPageState('loading');

		pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId).then(pensionDetailsObj => {

			$scope.pension = populateDetails(pensionDetailsObj);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openCompanyPensionAutomationForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: callback,
			formKey: 'pension-scheme-automation'
		});
	}

	function openCompanyPensionConnectorForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: callback,
			formKey: 'company-pension-connector'
		});
	}

	function openCompanyPensionGroupsForm (pensionObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: callback,
			formKey: 'pension-scheme-groups',
			title: pensionService.isNonAEPension(pensionObj.PensionProviderDetails) ? 'Contribution bands' : null
		});
	}

	function openCompanyPensionPostponementForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: callback,
			formKey: 'pension-scheme-postponement'
		});
	}

	function openCompanyPensionProviderForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: callback,
			formKey: 'pension-scheme-provider'
		});
	}

	function openCompanyPensionStagingForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: callback,
			formKey: 'pension-scheme-staging'
		});
	}

	function openCompanyPensionSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			agencyEmployerPensionId: agencyEmployerPensionId,
			callback: callback,
			formKey: 'pension-scheme-settings'
		});
	}

	function openViewPensionPolicyForm (pensionDetailsObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId: pensionDetailsObj.AgencyEmployerPensionID,
			policyId: pensionDetailsObj.PensionPolicyDetails.PolicyID,
			showPensionContext: true,
			formKey: 'view-pension-policy'
		});
	}

	function populateDetails (pensionDetailsObj) {

		// Pension provider
		pensionDetailsObj.providerDetails = {
			icon: 'settings',
			theme: 'secondary',
			title: 'Pension provider',
			detailGroups: [
				{
					editAction: () => getPensionProviderForm(pensionDetailsObj),
					id: 'pension-provider',
					details: [
						{
							type: 'image',
							value: pensionDetailsObj.PensionProviderDetails.PensionProviderImageUrl,
							imageDescription: pensionDetailsObj.PensionProviderDetails.PensionProviderName,
							fallbackIcon: 'money'
						}
					]
				}
			]
		};

		// Automation options
		pensionDetailsObj.automationDetails = {
			icon: 'submitted',
			theme: 'secondary',
			title: 'Automation options',
			detailGroups: [
				{
					editAction: openCompanyPensionAutomationForm,
					id: 'automation-options',
					details: [
						{
							label: 'Team assessment',
							type: 'switch',
							value: pensionDetailsObj.PensionAutomationDetails.AssessTeam
						},
						{
							label: 'Employee communications',
							type: 'switch',
							value: pensionDetailsObj.PensionAutomationDetails.SendCommunications
						}
					]
				}
			]
		};

		// Insert 'Connect to' detail if pension provider has an API
		if (pensionDetailsObj.PensionAutomationDetails.PensionProviderHasAPI) {
			pensionDetailsObj.automationDetails.detailGroups[0].details.splice(1, 0, {
				label: 'Connect to ' + pensionDetailsObj.PensionProviderDetails.PensionProviderName,
				type: 'switch',
				value: pensionDetailsObj.PensionAutomationDetails.ConnectToProvider
			});
		}

		var newStarterLabel = pensionDetailsObj.PensionPostponementDetails.NewStarterPostponementLength > 1 || pensionDetailsObj.PensionPostponementDetails.NewStarterPostponementLength === 0 ? 'periods' : 'period';
		var eligibleWorkerLabel = pensionDetailsObj.PensionPostponementDetails.EligibleWorkerPostponementLength > 1 || pensionDetailsObj.PensionPostponementDetails.EligibleWorkerPostponementLength === 0 ? 'periods' : 'period';

		// Staging and re-enrolment
		pensionDetailsObj.stagingDetails = {
			icon: 'calendar',
			theme: 'secondary',
			title: 'Staging and re-enrolment',
			detailGroups: [
				{
					editAction: openCompanyPensionStagingForm,
					id: 'staging-and-reenrolment',
					details: [
						{
							label: 'Staging date',
							type: 'date',
							value: pensionDetailsObj.PensionStagingDetails.StagingDateISO
						},
						{
							label: 'Staging date postponed',
							type: 'boolean',
							value: pensionDetailsObj.PensionStagingDetails.IsStagingPostponed
						},
						{
							isHidden: !pensionDetailsObj.PensionStagingDetails.IsStagingPostponed,
							label: 'Postponement date',
							type: 'date',
							value: pensionDetailsObj.PensionStagingDetails.PostponementDateISO
						},
						{
							label: 'Re-enrolment date',
							type: 'date',
							value: pensionDetailsObj.PensionStagingDetails.ReenrolmentDateISO
						},
						{
							label: 'Re-enrolment completed',
							type: 'boolean',
							value: pensionDetailsObj.PensionStagingDetails.ReenrolmentAlreadyCompleted
						},
						{
							label: 'TPR letter code',
							value: pensionDetailsObj.PensionStagingDetails.PensionLetterCode
						},
						{
							label: 'DoC submitted',
							type: 'boolean',
							value: pensionDetailsObj.PensionStagingDetails.DOCSubmitted
						}
					]
				}
			]
		};

		if (pensionDetailsObj.PensionStagingDetails.ReenrolmentAlreadyCompleted) {
			pensionDetailsObj.stagingDetails.detailGroups[0].details.splice(3, 0, {
				label: 'Re-enrolment completion date',
				type: 'date',
				value: pensionDetailsObj.PensionStagingDetails.ReenrolmentCompletionDateISO
			});
		}

		// Pension settings
		pensionDetailsObj.pensionSettingsDetails = {
			icon: 'settings',
			theme: 'secondary',
			title: 'Pension settings',
			detailGroups: [
				{
					editAction: openCompanyPensionSettingsForm,
					id: 'pension-settings',
					details: [
						{
							// Scheme reference format hidden if no scheme reference set, or for a non-AE pension (not applicable in that case)
							isHidden: !pensionDetailsObj.PensionSettingDetails.HasSchemeReference || pensionDetailsObj.PensionSettingDetails.PensionType === PENSION_TYPES.nonAutoEnrolment,
							label: 'Scheme reference format',
							value: pensionService.getSchemeReferenceFormatDescription(pensionDetailsObj)
						},
						{
							// Employer reference hidden if scheme reference display type is not employerReference
							isHidden: pensionDetailsObj.PensionSettingDetails.SchemeReferenceDisplayType !== PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference,
							label: pensionService.isAEPension(pensionDetailsObj.PensionProviderDetails) ? 'Employer pension scheme reference' : 'Reference number',
							value: pensionDetailsObj.PensionSettingDetails.EmployerReference
						},
						{
							// Local authority number hidden if scheme reference display type not educationEmployerNumber
							isHidden: pensionDetailsObj.PensionSettingDetails.SchemeReferenceDisplayType !== PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber,
							label: 'Local authority number',
							value: pensionDetailsObj.PensionSettingDetails.LocalAuthorityNumber
						},
						{
							// Establishment number hidden if scheme reference display type is not educationEmployerNumber
							isHidden: pensionDetailsObj.PensionSettingDetails.SchemeReferenceDisplayType !== PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber,
							label: 'Establishment number',
							value: pensionDetailsObj.PensionSettingDetails.EstablishmentNumber
						},
						{
							label: 'Description',
							type: pensionDetailsObj.PensionSettingDetails.PensionDescription === '' ? 'placeholder' : null,
							value: pensionDetailsObj.PensionSettingDetails.PensionDescription !== '' ? pensionDetailsObj.PensionSettingDetails.PensionDescription : 'Not entered'
						},
						{
							label: 'Tax relief type',
							value: pensionDetailsObj.PensionSettingDetails.TaxReliefTypeDisplay
						}
					]
				}
			]
		};

		// Show pension provider name in pension settings block for Non-AE Pensions
		if (pensionService.isNonAEPension(pensionDetailsObj.PensionSettingDetails)) {

			pensionDetailsObj.pensionSettingsDetails.detailGroups[0].details.unshift({
				label: 'Pension provider name',
				value: pensionDetailsObj.PensionSettingDetails.PensionProviderName
			});

			// Remove "Pension period start date" and "Pension period end date"
			pensionDetailsObj.pensionSettingsDetails.detailGroups[0].details.splice(3, 2);
		}

		// Team postponement
		pensionDetailsObj.postponementDetails = {
			icon: 'team-alt',
			theme: 'secondary',
			title: 'Team postponement',
			detailGroups: [
				{
					editAction: openCompanyPensionPostponementForm,
					id: 'team-postponement',
					demoTooltip: DEMO_TASKS.workplacePension.updateTeamPostponementSettings,
					details: [
						{
							label: 'New team member postponement',
							value: pensionDetailsObj.PensionPostponementDetails.NewStarterPostponementLength + ' ' + newStarterLabel
						},
						{
							label: 'Threshold change postponement',
							value: pensionDetailsObj.PensionPostponementDetails.EligibleWorkerPostponementLength + ' ' + eligibleWorkerLabel
						}
					]
				}
			]
		};

		// Group details (when UsePensionPolicy === false)
		if (!pensionDetailsObj.PensionPolicyDetails.UsePensionPolicy) {
			pensionDetailsObj.groupDetails = {
				icon: 'group',
				theme: 'secondary',
				title: pensionService.isAEPension(pensionDetailsObj.PensionProviderDetails) ? 'Groups' : 'Contribution bands',
				layout: 'groups',
				detailGroups: [
					{
						editAction: () => openCompanyPensionGroupsForm(pensionDetailsObj),
						id: 'groups',
						details: []
					}
				]
			};

			if (pensionDetailsObj.PensionGroupDetails.PensionGroups.length > 0) {

				// Attach pension groups
				for (let pensionGroup of pensionDetailsObj.PensionGroupDetails.PensionGroups) {

					pensionGroup.pensionType = pensionDetailsObj.PensionProviderDetails.PensionType;

					pensionDetailsObj.groupDetails.detailGroups[0].details.push({
						type: 'pension-group',
						group: pensionGroup
					});
				}

			} else {

				// Show note if there are no pension groups
				pensionDetailsObj.groupDetails.layout = null;

				pensionDetailsObj.groupDetails.detailGroups[0].details.push({
					type: 'html'
				});
			}
		}

		// Policy details (when UsePensionPolicy === true)
		if (pensionDetailsObj.PensionPolicyDetails.UsePensionPolicy) {
			pensionDetailsObj.policyDetails = {
				icon: 'document',
				theme: 'secondary',
				title: 'Policy',
				detailGroups: [
					{
						details: [
							{
								label: 'Pension policy',
								type: 'pension-policy',
								policy: {
									name: pensionDetailsObj.PensionPolicyDetails.PolicyName,
									viewAction: () => openViewPensionPolicyForm(pensionDetailsObj)
								}
							},
							{
								label: 'Bands',
								value: pensionDetailsObj.PensionPolicyDetails.PensionPolicyBandCount
							}
						]
					}
				]
			};
		}

		return pensionDetailsObj;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		openCompanyPensionGroupsForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSchemeStatusCtrl', [
	'$rootScope',
	'$scope',
	'dataTransfer',
	'payrollWorker',
	'reportData',
	'PENSION_PROVIDER_APIS',
	'PENSION_SUBMISSION_STATES',
	'SUBMISSION_STATES',
	function (
		$rootScope,
		$scope,
		dataTransfer,
		payrollWorker,
		reportData,
		PENSION_PROVIDER_APIS,
		PENSION_SUBMISSION_STATES,
		SUBMISSION_STATES
	) {

	const agencyProfleId = $scope.agencyProfileId;
	const agencyEmployerPensionid = $scope.agencyEmployerPensionId;
	const callback = $scope.refreshPension; // From parent

	function getReportsForPensionScheme (vmObj, pensionObj) {

		if (vmObj.reportDownloadState === 'loading') {
			reportData.getClassicReports(agencyProfleId, pensionObj.PreviousPayPeriod.PayPeriodID)
				.then(classicReportsArr => {
					angular.extend(vmObj, {
						reports: classicReportsArr,
						reportDownloadState: 'ready'
					});
				})
				.catch(onError);
		}
	}

	function init () {

		setPageState('ready');

		$scope.vm = {
			reportDownloadState: 'loading',
		};
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onUnauthorisedPensionAuthorise (pensionObj) {

		switch (pensionObj.PensionProviderAPI) {

			case PENSION_PROVIDER_APIS.pensionSync:
				dataTransfer.getURLRedirect(pensionObj.PensionSyncAuthUrl);
				break;

			case PENSION_PROVIDER_APIS.nest:
				openAuthoriseNestForm();
				break;

			case PENSION_PROVIDER_APIS.smart:
				openAuthoriseSmartForm();
				break;

			case PENSION_PROVIDER_APIS.peoplesPension:
				openAuthorisePeoplesPensionForm();
				break;
		}
	}

	function openAuthoriseSmartForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			callback: callback,
			formKey: 'pension-scheme-authorise-smart'
		});
	}

	function openAuthoriseNestForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			callback: callback,
			formKey: 'pension-scheme-authorise-nest'
		});
	}

	function openAuthorisePeoplesPensionForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			callback: callback,
			formKey: 'pension-scheme-authorise-peoples-pension'
		});
	}

	function openContributionsSinceDateModal () {

		$rootScope.openModalDialog({
			modalKey: 'pension-scheme-contributions-since-date'
		});
	}

	function openFailedPensionManuallySubmitWarningForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			callback: callback,
			formKey: 'pension-scheme-failed-pension-manually-submit-warning'
		});
	}

	function openQueuedPensionCancelWarningForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			callback: callback,
			formKey: 'pension-scheme-queued-pension-cancel-warning'
		});
	}

	function openPensionTeamForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfleId,
			agencyEmployerPensionId: agencyEmployerPensionid,
			showPensionContext: true,
			callback: callback,
			formKey: 'pension-scheme-team'
		});
	}

	function resubmitPension () {

		setPensionResubmittingState('loading');

		payrollWorker.payrollResubmitAE(agencyProfleId, agencyEmployerPensionid)
			.then(callback)
			.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setPensionResubmittingState (pensionResubmittingState) {
		$scope.pensionResubmittingState = pensionResubmittingState;
	}

	init();

	angular.extend($scope, {
		PENSION_SUBMISSION_STATES,
		SUBMISSION_STATES,

		getURLRedirect: dataTransfer.getURLRedirect,
		getReportsForPensionScheme,
		onUnauthorisedPensionAuthorise,
		openAuthoriseNestForm,
		openAuthorisePeoplesPensionForm,
		openAuthoriseSmartForm,
		openContributionsSinceDateModal,
		openFailedPensionManuallySubmitWarningForm,
		openQueuedPensionCancelWarningForm,
		openPensionTeamForm,
		resubmitPension,
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('pensionsSchemeTeamCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'bulkService', 'filterService', 'pensionData', 'searchService',
	function ($q, $rootScope, $scope, $stateParams, bulkService, filterService, pensionData, searchService) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyEmployerPensionId = $stateParams.agencyEmployerPensionId;
	const applyfilter = $stateParams.applyfilter;
	const pensionObj = $scope.pension; // From parent

	function decorateTeam (teamMembersArr) {

		// Kick off demo tooltip for first team member
		if (teamMembersArr.length > 0) {
			teamMembersArr[0].showDemo = true;
		}
	}

	function init () {

		setPageState('loading');

		let userId; // Undefined

		const getUserAgencyProfilesForWorkplacePension = pensionData.getUserAgencyProfilesForWorkplacePension(agencyProfileId, agencyEmployerPensionId);
		const getPensionGroupsForAgency = pensionData.getPensionGroupsForAgency(agencyProfileId, agencyEmployerPensionId, userId);

		$q.all([getUserAgencyProfilesForWorkplacePension, getPensionGroupsForAgency]).then(([teamMembersArr, companyPensionGroupsArr]) => {

			decorateTeam(teamMembersArr);

			angular.extend($scope, {
				filterBarOptions: filterService.getFilterBarOptionsPensionTeam(companyPensionGroupsArr, pensionObj),
				teamMembers: bulkService.getBulkItemsObj(teamMembersArr)
			});

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function openPensionTeamForm () {

		$rootScope.openSlideInForm({
			agencyEmployerPensionId: agencyEmployerPensionId,
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'pension-scheme-team'
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		init,
		openPensionTeamForm,

		agencyEmployerPensionId: agencyEmployerPensionId,
		agencyProfileId: agencyProfileId,
		applyfilter,
		modal: {},
		searchBarOptions: searchService.pensionTeam,
	});

	$rootScope.$on('update-pension-team', init);
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const directory = 'features/app/team/';
	const profileDirectory = directory + 'profile/';
	const profileTabsDirectory = profileDirectory + 'tabs/';

	$stateProvider

	.state('team', {
		abstract: true,
		url: '/team/:agencyProfileId?applyfilter&presetfilterkey',
		templateUrl: directory + 'teamView.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			permissions: [
				'isTeamVisible'
			],
			title: 'Team'
		},
	})
		.state('team.members', {
			url: '',
			templateUrl: directory + 'members/teamView.html',
			controller: 'teamCtrl',
			data: {
				companyFlagRedirect: {
					IsPayslipManagerActive: 'team.manager'
				},
				helpAndSupportOptions: {
					tags: ['company-team-members']
				}
			}
		})

		.state('team.leavers', {
			url: '/leavers',
			templateUrl: directory + 'leavers/teamLeaversView.html',
			controller: 'teamLeaversCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-leavers']
				}
			}
		})

		.state('team.manager', {
			url: '/manager',
			templateUrl: directory + 'manager/teamManagerView.html',
			reloadOnSearch: false,
			controller: 'teamManagerCtrl'
		})

		.state('team.moved-payrolls', {
			url: '/moved-payrolls',
			templateUrl: directory + 'moved-payrolls/teamMovedPayrollsView.html',
			controller: 'teamMovedPayrollsCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-moved-payrolls']
				}
			}
		})

		.state('team.imports', {
			url: '/imports',
			templateUrl: directory + 'imports/teamImportsView.html',
			controller: 'teamImportsCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-team-imports']
				}
			}
		})

		.state('team.people-hr-updates', {
			url: '/people-hr-updates',
			templateUrl: directory + 'people-hr-updates/team-people-hr-updates.view.html',
			controller: 'teamPeopleHrUpdatesCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-team-people-hr-updates']
				}
			}
		})

		.state('team.rotaready-updates', {
			url: '/rotaready-updates',
			templateUrl: directory + 'rotaready-updates/team-rotaready-updates.view.html',
			controller: 'teamRotareadyUpdatesCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-team-rotaready-updates']
				}
			}
		})

		.state('team.profile', {
			abstract: true,
			url: '/profile/:userId?archivedEmploymentId&from',
			templateUrl: profileDirectory + 'profileView.html',
			controller: 'profileCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-team-members']
				}
			}
		})
			.state('team.profile.overview', {
				url: '',
				templateUrl: profileTabsDirectory + 'profileOverviewView.html'
			})

			.state('team.profile.information', {
				url: '/information',
				templateUrl: profileTabsDirectory + 'profileInformationView.html',
				controller: 'profileInformationCtrl'
			})

			.state('team.profile.pension', {
				url: '/pension',
				templateUrl: profileTabsDirectory + 'profilePensionView.html',
				controller: 'profilePensionCtrl'
			})

			.state('team.profile.payments', {
				url: '/payments',
				templateUrl: profileTabsDirectory + 'profilePaymentsView.html',
				controller: 'profilePaymentsCtrl'
			})

			.state('team.profile.documents', {
				url: '/documents',
				templateUrl: profileTabsDirectory + 'profileDocumentsView.html',
				controller: 'profileDocumentsCtrl'
			})

			.state('team.profile.holiday', {
				url: '/holiday',
				templateUrl: profileTabsDirectory + 'profileHolidayView.html',
				controller: 'profileHolidayCtrl'
			})

			.state('team.profile.sickness', {
				url: '/sickness',
				templateUrl: profileTabsDirectory + 'profileSicknessView.html',
				controller: 'profileSicknessCtrl'
			})

			.state('team.profile.history', {
				url: '/history',
				templateUrl: profileTabsDirectory + 'profileHistoryView.html',
				controller: 'profileHistoryCtrl'
			})

			.state('team.profile.account', {
				url: '/account',
				templateUrl: profileTabsDirectory + 'profile-account.view.html',
				controller: 'profileAccountCtrl'
			})

			.state('team.profile.schedules', {
				url: '/schedules',
				templateUrl: profileTabsDirectory + 'profileSchedulesView.html',
				controller: 'profileSchedulesCtrl'
			})

			.state('team.profile.link-rates', {
				url: '/link-rates',
				templateUrl: profileTabsDirectory + 'link-rates/profile-link-rates.view.html',
				controller: 'profileLinkRatesCtrl'
			})

			.state('team.profile.tax-status', {
				url: '/tax-status',
				templateUrl: profileTabsDirectory + 'profile-tax-status.view.html',
				controller: 'profileTaxStatusCtrl'
			});
}]);

'use strict';

angular.module('paycircleApp')

.controller('teamMovedPayrollsCtrl', ['$scope', '$stateParams', 'bulkService', 'filterService', 'searchService', 'userData',
	function ($scope, $stateParams, bulkService, filterService, searchService, userData) {

	var agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		userData.getTeamMembersForMovedPayrolls(agencyProfileId).then(function (teamMembersArr) {

			$scope.vm = {
				agencyProfileId: agencyProfileId,
				filterBarOptions: filterService.archivedTeamMembers,
				searchBarOptions: searchService.archivedTeamMembers,
				teamMembers: bulkService.getBulkItemsObj(teamMembersArr)
			};

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.init = function () {

		init();
	};

}]);

'use strict';

angular.module('paycircleApp')

.controller('teamImportsCtrl', [
	'$scope',
	'$stateParams',
	'dataImport',
	'filterService',
	'importService',
	'payrollData',
	'searchService',
	'IMPORT_MAPPING_TYPES',
	function (
		$scope,
		$stateParams,
		dataImport,
		filterService,
		importService,
		payrollData,
		searchService,
		IMPORT_MAPPING_TYPES
	) {

	const INCLUDE_DELETED = true;
	const INCLUDE_TEAM_IMPORTS = true;
	const INCLUDE_PERIOD_IMPORTS = false;
	const IMPORT_TYPE = IMPORT_MAPPING_TYPES.team;

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $scope.currentCompany; // From root

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then((payPeriodObj) => {

			dataImport.getUserImportGroups(agencyProfileId, payPeriodObj.AgencyPayPeriodID, INCLUDE_DELETED, INCLUDE_TEAM_IMPORTS, INCLUDE_PERIOD_IMPORTS, IMPORT_TYPE).then((importGroupsArr) => {

				$scope.vm = {
					filterBarOptions: filterService.getFilterBarOptionsTeamImports(currentCompanyObj),
					importGroups: importGroupsArr.filter(importService.decorateImportGroup),
					importGroupsFiltered: [],
					payPeriod: payPeriodObj,
					searchBarOptions: searchService.currentPeriodImports
				};

				setPageState('ready');
			})
			.catch((error) => {
				console.error(error);
				setPageState('error');
			});
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		refreshPage: init,
		agencyProfileId
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('teamLeaversCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'bulkService',
	'config',
	'filterService',
	'payrollData',
	'searchService',
	'teamData',
	'teamService',
	function (
		$q,
		$scope,
		$stateParams,
		bulkService,
		config,
		filterService,
		payrollData,
		searchService,
		teamData,
		teamService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function decorateTeamMembers (teamMemberObj) {

		teamService.decorateTeamMember(teamMemberObj);

		// Hide actions on leaver card
		teamMemberObj.isArchivedLeaver = teamMemberObj.ArchivedEmploymentID !== config.guidEmpty;

		return teamMemberObj;
	}

	function init () {

		setPageState('loading');

		const RETURN_LEAVERS = true;

		const getTeamMembers = teamData.getTeamMembers(agencyProfileId, RETURN_LEAVERS);
		const getTeamMembersForArchivedEmployments = teamData.getTeamMembersForArchivedEmployments(agencyProfileId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);

		$q.all([getTeamMembers, getTeamMembersForArchivedEmployments, getPayPeriodMinimum])
			.then(([leaversArr, archivedEmploymentsArr, payPeriodObj]) => {

				const teamMembersArr = leaversArr.concat(archivedEmploymentsArr).filter(decorateTeamMembers);

				$scope.vm = {
					currentPayPeriod: payPeriodObj,
					leavers: bulkService.getBulkItemsObj(teamMembersArr)
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		refreshLeavers: init,

		filterBarOptions: filterService.leavers,
		searchBarOptions: searchService.leavers,
		agencyProfileId: agencyProfileId,
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('teamManagerCtrl', [
	'$scope',
	'$stateParams',
	'bulkService',
	'searchService',
	'teamData',

	function (
		$scope,
		$stateParams,
		bulkService,
		searchService,
		teamData
	) {

	const LEAVERS = false;

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		teamData.getTeamMembers(agencyProfileId, LEAVERS)
			.then(teamMembersArr => {

				$scope.vm = {
					teamMembers: bulkService.getBulkItemsObj(teamMembersArr),
					searchBarOptions: searchService.teamManager,
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		init,

		agencyProfileId
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('teamCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'agency',
	'bulkService',
	'companyData',
	'filterService',
	'payrollData',
	'reportData',
	'searchService',
	'teamData',
	'utilities',
	'wootricService',
	'COMPANY_HOLIDAY_POLICY_TYPES',
	'CORRECTIONAL_SUBMISSION_TYPES',
	'DOCUMENT_TYPES',
	'FORM_WIZARD_KEYS',
	'INTERFACE_TYPES',
	'PAYROLL_MOVE_STATUSES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		agency,
		bulkService,
		companyData,
		filterService,
		payrollData,
		reportData,
		searchService,
		teamData,
		utilities,
		wootricService,
		COMPANY_HOLIDAY_POLICY_TYPES,
		CORRECTIONAL_SUBMISSION_TYPES,
		DOCUMENT_TYPES,
		FORM_WIZARD_KEYS,
		INTERFACE_TYPES,
		PAYROLL_MOVE_STATUSES
	) {

	const LEAVERS = false;

	const agencyProfileId = $stateParams.agencyProfileId;
	const applyfilter = $stateParams.applyfilter;
	const currentCompanyObj = $rootScope.currentCompany;
	const presetFilterKey = $stateParams.presetfilterkey;
	let wootricTimeout;

	function getApplicableTeamMembers (teamMemberObj) {
		// Remove excluded team members that are in the process of moving payrolls, otherwise they'll appear in two places
		return !(teamMemberObj.ExcludeFromPayroll && teamMemberObj.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.Outward);
	}

	function getHasSetupBusinessCategories (businessCategoriesArr) {
		return businessCategoriesArr.some(businessCategoryObj => businessCategoryObj.BusinessCodes.length > 0);
	}

	function init () {

		setPageState('loading');

		const getTeamMembers = teamData.getTeamMembers(agencyProfileId, LEAVERS);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);
		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
		const getAgencyDepartments = agency.getAgencyDepartments(agencyProfileId);
		const getPayeDetails = companyData.getPAYEDetails(agencyProfileId);

		$q.all([getTeamMembers, getPayPeriodMinimum, getBusinessCategoriesList, getAgencyDepartments, getPayeDetails])
			.then(([teamMembersArr, payPeriodObj, businessCategoriesArr, departmentsArr, payeDetails]) => {

				angular.extend($scope, {
					company: currentCompanyObj,
					currentPayPeriod: payPeriodObj,
					filterBarOptions: filterService.getFilterBarOptionsTeam(currentCompanyObj, departmentsArr),
					hasSetupBusinessCategories: getHasSetupBusinessCategories(businessCategoriesArr),
					payeDetails: payeDetails,
					searchBarOptions: searchService.team,
					teamMembers: bulkService.getBulkItemsObj(teamMembersArr.filter(getApplicableTeamMembers))
				});

				setPageState('ready');

				if (teamMembersArr.length >= 5) {
					wootricTimeout = $timeout(function () {
						wootricService.triggerSurvey();
					}, 1500);
				}
			})
		.catch(onError);
	}

	$scope.$on('$destroy', function () {
		$timeout.cancel(wootricTimeout);
		wootricService.stopSurvey();
	});

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	$scope.$on('refresh-team-view', function() {
		init();
	});

	function openAddLinkRateForm (filteredTeamMembers) {

		const selectedTeamMemberIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		if (!selectedTeamMemberIdsArr.length) {
			console.warn('Team members need to be selected to add link rates.');
			return;
		}

		if (selectedTeamMemberIdsArr.length > 1) {
			$rootScope.openSlideInForm({
				agencyProfileId: agencyProfileId,
				formKey: 'link-rate',
				userId: selectedTeamMemberIdsArr[0],
				userIds: selectedTeamMemberIdsArr
			});
		}
		else {
			$rootScope.openSlideInForm({
				agencyProfileId: agencyProfileId,
				contextType: 'user',
				formKey: 'link-rate',
				userId: selectedTeamMemberIdsArr[0]
			});
		}
	}

	function openAddTeamMemberWizard () {

		$rootScope.$broadcast('open-form-wizard', {
			agencyProfileId: agencyProfileId,
			callback: init,
			isPayPeriodCurrentRequired: true,
			wizardKey: FORM_WIZARD_KEYS.teamMemberAdd
		});
	}

	function openAddToBusinessCategoryForm (filteredTeamMembers) {

		const selectedTeamMemberIDs = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'add-to-business-category',
			userIds: selectedTeamMemberIDs
		});
	}

	function openAdvanceFuturePeriodsForm (filteredTeamMembers, currentPayPeriodObj) {

		const selectedTeamMemberIDs = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			// Context is 'user' when a single team member has been selected, 'company' for bulk operations
			contextType: selectedTeamMemberIDs.length === 1 ? 'user' : 'company',
			formKey: 'advance-future-periods',
			// UserID used for context type 'user', otherwise not applicable
			userId: selectedTeamMemberIDs.length === 1 ? selectedTeamMemberIDs[0] : undefined,
			userIds: selectedTeamMemberIDs,
			currentPayPeriod: currentPayPeriodObj
		});
	}

	function getTeamMemberCounts (teamMembersArr) {

		let teamMemberCounts = {
			canBeDeleted: [],
			cannotBeDeleted: [],
			total: teamMembersArr.length
		};

		teamMembersArr.forEach(teamMemberObj => {

			// Only applicable to team members in setup mode who aren't restarters
			if (teamMemberObj.IsInSetupMode && !teamMemberObj.IsRestarter) {
				teamMemberCounts.canBeDeleted.push(teamMemberObj);
			}
			else {
				teamMemberCounts.cannotBeDeleted.push(teamMemberObj);
			}
		});

		return teamMemberCounts;
	}

	function openDeleteTeamMembersForm (teamMembersArr) {

		const selectedTeamMemberIdsArr = bulkService.getValuesFromSelectedItems(teamMembersArr, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'delete-team-member',
			userIds: selectedTeamMemberIdsArr
		});
	}

	function openCorrectionalSubmissionForm (correctionalSubmissionType, filteredTeamMembers) {

		const selectedTeamMembers = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		if (!filteredTeamMembers.length) {
			console.warn(`Team members need to be selected to ${correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'submit an Earlier Year FPS' : 'run an early year update'}.`);
			return;
		}

		const eyuFormOptionsObj = {
			agencyProfileId: agencyProfileId,
			correctionalSubmissionType: correctionalSubmissionType,
			formKey: 'correctional-submission',
			title: correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'Submit Earlier Year FPS' : 'Earlier year update',
			userIds: selectedTeamMembers
		};

		if (selectedTeamMembers.length === 1) {
			angular.extend(eyuFormOptionsObj, {
				contextType: 'user',
				userId: selectedTeamMembers[0]
			});
		}

		$rootScope.openSlideInForm(eyuFormOptionsObj);
	}

	function openFurloughForm (filteredTeamMembers) {

		const selectedTeamMembersUserIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'furlough',
			userIds: selectedTeamMembersUserIdsArr
		});
	}

	function openInviteToRegisterForm (filteredTeamMembersArr) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'invite-to-register',
			userIds: bulkService.getValuesFromSelectedItems(filteredTeamMembersArr, 'UserID')
		});
	}

	function openFurloughModal () {

		$rootScope.openModalDialog({
			callback: openFurloughForm.bind(undefined, $scope.teamMembers.filtered),
			modalKey: 'team-furlough',
		});
	}

	function openOnHoldForm (filteredTeamMembers, markAsOnHold) {

		const selectedTeamMembersUserIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		let formOptions = {
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'on-hold',
			isOnHold: markAsOnHold ? false : true,
			title: markAsOnHold ? 'Mark as ‘On hold’' : 'Mark as ‘Active on payroll’'
		};

		if (selectedTeamMembersUserIdsArr.length === 1) {
			formOptions.userId = selectedTeamMembersUserIdsArr[0];
			formOptions.contextType =  'user';
		}
		else {
			formOptions.userIds = selectedTeamMembersUserIdsArr;
		}

		$rootScope.openSlideInForm(formOptions);
	}

	function openSupplementaryPayRunForm (filteredTeamMembers) {

		const selectedTeamMembersUserIdsArr = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		// Pass in team member if just a single one has been selected
		let teamMember;
		if (filteredTeamMembers.length === 1) {
			teamMember = filteredTeamMembers[0];
		}

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			availableWhenTeamMemberIsAdvancingOrAdvanced: filteredTeamMembers.length > 1 ? true : false,
			callback: init,
			contextType: 'company',
			formKey: 'supplementary-pay-run',
			teamMember,
			userId: teamMember ? teamMember.UserID : null,
			userIds: selectedTeamMembersUserIdsArr
		});
	}

	function openManageHolidayPayForm (selectedTeamMemberIDs) {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'manage-rolled-up-holiday',
			payeDetails: $scope.payeDetails,
			userIds: selectedTeamMemberIDs
		});
	}

	function openUnmarkAsAdvancingForm (filteredTeamMembers) {

		const selectedTeamMemberIDs = bulkService.getValuesFromSelectedItems(filteredTeamMembers, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			// Context is 'user' when a single team member has been selected, 'company' for bulk operations
			contextType: selectedTeamMemberIDs.length === 1 ? 'user' : 'company',
			formKey: 'unmark-as-advancing',
			// UserID used for context type 'user', otherwise not applicable
			userId: selectedTeamMemberIDs.length === 1 ? selectedTeamMemberIDs[0] : undefined,
			userIds: selectedTeamMemberIDs
		});
	}

	function refreshTeamMemberFromObject (callbackObj) {

		const index = utilities.getArrayItemIndexByPropertyName($scope.teamMembers.all, null, callbackObj.userId, 'UserID');



		if (index !== null) {

			// Set original PayrollIDSequence to add back to team member once updted
			// https://www.notion.so/paycircle/Team-Payroll-ID-sort-order-becomes-incorrect-when-adding-a-change-in-current-period-e413a8f6d40f424bb321cc0198116b41#b38b16d43cd0482689ccfb36cb29af15
			callbackObj.updatedTeamMemberObj.PayrollIDSequence = $scope.teamMembers.all[index].PayrollIDSequence;

			$scope.teamMembers.all[index] = callbackObj.updatedTeamMemberObj;
		}
		else {
			$rootScope.paycircleMessage('Unable to match user by user ID to refresh', 'warn');
		}
	}

	function reviewAdvanceFuturePeriodTeamMembers (filteredTeamMembers, currentPayPeriod) {

		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		const advanceFuturePeriods = {
			teamMembers: [],
			counts: {
				advancingOrAdvanced: 0,
				onHold: 0,
				incomplete: 0,
				leaverOrLeaving: 0,
				other: 0,
				total: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		// Count up team members based on validity or invalidity w.r.t. advance future periods operation
		selectedTeamMembersArr.forEach(teamMemberObj => {

			if (teamMemberObj.IsAdvancingFuturePeriods || teamMemberObj.HasAdvancedFuturePeriods) {
				advanceFuturePeriods.counts.advancingOrAdvanced++;
			}
			else if (teamMemberObj.IsOnHold) {
				advanceFuturePeriods.counts.onHold++;
			}
			else if (!teamMemberObj.IsComplete) {
				advanceFuturePeriods.counts.incomplete++;
			}
			else if (teamMemberObj.IsLeaver || teamMemberObj.IsLeaving) {
				advanceFuturePeriods.counts.leaverOrLeaving++;
			}
			else if (!teamMemberObj.CanAdvanceFuturePeriods) {
				advanceFuturePeriods.counts.other++;
			}
			else {
				// This one's OK ....
				advanceFuturePeriods.teamMembers.push(teamMemberObj);
				advanceFuturePeriods.counts.totalAllowed++;
			}
		});

		// Calc total invalid
		advanceFuturePeriods.counts.totalNotAllowed = advanceFuturePeriods.counts.total - advanceFuturePeriods.counts.totalAllowed;

		// If any aren't allowed, show the summary, otherwise proceed with the operation
		if (advanceFuturePeriods.counts.totalNotAllowed !== 0) {
			$rootScope.openModalDialog({
				modalData: advanceFuturePeriods,
				modalKey: 'team-advance-pay-periods',
				callback: () => {
					openAdvanceFuturePeriodsForm(advanceFuturePeriods.teamMembers, currentPayPeriod);
				}
			});
		}
		else {
			openAdvanceFuturePeriodsForm(advanceFuturePeriods.teamMembers, currentPayPeriod);
		}
	}

	function reviewDeleteTeamMembers (filteredTeamMembers) {

		const teamMemberCounts = getTeamMemberCounts(filteredTeamMembers);

		// Noone selected can be deleted
		if (teamMemberCounts.cannotBeDeleted.length > 0) {

			$rootScope.openModalDialog({
				modalKey: 'team-bulk-delete-summary',
				modalData: {
					agencyProfileId,
					callback: init,
					teamMemberCounts
				}
			});

			return;
		}

		openDeleteTeamMembersForm(teamMemberCounts.canBeDeleted);
	}

	function reviewCorrectionalSubmissionTeamMembers (correctionalSubmissionType, filteredTeamMembers) {
		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		let correctionalSubmissionDto = {
			correctionalSubmissionType,
			teamMembers: [],
			counts: {
				advancedOrAdvancing: 0,
				total: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		correctionalSubmissionDto.teamMembers = selectedTeamMembersArr.filter(teamMemberObj => {

			if (teamMemberObj.IsAdvancingFuturePeriods || teamMemberObj.HasAdvancedFuturePeriods) {
				correctionalSubmissionDto.counts.advancedOrAdvancing++;
				return;
			}

			correctionalSubmissionDto.counts.totalAllowed++;

			return teamMemberObj;
		});

		correctionalSubmissionDto.counts.totalNotAllowed = correctionalSubmissionDto.counts.total - correctionalSubmissionDto.counts.totalAllowed;

		if (correctionalSubmissionDto.counts.totalNotAllowed > 0) {
			$rootScope.openModalDialog({
				modalData: correctionalSubmissionDto,
				modalKey: 'team-correctional-submission',
				title: correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'Submit Earlier Year FPS' : 'Earlier year update',
				callback: () => {
					openCorrectionalSubmissionForm(correctionalSubmissionType, correctionalSubmissionDto.teamMembers);
				}
			});
		}
		else {
			openCorrectionalSubmissionForm(correctionalSubmissionType, correctionalSubmissionDto.teamMembers);
		}
	}

	function reviewManageRolledUpHoliday(filteredTeamMembers) {

		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		let data = {
			teamMembersIds: [],
			counts: {
				cis: 0,
				offPayroll: 0,
				total: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		for (const teamMemberObj of selectedTeamMembersArr) {
			if (teamMemberObj.IsCISSubcontractor) {
				data.counts.cis++;
				continue;
			}

			if (teamMemberObj.IsOffPayrollWorker) {
				data.counts.offPayroll++;
				continue;
			}

			data.teamMembersIds.push(teamMemberObj.UserID);
		  }

		// Calculate totals
		data.counts.totalAllowed = data.teamMembersIds.length;
		data.counts.totalNotAllowed = data.counts.total - data.counts.totalAllowed;

		if (data.counts.totalNotAllowed > 0) {
			$rootScope.openModalDialog({
				callback: openManageHolidayPayForm.bind(undefined, data.teamMembersIds),
				modalData: {
					data
				},
				modalKey: 'team-manage-rolled-up-holiday'
			});
		}
		else {
			openManageHolidayPayForm(data.teamMembersIds);
		}
	}

	function reviewOnHoldTeamMembers (filteredTeamMembers, markAsOnHold) {

		// Get selected team members
		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		let markAsOnHoldOrActive = {
			teamMembers: [],
			counts: {
				advancedOrAdvancing: 0,
				// Applicable when marking as 'on hold'
				alreadyOnHold: 0,
				// Applicable only when marking as 'active' (effectively unmarking as 'on hold')
				alreadyActive: 0,
				total: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			},
			// Copy flag to indicate operation - mark as 'on hold' (true) or mark as 'active' (false)
			markAsOnHold
		};

		// Derive counts based on validity of operation
		selectedTeamMembersArr.forEach(teamMemberObj => {
			if (markAsOnHold && teamMemberObj.IsOnHold) {
				markAsOnHoldOrActive.counts.alreadyOnHold++;
			}
			else if (!markAsOnHold && !teamMemberObj.IsOnHold) {
				markAsOnHoldOrActive.counts.alreadyActive++;
			}
			else if (teamMemberObj.IsAdvancingFuturePeriods || teamMemberObj.HasAdvancedFuturePeriods) {
				markAsOnHoldOrActive.counts.advancedOrAdvancing++;
			}
			else {
				// OK to proceed with operation
				markAsOnHoldOrActive.teamMembers.push(teamMemberObj);
				markAsOnHoldOrActive.counts.totalAllowed++;
			}
		});

		// Calculate total invalid
		markAsOnHoldOrActive.counts.totalNotAllowed = markAsOnHoldOrActive.counts.total - markAsOnHoldOrActive.counts.totalAllowed;

		// If any aren't allowed, show the summary, otherwise proceed with the operation as normal
		if (markAsOnHoldOrActive.counts.totalNotAllowed !== 0) {
			$rootScope.openModalDialog({
				modalData: markAsOnHoldOrActive,
				modalKey: 'team-mark-as-on-hold-or-active',
				title: markAsOnHold ? 'Mark as ‘On hold’' : 'Mark as ‘Active on payroll’',
				callback: () => {
					openOnHoldForm(markAsOnHoldOrActive.teamMembers, markAsOnHold);
				}
			});
		}
		else {
			openOnHoldForm(markAsOnHoldOrActive.teamMembers, markAsOnHold);
		}
	}

	function reviewUnmarkAsAdvancingTeamMembers (filteredTeamMembers) {

		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		let unmarkAsAdvancing = {
			teamMembers: [],
			counts: {
				notAdvancing: 0,
				total: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		// Count up team members based on validity or invalidity w.r.t. advance future periods operation
		selectedTeamMembersArr.forEach(teamMemberObj => {

			if (!teamMemberObj.IsAdvancingFuturePeriods) {
				unmarkAsAdvancing.counts.notAdvancing++;
			}
			else {
				// This one's OK ....
				unmarkAsAdvancing.teamMembers.push(teamMemberObj);
				unmarkAsAdvancing.counts.totalAllowed++;
			}
		});

		// Calc total invalid
		unmarkAsAdvancing.counts.totalNotAllowed = unmarkAsAdvancing.counts.total - unmarkAsAdvancing.counts.totalAllowed;

		// If any aren't allowed, show the summary, otherwise proceed with the operation
		if (unmarkAsAdvancing.counts.totalNotAllowed !== 0) {
			$rootScope.openModalDialog({
				modalData: unmarkAsAdvancing,
				modalKey: 'team-unmark-as-advancing',
				callback: () => {
					openUnmarkAsAdvancingForm(unmarkAsAdvancing.teamMembers);
				}
			});
		}
		else {
			openUnmarkAsAdvancingForm(unmarkAsAdvancing.teamMembers);
		}
	}

	function reviewSupplementaryTeamMembers (filteredTeamMembers) {

		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembers);

		let supplementaryRun = {
			teamMembers: [],
			counts: {
				advancedOrAdvancing: 0,
				cis: 0,
				excludedFromRti: 0,
				includedInRti: 0,
				incomplete: 0,
				leavers: 0,
				offPayroll: 0,
				original: selectedTeamMembersArr.length,
				other: 0,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		supplementaryRun.teamMembers = selectedTeamMembersArr.filter(teamMemberObj => {

			if (teamMemberObj.IsExcludedFromRTI) {
				supplementaryRun.counts.excludedFromRti++;
			} else {
				supplementaryRun.counts.includedInRti++;
			}

			if (!teamMemberObj.IsComplete) {
				supplementaryRun.counts.incomplete++;
				return;
			}

			if (teamMemberObj.IsCISSubcontractor) {
				supplementaryRun.counts.cis++;
				return;
			}

			if (teamMemberObj.IsOffPayrollWorker) {
				supplementaryRun.counts.offPayroll++;
				return;
			}

			if (teamMemberObj.IsAdvancingFuturePeriods || teamMemberObj.HasAdvancedFuturePeriods) {
				supplementaryRun.counts.advancedOrAdvancing++;
				return;
			}

			if (!teamMemberObj.IsSupplementaryAvailable) {
				supplementaryRun.counts.other++;
				return;
			}

			supplementaryRun.counts.totalAllowed++;

			return teamMemberObj;
		});

		supplementaryRun.counts.totalNotAllowed = supplementaryRun.counts.original - supplementaryRun.counts.totalAllowed;

		$scope.supplementaryRun = supplementaryRun;

		// Show warning for a mix of included and ommitted from RTI team members
		if (supplementaryRun.counts.excludedFromRti > 0 && supplementaryRun.counts.includedInRti > 0) {
			$rootScope.openModalDialog({
				modalData: supplementaryRun,
				modalKey: 'team-excluded-from-rti'
			});
			return;
		}

		if (supplementaryRun.counts.totalNotAllowed > 0) {
			$rootScope.openModalDialog({
				callback: openSupplementaryPayRunForm.bind(undefined, supplementaryRun.teamMembers),
				modalData: {
					supplementaryRun
				},
				modalKey: 'team-supplementary-pay-run'
			});
		}
		else {
			openSupplementaryPayRunForm(supplementaryRun.teamMembers);
		}
	}

	function reviewTeamMembersAccountForRegistration (filteredTeamMembersArr) {

		const selectedTeamMembersArr = bulkService.getSelectedItems(filteredTeamMembersArr);

		let inviteToRegisterObj = {
			teamMembers: [],
			counts: {
				missingEmails: 0,
				alreadyRegistered: 0,
				original: selectedTeamMembersArr.length,
				totalAllowed: 0,
				totalNotAllowed: 0
			}
		};

		inviteToRegisterObj.teamMembers = selectedTeamMembersArr.filter(teamMemberObj => {

			if (teamMemberObj.IsRegistered) {
				inviteToRegisterObj.counts.alreadyRegistered++;
				return;
			}

			if (teamMemberObj.EmailAddress === '') {
				inviteToRegisterObj.counts.missingEmails++;
				return;
			}

			inviteToRegisterObj.counts.totalAllowed++;

			return teamMemberObj;
		});

		inviteToRegisterObj.counts.totalNotAllowed = inviteToRegisterObj.counts.original - inviteToRegisterObj.counts.totalAllowed;

		if (inviteToRegisterObj.counts.totalNotAllowed > 0) {

			$rootScope.openModalDialog({
				callback: openInviteToRegisterForm.bind(undefined, inviteToRegisterObj.teamMembers),
				modalKey: 'team-invite-to-register',
				modalData: {
					inviteToRegister: inviteToRegisterObj
				}
			});
		}
		else {
			openInviteToRegisterForm(inviteToRegisterObj.teamMembers);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		COMPANY_HOLIDAY_POLICY_TYPES,
		CORRECTIONAL_SUBMISSION_TYPES,
		DOCUMENT_TYPES,
		INTERFACE_TYPES,

		agencyProfileId,
		applyfilter,
		presetFilterKey,
		openAddLinkRateForm,
		openAddTeamMemberWizard,
		openAddToBusinessCategoryForm,
		openAdvanceFuturePeriodsForm,
		openDeleteTeamMembersForm,
		openFurloughForm,
		openFurloughModal,
		openInviteToRegisterForm,
		openManageHolidayPayForm,
		openOnHoldForm,
		openSupplementaryPayRunForm,
		openUnmarkAsAdvancingForm,
		refreshTeamMemberFromObject,
		refreshTeam: init,
		reviewAdvanceFuturePeriodTeamMembers,
		reviewCorrectionalSubmissionTeamMembers,
		reviewDeleteTeamMembers,
		reviewManageRolledUpHoliday,
		reviewOnHoldTeamMembers,
		reviewSupplementaryTeamMembers,
		reviewTeamMembersAccountForRegistration,
		reviewUnmarkAsAdvancingTeamMembers
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('teamPeopleHrUpdatesCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'bulkService',
	'dataTransfer',
	'filterService',
	'growl',
	'searchService',
	'teamData',
	'EDP_UPDATES_EXPORT_FILTER_MAPS',
	'PEOPLE_HR_UPDATES_EVENT_STATUS',
	'PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS',
	'PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		bulkService,
		dataTransfer,
		filterService,
		growl,
		searchService,
		teamData,
		EDP_UPDATES_EXPORT_FILTER_MAPS,
		PEOPLE_HR_UPDATES_EVENT_STATUS,
		PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS,
		PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	const currentCompany = $rootScope.currentCompany || {};
	const hasEdp = !!currentCompany.IsEdpIntegrationEnabled;
	const hasPeopleHr = !!currentCompany.IsPeopleHRIntegrationEnabled;

	// Companies can accumulate months of events, so only a recent window is fetched up front.
	const DEFAULT_DATE_RANGE_DAYS = 90;

	// Statuses and severities share one canonical contract across both sources, so their
	// export codes can be looked up from a single merged map. Types stay source-specific.
	const combinedStatusExportMap = angular.extend({}, PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS.status, EDP_UPDATES_EXPORT_FILTER_MAPS.status);
	const combinedSeverityExportMap = angular.extend({}, PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS.severity, EDP_UPDATES_EXPORT_FILTER_MAPS.severity);

	function isEdpEvent (event) {

		return !!(event && event.EdpEventID);
	}

	function getEventStatus (event) {

		return isEdpEvent(event) ? event.EdpEventStatus : event.Status;
	}

	function exportUpdates (format) {

		$scope.isExporting = true;

		const formatLabel = format === 'xlsx' ? 'Excel' : 'CSV';
		growl.success('Exporting integration events to ' + formatLabel + '...');

		const filters = getActiveFilterValues();

		const dateRange = getDateRangeFromFilterBar();
		const fromDateParam = dateRange ? dateRange.fromDateIso : null;
		const toDateParam = dateRange ? dateRange.toDateIso : null;

		const exportTasks = [];

		if (hasPeopleHr) {
			exportTasks.push(buildExportTask('peoplehr', filters, fromDateParam, toDateParam, format));
		}

		if (hasEdp) {
			exportTasks.push(buildExportTask('edp', filters, fromDateParam, toDateParam, format));
		}

		// Run sequentially so multiple file downloads do not clobber each other.
		exportTasks.reduce((chain, task) => chain.then(task), $q.resolve())
			.then(() => {
				growl.success('Export complete');
			})
			.catch((error) => {
				growl.error('Failed to export events. Please try again or contact support if the issue persists.');
				console.error('Export failed:', error);
			})
			.finally(() => {
				$scope.isExporting = false;
			});
	}

	function buildExportTask (source, filters, fromDateParam, toDateParam, format) {

		return function () {

			const isEdpSource = source === 'edp';
			const typeMap = isEdpSource ? EDP_UPDATES_EXPORT_FILTER_MAPS.type : PEOPLE_HR_UPDATES_EXPORT_FILTER_MAPS.type;

			const statusParam = mapFilterKeys(filters.statuses, combinedStatusExportMap);
			const eventTypeParam = mapFilterKeys(filters.types, typeMap);
			const severityParam = mapFilterKeys(filters.severities, combinedSeverityExportMap);

			const exportPromise = isEdpSource ?
				teamData.exportEdpEvents(agencyProfileId, fromDateParam, toDateParam, statusParam, eventTypeParam, severityParam, format) :
				teamData.exportPeopleHrIntegrationEvents(agencyProfileId, fromDateParam, toDateParam, statusParam, eventTypeParam, severityParam, format);

			return exportPromise.then((data) => dataTransfer.downloadFileContent(data));
		};
	}

	function mapFilterKeys (keys, map) {

		return keys.map((key) => map[key]).filter(Boolean).join(',') || null;
	}

	function getActiveFilterValues () {

		const activeStatuses = [];
		const activeTypes = [];
		const activeSeverities = [];

		$scope.filterBarOptions.filterGroups.forEach((group) => {

			group.filterOptions.forEach((option) => {

				if (!option.isActive) {
					return;
				}

				if (group.name === 'Status') {
					activeStatuses.push(option.key);
				}
				else if (group.name === 'Type') {
					activeTypes.push(option.key);
				}
				else if (group.name === 'Severity') {
					activeSeverities.push(option.key);
				}
			});
		});

		return {
			statuses: activeStatuses,
			types: activeTypes,
			severities: activeSeverities
		};
	}

	function getDateRangeFilterGroup () {

		return $scope.filterBarOptions.filterGroups.find(function (group) {
			return group.filterAction === 'dateRange';
		});
	}

	function getDateRangeFromFilterBar () {

		const dateGroup = getDateRangeFilterGroup();

		const fromDateIso = dateGroup ? dateGroup.fromDateIso : '';
		const toDateIso = dateGroup ? dateGroup.toDateIso : '';

		if (fromDateIso && toDateIso) {
			return {
				fromDateIso: fromDateIso,
				toDateIso: toDateIso
			};
		}

		return null;
	}

	function getDefaultDateRange () {

		return {
			fromDateIso: moment().subtract(DEFAULT_DATE_RANGE_DAYS, 'days').format('YYYY-MM-DD'),
			toDateIso: moment().format('YYYY-MM-DD')
		};
	}

	// Opening the page always starts from the default range, and any range the user then chooses or
	// clears only lasts until they leave. The filter bar restores its own date range from
	// sessionStorage when it initialises, which happens after this controller has already fetched,
	// so the default is written there too to keep the two in step.
	function initialiseDateRange () {

		const dateRange = getDefaultDateRange();
		const dateGroup = getDateRangeFilterGroup();

		if (!dateGroup) {
			return dateRange;
		}

		dateGroup.fromDateIso = dateRange.fromDateIso;
		dateGroup.toDateIso = dateRange.toDateIso;
		dateGroup.displayText = moment(dateRange.fromDateIso).format('DD/MM/YYYY') +
			' - ' + moment(dateRange.toDateIso).format('DD/MM/YYYY');

		sessionStorage.setItem(dateGroup.storageKeyFrom, dateRange.fromDateIso);
		sessionStorage.setItem(dateGroup.storageKeyTo, dateRange.toDateIso);

		return dateRange;
	}

	// The platform parses ISO dates as yyyy-MM-ddTHH:mm:ss, so a date on its own is not accepted.
	function getIsoDateTime (dateIso) {

		return moment(dateIso).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
	}

	// A null date range fetches every event the company has received.
	function getEventsForDateRange (dateRange) {

		const fromDateTime = dateRange ? getIsoDateTime(dateRange.fromDateIso) : null;
		const toDateTime = dateRange ? getIsoDateTime(dateRange.toDateIso) : null;

		return $q.all({
			peopleHrEvents: hasPeopleHr ? teamData.getIntegrationEvents(agencyProfileId, fromDateTime, toDateTime) : $q.resolve([]),
			edpEvents: hasEdp ? teamData.getEdpEvents(agencyProfileId, null, fromDateTime, toDateTime, null) : $q.resolve([])
		}).then((results) => {
			return [].concat(results.peopleHrEvents || [], results.edpEvents || []);
		});
	}

	function setEvents (eventsArr) {

		const events = processEventDataResults(eventsArr || []);

		angular.extend($scope, {
			integrationEvents: bulkService.getBulkItemsObj(events),
			statusCounts: getMergedStatusCounts(events)
		});
	}

	function onDateRangeChange (newValues, oldValues) {

		if (newValues === oldValues) {
			return;
		}

		const dateRange = getDateRangeFromFilterBar();

		$scope.hasDateRange = Boolean(dateRange);

		// Clearing the date range is not fetched automatically, as fetching every event ever
		// received is slow for some companies. It is applied when the updates are next refreshed.
		if (!dateRange) {
			return;
		}

		refreshUpdates();
	}

	function refreshUpdates () {

		setPageState('refreshing');

		const dateRange = getDateRangeFromFilterBar();

		getEventsForDateRange(dateRange)
			.then(function (eventsArr) {

				$scope.hasDateRange = Boolean(dateRange);

				setEvents(eventsArr);

				setPageState('ready');
			})
			.catch(function (error) {
				setPageState('ready');
				onError(error);
			});
	}

	function getMergedStatusCounts (events) {

		const counts = {
			TotalCount: events.length,
			NewCount: 0,
			ProcessingCount: 0,
			CompleteCount: 0,
			FailedCount: 0,
			SkippedCount: 0
		};

		events.forEach(function (event) {

			switch (getEventStatus(event)) {
				case PEOPLE_HR_UPDATES_EVENT_STATUS.new: counts.NewCount++; break;
				case PEOPLE_HR_UPDATES_EVENT_STATUS.processing: counts.ProcessingCount++; break;
				case PEOPLE_HR_UPDATES_EVENT_STATUS.complete: counts.CompleteCount++; break;
				case PEOPLE_HR_UPDATES_EVENT_STATUS.failed: counts.FailedCount++; break;
				case PEOPLE_HR_UPDATES_EVENT_STATUS.skipped: counts.SkippedCount++; break;
			}
		});

		return counts;
	}

	function init () {

		setPageState('loading');

		const dateRange = initialiseDateRange();

		$scope.hasDateRange = Boolean(dateRange);

		// Load whichever integrations the company has enabled and merge the results into
		// one list. The screen is the PeopleHR updates screen; EDP events are added in with
		// the same presentation.
		$q.all({
			events: getEventsForDateRange(dateRange),
			peopleHrServiceStatus: hasPeopleHr ? teamData.getIntegrationServiceStatus(agencyProfileId) : $q.resolve(null)
		}).then((results) => {

			angular.extend($scope, {
				agencyProfileId,
				integrationStatusData: results.peopleHrServiceStatus,
				integrationServiceStatusText: getIntegrationServiceStatusText(results.peopleHrServiceStatus)
			});

			setEvents(results.events);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function deriveEdpEventSeverity (edpEvent) {

		if (edpEvent.EdpEventStatus === PEOPLE_HR_UPDATES_EVENT_STATUS.failed) {
			return 'Error';
		}

		if (edpEvent.EdpEventStatus === PEOPLE_HR_UPDATES_EVENT_STATUS.skipped) {
			return 'Warning';
		}

		// A Complete event's message is an informational note about the result (e.g. missing
		// relevant earnings, advance funding not set, leave beyond the statutory pay window),
		// not a problem requiring attention. Mirrors EdpEvent.DeriveSeverity in the Platform repo.
		return 'Info';
	}

	function processEventDataResults (eventData) {

		return eventData.map(function (item) {

			// Trim is here because if the names are empty then teamMemberFullName will be an empty string.
			item.teamMemberFullname = `${item.Forename || ''} ${item.Surname || ''}`.trim();

			if (isEdpEvent(item)) {

				item.receivedTimeISOUnix = moment(item.EdpEventReceivedTime).format('x');

				// Severity is computed on the EDP event model but is not guaranteed to be present
				// in the API response; derive it locally from status and error message so the
				// severity filter can still match.
				item.EdpEventSeverity = item.EdpEventSeverity || deriveEdpEventSeverity(item);

				// Only failed and skipped events can be retried
				item.cannotBeSelected = item.EdpEventStatus !== PEOPLE_HR_UPDATES_EVENT_STATUS.failed &&
					item.EdpEventStatus !== PEOPLE_HR_UPDATES_EVENT_STATUS.skipped;

				return item;
			}

			// Convert the date to unix dates for sorting
			item.receivedTimeISOUnix = moment(item.ReceivedTimeISO).format('x');

			// Can only select Failed events
			item.cannotBeSelected = item.Status !== PEOPLE_HR_UPDATES_EVENT_STATUS.failed;

			return item;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function getIntegrationServiceStatusText (integrationServiceStatus) {

		if (!integrationServiceStatus) {
			return '';
		}

		switch (integrationServiceStatus.Status) {

			case PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS.active:
				return 'active';

			case PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS.paused:
				return 'paused';

			default:
				return '';
		}
	}

	function retryUpdates () {

		const selected = $scope.integrationEvents.filtered.filter((event) => event.isSelected);

		if (!selected.length) {
			return;
		}

		const eventIds = selected.filter(isEdpEvent).map((event) => event.EdpEventID);
		const messageIds = selected.filter((event) => !isEdpEvent(event)).map((event) => event.MessageID);

		const formOptions = {
			agencyProfileId: $scope.agencyProfileId,
			formKey: 'people-hr-updates-data',
			callback: init
		};

		if (eventIds.length) {
			formOptions.eventId = eventIds;
		}

		if (messageIds.length) {
			formOptions.messageId = messageIds;
		}

		$rootScope.openSlideInForm(formOptions);
	}

	angular.extend($scope, {
		exportUpdates,
		filterBarOptions: filterService.getPeopleHrUpdatesFilterBarOptions({ hasEdp, hasPeopleHr }),
		hasEdp,
		hasPeopleHr,
		init,
		integrationEvents: bulkService.getBulkItemsObj([]),
		refreshUpdates,
		retryUpdates,
		statusCounts: {},
		PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS,
		searchBarOptions: searchService.peopleHrUpdates
	});

	$scope.$watchGroup([
		function () {
			const dateGroup = getDateRangeFilterGroup();
			return dateGroup ? dateGroup.fromDateIso : null;
		},
		function () {
			const dateGroup = getDateRangeFilterGroup();
			return dateGroup ? dateGroup.toDateIso : null;
		}
	], onDateRangeChange);

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('teamRotareadyUpdatesCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'base',
	'bulkService',
	'dataTransfer',
	'filterService',
	'growl',
	'searchService',
	'teamData',
	'ROTAREADY_UPDATES_EVENT_STATUS',
	'ROTAREADY_UPDATES_EVENT_SERVICE_STATUS',
	'ROTAREADY_UPDATES_EXPORT_FILTER_MAPS',
	'FEATURE_FLAGS',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		base,
		bulkService,
		dataTransfer,
		filterService,
		growl,
		searchService,
		teamData,
		ROTAREADY_UPDATES_EVENT_STATUS,
		ROTAREADY_UPDATES_EVENT_SERVICE_STATUS,
		ROTAREADY_UPDATES_EXPORT_FILTER_MAPS,
		FEATURE_FLAGS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	let isGroupedUpdatesEnabled = false;
	let rawIntegrationEvents = [];
	let groupedIntegrationEvents = [];

	// Companies can have tens of thousands of events, so only a recent window is fetched up front.
	const DEFAULT_DATE_RANGE_DAYS = 14;

	function getDateRangeFilterGroup () {

		return $scope.filterBarOptions.filterGroups.find(function (group) {
			return group.filterAction === 'dateRange';
		});
	}

	function getDateRangeFromFilterBar () {

		const dateGroup = getDateRangeFilterGroup();

		const fromDateIso = dateGroup ? dateGroup.fromDateIso : '';
		const toDateIso = dateGroup ? dateGroup.toDateIso : '';

		if (fromDateIso && toDateIso) {
			return {
				fromDateIso: fromDateIso,
				toDateIso: toDateIso
			};
		}

		return null;
	}

	function getDefaultDateRange () {

		return {
			fromDateIso: moment().subtract(DEFAULT_DATE_RANGE_DAYS, 'days').format('YYYY-MM-DD'),
			toDateIso: moment().format('YYYY-MM-DD')
		};
	}

	// Opening the page always starts from the default range, and any range the user then chooses or
	// clears only lasts until they leave. The filter bar restores its own date range from
	// sessionStorage when it initialises, which happens after this controller has already fetched,
	// so the default is written there too to keep the two in step.
	function initialiseDateRange () {

		const dateRange = getDefaultDateRange();
		const dateGroup = getDateRangeFilterGroup();

		if (!dateGroup) {
			return dateRange;
		}

		dateGroup.fromDateIso = dateRange.fromDateIso;
		dateGroup.toDateIso = dateRange.toDateIso;
		dateGroup.displayText = moment(dateRange.fromDateIso).format('DD/MM/YYYY') +
			' - ' + moment(dateRange.toDateIso).format('DD/MM/YYYY');

		sessionStorage.setItem(dateGroup.storageKeyFrom, dateRange.fromDateIso);
		sessionStorage.setItem(dateGroup.storageKeyTo, dateRange.toDateIso);

		return dateRange;
	}

	// The platform parses ISO dates as yyyy-MM-ddTHH:mm:ss, so a date on its own is not accepted.
	function getIsoDateTime (dateIso) {

		return moment(dateIso).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
	}

	function updateSummaryCounts () {

		const appliedFilter = $scope.filterBarOptions.appliedFilter || function () {
			return true;
		};
		const filteredRawEvents = rawIntegrationEvents.filter(appliedFilter);
		const filteredGroupedEvents = groupedIntegrationEvents.filter(appliedFilter);

		$scope.filteredEventsCount = filteredRawEvents.length;
		$scope.filteredGroupedEventsCount = filteredGroupedEvents.reduce(function (total, group) {
			return total + group.OccurrenceCount;
		}, 0);
		$scope.filteredUniqueGroupsCount = filteredGroupedEvents.length;
	}

	function getGroupedUpdates () {

		const dateRange = getDateRangeFromFilterBar();

		return teamData.getAccessRotareadyEventsGrouped(
			agencyProfileId,
			dateRange ? getIsoDateTime(dateRange.fromDateIso) : null,
			dateRange ? getIsoDateTime(dateRange.toDateIso) : null)
			.catch(function (error) {
				console.error(error);
				return null;
			});
	}

	// A null date range fetches every event the company has received.
	function getEventsForDateRange (dateRange) {

		return teamData.getAccessRotareadyEventsFiltered(
			agencyProfileId,
			dateRange ? getIsoDateTime(dateRange.fromDateIso) : null,
			dateRange ? getIsoDateTime(dateRange.toDateIso) : null);
	}

	function getUpdates (dateRange) {

		const promises = [getEventsForDateRange(dateRange)];

		if (isGroupedUpdatesEnabled) {
			promises.push(getGroupedUpdates());
		}

		return $q.all(promises);
	}

	function setEvents (integrationEventsArr) {

		const processedEvents = processEventDataResults(integrationEventsArr || []);

		$scope.criticalEventsCount = processedEvents.filter(function (event) {
			return event.criticalMessagesNotDismissedCount > 0;
		}).length;

		return processedEvents;
	}

	function setEventCollections (integrationEventsArr, groupedEventsResult) {

		rawIntegrationEvents = setEvents(integrationEventsArr);
		setGroupedEventCollection(groupedEventsResult);
	}

	function setGroupedEventCollection (groupedEventsResult) {

		groupedIntegrationEvents = processGroupedEventDataResults(groupedEventsResult ? groupedEventsResult.GroupedEvents : []);

		$scope.isGroupedUpdatesAvailable = groupedIntegrationEvents.length > 0;
		updateSummaryCounts();

		if (!$scope.isGroupedUpdatesAvailable && $scope.updatesViewMode === 'grouped') {
			$scope.updatesViewMode = 'raw';
		}

		setVisibleEvents();
	}

	function setVisibleEvents () {

		const events = $scope.updatesViewMode === 'grouped' ? groupedIntegrationEvents : rawIntegrationEvents;
		$scope.integrationEvents = bulkService.getBulkItemsObj(events);
	}

	function onDateRangeChange (newValues, oldValues) {

		if (newValues === oldValues) {
			return;
		}

		const dateRange = getDateRangeFromFilterBar();

		// Clearing the date range is not fetched automatically, as fetching every event ever
		// received is slow for some companies. It is applied when the updates are next refreshed.
		if (!dateRange) {
			return;
		}

		refreshUpdates();
	}

	function init () {

		setPageState('loading');

		const dateRange = initialiseDateRange();

		$scope.hasDateRange = Boolean(dateRange);

		$q.all([
			getEventsForDateRange(dateRange),
			teamData.getAccessRotareadyIntegrationStatus(agencyProfileId),
			base.isFeatureEnabled(agencyProfileId, FEATURE_FLAGS.ROTAREADY_GROUPED_UPDATES)
				.catch(function (error) {
					console.error(error);
					return false;
				})
		]).then(([integrationEventsArr, integrationServiceStatusObj, isEnabled]) => {

			isGroupedUpdatesEnabled = isEnabled;

			if (!isGroupedUpdatesEnabled) {
				return [integrationEventsArr, integrationServiceStatusObj, null];
			}

			return getGroupedUpdates()
				.then(function (groupedEventsResult) {
					return [integrationEventsArr, integrationServiceStatusObj, groupedEventsResult];
				});
		})
		.then(([integrationEventsArr, integrationServiceStatusObj, groupedEventsResult]) => {

			angular.extend($scope, {
				agencyProfileId,
				integrationServiceStatusText: getIntegrationStatusText(integrationServiceStatusObj),
				integrationStatusData: integrationServiceStatusObj,
				isGroupedUpdatesEnabled
			});

			setEventCollections(integrationEventsArr, groupedEventsResult);

			setPageState('ready');
		})
		.catch(onError);
	}

	function applyCriticalFilter () {

		const severityGroup = $scope.filterBarOptions.filterGroups.find(function (group) {
			return group.name === 'Severity';
		});

		if (severityGroup) {
			severityGroup.filterOptions.forEach(function (option) {
				option.isActive = option.name === 'Critical';
			});
		}
	}

	function dismissUpdates () {

		const selectedEvents = $scope.integrationEvents.filtered.filter(function (event) {
			return event.isSelected && event.CriticalMessagesCount > 0;
		});

		const eventIds = selectedEvents.map(function (event) {
			return event.RotareadyWebhookEventID;
		});

		const totalCriticalMessages = selectedEvents.reduce(function (total, event) {
			return total + event.CriticalMessagesCount;
		}, 0);

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUpdates,
			eventIds: eventIds,
			formKey: 'rotaready-updates-dismiss-all',
			title: 'Dismiss critical messages',
			totalCriticalMessages: totalCriticalMessages
		});
	}

	function hasCriticalEventsSelected () {

		return $scope.integrationEvents.filtered.some(function (event) {
			return event.isSelected && event.CriticalMessagesCount > 0;
		});
	}

	function hasOnlyCriticalEventsSelected () {

		return hasCriticalEventsSelected() && !$scope.integrationEvents.filtered.some(function (event) {
			return event.isSelected && event.CriticalMessagesCount === 0;
		});
	}

	function refreshUpdates () {

		setPageState('refreshing');

		const dateRange = getDateRangeFromFilterBar();

		getUpdates(dateRange)
			.then(function (updatesResult) {

				$scope.hasDateRange = Boolean(dateRange);

				setEventCollections(updatesResult[0], updatesResult[1]);

				setPageState('ready');
			})
			.catch(function (error) {
				setPageState('ready');
				onError(error);
			});
	}

	function onCheckboxToggle () {

		$scope.integrationEvents = bulkService.updateBulkItemTotals($scope.integrationEvents);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function processEventDataResults (eventData) {

		return eventData.map(item =>{

			item.receivedTimeISOUnix = moment(item.ReceivedTimeISO).unix();
			item.cannotBeSelected = item.Status !== ROTAREADY_UPDATES_EVENT_STATUS.failed;
			item.criticalMessagesNotDismissed = getNonDismissedCriticalMessages(item);
			item.criticalMessagesNotDismissedCount = item.criticalMessagesNotDismissed.length;

			return item;
		});
	}

	function getNonDismissedCriticalMessages (eventItem) {
		if (!eventItem.Messages) {
			return [];
		}
		return eventItem.Messages.filter(message => message.MessageLevel === 3 && (!message.DismissedAtISO || message.DismissedAtISO === ''));
	}

	function processGroupedEventDataResults (groupedEvents) {

		const rawEventsById = rawIntegrationEvents.reduce(function (eventsById, event) {
			eventsById[event.RotareadyWebhookEventID.toLowerCase()] = event;
			return eventsById;
		}, {});

		return (groupedEvents || []).map(function (item) {

			item.affectedDaysCount = Math.max(1, moment(item.LastReceivedTimeISO).startOf('day').diff(moment(item.FirstReceivedTimeISO).startOf('day'), 'days'));
			item.receivedTimeISOUnix = moment(item.LastReceivedTimeISO).unix();
			item.ReceivedTimeISO = item.LastReceivedTimeISO;
			item.cannotBeSelected = true;
			item.isGrouped = true;
			item.occurrences = (item.RotareadyWebhookEventIDs || [])
				.map(function (eventId) {
					return rawEventsById[eventId.toLowerCase()];
				})
				.filter(function (event) {
					return Boolean(event);
				});
			item.InfoMessagesCount = item.MessageLevel === 0 ? 1 : 0;
			item.WarningMessagesCount = item.MessageLevel === 1 ? 1 : 0;
			item.ErrorMessagesCount = item.MessageLevel === 2 ? 1 : 0;
			item.CriticalMessagesCount = item.MessageLevel === 3 ? 1 : 0;
			item.DismissedCriticalMessagesCount = 0;

			return item;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function getIntegrationStatusText (integrationStatus) {

		switch (integrationStatus.Status) {

			case ROTAREADY_UPDATES_EVENT_SERVICE_STATUS.active:
				return 'active';

			case ROTAREADY_UPDATES_EVENT_SERVICE_STATUS.paused:
				return 'paused';
		}
	}

	function retryUpdates () {

		const eventIds = $scope
			.integrationEvents
			.filtered
			.filter(event => event.isSelected)
			.map(event => event.RotareadyWebhookEventID);

		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			formKey: 'rotaready-updates-data',
			eventId: eventIds,
			callback: init
		});
	}


	function toggleUpdatesViewMode () {

		$scope.updatesViewMode = $scope.updatesViewMode === 'grouped' ? 'raw' : 'grouped';
		setVisibleEvents();
	}


	function getActiveFilterValues () {

		const activeStatuses = [];
		const activeTypes = [];
		const activeSeverities = [];

		$scope.filterBarOptions.filterGroups.forEach((group) => {

			group.filterOptions.forEach((option) => {

				if (!option.isActive) {
					return;
				}

				if (group.name === 'Status') {
					activeStatuses.push(option.key);
				}
				else if (group.name === 'Type') {
					activeTypes.push(option.key);
				}
				else if (group.name === 'Severity') {
					activeSeverities.push(option.key);
				}
			});
		});

		return {
			statuses: activeStatuses,
			types: activeTypes,
			severities: activeSeverities
		};
	}

	$scope.$watch(function () {
		return $scope.filterBarOptions.filterGroups.map(function (group) {
			return group.filterOptions.map(function (option) {
				return option.isActive;
			}).join(',');
		}).join('|');
	}, updateSummaryCounts);

	// Several filter options share a backend enum name (the backend cannot filter by message
	// counts or dismissed state), so the mapped names are de-duplicated.
	function getExportFilterParam (filterKeys, filterMap) {

		const backendNames = filterKeys
			.map(key => filterMap[key])
			.filter((name, index, names) => name && names.indexOf(name) === index);

		return backendNames.join(',') || null;
	}

	function exportUpdates (format) {

		$scope.isExporting = true;

		const formatLabel = format === 'xlsx' ? 'Excel' : 'CSV';
		growl.success('Exporting Rotaready events to ' + formatLabel + '...');

		// Get active filters from the page's filter-bar
		const filters = getActiveFilterValues();
		const statusParam = getExportFilterParam(filters.statuses, ROTAREADY_UPDATES_EXPORT_FILTER_MAPS.status);
		const eventTypeParam = getExportFilterParam(filters.types, ROTAREADY_UPDATES_EXPORT_FILTER_MAPS.type);
		const severityParam = getExportFilterParam(filters.severities, ROTAREADY_UPDATES_EXPORT_FILTER_MAPS.severity);

		const dateRange = getDateRangeFromFilterBar();
		const fromDateParam = dateRange ? dateRange.fromDateIso : null;
		const toDateParam = dateRange ? dateRange.toDateIso : null;

		const exportEvents = $scope.updatesViewMode === 'grouped' ?
			teamData.exportAccessRotareadyEventsGrouped : teamData.exportAccessRotareadyEvents;

		exportEvents(agencyProfileId, fromDateParam, toDateParam, statusParam, eventTypeParam, severityParam, format)
			.then((data) => dataTransfer.downloadFileContent(data))
			.then(() => {
				growl.success('Export complete');
			})
			.catch((error) => {
				growl.error('Failed to export events. Please try again or contact support if the issue persists.');
				console.error('Export failed:', error);
			})
			.finally(() => {
				$scope.isExporting = false;
			});
	}

	angular.extend($scope, {
		applyCriticalFilter,
		criticalEventsCount: 0,
		dismissUpdates,
		exportUpdates,
		filterBarOptions: filterService.rotareadyUpdates,
		hasCriticalEventsSelected,
		hasOnlyCriticalEventsSelected,
		integrationEvents: bulkService.getBulkItemsObj([]),
		isGroupedUpdatesAvailable: false,
		isGroupedUpdatesEnabled: false,
		onCheckboxToggle,
		refreshUpdates,
		retryUpdates,
		searchBarOptions: searchService.rotareadyUpdates,
		toggleUpdatesViewMode,
		filteredEventsCount: 0,
		filteredGroupedEventsCount: 0,
		filteredUniqueGroupsCount: 0,
		updatesViewMode: 'raw',

		ROTAREADY_UPDATES_EVENT_SERVICE_STATUS
	});

	$scope.$watchGroup([
		function () {
			const dateGroup = getDateRangeFilterGroup();
			return dateGroup ? dateGroup.fromDateIso : null;
		},
		function () {
			const dateGroup = getDateRangeFilterGroup();
			return dateGroup ? dateGroup.toDateIso : null;
		}
	], onDateRangeChange);

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('profileCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'config',
	'dataTransfer',
	'growl',
	'payrollData',
	'pensionService',
	'scheduleService',
	'securityData',
	'securityService',
	'session',
	'tabService',
	'teamData',
	'teamService',
	'user',
	'COMPANY_TYPES',
	'BUSINESS_TYPES',
	'CORRECTIONAL_SUBMISSION_TYPES',
	'EMPLOYMENT_TYPES',
	'EMPLOYMENT_PAYROLL_TYPES',
	'FORM_WIZARD_KEYS',
	'PAY_PERIOD_TYPES',
	'PAYMENT_TYPES',
	'PAYROLL_MOVE_STATUSES',
	'PENSION_ENROLMENT_STATES',
	'PENSION_TYPES',
	'PROGRESS_CARD_TYPES',
	'PROGRESS_GROUP_ACTION_IDS',
	'PROGRESS_GROUP_IDS',
	'TAB_KEYS',

	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		config,
		dataTransfer,
		growl,
		payrollData,
		pensionService,
		scheduleService,
		securityData,
		securityService,
		session,
		tabService,
		teamData,
		teamService,
		user,
		COMPANY_TYPES,
		BUSINESS_TYPES,
		CORRECTIONAL_SUBMISSION_TYPES,
		EMPLOYMENT_TYPES,
		EMPLOYMENT_PAYROLL_TYPES,
		FORM_WIZARD_KEYS,
		PAY_PERIOD_TYPES,
		PAYMENT_TYPES,
		PAYROLL_MOVE_STATUSES,
		PENSION_ENROLMENT_STATES,
		PENSION_TYPES,
		PROGRESS_CARD_TYPES,
		PROGRESS_GROUP_ACTION_IDS,
		PROGRESS_GROUP_IDS,
		TAB_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const archivedEmploymentId = $stateParams.archivedEmploymentId;
	const userId = $stateParams.userId;
	const currentCompanyObj = $rootScope.currentCompany;

	const canManageAccounts = securityService.canUserManageAccountsForCompanyType(COMPANY_TYPES.company, false);

	function callback () {

		init();
	}

	function changeEmployeePayrollType (employeePayrollType, title) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'user',
			employeePayrollType: employeePayrollType,
			formKey: 'change-employee-payroll-type',
			showContext: true,
			title,
			userId
		});
	}

	function checkEditTeamMemberEmploymentWizard (teamMemberObj, activeStepIndex, currentPayPeriodObj) {

		if (teamMemberObj.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending) {
			$rootScope.openSlideInForm({
				agencyProfileId,
				callback: openEditTeamMemberEmploymentWizard.bind(null, activeStepIndex, currentPayPeriodObj),
				contextType: 'user',
				fromCompanyName: teamMemberObj.Company.PayrollMoveCompanyName,
				formKey: 'moved-payrolls-warning',
				showContext: true,
				title: 'Changing Employment Information',
				userId
			});
		}
		else {
			openEditTeamMemberEmploymentWizard(activeStepIndex, currentPayPeriodObj);
		}
	}

	function decorateTeamMember (teamMemberObj) {

		function getOptionalDataBlock (teamMemberObj) {

			// Not needed if in non-setup mode
			if (!teamMemberObj.IsInSetupMode || currentCompanyObj.IsPayslipManagerActive) {
				return;
			}

			function getContinuousEmploymentGroup (teamMemberObj) {

				if (teamMemberObj.IsCISSubcontractor) {
					return;
				}

				const continuousEmploymentDataArr = [];
				const continuousEmploymentActionsArr = [];

				if (teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO) {

					continuousEmploymentDataArr.push(
						{
							label: 'Start date',
							value: $filter('dateformat')(teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO)
						}
					);

					if (teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentEmployerName) {
						continuousEmploymentDataArr.unshift(
							{
								label: 'Previous employer',
								value: teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentEmployerName
							}
						);
					}

					continuousEmploymentActionsArr.push(
						{
							copy: 'Edit',
							icon: 'icon-edit',
							onClick: openContinuousEmploymentForm
						},
						{
							copy: 'Delete',
							icon: 'icon-trash',
							onClick: () => {
								openContinuousEmploymentForm('delete-employment');
							}
						}
					);
				}
				else {

					continuousEmploymentActionsArr.push({
						copy: 'Add information',
						icon: 'icon-add',
						onClick: openContinuousEmploymentForm
					});
				}

				return {
					actions: continuousEmploymentActionsArr,
					data: continuousEmploymentDataArr,
					heading: 'Continuous employment',
					icon: 'icon-calendar',
					id: 'profile-continuous-employment',
					theme: 'is-primary',
				};
			}

			function getPassportGroup (teamMemberObj) {

				function getIsTeamMemberPassportDetailsEntered (teamMemberObj) {

					return [
						'Nationality',
						'PassportNumber',
						'UKArrivalDateISO',
						'VisaNumber'
					].some(property => teamMemberObj.Personal[property]);
				}

				const isTeamMemberPassportDetailsEntered = getIsTeamMemberPassportDetailsEntered(teamMemberObj);

				const passportVisaDataArr = [];
				const passportVisaActionsArr = [];

				if (isTeamMemberPassportDetailsEntered){
					passportVisaDataArr.push(
						{
							label: 'Passport number',
							value: `${teamMemberObj.Personal.PassportNumber}${teamMemberObj.Personal.PassportExpiryDateISO ? ` (expires ${$filter('dateformat')(teamMemberObj.Personal.PassportExpiryDateISO)})` : ''}`
						},
						{
							label: 'EU Citizen',
							value: teamMemberObj.Personal.EUCitizen ? 'Yes' : 'No'
						},
						{
							label: 'Nationality',
							value: teamMemberObj.Personal.Nationality
						},
						{
							label: 'Visa number',
							value: `${teamMemberObj.Personal.VisaNumber}${teamMemberObj.Personal.VisaExpiryDateISO ? ` (expires ${$filter('dateformat')(teamMemberObj.Personal.VisaExpiryDateISO)})` : ''}`
						},
						{
							label: 'Arrival in UK date',
							value: $filter('dateformat')(teamMemberObj.Personal.UKArrivalDateISO)
						}
					);

					passportVisaActionsArr.push(
						{
							copy: 'Edit',
							icon: 'icon-edit',
							onClick: openPassportForm
						},
						{
							copy: 'Delete',
							icon: 'icon-trash',
							onClick: () => {
								openPassportForm('delete-information');
							}
						}
					);
				}

				else {
					passportVisaActionsArr.push({
						copy: 'Add information',
						icon: 'icon-add',
						onClick: openPassportForm
					});
				}

				return {
					actions: passportVisaActionsArr,
					data: passportVisaDataArr,
					heading: 'Passport and Visa',
					icon: 'icon-passport',
					id: 'profile-passport-and-visa',
					theme: 'is-primary'
				};
			}

			function getWorkplaceInformationGroup (teamMemberObj) {

				if (teamMemberObj.IsCISSubcontractor) {
					return;
				}

				const workplaceInformationDataArr = [];
				const workplaceInformationActionsArr = [];

				if (teamMemberObj.Company.WorkplaceInformation.WorkplacePostcode) {

					workplaceInformationDataArr.push(
						{
							label: 'Workplace postcode',
							value: teamMemberObj.Company.WorkplaceInformation.WorkplacePostcode
						}
					);

					workplaceInformationActionsArr.push(
						{
							copy: 'Edit',
							icon: 'icon-edit',
							onClick: openWorkplaceInformationForm
						},
						{
							copy: 'Delete',
							icon: 'icon-trash',
							onClick: () => {
								openWorkplaceInformationForm('delete-information');
							}
						}
					);
				}
				else {

					workplaceInformationActionsArr.push({
						copy: 'Add information',
						icon: 'icon-add',
						onClick: openWorkplaceInformationForm
					});
				}

				return {
					actions: workplaceInformationActionsArr,
					data: workplaceInformationDataArr,
					heading: 'Workplace information',
					icon: 'icon-company',
					id: 'profile-workplace-information',
					theme: 'is-primary',
				};
			}

			return [
				getPassportGroup(teamMemberObj),
				getContinuousEmploymentGroup(teamMemberObj),
				getWorkplaceInformationGroup(teamMemberObj)
			];
		}

		return $q((resolve, reject) => {

			// If the team member has additional posts, get the business codes for each
			const getAdditionalPostsBusinessCodes = [];
			teamMemberObj.Posts.forEach(post => {
				// Default business codes to empty array, this will remain if no codes have been assigned
				post.businessCodes = [];
				// Get business codes API for the post
				getAdditionalPostsBusinessCodes.push(
					user.getUserAgencyProfileBusinessCodesForSalaryPolicyPost(
						userId,
						agencyProfileId,
						post.SalaryPolicyPostID
					)
				);
			});

			/* Get the business codes for additional posts. If there aren't any additional posts, this will be called with
			   an empty array, returning an empty array. No problem. */
			$q.all(getAdditionalPostsBusinessCodes).then(additionalPostsBusinessCodesArr => {

				// For each set of business codes, attach to corresponding post
				additionalPostsBusinessCodesArr.forEach(additionalPostBusinessCodesObj => {

					// There may not be any business codes for this post
					if (additionalPostBusinessCodesObj.UserAgencyProfileBusinessCodes !== 0) {
						const salaryPolicyPostId = additionalPostBusinessCodesObj.SalaryPolicyPostID;
						// Find the post and attach the business codes
						const post = teamMemberObj.Posts.find(post => post.SalaryPolicyPostID === salaryPolicyPostId);
						post.businessCodes = additionalPostBusinessCodesObj;
					}
					// - else post.businessCodes remains as an empty array
				});

				/* Set flag for payroll move status === InwardPending for convenience. This indicates that the team member
				   is in the process of moving from another payroll to this one, thereby disabling certain fields and displaying
				   a note about that */
				teamMemberObj.Company.isMovingPayrollsInwardPending = (teamMemberObj.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending);

				// Check leaver / archive status for 'back to' link on page
				let backToContext;
				if (teamMemberObj.Company.IsArchived) {
					backToContext = {
						linkText: 'moved payrolls',
						sref: 'team.moved-payrolls'
					};
				}
				else if (teamMemberObj.Company.IsLeaver) {
					backToContext = {
						linkText: 'leavers',
						sref: 'team.leavers'
					};
				}
				else {
					backToContext = {
						linkText: 'team',
						sref: 'team.members'
					};
				}

				angular.extend(teamMemberObj, {
					Pensions: decorateTeamMemberPensions(teamMemberObj),
					backToContext: backToContext,
					isArchivedEmployment: teamMemberObj.ArchivedEmploymentID !== config.guidEmpty,
					isCompany: teamMemberObj.Company.IsCISSubcontractor && (teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust),
					isTeamMemberMovingPayrollsOutward: teamMemberObj.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.Outward,
					pensionIndex: 0,
					optionalDetails: getOptionalDataBlock(teamMemberObj)
				});

				resolve(teamMemberObj);
			})
			.catch(reject);

		});
	}

	function decorateTeamMemberPensions (teamMemberObj) {

		// Reorder pensions to bring AE pension to the beginning
		pensionService.getOrderedPensionsArray(teamMemberObj.Pensions);

		// Decorate pension with class
		for (let pensionObj of teamMemberObj.Pensions) {
			pensionObj.class = pensionService.getStyleForPension(teamMemberObj, currentCompanyObj, pensionObj);
		}

		return teamMemberObj.Pensions;
	}

	function hasLinkedUserProfile () {

		if (securityService.isUserAuthorisedForIdentityAdmin()) {
			securityData.HasIdentityMigratedUserProfile(userId)
				.then(LinkedUserProfile => {
					$scope.linkedUserProfile = LinkedUserProfile;
				});
		}
	}

	function init () {

	   setPageState('loading');

		if (archivedEmploymentId) {
			initArchivedEmploymentProfile();

		} else {
			initTeamMemberProfile();
		}
	}

	function initArchivedEmploymentProfile () {

		const getTeamMemberInformationForArchivedEmployment = teamData.getTeamMemberInformationForArchivedEmployment(userId, agencyProfileId, archivedEmploymentId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([getTeamMemberInformationForArchivedEmployment, getPayPeriodCurrent]).then(
			([teamMemberObj, currentPayPeriodObj]) => {

			// Decorate
			decorateTeamMember(teamMemberObj).then(() => {

				// Scope
				angular.extend($scope, {
					currentPayPeriod:       currentPayPeriodObj,
					teamMember:             teamMemberObj,
					teamProfileTabBarDef:   tabService.getTabsForKey(TAB_KEYS.team.archivedProfile.id, { teamMember: teamMemberObj })
				});

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function initTeamMemberProfile () {

		const getTeamMemberAndAccountInformation = securityData.getTeamMemberAndAccountInformation(userId, agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([getTeamMemberAndAccountInformation, getPayPeriodCurrent]).then(
			([teamMemberObj, currentPayPeriodObj]) => {

			// Decorate
			decorateTeamMember(teamMemberObj).then(() => {

				// Set complete states
				setCompleteStates(teamMemberObj, currentPayPeriodObj);

				// Scope
				angular.extend($scope, {
					currentPayPeriod:		currentPayPeriodObj,
					teamMember:				teamMemberObj,
					percentCompleted:		teamService.getPercentComplete(teamMemberObj, currentPayPeriodObj, currentCompanyObj),
					furloughSchedule:		scheduleService.getScheduleForFurlough(teamMemberObj),
					teamProfileTabBarDef:	tabService.getTabsForKey(TAB_KEYS.team.profile.id, { teamMember: teamMemberObj })
				});

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function isSalaryChangeVisible (teamMember) {
		return ($scope.currentPayPeriod.IsPayrollLocked || teamMember.Company.IsOnHold) && teamMember.Salary.SalaryChangeEffectiveDateISO !== '';
	}

	function isWorkPatternVisible (teamMember) {
		const isAllowedEmploymentType = [EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(teamMember.Salary.EmploymentType);

		return ($scope.currentPayPeriod.IsPayrollLocked || teamMember.Company.IsOnHold) && isAllowedEmploymentType;
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onProgressGroupClick (progressGroup, groupActionId) {
		switch (groupActionId) {
			case PROGRESS_GROUP_ACTION_IDS.employment.deletePost: {
				openDeleteAdditionalPostForm(progressGroup.data.additionalPost);
				break;
			}
			case PROGRESS_GROUP_ACTION_IDS.pension.editPension: {
				openEditTeamMemberPensionWizard(progressGroup.data.pension, 0);
				break;
			}
			case PROGRESS_GROUP_ACTION_IDS.pension.deletePension: {
				openPensionTeamRemoveForm(progressGroup.data.pension);
				break;
			}
			default: {
				// This silences the jshints's whinging and moaning
				angular.noop();
			}
		}
	}

	function onProgressStepClick (progressGroup, wizardStepIndex) {
		switch (progressGroup.id) {
			case PROGRESS_GROUP_IDS.personal: {
				openEditTeamMemberPersonalWizard(wizardStepIndex);
				break;
			}
			case PROGRESS_GROUP_IDS.employment: {
				checkEditTeamMemberEmploymentWizard($scope.teamMember, wizardStepIndex, $scope.currentPayPeriod);
				break;
			}
			case PROGRESS_GROUP_IDS.additionalPost: {
				openAdditionalPostForm($scope.currentPayPeriod, progressGroup.data.additionalPost, wizardStepIndex);
				break;
			}
			case PROGRESS_GROUP_IDS.cisCompany: {
				openCISCompanyWizard(wizardStepIndex);
				break;
			}
			case PROGRESS_GROUP_IDS.cisInformationCompanyOrTrust: {
				openCISVerificationForm();
				break;
			}
			case PROGRESS_GROUP_IDS.cisInformationSoleTraderOrPartnership: {
				openCISSubcontractorWizard(wizardStepIndex);
				break;
			}
			case PROGRESS_GROUP_IDS.aePension:
			case PROGRESS_GROUP_IDS.additionalPostAEPension: {
				openEditTeamMemberPensionWizard(progressGroup.data.pension, wizardStepIndex);
				break;
			}
			default: {
				// Do nothing but placate jshint
				angular.noop();
			}
		}
	}

	function onSchedulesUpdate () {

		// Refresh schedules if on schedules page, go to schedules page otherwise
		if ($state.current.name !== 'team.profile.schedules') {
			$state.go('team.profile.schedules');
		} else {
			$state.go('team.profile.schedules', {}, {reload: 'team.profile.schedules'});
		}
	}

	function onTeamMemberDelete () {

		growl.success($scope.teamMember.Personal.Forename + ' has been deleted.');

		// Navigate to team page, or team manager page if payslip manager is active
		if (currentCompanyObj.IsPayslipManagerActive) {
			$state.go('team.manager', {agencyProfileId: agencyProfileId});
		}
		else {
			$state.go('team.members', {agencyProfileId: agencyProfileId});
		}
	}

	function openAdditionalPostForm (currentPayPeriodObj, additionalPost, stepIndex) {

		$rootScope.openSlideInForm({
			activeStep: angular.isDefined(stepIndex) ? stepIndex + 1 : 1,
			additionalPost: additionalPost,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			currentPayPeriod: currentPayPeriodObj,
			formKey: 'additional-post-form',
			showContext: true,
			title: angular.isDefined(additionalPost) ? 'Edit post' : 'Add post',
			userId: userId
		});
	}

	function openAdvanceFuturePeriodsForm (currentPayPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'advance-future-periods',
			userId,
			currentPayPeriod: currentPayPeriodObj
		});
	}

	function openApplyTaxRefundForm (teamMemberObj, currentPayPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'apply-tax-refund',
			title: teamMemberObj.Tax.HasTaxRefund ? 'Tax refund' : 'Apply tax refund',
			userId: userId,
			currentPayPeriod: currentPayPeriodObj
		});
	}

	function openAttachmentOfEarningsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'attachment-of-earnings',
			userId: userId
		});
	}

	function openCancelMovePayrollsForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'cancel-move-payrolls',
			teamMember: teamMemberObj,
			title: 'Cancel move',
			userId: userId
		});
	}

	function openCancelRejoinLeaver () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'cancel-rejoin-leaver',
			userId: userId,
		});
	}

	function openChangeAdminStateForm (isExcluding) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'change-admin-state',
			userId: userId,
			isExcluding: isExcluding
		});
	}

	function openChildcareVouchersForm (paymentScheduleGroupId) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'childcare-vouchers',
			userId: userId,
			paymentScheduleGroupId: paymentScheduleGroupId
		});
	}

	function openCISVerificationForm (isReverify) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			isReverify: isReverify,
			contextType: 'user',
			title: isReverify ? 'Re-verify' : 'Verification',
			formKey: 'cis-verification',
			userId: userId
		});
	}

	function openCompanyVehicleForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'company-vehicle',
			userId: userId
		});
	}

	function openCompanyVehicleViewForm (scheduleObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'company-vehicle-view',
			paymentScheduleGroupId: scheduleObj.PaymentScheduleGroupID,
			userId: userId
		});
	}

	function openContinuousEmploymentForm (formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'continuous-employment',
			formState: formState,
			userId: userId
		});
	}

	function onCancelLeavingAdditionalPostClick (additionalPostObj) {
		openCancelLeavingAdditionalPostForm (additionalPostObj);
	}

	function openCancelLeavingAdditionalPostForm (additionalPostObj) {

		$rootScope.openSlideInForm({
			additionalPost: additionalPostObj,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'cancel-leaving-additional-post',
			userId: userId
		});
	}

	function openDeleteAdditionalPostForm (additionalPostObj) {

		$rootScope.openSlideInForm({
			salaryPolicyPostId: additionalPostObj.SalaryPolicyPostID,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'delete-additional-post',
			userId: userId
		});
	}

	function openDeleteTeamMemberForm (forceDelete) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onTeamMemberDelete,
			contextType: 'user',
			forceDelete: forceDelete,
			formKey: 'delete-team-member',
			userId: userId,
		});
	}

	function openCorrectionalSubmissionForm (correctionalSubmissionType) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			correctionalSubmissionType: correctionalSubmissionType,
			formKey: 'correctional-submission',
			title: correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'Submit Earlier Year FPS' : 'Earlier year update',
			userId: userId,
			userIds: [userId]
		});
	}

	function openEditTeamMemberEmploymentWizard (activeStepIndex, currentPayPeriodObj) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditEmployment,
			currentPayPeriod: currentPayPeriodObj
		});
	}

	function openEditTeamMemberPensionWizard (pensionObj, activeStepIndex) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditAEPension
		});
	}

	function openEditTeamMemberPensionNonAEWizard (pensionObj, activeStepIndex) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditNonAEPension
		});
	}

	function openEditTeamMemberPersonalWizard (activeStepIndex) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditPersonal
		});
	}

	function openFurloughForm (teamMember) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'furlough',
			lastPayPeriodDateISO: teamMember.Payment.PaymentDateISO,
			userId: userId
		});
	}

	function openGenerateP45Form () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'generate-p45',
			userId: userId
		});
	}

	function openHealthcareForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'healthcare',
			userId: userId
		});
	}

	function openHealthcareViewForm (scheduleObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'healthcare-view',
			paymentScheduleGroupId: scheduleObj.PaymentScheduleGroupID,
			userId: userId
		});
	}

	function openLeaveAdditionalPostForm (additionalPostObj, teamMemberObj, currentPayPeriodObj) {

		$rootScope.openSlideInForm({
			additionalPost: additionalPostObj,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			currentPayPeriod: currentPayPeriodObj,
			formKey: 'leave-additional-post',
			teamMember: teamMemberObj,
			userId: userId
		});
	}

	function openLeaverMadeInErrorForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'leaver-made-in-error',
			userId: userId
		});
	}

	function openCISCompanyWizard (activeStepIndex) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.cisCompany
		});
	}

	function openCISSubcontractorWizard (activeStepIndex) {

		$rootScope.$broadcast('open-form-wizard', {
			contextType: 'user',
			showContext: true,
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.cisSubcontractor
		});
	}

	function openExcludeFromPayrollForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'exclude-from-payroll',
			userId: userId
		});
	}

	function openInviteToRegisterForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'invite-to-register',
			userId: userId
		});
	}


	function openMaternityPayForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'maternity-pay',
			userId: userId
		});
	}

	function openMovePayrollsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'move-payrolls-form',
			parentBureauAgencyProfileId: session.getAgencyProfileParentId(),
			title: 'Move Payrolls',
			userId: userId
		});
	}

	function openNewAdminForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'new-admin',
			userId: userId
		});
	}

	function openOnHoldForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'on-hold',
			userId: userId,
			isOnHold: teamMemberObj.Company.IsOnHold,
			title: teamMemberObj.Company.IsOnHold ? 'Mark as ‘Active on payroll’' : 'Mark as ‘On hold’'
		});
	}

	function openPassportForm (formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'passport',
			formState: formState,
			userId: userId
		});
	}

	function openPaternityPayForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'paternity-pay',
			userId: userId
		});
	}

	function openPayInformationForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'pay-information',
			userId: userId
		});
	}

	function openPaymentAfterLeavingForm (currentPayPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'add-a-change',
			includeLeavers: true,
			payPeriod: currentPayPeriodObj,
			title: 'Payment after leaving',
			userId: userId
		});
	}

	function openPayStatementForm (agencyPayPeriodId) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'pay-statement',
			userId: userId,
			formState: 'personal',
			teamMemberPayment: $scope.teamMember.Payment,
			agencyPayPeriodId: agencyPayPeriodId
		});
	}

	function openPensionTeamContributionsNonAEForm (pensionObj) {
		$rootScope.openSlideInForm({
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'pension-team-contributions-non-ae',
			pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
			userId: userId
		});
	}

	function openSalaryChangeView () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			payPeriodId: $scope.currentPayPeriod.PayPeriodID,
			hideProfileLink: true,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'salary-change',
			userId: userId
		});
	}

	function openPensionTeamRemoveForm (pensionObj) {

		$rootScope.openSlideInForm({
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'pension-team-remove',
			userId: userId
		});
	}

	function openRejoinLeaverForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'rejoin-leaver',
			userId: userId
		});
	}

	function openRemoveAdminAccessForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			formKey: 'remove-admin-access',
			userId: userId,
		});
	}

	function openRepaymentScheduleForm (repaymentSchedule) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'repayment-schedules',
			paymentScheduleGroupId: repaymentSchedule !== undefined ? repaymentSchedule.PaymentScheduleGroupID : null,
			userId: userId
		});
	}

	function openRtiSubmissionForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: () => {
				callback();
				$state.go('team.profile.overview');
			},
			contextType: 'user',
			formKey: 'rti-submission',
			isExcludedFromRti: teamMemberObj.Company.IsExcludedFromRTI,
			title: teamMemberObj.Company.IsExcludedFromRTI ? 'Include in RTI submissions' : 'Omit from RTI submissions',
			userId: userId
		});
	}

	function openSickPayForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onSchedulesUpdate,
			contextType: 'user',
			formKey: 'sick-pay',
			userId: userId
		});
	}
	function openSupplementaryPayRunForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			availableWhenTeamMemberIsAdvancingOrAdvanced: false,
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'supplementary-pay-run',
			teamMember: teamMemberObj,
			userIds: [userId]
		});
	}
	
	function openUnlinkAccessAccountForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback,
			formKey: 'unlink-access-account',
			userId: userId,
			requiredPermissions: securityService.getRequiredPermissionsForAccountManagement(COMPANY_TYPES.company, false)
		});
	}

	function openUnmarkAsAdvancingForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'unmark-as-advancing',
			userId
		});
	}

	function openUnmarkAsLeaverForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'unmark-as-leaver',
			primaryButtonText: 'Unmark',
			userId: userId
		});
	}

	function openUnregisterUserForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'unregister-user',
			userId: userId
		});
	}

	function openUpdateLeaverStatusForm (forUpdate) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'update-leaver-status',
			forUpdate: forUpdate,
			title: forUpdate ? 'Edit leaver information' : 'Mark as leaver',
			userId: userId
		});
	}

	function openViewWorkPatternForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			hideProfileLink: true,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'view-work-pattern',
			userId: userId
		});
	}

	function openWorkplaceInformationForm (formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshUser,
			contextType: 'user',
			formKey: 'workplace-information',
			formState: formState,
			userId: userId
		});
	}

	function refreshUser () {

		setPageState('loading');

		securityData.getTeamMemberAndAccountInformation(userId, agencyProfileId)
			.then(teamMemberObj => {

				// Decorate
				decorateTeamMember(teamMemberObj).then(() => {
					// Set complete states
					setCompleteStates(teamMemberObj, $scope.currentPayPeriod);

					angular.extend($scope, {
						teamMember:         teamMemberObj,
						percentCompleted:   teamService.getPercentComplete(teamMemberObj, $scope.currentPayPeriod, currentCompanyObj),
						furloughSchedule:   scheduleService.getScheduleForFurlough(teamMemberObj)
					});

					setPageState('ready');
				})
				.catch(onError);
			})
			.catch(onError);
	}

	function setCompleteStates (teamMember, currentPayPeriodObj) {

		// Personal
		updatePersonalSteps(teamMember);

		// Employment
		updateEmploymentSteps(teamMember, currentPayPeriodObj);

		// CIS
		updateCISInformationSteps(teamMember);

		// CIS (company)
		updateCISCompanySteps(teamMember);

		// Pensions
		updatePensionSteps(teamMember);

		return teamMember;
	}

	function updateCISInformationSteps (teamMember) {

		// CIS steps ...
		const cisInformationStepsGroups = [];

		// ... single group
		const cisInformationSteps = [];

		// Applicable only to CIS subcontractors
		if (teamMember.Company.IsCISSubcontractor) {
			let notice;
			let progressGroupId;
			if (!teamMember.isCompany) {
				// Sole trader or partnership
				progressGroupId = PROGRESS_GROUP_IDS.cisInformationSoleTraderOrPartnership;
				// Business setup name differs slightly depending on sole trader or partnership
				const name = teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership ? 'Trading name, Partnership UTR' : 'Trading name';
				cisInformationSteps.push({
					name,
					complete: teamMember.BusinessSetupComplete,
					wizardStepIndex: 0
				});
				cisInformationSteps.push({
					name: 'VAT registration',
					complete: teamMember.VATSetupComplete,
					wizardStepIndex: 1
				});
				// Notice displayed conditionally
				if (!teamMember.AddressSetupComplete || !teamMember.BusinessSetupComplete) {
					notice = 'Please add address, trading, and VAT details before verifying.';
				}
			}
			else {
				// Limited company or trust. No special steps, just a differing notice
				progressGroupId = PROGRESS_GROUP_IDS.cisInformationCompanyOrTrust;
				// Notice displayed conditionally
				if (!teamMember.CISCompanyDetailsComplete || !teamMember.CISCompanyContactComplete || !teamMember.BankSetupComplete) {
					notice = 'Please add company, contact and payment details before verifying';
				}
			}

			// Tax treatment - common to both
			const taxTreatmentDescription = $filter('taxTreatment')(teamMember.CIS.TaxTreatment);
			cisInformationSteps.push({
				name: `Verification (${taxTreatmentDescription})`,
				complete: teamMember.VerificationSetupComplete,
				// Not available until address and business setup complete
				disabled: !teamMember.AddressSetupComplete || !teamMember.BusinessSetupComplete,
				wizardStepIndex: 2
			});

			cisInformationStepsGroups.push({
				id: progressGroupId,
				notice,
				steps: cisInformationSteps
			});
		}

		teamMember.cisInformationStepsGroups = cisInformationStepsGroups;
	}

	function updateCISCompanySteps (teamMember) {

		// CIS company steps ...
		const cisCompanyStepsGroups = [];

		// Applicable to CIS company or trust business types
		if (teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust) {
			// ... single group
			const cisCompanySteps = [];
			// Company details
			cisCompanySteps.push({
				name: 'Company details',
				complete: teamMember.CISCompanyDetailsComplete,
				wizardStepIndex: 0
			});

			// Company contact
			cisCompanySteps.push({
				name: 'Company contact',
				complete: teamMember.CISCompanyContactComplete,
				wizardStepIndex: 1
			});

			// Payment details
			cisCompanySteps.push({
				name: 'Payment details',
				complete: teamMember.BankSetupComplete,
				wizardStepIndex: 2
			});

			cisCompanyStepsGroups.push({
				id: PROGRESS_GROUP_IDS.cisCompany,
				steps: cisCompanySteps
			});
		}

		teamMember.cisCompanyStepsGroups = cisCompanyStepsGroups;
	}

	function updateEmploymentSteps (teamMember, currentPayPeriod) {

		// Employment steps for each post
		const employmentStepsGroups = [];

		// Applicable only to non-CIS subcontractors
		if (!teamMember.Company.IsCISSubcontractor) {
			// Start with the steps for the main role.
			let employmentSteps = [];
			// Company details
			employmentSteps.push({
				name: 'Company details',
				complete: teamMember.CompanySetupComplete,
				wizardStepIndex: 0
			});

			// Pay information. Not applicable to off-payroll workers
			if (!teamMember.Company.IsOffPayrollWorker) {
				employmentSteps.push({
					name: 'Pay information',
					complete: teamMember.SalarySetupComplete,
					wizardStepIndex: 1
				});
			}

			// Starter information. Applicable to starters
			if (teamMember.Company.IsStarter) {
				employmentSteps.push({
					name: 'Starter information',
					complete: teamMember.StarterSetupComplete,
					wizardStepIndex: teamMember.Company.IsOffPayrollWorker ? 1 : 2
				});
			}

			// Payments to date
			if (!teamMember.Company.IsStarter && currentPayPeriod.IsYTDInformationRequired) {
				employmentSteps.push({
					name: 'Payments to date',
					complete: teamMember.YTDSetupComplete,
					wizardStepIndex: teamMember.Company.IsOffPayrollWorker ? 1 : 2
				});
			}

			// Tax code, student loan
			if ((teamMember.Company.IsStarter && teamMember.Tax.IsP45Available) || !teamMember.Company.IsStarter) {
				employmentSteps.push({
					name: 'Tax code, Student loan',
					complete: teamMember.TaxSetupComplete,
					wizardStepIndex: setWizardStepIndexForTaxStudent(teamMember, currentPayPeriod)
				});
			}

			employmentStepsGroups.push({
				id: PROGRESS_GROUP_IDS.employment,
				steps: employmentSteps
			});

			// Add a group for each additional post
			teamMember.Posts.forEach(additionalPost => {
				const additionalPostSteps = [];
				additionalPostSteps.push({
					name: 'Company details',
					wizardStepIndex: 0,
					complete: additionalPost.SalaryPolicyPostTitle !== ''
				});
				additionalPostSteps.push({
					name: 'Pay information',
					wizardStepIndex: 1,
					complete: additionalPost.SalaryPolicy.PolicyName !== ''
				});
				employmentStepsGroups.push({
					data: {
						additionalPost
					},
					id: PROGRESS_GROUP_IDS.additionalPost,
					steps: additionalPostSteps
				});
			});
		}

		teamMember.employmentStepsGroups = employmentStepsGroups;
	}

	function setWizardStepIndexForTaxStudent (teamMember, currentPayPeriod) {

		if (currentPayPeriod.IsYTDInformationRequired && teamMember.Company.IsOffPayrollWorker) {
			return 2;
		}

		if (!currentPayPeriod.IsYTDInformationRequired && !teamMember.Company.IsOffPayrollWorker) {
			return teamMember.Company.IsStarter ? 3 : 2;
		}

		if (currentPayPeriod.IsYTDInformationRequired && !teamMember.Company.IsOffPayrollWorker) {
			return 3;
		}

		if (!currentPayPeriod.IsYTDInformationRequired && teamMember.Company.IsOffPayrollWorker) {
			return teamMember.Company.IsStarter ? 2 : 1;
		}

		console.error('No tab was returned for "Tax code, Student loan"');
	}

	function updatePensionSteps (teamMember) {

		// Pension steps for each AE pension
		const pensionStepsGroups = [];

		// Not applicable if pensions not active, or the team member is CIS or off-payroll
		if (currentCompanyObj.IsPensionActive && !teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker) {

			// Grab AE pensions
			const aePensions = pensionService.filterAndSortPensions(teamMember.Pensions, PENSION_TYPES.autoEnrolment);

			/* Do something sneaky here. If there are no pensions, stuff in a dummy one. A progress card should be created when there
			   are no pensions to display, to show bugger-all progress and to allow user to make some. */
			if (aePensions.length === 0) {
				aePensions.push({
					PensionSchemeSetupComplete: false,
					PensionSetupComplete: false,
					PensionGroupSetupComplete: false
				});
			}

			/* ... Aye. Create a progress group for each AE pension. There should only be one for the main post and each additional post
				(though the data model doesn't preclude multiple) */
			aePensions.forEach(aePension => {
				let pensionSteps = [];

				pensionSteps.push({
					name: 'Status',
					complete: aePension.PensionSchemeSetupComplete && aePension.PensionSetupComplete,
					disabled: !aePension.PensionSchemeSetupComplete,
					wizardStepIndex: 1
				});
				pensionSteps.push({
					name: aePension.UsePensionPolicy ? 'Band' : 'Group',
					complete: aePension.PensionGroupSetupComplete,
					disabled: !aePension.PensionSchemeSetupComplete,
					wizardStepIndex: 2
				});
				pensionSteps.push({
					name: 'Contributions',
					complete: aePension.PensionGroupSetupComplete,
					disabled: !aePension.PensionSchemeSetupComplete,
					wizardStepIndex: 3
				});

				// Salary sacrifice if applicable
				if (aePension.CanBeSalarySacrifice) {
					pensionSteps.push({
						name: 'Salary sacrifice',
						complete: aePension.PensionGroupSetupComplete,
						disabled: !aePension.PensionSchemeSetupComplete,
						wizardStepIndex: 4
					});
				}

				pensionStepsGroups.push({
					data: {
						pension: aePension
					},
					id: aePension.IsAdditionalPost ? PROGRESS_GROUP_IDS.additionalPostAEPension : PROGRESS_GROUP_IDS.aePension,
					steps: pensionSteps
				});
			});
		}

		// Grab bonafide (non excluded, not ghost, etc) non-AE pensions.
		const nonAePensions = teamMember.Pensions.filter(pension =>
			pensionService.isNonAEPension(pension) &&
			pension.AgencyEmployerPensionID !== config.guidEmpty &&
			!pension.PensionIsExcluded &&
			!pension.IsGhostPension
		);

		angular.extend(teamMember, {
			nonAePensions,
			pensionStepsGroups
		});
	}

	function updatePersonalSteps (teamMember) {

		// Personal steps ...
		const personalStepsGroups = [];

		// Only applicable to non-CIS company types
		if (teamMember.CIS.BusinessDetails.BusinessType !== BUSINESS_TYPES.company && teamMember.CIS.BusinessDetails.BusinessType !== BUSINESS_TYPES.trust) {
			// ... single group ...
			let personalSteps = [];

			// ... this is straightforward stuff, applicable to all ...
			personalSteps.push({
				name: 'Name, Date of birth, NI Number',
				complete: teamMember.PersonalSetupComplete,
				wizardStepIndex: 0
			});
			personalSteps.push({
				name: 'Email address',
				complete: teamMember.EmailSetupComplete,
				wizardStepIndex: 1
			});
			personalSteps.push({
				name: 'Address',
				complete: teamMember.AddressSetupComplete,
				wizardStepIndex: 2
			});
			personalSteps.push({
				name: 'Contact details',
				complete: teamMember.TelephoneSetupComplete,
				wizardStepIndex: 3
			});
			personalSteps.push({
				name: 'Payment details',
				complete: teamMember.BankSetupComplete,
				wizardStepIndex: 4
			});

			personalStepsGroups.push({
				id: PROGRESS_GROUP_IDS.personal,
				steps: personalSteps
			});
		}

		teamMember.personalStepsGroups = personalStepsGroups;
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {

		// Constants
		BUSINESS_TYPES,
		CORRECTIONAL_SUBMISSION_TYPES,
		EMPLOYMENT_TYPES,
		EMPLOYMENT_PAYROLL_TYPES,
		PAY_PERIOD_TYPES,
		PAYMENT_TYPES,
		PAYROLL_MOVE_STATUSES,
		PENSION_ENROLMENT_STATES,
		PENSION_TYPES,
		PROGRESS_CARD_TYPES,

		// Variables
		agencyProfileId,
		linkedUserProfile: false,
		canManageAccounts,

		// Functions
		changeEmployeePayrollType,
		checkEditTeamMemberEmploymentWizard,
		downloadFile: dataTransfer.downloadFile,
		hasLinkedUserProfile,
		isSalaryChangeVisible,
		isWorkPatternVisible,
		onProgressGroupClick,
		onProgressStepClick,
		openAdditionalPostForm,
		openAdvanceFuturePeriodsForm,
		openApplyTaxRefundForm,
		openAttachmentOfEarningsForm,
		onCancelLeavingAdditionalPostClick,
		openCancelMovePayrollsForm,
		openCancelRejoinLeaver,
		openChangeAdminStateForm,
		openChildcareVouchersForm,
		openCISCompanyWizard,
		openCISSubcontractorWizard,
		openCISVerificationForm,
		openCompanyVehicleForm,
		openCompanyVehicleViewForm,
		openCorrectionalSubmissionForm,
		openDeleteAdditionalPostForm,
		openDeleteTeamMemberForm,
		openEditTeamMemberPensionWizard,
		openEditTeamMemberPensionNonAEWizard,
		openEditTeamMemberPersonalWizard,
		openExcludeFromPayrollForm,
		openFurloughForm,
		openGenerateP45Form,
		openHealthcareForm,
		openHealthcareViewForm,
		openInviteToRegisterForm,
		openLeaveAdditionalPostForm,
		openLeaverMadeInErrorForm,
		openMaternityPayForm,
		openMovePayrollsForm,
		openNewAdminForm,
		openOnHoldForm,
		openPaternityPayForm,
		openPayInformationForm,
		openPaymentAfterLeavingForm,
		openPayStatementForm,
		openPensionTeamContributionsNonAEForm,
		openPensionTeamRemoveForm,
		openRejoinLeaverForm,
		openRemoveAdminAccessForm,
		openRepaymentScheduleForm,
		openRtiSubmissionForm,
		openSalaryChangeView,
		openSickPayForm,
		openSupplementaryPayRunForm,
		openUnlinkAccessAccountForm,
		openUnmarkAsAdvancingForm,
		openUnmarkAsLeaverForm,
		openUnregisterUserForm,
		openUpdateLeaverStatusForm,
		openViewWorkPatternForm,
		refreshUser
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('profileLinkRatesCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'adjustmentsService', 'filterService', 'payrollData', 'searchService', 'utilities', function ($q, $rootScope, $scope, $stateParams, adjustmentsService, filterService, payrollData, searchService, utilities) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const userId = $stateParams.userId;

	function attachPayElementToLinkRates (payElementDetailsObj, linkElementsDetailsObj) {

		payElementDetailsObj.PayElements.forEach(payElementObj => {

			payElementObj.linkElement = utilities.getArrayItemByPropertyName(linkElementsDetailsObj.LinkElements, 'LinkElementID', payElementObj.LinkElementID);
		});
	}

	function init () {

		var AGENCY_PAY_PERIOD_ID; // Undefined
		var FUTURE_ADJUSTMENTS = false;
		var LINK_ELEMENTS = true;
		var USER_IMPORT_GROUP_ID; // Undefined

		setPageState('loading');

		const getLinkElements = payrollData.getLinkElements(agencyProfileId);
		const getUserPayElements = payrollData.getUserPayElements(agencyProfileId, AGENCY_PAY_PERIOD_ID, userId, FUTURE_ADJUSTMENTS, USER_IMPORT_GROUP_ID, LINK_ELEMENTS);

		$q.all([getLinkElements, getUserPayElements]).then(dataArr => {

			const linkElementsDetailsObj = dataArr[0];
			const userPayElementDetailsArr = dataArr[1];

			let linkRateDetailsObj;

			if (userPayElementDetailsArr.length) {

				linkRateDetailsObj = userPayElementDetailsArr[0];

				attachPayElementToLinkRates(linkRateDetailsObj, linkElementsDetailsObj);
			}
			else {
				linkRateDetailsObj = null;
			}

			angular.extend($scope, {
				filterBarOptions: filterService.linkRates,
				openLinkRateForm,
				refreshLinkRates: init,
				searchBarOptions: searchService.linkRates,
				userId,
				userPayElementDetails: linkRateDetailsObj
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openLinkRateForm (appliedLinkRatesArr) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			appliedLinkRates: appliedLinkRatesArr,
			callback: init,
			formContext: 'user',
			formKey: 'link-rate',
			userId
		});
	}
	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('profileInformationCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	'config',
	'journalsService',
	'reportData',
	'utilities',
	'BUSINESS_TYPES',
	'CALCULATION_METHODS',
	'DEMO_TASKS',
	'EMPLOYMENT_TYPES',
	'LEAVING_REASONS',
	'POLICY_PAY_BASES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		companyData,
		config,
		journalsService,
		reportData,
		utilities,
		BUSINESS_TYPES,
		CALCULATION_METHODS,
		DEMO_TASKS,
		EMPLOYMENT_TYPES,
		LEAVING_REASONS,
		POLICY_PAY_BASES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $rootScope.currentCompany;
	const userId = $stateParams.userId;

	// From parent controller
	const currentPeriodObj = $scope.currentPayPeriod;
	const refreshUser = $scope.refreshUser;
	const teamMemberObj = $scope.teamMember;

	function getCompanyDetailsBlock (teamMemberObj, businessCategoriesArr, additionalPost) {

		function getCompanyDetailsBusinessCategoriesGroup (businessCategoriesArr, editAction) {

			// Decide where to get the business codes. Either from the main or additional post
			let businessCodesArr;
			if (angular.isDefined(additionalPost)) {
				// Use business codes attached to the additional post (decorateTeamMember in parent controller)
				businessCodesArr = additionalPost.businessCodes.UserAgencyProfileBusinessCodes;
			}
			else if (angular.isDefined(teamMemberObj.Company.BusinessCodes) && teamMemberObj.Company.BusinessCodes != null) {
				// Use business codes attached to the team member company object
				businessCodesArr = teamMemberObj.Company.BusinessCodes.UserAgencyProfileBusinessCodes;
			}

			// Business Codes
			if (angular.isDefined(businessCodesArr) && businessCategoriesArr && businessCategoriesArr.length > 0) {

				journalsService.decorateBusinessCodesWithBusinessCategories(businessCodesArr, businessCategoriesArr);

				/* Cycle through all business categories, if there's a match in the team member business codes, it will
					be displayed as normal. If not, it needs to be shown with default placeholder text for unknown values */
				let businessCodeDetailsArr = [];
				businessCategoriesArr.forEach(businessCategory => {
					let teamMemberBusinessCode = businessCodesArr.find(teamMemberBusinessCode => {
						return teamMemberBusinessCode.BusinessCategoryID === businessCategory.BusinessCategoryID;
					});
					if (teamMemberBusinessCode) {
						businessCodeDetailsArr.push({
							label: businessCategory.BusinessCategoryName,
							value: teamMemberBusinessCode.businessCodeDetail.BusinessCodeNarrative
						});
					}
					else {
						businessCodeDetailsArr.push({
							label: businessCategory.BusinessCategoryName,
							value: '' // The UI will show some placeholder 'unknown' text for empty values
						});
					}
				});

				return {
					editAction,
					id: 'profile-business-categories',
					details: businessCodeDetailsArr
				};
			}
		}

		function getCompanyDetailsCostSplitGroup () {

			// Decide where to get the business codes cost splits. Either from the main or additional post
			let costSplitObj;
			if (angular.isDefined(additionalPost)) {
				// Use business codes cost splits attached to the additional post (decorateTeamMember in parent controller)
				costSplitObj = additionalPost.businessCodes.BusinessCodeCostSplit;
			}
			else if (angular.isDefined(teamMemberObj.Company.BusinessCodes) && teamMemberObj.Company.BusinessCodes != null) {
				// Use business codes cost splits attached to the team member company object
				costSplitObj = teamMemberObj.Company.BusinessCodes.BusinessCodeCostSplit;
			}

			function sortPrimaryFirst(userBusinessCode) {
				return userBusinessCode.UserAgencyProfileBusinessCodePrimary ? -1 : 1;
			}

			function sortBusinessCodesStringsObj (a, b) {
				// We want primary business codes at the top
				if (a.primary) {
					return -1;
				} else if (b.primary) {
					return 1;
				}

				// Sort by descending percentage (multiplied by -1 to reverse the default comparison order)
				const percentComparison = utilities.comparator('percentage')(a, b) * -1;

				// If the percentages are equal, sort by business code name
				if (percentComparison === 0) {
					return utilities.comparator('businessCodeNarrative')(a, b);
				} else {
					return percentComparison;
				}
			}

			let costSplitValue = 'Not added';

			// Build a string containing the business category and a comma separated list of each cost split to show under company details
			if (angular.isDefined(costSplitObj) && costSplitObj != null && costSplitObj.UserAgencyProfileBusinessCodes !== null && costSplitObj.UserAgencyProfileBusinessCodes.length > 1) {
				const businessCategory = businessCategoriesArr.find(businessCategory => businessCategory.BusinessCategoryID === costSplitObj.BusinessCategoryID);
				const businessCodesStringsObj = costSplitObj.UserAgencyProfileBusinessCodes.sort(sortPrimaryFirst).map(costSplitBusinessCode => {
					const businessCodeObj = businessCategory.BusinessCodes.find(businessCodeObj => businessCodeObj.BusinessCodeID === costSplitBusinessCode.BusinessCodeID);

					return {
						businessCodeNarrative: businessCodeObj.BusinessCodeNarrative,
						percentage: costSplitBusinessCode.UserAgencyProfileBusinessCodePercent,
						primary: costSplitBusinessCode.UserAgencyProfileBusinessCodePrimary,
						costSplitText: `${businessCodeObj.BusinessCodeNarrative} - ${costSplitBusinessCode.UserAgencyProfileBusinessCodePercent.toFixed(4)}%`
					};
				});

				// Example - "Department: Marketing - 50.0000% / Sales - 50.0000%"
				costSplitValue = `${businessCategory.BusinessCategoryName}: ${businessCodesStringsObj.sort(sortBusinessCodesStringsObj).map(ubc => ubc.costSplitText).join(' / ')}`;
			}

			return {
				details: [{
					label: 'Cost Split',
					value: costSplitValue,
					type: 'multiline-text'
				}]
			};
		}

		let companyDetailGroupDetailsArr;
		let editAction;
		// Are these company details for an additional post?
		if (angular.isDefined(additionalPost)) {
			editAction = () => openSlideInForm('additional-post-form', {
				additionalPost,
				activeStep: 1,
				currentPayPeriod: currentPeriodObj,
				showFormAsWizard: false,
				title: 'Edit post'
			});
			companyDetailGroupDetailsArr = [
				{
					label: 'Job title',
					value: additionalPost.SalaryPolicyPostTitle
				},
				{
					label: 'Post start date',
					type: 'date',
					value: additionalPost.StartDateISO
				},
				{
					label: 'Post identifier',
					value: additionalPost.SalaryPolicyPostReference
				}
			];

			if (currentCompanyObj.IsHRActive) {
				companyDetailGroupDetailsArr.push({
					label: 'Job grade',
					value: $filter('checkEmpty')(additionalPost.JobGradeName, 'None')
				});
			}
		}
		else {
			editAction = () => openSlideInForm('company-details');
			companyDetailGroupDetailsArr = [
				{
					label: 'Job title',
					value: $filter('checkEmpty')(teamMemberObj.Company.JobTitle, 'No job title')
				}
			];
			if (currentCompanyObj.IsHRActive) {
				companyDetailGroupDetailsArr.push(
					{
						label: 'Job grade',
						value: $filter('checkEmpty')(teamMemberObj.Company.PolicyGradeName, 'None')
					},
					{
						label: 'Post identifier',
						value: teamMemberObj.Company.PrimarySalaryPolicyPostReference
					}
				);

				if (!teamMemberObj.Company.IsOffPayrollWorker) {
					companyDetailGroupDetailsArr.push(
					{
						label: 'Occupational sick policy code',
						value: $filter('checkEmpty')(teamMemberObj.Company.OccupationalSicknessPolicyCode, 'None')
					});
				}
			}

			companyDetailGroupDetailsArr.push({
				label: 'Start date',
				type: 'date',
				value: teamMemberObj.Company.StartDateISO
			});

			companyDetailGroupDetailsArr.push({
				label: 'Payroll ID',
				value: teamMemberObj.Company.StaffNumber
			});

			// Expats
			if (currentCompanyObj.IsExpatActive) {
				companyDetailGroupDetailsArr.push({
					label: 'Expat',
					type: 'boolean',
					value: teamMemberObj.Company.IsExpatriate
				});
			}

			// Show HMRC ID for non pension only
			if (!currentCompanyObj.PensionOnly) {
				companyDetailGroupDetailsArr.push({
					label: 'HMRC Submission ID',
					value: teamMemberObj.Company.PayrollNumber
				});
			}

			companyDetailGroupDetailsArr.push({
				label: 'Omit from RTI?',
				type: 'boolean',
				value: teamMemberObj.Company.IsExcludedFromRTI
			});

			companyDetailGroupDetailsArr.push({
				label: 'Director?',
				type: 'boolean',
				value: teamMemberObj.Company.IsDirectorInTaxYear
			});

			// Director-specific info where applicable
			if (teamMemberObj.Company.IsDirectorInTaxYear) {

				// Appointment / appointment end dates
				if (teamMemberObj.Company.DirectorStartDateISO !== '') {
					companyDetailGroupDetailsArr.push({
						label: 'Appointment date',
						value: teamMemberObj.Company.DirectorStartDateISO,
						type: 'date'
					});
				}

				companyDetailGroupDetailsArr.push({
					label: 'Director NI Payment Method',
					value: teamMemberObj.Company.DirectorNIStandard ? 'Standard (cumulative)' : 'Alternative (non-cumulative)'
				});

				if (teamMemberObj.Company.HasDirectorEndDateInTaxYear) {
					companyDetailGroupDetailsArr.push({
						label: 'Appointment end date',
						value: teamMemberObj.Company.DirectorEndDateISO,
						type: 'date'
					});
				}
			}

			// Leaver info if applicable
			if (teamMemberObj.Company.LeaveDateISO) {
				companyDetailGroupDetailsArr.push({
					label: 'Leave date',
					type: 'date',
					value: teamMemberObj.Company.LeaveDateISO
				},
				{
					label: 'Reason for leaving',
					value: LEAVING_REASONS.find(leavingReason => {
						return leavingReason.id === teamMemberObj.Company.LeaveReason;
					}).name
				},
				{
					label: 'Additional notes',
					value: teamMemberObj.Company.LeaveNote ? teamMemberObj.Company.LeaveNote : '(none)',
					type: 'multiline-text'
				});
			}

			companyDetailGroupDetailsArr.push({
				label: 'Apprentice?',
				type: 'boolean',
				value: teamMemberObj.Company.IsApprentice
			});

			companyDetailGroupDetailsArr.push({
				label: 'Irregular worker?',
				type: 'boolean',
				value: teamMemberObj.Company.IsIrregularWorker
			});

			if ($rootScope.currentCompany.IsPeopleHRIntegrationEnabled) {
				companyDetailGroupDetailsArr.push({
					label: 'PeopleHR Employee ID',
					value: teamMemberObj.Company.PhrEmployeeID
				});
			}
		}

		return  {
			icon: 'company',
			title: 'Company details',
			layout: 'inline',
			detailGroups: [
				{
					editAction,
					details: companyDetailGroupDetailsArr,
					id: 'profile-company-details'
				},
				getCompanyDetailsBusinessCategoriesGroup(businessCategoriesArr, editAction),
				getCompanyDetailsCostSplitGroup()
			],
		};
	}

	function getPayInformationBlock (teamMemberObj, calculationDetailsObj, additionalPost) {

		if (teamMemberObj.Company.IsOffPayrollWorker || teamMemberObj.isArchivedEmployment) {
			return;
		}

		function getPayInformationWorkPatternsGroups (teamMemberObj, payInformationDetailGroupsArr, payInformationGroupSalaryDetailsArr) {

			// Work Patterns
			teamMemberObj.WorkPatterns.forEach(workPatternObj => {

				payInformationDetailGroupsArr.push(
					{
						details: [
							{
								label: 'Work Pattern',
								value: workPatternObj.Description
							},
							{
								label: 'Pattern Length',
								icon: 'pay-periods',
								type: 'pluralize',
								value: workPatternObj.NonWorkingDays + workPatternObj.WorkingDays,
								pluralValues: {
									single: 'day',
									plural: 'days'
								}
							},
							{
								label: 'Working Hours',
								icon: 'clock',
								type: 'pluralize',
								value: workPatternObj.TotalHours,
								pluralValues: {
									single: 'hr',
									plural: 'hrs'
								}
							},
							{
								label: 'Working Days',
								icon: 'calendar',
								type: 'pluralize',
								value: workPatternObj.WorkingDays,
								pluralValues: {
									single: 'day',
									plural: 'days'
								}
							},
							{
								label: 'Non-working Days',
								icon: 'menu-close',
								type: 'pluralize',
								value: workPatternObj.NonWorkingDays,
								pluralValues: {
									single: 'day',
									plural: 'days'
								}
							}
						]
					}
				);

				if (workPatternObj.EffectiveDateISO !== '') {
					payInformationGroupSalaryDetailsArr.splice(2, 0, {
						label: 'Effective From',
						type: 'date',
						value: workPatternObj.EffectiveDateISO
					});
				}
			});
		}

		function getPayInformationPaymentTypeDetail (teamMemberObj) {

			// Salary or Hourly rate
			const paymentRate = $filter('salaryRateDescription')(teamMemberObj.Salary);

			// Rates (daily/hourly)
			if (paymentRate) {
				return {
					label: 'Rate',
					value: `${paymentRate}`
				};
			}

			// Salary
			switch (teamMemberObj.Salary.EmploymentType) {

				case EMPLOYMENT_TYPES.paidHourly:
					return {
						label: 'Paid hourly',
						type: 'monetise',
						value: teamMemberObj.Salary.SalaryHourlyRate,
						precision: config.precision.salaryRates
					};

				case EMPLOYMENT_TYPES.netPay:
					return {
						label: 'Net pay per ' + $filter('payPeriodTypeDescription')(currentPeriodObj.PayPeriodType, 'month'),
						type: 'monetise',
						value: teamMemberObj.Salary.SalaryYearly,
						precision: config.precision.salaryRates
					};

				case EMPLOYMENT_TYPES.standard:
				case EMPLOYMENT_TYPES.nonStandard:
					return {
						label: 'Annual salary',
						type: 'monetise',
						value: teamMemberObj.Salary.SalaryYearly,
						precision: config.precision.salaryRates
					};
			}
		}

		function getCalculationsSettingsDetail (teamMemberObj, payInformationDetailGroupsArr, calculationDetailsObj) {

			// Calculation settings (All employment types but pay policy)
			if (teamMemberObj.Salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy) {
				return;
			}

			const calculationDetailsToUseObj = teamMemberObj.Salary.UseCompanyDefaults ? calculationDetailsObj : teamMemberObj.Salary.CalculationDetails;

			const calculationAndPaymentsDetailsArr = [
				{
					label: 'Calculate gross to net elements before net to gross',
					type: 'boolean',
					value: calculationDetailsToUseObj.CalculateGrossToNetElementsFirst
				}
			];

			if (teamMemberObj.Salary.CalculationDetails.HasNetToGrossEENIPaidByEmployer) {
				calculationAndPaymentsDetailsArr.push(
					{
						label: 'Gross up for Employee NI',
						value: calculationDetailsToUseObj.NetToGrossEENIPaidByEmployer,
						type: 'boolean'
					}
				);
			}

			calculationAndPaymentsDetailsArr.push(
				{
					label: 'Gross up for pension contributions',
					value: calculationDetailsToUseObj.NetToGrossPensionPaidByEmployer,
					type: 'boolean'
				},
				{
					label: 'Gross up for student loans (Plan 1, 2, 4, and 5)',
					value: calculationDetailsToUseObj.NetToGrossSLPaidByEmployer,
					type: 'boolean'
				},
				{
					label: 'Gross up for postgraduate loans',
					value: calculationDetailsToUseObj.NetToGrossPGLPaidByEmployer,
					type: 'boolean'
				}
			);

			payInformationDetailGroupsArr.push({
				title: 'Calculation settings',
				details: calculationAndPaymentsDetailsArr
			});
		}

		function getTaxNISettingsDetail (teamMemberObj, payInformationDetailGroupsArr) {

			// Tax and NI settings (Expats && Net Pay || Standard Pattern)
			if (
				!(
					currentCompanyObj.IsExpatActive && teamMemberObj.Company.IsExpatriate &&
					[EMPLOYMENT_TYPES.netPay, EMPLOYMENT_TYPES.standard].includes(teamMemberObj.Salary.EmploymentType)
				)
			) {
				return;
			}

			// Change salary to show currency
			if (teamMemberObj.Salary.CurrencyID !== config.guidEmpty) {
				payInformationPaymentTypeDetail.currency = teamMemberObj.Salary.CurrencyLabel;
			}


			const taxNiSettingsDetailsArr = [];

			taxNiSettingsDetailsArr.push(
				{
					label: 'Exempt from Employee’s NI',
					type: 'boolean',
					value: teamMemberObj.Salary.EENIExcluded
				},
				{
					label: 'Exempt from Employer’s NI',
					type: 'boolean',
					value: teamMemberObj.Salary.ERNIExcluded
				}
			);

			if (!teamMemberObj.Salary.EENIExcluded) {
				taxNiSettingsDetailsArr.push({
					label: 'Employee’s NI is paid by:',
					value: teamMemberObj.Salary.EENIPaidByEmployer ? 'Employer' : 'Employee'
				});
			}

			if (teamMemberObj.Salary.TaxExcemptPercent > 0) {
				taxNiSettingsDetailsArr.push({
					label: 'Tax exempt percentage',
					value: teamMemberObj.Salary.TaxExcemptPercent+'%'
				});
			}

			taxNiSettingsDetailsArr.push({
				label: 'Allow tax greater than 50%?',
				type: 'boolean',
				value: teamMemberObj.Salary.TaxCanExceed50Percent
			});

			payInformationDetailGroupsArr.push({
				title: 'NI and Tax settings',
				details: taxNiSettingsDetailsArr
			});
		}

		function getSalaryChangeDetails (teamMemberObj, payInformationDetailGroupsArr) {

			if (!currentPeriodObj.IsPayrollLocked && !teamMemberObj.Company.IsOnHold) {
				return;
			}

			// Add group cta if salary change exists
			if (teamMemberObj.Salary.SalaryChangeEffectiveDateISO !==  '') {
				payInformationDetailGroupsArr.groupCta = {
					viewAction: () => {
						openSlideInForm('salary-change', { payPeriodId: currentPeriodObj.PayPeriodID });
					},
					editAction: () => {
						openSlideInForm('salary-change', { payPeriodId: currentPeriodObj.PayPeriodID });
					},
					viewLabel: 'Salary change',
					editCopy: 'View',
					copy: `Effective date: ${$filter('dateformat')(teamMemberObj.Salary.SalaryChangeEffectiveDateISO)}`,
					copyTheme: 'is-medium',
					theme: 'tertiary',
					customClass: 'cheese'
				};
			}
		}

		const canViewWorkPattern = [EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(teamMemberObj.Salary.EmploymentType) &&
		(currentPeriodObj.IsPayrollLocked || teamMemberObj.Company.IsOnHold);

		const payInformationPaymentTypeDetail = getPayInformationPaymentTypeDetail(teamMemberObj);
		const payInformationGroupSalaryDetailsArr = [
			{
				actionFunction: () => openSlideInForm('view-work-pattern', { hideProfileLink: true }),
				label: 'Employment Type',
				type: canViewWorkPattern ? 'action-link' : 'string',
				value: $filter('employmentTypeDescription')(teamMemberObj.Salary.EmploymentType)
			},
			payInformationPaymentTypeDetail,
		];

		if (![EMPLOYMENT_TYPES.paidHourly, EMPLOYMENT_TYPES.payPolicy].includes(teamMemberObj.Salary.EmploymentType)) {

			payInformationGroupSalaryDetailsArr.push({
				label: 'Overtime hourly rate',
				type: 'monetise',
				value: teamMemberObj.Salary.SalaryHourlyRateOvertime,
				precision: config.precision.salaryRates
			},
			{
				label: 'Overtime daily rate',
				type: 'monetise',
				value: teamMemberObj.Salary.SalaryDailyRateOvertime,
				precision: config.precision.salaryRates
			});

			if (teamMemberObj.Salary.EmploymentType !== EMPLOYMENT_TYPES.netPay) {
				payInformationGroupSalaryDetailsArr.push({
					label: 'Day rate calculation',
					value: $filter('calculationMethodDescription')(teamMemberObj.Salary.ProRatingType)
				});
			}
		}

		if (teamMemberObj.Company.IsRollUpHolidayVisible) {
			// Add 'Rolled up holiday'
			payInformationGroupSalaryDetailsArr.push({
				label: 'Rolled up holiday',
				type: 'boolean',
				value: teamMemberObj.Company.IsRollUpHoliday
			});
		}

		// Determine edit action. This is different for additional posts
		let editAction;
		if (angular.isUndefined(additionalPost)) {
			editAction = () => openSlideInForm('pay-information');
		}
		else {
			editAction = () => openSlideInForm('additional-post-form', {
				additionalPost: additionalPost,
				activeStep: 2,
				currentPayPeriod: currentPeriodObj,
				showFormAsWizard: false,
				title: 'Edit post'
			});
		}

		const payInformationSalaryGroup = {
			editAction,
			demoTooltip: DEMO_TASKS.team.editSalary,
			details: payInformationGroupSalaryDetailsArr,
			id: 'profile-pay-information'
		};

		const payInformationDetailGroupsArr = [
			payInformationSalaryGroup
		];

		if (teamMemberObj.Salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy) {

			let annualSalaryPolicyObj;
			let annualAllowancePoliciesArr;

			if (angular.isDefined(additionalPost)) {
				annualSalaryPolicyObj = (additionalPost.SalaryPolicy.SiblingPolicy !== null && angular.isDefined(additionalPost.SalaryPolicy.SiblingPolicy)) ? additionalPost.SalaryPolicy.SiblingPolicy : additionalPost.SalaryPolicy;
				annualAllowancePoliciesArr = additionalPost.SalaryPolicy.AllowancePolicies;
			}
			else {
				// Get salary policy (should be 1 present) and annual allowance policies (0+) if they haven't been presented for an additional post
				annualSalaryPolicyObj = teamMemberObj.Salary.Policies.find(salaryPolicy => salaryPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary && salaryPolicy.IsPrimary);
				annualAllowancePoliciesArr = teamMemberObj.Salary.AllowancePolicies;
			}

			// Generate a description for the selected annual salary policy band that includes the annual amount (without FTE adjustment)
			const annualSalaryPolicyBandDescription = `${annualSalaryPolicyObj.Band.PolicyBandName} (${$filter('monetise')(annualSalaryPolicyObj.Band.PolicyBandAnnualSalary)})`;

			// Salary policy
			payInformationDetailGroupsArr.push({
				title: 'Pay',
				details: [
					{
						label: 'Pay policy',
						value: annualSalaryPolicyObj.PolicyName
					},
					{
						label: 'Pay point',
						value: annualSalaryPolicyBandDescription
					},
					{
						label: 'Contracted hours per week',
						type: 'number',
						value: annualSalaryPolicyObj.HoursPerWeek
					},
					{
						label: 'Contracted weeks per year',
						type: 'number',
						value: annualSalaryPolicyObj.WeeksPerYear
					},
					{
						label: 'Full time equivalent',
						type: 'percent',
						value: annualSalaryPolicyObj.FTEPercent
					},
					{
						label: 'Annual salary',
						type: 'monetise',
						value: annualSalaryPolicyObj.FTEAnnualSalary
					},
					{
						label: 'Hourly rate',
						precision: config.precision.salaryRates,
						type: 'monetise',
						value: annualSalaryPolicyObj.Band.PolicyBandHourlyRate
					}
				]
			});

			// Annual allowance policies
			annualAllowancePoliciesArr.forEach(annualAllowancePolicy => {
				const effectiveAllowancePolicy = (annualAllowancePolicy.SiblingPolicy !== null && angular.isDefined(annualAllowancePolicy.SiblingPolicy)) ? annualAllowancePolicy.SiblingPolicy : annualAllowancePolicy;

				// Generate a description for the selected annual salary policy band that includes the annual amount (without FTE adjustment)
				const annualAllowancePolicyBandDescription = `${effectiveAllowancePolicy.Band.PolicyBandName} (${$filter('monetise')(effectiveAllowancePolicy.Band.PolicyBandAnnualAllowance)})`;

				payInformationDetailGroupsArr.push({
					title: 'Annual allowance',
					details: [
						{
							label: 'Pay policy',
							value: effectiveAllowancePolicy.PolicyName
						},
						{
							label: 'Pay point',
							value: annualAllowancePolicyBandDescription
						},
						// Get correct annual allowance salary depending on FTEApply
						{
							label: 'Annual allowance',
							type: 'monetise',
							value: effectiveAllowancePolicy.FTEApply ? effectiveAllowancePolicy.FTEAnnualSalary : effectiveAllowancePolicy.Band.PolicyBandAnnualAllowance
						},
						{
							label: 'Calculated at FTE?',
							type: 'boolean',
							value: effectiveAllowancePolicy.FTEApply
						}
					]
				});
			});

			payInformationDetailGroupsArr.push({
				title: 'Day rate calculations',
				details: [
					{
						label: 'Starting/Leaving',
						value: CALCULATION_METHODS.find(calculationMethod => calculationMethod.key === annualSalaryPolicyObj.PeriodProRatingMethod).description
					},
					{
						label: 'Pay elements',
						value: CALCULATION_METHODS.find(calculationMethod => calculationMethod.key === annualSalaryPolicyObj.ElementProRatingMethod).description
					}
				]
			});
		}

		if ([EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(teamMemberObj.Salary.EmploymentType)) {
			getPayInformationWorkPatternsGroups(teamMemberObj, payInformationDetailGroupsArr, payInformationGroupSalaryDetailsArr);
		}

		// Tax and NI Settings
		getTaxNISettingsDetail(teamMemberObj, payInformationDetailGroupsArr);

		// Calculation Settings
		getCalculationsSettingsDetail(teamMemberObj, payInformationDetailGroupsArr, calculationDetailsObj);

		// Salary change read only details
		getSalaryChangeDetails(teamMemberObj, payInformationSalaryGroup);

		return {
			detailGroups: payInformationDetailGroupsArr,
			hasBeenUpdated: teamMemberObj.Salary.PatternUpdated,
			icon: 'setup-user',
			layout: 'inline',
			title: 'Pay information'
		};
	}

	function getTeamMemberDetailBlocks (teamMemberObj, businessCategoriesArr, calculationDetailsObj) {

		function getAdditionalPostsSections (teamMemberObj, businessCategoriesArr) {

			function setDetailGroupActionIdsForAdditionalPostDetailBlock (additionalPostIndex, detailBlockObj) {

				for (let detailGroupObj of detailBlockObj.detailGroups) {
					if (detailGroupObj.id) {
						detailGroupObj.id = `${detailGroupObj.id}-post-${additionalPostIndex}`;
					}
				}
			}

			let additionalPostsSections;
			if (teamMemberObj.Posts.length !== 0) {

				additionalPostsSections = [];

				for (let additionalPostIndex = 0; additionalPostIndex < teamMemberObj.Posts.length; additionalPostIndex++) {

					const additionalPost = teamMemberObj.Posts[additionalPostIndex];

					// Theme for additional post detail blocks is greyscale if the policy is locked or left, otherwise primary
					const isEditableTheme = (!additionalPost.IsLocked || additionalPost.SalaryPolicy.State === 0) && !additionalPost.HasLeft;
					const theme = isEditableTheme ? 'primary' : 'greyscale';
					const companyDetails = getCompanyDetailsBlock(teamMemberObj, businessCategoriesArr, additionalPost);
					const payInformation = getPayInformationBlock(teamMemberObj, calculationDetailsObj, additionalPost);

					setDetailGroupActionIdsForAdditionalPostDetailBlock(additionalPostIndex, companyDetails);
					setDetailGroupActionIdsForAdditionalPostDetailBlock(additionalPostIndex, payInformation);

					companyDetails.theme = theme;
					payInformation.theme = theme;
					additionalPostsSections.push({
						companyDetails,
						payInformation,
						post: additionalPost,
						salaryPolicy: additionalPost.SalaryPolicy,
						showAdditionalPost: true,
						title: additionalPost.SalaryPolicyPostTitle,
						theme: theme
					});
				}

				// Get additional posts policies
				return additionalPostsSections;
			}
		}

		function getIsNewStarterInformationBlockVisible (teamMemberObj) {

			// Not applicable if archived
			if (teamMemberObj.isArchivedEmployment) {
				return false;
			}

			// Seconded expats have their own declaration state
			if (!teamMemberObj.Company.IsSeconded && !teamMemberObj.Tax.StarterDeclaration) {

				return false;
			}

			return true;
		}

		function getEmploymentSection (teamMemberObj, businessCategoriesArr, calculationDetailsObj) {

			// Don't show personal section for CIS/Payslip manager companies
			if (teamMemberObj.Company.IsCISSubcontractor || currentCompanyObj.IsPayslipManagerActive) {
				return;
			}

			function getNewStarterInformationBlock (teamMemberObj) {

				if (!getIsNewStarterInformationBlockVisible(teamMemberObj)) {
					return;
				}

				// Seconded Expats
				if (teamMemberObj.Company.IsSeconded) {

					return {
						icon: 'joiners',
						title: 'New starter information',
						layout: 'inline',
						detailGroups: [
							{
								details: [
									{
										label: 'Starter declaration',
										value: $filter('secondedStateDescription')(teamMemberObj.Tax.SecondedState)
									}
								],
								editAction: () => openSlideInForm('new-starter-information'),
								id: 'profile-new-starter-information'
							}
						]
					};
				}

				// Everyone else
				return {
					icon: 'joiners',
					title: 'New starter information',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'Has P45?',
									type: 'boolean',
									value: teamMemberObj.Tax.IsP45Available
								},
								{
									label: 'Has P6?',
									type: 'boolean',
									value: teamMemberObj.Tax.IsP6Available
								},
								{
									label: 'Starter declaration',
									value: teamMemberObj.Tax.StarterDeclaration
								}
							],
							editAction: () => openSlideInForm('new-starter-information'),
							id: 'profile-new-starter-information',
							show: !(teamMemberObj.Tax.IsP45Available || teamMemberObj.Tax.IsP6Available)
						},
						{
							details: [
								{
									label: 'Has P45?',
									type: 'boolean',
									value: teamMemberObj.Tax.IsP45Available
								},
								{
									label: 'Leaving date on P45',
									type: 'date',
									value: teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISO
								},
								{
									label: 'Total pay in previous employment',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDGrossPreviousEmployment
								},
								{
									label: 'Total tax paid in previous employment',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDTaxPreviousEmployment
								}
							],
							editAction: () => openSlideInForm('new-starter-information'),
							id: 'profile-new-starter-information',
							show: teamMemberObj.Tax.IsP45Available
						},
						{
							details: [
								{
									label: 'Has P6?',
									type: 'boolean',
									value: teamMemberObj.Tax.IsP6Available
								},
								{
									label: 'Total pay in previous employment',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDGrossPreviousEmployment
								},
								{
									label: 'Total tax paid in previous employment',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDTaxPreviousEmployment
								}
							],
							editAction: () => openSlideInForm('new-starter-information'),
							id: 'profile-new-starter-information',
							show: teamMemberObj.Tax.IsP6Available
						}
					]
				};
			}

			function getYearToDatesBlock (teamMemberObj) {

				return {
					icon: 'payslip',
					title: 'Year to dates',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'YTD gross pay',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDGrossCurrentEmploymentTotal
								},
								{
									label: 'YTD gross pay for Tax',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDGrossCurrentEmploymentforTax + teamMemberObj.YTD.YTDGrossPreviousEmployment
								},
								{
									label: 'YTD gross pay for NIC',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDGrossCurrentEmploymentforNIC
								},
								{
									label: 'YTD tax paid',
									type: 'monetise',
									value: teamMemberObj.YTD.YTDTaxCurrentEmployment + teamMemberObj.YTD.YTDTaxPreviousEmployment
								}
							],
							editAction: () => openSlideInForm('payments-to-date'),
							id: 'profile-payments-to-date'
						}
					]
				};
			}

			function getContinuousEmploymentBlock (teamMemberObj) {

				if (teamMemberObj.isArchivedEmployment) {
					return;
				}

				return {
					icon: 'calendar',
					title: 'Continuous employment',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'Company name',
									value: teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentEmployerName
								},
								{
									label: 'Start date',
									type: teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO ? 'date' : null,
									value: teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO ? teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO : ''
								},
							],
							editAction: () => openSlideInForm('continuous-employment'),
							id: 'profile-continuous-employment'
						}
					]
				};
			}

			function getWorkplaceInformationBlock (teamMemberObj) {

				if (teamMemberObj.isArchivedEmployment) {
					return;
				}

				return {
					icon: 'company',
					title: 'Workplace information',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'Workplace postcode',
									value: teamMemberObj.Company.WorkplaceInformation.WorkplacePostcode
								}
							],
							editAction: () => openSlideInForm('workplace-information'),
							id: 'profile-workplace-information'
						}
					]
				};
			}

			return {
				showEmployment: true,
				newStarterInformation: getNewStarterInformationBlock(teamMemberObj),
				yearToDates: getYearToDatesBlock(teamMemberObj),
				companyDetails: getCompanyDetailsBlock(teamMemberObj, businessCategoriesArr),
				payInformation: getPayInformationBlock(teamMemberObj, calculationDetailsObj),
				continuousEmployment: getContinuousEmploymentBlock(teamMemberObj),
				workplaceInformation: getWorkplaceInformationBlock(teamMemberObj)
			};
		}

		function getPersonalSection (teamMemberObj) {

			// Don't show personal section for companies or archived employments
			if (teamMemberObj.isCompany || teamMemberObj.isArchivedEmployment) {
				return;
			}

			function getPersonalDetailsBlock (teamMemberObj) {
				const personalDetailsGroupsArr = [
					{
						details: [
							{
								label: 'Title',
								value: `${teamMemberObj.Personal.Title}`
							},
							{
								label: 'Name',
								value: `${teamMemberObj.Personal.Forename} ${teamMemberObj.Personal.Surname}`
							},
							{
								label: 'Date of birth',
								value: $filter('dateformat')(teamMemberObj.Personal.DOBISO)
							},
							{
								label: 'Age',
								value: $filter('yearsold')(teamMemberObj.Personal.DOBISO)
							},
							{
								label: 'NI Number',
								value: teamMemberObj.Personal.NINumberPending ? 'Waiting' : teamMemberObj.Personal.NINumber
							},
							{
								label: 'Gender',
								value: teamMemberObj.Personal.Gender
							}
						 ],
						 editAction: () => openSlideInForm('personal'),
						 id: 'profile-personal-details'
					}
				];

				return {
					icon: 'user',
					title: 'Personal details',
					layout: 'inline',
					detailGroups: personalDetailsGroupsArr
				};
			}

			function getContactDetailsBlock (teamMemberObj) {

				const contactDetailsGroupsArr = [
					{
						details: [
							{
								label: 'Email address',
								type: teamMemberObj.Personal.DummyEmail ? null : 'email',
								value: teamMemberObj.Personal.DummyEmail ? 'Doesn\'t have an email address' : teamMemberObj.Personal.Email === '' ? 'No email address added' : teamMemberObj.Personal.Email
							}
						],
						editAction: () => openSlideInForm('email-address'),
						id: 'profile-contact-details-email-address'
					}
				];

				// Company is not a payslip manager company
				if (!currentCompanyObj.IsPayslipManagerActive) {
					contactDetailsGroupsArr.push({
						details: [
							{
								label: 'Main contact number',
								type: 'phone',
								value: teamMemberObj.Personal.PhoneNumberPrimary
							},
							{
								label: 'Other contact number',
								type: 'phone',
								value: teamMemberObj.Personal.PhoneNumberSecondary
							}
						],
						editAction: () => openSlideInForm('telephone'),
						id: 'profile-contact-details-telephone'
					});
				}

				return {
					icon: 'email',
					title: 'Contact details',
					layout: 'inline',
					detailGroups: contactDetailsGroupsArr
				};
			}

			function getAddressBlock (teamMemberObj) {

				return {
					icon: 'building-society',
					title: 'Address',
					layout: 'inline single',
					detailGroups: [
						{
							details: [
								{
									type: 'address',
									value: teamMemberObj.HasForeignAddress ? teamMemberObj.ForeignAddress : teamMemberObj.Address,
								}
							],
							editAction: () => openSlideInForm('address'),
							id: 'profile-address'
						}
					]
				};
			}

			function getBankDetailsBlock (teamMemberObj) {

				if (currentCompanyObj.IsPayslipManagerActive) {
					return;
				}

				const bankDetailsGroupsDetailsArr = [
					{
						label: 'Account type',
						value: teamMemberObj.Bank.BankAccountNumber === '' ? '' : (teamMemberObj.Bank.BuildingSocietyReference === '' ? 'Bank account' : 'Building society account')
					},
					{
						label: 'Account number',
						value: (teamMemberObj.Bank.BuildingSocietyReference === '' ? '' : teamMemberObj.Bank.BuildingSocietyReference + '/') + teamMemberObj.Bank.BankAccountNumber
					},
					{
						label: 'Sort code',
						value: teamMemberObj.Bank.SortCode === '000000' ? '' : teamMemberObj.Bank.SortCode
					},
					{
						label: 'Account holder name',
						value: teamMemberObj.Bank.BankAccountName
					}
				];

				// International
				if (teamMemberObj.Bank.BankIBAN !== '') {
					bankDetailsGroupsDetailsArr.push({
						label: 'IBAN',
						value: teamMemberObj.Bank.BankIBAN
					});
				}
				if (teamMemberObj.Bank.BankBIC !== '') {
					bankDetailsGroupsDetailsArr.push({
						label: 'BIC',
						value: teamMemberObj.Bank.BankBIC
					});
				}
				if (currentCompanyObj.IsExpatActive && teamMemberObj.Bank.CurrencyID !== config.guidEmpty) {
					bankDetailsGroupsDetailsArr.push({
						label: 'Currency',
						value: teamMemberObj.Bank.CurrencyLabel
					});
				}

				return {
					icon: 'bank',
					title: 'Bank details',
					layout: 'inline',
					detailGroups: [
						{
							details: bankDetailsGroupsDetailsArr,
							editAction: () => openSlideInForm('payment-details'),
							id: 'profile-bank-details'
						}
					]
				};
			}

			function getPassportDetailsBlock (teamMemberObj) {

				if (currentCompanyObj.IsPayslipManagerActive) {
					return;
				}

				const passportDetailsArr = [
					{
						label: 'Passport number',
						value: teamMemberObj.Personal.PassportNumber
					},
					{
						label: 'Expiry date',
						type: 'date',
						value: teamMemberObj.Personal.PassportExpiryDateISO
					},
					{
						label: 'EU Citizen?',
						type: 'boolean',
						value: teamMemberObj.Personal.EUCitizen
					}
				];

				if (teamMemberObj.Personal.Nationality !== '') {
					passportDetailsArr.push({
						label: 'Nationality',
						value: teamMemberObj.Personal.Nationality
					});
				}

				if (teamMemberObj.Personal.VisaNumber !== '') {
					passportDetailsArr.push({
						label: 'Visa Number',
						value: teamMemberObj.Personal.VisaNumber
					});
				}

				if (teamMemberObj.Personal.VisaExpiryDateISO !== '') {
					passportDetailsArr.push({
						label: 'Visa expiry date',
						type: 'date',
						value: teamMemberObj.Personal.VisaExpiryDateISO
					});
				}

				if (teamMemberObj.Personal.UKArrivalDateISO !== '') {
					passportDetailsArr.push({
						label: 'Arrival in UK date',
						type: 'date',
						value: teamMemberObj.Personal.UKArrivalDateISO
					});
				}

				return {
					icon: 'passport',
					title: 'Passport and Visa',
					layout: 'inline',
					detailGroups: [
						{
							details: passportDetailsArr,
							editAction: () => openSlideInForm('passport'),
							id: 'profile-passport-and-visa'
						}
					]
				};
			}

			return {
				showPersonal: true,
				personalDetails: getPersonalDetailsBlock(teamMemberObj),
				contactDetails: getContactDetailsBlock(teamMemberObj),
				address: getAddressBlock(teamMemberObj),
				bankDetails: getBankDetailsBlock(teamMemberObj),
				passportDetails: getPassportDetailsBlock(teamMemberObj)
			};
		}

		function getCISSubcontractorSection (teamMemberObj) {

			if (!teamMemberObj.Company.IsCISSubcontractor) {
				return;
			}

			function getCisInformationBlock (teamMemberObj) {

				const cisInformationGroupDetailsArr = [
					{
						label: 'Business Type',
						value: $filter('cisBusinessType')(teamMemberObj.CIS.BusinessDetails.BusinessType)
					},
					{
						label: 'Trading Name',
						value: teamMemberObj.CIS.BusinessDetails.TradingName
					},
					{
						label: 'Verification Number',
						value: teamMemberObj.CIS.VerificationReference
					},
					{
						label: 'Deduction rate',
						value: $filter('taxTreatment')(teamMemberObj.CIS.TaxTreatment)
					}
				];

				// CIS Partnerships Only
				if (teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership) {
					cisInformationGroupDetailsArr.splice(2, 0, {
						label: 'Partnership UTR',
						value: teamMemberObj.CIS.BusinessDetails.PartnershipUTR
					});
				}

				// CIS Subcontractors Only
				if (teamMemberObj.Company.IsCISSubcontractor) {
					cisInformationGroupDetailsArr.push({
						label: 'UTR',
						value: teamMemberObj.Personal.UTRPending ? 'Doesn\'t have a Unique Tax Reference' : teamMemberObj.Personal.UTR
					});
				}

				return {
					icon: 'cis',
					title: 'CIS information',
					layout: 'inline',
					detailGroups: [
						{
							details: cisInformationGroupDetailsArr,
							editAction: () => openSlideInForm('cis-business-type', {
								title: teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.soletrader ? 'Sole Trader details' : 'Partnership details'
							}),
							id: 'profile-cis-information'
						}
					]
				};
			}

			return {
				showCISSubcontractor: true,
				cisInformation: getCisInformationBlock(teamMemberObj)
			};
		}

		function getCISCompanySection (teamMemberObj) {

			if (!teamMemberObj.isCompany) {
				return;
			}

			function getCISCompanyDetailsBlock (teamMemberObj) {

				return {
					icon: 'cis',
					title: 'Company information',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'Company name',
									value: teamMemberObj.CIS.BusinessDetails.TradingName
								},
								{
									label: 'Company UTR',
									value: $filter('checkEmpty')(teamMemberObj.Personal.UTR, 'No UTR provided')
								},
								{
									label: 'VAT registration number',
									value: teamMemberObj.CIS.VATRegistrationNumber
								},
								{
									label: 'Address',
									type: 'address',
									value: teamMemberObj.Address
								}
							],
							editAction: () => openSlideInForm('cis-company-details'),
							id: 'profile-company-information'
						}
					]
				};
			}

			function getCISCompanyContactDetails (teamMemberObj) {

				return {
					icon: 'user',
					title: 'Company contact',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: 'Name',
									value: teamMemberObj.Personal.Title + ' ' + teamMemberObj.Personal.Forename + ' ' + teamMemberObj.Personal.Surname
								},
								{
									label: 'Email address',
									value: $filter('checkEmpty')(teamMemberObj.Personal.Email, 'No email address added')
								}
							],
							editAction: () => openSlideInForm('cis-company-contact'),
							id: 'profile-company-contact'
						}
					]
				};
			}

			function getCISCompanyPaymentDetails (teamMemberObj) {

				return {
					icon: 'bank',
					title: 'Payment details',
					layout: 'inline',
					detailGroups: [
						{
							details: [
								{
									label: teamMemberObj.Bank.BuildingSocietyReference === '' ? 'Bank account' : 'Building society account',
									value: teamMemberObj.Bank.BuildingSocietyReference !== '' ? teamMemberObj.Bank.BuildingSocietyReference + '/' + teamMemberObj.Bank.BankAccountNumber : teamMemberObj.Bank.BankAccountNumber
								},
								{
									label: 'Sort code',
									value: teamMemberObj.Bank.SortCode
								}
							],
							editAction: () => openSlideInForm('payment-details', {
								showContext: false
							}),
							id: 'profile-payment-detais'
						}
					]
				};
			}

			return {
				showCISCompany: true,
				cisCompanyDetails: getCISCompanyDetailsBlock(teamMemberObj),
				cisCompanyContactDetails: getCISCompanyContactDetails(teamMemberObj),
				cisCompanyPaymentDetails: getCISCompanyPaymentDetails(teamMemberObj)
			};
		}

		return {
			additionalPosts: getAdditionalPostsSections(teamMemberObj, businessCategoriesArr, calculationDetailsObj),
			employment: getEmploymentSection(teamMemberObj, businessCategoriesArr, calculationDetailsObj),
			personal: getPersonalSection(teamMemberObj),
			cisSubContractor: getCISSubcontractorSection(teamMemberObj),
			cisCompany: getCISCompanySection(teamMemberObj)
		};
	}

	function init () {

	   setPageState('loading');

		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
		const getAgencyEmployerCalculationDetails = teamMemberObj.Salary.UseCompanyDefaults && teamMemberObj.Salary.EmploymentType !== EMPLOYMENT_TYPES.payPolicy ? companyData.getAgencyEmployerNetPayCalculationDetails(agencyProfileId) : null;

		$q.all([getBusinessCategoriesList, getAgencyEmployerCalculationDetails])
			.then(([businessCategoriesArr, calculationDetailsObj]) => {

				$scope.vm = getTeamMemberDetailBlocks(teamMemberObj, businessCategoriesArr, calculationDetailsObj);

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openSlideInForm (formKey, formOptionsObj) {

		const defaultFormOptionsObj = {
			agencyProfileId: agencyProfileId,
			availableWhenCompanyArchived: true,
			callback: refreshUser,
			contextType: 'user',
			formKey: formKey,
			userId: userId
		};

		$rootScope.openSlideInForm(angular.extend(defaultFormOptionsObj, formOptionsObj));
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		openSlideInForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('profilePensionCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'pensionData',
	'pensionService',
	'FORM_WIZARD_KEYS',
	'PENSION_ENROLMENT_STATES',
	'PENSION_TYPES',
	function (
		$rootScope,
		$scope,
		$stateParams,
		pensionData,
		pensionService,
		FORM_WIZARD_KEYS,
		PENSION_ENROLMENT_STATES,
		PENSION_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const userId = $stateParams.userId;

	/* Callback ensures refresh is initiated from the parent controller. If a team member is added or removed from a pension here,
	   that needs to be updated in the overview. */
	const callback = $scope.refreshUser;

	function decoratePensionPayments (pensionPaymentsArr) {

		// Sort these, so additional post pensions come after main post, in job title order
		pensionPaymentsArr = pensionService.filterAndSortPensions(pensionPaymentsArr, PENSION_TYPES.all, 'PensionDetails');

		const aePensionIndex = pensionPaymentsArr.findIndex(paymentObj => paymentObj.PensionDetails.PensionType === PENSION_TYPES.autoEnrolment);
		const aePensionObj = angular.copy(pensionPaymentsArr[aePensionIndex]);

		if (aePensionIndex > -1) {

			// Remove AE pension from array
			pensionPaymentsArr.splice(aePensionIndex, 1);

			// Move excluded pension to end of array
			if (aePensionObj.PensionDetails.PensionState === PENSION_ENROLMENT_STATES.excluded) {
				pensionPaymentsArr.push(aePensionObj);

			} else {

				// Bring non-excluded pension to beginning of array
				pensionPaymentsArr.unshift(aePensionObj);
			}
		}

		return pensionPaymentsArr;
	}

	function getPensionCount (pensionPaymentsArr) {
		return pensionPaymentsArr.filter(paymentObj => paymentObj.PensionDetails.PensionState !== PENSION_ENROLMENT_STATES.excluded).length;
	}

	function init () {

		setPageState('loading');

		pensionData.getTeamMemberPensionPaymentHistory(agencyProfileId, userId)
			.then(pensionPaymentsArr => {

				const vmObj = {
					pensionCount: getPensionCount(pensionPaymentsArr),
					pensionPayments: decoratePensionPayments(pensionPaymentsArr),
					activePayment: null
				};

				setActivePayment(vmObj, pensionPaymentsArr[0]);

				$scope.vm = vmObj;

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openAddToPensionWizard (pensionObj) {

		switch (pensionObj.PensionType) {
			case PENSION_TYPES.autoEnrolment:
				$rootScope.$broadcast('open-form-wizard', {
					contextType: 'user',
					showContext: true,
					activeStepIndex: 0,
					agencyProfileId: agencyProfileId,
					agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
					pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
					callback,
					userId: userId,
					wizardKey: FORM_WIZARD_KEYS.teamMemberEditAEPension
				});
				break;

			case PENSION_TYPES.nonAutoEnrolment:
				$rootScope.$broadcast('open-form-wizard', {
					contextType: 'user',
					showContext: true,
					activeStepIndex: 0,
					agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
					agencyProfileId: agencyProfileId,
					callback,
					userId: userId,
					wizardKey: FORM_WIZARD_KEYS.teamMemberEditNonAEPension
				});
				break;
		}
	}

	function openSlideInForm (pensionObj, formKey) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
			callback,
			contextType: 'user',
			userId: userId,
			formKey: formKey
		});
	}

	function setActivePayment (vmObj, paymentObj) {
		vmObj.activePayment = paymentObj;
	}

	function canShowPensionSettingsMenu () {

		if (!$scope.vm || !$scope.vm.activePayment || !$scope.vm.activePayment.PensionDetails) {
			return false;
		}

		const pensionDetails = $scope.vm.activePayment.PensionDetails;

		return $rootScope.currentUser.Permissions.Team.canUpdateTeamPensionSettings &&
			(pensionDetails.CanUpdatePensionStatus ||
			pensionDetails.CanUpdatePensionStatusFull ||
			pensionDetails.CanUpdatePensionBand ||
			pensionDetails.CanUpdatePensionGroup ||
			pensionDetails.CanUpdatePensionSetup ||
			pensionDetails.CanUpdatePensionContributions ||
			pensionDetails.CanUpdatePensionPostponement ||
			pensionDetails.CanAddToPension ||
			pensionDetails.CanRejoinPension);
	}

	function canShowPensionRemoveMenu () {

		if (!$scope.vm || !$scope.vm.activePayment || !$scope.vm.activePayment.PensionDetails) {
			return false;
		}

		const pensionDetails = $scope.vm.activePayment.PensionDetails;

		return pensionDetails.CanRemoveFromPension || pensionDetails.CanArchiveFromPension;
	}

	function canShowPensionActions () {

		if (!$scope.vm || !$scope.vm.activePayment || !$scope.vm.activePayment.PensionDetails) {
			return false;
		}

		const pensionDetails = $scope.vm.activePayment.PensionDetails;

		return !pensionDetails.PensionDeletedDateISO && (canShowPensionSettingsMenu() || canShowPensionRemoveMenu());
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PENSION_ENROLMENT_STATES,
		PENSION_TYPES,

		agencyProfileId,

		canShowPensionActions,
		canShowPensionRemoveMenu,
		canShowPensionSettingsMenu,
		openAddToPensionWizard,
		openSlideInForm,
		setActivePayment
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('profilePaymentsCtrl', ['$scope', '$stateParams', 'config', 'filterService', 'payrollData', 'searchService', function ($scope, $stateParams, config, filterService, payrollData, searchService) {

	var agencyProfileId = $stateParams.agencyProfileId;
	var from = moment().subtract(100, 'years').format(config.dateFormatPrimary);
	var to = moment().add(100, 'years').format(config.dateFormatPrimary);
	var userId = $stateParams.userId;

	function decoratePayments (paymentObj) {

		paymentObj.userPaymentDateDisplayUnix = moment(paymentObj.UserPaymentDateDisplay, config.dateFormatPrimary).unix();

		return paymentObj;
	}

	function init () {

		setPageState('loading');

		payrollData.getUserPaymentsForDateRange(userId, agencyProfileId, from, to).then(function (paymentsArray) {

			$scope.payments = paymentsArray.filter(decoratePayments);

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	// Scope variables
	$scope.agencyProfileId 	= agencyProfileId;
	$scope.searchBarOptions = searchService.profilePayments;
	$scope.userId = userId;
}]);

'use strict';

angular.module('paycircleApp')
.controller('profileDocumentsCtrl', [
	'$rootScope',
	'$timeout',
	'$scope',
	'$stateParams',
	'$window',
	'config',
	'documentsService',
	'filterService',
	'PAYROLL_MOVE_STATUSES',
	'searchService',
	'teamData',
	'UPLOADS_DOCUMENTS_FORMS',
	function (
		$rootScope,
		$timeout,
		$scope,
		$stateParams,
		$window,
		config,
		documentsService,
		filterService,
		PAYROLL_MOVE_STATUSES,
		searchService,
		teamData,
		UPLOADS_DOCUMENTS_FORMS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const archivedEmploymentId = $stateParams.archivedEmploymentId;
	const userId = $stateParams.userId;

	const teamMemberObj = $scope.teamMember; // From parent;

	const VIEW_MODES = {
		desktop: 'desktop',
		mobile: 'mobile'
	};

	function getDocumentsService () {

		if (teamMemberObj.isArchivedEmployment) {
			return teamData.getAllUserDocumentsForArchivedEmployment(userId, agencyProfileId, archivedEmploymentId);
		} else {
			return teamData.getAllUserDocuments(userId, agencyProfileId);
		}
	}

	function init () {

		setPageState('loading');

		getDocumentsService()
			.then(documentsArr => {

				$scope.documents = documentsService.getDecoratedDocuments(documentsArr);

				setPageState('ready');
			})
			.catch(onError);

		// On window resize, set the view mode accordingly.
		angular.element($window).on('resize', () => {
			setViewMode();
		});

		// Set initial view mode
		setViewMode();
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function openRegenerateDocumentsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'regenerate-documents',
			userId: userId
		});
	}

	function openUploadDocumentsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'user-documents',
			formState: UPLOADS_DOCUMENTS_FORMS.uploadFile,
			userId: userId
		});
	}

	function openPdfDownloadForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'user-downloads-document',
			title: 'Download documents',
			userIds: [userId],
			userId: userId
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setViewMode () {

		// Switch view mode if necessary. Do this in a timeout so the digest cycle runs on change.
		$timeout(() => {
			if ($window.innerWidth < config.screenPixelMaxWidths.tablet && $scope.viewMode !== VIEW_MODES.mobile) {
				$scope.viewMode = VIEW_MODES.mobile;
			}
			else if ($window.innerWidth >= config.screenPixelMaxWidths.tablet && $scope.viewMode !== VIEW_MODES.desktop) {
				$scope.viewMode = VIEW_MODES.desktop;
			}
		}, 0);
	}

	init();

	angular.extend($scope, {
		openRegenerateDocumentsForm,
		openUploadDocumentsForm,
		openPdfDownloadForm,
		refreshDocuments: init,

		filterBarOptions: filterService.profileDocuments,
		PAYROLL_MOVE_STATUSES,
		searchBarOptions: searchService.profileDocuments,
		VIEW_MODES
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('profileHolidayCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'agency', 'edpTopicService', 'filterService', 'holidaySicknessService', 'searchService', function ($q, $rootScope, $scope, $stateParams, agency, edpTopicService, filterService, holidaySicknessService, searchService) {

	var agencyProfileId = $stateParams.agencyProfileId;
	var userId = $stateParams.userId;

	$scope.isAddHolidayLeaveDisabled = true;
	$scope.isEdpHolidayTopicEnabled = false;

	function init () {

		setPageState('loading');
		$scope.isAddHolidayLeaveDisabled = true;

		$scope.isEdpHolidayTopicEnabled = false;

		const getHolidaySummary = agency.getHolidaySummary(agencyProfileId, userId);
		const getHolidayTopicEnabled = edpTopicService.isTopicEnabled(agencyProfileId, edpTopicService.TOPIC_KEYS.holiday);
		$q.all([getHolidaySummary, getHolidayTopicEnabled]).then(function (dataArr) {

			let holidayObj = dataArr[0];
			$scope.isEdpHolidayTopicEnabled = dataArr[1];
			$scope.isAddHolidayLeaveDisabled = false;

			if (holidayObj.Holidays.length === 0) {
				$rootScope.paycircleMessage('Unable to load holiday for user', 'error');
				setPageState('error');
				return;
			}

			$scope.userHoliday = holidaySicknessService.decorateHolidayDetails(holidayObj);

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			$scope.isAddHolidayLeaveDisabled = true;
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.agencyProfileId = agencyProfileId;
	$scope.filterBarOptions = filterService.profileHoliday;
	$scope.searchBarOptions = searchService.profileHoliday;

	$scope.openAddLeaveForm = function () {

		if ($scope.isAddHolidayLeaveDisabled) {
			return;
		}

		$rootScope.openSlideInForm({
			title: 'Add leave',
			agencyProfileId: agencyProfileId,
			userId: userId,
			callback: init,
			contextType: 'user',
			leaveType: 'holiday',
			formKey: 'add-leave'
		});
	};

	$scope.openEditHolidayPolicyForm = function () {

		$rootScope.openSlideInForm({
			title: 'Edit holiday policy',
			agencyProfileId: agencyProfileId,
			userId: userId,
			callback: init,
			contextType: 'user',
			formKey: 'edit-holiday-policy'
		});
	};

	$scope.loadHoliday = function () {

		init();
	};

}]);

'use strict';

angular.module('paycircleApp')
.controller('profileSicknessCtrl', ['$rootScope', '$scope', '$stateParams', 'agency', 'filterService', 'holidaySicknessService', 'searchService', function ($rootScope, $scope, $stateParams, agency, filterService, holidaySicknessService, searchService) {

	var agencyProfileId = $stateParams.agencyProfileId;
	var userId = $stateParams.userId;

	function loadSickness () {

		setPageState('loading');

		agency.getSicknessSummary(agencyProfileId, userId).then(function (sicknessObj) {

			$scope.summary = holidaySicknessService.decorateSicknessDetails(sicknessObj);
			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	loadSickness();

	$scope.agencyProfileId = agencyProfileId;
	$scope.filterBarOptions = filterService.profileSickness;
	$scope.searchBarOptions = searchService.profileSickness;

	$scope.openAddLeaveForm = function () {

		$rootScope.openSlideInForm({
			title: 'Add leave',
			agencyProfileId: agencyProfileId,
			userId: userId,
			callback: loadSickness,
			leaveType: 'sickness',
			contextType: 'user',
			formKey: 'add-leave'
		});
	};

	$scope.openEditSicknessPolicyForm = function () {

		$rootScope.openSlideInForm({
			title: 'Edit sickness policy',
			agencyProfileId: agencyProfileId,
			userId: userId,
			callback: loadSickness,
			contextType: 'user',
			formKey: 'edit-sickness-policy'
		});
	};

	$scope.loadSickness = function () {

		loadSickness();
	};

}]);

'use strict';

angular.module('paycircleApp')
.controller('profileHistoryCtrl', [
	'$scope',
	'$stateParams',
	'base',
	'filterService',
	'logService',
	'searchService',
	function (
		$scope,
		$stateParams,
		base,
		filterService,
		logService,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const archivedEmploymentId = $stateParams.archivedEmploymentId;
	const userId = $stateParams.userId;

	const teamMemberObj = $scope.teamMember; // From parent

	function getHistoryService () {

		if (teamMemberObj.isArchivedEmployment) {
			return base.getAgencyLogEntriesForArchivedEmployment(agencyProfileId, userId, archivedEmploymentId);
		} else {
			return base.getAgencyLogEntriesForLogCategoryList(agencyProfileId, userId);
		}
	}

	function init () {

		setPageState('loading');

		getHistoryService()
			.then(logEntriesArray => {

				if (!logEntriesArray.length) {
					setPageState('no-history');
					return;
				}

				$scope.logEntries = logService.decorateLogEntries(logEntriesArray);

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		filterBarOptions: filterService.profileHistory,
		searchBarOptions: searchService.profileHistory
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('profileAccountCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	function (
		$rootScope,
		$scope,
		$stateParams
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const teamMemberObj = $scope.teamMember; // From parent scope
	const userId = $stateParams.userId;

	function init () {

		setPageState('loading');

		$scope.vm = {
			loginDetails: {
				icon: 'padlock',
				title: 'Sign in',
				detailGroups: [
					{
						details: [
							{
								label: 'Username',
								value: teamMemberObj.Personal.Username
							},
							{
								emptyText: 'Not set',
								label: 'Recovery email address',
								value: teamMemberObj.Personal.EmailRecovery
							},
							{
								emptyText: 'Not set',
								label: 'Access account',
								value: teamMemberObj.AccountEmailAddress || ''
							}
						]
					},
					{
						details: [
							{
								type: 'buttons',
								buttons: [
									{
										label: 'Send password reset link',
										onClick: openSendPasswordResetLinkForm
									},
									{
										label: 'Send username retrieval link',
										onClick: openSendUsernameResetLinkForm
									}
								]
							}
						]
					},
				]
			}
		};

		setPageState('ready');
	}

	function openSendPasswordResetLinkForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'password-reset',
			userId
		});
	}

	function openSendUsernameResetLinkForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'username-retrieval',
			title: 'Send username retrieval link',
			userId
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		openSendPasswordResetLinkForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('profileSchedulesCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'filterService', 'scheduleService', 'searchService', 'teamData', 'UI_SCHEDULE_TYPES',
	function ($q, $rootScope, $scope, $stateParams, filterService, scheduleService, searchService, teamData, UI_SCHEDULE_TYPES) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const userId = $stateParams.userId;
	const teamMemberObj = $scope.teamMember; // From parent

	function init () {

		setPageState('loading');

		const getTeamMemberStatutoryPay = teamData.getTeamMemberStatutoryPay(userId, agencyProfileId);
		const getAttachmentOrderInformation = teamData.getAttachmentOrderInformation(userId, agencyProfileId);

		$q.all([
			getTeamMemberStatutoryPay,
			getAttachmentOrderInformation
		]).then(([
			statPayObj,
			aoeInfoObj
		]) => {

			angular.extend($scope, {
				statutoryPay: statPayObj,
				schedules: scheduleService.createNormalisedSchedules(statPayObj, aoeInfoObj),
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function openAttachmentOfEarningsViewForm (aoe) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-attachment-of-earnings',
			userId: userId,
			aoeId: aoe.AttachmentOrderID
		});
	}

	function openMaternityPayViewForm (maternityPay) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-maternity-pay',
			userId: userId,
			scheduleID: maternityPay.PaymentScheduleGroupID
		});
	}

	function openPaternityPayViewForm (paternityPay) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-paternity-pay',
			userId: userId,
			scheduleID: paternityPay.PaymentScheduleGroupID
		});
	}

	function openSickPayViewForm (sicknessPay) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'view-sick-pay',
			userId: userId,
			scheduleID: sicknessPay.PaymentScheduleGroupID
		});
	}

	function scheduleOnClick (scheduleObj) {

		switch (scheduleObj.type) {
			case UI_SCHEDULE_TYPES.attachmentOfEarnings: {
				openAttachmentOfEarningsViewForm(scheduleObj.aoe);
				break;
			}
			case UI_SCHEDULE_TYPES.covid19SickPay: {
				openSickPayViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.maternityPay: {
				openMaternityPayViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.paternityPay: {
				openPaternityPayViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.sickPay: {
				openSickPayViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.carBenefitInKind: {
				$scope.openCompanyVehicleViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.covid19SickPay: {
				openSickPayViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.childcareVouchers: {
				$scope.openChildcareVouchersForm(scheduleObj.PaymentScheduleGroupID);
				break;
			}
			case UI_SCHEDULE_TYPES.companyLoan: {
				$scope.openRepaymentScheduleForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.healthcare: {
				$scope.openHealthcareViewForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.cycleToWorkScheme: {
				$scope.openRepaymentScheduleForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.furlough: {
				$scope.openFurloughForm(teamMemberObj);
				break;
			}
			case UI_SCHEDULE_TYPES.seasonTicketLoan: {
				$scope.openRepaymentScheduleForm(scheduleObj);
				break;
			}
			case UI_SCHEDULE_TYPES.sharedParentalPay: {
				// ???
				break;
			}
		}
	}

	function scheduleOnUpdate () {

		init();
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		scheduleOnClick,
		scheduleOnUpdate,
		refreshSchedules: init,

		filterBarOptions: filterService.schedules,
		searchBarOptions: searchService.schedules
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('profileTaxStatusCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'filterService',
	'searchService',
	'taxUpdatesService',
	'userData',
	function (
		$rootScope,
		$scope,
		$stateParams,
		filterService,
		searchService,
		taxUpdatesService,
		userData
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const userId = $stateParams.userId;

	function init (refreshUser) {

		setPageState('loading');

		// From parent controller
		if (refreshUser) {
			$scope.refreshUser();
		}

		userData.getUserTaxUpdates(agencyProfileId, userId)
			.then((taxUpdatesArray) => {

				if (taxUpdatesArray.length === 0) {
					setPageState('no-history');
					return;
				}

				$scope.taxUpdates = taxUpdatesArray.map(taxUpdatesService.decorateTaxUpdateForProfile);

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function openAddTaxUpdateForm () {
		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: refreshTaxUpdates,
			contextType: 'user',
			formKey: 'add-tax-update',
			initCallbackOnClose: true,
			taxUpdates: $scope.taxUpdates,
			userId,
		});
	}

	function refreshTaxUpdates () {

		init(true);
	}

	function setPageState (newState) {

		$scope.pageState = newState;
	}

	init(false);

	angular.extend($scope, {
		filterBarOptions: filterService.taxUpdates,
		openAddTaxUpdateForm,
		refreshTaxUpdates,
		searchBarOptions: searchService.taxUpdates
	});
}]);

'use strict';

angular.module('paycircleApp')
.config([
	'$stateProvider',
	'POLICY_CATEGORIES',
function (
	$stateProvider,
	POLICY_CATEGORIES
) {

	const directory = 'features/app/hr/';
	const policiesDirectory = directory + 'policies/';
	const policiesTabsDirectory = policiesDirectory + 'tabs/';

	$stateProvider

	.state('hr', {
		abstract: true,
		url: '/hr/:agencyProfileId?applyfilter&presetfilterkey&page&search&search-filter',
		templateUrl: directory + 'hrView.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			permissions: [
				'isHRVisible'
			],
			title: 'HR'
		}
	})
		.state('hr.job-grades', {
			url: '',
			templateUrl: directory + 'job-grades/jobGradesView.html',
			reloadOnSearch: false,
			controller: 'jobGradesCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-job-grades']
				}
			}
		})

		.state('hr.policies', {
			abstract: true,
			url: '/policies',
			templateUrl: policiesDirectory + 'policiesView.html',
			controller: 'policiesCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-policies']
				}
			}
		})
			.state('hr.policies.holiday', {
				url: '',
				templateUrl: policiesTabsDirectory + 'policiesHolidayView.html',
				controller: 'policiesHolidayCtrl'
			})

			.state('hr.policies.sickness', {
				url: '/sickness',
				templateUrl: policiesTabsDirectory + 'policiesTabView.html',
				controller: 'policiesTabCtrl',
				data: {
					policyCategory: POLICY_CATEGORIES.sickness
				}
			})

			.state('hr.policies.parental', {
				data: {
					policyCategory: POLICY_CATEGORIES.parental
				},
				url: '/parental',
				templateUrl: policiesTabsDirectory + 'policiesTabView.html',
				controller: 'policiesTabCtrl'
			})

			.state('hr.policies.pension', {
				data: {
					policyCategory: POLICY_CATEGORIES.pension
				},
				url: '/pension',
				templateUrl: policiesTabsDirectory + 'policiesTabView.html',
				controller: 'policiesTabCtrl'
			})

			.state('hr.policies.pay', {
				data: {
					policyCategory: POLICY_CATEGORIES.pay
				},
				url: '/pay',
				templateUrl: policiesTabsDirectory + 'policiesTabView.html',
				controller: 'policiesTabCtrl'
			})

		.state('hr.holiday-sickness', {
			url: '/holiday-sickness',
			templateUrl: directory + 'holiday-sickness/holidaySicknessView.html',
			controller: 'holidaySicknessCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-holiday-and-sickness']
				}
			}
		})

		.state('hr.imports', {
			url: '/imports',
			templateUrl: directory + 'imports/hrImportsView.html',
			controller: 'hrImportsCtrl',
			data: {
				helpAndSupportOptions: {
					tags: ['company-policy-imports']
				}
			}
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('holidaySicknessCtrl', ['$q', '$rootScope', '$scope', '$stateParams', '$timeout', 'agency', 'config', 'edpTopicService', 'holidaySicknessService', 'growl', 'utilities', 'LEAVE_TYPE_DESCRIPTIONS', function ($q, $rootScope, $scope, $stateParams, $timeout, agency, config, edpTopicService, holidaySicknessService, growl, utilities, LEAVE_TYPE_DESCRIPTIONS) {

	const AGENCY_PROFILE_ID = $stateParams.agencyProfileId;
	const DATE_ID_FORMAT = 'MM-DD-YY';

    function addHalfDayFrom (leaveItemObj, teamMemberObj) {

    	holidaySicknessService.addHalfDayFrom(leaveItemObj);
    	updateLeave(leaveItemObj);
    	toggleMenu(leaveItemObj, teamMemberObj);
    }

    function addHalfDayTo (leaveItemObj, teamMemberObj) {

    	holidaySicknessService.addHalfDayTo(leaveItemObj);
    	updateLeave(leaveItemObj);
    	toggleMenu(leaveItemObj, teamMemberObj);
    }

	function changeDate (direction) {

		switch (direction) {
			case -1:
				$scope.HS.calendar.currentDate = $scope.HS.calendar.currentDate.subtract(1, 'M');
				setMonth();
				break;
			case 1:
				$scope.HS.calendar.currentDate = $scope.HS.calendar.currentDate.add(1, 'M');
				setMonth();
				break;
			default:
				$scope.HS.calendar.currentDate = moment();
				setMonth();
				break;
		}

		$timeout(function() {
			$scope.HS.calendar.scrollMonthIntoView(1);
		});
	}

	function createNewLeave (teamMemberObj, dayObj) {

		if (teamMemberObj.leaveDetails[dayObj.id] || !$scope.userCanManageTeamHR) {
			return;
		}

		// Add support for DST
		let dayISO = utilities.offsetDateForDST(moment(dayObj.id, DATE_ID_FORMAT));

		let newLeaveItemObj = {
		    day: dayObj.id,
		    forename: teamMemberObj.Name.split(' ')[0],
		    halfDayFrom: false,
		    halfDayTo: false,
		    startDateIso: dayISO,
		    leaveDays: 1,
		    theme: getLeaveTheme(-1),
		    endDateIso: dayISO,
		    userId: teamMemberObj.UserID,
		};

		if ($scope.HS.emptyLeave.length) {
		    delete $scope.HS.teamMembers[$scope.HS.emptyLeave[0]].leaveDetails[$scope.HS.emptyLeave[1]];
		}
		$scope.HS.emptyLeave = [teamMemberObj.id, dayObj.id];

		placeLeaveInCalendar(newLeaveItemObj, teamMemberObj, dayObj.id);
		toggleMenu(newLeaveItemObj, teamMemberObj);
	}

	function decorateLeaveItemsForTeamMember (teamMemberObj) {

		let teamMemberLeaveDefaultObj = {
			forename: teamMemberObj.Name.split(' ')[0],
			userId: teamMemberObj.UserID,
		};

		for (let teamMemberleaveItemObj of teamMemberObj.allLeaveDetails) {

			let leaveDetailsObj = getLeaveDetails(teamMemberleaveItemObj);
			angular.extend(leaveDetailsObj, teamMemberLeaveDefaultObj);

			placeLeaveInCalendar(leaveDetailsObj, teamMemberObj, leaveDetailsObj.day);
		}

		return teamMemberObj;
	}

	function decorateTeamLeaveDetails (holidayObj, sicknessObj) {

        return holidayObj.Holidays.reduce((teamMembersArr, teamMemberObj, teamMemberIndex) => {

            let teamMemberSicknessDetailsArr = sicknessObj.Sickness.find(teamMemberSicknessObj => teamMemberSicknessObj.UserID === teamMemberObj.UserID).SicknessDetails;

            angular.extend(teamMemberObj, {
                allLeaveDetails: teamMemberObj.HolidayDetails.concat(teamMemberSicknessDetailsArr),
                id: teamMemberIndex,
                leaveDetails: {},
                SicknessDetails: teamMemberSicknessDetailsArr,
            });

            decorateLeaveItemsForTeamMember(teamMemberObj);

            return teamMembersArr.concat(teamMemberObj);
        }, []);
    }

	function deleteAllFromTeamMembers () {

		if ($rootScope.userHasRole('paycircle') && window.confirm('This is a destructive action: Are you sure?')) {
			for (let teamMemberObj of $scope.HS.summary.holiday.Holidays) {
				for (let holidayObj of teamMemberObj.HolidayDetails) {
					agency.deleteHolidayDetail(holidayObj.UserAgencyProfileHolidayID).catch(onError);
				}
			}

			for (let teamMemberObj of $scope.HS.summary.sickness.Sickness) {
				for (let sicknessObj of teamMemberObj.SicknessDetails) {
					agency.deleteSicknessDetail(sicknessObj.UserAgencyProfileSicknessID).catch(onError);
				}
			}
		}
	}

	function deleteLeave (leaveItemObj, teamMemberObj) {

		if (isLeaveItemTypeHoliday(leaveItemObj.obj)) {

			if (leaveItemObj.obj.UserAgencyProfileHolidayID !== config.guidEmpty) {
				agency.deleteHolidayDetail(leaveItemObj.obj.UserAgencyProfileHolidayID).then(() => {

	                growl.success(`${leaveItemObj.leaveDays} day(s) holiday for ${teamMemberObj.Name} have been deleted.`);
					delete teamMemberObj.leaveDetails[leaveItemObj.day];
					updateSummary('holiday');
					$scope.HS.menuShown = [];
				})
				.catch(error => onDeleteError(error, leaveItemObj));
			}
		} else {

			if (leaveItemObj.obj.UserAgencyProfileSicknessID !== config.guidEmpty) {
				agency.deleteSicknessDetail(leaveItemObj.obj.UserAgencyProfileSicknessID).then(() => {

					growl.success(`${leaveItemObj.leaveDays} day(s) sickness leave for ${teamMemberObj.Name} have been deleted.`);
					delete teamMemberObj.leaveDetails[leaveItemObj.day];
					updateSummary('sickness');
					$scope.HS.menuShown = [];
				})
				.catch(onError);
			}
		}
	}

	function generateStats (holidayObj, sicknessObj) {

		if (holidayObj.AnnualLeaveDaysPreviousYear !== 0 && holidayObj.AnnualLeaveDaysPreviousYear !== holidayObj.AnnualLeaveDays) {
			holidayObj.holidayDiff = holidayObj.AnnualLeaveDaysPreviousYear > holidayObj.AnnualLeaveDays ? false : true;
			holidayObj.holidayDiffDisplay = Math.abs(holidayObj.AnnualLeaveDaysPreviousYear - holidayObj.AnnualLeaveDays);
		}
		if (sicknessObj.SickLeaveDaysPreviousYear !== 0 && sicknessObj.SickLeaveDaysPreviousYear !== sicknessObj.SickLeaveDays) {
			sicknessObj.sicknessDaysDiff = sicknessObj.SickLeaveDaysPreviousYear > sicknessObj.SickLeaveDays ? false : true;
			sicknessObj.sicknessDaysDiffDisplay = Math.abs(sicknessObj.SickLeaveDaysPreviousYear - sicknessObj.SickLeaveDays);
		}
		if (sicknessObj.AbsenceRatePreviousYear !== 0 && sicknessObj.AbsenceRatePreviousYear !== sicknessObj.AbsenceRate) {
			sicknessObj.absenceDiff = sicknessObj.AbsenceRatePreviousYear > sicknessObj.AbsenceRate ? false : true;
			sicknessObj.absenceDiffDisplay = Math.abs(sicknessObj.AbsenceRatePreviousYear - sicknessObj.AbsenceRate);
		}
		if (sicknessObj.MostAbsentDaysPreviousYear !== 0 && sicknessObj.MostAbsentDaysPreviousYear !== sicknessObj.MostAbsentDays) {
			sicknessObj.mostAbsenceDaysDiff = sicknessObj.MostAbsentDaysPreviousYear > sicknessObj.MostAbsentDays ? false : true;
			sicknessObj.mostAbsenceDaysDiffDisplay = Math.abs(sicknessObj.MostAbsentDaysPreviousYear - sicknessObj.MostAbsentDays);
		}
		if (sicknessObj.LeastAbsentDaysPreviousYear !== 0 && sicknessObj.LeastAbsentDaysPreviousYear !== sicknessObj.LeastAbsentDays) {
			sicknessObj.leastAbsenceDaysDiff = sicknessObj.LeastAbsentDaysPreviousYear > sicknessObj.LeastAbsentDays ? false : true;
			sicknessObj.leastAbsenceDaysDiffDisplay = Math.abs(sicknessObj.LeastAbsentDaysPreviousYear - sicknessObj.LeastAbsentDays);
		}

		$scope.HS.summary.holiday = holidayObj;
		$scope.HS.summary.sickness = sicknessObj;
	}

	function getDayID (fromDate) {
		return moment(fromDate).format(DATE_ID_FORMAT);
	}

	function getLeaveDetails (leaveItemObj) {

		let leaveDetailsObj;

		if (isLeaveItemTypeHoliday(leaveItemObj)) {

			let leaveDays = parseFloat(leaveItemObj.HolidayDays);

			leaveDetailsObj = {
				day: getDayID(leaveItemObj.HolidayDateFromISO),
				endDateIso: leaveItemObj.HolidayDateToISO,
				halfDayFrom: leaveItemObj.HolidayDateFromHalfDay,
				halfDayTo: leaveItemObj.HolidayDateToHalfDay,
				leaveDays: leaveDays,
				obj: leaveItemObj,
				startDateIso: leaveItemObj.HolidayDateFromISO,
				theme: getLeaveTheme(leaveItemObj.HolidayType),
			};

		} else {

			let leaveDays = parseFloat(leaveItemObj.SicknessDays);

			leaveDetailsObj = {
				day: getDayID(leaveItemObj.SicknessDateFromISO),
				endDateIso: leaveItemObj.SicknessDateToISO,
				halfDayFrom: leaveItemObj.SicknessDateFromHalfDay,
				halfDayTo: leaveItemObj.SicknessDateToHalfDay,
				leaveDays: leaveDays,
				obj: leaveItemObj,
				startDateIso: leaveItemObj.SicknessDateFromISO,
				// SicknessType is the SSP policy enum, not a leave category - all sickness entries are Sick Leave
				theme: getLeaveTheme(LEAVE_TYPE_DESCRIPTIONS.sickLeave),
			};
		}

		setLeaveIntegrationLock(leaveDetailsObj);

		return leaveDetailsObj;
	}

	function getLeaveTheme (typeId) {

		incrementLeaveTypeCounts($scope.HS.calendar.count, typeId);

		switch(typeId) {
			case LEAVE_TYPE_DESCRIPTIONS.annualLeave:
				return {
					class: 'secondary',
					display: 'Annual Leave',
					type: 'holiday',
					count: $scope.HS.calendar.count.annualLeave,
					id: LEAVE_TYPE_DESCRIPTIONS.annualLeave
				};
			case LEAVE_TYPE_DESCRIPTIONS.specialLeave:
				return {
					class: 'quarternary',
					display: 'Special Leave',
					type: 'holiday',
					count: $scope.HS.calendar.count.specialLeave,
					id: LEAVE_TYPE_DESCRIPTIONS.specialLeave
				};
			case LEAVE_TYPE_DESCRIPTIONS.sickLeave:
				return {
					class: 'assertive',
					display: 'Sick Leave',
					type: 'sickness',
					count: $scope.HS.calendar.count.sickLeave,
					id: LEAVE_TYPE_DESCRIPTIONS.sickLeave
				};
			case LEAVE_TYPE_DESCRIPTIONS.unpaidLeave:
				return {
					class: 'greyscale',
					display: 'Unpaid Leave',
					type: 'holiday',
					count: $scope.HS.calendar.count.unpaidLeave,
					id: LEAVE_TYPE_DESCRIPTIONS.unpaidLeave
				};
			default:
				return {
					class: 'primary',
					display: '',
					type: 'add'
				};
		}
	}

    function incrementLeaveTypeCounts (countObj, leaveTypeId) {

        switch(leaveTypeId) {
            case LEAVE_TYPE_DESCRIPTIONS.annualLeave:
                countObj.annualLeave++;
                break;
            case LEAVE_TYPE_DESCRIPTIONS.specialLeave:
                countObj.specialLeave++;
                break;
            case LEAVE_TYPE_DESCRIPTIONS.sickLeave:
                countObj.sickLeave++;
                break;
            case LEAVE_TYPE_DESCRIPTIONS.unpaidLeave:
                countObj.unpaidLeave++;
                break;
        }
    }

	function setLeaveIntegrationLock (leaveItemObj) {

		if (!leaveItemObj.theme || leaveItemObj.theme.type === 'add') {
			return;
		}

		if (leaveItemObj.theme.type === 'holiday') {
			const isIntegrationLocked = !!(leaveItemObj.obj && leaveItemObj.obj.IsFromIntegration);

			leaveItemObj.isIntegrationLocked = isIntegrationLocked;
			leaveItemObj.integrationMessage = isIntegrationLocked ? edpTopicService.getTopicMessage(edpTopicService.TOPIC_KEYS.holiday) : '';
		} else if (leaveItemObj.theme.type === 'sickness') {
			const isIntegrationLocked = !!(leaveItemObj.obj && leaveItemObj.obj.IsFromIntegration);

			leaveItemObj.isIntegrationLocked = isIntegrationLocked;
			leaveItemObj.integrationMessage = isIntegrationLocked ? edpTopicService.getTopicMessage(edpTopicService.TOPIC_KEYS.sickness) : '';
		}
	}

	function init () {

		setPageState('loading');

		$scope.HS = {
			calendar: {
				dayWidth: 69,
				halfDay: 0.5,
				currentDate: moment(),
				months: [],
				position: {},
				count: {
					unpaidLeave: 0,
					annualLeave: 0,
					specialLeave: 0,
					sickLeave: 0,
				},
				currentMonth: {},
				setCurrentMonth: monthObj => setCurrentMonth(monthObj)
			},
			summary: {},
			menuShown: [],
			tempLeave: [],
			emptyLeave: []
		};

		const getHolidaySummary = agency.getHolidaySummary(AGENCY_PROFILE_ID, config.guidEmpty);
		const getSicknessSummary = agency.getSicknessSummary(AGENCY_PROFILE_ID, config.guidEmpty);

		$q.all([getHolidaySummary, getSicknessSummary]).then(dataArr => {

			let holidayObj = dataArr[0];
			let sicknessObj = dataArr[1];

			generateStats(holidayObj, sicknessObj);

			$scope.HS.teamMembers = decorateTeamLeaveDetails(holidayObj, sicknessObj);

			if ($scope.HS.teamMembers.length > 0) {
				loadCalendar();
			} else {
				setPageState('ready');
			}
		})
		.catch(onError);
	}

    function isLeaveItemTypeHoliday (leaveItemObj) {
        return leaveItemObj.UserAgencyProfileHolidayID;
    }

	function loadCalendar () {

		setMonth();
		$scope.pageState = 'ready';

		$timeout(function() {
			$scope.HS.calendar.scrollMonthIntoView(1);
		});
	}

	function placeLeaveInCalendar (leaveItemObj, teamMemberObj, dayId) {

		angular.extend(leaveItemObj, {
			update: () => updateLeave(leaveItemObj),
			replace: () => replaceLeave(teamMemberObj, leaveItemObj)
		});

		if (teamMemberObj.leaveDetails[dayId]) {
			teamMemberObj.leaveDetails[dayId].push(leaveItemObj);
		} else {
			teamMemberObj.leaveDetails[dayId] = [leaveItemObj];
		}

		$timeout(function() {
			if (typeof leaveItemObj.checkMenuPosition === 'function' && !leaveItemObj.obj) {
				leaveItemObj.checkMenuPosition();
			}
		});
	}

	function onDeleteError (error, leaveItemObj) {
		if (error && error.status === 403) {
			leaveItemObj.isIntegrationLocked = true;
			leaveItemObj.integrationMessage = edpTopicService.getTopicMessage(edpTopicService.TOPIC_KEYS.holiday);
			return;
		}

		setPageState('error');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openHolidaySicknessForm (userId) {

		$rootScope.openSlideInForm({
			title: 'Holiday and sickness',
			agencyProfileId: AGENCY_PROFILE_ID,
			userId: userId,
			callback: init,
			contextType: 'user',
			formKey: 'holiday-sickness',
		});
	}

	function replaceLeave (teamMember, leave) {

		var dayId;
		var updatedLeave = angular.copy(leave);
		delete teamMember.leaveDetails[leave.day];

		if (updatedLeave.theme.id === LEAVE_TYPE_DESCRIPTIONS.sickLeave) {
			dayId = getDayID(leave.obj.SicknessDateFromISO);
		} else {
			dayId = getDayID(leave.obj.HolidayDateFromISO);
		}

		updatedLeave.day = dayId;
		placeLeaveInCalendar(updatedLeave, teamMember, dayId);
		updateLeaveLengths(leave.obj, teamMember);
		toggleMenu(updatedLeave, teamMember);
	}

	function saveNewLeave (leaveItemObj) {

	    const emptyLeaveDetailPromise = leaveItemObj.theme.id === LEAVE_TYPE_DESCRIPTIONS.sickLeave ? agency.getEmptySicknessDetail() : agency.getEmptyHolidayDetail();

	    emptyLeaveDetailPromise.then(emptyLeaveDetailObj => {

	        leaveItemObj.obj = emptyLeaveDetailObj;
	        updateLeave(leaveItemObj);
	    })
	    .catch(onError);
	}

	function setCurrentMonth (monthObj) {

		$timeout(function () {
			if ($scope.HS.calendar.currentMonth.monthDisplay !== monthObj.monthDisplay) {
				$scope.HS.calendar.currentMonth = monthObj;
				$scope.HS.calendar.currentDate = moment(monthObj.id, DATE_ID_FORMAT);
			}
		});
	}

	function setLeaveTypeForNewLeaveItem (teamMemberObj, leaveItemObj, typeId) {

	    $scope.HS.emptyLeave = [];
	    leaveItemObj.theme = getLeaveTheme(typeId);
	    setLeaveIntegrationLock(leaveItemObj);
	    toggleMenu(leaveItemObj, teamMemberObj);
	    saveNewLeave(leaveItemObj);
	}

	function setMonth () {

		const currentDate = angular.copy($scope.HS.calendar.currentDate);
		const startOfPeriodMoment = angular.copy(currentDate).subtract(1, 'M').startOf('month');
		const endOfPeriodMoment = currentDate.add(1, 'M').endOf('month').subtract(1, 'days');
		const monthsArr = [];

		for (let monthMoment = startOfPeriodMoment; monthMoment.diff(endOfPeriodMoment, 'months') <= 0; monthMoment.add(1, 'months')) {

			const startOfMonthMoment = angular.copy(monthMoment).startOf('month');
			const endOfMonthMoment = monthMoment.endOf('month').subtract(1, 'days');
			const daysArr = [];

			for (let dayMoment = startOfMonthMoment; dayMoment.diff(endOfMonthMoment, 'days') <= 0; dayMoment.add(1, 'days')) {
				daysArr.push({
					nameDisplay: dayMoment.format('dd'),
					date: dayMoment.format('D'),
					id: dayMoment.format(DATE_ID_FORMAT)
				});
			}

			monthsArr.push({
				days: daysArr,
				id: monthMoment.format(DATE_ID_FORMAT),
				monthDisplay: monthMoment.format('MMMM'),
				yearDisplay: monthMoment.format('Y'),
			});
		}

		angular.extend($scope.HS.calendar, {
			months: monthsArr,
			endOfPeriod: moment(monthsArr[2].id, DATE_ID_FORMAT).endOf('month'),
			startOfPeriod: moment(monthsArr[0].id, DATE_ID_FORMAT).startOf('month'),
		});

		if ($scope.HS.tempLeave.length) {
			for (let templeaveItemObj of $scope.HS.tempLeave) {
				delete $scope.HS.teamMembers[templeaveItemObj[0]].leaveDetails[templeaveItemObj[1]];
			}
		}

		$timeout(function() {
			$scope.HS.teamMembers.filter(updateTeamMemberLeaves);
		}, 100);
	}

	function setPageState (newState){
		$scope.pageState = newState;
	}

	function toggleMenu (leave, teamMember) {

		if (leave.showMenu) {
			leave.showMenu = false;
			$scope.HS.menuShown = [];
		} else {

			if ($scope.HS.menuShown.length) {
				if ($scope.HS.teamMembers[$scope.HS.menuShown[0]].leaveDetails[$scope.HS.menuShown[1]]) {
					if (!$scope.HS.teamMembers[$scope.HS.menuShown[0]].leaveDetails[$scope.HS.menuShown[1]][0].obj) {
						delete $scope.HS.teamMembers[$scope.HS.menuShown[0]].leaveDetails[$scope.HS.menuShown[1]];
						$scope.HS.menuShown = [];
					} else {
						$scope.HS.teamMembers[$scope.HS.menuShown[0]].leaveDetails[$scope.HS.menuShown[1]][0].showMenu = false;
					}
				}
			}
			leave.showMenu = true;
			$scope.HS.menuShown = [teamMember.id, leave.day];
		}
	}

	function updateLeave (leave) {

		var leaveStartDate = utilities.offsetDateForDST(leave.startDateIso);
		var leaveEndDate = utilities.offsetDateForDST(leave.endDateIso);

		if (leave.theme.id === LEAVE_TYPE_DESCRIPTIONS.sickLeave) {

			angular.extend(leave.obj, {
				SicknessDateFromHalfDay: leave.halfDayFrom,
				SicknessDateFromISO: leaveStartDate,
				SicknessDateToHalfDay: leave.halfDayTo,
				SicknessDateToISO: leaveEndDate,
				SicknessDays: leave.leaveDays,
				SicknessType: LEAVE_TYPE_DESCRIPTIONS.sickLeave,
			});

			agency.updateSicknessDetail(leave.userId, AGENCY_PROFILE_ID, leave.obj).then(newSicknessObj => {

				leave.obj = newSicknessObj;
				leave.replace();
				updateSummary('sickness');
				$rootScope.setDemoTaskAsComplete('addSickness', leave.forename);
			})
			.catch(onError);
		} else {

			angular.extend(leave.obj, {
				HolidayDateFromHalfDay: leave.halfDayFrom,
				HolidayDateFromISO: leaveStartDate,
				HolidayDateToHalfDay: leave.halfDayTo,
				HolidayDateToISO: leaveEndDate,
				HolidayDays: leave.leaveDays,
				HolidayType: leave.theme.id,
			});

			agency.updateHolidayDetail(leave.userId, AGENCY_PROFILE_ID, leave.obj).then(newHolidayObj => {

				leave.obj = newHolidayObj;
				leave.replace();
				updateSummary('holiday');
				$rootScope.setDemoTaskAsComplete('addHoliday', leave.forename);
				$rootScope.setDemoTaskAsComplete('editHoliday', leave.forename);
			})
			.catch(onError);
		}
	}

	function updateLeaveLengths (leaveItemObj, teamMember) {

	    const startOfPeriod = moment($scope.HS.calendar.startOfPeriod);
	    const endOfPeriod = moment($scope.HS.calendar.endOfPeriod);
	    const newDayId = getDayID(startOfPeriod.toISOString());

	    if (isLeaveItemTypeHoliday(leaveItemObj)) {
	        let toDate = moment(leaveItemObj.HolidayDateToISO);
	        let fromDate = moment(leaveItemObj.HolidayDateFromISO);
	        let dayId = getDayID(leaveItemObj.HolidayDateFromISO);
	        let teamMemberDayArr = teamMember.leaveDetails[dayId];

	        for (let i = 0; i < teamMemberDayArr.length; i++) {

	            if (toDate.isAfter(endOfPeriod)) {

	                let daysInBetween = toDate.diff(endOfPeriod, 'days')+1;

	                if (teamMemberDayArr[i].endDateIso === leaveItemObj.HolidayDateToISO) {
	                    teamMemberDayArr[i].sublength = teamMemberDayArr[i].leaveDays-daysInBetween;
	                    teamMemberDayArr[i].theme.layoutClass = 'leave-calendar__leave--gone-over';
	                }

	            } else if (toDate.isAfter(startOfPeriod) && fromDate.isBefore(startOfPeriod)) {

	                let daysInBetween = toDate.diff(startOfPeriod, 'days')+1;

	                if (teamMemberDayArr[i].endDateIso === leaveItemObj.HolidayDateToISO) {
	                    teamMemberDayArr[i].sublength = daysInBetween;
	                    teamMemberDayArr[i].theme.layoutClass = 'leave-calendar__leave--come-over';

	                    placeLeaveInCalendar(teamMemberDayArr[i], teamMember, newDayId);
	                    $scope.HS.tempLeave.push([teamMember.id, newDayId]);
	                }

	            } else {
	                teamMemberDayArr[i].theme.layoutClass = '';
	                teamMemberDayArr[i].sublength = null;
	            }
	        }

	    } else {
	        let toDate = moment(leaveItemObj.SicknessDateToISO);
	        let fromDate = moment(leaveItemObj.SicknessDateFromISO);
	        let leaveId = getDayID(leaveItemObj.SicknessDateFromISO);

	        for (let i = 0; i < teamMember.leaveDetails[leaveId].length; i++) {

	            if (toDate.isAfter(endOfPeriod)) {

	                let daysInBetween = toDate.diff(endOfPeriod, 'days')+1;

	                if (teamMember.leaveDetails[leaveId][i].endDateIso === leaveItemObj.SicknessDateToISO) {
	                    teamMember.leaveDetails[leaveId][i].sublength = teamMember.leaveDetails[leaveId][i].leaveDays-daysInBetween;
	                    teamMember.leaveDetails[leaveId][i].theme.layoutClass = 'leave-calendar__leave--gone-over';
	                }

	            } else if (toDate.isAfter(startOfPeriod) && fromDate.isBefore(startOfPeriod)) {

	                let daysInBetween = toDate.diff(startOfPeriod, 'days')+1;

	                if (teamMember.leaveDetails[leaveId][i].endDateIso === leaveItemObj.SicknessDateToISO) {
	                    teamMember.leaveDetails[leaveId][i].sublength = daysInBetween;
	                    teamMember.leaveDetails[leaveId][i].theme.layoutClass = 'leave-calendar__leave--come-over';
	                    placeLeaveInCalendar(teamMember.leaveDetails[leaveId][i], teamMember, newDayId);
	                    $scope.HS.tempLeave.push([teamMember.id, newDayId]);
	                }
	            } else {

	                teamMember.leaveDetails[leaveId][i].theme.layoutClass = '';
	                teamMember.leaveDetails[leaveId][i].sublength = null;
	            }
	        }
	    }
	}

	function updateSummary (which) {

	    switch (which) {

	        case 'holiday':
	            agency.getHolidaySummary(AGENCY_PROFILE_ID, config.guidEmpty).then(newHolidaySummaryObj => {
	                generateStats(newHolidaySummaryObj, $scope.HS.summary.sickness);
	            })
	            .catch(onError);
	            break;

	        case 'sickness':
	            agency.getSicknessSummary(AGENCY_PROFILE_ID, config.guidEmpty).then(newSicknessSummaryObj => {
	                generateStats($scope.HS.summary.holiday, newSicknessSummaryObj);
	            })
	            .catch(onError);
	            break;
	    }
	}

	function updateTeamMemberLeaves (teamMemberObj) {

		for (let leaveItemObj of teamMemberObj.allLeaveDetails) {
			updateLeaveLengths(leaveItemObj, teamMemberObj);
		}

		return teamMemberObj;
	}

	init();

	angular.extend($scope, {
		AGENCY_PROFILE_ID,
		LEAVE_TYPE_DESCRIPTIONS,

		userCanManageTeamHR: $rootScope.currentUser.Permissions.HR.canManageTeamHR,

		changeDate,
		createNewLeave,
		addHalfDayFrom,
		addHalfDayTo,
		deleteAllFromTeamMembers,
		deleteLeave,
		openHolidaySicknessForm,
		setLeaveTypeForNewLeaveItem,
		toggleMenu
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('jobGradesCtrl', ['$rootScope', '$scope', '$stateParams', 'bulkService', 'companyData', 'searchService', 'SEARCH_BAR_ACTIONS', function ($rootScope, $scope, $stateParams, bulkService, companyData, searchService, SEARCH_BAR_ACTIONS) {

	const agencyProfileId = $stateParams.agencyProfileId;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function addJobGrade (jobGradesArr) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'update-job-grade',
			jobGrades: jobGradesArr || [],
			title: 'Add job grade'
		});
	}

	function init () {
		setPageState(PAGE_STATES.loading);

		companyData.getPolicyGrades(agencyProfileId).then(policyGradesArr => {

			// Do some stuff here with the array
			angular.extend($scope.vm, {
				jobGrades: bulkService.getBulkItemsObj(policyGradesArr),
			});
			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function refresh () {
		init();
	}

	function searchBarActionSelected (searchBarActionKey) {
		if (searchBarActionKey === SEARCH_BAR_ACTIONS.jobGrades.addJobGrade) {
			addJobGrade($scope.vm.jobGrades.all);
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		agencyProfileId,
		vm: {
			searchBarOptions: searchService.jobGrades
		},

		addJobGrade,
		refresh,
		searchBarActionSelected
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('policiesCtrl', ['$scope', '$stateParams', 'USER_ROLES', function ($scope, $stateParams, USER_ROLES) {

	// From parent
	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {
		setPageState('ready');

		$scope.vm = {
			agencyProfileId
		};
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		USER_ROLES
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('policiesHolidayCtrl', ['$q', '$rootScope', '$scope', '$stateParams', '$timeout', 'agency', 'config', function ($q, $rootScope, $scope, $stateParams, $timeout, agency, config) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		agency.getHolidayPolicies(agencyProfileId).then(holidayPoliciesArr => {

			// Use first holiday policy to check for setup
			const holidayPolicy = holidayPoliciesArr[0];

			if (holidayPolicy.HolidayPolicyID === config.guidEmpty) {
				setPageState('holiday-policy-not-setup');
			}
			else {
				populateDetails(holidayPoliciesArr);
				setPageState('ready');
			}
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function openHolidayForm (holidayPolicyObj) {

		const isExistingHolidayPolicy = angular.isDefined(holidayPolicyObj);

		$scope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			holidayPolicyId: isExistingHolidayPolicy ? holidayPolicyObj.HolidayPolicyID : undefined,
			title: isExistingHolidayPolicy ? 'Holiday policy' : 'New holiday policy',
			callback: isExistingHolidayPolicy ? init : updateHrActive,
			contextType: 'company',
			formKey: 'company-settings-holiday-policy'
		});
	}

	function populateDetails (holidayPoliciesArr) {

		let holidayDetailsBlock = {
			icon: 'holiday',
			title: 'Holiday',
			theme: 'quarternary stacked',
			detailGroups: []
		};

		holidayPoliciesArr.forEach(holidayPolicy => {
			const holidayDetailBlock = {
				editAction: () => openHolidayForm(holidayPolicy),
				details: [
					{
						label: holidayPolicy.HolidayPolicyName,
						value: holidayPolicy.HolidayPolicyDescription
					}
				]
			};
			holidayDetailsBlock.detailGroups.push(holidayDetailBlock);
		});

		$scope.vm = {
			holidayDetailsBlock
		};
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateHrActive () {

		init();
		$rootScope.currentCompany.HasHR = true;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,

		openHolidayForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('policiesTabCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'bulkService',
	'filterService',
	'policyService',
	'searchService',
	'POLICY_CATEGORIES',
	'DOCUMENT_TYPES',
	'SEARCH_BAR_ACTIONS',
	'UPDATE_POLICY_MODES',
function (
	$rootScope,
	$scope,
	$state,
	$stateParams,
	bulkService,
	filterService,
	policyService,
	searchService,
	POLICY_CATEGORIES,
	DOCUMENT_TYPES,
	SEARCH_BAR_ACTIONS,
	UPDATE_POLICY_MODES
) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const policyCategory = $state.current.data.policyCategory;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function openUpdatePolicyForm (vmObj, updatePolicyMode) {

		if (updatePolicyMode === UPDATE_POLICY_MODES.import) {
			// Skip the wizard entirely — go straight to file upload
			$state.go('data-importer.upload-file', {
				agencyDocumentType: DOCUMENT_TYPES.policyImport,
				agencyProfileId: agencyProfileId
			});
			return;
		}

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'update-policy',
			policyCategory,
			policies: vmObj.policies.all,
			title: `Add ${policyCategory} policy`,
			updatePolicyMode: updatePolicyMode
		});
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		// Get legacy policies to include in the list. Only applicable for sickness, won't do any harm otherwise.
		const INCLUDE_LEGACY_POLICIES = true;

		policyService.getPoliciesForCategory(agencyProfileId, policyCategory, INCLUDE_LEGACY_POLICIES).then(policiesArr => {

			$scope.vm = {
				policies: bulkService.getBulkItemsObj(policiesArr),
				policyCategory,
				searchBarOptions: searchService.policies
			};

			// Filter for pay policies only
			if (policyCategory === POLICY_CATEGORIES.pay) {
				$scope.vm.filterBarOptions = filterService.payPolicies;
			}

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function refresh () {
		init();
	}

	function searchBarActionSelected (searchBarActionKey) {
		if (searchBarActionKey === SEARCH_BAR_ACTIONS.policies.addPolicy) {
			openUpdatePolicyForm($scope.vm, UPDATE_POLICY_MODES.create);
		}
	}


	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		agencyProfileId,

		PAGE_STATES,
		POLICY_CATEGORIES,
		UPDATE_POLICY_MODES,

		addPolicy: openUpdatePolicyForm,
		refresh,
		searchBarActionSelected
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('hrImportsCtrl', [
	'$scope',
	'$stateParams',
	'config',
	'dataImport',
	'importService',
	'payrollData',
	'searchService',
	'IMPORT_MAPPING_TYPES',
	function (
		$scope,
		$stateParams,
		config,
		dataImport,
		importService,
		payrollData,
		searchService,
		IMPORT_MAPPING_TYPES
	) {

	const INCLUDE_DELETED = true;
	const TEAM_IMPORTS = false;
	const PERIOD_IMPORTS = false;
	const IMPORT_TYPE = IMPORT_MAPPING_TYPES.policyImport;

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodMinimum(agencyProfileId).then(function (payPeriodObj) {

			const PAY_PERIOD_ID = config.guidEmpty;

			dataImport.getUserImportGroups(agencyProfileId, PAY_PERIOD_ID, INCLUDE_DELETED, TEAM_IMPORTS, PERIOD_IMPORTS, IMPORT_TYPE).then(function (importGroupsArr) {

				$scope.vm = {
					importGroups: importGroupsArr.filter(importService.decorateImportGroup),
					importGroupsFiltered: [],
					payPeriod: payPeriodObj,
					searchBarOptions: searchService.currentPeriodImports
				};

				setPageState('ready');
			})
			.catch(function (error) {
				console.error(error);
				setPageState('error');
			});
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		refreshPage: init,
		agencyProfileId
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/data-importer/';

	$stateProvider

	.state('data-importer', {
		url: '/data-importer/:agencyProfileId?backState',
		templateUrl: directory + 'data-importer.view.html',
		data: {
		    fullPage: true,
		    title: 'Importer'
		},
		params: {
			endOnValidate: false
		},
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	})
		.state('data-importer.my-files', {
			url: '/my-files/:agencyDocumentType',
			templateUrl: directory + 'my-files/data-importer-my-files.view.html',
			controller: 'dataImporterMyFilesCtrl'
		})
		.state('data-importer.upload-file', {
			url: '/upload-file/:agencyDocumentType/:payPeriodId?from&importMappingData',
			templateUrl: directory + 'upload-file/data-importer-upload-file.view.html',
			controller: 'dataImporterUploadFileCtrl'
		})
		.state('data-importer.validate-file', {
			url: '/validate-file/:payPeriodId/:agencyDocumentId/:agencyDocumentType/:importMappingType?importMappingTemplateId?layoutType',
			templateUrl: directory + 'validate-file/data-importer-validate-file.view.html',
			controller: 'dataImporterValidateFileCtrl'
		})
		.state('data-importer.select-import-type', {
			url: '/select-import-type/:payPeriodId/:agencyDocumentId/:agencyDocumentType?layoutType',
			templateUrl: directory + 'select-import-type/data-importer-select-import-type.view.html',
			controller: 'dataImporterSelectImportTypeCtrl'
		})
		.state('data-importer.select-import-file-type', {
			url: '/select-import-file-type/:agencyDocumentType',
			templateUrl: directory + 'select-import-file-type/data-importer-select-import-file-type.view.html',
			controller: 'dataImporterSelectImportFileTypeCtrl'
		})
		.state('data-importer.select-import-file-type-bcat', {
			url: '/select-import-file-type-bcat/:agencyDocumentType',
			templateUrl: directory + 'select-import-file-type-bcat/data-importer-select-import-file-type-bcat.view.html',
			controller: 'dataImporterSelectImportFileTypeBcatCtrl'
		})
		.state('data-importer.select-import-file-type-xero', {
			url: '/select-import-file-type-xero/:agencyDocumentType',
			templateUrl: directory + 'select-import-file-type-xero/data-importer-select-import-file-type-xero.view.html',
			controller: 'dataImporterSelectImportFileTypeXeroCtrl'
		})
		.state('data-importer.select-mapping-type', {
			url: '/select-mapping-type/:agencyDocumentId',
			templateUrl: directory + 'select-mapping-type/data-importer-select-mapping-type.view.html',
			controller: 'dataImporterSelectMappingTypeCtrl'
		})
		.state('data-importer.import-data', {
			url: '/import-data/:payPeriodId/:agencyDocumentId/:agencyDocumentType/:importMappingType?importMappingTemplateId?layoutType&importMappingData',
			templateUrl: directory + 'import-data/data-importer-import-data.view.html',
			controller: 'dataImporterValidateFileCtrl'
		})
		.state('data-importer.validate-xml-file', {
			url: '/validate-xml-file/:payPeriodId/:agencyDocumentId/:agencyDocumentType/:importMappingType?importMappingTemplateId?layoutType',
			templateUrl: directory + 'validate-xml-file/data-importer-validate-xml-file.view.html',
			controller: 'dataImporterValidateXMLFileCtrl'
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterMyFilesCtrl', ['$filter', '$rootScope', '$scope', '$stateParams', 'base', 'growl', 'importService', 'payrollData', 'DOCUMENT_STATES', 'DOCUMENT_TYPES',
	function ($filter, $rootScope, $scope, $stateParams, base, growl, importService, payrollData, DOCUMENT_STATES, DOCUMENT_TYPES) {

	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;
	const backState = $stateParams.backState;

	function onDeleteDocument (documentsArray, documentObj, documentIndex) {

		documentsArray.splice(documentIndex, 1);

		growl.success(documentObj.DocumentName + ' has been deleted');
	}

	function filterAgencyDocumentsNotValidated (documentObj) {
		return documentObj.DocumentState === DOCUMENT_STATES.unchecked;
	}

	function filterAgencyDocumentsValidated (documentObj) {
		return documentObj.DocumentState === DOCUMENT_STATES.checked;
	}

	function init () {

		if (!isStateValid()) {
			setPageState('error');
			return;
		}

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then((payPeriodObj) => {
			loadDataImports(payPeriodObj);
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function isStateValid () {

		if (isNaN(agencyDocumentType)) {
			$rootScope.paycircleMessage('dataImporterMyFilesCtrl: No agency document type defined', 'error');
			return false;
		}

		if (angular.isUndefined(agencyProfileId)) {
			$rootScope.paycircleMessage('dataImporterMyFilesCtrl: No agency profile id defined', 'error');
			return false;
		}

		return true;
	}
	function loadDataImports (payPeriodObj) {

		base.getAgencyDocumentsForType(agencyProfileId, agencyDocumentType).then((agencyDocumentsArray) => {

			const showDocumentStateIcon = true;
			agencyDocumentsArray = agencyDocumentsArray.filter(importService.decorateDocumentUploads(agencyDocumentType, showDocumentStateIcon));

			$scope.vm = {
				agencyDocuments: agencyDocumentsArray,
				agencyDocumentsNotValidated: agencyDocumentsArray.filter(filterAgencyDocumentsNotValidated),
				agencyDocumentsValidated: agencyDocumentsArray.filter(filterAgencyDocumentsValidated),
				currentPayPeriod: payPeriodObj
			};

			// Not team type and no complete team members
			if (agencyDocumentType !== DOCUMENT_TYPES.teamImport && payPeriodObj.NumberOfCompleteTeamMembers === 0) {
				setPageState('no-team-members');
				return;
			}

			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		DOCUMENT_TYPES,
		agencyDocumentType,
		agencyProfileId,
		backNgHref: importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId, backState),
		defaultImportMappingType: importService.getImportMappingTypeForAgencyDocumentType(agencyDocumentType),
		onDeleteDocument
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('dataImporterSelectImportFileTypeCtrl', [
	'$scope',
	'$stateParams',
	'base',
	'dataImport',
	'dataTransfer',
	'growl',
	'importService',
	'DOCUMENT_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		$scope,
		$stateParams,
		base,
		dataImport,
		dataTransfer,
		growl,
		importService,
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId);

	function init () {

		setPageState('loading');

		dataImport.getImportMappingColumns2(agencyProfileId, IMPORT_MAPPING_TYPES.all).then((importMappingColumnsArr) => {

			base.getAgencyDocumentsForType(agencyProfileId, agencyDocumentType).then((agencyDocumentsArray) => {

				$scope.vm = {
					DOCUMENT_TYPES,
					agencyDocumentType,
					agencyDocuments: agencyDocumentsArray,
					agencyProfileId,
					backNgHref,
					importMappingColumns: importMappingColumnsArr
				};

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function downloadImportTemplate () {

		const filename = 'ImportTemplate.csv';

		// Generate CSV content from import mapping columns
		const csvContent = $scope.vm.importMappingColumns.map(column => column.ImportMappingColumnText).join(',') + '\n';

		growl.success('Downloading file…');

		dataTransfer.downloadBlob(csvContent, filename);
	}

	$scope.downloadImportTemplate = function () {

		downloadImportTemplate();
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterSelectImportFileTypeBcatCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'config',
	'importService',
	'payrollData',
	'reportData',
	'ACCOUNTING_INTEGRATION_TYPES',
	'DOCUMENT_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		config,
		importService,
		payrollData,
		reportData,
		ACCOUNTING_INTEGRATION_TYPES,
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId);

	function init () {

		setPageState('loading');

		const getAccountingIntegrationConnection = reportData.getAccountingIntegrationConnection(agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([
			getPayPeriodCurrent,
			getAccountingIntegrationConnection
		]).then(([
			payPeriodObj,
			accountingIntegrationConnectionObj
		]) => {
			
			$scope.vm = {
				ACCOUNTING_INTEGRATION_TYPES,
				DOCUMENT_TYPES,
				IMPORT_MAPPING_TYPES,
				agencyDocumentId: config.guidEmpty,
				agencyProfileId,
				backNgHref,
				payPeriod: payPeriodObj,
				payPeriodId: config.guidEmpty,
				accountingIntegrationConnection: accountingIntegrationConnectionObj
			};

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterSelectImportFileTypeXeroCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'config',
	'importService',
	'payrollData',
	'reportData',
	'ACCOUNTING_INTEGRATION_TYPES',
	'DOCUMENT_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		config,
		importService,
		payrollData,
		reportData,
		ACCOUNTING_INTEGRATION_TYPES,
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId);

	function init () {

		setPageState('loading');

		const getAccountingIntegrationConnection = reportData.getAccountingIntegrationConnection(agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([
			getPayPeriodCurrent,
			getAccountingIntegrationConnection
		]).then(([
			payPeriodObj,
			accountingIntegrationConnectionObj
		]) => {
			
			$scope.vm = {
				ACCOUNTING_INTEGRATION_TYPES,
				DOCUMENT_TYPES,
				IMPORT_MAPPING_TYPES,
				agencyDocumentId: config.guidEmpty,
				agencyProfileId,
				backNgHref,
				payPeriod: payPeriodObj,
				payPeriodId: config.guidEmpty,
				accountingIntegrationConnection: accountingIntegrationConnectionObj
			};

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterSelectImportTypeCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'agency', 'base', 'companyData', 'importService', 'payrollData', 'DOCUMENT_TYPES', 'IMPORT_MAPPING_TYPES', 'INTERFACE_TYPES', 'POLICY_TYPES', function ($q, $rootScope, $scope, $stateParams, agency, base, companyData, importService, payrollData, DOCUMENT_TYPES, IMPORT_MAPPING_TYPES, INTERFACE_TYPES, POLICY_TYPES) {

	const IS_BUREAU_MAPPING = $rootScope.currentCompany.CompanyType === INTERFACE_TYPES.bureau;
	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyDocumentId = $stateParams.agencyDocumentId;
	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const backState = $stateParams.backState;
	const currentCompany = $rootScope.currentCompany;
	const layoutType = $stateParams.layoutType;
	const payPeriodId = $stateParams.payPeriodId;

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId, backState);
	const isCISActive = importService.getIsCISActiveForCompany(currentCompany);
	const isExpatsActive = importService.getIsExpatsActiveForCompany(currentCompany);
	const isPensionActive = importService.getIsPensionActiveForCompany(currentCompany);
	const hasHRModule = importService.getIsHrActiveForCompany(currentCompany);

	function init () {

		setPageState('loading');

		const getAgencyProfileImportOrientationVertical = agency.getAgencyProfileImportOrientationVertical(agencyProfileId);
		const getCompanyDocument = base.getCompanyDocument(agencyDocumentId);
		// IMPORT_ABSENCES_SICKNESS feature
		const getIsImportSicknessEnabled = base.isFeatureEnabled(agencyProfileId, 'IMPORT_ABSENCES_SICKNESS');
		// Only needed to gate the Posts & pay policies card, which requires both the HR module and at least one pay policy.
		const getPayPolicies = hasHRModule ? companyData.getPolicies(agencyProfileId, POLICY_TYPES.pay) : null;
		const getPayPeriodCurrent = IS_BUREAU_MAPPING || agencyDocumentType !== DOCUMENT_TYPES.teamImport ? null : payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([getCompanyDocument, getAgencyProfileImportOrientationVertical, getIsImportSicknessEnabled, getPayPolicies, getPayPeriodCurrent]).then(dataArr => {

			const documentObj = dataArr[0];
			const companyLayoutTypeIsVertical = dataArr[1];
			const isImportSicknessEnabled = dataArr[2];
			const hasPayPolicies = (dataArr[3] || []).length !== 0;
			const payPeriodCurrentObj = dataArr[4];
			const isVertical = importService.getIsVerticalLayout(companyLayoutTypeIsVertical, layoutType);
			const dataImportTypes = importService.getMappingOptionsForDocumentType(agencyDocumentType, isVertical, isCISActive, isExpatsActive, isPensionActive, isImportSicknessEnabled, hasHRModule, hasPayPolicies);

			return importService.filterImportMappingTypesByFeature(agencyProfileId, dataImportTypes).then(enabledDataImportTypes => {

				enabledDataImportTypes.forEach(dataImportType => {
					dataImportType.isUnavailable = payPeriodCurrentObj && payPeriodCurrentObj.IsPayrollLocked && dataImportType.availableWhenPayrollCalculated === false;
				});

				$scope.vm = {
					agencyDocumentId,
					agencyDocumentType,
					agencyProfileId,
					dataImportTypes: enabledDataImportTypes,
					document: documentObj,
					isVertical,
					layoutType,
					payPeriodId
				};

				setPageState('ready');
			});
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES,
		INTERFACE_TYPES,
		IS_BUREAU_MAPPING,
		backNgHref
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterSelectMappingTypeCtrl', ['$scope', '$stateParams', 'importService', 'IMPORT_MAPPING_TYPES', function ($scope, $stateParams, importService, IMPORT_MAPPING_TYPES) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyDocumentId = $stateParams.agencyDocumentId;

	angular.extend($scope, {
		IMPORT_MAPPING_TYPES,
		agencyDocumentId,
		agencyProfileId,
		mappingTypes: importService.getMappingTypes()
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterUploadFileCtrl', [
	'$q',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'agency',
	'dataImport',
	'dataTransfer',
	'growl',
	'importService',
	'libraries',
	'payrollData',
	'payrollWorker',
	'utilities',
	'DOCUMENT_TYPES',
	'FILE_TYPES',
	'IMPORT_MAPPING_TYPES',
	'IMPORT_TYPES',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'VALIDATION_FIELD_TYPES',
	function (
		$q,
		$scope,
		$state,
		$stateParams,
		$timeout,
		agency,
		dataImport,
		dataTransfer,
		growl,
		importService,
		libraries,
		payrollData,
		payrollWorker,
		utilities,
		DOCUMENT_TYPES,
		FILE_TYPES,
		IMPORT_MAPPING_TYPES,
		IMPORT_TYPES,
		STATE_TYPES,
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES
	) {

	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;
	const statePeriodId = $stateParams.payPeriodId;
	const importMappingData = $stateParams.importMappingData;
	const from = $stateParams.from;

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId);
	const documentTypeId = importService.getDocumentTypeIdForAgencyDocumentType(agencyDocumentType);
	const fileTypeAcceptOption = importService.getFileTypeAcceptForDocumentType(agencyDocumentType);

	function getImportMappingTypeForDocumentType (agencyDocumentType) {

		switch (agencyDocumentType) {
			case DOCUMENT_TYPES.nominalCodes:
			case DOCUMENT_TYPES.xeroNominalCodes:
			case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
				return IMPORT_MAPPING_TYPES.nominalCodes;
			case DOCUMENT_TYPES.businessCategories:
			case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
				return IMPORT_MAPPING_TYPES.businessCategories;
			case DOCUMENT_TYPES.payslipManagerFullRun:
			case DOCUMENT_TYPES.payslipManagerSupplementaryRun:
				return IMPORT_MAPPING_TYPES.payslipManager;
			case DOCUMENT_TYPES.periodImport:
				return IMPORT_MAPPING_TYPES.users;
			case DOCUMENT_TYPES.teamImport:
				return IMPORT_MAPPING_TYPES.team;
			case DOCUMENT_TYPES.policyImport:
				return IMPORT_MAPPING_TYPES.policyImport;
		}
	}

	function getPayPeriodForImporter () {

		if (statePeriodId) {
			return payrollData.getPayPeriodSpecific(statePeriodId);
		} else {
			return payrollData.getPayPeriodCurrent(agencyProfileId);
		}
	}

	function init () {

		setPageState('loading');

		getPayPeriodForImporter().then((currentPayPeriodObj) => {

			currentPayPeriodObj.dataImportState = SUBMISSION_STATES.unsubmitted;

			$scope.currentPayPeriod = currentPayPeriodObj;

			setupImporter(currentPayPeriodObj);
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function resetImporter (payPeriodObj) {

		payPeriodObj.dataImportState = 0;

		angular.extend($scope, {
			uploadFilename: null,
			uploadingProgress: 0
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setupImporter (payPeriodObj) {

		var payPeriodId = utilities.isEmptyGuid(statePeriodId) ? statePeriodId : payPeriodObj.PayPeriodID;

		// Set up the uploader for the import
		var uploader = $scope.uploader = dataTransfer.getNewFileUploader({
			formData: [{
				agencyPayPeriodId: payPeriodId,
				agencyProfileId,
				documentTypeId
			}],
			url: libraries.httpHandler.upload.importFile,
			queueLimit: 1,
			onAfterAddingFile: (fileItem) => {

				$scope.uploadFilename = fileItem.file.name;

				payPeriodObj.dataImportState = SUBMISSION_STATES.submitting;

				uploader.uploadAll();
			},
			onProgressItem: (fileItem, progress) => {

				$scope.uploadingProgress = progress;
			},

			onSuccessItem: (item, fileUploadArr) => {

				// If file upload is unsuccessful (file size too bug/contains virus)
				if (fileUploadArr.length === 0) {
					uploader.clearQueue();
					payPeriodObj.dataImportState = SUBMISSION_STATES.failed;
					return;
				}

				$timeout(() => {

					switch (agencyDocumentType) {

						case DOCUMENT_TYPES.businessCategories:
						case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
						case DOCUMENT_TYPES.nominalCodes:
						case DOCUMENT_TYPES.xeroNominalCodes:
						case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
						case DOCUMENT_TYPES.policyImport:

							// Import data
							$state.go('data-importer.import-data', {
								agencyDocumentId: fileUploadArr[0],
								agencyDocumentType: agencyDocumentType,
								agencyProfileId: agencyProfileId,
								importMappingData,
								importMappingType: getImportMappingTypeForDocumentType(agencyDocumentType),
								payPeriodId: payPeriodId,
							});

							break;

						case DOCUMENT_TYPES.payslipManagerFullRun:

							// Import data
							$state.go('data-importer.validate-xml-file', {
								agencyDocumentId: fileUploadArr[0],
								agencyDocumentType: agencyDocumentType,
								agencyProfileId: agencyProfileId,
								importMappingType: getImportMappingTypeForDocumentType(agencyDocumentType),
								payPeriodId: payPeriodId
							});

							break;

						// Bureau mapping template > Different flow
						case DOCUMENT_TYPES.bureauMappingTemplate:

							// Select mapping type
							$state.go('data-importer.select-mapping-type', {
								agencyDocumentId: fileUploadArr[0],
								agencyProfileId
							});

							break;

						default:

							// Validate file
							$state.go('data-importer.validate-file', {
								agencyDocumentId: fileUploadArr[0],
								agencyDocumentType: agencyDocumentType,
								agencyProfileId: agencyProfileId,
								importMappingType: getImportMappingTypeForDocumentType(agencyDocumentType),
								payPeriodId: payPeriodId
							});
					}

				}, 2000);
			},
			onCompleteAll: () => {
				uploader.clearQueue();
			},
			onWhenAddingFileFailed: (item, filter) => {

				uploader.clearQueue();

				switch (filter.name) {
					case 'validateNumberOfColumns':
						payPeriodObj.dataImportState = -2;
						break;
					case 'validateFileType':
						payPeriodObj.dataImportState = -1;
						break;
				}
			}
		});

		// Validate file type is correct type
		uploader.filters.push(
			{
				name: 'validateFileType',
				fn: (fileItem) => {

					if (fileItem.name.toLowerCase().indexOf(fileTypeAcceptOption.fileExtension) > -1) {
						return true;
					}

					return false;
				}
			}
		);

		// Validate CVS file
		if (fileTypeAcceptOption.key === FILE_TYPES.csv) {
			uploader.filters.push({
				name: 'validateNumberOfColumns',
				fn: (fileItem, b, referred) => {

					var reader = new FileReader();

					reader.onload = (e) => {

						const parsedCsvObj = importService.parseCSV(e.target.result);

						if (parsedCsvObj.errors.length > 0) {
							payPeriodObj.errors = parsedCsvObj.errors;
							referred.reject(false);
						}

						referred.resolve(true);
					};

					reader.readAsText(fileItem);
				}
			});
		}

		setPageState('ready');
	}

	init();

	angular.extend($scope, {
		DOCUMENT_TYPES,
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES,
		agencyDocumentType,
		agencyProfileId,
		backNgHref,
		from,
		resetImporter,
		uploadingProgress: 0,
		fileTypeAcceptOption: fileTypeAcceptOption.fileExtension,
		uploader: null
	});
}]);

// jshint maxstatements:200
'use strict';

angular.module('paycircleApp')

.controller('dataImporterValidateFileCtrl', [
	'$element',
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'accessButtonService',
	'adjustmentsService',
	'agency',
	'applicationService',
	'base',
	'config',
	'dataImport',
	'filterService',
	'growl',
	'importService',
	'payrollData',
	'recurringPayElementImportService',
	'tooltipsService',
	'utilities',
	'DOCUMENT_TYPES',
	'FILTER_KEYS',
	'IMPORT_CONTEXT_TYPES',
	'IMPORT_MAPPING_COLUMN_SALARY',
	'IMPORT_MAPPING_COLUMN_SICKNESS',
	'IMPORT_MAPPING_COLUMN_TYPES',
	'IMPORT_MAPPING_TYPES',
	'IMPORT_RATE_TYPES',
	'INTERFACE_TYPES',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	'VALIDATION_COLUMN_TYPES',
	'VALIDATION_COLUMN_TYPES_NAMES',
	'VALIDATION_TYPES',
	'VALIDATION_TYPE_LEVELS',
	function (
		$element,
		$filter,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		accessButtonService,
		adjustmentsService,
		agency,
		applicationService,
		base,
		config,
		dataImport,
		filterService,
		growl,
		importService,
		payrollData,
		recurringPayElementImportService,
		tooltipsService,
		utilities,
		DOCUMENT_TYPES,
		FILTER_KEYS,
		IMPORT_CONTEXT_TYPES,
		IMPORT_MAPPING_COLUMN_SALARY,
		IMPORT_MAPPING_COLUMN_SICKNESS,
		IMPORT_MAPPING_COLUMN_TYPES,
		IMPORT_MAPPING_TYPES,
		IMPORT_RATE_TYPES,
		INTERFACE_TYPES,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES,
		VALIDATION_COLUMN_TYPES,
		VALIDATION_COLUMN_TYPES_NAMES,
		VALIDATION_TYPES,
		VALIDATION_TYPE_LEVELS
	) {

	const DEFAULT_MAPPING_COLUMNS_VISIBLE = 10;
	const ERROR_STATES = {
		adjustmentTypeColumnNotDefined: 'adjustment-type-column-undefined'
	};
	const INCLUDE_ADMIN_ACCESS_ENTRIES = true;
	const IS_BUREAU_MAPPING = $rootScope.currentCompany.CompanyType === INTERFACE_TYPES.bureau;
	const SHOW_HIDDEN_COLUMNS = false;
	const TEAM_MEMBER_VIEW_TYPES = [
		{
			key: 'full-name',
			description: 'Full name'
		},
		{
			key: 'ni-number',
			description: 'NI Number'
		}
		/* Requires PayrollID to be added to TeamMember obj
		{
			key: 'payroll-id',
			description: 'Payroll ID'
		}
		*/
	];

	let importMappingType = parseInt($stateParams.importMappingType);
	const agencyDocumentId = $stateParams.agencyDocumentId;
	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyDocumentTypeId = importService.getDocumentTypeIdForAgencyDocumentType(agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;
	const backState = $stateParams.backState;
	const importMappingData = $stateParams.importMappingData;
	const importMappingTemplateId = angular.isDefined($stateParams.importMappingTemplateId) ? $stateParams.importMappingTemplateId : config.guidEmpty;
	const importMappingTypeDisplay = parseInt($stateParams.importMappingType);
	const layoutType = $stateParams.layoutType;
	const payPeriodId = $stateParams.payPeriodId;

	const IS_ADJUSTMENTS_IMPORT_TYPE = importService.getIsAdjustmentImportMappingType(importMappingType);
	const IS_AUTO_MAPPED = importService.getIsImportMappingTypeAutoMapped(importMappingType);
	const IS_IN_DEBUG_MODE = utilities.isDevelopment() && config.isInDebugMode;
	const IS_LINK_RATES_APPLICABLE = importService.getIsLinkRatesApplicableForImportMappingType(importMappingType);
	const IS_PAY_ELEMENTS_APPLICABLE = importService.getIsPayElementsApplicableForImportMappingType(importMappingType);
	const IS_PAY_ELEMENTS_APPLICABLE_CIS = importService.getIsPayElementsCISApplicableForImportMappingType(importMappingType);
	const IS_PAY_ELEMENTS_APPLICABLE_DEEMED = importService.getIsPayElementsDeemedApplicableForImportMappingType(importMappingType);
	const IS_PAY_ELEMENTS_APPLICABLE_RATED_UNITS = importService.getIsPayElementsRatedUnitsApplicableForImportMappingType(importMappingType);
	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId, backState);

	/**
	 * A manual action to map headers against the files header cells
	**/
	function autoMapColumnsByName (vmObj) {

		const IS_BULK_MAPPING = true;
		const IS_MANUAL_DROP = true;
		const numberOfFileColumns = getFileColumnsLength(vmObj);
		const numberOfMappingHeaders = getMappingColumnsLength(vmObj);

		let autoMatchedIndexesArr = [];
		let i = 0;

		// Loop over columns and action ones that are mapped
		for (i; i < numberOfFileColumns; i++) {

			const fileColumnObj = getFileColumnByIndex(vmObj, i);

			if (fileColumnObj.ImportMappingColumnHidden) {
				continue;
			}

			let j = 0;

			// Loop over mapping headers and match up to mapped column
			for (j; j < numberOfMappingHeaders; j++) {

				const mappingHeaderObj = getMappingColumnByIndex(vmObj, j);

				if (mappingHeaderObj.isIgnored || mappingHeaderObj.ImportMappingColumnHidden) {
					continue;
				}

				if (mappingHeaderObj.ImportMappingColumnText.toLowerCase() === fileColumnObj.ImportMappingColumnText.toLowerCase()) {

					// If the header is in use by a different column, release it from that column
					if (mappingHeaderObj.isInUse && !mappingHeaderObj.isReusable) {
						releaseMappingHeaderFromHolder(vmObj, mappingHeaderObj);
					}

					// Ignore if not mappable (after release attempt)
					if (!isMappingHeaderMappable(mappingHeaderObj)) {
						continue;
					}

					// Release this file column's old mapping header so it's available for later columns
					if (fileColumnObj.mappingHeader && fileColumnObj.mappingHeader.originalIndex !== mappingHeaderObj.originalIndex) {
						resetMappingHeaderByOriginalIndex(vmObj, fileColumnObj.mappingHeader.originalIndex);
					}

					autoMatchedIndexesArr.push({
						headerOriginalIndex: mappingHeaderObj.originalIndex,
						fileColumnOriginalIndex: fileColumnObj.originalIndex
					});

					// Make sure any auto-mapped hidden columns are visible
					if (fileColumnObj.isHidden) {
						toggleShowColumn(vmObj, fileColumnObj);
					}

					break;
				}
			}
		}

		// Delay updating so that we can validate the entire file once all columns are matched
		if (autoMatchedIndexesArr.length > 0) {

			matchHeadersByIndexes(vmObj, autoMatchedIndexesArr, IS_MANUAL_DROP, IS_BULK_MAPPING);
		}

		else {
			growl.warning('No headers could be auto mapped');
		}
	}

	/**
	 * An action triggered by a mapping template being used
	 * Mapping headers have property values assigned which are used to apply the correct mapping
	**/
	function autoMapColumnsByProperty (vmObj) {

		const IS_MANUAL_DROP = false;
		const numberOfFileColumns = getFileColumnsLength(vmObj);
		const numberOfMappingHeaders = getMappingColumnsLength(vmObj);

		let autoMatchedIndexesArr = [];
		let i = 0;

		// Loop over columns and action ones that are mapped
		for (i; i < numberOfFileColumns; i++) {

			const fileColumnObj = getFileColumnByIndex(vmObj, i);

			// Skip if not mapped
			if (fileColumnObj.ImportMappingColumnProperty === '') {
				continue;
			}

			let j = 0;

			// Loop over mapping headers and match up to mapped column
			for (j; j < numberOfMappingHeaders; j++) {

				const mappingHeaderObj = getMappingColumnByIndex(vmObj, j);

				if (mappingHeaderObj.ImportMappingColumnProperty === fileColumnObj.ImportMappingColumnProperty) {

					autoMatchedIndexesArr.push({
						headerOriginalIndex: mappingHeaderObj.originalIndex,
						fileColumnOriginalIndex: fileColumnObj.originalIndex
					});

					break;
				}
			}
		}

		// Delay updating so that we can validate the entire file once all columns are matched
		if (autoMatchedIndexesArr.length > 0) {

			matchHeadersByIndexes(vmObj, autoMatchedIndexesArr, IS_MANUAL_DROP);
		}
	}

	/**
	 * Reviews file column headers for duplicates and populates an array of duplicates, if present
	**/
	function checkDuplicateFileHeaders (vmObj) {

		function isDuplicateHeader (columnObj, columnHeadersArr) {

			return columnHeadersArr.includes(columnObj.ImportMappingColumnText);
		}

		vmObj.duplicateFileColumns = [];

		let columnHeadersArr = [];

		vmObj.fileData.Columns.forEach(columnObj => {

			if (isDuplicateHeader(columnObj, columnHeadersArr)) {

				let duplicateFileColumnObj = vmObj.duplicateFileColumns.find(duplicateFileColumnObj => duplicateFileColumnObj.importMappingColumnText === columnObj.ImportMappingColumnText);

				// Duplicate already exists, so append column number
				if (angular.isDefined(duplicateFileColumnObj)) {
					duplicateFileColumnObj.importMappingColumnNumbers.push(columnObj.ImportMappingColumnNumber + 1);
				}

				// Duplicate doesn't exist, so create it and attach the original column number
				else {

					const duplicateFileColumnObj = {
						importMappingColumnNumbers: [columnObj.ImportMappingColumnNumber + 1],
						importMappingColumnText: columnObj.ImportMappingColumnText
					};
					const originalDuplicateFileColumnObj = vmObj.fileData.Columns.find(fileColumnObj => fileColumnObj.ImportMappingColumnText === columnObj.ImportMappingColumnText);

					// Make sure original duplicate column number is included
					if (angular.isDefined(originalDuplicateFileColumnObj)) {
						duplicateFileColumnObj.importMappingColumnNumbers.unshift(originalDuplicateFileColumnObj.ImportMappingColumnNumber + 1);
					}

					// Add duplicate to array
					vmObj.duplicateFileColumns.push(duplicateFileColumnObj);
				}
			}
			else {
				columnHeadersArr.push(columnObj.ImportMappingColumnText);
			}
		});
	}

	function countPopulatedCellsForAllColumns (vmObj) {

		vmObj.fileData.Columns.forEach(columnObj => {

			countPopulatedCellsForColumn(vmObj, columnObj);
		});
	}

	function countPopulatedCellsForColumn (vmObj, columnObj) {

		let cellCountNotEmpty = 0;

		vmObj.fileData.Rows.forEach(rowObj => {

			const rowCellValue = getRowCellValue(vmObj, rowObj.originalIndex, columnObj.originalIndex);

			if (rowCellValue !== '') {
				cellCountNotEmpty++;
			}
		});

		columnObj.cellCountNotEmpty = cellCountNotEmpty;
	}

	function countPopulatedCellsForColumnByCellIndex (vmObj, cellOriginalIndex) {

		const columnObj = getFileColumnByOriginalIndex(vmObj, cellOriginalIndex);

		countPopulatedCellsForColumn(vmObj, columnObj);
	}

	function decorateMappingColumn (mappingColumnObj, fileColumnIndex) {

		mappingColumnObj.isInUse = false;
		mappingColumnObj.isIgnored = !!mappingColumnObj.ImportMappingColumnHidden;
		mappingColumnObj.originalIndex = fileColumnIndex;
	}

	function decorateMappingColumns (vmObj) {

		vmObj.mappingColumns.forEach((mappingColumnObj, mappingColumnIndex) => {

			decorateMappingColumn(mappingColumnObj, mappingColumnIndex);

			const tooltipObj = tooltipsService.getTooltipForImportMappingTypeColumn(vmObj.mappingColumns, vmObj.importMappingType, mappingColumnObj);

			// Add tooltip
			angular.extend(mappingColumnObj, {
				hasTooltip: tooltipObj !== null,
				tooltip: tooltipObj
			});

		});

		return vmObj;
	}

	function decorateMappingColumnsArrForMappingType (mappingColumnsArr, importMappingType) {

		switch (importMappingType) {

			// Can be re-used
			case IMPORT_MAPPING_TYPES.payElementsFixed:
			case IMPORT_MAPPING_TYPES.payElementsFixedCIS:

				mappingColumnsArr.forEach(mappingColumnObj => {

					angular.extend(mappingColumnObj, {
						isPayElementNetable: importService.getIsMappingColumnNetable(mappingColumnObj),
						isReusable: importService.getIsMappingColumnReuseable(mappingColumnObj)
					});
				});

				return mappingColumnsArr;

			case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
				return recurringPayElementImportService.decorateVerticalRecurringImportMappingColumns(mappingColumnsArr);
			case IMPORT_MAPPING_TYPES.payElementsRecurring:
				return recurringPayElementImportService.decorateHorizontalRecurringImportMappingColumns(mappingColumnsArr);

			// Grouped columns
			case IMPORT_MAPPING_TYPES.payElementsHourlyRate:

				const NUMBER_OF_COLUMNS_IN_GROUP = 2;

				let mappingColumnGroupId = 0;

				mappingColumnsArr.forEach((mappingColumnObj, i) => {
					mappingColumnObj.mappingColumnGroupId = mappingColumnGroupId;

					if (i % NUMBER_OF_COLUMNS_IN_GROUP > 0) {
						mappingColumnGroupId++;
					}
				});

				return mappingColumnsArr;

			case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical: {

				mappingColumnsArr.forEach(mappingColumnObj => {

					angular.extend(mappingColumnObj, {
						isPayElementRateTypeEditable: importService.getIsMappingColumnRateTypeEditable(importMappingType, mappingColumnObj),
					});
				});

				return mappingColumnsArr;

			}

			default:
				return mappingColumnsArr;
		}
	}

	function decorateMappingTemplates (mappingTemplatesArr) {

		// Add default label to template name
		mappingTemplatesArr.forEach(mappingTemplateObj => {
			mappingTemplateObj.isTemplate = true;
		});

		const placeholderTemplate = mappingTemplatesArr.find(template => template.IgnoreTemplate && template.IsDefault);

		const emptyTemplate = {
			ImportMappingID: config.guidEmpty,
			IsDefault: false,
			IsGlobalTemplate: false,
			MappingType: importMappingType,
			Name: 'Do not use a template',
			IsTemplateInUse: false
		};

		if (angular.isDefined(placeholderTemplate)) {
			angular.extend(emptyTemplate, {
				ImportMappingID: placeholderTemplate.ImportMappingID,
				IsDefault: placeholderTemplate.IsDefault,
				isTemplate: placeholderTemplate.isTemplate
			});
		}

		// Add option to not use a template
		mappingTemplatesArr.unshift(emptyTemplate);

		return mappingTemplatesArr;
	}

	function deleteColumnMapping (vmObj, fileColumnOriginalIndex, mappingHeaderOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, fileColumnOriginalIndex);
		let fileColumnObjMappingColumnGroupId = fileColumnObj.mappingColumnGroupId;
		let isLinked = false;

		// Pay Element Mapping Headers
		if (isPayElementMappingHeader(vmObj, mappingHeaderOriginalIndex)) {

			// Horizontal
			if (isPayElementMappingHeaderHorizontal(vmObj, mappingHeaderOriginalIndex)) {

				// Reset flag to hide any UI elements
				vmObj.isChangeTypeMapped = false;
				vmObj.isRatedElementMapped = false;

				// Reset the file column
				resetFileColumnObj(fileColumnObj);

				// Reset the adjustment type mapping
				unmapAdjustmentTypesHorizontal(vmObj);

				// Reset the mapping column (note: needs to happen before resetting file column obj)
				resetMappingHeaderByOriginalIndex(vmObj, mappingHeaderOriginalIndex);
			}

			// Vertical
			else {

				switch (fileColumnObj.ImportMappingColumnType) {
					case IMPORT_MAPPING_COLUMN_TYPES.rate:
					case IMPORT_MAPPING_COLUMN_TYPES.unit:

						isLinked = true;

						let columnGroupArr = getColumnsArrByGroupId(vmObj, fileColumnObjMappingColumnGroupId);

						// Map details for both rate and unit columns
						columnGroupArr.forEach(_ => {

							// Reset mapping header
							if (_.mappingHeader) {
								resetMappingHeaderByOriginalIndex(vmObj, _.mappingHeader.originalIndex);
							}

							// Reset file column
							resetFileColumnObj(_);

							// Update
							dataImport.updateImportMappingColumn(_).then(updatedFileColumnObj => {

								updatedFileColumnObj.isPayElementNetable = false;

								$timeout(() => {
									angular.extend(_, updatedFileColumnObj, {
										loadingState: 'ready'
									});
								});
							})
							.catch(onError);
						});

						setAndUpdateRatesAndUnitsFilterIndex(vmObj, fileColumnObjMappingColumnGroupId);

						break;

					default:
						
						// Reset the file column
						resetFileColumnObj(fileColumnObj);

						// Reset the mapping column (note: needs to happen before resetting file column obj)
						resetMappingHeaderByOriginalIndex(vmObj, mappingHeaderOriginalIndex);
				}
			}
		}

		else {

			// Reset the file column
			resetFileColumnObj(fileColumnObj);

			// Reset the mapping column (note: needs to happen before resetting file column obj)
			resetMappingHeaderByOriginalIndex(vmObj, mappingHeaderOriginalIndex);
		}

		// Track manual template mapping changes
		vmObj.hasTemplateMappingChanged = true;

		// Reset rows/cells
		resetRowsForFileColumnObj(vmObj, fileColumnObj);

		// Re-evaluate the mapping to see whether the overall form is valid or not
		validateMapping(vmObj);
		validateRowData(vmObj);

		// Save to DB
		if (!isLinked) {
			dataImport.updateImportMappingColumn(fileColumnObj).then(updatedFileColumnObj => {

				updatedFileColumnObj.loadingState = 'ready';

				angular.extend(fileColumnObj, updatedFileColumnObj);
			})
			.catch(onError);
		}
	}

	/**
	 * Extracts unique policy names from the Policy Name column for click-to-match.
	 * Creates a policyMatches map keyed by policy name.
	 **/
	function extractUniquePolicyNames (vmObj) {

		// Find the Policy Name column (the column mapped to the PolicyName mapping header)
		let policyNameColumnIndex = -1;

		vmObj.fileData.Columns.forEach(columnObj => {

			if (columnObj.isInUse && columnObj.mappingHeader && columnObj.mappingHeader.ImportMappingColumnText === 'Policy Name') {
				policyNameColumnIndex = columnObj.ImportMappingColumnNumber;
			}
		});

		if (policyNameColumnIndex === -1) {
			return;
		}

		// Collect unique policy names from rows
		let policyMatches = {};

		vmObj.fileData.Rows.forEach(rowObj => {

			let cellObj = rowObj.cells[policyNameColumnIndex];

			if (cellObj && cellObj.value && cellObj.value.trim() !== '') {

				let policyName = cellObj.value.trim();

				if (!policyMatches[policyName]) {
					policyMatches[policyName] = {
						matched: false,
						data: null
					};
				}
			}
		});

		angular.extend(vmObj, {
			policyMatches: policyMatches,
			uniquePolicyNamesCollected: true,
			allPoliciesMatched: false,
			policyNameColumnIndex: policyNameColumnIndex,
			policyTotalCount: Object.keys(policyMatches).length,
			policyMatchedCount: 0
		});
	}

	function syncPolicyMatches (vmObj) {

		if (!vmObj.uniquePolicyNamesCollected || vmObj.policyNameColumnIndex === undefined) {
			return;
		}

		var oldMatches = vmObj.policyMatches || {};
		var newMatches = {};

		vmObj.fileData.Rows.forEach(function (rowObj) {
			var cellObj = rowObj.cells[vmObj.policyNameColumnIndex];

			if (cellObj && cellObj.value && cellObj.value.trim() !== '') {
				var policyName = cellObj.value.trim();

				if (!newMatches[policyName]) {
					if (oldMatches[policyName]) {
						newMatches[policyName] = oldMatches[policyName];
					} else {
						newMatches[policyName] = {
							matched: false,
							data: null
						};
					}
				}
			}
		});

		vmObj.policyMatches = newMatches;
		updatePolicyMatchCounts(vmObj);
	}

	function editCell (cellObj, rowIndex, $event) {

		const cellWidth = angular.element($event.srcElement)[0].offsetWidth;

		cellObj.state = 'editing';
		cellObj.width = cellWidth + 16; // Additional padding added to align with value element, to avoid jumping

		// Focus
		if (!angular.isUndefined(rowIndex)) {

			$timeout(() => {

				const inputId = 'cell-' + rowIndex + '-' + cellObj.originalIndex;

				document.getElementById(inputId).focus();
			});
		}
	}

	function generateUserImport (vmObj, reviewValidRows) {

		reviewValidRows = angular.isDefined(reviewValidRows) ? true : false;

		if (getIsNothingToImport(vmObj, reviewValidRows)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'importing';

		dataImport.getImportMappingDescription(importMappingType).then(importMappingDescription => {
			accessButtonService.sendImportsTelemetry(
				TELEMETRY_TRACKED_FEATURES.imports,
				TELEMETRY_PROJECT_INFO.projectReportingCode,
				importMappingDescription
			);
		});	

		$timeout(() => {
			vmObj.importingPercentComplete = 100;
		}, 200);

		// Policy metadata is already written to hidden columns via updateRowsPolicyMetadata (called from openMatchPolicyDetailsForm).
		// Set Ignore=true on rows belonging to skipped policies so the backend excludes them from processing.
		if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && vmObj.policyMatches) {

			vmObj.fileData.Rows.forEach(function (rowObj) {
				var rowPolicyName = getPolicyNameForRow(vmObj, rowObj);
				if (rowPolicyName && vmObj.policyMatches[rowPolicyName] && vmObj.policyMatches[rowPolicyName].skipped) {
					rowObj.Ignore = true;
				}
			});
		}

		importService.reMapValues(vmObj.fileData.Rows);

		const generateImport = () => dataImport.generateUserImport(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData, importMappingType);
		const generateImportPromise = importMappingType === IMPORT_MAPPING_TYPES.calculatedPayHistoryImport ?
			payrollData.getPayPeriodCurrent(agencyProfileId).then(payPeriodCurrentObj => {
				if (payPeriodCurrentObj && payPeriodCurrentObj.IsPayrollLocked) {
					vmObj.state = 'calculated-pay-history-import-locked';
					return null;
				}

				return generateImport();
			}) : generateImport();

		generateImportPromise.then(importSummaryObj => {

			if (vmObj.state === 'calculated-pay-history-import-locked') {
				return;
			}

			if (!importSummaryObj || importSummaryObj.Success === false) {
				vmObj.importErrors = importSummaryObj && importSummaryObj.Errors && importSummaryObj.Errors.length ? importSummaryObj.Errors : ['The import could not be completed.'];
				vmObj.state = 'import-blocked';
				return;
			}

			angular.extend(vmObj, {
				hasImportSummaryToDisplay: importService.getHasImportSummaryToDisplay(importSummaryObj),
				importSummary: importSummaryObj
			});

			$timeout(() => {
				vmObj.state = 'imported';
			}, 2000);
		})
		.catch(onError);
	}

	function getAdjustmentDetailsByString (vmObj, searchString) {

		const numberOfAdjustmentLabels = vmObj.adjustmentLabels.length;
		const numberOfAdjustmentTypes = vmObj.adjustmentTypes.length;
		let i = 0;
		let j = 0;
		let responseObj = {
			adjustmentTypeObj: '',
			adjustmentLabelObj: '',
			matchType: null
		};

		// Check against adjustment types
		for (i; i < numberOfAdjustmentTypes; i++) {

			const adjustmentTypeObj = vmObj.adjustmentTypes[i];

			if (adjustmentTypeObj.AgencyAdjustmentGroupEntryText.toLowerCase() === searchString.toLowerCase()) {

				responseObj.adjustmentTypeObj = angular.copy(adjustmentTypeObj);
				responseObj.matchType = 'adjustment';

				return responseObj;
			}
		}

		// Check against adjustment labels
		for (j; j < numberOfAdjustmentLabels; j++) {

			const adjustmentLabelObj = vmObj.adjustmentLabels[j];

			if (adjustmentLabelObj.AgencyAdjustmentLabelText.toLowerCase() === searchString.toLowerCase()) {

				responseObj.adjustmentTypeObj = angular.copy(adjustmentLabelObj.adjustmentType);
				responseObj.adjustmentLabelObj = angular.copy(adjustmentLabelObj);
				responseObj.matchType = 'label';

				return responseObj;
			}
		}

		return responseObj;
	}

	function getLinkElementDetailsByString (vmObj, searchString) {

		const numberOfLinkElements = vmObj.linkElementsDetails.LinkElements.length;
		let i = 0;

		// Check against adjustment types
		for (i; i < numberOfLinkElements; i++) {

			const linkElementObj = vmObj.linkElementsDetails.LinkElements[i];

			if (linkElementObj.LinkElementName.toLowerCase() === searchString.toLowerCase()) {

				return linkElementObj;
			}
		}

		return null;
	}

	function getAdjustmentTypeFilterKey () {

		// Deemed only
		if (IS_PAY_ELEMENTS_APPLICABLE_DEEMED) {
			return 'deemed';
		}

		// CIS only
		if (IS_PAY_ELEMENTS_APPLICABLE_CIS) {
			return 'cis';
		}

		return 'paye';
	}

	function getAdjustmentTypeValueForRow (vmObj, fileRowOriginalIndex) {

		const cellIndex = vmObj.columnIndexes.adjustmentType;

		if (angular.isUndefined(cellIndex)) {
			$rootScope.paycircleMessage('dataImporterFileController: No Adjustment Type column mapped > Unable to match change', 'error');
			setPageState('error', ERROR_STATES.adjustmentTypeColumnNotDefined);
			return;
		}

		return getRowCellValue(vmObj, fileRowOriginalIndex, cellIndex);
	}

	function getColumnIndexForAdjustmentLabelId (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.adjustmentLabel);
	}

	function getColumnIndexForAdjustmentTypeId (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.adjustmentId);
	}

	function getColumnIndexForNetToGrossId (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.netToGross);
	}

	function getColumnIndexForAgencyAdjustmentRateTypeId (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.adjustmentRateType);
	}

	function getColumnIndexForUserId (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.userId);
	}

	function getColumnIndexForPolicyPayBasis (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.policyPayBasis);
	}

	function getColumnIndexForPolicyEffectiveDate (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.policyEffectiveDate);
	}

	function getColumnIndexForPolicyHoursPerWeek (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.policyHoursPerWeek);
	}

	function getColumnIndexForPolicyWeeksPerYear (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.policyWeeksPerYear);
	}

	function getColumnIndexForPolicyIsPensionable (vmObj) {

		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.policyIsPensionable);
	}

	function getColumnsArrByGroupId (vmObj, columnGroupId) {

		return vmObj.fileData.Columns.filter(columnObj => {
			return columnObj.mappingColumnGroupId === columnGroupId;
		});
	}

	function getDataValidationStateForFileColumnIndex (vmObj, columnIndex) {

		validateCellsForColumn(vmObj, columnIndex);

		const fileColumnObj = getFileColumnByIndex(vmObj, columnIndex);
		const isColumnValid = getIsColumnValid(vmObj, columnIndex);

		if (fileColumnObj.ImportMappingColumnProperty === '') {
			return null;
		}

		return isColumnValid ? 'valid' : 'invalid';
	}

	function getDefaultMappingTemplate (mappingTemplatesArr) {

		const defaultMappingTemplateObj = angular.copy(mappingTemplatesArr.find(_ => _.IsDefault));
		const noMappingTemplateObj = angular.copy(mappingTemplatesArr.find(_ => !_.isTemplate));

		// Template ID is passed in to URL
		if (angular.isDefined(importMappingTemplateId) && importMappingTemplateId !== config.guidEmpty) {

			const selectedMappingTemplateObj = angular.copy(mappingTemplatesArr.find(_ => _.ImportMappingID === importMappingTemplateId));

			if (angular.isDefined(selectedMappingTemplateObj)) {
				return selectedMappingTemplateObj;
			}
		}

		return angular.isDefined(defaultMappingTemplateObj) ? defaultMappingTemplateObj : noMappingTemplateObj;
	}

	function getFileCellByOriginalIndex (vmObj, rowOriginalIndex, cellOriginalIndex) {

		let fileRowObj = getFileRowByOriginalIndex(vmObj, rowOriginalIndex);

		return utilities.getArrayItemByPropertyName(fileRowObj.cells, 'originalIndex', cellOriginalIndex);
	}

	function getFileColumnByIndex (vmObj, fileColumnIndex) {

		return vmObj.fileData.Columns[fileColumnIndex];
	}

	function getFileColumnByOriginalIndex (vmObj, columnOriginalIndex) {

		return utilities.getArrayItemByPropertyName(vmObj.fileData.Columns, 'originalIndex', columnOriginalIndex);
	}

	function getFileColumnsLength (vmObj) {

		return vmObj.fileData.Columns.length;
	}

	function getFileRowByOriginalIndex (vmObj, rowOriginalIndex) {

		return utilities.getArrayItemByPropertyName(vmObj.fileData.Rows, 'originalIndex', rowOriginalIndex);
	}

	function getFiltersForImportMappingType (mappingColumnsArr) {

		// Rates / Units
		if (importService.getIsRatesUnitsImportMappingType(importMappingType)) {
			return [];
		}

		// Everything else
		return filterService.getFilterBarOptionsImportMappingColumns(mappingColumnsArr);
	}

	function getPolicyNameForRow (vmObj, row) {

		if (!vmObj.policyNameColumnIndex && vmObj.policyNameColumnIndex !== 0) {
			return null;
		}

		var cellObj = row.cells[vmObj.policyNameColumnIndex];

		if (cellObj && cellObj.value) {
			return cellObj.value.trim();
		}

		return null;
	}

	function getFullNameDescriptionForRow (rowObj, isTruncated) {

		if (!rowObj.isTeamMemberValid || !rowObj.TeamMember) {
			return 'Select team member';
		}

		const teamMemberFullName = `${rowObj.TeamMember.Forename} ${rowObj.TeamMember.Surname}`;

		if (isTruncated) {
			return $filter('truncate')(teamMemberFullName, 20);
		}

		return teamMemberFullName;
	}

	function getIndexForColumnType (vmObj, columnType) {

		const returnIndex = utilities.getArrayItemIndexByPropertyName(vmObj.fileData.Columns, 'ImportMappingColumnText', columnType);

		// Column not found
		if (!returnIndex) {
			$rootScope.paycircleMessage('Importer: Unable to get column index for ' + VALIDATION_COLUMN_TYPES_NAMES[columnType], 'error');
			setPageState('error');
			return returnIndex;
		}

		return returnIndex;
	}

	function getIsCellObjValid (vmObj, columnOriginalIndex, rowOriginalIndex) {

		const fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);
		const fileRowObj = getFileRowByOriginalIndex(vmObj, rowOriginalIndex);
		const fileCellObj = getFileCellByOriginalIndex(vmObj, rowOriginalIndex, columnOriginalIndex);

		const isValidationApplicable = getIsValidationApplicableForFileColumn(fileColumnObj);

		// Row is ignored
		if (fileRowObj.Ignore || IS_BUREAU_MAPPING) {

			if (IS_IN_DEBUG_MODE) {
				console.info(`Row ${rowOriginalIndex}: Row ignored or is Bureau mapping`);
			}

			return true;
		}

		// Only applies to Pay Element > Horizontal
		if (isPayElementMappingHeaderHorizontal(vmObj, fileColumnObj.mappingHeader.originalIndex)) {

			// Adjustment type is required
			if (!fileRowObj.adjustmentType) {

				if (IS_IN_DEBUG_MODE) {
					console.info(`Row ${rowOriginalIndex}, Cell ${columnOriginalIndex}: Horizontal and adjustment mapping header and adjustment not set`);
				}

				return false;
			}
		}

		// No cells are allowed to contain a comma
		if (fileCellObj.value.indexOf(',') > -1) {

			if (IS_IN_DEBUG_MODE) {
				console.info(`Row ${rowOriginalIndex}, Cell ${columnOriginalIndex}: Comma found in value`);
			}

			return false;
		}

		// Validate (default to true)
		if (isValidationApplicable) {

			// Validate DOB (bespoke date validation)
			if (fileColumnObj.ImportMappingColumnLocalValidation) {
				if (!importService.getIsCellDateValueValid(fileCellObj.value)) {

					if (IS_IN_DEBUG_MODE) {
						console.info(`Row ${rowOriginalIndex}, Cell ${columnOriginalIndex}: Bespoke date validation failed`);
					}

					return false;
				}
			}

			// Validate Total Work Hours Per Week (max hours validation)
			const isTotalHoursColumn = fileColumnObj.mappingHeader &&
			importMappingType === IMPORT_MAPPING_TYPES.salary &&
			+fileColumnObj.mappingHeader.ImportMappingColumnProperty === IMPORT_MAPPING_COLUMN_SALARY.totalWorkHoursPerWeek;
			
			if (isTotalHoursColumn) {
				const maxHours = $rootScope.CONFIG.maxHoursPerWeek;
				if (!importService.getIsCellTotalHoursValid(fileCellObj.value, maxHours)) {
					return false;
				}
			}

			// Validate Work Pattern (must have at least one working day)
			const isWorkPatternColumn = fileColumnObj.mappingHeader &&
				importMappingType === IMPORT_MAPPING_TYPES.salary &&
				+fileColumnObj.mappingHeader.ImportMappingColumnProperty === IMPORT_MAPPING_COLUMN_SALARY.workPattern;

			if (isWorkPatternColumn) {
				if (!importService.getIsCellWorkPatternValid(fileCellObj.value)) {
					return false;
				}
			}

			// Validate Work Pattern on sickness schedules (must have at least one working day)
			const isSicknessWorkPatternColumn = fileColumnObj.mappingHeader &&
				importMappingType === IMPORT_MAPPING_TYPES.sickness &&
				+fileColumnObj.mappingHeader.ImportMappingColumnProperty === IMPORT_MAPPING_COLUMN_SICKNESS.workPattern;

			if (isSicknessWorkPatternColumn) {
				if (!importService.getIsCellWorkPatternValid(fileCellObj.value)) {
					return false;
				}
			}

			// Validate Work Pattern Effective Date (must be within current pay period)
			const isWorkPatternEffectiveDateColumn = fileColumnObj.mappingHeader &&
				importMappingType === IMPORT_MAPPING_TYPES.salary &&
				+fileColumnObj.mappingHeader.ImportMappingColumnProperty === IMPORT_MAPPING_COLUMN_SALARY.workPatternEffectiveDate;
			
			if (isWorkPatternEffectiveDateColumn && $scope.vm.payPeriodStartDateISO && $scope.vm.payPeriodEndDateISO) {
				if (!importService.getIsCellWorkPatternEffectiveDateValid(fileCellObj.value, $scope.vm.payPeriodStartDateISO, $scope.vm.payPeriodEndDateISO)) {
					return false;
				}
			}


			// Validate REGEX
			const isRegexValid = getIsFieldValidByRegexString(fileColumnObj.ImportMappingColumnRegex, fileCellObj.value);

			if (IS_IN_DEBUG_MODE && !isRegexValid) {
				console.info(`Row ${rowOriginalIndex}, Cell ${columnOriginalIndex}: Regex validation failed (${fileColumnObj.ImportMappingColumnRegex}) on value '${fileCellObj.value}'`);
			}

			return isRegexValid;
		}

		return true;
	}

	function getIsColumnValid (vmObj, fileColumnIndex) {

		const numberOfFileRows = vmObj.fileData.Rows.length;
		let i = 0;

		for (i; i < numberOfFileRows; i++) {

			const rowObj = vmObj.fileData.Rows[i];

			const cellObj = rowObj.cells[fileColumnIndex];

			if (!cellObj.isValid) {
				return false;
			}
		}

		return true;
	}

	function getIsFieldValidByRegexString (regexString, value) {

		if (regexString === '') {
			return true;
		}

		var regex = new RegExp(regexString);

		return regex.test(value);
	}

	function getIsIgnoreAllRowsEnabled (vmObj) {

		if (vmObj.activeValidationResultFilter && vmObj.fileData.filteredRows)  {
			return vmObj.fileData.filteredRows.every(rowObj => rowObj.Ignore);
		}
		else {
			return vmObj.fileData.Rows.every(rowObj => rowObj.Ignore);
		}
	}

	function getIsNothingToImport (vmObj, reviewValidRows) {
		return (
			reviewValidRows &&
			(vmObj.fileData.validRowCount === 0 || vmObj.fileData.Rows.length === 0) ||
			(vmObj.fileData.ignoreRowCount === vmObj.fileData.Rows.length)
		);
	}

	function getIsValidationApplicableForFileColumn (fileColumnObj) {

		// Doesn't apply to bureau mappings
		if (IS_BUREAU_MAPPING) {
			return false;
		}

		// Column not mapped
		if (fileColumnObj.ImportMappingColumnProperty === '') {
			return false;
		}

		// No validation defined
		if (fileColumnObj.ImportMappingColumnRegex === '' && !fileColumnObj.ImportMappingColumnLocalValidation) {
			return false;
		}

		return true;
	}

	function getMappingColumnByIndex (vmObj, index) {

		return vmObj.mappingColumns[index];
	}

	function getMappingColumnByOriginalIndex (vmObj, originalIndex) {

		return utilities.getArrayItemByPropertyName(vmObj.mappingColumns, 'originalIndex', originalIndex);
	}

	function getMappingColumnIndex (vmObj, originalPropertyValue) {

		let columnGroupsArr = [];

		vmObj.fileData.Columns

			// Only interested in mapped columns
			.filter(_ => {
				return angular.isNumber(_.mappingColumnGroupId);
			})

			// Group mapped columns by their property value
			.forEach(_ => {

				let columnGroupObj = utilities.getArrayItemByPropertyName(columnGroupsArr, 'property', _.mappingColumnGroupId);

				if (angular.isUndefined(columnGroupObj)) {
					columnGroupsArr.push({
						property: _.mappingColumnGroupId,
						columns: [
							angular.copy(_)
						]
					});
				}

				else {
					columnGroupObj.columns.push(angular.copy(_));
				}
			});

		// Shift all mappings when one is deleted
		if (angular.isDefined(originalPropertyValue)) {

			const REVERSE = false;

			// Needs to descend so they are not overridden
			columnGroupsArr = $filter('orderBy')(columnGroupsArr, 'property', REVERSE);

			columnGroupsArr.forEach(_ => {

				// Only applies to groups added after
				if (_.property > originalPropertyValue) {

					_.columns.forEach(columnObj => {

						const IS_MANUAL_DROP = false;

						const mappingHeaderOriginalIndexOld = columnObj.mappingHeader.originalIndex;
						const mappingHeaderOriginalIndexNew = columnObj.mappingHeader.originalIndex - 2;

						// Unmap
						resetFileColumnObjByOriginalIndex(vmObj, columnObj.originalIndex);
						resetMappingHeaderByOriginalIndex(vmObj, mappingHeaderOriginalIndexOld);

						// Remap
						updateColumnMapping(vmObj, mappingHeaderOriginalIndexNew, columnObj.originalIndex, IS_MANUAL_DROP, {
							AgencyAdjustmentGroupEntryID: angular.copy(columnObj.AgencyAdjustmentGroupEntryID),
							AgencyAdjustmentID: angular.copy(columnObj.AgencyAdjustmentID),
							AgencyAdjustmentLabel: angular.copy(columnObj.AgencyAdjustmentLabel),
							adjustmentType: angular.copy(columnObj.adjustmentType)
						});

						// Save to DB
						saveColumnMapping(vmObj, columnObj.originalIndex);
					});
				}
			});
		}

		return columnGroupsArr.length;
	}

	function getMappingColumnsLength (vmObj) {

		return vmObj.mappingColumns.length;
	}

	function getMappingFilterOptionsByGroupIndex (vmObj, groupIndex) {

		// No filter groups
		if (!vmObj.filterBarOptions.filterGroups.length) {
			$rootScope.paycircleMessage('No filter groups defined', 'warn');
			return [];
		}

		const filterGroup = vmObj.filterBarOptions.filterGroups[groupIndex];

		// No filter options
		if (!filterGroup.filterOptions.length) {
			$rootScope.paycircleMessage('No filter options defined', 'warn');
			return [];
		}

		return filterGroup.filterOptions;
	}

	function getNewMappingColumn (vmObj) {

		const originalMappingColumnsIds = vmObj.mappingColumns.map(_ => _.LinkElementID);

		let deferred = $q.defer();

		dataImport.getImportMappingColumns2(agencyProfileId, importMappingType).then(mappingColumnsArr => {

			mappingColumnsArr.forEach((mappingColumnObj, mappingColumnIndex) => {

				// We only want the new mapping column
				if (originalMappingColumnsIds.indexOf(mappingColumnObj.LinkElementID) === -1) {

					// Decorate new mapping column
					decorateMappingColumn(mappingColumnObj, mappingColumnIndex);

					vmObj.mappingColumns.push(mappingColumnObj);
				}
			});

			deferred.resolve(vmObj);
		})
		.catch(error => {
			deferred.reject();
			onError(error);
		});

		return deferred.promise;
	}

	function getNIDescriptionForRow (rowObj) {

		// No team member
		if (!rowObj.TeamMember) {
			return 'Unknown';
		}

		// No NI number
		if (rowObj.TeamMember.NINumber === '') {
			return 'N/A';
		}

		return rowObj.TeamMember.NINumber;
	}

	function getRowCellByOriginalIndex (vmObj, rowOriginalIndex, cellOriginalIndex) {

		const rowObj = getFileRowByOriginalIndex(vmObj, rowOriginalIndex);

		return rowObj.cells[cellOriginalIndex];
	}

	function getRowCellValue (vmObj, rowOriginalIndex, cellOriginalIndex) {

		const cellObj = getRowCellByOriginalIndex(vmObj, rowOriginalIndex, cellOriginalIndex);

		if (!cellObj) {
			return '';
		}

		return cellObj.value;
	}

	function hasDefaultMappingTemplateChanged (vmObj) {

		return vmObj.importMappingTemplate.IsDefault && vmObj.importMappingTemplate.ImportMappingID !== vmObj.importMappingTemplateDefaultId;
	}

	function hideEmptyColumns (vmObj) {

		vmObj.fileData.Columns.forEach(columnObj => {

			// Ignore if already hidden
			if (columnObj.isHidden) {
				return;
			}

			else {

				countPopulatedCellsForColumn(vmObj, columnObj);

				columnObj.isHidden = columnObj.cellCountNotEmpty === 0;

				// Loop over every row and hide cell for hidden columns
				if (columnObj.isHidden) {

					vmObj.fileData.Rows.forEach(rowObj => {

						let cellObj = getRowCellByOriginalIndex(vmObj, rowObj.originalIndex, columnObj.originalIndex);

						cellObj.isHidden = true;
					});
				}
			}
		});

		vmObj.emptyColumnsState = 'hidden';
	}

	function init (FORCE_TEMPLATE_SELECTION) {

		if (!isStateValid()) {
			setPageState('error');
			return;
		}

		FORCE_TEMPLATE_SELECTION = angular.isDefined(FORCE_TEMPLATE_SELECTION) ? FORCE_TEMPLATE_SELECTION : false;

		setPageState('loading');

		const getImportMappingTemplates = dataImport.getImportMappingTemplates(agencyProfileId, importMappingType);
		const isExcludedType = [IMPORT_MAPPING_TYPES.xeroNominalCodes, IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts].includes(importMappingType);
		const getCompanyDocument = isExcludedType ? null : base.getCompanyDocument(agencyDocumentId);
		const isCalculatedPayHistoryImport = importMappingType === IMPORT_MAPPING_TYPES.calculatedPayHistoryImport;
		const getPayPeriodCurrent = !IS_BUREAU_MAPPING && isCalculatedPayHistoryImport ? payrollData.getPayPeriodCurrent(agencyProfileId) : null;
		const getIsImportTypeFeatureEnabled = importService.getIsImportMappingTypeFeatureEnabled(agencyProfileId, importMappingType);

		$q.all([
			getCompanyDocument,
			getImportMappingTemplates,
			getPayPeriodCurrent,
			getIsImportTypeFeatureEnabled
		]).then(([
			documentObj,
			mappingTemplatesArr,
			payPeriodCurrentObj,
			isImportTypeFeatureEnabled
		]) => {

			if (!isImportTypeFeatureEnabled) {
				$state.go('team.imports', {agencyProfileId});
				return;
			}

			if (payPeriodCurrentObj && payPeriodCurrentObj.IsPayrollLocked) {
				$scope.vm = {
					agencyProfileId,
					state: 'calculated-pay-history-import-locked'
				};
				setPageState('ready');
				return;
			}

			mappingTemplatesArr = decorateMappingTemplates(mappingTemplatesArr);

			// Pre-select either 'Default', if set or 'Do not use a template'
			const defaultMappingTemplateObj = getDefaultMappingTemplate(mappingTemplatesArr);

			$scope.vm = {
				IS_AUTO_MAPPED,
				agencyDocumentId: agencyDocumentId,
				agencyProfileId: agencyProfileId,
				currentSelectedRecurringGroup: recurringPayElementImportService.RECURRING_GROUP_NONE,
				document: documentObj,
				emptyColumnsState: 'visible',
				hasSavedFileMapping: false,
				importMappingTemplate: defaultMappingTemplateObj,
				importMappingTemplateDefaultId: defaultMappingTemplateObj.isTemplate ? angular.copy(defaultMappingTemplateObj.ImportMappingID) : null, // Take snapshot of default import mapping id (if exists) to know whether the default has changed
				importMappingType,
				importMappingTypeDisplay,
				importMappingTypeDescription: $filter('importMappingTypeDescription')(importMappingType),
				mappingTemplates: mappingTemplatesArr.filter(template => angular.isUndefined(template.IgnoreTemplate) || !template.IgnoreTemplate),
				state: 'mapping-templates',
				stateKey: $state.current.name
			};

			// Check if mapping templates exists and whether a default is applied
			if (mappingTemplatesArr.length > 1) {

				// Ignore mapping templates, not applicable
				if (IS_BUREAU_MAPPING) {
					initMapping($scope.vm);
					return;
				}

				// Mapping template id can be passed in as URL param
				if (utilities.isValidGuid(importMappingTemplateId) && !FORCE_TEMPLATE_SELECTION) {
					initMapping($scope.vm);
					return;
				}

				// Auto map default template selection
				if (defaultMappingTemplateObj.isTemplate && defaultMappingTemplateObj.IsDefault && !FORCE_TEMPLATE_SELECTION) {
					initMapping($scope.vm);
					return;
				}

				// Select template
				setPageState('ready');
				return;
			}

			// If validating users, check row settings > Not currently active (due: v3)
			/*
			if (importMappingType === IMPORT_MAPPING_TYPES.users) {
				setImportState($scope.vm, 'row-settings');
				setPageState('ready');
				return;
			}
			*/

			initMapping($scope.vm);
		})
		.catch(onError);
	}

	function initMapping (vmObj) {

		setPageState('loading');

		const HAS_USED_TEMPLATE = vmObj.importMappingTemplate.isTemplate;

		const importDataCheckFormat = dataImport.importDataCheckFormat(agencyProfileId, payPeriodId, agencyDocumentTypeId, agencyDocumentId, importMappingType, vmObj.importMappingTemplate.ImportMappingID);
		const getImportMappingColumns2 = dataImport.getImportMappingColumns2(agencyProfileId, importMappingType);
		const getLinkElements = IS_LINK_RATES_APPLICABLE ? payrollData.getLinkElements(agencyProfileId) : null;
		const getAgencyAdjustmentLabels = IS_PAY_ELEMENTS_APPLICABLE ? payrollData.getAgencyAdjustmentLabels(agencyProfileId) : null;
		const getAgencyProfileImportOrientationVertical = IS_BUREAU_MAPPING ? null : agency.getAgencyProfileImportOrientationVertical(agencyProfileId);
		const getDefaultRateType = IS_ADJUSTMENTS_IMPORT_TYPE ? dataImport.getDefaultImportAgencyAdjustmentRateType(agencyProfileId, importMappingType) : null;
		const getPayPeriod = importMappingType === IMPORT_MAPPING_TYPES.salary && payPeriodId ? payrollData.getPayPeriod(agencyProfileId, payPeriodId) : null;

		let getAgencyAdjustmentGroupCombined = null;

		if (IS_PAY_ELEMENTS_APPLICABLE) {

			getAgencyAdjustmentGroupCombined = IS_PAY_ELEMENTS_APPLICABLE_RATED_UNITS ?
				payrollData.getAgencyAdjustmentGroupCombinedForRatedUnits(agencyProfileId, INCLUDE_ADMIN_ACCESS_ENTRIES) :
				payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId, INCLUDE_ADMIN_ACCESS_ENTRIES);
		}

		$q.all([
			importDataCheckFormat,
			getImportMappingColumns2,
			getLinkElements,
			getAgencyAdjustmentGroupCombined,
			getAgencyAdjustmentLabels,
			getAgencyProfileImportOrientationVertical,
			getDefaultRateType,
			getPayPeriod
		]).then(([
			fileDataObj,
			mappingColumnsArr,
			linkElementsDetailsObj,
			adjustmentGroupsObj,
			adjustmentLabelsArray,
			companyLayoutTypeIsVertical,
			defaultRateType,
			payPeriodObj
		]) => {

			const hiddenColumnsArr = importService.getHiddenColumnsArr(fileDataObj);
			const importContext = importService.getImportContextForImportMappingType(importMappingType);

			angular.extend(vmObj, {
				DEFAULT_MAPPING_COLUMNS_VISIBLE,
				activeMappingHeaderIndex: null,
				activeValidationResultFilter: null,
				agencyDocumentType: agencyDocumentType,
				columnIndexes: {
					adjustmentType: null
				},
				defaultRateType: defaultRateType,
				duplicateFileColumns: [],
				fileData: importService.decorateFileDataObj(fileDataObj, importMappingType, importMappingData),
				filterBarOptions: filterService.dataImporterValidate,
				filterBarOptionsMappingColumns: {
					displayOption: {
						key: 'is-layout-row',
						icon: 'rows',
						name: 'Row'
					},
					displayOptions: [
						{
							key: 'is-layout-row',
							icon: 'single-header-row',
							name: 'Row'
						},
						{
							key: 'is-layout-grid',
							icon: 'multi-header-row',
							name: 'Grid'
						}
					],
					filters: getFiltersForImportMappingType(mappingColumnsArr),
					onDisplayChange
				},
				hasTemplateMappingChanged: false,
				hasUsedTemplate: HAS_USED_TEMPLATE,
				hiddenColumnsArr,
				importContext,
				importingPercentComplete: 0,
				isAdjustmentImportMappingType: IS_ADJUSTMENTS_IMPORT_TYPE,
				isChangeTypeMapped: false,
				isContextVisible: true,
				isIgnoreAllRowsEnabled: false,
				isMappingHeaderActive: false,
				isMappingValid: false,
				isPayElementImportMappingTypeWithElementLabel: importService.getIsPayElementImportMappingTypeWithElementLabel(importMappingType),
				isRatedElementMapped: false,
				isRowDataValid: importService.isRowDataValid(fileDataObj, importMappingType, IS_BUREAU_MAPPING),
				isVertical: importService.getIsVerticalLayout(companyLayoutTypeIsVertical, layoutType),
				leavers: importService.getLeavers(fileDataObj, importContext, importMappingType),
				linkElementsDetails: linkElementsDetailsObj,
				mappingColumns: decorateMappingColumnsArrForMappingType(mappingColumnsArr, importMappingType),
				mappingColumnsVisible: angular.copy(DEFAULT_MAPPING_COLUMNS_VISIBLE),
				mappingColumnsFiltered: [],
				mappingColumnsIndex: 0,
				payPeriodId: payPeriodId,
				payPeriodStartDateISO: payPeriodObj ? payPeriodObj.StartDateISO : null,
				payPeriodEndDateISO: payPeriodObj ? payPeriodObj.EndDateISO : null,
				showHiddenColumnsFilter: (value) => {

					if (SHOW_HIDDEN_COLUMNS) {
						return value;
					}

					// Hidden on platform
					if (value.ImportMappingColumnHidden) {
						return;
					}

					// Hidden in UI (e.g. hide empty columns)
					if (value.isHidden) {
						return;
					}

					return value;
				},
				showHiddenColumnsFilterForCells: (value) => {

					if (SHOW_HIDDEN_COLUMNS) {
						return value;
					}

					// Hide cells that exceed the number of file columns (extra padded values from platform)
					if (value.originalIndex >= fileDataObj.Columns.length) {
						return;
					}

					// Has to compare against ignored header columns array
					if (hiddenColumnsArr.indexOf(value.originalIndex) > -1) {
						return;
					}

					// Hidden in UI (e.g. hide empty columns)
					if (value.isHidden) {
						return;
					}

					return value;
				},
				state: getInitialState(importMappingType),
				teamMemberViewTypes: TEAM_MEMBER_VIEW_TYPES,
				teamMemberViewType: angular.copy(TEAM_MEMBER_VIEW_TYPES[0]),
				totalValidationValue: 0,
				uploadingProgress: 0,
				xeroLoadingPercentage: 0,
				financialsLoadingPercentage: 0
			});

			// Mapping types that require the selection of pay elements or labels
			if (IS_PAY_ELEMENTS_APPLICABLE) {

				const adjustmentTypeFilterKey = getAdjustmentTypeFilterKey();

				// Get all adjustment types as a single array (move to platform?)
				let adjustmentTypesArr = adjustmentsService.getAllAdjustmentTypesFromAdjustmentGroup(adjustmentGroupsObj, adjustmentTypeFilterKey);

				angular.extend(vmObj, {
					adjustmentLabels: adjustmentsService.decorateLabelsWithAdjustmentTypes(adjustmentLabelsArray, adjustmentTypesArr),
					adjustmentTypes: adjustmentTypesArr
				});
			}

			countPopulatedCellsForAllColumns(vmObj);
			decorateMappingColumns(vmObj);
			selectMappingFilter(vmObj);
			hideEmptyColumns(vmObj);

			// Auto map headers if template used
			if (HAS_USED_TEMPLATE) {
				autoMapColumnsByProperty(vmObj);

				checkDuplicateFileHeaders(vmObj);
			}

			// Default mapping template has changed > save to server
			if (hasDefaultMappingTemplateChanged(vmObj)) {
				updateImportMappingTemplateDefault(vmObj);
			}

			// Rates & Units
			if (importService.getIsRatesUnitsImportMappingType(importMappingType)) {
				updateRatesAndUnitsFilter(vmObj);
			}

			// Some specific import mapping types are automatically mapped (e.g. link rates)
			if (IS_AUTO_MAPPED) {
				autoMapColumnsByName(vmObj);
			}

			setPageState('ready');

			// Xero indicative loading screen
			if (importMappingType === IMPORT_MAPPING_TYPES.xeroNominalCodes) {

				$timeout(() => {
					$scope.vm.xeroLoadingPercentage = 50;

					$timeout(() => {
						$scope.vm.xeroLoadingPercentage = 100;

						$timeout(() => {
							setImportState(vmObj, 'mapping');
						}, 1000);
					}, 1000);
				}, 1000);
			}

			// Financials indicative loading screen
			if (importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts ||
				importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories) {

				$timeout(() => {
					$scope.vm.financialsLoadingPercentage = 50;

					$timeout(() => {
						$scope.vm.financialsLoadingPercentage = 100;

						$timeout(() => {
							setImportState(vmObj, 'mapping');
						}, 1000);
					}, 1000);
				}, 1000);
			}

			// Check for duplicate headers in file
			if (vmObj.duplicateFileColumns.length > 0) {
				$rootScope.openModalDialog({
					modalData: {
						fileColumns: vmObj.duplicateFileColumns
					},
					modalKey: 'imports-duplicate-mapping-headers'
				});
			}

			// Show message if leavers appear in validated import file
			if (vmObj.leavers.length > 0) {
				$rootScope.openModalDialog({
					modalData: {
						leavers: vmObj.leavers
					},
					modalKey: 'imports-leavers'
				});
			}

			// Optional debugging
			if (IS_IN_DEBUG_MODE) {
				console.info({
					hasUsedTemplate: HAS_USED_TEMPLATE,
					isAutoMapped: IS_AUTO_MAPPED,
					isBureauMapping: IS_BUREAU_MAPPING,
					isPayElementsApplicable: {
						paye: IS_PAY_ELEMENTS_APPLICABLE,
						cis: IS_PAY_ELEMENTS_APPLICABLE_CIS
					},
					mappingDirection: vmObj.isVertical ? 'vertical' : 'horizontal'
				});
			}
		})
		.catch(onError);
	}

	function isMappingHeaderMappable (mappingHeaderObj) {

		if (mappingHeaderObj.isReusable) {
			return true;
		}

		if (mappingHeaderObj.isInUse) {
			return false;
		}

		if (mappingHeaderObj.isIgnored) {
			return false;
		}

		return true;
	}

	function isPayElementMappingHeader (vmObj, mappingHeaderIndex) {

		// Based on Mapping Type
		if (vmObj.isPayElementImportMappingTypeWithElementLabel) {
			return true;
		}

		// Based on Mapping Header Type: Horizontal > Fixed & Fixed recurring
		if (isPayElementMappingHeaderHorizontal(vmObj, mappingHeaderIndex)) {
			return true;
		}

		return false;
	}

	function isPayElementMappingHeaderHorizontal (vmObj, mappingHeaderOriginalIndex) {

		const mappingHeaderObj = getMappingColumnByOriginalIndex(vmObj, mappingHeaderOriginalIndex);

		if (vmObj.isVertical) {
			return false;
		}

		if (mappingHeaderObj.ImportMappingColumnText === 'Type') {
			return true;
		}

		return false;
	}

	function isStateValid () {

		if (angular.isUndefined(agencyDocumentId)) {
			$rootScope.paycircleMessage('No document id defined', 'error');
			return false;
		}

		if (isNaN(agencyDocumentType)) {
			$rootScope.paycircleMessage('No agency document type defined', 'error');
			return false;
		}

		if (angular.isUndefined(agencyProfileId)) {
			$rootScope.paycircleMessage('No agency profile id defined', 'error');
			return false;
		}

		if (isNaN(importMappingType)) {
			$rootScope.paycircleMessage('No import mapping type defined', 'error');
			return false;
		}

		if (angular.isUndefined(payPeriodId)) {
			$rootScope.paycircleMessage('No pay period id defined', 'error');
			return false;
		}

		return true;
	}

	function mapAdjustmentTypes (vmObj, columnIndex, searchString) {

		// Rows
		vmObj.fileData.Rows.forEach((rowObj, rowIndex) => {

			// Adjustment Type (string)
			const searchTerm = angular.isDefined(searchString) ? searchString : rowObj.cells[columnIndex].value;

			// Match adjustment type
			const adjustmentDetailsObj = getAdjustmentDetailsByString(vmObj, searchTerm);

			// Set values
			updateRowAdjustmentTypeByIndex(vmObj, rowIndex, adjustmentDetailsObj.adjustmentTypeObj);

			// Default rate type to 'Calculated Hourly Rate'
			if (IS_PAY_ELEMENTS_APPLICABLE_RATED_UNITS) {
				updateRowAdjustmentRateTypeCellValueByIndex(vmObj, rowIndex, vmObj.defaultRateType);
			}

			if (adjustmentDetailsObj.matchType === 'label') {
				updateRowAdjustmentLabelByIndex(vmObj, rowIndex, adjustmentDetailsObj.adjustmentLabelObj.AgencyAdjustmentLabelText);
			}
			else {
				rowObj.adjustmentLabel = '';
			}
		});

		// For validation and UI display
		vmObj.isChangeTypeMapped = true;

		if (IS_PAY_ELEMENTS_APPLICABLE_RATED_UNITS) {
			vmObj.isRatedElementMapped = true;
		}
	}

	function mapLinkElements (vmObj, columnIndex, searchString) {

		// Rows
		vmObj.fileData.Rows.forEach((rowObj, rowIndex) => {

			// Adjustment Type (string)
			const searchTerm = angular.isDefined(searchString) ? searchString : rowObj.cells[columnIndex].value;

			// Match adjustment type
			const linkElementObj = getLinkElementDetailsByString(vmObj, searchTerm);

			// Set values
			if (linkElementObj) {
				updateRowAdjustmentTypeByIndexForLinkElement(vmObj, rowIndex, linkElementObj);
			}
		});

		// For validation and UI display
		vmObj.isLinkElementMapped = true;
	}

	function getLoadingString (headerCount) {

		const dynamicString = headerCount === 1 ? 'header' : 'headers';

		return `Auto-mapping ${headerCount} ${dynamicString}. This may take a few moments depending on the size of your file.`;
	}

	function matchHeadersByIndexes (vmObj, autoMatchedIndexesArr, IS_MANUAL_DROP, IS_BULK_MAPPING) {

		const VALIDATE_FILE = false;
		const deferred = $q.defer();

		// Delay updating so that we can validate the entire file once all columns are matched
		if (autoMatchedIndexesArr.length === 0) {
			deferred.resolve('No matched mapping headers');
			return deferred.promise;
		}

		const loadingString = getLoadingString(autoMatchedIndexesArr.length);

		applicationService.displaySecondaryLoader(loadingString);

		let updatedMappingHeadersArr = [];

		// Reset duplicate mapping headers array
		vmObj.duplicateFileColumns = [];

		autoMatchedIndexesArr.forEach(autoMatchedIndexObj => {

			// Update mapping header object
			updateColumnMapping(vmObj, autoMatchedIndexObj.headerOriginalIndex, autoMatchedIndexObj.fileColumnOriginalIndex, IS_MANUAL_DROP, {}, VALIDATE_FILE, IS_BULK_MAPPING);

			// Add updated mapping header object to array
			updatedMappingHeadersArr.push(getFileColumnByOriginalIndex(vmObj, autoMatchedIndexObj.fileColumnOriginalIndex));
		});

		$timeout(() => {

			dataImport.updateImportMappingColumnBulk(updatedMappingHeadersArr).then(() => {

				// Extract unique policy names for click-to-match after columns are mapped
				if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && !vmObj.uniquePolicyNamesCollected) {
					extractUniquePolicyNames(vmObj);
				}

				validateMapping(vmObj);
				validateRowData(vmObj);

				// Reset active mapping header
				resetActiveMappingHeader(vmObj);

				applicationService.hideSecondaryLoader();

				// Duplicate headers
				if (vmObj.duplicateFileColumns.length > 0) {
					$rootScope.openModalDialog({
						modalData: {
							fileColumns: vmObj.duplicateFileColumns
						},
						modalKey: 'imports-duplicate-mapping-headers'
					});
				}
			})
			.catch(error => {
				onError(error);
				throw('Unable to update import mapping column bulk');
			});
		});
	}

	function onDisplayChange (filterBarOptionsObj) {

		switch (filterBarOptionsObj.displayOption.key) {
			case 'is-layout-row':

				// Hides/Disables 'More' link
				$scope.vm.mappingColumnsVisible = Infinity;

				break;

			case 'is-layout-grid':

				// Re-enables 'More' link
				$scope.vm.mappingColumnsVisible = DEFAULT_MAPPING_COLUMNS_VISIBLE;

				break;
		}
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function onToggleFullScreen () {

		const dataImpoterContentElement = $element[0].querySelector('#data-importer-content');

		utilities.toggleBrowserFullScreen(dataImpoterContentElement);
	}

	function openEditPayElementNetToGrossForm (vmObj, columnOriginalIndex) {

		const fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);

		$rootScope.openSlideInForm({
			agencyProfileId,
			fileColumn: fileColumnObj,
			callback: callbackObj => {

				// Update column data based on selection in form
				fileColumnObj.AgencyAdjustmentNetToGross = callbackObj.isNetImport;

				// Save to DB
				saveColumnMapping(vmObj, columnOriginalIndex);

				// Track manual template mapping changes
				vmObj.hasTemplateMappingChanged = true;
			},
			formKey: 'pay-element-net-to-gross'
		});
	}

	function openEditPayElementRateTypeForm (vmObj, columnOriginalIndex) {

		const fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);

		$rootScope.openSlideInForm({
			agencyProfileId,
			fileColumn: fileColumnObj,
			callback: callbackObj => {

				// Update column data based on selection in form
				fileColumnObj.AgencyAdjustmentRateType = callbackObj.payElementRateType;

				// Save to DB
				saveColumnMapping(vmObj, columnOriginalIndex);

				// Track manual template mapping changes
				vmObj.hasTemplateMappingChanged = true;
			},
			formKey: 'pay-element-rate-type'
		});
	}

	function openMappingTemplateForm (vmObj, actionType) {

		// If no template is used, use ImportMappingID from file date service
		if (!vmObj.importMappingTemplate.isTemplate) {
			angular.extend(vmObj.importMappingTemplate, {
				ImportMappingID: vmObj.fileData.ImportMappingID,
				Name: ''
			});
		}

		$rootScope.openSlideInForm({
			actionType,
			agencyDocumentId: vmObj.agencyDocumentId,
			agencyProfileId,
			callback: callbackResponseObj => {

				angular.extend($scope.vm, {
					hasSavedFileMapping: true,
					hasTemplateMappingChanged: false,
					templateTotalMatchedColumns: angular.copy(vmObj.totalMappedColumns) // Take a snapshot of number of columns changed to know when a saved mapping template has changed
				});

				refreshMappingTemplates($scope.vm, callbackResponseObj.updatedMappingTemplate);
			},
			formKey: 'mapping-template',
			headerCount: vmObj.totalMappedColumns,
			fileColumns: vmObj.fileData.Columns,
			importMappingTemplate: vmObj.importMappingTemplate,
			title: actionType === 'update' ? 'Update mapping' : null
		});
	}

	/**
	 * Updates the policy match counts and allPoliciesMatched flag.
	 * Used after a policy is matched or skipped via click-to-match.
	 **/
	function updatePolicyMatchCounts (vmObj) {

		vmObj.allPoliciesMatched = Object.keys(vmObj.policyMatches).every(function (key) {
			return vmObj.policyMatches[key].matched;
		});

		vmObj.policyMatchedCount = Object.keys(vmObj.policyMatches).filter(function (key) {
			return vmObj.policyMatches[key].matched && !vmObj.policyMatches[key].skipped;
		}).length;

		vmObj.policySkippedCount = Object.keys(vmObj.policyMatches).filter(function (key) {
			return vmObj.policyMatches[key].skipped;
		}).length;

		// Exclude skipped policies (e.g. locked with pending update) from the total count
		// so users can complete the import without being blocked by policies that can't be updated.
		vmObj.policyTotalCount = Object.keys(vmObj.policyMatches).filter(function (key) {
			return !vmObj.policyMatches[key].skipped;
		}).length;
	}

	/**
	 * Writes policy metadata from click-to-match into the hidden columns for all rows matching a policy name.
	 * Follows the pattern of updateRowAdjustmentTypeByIndex.
	 **/
	function updateRowsPolicyMetadata (vmObj, policyName, matchData) {

		const payBasisIndex = getColumnIndexForPolicyPayBasis(vmObj);
		const effectiveDateIndex = getColumnIndexForPolicyEffectiveDate(vmObj);
		const hoursPerWeekIndex = getColumnIndexForPolicyHoursPerWeek(vmObj);
		const weeksPerYearIndex = getColumnIndexForPolicyWeeksPerYear(vmObj);
		const isPensionableIndex = getColumnIndexForPolicyIsPensionable(vmObj);

		vmObj.fileData.Rows.forEach(function (rowObj) {
			const rowPolicyName = getPolicyNameForRow(vmObj, rowObj);

			if (rowPolicyName && rowPolicyName.toLowerCase() === policyName.toLowerCase()) {
				rowObj.Values[payBasisIndex] = String(matchData.policyPayBasis);
				rowObj.Values[effectiveDateIndex] = matchData.effectiveDateISO || '';
				rowObj.Values[hoursPerWeekIndex] = String(matchData.hoursPerWeek);
				rowObj.Values[weeksPerYearIndex] = String(matchData.weeksPerYear);
				rowObj.Values[isPensionableIndex] = String(matchData.isPensionable !== false);

				rowObj.cells[payBasisIndex].value = String(matchData.policyPayBasis);
				rowObj.cells[effectiveDateIndex].value = matchData.effectiveDateISO || '';
				rowObj.cells[hoursPerWeekIndex].value = String(matchData.hoursPerWeek);
				rowObj.cells[weeksPerYearIndex].value = String(matchData.weeksPerYear);
				rowObj.cells[isPensionableIndex].value = String(matchData.isPensionable !== false);
			}
		});
	}

	/**
	 * Opens the click-to-match flyout for collecting policy details.
	 * Follows the pattern of openMatchChangeTypeFormHorizontal.
	 **/
	function openMatchPolicyDetailsForm (vmObj, policyName) {

		let existingMatch = vmObj.policyMatches[policyName];

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			isPayPeriodMinimumRequired: true,
			callback: responseObj => {

				switch (responseObj.responseState) {

					case 'update': {

						vmObj.policyMatches[policyName].data = {
							policyPayBasis: responseObj.policyPayBasis,
							effectiveDateISO: responseObj.effectiveDateISO,
							hoursPerWeek: responseObj.hoursPerWeek,
							weeksPerYear: responseObj.weeksPerYear,
							isPensionable: responseObj.isPensionable,
							pensionState: responseObj.pensionState,
							isExistingPolicy: responseObj.isExistingPolicy,
							isPolicyRestricted: responseObj.isPolicyRestricted
						};
						vmObj.policyMatches[policyName].matched = true;
						vmObj.policyMatches[policyName].skipped = false;

						updateRowsPolicyMetadata(vmObj, policyName, vmObj.policyMatches[policyName].data);

						updatePolicyMatchCounts(vmObj);
						reValidateAll(vmObj);
						break;
					}

					case 'skip': {

						// Policy can't be updated (locked/pending update/future changes).
						// Mark as matched + skipped so it doesn't block the import but is excluded from import data.
						vmObj.policyMatches[policyName].matched = true;
						vmObj.policyMatches[policyName].skipped = true;
						vmObj.policyMatches[policyName].data = null;

						// Immediately mark all rows for this policy as ignored in the UI grid
						vmObj.fileData.Rows.forEach(function (rowObj) {
							var rowPolicyName = getPolicyNameForRow(vmObj, rowObj);
							if (rowPolicyName && rowPolicyName.toLowerCase() === policyName.toLowerCase()) {
								rowObj.Ignore = true;
							}
						});

						updatePolicyMatchCounts(vmObj);
						reValidateAll(vmObj);
						break;
					}
				}
			},
			formKey: 'match-policy-details',
			policyName: policyName,
			policyPayBasis: existingMatch.data ? existingMatch.data.policyPayBasis : null,
			effectiveDateISO: existingMatch.data ? existingMatch.data.effectiveDateISO : '',
			hoursPerWeek: existingMatch.data ? existingMatch.data.hoursPerWeek : null,
			weeksPerYear: existingMatch.data ? existingMatch.data.weeksPerYear : null,
			pensionState: existingMatch.data ? existingMatch.data.pensionState : null,
			isExistingPolicy: false
		});
	}

	/**
	 * Matches 'hidden' columns within each row for horizontal imports:
	 * Adjustment Type (guid)
	 * Adjustment Label (string)
	 * Net to Gross (bool)
	 * Adjustment Rate Type (enum)
	**/
	function openMatchChangeTypeFormHorizontal (vmObj, fileRowOriginalIndex) {

		let rowObj = getFileRowByOriginalIndex(vmObj, fileRowOriginalIndex);

		$rootScope.openSlideInForm({
			adjustmentLabel: rowObj.adjustmentLabel,
			adjustmentLabels: vmObj.adjustmentLabels,
			adjustmentType: rowObj.adjustmentType,
			adjustmentTypes: vmObj.adjustmentTypes,
			agencyProfileId: agencyProfileId,
			callback: responseObj => {

				switch (responseObj.responseState) {

					case 'update': {

						const originalCellValue = getAdjustmentTypeValueForRow(vmObj, fileRowOriginalIndex);

						// Update all change types with the same cell value
						vmObj.fileData.Rows.forEach((rowObj, rowIndex) => {

							let rowAdjustmentTypeCellValue = getAdjustmentTypeValueForRow(vmObj, rowIndex);

							// Replace all row values of the same original value
							if (rowAdjustmentTypeCellValue.toLowerCase() === originalCellValue.toLowerCase()) {

								const newCellValue = responseObj.adjustmentLabel !== '' ? responseObj.adjustmentLabel : responseObj.adjustmentType.AgencyAdjustmentGroupEntryText;

								// Update adjustment type / label / net to gross values for the row
								updateRowAdjustmentTypeByIndex(vmObj, rowIndex, responseObj.adjustmentType);
								updateRowAdjustmentLabelByIndex(vmObj, rowIndex, responseObj.adjustmentLabel);
								updateRowNetToGrossCellValueByIndex(vmObj, rowIndex, responseObj.isNetImport);
								updateRowAdjustmentRateTypeCellValueByIndex(vmObj, rowIndex, responseObj.payElementRateType);
								rowObj.NetToGross = responseObj.isNetImport;
								rowObj.AgencyAdjustmentRateType = responseObj.payElementRateType;

								// Update cell value
								updateRowAdjustmentTypeCellValueByIndex(vmObj, rowIndex, newCellValue);
							}
						});

						reValidateAll(vmObj);
					}
				}
			},
			formKey: 'match-change-type',
			importMappingType: vmObj.importMappingType,
			isNetImport: rowObj.NetToGross,
			payElementRateType: rowObj.AgencyAdjustmentRateType,
		});
	}

	// Matches Adjustment Type (guid) & Adjustment Label (string) to the mapped file column (vertical)
	function openMatchChangeTypeFormVertical (vmObj, columnOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);

		$rootScope.openSlideInForm({
			adjustmentLabel: fileColumnObj.AgencyAdjustmentLabel,
			adjustmentLabels: vmObj.adjustmentLabels,
			adjustmentType: fileColumnObj.adjustmentType,
			adjustmentTypes: vmObj.adjustmentTypes,
			agencyProfileId: agencyProfileId,
			callback: responseObj => {

				let columnGroupArr = getColumnsArrByGroupId(vmObj, fileColumnObj.mappingColumnGroupId);

				switch (responseObj.responseState) {

					case 'update':

						const adjustmentGroupEntryId = responseObj.adjustmentType ? adjustmentsService.getAgencyAdjustmentGroupEntryId(responseObj.adjustmentType) : '';

						// Map details for both rate and unit columns
						columnGroupArr.forEach(_ => {

							// Map adjustment type & label
							_.AgencyAdjustmentGroupEntryID = adjustmentGroupEntryId;
							_.AgencyAdjustmentID = responseObj.adjustmentType.AgencyAdjustmentID;
							_.AgencyAdjustmentLabel = responseObj.adjustmentLabel;
							_.AgencyAdjustmentNetToGross = responseObj.isNetImport;
							_.adjustmentType = responseObj.adjustmentType;

							// Update column text
							_.mappingHeader.ImportMappingColumnText = responseObj.adjustmentType.AgencyAdjustmentGroupEntryText;
							_.mappingHeader.isPayElementNetable = responseObj.isPayElementNetable;
							_.mappingHeader.isPayElementRateTypeEditable = responseObj.isPayElementRateTypeEditable;

							// Save to DB
							dataImport.updateImportMappingColumn(_).then(updatedFileColumnObj => {

								angular.extend(_, updatedFileColumnObj);
							})
							.catch(onError);
						});

						// Increment Rates / Units headers pair
						setAndUpdateRatesAndUnitsFilterIndex(vmObj);

						// Validate
						reValidateAll(vmObj);

						break;

					case 'cancel':

						// Map details for both rate and unit columns
						columnGroupArr.forEach(_ => {

							// Reset mapping header
							if (_.mappingHeader) {
								resetMappingHeaderByOriginalIndex(vmObj, _.mappingHeader.originalIndex);
							}

							// Reset file column
							resetFileColumnObj(_);
						});

						// Increment Rates / Units headers pair
						setAndUpdateRatesAndUnitsFilterIndex(vmObj);

						// Validate
						reValidateAll(vmObj);

						break;
				}
			},
			canCloseForm: false,
			formKey: 'match-change-type',
			importMappingType: vmObj.importMappingType,
		});
	}

	// Matches link element (horizontal)
	function openMatchLinkElementFormHorizontal (vmObj, fileRowOriginalIndex) {

		$rootScope.openSlideInForm({
			layoutType: 'horizontal',
			linkElements: vmObj.linkElementsDetails.LinkElements,
			agencyProfileId: agencyProfileId,
			callback: callbackObj => {

				switch (callbackObj.actionType) {

					// 1. Open 'Match link rate' form
					// 2. Click 'Create a new Link Element' > Save
					// 3. Link elements are reloaded (to include newly created one)
					// 4. 'Match link rate' form is then re-opened with the new set of link elements
					case 'updated':

						$timeout(() => {
							refreshLinkElements(vmObj).then(vmObj => {
								openMatchLinkElementFormHorizontal(vmObj, fileRowOriginalIndex);
							});
						});

						break;

					// 1. Take original cell value (that has been mapped to Link Element)
					// 2. Compare original cell value to all cell values in the same row
					// 3. Update Link Element for all matched cell rows
					default:

						// Compare to original cell value to update any cells with the same value to use the same
						const originalCellValue = getAdjustmentTypeValueForRow(vmObj, fileRowOriginalIndex);

						// Update all change types with the same cell value
						vmObj.fileData.Rows.forEach((rowObj, rowIndex) => {

							let rowAdjustmentTypeCellValue = getAdjustmentTypeValueForRow(vmObj, rowIndex);

							// Replace all row values of the same original value
							if (rowAdjustmentTypeCellValue.toLowerCase() === originalCellValue.toLowerCase()) {

								const newCellValue = callbackObj.linkElement.LinkElementName;

								// Update adjustment type / label for the row
								updateRowAdjustmentTypeByIndexForLinkElement(vmObj, rowIndex, callbackObj.linkElement);

								// Update cell value
								updateRowAdjustmentTypeCellValueByIndex(vmObj, rowIndex, newCellValue);
							}
						});

						reValidateAll(vmObj);
				}
			},
			formKey: 'match-link-element',
			importMappingType: vmObj.importMappingType
		});
	}

	// Matches link element (vertical)
	function openMatchLinkElementFormVertical (vmObj, columnOriginalIndex) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			layoutType: 'vertical',
			mappingHeaders: vmObj.mappingColumns,
			callback: callbackObj => {

				switch (callbackObj.actionType) {

					// 1. Open 'Match link rate' form
					// 2. Click 'Create a new Link Element' > Save
					// 3. Mapping columns are reloaded (to include newly created one)
					// 4. 'Match link rate' form is then re-opened with the new set of mapping headers
					case 'updated':

						$timeout(() => {
							getNewMappingColumn(vmObj).then((vmObj) => {
								openMatchLinkElementFormVertical(vmObj, columnOriginalIndex);
							});
						});

						break;

					default:

						const IS_MANUAL_DROP = true;

						updateColumnMapping(vmObj, callbackObj.linkElement.originalIndex, columnOriginalIndex, IS_MANUAL_DROP);

						saveColumnMapping(vmObj, columnOriginalIndex);
				}

			},
			formKey: 'match-link-element'
		});
	}

	function openMatchPayslipLabelForm (vmObj, columnOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);

		$rootScope.openSlideInForm({
			adjustmentLabel: fileColumnObj.AgencyAdjustmentLabel,
			fileColumn: fileColumnObj,
			callback: callbackObj => {

				switch (fileColumnObj.ImportMappingColumnType) {
					case IMPORT_MAPPING_COLUMN_TYPES.rate:
					case IMPORT_MAPPING_COLUMN_TYPES.unit:

						let columnGroupArr = getColumnsArrByGroupId(vmObj, fileColumnObj.mappingColumnGroupId);

						// Map details for both rate and unit columns
						columnGroupArr.forEach(_ => {

							// Map adjustment label
							_.AgencyAdjustmentLabel = callbackObj.adjustmentLabel;

							dataImport.updateImportMappingColumn(_).catch(onError);
						});

						break;

					default:

						fileColumnObj.AgencyAdjustmentLabel = callbackObj.adjustmentLabel;

						// Update label on server
						dataImport.updateImportMappingColumn(fileColumnObj).catch(onError);
				}

			},
			formKey: 'match-payslip-label'
		});
	}

	function openUpdateValidationResultForm (vm, rowObj, validationResult) {

		let formKey = 'update-validation-result';
		let formTitle = validationResult.ValidationType.ValidationTypeText;

		if (recurringPayElementImportService.assessIsRecurringImportType(importMappingType)) {
			formKey = 'update-payelement-validation-result';
			formTitle = vm.fileData.Columns.find(x => x.ImportMappingColumnNumber === validationResult.ValidationResultColNumber).ImportMappingColumnText;
		}

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: (responseObj) => {
				updateValidationResult(responseObj, validationResult);
			},
			formKey: formKey,
			rowObj,
			title: formTitle,
			validationResult
		});
	}

	function openPayElementMatchingForm (vm, rowObj, validationResult) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: (responseObj) => {
				handlePayElementMatchResolution(responseObj, rowObj, validationResult);
			},
			formKey: 'pay-element-matching',
			rowObj: rowObj,
			title: 'Resolve pay element match',
			validationResult: validationResult
		});
	}

	function handlePayElementMatchResolution (responseObj, rowObj, originalValidationResult) {

		if (responseObj.callbackAction === 'pay-element-match-resolution' && responseObj.resolution) {
			let resolution = responseObj.resolution;
			let validationTypeID = responseObj.validationResult.ValidationResultTypeID;

			if (resolution.SkipRow) {
				// Mark the row as skipped/ignored
				rowObj.Ignore = true;
				return;
			}

			responseObj.validationResult.ValidationResultImportValue = JSON.stringify(resolution); 
			responseObj.validationResult.ValidationResultTypeID = validationTypeID;
			responseObj.validationResult.ValidationType.ValidationTypeID = validationTypeID;

			updateValidationResult(responseObj, originalValidationResult);
		}
	}

	function openValidateDataForm (rowObj, validationObj) {

		// As there can be multiple validation results, attach the specific validation result related to this action
		rowObj.validationResult = validationObj;

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: (responseObj) => {
				updateValidationResult(responseObj, validationObj);
			},
			formKey: 'validate-data',
			rowObj: rowObj,
			title: rowObj.actionMessage
		});
	}

	function refreshLinkElements (vmObj) {

		let deferred = $q.defer();

		payrollData.getLinkElements(agencyProfileId).then(linkElementsDetailsObj => {

			vmObj.linkElementsDetails = linkElementsDetailsObj;

			deferred.resolve(vmObj);
		})
		.catch(error => {
			deferred.reject();
			onError(error);
		});

		return deferred.promise;
	}

	function refreshMappingTemplates (vmObj, updatedMappingTemplate) {

		dataImport.getImportMappingTemplates(agencyProfileId, importMappingType).then(mappingTemplatesArr => {

			// Inconsistencies in service objects mean we can only map based on name currently - to be improved (JE)
			angular.extend(vmObj, {
				mappingTemplates: decorateMappingTemplates(mappingTemplatesArr).filter(template => angular.isUndefined(template.IgnoreTemplate) || !template.IgnoreTemplate),
				importMappingTemplate: angular.copy(mappingTemplatesArr.find(mappingTemplateObj => mappingTemplateObj.Name === updatedMappingTemplate.Name))
			});

		})
		.catch(onError);
	}

	function resetActiveMappingHeader (vmObj) {

		angular.extend(vmObj, {
			activeMappingHeaderIndex: null
		});
	}

	function resetFileColumnObj (fileColumnObj) {

		fileColumnObj.AgencyAdjustmentGroupEntryID = config.guidEmpty;
		fileColumnObj.AgencyAdjustmentID = config.guidEmpty;
		fileColumnObj.AgencyAdjustmentLabel = '';
		fileColumnObj.ImportMappingColumnProperty = '';
		fileColumnObj.ImportMappingColumnRegex = '';
		fileColumnObj.ImportMappingColumnValidationValue = 0;

		fileColumnObj.adjustmentType = null;
		fileColumnObj.isInUse = false;
		fileColumnObj.isLinked = false;
		fileColumnObj.mappingColumnGroupId = null;
		fileColumnObj.mappingHeader = null;
		fileColumnObj.state = null;
	}

	function resetFileColumnObjByOriginalIndex (vmObj, fileColumnOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, fileColumnOriginalIndex);

		resetFileColumnObj(fileColumnObj);
	}

	function resetFileRowCellsByOriginalIndex (vmObj, fileRowOriginalIndex) {

		let fileRowObj = getFileRowByOriginalIndex(vmObj, fileRowOriginalIndex);

		fileRowObj.isInvalid = false;
	}

	function releaseMappingHeaderFromHolder (vmObj, mappingHeaderObj) {

		const numberOfFileColumns = getFileColumnsLength(vmObj);

		for (let k = 0; k < numberOfFileColumns; k++) {
			const holderColumnObj = getFileColumnByIndex(vmObj, k);
			if (holderColumnObj.mappingHeader && holderColumnObj.mappingHeader.originalIndex === mappingHeaderObj.originalIndex) {
				resetMappingHeaderByOriginalIndex(vmObj, mappingHeaderObj.originalIndex);
				resetFileColumnObj(holderColumnObj);
				break;
			}
		}
	}

	function resetMappingHeaderByOriginalIndex (vmObj, mappingHeaderOriginalIndex) {

		let mappingHeaderObj = getMappingColumnByOriginalIndex(vmObj, mappingHeaderOriginalIndex);

		mappingHeaderObj.isInUse = false;
		mappingHeaderObj.state = null;
		
		if (!recurringPayElementImportService.assessIsRecurringMappingSettingColumn(mappingHeaderObj)) {
			resetMappingHeadersBymappingColumnGroupId(vmObj, mappingHeaderObj);
		}

		if (vmObj.isVertical) {
			recurringPayElementImportService.resetActiveRecurringColumnGroup(vmObj);
		}
	}

	/**
	 * Removes mapping for all columns sharing the same mappingColumnGroupId
	 * @param {Object} vmObj - View model object
	 * @param {Object} mappingHeaderObj - Mapping header object being unmapped
	 */
	function resetMappingHeadersBymappingColumnGroupId (vmObj, mappingHeaderObj) {
		if (angular.isDefined(mappingHeaderObj.mappingColumnGroupId)) {
			vmObj.fileData.Columns.forEach(m => {
				if (m.mappingHeader && 
					angular.isDefined(m.mappingHeader.mappingColumnGroupId) && 
					m.mappingHeader.mappingColumnGroupId === mappingHeaderObj.mappingColumnGroupId)
				{
					let header = getMappingColumnByOriginalIndex(vmObj, m.mappingHeader.originalIndex);
					header.isInUse = false;
					header.state = null;
					
					resetFileColumnObj(m);
					m.loadingState = 'ready';
				}
			});
		}
	}

	function resetRowsForFileColumnObj (vmObj, fileColumnObj) {

		vmObj.fileData.Rows.forEach((fileRowObj) => {

			var cellObj = fileRowObj.cells[fileColumnObj.ImportMappingColumnNumber];

			// Validate (default to true)
			cellObj.isValid = true;
		});
	}

	function reviewActiveMappingColumn (vmObj, mappingHeaderObj) {
		recurringPayElementImportService.setActiveRecurringColumnGroup(vmObj, mappingHeaderObj.mappingColumnGroupId);

		if (vmObj.activeMappingHeaderIndex === mappingHeaderObj.originalIndex) {
			vmObj.activeMappingHeaderIndex = null;

			if (vmObj.isVertical) {
				recurringPayElementImportService.resetActiveRecurringColumnGroup(vmObj);
			}
		}
	}

	function reValidateAll (vmObj) {

		validateColumnsInUse(vmObj);
		validateRowData(vmObj);

		// Extract unique policy names for click-to-match after columns are mapped
		if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && !vmObj.uniquePolicyNamesCollected) {
			extractUniquePolicyNames(vmObj);
		}

		// Not applicable to validation results
		if (vmObj.state !== 'validation-results' && vmObj.state !== 'validation-results-recurring-payelements') {
			validateMapping(vmObj);
		}
	}

	function selectMappingFilter (vmObj, filterObj) {

		// Select first available
		if (angular.isUndefined(filterObj)) {

			const filterOptionsArr = getMappingFilterOptionsByGroupIndex(vmObj, 0);

			filterObj = filterOptionsArr[0];
		}

		vmObj.activeMappingFilterKey = filterObj.key;
		vmObj.filterBarOptions.appliedFilter = filterObj.filterExp;
		//vmObj.activeMappingFilterExp = filterObj.filterExp;
	}

	function selectMappingFilterByKey (vmObj, key) {

		const filterOptionsArr = getMappingFilterOptionsByGroupIndex(vmObj, 0);
		const filterOptionsCount = filterOptionsArr.length;

		let i = 0;
		let selectedMappingFilterObj;

		for (i; i < filterOptionsCount; i++) {

			const filterOptionObj = filterOptionsArr[i];

			if (filterOptionObj.key === key) {
				selectedMappingFilterObj = angular.copy(filterOptionObj);
				break;
			}
		}

		// Unable to find filter obj by key
		if (angular.isUndefined(selectedMappingFilterObj)) {
			$rootScope.paycircleMessage('dataImporterValidateFileController.js > selectMappingFilterByKey: Unable to select mapping filter obj by key', 'error');
			return;
		}

		selectMappingFilter(vmObj, selectedMappingFilterObj);
	}

	function setActiveValidationResultFilter (vmObj, validationResultFilterObj) {

		vmObj.activeValidationResultFilter = validationResultFilterObj;

		$timeout(() => {
			vmObj.isIgnoreAllRowsEnabled = getIsIgnoreAllRowsEnabled(vmObj);
		});
	}

	function setAndUpdateRatesAndUnitsFilterIndex (vmObj, originalPropertyValue) {

		vmObj.mappingColumnsIndex = getMappingColumnIndex(vmObj, originalPropertyValue);

		updateRatesAndUnitsFilter(vmObj);
	}

	function setImportState (vmObj, importState) {

		vmObj.state = importState;
	}

	function setPageState (pageState, errorState) {

		$scope.pageState = pageState;

		if (angular.isDefined(errorState)) {
			$scope.errorState = errorState;
		}
	}

	function setupValidationResultsTabs (vmObj) {

		vmObj.validationResultFilters = [
			{
				canIgnore: true,
				hasActions: true,
				isHiddenWhenEmpty: true,
				isTeamMemberMatched: false,
				title: 'Warnings',
				theme: 'assertive inverse',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.warning,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.warning);
				}
			},
			{
				canIgnore: true,
				hasActions: false,
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: false,
				title: 'New',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.new,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.new);
				}
			},
			{
				canIgnore: true,
				hasActions: recurringPayElementImportService.assessIsRecurringImportType(importMappingType),
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: true,
				title: 'Updates',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.update,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.update);
				}
			},
			{
				canIgnore: false,
				hasActions: false,
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: true,
				title: 'Unchanged',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.unchanged,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.unchanged);
				}
			}
		];

		// Counts
		vmObj.fileData.Rows.forEach(rowObj => {

			// Skip ignored rows
			if (rowObj.Ignore) {
				return;
			}

			// No validation result returned for row
			if (angular.isUndefined(rowObj.validationResults) || rowObj.validationResults.length === 0) {
				console.info(rowObj);
				throw `Validation Result not defined for row. Each row should have an associated validation result, whether it's valid or not`;
			}

			rowObj.validationResults.forEach(validationResultObj => {

				switch (validationResultObj.ValidationType.ValidationTypeLevel) {

					case VALIDATION_TYPE_LEVELS.warning:
						vmObj.validationResultFilters[0].total++;
						break;

					case VALIDATION_TYPE_LEVELS.new:
						vmObj.validationResultFilters[1].total++;
						break;

					case VALIDATION_TYPE_LEVELS.update:
						vmObj.validationResultFilters[2].total++;
						break;

					case VALIDATION_TYPE_LEVELS.unchanged:
						vmObj.validationResultFilters[3].total++;
						break;
				}
			});
		});

		if (vmObj.validationResultFilters[0].total === 1) {
			vmObj.validationResultFilters[0].title = 'Warning';
		}

		setActiveValidationResultFilter(vmObj, importService.getFirstFilterWithResults(vmObj.validationResultFilters));
	}

	function showEmptyColumns (vmObj) {

		vmObj.fileData.Columns.forEach(columnObj => {

			if (columnObj.isHidden) {

				// Loop over every row and hide cell for hidden columns
				vmObj.fileData.Rows.forEach(rowObj => {

					let cellObj = getRowCellByOriginalIndex(vmObj, rowObj.originalIndex, columnObj.originalIndex);

					cellObj.isHidden = false;
				});

				// Delay the setting of the hidden flag so we only loop over columns that are already hidden
				columnObj.isHidden = false;
			}
		});

		vmObj.emptyColumnsState = 'visible';
	}

	function showMoreMappingColumns (vmObj) {

		vmObj.mappingColumnsVisible = vmObj.mappingColumnsVisible + 10;
	}

	function toggleIsIgnoreAllRowsEnabled (vmObj, filteredRowsArr, isIgnoreAllRowsEnabled) {

		let ignoreValue = angular.isDefined(isIgnoreAllRowsEnabled) ? isIgnoreAllRowsEnabled : vmObj.isIgnoreAllRowsEnabled;
		vmObj.isIgnoreAllRowsEnabled = ignoreValue;

		function toggleIgnoreRow (rowObj) {

			if (rowObj.isDisabled) {
				return;
			}

			return rowObj.Ignore = ignoreValue;
		}

		if (filteredRowsArr) {
			filteredRowsArr.forEach(toggleIgnoreRow);
		}
		else {
			vmObj.fileData.Rows.forEach(toggleIgnoreRow);
		}

		reValidateAll(vmObj);
	}

	function toggleMappingFilter (vmObj) {

		const newFilterKey = vmObj.activeMappingFilterKey === FILTER_KEYS.dataImporterValidate.validationState.all ? FILTER_KEYS.dataImporterValidate.validationState.invalid : FILTER_KEYS.dataImporterValidate.validationState.all;

		selectMappingFilterByKey(vmObj, newFilterKey);
	}

	function toggleShowColumn (vmObj, columnObj) {

		columnObj.isHidden = !columnObj.isHidden;

		// Loop over every row and hide cell for hidden columns
		vmObj.fileData.Rows.forEach(rowObj => {

			let cellObj = getRowCellByOriginalIndex(vmObj, rowObj.originalIndex, columnObj.originalIndex);

			cellObj.isHidden = columnObj.isHidden;
		});
	}

	function toggleShowContext (vmObj) {

		vmObj.isContextVisible = !vmObj.isContextVisible;
	}

	function unmapAdjustmentTypesHorizontal (vmObj) {

		vmObj.fileData.Rows.forEach((rowObj, rowIndex) => {

			updateRowAdjustmentTypeByIndex(vmObj, rowIndex, null);
			updateRowAdjustmentLabelByIndex(vmObj, rowIndex, '');
		});
	}

	/**
	 * Updates a column mapping when either:
	 * 1. A mapping header has been manually dropped onto a file column
	 * 2. Mapping headers have been auto-mapped to the file column headers:
	 * 		- Manually (by clicking 'Auto-map' button)
	 * 		- Automatically (by a mapping template being applied)
	 *
	 * Considerations:
	 * 		- Mapping headers cannot be re-used, unless specifically set to be re-useable
	 * 		- Rate / Unit mappings are mapped in pairs 😵‍💫
	 *  	- Element mappings attach the pay element object
	 * 		- Link elements
	**/
	function updateColumnMapping (vmObj, mappingHeaderOriginalIndex, fileColumnOriginalIndex, IS_MANUAL_DROP, fileColumnMetaObj, VALIDATE_FILE, IS_BULK_MAPPING) {

		IS_BULK_MAPPING = angular.isDefined(IS_BULK_MAPPING) ? IS_BULK_MAPPING : false;
		IS_MANUAL_DROP = angular.isDefined(IS_MANUAL_DROP) ? IS_MANUAL_DROP : false;
		VALIDATE_FILE = angular.isDefined(VALIDATE_FILE) ? VALIDATE_FILE : true;

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, fileColumnOriginalIndex);
		let mappingHeaderObj = getMappingColumnByOriginalIndex(vmObj, mappingHeaderOriginalIndex);

		// Release the old mapping header if the file column was already mapped to a different one
		if (fileColumnObj.mappingHeader && fileColumnObj.mappingHeader.originalIndex !== mappingHeaderOriginalIndex) {
			resetMappingHeaderByOriginalIndex(vmObj, fileColumnObj.mappingHeader.originalIndex);
		}

		// Prevent re-use
		if (!isMappingHeaderMappable(mappingHeaderObj)) {

			const existingDuplicateFileColumnObj = vmObj.duplicateFileColumns.find(_ => _.importMappingColumnText === fileColumnObj.ImportMappingColumnText);

			// Only push if not already created to avoid duplicates of the same column header
			if (!angular.isDefined(existingDuplicateFileColumnObj)) {
				vmObj.duplicateFileColumns.push({
					importMappingColumnText: fileColumnObj.ImportMappingColumnText,
				});
			}

			vmObj.duplicateFileColumns.push(mappingHeaderObj.ImportMappingColumnText);
			console.warn(`Mapping header is not mappable: ${mappingHeaderObj.ImportMappingColumnText}`);
			return;
		}

		// Mark as in use so it can't be re-used
		mappingHeaderObj.isInUse = true;

		// Copy mapping column obj across to file column obj
		angular.extend(fileColumnObj, {
			ImportMappingColumnLocalValidation: angular.copy(mappingHeaderObj.ImportMappingColumnLocalValidation),
			ImportMappingColumnProperty: angular.copy(mappingHeaderObj.ImportMappingColumnProperty),
			ImportMappingColumnRegex: angular.copy(mappingHeaderObj.ImportMappingColumnRegex),
			ImportMappingColumnType: angular.copy(mappingHeaderObj.ImportMappingColumnType),
			ImportMappingColumnValidationValue: angular.copy(mappingHeaderObj.ImportMappingColumnValidationValue),
			LinkElementID: angular.copy(mappingHeaderObj.LinkElementID),

			isInUse: true,
			loadingState: 'loading',
			mappingColumnGroupId: angular.copy(mappingHeaderObj.mappingColumnGroupId),
			mappingHeader: angular.copy(mappingHeaderObj)
		});

		// Extend with additional info
		if (angular.isDefined(fileColumnMetaObj)) {

			angular.extend(fileColumnObj, fileColumnMetaObj);
		}

		// Horizontal
		if (isPayElementMappingHeaderHorizontal(vmObj, mappingHeaderOriginalIndex)) {

			switch (vmObj.importMappingType) {

				// + Link rate units
				case IMPORT_MAPPING_TYPES.linkRateUnits:

					// Match cells/rows to link elements by name
					mapLinkElements(vmObj, fileColumnObj.ImportMappingColumnNumber);

					break;

				// + Pay elements
				default:

					// Match cells/rows to adjustment types by name
					mapAdjustmentTypes(vmObj, fileColumnObj.ImportMappingColumnNumber);
			}

			// Store adjustment type column number to prevent further lookups
			vmObj.columnIndexes.adjustmentType = fileColumnObj.ImportMappingColumnNumber;
		}

		switch (mappingHeaderObj.ImportMappingColumnType) {

			// Rates / Units
			// Behave slightly differently to other mapping headers as they're paired by "mappingColumnGroupId"
			case IMPORT_MAPPING_COLUMN_TYPES.rate:
			case IMPORT_MAPPING_COLUMN_TYPES.unit:

				fileColumnObj.isLinked = true;

				if (IS_MANUAL_DROP) {

					const columnHeaderPairingArr = getColumnsArrByGroupId(vmObj, mappingHeaderObj.mappingColumnGroupId);

					// Is paired
					if (columnHeaderPairingArr.length === 2) {

						// Open form to select change type
						openMatchChangeTypeFormVertical(vmObj, fileColumnObj.originalIndex);
					}
				}

				else {

					// Increment Rates / Units headers pair
					setAndUpdateRatesAndUnitsFilterIndex(vmObj);
				}

				break;
		}

		// Pre-mapped using a saved mapping template
		if (!IS_MANUAL_DROP) {

			// Attach adjustment object if automatically mapped
			if (fileColumnObj.AgencyAdjustmentGroupEntryID !== config.guidEmpty && IS_PAY_ELEMENTS_APPLICABLE) {

				// Attach adjustment type
				fileColumnObj.adjustmentType = adjustmentsService.getAdjustmentTypeById('AgencyAdjustmentGroupEntryID', fileColumnObj.AgencyAdjustmentGroupEntryID, vmObj.adjustmentTypes);

				if (fileColumnObj.adjustmentType) {

					// Update mapping header label
					fileColumnObj.mappingHeader.ImportMappingColumnText = fileColumnObj.adjustmentType.AgencyAdjustmentGroupEntryText;
				}

				// Adjustment type cannot be found for the mapping template -> Show a modal to explain
				else {
					$rootScope.paycircleMessage('Data importer: Pay element could not be matched for mapping template', 'warning');
				}
			}

			// If rate type available, then assign default rate type if not set
			if (mappingHeaderObj.isPayElementRateTypeEditable) {
				
				angular.extend(fileColumnObj, {
					AgencyAdjustmentRateType: importService.getRateForRatedUnits(fileColumnObj.AgencyAdjustmentRateType, vmObj.defaultRateType)
				});
			}
		}

		// Manual drop
		else {

			// Update adjustment detail
			angular.extend(fileColumnObj, {
				AgencyAdjustmentGroupEntryID: angular.copy(mappingHeaderObj.AgencyAdjustmentGroupEntryID),
				AgencyAdjustmentID: angular.copy(mappingHeaderObj.AgencyAdjustmentID)
			});

			// If Netable and not bulk (auto-mapped), then open Net to Gross form automatically
			if (!IS_BULK_MAPPING && mappingHeaderObj.isPayElementNetable) {

				// Open form to choose whether to import as net or gross
				openEditPayElementNetToGrossForm(vmObj, fileColumnObj.originalIndex);
			}

			// If rate type available, then open/assign rate type form automatically
			if (mappingHeaderObj.isPayElementRateTypeEditable) {
				
				// Default rate type at all times
				angular.extend(fileColumnObj, {
					AgencyAdjustmentRateType: vmObj.defaultRateType
				});
				
				if (!IS_BULK_MAPPING) {

					// Open form to chose pay element rate type if not bulk (auto-mapped)
					openEditPayElementRateTypeForm(vmObj, fileColumnObj.originalIndex);
				}
			}

			// Track manual template mapping changes
			vmObj.hasTemplateMappingChanged = true;
		}

		$timeout(() => {

			validateCellsForColumn(vmObj, fileColumnObj.ImportMappingColumnNumber);

			// Validation state
			fileColumnObj.state = getDataValidationStateForFileColumnIndex(vmObj, fileColumnObj.ImportMappingColumnNumber);

			// Validate mapping
			if (VALIDATE_FILE) {

				// Extract unique policy names for click-to-match after columns are mapped
				if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && !vmObj.uniquePolicyNamesCollected) {
					extractUniquePolicyNames(vmObj);
				}

				validateMapping(vmObj);
				validateRowData(vmObj);

				// Reset active mapping header
				resetActiveMappingHeader(vmObj);
			}
		});
	}

	/**
	 * Save the updated column to the DB
	**/
	function saveColumnMapping (vmObj, fileColumnOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, fileColumnOriginalIndex);

		dataImport.updateImportMappingColumn(fileColumnObj).then(updatedFileColumnObj => {

			updatedFileColumnObj.loadingState = 'ready';

			angular.extend(fileColumnObj, updatedFileColumnObj);
		})
		.catch(onError);
	}

	function isMappingHeaderIndexSet (vmObj) {

		return angular.isDefined(vmObj.activeMappingHeaderIndex) && vmObj.activeMappingHeaderIndex !== null;
	}

	function mapColumn (vmObj, columnObj) {

		if (!isMappingHeaderIndexSet(vmObj)) {
			return;
		}

		const IS_MANUAL_DROP = true;

		updateColumnMapping(vmObj, vmObj.activeMappingHeaderIndex, columnObj.originalIndex, IS_MANUAL_DROP);
		saveColumnMapping(vmObj, columnObj.originalIndex);
	}

	function validatePayElementImportFile (vmObj, reviewValidRows, isSecondPassValidation) {
		reviewValidRows = angular.isDefined(reviewValidRows) ? reviewValidRows : false;

		if (getIsNothingToImport(vmObj, reviewValidRows)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'validating';

		$timeout(() => {

			vmObj.uploadingProgress = 50;
			
			// Re-map values
			importService.reMapValues(vmObj.fileData.Rows);

			//isSecondPassValidation controls the deletion of existing validation results. When false, existing results are deleted and not considered for pay element resolution in the import process.
			dataImport.validatePayElementImportFile(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData, importMappingType, isSecondPassValidation).then(validatedFileDataObj => {
				vmObj.uploadingProgress = 100;
				vmObj.fileData = importService.decorateFileDataObj(validatedFileDataObj, importMappingType);

				// Validation results
				if (validatedFileDataObj.ValidationResults.length > 0) {

					importService.mapValidationErrors(vmObj.fileData.ValidationResults, vmObj.fileData.Rows);

					validateRowData(vmObj);

					setupValidationResultsTabs(vmObj);
				}

				if (reviewValidRows && (recurringPayElementImportService.assessIsRecurringImportType(importMappingType))) {

					$timeout(() => {
						vmObj.state = 'validation-results-recurring-payelements';
						vmObj.uploadingProgress = 0;
					}, 2000);

					return;
				}

				// Valid
				$timeout(() => {
					switch (agencyDocumentType) {

						// Automatically trigger import
						case DOCUMENT_TYPES.periodImport:
							if (recurringPayElementImportService.assessIsRecurringImportType(importMappingType)) {
								generateUserImport(vmObj);
								break;
							}
					}
				}, 2000);

			}).catch(onError);
		}, 200);

	}

	function validatePayPolicyImportFile (vmObj) {

		if (getIsNothingToImport(vmObj)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'validating';

		$timeout(() => {

			vmObj.uploadingProgress = 50;

			// Re-map values
			importService.reMapValues(vmObj.fileData.Rows);

			// Policy metadata is already written to hidden columns via updateRowsPolicyMetadata (called from openMatchPolicyDetailsForm).
			// Set Ignore=true on rows belonging to skipped policies.
			if (vmObj.policyMatches) {

				vmObj.fileData.Rows.forEach(function (rowObj) {
					var rowPolicyName = getPolicyNameForRow(vmObj, rowObj);
					if (rowPolicyName && vmObj.policyMatches[rowPolicyName] && vmObj.policyMatches[rowPolicyName].skipped) {
						rowObj.Ignore = true;
					}
				});
			}

			dataImport.validatePayPolicyImportFile(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData).then(validatedFileDataObj => {

				vmObj.uploadingProgress = 100;
				vmObj.fileData = importService.decorateFileDataObj(validatedFileDataObj, importMappingType);

				// Validation results
				if (validatedFileDataObj.ValidationResults.length > 0) {

					importService.mapValidationErrors(vmObj.fileData.ValidationResults, vmObj.fileData.Rows);

					validateRowData(vmObj);

					setupValidationResultsTabs(vmObj);
				}

				// Proceed to import
				$timeout(() => {
					generateUserImport(vmObj);
				}, 2000);

			}).catch(onError);
		}, 200);

	}

	function updateImportMappingFile (vmObj, reviewValidRows) {

		reviewValidRows = angular.isDefined(reviewValidRows) ? true : false;

		if (getIsNothingToImport(vmObj, reviewValidRows)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'validating';

		$timeout(() => {

			vmObj.uploadingProgress = 50;

			// Re-map values
			importService.reMapValues(vmObj.fileData.Rows);

			dataImport.updateImportMappingFile(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData, importMappingType).then(updatedFileDataObj => {

				vmObj.uploadingProgress = 100;

				vmObj.fileData = importService.decorateFileDataObj(updatedFileDataObj, importMappingType);

				// Validation results
				if (updatedFileDataObj.ValidationResults.length > 0) {

					importService.mapValidationErrors(vmObj.fileData.ValidationResults, vmObj.fileData.Rows);

					validateRowData(vmObj);

					setupValidationResultsTabs(vmObj);
				}

				// Invalid
				if (importService.hasInvalidValidationResults(vmObj.fileData.ValidationResults)) {

					$timeout(() => {
						switch (agencyDocumentType) {

							case DOCUMENT_TYPES.businessCategories:
							case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
							case DOCUMENT_TYPES.nominalCodes:
							case DOCUMENT_TYPES.xeroNominalCodes:
							case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
								vmObj.state = 'validation-results';
								vmObj.uploadingProgress = 0;
								break;

							default:
								vmObj.state = 'validation-results-team';
								vmObj.uploadingProgress = 0;
								break;
						}
					}, 2000);

					return;
				}

				// Valid
				$timeout(() => {
					switch (agencyDocumentType) {

						// Automatically trigger import
						case DOCUMENT_TYPES.businessCategories:
						case DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport:
						case DOCUMENT_TYPES.nominalCodes:
						case DOCUMENT_TYPES.xeroNominalCodes:
						case DOCUMENT_TYPES.accessFinancialsNominalAccountsImport:
							generateUserImport(vmObj);
							break;

						case DOCUMENT_TYPES.periodImport:
							vmObj.state = 'validated';
							vmObj.uploadingProgress = 0;
							break;

						case DOCUMENT_TYPES.teamImport:
							vmObj.state = 'validation-results-team';
							vmObj.uploadingProgress = 0;
							break;

					}
				}, 2000);
			})
			.catch(onError);
		}, 200);
	}

	function updateImportMappingTemplateDefault (vmObj) {

		dataImport.updateImportMappingTemplateDefault(vmObj.agencyProfileId, vmObj.importMappingTemplate.ImportMappingID, vmObj.importMappingType, vmObj.importMappingTemplate.IsDefault).catch(onError);
	}

	function updateRatesAndUnitsFilter (vmObj) {

		angular.extend(vmObj.filterBarOptionsMappingColumns, {
			filterExp: (value) => {
				return value.mappingColumnGroupId === vmObj.mappingColumnsIndex || value.ImportMappingColumnType === IMPORT_MAPPING_COLUMN_TYPES.postIdentifier || importService.getIsImportMappingColumnTypeBusinessCategory(value.ImportMappingColumnType);
			}
		});
	}

	function updateRowAdjustmentLabelByIndex (vmObj, rowIndex, adjustmentLabel) {

		const adjustmentLabelColumnIndex = getColumnIndexForAdjustmentLabelId(vmObj);

		vmObj.fileData.Rows[rowIndex].adjustmentLabel = adjustmentLabel;
		vmObj.fileData.Rows[rowIndex].Values[adjustmentLabelColumnIndex] = adjustmentLabel;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentLabelColumnIndex].value = adjustmentLabel;
	}

	function updateRowAdjustmentTypeByIndex (vmObj, rowIndex, adjustmentTypeObj) {

		const adjustmentTypeColumnIndex = getColumnIndexForAdjustmentTypeId(vmObj);
		const adjustmentGroupEntryId = adjustmentTypeObj ? adjustmentsService.getAgencyAdjustmentGroupEntryId(adjustmentTypeObj) : '';

		vmObj.fileData.Rows[rowIndex].adjustmentType = adjustmentTypeObj;
		vmObj.fileData.Rows[rowIndex].Values[adjustmentTypeColumnIndex] = adjustmentGroupEntryId;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentTypeColumnIndex].value = adjustmentGroupEntryId;
	}

	function updateRowAdjustmentTypeByIndexForLinkElement (vmObj, rowIndex, linkElementObj) {

		const adjustmentTypeColumnIndex = getColumnIndexForAdjustmentTypeId(vmObj);

		vmObj.fileData.Rows[rowIndex].adjustmentType = linkElementObj;
		vmObj.fileData.Rows[rowIndex].Values[adjustmentTypeColumnIndex] = linkElementObj.LinkElementID;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentTypeColumnIndex].value = linkElementObj.LinkElementID;
	}

	function updateRowAdjustmentTypeCellValueByIndex (vmObj, rowIndex, cellValue) {

		const adjustmentTypeCellColumnIndex = vmObj.columnIndexes.adjustmentType;

		vmObj.fileData.Rows[rowIndex].Values[adjustmentTypeCellColumnIndex] = cellValue;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentTypeCellColumnIndex].value = cellValue;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentTypeCellColumnIndex].state = 'loading';
		$timeout(() => {
			vmObj.fileData.Rows[rowIndex].cells[adjustmentTypeCellColumnIndex].state = null;
		});
	}

	function updateRowNetToGrossCellValueByIndex (vmObj, rowIndex, cellValue) {

		const netToGrossCellColumnIndex = getColumnIndexForNetToGrossId(vmObj);

		vmObj.fileData.Rows[rowIndex].adjustmentType.NetToGross = cellValue;
		vmObj.fileData.Rows[rowIndex].Values[netToGrossCellColumnIndex] = cellValue;
		vmObj.fileData.Rows[rowIndex].cells[netToGrossCellColumnIndex].value = cellValue;
	}

	function updateRowAdjustmentRateTypeCellValueByIndex (vmObj, rowIndex, cellValue) {

		const adjustmentRateTypeCellColumnIndex = getColumnIndexForAgencyAdjustmentRateTypeId(vmObj);

		vmObj.fileData.Rows[rowIndex].AgencyAdjustmentRateType = cellValue;
		vmObj.fileData.Rows[rowIndex].Values[adjustmentRateTypeCellColumnIndex] = cellValue;
		vmObj.fileData.Rows[rowIndex].cells[adjustmentRateTypeCellColumnIndex].value = cellValue;
	}

	function updateRowSettings (vmObj) {

		const importMappingTemplateId = config.guidEmpty;

		base.updateAgencyDocumentRowCounts(vmObj.agencyDocumentId, vmObj.fileData.TitleRows, vmObj.fileData.FooterRows).then(() => {

			dataImport.importDataCheckFormat(agencyProfileId, payPeriodId, agencyDocumentTypeId, agencyDocumentId, importMappingType, importMappingTemplateId).then(updatedFileDataObj => {

				angular.extend(vmObj, {
					fileData: importService.decorateFileDataObj(updatedFileDataObj, importMappingType)
				});

				initMapping(vmObj);
			});
		})
		.catch(onError);
	}

	function getRowValidationResultObjById (fileRowObj, validationResultId) {

		return fileRowObj.validationResults.find(validationResultObj => {
			return validationResultObj.ValidationResultID === validationResultId;
		});
	}

	const filterRecurringElementOptions = (mappingColumnObj) => recurringPayElementImportService.filterRecurringElementOptions(mappingColumnObj, $scope.vm.currentSelectedRecurringGroup);

	function updateRowByValidationResult (vmObj, responseObj) {

		let fileRowObj = getFileRowByOriginalIndex(vmObj, responseObj.rowObj.originalIndex);
		const validationResultObj = getRowValidationResultObjById(fileRowObj, responseObj.validationResult.ValidationResultID);

		if (angular.isUndefined(validationResultObj)) {
			$rootScope.paycircleMessage('Unable to find validation result object by id.', 'warning');
			return;
		}

		validationResultObj.isUpdated = true;

		fileRowObj.Values[validationResultObj.ValidationResultColNumber] = responseObj.validationResult.ValidationResultImportValue;
		fileRowObj.cells[validationResultObj.ValidationResultColNumber].value = responseObj.validationResult.ValidationResultImportValue;
	}

	function updateRowUserByOriginalIndex (vmObj, fileRowOriginalIndex, userObj) {

		const userIdColumnIndex = getColumnIndexForUserId(vmObj);

		let fileRowObj = getFileRowByOriginalIndex(vmObj, fileRowOriginalIndex);

		angular.extend(fileRowObj, {
			TeamMember: userObj,
			isInvalid: false,
			teamMember: {
				name: `${userObj.Forename} ${userObj.Surname}`
			}
		});

		fileRowObj.Values[userIdColumnIndex] = userObj.UserID;
		fileRowObj.cells[userIdColumnIndex].value = userObj.UserID;
	}

	function updateValidationResult (responseObj, validationResultObj) {

		switch (responseObj.callbackAction) {

			// Restart import
			case 'restart':
				init();
				break;

			// Update user id
			case 'update-user-id':
				updateRowUserByOriginalIndex($scope.vm, responseObj.rowOriginalIndex, responseObj.userObj);
				resetFileRowCellsByOriginalIndex($scope.vm, responseObj.rowOriginalIndex);
				validateRowData($scope.vm);
				break;

			case 'update-payelement-validation-result':
				updateRowByValidationResult($scope.vm, responseObj);
				resetFileRowCellsByOriginalIndex($scope.vm, responseObj.rowObj.originalIndex);
				validationResultObj.ValidationResultImportValue = responseObj.validationResult.ValidationResultImportValue;
				reValidateAll($scope.vm);
				break;

			case 'pay-element-match-resolution':

				validationResultObj.isUpdated = true;
				dataImport.resolvePayElementMatch(responseObj.validationResult).then((result) => {
					if (result !== 0) 
					{
						//error state
						onError('Error resolving pay element match');
						return;
					}
				});
				reValidateAll($scope.vm);
				break;

			// Update validation result (generic)
			case 'update-validation-result':
				updateRowByValidationResult($scope.vm, responseObj);
				resetFileRowCellsByOriginalIndex($scope.vm, responseObj.rowObj.originalIndex);
				validationResultObj.ValidationResultImportValue = responseObj.validationResult.ValidationResultImportValue;
				validateRowData($scope.vm);
				break;
		}
	}

	function validateCellData (vmObj, cellObj) {

		cellObj.state = 'loading';

		$timeout(() => {

			validateColumnState(vmObj, cellObj.originalIndex);
			validateRowData(vmObj);
			validateMapping(vmObj);
			countPopulatedCellsForColumnByCellIndex(vmObj, cellObj.originalIndex);

			if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && vmObj.uniquePolicyNamesCollected && cellObj.originalIndex === vmObj.policyNameColumnIndex) {
				syncPolicyMatches(vmObj);
			}

			cellObj.state = 'ready';
		});
	}

	function validateCellsForColumn (vmObj, columnOriginalIndex) {

		utilities.profilingStart('Importer Validate Cells');

		vmObj.fileData.Rows.forEach(rowObj => {

			let cellObj = getRowCellByOriginalIndex(vmObj, rowObj.originalIndex, columnOriginalIndex);

			const isCellValid = getIsCellObjValid(vmObj, columnOriginalIndex, rowObj.originalIndex);

			cellObj.isValid = isCellValid;
		});

		utilities.profilingEnd('Importer Validate Cells');
	}

	function validateColumnState (vmObj, columnOriginalIndex) {

		let fileColumnObj = getFileColumnByOriginalIndex(vmObj, columnOriginalIndex);

		// No need to validate if not mapped
		if (!fileColumnObj.isInUse) {
			return;
		}

		fileColumnObj.state = getDataValidationStateForFileColumnIndex(vmObj, columnOriginalIndex);
	}

	function validateColumnsInUse (vmObj) {

		vmObj.fileData.Columns.forEach(columnObj => {

			if (!IS_BUREAU_MAPPING && columnObj.isInUse) {

				validateCellsForColumn(vmObj, columnObj.originalIndex);
				validateColumnState(vmObj, columnObj.originalIndex);
			}
		});
	}

	function validateMapping (vmObj) {

		utilities.profilingStart('Importer Validate Mapping');

		vmObj.isMappingValid = true;
		vmObj.totalValidationValue = 0;
		vmObj.totalMappedColumns = 0;

		// Check 1: Make sure file data is valid for all and total up validation value
		vmObj.fileData.Columns.forEach((fileColumnObj) => {

			if (fileColumnObj.isInUse && !fileColumnObj.ImportMappingColumnHidden) {

				if (!IS_BUREAU_MAPPING) {
					vmObj.totalValidationValue += fileColumnObj.ImportMappingColumnValidationValue;

					if (!fileColumnObj.state || angular.isUndefined(fileColumnObj.state) || fileColumnObj.state === 'invalid') {
						vmObj.isMappingValid = false;
						return;
					}
				}

				vmObj.totalMappedColumns++;
			}
		});

		utilities.profilingEnd('Importer Validate Mapping');

		// Further validation is not required for Bureau Mapping Templates
		if (IS_BUREAU_MAPPING) {
			return;
		}

		// Further validation is not required in 'validate' phase as header mapping is not applicable
		if (vmObj.state === 'validation-results-team') {
			return;
		}

		// Check 2: Make sure enough headers are mapped (total in use columns should add up to more than 100)
		if (vmObj.totalValidationValue < 100) {
			vmObj.isMappingValid = false;
		}

		// Check 3: For policy imports, all unique policies must be matched via click-to-match
		if (importMappingType === IMPORT_MAPPING_TYPES.policyImport && vmObj.uniquePolicyNamesCollected && !vmObj.allPoliciesMatched) {
			vmObj.isMappingValid = false;
		}
	}

	function validateRowData (vmObj) {

		utilities.profilingStart('Importer Validate Rows');

		angular.extend(vmObj, {
			isIgnoreAllRowsEnabled: getIsIgnoreAllRowsEnabled(vmObj),
			isRowDataValid: importService.isRowDataValid(vmObj.fileData, importMappingType, IS_BUREAU_MAPPING),
		});

		const filterKey = vmObj.isRowDataValid ? FILTER_KEYS.dataImporterValidate.validationState.all : FILTER_KEYS.dataImporterValidate.validationState.invalid;

		selectMappingFilterByKey(vmObj, filterKey);

		utilities.profilingEnd('Importer Validate Rows');
	}

	function getInitialState (importMappingType) {
		if (importMappingType === IMPORT_MAPPING_TYPES.xeroNominalCodes) {
			return 'xero-loading';
		} else if (importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts || importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories) {
			return 'financials-loading';
		} else {
			return 'mapping'; // 'mapping', 'validate'
		}
	}

	init();

	angular.extend($scope, {
		DOCUMENT_TYPES,
		ERROR_STATES,
		FILTER_KEYS,
		IMPORT_CONTEXT_TYPES,
		IMPORT_MAPPING_TYPES,
		IMPORT_RATE_TYPES,
		IS_BUREAU_MAPPING,
		SHOW_HIDDEN_COLUMNS,
		VALIDATION_TYPES,
		VALIDATION_TYPE_LEVELS,
		autoMapColumnsByName,
		backNgHref,
		countPopulatedCellsForColumn,
		deleteColumnMapping,
		editCell,
		filterRecurringElementOptions,
		getFullNameDescriptionForRow,
		getNIDescriptionForRow,
		getPolicyNameForRow,
		hasScrollWidth: utilities.hasScrollWidth,
		hideEmptyColumns,
		importMappingType,
		initMapping,
		isFullScreenActive: utilities.isFullScreenActive,
		isMappingHeaderIndexSet,
		generateUserImport,
		mapColumn,
		onToggleFullScreen,
		openEditPayElementNetToGrossForm,
		openEditPayElementRateTypeForm,
		openMappingTemplateForm,
		openMatchChangeTypeFormHorizontal,
		openMatchPolicyDetailsForm,
		openMatchPayslipLabelForm,
		openMatchLinkElementFormHorizontal,
		openMatchLinkElementFormVertical,
		openPayElementMatchingForm,
		openUpdateValidationResultForm,
		openValidateDataForm,
		reValidateAll,
		reviewActiveMappingColumn,
		restartImport: init,
		setActiveValidationResultFilter,
		setImportState,
		showEmptyColumns,
		showMoreMappingColumns,
		toggleIsIgnoreAllRowsEnabled,
		toggleMappingFilter,
		toggleShowColumn,
		toggleShowContext,
		updateImportMappingFile,
		updateRowSettings,
		validatePayElementImportFile,
		validatePayPolicyImportFile,
		validateCellData
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('dataImporterValidateXMLFileCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'base',
	'dataImport',
	'filterService',
	'importService',
	'utilities',
	'DOCUMENT_TYPES',
	'FILTER_KEYS',
	'IMPORT_MAPPING_TYPES',
	'VALIDATION_COLUMN_TYPES',
	'VALIDATION_COLUMN_TYPES_NAMES',
	'VALIDATION_TYPES',
	'VALIDATION_TYPE_LEVELS',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		base,
		dataImport,
		filterService,
		importService,
		utilities,
		DOCUMENT_TYPES,
		FILTER_KEYS,
		IMPORT_MAPPING_TYPES,
		VALIDATION_COLUMN_TYPES,
		VALIDATION_COLUMN_TYPES_NAMES,
		VALIDATION_TYPES,
		VALIDATION_TYPE_LEVELS
	) {

	const SHOW_HIDDEN_COLUMNS = false;

	const agencyDocumentId = $stateParams.agencyDocumentId;
	const agencyDocumentType = parseInt($stateParams.agencyDocumentType);
	const agencyDocumentTypeId = importService.getDocumentTypeIdForAgencyDocumentType(agencyDocumentType);
	const agencyProfileId = $stateParams.agencyProfileId;
	const backState = $stateParams.backState;
	const payPeriodId = $stateParams.payPeriodId;
	let importMappingType = parseInt($stateParams.importMappingType);

	const backNgHref = importService.getImportBackHrefForAgencyDocumentType(agencyDocumentType, agencyProfileId, backState);

	function generateUserImport (vmObj, reviewValidRows) {

		reviewValidRows = angular.isDefined(reviewValidRows) ? true : false;

		if (getIsNothingToImport(vmObj, reviewValidRows)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'importing';

		$timeout(() => {
			vmObj.importingPercentComplete = 100;
		}, 200);

		importService.reMapValues(vmObj.fileData.Rows);

		dataImport.generateUserImport(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData, importMappingType).then((responseObj) => {

			angular.extend(vmObj, {
				hasImportSummaryToDisplay: importService.getHasImportSummaryToDisplay(responseObj),
				importSummary: responseObj
			});

			$timeout(() => {
				vmObj.state = 'imported';
			}, 2000);
		})
		.catch(onError);
	}

	function getColumnIndexForUserId (vmObj) {
		return getIndexForColumnType(vmObj, VALIDATION_COLUMN_TYPES.userId);
	}

	function getFileRowByOriginalIndex (vmObj, fileRowOriginalIndex) {

		return utilities.getArrayItemByPropertyName(vmObj.fileData.Rows, 'originalIndex', fileRowOriginalIndex);
	}

	function getIsIgnoreAllRowsEnabled (vmObj) {

		if (vmObj.activeValidationResultFilter && vmObj.fileData.rowsFiltered && vmObj.fileData.rowsFiltered.length > 0)  {
			return vmObj.fileData.rowsFiltered.every(rowObj => rowObj.Ignore);
		}
		else {
			return vmObj.fileData.Rows.every(rowObj => rowObj.Ignore);
		}
	}

	function getIsNothingToImport (vmObj, reviewValidRows) {
		return (
			reviewValidRows &&
			vmObj.fileData.validRowCount === 0 ||
			(vmObj.fileData.ignoreRowCount === vmObj.fileData.Rows.length)
		);
	}

	function getIndexForColumnType (vmObj, columnType) {

		const returnIndex = utilities.getArrayItemIndexByPropertyName(vmObj.fileData.Columns, 'ImportMappingColumnText', columnType);

		// Column not found
		if (!returnIndex) {
			$rootScope.paycircleMessage('Importer: Unable to get column index for ' + VALIDATION_COLUMN_TYPES_NAMES[columnType], 'error');
			setPageState('error');
			return returnIndex;
		}

		return returnIndex;
	}

	function init () {

		if (!isStateValid()) {
			setPageState('error');
			return;
		}

		setPageState('loading');

		base.getCompanyDocument(agencyDocumentId).then(documentObj => {

			$scope.vm = {
				agencyDocumentId: agencyDocumentId,
				agencyProfileId: agencyProfileId,
				document: documentObj,
				stateKey: $state.current.name
			};

			initMapping($scope.vm);
		})
		.catch(onError);
	}

	function initMapping (vmObj) {

		setPageState('loading');

		dataImport.importDataCheckFormat(agencyProfileId, payPeriodId, agencyDocumentTypeId, agencyDocumentId, importMappingType).then(fileDataObj => {

			angular.extend(vmObj, {
				activeValidationResultFilter: (v) => { return v; },
				agencyDocumentType: agencyDocumentType,
				columnIndexes: {
					adjustmentType: null
				},
				fileData: importService.decorateFileDataObj(fileDataObj, importMappingType),
				filterBarOptions: filterService.dataImporterValidate,
				filteredRows: [],
				hiddenColumnsArr: importService.getHiddenColumnsArr(fileDataObj),
				importingPercentComplete: 0,
				isIgnoreAllRowsEnabled: false,
				isRowDataValid: importService.isRowDataValid(fileDataObj, importMappingType),
				isVertical: true,
				payPeriodId: payPeriodId,
				showHiddenColumnsFilter: (value) => {

					if (SHOW_HIDDEN_COLUMNS) {
						return value;
					}

					return !value.ImportMappingColumnHidden;
				},
				state: 'validating', // 'mapping', 'validate'
				uploadingProgress: 0
			});

			setPageState('ready');

			updateImportMappingFile($scope.vm);
		})
		.catch(onError);
	}

	function isStateValid () {

		if (angular.isUndefined(agencyDocumentId)) {
			$rootScope.paycircleMessage('No document id defined', 'error');
			return false;
		}

		if (isNaN(agencyDocumentType)) {
			$rootScope.paycircleMessage('No agency document type defined', 'error');
			return false;
		}

		if (angular.isUndefined(agencyProfileId)) {
			$rootScope.paycircleMessage('No agency profile id defined', 'error');
			return false;
		}

		if (isNaN(importMappingType)) {
			$rootScope.paycircleMessage('No import mapping type defined', 'error');
			return false;
		}

		if (angular.isUndefined(payPeriodId)) {
			$rootScope.paycircleMessage('No pay period id defined', 'error');
			return false;
		}

		return true;
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openValidateDataForm (rowObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateValidationResult,
			formKey: 'validate-data',
			rowObj: rowObj,
			title: rowObj.actionMessage
		});
	}

	function resetFileRowCellsByOriginalIndex (vmObj, fileRowOriginalIndex) {

		let fileRowObj = getFileRowByOriginalIndex(vmObj, fileRowOriginalIndex);

		fileRowObj.isInvalid = false;
	}

	function reValidateAll (vmObj) {
		validateRowData(vmObj);
	}

	function setImportState (vmObj, importState) {
		vmObj.state = importState;
	}

	function setPageState (pageState, errorState) {

		$scope.pageState = pageState;

		if (angular.isDefined(errorState)) {
			$scope.errorState = errorState;
		}
	}

	function setupValidationResultsTabs (vmObj) {

		vmObj.validationResultFilters = [
			{
				canIgnore: true,
				hasActions: true,
				isHiddenWhenEmpty: true,
				isTeamMemberMatched: false,
				title: 'Warnings',
				theme: 'assertive inverse',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.warning,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.warning);
				}
			},
			{
				canIgnore: true,
				hasActions: false,
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: true,
				title: 'Current team',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.update,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.update);
				}
			},
			{
				canIgnore: true,
				hasActions: false,
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: false,
				title: 'New',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.new,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.new);
				}
			},
			{
				canIgnore: false,
				hasActions: false,
				isHiddenWhenEmpty: false,
				isTeamMemberMatched: true,
				title: 'Ignored',
				theme: 'primary',
				themeActive: 'primary',
				total: 0,
				filterKey: VALIDATION_TYPE_LEVELS.unchanged,
				filter: (v) => {
					return v.validationResults !== undefined && v.validationResults.length > 0 && v.validationResultTypes.includes(VALIDATION_TYPE_LEVELS.unchanged);
				}
			}
		];

		// Counts
		vmObj.fileData.Rows.forEach((rowObj) => {

			// Skip ignored rows
			if (rowObj.Ignore) {
				return;
			}

			// No validation result returned for row
			if (angular.isUndefined(rowObj.validationResults) || rowObj.validationResults.length === 0) {
				console.info(rowObj);
				throw `Validation Result not defined for row. Each row should have an associated validation result, whether it's valid or not`;
			}

			rowObj.validationResults.forEach(validationResultObj => {

				switch (validationResultObj.ValidationType.ValidationTypeLevel) {

					case VALIDATION_TYPE_LEVELS.warning:
						vmObj.validationResultFilters[0].total++;
						break;

					case VALIDATION_TYPE_LEVELS.update:
						vmObj.validationResultFilters[1].total++;
						break;

					case VALIDATION_TYPE_LEVELS.new:
						vmObj.validationResultFilters[2].total++;
						break;

					case VALIDATION_TYPE_LEVELS.unchanged:
						vmObj.validationResultFilters[3].total++;
						break;
				}
			});
		});

		if (vmObj.validationResultFilters[0].total === 1) {
			vmObj.validationResultFilters[0].title = 'Warning';
		}

		setActiveValidationResultFilter(vmObj, importService.getFirstFilterWithResults(vmObj.validationResultFilters));
	}

	function setActiveValidationResultFilter (vmObj, validationResultFilterObj) {

		vmObj.activeValidationResultFilter = validationResultFilterObj;

		$timeout(() => {
			vmObj.isIgnoreAllRowsEnabled = getIsIgnoreAllRowsEnabled(vmObj);
		});
	}

	function toggleIsIgnoreAllRowsEnabled (vmObj, filteredRowsArr) {

		function toggleIgnoreRow (rowObj) {
			return rowObj.Ignore = vmObj.isIgnoreAllRowsEnabled;
		}

		if (filteredRowsArr) {
			filteredRowsArr.forEach(toggleIgnoreRow);
		}
		else {
			vmObj.fileData.Rows.forEach(toggleIgnoreRow);
		}

		reValidateAll(vmObj);
	}

	function updateImportMappingFile (vmObj, reviewValidRows) {

		reviewValidRows = angular.isDefined(reviewValidRows) ? true : false;

		if (getIsNothingToImport(vmObj, reviewValidRows)) {

			$rootScope.openModalDialog({
				modalKey: 'imports-nothing-to-import'
			});

			return;
		}

		vmObj.state = 'validating';

		$timeout(() => {

			vmObj.uploadingProgress = 50;

			// Re-map values
			importService.reMapValues(vmObj.fileData.Rows);

			dataImport.updateImportMappingFile(agencyProfileId, payPeriodId, agencyDocumentId, vmObj.fileData, importMappingType).then((updatedFileDataObj) => {

				vmObj.uploadingProgress = 100;

				vmObj.fileData = importService.decorateFileDataObj(updatedFileDataObj, importMappingType);

				// Validation results
				if (updatedFileDataObj.ValidationResults) {

					importService.mapValidationErrors(vmObj.fileData.ValidationResults, vmObj.fileData.Rows);

					validateRowData(vmObj);

					setupValidationResultsTabs(vmObj);
				}

				// Invalid
				if (importService.hasInvalidValidationResults(vmObj.fileData.ValidationResults)) {

					$timeout(() => {
						vmObj.state = 'validate';
						vmObj.uploadingProgress = 0;
					}, 2000);

					return;
				}

				// Valid
				$timeout(() => {
					vmObj.state = 'validate';
					vmObj.uploadingProgress = 0;
				}, 2000);
			})
			.catch(onError);
		}, 200);
	}

	function updateRowUserByOriginalIndex (vmObj, rowOriginalIndex, userObj) {

		const userIdColumnIndex = getColumnIndexForUserId(vmObj);

		let fileRowObj = getFileRowByOriginalIndex(vmObj, rowOriginalIndex);

		angular.extend(fileRowObj, {
			TeamMember: userObj,
			isInvalid: false,
			teamMember: {
				name: `${userObj.Forename} ${userObj.Surname}`
			}
		});

		fileRowObj.Values[userIdColumnIndex] = userObj.UserID;
		fileRowObj.cells[userIdColumnIndex].value = userObj.UserID;
	}

	function updateValidationResult (responseObj) {

		switch (responseObj.callbackAction) {

			// Restart import
			case 'restart':
				init();
				break;

			// Update user id
			case 'update-user-id':
				updateRowUserByOriginalIndex($scope.vm, responseObj.rowOriginalIndex, responseObj.userObj);
				resetFileRowCellsByOriginalIndex($scope.vm, responseObj.rowOriginalIndex);
				validateRowData($scope.vm);
				break;
		}
	}

	function validateRowData (vmObj) {

		angular.extend(vmObj, {
			isIgnoreAllRowsEnabled: getIsIgnoreAllRowsEnabled(vmObj),
			isRowDataValid: importService.isRowDataValid(vmObj.fileData, importMappingType),
		});
	}


	init();

	angular.extend($scope, {
		DOCUMENT_TYPES,
		FILTER_KEYS,
		IMPORT_MAPPING_TYPES,
		SHOW_HIDDEN_COLUMNS,
		VALIDATION_TYPE_LEVELS,
		VALIDATION_TYPES,

		backNgHref,
		importMappingType,

		generateUserImport,
		initMapping,
		openValidateDataForm,
		restartImport: init,
		reValidateAll,
		setActiveValidationResultFilter,
		setImportState,
		toggleIsIgnoreAllRowsEnabled,
		updateImportMappingFile
	});
}]);

'use strict';
angular.module('paycircleApp')
.component('validationResults', {
	bindings: {
		activeValidationResultFilter: '<',
		allowActionsOnUpdates: '<',
		fileData: '<',
		hiddenColumnsArray: '<',
		isIgnoreAllRowsEnabled: '<',
		onToggleIgnoreRow: '&',
		onToggleIgnoreAllRows: '&',
		onUpdateFilter: '&',
		onValidationResultAction: '&',
		onPayElementValidationAction: '&',
		validationResultFilters: '<',
		validationResultsMessage: '@',
		validationResultsTitle: '@',
		showHiddenColumns: '<',
		showHiddenColumnsFilter: '<'

	},
	templateUrl: 'features/app/data-importer/validation-results/validation-results.component.html'
});
'use strict';

angular.module('paycircleApp')
.component('validationResultsFileData', {
	bindings: {
		activeValidationResultFilter: '<',
		allowActionsOnUpdates: '<',
		fileData: '<',
		hiddenColumnsArray: '<',
		isIgnoreAllRowsEnabled: '<',
		onToggleIgnoreRow: '&',
		onToggleIgnoreAllRows: '&',
		onValidationResultAction: '&',
		onPayElementValidationAction: '&',
		showHiddenColumns: '<',
		showHiddenColumnsFilter: '<'
	},
	controller: ['VALIDATION_TYPES', 'VALIDATION_TYPE_LEVELS', function (VALIDATION_TYPES, VALIDATION_TYPE_LEVELS) {

		const payElementMatchingValidationTypeIds = [VALIDATION_TYPES.payElementWillBeUpdated, VALIDATION_TYPES.payElementHasMultipleMatches]; 

		let ctrl = this;

		let validationResultMatchMap = new Map();
		
		ctrl.onValidationAction = function(row, validationResult) {
			//..Add the original matching options to the map so they can be re-used to re resolve the validation result.
			validationResultMatchMap.set(validationResult.ValidationResultID, angular.copy(validationResult.ValidationResultImportValue));

			if (validationResult && payElementMatchingValidationTypeIds.includes(validationResult.ValidationResultTypeID)) {
				ctrl.onPayElementValidationAction({ row: row, validationResult: validationResult });
				return;
			}
			
			ctrl.onValidationResultAction({ row: row, validationResult: validationResult });
			return;
		};

		function validationActionsFilter(ValidationResult) {
			if (ctrl.allowActionsOnUpdates) {
				return ValidationResult.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.warning ||
					ValidationResult.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.update;
			}

			return ValidationResult.ValidationType.ValidationTypeLevel === VALIDATION_TYPE_LEVELS.warning;
		}

		ctrl.$onInit = function () {
			angular.extend(ctrl, {
				VALIDATION_TYPE_LEVELS: VALIDATION_TYPE_LEVELS,
				validationActionsFilter
			});
		};
	}],
	templateUrl: 'features/app/data-importer/validation-results/validation-results-file-data/validation-results-file-data.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('validationResultsFilter', {
	bindings: {
		activeValidationResultFilter: '<',
		onUpdateFilter: '&',
		validationResultFilters: '<'
	},
	templateUrl: 'features/app/data-importer/validation-results/validation-results-filter/validation-results-filter.component.html'
});
'use strict';

angular.module('paycircleApp')
.component('validationResultsTitle', {
	bindings: {
		validationResultsMessage: '@',
		validationResultsTitle: '@'
	},
	templateUrl: 'features/app/data-importer/validation-results/validation-results-title/validation-results-title.component.html'
});

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const directory = 'features/app/reporting/';

	$stateProvider

	.state('reporting', {
		abstract: true,
		url: '/reporting/:agencyProfileId',
		controller: 'reportingCtrl',
		data: {
			helpAndSupportOptions: {
				tags: ['company-reporting']
			},
			permissions: [
				'isReportingVisible'
			],
			title: 'Reporting'
		},
		templateUrl: directory + 'reporting.view.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		}
	})

		.state('reporting.summary', {
			url: '',
			templateUrl: directory + 'summary/reporting-summary.view.html',
			controller: 'reportingSummaryCtrl',
			data: {
				showReportingHeader: true
			}
		})

		// .state('reporting.saved-settings', {
		// 	url: '/saved-settings',
		// 	templateUrl: directory + 'saved-settings/reporting-saved-settings.view.html',
		// 	controller: 'reportingSavedSettingsCtrl',
		// 	data: {
		// 		showReportingHeader: true
		// 	}
		// })

		.state('reporting.report', {
			reload: true,
			url: '/:reportTemplateId?agencyPayPeriodId',
			templateUrl: directory + 'report/reporting-report.view.html',
			controller: 'reportingReportCtrl',
			data: {
				showReportingHeader: false
			},
			params: {
	            reportDTO: null,
				returnTo: null
	        }
		});
}]);

'use strict';

angular.module('paycircleApp')

.controller('reportingCtrl', [
	'$scope',
	'$state',
	function (
		$scope,
		$state
	){

	angular.extend($scope, {
		showReportingHeader: $state.current.data.showReportingHeader
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('reportingSummaryCtrl', [
	'$q',
	'$rootScope',
	'$stateParams',
	'$scope',
	'filterService',
	'reportData',
	'reportsService',
	'searchService',
	function (
		$q,
		$rootScope,
		$stateParams,
		$scope,
		filterService,
		reportData,
		reportsService,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		if ($rootScope.currentCompany.isPayrollCompany) {
			reportData.getReports(agencyProfileId)
				.then(loadPage)
				.catch(onError);

		} else {

			reportData.getCustomReports(agencyProfileId)
				.then(loadPage)
				.catch(onError);
		}
	}

	function decorateReports (reportsArr) {

		for (let reportObj of reportsArr) {
			reportsService.decorateReportDTO(reportObj);
		}

		return reportsArr.filter(reportObj => reportObj.CanView);
	}

	function loadPage (reportsArr) {

		$scope.vm = {
			reports: decorateReports(reportsArr),
			filterBarOptions: filterService.reports,
			reportsFiltered: [],
			searchBarOptions: searchService.reports
		};

		setPageState('ready');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (newPageState) {
		$scope.pageState = newPageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')

.controller('reportingSavedSettingsCtrl', [
	'$rootScope',
	'$scope',
	'searchService',
	function (
		$rootScope,
		$scope,
		searchService
	) {

	function init () {

		setPageState('loading');

		//todo: integrate
		let savedSettingsArr = [
			{
				ReportName: 'Saved Settings name',
				ReportType: 'pension',
				ReportTypeDisplay: 'Payroll totals by department',
				ReportCreator: 'Anand Davis',
				ReportCreationDateISO: '2019-06-06T00:00:00',
				ReportCompanyCount: 44,
				reportTheme: 'is-primary'
			},
			{
				ReportName: 'Saved Settings name 2',
				ReportType: 'pension',
				ReportTypeDisplay: 'Payroll totals by department',
				ReportCreator: 'Anand Davis',
				ReportCreationDateISO: '2019-05-06T00:00:00',
				ReportCompanyCount: 44,
				reportTheme: 'is-secondary'
			},
			{
				ReportName: 'Saved Settings name 3',
				ReportType: 'pension',
				ReportTypeDisplay: 'Payroll totals by department',
				ReportCreator: 'Anand Davis',
				ReportCreationDateISO: '2019-04-06T00:00:00',
				ReportCompanyCount: 44,
				reportTheme: 'is-tertiary'
			},
			{
				ReportName: 'Saved Settings name 4',
				ReportType: 'pension',
				ReportTypeDisplay: 'Payroll totals by department',
				ReportCreator: 'Anand Davis',
				ReportCreationDateISO: '2019-03-06T00:00:00',
				ReportCompanyCount: 44,
				reportTheme: 'is-quarternary'
			},
			{
				ReportName: 'Saved Settings name 5',
				ReportType: 'pension',
				ReportTypeDisplay: 'Payroll totals by department',
				ReportCreator: 'Anand Davis',
				ReportCreationDateISO: '2019-02-06T00:00:00',
				ReportCompanyCount: 44,
				reportTheme: 'is-assertive'
			}
		];

		$scope.vm = {
			savedSettings: savedSettingsArr
		};

		setPageState('ready');
	}

	function setPageState (newPageState) {

		$scope.pageState = newPageState;
	}

	init();

	$scope.searchBarOptions = searchService.reportSettings;

}]);

'use strict';

angular.module('paycircleApp')

.controller('reportingReportCtrl', [
	'$scope',
	'$state',
	'$stateParams',
	function (
		$scope,
		$state,
		$stateParams
	) {

	function onGoBack () {

		const returnToState = $stateParams.returnTo ? $stateParams.returnTo : 'reporting.summary';

		return $state.go(returnToState, {
			agencyProfileId: $stateParams.agencyProfileId
		}, {
			reload: true
		});
	}

	angular.extend($scope, {
		reportOptions: $stateParams,
		onGoBack
	});

}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/eps-importer/';

	$stateProvider

	.state('eps-importer', {
		url: '/eps-importer/{agencyProfileId}&from',
		templateUrl: directory + 'epsImporterView.html',
		controller: 'epsImporterCtrl',
		data: {
		    fullPage: true,
		    title: 'EPS Importer'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('epsImporterCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'$timeout',
	'agency',
	'dataImport',
	'dataTransfer',
	'growl',
	'importService',
	'libraries',
	'payrollData',
	'payrollWorker',
	'DOCUMENT_TYPE_IDS',
	'IMPORT_TYPES',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'VALIDATION_FIELD_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		$timeout,
		agency,
		dataImport,
		dataTransfer,
		growl,
		importService,
		libraries,
		payrollData,
		payrollWorker,
		DOCUMENT_TYPE_IDS,
		IMPORT_TYPES,
		STATE_TYPES,
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES
	) {

	var agencyProfileId = $stateParams.agencyProfileId;
	var timerId;

	function checkWorkerImportState (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		if (payPeriod.WorkerImportState === SUBMISSION_STATES.unsubmitted) {

			setPageState('ready');

			return;
		}

		agency.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.workerimport).then(function (workerImportState) {

			payPeriod.WorkerImportState = workerImportState;

			switch (workerImportState) {

				// If import has errors then we get those errors and stop checking the status
				case SUBMISSION_STATES.haserrors1:
				case SUBMISSION_STATES.haserrors2:
				case SUBMISSION_STATES.verified:

					// Reset uploader progress state
					$scope.uploadingProgress = 0;

					break;

				case SUBMISSION_STATES.submitting:
				case SUBMISSION_STATES.processing1:
				case SUBMISSION_STATES.processing2:

					timerId = $timeout(function () {
						checkWorkerImportState(payPeriod);
					}, 3000);

					break;

				default:

					// Reset uploader progress state
					$scope.uploadingProgress = 0;
			}
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function importData (payPeriod) {

		// Set to processing
		payPeriod.WorkerImportState = SUBMISSION_STATES.processing2;

		// Actually update the pay period state on the server
		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriod.PayPeriodID, SUBMISSION_STATES.processing2).then(function () {

			// Kick start the actual import
			payrollWorker.payrollDataImport(agencyProfileId, payPeriod.PayPeriodID, IMPORT_TYPES.eps);

			// Kick off polling for state, after a short delay
			timerId = $timeout(function () {
				checkWorkerImportState(payPeriod);
			}, 3000);
		})
		.catch(function () {
			growl.error('We were unable to change the status of the import.');
		});
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setupImporter(currentPayPeriodObj);

			checkWorkerImportState(currentPayPeriodObj);
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function resetImporter (payPeriod) {

		payPeriod.WorkerImportState = 0;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setupImporter (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		// Set up the uploader for the import
		var uploader = $scope.uploader = dataTransfer.getNewFileUploader({
			formData: [{
				agencyPayPeriodID: payPeriodId,
				agencyProfileID: agencyProfileId,
				documentTypeID: DOCUMENT_TYPE_IDS.epsImport
			}],
			url: libraries.httpHandler.upload.importFile,
			queueLimit: 1,
			onAfterAddingFile: function (fileItem) {

				$scope.uploadFilename = fileItem.file.name;

				payPeriod.WorkerImportState = SUBMISSION_STATES.submitting;

				uploader.uploadAll();
			},
			onProgressItem: function (fileItem, progress) {

				$scope.uploadingProgress = progress;
			},
			onCompleteAll: function () {

				dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriodId, SUBMISSION_STATES.submitted).then(function () {

					// Trigger worker import
					payrollWorker.payrollDataImport(agencyProfileId, payPeriodId, IMPORT_TYPES.eps);

					timerId = $timeout(function () {
						checkWorkerImportState(payPeriod);
					}, 3000);
				})
				.catch(function () {
					growl.error('We were unable to change the status of the import.');
				});

				uploader.clearQueue();
			}
		});

		setPageState('ready');
	}

	init();

	// Scope constants
	$scope.SUBMISSION_STATES = SUBMISSION_STATES;
	$scope.VALIDATION_FIELD_TYPES = VALIDATION_FIELD_TYPES;

	// Scope variables
	$scope.agencyProfileId = agencyProfileId;
	$scope.uploadingProgress = 0;
	$scope.uploader = null;

	// Scope functions
	$scope.importData = function (payPeriod) {

		importData(payPeriod);
	};

	$scope.resetImporter = function (payPeriod) {

		resetImporter(payPeriod);
	};

	$scope.resetEPSImportStatus = function (payPeriod) {

		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriod.PayPeriodID, SUBMISSION_STATES.unsubmitted).then(function () {
			checkWorkerImportState(payPeriod);
		});
	};

	$scope.$on('$destroy', function () {
		$timeout.cancel(timerId);
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/fps-importer/';

	$stateProvider

	.state('fps-importer', {
		url: '/fps-importer/:agencyProfileId/:agencyDocumentId?returnState',
		templateUrl: directory + 'fpsImporterView.html',
		controller: 'fpsImporterCtrl',
		data: {
		    fullPage: true,
		    title: 'FPS Importer'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('fpsImporterCtrl', [
	'$q',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'agency',
	'base',
	'dataImport',
	'dataTransfer',
	'growl',
	'importService',
	'libraries',
	'payrollData',
	'payrollWorker',
	'DOCUMENT_TYPE_IDS',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'VALIDATION_FIELD_TYPES',
	function (
		$q,
		$scope,
		$state,
		$stateParams,
		$timeout,
		agency,
		base,
		dataImport,
		dataTransfer,
		growl,
		importService,
		libraries,
		payrollData,
		payrollWorker,
		DOCUMENT_TYPE_IDS,
		STATE_TYPES,
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyDocumentId = $stateParams.agencyDocumentId;
	const returnState = $stateParams.returnState;

	const options = {
		addressSearchString: '',
		delay: 3000,
		doNotAskAgain: false,
		showAddressResult: false
	};

	let currentIndex = 0;
	let currentResultNumber = 0;
	let timerId;

	function checkWorkerImportState (payPeriodObj) {

		if (payPeriodObj.WorkerImportState === SUBMISSION_STATES.unsubmitted) {
			setPageState('ready');
			return;
		}

		agency.getAgencyPayPeriodState(payPeriodObj.PayPeriodID, STATE_TYPES.workerimport).then(workerImportState => {

			payPeriodObj.WorkerImportState = workerImportState;

			switch (workerImportState) {

				// If import has errors then we get those errors and stop checking the status
				case SUBMISSION_STATES.haserrors1:
				case SUBMISSION_STATES.haserrors2:
				case SUBMISSION_STATES.verified:

					// Set default internal ID option
					payPeriodObj.setInternalId = true;

					loadValidationResults(payPeriodObj);

					// Reset uploader progress state
					$scope.uploadingProgress = 0;

					// Setup action buttons
					$scope.canCancelImport = true;
					$scope.canCloseImport = true;

					break;

				case SUBMISSION_STATES.submitting:
				case SUBMISSION_STATES.processing1:
				case SUBMISSION_STATES.processing2:

					timerId = $timeout(() => {
						checkWorkerImportState(payPeriodObj);
					}, 3000);

					break;

				default:

					// Reset uploader progress state
					$scope.uploadingProgress = 0;
			}
		})
		.catch(onError);
	}

	function closeImporter () {

		if (returnState) {
			$state.go(returnState, {agencyProfileId});
		} else {
			$state.go('team.members', {agencyProfileId});
		}
	}

	function goToNext (validationResults, payPeriod, validationForm) {

		$scope.animationStep = 'fadeOutLeft';

		// Validate import on last result
		if (isLastResult(validationResults)) {

			// Reset animation step
			$scope.animationStep = '';
			return;
		}

		// Increase index
		currentIndex++;

		// Update current index
		updateCurrentIndex(currentIndex);

		// Timeout to allow animation to complete
		$timeout(() => {

			// Select next result
			setupValidationResult(validationResults);

			// Update animation step
			$scope.animationStep = 'fadeInRight';

			// Reset form state
			if (validationForm !== undefined) {
				validationForm.$setPristine();
			}

		}, 300);
	}

	function goToPrevious (validationResults, validationForm) {

		// Do nothing if first result
		if (isFirstResult()) {
			return;
		}

		// Show previous worker
		currentIndex--;

		// Update current index
		updateCurrentIndex(currentIndex);

		$scope.animationStep = 'fadeOutRight';

		$timeout(() => {

			// Select previous result
			setupValidationResult(validationResults);

			$scope.animationStep = 'fadeInLeft';
			$scope.selectedAddress = null;

			// Reset form state
			if (validationForm !== undefined) {
				validationForm.$setPristine();
			}

		}, 300);
	}

	function importData (payPeriodObj) {

		// Set to processing
		payPeriodObj.WorkerImportState = SUBMISSION_STATES.processing2;

		// Actually update the pay period state on the server
		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriodObj.PayPeriodID, SUBMISSION_STATES.processing2).then(() => {

			// Kick start the actual import
			payrollWorker.payrollStartWorkerImport(agencyProfileId, payPeriodObj.PayPeriodID, payPeriodObj.setInternalId);

			// Kick off polling for state, after a short delay
			timerId = $timeout(() => {
				checkWorkerImportState(payPeriodObj);
			}, 3000);
		})
		.catch(error => {
			growl.error('We were unable to change the status of the import.');
			onError(error);
		});
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then(currentPayPeriodObj => {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setupImporter(currentPayPeriodObj);

			if (agencyDocumentId) {
				importUploadedFile(currentPayPeriodObj);
			} else {
				checkWorkerImportState(currentPayPeriodObj);
			}
		})
		.catch(onError);
	}

	function importUploadedFile (payPeriodObj) {

		base.getCompanyDocument(agencyDocumentId)
			.then(documentObj => {

				$scope.uploadFilename = documentObj.DocumentName;

				setPageState('loading');

				payPeriodObj.WorkerImportState = SUBMISSION_STATES.submitting;

				onFileUpload(payPeriodObj);
			})
			.catch(onError);
	}

	function loadValidationResults (payPeriodObj) {

		const getNumberOfUserImportsByOwner = dataImport.getNumberOfUserImportsByOwner(payPeriodObj.PayPeriodID);
		const getUserImportValidationResults = dataImport.getUserImportValidationResults(payPeriodObj.PayPeriodID);

		$q.all([getUserImportValidationResults, getNumberOfUserImportsByOwner]).then(([invalidWorkers, totalWorkers]) => {

			// Re-map Invalid Workers array into results array
			const validationResults = importService.getValidationResults(invalidWorkers);

			angular.extend($scope, {
				numberOfNewStarters: importService.getNumberOfNewStarters(validationResults),
				numberOfWorkers: totalWorkers,
				validationResults,
				validationResult: validationResults[currentIndex]
			});

			// Page state
			setPageState('ready');
		})
		.catch(onError);
	}
	function isFirstResult () {

		return currentResultNumber === 1;
	}

	function isLastResult (validationResultsArr) {

		return currentResultNumber === validationResultsArr.length;
	}

	function onError (errorMessage) {
		setPageState('error');
		console.error(errorMessage);
	}

	function onFileUpload (payPeriodObj) {

		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriodObj.PayPeriodID, SUBMISSION_STATES.submitted).then(() => {

			// Trigger worker import
			payrollWorker.payrollStartWorkerImport(agencyProfileId, payPeriodObj.PayPeriodID);

			timerId = $timeout(() => {
				checkWorkerImportState(payPeriodObj);
			}, 3000);

		})
		.catch(error => {
			growl.error('We were unable to change the status of the import.');
			onError(error);
		});
	}

	function resetImporter (payPeriodObj) {
		payPeriodObj.WorkerImportState = 0;
	}

	function resetWorkerImportStatus (payPeriodObj, submissionState) {

		dataImport.updateAgencyPayPeriodImportWorkerStatus(
			payPeriodObj.PayPeriodID, 
			submissionState === undefined ? SUBMISSION_STATES.unsubmitted : submissionState
		).then(() => {

			checkWorkerImportState(payPeriodObj);
		});
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	function setupImporter (payPeriodObj) {

		// Set up the uploader for the import
		const uploader = dataTransfer.getNewFileUploader({
			formData: [{
				agencyPayPeriodID: payPeriodObj.PayPeriodID,
				agencyProfileID: agencyProfileId,
				documentTypeID: DOCUMENT_TYPE_IDS.fpsImport
			}],
			url: libraries.httpHandler.upload.importFile,
			queueLimit: 1,
			onAfterAddingFile: fileItem => {

				$scope.uploadFilename = fileItem.file.name;

				payPeriodObj.WorkerImportState = SUBMISSION_STATES.submitting;

				uploader.uploadAll();
			},
			onProgressItem: (fileItem, progress) => {
				$scope.uploadingProgress = progress;
			},
			onCompleteItem: (item, response) => {
				// The API endpoint does not return an error when the wrong type of file is uploaded.
				// The way that we know that no file was uploaded is if we check the response.
				// 0 means that no file was uploaded.
				if (response.length === 0) {
					resetWorkerImportStatus(payPeriodObj, SUBMISSION_STATES.failed);
				
				} else {
					onFileUpload(payPeriodObj);
				}

				uploader.clearQueue();
			}
		});

		$scope.uploader = uploader;

		setPageState('ready');
	}

	function setupValidationResult (validationResults) {

		$scope.validationResult = validationResults[currentIndex];
	}

	function updateCurrentIndex (value) {

		// Var
		currentIndex 		= value;
		currentResultNumber = value + 1;

		// Scope
		$scope.currentIndex 		= value;
		$scope.currentResultNumber 	= value + 1;
	}

	init();

	angular.extend($scope, {
		// Scope constants
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES,

		// Scope variables
		agencyProfileId,
		currentIndex,
		currentResultNumber: currentIndex + 1,
		options,
		returnState: returnState ? returnState : 'team.members',
		uploader: null,
		uploadingProgress: 0,

		// Scope functions
		closeImporter,
		goToNext,
		goToPrevious,
		importData,
		resetImporter,
		resetWorkerImportStatus
	});

	$scope.$on('$destroy', () => {
		$timeout.cancel(timerId);
	});
}]);

'use strict';

angular.module('paycircleApp')

/* Routing */
.config(['$stateProvider', 'INTERFACE_TYPES', function ($stateProvider, INTERFACE_TYPES) {

	var directory = 'features/app/settings';

	$stateProvider

	.state('settings', {
		url: '/settings/{agencyProfileId}?openForm',
		templateUrl: directory + '/settings.view.html',
		abstract: true,
		controller: 'settingsCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			title: 'Settings'
		}
	})

		/* Bureaus */
		.state('settings.bureau', {
			url: '/bureau',
			abstract: true,
			data: {
				helpAndSupportOptions: {
					isContextual: true,
					[INTERFACE_TYPES.bureau]: {
						tags: ['bureau-settings']
					},
					[INTERFACE_TYPES.group]: {
						tags: ['group-settings']
					}
				},
				permissions: [
					'Admin.canManageBureauSettings'
				]
			},
			templateUrl: directory + '/settings-entity.view.html',
		})

			.state('settings.bureau.access', {
				abstract: true,
				controller: 'settingsAccessCtrl',
				url: '',
				data: {
					helpAndSupportOptions: {
						tags: ['bureau-access']
					},
					permissions: [
						'Admin.canManageAccess'
					]
				},
				templateUrl: directory + '/access/settings-access.view.html'
			})

				.state('settings.bureau.access.authentication', {
					controller: 'settingsAccessAuthenticationCtrl',
					templateUrl: directory + '/access/authentication/settings-access-authentication.view.html',
					url: '/access/authentication',
				})

				.state('settings.bureau.access.ip-management', {
					controller: 'settingsAccessIPManagementCtrl',
					templateUrl: directory + '/access/ip-management/settings-access-ip-management.view.html',
					url: '/access/ip-management'
				})

			.state('settings.bureau.admins', {
				url: '/admins',
				controller: 'settingsAdminsCtrl',
				templateUrl: directory + '/admins/settings-admins.view.html',
				data: {
					permissions: [
						'Admin.canManageBureauAdmins'
					],
					helpAndSupportOptions: {
						isContextual: true,
						[INTERFACE_TYPES.bureau]: {
							tags: ['bureau-admins']
						},
						[INTERFACE_TYPES.group]: {
							tags: ['group-admins']
						}
					}
				}
			})

			.state('settings.bureau.bacs-downloads', {
				url: '/bacs-downloads',
				controller: 'settingsBacsDownloadsCtrl',
				templateUrl: directory + '/bacs-downloads/settings-bacs-downloads.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['bureau-bacs-downloads']
					},
					permissions: [
						'Admin.canManageBacsDownloads'
					]
				}
			})

			.state('settings.bureau.customer-codes', {
				url: '/customer-codes',
				controller: 'settingsCustomerCodesCtrl',
				templateUrl: directory + '/customer-codes/settings-customer-codes.view.html',
			})

			.state('settings.bureau.customisation', {
				url: '/customisation',
				controller: 'settingsCustomisationCtrl',
				templateUrl: directory + '/customisation/settings-customisation.view.html',
			})

			.state('settings.bureau.email-notifications', {
				url: '/email-notifications',
				controller: 'settingsEmailNotificationsCtrl',
				templateUrl: directory + '/email-notifications/settings-email-notifications.view.html',
				data: {
					helpAndSupportOptions: {
						isContextual: true,
						[INTERFACE_TYPES.bureau]: {
							tags: ['bureau-email-notifications']
						},
						[INTERFACE_TYPES.group]: {
							tags: ['group-email-notifications']
						}
					},
					permissions: [
						'Admin.canManageEmailNotifications'
					]
				}
			})

			.state('settings.bureau.imports', {
				abstract: true,
				controller: 'settingsImportsCtrl',
				templateUrl: directory + '/imports/settings-imports.view.html',
				url: ''
			})

				.state('settings.bureau.imports.mappings', {
					controller: 'settingsImportsMappingsCtrl',
					templateUrl: directory + '/imports/mappings/settings-imports-mappings.view.html',
					url: '/imports/mappings',
					data: {
						helpAndSupportOptions: {
							tags: ['bureau-mapping-templates']
						}
					}
				})

			.state('settings.bureau.information', {
				url: '/information',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/information/settings-information.view.html',
			})

			.state('settings.bureau.employee-portal-settings', {
				url: '/employee-portal-settings',
				controller: 'settingsEmployeePortalSettingsCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-employee-portal-settings']
					}
				},
				templateUrl: directory + '/employee-portal/settings-employee-portal-settings.view.html'
			})

			.state('settings.bureau.modules', {
				url: '/modules',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/modules/settings-modules.view.html',
			})

			.state('settings.bureau.overview', {
				url: '/overview'
			})

			.state('settings.bureau.pay-elements', {
				abstract: true,
				controller: 'settingsPayElementsCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['bureau-pay-elements']
					}
				},
				templateUrl: directory + '/pay-elements/settings-pay-elements.view.html',
				url: ''
			})

				.state('settings.bureau.pay-elements.core', {
					url: '/pay-elements/core',
					templateUrl: directory + '/pay-elements/core/settings-pay-elements-core.view.html',
					controller: 'settingsPayElementsCoreCtrl'
				})

				.state('settings.bureau.pay-elements.bik', {
					url: '/pay-elements/bik',
					templateUrl: directory + '/pay-elements/bik/settings-pay-elements-bik.view.html',
					controller: 'settingsPayElementsBIKCtrl'
				})

				.state('settings.bureau.pay-elements.cis', {
					url: '/pay-elements/cis',
					templateUrl: directory + '/pay-elements/cis/settings-pay-elements-cis.view.html',
					controller: 'settingsPayElementsCisCtrl'
				})

				.state('settings.bureau.pay-elements.element-packs', {
					controller: 'settingsPayElementsElementPacksCtrl',
					url: '/pay-elements/element-packs',
					templateUrl: directory + '/pay-elements/element-packs/settings-pay-elements-element-packs.view.html',
				})

			.state('settings.bureau.payroll-settings', {
				url: '/payroll-settings',
				controller: 'bureauPayrollSettingsCtrl',
				templateUrl: directory + '/bureau-payroll-settings/bureau-payroll-settings.view.html',
			})

			.state('settings.bureau.reports', {
				abstract: true,
				controller: 'settingsReportsCtrl',
				data: {
					helpAndSupportOptions: {
						isContextual: true,
						[INTERFACE_TYPES.bureau]: {
							tags: ['bureau-report-templates']
						},
						[INTERFACE_TYPES.group]: {
							tags: ['group-report-templates']
						}
					}
				},
				templateUrl: directory + '/reports/settings-reports.view.html',
				url: '',
			})

				.state('settings.bureau.reports.custom', {
					url: '/reports/custom',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'custom'
					}
				})

				.state('settings.bureau.reports.standard', {
					url: '/reports/standard',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'standard'
					}
				})

				.state('settings.bureau.reports.packs', {
					url: '/reports/packs',
					controller: 'settingsReportsPacksCtrl',
					templateUrl: directory + '/reports/packs/settings-reports-packs.view.html',
				})

			.state('settings.bureau.average-holiday-pay', {
				url: '/average-holiday-pay',
				controller: 'settingsAverageHolidayPayCtrl',
				templateUrl: directory + '/average-holiday-pay/settings-average-holiday-pay.view.html'
			})

			.state('settings.bureau.roles', {
				url: '/roles',
				controller: 'settingsRolesCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['bureau-roles']
					}
				},
				templateUrl: directory + '/roles/settings-roles.view.html',
			})

		/* Groups */
		.state('settings.group', {
			url: '/group',
			abstract: true,
			data: {
				permissions: [
					'Admin.canManageCompanyGroupSettings'
				]
			},
			templateUrl: directory + '/settings-entity.view.html'
		})

			.state('settings.group.admins', {
				url: '/admins',
				controller: 'settingsAdminsCtrl',
				templateUrl: directory + '/admins/settings-admins.view.html',
			})

			.state('settings.group.customisation', {
				url: '/customisation',
				controller: 'settingsCustomisationCtrl',
				templateUrl: directory + '/customisation/settings-customisation.view.html',
			})

			.state('settings.group.email-notifications', {
				url: '/email-notifications',
				controller: 'settingsEmailNotificationsCtrl',
				templateUrl: directory + '/email-notifications/settings-email-notifications.view.html',
				data: {
					permissions: [
						'Admin.canManageEmailNotifications'
					]
				}
			})

			.state('settings.group.information', {
				url: '/information',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/information/settings-information.view.html',
			})

			.state('settings.group.business-categories', {
				controller: 'settingsBusinessCategoriesCtrl',
				templateUrl: directory + '/business-categories/settings-business-categories.view.html',
				url: '/business-categories'
			})

			.state('settings.group.overview', {
				url: '/overview'
			})

			.state('settings.group.reports', {
				abstract: true,
				controller: 'settingsReportsCtrl',
				templateUrl: directory + '/reports/settings-reports.view.html',
				url: '',
			})

				.state('settings.group.reports.custom', {
					url: '/reports/custom',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'custom'
					}
				})

				.state('settings.group.reports.standard', {
					url: '/reports/standard',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'standard'
					}
				})

				.state('settings.group.reports.packs', {
					url: '/reports/packs',
					controller: 'settingsReportsPacksCtrl',
					templateUrl: directory + '/reports/packs/settings-reports-packs.view.html',
				})

			.state('settings.group.gender-pay-gap', {
				url: '/gender-pay-gap',
				controller: 'settingsGenderPayGapCtrl',
				templateUrl: directory + '/gender-pay-gap/settings-gender-pay-gap.view.html'
			})

			.state('settings.group.modules', {
				url: '/modules',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/modules/settings-modules.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['group-modules']
					}
				}
			})

		/* Companies */
		.state('settings.company', {
			url: '/company',
			abstract: true,
			data: {
				helpAndSupportOptions: {
					tags: ['company-settings']
				},
				permissions: [
					'isCompanySettingsVisible'
				]
			},
			templateUrl: directory + '/settings-entity.view.html',
		})

			.state('settings.company.admins', {
				url: '/admins',
				controller: 'settingsAdminsCtrl',
				templateUrl: directory + '/admins/settings-admins.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-admins']
					},
					permissions: [
						'CompanySettings.canAccessPermissions'
					]
				},
			})

			.state('settings.company.billing', {
				url: '/billing',
				controller: 'settingsBillingCtrl',
				templateUrl: directory + '/billing/settings-billing.view.html',
			})

			.state('settings.company.customisation', {
				url: '/customisation',
				controller: 'settingsCustomisationCtrl',
				templateUrl: directory + '/customisation/settings-customisation.view.html',
			})

			.state('settings.company.email-notifications', {
				url: '/email-notifications',
				controller: 'settingsEmailNotificationsCtrl',
				templateUrl: directory + '/email-notifications/settings-email-notifications.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-email-notifications']
					},
					permissions: [
						'Admin.canManageEmailNotifications',
						'CompanySettings.canAccessNotifications'
					]
				}
			})

			.state('settings.company.employee-portal-settings', {
				url: '/employee-portal-settings',
				controller: 'settingsEmployeePortalSettingsCtrl',
				templateUrl: directory + '/employee-portal/settings-employee-portal-settings.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-employee-portal-settings']
					}
				}
			})

			.state('settings.company.information', {
				url: '/information',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/information/settings-information.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-information']
					},
					permissions: [
						'CompanySettings.canAccessGeneral'
					]
				}
			})

			.state('settings.company.integrations', {
				url: '/integrations',
				controller: 'settingsIntegrationsCtrl',
				templateUrl: directory + '/integrations/settings-integrations.view.html',
				data: {
					permissions: [
						'CompanySettings.canAccessModules'
					]
				}
			})

			.state('settings.company.imports', {
				abstract: true,
				controller: 'settingsImportsCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-imports']
					}
				},
				templateUrl: directory + '/imports/settings-imports.view.html',
				url: ''
			})

				.state('settings.company.imports.settings', {
					controller: 'settingsImportsSettingsCtrl',
					templateUrl: directory + '/imports/settings/settings-imports-settings.view.html',
					url: '/imports/settings'
				})

				.state('settings.company.imports.mappings', {
					controller: 'settingsImportsMappingsCtrl',
					templateUrl: directory + '/imports/mappings/settings-imports-mappings.view.html',
					url: '/imports/mappings'
				})

			.state('settings.company.business-categories', {
				abstract: true,
				controller: 'settingsBusinessCategoriesCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-business-categories']
					}
				},
				templateUrl: directory + '/business-categories/settings-business-categories.view.html',
				url: '',
			})

				.state('settings.company.business-categories.category', {
					controller: 'settingsBusinessCategoriesCategoryCtrl',
					templateUrl: directory + '/business-categories/category/settings-business-categories-category.view.html',
					url: '/business-categories/category?categoryId'
				})

				.state('settings.company.business-categories.imports', {
					controller: 'settingsBusinessCategoriesImportsCtrl',
					templateUrl: directory + '/business-categories/imports/settings-business-categories-imports.view.html',
					url: '/business-categories/imports'
				})

			.state('settings.company.journals', {
				abstract: true,
				controller: 'settingsJournalsCtrl',
				templateUrl: directory + '/journals/settings-journals.view.html',
				url: '',
				data: {
					helpAndSupportOptions: {
						tags: ['company-journals']
					},
					permissions: [
						'CompanySettings.canAccessReports'
					]
				}
			})

				.state('settings.company.journals.nominal-codes', {
					controller: 'settingsJournalsNominalCodesCtrl',
					templateUrl: directory + '/journals/nominal-codes/settings-journals-nominal-codes.view.html',
					url: '/journals/nominal-codes'
				})

				.state('settings.company.journals.business-categories', {
					controller: 'settingsJournalsBusinessCategoriesCtrl',
					templateUrl: directory + '/journals/business-categories/settings-journals-business-categories.view.html',
					url: '/journals/business-categories'
				})

				.state('settings.company.journals.imports', {
					controller: 'settingsJournalsImportsCtrl',
					templateUrl: directory + '/journals/imports/settings-journals-imports.view.html',
					url: '/journals/imports'
				})

				.state('settings.company.journals.posts', {
					controller: 'settingsJournalsPostsCtrl',
					templateUrl: directory + '/journals/posts/settings-journals-posts.view.html',
					url: '/journals/posts'
				})

			.state('settings.company.modules', {
				url: '/modules',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/modules/settings-modules.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-modules']
					},
					permissions: [
						'CompanySettings.canAccessModules'
					]
				}
			})

			.state('settings.company.overview', {
				url: '/overview'
			})

			.state('settings.company.p11db-submissions', {
				url: '/p11db-submissions',
				controller: 'settingsP11DbSubmissionsCtrl',
				templateUrl: directory + '/p11db-submissions/settings-p11db-submissions.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-p11db-submissions']
					}
				}
			})

			.state('settings.company.gender-pay-gap', {
				url: '/gender-pay-gap',
				controller: 'settingsGenderPayGapCtrl',
				templateUrl: directory + '/gender-pay-gap/settings-gender-pay-gap.view.html'
			})

			.state('settings.company.payroll-settings', {
				url: '/payroll-settings',
				controller: 'settingsPayrollSettingsCtrl',
				templateUrl: directory + '/payroll-settings/settings-payroll-settings.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-payroll-settings']
					},
					permissions: [
						'CompanySettings.canAccessPayroll'
					]
				}
			})

			.state('settings.company.payslips', {
				url: '/payslips',
				controller: 'settingsPayslipsCtrl',
				templateUrl: directory + '/payslips/settings-payslips.view.html',
				data: {
					helpAndSupportOptions: {
						tags: [
							'company-payslips'
						]
					},
					permissions: [
						'CompanySettings.canAccessPayroll'
					]
				}
			})

			.state('settings.company.pension-settings', {
				url: '/pension-settings',
				controller: 'settingsPensionSettingsCtrl',
				templateUrl: directory + '/pension-settings/settings-pension-settings.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-pension-settings']
					}
				}
			})

			.state('settings.company.pay-elements', {
				abstract: true,
				controller: 'settingsPayElementsCtrl',
				templateUrl: directory + '/pay-elements/settings-pay-elements.view.html',
				url: '',
				data: {
					helpAndSupportOptions: {
						tags: ['company-pay-elements']
					},
					permissions: [
						'CompanySettings.canAccessPayroll'
					]
				}
			})

				.state('settings.company.pay-elements.additions', {
					url: '/pay-elements/additions',
					templateUrl: directory + '/pay-elements/additions/settings-pay-elements-additions.view.html',
					controller: 'settingsPayElementsAdditionsCtrl'
				})

				.state('settings.company.pay-elements.core', {
					url: '/pay-elements/core',
					templateUrl: directory + '/pay-elements/core/settings-pay-elements-core.view.html',
					controller: 'settingsPayElementsCoreCtrl'
				})

				.state('settings.company.pay-elements.deductions', {
					url: '/pay-elements/deductions',
					templateUrl: directory + '/pay-elements/deductions/settings-pay-elements-deductions.view.html',
					controller: 'settingsPayElementsDeductionsCtrl'
				})

				.state('settings.company.pay-elements.bik', {
					url: '/pay-elements/bik',
					templateUrl: directory + '/pay-elements/bik/settings-pay-elements-bik.view.html',
					controller: 'settingsPayElementsBIKCtrl'
				})

				.state('settings.company.pay-elements.cis', {
					url: '/pay-elements/cis',
					templateUrl: directory + '/pay-elements/cis/settings-pay-elements-cis.view.html',
					controller: 'settingsPayElementsCisCtrl'
				})

				.state('settings.company.pay-elements.disbursements', {
					url: '/pay-elements/disbursements',
					templateUrl: directory + '/pay-elements/disbursements/settings-pay-elements-disbursements.view.html',
					controller: 'settingsPayElementsDisbursementsCtrl'
				})

				.state('settings.company.pay-elements.link-elements', {
					url: '/pay-elements/link-elements',
					templateUrl: directory + '/pay-elements/link-elements/settings-pay-elements-link-elements.view.html',
					controller: 'settingsPayElementsLinkElementsCtrl'
				})

				.state('settings.company.pay-elements.payslip-labels', {
					url: '/pay-elements/payslip-labels',
					templateUrl: directory + '/pay-elements/payslip-labels/settings-pay-elements-payslip-labels.view.html',
				})

				.state('settings.company.pay-elements.element-packs', {
					controller: 'settingsPayElementsElementPacksCtrl',
					url: '/pay-elements/element-packs',
					templateUrl: directory + '/pay-elements/element-packs/settings-pay-elements-element-packs.view.html',
				})

			.state('settings.company.reports', {
				abstract: true,
				templateUrl: directory + '/reports/settings-reports.view.html',
				controller: 'settingsReportsCtrl',
				url: '',
				data: {
					helpAndSupportOptions: {
						tags: ['company-report-templates']
					},
					permissions: [
						'CompanySettings.canAccessReports'
					]
				}
			})

				.state('settings.company.reports.custom', {
					url: '/reports/custom',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'custom'
					}
				})

				.state('settings.company.reports.standard', {
					url: '/reports/standard',
					controller: 'settingsReportsTemplatesCtrl',
					templateUrl: directory + '/reports/templates/settings-reports-templates.view.html',
					params: {
						reportFilter: 'standard'
					}
				})

				.state('settings.company.reports.packs', {
					url: '/reports/packs',
					controller: 'settingsReportsPacksCtrl',
					templateUrl: directory + '/reports/packs/settings-reports-packs.view.html',
				})

			.state('settings.company.average-holiday-pay', {
				url: '/average-holiday-pay',
				controller: 'settingsAverageHolidayPayCtrl',
				templateUrl: directory + '/average-holiday-pay/settings-average-holiday-pay.view.html',
				data: {
					permissions: [
						'CompanySettings.canAccessReports'
					]
				}
			})

			.state('settings.company.roles', {
				url: '/roles',
				controller: 'settingsRolesCtrl',
				templateUrl: directory + '/roles/settings-roles.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-roles']
					},
					permissions: [
						'CompanySettings.canAccessPermissions'
					]
				}
			})

			.state('settings.company.upgrade', {
				url: '/upgrade',
				controller: 'settingsUpgradeCtrl',
				templateUrl: directory + '/upgrade/settings-upgrade.view.html',
			})

			.state('settings.company.work-patterns', {
				url: '/work-patterns',
				controller: 'settingsWorkPatternsCtrl',
				templateUrl: directory + '/work-patterns/settings-work-patterns.view.html',
				data: {
					helpAndSupportOptions: {
						tags: ['company-work-patterns']
					},
					permissions: [
						'CompanySettings.canAccessPayroll'
					]
				}
			})

			.state('settings.company.workflow', {
				url: '/workflow',
				controller: 'settingsWorkflowCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-workflow']
					}
				},
				templateUrl: directory + '/workflow/settings-workflow.view.html'
			})

			.state('settings.company.file-uploads', {
				url: '/file-uploads',
				controller: 'settingsFileUploadsCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-file-uploads']
					}
				},
				templateUrl: directory + '/file-uploads/settings-file-uploads.view.html'
			})

			.state('settings.company.currencies', {
				url: '/currencies',
				controller: 'settingsCurrenciesCtrl',
				data: {
					helpAndSupportOptions: {
						tags: ['company-currencies']
					}
				},
				templateUrl: directory + '/currencies/settings-currencies.view.html'
			});
}]);

'use strict';

angular.module('paycircleApp')

	.controller('settingsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'base',
	'companyData',
	'companyService',
	'settingsService',
	'COMPANY_TYPES',
	'FEATURE_FLAGS',
		function (
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		base,
		companyData,
		companyService,
		settingsService,
		COMPANY_TYPES,
		FEATURE_FLAGS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const loggedInUser = $rootScope.currentUser;

	function init () {

		setPageState('loading');

		const getAgencyCustomerCodeEnabledState = companyData.getAgencyCustomerCodeEnabledState(agencyProfileId);
		const getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);
		const getIsAverageHolidayPayEnabled = base.isFeatureEnabled(agencyProfileId, FEATURE_FLAGS.AVERAGE_HOLIDAY_PAY);

		$q.all([getAgencyProfileCompanyInformationDetailed, getAgencyCustomerCodeEnabledState, getIsAverageHolidayPayEnabled]).then(([companyObj, isCustomerCodeEnabled, isAverageHolidayPayEnabled]) => {

			angular.extend(companyObj, {
				isBillingEnabled: $rootScope.currentCompany.isBillingEnabled,
				IsCustomerCodesEnabled: $rootScope.currentCompany.IsCustomerCodesEnabled,
				IsExpatActive: $rootScope.currentCompany.IsExpatActive,
				MandateState: $rootScope.currentCompany.MandateState
			});

			angular.extend($scope, {
				company: companyService.decorateCompanyInformationDetailedObj(companyObj),
				isPayrollCompany: companyService.isPayrollCompany(companyObj), // Required for child pages (e.g. Company Overview)
				settingsOverviewGroups: settingsService.getSettingsOverviewCardsForCompanyType(companyObj, loggedInUser, isCustomerCodeEnabled, isAverageHolidayPayEnabled)
			});

			setPageState('ready');

		})
			.catch(function (error) {
				setPageState('error');
				console.error(error);
			});
	}

	function refreshCompanyDetails () {

		$scope.callbackFired = true;

		init();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}
	init();

	angular.extend($scope, {
		COMPANY_TYPES,
		$state,

		agencyProfileId,
		callbackFired: false,
		refreshCompanyDetails
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const directory = 'features/app/rotaready-connection/';

	$stateProvider
	.state('rotaready-connection', {
		url: '/rotaready-connection/:agencyProfileId',
		templateUrl: directory + 'rotaready-connection.view.html',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			fullPage: true,
			document: true
		}
	})
		.state('rotaready-connection.summary', {
			url: '/summary',
			templateUrl: directory + 'rotaready-summary/rotaready-summary.view.html',
			controller: 'rotareadySummaryCtrl'
		})
		.state('rotaready-connection.paycircle-only', {
			url: '/paycircle-only',
			templateUrl: directory + 'rotaready-employees-only-paycircle/rotaready-employees-only-paycircle.view.html',
			controller: 'rotareadyPaycircleOnlyCtrl'
		})
		.state('rotaready-connection.matched', {
			url: '/matched',
			templateUrl: directory + 'rotaready-matched/rotaready-matched.view.html',
			controller: 'rotareadyMatchedCtrl'
		})
		.state('rotaready-connection.match-now', {
		url: '/match-now',
		templateUrl: directory + 'rotaready-match-now/rotaready-match-now.view.html',
		controller: 'rotareadyMatchNowCtrl'
	})
	.state('rotaready-connection.entity-matched', {
		url: '/entity-matched',
		templateUrl: directory + 'rotaready-entity-matched/rotaready-entity-matched.view.html',
		controller: 'rotareadyEntityMatchedCtrl'
	})
	.state('rotaready-connection.entity-match-now', {
		url: '/entity-match-now',
		templateUrl: directory + 'rotaready-entity-match-now/rotaready-entity-match-now.view.html',
		controller: 'rotareadyEntityMatchNowCtrl'
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('rotareadySummaryCtrl', [
	'$q',
	'$state',
	'$scope',
	'$stateParams',
	'companyData',
	'config',
	'rotareadyTeamMembersDataFactory',
	'rotareadyTeamMembersService',
	function (
		$q,
		$state,
		$scope,
		$stateParams,
		companyData,
		config,
		rotareadyTeamMembersDataFactory,
		rotareadyTeamMembersService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	const PAGE_STATE = {
		error: 'error',
		loading: 'loading',
		ready: 'ready',
	};

	const STAT_TYPES = {
		matched: 'matched',
		unmatchedRotaready: 'unmatchedRotaready',
		unmatchedPaycircle: 'unmatchedPaycircle',
	};

	function init () {

		setPageState('loading');
		getTeamMembers();
		loadEntityBusinessCodeMapping();
	}

	function loadEntityBusinessCodeMapping () {

		companyData.getRotareadyEntityBusinessCodeMapping(agencyProfileId).then(result => {

			const mappings = result.EntityBusinessCodeMapping || [];

			const entityMappingMatched = mappings.filter(m => {
				return m.BusinessCodeID && m.BusinessCodeID !== config.guidEmpty;
			}).length;
			const entityMappingUnmatched = mappings.filter(m => {
				return !m.BusinessCodeID || m.BusinessCodeID === config.guidEmpty;
			}).length;

			angular.extend($scope, {
				entitiesLinkedFromRotaready: mappings.length,
				entityMappingMatched,
				entityMappingUnmatched,
				unmappedEntityStatTitle: `${entityMappingUnmatched} unmapped site${entityMappingUnmatched === 1 ? '/department' : 's/departments'}`,
				unmappedEntityStatDescription: entityMappingUnmatched === 1 ? 'This site/department was sent from Rotaready and hasn\'t been mapped to a business category in Paycircle.'
					: 'These sites/departments were sent from Rotaready and haven\'t been mapped to business categories in Paycircle.',
				mappedEntityStatTitle: `${entityMappingMatched} mapped site${entityMappingMatched === 1 ? '/department' : 's/departments'}`,
				mappedEntityStatDescription: entityMappingMatched === 1 ? 'This site/department was sent from Rotaready and has been mapped to a business category in Paycircle.'
					: 'These sites/departments were sent from Rotaready and have been mapped to business categories in Paycircle.',
			});
		})
		.catch(onError);
	}

	function goToEntityMatched () {

		$state.go('rotaready-connection.entity-matched', { agencyProfileId });
	}

	function goToEntityMatchNow () {

		$state.go('rotaready-connection.entity-match-now', { agencyProfileId });
	}

	function getTeamMembers () {

		const getUserMapping = rotareadyTeamMembersService.getAccessRotareadyUserMapping(agencyProfileId);
		const getPayElementMapping = companyData.getAccessRotareadyPayElementMapping(agencyProfileId);

		$q.all([
			getUserMapping,
			getPayElementMapping
		]).then(
		([
			_,
			payElementMappingArr
		]) => {
			const teamMembersMatched = rotareadyTeamMembersDataFactory.getTeamMembersMatched();
			const teamMembersUnmatchedRotaready = rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedRotaready();
			const teamMembersUnmatchedPaycircle = rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedPaycircle();
			angular.extend($scope, {
				teamMembersMatched,
				teamMembersUnmatchedRotaready,
				teamMembersUnmatchedPaycircle,
				teamMembersReceivedFromRotaready: rotareadyTeamMembersDataFactory.getTeamMembersReceivedFromRotaready(),

				unmatchedPayElements: payElementMappingArr.filter(x => !x.Paycircle).map(x => x.Rotaready.Name),

				unmatchedRotareadyStatTitle: getStatTitle(teamMembersUnmatchedRotaready.length, STAT_TYPES.unmatchedRotaready),
				unmatchedPaycircleStatTitle: getStatTitle(teamMembersUnmatchedPaycircle.length, STAT_TYPES.unmatchedPaycircle),
				matchedStatTitle: getStatTitle(teamMembersMatched.length, STAT_TYPES.matched),
				unmatchedRotareadyStatDescription: getStatDescriptions(teamMembersUnmatchedRotaready.length, STAT_TYPES.unmatchedRotaready),
				unmatchedPaycircleStatDescription: getStatDescriptions(teamMembersUnmatchedPaycircle.length, STAT_TYPES.unmatchedPaycircle),
				matchedStatDescription: getStatDescriptions(teamMembersMatched.length, STAT_TYPES.matched),
			});
			setPageState(PAGE_STATE.ready);
		})
		.catch(onError);
	}

	function onError () {

		setPageState(PAGE_STATE.error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}


	function goTo(state) {

		$state.go(state, { agencyProfileId });
	}

	function getStatDescriptions (count, type) {

		const descriptions = {
			[STAT_TYPES.matched]: count === 1 ? `This employee was sent from Rotaready and has been matched with an employee in Paycircle.`
				: `These employees were sent from Rotaready and have been matched with employees in Paycircle.`,
			[STAT_TYPES.unmatchedRotaready]: count === 1 ? `This employee was sent from Rotaready and couldn\'t be matched with an employee in Paycircle.`
				: `These employees were sent from Rotaready and couldn\'t be matched with employees in Paycircle.`,
			[STAT_TYPES.unmatchedPaycircle]: `Choose which employees you\'d like to send to Rotaready to be created. \'Send all\' will send all ${count === 1 ? count + ' employee' : count + ' employees'} over.`,
		};
		return descriptions[type] || '';
	}

	function getStatTitle(count, type) {

		const titles = {
			[STAT_TYPES.matched]: `${count} matched employee${count === 1 ? '' : 's'}`,
			[STAT_TYPES.unmatchedRotaready]: `${count} unmatched employee${count === 1 ? '' : 's'}`,
			[STAT_TYPES.unmatchedPaycircle]: `${count} exist${count === 1 ? 's' : ''} only in Paycircle`,
		};
		return titles[type] || '';
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		PAGE_STATE,
		goBack: () => goTo('settings.company.integrations'),
		goToEntityMatched: goToEntityMatched,
		goToEntityMatchNow: goToEntityMatchNow,
		goToOnlyPaycircle: () => goTo('rotaready-connection.paycircle-only'),
		goToMatched: () => goTo('rotaready-connection.matched'),
		goToMatchNow: () => goTo('rotaready-connection.match-now'),
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('rotareadyMatchedCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'$state',
	'bulkService',
	'searchService',
	'rotareadyTeamMembersDataFactory',
	'rotareadyTeamMembersService',
	function (
		$rootScope,
		$scope,
		$stateParams,
		$state,
		bulkService,
		searchService,
		rotareadyTeamMembersDataFactory,
		rotareadyTeamMembersService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');
		// Try to use data from the factory, if its not there call the API
		const teamMembersMatched = rotareadyTeamMembersDataFactory.getTeamMembersMatched();
		if (teamMembersMatched.length === 0) {
			fetchNewData();
		}
		else {
			updateScopeData(teamMembersMatched);
		}
	}

	function fetchNewData () {

		setPageState('loading');

		rotareadyTeamMembersService.getAccessRotareadyUserMapping(agencyProfileId).then(() => {
			updateScopeData(rotareadyTeamMembersDataFactory.getTeamMembersMatched());
		})
		.catch(onError);
	}

	function goTo () {
		$state.go('rotaready-connection.match-now', { agencyProfileId });
	}

	function onError () {

		setPageState('error');
	}

	function updateScopeData (teamMembersMatched) {

		$scope.teamMembersMatched = bulkService.getBulkItemsObj(teamMembersMatched);

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function cancel () {

		$state.go('rotaready-connection.summary', { agencyProfileId });
	}

	function unmatchTeamMembers (teamMember) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: fetchNewData,
			formKey: 'company-settings-rotaready-unmatch',
			teamMember,
			title: 'Unmatch team member'
		});
	}

	init();

	angular.extend($scope, {
		cancel,
		goTo,
		searchBarOptions: searchService.teamRotaready,
		unmatchTeamMembers
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('rotareadyMatchNowCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'bulkService',
	'payrollData',
	'rotareadyTeamMembersDataFactory',
	'rotareadyTeamMembersService',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		bulkService,
		payrollData,
		rotareadyTeamMembersDataFactory,
		rotareadyTeamMembersService
	) {

		const agencyProfileId = $stateParams.agencyProfileId;

		const TABS = {
			AVAILABLE: 'availableToMatch',
			PENDING: 'pending'
		};

		function init () {
	
			setPageState('loading');
	
			payrollData.getPayPeriodMinimum(agencyProfileId).then(payPeriodObj => {
	
				$scope.isPayrollLocked = payPeriodObj.IsPayrollLocked;
	
				const teamMembersUnmatchedRotaready = rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedRotaready();
				const teamMembersUnmatchedPaycircle = rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedPaycircle();
	
				if (teamMembersUnmatchedRotaready.length === 0 || teamMembersUnmatchedPaycircle.length === 0) {
	
					fetchNewData();
				}
				else {
					refreshLists(true);
					setPageState('ready');
				}
			})
			.catch(onError);
		}

		function fetchNewData () {

			setPageState('loading');

			rotareadyTeamMembersService.getAccessRotareadyUserMapping(agencyProfileId).then(() => {
				refreshLists(true);
				setPageState('ready');
			})
			.catch(onError);
		}

		function onSaveMappings () {

			const teamMembersMappings = rotareadyTeamMembersDataFactory.getTeamMembersMappings();

			$rootScope.openSlideInForm({
				agencyProfileId,
				callback: fetchNewData,
				formKey: 'company-settings-rotaready-save',
				teamMembersMappings,
				title: 'Save matches'
			});
		}

		function onError () {

			setPageState('error');
		}

		function cancel () {

			$state.go('rotaready-connection.summary', { agencyProfileId });
		}

		function setPageState (pageState) {

			$scope.pageState = pageState;
		}

		function setActiveTab (tab) {

			$scope.activeTab = tab;
		}

		function updateTeamMemberState (teamMember, action) {

			switch (action) {
				case 'match':
					rotareadyTeamMembersDataFactory.matchTeamMembers(teamMember);
					break;
				case 'unmatch':
					rotareadyTeamMembersDataFactory.unmatchTeamMembers(teamMember);
					break;
				case 'create':
					rotareadyTeamMembersDataFactory.addNewPaycircleTeamMember(teamMember);
					break;
				case 'cancelCreate':
					rotareadyTeamMembersDataFactory.cancelNewPaycircleTeamMember(teamMember);
					break;
			}

			refreshLists(false);
		}

		function refreshLists (setTabs) {

			let activeTab = $scope.activeTab;

			if (setTabs) {
				activeTab = TABS.AVAILABLE;
			}

			const teamMembersUnmatchedRotaready = [...rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedRotaready()];
			const teamMembersUnmatchedPaycircle = [...rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedPaycircle()];
			const teamMemberMappingsUpdated = [...rotareadyTeamMembersDataFactory.getTeamMembersMappings()];
			const createInPaycircle = [...rotareadyTeamMembersDataFactory.getCreateInPaycircle()];
			const teamMembersUnmatchedRotareadyBulkItems = bulkService.getBulkItemsObj(teamMembersUnmatchedRotaready);
			const teamMemberMappingsUpdatedBulkItems = bulkService.getBulkItemsObj(teamMemberMappingsUpdated);

			// If there are no more unmatched Rotaready members, switch to Pending tab
			if (teamMembersUnmatchedRotaready.length === 0 && teamMemberMappingsUpdated.length > 0) {
				activeTab = TABS.PENDING;
			}
			else if (teamMemberMappingsUpdated.length === 0) {
				activeTab = TABS.AVAILABLE;
			}

			angular.extend($scope, {
				activeTab,
				teamMembersUnmatchedRotaready,
				teamMembersUnmatchedPaycircle,
				teamMemberMappingsUpdated,
				createInPaycircle,
				teamMembersUnmatchedRotareadyBulkItems,
				teamMemberMappingsUpdatedBulkItems
			});
		}

		$scope.$on('tabCountsUpdated', () => {
			refreshLists(false);
		});

		init();

		angular.extend($scope, {
			cancel,
			onSaveMappings,
			setActiveTab,
			updateTeamMemberState,

			TABS
		});
}]);

'use strict';

angular.module('paycircleApp')
.controller('rotareadyPaycircleOnlyCtrl', [
	'$scope',
	'$state',
	'$stateParams',
	'rotareadyTeamMembersDataFactory',
	'rotareadyTeamMembersService',
	function (
		$scope,
		$state,
		$stateParams,
		rotareadyTeamMembersDataFactory,
		rotareadyTeamMembersService
	) {

		const agencyProfileId = $stateParams.agencyProfileId;

		function init() {

			setPageState('loading');

			const teamMembersUnmatchedPaycircle = rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedPaycircle();
			if (teamMembersUnmatchedPaycircle.length === 0) {
				rotareadyTeamMembersService.getAccessRotareadyUserMapping(agencyProfileId).then(() => {
					updateScopeData(rotareadyTeamMembersDataFactory.getTeamMembersUnmatchedPaycircle());
				})
				.catch(onError);
			}
			else {
				updateScopeData(teamMembersUnmatchedPaycircle);
			}
		}

		function updateScopeData(teamMembers) {

			angular.extend($scope, {
				teamMembersUnmatchedPaycircle: teamMembers,
				createInRotaready: []
			});
			setPageState('ready');
		}

		function toggleAllTeamMembers (changeToBool) {

			for (let teamMemberObj of $scope.teamMembersUnmatchedPaycircle) {
				teamMemberObj.Paycircle.isSelected = changeToBool;
			}

			updateSelectedTeamMembers();
		}

		function updateSelectedTeamMembers() {

			const selectedTeamMembers = [];

			for (let teamMemberObj of $scope.teamMembersUnmatchedPaycircle) {
				if (teamMemberObj.Paycircle.isSelected) {
					selectedTeamMembers.push(teamMemberObj);
				}
			}

			$scope.createInRotaready = selectedTeamMembers;
		}

		function onSendToRotaready () {
			console.log($scope.createInRotaready);
		}

		function onError (error) {
			setPageState('error');
			console.error(error);
		}

		function cancel() {

			$state.go('rotaready-connection.summary', {
				agencyProfileId: agencyProfileId
			});
		}

		function setPageState(pageState) {

			$scope.pageState = pageState;
		}

		init();

		angular.extend($scope, {
			cancel,
			toggleAllTeamMembers,
			updateSelectedTeamMembers,
			onSendToRotaready
		});

}]);

'use strict';

angular.module('paycircleApp')

.controller('rotareadyEntityMatchedCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'bulkService',
	'BUSINESS_CATEGORY_TYPE_OPTIONS',
	'companyData',
	'config',
	'searchService',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		bulkService,
		BUSINESS_CATEGORY_TYPE_OPTIONS,
		companyData,
		config,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		loadEntityBusinessCodeMapping();
	}

	function loadEntityBusinessCodeMapping () {

		companyData.getRotareadyEntityBusinessCodeMapping(agencyProfileId).then(function (result) {

			const businessCodes = result.BusinessCodes;

				const allEntities = result.EntityBusinessCodeMapping.map(function (entity) {
				const businessCodeId = entity.BusinessCodeID !== config.guidEmpty ? entity.BusinessCodeID : null;
				const businessCode = businessCodeId ? getBusinessCodeById(businessCodes, businessCodeId) : null;

				return {
					RotareadyEntityID: entity.RotareadyEntityID,
					EntityName: entity.EntityName,
					EntityNameRaw: entity.EntityNameRaw,
					PayrollCalendarName: entity.PayrollCalendarName,
					PayrollCalendarStartDateISO: entity.PayrollCalendarStartDateISO,
					EntityGroupName: entity.EntityGroupName,
					MissingInSourceUTC: entity.MissingInSourceUTC,
					BusinessCodeID: businessCodeId,
					businessCodeNarrative: businessCode ? businessCode.BusinessCodeNarrative : null,
					businessCodeValue: businessCode ? businessCode.BusinessCodeValue : null,
					businessCategoryTypeDescription: businessCode ? getCategoryTypeDescription(businessCode.BusinessCategoryType, businessCode) : null
				};
			});

			const mapped = allEntities.filter(function (e) {
				return e.BusinessCodeID;
			});

			$scope.entitiesMapped = bulkService.getBulkItemsObj(mapped);

			setPageState('ready');
		})
		.catch(onError);
	}

	function getBusinessCodeById (businessCodes, businessCodeId) {

		if (!businessCodeId || !businessCodes) {
			return null;
		}

		return businessCodes.find(function (code) {
			return code.BusinessCodeID === businessCodeId;
		});
	}

	function getCategoryTypeDescription (categoryType, businessCode) {

		if (categoryType === 0 && businessCode) {
			return businessCode.BusinessCategoryName || 'Custom';
		}

		const match = BUSINESS_CATEGORY_TYPE_OPTIONS.find(function (option) {
			return option.value === categoryType;
		});
		return match ? match.description : '';
	}

	function unmapEntity (entity) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: loadEntityBusinessCodeMapping,
			formKey: 'company-settings-rotaready-entity-unmatch',
			entity: entity,
			title: 'Unmap site/department'
		});
	}

	function goToMapNow () {

		$state.go('rotaready-connection.entity-match-now', { agencyProfileId: agencyProfileId });
	}

	function cancel () {

		$state.go('rotaready-connection.summary', { agencyProfileId: agencyProfileId });
	}

	function onError () {

		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		cancel: cancel,
		goToMapNow: goToMapNow,
		searchBarOptions: searchService.entityRotareadyMatched,
		unmapEntity: unmapEntity
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('rotareadyEntityMatchNowCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'bulkService',
	'BUSINESS_CATEGORY_TYPE_OPTIONS',
	'companyData',
	'config',
	'ROTAREADY_ENTITY_NAMING_STRATEGIES',
	'searchService',
	'utilities',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		bulkService,
		BUSINESS_CATEGORY_TYPE_OPTIONS,
		companyData,
		config,
		ROTAREADY_ENTITY_NAMING_STRATEGIES,
		searchService,
		utilities
	) {

	const businessCategoryFilterStorageKey = 'entityCustom';
	const agencyProfileId = $stateParams.agencyProfileId;

	const NAMING_STRATEGIES = ROTAREADY_ENTITY_NAMING_STRATEGIES;

	const TABS = {
		AVAILABLE: 'available',
		PENDING: 'pending'
	};

	function init () {

		setPageState('loading');
		$scope.activeTab = TABS.AVAILABLE;

		loadEntityBusinessCodeMapping();
	}

	function loadEntityBusinessCodeMapping () {

		companyData.getRotareadyEntityBusinessCodeMapping(agencyProfileId).then(function (result) {

			$scope.businessCodes = result.BusinessCodes;
			$scope.businessCategories = result.BusinessCategories || [];
			$scope.readOnlyFramework = result.ReadOnlyFramework;

			const allEntities = result.EntityBusinessCodeMapping.map(function (entity) {
				const businessCodeId = entity.BusinessCodeID !== config.guidEmpty ? entity.BusinessCodeID : null;

				return {
					RotareadyEntityID: entity.RotareadyEntityID,
					EntityName: entity.EntityName,
					EntityNameRaw: entity.EntityNameRaw,
					PayrollCalendarName: entity.PayrollCalendarName,
					PayrollCalendarStartDateISO: entity.PayrollCalendarStartDateISO,
					EntityGroupName: entity.EntityGroupName,
					MissingInSourceUTC: entity.MissingInSourceUTC,
					BusinessCodeID: businessCodeId,
					selectedBusinessCodeID: null,
					isNewBusinessCode: false
				};
			});

			const unmapped = allEntities.filter(function (e) {
				return !e.BusinessCodeID;
			});

			setBusinessCategoryDescriptions();
			getPossibleMatches(unmapped);

			$scope.entitiesUnmapped = bulkService.getBulkItemsObj(unmapped);
			$scope.entityMappingsPending = [];
			$scope.newBusinessCodes = [];
			$scope.searchBarOptions = searchService.entityRotaready;

			filterBusinessCodes();

			setPageState('ready');
		})
		.catch(onError);
	}

	function setBusinessCategoryDescriptions () {

		$scope.businessCodes.forEach(function (businessCode) {
			businessCode.businessCategoryTypeDescription = getCategoryTypeDescription(businessCode.BusinessCategoryType, businessCode);
		});
	}

	function getPossibleMatches (entities) {

		if (!entities || !$scope.businessCodes) {
			return;
		}

		entities.forEach(function (entity) {

			if (!entity.EntityName) {
				entity.possibleMatches = [];
				return;
			}

			const entityNameLower = entity.EntityName.toLowerCase().trim();

			entity.possibleMatches = $scope.businessCodes.filter(function (code) {
				const codeNameLower = code.BusinessCodeNarrative.toLowerCase().trim();
				return codeNameLower === entityNameLower || codeNameLower.indexOf(entityNameLower) !== -1 || entityNameLower.indexOf(codeNameLower) !== -1;
			});
		});
	}

	function getCategoryTypeDescription (categoryType, businessCode) {

		if (categoryType === 0 && businessCode) {
			return businessCode.BusinessCategoryName || 'Custom';
		}

		const match = BUSINESS_CATEGORY_TYPE_OPTIONS.find(function (option) {
			return option.value === categoryType;
		});
		return match ? match.description : '';
	}

	function mapEntity (entity) {

		if (!entity.selectedBusinessCodeID) {
			return;
		}

		const businessCode = getBusinessCodeById(entity.selectedBusinessCodeID);

		entity.BusinessCodeID = entity.selectedBusinessCodeID;
		entity.businessCodeNarrative = businessCode ? businessCode.BusinessCodeNarrative : null;
		entity.businessCodeValue = businessCode ? businessCode.BusinessCodeValue : null;
		entity.businessCategoryTypeDescription = businessCode ? getCategoryTypeDescription(businessCode.BusinessCategoryType, businessCode) : null;
		entity.selectedBusinessCodeID = null;
		entity.isNewBusinessCode = businessCode ? businessCode.isNewBusinessCode : false;

		$scope.entityMappingsPending.push(entity);

		const unmappedAll = $scope.entitiesUnmapped.all.filter(function (e) {
			return e.RotareadyEntityID !== entity.RotareadyEntityID;
		});
		$scope.entitiesUnmapped = bulkService.getBulkItemsObj(unmappedAll);

		if (unmappedAll.length === 0 && $scope.entityMappingsPending.length > 0) {
			$scope.activeTab = TABS.PENDING;
		}
	}

	function mapEntityFromSuggestion (entity, businessCode) {

		entity.selectedBusinessCodeID = businessCode.BusinessCodeID;
		entity.selectedBusinessCode = businessCode;
	}

	function mapEntitySelect (entity) {

		entity.selectedBusinessCode = getBusinessCodeById(entity.selectedBusinessCodeID);
	}

	function mapEntityDeselect (entity) {

		entity.selectedBusinessCodeID = null;
		entity.selectedBusinessCode = null;
	}

	function unmapPendingEntity (entity) {

		const businessCodeID = entity.BusinessCodeID;
		const isCreatedCode = $scope.newBusinessCodes.some(function (e) {
			return e.BusinessCodeID === entity.BusinessCodeID;
		});

		entity.BusinessCodeID = null;
		entity.businessCodeNarrative = null;
		entity.businessCodeValue = null;
		entity.businessCategoryTypeDescription = null;
		entity.selectedBusinessCodeID = null;
		entity.selectedBusinessCode = null;
		entity.isNewBusinessCode = false;

		$scope.entityMappingsPending = $scope.entityMappingsPending.filter(function (e) {
			return e.RotareadyEntityID !== entity.RotareadyEntityID;
		});

		if (isCreatedCode) {
			const isCodeUsedByOtherEntity = $scope.entityMappingsPending.some(function (e) {
				return e.BusinessCodeID === businessCodeID;
			});

			if (!isCodeUsedByOtherEntity) {
				$scope.newBusinessCodes = $scope.newBusinessCodes.filter(function (code) {
					return code.BusinessCodeID !== businessCodeID;
				});

				$scope.businessCodes = $scope.businessCodes.filter(function (code) {
					return code.BusinessCodeID !== businessCodeID;
				});
			}
		}

		const unmappedAll = $scope.entitiesUnmapped.all.slice();
		unmappedAll.push(entity);
		$scope.entitiesUnmapped = bulkService.getBulkItemsObj(unmappedAll);

		filterBusinessCodes();

		if ($scope.entityMappingsPending.length === 0) {
			$scope.activeTab = TABS.AVAILABLE;
		}
	}

	function unmapAllPendingEntities () {

		const unmappedAll = $scope.entitiesUnmapped.all.slice();
		const mappedEntities = $scope.entityMappingsPending;
		const newBusinessCodes = $scope.newBusinessCodes;

		mappedEntities.forEach(function (entity) {
			unmappedAll.push(entity);
			entity.BusinessCodeID = null;
			entity.businessCodeNarrative = null;
			entity.businessCodeValue = null;
			entity.businessCategoryTypeDescription = null;
			entity.selectedBusinessCodeID = null;
			entity.selectedBusinessCode = null;
			entity.isNewBusinessCode = false;
		});

		newBusinessCodes.forEach(function (businessCode) {
			$scope.businessCodes = $scope.businessCodes.filter(function (code) {
				return code.BusinessCodeID !== businessCode.BusinessCodeID;
			});
		});

		$scope.newBusinessCodes = [];
		$scope.entityMappingsPending = [];
		$scope.entitiesUnmapped = bulkService.getBulkItemsObj(unmappedAll);

		filterBusinessCodes();

		$scope.activeTab = TABS.AVAILABLE;
	}

	function createBusinessCode (entity) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			businessCategories: $scope.businessCategories,
			selectedCategoryID: getFilteredBusinessCategory(),
			businessCodes: $scope.businessCodes,
			callback: function (newCode) {
				onBusinessCodeCreated(entity, newCode);
			},
			formKey: 'company-settings-rotaready-entity-create-business-code',
			title: 'Create business category'
		});
	}

	function onBusinessCodeCreated (entity, newCode) {

		const businessCodeId = utilities.guid();

		const newBusinessCode = {
			BusinessCodeID: businessCodeId,
			BusinessCategoryID: newCode.BusinessCategoryID,
			BusinessCodeNarrative: newCode.BusinessCodeNarrative,
			isNewBusinessCode: true
		};

		$scope.newBusinessCodes.push(newBusinessCode);

		const category = getCategoryById(newCode.BusinessCategoryID);

		const businessCodeForDropdown = {
			BusinessCodeID: businessCodeId,
			BusinessCodeNarrative: newCode.BusinessCodeNarrative,
			BusinessCategoryID: newCode.BusinessCategoryID,
			BusinessCategoryName: category ? category.BusinessCategoryName : '',
			BusinessCategoryType: category ? category.BusinessCategoryType : 0,
			isNewBusinessCode: true
		};

		businessCodeForDropdown.businessCategoryTypeDescription = category ? getCategoryTypeDescription(category.BusinessCategoryType, businessCodeForDropdown) : '';

		$scope.businessCodes.push(businessCodeForDropdown);

		entity.BusinessCodeID = businessCodeId;
		entity.businessCodeNarrative = newCode.BusinessCodeNarrative;
		entity.businessCategoryTypeDescription = businessCodeForDropdown.businessCategoryTypeDescription;
		entity.selectedBusinessCodeID = null;
		entity.isNewBusinessCode = true;

		$scope.entityMappingsPending.push(entity);

		const unmappedAll = $scope.entitiesUnmapped.all.filter(function (e) {
			return e.RotareadyEntityID !== entity.RotareadyEntityID;
		});
		$scope.entitiesUnmapped = bulkService.getBulkItemsObj(unmappedAll);

		filterBusinessCodes();

		if (unmappedAll.length === 0 && $scope.entityMappingsPending.length > 0) {
			$scope.activeTab = TABS.PENDING;
		}
	}

	function createAllBusinessCodes () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			businessCategories: $scope.businessCategories,
			selectedCategoryID: getFilteredBusinessCategory(),
			callback: function (options) {
				onAllBusinessCodesCreated(options);
			},
			formKey: 'company-settings-rotaready-entity-create-all-business-codes',
			title: 'Create all business categories',
			unmappedCount: $scope.entitiesUnmapped.all.length
		});
	}

	function onAllBusinessCodesCreated (options) {

		const category = getCategoryById(options.BusinessCategoryID);
		const unmappedEntities = $scope.entitiesUnmapped.all.slice();

		unmappedEntities.forEach(function (entity) {

			const codeName = generateBusinessCodeName(entity, options);
			const existingBusinessCode = getBusinessCodeByNarrative(category.BusinessCategoryID, codeName);

			if (existingBusinessCode) {
				entity.BusinessCodeID = existingBusinessCode.BusinessCodeID;
				entity.businessCodeNarrative = codeName;
				entity.businessCategoryTypeDescription = category ? getCategoryTypeDescription(category.BusinessCategoryType, { BusinessCategoryName: category.BusinessCategoryName }) : '';
				entity.selectedBusinessCodeID = null;
				entity.isNewBusinessCode = existingBusinessCode.isNewBusinessCode;

				$scope.entityMappingsPending.push(entity);
				return;
			}

			const businessCodeId = utilities.guid();

			const newBusinessCode = {
				BusinessCodeID: businessCodeId,
				BusinessCategoryID: options.BusinessCategoryID,
				BusinessCodeNarrative: codeName,
				isNewBusinessCode: true
			};

			$scope.newBusinessCodes.push(newBusinessCode);

			const businessCodeForDropdown = {
				BusinessCodeID: businessCodeId,
				BusinessCodeNarrative: codeName,
				BusinessCategoryID: options.BusinessCategoryID,
				BusinessCategoryName: category ? category.BusinessCategoryName : '',
				BusinessCategoryType: category ? category.BusinessCategoryType : 0,
				isNewBusinessCode: true
			};

			businessCodeForDropdown.businessCategoryTypeDescription = category ? getCategoryTypeDescription(category.BusinessCategoryType, businessCodeForDropdown) : '';

			$scope.businessCodes.push(businessCodeForDropdown);

			entity.BusinessCodeID = businessCodeId;
			entity.businessCodeNarrative = codeName;
			entity.businessCategoryTypeDescription = businessCodeForDropdown.businessCategoryTypeDescription;
			entity.selectedBusinessCodeID = null;
			entity.isNewBusinessCode = true;

			$scope.entityMappingsPending.push(entity);
		});

		$scope.entitiesUnmapped = bulkService.getBulkItemsObj([]);

		filterBusinessCodes();

		$scope.activeTab = TABS.PENDING;
	}

	function generateBusinessCodeName (entity, options) {

		const strategy = options.namingStrategy;
		const usesPrefix = strategy === NAMING_STRATEGIES.PREFIX ||
			strategy === NAMING_STRATEGIES.PREFIX_AND_CALENDAR;
		const usesCalendar = strategy === NAMING_STRATEGIES.ENTITY_NAME_AND_CALENDAR ||
			strategy === NAMING_STRATEGIES.PREFIX_AND_CALENDAR;

		let name = entity.EntityNameRaw || entity.EntityName;

		if (usesPrefix && options.prefix) {
			name = options.prefix + ' ' + name;
		}

		if (usesCalendar && entity.PayrollCalendarName) {
			name = name + ' (' + entity.PayrollCalendarName + ')';
		}

		return name;
	}

	function getCategoryById (businessCategoryId) {

		if (!businessCategoryId || businessCategoryId === '' || !$scope.businessCategories) {
			return null;
		}

		return $scope.businessCategories.find(function (category) {
			return category.BusinessCategoryID === businessCategoryId;
		});
	}

	function getBusinessCodeById (businessCodeId) {

		if (!businessCodeId || !$scope.businessCodes) {
			return null;
		}

		return $scope.businessCodes.find(function (code) {
			return code.BusinessCodeID === businessCodeId;
		});
	}

	function getBusinessCodeByNarrative (businessCategoryId, businessCodeNarrative) {

		if (!businessCategoryId || !businessCodeNarrative || !$scope.businessCodes) {
			return null;
		}

		return $scope.businessCodes.find(function (code) {
			return code.BusinessCategoryID === businessCategoryId && code.BusinessCodeNarrative === businessCodeNarrative;
		});
	}

	function getNewBusinessCodesForSave () {

		return $scope.newBusinessCodes.filter(function (newCode) {
			return $scope.entityMappingsPending.some(function (entity) {
				return entity.BusinessCodeID === newCode.BusinessCodeID;
			});
		});
	}

	function onSaveMappings () {

		const newBusinessCodesForSave = getNewBusinessCodesForSave();

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: loadEntityBusinessCodeMapping,
			formKey: 'company-settings-rotaready-entity-save',
			entityMappingsPending: $scope.entityMappingsPending,
			newBusinessCodes: newBusinessCodesForSave,
			title: 'Save site/department mappings'
		});
	}

	function goToEntityMatched () {

		$state.go('rotaready-connection.entity-matched', { agencyProfileId: agencyProfileId });
	}

	function cancel () {

		$state.go('rotaready-connection.summary', { agencyProfileId: agencyProfileId });
	}

	function onError () {

		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setActiveTab (tab) {

		$scope.activeTab = tab;
	}

	function filterByBusinessCategoryID(collection, businessCategoryID) {

		if (!businessCategoryID) {
			return collection;
		}

		return collection.filter(function (c) {
			return c.BusinessCategoryID === businessCategoryID;
		});
	}

	function filterBusinessCodes () {

		const entitiesUnmapped = $scope.entitiesUnmapped.all.slice();
		const businessCategoryID = getFilteredBusinessCategory();
	
		entitiesUnmapped.forEach(function (entity) {
			entity.possibleMatchesFiltered = filterByBusinessCategoryID(entity.possibleMatches, businessCategoryID);
		});

		$scope.businessCodes = $scope.businessCodes.sort((a, b) => a.BusinessCodeNarrative.localeCompare(b.BusinessCodeNarrative) || a.businessCategoryTypeDescription.localeCompare(b.businessCategoryTypeDescription));
		$scope.businessCodesFiltered = filterByBusinessCategoryID($scope.businessCodes, businessCategoryID);
	}

	function getFilteredBusinessCategory () {

		const businessCategoryID = utilities.getFromStorage(businessCategoryFilterStorageKey);

		if (!businessCategoryID || businessCategoryID === null || businessCategoryID === '') {
			return null;
		}

		return businessCategoryID;
	}

	init();

	angular.extend($scope, {
		cancel: cancel,
		createAllBusinessCodes: createAllBusinessCodes,
		createBusinessCode: createBusinessCode,
		filterByBusinessCategoryID: filterByBusinessCategoryID,
		filterBusinessCodes: filterBusinessCodes,
		getCategoryTypeDescription: getCategoryTypeDescription,
		goToEntityMatched: goToEntityMatched,
		mapEntity: mapEntity,
		mapEntityDeselect: mapEntityDeselect,
		mapEntityFromSuggestion: mapEntityFromSuggestion,
		mapEntitySelect: mapEntitySelect,
		onSaveMappings: onSaveMappings,
		setActiveTab: setActiveTab,
		unmapAllPendingEntities: unmapAllPendingEntities,
		unmapPendingEntity: unmapPendingEntity,

		TABS: TABS
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsAccessCtrl', ['$scope', 'tabService', 'TAB_KEYS', function($scope, tabService, TAB_KEYS) {

	function init () {
		$scope.settingsAccessTabBarDef = tabService.getTabsForKey(TAB_KEYS.settings.access.id);
	}

	init();
}]);
'use strict';

angular.module('paycircleApp')

.controller('settingsAccessAuthenticationCtrl', ['$rootScope', '$scope', '$stateParams', '$filter', 'agency', 'dateService', 'TFA_STATES',
	function ($rootScope, $scope, $stateParams, $filter, agency, dateService, TFA_STATES) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function decorateCompanyAuthentication (companyAuthenticationObj) {
		companyAuthenticationObj.tfaIsEnabled = (companyAuthenticationObj.TwoFAState !== TFA_STATES.off);
	}

	function getSessionTimeoutBlock (companyAuthenticationObj) {

		return {
			icon: 'clock',
			title: 'Session timeout',
			detailGroups: [
				{
					details: [
						{
							label: 'Session duration',
							value: $filter('duration')(companyAuthenticationObj.SessionTimeout, true)
						},
						{
							label: 'Warning countdown',
							value: $filter('duration')(companyAuthenticationObj.SessionTimeoutWarning, true)
						}
					],
					editAction: openSessionAuthenticationForm,
					id: 'authentication-session'
				}
			]
		};
	}

	function getSSOBlock (companyAuthenticationObj) {

		return {
			icon: 'login',
			title: 'Single sign-on',
			detailGroups: [
				{
					details: [
						{
							label: 'Single sign-on',
							type: 'switch',
							value: companyAuthenticationObj.OIDCEnabled
						}
					],
					editAction: openSSOForm,
					id: 'authentication-sso'
				}
			]
		};
	}

	function getTwoFactorAuthenticationDetails (companyAuthenticationObj) {

		if (companyAuthenticationObj.IsIdentityEnabled) {
			companyAuthenticationObj.tfaIsEnabled = false;
			companyAuthenticationObj.TwoFAState = TFA_STATES.off;
			companyAuthenticationObj.TwoFAUpdatedDateISO = '';
		}

		const tfaDetailObj = {
			icon: 'mobile',
			title: 'Two Factor Authentication',
			detailGroups: [
				{
					details: [
						{
							label: 'Two Factor Authentication',
							type: 'switch',
							value: companyAuthenticationObj.tfaIsEnabled
						}
					],
					editAction: openTwoFactorAuthenticationForm,
					id: 'authentication-tfa'
				}
			]
		};

		if (companyAuthenticationObj.tfaIsEnabled) {

			if (companyAuthenticationObj.TwoFAState === TFA_STATES.timePeriod) {

				tfaDetailObj.detailGroups[0].details.push(
					{
						label: 'Re-authentication period',
						value: $filter('duration')(companyAuthenticationObj.TwoFATimePeriod, true)
					}
				);

			} else {

				tfaDetailObj.detailGroups[0].details.push(
					{
						label: 'Re-authentication period',
						value: 'Every sign in'
					}
				);
			}
		}

		if (companyAuthenticationObj.TwoFAUpdatedDateISO !== '') {
			tfaDetailObj.detailGroups[0].details.push(
				{
					label: 'Updated',
					type: 'date',
					value: companyAuthenticationObj.TwoFAUpdatedDateISO
				}
			);
		}

		return tfaDetailObj;
	}

	function init () {

		setPageState('loading');

		agency.getCompanyAuthenticationDetails(agencyProfileId).then(companyAuthenticationObj => {

			decorateCompanyAuthentication(companyAuthenticationObj);

			$scope.vm = {
				companyAuthentication: companyAuthenticationObj,
				twoFactorAuthentication: getTwoFactorAuthenticationDetails(companyAuthenticationObj),
				sessionTimeoutBlock: getSessionTimeoutBlock(companyAuthenticationObj),
				ssoBlock: getSSOBlock(companyAuthenticationObj)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openSessionAuthenticationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-authentication-session',
		});
	}

	function openSSOForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-authentication-sso',
			title: 'Single sign-on'
		});
	}

	function openTwoFactorAuthenticationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-authentication-tfa',
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsAccessIPManagementCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'bulkService', 'searchService', 'securityData', 'teamData', 'utilities',
	function ($q, $rootScope, $scope, $stateParams, bulkService, searchService, securityData, teamData, utilities) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		const getIPAddresses = securityData.getIPAddresses(agencyProfileId);
		const getTeamMemberAdmins = teamData.getTeamMemberAdmins(agencyProfileId);

		$q.all([getIPAddresses, getTeamMemberAdmins]).then(([ipAddresses, teamMemberAdmins]) => {

			angular.extend($scope.vm, {
				ipAddresses: ipAddresses.sort(utilities.comparator('Description')),
				teamMemberAdmins: bulkService.getBulkItemsObj(teamMemberAdmins)
			});

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function openAddOfficeLocationsForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: vmObj.agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-add-office-locations',
			title: 'Add office locations'
		});
	}

	function openEditRemoteLocationsForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: vmObj.agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-edit-remote-locations',
			title: 'Edit remote locations'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		vm: {
			// Variables
			agencyProfileId,
			searchBarOptions: searchService.remoteLocations,

			// Functions
			openAddOfficeLocationsForm,
			openEditRemoteLocationsForm,
			refresh: init
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsAdminsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'agency',
	'bulkService',
	'dataTransfer',
	'filterService',
	'permissionsService',
	'reportData',
	'searchService',
	'securityData',
	'session',
	'INTERFACE_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		agency,
		bulkService,
		dataTransfer,
		filterService,
		permissionsService,
		reportData,
		searchService,
		securityData,
		session,
		INTERFACE_TYPES
	) {

	var agencyProfileId = $stateParams.agencyProfileId;
	var currentCompany = $scope.currentCompany;
	var loggedInUserId = session.getUserId();

	function adminFilter (admin) {

		admin.isLoggedInUser = admin.UserID === loggedInUserId;
		admin.fullName = `${admin.Forename} ${admin.Surname}`;

		return admin;
	}

	function downloadPermissionsReport (vmObj) {

		vmObj.permissionReportDownloadState = 'loading';

		reportData.createPermissionsReportDownload(vmObj.agencyProfileId).then(permissionReportUrl => {

			dataTransfer.downloadFile(permissionReportUrl, 'PermissionsReport.xlsx');

			vmObj.permissionReportDownloadState = null;
		})
		.catch(error => {
		    console.error(error);
		});
	}

	function init () {

		setPageState('loading');

		const getTeamMemberAdminAccounts = securityData.getTeamMemberAdminAccounts(agencyProfileId);
		const getCompanyAuthenticationDetails = agency.getCompanyAuthenticationDetails(agencyProfileId);

		$q.all([getTeamMemberAdminAccounts, getCompanyAuthenticationDetails]).then(([adminsArray, companyAuthenticationObj]) => {

			$scope.vm = {
				admins: bulkService.getBulkItemsObj(adminsArray.filter(adminFilter)),
				canEditAdmin: permissionsService.getCanEditAdminPermissionForCompany(currentCompany.CompanyType),
				agencyProfileId: agencyProfileId,
				permissionReportDownloadState: null,
				ssoEnabled: companyAuthenticationObj.OIDCEnabled
			};

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function openNewAdminForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: vmObj.agencyProfileId,
			callback: init,
			formKey: 'new-admin'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		INTERFACE_TYPES,

		filterBarOptions: filterService.getFilterBarOptionsAdmins(currentCompany),
		searchBarOptions: searchService.admins,

		openNewAdminForm,
		downloadPermissionsReport,
		refreshAdmins: init
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsAverageHolidayPayCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'adjustmentsService',
	'bulkService',
	'filterService',
	'payrollData',
	'reportData',
	'searchService',
	'AVERAGE_HOLIDAY_PAY_RATE_TYPES',
	'GROUP_ENTRY_CATEGORIES',
	'INTERFACE_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		adjustmentsService,
		bulkService,
		filterService,
		payrollData,
		reportData,
		searchService,
		AVERAGE_HOLIDAY_PAY_RATE_TYPES,
		GROUP_ENTRY_CATEGORIES,
		INTERFACE_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const isBureau = $rootScope.currentCompany.CompanyType === INTERFACE_TYPES.bureau;

	// Bureau users get a flat array of the bureau's own raw group entries (GetBureauAgencyAdjustmentGroupEntries,
	// so push-down always targets the bureau's real entry ids rather than a merged/resolved view). Companies get
	// the normal nested pack hierarchy, which we flatten to the same leaf-entry shape below.
	//
	// An untouched element resolves to an entry with AgencyAdjustmentGroupEntryID = empty guid (it means
	// "inherits the parent pack's entry", not "no id") - several different elements can be in this untouched
	// state at once, so using the raw id as a unique/settings key would collide. adjustmentsService's existing
	// getAgencyAdjustmentGroupEntryId() idiom (id, or its parent's id when empty) resolves each to the entry it
	// actually inherits from, which is also the id a setting must be written against for it to apply.
	function getAdjustmentGroupEntries () {

		if (isBureau) {
			return reportData.getBureauAgencyAdjustmentGroupEntries(agencyProfileId);
		}

		return payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId).then(adjustmentGroupObj =>
			adjustmentsService.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntries)
				.map(adjustmentTypeObj => angular.extend({}, adjustmentTypeObj, {
					AgencyAdjustmentGroupEntryID: adjustmentsService.getAgencyAdjustmentGroupEntryId(adjustmentTypeObj)
				})));
	}

	function init () {

		setPageState('loading');

		$q.all([
			getAdjustmentGroupEntries(),
			reportData.getPayElementReportSettings(agencyProfileId)
		]).then(([adjustmentGroupEntriesArr, settingsArr]) => {

			$scope.vm = {
				payElements: bulkService.getBulkItemsObj(buildPayElements(adjustmentGroupEntriesArr, settingsArr))
			};

			setPageState('ready');

		}).catch(onError);
	}

	// Flattens the grouped pay element hierarchy into a single list, overlaying each element with its
	// resolved report setting: a setting defined at this profile supersedes an inherited bureau setting,
	// and elements with no setting fall back to defaults (Other rate type, not included).
	function buildPayElements (adjustmentGroupEntriesArr, settingsArr) {

		const ownSettingsByKey = {};
		const inheritedSettingsByKey = {};

		settingsArr.forEach(settingObj => {
			const targetObj = settingObj.AgencyProfileID === agencyProfileId ? ownSettingsByKey : inheritedSettingsByKey;
			targetObj[settingObj.AgencyAdjustmentGroupEntryID] = settingObj;
		});

		const payElementsArr = [];

		adjustmentGroupEntriesArr.forEach(adjustmentGroupEntry => {


				// System elements are internal, not user-facing pay elements.
				if (adjustmentGroupEntry.Category === GROUP_ENTRY_CATEGORIES.calculated.key) {
					return;
				}
				
				const elementName = (adjustmentGroupEntry.AgencyAdjustmentGroupEntryText || '').trim();

				// A setting defined at this profile always supersedes an inherited bureau setting -
				// this precedence is what makes push-down and defaults work, independent of whether
				// the resolved value is shown as the profile's "own" or "inherited" on screen.
				const resolvedSettingObj = ownSettingsByKey[adjustmentGroupEntry.AgencyAdjustmentGroupEntryID] || inheritedSettingsByKey[adjustmentGroupEntry.AgencyAdjustmentGroupEntryID];

				payElementsArr.push({
					AgencyAdjustmentGroupEntryID: adjustmentGroupEntry.AgencyAdjustmentGroupEntryID,
					ElementName: elementName,
					Name: elementName,
					Category: adjustmentGroupEntry.Category,
					RateType: resolvedSettingObj ? resolvedSettingObj.RateType : AVERAGE_HOLIDAY_PAY_RATE_TYPES.other,
					IncludeIn52WeekAverage: resolvedSettingObj ? resolvedSettingObj.IncludeIn52WeekAverage : false,
					isSelected: false
				});
		});

		return payElementsArr;
	}

	function manageOptions () {

		const selectedPayElements = $scope.vm.payElements.all.filter(payElement => payElement.isSelected);

		if (!selectedPayElements.length) {
			return;
		}

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'average-holiday-pay-options',
			selectedPayElements,
			title: 'Manage options'
		});
	}

	function onCheckboxToggle () {

		bulkService.updateBulkItemTotals($scope.vm.payElements);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		filterBarOptions: filterService.getFilterBarOptionsAverageHolidayPay(),
		manageOptions,
		onCheckboxToggle,
		rateTypes: AVERAGE_HOLIDAY_PAY_RATE_TYPES,
		refresh: init,
		searchBarOptions: searchService.averageHolidayPay
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsBacsDownloadsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'agency',
	'bulkService',
	'dataTransfer',
	'filterService',
	'reportData',
	'searchService',
	'tabService',
	'DOCUMENT_STATES',
	'TAB_KEYS',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		agency,
		bulkService,
		dataTransfer,
		filterService,
		reportData,
		searchService,
		tabService,
		DOCUMENT_STATES,
		TAB_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function createBACSDownloadFile (bacsFilesArr, isBulkDownload) {

		if (isBulkDownload) {
			bacsFilesArr = bulkService.getSelectedItems(bacsFilesArr);
		}

		setBacsFileLoadingState(bacsFilesArr, true);

		let agencyDocumentIds = bulkService.getValuesFromArray(bacsFilesArr, 'AgencyDocumentID');

		reportData.createBACSDownloadFile(agencyProfileId, agencyDocumentIds).then(downloadUrl => {

			const fallbackFileName = `BureauBulkBACS_${moment().format('YYYY-MM-DD_HHmmss')}.zip`;
			dataTransfer.downloadFile(downloadUrl, fallbackFileName);
			setBacsFileLoadingState(bacsFilesArr, false);
		})
		.catch(onError);
	}

	function decorateBacsFile (bacsFileObj) {

		bacsFileObj.documentStateDescription = getDocumentStateDescription(bacsFileObj.State);

		return bacsFileObj;
	}

	function getDocumentStateDescription (documentState) {

		switch (documentState) {
			case DOCUMENT_STATES.processed:
				return 'Processed';
			case DOCUMENT_STATES.pending:
				return 'Pending';
			default:
				return 'Available';
		}
	}

	function init () {

		setPageState('loading');

		const getBACSDownloads = reportData.getBACSDownloads(agencyProfileId);
		const getAgencyEmployerBUN = agency.getAgencyEmployerBUN(agencyProfileId);

		$q.all([getBACSDownloads, getAgencyEmployerBUN])
			.then(([bacsDownloadsArr, agencyEmployerBun]) => {

				$scope.vm = {
					agencyEmployerBun: agencyEmployerBun,
					bacsDownloads: bulkService.getBulkItemsObj(bacsDownloadsArr.filter(decorateBacsFile)),
					bacsDownloadsTabBarDef: tabService.getTabsForKey(TAB_KEYS.settings.bacsDownloads.id),
					filterBarOptions: filterService.bacsDownloads,
					searchBarOptions: searchService.bacsDownloads
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onTabSelected (tabId) {

		let documentState;

		switch (tabId) {
			case TAB_KEYS.settings.bacsDownloads.tabs.pending:
				documentState = DOCUMENT_STATES.pending;
				break;
			case TAB_KEYS.settings.bacsDownloads.tabs.processed:
				documentState = DOCUMENT_STATES.processed;
				break;
			default:
				documentState = DOCUMENT_STATES.available;
		}
		setActiveState($scope.vm, documentState);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openEditBureauBunForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'edit-bureau-bun'
		});
	}

	function setBacsFileLoadingState (bacsFilesArr, newLoadingState) {
		for (let bacsFileObj of bacsFilesArr) {
			bacsFileObj.isLoading = newLoadingState;
		}
	}

	function setActiveState (vmObj, newDocumentState) {

		$scope.activeState = newDocumentState;

		// Reset multi-select checkbox
		for (let bacsFileObj of vmObj.bacsDownloads.all) {
			bacsFileObj.isSelected = false;
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateBacsDocumentState (bacsFilesArr, documentState, isBulkUpdate) {

		if (isBulkUpdate) {
			bacsFilesArr = bulkService.getSelectedItems(bacsFilesArr);
		}

		setBacsFileLoadingState(bacsFilesArr, true);

		reportData.updateBACSDownloadStates(agencyProfileId, bacsFilesArr, documentState)
			.then(init)
			.catch(onError);
	}

	init();

	angular.extend($scope, {
		activeState: DOCUMENT_STATES.available,

		DOCUMENT_STATES,

		createBACSDownloadFile,
		openEditBureauBunForm,
		onTabSelected,
		updateBacsDocumentState,
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsBillingCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'companyData',
	'dataTransfer',
	'filterService',
	'growl',
	'payrollData',
	'searchService',
	'MANDATE_STATES',
	'PAYMENT_STATES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		companyData,
		dataTransfer,
		filterService,
		growl,
		payrollData,
		searchService,
		MANDATE_STATES,
		PAYMENT_STATES
	) {

	const PLAN_RENEWAL_DATE = '1st Jan 2020';
	const MANDATE_POLL_LENGTH = 60; // Seconds
	const MANDATE_POLL_LENGTH_SUBMISSION = 4; // Seconds

	var agencyProfileId = $stateParams.agencyProfileId;
	var mandatePoll;

	function decorateCompany (companyObj) {

		companyObj.numberOfModules = 1; // User portal

		companyObj.numberOfModules = companyObj.Employer.IsCISActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;
		companyObj.numberOfModules = companyObj.Employer.IsPayrollActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;
		companyObj.numberOfModules = companyObj.Employer.IsPensionActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;

		return companyObj;
	}

	function init () {

		setPageState('loading');

		var getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);
		var getCompanyDirectDebitMandate = payrollData.getCompanyDirectDebitMandate(agencyProfileId);
		var getNextBillingPayment = payrollData.getNextBillingPayment(agencyProfileId);

		$q.all([getAgencyProfileCompanyInformationDetailed, getCompanyDirectDebitMandate, getNextBillingPayment]).then(function (data) {

			var companyObj = data[0];
			var directDebitMandateObj = data[1];
			var nextPaymentObj = data[2];

			$scope.company = decorateCompany(companyObj);
			$scope.directDebitMandate = directDebitMandateObj;
			$scope.nextPayment = nextPaymentObj;

			$timeout(function () {
				reviewMandateState(directDebitMandateObj);
			}, 2000);
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function loadPayments () {

		payrollData.getBillingPayments(agencyProfileId).then(function (paymentsArray) {

			$scope.payments = paymentsArray;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function refreshMandate () {

		payrollData.getCompanyDirectDebitMandate(agencyProfileId).then(function (directDebitMandateObj) {

			$scope.directDebitMandate = directDebitMandateObj;

			reviewMandateState(directDebitMandateObj);
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function reviewMandateState (directDebitMandateObj) {

		switch (directDebitMandateObj.MandateDetails.MandateState) {
			case MANDATE_STATES.pendingSubmission:
				mandatePoll = $timeout(refreshMandate, MANDATE_POLL_LENGTH_SUBMISSION * 1000);
				setPageState('ready');
				break;

			case MANDATE_STATES.pendingCustomerApproval:
			case MANDATE_STATES.submitted:
				mandatePoll = $timeout(refreshMandate, MANDATE_POLL_LENGTH * 1000);
				setPageState('ready');
				break;

			case MANDATE_STATES.active:
				loadPayments();
				break;

			default:
				setPageState('ready');
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.agencyProfileId = agencyProfileId;
	$scope.payments = [];
	$scope.filterBarOptions = filterService.billing;
	$scope.searchBarOptions = searchService.billing;

	$scope.MANDATE_STATES = MANDATE_STATES;
	$scope.PAYMENT_STATES = PAYMENT_STATES;
	$scope.PLAN_RENEWAL_DATE = PLAN_RENEWAL_DATE;

	$scope.downloadFile = dataTransfer.downloadFile;

	$scope.incrementMandateState = function (mandateObj) {

		mandateObj.MandateDetails.MandateState = mandateObj.MandateDetails.MandateState === 8 ? 0 : mandateObj.MandateDetails.MandateState + 1;
	};

	$scope.incrementPaymentState = function (paymentObj, paymentsArray) {

		paymentObj.PaymentStatus = paymentObj.PaymentStatus === 10 ? 0 : paymentObj.PaymentStatus + 1;

		if (paymentsArray.length) {
			paymentsArray[0].PaymentStatus = paymentObj.PaymentStatus;
		}
	};

	$scope.openCompanyBankDetailsForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-bank-details'
		});
	};

	$scope.openCompanyBillingDetailsForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-billing-details'
		});
	};

	$scope.openCompanyBillingNameForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-billing-name'
		});
	};

	$scope.openDirectDebitForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'direct-debit'
		});
	};

	$scope.setupPayment = function () {

		/*
		updateCompanyDirectDebitMandateBank: function (agencyProfileId, updatedBankDetails)
		updateCompanyGoCardlessDetails: function (agencyProfileId, updatedDirectDebitMandate)
		*/

	};

	$scope.$on('$detroy', function () {
		$timeout.cancel(mandatePoll);
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('bureauPayrollSettingsCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	function (
		$rootScope,
		$scope,
		$stateParams,
		companyData
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		companyData.getP60NotificationSettings(agencyProfileId).then((p60NotificationSettingsObj)=> {
			populateDetails(p60NotificationSettingsObj);
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function populateDetails (p60NotificationSettingsObj) {

		$scope.basicDetails = {
			icon: 'pay-periods',
			title: 'Payroll settings',
			detailGroups: [
				{
					editAction: openP60NotificationsForm,
					details: [
						{
							label: 'Send next P60 notifications',
							value: p60NotificationSettingsObj.SendNextP60NotificationsText,
							upperFirstLetter: true
						}
					]
				}
			]
		};

		setPageState('ready');
	}

	function openP60NotificationsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-p60-notifications'
		});
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsBusinessCategoriesCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$stateParams',
	'filterService',
	'reportData',
	'searchService',
	'tabService',
	'utilities',
	'BUSINESS_CODE_FORM_STATES',
	'DOCUMENT_TYPES',
	'TAB_KEYS',
	function (
		$filter,
		$rootScope,
		$scope,
		$stateParams,
		filterService,
		reportData,
		searchService,
		tabService,
		utilities,
		BUSINESS_CODE_FORM_STATES,
		DOCUMENT_TYPES,
		TAB_KEYS
	) {

	const GET_UNALLOCATED_CODE = true;
	const agencyProfileId = $stateParams.agencyProfileId;

	function getBusinessCategoryObjByNumber (businessCategoriesArr, businessCategoryNumber) {

		const businessCategoryObj = businessCategoriesArr.find(_ => {
			return _.BusinessCategoryNumber === businessCategoryNumber;
		});

		return businessCategoryObj;
	}

	function init () {

		setPageState('loading');

		reportData.getBusinessCategoryListForAgency(agencyProfileId, GET_UNALLOCATED_CODE).then(businessCategoriesArr => {

			const TABS = tabService.getTabsForKey(TAB_KEYS.settings.businessCategories.id, {businessCategories: businessCategoriesArr});

			$scope.vm = {
				DOCUMENT_TYPES,
				agencyProfileId,
				businessCategories: businessCategoriesArr,
				businessCategoriesTabBarDef: TABS,
				openBusinessCodeForm,
				refresh,
				refreshDepartments,
				searchBarOptions: searchService.businessCategories,
				setActiveBusinessCategory,
				setActiveBusinessCategoryById
			};

			setActiveBusinessCategory($scope.vm, businessCategoriesArr[0]);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openBusinessCodeForm (businessCategoryObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			businessCategory: businessCategoryObj,
			callback: refreshDepartments,
			formKey: 'business-code',
			formState: BUSINESS_CODE_FORM_STATES.create,
			title: `Add ${businessCategoryObj.businessCategoryNameLower}`
		});
	}

	function refresh () {

		init();
	}

	function refreshDepartments () {

		reportData.getBusinessCategoryListForAgency(agencyProfileId, GET_UNALLOCATED_CODE).then(businessCategoriesArr => {

			angular.extend($scope.vm, {
				businessCategories: businessCategoriesArr
			});

			setActiveBusinessCategory($scope.vm, getBusinessCategoryObjByNumber(businessCategoriesArr, $scope.vm.activeBusinessCategory.BusinessCategoryNumber));
		})
		.catch(onError);
	}

	function setActiveBusinessCategory (vmObj, businessCategoryObj) {

		angular.extend(businessCategoryObj, {
			businessCategoryNameLower: $filter('lowercase')(businessCategoryObj.BusinessCategoryName)
		});

		angular.extend(vmObj, {
			activeBusinessCategory: businessCategoryObj
		});
	}

	function setActiveBusinessCategoryById (vmObj, businessCategoryId) {

		const activeBusinessCategoryObj = utilities.getArrayItemByPropertyName(vmObj.businessCategories, 'BusinessCategoryID', businessCategoryId);

		setActiveBusinessCategory(vmObj, activeBusinessCategoryObj);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsBusinessCategoriesCategoryCtrl', [
	'$scope',
	'$state',
	'$stateParams',
	function (
		$scope,
		$state,
		$stateParams
	) {

	const businessCategoryId = $stateParams.categoryId;

	function init () {

		if (angular.isUndefined(businessCategoryId)) {
			$state.go('settings.company.business-categories.category', {'categoryId': $scope.vm.businessCategories[0].BusinessCategoryID});
			return;
		}

		$scope.vm.setActiveBusinessCategoryById($scope.vm, businessCategoryId);
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsBusinessCategoriesImportsCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'dataImport',
	'filterService',
	'importService',
	'payrollData',
	'searchService',
	'DOCUMENT_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		dataImport,
		filterService,
		importService,
		payrollData,
		searchService,
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function getUserImportGroupsBusinessCategoriesService () {

		const INCLUDE_DELETED = true;
		const TEAM_IMPORTS = false;
		const PERIOD_IMPORTS = false;

		let PAY_PERIOD_ID; // Undefined as not period specific

		return dataImport.getUserImportGroups(agencyProfileId, PAY_PERIOD_ID, INCLUDE_DELETED, TEAM_IMPORTS, PERIOD_IMPORTS, IMPORT_MAPPING_TYPES.businessCategories);	
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodMinimum(agencyProfileId).then(currentPayPeriodObj => {

			getUserImportGroupsBusinessCategoriesService().then(userImportGroupsBusinessCategoriesArr => {

				angular.extend($scope.vm, {
					DOCUMENT_TYPES,
					agencyProfileId,
					filterBarOptionsImports: filterService.getFilterBarOptionsJournalImports(),
					importHistoryItems: userImportGroupsBusinessCategoriesArr.filter(importService.decorateImportGroup),
					importHistoryItemsFiltered: [],
					payPeriod: currentPayPeriodObj,
					searchBarOptionsImports: searchService.journalImports
				});

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsCurrenciesCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
function (
	$rootScope,
	$scope,
	$stateParams,
	companyData
) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		companyData.getCurrencies(agencyProfileId)
			.then(currenciesArr => {

				$scope.vm = {
					currencies: currenciesArr,
					exchangeRates: setupExchangeRatesDetailBlock(currenciesArr)
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openCompanySettingsCurrenciesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-currencies',
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setupExchangeRatesDetailBlock (currenciesArr) {

		const currenciesGroupArr = [];
		const exchangeRatesDetailObj = {
			icon: 'toggle-on',
			groupId: 'exchange-rates',
			title: 'Exchange rates',
			detailGroups: [
				{
					editAction: openCompanySettingsCurrenciesForm,
					details: currenciesGroupArr
				}
			]
		};

		if (currenciesArr.length > 0) {
			for (let currencyObj of currenciesArr) {
				currenciesGroupArr.push({
					label: currencyObj.CurrencyLabel,
					value: currencyObj.CurrencyValue
				});
			}
		} else {
			exchangeRatesDetailObj.feedback = 'Click ‘Edit’ to start adding currencies.';
		}

		return exchangeRatesDetailObj;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsCustomerCodesCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'bulkService',
	'companyData',
	'filterService',
	'searchService',
	'SEARCH_BAR_ACTIONS',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		bulkService,
		companyData,
		filterService,
		searchService,
		SEARCH_BAR_ACTIONS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init() {

		setPageState('loading');

		const getBureauCustomerCode = companyData.getAgencyCustomerCode(agencyProfileId);
		const getCompaniesCustomerCodes = companyData.getAgencyCustomerCodes(agencyProfileId);
		$q.all([
			getBureauCustomerCode,
			getCompaniesCustomerCodes
		])
			.then(([
				bureauCustomerCode,
				companiesCustomerCodes
			]) => {

				decorateCustomerCode(bureauCustomerCode);

				decorateCustomerCodes(companiesCustomerCodes);

				angular.extend($scope.vm, {
					agencyProfileId,
					bureauCustomerCode:bureauCustomerCode,
					customerCodes:bulkService.getBulkItemsObj(companiesCustomerCodes)
				});
				// Update state
				setPageState('ready');

			})
			.catch(() => {
				// Page state
				setPageState('error');
			});
	}

	function decorateCustomerCodes(customerCodes) {

		if (!customerCodes || customerCodes.length === 0) {
			return;
		}

		customerCodes.forEach(function (customerCode) {

			decorateCustomerCode(customerCode);
		});
	}

	function decorateCustomerCode (customerCodeObj) {

		customerCodeObj.verificationState = null;
		if (customerCodeObj.CustomerCode && customerCodeObj.IsEvoEnabled) {
			customerCodeObj.isLocked = true;
		}
	}

	function editCustomerCode () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			customerCode: null,
			customerCodes: $scope.vm.customerCodes,
			callback: init,
			formKey: 'company-settings-customer-codes'
		});
	}

	function editBureauCustomerCode (customerCodeObj) {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			customerCode: customerCodeObj,
			callback: init,
			isBureau: true,
			formKey: 'company-settings-customer-codes',
		});
	}

	function searchBarActionSelected (searchBarActionKey) {
		if (searchBarActionKey === SEARCH_BAR_ACTIONS.customerCodes.editCustomerCode) {
			editCustomerCode();
		}
	}

	function setPageState (pageState) {
		$scope.pageState=pageState;
	}

	init();

	angular.extend($scope, {
		vm: {
			// Variables
			agencyProfileId,
			searchBarOptions: searchService.customerCodes,
			filterBarOptions: filterService.customerCodes,

			//Functions
			editBureauCustomerCode,
			refresh: init,
			searchBarActionSelected
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsCustomisationCtrl', [
	'$filter',
	'$scope',
	'$state',
	'$stateParams',
	'companyData',
	'config',
	'customisationService',
	'tabService',
	'CUSTOMISATION_FEATURE_KEYS',
	'TAB_KEYS',
function (
	$filter,
	$scope,
	$state,
	$stateParams,
	companyData,
	config,
	customisationService,
	tabService,
	CUSTOMISATION_FEATURE_KEYS,
	TAB_KEYS
) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const companyObj = $scope.company; // From parent

	function getAppHeaderBlock (customisationObj) {

		const appHeaderDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.appHeader);

		return {
			title: appHeaderDetailsObj.title,
			image: `/images/graphics/${appHeaderDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: appHeaderDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.appHeader);
					},
					details: [
						{
							label: 'App icon',
							type: 'image',
							value: customisationObj.LogoUrls.Icon,
						},
						{
							label: 'Header colour 1',
							type: 'customisation-colour',
							value: customisationObj.Branding.Colour1
						},
						{
							label: 'Header colour 2',
							type: 'customisation-colour',
							value: customisationObj.Branding.Colour2
						},
						{
							label: 'Gradient',
							type: 'customisation-gradient',
							value: customisationObj.Branding
						}
					]
				}
			]
		};
	}

	function getEmployeePortalBlock (customisationObj) {

		const employeePortalDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.employeePortal);

		return {
			title: employeePortalDetailsObj.title,
			image: `/images/graphics/${employeePortalDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: employeePortalDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.employeePortal);
					},
					details: [
						{
							label: 'Logo',
							type: 'image',
							value: customisationObj.SideBar.LogoURL,
						}
					]
				}
			]
		};
	}

	function getIntercomBlock (intercomCustomisationObj) {

		const intercomDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.intercom);

		const intercomIsActive = getIsIntercomEnabled(intercomCustomisationObj);

		const intercomBlockObj = {
			title: intercomDetailsObj.title,
			image: `/images/graphics/${intercomDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: intercomDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.intercom);
					},
					details: [
						{
							label: 'Status',
							type: 'switch',
							value: intercomIsActive
						}
					]
				},
				{
					details: [
						{
							type: 'html'
						}
					]
				}
			]
		};

		if (intercomIsActive) {

			intercomBlockObj.detailGroups[0].details.unshift(
				{
					label: 'App ID',
					value: '*'.repeat(intercomCustomisationObj.AppID.length)
				},
				{
					label: 'Identity Verification Secret',
					value: '*'.repeat(intercomCustomisationObj.HashKey.length/2)
				}
			);

		}

		return intercomBlockObj;
	}

	function getIsIntercomEnabled (intercomCustomisationObj) {

		const isPaycircleBureau = (companyObj.AgencyProfileID === config.paycircleBureauId);

		const hasSameAppID = (intercomCustomisationObj.AppID === config.intercomAppId);

		return (isPaycircleBureau && hasSameAppID) || (!isPaycircleBureau && !hasSameAppID);
	}

	function getLoginPageBlock (loginPageCustomisationObj) {

		const loginDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.login);

		return {
			title: loginDetailsObj.title,
			image: `/images/graphics/${loginDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: loginDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.login);
					},
					details: [
						{
							label: 'Logo',
							type: 'image',
							value: loginPageCustomisationObj.LogoURL,
						},
						{
							label: 'Background colour',
							type: 'customisation-colour',
							value: loginPageCustomisationObj.BackgroundColour
						},
						{
							label: 'Text shade',
							type: 'customisation-shade',
							value: loginPageCustomisationObj.TextShade
						},
						{
							label: 'Address',
							value: getVisibilityDisplay(loginPageCustomisationObj.IsAddressVisible)
						},
						{
							label: 'Email address',
							value: getVisibilityDisplay(loginPageCustomisationObj.IsEmailAddressVisible)
						},
						{
							label: 'Telephone',
							value: getVisibilityDisplay(loginPageCustomisationObj.IsPhoneVisible)
						},
					]
				}
			]
		};
	}

	function getOnlinePayslipsBlock (payslipCustomisationObj) {

		const onlinePayslipsDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.onlinePayslips);

		return {
			title: onlinePayslipsDetailsObj.title,
			image: `/images/graphics/${onlinePayslipsDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: onlinePayslipsDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.onlinePayslips);
					},
					details: [
						{
							label: 'Logo',
							type: 'image',
							value: payslipCustomisationObj.LogoURL,
						},
						{
							label: 'Payroll support contact',
							value: getVisibilityDisplay(payslipCustomisationObj.IsContactVisible)
						},
						{
							label: 'Custom message',
							value: payslipCustomisationObj.CustomMessage
						},
					]
				}
			]
		};
	}

	function getSystemEmailsBlock (customisationObj) {

		const systemEmailsDetailsObj = customisationService.getCustomisationFeatureByFeatureKey(CUSTOMISATION_FEATURE_KEYS.systemEmails);

		return {
			title: systemEmailsDetailsObj.title,
			image: `/images/graphics/${systemEmailsDetailsObj.imageUrl}`,
			theme: 'primary has-centered-header',
			description: systemEmailsDetailsObj.description,
			detailGroups: [
				{
					editAction: () => {
						goToCustomisation(CUSTOMISATION_FEATURE_KEYS.systemEmails);
					},
					details: [
						{
							label: 'Logo',
							type: 'image',
							value: customisationObj.Emails.LogoURL,
						},
						{
							label: 'Email address',
							value: getVisibilityDisplay(customisationObj.Emails.EmailAddress)
						},
						{
							label: 'Address',
							value: 'Displayed'
						}
					]
				}
			]
		};
	}

	function getVisibilityDisplay (isVisible) {
		return isVisible ? 'Displayed' : 'Hidden';
	}

	function goToCustomisation (featureKey) {
		$state.go('customisation', {agencyProfileId, featureKey});
	}

	function init () {

		setPageState('loading');

		companyData.getCompanyCustomisationToUse(agencyProfileId).then(customisationObj => {

			$scope.customisation = $filter('customisation')(customisationObj);

			$scope.vm = {
				// Customisation detail blocks
				appHeader: getAppHeaderBlock(customisationObj),
				intercomChat: getIntercomBlock(customisationObj.Intercom),
				loginPage: getLoginPageBlock(customisationObj.Login),
				onlinePayslips: getOnlinePayslipsBlock(customisationObj.Payslips),
				systemEmails: getSystemEmailsBlock(customisationObj),
				employeePortal: getEmployeePortalBlock(customisationObj),

				// Initial selected tab and tab definitions
				currentTab: TAB_KEYS.settings.customisation.tabs.system,
				customisationTabBarDef: tabService.getTabsForKey(TAB_KEYS.settings.customisation.id)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onTabSelected (tabId) {
		$scope.vm.currentTab = tabId;
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		onTabSelected,
		TAB_KEYS
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsEmailNotificationsCtrl', ['$rootScope', '$scope', '$stateParams', 'mailData', 'utilities', 'EMAIL_PREVIEW_TYPES', 'MAIL_GROUP_TYPES', 'MAIL_SUBGROUP_TYPES',
	function ($rootScope, $scope, $stateParams, mailData, utilities, EMAIL_PREVIEW_TYPES, MAIL_GROUP_TYPES, MAIL_SUBGROUP_TYPES) {

	let agencyProfileId = $stateParams.agencyProfileId;
	let companyObj = $scope.company;

	function getGroupName (group) {

		switch (group) {
			case MAIL_GROUP_TYPES.none:
				return 'None';
			case MAIL_GROUP_TYPES.payroll:
				return 'Payroll';
			case MAIL_GROUP_TYPES.pension:
				return 'Pension';
			case MAIL_GROUP_TYPES.system:
				return 'System';
		}
	}

	function getSubgroupName (subGroup) {

		switch (subGroup) {
			case MAIL_SUBGROUP_TYPES.none:
				return 'None';
			case MAIL_SUBGROUP_TYPES.companyAdmins:
				return 'Company Admins';
			case MAIL_SUBGROUP_TYPES.teamMembers:
				return 'Team Members';
			case MAIL_SUBGROUP_TYPES.invitation:
				return 'Invitations';
			case MAIL_SUBGROUP_TYPES.pension:
				return 'Pensions';
			case MAIL_SUBGROUP_TYPES.security:
				return 'Security';
			case MAIL_SUBGROUP_TYPES.onboarding:
				return 'Onboarding';
			case MAIL_SUBGROUP_TYPES.workflow:
				return 'Workflow';
			case MAIL_SUBGROUP_TYPES.notes:
				return 'Notes';
			case MAIL_SUBGROUP_TYPES.company:
				return 'Company';
		}
	}

	function decorateEmails (companyEmailFramework, emailListObj) {

		// Put the emails in their places
		let emailGroupArray = [];
		emailListObj.forEach(emailObj => {

			// Override IsReadOnly if parent framework is readonly
			if (companyEmailFramework.IsReadOnly) {
				// Ignore the case difference between parent and child IsReadOnly -> IsReadonly. That's a quirk of the API.
				emailObj.IsReadonly = true;
			}

			// Create group if it doesn't exist
			if (!emailGroupArray[emailObj.Group]) {
				emailGroupArray[emailObj.Group] = [];
			}
			// Create subgroup if it doesn't exist
			if (!emailGroupArray[emailObj.Group][emailObj.Subgroup]) {
				emailGroupArray[emailObj.Group][emailObj.Subgroup] = [];
			}
			/* Add email to appropriate subgroup. Leave out auto-run emails (IsHiddenInSettings); best to do that here
			   rather than in the template, as it could give rise to empty groups. */
			if (!emailObj.IsHiddenInSettings) {
				emailGroupArray[emailObj.Group][emailObj.Subgroup].push(emailObj);
			}
		});

		// Normalise that - removing anyhing that's empty
		let emailGroups = [];
		for (let group = 0; group < emailGroupArray.length; group++) {
			if (emailGroupArray[group]) {
				let emailGroup = {
					emailSubgroups: [],
					groupName: getGroupName(group),
					isSystem: group === MAIL_GROUP_TYPES.system
				};
				emailGroups.push(emailGroup);
				for (let subgroup = 0; subgroup < emailGroupArray[group].length; subgroup++) {
					if (emailGroupArray[group][subgroup]) {
						let emailList = emailGroupArray[group][subgroup];
						// Ensure emails in each subgroup are ordered by title
						emailList = emailList.sort(utilities.comparator('Title'));
						let activeCount = emailList.filter(email => email.IsActive).length;
						emailGroup.emailSubgroups.push({
							activeCount,
							emailList,
							groupTheme: group === MAIL_GROUP_TYPES.system ? 'primary' : 'secondary',
							isExpanded: true,
							subgroupName: getSubgroupName(subgroup)
						});
					}
				}
			}
		}

		return emailGroups;
	}

	function init () {

		setPageState('loading');

		// Listen for switch to live / test and refresh, since this can affect email notifications settings availability
		angular.forEach(['company-switch-to-test', 'company-switch-to-live'], (event) => {
			$rootScope.$on(event, () => {
				init();
			});
		});

		mailData.getCompanyEmailSettings(agencyProfileId).then(companyEmails => {

			let companyEmailFramework = companyEmails.CompanyEmailFramework;
			let emailGroups = decorateEmails(companyEmailFramework, companyEmails.EmailList);

			// Keep active counts in sync
			$scope.$watch('emailGroups', () => {
				$scope.emailGroups.forEach(groupObj => {
					updateGroupCounts(groupObj);
				});
			}, true);

			angular.extend($scope, {
				companyEmailFramework,
				frameworkIsInherited: companyEmailFramework.FrameworkOwnerAgencyProfileID !== agencyProfileId,
				emailGroups
			});

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function onEmailActiveChange (emailObj) {

		// Single email change - call update
		updateEmails([emailObj]);
	}

	function openEmailNotificationSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			company: companyObj,
			callback: init,
			formKey: 'company-settings-email-notifications',
			contextType: 'company',
			showContext: true
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setAllActive (groupObj, active) {

		// Set all active or inactive, and update via API
		let updateEmailList = [];
		groupObj.emailSubgroups.forEach(subGroup => {
			subGroup.emailList.forEach(email => {
				email.IsActive = active;
				updateEmailList.push(email);
			});
		});
		updateEmails(updateEmailList);

		// Keep group counts in sync
		updateGroupCounts(groupObj);
	}

	function toggleExpand (subgroupObj) {

		subgroupObj.isExpanded = !subgroupObj.isExpanded;
	}

	function updateEmails (updateEmailList) {

		let updateEmails = {
			CompanyEmailFramework: $scope.companyEmailFramework,
			EmailList: updateEmailList
		};

		mailData.updateCompanyEmailSettings(agencyProfileId, updateEmails).then(() => {

		})
		.catch(error => {
			console.error(error);
			setPageState(error);
		});
	}

	function updateGroupCounts (groupObj) {

		groupObj.emailSubgroups.forEach(subgroupObj => {
			updateSubgroupCount(subgroupObj);
		});
	}

	function updateSubgroupCount (subgroupObj) {

		subgroupObj.activeCount = subgroupObj.emailList.filter(email => email.IsActive).length;
	}

	init();

	angular.extend($scope, {
		// Constants
		EMAIL_PREVIEW_TYPES,

		// Variables
		agencyProfileId,

		// Functions
		getGroupName,
		getSubgroupName,
		onEmailActiveChange,
		openEmailNotificationSettingsForm,
		setAllActive,
		toggleExpand
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsEmployeePortalSettingsCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	'EMPLOYEE_PORTAL_PERMISSIONS_FLAGS',
	'EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS',
	function (
		$rootScope,
		$scope,
		$stateParams,
		companyData,
		EMPLOYEE_PORTAL_PERMISSIONS_FLAGS,
		EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileEmployeePortalPermissionValue(agencyProfileId).then((permissionValue) => {

			const employeePortalPermissionsSet = unravelPermissions(permissionValue);
			const employeePortalSettingsDetailBlocks = setupSettingsDetailBlocks(permissionValue, employeePortalPermissionsSet);

			angular.extend($scope, {
				vm: {
					employeePortalSettingsDetailBlocks
				}
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function permissionsKeyForSwitchBit (switchBit) {
		return Object.keys(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS).find(permissionFlag => {
			if (EMPLOYEE_PORTAL_PERMISSIONS_FLAGS[permissionFlag] === switchBit) {
				return permissionFlag;
			}
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openEditEmployeePermissionForm (permissionValue, permissionsGroupId, employeePortalSettingsDetailBlocks) {

		// Extract the permissions group from the vm object based on the ID
		const permissionsGroup = employeePortalSettingsDetailBlocks.find(employeePortalSettingsDetailBlock => {
			return employeePortalSettingsDetailBlock.groupId === permissionsGroupId;
		});

		// That should have been found ...
		if (angular.isDefined(permissionsGroup)) {
			$rootScope.openSlideInForm({
				agencyProfileId,
				callback: init,
				permissionsGroup,
				permissionValue,
				formKey: 'company-settings-employee-portal',
				title: `Edit ${permissionsGroup.title.toLowerCase()}`
			});
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setupSettingsDetailBlocks (permissionValue, employeePortalPermissionsSet) {
		const employeePortalSettingsDetailBlocks = [];

		// Employee Portal Profile settings
		employeePortalSettingsDetailBlocks.push({
			groupId: EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.profile,
			icon: 'user',
			title: 'Profile',
			detailGroups: [
				{
					editAction: openEditEmployeePermissionForm.bind(
						undefined,
						permissionValue,
						EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.profile,
						employeePortalSettingsDetailBlocks
					),
					details: [
						{
							switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation,
							infoText: 'Title / First name / Surname / Work email / Personal email / Phone number / Alternative phone number',
							label: 'Personal Information',
							type: 'switch-editable',
							value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation)]
						},
						{
							switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender,
							label: 'Gender',
							type: 'switch-visible-reversed',
							value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender)]
						},
						{
							type: 'divider'
						},
						{
							switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses,
							infoText: 'Home address / Correspondence address',
							label: 'Addresses',
							type: 'switch-editable',
							value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses)]
						},
						{
							type: 'divider'
						},
						{
							switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails,
							infoText: 'Bank details 1 / Bank details 2 / Bank details 3',
							label: 'Bank details',
							type: 'switch-editable',
							value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails)]
						}
					]
				}
			]
		});

		// Employee Portal Documents settings
		employeePortalSettingsDetailBlocks.push({
			groupId: EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.documents,
			icon: 'document',
			title: 'Documents',
			feedback: 'Documents that have been made available in the Employee portal will always be visible and downloadable by the employee',
			detailGroups: [
				{
					details: [
						{
							label: 'Document Storage',
							value: 'Pay statements / P60 / P45 / CIS'
						}
					]
				}
			]
		});

		// Employee Portal Pensions settings. Only applicable if pension module is switched on for current company
		if ($rootScope.currentCompany.IsPensionActive) {
			employeePortalSettingsDetailBlocks.push({
				groupId: EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.pensions,
				icon: 'money',
				title: 'Pensions',
				detailGroups: [
					{
						editAction: openEditEmployeePermissionForm.bind(undefined,
																		permissionValue,
																		EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.pensions,
																		employeePortalSettingsDetailBlocks),
						details: [
							{
								switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.employeeOptInOut,
								label: 'Employee opt in/out',
								type: 'switch',
								value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.employeeOptInOut)]
							},
							{
								switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.manageContributions,
								label: 'Manage pension contributions',
								type: 'switch',
								value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.manageContributions)]
							}
						]
					}
				]
			});
		}

		// Employee Portal Holiday and Sickness settings. Only applicable if HR module is switched on for current company
		if ($rootScope.currentCompany.IsHRActive) {
			employeePortalSettingsDetailBlocks.push({
				groupId: EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.holidayAndSickness,
				icon: 'holiday',
				title: 'Holiday and Sickness',
				detailGroups: [
					{
						editAction: openEditEmployeePermissionForm.bind(undefined,
																		permissionValue,
																		EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.holidayAndSickness,
																		employeePortalSettingsDetailBlocks),
						details: [
							{
								switchBit: EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.holidayAndSickness,
								infoText: 'Holiday pay / sickness pay',
								label: 'Holiday and Sickness',
								type: 'switch-visible',
								value: employeePortalPermissionsSet[permissionsKeyForSwitchBit(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.holidayAndSickness)]
							}
						]
					}
				]
			});
		}

		return employeePortalSettingsDetailBlocks;
	}

	function unravelPermissions (permissionValue) {

		// Make a copy of the permissions set for blatant manipulation
		const permissionSet = angular.copy(EMPLOYEE_PORTAL_PERMISSIONS_FLAGS);

		// For each permission bit, determine whether it's set (true) or not set (false).
		Object.keys(permissionSet).forEach(permissionBit => {
			permissionSet[permissionBit] = (permissionValue & permissionSet[permissionBit]) !== 0;
		});

		return permissionSet;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsFileUploadsCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'base',
	'bulkService',
	'filterService',
	'importService',
	'searchService',
	'DOCUMENT_TYPES',
	'FILE_UPLOAD_FORMS',
	function (
		$rootScope,
		$scope,
		$stateParams,
		base,
		bulkService,
		filterService,
		importService,
		searchService,
		DOCUMENT_TYPES,
		FILE_UPLOAD_FORMS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		base.getAgencyDocumentsForType(agencyProfileId, DOCUMENT_TYPES.genericUpload).then(documentsArr => {

			const decoratedDocumentsArr = documentsArr.filter(importService.decorateDocumentUploads(DOCUMENT_TYPES.genericUpload));

			$scope.vm = {
				documents: bulkService.getBulkItemsObj(decoratedDocumentsArr)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openFileUploadsForm (formState, filteredDocumentsArr) {

		const formOptionsObj = {
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-file-uploads',
			formState: formState,
			title: formState === FILE_UPLOAD_FORMS.uploadFile ? 'Upload files' : 'Delete files'
		};

		if (angular.isDefined(filteredDocumentsArr)) {

			const selectedDocumentsArr = bulkService.getSelectedItems(filteredDocumentsArr);

			if (selectedDocumentsArr.length > 1) {
				formOptionsObj.documents = bulkService.getValuesFromArray(selectedDocumentsArr, 'AgencyDocumentID');
			}
			else {
				formOptionsObj.document = selectedDocumentsArr[0];
			}
		}

		$rootScope.openSlideInForm(formOptionsObj);
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		openFileUploadsForm,
		refreshPage: init,

		FILE_UPLOAD_FORMS,

		agencyProfileId,
		filterBarOptions: filterService.documents,
		searchBarOptions: searchService.documents
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsGenderPayGapCtrl', [
	'$scope',
	'$stateParams',
	'bulkService',
	'reportData',
	'reportsService',
	'searchService',
	function (
		$scope,
		$stateParams,
		bulkService,
		reportData,
		reportsService,
		searchService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		reportData.getGenderPayGapReportsForAgency(agencyProfileId)
			.then(genderPayGapReportsArr => {

				$scope.vm = {
					genderPayGapReports: bulkService.getBulkItemsObj(genderPayGapReportsArr),
				};

				setPageState('ready');

			}).catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function openGenderPayGapWizard () {

		reportsService.openGenderPayGapReportCreator({
			agencyProfileId: agencyProfileId,
			callback: init,
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		openGenderPayGapWizard,
		refresh: init,
		searchBarOptions: searchService.genderPayGap,

		agencyProfileId
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsImportsCtrl', ['$scope', '$stateParams', 'tabService', 'TAB_KEYS', function ($scope, $stateParams, tabService, TAB_KEYS) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const company = $scope.company;

	function init () {
		setPageState('ready');
		$scope.settingsImportsTabBarDef = tabService.getTabsForKey(TAB_KEYS.settings.imports.id);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	$scope.vm = {
		// Variables
		agencyProfileId,
		company

	};
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsImportsSettingsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'agency',
	function (
		$q,
		$rootScope,
		$scope,
		agency
	) {

	const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

	function getCurrentPeriodDetails () {

		return {
			icon: 'settings',
			title: 'Changes imports',
			detailGroups: [
				{
					editAction: () => openEditImportLayoutForm($scope.vm, 'Current period'),
					details: [
						{
							label: 'Data layout',
							type: 'html' // Value is provided by template
						}
					]
				}
			]
		};
	}

	function getTeamImportsDetails (vmObj) {

		return {
			detailGroups: [
				{
					details: [
						{
							label: 'Auto-set casual workers',
							type: 'switch',
							value: vmObj.isAutoCompleteEnabled
						},
						{
							type: 'html',
							value: vmObj.isAutoCompleteEnabled
						}
					],
					editAction: () => openEditTeamImportsForm($scope.vm)
				}
			],
			icon: 'team-alt',
			title: 'Team imports'
		};
	}

	function init () {

		setPageState('loading');

		const getAgencyProfileImportAutoComplete = agency.getAgencyProfileImportAutoComplete(agencyProfileId);
		const getAgencyProfileImportOrientationVertical = agency.getAgencyProfileImportOrientationVertical(agencyProfileId);

		$q.all([
			getAgencyProfileImportAutoComplete,
			getAgencyProfileImportOrientationVertical
		]).then(([
			isAutoCompleteEnabled,
			isVertical
		]) => {

			let vmObj = {
				agencyProfileId,
				isAutoCompleteEnabled,
				isVertical
			};

			angular.extend(vmObj, {
				currentPeriodDetails: getCurrentPeriodDetails(),
				teamImportsDetails: getTeamImportsDetails(vmObj)
			});

			angular.extend($scope.vm, vmObj);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openEditImportLayoutForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: vmObj.agencyProfileId,
			callback: init,
			formKey: 'edit-import-layout'
		});
	}

	function openEditTeamImportsForm (vmObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: vmObj.agencyProfileId,
			callback: init,
			contextType: 'company',
			formKey: 'edit-team-imports'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsImportsMappingsCtrl', ['$rootScope', '$scope', 'bulkService', 'dataImport', 'filterService', 'searchService', 'DOCUMENT_TYPES',
	function ($rootScope, $scope, bulkService, dataImport, filterService, searchService, DOCUMENT_TYPES) {

	const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;
	const currentCompany = $rootScope.currentCompany;

	function init () {

		setPageState('loading');

		dataImport.getImportMappingTemplates(agencyProfileId).then(importMappingTemplatesArr => {

			angular.extend($scope.vm, {
				DOCUMENT_TYPES,
				agencyProfileId,
				filterBarOptions: filterService.getFilterBarOptionsImportMapping(currentCompany),
				importMappingTemplates: importMappingTemplatesArr.filter(template => angular.isUndefined(template.IgnoreTemplate) || !template.IgnoreTemplate),
				refresh: init,
				searchBarOptions: searchService.importMappings
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsIntegrationsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'base',
	'companyData',
	'reportData',
	'ACCOUNTING_INTEGRATION_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		base,
		companyData,
		reportData,
		ACCOUNTING_INTEGRATION_TYPES
	) {

	let integrationData = null;

	$scope.agencyProfileId = $stateParams.agencyProfileId;

	function init () {
		loadCompany();
	}

	function loadCompany () {

		setPageState('loading');

		const getCompanyIntegrationDetails = companyData.getCompanyIntegrationDetails($scope.agencyProfileId);
		const getAccountingIntegrationConnection = reportData.getAccountingIntegrationConnection($scope.agencyProfileId);
		const getAccessRotareadyConnection = companyData.getAccessRotareadyConnection($scope.agencyProfileId);
		const isFeatureEnabled = base.isFeatureEnabled($scope.agencyProfileId, 'ACCESS_FINANCIALS_INTEGRATION');

		$q.all([
			getCompanyIntegrationDetails,
			getAccountingIntegrationConnection,
			getAccessRotareadyConnection,
			isFeatureEnabled
		]).then(([
			integrationObj,
			accountingIntegrationObj,
			accessRotareadyConnectionObj,
			isFeatureEnabledBool
		]) => {

			const isXeroIntegrationEnabled = accountingIntegrationObj.IsConnected && accountingIntegrationObj.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.xero;
			const isAccessFinancialsIntegrationEnabled = accountingIntegrationObj.IsConnected && accountingIntegrationObj.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.accessFinancials;
			const isAccessRotareadyFeatureEnabled = accessRotareadyConnectionObj.IsFeatureEnabled;
			const isAccessRotareadyIntegrationEnabled = accessRotareadyConnectionObj.IsConnected;
			
			integrationData = {
				isEdpIntegrationEnabled: integrationObj.IsEdpIntegrationEnabled,
				isPayExperianIntegrationEnabled: integrationObj.IsPayExperianIntegrationEnabled,
				isPeopleHRIntegrationEnabled: integrationObj.IsPeopleHRIntegrationEnabled
			};

			angular.extend($scope, {
				canEditEdpIntegrationEnabled: true,
				canEditPayExperianIntegrationEnabled: integrationObj.CanEditPayExperianIntegrationEnabled,
				canEditPeopleHRIntegrationEnabled: integrationObj.CanEditPeopleHRIntegrationEnabled,
				isEdpIntegrationEnabled: integrationObj.IsEdpIntegrationEnabled,
				isXeroIntegrationEnabled,
				isAccessFinancialsFeatureEnabled: isFeatureEnabledBool,
				isAccessFinancialsIntegrationEnabled,
				isAccountingIntegrationEnabled: isXeroIntegrationEnabled || isAccessFinancialsIntegrationEnabled,
				isAccessRotareadyFeatureEnabled,
				isAccessRotareadyIntegrationEnabled,
				payExperianIntegration: {
					icon: 'fixed-value',
					title: 'Verification',
					detailGroups: [
						{
							editAction: openPayExperianIntegrationForm,
							details: [
								{
									label: 'Digital Employment Verification',
									type: 'switch',
									value: integrationObj.IsPayExperianIntegrationEnabled
								}
							],
							id: 'pay-experian-integration-setting'
						}
					]
				},
				edpIntegration: {
					icon: 'connection',
					title: 'Event-Driven Processing',
					detailGroups: [
						{
							editAction: openEdpIntegrationForm,
							details: [
								{
									label: 'EDP Integration',
									labelTrue: 'Connected',
									labelFalse: 'Not Connected',
									type: 'switch-custom',
									value: integrationObj.IsEdpIntegrationEnabled
								}
							],
							id: 'edp-integration-setting'
						}
					]
				},
				peopleHrIntegration: {
					icon: 'team',
					title: 'HR',
					detailGroups: [
						{
							editAction: openPeopleHrIntegrationForm,
							details: [
								{
									label: 'Access PeopleHR',
									type: 'switch',
									value: integrationObj.IsPeopleHRIntegrationEnabled
								},
								$rootScope.userHasRole('paycircle') ? { type: 'divider' } : {},
								$rootScope.userHasRole('paycircle') ? { type: 'html' } : {},
							],
							id: 'people-hr-integration-setting'
						}
					]
				},
				accountingIntegration: {
					icon: 'excel',
					title: 'Accounting',
					detailGroups: [
						{
							editAction: openNextForm,
							details: [
								{
									label: 'Xero',
									labelTrue: 'Connected',
									labelFalse: 'Not Connected',
									type: 'switch-custom',
									value: isXeroIntegrationEnabled
								},
								{
									label: 'Organisation',
									type: accountingIntegrationObj.CredentialTenantName === '' ? 'placeholder' : null,
									value: accountingIntegrationObj.CredentialTenantName === '' ? 'Not added' : accountingIntegrationObj.CredentialTenantName
								}
							],
							id: 'accounting-integration-setting'
						}
					]
				},
				timeAndAttendanceIntegration: {
					icon: 'team',
					title: 'Time & Attendance',
					detailGroups: [
						{
							editAction: isAccessRotareadyIntegrationEnabled ? openEditAccessRotareadyIntegrationForm : openConnectToAccessRotareadyForm,
							details: [
								{
									label: 'Rotaready',
									labelTrue: 'Connected',
									labelFalse: 'Not Connected',
									type: 'switch-custom',
									value: isAccessRotareadyIntegrationEnabled			
								},
								{
									label: accessRotareadyConnectionObj.Entities.length > 1 ? 'Sites' : 'Site',
									type: accessRotareadyConnectionObj.Entities.length === 0 ? 'placeholder' : null,
									value: accessRotareadyConnectionObj.Entities.length === 0 ? 'Not added' : accessRotareadyConnectionObj.Entities.map(entity => entity.EntityName).join(' | ')
								}
							],
							id: 'time-and-attendance-integration-setting'
						}
					]
				}
			});

			if ($scope.isAccessFinancialsFeatureEnabled) {
				$scope.accountingIntegration.detailGroups[0].details.splice(0, 0, {
					label: 'Access Financials',
					labelTrue: 'Connected',
					labelFalse: 'Not Connected',
					type: 'switch-custom',
					value: isAccessFinancialsIntegrationEnabled
				});
			}

			setPageState('ready');
		})
		.catch(() => {
			setPageState('error');
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function openPayExperianIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'edit-pay-experian-integration',
			integrationData,
			title: 'Digital Employment Verification'
		});
	}

	function openEdpIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'edit-edp-integration',
			integrationData
		});
	}

	function openEditAccessRotareadyIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'edit-rotaready-integration',
			title: 'Edit Rotaready Integration'
		});
	}

	function openConnectToAccessRotareadyForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'edit-rotaready-integration',
			title: 'Connect to Rotaready'
		});
	}

	function openPeopleHrIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'edit-people-hr-integration',
			integrationData
		});
	}

	function openAlignTeamMemberMappingsIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'align-team-member-mappings-integration'
		});
	}


	function openNextForm () {
		if (!$scope.isAccountingIntegrationEnabled) {
			openAccountingIntegrationForm();
		} else {
			if ($scope.isXeroIntegrationEnabled) {
				openDisconnectXeroForm();
			} else if ($scope.isAccessFinancialsIntegrationEnabled) {
				openDisconnectAccessFinancialsForm();
			}
		}
	}

	function openAccountingIntegrationForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			isAccessFinancialsFeatureEnabled: $scope.isAccessFinancialsFeatureEnabled,
			formKey: 'edit-accounting-integration'
		});
	}

	function openDisconnectXeroForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'xero',
			title: 'Disconnect from accounting software'
		});
	}

	function openDisconnectAccessFinancialsForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: $scope.agencyProfileId,
			callback: loadCompany,
			formKey: 'financials',
			title: 'Disconnect from accounting software'
		});
	}

	init();

	angular.extend($scope, {
		openAlignTeamMemberMappingsIntegrationForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsJournalsBusinessCategoriesCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'reportData',
	'utilities',
	'DOCUMENT_TYPES',
	function (
		$rootScope,
		$scope,
		$stateParams,
		reportData,
		utilities,
		DOCUMENT_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function decorateBusinessCategories (businessCategoriesArr) {

		businessCategoriesArr.sort(utilities.comparator('BusinessCategoryNumber'));

		// Business categories themselves are in a specific, user-defined order, but it's sensible to order the codes within.
		businessCategoriesArr.forEach(businessCategoryObj => {
			businessCategoryObj.BusinessCodes.sort(utilities.comparator('BusinessCodeValue'));
		});

		return businessCategoriesArr;
	}

	function getBusinessCategoryOverride (businessCategoriesArr) {

		return businessCategoriesArr.find(businessCategoryObj => {
			if (businessCategoryObj.BusinessCategoryNominalCodeOverridesEnabled) {
				return businessCategoryObj;
			}
		});
	}

	function init () {

		setPageState('loading');

		reportData.getBusinessCategoryListForAgency(agencyProfileId).then(businessCategoriesArr => {

			angular.extend($scope.vm, {
				DOCUMENT_TYPES,
				agencyProfileId,
				businessCategories: decorateBusinessCategories(businessCategoriesArr),
				businessCategoryOverride: getBusinessCategoryOverride(businessCategoriesArr),
				onUpdateBusinessCategory,
				openSubCodeOverridesForm
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function onUpdateBusinessCategory () {
		init();
	}

	function openSubCodeOverridesForm (businessCategoriesArr) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			businessCategories: businessCategoriesArr,
			callback: $scope.vm.refresh,
			formKey: 'company-settings-sub-code-overrides'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsJournalsImportsCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'dataImport',
	'filterService',
	'importService',
	'payrollData',
	'searchService',
	'DOCUMENT_TYPES',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		$scope,
		$stateParams,
		dataImport,
		filterService,
		importService,
		payrollData,
		searchService,
		DOCUMENT_TYPES,
		IMPORT_MAPPING_TYPES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function getUserImportGroupsNominalCodesService () {

		const INCLUDE_DELETED = true;
		const TEAM_IMPORTS = false;
		const PERIOD_IMPORTS = false;

		let PAY_PERIOD_ID; // Undefined as not period specific

		return dataImport.getUserImportGroups(agencyProfileId, PAY_PERIOD_ID, INCLUDE_DELETED, TEAM_IMPORTS, PERIOD_IMPORTS, IMPORT_MAPPING_TYPES.nominalCodes);	
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodMinimum(agencyProfileId).then(currentPayPeriodObj => {

			getUserImportGroupsNominalCodesService().then(userImportGroupsNominalCodesArr => {

				angular.extend($scope.vm, {
					DOCUMENT_TYPES,
					agencyProfileId,
					filterBarOptions: filterService.getFilterBarOptionsJournalImports(),
					importHistoryItems: userImportGroupsNominalCodesArr.filter(importService.decorateImportGroup),
					importHistoryItemsFiltered: [],
					payPeriod: currentPayPeriodObj,
					searchBarOptionsImports: searchService.journalImports
				});

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsJournalsNominalCodesCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$stateParams',
	'config',
	'dataTransfer',
	'journalsService',
	'reportData',
	'searchService',
	'storageService',
	'utilities',
	'DOCUMENT_TYPES',
	'GROUP_ENTRY_CATEGORIES',
	function (
		$filter,
		$rootScope,
		$scope,
		$stateParams,
		config,
		dataTransfer,
		journalsService,
		reportData,
		searchService,
		storageService,
		utilities,
		DOCUMENT_TYPES,
		GROUP_ENTRY_CATEGORIES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	const isHelperTextVisibleKey = 'nominalCodesIsHelperTextVisible';
	const isHelperTextVisibleValue = storageService.getFromSessionStorage(isHelperTextVisibleKey, true);
	const isHelperTextVisible = isHelperTextVisibleValue === true || isHelperTextVisibleValue === 'true';

	function decorateNominalEntry (nominalEntryObj) {

		nominalEntryObj.category = getCategoryForNominalEntry(nominalEntryObj);

		// Requires category
		nominalEntryObj.theme = getNominalEntryTheme(nominalEntryObj);
	}

	function deleteNominalEntry (vmObj, nominalCodeObj, nominalEntryObj) {

		// Mark as archived
		nominalEntryObj.NominalEntryArchived = true;
		nominalEntryObj.isActive = false;

		reportData.updateNominalEntryList(nominalCodeObj.AgencyProfileID, nominalCodeObj.NominalEntries).then(() => {

			// Now the entry has been saved, and it's unallocated, set properties to properly unassign it
			angular.extend(nominalEntryObj, {
				NominalCodeID: config.guidEmpty,
				NominalEntryArchived: false,
				NominalEntryID: config.guidEmpty
			});

			// Add to unallocated entries array
			vmObj.nominalCodes.entries.unallocated.push(angular.copy(nominalEntryObj));

			// Remove from allocated entries array
			vmObj.nominalCodes.entries.allocated = vmObj.nominalCodes.entries.allocated.filter(entry => {
				return entry.AgencyAdjustmentGroupEntryID !== nominalEntryObj.AgencyAdjustmentGroupEntryID;
			});

			// Add to unallocated nominal code
			vmObj.nominalCodes.unallocated[0].NominalEntries.push(angular.copy(nominalEntryObj));

			// Remove from existing nominal code
			nominalCodeObj.NominalEntries = nominalCodeObj.NominalEntries.filter(entry => {
				return entry.AgencyAdjustmentGroupEntryID !== nominalEntryObj.AgencyAdjustmentGroupEntryID;
			});
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function dismissHelperText (vmObj) {

		vmObj.isHelperTextVisible = false;

		storageService.addToSessionStorage(isHelperTextVisibleKey, false);
	}

	function errorHandler () {

		setPageState('error');
	}

	function exportNominalCodesCSV (agencyProfileId) {

		reportData.createNominalCodeReportDownload(agencyProfileId).then(nominalCodeReportUrl => {
			dataTransfer.downloadFile(nominalCodeReportUrl);
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function getActiveEntries (vmObj) {

		return vmObj.nominalCodes.entries.unallocated.filter(i => { return i.isActive; });
	}

	function getCategoryForNominalEntry (nominalEntryObj) {

		// Calculated
		if (nominalEntryObj.AgencyAdjustmentGroupEntry.Category === GROUP_ENTRY_CATEGORIES.calculated.key) {
			return GROUP_ENTRY_CATEGORIES.calculated.key;
		}

		// Deductions
		if (nominalEntryObj.AgencyAdjustmentGroupEntry.IsDeduction) {
			return GROUP_ENTRY_CATEGORIES.deductions.key;
		}

		// Additions
		return GROUP_ENTRY_CATEGORIES.additions.key;
	}

	function getNominalCodesData (nominalCodesArr) {

		let nominalCodesDataObj = {
			all: angular.copy(nominalCodesArr),
			allocated: [],
			filtered: [],
			unallocated: [],
			entries: {
				active: [],
				all: [],
				allocated: [],
				filtered: [],
				totalActive: 0,
				unallocated: []
			}
		};

		// Order nominal codes by value
		journalsService.sortNominalCodes(nominalCodesArr);

		/* Decorate nominal codes with category and get some useful counts for the preview */
		nominalCodesArr.forEach(nominalCodeObj => {

			// Do not show 'Unallocated'
			nominalCodeObj.isActive = true;
			nominalCodeObj.isVisible = nominalCodeObj.NominalCodeID !== config.guidEmpty;

			// Categorise entries for search / filtering
			nominalCodeObj.NominalEntries.forEach(decorateNominalEntry);

			// Allocated entries
			if (nominalCodeObj.isVisible) {
				nominalCodesDataObj.allocated.push(nominalCodeObj);
				nominalCodesDataObj.entries.all = nominalCodesDataObj.entries.all.concat(nominalCodeObj.NominalEntries);
				nominalCodesDataObj.entries.allocated = nominalCodesDataObj.entries.allocated.concat(nominalCodeObj.NominalEntries);
			}

			// Unallocated entries
			else {
				nominalCodesDataObj.unallocated.push(nominalCodeObj);
				nominalCodesDataObj.entries.all = nominalCodesDataObj.entries.all.concat(nominalCodeObj.NominalEntries);
				nominalCodesDataObj.entries.unallocated = nominalCodesDataObj.entries.unallocated.concat(nominalCodeObj.NominalEntries);
			}
		});

		// Find the unallocated nominal code in the list. This is just a container for pay elements that haven't been allocated
		let unallocatedNominalCodeIndex = nominalCodesArr.findIndex(nominalCodeObj => {
			return nominalCodeObj.NominalCodeID === config.guidEmpty;
		});

		// Get that and remove it from the list.
		nominalCodesArr.splice(unallocatedNominalCodeIndex, 1);

		return nominalCodesDataObj;
	}

	function getNominalEntryTheme (nominalEntryObj) {

		switch (nominalEntryObj.category) {
			case GROUP_ENTRY_CATEGORIES.additions.key:
				return 'is-secondary';
			case GROUP_ENTRY_CATEGORIES.deductions.key:
				return 'is-assertive';
			case GROUP_ENTRY_CATEGORIES.calculated.key:
				return 'is-primary';
			default:
				return 'is-primary';
		}
	}

	function init () {

		setPageState('loading');

		reportData.getNominalCodeListForAgency(agencyProfileId).then(nominalCodesArr => {

			angular.extend($scope.vm, {
				DOCUMENT_TYPES,
				GROUP_ENTRY_CATEGORIES,
				activeCategory: GROUP_ENTRY_CATEGORIES.calculated,
				deleteNominalEntry,
				dismissHelperText,
				errorHandler,
				exportNominalCodesCSV,
				isHelperTextVisible,
				moveActivePayElementsToNominalCodes,
				nominalCodes: getNominalCodesData(nominalCodesArr),
				openAddNominalCodesForm,
				openDeleteNominalCodeForm,
				openPreviewAndExportModal,
				payElementsSearchTerm: '',
				populateActiveEntries,
				selectCategory,
				searchBarOptions: searchService.nominalCodes,
				toggleIsActive
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function moveActivePayElementsToNominalCodes (vmObj, nominalCodeObj) {

		const nominalCodesActiveArr = getActiveEntries(vmObj);

		// Attach nominal code id
		nominalCodesActiveArr.forEach(nominalCodeActiveObj => {
			nominalCodeActiveObj.NominalCodeID = nominalCodeObj.NominalCodeID;
		});

		// Add to nominal code
		nominalCodeObj.NominalEntries = nominalCodeObj.NominalEntries.concat(nominalCodesActiveArr);

		// Do the update and add to the list
		reportData.updateNominalEntryList(nominalCodeObj.AgencyProfileID, nominalCodesActiveArr).then(() => {

			for (let i = 0; i < nominalCodesActiveArr.length; i++) {
				
				const nominalCodeActiveObj = nominalCodesActiveArr[i];

				// Remove from unallocated entries array
				vmObj.nominalCodes.entries.unallocated = vmObj.nominalCodes.entries.unallocated.filter(entry => {
					return entry.AgencyAdjustmentGroupEntryID !== nominalCodeActiveObj.AgencyAdjustmentGroupEntryID;
				});
	
				// Remove from unallocated nominal code
				vmObj.nominalCodes.unallocated[0].NominalEntries = vmObj.nominalCodes.unallocated[0].NominalEntries.filter(entry => {
					return entry.AgencyAdjustmentGroupEntryID !== nominalCodeActiveObj.AgencyAdjustmentGroupEntryID;
				});
			}

			// Add to allocated entries array
			vmObj.nominalCodes.entries.allocated = vmObj.nominalCodes.entries.allocated.concat(nominalCodesActiveArr);

			populateActiveEntries(vmObj);
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function openAddNominalCodesForm (nominalCodesArr, isFinancialsIntegrated) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'company-settings-add-nominal-codes',
			isFinancialsIntegrated,
			nominalCodes: nominalCodesArr,
			title: nominalCodesArr.length ? 'Edit nominal codes' : 'Add nominal codes'
		});
	}

	function openDeleteNominalCodeForm (nominalCodeObj, nominalCodesArr) {

		$rootScope.openSlideInForm({
			agencyProfileId: nominalCodeObj.AgencyProfileID,
			callback: init,
			formKey: 'company-settings-delete-nominal-code',
			nominalCode: nominalCodeObj,
			nominalCodes: nominalCodesArr
		});
	}

	function openPreviewAndExportModal (vmObj) {

		refreshAllNominalCodesArr(vmObj);

		$rootScope.openModalDialog({
			callback: exportNominalCodesCSV.bind(undefined, vmObj.agencyProfileId),
			modalData: {
				nominalCodes: vmObj.nominalCodes
			},
			modalKey: 'settings-journal-nominal-codes-allocation-report'
		});
	}

	function refreshAllNominalCodesArr (vmObj) {
		
		vmObj.nominalCodes.all = vmObj.nominalCodes.allocated.concat(vmObj.nominalCodes.unallocated);
	}

	function populateActiveEntries (vmObj) {

		vmObj.nominalCodes.entries.active = getActiveEntries(vmObj);
	}

	function selectCategory (vmObj, categoryObj) {

		vmObj.activeCategory = categoryObj;

		populateActiveEntries(vmObj);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleIsActive (nominalCodeObj) {

		nominalCodeObj.isActive = !nominalCodeObj.isActive;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsJournalsPostsCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'config',
	'payrollData',
	'reportData',
	'reportsService',
	'searchService',
	'utilities',
	'ACCOUNTING_INTEGRATION_TYPES',
	'SUBMISSION_STATES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		config,
		payrollData,
		reportData,
		reportsService,
		searchService,
		utilities,
		ACCOUNTING_INTEGRATION_TYPES,
		SUBMISSION_STATES
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const TEMPORAL_DATA_ENUM = {
		payroll: 0,
		latest: 1
	};

	function canUpdatePostObj (postObj) {

		switch (postObj.JournalPostState) {
			case SUBMISSION_STATES.unsubmitted:
			case SUBMISSION_STATES.failed:
				return true;
			default:
				return false;
		}
	}

	function decoratePosts (postsArr) {

		postsArr.forEach(postObj => {

			const journalPostIdOriginal = angular.copy(postObj.JournalPostID);

			angular.extend(postObj, {

				// Attach to use in forms
				AgencyProfileID: agencyProfileId,

				// Set to empty GUID if not editable so a new unsubmitted post is created
				JournalPostID: canUpdatePostObj(postObj) ? postObj.JournalPostID : config.guidEmpty,

				// Decorators
				canUpdatePost: canUpdatePostObj(postObj),
				hasBeenPosted: getHasBeenPosted(postObj),
				isPostsVisible: getHasBeenPosted(postObj) ? false : true,
				isSupRun: postObj.SupplementaryPaymentID !== config.guidEmpty,
				journalPostActionDateUnix: moment(postObj.JournalPostActionDateISO).format('x'), // For sorting
				journalPostIdOriginal,
				journalPostOverrideTemporalDataEnum: postObj.JournalPostOverrideTemporalData ? TEMPORAL_DATA_ENUM.latest : TEMPORAL_DATA_ENUM.payroll, // Convert boolean to Enum
				journalPostRunDateUnix: moment(postObj.JournalPostPayRunDateISO).format('x') // For sorting
			});
		});

		return postsArr;
	}

	function getHasBeenPosted (postObj) {

		switch (postObj.JournalPostState) {
			case SUBMISSION_STATES.unsubmitted:
				return false;
			default:
				return true;
		}
	}

	function getUniquePayPeriodIdsForPosts (postsArr) {

		let returnArr = [];

		postsArr.forEach(postObj => {
			returnArr.push(postObj.AgencyPayPeriodID);
		});

		return [...new Set(returnArr)];
	}

	function getUniqueSupplementaryPaymentIdsForPosts (postsArr) {

		let returnArr = [];

		postsArr.forEach(postObj => {
			returnArr.push(postObj.SupplementaryPaymentID);
		});

		return [...new Set(returnArr)];
	}

	function filterSupRunsOnly (postObj) {

		return postObj.isSupRun;
	}

	function filterRegularPayRunsOnly (postObj) {

		return !postObj.isSupRun;
	}

	function getPostGroupsForRegularPosts (postsArr) {

		// Group by Pay Period
		const postGroupsArr = utilities.groupArrayByProperty(postsArr, 'AgencyPayPeriodID');

		// Fetch list of PayPeriodID's
		const payPeriodIds = getUniquePayPeriodIdsForPosts(postsArr);
		
		let returnArr = [];

		payPeriodIds.forEach(payPeriodId => {

			// Fetch grouped posts
			let postGroupPostsArr = postGroupsArr[payPeriodId];

			postGroupPostsArr = $filter('orderBy')(postGroupPostsArr, 'journalPostActionDateUnix', true);

			// Use first post object as group object
			const postGroupObj = postGroupPostsArr[0];

			// Attach full list of posts to parent
			postGroupObj.posts = angular.copy(postGroupPostsArr);

			// Add to list of Sup Runs
			returnArr.push(postGroupObj);
		});

		return returnArr;
	}

	function getPostGroupsForSupRunPosts (postsArr) {

		// Group by Pay Period
		const postGroupsArr = utilities.groupArrayByProperty(postsArr, 'SupplementaryPaymentID');

		// Fetch list of PayPeriodID's
		const supplementaryPaymentIds = getUniqueSupplementaryPaymentIdsForPosts(postsArr);
		
		let returnArr = [];

		supplementaryPaymentIds.forEach(supplementaryPaymentId => {

			// Fetch grouped posts
			let postGroupPostsArr = postGroupsArr[supplementaryPaymentId];

			postGroupPostsArr = $filter('orderBy')(postGroupPostsArr, 'journalPostActionDateUnix', true);

			// Use first post object as group object
			const postGroupObj = postGroupPostsArr[0];

			// Attach full list of posts to parent
			postGroupObj.posts = angular.copy(postGroupPostsArr);

			// Add to list of Sup Runs
			returnArr.push(postGroupObj);
		});

		return returnArr;
	}

	function groupJournalPostsByPeriod (postsArr) {

		// Decorate
		postsArr = decoratePosts(postsArr);

		// Sort
		postsArr = $filter('orderBy')(postsArr, 'journalPostRunDateUnix', true);

		// Split regular pay & sup runs
		const regularPayRunsArr = postsArr.filter(filterRegularPayRunsOnly);
		const supRunsArr = postsArr.filter(filterSupRunsOnly);

		// Group posts for both Sup runs and regular runs
		let postGroupsArr = [];

		// Regular pay runs
		const groupedPostsArr = getPostGroupsForRegularPosts(regularPayRunsArr);

		postGroupsArr = postGroupsArr.concat(groupedPostsArr);

		// Sup runs
		const groupedSupRunPostsArr = getPostGroupsForSupRunPosts(supRunsArr);

		postGroupsArr = postGroupsArr.concat(groupedSupRunPostsArr);

		return postGroupsArr;
	}

	function init () {

		setPageState('loading');

		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);
		const getJournalPostHistory = reportData.getJournalPostHistory(agencyProfileId);

		$q.all([
			getPayPeriodMinimum,
			getJournalPostHistory
		]).then(([
			payPeriodObj,
			journalPostHistoryArr
		]) => {
						
			const accountingIntegrationName = $scope.vm.accountingIntegrationConnection.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.xero ?
				'Xero' : 
				'Access Financials';

			angular.extend($scope.vm, {
				accountingIntegrationName,
				SUBMISSION_STATES,
				TEMPORAL_DATA_ENUM,
				agencyProfileId,
				journalPostGroups: groupJournalPostsByPeriod(journalPostHistoryArr, 'AgencyPayPeriodID'),
				journalPostGroupsFiltered: [],
				openAddPostForm,
				openJournalDataPreview,
				openJournalPostTemporalDataForm,
				openPostToAccountingIntegrationForm,
				payPeriod: payPeriodObj,
				searchBarOptions: searchService.journalPosts,
				toggleIsPostsVisible
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openJournalPostTemporalDataForm (postGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'journal-post-temporal-data',
			postContext: 'edit',
			postGroup: postGroupObj,
			title: 'Update post settings'
		});
	}

	function openAddPostForm (postGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'journal-post-temporal-data',
			postContext: 'add',
			postGroup: postGroupObj
		});
	}

	function openPostToAccountingIntegrationForm (postObj) {

		if ($scope.vm.accountingIntegrationConnection.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.xero) {
			openPostToXeroForm(postObj);
		} else {
			openPostToFinancialsForm(postObj);
		}
	}

	function openPostToXeroForm (postObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'post-to-xero',
			postObj
		});
	}

	function openPostToFinancialsForm (postObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'post-to-financials',
			postObj
		});
	}

	function openJournalDataPreview (vmObj, postObj) {

		reportsService.openReportFromCustomService(
			{
				agencyPayPeriodId: postObj.AgencyPayPeriodID,
				agencyProfileId: postObj.AgencyProfileID,
				journalPostId: postObj.JournalPostID,
				supplementaryPaymentId: postObj.SupplementaryPaymentID
			},
			() => reportData.getReportForJournalDataPreview(postObj.AgencyProfileID, postObj.AgencyPayPeriodID, postObj.SupplementaryPaymentID),
			() => reportData.getJournalDataPreview(postObj.AgencyProfileID, postObj.AgencyPayPeriodID, postObj.SupplementaryPaymentID, postObj.journalPostIdOriginal),
			postObj
		);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleIsPostsVisible (postGroupObj) {

		postGroupObj.isPostsVisible = !postGroupObj.isPostsVisible;
	}

	init();

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsJournalsCtrl', [
	'$q',
	'$scope',
	'$stateParams',
	'journalsService',
	'reportData',
	'tabService',
	'ACCOUNTING_INTEGRATION_TYPES',
	'TAB_KEYS',
	function (
		$q,
		$scope,
		$stateParams,
		journalsService,
		reportData,
		tabService,
		ACCOUNTING_INTEGRATION_TYPES,
		TAB_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		const getJournalCodeFormatForAgency = reportData.getJournalCodeFormatForAgency(agencyProfileId);
		const getAccountingIntegrationConnection = reportData.getAccountingIntegrationConnection(agencyProfileId);

		$q.all([
			getJournalCodeFormatForAgency,
			getAccountingIntegrationConnection
		]).then(([
			journalCodeFormatObj,
			accountingIntegrationConnectionObj
		]) => {

			const journalCodesArr = journalsService.getJournalCodesByFormat(journalCodeFormatObj);

			$scope.vm = {
				agencyProfileId,
				isFinancialsIntegrated: accountingIntegrationConnectionObj.IsConnected && accountingIntegrationConnectionObj.IntegrationType === ACCOUNTING_INTEGRATION_TYPES.accessFinancials,
				journalCodeFormat: journalsService.decorateJournalCodeFormat(journalCodeFormatObj),
				journalCodesActive: angular.copy(journalCodesArr.filter(_ => !_.isHidden)),
				refresh,
				settingsJournalsTabBarDef: tabService.getTabsForKey(TAB_KEYS.settings.journals.id, {
					accountingIntegrationConnection: accountingIntegrationConnectionObj
				}),
				accountingIntegrationConnection: accountingIntegrationConnectionObj
			};

			journalsService.generateFullJournalCodePreview($scope.vm.journalCodesActive);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function refresh () {

		init();
	}
	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsAdditionsCtrl', ['$scope', 'searchService', function ($scope, searchService) {

	function additionsFilter (value) {

		return value.Category !== 'Deductions' && value.Category !== 'BIK' && value.Category !== 'SalarySacrifice';
	}

	function init () {

		angular.extend($scope, {
			payElementsAdditionsSearchBarOptions: searchService.payElementsAdditions,
			additionsFilter
		});
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsBIKCtrl', ['$scope', 'searchService', function ($scope, searchService) {

	$scope.payElementsBIKSearchBarOptions = searchService.payElementsBIK;

	function init () {

		//Find BIK category in Group Entries to check if any BIK pay elements exist
        const bikCategory = $scope.adjustmentGroup.GroupEntries.find(category => category.Category === 'BIK');
        $scope.bikCategory = bikCategory;
    }

	$scope.schedulesFilter = function (value) {
		return value.Category === 'BIK';
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsCisCtrl', ['$scope', function ($scope) {

	var adjustmentGroup = $scope.adjustmentGroup.GroupEntriesCIS; // From parent

	function init () {

		$scope.adjustmentGroupEntries = adjustmentGroup.GroupEntriesCIS;
	}

	init();

	$scope.payElementsCisSearchBarOptions = {
		search: {
			terms: {
				placeholder: 'Search cis...',
				singular: '1 cis element',
				plural: '{} cis elements'
			}
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsPayElementsCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'filterService',
	'payrollData',
	'searchService',
	'tabService',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'ADJUSTMENT_DETAIL_STATES',
	'ADJUSTMENT_VALUE_TYPES',
	'INTERFACE_TYPES',
	'PAY_ELEMENTS',
	'TAB_KEYS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		filterService,
		payrollData,
		searchService,
		tabService,
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_DETAIL_STATES,
		ADJUSTMENT_VALUE_TYPES,
		INTERFACE_TYPES,
		PAY_ELEMENTS,
		TAB_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $rootScope.currentCompany;

	function decorateGroupEntries (adjustmentGroupEntryObj) {

		adjustmentGroupEntryObj.canDuplicate = true;
		adjustmentGroupEntryObj.payElementDescription = $filter('adjustmentGroupEntryDescription')(adjustmentGroupEntryObj);
		adjustmentGroupEntryObj.isPensionDeduction = false;

		switch (adjustmentGroupEntryObj.Category) {
			case 'CIS':
				adjustmentGroupEntryObj.canDuplicate = false;
				break;
			case 'Deductions':
				switch (adjustmentGroupEntryObj.AgencyAdjustmentID) {
					case PAY_ELEMENTS.employersPension:
					case PAY_ELEMENTS.employersPensionPercent:
					case PAY_ELEMENTS.pension:
					case PAY_ELEMENTS.pensionNet:
					case PAY_ELEMENTS.pensionPercent:
						adjustmentGroupEntryObj.isPensionDeduction = true;
						break;
				}
				break;
			case 'SalarySacrifice':
				switch (adjustmentGroupEntryObj.AgencyAdjustmentID) {
					case PAY_ELEMENTS.pensionSalarySacrifice:
						adjustmentGroupEntryObj.isPensionDeduction = true;
						break;
				}
				break;
		}

		return adjustmentGroupEntryObj;
	}

	function decorateAdjustmentGroup (adjustmentGroupObj) {

		adjustmentGroupObj.GroupEntries.filter(decorateGroups);
		adjustmentGroupObj.GroupEntriesCIS.filter(decorateGroups);

		return adjustmentGroupObj;
	}

	function decorateGroups (groupObj) {

		groupObj.GroupEntries.filter(decorateGroupEntries);

		// Decorate with theme
		switch (groupObj.Category) {
			case 'Deductions':
				groupObj.theme = 'assertive';
				groupObj.order = 'd';
				break;
			case 'SalarySacrifice':
				groupObj.theme = 'assertive';
				groupObj.order = 'c';
				break;
			case 'BIK':
				groupObj.theme = '';
				groupObj.order = 'd';
				break;
			case 'Additions':
				groupObj.theme = 'positive';
				groupObj.order = 'b';
				break;
			default:
				groupObj.theme = 'positive';
				groupObj.order = 'a';
		}

		groupObj.isOpen = true;

		return groupObj;
	}

	function decorateLabelObj (labelObj) {

		labelObj.createdDateUnix = moment(labelObj.CreatedDateISO).format('x');

		return labelObj;
	}

	function decoratePayElementObj (payElementObj) {

		payElementObj.settings = [
			{
				label: 'Taxable',
				isActive: payElementObj.Taxable,
				isApplicable: !payElementObj.IsSalarySacrifice,
				isVisible: true
			},
			{
				label: 'National Insurance',
				isActive: payElementObj.IsNIable,
				isApplicable: !payElementObj.IsSalarySacrifice,
				isVisible: true
			},
			{
				label: 'Notional payment',
				isActive: payElementObj.IsNotional,
				isApplicable: true,
				isVisible: true
			},
			{
				label: 'Benefit in kind',
				isActive: payElementObj.IsBIK,
				isApplicable: true,
				isVisible: true
			},
			{
				label: 'Salary sacrifice',
				isActive: payElementObj.AgencyAdjustmentGroupEntrySalarySacrificeState,
				isApplicable: true,
				isVisible: payElementObj.SalarySacrificeState !== ADJUSTMENT_DETAIL_STATES.hidden // TBD: What happens here for a Bureau?
			},
			{
				label: 'Payroll Benefit',
				isActive: payElementObj.AgencyAdjustmentGroupEntryPayrollBIKState,
				isApplicable: true,
				isVisible: true
			},
			{
				label: 'Holiday Pay',
				isActive: payElementObj.AgencyAdjustmentGroupEntryHolidayState,
				isApplicable: true,
				isVisible: true
			},
			{
				label: 'Prorate',
				isActive: payElementObj.AgencyAdjustmentGroupEntryProrateState,
				isApplicable: true,
				isVisible: true
			}
		];

		if (currentCompanyObj.CompanyType !== INTERFACE_TYPES.bureau) {
			payElementObj.settings.push(
				{
					label: 'Pensionable',
					isActive: payElementObj.IsPensionable,
					isApplicable: true,
					isVisible: true
				},
				{
					label: 'Net Pay',
					isActive: payElementObj.AgencyAdjustmentGroupEntryNetPayState,
					isApplicable: true,
					isVisible: true
				}
			);
		}

		return payElementObj;
	}

	function init () {

		setPageState('loading');

		const getAgencyAdjustmentGroupCombined = payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId);
		const getAgencyAdjustmentLabels = payrollData.getAgencyAdjustmentLabels(agencyProfileId);

		$q.all([
			getAgencyAdjustmentGroupCombined,
			getAgencyAdjustmentLabels
		]).then(([
			adjustmentGroupObj,
			adjustmentLabelsArray
		]) => {

			$scope.adjustmentGroup = decorateAdjustmentGroup(adjustmentGroupObj); // Used in child controller
			$scope.adjustmentLabels = adjustmentLabelsArray.filter(decorateLabelObj);
			$scope.payElementsTabBarDef = tabService.getTabsForKey(TAB_KEYS.settings.payElements.id, {adjustmentGroup: $scope.adjustmentGroup});

			setAddGroupState('add-pack');
			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function openDeletePayslipLabelForm (adjustmentLabelObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'delete-payslip-label',
			adjustmentLabelObj: adjustmentLabelObj
		});
	}

	function openNewPayslipLabelForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'add-payslip-label'
		});
	}

	function openPayElementModal (payElementTypeObj) {

		$rootScope.openModalDialog({
			modalData: {
				activePayElementType: decoratePayElementObj(payElementTypeObj),
				currentCompany: currentCompanyObj,
			},
			modalKey: 'settings-pay-element-type'
		});
	}

	function refreshPayElements () {

		init();
	}

	function setAddGroupState (addGroupState) {

		$scope.addGroupState = addGroupState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleCategory (categoryObj) {

		categoryObj.isOpen = !categoryObj.isOpen;
	}

	function toggleModal (modalName) {

		$scope.modal[modalName] = !$scope.modal[modalName];
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_VALUE_TYPES,
		INTERFACE_TYPES,
		agencyProfileId,
		openDeletePayslipLabelForm,
		openNewPayslipLabelForm,
		openPayElementModal,
		payslipLabelsFilterBarOptions: filterService.payslipLabels,
		payslipLabelsSearchBarOptions: searchService.payslipLabels,
		refreshPayElements,
		toggleCategory,
		toggleModal
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsCoreCtrl', ['$scope', function ($scope) {

	$scope.payElementsCoreSearchBarOptions = {
		search: {
			terms: {
				placeholder: 'Search pay elements...',
				singular: '1 pay elements',
				plural: '{} pay elements'
			}
		}
	};
	$scope.corePayElementsFilter = function (value) {

		return value.Category !== 'BIK';
	};
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsDeductionsCtrl', ['$scope', 'searchService', function ($scope, searchService) {

	$scope.payElementsDeductionsSearchBarOptions = searchService.payElementsDeductions;

	$scope.deductionsFilter = function (value) {
		return value.Category === 'Deductions' || value.Category === 'SalarySacrifice';
	};

}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsPayElementsDisbursementsCtrl', ['$rootScope', '$scope', 'base', 'bulkService', 'searchService', function($rootScope, $scope, base, bulkService, searchService) {

	const company = $scope.company;

	function decorateDisbursement (disbursementObj) {

		disbursementObj.theme = 'assertive-light';

		return disbursementObj;
	}

	function openAddDisbursementForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: init,
			contextType: 'company',
			formKey: 'company-settings-add-bacs-disbursement',
			title: 'Add disbursement'
		});
	}

	function init () {

		setPageState('loading');

		if (!company.Bank.BACSEnabled) {

			// BACS file creation isn't enabled. No BACS, no disbursements.
			setPageState('bacs-file-creation-disabled');
		}
		else {

			// Get list of disbursements (API)
			base.getDisbursementsForPayElements(company.AgencyProfileID).then((disbursementsArr) => {

				disbursementsArr = disbursementsArr.filter(decorateDisbursement);

				angular.extend($scope, {
					disbursements: bulkService.getBulkItemsObj(disbursementsArr)
				});
				setPageState('ready');
			})
			.catch(error => {
				console.error(error);
				setPageState('error');
			});
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		company,
		openAddDisbursementForm,
		refreshDisbursements: init,
		searchBarOptions: searchService.disbursements
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsElementPacksCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'payrollData',
	'searchService',
	'ADJUSTMENT_GROUP_UPDATE_TYPES',
	function (
		$filter,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		payrollData,
		searchService,
		ADJUSTMENT_GROUP_UPDATE_TYPES
	) {

	var activeAdjustmentGroupId = null;
	var agencyProfileId = $stateParams.agencyProfileId;

	function adjustmentsGroupsFilter (adjustmentGroupObj) {

		switch (adjustmentGroupObj.AgencyAdjustmentGroupName) {
			case 'CIS':
				adjustmentGroupObj.isVisible = false;
				break;
			default:
				adjustmentGroupObj.isVisible = true;
		}
		
		return adjustmentGroupObj.isVisible;
	}

	function calculateTotalsForAdjustmentGroup (adjustmentGroupObj) {

		adjustmentGroupObj.totalChangedAdjustmentTypes = 0;
		adjustmentGroupObj.totalElementsVisible = 0;
		adjustmentGroupObj.totalElements = 0;

		adjustmentGroupObj.GroupEntries.forEach(categoryObj => {
			adjustmentGroupObj.totalChangedAdjustmentTypes += categoryObj.numberOfElementsChanged;
			adjustmentGroupObj.totalElementsVisible += categoryObj.numberOfElementsVisible;
			adjustmentGroupObj.totalElements += categoryObj.numberOfElements;
		});
	}

	function calculateTotalsForCategory (categoryObj, SET_ORIGINALS, RESET_VALUES) {

		RESET_VALUES = angular.isDefined(RESET_VALUES) ? RESET_VALUES : false;
		SET_ORIGINALS = angular.isDefined(SET_ORIGINALS) ? SET_ORIGINALS : false;
		
		categoryObj.numberOfElements = 0;
		categoryObj.numberOfElementsChanged = 0;
		categoryObj.numberOfElementsHidden = 0;
		categoryObj.numberOfElementsVisible = 0;
		
		// Decorate pay elements
		categoryObj.GroupEntries.forEach(payElementObj => {

			// Only set on initial decoration
			if (SET_ORIGINALS) {		
				payElementObj.agencyAdjustmentGroupEntryVisibleOriginal = angular.copy(payElementObj.AgencyAdjustmentGroupEntryVisible);
			}

			// Ability to reset the values to the original value
			if (RESET_VALUES) {
				payElementObj.AgencyAdjustmentGroupEntryVisible = angular.copy(payElementObj.agencyAdjustmentGroupEntryVisibleOriginal);
			}

			// Changed
			payElementObj.hasChanged = payElementObj.AgencyAdjustmentGroupEntryVisible !== payElementObj.agencyAdjustmentGroupEntryVisibleOriginal;

			if (payElementObj.hasChanged) {
				categoryObj.numberOfElementsChanged++;
			}

			// Visibility
			if (payElementObj.AgencyAdjustmentGroupEntryVisible) {
				categoryObj.numberOfElementsVisible++;
			}
			else {
				categoryObj.numberOfElementsHidden++;
			}

			// Total
			categoryObj.numberOfElements++;
		});
	}

	function clearAllChanges (adjustmentGroupObj) {

		const RESET_VALUES = true;
		const SET_ORIGINALS = false;

		// Categories
		adjustmentGroupObj.GroupEntries.forEach(categoryObj => {

			calculateTotalsForCategory(categoryObj, SET_ORIGINALS, RESET_VALUES);
		});

		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);
	}

	function decorateAdjustmentGroup (adjustmentGroupObj) {

		const SET_ORIGINALS = true;

		adjustmentGroupObj.GroupEntries.forEach(categoryObj => {

			categoryObj.numberOfElementsVisible = 0;

			// Decorate with theme
			switch (categoryObj.Category) {
				case 'Deductions':
				case 'SalarySacrifice':
					categoryObj.theme = 'assertive';
					categoryObj.order = 'b';
					break;
				case 'BIK':
					categoryObj.theme = '';
					categoryObj.order = 'c';
					break;
				default: 
					categoryObj.theme = 'positive';
					categoryObj.order = 'a';
			}

			calculateTotalsForCategory(categoryObj, SET_ORIGINALS);
		});

		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);

		return adjustmentGroupObj;
	}

	function deleteActiveAdjustmentGroupRefresh () {

		activeAdjustmentGroupId = null;

		init();
	}

	function deselectAllPayElements (adjustmentGroupObj) {

		// Categories
		adjustmentGroupObj.GroupEntries.forEach(categoryObj => {
			toggleAllPayElementsForCategory(categoryObj, false);
			calculateTotalsForCategory(categoryObj);
		});

		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);
	}

	function getUpdatedPayElements (categoryGroupObj) {

		var changedElements = [];

		// Categories
		categoryGroupObj.GroupEntries.forEach(categoryObj => {

			// Pay elements
			categoryObj.GroupEntries.forEach(payElementObj => {
				if (payElementObj.hasChanged) {
					changedElements.push(payElementObj);
				}
			});
		});

		return changedElements;
	}

	function init () {

		setPageState('loading');

		payrollData.getAgencyAdjustmentGroups(agencyProfileId).then(adjustmentGroupsArray => {

			$scope.adjustmentGroups = $filter('orderBy')(adjustmentGroupsArray.filter(adjustmentsGroupsFilter), 'AgencyAdjustmentGroupName');

			if (adjustmentGroupsArray.length > 0) {
				if (activeAdjustmentGroupId) {
					selectAdjustmentGroupById(activeAdjustmentGroupId);
				}
				else {
					selectAdjustmentGroupById($scope.adjustmentGroups[0].AgencyAdjustmentGroupID);
				}
			}
			else {			
				setPageState('ready');
			}
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openAddAdjustmentGroupForm (adjustmentGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateActiveAdjustmentGroupRefresh,
			formKey: 'adjustment-group',
			adjustmentGroupObj: adjustmentGroupObj,
			adjustmentGroupUpdateType: ADJUSTMENT_GROUP_UPDATE_TYPES.newGroup,
			title: 'Add new element pack'
		});
	}

	function openDeleteAdjustmentGroupForm (adjustmentGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: deleteActiveAdjustmentGroupRefresh,
			formKey: 'delete-adjustment-group',
			adjustmentGroupObj: adjustmentGroupObj
		});
	}

	function openDuplicateAdjustmentGroupForm (adjustmentGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateActiveAdjustmentGroupRefresh,
			formKey: 'adjustment-group',
			adjustmentGroupObj: adjustmentGroupObj,
			adjustmentGroupUpdateType: ADJUSTMENT_GROUP_UPDATE_TYPES.duplicateGroup,
			title: 'Duplicate element pack'
		});
	}

	function openSetDefaultAdjustmentGroupForm (adjustmentGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateActiveAdjustmentGroupRefresh,
			formKey: 'adjustment-group',
			adjustmentGroupObj: adjustmentGroupObj,
			adjustmentGroupUpdateType: ADJUSTMENT_GROUP_UPDATE_TYPES.setDefaultGroup,
			title: 'Set as default element pack'
		});
	}

	function openUpdateAdjustmentGroupForm (adjustmentGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateActiveAdjustmentGroupRefresh,
			formKey: 'adjustment-group',
			adjustmentGroupObj: adjustmentGroupObj,
			adjustmentGroupUpdateType: ADJUSTMENT_GROUP_UPDATE_TYPES.updateGroup,
			title: 'Update element pack'
		});
	}

	function refreshAdjustmentGroups () {

		payrollData.getAgencyAdjustmentGroups(agencyProfileId).then(adjustmentGroupsArray => {

			$scope.adjustmentGroups = adjustmentGroupsArray.filter(adjustmentsGroupsFilter);
		})
		.catch(onError);
	}

	function selectAdjustmentGroupById (adjustmentGroupId) {

		setAdjustmentGroupState('loading');

		payrollData.getAgencyAdjustmentGroup(adjustmentGroupId).then(function (adjustmentGroupObj) {

			// Set active group ID
			activeAdjustmentGroupId = adjustmentGroupObj.AgencyAdjustmentGroupID;

			$scope.activeAdjustmentGroup = decorateAdjustmentGroup(adjustmentGroupObj);

			setAdjustmentGroupState('ready');
			setPageState('ready');
		})
		.catch(onError);
	}

	function selectAllPayElements (adjustmentGroupObj) {

		// Categories
		adjustmentGroupObj.GroupEntries.forEach(adjustmentCategoryObj => {
			toggleAllPayElementsForCategory(adjustmentCategoryObj, true);
			calculateTotalsForCategory(adjustmentCategoryObj);
		});

		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);
	}

	function setAdjustmentGroupState (adjustmentGroupState) {

		$scope.adjustmentGroupState = adjustmentGroupState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setAdjustmentIsVisible (adjustmentObj, isVisible) {

		if (isVisible !== undefined) {
			adjustmentObj.AgencyAdjustmentGroupEntryVisible = isVisible;
		}
		else {
			adjustmentObj.AgencyAdjustmentGroupEntryVisible = !adjustmentObj.AgencyAdjustmentGroupEntryVisible;
		}

		adjustmentObj.hasChanged = adjustmentObj.AgencyAdjustmentGroupEntryVisible !== adjustmentObj.agencyAdjustmentGroupEntryVisibleOriginal;
	}

	function toggleAdjustmentCategoryActions (categoryObj, isVisible, adjustmentGroupObj) {

		toggleAllPayElementsForCategory(categoryObj, isVisible);
		calculateTotalsForCategory(categoryObj);
		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);
	}

	function toggleAdjustmentGroupCategory (adjustmentGroupCategoryObj) {

		adjustmentGroupCategoryObj.AdjustmentGroupCategoryIsOpen = !adjustmentGroupCategoryObj.AdjustmentGroupCategoryIsOpen;
	}

	function toggleAdjustmentIsVisible (adjustmentObj, categoryObj, adjustmentGroupObj) {

		setAdjustmentIsVisible(adjustmentObj);
		calculateTotalsForCategory(categoryObj);
		calculateTotalsForAdjustmentGroup(adjustmentGroupObj);
	}

	function toggleAllPayElementsForCategory (categoryObj, isVisible) {

		categoryObj.GroupEntries.forEach(adjustmentObj => {
			setAdjustmentIsVisible(adjustmentObj, isVisible);
		});
	}

	function updateActiveAdjustmentGroupRefresh (obj) {

		activeAdjustmentGroupId = obj.AgencyAdjustmentGroupID;

		init();
	}

	function updatePayElementsVisibility (adjustmentGroupObj) {

		$scope.savingState = 'saving';

		const updatedPayElementsArr = getUpdatedPayElements(adjustmentGroupObj);

		payrollData.updateAgencyAdjustmentGroupEntryVisible(updatedPayElementsArr).then(() => {

			$scope.savingState = 'saved';

			// Refresh adjustment group list
			refreshAdjustmentGroups();
			
			$timeout(() => {

				// Set up as though defaults
				decorateAdjustmentGroup(adjustmentGroupObj);
				
				$scope.savingState = null;
			}, 2000);
		})
		.catch(error => {
			onError(error);
			$scope.savingState = 'error';
		});
	}

	init();

	angular.extend($scope, {

		searchBarOptions: searchService.managePayElementPacks,
		savingState: 'ready',

		clearAllChanges,
		deselectAllPayElements,
		getUpdatedPayElements,
		openAddAdjustmentGroupForm,
		openDeleteAdjustmentGroupForm,
		openDuplicateAdjustmentGroupForm,
		openSetDefaultAdjustmentGroupForm,
		openUpdateAdjustmentGroupForm,
		selectAdjustmentGroupById,
		selectAllPayElements,
		toggleAdjustmentCategoryActions,
		toggleAdjustmentGroupCategory,
		toggleAdjustmentIsVisible,
		updatePayElementsVisibility
	});

}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsPayElementsLinkElementsCtrl', ['$rootScope', '$scope', 'filterService', 'payrollData', 'searchService', function ($rootScope, $scope, filterService, payrollData, searchService) {

	const companyObj = $scope.currentCompany;

	function openLinkElementForm (linkElementDetailsObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: init,
			formKey: 'link-element',
			linkElementGroupId: linkElementDetailsObj.LinkElementGroupID
		});
	}

	function init () {

		setPageState('loading');

		payrollData.getLinkElements(companyObj.AgencyProfileID).then(linkElementDetailsObj => {

			angular.extend($scope, {
				filterBarOptions: filterService.linkElements,
				linkElementDetails: linkElementDetailsObj,
				openLinkElementForm,
				refreshLinkElements: init,
				searchBarOptions: searchService.linkElements
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

	.controller('settingsP11DbSubmissionsCtrl', [
		'payrollData',
		'$rootScope',
		'$scope',
		'$stateParams',

		function (payrollData,
				  $rootScope,
				  $scope,
				  $stateParams) {

			const agencyProfileId = $stateParams.agencyProfileId;

			function init () {
				$scope.vm = {
					agencyProfileId,
					openP11DbSubmissionForm,
					refreshSubmissions: init
				};
				setPageState('loading');
				payrollData.getP11DbSubmissions(agencyProfileId).then(p11dbSubmissionArr => {
					angular.extend($scope.vm, {
						p11DbSubmissions: p11dbSubmissionArr,
					});
					setPageState('ready');
				}).catch(function (error) {
					console.error(error);
					setPageState('error');
				});
			}


			function setPageState (pageState) {
				$scope.pageState = pageState;
			}

			function openP11DbSubmissionForm () {

				$rootScope.openSlideInForm({
					agencyProfileId,
					callback: init,
					formKey: 'company-settings-p11d-submission',
					initCallbackOnClose: true
				});
			}

			init();

		}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsPayrollSettingsCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'bankService',
	'base',
	'companyData',
	'config',
	'payPeriodSetupService',
	'payrollData',
	'reportData',
	'teamData',
	'utilities',
	'workPatternService',
	'BANK_IDS',
	'DEMO_TASKS',	
	'FEATURE_FLAGS',
	'INTERFACE_TYPES',
	'P32_EMAIL_FREQUENCIES',
	'PAY_PERIOD_SETUP_TYPES',
	'PAY_PERIOD_SETUP_TYPES_DESCRIPTIONS',
	'PRO_RATION_METHODS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		bankService,
		base,
		companyData,
		config,
		payPeriodSetupService,
		payrollData,
		reportData,
		teamData,
		utilities,
		workPatternService,
		BANK_IDS,
		DEMO_TASKS,
		FEATURE_FLAGS,
		INTERFACE_TYPES,
		P32_EMAIL_FREQUENCIES,
		PAY_PERIOD_SETUP_TYPES,
		PAY_PERIOD_SETUP_TYPES_DESCRIPTIONS,
		PRO_RATION_METHODS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const callbackFired = $scope.callbackFired; // From parent
	const detailedCompanyObj = $scope.company; // From parent
	const isPayrollCompany = $scope.isPayrollCompany; // From parent
	const openForm = $stateParams.openForm;

	function init () {

		$scope.isPayrollCompany = isPayrollCompany;

		if (isPayrollCompany) {
			loadPayPeriodDetails();
		}
		else {
			populateDetails(detailedCompanyObj);
		}

		if (openForm !== undefined && !callbackFired) {

			$timeout(() => {

				switch (openForm) {
					case 'basic':
						openBasicForm();
				}
			}, 750);
		}
	}

	function getCalculationSettingsBlock (companyDetailsObj) {

		const calculationSettingsDetailsArr = [
			{
				type: 'heading',
				value: 'Calculation order'
			},
			{
				label: 'Calculate gross to net elements first',
				type: 'boolean',
				value: companyDetailsObj.NetPayCalculationDetails.CalculateGrossToNetElementsFirst
			},
			{
				type: 'heading',
				value: 'Net to gross calculations'
			}
		];

		// EE NI paid by employer
		if (companyDetailsObj.NetPayCalculationDetails.HasNetToGrossEENIPaidByEmployer) {
			calculationSettingsDetailsArr.push({
				label: 'Gross up for Employee NI',
				type: 'boolean',
				value: companyDetailsObj.NetPayCalculationDetails.NetToGrossEENIPaidByEmployer
			});
		}

		// Other contributions
		calculationSettingsDetailsArr.push(
			{
				label: 'Gross up for pension contributions',
				type: 'boolean',
				value: companyDetailsObj.NetPayCalculationDetails.NetToGrossPensionPaidByEmployer
			},

			{
				label: 'Gross up for student loans (Plan 1, 2, 4, and 5)',
				type: 'boolean',
				value: companyDetailsObj.NetPayCalculationDetails.NetToGrossSLPaidByEmployer
			},
			{
				label: 'Gross up for postgraduate loans',
				type: 'boolean',
				value: companyDetailsObj.NetPayCalculationDetails.NetToGrossPGLPaidByEmployer
			}
		);

		return {
			icon: 'calculator',
			groupId: 'calculations-settings',
			title: 'Calculation settings',
			detailGroups: [
				{
					details: calculationSettingsDetailsArr,
					editAction: openCalculationSettingsForm,
					id: 'settings-payroll-calculation-settings'
				}
			]
		};
	}

	function loadPayPeriodDetails () {

		setPageState('loading');

		const getPayPeriodDetails = companyData.getPayPeriodDetails2(agencyProfileId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);
		const getAgencyProfileCompanyDetails = companyData.getAgencyProfileCompanyDetails(agencyProfileId);
		const getPayrollReportsMailReportTemplateCollection = reportData.getPayrollReportsMailReportTemplateCollection(agencyProfileId);
		const getP60NotificationSettings = companyData.getP60NotificationSettings(agencyProfileId);
		const getAgencyProfileSickPayDefaultWorkDays = companyData.getAgencyProfileSickPayDefaultWorkDays(agencyProfileId);
		const getIndustrySectorByAgencyProfileID = companyData.getIndustrySectorByAgencyProfileID(agencyProfileId);
		const getAgencyCustomerCodeEnabledState = companyData.getAgencyCustomerCodeEnabledState(agencyProfileId);
		const getAgencyProfileSicknessProRationMethod = companyData.getAgencyProfileSicknessProRationMethod(agencyProfileId);

		$q.all([
			getPayPeriodDetails,
			getPayPeriodMinimum,
			getAgencyProfileCompanyDetails,
			getPayrollReportsMailReportTemplateCollection,
			getP60NotificationSettings,
			getAgencyProfileSickPayDefaultWorkDays,
			getIndustrySectorByAgencyProfileID,
			getAgencyCustomerCodeEnabledState,
			getAgencyProfileSicknessProRationMethod
		]).then(([
			payPeriodDetailsObj,
			currentPeriodObj,
			companyDetailsObj,
			reportCollectionObj,
			p60NotificationSettingsObj,
			sickPayDefaultWorkDaysObj,
			industrySectorObj,
			agencyCustomerCodeEnabledState,
			sicknessProRationMethodObj
		]) => {

			// Copy property across as not currently available (TODO: Need to move to platform)
			angular.extend(detailedCompanyObj, {
				AgencyEmployerEPSDisabled: companyDetailsObj.AgencyEmployerEPSDisabled,
				AgencyEmployerPayrollBIK: companyDetailsObj.AgencyEmployerPayrollBIK,
				AgencyEmployerPayrollBIKRegistrationDateISO: companyDetailsObj.AgencyEmployerPayrollBIKRegistrationDateISO,
				IsBillingEnabled: companyDetailsObj.IsBillingEnabled,
				PAYECeaseDateISO: companyDetailsObj.PAYECeaseDateISO,
				SickPayDefaultWorkDays: sickPayDefaultWorkDaysObj,
				SicknessDisplayLeaveDaysAsSeparateDeduction: sicknessProRationMethodObj.DisplayLeaveDaysAsSeparateDeduction,
				SicknessProRationMethod: sicknessProRationMethodObj.ProRationMethod
			});

			$scope.company = detailedCompanyObj;

			// Incomplete bank details for companies with BACS enabled
			if (detailedCompanyObj.Bank.BACSEnabled) {

				const getBankFiles = base.getBankFiles();
				const getUserAgencyProfileForAgencyNoBankDetails = teamData.getUserAgencyProfileForAgencyNoBankDetails(agencyProfileId);

				$q.all([
					getBankFiles,
					getUserAgencyProfileForAgencyNoBankDetails
				]).then(([
					bankFilesArr,
					incompleteTeamMembersBankArray
				]) => {

					detailedCompanyObj.bacsBankDetails = {
						incompleteTeamMembers: incompleteTeamMembersBankArray,
						selectedBank: bankFilesArr.find(bankFileObj => bankFileObj.BankID === detailedCompanyObj.Bank.BankFileID)
					};

					populateDetails(detailedCompanyObj, payPeriodDetailsObj, currentPeriodObj, companyDetailsObj, reportCollectionObj, p60NotificationSettingsObj, industrySectorObj, agencyCustomerCodeEnabledState);
				})
				.catch(onError);

			}
			else {
				populateDetails(detailedCompanyObj, payPeriodDetailsObj, currentPeriodObj, companyDetailsObj, reportCollectionObj, p60NotificationSettingsObj, industrySectorObj, agencyCustomerCodeEnabledState);
			}
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openAutoApplyTaxRefundsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-auto-apply-tax-refunds'
		});
	}

	function openBacsSettingsForm (formStage) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-bacs',
			formStage: formStage,
			title: formStage === 'incomplete-team-members' ? 'Incomplete team members' : 'BACS file creation'
		});
	}

	function openBenefitsInKindForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			bikSettings: {
				agencyEmployerPayrollBIK: $scope.company.AgencyEmployerPayrollBIK,
				agencyEmployerPayrollBIKRegistrationDateISO: $scope.company.AgencyEmployerPayrollBIKRegistrationDateISO
			},
			callback: refreshCompanyDetails,
			formKey: 'company-settings-bik',
			title: 'Benefits in Kind'
		});
	}

	function openBasicForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-basic'
		});
	}

	function openCalculationSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-calculation-settings',
		});
	}

	function openCeasePayeForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-cease-paye'
		});
	}

	function openCompanyWorkDurationsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-work-durations'
		});
	}

	function openCompanySickPayDefaultWorkPatternForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-sick-pay-default-work-pattern'
		});
	}

	function openCompanyProRationMethodForm () {
		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-sickness-pro-ration-method'
		});
	}

	function getProRationMethodDisplay (proRationMethod, displayLeaveDaysAsSeparateDeduction) {

		switch (proRationMethod) {
			case PRO_RATION_METHODS.companySetting:
				return 'Standard pro-ration';
			case PRO_RATION_METHODS.period:
				return displayLeaveDaysAsSeparateDeduction ? 'Period pro-ration (offset)' : 'Period pro-ration';
			case PRO_RATION_METHODS.manual:
				return 'Manual pro-ration';
			default:
				return 'Standard pro-ration';
		}
	}

	function openCompanyBillingEnabledForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'billing-enabled'
		});
	}

	function openCompanyCalculationMethodForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-calculation-method'
		});
	}

	function openCompanyModulesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-modules'
		});
	}

	function openCompanySettingsNmwCalculationForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-nmw-calculation'
		});
	}

	function openCompanySettingsNiUpdatesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-ni-updates'
		});
	}

	function openCompanySettingsPeriodDisplayTitleForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-period-display-title'
		});
	}

	function openEmployerForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-employer'
		});
	}

	function openEPSSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-eps'
		});
	}

	function openGenderPayGapEnabledForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-gender-pay-gap-enabled'
		});
	}

	function openInactivePeriodForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-inactive-period'
		});
	}

	function openP32PaymentForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-p32-payment'
		});
	}

	function openP60NotificationsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-p60-notifications'
		});
	}

	function openPayDashboardSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-paydashboard-settings'
		});
	}

	function openPayrollSettingsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-payroll-settings'
		});
	}

	function openPayrollSettingsAutoRunForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-payroll-auto'
		});
	}

	function openBackdatedSalaryElementsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			companyDetails: $scope.company,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-backdated-salary-elements'
		});
	}

	function openHMRCForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-hmrc'
		});
	}

	function openReferencesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-references'
		});
	}

	function openRtiSubmissionsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-rti-submissions'
		});
	}

	function openSkipPayPeriodsForm() {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-skip-pay-periods'
		});
	}

	function populateDetails(companyObj, payPeriod, currentPeriodObj, companyDetailsObj, reportCollectionObj, p60NotificationSettingsObj, industrySectorObj, agencyCustomerCodeEnabledState) {

		companyData.getCompanyModuleDetails(companyObj.AgencyProfileID).then(moduleDetailsObj => {
			// Company Groups
			if (companyObj.CompanyType !== INTERFACE_TYPES.group) {

				$scope.basicDetails = {
					icon: 'company',
					title: 'Basic information',
					detailGroups: [
						{
							editAction: openBasicForm,
							details: [
								{
									label: 'Company Name',
									value: companyObj.Name
								},
								{
									displayAsForeign: true,
									label: 'Address',
									type: companyObj.Address.HasAddress ? 'address' : null,
									value: companyObj.Address.HasAddress ? companyObj.Address : '',
								},
								{
									label: 'Telephone',
									type: 'phone',
									value: companyObj.Contact.Phone
								},
								{
									label: 'Website',
									type: 'url',
									value: companyObj.Website
								},
								{
									label: 'Payroll support contact',
									value: companyObj.Contact.Forename !== '' ? companyObj.Contact.Forename + ' ' + companyObj.Contact.Surname : ''
								},
								{
									label: 'Payroll support contact email',
									type: 'email',
									value: companyObj.Contact.EmailAddress
								},
								{
									label: 'Primary industry sector',
									value: industrySectorObj ? industrySectorObj.CategoryName : 'Not set',
								}
							],
							id: 'settings-payroll-basic-information'
						}
					]
				};

				// Customer code feature
				if (agencyCustomerCodeEnabledState) {
					$scope.basicDetails.detailGroups[0].details.push(
						{
							label: 'Customer code',
							value: companyObj.CustomerCode
						}
					);
				}
			}

			else {

				$scope.basicDetails = {
					icon: 'company-groups',
					title: 'Group information',
					detailGroups: [
						{
							editAction: openBasicForm,
							details: [
								{
									label: 'Group Name',
									value: companyObj.Name
								}
							],
							id: 'settings-payroll-group-information'
						}
					]
				};
			}

			$scope.moduleDetails = {
				icon: 'toggle-on',
				title: 'Modules',
				detailGroups: []
			};

			if (isPayrollCompany) {

				$scope.moduleDetails.detailGroups.push(
					{
						id: 'modules',
						editAction: openCompanyModulesForm,
						details: [
							{
								label: 'Payroll',
								type: 'switch',
								value: moduleDetailsObj.IsPayrollActive
							},
							{
								label: 'Pension',
								type: 'switch',
								value: moduleDetailsObj.IsPensionActive
							},
							{
								label: 'CIS (Construction Industry Scheme)',
								type: 'switch',
								value: moduleDetailsObj.IsCISActive
							},
							{
								label: 'Off-payroll workers',
								type: 'switch',
								value: moduleDetailsObj.IsOffPayrollActive
							},
							{
								label: 'HR',
								type: 'switch',
								value: moduleDetailsObj.IsHRActive
							},
							{
								label: 'Expats',
								type: 'switch',
								value: moduleDetailsObj.IsExpatActive
							}
						]
					},
					{
						id: 'gender-pay-gap',
						editAction: openGenderPayGapEnabledForm,
						details: [
							{
								label: 'Gender pay gap reporting',
								type: 'switch',
								value: moduleDetailsObj.IsGenderPayGapReportingActive
							}
						]
					}
				);

				const isP32PaymentSetup = companyDetailsObj.CompanyP32Management.AutomatedEmailFrequency !== P32_EMAIL_FREQUENCIES.none;

				$scope.p32PaymentDetails = {
					icon: 'billing',
					title: 'P32 Payment',
					detailGroups: [
						{
							editAction: openP32PaymentForm,
							details: [
								{
									label: 'HMRC account',
									value: $filter('hmrcBankDetails')(companyDetailsObj.CompanyP32Management.HMRCPaymentAccount)
								},
								{
									label: 'Auto email instruction',
									value: companyDetailsObj.CompanyP32Management.IsAutomatedEmailsEnabled,
									type: 'switch',
									mailTypeId: companyDetailsObj.CompanyP32Management.MailTypeID
								},
								{
									label: 'Payment frequency',
									value: isP32PaymentSetup ? $filter('p32EmailFrequency')(companyDetailsObj.CompanyP32Management.AutomatedEmailFrequency) : ''
								},
							],
							id: 'settings-payroll-p32-payment'
						}
					]
				};

				$scope.bik = {
					icon: 'smiley',
					title: 'Benefits in Kind',
					detailGroups: [
						{
							editAction: openBenefitsInKindForm,
							details: [
								{
									label: 'Payroll Benefits in Kind',
									type: 'switch',
									value: companyDetailsObj.AgencyEmployerPayrollBIK
								},
								{
									label: 'Registration date',
									type: 'date',
									// It appears the registration date can be set even when BIK are turned off
									value: companyDetailsObj.AgencyEmployerPayrollBIK ? companyDetailsObj.AgencyEmployerPayrollBIKRegistrationDateISO : ''
								}
							],
							id: 'payroll-settings_biks'
						}
					]
				};

				if (payPeriod) {

					// Pay Period details
					$scope.payPeriodDetails = {
						icon: 'pay-periods',
						title: 'Payroll settings',
						headerActions: {
							icon: 'icon-setup',
							iconTheme: 'primary',
							actions: [
								{
									actionHide: !companyObj.Employer.IsPayrollActive,
									actionCopy: (companyObj.PAYECeaseDateISO !== '' ? 'Cancel closing your PAYE scheme' : 'Want to close your PAYE scheme?'),
									actionFunction: openCeasePayeForm
								},
								{
									actionCopy: 'Report period of inactivity',
									actionFunction: openInactivePeriodForm
								},
								{
									actionCopy: 'Skip pay periods',
									actionFunction: openSkipPayPeriodsForm
								}
							]
						},
						detailGroups: [
							{
								editAction: openPayrollSettingsForm,
								demoTooltip: DEMO_TASKS.companySettings.changePayrollProcessingDate,
								details: [
									{
										label: 'Pay frequency',
										value: PAY_PERIOD_SETUP_TYPES_DESCRIPTIONS[payPeriod.PayPeriodType]
									}
								],
								id: 'settings-payroll-payroll-settings'
							}
						]
					};

					if (payPeriod.PayPeriodType === PAY_PERIOD_SETUP_TYPES.monthly) {
						$scope.payPeriodDetails.detailGroups.push({
							editAction: openCompanySettingsPeriodDisplayTitleForm,
							details: [
								{
									label: 'Period display title',
									value: currentPeriodObj.PayPeriodDisplay
								}
							],
							id: 'settings-payroll-period-title-display'
						});
					}

					$scope.payPeriodDetails.detailGroups.push(
						{
							editAction: openPayrollSettingsAutoRunForm,
							demoTooltip: DEMO_TASKS.companySettings.switchToAutoRun,
							details: [
								{
									label: 'Auto run payroll',
									type: 'switch',
									value: companyObj.Employer.IsAutoRun
								},
								{
									label: 'Auto send payroll reports',
									type: 'switch',
									value: reportCollectionObj.ReportTemplateCollectionActive
								}
							],
							id: 'settings-payroll-auto-run'
						}
					);

					// P60 Settings
					if (p60NotificationSettingsObj.CanShowSettings) {

						$scope.payPeriodDetails.detailGroups.push(
							{
								editAction: openP60NotificationsForm,
								details: [
									{
										label: 'Send next P60 notifications',
										value: p60NotificationSettingsObj.SendNextP60NotificationsText,
										upperFirstLetter: true,
									}
								],
								id: 'settings-payroll-p60-notifications'
							}
						);
					}

					$scope.payPeriodDetails.detailGroups.push(
						{
							editAction: openCompanySettingsNmwCalculationForm,
							details: [
								{
									label: 'National minimum wage calculation',
									value: $filter('nmwCalculationMethod')(companyDetailsObj.NMWCalculationMethod)
								}
							],
							id: 'settings-payroll-nmw-calculations'
						},
						{
							editAction: openCompanySettingsNiUpdatesForm,
							details: [
								{
									label: 'Auto accept NI Category updates',
									type: 'switch',
									value: companyDetailsObj.AutoApplyNICode
								}
							],
							id: 'settings-payroll-auto-accept-ni-categories'
						},
						{
							editAction: openEPSSettingsForm,
							details: [
								{
									label: 'Auto submit EPS',
									type: 'switch',
									value: !companyObj.AgencyEmployerEPSDisabled
								}
							],
							id: 'settings-payroll-auto-submut-eps'
						},
						{
							editAction: openAutoApplyTaxRefundsForm,
							details: [
								{
									label: 'Auto apply tax refunds',
									type: 'switch',
									value: companyDetailsObj.AutoApplyTaxRefund
								}
							],
							id: 'settings-payroll-auto-apply-tax-refunds'
						}
					);

					$scope.payPeriodDetails.detailGroups.push(
					{
						editAction: openBackdatedSalaryElementsForm,
						details: [
							{
								label: 'Backdate salary derived elements',
								type: 'switch',
								value: companyObj.BackdatedSalaryDerivedElementsEnabled
							}
						],
						id: 'settings-payroll-backdated-salary-elements'
					});

					switch (payPeriod.PayPeriodType) {

						case PAY_PERIOD_SETUP_TYPES.weekly:
						case PAY_PERIOD_SETUP_TYPES.twoWeekly:
						case PAY_PERIOD_SETUP_TYPES.fourWeekly:
						case PAY_PERIOD_SETUP_TYPES.monthly:
						case PAY_PERIOD_SETUP_TYPES.daily:

							$scope.payPeriodDetails.detailGroups[0].details.push(
								{
									label: 'Pay date',
									value: payPeriodSetupService.getDescriptionForPayDate(payPeriod)
								},
								{
									label: 'In arrears',
									value: payPeriodSetupService.getDescriptionForArrears(payPeriod)
								},
								{
									label: 'Payroll processing date',
									value: payPeriodSetupService.getDescriptionForPayProcessingDate(payPeriod)
								},
								{
									label: 'Date to send pay notifications',
									value: payPeriodSetupService.getDescriptionForPayNotifications(payPeriod)
								}
							);
							break;

						case PAY_PERIOD_SETUP_TYPES.quarterly:

							$scope.payPeriodDetails.detailGroups[0].details.push(
								{
									label: 'First payment',
									value: payPeriod.PeriodStartDateISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDateISO)
								},
								{
									label: 'Second payment',
									value: payPeriod.PeriodStartDate2ISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDate2ISO)
								},
								{
									label: 'Third payment',
									value: payPeriod.PeriodStartDate3ISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDate3ISO)
								},
								{
									label: 'Fourth payment',
									value: payPeriod.PeriodStartDate4ISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDate4ISO)
								}
							);
							break;

						case PAY_PERIOD_SETUP_TYPES.annually:

							$scope.payPeriodDetails.detailGroups[0].details.push(
								{
									label: 'Payment date',
									value: payPeriod.PeriodStartDateISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDateISO)
								}
							);
							break;

						case PAY_PERIOD_SETUP_TYPES.biAnnually:

							$scope.payPeriodDetails.detailGroups[0].details.push(
								{
									label: 'First payment',
									value: payPeriod.PeriodStartDateISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDateISO)
								},
								{
									label: 'Second payment',
									value: payPeriod.PeriodStartDate2ISO === '' ? 'Passed' : $filter('dateformat')(payPeriod.PeriodStartDate2ISO)
								}
							);
							break;
					}

					// BACS
					var bacsDetailGroup;

					if (companyObj.Bank.BACSEnabled) {
						bacsDetailGroup = {
							editAction: openBacsSettingsForm,
							details: [
								{
									label: 'BACS file format',
									value: $filter('bankFileFormatDescription')(companyObj.Bank.BACSFileFormat)
								},
								{
									label: 'Bank',
									value: companyObj.bacsBankDetails.selectedBank.BankName
								}
							],
							id: 'settings-payroll-bacs-file-format'
						};

						// Global ACH
						if (companyObj.Bank.BankFileID === BANK_IDS.globalAch) {

							bacsDetailGroup.details.push(
								{
									label: 'Client identifier',
									value: companyObj.Bank.GdffClientIdentifier
								},
								{
									label: 'Customer account number',
									value: companyObj.Bank.GdffOriginatorsAccountNumber
								},
								{
									label: 'Payments included',
									value: $filter('bacsIncludedPaymentsDescription')(companyObj.Bank.BACSIncludedPayments)
								}
							);

						}

						// Everything else
						else {

							bacsDetailGroup.details.push(
								{
									emptyText: 'Not added',
									label: 'Account name',
									value: companyObj.Bank.BankAccountName
								},
								{
									emptyText: 'Not added',
									label: 'Account number',
									value: companyObj.Bank.BankAccountNumber
								},
								{
									emptyText: 'Not added',
									label: 'Sort code',
									value: companyObj.Bank.SortCode
								},
								{
									label: 'Payments included',
									value: $filter('bacsIncludedPaymentsDescription')(companyObj.Bank.BACSIncludedPayments)
								},
								{
									label: 'Payment Reference',
									value: companyObj.Bank.BACSPaymentReference
								}
							);

							if (companyObj.bacsBankDetails.selectedBank && companyObj.bacsBankDetails.selectedBank.ShowTemplateReference) {
								bacsDetailGroup.details.push({
									emptyText: 'Not added',
									label: 'Template Reference',
									value: companyObj.Bank.BankTemplateReference
								});
							}
						}

						if (companyObj.bacsBankDetails.incompleteTeamMembers.length > 0) {
							bacsDetailGroup.groupCta = {
								editAction: () => {
									openBacsSettingsForm('incomplete-team-members');
								},
								editCopy: 'View',
								copy: `${companyObj.bacsBankDetails.incompleteTeamMembers.length} team ${companyObj.bacsBankDetails.incompleteTeamMembers.length === 1 ? 'member is' : 'members are'} missing bank details`,
								theme: 'indifferent',
							};
						}

						// International
						if (companyObj.Bank.BankIBAN !== '') {
							bacsDetailGroup.details.push({
								label: 'IBAN',
								value: companyObj.Bank.BankIBAN
							});
						}
						if (companyObj.Bank.BankBIC !== '') {
							bacsDetailGroup.details.push({
								label: 'BIC',
								value: companyObj.Bank.BankBIC
							});
						}

						if (bankService.isSunNumberApplicable(companyObj.bacsBankDetails.selectedBank, {
							bankFileFormat: companyObj.Bank.BACSFileFormat,
							isGdffAvailable: companyObj.bacsBankDetails.selectedBank.IsGdffAvailable
						}) && companyObj.Bank.BACSSUNNumber !== '') {
							bacsDetailGroup.details.push({
								label: 'SUN Number',
								value: companyObj.Bank.BACSSUNNumber
							});
						}
					}
					else {
						bacsDetailGroup = {
							editAction: openBacsSettingsForm,
							details: [
								{
									label: 'BACS file creation',
									type: 'switch',
									value: companyObj.Employer.HasBacsEnabled
								}
							],
							id: 'settings-payroll-bacs-file-creation'
						};
					}

					$scope.payPeriodDetails.detailGroups.push(bacsDetailGroup);

					// PayDashboard file creation for upload, with related user portal on / off
					$scope.payPeriodDetails.detailGroups.push({
						editAction: openPayDashboardSettingsForm,
						details: [
							{
								label: 'PayDashboard file creation',
								type: 'switch',
								value: companyObj.IsPayDashboardEnabled
							}
						],
						id: 'settings-payroll-pay-dashboard-file-creation'
					});
				}

				// References & updates
				$scope.referencesDetails = {
					icon: 'reference-number',
					title: 'References and updates',
					detailGroups: [
						{
							editAction: openReferencesForm,
							details: [
								{
									label: 'Company Number',
									value: companyObj.Employer.CompanyNumber
								},
								{
									label: 'Client Reference',
									value: companyObj.Employer.ClientReference
								},
								{
									emptyText: 'Not added',
									label: 'Accounts Office',
									value: companyObj.Employer.AccountsOffice,
									type: companyObj.PensionOnly ? 'not-applicable' : null
								},
								{
									label: 'UTR',
									value: companyObj.Employer.UTR
								}
							],
							id: 'settings-payroll-references'
						},
						{
							editAction: openHMRCForm,
							details: [
								{
									label: 'Electronic updates',
									type: 'switch',
									value: companyObj.Employer.DPSImport
								},
								{
									label: 'Auto Accept',
									type: 'switch',
									value: companyObj.Employer.DPSAutoApply
								},
								{
									label: 'HMRC credentials',
									type: 'boolean',
									value: companyObj.Employer.HMRCPassword.length > 0 && companyObj.Employer.HMRCUserName.length > 0 ? true : false
								}
							],

							id: 'settings-payroll-basic-hmrc'
						},
						{
							editAction: openRtiSubmissionsForm,
							details: [
								{
									label: 'RTI submissions',
									type: 'switch',
									value: !companyObj.IsRTISubmissionDisabled
								}
							],
							id: 'settings-payroll-rti-submissions'
						}
					]
				};

				// Only necessary when in setup mode
				if (!companyObj.HasRunPayroll) {
					$scope.referencesDetails.detailGroups[0].details.splice(0, 0, {
						label: 'New company',
						type: 'boolean',
						value: companyObj.Employer.IsNewCompany
					});
				}

				// Not applicable to CIS only companies
				if (!companyObj.Employer.CISOnly) {

					$scope.employerDetails = {
						icon: 'document',
						title: 'Employer status',
						detailGroups: [
							{
								editAction: openEmployerForm,
								details: [
									{
										label: 'Small employer',
										type: 'boolean',
										value: companyObj.Employer.SmallEmployer
									},
									{
										label: 'Entitled to Employment Allowance',
										type: 'boolean',
										value: companyObj.Employer.EmployersAllowanceEligible
									},
									{
										label: 'Employment Allowance claimed to date',
										type: companyObj.Employer.EmployersAllowanceEligible ? null : 'not-applicable',
										value: $filter('monetise')(companyObj.Employer.EmployersAllowanceUsed)
									},
									{
										label: 'Employer\'s National Insurance eligible for Employment Allowance to date',
										type: companyObj.Employer.EmployersAllowanceEligible ? null : 'not-applicable',
										value: $filter('monetise')(companyObj.Employer.EmployersNIForEmployersAllowance)
									},
									{
										label: 'Business sector',
										type: companyObj.Employer.EmployersAllowanceEligible && companyObj.Employer.CanHaveEmployersAllowanceSector ? null : 'not-applicable',
										value: $filter('businessSectorDescription')(companyObj.Employer.EmployersAllowanceSector),
										isHidden: !companyObj.Employer.CanHaveEmployersAllowanceSector
									},
									{
										label: 'Auto-reclaim',
										type: companyObj.Employer.EmployersAllowanceEligible ? 'switch' : 'not-applicable',
										value: companyObj.Employer.EmployersAllowanceAutoReclaim
									},
									{
										label: 'Apprenticeship Levy Allowance allocation',
										type: companyObj.PensionOnly ? 'not-applicable' : null,
										value: $filter('monetise')(companyObj.Employer.ApprenticeshipLevyAmount)
									},
									{
										label: 'Onboarding PAYE credit',
										type: companyObj.Employer.HasOnboardingPAYECredit ? null : 'not-applicable',
										value: $filter('monetise')(companyObj.Employer.OnboardingPAYECredit)
									},

									{
										label: 'CIS deductions suffered',
										value: $filter('monetise')(companyObj.Employer.CISDeductionsSuffered)
									}
								],
								id: 'settings-payroll-employer-status'
							}
						]
					};

					// Insert Tax Office reference after Accounts Office
					$scope.referencesDetails.detailGroups[0].details.splice(3, 0, {
						label: 'Tax Office',
						value: (companyObj.Employer.TaxOffice && companyObj.Employer.TaxOfficeReference) ? companyObj.Employer.TaxOffice + '/' + companyObj.Employer.TaxOfficeReference : ''
					});

					$scope.workPatternDetails = {
						icon: 'pay-periods',
						title: 'Work patterns',
						detailGroups: [
							{
								editAction: openCompanyWorkDurationsForm,
								details: [
									{
										label: 'Standard work hours per week',
										value: utilities.formatDecimal(companyDetailsObj.WorkHoursPerWeek, config.precision.contractedWorkingTimes, true)
									},
									{
										label: 'Standard work weeks per year',
										value:  utilities.formatDecimal(companyDetailsObj.WorkWeeksPerYear, config.precision.contractedWorkingTimes, true)
									}
								],
								id: 'settings-payroll-work-pattern-durations'
							},
							{
								editAction: openCompanyCalculationMethodForm,
								details: [
									{
										label: 'Day rate calculation method',
										value: $filter('calculationMethodDescription')(companyDetailsObj.DayRateCalculationMethod)
									},
									{
										label: 'Max. working days in a month',
										value: companyDetailsObj.MaximumWorkingDaysInMonth
									},
									{
										label: 'Working days for calculations',
										value: companyDetailsObj.CalculatePatternOnYearlyBasis ? 'Calendar year' : 'Pay period'
									}
								],
								id: 'settings-payroll-calculcation-methods'
							}
						]
					};

					$scope.sicknessSettingsDetails = {
						icon: 'sick',
						title: 'Sickness settings',
						detailGroups: [
							{
								editAction: openCompanySickPayDefaultWorkPatternForm,
								details: [
									{
										label: 'Default work pattern for sick pay',
										value: workPatternService.getWorkDaysDisplay(detailedCompanyObj.SickPayDefaultWorkDays)
									}
								],
								id: 'settings-payroll-sick-pay-default-work-pattern'
							},
							{
								editAction: openCompanyProRationMethodForm,
								details: [
									{
										label: 'Pro-ration method',
										value: getProRationMethodDisplay(detailedCompanyObj.SicknessProRationMethod, detailedCompanyObj.SicknessDisplayLeaveDaysAsSeparateDeduction)
									}
								],
								id: 'settings-payroll-sickness-pro-ration-method'
							}
						]
					};
				}

				$scope.calculationSettings = getCalculationSettingsBlock(companyDetailsObj);
			}

			// Group Modules
			if (companyObj.CompanyType === INTERFACE_TYPES.group) {
				$scope.moduleDetails.detailGroups.push(
					{
						id: 'gender-pay-gap',
						editAction: openGenderPayGapEnabledForm,
						details: [
							{
								label: 'Gender pay gap reporting',
								type: 'switch',
								value: moduleDetailsObj.IsGenderPayGapReportingActive
							}
						]
					}
				);
			}

			// Paycircle only
			if ($rootScope.userHasRole('paycircle') && (isPayrollCompany || companyObj.CompanyType === INTERFACE_TYPES.bureau)) {

				$scope.moduleDetails.detailGroups.push({
					editAction: openCompanyBillingEnabledForm,
					details: [
						{
							label: 'Billing (Paycircle only)',
							type: 'switch',
							value: companyObj.IsBillingEnabled
						}
					],
					id: 'settings-payroll-billing'
				});
			}

			setPageState('ready');
		})
		.catch(onError);

	}

	function refreshCompanyDetails () {

		$scope.refreshCompanyDetails(); // From parent
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleCompanyMore () {

		$scope.showMoreCompany = !$scope.showMoreCompany;
	}

	function togglePensionMore () {

		$scope.showMorePension = !$scope.showMorePension;
	}

	init();

	angular.extend($scope, {
		openBasicForm,
		openBenefitsInKindForm,
		openEmployerForm,
		openReferencesForm,
		openPayrollSettingsForm,
		toggleCompanyMore,
		togglePensionMore
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsPayslipsCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	'payslipService',
	'CUSTOMISATION_TYPES',
	'DEMO_TASKS',
	'FULL_SCREEN_MODAL_KEYS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		companyData,
		payslipService,
		CUSTOMISATION_TYPES,
		DEMO_TASKS,
		FULL_SCREEN_MODAL_KEYS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function getPayslipsDetailBlocks (customisationObj, companyDetailsObj) {

		function getPayslipDownloadsSection () {

			return {
				icon: 'download',
				title: 'Downloads',
				detailGroups: [
					{
						details: [
							{
								label: 'Team member sort order',
								value: $filter('payslipSortByDescription')(companyDetailsObj.PdfPayslipTeamMemberSorting)
							},
							{
								emptyText: 'Not set',
								label: 'Business category sorting',
								value: companyDetailsObj.PdfPayslipBusinessCategorySorting === 0 ? '' : $filter('businessCategorySortByDescription')(companyDetailsObj.PdfPayslipBusinessCategorySorting)
							}
						],
						editAction: openPdfDownloadSortingForm
					}
				]
			};
		}

		function getDisplaySection () {

			const displayUploadDetailsObj = {
				agencyProfileId: agencyProfileId,
				callback: onPayslipLogoChange,
				customisationType: CUSTOMISATION_TYPES.payslip,
				model: customisationObj.Payslips.LogoURL
			};

			function getDisplayFileUploadGroup () {

				return {
					demoTooltip: DEMO_TASKS.companySettings.uploadCompanyPayslipLogo,
					fileUpload: true,
					uploadDetails: displayUploadDetailsObj
				};
			}

			function getDisplayPeriodVisibilityGroup () {

				return {
					details: [
						{
							label: 'Display pay period',
							type: 'switch',
							value: payslipService.getPeriodVisiblityBoolFromEnum(companyDetailsObj.PayslipPeriodVisible)
						}
					],
					editAction: openPayslipDisplayPeriodForm
				};
			}

			function getAdditionalNoteVisibilityGroup () {

				return {
					details: [
						{
							label: 'Display Healthcare Levy notice',
							type: 'switch',
							value: payslipService.getAdditionalNoteVisibilityBoolFromEnum(companyDetailsObj.PayslipAdditionalNoteVisible)
						}
					],
					editAction: openPayslipAdditionalNoteForm
				};
			}

			return {
				icon: 'paintpot',
				title: 'Display',
				uploadDetails: displayUploadDetailsObj,
				detailGroups: [
					getDisplayFileUploadGroup(),
					getDisplayPeriodVisibilityGroup(),
					getAdditionalNoteVisibilityGroup(),
				]
			};
		}

		return {
			payslipDisplay: getDisplaySection(),
			payslipDownloads: getPayslipDownloadsSection()
		};
	}

	function init () {

		const getCompanyCustomisation = companyData.getCompanyCustomisation(agencyProfileId);
		const getAgencyProfileCompanyDetails = companyData.getAgencyProfileCompanyDetails(agencyProfileId);

		$q.all([
			getCompanyCustomisation,
			getAgencyProfileCompanyDetails
		])
			.then(([
				customisationObj,
				companyDetailsObj
			]) => {

				$filter('customisation')(customisationObj);

				angular.extend($scope, {
					customisation: customisationObj,
					vm: getPayslipsDetailBlocks(customisationObj, companyDetailsObj)
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onPayslipLogoChange () {

		companyData.getCompanyCustomisation(agencyProfileId)
			.then(customisationObj => {

				$filter('customisation')(customisationObj);

				// Update displayed Logo
				$scope.vm.payslipDisplay.uploadDetails.model = customisationObj.Payslips.LogoURL;

				// Update logo in preview
				$scope.customisation = customisationObj;

				// Demo Task
				if (customisationObj.Payslips.LogoURL !== '') {
					$rootScope.setDemoTaskAsComplete('uploadCompanyPayslipLogo');
				}
			})
			.catch(onError);
	}

	function openPayslipAdditionalNoteForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'company-settings-payslip-additional-note'
		});
	}

	function openPayslipDisplayPeriodForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'company-settings-payslip-display-period'
		});
	}

	function openPayslipPreviewForm (payslipType) {

		$rootScope.$broadcast('open-full-screen-modal', {
			agencyProfileId: agencyProfileId,
			logoToUse: $scope.customisation.Payslips.LogoURL,
			modalKey: FULL_SCREEN_MODAL_KEYS.payslipPreview,
			payslipType: payslipType,
			title: payslipType + ' payslip preview'
		});
	}

	function openPdfDownloadSortingForm () {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: init,
			formKey: 'company-settings-pdf-download-sorting'
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		openPayslipPreviewForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsPensionSettingsCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	function (
		$rootScope,
		$scope,
		$stateParams,
		companyData
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function getSettingsForCommunictions (pensionSettingsObj) {

		const returnObj = {
			icon: 'email',
			title: 'Communications',
			detailGroups: [
				{
					editAction: openPensionCommunicationsForm,
					details: [
						{
							label: 'Default pension communications email',
							type: 'switch',
							value: pensionSettingsObj.Communications.UseDefaultPensionRecipientEmail
						}
					]
				}
			]
		};

		// Email Address
		if (pensionSettingsObj.Communications.UseDefaultPensionRecipientEmail) {
			returnObj.detailGroups[0].details.push({
				label: 'Email address',
				type: 'email',
				value: pensionSettingsObj.Communications.DefaultPensionRecipientEmail
			});
		}

		return returnObj;
	}

	function getDescriptionForSubmissionDay (pensionSettingsObj) {

		switch (pensionSettingsObj.Submissions.PensionSubmissionDelayCount) {

			case 1:
				return '1 day after payroll processing date';

			default:
				return `${pensionSettingsObj.Submissions.PensionSubmissionDelayCount} days after payroll processing date`;
		}
	}

	function getSettingsForSubmissions (pensionSettingsObj) {

		let returnObj = {
			icon: 'remote-access',
			title: 'Submissions',
			detailGroups: [
				{
					editAction: openSubmissionsForm,
					details: [
						{
							label: 'Delay pension submissions',
							type: 'switch',
							value: pensionSettingsObj.Submissions.DelayPensionSubmission
						}
					]
				}
			]
		};

		// Submission delay active
		if (pensionSettingsObj.Submissions.DelayPensionSubmission) {

			returnObj.detailGroups[0].details.push(
				{
					label: 'Submission day',
					value: getDescriptionForSubmissionDay(pensionSettingsObj)
				}
			);
		}

		return returnObj;
	}

	function getSettingsForSupRuns (pensionSettingsObj) {

		let returnObj = {
			icon: 'calendar',
			title: 'Supplementary pay runs',
			detailGroups: [
				{
					editAction: openSupRunsForm,
					details: [
						{
							label: 'Pension calculations',
							type: 'switch',
							value: pensionSettingsObj.SupplementaryPay.CalculatePensionsInSupplementaryRun
						}
					]
				}
			]
		};

		return returnObj;
	}

	function init () {

		companyData.getAgencyProfilePensionSettings(agencyProfileId).then(pensionSettingsObj => {

			angular.extend($scope, {
				communications: getSettingsForCommunictions(pensionSettingsObj),
				submissions: getSettingsForSubmissions(pensionSettingsObj),
				supplementaryPayRuns: getSettingsForSupRuns(pensionSettingsObj)
			});
		})
		.catch(onError);
	}

	function onError (error) {

		$scope.setPageState('error');
		console.error(error);
	}

	function openPensionCommunicationsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-pension-communications'
		});
	}

	function openSubmissionsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-pension-submissions'
		});
	}

	function openSupRunsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshCompanyDetails,
			formKey: 'company-settings-pension-sup-runs'
		});
	}

	function refreshCompanyDetails () {

		$scope.refreshCompanyDetails(); // From parent
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsReportsCtrl', ['$scope', 'tabService', 'TAB_KEYS', function($scope, tabService, TAB_KEYS) {

	function init () {
		$scope.settingsReportsTabBarDef = tabService.getTabsForKey(TAB_KEYS.settings.reports.id);
	}

	init();
}]);
'use strict';

angular.module('paycircleApp')
.controller('settingsReportsPacksCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'config',
	'payrollData',
	'searchService',
	'reportData',
	'reportsService',
	'REPORT_TEMPLATE_GROUP_FORM_VIEWS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		config,
		payrollData,
		searchService,
		reportData,
		reportsService,
		REPORT_TEMPLATE_GROUP_FORM_VIEWS
	) {

	const AGENCY_PROFILE_ID = $stateParams.agencyProfileId;

	let activeReportGroupId = null;

	function clearAllChanges (vmObj) {

		if (vmObj.numberOfChangedReportTemplates > 0) {
			for (let reportTemplateObj of vmObj.activeReportGroup.ReportTemplates) {
				reportTemplateObj.isActiveInGroup = reportTemplateObj.originalIsActiveInGroup;
				reportTemplateObj.hasChanged = false;
			}

			updateChangedReportsCount(vmObj);
		}
	}

	function getTemplatesFromReportCategories (reportGroupObj) {

		reportGroupObj.ReportTemplates = reportsService.getTemplatesFromReportCategories(reportGroupObj.ReportTemplates);

		reportGroupObj.ReportTemplates = reportGroupObj.ReportTemplates.filter(reportsService.decorateReportTemplatesInGroups(reportGroupObj));

		return reportGroupObj;
	}

	function formCallback (reportGroupObj) {

		activeReportGroupId = reportGroupObj ? reportGroupObj.ReportTemplateGroupID : null;

		init();
	}

	function getUpdatedReportTemplates (vmObj) {
		return vmObj.activeReportGroup.ReportTemplates.filter(reportTemplateObj => reportTemplateObj.hasChanged);
	}

	function init () {

		setPageState('loading');

		const INCLUDE_COLUMN_DETAILS = true;
		const REPORT_TEMPLATE_GROUP_ID = config.guidEmpty;
		const STANDARD_REPORT_TEMPLATE_GROUP_ID = config.standardReportTemplateGroupId;

		const getReportTemplateGroups = reportData.getReportTemplateGroups(AGENCY_PROFILE_ID);
		const getReportTemplates = reportData.getReportTemplates(STANDARD_REPORT_TEMPLATE_GROUP_ID, REPORT_TEMPLATE_GROUP_ID, INCLUDE_COLUMN_DETAILS);

		$q.all([getReportTemplateGroups, getReportTemplates]).then(([reportTemplateGroupsArr, reportsArr]) => {

			reportTemplateGroupsArr = reportTemplateGroupsArr.filter(getTemplatesFromReportCategories);
			reportsArr = reportsService.getTemplatesFromReportCategories(reportsArr);

			let vmObj = {
				reportTemplateGroups: reportsService.loadTemplatesIntoGroups(reportTemplateGroupsArr, reportsArr)
			};

			$scope.vm = vmObj;

			if (reportTemplateGroupsArr.length > 0) {
				if (activeReportGroupId) {
					selectReportGroupById(vmObj, activeReportGroupId);
				}
				else {
					let defaultTemplateGroupObj = vmObj.reportTemplateGroups.find(reportTemplateGroupObj => reportTemplateGroupObj.ReportTemplateGroupDefault);
					selectReportGroupById(vmObj, defaultTemplateGroupObj.ReportTemplateGroupID);
				}
			}
			else {
				setPageState('ready');
			}

		})
		.catch(onError);
	}
	function openReportTemplateGroupForm (reportTemplateFormViewKey, reportTemplateGroupObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: formCallback,
			formKey: 'report-template-group',
			reportTemplateGroup: reportTemplateGroupObj,
			reportTemplateGroupFormView: reportTemplateFormViewKey,
			title: reportsService.getReportTemplateGroupFormTitleForView(reportTemplateFormViewKey)
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function selectReportGroupById (vmObj, reportTemplateGroupId) {

		clearAllChanges(vmObj);

		setReportGroupState('loading');

		let selectedReportGroupObj = vmObj.reportTemplateGroups.find(reportTemplateGroupObj => reportTemplateGroupObj.ReportTemplateGroupID === reportTemplateGroupId);

		activeReportGroupId = selectedReportGroupObj.ReportTemplateGroupID;

		vmObj.activeReportGroup = selectedReportGroupObj;

		setReportGroupState('ready');
		setPageState('ready');
	}

	function setReportGroupState (reportGroupState) {
		$scope.reportGroupState = reportGroupState;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setSavingState (newState) {
		$scope.savingState = newState;
	}

	function toggleReportTemplates (vmObj, toggleOption) {

		vmObj.activeReportGroup.ReportTemplates.forEach(function (reportTemplateObj) {
			toggleReportActiveState(vmObj, reportTemplateObj, toggleOption);
		});
	}

	function toggleReportActiveState (vmObj, reportTemplateObj, toggleOption) {

		if (toggleOption !== undefined) {
			reportTemplateObj.isActiveInGroup = toggleOption;
		}
		else {
			reportTemplateObj.isActiveInGroup = !reportTemplateObj.isActiveInGroup;
		}

		reportTemplateObj.hasChanged = reportTemplateObj.isActiveInGroup !== reportTemplateObj.originalIsActiveInGroup;

		updateChangedReportsCount(vmObj);
	}

	function updateChangedReportsCount (vmObj) {

		let updatedReportTemplates = getUpdatedReportTemplates(vmObj);

		vmObj.numberOfChangedReportTemplates = updatedReportTemplates.length;
	}

	function updateReportTemplatePack (vmObj) {

		setSavingState('saving');

		let activeReportGroupId = vmObj.activeReportGroup.ReportTemplateGroupID;

		let updatedReportTemplates = getUpdatedReportTemplates(vmObj);
		let newReportTemplates = updatedReportTemplates.filter(reportTemplateObj => !reportTemplateObj.originalIsActiveInGroup);
		let removedReportTemplates = updatedReportTemplates.filter(reportTemplateObj => reportTemplateObj.originalIsActiveInGroup);

		let addReportTemplatesToGroup = newReportTemplates.length > 0 ? reportData.addReportTemplatesToGroup(activeReportGroupId, newReportTemplates, AGENCY_PROFILE_ID) : null;
		let removeReportTemplatesFromGroup = removedReportTemplates.length > 0 ? reportData.removeReportTemplatesFromGroup(activeReportGroupId, removedReportTemplates, AGENCY_PROFILE_ID) : null;

		$q.all([addReportTemplatesToGroup, removeReportTemplatesFromGroup]).then(() => {

			setSavingState('saved');

			init();

			$timeout(function () {
				setSavingState(null);
			}, 1500);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		numberOfChangedReportTemplates: 0,
		savingState: 'ready',
		searchBarOptions: searchService.reportTemplates,

		clearAllChanges,
		openReportTemplateGroupForm,
		selectReportGroupById,
		toggleReportActiveState,
		toggleReportTemplates,
		updateReportTemplatePack,

		REPORT_TEMPLATE_GROUP_FORM_VIEWS,
	});
}]);


'use strict';

angular.module('paycircleApp')

.controller('settingsReportsTemplatesCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'config', 'reportData', 'reportsService', 'searchService', 'INTERFACE_TYPES', 'SEARCH_BAR_ACTIONS', function ($q, $rootScope, $scope, $stateParams, config, reportData, reportsService, searchService, INTERFACE_TYPES, SEARCH_BAR_ACTIONS) {

	const currentCompanyObj = $rootScope.currentCompany;

	const AGENCY_PROFILE_ID = $stateParams.agencyProfileId;
	const REPORT_FILTER = $stateParams.reportFilter;
	const INCLUDE_COLUMN_DETAILS = true;
	const REPORT_TEMPLATE_GROUP_ID = config.guidEmpty;
	const STANDARD_REPORT_TEMPLATE_GROUP_ID = config.standardReportTemplateGroupId;

	const REPORT_FILTERS = {
		custom: 'custom',
		standard: 'standard'
	};

	function filterReportTemplates (reportTemplateObj) {

		reportTemplateObj.companyOwnsReport = (reportTemplateObj.AgencyProfileID === currentCompanyObj.AgencyProfileID);

		switch (REPORT_FILTER) {
			case REPORT_FILTERS.custom:
				return !reportTemplateObj.IsClassicReport;

			case REPORT_FILTERS.standard:
				return reportTemplateObj.IsClassicReport;

			default:
				return reportTemplateObj;
		}
	}

	function getReportTemplatesForBureaus () {

		const getReportTemplateGroups = reportData.getReportTemplateGroups(AGENCY_PROFILE_ID);
		const getReportTemplates = reportData.getReportTemplates(STANDARD_REPORT_TEMPLATE_GROUP_ID, REPORT_TEMPLATE_GROUP_ID, INCLUDE_COLUMN_DETAILS);

		$q.all([getReportTemplateGroups, getReportTemplates]).then(([reportTemplateGroupsArr, reportsArr]) => {

			let bureauReportsArr = reportsService.getReportTemplatesForBureau(reportTemplateGroupsArr, reportsArr);

			loadPage(bureauReportsArr);
		})
		.catch(onError);
	}

	function getReportTemplatesForCompanies () {

		reportData.getReportTemplates(AGENCY_PROFILE_ID, REPORT_TEMPLATE_GROUP_ID, INCLUDE_COLUMN_DETAILS).then(reportsArr => {

			let companyReportsArr = reportsService.getTemplatesFromReportCategories(reportsArr);

			loadPage(companyReportsArr);
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		if (currentCompanyObj.CompanyType === INTERFACE_TYPES.bureau) {
			getReportTemplatesForBureaus();

		} else {
			getReportTemplatesForCompanies();
		}
	}

	function loadPage (reportTemplatesArr) {

		$scope.vm = {
			reportTemplates: reportTemplatesArr.filter(filterReportTemplates),
			searchBarOptions: searchService.reportTemplates,
		};

		setPageState('ready');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openReportTemplateForm () {

		reportsService.openReportTemplateCreator(
			{
				agencyProfileId: AGENCY_PROFILE_ID,
				callback: init
			}
		);
	}

	function searchBarActionSelected (searchBarActionKey) {
		if (searchBarActionKey === SEARCH_BAR_ACTIONS.reportTemplates.addNewTemplate) {
			openReportTemplateForm();
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		AGENCY_PROFILE_ID,
		REPORT_FILTERS,
		REPORT_FILTER,
		openReportTemplateForm,
		init,
		searchBarActionSelected
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('settingsRolesCtrl', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'base',
	'permissionsService',
	function (
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		base,
		permissionsService
	) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const currentCompanyObj = $rootScope.currentCompany;

	function clearAllChanges (vmObj) {

		vmObj.activeRole.Groups.forEach(activeRoleGroupObj => {

			angular.extend(activeRoleGroupObj, {
				GroupVisible: activeRoleGroupObj.originalGroupVisible,
				GroupValue: activeRoleGroupObj.originalGroupValue,
			});

			activeRoleGroupObj.GroupPermissionActions.forEach(activeRoleGroupActionObj => {
				activeRoleGroupActionObj.IsActive = activeRoleGroupActionObj.originalIsActive;
			});

			permissionsService.calculateActiveActionsCount(activeRoleGroupObj);
		});

		vmObj.changesCount = 0;
	}

	function openUpdateRoleModal (vmObj) {
		vmObj.updateRoleModalOptions.isOpen = true;
	}

	function init (activeRoleType) {

		setPageState('loading');

		base.getPermissionRoles(agencyProfileId).then(permissionRolesObj => {

			const rolesArr = permissionRolesObj.Roles.filter(permissionsService.decorateRole);

			const vmObj = {
				changesCount: 0,
				isValid: true,
				roles: rolesArr,
				saveState: null,
				updateRoleModalOptions: {
					isOpen: false,
					size: 'm',
					title: 'Update role',
				}
			};

			if (activeRoleType) {
				const activeRoleObj = rolesArr.find(roleObj => roleObj.RoleType === activeRoleType);
				selectRole(vmObj, activeRoleObj);

			} else {
				selectRole(vmObj, rolesArr[0]);
			}

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openViewRoleForm (activeRoleObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			role: activeRoleObj,
			formKey: 'view-role'
		});
	}

	function selectRole (vmObj, roleObj) {

		// Show "View roles" on correct compaines
		roleObj.showViewRoleButton = permissionsService.getIsPermissionRoleVisibleForCompany(roleObj.RoleType, currentCompanyObj);

		if (vmObj.activeRole) {
			clearAllChanges(vmObj);
		}

		vmObj.activeRole = roleObj;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateRole (vmObj) {

		vmObj.updateRoleModalOptions.isOpen = false;

		setPageState('loading');

		base.updatePermissionRoleDetail(agencyProfileId, vmObj.activeRole).then(() => {

			vmObj.saveState = 'saved';

			$timeout(() => {
				init(vmObj.activeRole.RoleType);
			}, 2000);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		clearAllChanges,
		openUpdateRoleModal,
		openViewRoleForm,
		selectRole,
		updateRole,
	});
}]);


'use strict';

angular.module('paycircleApp')

.controller('settingsUpgradeCtrl', ['$filter', '$q', '$rootScope', '$scope', '$state', '$stateParams', 'companyData', 'payrollData', 'session', 'MANDATE_STATES', 'PAYMENT_STATES', function ($filter, $q, $rootScope, $scope, $state, $stateParams, companyData, payrollData, session, MANDATE_STATES, PAYMENT_STATES) {

	var agencyProfileId = $stateParams.agencyProfileId;

	function decorateCompany (companyObj) {

		companyObj.numberOfModules = 1; // User portal

		companyObj.numberOfModules = companyObj.Employer.IsCISActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;
		companyObj.numberOfModules = companyObj.Employer.IsPayrollActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;
		companyObj.numberOfModules = companyObj.Employer.IsPensionActive ? companyObj.numberOfModules + 1 : companyObj.numberOfModules;

		return companyObj;
	}

	function init () {

		setPageState('loading');

		var getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);
		var getCompanyDirectDebitMandate = payrollData.getCompanyDirectDebitMandate(agencyProfileId);
		var getNextBillingPayment = payrollData.getNextBillingPayment(agencyProfileId);

		$q.all([getAgencyProfileCompanyInformationDetailed, getCompanyDirectDebitMandate, getNextBillingPayment]).then(function (data) {

			var companyObj = data[0];
			var directDebitMandateObj = data[1];
			var nextPaymentObj = data[2];

			$scope.company = decorateCompany(companyObj);
			$scope.directDebitMandate = directDebitMandateObj;
			$scope.modules = [
				{
					Icon: 'pay-periods',
					IncludedInPlan: companyObj.Employer.IsPayrollActive,
					IsFree: true,
					Key: 'payroll',
					Theme: 'primary',
					Title: 'Payroll',
					Description: 'Manage payroll for your team - simple, cloud-based and collaborative, no previous payroll experience required!'
				},
				{
					Icon: 'money',
					IncludedInPlan: companyObj.Employer.IsPensionActive,
					IsFree: true,
					Key: 'pension',
					Theme: 'secondary',
					Title: 'Pension',
					Description: 'Connect your workplace pension to payroll or manage your workplace pension on its own - with no payroll connected'
				},
				{
					Icon: 'mobile',
					IncludedInPlan: true,
					IsFree: true,
					Key: 'user-portal',
					Theme: 'primary',
					Title: 'User Portal',
					Description: 'Your team’s own secure portal to view their payslips and other pay related info online'
				},
				{
					Icon: 'cis',
					IncludedInPlan: companyObj.Employer.IsCISActive,
					IsFree: true,
					Key: 'cis',
					Theme: 'tertiary',
					Title: 'CIS',
					Description: 'Construction Industry Scheme for contractors - manage payments to subcontractors'
				},
				{
					Icon: 'team-alt',
					IncludedInPlan: companyObj.Employer.IsHRActive,
					IsFree: true,
					Key: 'hr-lite',
					Theme: 'quarternary',
					Title: 'HR',
					Description: 'Manage and track your team\’s holidays and sick days plus more features coming soon!'
				}
			];
			$scope.nextPayment = nextPaymentObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function onDirectDebitCreation () {

		$state.go('settings.company.billing', {agencyProfileId: agencyProfileId});

		$scope.currentCompany.MandateState = 2;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.MANDATE_STATES = MANDATE_STATES;
	$scope.PAYMENT_STATES = PAYMENT_STATES;

	$scope.agencyProfileId = agencyProfileId;

	$scope.openDirectDebitForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onDirectDebitCreation,
			formKey: 'direct-debit'
		});
	};

	$scope.openModulesForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-modules'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsWorkPatternsCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'companyData',
	'payrollData',
	'workPatternService',
	'WORK_PATTERN_GROUPS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$stateParams,
		companyData,
		payrollData,
		workPatternService,
		WORK_PATTERN_GROUPS
	) {

	const agencyProfileId = $stateParams.agencyProfileId;

	function init () {

		setPageState('loading');

		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getWorkPatterns = companyData.getWorkPatternsForAgency(agencyProfileId);

		$q.all([getWorkPatterns, getPayPeriodCurrent]).then((dataArr) => {

			const companyWorkPatternsArr = dataArr[0];
			const currentPayPeriodObj = dataArr[1];

			if (!workPatternService.isWorkPatternsApplicable(currentPayPeriodObj)) {
				setFeatureState('not-applicable');
				setPageState('ready');
				return;
			}

			if (!companyWorkPatternsArr.length) {
				setFeatureState('not-active');
				setPageState('ready');
				return;
			}

			const workPatternsStandardArr = $filter('filter')(companyWorkPatternsArr, {Group: WORK_PATTERN_GROUPS.standard});
			const workPatternsNonStandardArr = $filter('filter')(companyWorkPatternsArr, {Group: WORK_PATTERN_GROUPS.nonStandard});

			$scope.vm = {
				canDeleteWorkPatternsNonStandard: workPatternsNonStandardArr.length > 1,
				canDeleteWorkPatternsStandard: workPatternsStandardArr.length > 1,
				workPatternsStandard: workPatternsStandardArr,
				workPatternsNonStandard: workPatternsNonStandardArr
			};

			setFeatureState('active');
			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function openWorkPatternForm (workPatternObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'work-pattern',
			title: workPatternObj !== undefined ? 'Edit work pattern' : 'New work pattern',
			workPatternId: workPatternObj !== undefined ? workPatternObj.WorkPatternID : undefined
		});
	}

	function setFeatureState (featureState) {

		$scope.featureState = featureState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		WORK_PATTERN_GROUPS,
		agencyProfileId,
		init,
		openWorkPatternForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('settingsWorkflowCtrl', ['$q', '$rootScope', '$scope', '$stateParams', 'bulkService', 'config', 'filterService', 'messageData', 'payrollData', 'searchService', 'session', 'INTERFACE_TYPES', 'WORKFLOW_TEMPLATE_ENTRY_STATES', 'WORKFLOW_TEMPLATE_STATES', function ($q, $rootScope, $scope, $stateParams, bulkService, config, filterService, messageData, payrollData, searchService, session, INTERFACE_TYPES, WORKFLOW_TEMPLATE_ENTRY_STATES, WORKFLOW_TEMPLATE_STATES) {

	const agencyProfileId = $stateParams.agencyProfileId;

	let currentCompanyObj = $scope.currentCompany;

	function decorateWorkflowTemplate (workflowTemplateObj) {

		let previousTemplateEntryObj = null;
		workflowTemplateObj.TemplateEntries.forEach((templateEntryObj) => {

			templateEntryObj = decorateTemplateEntry(templateEntryObj, previousTemplateEntryObj);
			previousTemplateEntryObj = templateEntryObj;
		});

		return workflowTemplateObj;
	}

	function decorateTemplateEntry (templateEntryObj, previousTemplateEntryObj) {

		angular.extend(templateEntryObj, {
			hasActioner: templateEntryObj.ActionerID !== config.guidEmpty,
			hasAuthoriser: templateEntryObj.AuthoriserID !== config.guidEmpty,
			hasDueDate: hasDueDate(templateEntryObj),
			dueDateValid: isDueDateValid(templateEntryObj, previousTemplateEntryObj),
			icon: getIconForTemplateEntryState(templateEntryObj),
			theme: getThemeForTemplateEntryState(templateEntryObj)
		});

		// Validate step 1 date based on step 2 validity comparison
		if(templateEntryObj.Number === 2 && templateEntryObj.dueDateValid) {
			angular.extend(previousTemplateEntryObj, {
				dueDateValid: true,
				theme: getThemeForTemplateEntryState(previousTemplateEntryObj),
				icon: getIconForTemplateEntryState(previousTemplateEntryObj)
			});
		}

		// Highlight missing/invalid due date
		if(!templateEntryObj.dueDateValid) {
			templateEntryObj.theme = 'is-assertive';
			templateEntryObj.icon = 'icon-warning';
		}

		return templateEntryObj;
	}

	function isDueDateValid (templateEntryObj, previousTemplateEntryObj) {

		// If first step, always valid if there is a due date
		if (previousTemplateEntryObj === null) {
			return hasDueDate(templateEntryObj);
		}

		// If due date was set correcly, but was moved because its falling on a weekend
		if (templateEntryObj.DueDays !== templateEntryObj.DueDaysConstant) {
			return true;
		}

		return moment(templateEntryObj.DueDateISO).isAfter(previousTemplateEntryObj.DueDateISO);
	}

	function hasDueDate (templateEntryObj) {
		return templateEntryObj.DueDaysConstant > 0 || templateEntryObj.DueTimeHour > 0 || templateEntryObj.DueTimeMinutes > 0;
	}

	function getThemeForTemplateEntryState (templateEntryObj) {

		switch (templateEntryObj.State) {
			case WORKFLOW_TEMPLATE_ENTRY_STATES.inactive:
				return 'is-assertive';
			case WORKFLOW_TEMPLATE_ENTRY_STATES.active:
			case WORKFLOW_TEMPLATE_ENTRY_STATES.complete:
			case WORKFLOW_TEMPLATE_ENTRY_STATES.current:
				return 'is-primary';
		}
	}

	function getIconForTemplateEntryState (templateEntryObj) {

		switch (templateEntryObj.State) {
			case WORKFLOW_TEMPLATE_ENTRY_STATES.inactive:
				return 'icon-warning';
			case WORKFLOW_TEMPLATE_ENTRY_STATES.active:
			case WORKFLOW_TEMPLATE_ENTRY_STATES.complete:
			case WORKFLOW_TEMPLATE_ENTRY_STATES.current:
				return 'icon-workflow-alt';
		}
	}

	function init () {

		// Reset current company on init for form callback
		currentCompanyObj = $scope.currentCompany;

		if (currentCompanyObj.IsWorkflowEnabled) {

			loadWorkflow();
		}
	}

	function loadWorkflow () {

		setPageState('loading');

		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);
		const getWorkflowTemplates = messageData.getWorkflowTemplates(agencyProfileId);

		$q.all([getWorkflowTemplates, getPayPeriodMinimum]).then((data) => {

			const workflowTemplatesArr = data[0];
			const payPeriodObj = data[1];

			let vmObj = {
				payPeriod: payPeriodObj
			};

			if (currentCompanyObj.IsWorkflowEnabled && workflowTemplatesArr.length) {
				let workflowTemplate = decorateWorkflowTemplate(workflowTemplatesArr[0]);
				angular.extend(vmObj, {
					workflowTemplate: workflowTemplate,
					dueDateSetupComplete: workflowTemplate.TemplateEntries.every(e => e.dueDateValid === true)
				});
			}

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function openCompanySettingsWorkflowForm (workflowTemplateObj, formOptionsObj) {

		const defaultFormOptionsObj = {
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-workflow',
			workflowTemplate: workflowTemplateObj,
		};

		$rootScope.openSlideInForm(angular.extend(defaultFormOptionsObj, formOptionsObj));
	}

	function openEnableWorkflowForm (workflowTemplateObj) {

		openCompanySettingsWorkflowForm(workflowTemplateObj, {
			title: 'Enable workflow'
		});
	}

	function openStartWorkflowForm (workflowTemplateObj) {

		openCompanySettingsWorkflowForm(workflowTemplateObj, {
			title: 'Start workflow',
			workflowAction: 'start-workflow'
		});
	}

	function openDisableWorkflowForm (workflowTemplateObj) {

		openCompanySettingsWorkflowForm(workflowTemplateObj, {
			availableWhenCompanyPAYESchemeCeased: true,
			title: 'Disable workflow',
			workflowAction: 'disable-workflow'
		});
	}

	function openStopWorkflowForm (workflowTemplateObj) {

		openCompanySettingsWorkflowForm(workflowTemplateObj, {
			availableWhenCompanyPAYESchemeCeased: true,
			title: 'Stop workflow',
			workflowAction: 'stop-workflow'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		WORKFLOW_TEMPLATE_STATES,
		openCompanySettingsWorkflowForm,
		openDisableWorkflowForm,
		openEnableWorkflowForm,
		openStartWorkflowForm,
		openStopWorkflowForm,
		refreshPage: loadWorkflow
	});
}]);

'use strict';

/**
 * @ngdoc #Name#
 * @name paycircleApp
 * @description #Description#
 * # paycircleApp
 *
 * Main module of the application.
 */
angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/user-importer/';

	$stateProvider

	.state('user-importer', {
		url: '/user-importer/{agencyProfileId}&from',
		templateUrl: directory + 'userImporterView.html',
		controller: 'userImporterCtrl',
		/*
		resolve: {
			auth: ['AuthResolverCompany', function resolveAuthentication (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		*/
		data: {
		    fullPage: true,
		    title: 'User Importer'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('userImporterCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$stateParams',
	'$timeout',
	'addressService',
	'agency',
	'dataImport',
	'dataTransfer',
	'growl',
	'importService',
	'libraries',
	'payrollData',
	'payrollWorker',
	'postcodeLookup',
	'DOCUMENT_TYPE_IDS',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'VALIDATION_FIELD_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$stateParams,
		$timeout,
		addressService,
		agency,
		dataImport,
		dataTransfer,
		growl,
		importService,
		libraries,
		payrollData,
		payrollWorker,
		postcodeLookup,
		DOCUMENT_TYPE_IDS,
		STATE_TYPES,
		SUBMISSION_STATES,
		VALIDATION_FIELD_TYPES
	) {

	var agencyProfileId 					= $stateParams.agencyProfileId;
	var currentIndex 						= 0;
	var currentResultNumber 				= 0;
	var numberOfValidationResults 			= 0;
	var options = {
		addressLookupVisible: false,
		addressSearchString: '',
		delay: 3000,
		doNotAskAgain: false,
		isWorkerInfoVisible: false,
		showAddressResult: false
	};
	var timerId;
	var workerPriorityFilter = 'basic';

	function checkDataImportState (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		agency.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.dataimport).then(function (updatedDataImportState) {

			// Update scope
			payPeriod.DataImportState = updatedDataImportState;

			switch (updatedDataImportState) {
				case SUBMISSION_STATES.submitting:

					timerId = $timeout(function () {
						checkDataImportState(payPeriod);
					}, options.delay);

					return;

				case SUBMISSION_STATES.failed:

					growl.error('There was a problem importing the shifts');

					break;
			}

			// Scope
			$scope.pageState = 'ready';
		});
	}

	function checkWorkerImportState (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		// Unsubmitted - Start importer
		if (payPeriod.WorkerImportState === SUBMISSION_STATES.unsubmitted) {

			// Page state
			$scope.pageState = 'ready';

			// Update progress indicator
			setProgressIndicator(payPeriod);

			return;
		}

		// Check pay period state
		agency.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.workerimport).then(function (workerImportState) {

			// Update pay period
			payPeriod.WorkerImportState = workerImportState;

			// Update progress indicator
			setProgressIndicator(payPeriod);

			// Hide worker info
			$scope.options.isWorkerInfoVisible = false;

			switch (workerImportState) {

				// If import has errors then we get those errors and stop checking the status
				case SUBMISSION_STATES.haserrors1:
				case SUBMISSION_STATES.haserrors2:
				case SUBMISSION_STATES.verified:

					loadValidationResults(payPeriod);

					// Reset uploader progress state
					$scope.uploadingProgress = 0;

					return;

				// Processing or Submitted
				case SUBMISSION_STATES.submitting:
				case SUBMISSION_STATES.processing1:
				case SUBMISSION_STATES.processing2:

					timerId = $timeout(function () {
						checkWorkerImportState(payPeriod);
					}, options.delay);

					return;

				// Finished
				case SUBMISSION_STATES.finished:

					checkDataImportState(payPeriod);

					return;
			}

			setupActionButtons(workerImportState);

			// Scope
			$scope.pageState = 'ready';
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	}

	function goToNext (validationResults, payPeriod, validationForm) {

		$scope.animationStep = 'fadeOutLeft';

		// Validate import on last result
		if (isLastResult()) {
			validateUserImport(payPeriod);

			// Reset animation step
			$scope.animationStep = '';
			return;
		}

		// Increase index
		currentIndex++;

		// Update current index
		updateCurrentIndex(currentIndex);

		// Timeout to allow animation to complete
		$timeout(function () {

			// Select next result
			setupValidationResult(validationResults);

			// Update animation step
			$scope.animationStep = 'fadeInRight';

			// Reset form state
			if (validationForm !== undefined) {
				validationForm.$setPristine();
			}

		}, 300);
	}

	function goToPrevious (validationResults, validationForm) {

		// Do nothing if first result
		if (isFirstResult()) {
			return;
		}

		// Show previous worker
		currentIndex--;

		// Update current index
		updateCurrentIndex(currentIndex);

		$scope.animationStep = 'fadeOutRight';

		$timeout(function () {

			// Select previous result
			setupValidationResult(validationResults);

			$scope.animationStep = 'fadeInLeft';

			$scope.options.addressLookupVisible = false;
			$scope.selectedAddress = null;

			// Reset form state
			if (validationForm !== undefined) {
				validationForm.$setPristine();
			}

		}, 300);
	}

	function importData (payPeriod) {

		// Set to processing
		payPeriod.WorkerImportState = SUBMISSION_STATES.processing2;

		// Actually update the pay period state on the server
		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriod.PayPeriodID, SUBMISSION_STATES.processing2).then(function () {

			// Kick start the actual import
			payrollWorker.payrollStartWorkerImport(agencyProfileId, payPeriod.PayPeriodID);

			// Kick off polling for state, after a short delay
			timerId = $timeout(function () {
				checkWorkerImportState(payPeriod);
			}, options.delay);
		})
		.catch(function () {
			growl.error('We were unable to change the status of the import.');
		});
	}

	function init () {

		$scope.pageState = 'loading';

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setupActionButtons(currentPayPeriodObj.WorkerImportState);
			setupImporter(currentPayPeriodObj);
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	function isFirstResult () {

		return currentResultNumber === 1;
	}

	function isLastResult () {

		return currentResultNumber === numberOfValidationResults;
	}

	function loadValidationResults (payPeriod) {

		// Reset current index
		resetCurrentIndex();

		var getNumberOfUserImportsByOwner 	= dataImport.getNumberOfUserImportsByOwner(payPeriod.PayPeriodID);
		var getUserImportValidationResults 	= dataImport.getUserImportValidationResults(payPeriod.PayPeriodID);

		$q.all([getUserImportValidationResults, getNumberOfUserImportsByOwner]).then(function (data) {

			var invalidWorkers 	= data[0];
			var totalWorkers 	= data[1];

			// Re-map Invalid Workers array into results array
			var validationResults 					= importService.getValidationResults(invalidWorkers);
			var validationResultsPropertyNames 		= importService.getValidationResultsPropertyNamesVisible(validationResults);

			// Scope
			$scope.validationResults 				= validationResults;
			$scope.validationResult 				= $scope.validationResults[currentIndex];
			$scope.validationResultsPropertyNames 	= validationResultsPropertyNames;
			$scope.numberOfWorkers 					= totalWorkers;
			$scope.numberOfValidationResults 		= validationResults.length;
			$scope.numberOfSkippedResults 			= importService.getNumberOfSkippedResults(validationResults);
			$scope.numberOfNewStarters 				= importService.getNumberOfNewStarters(validationResults);

			// Update local variable
			numberOfValidationResults = validationResults.length;

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	function resetCurrentIndex () {

		updateCurrentIndex(0);
	}

	function resetImporter (payPeriod) {

		// Reset importer state
		payPeriod.WorkerImportState = 0;

		// Reset progress
		payPeriod.progress = 0;

		// Reset uploader progress state
		$scope.uploadingProgress = 0;
	}

	function setProgressIndicator (payPeriod) {

		var progress = 0;

		// Uploaded file
		if (payPeriod.WorkerImportState >= SUBMISSION_STATES.unsubmitted) {
			progress = 1;
		}

		// File passed
		if (payPeriod.WorkerImportState >= SUBMISSION_STATES.haserrors1) {
			progress = 2;
		}

		// Verified
		if (payPeriod.WorkerImportState >= SUBMISSION_STATES.verified) {
			progress = 3;
		}

		// Finished
		if (payPeriod.WorkerImportState >= SUBMISSION_STATES.finished) {
			progress = 4;
		}

		// Scope
		$scope.progress = progress;
	}

	function setupActionButtons (workerImportState) {

		switch (workerImportState) {

			// If import has errors then we get those errors and stop checking the status
			case SUBMISSION_STATES.haserrors1:
			case SUBMISSION_STATES.haserrors2:
			case SUBMISSION_STATES.verified:

				$scope.canCancelImport = true;
				$scope.canCloseImport = true;

				break;

			// Processing or Submitted
			case SUBMISSION_STATES.submitting:
			case SUBMISSION_STATES.processing1:
			case SUBMISSION_STATES.processing2:
			case SUBMISSION_STATES.finished:

				$scope.canCancelImport = false;
				$scope.canCloseImport = false;

				break;

			default:

				$scope.canCancelImport = false;
				$scope.canCloseImport = true;
		}

	}

	function setupImporter (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		// Set up the uploader for the import
		var uploader = $scope.uploader = dataTransfer.getNewFileUploader({
			formData: [{
				agencyPayPeriodID: payPeriodId,
				agencyProfileID: agencyProfileId,
				documentTypeID: DOCUMENT_TYPE_IDS.workerImport
			}],
			url: libraries.httpHandler.upload.importFile,
			queueLimit: 1,
			onProgressItem: function (fileItem, progress) {

				payPeriod.WorkerImportState = SUBMISSION_STATES.submitting;

				// Scope
				$scope.uploadFilename = fileItem.file.name;
				$timeout(function () {
					$scope.uploadingProgress = progress;
				}, 500);
			},
			onCompleteAll: function () {

				dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriodId, SUBMISSION_STATES.submitted).then(function () {

					// Trigger worker import
					payrollWorker.payrollStartWorkerImport(agencyProfileId, payPeriodId);

					timerId = $timeout(function () {
						checkWorkerImportState(payPeriod);
					}, options.delay);
				})
				.catch(function () {
					growl.error('We were unable to change the status of the import.');
				});
			}
		});

		function validateFile (fileContents) {

			var parsedFileRows 			= importService.parseToRowsAndCols(fileContents);
			var parsedFileColumnTitles 	= parsedFileRows[0];
			var numberOfColumns 		= parsedFileColumnTitles.cols.length;
			var i 						= 1; // Start after title row
			var responseObject = {
				valid: true,
				errorMessage: null
			};

			for (i; i < parsedFileColumnTitles.length; i++) {

				var workerRow = parsedFileRows[i];
				var workerName = workerRow.cols[4].text;
				var workerColumnsLength = workerRow.cols.length;

				if (workerColumnsLength !== numberOfColumns) {

					// Why is this valid?
					if (workerColumnsLength === 0) {
						continue;
					}
					else if (workerColumnsLength > 4) {
						responseObject.errorMessage = 'There is a problem for worker named ' + workerName + ', the row has the wrong number of columns. Please correct and try again. Row[' + (i + 1) + ']';
					}
					else {
						$scope.parseFileErrorMessage = 'There is a problem with the import file, row ' + (i + 1) + ' contains the wrong number of columns.';
					}

					// Set invalid
					responseObject.valid = false;

					$scope.$applyAsync();

					return responseObject;
				}

			}

			return responseObject;
		}

		// Validate file type is .csv
		uploader.filters.push({
			name: 'validateFileType',
			fn: function (fileItem) {

				if (fileItem.name.toLowerCase().indexOf('.csv') !== -1) {
					return true;
				}

				payPeriod.WorkerImportState = -1;

				return false;
			}
		});

		// When user selects a file, the uploader runs through this filter and here we verify that it has the right number of columns
		uploader.filters.push({
			name: 'filterNumberOfColumns',
			fn: function (item) {

				var reader = new FileReader();

				reader.onloadend = function (e) {

					var isFileValid = validateFile(e.target.result);

					if (isFileValid.valid) {

						dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriodId, SUBMISSION_STATES.submitting).then(function () {

							uploader.uploadAll();

							timerId = $timeout(function () {
								checkWorkerImportState(payPeriod);
							}, options.delay);
						})
						.catch(function () {
							growl.error('We were unable to change the status of the import.');
						});
					}

					else {
						uploader.clearQueue();
					}
				};

				reader.readAsText(item);

				return true;
			}
		});

		// Check worker import state
		checkWorkerImportState(payPeriod);
	}

	function setupValidationResult (validationResults) {

		$scope.validationResult = validationResults[currentIndex];
	}

	function toggleModal (modalName) {

		$scope.modal[modalName] = !$scope.modal[modalName];
	}

	function changeShowWorkerInfo (value) {

		if (value !== undefined) {
			$scope.options.isWorkerInfoVisible = value;
			return;
		}

		$scope.options.isWorkerInfoVisible = !$scope.options.isWorkerInfoVisible;
	}

	function updateCurrentIndex (value) {

		// Var
		currentIndex 		= value;
		currentResultNumber = value + 1;

		// Scope
		$scope.currentIndex 		= value;
		$scope.currentResultNumber 	= value + 1;
	}

	function updateValidationResultIgnore (validationResult, validationResults, payPeriod, validationForm) {

		validationResult.ValidationResultIgnore = !validationResult.ValidationResultIgnore;

		dataImport.updateValidationResultIgnore(validationResult.ValidationResultID, validationResult.ValidationResultIgnore).then(function () {

			$scope.modal.skipWorker = false;

			goToNext(validationResults, payPeriod, validationForm);
		});
	}

	function validateUserImport (payPeriod) {

		// Update scope
		payPeriod.WorkerImportState = SUBMISSION_STATES.processing1;

		// Set import state to processing1, validate and poll for state changes
		dataImport.updateAgencyPayPeriodImportWorkerStatus(payPeriod.PayPeriodID, SUBMISSION_STATES.processing1).then(function () {

			dataImport.validateUserImport(payPeriod.PayPeriodID).finally(function () {

				checkWorkerImportState(payPeriod);
			});
		})
		.catch(function () {
			growl.error('We were unable to change the status of the import.');
		});
	}

	init();

	// Scope constants
	$scope.SUBMISSION_STATES 		= SUBMISSION_STATES;
	$scope.VALIDATION_FIELD_TYPES 	= VALIDATION_FIELD_TYPES;

	// Scope variables
	$scope.addresses = [];
	$scope.addressFormFadeOut = false;
	$scope.addressLookupFailed = false;
	$scope.loadingAddresses = false;
	$scope.noAddressesFound = false;

	$scope.agencyProfileId 				= agencyProfileId;
	$scope.animationStep 				= null;
	$scope.canCancelImport 				= true;
	$scope.canCloseImport 				= true;
	$scope.currentIndex 				= currentIndex;
	$scope.currentResultNumber 			= currentIndex + 1;
	$scope.modal = {
		skipWorker: false,
	};
	$scope.numberOfNewStarters 			= 0;
	$scope.numberOfSkippedResults 		= 0;
	$scope.numberOfValidationResults 	= 0;
	$scope.options 						= options;
	$scope.uploadingProgress 			= 0;
	$scope.reload 						= false;
	$scope.selectedAddress 				= null;
	$scope.status 						= status;
	$scope.uploader 					= null;
	$scope.validationResult 			= null;
	$scope.workerPriorityFilter 		= workerPriorityFilter;

	// Scope functions
	$scope.changeWorkerPriorityFilter = function (filterName) {

		$scope.workerPriorityFilter = filterName;
	};

	$scope.goToNext = function (validationResults, payPeriod, validationForm) {

		goToNext(validationResults, payPeriod, validationForm);
	};

	$scope.goToPrevious = function (animationStep, validationForm) {

		goToPrevious(animationStep, validationForm);
	};

	$scope.importData = function (payPeriod) {

		importData(payPeriod);
	};

	$scope.lookupAddress = function () {

		var query = $scope.options.addressSearchString;

		if (query.length > 4) {

			$scope.loadingAddresses = true;
			$scope.addressLookupFailed = false;

			postcodeLookup.autoCompleteAddress(query).then(addressResults => {

				$scope.addresses = addressResults;
				$scope.options.showAddressResult = true;
				$scope.loadingAddresses = false;

				if ($scope.addresses.length === 0) {
					$scope.noAddressesFound = true;
				}
				else {
					$scope.noAddressesFound = false;
				}
			})
			.catch(function () {
				$scope.addressLookupFailed = true;
			})
			.finally(function () {
				$scope.loadingAddresses = false;
			});
		} else {
			$scope.options.showAddressResult = false;
		}
	};

	$scope.openCancelImportForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'cancel-user-import'
		});
	};

	$scope.resetImporter = function (payPeriod) {

		resetImporter(payPeriod);
	};

	$scope.selectAddress = function (validationResult, lookupAddressHitObj) {

		postcodeLookup.getAddressFromUrlPath(lookupAddressHitObj.urlPath).then(lookupAddressObj => {

			$scope.selectedAddress = lookupAddressObj;
			$scope.options.showAddressResult = false;
		});
	};

	$scope.skipEntry = function (validationResult, validationResults, payPeriod, validationForm, options) {

		// Serious errors cannot be skipped
		if (validationResult.ValidationType.ValidationTypeLevel === 1) {
			return;
		}

		// Do not ask again
		if (!options.doNotAskAgain && !validationResult.ValidationResultIgnore) {
			toggleModal('skipWorker');
			return;
		}

		updateValidationResultIgnore(validationResult, validationResults, payPeriod, validationForm);

		validationForm.$setPristine();
	};

	$scope.toggleAddressLookup = function (validationResult, validationForm) {

		$scope.options.addressSearchString = '';

		if (validationResult.addressLookupVisible) {

			// Hide address lookup
			validationResult.addressLookupVisible = false;

			// Reset address
			$scope.selectedAddress = null;

			// Reset form
			if (validationForm !== undefined) {
				validationForm.$setPristine();
			}
		}
		else {

			// Show address lookup
			validationResult.addressLookupVisible = true;
		}
	};

	$scope.toggleEditMode = function (validationResult, propertyName) {

		if ($rootScope.userHasRole('paycircle')) {
			validationResult.editMode = propertyName;
		}
	};

	$scope.toggleModal = function (modalName) {

		toggleModal(modalName);
	};

	$scope.changeShowWorkerInfo = function (value) {

		changeShowWorkerInfo(value);
	};

	$scope.toggleShowAddressLookup = function (validationResult) {

		validationResult.isAddressLookupVisible = !validationResult.isAddressLookupVisible;
	};

	$scope.updateUserInImport = function (validationResult, validationResults, payPeriod, validationForm) {

		validationResult.state = 'saving';

		dataImport.updateUserInImport(agencyProfileId, validationResult.worker, validationResult.ValidationResultID).then(function () {

			// Update states
			validationResult.state = 'saved';

			// Set flag to show as 'updated'
			validationResult.isUpdated = true;

			// Give user time to digest update
			$timeout(function () {

				// Hide worker info
				changeShowWorkerInfo(false);

				// Wait for worker card to close
				$timeout(function () {

					// Go to next state
					goToNext(validationResults, payPeriod, validationForm);

					// Reset button state for next card
					validationResult.state = null;
				}, 500);

			}, 500);
		})
		.catch(function () {

			validationResult.state = null;

			growl.error('Could not update record.');
		});
	};

	$scope.updateFullWorker = function (validationResult, validationResults, payPeriod, validationForm) {

		validationResult.state = 'saving';

		dataImport.updateUserInImport(agencyProfileId, validationResult.worker, validationResult.ValidationResultID).then(function () {

			validationResult.state = 'saved';

			goToNext(validationResults, payPeriod, validationForm);

			$timeout(function () {
				validationResult.state = null;
			}, 1000);
		})
		.catch(function () {

			validationResult.state = null;

			growl.error('Could not update record.');
		});
	};

	$scope.updateValidationResultIgnore = function (validationResult, validationResults, payPeriod, validationForm) {

		updateValidationResultIgnore(validationResult, validationResults, payPeriod, validationForm);
	};

	$scope.useSelectedAddress = function (validationResult, selectedLookupAddress) {

		const userImportAddressObj = addressService.convertPostcodeLookupAddressToPaycircleAddressForUserImport(selectedLookupAddress);

		angular.extend(validationResult.worker, userImportAddressObj);

		changeShowWorkerInfo(false);
	};

	$scope.validateUserImport = function (payPeriod) {

		validateUserImport(payPeriod);
	};

	$scope.$on('$destroy', function () {
		$timeout.cancel(timerId);
	});
}]);

'use strict';

/**
 * @ngdoc Auto Enrolment
 * @name paycircleApp
 * @description Auto Enrolment Config
 * # paycircleApp
 *
 * Main module of the application.
 */
angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/document-preview/';
	$stateProvider

	.state('document-preview', {
		url: '/document-preview/:agencyProfileId/:agencyEmployerPensionId/:mailtypeid?',
		templateUrl: directory + 'documentPreviewView.html',
		controller: 'documentPreviewCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
		    fullPage: true,
		    title: 'Document Preview'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('documentPreviewCtrl', ['$scope', '$stateParams', 'growl', 'pensionData', 'utilities', 'MAIL_TYPES',
	function ($scope, $stateParams, growl, pensionData, utilities, MAIL_TYPES) {

	const agencyProfileId = $stateParams.agencyProfileId;
	const agencyEmployerPensionId = $stateParams.agencyEmployerPensionId;
	const mailTypeId = $stateParams.mailtypeid;

	function init () {

		setPageState('loading');

		if (angular.isUndefined(mailTypeId)) {
			onError('We cannot load this document. Please go back and try again.');
			return;
		}

		pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId).then(pensionObj => {

			$scope.vm = {
				pensionStaging: pensionObj.PensionStagingDetails,
			};

			setPageState('ready');
		})
		.catch(() => {
			onError('We were unable to load some information needed for this page. Please refresh and try again.');
		});
	}

	function onError (error) {
		growl.error(error);
		console.error(error);
		setPageState('error');
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope,  {
		MAIL_TYPES,
		mailTypeId,

		goBack: utilities.goBack,
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/email-preview/';
	$stateProvider

	.state('email-preview', {
		url: '/email-preview/:agencyProfileId/:previewType/:mailtypeid?maillogkey&userid',
		templateUrl: directory + 'emailPreviewView.html',
		controller: 'emailPreviewCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
			contextType: 'company',
		    fullPage: true,
		    title: 'Email Preview'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
	.controller('emailPreviewCtrl', ['$q', '$scope', '$stateParams', '$timeout', '$window', 'config', 'growl', 'mailData', 'utilities', 'EMAIL_PREVIEW_TYPES', function ($q, $scope, $stateParams, $timeout, $window, config, growl, mailData, utilities, EMAIL_PREVIEW_TYPES) {

		const agencyProfileId = $stateParams.agencyProfileId;
		const mailTypeId = $stateParams.mailtypeid;
		const userId = $stateParams.userid;
		const previewType = $stateParams.previewType || EMAIL_PREVIEW_TYPES.standard;

		function getUserIDArray (teamMembers) {

			let userArray = [];

			angular.forEach(teamMembers, function (teamMember) {
				this.push(teamMember.UserID);
			}, userArray);

			return userArray;
		}

		function init () {

			// No mail template ID provided
			if (mailTypeId === undefined) {
				growl.error('We cannot load this email template. Please go back and try again.');
				return;
			}

			$scope.isLoading = true;

			const getMailLogSummariesForAgency = mailData.getMailLogSummariesForAgency(agencyProfileId);
			const getMailTemplateForMailType = mailData.getMailTemplateForMailType(mailTypeId);

			$q.all([getMailLogSummariesForAgency, getMailTemplateForMailType]).then(function(data) {

				let teamMembers		= data[0];
				let mailTemplate 	= data[1];

				// Send to individual
				if (userId !== undefined) {

					for (let i = 0; i < teamMembers.length; i++) {

						if (teamMembers[i].UserID === userId) {
							let teamMember = teamMembers[i];
							teamMembers = [];
							teamMembers.push(teamMember);
							break;
						}
					}
				}

				$scope.mailTemplate = mailTemplate;
				$scope.teamMembers 	= teamMembers;

				$timeout(() => {

					var iframe = document.getElementById('email-html').contentWindow.document;

					iframe.write(mailTemplate.MailTemplateBody);
					iframe.close();
				});
			})
				.catch(function (error) {
					console.error(error);
					growl.error('We were unable to load some information needed for this page. Please refresh and try again.');
				})
				.finally(function () {
					$scope.isLoading = false;
				});
		}

		function toggleModal (name) {

			$scope.modal[name] = !$scope.modal[name];
		}

		// Scope constants
		$scope.EMAIL_PREVIEW_TYPES  = EMAIL_PREVIEW_TYPES;

		// Scope variables
		$scope.agencyProfileId 		= agencyProfileId;
		$scope.context 				= userId !== undefined ? 'individual' : 'company';
		$scope.mailTypeId 			= mailTypeId;
		$scope.openConfirmation  	= false;
		$scope.previewType          = previewType;
		$scope.sendingState 		= '';

		// Scope functions
		$scope.goBack = utilities.goBack;

		$scope.sendMail = function (teamMembers) {

			$scope.sendingState = 'sending';

			let userIDArray = getUserIDArray(teamMembers);

			mailData.sendMailTemplateForMailType(mailTypeId, userIDArray, agencyProfileId).then(function () {

				$scope.sendingState = 'sent';

				// Send to individual
				if (teamMembers.length === 1) {
					growl.success('This email has been sent to ' + teamMembers[0].Forename);
				}

				// Send to team
				else {
					growl.success('This email has been sent');
				}

				toggleModal('sendEmail');
			})
				.catch(function () {
					$scope.sendingState = '';

					growl.error('There was a problem sending this email. Try again or get in touch');
				});
		};

		$scope.showConfirmation = function () {

			$scope.openConfirmation = !$scope.openConfirmation;
		};

		$scope.toggleModal = function (name) {

			toggleModal(name);
		};

		$scope.print = function(){
			document.getElementById('email-html').contentWindow.print();
		};

		init();

	}]);

'use strict';

/**
 * @ngdoc Auto Enrolment
 * @name paycircleApp
 * @description Auto Enrolment Config
 * # paycircleApp
 *
 * Main module of the application.
 */
angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	var directory = 'features/app/sent-mail/';
	$stateProvider

	.state('sent-mail', {
		url: '/sent-mail/:agencyProfileId/:maillogkey',
		templateUrl: directory + 'sentMailView.html',
		controller: 'sentMailCtrl',
		resolve: {
			auth: ['AuthResolverCompany', function (AuthResolverCompany) {
				return AuthResolverCompany.resolve();
			}]
		},
		data: {
		    fullPage: true,
		    title: 'Sent Mail'
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.controller('sentMailCtrl', ['$scope', '$stateParams', '$timeout', 'config', 'growl', 'mailData', 'utilities',
	function ($scope, $stateParams, $timeout, config, growl, mailData, utilities) {

	const mailLogKey = $stateParams.maillogkey;

	function init () {

		$scope.isLoading = true;

		mailData.getMailLog(mailLogKey).then(emailObj => {

			$scope.email = emailObj;

			$timeout(() => {

				const iframe = document.getElementById('email-html').contentWindow.document;

				iframe.write(emailObj.MailBody);
				iframe.close();
			});

		 	$scope.isLoading = false;
		})
		.catch(() => {
			growl.error('We were unable to load the email');
		});
	}

	function showConfirmation () {
		$scope.openMoreInfo = !$scope.openMoreInfo;
	}

	init();

	angular.extend($scope, {
		openMoreInfo: false,
		goBack: utilities.goBack,
		showConfirmation
	});
}]);

'use strict';

angular.module('paycircleApp')
.config(['$stateProvider', function ($stateProvider) {

	const directory = 'features/app/identity/';
	
	$stateProvider
	.state('identity-signin-oidc', {
		url: '/identity/signin-oidc?code&state',
		name: 'Paycircle',
		templateUrl: directory + 'identity.view.html',
		controller: 'identitySigninOidcCtrl',
		data: {
			isPublic: true,
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	})
	.state('identity-signout-callback-oidc', {
		url: '/identity/signout-callback-oidc',
		name: 'Paycircle',
		templateUrl: directory + 'identity.view.html',
		controller: 'identitySignoutCallbackOidcCtrl',
		data: {
			isPublic: true,
		},
		resolve: {
			auth: ['CustomisationResolver', CustomisationResolver => {
				return CustomisationResolver.resolve();
			}]
		}
	})	
	.state('identity-link-identity-account-to-user-profile-oidc', {
		url: '/identity/link-identity-account-to-user-profile-oidc?code&state',
		name: 'Paycircle',
		templateUrl: directory + 'identity.view.html',
		controller: 'identityLinkAccountAndSignInCallbackOidcCtrl',
		data: {
			isPublic: true,
		}
	});
}]);

'use strict';

angular.module('paycircleApp')

.controller('identitySignoutCallbackOidcCtrl', [
	'$state',
	function (
		$state
	) {

	function init () {
		// Go to the login page
		$state.go('login');
	}
	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('identityLinkAccountAndSignInCallbackOidcCtrl', [
	'$rootScope',
	'$state',
	'securityData',
	'utilities',
	'authErrorLoggingService',
	'AUTH_EVENTS',
	'AUTH_ERRORS',
	'LOCAL_STORAGE_KEYS',
	function (
		$rootScope,
		$state,
		securityData,
		utilities,
		authErrorLoggingService,
		AUTH_EVENTS,
		AUTH_ERRORS,
		LOCAL_STORAGE_KEYS
	) {

	function init () {

		const authData = {
				Code: $state.params.code,
				State: $state.params.state,
				Nonce: utilities.getFromStorage(LOCAL_STORAGE_KEYS.nonce)
		};

		securityData.linkAccountToUserProfileAndSignIn(authData.Code, authData.State, authData.Nonce)
			.then(userObj => {
					// Authenticate
					$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, userObj, userObj.agencyProfileId, authData.Code);
			})
			.catch(error => {

				let dataObj = {};

				if (!error.data) {
					authErrorLoggingService.logAuthError('auth_oidc_link_account_missing_error_data', error, null, null, authData);
					dataObj = { signInErrorCode: null };
					$state.go('login', dataObj);
					return;
				}

				switch (error.data.Error) {
					case AUTH_ERRORS.impersonationNotSupported:
						dataObj = { impersonationErrorData: error.data };
						authErrorLoggingService.logAuthError('auth_oidc_link_account_impersonation_not_supported', error, null, null, authData);
						break;
					default:
						dataObj = { 
							signInErrorActiveSessionEmail: (error.data && error.data.Error === AUTH_ERRORS.accountNotLinkedToIdentity) ? error.data.ActiveSessionEmail : null,
							signInErrorCode: error.data ? error.data.Error : null,
							signInErrorIdentityUrl: error.data ? error.data.IdentityUrl : null
						};
						authErrorLoggingService.logAuthError('auth_oidc_link_account_sign_in_error', error, null, null, authData);
				}
		
				$state.go('login', dataObj);
			});
	}
	init();
}]);

'use strict';

angular.module('paycircleApp')

.controller('identitySigninOidcCtrl', [
	'$rootScope',
	'$state',
	'$window',
	'iframeDetectionService',
	'securityData',
	'securityService',
	'silentAuthService',
	'utilities',
	'authErrorLoggingService',
	'AUTH_EVENTS',
	'AUTH_ERRORS',
	'LOCAL_STORAGE_KEYS',
	function (
		$rootScope,
		$state,
		$window,
		iframeDetectionService,
		securityData,
		securityService,
		silentAuthService,
		utilities,
		authErrorLoggingService,
		AUTH_EVENTS,
		AUTH_ERRORS,
		LOCAL_STORAGE_KEYS
	) {

	function init () {

		const authData = {
			Code: $state.params.code,
			State: $state.params.state,
			Nonce: utilities.getFromStorage(LOCAL_STORAGE_KEYS.nonce)
		};

		securityData.signIn(authData.Code, authData.State, authData.Nonce)
			.then(userObj => {
				if (!securityService.isUserAllowedAccess(userObj)) {
					console.warn('Paycircle: User is not allowed access. They may have logged into the wrong identity account');
				
					const userContext = authErrorLoggingService.buildUserContext(userObj);
					authErrorLoggingService.logAuthError('auth_oidc_no_access', null, userContext, null, authData);
				
					throw new Error('no_access');
				}
				
				if (!iframeDetectionService.isRunningInIframe() && userObj.EvoWorkspaceUrl ) {
					$window.open(userObj.EvoWorkspaceUrl, '_self');
				}
				
				$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, userObj, userObj.agencyProfileId, authData.Code);
		}).catch(error => {

			if (error.message === 'no_access') {
				if (iframeDetectionService.isRunningInIframe()) {
					silentAuthService.requestReauthenticationFromParent(); 
				} else {
					$state.go('login', { identityNoAccess: true });
				}
				return;
			}
			let dataObj = {};

			if (!error.data) {
				authErrorLoggingService.logAuthError('auth_oidc_missing_error_data', error, null, null, authData);
				dataObj = { signInErrorCode: null };
				if (iframeDetectionService.isRunningInIframe()) {
					silentAuthService.requestReauthenticationFromParent(); 
				} else {
					$state.go('login', dataObj);
				}
				return;
			}

			switch (error.data.Error) {
				case AUTH_ERRORS.evoMigrationRequired:
					dataObj = { 
						isEvoMigrationRequired: true,
						evoMigrationUrl: error.data.IdentityUrl 
					};
					authErrorLoggingService.logAuthError('auth_oidc_evo_migration_required', error, null, { identityUrl: error.data.IdentityUrl }, authData);
					break;
				case AUTH_ERRORS.impersonationNotSupported:
					dataObj = { 
						signInErrorCode: AUTH_ERRORS.impersonationNotSupported,
						impersonationErrorData: error.data
					};
					authErrorLoggingService.logAuthError('auth_oidc_impersonation_not_supported', error, null, null, authData);
					break;
				default:
					dataObj = { 
						signInErrorActiveSessionEmail: (error.data && error.data.Error === AUTH_ERRORS.accountNotLinkedToIdentity) ? error.data.ActiveSessionEmail : null,
						signInErrorCode: error.data ? error.data.Error : null,
						signInErrorIdentityUrl: error.data ? error.data.IdentityUrl : null
					};
					authErrorLoggingService.logAuthError('auth_oidc_sign_in_error', error, null, null, authData);
			}

			if (iframeDetectionService.isRunningInIframe()) {
				silentAuthService.requestReauthenticationFromParent(); 
			} else {
				$state.go('login', dataObj);
			}
		});
	}
	init();
}]);

'use strict';

angular.module('paycircleApp')
.component('accessCard', {
	templateUrl: 'components/access-card/access-card.component.html',
});
'use strict';

angular.module('paycircleApp')
.component('accessInfoLinks', {
	bindings: {
		showOverviewLink: '<',
		forSso: '<'
	},
	templateUrl: 'components/access-info-links/access-info-links.component.html',
	controller: ['$scope', 'config', function ($scope, config) {
		var ctrl = this;
		// Set default value for forSSO if not defined
		ctrl.$onInit = () => {
			if (angular.isUndefined(ctrl.forSso)) {
				ctrl.forSSO = false;
			}
		};

		angular.extend($scope, {
			externalUrls: config.externalUrls
		});
	}]
});

'use strict';

angular.module('paycircleApp')
.component('accordionItem', {

	bindings: {
		// The set of icons / labels + tooltips for additional information
		aiAttributes: '<?',
		aiDescription: '@',
		aiDescriptionStyles: '<?',
		aiDescriptionMarkerStyles: '<?',
		// Detail - typically adjustment breakdown (e.g. '7 @ 1.23 x 4')
		aiDetail: '@?',
		aiHasHiddenContent: '<?',
		// Main icon
		aiIcon: '@',
		aiInfoTooltip: '@?',
		aiId: '@?',
		aiLabel: '@',
		aiTemplate: '@?',
		aiTheme: '@',
		aiTooltips: '<?',
		aiUnits: '@',
		aiUnitValue: '@',
		aiValue: '@',
		aiHideSections: '<?'
	},
	controller: 'accordionItemController',
	templateUrl: 'components/accordion-item/accordion-item.component.html',
	transclude: {
		'aiContent': '?aiContent'
	}
})

.controller('accordionItemController', [function () {

	const $ctrl = this;

	function $onInit () {
		$ctrl.aiTheme = angular.isDefined($ctrl.aiTheme) ? $ctrl.aiTheme : '';
		$ctrl.aiHasHiddenContent = angular.isDefined($ctrl.aiHasHiddenContent) ? $ctrl.aiHasHiddenContent : false;
		$ctrl.aiDescriptionStylesClasses = ['accordion-item_description'];
		if(angular.isDefined($ctrl.aiDescriptionStyles) && $ctrl.aiDescriptionStyles instanceof Array) {
			$ctrl.aiDescriptionStylesClasses = $ctrl.aiDescriptionStylesClasses.concat($ctrl.aiDescriptionStyles);
		}
		$ctrl.aiDescriptionMarkerStylesClasses = angular.isDefined($ctrl.aiDescriptionMarkerStyles) && $ctrl.aiDescriptionMarkerStyles instanceof Array ? 
			['marker'].concat($ctrl.aiDescriptionMarkerStyles) : null;
		$ctrl.aiHiddenSections = {
			hiddenContent: {
				hiddenStats: {
					actionBar: $ctrl.aiHideSections && $ctrl.aiHideSections.hiddenContent && $ctrl.aiHideSections.hiddenContent.hiddenStats && 
						$ctrl.aiHideSections.hiddenContent.hiddenStats.actionBar ? $ctrl.aiHideSections.hiddenContent.hiddenStats.actionBar : false,
					header: $ctrl.aiHideSections && $ctrl.aiHideSections.hiddenContent && $ctrl.aiHideSections.hiddenContent.hiddenStats && 
						$ctrl.aiHideSections.hiddenContent.hiddenStats.header ? $ctrl.aiHideSections.hiddenContent.hiddenStats.header : false,
				}
			}
		};
	}

	function toggleOpen () {
		$ctrl.isOpen = !$ctrl.isOpen;
	}

	angular.extend($ctrl, {
		// Variables
		isOpen: false,

		// Functions
		$onInit,
		toggleOpen
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('actionBar', {

	bindings: {
		showLogo: '=?',
		subtitle: '@?'
	},
	controller: 'actionBarController',
	templateUrl: 'components/action-bar/action-bar.component.html',
	transclude: {
	'left': '?actionBarLeft',
		'right': '?actionBarRight'
	}
})

.controller('actionBarController', [function () {

	const $ctrl = this;

	function $onInit () {
		$ctrl.showLogo = angular.isDefined($ctrl.showLogo) ? $ctrl.showLogo : true;
	}

	angular.extend($ctrl, {
		$onInit
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('actionBlock', {

	bindings: {
		abTheme: '@?',
		abLayout: '@?',
		abShowLoading: '@?',
		abIcon: '@?',
		abIconTheme: '@?',
		abIconSize: '@?'
	},
	controller: 'actionBlockController',
	templateUrl: 'components/action-block/action-block.component.html',
	transclude: {
		'actions': '?abActions',
		'footer': '?abFooter',
		'header': '?abHeader',
		'main': '?abMain'
	}
})

.controller('actionBlockController', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			abGraphic: angular.isDefined($ctrl.abGraphic) ? $ctrl.abGraphic : 'wizard',
			abShowLoading: angular.isDefined($ctrl.abShowLoading) ? $ctrl.abShowLoading : false,
			abTheme: angular.isDefined($ctrl.abTheme) ? $ctrl.abTheme : 'primary',
			abLayout: angular.isDefined($ctrl.abLayout) ? $ctrl.abLayout : 'row',
			abIcon: angular.isDefined($ctrl.abIcon) ? $ctrl.abIcon : null,
			abIconTheme: angular.isDefined($ctrl.abIconTheme) ? $ctrl.abIconTheme : '',
			abIconSize: angular.isDefined($ctrl.abIconSize) ? $ctrl.abIconSize : 'm',
			hasIcon: angular.isDefined($ctrl.abIcon),
			hasActions: $transclude.isSlotFilled('actions'),
			hasFooter: $transclude.isSlotFilled('footer'),
			hasHeader: $transclude.isSlotFilled('header'),
			hasMain: $transclude.isSlotFilled('main')
		});
	}

	angular.extend($ctrl, {
		$onInit
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('actionCard', {

	bindings: {
		acIcon: '@',
		acPercentageComplete: '=?',
		acStepsComplete: '=?',
		acStepsTotal: '=?',
		acTheme: '@',
		acTitle: '@',
		acVariant: '<?'
	},
	controller: 'actionCardController',
	templateUrl: 'components/action-card/action-card.component.html',
	transclude: {
		'action': '?acAction',
		'main': '?acMain',
		'footer': '?acFooter',
	}
})

.controller('actionCardController', ['$scope', '$transclude', function ($scope, $transclude) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.showAction = $transclude.isSlotFilled('action');
		$ctrl.showProgressBar = angular.isDefined($ctrl.acStepsTotal) && angular.isDefined($ctrl.acStepsComplete);
		$ctrl.showMain = $transclude.isSlotFilled('main');
		$ctrl.showFooter = $transclude.isSlotFilled('footer');
	}

	angular.extend($ctrl, {
		$onInit
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('activityBlock', {
	bindings: {
		agencyProfileId: '<',
		dateFrom: '<?',
		theme: '@' // 'is-inline' || 'is-block'
	},
	controller: 'activityBlockCtrl',
	templateUrl: 'components/activity-block/activity-block.component.html'
})
.controller('activityBlockCtrl', [
	'$rootScope',
	'base',
	'logService',
	'LOG_CATEGORIES',
	'USER_ROLES',
	function (
		$rootScope,
		base,
		logService,
		LOG_CATEGORIES,
		USER_ROLES
	) {

	const $ctrl = this;
	const currentCompany = $rootScope.currentCompany;
	const logCategories = [
		{
			id: LOG_CATEGORIES.payroll,
			label: 'Payroll'
		},
		{
			id: LOG_CATEGORIES.user,
			label: 'Team'
		}
	];

	function $onInit () {

		// No agency profile id provided
		if (angular.isUndefined($ctrl.agencyProfileId)) {
			throw('activityBlockCtrl: No agencyProfileId provided');
		}

		// Dynamically add pension filter, if applicable
		if (currentCompany.IsPensionActive) {
			logCategories.push({
				id: LOG_CATEGORIES.pension,
				label: 'Pension'
			});
		}

		loadLogsForCategory(logCategories[0]);

		$ctrl.logCategories = logCategories;
	}

	function getServiceForCategoryId (categoryId) {

		switch (categoryId) {
			case LOG_CATEGORIES.payroll:
				return base.getPayrollAgencyLogEntriesForDashboard;
			case LOG_CATEGORIES.user:
				return base.getUsersAgencyLogEntriesForDashboard;
			case LOG_CATEGORIES.pension:
				return base.getPensionAgencyLogEntriesForDashboard;
		}
	}

	function loadLogsForCategory (categoryObj) {

		// Logs already loaded
		if (angular.isDefined(categoryObj.logEntries)) {
			setActiveLogCategory(categoryObj);
			return;
		}

		const getLogsServiceForCategoryId = getServiceForCategoryId(categoryObj.id);

		setComponentState('loading');

		getLogsServiceForCategoryId($ctrl.agencyProfileId).then(logEntriesArr => {

			angular.extend(categoryObj, {
				logEntries: logService.decorateLogEntries(logEntriesArr),
			});

			setActiveLogCategory(categoryObj);

			setComponentState('ready');
		})
		.catch(error => {
			setComponentState('error');
			console.error(error);
		});
	}

	function openActivitySideBar () {

		$rootScope.$broadcast('open-side-bar', {
			activeMenu: 'activity'
		});
	}

	function setActiveLogCategory (logCategoryObj) {

		$ctrl.logCategoryActive = angular.copy(logCategoryObj);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {

		LOG_CATEGORIES,
		USER_ROLES,

		$onInit,
		loadLogsForCategory,
		openActivitySideBar,
		setActiveLogCategory,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('activityLog', {

	controller: 'activityLogController',
	templateUrl: 'components/activity-log/activity-log.component.html',
	bindings: {
		alStyle: '<?',
		logEntry: '<',
		layout: '@?', // 'is-inline' || 'is-block'
		theme: '@?'
	}
})

.controller('activityLogController', [
	'LOG_DATA_TYPES',
	'LOG_TYPES',
	function (
		LOG_DATA_TYPES,
		LOG_TYPES
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		LOG_DATA_TYPES,
		LOG_TYPES
	});

}]);
'use strict';

angular.module('paycircleApp')
.component('addTeamMembers', {
	controller: 'addTeamMembersController',
	templateUrl: 'components/add-team-members/add-team-members.component.html',
	bindings: {
		agencyProfileId: '<',
		onboardingDashboard: '=',
		onClose: '&'
	}
})
.controller('addTeamMembersController', [
	'$q',
	'$rootScope',
	'companyData',
	'growl',
	'intercomService',
	'onboardingService',
	'teamData',
	'tracking',
	'userData',
	'FORM_WIZARD_KEYS',
	'TOOLTIPS',
	'TRACKING_EVENTS',
	function (
		$q,
		$rootScope,
		companyData,
		growl,
		intercomService,
		onboardingService,
		teamData,
		tracking,
		userData,
		FORM_WIZARD_KEYS,
		TOOLTIPS,
		TRACKING_EVENTS
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		const getTeamMemberAdmins = teamData.getTeamMemberAdmins($ctrl.agencyProfileId);
		const getOnboardingTeamMembers = companyData.getOnboardingTeamMembers($ctrl.agencyProfileId);

		$q.all([getTeamMemberAdmins, getOnboardingTeamMembers]).then(([teamAdminsArr, teamMembersArr]) => {

			angular.extend($ctrl, {
				teamAdmins: filterTeamMemberAdmins(teamAdminsArr, teamMembersArr),
				teamMembers: teamMembersArr,
				areTeamMembersComplete: onboardingService.getAreTeamMembersComplete(teamMembersArr)
			});

			setComponentState('ready');
		})
		.catch(error => {
			setComponentState('error');
			console.error(error);
		});
	}

	function filterTeamMemberAdmins (teamAdminsArr, teamMembersArr) {

		return teamAdminsArr.filter(adminObj => {

			var hasMatch = false;
			var i = 0;
			var numberOfTeamMembers = teamMembersArr.length;

			for (i; i < numberOfTeamMembers; i++) {

				var teamMemberObj = teamMembersArr[i];

				if (adminObj.UserID === teamMemberObj.UserID && !teamMemberObj.IsExcluded) {
					hasMatch = true;
					break;
				}
			}

			return !hasMatch;
		});
	}

	function hideMenu (teamMemberObj) {

		teamMemberObj.showMenu = false;
	}

	function openAddTeamMemberWizard () {

		$rootScope.$broadcast('open-form-wizard', {
			wizardKey: FORM_WIZARD_KEYS.teamMemberAdd,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			companyState: $rootScope.currentCompany.State
		});
	}

	function openChangeAdminStateForm (userObj, isExcluding) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			contextType: 'user',
			formKey: 'change-admin-state',
			userId: userObj.UserID,
			isExcluding: isExcluding
		});
	}

	function openDeleteTeamMemberForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			contextType: 'user',
			formKey: 'delete-team-member',
			userId: teamMemberObj.UserID
		});
	}

	function openEditAdminForm (adminObj) {

		$rootScope.openSlideInForm({
			adminObj: adminObj,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			formKey: 'edit-admin',
			roleType: adminObj.RoleType,
			userId: adminObj.UserID
		});
	}

	function openEditTeamMemberWizard (teamMemberObj) {

		$rootScope.$broadcast('open-form-wizard', {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			userId: teamMemberObj.UserID,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditPersonal
		});
	}

	function openExcludeFromPayrollForm (teamMemberObj, isExcluding) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			formKey: 'exclude-from-payroll',
			userId: teamMemberObj.UserID,
			title: isExcluding !== undefined && isExcluding ? null : 'Add to payroll'
		});
	}

	function openNewAdminForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			formKey: 'new-admin',
			showContext: false
		});
	}

	function openPersonalOverviewForm (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			formKey: 'personal-overview',
			userId: teamMemberObj.UserID
		});
	}

	function openRemoveAdminAccessForm (adminObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $onInit,
			formKey: 'remove-admin-access',
			userId: adminObj.UserID
		});
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setExcludeFromPayroll (userObj, isExcluding) {

		userData.updateUserAgencyProfileExcludeFromPayroll($ctrl.agencyProfileId, userObj.UserID, isExcluding).then(() => {

			$onInit();

			growl.success(userObj.Forename + (isExcluding ? ' has been excluded from payroll' : ' has been added to payroll'));
		})
		.catch(error => {
			setComponentState('error');
			console.error(error);
		});
	}

	function toggleTeamCompleteState (onboardingObj) {

		companyData.updateOnboardingTeamComplete(onboardingObj.OnboardingID, $ctrl.agencyProfileId, onboardingObj.IsTeamComplete).then(function () {

			// Feedback
			growl.success(onboardingObj.IsTeamComplete ? 'Your team has been marked as complete' : 'Your team has been re-opened for editing');

			// Tracking
			if (onboardingObj.IsTeamComplete) {
				tracking.trackEvent(TRACKING_EVENTS.onboardingTeamCompleted);
				intercomService.updateCompanyData($ctrl.agencyProfileId, {
					size: onboardingObj.teamMembers.length
				});
			}
		})
		.catch(function () {
			setComponentState('error');
		});
	}

	angular.extend($ctrl, {
		$onInit,
		hideMenu,
		openAddTeamMemberWizard,
		openChangeAdminStateForm,
		openDeleteTeamMemberForm,
		openEditAdminForm,
		openEditTeamMemberWizard,
		openExcludeFromPayrollForm,
		openNewAdminForm,
		openPersonalOverviewForm,
		openRemoveAdminAccessForm,
		setExcludeFromPayroll,
		toggleTeamCompleteState,
		willAdminBeOnPayrollTooltip: TOOLTIPS.onboarding.willAdminBeOnPayroll
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('addressBook', {
	bindings: {
		addressBookOptions: '='
	},
	controller: 'addressBookCtrl',
	templateUrl: 'components/address-book/address-book.component.html',
})
.controller('addressBookCtrl', ['$q', 'companyService', 'growl', 'userData', 'CONTACT_EXTERNAL_CATEGORIES',
	function ($q, companyService, growl, userData, CONTACT_EXTERNAL_CATEGORIES) {

	const $ctrl = this;

	function $onInit () {
		$ctrl.categoryTitle = getCategoryTitle($ctrl.addressBookOptions.contactExternalId);
	}

	function getCategoryTitle (contactExternalId) {

		switch (contactExternalId) {
			case CONTACT_EXTERNAL_CATEGORIES.p32EmailRecipient:
				return 'Auto email instruction';

			case CONTACT_EXTERNAL_CATEGORIES.payrollEmailRecipient:
				return 'Auto send payroll reports';
		}
	}

	function getCategoryUpdateService (contactExternalId) {

		switch (contactExternalId) {
			case CONTACT_EXTERNAL_CATEGORIES.p32EmailRecipient:
				return userData.updateTeamMemberContactsExternalP32Mail;

			case CONTACT_EXTERNAL_CATEGORIES.payrollEmailRecipient:
				return userData.updateTeamMemberContactsExternalPayrollMail;
		}
	}

	function onError (error) {
		console.error(error);
		growl.error('Error when attempting to update external contacts');
		$ctrl.addressBookOptions.closeModal();
	}

	function onSave () {
		growl.success('Email recipients updated.');
		$ctrl.addressBookOptions.closeModal();
	}

	function saveForm (ctrlObj, formObj) {

		formObj.state = 'saving';

		const categoryUpdateService = getCategoryUpdateService(ctrlObj.addressBookOptions.contactExternalId);

		const newEmailContactsPromise = ctrlObj.contacts.contactsExternalNew.length > 0 ? categoryUpdateService(ctrlObj.addressBookOptions.agencyProfileId, ctrlObj.contacts.contactsExternalNew, false) : null;
		const oldEmailContactsPromise = ctrlObj.contacts.contactsExternalOld.length > 0 ? categoryUpdateService(ctrlObj.addressBookOptions.agencyProfileId, ctrlObj.contacts.contactsExternalOld, true) : null;

		$q.all([newEmailContactsPromise, oldEmailContactsPromise])
			.then(onSave)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		saveForm,
		contacts: companyService.getEmailRecipientsArrays()
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('addressLookup', {
	bindings: {
		address: '=',
		hasAddress: '=',
		id: '@',
		isCompanyAddress: '<?',
		isDisabled: '=?',
		isRequired: '=?',
		isUkOnly: '=?',
		label: '@?',
		manualEntryOnly: '=?',
		showLabel: '<?'
	},
	controller: 'addressLookupCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/address-lookup/address-lookup.component.html'
})

.controller('addressLookupCtrl', [
	'$scope',
	'$timeout',
	'addressService',
	'config',
	'postcodeLookup',
	'COUNTRIES',
	'COUNTRY_UK',
	function (
		$scope,
		$timeout,
		addressService,
		config,
		postcodeLookup,
		COUNTRIES,
		COUNTRY_UK
	) {

	const $ctrl = this;

	// Number of characters that must be entered prior to searching
	const MIN_SEARCH_LENGTH = 5;

	// States for address lookup operation
	const ADDRESS_LOOKUP_STATES = {
		hidden: 'hidden',
		loading: 'loading',
		loaded: 'loaded',
		error: 'error'
	};

	// UI view states for component
	const VIEW_STATES = {
		// Lookup - enter postcode or address part for searching address
		lookup: 'lookup',
		// Manual address entry (for UK and non-UK addresses)
		manual: 'manual',
		// View address - presentation of already entered address in form
		view: 'view'
	};

	$ctrl.$onInit = function () {

		// Get country list and add invalid 'unselected' value
		let countries = angular.copy(COUNTRIES);
		countries.unshift({
			name: 'Select a country...',
			value: ''
		});

		// Default values for optional attributes
		angular.extend($ctrl, {
			addressLookupResults: [],
			addressLookupState: ADDRESS_LOOKUP_STATES.hidden,
			addressSearchString: '',
			countries,
			isCompanyAddress: angular.isDefined($ctrl.isCompanyAddress) ? $ctrl.isCompanyAddress : false,
			isDisabled: angular.isDefined($ctrl.isDisabled) ? $ctrl.isDisabled : false,
			isRequired: angular.isDefined($ctrl.isRequired) ? $ctrl.isRequired : false,
			isUkOnly: angular.isDefined($ctrl.isUkOnly) ? $ctrl.isUkOnly : false,
			label: angular.isDefined($ctrl.label) ? $ctrl.label : 'Address',
			manualEntryOnly: angular.isDefined($ctrl.manualEntryOnly) ? $ctrl.manualEntryOnly : false,
			showLookupAddressResults: false,
			showLabel: angular.isDefined($scope.showLabel) ? $scope.showLabel : true,

			// Dummy variable used for ensuring validity of component in lookup state. Must be and remain empty.
			requiredCheck: ''
		});

		// Unique IDs for component form fields
		angular.extend($ctrl, {
			ids: {
				addressLookup: `addressLookup_${$ctrl.id}`,
				addressSearchResults: `addressSearchResults_${$ctrl.id}`,
				addressName: `addressName_${$ctrl.id}`,
				addressNumber: `addressNumber_${$ctrl.id}`,
				addressStreet: `addressStreet_${$ctrl.id}`,
				addressCity: `addressCity_${$ctrl.id}`,
				addressCounty: `addressCounty_${$ctrl.id}`,
				addressPostcode: `addressPostcode_${$ctrl.id}`,
				addressCountry: `addressCountry_${$ctrl.id}`,
				addressLine1: `address_Line1_${$ctrl.id}`,
				addressLine2: `address_Line2_${$ctrl.id}`,
				addressLine3: `address_Line3_${$ctrl.id}`,
				addressLine4: `address_Line4_${$ctrl.id}`,
				addressLine5: `address_Line5_${$ctrl.id}`,
				addressLine6: `address_Line6_${$ctrl.id}`,
			}
		});

		// Determine initial view state
		if (angular.isDefined($ctrl.address.HasAddress) ? $ctrl.address.HasAddress : $ctrl.address.AddressID !== config.guidEmpty) {
			// The address is already populated, so just show it
			setViewState($ctrl, VIEW_STATES.view);
		}
		else {
			if ($ctrl.isUkOnly) {
				// Only for UK addresses. The manual fields in this case are configured for UK addresses, and the country is set an non-editable ...
				$ctrl.address.AddressCountry = COUNTRY_UK.name;
			}
			if ($ctrl.manualEntryOnly) {
				// Show for manual address entry. Switching back to lookup won't be possible.
				setViewState($ctrl, VIEW_STATES.manual);
			}
			else {
				// Default, show for address lookup
				setViewState($ctrl, VIEW_STATES.lookup);
			}
		}
	};

	function emptyAddress (ctrlObj) {
		resetAddress(ctrlObj);
		resetAddressResults(ctrlObj);
		setViewState(ctrlObj, VIEW_STATES.lookup);
	}

	function lookupAddress (ctrlObj, searchString) {

		// Start looking when minimum no. of characters have been entered
		if (searchString && searchString.length >= MIN_SEARCH_LENGTH) {

			ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.loading;
			ctrlObj.showLookupAddressResults = true;

			$timeout(() => {
				postcodeLookup.autoCompleteAddress(searchString).then(addressResults => {
					ctrlObj.addressResults = addressResults;
					ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.loaded;
				})
				.catch(error => {
					ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.error;
					console.error(error);
				});
			}, 500);
		}
		else {
			ctrlObj.addressLookupResults = [];
			ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.hidden;
		}
	}

	function resetAddress (ctrlObj) {

		// Reset individual values so AddressID persists
		angular.extend(ctrlObj.address, {
			AddressCity: '',
			AddressCountry: ctrlObj.isUkOnly ? COUNTRY_UK.name : '',
			AddressCounty: '',
			AddressName: '',
			AddressNumber: '',
			AddressPostcode: '',
			AddressStreet: ''
		});
	}

	function resetAddressResults (ctrlObj) {

		ctrlObj.addressSearchString = '';
		ctrlObj.addressLookupResults = [];
		ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.hidden;
		ctrlObj.showLookupAddressResults = false;
	}

	function selectAddress (ctrlObj, addressResultObj) {

		// Show loading state while the address is retieved
		ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.loading;

		// Lookup the full address using the URL path attached to the address result object
		postcodeLookup.getAddressFromUrlPath(addressResultObj.urlPath).then(lookupAddressObj => {

			angular.extend(ctrlObj.address, addressService.convertPostcodeLookupAddressToPaycircleAddress(lookupAddressObj, ctrlObj.isUkOnly));

			if (angular.isDefined(ctrlObj.hasAddress)) {
				ctrlObj.hasAddress = true;
			}

			// Set view state to show address (this will reset the address results and lookup state to hidden)
			setViewState(ctrlObj, VIEW_STATES.view);
		})
		.catch(error => {
			console.error(error);
			ctrlObj.addressLookupState = ADDRESS_LOOKUP_STATES.error;
		});
	}

	function setViewState (ctrlObj, viewState) {

		ctrlObj.viewState = viewState;

		if (viewState === VIEW_STATES.manual) {
			resetAddress(ctrlObj);
		}

		resetAddressResults(ctrlObj);
	}

	angular.extend($ctrl, {

		ADDRESS_LOOKUP_STATES,
		VIEW_STATES,

		setViewState,
		lookupAddress,
		resetAddressResults,
		selectAddress
	});

	$scope.$watch('$ctrl.isDisabled', function (oldValue, newValue) {

		// Clear out the address on disable
		if (oldValue !== newValue && !newValue) {
			emptyAddress($ctrl);
		}
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('adjustmentSummaryCard', {
	bindings: {
		adjustment: '=',
		adjustmentLabel: '=?',
		adjustmentLabelContext: '=?'
	},
	controller: 'adjustmentSummaryCardCtrl',
	templateUrl: 'components/adjustment-summary-card/adjustment-summary-card.component.html'
})
.controller('adjustmentSummaryCardCtrl', ['ADJUSTMENT_VALUE_TYPES', function (ADJUSTMENT_VALUE_TYPES) {

	const $ctrl = this;

	angular.extend($ctrl, {
		ADJUSTMENT_VALUE_TYPES: ADJUSTMENT_VALUE_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('adjustmentTypeTaxTreatment', {
	bindings: {
		adjustmentType: '<'
	},
	templateUrl: 'components/adjustment-type-tax-treatment/adjustment-type-tax-treatment.component.html'
});
'use strict';

angular.module('paycircleApp')
.component('adjustmentsList', {
	bindings: {
		adjustmentDetailSummary: '=',
		agencyProfileId: '@',
		callback: '=',
		// Can update or delete adjustments. Overrides any adjustment-specific permissions when false.
		canUpdate: '=?',
		formOptions: '=?',
		payPeriod: '<',
		// Show or hide adjustments count for each adjustment group. Defaults to true.
		showAdjustmentsCount: '<?',
		theme: '@?',
		userId: '@'
	},
	controller: 'adjustmentsListController',
	templateUrl: 'components/adjustments-list/adjustments-list.component.html'
})
.controller('adjustmentsListController', [
	'$filter',
	'$rootScope',
	'$scope',
	'$timeout',
	'adjustmentsService',
	'config',
	'payrollData',
	'session',
	'ADJUSTMENT_DETAIL_TYPES',
	'ADJUSTMENT_SPECIAL_TYPES',
	'ADJUSTMENT_VALUE_TYPES',
function (
	$filter,
	$rootScope,
	$scope,
	$timeout,
	adjustmentsService,
	config,
	payrollData,
	session,
	ADJUSTMENT_DETAIL_TYPES,
	ADJUSTMENT_SPECIAL_TYPES,
	ADJUSTMENT_VALUE_TYPES
) {

	const $ctrl = this;

	const ADJUSTMENT_STATES = {
		confirmDelete: 'confirmDelete',
		deleting: 'deleting',
		error: 'error',
		ready: 'ready'
	};

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			showAdjustmentsCount: angular.isDefined($scope.showAdjustmentsCount) ? $scope.showAdjustmentCount : true,
			adjustmentDetailSummary: decorateAdjustmentDetailSummary($ctrl, $ctrl.adjustmentDetailSummary),
		});
	};

	function getAdjustmentValueDisplayClass(adjustmentObj) {
		let cssClass;
		if (adjustmentObj.AdjustmentDeduction) {
			cssClass = adjustmentObj.AdjustmentValue < 0 ? 'is-font-secondary-300' : 'is-font-quinary-300';
		} else {
			cssClass = adjustmentObj.AdjustmentValue > 0 ? 'is-font-secondary-300' : 'is-font-quinary-300';
		}

		return cssClass;
	}

	function decorateAdjustmentDetailSummary (ctrlObj, adjustmentDetailSummaryObj) {

		adjustmentDetailSummaryObj.Adjustments.forEach(adjustmentObj => {

			// Adjustment Icon
			if (adjustmentObj.AdjustmentRecurring) {
				const DEFAULT_VALUE = null;
				adjustmentObj.adjustmentIcon = $filter('paymentScheduleTypeIcon')(adjustmentObj.AdjustmentDetailID, DEFAULT_VALUE);
			}

			const isBackdatedSalary = adjustmentObj.AdjustmentSpecialType === ADJUSTMENT_SPECIAL_TYPES.backdatedSalary ||
				adjustmentObj.AdjustmentSpecialType === ADJUSTMENT_SPECIAL_TYPES.backdatedSalaryForStarter ||
				adjustmentObj.AdjustmentSpecialType === ADJUSTMENT_SPECIAL_TYPES.backdatedSalaryForPolicy;

			angular.extend(adjustmentObj, {
				// Use adjustment-specific permissions if canUpdate === true, otherwise edit and delete not permitted.
				// Adjustments created by an external integration (e.g. EDP) are read-only and managed at source.
				canEdit: ctrlObj.canUpdate && adjustmentObj.AdjustmentCanBeUpdated && !adjustmentObj.IsFromIntegration,
				canDelete: ctrlObj.canUpdate && (adjustmentObj.AdjustmentCanBeDeleted || isBackdatedSalary) && !adjustmentObj.IsFromIntegration,
				isBackdatedSalary: isBackdatedSalary,

				label: adjustmentObj.AdjustmentLabel !== '' ? adjustmentObj.AdjustmentLabel : adjustmentObj.AdjustmentDescription,
				state: ADJUSTMENT_STATES.ready
			});
		});

		/* Group the adjustments according to group title (== additional post job title). There will be a group for the main post, and an additional
		   group for each additional post. The main post has no title (job title is optional for the main post). */
		adjustmentDetailSummaryObj.adjustmentGroups = adjustmentsService.groupAdjustmentsForMultiplePosts(adjustmentDetailSummaryObj.Adjustments);

		return adjustmentDetailSummaryObj;
	}

	function deleteAdjustment (ctrlObj, adjustmentDetailSummaryObj, adjustmentObj) {

		adjustmentObj.state = ADJUSTMENT_STATES.deleting;

		let deletePromise;

		if (adjustmentObj.isBackdatedSalary) {
			deletePromise = payrollData.removeBackdatedSalary(ctrlObj.userId, ctrlObj.agencyProfileId, adjustmentObj.AdjustmentID);
		} else {
			deletePromise = payrollData.deleteUserPayElement(ctrlObj.agencyProfileId,
															 ctrlObj.payPeriod.PayPeriodID,
															 adjustmentObj.AdjustmentID,
															 session.getUserId());
		}

		deletePromise.then(() => {

			// Deletion worked, so remove the adjustment.
			adjustmentDetailSummaryObj.Adjustments.splice(adjustmentDetailSummaryObj.Adjustments.indexOf(adjustmentObj), 1);

			// Fire callback
			$timeout(() => {
				ctrlObj.callback({
					userId: ctrlObj.userId
				});
			});
		})
		.catch(error => {
			console.error(error);
			setAdjustmentState(adjustmentObj, ADJUSTMENT_STATES.error);
		});
	}

	function setAdjustmentState (adjustmentObj, state) {
		adjustmentObj.state = state;
	}

	function onAdjustmentDelete (ctrlObj, adjustmentObj) {

		// Show warning when payroll is partially submitted
		if (ctrlObj.payPeriod.IsPayrollPartiallySubmitted) {
			openEditChangeForm(ctrlObj, adjustmentObj);
			return;
		}

		setAdjustmentState(adjustmentObj, ADJUSTMENT_STATES.confirmDelete);
	}

	function openEditChangeForm (ctrlObj, adjustmentObj) {

		const agencyProfileId = ctrlObj.agencyProfileId;
		const callback = ctrlObj.callback;

		let formOptions;

		// Repayment schedules
		if (adjustmentObj.PaymentScheduleGroupID && adjustmentObj.PaymentScheduleGroupID !== config.guidEmpty) {

			formOptions = {
				agencyProfileId,
				callback,
				contextType: 'user',
				paymentScheduleGroupId: adjustmentObj.PaymentScheduleGroupID,
				userId: ctrlObj.userId
			};

			switch (adjustmentObj.AdjustmentDetailID) {
				case ADJUSTMENT_DETAIL_TYPES.childcareVouchers:
					formOptions.paymentScheduleId = adjustmentObj.AdjustmentID;
					formOptions.formKey = 'edit-repayment-schedule-fixed-for-period';
					break;
				default:
					formOptions.formKey = 'edit-repayment-schedule-for-period';
			}
		}

		// Link Element
		if (adjustmentObj.IsLinkElement) {
			formOptions = {
				adjustmentId: adjustmentObj.AdjustmentID,
				agencyProfileId,
				callback: () => {
					callback({
						userId: ctrlObj.userId
					});
				},
				contextType: 'user',
				formKey: 'link-rates',
				userId: ctrlObj.userId
			};
		}

		// Backdated NI / salary
		switch (adjustmentObj.AdjustmentSpecialType) {

			case ADJUSTMENT_SPECIAL_TYPES.niCorrection:
				formOptions = {
					adjustmentId: adjustmentObj.AdjustmentID,
					agencyProfileId,
					contextType: 'user',
					formKey: 'backdated-ni-view',
					title: 'Backdated employee NI and net pay',
					userId: ctrlObj.userId
				};
				break;

			case ADJUSTMENT_SPECIAL_TYPES.backdatedSalaryForStarter:
			case ADJUSTMENT_SPECIAL_TYPES.backdatedSalary:
			case ADJUSTMENT_SPECIAL_TYPES.backdatedSalaryForPolicy:
				formOptions = {
					adjustmentId: adjustmentObj.AdjustmentID,
					agencyProfileId,
					contextType: 'user',
					formKey: 'backdated-salary-view',
					title: 'Backdated salary',
					userId: ctrlObj.userId
				};
				break;
		}

		// Open form for special view-only cases (above) if form options set
		if (formOptions) {
			openSlideInForm(ctrlObj, formOptions);
		}
		else {
			openSlideInForm(ctrlObj, {
				adjustmentId: adjustmentObj.AdjustmentID,
				agencyProfileId,
				callback,
				contextType: 'user',
				formKey: 'add-a-change',
				includeLeavers: true,
				showContext: true,
				title: 'Edit change',
				userId: ctrlObj.userId
			});
		}
	}

	function openSlideInForm (ctrlObj, formConfigObj) {

		// Open slide-in form from other slide-in form if formOptions object is available
		if (angular.isDefined(ctrlObj.formOptions)) {
			ctrlObj.formOptions.openNewSlideInForm(formConfigObj);
		}
		else {
			$rootScope.openSlideInForm(formConfigObj);
		}
	}

	angular.extend($ctrl, {

		ADJUSTMENT_STATES,
		ADJUSTMENT_VALUE_TYPES,
		config,

		deleteAdjustment,
		getAdjustmentValueDisplayClass,
		onAdjustmentDelete,
		openEditChangeForm,
		setAdjustmentState
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('adjustmentsListItemDetails', {
	bindings: {
		adjustment: '='
	},
	templateUrl: 'components/adjustments-list-item-details/adjustments-list-item-details.component.html'
});

'use strict';

angular.module('paycircleApp')
.directive('adminCard', function () {

	return {
		templateUrl: 'components/admin-card/adminCard.html',
		replace: true,
		scope: {
			admin: '<',
			agencyProfileId: '<',
			callback: '=',
			canEditAdmin: '<?',
			canAddToTeam: '<?',
			canManageMentionsAccess: '<?',
			formOptions: '=?',
			ssoEnabled: '<?'
		},
		controller: 'adminCardController'
	};
})
.controller('adminCardController', [
	'$q',
	'$rootScope',
	'$scope',
	'companyService',
	'securityData',
	'securityService',
	'utilities',
	'REGISTRATION_INVITATION_STATUSES',
	function (
		$q,
		$rootScope,
		$scope,
		companyService,
		securityData,
		securityService,
		utilities,
		REGISTRATION_INVITATION_STATUSES		
	) {

	const agencyProfileId = $scope.agencyProfileId;
	const callback = $scope.callback;
	const formOptions = $scope.formOptions;
	const companyType = companyService.getCompanyTypeByInterfaceType($rootScope.currentCompany.CompanyType);
	const canManageAccounts = securityService.canUserManageAccountsForCompanyType(companyType, true);

	const REGISTRATION_SUMMARY_STATES = {
		loading: 'loading',
		ready: 'ready'
	};

	function onMenuOpen(adminObj) {
		var LinkedUserProfile = hasLinkedUserProfile(adminObj);
		
		var userRegistrationSummary = getUserRegistrationSummary(adminObj);

		$q.all([
			LinkedUserProfile,
			userRegistrationSummary
		])		
		.catch(function (error) {
			console.error(error);
		});
	}
	
	function hasLinkedUserProfile (adminObj) {

		if (securityService.isUserAuthorisedForIdentityAdmin()) {
			securityData.HasIdentityMigratedUserProfile(adminObj.UserID)
				.then(LinkedUserProfile => {
					$scope.linkedUserProfile = LinkedUserProfile;
				});
		}
	}

	function getUserRegistrationSummary (adminObj) {

		if ($scope.registrationSummaryDownloadState === REGISTRATION_SUMMARY_STATES.loading) {

			securityData.getUserRegistrationSummary(adminObj.UserID, adminObj.AgencyProfileID)
				.then(userRegistrationSummary => {

					angular.extend($scope, {
						invitation: userRegistrationSummary.Invitation,
						isRegistered: userRegistrationSummary.IsRegistered,
						registeredDateISO: userRegistrationSummary.RegisteredDateISO,
						registrationSummaryDownloadState: REGISTRATION_SUMMARY_STATES.ready
					});

				});
		}
	}

	function onCodeClick (invitationObj) {
		utilities.copyToClipboard(invitationObj.InvitationVerificationCode, 'Verification code copied to clipboard');
	}

	function openChangeAdminStateForm (adminObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'change-admin-state',
			userId: adminObj.UserID,
			isExcluding: false
		});
	}

	function openEditAdminForm (adminObj) {

		openSlideInForm({
			adminObj: adminObj,
			agencyProfileId: agencyProfileId,
			callback: callback,
			formKey: 'edit-admin',
			roleType: adminObj.RoleType,
			userId: adminObj.UserID
		});
	}

	function openManageMentionsAccessForm (adminObj) {

		openSlideInForm({
			adminObj: adminObj,
			agencyProfileId: agencyProfileId,
			callback: callback,
			formKey: 'manage-mentions-access',
			userId: adminObj.UserID
		});
	}

	function openManagePermissionsForm (adminObj) {

		openSlideInForm({
			adminObj: adminObj,
			agencyProfileId: agencyProfileId,
			callback: callback,
			formKey: 'manage-permissions',
			userId: adminObj.UserID
		});
	}

	function openRemoveAdminAccessForm (adminObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			formKey: 'remove-admin-access',
			userId: adminObj.UserID
		});
	}

	function openInviteToFullyRegisterForm (adminObj) {
		openSlideInForm({
			adminObj: adminObj,
			agencyProfileId: agencyProfileId,
			callback: callback,
			formKey: 'invite-sso-admin-to-fully-register',
			userId: adminObj.UserID
		});
	}

	function openResetAuthAccessForm (adminObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			adminObj: adminObj,
			callback: callback,
			formKey: 'reset-auth-access'
		});
	}

	function openResendInviteForm (adminObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			adminObj: adminObj,
			formContext: 'resend-invite',
			formKey: 'new-admin',
			title: 'Edit admin details'
		});
	}

	function openSendPasswordResetLinkForm (adminObj) {

		openSlideInForm({
			agencyProfileId,
			callback,
			contextType: 'user',
			formKey: 'password-reset',
			userId: adminObj.UserID
		});
	}

	function openUnlinkAccessAccountForm (adminObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback,
			formKey: 'unlink-access-account',
			userId: adminObj.UserID,
			requiredPermissions: securityService.getRequiredPermissionsForAccountManagement(companyType, true)
		});
	}

	function openSlideInForm (newFormOptions) {

		if (formOptions) {
			newFormOptions.callback = null;
			formOptions.openNewSlideInForm(newFormOptions);
		} else {
			$rootScope.openSlideInForm(newFormOptions);
		}
	}

	function openViewRoleForm (adminObj) {

		openSlideInForm({
			adminFullName: `${adminObj.Forename} ${adminObj.Surname}`,
			agencyProfileId: agencyProfileId,
			formKey: 'view-role',
			userId: adminObj.UserID
		});
	}

	angular.extend($scope, {
		canAddToTeam: $scope.canAddToTeam !== undefined ? $scope.canAddToTeam : true,
		canEditAdmin: $scope.canEditAdmin !== undefined ? $scope.canEditAdmin : false,
		registrationSummaryDownloadState: REGISTRATION_SUMMARY_STATES.loading,
		REGISTRATION_INVITATION_STATUSES,
		REGISTRATION_SUMMARY_STATES,
		canManageAccounts: canManageAccounts,
		linkedUserProfile: false,

		onCodeClick,
		onMenuOpen,
		openChangeAdminStateForm,
		openEditAdminForm,
		openInviteToFullyRegisterForm,
		openManageMentionsAccessForm,
		openManagePermissionsForm,
		openRemoveAdminAccessForm,
		openResendInviteForm,
		openResetAuthAccessForm,
		openSendPasswordResetLinkForm,
		openUnlinkAccessAccountForm,
		openViewRoleForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('adminCardWorkflow', {
	templateUrl: 'components/admin-card-workflow/admin-card-workflow.component.html',
	bindings: {
		admin: '<'
	},
	transclude: {
		'action': '?action'
	}
});

'use strict';

angular.module('paycircleApp')
.component('adminValidationCode', {
	bindings: {
		code: '@'
	},
	templateUrl: 'components/admin-validation-code/admin-validation-code.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('appHeader', {
	bindings: {
		companies: '<',
		currentCompany: '<',
		currentPeriod: '<?',
		currentUser: '<',
		isHelpAndSupportOpen: '=',
		sideBarOptions: '<'
	},
	controller: 'appHeaderCtrl',
	templateUrl: 'components/app-header/app-header.component.html',
})
.controller('appHeaderCtrl', [
	'$rootScope',
	'$state',
	'accessButtonService',
	'base',
	'applicationService',
	'config',
	'dateService',
	'securityData',
	'session',
	'silentAuthService',
	'telemetryLoadedEventState',
	'utilities',
	'AUTH_ERRORS',
	'AUTH_EVENTS',
	'COMPANY_STATES',
	'LOCAL_STORAGE_KEYS',
	'LOGIN_TYPES',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	'USER_ROLES',
	'FULL_SCREEN_MODAL_KEYS',
	function (
		$rootScope,
		$state,
		accessButtonService,
		base,
		applicationService,
		config,
		dateService,
		securityData,
		session,
		silentAuthService,
		telemetryLoadedEventState,
		utilities,
		AUTH_ERRORS,
		AUTH_EVENTS,
		COMPANY_STATES,
		LOCAL_STORAGE_KEYS,
		LOGIN_TYPES,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES,
		USER_ROLES,
		FULL_SCREEN_MODAL_KEYS
	) {

	const $ctrl = this;
	const MAX_BREADCRUMBS_LENGTH = 3;
	const maxAccountsVisible = 4;

	$ctrl.$onInit = () => {
		/* Establish whether or not the Help and Support link should be shown.
			Start with the set of roles that have full Help and Support access. */
		const helpAndSupportRoles = [
			$ctrl.USER_ROLES.paycircle,
			$ctrl.USER_ROLES.bureau,
			$ctrl.USER_ROLES.bureaumanager
		];

		// Add role-based support contextx from config
		if (angular.isDefined(config.supportRoleContexts) && config.supportRoleContexts.length) {
			config.supportRoleContexts.forEach(supportRoleContext => helpAndSupportRoles.push(supportRoleContext.primaryRole));
		}

		initializeAccessButton();

		getAccountsLinkedForSwitch();

		base.isFeatureEnabled($ctrl.currentUser.AgencyProfileParentID, 'ADMIN_LINKING').then(isFeatureEnabled => {
            $ctrl.IsLinkingAdminsFeatureEnabled = isFeatureEnabled;
        });

		base.isFeatureEnabled($ctrl.currentUser.UserResponseUserID, 'PAYROLL_ASSISTANT').then(isFeatureEnabled => {
			$ctrl.isPayrollAssistantEnabled = isFeatureEnabled;
		});

		angular.extend($ctrl, {
			helpAndSupportRoles: helpAndSupportRoles,
			isAccountSettingsVisible: getIsAccountSettingsVisible()
		});
	};

	function initializeAccessButton () {
		accessButtonService.initialize()
			.then(handleAccessButtonInstance)
			.catch(handleAccessButtonError);
	}

	function handleAccessButtonInstance (button) {
		const loadedEventState = telemetryLoadedEventState.getState();

		if (loadedEventState.userLoggedIn) {
			const userLastLoginDate = dateService.parseIsoDate(loadedEventState.userLastLoginDate);
			const userCurrentLoginDate = dateService.parseIsoDate(loadedEventState.userCurrentLoginDate);

			if (!dateService.areDatesSameDay(userLastLoginDate, userCurrentLoginDate)) {
				button.trackWorkItem({
					ticketId: TELEMETRY_TRACKED_FEATURES.loaded,
					productReportingCode: TELEMETRY_PROJECT_INFO.projectReportingCode,
					payload: { correlationId: loadedEventState.correlationId },
				});
			}

			telemetryLoadedEventState.clearState();
		}
	}

	function handleAccessButtonError (error) {
		console.error('Failed to get access button instance:', error);
	}

	function getIsAccountSettingsVisible () {

		// Hide "Account Settings" for users logged in with SSO
		const userLoginType = utilities.getFromStorage(LOCAL_STORAGE_KEYS.loginType);

		if (userLoginType && userLoginType === LOGIN_TYPES.sso) {
			return false;
		}

		// Visible by default
		return true;
	}

	function getAccountsLinkedForSwitch () {
		securityData.getSwitchAccountMinimalList($ctrl.currentUser.UserResponseUserID).then((data) => {
			const linkedAccounts = data.filter(account => !account.IsSignedIn);
			angular.extend($ctrl, {
				accountsList: linkedAccounts,
				shortAccountList: linkedAccounts.slice(0, Math.min(linkedAccounts.length, maxAccountsVisible)),
				maxAccountsVisible: maxAccountsVisible
			});
		});
	}

	function goToAccountSettings () {
		
		if ($rootScope.currentUser.IsAccessIdentityAccount) {
			// This is an identity account
			securityData.getUserAccountSettingsUrl().then((data) => {
				// Open the identity setting in a new browser window
				window.open(data.AccountSettingsUrl, '_blank');
			}).catch(error => {
				console.error(error);
			});

		} else {

			$state.go('account-settings', {
				userId: $ctrl.currentUser.UserResponseUserID,
				agencyProfileId: $ctrl.currentUser.AgencyProfileParentID
			});
		}

	}

	function goLinkAccounts () {

		$state.go('manage-linked-accounts', {
			userId: $ctrl.currentUser.UserResponseUserID,
			agencyProfileId: $ctrl.currentUser.AgencyProfileParentID
		});
	}

	function isAppHeaderFooterVisible () {

		// Show for Bureau/Group Admins when there are multiple
		if ($ctrl.currentUser.IsMultipleCompanyAdmin) {
			return $ctrl.companies.length > 1;

		}
		else {
			// Show for CAL when History is visible
			if ($rootScope.userHasRole(USER_ROLES.companyadministratorlite)) {
				return $rootScope.currentUser.Permissions.isHistoryVisible;
			}
		}

		// Hide for everyone else
		return false;
	}

	function logout () {
		$rootScope.$broadcast('log-out');
	}

	function openTemplateForm () {
		$rootScope.openSlideInForm({
			formKey: 'template'
		});
	}

	function goToListPageForCompany (ctrlObj, selectedCompanyObj, companyIndex) {

		ctrlObj.showCollapsedBreadcrumbs = false;

		const companyBeforeSelectedCompanyObj = ctrlObj.companies[companyIndex + 1];

		const companyListState = applicationService.getCompaniesPageForCompany(companyBeforeSelectedCompanyObj);

		$state.go(companyListState, { agencyProfileId: selectedCompanyObj.AgencyProfileID });
	}

	function openHelpAndSupport () {
		$rootScope.openHelpAndSupportPanel();
	}

	function showFastSearch () {
		$rootScope.$broadcast('open-fast-search');
	}

	function toggleCollapsedMenu (ctrlObj) {
		ctrlObj.showCollapsedBreadcrumbs = !ctrlObj.showCollapsedBreadcrumbs;
	}

	function toggleNav () {
		$rootScope.isNavOpen = !$rootScope.isNavOpen;
	}

	function toggleNavMobile () {

		// Close side bar before opening mobile menu
		if (!$rootScope.isNavOpenMobile && $ctrl.sideBarOptions.isOpen) {
			$ctrl.sideBarOptions.isOpen = false;
		}

		$rootScope.isNavOpenMobile = !$rootScope.isNavOpenMobile;
	}

	function togglePayircleTools () {
		$rootScope.showPaycircleTools = !$rootScope.showPaycircleTools;
	}

	function togglePlayground () {
		$rootScope.$broadcast ('toggle-playground');
	}

	function openPayrollAssistant () {
		$rootScope.$broadcast('open-full-screen-modal', {
			modalKey: FULL_SCREEN_MODAL_KEYS.payrollAssistant
		});
	}

	function toggleSideBarMenu (activeMenuKey) {
		$rootScope.$broadcast('open-side-bar', {
			activeMenu: activeMenuKey
		});
	}

	function toggleUserMenu (ctrlObj) {
		ctrlObj.showUserMenu = !ctrlObj.showUserMenu;
	}

	function switchAccount(account) {

		securityData.switchProfile(account.UserID).then((data) => {

			if (data && data.Error === AUTH_ERRORS.evoMigrationRequired) {
				silentAuthService.goToEvoMigration(data.IdentityUrl);
				return;
			}

			$rootScope.$broadcast(AUTH_EVENTS.sessionDestroy);
			$rootScope.$broadcast(AUTH_EVENTS.sessionCreate, data);

		}).catch(error => {

			if (error && error.data && error.data.Error === AUTH_ERRORS.evoMigrationRequired) {
				silentAuthService.goToEvoMigration(error.data.IdentityUrl);
				return;
			}

			$rootScope.paycircleMessage('Unable to switch account', 'warn');
			console.error(error);
		});
	}

	function viewMoreAccounts () {
		$state.go('switch-account');
	}

	$rootScope.$on('refreshLinkedAccounts', () => {
		getAccountsLinkedForSwitch();
	});

	angular.extend($ctrl, {
		MAX_BREADCRUMBS_LENGTH,
		PAYROLL_HISTORY_STATES: applicationService.PAYROLL_HISTORY_STATES,
		COMPANY_STATES,
		USER_ROLES,
		session,

		$state,
		logout,
		isStateActive: applicationService.isStateActive,
		isAnyStateActive: applicationService.isAnyStateActive,
		isAppHeaderFooterVisible,
		openTemplateForm,
		goToAccountSettings,
		goToDefaultLandingPageForUser: applicationService.goToDefaultLandingPageForUser,
		goLinkAccounts,
		goToListPageForCompany,
		openHelpAndSupport,
		openPayrollAssistant,
		showFastSearch,
		switchAccount,
		toggleCollapsedMenu,
		toggleNav,
		toggleNavMobile,
		togglePayircleTools,
		togglePlayground,
		toggleSideBarMenu,
		toggleUserMenu,
		viewMoreAccounts,

		showCollapsedBreadcrumbs: false,
		showUserMenu: false
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('appNavigation', {
	bindings: {
		currentCompany: '<',
		companies: '<'
	},
	controller: 'appNavigationCtrl',
	templateUrl: 'components/app-navigation/app-navigation.component.html',
})
.controller('appNavigationCtrl', [
	'$rootScope',
	'$state',
	'applicationService',
	'config',
	'stateService',
	'INTERFACE_TYPES',
	'USER_ROLES',
	function (
		$rootScope,
		$state,
		applicationService,
		config,
		stateService,
		INTERFACE_TYPES,
		USER_ROLES
	) {

	const $ctrl = this;

	const NAVIGATION_STATES = {
		accountSettings: 'account-settings',
		companyDefined: 'company-defined'
	};

	function getNavigationState (stateKey) {

		switch (stateKey) {
			case NAVIGATION_STATES.accountSettings:
				return 'account-settings';

			default:
				return NAVIGATION_STATES.companyDefined;
		}
	}

	function setNavigationState (stateKey) {
		$ctrl.navigationState = getNavigationState(stateKey);
	}

	$rootScope.$on('$stateChangeStart', function (event, toState) {
		setNavigationState(toState.name);
	});

	$ctrl.$onInit = function () {
		setNavigationState($state.current.name);
	};

	angular.extend($ctrl, {
		INTERFACE_TYPES,
		NAVIGATION_STATES,
		PAYROLL_HISTORY_STATES: applicationService.PAYROLL_HISTORY_STATES,
		USER_ROLES,

		externalUrls: config.externalUrls,
		goToDefaultLandingPageForUser: applicationService.goToDefaultLandingPageForUser,
		goToPreviousCompany: stateService.goToPreviousCompany,
		isAnyStateActive: applicationService.isAnyStateActive,
		isStateActive: applicationService.isStateActive
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('appSideBar', {
	bindings: {
		sideBarOptions: '='
	},
	controller: 'appSideBarCtrl',
	templateUrl: 'components/app-side-bar/app-side-bar.component.html'
})
.controller('appSideBarCtrl', [
	'$scope',
	function (
		$scope
	) {

	const $ctrl = this;

	function $onInit () {

		getMetaDetailsForActiveMenu();
	}

	function getAnimationForActivityBar () {
		return $ctrl.sideBarOptions.animation !== undefined ? $ctrl.sideBarOptions.animation : 'slideInRight';
	}

	function getIconForActivityBar (activeMenu) {

		switch (activeMenu) {
			case 'activity':
				return 'history';
			case 'onboarding':
				return 'admins';
			default:
				return 'question-mark';
		}
	}

	function getMetaDetailsForActiveMenu () {
		angular.extend($ctrl.sideBarOptions, {
			animation: getAnimationForActivityBar(),
			icon: getIconForActivityBar($ctrl.sideBarOptions.activeMenu),
			title: getTitleForActivityBar($ctrl.sideBarOptions.activeMenu)
		});
	}

	function getTitleForActivityBar (activeMenu) {

		switch (activeMenu) {
			case 'activity':
				return 'Activity';
			case 'onboarding':
				return 'Admin';
			default:
				return 'No title';
		}
	}

	function onCloseSidebarMenu () {

		angular.extend($ctrl.sideBarOptions, {
			isOpen: false,
			activeMenu: null
		});
	}

	angular.extend($ctrl, {
		$onInit,

		onCloseSidebarMenu
	});

	$scope.$watch('$ctrl.sideBarOptions.activeMenu', function (newValue, oldValue) {

		if (newValue !== oldValue) {
			getMetaDetailsForActiveMenu();
		}
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('appUserMessageBar', {
	bindings: {
		userMessageBarState: '<'
	},
	controller: 'appUserMessageBarCtrl',
	templateUrl: 'components/app-user-message-bar/app-user-message-bar.component.html',
})

.constant('USER_MESSAGE_BAR_STATES', {
	viewingRolePermisisons: 'viewing-role-permissions',
	viewingUserPermissions: 'viewing-user-permissions',
	timeoutWarning: 'timeout-warning',
})

.controller('appUserMessageBarCtrl', [
	'permissionsService',
	'$rootScope',
	'USER_MESSAGE_BAR_STATES',
	function (
		permissionsService,
		$rootScope,
		USER_MESSAGE_BAR_STATES
	) {

	const $ctrl = this;
	
	function init () {
		if (angular.isDefined($rootScope.CONFIG.appTimeoutMessageTimeConstraint) && $rootScope.CONFIG.appTimeoutMessageTimeConstraint.hasTimeConstraint) {
			$ctrl.timeoutWarningTimeContraintExpired = assessIsTimeoutWarningTimeContraintExpired($rootScope.CONFIG.appTimeoutMessageTimeConstraint);
			$ctrl.timeoutWarningTimeContraint = true;
		} else { 
			$ctrl.timeoutWarningTimeContraintExpired = false;
			$ctrl.timeoutWarningTimeContraint = false;
		}
	}

	function assessIsTimeoutWarningTimeContraintExpired (timeConstraint) {
			const now = new Date();
			return now > timeConstraint.timeConstraintEnd;
	}

	init();

	angular.extend($ctrl, {
		USER_MESSAGE_BAR_STATES,
		disableAdminViewMode: permissionsService.disableAdminViewMode
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('arcDeChart', function () {

	return {
		templateUrl: 'components/arc-de-chart/arcDeChartComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			stack: '<',
			total: '<',
			value: '<',
			barColor: '@'
		},
		controller: 'arcDeChartCtrl'
	};
})
.controller('arcDeChartCtrl', ['$scope', function ($scope) {
	const init = () => {
		const proportion = 5.85;
		const cap = 785;

		$scope.displayValue = -1 * ((100 / $scope.total) * $scope.value) * proportion + cap;
		$scope.arcScale = 1 - ($scope.stack - 1) * 0.2;
		$scope.strokeWidth = 8 + ($scope.stack - 1) * 2 + $scope.stack;
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')
.component('avatar', {
	bindings: {
		avatarInitial: '@',
		avatarSize: '@?',
		avatarTheme: '@?',
		avatarUrl: '@?',
		avatarUserId: '@?'
	},
	controller: 'avatarController',
	templateUrl: 'components/avatar/avatar.component.html'
})
.controller('avatarController', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.avatarTheme = angular.isDefined($ctrl.avatarTheme) && $ctrl.avatarTheme !== '' ? $ctrl.avatarTheme : 'is-primary';
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('bacsCard', {
	bindings: {
		bacsFile: '<',
		bulkItems: '=',
		onDownload: '=',
		onStateChange: '='
	},
	controller: 'bacsCardCtrl',
	templateUrl: 'components/bacs-card/bacs-card.component.html',
})
.controller('bacsCardCtrl', ['bulkService', 'DOCUMENT_STATES', function (bulkService, DOCUMENT_STATES) {

	const $ctrl = this;

	function downloadBacsFile (ctrlObj) {

		hideMenu(ctrlObj);

		if (angular.isFunction($ctrl.onDownload)) {
			let bacsFileArr = [ctrlObj.bacsFile];
			$ctrl.onDownload(bacsFileArr);
		}
	}

	function hideMenu (ctrlObj) {
		ctrlObj.showMenu = false;
	}

	function onCheckboxToggle (bulkItemsObj) {
		bulkItemsObj = bulkService.updateBulkItemTotals(bulkItemsObj);
	}

	function updateBacsDocumentState (ctrlObj, documentState) {

		hideMenu(ctrlObj);

		if (angular.isFunction($ctrl.onStateChange)) {
			let bacsFileArr = [ctrlObj.bacsFile];
			$ctrl.onStateChange(bacsFileArr, documentState);
		}
	}

	angular.extend($ctrl, {
		DOCUMENT_STATES,

		downloadBacsFile,
		hideMenu,
		onCheckboxToggle,
		updateBacsDocumentState,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('bacsDisbursement', {
	bindings: {
		agencyProfileId: '<',
		bacsEnabled: '<?',
		disabled: '<?',
		disbursement: '=',
		form: '=',
		isAoePayment: '<?',
		isHmrcPayment: '<?',
		payPeriod: '<',
		showBacsTitle: '<?',
		companyName: '<?'
	},
	controller: 'bacsDisbursementCtrl',
	require: '^form',
	templateUrl: 'components/bacs-disbursement/bacs-disbursement.component.html',
})
.controller('bacsDisbursementCtrl', [
	'config',
	'payPeriodService',
	'utilities',
	'DISBURSEMENT_CONTEXT_TYPES',
	'HMRC_PAYMENT_ACCOUNTS',
	'HMRC_PAYMENT_ACCOUNTS_IDS',
	'PAY_PERIOD_OFFSET_OPTIONS',
	'PAY_PERIOD_TYPES',
	function (
		config,
		payPeriodService,
		utilities,
		DISBURSEMENT_CONTEXT_TYPES,
		HMRC_PAYMENT_ACCOUNTS,
		HMRC_PAYMENT_ACCOUNTS_IDS,
		PAY_PERIOD_OFFSET_OPTIONS,
		PAY_PERIOD_TYPES
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		loading: 'loading',
		ready: 'ready'
	};

	const RELATIVE_PAYMENT_OPTIONS = {
		afterPayDay: 'after-pay-day',
		onPayDay: 'on-pay-day'
	};

	const PAYMENT_FREQUENCIES = {
		relativeToPayPeriod: 0,
		monthly: 1,
		quarterly: 2,
		biannually: 3,
		annually: 4
	};

	function $onInit () {

		const payPeriodObj = angular.copy($ctrl.payPeriod);

		const relativeOptionState = getRelativeDaysState();
		const relativesDaysPositive = Math.abs($ctrl.disbursement.RelativeDays);

		angular.extend($ctrl, {
			bacsEnabled: angular.isDefined($ctrl.bacsEnabled) ? $ctrl.bacsEnabled : true,
			bacsPaymentDateOption: getBacsPaymentOption(payPeriodObj),
			formId: utilities.guid(), // used for form validation when there are multiple disbursments in one form
			payPeriod: payPeriodObj,
			recuringOptions: payPeriodService.getPaymentOptionsDaysByPeriodType(PAY_PERIOD_TYPES.monthly),
			relativeOptions: {
				state: relativeOptionState,
				afterDayCount: relativeOptionState === RELATIVE_PAYMENT_OPTIONS.afterPayDay ? relativesDaysPositive : 0
			}
		});

		if ($ctrl.disbursement.DisbursementID === config.guidEmpty) {
			decorateEmptyDisbursement($ctrl.disbursement);
		}

		if ($ctrl.isHmrcPayment) {
			changePeriodType();
		} else {
			decorateExistingDisbursement();
		}
	}

	function changePeriodType () {
		if($ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.annually || $ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.biannually) {
			return;
		} else if ($ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.dayOfMonth) {
			$ctrl.payPeriod.PeriodType = PAY_PERIOD_TYPES.monthly;
		} else {
			$ctrl.payPeriod.PeriodType = PAY_PERIOD_TYPES.quarterly;
		}
	}

	function decorateEmptyDisbursement (disbursementObj) {
		angular.extend(disbursementObj, {
			AgencyProfileID: $ctrl.agencyProfileId
		});
	}

	function decorateExistingDisbursement () {
		$ctrl.disbursement.PaymentFrequency = getPaymentFrequencyOption();
	}

	function getBacsPaymentOption (payPeriodObj) {

		if ($ctrl.isHmrcPayment) {
			if (payPeriodObj.PeriodType === PAY_PERIOD_TYPES.annuall || payPeriodObj.PeriodType === PAY_PERIOD_TYPES.biannually) {
				return DISBURSEMENT_CONTEXT_TYPES.paymentDates;
			} else if ($ctrl.disbursement.PaymentFrequency === PAYMENT_FREQUENCIES.monthly) {
				return DISBURSEMENT_CONTEXT_TYPES.dayOfMonth;
			} else {
				return DISBURSEMENT_CONTEXT_TYPES.paymentDates;
			}

		} else {
			switch (payPeriodObj.PeriodType) {
				case PAY_PERIOD_TYPES.weekly:
				case PAY_PERIOD_TYPES.fortnightly:
				case PAY_PERIOD_TYPES.fourweekly:
				case PAY_PERIOD_TYPES.monthly:
					if ($ctrl.disbursement.DayOfMonth !== 0) {
						return DISBURSEMENT_CONTEXT_TYPES.dayOfMonth;
					} else {
						return DISBURSEMENT_CONTEXT_TYPES.relativeDays;
					}
					break;
				default:
					if (isSpecificDatePaymentOption()) {
						return DISBURSEMENT_CONTEXT_TYPES.paymentDates;
					} else {
						return DISBURSEMENT_CONTEXT_TYPES.relativeDays;
					}
			}
		}
	}

	function getPaymentFrequencyOption () {

		if ($ctrl.isHmrcPayment) {
			if($ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.annually) {
				return PAYMENT_FREQUENCIES.annually;
			} else if ($ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.biannually) {
				return PAYMENT_FREQUENCIES.biannually;
			} else if ($ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.dayOfMonth) {
				return PAYMENT_FREQUENCIES.monthly;
			} else {
				return PAYMENT_FREQUENCIES.quarterly;
			}
		}

		switch ($ctrl.payPeriod.PeriodType) {
			case PAY_PERIOD_TYPES.weekly:
			case PAY_PERIOD_TYPES.fortnightly:
			case PAY_PERIOD_TYPES.fourweekly:
			case PAY_PERIOD_TYPES.monthly:
				return $ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.dayOfMonth ? PAYMENT_FREQUENCIES.monthly : PAYMENT_FREQUENCIES.relativeToPayPeriod;
			case PAY_PERIOD_TYPES.quarterly:
				return $ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.paymentDates ? PAYMENT_FREQUENCIES.quarterly : PAYMENT_FREQUENCIES.relativeToPayPeriod;
			case PAY_PERIOD_TYPES.biannually:
				return $ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.paymentDates ? PAYMENT_FREQUENCIES.biannually : PAYMENT_FREQUENCIES.relativeToPayPeriod;
			case PAY_PERIOD_TYPES.annually:
				return $ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.paymentDates ? PAYMENT_FREQUENCIES.annually : PAYMENT_FREQUENCIES.relativeToPayPeriod;
			}
	}

	function getRelativeDaysCount () {

		switch ($ctrl.relativeOptions.state) {
			case RELATIVE_PAYMENT_OPTIONS.afterPayDay:
				return $ctrl.relativeOptions.afterDayCount;

			case RELATIVE_PAYMENT_OPTIONS.onPayDay:
				return 0;
		}
	}

	function getRelativeDaysState () {

		if ($ctrl.disbursement.RelativeDays > 0) {
			return RELATIVE_PAYMENT_OPTIONS.afterPayDay;
		} else {
			return RELATIVE_PAYMENT_OPTIONS.onPayDay;
		}
	}

	function isSpecificDatePaymentOption () {
		return $ctrl.disbursement.Date1ISO !== '' && $ctrl.disbursement.Date1ISO !== '1900-01-01T00:00:00';
	}

	function onSeparateBACSChange () {

		if (!$ctrl.disbursement.SeparateBACS) {

			angular.merge($ctrl, {
				disbursement: {
					RelativeDays: 0,
					PaymentFrequency: PAYMENT_FREQUENCIES.relativeToPayPeriod,
					DayOfMonth: 0
				},
				bacsPaymentDateOption: DISBURSEMENT_CONTEXT_TYPES.relativeDays
			});

			resetRelativeDateOptions();
			resetPaymentDateOptions();

		} else {
			if ($ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.annually || $ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.biannually) {
				$ctrl.bacsPaymentDateOption = DISBURSEMENT_CONTEXT_TYPES.paymentDates;
			} else {
				$ctrl.bacsPaymentDateOption = $ctrl.isHmrcPayment ? DISBURSEMENT_CONTEXT_TYPES.dayOfMonth : DISBURSEMENT_CONTEXT_TYPES.relativeDays;
			}
			resetPaymentOptions();
		}
	}

	function resetPaymentOptions () {

		resetRelativeDateOptions();

		$ctrl.disbursement.PaymentFrequency = getPaymentFrequencyOption();

		if ($ctrl.isHmrcPayment) {
			if ($ctrl.payPeriod.PeriodType !== PAY_PERIOD_TYPES.annually || $ctrl.payPeriod.PeriodType !== PAY_PERIOD_TYPES.biannually) {
				changePeriodType();
			}
		}

		resetPaymentDateOptions();

		updateDisbursementRelativeDays();
	}

	function resetRelativeDateOptions () {
		angular.merge($ctrl, {
			relativeOptions: {
				state: RELATIVE_PAYMENT_OPTIONS.onPayDay,
				beforeDayCount: 0,
				afterDayCount: 0
			}
		});
	}

	function resetPaymentDateOptions () {
		angular.merge($ctrl.disbursement, {
			Date1ISO: '',
			Date2ISO: '',
			Date3ISO: '',
			Date4ISO: '',
			DayOfMonth: $ctrl.disbursement.SeparateBACS && $ctrl.bacsPaymentDateOption === DISBURSEMENT_CONTEXT_TYPES.dayOfMonth ? null : 0,
		});
	}

	function updateDisbursementRelativeDays () {
		$ctrl.disbursement.RelativeDays = getRelativeDaysCount();

		if ($ctrl.relativeOptions.state === RELATIVE_PAYMENT_OPTIONS.onPayDay && angular.isDefined($ctrl.form[`${$ctrl.formId}-afterDayCount`])) {
			$ctrl.form[`${$ctrl.formId}-afterDayCount`].$setUntouched();
			$ctrl.relativeOptions.afterDayCount = 0;
		}
	}

	function updatePaymentDateValidation (date1Iso) {
		$ctrl.paymentDateValidation = payPeriodService.getPayPeriodsDateValidation(date1Iso, $ctrl.payPeriod.PeriodType === PAY_PERIOD_TYPES.quarterly);
	}

	angular.extend($ctrl,  {
		$onInit,

		COMPONENT_STATES,
		DISBURSEMENT_CONTEXT_TYPES,
		PAY_PERIOD_OFFSET_OPTIONS,
		PAY_PERIOD_TYPES,
		PAYMENT_FREQUENCIES,
		RELATIVE_PAYMENT_OPTIONS,

		onSeparateBACSChange,
		resetPaymentOptions,
		updateDisbursementRelativeDays,
		updatePaymentDateValidation,

		hmrcBankAccount: HMRC_PAYMENT_ACCOUNTS.find(bankAccountObj => bankAccountObj.id === HMRC_PAYMENT_ACCOUNTS_IDS.uk)
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('bankSummaryCard', {
	bindings: {
		bank: '<',
		bankTitle: '@',
		onEdit: '&',
		theme: '@'
	},
	templateUrl: 'components/bank-summary-card/bank-summary-card.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('birthDateInput', {
	bindings: {
		debounce: '<?',
		id: '@',
		maxDateIso: '<?',
		minDateIso: '<?',
		ngModel: '=',
		onUpdate: '&',
		required: '<?'
	},
	require: {
		form: '^form'
	},
	controller: 'birthDateInputComponentCtrl',
	templateUrl: 'components/birth-date-input/birth-date-input.component.html',
})
.controller('birthDateInputComponentCtrl', [
	'config',
	function (
		config
	) {

	const $ctrl = this;

	const VALIDATION_STATES = {
		dateDoesntExist: 'date-doesnt-exist', // Date isn't real (eg, 29th Feb 2022)
		dateIsAfterMax: 'date-after-max-date', // Date is after set maxDateIso
		dateIsBeforeMin: 'date-before-min-date', // Date is after set minDateIso
		valid: true,
		waiting: false
	};

	function $onInit () {

		setValidationState(VALIDATION_STATES.waiting);

		// Set defaults
		const date = {
			ngModel: null,
			id: $ctrl.id + '-date'
		};

		const month = {
			ngModel: null,
			id: $ctrl.id + '-month'
		};

		const year = {
			ngModel: null,
			id: $ctrl.id + '-year'
		};

		angular.extend($ctrl, {
			segments: {
				date,
				month,
				year
			},
			segmentsArray: [
				date,
				month,
				year
			]
		});

		setSegmentValuesFromNgModel();
	}


	function getDateFromSegments () {

		const segmentValuesObj = getSegmentValuesObject();
		const birthDateMoment = moment().set(segmentValuesObj);

		// Block MomentJS from overflowing the dates (date = 34 would return the 4th of the next month)
		if (birthDateMoment.month() !== segmentValuesObj.month || birthDateMoment.year() !== segmentValuesObj.year) {
			return;
		}

		return birthDateMoment;
	}

	function getPaddedStringForIntegerValue (value) {
		return value.toString().padStart(2, '0'); // 3 => "04", 12 => "12"
	}

	function getSegmentValuesObject () {

		// Create object from segment values, and set time to middnight
		return {
			year: getSegmentValueAsInteger($ctrl.segments.year),
			month: getSegmentValueAsInteger($ctrl.segments.month)-1, // MomentJS indexes months from 0
			date: getSegmentValueAsInteger($ctrl.segments.date),
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0
		};
	}

	function getSegmentValueAsInteger (segmentObj) {
		return parseInt(segmentObj.formField.$viewValue); // Get view value instead if ngModel as ngModel is null if field is invalid
	}

	function getValidDate () {

		const birthDateMoment = getDateFromSegments();
		const isDateRealDate = moment.isMoment(birthDateMoment) && birthDateMoment.isValid();

		setSegmentValidity(isDateRealDate);

		if (isDateRealDate) {

			// Max date validation
			if (angular.isDefined($ctrl.maxDateIso)) {

				if (birthDateMoment.isAfter(moment($ctrl.maxDateIso))) {
					setValidationState(VALIDATION_STATES.dateIsAfterMax);
					setSegmentValidity(false);
					return;
				} else {
					setSegmentValidity(true);
				}
			}

			// Min date validation
			if (angular.isDefined($ctrl.minDateIso)) {
				if (birthDateMoment.isBefore(moment($ctrl.minDateIso))) {
					setValidationState(VALIDATION_STATES.dateIsBeforeMin);
					setSegmentValidity(false);
					return;
				} else {
					setSegmentValidity(true);
				}
			}

			onDateValid(birthDateMoment);

		} else {
			setValidationState(VALIDATION_STATES.dateDoesntExist);
			$ctrl.ngModel = null;
		}
	}

	function onDateValid (birthDateMoment) {

		setValidationState(VALIDATION_STATES.valid);

		// Set ngModel to standard ISO date format if valid
		$ctrl.ngModel = birthDateMoment.format(config.dateFormatISO);

		if (angular.isFunction($ctrl.onUpdate)) {
			$ctrl.onUpdate({ dobIso: $ctrl.ngModel });
		}
	}

	function onSegmentChange () {

		setValidationState(VALIDATION_STATES.waiting);

		// Clear ngModel if segments are empty`
		if (!$ctrl.segments.date.ngModel || !$ctrl.segments.month.ngModel || !$ctrl.segments.year.ngModel) {
			$ctrl.ngModel = null;
			return;
		}

		getValidDate();
	}


	function setInputFormFields () {

		// Set form fields, only once form has loaded
		for (let segmentObj of $ctrl.segmentsArray) {

			// Attach $form field to segment
			segmentObj.formField = $ctrl.form[segmentObj.id];

		}
	}

	function setSegmentValidity (isDateValid) {

		// Set validation state across all segments
		for (let segmentObj of $ctrl.segmentsArray) {
			segmentObj.formField.$setValidity('isDateValid', isDateValid);
		}
	}

	function setSegmentValuesFromNgModel () {

		// Assign values from ISO timestamp
		if (!$ctrl.ngModel) {
			return;
		}

		const ngModelMoment = moment($ctrl.ngModel);

		$ctrl.segments.date.ngModel = getPaddedStringForIntegerValue(ngModelMoment.date());
		$ctrl.segments.month.ngModel = getPaddedStringForIntegerValue(ngModelMoment.month()+1); // MomentJS month index begins at 0
		$ctrl.segments.year.ngModel = getPaddedStringForIntegerValue(ngModelMoment.year());
	}

	function setValidationState (newState) {
		$ctrl.validationState = newState;
	}

	angular.extend($ctrl, {
		$onInit,
		$postLink: setInputFormFields,

		onSegmentChange,

		VALIDATION_STATES,

		debounce: $ctrl.debounce || 0
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('bulletList', {
	bindings: {
		blItems: '<?',
		blTheme: '@?'
	},
	controller: 'bulletListCtrl',
	templateUrl: 'components/bullet-list/bullet-list.component.html',
	transclude: {
		'items': '?blItems'
	},
})
.controller('bulletListCtrl', ['$transclude', function ($transclude) {

	const $ctrl = this;

	function $onInit () {

		const listItemsArr = [];

		/*
			List could be either objects or strings to allow for custom class names per list item
			e.g,
			[
				{
					text: 'Highlighted test',
					class: 'highlighted'
				},
				'Normal Text',
				'Normal Text'
			]
		*/

		if (angular.isArray($ctrl.blItems)) {

			for (let listItem of $ctrl.blItems) {

				if (angular.isObject(listItem)) {
					listItemsArr.push(listItem);

				} else {
					listItemsArr.push({
						text: listItem
					});
				}

			}
		}

		$ctrl.listItemsDecorated = listItemsArr;
	}

	angular.extend($ctrl, {
		$onInit,

		hasItems: $transclude.isSlotFilled('items')
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('bureauCard', {
	bindings: {
		bureau: '=',
		callback: '=',
		onCheckboxToggle: '=',
		refreshBureaus: '='
	},
	controller: 'bureauCardCtrl',
	templateUrl: 'components/bureau-card/bureau-card.component.html'
})
.controller('bureauCardCtrl', [
	'$rootScope',
	'FORM_WIZARD_KEYS',
	function (
		$rootScope,
		FORM_WIZARD_KEYS
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		// IsArchived flag on bureau doesn't appear to be set correctly. Determine using the archive date.
		$ctrl.bureau.isArchived = $ctrl.bureau.Company.ArchiveDateISO !== '';
	};

	function openAddCompanyWizard () {

		$rootScope.$broadcast('open-form-wizard', {
			callback: $ctrl.callback,
			agencyProfileParentId: $ctrl.bureau.Company.AgencyProfileID,
			primaryButtonText: 'Next',
			showHeader: true,
			title: 'Create company',
			wizardKey: FORM_WIZARD_KEYS.company
		});
	}

	function openAutoCreateCompanyForm () {

		$rootScope.openSlideInForm({
			callback: $ctrl.callback,
			formKey: 'auto-create-company',
			agencyProfileParentId: $ctrl.bureau.Company.AgencyProfileID
		});
	}

	function openManageAdminsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.bureau.Company.AgencyProfileID,
			formKey: 'manage-admins'
		});
	}

	function openArchiveBureauForm () {

		$rootScope.openSlideInForm({
			bureauCompany: $ctrl.bureau.Company,
			callback: $ctrl.refreshBureaus,
			formKey: 'archive-bureau',
			showContext: false
		});
	}

	function openDeleteBureauForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.bureau.Company.AgencyProfileID,
			callback: $ctrl.refreshBureaus,
			formKey: 'delete-bureau',
			showContext: false
		});
	}

	angular.extend($ctrl, {

		showMenu: false,

		openAddCompanyWizard,
		openAutoCreateCompanyForm,
		openManageAdminsForm,
		openArchiveBureauForm,
		openDeleteBureauForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('businessCategory', {
	bindings: {
		businessCategory: '<',
		disabled: '<',
		index: '<',
		onUpdate: '&',
	},
	controller: 'businessCategoryController',
	templateUrl: 'components/business-category/business-category.component.html'
})
.controller('businessCategoryController', [
	'$rootScope',
	function (
		$rootScope
	) {

	const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;
	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			deleteBusinessCategory,
			isExpanded: true,
			showActionMenu: false,
			toggleIsExpanded
		});
	}

	function deleteBusinessCategory (businessCategory) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			businessCategory,
			callback: $ctrl.onUpdate(),
			formKey: 'company-settings-delete-business-category',
			primaryButtonText: 'Delete'
		});
	}

	function openDepartmentSubCodeOverridesForm (businessCodeObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			businessCode: businessCodeObj,
			callback: $ctrl.onUpdate(),
			formKey: 'company-settings-department-sub-code-overrides',
			title: `${businessCodeObj.BusinessCodeNarrative} sub-code overrides`
		});
	}

	function toggleIsExpanded () {

		$ctrl.isExpanded = !$ctrl.isExpanded;
	}

	angular.extend($ctrl, {
		$onInit,
		openDepartmentSubCodeOverridesForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('businessCategoriesOverride', {
	bindings: {
		businessCategories: '=',
		userForename: '<'
	},
	controller: 'businessCategoriesOverrideCtrl',
	templateUrl: 'components/business-categories-override/business-categories-override.component.html'
})
.controller('businessCategoriesOverrideCtrl', function () {


	const $ctrl = this;

	function $onInit () {

		if ($ctrl.businessCategories) {
			$ctrl.businessCategories = $ctrl.businessCategories.filter(businessCategory => businessCategory.BusinessCodes.length !== 0);
		}
	}

	angular.extend($ctrl, {
		$onInit
	});
});

'use strict';

angular.module('paycircleApp')
.component('businessCodeCard', {
	bindings: {
		agencyProfileId: '<',
		businessCategory: '<',
		businessCode: '<',
		refreshDepartments: '&?',
		showExtras: '&?'
	},
	controller: 'businessCodeCardCtrl',
	templateUrl: 'components/business-code-card/business-code-card.component.html',
})
.controller('businessCodeCardCtrl', [
	'$rootScope',
	'BUSINESS_CATEGORY_TYPES',
	'BUSINESS_CODE_FORM_STATES',
	function (
		$rootScope,
		BUSINESS_CATEGORY_TYPES,
		BUSINESS_CODE_FORM_STATES
	) {

	const $ctrl = this;

	function getBusinessCodeFormTitle (formState) {

		switch (formState) {
			case BUSINESS_CODE_FORM_STATES.delete:
				return 'Delete business category';

			case BUSINESS_CODE_FORM_STATES.manageTeamMembers:
				return 'Manage team members';

			case BUSINESS_CODE_FORM_STATES.manageVisibility:
				return 'Manage visibility';

			case BUSINESS_CODE_FORM_STATES.create:
				return 'Add new business category';

			case BUSINESS_CODE_FORM_STATES.edit:
				return 'Edit business category';
		}
	}

	function hideMenu (ctrlObj) {

		ctrlObj.showMenu = false;
	}

	function openBusinessCodeEditForm ($ctrl) {

		openBusinessCodeForm($ctrl, {
			formState: BUSINESS_CODE_FORM_STATES.edit
		});
	}

	function openBusinessCodeDeleteForm ($ctrl) {

		openBusinessCodeForm($ctrl, {
			formState: BUSINESS_CODE_FORM_STATES.delete
		});
	}

	function openBusinessCodeForm ($ctrl, formObj) {

		$rootScope.openSlideInForm(angular.extend({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshDepartments,
			businessCategory: $ctrl.businessCategory,
			businessCodeId: $ctrl.businessCode.BusinessCodeID,
			formKey: 'business-code',
			title: getBusinessCodeFormTitle(formObj.formState)
		}, formObj));
	}

	function openBusinessCodeManageTeamMembersForm ($ctrl) {

		openBusinessCodeForm($ctrl, {
			formState: BUSINESS_CODE_FORM_STATES.manageTeamMembers
		});
	}
	
	function openBusinessCodeManageVisibilityForm ($ctrl) {

		openBusinessCodeForm($ctrl, {
			formState: BUSINESS_CODE_FORM_STATES.manageVisibility
		});
	}

	angular.extend($ctrl, {
		BUSINESS_CATEGORY_TYPES,
		BUSINESS_CODE_FORM_STATES,

		hideMenu,
		openBusinessCodeDeleteForm,
		openBusinessCodeEditForm,
		openBusinessCodeManageTeamMembersForm,
		openBusinessCodeManageVisibilityForm,

		showMenu: false
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('businessCodeFormField', {
	bindings: {
		index: '=',
		businessCode: '=',
		businessCodeList: '=',
		showActions: '<?'
	},
	controller: 'businessCodeFormFieldController',
	require: {
		form: '^form'
	},
	templateUrl: 'components/business-code-form-field/business-code-form-field.component.html'
})
.controller('businessCodeFormFieldController', [function () {

	let $ctrl = this;

	$ctrl.$onInit = function () {

		angular.extend($ctrl, {
			businessCodeValueFormFieldId: `businessCodeValue${$ctrl.index}`,
			businessCodeNarrativeFormFieldId: `businessCodeNarrative${$ctrl.index}`
		});
		decorateBusinessCode($ctrl.businessCode);
	};

	function decorateBusinessCode (businessCode) {

		businessCode.confirmDelete = false;
	}

	function deleteBusinessCode (businessCode) {

		businessCode.BusinessCodeArchived = true;
	}

	function isUnique (businessCode, businessCodeList, businessCodeAttribute) {

		return !angular.isDefined(businessCodeList.find(code => {
			return (code !== businessCode && !code.BusinessCodeArchived && code[businessCodeAttribute] === businessCode[businessCodeAttribute]);
		}));
	}

	function onBusinessCodeAttributeChange (formFieldName, attributeName) {

		$ctrl.businessCodeList.forEach((businessCode, index) => {
			let formField = $ctrl.form[`${formFieldName}${index}`];
			if (!businessCode.BusinessCodeArchived) {
				formField.$setValidity('nonUnique', isUnique(businessCode, $ctrl.businessCodeList, attributeName));
			}
		});
	}

	function toggleConfirmDeleteBusinessCode (businessCode) {

		businessCode.confirmDelete = !businessCode.confirmDelete;
	}

	angular.extend($ctrl, {

		deleteBusinessCode,
		onBusinessCodeAttributeChange,
		showActions: angular.isDefined($ctrl.showActions) ? $ctrl.showActions : true,
		toggleConfirmDeleteBusinessCode
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('buttonCard', {
	bindings: {
		imgSrc: '@',
		title: '@?',
		subtitle: '@?',
		buttonLink: '@?',
		bannerText: '@?'
	},
	controllerAs: '$ctrl',
	templateUrl: 'components/button-card/button-card.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('calculationCard', {
	bindings: {
		title: '@',
		amount: '=',
		busy: '<?'
	},
	templateUrl: 'components/calculation-card/calculation-card.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('carouselInput', {
	bindings: {
		currentIndex: '=',
		maxIndex: '<',
		onIndexChange: '&?',
		showDetail: '<?',
		theme: '<?'
	},
	controller: 'carouselInputCtrl',
	templateUrl: 'components/carousel-input/carousel-input.component.html'
})
.controller('carouselInputCtrl', function () {

	const $ctrl = this;

	function $onInit () {
		angular.extend($ctrl, {
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-secondary',
			showDetail: angular.isDefined($ctrl.showDetail) ? $ctrl.showDetail : true
		});
	}

	function decreaseIndex ($ctrl) {
		$ctrl.currentIndex--;
		onIndexChange($ctrl);
	}

	function increaseIndex ($ctrl) {
		$ctrl.currentIndex++;
		onIndexChange($ctrl);
	}

	function onIndexChange ($ctrl) {

		if (angular.isFunction($ctrl.onIndexChange)) {
			$ctrl.onIndexChange();
		}
	}

	angular.extend($ctrl, {
		$onInit,

		decreaseIndex,
		increaseIndex,
	});
});

'use strict';

angular.module('paycircleApp')
.component('changeCreator', {
	bindings: {
		vm: '=',
		adjustmentLabel: '=?',
		agencyProfileId: '<',
		allowAddTeamMembers: '<'
	},
	controller: 'changeCreatorCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/change-creator/change-creator.component.html'
})
.controller('changeCreatorCtrl', [
	'$q',
	'$rootScope',
	'$timeout',
	'adjustmentsService',
	'base',
	'config',
	'growl',
	'journalsService',
	'coralogixService',
	'payrollData',
	'pensionData',
	'pensionService',
	'salaryService',
	'validationService',
	'ADJUSTMENT_CATEGORY_TYPES',
	'ADJUSTMENT_SPECIAL_TYPES',
	'ADJUSTMENT_VALUE_TYPES',
	function (
		$q,
		$rootScope,
		$timeout,
		adjustmentsService,
		base,
		config,
		growl,
		journalsService,
		coralogixService,
		payrollData,
		pensionData,
		pensionService,
		salaryService,
		validationService,
		ADJUSTMENT_CATEGORY_TYPES,
		ADJUSTMENT_SPECIAL_TYPES,
		ADJUSTMENT_VALUE_TYPES
	) {

	const $ctrl = this;
	const ADJUSTMENT_TYPE_FILTER_KEYS = {
		deductions: 'deductions',
		additions: 'additions'
	};
	const FORM_FIELD_IDS = {
		adjustmentTotalValue: 'adjustmentTotalValue',
		adjustmentUnits: 'adjustmentUnits',
		salaryRate: 'salaryRate',
		searchTermTeamMembers: 'searchTermTeamMembers'
	};

	function $onInit () {

		// Defaults
		$ctrl.allowAddTeamMembers = angular.isDefined($ctrl.allowAddTeamMembers) ? $ctrl.allowAddTeamMembers : true;

		angular.extend($ctrl.vm, {
			ADJUSTMENT_CATEGORY_TYPES,
			ADJUSTMENT_TYPE_FILTER_KEYS,
			calculateAdjustmentValue,
			calculatePercentageValue,
			canSetToSalary,
			deselectAdjustmentType,
			deselectTeamMember,
			getPayPeriodForPeriodCount,
			incrementSearchResultsAdjustmentTypes,
			onAdditionalPostChange,
			onBusinessCategoriesOverrideChange,
			onApplyToAdditionalPostChange,
			resetAdjustmentTypeSearchTerm,
			resetNetToGrossEnabled,
			resetTeamMemberSearchTerm,
			reviewNetToGross,
			selectAdjustmentType,
			selectAdjustmentTypeCategory,
			selectSalaryRate,
			selectTeamMember,
			selectedTeamMembers: [], // Make sure this is reset each time the component is initiated otherwise it will duplicate
			setPercentageCalculationToSalary,
			toggleIsApplyToAll,
			toggleSearchTermTeamMembersFocus,
			updateAdjustmentTypeFilter
		});

		validateVm($ctrl);

		// Not valid
		if (!$ctrl.vm.isValid) {
			setComponentState($ctrl.vm.validationState);
			return;
		}

		// Preselect team members if applicable
		if ($ctrl.vm.IS_APPLICABLE_TO_TEAM_MEMBERS && angular.isDefined($ctrl.vm.userIds) && $ctrl.vm.userIds.length > 0) {
			try {
				selectTeamMembersByUserIds($ctrl, $ctrl.vm.userIds);
			}
			catch (error) {
				console.error(error);
			}
		}

		// Preselect adjustment type by id if defined and not an empty guid
		if ($ctrl.vm.selectedAdjustmentTypeId && !validationService.isEmptyGuid($ctrl.vm.selectedAdjustmentTypeId)) {
			selectAdjustmentTypeById($ctrl);
		}

		// Preselect Pension scheme
		if ($ctrl.vm.newAdjustment && $ctrl.vm.newAdjustment.adjustmentType && ($ctrl.vm.newAdjustment.adjustmentType.IsEmployerPension || $ctrl.vm.newAdjustment.adjustmentType.IsEmployeePension)) {
			getPensionsForTeamMember($ctrl);
		}

		// Preselect adjustment type by name if defined
		if ($ctrl.vm.selectedAdjustmentTypeName) {
			selectAdjustmentTypeByName($ctrl);
		}

		try {

			// Setup adjustment categories
			setupAdjustmentCategories($ctrl);
		}
		catch (error) {

			console.error(error);
		}

		setComponentState('ready');
	}

	function calculateAdjustmentValue ($ctrl) {

		$ctrl.vm.newAdjustment.Value = adjustmentsService.getAdjustmentUnitValue($ctrl.vm.newAdjustment);
	}

	function calculatePercentageValue ($ctrl) {

		$ctrl.vm.newAdjustment.Value = adjustmentsService.getAdjustmentPercentageValue($ctrl.vm.newAdjustment);
	}

	function canSetToSalary ($ctrl) {

		if (!$ctrl.vm.IS_SET_TO_SALARY_ENABLED) {
			return false;
		}

		// Only applies to team members with salaries
		return $ctrl.vm.selectedTeamMembers[0].SalaryType === $ctrl.vm.PAYMENT_TYPES.salary;
	}

	function deselectAdjustmentType ($ctrl) {

		$ctrl.vm.newAdjustment.adjustmentType = null;

		setValidity(true);
		resetNetToGrossEnabled($ctrl);
		resetPayslipLabel($ctrl);
	}

	function deselectTeamMember ($ctrl, index) {

		$ctrl.vm.selectedTeamMembers.splice(index, 1);

		resetAdjustmentType($ctrl);

		focusOn(FORM_FIELD_IDS.searchTermTeamMembers);
	}

	function focusOn (elementId) {

		if (!elementId) {
			return;
		}

		$timeout(() => {
			if (document.getElementById(elementId)) {
				document.getElementById(elementId).focus();
			}
			else {
				$rootScope.paycircleMessage(`Unable to apply element focus to #${elementId} as it could not be found.`, 'warn');
			}
		});
	}

	function getAdjustmentTypeByName ($ctrl) {

		const numberOfAdjustmentTypes = $ctrl.vm.adjustmentTypes.length;

		let i = 0;

		for (i; i < numberOfAdjustmentTypes; i++) {

			if ($ctrl.vm.adjustmentTypes[i].AgencyAdjustmentGroupEntryText === $ctrl.vm.selectedAdjustmentTypeName) {
				return angular.copy($ctrl.vm.adjustmentTypes[i]);
			}
		}

		return null;
	}

	function getAdjustmentTypeFilterByFilterKey (filterKey) {

		switch (filterKey) {
			case ADJUSTMENT_TYPE_FILTER_KEYS.deductions:
				return (v) => {
					return v.IsDeduction;
				};
			case ADJUSTMENT_TYPE_FILTER_KEYS.additions:
				return (v) => {
					return !v.IsDeduction;
				};
			default:
				return (v) => {
					return v;
				};
		}
	}

	function getFormFieldIdForAdjustmentType (adjustmentTypeObj) {

		switch (adjustmentTypeObj.AgencyAdjustmentValueType) {

			// Absolute
			case ADJUSTMENT_VALUE_TYPES.absolute:

				// Special types
				switch (adjustmentTypeObj.AgencyAdjustmentSpecialType) {

					// Accrued holiday
					case ADJUSTMENT_SPECIAL_TYPES.accruedHoliday:

						// Accrued holiday is automatically calculated so focus is not required
						return null;

					default:

						return FORM_FIELD_IDS.adjustmentTotalValue;

				}

				break;

			// Linked
			case ADJUSTMENT_VALUE_TYPES.linked:
				return FORM_FIELD_IDS.salaryRate;
			// Unit
			case ADJUSTMENT_VALUE_TYPES.unit:
			// Percentage
			case ADJUSTMENT_VALUE_TYPES.percentage:
				return FORM_FIELD_IDS.adjustmentUnits;

			default:
				return null;
		}
	}

	function getPensionsForTeamMember ($ctrl) {

		setPensionState('loading');

		pensionData.getPensionsForTeamMember($ctrl.vm.selectedTeamMembers[0].UserID, $ctrl.agencyProfileId)
			.then(teamMemberPensionsArr => {

				// Decorate pension with label
				for (let pensionObj of teamMemberPensionsArr) {
					let pensionLabel = `${pensionObj.PensionProviderName} ${pensionObj.EmployerReference}`;
					// Append additional post title if applicable
					if (pensionObj.IsAdditionalPost) {
						pensionLabel += ` (${pensionObj.SalaryPolicyPostTitle})`;
					}
					pensionObj.pensionLabel = pensionLabel;
				}

				$ctrl.vm.selectedTeamMembers[0].pensions = teamMemberPensionsArr;

				if (teamMemberPensionsArr.length > 0) {

					if ($ctrl.vm.newAdjustment.AgencyEmployerPensionID === config.guidEmpty) {
						const defaultPension = pensionService.getDefaultPensionForAdjustment(teamMemberPensionsArr);
						$ctrl.vm.newAdjustment.AgencyEmployerPensionID = defaultPension.AgencyEmployerPensionID;
					}

					focusOn('adjustmentTotalValue');

					setPensionState('ready');
				} else {
					setValidity(false);
				}

			})
			.catch(error => {
				console.error(error);
				setPensionState('error');
			});
	}

	function getPayPeriodForPeriodCount ($ctrl) {

		$ctrl.vm.recurringPayPeriodDisplay = '';

		if (!$ctrl.vm.newAdjustment.RecurringPeriodCount || $ctrl.vm.newAdjustment.RecurringPeriodCount < 1) {
			return;
		}

		payrollData.getPayPeriodForPeriodCount($ctrl.agencyProfileId, $ctrl.vm.newAdjustment.RecurringPeriodCount)
			.then(payPeriodObj => {
				$ctrl.vm.recurringPayPeriodDisplay = payPeriodObj.PayPeriodDisplay;
			})
			.catch(error => {
				console.error(error);
				setComponentState('error');
			});
	}

	function incrementSearchResultsAdjustmentTypes ($ctrl) {

		$ctrl.vm.SEARCH_RESULTS_LIMIT_ADJUSTMENT_TYPES += $ctrl.vm.SEARCH_RESULTS_INCREMENT_COUNT;
	}

	function onBusinessCategoriesOverrideChange ($ctrl) {

		const businessCategories = $ctrl.vm.newAdjustment.overrideBusinessCategories ?
			journalsService.decorateBusinessCategories($ctrl.vm.businessCategories, $ctrl.vm.newAdjustment.UserAgencyProfileBusinessCodeOverrides) :
			[];

		$ctrl.vm.newAdjustment.businessCategories = businessCategories;
	}

	function onAdditionalPostChange ($ctrl) {

		// Sync the SalaryPolicyPostID from the selected additional post object
		$ctrl.vm.newAdjustment.SalaryPolicyPostID = $ctrl.vm.newAdjustment.additionalPost.SalaryPolicyPostID;

		// Re-calculate salary rates for the selected post
		refreshSalaryRatesForPost($ctrl);
	}

	function onApplyToAdditionalPostChange ($ctrl) {

		/* Clear target ID of adjustment and additional post. This removes the additional post association with the adjustment.
		   When 'apply to additional post' is being switched on, this forces reselection. */
		delete($ctrl.vm.newAdjustment.SalaryPolicyPostID);
		delete($ctrl.vm.newAdjustment.additionalPost);

		// Recalc salary rates for main post if switched off
		if (!$ctrl.vm.newAdjustment.applyToAdditionalPost) {
			refreshSalaryRatesForPost($ctrl);
		}
	}

	function refreshSalaryRatesForPost ($ctrl) {

		// If Salaries aren't loaded yet, call reviewTeamMemberSalary which will load them
		if (angular.isUndefined($ctrl.vm.selectedTeamMembers[0].Salaries)) {
			reviewTeamMemberSalary($ctrl);
			return;
		}

		$ctrl.vm.selectedTeamMembers[0].salaryState = 'loading';

		const applyToAdditionalPost = angular.isDefined($ctrl.vm.newAdjustment) && $ctrl.vm.newAdjustment.applyToAdditionalPost;
		const salaryPolicyPostId = applyToAdditionalPost ? $ctrl.vm.newAdjustment.SalaryPolicyPostID : config.guidEmpty;
		const teamMemberSalaryObj = salaryService.getSalaryDetailsWithRatesForPost($ctrl.vm.selectedTeamMembers[0].Salaries, salaryPolicyPostId);

		// If the user had a rate selected, try to find the corresponding rate in the new set
		if ($ctrl.vm.newAdjustment.selectedRate) {
			const newSelectedRate = teamMemberSalaryObj.SalaryRatesWithCalculated.find(
				salaryRate => salaryRate.SalaryRateID === $ctrl.vm.newAdjustment.selectedRate.SalaryRateID
			);
			if (newSelectedRate) {
				$ctrl.vm.newAdjustment.selectedRate = newSelectedRate;
				selectSalaryRate($ctrl);
			} else {
				$ctrl.vm.newAdjustment.selectedRate = null;
			}
		}

		$ctrl.vm.selectedTeamMembers[0].Salary = teamMemberSalaryObj;
		$ctrl.vm.selectedTeamMembers[0].salaryState = 'ready';
	}

	function resetAdjustmentType ($ctrl) {

		$ctrl.vm.newAdjustment.adjustmentType = null;

		resetNetToGrossEnabled($ctrl);
		resetPayslipLabel($ctrl);
	}

	function resetAdjustmentTypeSearchTerm ($ctrl) {

		$ctrl.vm.searchTermAdjustmentTypes = '';
	}

	function resetNetToGrossEnabled ($ctrl) {

		$ctrl.vm.newAdjustment.NetToGross = false;
		$ctrl.vm.newAdjustment.grossAmount = null;
	}

	function resetPayslipLabel ($ctrl) {

		$ctrl.vm.saveLabel = false;

		setAdjustmentLabel($ctrl);
	}

	function resetTeamMemberSearchTerm ($ctrl) {

		$ctrl.vm.searchTermTeamMembers = '';
	}

	function reviewNetToGross ($ctrl, isNetToGrossEnabled, reset) {

		$ctrl.vm.newAdjustment.NetToGross = isNetToGrossEnabled;

		// Force a recalculation
		if (angular.isDefined(reset) && reset) {
			$ctrl.vm.newAdjustment.grossAmount = null;
		}

		if (isNetToGrossEnabled || $ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentNetToGrossOnly) {

			if ($ctrl.vm.newAdjustment.Value && !$ctrl.vm.newAdjustment.grossAmount) {

				setNetToGrossLoadingState($ctrl, 'loading');

				payrollData.getGrossForNetAdjustment($ctrl.agencyProfileId, $ctrl.vm.selectedPayPeriodId, $ctrl.vm.selectedTeamMembers[0].UserID, $ctrl.vm.newAdjustment.Value).then(grossAmount => {

					$ctrl.vm.newAdjustment.grossAmount = grossAmount;

					setNetToGrossLoadingState($ctrl, 'ready');
				})
				.catch(error => {
					$rootScope.paycircleMessage('Unable to calculate Net to Gross for team member.', 'info');
					console.error(error);
					setComponentState('error');
				});
			}
		}
		else {

			$ctrl.vm.newAdjustment.grossAmount = null;
		}
	}

	function reviewTeamMemberHolidayAccrual ($ctrl) {

		var deferred = $q.defer();

		// Team member must be selected
		if ($ctrl.vm.selectedTeamMembers.length === 0) {
			growl.error('No team members have been selected');
			$rootScope.paycircleMessage('A calculated/percentage change type requires a team member to have been selected to work.', 'info');
			deferred.reject('No team members have been selected');
			return deferred.promise;
		}

		// Already populated
		if (angular.isDefined($ctrl.vm.selectedTeamMembers[0].HolidayAccrual)) {
			deferred.resolve();
			return deferred.promise;
		}

		setHolidayAccrualState('loading');

		base.getUserPayYTDHolidayAccrued($ctrl.agencyProfileId, $ctrl.vm.selectedTeamMembers[0].UserID).then(teamMemberHolidayAccrualAmount => {

			$ctrl.vm.selectedTeamMembers[0].HolidayAccrual = teamMemberHolidayAccrualAmount;

			focusOn('adjustmentTotalValue');

			setHolidayAccrualState('ready');
			deferred.resolve();
		})
		.catch(error => {
			console.error(error);
			setHolidayAccrualState('error');
			deferred.reject(error);
		});

		return deferred.promise;
	}

	function reviewTeamMemberLinkedRates ($ctrl) {

		var deferred = $q.defer();

		// Team member must be selected
		if ($ctrl.vm.selectedTeamMembers.length === 0) {
			growl.error('No team members have been selected');
			$rootScope.paycircleMessage('A linked change type requires a team member to have been selected to work.', 'info');
			deferred.reject('No team members have been selected');
			return deferred.promise;
		}

		return deferred.promise;
	}

	function reviewTeamMemberSalary ($ctrl) {

		var deferred = $q.defer();

		// Team member must be selected
		if ($ctrl.vm.selectedTeamMembers.length === 0) {
			growl.error('No team members have been selected');
			$rootScope.paycircleMessage('A calculated/percentage change type requires a team member to have been selected to work.', 'info');
			deferred.reject('No team members have been selected');
			return deferred.promise;
		}

		// Cannot apply to multiple team members
		if ($ctrl.vm.selectedTeamMembers.length > 1) {
			growl.error('Calculated/Percentage change types can only be applied to one team member at a time');
			$rootScope.paycircleMessage('A calculated/percentage change type has been selected for multiple team members. This is not allowed.', 'info');
			deferred.reject('Calculated/Percentage change types can only be applied to one team member at a time');
			return deferred.promise;
		}

		// Skip if salary is already populated
		if (angular.isDefined($ctrl.vm.selectedTeamMembers[0].Salaries)) {
			deferred.resolve();
			return deferred.promise;
		}

		// Load salary object

		$ctrl.vm.selectedTeamMembers[0].salaryState = 'loading';

		payrollData.getTeamMemberSalariesForPostsWithCalculatedRates($ctrl.agencyProfileId, $ctrl.vm.selectedPayPeriodId, $ctrl.vm.selectedTeamMembers[0].UserID).then(teamMemberSalariesObj => {

			const applyToAdditionalPost = angular.isDefined($ctrl.vm.newAdjustment) && $ctrl.vm.newAdjustment.applyToAdditionalPost;

			const salaryPolicyPostId = applyToAdditionalPost ? $ctrl.vm.newAdjustment.SalaryPolicyPostID : config.guidEmpty;

			var teamMemberSalaryObj = salaryService.getSalaryDetailsWithRatesForPost(teamMemberSalariesObj, salaryPolicyPostId);

			// If the user has selected a rate, try to find the corresponding rate in the new set
			if ($ctrl.vm.newAdjustment.selectedRate) {
				const newSelectedRate = teamMemberSalaryObj.SalaryRatesWithCalculated.find(
					salaryRate => salaryRate.SalaryRateID === $ctrl.vm.newAdjustment.selectedRate.SalaryRateID
				);
				if (newSelectedRate) {
					$ctrl.vm.newAdjustment.selectedRate = newSelectedRate;
					selectSalaryRate($ctrl);
				} else {
					$ctrl.vm.newAdjustment.selectedRate = null;
				}
			}

			$ctrl.vm.selectedTeamMembers[0].Salary = teamMemberSalaryObj;
			$ctrl.vm.selectedTeamMembers[0].Salaries = teamMemberSalariesObj;

			$ctrl.vm.selectedTeamMembers[0].salaryState = 'ready';

			deferred.resolve();
		})
		.catch(error => {
			deferred.reject(error);
		});

		return deferred.promise;
	}

	function selectAdjustmentType ($ctrl, adjustmentTypeObj, resetValues) {

		resetValues = angular.isDefined(resetValues) ? resetValues : true;

		angular.extend($ctrl.vm.newAdjustment, {
			adjustmentType: angular.copy(adjustmentTypeObj),
			applyToAdditionalPost: false,
			isApplyToAll: angular.isDefined($ctrl.vm.newAdjustment.isApplyToAll) ? $ctrl.vm.newAdjustment.isApplyToAll : false,
			Deduction: angular.copy(adjustmentTypeObj.IsDeduction),
			ValueType: angular.copy(adjustmentTypeObj.AgencyAdjustmentValueType),
		});

		/* If the SalaryPolicyPostID is empty Guid, it should be removed, as that looks like a valid selection
		   as far as the UI is concerned. */
		if ($ctrl.vm.newAdjustment.SalaryPolicyPostID === config.guidEmpty) {
			delete($ctrl.vm.newAdjustment.SalaryPolicyPostID);
		}

		if (resetValues) {
			adjustmentsService.setDefaultAdjustmentValues($ctrl.vm.newAdjustment.adjustmentType, $ctrl.vm.newAdjustment);
		}

		// Adjustment value types
		switch (adjustmentTypeObj.AgencyAdjustmentValueType) {

			// Absolute
			case ADJUSTMENT_VALUE_TYPES.absolute:

				// When editing and NetToGross is enabled, fetch NetToGross calculation
				if ($ctrl.vm.newAdjustment.NetToGross || $ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentNetToGrossOnly) {
					reviewNetToGross($ctrl, $ctrl.vm.newAdjustment.NetToGross);
				}
				break;

			// Linked (e.g. Daily & Hourly rates / Link rates)
			case ADJUSTMENT_VALUE_TYPES.linked: {

				// Make sure salary is populated
				reviewTeamMemberSalary($ctrl).then(() => {

					// Generate linked rates (and calculated rates if they apply)
					reviewTeamMemberLinkedRates($ctrl).catch(error => {
						console.error(error);
					});
				})
				.catch(error => {
					console.error(error);
				});
			}
		}

		// Special adjustment types
		switch (adjustmentTypeObj.AgencyAdjustmentSpecialType) {

			// Accrued holiday
			case ADJUSTMENT_SPECIAL_TYPES.accruedHoliday: {
				reviewTeamMemberHolidayAccrual($ctrl);
			}
		}

		// Load pensions for team member
		if ($ctrl.vm.CAN_ATTACH_PENSION_SCHEME && (adjustmentTypeObj.IsEmployeePension || adjustmentTypeObj.IsEmployerPension)) {
			getPensionsForTeamMember($ctrl);
		}

		resetAdjustmentTypeSearchTerm($ctrl);

		if ($ctrl.vm.IS_ADJUSTMENT_AMOUNT_APPLICABLE) {
			focusOn(getFormFieldIdForAdjustmentType(adjustmentTypeObj));
		}
	}

	function selectAdjustmentTypeById ($ctrl) {

		const selectedAdjustmentTypeObj = adjustmentsService.getAdjustmentTypeById('AgencyAdjustmentGroupEntryID', $ctrl.vm.selectedAdjustmentTypeId, $ctrl.vm.adjustmentTypes);

		if (!selectedAdjustmentTypeObj) {
			const message = 'Change Creator > selectAdjustmentTypeById > No adjustment type matched: Unable to pre-select';
			$rootScope.paycircleMessage(message, 'info');
			coralogixService.noticeError(message);
			return;
		}

		selectAdjustmentType($ctrl, selectedAdjustmentTypeObj, false);
	}

	function selectAdjustmentTypeByName ($ctrl) {

		const selectedAdjustmentTypeObj = getAdjustmentTypeByName($ctrl);

		if (!selectedAdjustmentTypeObj) {
			$rootScope.paycircleMessage('Change Creator > selectAdjustmentTypeByName > No adjustment type matched: Unable to pre-select', 'info');
			return;
		}

		selectAdjustmentType($ctrl, selectedAdjustmentTypeObj);
	}

	function selectAdjustmentTypeCategory ($ctrl, categoryIndex) {

		if (!$ctrl.vm.adjustmentTypesCategories.length) {
			console.warn('No enabled categories or categories with results');
			return;
		}

		const activeCategoryObj = $ctrl.vm.adjustmentTypesCategories[categoryIndex];

		$ctrl.vm.adjustmentTypesCategory = angular.copy(activeCategoryObj);
		$ctrl.vm.adjustmentTypesCategoryKey = angular.copy(activeCategoryObj.key);
	}

	function selectSalaryRate ($ctrl) {

		$timeout(() => {

			if (!$ctrl.vm.newAdjustment.selectedRate) {
				$ctrl.vm.newAdjustment.Value = null;
				return;
			}

			adjustmentsService.selectSalaryRate($ctrl.vm.newAdjustment.adjustmentType, $ctrl.vm.newAdjustment);

			if ($ctrl.vm.newAdjustment.selectedRate.SalaryRateID === 'custom') {
				focusOn('adjustmentUnitValue');
			}

			calculateAdjustmentValue($ctrl);
		});
	}

	function selectTeamMember ($ctrl, teamMemberObj) {

		$ctrl.vm.selectedTeamMembers.push(teamMemberObj);

		updateTeamDescriptionLabel($ctrl);
		setupAdjustmentTypesForUserTypes($ctrl);
		updateAdjustmentTypeFilter($ctrl);
		resetTeamMemberSearchTerm($ctrl);
	}

	function selectTeamMemberByUserId ($ctrl, userId) {

		const selectedTeamMemberObj = $ctrl.vm.teamMembers.find(teamMemberObj => teamMemberObj.UserID === userId);

		selectTeamMember($ctrl, selectedTeamMemberObj);
	}

	function selectTeamMembersByUserIds ($ctrl, userIds) {

		userIds.forEach(userId => {

			selectTeamMemberByUserId($ctrl, userId);
		});
	}

	function setAdjustmentLabel ($ctrl, adjustmentLabel) {

		adjustmentLabel = angular.isDefined(adjustmentLabel) ? adjustmentLabel : '';

		$ctrl.vm.newAdjustment.Label = adjustmentLabel;
		$ctrl.vm.selectedAdjustmentLabel = adjustmentLabel;
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setHolidayAccrualState (holidayAccrualState) {

		$ctrl.holidayAccrualState = holidayAccrualState;
	}

	function setNetToGrossLoadingState ($ctrl, netToGrossLoadingState) {

		$ctrl.vm.newAdjustment.netToGrossLoadingState = netToGrossLoadingState;
	}

	function setPensionState (pensionState) {

		$ctrl.pensionState = pensionState;
	}

	function setPercentageCalculationToSalary ($ctrl) {

		reviewTeamMemberSalary($ctrl).then(() => {

			$ctrl.vm.newAdjustment.UnitValue = angular.copy($ctrl.vm.selectedTeamMembers[0].Salary.SalaryYearly);

			calculatePercentageValue($ctrl);
		})
		.catch(error => {
			console.error(error);
		});
	}

	function setupAdjustmentCategories ($ctrl) {

		$ctrl.vm.adjustmentTypesCategoryKey = null;
		$ctrl.vm.adjustmentTypesCategories = [
			{
				count: 0,
				key: 'all',
				isEnabled: false,
				name: 'All',
				filter: value => { return value.IsDeduction; }
			},
			{
				count: 0,
				key: 'additions',
				isEnabled: true,
				name: 'Additions',
				filter: value => { return !value.IsDeduction; }
			},
			{
				count: 0,
				key: 'deductions',
				isEnabled: true,
				name: 'Deductions',
				filter: value => { return value.IsDeduction; }
			},
			{
				count: 0,
				key: 'calculated',
				isEnabled: true,
				name: 'Calculated',
				filter: value => { return value.Category === 'Calculated'; } // TODO: Need service to return category type and map to ENUM to avoid category name changing
			}
		];

		// Populate counts
		$ctrl.vm.adjustmentTypes.forEach(adjustmentType => {

			// Add total count
			$ctrl.vm.adjustmentTypesCategories[0].count++;

			// Calculated
			if (adjustmentType.Category === 'Calculated') {
				$ctrl.vm.adjustmentTypesCategories[3].count++;
				return;
			}

			// Deductions
			if (adjustmentType.IsDeduction) {
				$ctrl.vm.adjustmentTypesCategories[2].count++;
				return;
			}

			// Additions
			else {
				$ctrl.vm.adjustmentTypesCategories[1].count++;
				return;
			}
		});

		// Remove any inactive categories
		$ctrl.vm.adjustmentTypesCategories = $ctrl.vm.adjustmentTypesCategories.filter(_ => { return _.isEnabled && _.count > 0; });

		// Select active category
		selectAdjustmentTypeCategory($ctrl, 0);
	}

	function setupAdjustmentTypesForUserTypes ($ctrl) {

		/*
		const ADJUSTMENT_TYPE_STATES = {
			none: -1,
			payrollOnly: 0,
			cisOnly: 1,
			all: 2
		};
		*/

		let hasCISTeamMembers = false;
		let hasPAYETeamMembers = false;
		let returnedAdjustmentTypesArr = angular.copy($ctrl.vm.adjustmentTypesOriginal);

		$ctrl.vm.selectedTeamMembers.forEach((teamMemberObj) => {

			if (teamMemberObj.IsCISSubcontractor) {
				hasCISTeamMembers = true;
			}
			else {
				hasPAYETeamMembers = true;
			}
		});

		// Filter original set based on team members chosen
		returnedAdjustmentTypesArr = returnedAdjustmentTypesArr.filter((adjustmentTypeObj) => {

			// Multiple team members
			if ($ctrl.vm.selectedTeamMembers.length > 1) {

				// No percentage types allowed for multiple selection
				if (adjustmentTypeObj.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.percentage) {
					return;
				}

				// No accrued holiday allowed for multiple selection
				if (adjustmentTypeObj.AgencyAdjustmentSpecialType === ADJUSTMENT_SPECIAL_TYPES.accruedHoliday) {
					return;
				}
			}

			// CIS & Payroll
			if (hasPAYETeamMembers && hasCISTeamMembers) {
				return adjustmentTypeObj;
			}

			// Payroll only
			if (hasPAYETeamMembers) {
				return adjustmentTypeObj.Category !== 'CIS';
			}

			// CIS only
			if (hasCISTeamMembers) {
				return adjustmentTypeObj.Category === 'CIS';
			}
		});

		// No adjustment types
		if ($ctrl.vm.adjustmentTypes.length === 0) {
			setComponentState('no-adjustment-types');
			return;
		}

		$ctrl.vm.adjustmentTypes = returnedAdjustmentTypesArr;
		$ctrl.vm.adjustmentTypesCount = adjustmentsService.getAdjustmentTypesCounts(returnedAdjustmentTypesArr);
	}

	function setValidity (isValid) {
		$ctrl.vm.isValid = isValid;
	}

	function toggleIsApplyToAll (newAdjustmentObj) {

		newAdjustmentObj.isApplyToAll = !newAdjustmentObj.isApplyToAll;
	}

	function toggleSearchTermTeamMembersFocus ($ctrl, newValue) {

		$ctrl.vm.searchTermTeamMembersFocused = newValue;
	}

	function updateAdjustmentTypeFilter ($ctrl, filterKey) {

		// Use filter key if defined, otherwise base it on initial count
		filterKey = angular.isDefined(filterKey) ? filterKey : $ctrl.vm.adjustmentTypesCount.totalAdditions > 0 ? ADJUSTMENT_TYPE_FILTER_KEYS.additions : ADJUSTMENT_TYPE_FILTER_KEYS.deductions;

		$ctrl.vm.adjustmentTypesFilter = getAdjustmentTypeFilterByFilterKey(filterKey);
		$ctrl.vm.adjustmentTypesFilterKey = filterKey;
	}

	function updateTeamDescriptionLabel ($ctrl) {

		$ctrl.vm.teamDescriptionLabel = '';

		// Summarise if more than 1 team member
		if ($ctrl.vm.selectedTeamMembers.length > 1) {

			$ctrl.vm.teamDescriptionLabel = `${$ctrl.vm.selectedTeamMembers.length} team members`;

			return;
		}

		$ctrl.vm.selectedTeamMembers.forEach((teamMemberObj, index) => {

			if (index > 0) {
				$ctrl.vm.teamDescriptionLabel += ', ';
			}

			$ctrl.vm.teamDescriptionLabel += `${teamMemberObj.Forename} ${teamMemberObj.Surname}`;
		});
	}

	function validateVm ($ctrl) {

		setValidity(true);
		$ctrl.vm.validationState = null;

		// No adjustment types
		if ($ctrl.vm.adjustmentTypes.length === 0) {
			setValidity(false);
			$ctrl.vm.validationState = 'no-adjustment-types';
			$rootScope.paycircleMessage('Change Creator: No adjustment types are available', 'error');
			return $ctrl;
		}

		// No team members
		if ($ctrl.vm.IS_APPLICABLE_TO_TEAM_MEMBERS && $ctrl.vm.teamMembers.length === 0) {
			setValidity(false);
			$ctrl.vm.validationState = 'no-team-members';
			$rootScope.paycircleMessage(`Change Creator: Configured to apply to team members but no team members are defined.
				Either populate the teamMembers array or you can switch IS_APPLICABLE_TO_TEAM_MEMBERS to false if this is company specific
			`, 'error');
			return $ctrl;
		}

		return $ctrl;
	}

	angular.extend($ctrl, {
		$onInit
	});

	/* Watch for changes for the selected adjustment type (by ID or name). When used to edit a set of adjustments,
	   this component needs to auto-select the adjustment type when switching
	$scope.$watch('$ctrl.vm.selectedAdjustmentTypeId', (newValue, oldValue) => {
		if (newValue !== oldValue) {
			if ($ctrl.vm.selectedAdjustmentTypeId && !validationService.isEmptyGuid($ctrl.vm.selectedAdjustmentTypeId)) {
				selectAdjustmentTypeById($ctrl);
			}
		}
	});
	$scope.$watch('$ctrl.vm.selectedAdjustmentTypeName', (newValue, oldValue) => {
		if (newValue !== oldValue) {
			selectAdjustmentTypeByName($ctrl);
		}
	}); */
}]);

'use strict';

angular.module('paycircleApp')
.component('changesImported', {
	bindings: {
		agencyProfileId: '<',
		isWorkflowActive: '<',
		onImport: '&',
		payPeriod: '<',
		userPayElements: '<'
	},
	controller: 'changesImportedCtrl',
	templateUrl: 'components/changes-imported/changes-imported.component.html',
})
.controller('changesImportedCtrl', [
	'$rootScope',
	'FULL_SCREEN_MODAL_KEYS',
	'WORKFLOW_CHANGES_TABLE_STATES',
function (
	$rootScope,
	FULL_SCREEN_MODAL_KEYS,
	WORKFLOW_CHANGES_TABLE_STATES
) {

	const $ctrl = this;

	function getPayElementCounts (userPayElementsArr) {

		const payElementObj = {
			totalCount: 0,
			additions: {
				count: 0,
				value: 0
			},
			deductions: {
				count: 0,
				value: 0
			}
		};

		for (let teamMemberObj of userPayElementsArr) {

			payElementObj.totalCount += teamMemberObj.PayElements.length;

			for (let teamMemberPayElementsObj of teamMemberObj.PayElements) {

				if (teamMemberPayElementsObj.Deduction) {
					payElementObj.deductions.count++;
					payElementObj.deductions.value += teamMemberPayElementsObj.Value;

				} else {
					payElementObj.additions.count++;
					payElementObj.additions.value += teamMemberPayElementsObj.Value;
				}
			}
		}

		return payElementObj;
	}

	function openChangesTable (ctrlObj) {

		$rootScope.$broadcast('open-full-screen-modal', {
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onImport,
			modalKey: FULL_SCREEN_MODAL_KEYS.changesTable,
			payPeriodId: ctrlObj.payPeriod.PayPeriodID,
		});
	}

	function submitChanges (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onImport,
			formKey: 'submit-changes-table'
		});
	}

	$ctrl.$onInit = function () {

		// Check what state the changes table submission is in.
		let changesTableMessage = '';
		let changesTableCanBeSubmitted = false;
		if ($ctrl.payPeriod.ChangesTableState === WORKFLOW_CHANGES_TABLE_STATES.submitted) {
			changesTableMessage = 'The changes table has been submitted for review before importing.';
		}
		else if ($ctrl.isWorkflowActive) {
			changesTableMessage = 'Check that you’ve added all your changes before clicking ‘I’ve added everything’.';
		}
		else {
			// Show submit option for non-[paycircle, bureau, bureaumanager] roles
			if (!$rootScope.userHasRole(['paycircle', 'bureau', 'bureaumanager'])) {
				changesTableMessage = 'Add your changes then submit them for review.';
				changesTableCanBeSubmitted = true;
			}
			// Nothing additional is shown for [paycircle, bureau, bureaumanager] roles
		}

		angular.extend($ctrl, {
			changesTableMessage,
			changesTableCanBeSubmitted,
			payElements: getPayElementCounts($ctrl.userPayElements),
			openChangesTable,
			submitChanges
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('changesTable', {
	bindings: {
		changesOptions: '='
	},
	controller: 'changesTableCtrl',
	templateUrl: 'components/changes-table/changes-table.component.html',
})
.controller('changesTableCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$state',
	'$timeout',
	'adjustmentsService',
	'config',
	'dataImport',
	'growl',
	'importService',
	'messageData',
	'payPeriodService',
	'payrollData',
	'searchService',
	'session',
	'teamData',
	'teamService',
	'salaryService',
	'ADJUSTMENT_VALUE_TYPES',
	'IMPORT_MAPPING_TYPES',
	'TOOLTIPS',
	'USER_IMPORT_GROUP_STATES',
	'WORKFLOW_CHANGES_TABLE_STATES',
function (
	$filter,
	$q,
	$rootScope,
	$state,
	$timeout,
	adjustmentsService,
	config,
	dataImport,
	growl,
	importService,
	messageData,
	payPeriodService,
	payrollData,
	searchService,
	session,
	teamData,
	teamService,
	salaryService,
	ADJUSTMENT_VALUE_TYPES,
	IMPORT_MAPPING_TYPES,
	TOOLTIPS,
	USER_IMPORT_GROUP_STATES,
	WORKFLOW_CHANGES_TABLE_STATES
) {

	const $ctrl = this;

	const CURRENT_USER_ID = session.getUserId();

	const COMPONENT_STATES = {
		confirmImport: 'confirmImport',
		error: 'error',
		imported: 'imported',
		importing: 'importing',
		loading: 'loading',
		noAdjustmentsAvailable: 'no-adjustments-available',
		noTeamMembers: 'no-team-members',
		payrollPartiallySubmitted: 'payroll-partially-submitted',
		ready: 'ready',
	};

	const HEADER_STATES = {
		cancel: 'cancel',
		default: 'default',
		delete: 'delete'
	};

	const PAY_ELEMENT_STATES = {
		editing: 'editing',
		edited: 'edited'
	};

	const COLUMN_WIDTHS = {
		wide: 390,
		extrawide: 640,
		default: 210
	};

	const TEAM_MEMBER_VIEW_TYPES = [
		{
			prop: 'fullname',
			display: 'Name'
		},
		{
			prop: 'PayrollID',
			display: 'Payroll ID'
		},
		{
			prop: 'NINumber',
			display: 'NI Number'
		}
	];

	let AGENCY_PROFILE_ID;
	let PAY_PERIOD_ID;
	let USER_IMPORT_GROUP_ID;
	let SALARY_PROMISES_CACHE = {}; // Cache to store promises or resolved data

	function addNewPayElementForTeamMember (ctrlObj, teamMemberObj, payElementObj) {

		let newPayElementObj = getNewPayElementForTeamMember(ctrlObj, teamMemberObj, payElementObj);

		const payElementState = payElementObj.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.linked ? PAY_ELEMENT_STATES.edited : PAY_ELEMENT_STATES.editing;

		addPayElementToTable(ctrlObj, newPayElementObj, payElementState).then(() => {
			if (payElementObj.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.linked) {
				fetchTeamMemberSalary(teamMemberObj,
					payElementObj,
					ctrlObj,
					false
				);
			}

			focusOnElement(newPayElementObj.postId + payElementObj.id);
		});
	}

	function addPayElementToTable (ctrlObj, payElementObj, payElementState) {

		return $q(resolve => {

			let teamMemberTableObj = getTeamMemberFromTable(ctrlObj, payElementObj.postId);

			if (!teamMemberTableObj) {
				teamMemberTableObj = {};
			}

			payElementObj.state = payElementState;

			teamMemberTableObj[payElementObj.id] = payElementObj;

			ctrlObj.updatedPayElements[payElementObj.postId] = teamMemberTableObj;

			resolve();
		});
	}

	function changeOrderBy (searchOptionsObj, orderByOptionObj) {
		searchService.changeOrderBy(searchOptionsObj, orderByOptionObj);
	}

	function createNewUserImportGroup (ctrlObj) {

		return $q((resolve, reject) => {
			let updatedElementsArr = getUpdatedElements(ctrlObj);

			ctrlObj.payElementSavedCount = updatedElementsArr.length;

			payrollData.updateUserPayElementsForImportGroup(AGENCY_PROFILE_ID, PAY_PERIOD_ID, updatedElementsArr, USER_IMPORT_GROUP_ID).then(() => {

				getUserImportGroup()
					.then(resolve)
					.catch(reject);
			})
			.catch(reject);
		});
	}

	function decoratePayElements (payElementObj) {

		payElementObj.columnWidth = getColumnWidthForPayElement(payElementObj);
		payElementObj.id = getPayElementId(payElementObj);

		return [
			ADJUSTMENT_VALUE_TYPES.absolute, 
			ADJUSTMENT_VALUE_TYPES.unit, 
			ADJUSTMENT_VALUE_TYPES.percentage,
			ADJUSTMENT_VALUE_TYPES.linked
		].includes(payElementObj.AgencyAdjustmentValueType);
	}

	function deletePayElementFromTeamMember (ctrlObj, teamMemberObj, payElementObj) {

		let teamMemberTableObj = getTeamMemberFromTable(ctrlObj, teamMemberObj.postId);

		delete teamMemberTableObj[payElementObj.id];

		if (Object.values(teamMemberTableObj).length === 0) {
			delete ctrlObj.updatedPayElements[teamMemberObj.postId];
		}

		updatePayElementTotals(ctrlObj);
	}

	function deleteUserImportGroup (ctrlObj) {

		if (isUserImportGroupSaved()) {
			dataImport.deleteUserImportGroup(USER_IMPORT_GROUP_ID).then(() => {

				setCallbackOnClose(ctrlObj);
				resetTable(ctrlObj);
				growl.success('All changes deleted');
			})
			.catch(onError);

		} else {
			resetTable(ctrlObj);
			growl.success('All changes deleted');
		}
	}

	function editPayElementForTeamMember (ctrlObj, teamMemberObj, payElementObj) {
		getTeamMemberPayElement(ctrlObj, teamMemberObj, payElementObj).state = PAY_ELEMENT_STATES.editing;
	}

	function focusOnElement (elementId) {
		$timeout(function () {
			let tableElement = document.getElementById(elementId);

			if (tableElement) {
				tableElement.focus();

				if (angular.isDefined(tableElement.select)) {
					tableElement.select();
				}
			}
		});
	}

	function getAdjustmentValue (payElementObj, teamMemberPayElementObj) {

		switch (payElementObj.AgencyAdjustmentValueType) {
			case ADJUSTMENT_VALUE_TYPES.percentage:
				return adjustmentsService.getAdjustmentPercentageValue(teamMemberPayElementObj);
			case ADJUSTMENT_VALUE_TYPES.linked:
			case ADJUSTMENT_VALUE_TYPES.unit:
				return adjustmentsService.getAdjustmentUnitValue(teamMemberPayElementObj);
			default:
				return teamMemberPayElementObj.Value;
		}
	}

	function getColumnWidthForPayElement (payElementObj) {

		switch (payElementObj.AgencyAdjustmentValueType) {
			case ADJUSTMENT_VALUE_TYPES.unit:
			case ADJUSTMENT_VALUE_TYPES.percentage:
				return COLUMN_WIDTHS.wide;
			case ADJUSTMENT_VALUE_TYPES.linked:
				return COLUMN_WIDTHS.extrawide;
			default:
				return COLUMN_WIDTHS.default;
		}
	}

	function getTeamMembersAdjustmentTypeFilterKey (teamMembersArr) {

		for (const teamMemberObj of teamMembersArr) {

			if (teamMemberObj.IsCISSubcontractor) {
				return 'all';
			}
		}

		return 'paye';
	}

	function getNewPayElementForTeamMember (ctrlObj, teamMemberObj, payElementObj) {

		let newPayElementObj = angular.copy(ctrlObj.emptyPayElement);

		angular.extend(newPayElementObj, {
			AgencyAdjustmentGroupEntryID: adjustmentsService.getAgencyAdjustmentGroupEntryId(payElementObj),
			id: payElementObj.id,
			PayPeriodID: PAY_PERIOD_ID,
			postId: teamMemberObj.postId,
			// Salary Policy Post ID !== emptyGuid for additional posts
			SalaryPolicyPostID: teamMemberObj.salaryPolicyPostId,
			UserID: teamMemberObj.UserID
		});

		adjustmentsService.setDefaultAdjustmentValues(payElementObj, newPayElementObj);

		return newPayElementObj;
	}

	function getPayElementId (payElementObj) {
		return payElementObj.Description ? $filter('slugify')(payElementObj.Description) : $filter('slugify')(payElementObj.AgencyAdjustmentGroupEntryText);
	}

	function getPayElementsFromImportGroup (ctrlObj) {

		const FUTURE_ADJUSTMENTS = false;
		const USER_ID = null;

		return $q((resolve, onError) => {
			payrollData.getUserPayElements(AGENCY_PROFILE_ID, PAY_PERIOD_ID, USER_ID, FUTURE_ADJUSTMENTS, USER_IMPORT_GROUP_ID).then(payElementGroupArr => {
				processPayElementsFromGroup(ctrlObj, payElementGroupArr).then(() => {
					resolve(ctrlObj);
				});
			})
			.catch(onError);
		});
	}

	function getPayElementsFromTable (ctrlObj) {
		return Object.keys(ctrlObj.updatedPayElements).reduce((returnArr, postId) => {
			return returnArr.concat(Object.values(ctrlObj.updatedPayElements[postId]));
		}, []);
	}

	function getTeamMemberFromTable (ctrlObj, postId) {
		return ctrlObj.updatedPayElements[postId];
	}

	function getTeamMemberPayElement (ctrlObj, teamMemberObj, payElementObj) {
		return getTeamMemberFromTable(ctrlObj, teamMemberObj.postId)[payElementObj.id];
	}

	function getUpdatedElements (ctrlObj) {

		let updatedPayElementArr = getPayElementsFromTable(ctrlObj);

		return updatedPayElementArr.filter(adjustmentsService.resetNewAdjustmentValues);
	}

	function getUserImportGroup () {

		return $q((resolve, reject) => {
			dataImport.getUserImportGroupForUser(PAY_PERIOD_ID, CURRENT_USER_ID, IMPORT_MAPPING_TYPES.changesTable).then(userImportGroupObj => {

				USER_IMPORT_GROUP_ID = userImportGroupObj.UserImportGroupID;
				resolve(userImportGroupObj);
			})
			.catch(reject);
		});
	}

	function goToCompanyState (ctrlObj, state) {

		ctrlObj.changesOptions.closeModal();

		$state.go(state, {
			agencyProfileId: AGENCY_PROFILE_ID,
		});
	}

	function init () {

		const INCLUDE_LEAVERS = false;

		const getAgencyAdjustmentGroupCombined = payrollData.getAgencyAdjustmentGroupCombined(AGENCY_PROFILE_ID);
		const getEmptyUserPayElementDetail = payrollData.getEmptyUserPayElementDetail(AGENCY_PROFILE_ID);
		const getUserAgencyProfilesForAgencyTeamMemberMinimum = teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(AGENCY_PROFILE_ID, INCLUDE_LEAVERS);
		const getUserImportGroupForUser = getUserImportGroup();

		$q.all([
			getAgencyAdjustmentGroupCombined,
			getEmptyUserPayElementDetail,
			getUserAgencyProfilesForAgencyTeamMemberMinimum,
			getUserImportGroupForUser])
		.then(([
			adjustmentGroupsObj,
			emptyPayElementObj,
			teamMembersArr,
			userImportGroupObj
		]) => {
			let teamMembersAdjustmentTypeFilterKey = getTeamMembersAdjustmentTypeFilterKey(teamMembersArr);

			let adjustmentTypesArr = adjustmentsService.getAllAdjustmentTypesFromAdjustmentGroup(adjustmentGroupsObj, teamMembersAdjustmentTypeFilterKey);

			let searchOptionsObj = searchService.getOptionsWithDefaults(searchService.changesTable);

			// Block changes when payroll is partially submitted
			if ($rootScope.currentPeriod.IsPayrollPartiallySubmitted) {
				$ctrl.submittedFiles = payPeriodService.getSuccessfulSubmissionsDisplayForPayPeriod($rootScope.currentPeriod);
				setComponentState(COMPONENT_STATES.payrollPartiallySubmitted);
			    setShowClose();
				return;
			}

			const EXPAND_ADDITIONAL_POSTS = true;
			let ctrlObj = {
				emptyPayElement: emptyPayElementObj,
				errorMessages: {
					required: 'Please enter a value',
					pattern: 'Maximum of ' + $filter('monetise')(config.number7Digits4Decimal),
					number: 'Value must be a number'
				},
				errorMessagesMultiplier: {
					required: 'Please enter a value',
					pattern: 'Maximum of ' + $filter('monetise')(config.number7Digits2Decimal),
					number: 'Value must be a number'
				},
				errorMessagesRate: {
					required: 'Please select a rate'
				},
				errorMessagesTotals: {
					required: 'Please enter a value',
					pattern: 'Maximum of ' + $filter('monetise')(config.number9Digits2Decimal),
					number: 'Value must be a number'
				},
				headerState: HEADER_STATES.default,
				payElements: adjustmentTypesArr.filter(decoratePayElements),
				searchOptions: searchOptionsObj,
				showSearch: false,
				showMarkAsActiveTooltip: false,
				teamMembers: teamService.decorateAndFilterTeamMembers(teamMembersArr, { ExcludeFromPayroll: true, IsOnHold: true, IsOffPayrollWorker: true, IsAdvancingFuturePeriods: true, HasAdvancedFuturePeriods: true }, EXPAND_ADDITIONAL_POSTS),
				teamMembersAdjustmentTypeFilterKey: teamMembersAdjustmentTypeFilterKey,
				teamMemberView: TEAM_MEMBER_VIEW_TYPES.find(viewTypeObj => viewTypeObj.prop === 'fullname').prop,
				updatedPayElements: {},
				isImportGroupComplete: (userImportGroupObj.State === USER_IMPORT_GROUP_STATES.complete && isUserImportGroupSaved()),
			};

			if (ctrlObj.teamMembers.length === 0) {
				setComponentState(COMPONENT_STATES.noTeamMembers);
				setShowClose();
				return;
			}

			setChangesMade(false);

			if (importService.hasUserImportedElements(userImportGroupObj)) {
				getPayElementsFromImportGroup(ctrlObj)
					.then(loadTable)
					.catch(onError);

			} else {
				loadTable(ctrlObj);
			}
		})
		.catch(onError);
	}

	function isUserImportGroupSaved () {
		return USER_IMPORT_GROUP_ID !== config.guidEmpty;
	}

	function loadTable (ctrlObj) {
		$ctrl.missingPayElementDescriptions = [];
		let usedPayElementsVisible = getIsUsedPayElementsVisibleInPack(ctrlObj);
		if (usedPayElementsVisible.isVisible) {
			updatePayElementTotals(ctrlObj);
			angular.extend($ctrl, ctrlObj);
			setComponentState(COMPONENT_STATES.ready);
		}
		else {
			$ctrl.missingPayElementDescriptions = usedPayElementsVisible.missingPayElementDescriptions;
			setComponentState(COMPONENT_STATES.noAdjustmentsAvailable);
		}
	}

	function onConfirmImport (ctrlObj) {

		setComponentState(COMPONENT_STATES.importing);

		if (isUserImportGroupSaved()) {
			updateUserImportGroupApproved(ctrlObj);

		} else {
			createNewUserImportGroup(ctrlObj).then(() => {
				updateUserImportGroupApproved(ctrlObj);
			})
			.catch(onError);
		}
	}

	function onCancelClick (ctrlObj) {

		if (ctrlObj.changesMade) {
			setHeaderState(HEADER_STATES.cancel);
		} else {
			ctrlObj.changesOptions.closeModal();
		}
	}

	function onCellChange (ctrlObj) {
		setChangesMade(true);
		updatePayElementTotals(ctrlObj);
	}

	function onFormSave () {

		setFormState('saved');
		growl.success('Changes saved');

		$timeout(function () {
			setFormState(null);
		}, 2000);
	}

	function onError (error) {
		setComponentState(COMPONENT_STATES.error);
	    console.error(error);
	    setShowClose();
	}

	function onTableCellClick (ctrlObj, teamMemberObj, payElementObj) {

		let teamMemberPayElementObj = getTeamMemberPayElement(ctrlObj, teamMemberObj, payElementObj);

		if (teamMemberPayElementObj.state === PAY_ELEMENT_STATES.edited) {
			teamMemberPayElementObj.state = PAY_ELEMENT_STATES.editing;
		}
	}

	function openMarkAsActiveTooltip (ctrlObj) {
		ctrlObj.showMarkAsActiveTooltip = true;
	}

	function processPayElementsFromGroup (ctrlObj, payElementGroupArr) {

		let payElementsArr = payElementGroupArr.map(teamMemberObj => teamMemberObj.PayElements).flat();

		ctrlObj.payElementSavedCount = 0;

		return $q(resolve => {

			if (payElementsArr.length === 0) {
				resolve();
			}

			for (let payElementObj of payElementsArr) {

				angular.extend(payElementObj, {
					id: getPayElementId(payElementObj),
					// Uniquely identify pay element by post (UserId + SalaryPolicyPostID)
					postId: payElementObj.UserID + payElementObj.SalaryPolicyPostID
				});

				addPayElementToTable(ctrlObj, payElementObj, PAY_ELEMENT_STATES.edited).then(() => {

					ctrlObj.payElementSavedCount++;

					if (payElementObj.ValueType === ADJUSTMENT_VALUE_TYPES.linked) {
						fetchTeamMemberSalary({ UserID: payElementObj.UserID, postId: payElementObj.postId, salaryPolicyPostId: payElementObj.SalaryPolicyPostID },
							payElementObj,
							ctrlObj,
							true
						);
					}

					if (ctrlObj.payElementSavedCount === payElementsArr.length) {
						resolve();
					}
				});
			}
		});
	}

	function resetTable (ctrlObj) {

		angular.extend(ctrlObj, {
			headerState: HEADER_STATES.default,
			payElementSavedCount: 0,
			updatedPayElements: {},
			isImportGroupComplete: false
		});

		USER_IMPORT_GROUP_ID = config.guidEmpty;
		setChangesMade(false);
		updatePayElementTotals(ctrlObj);
	}

	function setCallbackOnClose (ctrlObj) {

		if (!angular.isDefined(ctrlObj.changesOptions.onClose)) {
			ctrlObj.changesOptions.onClose = ctrlObj.changesOptions.callback;
		}
	}

	function setChangesMade (changesMadeBool) {
		$ctrl.changesMade = changesMadeBool;
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function setFormState (newState) {
		if ($ctrl.changesTableForm) {
			$ctrl.changesTableForm.state = newState;
		}
	}

	function setHeaderState (newState) {
		$ctrl.headerState = newState;
	}

	function setShowClose () {
		$ctrl.changesOptions.showClose = true;
	}

	function toggleSearch (ctrlObj) {
		ctrlObj.showSearch = !ctrlObj.showSearch;

		if (ctrlObj.showSearch) {
			focusOnElement('changes-table-search');
		}
	}

	function updateUserImportGroupState (ctrlObj, newImportGroupState) {

		// If new state is 'approved', also update the workflow template changes table state
		const updateChangesTable = [];
		if (newImportGroupState = USER_IMPORT_GROUP_STATES.approved) {
			updateChangesTable.push(messageData.updateWorkflowTemplateChangesTableState(AGENCY_PROFILE_ID, WORKFLOW_CHANGES_TABLE_STATES.complete));
		}
		updateChangesTable.push(dataImport.updateUserImportGroupState(USER_IMPORT_GROUP_ID, newImportGroupState));

		return $q((resolve, reject) => {
			$q.all(updateChangesTable).then(() => {
				setCallbackOnClose(ctrlObj);
				resolve();
			})
			.catch(reject);
		});
	}

	function getIsUsedPayElementsVisibleInPack (ctrlObj) {
		let returnValue = {
			isVisible: false,
			missingPayElementDescriptions: []
		};

		if (ctrlObj.payElements.length === 0) {
			return returnValue;
		}

		let teamMemberPayElementsArr = getPayElementsFromTable(ctrlObj);

		for (let teamMemberPayElementObj of teamMemberPayElementsArr) {

			// If matching pay element within pack doesn't exist then show warning
			let payElementObj = ctrlObj.payElements.find(payElementObj => payElementObj.id === teamMemberPayElementObj.id);

			if (!payElementObj) {
				returnValue.missingPayElementDescriptions.push(teamMemberPayElementObj.Description);
			}
		}

		if(returnValue.missingPayElementDescriptions.length < 1){
			returnValue.isVisible = true;
		}

		return returnValue;
	}

	function updatePayElementTotals (ctrlObj) {

		let teamMemberPayElementsArr = getPayElementsFromTable(ctrlObj);

		for (let payElementObj of ctrlObj.payElements) {
			payElementObj.totalValue = 0;
		}

		for (let teamMemberPayElementObj of teamMemberPayElementsArr) {

			let payElementObj = ctrlObj.payElements.find(payElementObj => payElementObj.id === teamMemberPayElementObj.id);

			teamMemberPayElementObj.Value = getAdjustmentValue(payElementObj, teamMemberPayElementObj);

			if (teamMemberPayElementObj.Value && teamMemberPayElementObj.Value !== '') {
				payElementObj.totalValue += parseFloat(teamMemberPayElementObj.Value);
			}

		}
	}

	function updateUserImportGroupApproved (ctrlObj) {

		updateUserImportGroupState(ctrlObj, USER_IMPORT_GROUP_STATES.approved).then(() => {
			setComponentState(COMPONENT_STATES.imported);
			setShowClose();
		})
		.catch(onError);
	}

	function updateUserPayElementsForImportGroup (ctrlObj) {

		setFormState('saving');

		let updatedElementsArr = getUpdatedElements(ctrlObj);

		ctrlObj.payElementSavedCount = updatedElementsArr.length;

		getIsSavingPayElementsVisibleInPack(ctrlObj, updatedElementsArr).then(function(savingPayElementsVisible){
			if(savingPayElementsVisible.isVisible){
				payrollData.updateUserPayElementsForImportGroup(AGENCY_PROFILE_ID, PAY_PERIOD_ID, updatedElementsArr, USER_IMPORT_GROUP_ID).then(() => {
		
					setCallbackOnClose(ctrlObj);
					setChangesMade(false);
		
					if (isUserImportGroupSaved()) {
						getPayElementsFromImportGroup(ctrlObj)
							.then(onFormSave)
							.catch(onError);
		
					} else {
						getUserImportGroup()
							.then(() => {
								getPayElementsFromImportGroup(ctrlObj)
									.then(onFormSave)
									.catch(onError);
							})
							.catch(onError);
					}
				})
				.catch(onError);
			}else{
				setFormState(null);
				let payElementDescriptions = savingPayElementsVisible.missingPayElementDescriptions;
				let errorMessage;
				if(payElementDescriptions.length < 1){
					errorMessage = 'All pay elements were removed from the pay element packs while the changes table was being edited.';
				}else{
					errorMessage = `The pay element${payElementDescriptions.length > 1 ? 's' : ''} ${payElementDescriptions.map(function(pED){ return `<strong>'${pED}'</strong>`; }).join(', ')} ${payElementDescriptions.length > 1 ? 'were' : 'was'} removed from the pay element packs while the changes table was being edited.`;
				}
				growl.error(errorMessage);
			}
		});
	}

	function getIsSavingPayElementsVisibleInPack(ctrlObj, userPayElements){
		return payrollData.getAgencyAdjustmentGroupCombined(AGENCY_PROFILE_ID)
			.then(function(adjustmentGroupsObj){ 
				return adjustmentsService.getAllAdjustmentTypesFromAdjustmentGroup(adjustmentGroupsObj, ctrlObj.teamMembersAdjustmentTypeFilterKey)
					.filter(decoratePayElements); 
			})
			.then(function(adjustmentTypesArr){
				let returnValue = {
					isVisible: false,
					missingPayElementDescriptions: []
				};

				if(adjustmentTypesArr.length < 1){
					return returnValue;
				}

				returnValue.missingPayElementDescriptions = userPayElements.filter(function(userPayElement){
					return adjustmentTypesArr.every(function(adjustmentType){
						return adjustmentType.id !== userPayElement.id;
					});
				}).map(function (userPayElement){
					if(userPayElement.Description && userPayElement.Description !== ''){
						return userPayElement.Description;
					}

					let oldPayElement = ctrlObj.payElements.find(function (payElement){
						return payElement.id === userPayElement.id;
					});
					if(oldPayElement){
						return oldPayElement.AgencyAdjustmentGroupEntryText;
					}

					return null;
				});

				if(returnValue.missingPayElementDescriptions.length < 1){
					returnValue.isVisible = true;
				}

				return returnValue;
			})
			.catch(onError);
	}

	function fetchTeamMemberSalary(selectedTeamMember, adjustmentObj, ctrlObj, preselectDropdown) {
		const postId = selectedTeamMember.postId;

		if (!ctrlObj.rates) {
			ctrlObj.rates = {};
		}

		// If the salary data is already defined, preselect the dropdown if needed
		if (angular.isDefined(ctrlObj.rates[selectedTeamMember.postId])) {
			if (preselectDropdown) {
				preselectSalaryDropdown(ctrlObj, selectedTeamMember, adjustmentObj);
			}
			return;
		}

		// Check if the salary data exists for this postId or is already being fetched
		if (SALARY_PROMISES_CACHE[postId]) {
			// If preselectDropdown is true, handle it after the promise resolves
			SALARY_PROMISES_CACHE[postId].then(() => {
				if (preselectDropdown) {
					preselectSalaryDropdown(ctrlObj, selectedTeamMember, adjustmentObj);
				}
			});
			return;
		}

		// Create a new promise and store it in the cache
		SALARY_PROMISES_CACHE[postId] = $q((resolve, reject) => {
			
			let getTeamMemberSalaries = null;
			if (angular.isUndefined(selectedTeamMember.Salaries)) {
				getTeamMemberSalaries = payrollData.getTeamMemberSalariesForPostsWithCalculatedRates(AGENCY_PROFILE_ID, PAY_PERIOD_ID, selectedTeamMember.UserID);
			}

			$q.all([getTeamMemberSalaries]).then(([teamMemberSalariesObj]) => {
					
				// Use cached copy
				if (!teamMemberSalariesObj) {
					// Use cached copy
					teamMemberSalariesObj = selectedTeamMember.Salaries;
				}

				var teamMemberSalaryObj = salaryService.getSalaryDetailsWithRatesForPost(teamMemberSalariesObj, selectedTeamMember.salaryPolicyPostId);

				if (!ctrlObj.rates[postId]) {
					ctrlObj.rates[postId] = {};
				}

				ctrlObj.rates[postId] = teamMemberSalaryObj;

				if (preselectDropdown) {
					preselectSalaryDropdown(ctrlObj, selectedTeamMember, adjustmentObj);
				}
				
				selectedTeamMember.Salary = teamMemberSalaryObj;
				selectedTeamMember.Salaries = teamMemberSalariesObj;

				resolve();
			})
			.catch(reject);
		});

		// Handle cleanup of cache after the promise resolves
		SALARY_PROMISES_CACHE[postId].finally(() => {
			delete SALARY_PROMISES_CACHE[postId];
		});
	}

	function preselectSalaryDropdown(ctrlObj, selectedTeamMember, adjustmentObj) {
		const payElement = ctrlObj.updatedPayElements[selectedTeamMember.postId][adjustmentObj.id];

		let selectedRate = ctrlObj.rates[selectedTeamMember.postId].SalaryRatesWithCalculated.find(
			rateObj => rateObj.SalaryRateValue === payElement.UnitValue
		);

		if (!selectedRate) {
			selectedRate = ctrlObj.rates[selectedTeamMember.postId].SalaryRatesWithCalculated.find(
				rateObj => rateObj.SalaryRateID === 'custom'
			);
		}

		if (selectedRate) {
			ctrlObj.updatedPayElements[selectedTeamMember.postId][adjustmentObj.id].selectedRate = selectedRate;

			let isCalculatedRate = false;
			if (selectedRate.SalaryRateID)
			{
				isCalculatedRate = salaryService.getSalaryRateTypeIsSalaryDerivedRate(selectedRate);
			}

			angular.extend(ctrlObj.updatedPayElements[selectedTeamMember.postId][adjustmentObj.id], {
				UserPayElementIsSalaryDerivedRatedElement: isCalculatedRate,
				RateType: selectedRate.RateType
			});
		}
	}

	function selectSalaryRate (ctrlObj, teamMemberObj, payElementObj) {

		let teamMemberPayElementObj = getTeamMemberPayElement(ctrlObj, teamMemberObj, payElementObj);
		
		if (!teamMemberPayElementObj.selectedRate) {
			teamMemberPayElementObj.Value = null;
			return;
		}

		adjustmentsService.selectSalaryRate(payElementObj, teamMemberPayElementObj);

		teamMemberPayElementObj.state = PAY_ELEMENT_STATES.editing;

		onCellChange(ctrlObj);
	}

	$ctrl.$onInit = function () {

		setComponentState(COMPONENT_STATES.loading);

		let changesOptionsObj = $ctrl.changesOptions;
		AGENCY_PROFILE_ID = changesOptionsObj.agencyProfileId;
		PAY_PERIOD_ID = changesOptionsObj.payPeriodId;

		angular.extend($ctrl, {
			ADJUSTMENT_VALUE_TYPES,
			COMPONENT_STATES,
			PAY_ELEMENT_STATES,
			HEADER_STATES,
			TEAM_MEMBER_VIEW_TYPES,
			TOOLTIPS: TOOLTIPS.changesTable,
			USER_IMPORT_GROUP_STATES,

			addNewPayElementForTeamMember,
			changeOrderBy,
			deletePayElementFromTeamMember,
			deleteUserImportGroup,
			editPayElementForTeamMember,
			goToCompanyState,
			onCancelClick,
			onCellChange,
			onConfirmImport,
			onTableCellClick,
			openMarkAsActiveTooltip,
			selectSalaryRate,
			setComponentState,
			setHeaderState,
			toggleSearch,
			updateUserPayElementsForImportGroup
		});

		init();
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('checkbox', [function () {
	return {
		restrict: 'A',
		scope: {
			labelText: '=',
			labelTextClass: '@?',
			icon:	   '@?',
			id: '@',
			align: '@'
		},
		link: function (scope, element) {

			let checkbox = angular.element(element);
			let checkboxClass = scope.align !== undefined ? ' ' + scope.align : '';
			let checkboxId = !scope.id ? element[0].id : scope.id;
			let labelTextClass = angular.isDefined(scope.labelTextClass) ? scope.labelTextClass : '';

			// Add wrapper
			checkbox.wrap('<div class="checkbox-field' + checkboxClass + '"></div>');

			// Append icon (optional, still used?)
			if (scope.icon !== undefined) {
				checkbox.after(`<i class="checkbox-field-icon ${scope.icon}"></i>`);
			}

			// Append tick box
			checkbox.after(`<label class="checkbox-field-tickbox" for="${checkboxId}"></label>`);

			// Append text label
			if (scope.labelText !== undefined) {
				checkbox.after(`<label class="checkbox-field-label ${labelTextClass}" for="${checkboxId}">${scope.labelText}</label>`);
			}
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('checkboxInput', [function () {
	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {

			$element.addClass('checkbox-input-field');

			var checkboxEl = angular.element($element);
			var checkboxId = $attrs.id;
			var checkboxTheme = $attrs.checkboxInputTheme !== undefined ? $attrs.checkboxInputTheme : 'primary';

			// Add wrapper
			checkboxEl.wrap(`<div class="checkbox-input ${checkboxTheme}"></div>`);

			// Append tick box
			checkboxEl.after(`<label class="checkbox-input-label" for="${checkboxId}"></label>`);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

/**
	A simple component for showing a list of items in a collapsible container.
	isActive: initial state of container
*/
.component('collapsibleList', {
	bindings: {
		canOpen: '<',
		isActive: '<',
		label: '<'
	},
	controller: 'collapsibleListCtrl',
	templateUrl: 'components/collapsible-list/collapsible-list.component.html',
	transclude: {
		'collapsibleListContent': '?collapsibleListContent',
		'collapsibleListActions': '?collapsibleListActions'
	}
})

.controller('collapsibleListCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			canOpen: angular.isDefined($ctrl.canOpen) ? $ctrl.canOpen : true,
			hasActions: $transclude.isSlotFilled('collapsibleListActions'),
			isCollapsed: angular.isDefined($ctrl.isCollapsed) ? $ctrl.isCollapsed : false
		});
	}

	function toggleIsActive ($ctrl) {

		if (!$ctrl.canOpen) {
			return;
		}

		$ctrl.isActive = !$ctrl.isActive;
	}

	angular.extend($ctrl, {
		$onInit,
		toggleIsActive
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('costSplitFormField', {
    bindings: {
        businessCategories: '<',
		emptyUserAgencyProfileBusinessCode: '<',
		user:'<',
		userBusinessCodes: '='
    },
    controller: 'costSplitFormFieldController',
    require: {
		form: '^form'
    },
    templateUrl: 'components/cost-split-form-field/cost-split-form-field.component.html',
    transclude: true
})

.controller('costSplitFormFieldController', [
	'config',
	'utilities',
	function(
		config,
		utilities
	) {

	const $ctrl = this;

	function $onChanges (changes) {

		if (changes.businessCategories) {
			$ctrl.businessCategories = changes.businessCategories.currentValue.filter((businessCategory) => businessCategory.selectedBusinessCode !== null);
		}
	}

	function $onInit () {

		angular.extend($ctrl, {
			confirmDelete: false,
			businessCodesCostSplit: $ctrl.userBusinessCodes.BusinessCodeCostSplit,
		});

		setupSelectedBusinessCategory();
	}

	function addBusinessCode () {

		$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.push(getEmptyUserAgencyProfileBusinessCode($ctrl.selectedBusinessCategory));

		validateCostSplits();
	}

	function getEmptyUserAgencyProfileBusinessCode (selectedBusinessCategory) {

		return angular.extend({}, $ctrl.emptyUserAgencyProfileBusinessCode, {
			BusinessCategoryID: selectedBusinessCategory.BusinessCategoryID,
			BusinessCodeID: null,
			UserAgencyProfileBusinessCodePercent: 0,
			UserAgencyProfileBusinessCodePrimary: false,
		});
	}

	function getPercentageTotal () {
		if (!$ctrl.businessCodesCostSplit || !$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes) {
			return 0;
		}
		const total = $ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.reduce((total, businessCode) => {
			const percent = parseFloat(businessCode.UserAgencyProfileBusinessCodePercent) || 0;
			return total + percent;
		}, 0);

		return Math.round(total * 10000) / 10000;
	}

	function onBusinessCodeChangeDelete ($index) {

		$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.splice($index, 1);

		updatePercentage();
		setDirty();
	}

	function onDelete () {

		angular.extend($ctrl.businessCodesCostSplit, {
			BusinessCategoryID: config.guidEmpty,
			UserAgencyProfileBusinessCodes: []
		});

		$ctrl.form.$setValidity('costSplits', true);
	}

	function onBusinessCodeChange () {

		validateCostSplits();
		setDirty();
	}

	function onBusinessCodePercentageChange () {

		updatePercentage();
		setDirty();
	}

	function onBusinessCategoryChange (selectedBusinessCategory) {

		setupSelectedBusinessCategory(selectedBusinessCategory);
	}

	function setDirty() {

		// We need to set to empty guid otherwise the business code won't be saved in the backend
		for (let businessCode of $ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes) {
			businessCode.UserAgencyProfileBusinessCodeID = config.guidEmpty;
		}
	}

	function setupSelectedBusinessCategory (selectedBusinessCategory) {

		if (!selectedBusinessCategory) {
			selectedBusinessCategory = $ctrl.businessCategories.find(businessCategory => businessCategory.BusinessCategoryID === $ctrl.businessCodesCostSplit.BusinessCategoryID);
		}

		function isInSelectedBusinessCategory (userBusinessCodeObj) {
			return userBusinessCodeObj.BusinessCategoryID === selectedBusinessCategory.BusinessCategoryID;
		}

		function sortUserBusinessCodes (a, b) {
			// We want primary business codes at the top
			if (a.BusinessCodeID === selectedBusinessCategory.selectedBusinessCode.BusinessCodeID) {
				return -1;
			} else if (b.BusinessCodeID === selectedBusinessCategory.selectedBusinessCode.BusinessCodeID) {
				return 1;
			}

			// Sort by descending percentage (multiplied by -1 to reverse the default comparison order)
			const percentComparison = utilities.comparator('UserAgencyProfileBusinessCodePercent')(a, b) * -1;

			// If the percentages are equal, sort by business code name
			if (percentComparison === 0) {
				return utilities.comparator('BusinessCodeNarrative')(a, b);
			} else {
				return percentComparison;
			}
		}

		// Filter out the non assigned business codes
		selectedBusinessCategory.BusinessCodes = selectedBusinessCategory.BusinessCodes.filter(businessCode => businessCode.BusinessCodeID !== config.guidEmpty);

		$ctrl.businessCodesCostSplit.BusinessCategoryID = selectedBusinessCategory.BusinessCategoryID;

		// Copy the BusinessCodeNarrative from the BusinessCode to the UserAgencyProfileBusinessCode so that we can sort based on the name
		$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.forEach(userBusinessCode => {
			if (isInSelectedBusinessCategory(userBusinessCode)) {

				if (userBusinessCode.BusinessCodeID !== null) {

					userBusinessCode.BusinessCodeNarrative = selectedBusinessCategory.BusinessCodes.find(businessCode => businessCode.BusinessCodeID === userBusinessCode.BusinessCodeID && userBusinessCode.BusinessCodeID !== null).BusinessCodeNarrative;
				}
			}
		});

		$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes = $ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.filter(isInSelectedBusinessCategory).sort(sortUserBusinessCodes);

		let primaryBusinessCode = $ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.find(businessCode => businessCode.UserAgencyProfileBusinessCodePrimary);

		if ($ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.length === 0) {

			const emptyUserBusinessCode = getEmptyUserAgencyProfileBusinessCode(selectedBusinessCategory);
			primaryBusinessCode = getEmptyUserAgencyProfileBusinessCode(selectedBusinessCategory);

			angular.extend(primaryBusinessCode, {
				BusinessCategoryID: selectedBusinessCategory.BusinessCategoryID,
				BusinessCodeID: selectedBusinessCategory.selectedBusinessCode.BusinessCodeID,
				UserAgencyProfileBusinessCodePercent: 100,
				UserAgencyProfileBusinessCodePrimary: true,
			});

			$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes = [primaryBusinessCode, emptyUserBusinessCode];
		}

		primaryBusinessCode.BusinessCodeNarrative = selectedBusinessCategory.selectedBusinessCode.BusinessCodeNarrative;

		angular.extend($ctrl, {
			selectedBusinessCategory,
			primaryBusinessCode
		});

		updatePercentage();
	}

	function toggleConfirmDelete () {

		$ctrl.confirmDelete = !$ctrl.confirmDelete;
	}

	function updatePercentage () {

		function equal(x, y) {
			return Math.abs(x - y) < 100 * Number.EPSILON;
		}

		const total = getPercentageTotal();

		$ctrl.isMaxValue = equal(total, 100);
		$ctrl.totalPercentage = parseFloat(total).toFixed(4) + '%';

		validateCostSplits();
	}

	function validateCostSplits () {

		function isBusinessCodeValid (businessCodeObj) {
			return businessCodeObj.BusinessCodeID !== null &&
				   businessCodeObj.UserAgencyProfileBusinessCodePercent > 0 &&
				   businessCodeObj.UserAgencyProfileBusinessCodePercent < 100;
		}

		const isValid = $ctrl.isMaxValue &&
			angular.isDefined($ctrl.selectedBusinessCategory) &&
			$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.every(isBusinessCodeValid);

		// We invalidate the parent form to disable the submit button
		$ctrl.form.$setValidity('costSplits', isValid);
	}

	angular.extend($ctrl, {
		$onChanges,
		$onInit,
		addBusinessCode,
		onBusinessCategoryChange,
		onBusinessCodeChange,
		onBusinessCodeChangeDelete,
		onBusinessCodePercentageChange,
		onDelete,
		toggleConfirmDelete
	});
}])

// Filter for the business codes to removed the ones already used (make sure to reapply the filter in the HTML file
.filter('addToBusinessCodesRemoveUsedCodes', function () {

	return function (
		businessCodesArr,
		businessCodesCostSplitArr,
		currentValue
	) {

		// Returns array of Business Codes - Filtering out IDs that appear in updatesList more than once, unless ID is the current value

		function getUsedBusinessCodes () {

			const returnArr = [];

			for (let businessCodeChange of businessCodesCostSplitArr) {

				// Initial value is null, don't include that in this array
				if (businessCodeChange.BusinessCodeID !== null) {
					returnArr.push(businessCodeChange.BusinessCodeID);
				}
			}

			return returnArr;
		}

		function getApplicableBusinessCodesIds () {

			function filterOutUsedBusinessCodes (businessCodeObj) {

				// Can only select the business code type once
				const isBusinessCategoryIsNotAlreadyUsed = !usedBusinessCategoriesArr.includes(businessCodeObj.BusinessCodeID);

				// Keep the current value in the array as it would be removed from the dropdown otherwise
				const isBusinessCategoryCurrentValue = businessCodeObj.BusinessCodeID === currentValue;

				return isBusinessCategoryIsNotAlreadyUsed || isBusinessCategoryCurrentValue;
			}

			if (angular.isUndefined(businessCodesArr)) {
				return [];
			}

			const usedBusinessCategoriesArr = getUsedBusinessCodes();

			return businessCodesArr.filter(filterOutUsedBusinessCodes);
		}

		return getApplicableBusinessCodesIds();
	};
});

'use strict';

angular.module('paycircleApp')
.directive('pcCheckbox', [function () {
	return {
		restrict: 'C',
		scope: {
			pcCheckboxClass: '@'
		},
		link: function ($scope, element, attrs) {

			var checkbox = angular.element(element);
			var checkboxId = attrs.id;

			// Add label
			checkbox.after(`<label class="pc-checkbox-label" for="${checkboxId}"></label>`);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('circleLoader', [function () {
	return {
		restrict: 'E',
		templateUrl: 'components/circle-loader/circleLoaderComponent.html',
		replace: true,
		scope: {
			size: '='
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.component('codeField', {
	bindings: {
		code: '=',
		fieldDisabled: '<?',
		onCodeChange: '&?',
		showFooter: '<?',
		theme: '@?',
		title: '@?'
	},
	controller: 'codeFieldCtrl',
	require: '^form',
	templateUrl: 'components/code-field/code-field.component.html',
	transclude: {
		footer: '?cfFooter',
	},
})
.controller('codeFieldCtrl', ['$scope', '$timeout', '$transclude', 'utilities',
	function ($scope, $timeout, $transclude, utilities) {

	const $ctrl = this;
	const MAX_LENGTH = 6;

	function $onInit () {

		const fieldsObj = {};

		for (let fieldIndex = 0; fieldIndex < MAX_LENGTH; fieldIndex++) {
			fieldsObj[`field${fieldIndex+1}`] = $ctrl.code && $ctrl.code[fieldIndex] ? $ctrl.code[fieldIndex] : null;
		}

		$ctrl.fields = fieldsObj;

		focusOnEmptyCode($ctrl);
	}

	function focusOnEmptyCode (ctrlObj) {

		if (!ctrlObj.code) {
			utilities.focusOn('field1');
		}
	}

	function onBlur (ctrlObj) {
		ctrlObj.isFocussed = false;
	}

	function onChange (ctrlObj) {

		const codeString = Object.values(ctrlObj.fields).join('');

		if (codeString && codeString !== ctrlObj.code) {

			$ctrl.code = codeString;

			if (codeString.length === MAX_LENGTH && angular.isDefined(ctrlObj.onCodeChange)) {
				$timeout(() => {
					ctrlObj.onCodeChange();
				});
			}

		}
	}

	function onFocus (ctrlObj) {

		ctrlObj.isFocussed = true;

		focusOnEmptyCode(ctrlObj);
	}

	function onMouseLeave (ctrlObj) {
		ctrlObj.isMouseOver = false;
	}

	function onMouseOver (ctrlObj) {
		ctrlObj.isMouseOver = true;
	}

	function onPaste (ctrlObj, eventObj) {

		const code = utilities.getClipboardTextFromEvent(eventObj);

		ctrlObj.code = code.substr(0, MAX_LENGTH);

		utilities.focusOn('field6');
	}

	$scope.$watch('$ctrl.code', function (oldValue, newValue) {

		if (oldValue !== newValue) {
			$onInit();
		}
	});

	angular.extend($ctrl, {
		$onInit,
		onBlur,
		onFocus,
		onMouseLeave,
		onMouseOver,
		onPaste,
		onChange,

		hasFooter: $transclude.isSlotFilled('footer'),
		isMouseOver: false
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('colourPicker', ['REGEX', function (REGEX) {
	return {
		restrict: 'E',
		templateUrl: 'components/colour-picker/colourPickerComponent.html',
		replace: true,
		scope: {
			colour: '=',
			cpOnChange: '&',
			cpId: '@'
		},
		link: function (scope, element) {

			var colourPicker = element[0];
			var slideInFormBody = document.getElementById('slide-in-form-body');

			var spectrumCanvas = colourPicker.querySelector('.colour-picker__canvas--spectrum');
			var spectrumCtx = spectrumCanvas.getContext('2d');
			var spectrumCursor = colourPicker.querySelector('.colour-picker__cursor--spectrum');
			var spectrumRect = spectrumCanvas.getBoundingClientRect();

			var hueCanvas = colourPicker.querySelector('.colour-picker__canvas--hue');
			var hueCtx = hueCanvas.getContext('2d');
			var hueCursor = colourPicker.querySelector('.colour-picker__cursor--hue');
			var hueRect = hueCanvas.getBoundingClientRect();

			var hex = colourPicker.querySelector('.colour-picker__input');
			var hexBox = colourPicker.querySelector('.colour-picker__colour');
			var popOut = colourPicker.querySelector('.colour-picker__popout');
			var popOutBackground = colourPicker.querySelector('.colour-picker__background');

			var hue = 0;
			var saturation = 1;
			var lightness = 0.5;

			var open = false;

			scope.onChange = function (updatedColour) {

				if (scope.cpOnChange !== undefined && typeof scope.cpOnChange === 'function' && REGEX.hex.test(updatedColour)) {
					scope.cpOnChange();
				}
			};

			function colorPicker () {

				refreshElementRects();
				createShadeSpectrum();
				createHueSpectrum();
			}

			function colorToHue (colour) {
				
				colour = tinycolor(colour);
				var hueString = tinycolor('hsl ' + colour.toHsl().h + ' 1 .5').toHslString();
				return hueString;
			}

			function colorToPos (colour) {
				colour = tinycolor(colour);
				var hsl = colour.toHsl();
				hue = hsl.h;
				var hsv = colour.toHsv();
				var x = spectrumRect.width * hsv.s;
				var y = spectrumRect.height * (1 - hsv.v);
				var hueY = hueRect.height - hue / 360 * hueRect.height;
				updateSpectrumCursor(x, y);
				updateHueCursor(hueY);
				setCurrentColor(colour);
				createShadeSpectrum(colorToHue(colour));
			}

			function createHueSpectrum () {
				
				var canvas = hueCanvas;
				var ctx = hueCtx;
				var hueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
				
				hueGradient.addColorStop(0.0, 'hsl(0,100%,50%)');
				hueGradient.addColorStop(0.17, 'hsl(298.8, 100%, 50%)');
				hueGradient.addColorStop(0.33, 'hsl(241.2, 100%, 50%)');
				hueGradient.addColorStop(0.5, 'hsl(180, 100%, 50%)');
				hueGradient.addColorStop(0.67, 'hsl(118.8, 100%, 50%)');
				hueGradient.addColorStop(0.83, 'hsl(61.2,100%,50%)');
				hueGradient.addColorStop(1.0, 'hsl(360,100%,50%)');
				
				ctx.fillStyle = hueGradient;
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				canvas.addEventListener('mousedown', function(e) {
					startGetHueColor(e);
				});
			}

			function createShadeSpectrum (colour) {

				var canvas = spectrumCanvas;
				var ctx = spectrumCtx;
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				if (!colour) {
					colour = '#f00';
				}
				ctx.fillStyle = colour;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				var whiteGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
				whiteGradient.addColorStop(0, '#fff');
				whiteGradient.addColorStop(1, 'transparent');
				ctx.fillStyle = whiteGradient;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				var blackGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
				blackGradient.addColorStop(0, 'transparent');
				blackGradient.addColorStop(1, '#000');
				ctx.fillStyle = blackGradient;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				canvas.addEventListener('mousedown', function(e) {
					startGetSpectrumColor(e);
				});
			}

			function endGetHueColor () {

				hueCursor.classList.remove('dragging');
				window.removeEventListener('mousemove', getHueColor);
			}

			function endGetSpectrumColor () {

				spectrumCursor.classList.remove('dragging');
				window.removeEventListener('mousemove', getSpectrumColor);
			}

			function getHueColor (e) {

				e.preventDefault();
				var y = e.pageY - hueRect.top;
				if (y > hueRect.height) {
					y = hueRect.height;
				}
				if (y < 0) {
					y = 0;
				}
				var percent = y / hueRect.height;
				hue = 360 - 360 * percent;
				var hueColor = tinycolor('hsl ' + hue + ' 1 .5').toHslString();
				var colour = tinycolor('hsl ' + hue + ' ' + saturation + ' ' + lightness).toHslString();
				createShadeSpectrum(hueColor);
				updateHueCursor(y, hueColor);
				setCurrentColor(colour);
				setColorValues(colour);
			}

			function getSpectrumColor (e) {
				
				// got some help here - http://stackoverflow.com/questions/23520909/get-hsl-value-given-x-y-and-hue
				e.preventDefault();
				//get x/y coordinates
				var x = e.pageX - spectrumRect.left;
				var y = e.pageY - spectrumRect.top;
				//constrain x max
				if (x > spectrumRect.width) {
					x = spectrumRect.width;
				}
				if (x < 0) {
					x = 0.1;
				}
				if (y > spectrumRect.height) {
					y = spectrumRect.height;
				}
				if (y < 0) {
					y = 0.1;
				}
				//convert between hsv and hsl
				var xRatio = x / spectrumRect.width * 100;
				var yRatio = y / spectrumRect.height * 100;
				var hsvValue = 1 - yRatio / 100;
				var hsvSaturation = xRatio / 100;
				lightness = hsvValue / 2 * (2 - hsvSaturation);
				saturation = hsvValue * hsvSaturation / (1 - Math.abs(2 * lightness - 1));
				var colour = tinycolor('hsl ' + hue + ' ' + saturation + ' ' + lightness);
				setCurrentColor(colour);
				setColorValues(colour);
				updateSpectrumCursor(x, y);
			}

			function init () {
				
				colorPicker();
				colorToPos(hex.value);
			}

			function refreshElementRects () {

				spectrumRect = spectrumCanvas.getBoundingClientRect();
				hueRect = hueCanvas.getBoundingClientRect();
			}

			function refreshElementRectsOnScrollStop () {

				var timer = null;

				if (timer !== null) {
					clearTimeout(timer);        
				}
				timer = setTimeout(function () {
					refreshElementRects();
				}, 150);	
			}

			function setColorValues (colour) {

				//convert to tinycolor object
				colour = tinycolor(colour);
				var hexValue = '#' + colour.toHex();
				//set inputs
				// hex.value = hexValue;
				hexBox.style.backgroundColor = hexValue;
				scope.$apply(function(){
					scope.colour = hexValue;
					scope.onChange(hexValue);
				});
			}

			function setCurrentColor (colour) {

				colour = tinycolor(colour);
				spectrumCursor.style.backgroundColor = colour;
				hueCursor.style.backgroundColor = 'hsl(' + colour.toHsl().h + ', 100%, 50%)';
			}

			function startGetHueColor (e) {
				
				getHueColor(e);
				hueCursor.classList.add('dragging');
				window.addEventListener('mousemove', getHueColor);
				window.addEventListener('mouseup', endGetHueColor);
			}

			function togglePopup () {

				refreshElementRects();
				colorToPos(hex.value);

				if (!open) {
					popOut.classList.add('colour-picker__popout--active');
					open = true;
				}
				else {
					popOut.classList.remove('colour-picker__popout--active');
					open = false;
				}
			}

			function updateHueCursor (y) {

				hueCursor.style.top = (y - 3) + 'px'; // Remove 3px for cursor border
			}

			function updateSpectrumCursor (x, y) {
				
				//assign position
				spectrumCursor.style.left = x + 'px';
				spectrumCursor.style.top = y + 'px';
			}

			var startGetSpectrumColor = function (e) {
				
				getSpectrumColor(e);
				spectrumCursor.classList.add('dragging');
				window.addEventListener('mousemove', getSpectrumColor);
				window.addEventListener('mouseup', endGetSpectrumColor);
			};

			hex.addEventListener('input', function () {

				var value = hex.value;

				if (value.length > 1 && value.charAt(0) !== '#') {
					hex.value = '#';
				}
				else if (REGEX.hex.test(value)) {
					colorToPos(value);
					hexBox.style.backgroundColor = value;
				}
			});

			hexBox.addEventListener('click', function () {

				togglePopup();
			});

			popOutBackground.addEventListener('click', function () {
				togglePopup();
			});

			window.addEventListener('resize', function () {
				refreshElementRects();
			});

			slideInFormBody.addEventListener('scroll', refreshElementRectsOnScrollStop);

			init();

			scope.$on('$destroy', function () {
				
				slideInFormBody.removeEventListener('scroll', refreshElementRectsOnScrollStop);
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('communicationsTimeline', function () {

	return {
		controller: 'communicationsTimelineController',
		templateUrl: 'components/communications-timeline/communicationsTimelineComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			agencyEmployerPensionId: '<',
			companyPostponed: '='
		}
	};
})
.directive('communicationsTimelineMobile', function () {

	return {
		controller: 'communicationsTimelineController',
		templateUrl: 'components/communications-timeline/communicationsTimelineComponentMobile.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			agencyEmployerPensionId: '<',
			companyPostponed: '='
		}
	};
})
.controller('communicationsTimelineController', ['$scope', 'pensionService', function ($scope, pensionService) {

	$scope.pensionComms = pensionService.getDeadlinesArray();
	$scope.selected = -1;
	$scope.toggleSelected = function (popup) {

		if ($scope.selected === popup) {
			$scope.selected = -1;
		}
		else {
			$scope.selected = popup;
		}
	};

}]);

'use strict';

angular.module('paycircleApp')
.directive('companyActivity', function () {

	return {
		controller: 'companyActivityController',
		templateUrl: 'components/company-activity/company-activity.component.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			sideBarOptions: '='
		}
	};
})
.controller('companyActivityController', [
	'$filter',
	'$scope',
	'base',
	'logService',
	function (
		$filter,
		$scope,
		base,
		logService
	) {

	const agencyProfileId = $scope.agencyProfileId;

	function init () {

		loadActivity();
	}

	function loadActivity () {

		setPageState('loading');

		base.getAgencyLogEntriesForLogCategoryList(agencyProfileId).then(logEntriesArray => {

			var logCategoriesArray = logService.getLogCategoriesArray(logEntriesArray);
			
			logEntriesArray = logService.decorateLogEntries(logEntriesArray);

			$scope.vm = {
				logEntries: logEntriesArray,
				logCategories: logCategoriesArray,
				logCategoryId: logCategoriesArray.length ? logCategoriesArray[0].id : 0
			};

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		loadActivity
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('companyCard', {
	bindings: {
		agencyProfileParentId: '<',
		bulkItems: '=',
		company: '<',
		isClone: '<?',
		isBasicView: '<?',
		reloadCompany: '&',
		reloadCompanies: '&?'
	},
	controller: 'companyCardCtrl',
	templateUrl: 'components/company-card/company-card.component.html',
})
.controller('companyCardCtrl', [
	'$rootScope',
	'$filter',
	'agency',
	'bulkService',
	'companyData',
	'payPeriodService',
	'reportData',
	'utilities',
	'PAY_PERIOD_TYPES',
	'PENSION_STATES',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'USER_ROLES',
	function (
		$rootScope,
		$filter,
		agency,
		bulkService,
		companyData,
		payPeriodService,
		reportData,
		utilities,
		PAY_PERIOD_TYPES,
		PENSION_STATES,
		STATE_TYPES,
		SUBMISSION_STATES,
		USER_ROLES
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			isBulkSelectionEnabled: angular.isDefined($ctrl.bulkItems) && !$rootScope.userHasRole($ctrl.USER_ROLES.groupadminlite),
			isClone: angular.isDefined($ctrl.isClone) ? $ctrl.isClone : false,
			reportDownloadState: 'loading'
		});

		if ($ctrl.company.PayPeriod.PayrollState > SUBMISSION_STATES.unsubmitted) {
			payPeriodService.pollForSubmissionState($ctrl.company.PayPeriod, STATE_TYPES.finalise, 'PayrollState', $ctrl.company.Company.AgencyProfileID)
				.then($ctrl.reloadCompany);
		}
	}

	function deleteCompany () {

		const confirmed = window.confirm(`Are you sure you wish to delete ${$ctrl.company.Company.Name}? This cannot be undone.`);

		if (confirmed) {

			$ctrl.isCompanyBeingDeleted = true;

			companyData.deleteAgencyProfile($ctrl.company.Company.AgencyProfileID)
				.then(() => {
					$ctrl.reloadCompanies();
				})
				.catch(onError)
				.finally(() => {
					$ctrl.isCompanyBeingDeleted = false;
				});
		}
	}

	function getReportsForCompany () {

		function getPayPeriodForReports (companyObj) {

			if (angular.isObject(companyObj.PreviousPayPeriod)) {
				return companyObj.PreviousPayPeriod;

			} else if (utilities.isValidGuid(companyObj.PayPeriod.PayPeriodID)) {
				return companyObj.PayPeriod;

			} else {
				return null;
			}
		}

		if ($ctrl.reportDownloadState === 'loading') {

			companyData.getAgencyProfileAgencyProfile($ctrl.company.Company.AgencyProfileID)
				.then(companyObj => {

					const reportPayPeriodObj = getPayPeriodForReports(companyObj);

					if (reportPayPeriodObj) {
						reportData.getClassicReports($ctrl.company.Company.AgencyProfileID, reportPayPeriodObj.PayPeriodID)
							.then(classicReportsArr => {

								angular.extend($ctrl, {
									reports: classicReportsArr,
									reportPeriod: reportPayPeriodObj,
									reportDownloadState: 'ready'
								});
							})
							.catch(onError);

					} else {
						$ctrl.reportDownloadState = 'error';
					}
				})
				.catch(onError);
		}
	}

	function hideMenus () {
		$ctrl.options = {
			showMenu: false,
			showReportMenu: false
		};
	}

	function onCheckboxToggle (ctrlObj) {
		ctrlObj.bulkItems = bulkService.updateBulkItemTotals(ctrlObj.bulkItems);
	}

	function onError (error) {
		console.error(error);
		setPageState(error);
	}

	function openAddAChangeForm (companyObj) {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'add-a-change',
			payPeriod: companyObj.PayPeriod
		});
	}

	function openArchiveCompanyForm () {
		openSlideInForm({
			availableWhenCompanyPAYESchemeCeasedPending: false,
			callback: $ctrl.reloadCompanies,
			formKey: 'archive-company'
		});
	}

	function openBacsPennyTestForm () {

		openSlideInForm({
			formKey: 'bacs-penny-test'
		});
	}

	function openCeasePayeForm () {

		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'company-settings-cease-paye'
		});
	}

	function openClonePayrollForm () {

		openSlideInForm({
			formKey: 'clone-payroll'
		});
	}

	function openCompanyOverviewForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'company-overview',
			agencyProfileParentId: $ctrl.agencyProfileParentId,
			showContext: false,
			size: 'large'
		});
	}

 	function openCrossPeriodReportForm () {
		openSlideInForm({
			formKey: 'cross-period-report'
		});
	}

	function openDeleteCloneForm () {

		openSlideInForm({
			callback: $ctrl.reloadCompanies,
			formAction: 'delete',
			formKey: 'clone-payroll',
			title: 'Delete clone'
		});
	}

	function openManageAdminsForm () {
		openSlideInForm({
			formKey: 'manage-admins'
		});
	}

	function openManageCompanyGroupsForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompanies,
			formKey: 'manage-company-groups',
			title: 'Manage groups'
		});
	}

 	function openManagePayElementsForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompanies,
			agencyProfileParentId: $ctrl.agencyProfileParentId,
			formKey: 'manage-pay-elements'
		});
	}

	function openManageReportPacksForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			agencyProfileParentId: $ctrl.agencyProfileParentId,
			formKey: 'manage-report-packs'
		});
	}

	function openManageVisibilityForm () {
		openSlideInForm({
			agencyProfileParentId: $ctrl.agencyProfileParentId,
			formKey: 'manage-visibility'
		});
	}

	function openRunPayrollForm (companyObj) {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'run-payroll',
			title: companyObj.Company.PensionOnly ? 'Run period' : null
		});
	}

	function openSlideInForm (formOptions) {

		// Hide dropdown menu
		hideMenus();

		angular.extend(formOptions, {
			agencyProfileId: $ctrl.company.Company.AgencyProfileID,
			agencyProfileParentId: $ctrl.agencyProfileParentId
		});

		$rootScope.$broadcast('open-slide-in-form', formOptions);
	}

	function openSwitchToLiveForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'switch-to-live'
		});
	}

	function openSwitchToTestForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			formKey: 'switch-to-live',
			title: 'Switch to Test Mode'
		});
	}

	function openViewChangesForm () {
		openSlideInForm({
			callback: $ctrl.reloadCompany,
			contextType: 'company',
			formKey: 'view-changes'
		});
	}

	function resetPeriod ($ctrl) {

		agency.updateAgencyPayPeriodResetFailedState($ctrl.company.PayPeriod.PayPeriodID).then(() => {
			$ctrl.reloadCompany();
		})
		.catch(onError);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function showResetPeriodConfirmation ($ctrl) {

		$rootScope.openModalDialog({
			callback: resetPeriod.bind(undefined, $ctrl),
			modalKey: 'payroll-reset-period',
			modalData: {
				company: $ctrl.company
			}
		});
	}

	function shouldShowTaxPeriod(payPeriod) {
		return [
			PAY_PERIOD_TYPES.quarterly,
			PAY_PERIOD_TYPES.biannually,
			PAY_PERIOD_TYPES.annually,
			PAY_PERIOD_TYPES.weekly,
			PAY_PERIOD_TYPES.monthly,
			PAY_PERIOD_TYPES.fortnightly,
			PAY_PERIOD_TYPES.fourweekly
		].includes(payPeriod.PayPeriodType) && !!payPeriod.TaxPeriod;
	}

	function getPeriodDisplayText(payPeriod) {
		// For quarterly, biannually, annually: show (P{TaxPeriod})
		if (
			[
				PAY_PERIOD_TYPES.quarterly,
				PAY_PERIOD_TYPES.biannually,
				PAY_PERIOD_TYPES.annually
			].includes(payPeriod.PayPeriodType)
		) {
			return `(P${payPeriod.TaxPeriod})`;
		}

		// For weekly, bianually, anually: show (Period {TaxPeriod})
		return `(${$filter('capitalise')(
			$filter('taxPeriodDescription')(
				payPeriod.TaxPeriod,
				payPeriod.PayPeriodType
			)
		)})`;
	}

	angular.extend($ctrl, {
		// $onChanges,
		$onInit,
		PENSION_STATES,
		SUBMISSION_STATES,
		USER_ROLES,

		isCompanyBeingDeleted: false,
		options: {
			showMenu: false,
			showReportMenu: false
		},

		deleteCompany,
		getReportsForCompany,
		hideMenus,
		onCheckboxToggle,
		openAddAChangeForm,
		openArchiveCompanyForm,
		openBacsPennyTestForm,
		openCeasePayeForm,
		openClonePayrollForm,
		openCompanyOverviewForm,
		openCrossPeriodReportForm,
		openDeleteCloneForm,
		openManageAdminsForm,
		openManageCompanyGroupsForm,
		openManagePayElementsForm,
		openManageReportPacksForm,
		openManageVisibilityForm,
		openRunPayrollForm,
		openSwitchToLiveForm,
		openSwitchToTestForm,
		openViewChangesForm,
		resetPeriod,
		showResetPeriodConfirmation,
		reloadCompany: $ctrl.reloadCompany,
		shouldShowTaxPeriod,
		getPeriodDisplayText
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('companyArchivedCard', function () {

	return {
		templateUrl: 'components/company-archived-card/companyArchivedCard.html',
		replace: true,
		scope: {
			company: '=',
			onCheckboxToggle: '=',
			onUpdate: '=',
			reloadCompanies: '&?'
		},
		controller: 'companyArchivedCardController'
	};
})
.controller('companyArchivedCardController', ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', 'agency', 'companyData', 'payPeriodService', 'session', 'ARCHIVE_REASONS', function ($rootScope, $scope, $state, $stateParams, $timeout, agency, companyData, payPeriodService, session, ARCHIVE_REASONS) {

	var onUpdate = $scope.onUpdate;

	function hideMenus () {

		$scope.options = {
			showMenu: false,
			showReportMenu: false
		};
	}

	function openUndoArchiveCompanyForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			availableWhenCompanyPAYESchemeCeased: true,
			availableWhenCompanyPAYESchemeCeasedPending: true,
			callback: onUpdate,
			formKey: 'archive-company'
		});
	}

	function openExportDataForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			formKey: 'export-company-data'
		});
	}

	function openManageAdminsForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.Company.AgencyProfileID,
			formKey: 'manage-admins'
		});
	}

	// Scope variables
	$scope.ARCHIVE_REASONS = ARCHIVE_REASONS;
	$scope.options = {
		showMenu: false,
		showReportMenu: false
	};

	$scope.hideMenus = function () {

		hideMenus();
	};

	$scope.openExportDataForm = function (companyObj) {

		openExportDataForm(companyObj);
	};

	$scope.openManageAdminsForm = function (companyObj) {

		openManageAdminsForm(companyObj);
	};

	$scope.openUndoArchiveCompanyForm = function (companyObj) {

		openUndoArchiveCompanyForm(companyObj);
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('companyGroupCard', {
	bindings: {
		companyGroup: '=',
		companyGroups: '=',
		callback: '&?',
		agencyProfileParentId: '<?'
	},
	controller: 'companyGroupCardCtrl',
	templateUrl: 'components/company-group-card/company-group-card.component.html',
})
.controller('companyGroupCardCtrl', ['$rootScope', 'FORM_WIZARD_KEYS',
	function ($rootScope, FORM_WIZARD_KEYS) {

	const $ctrl = this;

	function hideMenu (ctrlObj) {
		ctrlObj.showMenu = false;
	}

	function openAddCompanyWizard (ctrlObj) {
		$rootScope.$broadcast('open-form-wizard', {
			callback: $ctrl.callback,
			agencyProfileParentId: ctrlObj.companyGroup.Company.AgencyProfileID,
			primaryButtonText: 'Next',
			showHeader: true,
			title: 'Create company',
			wizardKey: FORM_WIZARD_KEYS.company
		});
	}

	function openAutoCreateCompanyForm (ctrlObj) {
		openSlideInForm(ctrlObj, {
			formKey: 'auto-create-company',
			agencyProfileParentId: ctrlObj.companyGroup.Company.AgencyProfileID
		});
	}

	function openDeleteCompanyGroupForm (ctrlObj) {
		openSlideInForm(ctrlObj, {
			companyGroups: ctrlObj.companyGroups,
			formKey: 'delete-company-group',
			title: 'Delete group'
		});
	}

	function openManageAdminsForm (ctrlObj) {
		openSlideInForm(ctrlObj, {
			formKey: 'manage-admins'
		});
	}

	function openManageReportPacksForm (ctrlObj) {
		openSlideInForm(ctrlObj, {
			agencyProfileParentId: ctrlObj.agencyProfileParentId,
			formKey: 'manage-report-packs'
		});
	}

	function openSlideInForm (ctrlObj, formOptionsObj) {

		hideMenu(ctrlObj);

		angular.extend(formOptionsObj, {
			agencyProfileId: ctrlObj.companyGroup.Company.AgencyProfileID,
			callback: $ctrl.callback,
		});

		$rootScope.openSlideInForm(formOptionsObj);
	}

	function openEditCompanyGroupForm (ctrlObj) {
		openSlideInForm(ctrlObj, {
			formKey: 'edit-company-group',
			title: 'Edit ' + ctrlObj.companyGroup.Company.Name,
			companyGroupName: ctrlObj.companyGroup.Company.Name,
			companyGroupId: ctrlObj.companyGroup.Company.AgencyProfileID
		});
	}

	angular.extend($ctrl, {
		hideMenu,
		openAddCompanyWizard,
		openAutoCreateCompanyForm,
		openDeleteCompanyGroupForm,
		openEditCompanyGroupForm,
		openManageAdminsForm,
		openManageReportPacksForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('companyGroupCardBasic', function () {

	return {
		templateUrl: 'components/company-group-card-basic/companyGroupCardBasic.html',
		scope: {
			companyGroup: '=',
			callback: '=',
			removeCompanyGroup: '&?',
		},
		controller: 'companyGroupCardBasicController'
	};
})
.controller('companyGroupCardBasicController', ['$rootScope', '$scope', 'FORM_WIZARD_KEYS',
	function ($rootScope, $scope, FORM_WIZARD_KEYS) {

	var agencyProfileParentId 	= $scope.companyGroup.AgencyProfileID;
	var callback 				= $scope.callback;

	// Scope variables
	$scope.companyGroup.isSelected = false;

	// Scope functions
	$scope.openAddCompanyWizard = function () {

		$rootScope.$broadcast('open-form-wizard', {
			callback: callback,
			agencyProfileParentId: agencyProfileParentId,
			primaryButtonText: 'Next',
			showHeader: true,
			title: 'Create company',
			wizardKey: FORM_WIZARD_KEYS.company
		});
	};

	$scope.openAutoCreateCompanyForm = function () {

		$rootScope.openSlideInForm({
			callback: callback,
			formKey: 'auto-create-company',
			agencyProfileParentId: agencyProfileParentId
		});
	};

	$scope.openManageAdminsForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileParentId,
			formKey: 'manage-admins'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('companyMessageBar', {
	templateUrl: 'components/company-message-bar/company-message-bar.component.html',
	bindings: {
		company: '='
	},
	controller: 'companyMessageBarController'
})
.controller('companyMessageBarController', [
	'$rootScope',
	'stateService',
	function (
		$rootScope,
		stateService
	) {

	const $ctrl = this;

	function openSwitchToLiveForm (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: refreshCompany,
			formKey: 'switch-to-live',
			title: companyObj.IsInTestMode ? null : 'Switch to Test Mode'
		});
	}

	function refreshCompany () {

		stateService.setCompany($ctrl.company.AgencyProfileID);
	}

	angular.extend($ctrl, {
		openSwitchToLiveForm,
		parentCompany: stateService.getPreviousCompanyObj()
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('companyOnboardingCard', function () {

	return {
		templateUrl: 'components/company-onboarding-card/companyOnboardingCard.html',
		replace: true,
		scope: {
			agencyProfileParentId: '@',
			company: '=',
			reloadCompanies: '&'
		},
		controller: 'companyOnboardingCardController'
	};
})
.controller('companyOnboardingCardController', ['$rootScope', '$scope', '$state', 'companyData', 'growl', 'ADMIN_INVITE_STATES', 'COMPANY_STATES', function ($rootScope, $scope, $state, companyData, growl, ADMIN_INVITE_STATES, COMPANY_STATES) {

	var agencyProfileParentId = $scope.agencyProfileParentId;

	function updateCompany () {

		$scope.reloadCompanies();
	}

	$scope.COMPANY_STATES = COMPANY_STATES;
	$scope.ADMIN_INVITE_STATES = ADMIN_INVITE_STATES;

	$scope.openBureauNewCompanyForm = function (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileParentId: agencyProfileParentId,
			callback: updateCompany,
			companyObj: companyObj,
			formKey: 'onboarding-bureau-new-company',
			showContext: false,
		});
	};

	$scope.openChangeCompanyStateForm = function (companyObj, newState) {

		var formTitle;
		switch (newState) {
			case COMPANY_STATES.onboarding:
				formTitle = 'Move to Onboarding';
				break;
			case COMPANY_STATES.firstPeriod:
				formTitle = 'Move to first pay period';
				break;
			case COMPANY_STATES.readyToRun:
				formTitle = 'Mark as \'Ready to run\'';
		}

		$rootScope.openSlideInForm({
			company: companyObj,
			newCompanyState: newState,
			callback: updateCompany,
			formKey: 'onboarding-bureau-change-company-state',
			title: formTitle,
			contextType: 'company',
			showContext: true
		});
	};

	$scope.openDeleteCompanyForm = function (companyObj) {

		$rootScope.openSlideInForm({
			company: companyObj,
			callback: updateCompany,
			formKey: 'onboarding-bureau-delete-company',
			title: 'Delete company',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.openEditFirstPeriodForm = function (companyObj) {

		$rootScope.openSlideInForm({
			company: companyObj,
			callback: updateCompany,
			formKey: 'onboarding-bureau-edit-first-period',
			title: 'Edit first pay period',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.openExtendTrialForm = function (companyObj) {

		$rootScope.openSlideInForm({
			company: companyObj,
			callback: updateCompany,
			formKey: 'onboarding-bureau-extend-trial',
			title: 'Extend free trial',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.openNewAdminForm = function (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: updateCompany,
			formKey: 'new-admin'
		});
	};

	$scope.openManageAdminsForm = function (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			formKey: 'manage-admins',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.openManagePayElementsForm = function (companyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			agencyProfileParentId: agencyProfileParentId,
			formKey: 'manage-pay-elements'
		});
	};

	$scope.openOnboardingChecklistForm = function (companyObj) {

		$rootScope.openSlideInForm({
			company: companyObj,
			callback: updateCompany,
			formKey: 'onboarding-bureau-onboarding-checklist',
			title: $scope.company.State === COMPANY_STATES.onboarding ? 'Onboarding checklist' : 'Demo checklist',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.resendInvite = function (companyObj) {

		companyObj.inviteSendingState = 'sending';

		companyData.sendInvitationMailInternal(companyObj.OnboardingID, agencyProfileParentId).then(function () {
			growl.success(companyObj.AdminForename + ' has been resent an invitation');
			companyObj.inviteSendingState = null;
		})
		.catch(function () {
			companyObj.inviteSendingState = null;
			growl.error('We were unable to resend an invitation');
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('companyOnboardingStatus', function () {

	return {
		controller: 'companyOnboardingStatusController',
		templateUrl: 'components/company-onboarding-status/companyOnboardingStatusComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			sideBarOptions: '='
		}
	};
})
.controller('companyOnboardingStatusController', ['$q', '$rootScope', '$scope', 'companyData', 'onboardingService', 'teamData', 'teamService', 'FORM_WIZARD_KEYS',
	function ($q, $rootScope, $scope, companyData, onboardingService, teamData, teamService, FORM_WIZARD_KEYS) {

	var agencyProfileId = $scope.agencyProfileId;

	function closeSideBarMenu (sideBarOptions) {

		sideBarOptions.isOpen = false;
		sideBarOptions.activeMenu = null;
	}

	function decorateIncompleteTeamMembers (incompleteTeamMemberObj) {

		var count = 0;

		incompleteTeamMemberObj.AddressSetupComplete ? null : count++;
		incompleteTeamMemberObj.BankSetupComplete ? null : count++;
		incompleteTeamMemberObj.CompanySetupComplete ? null : count++;
		incompleteTeamMemberObj.TelephoneSetupComplete ? null : count++;
		incompleteTeamMemberObj.EmailSetupComplete ? null : count++;
		incompleteTeamMemberObj.PersonalSetupComplete ? null : count++;
		incompleteTeamMemberObj.SalarySetupComplete ? null : count++;
		incompleteTeamMemberObj.TaxSetupComplete ? null : count++;

		incompleteTeamMemberObj.isOpen = false;
		incompleteTeamMemberObj.incompleteTaskCount = count;

		return incompleteTeamMemberObj;
	}

	function getSkippedQuestions (onboardingDashboardObj) {

		return {
			company: {
				isOpen: false,
				questions: onboardingService.getSkippedQuestionsByQuestionGroupKey(onboardingDashboardObj, 'company')
			},
			payroll: {
				isOpen: false,
				questions: onboardingService.getSkippedQuestionsByQuestionGroupKey(onboardingDashboardObj, 'payroll')
			}
		};
	}

	function getTotalSkippedQuestions (skippedQuestionsObj) {

		return skippedQuestionsObj.company.questions.length + skippedQuestionsObj.payroll.questions.length;
	}

	function init () {

		setPageState('loading');

		var getOnboardingDashboard = companyData.getOnboardingDashboard(agencyProfileId);
		var getTeamMemberAdmins = teamData.getTeamMemberAdmins(agencyProfileId);
		var getTeamMemberCompletionState = teamData.getTeamMemberCompletionState(agencyProfileId);

		$q.all([getOnboardingDashboard, getTeamMemberAdmins, getTeamMemberCompletionState]).then(function (data) {

			var onboardingDashboardObj = data[0];
			var companyAdminsArray = data[1];
			var teamMemberCompletionArray = data[2];

			var skippedQuestions = getSkippedQuestions(onboardingDashboardObj);

			$scope.hasAdviser = onboardingDashboardObj.HasAdviser;
			$scope.companyAdmins = companyAdminsArray.filter(teamService.adminFilter);
			$scope.incompleteTeamMembers = teamMemberCompletionArray.filter(decorateIncompleteTeamMembers);
			$scope.isCompanyQuestionsOpen = false;
			$scope.onboardingDashboardObj = onboardingDashboardObj;
			$scope.skippedQuestions = skippedQuestions;
			$scope.totalSkippedQuestions = skippedQuestions.company.questions.length + skippedQuestions.payroll.questions.length;

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function refreshOnboardingDashboard () {

		companyData.getOnboardingDashboard(agencyProfileId).then(function (onboardingDashboardObj) {

			var skippedQuestionsObj = getSkippedQuestions(onboardingDashboardObj);

			$scope.hasAdviser = onboardingDashboardObj.HasAdviser;
			$scope.skippedQuestions = skippedQuestionsObj;
			$scope.totalSkippedQuestions = getTotalSkippedQuestions(skippedQuestionsObj);
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.closeSideBarMenu = function (sideBarOptions) {

		closeSideBarMenu(sideBarOptions);
	};

	$scope.openAddressForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'address',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openAddTeamMembers = function () {

		closeSideBarMenu($scope.sideBarOptions);
		$rootScope.$broadcast('show-onboarding-add-team-members');
	};

	$scope.openAskMyAdvisorForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'ask-my-advisor',
			showContext: false
		});
	};

	$scope.openCompanyDetailsForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'company-details',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openCompanyReferencesForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'company-settings-references'
		});
	};

	$scope.openEmailAddressForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'email-address',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openOnboardingWizardCompanyForm = function (questionObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: refreshOnboardingDashboard,
			formKey: 'onboarding-wizard-company',
			formStep: questionObj.formStep,
			initCallbackOnClose: true
		});
	};

	$scope.openOnboardingWizardPayrollForm = function (questionObj, onboardingDashboardObj) {

		$rootScope.$broadcast('open-form-wizard', {
			activeStepIndex: questionObj.formStep,
			agencyProfileId: agencyProfileId,
			callback: refreshOnboardingDashboard,
			questionGroup: onboardingService.getQuestionGroupForQuestionGroupKey(onboardingDashboardObj, 'payroll'),
			wizardKey: FORM_WIZARD_KEYS.companyPayroll
		});
	};


	$scope.openPayInformationForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'pay-information',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openPaymentDetailsForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'payment-details',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openPaymentsToDateForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'payments-to-date',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openPersonalForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'personal',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openStarterInformationForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'starter-information',
			userId: teamMemberObj.UserID
		});
	};

	$scope.openTaxStatusForm = function (teamMemberObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			contextType: 'user',
			formKey: 'tax-status',
			userId: teamMemberObj.UserID
		});
	};

	$scope.toggleIsOpen = function (vmObj) {

		vmObj.isOpen = !vmObj.isOpen;
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('companyOnboardingSummary', function () {

	return {
		controller: 'companyOnboardingSummaryController',
		templateUrl: 'components/company-onboarding-summary/companyOnboardingSummaryComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			onClose: '&?'
		}
	};
})
.controller('companyOnboardingSummaryController', ['$rootScope', '$scope', 'teamData', function ($rootScope, $scope, teamData) {

	const INCLUDE_LEAVERS = false;

	var agencyProfileId = $scope.agencyProfileId;

	// TODO: data to be added to service
	function decorateTeamMember (teamMemberObj) {

		teamMemberObj.PercentageComplete = 75;
		teamMemberObj.OnboardingType = 1; // 0 = form, 1 = import

		return teamMemberObj;
	}

	function init () {

		setPageState('loading');

		teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(agencyProfileId, INCLUDE_LEAVERS).then(function (teamMembersArray) {

			$scope.teamMembers = teamMembersArray.filter(decorateTeamMember);

			selectTeamMember($scope.teamMembers, 0);
			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function selectTeamMember (teamMembersArray, index) {

		setTeamMemberState('loading');

		var activeTeamMember = teamMembersArray[index];

		// Hook up GetPensionInfo service to return pension details

		$scope.activeTeamMember = activeTeamMember;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setTeamMemberState (teamMemberState) {

		$scope.teamMemberState = teamMemberState;
	}

	init();

	$scope.selectTeamMember = function (teamMembersArray, index) {

		selectTeamMember(teamMembersArray, index);
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('companyPensionSummary', function () {

    return {
        templateUrl: 'components/company-pension-summary/companyPensionSummaryComponent.html',
        restrict: 'E',
        replace: true,
        controller: 'companyPensionSummaryCtrl',
        scope: {
        	agencyProfileId: '<',
            pension: '='
        }
    };
})
.controller('companyPensionSummaryCtrl', ['$scope', 'PENSION_TYPES', function ($scope, PENSION_TYPES) {
	$scope.PENSION_TYPES = PENSION_TYPES;
}]);

/* globals confetti */
'use strict';

angular.module('paycircleApp')
.component('confetti', {
	bindings: {
		fireConfetti: '&?',
		isConfettiVisible: '=',
		confettiId: '@',
		useElementLocation: '<?',
		x: '@?',
		y: '@?'
	},
	controller: 'confettiCtrl',
	templateUrl: 'components/confetti/confetti.component.html',
})
.controller('confettiCtrl', [
	'$element',
	'$timeout',
	'utilities',
	function (
		$element,
		$timeout,
		utilities
	) {

	const CONFETTI_COLOURS = ['#2cb1d3', '#f3428d', '#2faf94', '#b08dc4', '#e3c369', '#df6f5a'];

	var $ctrl = this;
	var myCanvas;
	var myConfetti;

	function fireConfetti () {

		let xCoOrd = utilities.getMediaType() === 'phone' ? 0.5 : 0.44;
		let yCoOrd = utilities.getMediaType() === 'phone' ? 0.4 : 0.35;

		if (angular.isDefined($ctrl.x)) {
			xCoOrd = parseFloat($ctrl.x);
		}
		if (angular.isDefined($ctrl.y)) {
			yCoOrd = parseFloat($ctrl.y);
		}

		if ($ctrl.useElementLocation) {

			const viewportOffset = $element[0].getBoundingClientRect();

			xCoOrd = 1-(window.innerWidth-viewportOffset.left)/window.innerWidth;
			yCoOrd = 1-(window.innerHeight-viewportOffset.top)/window.innerHeight;
		}

		myConfetti({
		    angle: 90,
			colors: CONFETTI_COLOURS,
		    spread: r(50, 70),
		    particleCount: r(250, 500),
		    origin: {
		        y: yCoOrd,
		        x: xCoOrd
		    },
		    zIndex: 100000
		});
	}

	function r (min, max) {

	    return Math.random() * (max - min) + min;
	}

	$ctrl.$onInit = function () {

		myCanvas = document.getElementById($ctrl.confettiId);
		myConfetti = confetti.create(myCanvas, { resize: true });

		fireConfetti();
	};

	$ctrl.fireConfetti = function () {

		fireConfetti();
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('copilotButton', {
	bindings: {
		buttonText: '<',
		isLoading: '<',
		onButtonClick: '&'
	},
	controller: 'copilotButtonCtrl',
	templateUrl: 'components/copilot-button/copilot-button.component.html',
})
.controller('copilotButtonCtrl', [function ()
{
	const $ctrl = this;

	function handleClick() {

		if ( angular.isFunction($ctrl.onButtonClick)) {
			$ctrl.onButtonClick();
		}
	}

	angular.extend($ctrl, {
		handleClick
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('copilotFeedback', {
	bindings: {
		labelText: '@',
		onFeedbackClick: '&?',
		showButtons: '<?',
		agencyProfileId: '<?',
		payPeriodId: '<?',
		onFeedbackSubmitted: '&?',
		copilotFeature: '@?'
	},
	controller: 'copilotFeedbackCtrl',
	templateUrl: 'components/copilot-feedback/copilot-feedback.component.html'
})
.controller('copilotFeedbackCtrl',[
	'$rootScope',
	'$scope',
	'accessButtonService',
	'payrollData',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	function (
		$rootScope,
		$scope,
		accessButtonService,
		payrollData,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES
	) {

	function submitFeedback (copilotFeature, feedbackType) {
		$scope.submittingFeedback = true;
		$scope.telemetryParams = { copilotFeature: copilotFeature, feedbackType: feedbackType };

		if ($scope.$ctrl.onFeedbackClick) {
			$scope.$ctrl.onFeedbackClick({
				copilotFeature: copilotFeature,
				feedbackType: feedbackType,
				onSubmitComplete: function (success) {
					$scope.submittingFeedback = false;
					if (success) {
						openFeedbackModal(copilotFeature, feedbackType);
					}
				}
			});
		}
	}

	function openFeedbackModal(copilotFeature, feedbackType) {
		$scope.feedbackCompleted = false;
		$scope.submittedMessage = null;

		$rootScope.openModalDialog({
			modalKey: 'smart-view-feedback',
			modalData: {
				copilotFeature: copilotFeature,
				feedbackType: feedbackType
			},
			onSubmit: function (messageText) {
				$scope.feedbackCompleted = true;
				$scope.submittedMessage = messageText;
			},
			closeModal: function () {
				if ($scope.telemetryParams) {
					if ($scope.feedbackCompleted && $scope.submittedMessage) {
						sendCopilotTelemetry($scope.telemetryParams.copilotFeature, $scope.telemetryParams.feedbackType, $scope.submittedMessage);
					} else {
						sendCopilotTelemetry($scope.telemetryParams.copilotFeature, $scope.telemetryParams.feedbackType, null);
					}
				}

				if ($scope.$ctrl.onFeedbackSubmitted) {
					$scope.$ctrl.onFeedbackSubmitted();
				}

				$rootScope.closeModalDialog();
			}
		});
	}

	function sendCopilotTelemetry(copilotFeature, feedbackType, feedbackMessage) {

		const messagePart = (feedbackMessage && typeof feedbackMessage === 'string' && feedbackMessage.trim().length) ? feedbackMessage.replace(/\s+/g, ' ').slice(0, 200) : '';
		const normalizedType = (feedbackType === 'positive' || feedbackType === 'negative') ? feedbackType : 'unknown';
		const correlationId = copilotFeature + '_' + normalizedType + '_' + messagePart;
		accessButtonService.sendTelemetry(TELEMETRY_TRACKED_FEATURES.feedbackCopilot, TELEMETRY_PROJECT_INFO.projectReportingCode, correlationId);
	}

	angular.extend($scope, {
		submitFeedback: submitFeedback
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('copilotResponseCard', {
	bindings: {
		title: '@',
		content: '@',
		response: '<',
		isError: '<',
		isFeedbackRequired: '<',
		onReloadClick: '&',
		onFeedbackClick: '&?',
		copilotFeatureContext: '@?'
	},
	transclude: {
		'content': '?cpContent'
	},
	controller: 'copilotResponseCardCtrl',
	templateUrl: 'components/copilot-response-card/copilot-response-card.component.html',
})
.controller('copilotResponseCardCtrl', ['$transclude', 'COPILOT_FEATURES',

	function ($transclude, COPILOT_FEATURES
	) {
		const $ctrl = this;


		$ctrl.$onInit = function () {

			angular.extend($ctrl, {
				hasContent: $transclude.isSlotFilled('content'),
				COPILOT_FEATURES
			});
		};

}]);

'use strict';

angular.module('paycircleApp')

.directive('correctionalSubmissionFieldset', function () {

	// This has to be a angular directive with restrict:A as it's within a table
	return {
		restrict: 'A',
		templateUrl: 'components/correctional-submission-fieldset/correctional-submission-fieldset.component.html',
		scope: {
			fieldsetId: '@',
			form: '<',
			isDifferenceColumnVisible: '<',
			onPaymentChange: '&',
			payment: '<',
			taxYear: '<',
			teamMember: '<',
		},
		controller: 'correctionalSubmissionFieldsetCtrl'
	};
})
.controller('correctionalSubmissionFieldsetCtrl', [
	'$filter',
	'$scope',
	function (
		$filter,
		$scope
	) {

	const paymentObj = $scope.payment;

	function init () {
		onNewPaymentAmountChange();
	}

	function calculateDifference () {

		// Difference is not shown on YTD FPS, but is needed to know if the form is valid or not
		const oldAmount = paymentObj.paymentAmount;
		const newAmountInteger = parseFloat(paymentObj.paymentNewAmount);
		const difference = Math.abs(oldAmount - newAmountInteger);

		// Save integer version to use on save and for display
		paymentObj.paymentNewAmountInteger = newAmountInteger;

		if (paymentObj.paymentNewAmount && difference > 0) {
			if (newAmountInteger > oldAmount) {
				angular.extend(paymentObj, {
					paymentDifferenceLabel: '+' + $filter('number')(difference, 2),
					paymentIsDecrease: false,
					paymentIsIncrease: true,
				});

			} else {
				angular.extend(paymentObj, {
					paymentDifferenceLabel: '-' + $filter('number')(difference, 2),
					paymentIsDecrease: true,
					paymentIsIncrease: false
				});
			}
		}
		else {
			angular.extend(paymentObj, {
				paymentDifferenceLabel: '0.00',
				paymentIsDecrease: false,
				paymentIsIncrease: false
			});
		}
	}

	function onNewPaymentAmountChange () {
		calculateDifference();
		setIsPaymentValid();
		$scope.onPaymentChange();
	}

	function setIsPaymentValid () {

		const paymentNewAmountIsEmpty = (!paymentObj.paymentNewAmount || paymentObj.paymentNewAmount === '');
		const paymentNewAmountHasChanged = (paymentObj.paymentNewAmountInteger !== paymentObj.paymentAmount);

		paymentObj.isValid = (!paymentNewAmountIsEmpty && paymentNewAmountHasChanged);
	}

	function paymentPatternConfig() {

		if (paymentObj.paymentPatternConfig.toString().includes('.')) {
			return 'Maximum of ' + $filter('monetise')(paymentObj.paymentPatternConfig) + ' for ' + paymentObj.paymentLabel;
		} else {
			return 'Maximum of ' + $filter('monetise')(paymentObj.paymentPatternConfig, 'down') + ' for ' + paymentObj.paymentLabel + '. No decimal places';
		}
	}

	init();

	angular.extend($scope, {
		onNewPaymentAmountChange,
		paymentConfig: paymentPatternConfig(),
		paymentId: $filter('slugify')(`${$scope.fieldsetId}-${paymentObj.paymentLabel}`)
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('currentTaxStatus', {
	bindings: {
		teamMember: '<',
	},
	controller: 'currentTaxStatusCtrl',
	templateUrl: 'components/current-tax-status/current-tax-status.component.html',
})
.controller('currentTaxStatusCtrl', [
	'config',
	'NI_CATEGORY_LETTER',
	function (
		config,
		NI_CATEGORY_LETTER
	) {

	const $ctrl = this;

	function getTaxCode (taxStatusDetailsObj) {

		return taxStatusDetailsObj.TaxCode + (taxStatusDetailsObj.TaxCodeM1W1 ? ' ' + config.w1m1Label : '');
	}

	function $onInit () {
		angular.extend($ctrl, {
			taxCode: getTaxCode($ctrl.teamMember.Tax),
		});
	}
	
	angular.extend($ctrl, {
		$onInit,
		NI_CATEGORY_LETTER,
	});
}]);

'use strict';

angular.module('paycircleApp')

	.component('customTextarea', {
		bindings: {
			text: '=',
			name: '@',
			placeholder: '@',
			required: '@',
			rows: '@',
			form: '<'
		},
		controller: 'customTextareaCtrl',
		templateUrl: 'components/custom-textarea/custom-textarea.component.html',
		require: {
			form: '^form',
			ngModel: '?^ngModel'
		},
	})

	.controller('customTextareaCtrl', [
		function (
		){

		const $ctrl = this;

		$ctrl.$onInit = function () {

		};

		function updateNgModel () {

			// Since we are using the div as input, we need to update the ngModel manually
			const divInput = getDivInput();

			if (divInput) {
				$ctrl.text = divInput.innerText;
			}

			const textarea = getTextarea();

			if (textarea) {

				textarea.value = $ctrl.text;
				textarea.dispatchEvent(new Event('input'));
				// Mark as touched to be able to trigger the validation
				$ctrl.form[$ctrl.name].$setTouched(true);

			}
		}

		function getDivInput () {

			return document.getElementById(`${$ctrl.name}-textarea-input`);
		}

		function getTextarea () {

			return document.getElementById(`${$ctrl.name}`);
		}

		angular.extend($ctrl, {

			updateNgModel,
		});
}]);

'use strict';

angular.module('paycircleApp')

.component('customerCodesCard', {
	bindings: {
		agencyProfileId: '=',
		customerCode: '<',
		refresh: '='
	},
	controller: 'customerCodesCardCtrl',
	templateUrl: 'components/customer-codes-card/customer-codes-card.component.html'
})

.controller('customerCodesCardCtrl', [
	'$rootScope',
	function (
		$rootScope
	){

	const $ctrl = this;

	$ctrl.$onInit = function () {
	};

	function editCustomerCode (customerCodeObj) {
		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			customerCode: customerCodeObj,
			callback: $ctrl.refresh,
			formKey: 'company-settings-customer-codes'
		});
	}

	angular.extend($ctrl, {
		editCustomerCode
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('customisationImageUploader', function () {

	return {
		templateUrl: 'components/customisation-image-uploader/customisationImageUploaderComponent.html',
		controller: 'customisationImageUploaderController',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			fuAllowedFileTypes: '@?',
			fuCustomisationType: '<',
			fuMaxFileSize: '<', // kb
			fuModel: '=',
			fuTheme: '@?',
			fuTemplate: '@?',
			fuOnDelete: '&?',
			fuOnUpdate: '&',
			fuMessage: '@?'
		}
	};
})
.controller('customisationImageUploaderController', [
	'$scope',
	'$timeout',
	'$transclude',
	'companyData',
	'dataTransfer',
	'libraries',
	'CUSTOMISATION_TYPES',
	'CUSTOMISATION_TYPE_IDS',
	function (
		$scope,
		$timeout,
		$transclude,
		companyData,
		dataTransfer,
		libraries,
		CUSTOMISATION_TYPES,
		CUSTOMISATION_TYPE_IDS
	) {

	var agencyProfileId = $scope.agencyProfileId;
	var customisationType = $scope.fuCustomisationType;
	var customisationTypeId = CUSTOMISATION_TYPE_IDS[customisationType];
	var maxFileSize = $scope.fuMaxFileSize !== undefined ? $scope.fuMaxFileSize * 1000 : null;

	function fireCallback () {

		if (typeof($scope.fuOnUpdate) === 'function') {

			$scope.fuOnUpdate();
		}
	}

	function fireOnDelete () {

		if (typeof($scope.fuOnDelete) === 'function') {

			$scope.fuOnDelete();
		}
		else {

			fireCallback();
		}
	}

	function init () {

		// Customisation type is required
		if (customisationType === undefined || customisationTypeId === undefined) {
			console.error('Paycircle: Customisation type does not exist');
			return;
		}

		// If max file size provided, make sure it's a number
		if (isNaN(maxFileSize)) {
			console.error('Paycircle: Customisation maximum file size is not a number');
			return;
		}

		var uploader = $scope.uploader = dataTransfer.getNewFileUploader({
			url: libraries.httpHandler.upload.customisation,
			queueLimit: 1,
			formData: [{
				agencyprofileid: agencyProfileId,
				imageType: customisationType,
			}],
			onAfterAddingFile: function (item) {

				// Validate file size
				if (maxFileSize && item.file.size > maxFileSize) {
					$scope.attemptedFileSize = item.file.size;
					$scope.fuState = 'invalid-file-size';
					uploader.clearQueue();
					return;
				}

				$scope.fuState = 'uploading';

				// Give the uploading message time to be digested
				$timeout(function () {
					uploader.uploadAll();
				}, 1500);
			},
			onSuccessItem: (item, response) => {

				// If file upload is unsuccessful (incorrect format/contains virus)
				if (response !== '1') {
					$scope.fuState = 'invalid-file';
					uploader.clearQueue();
					return;
				}

				// Give server time to generate file
				$timeout(function () {

					$scope.fuState = 'uploaded';
					fireCallback();
					uploader.clearQueue();

				}, 2000);
			}
		});
	}

	function isImagePopulated (imageUrl) {

		if (imageUrl === '' || imageUrl === undefined || !imageUrl) {
			return false;
		}

		return true;
	}

	init();

	$scope.deleteState = null;
	$scope.fuAllowedFileTypes = 'image/jpg, image/jpeg, image/png';
	$scope.fuProgress = 45;
	$scope.fuState = isImagePopulated($scope.fuModel) ? 'uploaded' : 'upload';
	$scope.fuTheme = $scope.fuTheme !== undefined ? $scope.fuTheme : 'primary';
	$scope.fuTemplate = $scope.fuTemplate !== undefined ? $scope.fuTemplate : 'inline';
	$scope.fuMessage = $scope.fuMessage || 'Choose file';

	$scope.cancelDeleteFileUpload = function () {

		$scope.fuState = 'uploaded';
	};

	$scope.confirmDeleteFileUpload = function () {

		$scope.fuState = 'confirm-delete';
	};

	$scope.deleteFileUpload = function () {

		$scope.fuState = 'deleting';

		// Give the deleting message time to be digested
		$timeout(function () {

			companyData.deleteAgencyProfileBLOBKey(agencyProfileId, customisationTypeId).then(function () {
				$scope.fuState = 'upload';

				// Give the server time to delete the file
				$timeout(function () {
					fireOnDelete();
				}, 1000);
			})
			.catch(function () {
				$scope.fuState = 'delete-error';
			});
		}, 1500);
	};

	$scope.setState = function (state) {

		$scope.fuState = state;
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('dateRangeFilter', {
	bindings: {
		filterGroup: '=',
		onApply: '&?',
		onClear: '&?'
	},
	controller: 'dateRangeFilterCtrl',
	templateUrl: 'components/date-range-filter/date-range-filter.component.html'
})
.controller('dateRangeFilterCtrl', [function () {

	const $ctrl = this;

	// Local input values - not bound to filterGroup, so typing does nothing until Apply
	$ctrl.fromDateIso = '';
	$ctrl.toDateIso = '';

	// Show the range that is already applied, so an applied range can be adjusted rather than retyped
	function $onInit () {

		$ctrl.fromDateIso = $ctrl.filterGroup.fromDateIso || '';
		$ctrl.toDateIso = $ctrl.filterGroup.toDateIso || '';
	}

	function isDateRangeValid () {

		if (!$ctrl.fromDateIso || !$ctrl.toDateIso) {
			return true;
		}

		return moment($ctrl.toDateIso).isSameOrAfter(moment($ctrl.fromDateIso), 'day');
	}

	function onApplyClick () {

		if ($ctrl.fromDateIso && $ctrl.toDateIso && isDateRangeValid()) {
			$ctrl.filterGroup.fromDateIso = $ctrl.fromDateIso;
			$ctrl.filterGroup.toDateIso = $ctrl.toDateIso;

			if (angular.isFunction($ctrl.onApply)) {
				$ctrl.onApply();
			}
		}
	}

	function onClearClick () {

		$ctrl.fromDateIso = '';
		$ctrl.toDateIso = '';
		$ctrl.filterGroup.fromDateIso = '';
		$ctrl.filterGroup.toDateIso = '';

		if (angular.isFunction($ctrl.onClear)) {
			$ctrl.onClear();
		}
	}

	angular.extend($ctrl, {
		$onInit,
		isDateRangeValid,
		onApplyClick,
		onClearClick
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('dashboardCarousel', function () {

	return {
		templateUrl: 'components/dashboard-carousel/dashboardCarouselComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			cap: '@?',
			companyList: '=?',
			companyLists: '=?',
			presetFilterKey: '<?',
			infoLabel: '@?',
			info: '@',
			itemsCount: '=?',
			isTeamMemberList: '=?',
			itemDescription: '<',
			tagType: '@?',
			theme: '@',
		},
		controller: 'dashboardCarouselCtrl'
	};
})

.controller('dashboardCarouselCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$timeout',
	'DPS_STATES',
function (
	$rootScope,
	$scope,
	$state,
	$timeout,
	DPS_STATES
) {

	const init = () => {

		$scope.companyData = {};
		$scope.companyData.companyList = $scope.companyList ? $scope.companyList : [];
		$scope.companyData.companyLists = $scope.companyLists ? $scope.companyLists : [];
		//Set the number of items to display per page of the carousel.
		$scope.mediaPhone = 760; //Width in pixels to jump the display count
		$scope.displayCountPhone = 2;
		$scope.displayCountDesktop = 6;

		$scope.tagType = !$scope.tagType ? 'daysTo' : 'isApproved';

		setDisplayCount();
		if($scope.companyData.companyLists.length > 0) {
			$scope.changeCategory(0);
		}

		$scope.cap = $scope.cap && $scope.cap < $scope.companyData.companyList.length ? parseInt($scope.cap) : $scope.companyData.companyList.length;

		window.addEventListener('resize', () => {
			setDisplayCount();
			configureCarousel($scope.displayCount, $scope.companyData.companyList.length);
		});
		configureCarousel($scope.displayCount, $scope.companyData.companyList.length);
	};

	const setDisplayCount = () => {
		$scope.displayCount = window.innerWidth <= $scope.mediaPhone ? $scope.displayCountPhone : $scope.displayCountDesktop;
	};
	/**
	 * Creates a new data ref that can be used by the data carousel component.
	 * @param  {number} displayCount the amount of items to show in a single slide.
	 * @param  {number} totalItems   the length of the list to be shown.
	 * @return {void}
	 */
	const configureCarousel = (displayCount, totalItems, noReset) => {
		totalItems = totalItems > $scope.cap ? $scope.cap : totalItems;
		//Each item in the returned array will represent a pip of the pagination controls in the carousel.
		// ES6 LINE READS: $scope.paginationList = [...new Array(Math.ceil(totalItems/displayCount)).keys()].map(_ => _ + 1);
		// Line has been pre-processed by babel to remove spread syntax that would otherwise break the build.
		$scope.paginationList = [].concat(_toConsumableArray(new Array(Math.ceil(totalItems / displayCount)).keys())).map(function (_) {
			return _ + 1;
		});
		//Pointer to be used against the pagination list to control navigation.
		if(!noReset) {
			$scope.paginationIndex = 0;
			//Object that will inform the view which items should presently be in view.
			$scope.displayBounds = getDisplayBounds($scope.paginationList[$scope.paginationIndex], displayCount);
		}
	};

	/**
	 * Returns the upper and lower bounds of items that should be displayed.
	 * @param  {number} paginationIndex The page currently on by the user. - Used to calculate offsets.
	 * @param  {number} displayCount    How many items should be listed on each page of the carousel.
	 * @return {object}                 {max, min}
	 */
	const getDisplayBounds = (page, displayCount) => ({
		max: page * displayCount - 1,
		min: page * displayCount - displayCount,
	});

	/**
	 * Function generater by babel to avoid spread syntax use.
	 * @type {arr}
	 */
	const _toConsumableArray = arr => {
		if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); }
	};
	/**
	 * Updates the paginationIndex pointer to the next item in the paginationList.
	 * Sets flag 'animateOut' which can be checked in scope for closing animations.
	 * @param  {number} destinationPage prodided as an index of the paginationList array. (NOT the value)
	 * @return {void}
	 */
	$scope.navigateToPage = (destinationPage) => {
		if(destinationPage !== $scope.paginationIndex) {
			$scope.animateOut = true;
			if(destinationPage < $scope.paginationIndex) {
				$scope.animateBackwards = true;
			} else {
				$scope.animateBackwards = false;
			}
			$timeout(() => {
				$scope.animateOut = false;
				if(destinationPage > $scope.paginationList.length - 1) {
					$scope.paginationIndex = 0;
				} else if (destinationPage < 0) {
					$scope.paginationIndex = $scope.paginationList.length - 1;
				} else {
					$scope.paginationIndex = destinationPage;
				}

				$scope.displayBounds = getDisplayBounds($scope.paginationList[$scope.paginationIndex], $scope.displayCount);
			}, 300);
		}
	};

	/**
	 * Switches the active company list to be used in the carousel.
	 * @param  {number} index index of the list in companylists
	 * @return {void}
	 */

	$scope.DPS_STATES = DPS_STATES;

	$scope.changeCategory = (index) => {
		$scope.paginationIndex = -1;
		$scope.animateOut = true;
		$scope.animateBackwards = false;
		$timeout(() => {
			$scope.animateOut = false;
			$scope.companyData.companyList = $scope.companyData.companyLists[index].companies;
			configureCarousel($scope.displayCount, $scope.companyData.companyList.length, true);

			$scope.displayBounds = getDisplayBounds($scope.paginationList[$scope.paginationIndex], $scope.displayCount);
			$scope.activeList = $scope.companyData.companyLists[index].title;
		}, 300);
		$scope.navigateToPage(0);

	};

	$scope.navigateTo = (companyId, companyName, userId) => {

		// Context: Team Member
		if (userId) {
			$state.go('team.profile.overview', {userId: userId, agencyProfileId: companyId});
		}

		// Context: Company
		else {
			$state.go('company-dashboard', {agencyProfileId: companyId});
		}
	};

	init();
}]);

'use strict';

angular.module('paycircleApp')
.directive('demoCompleted', function () {

	return {
		restrict: 'E',
		templateUrl: 'components/demo-completed/demoCompletedComponent.html',
		scope: {
			dcFor: '@'
		},
		controller: 'demoCompletedCtrl'
	};
})
.controller('demoCompletedCtrl', ['$element', '$rootScope', '$scope', '$state', '$timeout', 'TOOLTIPS', function ($element, $rootScope, $scope, $state, $timeout, TOOLTIPS) {

	var showFor = $scope.dcFor.split(',');
	var demoTaskComplete = $rootScope.demoTaskComplete;
	var demoToooltip = TOOLTIPS.demo[demoTaskComplete.demoShortId];

	$scope.demoCompletedMessage = demoToooltip.completed.replace('{{firstname}}', demoTaskComplete.firstName);
	$scope.demoLinkCopy = demoToooltip.link ? demoToooltip.link : 'Complete more tasks';
	$scope.showMessage = showFor.includes(demoTaskComplete.demoShortId) ? true : false;

	if ($scope.showMessage) {
		$timeout(function() {

			$element[0].scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
		}, 0);
	}


	$scope.backToDashboard = function () {

		$state.go('company-dashboard', {
			agencyProfileId: $rootScope.currentCompany.AgencyProfileID,
			completedDemo: demoTaskComplete.groupId
		});
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('descriptionCard', {
	bindings: {
		icon: '@',
		theme: '@'
	},
	templateUrl: 'components/description-card/description-card.component.html',
	transclude: true
});

'use strict';

angular.module('paycircleApp')
.component('detailBlock', {
	bindings: {
		dbCanEdit: '<?',
		dbDetails: '=',
		dbEditText: '<?',
		dbFeedbackPosition: '@?',
		dbShowFeedback: '<?'
	},
	controller: 'detailBlockCtrl',
	templateUrl: 'components/detail-block/detail-block.component.html',
	transclude: {
		'feedback': '?dbFeedback',
		'content': '?dbContent',
		'html': '?dbHtml'
	}
})
.controller('detailBlockCtrl', ['$rootScope', 'CUSTOMISATION_SHADES', 'EMAIL_PREVIEW_TYPES', 'PENSION_TYPES', function ($rootScope, CUSTOMISATION_SHADES, EMAIL_PREVIEW_TYPES, PENSION_TYPES) {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		angular.extend($ctrl, {
			CUSTOMISATION_SHADES,
			EMAIL_PREVIEW_TYPES,
			PENSION_TYPES,
			currentCompany: $rootScope.currentCompany,
			dbCanEdit: angular.isDefined($ctrl.dbCanEdit) ? $ctrl.dbCanEdit : true,
			dbEditText: angular.isDefined($ctrl.dbEditText) ? $ctrl.dbEditText : 'Edit',
			dbFeedbackPosition: angular.isDefined($ctrl.dbFeedbackPosition) ? $ctrl.dbFeedbackPosition : 'top',
			dbShowFeedback: angular.isDefined($ctrl.dbShowFeedback) ? $ctrl.dbShowFeedback : false
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('disbursementCard', function () {

	return {
		controller: 'disbursementCardCtrl',
		replace: true,
		scope: {
			company: '<',
			disbursement: '<',
			refreshDisbursements: '&?'
		},
		templateUrl: 'components/disbursement-card/disbursement-card.component.html'
	};
})

.controller('disbursementCardCtrl', ['$rootScope', '$scope', 'DISBURSEMENT_CONTEXT_TYPES', function ($rootScope, $scope, DISBURSEMENT_CONTEXT_TYPES) {

	function openDeleteBacsDisbursementForm (companyObj, disbursementObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: $scope.refreshDisbursements,
			contextType: 'company',
			disbursement: disbursementObj,
			formKey: 'company-settings-delete-bacs-disbursement',
			title: 'Delete disbursement'
		});
	}

	function openEditBacsDisbursementForm (companyObj, disbursementObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: $scope.refreshDisbursements,
			contextType: 'company',
			disbursementId: disbursementObj.DisbursementID,
			formKey: 'company-settings-add-bacs-disbursement',
			title: 'Edit disbursement'
		});
	}

	angular.extend($scope, {
		DISBURSEMENT_CONTEXT_TYPES,
		openDeleteBacsDisbursementForm,
		openEditBacsDisbursementForm,
		showMenu: false
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('documentUploadCard', {
	bindings: {
		document: '<',
		documentIndex: '<',
		onDelete: '&'
	},
	controller: 'documentUploadCardCtrl',
	templateUrl: 'components/document-upload-card/document-upload-card.component.html',
	transclude: {
		'actions': '?actions',
	},
})
.controller('documentUploadCardCtrl', ['$transclude', 'base', function ($transclude, base) {

	const $ctrl = this;

	function confirmDeleteDocument (documentObj) {

		documentObj.state = 'confirm';
	}

	function deleteDocument (documentObj) {

		base.deleteAgencyDocument(documentObj.AgencyDocumentID).then(() => {

			if (angular.isFunction($ctrl.onDelete)) {
				$ctrl.onDelete();
			}
		})
		.catch((error) => {
			console.error(error);
			documentObj.state = 'error';
		});
	}

	function resetDocumentState (documentObj) {

		documentObj.state = null;
	}

	$ctrl.$onInit = () => {

		$ctrl.hasActions = $transclude.isSlotFilled('actions');
	};

	angular.extend($ctrl, {
		confirmDeleteDocument,
		deleteDocument,
		resetDocumentState
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('documentUploadRow', {
	bindings: {
		agencyProfileId: '<',
		document: '<',
		bulkItems: '=?',
		refreshPage: '&?'
	},
	controller: 'documentUploadRowCtrl',
	templateUrl: 'components/document-upload-row/document-upload-row.component.html',
})
.controller('documentUploadRowCtrl', [
	'$rootScope',
	'bulkService',
	'dataTransfer',
	'importService',
	'DOCUMENT_STATES',
	'DOCUMENT_TYPES',
	'FILE_UPLOAD_FORMS',
	'MIME_FORMATS',
	function (
		$rootScope,
		bulkService,
		dataTransfer,
		importService,
		DOCUMENT_STATES,
		DOCUMENT_TYPES,
		FILE_UPLOAD_FORMS,
		MIME_FORMATS
	) {

	const $ctrl = this;

	function downloadDocument (ctrlObj) {

		const downloadUrl = dataTransfer.getBlobDownloadUrl(ctrlObj.document.AgencyDocumentID, ctrlObj.agencyProfileId, ctrlObj.document.documentNameOriginal);

		dataTransfer.downloadFile(downloadUrl, ctrlObj.document.documentNameOriginal);
	}

	function getFormTitle (formState) {

		switch (formState) {
			case FILE_UPLOAD_FORMS.deleteFile:
				return 'Delete file';

			case FILE_UPLOAD_FORMS.importFile:
				return 'Import team data';

			case FILE_UPLOAD_FORMS.importHistory:
				return 'Import history';

			default:
				return 'Edit file label';
		}
	}

	function onCheckboxToggle (ctrlObj) {
		bulkService.updateBulkItemTotals(ctrlObj.bulkItems);
	}

	function openFileUploadsForm (ctrlObj, formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			document: ctrlObj.document,
			callback: ctrlObj.refreshPage,
			formKey: 'company-settings-file-uploads',
			formState: formState,
			title: getFormTitle(formState)
		});
	}

	angular.extend($ctrl, {
		downloadDocument,
		goToDataImporterForDocumentType: importService.goToDataImporterForDocumentType,
		onCheckboxToggle,
		openFileUploadsForm,

		DOCUMENT_TYPES,
		DOCUMENT_STATES,
		FILE_UPLOAD_FORMS,
		MIME_FORMATS,

		showMenu: false,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('downloadLinkCard', {
	bindings: {
		text: '@',
		url: '<'
	},
	controller: 'downloadLinkCtrl',
	templateUrl: 'components/download-link-card/download-link-card.component.html'
})
.controller('downloadLinkCtrl', ['dataTransfer', function (dataTransfer) {

	const $ctrl = this;

	angular.extend($ctrl, {
		downloadFile: dataTransfer.downloadFile
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('dropdownMenu', {
	bindings: {
		menuAlign: '@?',
        menuDemoId: '@?',
        menuText: '@?',
        menuIcon: '@?',
        menuIconSize: '@?',
        menuId: '@?',
        menuOnOpen: '&?',
        menuShow: '=?',
        menuShowChevron: '<?',
        menuSize: '@?', // s, m (default), l
        menuTheme: '@?'
	},
	controller: 'dropdownMenuCtrl',
	templateUrl: 'components/dropdown-menu/dropdown-menu.component.html',
	transclude: true
})
.controller('dropdownMenuCtrl', function () {

	const $ctrl = this;

	function toggleMenu (ctrlObj) {
		ctrlObj.menuShow = !ctrlObj.menuShow;

		if (ctrlObj.menuShow && angular.isDefined(ctrlObj.menuOnOpen) && angular.isFunction(ctrlObj.menuOnOpen)) {
			ctrlObj.menuOnOpen();
		}
	}

	$ctrl.$onInit = () => {
		angular.extend($ctrl, {
			menuAlign: angular.isDefined($ctrl.menuAlign) ? $ctrl.menuAlign : 'right',
			menuIconSize: angular.isDefined($ctrl.menuIconSize) ? $ctrl.menuIconSize : 'm',
			menuShow: angular.isDefined($ctrl.menuShow) ? $ctrl.menuShow : false,
			menuShowChevron: angular.isDefined($ctrl.menuShowChevron) ? $ctrl.menuShowChevron : true,
			menuTheme: angular.isDefined($ctrl.menuTheme) ? $ctrl.menuTheme : '',
		});
	};

	$ctrl.toggleMenu = ctrlObj => {
		toggleMenu(ctrlObj);
	};
});

'use strict';

angular.module('paycircleApp')
.component('editableLabel', {
	bindings: {
		fieldName: '@',
		isEditable: '<?',
		ngModel: '=',
		onEdit: '&?'
	},
	controller: 'editableLabelCtrl',
	templateUrl: 'components/editable-label/editable-label.component.html'
})
.controller('editableLabelCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		angular.extend($ctrl, {
			editMode: false,
			isEditable: angular.isDefined($ctrl.isEditable) ? $ctrl.isEditable : false
		});
	};

	function cancelEditMode (ctrlObj) {

		ctrlObj.editMode = false;

		// Optional callback
		if (angular.isDefined($ctrl.onEdit)) {
			$ctrl.onEdit();
		}
	}

	function enterEditMode (ctrlObj) {
		ctrlObj.editMode = true;
	}

	angular.extend($ctrl, {
		cancelEditMode,
		enterEditMode
	});
});

'use strict';

angular.module('paycircleApp')
.component('emailCard', {

	controller: 'emailCardController',
	templateUrl: 'components/email-card/email-card.component.html',
	bindings: {
		agencyProfileId: '<',
		email: '<',
		onEmailActiveChange: '&?',
		previewType: '=?'
	}
})

.controller('emailCardController', ['$scope', 'EMAIL_PREVIEW_TYPES', 'MAIL_GROUP_TYPES', function($scope, EMAIL_PREVIEW_TYPES, MAIL_GROUP_TYPES) {

	const $ctrl = this;

	$ctrl.$onInit = function() {
		$ctrl.previewType = $ctrl.previewType || EMAIL_PREVIEW_TYPES.standard;
		if ($ctrl.email.Group === MAIL_GROUP_TYPES.system) {
			$ctrl.cardTheme = 'primary';
			$ctrl.isSystemEmail = true;
		}
		else {
			$ctrl.cardTheme = 'secondary';
			$ctrl.isSystemEmail = false;
		}
	};

	function toggleEmailIsActive (emailObj) {
		emailObj.IsActive = !emailObj.IsActive;
		if (angular.isDefined($ctrl.onEmailActiveChange)) {
			$ctrl.onEmailActiveChange();
		}
	}

	angular.extend($scope, {
		// Constants
		EMAIL_PREVIEW_TYPES,
		MAIL_GROUP_TYPES,

		// Functions
		toggleEmailIsActive
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('emailContacts', {
	bindings: {
		agencyProfileId: '<',
		contactExternalId: '<',
		isInAddressBook: '<?',
		label: '@',
		newContacts: '=',
		oldContacts: '='
	},
	require: {
		form: '^form'
	},
	controller: 'emailContactsCtrl',
	templateUrl: 'components/email-contacts/email-contacts.component.html',
})
.controller('emailContactsCtrl', ['$q', 'searchService', 'teamData', 'userData',
	function ($q, searchService, teamData, userData) {

	const $ctrl = this;

	const CONTACT_TYPES = {
		existing: 'existing',
		new: 'new'
	};

	const COMPONENT_STATES = {
		loading: 'loading',
		ready: 'ready',
		error: 'error',
	};

	function $onInit () {

		setComponentState(COMPONENT_STATES.loading);

		const getTeamMemberAdmins = teamData.getTeamMemberAdmins($ctrl.agencyProfileId);
		const getAllTeamMemberContactsExternal = userData.getAllTeamMemberContactsExternal($ctrl.agencyProfileId);
		const getTeamMemberContactsExternal = userData.getTeamMemberContactsExternal($ctrl.agencyProfileId, $ctrl.contactExternalId);

		$q.all([getTeamMemberAdmins, getAllTeamMemberContactsExternal, getTeamMemberContactsExternal]).then(
			([teamMemberAdminsArr, allExternalEmailContactsArr, externalEmailContactsForContactTypeArr]) => {

			const unusedExternalContactsArr = getUnusedContacts(allExternalEmailContactsArr, externalEmailContactsForContactTypeArr);

			angular.extend($ctrl, {
				teamMemberAdmins: teamMemberAdminsArr,
				externalContactsForType: externalEmailContactsForContactTypeArr,
				unusedExternalContacts: unusedExternalContactsArr.filter(decorateExistingContacts),
				showPayrollAdmins: false,
				showExternalContacts: false,
				selectedContacts: {}
			});

			setComponentState(COMPONENT_STATES.ready);
		})
		.catch(onError);
	}

	function decorateExistingContacts (externalContactObj) {

		externalContactObj.fullName = `${externalContactObj.Forename} ${externalContactObj.Surname}`;

		return externalContactObj;
	}

	function deleteSavedContact (ctrlObj, contactIndex) {

		const deletedContactObj = ctrlObj.externalContactsForType[contactIndex];

		ctrlObj.oldContacts.push(deletedContactObj);
		ctrlObj.unusedExternalContacts.push(decorateExistingContacts(deletedContactObj));

		ctrlObj.externalContactsForType.splice(contactIndex, 1);
	}

	function deleteUnsavedContact (ctrlObj, contactIndex) {
		ctrlObj.newContacts.splice(contactIndex, 1);
	}

	function getEmptyTeamMemberContact (ctrlObj) {

		return $q((onComplete, onError) => {

			if (!angular.isDefined(ctrlObj.emptyContact)) {

				userData.getEmptyTeamMemberContact().then(emptyTeamMemberContactObj => {

					ctrlObj.emptyContact = emptyTeamMemberContactObj;

					onComplete(emptyTeamMemberContactObj);
				})
				.catch(onError);

			} else {
				onComplete(angular.copy(ctrlObj.emptyContact));
			}
		});
	}

	function getUnusedContacts (allExternalEmailContactsArr, externalEmailContactsForContactTypeArr) {

		const externalContactIdsOfTypeArr = externalEmailContactsForContactTypeArr.map(externalContactObj => externalContactObj.ContactID);

		return allExternalEmailContactsArr.filter(externalContactObj => !externalContactIdsOfTypeArr.includes(externalContactObj.ContactID));
	}

	function onAddExternalContact (ctrlObj) {

		getEmptyTeamMemberContact(ctrlObj).then(emptyContactObj => {

			angular.extend(emptyContactObj, {
				externalContactType: ctrlObj.unusedExternalContacts.length > 0 ? CONTACT_TYPES.existing : CONTACT_TYPES.new,
				existingContact: null
			});

			ctrlObj.newContacts.push(emptyContactObj);
		})
		.catch(onError);
	}

	function onExternalContactSelect (ctrlObj, contactIndex, contactObj) {

		ctrlObj.selectedContacts[contactIndex] = contactObj.existingContact.ContactID;

		angular.extend(contactObj, {
			ContactID: contactObj.existingContact.ContactID,
			Email: contactObj.existingContact.Email,
			Forename: contactObj.existingContact.Forename,
			Surname: contactObj.existingContact.Surname
		});

		unselectContactIfAlreadySelected(ctrlObj, contactIndex, contactObj);
	}

	function onExternalContactTypeChange (contactObj) {
		angular.extend(contactObj, {
			Email: '',
			Forename: '',
			Surname: '',
			existingContact: null
		});
	}

	function onError (error) {
		console.error(error);
		setComponentState(COMPONENT_STATES.error);
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function toggleShowPayrollAdmins (ctrlObj) {
		if (ctrlObj.teamMemberAdmins.length > 0) {
			ctrlObj.showPayrollAdmins = !ctrlObj.showPayrollAdmins;
		}
	}

	function toggleshowExternalContacts (ctrlObj) {
		ctrlObj.showExternalContacts = !ctrlObj.showExternalContacts;
	}

	function unselectContactIfAlreadySelected (ctrlObj, contactIndex, contactObj) {

		for (let externalContactIndex = 0; externalContactIndex < ctrlObj.newContacts.length; externalContactIndex++) {

			if (contactIndex !== externalContactIndex) {

				const externalContactObj = ctrlObj.newContacts[externalContactIndex];

				if (externalContactObj.existingContact && contactObj.existingContact.ContactID === externalContactObj.existingContact.ContactID) {
					externalContactObj.existingContact = null;
				}
			}
		}
	}

	angular.extend($ctrl, {
		$onInit,
		COMPONENT_STATES,
		CONTACT_TYPES,

		deleteSavedContact,
		deleteUnsavedContact,
		onAddExternalContact,
		onExternalContactSelect,
		onExternalContactTypeChange,
		toggleShowPayrollAdmins,
		toggleshowExternalContacts,

		searchBarOptionsAdmins: searchService.emailContactsAdmins,
		searchBarOptionsExternal: searchService.emailContactsExternal
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('emptySearch', {
	bindings: {
		searchBarOptions: '='
	},
	templateUrl: 'components/empty-search/empty-search.component.html'
});
'use strict';

angular.module('paycircleApp')
.component('epsFormField', {
	bindings: {
		epsDetail: '<',
		epsFormField: '<',
		isDisabled: '<?',
		onChange: '&?',
		showLabels: '<'
	},
	require: {
		epsForm: '^form',
		// Just to enforce parent / child relationship. An epsFormField must belong to an epsFormFieldset
		epsFormFieldset: '^epsFormFieldset'
	},
	controller: 'epsFormFieldCtrl',
	templateUrl: 'components/eps-form-field/eps-form-field.component.html'
})
.controller('epsFormFieldCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		// Enabled by default. (Calculated EPS fields will always be disabled in the template).
		$ctrl.isDisabled = angular.isDefined($ctrl.isDisabled) ? $ctrl.isDisabled : false;
	};

	function differenceOnChange(ctrlObj) {

		if (angular.isFunction(ctrlObj.onChange)) {
			ctrlObj.onChange();
		}
	}

	angular.extend($ctrl, {
		differenceOnChange
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('epsFormFieldset', {
	bindings: {
		eps: '<'
	},
	controller: 'epsFormFieldsetCtrl',
	templateUrl: 'components/eps-form-fieldset/eps-form-fieldset.component.html'
})
.controller('epsFormFieldsetCtrl', ['utilities', function (utilities) {

	const $ctrl = this;

	const EPS_FORM_NO_CHANGES = 'epsFormNoChanges';
	const EPS_FIELD_NEGATIVE = 'epsFormFieldNegative';

	function decorateEPS (epsObj) {

		/* Don't do anything if this object has already been updated. This form can be reinstated, and its changes state needs to be
		   preserved for potential resubmission (if eps submission fails). There's no point doing all of this twice anyway. */
		if (!epsObj.hasChanges) {
			// Add eps fields. Used to build up form and check validity. Dependant fields are marked, correspond to other calculated fields.
			epsObj.epsFormFields = [];

			if (epsObj.CanUpdateSMP || 
				epsObj.EPSDetail.SMPRecoveredYTD !== 0 || epsObj.EPSDetail.SMPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnSMPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnSMPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'SMPRecovered',
					description: 'SMP Reclaimed',
					dependantNICField: 'NICCompensationOnSMP'
				},
				{
					name: 'NICCompensationOnSMP',
					description: 'SMP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			if (epsObj.CanUpdateSPP || 
				epsObj.EPSDetail.SPPRecoveredYTD !== 0 || epsObj.EPSDetail.SPPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnSPPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnSPPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'SPPRecovered',
					description: 'SPP Reclaimed',
					dependantNICField: 'NICCompensationOnSPP'
				},
				{
					name: 'NICCompensationOnSPP',
					description: 'SPP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			if (epsObj.CanUpdateSAP || 
				epsObj.EPSDetail.SAPRecoveredYTD !== 0 || epsObj.EPSDetail.SAPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnSAPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnSAPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'SAPRecovered',
					description: 'SAP Reclaimed',
					dependantNICField: 'NICCompensationOnSAP'
				},
				{
					name: 'NICCompensationOnSAP',
					description: 'SAP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			if (epsObj.CanUpdateShPP || 
				epsObj.EPSDetail.ShPRecoveredYTD !== 0 || epsObj.EPSDetail.ShPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnShPPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnShPPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'ShPPRecovered',
					description: 'ShPP Reclaimed',
					dependantNICField: 'NICCompensationOnShPP'
				},
				{
					name: 'NICCompensationOnShPP',
					description: 'ShPP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			if (epsObj.CanUpdateSPBP || 
				epsObj.EPSDetail.SPBPRecoveredYTD !== 0 || epsObj.EPSDetail.SPBPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnSPBPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnSPBPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'SPBPRecovered',
					description: 'SPBP Reclaimed',
					dependantNICField: 'NICCompensationOnSPBP'
				},
				{
					name: 'NICCompensationOnSPBP',
					description: 'SPBP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			if (epsObj.CanUpdateSNCP || 
				epsObj.EPSDetail.SNCPRecoveredYTD !== 0 || epsObj.EPSDetail.SNCPRecoveredThisPeriod !== 0 || 
				epsObj.EPSDetail.NICCompensationOnSNCPYTD !== 0 || epsObj.EPSDetail.NICCompensationOnSNCPThisPeriod !== 0) {
				epsObj.epsFormFields.push({
					name: 'SNCPRecovered',
					description: 'SNCP Reclaimed',
					dependantNICField: 'NICCompensationOnSNCP'
				},
				{
					name: 'NICCompensationOnSNCP',
					description: 'SNCP NIC Compensation Recovered',
					isCalculated: true
				});
			}

			epsObj.epsFormFields.push({
				name: 'CISDeductionsSuffered',
				description: 'CIS Deductions Suffered'
			},
			{
				name: 'AppLevyDue',
				description: 'Apprenticeship Levy',
				integersOnly: true
			},
			{
				name: 'EmploymentAllowanceClaimed',
				description: 'Employment Allowance',
				isEmploymentAllowanceField: true
			});

			// In turn, decorate those with field names for YTD (current value) and ThisPeriod (difference)
			epsObj.epsFormFields.forEach(epsFormField => {
				epsFormField.currentValueField = `${epsFormField.name}YTD`;
				epsFormField.differenceField = `${epsFormField.name}ThisPeriod`;
				// This field is calculated and doesn't form part of the API, so lowercase it to ensure it's ignored
				epsFormField.newValueField = `${epsFormField.name.toLowerCase()}NewValue`;
				updateEpsFormField(epsObj, epsFormField);
			});

			// Check for changes. There may be some initially if an EPS is retrieved that hasn't been successfully submitted.
			checkForChanges(epsObj);

			// Assess if manual EPS warning needs to be shown
			updateIsEAOnlyUpdatedField();
		}
	}

	function checkForChanges (epsObj) {

		let epsHasChanges = false;

		// The form is valid if at least one difference value has changed; i.e. if current !== new for any eps field
		for (let epsFormField of epsObj.epsFormFields) {
			if (epsObj.EPSDetail[epsFormField.currentValueField] !== epsObj.EPSDetail[epsFormField.newValueField]) {
				epsHasChanges = true;
				break;
			}
		}
		epsObj.hasChanges = epsHasChanges;
	}

	function epsFormFieldOnChange (epsForm, epsObj, epsFormField) {
		updateEpsFormField(epsObj, epsFormField);

		// If the new value is -ve, mark the difference field as invalid, valid otherwise
		epsForm[epsFormField.differenceField].$setValidity(EPS_FIELD_NEGATIVE, epsObj.EPSDetail[epsFormField.newValueField] >= 0);

		/* Check EPS object for changes. This field change could have restored the object to its unchanged state,
		   so it needs to be checked here. */
		checkForChanges(epsObj);

		// Assess if manual EPS warning needs to be shown
		updateIsEAOnlyUpdatedField();
	}

	function getEpsFormField (epsObj, epsFormFieldName) {

		return epsObj.epsFormFields.find(epsFormField => {
			return epsFormField.name === epsFormFieldName;
		});
	}

	function getShowManualEPSEAWarning () {

		// Warning should be shown if only the EA field has a difference applied to it

		let otherFieldsHaveDifferenceValue = false;
		let employmentAllowanceFieldHasValue = false;

		function isDifferenceFieldUpdated (formField) {
			return $ctrl.eps.EPSDetail[formField.differenceField] !== 0;
		}

		for (let formField of $ctrl.eps.epsFormFields) {

			if (!formField.isEmploymentAllowanceField) {

				// Check fields other than EA field for a value
				if (isDifferenceFieldUpdated(formField)) {
					otherFieldsHaveDifferenceValue = true;
				}

			}
			// Check EA field for a value
			else {
				employmentAllowanceFieldHasValue = isDifferenceFieldUpdated(formField);
			}

		}

		// Returns true if all difference fields other than the EA field are empty
		return !otherFieldsHaveDifferenceValue && employmentAllowanceFieldHasValue;
	}

	function onEPSCanBeSubmittedWithoutChangesChange(epsObj) {
		if (epsObj.canBeSubmittedWithoutChanges) {
			// For each EPS form field, zero the difference and update to get everything in sync.
			epsObj.epsFormFields.forEach(epsFormField => {
				epsObj.EPSDetail[epsFormField.differenceField] = 0;
				updateEpsFormField (epsObj, epsFormField);
			});
		}
	}

	function updateEpsFormField (epsObj, epsFormField) {

		// Set or update new value for UI. Round to two decimal places.
		const newValue = utilities.roundTo((epsObj.EPSDetail[epsFormField.currentValueField] + epsObj.EPSDetail[epsFormField.differenceField]), 2);
		epsObj.EPSDetail[epsFormField.newValueField] = newValue;

		// If there's a dependant NIC field, calculate and set that
		if (angular.isDefined(epsFormField.dependantNICField)) {
			// Calculate and round
			let dependantNICFieldValue = epsObj.EPSDetail[epsFormField.differenceField] * epsObj.EPSDetail.StatPayNICCompensationPcnt;
			dependantNICFieldValue = utilities.roundTo(dependantNICFieldValue, 2);

			// Get the dependant form field, set its calculated value and in turn update it.
			const dependantEpsFormField = getEpsFormField(epsObj, epsFormField.dependantNICField);
			if (angular.isDefined(dependantEpsFormField)) {
				epsObj.EPSDetail[dependantEpsFormField.differenceField] = dependantNICFieldValue;
				updateEpsFormField(epsObj, dependantEpsFormField);
			}
		}
	}

	function updateIsEAOnlyUpdatedField () {
		$ctrl.eps.showManualEPSEAWarning = getShowManualEPSEAWarning();
	}

	$ctrl.$onInit = function () {

		// By default a change must be made to pass form validation
		$ctrl.eps.canBeSubmittedWithoutChanges = angular.isDefined($ctrl.eps.canBeSubmittedWithoutChanges) ? $ctrl.eps.canBeSubmittedWithoutChanges : false;

		decorateEPS($ctrl.eps);
	};

	angular.extend($ctrl, {

		// Constants
		EPS_FORM_NO_CHANGES,

		// Functions
		epsFormFieldOnChange,
		onEPSCanBeSubmittedWithoutChangesChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('errorBlock', {
	bindings: {
		title: '<?',
		hasGutter: '<?',
		secondaryAction: '&?',
		secondaryActionText: '@?',
		errorMessage: '@?'
	},
	controller: 'errorBlockCtrl',
	templateUrl: 'components/error-block/error-block.component.html',
	transclude: true,
})
.controller('errorBlockCtrl', [
	'tracking',
	'utilities',
	'TRACKING_EVENTS',
	'TRACKING_EVENT_CATEGORIES',
	function (
		tracking,
		utilities,
		TRACKING_EVENTS,
		TRACKING_EVENT_CATEGORIES
	) {

	const $ctrl = this;

	function $onInit () {

		// Track search events
		tracking.trackEvent(TRACKING_EVENTS.errorBlock, {
			event_category: TRACKING_EVENT_CATEGORIES.errors
		});
	}

	angular.extend($ctrl, {
		$onInit,
		hasGutter: angular.isDefined($ctrl.hasGutter) ? $ctrl.hasGutter : false,
		reloadPage: utilities.reloadPage,
		title: angular.isDefined($ctrl.title) ? $ctrl.title : 'There seems to be a problem'
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('extendedCheckbox', {
	bindings: {
		alwaysShowContent: '<?',
		disabled: '=?',
		hasBorder: '<',
		name: '@',
		ngModel: '=',
		onChange: '&?',
		required: '=?'
	},
	controller: 'extendedCheckboxCtrl',
	templateUrl: 'components/extended-checkbox/extended-checkbox.component.html',
	transclude: {
		'label': 'checkboxLabel',
		'content': '?checkboxContent'
	},
})
.controller('extendedCheckboxCtrl', ['$transclude', '$timeout', function ($transclude, $timeout) {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		let alwaysShowContent = $ctrl.alwaysShowContent;
		let disabled = $ctrl.disabled;
		let hasBorder = $ctrl.hasBorder;
		let required = $ctrl.required;

		angular.extend($ctrl, {
			hasBorder: angular.isDefined(hasBorder) ? hasBorder : true,
			hasContent: $transclude.isSlotFilled('content'),
			alwaysShowContent: angular.isDefined(alwaysShowContent) ? alwaysShowContent : false,
			required: angular.isDefined(required) ? required : false,
			disabled: angular.isDefined(disabled) ? disabled : false,
		});
	};

	function onCheckboxChange () {

		if (angular.isDefined($ctrl.onChange) && angular.isFunction($ctrl.onChange)) {
			$timeout(function () {
				$ctrl.onChange();
			});
		}
	}

	$ctrl.onCheckboxChange = onCheckboxChange;
}]);

'use strict';

angular.module('paycircleApp')
.component('extendedRadio', {
	bindings: {
		alwaysShowContent: '<',
		disabled: '<?',
		hasClickAnywhere: '<?',
		id: '@?',
		name: '@',
		ngModel: '=',
		required: '<?',
		onChange: '&?',
		showContentWhenChecked: '<?',
		theme: '@?',
		value: '<'
	},
	controller: 'extendedRadioCtrl',
	templateUrl: 'components/extended-radio/extended-radio.component.html',
	transclude: {
		'content': '?radioContent',
		'field': '?radioField',
		'label': 'radioLabel'
	},
})
.controller('extendedRadioCtrl', ['$transclude', '$timeout', function ($transclude, $timeout) {

	const $ctrl = this;

	function onRadioChange (ctrlObj) {

		if (angular.isDefined(ctrlObj.onChange) && angular.isFunction(ctrlObj.onChange)) {
			$timeout(() => {
				ctrlObj.onChange();
			});
		}
	}

	$ctrl.$onInit = function () {

		const alwaysShowContent = $ctrl.alwaysShowContent;
		const disabled = $ctrl.disabled;
		const required = $ctrl.required;

		angular.extend($ctrl, {
			alwaysShowContent: angular.isDefined(alwaysShowContent) ? alwaysShowContent : false,
			disabled: angular.isDefined(disabled) ? disabled : false,
			hasContent: $transclude.isSlotFilled('content'),
			hasField: $transclude.isSlotFilled('field'),
			id: angular.isDefined($ctrl.id) ? $ctrl.id : `${$ctrl.name}-${$ctrl.value}`,
			showContentWhenChecked: angular.isDefined($ctrl.showContentWhenChecked) ? $ctrl.showContentWhenChecked : true,
			required: angular.isDefined(required) ? required : false
		});
	};

	$ctrl.onRadioChange = onRadioChange;
}]);

'use strict';

angular.module('paycircleApp')
.component('extendedToggleInput', {
	bindings: {
		// See toggle-input.component.js for definitions
		alwaysShowContent: '<?',
		fieldDisabled: '=?',
		fieldLabel: '@',
		fieldLabelStayActive: '<?',
		fieldModel: '=',
		fieldName: '@',
		fieldOnChange: '&?',
		fieldThemeLight: '<?'
	},
	controller: 'extendedToggleInputCtrl',
	templateUrl: 'components/extended-toggle-input/extended-toggle-input.component.html',
	transclude: {
		'content': '?fieldContent',
		'description': '?fieldDescription'
	},
})
.controller('extendedToggleInputCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		angular.extend($ctrl, {
			hasDescription: $transclude.isSlotFilled('description'),
			hasContent: $transclude.isSlotFilled('content')
		});
	};

	function onFieldChange (ctrlObj) {
		if (angular.isFunction(ctrlObj.fieldOnChange)) {
			ctrlObj.fieldOnChange();
		}
	}

	angular.extend($ctrl, {
		onFieldChange
	});
}]);

'use strict';

angular.module('paycircleApp')

	.component('fastSearch', {
		bindings: {
			agencyProfileId: '=',
			userId: '='
		},
		controller: 'fastSearchCtrl',
		templateUrl: 'components/fast-search/fast-search.component.html',
	})

	.controller('fastSearchCtrl', [
		'TRACKING_EVENTS',
		'TRACKING_EVENT_CATEGORIES',
		'$q',
		'REGEX',
		'$rootScope',
		'$state',
		'$timeout',
		'tracking',
		'userData',
		'utilities',
		'USER_ROLES',
		function (
			TRACKING_EVENTS,
			TRACKING_EVENT_CATEGORIES,
			$q,
			REGEX,
			$rootScope,
			$state,
			$timeout,
			tracking,
			userData,
			utilities,
			USER_ROLES
		) {

			const $ctrl = this;

			function getCategoriesForUserType () {

				const isPaycircleSuperUser = $rootScope.userHasRole([USER_ROLES.paycircle]);
				if (isPaycircleSuperUser) {
					return {
						teamMembers: {
							Name: 'teamMembers',
							Label: 'Team members',
							Search: userData.getTeamMemberTurboSearch,
							Fields: {
								FullName: {
									Name: 'FullName',
									Label: 'Full name'
								},
								EmailAddress: {
									Name: 'Email',
									Label: 'Email address'
								},
								NiNumber: {
									Name: 'NiNumber',
									Label: 'NI number'
								},
								Guid: {
									Name: 'SearchGuid',
									Label: 'GUID',
									InputPattern: REGEX.guid
								}
							}
						},
						companies: {
							Name: 'comapanies',
							Label: 'Companies',
							Search: userData.getCompanyTurboSearch,
							Fields: {
								Name: {
									Name: 'Name',
									Label: 'Name'
								},
								TaxOfficeReference: {
									Name: 'TaxOfficeReference',
									Label: 'Tax office reference'
								},
								ClientReference: {
									Name: 'ClientReference',
									Label: 'Client reference'
								},
								Guid: {
									Name: 'SearchGuid',
									Label: 'GUID',
									InputPattern: REGEX.guid
								}
							}
						}
					};
				}

				return {
					teamMembers: {
						Name: 'teamMembers',
						Label: 'Team members',
						Search: userData.getTeamMemberTurboSearch,
						Fields: {
							FullName: {
								Name: 'FullName',
								Label: 'Full name'
							},
							EmailAddress: {
								Name: 'Email',
								Label: 'Email address'
							},
							NiNumber: {
								Name: 'NiNumber',
								Label: 'NI number'
							}
						}
					},
					companies: {
						Name: 'comapanies',
						Label: 'Companies',
						Search: userData.getCompanyTurboSearch,
						Fields: {
							Name: {
								Name: 'Name',
								Label: 'Name'
							},
							TaxOfficeReference: {
								Name: 'TaxOfficeReference',
								Label: 'Tax office reference'
							},
							ClientReference: {
								Name: 'ClientReference',
								Label: 'Client reference'
							}
						}
					}
				};
			}

			const CATEGORIES = getCategoriesForUserType();

			const COMPONENT_STATES = {
				closing: 'closing',
				error: 'error',
				loading: 'loading',
				opening: 'opening',
				noResults: 'no-results',
				ready: 'ready'
			};

			const SEARCH_STATES = {
				loading: 'loading',
				ready: 'ready'
			};

			const MIN_SEARCH_LENGTH = 3;
			const MAX_SEARCH_LENGTH = 100;
			const RESULTS_COUNT = 20;

			function $onInit () {

				setComponentState(COMPONENT_STATES.opening);

				$ctrl.searchData = {
					ResultsLimit: RESULTS_COUNT,
					SearchResults: [],
					State: SEARCH_STATES.loading,
					SearchString: ''
				};

				setFocusOnSearchInput();

				// Give the component time to animate
				$timeout(() => {
					setComponentState(COMPONENT_STATES.ready);
				}, 200);
			}

			function closeFastSearch () {
				setComponentState(COMPONENT_STATES.closing);

				$timeout(() => {
					$rootScope.$broadcast('close-fast-search');
				}, 200);
			}

			function getInputPattern () {
				return angular.isDefined($ctrl.activeField.InputPattern) ? $ctrl.activeField.InputPattern : '';
			}

			function onError (error) {

				setComponentState(COMPONENT_STATES.error);
				console.error(error);
			}

			function setActiveCategory (category) {

				angular.extend($ctrl, {
					categoryMenuOpen: false,
					activeCategory: category,
					activeField: Object.values(category.Fields)[0]
				});

				setFocusOnSearchInput();
			}

			function setActiveField (field) {

				angular.extend($ctrl, {
					fieldMenuOpen: false,
					activeField: field
				});

				setFocusOnSearchInput();
			}

			function setComponentState (componentState) {

				$ctrl.componentState = componentState;
			}

			function setFocusOnSearchInput () {
				const selectAll = false;
				const delay = 0;

				utilities.focusOn('paycircle-fast-search-input', selectAll, delay);
			}

			function showMoreResults () {

				$ctrl.searchData.ResultsLimit += RESULTS_COUNT;
			}

			function navigateToTeamMember (userId, companyId) {
				// Reset app header to remove current breadcrumbs companies
				$rootScope.$broadcast('reset-company-storage');
				// Load the team member
				$state.go(
					'team.profile.overview',
					{userId: userId, agencyProfileId: companyId},
					{reload: true}
				);
			}

			function navigateToCompany (companyId) {
				// Reset app header to remove current breadcrumbs companies
				$rootScope.$broadcast('reset-company-storage');
				// Navigate to company dashboard
				$state.go(
					'company-dashboard',
					{agencyProfileId: companyId},
					{reload: true}
				);
			}

			function updateSearch (searchString) {

				if (searchString.length < MIN_SEARCH_LENGTH) {
					return;
				}

				$ctrl.searchState = SEARCH_STATES.ready;

				angular.extend($ctrl.searchData, {
					State: SEARCH_STATES.loading,
					Category: $ctrl.activeCategory,
					SearchString: searchString
				});

				const searchCriteria = { [$ctrl.activeField.Name]: searchString };

				$ctrl.activeCategory.Search($ctrl.agencyProfileId, searchCriteria)
					.then((resultsArr) => {
						angular.extend($ctrl.searchData, {
							SearchResults: resultsArr,
							State: SEARCH_STATES.ready
						});

						// Track search events
						tracking.trackEvent(TRACKING_EVENTS.fastSearchQuery, {
							event_category: TRACKING_EVENT_CATEGORIES.search,
							event_label: searchString
						});
					})
					.catch(onError);
			}

			angular.extend($ctrl, {
				CATEGORIES,
				COMPONENT_STATES,
				SEARCH_STATES,
				MIN_SEARCH_LENGTH,
				MAX_SEARCH_LENGTH,

				$onInit,
				activeCategory: CATEGORIES.companies,
				activeField: Object.values(CATEGORIES.companies.Fields)[0],
				searchString: '',
				categoryMenuOpen: false,
				fieldMenuOpen: false,

				closeFastSearch,
				getInputPattern,
				navigateToCompany,
				navigateToTeamMember,
				setActiveCategory,
				setActiveField,
				showMoreResults,
				updateSearch
			});
		}]);

'use strict';

angular.module('paycircleApp')
.directive('featureCarousel', function () {

	return {
		templateUrl: 'components/feature-carousel/featureCarouselComponent.html',
		controller: 'featureCarouselController',
		replace: true,
		restrict: 'E',
		scope: {
			fcActiveKey: '=?',
			fcItems: '<',
			fcOnActiveKeyChange: '=?',
			fcTheme: '@?',
			fcDirectory: '@?'
		}
	};
})
.controller('featureCarouselController', ['$scope', '$timeout', function ($scope, $timeout) {

	var activeItemIndex = $scope.fcActiveKey !== undefined ? getItemIndexByItemKey($scope.fcActiveKey) : 0;

	function getItemIndexByItemKey (itemKey) {
		return $scope.fcItems.findIndex(function(i){
			return i.key === itemKey;
		});
	}

	function setActiveItem (activeItemIndex) {

		if ($scope.fcItems[activeItemIndex] === undefined) {
			console.error('Paycircle: The feature key provided is incorrect or does not match. Please make sure a correct feature key is used');
			return;
		}

		var activeKey = $scope.fcItems[activeItemIndex].key;

		$scope.fcActiveKey = activeKey;
		$scope.activeItemIndex = activeItemIndex;

		if ($scope.fcOnActiveKeyChange !== undefined) {
			$scope.fcOnActiveKeyChange(activeKey);
		}
	}

	setActiveItem(activeItemIndex);

	$scope.goToNextItem = function () {


		if ($scope.activeItemIndex === ($scope.fcItems.length - 1)) {
			return;
		}

		$scope.carouselState = 'closeNext';

		$timeout(function () {
			$scope.carouselState = 'next';
			$scope.activeItemIndex = $scope.activeItemIndex + 1;
			setActiveItem($scope.activeItemIndex);
		}, 250);
	};

	$scope.goToPreviousItem = function () {

		if ($scope.activeItemIndex === 0) {
			return;
		}

		$scope.carouselState = 'closePrevious';

		$timeout(function () {
			$scope.carouselState = 'previous';
			$scope.activeItemIndex = $scope.activeItemIndex - 1;
			setActiveItem($scope.activeItemIndex);
		}, 250);
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('featureSentiment', {
	bindings: {
		customerName: '<',
		feature: '@',
		product: '@?',
		theme: '@?',
		userId: '<'
	},
	controller: 'featureSentimentCtrl',
	templateUrl: 'components/feature-sentiment/feature-sentiment.component.html'
})
.controller('featureSentimentCtrl', [
	'$element',
	'$scope',
	'config',
	'loggedUserService',
	'mfeService',
	'utilities',
	function (
		$element,
		$scope,
		config,
		loggedUserService,
		mfeService,
		utilities
	) {

	const $ctrl = this;
	const currentUser = $scope.$root.currentUser;
	const isProduction = utilities.isEnvironmentProduction || utilities.isEnvironmentPreProduction;
	const sentimentConfig = isProduction ? config.sentiment.production : config.sentiment.test;
	const MFE_NAME = 'evo-feature-feedback-collector';
	const userRole = (currentUser && currentUser.UserResponseRoles) ? utilities.getPrimaryRole(currentUser.UserResponseRoles) || '' : '';
	let mfeInstance = null;

	$ctrl.instanceId = utilities.guid();
	$ctrl.isEvoEnabled = loggedUserService.isEvoEnabled();

	function $postLink () {
		if ($ctrl.isEvoEnabled) {
			loadMfe();
		}
	}

	function $onDestroy () {
		removeMfe();
	}

	function loadMfe () {
		const containerElement = $element[0].querySelector('.feature-sentiment_container');

		if (!containerElement) {
			console.error('Feature Sentiment: Container element not found in DOM');
			return;
		}

		mfeService.addMfe({
			instanceId: $ctrl.instanceId,
			name: MFE_NAME,
			container: containerElement,
			shell: 'none',
			parameters: {
				accountToken: sentimentConfig.accountToken,
				apiHost: sentimentConfig.apiHost,
				customerName: $ctrl.customerName,
				feature: $ctrl.feature,
				product: $ctrl.product || 'Paycircle',
				reDisplayAfterDays: sentimentConfig.reDisplayAfterDays,
				theme: $ctrl.theme || 'light',
				userId: $ctrl.userId,
				roleId: userRole
			}
		})
		.then(function (mfe) {
			mfeInstance = mfe;
			$scope.$applyAsync();
		})
		.catch(function (error) {
			console.error('Failed to load Feature Sentiment MFE:', error);
		});
	}

	function removeMfe () {
		if (mfeInstance) {
			mfeService.removeMfe($ctrl.instanceId);
			mfeInstance = null;
		}
	}

	angular.extend($ctrl, {
		$postLink,
		$onDestroy
	});
}]);

'use strict';

// Filter Bar Options
	// Filter Groups
		// Filter Options
			// Filter Option

angular.module('paycircleApp')
.component('filterBar', {
	bindings: {
		applyFilterKeys: '<?',
		filterBarOptions: '=',
		presetFilterKey: '@?'
	},
	controller: 'filterBarCtrl',
	controllerAs: 'vm',
	templateUrl: 'components/filter-bar/filter-bar.component.html'
})
.controller('filterBarCtrl',  [
	'$rootScope',
	'filterService',
	'storageService',
	'FILTER_OPTION_SPECIAL_TYPES',
	'STATE_STORAGE_KEYS',
	function (
		$rootScope,
		filterService,
		storageService,
		FILTER_OPTION_SPECIAL_TYPES,
		STATE_STORAGE_KEYS
	) {

	const $ctrl = this;

	function $onInit () {

		let savedFilterKeys = storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterKeys);
		let savedAdditionalValuesObj = storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterAdditionalData);

		let appliedFilterKeys = $ctrl.applyFilterKeys !== undefined ? $ctrl.applyFilterKeys.split(',') : savedFilterKeys ? savedFilterKeys : null;
		let filterBarOptionsObj = $ctrl.filterBarOptions;
		let presetFilterKey = $ctrl.presetFilterKey !== undefined ? $ctrl.presetFilterKey : null;
		let resetFilters = false;

		// No filter bar options defined
		if (filterBarOptionsObj === undefined) {
			$rootScope.paycircleMessage('Filter cannot be loaded as no filter options are defined', 'error');
			return;
		}

		// Check for preset filter
		if (presetFilterKey) {
			appliedFilterKeys = filterService.getFilterKeysByPresetFilterKey(presetFilterKey);
		}

		$ctrl.filterBarOptions = decorateFilterBarOptionsObj(filterBarOptionsObj, resetFilters, appliedFilterKeys, savedAdditionalValuesObj);

		applyAllFilters(filterBarOptionsObj);
	}

	function applyAllFilters (filterBarOptionsObj) {

		function getIsFilterAMatch (filterGroupOptionObj, value) {

			if (filterGroupOptionObj.inputType) {

				switch (filterGroupOptionObj.inputType) {

					// Pass in date to filter function
					case FILTER_OPTION_SPECIAL_TYPES.date:
						if (filterGroupOptionObj.filterExp(value, filterGroupOptionObj.dateIso)) {
							return true;
						}
						break;
				}
			}
			else if (filterGroupOptionObj.filterExp(value)) {
				return true;
			}

			return false;
		}

		filterBarOptionsObj.appliedFilter = value => {

			let returnBool = false;

			// Loop over filter groups
			for (let filterGroupObj of filterBarOptionsObj.filterGroups) {

				// Setup active states
				filterGroupObj.isActive = false; // Has a filter in this group been activated
				filterGroupObj.isMatch = false; // Has a filter in this group matched

				switch (filterGroupObj.filterAction) {

					case 'or':

						// Loop over filter options
						for (let filterGroupOptionObj of filterGroupObj.filterOptions) {

							if (filterGroupObj.activeFilterKey === filterGroupOptionObj.key) {
								filterGroupOptionObj.isActive = true;
								filterGroupObj.isActive = true;
								filterGroupObj.isMatch = getIsFilterAMatch(filterGroupOptionObj, value);
							}
							else {
								filterGroupOptionObj.isActive = false;
							}
						}

						break;

					case 'dateRange':

						if (filterGroupObj.fromDateIso && filterGroupObj.toDateIso && (filterGroupObj.filterExp || filterGroupObj.filterServerSide)) {
							filterGroupObj.isActive = true;
							// filterServerSide date ranges are filtered by the API, so they match everything in the UI
							filterGroupObj.isMatch = filterGroupObj.filterServerSide === true ?
								true :
								filterGroupObj.filterExp(value, filterGroupObj.fromDateIso, filterGroupObj.toDateIso);
						}
						break;

					default:

						// Loop over filter options
						for (let filterGroupOptionObj of filterGroupObj.filterOptions) {

							// Inclusive - Builds results up
							if (filterGroupOptionObj.isActive) {
								filterGroupObj.isActive = true;
								filterGroupObj.isMatch = getIsFilterAMatch(filterGroupOptionObj, value);
								if (filterGroupObj.isMatch) {
									break;
								}
							}
						}
				}
			}

			// Loop over active filter groups and only return if matches across all filter groups
			for (let filterGroupObj of filterBarOptionsObj.filterGroups) {
				if (filterGroupObj.isActive) {
					if (!filterGroupObj.isMatch) {
						returnBool = false;
						break;
					}
					else {
						returnBool = true;
					}
				}
			}

			updateFilterCounts(filterBarOptionsObj);

			return filterBarOptionsObj.totalCount === 0 ? true : returnBool; // Return all if no filters are applied
		};
	}

	function clearFilters (vmObj) {

		let resetFilters = true;

		decorateFilterBarOptionsObj(vmObj.filterBarOptions, resetFilters);

		vmObj.filterBarOptions.filterGroups.forEach(filterGroupObj => {
			resetFilterGroupValues(filterGroupObj);

			// Clear sessionStorage date keys for dateRange groups
			if (filterGroupObj.filterAction === 'dateRange') {
				sessionStorage.removeItem(filterGroupObj.storageKeyFrom);
				sessionStorage.removeItem(filterGroupObj.storageKeyTo);
			}
		});

		storageService.deleteFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterKeys);

		// Clear additional data
		storageService.deleteFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterAdditionalData);

		applyAllFilters(vmObj.filterBarOptions);
	}

	function decorateFilterBarOptionsObj (filterBarOptionsObj, resetFilters, appliedFilterKeys, savedAdditionalValuesObj) {

		function setupAdditionalData (filterOptionObj, savedAdditionalValuesObj) {

			const savedFilterValue = savedAdditionalValuesObj[filterOptionObj.key];

			if (!savedFilterValue) {
				return;
			}

			// Get saved value from storage and apply to filter option
			switch (filterOptionObj.inputType) {
				case FILTER_OPTION_SPECIAL_TYPES.date:
					filterOptionObj.dateIso = savedFilterValue;
					break;
			}
		}

		filterBarOptionsObj.appliedFilter = null;
		filterBarOptionsObj.modalOpen = false;
		filterBarOptionsObj.totalCount = 0;

		// Filter groups
		filterBarOptionsObj.filterGroups.forEach(filterGroupObj => {

			filterGroupObj.activeFilterKey = null;
			filterGroupObj.count = 0;
			filterGroupObj.menuOpen = false;

			// Date range filter group - restore saved dates directly from sessionStorage
			if (filterGroupObj.filterAction === 'dateRange') {

				// A date range must declare how it filters: a filterExp for UI filtering, or
				// filterServerSide: true when the API applies the range (so the UI matches everything).
				if (!filterGroupObj.filterExp && !filterGroupObj.filterServerSide) {
					console.error('filterBar: date range group "' + filterGroupObj.name + '" must define a filterExp or set filterServerSide: true');
				}

				if (!resetFilters) {
					filterGroupObj.fromDateIso = sessionStorage.getItem(filterGroupObj.storageKeyFrom) || '';
					filterGroupObj.toDateIso = sessionStorage.getItem(filterGroupObj.storageKeyTo) || '';
				}
				else {
					filterGroupObj.fromDateIso = '';
					filterGroupObj.toDateIso = '';
				}

				updateDateRangeDisplayText(filterGroupObj);
			}
			// Is this an 'or' (radio) option, only one can be active
			else if (filterGroupObj.filterAction === 'or') {
				filterGroupObj.filterOptions.forEach(filterOptionObj => {
					if (appliedFilterKeys && appliedFilterKeys.includes(filterOptionObj.key) && !resetFilters) {
						filterGroupObj.activeFilterKey = filterOptionObj.key;
						filterOptionObj.isActive = true;

						if (filterOptionObj.inputType) {
							setupAdditionalData(filterOptionObj, savedAdditionalValuesObj);
						}
					}
					else {
						filterOptionObj.isActive = false;
					}
				});
			}
			else {
				// Filter group options
				filterGroupObj.filterOptions.forEach(filterOption => {
					filterOption.isActive = false;

					if (appliedFilterKeys && !resetFilters) {
						filterOption.isActive = appliedFilterKeys.indexOf(filterOption.key) > -1;

						if (filterOption.isActive && filterOption.inputType) {
							setupAdditionalData(filterOption, savedAdditionalValuesObj);
						}
					}
				});
			}
		});

		return filterBarOptionsObj;
	}

	function deselectAllFilterGroupOptions (filterGroupObj) {

		filterGroupObj.activeFilterKey = null;

		resetFilterGroupValues(filterGroupObj);

		// Update storage
		saveFilterGroupOptions(filterGroupObj);
	}

	function updateSavedAdditionalDataForFilterOption (key, value) {

		const additionalDataObj = angular.copy(storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterAdditionalData, {}));

		storageService.deleteFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterAdditionalData);

		additionalDataObj[key] = value;

		storageService.addToSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterAdditionalData, additionalDataObj);
	}

	function saveFilterGroupOptions (filterGroupOptionObj, isFromOptionChangeClick) {

		function onFilterGroupOptionIsActive (filterOptionObj) {

			if (isFromOptionChangeClick && filterOptionObj.inputType) {
				switch (filterOptionObj.inputType) {
					case FILTER_OPTION_SPECIAL_TYPES.date:
						if (filterOptionObj.dateIso === undefined || filterOptionObj.dateIso === '') {
							return;
						}
				}
			}

			storageService.addToSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterKeys, filterOptionObj.key);

			if (filterOptionObj.inputType) {
				switch (filterOptionObj.inputType) {
					case FILTER_OPTION_SPECIAL_TYPES.date:
						updateSavedAdditionalDataForFilterOption(filterOptionObj.key, filterOptionObj.dateIso);
						break;
				}
			}
		}

		function onFilterGroupOptionIsInactive (filterOptionObj) {

			storageService.deleteFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.filterKeys, filterOptionObj.key);

			if (filterOptionObj.inputType) {
				switch (filterOptionObj.inputType) {
					case FILTER_OPTION_SPECIAL_TYPES.date:
						updateSavedAdditionalDataForFilterOption(filterOptionObj.key, '');
						break;
				}
			}
		}

		filterGroupOptionObj.filterOptions.forEach(filterOption => {
			if (filterGroupOptionObj.filterAction === 'or') {
				// Ensure that only the specified key is active
				if (filterGroupOptionObj.activeFilterKey === filterOption.key) {
					onFilterGroupOptionIsActive(filterOption);
				}
				else {
					onFilterGroupOptionIsInactive(filterOption);
				}
			}
			else {
				// Add or remove the filter option key from storage, depending on its active state
				if (filterOption.isActive) {
					onFilterGroupOptionIsActive(filterOption);
				}
				else {
					onFilterGroupOptionIsInactive(filterOption);
				}
			}
		});
	}

	function selectAllFilterGroupOptions (filterGroupObj) {

		filterGroupObj.filterOptions.forEach(filterOption => {
			filterOption.isActive = true;
		});

		// Save filter to storage
		saveFilterGroupOptions(filterGroupObj);
	}

	function resetFilterGroupValues (filterGroupObj) {

		if (filterGroupObj.filterAction === 'dateRange') {
			filterGroupObj.fromDateIso = '';
			filterGroupObj.toDateIso = '';
			updateDateRangeDisplayText(filterGroupObj);
			return;
		}

		filterGroupObj.filterOptions.forEach(filterOption => {
			filterOption.isActive = false;

			if (filterOption.inputType) {
				switch (filterOption.inputType) {
					case FILTER_OPTION_SPECIAL_TYPES.date:
						filterOption.dateIso = '';
						break;
				}
			}
		});
	}

	function toggleMenu (selectedFilter) {

		selectedFilter.menuOpen = !selectedFilter.menuOpen;
	}

	function toggleMobileMenu (vmObj) {

		vmObj.filterBarOptions.modalOpen = !vmObj.filterBarOptions.modalOpen;
	}

	function applyDateRange (filterGroupObj) {

		if (filterGroupObj.fromDateIso && filterGroupObj.toDateIso) {
			updateDateRangeDisplayText(filterGroupObj);
			saveDateRange(filterGroupObj);
		}
	}

	function clearDateRange (filterGroupObj) {

		filterGroupObj.fromDateIso = '';
		filterGroupObj.toDateIso = '';
		updateDateRangeDisplayText(filterGroupObj);

		sessionStorage.removeItem(filterGroupObj.storageKeyFrom);
		sessionStorage.removeItem(filterGroupObj.storageKeyTo);
	}

	function saveDateRange (filterGroupObj) {

		if (filterGroupObj.fromDateIso) {
			sessionStorage.setItem(filterGroupObj.storageKeyFrom, filterGroupObj.fromDateIso);
		}

		if (filterGroupObj.toDateIso) {
			sessionStorage.setItem(filterGroupObj.storageKeyTo, filterGroupObj.toDateIso);
		}
	}

	function updateDateRangeDisplayText (filterGroupObj) {

		if (filterGroupObj.fromDateIso && filterGroupObj.toDateIso) {
			filterGroupObj.displayText = moment(filterGroupObj.fromDateIso).format('DD/MM/YYYY') + ' - ' + moment(filterGroupObj.toDateIso).format('DD/MM/YYYY');
		}
		else {
			filterGroupObj.displayText = null;
		}
	}

	function updateFilterCounts (filterBarOptionsObj) {

		filterBarOptionsObj.totalCount = 0;

		filterBarOptionsObj.filterGroups.forEach(filterGroupObj => {

			filterGroupObj.count = 0;

			if (filterGroupObj.filterAction === 'dateRange') {
				if (filterGroupObj.fromDateIso && filterGroupObj.toDateIso) {
					filterBarOptionsObj.totalCount++;
					filterGroupObj.count = 1;
				}
				return;
			}

			filterGroupObj.filterOptions.forEach(filterOptionObj => {

				if (filterOptionObj.isActive) {
					filterBarOptionsObj.totalCount++;
					filterGroupObj.count++;
				}
			});
		});
	}

	angular.extend($ctrl, {
		$onInit,
		applyDateRange,
		clearDateRange,
		clearFilters,
		deselectAllFilterGroupOptions,
		saveFilterGroupOptions,
		selectAllFilterGroupOptions,
		toggleMenu,
		toggleMobileMenu,

		FILTER_OPTION_SPECIAL_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('filterBarBasic', {
	bindings: {
		filterBarOptions: '='
	},
	controller: 'filterBarBasicCtrl',
	templateUrl: 'components/filter-bar-basic/filter-bar-basic.component.html'
})
.controller('filterBarBasicCtrl', [
	'$timeout',
	function (
		$timeout
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl.filterBarOptions, {
			isSearchActive: false,
			searchString: ''
		});

		// Set initial filter option
		if (angular.isUndefined($ctrl.filterBarOptions.filterKey)) {
			$ctrl.filterBarOptions.filterKey = 'all';
		}

		// Set initial display option
		if (angular.isDefined($ctrl.filterBarOptions.displayOptions) && angular.isUndefined($ctrl.filterBarOptions.displayKey)) {
			setDisplayKey($ctrl, $ctrl.filterBarOptions.displayOptions[0]);
		}
	}

	function focusOn (elementId) {

		$timeout(() => {
			if (document.getElementById(elementId)) {
				document.getElementById(elementId).focus();
			}
		});
	}

	function setDisplayKey ($ctrl, displayOptionObj) {

		angular.extend($ctrl.filterBarOptions, {
			displayOption: displayOptionObj
		});

		if (angular.isFunction($ctrl.filterBarOptions.onDisplayChange)) {
			$ctrl.filterBarOptions.onDisplayChange($ctrl.filterBarOptions);
		}
	}

	function setFilterExp ($ctrl, filterObj) {

		angular.extend($ctrl.filterBarOptions, {
			filterKey: filterObj.key,
			filterExp: filterObj.filterExp,
			searchString: ''
		});
	}

	function toggleIsSearchActive ($ctrl) {

		$ctrl.filterBarOptions.isSearchActive = $ctrl.filterBarOptions.isSearchActive ? false : true;

		if ($ctrl.filterBarOptions.isSearchActive) {
			focusOn('filter-bar-basic_search-input');
		}
	}

	function toggleIsSearchActiveOnBlur ($ctrl) {

		if ($ctrl.filterBarOptions.searchString === '') {
			$ctrl.toggleIsSearchActive($ctrl);
		}
	}

	angular.extend($ctrl, {
		$onInit,
		focusOn,
		setDisplayKey,
		setFilterExp,
		toggleIsSearchActive,
		toggleIsSearchActiveOnBlur
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('fileCard', {
	bindings: {
		agencyProfileId: '<',
		file: '<',
		fileSize: '@?',
		fileTheme: '@?',
        onDelete: '&?',
        hasDownload: '<?',
		payPeriodId: '<?'
	},
	controller: 'fileCardCtrl',
	templateUrl: 'components/file-card/file-card.component.html',
	transclude: {
		'footer': '?fcFooter'
	},
})
.controller('fileCardCtrl', [
	'$transclude',
	'dataTransfer',
	'importService',
	'messageData',
	function (
		$transclude,
		dataTransfer,
		importService,
		messageData
	) {

	const $ctrl = this;

	function $onInit () {

		const fileObj = $ctrl.file;

		angular.extend($ctrl, {
        	hasDownload: angular.isDefined($ctrl.hasDownload) && $ctrl.hasDownload,
        	downloadUrl: dataTransfer.getBlobDownloadUrl(fileObj.AgencyDocumentID, $ctrl.agencyProfileId, fileObj.DocumentName),
        	icon: importService.getIconForMimeFormat(fileObj.MIMEFormat, fileObj.DocumentState)
		});
	}

	function deleteFile (fileObj) {

		fileObj.state = 'deleting';

		messageData.messageDocumentDelete($ctrl.agencyProfileId, fileObj.AgencyDocumentID).then(() => {

			if (angular.isFunction($ctrl.onDelete)) {
				$ctrl.onDelete();
			}

			fileObj.state = null;
		})
		.catch(error => {
			fileObj.state = 'error';
		    console.error(error);
		});
	}

	angular.extend($ctrl, {
		$onInit,
		deleteFile,
		downloadFile: dataTransfer.downloadFile,
		hasFooter: $transclude.isSlotFilled('footer')
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('formAccordion', {
	bindings: {
		icon: '@?',
		onToggle: '&?',
		showContent: '=?',
		theme: '@?'
	},
	controller: 'formAccordionCtrl',
	templateUrl: 'components/form-accordion/form-accordion.component.html',
	transclude: {
		'content': '?faContent',
		'title': '?faTitle'
	},
})
.controller('formAccordionCtrl', ['$timeout', '$transclude',
	function ($timeout, $transclude) {

	const $ctrl = this;

	function toggleContent () {

		$ctrl.showContent = !$ctrl.showContent;

		if (angular.isFunction($ctrl.onToggle)) {
			$timeout($ctrl.onToggle, 0);
		}
	}

	function $onInit () {
		angular.extend($ctrl, {
			hasContent: $transclude.isSlotFilled('content'),
			hasTitle: $transclude.isSlotFilled('title'),
			icon: angular.isDefined($ctrl.icon) ? $ctrl.icon : 'icon-edit',
			showContent: angular.isDefined($ctrl.showContent) ? $ctrl.showContent : false,
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-tertiary',
		});
	}

	angular.extend($ctrl, {
		$onInit,
		toggleContent,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('formAccordionAlternative', {
	bindings: {
		cancelId: '@?',
		editId: '@?',
		isReadOnly: '<?',
		onCancel: '&?',
		onEdit: '&?'
	},
	controller: 'formAccordionAlternativeCtrl',
	templateUrl: 'components/form-accordion-alternative/form-accordion-alternative.component.html',
	transclude: {
		'content': '?faaContent',
		'subtitle': '?faaSubtitle',
		'titleClosed': '?faaTitleClosed',
		'titleOpen': '?faaTitleOpen',
	},
})
.controller('formAccordionAlternativeCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit() {

		$ctrl.hasContent = $transclude.isSlotFilled('content');
		$ctrl.hasSubtitle = $transclude.isSlotFilled('subtitle');
	}

	function toggleContent () {

		$ctrl.showContent = !$ctrl.showContent;

		if (!$ctrl.showContent && angular.isFunction($ctrl.onCancel)) {
			$ctrl.onCancel();
		}

		if ($ctrl.showContent && angular.isFunction($ctrl.onEdit)) {
			$ctrl.onEdit();
		}
	}

	angular.extend($ctrl, {
		$onInit,
		toggleContent
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('formCabinet', function () {

	return {
		controller: 'formCabinetCtrl',
		templateUrl: 'components/form-cabinet/formCabinet.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})
.controller('formCabinetCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'applicationService',
	'payrollData',
	'teamData',
	'companyData',
	'companyService',
	'payPeriodService',
	'pensionData',
	'securityService',
	'tracking',
	'utilities',
	'BUSINESS_TYPES',
	'PENSION_TYPES',
	'SUBMISSION_STATES',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	'USER_GUIDES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$timeout,
		applicationService,
		payrollData,
		teamData,
		companyData,
		companyService,
		payPeriodService,
		pensionData,
		securityService,
		tracking,
		utilities,
		BUSINESS_TYPES,
		PENSION_TYPES,
		SUBMISSION_STATES,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS,
		USER_GUIDES
	) {

	const currentUserObj = $rootScope.currentUser;

	let formOptionsObj = $scope.formOptions;
	const agencyProfileId = formOptionsObj.agencyProfileId;
	const userId = formOptionsObj.userId;

	const CABINET_STATES = {
		companyArchived: 'company-archived',
		companyIsClone: 'company-is-clone',
		companyHasNoPayroll: 'company-has-no-payrll',
		error: 'error',
		loading: 'loading',
		noPermissions: 'no-permissions',
		notAvailableInPlayground: 'not-available-in-playground',
		payeSchemeCeased: 'paye-scheme-ceased',
		payrollFailed: 'payroll-failed',
		payrollNotUnsubmitted: 'payroll-not-unsubmitted',
		payrollPartiallySubmitted: 'payroll-partially-submitted',
		periodCalculated: 'period-calculated',
		periodInRollback: 'period-in-rollback',
		ready: 'ready',
		teamMemberAdvancingOrAdvanced: 'team-member-advancing-or-advanced',
		teamMemberOnHold: 'team-member-on-hold',
	};

	function checkFormData (formOptionsObj) {

		const companyObj = formOptionsObj.company;
		const currentPayPeriodObj = formOptionsObj.currentPayPeriod;
		const teamMemberObj = formOptionsObj.context;

		if (companyObj) {

			// Company archived
			if (companyObj.IsArchived && !formOptionsObj.availableWhenCompanyArchived) {
				setPageState(CABINET_STATES.companyArchived);
				return;
			}

			// Company PAYE ceased
			if (companyObj.CeasePAYESchemeComplete && !formOptionsObj.availableWhenCompanyPAYESchemeCeased) {
				setPageState(CABINET_STATES.payeSchemeCeased);
				return;
			}

			// Company PAYE cease pending
			if (!companyObj.CeasePAYESchemeComplete && companyObj.PAYECeaseDateISO !== '' && !formOptionsObj.availableWhenCompanyPAYESchemeCeasedPending) {
				setPageState(CABINET_STATES.payeSchemeCeased);
				return;
			}

			// Company cloned
			if (companyObj.IsClone && !formOptionsObj.availableWhenCompanyIsClone) {
				setPageState(CABINET_STATES.companyIsClone);
				return;
			}

			// Company is Pension only
			if (companyObj.PensionOnly && !formOptionsObj.availableWhenCompanyIsPensionOnly) {
				setPageState(CABINET_STATES.companyHasNoPayroll);
				return;
			}

			// Company has no payroll
			if (!companyObj.IsPayrollActive && !formOptionsObj.availableWhenCompanyPayrollModuleOff) {
				setPageState(CABINET_STATES.companyHasNoPayroll);
				return;
			}
		}

		// Payroll pending, submitting or failed
		if (!formOptionsObj.availableWhenNotUnsubmitted) {

			// No period loaded for company
			if (!currentPayPeriodObj) {
				setPageState(CABINET_STATES.error);
				throw(`PayrollState is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// No payroll state
			if (angular.isUndefined(currentPayPeriodObj.PayrollState)) {
				setPageState(CABINET_STATES.error);
				throw(`PayrollState is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// Failed
			if (currentPayPeriodObj.PayrollState === SUBMISSION_STATES.failed) {
				setPageState(CABINET_STATES.payrollFailed);
				return;
			}

			// Pending
			if (currentPayPeriodObj.PayrollState !== SUBMISSION_STATES.unsubmitted) {
				setPageState(CABINET_STATES.payrollNotUnsubmitted);
				return;
			}
		}

		// Payroll Partially Submitted
		if (!formOptionsObj.availableWhenPayrollPartiallySubmitted) {

			// No period loaded for company
			if (!currentPayPeriodObj) {
				setPageState(CABINET_STATES.error);
				throw(`Pay period is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// No IsPayrollPartiallySubmitted state
			if (angular.isUndefined(currentPayPeriodObj.IsPayrollPartiallySubmitted)) {
				setPageState(CABINET_STATES.error);
				throw(`IsPayrollPartiallySubmitted is not defined and is required for form: ${formOptionsObj.formKey}. Set isPayPeriodMinimumRequired: true in form options`);
			}

			// Partial Submission
			if (currentPayPeriodObj.IsPayrollPartiallySubmitted) {

				$scope.submittedFiles = payPeriodService.getSuccessfulSubmissionsDisplayForPayPeriod(currentPayPeriodObj);

				setPageState(CABINET_STATES.payrollPartiallySubmitted);
				return;
			}
		}

		// Period in rollback
		if (!formOptionsObj.availableWhenPeriodInRollback) {

			// No period loaded for company
			if (!currentPayPeriodObj) {
				setPageState(CABINET_STATES.error);
				throw(`Pay period is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// No IsRollback state
			if (angular.isUndefined(currentPayPeriodObj.IsRollback)) {
				setPageState(CABINET_STATES.error);
				throw(`IsRollback is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// In rollback
			if (currentPayPeriodObj.IsRollback) {
				setPageState(CABINET_STATES.periodInRollback);
				return;
			}
		}

		// Period calculated
		if (!formOptionsObj.availableWhenPayrollCalculated) {

			// No period loaded for company
			if (!currentPayPeriodObj) {
				setPageState(CABINET_STATES.error);
				throw(`Pay period is not defined and is required for form: ${formOptionsObj.formKey}`);
			}

			// No IsPayrollLocked state
			if (angular.isUndefined(currentPayPeriodObj.IsPayrollLocked)) {
				setPageState(CABINET_STATES.error);
				throw(`IsPayrollLocked is not defined and is required for form: ${formOptionsObj.formKey}. Set isPayPeriodMinimumRequired: true in form options`);
			}

			if (currentPayPeriodObj.IsPayrollLocked) {
				setPageState(CABINET_STATES.periodCalculated);
				return;
			}
		}

		// If team member loaded
		if (teamMemberObj) {

			// 'On Hold'
			if (!formOptionsObj.availableWhenTeamMemberOnHold && teamMemberObj.IsOnHold) {
				setPageState(CABINET_STATES.teamMemberOnHold);
				return;
			}

			// 'Advancing' or 'Advanced'
			if (!formOptionsObj.availableWhenTeamMemberIsAdvancingOrAdvanced && (teamMemberObj.IsAdvancingFuturePeriods || teamMemberObj.HasAdvancedFuturePeriods)) {
				setPageState(CABINET_STATES.teamMemberAdvancingOrAdvanced);
				return;
			}

		}

		// Page state
		setPageState(CABINET_STATES.ready);
	}

	function decorateCompany (companyObj) {

		companyObj.companyType = companyService.getCompanyTypeByInterfaceType(companyObj.CompanyType);

		return $filter('companyDetails')(companyObj, currentUserObj.isPaycircleAdmin);
	}

	function decorateTeamMember (teamMemberObj) {

		if (!teamMemberObj) {
			return teamMemberObj;
		}

		teamMemberObj.isCompany = teamMemberObj.IsCISSubcontractor && (teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.trust);

		return teamMemberObj;
	}

	function init () {

		// Setup form options with default properties
		applicationService.setupFormOptions(formOptionsObj);

		// Check if user has correct permissions, if permissions required
		if (formOptionsObj.requiredPermissions && !securityService.isUserAuthorisedFromPermissionArray(currentUserObj, formOptionsObj.requiredPermissions, 'form')) {
			setPageState(CABINET_STATES.noPermissions);
			return;
		}

		// Check if available while in playground
		if (!formOptionsObj.availableInPlayground && currentUserObj.IsInPlayground) {
			setPageState(CABINET_STATES.notAvailableInPlayground);
			return;
		}

		// Load context data if it hasn't been loaded previously
		if (formOptionsObj.contextDataLoaded) {
			checkFormData(formOptionsObj);

		} else {
			loadContextData(formOptionsObj);
		}

		// Track form opening
		tracking.trackEvent(TRACKING_EVENTS.slideInFormOpened, {
			event_category: TRACKING_EVENT_CATEGORIES.forms,
			event_label: formOptionsObj.formKey
		});
	}

	function getFormContextType (formOptionsObj) {

		// Context type specified
		if (formOptionsObj.contextType) {
			return formOptionsObj.contextType;
		}

		// Company
		if (agencyProfileId && userId) {
			return 'company';
		}

		return formOptionsObj.context ? 'user' : 'company';
	}

	function getIsServiceCallsApplicable (formOptionsObj) {

		// All service calls require company id
		if (!formOptionsObj.agencyProfileId) {
			return false;
		}

		return true;
	}

	function getIsServiceCallsRequired () {

		if (
			formOptionsObj.loadCompanyDetails ||
			formOptionsObj.loadPayPeriodCurrentDetails ||
			formOptionsObj.loadPayPeriodMinimumDetails ||
			formOptionsObj.loadPensionDetails ||
			formOptionsObj.loadTeamMemberDetails
		) {
			return true;
		}

		return false;
	}

	function getLoadCompanyDetails (formOptionsObj) {

		if (formOptionsObj.agencyProfileId) {
			return true;
		}

		return false;
	}

	function getLoadPayPeriodCurrentDetails (formOptionsObj) {

		// Pay period object is passed into form so use that
		if (angular.isObject(formOptionsObj.currentPayPeriod)) {
			return false;
		}

		// Manual option to force loading of pay period
		if (formOptionsObj.isPayPeriodCurrentRequired) {
			return true;
		}

		return false;
	}

	function getLoadPayPeriodMinimumDetails (formOptionsObj) {

		// Pay period object has been passed into the formOptionsObj, so we'll use that
		if (angular.isObject(formOptionsObj.currentPayPeriod)) {
			return false;
		}

		// Pay period is available at company level, so we'll use that
		if (angular.isObject($rootScope.currentPeriod)) {
			return false;
		}

		// If the pay period minimum object is required for the form to work it will get loaded if not available higher up the hierarchy tree
		if (formOptionsObj.isPayPeriodMinimumRequired) {
			return true;
		}

		// If any of these are defined, and there is no pay period object, then we need to make sure it's available
		if (
			!formOptionsObj.availableWhenNotUnsubmitted ||
			!formOptionsObj.availableWhenPayrollPartiallySubmitted ||
			!formOptionsObj.availableWhenPeriodInRollback ||
			!formOptionsObj.availableWhenPayrollCalculated
		) {
			return true;
		}

		return false;
	}

	function getLoadPensionDetails (formOptionsObj) {

		if (formOptionsObj.agencyEmployerPensionId && formOptionsObj.showPensionContext) {
			utilities.debug(`Pension details loaded for ${formOptionsObj.formKey}`);
			return true;
		}

		return false;
	}

	function getLoadTeamMemberDetails (formOptionsObj) {

		if (formOptionsObj.agencyProfileId && formOptionsObj.userId) {
			utilities.debug(`Team member details loaded for ${formOptionsObj.formKey}`);
			return true;
		}

		return false;
	}

	function getPayPeriodCurrentService (formOptionsObj) {

		if (!formOptionsObj.loadPayPeriodCurrentDetails) {
			return null;
		}

		utilities.debug(`GetPayPeriodCurrent loaded for ${formOptionsObj.formKey}`);

		return payrollData.getPayPeriodCurrent(formOptionsObj.agencyProfileId);
	}

	function getPayPeriodMinimumService (formOptionsObj) {

		if (!formOptionsObj.loadPayPeriodMinimumDetails) {
			return null;
		}

		utilities.debug(`GetPayPeriodMinimum loaded for ${formOptionsObj.formKey}`);

		return payrollData.getPayPeriodMinimum(formOptionsObj.agencyProfileId);
	}

	function loadContextData (formOptionsObj) {

		// Bow out early if there's no company id
		if (!getIsServiceCallsApplicable(formOptionsObj)) {
			setPageState(CABINET_STATES.ready);
			return;
		}

		// Needs to happen prior to getLoadPayPeriodMinimumDetails
		const loadPayPeriodCurrentDetails = getLoadPayPeriodCurrentDetails(formOptionsObj);

		angular.extend(formOptionsObj, {
			loadCompanyDetails: getLoadCompanyDetails(formOptionsObj),
			loadPayPeriodCurrentDetails,
			loadPayPeriodMinimumDetails: getLoadPayPeriodMinimumDetails(formOptionsObj),
			loadPensionDetails: getLoadPensionDetails(formOptionsObj),
			loadTeamMemberDetails: getLoadTeamMemberDetails(formOptionsObj)
		});

		// Drop out if no service calls are actually required
		if (!getIsServiceCallsRequired(formOptionsObj)) {
			setPageState(CABINET_STATES.ready);
			return;
		}

		function getCurrentPeriodObj (currentPeriodObj, minimumPeriodObj) {

			// Pay period current
			if (currentPeriodObj) {
				return currentPeriodObj;
			}

			// Minimum pay period
			if (minimumPeriodObj) {
				return minimumPeriodObj;
			}

			// Pay period is passed in to form options, use that
			if (formOptionsObj.currentPayPeriod) {
				return formOptionsObj.currentPayPeriod;
			}

			// Use currentPeriod from root
			return $rootScope.currentPeriod;
		}

		setPageState(CABINET_STATES.loading);

		$timeout(() => {

			const getAgencyProfileCompanyDetails = formOptionsObj.loadCompanyDetails ? companyData.getAgencyProfileCompanyDetails(agencyProfileId) : null;
			const getUserAgencyProfileForAgencyTeamMemberMinimum = formOptionsObj.loadTeamMemberDetails ? teamData.getUserAgencyProfileForAgencyTeamMemberMinimum(userId, agencyProfileId) : null;
			const getPayPeriodCurrent = getPayPeriodCurrentService(formOptionsObj);
			const getPayPeriodMinimum = getPayPeriodMinimumService(formOptionsObj);
			const getAgencyEmployerPensionSummary = formOptionsObj.loadPensionDetails ? pensionData.getAgencyEmployerPensionSummary(agencyProfileId, formOptionsObj.agencyEmployerPensionId) : null;

			$q.all([
				getAgencyProfileCompanyDetails,
				getUserAgencyProfileForAgencyTeamMemberMinimum,
				getPayPeriodCurrent,
				getPayPeriodMinimum,
				getAgencyEmployerPensionSummary
			]).then(([
				companyObj,
				teamMemberObj,
				currentPayPeriodObj,
				minimumPayPeriodObj,
				pensionObj
			]) => {

				angular.extend(formOptionsObj, {
					company: decorateCompany(companyObj),
					context: decorateTeamMember(teamMemberObj),
					currentPayPeriod: getCurrentPeriodObj(currentPayPeriodObj, minimumPayPeriodObj),
					contextDataLoaded: true,
					contextType: getFormContextType(formOptionsObj),
					pension: pensionObj
				});

				utilities.debug(formOptionsObj, 'log');

				checkFormData(formOptionsObj);
			})
			.catch(onError);

		}, formOptionsObj.animationSpeed * 1000);
	}

	function onError (error) {

		setPageState(CABINET_STATES.error);
		throw(error);
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		CABINET_STATES,
		PENSION_TYPES,
		USER_GUIDES
	});

	$scope.$watch('formOptions.formKey', function (newValue, oldValue) {
		if (!angular.equals(newValue, oldValue)) {
			init();
		}
	});
}]);



'use strict';

/**
 * @ngdoc function
 * @name formFeedback
 * @description
 * Directive that handles the form feedback
 */

angular.module('paycircleApp')
.directive('formFeedback', function () {

	return {
		controller: 'formFeedbackCtrl',
		templateUrl: 'components/form-feedback/formFeedback.html',
		replace: true,
		transclude: true,
		scope: {
			state: '='
		}
	};
})
.controller('formFeedbackCtrl', ['$scope', '$timeout', function ($scope, $timeout) {

	var timer;

	timer = $timeout(function () {
		$scope.state = '';
	}, 2000);


	$scope.$on('$destroy', function () {

		$timeout.cancel(timer);
	});

}]);


'use strict';

angular.module('paycircleApp')
.component('formField', {
	bindings: {
		formFieldOptions: '=',
		ngModel: '='
	},
	controller: 'formFieldCtrl',
	require: {
		parentForm: '^form'
	},
	templateUrl: 'components/form-field/form-field.component.html',
	transclude: {
		'main': '?formFieldMain'
	}
})
.controller('formFieldCtrl', [
	'$timeout',
	'config',
	'REGEX', 
function (
	$timeout,
	config,
	REGEX
) {

	const $ctrl = this;
	const FIELD_KEYS = [
		'errorMessages',
		'fieldType',
		'hasHeader',
		'isRequired',
		'label',
		'maxlength',
		'message',
		'minlength',
		'name',
		'onChange',
		'options',
		'patternRegex',
		'patternRegexKey',
		'placeholder',
		'suffix'
	];
	const FIELD_TYPES = {
		checkbox: 'checkbox',
		date: 'date',
		money: 'money',
		number: 'number',
		percentage: 'percentage',
		radios: 'radios',
		select: 'select',
		text: 'text'
	};

	function $onInit () {

		validateFormFieldOptions($ctrl.formFieldOptions);

		decorateFormFieldOptionsWithDefaults($ctrl.formFieldOptions);

		$ctrl.componentState = 'ready';
	}

	function decorateFormFieldOptionsWithDefaults (formFieldOptionsObj) {
		
		// Defaults
		const DEFAULTS = {
			class: null,
			errorMessages: getErrorMessages(formFieldOptionsObj),
			fieldType: FIELD_TYPES.text,
			hasHeader: true,
			isRequired: true,
			label: 'Test field',
			maxDateIso: null,
			maxlength: null,
			message: null,
			minDateIso: null,
			minlength: null,
			name: getFieldName(formFieldOptionsObj),
			options: null,
			patternRegex: getPatternRegexForForm(formFieldOptionsObj),
			patternRegexKey: null,
			placeholder: '',
			suffix: null
		};

		// A variation of angular.extend to keep the original object in tact >
		// Without this, two way binding is not possible as the object is re-created as this components $ctrl
		const numberOfFieldKeys = FIELD_KEYS.length;
		let i = 0;

		for (i; i < numberOfFieldKeys; i++) {
			
			const FIELD_KEY = FIELD_KEYS[i];

			if (angular.isUndefined(formFieldOptionsObj[FIELD_KEY])) {
				formFieldOptionsObj[FIELD_KEY] = DEFAULTS[FIELD_KEY];
			}	
		}
	}

	function getErrorMessages (formFieldOptions) {

		switch (formFieldOptions.fieldType) {

			case FIELD_TYPES.date:

				let errors = [
					{
						key: 'pattern',
						message: 'Please enter a valid date'
					},
					{
						key: 'required',
						message: 'Please enter a date'
					}
				];

				if (angular.isDefined(formFieldOptions.maxDateIso) && formFieldOptions.maxDateIso) {
					errors.push({
						key: 'max',
						message: `Please enter a date up to ${moment(formFieldOptions.maxDateIso, config.dateFormatISO).format(config.dateFormatPrimary)}`
					});
				}

				if (angular.isDefined(formFieldOptions.minDateIso) && formFieldOptions.minDateIso) {
					errors.push({
						key: 'min',
						message: `Please enter a date from ${moment(formFieldOptions.minDateIso, config.dateFormatISO).format(config.dateFormatPrimary)}`
					});
				}

				return errors;

			default:

				return [
					{
						key: 'maxlength',
						message: `Please enter a maximum of ${formFieldOptions.maxlength} character${formFieldOptions.maxlength > 1 ? 's' : ''}`
					},
					{
						key: 'minlength',
						message: `Please enter a maximum of ${formFieldOptions.minlength} character${formFieldOptions.minlength > 1 ? 's' : ''}`
					},
					{
						key: 'pattern',
						message: getPatternMessageForRegexPatternKey(formFieldOptions)
					},
					{
						key: 'required',
						message: 'Please enter a value'
					}
				];

		}
	}

	function getFieldName (formFieldOptions) {

		// Use name if supplied
		if (angular.isDefined(formFieldOptions.name)) {
			return formFieldOptions.name;
		}

		// Default to ID
		return formFieldOptions.id;
	}

	function getPatternMessageForRegexPatternKey (formFieldOptions) {

		switch (formFieldOptions.patternRegexKey) {

			case 'carMakeModel': {
				return 'Please enter letters, numbers or basic symbols';
			}
			case 'number7Digits2Decimal': {
				return `Please enter a positive number, maximum of ${config.number7Digits2Decimal}`;
			}
			case 'number8Digits2Decimal': {
				return `Please enter a positive number, maximum of ${config.number8Digits2Decimal}`;
			}
			case 'numberMax100': {
				return 'Please enter a positive number, maximum of 100';
			}	
			case 'numbersPositiveWhole': {
				return 'Please enter a positive whole number';
			}
			default: {
				return 'Please enter a valid value';
			}
		}
	}

	function hasHeader (formFieldOptions) {

		switch (formFieldOptions.fieldType) {
			case FIELD_TYPES.checkbox:
				return false;
			default:
				return true;
		}
	}

	function onChange () {

		// ng-model update event needs to happen before on change event, otherwise values in parent controller are incorrect
		if (angular.isFunction($ctrl.formFieldOptions.onChange)) {
			$timeout(() => {
				$ctrl.formFieldOptions.onChange();
			});
		}
	}

	function getPatternRegexForForm (formFieldOptions) {

		// If a specific regex key is defined, fetch it
		if (formFieldOptions.patternRegexKey) {

			const matchedPatternRegex = REGEX[formFieldOptions.patternRegexKey];

			// Unable to match pattern by key
			if (angular.isUndefined(matchedPatternRegex)) {
				throw 'No REGEX pattern matched';
			}

			return matchedPatternRegex;
		}

		return null;
	}

	function validateFormFieldOptions (formFieldOptions) {

		// Requires options
		if (angular.isUndefined(formFieldOptions)) {
			throw 'No formFieldOptions provided';
		}
	}

	angular.extend($ctrl, {
		FIELD_TYPES,
		$onInit,
		hasHeader,
		onChange
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('formFieldErrors', {
	bindings: {
		errorTypes: '<',
		inputName: '@'
	},
	controller: 'formFieldErrorsCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/form-field-errors/form-field-errors.component.html'
})
.controller('formFieldErrorsCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		// Input name is required
		if (!angular.isString($ctrl.inputName)) {
			console.error('<form-field-errors>: input-name is not defined. An input name is required for the form field errors component');
		}

		// Form object is required
		if (angular.isUndefined($ctrl.errorTypes)) {
			console.error('<form-field-errors>: Error types are not defined. Error types are required for the form field errors component');
		}
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('formGroup', function () {

	return {
		templateUrl: 'components/form-group/formGroupComponent.html',
		controller: 'formGroupController',
		replace: true,
		restrict: 'E',
		scope: {
			fgIsOpen: '<?',
			fgTitle: '@'
		},
		transclude: true
	};
})
.controller('formGroupController', ['$scope', function ($scope) {

	$scope.fgIsOpen = $scope.fgIsOpen !== undefined ? $scope.fgIsOpen : false;

	$scope.toggleOpen = function () {

		$scope.fgIsOpen = !$scope.fgIsOpen;
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('formHeader', {
	bindings: {
		fhShowTitle: '<?',
		fhSubtitle: '@',
		theme: '@'
	},
	controller: 'formHeaderComponentCtrl',
	templateUrl: 'components/form-header/form-header.component.html',
	transclude: {
		'formHeaderIntro': '?formHeaderIntro'
	}
})
.controller('formHeaderComponentCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			fhShowTitle: angular.isDefined($ctrl.fhShowTitle) ? $ctrl.fhShowTitle : true,
			hasIntro: $transclude.isSlotFilled('formHeaderIntro')
		});
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('formState', {
	templateUrl: 'components/form-state/form-state.component.html',
	controller: 'formStateController',
	bindings: {
		fsIcon: '@',
		fsShowClose: '<',
		fsTheme: '@?',
		fsTitle: '@',
		formOptions: '='
	},
	transclude: {
		'main': '?fsMain',
		'preheader': '?fsPreheader',
		'actions': '?fsActions'
	}
})

.controller('formStateController', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {

			// Defaults
			fsShowClose: angular.isDefined($ctrl.fsShowClose) ? $ctrl.fsShowClose : true,
			fsTheme: angular.isDefined($ctrl.fsTheme) ? $ctrl.fsTheme : 'primary',
			fsIcon: angular.isDefined($ctrl.fsIcon) ? $ctrl.fsIcon: 'question-mark',

			// Transclusion flags for convenience
			showFormActions: $transclude.isSlotFilled('actions'),
			showPreHeader: $transclude.isSlotFilled('preheader')
		});

		// Derived icon theme, based on icon type. Default to overall theme.
		$ctrl.iconTheme = $ctrl.fsTheme;
		switch ($ctrl.fsIcon) {
			case 'warning': {
				$ctrl.iconTheme = 'tertiary';
				break;
			}
			case 'information':
			case 'question-mark': {
				$ctrl.iconTheme = 'primary';
				break;
			}
			case 'tick': {
				$ctrl.iconTheme = 'positive';
				break;
			}
		}
	};

}]);


'use strict';

angular.module('paycircleApp')
.directive('formWizard', function () {

	return {
		templateUrl: 'components/form-wizard/formWizard.html',
		scope: {
			wizardOptions: '='
		},
		controller: 'formWizardCtrl'
	};
})
.controller('formWizardCtrl', [
	'$rootScope',
	'$scope',
	'$state',
	'$timeout',
	'applicationService',
	'companyData',
	'pensionService',
	'session',
	'teamData',
	'teamService',
	'utilities',
	'wizardService',
	'COMPANY_STATES',
	'FORM_WIZARD_KEYS',
	function (
		$rootScope,
		$scope,
		$state,
		$timeout,
		applicationService,
		companyData,
		pensionService,
		session,
		teamData,
		teamService,
		utilities,
		wizardService,
		COMPANY_STATES,
		FORM_WIZARD_KEYS
	) {

	const agencyProfileId = $scope.wizardOptions.agencyProfileId;
	const animationSpeed = $scope.wizardOptions.animationSpeed; // Seconds
	const callback = $scope.wizardOptions.callback;
	const companyState = $scope.wizardOptions.companyState;
	const currentPayPeriod = $scope.wizardOptions.currentPayPeriod;
	const wizardKey = $scope.wizardOptions.wizardKey;

	let activeStepIndex = $scope.wizardOptions.activeStepIndex;
	let isCallbackActive = false; // Set to true if updates have been made to know when to fire callback
	let userId = $scope.wizardOptions.userId;
	let wizardOptions = $scope.wizardOptions;

	function back () {

		activeStepIndex--;
		loadWizardForms();
	}

	function closeWizard (onClosed) {

		$scope.wizardOptions.isClosing = true;

		// Signal close to application. This is effectively a slide-in form. It just needs to know so it can deal with the overlay.
		$rootScope.$broadcast('close-slide-in-form');

		$timeout(() => {
			$scope.wizardOptions.isClosing = false;
			$scope.wizardOptions.isWizardOpen = false;

			// Only execute callback when a change has been made
			if (wizardOptions.initCallbackOnClose !== false && isCallbackActive) {
				$scope.wizardOptions.forceCallback();
			}

			// Used when opening new form wizard from within a wizard
			if (onClosed !== undefined && typeof onClosed === 'function') {
				onClosed();
			}
		}, animationSpeed * 1000);
	}

	function forceCallback (callbackPropertiesObj) {

		if (callback !== undefined) {

			// Validate to make sure the callback is a function
			if (!utilities.isFunction(callback)) {
				console.warn('Callback provided is not a function');
				return;
			}

			// Callback can provide a custom callback object
			if (callbackPropertiesObj !== undefined) {
				callback(callbackPropertiesObj);
			}
			else {
				callback(userId, agencyProfileId);
			}
		}
	}

	function getFormKeyIndexForWizard (wizardFormsData) {

		var i = 0;
		var numberOfForms = wizardFormsData.length;

		for (i; i < numberOfForms; i++) {

			var wizardForm = wizardFormsData[i];

			if (wizardForm.state === 0) {
				return i;
			}
		}

		return 0;
	}

	function getRequiredPermissionsForWizard (wizardKey) {

		switch (wizardKey) {
			case FORM_WIZARD_KEYS.teamMemberAdd:
				return [
					'Team.canAddDeleteTeamMembers'
				];

			case FORM_WIZARD_KEYS.teamMemberEditPersonal:
				return [
					'Team.canAddDeleteTeamMembers',
					'Team.canEditPersonalDetails'
				];

			case FORM_WIZARD_KEYS.cisCompany:
			case FORM_WIZARD_KEYS.cisSubcontractor:
			case FORM_WIZARD_KEYS.teamMemberEditEmployment:
				return [
					'Team.canAddDeleteTeamMembers',
					'Team.canEditCompanyDetails'
				];

			case FORM_WIZARD_KEYS.teamMemberEditAEPension:
			case FORM_WIZARD_KEYS.teamMemberEditNonAEPension:
				return [
					'Team.canAddDeleteTeamMembers',
					'Team.canUpdateTeamPensionSettings'
				];

			default:
				return null;
		}
	}

	function getWizardOptions (wizardFormsArray, teamMemberInformationObj) {

		var activeStep;
		var formKey;
		var totalForms = wizardFormsArray.length;

		// If no active step load first incomplete form
		if (activeStepIndex === undefined) {

			// Get index of first incomplete form
			activeStepIndex = getFormKeyIndexForWizard(wizardFormsArray);

			// Set form key
			formKey = wizardFormsArray[activeStepIndex].formKey;
		}

		// Otherwise load first form in array
		else {
			formKey = wizardFormsArray[activeStepIndex].formKey;
		}

		activeStep = activeStepIndex + 1;

		// Get index of first form in array in a 'pending' state
		var updatedWizardOptions = {
			activeStep: activeStep,
			activeStepIndex: activeStepIndex,
			canGoBack: totalForms > 0 && activeStep > 1,
			canSkip: wizardOptions.canSkip === false ? false : totalForms && activeStep < totalForms,
			closeWizard: closeWizard,
			formKey: formKey,
			isOpen: true,
			openNewFormWizard: openNewFormWizard,
			showHeader: true,
			showProgressBar: true,
			state: 'ready',
			teamMemberInformation: angular.isDefined(teamMemberInformationObj) ? teamMemberInformationObj : null,
			totalSteps: wizardOptions.noWizardSummary ? totalForms : (totalForms -1),
			primaryButtonText: (!wizardOptions.noWizardSummary && activeStep === totalForms -1) || (wizardOptions.noWizardSummary && activeStep === totalForms) ? 'Finish' : 'Next',
			wizardFormsArray: wizardFormsArray,
			wizardKey: wizardKey,
			requiredPermissions: getRequiredPermissionsForWizard(wizardKey)
		};

		wizardOptions = angular.extend(wizardOptions, updatedWizardOptions);

		applicationService.setupFormOptions(wizardOptions);

		return wizardOptions;
	}

	function init () {

		setPageState('loading');

		switch (wizardKey) {
			case 'company':
				wizardService.resetCompany();
				wizardService.resetPension();
				break;
		}

		loadWizardForms();
	}

	function loadTeamMemberForms (formKey) {

		if (!userId) {
			$rootScope.paycircleMessage('Add new team member wizard - No user ID provided', 'error');
			return;
		}

		if (!agencyProfileId) {
			$rootScope.paycircleMessage('Add new team member wizard - No AgencyProfileID provided', 'error');
			return;
		}

		teamData.getTeamMemberInformation(userId, agencyProfileId).then(teamMemberInformationObj => {

			// Grab the pension object for the pension wizard
			let teamMemberWizardPensionObj = {};
			if (formKey === 'ae-pension') {
				const teamMemberPensionObj = pensionService.getTeamMemberAEPension(teamMemberInformationObj.Pensions, wizardOptions.agencyEmployerPensionId, wizardOptions.pensionAdditionalPostId);
				// If found, set for wizard service. If not, a pension hasn't been set yet and the wizard pension object will remain empty.
				if (angular.isDefined(teamMemberPensionObj)) {
					teamMemberWizardPensionObj = teamMemberPensionObj;
				}
			}

			const wizardFormsArray = wizardService.getWizardTeamMemberForms(formKey, teamMemberInformationObj, currentPayPeriod, teamMemberWizardPensionObj);

			openSlideInForm(wizardFormsArray, teamMemberInformationObj);
		})
		.catch(onError);
	}

	function loadWizardForms () {

		var wizardFormsArray = null;

		switch (wizardKey) {

			// Add new company
			case FORM_WIZARD_KEYS.company:

				wizardFormsArray = wizardService.getWizardCompanyForms();

				openSlideInForm(wizardFormsArray);

				break;

			// Company > Payroll
			case FORM_WIZARD_KEYS.companyPayroll:

				wizardFormsArray = wizardService.getWizardCompanyPayrollForms();

				openSlideInForm(wizardFormsArray);

				break;

			// Company > HR
			case FORM_WIZARD_KEYS.companyHR:

				wizardFormsArray = wizardService.getHRSetupWizardForms();

				openSlideInForm(wizardFormsArray);

				break;

			// CIS Company
			case FORM_WIZARD_KEYS.cisCompany:

				loadTeamMemberForms('cis-company');

				break;

			// CIS Subcontractor
			case FORM_WIZARD_KEYS.cisSubcontractor:

				loadTeamMemberForms('cis-subcontractor');

				break;


			// Team Member > Add
			case FORM_WIZARD_KEYS.teamMemberAdd:

				wizardFormsArray = wizardService.getWizardTeamMemberForms('personal');

				openSlideInForm(wizardFormsArray);

				break;

			// Team Member > Edit
			case FORM_WIZARD_KEYS.teamMemberEditPersonal:

				loadTeamMemberForms('personal');

				break;

			// Team Member > Employment
			case FORM_WIZARD_KEYS.teamMemberEditEmployment:

				loadTeamMemberForms('employment');

				break;

			// Team Member > AE Pension
			case FORM_WIZARD_KEYS.teamMemberEditAEPension:

				loadTeamMemberForms('ae-pension');

				break;

			// Team Member > Non-AE Pension
			case FORM_WIZARD_KEYS.teamMemberEditNonAEPension:

				loadTeamMemberForms('non-ae-pension');

				break;

			// Form key not set up
			default:
				$rootScope.paycircleMessage('Unable to find form wizard for key: ' + wizardKey, 'error');
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onSuccess (responseObj) {

		activeStepIndex++;

		isCallbackActive = true;

		// On team member creation, no UserID is present
		if (responseObj !== undefined) {
			userId = responseObj.userId;
		}
		loadWizardForms();
	}

	function openNewFormWizard (wizardOptions) {

		if (wizardOptions.disableCallback) {
			isCallbackActive = false;
		}

		closeWizard(function () {
			$timeout(function () {
				$rootScope.$broadcast('open-form-wizard', wizardOptions);
			});
		});
	}

	function openSlideInForm (wizardFormsArray, teamMemberInformationObj) {

		if (!wizardFormsArray.length) {
			$rootScope.paycircleMessage('Form wizard - No forms returned for wizard', 'info');
			return;
		}

		if (companyState === COMPANY_STATES.onboarding) {
			wizardFormsArray[wizardFormsArray.length-1].formKey = 'personal-overview';
		}

		var slideInFormOptions = getWizardOptions(wizardFormsArray, teamMemberInformationObj);

		$scope.wizardOptions = slideInFormOptions;

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function skip () {

		activeStepIndex++;
		loadWizardForms();
	}

	init();

	angular.extend($scope.wizardOptions, {
		back,
		closeWizard,
		forceCallback,
		onSuccess,
		skip
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('fullPageControls', {
	bindings: {
		theme: '@?'
	},
	controller: 'fullPageControlsCtrl',
	templateUrl: 'components/full-page-controls/full-page-controls.component.html',
	transclude: {
		'primaryActions': '?fpcPrimary',
		'secondaryActions': '?fpcSecondary',
		'tertiaryActions': '?fpcTertiary'
	},
})
.controller('fullPageControlsCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			hasPrimaryActions: $transclude.isSlotFilled('primaryActions'),
			hasSecondaryActions: $transclude.isSlotFilled('secondaryActions'),
			hasTertiaryActions: $transclude.isSlotFilled('tertiaryActions')
		});
	}
	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('fileUploader', {
	bindings: {
		fuAgencyProfileId: '<',
		fuAllowedFileTypes: '@?',
		fuAllowedFileTypesKey: '@?',
		fuAllowMultiple: '<?',
		fuFileList: '<?',
		fuLabel: '@?',
		fuMaxFileSize: '<?',
		fuName: '@',
		fuOnError: '&?',
		fuOnUpdate: '&?',
		fuOnUploadStart: '&?',
		fuOnUploadComplete: '&?',
		fuParams: '<'
	},
	controller: 'fileUploaderAltCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/file-uploader/file-uploader.component.html'
})
.controller('fileUploaderAltCtrl', [
	'$scope',
	'$timeout',
	'$window',
	'config',
	'dataTransfer',
	'fileUploadService',
	'importService',
	'libraries',
	'messageData',
	'utilities',
	function (
		$scope,
		$timeout,
		$window,
		config,
		dataTransfer,
		fileUploadService,
		importService,
		libraries,
		messageData,
		utilities
	) {
		const $ctrl = this;

		// Individual file upload statuses
		const FILE_UPLOAD_STATUSES = {
			complete: 'complete',
			error: 'error',
			success: 'success',
			uploading: 'uploading'
		};

		// Overall uploader status; if anything's being uploaded, it'll be 'uploaded', otherwise 'complete' (even if nothing's been uploaded)
		const UPLOADER_STATUSES = {
			complete: 'complete',
			uploading: 'uploading'
		};

		/* These will get stuffed into a hidden required input to control the overall uploader validity in the context of the parent form,
		   to effectively disable the form during upload. */
		const UPLOADER_VALID_STATUSES = {
			// This can be any string as long as it isn't empty; 'valid' is an obvious and inoffensive choice.
			valid: 'valid',
			// Similarly for invalid status. Must be an empty string, so the hidden required input is invalid.
			invalid: ''
		};

		$ctrl.$onDestroy = () => {

			// Ensure window events don't linger once this component is destroyed
			setUploaderEnabled(false);
		};

		$ctrl.$onInit = () => {

			const fileUploadTypesStr = fileUploadService.getAllowedFileTypesForUpload($ctrl.fuAllowedFileTypes, $ctrl.fuAllowedFileTypesKey);

			angular.extend($ctrl, {
				showDropzone: false,

				/* Unique file ID (in the context of this uploader). A list of files (for the UI) and file items (for the uploader) are maintained
				   separately in this component, so as not to corrupt the file list provided by the component client. Uploader file items have a
				   recursive structure which will cause a problem if they end up getting passed to the platform. In this way a mapping can be
				   established between files and fileitems without combining the two. */
				fileId: 0,

				// Defaults
				fuAllowedFileTypes: fileUploadTypesStr,
				fuAllowedFileTypesDescription: getFileUploadTypesDescription(fileUploadTypesStr),
				fuLabel: angular.isDefined($ctrl.fuLabel) ? $ctrl.fuLabel : 'Drag and drop or click to browse files',
				fuMaxFileSize: angular.isDefined($ctrl.fuMaxFileSize) ? $ctrl.fuMaxFileSize : config.maxDocumentUploadSize,
				fuAllowMultiple: angular.isDefined($ctrl.fuAllowMultiple) ? $ctrl.fuAllowMultiple : false,
				// Initialise file list to empty array if not specified
				fuFileList: angular.isDefined($ctrl.fuFileList) ? $ctrl.fuFileList : [],
				/* File items for uploader. Initially always empty; this will only become populated for new uploads
				   (while the file list, above, may contain files, those represent files that have already been uploaded,
				   so the uploader doesn't need to know anything about those) */
				uploaderFileItems: []
			});

			// Decorate file list for UI. These have been passed to the uploader, so have already been uploaded.
			$ctrl.fuFileList.forEach(file => {
				angular.extend(file, {
					allowRetry: false,
					icon: importService.getIconForMimeFormat(file.MIMEFormat),
					status: FILE_UPLOAD_STATUSES.complete,
					/* Add file ID and increment for next. Strictly this won't be necessary for already uplaoded files,
					   just here to keep things consistent. */
					id: $ctrl.fileId++
				});
			});

			// Create and set uploader
			const uploader = dataTransfer.getNewFileUploader({

				formData: [$ctrl.fuParams],
				url: libraries.httpHandler.upload.importFile,

				onAfterAddingFile: fileItem => {

					// Add file, grab ID
					const newFile = $ctrl.addFileForFileItem(fileItem);

					// Hide the dropzone overlay, in case this follows a drop operation
					$ctrl.showDropzone = false;

					// Validate file format
					if (!fileUploadService.isUploadValidFileFormat(fileItem, $ctrl.fuAllowedFileTypes)) {
						angular.extend(newFile, {
							allowRetry: false,
							errorMessage: 'File format not allowed',
							icon: 'icon-warning',
							status: FILE_UPLOAD_STATUSES.error
						});
					}

					// Validate file size
					else if (newFile.DocumentSize > $ctrl.fuMaxFileSize) {
						angular.extend(newFile, {
							allowRetry: false,
							errorMessage: 'File size too big',
							icon: 'icon-warning',
							status: FILE_UPLOAD_STATUSES.error
						});
					}
					
					// Upload the file
					else {
						$ctrl.uploadFile(newFile);
					}

					// Update uploader status
					setUploaderStatus();
				},

				onCancelItem: fileItem => {

					// Remove the item
					$ctrl.removeFile(fileItem.fileId);

					// Update uploader status
					setUploaderStatus();
				},

				onErrorItem: fileItem => {

					// Add the file item to the separate list of file items, in case the user decides to retry
					$ctrl.uploaderFileItems.push(fileItem);

					// Set error state on file
					const file = getFile(fileItem.fileId);
					angular.extend(file, {
						allowRetry: true,
						errorMessage: 'Upload error',
						icon: 'icon-warning',
						status: FILE_UPLOAD_STATUSES.error
					});

					// Update uploader status
					setUploaderStatus();
				},

				onSuccessItem: fileItem => {

					// Set success state on item
					const file = getFile(fileItem.fileId);
					const responseJsonArr = JSON.parse(fileItem._xhr.response);

					// If server response is an empty array, presume file has been rejected by server as mime type is not valid
					if (responseJsonArr.length === 0) {
						angular.extend(file, {
							allowRetry: false,
							errorMessage: 'File format not allowed',
							icon: 'icon-warning',
							status: FILE_UPLOAD_STATUSES.error
						});
					}

					// File format is valid
					else {
						angular.extend(file, {
							// Attach document ID to match platform document structure, and to enable deletion in UI
							AgencyDocumentID: responseJsonArr[0],

							// Decorators for UI
							allowRetry: false,
							errorMessage: '',
							icon: 'icon-tick',
							status: FILE_UPLOAD_STATUSES.success
						});

						/* After a short delay, update status to 'complete'. There is a distinction here in the UI,
						   between 'success' and 'complete'. This will merely have the effect of briefly showing a
						   tick before the normal attachment icon ... in case the latter isn't clear enough on its own. */
						$timeout(() => {
							angular.extend(file, {
								icon: importService.getIconForMimeFormat(file.MIMEFormat),
								status: FILE_UPLOAD_STATUSES.complete
							});
						}, 500);
					}

					// Update uploader status
					setUploaderStatus();
				}
			});

			angular.extend($ctrl, {
				uploader,
				uploaderStatus: UPLOADER_STATUSES.complete,
				// Initially valid
				validStatus: UPLOADER_VALID_STATUSES.valid
			});

			// Enable upload
			setUploaderEnabled(true);

			// Init status
			setUploaderStatus();
		};

		function addFileForFileItem (fileItem) {
			// Add a 'platform-friendly' file object for this file item, with the next file Id.
			const file = {
				id: ++$ctrl.fileId,

				// Attributes as understood by the platform
				DocumentName: fileItem.file.name,
				DocumentSize: fileItem.file.size,
				// 'Mime types' defined by platform are all upper case file extensions
				MIMEFormat: utilities.getFileExtension(fileItem.file.name.toUpperCase())
			};
			$ctrl.fuFileList.push(file);

			// Establish relationship between file and file item and add file item to list
			fileItem.fileId = $ctrl.fileId;
			$ctrl.uploaderFileItems.push(fileItem);

			// File list changed - refresh enabled status
			setUploaderEnabled();

			// Notify observer if there is one
			if (angular.isFunction($ctrl.fuOnUpdate)) {
				$ctrl.fuOnUpdate();
			}

			// Return new file
			return file;
		}

		function deleteFile (file) {

			if (file.status === FILE_UPLOAD_STATUSES.error) {
				// This file hasn't been uploaded, so just remove it
				removeFile(file.id);
			}
			else {
				// This file has been uploaded so needs to be properly removed
				messageData.messageDocumentDelete(
					$ctrl.fuAgencyProfileId,
					file.AgencyDocumentID
				)
				.then(() => {
					removeFile(file.id);
				})
				.catch (error => {
					console.error(error);

					// Notify observer if there is one
					if (angular.isFunction($ctrl.fuOnError())) {
						$ctrl.fuOnError(error);
					}
				});
			}
		}

		function getFile (fileId) {

			// Get file corresponding to file ID
			return $ctrl.fuFileList.find(file => file.id === fileId);
		}

		function getFileItem (fileId) {

			// Get file item corresponding to file ID
			return $ctrl.uploaderFileItems.find(fileItem => fileItem.fileId === fileId);
		}

		function getFileUploadTypesDescription (fileUploadTypesStr) {

			let returnStr = '';

			let fileUploadTypesArr = fileUploadTypesStr.split(',');

			const numberOfFileTypes = fileUploadTypesArr.length;

			fileUploadTypesArr.forEach((fileUploadType, index) => {

				// Last
				if (index === (numberOfFileTypes - 1)) {

					returnStr += `and ${fileUploadType}`;
					return;
				}

				// Second from last
				if (index === (numberOfFileTypes - 2)) {

					returnStr += `${fileUploadType} `;
					return;
				}

				// Everything else
				returnStr += `${fileUploadType}, `;
			});

			return returnStr;
		}

		function getUploadedCount (uploaderFileItemsArr) {

			return uploaderFileItemsArr.reduce((uploadedCount, fileItem) => {
				return (fileItem.status === FILE_UPLOAD_STATUSES.complete) ? uploadedCount + 1 : uploadedCount;
			}, 0);
		}

		function onCancelClick () {

			/* Every file being uploaded needs to be cancelled. These will be removed by the onCancel event
			   handler in the uploader. */
			$ctrl.fuFileList.forEach(file => {
				if (file.status === FILE_UPLOAD_STATUSES.uploading) {
					const fileItem = getFileItem(file.id);
					$ctrl.uploader.cancelItem(fileItem);
				}
			});
		}

		function onDeleteClick (file) {

			deleteFile(file);
		}

		function onDropZoneDragLeave () {
			/* Ensure change detection picks this up. The event handler fires outside the context of angularjs,
				so if this isn't done, the change isn't reflected in the view. */
			$scope.$apply(() => {
				$ctrl.showDropzone = false;
			});
		}

		function onRetryClick (file) {

			uploadFile(file);
		}

		function onWindowDragOver () {
			/* Ensure change detection picks this up. The event handler fires outside the context of angularjs,
			   so if this isn't done, the change isn't reflected in the view. */
			$scope.$apply(() => {
				// Show / hide dropzone depending on isEnabled
				$ctrl.showDropzone = $ctrl.isEnabled;
			});
		}

		function removeFile (fileId) {

			// Remove specified file from file list. Ensure this is done in place so the bound array is affected.
			const fileToRemove = $ctrl.fuFileList.find(file => file.id === fileId);
			const fileToRemoveIndex = $ctrl.fuFileList.indexOf(fileToRemove);
			$ctrl.fuFileList.splice(fileToRemoveIndex, 1);

			// Remove from uploader file items. Internal to this component so filter can be used here.
			$ctrl.uploaderFileItems = $ctrl.uploaderFileItems.filter(fileItem => fileItem.fileId !== fileId);

			// File list changed - refresh enabled status
			setUploaderEnabled();
		}

		function setUploaderEnabled (isEnabled) {

			// If not specified, determine whether the uploader should be enabled.
			if (angular.isUndefined(isEnabled)) {
				// Ensure upload isn't possible if allow multiple is false and file list has an entry
				isEnabled = ($ctrl.fuAllowMultiple || (!$ctrl.fuAllowMultiple && $ctrl.fuFileList.length === 0));
			}

			const uploaderDropzoneElement = document.getElementById('file-uploader-dropzone');

			// Do this only if enabled status has changed, or if this is being forced
			if (isEnabled !== $ctrl.isEnabled) {

				$ctrl.isEnabled = isEnabled;

				// Enable / disable drag drop events
				if (isEnabled) {
					// Show dropzone when dragging anywhere onto browser window.
					$window.addEventListener('dragenter', onWindowDragOver);

					// Hide dropzone when dragging outside of it
					uploaderDropzoneElement.addEventListener('dragleave', onDropZoneDragLeave);
				}
				else {
					// Remove event listeners on disable
					$window.removeEventListener('dragenter', onWindowDragOver);
					uploaderDropzoneElement.removeEventListener('dragleave', onDropZoneDragLeave);
				}
			}
		}

		function setUploaderStatus () {

			// Set overall uploader status based on individual file statuses.
			if ($ctrl.fuFileList.some(file => file.status === FILE_UPLOAD_STATUSES.uploading)) {

				// Do nothing if the status isn't going to change.
				if ($ctrl.uploaderStatus !== UPLOADER_STATUSES.uploading) {

					// At least one file is currently uploading
					angular.extend($ctrl, {
						uploaderStatus: UPLOADER_STATUSES.uploading,
						validStatus: UPLOADER_VALID_STATUSES.invalid
					});

					// Notify upload(s) in progress
					if (angular.isFunction($ctrl.fuOnUploadStart())) {
						$ctrl.fuOnUploadStart()();
					}

				}
			}
			else {

				// Do nothing if the status isn't going to change.
				if ($ctrl.uploaderStatus !== UPLOADER_STATUSES.complete) {

					// No files uploading
					angular.extend($ctrl, {
						uploaderStatus: UPLOADER_STATUSES.complete,
						validStatus: UPLOADER_VALID_STATUSES.valid
					});

					// Notify upload(s) complete
					if (angular.isFunction($ctrl.fuOnUploadComplete())) {
						$ctrl.fuOnUploadComplete()();
					}
				}
			}
		}

		function uploadFile (file) {

			// Update status for uploading
			angular.extend(file, {
				status: FILE_UPLOAD_STATUSES.uploading,
				errorMessage: ''
			});

			// Update uploader status
			setUploaderStatus();

			// The file item is used for the upload. Find it, upload it.
			const fileItem = getFileItem(file.id);
			$ctrl.uploader.uploadItem(fileItem);
		}

		angular.extend($ctrl, {

			FILE_UPLOAD_STATUSES,
			UPLOADER_STATUSES,

			getUploadedCount,
			onCancelClick,
			onDeleteClick,
			onRetryClick,

			// Required for uploader above, not template
			addFileForFileItem,
			deleteFile,
			removeFile,
			setUploaderStatus,
			uploadFile
		});
	}
]);
'use strict';

angular.module('paycircleApp')
.component('fileUploaderQueued', {
	bindings: {
		fuAllowedFileTypes: '@?',
		fuAllowedFileTypesKey: '@?',
		fuMaxFileSize: '<',
		fuMessage: '@?',
		fuOnQueueUpdate: '&?',
		fuQueue: '='
	},
	controller: 'fileUploaderQueuedCtrl',
	templateUrl: 'components/file-uploader/file-uploader-queued.component.html'
})
.controller('fileUploaderQueuedCtrl', [
	'$rootScope',
	'$timeout',
	'dataTransfer',
	'fileUploadService',
	'utilities',
	function (
		$rootScope,
		$timeout,
		dataTransfer,
		fileUploadService,
		utilities
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		invalidFileSize: 'invalid-file-size',
		upload: 'upload',
		uploaded: 'uploaded',
		uploadError: 'upload-error',
		uploading: 'uploading'
	};

	function $onInit () {

		angular.extend($ctrl, {
			files: [],
			fuAllowedFileTypes: fileUploadService.getAllowedFileTypesForUpload($ctrl.fuAllowedFileTypes, $ctrl.fuAllowedFileTypesKey),
			fuMaxFileSize: $ctrl.fuMaxFileSize || 750000, // bytes 1000 bytes = 1kB, 1000kB = 1mB
			fuMessage: $ctrl.fuMessage || 'Choose file'
		});

		// If max file size provided, make sure it's a number
		if (isNaN($ctrl.fuMaxFileSize)) {
			$rootScope.paycircleMessage('<file-uploader> maximum file size is not a number', 'warn');
			return;
		}

		const uploader = dataTransfer.getNewFileUploader({

			onAfterAddingFile: fileItem => {

				// Validate file size
				if ($ctrl.fuMaxFileSize && fileItem.file.size > $ctrl.fuMaxFileSize) {
					setComponentState(COMPONENT_STATES.invalidFileSize);
					fileItem.remove();
					$timeout(() => {
						setComponentState(COMPONENT_STATES.upload);
					}, 2000);
					return;
				}

				// Decorate for file-card
				angular.extend(fileItem, {
					DocumentName: fileItem.file.name,
					DocumentSize: fileItem.file.size,
					MIMEFormat: utilities.getMimeFormatFromDocumentName(fileItem.file.name),
				});

				// Call parent decorator
				if (angular.isDefined($ctrl.fuOnQueueUpdate) && angular.isFunction($ctrl.fuOnQueueUpdate)) {
					$ctrl.fuOnQueueUpdate();
				}
			}
		});

		angular.extend($ctrl, {
			fuQueue: uploader.queue,
			uploader: uploader
		});

		setComponentState(COMPONENT_STATES.upload);
	}

	function getComponentClass (componentState) {

		switch (componentState) {
			case COMPONENT_STATES.upload:
				return 'has-background is-primary';

			case COMPONENT_STATES.uploading:
				return '';

			case COMPONENT_STATES.uploaded:
				return 'has-background is-positive';

			case COMPONENT_STATES.invalidFileSize:
			case COMPONENT_STATES.uploadError:
				return 'has-background is-assertive';
		}
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		COMPONENT_STATES,

		getComponentClass,
		setComponentState
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('fullScreenModal', {
	bindings: {
		modalOptions: '=',
	},
	controller: 'fullScreenModalCtrl',
	templateUrl: 'components/full-screen-modal/full-screen-modal.component.html',
})
.controller('fullScreenModalCtrl', [
	'FULL_SCREEN_MODAL_KEYS',
	'FULL_SCREEN_MODAL_OPTIONS',
	function (
		FULL_SCREEN_MODAL_KEYS,
		FULL_SCREEN_MODAL_OPTIONS
	) {

	const $ctrl = this;

	function $onInit  () {

		if ($ctrl.modalOptions.modalKey) {
			$ctrl.modalOptions = angular.extend($ctrl.modalOptions, FULL_SCREEN_MODAL_OPTIONS[$ctrl.modalOptions.modalKey]);
		}

		$ctrl.modalOptions.closeModal = closeModal;
	}

	function closeModal () {

		if (angular.isFunction($ctrl.modalOptions.onClose)) {
			$ctrl.modalOptions.onClose($ctrl.modalOptions.returnObject);
		}

		$ctrl.modalOptions.previewIsOpen = false;
	}

	angular.extend($ctrl, {
		$onInit,

		closeModal,

		FULL_SCREEN_MODAL_KEYS
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payrollAssistantFullScreen', {
	bindings: {
		payrollAssistantOptions: '='
	},
	controller: 'payrollAssistantFullScreenCtrl',
	templateUrl: 'components/payroll-assistant-full-screen/payroll-assistant-full-screen.component.html'
})
.controller('payrollAssistantFullScreenCtrl', [
	'$element',
	'$rootScope',
	'$scope',
	'mfeService',
	'session',
	'utilities',
	function (
		$element,
		$rootScope,
		$scope,
		mfeService,
		session,
		utilities
	) {

	const $ctrl = this;
	const MFE_NAME = 'ppl-agentic-payroll';
	let mfeInstance = null;

	$ctrl.instanceId = utilities.guid();

	function $onInit () {
		$ctrl.isLoading = true;
		$ctrl.hasError = false;
	}

	function $postLink () {
		loadMfe();
	}

	function $onDestroy () {
		removeMfe();
	}

	function loadMfe () {
		$ctrl.isLoading = true;
		$ctrl.hasError = false;

		const containerElement = $element[0].querySelector('.payroll-assistant-full-screen_container');

		if (!containerElement) {
			console.error('Payroll Assistant Full Screen: Container element not found in DOM');
			$ctrl.hasError = true;
			$ctrl.isLoading = false;
			return;
		}

		mfeService.addMfe({
			instanceId: $ctrl.instanceId,
			name: MFE_NAME,
			container: containerElement,
			shell: 'none',
			parameters: {
				authString: utilities.getToken(),
				userId: $rootScope.currentUser.UserResponseUserID,
				sessionId: session.getSessionId()
			},
			onRemove: closeModal
		})
		.then(mfe => {
			mfeInstance = mfe;
			$ctrl.isLoading = false;
			$scope.$applyAsync();
		})
		.catch(error => {
			console.error('Failed to load Payroll Assistant MFE:', error);
			$ctrl.hasError = true;
			$ctrl.isLoading = false;
			$scope.$applyAsync();
		});
	}

	function removeMfe () {
		if (mfeInstance) {
			mfeService.removeMfe($ctrl.instanceId);
			mfeInstance = null;
		}
	}

	function closeModal () {
		removeMfe();
		if ($ctrl.payrollAssistantOptions && $ctrl.payrollAssistantOptions.closeModal) {
			$ctrl.payrollAssistantOptions.closeModal();
		}
	}

	angular.extend($ctrl, {
		$onInit,
		$postLink,
		$onDestroy,
		closeModal
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('furloughPartTimeFormField', {
	bindings: {
		index: '=',
		isPaid: '<?',
		payPeriodDetail: '<'
	},
	controller: 'furloughPartTimeFormFieldCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/furlough-part-time-form-field/furlough-part-time-form-field.component.html'
})

.controller('furloughPartTimeFormFieldCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.isPaid = angular.isDefined($ctrl.isPaid) ? $ctrl.isPaid : false;
	};

}]);
'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportCard', {
	bindings: {
		agencyProfileId: '<',
		index: '<',
		genderPayGapReport: '<',
		onUpdate: '&'
	},
	controller: 'genderPayGapReportCardCtrl',
	templateUrl: 'components/gender-pay-gap-report-card/gender-pay-gap-report-card.component.html'
})
.controller('genderPayGapReportCardCtrl', [
	'$rootScope',
	'reportsService',
	function (
		$rootScope,
		reportsService
	) {

	const $ctrl = this;

	function openDeleteGenderPayGapReportForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'company-settings-gender-pay-gap-delete',
			report: $ctrl.genderPayGapReport
		});
	}

	function openGenderPayGapWizard () {

		reportsService.openGenderPayGapReportCreator(
			{
				agencyProfileId: $ctrl.agencyProfileId,
				callback: $ctrl.onUpdate
			},
			$ctrl.genderPayGapReport
		);
	}

	angular.extend($ctrl, {
		openDeleteGenderPayGapReportForm,
		openGenderPayGapWizard
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportCreator', {
	bindings: {
		reportOptions: '=',
	},
	controller: 'genderPayGapReportCreatorCtrl',
	templateUrl: 'components/gender-pay-gap-report-creator/gender-pay-gap-report-creator.component.html',
})
.controller('genderPayGapReportCreatorCtrl', [
	'$q',
	'$rootScope',
	'bulkService',
	'config',
	'filterService',
	'growl',
	'reportData',
	'searchService',
	'utilities',
	function (
		$q,
		$rootScope,
		bulkService,
		config,
		filterService,
		growl,
		reportData,
		searchService,
		utilities
	) {

	const $ctrl = this;

	const ADD_TEAM_MEMBER_STATES = {
		active: 'active',
		inactive: 'inactive',
		loading: 'loading',
	};

	const COMPONENT_STATES = {
		error: 'error',
		calculating: 'calculating',
		loading: 'loading',
		ready: 'ready'
	};

	const FORM_STATES = {
		saving: 'saving',
		active: null
	};

	const WIZARD_STEPS = {
		combineReports: 'combine-reports',
		excludeTeamMembers: 'exclude-team-members',
		noPayElements: 'no-pay-elements',
		noTeamMembers: 'no-team-members',
		payAndHours: 'pay-and-hours',
		payElements: 'pay-elements',
		settings: 'settings',
		viewReport: 'view-report'
	};

	function $onInit () {

		angular.extend($ctrl, {
			isBulkReport: !$rootScope.currentCompany.isPayrollCompany,
			isNewReport: !$ctrl.reportOptions.report
		});

		// If we are editing an existing report
		if (!$ctrl.isNewReport) {
			setupExistingReportWizard();
		}
		else {
			setupNewReportWizard();
		}
	}

	function getDecoratedTeam (teamMembersArr) {

		for (let teamMemberObj of teamMembersArr) {

			const nameSplitArr = teamMemberObj.Name.split(' ');

			teamMemberObj.forenameSearch = nameSplitArr.shift();
			teamMemberObj.surnameSearch = nameSplitArr.join(' ');
		}

		return teamMembersArr;
	}

	function getDecoratedReports (reportsArr) {

		for (let reportObj of reportsArr) {
			reportObj.isIncluded = ($ctrl.report.GenderPayGapReportIDs || []).includes(reportObj.GenderPayGapReportID);
		}

		return reportsArr;
	}

	function getGPGPayElementSettings () {
		return $q((resolve, reject) => {

			// Return saved data if it exists
			if ($ctrl.payElements) {
				resolve($ctrl.payElements);
				return;
			}

			// Show loading state if report is complete
			if ($ctrl.report.GenderPayGapReportCreationComplete) {
				setComponentState(COMPONENT_STATES.loading);
			}

			reportData.getGenderPayGapPayElementSettings($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID)
				.then(payElementsArr => {

					$ctrl.payElements = payElementsArr;

					resolve($ctrl.payElements);
				})
				.catch(reject);
		});
	}

	function getGPGReports () {

		return $q((resolve, reject) => {

			// Return saved data if it exists
			if ($ctrl.genderPayGapReports) {
				resolve();
				return;
			}

			// Show loading state if report is complete
			if ($ctrl.report.GenderPayGapReportCreationComplete) {
				setComponentState(COMPONENT_STATES.loading);
			}

			// We need to update the report object with the latest values
			reportData.getGenderPayGapReport($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID)
				.then(reportData => {

					// Set report data
					$ctrl.report = reportData;

				})
				.catch(onError);

			reportData.getGenderPayGapReportsForAgencyParent($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportSnapshotDateISO)
				.then(reportsArr => {

					$ctrl.genderPayGapReports = bulkService.getBulkItemsObj(getDecoratedReports(reportsArr));

					setComponentState(COMPONENT_STATES.ready);

					resolve();
				})
				.catch(reject);
		});
	}

	function getGPGUsers () {

		return $q((resolve, reject) => {

			// Return saved data if it exists
			if ($ctrl.team) {
				resolve($ctrl.team);
				return;
			}

			// Show loading state if report is complete
			if ($ctrl.report.GenderPayGapReportCreationComplete) {
				setComponentState(COMPONENT_STATES.loading);
			}

			reportData.getGenderPayGapUsers($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID)
				.then(teamMembersArr => {

					$ctrl.team = getDecoratedTeam(teamMembersArr);

					resolve(teamMembersArr);
				})
				.catch(reject);
		});
	}

	function getIncludedGenderPayGapReportIDs () {

		if ($ctrl.genderPayGapReports && $ctrl.genderPayGapReports.all)
		{
			return $ctrl.genderPayGapReports.all.filter(reportObj => reportObj.isIncluded).map(reportObj => reportObj.GenderPayGapReportID);
		}

		return [];
	}

	function getIsSaveActionsDisabled () {

		// Disabled when excluding a team member
		if ($ctrl.addTeamMemberState === ADD_TEAM_MEMBER_STATES.active) {
			return true;
		}

		// Disabled when a team member is being edited
		if ($ctrl.team && $ctrl.team.some(teamMemberObj => teamMemberObj.isEditing)) {
			return true;
		}

		const hasNoIncludedReports = $ctrl.genderPayGapReports && $ctrl.genderPayGapReports.all && $ctrl.genderPayGapReports.all.every(reportObj => !reportObj.isIncluded);

		// Disabled when no reports are selected for combination but only when we're on the combineReports step
		if ($ctrl.wizardStep === $ctrl.WIZARD_STEPS.combineReports && hasNoIncludedReports) {
			return true;
		}

		// Disabled when form is missing information
		return [
			$ctrl.WIZARD_STEPS.noTeamMembers,
			$ctrl.WIZARD_STEPS.noPayElements
		].includes($ctrl.wizardStep);
	}

	function getUpdatedItemsFromList (itemsArr) {
		return itemsArr.filter(itemObj => itemObj.hasUpdated);
	}

	function initStepCombineReports () {

		setFormState(FORM_STATES.saving);

		getGPGReports()
			.then(() => {

				setWizardStep(WIZARD_STEPS.combineReports);

				setFormState(FORM_STATES.active);
			})
			.catch(onError);
	}

	function initStepExcludeTeamMembers () {

		setFormState(FORM_STATES.saving);
		setComponentState(COMPONENT_STATES.calculating);

		getGPGUsers()
			.then(teamMembersArr => {

				if (teamMembersArr.length === 0) {
					setWizardStep(WIZARD_STEPS.noTeamMembers);
					setComponentState(COMPONENT_STATES.ready);
					return;
				}

				setAddTeamMemberState(ADD_TEAM_MEMBER_STATES.inactive);

				setWizardStep(WIZARD_STEPS.excludeTeamMembers);

				setComponentState(COMPONENT_STATES.ready);
				setFormState(FORM_STATES.active);
			})
			.catch(onError);
	}

	function initStepPayElements () {

		setFormState(FORM_STATES.saving);
		setComponentState(COMPONENT_STATES.loading);

		getGPGPayElementSettings()
			.then(payElementsArr => {

				if (payElementsArr.length === 0) {
					setWizardStep(WIZARD_STEPS.noPayElements);
					setComponentState(COMPONENT_STATES.ready);
					return;
				}

				setWizardStep(WIZARD_STEPS.payElements);

				setComponentState(COMPONENT_STATES.ready);
				setFormState(FORM_STATES.active);
			})
			.catch(onError);
	}

	function initStepPayAndHours () {

		setFormState(FORM_STATES.saving);
		setComponentState(COMPONENT_STATES.loading);

		getGPGUsers()
			.then(() => {

				setWizardStep(WIZARD_STEPS.payAndHours);

				setComponentState(COMPONENT_STATES.ready);
				setFormState(FORM_STATES.active);
			})
			.catch(onError);
	}

	function initStepSettings () {

		function openPage () {

			setWizardStep(WIZARD_STEPS.settings);

			setComponentState(COMPONENT_STATES.ready);
		}

		setComponentState(COMPONENT_STATES.loading);

		// Reteieve whole report object if editing a newly created report
		if ($ctrl.isNewReport && $ctrl.report.GenderPayGapReportID) {
			reportData.getGenderPayGapReport($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID)
				.then(reportData => {

					// Set report data
					$ctrl.report = reportData;

					// Set to existing report
					$ctrl.isNewReport = false;

					openPage();
				})
				.catch(onError);
			return;
		}

		openPage();
	}

	function initStepViewReport () {

		setComponentState(COMPONENT_STATES.calculating);

		const getGenderPayGapAnalytics = $ctrl.isBulkReport ? reportData.getGenderPayGapAnalyticsForReportParent : reportData.getGenderPayGapAnalytics;

		getGenderPayGapAnalytics($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID)
			.then(reportData => {

				// Decorate team members
				reportData.Users = getDecoratedTeam(reportData.Users);

				// Set report data
				angular.extend($ctrl.report, reportData);

				setWizardStep(WIZARD_STEPS.viewReport);

				setComponentState(COMPONENT_STATES.ready);
			})
			.catch(onError);
	}

	function onStepSubmitCombineReports () {

		setFormState(FORM_STATES.saving);

		// We need to update GenderPayGapReportIDs with the selected reports
		angular.extend($ctrl.report, {
			GenderPayGapReportCreationComplete: true,
			GenderPayGapReportIDs: getIncludedGenderPayGapReportIDs()
		});

		reportData.updateGenderPayGapReport($ctrl.reportOptions.agencyProfileId, $ctrl.report)
			.then(() => {

				// Go to next step
				initStepViewReport();
			})
			.catch(onError);
	}

	function onStepSubmitExcludeTeamMembers () {

		function onSubmit () {

			// Go to next step
			initStepPayAndHours();
		}

		setFormState(FORM_STATES.saving);

		const updatedTeamMembersArr = getUpdatedItemsFromList($ctrl.team);

		if (updatedTeamMembersArr.length === 0) {
			onSubmit();
			return;
		}

		reportData.updateGenderPayGapUsers($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID, updatedTeamMembersArr)
			.then(() => {

				resetUpdatedItems(updatedTeamMembersArr);

				onSubmit();
			})
			.catch(onError);
	}

	function onStepSubmitPayAndHours () {

		function onSubmit () {

			// Set report as complete
			$ctrl.report.GenderPayGapReportCreationComplete = true;

			// Go to next step
			initStepViewReport();
		}

		setFormState(FORM_STATES.saving);

		const updatedTeamMembersArr = getUpdatedItemsFromList($ctrl.team);

		reportData.updateGenderPayGapReportCreationComplete($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID, true)
			.then($ctrl.reportOptions.callback)
			.catch(onError);

		if (updatedTeamMembersArr.length > 0) {

			reportData.updateGenderPayGapUsers($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID, updatedTeamMembersArr)
				.then(onSubmit)
				.catch(onError);
			return;
		}

		onSubmit();
	}

	function onStepSubmitPayElements () {

		function onSubmit () {

			// Go to next step
			initStepExcludeTeamMembers();
		}

		setFormState(FORM_STATES.saving);

		const updatedPayElementsArr = getUpdatedItemsFromList($ctrl.payElements);

		if (updatedPayElementsArr.length === 0) {
			onSubmit();
			return;
		}

		setComponentState(COMPONENT_STATES.calculating);

		reportData.updateGenderPayGapPayElementSettings($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportID, updatedPayElementsArr)
			.then(() => {

				resetUpdatedItems(updatedPayElementsArr);
				setComponentState(COMPONENT_STATES.ready);
				onSubmit();
			})
			.catch(onError);
	}

	function onStepSubmitSettings () {

		function onSubmit () {

			// Go to next step
			if ($ctrl.isBulkReport) {
				initStepCombineReports();
			}
			else {
				initStepPayElements();
			}
		}

		setFormState(FORM_STATES.saving);

		if ($ctrl.report.GenderPayGapReportID) {

			// If no changes, go to next step
			if ($ctrl.genderPayGapReportForm.settingsReportName.$pristine && $ctrl.genderPayGapReportForm.settingsSnapshotDate.$pristine) {
				onSubmit();
				return;
			}

			// If the snapshot date has changed, reset the reports as we want to fetch new ones using the new snapshot date
			if ($ctrl.genderPayGapReportForm.settingsSnapshotDate.$dirty) {
				$ctrl.genderPayGapReports = null;
			}

			reportData.updateGenderPayGapReport($ctrl.reportOptions.agencyProfileId, $ctrl.report)
				.then(() => {

					// Reset saved pay elements
					$ctrl.payElements = null;

					onSubmit();
				})
				.then($ctrl.reportOptions.callback)
				.catch(onError);
		}
		else {
			reportData.createGenderPayGapReport($ctrl.reportOptions.agencyProfileId, $ctrl.report.GenderPayGapReportName, $ctrl.report.GenderPayGapReportSnapshotDateISO)
				.then(reportId => {

					// Service might change in the future to return an object, this is to handle both cases
					if (angular.isObject(reportId)) {
						$ctrl.report = reportId;
					}
					else {

						// Set report ID
						$ctrl.report.GenderPayGapReportID = reportId;
					}

					onSubmit();
				})
				.then($ctrl.reportOptions.callback)
				.catch(onError);
		}
	}

	function onAddTeamMemberClick () {
		setAddTeamMemberState(ADD_TEAM_MEMBER_STATES.active);
	}

	function onBackClick () {

		const stepInitFunctions = {
			[WIZARD_STEPS.payElements]: initStepSettings,
			[WIZARD_STEPS.combineReports]: initStepSettings,
			[WIZARD_STEPS.noPayElements]: initStepSettings,
			[WIZARD_STEPS.excludeTeamMembers]: initStepPayElements,
			[WIZARD_STEPS.payAndHours]: initStepExcludeTeamMembers,
			[WIZARD_STEPS.viewReport]: $ctrl.isBulkReport ? initStepCombineReports : initStepPayAndHours
		};

		const stepInitFunction = stepInitFunctions[$ctrl.wizardStep];

		resetShowMore();

		if (stepInitFunction) {
			stepInitFunction();
		}
	}

	function onClose () {

		$ctrl.reportOptions.closeModal();
		$ctrl.reportOptions.callback();
	}

	function onError (error) {
		setComponentState(COMPONENT_STATES.error);
		$ctrl.reportOptions.showClose = true;
		throw new Error(error);
	}

	function onFormSubmit () {

		setFormState(FORM_STATES.saving);

		const stepSubmitFunctions = {
			[WIZARD_STEPS.settings]: onStepSubmitSettings,
			[WIZARD_STEPS.payElements]: onStepSubmitPayElements,
			[WIZARD_STEPS.combineReports]: onStepSubmitCombineReports,
			[WIZARD_STEPS.excludeTeamMembers]: onStepSubmitExcludeTeamMembers,
			[WIZARD_STEPS.payAndHours]: onStepSubmitPayAndHours
		};

		resetShowMore();

		stepSubmitFunctions[$ctrl.wizardStep]();
	}

	function onNewTeamMemberSave () {

		setAddTeamMemberState(ADD_TEAM_MEMBER_STATES.inactive);

		growl.success('Excluded team member added');
	}

	function resetUpdatedItems (itemsArr) {
		itemsArr.forEach(itemObj => {
			itemObj.hasUpdated = false;
		});
	}

	function setAddTeamMemberState (newState) {
		$ctrl.addTeamMemberState = newState;
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function setFormState (newState) {

		if ($ctrl.genderPayGapReportForm) {
			$ctrl.genderPayGapReportForm.state = newState;
		}
	}

	function setupExistingReportWizard () {

		$ctrl.report = angular.copy($ctrl.reportOptions.report);

		if ($ctrl.report.GenderPayGapReportCreationComplete) {
			initStepViewReport();
			return;
		}

		// Load first step
		initStepSettings();
	}

	function setupNewReportWizard () {

		$ctrl.report = {
			GenderPayGapReportName: '',
			GenderPayGapReportSnapshotDateISO: '',
			AgencyProfileID: $ctrl.reportOptions.agencyProfileId
		};

		// Will be removed in future story
		if (utilities.isEnvironmentLocalhost) {
			$ctrl.report.GenderPayGapReportName = 'Test report name';
			$ctrl.report.GenderPayGapReportSnapshotDateISO = moment().format(config.dateFormatISO);
		}

		initStepSettings();
	}

	function setWizardStep (newStep) {

		function getActiveStepNumberFromWizardStep (newStep) {

			switch (newStep) {
				case WIZARD_STEPS.settings:
					return 1;

				case WIZARD_STEPS.payElements:
				case WIZARD_STEPS.noPayElements:
				case WIZARD_STEPS.combineReports:
					return 2;

				case WIZARD_STEPS.excludeTeamMembers:
				case WIZARD_STEPS.noTeamMembers:
					return 3;

				case WIZARD_STEPS.payAndHours:
					return 4;

				case WIZARD_STEPS.viewReport:

					if ($ctrl.isBulkReport) {
						return 3;
					}

					return 5;
			}
		}

		$ctrl.wizardStep = newStep;

		// For modal progress bar
		$ctrl.reportOptions.steps.activeStep = getActiveStepNumberFromWizardStep(newStep);
	}

	function toggleShowMore () {
		$ctrl.showMore = !$ctrl.showMore;
	}

	function resetShowMore () {

		if ($ctrl.showMore) {
			$ctrl.showMore = false;
		}

	}

	angular.extend($ctrl, {
		$onInit,

		ADD_TEAM_MEMBER_STATES,
		COMPONENT_STATES,
		WIZARD_STEPS,

		onAddTeamMemberClick,
		onBackClick,
		onClose,
		onFormSubmit,
		onNewTeamMemberSave,
		setAddTeamMemberState,
		toggleShowMore,

		excludedTeamMembers: [],
		isSaveActionsDisabled: getIsSaveActionsDisabled,
		filterBarOptions: {
			teamOverrides: filterService.genderPayGapOverrides
		},
		searchBarOptions: {
			payElements: searchService.payElementsBIK,
			teamPayAndHours: searchService.teamReport,
			teamExcludedTeamMembers: searchService.teamReport,
			companies: searchService.companiesReport
		},
		showMore: false,
	});
}])
.filter('genderPayGapIncludedUsersOnly', [
	'GENDER_PAY_GAP_EXCLUSION_REASONS',
	function (
		GENDER_PAY_GAP_EXCLUSION_REASONS
	) {

	return function (teamMembersArr) {
		return teamMembersArr.filter(teamMemberObj => teamMemberObj.ExclusionType === GENDER_PAY_GAP_EXCLUSION_REASONS.none);
	};

}])
.filter('genderPayGapExcludedUsersForStep3', [
	'GENDER_PAY_GAP_EXCLUSION_REASONS',
	function (
		GENDER_PAY_GAP_EXCLUSION_REASONS
	) {

	return function (teamMembersArr) {

		function showExcluded (teamMemberObj) {

			return teamMemberObj.ExclusionType !== GENDER_PAY_GAP_EXCLUSION_REASONS.none;
		}

		if (!teamMembersArr) {
			return [];
		}

		// Only show users that have been excluded
		return teamMembersArr.filter(showExcluded);
	};

}]);

'use strict';

angular.module('paycircleApp')
	.component('genderPayGapReportCombineReports', {
		bindings: {
			index: '<',
			report: '<',
		},
		controller: 'genderPayGapReportCombineReportsCtrl',
		templateUrl: 'components/gender-pay-gap-report-combine-reports/gender-pay-gap-report-combine-reports.component.html'
	})
	.controller('genderPayGapReportCombineReportsCtrl', [
		function() {

			const $ctrl = this;

			function $onInit () {

			}

			function onSubmit () {

			}

			angular.extend($ctrl, {
				$onInit,
				onSubmit,
			});
		}]);


'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportPayElement', {
	bindings: {
		index: '<',
		payElement: '<'
	},
	controller: 'genderPayGapReportPayElementCtrl',
	templateUrl: 'components/gender-pay-gap-report-pay-element/gender-pay-gap-report-pay-element.component.html',
})
.controller('genderPayGapReportPayElementCtrl', function () {

	const $ctrl = this;

	function onToggleChange () {
		$ctrl.payElement.hasUpdated = true;
	}

	angular.extend($ctrl, {
		onToggleChange
	});
});

'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportTeamMemberOverride', {
	bindings: {
		canUpdate: '<?',
		index: '<',
		teamMember: '<',
	},
	controller: 'genderPayGapReportTeamMemberOverrideCtrl',
	templateUrl: 'components/gender-pay-gap-report-team-member-override/gender-pay-gap-report-team-member-override.component.html',
})
.controller('genderPayGapReportTeamMemberOverrideCtrl', [
	'GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS',
	function(
		GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS
	) {

	const $ctrl = this;

	function $onInit () {

		setIsEditing(false);

		angular.extend($ctrl, {
			canUpdate: angular.isDefined($ctrl.canUpdate) ? $ctrl.canUpdate : true,
		});
	}

	function onCancelClick () {

		// Reset values
		if ($ctrl.editBackup) {
			angular.extend($ctrl.teamMember, {
				Category: $ctrl.editBackup.Category,
				OrdinaryPaySnapshot: $ctrl.editBackup.OrdinaryPaySnapshot,
				BonusPaySnapshot: $ctrl.editBackup.BonusPaySnapshot,
				BonusPayAnnual: $ctrl.editBackup.BonusPayAnnual,
				WeeklyWorkingHours: $ctrl.editBackup.WeeklyWorkingHours
			});
		}

		$ctrl.editBackup = null;

		setIsEditing(false);
	}

	function onEditClick () {

		$ctrl.editBackup = angular.copy($ctrl.teamMember);

		setIsEditing(true);
	}

	function onSubmit () {

		// Mark team member as updated
		$ctrl.teamMember.hasUpdated = true;

		setIsEditing(false);
	}

	function setIsEditing (state) {
		$ctrl.teamMember.isEditing = state;
	}

	angular.extend($ctrl, {
		$onInit,
		onCancelClick,
		onEditClick,
		onSubmit,

		GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS
	});
}])
.filter('genderPayGapEmployeeTypeLabel', [
	'GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS',
	function (
		GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS
	) {
		return function (value) {

			const reasonObj = GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS.find(reasonObj => reasonObj.value === value);

			if (reasonObj) {
				return reasonObj.label;
			}

			return null;
		};
	}
]);


'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportTeamMember', {
	bindings: {
		index: '<',
		onDelete: '&',
		onSave: '&',
		teamMember: '=?',
		teamMembers: '<?'
	},
	controller: 'genderPayGapReportTeamMemberCtrl',
	templateUrl: 'components/gender-pay-gap-report-team-member/gender-pay-gap-report-team-member.component.html',
})
.controller('genderPayGapReportTeamMemberCtrl', [
	'utilities',
	'GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS',
	'GENDER_PAY_GAP_EXCLUSION_REASONS',
	function(
		utilities,
		GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS,
		GENDER_PAY_GAP_EXCLUSION_REASONS
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		active: 'active',
		editing: 'editing'
	};

	function $onInit () {

		if (angular.isUndefined($ctrl.teamMember)) {
			setComponentState(COMPONENT_STATES.editing);
			$ctrl.exclusionType = null;
			return;
		}

		$ctrl.includeInReport = $ctrl.teamMember.ExclusionType === GENDER_PAY_GAP_EXCLUSION_REASONS.none;

		setComponentState(COMPONENT_STATES.active);
	}

	function onAddTeamMemberSubmit () {

		$ctrl.teamMember.ExclusionType = $ctrl.exclusionType;

		setTeamMemberHasUpdated();

		$ctrl.onSave();
	}

	function onCancelClick () {
		$ctrl.onDelete();
	}

	function onDeleteTeamMemberClick () {

		$ctrl.teamMember.ExclusionType = GENDER_PAY_GAP_EXCLUSION_REASONS.none;

		setTeamMemberHasUpdated();
	}

	function onIncludeInReportChange () {

		if ($ctrl.includeInReport) {

			// Save the original exclusion type
			$ctrl.teamMember.originalExclusionType = $ctrl.teamMember.ExclusionType;

			$ctrl.teamMember.ExclusionType = GENDER_PAY_GAP_EXCLUSION_REASONS.none;
		}
		else {
			$ctrl.teamMember.ExclusionType = $ctrl.teamMember.originalExclusionType;
		}

		setTeamMemberHasUpdated();
	}


	function onTeamMemberDeselectClick () {

		$ctrl.teamMember = null;

		utilities.focusOn('searchTermTeamMembers-'+ $ctrl.index);
	}

	function onTeamMemberClick (teamMemberObj) {

		$ctrl.teamMember = teamMemberObj;

		resetTeamMemberSearchTerm();
	}

	function resetTeamMemberSearchTerm () {
		$ctrl.searchValue = '';
	}

	function setComponentState (state) {
		$ctrl.componentState = state;
	}

	function setTeamMemberHasUpdated () {
		$ctrl.teamMember.hasUpdated = true;
	}

	angular.extend($ctrl, {
		$onInit,

		onAddTeamMemberSubmit,
		onCancelClick,
		onIncludeInReportChange,
		onDeleteTeamMemberClick,
		onTeamMemberClick,
		onTeamMemberDeselectClick,
		resetTeamMemberSearchTerm,

		COMPONENT_STATES,
		GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS,
		GENDER_PAY_GAP_EXCLUSION_REASONS,
		SEARCH_TERM_MIN_COUNT: 3,
		SEARCH_RESULTS_LIMIT: 20,

		searchValue: null
	});
}])
.filter('genderPayGapExclusionReasonLabel', [
	'GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS',
	function (
		GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS
	) {
		return function (value) {

			const reasonObj = GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS.find(reasonObj => reasonObj.value === value);

			if (reasonObj) {
				return reasonObj.label;
			}

			return null;
		};
	}
])
.filter('genderPayGapExclusionIncludedUsersForSearch', [
	'GENDER_PAY_GAP_EXCLUSION_REASONS',
	function (
		GENDER_PAY_GAP_EXCLUSION_REASONS
	) {

	return function (teamMembersArr) {

		function showIncluded (teamMember) {

			return teamMember.ExclusionType === GENDER_PAY_GAP_EXCLUSION_REASONS.none;
		}

		// Only show users that have been included
		return teamMembersArr.filter(showIncluded);
	};

}]);


'use strict';

angular.module('paycircleApp')
.component('genderPayGapReportViewer', {
	bindings: {
		report: '<'
	},
	controller: 'genderPayGapReportViewerCtrl',
	templateUrl: 'components/gender-pay-gap-report-viewer/gender-pay-gap-report-viewer.component.html',
})
.controller('genderPayGapReportViewerCtrl', [
	'config',
	'searchService',
	'tabService',
	'TAB_KEYS',
	function (
		config,
		searchService,
		tabService,
		TAB_KEYS
	) {

	const $ctrl = this;

	const CHART_THEME = {
		green: [
			'#009f78', // GREEN-300
			'#c2ecdb' // GREEN-200
		],
		blue: [
			'#00819d', // BLUE-300
			'#bde6f0' // BLUE-200
		]
	};

	const TOOLTIP_COMMS_TYPE = {
		hourly: 'hourly',
		bonus: 'bonus'
	};

	const DEFAULT_CHART = {
		type: 'doughnut',
		data: {
			labels: [
				'Female',
				'Male'
			],
			datasets: [
				{
					borderAlign: 'inner',
					borderJoinStyle: 'miter',
					hoverBorderJoinStyle: 'miter',
					hoverOffset: 5,
					offset: 0,
					borderWidth: 0,
					spacing: 0
				}
			]
		},
		options: {
			animation: {
				delay: 500 // Delay chart load to show animation properly
			},
			cutout: '68%',
			layout: {
				padding: 5
			},
			plugins: {
				legend: {
					display: false
				},
				tooltip: {
					bodyFont: {
						family: config.fontFamilyAlpha
					},
					displayColors: false
				}
			}
		}
	};

	function $onInit () {

		$ctrl.charts = [
			{
				id: 'gpg-upper-quarter',
				data: getNewChartData($ctrl.report.UpperQuartilePercentageFemale, $ctrl.report.UpperQuartilePercentageMale, CHART_THEME.green)
			},
			{
				id: 'gpg-upper-middle-quarter',
				data: getNewChartData($ctrl.report.UpperMiddleQuartilePercentageFemale, $ctrl.report.UpperMiddleQuartilePercentageMale, CHART_THEME.green)
			},
			{
				id: 'gpg-lower-middle-quarter',
				data: getNewChartData($ctrl.report.LowerMiddleQuartilePercentageFemale, $ctrl.report.LowerMiddleQuartilePercentageMale, CHART_THEME.green)
			},
			{
				id: 'gpg-lower-quarter',
				data: getNewChartData($ctrl.report.LowerQuartilePercentageFemale, $ctrl.report.LowerQuartilePercentageMale, CHART_THEME.green)
			},
			{
				id: 'gpg-number-receiving-bonus-pay',
				data: getNewChartData($ctrl.report.BonusPayRecipientsFemaleCount, $ctrl.report.BonusPayRecipientsMaleCount, CHART_THEME.blue)
			},
			{
				id: 'gpg-percentage-receiving-bonus-pay',
				data: getNewChartData($ctrl.report.BonusPayRecipientsFemalePercentage, $ctrl.report.BonusPayRecipientsMalePercentage, CHART_THEME.blue)
			}
		];
	}

	function getNewChartData (femaleCount, maleCount, theme) {

		const newChart = angular.copy(DEFAULT_CHART);

		angular.extend(newChart.data.datasets[0], {
			backgroundColor: theme,
			borderColor: theme,
			data: [femaleCount, maleCount]
		});

		return newChart;
	}

	function getTooltopText (value, commsType) {

		switch (commsType) {
			case TOOLTIP_COMMS_TYPE.hourly:
				if (value > 0) {
					return 'A positive percentage shows that women have lower pay than men in your company';
				}
				else if (value < 0) {
					return 'A negative percentage shows that women have higher pay than men in your company';
				}

				return 'A zero percentage shows that there is equal pay between men and women in your company';

			case TOOLTIP_COMMS_TYPE.bonus:
				if (value > 0) {
					return 'A positive percentage shows that women have lower bonuses than men in your company';
				}
				else if (value < 0) {
					return 'A negative percentage shows that women have higher bonuses than men in your company';
				}

				return 'A zero percentage shows that there are equal bonuses between men and women in your company';
		}
	}

	function setActiveTab (tab) {
		$ctrl.activeTab = tab;

		if (tab === $ctrl.TABS.hourlyBonusPay) {
			setupCharts();
		}
	}

	function setupCharts () {

		for (let chartObj of $ctrl.charts) {

			// Wait for element to render before loading chart
			angular.element(() => {

				const chartElement = document.getElementById(chartObj.id);

				if (angular.isElement(chartElement)) {

					chartObj.chart = new Chart(
						chartElement,
						chartObj.data
					);
				}

			});
		}
	}

	angular.extend($ctrl, {
		$onInit,
		$postLink: setupCharts,

		getTooltopText,
		setActiveTab,

		TABS: TAB_KEYS.settings.genderPayGap.tabs,
		TOOLTIP_COMMS_TYPE,

		activeTab: TAB_KEYS.settings.genderPayGap.tabs.hourlyBonusPay,
		searchBarOptions: searchService.teamReport,
		tabBarDef: tabService.getTabsForKey(TAB_KEYS.settings.genderPayGap.id)
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('gradientBar', [function () {
	return {
		restrict: 'E',
		templateUrl: 'components/gradient-bar/gradientBarComponent.html',
		replace: true,
		scope: {
			colour1: '=',
			colour2: '=',
			height: '@',
			template: '@'
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('graphicCard', {
	bindings: {
		graphicKey: '@',
		layout: '@?',
		theme: '@?'
	},
	controller: 'graphicCardCtrl',
	templateUrl: 'components/graphic-card/graphic-card.component.html',
	transclude: {
		'copy': '?copy'
	},
})
.controller('graphicCardCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			layout: angular.isDefined($ctrl.layout) ? $ctrl.layout : 'is-inline',
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary'
		});
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')

.constant('HELP_AND_SUPPORT_DISPLAY_OPTIONS', {
	inlineLeft: 'is-inline-left',
	inlineRight: 'is-inline-right',
	fullPage: 'is-full-page'
})

/* These are used to indicate that a category tag requires some 'special' treatment. In the case of 'latest', for example,
   it doesn't exist in WordPress as a category but rather as a separate true / false ACF, and also has its own special
   view, different from other categories. While 'latest' might be the only special view, ever, this at least provides a
   mechanism to add others in the future. */
.constant('HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS', {
	// Distinguish these from WordPress IDs by using negative values. Any negative value will do, as long as none are repeated of course.
	latest: -1
})

.component('helpAndSupportPanel', {

	bindings: {
		helpAndSupportOptions: '=',
		displayMode: '=?' 		// HELP_AND_SUPPORT_DISPLAY_OPTIONS
	},
	controller: 'helpAndSupportPanelCtrl',
	templateUrl: 'components/help-and-support-panel/help-and-support-panel.component.html'
})

.controller('helpAndSupportPanelCtrl', [
	'$location',
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'accessButtonService',
	'supportData',
	'utilities',
	'HELP_AND_SUPPORT_DISPLAY_OPTIONS',
	'HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS',
	'SUPPORT_ARTICLE_CARD_VIEW_MODES',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	function (
		$location,
		$q,
		$rootScope,
		$scope,
		$timeout,
		accessButtonService,
		supportData,
		utilities,
		HELP_AND_SUPPORT_DISPLAY_OPTIONS,
		HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS,
		SUPPORT_ARTICLE_CARD_VIEW_MODES,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready',
		secondaryContentLoading: 'secondaryContentLoading'
	};

	const HELP_AND_SUPPORT_VIEWS = {
		article: 'article',		// Single article display
		browse: 'browse',		// Browse. Article categories (full screen help and support only) and 'Latest articles' (full screen and inline)
		latest: 'latest',		// Latest articles
		search: 'search',		// Search results display
		tags: 'tags'			// Articles and guides identified by tag(s)
	};

	// Support categories (all and public only), latest and popular articles. Retrieved once-only.
	let supportCategories;
	let latestSupportArticlesGrouped;
	let popularSupportArticles;

	$ctrl.$onInit = function () {

		setComponentState(COMPONENT_STATES.loading);

		// Panel is inline-left by default
		$ctrl.displayMode = angular.isDefined($ctrl.displayMode) ? $ctrl.displayMode : HELP_AND_SUPPORT_DISPLAY_OPTIONS.inlineLeft;
		// Inline flag for convenience
		$ctrl.isInline = $ctrl.displayMode !== HELP_AND_SUPPORT_DISPLAY_OPTIONS.fullPage;

		// Get all of the 'meta' information upfront - support categories, latest and popular articles
		const getSupportCategories = supportData.getAllCategories();
		const getLatestSupportArticlesGrouped = supportData.getLatestSupportArticlesGrouped();
		const getPopularSupportArticles = supportData.getPopularSupportArticles();

		$q.all([
			getSupportCategories,
			getLatestSupportArticlesGrouped,
			getPopularSupportArticles
		])
		.then(([
			supportCategoriesArr,
			latestSupportArticlesGroupedObj,
			popularSupportArticlesArr
		]) => {

			/* Hold onto those for use elsewhere. Copy support categories since they're going to be augmented with special categories,
			   and the service itself caches them, so we'd be updating its version of reality here too unless we use a copy. */
			supportCategories = angular.copy(supportCategoriesArr);
			latestSupportArticlesGrouped = latestSupportArticlesGroupedObj;
			popularSupportArticles = popularSupportArticlesArr;

			/* Add any 'special' headline categories. These have negative IDs so they don't conflict with WordPress IDs.
			   These are also retrieved differently; not based on category, but some other property */
			/* Latest articles is a super special headline category. Unshift into categories array so it appears
			   before any other, not-so-special headline categories that have been defined in WordPress */
			supportCategories.unshift({
				articleCount: latestSupportArticlesGrouped.articleCount,
				description: 'What’s new in Paycircle? Guides on how to use our latest features and product enhancements.',
				icon: 'icon-help',
				id: HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS.latest,
				isHeadline: true,
				headlineImageName: 'latest-articles',
				headlineItemSingular: 'article',
				headlineItemPlural: 'articles',
				parentId: 0,
				name: 'Latest features and updates'
			});

			// Keep an eye on the refresh option, in order to update while the form is still open.
			$scope.$watch('$ctrl.helpAndSupportOptions.refresh', (refresh) => {
				if (refresh) {
					showHelpAndSupport($ctrl);
				}
			});

			// Finally, show help and support
			showHelpAndSupport($ctrl);

			accessButtonService.sendTelemetry(TELEMETRY_TRACKED_FEATURES.helpAndSupport, TELEMETRY_PROJECT_INFO.projectReportingCode);
		});
	};

	function changeCategory (ctrlObj, categoryId) {
		// If changing to top level category, go home. That'll clear the search, and set focus to the search box for free
		if (categoryId === 0) {
			goHome(ctrlObj);
		}
		else {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.browse, {categoryId});
		}
	}

	function closePanel (ctrlObj) {

		// This will slide the panel into oblivion.
		ctrlObj.isClosed = true;
		// Signal to app that it's closed
		$rootScope.$broadcast('close-help-and-support-panel');
		// Signal removal from DOM after a short delay to ensure close animation runs.
		$timeout(() => {
			ctrlObj.helpAndSupportOptions.isOpen = false;
		}, 500);
	}

	function returnToSearchResults (ctrlObj) {
		/* Return to the last stored search results if there are any. It shouldn't be possible to get here
		   if there aren't any */
		if (angular.isDefined(ctrlObj.lastSearchStateData)) {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.search, ctrlObj.lastSearchStateData);
		}
	}

	function goHome (ctrlObj) {
		// Clear out search stuff ...
		ctrlObj.lastSearchStateData = undefined;
		ctrlObj.canReturnToSearchResults = false;
		ctrlObj.searchTerm = '';

		// Set to default browse categories state (shows top level categories)
		setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.browse);

		// Set focus to search box.
		$timeout(() => {
			document.getElementById('help-and-support-search-box').focus();
		}, 0);
	}

	function onError (error) {

		console.error(error);
		$ctrl.setComponentState(COMPONENT_STATES.error);
	}

	function openHelpAndSupportArticle (ctrlObj, supportArticle, categoryId) {
		setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.article, {articleKey:supportArticle.slug, categoryId});
	}

	function search (ctrlObj, searchString) {
		if (searchString !== '') {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.search, {searchString});
		}
	}

	function setBreadcrumb (ctrlObj, categoryId, articleTitle, breadcrumb) {
		if (!angular.isDefined(breadcrumb)) {
			breadcrumb = [];
		}
		const category = supportCategories.find(category => category.id === categoryId);

		// Add to breadcrumb to start of array and move up the 'tree'
		breadcrumb.unshift(category);
		if (category.id !== 0) {
			setBreadcrumb(ctrlObj, category.parentId, articleTitle, breadcrumb);
		}
		else {

			/* End case. Now add the article title to the breadcrumb if specified. It's not really a category, and won't be clickable
			   as it will be at the end of the breadcrumb */
			if (angular.isDefined(articleTitle)) {
				breadcrumb.push({id: -1, name: articleTitle});
			}

			// All done, set the breadcrumb
			ctrlObj.breadcrumb = breadcrumb;
		}
	}

	// Set the overall component state
	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	function setCurrentCategory (ctrlObj, categoryId, articleTitle) {
		const category = supportCategories.find(category => category.id === categoryId);
		ctrlObj.currentCategory = category;

		// Set the breadcrumb to match the category, including the article if specified.
		setBreadcrumb(ctrlObj, categoryId, articleTitle);
	}

	/*
		Set component state. This will do whatever is required to show the help and support panel in the required
		state. Implemented this way to ease the restoration of previous states when navigating through help
	 */
	function setHelpAndSupportViewState (ctrlObj, viewState, stateData) {

		setComponentState(COMPONENT_STATES.loading);

		// If changing to a special category, this might need a special view
		if (viewState === HELP_AND_SUPPORT_VIEWS.browse && angular.isDefined(stateData) && angular.isDefined(stateData.categoryId)) {
			switch (stateData.categoryId) {
				case HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS.latest: {
					viewState = HELP_AND_SUPPORT_VIEWS.latest;
					break;
				}
				default: {
					// Do nothing but keep jslint happy; i.e. leave the viewState intact.
					break;
				}
			}
		}

		/* Timeout seems to be required here, otherwise if an article is already being displayed, a new one
		   doesn't replace it when navigating back */
		$timeout(() => {

			switch (viewState) {
				case HELP_AND_SUPPORT_VIEWS.article: {
					supportData.getSupportArticleByKey(stateData.articleKey).then(articleObj => {

						// If the article isn't found, default to the home screen
						if (angular.isUndefined(articleObj)) {
							goHome(ctrlObj);
						}
						else {
						   /* If there's also a categoryID available, set the current category. First see if its in the state data (in which
							  case it's originated from a special category that WordPress knows nothing about), otherwise ask the article itself
							  (a bonafide WordPress category) */
						   let categoryId;
						   if (angular.isDefined(stateData.categoryId)) {
							   categoryId = stateData.categoryId;
						   }
						   else if (articleObj.categories.length !== 0) {
							   categoryId = articleObj.categories[0].categoryId;
						   }

						   // Set category and breadcrumb, with the article title included, and show breadcrumb if a category is available
						   let showBreadcrumb = false;
						   if (categoryId) {
							   setCurrentCategory(ctrlObj, categoryId, articleObj.title);
							   showBreadcrumb = true;
						   }

						   angular.extend(ctrlObj, {
							   article: articleObj,
							   showBreadcrumb,
							   viewState
						   });

						   // Get related articles for bonafide WordPress categories if there are any, and if set in options. Just use the first category.
						   if (ctrlObj.helpAndSupportOptions.showRelated && articleObj.categories.length !== 0) {
							   setComponentState(COMPONENT_STATES.secondaryContentLoading);
							   supportData.getSupportArticlesForCategory(articleObj.categories[0].categorySlug).then(supportArticlesArr => {
								   // Filter out the current article
								   ctrlObj.supportArticles = supportArticlesArr.filter(supportArticle => supportArticle.slug !== articleObj.slug);
								   setComponentState(COMPONENT_STATES.ready);
							   });
						   }
						   else {
							   ctrlObj.supportArticles = [];
							   setComponentState(COMPONENT_STATES.ready);
						   }

						   /* Update location so user can link to a specific article. The help and support state is configured not to reload
							  when the location is updated */
						   let urlRef = `?articleKey=${articleObj.slug}`;
						   if (categoryId) {
							   urlRef += `&categoryId=${categoryId}`;
						   }
						   $location.url(urlRef);

						}

					})
					.catch(onError);
					break;
				}
				case HELP_AND_SUPPORT_VIEWS.tags: {
					const getTags = supportData.getTags(stateData.tags);
					const getSupportArticlesForTags = supportData.getSupportArticlesForTags(stateData.tags);

					$q.all([getTags, getSupportArticlesForTags]).then(([tagsArr, supportArticlesArr]) => {
						angular.extend(ctrlObj, {
							tags: tagsArr,
							tagNamesDisplay: utilities.formatArrayAsReadableList(tagsArr.map(tag => tag.name), true),
							showBreadcrumb: false,
							supportArticles: supportArticlesArr,
							viewState
						});
						setComponentState(COMPONENT_STATES.ready);
					})
					.catch(onError);
					break;
				}
				case HELP_AND_SUPPORT_VIEWS.latest: {

					// Set current category to unofficial 'latest' category
					setCurrentCategory(ctrlObj, HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS.latest);

					angular.extend(ctrlObj, {
						showBreadcrumb: true,
						// Use pre-retrieved, latest article groups
						latestSupportArticleGroups: latestSupportArticlesGrouped.articleGroups,
						viewState
					});

					setComponentState(COMPONENT_STATES.ready);

					break;
				}
				case HELP_AND_SUPPORT_VIEWS.browse: {

					// Determine category ID if possible. Default to top level of hierarchy.
					let categoryId = 0;
					if (angular.isDefined(ctrlObj.helpAndSupportOptions.supportContext)) {
						/* Category slug will be specified when viewing a single category; typically used for role-based Help and Support,
							limiting viewing to a single set of articles in a private category */
						const category = supportCategories.find(category => category.slug === ctrlObj.helpAndSupportOptions.supportContext);
						if (angular.isDefined(category)) {
							categoryId = category.id;
						}
					}
					else if (angular.isDefined(stateData) && angular.isDefined(stateData.categoryId)) {
						// Category ID specified during general browing through public categories, for users with full Help and Support access
						categoryId = stateData.categoryId;
					}

					// Update filtered categories. Strip out headline categories for special consideration. Ignore any categories that are marked 'private'
					ctrlObj.filteredCategories = supportCategories.filter(
						supportCategory => supportCategory.parentId === categoryId && !supportCategory.isHeadline && !supportCategory.isPrivate
					);
					ctrlObj.headlineCategories = supportCategories.filter(
						supportCategory => supportCategory.parentId === categoryId && supportCategory.isHeadline && !supportCategory.isPrivate
					);

					// If we've drilled down to a proper category, get the articles for it. First set the current category.
					setCurrentCategory(ctrlObj, categoryId);
					if (categoryId !== 0) {
						// Get articles for this category
						setComponentState(COMPONENT_STATES.secondaryContentLoading);

						supportData.getSupportArticlesForCategory(ctrlObj.currentCategory.slug).then(supportArticlesArr => {
							ctrlObj.supportArticles = supportArticlesArr;
							setComponentState(COMPONENT_STATES.ready);
						})
						.catch(onError);
					}
					else {
						// We're at the top-level placeholder Help and Support category. Popular articles are shown here.
						ctrlObj.supportArticles = popularSupportArticles;
						setComponentState(COMPONENT_STATES.ready);
					}

					/* Let the breadcrumb be displayed. This will be overridden in the template if the breadcrumb has been disabled
					   with helpAndSupportOptions.showBreadcrumb */
					angular.extend(ctrlObj, {
						showBreadcrumb: true,
						viewState
					});

					break;
				}
				case HELP_AND_SUPPORT_VIEWS.search: {

					// If there's a supportContext set in config, search under that category. Otherwise search all
					let searchSupportArticles;
					if (angular.isDefined(ctrlObj.helpAndSupportOptions.supportContext)) {
						searchSupportArticles = supportData.searchSupportArticlesForCategory(ctrlObj.helpAndSupportOptions.supportContext, stateData.searchString);
					}
					else {
						searchSupportArticles = supportData.searchSupportArticles(stateData.searchString);
					}

					// Do the search
					searchSupportArticles.then(supportArticlesArr => {
						angular.extend(ctrlObj, {
							showBreadcrumb: false,
							supportArticles: supportArticlesArr,
							searchString: stateData.searchString
						});
						ctrlObj.viewState = viewState;

						// Keep hold of search state to enable 'return to search results'
						ctrlObj.lastSearchStateData = stateData;
						ctrlObj.canReturnToSearchResults = true;

						setComponentState(COMPONENT_STATES.ready);
					})
					.catch(onError);
					break;
				}
			}

		}, 0);
	}

	function showHelpAndSupport (ctrlObj) {

		// Get the article key (+ optional category Id), tags or search terms. Only one should be available, but article key trumps tags trumps search.
		const articleKey = ctrlObj.helpAndSupportOptions.articleKey;
		const categoryId = ctrlObj.helpAndSupportOptions.categoryId; 		// Optional. Category context.
		const categorySlug = ctrlObj.helpAndSupportOptions.categorySlug; 	// Specified for role-specific help and support
		const tags = ctrlObj.helpAndSupportOptions.tags;					// For contextual help and support
		const searchTerm = ctrlObj.helpAndSupportOptions.searchTerm;

		if (angular.isDefined(articleKey)) {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.article, {articleKey, categoryId});
		}
		else if (angular.isDefined(tags)) {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.tags, {tags});
		}
		else if (angular.isDefined(searchTerm)) {
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.search, {searchTerm});
		}
		else if (angular.isDefined(categorySlug)) {
			// Role-specific help and support, limited to single category
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.browse, {categorySlug});
		}
		else {
			// Just show the main help home page
			setHelpAndSupportViewState(ctrlObj, HELP_AND_SUPPORT_VIEWS.browse);
		}

		/* Allow refresh to be reset in order to update the help content while it's still open. Typically this
		   will happen when a help & support link is clicked while the help and support panel is already open */
		ctrlObj.helpAndSupportOptions.refresh = false;
	}

	angular.extend($ctrl, {

		// Constants
	COMPONENT_STATES,
		HELP_AND_SUPPORT_DISPLAY_OPTIONS,
		HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS,
		HELP_AND_SUPPORT_VIEWS,
		SUPPORT_ARTICLE_CARD_VIEW_MODES,

		// Variables
		isClosed: false,
		searchTerm: '',

		// Functions
		changeCategory,
		closePanel,
		goHome,
		openHelpAndSupportArticle,
		returnToSearchResults,
		search
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('ipAddress', {

	bindings: {
		ipAddress: '=',
		ipAddressDisabled: '<?',
		ipAddressRequired: '<?',
		onChange: '&?',
		name: '@'
	},
	controller: 'ipAddressCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/ip-address/ip-address.component.html'
})

.controller('ipAddressCtrl', ['$timeout', function ($timeout) {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		// Default bindings
		$ctrl.ipAddressDisabled = angular.isDefined($ctrl.ipAddressDisabled) ? $ctrl.ipAddressDisabled : false;
		$ctrl.ipAddressRequired = angular.isDefined($ctrl.ipAddressRequired) ? $ctrl.ipAddressRequired : false;
	};

	function ipAddressOnChange ($ctrl) {

		if (angular.isFunction($ctrl.onChange)) {
			// Allow a digest to run so the change function gets the updated model
			$timeout(() => {
				$ctrl.onChange();
			});
		}
	}

	angular.extend($ctrl, {
		ipAddressOnChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('journalCodePreview', {
	bindings: {
		agencyProfileId: '<', 
		isFinancialsIntegrated: '<',
		journalCodeFormat: '<',
		journalCodesActive: '<',
		onUpdate: '&'
	},
	controller: 'journalCodePreviewController',
	templateUrl: 'components/journal-code-preview/journal-code-preview.component.html'
})
.controller('journalCodePreviewController', [
	'$rootScope',
	function (
		$rootScope
	) {

	const $ctrl = this;

	function openJournalFormatForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'journal-code-format'
		});
	}

	function openJournalCodeFinancialsForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'journal-code-financials'
		});
	}

	function openJournalCodePreviewInfoModal () {
		$rootScope.openModalDialog('settings-journal-code-preview-info');
	}

	angular.extend($ctrl, {
		componentState: 'ready',
		openJournalCodeFinancialsForm,
		openJournalCodePreviewInfoModal,
		openJournalFormatForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('iconCardBasic', {
	bindings: {
		contents: '@?',
		icon: '@?',
		theme: '@?',
	},
	controller: 'iconCardBasicCtrl',
	templateUrl: 'components/icon-card-basic/icon-card-basic.component.html'
})
.controller('iconCardBasicCtrl', function () {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary'
		});

	}

	angular.extend($ctrl, {
		$onInit
	});
});

'use strict';

angular.module('paycircleApp')
.component('iconDot', {
	bindings: {
		/* One of icon or label should be specified. If both are present, icon takes precedence. Icon is the icon to display,
		   label will be a character (A-Z) to display. If label is more than a single character, the first will be used. It will
		   always be uppercased. */
		icon: '@?',
		iconSize: '@?',
		label: '@?',
		isLight: '<?',
		tooltipPosition: '@?',
		tooltipText: '@?',
		tooltipTheme: '@?',
		theme: '@?'
	},
	controller: 'iconDotCtrl',
	templateUrl: 'components/icon-dot/icon-dot.component.html',
})
.controller('iconDotCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			char: $ctrl.label ? $ctrl.label.charAt(0).toUpperCase() : '',
			iconSize: $ctrl.iconSize || null,
			theme: $ctrl.theme || 'is-primary'
		});
	};
});

'use strict';

angular.module('paycircleApp')
.component('imageBadge', {
	bindings: {
		imageAlt: '@',
		imageClass: '@?',
		imageSize: '@?',
		imageKey: '@',
		imageType: '@?'
	},
	controller: 'imageBadgeComponentCtrl',
	templateUrl: 'components/image-badge/image-badge.component.html'
})
.controller('imageBadgeComponentCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			imageSize: angular.isDefined($ctrl.size) ? $ctrl.size : 'is-medium',
			imageUrl: getImageUrl($ctrl),
		});
	}

	function getImageUrl ($ctrl) {

		let imageUrl = '../images/logo/';

		if (angular.isDefined($ctrl.imageType)) {
			imageUrl += `/${$ctrl.imageType}`;
		}

		if (angular.isDefined($ctrl.imageKey)) {
			imageUrl += `/${$ctrl.imageKey}`;
		}

		imageUrl += '.2x.png';

		return imageUrl;
	}
	
	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('imageFocusPanel', {
	bindings: {
		image: '='
	},
	controller: 'imageFocusPanelCtrl',
	templateUrl: 'components/image-focus-panel/image-focus-panel.component.html'
})

.controller('imageFocusPanelCtrl', ['$rootScope', '$timeout', function ($rootScope, $timeout) {

	const $ctrl = this;

	function closeImageFocusPanel (ctrlObj) {
		ctrlObj.isClosing = true;
		// Give the pleasant fade out effect time to complete before obliterating the panel
		$timeout(() => {
			$rootScope.$broadcast('close-image-focus');
		}, 200);
	}

	angular.extend($ctrl, {
		isClosing: false,

		closeImageFocusPanel
	});

}]);
'use strict';

angular.module('paycircleApp')
.component('importHistoryItem', {
	bindings: {
		agencyProfileId: '<?',
		formOptions: '<?',
		import: '<',
		onUndo: '&?',
		onUpdate: '&?',
		payPeriod: '<'
	},
	controller: 'importHistoryItemCtrl',
	templateUrl: 'components/import-history-item/import-history-item.component.html',
})
.controller('importHistoryItemCtrl', ['$rootScope', 'IMPORT_MAPPING_TYPES', function ($rootScope, IMPORT_MAPPING_TYPES) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.hasNoChanges = $ctrl.import.NumberImported === 0 &&
			$ctrl.import.NumberUpdated === 0;
	}

	function openSlideInForm ($ctrl, newFormOptionsObj) {

		if (angular.isDefined($ctrl.formOptions)) {
			$ctrl.formOptions.openNewSlideInForm(newFormOptionsObj);
		} else {
			$rootScope.openSlideInForm(newFormOptionsObj);
		}
	}

	function openUndoImportCompanyDataForm ($ctrl) {

		openSlideInForm($ctrl, {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'undo-import-company-data',
			payPeriod: $ctrl.payPeriod,
			userImportGroupObj: $ctrl.import
		});
	}

	function openUndoImportTeamForm ($ctrl, isPeriodImport) {

		openSlideInForm($ctrl, {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'undo-import-team',
			isPeriodImport: isPeriodImport,
			payPeriod: $ctrl.payPeriod,
			userImportGroupObj: $ctrl.import
		});
	}

	function openUndoImportPayElementForm ($ctrl) {

		openSlideInForm($ctrl, {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'undo-import-pay-element',
			payPeriod: $ctrl.payPeriod,
			userImportGroupObj: $ctrl.import
		});
	}

	function openUndoImportPayPolicyForm ($ctrl) {

		openSlideInForm($ctrl, {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'undo-import-pay-policy',
			payPeriod: $ctrl.payPeriod,
			userImportGroupObj: $ctrl.import
		});
	}

	function openUndoImportPostsPayPoliciesForm ($ctrl) {

		openSlideInForm($ctrl, {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'undo-import-posts-pay-policies',
			payPeriod: $ctrl.payPeriod,
			userImportGroupObj: $ctrl.import
		});
	}

	function reviewUndoImportForm ($ctrl) {

		if (angular.isDefined($ctrl.onUndo)) {
			$ctrl.onUndo();
			return;
		}

		switch ($ctrl.import.ImportType) {

			// Pay Element import mapping types
			case IMPORT_MAPPING_TYPES.changesTable:
			case IMPORT_MAPPING_TYPES.linkedElements:
			case IMPORT_MAPPING_TYPES.payElements:
			case IMPORT_MAPPING_TYPES.payElementsDailyRate:
			case IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsFixed:
			case IMPORT_MAPPING_TYPES.payElementsFixedCIS:
			case IMPORT_MAPPING_TYPES.payElementsFixedCISHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsFixedRecurring:
			case IMPORT_MAPPING_TYPES.payElementsHourlyRate:
			case IMPORT_MAPPING_TYPES.payElementsRatedUnitsVertical:
			case IMPORT_MAPPING_TYPES.payElementsRecurring:
			case IMPORT_MAPPING_TYPES.payElementsOffPayroll:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollHorizontal:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurring:
			case IMPORT_MAPPING_TYPES.payElementsOffPayrollRecurringHorizontal:
			case IMPORT_MAPPING_TYPES.nominalCodes:
			case IMPORT_MAPPING_TYPES.xeroNominalCodes:
			case IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts:
				openUndoImportPayElementForm($ctrl);
				break;

			// Company imports
			case IMPORT_MAPPING_TYPES.businessCategories:
			case IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories:
				openUndoImportCompanyDataForm($ctrl);
				break;

			// Pay Policy imports
			case IMPORT_MAPPING_TYPES.policyImport:
				openUndoImportPayPolicyForm($ctrl);
				break;

			// Posts & Pay Policy imports
			case IMPORT_MAPPING_TYPES.postsPayPolicies:
				openUndoImportPostsPayPoliciesForm($ctrl);
				break;

			// Period imports
			case IMPORT_MAPPING_TYPES.payslipNotes:
				openUndoImportTeamForm($ctrl, true);
				break;

			// Team imports
			default:
				openUndoImportTeamForm($ctrl);
		}
	}

	angular.extend($ctrl, {
		$onInit,
		reviewUndoImportForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('importMappingCard', {

	templateUrl: 'components/import-mapping-card/import-mapping-card.component.html',
	bindings: {
		refresh: '&?',
		importMapping: '<'
	},
	controller: 'importMappingCardController'
})

.controller('importMappingCardController', ['$rootScope', '$state', 'validationService', 'IMPORT_MAPPING_TYPES', function ($rootScope, $state, validationService, IMPORT_MAPPING_TYPES) {

	const $ctrl = this;

	const agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

	function getCanDeleteMapping ($ctrl) {

		// Bureau level templates
		if ($ctrl.importMapping.IsGlobalTemplate) {

			// Companies cannot delete bureau level mappings
			if ($rootScope.currentCompany.isPayrollCompany) {
				return false;
			}
		}

		return true;
	}

	function getCanEditMapping ($ctrl) {

		// Editing throws a gremlin if the AgencyDocumentID is not provided
		if (validationService.isEmptyGuid($ctrl.importMapping.AgencyDocumentID)) {
			return false;
		}

		// Companies cannot edit bureau level mappings
		if ($rootScope.currentCompany.isPayrollCompany) {
			return false;
		}

		return true;
	}

	function getEditNgHref ($ctrl) {

		const ngHrefObj = {
			agencyDocumentId: $ctrl.importMapping.AgencyDocumentID,
			agencyDocumentType: -1,
			agencyProfileId: $ctrl.agencyProfileId,
			backState: 'settings.bureau.imports.mappings',
			importMappingType: $ctrl.importMapping.MappingType,
			importMappingTemplateId: $ctrl.importMapping.ImportMappingID,
			payPeriodId: $rootScope.CONFIG.guidEmpty
		};

		switch ($ctrl.importMapping.MappingType) {

			case IMPORT_MAPPING_TYPES.users: {			
				return $state.href('data-importer.validate-file', ngHrefObj);
			}
		}

		return $state.href('data-importer.import-data', ngHrefObj);
	}

	function openDeleteImportMappingForm (ctrlObj, importMappingObj) {

		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: $ctrl.refresh,
			formKey: 'delete-import-mapping',
			importMappingTemplate: importMappingObj,
		});
	}

	function openDuplicateImportMappingForm (ctrlObj, importMappingObj) {

		importMappingObj = angular.copy(importMappingObj);

		importMappingObj.Name += ' (copy)';

		$rootScope.openSlideInForm({
			actionType: 'duplicate',
			agencyProfileId,
			callback: $ctrl.refresh,
			formKey: 'mapping-template',
			headerCount: importMappingObj.HeaderCount,
			importMappingTemplate: importMappingObj,
			title: 'Duplicate mapping'
		});
	}

	angular.extend($ctrl, {

		IMPORT_MAPPING_TYPES,

		// Variables
		agencyProfileId,

		// Functions
		getCanDeleteMapping,
		getCanEditMapping,
		getEditNgHref,
		openDeleteImportMappingForm,
		openDuplicateImportMappingForm
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('importSummary', {
	bindings: {
		importSummary: '<',
		isPayElementImport: '<?'
	},
	controller: 'importSummaryCtrl',
	templateUrl: 'components/import-summary/import-summary.component.html',
})
.controller('importSummaryCtrl', [
	'IMPORT_WARNING_TYPES',
	function (
		IMPORT_WARNING_TYPES
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		IMPORT_WARNING_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('infoBlock', function () {

	return {
		controller: 'infoBlockCtrl',
		templateUrl: 'components/info-block/infoBlock.html',
		replace: true,
		restrict: 'E',
		scope: {
			'ibAlign': '@?',
			'ibIconDot': '@?',
			'ibTheme': '@?',
			'ibTitle': '@?'
		},
		transclude: {
			'ibHeader': '?ibHeader',
			'ibMain': '?ibMain'
		}
	};
})
.controller('infoBlockCtrl', ['$scope', '$transclude', function ($scope, $transclude) {

	$scope.ibTheme = $scope.ibTheme !== undefined ? $scope.ibTheme : 'primary';
	$scope.hasHeader = $transclude.isSlotFilled('ibHeader');
	$scope.hasMain = $transclude.isSlotFilled('ibMain');
	$scope.hasTitle = $scope.ibTitle !== undefined;
}]);

'use strict';

angular.module('paycircleApp')
.directive('intercomForm', [function () {
	return {
		restrict: 'E',
		templateUrl: 'components/intercom-form/intercomFormBlock.html',
		replace: true,
		controller: 'intercomFormBlockCtrl',
		scope: {
			customisation: '='
		}
	};
}])
.controller('intercomFormBlockCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {

	$scope.state = 'connect';

	$rootScope.$on('INTERCOM_CHANGE_STATE', function (event, newState) {
		$scope.state = newState;
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('leaveCalendar', function () {

	return {
		scope: {
			hs: '='
		},
		link: function(scope, element) {

			var calendarBody = element[0].getElementsByClassName('leave-calendar__content')[0];

			function scrollMonthIntoView () {
				if (scope.hs.calendar.currentDate.month() === moment().month()) {
					calendarBody.scrollLeft = (scope.hs.calendar.months[0].days.length+moment().date()-1)*scope.hs.calendar.dayWidth+2;
				} else {
					calendarBody.scrollLeft = scope.hs.calendar.months[0].days.length*scope.hs.calendar.dayWidth+2;
				}
				updateCurrentMonth();
			}

			function updateCurrentMonth () {

				var scrollPos = calendarBody.scrollLeft+calendarBody.offsetWidth/2;
				var months = {
					one: scope.hs.calendar.months[0].days.length*scope.hs.calendar.dayWidth,
					two: scope.hs.calendar.months[1].days.length*scope.hs.calendar.dayWidth,
					three: scope.hs.calendar.months[2].days.length*scope.hs.calendar.dayWidth
				};

				if (scrollPos < months.one) {
					scope.hs.calendar.setCurrentMonth(scope.hs.calendar.months[0]);
				} else if (scrollPos > months.one && scrollPos < months.one+months.two) {
					scope.hs.calendar.setCurrentMonth(scope.hs.calendar.months[1]);
				} else if (scrollPos > months.one+months.two) {
					scope.hs.calendar.setCurrentMonth(scope.hs.calendar.months[2]);
				}
			}

			function setCalendarWidth() {

				var positionRect = calendarBody.getBoundingClientRect();
				scope.hs.calendar.position = {
					left: positionRect.left,
					right: positionRect.right
				};
			}

			window.addEventListener('resize', function() {

				setCalendarWidth();
			});

			scope.hs.calendar.scrollMonthIntoView = function (which) {
				scrollMonthIntoView(which);
			};

			angular.element(calendarBody).bind('scroll', function () {

				updateCurrentMonth();
			});

			setCalendarWidth();

		}
	};
});

'use strict';

angular.module('paycircleApp')
.directive('leaveCalendarCard', ['config', 'holidaySicknessService', function (config, holidaySicknessService) {

	return {
		scope: {
			isReadonly: '<?',
			leave: '=',
			teamMember: '=',
			hs: '='
		},
		link: function(scope, element) {

			const leaveCard = element[0];
			const dayWidth = parseInt(scope.hs.calendar.dayWidth);

			let newLength;
			let isLeftHandle;
			let target;

			const isReadonly = angular.isDefined(scope.isReadonly) ? scope.isReadonly : false;
			if (isReadonly) {
				element.addClass('is-readonly');
			}

			function checkMenuPosition (goStraightAway) {

				setTimeout(function() {
					if (scope.leave.showMenu || (goStraightAway && element.parent().children().length > 1)) {
						var leaveMenu = element.parent().children()[1];
						if (leaveMenu.getBoundingClientRect().left < scope.hs.calendar.position.left) {
							leaveMenu.scrollIntoView({
								behavior: 'smooth',
								inline: 'start',
								block: 'end'
							});
						} else if (leaveMenu.getBoundingClientRect().right > scope.hs.calendar.position.right) {
							leaveMenu.scrollIntoView({
								behavior: 'smooth',
								inline: 'end',
								block: 'end'
							});
						}
					}
				}, 0);
			}

			element.bind('click', function () {

				checkMenuPosition(false);
			});

			scope.leave.checkMenuPosition = function (goStraightAway) {

				checkMenuPosition(goStraightAway);
			};

			interact(leaveCard)
			.resizable({
			    allowFrom: '.leave-calendar__leave-card--resize:not(.is-readonly)',
				edges: {
					left: true,
					right: true
				},
				restrictEdges: {
					outer: 'parent',
					endOnly: true,
				},
				restrictSize: {
					min: {
						width: dayWidth
					}
				}
			})
			.on('resizestart', function (event) {

				target = event.target.parentNode;

				if (scope.leave.halfDayFrom) {
					scope.leave.leaveDays += scope.hs.calendar.halfDay;
					target.style.setProperty('--lengthModifier', 0);
				}

				if (scope.leave.halfDayTo) {
					scope.leave.leaveDays += scope.hs.calendar.halfDay;
				}
			})

			.on('resizemove', function (event) {

				target = event.target.parentNode;
				newLength = Math.ceil(event.rect.width/dayWidth);
				isLeftHandle = event.edges.left;
				if (isLeftHandle) {
					target.style.setProperty('--leaveRight', -((dayWidth*(scope.leave.leaveDays-1))-6) + 'px');
					scope.leave.startDateIso = moment(scope.leave.endDateIso).subtract(newLength-1, 'd').format(config.dateFormatISO);
				} else {
					scope.leave.endDateIso = moment(scope.leave.startDateIso).add(newLength-1, 'd').format(config.dateFormatISO);
				}
				target.style.setProperty('--leaveLength', newLength);
			})

			.on('resizeend', function (event) {

				target = event.target.parentNode;
				target.style.setProperty('--lengthModifier', 1);

				if (newLength === 1 && (scope.leave.halfDayFrom || scope.leave.halfDayTo)) {
					scope.leave.halfDayFrom = false;
					scope.leave.halfDayTo = false;
				}

				newLength = holidaySicknessService.checkForHalfDayLeave(scope.leave, newLength);

				scope.leave.leaveDays = newLength;

				if (isLeftHandle) {
					scope.leave.startDateIso = moment(scope.leave.endDateIso).subtract(newLength-1, 'd').format(config.dateFormatISO);
				} else {
					scope.leave.endDateIso = moment(scope.leave.startDateIso).add(newLength-1, 'd').format(config.dateFormatISO);
				}
				scope.leave.update();
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('leaveCard', function () {

	return {
		templateUrl: 'components/leave-card/leaveCard.html',
		replace: true,
		restrict: 'E',
		scope: {
			callback: '&',
			index: '<',
			integrationMessage: '@?',
			isIntegrationLocked: '<?',
			leave: '<',
			leaveType: '@'
		},
		controller: 'leaveCardCtrl'
	};
})
.controller('leaveCardCtrl', ['$filter', '$scope', 'agency', 'LEAVE_TYPE_DESCRIPTIONS', function($filter, $scope, agency, LEAVE_TYPE_DESCRIPTIONS) {

	if (!angular.isDefined($scope.isIntegrationLocked)) {
		$scope.isIntegrationLocked = false;
	}

	$scope.$watchGroup(['isIntegrationLocked', 'leave.IsFromIntegration'], function () {
		$scope.isLocked = !!$scope.isIntegrationLocked || !!($scope.leave && $scope.leave.IsFromIntegration);

		if ($scope.isLocked && !angular.isDefined($scope.integrationMessage)) {
			$scope.integrationMessage = getDefaultIntegrationMessage($scope.leaveType);
		}
	});

	if ($scope.leaveType === 'holiday') {
		loadHoliday();
	} else {
		loadSickness();
	}

	function getDefaultIntegrationMessage (leaveType) {

		switch (leaveType) {
			case 'holiday':
				return 'Holiday is managed by a source system and cannot be edited here.';
			case 'sickness':
				return 'Sickness is managed by a source system and cannot be edited here.';
			default:
				return 'This schedule is managed by a source system and cannot be edited here.';
		}
	}

	function loadHoliday() {

		$scope.cardTheme = $filter('leaveThemes')($scope.leave.HolidayType);
		$scope.startDate = $scope.leave.HolidayDateFromISO;
		$scope.endDate = $scope.leave.HolidayDateToISO;
		$scope.leaveDays = $scope.leave.HolidayDays;
	}

	function loadSickness () {

		// SicknessType is the SSP policy enum, not a leave category - all sickness entries are Sick Leave
		$scope.cardTheme = $filter('leaveThemes')(LEAVE_TYPE_DESCRIPTIONS.sickLeave);
		$scope.startDate = $scope.leave.SicknessDateFromISO;
		$scope.endDate = $scope.leave.SicknessDateToISO;
		$scope.leaveDays = $scope.leave.SicknessDays;
	}

	$scope.deleteLeave = function (leave) {

		if ($scope.isLocked) {
			return;
		}

		leave.state = 'deleting';

		if ($scope.leaveType === 'holiday') {
			agency.deleteHolidayDetail(leave.UserAgencyProfileHolidayID).then(function () {

				$scope.callback();
			})
			.catch(function (error) {

				if (error && error.status === 403) {
					$scope.isIntegrationLocked = true;
					$scope.integrationMessage = getDefaultIntegrationMessage($scope.leaveType);
					return;
				}

				leave.state = 'error';
			});
		} else {
			agency.deleteSicknessDetail(leave.UserAgencyProfileSicknessID).then(function () {

				$scope.callback();
			})
			.catch(function () {

				leave.state = 'error';
			});
		}

	};

}]);

'use strict';

angular.module('paycircleApp')
.component('linkElementCard', {
	bindings: {
		agencyProfileId: '<',
		linkElement: '<',
		linkElementGroupId: '<',
		onUpdate: '=?'
	},
	controller: 'linkElementCardCtrl',
	templateUrl: 'components/link-element-card/link-element-card.component.html'
})
.controller('linkElementCardCtrl', ['$rootScope', function ($rootScope) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.linkElement.theme = $ctrl.linkElement.IsDeduction ? 'is-assertive' : 'is-positive';
	}

	function getFormTitleForActionType (actionType) {

		switch (actionType) {
			case 'delete':
				return 'Delete link element';
			case 'duplicate':
				return 'Duplicate link element';
			case 'edit':
				return 'Edit link element';
			default:
				return;
		}
	}

	function openDeleteLinkElementForm ($ctrl) {

		openLinkElementForm($ctrl, 'delete');
	}

	function openDuplicateLinkElementForm ($ctrl) {

		openLinkElementForm($ctrl, 'duplicate');
	}

	function openEditLinkElementForm ($ctrl) {

		openLinkElementForm($ctrl, 'edit');
	}

	function openLinkElementForm ($ctrl, actionType) {

		$rootScope.openSlideInForm({
			actionType,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'link-element',
			linkElementObj: $ctrl.linkElement,
			linkElementGroupId: $ctrl.linkElementGroupId,
			title: getFormTitleForActionType(actionType)
		});
	}

	angular.extend($ctrl, {
		$onInit,
		openDeleteLinkElementForm,
		openDuplicateLinkElementForm,
		openEditLinkElementForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('linkRateCard', {
	bindings: {
		agencyProfileId: '<',
		linkRate: '<',
		linkRates: '=',
		onUpdate: '=?',
		userId: '<'
	},
	controller: 'linkRateCardCtrl',
	templateUrl: 'components/link-rate-card/link-rate-card.component.html'
})
.controller('linkRateCardCtrl', ['$rootScope', 'ADJUSTMENT_VALUE_TYPES', function ($rootScope, ADJUSTMENT_VALUE_TYPES) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.linkRate.theme = $ctrl.linkRate.Deduction ? 'is-assertive' : 'is-positive';
	}

	function getFormTitleForActionType (actionType) {

		switch (actionType) {
			case 'delete':
				return 'Delete link rate';
			case 'edit':
				return 'Edit link rate';
			default:
				return;
		}
	}

	function openDeleteLinkRateForm ($ctrl) {

		openLinkRateForm($ctrl, 'delete');
	}

	function openEditLinkRateForm ($ctrl) {

		openLinkRateForm($ctrl, 'edit');
	}

	function openLinkRateForm ($ctrl, actionType) {

		$rootScope.openSlideInForm({
			actionType,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'link-rate',
			linkRateObj: $ctrl.linkRate,
			title: getFormTitleForActionType(actionType),
			userId: $ctrl.userId
		});
	}

	angular.extend($ctrl, {
		ADJUSTMENT_VALUE_TYPES,
		$onInit,
		openDeleteLinkRateForm,
		openEditLinkRateForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('loadingBlock', function () {

	return {
		controller: 'loadingBlockCtrl',
		templateUrl: 'components/loading-block/loadingBlock.html',
		replace: true,
		restrict: 'E',
		scope: {
			'position': '@?',
			'size': '@?'
		},
		transclude: {
			'description': '?lbDescription'
		}
	};
})
.controller('loadingBlockCtrl', ['$scope', '$transclude', function ($scope, $transclude) {

	// Scope
	$scope.showDescription = $transclude.isSlotFilled('description');
	$scope.size = $scope.size !== undefined ? $scope.size : '';
	$scope.position = $scope.position !== undefined ? $scope.position : 'before';
}]);

'use strict';

angular.module('paycircleApp')
.directive('logCard', function () {

	return {
		templateUrl: 'components/log-card/logCardComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			log: '<',
			showLogActor: '<?'
		},
		controller: 'logCardCtrl'
	};
})
.controller('logCardCtrl', ['$scope', 'LOG_ACTIONED_BY_TYPES', 'LOG_DATA_TYPES', 'LOG_TYPES', 'LOG_TYPE_KEYS', function ($scope, LOG_ACTIONED_BY_TYPES, LOG_DATA_TYPES, LOG_TYPES, LOG_TYPE_KEYS) {

	$scope.LOG_DATA_TYPES = LOG_DATA_TYPES;
	$scope.LOG_TYPES = LOG_TYPES;

	$scope.showLogActor = $scope.showLogActor !== undefined ? $scope.showLogActor : false;

	function init() {
		if (!angular.isDefined($scope.log.LogEntryTitle) || $scope.log.LogEntryTitle === '') {
			const logType = LOG_TYPES[LOG_TYPE_KEYS[$scope.log.LogType]];
			$scope.logDescription = logType ? logType.description : 'Unknown action';
		}
		else {
			$scope.logDescription = $scope.log.LogEntryTitle;
		}
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')
.component('menuButton', {
	bindings: {
		menuButtonAddIcon: '<?',
		menuButtonAlign: '@?',
		menuButtonHasChevron: '<?',
		menuButtonIcon: '@?',
		menuButtonId: '@?',
		menuButtonOpen: '=?',
		menuButtonSize: '@?',
		menuButtonText: '@?',
		menuButtonTheme: '@?',
		menuButtonType: '@?' // 'icons' || 'links' (default)
	},
	controller: 'menuButtonCtrl',
	templateUrl: 'components/menu-button/menu-button.component.html',
	transclude: true
})
.controller('menuButtonCtrl', function () {

	const $ctrl = this;

	angular.extend($ctrl, {
		menuButtonAddIcon: angular.isDefined($ctrl.menuButtonAddIcon) ? $ctrl.menuButtonAddIcon : true,
		menuButtonAlign: angular.isDefined($ctrl.menuButtonAlign) ? $ctrl.menuButtonAlign : 'right',
		menuButtonHasChevron: angular.isDefined($ctrl.menuButtonHasChevron) ? $ctrl.menuButtonHasChevron : true,
		menuButtonIcon: angular.isDefined($ctrl.menuButtonIcon) ? $ctrl.menuButtonIcon : 'icon-plus',
		menuButtonOpen: angular.isDefined($ctrl.menuButtonOpen) ? $ctrl.menuButtonOpen : false,
		menuButtonSize: angular.isDefined($ctrl.menuButtonSize) ? $ctrl.menuButtonSize : 'm',
		menuButtonTheme: angular.isDefined($ctrl.menuButtonTheme) ? $ctrl.menuButtonTheme : 'primary',
		menuButtonType: angular.isDefined($ctrl.menuButtonType) ? $ctrl.menuButtonType : 'links',
	});
});

'use strict';

angular.module('paycircleApp')
.directive('messageBar', function () {

	return {
		templateUrl: 'components/message-bar/messageBarComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			'tagLabel': '@?',
			'tagLabelIcon': '@?',
			'tagLabelTheme': '@?',
			'theme': '@?', // primary, secondary
			'type': '@?' // action
		},
		transclude: true
	};
});

'use strict';

angular.module('paycircleApp')
.component('messageBlock', {
	templateUrl: 'components/message-block/message-block.component.html',
	bindings: {
		/* Optional action attributes. Action is displayed at RHS of message block. actionText and actionFn must be set
           to show the action. The icon is optional. actionTheme defaults to theme if not specified. */
		actionFn: '&?',
		actionIcon: '@?',
		actionText: '@?',
		actionTheme: '@?',

		hasDropIn: '<?',
		icon: '@?',
		theme: '@?'
	},
	controller: 'messageBlockCtrl',
	transclude: true
})
.controller('messageBlockCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		angular.extend($ctrl, {
			actionTheme: angular.isDefined($ctrl.actionTheme) ? $ctrl.actionTheme : $ctrl.theme,
			hasAction: angular.isDefined($ctrl.actionText) && angular.isDefined($ctrl.actionFn) && angular.isFunction($ctrl.actionFn),
			hasActionIcon: angular.isDefined($ctrl.actionIcon),
			hasDropIn: angular.isDefined($ctrl.hasDropIn) ? $ctrl.hasDropIn : true,
			hasIcon: angular.isDefined($ctrl.icon)
		});
	};

	function onActionClick (ctrlObj) {
		// This will be a function; checked in onInit
		ctrlObj.actionFn();
	}

	angular.extend($ctrl, {
		onActionClick
	});
});

'use strict';

angular.module('paycircleApp')
.component('metaDataCard', {
	bindings: {
		icon: '@?',
		metaItems: '<',
		metaTitle: '<?',
		theme: '@?',
	},
	controller: 'metaDataCardComponentCtrl',
	templateUrl: 'components/meta-data-card/meta-data-card.component.html'
})
.controller('metaDataCardComponentCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		$ctrl.theme = angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary';
	};
});


'use strict';

angular.module('paycircleApp')
.component('metaTags', {
	bindings: {
		// Optional align-right to put the tags at the end of their container. Defaults to false.
		alignRight: '<?',
		metaTags: '<',
		// Put an empty meta-tag in to take up space. Defaults to false.
		showIfEmpty: '<?',
		theme: '@?'
	},
	controller: 'metaTagsComponentCtrl',
	templateUrl: 'components/meta-tags/meta-tags.component.html'
})
.controller('metaTagsComponentCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		$ctrl.alignRight = angular.isDefined($ctrl.alignRight) ? $ctrl.alignRight : false;
		$ctrl.showIfEmpty = angular.isDefined($ctrl.showIfEmpty) ? $ctrl.showIfEmpty : false;
		$ctrl.theme = angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary';
	};
});

'use strict';

angular.module('paycircleApp')
.component('mobileMenu', {

	bindings: {
		mmTitle: '@'
	},
	controller: 'mobileMenuController',
	templateUrl: 'components/mobile-menu/mobile-menu.component.html',
	transclude: true
})

.controller('mobileMenuController', [
	'utilities',
	function (
		utilities
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		const appHeaderHeight = utilities.getAppHeaderHeight();
		$ctrl.appHeaderPixelHeight = `${appHeaderHeight}px`;
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('modal', {

	bindings: {
		modalOptions: '='
	},
	controller: 'modalController',
	templateUrl: 'components/modal/modal.component.html',
	transclude: {
		'modalBody': 'modalBody',
		'primaryActions': '?modalPrimaryActions',
		'secondaryActions': '?modalSecondaryActions'
	}
})
.controller('modalController', [
	'$transclude',
	'MODAL_OPTIONS',
	function (
		$transclude,
		MODAL_OPTIONS
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			/* For modals not yet refactored into the modal-cabinet, these different treatment. They'll display their
			   own overlay and won't be opened or closed using the application-level functions which control overlay
			   display. This can go when all modals have been refactored to the new cabinet structure. */
			isModalCabinet: MODAL_OPTIONS.hasOwnProperty($ctrl.modalOptions.modalKey),
			hasPrimaryActions: $transclude.isSlotFilled('primaryActions'),
			hasSecondaryActions: $transclude.isSlotFilled('secondaryActions')
		});
	};

	/**
	 * Close the modal. This is here to allow refactored and legacy modals to live together in relative harmony.
	 * When all have been refactored, this can go. See additional comments in template.
	 */
	function closeModal () {

		// Is this a refactored modal?
		if ($ctrl.isModalCabinet) {
			// It is. Use closeModal provided to modalOptions by the modal service
			$ctrl.modalOptions.closeModal();
		}
		else {
			// Legacy close.
			if (angular.isFunction($ctrl.modalOptions.onClose)) {
				$ctrl.modalOptions.onClose();
			}
			$ctrl.modalOptions.isOpen = false;
		}
	}

	angular.extend($ctrl, {
		closeModal
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('modalCabinet', {
	bindings: {
		modalOptions: '='
	},
	controller: 'modalCabinetCtrl',
	templateUrl: 'components/modal-cabinet/modal-cabinet.component.html'
})
.controller('modalCabinetCtrl', [
	'MODAL_GENERIC_TYPES',
	function (
		MODAL_GENERIC_TYPES
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		MODAL_GENERIC_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('modalDialog', {
	templateUrl: 'components/modal-dialog/modal-dialog.component.html',
	bindings: {
		modalData: '=',
		modalOptions: '='
	},
	controller: 'modalDialogController',
	transclude: {
		'modalBody': '?modalBody',
		'modalFooter': '?modalFooter',
		'primaryActions': '?modalPrimaryActions',
		'secondaryActions': '?modalSecondaryActions'
	}
})
.controller('modalDialogController', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {

		const hasPrimaryActions = $transclude.isSlotFilled('primaryActions');
		const hasSecondaryActions = $transclude.isSlotFilled('secondaryActions');

		angular.extend($ctrl, {
			hasFooter: hasPrimaryActions || hasSecondaryActions,
			hasPrimaryActions: hasPrimaryActions,
			hasSecondaryActions: hasSecondaryActions,
			isDarkMode: getIsDarkMode($ctrl.modalOptions.theme)
		});
	}

	function getIsDarkMode (theme) {

		switch (theme) {
			case 'is-primary':
				return false;
			default:
				return true;
		}
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);


'use strict';

angular.module('paycircleApp')
.directive('modalMobile', function () {

	return {
		templateUrl: 'components/modal-mobile/modal-mobile.component.html',
		replace: true,
		restrict: 'E',
		controller: 'modalMobileCtrl',
		scope: {
			modalOpen: '=',
			modalClose: '&?',
			modalSubmit: '&?',
			modalSubmitText: '<'
		},
		transclude: {
			'modalBody': '?mmBody',
			'modalActions': '?mmActions'
		}
	};
})
.controller('modalMobileCtrl', ['$scope', function ($scope) {

	$scope.toggleState = function () {

		$scope.modalOpen = !$scope.modalOpen;
	};

	$scope.submit = function () {

		$scope.modalSubmit();
		$scope.modalOpen = false;
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('name', function () {

	return {
		templateUrl: 'components/name/nameComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			companyName: '@?',
			forename: '@?',
			fullName: '<?',
			nameType: '@?', // company || person (default)
			surname: '@?',
		}
	};
});

'use strict';

angular.module('paycircleApp')
.directive('navigationTabs', function () {

	return {
		templateUrl: 'components/navigation-tabs/navigationTabsComponent.html',
		replace: true,
		restrict: 'E',
		transclude: true,
		link: function ($scope) {

			$scope.isOpen = false;
		}
	};
});

'use strict';

angular.module('paycircleApp')
.component('niNumber', {
	bindings: {
		niNumber: '=',
		niNumberDisabled: '<?',
		niNumberName: '@',
		niNumberRequired: '<?'
	},
	controller: 'niNumberCtrl',
	templateUrl: 'components/ni-number/ni-number.component.html',
})
.controller('niNumberCtrl', function () {

	const $ctrl = this;

	function $onInit () {
		angular.extend($ctrl, {
			niNumberDisabled: angular.isDefined($ctrl.niNumberDisabled) ? $ctrl.niNumberDisabled : false,
			niNumberRequired: angular.isDefined($ctrl.niNumberRequired) ? $ctrl.niNumberRequired : true
		});
	}

	function onChange () {
		// Change NI number to uppercase so that it displays correctly after save
		if ($ctrl.niNumber) {
			$ctrl.niNumber = $ctrl.niNumber.toUpperCase();
		}
	}

	angular.extend($ctrl, {
		$onInit,

		onChange
	});
});

'use strict';

angular.module('paycircleApp')
.component('nominalCodeFormField', {
	bindings: {
		index: '=',
		isFinancialsIntegrated: '<',
		nominalCode: '=',
		nominalCodeList: '=',
		showActions: '<?'
	},
	controller: 'nominalCodeFormFieldController',
	require: {
		form: '^form'
	},
	templateUrl: 'components/nominal-code-form-field/nominal-code-form-field.component.html'
})
.controller('nominalCodeFormFieldController', [function () {

	let $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			hasExistingControlAccounts: hasExistingControlAccounts($ctrl.nominalCodeList),
			nominalCodeValueFormFieldId: `nominalCodeValue${$ctrl.index}`,
			nominalCodeNarrativeFormFieldId: `nominalCodeNarrative${$ctrl.index}`,
			nominalCodeOverrideJournalCodeFormFieldId: `nominalCodeOverrideJournalCode${$ctrl.index}` 
		});
		decorateNominalCode($ctrl.nominalCode);
	}

	function decorateNominalCode (nominalCode) {

		angular.extend(nominalCode, {
			confirmDelete: false,
			originalNominalCodeOverrideJournalCode: nominalCode.NominalCodeOverrideJournalCode
		});
	}

	function deleteNominalCode (nominalCode) {

		nominalCode.NominalCodeArchived = true;
	}

	function hasExistingControlAccounts (nominalCodeList) {
		
		return angular.isDefined(nominalCodeList.find(code => {
			return code.NominalCodeOverrideJournalCode;
		}));
	}

	function isUnique (nominalCode, nominalCodeList, nominalCodeAttribute) {

		return !angular.isDefined(nominalCodeList.find(code => {
			return (code !== nominalCode && !code.NominalCodeArchived && code[nominalCodeAttribute] === nominalCode[nominalCodeAttribute]);
		}));
	}

	function onNarrativeChange (nominalCode, formFieldName) {

		for (let i = 0, ii = $ctrl.nominalCodeList.length; i < ii; i++) {
			$ctrl.form[`${formFieldName}${i}`].$setValidity('nonUnique', isUnique(nominalCode, $ctrl.nominalCodeList, 'NominalCodeNarrative'));
		}
	}

	function toggleConfirmDeleteNominalCode (nominalCode) {

		nominalCode.confirmDelete = !nominalCode.confirmDelete;
	}

	angular.extend($ctrl, {
		$onInit,
		deleteNominalCode,
		onNarrativeChange,
		showActions: angular.isDefined($ctrl.showActions) ? $ctrl.showActions : true,
		toggleConfirmDeleteNominalCode
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('nominalCodePreview', {
	bindings: {
		nominalCodesList: '<'
	},
	templateUrl: 'components/nominal-code-preview/nominal-code-preview.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('nominalCodePreviewCode', {
	bindings: {
		nominalCode: '<'
	},
	controller: 'nominalCodePreviewCodeController',
	templateUrl: 'components/nominal-code-preview/nominal-code-preview-code.component.html'
})
.controller('nominalCodePreviewCodeController', [function () {

	let $ctrl = this;

	$ctrl.$onInit = function () {

		angular.extend($ctrl, {
			isExpanded: $ctrl.nominalCode.NominalEntries.length > 0,
			toggleIsExpanded
		});
	};

    function toggleIsExpanded ($ctrl) {

    	if ($ctrl.nominalCode.NominalEntries.length === 0) {
    		return;
    	}

		$ctrl.isExpanded = !$ctrl.isExpanded;
	}
}]);

'use strict';

angular.module('paycircleApp')
.component('note', {
	bindings: {
		noteAction: '&?',
		noteActionIcon: '@?',
		noteAnimation: '@?',
		// Cheese to display in note title. Ignored if no header is specified.
		noteCheese: '@?',
		noteConfirmationField: '=?',
		noteDismiss: '<?',
		noteDismissKey: '@?',
		noteDismissParam: '=?',
		noteEmphasise: '<?',
		noteHasAction: '<?',
		noteHasConfirmation: '<?',
		noteIcon: '@?',
		noteIconSize: '@?',
		noteId: '@?',
		noteOnDismiss: '&?',
		noteTheme: '@?',
		noteTitle: '@?',
	},
	controller: 'noteController',
	templateUrl: 'components/note/note.component.html',
	transclude: {
		'noteItems': '?noteItems',
		'noteColumns': '?noteColumns',
		'noteContent': '?noteContent',
		'noteHeader': '?noteHeader'
	}
})
.controller('noteController', ['$scope', '$transclude', 'utilities', 'LOCAL_STORAGE_KEYS', function ($scope, $transclude, utilities, LOCAL_STORAGE_KEYS) {

	const $ctrl = this;

	function dismissNote (ctrlObj) {

		ctrlObj.isNoteVisible = !ctrlObj.isNoteVisible;

		if (angular.isDefined($ctrl.noteDismissParam)) {
			$ctrl.noteDismissParam = ctrlObj.isNoteVisible;
		}

		if (angular.isDefined(ctrlObj.noteDismissKey)) {
			utilities.addToStoredArray(LOCAL_STORAGE_KEYS.dismissedNotes, ctrlObj.noteDismissKey);
		}

		if (angular.isFunction(ctrlObj.noteOnDismiss)) {
			ctrlObj.noteOnDismiss();
		}
	}

	function getIsNoteVisible (ctrlObj) {

		if (angular.isDefined(ctrlObj.noteDismissKey)) {
			return !utilities.checkStoredArray(LOCAL_STORAGE_KEYS.dismissedNotes, ctrlObj.noteDismissKey);
		}

		return true;
	}

	function toggleActionConfirm (ctrlObj) {
		ctrlObj.showActionConfirm = !ctrlObj.showActionConfirm;
	}

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			dismissNote,
			toggleActionConfirm,

			hasNoteCheese: angular.isDefined($ctrl.noteCheese),
			hasNoteColumns: $transclude.isSlotFilled('noteColumns'),
			hasNoteContent: $transclude.isSlotFilled('noteContent'),
			hasNoteHeader: $transclude.isSlotFilled('noteHeader'),
			hasNoteItems: $transclude.isSlotFilled('noteItems'),
			isNoteVisible: getIsNoteVisible($ctrl),
			noteIconSize: angular.isDefined($ctrl.noteIconSize) ? $ctrl.noteIconSize : 'm',
			noteTheme: angular.isDefined($ctrl.noteTheme) ? $ctrl.noteTheme : 'primary',
			noteEmphasise: angular.isDefined($ctrl.noteEmphasise) ? $ctrl.noteEmphasise : false,
			showActionConfirm: false
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('notificationBar', {
	bindings: {
		tagCopy: '@',
		tagIcon: '@',
		tagTheme: '@'
	},
	templateUrl: 'components/notification-bar/notification-bar.component.html',
	transclude: true
});

'use strict';

angular.module('paycircleApp')
.component('notificationBlock', {
	bindings: {
		icon: '@',
		iconTheme: '@'
	},
	controller: 'notificationBlockCtrl',
	templateUrl: 'components/notification-block/notification-block.component.html',
	transclude: {
		'nbActions': '?nbActions',
		'nbDetails': 'nbDetails'
	},
})
.controller('notificationBlockCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Transclusion logic
		$ctrl.hasActions = $transclude.isSlotFilled('nbActions');
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('notificationCard', {
	bindings: {
		icon: '@?',
		theme: '@?'
	},
	controller: 'notificationCardController',
	templateUrl: 'components/notification-card/notification-card.component.html',
	transclude: {
		'action': '?ncAction',
		'description': '?ncDescription'
	}
})
.controller('notificationCardController', ['$transclude', function ($transclude) {

	let $ctrl = this;

	$ctrl.$onInit = function () {

		angular.extend($ctrl, {
			hasAction: $transclude.isSlotFilled('action'),
			hasDescription: $transclude.isSlotFilled('description'),
			hasIcon: angular.isDefined($ctrl.icon),
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-indifferent'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('notificationPopout', {
	bindings: {
		agencyProfileId: '<',
		userId: '<'
	},
	controller: 'notificationPopoutCtrl',
	templateUrl: 'components/notification-popout/notification-popout.component.html',
})
.controller('notificationPopoutCtrl', [
	'$state',
	'$timeout',
	'config',
	'messageData',
	'session',
	'teamData',
	'MENTION_OPTIONS',
	'MESSAGE_STATUS',
	'MESSAGE_TYPES',
function (
	$state,
	$timeout,
	config,
	messageData,
	session,
	teamData,
	MENTION_OPTIONS,
	MESSAGE_STATUS,
	MESSAGE_TYPES
) {

	const $ctrl = this;

	const POPOUT_TABS = {
		autoRunWarnings: 'auto-run-warnings',
		myMentions: 'my-mentions',
		teamMentions: 'team-mentions',
		updates: 'updates'
	};

	function checkForNotifications ($ctrl) {

		if (session.user && session.getSessionId()) {
			messageData.getMessageCountsPolling($ctrl.userId)
				.then(messageCountObj => {

					const totalNewNotifications = Object.values(messageCountObj).reduce((count, number) => count+number, 0);

					angular.extend($ctrl, {
						hasNewNotifications: totalNewNotifications > 0,
						totalMyMentions: messageCountObj.m_Item1,
						totalAutoRunWarnings: messageCountObj.m_Item2,
						totalUpdates: messageCountObj.m_Item3
					});

					scheduleNextCheck($ctrl);
				})
				.catch(error => {
					// Stop polling on failure (e.g. 401 for a replaced session)
					console.error(error);
					$timeout.cancel($ctrl.timeout);
				});

		} else if (session.user) {

			// SessionID cookie has expired (e.g. device was asleep), skip the call until the session is renewed
			scheduleNextCheck($ctrl);

		} else {

			// Cancel timeout if session is no longer active
			$timeout.cancel($ctrl.timeout);
		}
	}

	function clearAllMessages ($ctrl) {

		setClearAllActionState('loading');

		messageData.markAllMentionsAsRead($ctrl.userId).then(() => {

			$ctrl.myMentions = [];

			resetClearAllActionState();

			checkForNotifications($ctrl);
		})
		.catch(error => {
			console.error(error);
			setClearAllActionState('error');
		});
	}

	function confirmClearAllMessage () {

		setClearAllActionState('confirm-clear');
	}

	function clearAllUpdates ($ctrl) {

		setClearAllActionState('loading');

		messageData.markAllUpdatesAsRead($ctrl.userId).then(() => {

			$ctrl.updates = [];

			resetClearAllActionState();

			checkForNotifications($ctrl);
		})
		.catch(error => {
			console.error(error);
			setClearAllActionState('error');
		});
	}

	function confirmClearAllUpdates () {

		setClearAllActionState('confirm-clear');
	}

	function getAdminsForUser ($ctrl, adminsArr) {
		return adminsArr.filter(adminObj => adminObj.HasMentionsAccess && adminObj.UserID !== $ctrl.userId);
	}

	function goToCompany ($ctrl, state, agencyProfileId) {

		$state.go(state, {agencyProfileId: agencyProfileId });

		togglePopout($ctrl);
	}

	function loadAdmins ($ctrl) {

		if (!$ctrl.teamAdmins) {
			teamData.getTeamMemberAdmins($ctrl.agencyProfileId, $ctrl.userId)
				.then(adminsArr => {

					// Filter out admins that the user doens't have access to
					angular.extend($ctrl, {
						teamAdmins: getAdminsForUser($ctrl, adminsArr)
					});
				})
				.catch(onError);
		}
	}

	function loadAutoRunWarnings ($ctrl) {

		messageData.getMessagesForAlert($ctrl.userId)
			.then(autoRunWarningsArr => {
				$ctrl.autoRunWarnings = autoRunWarningsArr;
			})
			.catch(onError);
	}

	function loadDataForActiveTab ($ctrl) {

		switch ($ctrl.activeTab) {
			case POPOUT_TABS.myMentions:
				loadMentions($ctrl);
				break;

			case POPOUT_TABS.teamMentions:
				resetTeamMentions($ctrl);
				break;

			case POPOUT_TABS.updates:
				loadUpdates($ctrl);
				break;

			case POPOUT_TABS.autoRunWarnings:
				loadAutoRunWarnings($ctrl);
				break;
		}
	}

	function loadMentions ($ctrl) {

		messageData.getMessagesForMention($ctrl.agencyProfileId, $ctrl.userId).then(mentionsArr => {
			$ctrl.myMentions = mentionsArr;
		})
		.catch(onError);
	}

	function loadUpdates (ctrlObj) {

		messageData.getMessagesForUpdate(ctrlObj.userId).then(updatesArr => {
			ctrlObj.updates = updatesArr;
		})
		.catch(onError);
	}

	function loadMentionsForAdmin ($ctrl, adminObj) {

		$ctrl.selectedAdmin = adminObj;

		if (!adminObj.mentions) {
			messageData.getMessagesForMention($ctrl.agencyProfileId, adminObj.UserID)
				.then(mentionsArr => {
					adminObj.mentions = mentionsArr;
				})
				.catch(onError);
		}
	}

	function onClickElsewhere ($ctrl) {
		$ctrl.popoutOpen = false;
		resetPopout($ctrl);
	}

	function onError (error) {
		console.error(error);
		$ctrl.hasError = true;
	}

	function resetClearAllActionState () {

		setClearAllActionState(null);
	}

	function resetPopout ($ctrl) {
		angular.extend($ctrl, {
			activeTab: POPOUT_TABS.myMentions,
			selectedAdmin: null
		});
	}

	function resetTeamMentions ($ctrl) {
		$ctrl.selectedAdmin = null;
	}

	function scheduleNextCheck ($ctrl) {

		if (!$ctrl.popoutOpen && !$ctrl.isDestroyed) {
			$timeout.cancel($ctrl.timeout);
			$ctrl.timeout = $timeout(() => {
				checkForNotifications($ctrl);
			}, config.timeToPollForNotifications*60*1000);
		}
	}

	function setActiveTab ($ctrl, newActiveTab) {

		if ($ctrl.activeTab === newActiveTab) {
			return;
		}

		$ctrl.activeTab = newActiveTab;
		loadDataForActiveTab($ctrl);
	}

	function setClearAllActionState (clearAllActionState) {
		$timeout(() => {
			$ctrl.clearAllActionState = clearAllActionState;
		});
	}

	function togglePopout ($ctrl) {

		$ctrl.popoutOpen = !$ctrl.popoutOpen;

		if ($ctrl.popoutOpen) {
			checkForNotifications($ctrl);
			loadDataForActiveTab($ctrl);
			loadAdmins($ctrl);
		} else {
			resetPopout($ctrl);
		}
	}

	function updateMessageStatus ($ctrl, messageObj, messageIndex, messageTypeList) {

		// Remove message from index to prevent having to wait for http request
		$timeout(() => {
			messageTypeList.splice(messageIndex, 1);
		});

			messageData.updateMessageStatus(messageObj.MessageID, MESSAGE_STATUS.read).then(() => {
			checkForNotifications($ctrl);
		})
		.catch(error => {

 			// Re-insert message
 			messageTypeList.splice(messageIndex, 0, messageObj);

 			console.error(error);
 		});
 	}

	$ctrl.$onInit = function () {
		checkForNotifications($ctrl);
	};

	$ctrl.$onDestroy = function () {
		$ctrl.isDestroyed = true;
		$timeout.cancel($ctrl.timeout);
	};

	angular.extend($ctrl, {
		MENTION_OPTIONS,
		MESSAGE_TYPES,
		POPOUT_TABS,

		activeTab: POPOUT_TABS.myMentions,
		autoRunWarnings: null,
		myMentions: null,
		selectedAdmin: null,

		clearAllMessages,
		clearAllUpdates,
		confirmClearAllMessage,
		confirmClearAllUpdates,
		goToCompany,
		loadMentionsForAdmin,
		resetTeamMentions,
		onClickElsewhere,
		resetClearAllActionState,
		setActiveTab,
		togglePopout,
		updateMessageStatus
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('numberPicker', ['utilities', function (utilities) {

	return {
		templateUrl: 'components/number-picker/numberPickerComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			fieldName: '@?',
			figureType: '@?',
			heading: '@',
			isDisabled: '<?',
			isEditable: '@?',
			max: '<?',
			min: '<?',
			minTotal: '<?',
			ngModel: '=',
			ngModelOptions: '<?',
			ngPattern: '<?',
			npOnChange: '&?',
			step: '<?',
			subHeading: '@?',
			theme: '<?',
			totalWith: '=?'
		},
		link: function ($scope) {

			$scope.figureType 	= $scope.figureType !== undefined ? $scope.figureType : 'percentage'; // percentage|monetary
			$scope.isEditable 	= $scope.isEditable !== undefined ? $scope.isEditable : false;
			$scope.ngModel 		= $scope.ngModel !== undefined ? $scope.ngModel : 0;
			$scope.max 			= $scope.max !== undefined ? parseFloat($scope.max) : 0;
			$scope.min 			= $scope.min !== undefined ? parseFloat($scope.min) : 0;
			$scope.minTotal 	= $scope.minTotal !== undefined ? parseFloat($scope.minTotal) : 0;
			$scope.step 		= $scope.step !== undefined ? parseFloat($scope.step) : 0.1;
			$scope.totalWith 	= $scope.totalWith !== undefined ? parseFloat($scope.totalWith) : null;

			function updateDisabledStates () {

				$scope.incrementDisabled = $scope.ngModel === undefined || $scope.ngModel >= $scope.max;
				$scope.decrementDisabled = $scope.ngModel === undefined || $scope.ngModel <= $scope.min; // undefined if validation fails
			}

			// Scope
			$scope.decrement = function () {

				if ($scope.ngModel > $scope.min) {
					$scope.ngModel = utilities.roundTo($scope.ngModel - $scope.step, 2);
				}

				if ($scope.ngModel < $scope.min) {
					$scope.ngModel = $scope.min;
				}
			};

			$scope.increment = function () {

				if ($scope.ngModel < $scope.max) {
					$scope.ngModel = utilities.roundTo($scope.ngModel + $scope.step, 2);
				}

				if ($scope.ngModel > $scope.max) {
					$scope.ngModel = $scope.max;
				}
			};

			// Scope watchers
			if ($scope.totalWith) {

				$scope.$watch('totalWith', function (newValue) {

					if (newValue >= $scope.minTotal) {
						$scope.min = 0;
					}

					else {
						$scope.min = $scope.minTotal - newValue;
					}

					if ($scope.ngModel < $scope.min) {
						$scope.ngModel = $scope.min;
					}

					updateDisabledStates();
				});
			}

			$scope.$watch('ngModel', function (newValue, oldValue) {

				updateDisabledStates();

				if (newValue !== oldValue && newValue !== '' && newValue !== undefined && newValue) {

					if ($scope.npOnChange !== undefined) {

						$scope.npOnChange();
					}
				}
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('officeLocationCard', {

	bindings: {
		agencyProfileId: '=',
		ipAddress: '<',
		refresh: '&?'
	},
	controller: 'officeLocationCardCtrl',
	templateUrl: 'components/office-location-card/office-location-card.component.html'
})

.controller('officeLocationCardCtrl', ['$rootScope', function ($rootScope) {

	const $ctrl = this;

	function openDeleteOfficeLocationForm (ctrlObj, ipAddress) {

		ctrlObj.showActionMenu = false;

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.refresh(),
			contextType: 'company',
			formKey: 'delete-office-location',
			officeLocation: ipAddress
		});
	}

	function openEditDetailsForm (ctrlObj, ipAddressId) {

		ctrlObj.showActionMenu = false;

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.refresh(),
			contextType: 'company',
			formKey: 'company-settings-add-office-locations',
			ipAddressId,
			title: 'Add office locations'
		});
	}

	angular.extend($ctrl, {
		// Variables
		showActionMenu: false,

		// Functions
		openDeleteOfficeLocationForm,
		openEditDetailsForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('officeLocationFormField', {

	bindings: {
		index: '=?',
		ipAddress: '<',
		onDelete: '&',
		name: '@',
		showDelete: '<?'
	},
	controller: 'officeLocationFormFieldCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/office-location-form-field/office-location-form-field.component.html'
})

.controller('officeLocationFormFieldCtrl', ['utilities', function (utilities) {

	const IP_ADDRESS_RANGE_INVALID = 'ipAddressRangeInvalid';

	const $ctrl = this;

	$ctrl.$onInit = function () {

		// Build up form field names. It just makes life easier, and less error-prone.
		$ctrl.descriptionFieldName = `${$ctrl.name}_${$ctrl.index}_description`;
		$ctrl.valueStartFieldName = `${$ctrl.name}_${$ctrl.index}_value-start`;
		$ctrl.valueEndFieldName = `${$ctrl.name}_${$ctrl.index}_value-end`;

		// Delete confirmation, hidden initially
		$ctrl.ipAddress.confirmOfficeLocationDelete = false;
	};

	function deleteOfficeLocation (ctrlObj) {

		if (angular.isFunction(ctrlObj.onDelete)) {
			ctrlObj.onDelete();
		}
	}

	function onIPAddressRangeChange (ctrlObj, ipAddressStart, ipAddressEnd) {

		const ipAddressRangeCheck = utilities.compareIPAddresses (ipAddressStart, ipAddressEnd);

		/* Range valid will default to true if either or both of the addresses aren't specified, in which
		   case other validation will apply. */
		let rangeValid = true;
		if (ipAddressRangeCheck) {
			rangeValid = (ipAddressRangeCheck !== 1);
		}

		/* Set validity on first IP address. One has to change, so might as well make it the first,
		   plus it looks better in the UI */
		ctrlObj.form[ctrlObj.valueStartFieldName].$setValidity(IP_ADDRESS_RANGE_INVALID, rangeValid);
		ctrlObj.form[ctrlObj.valueStartFieldName].$setTouched(true);
	}

	function toggleConfirmDeleteOfficeLocation (ipAddress) {
		ipAddress.confirmOfficeLocationDelete = !ipAddress.confirmOfficeLocationDelete;
	}

	angular.extend($ctrl, {
		deleteOfficeLocation,
		onIPAddressRangeChange,
		toggleConfirmDeleteOfficeLocation
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('onboardingCard', function () {

	return {
		controller: 'onboardingCardController',
		templateUrl: 'components/onboarding-card/onboardingCardComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			onboardingQuestionGroup: '=',
			onboardingTeamMembersCount: '<',
			onboardingActions: '=',
			onClick: '='
		}
	};
})
.controller('onboardingCardController', ['$scope', 'ONBOARDING_QUESTION_GROUPS', function ($scope, ONBOARDING_QUESTION_GROUPS) {

	$scope.ONBOARDING_QUESTION_GROUPS = ONBOARDING_QUESTION_GROUPS;
}]);

'use strict';

angular.module('paycircleApp')
.component('overlayForm', {
	bindings: {
		onClose: '&',
	},
	controller: 'overlayFormCtrl',
	templateUrl: 'components/overlay-form/overlay-form.component.html',
	transclude: {
		'header': '?overlayFormHeader',
		'main': '?overlayFormMain',
		'preMain': '?overlayFormPreMain'
	}
})
.controller('overlayFormCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		$ctrl.hasClose = angular.isDefined($ctrl.onClose);
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('overviewCard', {
	bindings: {
		details: '<',
		overviewData: '<',
		theme: '@'
	},
	controller: 'overviewCardCtrl',
	templateUrl: 'components/overview-card/overview-card.component.html',
	transclude: {
		'footerActions': '?ocFooterActions'
	}
})
.controller('overviewCardCtrl', [
	'config',
	'$transclude',
	function (
		config,
		$transclude
	) {

	const $ctrl = this;
	const detailsDefaults = {
		header: {
			tag: '12 days to go',
			icon: 'wallet',
			iconTheme: 'is-white-transparent',
			subtitle: 'Pay day',
			title: 'Fri 25 Jul',
			layout: 'bar', // bar || doughnut
		},
		main: {
			barPercentage: 0
		}
	};

	function $onInit () {

		angular.extend($ctrl, {
			details: getOverviewCardDetails(),
			hasFooterActions: $transclude.isSlotFilled('footerActions'),
			theme: $ctrl.theme || 'is-style-a' // 'is-style-a' || 'is-style=b'
		});

		// Set up Pie Chart
		if ($ctrl.details.header.layout === 'doughnut') {

			// Wait for element to render before loading chart
			angular.element(() => {

				const ctx = document.getElementById('overview-card_doughnut');

				$ctrl.doughnutChart = new Chart(
					ctx,
					{
						type: 'doughnut',
						data: $ctrl.details.header.chartData,
						options: {
							animation: {
								delay: 500 // Delay chart load to show animation properly
							},
							cutout: '68%',
							layout: {
								padding: 5
							},
							plugins: {
								legend: {
									display: false
								},
								tooltip: {
									bodyFont: {
							        	family: config.fontFamilyAlpha
							        },
									displayColors: false
								}
							}
						}
					}
				);

			});
		}
	}

	function getOverviewCardDetails () {

		angular.extend(detailsDefaults, $ctrl.details);

		return detailsDefaults;
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('overviewData', function () {

	return {
		templateUrl: 'components/overview-data/overviewDataComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			overviewGroups: '=',
			onEdit: '='
		}
	};
});

'use strict';

angular.module('paycircleApp')
	.component('p11dbSubmissionsCard',{

		bindings: {
			p11dbSubmission: '=?',
			agencyProfileId: '<',
			refreshSubmissions: '=',
		},
		controller: 'p11dbSubmissionsCardController',
		templateUrl: 'components/p11db-submissions-card/p11db-submissions-card.html',
	})

	.controller('p11dbSubmissionsCardController', [
		'$rootScope',
		'reportData',
		'reportsService',
		'RTI_SUBMISSION_REPORT_TYPE_BITWISE',
		'SUBMISSION_STATES',
		function (
			$rootScope,
			reportData,
			reportsService,
			RTI_SUBMISSION_REPORT_TYPE_BITWISE,
			SUBMISSION_STATES
		) {

			const $ctrl = this;
			function $onInit () {

				const isViewSubmissionFileOptionVisible =
					$ctrl.p11dbSubmission.P11DbSubmissionFinaliseState === SUBMISSION_STATES.submitted ||
					$ctrl.p11dbSubmission.P11DbSubmissionFinaliseState === SUBMISSION_STATES.failed;

				angular.extend($ctrl, {
					isContinueOptionVisible: $ctrl.p11dbSubmission.CanUpdate,
					isDeleteOptionVisible: $ctrl.p11dbSubmission.CanDelete,
					isViewSubmissionFileOptionVisible,
					reportViewState: 'loading',
				});

				//determine card theme based on status
				switch ($ctrl.p11dbSubmission.P11DbSubmissionFinaliseState){
					case SUBMISSION_STATES.unsubmitted:
						$ctrl.state='Draft';
						$ctrl.theme='is-indifferent';
						break;
					case SUBMISSION_STATES.submitted:
						$ctrl.state='Submitted';
						$ctrl.theme='is-primary';
						break;
					case SUBMISSION_STATES.failed:
						$ctrl.state='Submission failed';
						$ctrl.theme='is-quinary';
						break;
					default:
						$ctrl.theme='is-primary';
						break;
				}
			}

			function refreshCards () {
				if (angular.isFunction($ctrl.refreshSubmissions)) {
					$ctrl.refreshSubmissions();
				}
			}

			function openDeleteConfirmationView () {
				$rootScope.openSlideInForm({
					agencyProfileId: $ctrl.agencyProfileId,
					callback: refreshCards,
					formKey: 'company-settings-p11db-submission-delete',
					initCallbackOnClose: true,
					p11dbSubmission: $ctrl.p11dbSubmission,
				});
			}

			function editP11DbSubmission (p11dbSubmissionObj) {
				$rootScope.openSlideInForm({
					agencyPayPeriodId: p11dbSubmissionObj.AgencyPayPeriodID,
					agencyProfileId: $ctrl.agencyProfileId,
					callback: refreshCards,
					formKey: 'company-settings-p11d-submission',
					initCallbackOnClose: true
				});
			}

			function viewSubmissionFile (report) {

				reportsService.openReport(
					report,
					{ agencyProfileId: $ctrl.agencyProfileId }
				);
			}

			function getReportForP11Db () {

				if ($ctrl.reportViewState !== 'loading' || !$ctrl.isViewSubmissionFileOptionVisible) {
					return;
				}

				const agencyProfileId = $ctrl.agencyProfileId;
				const agencyPayPeriodId = $ctrl.p11dbSubmission.AgencyPayPeriodID;
				const p11dbSubmissionId = $ctrl.p11dbSubmission.P11DbSubmissionID;
				const rtiSubmissionReportType = RTI_SUBMISSION_REPORT_TYPE_BITWISE.p11db;

				reportData.getRTISubmissionReports(agencyProfileId, agencyPayPeriodId, undefined, p11dbSubmissionId, rtiSubmissionReportType)
				.then(reportsArr => {

					angular.extend($ctrl, {
						reports: reportsArr,
						reportViewState: 'ready',
						isViewSubmissionFileOptionVisible: reportsArr.length > 0
					});
				})
				.catch(onError);
			}

			function onError (error) {
				$ctrl.reportViewState = 'error';
				console.error(error);
			}

			angular.extend($ctrl, {
				$onInit,
				editP11DbSubmission,
				getReportForP11Db,
				openDeleteConfirmationView,
				viewSubmissionFile
			});
		}
	]);

'use strict';

angular.module('paycircleApp')
.directive('pageTemplateAHeader', function () {

	return {
		templateUrl: 'components/page-template-a-header/pageTemplateAHeaderComponent.html',
		controller: 'pageTemplateAHeaderCtrl',
		replace: true,
		restrict: 'E',
		scope: {
			emoji: '@?',
			icon: '@?',
			pageSubTitle: '@',
			pageTitle: '@',
			secondaryContentType: '@?',
			showBreadcrumb: '<?',
			showSecondaryContent: '<?',
			theme: '@?'
		},
		transclude: {
			'breadcrumb': '?ptBreadcrumb',
			'secondaryContent': '?ptSecondary',
			'subHeading': '?ptSubHeading',
			'titleMenu': '?ptTitleMenu'
		}
	};
})
.controller('pageTemplateAHeaderCtrl', ['$scope', '$transclude', function ($scope, $transclude) {

	// Scope
	$scope.hasSubTitle 			= $scope.pageSubTitle !== undefined ? $scope.pageSubTitle : null;
	$scope.secondaryContentType = $scope.secondaryContentType !== undefined ? $scope.secondaryContentType : 'actions';
	$scope.showBreadcrumb 		= $scope.showBreadcrumb !== undefined ? $scope.showBreadcrumb : 'actions';
	$scope.showSecondaryContent = $scope.showSecondaryContent !== undefined ? $scope.showSecondaryContent : true;
	
	// Transcludes
	$scope.hasBreadcrumb 		= $transclude.isSlotFilled('breadcrumb');
	$scope.hasSecondaryContent 	= $transclude.isSlotFilled('secondaryContent');
	$scope.hasSubHeading 		= $transclude.isSlotFilled('subHeading');
	$scope.hasTitleMenu 		= $transclude.isSlotFilled('titleMenu');
}]);

'use strict';

angular.module('paycircleApp')
.directive('pageTemplateCHeader', function () {

	return {
		templateUrl: 'components/page-template-c-header/pageTemplateCHeaderComponent.html',
		controller: 'pageTemplateCHeaderCtrl',
		replace: true,
		restrict: 'E',
		scope: {
			icon: '@?',
			emoji: '@?',
			pageTitle: '@',
			pageSubTitle: '@',
			secondaryContentType: '@?',
			showBreadcrumb: '<?',
			showSecondaryContent: '<?',
			showTertiaryContent: '<?'
		},
		transclude: {
			'actionMenu': '?ptActionMenu',
			'breadcrumb': '?ptBreadcrumb',
			'secondaryContent': '?ptSecondary',
			'subHeading': '?ptSubHeading',
			'tertiaryContent': '?ptTertiary',
			'totalCost': '?ptTotalCost'

		}
	};
})
.controller('pageTemplateCHeaderCtrl', ['$scope', '$transclude', function ($scope, $transclude) {

	// Scope
	$scope.hasSubTitle 			= $scope.pageSubTitle !== undefined ? $scope.pageSubTitle : null;
	$scope.secondaryContentType = $scope.secondaryContentType !== undefined ? $scope.secondaryContentType : 'actions';
	$scope.showBreadcrumb 		= $scope.showBreadcrumb !== undefined ? $scope.showBreadcrumb : 'actions';
	$scope.showSecondaryContent = $scope.showSecondaryContent !== undefined ? $scope.showSecondaryContent : true;
	$scope.showTertiaryContent 	= $scope.showTertiaryContent !== undefined ? $scope.showTertiaryContent : true;
	$scope.tertiaryContentType 	= $scope.tertiaryContentType !== undefined ? $scope.tertiaryContentType : 'actions';
	
	// Transcludes
	$scope.hasActionMenu 		= $transclude.isSlotFilled('actionMenu');
	$scope.hasBreadcrumb 		= $transclude.isSlotFilled('breadcrumb');
	$scope.hasSecondaryContent 	= $transclude.isSlotFilled('secondaryContent');
	$scope.hasSubHeading 		= $transclude.isSlotFilled('subHeading');
	$scope.hasTertiaryContent 	= $transclude.isSlotFilled('tertiaryContent');
	$scope.hasTotalCost 		= $transclude.isSlotFilled('totalCost');
}]);

'use strict';

angular.module('paycircleApp')
.component('paycirclePermissionTool', {
	bindings: {
		currentUser: '<'
	},
	controller: 'paycirclePermissionToolCtrl',
	templateUrl: 'components/paycircle-permission-tool/paycircle-permission-tool.component.html',
})
.controller('paycirclePermissionToolCtrl', [
	'paycircleService',
	function (
		paycircleService
	) {

	const $ctrl = this;

	const RECORDER_STATES = {
		waiting: 'waiting',
		recording: 'recording'
	};

	function $onInit () {

		if (paycircleService.permissionTracking.getIsTrackingEnabled()) {
			setRecorderState(RECORDER_STATES.recording);
		}
		else {
			setRecorderState(RECORDER_STATES.waiting);
		}
	}

	function onRecordingEnd () {

		paycircleService.permissionTracking.disableTracking();

		setRecorderState(RECORDER_STATES.waiting);
	}

	function onRecordingOutput () {

		const recordingsArr = paycircleService.permissionTracking.getStoredPermissions();

		console.log(recordingsArr);
	}

	function onRecordingReset () {

		paycircleService.permissionTracking.resetStore();
	}

	function onRecordingStart () {

		setRecorderState(RECORDER_STATES.recording);

		paycircleService.permissionTracking.enableTracking();
	}

	function setRecorderState (newState) {
		$ctrl.recorderState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		RECORDER_STATES,

		onRecordingEnd,
		onRecordingOutput,
		onRecordingStart,
		onRecordingReset,

		getStoredPermissionLength: paycircleService.permissionTracking.getStoredPermissionLength
	});
}]);

'use strict';

angular.module('paycircleApp')
.controller('PayslipCtrl', [
	'$filter',
	'$q',
	'$scope',
	'$state',
	'$stateParams',
	'$timeout',
	'$window',
	'adjustmentsService',
	'base',
	'companyData',
	'config',
	'dataTransfer',
	'dateService',
	'payslipService',
	'travel',
	'userData',
	'utilities',
	'ADJUSTMENT_TYPES',
	'INTERFACE_TYPES',
	'JOB_STATUS_LABELS',
	'PAYSLIP_TOOLTIPS',
	'PENSION_TYPES',
	'REPAYMENT_SCHEDULE_TYPES',
	function (
		$filter,
		$q,
		$scope,
		$state,
		$stateParams,
		$timeout,
		$window,
		adjustmentsService,
		base,
		companyData,
		config,
		dataTransfer,
		dateService,
		payslipService,
		travel,
		userData,
		utilities,
		ADJUSTMENT_TYPES,
		INTERFACE_TYPES,
		JOB_STATUS_LABELS,
		PAYSLIP_TOOLTIPS,
		PENSION_TYPES,
		REPAYMENT_SCHEDULE_TYPES
	) {

	let agencyProfileId = $stateParams.agencyProfileId;
	let payPeriodId = $stateParams.payPeriodId;
	let userId = $stateParams.userId;

	const userPaymentId = $stateParams.userPaymentId;
	const authString = $stateParams.authString; // Slack integration
	const userDocumentTypeId = $stateParams.userDocumentTypeId;
	// This is optional. It should be defined as a non-empty guid when userDocumentTypeId isn't standard 'payStatement'
	const supplementaryPaymentId = $stateParams.supplementaryPaymentId;

	let adjustmentTotal = 0;

	function closeDropdown (object) {

		object.isActive 		= false;
		$scope.activeDropdown 	= '';
	}

	function init () {

		setPageState('loading');

		checkAuthentication().then(authResponseObj => {

			// Use values from authentication if populated
			if (angular.isDefined(authResponseObj)) {
				agencyProfileId = authResponseObj.agencyProfileId;
				userId = authResponseObj.userId;
				payPeriodId = authResponseObj.payPeriodId;
			}

			const getAgencyProfileCompanyDetailsUser = companyData.getAgencyProfileCompanyDetailsUser(userId, agencyProfileId);
			// Get payment depending on type
			let getPayment;
			// Is this a supplementary payment of some sort (combined or single?)
			if (supplementaryPaymentId && supplementaryPaymentId !== config.guidEmpty) {
				// Supplementary pay statement - single or combined
				getPayment = userData.getTeamMemberSupplementaryPayment(userId, agencyProfileId, supplementaryPaymentId, userDocumentTypeId);
			}
			else {
				// Standard pay statement
				getPayment = userData.getTeamMemberPayment(agencyProfileId, userId, payPeriodId, userPaymentId, authString);
			}

			const getCompanyCustomisation = companyData.getCompanyCustomisationToUse(agencyProfileId);
			const getTeamMemberAddressDetail = travel.getTeamMemberAddressDetail(userId);

			$q.all([
				getAgencyProfileCompanyDetailsUser,
				getPayment,
				getCompanyCustomisation,
				getTeamMemberAddressDetail
			]).then(([
				companiesArr,
				payslip,
				customisationObj,
				addressDetailObj
			]) => {

				const companyObj = companiesArr.find(company => company.AgencyProfileID === agencyProfileId);
				const isCISPayStatement = payslip.Personal.IsCISSubcontractor;

				if (angular.isUndefined(companyObj)) {
					console.error('Unable to load company information');
					setPageState('error');
					return;
				}

				// ... Set window title to something meaningful, so when saving to PDF the file has a name that corresponds to the payslip
				$window.document.title = `${payslip.Personal.Surname}, ${payslip.Personal.Forename} Payslip ${$filter('dateformat')(payslip.PayPeriod.PayDateISO)}`;
				/* ... set 'showLogo' flag. If the default is in use, don't show it. This is a little bit nasty, but we're checking
					for the default image URL. A custom URL will have an AgencyProfileID stuffed in between paycircle.blob.core.windwos.net
					and paycircle in the path */
				payslip.showLogoForPrintablePayslip = !customisationObj.Payslips.LogoURL.includes('windows.net/paycircle');

				// CIS
				if (isCISPayStatement) {

					payslip.CIS.costOfMaterials = 0;
					payslip.CIS.deduction = 0;

					for (var i = payslip.Adjustments.length - 1; i >= 0; i--) {
						switch (payslip.Adjustments[i].AdjustmentDescription) {
							case 'Cost of Materials':
								payslip.CIS.costOfMaterials = payslip.Adjustments[i].AdjustmentValue;
								break;
							case 'CIS Deduction':
								payslip.CIS.deduction = payslip.Adjustments[i].AdjustmentValue;
								break;
						}
					}

					companyObj.Address.AddressBusinessName = companyObj.Name;
					payslip.CIS.DeductionRateDescription = payslip.CIS.TaxTreatment === 0 ? 'higher rate' : payslip.CIS.TaxTreatment === 1 ? 'gross rate' : 'standard rate';
				}

				// Determine 'Salary' label. This will differ for furloughed, partnership and off-payroll workers
				let salaryLabel = 'Salary';
				if (payslip.Personal.IsFurloughed) {
					salaryLabel = 'Furlough pay';
				}
				else if (payslip.PayPeriod.IsPartnership) {
					salaryLabel = 'Profit share';
				}
				else if (payslip.Personal.IsOffPayrollWorker) {
					salaryLabel = 'Deemed payment';
				}
				payslip.salaryLabel = salaryLabel;

				// Determine salary detail. Present when salary paid by currency
				if (payslip.Salary.SalaryHasCurrency) {
					// Build salary detail
					payslip.salaryDetail = `${payslip.Salary.SalaryForeignValue} ${payslip.Salary.CurrencyLabel} (Ex. ${payslip.Salary.CurrencyValue})`;
				}

				// Gross up adjustments
				payslip.grossUpAdjustments = adjustmentsService.getGrossUpAdjustmentsForPayslip(payslip);

				// Decorate adjustments.
				if (payslip.Adjustments) {
					payslip.Adjustments = adjustmentsService.decorateAdjustments(payslip.Adjustments);

					// PayPointAdjustments is now provided directly by the backend
					if (payslip.PayPointAdjustments) {
						payslip.PayPointAdjustments = adjustmentsService.decorateAdjustments(payslip.PayPointAdjustments);
					}

					payslip.PensionAdjustments = adjustmentsService.decorateAdjustments(payslip.PensionAdjustments);
					payslip = adjustmentsService.createAdjustmentsForPrintablePayslip(payslip);
					payslip.paginatedPayslip = adjustmentsService.createPaginatedPayslipPages(payslip);

					// Calculate total hours and days from shift components.
					// Days are counted as distinct calendar dates (not summed units) because
					// multiple daily-rate components can share the same date (e.g. standard + overtime),
					// and the business requirement is to show the number of unique days worked.
					let totalShiftHours = 0;
					const dailyRateDates = new Set();
					payslip.Adjustments.forEach(adjustment => {
						if (adjustment.Components && adjustment.Components.length > 0) {
							adjustment.Components.forEach(component => {
										if (component.isDailyRate) {
										const dateOnly = dateService.parseAspNetDate(component.ComponentDate);
										if (dateOnly) {
											dailyRateDates.add(dateOnly);
										}
								} else {
									totalShiftHours += component.Units || 0;
								}
							});
						}
					});
					payslip.totalShiftHours = totalShiftHours;
					payslip.totalShiftDays = dailyRateDates.size;
				}
				if (payslip.Pensions) {
					// Split pensions into two lists - one for contributions, one for refunds, for separate display in the UI
					payslip.pensionLists = [];
					payslip.pensionLists.push({
						heading: 'Pension contributions',
						pensions: payslip.Pensions.filter(pensionObj => !pensionObj.EmployeePensionIsRefund)
					});
					payslip.pensionLists.push({
						heading: 'Pension refunds',
						pensions: payslip.Pensions.filter(pensionObj => pensionObj.EmployeePensionIsRefund)
					});
				}

				// Calculate total adjustments
				adjustmentTotal = Math.round(adjustmentTotal * 100) / 100;
				const adjustmentSymbol = adjustmentTotal > 0 ? '+' : adjustmentTotal === 0 ? '' : '-';
				payslip.adjustmentTotalLabel = adjustmentSymbol + '£' + Math.abs(adjustmentTotal);

				// Allow PDF download, set in state config
				let allowPDFDownload = false;
				if (angular.isDefined($state.current.data)) {
					allowPDFDownload = angular.isDefined($state.current.data.allowPDFDownload) ? $state.current.data.allowPDFDownload : false;
				}

				// Scope VM
				angular.extend($scope, {
					vm: {
						address: addressDetailObj.HasForeignAddress ? addressDetailObj.ForeignAddress : addressDetailObj.Address,
						allowPDFDownload,
						company: companyObj,
						customisation: customisationObj,
						// Additional Note Display
						isAdditionalNoteVisible: payslipService.getAdditionalNoteVisibilityBoolFromEnumForOnlinePayslip(payslip.PayPeriod.PayslipAdditionalNoteVisible),
						isCISPayStatement,
						// Pay Period Display
						isPayslipPeriodVisible: payslipService.getPeriodVisiblityBoolFromEnumForOnlinePayslip(payslip.PayPeriod.PayslipPeriodVisible),
						payslip,
						// Tooltips states
						showPrintableTooltip: false,
						showDownloadTooltip: false,
						// Initial view is online payslip
						viewPrintablePayslip: false
					}
				});

				setPageState('ready');
			})
			.catch(error => {
				setPageState('error');
				console.error(error);
			});

		})
		.catch(error => {
			$state.go('login');
			console.error('Unable to authenticate user, redirected to sign in', error);
		});

	}

	function checkAuthentication () {

		return $q((resolve, reject) => {

			/* Check authentication is only applicable to Slack integration in User Portal;
			   the paystatement state exists there */
			if (!$state.includes('paystatement')) {
				resolve();
			}

			// Slack integration
			if (angular.isDefined(authString)) {
				base.decrypt(authString).then(decryptString => {

					const GUIDS = decryptString.split('/');
					agencyProfileId = GUIDS[0];
					userId = GUIDS[1];
					payPeriodId = GUIDS[2];

					resolve({
						agencyProfileId,
						payPeriodId,
						userId
					});
				})
				.catch(error => {
					reject(error);
				});
			}

			// Auth string not defined
			else {
				reject();
			}
		});

	}

	function openBrowserPrintDialog (vmObj) {
		/* Switch to printable payslip if online is active. Print dialog opens in a timeout to allow
		   a delay to be introduced when switching to printable payslip view */
		const timeoutWait = vmObj.viewPrintablePayslip ? 0 : 200;
		if (!vmObj.viewPrintablePayslip) {
			vmObj.viewPrintablePayslip = true;
		}
		// Open print dialog
		$timeout(() => {
			$window.print();
		}, timeoutWait);
	}

	function showDownloadTooltip (vmObj) {
		vmObj.showDownloadTooltip = true;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function showPrintableTooltip (vmObj) {
		vmObj.showPrintableTooltip = true;
	}

	function toggleDropdown (object, dropdownId) {

		object.isActive 		= !object.isActive;
		$scope.activeDropdown 	= object.isActive ? dropdownId : null;
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_TYPES,
		INTERFACE_TYPES,
		JOB_STATUS_LABELS,
		PAYSLIP_TOOLTIPS,
		PENSION_TYPES,
		REPAYMENT_SCHEDULE_TYPES,

		agencyProfileId,
		payPeriodId,
		supplementaryPaymentId,
		userDocumentTypeId,
		userId,
		userPaymentId,

		config,
		closeDropdown,
		downloadFile: dataTransfer.downloadFile,
		goBack: utilities.goBack,
		openBrowserPrintDialog,
		showDownloadTooltip,
		showPrintableTooltip,
		toggleDropdown
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('payElementTypeCard', [
	'$rootScope',
	'INTERFACE_TYPES',
	function (
		$rootScope,
		INTERFACE_TYPES
	) {

	return {
		templateUrl: 'components/pay-element-type-card/pay-element-type-card.component.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			hasActions: '<?',
			onUpdate: '=?',
			onViewDetails: '=?',
			payElementType:	'<'
		},
		link: function ($scope) {

			var agencyProfileId = $scope.agencyProfileId;
			var onUpdate = $scope.onUpdate;

			$scope.INTERFACE_TYPES = INTERFACE_TYPES;
			$scope.hasActions = $scope.hasActions !== undefined ? $scope.hasActions : false;
			$scope.vm = {
				showMenu: false
			};

			$scope.openDuplicatePayElementForm = function (payElementObj) {

				$rootScope.openSlideInForm({
					agencyProfileId: agencyProfileId,
					callback: onUpdate,
					formKey: 'duplicate-pay-element',
					payElementObj: payElementObj
				});
			};

			$scope.openDeletePayElementForm = function (payElementObj) {

				$rootScope.openSlideInForm({
					agencyProfileId: agencyProfileId,
					callback: onUpdate,
					formKey: 'delete-pay-element',
					payElementObj: payElementObj
				});
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('payElementTypeCardBasic', {
	templateUrl: 'components/pay-element-type-card/pay-element-type-card-basic.component.html',
	bindings: {
		description: '@?',
		isDeduction: '<',
		label: '<',
		theme: '@?'
	}
});

'use strict';

angular.module('paycircleApp')
.directive('payElementTypeRow', [
	'ADJUSTMENT_BEHAVIOUR_STATES',
	function (
		ADJUSTMENT_BEHAVIOUR_STATES
	) {

	return {
		templateUrl: 'components/pay-element-type-row/payElementTypeRowComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			isPensionOnly: '<?',
			onEditPayElement: '=',
			payElementType:	'<',
			payElementTypeGroup: '=',
			payElementTypeIndex: '<',
		},
		link: function ($scope) {

			angular.extend($scope, {
				ADJUSTMENT_BEHAVIOUR_STATES,
				isPensionOnly: angular.isDefined($scope.isPensionOnly) ? $scope.isPensionOnly : false
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('payInformationCalculationsFieldset', {
	bindings: {
		agencyProfileId: '<',
		teamMember: '<'
	},
	controller: 'payInformationCalculationsFieldsetCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pay-information-calculations-fieldset/pay-information-calculations-fieldset.component.html'
})
.controller('payInformationCalculationsFieldsetCtrl', [
	'companyData',
	function (
		companyData
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const OVERRIDE_STATE = {
		companyDefaults: 'company-defaults',
		confirmUndo: 'confirm-undo',
		overridden: 'overridden',
	};

	function $onInit () {

		companyData.getAgencyEmployerNetPayCalculationDetails($ctrl.agencyProfileId)
			.then(companyCalculationDetailsObj => {

				angular.extend($ctrl, {
					companyCalculationDetail: companyCalculationDetailsObj,
					overrideState: getInitialOverrideState(),
					teamMemberCalculcationDetailsBackup: angular.copy($ctrl.teamMember.salary.CalculationDetails)
				});

				setComponentState(COMPONENT_STATES.ready);
			})
			.catch(onError);
	}

	function getInitialOverrideState () {
		return $ctrl.teamMember.salary.UseCompanyDefaults ? OVERRIDE_STATE.companyDefaults : OVERRIDE_STATE.overridden;
	}

	function onConfirmUndoCancel () {
		setOverrideState(OVERRIDE_STATE.overridden);
	}

	function onConfirmUndoContinue () {

		setOverrideState(OVERRIDE_STATE.companyDefaults);

		// Reset properties on salary object
		setTeamMemberCalculationDetailToCompanySettings();

		$ctrl.teamMember.salary.UseCompanyDefaults = true;
	}

	function onDeleteOverride () {
		setOverrideState(OVERRIDE_STATE.confirmUndo);
	}

	function onError (error) {
		setComponentState(COMPONENT_STATES.error);
		console.error(error);
		$ctrl.form.$invalid = true;
	}

	function onOverrideCompanyDefaults () {

		// Default override properties to company defaults on override
		setTeamMemberCalculationDetailToCompanySettings();

		$ctrl.teamMember.salary.UseCompanyDefaults = false;

		setOverrideState(OVERRIDE_STATE.overridden);
	}

	function setOverrideState (newState) {
		$ctrl.overrideState = newState;
	}

	function setTeamMemberCalculationDetailToCompanySettings () {
		angular.extend($ctrl.teamMember.salary.CalculationDetails, $ctrl.companyCalculationDetail);
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		onConfirmUndoCancel,
		onConfirmUndoContinue,
		onDeleteOverride,
		onOverrideCompanyDefaults,

		COMPONENT_STATES,
		OVERRIDE_STATE,

		componentState: COMPONENT_STATES.loading,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payInformationCurrenciesFieldset', {
	bindings: {
		agencyProfileId: '<',
		isRequired: '<',
		teamMember: '<'
	},
	controller: 'payInformationCurrenciesFieldsetCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pay-information-currencies-fieldset/pay-information-currencies-fieldset.component.html'
})
.controller('payInformationCurrenciesFieldsetCtrl', [
	'companyData',
	'config',
	function (
		companyData,
		config
	) {

	const $ctrl = this;

	function $onInit () {

		companyData.getCurrencies($ctrl.agencyProfileId)
			.then(currenciesArr => {

				angular.extend($ctrl, {
					currencies: currenciesArr,
					isPaymentInCurrency: $ctrl.teamMember.salary.CurrencyID !== config.guidEmpty
				});

				$ctrl.selectedCurrency = getInitialSelectedCurrency();
			});
	}

	function getInitialSelectedCurrency () {

		// Find selected currency or leave empty
		if ($ctrl.isPaymentInCurrency && $ctrl.currencies.length > 0) {
			return $ctrl.currencies.find(currencyObj => currencyObj.CurrencyID === $ctrl.teamMember.salary.CurrencyID);
		}
		else {
			return null;
		}
	}

	function onCurrencyChange () {
		$ctrl.teamMember.salary.CurrencyID = $ctrl.selectedCurrency.CurrencyID;
	}

	function onUseCurrencyChange () {

		// Clear out currency properties
		if (!$ctrl.isPaymentInCurrency) {

			$ctrl.selectedCurrency = null;

			angular.extend($ctrl.teamMember.salary, {
				CurrencyID: config.guidEmpty,
				CurrencyLabel: ''
			});
		}
	}

	angular.extend($ctrl, {
		$onInit,

		onCurrencyChange,
		onUseCurrencyChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payInformationRolledUpFieldset', {
	bindings: {
		agencyProfileId: '<',
		isRequired: '<',
		payeDetails: '<',
		teamMember: '<'
	},
	controller: 'payInformationRolledUpFieldsetCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pay-information-rolled-up-fieldset/pay-information-rolled-up-fieldset.component.html'
})
.controller('payInformationRolledUpFieldsetCtrl', [
	'accessButtonService',
	'companyData',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	function (
		accessButtonService,
		companyData,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES
	) {

		let ctrl = this;

		ctrl.$onInit = function() {
			if (!ctrl.payeDetails) {
			companyData.getPAYEDetails(ctrl.agencyProfileId).then(function(response) {
				ctrl.payeDetails = response;
				});
			}
		};

		function onIsRollUpHolidayChange() {
			if (!ctrl.teamMember.company.IsRollUpHoliday) {
				ctrl.teamMember.company.ExcludeSalaryFromRolledUpHoliday = false;
			}
			// Telemetry
			accessButtonService.sendTelemetry(TELEMETRY_TRACKED_FEATURES.rolledUpHolidayPay, TELEMETRY_PROJECT_INFO.projectReportingCode);
		}		

		angular.extend(ctrl, {
			onIsRollUpHolidayChange
		});
	}
]);

'use strict';

angular.module('paycircleApp')
.component('payInformationTaxNiFieldset', {
	bindings: {
		isRequired: '<',
		teamMember: '<'
	},
	controller: 'payInformationTaxNiFieldsetCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pay-information-tax-ni-fieldset/pay-information-tax-ni-fieldset.component.html'
})
.controller('payInformationTaxNiFieldsetCtrl', [
	'SALARY_TYPES',
	function (
		SALARY_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			isPercentageOfPayTaxExempt: $ctrl.teamMember.salary.TaxExcemptPercent > 0
		});
	}

	function onPercentageOfPayTaxExemptToggle () {

		if (!$ctrl.isPercentageOfPayTaxExempt) {
			$ctrl.teamMember.salary.TaxExcemptPercent = 0;
		}
	}

	angular.extend($ctrl, {
		$onInit,

		onPercentageOfPayTaxExemptToggle,

		SALARY_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('payPeriodDates', function () {

	return {
		controller: 'payPeriodDatesController',
		templateUrl: 'components/pay-period-dates/payPeriodDatesComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			currentPeriod: '<?',
			onPreview: '=?',
			periodDetails: 	'=',
			hasRunPayroll: '<?',
			isCisActive: '<',
			form: '='
		},
	};
})
.controller('payPeriodDatesController', [
	'$filter',
	'$scope',
	'companyData',
	'config',
	'dateService',
	'payPeriodSetupService',
	'utilities',
	'PAY_DATE_OPTIONS',
	'PAY_PERIOD_ARREARS_OPTIONS',
	'PAY_PERIOD_ARREARS_TYPES',
	'PAY_PERIOD_OFFSET_OPTIONS',
	'PAY_PERIOD_PAYSLIP_DATE_TYPES',
	'PAY_PERIOD_PROCESSING_DATE_TYPES',
	'PAY_PERIOD_SETUP_TYPES',
	'PAY_PERIOD_SETUP_TYPES_OPTIONS',
	'QBA_OPTIONS',
	'WEEK_NUMBER_OPTIONS_FOUR_WEEKLY',
	'WEEK_NUMBER_OPTIONS_TWO_WEEKLY',
	function (
		$filter,
		$scope,
		companyData,
		config,
		dateService,
		payPeriodSetupService,
		utilities,
		PAY_DATE_OPTIONS,
		PAY_PERIOD_ARREARS_OPTIONS,
		PAY_PERIOD_ARREARS_TYPES,
		PAY_PERIOD_OFFSET_OPTIONS,
		PAY_PERIOD_PAYSLIP_DATE_TYPES,
		PAY_PERIOD_PROCESSING_DATE_TYPES,
		PAY_PERIOD_SETUP_TYPES,
		PAY_PERIOD_SETUP_TYPES_OPTIONS,
		QBA_OPTIONS,
		WEEK_NUMBER_OPTIONS_FOUR_WEEKLY,
		WEEK_NUMBER_OPTIONS_TWO_WEEKLY) {

	const currentPeriodObj = $scope.currentPeriod;
	const hasRunPayroll = $scope.hasRunPayroll;
	const isCisActive = $scope.isCisActive;
	const periodDetails = $scope.periodDetails;

	function filterPayPeriodTypesForCompany (payPeriodOption) {

		// Companies with CIS cannot run quarterly/annual payrolls
		if (isCisActive) {

			switch (payPeriodOption.id) {

				case PAY_PERIOD_SETUP_TYPES.quarterly:
				case PAY_PERIOD_SETUP_TYPES.biAnnually:
				case PAY_PERIOD_SETUP_TYPES.annually:
					return;
			}
		}

		return payPeriodOption;
	}

	function generateEndDateFromStartDateIso (startDateIso) {

		if (startDateIso) {
			$scope.periodDetails.PeriodStartDateISO = startDateIso;
			$scope.periodDetails.periodEndDateISO = payPeriodSetupService.getEndDateForPeriodType($scope.periodDetails);
			$scope.periodDetails.isTimelineVisible = true;

			reviewPreview($scope.periodDetails);

		} else {
			$scope.periodDetails.isTimelineVisible = false;
		}

	}

	function init () {

		payPeriodSetupService.decoratePayPeriodDetails(periodDetails);

		setupActivePeriodOptions(periodDetails);

		setupPayDateReadOnly(periodDetails);

		setMaxPayPeriodProcessingDayOffset(periodDetails.PayPeriodType);

		if (periodDetails.ActivePeriodQBA === 0) {
			payPeriodSetupService.reviewActivePeriod(periodDetails);
		}
	}

	function onError (error) {
		console.error(error);
	}

	function onDate1Change (periodDetailsObj, $field) {

		if (periodDetailsObj.PeriodStartDateISO === '') {
			periodDetailsObj.isOptionsDisabled = true;
			$field.$setValidity('betweenDate1Range', true);
			$field.$setValidity('validDate', false);
		}
		else {
			$field.$setValidity('validDate', true);

			const periodStartDate = moment(periodDetailsObj.PeriodStartDateISO);

			companyData.getQBAPayDateRanges(periodDetailsObj.PeriodStartDateISO, periodDetailsObj.PayPeriodType).then(value => {

					periodDetailsObj.DateRanges = value;
					const minDate = moment(periodDetailsObj.DateRanges[0].PayDateMinISO);
					const maxDate = moment(periodDetailsObj.DateRanges[0].PayDateMaxISO);

					if (periodStartDate.isBetween(minDate, maxDate,  null, '[]')) {
						$field.$setValidity('betweenDate1Range', true);
						periodDetailsObj.isOptionsDisabled = false;
					} else {
						$field.$setValidity('betweenDate1Range', false);
						periodDetailsObj.isOptionsDisabled = true;
					}
				})
				.catch(onError);

			if (periodDetailsObj.isEditing) {
				$field.$touched = true;
			}
		}
    }

	function openPreview (payPeriodObj) {

		if ($scope.onPreview !== undefined) {

			$scope.onPreview(payPeriodObj);
		}
	}

	function previewPeriodDetails (periodDetailsObj) {

		periodDetailsObj = payPeriodSetupService.reviewPayPeriodDetails(periodDetailsObj);

		// Close timeline if unable to update
		if (periodDetailsObj.PayPeriodPaymentDay === null || periodDetailsObj.PayPeriodPayslipDay === null || periodDetailsObj.PayPeriodProcessingDay === null) {
			return;
		}

		periodDetailsObj.payPeriodsLoadingState = 'loading';

		openPreview(periodDetailsObj);

		companyData.createAgencyPayPeriodsPreview(periodDetailsObj).then((payPeriodsArr) => {

			periodDetailsObj.payPeriods = payPeriodsArr;
			periodDetailsObj.payPeriodsLoadingState = 'ready';

			openPreview(periodDetailsObj);
		})
		.catch((error) => {

			periodDetailsObj.payPeriodsLoadingState = 'error';

			openPreview(periodDetailsObj);
			console.error(error);
		});
	}

	function reviewPayPeriodPaymentDay (periodDetailsObj) {

		periodDetailsObj = payPeriodSetupService.reviewPayPeriodPaymentDay(periodDetailsObj);

		reviewPreview(periodDetailsObj);
	}

	function reviewPayslipDay (periodDetailsObj) {

		periodDetailsObj = payPeriodSetupService.reviewPayslipDay(periodDetailsObj);

		reviewPreview(periodDetailsObj);
	}

	function reviewPreview (periodDetailsObj) {

		if (periodDetailsObj.isTimelineVisible) {
			previewPeriodDetails(periodDetailsObj);
		}
	}

	function reviewProcessingDay (periodDetailsObj) {

		periodDetailsObj = payPeriodSetupService.reviewProcessingDay(periodDetailsObj);

		reviewPreview(periodDetailsObj);
	}

	function setupActivePeriodOptions (periodDetailsObj) {

		// Only show field before payroll has been run for BiAnnual and Quarterly
		if (hasRunPayroll || ![PAY_PERIOD_SETUP_TYPES.biAnnually, PAY_PERIOD_SETUP_TYPES.quarterly].includes(periodDetailsObj.PayPeriodType)) {
			return;
		}

		const activePeriodOptionsArr = [
			{
				description: 'Pay date 1',
				value: QBA_OPTIONS.payDateOne
			},
			{
				description: 'Pay date 2',
				value: QBA_OPTIONS.payDateTwo
			}
		];

		if (periodDetailsObj.PayPeriodType === PAY_PERIOD_SETUP_TYPES.quarterly) {
			activePeriodOptionsArr.push(
				{
					description: 'Pay date 3',
					value: QBA_OPTIONS.payDateThree
				},
				{
					description: 'Pay date 4',
					value: QBA_OPTIONS.payDateFour
				}
			);
		}

		periodDetailsObj.activePeriodOptions = activePeriodOptionsArr;
		periodDetailsObj.isEditing = true;

		companyData.getQBAPayDateRanges(periodDetailsObj.PeriodStartDateISO || '2000-01-01', periodDetailsObj.PayPeriodType)
			.then(value => {
				periodDetailsObj.DateRanges = value;
				onDate1Change(periodDetailsObj, $scope.form.payDate1);
			})
			.catch(onError);
	}

	function setupPayDateReadOnly (periodDetailsObj) {

		// Disabled certainpay date fields if payroll has been run on BiAnnual and Quarterly payrolls

		// Defaults
		const payDateReadOnlyObj = {
			payDate1: false,
			payDate2: false,
			payDate3: false,
			payDate4: false,
		};

		if (
			hasRunPayroll &&
			angular.isDefined(currentPeriodObj) &&
			[PAY_PERIOD_SETUP_TYPES.biAnnually, PAY_PERIOD_SETUP_TYPES.quarterly].includes(periodDetailsObj.PayPeriodType)
		) {


			const currentPeriodStartDateIso = moment(currentPeriodObj.StartDateISO);

			// Date first run through Paycircle and any earlier are non-editable
			angular.extend(payDateReadOnlyObj, {
				payDate1: moment(periodDetailsObj.PeriodStartDateISO).isBefore(currentPeriodStartDateIso),
				payDate2: moment(periodDetailsObj.PeriodStartDate2ISO).isBefore(currentPeriodStartDateIso),
				payDate3: moment(periodDetailsObj.PeriodStartDate3ISO).isBefore(currentPeriodStartDateIso),
				payDate4: moment(periodDetailsObj.PeriodStartDate4ISO).isBefore(currentPeriodStartDateIso)
			});

		}

		periodDetailsObj.payDateReadOnly = payDateReadOnlyObj;
	}

	function setupPayPeriodType (periodDetailsObj) {

		setupActivePeriodOptions(periodDetailsObj);
		setMaxPayPeriodProcessingDayOffset(periodDetailsObj.PayPeriodType);
		payPeriodSetupService.reviewActivePeriod(periodDetails);

		periodDetailsObj.PayPeriodPaymentDay = null;
		periodDetailsObj.payPeriodPaymentDayDisplay = null;

		periodDetailsObj = payPeriodSetupService.decoratePayPeriodDetails(periodDetailsObj);

		periodDetailsObj.isTimelineVisible = false;
		periodDetailsObj.isOptionsDisabled = true;
		periodDetailsObj.isEditing = false;

		companyData.getQBAPayDateRanges(periodDetailsObj.PeriodStartDateISO || '2000-01-01', periodDetailsObj.PayPeriodType)
			.then(value => {
				periodDetailsObj.DateRanges = value;
			})
			.catch(onError);
	}

	function setMaxPayPeriodProcessingDayOffset (payPeriodTypeId) {

		// Determine processing date max days before payroll run date
		const payPeriodType = PAY_PERIOD_SETUP_TYPES_OPTIONS.find(payPeriodSetupType => payPeriodSetupType.id === payPeriodTypeId);
		// Not defined for the longer pay period types
		$scope.maxPayPeriodProcessingDayOffset = angular.isDefined(payPeriodType.maxPayPeriodProcessingDayOffset) ? payPeriodType.maxPayPeriodProcessingDayOffset : 0;
	}

	function togglePayPeriodCalendar (periodDetailsObj) {

		if (periodDetailsObj.isTimelineVisible) {
			periodDetailsObj.isTimelineVisible = false;
		}
		else {
			previewPeriodDetails(periodDetailsObj);
		}
	}

	function updateArrearsType (periodDetailsObj) {

		periodDetailsObj.PayPeriodArrearsCount = periodDetailsObj.payPeriodArrearsType === PAY_PERIOD_ARREARS_TYPES.samePeriod ? 0 : 1;

		reviewPreview(periodDetailsObj);
	}

	init();

	angular.extend($scope, {
		PAY_PERIOD_ARREARS_OPTIONS,
		PAY_PERIOD_ARREARS_TYPES,
		PAY_PERIOD_OFFSET_OPTIONS,
		PAY_PERIOD_PAYSLIP_DATE_TYPES,
		PAY_PERIOD_PROCESSING_DATE_TYPES,
		PAY_PERIOD_SETUP_TYPES,
		PAY_PERIOD_SETUP_TYPES_OPTIONS: PAY_PERIOD_SETUP_TYPES_OPTIONS.filter(filterPayPeriodTypesForCompany),
		PAY_DATE_OPTIONS,
		WEEK_NUMBER_OPTIONS_TWO_WEEKLY,
		WEEK_NUMBER_OPTIONS_FOUR_WEEKLY,
		generateEndDateFromStartDateIso,
		onDate1Change,
		previewPeriodDetails,
		reviewPayPeriodPaymentDay,
		reviewPayslipDay,
		reviewPreview,
		reviewProcessingDay,
		setupPayPeriodType,
		togglePayPeriodCalendar,
		updateArrearsType
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payPeriodCard', {
	bindings: {
		agencyProfileId: '<',
		payPeriod: '<',
		refreshPeriods: '&'
	},
	controller: 'payPeriodCardCtrl',
	templateUrl: 'components/pay-period-card/pay-period-card.component.html',
})
.controller('payPeriodCardCtrl', [
	'$rootScope',
	'$state',
	'reportData',
	'reportsService',
	'DOCUMENT_TYPES',
	'INTERFACE_TYPES',
	'PAYSLIP_MANAGER_STATE',
	'REPORT_TEMPLATE_IDS',
	function (
		$rootScope,
		$state,
		reportData,
		reportsService,
		DOCUMENT_TYPES,
		INTERFACE_TYPES,
		PAYSLIP_MANAGER_STATE,
		REPORT_TEMPLATE_IDS
	) {

	const $ctrl = this;

	function checkCanImportMainRun ($ctrl) {

		if ($rootScope.currentCompany.IsArchived) {
			$rootScope.openSlideInForm({
				agencyProfileId: $ctrl.agencyProfileId,
				formKey: 'payslip-manager',
				title: 'Import main run'
			});
			return;
		}

		switch ($ctrl.payPeriod.PayslipManagerState) {
			case PAYSLIP_MANAGER_STATE.awaitingUpload:

				$state.go('data-importer.upload-file', {
					agencyDocumentType: DOCUMENT_TYPES.payslipManagerFullRun,
					agencyProfileId: $ctrl.agencyProfileId,
					from: 'payslip-manager',
					payPeriodId: $ctrl.payPeriod.PayPeriodID
				});

				break;

			case PAYSLIP_MANAGER_STATE.notificationsNotSent:
			case PAYSLIP_MANAGER_STATE.notificationsSent:

				$rootScope.openSlideInForm({
					agencyProfileId: $ctrl.agencyProfileId,
					callback: $ctrl.refreshPeriods,
					formKey: 'payslip-manager',
					formState: 'main-run-imported-previously',
					payPeriodId: $ctrl.payPeriod.PayPeriodID,
					title: 'Import main run'
				});

				break;
		}
	}

	function checkCanImportSupplementaryRun ($ctrl) {

		if ($rootScope.currentCompany.IsArchived) {
			$rootScope.openSlideInForm({
				agencyProfileId: $ctrl.agencyProfileId,
				formKey: 'payslip-manager',
				title: 'Import supplementary pay run'
			});
			return;
		}

		switch ($ctrl.payPeriod.PayslipManagerState) {
			case PAYSLIP_MANAGER_STATE.notificationsNotSent:
			case PAYSLIP_MANAGER_STATE.notificationsSent:

				$state.go('data-importer.upload-file', {
					agencyDocumentType: DOCUMENT_TYPES.payslipManagerSupplementaryRun,
					agencyProfileId: $ctrl.agencyProfileId,
					from: 'payslip-manager',
					payPeriodId: $ctrl.payPeriod.PayPeriodID
				});

				break;

			case PAYSLIP_MANAGER_STATE.awaitingUpload:

				$rootScope.openSlideInForm({
					agencyProfileId: $ctrl.agencyProfileId,
					formKey: 'payslip-manager',
					formState: 'main-run-not-imported',
					title: 'Import supplementary pay run'
				});

				break;
		}
	}

	function getReportsForPeriod () {

		if (!$ctrl.payPeriod.IsAutoSubmitPeriod && !$ctrl.payPeriod.payPeriodIsDisabled && $ctrl.reportDownloadState === 'loading') {
			reportData.getClassicReports($ctrl.agencyProfileId, $ctrl.payPeriod.PayPeriodID)
				.then(classicReportsArr => {
					angular.extend($ctrl, {
						reports: classicReportsArr,
						reportDownloadState: 'ready'
					});
				})
				.catch(() => {
					angular.extend($ctrl, {
						reports: [],
						reportDownloadState: 'error'
					});
				});
		}
	}

	function openCISSufferedForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			formKey: 'cis-suffered',
			payPeriodId: $ctrl.payPeriod.PayPeriodID
		});
	}

	function openDeleteHistoricPayPeriodForm ($ctrl) {

		$rootScope.openSlideInForm({
			callback: $ctrl.refreshPeriods,
			contextType: 'company',
			formKey: 'delete-historic-pay-period',
			payPeriod: $ctrl.payPeriod,
			showContext: true
		});
	}

	function openEPSReportModal ($ctrl) {

		reportsService.openReportFromReportTemplateId(
			REPORT_TEMPLATE_IDS.eps,
			{
				agencyDocumentId: $ctrl.payPeriod.AutoSubmitEPSID,
				agencyProfileId: $ctrl.agencyProfileId
			}
		);
	}

	function openHistoricPeriodForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			contextType: 'company',
			formKey: 'historic-tax-period',
			historicPayPeriodId: $ctrl.payPeriod.AgencyPaymentID,
			showContext: true,
		});
	}

	function openImportHistoryForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			formKey: 'import-history',
			payPeriod: $ctrl.payPeriod,
		});
	}

	function openP32ReportModal ($ctrl) {

		reportsService.openReportFromReportTemplateId(
			REPORT_TEMPLATE_IDS.p32Report,
			{
				agencyProfileId: $ctrl.agencyProfileId
			}
		);
	}

	function openReopenPeriodForm ($ctrl) {

		const formOptionsObj = {
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			showContext: false,
			payPeriod: $ctrl.payPeriod,
			title: 'Reopen period'
		};

		if ($ctrl.payPeriod.IsRunInactivity) {
			formOptionsObj.formKey = 'company-settings-inactive-period';
		} else if ($ctrl.payPeriod.IsRunSkipped) {
			formOptionsObj.formKey = 'company-settings-skip-pay-periods';
		}

		$rootScope.openSlideInForm(formOptionsObj);
	}

	function openRollbackPeriodForm ($ctrl) {
		
		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			formKey: 'rollback-period',
			payPeriodId: $ctrl.payPeriod.PayPeriodID
		});
	}

	function openSendNotificationsForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			formKey: 'send-notifications',
			payPeriod: $ctrl.payPeriod,
		});
	}

	function openSubmitEpsForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.refreshPeriods,
			canCloseForm: false,
			contextType: 'company',
			formKey: 'submit-eps',
			payPeriodId: $ctrl.payPeriod.PayPeriodID,
			title: 'Submit EPS'
		});
	}

	angular.extend($ctrl, {
		INTERFACE_TYPES,
		PAYSLIP_MANAGER_STATE,

		reportDownloadState: 'loading',

		checkCanImportMainRun,
		checkCanImportSupplementaryRun,
		getReportsForPeriod,
		openCISSufferedForm,
		openDeleteHistoricPayPeriodForm,
		openEPSReportModal,
		openHistoricPeriodForm,
		openImportHistoryForm,
		openP32ReportModal,
		openReopenPeriodForm,
		openRollbackPeriodForm,
		openSendNotificationsForm,
		openSubmitEpsForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payPeriodNote', {
	bindings: {
		note: '=',
		agencyProfileId: '<',
		agencyPayPeriodId: '<',
		refreshNotes: '&',
		refreshTasks: '&?'
	},
	controller: 'payPeriodNoteCtrl',
	templateUrl: 'components/pay-period-note/pay-period-note.component.html',
})
.controller('payPeriodNoteCtrl', ['$rootScope', 'MESSAGE_SUBJECT_TYPES', function ($rootScope, MESSAGE_SUBJECT_TYPES) {

	const $ctrl = this;

	function getThemeForNote (noteObj) {

		switch (noteObj.SubjectType) {

			// Query
			case MESSAGE_SUBJECT_TYPES.query:
				return 'is-indifferent';

			// Note
			default:
				return noteObj.IsSender ? 'is-quarternary' : 'is-primary';
		}
	}

	function openAddPeriodTaskForm (noteObj) {
		openSlideInForm({
			callback: angular.isDefined($ctrl.refreshTasks) ? $ctrl.refreshTasks : undefined,
			formKey: 'add-period-task',
			note: noteObj
		});
	}

	function openDeletePeriodNoteForm (noteObj) {
		openSlideInForm({
			callback: $ctrl.refreshNotes,
			formKey: 'delete-period-note',
			note: noteObj
		});
	}

	function openSlideInForm (formOptionsObj) {
		angular.extend(formOptionsObj, {
			agencyProfileId: $ctrl.agencyProfileId,
		});

		$rootScope.openSlideInForm(formOptionsObj);
	}

	$ctrl.$onInit = function  () {
		$ctrl.cardTheme = getThemeForNote($ctrl.note);
	};

	angular.extend($ctrl, {
		MESSAGE_SUBJECT_TYPES,
		openAddPeriodTaskForm,
		openDeletePeriodNoteForm,
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('payPeriodTabs', function () {

	return {
		templateUrl: 'components/pay-period-tabs/payPeriodTabsComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			activeTab: '<?',
			agencyProfileId: '<',
			allowChangesInRestrictedView: '<?',
			company: '<',
			formOptions: '=?',
			isRestrictedView: '<?',
			onPayPeriodChange: '=',
			payPeriod: '=',
			reports: '<?',
			supplementaryPayRuns: '<?'
		},
		controller: 'payPeriodTabsCtrl'
	};
})
.controller('payPeriodTabsCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'aiServices',
	'base',
	'bulkService',
	'companyData',
	'config',
	'dataTransfer',
	'filterService',
	'growl',
	'logService',
	'messageData',
	'payPeriodService',
	'payrollData',
	'permissionsService',
	'reportData',
	'reportsService',
	'searchService',
	'session',
	'utilities',
	'COPILOT_FEATURES',
	'MESSAGE_TYPES',
	'SUBMISSION_STATES',
	'DRAFT_PAYSLIP_TASK_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$timeout,
		aiServices,
		base,
		bulkService,
		companyData,
		config,
		dataTransfer,
		filterService,
		growl,
		logService,
		messageData,
		payPeriodService,
		payrollData,
		permissionsService,
		reportData,
		reportsService,
		searchService,
		session,
		utilities,
		COPILOT_FEATURES,
		MESSAGE_TYPES,
		SUBMISSION_STATES,
		DRAFT_PAYSLIP_TASK_STATES
	) {

	const TABS = {
		alerts: {
			id: 'alerts',
			label: 'Alerts'
		},
		changes: {
			id: 'changes',
			label: 'Changes'
		},
		pensions: {
			id: 'pensions',
			label: 'Pensions'
		},
		periodNotes: {
			id: 'periodNotes',
			label: 'Notes'
		},
		periodTasks: {
			id: 'periodTasks',
			label: 'Tasks'
		},
		receipts: {
			id: 'receipts',
			label: 'Receipts'
		},
		reports: {
			id: 'reports',
			label: 'Reports'
		},
		smartView: {
			id: 'smartView',
			label: 'Smart View'
		},
		team: {
			id: 'team',
			label: 'Team'
		}
	};

	const companyObj = $scope.company;
	const formOptions = $scope.formOptions;
	const isInPlayground = session.isInPlayground();
	const onPayPeriodChange = $scope.onPayPeriodChange;
	const payPeriod = $scope.payPeriod;
	const isRestrictedView = angular.isDefined($scope.isRestrictedView) ? $scope.isRestrictedView : false;
	const isChangesTabVisible = permissionsService.getPermissionValueByString($rootScope.currentUser, 'Payroll.canViewChanges', 'pay-period-tabs');
	const PAY_PERIOD_SUBMITTED = (payPeriod.PayrollState === SUBMISSION_STATES.submitted);
	const userPermissions = $rootScope.currentUser.Permissions;
	const isLiteAdminRole = $rootScope.userHasRole(['groupadminlite', 'companyadministratorlite']);

	/* Single source of truth for tab visibility - consumed by both the nav template (via $scope) and
	   getDefaultActiveTab, so the nav and the default-landing logic can never fall out of sync. */
	$scope.tabVisibility = {
		alerts: !isRestrictedView && userPermissions.Payroll.canManageAlerts,
		changes: isChangesTabVisible && (!isRestrictedView || $scope.allowChangesInRestrictedView),
		pensions: companyObj.IsPensionActive && companyObj.HasPension && !isLiteAdminRole,
		periodNotes: userPermissions.Payroll.canUpdateNotes,
		periodTasks: !isRestrictedView && userPermissions.Payroll.canUpdateTasks,
		receipts: PAY_PERIOD_SUBMITTED && !isRestrictedView,
		reports: userPermissions.isReportingVisible,
		team: PAY_PERIOD_SUBMITTED && !isRestrictedView && userPermissions.isTeamVisible
	};

	let activeTab = angular.isDefined($scope.activeTab) ? $scope.activeTab : getDefaultActiveTab();
	const smartViewSections = {
		loadedSections: false,
		subtitleSection: {
			subtitleText: ''
		},
		summarySection: {
			state: 'loading',
			percentageMode: false,
			fields: null,
			copilotError: false, 
			copilotFirstErrorMessage: false
		}, 
		nextMonthSection: null, 
		smartMovesSection: null,
		draftPayslipsSection: {
			state: 'loading',
			canGenerateDraftPayslips: false,
			taskState: DRAFT_PAYSLIP_TASK_STATES.none,
			message: '',
			userFullName: '',
			updatedTime: '',
			updatedDate: ''
		}
	};

	const smartViewSummaryFirstLoadTimeoutSeconds = 15;
	const smartViewSummarySecondLoadTimeoutSeconds = 20;

	const netPayVarianceAiSettings = {
		highChange: {
			aiDescriptionStyles: ['font-weight-400'],
			aiDescriptionMarkerStyles: ['s', 'assertive'],
			aiHideSections: {
				hiddenContent: {
					hiddenStats: {
						actionBar: true,
						header: true
					}
				}
			}
		},
		mediumChange: {
			aiDescriptionStyles: ['font-weight-400'],
			aiDescriptionMarkerStyles: ['s', 'indifferent'],
			aiHideSections: {
				hiddenContent: {
					hiddenStats: {
						actionBar: true,
						header: true
					}
				}
			}
		}
	};

	function createAlertReportDownload (companyObj, payPeriodObj) {

		$scope.alertDownloadState = 'loading';

		reportData.createAlertReportDownload(companyObj.AgencyProfileID, payPeriodObj.PayPeriodID).then(alertReportUrl => {

			dataTransfer.downloadFile(alertReportUrl, 'alert-report.csv');

			$scope.alertDownloadState = null;
		})
		.catch(error => {
			console.error(error);
			setComponentState('error');
		});
	}

	function loadComponent () {

		if (isRestrictedView) {
			initRestrictedView();

			if ($scope.allowChangesInRestrictedView) {
				loadChanges();
			}
		} else {
			initNormalView();
		}
	}

	/* Pick the tab to land on when the consumer doesn't specify one: the first visible tab, in nav order.
	   Reports stays the default whenever it's visible and only falls back otherwise (e.g. to Team/Receipts).
	   If nothing is visible we return Reports, which simply renders nothing - the period figures still show. */
	function getDefaultActiveTab () {

		// Nav order; visibility is read from the shared $scope.tabVisibility so it stays in sync with the nav.
		const orderedTabs = [
			TABS.reports,
			TABS.team,
			TABS.changes,
			TABS.receipts,
			TABS.periodNotes,
			TABS.periodTasks,
			TABS.pensions,
			TABS.alerts
		];

		const firstVisibleTab = orderedTabs.find(tab => $scope.tabVisibility[tab.id]);

		return firstVisibleTab;
	}

	function initRestrictedView () {

		setTabState('reports', 'loading');
		setTabState('notes', 'loading');

		setComponentState('ready');

		// Notes
		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID, MESSAGE_TYPES.notes).then(periodNotesArr => {

			$scope.periodNotes = periodNotesArr;

			setTabState('notes', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('notes', 'error');
		});

		// Reports
		const getReports = angular.isDefined($scope.reports) ? $q.when($scope.reports) : reportData.getReports(companyObj.AgencyProfileID, payPeriod.PayPeriodID);

		getReports.then(reportsArr => {

			$scope.reports = reportsService.getReportsForPayPeriod(reportsArr);

			setTabState('reports', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('reports', 'error');
		});
	}

	function initNormalView () {

		let USER_ID; // Not defined to return all adjustments

		const isUserEvoEnabled = $rootScope.currentUser.IsAccessWorkspaceAccount && $rootScope.currentUser.IsApplicationProvisioned;

		/* Set up the synchronous scope data (filter/search options are derived from the company and static
		   services, not the API responses) so the tab nav and tab shells can render immediately whilst each
		   tab loads its own data independently. */
		angular.extend($scope, {
			filterBarOptions: {
				teamHistory: filterService.getFilterBarOptionsTeamHistory(companyObj),
				payrollAlerts: filterService.payrollAlerts,
				periodTasks: filterService.tasks
			},
			netPayVariance: {
				highChange: [],
				mediumChange: [],
				aiSettings: netPayVarianceAiSettings
			}
		});

		setTabState('reports', 'loading');
		setTabState('alerts', 'loading');
		setTabState('notes', 'loading');
		setTabState('tasks', 'loading');
		setTabState('pensions', 'loading');

		setComponentState('ready');

		// Changes
		loadChanges(USER_ID);

		// Team (only relevant once the period is complete; team payment history isn't loaded for in-progress periods)
		if (PAY_PERIOD_SUBMITTED) {

			setTabState('team', 'loading');

			payrollData.getTeamMembersPaymentHistory(companyObj.AgencyProfileID, payPeriod.PayPeriodID).then(paymentHistoryObj => {

				$scope.teamMembers = bulkService.getBulkItemsObj(paymentHistoryObj);

				setTabState('team', 'ready');
			})
			.catch(error => {
				console.error(error);
				setTabState('team', 'error');
			});
		}

		// Alerts
		messageData.getPeriodAlerts(companyObj.AgencyProfileID, payPeriod.PayPeriodID, !PAY_PERIOD_SUBMITTED).then(payrollAlertsArr => {

			$scope.payrollAlerts = payPeriodService.getPayrollAlertLevelsFromAlerts(payrollAlertsArr);

			setTabState('alerts', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('alerts', 'error');
		});

		// Notes
		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID, MESSAGE_TYPES.notes).then(periodNotesArr => {

			$scope.periodNotes = periodNotesArr;

			setTabState('notes', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('notes', 'error');
		});

		// Tasks
		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID, MESSAGE_TYPES.tasks).then(periodTasksArr => {

			$scope.periodTasks = bulkService.getBulkItemsObj(periodTasksArr);

			setTabState('tasks', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('tasks', 'error');
		});

		// Pensions
		if (companyObj.HasPension && companyObj.IsPensionActive) {

			messageData.getPensionLogEntriesForPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID).then(pensionLogEntriesArr => {

				$scope.pensionLogEntries = logService.decorateLogEntries(pensionLogEntriesArr);

				setTabState('pensions', 'ready');
			})
			.catch(error => {
				console.error(error);
				setTabState('pensions', 'error');
			});
		}
		else {
			$scope.pensionLogEntries = logService.decorateLogEntries(null);

			setTabState('pensions', 'ready');
		}

		// Reports (use the reports passed in by the parent if provided, otherwise fetch them)
		const getReports = angular.isDefined($scope.reports) ? $q.when($scope.reports) : reportData.getReports(companyObj.AgencyProfileID, payPeriod.PayPeriodID);

		getReports.then(reportsArr => {

			$scope.reports = reportsService.getReportsForPayPeriod(reportsArr);

			setTabState('reports', 'ready');
		})
		.catch(error => {
			console.error(error);
			setTabState('reports', 'error');
		});

		// Smart View feature flag (drives the Smart View nav tab visibility)
		base.isFeatureEnabled(companyObj.AgencyProfileID, 'SMART_VIEW').then(isSmartViewFeatureEnabledBool => {

			$scope.isSmartViewFeatureEnabled = isSmartViewFeatureEnabledBool && isUserEvoEnabled && !$rootScope.userHasRole(['groupadminlite', 'companyadministratorlite']);
		})
		.catch(error => {
			console.error(error);
			$scope.isSmartViewFeatureEnabled = false;
		});
	}

	function loadChanges (userId) {

		if (!isChangesTabVisible) {
			return;
		}

		setAdjustmentsState('loading');

		payrollData.getAgencyPaymentAdjustmentDetailList(companyObj.AgencyProfileID, userId, payPeriod.PayPeriodID).then(adjustmentDetailArr => {

			// Only keep team members that actually have adjustments, so the empty-state checks, the "has changes"
			// wrapper and the paginated list all operate on the same collection.
			$scope.adjustmentDetailList = adjustmentDetailArr.filter(hasAdjustments);

			setAdjustmentsState('ready');
		})
		.catch(error => {
			console.error(error);
			setAdjustmentsState('error');
		});
	}

	function openAddAChangeForm () {

		openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: onPayPeriodChange,
			formKey: 'add-a-change',
			payPeriod: payPeriod
		});
	}

	function openBACSFileCreationForm () {

		openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			callback: onPayPeriodChange,
			formKey: 'company-settings-bacs'
		});
	}

	function openCrossPeriodReportForm () {

		openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			formKey: 'cross-period-report'
		});
	}

	function openSlideInForm (formDetails) {
		if (formOptions) {
			formOptions.openNewSlideInForm(formDetails);
		}
		else {
			$rootScope.openSlideInForm(formDetails);
		}
	}

	function refreshNotes () {

		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID, MESSAGE_TYPES.notes).then(periodNotesArr => {

			$scope.periodNotes = periodNotesArr;
		})
		.catch(error => {
			setComponentState('error');
			setAdjustmentsState('error');
			console.error(error);
		});
	}

	function refreshTasks () {

		messageData.getMessagesForPayPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID, MESSAGE_TYPES.tasks).then(periodTasksArr => {

			$scope.periodTasks = bulkService.getBulkItemsObj(periodTasksArr);
		})
		.catch(error => {
			setComponentState('error');
			setAdjustmentsState('error');
			console.error(error);
		});
	}

	function setActiveTab (tab) {

		// Set active tab and close mobile menu (in case its open)
		angular.extend($scope, {
			activeTab: tab,
			isOpen: false
		});

		if (tab === TABS.smartView){
			initSmartViewTab();
		}
	}

	function setAdjustmentsState (adjustmentsState) {
		$scope.adjustmentsState = adjustmentsState;
	}

	function setComponentState (componentState) {
		$scope.componentState = componentState;
	}

	function setTabState (tab, state) {
		$scope[tab + 'State'] = state;
	}

	// Predicate used to only paginate/render team members that actually have adjustments
	function hasAdjustments (adjustmentDetail) {
		return adjustmentDetail.Adjustments && adjustmentDetail.Adjustments.length > 0;
	}

	function toggleDropdown() {
		$scope.isOpen = !$scope.isOpen;
	}

	function toggleShowCompleteTasks () {

		$scope.showCompleteTasks = !$scope.showCompleteTasks;
	}

	function updateCopied (property) {
		$scope.epsCopied = false;
		$scope.fpsCopied = false;
		$scope[property] = true;
	}

	function setSectionState (section, state) {
		if (smartViewSections[section]) {
			smartViewSections[section].state = state;
		}
	}

	function loadSmartView () {

		const agencyPayPeriodId = PAY_PERIOD_SUBMITTED ? payPeriod.PayPeriodID : null;

		aiServices.getSmartViewAnalysis(companyObj.AgencyProfileID, agencyPayPeriodId, smartViewSummaryFirstLoadTimeoutSeconds)
			.then(function (response) { onSmartViewSuccess(response, true); })
			.catch(function (error) { onSmartViewError(error, true); });
	}

	function onSmartViewSuccess (response, firstTime) {
		
		if (!response.AiRequestDataGenerated) {
			onSmartViewError(null, firstTime);
			return;
		}

		//	copilot can return the answer as '{[ACTUAL JSON OBJECT]}' or '```json\n{[ACTUAL JSON OBJECT]}\n```'
		const jsonString = response.ComparisonResponse.replaceAll(/(^(```json\n))|((\n```)$)/gi, '');
		
		try {
			smartViewSections.summarySection.fields = JSON.parse(jsonString);

			const fields = smartViewSections.summarySection.fields;
			['grossPay', 'netPay', 'paye', 'employeeCount'].forEach(fieldName => {
				if (fields[fieldName]) {
					const monetaryChange = parseFloat((fields[fieldName].monetaryChange || '').replace(/[^0-9.-]/g, '') || '0');
					const percentageChange = parseFloat((fields[fieldName].percentageChange || '').replace(/[^0-9.-]/g, '') || '0');
					const countDifference = parseFloat((fields[fieldName].countDifference || '').replace(/[^0-9.-]/g, '') || '0');
					
					if (monetaryChange === 0 && percentageChange === 0 && countDifference === 0) {
						fields[fieldName].direction = 'none';
					}
				}
			});

			$scope.netPayVariance = {
				highChange: mapVarianceItems(response.HighChange),
				mediumChange: mapVarianceItems(response.MediumChange),
				highChangeCount: response.HighChangeCount,
				mediumChangeCount: response.MediumChangeCount,
				aiSettings: netPayVarianceAiSettings
			};
		}
		catch (error) {
			onSmartViewError(true, firstTime);
			return;
		}

		setSectionState('summarySection', 'ready');
	}

	function onSmartViewError (copilotErrorOrTimeout, firstTime) {

		if (copilotErrorOrTimeout === true || copilotErrorOrTimeout === -1) {
			smartViewSections.summarySection.copilotError = true;
			smartViewSections.summarySection.copilotFirstErrorMessage = firstTime;
		} else {
			smartViewSections.summarySection.copilotError = false;
			smartViewSections.summarySection.copilotFirstErrorMessage = false;
		}

		setSectionState('summarySection', 'error');
	}

	function togglePercentageMode () {
		smartViewSections.summarySection.percentageMode = !smartViewSections.summarySection.percentageMode;
	}

	function openSmartViewInfoModal (metricType) {
		$rootScope.openModalDialog('smart-view-' + metricType);
	}

	function initSmartViewTab () {

		if (!smartViewSections.loadedSections) {
			smartViewSections.loadedSections = true;
			loadSubtitleSection();
			loadSmartView();
			loadDraftPayslipsSection();
		}
	}

	function loadSubtitleSection () {

		aiServices.getSubtitleForPayrollComparison(payPeriod.PayPeriodID)
			.then(function (subtitleText) {
				smartViewSections.subtitleSection.subtitleText = subtitleText;
			});
	}

	function loadDraftPayslipsSection () {

		aiServices.getDraftPayslipsState(payPeriod.PayPeriodID)
			.then(function (draftPayslipsState) {
				refreshDraftPayslipsSection(draftPayslipsState);
				setSectionState('draftPayslipsSection', 'ready');
			})
			.catch(function () {
				setSectionState('draftPayslipsSection', 'error');
			});
	}

	function refreshDraftPayslipsSection (draftPayslipsState) {

		const previousState = smartViewSections.draftPayslipsSection.canGenerateDraftPayslips ? smartViewSections.draftPayslipsSection.taskState : null;

		smartViewSections.draftPayslipsSection.canGenerateDraftPayslips = draftPayslipsState.CanGenerateDraftPayslips;
		smartViewSections.draftPayslipsSection.taskState = draftPayslipsState.State;
		smartViewSections.draftPayslipsSection.message = draftPayslipsState.Message;
		smartViewSections.draftPayslipsSection.userFullName = draftPayslipsState.UserFullName;
		smartViewSections.draftPayslipsSection.updatedDate = moment(draftPayslipsState.UpdatedISO).format('Do MMMM');
		smartViewSections.draftPayslipsSection.updatedTime = moment(draftPayslipsState.UpdatedISO).format('HH:mm');

		if (draftPayslipsState.State === DRAFT_PAYSLIP_TASK_STATES.none && draftPayslipsState.NumberOfCompleteTeamMembers === 0) {
			smartViewSections.draftPayslipsSection.taskState = DRAFT_PAYSLIP_TASK_STATES.noTeamMembers;
		}

		if (previousState !== null && previousState !== draftPayslipsState.State) {
			switch (draftPayslipsState.State) {

				case DRAFT_PAYSLIP_TASK_STATES.complete:
					growl.success('Draft payslips successfully sent');
					break;

				case DRAFT_PAYSLIP_TASK_STATES.failed:
					growl.error('Failed to send draft payslips');
					break;

				case DRAFT_PAYSLIP_TASK_STATES.recallComplete:
					smartViewSections.draftPayslipsSection.taskState = DRAFT_PAYSLIP_TASK_STATES.none;
					growl.success('Draft payslips successfully recalled');
					break;

				case DRAFT_PAYSLIP_TASK_STATES.none:
					if (previousState === DRAFT_PAYSLIP_TASK_STATES.recallPending || previousState === DRAFT_PAYSLIP_TASK_STATES.recallProcessing) {
						growl.success('Draft payslips successfully recalled');
					}
					break;

				case DRAFT_PAYSLIP_TASK_STATES.recallFailed:
					growl.error('Failed to recall draft payslips');
					break;
			}
		}

		if (isProcessingState(draftPayslipsState.State)) {
			pollForDraftPayslipsState();
		}
	}

	function pollForDraftPayslipsState () {
		$timeout(function () {
			aiServices.getDraftPayslipsState(payPeriod.PayPeriodID)
				.then(function (draftPayslipsState) {
					refreshDraftPayslipsSection(draftPayslipsState);
				})
				.catch(function () {
					setSectionState('draftPayslipsSection', 'error');
				});
		}, config.timeToPoll * 1000);
	}

	function generateDraftPayslips () {

		openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			formKey: 'send-draft-payslips',
			payPeriod: payPeriod,
			title: 'Send draft payslips',
			callback: refreshDraftPayslipsSection
		});
	}

	function cancelSendDraftPayslips () {

		aiServices.recallDraftPayslips(payPeriod.PayPeriodID)
			.then(function (draftPayslipsState) {
				refreshDraftPayslipsSection(draftPayslipsState);
			})
			.catch(function () {
				growl.error('Failed to cancel draft payslips');
			});
	}

	function retrySendDraftPayslips () {

		aiServices.generateDraftPayslips(payPeriod.PayPeriodID)
			.then(function (draftPayslipsState) {
				refreshDraftPayslipsSection(draftPayslipsState);
			})
			.catch(function () {
				growl.error('Failed to send draft payslips');
			});
	}

	function recallDraftPayslips () {

		openSlideInForm({
			agencyProfileId: companyObj.AgencyProfileID,
			formKey: 'recall-draft-payslips',
			payPeriod: payPeriod,
			title: 'Recall draft payslips',
			callback: refreshDraftPayslipsSection
		});
	}

	function recallDraftPayslipsDirectly () {

		growl.success('Recalling draft payslips');

		aiServices.recallDraftPayslips(payPeriod.PayPeriodID)
			.then(function (draftPayslipsState) {
				refreshDraftPayslipsSection(draftPayslipsState);
			})
			.catch(function () {
				growl.error('Failed to recall draft payslips');
			});
	}

	function retryRecallDraftPayslips () {

		aiServices.recallDraftPayslips(payPeriod.PayPeriodID)
			.then(function (draftPayslipsState) {
				refreshDraftPayslipsSection(draftPayslipsState);
			})
			.catch(function () {
				growl.error('Failed to recall draft payslips');
			});
	}

	function isProcessingState (draftPayslipTaskState) {
		return draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.pending || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.processing || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.retryPending || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.retryProcessing || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.cancelPending || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.cancelProcessing || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.recallPending || 
			draftPayslipTaskState === DRAFT_PAYSLIP_TASK_STATES.recallProcessing;
	}

	function reloadSmartView() {

		const agencyPayPeriodId = PAY_PERIOD_SUBMITTED ? payPeriod.PayPeriodID : null;

		setSectionState('summarySection', 'loading');
		
		smartViewSections.summarySection.copilotError = false;
		smartViewSections.summarySection.copilotFirstErrorMessage = false;

		aiServices.getSmartViewAnalysis(companyObj.AgencyProfileID, agencyPayPeriodId, smartViewSummarySecondLoadTimeoutSeconds)
			.then(function (response) { onSmartViewSuccess(response, false); })
			.catch(function (error) { onSmartViewError(error, false); });
	}

	function reloadPage () {
		utilities.reloadPage();
	}

	function handleFeedbackSubmitted() {
		$scope.smartViewFeedbackFading = true;
		$timeout(function () {
			$scope.payPeriod.FeedbackSubmitted = true;
			$scope.smartViewFeedbackFading = false;
		}, 300);
	}

	function handleSmartViewFeedback(copilotFeature, feedbackType, onSubmitComplete) {
		payrollData.submitFeedbackForCurrentPeriod(companyObj.AgencyProfileID, payPeriod.PayPeriodID)
			.then(function () {
				onSubmitComplete(true);
			})
			.catch(function (error) {
				console.error(error);
				onSubmitComplete(false);
			});
	}

	function mapVarianceItems(items) {
		return items.map(item => {
			const nameParts = item.EmployeeName.split(' ');
			return {
				UserID: null,
				Forename: nameParts[0] || '',
				Surname: nameParts.slice(1).join(' ') || '',
				PayChangeDescription: item.Explanation,
				NetPayChange: item.ChangeInNetPay,
				TotalNetPay: item.NetPay,
				VariancePercentage: item.VariancePercentage
			};
		});
	}

	loadComponent();

	angular.extend($scope, {

		// Constants
		COPILOT_FEATURES,
		TABS,
		SUBMISSION_STATES,
		DRAFT_PAYSLIP_TASK_STATES,

		// Variables
		activeTab,
		alertDownloadState: null,
		epsCopied: false,
		fpsCopied: false,
		isChangesTabVisible,
		isInPlayground,
		isOpen: false,
		searchBarOptions: {
			changes: searchService.currentPeriodChanges,
			payrollAlerts: searchService.payrollAlerts,
			pensionHistory: searchService.pensionHistory,
			notes: searchService.notes,
			periodTasks: searchService.tasks,
			teamHistory: searchService.teamHistory
		},
		showCompleteTasks: true,
		smartViewSections: smartViewSections,

		// Functions
		createAlertReportDownload,
		handleFeedbackSubmitted,
		handleSmartViewFeedback,
		openAddAChangeForm,
		openBACSFileCreationForm,
		openCrossPeriodReportForm,
		openSmartViewInfoModal,
		refreshNotes,
		refreshTasks,
		reloadPage,
		reloadSmartView,
		setActiveTab,
		toggleDropdown,
		togglePercentageMode,
		toggleShowCompleteTasks,
		updateCopied,
		generateDraftPayslips,
		cancelSendDraftPayslips,
		retrySendDraftPayslips,
		recallDraftPayslips,
		recallDraftPayslipsDirectly,
		retryRecallDraftPayslips,
		isProcessingState
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payPeriodWorkflow', {
	bindings: {
		agencyProfileId: '<',
		loggedInUser: '<',
		onUpdate: '&',
		onRunPayroll: '=',
		payPeriod: '=',
		workflowTemplate: '='
	},
	controller: 'payPeriodWorkflowCtrl',
	templateUrl: 'components/pay-period-workflow/pay-period-workflow.component.html'
})
.controller('payPeriodWorkflowCtrl', ['$rootScope', 'USER_ROLES', 'WORKFLOW_TEMPLATE_ENTRY_STATES',
	function ($rootScope, USER_ROLES, WORKFLOW_TEMPLATE_ENTRY_STATES) {

	let $ctrl = this;

	function getCompleteFormTitle (actionType) {

		switch (actionType) {
			case 'go-back':
				return 'Go back';
			case 'query-reports':
				return 'Query reports';
		}
	}

	function openCompleteStepForm (ctrlObj, actionType) {

		$rootScope.openSlideInForm({
			actionType: actionType,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate, // TBC
			formKey: 'complete-step',
			payPeriod: $ctrl.payPeriod,
			title: getCompleteFormTitle(actionType),
			workflowTemplateEntry: ctrlObj.workflowTemplate.TemplateEntryCurrent,
			workflowTemplateId: ctrlObj.workflowTemplate.WorkflowTemplateID
		});
	}

	function openReassignStepForm (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'reassign-workflow-task',
			omitCurrentUser: true,
			showContext: true,
			title: 'Re-assign workflow step',
			workflowTasks: [ctrlObj.workflowTemplate.TemplateEntryCurrent]
		});
	}

	function openRunPayrollForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onRunPayroll,
			formKey: 'run-payroll'
		});
	}

	function toggleIsOpen ($ctrl) {
		$ctrl.isOpen = !$ctrl.isOpen;
	}

	angular.extend($ctrl, {
		USER_ROLES,
		WORKFLOW_TEMPLATE_ENTRY_STATES,

		isOpen: false,
		openCompleteStepForm,
		openReassignStepForm,
		openRunPayrollForm,
		toggleIsOpen
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('payPolicyHistoryCard', {
	bindings: {
		onViewSettings: '&',
		payPolicy: '<',
		showActions: '<?'
	},
	controller: 'payPolicyHistoryCardController',
	templateUrl: 'components/pay-policy-history-card/pay-policy-history-card.component.html'
})
.controller('payPolicyHistoryCardController', [
	'POLICY_PAY_BASES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_STATES',
function (
	POLICY_PAY_BASES,
	POLICY_PAY_BASES_DESCRIPTIONS,
	POLICY_STATES
) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		$ctrl.payPolicy.isCurrent = $ctrl.payPolicy.PolicyEffectiveDateISO === '';
		$ctrl.showActions = angular.isDefined($ctrl.showActions) ? $ctrl.showActions : true;
	};

	function onViewSettingsClick (ctrlObj) {
		if (angular.isFunction(ctrlObj.onViewSettings)) {
			ctrlObj.onViewSettings();
		}
	}

	angular.extend($ctrl, {
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_STATES,

		onViewSettingsClick
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('payStatementField', {
	bindings: {
		callback: '&',
		payment: '=',
		paymentAffectsNetPay: '<?',
		paymentCanEdit: '<?',
		paymentId: '@',
		paymentLabel: '<',
		paymentMin: '<?',
		paymentOriginal: '<',
		paymentOverride: '='
	},
	controller: 'payStatementFieldCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pay-statement-field/pay-statement-field.component.html',
})
.controller('payStatementFieldCtrl', [
	'$timeout',
	'teamData',
	'utilities',
	function (
		$timeout,
		teamData,
		utilities
	) {

	const $ctrl = this;

	const PAYMENT_STATE = {
		unedited: 0,
		editing: 1,
		loading: 2,
		saved: 3,
		error: -1
	};

	const PAYMENT_RESET = -1;

	function $onInit () {

		// If viewing pay statement in anything other than preview mode, then set states to unedited
		if (!$ctrl.payment.Override || !$ctrl.paymentCanEdit) {
			setFieldState(PAYMENT_STATE.unedited);
			return;
		}

		$ctrl.hasBeenEdited = ($ctrl.paymentOverride !== -1 && $ctrl.paymentOverride !== $ctrl.paymentOriginal);

		angular.extend($ctrl, {
			paymentPrevious: $ctrl.hasBeenEdited ? $ctrl.paymentOverride : $ctrl.paymentOriginal,
			paymentOverride: $ctrl.paymentOverride === PAYMENT_RESET ? null : $ctrl.paymentOverride,
			paymentCanEdit: angular.isDefined($ctrl.paymentCanEdit) ? $ctrl.paymentCanEdit : false,
		});

		setFieldState($ctrl.hasBeenEdited ? PAYMENT_STATE.saved : PAYMENT_STATE.unedited);
	}

	function editPayment ($ctrl) {

		setFieldState(PAYMENT_STATE.editing);

		// Only one field can be edited at a time, this will save other fields before editing new one
		if ($ctrl.payment.activeField) {
			$ctrl.payment.activeField();
		}

		// Attach function to payment so that it can be saved through other pay statement fields
		$ctrl.payment.activeField = function () {
			savePayment($ctrl);
		};

		utilities.focusOn($ctrl.paymentId + '-input', true);
	}

	function onError (errorMessage) {
		console.error(errorMessage);
		setFieldState(PAYMENT_STATE.error);
	}

	function onPropertyOverride () {

		setFieldState($ctrl.isPaymentReset ? PAYMENT_STATE.unedited : PAYMENT_STATE.saved);

		$ctrl.hasBeenEdited = !$ctrl.isPaymentReset;

		// Update net pay figure if payment isn't an employer payment
		if ($ctrl.paymentAffectsNetPay) {
			$ctrl.payment.NetPay = getNetPayCalculation($ctrl);
		}

		angular.extend($ctrl, {
			paymentPrevious: $ctrl.isPaymentReset ? $ctrl.paymentOriginal : $ctrl.paymentOverride,
			paymentOverride: $ctrl.isPaymentReset ? null : $ctrl.paymentOverride
		});

		if (angular.isFunction($ctrl.callback)) {
			$ctrl.callback();
		}
	}

	function setFieldState (newState) {
		$ctrl.fieldState = newState;
	}

	function getIsPaymentReset ($ctrl) {

		if ($ctrl.paymentOverride === null || $ctrl.paymentOverride === $ctrl.paymentOriginal) {
			return true;
		}

		return false;
	}

	function getNetPayCalculation ($ctrl) {

		// Add previous value then subtract new value
		return $ctrl.payment.NetPay + $ctrl.paymentPrevious - ($ctrl.hasBeenEdited ? $ctrl.paymentOverride : $ctrl.paymentOriginal);
	}

	function savePayment ($ctrl) {

		// Stop enter key from submitting if validation is missing
		if (angular.isDefined($ctrl.paymentMin) && angular.isUndefined($ctrl.paymentOverride)) {
			return;
		}

		// Clear payment active field so other properties can be updates
		$ctrl.payment.activeField = null;

		// Set to -1 if new value field is empty or update is the same as original
		$ctrl.isPaymentReset = getIsPaymentReset($ctrl);

		// Reset override value to -1 if empty or same as original
		if ($ctrl.isPaymentReset) {
			$ctrl.paymentOverride = PAYMENT_RESET;
		}

		// Ignore update and reset to previous state/values if one of these is true:
		// 1. Payment has been updated previously and update is the same value as old update
		// 2. Payment hasn't been updated or update is the same as original
		if (($ctrl.hasBeenEdited && $ctrl.paymentOverride === $ctrl.paymentPrevious) || (!$ctrl.hasBeenEdited && $ctrl.isPaymentReset)) {
			$ctrl.paymentOverride = $ctrl.isPaymentReset ? $ctrl.paymentOriginal : $ctrl.paymentPrevious;

			setFieldState($ctrl.hasBeenEdited ? PAYMENT_STATE.saved : PAYMENT_STATE.unedited);
			return;
		}

		setFieldState(PAYMENT_STATE.loading);

		// Update Override in in pay period - Use timeout to allow for Override property to be updated
		$timeout(updateUserPayPeriodOverride);
	}

	function updateUserPayPeriodOverride () {

		// Make a copy of override object to not affect other pay-statement-fields
		const overrideObj = angular.copy($ctrl.payment.Override);

		// Clear defaults from Override
		utilities.setAnyPropertiesToValueIfNull(overrideObj, -1);

		// Update Override
		teamData.updateUserPayPeriodOverride($ctrl.payment.agencyPayPeriodId, $ctrl.payment.userId, overrideObj)
			.then(onPropertyOverride)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		PAYMENT_STATE,

		editPayment,
		savePayment,
		errorMessages: {
			min: 'Value must be positive',
		},
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payrollAlertCard', {
	bindings: {
		agencyPayPeriodId: '<',
		agencyProfileId: '<',
		alert: '=',
		reloadAlerts: '=',
		icon: '@?',
		theme: '@?',
		setTab: '=?'
	},
	controller: 'payrollAlertCardCtrl',
	templateUrl: 'components/payroll-alert-card/payroll-alert-card.component.html',
})
.controller('payrollAlertCardCtrl', [
	'$rootScope',
	'$state',
	'config',
	'payrollWorker',
	'ALERT_ACTIONS',
	'PRESET_FILTER_KEYS',
	function (
		$rootScope,
		$state,
		config,
		payrollWorker,
		ALERT_ACTIONS,
		PRESET_FILTER_KEYS
	) {

	const $ctrl = this;

	function openDeletePayrollAlertForm (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyPayPeriodId: ctrlObj.agencyPayPeriodId,
			agencyProfileId: ctrlObj.agencyProfileId,
			alert: ctrlObj.alert,
			callback: ctrlObj.reloadAlerts,
			formKey: 'delete-payroll-alert',
		});
	}

	function openPendingChangesForm (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.reloadAlerts,
			contextType: 'company',
			formKey: 'tax-updates-confirmation',
			payPeriodId: ctrlObj.agencyPayPeriodId,
			title: 'Tax updates'
		});
	}

	function openNICategoryUpdatesForm (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.reloadAlerts,
			contextType: 'company',
			formKey: 'ni-category-updates',
			payPeriodId: ctrlObj.agencyPayPeriodId,
		});
	}

	function payrollResubmitAE ($ctrl) {

		$ctrl.pensionAeState = 'loading';

		payrollWorker.payrollResubmitAE($ctrl.alert.TargetID, config.guidEmpty).then(() => {

			$ctrl.pensionAeState = 'saved';
			reloadAlerts($ctrl);
		});
	}

	function viewChanges () {

		if (angular.isDefined($ctrl.setTab) && angular.isFunction($ctrl.setTab) &&
			$state.current.name === 'payroll.run-payroll' ) {
			$ctrl.setTab({id: 'changes'});
		} else {
			$state.go('payroll.current-period.changes');
		}
	}

	function viewReversedHmrcTaxUpdates (ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.reloadAlerts,
			contextType: 'company',
			formKey: 'reversed-hmrc-tax-updates',
			payPeriodId: ctrlObj.agencyPayPeriodId
		});
	}

	function reloadAlerts ($ctrl) {

		if (angular.isFunction($ctrl.reloadAlerts)) {
			$ctrl.reloadAlerts();
		}
	}

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			ALERT_ACTIONS,
			ICON_STATES: {
				none: 0,
				avatar: 1
			},
			PRESET_FILTER_KEYS,
			alertTheme: $ctrl.alert.alertTheme || $ctrl.theme,
			openDeletePayrollAlertForm,
			openPendingChangesForm,
			openNICategoryUpdatesForm,
			payrollResubmitAE,
			viewChanges,
			viewReversedHmrcTaxUpdates
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('payrollAlertCardBasic', {
	bindings: {
		icon: '@?',
		theme: '@?'
	},
	controller: 'payrollAlertCardBasicCtrl',
	templateUrl: 'components/payroll-alert-card/payroll-alert-card-basic.component.html',
	transclude: {
		'title': '?pacbTitle',
		'detail': '?pacbDetail'
	}
})
.controller('payrollAlertCardBasicCtrl', ['$transclude', function ($transclude) {

	const $ctrl = this;

	angular.extend($ctrl, {
		hasDetail: $transclude.isSlotFilled('detail'),
		hasTitle: $transclude.isSlotFilled('title')
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('payrollAlertsLevel', {
	bindings: {
		agencyPayPeriodId: '<',
		agencyProfileId: '<',
		level: '=',
		reloadAlerts: '&',
		searchBarOptions: '=',
		setTab: '=?'
	},
	templateUrl: 'components/payroll-alerts-level/payroll-alerts-level.component.html',
});

'use strict';

angular.module('paycircleApp')

.component('payrollPaymentSummary', {
	bindings: {
		isCisOnly: '<',
		payPeriod: '<',
		showPensionInfo: '<'
	},
	templateUrl: 'components/payroll-payment-summary/payroll-payment-summary.component.html'
});

'use strict';

angular.module('paycircleApp')
.directive('payrollState', function () {

	return {
		templateUrl: 'components/payroll-state/payrollStateComponent.html',
		replace: true,
		scope: {
			ceasePayeSchemeComplete: '<',
			ceasedDate: '<',
			payPeriod: '=',
		},
		controller: 'payrollStateController'
	};
})
.controller('payrollStateController', ['$scope', 'SUBMISSION_STATES', function ($scope, SUBMISSION_STATES) {

	// Scope constants
	$scope.SUBMISSION_STATES = SUBMISSION_STATES;
	$scope.ceasePayeSchemeComplete = $scope.ceasePayeSchemeComplete !== undefined ? $scope.ceasePayeSchemeComplete : false;
	$scope.ceasedDate = $scope.ceasedDate !== undefined ? $scope.ceasedDate : '';
}]);


'use strict';

angular.module('paycircleApp')
.component('payslipNotes', {
	bindings: {
		payslipNotesOptions: '='
	},
	controller: 'payslipNotesCtrl',
	templateUrl: 'components/payslip-notes/payslip-notes.component.html',
})
.controller('payslipNotesCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$sanitize',
	'$scope',
	'companyData',
	'mailData',
	'session',
	'teamData',
	'utilities',
	'EMOJIS',
	'PAYSLIP_NOTE_OPTIONS',
	function (
		$filter,
		$q,
		$rootScope,
		$sanitize,
		$scope,
		companyData,
		mailData,
		session,
		teamData,
		utilities,
		EMOJIS,
		PAYSLIP_NOTE_OPTIONS
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const payPeriodObj = $ctrl.payslipNotesOptions.payPeriod;
		const agencyProfileId = $ctrl.payslipNotesOptions.agencyProfileId;
		const searchBarOptionsObj = getSearchBarOptions($ctrl);

		angular.extend($ctrl, {
			options: [
				{
					optionLabel: 'Personalisation tags',
					optionsOnFirstPage: 2,
					optionTheme: 'tag',
					optionKey: 'tags',
					optionExtras: false
				},
				{
					optionLabel: 'Throw in an emoji',
					optionsOnFirstPage: 11,
					optionTheme: 'emoji',
					optionKey: 'emoji',
					optionExtras: true
				},
				{
					optionLabel: 'Our favourites',
					optionsOnFirstPage: 3,
					optionTheme: 'pill',
					optionKey: 'favourites',
					optionExtras: false
				}
			],
			team: [],
			teamMember: null,
			teamMembersHaveSameNote: false,
			payPeriodDisplay: payPeriodObj.PayPeriodDisplay,
			tags: PAYSLIP_NOTE_OPTIONS,
			input: {
				maxLength: 150,
				currentPosition: 0
			},
			functions: {}
		});

		const getCompanyCustomisation = companyData.getCompanyCustomisation(agencyProfileId);
		const getTeamMemberPayslipNotes = mailData.getTeamMemberPayslipNotes($ctrl.payslipNotesOptions.userIds, payPeriodObj.PayPeriodID, agencyProfileId);

		$q.all([
			getCompanyCustomisation,
			getTeamMemberPayslipNotes
		]).then(([
			customisationObj,
			teamMembersPayslipObj
		]) => {

			teamMembersPayslipObj = $filter('orderBy')(teamMembersPayslipObj, searchBarOptionsObj.orderBy, searchBarOptionsObj.orderByReverse);
			teamMembersPayslipObj = teamMembersPayslipObj.filter(decorateTeamMember($ctrl.payslipNotesOptions));

			angular.extend($ctrl, {
				company: $filter('customisation')(customisationObj),
				team: teamMembersPayslipObj,
			});

			setMember(teamMembersPayslipObj[0].PersonalDetails.UserID);

			changeState('ready');

			setPageState('ready');
		})
		.catch(onError);
	}

	function addTagToPayslipNote (tag, theme) {
		$scope.$broadcast('payslip-notes-added-tag', {
			tag: tag,
			theme: theme
		});
	}

 	function changeState (newState) {
 		if ($ctrl.formState !== newState) {
 			$ctrl.formState = newState;
 		}
 	}

	function cleanUpPayslipNote (payslipNote) {

		// Replace personalisation tags with {{..}}
		payslipNote = payslipNote.replace(/<div data-type="tag".*?>/g, '{{').replace(/<\/div>/g, '}}').replace(/  /g, ' ');
		// Fix firstname tag
		payslipNote = payslipNote.replace(/{{first name}}/g, '{{firstname}}');
		// Remove all HTML tags from message
		payslipNote = stripHTMLFromText(payslipNote);
		// Replace emojis with unicode string
		payslipNote = $filter('emojify')(payslipNote, 'demojify');

		return payslipNote;
	}

	function decorateTeamMember (payslipNoteOptionsObj) {

		return teamMemberObj => {
			angular.merge(teamMemberObj, {
				isValid: true,
				PayslipNote: {
					AgencyProfileID: payslipNoteOptionsObj.agencyProfileId,
					AgencyPayPeriodID: payslipNoteOptionsObj.payPeriod.PayPeriodID,
				},
				PersonalDetails: {
					UserID: teamMemberObj.PayslipNote.UserID
				}
			});

			setMessage(teamMemberObj);

			return teamMemberObj;
		};
	}

	function getPayslipNoteTextBeforeSave (ctrlObj) {

		return teamMemberObj => {

			const placeholderText = `Your custom payslip note will be displayed at the top of ${teamMemberObj.PersonalDetails.Forename}’s payslip.`;
			
			teamMemberObj.PayslipNote.Text = cleanUpPayslipNote(teamMemberObj.payslipNote);
	
			if (teamMemberObj.PayslipNote.Text === '' || teamMemberObj.PayslipNote.Text === placeholderText || (teamMemberObj.hasDefault && !ctrlObj.teamMembersHaveSameNote) || !teamMemberObj.isValid) {
				teamMemberObj.PayslipNote.Text = null;
			}

			return teamMemberObj;
		};
	}

	function getSearchBarOptions (ctrlObj) {

		const searchBarOptionsObj = ctrlObj.payslipNotesOptions.searchBarOptions;

		if (searchBarOptionsObj && searchBarOptionsObj.orderByOptions) {

			const storedOrderByKey = utilities.getFromStorage(searchBarOptionsObj.storageKeys.orderBy);
			let orderByOptionObj = utilities.getObjectFromArrayByKey(searchBarOptionsObj.orderByOptions, storedOrderByKey);

			orderByOptionObj = orderByOptionObj ? orderByOptionObj : searchBarOptionsObj.orderByOptions[0];

			angular.extend(searchBarOptionsObj, {
				orderBy: orderByOptionObj.field,
				orderByObj: orderByOptionObj,
				orderByReverse: orderByOptionObj.reverse,
			});
		}

		return searchBarOptionsObj;
	}

	function giveTeamMembersSameNote (ctrlObj) {

		for (let teamMemberObj of ctrlObj.team) {		
			if (ctrlObj.teamMembersHaveSameNote) {
				teamMemberObj.payslipNote = ctrlObj.teamMember.payslipNote;
			} else {
				setMessage(teamMemberObj);
			}
		}
	}

	function goToExpandedView (ctrlObj, optionType) {

		ctrlObj.optionKey = optionType;

		if (optionType === 'emoji') {
			ctrlObj.emojis = EMOJIS;
		}

		changeState('more');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function saveForm (ctrlObj, formObj) {

		formObj.state = 'saving';

		ctrlObj.team.forEach(getPayslipNoteTextBeforeSave(ctrlObj));

		mailData.updateTeamMemberPayslipNotes(ctrlObj.team).then(function () {

			setPageState('saved');

			if (angular.isFunction(ctrlObj.payslipNotesOptions.callback)) {

				ctrlObj.payslipNotesOptions.callback({
					userId: ctrlObj.teamMember.PersonalDetails.UserID
				});
			}

			$rootScope.setDemoTaskAsComplete('addPayslipNote', ctrlObj.teamMember.PersonalDetails.Forename);
		})
		.catch(onError);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function setMember (userID) {

		const teamArr = $ctrl.team;

		for (let i = 0; i < teamArr.length; i++) {

			teamArr[i].teamIndex = i+1;

			if (teamArr[i].PersonalDetails.UserID === userID) {
				$ctrl.teamMember = teamArr[i];
			}
		}
	}

	function setMessage (teamMemberObj) {

		if (teamMemberObj.PayslipNote.Text === '' || !teamMemberObj.PayslipNote.Text) {
			teamMemberObj.payslipNote = `Your custom payslip note will be displayed at the top of ${teamMemberObj.PersonalDetails.Forename}’s payslip.`;
			teamMemberObj.hasDefault = true;
		} else {	
			teamMemberObj.payslipNote = $filter('emojify')($sanitize(teamMemberObj.PayslipNote.Text));
		}
	}

	function stripHTMLFromText (message) {

		message = $sanitize(message);

		const tempArea = document.createElement('DIV');

		tempArea.innerHTML = message;
		message = tempArea.textContent || tempArea.innerText || '';
		message = message.replace('  ', ' ');
		message = message.replace(/&nbsp;/g, '\u00a0');

		return message;
	}

	angular.extend($ctrl, {

		$onInit,
		addTagToPayslipNote,
		changeState,
		giveTeamMembersSameNote,
		goToExpandedView,
		saveForm,
		setMember,

		customisation: session.customisation
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('payslipPreview', {
	bindings: {
		payslipPreviewOptions: '='
	},
	templateUrl: 'components/payslip-preview/payslip-preview.component.html',
});

'use strict';

angular.module('paycircleApp')

/**
 * A slightly more useful pluralise component. Allows use of {{substitutions}} and automatic
 * insertion of number words (up to ten) in place of the count.
 */
.component('pcPluralise', {
	bindings: {
		// Things to count
		count: '=',
		// What to show after the number when there aren't any. Optional, defaults to whatever 'many' is
		none: '@?',
		// What to show after the number when there's just one.
		single: '@',
		// What to show after the number when there are many (and when there aren't any if 'zero' isn't specified)
		multiple: '@',
		// Use words 'one', 'two', etc. (up to ten) in place of number. Defaults to false.
		useWords: '<?'
	},
	controller: 'pcPluraliseController',
	template: '<span>{{$ctrl.pluraliseText}}</span>'
})
.controller('pcPluraliseController', [
	'utilities',
	'$scope',
function (
	utilities,
	$scope
) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		// Default zero to many if not specified
		$ctrl.none = angular.isDefined($ctrl.none) ? $ctrl.none : $ctrl.multiple;
		// Default useWords to false
		$ctrl.useWords = angular.isDefined($ctrl.useWords) ? $ctrl.useWords : false;
		buildText($ctrl);

		// Watch for changes to the count and update
		$scope.$watch('$ctrl.count', function (oldCount, newCount) {
			// On change, rebuild the text
			if (oldCount !== newCount) {
				buildText($ctrl);
			}
		});
	};

	function buildText (ctrlObj) {
		let pluraliseText = '';
		pluraliseText += ctrlObj.useWords ? utilities.getNumberText(ctrlObj.count) : Number(ctrlObj.count).toString() + ' ';
		if (ctrlObj.count === 0) {
			pluraliseText += ctrlObj.none;
		}
		else if (ctrlObj.count === 1) {
			pluraliseText += ctrlObj.single;
		}
		else {
			pluraliseText += ctrlObj.multiple;
		}
		ctrlObj.pluraliseText = pluraliseText;
	}

}]);
'use strict';

angular.module('paycircleApp')
.component('pensionSchemeCard', {
	bindings: {
		agencyProfileId: '<',
		callback: '&',
		index: '<',
		pension: '<',
		totalNotAllocated: '<'
	},
	controller: 'pensionSchemeCardCtrl',
	templateUrl: 'components/pension-scheme-card/pension-scheme-card.component.html'
})
.controller('pensionSchemeCardCtrl', [
	'$rootScope',
	'dataTransfer',
	'PENSION_PROVIDER_APIS',
	'PENSION_STATES',
	'PENSION_TYPES',
	function (
		$rootScope,
		dataTransfer,
		PENSION_PROVIDER_APIS,
		PENSION_STATES,
		PENSION_TYPES
	) {

	const $ctrl = this;

	function hideMenus () {
		$ctrl.showMenu = false;
	}

	function openAuthoriseNestForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			callback: $ctrl.callback,
			employerReference: $ctrl.pension.EmployerReference,
			formKey: 'pension-scheme-authorise-nest'
		});
	}

	function openAuthorisePeoplesPensionForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			callback: $ctrl.callback,
			employerReference: $ctrl.pension.EmployerReference,
			formKey: 'pension-scheme-authorise-peoples-pension'
		});
	}

	function openAuthoriseSmartForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			callback: $ctrl.callback,
			employerReference: $ctrl.pension.EmployerReference,
			formKey: 'pension-scheme-authorise-smart'
		});
	}

	function openDeletePensionForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			pension: $ctrl.pension,
			callback: $ctrl.callback,
			formKey: 'pension-scheme-delete'
		});
	}

	function openPensionTeamForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			callback: $ctrl.callback,
			formKey: 'pension-scheme-team'
		});
	}

	angular.extend($ctrl, {
		PENSION_PROVIDER_APIS,
		PENSION_STATES,
		PENSION_TYPES,

		getURLRedirect: dataTransfer.getURLRedirect,
		hideMenus,
		openAuthoriseNestForm,
		openAuthorisePeoplesPensionForm,
		openAuthoriseSmartForm,
		openDeletePensionForm,
		openPensionTeamForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeDetail', {
	bindings: {
		pension: '<',
		showLabels: '<?',
		showStatus: '<?',
		theme: '<?',
		variant: '@?'
	},
	controller: 'pensionSchemeDetailCtrl',
	templateUrl: 'components/pension-scheme-detail/pension-scheme-detail.component.html',
	transclude: {
		action: '?psdAction'
	},
})
.controller('pensionSchemeDetailCtrl', [
	'$transclude',
	'PENSION_TYPES',
	'PENSION_ENROLMENT_STATES',
function (
	$transclude,
	PENSION_TYPES,
	PENSION_ENROLMENT_STATES
) {

	const $ctrl = this;

	function $onInit () {
		$ctrl.theme = angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-secondary';
		$ctrl.showLabels = angular.isDefined($ctrl.showLabels) ? $ctrl.showLabels : false;
		$ctrl.showStatus = angular.isDefined($ctrl.showStatus) ? $ctrl.showStatus : false;
	}

	angular.extend($ctrl, {
		$onInit,

		PENSION_ENROLMENT_STATES,
		PENSION_TYPES,

		hasAction: $transclude.isSlotFilled('action')
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeEmployerReferenceField', {
	bindings: {
		connectToProvider: '<',
		employerReference: '=',
		pensionProviderId: '<',
		pensionType: '<'
	},
	controller: 'pensionSchemeEmployerReferenceFieldCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/pension-scheme-employer-reference-field/pension-scheme-employer-reference-field.component.html',
})
.controller('pensionSchemeEmployerReferenceFieldCtrl', [
	'$q',
	'pensionData',
	'PENSION_PROVIDER_IDS',
	'PENSION_TYPES',
	function (
		$q,
		pensionData,
		PENSION_PROVIDER_IDS,
		PENSION_TYPES
	) {

	const $ctrl = this;

	const EMPLOYER_REFERENCE_FIELD_NAME = 'pensionRef';
	const EMPLOYER_REFERENCE_VALIDATOR_NAME = 'validEmployerReference';

	const VALIDATION_SERVICES = {
		[PENSION_PROVIDER_IDS.nest]: pensionData.isValidNestEmployerReference,
	};

	function $onInit () {

		angular.extend($ctrl, {
			isNestPension: PENSION_PROVIDER_IDS.nest === $ctrl.pensionProviderId,
			isValidationRequired: getIsEmployerReferenceValidationRequired(),
			originalEmployerReference: $ctrl.employerReference,
		});
	}

	function $postLink () {

		// Ignore when no validation is required
		if (!$ctrl.isValidationRequired) {
			return;
		}

		// Save formField $controller
		$ctrl.$formField = $ctrl.form[EMPLOYER_REFERENCE_FIELD_NAME];

		// Attach validator to field
		$ctrl.$formField.$asyncValidators[EMPLOYER_REFERENCE_VALIDATOR_NAME] = getEmployerReferenceValidator();
	}

	function getEmployerReferenceValidator () {
		return employerReference => {

			// Ignore if empty reference
			if ($ctrl.$formField.$isEmpty(employerReference)) {
				return $q.when();
			}

			// Ignore if same as the previous
			if (employerReference === $ctrl.originalEmployerReference) {
				return $q.when();
			}

			// Ignore if a validation service isn't setup for this provider
			const validationPromise = VALIDATION_SERVICES[$ctrl.pensionProviderId];
			if (!validationPromise || !angular.isFunction(validationPromise)) {
				return $q.when();
			}

			// Run validation service
			return $q((resolve, reject) => {
				validationPromise(employerReference)
					.then(isEmployerReferenceValid => {

						if (isEmployerReferenceValid) {
							resolve();
						}
						else {
							reject();
						}
					})
					.catch(reject);
			});
		};
	}

	function getIsEmployerReferenceValidationRequired () {

		// Ignore if no provider is selected
		if (angular.isUndefined($ctrl.pensionProviderId)) {
			return false;
		}

		// Only if "Connect directly to {provider}" is enabled
		if (!$ctrl.connectToProvider) {
			return false;
		}

		// Only run validation if service is added for pension provider
		return VALIDATION_SERVICES[$ctrl.pensionProviderId];
	}

	angular.extend($ctrl, {
		$onInit,
		$postLink,

		EMPLOYER_REFERENCE_FIELD_NAME,
		EMPLOYER_REFERENCE_VALIDATOR_NAME,
		PENSION_PROVIDER_IDS,
		PENSION_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeGroup', {
	bindings: {
		group: '=',
		index: '<',
		onGroupDelete: '&',
		pensionGroups: '<',
		pensionType: '<',
	},
	require: {
		form: '^form'
	},
	controller: 'pensionSchemeGroupCtrl',
	templateUrl: 'components/pension-scheme-group/pension-scheme-group.component.html',
})
.controller('pensionSchemeGroupCtrl', ['CONTRIBUTION_BASIS', 'CONTRIBUTION_BASIS_OPTIONS', 'PENSION_GROUP_EARNINGS_LIMIT_OPTIONS', 'PENSION_TYPES',
	function (CONTRIBUTION_BASIS, CONTRIBUTION_BASIS_OPTIONS, PENSION_GROUP_EARNINGS_LIMIT_OPTIONS, PENSION_TYPES) {

	const $ctrl = this;

	function $onInit () {
		getPensionSchemeHasDefaultGroup($ctrl);
	}

	function getPensionSchemeHasDefaultGroup ($ctrl) {

		const pensionSchemeHasDefaultGroup = $ctrl.pensionGroups.some(pensionGroupObj => pensionGroupObj.IsDefault);

		for (let pensionGroupObj of $ctrl.pensionGroups) {
			pensionGroupObj.pensionSchemeHasDefaultGroup = pensionSchemeHasDefaultGroup;
		}
	}

	function onGroupIsDefaultChange ($ctrl) {

		// Only one default at a time
		for (let pensionGroupIndex = 0; pensionGroupIndex < $ctrl.pensionGroups.length; pensionGroupIndex++) {
			if (pensionGroupIndex !== $ctrl.index) {
				$ctrl.pensionGroups[pensionGroupIndex].IsDefault = false;
			}
		}

		getPensionSchemeHasDefaultGroup($ctrl);
	}

	function reviewPensionDisregard (pensionGroupObj) {

		// Reset to prevent empty select as using integers rather than null as 'invalid' option
		if (!pensionGroupObj.HasEarningsLimitDisregard) {
			pensionGroupObj.EarningsLimitDisregard = 0;
		}
	}

	angular.extend($ctrl, {
		$onInit,

		CONTRIBUTION_BASIS,
		CONTRIBUTION_BASIS_OPTIONS,
		PENSION_GROUP_EARNINGS_LIMIT_OPTIONS,
		PENSION_TYPES,

		onGroupIsDefaultChange,
		reviewPensionDisregard,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeHeader', {
	bindings: {
		agencyProfileId: '<',
		callback: '&',
		pension: '<'
	},
	controller: 'pensionSchemeHeaderCtrl',
	templateUrl: 'components/pension-scheme-header/pension-scheme-header.component.html',
})
.controller('pensionSchemeHeaderCtrl', [
	'$rootScope',
	'$state',
	'dataTransfer',
	'PENSION_PROVIDER_APIS',
	'PENSION_STATES',
	'PENSION_TYPES',
	function (
		$rootScope,
		$state,
		dataTransfer,
		PENSION_PROVIDER_APIS,
		PENSION_STATES,
		PENSION_TYPES
	) {

	const $ctrl = this;

	function onDeletePension () {
		$state.go('pensions.summary', {agencyProfileId : $ctrl.agencyProfileId}, {reload: true});
	}

	function onTeamUpdate () {

		// Refresh page
		if (angular.isFunction($ctrl.callback)) {
			$ctrl.callback();
		}

		// Update team if on the scheme team page
		if ($state.is('pensions.scheme.team')) {
			$rootScope.$broadcast('update-pension-team');
		}
	}

	function openAuthoriseNestForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			showPensionContext: true,
			callback: $ctrl.callback,
			formKey: 'pension-scheme-authorise-nest'
		});
	}

	function openAuthorisePeoplesPensionForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			callback: $ctrl.callback,
			formKey: 'pension-scheme-authorise-peoples-pension'
		});
	}

	function openAuthoriseSmartForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			showPensionContext: true,
			callback: $ctrl.callback,
			formKey: 'pension-scheme-authorise-smart'
		});
	}

	function openDeletePensionForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			pension: $ctrl.pension,
			callback: onDeletePension,
			showPensionContext: true,
			formKey: 'pension-scheme-delete'
		});
	}

	function openManagePayElementsPensionForm () {

		$rootScope.openSlideInForm({
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			agencyProfileId: $ctrl.agencyProfileId,
			callback: onTeamUpdate,
			formKey: 'manage-pay-elements-pension',
			showPensionContext: true
		});
	}

	function openPensionTeamForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID,
			showPensionContext: true,
			callback: onTeamUpdate,
			formKey: 'pension-scheme-team'
		});
	}

	angular.extend($ctrl, {
		PENSION_PROVIDER_APIS,
		PENSION_STATES,
		PENSION_TYPES,

		getURLRedirect: dataTransfer.getURLRedirect,
		openAuthoriseNestForm,
		openAuthorisePeoplesPensionForm,
		openAuthoriseSmartForm,
		openDeletePensionForm,
		openManagePayElementsPensionForm,
		openPensionTeamForm,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeRow', {
	bindings: {
		fieldDisabled: '<?',
		fieldName: '@',
		fieldRequired: '<?',
		ngModel: '=',
		pension: '<',
		pensionIndex: '<'
	},
	controller: 'pensionSchemeRowCtrl',
	templateUrl: 'components/pension-scheme-row/pension-scheme-row.component.html',
	transclude: {
		content: '?pensionContent'
	},
})
.controller('pensionSchemeRowCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		hasContent: $transclude.isSlotFilled('content'),
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionSchemeState', {
	bindings: {
		state: '<',
		hasBorder: '<?'
	},
	controller: 'pensionSchemeStateCtrl',
	templateUrl: 'components/pension-scheme-state/pension-scheme-state.component.html',
})
.controller('pensionSchemeStateCtrl', ['PENSION_STATES', function (PENSION_STATES) {

	const $ctrl = this;

	function $onInit ()  {

		angular.extend($ctrl, {
			class: getPensionStateClass($ctrl.state),
			label: getPensionStateLabel($ctrl.state)
		});

	}

	function getPensionStateClass (pensionState) {

		switch (pensionState) {
			case PENSION_STATES.unauthorised:
			case PENSION_STATES.creating:
			case PENSION_STATES.pending:
				return 'tertiary inverse';

			case PENSION_STATES.active:
				return 'positive';

			case PENSION_STATES.rejected:
				return 'assertive inverse';

			case PENSION_STATES.inactive:
				return 'greyscale';

			case PENSION_STATES.reenrolment:
			case PENSION_STATES.reassessment:
				return 'indifferent-lighter';
		}
	}

	function getPensionStateLabel (pensionState) {

		switch (pensionState) {
			case PENSION_STATES.reenrolment:
				return 'Re-enrolment';
			case PENSION_STATES.reassessment:
				return 'Re-assessment';
		}

		return pensionState;
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionTeamGroup', {
	bindings: {
		formOptions: '<',
		pension: '<',
		pensionGroup: '<',
		theme: '@?'
	},
	controller: 'pensionTeamGroupCtrl',
	templateUrl: 'components/pension-team-group/pension-team-group.component.html',
})
.controller('pensionTeamGroupCtrl', ['PENSION_TYPES', function (PENSION_TYPES) {

	const $ctrl = this;

	angular.extend($ctrl, {
		PENSION_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('pensionTeamState', {
	bindings: {
		isClickable: '<?',
		pensionState: '=?'
	},
	controller: 'pensionTeamStateCtrl',
	templateUrl: 'components/pension-team-state/pension-team-state.component.html'
})
.controller('pensionTeamStateCtrl', [
	'$filter',
	'$rootScope',
	'utilities',
	function (
		$filter,
		$rootScope,
		utilities
	) {

	const $ctrl = this;

	function $onInit () {

		const pensionState = $ctrl.pensionState !== undefined ? $ctrl.pensionState : 'not assessed';

		angular.extend($ctrl, {
			isClickable: angular.isDefined($ctrl.isClickable) ? $ctrl.isClickable : false,
			pensionStateKey: utilities.toCamelCase(pensionState),
			pensionStateSlug: utilities.slugify(pensionState),
			styleClass: $filter('pensionStateClass')(pensionState)
		});
	}

	function onClick () {
		$rootScope.openModalDialog(`pension-${$ctrl.pensionStateSlug}`);
	}

	angular.extend($ctrl, {
		$onInit,
		onClick
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('periodTaskCard', {
	bindings: {
		agencyPayPeriodId: '<?',
		showTaskCompany: '<?',
		task: '=',
		refreshTasks: '&',
		showComplete: '<?',
		updateTasksCount: '&?'
	},
	controller: 'periodTaskCardCtrl',
	templateUrl: 'components/period-task-card/period-task-card.component.html',
})
.controller('periodTaskCardCtrl', ['$rootScope', 'messageData', 'MESSAGE_STATUS', function ($rootScope, messageData, MESSAGE_STATUS) {

	const $ctrl = this;

	function getCardTheme (taskObj) {

		let cardTheme = '';

		if (taskObj.IsComplete) {
			cardTheme = 'is-primary is-complete';
		} else {
			if (taskObj.IsOverdue) {
				cardTheme = 'is-assertive';
			} else {
				cardTheme = 'is-primary';
			}
		}

		return cardTheme;
	}

	function openDeletePeriodTaskForm (taskObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: taskObj.AgencyProfileID,
			callback: $ctrl.refreshTasks,
			formKey: 'delete-period-task',
			task: taskObj
		});
	}

	function openEditPeriodTaskForm (taskObj, reassignBool) {

		$rootScope.openSlideInForm({
			agencyProfileId: taskObj.AgencyProfileID,
			callback: $ctrl.refreshTasks,
			formKey: 'add-period-task',
			reassign: reassignBool,
			task: taskObj
		});
	}

	function updateMessageStatus (ctrlObj) {

		let taskObj = ctrlObj.task;
		let newMessageStatusEnum = taskObj.IsComplete ? MESSAGE_STATUS.complete : MESSAGE_STATUS.incomplete;

		messageData.updateMessageStatus(taskObj.MessageID, newMessageStatusEnum).then(() => {

			ctrlObj.cardTheme = getCardTheme(taskObj);
			if (angular.isFunction(ctrlObj.updateTasksCount)) {
				ctrlObj.updateTasksCount();
			}
		})
		.catch(error => {
		    console.error(error);
		});
	}

	$ctrl.$onInit = function () {

		$ctrl.cardTheme = getCardTheme($ctrl.task);
	};

	$ctrl.openDeletePeriodTaskForm = function (taskObj) {

	    openDeletePeriodTaskForm(taskObj);
	};

	$ctrl.openEditPeriodTaskForm = function (taskObj, reassignBool) {

	    openEditPeriodTaskForm(taskObj, reassignBool);
	};

	$ctrl.updateMessageStatus = function (ctrlObj) {

	    updateMessageStatus(ctrlObj);
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('permissionsSelector', {
	bindings: {
		roleDetail: '<',
		permissionsUpdated: '=?',
		isValid: '=?',
		changesCount: '=?',
	},
	controller: 'permissionsSelectorCtrl',
	templateUrl: 'components/permissions-selector/permissions-selector.component.html',
})
.controller('permissionsSelectorCtrl', ['$rootScope', '$scope', 'permissionsService',
	function ($rootScope, $scope, permissionsService) {

	const $ctrl = this;

	function checkValidity (ctrlObj) {
		ctrlObj.isValid = permissionsService.calculateRoleActiveActionsCount(ctrlObj.roleDetail) > 0;
	}

	function init () {

		setComponentState('loading');

		if (!angular.isDefined($ctrl.roleDetail)) {
			setComponentState('error');
			$rootScope.paycircleMessage('Permissions could not be loaded as a role detail wasnt defined', 'error');
			return;
		}

		angular.extend($ctrl, {
			permissionsUpdated: false,
			changesCount: 0,
			isValid: true,
		});

		setComponentState('ready');
	}

	function onUpdate (ctrlObj, permissionGroupObj) {
		recalculatePermissionValue(ctrlObj, permissionGroupObj);
		permissionsService.calculateActiveActionsCount(permissionGroupObj);
		checkValidity(ctrlObj);
	}

	function recalculatePermissionValue (ctrlObj, permissionGroupObj) {

		let newGroupValueInt = 0;

		if (permissionGroupObj.GroupVisible) {

			permissionGroupObj.GroupPermissionActions.forEach(pensionActionObj => {
				newGroupValueInt = pensionActionObj.IsActive ? newGroupValueInt + pensionActionObj.Value : newGroupValueInt;
			});
		}
		else {
			newGroupValueInt = -1;
		}

		ctrlObj.permissionsUpdated = true;

		permissionGroupObj.GroupValue = newGroupValueInt;

		return permissionGroupObj;
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	function togglePermissionGroupVisibility (ctrlObj, permissionGroupObj) {

		permissionGroupObj.GroupVisible = !permissionGroupObj.GroupVisible;

		ctrlObj.permissionsUpdated = (permissionGroupObj.GroupVisible !== permissionGroupObj.originalGroupVisible);

		updateChangesCountForGroup(ctrlObj, permissionGroupObj);
		onUpdate(ctrlObj, permissionGroupObj);
	}

	function togglePermission (ctrlObj, permissionObj, permissionGroupObj) {

		ctrlObj.permissionsUpdated = true;

		permissionObj.IsActive = !permissionObj.IsActive;

		updateChangesCountForPermission(ctrlObj, permissionObj);
		onUpdate(ctrlObj, permissionGroupObj);
	}

	function toggleShowPermissionGroup (permissionGroupObj) {
		permissionGroupObj.showGroup = !permissionGroupObj.showGroup;
	}

	function updateChangesCountForGroup (ctrlObj, permissionGroupObj) {

		const permissionGroupActionsCount = permissionGroupObj.GroupPermissionActions.length;
		let changesCount = ctrlObj.changesCount;

		if (permissionGroupObj.GroupVisible === permissionGroupObj.originalGroupVisible) {
			if (permissionGroupActionsCount === 0) {
				changesCount--;
			} else {
				changesCount = changesCount - permissionGroupActionsCount;
			}

		} else {
			if (permissionGroupActionsCount === 0) {
				changesCount++;
			} else {
				changesCount = changesCount + permissionGroupActionsCount;
			}
		}

		ctrlObj.changesCount = changesCount;
	}

	function updateChangesCountForPermission (ctrlObj, permissionObj) {

		if (permissionObj.IsActive === permissionObj.originalIsActive) {
			ctrlObj.changesCount--;
		} else {
			ctrlObj.changesCount++;
		}
	}

	angular.extend($ctrl, {
		$onInit: init,
		$onChanges: init,
		togglePermission,
		togglePermissionGroupVisibility,
		toggleShowPermissionGroup,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('placeholder', {
	templateUrl: 'components/placeholder/placeholder.component.html',
	controller: 'placeholderController',
	bindings: {
		placeholderGraphic: '@?', // 'team',
		placeholderGraphicSize: '@?', // 'm', 'l',
		placeholderLayout: '@?' // 'is-horizontal', 'is-vertical' (default)
	},
	transclude: {
		'copy': '?placeholderCopy',
		'primaryActions': '?placeholderPrimaryActions',
		'secondaryActions': '?placeholderSecondaryActions',
		'title': '?placeholderTitle'
	},
})
.controller('placeholderController', ['$scope', '$transclude', function ($scope, $transclude) {

	var $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.hasCopy = $transclude.isSlotFilled('copy');
		$ctrl.hasGraphic = $ctrl.placeholderGraphic !== undefined ? true : false;
		$ctrl.hasPrimaryActions = $transclude.isSlotFilled('primaryActions');
		$ctrl.hasSecondaryActions = $transclude.isSlotFilled('secondaryActions');
		$ctrl.hasTitle = $transclude.isSlotFilled('title');
		$ctrl.placeholderLayout = $ctrl.placeholderLayout === 'is-horizontal' ? 'is-horizontal' : 'is-vertical';
		$ctrl.placeholderGraphicSize = $ctrl.placeholderGraphicSize !== undefined ? $ctrl.placeholderGraphicSize : 'l';
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('playgroundActionBox', ['$rootScope', '$timeout', 'utilities', 'LOCAL_STORAGE_KEYS', function ($rootScope, $timeout, utilities, LOCAL_STORAGE_KEYS) {

	return {
		templateUrl: 'components/playground-action-box/playgroundActionBoxComponent.html',
		restrict: 'E',
		link: function ($scope) {

			var hasVisitedPlayground 	= utilities.getFromStorage(LOCAL_STORAGE_KEYS.hasVisitedPlayground) !== undefined;
			var loggedInUser 			= $rootScope.currentUser;

			// Scope variables
			$scope.isPlaygroundActionBoxOpen 	= !hasVisitedPlayground;
			$scope.isPlaygroundActionBoxVisible = hasVisitedPlayground;
			$scope.isPlaygroundModalVisible 	= !hasVisitedPlayground;
			$scope.loggedInUser 				= loggedInUser;

			// Scope functions
			$scope.startPlaying = function () {

				// Hide modal
				$scope.isPlaygroundModalVisible = false;

				// Show playground action box
				$scope.isPlaygroundActionBoxVisible = true;

				// Add to local storage
				utilities.addToStorage(LOCAL_STORAGE_KEYS.hasVisitedPlayground, 'true');

				// Close playground action box after 3 seconds
				$timeout(function () {

					$scope.isPlaygroundActionBoxOpen = false;
				}, 2000);
			};

			$scope.switchToLive = function () {
				$rootScope.$broadcast('toggle-playground');
			};

			$scope.togglePlaygroundActionBox = function () {

				$scope.isPlaygroundActionBoxOpen = !$scope.isPlaygroundActionBoxOpen;
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('policyCard', {
	bindings: {
		agencyProfileId: '=',
		onUpdate: '&?',
		policy: '<',
		policies: '<'
	},
	controller: 'policyCardController',
	templateUrl: 'components/policy-card/policy-card.component.html'
})
.controller('policyCardController', [
	'$rootScope',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_PAY_BASES',
	'POLICY_TYPES',
	'POLICY_TYPE_NAMES',
	'UPDATE_POLICY_MODES',
function (
	$rootScope,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES_DESCRIPTIONS,
	POLICY_PAY_BASES,
	POLICY_TYPES,
	POLICY_TYPE_NAMES,
	UPDATE_POLICY_MODES
) {

	const $ctrl = this;

	function addPolicyUpdate (ctrlObj, policyObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'add-pay-policy-update',
			payPolicyId: policyObj.PolicyID
		});
	}

	function deletePolicy (ctrlObj, policyObj) {

		// Delete policy - Same form used for all policy types
		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'delete-policy',
			policyId: policyObj.PolicyID
		});
	}

	function openPolicy (ctrlObj, policyObj, policiesArr, updatePolicyMode) {

		let titlePrefix = '';
		switch (updatePolicyMode) {
			case UPDATE_POLICY_MODES.edit: {
				titlePrefix = 'Edit';
				break;
			}
			case UPDATE_POLICY_MODES.view: {
				titlePrefix = 'View';
				break;
			}
			case UPDATE_POLICY_MODES.duplicate: {
				titlePrefix = 'Duplicate';
				break;
			}
		}
		const title = `${titlePrefix} ${policyObj.policyCategory} policy`;

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: policyObj.policyUpdateForm,
			policy: policyObj,
			policies: policiesArr,
			policyCategory: policyObj.policyCategory,
			title,
			updatePolicyMode
		});
	}

	function openPayPolicyHistory (payPolicyObj, ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			formKey: 'pay-policy-history',
			payPolicy: payPolicyObj,
		});
	}

	function viewPayPolicyPendingUpdate (ctrlObj, payPolicyObj) {

		// The add pay policy update form will work out that the policy has an update and display it. It's clever like that.
		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'add-pay-policy-update',
			payPolicyId: payPolicyObj.PolicyID,
			title: 'View policy update'
		});
	}

	angular.extend($ctrl, {

		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_PAY_BASES,
		POLICY_TYPES,
		POLICY_TYPE_NAMES,
		UPDATE_POLICY_MODES,

		addPolicyUpdate,
		deletePolicy,
		openPayPolicyHistory,
		openPolicy,
		viewPayPolicyPendingUpdate
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('policyBandCard', {
	bindings: {
		// Is selectable, optional, defaults to false
		isSelectable: '<?',
		// Show with highlight, optional, defaults to false
		isHighlighted: '<?',
		// Policy band (aka pay point)
		policyBand: '<',
		// Parent policy
		policy: '<'
	},
	controller: 'policyBandCardCtrl',
	templateUrl: 'components/policy-band-card/policy-band-card.component.html'
})

.controller('policyBandCardCtrl', [
	'config',
	'POLICY_BAND_PAY_LIMIT_TYPES',
	'POLICY_BAND_RATE_TYPES',
	'POLICY_BAND_STAT_PAYMENT_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_TYPES',
function (
	config,
	POLICY_BAND_PAY_LIMIT_TYPES,
	POLICY_BAND_RATE_TYPES,
	POLICY_BAND_STAT_PAYMENT_TYPES,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES,
	POLICY_TYPES
) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		// Defaults
		$ctrl.isHighlighed = angular.isDefined($ctrl.isHighlighted) ? $ctrl.isHighlighted : false;
		$ctrl.isSelectable = angular.isDefined($ctrl.isSelectable) ? $ctrl.isSelectable : false;
	};

	angular.extend($ctrl, {

		config,

		POLICY_BAND_PAY_LIMIT_TYPES,
		POLICY_BAND_RATE_TYPES,
		POLICY_BAND_STAT_PAYMENT_TYPES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES,
		POLICY_TYPES
	});

}]);

'use strict';

angular.module('paycircleApp')
/**
 * Policy band form field. Used for all types of policies, since there is commonality between them (they all operate
 * on the same object type).
 */
.component('policyBandFormField', {
	bindings: {
		// Allow band name editing
		allowNameEdit: '<?',
		// Unique index in the context of the parent policy
		index: '=',
		// Event handlers for team members if relevant
		onViewTeamMembers: '&?',
		// Parent policy
		policy: '<',
		// Policy band for this form field
		policyBand: '<',
		// Previous band for fixed values. Optional, since the first band won't have a previous.
		previousPolicyBand: '<?',
		// Show or hide actions
		showActions: '<?',
		// Uplift result comparison object
		upliftPreview: '<?'
	},
	controller: 'policyBandFormFieldController',
	require: {
		form: '^form'
	},
	templateUrl: 'components/policy-band-form-field/policy-band-form-field.component.html',
	transclude: true
})
.controller('policyBandFormFieldController', [
	'config',
	'policyService',
	'regexService',
	'utilities',
	'POLICY_BAND_CALCULATION_TYPES',
	'POLICY_BAND_PAY_LIMIT_TYPES',
	'POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS',
	'POLICY_BAND_RATE_TYPES',
	'POLICY_BAND_STAT_PAYMENT_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_TYPES',
	'REGEX',
function (
	config,
	policyService,
	regexService,
	utilities,
	POLICY_BAND_CALCULATION_TYPES,
	POLICY_BAND_PAY_LIMIT_TYPES,
	POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS,
	POLICY_BAND_RATE_TYPES,
	POLICY_BAND_STAT_PAYMENT_TYPES,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES,
	POLICY_TYPES,
	REGEX
) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		edit: 'edit',
		cannotDelete: 'cannotDelete',
		confirmDelete: 'confirmDelete'
	};

	$ctrl.$onInit = function () {

		angular.extend($ctrl, {
			// Defaults
			allowNameEdit: angular.isDefined($ctrl.allowNameEdit) ? $ctrl.allowNameEdit : true,
			showActions: angular.isDefined($ctrl.showActions) ? $ctrl.showActions : true,

			/* Unique IDs for all policy-related form fields. Since these are typically repeated in the
			   parent form, for multiple bands, they need to be different. */
			policyBandAnnualAllowanceFormFieldId: `policyBandAnnualAllowance${$ctrl.index}`,
			policyBandAnnualSalaryFormFieldId: `policyBandAnnualSalary${$ctrl.index}`,
			policyBandDurationFormFieldId: `policyBandDuration${$ctrl.index}`,
			policyBandEmployeeContributionFormFieldId: `policyBandEmployeeContribution${$ctrl.index}`,
			policyBandEmployerContributionFormFieldId: `policyBandEmployerContribution${$ctrl.index}`,
			policyBandHourlyRateFormFieldId: `policyBandHourlyRate${$ctrl.index}`,
			policyBandIsUpperRangeInfiniteFieldId: `policyBandIsUpperRangeInfinite${$ctrl.index}`,
			policyBandLengthOfServiceFromFormFieldId: `policyBandLengthOfServiceFrom${$ctrl.index}`,
			policyBandLengthOfServiceToFormFieldId: `policyBandLengthOfServiceTo${$ctrl.index}`,
			policyBandNameFormFieldId: `policyBandName${$ctrl.index}`,
			policyBandPayFormFieldId: `policyBandPay${$ctrl.index}`,
			policyBandPayLimitFormFieldId: `policyBandPayLimit${$ctrl.index}`,
			policyBandStatPayAdditionalFormFieldId: `policyBandStatPayAdditional${$ctrl.index}`,
			policyBandStatPayGroupId: `policyBandStatPay${$ctrl.index}`,
			policyBandStatPayIncludedFormFieldId: `policyBandStatPayIncluded${$ctrl.index}`,
			policyBandValueFromFormFieldId: `policyBandFTESalaryFrom${$ctrl.index}`,
			policyBandValueToFormFieldId: `policyBandFTESalaryTo${$ctrl.index}`
		});

		setComponentState(COMPONENT_STATES.edit);
	};

	function isPolicyBandNameUnique (policyBandToCheck, policy) {
		return !angular.isDefined(policy.PolicyBands.find(policyBand => {
			return (policyBand !== policyBandToCheck && policyBand.PolicyBandName === policyBandToCheck.PolicyBandName);
		}));
	}

	function onPayPolicyBandAnnualSalaryChange (policyObj, policyBandObj) {

		// Update hourly rate based on entered annual salary for policy band
		policyService.setPayPolicyBandHourlyRate(policyObj, policyBandObj);
	}

	function onPolicyBandNameChange (form, policy) {

		// Check the uniqueness of all band names
		policy.PolicyBands.forEach((policyBand, index) => {
			const formField = form[`policyBandName${index}`];
			const isBandNameUnique = isPolicyBandNameUnique(policyBand, policy);
			formField.$setValidity('nonUnique', isBandNameUnique);

			// Touch all invalid fields, since some could be invalided here without being touched
			if (!isBandNameUnique) {
				formField.$setTouched(true);
			}
		});
	}

	function onIsUpperRangeInfiniteChange (policyBandObj) {
		policyBandObj.PolicyBandValueTo = policyBandObj.isUpperRangeInfinite ? -1 : 0;
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	function toggleConfirmDeletePolicyBand (ctrlObj, policyBandObj) {

		if (ctrlObj.componentState === COMPONENT_STATES.edit) {
			// Switch to delete confirm or cannot delete (pay only) message depending on whether or not it's in use
			if (ctrlObj.policy.policyCategory === POLICY_CATEGORIES.pay && policyBandObj.isInUse) {
				// Assigned to team members, can't delete
				setComponentState(COMPONENT_STATES.cannotDelete);
			}
			else {
				setComponentState(COMPONENT_STATES.confirmDelete);
			}
		}
		else {
			// Return to view state from confirm or cannot delete state
			setComponentState(COMPONENT_STATES.edit);
		}
	}

	function toggleConfirmDeletePolicyBandEntitlementPeriod (policyBandEntitlementPeriodObj) {
		if (angular.isUndefined(policyBandEntitlementPeriodObj.confirmDelete)) {
			policyBandEntitlementPeriodObj.confirmDelete = true;
		}
		else {
			policyBandEntitlementPeriodObj.confirmDelete = !policyBandEntitlementPeriodObj.confirmDelete;
		}
	}

	function viewTeamMembers (ctrlObj) {
		if (angular.isFunction(ctrlObj.onViewTeamMembers)) {
			ctrlObj.onViewTeamMembers();
		}
	}

	angular.extend($ctrl, {

		config,
		policyService,
		regexService,
		utilities,

		COMPONENT_STATES,
		POLICY_BAND_CALCULATION_TYPES,
		POLICY_BAND_PAY_LIMIT_TYPES,
		POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS,
		POLICY_BAND_RATE_TYPES,
		POLICY_BAND_STAT_PAYMENT_TYPES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES,
		POLICY_TYPES,
		REGEX,

		onIsUpperRangeInfiniteChange,
		onPayPolicyBandAnnualSalaryChange,
		onPolicyBandNameChange,
		toggleConfirmDeletePolicyBand,
		toggleConfirmDeletePolicyBandEntitlementPeriod,
		viewTeamMembers
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('jobGradeCard', {
	bindings: {
		agencyProfileId: '=',
		jobGrade: '<',
		jobGrades: '<',
		onUpdate: '&?'
	},
	controller: 'jobGradeCardController',
	templateUrl: 'components/job-grade-card/job-grade-card.component.html'
})
.controller('jobGradeCardController', ['$rootScope', function ($rootScope) {

	const $ctrl = this;

	function deleteJobGrade (jobGradeObj, ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'delete-job-grade',
			jobGrade: jobGradeObj
		});
	}

	function editJobGrade (jobGradeObj, jobGradesArr, ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'update-job-grade',
			jobGrade: jobGradeObj,
			jobGrades: jobGradesArr,
			title: 'Edit job grade'
		});
	}

	function viewTeamMembers (jobGradeObj, ctrlObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.onUpdate,
			formKey: 'job-grade-team-members',
			jobGrade: jobGradeObj,
			title: 'View team members'
		});
	}

	angular.extend($ctrl, {
		deleteJobGrade,
		editJobGrade,
		viewTeamMembers
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('policyPensionSchemeCard', {
	bindings: {
		agencyProfileId: '=',
		pensionScheme: '<'
	},
	controller: 'policyPensionSchemeCtrl',
	templateUrl: 'components/policy-pension-scheme-card/policy-pension-scheme-card.component.html'
})
.controller('policyPensionSchemeCtrl', [
	'$state',
function (
	$state
) {

	const $ctrl = this;

	function goToScheme (pensionSchemeObj, ctrlObj) {
		$state.go('pensions.scheme.settings', {
			agencyEmployerPensionId: pensionSchemeObj.AgencyEmployerPensionID,
			agencyProfileId: ctrlObj.agencyProfileId
		});
	}

	angular.extend($ctrl, {
		goToScheme
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('poweredByPaycircle', function () {

    return {
        templateUrl: 'components/powered-by-paycircle/poweredByPaycircleComponent.html',
        replace: true,
		scope: {
			'theme': '@?'
		},
    };
});

'use strict';

angular.module('paycircleApp')
.component('printAddress', {
	bindings: {
		address: '=',
		displayAsForeign: '<?'
	},
	controller: 'printAddressCtrl',
	templateUrl: 'components/print-address/printAddressComponent.html'
})

.controller('printAddressCtrl', [
	'COUNTRY_UK',
function (
	COUNTRY_UK
) {
	const $ctrl = this;

	$ctrl.$onInit = () => {
		// Don't show country if it's the UK. That's the default and is implied.
		angular.extend($ctrl, {
			displayAsForeign: $ctrl.displayAsForeign || $ctrl.address.AddressForeign,
			showCountry: ($ctrl.address.AddressCountry.toUpperCase() !== COUNTRY_UK.name.toUpperCase()),
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('profileCard', {
	bindings: {
		avatarSize: '@?',
		meta: '<?',
		name: '<',
		theme: '@'
	},
	controller: 'profileCardCtrl',
	templateUrl: 'components/profile-card/profile-card.component.html',
	transclude: {
		'action': '?action',
	},
})
.controller('profileCardCtrl', ['$transclude', function ($transclude) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		$ctrl.avatarSize = angular.isDefined($ctrl.avatarSize) ? $ctrl.avatarSize : 'is-small';
		$ctrl.hasAction = $transclude.isSlotFilled('action');
		$ctrl.hasMeta = angular.isString($ctrl.meta);
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('profileDataBlock', {
	bindings: {
		pdbGroups: '<'
	},
	templateUrl: 'components/profile-data-block/profile-data-block.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('progressBar', {
	controller: 'progressBarComponentCtrl',
	bindings: {
		pbHasValue: '<?',
		pbPercentage: '=',
		pbSize: '@?',
		pbTheme: '@?',
		pbTemplate: '@?'
	},
	templateUrl: 'components/progress-bar/progress-bar.component.html',
})
.controller('progressBarComponentCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		$ctrl.pbShowValue = $ctrl.pbShowValue || false;
		$ctrl.pbSize = $ctrl.pbSize || 'is-medium';
		$ctrl.pbTheme = $ctrl.pbTheme || 'is-primary';
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('progressRing', {
	bindings: {
		prBadge: '@?',
		prIcon: '@?',
		prPercentage: '<?',
		prShowPercentage: '=?',
		prSize: '@?',
		prThemeComplete: '@?',
		prThemeIncomplete: '@?'
	},
	controller: 'progressRingCtrl',
	templateUrl: 'components/progress-ring/progress-ring.component.html',
	transclude: {
		prContent: '?prContent'
	},
})
.controller('progressRingCtrl', ['$transclude', function ($transclude) {

	const $ctrl = this;

	const RING_SIZES = {
		small: {
			boxSize: 50,
			strokeWidth: 4
		},
		normal: {
			boxSize: 64,
			strokeWidth: 5
		},
		medium: {
			boxSize: 80,
			strokeWidth: 6
		},
		large: {
			boxSize: 110,
			strokeWidth: 8
		},
		extraLarge: {
			boxSize: 130,
			strokeWidth: 9
		}
	};

	function calculateRingSize (ringSize) {

		const ringOptionsObj = RING_SIZES[ringSize || 'normal'];

		ringOptionsObj.circle = ringOptionsObj.boxSize / 2;
		ringOptionsObj.radius = ringOptionsObj.circle - ringOptionsObj.strokeWidth / 2;
		ringOptionsObj.circumference = ringOptionsObj.radius * 2 * Math.PI;

		return ringOptionsObj;
	}

	$ctrl.$onInit = function () {
		angular.extend($ctrl, {
			hasContent: ($transclude.isSlotFilled('prContent') && !$ctrl.prShowPercentage),
			prThemeIncomplete: $ctrl.prThemeIncomplete || 'greyscale',
			ringOptions: calculateRingSize($ctrl.prSize)
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.constant('PROGRESS_CARD_TYPES', {
	cis: 0,
	employment: 1,
	pension: 2,
	personal: 3
})

.constant('PROGRESS_GROUP_IDS', {
	personal: 0,
	employment: 1,
	additionalPost: 2,
	cisInformationSoleTraderOrPartnership: 3,
	cisInformationCompanyOrTrust: 4,
	cisCompany: 5,
	aePension: 6,
	additionalPostAEPension: 7
})

.constant('PROGRESS_GROUP_ACTION_IDS', {
	employment: {
		deletePost: 'employment.deletePost'
	},
	pension: {
		editPension: 'pension.editPension',
		deletePension: 'pension.deletePension'
	}
})

.component('progressCard', {

	bindings: {
		icon: '@',
		// Optional event handler for action click
		onActionClick: '<?',
		// Optional event handler to fire when clicking on a step. The group and step index will be thrown at this.
		onProgressStepClick: '<?',
		// Optional event handler to fire a primary action for the group
		onProgressGroupClick: '<?',
		/*
			Related progress groups to display. Each should be in this format:
			{
				notice: string - optional; message to display in the card
				actionName: string - optional; name of group UI action (e.g. 'Delete post' for additional posts)
				actionIcon: string - optional; icon to display with the action, 'icon-*'
				title: string - optional; title for this group
				id: number; unique dentifier
				data: Object - optional; data to pass back to event handler for processing
				steps: [
					{
						stepName: string; the name of the step to display,
						complete: boolean; true if the step is complete,
						disabled: boolean - optional; true to disable this step (defaults to false)
						title: string - optional; title to show on group
						actionName: string - optional; action to display
						actionIcon: 'icon-*' string - optional; action icon to display with action,
						wizardStepIndex: number - optional; wizard step to invoke. In combination with the group Id,
							event handlers can use this to identify which step of a slide-in wizard to invoke.
					},
					...
				]
			}
			Steps will occupy the main central area of the card in a two-column list, unless the
			main transclusion slot is filled, in which case the list will be a single column alongside that
		 */
		progressGroups: '<',
		/* Show or hide footer - transcluded content. Sticking an ng-if on the content to be transcluded doesn't seem to prevent the template
		   from believing it's there, hence this attribute instead of $ctrl.showFooter = $transclude.isSlotFilled('footer'). Defaults to false. */
		showFooter: '<?',
		teamMember: '<',
		theme: '@',
		title: '@',
		// Mode, one of the PROGRESS_CARD_TYPES values
		type: '='
	},
	controller: 'progressCardController',
	templateUrl: 'components/progress-card/progress-card.component.html',
	transclude: {
		// Optional footer, inserted below the main content
		'footer': '?pcFooter',
	}
})

.controller('progressCardController', [
	'PROGRESS_CARD_TYPES',
	'PROGRESS_GROUP_ACTION_IDS',
	'PROGRESS_GROUP_IDS',
function (
	PROGRESS_CARD_TYPES,
	PROGRESS_GROUP_ACTION_IDS,
	PROGRESS_GROUP_IDS
) {

	const $ctrl = this;

	function $onInit () {

		// Calculate percentage complete, total steps and steps complete for each progress group
		$ctrl.progressGroups.forEach(progressGroup => {
			const totalSteps = progressGroup.steps.length;
			const completedSteps = progressGroup.steps.reduce((count, step) => (step.complete ? count + 1 : count), 0);
			const percentComplete = (completedSteps * 100 / totalSteps);
			angular.extend(progressGroup, {
				complete: totalSteps === completedSteps,
				completedSteps,
				disabled: angular.isDefined(progressGroup.disabled) ? progressGroup.disabled : false,
				percentComplete,
				totalSteps
			});
		});

		/* Some types will insert a pane to show additional information. */
		const hasPane = $ctrl.type === PROGRESS_CARD_TYPES.pension;

		angular.extend($ctrl, {
			showFooter: angular.isDefined($ctrl.showFooter) ? $ctrl.showFooter : false,
			hasPane,
			linkTheme: `${$ctrl.theme}-light`
		});
	}

	function onGroupClick (ctrlObj, progressGroup, groupActionId) {
		if (angular.isFunction(ctrlObj.onProgressGroupClick)) {
			$ctrl.onProgressGroupClick(progressGroup, groupActionId);
		}
	}

	function onStepClick (ctrlObj, progressGroup, wizardStepIndex) {
		if (angular.isFunction(ctrlObj.onProgressStepClick)) {
			$ctrl.onProgressStepClick(progressGroup, wizardStepIndex);
		}
	}

	angular.extend($ctrl, {

		PROGRESS_CARD_TYPES,
		PROGRESS_GROUP_ACTION_IDS,
		PROGRESS_GROUP_IDS,

		$onInit,
		onGroupClick,
		onStepClick
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('progressSteps', {
	bindings: {
		activeStep: '<',
		hasSpacers: '<?',
		stepCount: '<',
		theme: '@?'
	},
	controller: 'progressStepsCtrl',
	templateUrl: 'components/progress-steps/progress-steps.component.html',
})
.controller('progressStepsCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		angular.extend($ctrl, {
			steps: new Array($ctrl.stepCount),
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'tertiary',
		});
	};
});

'use strict';

angular.module('paycircleApp')
.directive('questionBlockBureau', function () {

	return {
		controller: 'questionBlockBureauController',
		templateUrl: 'components/question-block-bureau/questionBlockBureauComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			qbGroup: '='
		}
	};
})
.controller('questionBlockBureauController', ['$scope', function ($scope) {

	$scope.qbGroup.showQuestions = false;
}]);

'use strict';

angular.module('paycircleApp')
.directive('questionBlockDemo', function () {

	return {
		controller: 'questionBlockDemoController',
		templateUrl: 'components/question-block-demo/questionBlockDemoComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			agencyProfileId: '<',
			pensions: '<',
			qbGroup: '<',
			qbOnUpdate: '=?'
		}
	};
})
.controller('questionBlockDemoController', ['$rootScope', '$scope', '$state', 'companyData', 'DEMO_QUESTION_GROUPS', 'DEMO_TASKS', 'DEMO_TASKS_SHORT', 'session', function ($rootScope, $scope, $state, companyData, DEMO_QUESTION_GROUPS, DEMO_TASKS, DEMO_TASKS_SHORT, session) {

	var agencyProfileId = $scope.agencyProfileId;
	var demoUserId = $scope.qbGroup.userId;
	var pensionsArr = $scope.pensions;

	function getDemoPage (demoTaskId) {

		switch (demoTaskId) {
			case DEMO_TASKS.companySettings.uploadCompanyPayslipLogo:
			case DEMO_TASKS.companySettings.changePayrollProcessingDate:
			case DEMO_TASKS.companySettings.switchToAutoRun:
				return 'settings.company.payroll-settings';
			case DEMO_TASKS.team.editSalary:
			case DEMO_TASKS.team.editTaxCode:
				return 'team.profile.information';
			case DEMO_TASKS.team.makeLeaver:
				return 'team.profile.overview';
			case DEMO_TASKS.payroll.addBonus:
			case DEMO_TASKS.payroll.addExpense:
				return 'payroll.current-period.changes';
			case DEMO_TASKS.payroll.addPayslipNote:
				return 'payroll.current-period.team';
			case DEMO_TASKS.holidayAndSickness.addHoliday:
			case DEMO_TASKS.holidayAndSickness.addSickness:
			case DEMO_TASKS.holidayAndSickness.editHoliday:
				return 'hr.holiday-sickness';
			case DEMO_TASKS.workplacePension.updateEmployeePensionContributions:
			case DEMO_TASKS.workplacePension.updateEmployeesPensionState:
				return 'pensions.scheme.team';
			case DEMO_TASKS.workplacePension.updateTeamPostponementSettings:
				return 'pensions.scheme.settings';
		}
	}

	$scope.goToTask = function (taskObj, onboardingQuestionGroupID) {

		var demo = {
			onboardingQuestionID: taskObj.OnboardingQuestionID,
			onboardingQuestionGroupID: onboardingQuestionGroupID,
			demoTaskId: taskObj.TaskID,
			demoTask: DEMO_TASKS_SHORT[taskObj.TaskID]
		};

		session.setActiveDemo(demo);

		var statePropertiesObj = {
			agencyProfileId: agencyProfileId,
			userid: demoUserId,
			userId: demoUserId
		};

		// Add Pension ID if pensions are available
		if (pensionsArr.length) {
			statePropertiesObj.agencyEmployerPensionId = pensionsArr[0].AgencyEmployerPensionID;
		}

		$state.go(getDemoPage(demo.demoTaskId), statePropertiesObj);
	};

	$scope.resetAllTasksInGroup = function (questionGroupObj) {

		companyData.updateOnboardingQuestionGroupComplete(questionGroupObj.onboardingId, questionGroupObj.OnboardingQuestionGroupID, false).then(function() {

			for (var question of $scope.qbGroup.Questions) {
				question.Complete = false;
			}

			questionGroupObj.totalQuestionsRemaining = questionGroupObj.totalQuestions;

			if (typeof $scope.qbOnUpdate() === 'function') {
				$scope.qbOnUpdate();
			}
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('questionBlockOnboarding', function () {

	return {
		controller: 'questionBlockOnboardingController',
		templateUrl: 'components/question-block-onboarding/questionBlockOnboardingComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			onboardingDashboard: '=',
			agencyProfileId: '<',
			onboardingQuestionGroups: '=',
			onboardingActions: '=',
			onUpdate: '='
		}
	};
})
.controller('questionBlockOnboardingController', ['$rootScope', '$scope', 'wizardService', 'FORM_WIZARD_KEYS', 'ONBOARDING_QUESTION_GROUPS',
	function ($rootScope, $scope, wizardService, FORM_WIZARD_KEYS, ONBOARDING_QUESTION_GROUPS) {

	var agencyProfileId = $scope.agencyProfileId;
	var companyPayrollFormsCount = wizardService.getWizardLastFormIndex(FORM_WIZARD_KEYS.companyPayroll);

	$scope.ONBOARDING_QUESTION_GROUPS = ONBOARDING_QUESTION_GROUPS;

	for (var i = 0; i < $scope.onboardingQuestionGroups.length; i++) {
		$scope.onboardingQuestionGroups[i].mobileTaskPosition = i+1;
	}

	function hideThisBlock () {

		resetBlock();
		$scope.onUpdate();
	}

	function resetBlock () {

		$scope.onboardingActions.closeAllTasks($scope.onboardingDashboard);
		$scope.onboardingActions.showTasksFor = null;
		$scope.activeGroup = null;
	}

	$scope.openCompanyPayrollWizard = function (questionGroupObj) {

		$rootScope.$broadcast('open-form-wizard', {
			activeStepIndex: questionGroupObj.isComplete ? companyPayrollFormsCount : undefined,
			agencyProfileId: agencyProfileId,
			callback: hideThisBlock,
			initCallbackOnClose: true,
			questionGroup: questionGroupObj,
			wizardKey: FORM_WIZARD_KEYS.companyPayroll
		});
	};

	$scope.openCompanyPensionConnectorForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: hideThisBlock,
			formKey: 'company-pension-connector',
			initCallbackOnClose: true
		});
	};

	$scope.openOnboardingQuestions = function (onboardingGroup) {

		if ($scope.tasksOpen && onboardingGroup.OnboardingQuestionGroupID !== $scope.activeGroup.OnboardingQuestionGroupID) {
			resetBlock();
		}
		if ($scope.onboardingActions.showTasksFor === onboardingGroup.OnboardingQuestionGroupID) {
			resetBlock();
		} else {
			$scope.activeGroup = onboardingGroup;
			$scope.onboardingActions.showTasksFor = onboardingGroup.OnboardingQuestionGroupID;
		}
	};

	$scope.openOnboardingWizardCompanyForm = function (activeGroupObj) {

		$rootScope.openSlideInForm({
			callback: hideThisBlock,
			formKey: 'onboarding-wizard-company',
			agencyProfileId: agencyProfileId,
			initCallbackOnClose: true,
			formStep: activeGroupObj.isComplete ? 5 : undefined
		});
	};

	$scope.openOnboardingWizardProfileForm = function (activeGroupObj) {

		$rootScope.openSlideInForm({
			callback: hideThisBlock,
			formKey: 'onboarding-wizard-profile',
			agencyProfileId: agencyProfileId,
			initCallbackOnClose: true,
			formStep: activeGroupObj.isComplete ? 6 : undefined
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('remoteLocationCard', {

	bindings: {
		agencyProfileId: '=',
		teamMemberAdmin: '<',
		refresh: '&?'
	},
	controller: 'remoteLocationCardCtrl',
	templateUrl: 'components/remote-location-card/remote-location-card.component.html'
})

.controller('remoteLocationCardCtrl', ['$rootScope', function ($rootScope) {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.hasIPAddress = angular.isDefined($ctrl.teamMemberAdmin.IPAddress) && $ctrl.teamMemberAdmin.IPAddress !== '';
	};

	function openDeleteRemoteLocationForm (ctrlObj, adminUserId) {

		ctrlObj.showActionMenu = false;

		$rootScope.openSlideInForm({
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.refresh(),
			contextType: 'user',
			formKey: 'delete-remote-location',
			title: 'Delete IP address',
			userId: adminUserId
		});
	}

	function openEditDetailsForm (ctrlObj, adminUserId) {

		ctrlObj.showActionMenu = false;

		$rootScope.openSlideInForm({
			adminUserId,
			agencyProfileId: ctrlObj.agencyProfileId,
			callback: ctrlObj.refresh(),
			contextType: 'company',
			formKey: 'company-settings-edit-remote-locations',
			title: 'Edit remote location'
		});
	}

	angular.extend($ctrl, {
		// Variables
		showActionMenu: false,

		// Functions
		openDeleteRemoteLocationForm,
		openEditDetailsForm
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('remoteLocationFormField', {

	bindings: {
		index: '=?',
		teamMemberAdmin: '<',
		name: '@',
		showDelete: '<?'
	},
	controller: 'remoteLocationFormFieldCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/remote-location-form-field/remote-location-form-field.component.html'
})

.controller('remoteLocationFormFieldCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.teamMemberAdmin.hasIPAddress = ($ctrl.teamMemberAdmin.IPAddress && $ctrl.teamMemberAdmin.IPAddress !== '');

		// IP address form field name
		$ctrl.ipAddressFieldName = `${$ctrl.name}_${$ctrl.index}_ip-address`;

		// Toggle confirm delete
		$ctrl.teamMemberAdmin.toggleConfirmDeleteIPAddress = false;
	};

	function toggleConfirmDeleteIPAddress (teamMemberAdmin) {
		teamMemberAdmin.confirmIPAddressDelete = !teamMemberAdmin.confirmIPAddressDelete;
	}

	function toggleHasIPAddress (teamMemberAdmin) {

		teamMemberAdmin.hasIPAddress = !teamMemberAdmin.hasIPAddress;
		if (!teamMemberAdmin.hasIPAddress) {
			// Clear out IP Address
			teamMemberAdmin.IPAddress = '';
			// Clear delete confirmation
			$ctrl.teamMemberAdmin.toggleConfirmDeleteIPAddress = false;
		}
	}

	angular.extend($ctrl, {
		toggleConfirmDeleteIPAddress,
		toggleHasIPAddress
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('repaymentCard', {
	controller: 'repaymentCardCtrl',
	templateUrl: 'components/repayment-card/repayment-card.component.html',
	bindings: {
		canEdit: '<?',
		onEdit: '&?',
		repayment: '=',
		rcLabel: '@?',
		rcViewType: '@?',
		rcTheme: '@?'
	}
})
.controller('repaymentCardCtrl', [
	'adjustmentsService',
	function (
		adjustmentsService
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			rcLabel: angular.isDefined($ctrl.rcLabel) ? $ctrl.rcLabel : 'Payment amount',
			rcViewType: angular.isDefined($ctrl.rcViewType) ? $ctrl.rcViewType : 'schedule', // payment || schedule
			rcTheme: angular.isDefined($ctrl.rcTheme) ? $ctrl.rcTheme : 'is-primary'
		});
	}

	function isPayrollBenefit (repaymentObj) {

		return adjustmentsService.getIsAdjustmentBehaviourOn(repaymentObj.PaymentScheduleGroupPayrollBIKBehaviour);
	}

	angular.extend($ctrl, {
		$onInit,
		isPayrollBenefit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportCard', {
	bindings: {
		agencyProfileId: '<',
		report: '='
	},
	controller: 'reportCardCtrl',
	templateUrl: 'components/report-card/report-card.component.html',
})
.controller('reportCardCtrl', ['REPORT_TEMPLATE_ACCESSIBILITY', function (REPORT_TEMPLATE_ACCESSIBILITY) {

	const $ctrl = this;

	$ctrl.REPORT_TEMPLATE_ACCESSIBILITY = REPORT_TEMPLATE_ACCESSIBILITY;
}]);

'use strict';

angular.module('paycircleApp')
	.component('reportCardClickable', {
		bindings: {
			action: '<?',
			icon: '@',
			subtitle: '@',
			title: '@',
		},
		controller: 'reportCardClickableController',
		templateUrl: 'components/report-card-clickable/report-card-clickable.component.html'
	})
	.controller('reportCardClickableController', [
		function () {

			let $ctrl = this;

			$ctrl.$onInit = function () {
				angular.extend($ctrl, {
					action: $ctrl.action,
					icon: $ctrl.icon,
					subtitle: $ctrl.subtitle,
					title: $ctrl.title,
				});
			};
		}]);

'use strict';

angular.module('paycircleApp')

.component('reportColumnFilters', {
	bindings: {
		isRootFilterGroup: '<?',
		isWithinReportCreator: '<?',
		onDeleteLastClause: '&?',
		reportFilterComponents: '<?',
		reportFilterEmptyClause: '<?',
		reportFilterEmptyGroup: '<?',
		reportFilterGroupId: '<?',
		reportTemplateColumns: '<',
		reportTemplateFilterGroup: '<'
	},
	controller: 'reportColumnFiltersCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/report-column-filters/report-column-filters.component.html'
})

.controller('reportColumnFiltersCtrl', [
	'$q',
	'config',
	'reportData',
	'tracking',
	'REPORT_TEMPLATE_FILTER_CONDITIONS',
	'REPORT_TEMPLATE_FILTER_OPERATORS',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	function (
		$q,
		config,
		reportData,
		tracking,
		REPORT_TEMPLATE_FILTER_CONDITIONS,
		REPORT_TEMPLATE_FILTER_OPERATORS,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS
	) {

	const $ctrl = this;

	const CLAUSE_VALUE_TYPE = {
		boolean: 'boolean',
		date: 'date',
		numberic: 'numberic',
		percentage: 'percentage',
		select: 'select',
		text: 'text'
	};

	const COMPONENT_STATES = {
		error: 'erorr',
		loading: 'loading',
		ready: 'ready'
	};

	function $onInit () {

		if (!$ctrl.isRootFilterGroup) {
			setComponentState(COMPONENT_STATES.ready);
			return;
		}

		setComponentState(COMPONENT_STATES.loading);

		// Load in clause conditions, object will be passed into child filter groups
		reportData.getReportTemplateFilterClauseComponents()
			.then(clauseComponentsObj => {

				angular.extend($ctrl, {
					reportTemplateColumns: getCorrectReportTemplateColumns(),
					reportFilterComponents: clauseComponentsObj,
					reportFilterGroupId: '0' // Root group (Child groups get will be '0-0', '0-1' etc, a group within '0-1' will be '0-1-0')
				});

				tracking.trackEvent(TRACKING_EVENTS.reporting.columnFilterAddedToTemplate, {
					event_category: TRACKING_EVENT_CATEGORIES.reporting
				});

				setComponentState(COMPONENT_STATES.ready);
			})
			.catch(onError);
	}

	function decorateEmptyFilterClauseObj (reportTemplateFilterClauseObj) {

		// Clear defaults and use first column as base
		angular.extend(reportTemplateFilterClauseObj, {
			ReportTemplateColumnID: $ctrl.reportTemplateColumns[0].ReportColumnID,
			ReportTemplateFilterClauseValue: null
		});

		// Attach first condition as default
		const defaultClauseConditionsArr = getClauseConditionsForColumn(reportTemplateFilterClauseObj);
		reportTemplateFilterClauseObj.ReportTemplateFilterClauseCondition = defaultClauseConditionsArr[0].ID;

		return reportTemplateFilterClauseObj;
	}

	function getClauseConditionsForColumn (reportTemplateFilterClauseObj) {

		// Returns list of applicable conditions for a column

		if (!reportTemplateFilterClauseObj || reportTemplateFilterClauseObj.ReportTemplateColumnID === config.guidEmpty) {
			return null;
		}

		// Find selected column from template
		const clauseColumnObj = $ctrl.reportTemplateColumns.find(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnID === reportTemplateFilterClauseObj.ReportTemplateColumnID);

		if (!clauseColumnObj) {
			return null;
		}

		// Find clause conditions by column content type
		const conditionsArr = $ctrl.reportFilterComponents.ContentTypes.find(reportFilterClauseObj => reportFilterClauseObj.CellContentType === clauseColumnObj.ReportColumnContentType).ValidConditions;

		// Attach description to each condition
		for (let conditionObj of conditionsArr) {
			conditionObj.displayLabel = REPORT_TEMPLATE_FILTER_CONDITIONS.find(filterConditionObj => filterConditionObj.value === conditionObj.ID).label;
		}

		return conditionsArr;
	}

	function getClauseValueIsVisible (reportTemplateFilterClauseObj) {

		// Certain conditions do not need a value, eg "Is empty"

		// Clear clause if there are no conditions available (Column may have been removed from ReportTemplateColumns)
		if (!reportTemplateFilterClauseObj.clauseConditions) {
			resetClause(reportTemplateFilterClauseObj);
			return;
		}

		const reportFilterClauseObj = getSelectedClauseCondition(reportTemplateFilterClauseObj);

		if (!reportFilterClauseObj) {
			return true;
		}

		return reportFilterClauseObj.IsInputRequired;
	}

	function getClauseValueTypeForCondition (reportTemplateFilterClauseObj) {

		// Clear clause if there are no conditions available (Column may have been removed from ReportTemplateColumns)
		if (!reportTemplateFilterClauseObj.clauseConditions) {
			resetClause(reportTemplateFilterClauseObj);
			return;
		}

		// Select
		const reportTemplateColumnsDetailObj = getSelectedClauseColumnsDetail(reportTemplateFilterClauseObj);
		if (reportTemplateColumnsDetailObj) {
			reportTemplateFilterClauseObj.clauseValueOptions = reportTemplateColumnsDetailObj.ValueOptions;
			return CLAUSE_VALUE_TYPE.select;
		}

		// Text only
		const reportFilterClauseConditionsObj = getSelectedClauseCondition(reportTemplateFilterClauseObj);
		if (!reportFilterClauseConditionsObj) {
			return CLAUSE_VALUE_TYPE.text;
		}

		// Boolean
		if (reportFilterClauseConditionsObj.IsBooleanInput) {
			return CLAUSE_VALUE_TYPE.boolean;
		}

		// Date
		if (reportFilterClauseConditionsObj.IsDateInput || reportFilterClauseConditionsObj.IsDateTimeInput) {
			return CLAUSE_VALUE_TYPE.date;
		}

		// Numeric
		if (reportFilterClauseConditionsObj.IsNumericInput || reportFilterClauseConditionsObj.IsPercentageInput) {
			return CLAUSE_VALUE_TYPE.numberic;
		}

		// Default to text
		return CLAUSE_VALUE_TYPE.text;
	}

	function getCorrectReportTemplateColumns () {

		if ($ctrl.isWithinReportCreator) {
			return $ctrl.reportTemplateColumns;
		}

		// If filters are used from within a report preview then property names are different,
		// return a simplified version of that using the properties we need with correct ColumnName
		else {

			// Make copy of columns so changes here don't affect anywhere else
			const reportTemplateColumnsCopyArr = angular.copy($ctrl.reportTemplateColumns);

			return reportTemplateColumnsCopyArr.map(reportTemplateColumnObj => {
				return {
					columnNameOverride: reportTemplateColumnObj.ColumnNameOverride,
					ReportColumnCanApplyFilter: reportTemplateColumnObj.CanApplyFilter,
					ReportColumnContentType: reportTemplateColumnObj.ContentType,
					ReportColumnID: reportTemplateColumnObj.ReportTemplateColumnID,
					ReportColumnName: reportTemplateColumnObj.ColumnNameOverride || reportTemplateColumnObj.ColumnName,
					ReportTemplateColumnEntryID: reportTemplateColumnObj.ReportTemplateColumnEntryID
				};
			});
		}
	}

	function getEmptyReportTemplateFilterGroup () {

		// Returns an empty filter group, either by getting it from the services or from when it's been passed down

		return $q((onComplete, onError) => {

			function returnCopyOfFilterGroup () {
				onComplete(angular.copy($ctrl.reportFilterEmptyGroup));
			}

			if (angular.isDefined($ctrl.reportFilterEmptyGroup)) {
				returnCopyOfFilterGroup();
			} else {

				reportData.getEmptyReportTemplateFilterGroup()
					.then(reportTemplateFilterGroupObj => {

						$ctrl.reportFilterEmptyGroup = reportTemplateFilterGroupObj;

						returnCopyOfFilterGroup();
					})
					.catch(onError);
			}
		});
	}

	function getEmptyReportTemplateFilterClause () {

		// Returns an empty filter clause, either by getting it from the services or from when it's been passed down

		return $q((onComplete, onError) => {

			function returnCopyOfFilterClause () {

				const newClauseObj = angular.copy($ctrl.reportFilterEmptyClause);

				onComplete(decorateEmptyFilterClauseObj(newClauseObj));
			}

			if (angular.isDefined($ctrl.reportFilterEmptyClause)) {
				returnCopyOfFilterClause();
			} else {

				reportData.getEmptyReportTemplateFilterClause()
					.then(reportTemplateFilterClauseObj => {

						$ctrl.reportFilterEmptyClause = reportTemplateFilterClauseObj;

						returnCopyOfFilterClause();
					})
					.catch(onError);
			}
		});
	}

	function getSelectedClauseColumnsDetail (reportTemplateFilterClauseObj) {
		return $ctrl.reportFilterComponents.ReportTemplateColumns.find(reportTemplateColumnObj => reportTemplateColumnObj.ReportTemplateColumnID === reportTemplateFilterClauseObj.ReportTemplateColumnID);
	}

	function getSelectedClauseCondition (reportTemplateFilterClauseObj) {
		return reportTemplateFilterClauseObj.clauseConditions.find(reportFilterClauseObj => reportFilterClauseObj.ID === reportTemplateFilterClauseObj.ReportTemplateFilterClauseCondition);
	}

	function onAddMenuAction () {
		$ctrl.showAddMenu = false;
	}

	function onAddReportFilterClause () {

		onAddMenuAction();

		getEmptyReportTemplateFilterClause()
			.then(reportTemplateFilterClauseObj => {
				$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.push(reportTemplateFilterClauseObj);
			})
			.catch(onError);
	}

	function onAddReportFilterGroup () {

		onAddMenuAction();

		getEmptyReportTemplateFilterGroup()
			.then(reportTemplateFilterGroupObj => {

				getEmptyReportTemplateFilterClause()
					.then(reportTemplateFilterClauseObj => {

						reportTemplateFilterGroupObj.ChildReportTemplateFilterClauses.push(reportTemplateFilterClauseObj);

						$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.push(reportTemplateFilterGroupObj);
					})
					.catch(onError);
			})
			.catch(onError);
	}

	function onClauseColumnChange (reportTemplateFilterClauseObj) {

		const defaultClauseConditionsArr = getClauseConditionsForColumn(reportTemplateFilterClauseObj);

		// Clear clause if there are no conditions available (Column may have been removed from ReportTemplateColumns)
		if (!defaultClauseConditionsArr) {
			resetClause(reportTemplateFilterClauseObj);
			return;
		}

		// Set defaults
		angular.extend(reportTemplateFilterClauseObj, {
			ReportTemplateFilterClauseCondition: defaultClauseConditionsArr[0].ID,
			ReportTemplateFilterClauseValue: null
		});
	}

	function onClauseDelete ($index) {

		// If this clause is the last in the group then delete the group from the parent level (unless it's the root group)
		if (
			$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.length === 1 &&
			$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.length === 0 &&
			angular.isFunction($ctrl.onDeleteLastClause)
		) {

			$ctrl.onDeleteLastClause();
			return;
		}

		$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.splice($index, 1);
	}

	function onError (error) {
		console.error(error);
		setComponentState(COMPONENT_STATES.error);
	}

	function onGroupDelete ($index) {

		// If this is the last child group within the parent group then delete the parent group (unless it's the root group)
		if (
			$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.length === 1 &&
			$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.length === 0 &&
			angular.isFunction($ctrl.onDeleteLastClause)
		) {

			$ctrl.onDeleteLastClause();
			return;
		}

		$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.splice($index, 1);
	}

	function resetClause (reportTemplateFilterClauseObj) {
		angular.extend(reportTemplateFilterClauseObj, {
			ReportTemplateFilterClauseCondition: null,
			ReportTemplateColumnID: null,
			ReportTemplateFilterClauseValue: null,
			clauseConditions: null
		});
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		getClauseConditionsForColumn,
		getClauseValueIsVisible,
		getClauseValueTypeForCondition,
		onAddReportFilterClause,
		onAddReportFilterGroup,
		onClauseColumnChange,
		onClauseDelete,
		onGroupDelete,

		CLAUSE_VALUE_TYPE,
		COMPONENT_STATES,
		REPORT_TEMPLATE_FILTER_CONDITIONS,
		REPORT_TEMPLATE_FILTER_OPERATORS,

		showAddMenu: false
	});
}])

.filter('reportColumnFiltersCorrectReportColumns',
	function () {
	return function (reportColumnsArr) {

		function isFilterableColumn (currentColumnObj) {
			return currentColumnObj.ReportColumnCanApplyFilter;
		}

		function getApplicableColumns (currentColumnObj) {

			const columnsOfSameTypeArr = reportColumnsArr.filter(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnID === currentColumnObj.ReportColumnID);

			// When there are duplicates, just return the first of them only
			if (columnsOfSameTypeArr.length > 1) {
				return columnsOfSameTypeArr[0].ReportTemplateColumnEntryID === currentColumnObj.ReportTemplateColumnEntryID;
			}

			// Return normal columns
			return true;
		}

		return reportColumnsArr
				.filter(getApplicableColumns)
				.filter(isFilterableColumn);
	};
})

.filter('reportColumnFiltersOperationLabel', [
	'REPORT_TEMPLATE_FILTER_OPERATORS',
	function (
		REPORT_TEMPLATE_FILTER_OPERATORS
	) {

	return function (operationValue) {
		return REPORT_TEMPLATE_FILTER_OPERATORS.find(operationTypeObj => operationTypeObj.value === operationValue).label;
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('reportCompanyFilters', {
	bindings: {
		reportRequestOptions: '<',
		selectedCompanyOptions: '='
	},
	controller: 'reportCompanyFiltersCtrl',
	templateUrl: 'components/report-company-filters/report-company-filters.component.html',
})
.controller('reportCompanyFiltersCtrl', [
	'INTERFACE_TYPES',
	function (
		INTERFACE_TYPES
	) {

	const $ctrl = this;

	const COMPANIES_PER_PAGE = 16;

	function $onInit () {

		angular.extend($ctrl, {
			companyTypes: getCompanyTypesFromCompanies()
		});

		$ctrl.isCompanyCountGreaterThanMaxAllowedCompanies = getIsCompanyCountGreaterThanMaxAllowedCompanies();

		updateIsSelectedForSelectedCompanies();
	}

	function attachGroupsToCompanies (companiesArr, companyGroupsArr) {

		// Attach group object into child company, attach company object onto parent company to use later

		for (let companyGroupObj of companyGroupsArr) {

			for (let childCompanyID of companyGroupObj.ChildInformation.ChildCompanyIDs) {

				const childCompanyObj = companiesArr.find(companyObj => companyObj.CompanyID === childCompanyID);
				
				if (childCompanyObj) {
					childCompanyObj.ParentInformation.parentGroups.push(companyGroupObj);
					companyGroupObj.ChildInformation.childCompanies.push(childCompanyObj);
				}
			}
		}
	}

	function getApplicableChildCompanies (companiesArr) {

		if ($ctrl.excludeArchivedCompanies) {
			return companiesArr.filter(childCompanyObj => !childCompanyObj.CompanyIsArchived);
		}
		else {
			return companiesArr;
		}
	}

	function getCompanyTypesFromCompanies () {

		// Split out companies into group and companies

		const companyGroupsArr = [];
		const companiesArr = [];

		for (let companyObj of $ctrl.reportRequestOptions.CompanyOptions) {
			switch (companyObj.CompanyTypeEnum) {
				case INTERFACE_TYPES.agency:
				case INTERFACE_TYPES.dual:
				case INTERFACE_TYPES.hypoonly:
				case INTERFACE_TYPES.pensiononly:
				case INTERFACE_TYPES.actualonly:
				case INTERFACE_TYPES.cisonly:
				case INTERFACE_TYPES.test:

					companyObj.ParentInformation.parentGroups = [];

					companiesArr.push(companyObj);
					break;

				case INTERFACE_TYPES.group:

					companyObj.isCompanyGroup = true;
					companyObj.ChildInformation.childCompanies = [];

					companyGroupsArr.push(companyObj);
					break;
			}
		}

		attachGroupsToCompanies(companiesArr, companyGroupsArr);

		return {
			types: [
				{
					typeName: 'Company groups',
					typeId: 'company-groups',
					typeList: companyGroupsArr
				},
				{
					typeName: 'Companies',
					typeId: 'companies',
					typeList: companiesArr
				}
			],
			companies: companiesArr,
			companyGroups: companyGroupsArr,
		};
	}

	function getIsCompanyCountGreaterThanMaxAllowedCompanies () {
		return $ctrl.reportRequestOptions.MaxCompanySelections && $ctrl.companyTypes.companies.length > $ctrl.reportRequestOptions.MaxCompanySelections;
	}

	function getIsCompanyFilterSelectionValid () {

		// Check only if limit is defined
		if ($ctrl.reportRequestOptions.MaxCompanySelections) {
			return getIsLessCompaniesThanMaxSelected();
		}

		return true;
	}

	function getIsLessCompaniesThanMaxSelected () {
		// Are too many companies already selected?
		return $ctrl.selectedCompanyOptions.length <= $ctrl.reportRequestOptions.MaxCompanySelections;
	}

	function getSelectedCompanyIDS () {

		// Return array of all selected companies and filter out archived companies if need be

		return getApplicableChildCompanies($ctrl.companyTypes.companies)
				.filter(companyObj => companyObj.isSelected)
				.map(companyObj => companyObj.CompanyID);
	}

	function onAllCompanyToggle (isSelectedBool) {

		// Set isSelected for all companies

		for (let companyObj of $ctrl.reportRequestOptions.CompanyOptions) {
			companyObj.isSelected = isSelectedBool;
		}

		updateSelectedCompanies();
	}

	function onCompanyClick (selectedCompanyObj) {

		// Toggle isSelected for companies and check for child companies if a group and parent group if a company

		selectedCompanyObj.isSelected = !selectedCompanyObj.isSelected;

		if (selectedCompanyObj.isCompanyGroup) {
			updateCompaniesIsSelectedWithinGroup(selectedCompanyObj);

		} else {
			updateParentGroupIsSelected(selectedCompanyObj);
		}

		updateSelectedCompanies();
	}

	function onExcludeArchivedChange () {

		// Deselect archived companies when excluding

		for (let companyObj of $ctrl.companyTypes.companies) {

			if ($ctrl.excludeArchivedCompanies && companyObj.CompanyIsArchived) {
				companyObj.isSelected = false;
			}

			updateParentGroupIsSelected(companyObj);

		}

		updateSelectedCompanies();
	}

	function updateCompaniesIsSelectedWithinGroup (groupObj) {

		// Set isSelected for companies in group
		for (let companyObj of getApplicableChildCompanies(groupObj.ChildInformation.childCompanies)) {
			companyObj.isSelected = groupObj.isSelected;
		}

		// Check if parent group still needs to be selected (company may be in multiple groups)
		for (let companyObj of getApplicableChildCompanies(groupObj.ChildInformation.childCompanies)) {
			updateParentGroupIsSelected(companyObj);
		}
	}

	function updateIsSelectedForSelectedCompanies () {

		// Set isSelected for pre pre selected companies

		for (let companyObj of $ctrl.companyTypes.companies) {

			companyObj.isSelected = $ctrl.selectedCompanyOptions.includes(companyObj.CompanyID);

			updateParentGroupIsSelected(companyObj);
		}
	}

	function updateParentGroupIsSelected (companyObj) {

		// Set isSelected for parent groups of companies

		for (let parentGroupObj of companyObj.ParentInformation.parentGroups) {

			if (parentGroupObj) {
				parentGroupObj.isSelected = getApplicableChildCompanies(parentGroupObj.ChildInformation.childCompanies)
					.every(childCompanyObj => childCompanyObj.isSelected);
			}
		}
	}

	function updateSelectedCompanies () {

		// Update selected companies

		angular.extend($ctrl, {
			hasUpdated: true,
			selectedCompanyOptions: getSelectedCompanyIDS()
		});

		// Disable form if there are too many companies selected
		$ctrl.isCompanyFilterSelectionValid = getIsCompanyFilterSelectionValid();
	}

	angular.extend($ctrl, {
		$onInit,

		onAllCompanyToggle,
		onCompanyClick,
		onExcludeArchivedChange,

		excludeArchivedCompanies: true,
		isCompanyFilterSelectionValid: true,
		searchBarOptions: {
			string: '',
			itemsPerPage: COMPANIES_PER_PAGE,
		}
	});

}])

.filter('reportingExcludeArchived', function () {

	function companyIsArchivedFilter (companyObj) {
		return !companyObj.CompanyIsArchived;
	}

	function companyFilter (companyObj) {

		// Only show group if it contains non archived companies
		if (companyObj.isCompanyGroup) {
			return companyObj.ChildInformation.childCompanies.some(companyIsArchivedFilter);

		} else {
			return companyIsArchivedFilter(companyObj);
		}
	}

	return (companiesArr, excludeArchivedCompanies) => {

		if (excludeArchivedCompanies) {
			return companiesArr.filter(companyFilter);
		}

		return companiesArr;
	};
});

'use strict';

angular.module('paycircleApp')
.component('reportDownloadCard', {
	bindings: {
		agencyProfileId: '<',
		canRegenerateBacs: '<?',
		formOptions: '<?',
		onUpdate: '&?',
		payPeriod: '<',
		report: '<',
		showCreatedDate: '<?',
		supplementaryPaymentId: '<?'
	},
	controller: 'reportDownloadCardCtrl',
	templateUrl: 'components/report-download-card/report-download-card.component.html',
})
.controller('reportDownloadCardCtrl', [
	'$filter',
	'$rootScope',
	'reportsService',
	'REPORT_TEMPLATE_IDS',
	function (
		$filter,
		$rootScope,
		reportsService,
		REPORT_TEMPLATE_IDS
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			canRegenerateBacs: angular.isDefined($ctrl.canRegenerateBacs) ? $ctrl.canRegenerateBacs : true
		});
	}

	function openRegenerateBACSFileForm () {

		openSlideInForm({
			callback: $ctrl.onUpdate,
			agencyDocumentId: $ctrl.report.FileID,
			agencyProfileId: $ctrl.agencyProfileId,
			formKey: 'regenerate-bacs-file',
			title: 'Regenerate BACS file',
			payPeriodId: $ctrl.payPeriod.PayPeriodID
		});

	}
	function openBacsConfirmationForm (report) {

		openSlideInForm({
			callback: $ctrl.onUpdate,
			agencyProfileId: $ctrl.agencyProfileId,
			reportObj: report,
			formKey: 'bacs-download-confirmation',
			title: 'Download BACS file',
		});
	}

	function openSlideInForm (formDetailsObj) {

		if (angular.isDefined($ctrl.formOptions)) {
			$ctrl.formOptions.openNewSlideInForm(formDetailsObj);

		} else {
			$rootScope.openSlideInForm(formDetailsObj);
		}
	}

	function viewReport () {

		reportsService.openReport(
			$ctrl.report,
			{ agencyProfileId: $ctrl.agencyProfileId, supplementaryPaymentId: $ctrl.supplementaryPaymentId },
			$ctrl.payPeriod
		);
	}

	function getDisplayNameFormatForId(){
		return $filter('slugify')($ctrl.report.DisplayName);
	}

	angular.extend($ctrl, {
		$onInit,

		REPORT_TEMPLATE_IDS,

		menuShow: false,

		exportReportDTO: reportsService.exportReportDTO,
		getDisplayNameFormatForId,
		openBacsConfirmationForm,
		openRegenerateBACSFileForm,
		viewReport
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportDownloads', {
	bindings: {
		reportCollection: '=',
		agencyProfileId: '<',
		payPeriod: '<?'
	},
	controller: 'reportDownloadsCtrl',
	templateUrl: 'components/report-downloads/report-downloads.component.html'
})
.controller('reportDownloadsCtrl', ['$q', 'reportData', 'utilities',
	function ($q, reportData, utilities) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		loading: 'loading',
		ready: 'ready',
		error: 'error',
	};

	function $onInit () {

		setComponentState(COMPONENT_STATES.loading);

		const getReportTemplatesForReporting = getReportTemplatesForReportingService($ctrl);
		const getReportTemplateFormatTypes = reportData.getReportTemplateFormatTypes();
		const getEmptyReportTemplateCollectionEntry = reportData.getEmptyReportTemplateCollectionEntry();

		$q.all([getReportTemplatesForReporting, getReportTemplateFormatTypes, getEmptyReportTemplateCollectionEntry]).then(
			([reportTemplatesArr, reportFormatsArr, emptyReportEntryObj]) => {

			const applicableReportTemplatesArr = getApplicableReportsFromTemplates(reportTemplatesArr);
			const applicableReportFormatsArr = getApplicableReportFormats(reportFormatsArr, applicableReportTemplatesArr);

			angular.extend($ctrl, {
				reportFormats: applicableReportFormatsArr,
				reportTemplates: decorateReports($ctrl, applicableReportTemplatesArr, applicableReportFormatsArr),
				emptyReportEntry: decorateEmptyReportEntry($ctrl, emptyReportEntryObj)
			});

			setComponentState(COMPONENT_STATES.ready);

			if ($ctrl.reportCollection.ReportTemplateCollectionEntries.length > 0) {
				updateReportCollection($ctrl);
			}
		})
		.catch(onError);
	}

	function decorateEmptyReportEntry (ctrlObj, emptyReportEntryObj) {

		emptyReportEntryObj.ReportTemplateCollectionID = ctrlObj.reportCollection.ReportTemplateCollectionID;

		return emptyReportEntryObj;
	}

	function decorateReports (ctrlObj, reportTemplatesArr, applicableReportFormatsArr) {

		const existingReportTemplateFormatIdsArr = ctrlObj.reportCollection.ReportTemplateCollectionEntries.map(reportCollectionEntryObj => reportCollectionEntryObj.ReportTemplateFormatID);

		reportTemplatesArr.forEach(reportTemplateObj => {

			const reportTemplateFormatsArr = [];

			applicableReportFormatsArr.forEach(formatObj => {

				const reportTemplateFormatObj = reportTemplateObj.ReportTemplateFormats.find(reportTemplateFormatObj => reportTemplateFormatObj.ReportTemplateFormatTypeID === formatObj.ReportTemplateFormatTypeID);

				const reportFormatObj = {
					includeReportInDownload: false,
					reportTemplateFormatId: null,
					reportTemplateFormatTypeId: null,
					showFormatInTemplate: true
				};

				if (reportTemplateFormatObj) {

					angular.extend(reportFormatObj, {
						includeReportInDownload: existingReportTemplateFormatIdsArr.includes(reportTemplateFormatObj.ReportTemplateFormatID),
						reportTemplateFormatId: reportTemplateFormatObj.ReportTemplateFormatID,
						reportTemplateFormatTypeId: reportTemplateFormatObj.ReportTemplateFormatTypeID
					});

				} else {
					angular.extend(reportFormatObj, {
						reportTemplateFormatId: utilities.guid(),
						showFormatInTemplate: false
					});
				}

				reportTemplateFormatsArr.push(reportFormatObj);

			}, []);

			reportTemplateObj.ReportTemplateFormats = reportTemplateFormatsArr;

			setIsReportActive(reportTemplateObj);

			return reportTemplateObj;
		});

		return reportTemplatesArr;
	}

	function getApplicableReportFormats (reportFormatsArr, reportsTemplatesArr) {

		const reportFormatTypeIds = getUsedFormatsIdsFromReportTemplates(reportsTemplatesArr);

		const reportFormatsUsedByReportsArr = reportFormatsArr.filter(reportFormatObj => reportFormatTypeIds.includes(reportFormatObj.ReportTemplateFormatTypeID));

		return reportFormatsUsedByReportsArr.filter(reportFormatObj => reportFormatObj.ReportTemplateFormatTypeCanDownload);
	}

	function getApplicableReportsFromTemplates (reportTemplatesArr) {
		return reportTemplatesArr.filter(reportTemplateObj => reportTemplateObj.CanAddToCollection);
	}

	function getReportTemplateFormats (reportsTemplatesArr) {
		return reportsTemplatesArr.map(reportTemplateObj => reportTemplateObj.ReportTemplateFormats).flat();
	}

	function getReportTemplatesForReportingService () {

		return $q((onComplete, onError) => {

			if (angular.isDefined($ctrl.payPeriod)) {

				reportData.getReportTemplatesForPeriodReportsZipDownload($ctrl.agencyProfileId, $ctrl.payPeriod.PayPeriodID)
					.then(onComplete)
					.catch(onError);

			} else {

				reportData.getReportTemplatesForPayrollReportsMail($ctrl.agencyProfileId)
					.then(onComplete)
					.catch(onError);
			}

		});
	}

	function getSelectedReportFormats (reportTemplatesArr) {
		return getReportTemplateFormats(reportTemplatesArr).filter(reportFormatObj =>  reportFormatObj.showFormatInTemplate && reportFormatObj.includeReportInDownload);
	}

	function getUsedFormatsIdsFromReportTemplates (reportsTemplatesArr) {

		const usedReportFormatsArr = getReportTemplateFormats(reportsTemplatesArr);

		const removedDuplicatesArr = utilities.removeDuplicatesFromArrayByObjectProperty(usedReportFormatsArr, 'ReportTemplateFormatTypeID');

		return removedDuplicatesArr.map(formatObj => formatObj.ReportTemplateFormatTypeID);
	}

	function onError (error) {
		console.error(error);
		setComponentState(COMPONENT_STATES.error);
	}

	function onFormatClick (ctrlObj, formatObj) {

		const reportsOfFormatArr = getReportTemplateFormats(ctrlObj.reportTemplates).filter(reportFormatObj => reportFormatObj.reportTemplateFormatTypeId === formatObj.ReportTemplateFormatTypeID && reportFormatObj.showFormatInTemplate);

		setIncludeInReportDownloadBulk(reportsOfFormatArr);

		ctrlObj.reportTemplates.forEach(setIsReportActive);

		updateReportCollection(ctrlObj);
	}

	function onReportFormatCheckboxChange (ctrlObj, reportTemplateObj) {

		setIsReportActive(reportTemplateObj);

		updateReportCollection(ctrlObj);
	}

	function onReportTemplateClick (ctrlObj, reportTemplateObj) {

		setIncludeInReportDownloadBulk(reportTemplateObj.ReportTemplateFormats);

		setIsReportActive(reportTemplateObj);

		updateReportCollection(ctrlObj);
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function setIncludeInReportDownloadBulk (reportTemplateFormatsArr) {

		const selectedReportsOfFormatArr = reportTemplateFormatsArr.filter(reportFormatObj => reportFormatObj.showFormatInTemplate && reportFormatObj.includeReportInDownload);
		const unselectedReportsOfFormatArr = reportTemplateFormatsArr.filter(reportFormatObj => reportFormatObj.showFormatInTemplate && !reportFormatObj.includeReportInDownload);

		reportTemplateFormatsArr.forEach(reportFormatObj => {
			reportFormatObj.includeReportInDownload = (selectedReportsOfFormatArr.length < unselectedReportsOfFormatArr.length);
		});
	}

	function setIsReportActive (reportFormatObj) {
		reportFormatObj.isActive = reportFormatObj.ReportTemplateFormats.some(reportFormatObj => reportFormatObj.showFormatInTemplate && reportFormatObj.includeReportInDownload);
	}

	function updateReportCollection (ctrlObj) {

		const selectedReportsArr = getSelectedReportFormats(ctrlObj.reportTemplates);

		ctrlObj.reportCollection.ReportTemplateCollectionEntries = selectedReportsArr.reduce((reportCollectionEntriesArr, selectedFormatReportObj) => {

			const reportCollectionEntryObj = angular.copy(ctrlObj.emptyReportEntry);

			reportCollectionEntryObj.ReportTemplateFormatID = selectedFormatReportObj.reportTemplateFormatId;

			reportCollectionEntriesArr.push(reportCollectionEntryObj);

			return reportCollectionEntriesArr;
		}, []);
	}

	angular.extend($ctrl, {
		$onInit,
		onFormatClick,
		onReportFormatCheckboxChange,
		onReportTemplateClick,

		COMPONENT_STATES
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('reportEntry', {
	bindings: {
		customReportEntry: '<',
		reportOptions: '<',
		currentSearch: '<'
	},
	controller: 'reportEntryCtrl',
	templateUrl: 'components/report-entry/report-entry.component.html'
})
.controller('reportEntryCtrl', [
	'$element',
	'reportDataGrid',
	function (
		$element,
		reportDataGrid
	) {

	const $ctrl = this;

	function $onInit () {

		angular.element(() => {
			reportDataGrid.createDataGrid($element[0], $ctrl.customReportEntry);
			if ($ctrl.currentSearch !== '') {
				// Get the current Search Term and trigger a search
				reportDataGrid.onSearch($ctrl.currentSearch);
			}
		});
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);


'use strict';

angular.module('paycircleApp')
.component('reportExportItem', {
	bindings: {
		onExport: '&?',
		report: '<',
		reportRequest: '<?',
		reportRequestOptions: '<',
		showFullName: '<?'
	},
	controller: 'reportExportItemCtrl',
	templateUrl: 'components/report-export-item/report-export-item.component.html',
})
.controller('reportExportItemCtrl', [
	'reportsService',
	'tracking',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	function (
		reportsService,
		tracking,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS
	) {

	const COMPONENT_STATES = {
		waiting: 'waiting',
		loading: 'loading'
	};

	const $ctrl = this;

	function $onInit () {

		reportsService.decorateReportDTO($ctrl.report);

		$ctrl.showFullName = angular.isDefined($ctrl.showFullName) ? $ctrl.showFullName : true;

		$ctrl.displayName = getDisplayName();
	}

	function exportReportDTO () {

		tracking.trackEvent(TRACKING_EVENTS.reporting.reportExported, {
			event_category: TRACKING_EVENT_CATEGORIES.reporting,
			event_label: $ctrl.displayName
		});

		// Override default export service
		if (angular.isFunction($ctrl.onExport)) {
			$ctrl.onExport();
			return;
		}

		setComponentState(COMPONENT_STATES.loading);

		reportsService.exportReportDTO($ctrl.report, $ctrl.reportRequest, $ctrl.reportRequestOptions)
			.finally(() => {
				setComponentState(COMPONENT_STATES.waiting);
			});
	}

	function getDisplayName () {
		return angular.isDefined($ctrl.showFullName) && $ctrl.showFullName ? $ctrl.report.exportName : $ctrl.report.FormatTypeDisplayName;
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		exportReportDTO,

		COMPONENT_STATES,
		componentState: COMPONENT_STATES.waiting
	});
}]);

  'use strict';

angular.module('paycircleApp')
.component('reportExports', {
	bindings: {
		reportDto: '<',
		reportRequest: '<',
		reportRequestOptions: '<'
	},
	templateUrl: 'components/report-exports/report-exports.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('reportFilterBar', {
	bindings: {
		activeFilterKey: '<?',
		draftReportRequest: '<',
		reportDto: '<',
		reportOptions: '<',
		reportRequest: '<?',
		reportRequestOptions: '<',
		setupReport: '&'
	},
	controller: 'reportFilterBarCtrl',
	templateUrl: 'components/report-filter-bar/report-filter-bar.component.html',
})
.controller('reportFilterBarCtrl', [
	'applicationService',
	'tracking',
	'REPORT_FILTER_KEYS',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	function (
		applicationService,
		tracking,
		REPORT_FILTER_KEYS,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS
	) {

	const $ctrl = this;

	const FILTER_TYPES = {

		// Additional
		[REPORT_FILTER_KEYS.additional]: {
			key: REPORT_FILTER_KEYS.additional,
			trackingKey: TRACKING_EVENTS.reporting.additionalFilterUsed,

			onOpen: () => {
				$ctrl.backupStorage.additionalOptions = angular.copy($ctrl.draftReportRequest.AdditionalOptions);
			},
			onCancel: () => {
				$ctrl.draftReportRequest.AdditionalOptions = angular.copy($ctrl.backupStorage.additionalOptions);
			}
		},

		// Columns
		[REPORT_FILTER_KEYS.columns]: {
			key: REPORT_FILTER_KEYS.columns,
			trackingKey: TRACKING_EVENTS.reporting.columnFilterUsed,

			onOpen: () => {
				$ctrl.backupStorage.reportTemplateFilter = angular.copy($ctrl.draftReportRequest.ReportTemplateFilter);
			},
			onCancel: () => {
				$ctrl.draftReportRequest.ReportTemplateFilter = angular.copy($ctrl.backupStorage.reportTemplateFilter);
			}
		},

		// Companies
		[REPORT_FILTER_KEYS.companies]: {
			key: REPORT_FILTER_KEYS.companies,
			trackingKey: TRACKING_EVENTS.reporting.companyFilterUsed,

			onOpen: () => {
				$ctrl.backupStorage.companyIds = angular.copy($ctrl.draftReportRequest.CompanyIDs);
			},
			onCancel: () => {
				$ctrl.draftReportRequest.CompanyIDs = angular.copy($ctrl.backupStorage.companyIds);
			},

			isCancelDisabled: () => {
				return $ctrl.backupStorage.companyIds.length === 0;
			},

			isSubmitDisabled: () => {
				return $ctrl.draftReportRequest.CompanyIDs.length === 0;
			}
		},

		// Periods
		[REPORT_FILTER_KEYS.periods]: {
			key: REPORT_FILTER_KEYS.periods,
			trackingKey: TRACKING_EVENTS.reporting.periodFilterUsed,

			onOpen: () => {
				$ctrl.backupStorage.periodOptions = angular.copy($ctrl.draftReportRequest.PeriodOptions);
			},
			onCancel: () => {
				$ctrl.draftReportRequest.PeriodOptions = angular.copy($ctrl.backupStorage.periodOptions);
			}
		}

	};

	function $onInit () {

		// Open active filter if there is one set
		if ($ctrl.reportOptions.isReportFilterBarActive && $ctrl.activeFilterKey) {
			onFilterTypeClick(FILTER_TYPES[$ctrl.activeFilterKey]);
		}
	}

	function onCancel () {

		// Hide bar
		$ctrl.reportOptions.isReportFilterBarActive = false;

		// Reset filter objects
		if (angular.isFunction($ctrl.activeFilterType.onCancel)) {
			$ctrl.activeFilterType.onCancel();
		}

		// Clear active filter
		$ctrl.activeFilterType = null;
	}

	function onFilterTypeClick (activeFilterType, activeIndex) {

		// Set active filter
		$ctrl.activeFilterType = activeFilterType;

		// Some filter types can have multiple buttons, so let the page know which one to open
		if (angular.isDefined(activeIndex)) {
			$ctrl.activeFilterType.activeIndex = activeIndex;
		}

		// Make backup of objects to restore on cancel
		if (angular.isFunction($ctrl.activeFilterType.onOpen)) {
			$ctrl.activeFilterType.onOpen();
		}

		// Show filter bar at the end to allow for changes to appear
		$ctrl.reportOptions.isReportFilterBarActive = true;
	}

	function onSubmit ($form) {

		$form.state = 'saving';

		// Cancel loading report
		applicationService.cancelPendingRequests();

		$ctrl.setupReport();

		// Track filter event
		tracking.trackEvent($ctrl.activeFilterType.trackingKey, {
			event_category: TRACKING_EVENT_CATEGORIES.reporting
		});

		// Close filter bar
		$ctrl.reportOptions.isReportFilterBarActive = false;

		// Clear selected filter
		$ctrl.activeFilterType = null;

		$form.state = null;
	}

	angular.extend($ctrl, {
		$onInit,

		onCancel,
		onFilterTypeClick,
		onSubmit,

		FILTER_TYPES,

		backupStorage: {}
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportFilterInputs', {
	bindings: {
		onFilterValueChange: '&?',
		reportRequestFilterOption: '<',
		reportActiveFilterOption: '<'
	},
	controller: 'reportFilterInputsComponentCtrl',
	templateUrl: 'components/report-filter-inputs/report-filter-inputs.component.html'
})
.controller('reportFilterInputsComponentCtrl', [
	'$scope',
	'config',
	'REPORT_PERIOD_OPTION_TYPE',
	function (
		$scope,
		config,
		REPORT_PERIOD_OPTION_TYPE
	) {

	const $ctrl = this;

	function getApplicableSecondValueListForRange () {

		if (!$ctrl.reportRequestFilterOption.Values[0]) {
			return;
		}

		// Only show items after selected item
		const valueOneIndex = $ctrl.reportActiveFilterOption.Items.findIndex(itemObj => itemObj.Value === $ctrl.reportRequestFilterOption.Values[0]);

		if (valueOneIndex !== -1) {
			$ctrl.reportActiveFilterOption.valueTwoItems = $ctrl.reportActiveFilterOption.originalItems.slice(valueOneIndex+1, $ctrl.reportActiveFilterOption.originalItems.length);

		} else {
			$ctrl.reportActiveFilterOption.valueTwoItems = $ctrl.reportActiveFilterOption.originalItems;
		}

		$ctrl.onFilterValueChange();
	}

	function getInitialValueForFilterType () {

		switch ($ctrl.reportActiveFilterOption.Type) {

			// Return last item and empty item
			case REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists:
				return [$ctrl.reportActiveFilterOption.Items[$ctrl.reportActiveFilterOption.Items.length-1].Value, null];

			// "December 2021 → January 2022"
			case REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers:

				const lastMonthMoment = moment().subtract(1, 'month');

				return [lastMonthMoment.format(config.dateFormatISO), lastMonthMoment.add(1, 'month').format(config.dateFormatISO)];

			default:
				return $ctrl.reportActiveFilterOption.Items[$ctrl.reportActiveFilterOption.Items.length-1].Value;
		}
	}

	function onReportRequestPeriodOptionKeyChange () {
		// Keep previous value
		const previousValue = $ctrl.reportRequestFilterOption.Value;

		// Clear previous values
		angular.extend($ctrl.reportRequestFilterOption, {
			Value: undefined,
			Values: undefined
		});

		// Assign defaults
		if ([
			REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists,
			REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers
		].includes($ctrl.reportActiveFilterOption.Type)) {
			$ctrl.reportRequestFilterOption.Values = getInitialValueForFilterType();
		}
		else {
			// Use previous value where possible
			const isPreviousValueValid = previousValue && $ctrl.reportActiveFilterOption.Items.some(function (item1){ return item1.Value === previousValue; });
			$ctrl.reportRequestFilterOption.Value = isPreviousValueValid ? previousValue : getInitialValueForFilterType();
		}

		// Save periods on range filters to create "to" date field
		if ($ctrl.reportActiveFilterOption.Type === REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists) {
			angular.extend($ctrl.reportActiveFilterOption, {
				originalItems: angular.copy($ctrl.reportActiveFilterOption.Items),
				valueTwoItems: $ctrl.reportActiveFilterOption.Items
			});
		}

		if ($ctrl.onFilterValueChange) {
			$ctrl.onFilterValueChange();
		}
	}

	angular.extend($ctrl, {
		REPORT_PERIOD_OPTION_TYPE,

		getApplicableSecondValueListForRange
	});

	$scope.$watch('$ctrl.reportActiveFilterOption.Type', function () {
			onReportRequestPeriodOptionKeyChange();
	});
}]);

'use strict';
angular.module('paycircleApp')
.component('reportNotice', {
	bindings: {
		reportDto: '<'
	},
	controller: 'reportNoticeCtrl',
	templateUrl: 'components/report-notice/report-notice.component.html',
})
.controller('reportNoticeCtrl', [
	'STATIC_REPORT_TEMPLATES',
	function(
		STATIC_REPORT_TEMPLATES
	) {
		const $ctrl = this;

		$ctrl.$onChanges = function(changes) {
			if (changes.reportDto && $ctrl.reportDto && $ctrl.reportDto.ReportTemplate) {
				let noticeInfo = null;
				if ($ctrl.reportDto.ReportTemplate.IsStaticReport){
					noticeInfo = getStaticReportNoticeInfo();
					if (noticeInfo && noticeInfo.notice) {
						noticeInfo.notice = noticeInfo.notice;
					}
				}
				$ctrl.noticeInfo = noticeInfo;
			}
		};

		function getStaticReportNoticeInfo()
		{
			const reportType = $ctrl.reportDto.ReportTemplate.ReportTemplateName;
			const reportTypeInfo = STATIC_REPORT_TEMPLATES.templates.find((t) => t.template.name === reportType);

			if (reportTypeInfo){
				return {
					title: reportTypeInfo.template.noticeTitle,
					notice: reportTypeInfo.template.notice
				};
			}

			return null;
		}
	}
]);
'use strict';

angular.module('paycircleApp')
.component('reportPackRow', {
	bindings: {
		reportTemplate:	'<',
		onTemplateEdit: '&?'
	},
	controller: 'reportPackRowCtrl',
	templateUrl: 'components/report-pack-row/report-pack-row.component.html'
})
.controller('reportPackRowCtrl', ['ADJUSTMENT_BEHAVIOUR_STATES', 'REPORT_TEMPLATE_ACCESSIBILITY', function (ADJUSTMENT_BEHAVIOUR_STATES, REPORT_TEMPLATE_ACCESSIBILITY) {

	const $ctrl = this;

	angular.extend($ctrl, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		REPORT_TEMPLATE_ACCESSIBILITY
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportPeriodFilters', {
	bindings: {
		reportRequestPeriodOption: '<',
		reportRequestOptions: '<'
	},
	controller: 'reportPeriodFiltersComponentCtrl',
	templateUrl: 'components/report-period-filters/report-period-filters.component.html'
})
.controller('reportPeriodFiltersComponentCtrl', [
	'reportsService',
	'utilities',
	'REPORT_PERIOD_FILTER_KEYS',
	function (
		reportsService,
		utilities,
		REPORT_PERIOD_FILTER_KEYS
	) {

	const $ctrl = this;

	function isDatesWithinLimit (startDateIso, endDateIso) {

		const differenceInMonths = utilities.getDifference(startDateIso, endDateIso, 'months', true);

		return differenceInMonths <= $ctrl.reportRequestOptions.MaxDateRangeMonths-1;
	}

	function getIsDateRangeValid () {

		function getIsDateRangeOverLimit () {

			if (!$ctrl.reportRequestPeriodOption.Values[0] || !$ctrl.reportRequestPeriodOption.Values[1]) {
				return false;
			}

			const startDateIso = $ctrl.reportRequestPeriodOption.Values[0];
			const endDateIso = $ctrl.reportRequestPeriodOption.Values[1];

			return isDatesWithinLimit(startDateIso, endDateIso);
		}

		// Limit period length
		if ($ctrl.reportRequestOptions.MaxDateRangeMonths) {
			return getIsDateRangeOverLimit();
		}

		return true;
	}

	function getIsPeriodRangeValid () {

		function getValidationDateForPeriodOption (value) {
			return $ctrl.activeFilterOption.Items.find(itemObj => itemObj.Value === value).ValidationDateISO;
		}

		function getIsPeriodRangeOverLimit () {

			if (!$ctrl.reportRequestPeriodOption.Values[0] || !$ctrl.reportRequestPeriodOption.Values[1]) {
				return false;
			}

			// Get dates for validation
			const startPeriodDateIso = getValidationDateForPeriodOption($ctrl.reportRequestPeriodOption.Values[0]);
			const endPeriodDateIso = getValidationDateForPeriodOption($ctrl.reportRequestPeriodOption.Values[1]);

			return isDatesWithinLimit(startPeriodDateIso, endPeriodDateIso);
		}

		// Limit period length
		if ($ctrl.reportRequestOptions.MaxDateRangeMonths) {
			return getIsPeriodRangeOverLimit();
		}

		return true;
	}

	function getIsPeriodFilterSelectionValid () {

		// Validtion for different filter types
		switch ($ctrl.activeFilterOption.Key) {

			case REPORT_PERIOD_FILTER_KEYS.dateRange:
				return getIsDateRangeValid();

			case REPORT_PERIOD_FILTER_KEYS.periodRange:
				return getIsPeriodRangeValid();
		}

		return true;
	}

	function onPeriodFilterValueChange () {

		// Disable submission if period selection is not valid
		$ctrl.isPeriodFilterSelectionValid = getIsPeriodFilterSelectionValid();
	}

	function updateActiveFilterOption () {
		$ctrl.activeFilterOption = reportsService.getReportRequestOptionsTypeOptionForKey($ctrl.reportRequestOptions.PeriodOptions, $ctrl.reportRequestPeriodOption.Key);
	}

	angular.extend($ctrl, {
		$onInit: updateActiveFilterOption,

		onPeriodFilterValueChange,
		onReportRequestPeriodOptionKeyChange: updateActiveFilterOption,

		REPORT_PERIOD_FILTER_KEYS,

		isPeriodFilterSelectionValid: true
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportSettingsCard', {
	bindings: {
		report: '<',
		agencyProfileId: '<'
	},
	templateUrl: 'components/report-settings-card/report-settings-card.component.html',
});

'use strict';

angular.module('paycircleApp')
.component('reportTemplateCard', {
	bindings: {
		reportTemplate: '=',
		agencyProfileId: '<',
		refreshTemplates: '=',
	},
	controller: 'reportTemplateCardCtrl',
	templateUrl: 'components/report-template-card/report-template-card.component.html',
})
.controller('reportTemplateCardCtrl', [
	'$rootScope',
	'reportsService',
	'REPORT_TEMPLATE_ACCESSIBILITY',
	function (
		$rootScope,
		reportsService,
		REPORT_TEMPLATE_ACCESSIBILITY
	) {

	const $ctrl = this;

	function openDeleteReportTemplateForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			formKey: 'delete-report-template',
			reportTemplate: $ctrl.reportTemplate,
			callback: $ctrl.refreshTemplates
		});
	}

	function openReportPreview () {

		reportsService.openReportFromReportTemplateId(
			$ctrl.reportTemplate.ReportTemplateID,
			{ agencyProfileId: $ctrl.agencyProfileId }
		);
	}

	function openReportTemplateForm (isEditTemplate, isDuplicateTemplate) {

		reportsService.openReportTemplateCreator(
			{
				agencyProfileId: $ctrl.agencyProfileId,
				callback: $ctrl.refreshTemplates,
				isDuplicateTemplate,
				isEditTemplate
			},
			$ctrl.reportTemplate
		);
	}

	angular.extend($ctrl, {
		openDeleteReportTemplateForm,
		openReportPreview,
		openReportTemplateForm,

		REPORT_TEMPLATE_ACCESSIBILITY
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportTemplateColumns', {
	bindings: {
		report: '=',
		reportCategory: '<'
	},
	controller: 'reportTemplateColumnsCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/report-template-columns/report-template-columns.component.html',
})
.controller('reportTemplateColumnsCtrl', [
	'reportsService',
	'utilities',
	function (
		reportsService,
		utilities
	) {

	const $ctrl = this;

	function $onInit () {
		updateTotalAvailableColumns();
	}

	function addRepeatColumnToReport (columnObj) {

		const repeatColumnCopyObj = getCopyOfColumn(columnObj);

		repeatColumnCopyObj.isSelected = true;

		toggleIsColumnSelected(repeatColumnCopyObj);
	}

	function getCopyOfColumn (columnObj) {

		const duplicateColumnObj = angular.copy(columnObj);

		duplicateColumnObj.isSelected = true;

		// Give column a different ID to avoid conflict with others in the array
		angular.extend(duplicateColumnObj, {
			originalReportColumnEntryId: duplicateColumnObj.ReportTemplateColumnEntryID,
			ReportTemplateColumnEntryID: utilities.guid()
		});

		return duplicateColumnObj;
	}

	function getDefaultColumnFormat (columnObj) {
		return columnObj.ReportColumnSelectableFormats.length > 0 ? columnObj.ReportColumnSelectableFormats.find(formatObj => formatObj.ReportTemplateColumnFormatIsDefault) : undefined;
	}

	function getSelectedColumnNames () {

		// Create array of column names, using the override name if it exists
		return $ctrl.report.ReportTemplateColumns
					.filter(columnObj => !columnObj.isColumnEditVisible)
					.map(columnObj => {
						return (columnObj.columnNameOverride ? columnObj.columnNameOverride : columnObj.ReportColumnName).toLowerCase();
					});
	}

	function getReportCategoryTotalAvailableColumns () {
		return $ctrl.reportCategory.ColumnGroups.reduce((counter, columnGroupObj) => counter + columnGroupObj.ReportColumns.length, 0);
	}

	function getReportCategoryTotalFilteredColumns () {
		return $ctrl.reportCategory.ColumnGroups.reduce((counter, columnGroupObj) => counter + columnGroupObj.filteredReportColumns.length, 0);
	}

	function onColumnDelselectClick (columnObj) {

		angular.extend(columnObj, {
			isSelected: false,
			columnNameOverride: undefined,
			reportTemplateColumnEntrySpecifiedText: undefined
		});

		toggleColumnEntry(columnObj);

		// Check if groupByColumn and/or splitByColumn must
		// be set to null so that the radio buttons in 'Settings' display correctly.
		if ($ctrl.report.groupByColumn !== null && ($ctrl.report.groupByColumn.ReportColumnID === columnObj.ReportColumnID)) {
			$ctrl.report.groupByColumn = null;
		}
		if ($ctrl.report.splitByColumn !== null && ($ctrl.report.splitByColumn.ReportColumnID === columnObj.ReportColumnID)) {
			$ctrl.report.splitByColumn = null;
		}
	}

	function onColumnDuplicateClick (columnObj, $index) {

		const duplicateColumnObj = getCopyOfColumn(columnObj);

		angular.extend(duplicateColumnObj, {
			isDuplicatedColumn: true,
			isDuplicatedColumnSaved: false,

			// Reset name override
			columnNameOverride: null
		});

		// Insert copy after original
		$ctrl.report.ReportTemplateColumns.splice($index+1, 0, duplicateColumnObj);

		// Open edit mode
		toggleIsColumnEditVisible(duplicateColumnObj);
	}

	function onColumnEditCancel (columnObj) {

		// If duplicated column is cancelled before saving then remove it
		if (columnObj.isDuplicatedColumn && !columnObj.isDuplicatedColumnSaved) {
			columnObj.isSelected = false;

			toggleColumnEntry(columnObj);
			return;
		}

		toggleIsColumnEditVisible(columnObj);

		// If column name has been changed then reset to previous value
		angular.extend(columnObj, columnObj.editBackup);
	}

	function onColumnEditClick (columnObj) {

		// If edit mode is enable then cancel form
		if (columnObj.isColumnEditVisible) {
			onColumnEditCancel(columnObj);
			return;
		}

		toggleIsColumnEditVisible(columnObj);

		scrollToColumnEditArea(columnObj);

		// Save some properties in case they need to be reset later
		if (columnObj.isColumnEditVisible) {
			columnObj.editBackup = {
				columnNameOverride:  angular.isDefined(columnObj.columnNameOverride) ? columnObj.columnNameOverride : undefined,
				isColumnHidden: angular.isDefined(columnObj.isColumnHidden) ? columnObj.isColumnHidden : undefined,
				reportTemplateColumnEntryFormat: angular.isDefined(columnObj.reportTemplateColumnEntryFormat) ? columnObj.reportTemplateColumnEntryFormat : undefined,
				reportTemplateColumnEntrySpecifiedText: angular.isDefined(columnObj.reportTemplateColumnEntrySpecifiedText) ? columnObj.reportTemplateColumnEntrySpecifiedText : undefined
			};
		}
	}

	function onColumnEditSubmit (columnObj) {

		// Mark duplicate as saved
		if (columnObj.isDuplicatedColumn && !columnObj.isDuplicatedColumnSaved) {
			onDuplicateColumnSave(columnObj);
		}

		toggleIsColumnEditVisible(columnObj);
	}

	function onColumnNameOverrideChange (currentColumnObj, $field) {

		if (!currentColumnObj.columnNameOverride) {
			return;
		}

		const selectedColumnNamesArr = getSelectedColumnNames();

		// Column names should be unique
		const numberOfColumnsWithSameName = selectedColumnNamesArr.indexOf(currentColumnObj.columnNameOverride.toLowerCase()) === -1;

		$field.$setValidity('nonUnique', numberOfColumnsWithSameName);
	}

	function onDuplicateColumnSave (columnObj) {

		angular.extend(columnObj, {
			isDuplicatedColumnSaved: true
		});
	}

	function onSearchChange () {

		// Show placeholder if no columns are returning in search
		$ctrl.isSearchReturningZeroColumns = $ctrl.searchTerm && getReportCategoryTotalFilteredColumns() === 0 ? true : false;
	}

	function scrollToColumnEditArea (columnObj) {

		// Scroll form element into view when it's loaded
		angular.element( document.getElementById(`${columnObj.ReportTemplateColumnEntryID}-entryForm`))
			.ready(() => {

				const columnEditFormElement = document.getElementById(`${columnObj.ReportTemplateColumnEntryID}-entryForm`);

				columnEditFormElement.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			});
	}

	function setDefaultPropertiesToSelectedColumn (columnObj) {

		angular.extend(columnObj, {
			columnNameOverride: null,
			isColumnHidden: false,
			isColumnValid: true,
			isDuplicatedColumn: false,
			isDuplicatedColumnSaved: false,
			reportTemplateColumnEntryFormat: getDefaultColumnFormat(columnObj),
			reportTemplateColumnEntrySpecifiedText: null
		});
	}

	function toggleAllColumnsInGroup (groupObj, isSelected) {

		for (let columnObj of groupObj.ReportColumns) {

			if (columnObj.isSelected !== isSelected) {

				columnObj.isSelected = isSelected;

				toggleIsColumnSelected(columnObj);
			}

		}
	}

	function toggleColumnEntry (columnEntryObj) {

		// Get index of column entry within template
		const columnEntryIndex = $ctrl.report.ReportTemplateColumns.findIndex(selectedColumnObj => selectedColumnObj.ReportTemplateColumnEntryID === columnEntryObj.ReportTemplateColumnEntryID);

		// Get column within category
		const reportCategoryColumnObj = $ctrl.reportCategory.allAvailableColumns.find(reportCategoryColumnObj => reportCategoryColumnObj.ReportColumnID === columnEntryObj.ReportColumnID);

		// Remove column from template
		$ctrl.report.ReportTemplateColumns.splice(columnEntryIndex, 1);

		// Set isSelected flag on category column if there are entries of the same type selected still
		reportCategoryColumnObj.isSelected = $ctrl.report.ReportTemplateColumns.some(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnID === reportCategoryColumnObj.ReportColumnID);
	}

	function toggleIsColumnEditVisible (columnObj) {

		angular.extend(columnObj, {
			isColumnEditVisible: !columnObj.isColumnEditVisible,
			isColumnValid: !columnObj.isColumnValid,
		});
	}

	function toggleIsColumnSelected (columnObj) {

		if (columnObj.isSelected) {

			const newColumnObj = getCopyOfColumn(columnObj);

			setDefaultPropertiesToSelectedColumn(newColumnObj);

			$ctrl.report.ReportTemplateColumns.push(newColumnObj);

			// Set orderby to first column by default
			if ($ctrl.report.ReportTemplateColumns.length === 1) {
				$ctrl.report.orderByColumn = newColumnObj;
			}

		} else {

			const columnsOfSameTypeArr = $ctrl.report.ReportTemplateColumns.filter(reportTemplateColumnObj => reportTemplateColumnObj.ReportColumnID === columnObj.ReportColumnID);

			for (let columnOfSameTypeObj of columnsOfSameTypeArr) {

				toggleColumnEntry(columnOfSameTypeObj);

				if ($ctrl.report.orderByColumn && $ctrl.report.orderByColumn.ReportTemplateColumnEntryID === columnOfSameTypeObj.ReportTemplateColumnEntryID) {

					// If this column was the orderByColumn then set orderByColumn to the top of the list if that exists
					if ($ctrl.report.ReportTemplateColumns.length > 0) {
						$ctrl.report.orderByColumn = $ctrl.report.ReportTemplateColumns[0];
					} else {
						$ctrl.report.orderByColumn = null;
					}
				}
			}
		}
	}

	function toggleSearch () {

		$ctrl.showSearch = !$ctrl.showSearch;

		if ($ctrl.showSearch) {
			utilities.focusOn('search-input');
		} else {
			$ctrl.searchTerm = '';
		}
	}

	function updateTotalAvailableColumns () {
		$ctrl.totalAvailableColumns = getReportCategoryTotalAvailableColumns();
	}

	angular.extend($ctrl, {
		$onInit,
		$onChanges: updateTotalAvailableColumns,

		isSearchReturningZeroColumns: false,
		searchTerm: '',
		showAddMenu: false,
		showSearch: false,

		addRepeatColumnToReport,
		getReportTemplateSelectedColumnEditModeDisplayLabel: reportsService.getReportTemplateSelectedColumnEditModeDisplayLabel,
		onColumnDelselectClick,
		onColumnDuplicateClick,
		onColumnEditCancel,
		onColumnEditClick,
		onColumnEditSubmit,
		onColumnNameOverrideChange,
		onSearchChange,
		toggleAllColumnsInGroup,
		toggleIsColumnSelected,
		toggleSearch
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('reportTemplateCreator', {
	bindings: {
		reportTemplateCreatorOptions: '='
	},
	controller: 'reportTemplateCreatorCtrl',
	templateUrl: 'components/report-template-creator/report-template-creator.component.html',
})
.controller('reportTemplateCreatorCtrl', [
	'$q',
	'$rootScope',
	'config',
	'growl',
	'coralogixService',
	'reportData',
	'reportsService',
	'tracking',
	'utilities',
	'INTERFACE_TYPES',
	'REPORT_TEMPLATE_CATEGORIES',
	'REPORT_TEMPLATE_FILTER_OPERATOR',
	'REPORT_TEMPLATE_TOTALS_TYPE',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	function (
		$q,
		$rootScope,
		config,
		growl,
		coralogixService,
		reportData,
		reportsService,
		tracking,
		utilities,
		INTERFACE_TYPES,
		REPORT_TEMPLATE_CATEGORIES,
		REPORT_TEMPLATE_FILTER_OPERATOR,
		REPORT_TEMPLATE_TOTALS_TYPE,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		error: 'error',
		loading: 'loading',
		preview: 'preview',
		ready: 'ready',
		saved: 'saved'
	};

	const TABS = {
		name: 'name',
		columns: 'columns',
		filters: 'filters',
		settings: 'settings'
	};

	function $onInit () {

		setComponentState(COMPONENT_STATES.loading);
		setFilterState(COMPONENT_STATES.loading);

		if ($ctrl.reportTemplateCreatorOptions.isEditTemplate || $ctrl.reportTemplateCreatorOptions.isDuplicateTemplate) {
			setupEditTemplateForm();
		} else {
			setupNewTemplateForm();
		}
	}

	function createReportTemplate () {

		tracking.trackEvent(TRACKING_EVENTS.reporting.reportTemplateCreated, {
			event_category: TRACKING_EVENT_CATEGORIES.reporting
		});

		reportData.createReportTemplate(
				$ctrl.reportTemplateCreatorOptions.agencyProfileId,
				getSavedDraftReportTemplate(),
				getSavedReportTemplateFilter()
			)
			.then(onSave)
			.catch(onError);
	}

	function decorateEmptyReportTemplate (reportTemplateObj) {

		decorateReportTemplateWithDefaults(reportTemplateObj);

		return angular.merge(reportTemplateObj, {
			AgencyProfileID: $ctrl.reportTemplateCreatorOptions.agencyProfileId,
			Category: {
				ReportTemplateCategoryID: null
			},
			IsVisible: true,
			ReportTemplateColumns: [],
			ShowTotals: REPORT_TEMPLATE_TOTALS_TYPE.sum,
		});
	}

	function decorateReportTemplateCategory (reportTemplateCategoryObj) {
		return reportTemplateCategoryObj.ColumnGroups.length > 0 && reportTemplateCategoryObj.ReportTemplateCategoryID !== REPORT_TEMPLATE_CATEGORIES.standardReports;
	}

	function decorateReportTemplateGroupColumns (columnObj) {

		angular.extend(columnObj, {
			isSelected: false
		});

		return !columnObj.ReportColumnCanSelectMultiplePerReport;
	}

	function decorateReportTemplateWithDefaults (reportTemplateObj) {

		angular.extend(reportTemplateObj, {
			groupByColumn: null,
			isOrderedDescending: false,
			orderByColumn: null,
			splitByColumn: null
		});
	}

	function getDraftReportTemplate () {

		const reportTemplateObj = angular.copy($ctrl.reportTemplate);
		const columnCount = reportTemplateObj.ReportTemplateColumns.length;

		function getReportCategoryForDraftReport () {

			const reportCategoryObj = angular.copy($ctrl.reportCategory);

			// Clear out irrelevant properties to decrease payload size
			return angular.extend(reportCategoryObj, {
				ColumnGroups: null,
				allAvailableColumns: undefined,
				repeatColumns: undefined,
			});
		}

		function getColumnSettingForSelectedColumn (selectedColumnObj, currentColumnObj) {
			// If setting is defined (eg, group by, split by) then return true if current column is the one that's selected
			return selectedColumnObj && selectedColumnObj.ReportTemplateColumnEntryID === currentColumnObj.ReportTemplateColumnEntryID || false;
		}

		angular.extend(reportTemplateObj, {
			Accessibility: reportsService.getAccessibilityForReport(reportTemplateObj),
			ColumnCount: columnCount,
			ShowTotals: getShowTotalsOption(),
			Category: getReportCategoryForDraftReport()
		});

		for (let columnIndex = 0; columnIndex < columnCount; columnIndex++) {

			let columnObj = reportTemplateObj.ReportTemplateColumns[columnIndex];

			reportTemplateObj.ReportTemplateColumns[columnIndex] = {
				CanApplyFilter: columnObj.ReportColumnCanApplyFilter,
				CanGroup: columnObj.ReportColumnCanGroup,
				CanSplit: columnObj.ReportColumnCanSplit,
				ColumnName: columnObj.ReportColumnName,
				ColumnNameOverride: angular.isDefined(columnObj.columnNameOverride) ? columnObj.columnNameOverride : undefined,
				ColumnPosition: columnIndex,
				ContentType: columnObj.ReportColumnContentType,
				IsClassicReport: false,
				IsGrouped: getColumnSettingForSelectedColumn(reportTemplateObj.groupByColumn, columnObj),
				IsOrdered: getColumnSettingForSelectedColumn(reportTemplateObj.orderByColumn, columnObj),
				IsOrderedDescending: getColumnSettingForSelectedColumn(reportTemplateObj.orderByColumn, columnObj) ? reportTemplateObj.isOrderedDescending : undefined,
				IsSplit: getColumnSettingForSelectedColumn(reportTemplateObj.splitByColumn, columnObj),
				MaxValidGroupingLevel: columnObj.ReportColumnMaxGroupingLevel,
				ReportColumnCanSelectMultiplePerReport: columnObj.ReportColumnCanSelectMultiplePerReport,
				ReportTemplateColumnEntryFormat: angular.isDefined(columnObj.reportTemplateColumnEntryFormat) ? columnObj.reportTemplateColumnEntryFormat : undefined,
				ReportTemplateColumnEntryIsHidden: angular.isDefined(columnObj.isColumnHidden) ? columnObj.isColumnHidden : false,
				ReportTemplateColumnEntrySpecifiedText: angular.isDefined(columnObj.reportTemplateColumnEntrySpecifiedText) ? columnObj.reportTemplateColumnEntrySpecifiedText : undefined,
				ReportTemplateColumnGroupID: columnObj.ReportColumnGroupID,
				ReportTemplateColumnID: columnObj.ReportColumnID,
				ReportTemplateColumnEntryID: columnObj.originalReportColumnEntryId ? columnObj.originalReportColumnEntryId : columnObj.ReportColumnID
			};
		}

		return reportTemplateObj;
	}

	function getExistingReportTemplate () {

		const reportTemplateObj = angular.copy($ctrl.reportTemplateCreatorOptions.reportTemplate);

		// Reset template IDs before duplication
		if ($ctrl.reportTemplateCreatorOptions.isDuplicateTemplate) {
			angular.extend(reportTemplateObj, {
				AgencyProfileID: $ctrl.reportTemplateCreatorOptions.agencyProfileId,
				ReportTemplateID: config.guidEmpty
			});
		}

		decorateReportTemplateWithDefaults(reportTemplateObj);

		return reportTemplateObj;
	}

	function getReportCategory () {

		// Find report category object from ID
		const reportCategoryObj = $ctrl.reportCategories.find(reportTemplateCategoryObj => reportTemplateCategoryObj.ReportTemplateCategoryID === $ctrl.reportTemplate.Category.ReportTemplateCategoryID);

		// Get array of all columns to use later
		reportCategoryObj.allAvailableColumns = reportCategoryObj.ColumnGroups.map(columnObj => columnObj.ReportColumns).flat();

		// Get array of columns that can occur in template multiple times
		reportCategoryObj.repeatColumns = reportCategoryObj.allAvailableColumns.filter(columnObj => columnObj.ReportColumnCanSelectMultiplePerReport);

		// Remove columns from groups based on certain properties, ie columns that occur multiple times
		for (let columnGroupObj of reportCategoryObj.ColumnGroups) {
			columnGroupObj.ReportColumns = columnGroupObj.ReportColumns.filter(decorateReportTemplateGroupColumns);
		}

		$ctrl.reportTemplate.ShowRange = reportCategoryObj.ReportTemplateCategoryHasRange;

		return angular.copy(reportCategoryObj);
	}

	function getReportTemplateFilter () {

		reportsService.getReportTemplateFilter({
				reportTemplate: $ctrl.reportTemplateCreatorOptions.reportTemplate,
				isDuplicateTemplate: $ctrl.reportTemplateCreatorOptions.isDuplicateTemplate
			})
			.then(reportTemplateFilterObj => {

				$ctrl.reportTemplateFilter = reportTemplateFilterObj;

				setFilterState(COMPONENT_STATES.ready);
			})
			.catch(onError);
	}

	function getSavedDraftReportTemplate () {
		return $ctrl.draftReportTemplate ? $ctrl.draftReportTemplate : getDraftReportTemplate();
	}

	function getSavedReportTemplateFilter () {

		// No filter created, return nothing
		if (!$ctrl.reportTemplateFilter) {
			return;
		}

		// No need to save empty report filter
		if (
			!$ctrl.reportTemplateCreatorOptions.isEditTemplate &&
			$ctrl.reportTemplateFilter.ReportTemplateFilterGroup.ChildReportTemplateFilterClauses.length === 0 &&
			$ctrl.reportTemplateFilter.ReportTemplateFilterGroup.ChildReportTemplateFilterGroups.length === 0
		) {
			return;
		}

		return $ctrl.reportTemplateFilter;
	}

	function getSelectedColumn (reportTemplateColumnObj) {

		const reportCategoryColumnObj = $ctrl.reportCategory.allAvailableColumns.find(availableCategoryColumnObj => availableCategoryColumnObj.ReportColumnID === reportTemplateColumnObj.ReportTemplateColumnID);

		// Show column as selected
		reportCategoryColumnObj.isSelected = true;

		// Multiple columns of same type can be added so only return a copy of it
		return angular.copy(reportCategoryColumnObj);
	}

	function getShowTotalsOption () {

		if (!$ctrl.reportTemplate.ShowComparison && $ctrl.showTotals) {
			return REPORT_TEMPLATE_TOTALS_TYPE.sum;

		} else if ($ctrl.reportTemplate.ShowComparison && $ctrl.showTotals) {
			return $ctrl.reportTemplate.ShowTotals;

		} else if (!$ctrl.showTotals) {
			return REPORT_TEMPLATE_TOTALS_TYPE.none;
		}
	}

	function initForm () {

		reportsService.getAccessibilityForReportTemplate($ctrl.reportTemplate);

		angular.extend($ctrl, {
			canChangeCategory: !($ctrl.reportTemplateCreatorOptions.isEditTemplate || $ctrl.reportTemplateCreatorOptions.isDuplicateTemplate),
			showTotals: ($ctrl.reportTemplate.ShowTotals !== REPORT_TEMPLATE_TOTALS_TYPE.none),
		});

		setComponentState(COMPONENT_STATES.ready);
	}

	function onBackToTemplateSettings () {

		setComponentState(COMPONENT_STATES.ready);

		// Save ReportRequest to use next time report is previewed;
		$ctrl.draftReportRequest = angular.copy($ctrl.reportPreviewOptions.returnObject);
	}

	function onError (error) {
		console.error(error);
		$ctrl.reportTemplateCreatorOptions.showClose = true;
	    setComponentState(COMPONENT_STATES.error);
	}

	function onReportCategoryChange () {

		// Reset fields to default when changing category
		const selectedReportCategoryObj = getReportCategory();

		// Save certain report properties
		angular.merge($ctrl.reportTemplateEmpty, {
			ReportTemplateDescription: $ctrl.reportTemplate.ReportTemplateDescription,
			ReportTemplateName: $ctrl.reportTemplate.ReportTemplateName,
			Category: {
				ReportTemplateCategoryID: selectedReportCategoryObj.ReportTemplateCategoryID
			}
		});

		angular.extend($ctrl, {
			reportCategory: selectedReportCategoryObj,

			// Replace working report template with a new empty report template
			reportTemplate: angular.copy($ctrl.reportTemplateEmpty)
		});

		// Clear filter out
		if ($ctrl.reportTemplateFilter) {
			angular.extend($ctrl.reportTemplateFilter.ReportTemplateFilterGroup, {
				ChildReportTemplateFilterClauses: [],
				ChildReportTemplateFilterGroups: [],
				ReportTemplateFilterGroupOperator: REPORT_TEMPLATE_FILTER_OPERATOR.and
			});
		}
	}

	function onSave () {
		$ctrl.reportTemplateCreatorOptions.callback();
		setComponentState(COMPONENT_STATES.saved);
	}

	function openReportPreview () {

		setComponentState(COMPONENT_STATES.loading);

		$ctrl.draftReportTemplate = getDraftReportTemplate();

		$ctrl.reportPreviewOptions = reportsService.getReportOptionsForReportTemplate(
			$ctrl.draftReportTemplate,
			{
				agencyProfileId: $ctrl.reportTemplateCreatorOptions.agencyProfileId,
				reportRequest: $ctrl.draftReportRequest
			},
			$ctrl.reportTemplateFilter
		);

		setComponentState(COMPONENT_STATES.preview);
	}

	function saveForm () {

		setComponentState(COMPONENT_STATES.loading);

		$ctrl.reportTemplateCreatorForm = 'loading';

		if (!$ctrl.reportTemplateCreatorOptions.isEditTemplate || $ctrl.reportTemplateCreatorOptions.isDuplicateTemplate) {
			createReportTemplate();
		} else {
			updateReportTemplate();
		}
	}

	function setActiveTab (newTab) {

		$ctrl.activeTab = newTab;

		// Load in filter group if it doesn't exist already
		if (newTab === TABS.filters && !$ctrl.reportTemplateFilter) {
			getReportTemplateFilter();
		}
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function setFilterState (newState) {
		$ctrl.filterState = newState;
	}

	function setSelectedColumnsForReport () {

		const selectedColumnsArr = [];

		for (let reportTemplateColumnObj of $ctrl.reportTemplate.ReportTemplateColumns) {

			let selectedColumnObj = getSelectedColumn(reportTemplateColumnObj);

			angular.extend(selectedColumnObj, {
				columnNameOverride: reportTemplateColumnObj.ColumnNameOverride,
				isColumnHidden: reportTemplateColumnObj.ReportTemplateColumnEntryIsHidden,
				isColumnValid: true,
				isSelected: true,
				position: reportTemplateColumnObj.ColumnPosition,
				reportTemplateColumnEntryFormat: selectedColumnObj.ReportColumnSelectableFormats.find(formatObj => formatObj.ReportTemplateColumnFormatID  === reportTemplateColumnObj.ReportTemplateColumnEntryFormat.ReportTemplateColumnFormatID),
				reportTemplateColumnEntrySpecifiedText: reportTemplateColumnObj.ReportTemplateColumnEntrySpecifiedText
			});

			if (reportTemplateColumnObj.IsSplit) {
				$ctrl.reportTemplate.splitByColumn = selectedColumnObj;
			}

			if (reportTemplateColumnObj.IsGrouped) {
				$ctrl.reportTemplate.groupByColumn = selectedColumnObj;
			}

			if (reportTemplateColumnObj.IsOrdered) {
				angular.extend($ctrl.reportTemplate, {
					isOrderedDescending: reportTemplateColumnObj.IsOrderedDescending,
					orderByColumn: selectedColumnObj
				});
			}

			// Give column a different ID to avoid conflict with others in the array
			angular.extend(selectedColumnObj, {
				originalReportColumnEntryId: reportTemplateColumnObj.ReportTemplateColumnEntryID,
				ReportTemplateColumnEntryID: utilities.guid()
			});

			selectedColumnsArr.push(selectedColumnObj);
		}

		// Sort columns based on returned position
		$ctrl.reportTemplate.ReportTemplateColumns = selectedColumnsArr.sort((columnA, columnB) => {
			if (columnA.position > columnB.position) {
				return 1;
			}

			if (columnB.position > columnA.position) {
				return -1;
			}

			return 0;
		});
	}

	function setupEditTemplateForm () {

		coralogixService.addToTrace({
			message: 'Report wizard: ' + $ctrl.reportTemplateCreatorOptions.reportTemplate.ReportTemplateName,
			category: 'reporting'
		});

		reportData.getReportTemplateCategories($ctrl.reportTemplateCreatorOptions.agencyProfileId)
			.then(reportTemplateCategoriesArr => {

				angular.extend($ctrl, {
					reportTemplate: getExistingReportTemplate(),
					reportCategories: reportTemplateCategoriesArr.filter(decorateReportTemplateCategory)
				});

				$ctrl.reportCategory = getReportCategory();

				setSelectedColumnsForReport();

				// Load in filter - async so the form can continue loading
				getReportTemplateFilter();

				// Load form
				initForm();
			})
		.catch(onError);
	}

	function setupNewTemplateForm () {

		const getReportTemplateCategories = reportData.getReportTemplateCategories($ctrl.reportTemplateCreatorOptions.agencyProfileId);
		const getEmptyReportTemplate = reportData.getEmptyReportTemplate();

		$q.all([
				getReportTemplateCategories,
				getEmptyReportTemplate
			])
			.then(([
					reportTemplateCategoriesArr,
					emptyReportTemplateObj
				]) => {

				angular.extend($ctrl, {
					reportTemplate: decorateEmptyReportTemplate(emptyReportTemplateObj),
					reportTemplateEmpty: angular.copy(emptyReportTemplateObj),
					reportCategories: reportTemplateCategoriesArr.filter(decorateReportTemplateCategory),
					reportCategory: null
				});

				initForm();
			})
			.catch(onError);
	}

	function updateReportTemplate () {

		reportData.updateReportTemplate(
				$ctrl.reportTemplateCreatorOptions.agencyProfileId,
				getSavedDraftReportTemplate(),
				getSavedReportTemplateFilter()
			)
			.then(onSave)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		getIsReportViewerFiltersColumnFilterVisible: reportsService.getIsReportViewerFiltersColumnFilterVisible,
		getReportTemplateSelectedColumnEditModeDisplayLabel: reportsService.getReportTemplateSelectedColumnEditModeDisplayLabel,
		onBackToTemplateSettings,
		onReportCategoryChange,
		openReportPreview,
		saveForm,
		setActiveTab,
		setComponentState,

		TABS,
		COMPONENT_STATES,
		REPORT_TEMPLATE_TOTALS_TYPE,

		activeTab: TABS.name,
		isBulkReport: [INTERFACE_TYPES.bureau, INTERFACE_TYPES.group].includes($rootScope.currentCompany.CompanyType)
	});
}]);

  'use strict';

angular.module('paycircleApp')
.component('reportViewer', {
	bindings: {
		reportAdditionalData: '<?',
		reportDto: '<',
		reportOptions: '<',
		reportRequest: '<'
	},
	controller: 'reportViewerComponentCtrl',
	templateUrl: 'components/report-viewer/report-viewer.component.html'
})
.controller('reportViewerComponentCtrl', [
	'$q',
	'$timeout',
	'config',
	'reportData',
	'reportDataGrid',
	'reportsService',
	'searchService',
	'tracking',
	'REPORT_TEMPLATE_IDS',
    'STATIC_REPORT_STATUS',
	'TRACKING_EVENT_CATEGORIES',
	'TRACKING_EVENTS',
	function (
		$q,
		$timeout,
		config,
		reportData,
		reportDataGrid,
		reportsService,
		searchService,
		tracking,
		REPORT_TEMPLATE_IDS,
		STATIC_REPORT_STATUS,
		TRACKING_EVENT_CATEGORIES,
		TRACKING_EVENTS
	) {

	const $ctrl = this;

	const REPORT_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready',
		reportEmpty: 'report-empty'
	};

	let staticReportStatusPollTimeoutId = null;
	let staticReportSupportsStorage = false;
	let staticReportStatus = null;

	function $onInit () {

		setReportState(REPORT_STATES.loading);
		$ctrl.handleAsEmptyReport = false;

		getReportTableDataForType()
			.then(getFormattedReport)
			.catch(onError);
	}

	function getFormattedReport (reportObj) {

		// Convert Classic & static Report objects into custom report
		if ($ctrl.reportDto.ReportTemplate.IsClassicReport || $ctrl.reportDto.ReportTemplate.IsStaticReport && !$ctrl.handleAsEmptyReport) {

			const customReportObj = reportsService.getCustomReportFromClassicReport(reportObj, $ctrl.reportDto, $ctrl.reportOptions);

			openReport(customReportObj);
		}
		else {
			openReport(reportObj);
		}
	}

	function getReportTableDataForType () {

		// 1. Use passed in service
		if ($ctrl.reportOptions.reportCreationService) {
			return $ctrl.reportOptions.reportCreationService();
		}

		// 2. Classic reports - Some classic reports may have their own service
		if ($ctrl.reportDto.ReportTemplate.IsClassicReport) {

			switch ($ctrl.reportDto.ReportTemplate.ReportTemplateID) {

				// 2a. Comparison Report
				case REPORT_TEMPLATE_IDS.comparisonReport:
					return reportData.getPayrollComparisonReport($ctrl.reportRequest.CompanyIDs[0], $ctrl.reportRequest.PeriodOptions[0].Value);

				// 2b. Everything else
				default:
					return reportData.getClassicReport($ctrl.reportRequest);
			}
		}

		// 3. Static reports
		if ($ctrl.reportDto.ReportTemplate.IsStaticReport) {
			return reportData.getStaticReportSupportsStorage($ctrl.reportRequest.ReportTemplateID)
			.then(supportsStorage => {
				staticReportSupportsStorage = supportsStorage;

				if (!supportsStorage) {
					return reportData.getStaticReport($ctrl.reportRequest); //.. Report is on demand generated
				} else {
					return reportData.startStaticReportGeneration($ctrl.reportRequest)
					.then((result) => {
						staticReportStatus = result.Status;

						if (result.Status === STATIC_REPORT_STATUS.failed) {
							console.warn(result.ErrorMessage);
							$ctrl.handleAsEmptyReport = true;
							return emptyReport();
						}

						if (result.Status === STATIC_REPORT_STATUS.complete) //..The document is already generated
						{
							return reportData.getStaticReportFromStorage(result.DocumentID, $ctrl.reportRequest);
						}
						// poll for success
						return pollForStaticReport(result.DocumentID, $ctrl.reportRequest);
					}).catch(error => {
						onError(error);
						return;
					});
				}
			});
		}

		// 4. Custom reports
		return reportData.getCustomReport($ctrl.reportRequest);
	}

	function pollForStaticReport(documentID, reportRequest) {
		
		return reportData.getStaticReportStatus(documentID)
		.then(function(response) {
			staticReportStatus = response.Status;

			if (response.Status === STATIC_REPORT_STATUS.failed) {
				onError(response.ErrorMessage);
				return;
			}

			if (response.Status === STATIC_REPORT_STATUS.complete) {
				return reportData.getStaticReportFromStorage(documentID, reportRequest);
			} else {
				// Wait and poll again
				return $q(resolve => {
					staticReportStatusPollTimeoutId = $timeout(() => {
						resolve(pollForStaticReport(documentID, reportRequest));
					}, config.timeToPoll * 1000);
				});
			}
		}).catch(error => {
			onError(error);
			return $q.reject(error);
		});
	}

	function getTotalReportRowCount (reportObj) {

		let count = 0;

		for (let reportEntriesObj of reportObj.CustomReportEntries) {
			count += reportEntriesObj.CustomReportEntryTable.ReportRows.length;
		}

		return count;
	}

	function openReport (reportObj) {

		// Reset the report data grid to a new report instance when opening a new report to remove artifacts from previous reports
		reportDataGrid.createNewReport();

		angular.extend($ctrl, {
			report: reportObj,
			reportRowCount: getTotalReportRowCount(reportObj)
		});

		// Process additional data and assign to each entry if required
		reportsService.getProcessedAdditionalDataForReport($ctrl.reportDto, $ctrl.reportAdditionalData, reportObj);

		// GA tracking
		tracking.trackEvent(TRACKING_EVENTS.reporting.reportLoaded, {
			event_category: TRACKING_EVENT_CATEGORIES.reporting,
			event_label: $ctrl.reportDto.DisplayName
		});

		// Update various settings for this report
		angular.extend($ctrl.reportOptions, {
			hasMultipleEntries: $ctrl.report.CustomReportEntries.length > 1
		});

		if ($ctrl.reportRowCount === 0) {
			setReportState(REPORT_STATES.reportEmpty);
		}
		else {
			setReportState(REPORT_STATES.ready);
		}

		$ctrl.handleAsEmptyReport = false;
	}

	function $onDestroy() {
		if (staticReportStatusPollTimeoutId) {
			$timeout.cancel(staticReportStatusPollTimeoutId);
			staticReportStatusPollTimeoutId = null;
		}
	}

	function emptyReport()
	{
		// This function is used to return an empty report object when the report is not found or has no data
		return {
			CustomReportEntries: [],
			ReportRowCount: 0,
			ReportTemplate: {
				IsClassicReport: false,
				IsStaticReport: false
			}
		};
	}

	function onError (error) {
		setReportState(REPORT_STATES.error);
		console.error(error);
	}

	function setReportState (newState) {
		$ctrl.reportState = newState;
	}

	function toggleAllReportEntries () {

		const customReportEntriesCount = $ctrl.report.CustomReportEntries.length;
		const showFullEntries = $ctrl.expandedEntriesCount !== customReportEntriesCount;

		for (let customReportEntryObj of $ctrl.report.CustomReportEntries) {
			customReportEntryObj.showFullEntry = showFullEntries;
		}

		$ctrl.expandedEntriesCount = showFullEntries ? customReportEntriesCount : 0;
	}

	function toggleFullReportEntryContent (customReportEntryObj) {

		customReportEntryObj.showFullEntry = !customReportEntryObj.showFullEntry;

		if (customReportEntryObj.showFullEntry) {
			$ctrl.expandedEntriesCount++;
		} else {
			$ctrl.expandedEntriesCount--;
		}
	}

	function canRegenerateReport () {
		return $ctrl.reportDto.ReportTemplate.IsStaticReport &&
			staticReportSupportsStorage &&
			(staticReportStatus === STATIC_REPORT_STATUS.failed || staticReportStatus === STATIC_REPORT_STATUS.complete);
	}

	function regenerateReport () {
		setReportState(REPORT_STATES.loading);

		const forceRegenerationOption = {
			Key: '[ForceRegeneration]',
			Value: 'true'
		};

		const reportRequestWithForceRegeneration = angular.copy($ctrl.reportRequest);

		if (!reportRequestWithForceRegeneration.AdditionalOptions) {
			reportRequestWithForceRegeneration.AdditionalOptions = [];
		}

		reportRequestWithForceRegeneration.AdditionalOptions.push(forceRegenerationOption);

		reportData.startStaticReportGeneration(reportRequestWithForceRegeneration)
			.then((result) => {
				staticReportStatus = result.Status;

				if (result.Status === STATIC_REPORT_STATUS.failed) {
					console.warn(result.ErrorMessage);
					$ctrl.handleAsEmptyReport = true;
					return emptyReport();
				}

				if (result.Status === STATIC_REPORT_STATUS.complete) {
					return reportData.getStaticReportFromStorage(result.DocumentID, $ctrl.reportRequest);
				}

				return pollForStaticReport(result.DocumentID, $ctrl.reportRequest);
			})
			.then(getFormattedReport)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		$onDestroy,

		REPORT_STATES,

		expandedEntriesCount: 0,
		onDataGridSearch: reportDataGrid.onSearch,
		searchBarOptions: searchService.reportViewer,
		
		canRegenerateReport,
		regenerateReport,
		toggleAllReportEntries,
		toggleFullReportEntryContent,
	});
}])

.filter('reportViewerEntriesSearch', [
	'$filter',
	($filter) => {

	return (customReportEntriesArr, hasMultipleEntries, searchString) => {
		// This filter is used to filter the custom report entries in the report viewer, only searching by the label where there are multiple entry "blocks"
		if (hasMultipleEntries && searchString) {
			return $filter('filter')(customReportEntriesArr, { CustomReportEntryLabel : searchString } );
		}

		return customReportEntriesArr;
	};

}]);

  'use strict';

angular.module('paycircleApp')
.component('report', {
	bindings: {
		reportOptions: '=',
	},
	controller: 'reportComponentCtrl',
	templateUrl: 'components/report/report.component.html',
	transclude: {
		actions: '?reportActions'
	}
})
.controller('reportComponentCtrl', [
	'$element',
	'$q',
	'$timeout',
	'$transclude',
	'accessButtonService',
	'applicationService',
	'coralogixService',
	'reportData',
	'reportDataGrid',
	'reportsService',
	'utilities',
	'REPORT_TEMPLATE_ACCESSIBILITY',
	'REPORT_TEMPLATE_IDS',
	'TELEMETRY_PROJECT_INFO',
	'TELEMETRY_TRACKED_FEATURES',
	function (
		$element,
		$q,
		$timeout,
		$transclude,
		accessButtonService,
		applicationService,
		coralogixService,
		reportData,
		reportDataGrid,
		reportsService,
		utilities,
		REPORT_TEMPLATE_ACCESSIBILITY,
		REPORT_TEMPLATE_IDS,
		TELEMETRY_PROJECT_INFO,
		TELEMETRY_TRACKED_FEATURES
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		error: 'error',
		loading: 'loading',
		noPayPeriods: 'no-pay-periods',
		noPreviousPeriod: 'no-previous-period',
		ready: 'ready'
	};

	function $onInit () {

		coralogixService.addToTrace({
			message: 'Report: Component loaded',
			category: 'action'
		});


		setComponentState(COMPONENT_STATES.loading);

		getReportDTO()
			.then(reportDTOObj => {

				const getReportRequestOptions = reportData.getReportRequestOptions(
						$ctrl.reportOptions.agencyProfileId,
						reportDTOObj.ReportTemplate.ReportTemplateID,
						$ctrl.reportOptions.reportTemplate,
						$ctrl.reportOptions.agencyPayPeriodId,
						$ctrl.reportOptions.supplementaryPaymentId,
						$ctrl.reportOptions.journalPostId
				);

				const getAdditionalDataForReport = reportsService.getAdditionalDataForReport(
						$ctrl.reportOptions.agencyProfileId,
						reportDTOObj.ReportTemplate.ReportTemplateID
				);

				$q.all([
					getReportRequestOptions,
					getAdditionalDataForReport
				])
				.then(([
					reportRequestOptionsObj,
					reportAdditionalInfoObj
				]) => {

					angular.extend($ctrl, {
						draftReportRequest: reportsService.getReportRequest($ctrl.reportOptions, reportDTOObj, reportRequestOptionsObj),
						reportAdditionalData: reportAdditionalInfoObj,
						reportDTO: reportDTOObj,
						reportOptions: reportsService.getDefaultReportViewerOptions($ctrl.reportOptions, reportDTOObj, reportRequestOptionsObj),
						reportRequestOptions: reportRequestOptionsObj
					});

					$ctrl.componentState = getInitialComponentState();

					if (reportRequestOptionsObj.CompanyOptions.length <= 1 || $ctrl.reportOptions.reportRequest) {
						getReportFromRequest();	
					}

					// Telemetry
					if (reportDTOObj.ReportTemplate.ReportTemplateID === REPORT_TEMPLATE_IDS.averagePayReport) {
						accessButtonService.sendTelemetry(TELEMETRY_TRACKED_FEATURES.averagePayReport, TELEMETRY_PROJECT_INFO.projectReportingCode);
					}
				})
				.catch(onError);
			})
			.catch(onError);
	}

	function getInitialComponentState () {

		// Show company filter bar
		if ($ctrl.reportRequestOptions.CompanyOptions.length > 1) {
			return COMPONENT_STATES.ready;
		}

		if ($ctrl.reportDTO.ReportTemplate.Category.ReportTemplateCategoryIsDateBased) {
			if ($ctrl.reportRequestOptions.PeriodOptions.length === 0 || $ctrl.reportRequestOptions.PeriodOptions.every(periodOptionObj => periodOptionObj.Items.length === 0)) {
				return COMPONENT_STATES.noPayPeriods;
			}

			const companyOptions = $ctrl.reportRequestOptions.CompanyOptions;

			if (companyOptions.length > 0 && !companyOptions[0].PayPeriodInformation.HasCompletedPeriods && !$ctrl.reportOptions.canIgnoreCompletedPeriods) {

				if ($ctrl.reportDTO.ReportTemplate.Accessibility === REPORT_TEMPLATE_ACCESSIBILITY.final) {
					return COMPONENT_STATES.noPayPeriods;
				}

				if ($ctrl.reportDTO.ReportTemplate.ReportTemplateID === REPORT_TEMPLATE_IDS.comparisonReport) {
					return COMPONENT_STATES.noPreviousPeriod;
				}
			}
		}

		return COMPONENT_STATES.ready;
	}

	function getReportDTO () {

		return $q((onComplete, onError) => {

			// 1. Use passed in ReportDTO
			if ($ctrl.reportOptions.reportDTO) {
				onComplete($ctrl.reportOptions.reportDTO);
				return;
			}

			// 2. Create basic ReportDTO from report template
			if ($ctrl.reportOptions.reportTemplate) {
				onComplete({
					DisplayName: $ctrl.reportOptions.reportTemplate.ReportTemplateName,
					ReportTemplate: $ctrl.reportOptions.reportTemplate
				});
				return;
			}

			// 3. Get ReportDTO from separate service call
			if ($ctrl.reportOptions.reportDTOService) {
				$ctrl.reportOptions.reportDTOService()
					.then(reportDTOObj => {

						$ctrl.reportOptions.reportTemplateId = reportDTOObj.ReportTemplate.ReportTemplateID;

						onComplete(reportDTOObj);
					})
					.catch(onError);
				return;
			}

			// 4. Get ReportDTO from service
			reportData.getReport(
					$ctrl.reportOptions.agencyProfileId,
					$ctrl.reportOptions.agencyDocumentId,
					$ctrl.reportOptions.agencyPayPeriodId,
					$ctrl.reportOptions.reportTemplateId,
					$ctrl.reportOptions.supplementaryPaymentId
				)
				.then(onComplete)
				.catch(onError);
		});
	}

	function getReportFromRequest () {

		function publishReport () {

			// Cancel all current requests
			applicationService.cancelPendingRequests();

			// Overwrite current Report Request
			$ctrl.reportRequest = angular.copy($ctrl.draftReportRequest);

			// Attach ReportRequest to reportOptions so it can be saved elsewhere
			$ctrl.reportOptions.returnObject = $ctrl.reportRequest;
		}

		if ($ctrl.reportRequest) {

			// Swap out report request with new one
			delete $ctrl.reportRequest;

			// Create new data grid instance for report
			reportDataGrid.createNewReport();

			// Allow report-viewer to reset before recreating the component
			$timeout(publishReport, 0);

			return;
		}

		publishReport();
	}

	function onError (error) {
		setComponentState(COMPONENT_STATES.error);
		console.error(error);
	}

	function onToggleFullScreen () {
		utilities.toggleBrowserFullScreen($element[0]);
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		COMPONENT_STATES,

		getReportFromRequest,
		onToggleFullScreen,

		hasActions: $transclude.isSlotFilled('actions')
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('rollbackStatusBlock', {
	bindings: {
		payPeriod: '<'
	},
	templateUrl: 'components/rollback-status-block/rollback-status-block.component.html'
});

'use strict';

angular.module('paycircleApp')
	.component('rotareadyEmployeesCard', {
		bindings: {
			employee: '<?',
			isActive: '<?'
		},
		controller: 'rotareadyEmployeesCardController',
		templateUrl: 'components/rotaready-employees-card/rotaready-employees-card.component.html',
	})
	.controller('rotareadyEmployeesCardController', [ function () {

		let $ctrl = this;

		function $onInit() {
		}


		angular.extend($ctrl, {
			$onInit
		});
	}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyMatchEmployees', {
	bindings: {
		bulkItems : '=?',
		createInPaycircle: '=',
		isPendingTab: '<',
		isPayrollLocked: '<',
		paycircleTeamMembers: '=',
		rotareadyTeamMembers: '=',
		selectedEmployee:'=?',
		teamMembersMapped: '=',
		updateTeamMemberState: '&'
	},
	controller: 'rotareadyMatchEmployeesCtrl',
	templateUrl: 'components/rotaready-match-employees/rotaready-match-employees.component.html',
})
.controller('rotareadyMatchEmployeesCtrl', [
	'$rootScope',
	'bulkService',
	'dateService',
	'rotareadyTeamMembersDataFactory',
	'searchService',
	'utilities',
	function (
		$rootScope,
		bulkService,
		dateService,
		rotareadyTeamMembersDataFactory,
		searchService,
		utilities
	) {

	const $ctrl = this;

	function $onInit(){

		$ctrl.isRowDisabled = false;

		if (!$ctrl.isPendingTab) {

			$ctrl.getPossibleMatches();
		}
	}

	function getPossibleMatches() {

		if (!$ctrl.rotareadyTeamMembers || !$ctrl.paycircleTeamMembers) {
			return;
		}

		$ctrl.rotareadyTeamMembers.forEach(rotareadyMember => {

			if (!rotareadyMember.Rotaready || !rotareadyMember.Rotaready.FullName) {
				rotareadyMember.Rotaready.possibleMatches = [];
				return;
			}

			// Find possible matches based on NI number or date of birth
			const niNumber = rotareadyMember.Rotaready.Nino ? utilities.removeSpaces(rotareadyMember.Rotaready.Nino.toLowerCase()) : '';

			rotareadyMember.Rotaready.possibleMatches = $ctrl.paycircleTeamMembers
				.filter(teamMember =>
					// Same Nino (ignoring spaces and case)
					(teamMember.Paycircle.Nino && teamMember.Paycircle.Nino.toLowerCase() === niNumber) ||
					// Or same email (ignoring case)
					(
						teamMember.Paycircle.Email &&
						rotareadyMember.Rotaready.Email &&
						teamMember.Paycircle.Email.toLowerCase() === rotareadyMember.Rotaready.Email.toLowerCase()
					) ||
					// Or same date of birth
					dateService.areDatesSameDay(teamMember.Paycircle.DateOfBirthIso, rotareadyMember.Rotaready.DateOfBirthIso)
			);
		});
	}

	function onCreateAllAsNewClick () {

		$ctrl.rotareadyTeamMembers.forEach((teamMember) => {
			if (!teamMember.IsLocked) {
				onCreateAsNewClick(teamMember);
			}
		});

		$rootScope.$broadcast('tabCountsUpdated');
	}

	function onUndoAll () {

		$ctrl.teamMembersMapped.forEach((teamMember) => {
			if (!teamMember.IsLocked) {
				if (!teamMember.Paycircle) {
					$ctrl.updateTeamMemberState({ teamMember: teamMember, action: 'cancelCreate' });
					return;
				}
				$ctrl.updateTeamMemberState({ teamMember: teamMember, action: 'unmatch' });
			}
		});

		$rootScope.$broadcast('tabCountsUpdated');
	}

	function onCreateAsNewClick (teamMemberToCreate) {

		removeTeamMemberFromUnmatchedList(teamMemberToCreate);
		rotareadyTeamMembersDataFactory.addNewPaycircleTeamMember(teamMemberToCreate);
	}

	function onUnmatchClick (teamMemberToUnmatch) {

		rotareadyTeamMembersDataFactory.unmatchTeamMembers(teamMemberToUnmatch);
	}

	function removeTeamMemberFromUnmatchedList (teamMember) {

		$ctrl.rotareadyTeamMembers = $ctrl.rotareadyTeamMembers.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
		$ctrl.bulkItems = bulkService.getBulkItemsObj($ctrl.rotareadyTeamMembers);
	}

	function resetFlags () {

		$ctrl.isRowDisabled = false;
	}

	angular.extend($ctrl, {
		$onInit,

		getPossibleMatches,
		onCreateAllAsNewClick,
		onUndoAll,
		onUnmatchClick,
		resetFlags,
		searchBarOptions: searchService.teamRotaready,
		searchValue: null,

		SEARCH_TERM_MIN_COUNT: 3,
		SEARCH_RESULTS_LIMIT: 20
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyTeamCardBasic', {
	bindings: {
		teamMember: '<',
		isSmall: '<?',
		hasIcon: '<?',
		index: '<'
	},
	controller: 'rotareadyTeamCardBasicCtrl',
	templateUrl: 'components/rotaready-team-card-basic/rotaready-team-card-basic.component.html',
	transclude: {
		'actions': '?tcActions'
	}
})
.controller('rotareadyTeamCardBasicCtrl', [
	'$transclude',
	function ($transclude) {

	const $ctrl = this;

	function $onInit () {
		angular.extend($ctrl, {
			hasActions: $transclude.isSlotFilled('actions')
		});
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyTeamMemberMatchedCard', {
	bindings: {
		index: '<',
		teamMember: '<',
		onUnmatchClick: '&',
		onCancelClick: '&',
		isMatchedView: '<?'
	},
	controller: 'rotareadyTeamMemberMatchedCardCtrl',
	templateUrl: 'components/rotaready-team-member-matched-card/rotaready-team-member-matched-card.component.html',
})
.controller('rotareadyTeamMemberMatchedCardCtrl', [
	function () {

}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyTeamMemberSearchCard', {
	bindings: {
		employee: '<',
		index: '<',
		isPayrollLocked: '<',
		isRowDisabled:'=',
		onCreateAsNew: '&',
		onUnmatchClick: '&',
		paycircleTeamMembers: '<',
		resetFlags: '&',
		updateTeamMemberState: '&'
	},
	controller: 'rotareadyTeamMemberSearchCardCtrl',
	templateUrl: 'components/rotaready-team-member-search-card/rotaready-team-member-search-card.component.html',
})
.controller('rotareadyTeamMemberSearchCardCtrl', [
	function () {

	const $ctrl = this;

	function onTeamMemberClick(employee, teamMember) {

		employee.Paycircle = null;
		employee.Paycircle = teamMember.Paycircle;
		employee.searchValue = '';
		$ctrl.isRowDisabled = true;
	}

	function onTeamMemberDeselectClick(employee) {

		employee.Paycircle = null;
		$ctrl.isRowDisabled = false;
	}

	function resetTeamMemberSearchTerm(employee) {

		employee.searchValue = '';
		$ctrl.isRowDisabled = false;
	}

	function onMatch (employee) {

		$ctrl.updateTeamMemberState({teamMember: employee, action: 'match'});
		$ctrl.resetFlags();
	}

	angular.extend($ctrl, {
		onMatch,
		onTeamMemberClick,
		onTeamMemberDeselectClick,
		resetTeamMemberSearchTerm,
		searchValue: null,

		SEARCH_RESULTS_LIMIT: 20,
		SEARCH_TERM_MIN_COUNT: 3
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('searchSelect', [
	'$compile', 
	function () {
		return {
			restrict: 'E',
			scope: {
				items: '<',
				isDisabled: '<?',
				itemName: '@',
				searchProperty: '@',
				valueProperty: '@',
				labelSingular: '@',
				labelPlural: '@',
				ngModel: '=',
				onSelect: '&?'
			},
			controller: 'searchSelectCtrl',
			templateUrl: 'components/search-select/search-select.component.html',
			transclude: true
		};
	}
])
.controller('searchSelectCtrl', ['$scope', '$transclude', '$timeout', function ($scope, $transclude, $timeout) {

	const SEARCH_TERM_MIN_COUNT = 3;
	const SEARCH_RESULTS_LIMIT = 20;

	let templateHtml = '';

	$transclude($scope, function (clone) {
		for (let i = 0; i < clone.length; i++) {
			if (clone[i].nodeName.toLowerCase() === 'item-template') {
				const templateElement = clone[i];
				templateHtml = templateElement.innerHTML;							
			}
		}
	});

	function $onInit () {
		
		angular.extend($scope, {
			searchText: '',
			isOpen: false,
			filteredItems: []
		});
	}
	
	function $onChanges (changes) {

		if (changes.items) {
			filterItems();
		}
	}

	function filterItems () {

		const items = $scope.items || [];
		const searchText = ($scope.searchText || '').toLowerCase();
		const searchProperty = $scope.searchProperty;

		if (searchText.length < SEARCH_TERM_MIN_COUNT) {
			$scope.filteredItems = [];
			return;
		}

		const filtered = [];

		for (let i = 0; i < items.length; i++) {
			const itemText = items[i][searchProperty];

			if (itemText && itemText.toString().toLowerCase().indexOf(searchText) !== -1) {
				filtered.push(items[i]);
			}

			if (filtered.length >= SEARCH_RESULTS_LIMIT) {
				break;
			}
		}

		$scope.filteredItems = filtered;
	}

	function onSearchTextChange () {

		filterItems();
		$scope.isOpen = !!($scope.searchText && $scope.searchText.length >= SEARCH_TERM_MIN_COUNT);
	}

	function onItemClick (item) {

		const valueProperty = $scope.valueProperty;
		const value = valueProperty ? item[valueProperty] : item;

		$scope.ngModel = value;

		$scope.searchText = '';
		$scope.isOpen = false;

		if ($scope.onSelect) {
			$timeout(function () {
				$scope.onSelect();
			});
		}
	}

	function reset () {

		$scope.searchText = '';
		$scope.isOpen = false;
	}

	function getItemName () {

		return $scope.itemName;
	}

	function getTemplateHtml () {

		return templateHtml;
	}

	angular.extend($scope, {
		$onInit: $onInit,
		$onChanges: $onChanges,
		filterItems: filterItems,
		getItemName: getItemName,
		getTemplateHtml: getTemplateHtml,
		onItemClick: onItemClick,
		onSearchTextChange: onSearchTextChange,
		reset: reset
	});
}])
.directive('searchSelectItem', ['$compile', function ($compile) {

	return {
		restrict: 'A',
		scope: true,
		link: function (scope, element, attrs) {

			let ssScope = scope;

			while (ssScope && !ssScope.getTemplateHtml) {
				ssScope = ssScope.$parent;
			}

			if (!ssScope || !ssScope.getTemplateHtml) {
				return;
			}

			const templateHtml = ssScope.getTemplateHtml();
			const itemName = ssScope.getItemName();

			scope[itemName] = scope.$eval(attrs.searchSelectItem);

			element.html(templateHtml);
			$compile(element.contents())(scope);

			const itemWatcher = scope.$watch(attrs.searchSelectItem, function (newVal) {
				scope[itemName] = newVal;
			});

			scope.$on('$destroy', function () {
				itemWatcher();
				element.empty();
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('salaryBreakdown', {

	bindings: {
		salary: '=',
		sbId: '@',
		updateSalary: '=',
		disabled: '='
	},
	controller: 'salaryBreakdownController',
	require: {
		form: '^form'
	},
	templateUrl: 'components/salary-breakdown/salaryBreakdownComponent.html'
})

.controller('salaryBreakdownController', [
	'config',
	'SALARY_INTERVAL_TYPES',
	function (
		config,
		SALARY_INTERVAL_TYPES
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		const sbId = $ctrl.sbId;

		function onSalaryValueChanged (salaryObj, salaryPropertyName, payPeriodType) {
			// Do nothing if the user has entered nothing. The calculation will cause a gremlin otherwise.
			if (salaryObj.breakdown[salaryPropertyName] !== null && salaryObj.breakdown[salaryPropertyName].toFixed(2).toString().length <= config.salaryMaxLength) {
				$ctrl.updateSalary(salaryObj, salaryPropertyName, payPeriodType);
			}
		}

		angular.extend($ctrl, {
			SALARY_INTERVAL_TYPES,

			monthlySalaryId: `${sbId}_monthlySalary`,
			fourWeeklySalaryId: `${sbId}_fourWeeklySalary`,
			twoWeeklySalaryId: `${sbId}_twoWeeklySalary`,
			weeklySalaryId: `${sbId}_weeklySalary`,
			dailySalaryId: `${sbId}_dailySalary`,
			hourlySalaryId: `${sbId}_hourlySalary`,

			onSalaryValueChanged
		});
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('salaryPolicyFormField', {
	bindings: {
		agencyProfileId: '=',
		// Allow deletion of salary policy
		allowDelete: '<',
		// Allow editing of effective date. Default to false.
		allowEditEffectiveDate: '<?',
		/* Parent annual salary SalaryPolicy object for sourcing CWTs for FTE calculations. Applicable only to annual allowance policies,
		   when they need to use CWTs from the parent annual salary SalaryPolicy object. */
		backdatedSalaryDerivedElementsEnabled: '<',
		getBackdatedSalaryDerivedElementValueForDisplay: '&',
		parentAnnualSalaryPolicy: '<?',
		company: '<',
		currentPayPeriod: '<',
		id: '@',
		mode: '=',
		onDelete: '&',
		// Handler for 'Add <pay|allowance> change' option.
		onAddChange: '&?',
		onError: '&?',
		payPolicies: '<',
		salary: '<',
		/* Applicable if this policy is for a salary future change (i.e. a change for a main post). Used to copy the
		   policy effective date to that when it's changed. */
		salaryFutureChange: '<?',
		salaryPolicy: '<',
		// Set to show 'Add <pay|allowance> change' option. Defaults to true if onAddChange is a valid function , false if not.
		showAddChange: '<?',
		// Control visibility of effective date. Default to true. Ignored (set to true) when allowEditEffectiveDate is true.
		showEffectiveDate: '<?',
		teamMember: '<'
	},
	controller: 'salaryPolicyFormFieldController',
	require: {
		form: '^form'
	},
	templateUrl: 'components/salary-policy-form-field/salary-policy-form-field.component.html'
})

.constant('SALARY_POLICY_FORM_FIELD_MODES', {
	edit: 'edit',
	addChange: 'addChange',
	view: 'view'
})

.controller('salaryPolicyFormFieldController', [
	'$q',
	'$scope',
	'$timeout',
	'config',
	'payrollData',
	'policyService',
	'BACKDATED_SALARY_CALCULATION_METHODS',
	'POLICY_PAY_BASES',
	'POLICY_STATES',
	'SALARY_POLICY_FORM_FIELD_MODES',
function (
	$q,
	$scope,
	$timeout,
	config,
	payrollData,
	policyService,
	BACKDATED_SALARY_CALCULATION_METHODS,
	POLICY_PAY_BASES,
	POLICY_STATES,
	SALARY_POLICY_FORM_FIELD_MODES
) {

	const $ctrl = this;

	const ANNUAL_SALARY_FTE_EQUIVALENT_ITEMS = {
		ftePercent: 'm_Item1',
		annualSalary: 'm_Item2',
		hourlyRate: 'm_Item3'
	};

	const ANNUAL_ALLOWANCE_FTE_EQUIVALENT_ITEMS = {
		annualAllowance: 'm_Item2'
	};

	const FTE_EQUIVALENTS_STATUS = {
		init: 'init',
		updating: 'updating',
		complete: 'complete'
	};

	$ctrl.$onInit = function () {

		// Flag to indicate that this is an annual salary policy, as opposed to an annual allowance policy, for convenience
		const isAnnualSalaryPolicy = $ctrl.salaryPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary;

		// Defaults
		const mode = angular.isDefined($ctrl.mode) ? $ctrl.mode : SALARY_POLICY_FORM_FIELD_MODES.view;
		const allowEditEffectiveDate = angular.isDefined($ctrl.allowEditEffectiveDate) ? $ctrl.allowEditEffectiveDate : false;
		// Show add update if set and valid callback provided, otherwise show it by default only if a valid callback has been provided
		const showAddChange = angular.isDefined($ctrl.showAddChange) && angular.isFunction($ctrl.onAddChange) ? $ctrl.showAddChange : angular.isFunction($ctrl.onAddChange);
		// Show effective date defaults to true if not specified, but will always be set to true if allowEditEffective date is set to true. Obviously.
		const showEffectiveDate = angular.isDefined($ctrl.showEffectiveDate) ? ($ctrl.showEffectiveDate || allowEditEffectiveDate) : true;

		// Filter in only policies for the required basis (annual salary or annual allowance)
		const policyPayBasis = isAnnualSalaryPolicy ? POLICY_PAY_BASES.annualSalary : POLICY_PAY_BASES.annualAllowance;
		$ctrl.payPolicies = $ctrl.payPolicies.filter(payPolicy => payPolicy.PolicyPayBasis === policyPayBasis);
		/* Also hold a list specifically for selection in the UI. The selection list needs to contain active policies, or when an active policy
		   has an update, the updated policy in preference to the original. */
		$ctrl.payPoliciesForSelection = policyService.getPoliciesForSelection($ctrl.payPolicies);

		angular.extend($ctrl, {

			// Dynamic form field IDs for multiple instances. Create for all, whether applicable or not. Doesn't matter.
			effectiveDateFormFieldId: `${$ctrl.id}_EffectiveDate`,
			salaryPolicyFormFieldId: `${$ctrl.id}_Policy`,
			policyBandFormFieldId: `${$ctrl.id}_Band`,
			hoursPerWeekFieldId: `${$ctrl.id}_HoursPerWeek`,
			weeksPerYearFieldId: `${$ctrl.id}_WeeksPerYear`,
			fteApplyFieldId: `${$ctrl.id}_FTEApply`,

			mode,

			confirmDelete: false,
			fteLabel: 'Calculate at full time equivalent',
			hasBackdatedSalary: getHasBackdatedSalary($ctrl),
			isAnnualSalaryPolicy,
			allowEditEffectiveDate,
			minEffectiveDateIso: $ctrl.salaryPolicy.isSalaryPolicyUpdate ? $ctrl.salary.SalaryChangeEffectiveDateMinISO : $ctrl.salary.StartDateISO,
			salaryPolicy: decorateSalaryPolicy($ctrl.salaryPolicy, $ctrl.payPolicies),
			showAddChange,
			showEffectiveDate,
			showMore: false,

			/* Default parent annual salary SalaryPolicy object if not specified, to the salary policy, on the assumption that this form field corresponds
			   to the annual salary SalaryPolicy object */
			parentAnnualSalaryPolicy: angular.isDefined($ctrl.parentAnnualSalaryPolicy) ? $ctrl.parentAnnualSalaryPolicy : $ctrl.salaryPolicy
		});

		// FTE calculations
		if (angular.isDefined($ctrl.salaryPolicy.Band)) {
			// Initialise as if a new policy and band have been selected; calculate FTE equivalents
			updateFTEsAndBackdatedSalary($ctrl);
		}

		// Watchers to update - applicable only to edit / add change mode, when these values are updated dynamically
		if ([SALARY_POLICY_FORM_FIELD_MODES.edit, SALARY_POLICY_FORM_FIELD_MODES.addChange].includes(mode)) {
			// For annual allowance policies, if the FTE Percent changes on the salary, recalculate annual allowance
			if (!isAnnualSalaryPolicy) {
				let initFte = true;
				$scope.$watch('$ctrl.salary.fte', (newFte, oldFte) => {
					// Update FTE label and values when FTE calc changes, or when first being set
					if (angular.isDefined(newFte) && (!angular.equals(newFte, oldFte) || initFte)) {
						// Ensure this doesn't happen again until the values change
						initFte = false;
						$timeout(() => {
							$ctrl.fteLabel = `Calculate at full time equivalent (${newFte.ftePercent}%)`;
						}, 0);
						if ($ctrl.salaryPolicy.FTEApply) {
							updateFTEsAndBackdatedSalary($ctrl);
						}
					}
				});
			}

			// If the period prorating method changes, update backdated salary
			$scope.$watch('$ctrl.salary.periodProRatingMethod', (newPeriodProRatingMethod, oldPeriodProRatingMethod) => {
				// Don't bother updating any policies that have already been paid
				if (angular.isDefined(newPeriodProRatingMethod) && newPeriodProRatingMethod !== oldPeriodProRatingMethod && !$ctrl.salaryPolicy.HasBeenPaid) {
					updateFTEsAndBackdatedSalary($ctrl);
				}
			});
		}
	};

	function decorateSalaryPolicy (salaryPolicyObj, payPoliciesArr) {

		// Create FTE equivalents object on the salary policy object in init state. This will be used to hold the results of FTE calculations
		salaryPolicyObj.fteEquivalents = {
			status: FTE_EQUIVALENTS_STATUS.init
		};

		salaryPolicyObj.BackdateSalaryDerivedElements = $ctrl.backdatedSalaryDerivedElementsEnabled;
		salaryPolicyObj.backdatedSalary = {
			BackdatedElements:  []
		};
		salaryPolicyObj.CalculationMethod = BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod;

		/* Find the associated pay policy. This might be one of the main policies, or if it corresponds to a policy update,
		   it will be the policyUpdate object attached to the original */
		let payPolicy = payPoliciesArr.find(payPolicyObj => payPolicyObj.PolicyID === salaryPolicyObj.PolicyID);

		if (angular.isDefined(payPolicy)) {

			/* The band comes from PolicyBandID. Bind the Band object in the SalaryPolicy object to the correct object. The band may not be defined,
			   if this represents a pay update, the policy is present but the band will have been cleared to force selection */
			if (angular.isDefined(salaryPolicyObj.Band)) {
				salaryPolicyObj.Band = payPolicy.PolicyBands.find(payPolicyBandObj => payPolicyBandObj.PolicyBandID === salaryPolicyObj.Band.PolicyBandID);
			}
		}
		else {
			// Pay policy not set yet. It should be an empty guid, so unset it for the UI
			salaryPolicyObj.PolicyID = undefined;
			salaryPolicyObj.Band = undefined;
		}

		angular.extend(salaryPolicyObj, {
			// Hold reference to the pay policy for contracted times, and anything else it holds that's useful
			payPolicy
		});

		return salaryPolicyObj;
	}

	function getHasBackdatedSalary (ctrlObj) {

		// Is backdated salary applicable for this salary policy?
		const startDateIso = ctrlObj.salaryPolicy.EffectiveDateISO;
		const isUpdate = ctrlObj.salaryPolicy.State === POLICY_STATES.update;
		const hasBeenPaid = ctrlObj.salaryPolicy.HasBeenPaid;

		if (hasBeenPaid && !isUpdate) {
			// If it's already been paid and isn't an update, then no backdated salary
			return false;
		}
		return startDateIso && moment(startDateIso).isBefore(ctrlObj.currentPayPeriod.StartDateISO);
	}

	function onAddChangeClick (ctrlObj) {
		ctrlObj.onAddChange();
	}

	function onBackdatedSettingsChange (ctrlObj) {

		// Recalculate FTE equivalents, and any backdated salary
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function onContractedWorkTimeChange (ctrlObj) {

		// Recalculate FTE equivalents, and any backdated salary
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function onDeletePolicy (ctrlObj) {
		if (angular.isFunction(ctrlObj.onDelete)) {
			ctrlObj.onDelete();
		}
	}

	function onFTEApplyChange (ctrlObj) {
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function onEffectiveDateChange (ctrlObj) {
		// Ensure the policy effective date is also updated with this value if this is for a future change.
		if (angular.isDefined(ctrlObj.salaryFutureChange)) {
			ctrlObj.salaryFutureChange.SalaryEffectiveDateISO = ctrlObj.salaryPolicy.EffectiveDateISO;
		}
		// Recalculate FTE equivalents, and any backdated salary
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function onPolicyChange (ctrlObj, salaryPolicyObj, payPolicyObj) {

		setPolicy(ctrlObj, salaryPolicyObj, payPolicyObj);
	}

	function onPolicyBandChange (ctrlObj) {

		// Recalculate FTE equivalents, and any backdated salary
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function onSalaryPolicyFormFieldError (error) {
		if (angular.isFunction($ctrl.onError)) {
			$ctrl.onError()(error);
		}
	}

	function setPolicy (ctrlObj, salaryPolicyObj, payPolicyObj) {

		// Copy stuff from the selected policy to the parent salary policy. Name and ID apply, regardless
		const payPolicy = salaryPolicyObj.payPolicy;
		angular.extend(salaryPolicyObj, {
			PolicyID: payPolicy.PolicyID,
			PolicyName: payPolicy.PolicyName,
		});

		/* Update SalaryPolicy specific CWTs from parent annual salary policy. Not required for annual allowance
		   SalaryPolicy since that gets its values from the parent annual salary SalaryPolicy object. */
		if (ctrlObj.isAnnualSalaryPolicy) {
			angular.extend(salaryPolicyObj, {
				HoursPerWeek: payPolicyObj.PolicyHoursPerWeek,
				WeeksPerYear: payPolicyObj.PolicyWeeksPerYear,
				PolicyHoursPerWeek: payPolicy.PolicyHoursPerWeek,
				PolicyWeeksPerYear: payPolicy.PolicyWeeksPerYear
			});
		}

		// Now recalculate FTE equivalents, and any backdated salary
		updateFTEsAndBackdatedSalary(ctrlObj);
	}

	function toggleConfirmDelete (ctrlObj) {
		ctrlObj.confirmDelete = !ctrlObj.confirmDelete;
	}

	function toggleShowMore (ctrlObj) {
		ctrlObj.showMore = !ctrlObj.showMore;
	}

	function getBackdatedSalaryDerivedElementsEnabled (ctrlObj) {
		return ctrlObj.backdatedSalaryDerivedElementsEnabled && 
			   ctrlObj.salaryPolicy.CalculationMethod === BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod && 
			   ctrlObj.isAnnualSalaryPolicy && 
			   ctrlObj.salaryPolicy.isSalaryPolicyUpdate && 
			   ctrlObj.salaryPolicy.IsPrimary;
	}

	function getShowBackdatedSalaryDerivedElements(ctrlObj, salaryPolicy) {
		return ctrlObj.backdatedSalaryDerivedElementsEnabled && 
		salaryPolicy.backdatedSalary && 
		salaryPolicy.backdatedSalary.BackdatedElements.length && 
		salaryPolicy.CalculationMethod === BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod;
	}

	function updateFTEsAndBackdatedSalary (ctrlObj) {

		// Ensure the pro-rating method on the salary policy matches that set on the outer salary object
		ctrlObj.salaryPolicy.PeriodProRatingMethod = ctrlObj.salary.periodProRatingMethod;

		// Do the FTEs first, since the backdated salary may depend on the calculated FTE annual salary
		updateFtes(ctrlObj).then(() => {

			// Check backdated salary status
			ctrlObj.hasBackdatedSalary = getHasBackdatedSalary(ctrlObj);

			// Calculate backdated salary accordingly
			if (ctrlObj.hasBackdatedSalary) {
				const salaryPolicy = ctrlObj.salaryPolicy;

				let salaryYearly;
				// Use FTE annual salary in preference to the value defined by the selected band, source dependent on policy type
				if (ctrlObj.isAnnualSalaryPolicy) {
					if (angular.isDefined(salaryPolicy.fteEquivalents) && !isNaN(salaryPolicy.fteEquivalents.annualSalary)) {
						salaryYearly = salaryPolicy.fteEquivalents.annualSalary;
					}
					else {
						if (angular.isDefined(salaryPolicy.Band)) {
							salaryYearly = salaryPolicy.Band.PolicyBandAnnualSalary;
						}
					}
				}
				else {
					if (angular.isDefined(salaryPolicy.fteEquivalents) && !isNaN(salaryPolicy.fteEquivalents.annualAllowance)) {
						salaryYearly = salaryPolicy.fteEquivalents.annualAllowance;
					}
					else {
						if (angular.isDefined(salaryPolicy.Band)) {
							salaryYearly = salaryPolicy.Band.PolicyBandAnnualAllowance;
						}
					}
				}

				// Can only run if SalaryYearly is available. It might be an empty string ...
				if (!salaryYearly) {
					// Hide the backdated salary as it isn't currently applicable - the form field is probably invalid
					salaryPolicy.backdatedSalaryAmount = 0;
					return;
				}

				salaryPolicy.backdatedSalaryState = 'loading';

				let backdateElements = $ctrl.backdatedSalaryDerivedElementsEnabled;
				if (angular.isDefined(salaryPolicy.BackdateSalaryDerivedElements)) {
					backdateElements = salaryPolicy.BackdateSalaryDerivedElements;
				}

				/* Determine which calculation API to use depending on team member / policy / post status:
					getTeamMemberBackdatedSalary: Primary annual salary, team member is an existing worker (not new starter).
					getTeamMemberBackdatedSalaryNewStarter: Primary annual salary, team member is a new starter.
					getSalaryPolicyBackpay: Not primary (i.e. additional post) or annual allowance salary.
				 */
				let getBackdatedSalary;
				if (ctrlObj.salaryPolicy.IsPrimary && ctrlObj.isAnnualSalaryPolicy) {
					if (ctrlObj.teamMember.company.IsStarter) {
						getBackdatedSalary = payrollData.getTeamMemberBackdatedSalaryNewStarter(
							ctrlObj.teamMember.personal.UserID,
							ctrlObj.agencyProfileId,
							salaryYearly,
							ctrlObj.salaryPolicy.EffectiveDateISO,
							ctrlObj.salaryPolicy.CalculationMethod,
							ctrlObj.salaryPolicy.PeriodProRatingMethod
						);
					}
					else {
						/* For new policy updates the change policy has an empty SalaryPolicyID because it has not been
						   saved yet, so we pass the existing salaryPolicyID to build history for comparison. When saved, the existing update's id is passed. 
						   The api handles both these flows, understanding when it is handling a pending update vs an unsaved one*/
						let salaryPolicyID = ctrlObj.salaryPolicy.SalaryPolicyID;
						if (salaryPolicyID === config.guidEmpty && ctrlObj.salaryPolicy.isSalaryPolicyUpdate && angular.isDefined(ctrlObj.salary.Policies)) {
							const currentPrimaryPolicy = ctrlObj.salary.Policies.find(policy => policy.IsPrimary && policy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary);
							if (angular.isDefined(currentPrimaryPolicy)) {
								salaryPolicyID = currentPrimaryPolicy.SalaryPolicyID;
							}
						}

						getBackdatedSalary = payrollData.getPrimaryPolicyBackpayDisplay(
							ctrlObj.teamMember.personal.UserID,
							ctrlObj.agencyProfileId,
							salaryYearly,
							salaryPolicyID,
							ctrlObj.salaryPolicy.EffectiveDateISO,
							backdateElements
						);
					}
				}
				else {
					/* Applies to all non-primary policies, including any annual allowances and any policies (regardless of type)
					   for additional posts */
					getBackdatedSalary = payrollData.getSalaryPolicyBackpayDisplay(
						ctrlObj.agencyProfileId,
						ctrlObj.teamMember.personal.UserID,
						salaryYearly,
						ctrlObj.salaryPolicy.SalaryPolicyID,
						ctrlObj.salaryPolicy.EffectiveDateISO,
						ctrlObj.salaryPolicy.PeriodProRatingMethod
					);
				}

				getBackdatedSalary.then(backdatedSalaryAmountResponse => {

					// Depending on which API was used, the nature of this backdated salary amount response varies.
					let backdatedSalaryAmount;
					if (typeof backdatedSalaryAmountResponse === 'object') {
						// The number of interest is in the response object
						backdatedSalaryAmount = backdatedSalaryAmountResponse.BackdatedSalaryAmount;
					}
					else if (typeof backdatedSalaryAmountResponse === 'number') {
						// The number of the object is the response
						backdatedSalaryAmount = backdatedSalaryAmountResponse;
					}

					salaryPolicy.backdatedSalaryAmount = backdatedSalaryAmount;
					if (angular.isDefined(backdatedSalaryAmountResponse.BackdatedElements)) {
						salaryPolicy.backdatedSalary = {
							BackdatedElements: backdatedSalaryAmountResponse.BackdatedElements || []
						};
					}
					

					// Set label for backdated calculation card
					let backdatedSalaryLabel = 'Salary - Backdated';
					if (!ctrlObj.isAnnualSalaryPolicy) {
						backdatedSalaryLabel = `${ctrlObj.salaryPolicy.Band.PolicyBandName} - Backdated`;
					}
					salaryPolicy.backdatedSalaryLabel = backdatedSalaryLabel;

					// Allow time to avoid animation flashes
					$timeout(() => {
						salaryPolicy.backdatedSalaryState = 'ready';
					}, 500);
				})
				.catch(onSalaryPolicyFormFieldError);
			}
		});
	}

	function updateFtes (ctrlObj) {

		/* Do this asynchronously, so we can wait for the FTE calculation to complete before doing anything else. This is so FTEs are
		   up-to-date before calling any change handlers that depend on them */
		return $q(function(resolve) {

			// Get salaryPolicy for convenience
			const salaryPolicy = ctrlObj.salaryPolicy;

			/* If this is an annual allowance policy, get the contracted hours from the top level salary object. These will
			   have been applied when initialising the annual salary policy, for sharing amongst annual allowance policies */
			if (!ctrlObj.isAnnualSalaryPolicy) {
				const fte = ctrlObj.salary.fte;
				if (angular.isDefined(fte)) {
					// Set these things on the salary policy
					salaryPolicy.HoursPerWeek = fte.hoursPerWeek;
					salaryPolicy.WeeksPerYear = fte.weeksPerYear;
				}
			}

			// Can't do any calculating if there's no selected policy band, hours per week and weeks per year
			if (angular.isDefined(salaryPolicy.Band) &&
				salaryPolicy.Band.PolicyBandID !== config.guidEmpty &&
				angular.isDefined(salaryPolicy.HoursPerWeek) && angular.isDefined(salaryPolicy.WeeksPerYear)) {

				// Salary value to use for FTE calculation
				const salaryValue = ctrlObj.isAnnualSalaryPolicy ? salaryPolicy.Band.PolicyBandAnnualSalary : salaryPolicy.Band.PolicyBandAnnualAllowance;

				// If this is an annual allowance policy and fteApply isn't set, just use the salaryValue as is.
				if (!ctrlObj.isAnnualSalaryPolicy && !salaryPolicy.FTEApply) {
					salaryPolicy.fteEquivalents = {
						status: FTE_EQUIVALENTS_STATUS.complete,
						annualAllowance: salaryValue
					};
					resolve();
				}
				else {
					// Show calculating indicator after a short delay. No point showing if this is quick.
					const showFTECalculating = $timeout(() => {
						salaryPolicy.fteEquivalents = {
							status: FTE_EQUIVALENTS_STATUS.updating
						};
					}, 500);

					payrollData.getFTEEquivalentDetails(
						ctrlObj.teamMember.personal.UserID,
						ctrlObj.agencyProfileId,
						salaryValue,
						salaryPolicy.HoursPerWeek,
						salaryPolicy.WeeksPerYear,
						salaryPolicy.PolicyID,
						// parentAnnualSalaryPolicy will be equivalent to salaryPolicy when this form field is for the annual salary SalaryPolicy object
						ctrlObj.parentAnnualSalaryPolicy.payPolicy.PolicyHoursPerWeek,
						ctrlObj.parentAnnualSalaryPolicy.payPolicy.PolicyWeeksPerYear
					)
					.then(fteEquivalentDetails => {

						// Cancel timeout to show 'Calculating'. If the above call happens quickly, so the calculating state won't be seen.
						$timeout.cancel(showFTECalculating);

						// Set FTE equivalent values for display, depending on policy basis type
						if (ctrlObj.isAnnualSalaryPolicy) {
							salaryPolicy.fteEquivalents = {
								status: FTE_EQUIVALENTS_STATUS.complete,
								ftePercent: fteEquivalentDetails[ANNUAL_SALARY_FTE_EQUIVALENT_ITEMS.ftePercent],
								annualSalary: fteEquivalentDetails[ANNUAL_SALARY_FTE_EQUIVALENT_ITEMS.annualSalary],
								hourlyRate: fteEquivalentDetails[ANNUAL_SALARY_FTE_EQUIVALENT_ITEMS.hourlyRate]
							};
							// Set FTE object on top level salary object so annual allowance policies can pick it up and recalculate if required
							ctrlObj.salary.fte = {
								ftePercent: fteEquivalentDetails[ANNUAL_SALARY_FTE_EQUIVALENT_ITEMS.ftePercent],
								hoursPerWeek: salaryPolicy.HoursPerWeek,
								weeksPerYear: salaryPolicy.WeeksPerYear
							};
						}
						else {
							// Get annual allowance and adjust if FTE apply is set
							let annualAllowance = fteEquivalentDetails[ANNUAL_ALLOWANCE_FTE_EQUIVALENT_ITEMS.annualAllowance];
							salaryPolicy.fteEquivalents = {
								status: FTE_EQUIVALENTS_STATUS.complete,
								annualAllowance
							};
						}
						resolve();
					});
				}
			}
			else {
				// Not enough info to calculate
				salaryPolicy.fteEquivalents = {
					status: FTE_EQUIVALENTS_STATUS.init
				};
				resolve();
			}
		});
	}

	angular.extend($ctrl, {

		FTE_EQUIVALENTS_STATUS,
		POLICY_PAY_BASES,
		POLICY_STATES,
		SALARY_POLICY_FORM_FIELD_MODES,

		config,

		getBackdatedSalaryDerivedElementsEnabled,
		getShowBackdatedSalaryDerivedElements,
		onAddChangeClick,
		onBackdatedSettingsChange,
		onDeletePolicy,
		onFTEApplyChange,
		onContractedWorkTimeChange,
		onEffectiveDateChange,
		onPolicyChange,
		onPolicyBandChange,
		toggleConfirmDelete,
		toggleShowMore
	});
}]);

angular.module('paycircleApp')

.component('scheduleOverviewCard', {

	bindings: {
		agencyProfileId: '<',
		index: '<',
		onClick: '&?',
		onUpdate: '&?',
		schedule: '<',
		teamMember: '<'
	},
	controller: 'scheduleOverviewCardCtrl',
	templateUrl: 'components/schedule-overview-card/schedule-overview-card.component.html'
})

.controller('scheduleOverviewCardCtrl', [
	'$rootScope',
	'edpTopicService',
	'REPAYMENT_SCHEDULE_TYPES',
	function (
		$rootScope,
		edpTopicService,
		REPAYMENT_SCHEDULE_TYPES
	) {

	const $ctrl = this;

	$ctrl.isEdpMaternityTopicEnabled = false;

	function $onInit () {

		if ($ctrl.agencyProfileId) {
			edpTopicService.isTopicEnabled($ctrl.agencyProfileId, edpTopicService.TOPIC_KEYS.maternity).then(function (isEnabled) {
				$ctrl.isEdpMaternityTopicEnabled = isEnabled;
			})
			.catch(function (error) {
				console.error(error);
				$ctrl.isEdpMaternityTopicEnabled = false;
			});
		}
	}

	function onCardClick () {

		if (angular.isFunction($ctrl.onClick)) {
			$ctrl.onClick();
		}
	}

	function openAdvanceMaternityFundingForm (maternityScheduleId) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: () => {
				$ctrl.onUpdate({schedule: $ctrl.schedule});
			},
			contextType: 'user',
			formKey: 'advance-maternity-funding',
			maternityScheduleId: maternityScheduleId,
			userId: $ctrl.teamMember.Personal.UserID
		});
	}

	angular.extend($ctrl, {
		REPAYMENT_SCHEDULE_TYPES,
		isEdpMaternityTopicEnabled: $ctrl.isEdpMaternityTopicEnabled,
		$onInit,
		onCardClick,
		openAdvanceMaternityFundingForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('searchBar', {
	bindings: {
		// Callback for action selected. Must be of the form: callback(actionKey).
		actionSelected: '&?',
		bulkActionsActive: '<?',
		bulkItems: '=?',
		count: '<?',
		options: '=',
		onSearch: '&',
		onCustom: '&?',
		showActions: '<?'
	},
	controller: 'searchBarCtrl',
	controllerAs: 'vm',
	templateUrl: 'components/search-bar/search-bar.component.html',
	transclude: {
		bulkActions: '?sbBulkActions',
		leftActions: '?sbActions',
		rightActions: '?sbRightActions'
	},
})
.controller('searchBarCtrl', [
	'$rootScope',
	'$timeout',
	'$transclude',
	'$window',
	'bulkService',
	'config',
	'searchService',
	'securityService',
	'storageService',
	'utilities',
	'STATE_STORAGE_KEYS',
function (
	$rootScope,
	$timeout,
	$transclude,
	$window,
	bulkService,
	config,
	searchService,
	securityService,
	storageService,
	utilities,
	STATE_STORAGE_KEYS
) {

	const $ctrl = this;

	// View modes, dependent on window width
	const VIEW_MODES = {
		desktop: 'desktop',
		mobile: 'mobile'
	};

	const currentUserObj = $rootScope.currentUser;

	function $onDestroy () {
		// Remove window event listener
		angular.element($window).off('resize');
	}

	function $onInit () {

		let optionsObj = getOptionsForSearchBar($ctrl);
		let bulkItemsObj = $ctrl.bulkItems;

		$ctrl.showActions = angular.isDefined($ctrl.showActions) ? $ctrl.showActions : true;
		$ctrl.bulkActionsActive = angular.isDefined($ctrl.bulkActionsActive) ? $ctrl.bulkActionsActive : true;

		angular.extend($ctrl, {
			// Show search bar actions if there are any, and if a callback has been provided, and showActions is true
			showSearchBarActions: angular.isDefined(optionsObj.actions) && optionsObj.actions.length !== 0 && angular.isFunction($ctrl.actionSelected) && $ctrl.showActions,
			hasBulkActions: $transclude.isSlotFilled('bulkActions') && $ctrl.bulkActionsActive,
			hasLeftActions: $transclude.isSlotFilled('leftActions'),
			hasRightActions: $transclude.isSlotFilled('rightActions'),
			options: optionsObj,
		});

		// Load default filter options
		searchService.loadDefaultFilterOptions(optionsObj);
		searchService.loadDefaultSearchFilterOptions(optionsObj);

		if (bulkItemsObj) {
			bulkItemsObj = bulkService.updateBulkItemTotals(bulkItemsObj);
		}

		// On window resize, set the view mode accordingly.
        angular.element($window).on('resize', () => {
			setViewMode($ctrl);
		});

		// Set initial view mode
		setViewMode($ctrl);
	}

	function getAuthorisedActions (actionsArr) {
		return actionsArr.filter(actionObj => securityService.isUserAuthorisedFromPermissionArray(currentUserObj, actionObj.requiredPermissions, 'search'));
	}

	function getOptionsForSearchBar (ctrlObj) {

		const optionsWithDefaultObj = searchService.getOptionsWithDefaults(ctrlObj.options);
		const itemsCount = ctrlObj.bulkItems ? ctrlObj.bulkItems.filtered.length : ctrlObj.count;

		// Persist search in url parameters
		if (!optionsWithDefaultObj.search.disablePersistedSearch) {
			angular.extend(optionsWithDefaultObj.search, {
				filterOptionId: storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.searchFilterId, ''),
				string: storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.searchString, '')
			});
		}

		// Filter out actions that user doesn't have permission for
		if (angular.isDefined(optionsWithDefaultObj.actions)) {
			optionsWithDefaultObj.actions = getAuthorisedActions(optionsWithDefaultObj.actions);
		}

		return angular.extend(optionsWithDefaultObj, {
			currentPageNumber: storageService.getFromSessionStorageForCurrentState(STATE_STORAGE_KEYS.pageNumber, 1),
			itemsPerPageOptions: searchService.getItemsPerPageOptions(optionsWithDefaultObj, itemsCount),
			onPageChange,
			onSearchChange
		});
	}

	/* Ensure that the selected total is updated correctly prior to retrieving it, since selected items
	   may be being added or removed based on a search filter. */
	function getTotalSelected () {
		updateBulkItemTotals();
		return $ctrl.bulkItems.totalSelected;
	}

	function onPageChange (newPageNumber) {
		storageService.addToSessionStorageForCurrentState(STATE_STORAGE_KEYS.pageNumber, newPageNumber);
	}

	/* On search criteria change, ensure the total is updated correctly (this takes filters into account,
	   so filtered out but selected items aren't included in the total). Do this on a timeout so it executes
	   *after* any filter has been applied. Otherwise the UI will typically get out of sync. */
	function onSearchChange (searchOptionsObj) {

		searchService.createSearchFilter(searchOptionsObj);
		$timeout(updateBulkItemTotals());

		// Trigger on search function
		if (angular.isFunction($ctrl.onSearch)) {
			$ctrl.onSearch();
		}

		// Persist search parameters if enabled
		if (!searchOptionsObj.search.disablePersistedSearch) {
			storageService.addToSessionStorageForCurrentState(STATE_STORAGE_KEYS.searchFilterId,
															  angular.isDefined(searchOptionsObj.search.filterOptions) ? searchOptionsObj.search.filterOption.id : null);
			storageService.addToSessionStorageForCurrentState(STATE_STORAGE_KEYS.searchString,
															  searchOptionsObj.search.string ? searchOptionsObj.search.string : null);
		}
	}

	function onCustomChange (optionsObj, customOptionObj) {

		searchService.changeCustom(optionsObj, customOptionObj);

		// Trigger on custom function
		if (angular.isFunction($ctrl.onCustom)) {
			$ctrl.onCustom();
		}
	}

	function searchBarActionSelected (optionsObj, searchBarActionKey) {

		$ctrl.actionSelected()(searchBarActionKey);
		optionsObj.showMobileActions = false;
	}

	function setViewMode (ctrlObj) {

		// Switch view mode if necessary. Do this in a timeout so the digest cycle runs on change.
		$timeout(() => {
			if ($window.innerWidth < config.screenPixelMaxWidths.tablet && ctrlObj.viewMode !== VIEW_MODES.mobile) {
				ctrlObj.viewMode = VIEW_MODES.mobile;
			}
			else if ($window.innerWidth >= config.screenPixelMaxWidths.tablet && ctrlObj.viewMode !== VIEW_MODES.desktop) {
				ctrlObj.viewMode = VIEW_MODES.desktop;
			}
		}, 0);
	}

	function toggleMobileActions (optionsObj) {

		optionsObj.showMobileActions = !optionsObj.showMobileActions;
	}

	function toggleMobileCustom (optionsObj) {

		optionsObj.showMobileCustom = !optionsObj.showMobileCustom;
	}

	function toggleMobileItemsPerPage (optionsObj) {

		optionsObj.showMobileItemsPerPage = !optionsObj.showMobileItemsPerPage;
	}

	function toggleMobileSearch (optionsObj) {

		optionsObj.showMobileSearch = !optionsObj.showMobileSearch;

		// Set focus to search input field on open, clear search string on close
		if (optionsObj.showMobileSearch) {
			utilities.focusOn(optionsObj.id);
		}
		else {
			optionsObj.userSearchString = '';
		}
	}

	function toggleMobileSort (optionsObj) {

		optionsObj.showMobileSort = !optionsObj.showMobileSort;
	}

	function toggleSelectedItems (bulkItemsObj) {

		bulkService.updateItemsSelectedState(bulkItemsObj);
	}

	function updateBulkItemTotals () {

		if (angular.isDefined($ctrl.bulkItems)) {
			$ctrl.bulkItems = bulkService.updateBulkItemTotals($ctrl.bulkItems);
		}
	}

	function isCheckboxDisabled () {

		// Disable checkbox if there are no selectable items
		return $ctrl.bulkItems.filtered.filter(item => !item.cannotBeSelected).length === 0;
	}

	angular.extend($ctrl, {
		VIEW_MODES,

		$onDestroy,
		$onInit,
		changeCustom: onCustomChange,
		changeItemsPerPage: searchService.changeItemsPerPage,
		changeLayout: searchService.changeLayout,
		changeOrderBy: searchService.changeOrderBy,
		getTotalSelected,
		isCheckboxDisabled,
		toggleMobileActions,
		toggleMobileCustom,
		toggleMobileItemsPerPage,
		toggleMobileSearch,
		toggleMobileSort,
		toggleSelectedItems,
		searchBarActionSelected,

		searchBarOpen: false
	});
}]);

angular.module('paycircleApp')

.component('searchBox', {
	bindings: {
		inputId: '@?',
		ngModel: '=',
		onClear: '&?',
		onRemoveTag: '&?',
		searchFor: '@?', 	// Description of the domain being searched, e.g. 'articles'. Used to populate the placeholder. Defaults to '',
		showClear: '<?', 	// Show or hide the clear button. Defaults to false.
		tagList: '<?' 		// Tag list for display inside the input box. Array of tags.
	},
	controller: 'searchBoxCtrl',
	templateUrl: 'components/search-box/search-box.component.html'
})

.controller('searchBoxCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		// Defaults
		$ctrl.inputId = angular.isDefined($ctrl.inputId) ? $ctrl.inputId : '';
		$ctrl.showClear = angular.isDefined($ctrl.showClear) ? $ctrl.showClear : false;
		// If no tag list, create one with zero length just for consistency
		$ctrl.tagList = angular.isDefined($ctrl.tagList) ? $ctrl.tagList : [];
		$ctrl.placeholder = `Search ${$ctrl.searchFor}`;
	};

	function clearSearch (ctrlObj) {
		if (angular.isDefined(ctrlObj.tagList)) {
			ctrlObj.tagList = [];
		}
		ctrlObj.ngModel = '';
		if (angular.isFunction(ctrlObj.onClear)) {
			ctrlObj.onClear();
		}
	}

	function removeTag (ctrlObj, tagListIndex) {
		ctrlObj.tagList.splice(tagListIndex, 1);
		if (angular.isFunction(ctrlObj.onRemoveTag)) {
			ctrlObj.onRemoveTag();
		}
	}

	angular.extend($ctrl, {
		clearSearch,
		removeTag
	});

}]);
'use strict';

angular.module('paycircleApp')
.component('searchField', {
	bindings: {
		isSearchActive: '<',
		searchOptions: '='
	},
	controller: 'searchFieldCtrl',
	templateUrl: 'components/search-field/search-field.component.html'
})
.controller('searchFieldCtrl', ['$timeout', 'utilities', function ($timeout, utilities) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl.searchOptions, {
			clearSearch: () => {
				clearOrHideSearch($ctrl);
			},
			filterOptionsMenuOpen: false,
			id: angular.isDefined($ctrl.searchOptions.id) ? $ctrl.searchOptions.id : 'search-field',
			iconTheme: angular.isDefined($ctrl.searchOptions.iconTheme) ? $ctrl.searchOptions.iconTheme : '',
			isSearchActive: getIsSearchActiveOnInit($ctrl)
		});
	}

	function changeFilter ($ctrl, selectedOptionObj) {

		$ctrl.searchOptions.search.filterOption = selectedOptionObj;
		$ctrl.searchOptions.filterOptionsMenuOpen = false;

		triggerOnSearchChange($ctrl);
	}

	function clearOrHideSearch ($ctrl) {

		// Close if empty
		if (isSearchStringEmpty($ctrl)) {
			setIsSearchActive($ctrl, false);
			return;
		}

		// Clear if not empty
		setSearchString($ctrl, '');
		focusOnSearchString($ctrl);
	}

	function focusOnSearchString ($ctrl) {

		utilities.focusOn($ctrl.searchOptions.id);
	}

	function getIsSearchActive ($ctrl) {

		return $ctrl.searchOptions.isSearchActive;
	}

	function getIsSearchActiveOnInit ($ctrl) {

		// If search string is defined (e.g. in the URL)
		if (!isSearchStringEmpty($ctrl)) {
			return true;
		}

		// Can manually be set to active by default
		if (angular.isDefined($ctrl.isSearchActive)) {
			return $ctrl.isSearchActive;
		}

		// Closed by default
		return false;
	}

	function hideSearch ($ctrl) {

		setIsSearchActive($ctrl, false);
	}

	function isSearchStringEmpty ($ctrl) {

		return $ctrl.searchOptions.search.string === '';
	}

	function setIsSearchActive ($ctrl, isSearchActive) {

		$ctrl.searchOptions.isSearchActive = isSearchActive;
		$ctrl.searchOptions.showMobileSearch = isSearchActive;

	}

	function setSearchString ($ctrl, newSearchString) {

		$ctrl.searchOptions.search.string = newSearchString;

		triggerOnSearchChange($ctrl);
	}

	function toggleIsSearchActive ($ctrl) {

		const isSearchActiveNew = getIsSearchActive($ctrl) ? false : true;

		setIsSearchActive($ctrl, isSearchActiveNew);

		if (getIsSearchActive($ctrl)) {
			focusOnSearchString($ctrl);
		}
	}

	function triggerOnSearchChange ($ctrl) {

		if (angular.isFunction($ctrl.searchOptions.onSearchChange)) {
			$ctrl.searchOptions.onSearchChange($ctrl.searchOptions);
		}
	}

	angular.extend($ctrl, {
		$onInit,
		changeFilter,
		clearOrHideSearch,
		hideSearch,
		toggleIsSearchActive
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('secondaryLoadingMask', {
	bindings: {
		loadingMaskOptions: '<'
	},
	templateUrl: 'components/secondary-loading-mask/secondary-loading-mask.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('settingsBreadcrumb', {
	bindings: {
		'agencyProfileId': '<',
		'stateName': '<'
	},
	controller: 'settingsBreadcrumbCtrl',
	templateUrl: 'components/settings-breadcrumb/settings-breadcrumb.component.html'
})
.controller('settingsBreadcrumbCtrl', ['$scope', '$state', function ($scope, $state) {

	const $ctrl = this;


	function getNgHrefForState (state) {

		return $state.href(state, { agencyProfileId: $ctrl.agencyProfileId });
	}

	function getNgHrefForStateName (state) {

		if (state.indexOf('bureau') > -1) {
			return getNgHrefForState('settings.bureau.overview');
		}

		if (state.indexOf('group') > -1) {
			return getNgHrefForState('settings.group.overview');
		}

		return getNgHrefForState('settings.company.overview');
	}

	function $onInit () {

		$ctrl.ngHref = getNgHrefForStateName($ctrl.stateName);
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('setupBlock', {
	templateUrl: 'components/setup-block/setup-block.component.html',
	bindings: {
		sbGraphic: '@?',
		sbTheme: '@?'
	},
	transclude: {
		'header': '?sbHeader',
		'content': '?sbContent',
	}
});

'use strict';

angular.module('paycircleApp')
.component('simpleWorkPattern', {
	bindings: {
		onUpdate: '=',
		workPattern: '=',
	},
	controller: 'simpleWorkPatternCtrl',
	templateUrl: 'components/simple-work-pattern/simple-work-pattern.component.html',
})
.controller('simpleWorkPatternCtrl', [
	'SIMPLE_WORK_PATTERN_DAYS',
	'utilities',
	function (
		SIMPLE_WORK_PATTERN_DAYS,
		utilities
	) {

	const $ctrl = this;

	function onUpdateDay(day) {
		if (utilities.isFunction($ctrl.onUpdate)) {
			$ctrl.onUpdate(day);
		}
	}

	angular.extend($ctrl, {
		workPattern: $ctrl.workPattern,
		onUpdate: $ctrl.onUpdate,
		onUpdateDay: onUpdateDay,
		SIMPLE_WORK_PATTERN_DAYS
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('statutoryParentalPayNotEligible', {
	bindings: {
		eligibilityDateMinIso: '<',
		forename: '@',
		isLeaver: '<',
		isPoliciesApplicable: '<',
		leaveDateIso: '<',
		parentalType: '@', // 'maternity' | 'paternity'
		payErrors: '<',
		payStatus: '<',
		salaryPayments: '<',
		todayIso: '<'
	},
	controller: 'statutoryParentalPayNotEligibleCtrl',
	templateUrl: 'components/statutory-parental-pay-not-eligible/statutory-parental-pay-not-eligible.component.html'
})
.controller('statutoryParentalPayNotEligibleCtrl', [
	'URLS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	function (URLS, STAT_PAYMENT_SCHEDULE_STATES) {

	const $ctrl = this;

	angular.extend($ctrl, {
		STAT_PAYMENT_SCHEDULE_STATES
	});

	$ctrl.$onInit = function () {

		const isMaternity = $ctrl.parentalType === 'maternity';

		angular.extend($ctrl, {
			allowanceLabel: isMaternity ? 'Maternity Allowance' : 'Paternity Allowance',
			endDateIso: $ctrl.isLeaver ? $ctrl.leaveDateIso : $ctrl.todayIso,
			formName: isMaternity ? 'SMP1 form' : 'SPP1 form',
			formUrl: isMaternity ? URLS.gov.smp1Form : URLS.gov.spp1Form,
			isMaternity,
			payTypeLabel: isMaternity ? 'Maternity' : 'Paternity'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
	.component('simpleWorkPatternSummary', {
		bindings: {
			workPattern: '=',
		},
		controller: 'simpleWorkPatternSummaryCtrl',
		templateUrl: 'components/simple-work-pattern-summary/simple-work-pattern-summary.component.html',
	})
	.controller('simpleWorkPatternSummaryCtrl', ['SIMPLE_WORK_PATTERN_DAYS',
		function (SIMPLE_WORK_PATTERN_DAYS) {

			const $ctrl = this;


			angular.extend($ctrl, {
				SIMPLE_WORK_PATTERN_DAYS
			});

		}]);

'use strict';

angular.module('paycircleApp')
.directive('slideInForm', function () {

	return {
		controller: 'slideInFormCtrl',
		templateUrl: 'components/slide-in-form/slideInFormComponent.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		},
		transclude: true
	};
})
.controller('slideInFormCtrl', [
	'$rootScope',
	'$scope',
	'$timeout',
	'supportService',
	'utilities',
	'USER_ROLES',
function (
	$rootScope,
	$scope,
	$timeout,
	supportService,
	utilities,
	USER_ROLES
) {

	var agencyProfileId 	= $scope.formOptions.agencyProfileId;
	var animationSpeed 		= $scope.formOptions.animationSpeed; // Seconds
	var callback 			= $scope.formOptions.callback;
	var formKey 			= $scope.formOptions.formKey;
	var formTitle 			= $scope.formOptions.title;
	var userId 				= $scope.formOptions.userId;

	function closeForm (callbackPropertiesObj) {

		$scope.formOptions.isClosing = true;

		$rootScope.$broadcast('close-tooltip-card');

		// Signal close to application. It just needs to know so it can deal with the overlay.
		$rootScope.$broadcast('close-slide-in-form');

		$timeout(() => {

			$scope.formOptions.isOpen = false;
			$scope.formOptions.isClosing = false;

			initCallback(callbackPropertiesObj);

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.closeWizard();
			}

			if (angular.isFunction($scope.formOptions.onClose)) {
				$scope.formOptions.onClose();
			}

		}, animationSpeed * 1000);
	}

	function closeWithoutCallback () {

		$scope.formOptions.isClosing = true;

		// Signal close to application. It just needs to know so it can deal with the overlay.
		$rootScope.$broadcast('close-slide-in-form');

		$timeout(function () {

			$scope.formOptions.isOpen = false;
			$scope.formOptions.isClosing = false;

		}, animationSpeed * 1000);
	}

	function init () {

		// Ignore wizards as the form key is retrieved from the server
		if ($scope.formOptions.isWizard) {
			return;
		}

		if (!$scope.formOptions.formKey) {
			console.error('A form key is required to open a slide in form.');
			return;
		}

		setupFormTitle();
	}

	function initCallback (callbackPropertiesObj) {

		// Only fire callback if an update has occurred & a callback is supplied
		if ($scope.formOptions.initCallbackOnClose) {

			forceCallback(callbackPropertiesObj);
		}
	}

	function forceCallback (callbackPropertiesObj) {

		if (angular.isDefined(callback)) {

			// Validate to make sure the callback is a function
			if (!utilities.isFunction(callback)) {
				console.warn('Callback provided is not a function');
				return;
			}

			// Callback can provide a custom callback object
			if (angular.isDefined(callbackPropertiesObj)) {
				callback(callbackPropertiesObj);
			}
			else {
				callback(userId, agencyProfileId);
			}
		}
	}

	function openForm () {

		$scope.formOptions.isOpen = true;
	}

	function openInlineHelpAndSupport () {

		const tags = supportService.getHelpAndSupportTagsForSlideInForm(formKey);

		// If no tags defined, this will go to the help and support home page
		$rootScope.$broadcast('open-help-and-support-panel', { tags });
	}

	function openNewSlideInForm (formOptions) {

		// Close form and open new, notifying new form open operation of the intention to retain an existing overlay
		closeForm();

		$timeout(() => {
			$rootScope.$broadcast('open-slide-in-form', formOptions);
		}, animationSpeed * 1000);
	}

	function setupFormTitle () {

		// Add default title if not provided
		formTitle = formTitle ? formTitle : formKey.replace(/-/g, ' ');

		$scope.formOptions.title = formTitle;
	}

	init();

	angular.extend($scope.formOptions, {
		closeForm,
		closeWithoutCallback,
		forceCallback,
		openForm,
		openInlineHelpAndSupport,
		openNewSlideInForm
	});

	angular.extend($scope, {
		USER_ROLES
	});
}]);

'use strict';

/**
 * @ngdoc function
 * @name statusDirective
 * @description
 * Directive that displays an object that shows a state
 */

angular.module('paycircleApp')
.directive('statusDirective', function () {

	return {
		templateUrl: 'components/state/stateComponent.html',
		replace:true,
		scope: {
			step: '=',
			stepName: '@',
			active: '=',
			finished: '='
		}
	};
});


'use strict';

angular.module('paycircleApp')
.component('submissionLogs', {
	bindings: {
		agencyProfileId: '<',
		onResetPeriod: '&?',
		p11dbSubmissionId: '<?',
		payPeriodId: '<',
		submissionLogEntries: '=?',
		submissionLogType: '<',
		supplementaryPaymentId: '<?'
	},
	controller: 'submissionLogsCtrl',
	templateUrl: 'components/submission-logs/submission-logs.component.html',
	transclude: {
		'submissionLogsDismissedCopy': 'submissionLogsDismissedCopy',
	}
})
.controller('submissionLogsCtrl', [
	'$q',
	'$rootScope',
	'aiServices',
	'base',
	'payrollData',
	'reportData',
	'COPILOT_FEATURES',
	'RTI_SUBMISSION_REPORT_TYPE_BITWISE',
	'SUBMISSION_LOG_TYPE',
	function (
		$q,
		$rootScope,
		aiServices,
		base,
		payrollData,
		reportData,
		COPILOT_FEATURES,
		RTI_SUBMISSION_REPORT_TYPE_BITWISE,
		SUBMISSION_LOG_TYPE
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const SUBMISSION_DISMISS_STATES = {
		confirm: 'confirm',
		loading: 'loading'
	};

	const COPILOT_REQUEST_STATES = {
		notRequested: 'notRequested',
		loading: 'loading',
		completed: 'completed'
	};

	function $onInit () {

		setComponentState(COMPONENT_STATES.loading);

		if (angular.isUndefined($ctrl.submissionLogType)) {
			onError('Missing SubmissionLogType');
			return;
		}

		if (angular.isUndefined($ctrl.agencyProfileId)) {
			onError('Missing AgencyProfileID');
			return;
		}

		if (angular.isUndefined($ctrl.payPeriodId)) {
			onError('Missing PayPeriodID');
			return;
		}

		getSubmissionLogServiceForSubmissionLogType()
			.then(loadComponentFromSubmissionLogs)
			.catch(onError);
	}

	function getSubmissionLogServiceForSubmissionLogType () {

		const includeDismissed = false;
		const latestAttemptsOnly = true;

		switch ($ctrl.submissionLogType) {

			// CIS Suffered
			case SUBMISSION_LOG_TYPE.cisSuffered:
				return base.getSubmissionLogsForEPSSubmission(
					$ctrl.agencyProfileId,
					$ctrl.payPeriodId,
					includeDismissed,
					latestAttemptsOnly
				);

			// P11D(b) Submissions
			case SUBMISSION_LOG_TYPE.p11dbSubmission:

				if (angular.isUndefined($ctrl.p11dbSubmissionId)) {
					onError('Missing P11DBSubmissionID');
					return;
				}

				return base.getSubmissionLogsForP11DbSubmission(
					$ctrl.agencyProfileId,
					$ctrl.payPeriodId,
					$ctrl.p11dbSubmissionId,
					includeDismissed,
					latestAttemptsOnly
				);

			// Supplementary Payments
			case SUBMISSION_LOG_TYPE.supplementaryPayRun:

				if (angular.isUndefined($ctrl.supplementaryPaymentId)) {
					onError('Missing SupplementaryPaymentID');
					return;
				}

				return base.getSubmissionLogsForSupplementaryPayment(
					$ctrl.agencyProfileId,
					$ctrl.payPeriodId,
					$ctrl.supplementaryPaymentId,
					includeDismissed,
					latestAttemptsOnly
				);

			// Pay Period
			case SUBMISSION_LOG_TYPE.payPeriod:

				return base.getSubmissionLogsForAgencyPayPeriod(
					$ctrl.agencyProfileId,
					$ctrl.payPeriodId,
					includeDismissed,
					latestAttemptsOnly
				);
		}
	}

	function loadComponentFromSubmissionLogs (submissionLogsArr) {

		const p11dbSubmissionId = $ctrl.p11dbSubmissionId;
		const supplementaryPaymentId = $ctrl.supplementaryPaymentId;
		const rtiSubmissionReportTypeBitwiseTotal = Object.values(RTI_SUBMISSION_REPORT_TYPE_BITWISE).reduce((a, b) => a + b, 0);
		const rtiSubmissionReportType = $ctrl.submissionLogType === SUBMISSION_LOG_TYPE.cisSuffered ? RTI_SUBMISSION_REPORT_TYPE_BITWISE.eps : rtiSubmissionReportTypeBitwiseTotal;

		const getRTISubmissionReports = reportData.getRTISubmissionReports($ctrl.agencyProfileId, $ctrl.payPeriodId, supplementaryPaymentId, p11dbSubmissionId, rtiSubmissionReportType);
		const isFeatureEnabled = base.isFeatureEnabled($ctrl.agencyProfileId, 'COPILOT_PAYROLL_ERRORS');
		const isUserEvoEnabled = $rootScope.currentUser.IsAccessWorkspaceAccount && $rootScope.currentUser.IsApplicationProvisioned;

		$q.all([getRTISubmissionReports, isFeatureEnabled])
			.then(([submissionFilesArr, isFeatureEnabled]) => {
			angular.extend($ctrl, {
				logIndex: 0,
				resetState: null,
				submissionFiles: submissionFilesArr,
				submissionLogEntries: getSubmissionLogEntriesFromSubmissionLogs(submissionLogsArr),
				isCopilotTranslationEnabled: isFeatureEnabled && isUserEvoEnabled
			});

			setComponentState(COMPONENT_STATES.ready);
		}).catch(onError);
	}

	function decorateSubmissionLogEntry (submissionLogEntryObj, submissionLogObj) {

		// Attach SubmissionLog to SubmissionLogEntry to use in the header
		angular.extend(submissionLogEntryObj, {
			dismissState: null,
			SubmissionLog: submissionLogObj,
			copilotState: COPILOT_REQUEST_STATES.notRequested
		});
	}

	function getSubmissionLogEntriesFromSubmissionLogs (submissionLogsArr) {

		const submissionLogEntriesArr = [];

		// Merge all SubmissionLogEntries into one array
		for (let submissionLogObj of submissionLogsArr) {

			for (let submissionLogEntryObj of submissionLogObj.SubmissionLogEntries) {

				decorateSubmissionLogEntry(submissionLogEntryObj, submissionLogObj);

				submissionLogEntriesArr.push(submissionLogEntryObj);
			}
		}

		return submissionLogEntriesArr;
	}

	function getCopilotErrorTranslation (submissionEntry) {

		setCopilotState(submissionEntry, COPILOT_REQUEST_STATES.loading);
		const translateHMRCError = aiServices.translateHMRCError($ctrl.payPeriodId, submissionEntry.SubmissionLogEntryID, submissionEntry.SubmissionLogEntryMessageText, submissionEntry.SubmissionLog.SubmissionLogType);
		const checkFeedbackExists = base.checkFeedbackExists($ctrl.agencyProfileId, $ctrl.payPeriodId, submissionEntry.SubmissionLogEntryID, COPILOT_FEATURES.payrollErrorTranslation);

		$q.all([translateHMRCError, checkFeedbackExists]).then(([translatedError, isAlreadyFeedbacked]) => {

			setCopilotState(submissionEntry, COPILOT_REQUEST_STATES.completed);

			if (translatedError && translatedError.IsResponseGenerated === false) {
				console.log('Error getting copilot error:', translatedError.AIResponse);
				submissionEntry.translationResponse = null;
				submissionEntry.isCopilotError = true;
			} else if (translatedError && translatedError.AIResponse) {
				try {
					const jsonString = translatedError.AIResponse.replaceAll(/(^(```json\n))|((\n```)$)/gi, '');
					const parsedResponse = JSON.parse(jsonString);

					submissionEntry.translationResponse = {
						Sections: parsedResponse.sections || []
					};
					submissionEntry.isCopilotError = false;
				} catch (parseError) {
					submissionEntry.isCopilotError = true;
				}
			} else {
				submissionEntry.translationResponse = translatedError;
				submissionEntry.isCopilotError = false;
			}

			submissionEntry.feedbackNotRequired = isAlreadyFeedbacked;
		}).
		catch(() => {
				setCopilotState(submissionEntry, COPILOT_REQUEST_STATES.completed);
				submissionEntry.isCopilotError = true;
		});
	}

	function onError (error) {
		setComponentState(COMPONENT_STATES.error);
		throw new Error(error);
	}

	function onLogIndexChange ($ctrl) {

		for (let submissionLogEntryObj of $ctrl.submissionLogEntries) {
			submissionLogEntryObj.dismissState = null;
		}
	}

	function onResetPeriodSubmit ($ctrl) {

		$ctrl.resetState = 'saving';

		$ctrl.onResetPeriod();
	}

	function setComponentState (newState) {
		$ctrl.componentState = newState;
	}

	function setCopilotState (submissionEntry, newState) {
		submissionEntry.copilotState = newState;
	}

	function handleErrorTranslationFeedback(copilotFeature, feedbackType, onSubmitComplete) {

		const currentEntry = $ctrl.submissionLogEntries[$ctrl.logIndex];

		const aiOutputContext = currentEntry.translationResponse ?
			JSON.stringify(currentEntry.translationResponse) : null;

		base.submitFeedbackForSubmissionLogEntry($ctrl.agencyProfileId, $ctrl.payPeriodId,
			$ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLogEntryID, copilotFeature, feedbackType, null, aiOutputContext)
			.then(function () {
				$ctrl.submissionLogEntries[$ctrl.logIndex].feedbackNotRequired = true;
				onSubmitComplete(true);
			})
			.catch(function (error) {
				console.error('Error submitting feedback:', error);
				onSubmitComplete(false);
			});
	}

	function setCurrentLogEntryDismissState ($ctrl, newState) {
		$ctrl.submissionLogEntries[$ctrl.logIndex].dismissState = newState;
	}

	function updateSubmissionLogEntryDismissed ($ctrl) {

		setCurrentLogEntryDismissState($ctrl, SUBMISSION_DISMISS_STATES.loading);

		base.updateSubmissionLogEntryDismissed($ctrl.agencyProfileId, $ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLogEntryID)
			.then(() => {

				// Remove from array
				$ctrl.submissionLogEntries.splice($ctrl.logIndex, 1);

				// Reset index
				$ctrl.logIndex = 0;
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		onLogIndexChange,
		onResetPeriodSubmit,
		setCurrentLogEntryDismissState,
		updateSubmissionLogEntryDismissed,
		getCopilotErrorTranslation,
		handleErrorTranslationFeedback,

		COMPONENT_STATES,
		COPILOT_FEATURES,
		SUBMISSION_DISMISS_STATES,
		COPILOT_REQUEST_STATES
	});

}])
.filter('submissionLogTypeLabel', [
	'SUBMISSION_LOG_ENTRY_TYPES',
	function (
		SUBMISSION_LOG_ENTRY_TYPES
	) {

	return (submissionLogType) => {

		switch (submissionLogType) {
			case SUBMISSION_LOG_ENTRY_TYPES.fps:
				return 'FPS';
			case SUBMISSION_LOG_ENTRY_TYPES.eps:
				return 'EPS';
			case SUBMISSION_LOG_ENTRY_TYPES.cis300:
				return 'CIS300';
			case SUBMISSION_LOG_ENTRY_TYPES.cisVerify:
				return 'CISVerify';
			case SUBMISSION_LOG_ENTRY_TYPES.eyu:
				return 'EYU';
			case SUBMISSION_LOG_ENTRY_TYPES.p11db:
				return 'P11D(b)';
		}
	};

}]);

'use strict';

/**
 * @ngdoc function
 * @name submitButton
 * @description
 * Directive that handles the submitButton
 */

angular.module('paycircleApp')
.directive('submitButton', [
	'$timeout',
	function (
		$timeout
	) {

	return {
		controller: 'submitButtonCtrl',
		templateUrl: 'components/submit-button/submitButton.html',
		replace: true,
		scope: {
			dataPageState: '<?',
			displayText: '<',
			disableButton: '<',
			state: '<',
			buttonId: '@?',
			buttonTheme: '<',
            buttonDemoId: '@?',
			isPrimaryAction: '<',
			icon: '@?',
			iconPosition: '@?'
		},
		link: function ($scope, $element) {

			$timeout(() => {
				$element.css({ 
					minWidth: $element[0].offsetWidth + 'px'
				});
			});
	    }
	};
}])
.controller('submitButtonCtrl', [
	'$scope',
	function (
		$scope
	) {

	$scope.buttonId = $scope.buttonId !== undefined ? $scope.buttonId : 'button-primary';
	$scope.buttonTheme = $scope.buttonTheme && $scope.buttonTheme !== undefined ? $scope.buttonTheme : 'tertiary';
	$scope.dataPageState = $scope.dataPageState !== undefined ? $scope.dataPageState : 'ready';
	$scope.displayText = $scope.displayText && $scope.displayText !== undefined ? $scope.displayText : 'Save';
	$scope.isPrimaryAction = $scope.isPrimaryAction !== undefined ? $scope.isPrimaryAction : true;

}]);

'use strict';

angular.module('paycircleApp')
.component('supportArticle', {

	controller: 'supportArticleComponentCtrl',
	bindings: {
		article: '=',
		categoryId: '<?',
		isInline: '<?',
		showLinkToFullPage: '<?'
	},
	templateUrl: 'components/support-article/support-article.component.html',

})
.controller('supportArticleComponentCtrl', [
	'$rootScope',
	'$sce',
	'$state',
	'$window',
	'supportService',
	function (
		$rootScope,
		$sce,
		$state,
		$window,
		supportService
	) {

	const $ctrl = this;

	const IS_DATE_INCLUDED = true;

	$ctrl.$onInit = function () {
		angular.extend($ctrl, {
			articleKey: $ctrl.article.slug,
			articleTitle: $ctrl.article.title,
			articleContent: $ctrl.article.content,
			isInline: angular.isDefined($ctrl.isInline) ? $ctrl.isInline : true,
			metaTags: supportService.getMetaTagsForSupportArticle($ctrl.article, IS_DATE_INCLUDED),
			showLinkToFullPage: angular.isDefined($ctrl.showLinkToFullPage) ? $ctrl.showLinkToFullPage : false
		});

		// Add video src if available (this could be undefined or null ot '' ... ?)
		if ($ctrl.article.supportVideoId) {
			$ctrl.articleVideoSrc = $sce.trustAsResourceUrl(`https://www.youtube.com/embed/${$ctrl.article.supportVideoId}?autoplay=1&rel=0`);
			$ctrl.articleHasVideo = true;
		}
		else {
			$ctrl.articleHasVideo = false;
		}
	};

	function openFullPage (ctrlObj) {
		const helpAndSupportFullPageUrl = $state.href('help-and-support-full-page', {
			agencyProfileId: $rootScope.currentCompany.AgencyProfileID,
			articleKey: ctrlObj.articleKey,
			categoryId: ctrlObj.categoryId
		});
		$window.open(helpAndSupportFullPageUrl,'_blank');
	}

	angular.extend($ctrl, {
		$sce,
		openFullPage
	});

}]);

angular.module('paycircleApp')

.component('supportArticleCard', {
	bindings: {
		onClick: '&?',
		supportArticle: '=',
		viewMode: '<?' // SUPPORT_ARTICLE_CARD_VIEW_MODES
	},
	controller: 'supportArticleCardCtrl',
	templateUrl: 'components/support-article-card/support-article-card.component.html'
})

/*
	View modes for support article card. Constant values match CSS classes
	narrow: single column
	wide: single row
	responsive: switched between narrow and wide based on screen width
 */
.constant('SUPPORT_ARTICLE_CARD_VIEW_MODES', {
	horizontal: 'is-horizontal',
	responsive: 'is-responsive',
	vertical: 'is-vertical'
})

.controller('supportArticleCardCtrl', [
	'supportService',
	'SUPPORT_ARTICLE_CARD_VIEW_MODES',
	function (
		supportService,
		SUPPORT_ARTICLE_CARD_VIEW_MODES
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Default to responsive view mode
		$ctrl.viewMode = angular.isDefined($ctrl.viewMode) ? $ctrl.viewMode : SUPPORT_ARTICLE_CARD_VIEW_MODES.responsive;

		// Get metatags for article
		$ctrl.metaTags = supportService.getMetaTagsForSupportArticle($ctrl.supportArticle);

		// Set controller properties for image display (video thumbnail or 'no video' placeholder)
		if ($ctrl.supportArticle.supportVideoId) { // No 'isUndefined' as WordPress likes to return empty strings
			// If there's a video, always show the thumbnail image
			$ctrl.hasVideo = true;
			// Video thumbnail image courtesy of YouTube™
			$ctrl.supportArticle.supportArticleThumbnailUrl = `https://img.youtube.com/vi/${$ctrl.supportArticle.supportVideoId}/0.jpg`;
		}
		else {
			// Show placeholder image if article image not specified
			$ctrl.hasVideo = false;
			// Generic placeholder image if none specified
			if (!$ctrl.supportArticle.supportArticleThumbnailUrl) {
				$ctrl.supportArticle.supportArticleThumbnailUrl = 'images/help/article.jpg';
			}
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
// This is a directive since support from the link function is required.
.directive('supportArticleContent', [
	'$compile',
	function (
		$compile
	) {

	return {
		link: ($scope, element, _attrs, _controller, transclude) => {

			/*
				Step 1. Replace support article references in content with support article link components.
				-------------------------------------------------------------------------------------------
			 */

			// Group 1 = article slug, Group 2 = link text for display
			const supportArticleLinkRegExp = /<a[\s]+href="[\S]+support-article\/([\w | -]+)[\/ | "][^>]+>(.*)<\/a>/gim;

			// Get the article HTML and replace any article links with support-article-link components, for inline viewing.
			const supportLinkHtmlRegExpReplace = '<support-article-link article-key="\'$1\'" theme="primary">$2</support-article-link>';
			let articleContentHtml = $scope.articleContent.replace(supportArticleLinkRegExp, supportLinkHtmlRegExpReplace);

			/*
				Step 2. Enclose support article images with support article image components.
				-----------------------------------------------------------------------------
			 */

			/* Group 1 = image src, Group 2 = image alt text @pbtodo - srcset and sizes attributes exist for some images,
			   and the order of these; e.g. what happens if alt comes before src with the regexp below */
			const supportArticleImageRegExp = /<img.+ src="([^"]+)".+alt="([^"]*)".+\/>/gim;

			// Get the article HTML and replace any image with support-article-image components, which support image focus
			const supportImageRegExpReplace = '<support-article-image article-image-src="$1" article-image-alt="$2"></support-article-image>';
			articleContentHtml = $scope.articleContent.replace(supportArticleImageRegExp, supportImageRegExpReplace);

			// Set the content html of the component element and compile it, so support article link components are properly created and active
			element.html(articleContentHtml);
			$compile(element.contents())($scope);
			transclude($scope.$parent, function (compiled) {
				element.children().append(compiled);
			});
		},
		scope: {
			articleContent: '<',
			articleKey: '=?'
		},
		templateUrl: 'components/support-article-content/support-article-content.component.html',
		transclude: true
	};
}]);
'use strict';

angular.module('paycircleApp')

.component('supportCategories', {

	bindings: {
		categories: '=',
		onCategoryChange: '&?',
		onArticleSelect:  '&?',
		categoryId: '=?'
	},
	controller: 'supportCategoriesCtrl',
	templateUrl: 'components/support-categories/support-categories.component.html'
})

.controller('supportCategoriesCtrl', [
	'$filter',
	'supportData',
	function (
		$filter,
		supportData
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		articlesLoading: 'articles-loading',
		error: 'error',
		ready: 'ready'
	};

	$ctrl.$onInit = () => {

		setComponentState(COMPONENT_STATES.articlesLoading);

		// Default to top level Help & Support
		$ctrl.categoryId = angular.isDefined($ctrl.categoryId) ? $ctrl.categoryId : 0;

		changeCategory($ctrl.categoryId, $ctrl);
	};

	function changeCategory (categoryId, ctrlObj) {

		const category = getCategory(ctrlObj, categoryId);
		ctrlObj.categoryId = categoryId;
		ctrlObj.currentCategoryName = category.name;

		// Update filtered categories and breadcrumb
		ctrlObj.filteredCategories = $filter('filter')(ctrlObj.categories, { parentId: categoryId });
		setBreadcrumb(categoryId, ctrlObj);

		// Get articles for this category
		setComponentState(COMPONENT_STATES.articlesLoading);

		// If we're at the top, uber level, get a list of the latest articles. Otherwise get the articles for the current category
		let getArticles;
		if (categoryId === 0) {
			getArticles = supportData.getLatestPosts('support');
		}
		else {
			getArticles = supportData.getSupportArticlesForCategory(category.slug);
		}
		getArticles.then(supportArticlesArr => {
			ctrlObj.supportArticles = supportArticlesArr;
			// If we're at the top, uber level, get the latest articles for display
			setComponentState(COMPONENT_STATES.ready);
		})
		.catch(onError);
	}

	function getCategory (ctrlObj, categoryId) {
		return ctrlObj.categories.find(category => category.id === categoryId);
	}

	function onArticleClick (ctrlObj, articleObj) {
		if (angular.isFunction(ctrlObj.onArticleSelect)) {
			$ctrl.onArticleSelect()(articleObj);
		}
	}

	function onCategoryClick (ctrlObj, categoryObj) {
		changeCategory(categoryObj.id, ctrlObj);
		if (angular.isFunction(ctrlObj.onCategoryChange)) {
			ctrlObj.onCategoryChange()(categoryObj);
		}
	}

	function onError (error) {
		console.error(error);
		setComponentState(COMPONENT_STATES.error);
	}

	function setBreadcrumb (categoryId, ctrlObj, breadcrumb) {
		if (!angular.isDefined(breadcrumb)) {
			breadcrumb = [];
		}
		let category = ctrlObj.categories.find(category => category.id === categoryId);

		// Add to breadcrumb to start of array and move up the 'tree'
		breadcrumb.unshift(category);
		if (category.id !== 0) {
			setBreadcrumb(category.parentId, ctrlObj, breadcrumb);
		}
		else {
			ctrlObj.breadcrumb = breadcrumb;
		}
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {

		// Constants
		COMPONENT_STATES,

		// Functions
		changeCategory,
		onArticleClick,
		onCategoryClick
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('supportCategoryCard', {

	bindings: {
		category: '=',
		onCategoryClick: '&?'
	},
	controller: 'supportCategoryCardCtrl',
	templateUrl: 'components/support-category-card/support-category-card.component.html'
})

.controller('supportCategoryCardCtrl', [
	function (
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Do some special stuff for headline categories
		if ($ctrl.category.isHeadline) {
			$ctrl.isHeadline = true;
			$ctrl.headlineImageSrc = `images/help/${$ctrl.category.headlineImageName}.png`;
			$ctrl.itemDescription = $ctrl.category.articleCount === 1 ? $ctrl.category.headlineItemSingular : $ctrl.category.headlineItemPlural;
		}
		else {
			$ctrl.isHeadline = false;
			/* Why not 'ng-pluralize' in the template? Because these descriptions could come (above) from WordPress, and in that case
			   we don't know what the pluralised form is. To keep a tidy template, we're doing the same for the default description */
			$ctrl.itemDescription = $ctrl.category.articleCount === 1 ? 'article' : 'articles';
		}
	};

	function onClick (ctrlObj) {

		if (angular.isFunction(ctrlObj.onCategoryClick)) {
			ctrlObj.onCategoryClick();
		}
	}

	angular.extend($ctrl, {
		onClick
	});
}]);
angular.module('paycircleApp')

.component('supportGuideCard', {
	bindings: {
		onClick: '&?',
		supportGuide: '='
	},
	controller: 'supportGuideCardCtrl',
	templateUrl: 'components/support-guide-card/support-guide-card.component.html'
})

.controller('supportGuideCardCtrl', [
	'supportService',
	function (
		supportService
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Get metatags for article
		$ctrl.metaTags = supportService.getMetaTagsForPost($ctrl.supportGuide);
	};
}]);
'use strict';

angular.module('paycircleApp')

.component('switchAccountCard', {
	bindings: {
		account: '<',
		onClick: '&?'
	},
	controller: 'switchAccountCardCtrl',
	templateUrl: 'components/switch-account-card/switch-account-card.component.html',
})

.controller('switchAccountCardCtrl', [
	function (
	) {
		const $ctrl = this;

		function $onInit () {
			$ctrl.isClickable = angular.isFunction($ctrl.onClick);
		}

		function onClickInternal () {
			$ctrl.onClick();
		}

		angular.extend($ctrl, {
			$onInit,
			onClickInternal
		});
	}
]);
'use strict';

angular.module('paycircleApp')
.component('switchAccountItem', {
	bindings: {
		account: '<',
	},
	controller: 'switchAccountItemCtrl',
	templateUrl: 'components/switch-account-item/switch-account-item.component.html',
})
.controller('switchAccountItemCtrl', [
	function () 
	{ 
		const $ctrl = this;

		function $onInit () {
		}

		angular.extend($ctrl, {
			$onInit
		});

	}]);
'use strict';

angular.module('paycircleApp')
.directive('paymentCard', function () {

	return {
		controller: 'paymentCardCtrl',
		templateUrl: 'components/payment-card/paymentCardComponent.html',
		replace: true,
		scope: {
			agencyProfileId: '@',
			isCisPayment: '<?',
			payment: '<',
			userId: '@'
		}
	};
})

.controller('paymentCardCtrl', [
	'USER_DOCUMENT_IDS',
	'$scope',
function (
	USER_DOCUMENT_IDS,
	$scope
) {

	function init () {
		let payslipSuffix = '';
		switch ($scope.payment.UserDocumentTypeID) {
			case USER_DOCUMENT_IDS.supplementaryPayStatement: {
				payslipSuffix = ' - Supplementary';
				break;
			}
			case USER_DOCUMENT_IDS.combinedSupplementaryRunPayStatement: {
				payslipSuffix = ' - Combined';
				break;
			}
			default:
		}
		$scope.payslipSuffix = payslipSuffix;
	}

	init();

}]);
'use strict';

angular.module('paycircleApp')
.component('paymentInfoCard', {
	bindings: {
		cardIcon: '@',
		cardId: '@',
		cardLayout: '@', // 'card' || 'row'
		cardTheme: '@',
		cardTitle: '@',
		cardValue: '='
	},
	templateUrl: 'components/payment-info-card/payment-info-card.component.html',
	transclude: true
});

'use strict';

angular.module('paycircleApp')
.component('paymentSchedule', {
    bindings: {
		canEditOccupationalPaymentValues: '<?',
		occupationalPaymentLabel: '@?',
		schedulePaymentLabel: '@?',
        schedulePayments: '<',
		showOccupationalPolicyPaymentValues: '<?',
        statutoryPayCalculationMethod: '='
    },
    controller: 'paymentScheduleCtrl',
    templateUrl: 'components/payment-schedule/payment-schedule.component.html'
})
.controller('paymentScheduleCtrl',
[
	'statutoryPaymentService',
	'STATUTORY_PAY_CALCULATION_METHODS',
function PaymentScheduleCtrl (
	statutoryPaymentService,
	STATUTORY_PAY_CALCULATION_METHODS
) {

    const $ctrl = this;

    $ctrl.$onInit = () => {

		// Defaults
		$ctrl.canEditOccupationalPaymentValues = angular.isDefined($ctrl.canEditOccupationalPaymentValues) ? $ctrl.canEditOccupationalPaymentValues : false,
		$ctrl.occupationalPaymentLabel = angular.isDefined($ctrl.occupationalPaymentLabel) ? $ctrl.occupationPaymentLabel : 'OCC';
		$ctrl.schedulePaymentLabel = angular.isDefined($ctrl.schedulePaymentLabel) ? $ctrl.schedulePaymentLabel : 'AMOUNT';
		$ctrl.showOccupationalPolicyPaymentValues = angular.isDefined($ctrl.showOccupationalPolicyPaymentValues) ? $ctrl.showOccupationalPolicyPaymentValues : false;

        if ($ctrl.schedulePayments) {
            $ctrl.schedulePayments = $ctrl.schedulePayments.filter(statutoryPaymentService.filterCancelledPayments);
            $ctrl.schedulePayments = statutoryPaymentService.transformStatutoryPaymentsForCalculationMethod($ctrl.schedulePayments, $ctrl.statutoryPayCalculationMethod);
        }
    };

    function recalculatePaymentGroup (paymentGroup) {

    	let newTotalOccupationalPaymentAmount = 0;

		paymentGroup.payments.forEach(paymentObj => {
			newTotalOccupationalPaymentAmount += paymentObj.OccupationalPaymentAmount;
		});

		paymentGroup.totalOccupationalPaymentAmount = newTotalOccupationalPaymentAmount;
    }

    angular.extend($ctrl, {
        STATUTORY_PAY_CALCULATION_METHODS: STATUTORY_PAY_CALCULATION_METHODS,
        recalculatePaymentGroup
    });
}]);
'use strict';

angular.module('paycircleApp')
.component('peopleHrUpdatesCard', {
	bindings: {
		agencyProfileId: '<',
		bulkItems: '=',
		// Set to true to hide the action dropdown
		hideAction: '<?',
		// Set to true to hide the footer (e.g. when the message is already shown in an "Update warnings" note)
		hideFooter: '<?',
		// Set to true to hide the warning icon
		hideWarningIcon: '<?',
		// Set to true to show the employee id (only shown in the review data slide-in, not the main updates list)
		showEmployeeId: '<?',
		// The data as an object
		eventData: '<',
		// The index of the card in the list
		index: '<',
		// Set to true to hide the effect when the user hovers over the card
		removeHoverEffect: '<?',
		// This function will reload the peopleHR updates page
		reloadPeopleHrUpdatesPage: '&',
		// The source of the event ('edp' | 'peoplehr'). Optional - falls back to EdpEventID detection
		source: '<?'
	},
	controller: 'peopleHrUpdatesCardCtrl',
	templateUrl: 'components/people-hr-updates-card/people-hr-updates-card.component.html'
})
.controller('peopleHrUpdatesCardCtrl', [
	'$filter',
	'$rootScope',
	'bulkService',
	'EDP_UPDATES_EVENT_TEXT_MAP',
	'EDP_UPDATES_EVENT_TITLE_MAP',
	'EDP_UPDATES_FRIENDLY_ERROR_MAP',
	'PEOPLE_HR_UPDATES_EVENT_STATUS',
	'PEOPLE_HR_UPDATES',
	function(
		$filter,
		$rootScope,
		bulkService,
		EDP_UPDATES_EVENT_TEXT_MAP,
		EDP_UPDATES_EVENT_TITLE_MAP,
		EDP_UPDATES_FRIENDLY_ERROR_MAP,
		PEOPLE_HR_UPDATES_EVENT_STATUS,
		PEOPLE_HR_UPDATES
	) {

	const $ctrl = this;

	const STATUS_FALLBACK_MAP = {
		[PEOPLE_HR_UPDATES_EVENT_STATUS.new]: 'received',
		[PEOPLE_HR_UPDATES_EVENT_STATUS.processing]: 'processing',
		[PEOPLE_HR_UPDATES_EVENT_STATUS.complete]: 'completed',
		[PEOPLE_HR_UPDATES_EVENT_STATUS.failed]: 'failed',
		[PEOPLE_HR_UPDATES_EVENT_STATUS.skipped]: 'skipped'
	};

	function $onInit () {

		const isEdp = !!($ctrl.eventData && $ctrl.eventData.EdpEventID) || $ctrl.source === 'edp';
		const status = isEdp ? $ctrl.eventData.EdpEventStatus : $ctrl.eventData.Status;
		const errorMessage = getErrorMessage(isEdp);

		angular.extend($ctrl, {
			cardTheme: getCardClass(status),
			cardTitle: getCardTitle(isEdp),
			// Both sources expose the employee number as EmployeeID: PeopleHR from the event itself,
			// EDP from the team member resolved server-side.
			employeeId: $ctrl.eventData.EmployeeID || '',
			employeeIdTooltip: getEmployeeIdTooltip(isEdp),
			errorMessage,
			eventId: isEdp ? $ctrl.eventData.EdpEventID : $ctrl.eventData.MessageID,
			eventText: getEventText(isEdp, status),
			footerText: status === PEOPLE_HR_UPDATES_EVENT_STATUS.new ? 'Update pending' : errorMessage,
			icon: getIconClass(status),
			isEdp,
			isStatusNew: status === PEOPLE_HR_UPDATES_EVENT_STATUS.new,
			showFooter: status === PEOPLE_HR_UPDATES_EVENT_STATUS.new || !!errorMessage,
			showWarningIcon: !$ctrl.hideWarningIcon && status === PEOPLE_HR_UPDATES_EVENT_STATUS.complete && !!errorMessage,
			status
		});
	}

	function getCardClass (status) {

		switch (status) {
			case PEOPLE_HR_UPDATES_EVENT_STATUS.complete:
				return 'is-secondary';

			case PEOPLE_HR_UPDATES_EVENT_STATUS.new:
			case PEOPLE_HR_UPDATES_EVENT_STATUS.processing:
				return 'is-primary';

			case PEOPLE_HR_UPDATES_EVENT_STATUS.skipped:
				return 'is-quaternary';

			default:
				return 'is-quinary';
		}
	}

	function getCardTitle (isEdp) {

		// Both sources show the team member the update is for. For EDP the name is resolved
		// server-side; when no matching team member is found we fall back to the absence type.
		const teamMemberName = `${$ctrl.eventData.Forename || ''} ${$ctrl.eventData.Surname || ''}`.trim();

		if (isEdp) {
			return teamMemberName ||
				EDP_UPDATES_EVENT_TITLE_MAP[$ctrl.eventData.EdpEventType] ||
				$ctrl.eventData.EdpEventType;
		}

		return teamMemberName;
	}

	function getEmployeeIdTooltip (isEdp) {

		// The two sources hold different identifiers, which often do not match for the same
		// team member, so the tooltip spells out which one is on show.
		return isEdp ?
			'Paycircle staff number. This can differ from the PeopleHR employee ID for the same team member.' :
			'PeopleHR employee ID.';
	}

	function getErrorMessage (isEdp) {

		if (isEdp) {
			const edpError = $ctrl.eventData.EdpEventErrorMessage;
			return edpError ? EDP_UPDATES_FRIENDLY_ERROR_MAP[edpError] || edpError : '';
		}

		return $ctrl.eventData.ErrorMessage || '';
	}

	function getEventText (isEdp, status) {

		if (!isEdp) {
			const timeISO = status === PEOPLE_HR_UPDATES_EVENT_STATUS.new ?
				$ctrl.eventData.ReceivedTimeISO : $ctrl.eventData.HandledTimeISO;

			return PEOPLE_HR_UPDATES.buildEventText($ctrl.eventData.Name, status, timeISO);
		}

		const typeEntry = EDP_UPDATES_EVENT_TEXT_MAP[$ctrl.eventData.EdpEventType];
		let eventText = typeEntry ? typeEntry[status] : null;

		if (!eventText) {
			const statusText = STATUS_FALLBACK_MAP[status] || '';
			eventText = $ctrl.eventData.EdpEventType + ' ' + statusText;
		}

		const dateText = $filter('dateformat')($ctrl.eventData.EdpEventReceivedTime, 'timeDayDate');

		return eventText + ' at ' + dateText;
	}

	function getIconClass (status) {

		switch (status) {
			case PEOPLE_HR_UPDATES_EVENT_STATUS.complete:
				return 'icon-tick';

			case PEOPLE_HR_UPDATES_EVENT_STATUS.new:
			case PEOPLE_HR_UPDATES_EVENT_STATUS.processing:
				return 'icon-loading';

			case PEOPLE_HR_UPDATES_EVENT_STATUS.skipped:
				return 'icon-warning';

			default:
				return 'icon-cross';
		}
	}

	function onCheckboxToggle () {

		$ctrl.bulkItems = bulkService.updateBulkItemTotals($ctrl.bulkItems);
	}

	function openEventDataForm () {

		const formOptions = {
			agencyProfileId: $ctrl.agencyProfileId,
			formKey: 'people-hr-updates-data',
			callback: $ctrl.reloadPeopleHrUpdatesPage
		};

		if ($ctrl.isEdp) {
			formOptions.eventId = $ctrl.eventId;
		}
		else {
			formOptions.messageId = $ctrl.eventId;
		}

		$rootScope.openSlideInForm(formOptions);
	}

	angular.extend($ctrl, {
		$onInit,

		onCheckboxToggle,
		openEventDataForm,

		PEOPLE_HR_UPDATES_EVENT_STATUS
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyUpdatesCard', {
	bindings: {
		agencyProfileId: '<',
		eventData: '<',
		hideAction: '<?',
		hideWarningIcon: '<?',
		index: '<',
		onCheckboxToggle: '&?',
		reloadRotareadyUpdatesPage: '&',
		removeHoverEffect: '<?'
	},
	controller: 'rotareadyUpdatesCardCtrl',
	templateUrl: 'components/rotaready-updates-card/rotaready-updates-card.component.html'
})
.controller('rotareadyUpdatesCardCtrl', [
	'$rootScope',
	'ROTAREADY_UPDATES',
	'ROTAREADY_UPDATES_EVENT_STATUS',
	function(
		$rootScope,
		ROTAREADY_UPDATES,
		ROTAREADY_UPDATES_EVENT_STATUS
	) {

	const $ctrl = this;

	const MESSAGE_LEVEL = {
		info: 0,
		warning: 1,
		error: 2,
		critical: 3
	};

	function $onInit () {

		const criticalMessagesCount = $ctrl.eventData.CriticalMessagesCount;
		const dismissedCriticalMessagesCount = $ctrl.eventData.DismissedCriticalMessagesCount;
		const totalCriticalMessagesCount = criticalMessagesCount + dismissedCriticalMessagesCount;

		const displayFooter = (
			// If failed and has errors or criticals
			($ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.failed && ($ctrl.eventData.ErrorMessagesCount > 0 || criticalMessagesCount > 0 || dismissedCriticalMessagesCount > 0)) ||
			// Or if new/held and has infos
			(($ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.held) && $ctrl.eventData.InfoMessagesCount > 0)
		);

		const messages = {
			criticals: getMessagesForLevel(MESSAGE_LEVEL.critical),
			errors: getMessagesForLevel(MESSAGE_LEVEL.error),
			warnings: getMessagesForLevel(MESSAGE_LEVEL.warning),
			infos: getMessagesForLevel(MESSAGE_LEVEL.info)
		};

		const criticalMessages = getCriticalMessages();
		const dismissedCriticalMessages = getDismissedCriticalMessages();

		angular.extend($ctrl, {
			cardTheme: getCardClass(),
			criticalMessages,
			criticalMessagesCount,
			dismissedCriticalMessages,
			dismissedCriticalMessagesCount,
			totalCriticalMessagesCount,
			displayBulkActions: angular.isDefined($ctrl.onCheckboxToggle),
			displayFooter,
			eventText: getEventText(),
			footerCriticalMessage: getCriticalMessageText(criticalMessagesCount, dismissedCriticalMessagesCount, messages),
			footerInfoMessage: getInfoMessageText($ctrl.eventData, messages),
			footerErrorMessage: getErrorMessageText($ctrl.eventData, messages),
			hasAllCriticalsDismissed: criticalMessages.length > 0 && criticalMessages.every(getIsDismissed),
			icon: getIconClass(),
			messages
		});
	}

	function getCardClass () {
		var baseClass;

		switch($ctrl.eventData.Status) {
			case ROTAREADY_UPDATES_EVENT_STATUS.complete:
			case ROTAREADY_UPDATES_EVENT_STATUS.skipped:
				baseClass = 'is-secondary';
				break;

			case ROTAREADY_UPDATES_EVENT_STATUS.new:
			case ROTAREADY_UPDATES_EVENT_STATUS.processing:
			case ROTAREADY_UPDATES_EVENT_STATUS.held:
				baseClass = 'is-primary';
				break;

			default:
				baseClass = 'is-quinary';
				break;
		}

		return baseClass;
	}

	function getEventText () {
		const timeISO = $ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.processing || $ctrl.eventData.Status === ROTAREADY_UPDATES_EVENT_STATUS.held ?
			$ctrl.eventData.ReceivedTimeISO : $ctrl.eventData.HandledTimeISO;

		return ROTAREADY_UPDATES.buildEventText(
			$ctrl.eventData.EventType, $ctrl.eventData.Status, timeISO);
	}

	function getIconClass () {
		switch($ctrl.eventData.Status) {
			case ROTAREADY_UPDATES_EVENT_STATUS.complete:
			case ROTAREADY_UPDATES_EVENT_STATUS.skipped:
				return 'icon-tick';

			case ROTAREADY_UPDATES_EVENT_STATUS.new:
			case ROTAREADY_UPDATES_EVENT_STATUS.held:
				return 'icon-add';

			case ROTAREADY_UPDATES_EVENT_STATUS.processing:
				return 'icon-loading spin';

			default:
				return getCriticalMessagesCount($ctrl.eventData) >= 1 ? 'icon-warning' : 'icon-cross';
		}
	}

	function openEventDataForm (agencyProfileId, eventId) {
		$rootScope.openSlideInForm({
			agencyProfileId,
			callback: $ctrl.reloadRotareadyUpdatesPage,
			eventId,
			formKey: 'rotaready-updates-data',
			title: 'Review data'
		});
	}

	function getCriticalMessagesCount (eventData) {
		return eventData.CriticalMessagesCount + (eventData.DismissedCriticalMessagesCount || 0);
	}

	function getCriticalMessages () {
		if (!$ctrl.eventData.Messages) {
			return [];
		}
		return $ctrl.eventData.Messages.filter(message => message.MessageLevel === MESSAGE_LEVEL.critical && !getIsDismissed(message));
	}

	function getDismissedCriticalMessages () {
		if (!$ctrl.eventData.Messages) {
			return [];
		}
		return $ctrl.eventData.Messages.filter(message => message.MessageLevel === MESSAGE_LEVEL.critical && getIsDismissed(message));
	}

	function getIsDismissed (message) {
		return message.DismissedAtISO && message.DismissedAtISO !== '';
	}

	function getMessagesForLevel (messageLevel) {
		return $ctrl
			.eventData
			.Messages
			.filter(message => message.MessageLevel === messageLevel)
			.map(message => message.MessageText);
	}

	function getCriticalMessageText (criticalMessagesCount, dismissedCriticalMessagesCount, messages) {

		const totalMessagesCount = criticalMessagesCount + dismissedCriticalMessagesCount;

		if (totalMessagesCount === 1 && messages.criticals.length === 1) {
			if (dismissedCriticalMessagesCount === 1) {
				return `${messages.criticals[0]} (dismissed)`;
			}
			return messages.criticals[0];
		}

		if (totalMessagesCount >= 1) {
			let dismissedMessage = '';
			if (dismissedCriticalMessagesCount === totalMessagesCount) {
				dismissedMessage = ' and have been dismissed';
			} else if (dismissedCriticalMessagesCount === 1) {
				dismissedMessage = ', 1 has been dismissed';
			} else if (dismissedCriticalMessagesCount > 1) {
				dismissedMessage = `, ${dismissedCriticalMessagesCount} have been dismissed`;
			}
			return `${totalMessagesCount} critical issues occurred${dismissedMessage}`;
		}

		return '';
	}

	function getErrorMessageText (eventData, messages) {

		if (eventData.ErrorMessagesCount === 1 && messages.errors.length === 1) {
			return messages.errors[0];
		}

		if (eventData.ErrorMessagesCount > 1) {
			return `${eventData.ErrorMessagesCount} errors occurred`;
		}

		return '';
	}

	function getInfoMessageText (eventData, messages) {

		if (eventData.InfoMessagesCount === 1 && messages.infos.length === 1) {
			return messages.infos[0];
		}

		if (eventData.InfoMessagesCount > 1) {
			return `${eventData.InfoMessagesCount} informational messages`;
		}

		return '';
	}

	angular.extend($ctrl, {
		$onInit,
		getIsDismissed,
		openEventDataForm,
		ROTAREADY_UPDATES_EVENT_STATUS
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('rotareadyUpdatesGroupedCard', {
	bindings: {
		agencyProfileId: '<',
		eventData: '<',
		index: '<'
	},
	controller: 'rotareadyUpdatesGroupedCardCtrl',
	templateUrl: 'components/rotaready-updates-grouped-card/rotaready-updates-grouped-card.component.html'
})
.controller('rotareadyUpdatesGroupedCardCtrl', [
	'ROTAREADY_UPDATES',
	'ROTAREADY_UPDATES_EVENT_STATUS',
	function (
		ROTAREADY_UPDATES,
		ROTAREADY_UPDATES_EVENT_STATUS
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			cardTheme: getCardClass(),
			icon: getIconClass(),
			severityText: getSeverityText(),
			isExpanded: false,
			occurrences: $ctrl.eventData.occurrences,
			toggleIsExpanded
		});
	}

	function getCardClass () {

		switch ($ctrl.eventData.Status) {
			case ROTAREADY_UPDATES_EVENT_STATUS.complete:
			case ROTAREADY_UPDATES_EVENT_STATUS.skipped:
				return 'is-secondary';

			case ROTAREADY_UPDATES_EVENT_STATUS.new:
			case ROTAREADY_UPDATES_EVENT_STATUS.processing:
			case ROTAREADY_UPDATES_EVENT_STATUS.held:
				return 'is-primary';

			default:
				return 'is-quinary';
		}
	}

	function getIconClass () {

		switch ($ctrl.eventData.Status) {
			case ROTAREADY_UPDATES_EVENT_STATUS.complete:
			case ROTAREADY_UPDATES_EVENT_STATUS.skipped:
				return 'icon-tick';

			case ROTAREADY_UPDATES_EVENT_STATUS.new:
			case ROTAREADY_UPDATES_EVENT_STATUS.held:
				return 'icon-add';

			case ROTAREADY_UPDATES_EVENT_STATUS.processing:
				return 'icon-loading spin';

			default:
				return $ctrl.eventData.MessageLevel === 3 ? 'icon-warning' : 'icon-cross';
		}
	}

	function getOccurrenceText (occurrence) {

		const timeISO = occurrence.Status === ROTAREADY_UPDATES_EVENT_STATUS.new || occurrence.Status === ROTAREADY_UPDATES_EVENT_STATUS.processing || occurrence.Status === ROTAREADY_UPDATES_EVENT_STATUS.held ?
			occurrence.ReceivedTimeISO : occurrence.HandledTimeISO;

		return ROTAREADY_UPDATES.buildEventText(occurrence.EventType, occurrence.Status, timeISO);
	}

	function getOccurrenceMessage (occurrence) {

		return occurrence.Messages && occurrence.Messages.length ? occurrence.Messages[0].MessageText : '';
	}

	function getSeverityText () {

		switch ($ctrl.eventData.MessageLevel) {
			case 0:
				return 'Info';
			case 1:
				return 'Warning';
			case 2:
				return 'Error';
			case 3:
				return 'Critical';
			default:
				return 'Message';
		}
	}

	function toggleIsExpanded () {

		$ctrl.isExpanded = !$ctrl.isExpanded;
	}

	angular.extend($ctrl, {
		$onInit,
		getOccurrenceMessage,
		getOccurrenceText,
		ROTAREADY_UPDATES_EVENT_STATUS
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('settingsOverviewCard', {
	bindings: {
		settingsOverviewGroup: '<'
	},
	templateUrl: 'components/settings-overview-card/settings-overview-card.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('settingsRow', {
	bindings: {
		ngModel: '=',
		onUpdate: '&?',
		srDisabled: '<?',
		srFieldName: '@',
		srIcon: '@',
		srLabel: '@',
		srTheme: '@',
		srContentCollapsed: '<?'
	},
	controller: 'settingsRowCtrl',
	require: 'ngModel',
	templateUrl: 'components/settings-row/settings-row.component.html',
	transclude: {
		'label' : '?srLabel',
		'description': '?srDescription',
		'content': '?srContent'
	}
})
.controller('settingsRowCtrl', ['$timeout', '$transclude', function ($timeout, $transclude) {

	const $ctrl = this;

	function $onInit () {

		if (angular.isUndefined($ctrl.srFieldName)) {
			throw('settings-row.component.js: No field name defined (sr-field-name)');
		}

		angular.extend($ctrl, {
			hasContent: $transclude.isSlotFilled('content'),
			hasIcon: !angular.isUndefined($ctrl.srIcon),
			srDisabled: angular.isUndefined($ctrl.srDisabled) ? false : $ctrl.srDisabled,
			srTheme: angular.isUndefined($ctrl.srTheme) ? 'primary' : $ctrl.srTheme
		});
	}

	function toggleSetting ($ctrl) {

		if ($ctrl.srDisabled) {
			return;
		}

		// Optional callback
		if (angular.isFunction($ctrl.onUpdate)) {
			$timeout(() => {
				$ctrl.onUpdate();
			});
		}
	}

	angular.extend($ctrl, {
		$onInit,
		toggleSetting
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('shadePicker', {
	bindings: {
		spModel: '=',
		spOnChange: '&?'
	},
	controller: 'shadePickerCtrl',
	templateUrl: 'components/shade-picker/shade-picker.component.html',
})
.controller('shadePickerCtrl', ['$timeout', 'CUSTOMISATION_SHADES',
	function ($timeout, CUSTOMISATION_SHADES) {

	const $ctrl = this;

	function onChange () {

		$timeout(() => {
			if (angular.isFunction($ctrl.spOnChange)) {
				$ctrl.spOnChange();
			}
		});
	}

	angular.extend($ctrl, {
		CUSTOMISATION_SHADES,

		onChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('sideBarItem', {
	bindings: {
		heading: '<',
		icon: '@?',
		id: '@?',
		isActive: '<?',
		isDisabled: '<?',
		onClick: '&',
		theme: '@?',
		variant: '@?'
	},
	controller: 'sideBarItemCtrl',
	templateUrl: 'components/side-bar-item/side-bar-item.component.html',
	transclude: {
		'description': '?sideBarItemDescription'
	}
})
.controller('sideBarItemCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	function $onInit () {
		$ctrl.hasDescription = $transclude.isSlotFilled('description');
	}

	angular.extend($ctrl, {
		$onInit
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('signedAmountTag', function () {

	return {
		templateUrl: 'components/signed-amount-tag/signedAmountTagComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			amount: '='
		}
	};
});

'use strict';

angular.module('paycircleApp')
.component('sortCode', {
	bindings: {
		sortCode: '=',
		sortCodeDisabled: '<?',
		sortCodeName: '@',
		sortCodeRequired: '<?'
	},
	controller: 'sortCodeCtrl',
	templateUrl: 'components/sort-code/sort-code.component.html',
})
.controller('sortCodeCtrl', function () {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			sortCodeDisabled: angular.isDefined($ctrl.sortCodeDisabled) ? $ctrl.sortCodeDisabled : false,
			sortCodeRequired: angular.isDefined($ctrl.sortCodeRequired) ? $ctrl.sortCodeRequired : true
		});
	}

	angular.extend($ctrl, {
		$onInit
	});
});

'use strict';

angular.module('paycircleApp')
.component('splitPane', {
	templateUrl: 'components/split-pane/split-pane.component.html',
	controller: 'splitPaneController',
	bindings: {
		spLeftTheme: '@?',
		spTemplate: '@?'
	},
	transclude: {
		'spLeft': 'spLeft'
	},
})
.controller('splitPaneController', [function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			spTemplate: $ctrl.spTemplate ? $ctrl.spTemplate : 'customisation'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('statCardActions', {
	bindings: {
		cardTitle: '<?',
		cardDescription: '<?',
		actions: '<?',
		isPositive: '<',
		isInline: '<?',
		cytext: '<?'
	},
	controller: 'statCardActionsCtrl',
	templateUrl: 'components/stat-card-actions/stat-card-actions.component.html',
})
.controller('statCardActionsCtrl', [function () {

	const $ctrl = this;

	function $onInit(){
	}

	angular.extend($ctrl, {
		$onInit,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('statPaymentSummaryCard', {
	bindings: {
		canEdit: '<',
		onEdit: '&',
		statPayment: '<',
		statPaymentType: '@'
	},
	controller: 'statPaymentSummaryCardCtrl',
	templateUrl: 'components/stat-payment-summary-card/stat-payment-summary-card.component.html'
})
.controller('statPaymentSummaryCardCtrl', [
	'SCHEDULE_UPDATE_REASONS',
	function (
		SCHEDULE_UPDATE_REASONS
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			canEdit: angular.isDefined($ctrl.canEdit) ? $ctrl.canEdit : true,
			icon: getIconForStatPaymentType($ctrl),
			isGrossPaymentsVisible: false
		});
	}

	function getIconForStatPaymentType ($ctrl) {

		switch ($ctrl.statPaymentType) {

			case 'paternity':
			case 'maternity':
				return 'maternity';
			case 'sickness':
				return 'sick';
			default:
				return 'question-mark';
		}
	}

	function toggleShowGrossPayments ($ctrl) {

		$ctrl.isGrossPaymentsVisible = !$ctrl.isGrossPaymentsVisible;
	}

	angular.extend($ctrl, {
		$onInit,
		SCHEDULE_UPDATE_REASONS,
		toggleShowGrossPayments
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('summaryActionCard', {
	bindings: {
		canEdit: '<?',
		onEdit: '&?',
		summaryCardDescription: '<',
		summaryCardTitle: '<'
	},
	controller: 'summaryActionCardCtrl',
	templateUrl: 'components/summary-action-card/summary-action-card.component.html'
})
.controller('summaryActionCardCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		$ctrl.canEdit = getCanEdit($ctrl);
	}

	function getCanEdit ($ctrl) {

		// Function needs to be provided
		if (!angular.isFunction($ctrl.onEdit)) {
			return false;
		}

		return angular.isDefined($ctrl.canEdit) ? $ctrl.canEdit : false;
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('supportArticleLink', {

	bindings: {
		articleKey: '=',
		position: '@',		// 'left' (default), 'right'. This is the side of the page the support article will appear.
		theme: '@?',
		underline: '<?'
	},
	controller: 'supportArticleLinkCtrl',
	templateUrl: 'components/support-article-link/support-article-link.component.html',
	transclude: true,

})

.controller('supportArticleLinkCtrl', [
	'$rootScope',
	function (
		$rootScope
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		$ctrl.theme = angular.isDefined($ctrl.theme) ? $ctrl.theme : '';
		$ctrl.underline = angular.isDefined($ctrl.underline) ? $ctrl.underline : false;
	};

	function openSupportArticle (articleKey) {

		$rootScope.openHelpAndSupportPanel({
			articleKey,
			// Default to left if not specified
			position: angular.isDefined($ctrl.position) && $ctrl.position === 'right' ? 'right' : 'left'
		});
	}

	angular.extend($ctrl, {
		openSupportArticle
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('supportArticleImage', {

	bindings: {
		articleImageSrc: '@',
		articleImageAlt: '@'
	},
	controller: 'supportArticleImageCtrl',
	templateUrl: 'components/support-article-image/support-article-image.component.html'
})

.controller('supportArticleImageCtrl', [
	'$rootScope',
	function (
		$rootScope
	) {

	const $ctrl = this;

	function showImageFocus (ctrlObj) {
		ctrlObj.showImageFocusButton = false;
		$rootScope.$broadcast('open-image-focus', {
			src: ctrlObj.articleImageSrc,
			alt: ctrlObj.articleImageAlt
		});
	}

	function onImageMouseOut (ctrlObj) {
		ctrlObj.showImageFocusButton = false;
	}

	function onImageMouseOver (ctrlObj) {
		ctrlObj.showImageFocusButton = true;
	}

	angular.extend($ctrl, {
		showImageFocusButton: false,

		onImageMouseOut,
		onImageMouseOver,
		showImageFocus
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('supplementaryPaymentCard', {
	bindings: {
		agencyProfileId: '<',
		onDelete: '&',
		onUpdate: '&',
		payment: '<',
		theme: '@'
	},
	controller: 'supplementaryPaymentCardComponentCtrl',
	templateUrl: 'components/supplementary-payment-card/supplementary-payment-card.component.html'
})
.controller('supplementaryPaymentCardComponentCtrl', [
	'$filter',
	'$rootScope',
	'payrollData',
	'supplementaryPayRunService',
	'utilities',
	'SUBMISSION_STATES',
	function (
		$filter,
		$rootScope,
		payrollData,
		supplementaryPayRunService,
		utilities,
		SUBMISSION_STATES
	) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.payment = supplementaryPayRunService.decorateSupplementaryPaymentObj($ctrl.payment);
	}

	function editSupplementaryPayment (supplementaryPaymentObj, isDownloadReports) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			continue: true,
			formKey: 'supplementary-pay-run',
			isDownloadReports: isDownloadReports,
			supplementaryPaymentId: supplementaryPaymentObj.SupplementaryPaymentID,
			title: isDownloadReports ? 'Download reports' : null,
			userIds: supplementaryPaymentObj.distinctUserIds
		});
	}

	function hideMenus (supplementaryPaymentObj) {

		supplementaryPaymentObj.showMenu = false;
	}

	function openDeleteSupplementaryPaymentForm (supplementaryPaymentObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onDelete,
			formKey: 'delete-supplementary-pay-run', // The specific form key (form to open)
			supplementaryPayment: supplementaryPaymentObj
		});
	}

	angular.extend($ctrl, {
		SUBMISSION_STATES,
		$onInit,
		editSupplementaryPayment,
		hideMenus,
		openDeleteSupplementaryPaymentForm
	});

}]);

angular.module('paycircleApp')

/*
	tabBarDef - tab bar definition as returned by the tab service. Very much required.
	tabBarCounts - set of counts for specific tabs. Optional. Should be of the form: {
		'tabKey1': {		.. tabKey is the id of the tab as defined in TAB_KEYS
			count,			.. count is the count to show alongside the tab. -1 indicates 'loading' (a spinny thingy is shown)
			theme			.. theme to use for the counter.
		}
		'tabKey2': { 		.. etc., and so on, and so forth, etc.
	}
	isCentered - true to centre the set of tabs in their container when the available width is greater than the width of the tab base.
				 Tabs are left-aligned, usually. Current period isn't. Optional, defaults to false.
	onTabSelected - callback for tab selection. The id of the selected tab is passed to the callback. Optional.
 */
.component('tabBar', {
    bindings: {
		isCentered: '<?',
		tabBarDef: '<',
		tabBarCounts: '<',
		onTabSelected: '&?'
    },
    templateUrl: 'components/tab-bar/tab-bar.component.html',
    controller: 'tabBarCtrl'
})

.controller('tabBarCtrl', ['$state', '$timeout', '$window', 'config', function ($state, $timeout, $window, config) {

    const $ctrl = this;

	/* Spacing between tabs. This is used for calculation (showCurrentTab below) and to set the margin
	   as an inline style in the template, just so it's defined in a single place. */
	const TAB_MARGIN = 25;

	$ctrl.$onDestroy = () => {
		// Remove window event listener
		angular.element($window).off('resize');
	};

    $ctrl.$onInit = () => {

		decorateTabItems($ctrl.tabBarDef);

		angular.extend($ctrl, {
			isCentred: angular.isDefined($ctrl.isCentred) ? $ctrl.isCentered : false,
			isOpen: false,
			tabWidthsCalculated: false,
			visibleTabs: $ctrl.tabBarDef.tabs
		});

		// On window resize, check which tabs needs to be hidden in the overflow dropdown. Also hide it, in case its visible.
        angular.element($window).on('resize', () => {
			hideOverflow($ctrl);
            showCurrentTab($ctrl);
		});
	};

	// After init and post-link, determine the current tab according to the current state and show it.
	$ctrl.$postLink = () => {

		// Set current tab based on state
		const currentStateName = $state.current.name;
		let currentTab;
		for (let i = 0, ii = $ctrl.tabBarDef.tabs.length; i < ii; i++) {
			const tab = $ctrl.tabBarDef.tabs[i];
			// sref could legitimately be an empty string, so no angular.isDefined here
			if (tab.sref && tab.sref.startsWith(currentStateName)) {
				currentTab = tab;
				// Found it, just get out.
				break;
			}
		}
		/* If current tab couldn't be established, default to the first. Some tabs won't have an sref, in which case the above
		   won't find the current tab. Because if truth be told, there really isn't one. */
		if (angular.isUndefined(currentTab)) {
			currentTab = $ctrl.tabBarDef.tabs[0];
		}

		showCurrentTab($ctrl, currentTab);
	};

	function calculateTabWidths (ctrlObj) {
		// One-time only calculation of tab widths to save getElementById calls and time
		if (!ctrlObj.tabWidthsCalculated) {
			ctrlObj.tabBarDef.tabs.forEach(tab => {
				// Include the tab margin as part of the overall tab width
				tab.width = document.getElementById(tab.id).clientWidth + TAB_MARGIN;
			});
			ctrlObj.tabWidthsCalculated = true;
		}
	}

    function decorateTabItems (tabBarDef) {
		// Generate a 'hasCount' flag for convenience if there are counts
		if (angular.isDefined($ctrl.tabBarCounts)) {
			tabBarDef.tabs.forEach((tab) => {
				tab.hasCount = angular.isDefined($ctrl.tabBarCounts[tab.id]);
			 });
		}
    }

	function hideOverflow (ctrlObj) {
		ctrlObj.showOverflow = false;
	}

	/* Make sure the current tab is always visible, hiding others as necessary. If tabObj is specified,
	   set that to the current tab and show that. */
	function showCurrentTab (ctrlObj, tabObj) {

		// Set current tab if specified
		if (angular.isDefined(tabObj)) {
			ctrlObj.currentTab = tabObj;
		}

		$timeout(() => {
			// If window has reached mobile size, drop back to mobile version
			if ($window.innerWidth < config.screenPixelMaxWidths.phone) {
				// All tabs visible, set to mobile view
				angular.extend(ctrlObj, {
					hasOverflow: false,
					mobileView: true,
					visibleTabs: ctrlObj.tabBarDef.tabs
				});
			}
			else {
				/* Normal view. Ensure the specified tab is visible at the end of the tab bar. Tabs that don't fit need to be
				   stuffed into overflow; this can include tabs at the start and / or at the end. As long as the
				   specified tab can be seen and all options are available either on-screen or in the overflow.
				   Do this in a timeout so angular does its digest thing afterwards, since when invoked by an event
				   that won't happen otherwise. Also ensures everything's in place for determining widths when
				   called from postLink. */
			   	ctrlObj.mobileView = false;

				// Ensure tab widths are calculated. (This won't do anything if they've already been calculated).
				calculateTabWidths(ctrlObj);

				/* Determine overall width of tab bar. This has to happen every time since the window may
				have been resized. */
				const tabBarContainer = document.getElementById(ctrlObj.tabBarDef.id);
				const tabBarContainerWidth = tabBarContainer.clientWidth;

				/* Go through tabs and check which can be displayed in the available width, and which need to
				be bunged into the overflow menu. Start with a little bit of width so tab overflow doesn't
				happen too early, and to take into account the space taken by the overflow menu button */
				let visibleTabs = [];
				let overflowTabs = [];
				let overflow = false;
				let tabsWidth = TAB_MARGIN;

				ctrlObj.tabBarDef.tabs.forEach(tab => {

					// Add calculated tab width for the current tab
					tabsWidth += tab.width;

					// If available width has been used up, start adding to overflow
					if (tabsWidth > tabBarContainerWidth) {
						overflow = true;
					}

					/* If we're at the tab that needs to be shown, but we've gone beyone the available width,
					some at the front need to go into overflow */
					if (tab === ctrlObj.currentTab && overflow) {

						// This tab *has* to be visible
						visibleTabs.push(tab);

						/* Remove a number of tabs at the start to accommodate the one that needs to be shown.
						Create a new array for them so they can be inserted back in the correct order */
						let tabsToMoveToOverflow = [];
						for (let i = 0, ii = ctrlObj.tabBarDef.tabs.length; i < ii; i++) {
							// Move tab from visible to overflow list
							tabsToMoveToOverflow.push(visibleTabs.shift());
							// Adjust the tabs width accordingly
							tabsWidth -= ctrlObj.tabBarDef.tabs[i].width;
							// Enough space now?
							if (tabsWidth <= tabBarContainerWidth) {
								// Yeah. Add the tabs to move to overflow in the correct order and get out
								overflowTabs.unshift(...tabsToMoveToOverflow);
								break;
							}
						}
					}
					else {
						// Add the tab to visible part of tab bar, or overflow area, depending on overflow flag
						if (!overflow) {
							visibleTabs.push(tab);
						}
						else {
							overflowTabs.push(tab);
						}
					}
				});

				angular.extend(ctrlObj, {
					hasOverflow: overflowTabs.length !== 0,
					overflowTabs,
					visibleTabs
				});
			}
		});
	}

	function overflowTabSelected (ctrlObj, tabObj) {
		// Set and show selected tab and hide the overflow menu
		showCurrentTab(ctrlObj, tabObj);
		ctrlObj.showOverflow = false;

		// Delegate to tab selected
		tabSelected(ctrlObj, tabObj);
	}

	function tabSelected (ctrlObj, tabObj) {
		// Set current tab
		ctrlObj.currentTab = tabObj;
		// Close mobile menu.
		ctrlObj.isOpen = false;

		// Invoke tab selected function if defined
		if (angular.isDefined(ctrlObj.onTabSelected)) {
			ctrlObj.onTabSelected()(tabObj.id);
		}
	}

    function toggleOverflow (ctrlObj) {
        ctrlObj.showOverflow = !ctrlObj.showOverflow;
    }

    angular.extend($ctrl, {
		TAB_MARGIN,

		hideOverflow,
		overflowTabSelected,
		tabSelected,
        toggleOverflow
    });
}])

// A little directive to reduce repetition in the tab-bar component template. For various reasons this is repeated 4 times.
.directive('tabBarCounter', function () {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			count: '=',
			theme: '=',
			isCurrent: '='
		},
		template: `<span class="tab-bar_tab-counter {{theme}}" ng-class="{'inverse': isCurrent, 'tada': count !== -1 }">
		               <i class="icon-loading xs spin" ng-if="count === -1"></i>
				       <span ng-if="count !== -1">{{count | nineMax}}</span>
				   </span>`
	};
});

'use strict';

angular.module('paycircleApp')
.component('taskCard', {
	bindings: {
		taskIcon: '@?',
		taskId: '@?',
		taskTheme: '@?'
	},
	controller: 'taskCardCtrl',
	templateUrl: 'components/task-card/task-card.component.html',
	transclude: {
		'action': '?taskAction',
		'title': '?taskTitle',
		'description': 'taskDescription',
		'footer': '?taskFooter'
	}
})
.controller('taskCardCtrl', ['$transclude', function ($transclude) {

	const $ctrl = this;

	$ctrl.$onInit = function () {
		angular.extend($ctrl, {
			hasFooter: $transclude.isSlotFilled('footer'),
			hasIcon: angular.isDefined($ctrl.taskIcon)
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('taskItem', function () {

	return {
		templateUrl: 'components/task-item/taskItemComponent.html',
		replace: true,
		restrict: 'E',
		scope: {
			tiText: '@?',
			tiRequired:  '=?',
			tiIsComplete:  '=?'
		}
	};
});

'use strict';

angular.module('paycircleApp')

.component('taxInfoFormFields', {

	bindings: {
		allowNiCategoryEdit: '<?',
		isDisabled: '<?',
		niCategoryLetters: '<',
		showNiCategory: '<?',
		taxInfo: '<',
		required: '<?'
	},
	controller: 'taxInfoFormFieldsCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'components/tax-info-form-fields/tax-info-form-fields.component.html'
})

.controller('taxInfoFormFieldsCtrl', [
	'TAX_CODES',
	'TAX_CODES_FIXED',
function (
	TAX_CODES,
	TAX_CODES_FIXED
) {

	const $ctrl = this;

	function decorateTaxInfo (taxInfoObj) {

		let taxCode = taxInfoObj.TaxCode;
		taxInfoObj.isTaxCodeScottish 	= false;
		taxInfoObj.taxCodeLetter 		= '';
		taxInfoObj.taxCodeNumber 		= '';

		if (taxCode) {

			/* Check first letter of tax code for special types. If it starts with 'S', it's Scottish.
			   If it starts with 'C', it's Welsh. Cymru, or whatever they call it. */
			const taxCodeLetter = taxCode.charAt(0);
			switch (taxCodeLetter) {
				case 'S':
					taxInfoObj.isTaxCodeScottish = true;
					taxCode = taxCode.substr(1);
					break;
				case 'C':
					taxInfoObj.isTaxCodeWelsh = true;
					taxCode = taxCode.substr(1);
			}

			// Tax code number is the bit of the tax code minus the last character
			const taxCodeNumber = taxCode.slice(0, -1);
			const taxCodeLastCharacter 	= taxCode.substr(taxCode.length - 1);

			// Is this a 'K' tax code ...
			if (taxCode.charAt(0) === 'K') {
				// It is ...
				taxInfoObj.taxCodeLetter = 'K';
				taxInfoObj.taxCodeNumber = taxCode.substr(1);
			}
			else {
				// It isn't ...

				// Non fixed tax code
				if (TAX_CODES_FIXED.indexOf(taxCode) === -1) {
					taxInfoObj.taxCodeLetter = taxCodeLastCharacter;
					taxInfoObj.taxCodeNumber = taxCodeNumber;
				}
				// Fixed tax code
				else {
					taxInfoObj.taxCodeLetter = taxCode;
					taxInfoObj.taxCodeNumber = '';
				}
			}

		}
		else {
			// No tax code - default to L
			if (taxCode === '') {
				taxInfoObj.taxCodeLetter = 'L';
				taxInfoObj.taxCodeNumber = '';
			}
		}
	}

	$ctrl.$onInit = () => {

		// Defaults
		$ctrl.allowNiCategoryEdit = !!$ctrl.allowNiCategoryEdit;
		$ctrl.isDisabled = !!$ctrl.isDisabled;
		$ctrl.required = angular.isDefined($ctrl.required) ? $ctrl.required : true;
		$ctrl.showNiCategory = angular.isDefined($ctrl.showNiCategory) ? $ctrl.showNiCategory : true;

		// Decoration
		decorateTaxInfo($ctrl.taxInfo);
	};

	function updateTaxCode (taxInfoObj) {

		let taxCodeNumber = taxInfoObj.taxCodeNumber;
		let taxCodeLetter = taxInfoObj.taxCodeLetter;
		let updatedTaxCode = '';

		// Scottish/Welsh tax codes
		if (taxCodeLetter !== 'NT') {
			if (taxInfoObj.isTaxCodeScottish) {
				updatedTaxCode += 'S';
			}
			else if (taxInfoObj.isTaxCodeWelsh) {
				updatedTaxCode += 'C';
			}
		}

		// K Codes (prefix)
		if (taxCodeLetter === 'K') {
			updatedTaxCode += 'K';
			updatedTaxCode += taxCodeNumber !== undefined ? taxCodeNumber : '';
		}

		// Fixed tax codes
		else if (TAX_CODES_FIXED.indexOf(taxCodeLetter) > -1) {

			// Make sure tax code number is empty
			taxCodeNumber = '';

			// Append fixed tax code
			updatedTaxCode += taxCodeLetter;
		}

		// Non fixed tax code (suffix)
		else {

			updatedTaxCode += taxCodeNumber !== undefined ? taxCodeNumber : '';
			updatedTaxCode += taxCodeLetter;
		}

		// NT codes
		if (taxCodeLetter === 'NT') {
			taxInfoObj.isTaxCodeScottish = false;
			taxInfoObj.isTaxCodeWelsh = false;
		}

		// Clear TaxCode if there isn't a tax code leetter
		if (!taxCodeLetter) {
			updatedTaxCode = '';
		}

		// Update tax code
		taxInfoObj.TaxCode = updatedTaxCode;
	}

	angular.extend($ctrl, {
		TAX_CODES,
		TAX_CODES_FIXED,

		updateTaxCode
	});
}]);

'use strict';

angular.module('paycircleApp')

/**
 * Displays tax treatement in a list for an adjustment group entry
 */
.component('taxTreatmentList', {
	bindings: {
		adjustmentGroupEntry: '='
	},
	controllerAs: '$ctrl',
	templateUrl: 'components/tax-treatment-list/tax-treatment-list.component.html'
});

'use strict';

angular.module('paycircleApp')
.component('taxInfoUpdateCard', {
	bindings: {
		index: '<',
		refreshTaxUpdates: '&',
		taxUpdate: '<'
	},
	controller: 'taxInfoUpdateCardCtrl',
	templateUrl: 'components/tax-info-update-card/tax-info-update-card.component.html'
})
.controller('taxInfoUpdateCardCtrl', [
	'$rootScope',
	function (
		$rootScope
	) {

	const $ctrl = this;

	function openDeleteTaxUpdateForm (taxUpdate) {
		$rootScope.openSlideInForm({
			agencyProfileId: taxUpdate.AgencyProfileID,
			callback: refreshTaxUpdates,
			contextType: 'user',
			formKey: 'delete-tax-update',
			initCallbackOnClose: true,
			taxUpdate,
			userId: taxUpdate.UserID,
		});
	}

	function openEditTaxUpdateForm (taxUpdate) {

		$rootScope.openSlideInForm({
			agencyProfileId: taxUpdate.AgencyProfileID,
			callback: refreshTaxUpdates,
			contextType: 'user',
			formKey: 'add-tax-update',
			initCallbackOnClose: true,
			isEditMode: true,
			taxUpdates: [taxUpdate],
			title: 'Edit update',
			userId: taxUpdate.UserID,
		});
	}

	function refreshTaxUpdates () {

		if (angular.isFunction($ctrl.refreshTaxUpdates)) {
			$ctrl.refreshTaxUpdates();
		}
	}

	angular.extend($ctrl, {
		openDeleteTaxUpdateForm,
		openEditTaxUpdateForm,
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('taxUpdateCard', {

	templateUrl: 'components/tax-update-card/tax-update-card.component.html',
	bindings: {
		taxUpdateLogEntry: '=',
		theme: '<?'
	}
});
'use strict';

angular.module('paycircleApp')
.component('taxUpdateConfirmationCard',  {

		templateUrl: 'components/tax-update-confirmation-card/tax-update-confirmation-card.component.html',
		replace: true,
		require: '^form',
		bindings: {
			index: '=',
			teamMemberTax: '='
		},
		controller: 'taxUpdateConfirmationCardController'
})
.controller('taxUpdateConfirmationCardController', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		// To begin with, all are accepted
		$ctrl.teamMemberTax.isAccepted = true;
		updateRejectedState($ctrl.teamMemberTax);
	};

	function updateRejectedState (teamMemberTax) {

		// Slight weirdness here. The 'on' state of the toggle means RejectTaxUpdate is false, 'off' means true.
		teamMemberTax.RejectTaxUpdate = !teamMemberTax.isAccepted;

		/* Clear out the reject reason if accepted. Just to really ensure that reject reasons aren't sent for accepted
		   tax updates, even though that might be a safe thing to do. */
		if (teamMemberTax.isAccepted) {
			teamMemberTax.RejectReason = '';
		}
	}

	angular.extend($ctrl, {
		updateRejectedState
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('teamCardBasic', {
	bindings: {
		hasCheckbox: '<?',
		isNameClickable: '<?',
		ngModel: '=?',
		onChange: '=?',
		showEmail: '<?',
		showFooter: '<?',
		showIcon: '<?',
		teamMember: '=',
		theme: '@?'
	},
	controller: 'teamCardBasicCtrl',
	templateUrl: 'components/team-card-basic/team-card-basic.component.html',
	transclude: {
		'actions': '?tcActions',
		'content': '?tcContent',
		'footer': '?tcFooter',
		'icon': '?tcIcon'
	}
})
.controller('teamCardBasicCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		angular.extend($ctrl, {
			isNameClickable: angular.isDefined($ctrl.isNameClickable) ? $ctrl.isNameClickable : false,
			hasActions: $transclude.isSlotFilled('actions'),
			hasContent: $transclude.isSlotFilled('content'),
			hasFooter: $transclude.isSlotFilled('footer'),
			showEmail: angular.isDefined($ctrl.showEmail) ? $ctrl.showEmail : true,
			showIcon: angular.isDefined($ctrl.showIcon) ? $ctrl.showIcon: false
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('teamCardArchived', function () {

	return {
		templateUrl: 'components/team-card-moved-payrolls/team-card-moved-payrolls.component.html',
		replace: true,
		scope: {
			agencyProfileId: '@',
			index: '<',
			teamMember: '=',
			bulkItems: '='
		},
		controller: 'teamCardMovedPayrollsController'
	};
})
.controller('teamCardMovedPayrollsController', ['$scope', function ($scope) {

	const agencyProfileId = $scope.agencyProfileId;
	const teamMemberObj = $scope.teamMember;

	angular.extend($scope, {
		agencyProfileId,
		teamMemberObj
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('teamCardHistory', function () {

	return {
		templateUrl: 'components/team-card-history/teamCardHistory.html',
		replace: true,
		scope: {
			agencyProfileId: '<',
			payPeriod: '=',
			searchBarOptions: '=?',
			teamMember: '=',
			teamMembers: '<?'
		},
		controller: 'teamCardHistoryController'
	};
})
.controller('teamCardHistoryController', ['$rootScope', '$scope', '$state', 'growl', 'teamData', function ($rootScope, $scope, $state, growl, teamData) {

	var agencyProfileId = $scope.agencyProfileId;
	var payPeriod = $scope.payPeriod;
	var searchBarOptions = $scope.searchBarOptions;
	var teamMember = $scope.teamMember;
	var userId = $scope.teamMember.UserID;

	function openAdditionalPayRunForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: '',
			userId: userId
		});
	}

	function openViewPayStatementForm (userId) {

		$rootScope.openSlideInForm({
			agencyPayPeriodId: payPeriod.PayPeriodID,
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			formKey: 'pay-statement',
			formState: 'history',
			searchBarOptions: searchBarOptions,
			showContext: false,
			teamMembers: $scope.teamMembers,
			title: 'Pay statement',
			userId: userId
		});
	}

	function updateUser (userId) {

		teamData.getUserAgencyProfileForAgencyTeamMember(userId, agencyProfileId).then(function (teamMemberObj) {

			// Set original PayrollIDSequence to add back to team member once updated
			// https://www.notion.so/paycircle/Team-Payroll-ID-sort-order-becomes-incorrect-when-adding-a-change-in-current-period-e413a8f6d40f424bb321cc0198116b41#b38b16d43cd0482689ccfb36cb29af15
			teamMemberObj.PayrollIDSequence = $scope.teamMember.PayrollIDSequence;

			$scope.teamMember = teamMemberObj;
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	}

	angular.extend($scope, {
		agencyProfileId,
		teamMember,
		openAdditionalPayRunForm,
		openViewPayStatementForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('teamCardLeaver', {
	bindings: {
		agencyProfileId: '<',
		index: '<',
		teamMember: '=',
		payPeriod: '<',
		onUpdate: '='
	},
	controller: 'teamCardLeaverCtrl',
	templateUrl: 'components/team-card-leaver/team-card-leaver.component.html',
})
.controller('teamCardLeaverCtrl', [
	'$rootScope',
	'$state',
	'dataTransfer',
	'CORRECTIONAL_SUBMISSION_TYPES',
	function (
		$rootScope,
		$state,
		dataTransfer,
		CORRECTIONAL_SUBMISSION_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			profileUrl: getProfileUrl($ctrl)
		});
	}

	function getProfileUrl ($ctrl) {

		if ($ctrl.teamMember.isArchivedLeaver) {
			return $state.href('team.profile.information', {
				agencyProfileId: $ctrl.agencyProfileId,
				userId: $ctrl.teamMember.UserID,
				archivedEmploymentId: $ctrl.teamMember.ArchivedEmploymentID
			});

		} else {
			return $state.href('team.profile.overview', {
				agencyProfileId: $ctrl.agencyProfileId,
				userId: $ctrl.teamMember.UserID
			});
		}
	}

	function openDeleteTeamMemberForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			forceDelete: true,
			formKey: 'delete-team-member',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openCorrectionalSubmissionForm ($ctrl, correctionalSubmissionType) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			correctionalSubmissionType: correctionalSubmissionType,
			formKey: 'correctional-submission',
			title: correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'Submit Earlier Year FPS' : 'Earlier year update',
			userId: $ctrl.teamMember.UserID,
			userIds: [$ctrl.teamMember.UserID]
		});
	}

	function openGenerateP45Form ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'generate-p45',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openLeaverMadeInErrorForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'leaver-made-in-error',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openUnmarkAsLeaverForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'unmark-as-leaver',
			primaryButtonText: 'Unmark',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openPaymentAfterLeavingForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'add-a-change',
			includeLeavers: true,
			payPeriodId: $ctrl.payPeriod.PayPeriodID,
			title: 'Payment after leaving',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openRejoinLeaverForm ($ctrl) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'rejoin-leaver',
			userId: $ctrl.teamMember.UserID
		});
	}

	function openUpdateLeaverStatusForm ($ctrl, forUpdate) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			contextType: 'user',
			formKey: 'update-leaver-status',
			forUpdate: forUpdate,
			title: forUpdate ? 'Edit leaver information' : 'Mark as leaver',
			userId: $ctrl.teamMember.UserID
		});
	}

	angular.extend($ctrl, {
		$onInit,

		CORRECTIONAL_SUBMISSION_TYPES,

		downloadFile: dataTransfer.downloadFile,
		openCorrectionalSubmissionForm,
		openDeleteTeamMemberForm,
		openGenerateP45Form,
		openLeaverMadeInErrorForm,
		openPaymentAfterLeavingForm,
		openRejoinLeaverForm,
		openUnmarkAsLeaverForm,
		openUpdateLeaverStatusForm
	});
}]);

'use strict';

angular.module('paycircleApp')
	.component('teamCardReversedTaxCodes', {
		bindings: {
			teamMember: '=',
		},
		controller: 'teamCardReversedTaxCodesCtrl',
		templateUrl: 'components/team-card-reversed-tax-codes/team-card-reversed-tax-codes.component.html',
	})
	.controller('teamCardReversedTaxCodesCtrl', [
		'$filter',
		function ($filter) {

			const $ctrl = this;

			$ctrl.$onInit = () => {

				angular.extend($ctrl, {
					taxCodeListItems: createComponentChangesArray(),
					effectiveDatesListItems: createEffectiveDatesArray(),
				});
			};

			function createComponentChangesArray () {

				return !$ctrl.teamMember ? [] :
					[
						`${$ctrl.teamMember.ReversedComponentName}: ${$ctrl.teamMember.ValueBeforeAfter}`,
						`${$ctrl.teamMember.ReversedComponentName}: ${$ctrl.teamMember.HmrcValue}`,
						`${$ctrl.teamMember.ReversedComponentName}: ${$ctrl.teamMember.ValueBeforeAfter}`,
					];
			}

			function createEffectiveDatesArray () {

				return !$ctrl.teamMember ? [] :
					[
						$ctrl.teamMember.ReversalRecordEffectiveDateISO ? `Effective: ${$filter('dateformat')($ctrl.teamMember.ReversalRecordEffectiveDateISO, 'numeric')}` : 'Setup status',
						$ctrl.teamMember.HmrcRecordEffectiveDateISO ? `Effective: ${$filter('dateformat')($ctrl.teamMember.HmrcRecordEffectiveDateISO, 'numeric')}` : 'Setup status',
						$ctrl.teamMember.InitialRecordEffectiveDateISO ? `Effective: ${$filter('dateformat')($ctrl.teamMember.InitialRecordEffectiveDateISO, 'numeric')}` : 'Setup status'
					];
			}

		}]);

'use strict';

angular.module('paycircleApp')
.directive('teamCardPayroll', function () {

	return {
		templateUrl: 'components/team-card-payroll/teamCardPayroll.html',
		replace: true,
		scope: {
			agencyProfileId: '@',
			company: '<',
			index: '<',
			bulkItems: '=',
			onUpdate: '=',
			payPeriod: '<',
			searchBarOptions: '=?',
			teamMember: '='
		},
		controller: 'teamCardPayrollController'
	};
})
.controller('teamCardPayrollController', [
	'$rootScope',
	'$scope',
	'bulkService',
	'ADJUSTMENT_TYPES',
	'BUSINESS_TYPES',
	'FULL_SCREEN_MODAL_KEYS',
	'PAYMENT_TYPES',
	'SALARY_TYPES',
	function (
		$rootScope,
		$scope,
		bulkService,
		ADJUSTMENT_TYPES,
		BUSINESS_TYPES,
		FULL_SCREEN_MODAL_KEYS,
		PAYMENT_TYPES,
		SALARY_TYPES
	) {

	var agencyProfileId = $scope.agencyProfileId;
	var onUpdate = $scope.onUpdate;
	var payPeriodObj = $scope.payPeriod;
	var searchBarOptions = $scope.searchBarOptions;
	var teamMember = $scope.teamMember;
	var userId = $scope.teamMember.PersonalDetails.UserID;
	var bulkItems = $scope.bulkItems;

	function decorateTeamMember (teamMemberObj) {

		// Is CIS company?
		teamMemberObj.isCompany = teamMemberObj.PersonalDetails.IsCISSubcontractor && (teamMemberObj.PersonalDetails.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.PersonalDetails.BusinessDetails.BusinessType === BUSINESS_TYPES.trust);
		teamMemberObj.loadingState = 'ready';

		// If there's a deemed payment adjustment available for editing, grab its ID.
		const deemedPaymentAdjustment = teamMemberObj.Adjustments.find(adjustment => adjustment.AdjustmentDetailID === ADJUSTMENT_TYPES.deemedPayment);
		if (angular.isDefined(deemedPaymentAdjustment)) {
			teamMemberObj.deemedPaymentAdjustmentId = deemedPaymentAdjustment.AdjustmentID;
		}

		return teamMemberObj;
	}

	function init () {

		$scope.teamMember = decorateTeamMember(teamMember);
	}

    function onCheckboxToggle () {

		bulkItems = bulkService.updateBulkItemTotals(bulkItems);
	}

	function openAddAChangeForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'add-a-change',
			includeLeavers: true,
			payPeriod: payPeriodObj,
			userId: userId
		});
	}

	function openApplyTaxRefundForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'apply-tax-refund',
			title: 'Tax refund',
			userId: userId,
			currentPayPeriod: payPeriodObj
		});
	}

	function openEditDeemedPaymentForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			deemedPaymentAdjustmentId: teamMember.deemedPaymentAdjustmentId,
			formKey: 'edit-deemed-payment',
			userId: userId,
			currentPayPeriod: payPeriodObj
		});
	}

	function openEditPayslipNotesForm () {

		$rootScope.$broadcast('open-full-screen-modal', {
			modalKey: FULL_SCREEN_MODAL_KEYS.payslipNotes,
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			payPeriod: payPeriodObj,
			searchBarOptions: $scope.searchBarOptions,
			userIds: [userId]
		});
	}

	function openFormForState (teamMemberObj) {

		switch (teamMemberObj.clickedState) {
			case 'salary-change':
				openSalaryChangeForm();
				break;
			default:
				$rootScope.paycircleMessage('Unable to open form', 'warn');
				break;
		}
	}

	function openUpdateLeaverStatusForm (forUpdate) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'update-leaver-status',
			forUpdate: forUpdate,
			title: forUpdate ? 'Update leaver information' : 'Mark as leaver',
			userId: userId
		});
	}

	function openPayStatementForm () {

		openSlideInForm({
			agencyPayPeriodId: payPeriodObj.PayPeriodID,
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			formState: 'preview',
			formKey: 'pay-statement',
			searchBarOptions: searchBarOptions,
			showContext: false,
			teamMembers: $scope.bulkItems.all,
			title: 'Preview pay statement',
			userId: userId
		});
	}

	function openPensionTeamManagePensionsForm () {

		openSlideInForm({
			agencyPayPeriodId: payPeriodObj.PayPeriodID,
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			formKey: 'pension-team-manage-pensions',
			userId: userId
		});
	}

	function openRemovePayslipNotesForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			payPeriod: payPeriodObj,
			callback: updateUser,
			contextType: 'user',
			formKey: 'remove-payslip-notes',
			searchBarOptions: $scope.searchBarOptions,
			title: 'Remove payslip notes',
			userId: userId,
			userIds: [userId]
		});
	}

	function openSalaryChangeForm () {

		openSlideInForm({
			payPeriodId: payPeriodObj.PayPeriodID,
			agencyProfileId: agencyProfileId,
			userId: userId,
			formKey: 'salary-change',
			contextType: 'user',
		});
	}

	function openSlideInForm (formOptionsObj) {

		$scope.menuShow = false;
		$rootScope.$broadcast('open-slide-in-form', formOptionsObj);
	}

	function openUpdateGrossPayForm (teamMemberObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'update-gross-pay',
			title: `Update ${teamMemberObj.PersonalDetails.SalaryType === SALARY_TYPES.netPay ? 'net pay' : 'salary'} for period`,
			userId: userId
		});
	}

	function openViewChangesForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			currentPayPeriod: payPeriodObj,
			formKey: 'view-changes',
			userId: userId
		});
	}

	function openViewWorkPatternForm (userId) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			contextType: 'user',
			formKey: 'view-work-pattern',
			userId: userId
		});
	}

	function updateUser (callbackResponse) {

		// Some forms return a callback object containing a userId
		if (angular.isObject(callbackResponse)) {
			onUpdate(callbackResponse.userId);
		}

		// Default slideInForm callback response returns the userId directly
		else {
			onUpdate(callbackResponse);
		}
	}

	init();

	angular.extend($scope, {
		PAYMENT_TYPES,
		SALARY_TYPES,

		agencyProfileId,
		menuShow: false,
		updateUser,
		userId,

		onCheckboxToggle,
		openAddAChangeForm,
		openApplyTaxRefundForm,
		openEditDeemedPaymentForm,
		openEditPayslipNotesForm,
		openUpdateLeaverStatusForm,
		openPayStatementForm,
		openPensionTeamManagePensionsForm,
		openRemovePayslipNotesForm,
		openUpdateGrossPayForm,
		openViewChangesForm,
		openViewWorkPatternForm,
		openFormForState
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('teamCardPension', function () {

	return {
		templateUrl: 'components/team-card-pension/teamCardPension.html',
		replace: true,
		scope: {
			teamMember: '=',
			agencyEmployerPensionId: '@',
			agencyProfileId: '@',
			index: '<',
			isGhostPension: '<',
			onUpdate: '=?',
			pensionAdditionalPostId: '@?'
		},
		controller: 'teamCardPensionController'
	};
})
.controller('teamCardPensionController', ['$rootScope', '$scope', 'pensionData', 'FORM_WIZARD_KEYS',
	function ($rootScope, $scope, pensionData, FORM_WIZARD_KEYS) {

	const agencyEmployerPensionId = $scope.agencyEmployerPensionId;
	const agencyProfileId = $scope.agencyProfileId;
	const onUpdate = $scope.onUpdate;
	const pensionAdditionalPostId = $scope.pensionAdditionalPostId;
	const userId = $scope.teamMember.UserID;

	function getApplicableDateByPensionState (pensionObj) {

		switch (pensionObj.PensionState) {

			case 'enrolled':
			case 'joined':
			case 'opted in':
			case 'voluntary':
				return pensionObj.PensionEnrolledDateISO;
			case 'ceased':
				return pensionObj.PensionCeaseDateISO;
			case 'opted out':
				return pensionObj.PensionOptOutDateISO;
			case 'postponed':
				return pensionObj.PensionPostponeDateISO;
			default:
				return '';
		}
	}

	function openSlideInForm (formKey, refreshTeamOnCallback) {
		$rootScope.openSlideInForm({
			agencyProfileId,
			agencyEmployerPensionId,
			callback: refreshTeamOnCallback ? onUpdate : updateUser,
			contextType: 'user',
			pensionAdditionalPostId,
			userId: userId,
			formKey: formKey
		});
	}

	function openEditTeamMemberPensionWizard () {
		$rootScope.$broadcast('open-form-wizard', {
			callback: updateUser,
			contextType: 'user',
			showContext: true,
			agencyProfileId,
			agencyEmployerPensionId,
			pensionAdditionalPostId,
			userId: userId,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditAEPension
		});
	}

	function updateUser (userId) {

		pensionData.getUserAgencyProfileForWorkplacePension(agencyProfileId, agencyEmployerPensionId, userId).then(teamMemberObj => {

			// Set original PayrollIDSequence to add back to team member once updated
			// https://www.notion.so/paycircle/Team-Payroll-ID-sort-order-becomes-incorrect-when-adding-a-change-in-current-period-e413a8f6d40f424bb321cc0198116b41#b38b16d43cd0482689ccfb36cb29af15
			teamMemberObj.PayrollIDSequence = $scope.teamMember.PayrollIDSequence;

			angular.extend($scope, {
				teamMember: teamMemberObj,
				pensionStateDate: getApplicableDateByPensionState(teamMemberObj.Pension)
			});
		})
		.catch(error => {
			console.error(error);
			$scope.pageState = 'error';
		});
	}

	angular.extend($scope, {
		agencyProfileId,
		menuShow: false,
		pensionStateDate: getApplicableDateByPensionState($scope.teamMember.Pension),
		openEditTeamMemberPensionWizard,
		openSlideInForm,
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('teamCard', function () {

	return {
		templateUrl: 'components/team-card/teamCard.html',
		replace: true,
		scope: {
			agencyProfileId: '@',
			bulkItems: '=',
			company: '=',
			index: '<',
			onUpdate: '=',
			payPeriod: '<',
			payeDetails: '<',
			teamMember: '='
		},
		controller: 'teamCardController'
	};
})
.controller('teamCardController', [
	'$rootScope',
	'$scope',
	'bulkService',
	'teamData',
	'BUSINESS_TYPES',
	'CORRECTIONAL_SUBMISSION_TYPES',
	'INTERFACE_TYPES',
	'PAYROLL_MOVE_STATUSES',
	function (
		$rootScope,
		$scope,
		bulkService,
		teamData,
		BUSINESS_TYPES,
		CORRECTIONAL_SUBMISSION_TYPES,
		INTERFACE_TYPES,
		PAYROLL_MOVE_STATUSES
	) {

	let agencyProfileId = $scope.agencyProfileId;
	let payPeriodObj = $scope.payPeriod;
	let teamMemberObj = $scope.teamMember;
	let userId = $scope.teamMember.UserID;
	let bulkItems = $scope.bulkItems;

	function decorateTeamMemberObj (teamMemberObj) {

		teamMemberObj.isCompany = teamMemberObj.IsCISSubcontractor && (teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.BusinessDetails.BusinessType === BUSINESS_TYPES.trust);

		return teamMemberObj;
	}

	function hideActionMenu () {

		$scope.vm.showActionMenu = false;
	}

	function init () {

		teamMemberObj = decorateTeamMemberObj(teamMemberObj);

	}

	function onCheckboxToggle () {

		bulkItems = bulkService.updateBulkItemTotals(bulkItems);
	}

	function onTeamMemberDelete () {

		if (angular.isFunction($scope.onUpdate)) {
			$scope.onUpdate();
		}
	}

	function openAddAChangeForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUserByObject,
			contextType: 'user',
			formKey: 'add-a-change',
			payPeriodId: payPeriodObj.PayPeriodID,
			userId: userId
		});
	}

	function openAdvanceFuturePeriodsForm (currentPayPeriodObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'advance-future-periods',
			userId,
			currentPayPeriod: currentPayPeriodObj
		});
	}

	function openAttachmentOfEarningsForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'attachment-of-earnings',
			userId: userId
		});
	}

	function openCancelRejoinLeaver () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'cancel-rejoin-leaver',
			userId: userId,
		});
	}

	function openChangeAdminStateForm (isExcluding) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'change-admin-state',
			userId: userId,
			isExcluding: isExcluding
		});
	}

	function openDeleteTeamMemberForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: onTeamMemberDelete,
			contextType: 'user',
			formKey: 'delete-team-member',
			userId: userId
		});
	}

	function openCorrectionalSubmissionForm (correctionalSubmissionType) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			correctionalSubmissionType: correctionalSubmissionType,
			formKey: 'correctional-submission',
			title: correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.YTDFPS ? 'Submit Earlier Year FPS' : 'Earlier year update',
			userId: userId,
			userIds: [userId]
		});
	}

	function openInviteToRegisterForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'invite-to-register',
			userId: userId
		});
	}

	function openMaternityPayForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'maternity-pay',
			userId: userId
		});
	}

	function openNewAdminForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'new-admin',
			userId: userId
		});
	}

	function openOnHoldForm (teamMemberObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'on-hold',
			userId: userId,
			isOnHold: teamMemberObj.IsOnHold,
			title: teamMemberObj.IsOnHold ? 'Mark as ‘Active on payroll’' : 'Mark as ‘On hold’'
		});
	}

	function openPaternityPayForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'paternity-pay',
			userId: userId
		});
	}

	function openPayInformationForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'pay-information',
			payeDetails: $scope.payeDetails,
			userId: userId
		});
	}

	function openRepaymentScheduleForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'repayment-schedules',
			userId: userId
		});
	}

	function openSickPayForm () {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'sick-pay',
			userId: userId
		});
	}

	function openSlideInForm (formOptionsObj) {

		hideActionMenu();

		$rootScope.openSlideInForm(formOptionsObj);
	}

	function openSupplementaryPayRunForm (teamMemberObj) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			availableWhenTeamMemberIsAdvancingOrAdvanced: false,
			callback: callbackObj => {

				// Only refresh team if leavers have been submitted in Sup. Run
				if (callbackObj && (callbackObj.hasSubmittedLeavers || callbackObj.hasSubmittedStarters)) {

					if (angular.isFunction($scope.onUpdate)) {
						$scope.onUpdate();
					}
				}
			},
			formKey: 'supplementary-pay-run',
			teamMember: teamMemberObj,
			userIds: [userId]
		});
	}

	function openUnmarkAsAdvancingForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'unmark-as-advancing',
			userId
		});
	}

	function openUnmarkAsLeaverForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'unmark-as-leaver',
			userId: userId
		});
	}

	function openUnregisterUserForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: updateUser,
			contextType: 'user',
			formKey: 'unregister-user',
			userId: userId
		});
	}

	function openUpdateLeaverStatusForm (forUpdate) {

		openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: () => {

				if (angular.isFunction($scope.onUpdate)) {
					$scope.onUpdate();
				}
			},
			contextType: 'user',
			formKey: 'update-leaver-status',
			forUpdate: forUpdate,
			title: forUpdate ? 'Edit leaver information' : 'Mark as leaver',
			userId: userId
		});
	}

	function updateUser (userId) {

		teamData.getUserAgencyProfileForAgencyTeamMember(userId, agencyProfileId).then(function (teamMemberObj) {

			$scope.teamMember = decorateTeamMemberObj(teamMemberObj);

			$scope.onUpdate({
				userId: userId,
				updatedTeamMemberObj: teamMemberObj
			});
		})
		.catch(function () {
			$scope.pageState = 'error';
		});
	}

	function updateUserByObject (responseObj) {

		updateUser(responseObj.userId);
	}

	init();

	$scope.INTERFACE_TYPES = INTERFACE_TYPES;
	$scope.agencyProfileId = agencyProfileId;
	$scope.vm = {
		showActionMenu: false
	};

	angular.extend($scope, {
		CORRECTIONAL_SUBMISSION_TYPES,
		PAYROLL_MOVE_STATUSES,

		// Functions
		onCheckboxToggle,
		openAddAChangeForm,
		openAdvanceFuturePeriodsForm,
		openAttachmentOfEarningsForm,
		openCancelRejoinLeaver,
		openChangeAdminStateForm,
		openCorrectionalSubmissionForm,
		openDeleteTeamMemberForm,
		openInviteToRegisterForm,
		openMaternityPayForm,
		openNewAdminForm,
		openOnHoldForm,
		openPaternityPayForm,
		openPayInformationForm,
		openRepaymentScheduleForm,
		openSickPayForm,
		openSupplementaryPayRunForm,
		openUnmarkAsAdvancingForm,
		openUnmarkAsLeaverForm,
		openUnregisterUserForm,
		openUpdateLeaverStatusForm
	});
}]);

'use strict';

angular.module('paycircleApp')
	.directive('teamMemberCarousel', function () {
		return {
			templateUrl: 'components/team-member-carousel/teamMemberCarouselComponent.html',
			controller: 'TeamMemberCarouselCtrl',
			replace: true,
			restrict: 'E',
			scope: {
				activeTeamMemberUserId: '@',
				teamMembers: '=',
				onTeamMemberChange: '=?',
				functions: '='
			}
		};
	})
	.controller('TeamMemberCarouselCtrl', ['$scope', '$timeout', function ($scope, $timeout) {

		var activeTeamMemberUserId = $scope.activeTeamMemberUserId;
		var onTeamMemberChange = $scope.onTeamMemberChange;
		var teamMembers = $scope.teamMembers;

		function getActiveTeamMemberIndex (teamMembers) {

			return teamMembers.findIndex(function (teamMember) {
				return teamMember.PersonalDetails.UserID === activeTeamMemberUserId;
			});
		}

		function init () {

			var activeTeamMemberIndex = getActiveTeamMemberIndex(teamMembers);

			if ($scope.functions) {
				$scope.functions.nextMember = function () {
					goToNextTeamMember($scope.activeTeamMemberIndex);
				};
				$scope.functions.previousMember = function () {
					goToPreviousTeamMember($scope.activeTeamMemberIndex);
				};
			}

			setActiveTeamMember(activeTeamMemberIndex);
		}

		function setActiveTeamMember (activeTeamMemberIndex) {

			var activeTeamMember = teamMembers[activeTeamMemberIndex];

			$scope.activeTeamMember = activeTeamMember;
			$scope.activeTeamMemberIndex = activeTeamMemberIndex;

			if (angular.isFunction(onTeamMemberChange)) {
				onTeamMemberChange(activeTeamMember.PersonalDetails.UserID);
			}
		}

		function goToNextTeamMember (activeTeamMemberIndex) {
			$scope.carouselState = 'closeNext';

			$timeout(function () {
				$scope.carouselState = 'next';
				setActiveTeamMember(activeTeamMemberIndex + 1);
			}, 250);
		}

		function goToPreviousTeamMember (activeTeamMemberIndex) {

			$scope.carouselState = 'closePrevious';

			$timeout(function () {
				$scope.carouselState = 'previous';
				setActiveTeamMember(activeTeamMemberIndex - 1);
			}, 250);
		}

		init();

		$scope.numberOfTeamMembers = teamMembers.length - 1;

		$scope.goToNextTeamMember = function (activeTeamMemberIndex) {

			goToNextTeamMember(activeTeamMemberIndex);
		};

		$scope.goToPreviousTeamMember = function (activeTeamMemberIndex) {

			goToPreviousTeamMember(activeTeamMemberIndex);
		};
	}]);

'use strict';

angular.module('paycircleApp')

.component('teamMemberCard', {
	bindings: {
		agencyProfileId: '=',
		teamMember: '<',
		info: '<?'
	},
	controller: 'teamMemberCtrl',
	templateUrl: 'components/team-member-card/team-member-card.component.html'
})
.controller('teamMemberCtrl', [
	'$state',
function (
	$state
) {

	const $ctrl = this;

	function goToProfile (teamMemberObj, ctrlObj) {
		$state.go('team.profile.overview', {agencyProfileId: ctrlObj.agencyProfileId, userId: teamMemberObj.UserID});
	}

	angular.extend($ctrl, {
		goToProfile
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('teamMemberState', [
	'utilities',
function (
	utilities
) {

	return {
		controller: 'teamMemberStateCtrl',
		templateUrl: 'components/team-member-state/teamMemberState.html',
		replace: true,
		scope: {
			onStateClick: '&?',
			teamMember: '='
		},
		link: function ($scope) {

			function getToolTipForState (teamMember, teamMemberStateSource) {

				// Create tooltip text here for 'ADVANCING' cheese
				if (teamMember.IsAdvancingFuturePeriods) {
					return `Advancing ${utilities.getNumberText(teamMemberStateSource.AdvancePeriodsCount)} period${teamMemberStateSource.AdvancePeriodsCount > 1 ? 's ' : ' '} when payroll is run for ${teamMemberStateSource.AdvancePeriodsStartPeriodDisplay}`;
				}

				// Create tooltip text here for 'ADVANCING' cheese
				if (teamMember.HasAdvancedFuturePeriods) {
					return `Will be added to payroll after the ${teamMemberStateSource.AdvancePeriodsEndPeriodDisplay} period is finalised`;
				}
			}

			function setupTeamMember (teamMember) {

				// Determine where the status info lives. Depends on where this teamMember object came from.
				let teamMemberStateSource;

				// Map specific attributes to object returned from GetTeamMemberInformation
				if (teamMember.Company !== undefined) {
					teamMemberStateSource = teamMember.Company;
					teamMember.ExcludeFromPayroll 		= teamMemberStateSource.ExcludeFromPayroll;
					teamMember.IsFurloughed 			= teamMemberStateSource.IsFurloughed && !teamMember.Company.IsFurloughedEnded;
					teamMember.IsLeaver 				= teamMemberStateSource.IsLeaver;
					teamMember.IsOnHold					= teamMemberStateSource.IsOnHold;
					teamMember.IsExcludedFromRTI		= teamMemberStateSource.IsExcludedFromRTI;
				}

				// Map specific attributes to object returned from GetTeamMembersPayroll
				if (teamMember.PersonalDetails !== undefined) {
					teamMemberStateSource = teamMember.PersonalDetails;
					teamMember.IsFurloughed 			= teamMemberStateSource.IsFurloughed;

				}

				// If source not determined ...
				if (angular.isUndefined(teamMemberStateSource)) {
					// ... attributes all on the TeamMember object ...
					teamMemberStateSource = teamMember;
				}
				else {
					// ... otherwise copy the common stuff from the source to the top level team member object
					teamMember.IsCISInactive 			= teamMemberStateSource.IsCISInactive;
					teamMember.IsAdmin 					= teamMemberStateSource.IsAdmin;
					teamMember.IsCISSubcontractor 		= teamMemberStateSource.IsCISSubcontractor;
					teamMember.IsLeaving 				= teamMemberStateSource.IsLeaving;
					teamMember.IsOffPayrollWorker   	= teamMemberStateSource.IsOffPayrollWorker;
					teamMember.IsRegistered 			= teamMemberStateSource.IsRegistered;
					teamMember.IsStarter 				= teamMemberStateSource.IsStarter;
					teamMember.IsRestarter 				= teamMemberStateSource.IsRestarter;
					teamMember.IsAdvancingFuturePeriods	= teamMemberStateSource.IsAdvancingFuturePeriods;
					teamMember.HasAdvancedFuturePeriods	= teamMemberStateSource.HasAdvancedFuturePeriods;
				}

				// Attach tooltip for certain states
				teamMember.StateTooltipText = getToolTipForState(teamMember, teamMemberStateSource);

				// Map setup complete
				if (teamMember.TeamMemberSetupComplete !== undefined) {
					teamMember.IsComplete = teamMember.TeamMemberSetupComplete;
				}

				return teamMember;
			}

			$scope.teamMember = setupTeamMember($scope.teamMember);

			// Watcher for when team member is updated
			$scope.$watch('teamMember', function (updatedTeamMemberObj) {

				$scope.teamMember = setupTeamMember(updatedTeamMemberObj);
			});

			$scope.stateClick = function (state) {

				$scope.teamMember.clickedState = state;
				$scope.onStateClick();
			};
		}
	};
}])

.controller('teamMemberStateCtrl', [
	'$scope',
	'utilities',
	'PAYROLL_MOVE_STATUSES',
function (
	$scope,
	utilities,
	PAYROLL_MOVE_STATUSES
) {

	angular.extend($scope, {
		PAYROLL_MOVE_STATUSES,
		utilities
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('teamPaymentInfo', {
	controller: 'teamPaymentInfoController',
	templateUrl: 'components/team-payment-info/teamPaymentInfoComponent.html',
	bindings: {
		agencyProfileId: '<',
		onClose: '&'
	}
})
.controller('teamPaymentInfoController', ['$timeout', 'teamData', function ($timeout, teamData) {

	const INCLUDE_LEAVERS = false;

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum($ctrl.agencyProfileId, INCLUDE_LEAVERS).then(teamMembersArr => {

			$ctrl.teamMembers = teamMembersArr;

			selectActiveTeamMember($ctrl, 0);
			setComponentState('ready');
		})
		.catch(error => {
			setComponentState('error');
			console.error(error);
		});
	}

	function selectActiveTeamMember ($ctrl, index) {

		setTeamMemberState('loading');

		angular.extend($ctrl.formOptions, {
			isOpen: false,
			formKey: null
		});

		$ctrl.activeTeamMember = angular.copy($ctrl.teamMembers[index]);

		$timeout(() => {
			$ctrl.formOptions = {
				agencyProfileId: $ctrl.agencyProfileId,
				callback: $onInit,
				context: $ctrl.activeTeamMember,
				contextType: 'user',
				formKey: 'payments-to-date',
				isOpen: true,
				userId: $ctrl.activeTeamMember.UserID
			};
		});

		setTeamMemberState($ctrl, 'ready');
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setTeamMemberState ($ctrl, teamMemberState) {

		$ctrl.teamMemberState = teamMemberState;
	}

	angular.extend($ctrl, {
		$onInit,
		formOptions: {
			isOpen: false,
		},
		selectActiveTeamMember
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('teamPensionInfo', {

	controller: 'teamPensionInfoController',
	templateUrl: 'components/team-pension-info/team-pension-info.component.html',
	bindings: {
		agencyProfileId: '<',
		onClose: '&'
	}
})
.controller('teamPensionInfoController', ['$rootScope', '$scope', 'teamData', function ($rootScope, $scope, teamData) {

	const INCLUDE_LEAVERS = false;

	const $ctrl = this;

	function init () {

		setComponentState('loading');

		teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum($ctrl.agencyProfileId, INCLUDE_LEAVERS).then(teamMembersArr => {

			$ctrl.teamMembers = teamMembersArr;

			selectActiveTeamMember($ctrl, $ctrl.teamMembers, 0);
			setComponentState('ready');
		})
		.catch(error => {
			setComponentState('error');
			console.error(error);
		});
	}

	function selectActiveTeamMember ($ctrl, index) {

		setTeamMemberState($ctrl, 'loading');

		// Hook up GetPensionInfo service to return pension details
		$ctrl.activeTeamMember = angular.copy($ctrl.teamMembers[index]);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setTeamMemberState ($ctrl, teamMemberState) {

		$ctrl.teamMemberState = teamMemberState;
	}

	init();

	angular.extend($ctrl, {
		selectActiveTeamMember
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('teamSummaryRow', {
	bindings: {
		index: '<?',
		showContent: '<?',
		showFooter: '<?',
		teamMember: '=',
		theme: '@?'
	},
	controller: 'teamSummaryRowCtrl',
	templateUrl: 'components/team-summary-row/team-summary-row.component.html',
	transclude: {
		'actions': '?tsrActions',
		'footer': '?tsrFooter',
	}
})
.controller('teamSummaryRowCtrl', [
	'$transclude',
	function (
		$transclude
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		angular.extend($ctrl, {
			hasActions: $transclude.isSlotFilled('actions'),
			hasFooter: $transclude.isSlotFilled('footer'),
			showContent: angular.isDefined($ctrl.showContent) ? $ctrl.showContent : true,
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('tooltipCard', {
	controller: 'tooltipCardCtrl',
	templateUrl: 'components/tooltip-card/tooltip-card.component.html'
})
.controller('tooltipCardCtrl', [
	'$filter',
	'$rootScope',
	function (
		$filter,
		$rootScope
	) {

	const $ctrl = this;

	$rootScope.$on('toggle-tooltip-card', (event, tooltipObj) => {

		// Tooltip is already closed
		if (angular.isUndefined(tooltipObj)) {
			return;
		}

		// Same tooltip clicked, so close
		if (isSameTooltipClicked(tooltipObj)) {
			closeTooltipCard($ctrl);
			return;
		}

		angular.extend(tooltipObj, {
			id: getTooltipId(tooltipObj),
			size: angular.isDefined(tooltipObj.size) ? tooltipObj.size : 'is-medium'
		});

		$ctrl.tooltip = tooltipObj;
	});

	$rootScope.$on('close-tooltip-card', () => {
		closeTooltipCard($ctrl);
	});

	function closeTooltipCard ($ctrl) {

		$ctrl.tooltip = null;
	}

	/**
	 * Dynamically generate a tooltip ID so it can be compared to add ability to toggle off tooltip from the trigger action
	**/
	function getTooltipId (tooltipObj) {

		// 1. Custom id defined
		if (angular.isDefined(tooltipObj.id)) {
			return tooltipObj.id;
		}

		// 2. Slugify heading
		if (angular.isDefined(tooltipObj.heading)) {
			return $filter('slugify')(tooltipObj.heading);
		}

		// 3. Slugify description
		if (angular.isDefined(tooltipObj.description)) {
			return $filter('slugify')(tooltipObj.description);
		}

		return;
	}

	function isSameTooltipClicked (tooltipObj) {

		// No new tooltip or exsiting tooltip
		if (!tooltipObj || !$ctrl.tooltip) {
			return false;
		}

		// Tooltip ID is not defined
		if (angular.isUndefined(tooltipObj.id)) {
			return false;
		}

		// Exsiting tooltip id doesn't match new tooltip ID
		if (tooltipObj.id !== $ctrl.tooltip.id) {
			return false;
		}

		return true;
	}

	angular.extend($ctrl, {
		closeTooltipCard
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('tooltipDemo', function () {

	return {
		restrict: 'A',
		templateUrl: 'components/tooltip-demo/tooltipDemoComponent.html',
		scope: {
			tdId: '@',
			tdActive: '=?'
		},
		transclude: true,
		controller: 'tooltipDemoCtrl'
	};
})
.controller('tooltipDemoCtrl', ['$element', '$scope', '$timeout', 'COMPANY_STATES', 'DEMO_TASKS_SHORT', 'session', 'TOOLTIPS', function ($element, $scope, $timeout, COMPANY_STATES, DEMO_TASKS_SHORT, session, TOOLTIPS) {

	function init () {

		var activeDemoTaskId = session.getActiveDemoTaskId();

		if (!activeDemoTaskId || !$scope.tdId) {
			$scope.showTooltip = false;
			return;
		}

		for (var demoId of $scope.tdId.split(',')) {
			if (demoId === activeDemoTaskId) {
				$scope.tdId = demoId;
			}
		}

		$scope.tooltipId = DEMO_TASKS_SHORT[$scope.tdId];
		$scope.tooltip = TOOLTIPS.demo[$scope.tooltipId];
		$scope.showTooltip = $scope.tdId === activeDemoTaskId ? true : false;
		$scope.tdActive = $scope.tdActive !== undefined ? $scope.tdActive : true;

		if ($scope.showTooltip) {
			$timeout(function() {

				$element[0].scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			}, 100);
		}
	}

	init();

	$scope.hideTooltip = function () {

		$scope.showTooltip = false;
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('tooltipPlus', function () {

	return {
		restrict: 'A',
		templateUrl: 'components/tooltip-plus/tooltipPlusComponent.html',
		scope: {
			tpOnClick: '&?',
			tpOptions: '='
		},
		controller: 'tooltipPlusCtrl'
	};
})
.controller('tooltipPlusCtrl', ['$rootScope', '$scope', 'config', 'utilities', 'LOCAL_STORAGE_KEYS', function ($rootScope, $scope, config, utilities, LOCAL_STORAGE_KEYS) {

	var agencyProfileId = $rootScope.currentCompany.AgencyProfileID;

	if (!$scope.tpOptions) {
		return;
	}

	function init () {

		if ($scope.tpOptions.showTooltip && $scope.tpOptions.neverOpenAgain) {
			$scope.showTooltip = !utilities.checkStoredArray(LOCAL_STORAGE_KEYS.closedTooltips, $scope.tpOptions.neverOpenAgain, agencyProfileId);

		} else if ($scope.tpOptions.showTooltip && !$scope.tpOptions.neverOpenAgain) {
			$scope.showTooltip = true;

		}
	}

	init();

	function hideTooltip () {

		$scope.showTooltip = false;
		if ($scope.tpOptions.neverOpenAgain) {
			utilities.addToStoredArray(LOCAL_STORAGE_KEYS.closedTooltips, $scope.tpOptions.neverOpenAgain, agencyProfileId);

		}
		$scope.tpOptions.showTooltip = false;
	}

	$scope.buttonClick = function ($event) {

		$event.stopImmediatePropagation();

		if (angular.isDefined($scope.tpOnClick)) {
			$scope.tpOnClick();
		}

		hideTooltip();
	};

	$scope.hideTooltip = function () {

		hideTooltip();
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('truncate', {
	bindings: {
		id: '@?',
		text: '<',
		truncateAmount: '@',
		onEmptyDisplay: '@'
	},
	controller: 'truncateComponentCtrl',
	templateUrl: 'components/truncate/truncate.component.html'
})
.controller('truncateComponentCtrl', [
	'$filter',
	function (
		$filter
	) {

	const $ctrl = this;

	const DEFAULT_ON_EMPTY_DISPLAY = '';
	const DEFAULT_TRUNCATED_AMOUNT = 25;

	function $onInit () {

		angular.extend($ctrl, {
			truncatedText: getTruncatedText($ctrl)
		});
	}

	function getTruncatedText ($ctrl) {

		// Empty
		if (angular.isUndefined($ctrl.text) || $ctrl.text === '') {
			return angular.isDefined($ctrl.onEmptyDisplay) ? $ctrl.onEmptyDisplay : DEFAULT_ON_EMPTY_DISPLAY;
		}

		// Truncate
		$ctrl.truncateAmount = angular.isDefined($ctrl.truncateAmount) ? $ctrl.truncateAmount : DEFAULT_TRUNCATED_AMOUNT;

		return $filter('truncate')($ctrl.text, $ctrl.truncateAmount);
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('userCard', function () {
	return {
		restrict: 'E',
		templateUrl: 'components/user-card/userCardComponent.html',
		replace: true,
		scope: {
			user: '='
		}
	};
});

'use strict';

angular.module('paycircleApp')
.component('userDocumentCard', {
	bindings: {
		agencyProfileId: '<',
		document: '<',
		documentIndex: '<',
		onUpdate: '=',
		userId: '<'
	},
	controller: 'userDocumentCardCtrl',
	templateUrl: 'components/user-document-card/user-document-card.component.html',
})
.controller('userDocumentCardCtrl', [
	'$rootScope',
	'dataTransfer',
	'utilities',
	'UPLOADS_DOCUMENTS_FORMS',
	'USER_DOCUMENT_STATES',
	function (
		$rootScope,
		dataTransfer,
		utilities,
		UPLOADS_DOCUMENTS_FORMS,
		USER_DOCUMENT_STATES
	) {

	const $ctrl = this;

	function getDecoratedDocument (documentObj) {
		return angular.extend(documentObj, {
			AgencyDocumentID: documentObj.UserDocumentID,
			DocumentName: documentObj.UserDocumentName,
			DocumentSize: documentObj.UserDocumentSize,
			DocumentTypeID: documentObj.UserDocumentTypeID,
			MIMEFormat: utilities.getMimeFormatFromDocumentName(documentObj.UserDocumentName)
		});
	}

	function getUploadDocumentsFormTitle (formState) {

		switch (formState) {
			case UPLOADS_DOCUMENTS_FORMS.deleteFile:
				return 'Delete document';

			case UPLOADS_DOCUMENTS_FORMS.editFile:
				return 'Document settings';
		}
	}

	function hideMenu ($ctrl) {
		$ctrl.menuShow = false;
	}

	function openUploadDocumentsForm ($ctrl, formState) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			document: getDecoratedDocument($ctrl.document),
			formKey: 'user-documents',
			formState: formState,
			title: getUploadDocumentsFormTitle(formState),
			userId: $ctrl.userId
		});
	}

	angular.extend($ctrl, {
		UPLOADS_DOCUMENTS_FORMS,
		USER_DOCUMENT_STATES,

		downloadFile: dataTransfer.downloadFile,
		hideMenu,
		openUploadDocumentsForm,

		menuShow: false
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('userGuideCard', ['utilities', 'USER_GUIDES', function (utilities, USER_GUIDES) {
	return {
		restrict: 'E',
		templateUrl: 'components/user-guide-card/userGuideCardComponent.html',
		replace: true,
		scope: {
			guideId: '@'
		},
		link: function ($scope) {

			$scope.userGuide = USER_GUIDES[$scope.guideId];
		}
	};
}]);
'use strict';

angular.module('paycircleApp')
.directive('userImporterStatusBlock', function () {
	return {
		templateUrl: 'components/user-importer-status-block/userImporterStatusBlockComponent.html',
		controller: 'userImporterStatusBlockCtrl',
		scope: {
			agencyProfileId: '=',
			payPeriod: '=',
			userImportVisible: '=',
			showPeriodInfo: '@?',
			reloadOnComplete: '=?',
			returnState: '=?'
		},
		link: function ($scope) {

			// Defaults
			$scope.showPeriodInfo 	= $scope.showPeriodInfo !== undefined ? $scope.showPeriodInfo : false;
			$scope.reloadOnComplete = $scope.reloadOnComplete !== undefined ? $scope.reloadOnComplete : false;
			$scope.returnState 		= $scope.returnState !== undefined ? $scope.returnState : 'payroll';
		}
	};
})

.controller('userImporterStatusBlockCtrl', ['$rootScope', '$scope', 'growl', '$timeout', '$state', '$q', 'agency', 'dataImport', 'importService', 'payrollData', 'payrollWorker', 'STATE_TYPES', 'SUBMISSION_STATES', function ($rootScope, $scope, growl, $timeout, $state, $q, agency, dataImport, importService, payrollData, payrollWorker, STATE_TYPES, SUBMISSION_STATES) {

	var agencyProfileId = $scope.agencyProfileId;
	var payPeriod = $scope.payPeriod;
	var pollDelay = 3; // seconds
	var timerId = null;

	function checkDataImportState (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		agency.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.dataimport).then(function (updatedDataImportState) {

			// Update scope
			payPeriod.DataImportState = updatedDataImportState;

			switch (updatedDataImportState) {
				case SUBMISSION_STATES.submitting:
					timerId = $timeout(function () {
						checkDataImportState(payPeriod);
					}, pollDelay * 1000);
					break;
				case SUBMISSION_STATES.submitted:
					$scope.dataImportFinished = true;
					break;
				case SUBMISSION_STATES.failed:
					growl.error('There was a problem importing the shifts');
					break;
			}
		});
	}

	function checkPayPeriodImportWorkerStatus (payPeriod) {

		var payPeriodId = payPeriod.PayPeriodID;

		if (payPeriod.WorkerImportState > SUBMISSION_STATES.unsubmitted) {

			// Get state for worker import
			payrollData.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.workerimport).then(function (workerImportState) {

				// Update pay period value
				payPeriod.WorkerImportState = workerImportState;

				switch (workerImportState) {
					case SUBMISSION_STATES.submitting:
					case SUBMISSION_STATES.processing1:
					case SUBMISSION_STATES.processing2:

						timerId = $timeout(function () {
							checkPayPeriodImportWorkerStatus(payPeriod);
						}, pollDelay * 1000);
						break;

					case SUBMISSION_STATES.haserrors1:
					case SUBMISSION_STATES.haserrors2:

						dataImport.getUserImportValidationResults(payPeriod.PayPeriodID).then(function (invalidWorkers) {

							var validationResults = importService.getValidationResults(invalidWorkers);

							$scope.numberOfIssues = validationResults.length;
						});

						break;

					case SUBMISSION_STATES.verified:

						// Get number of imports
						dataImport.getNumberOfUserImportsByOwner(payPeriodId).then(function (numberOfImports) {

							$scope.numberOfWorkers = numberOfImports;

							if (numberOfImports === 0) {
								payPeriod.WorkerImportState = SUBMISSION_STATES.finished;
							}
						});

						// Get number of invalid results
						dataImport.getUserImportValidationResults(payPeriodId).then(function (invalidWorkers) {

							// Re-map Invalid Workers array into results array
							var validationResults = importService.getValidationResults(invalidWorkers);

							// Scope
							$scope.numberOfIgnored = importService.getNumberOfSkippedResults(validationResults);
						});

						break;

					case SUBMISSION_STATES.finished:

						checkDataImportState(payPeriod);

						break;
				}
			})
			.catch(function () {
				growl.error('There was a problem getting the status of the import');
			});
		}
	}

	function init () {

		// Import state (locked if importing or deleting)
		$scope.importLocked = payPeriod.DataImportState === SUBMISSION_STATES.submitting || payPeriod.DataDeletionState === SUBMISSION_STATES.submitting;

		// Check import status
		checkPayPeriodImportWorkerStatus(payPeriod);
	}

	init();

	// Scope constants
	$scope.SUBMISSION_STATES = SUBMISSION_STATES;

	// Scope variables
	$scope.agencyProfileId = agencyProfileId;
	$scope.modal = {
		cancelImport: false,
		undoImport: false
	};
	$scope.numberOfIssues = 0;
	$scope.numberOfIgnored = 0;

	// Scope functions
	$scope.openCancelImportForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'cancel-user-import'
		});
	};

	$scope.openUndoImportForm = function () {

		$rootScope.openSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'undo-import'
		});
	};

	$scope.$on('$destroy', function () {
		$timeout.cancel(timerId);
	});

}]);

'use strict';

angular.module('paycircleApp')
	.component('valueCard', {
		bindings: {
			theme: '@',
			title: '@',
			value: '=',
			zeroValueText: '@?'
		},
		templateUrl: 'components/value-card/value-card.component.html'
	});

'use strict';

angular.module('paycircleApp')
.component('weeklyCalendar', {
	controller: 'weeklyCalendarCtrl',
	controllerAs: 'vm',
	bindings: {
		isPreview: '<',
		payPeriod: '<',
		workPatterns: '=?',
	},
	templateUrl: 'components/weekly-calendar/weekly-calendar.component.html'
})
.controller('weeklyCalendarCtrl', ['dateService', function (dateService) {

	const $ctrl = this;

	function buildCalendar (payPeriodObj, monthIterator) {

		const monthDatesObj = getMonthDates(payPeriodObj, monthIterator);
		
		const calendarMonthDatesArr = dateService.getDateRangeForWeeklyCalendar(monthDatesObj.startDateIso, monthDatesObj.endDateIso);
		const calendarDatesArr = getWorkPatternCalendarDates(calendarMonthDatesArr);
		
		$ctrl.calendar = {
			days: calendarDatesArr,
			month: monthDatesObj,
			monthIterator: monthIterator
		};
	}

	function decrementMonth (payPeriodObj, calendarObj) {

		calendarObj.monthIterator--;

		buildCalendar(payPeriodObj, calendarObj.monthIterator);
	}

	function getWorkPatternCalendarDates (calendarMonthDatesArr) {

		return dateService.getCalendarDatesForWorkPatterns($ctrl.workPatterns, $ctrl.payPeriod, calendarMonthDatesArr);
	}

	function getMonthDates (payPeriodObj, iterator) {

		var monthStartDateM;
		var monthEndDateM;

		// Set initial date
		if (!angular.isUndefined(iterator)) {
			monthStartDateM = moment(payPeriodObj.StartDateISO).add(iterator, 'months').startOf('month');
			monthEndDateM = moment(payPeriodObj.StartDateISO).add(iterator, 'months').endOf('month');
		}

		return {
			activeMonthNumber: monthStartDateM.format('M'),
			description: '1 - ' + monthEndDateM.format('D MMMM YYYY'),
			startDateIso: monthStartDateM.format(),
			endDateIso: monthEndDateM.format()
		};
	}

	function incrementMonth (payPeriodObj, calendarObj) {

		calendarObj.monthIterator++;

		buildCalendar(payPeriodObj, calendarObj.monthIterator);
	}

	$ctrl.$onInit = function () {

		$ctrl.isPreview = angular.isDefined($ctrl.isPreview) ? $ctrl.isPreview : false;

		buildCalendar($ctrl.payPeriod, 0);
	};

	angular.extend($ctrl, {
		decrementMonth,
		incrementMonth
	});
	
}]);

'use strict';

angular.module('paycircleApp')
.component('workPatternBuilder', {
	bindings: {
		onUpdate: '&',
		required: '<?',
		theme: '@',
		workPattern: '='
	},
	controller: 'workPatternBuilderCtrl',
	controllerAs: 'vm',
	require: {
		form: '^form'
	},
	templateUrl: 'components/work-pattern-builder/work-pattern-builder.component.html'
})
.controller('workPatternBuilderCtrl', ['$scope', 'workPatternService', 'WORK_PATTERN_BASIS', 'WORK_PATTERN_DAY_TYPES', 'WORK_PATTERN_GROUPS', function ($scope, workPatternService, WORK_PATTERN_BASIS, WORK_PATTERN_DAY_TYPES, WORK_PATTERN_GROUPS) {

	const MAX_WORK_PATTERN_DAYS = 56;
	const MAX_WORK_PATTERN_HOURS = 24;
	const MAX_WORK_PATTERN_WEEKS = 8;
	const STEP_COUNT = 0.25;

	const $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.workPattern = workPatternService.decorateWorkPattern($ctrl.workPattern);
	};

	function addWorkPatternDay (vmObj) {

		var newDayObj = angular.copy(vmObj.workPattern.Days[vmObj.workPattern.Days.length - 1]);

		vmObj.workPattern.Days.push(newDayObj);
	}

	function addWorkPatternWeek (vmObj) {

		var newWeekArr = angular.copy(vmObj.workPattern.weeks[vmObj.workPattern.weeks.length - 1]);

		vmObj.workPattern.weeks.push(newWeekArr);

		updateDays(vmObj);
	}

	function decrementValue (dayObj, vmObj) {

		if (dayObj.Hours - STEP_COUNT < 0) {
			dayObj.Hours = 0;
		}
		else {
			dayObj.Hours = dayObj.Hours - STEP_COUNT;
		}

		// Round to 2 decimal places to prevent floating-point precision errors
		dayObj.Hours = Math.round(dayObj.Hours * 100) / 100;

		// Weekly conversion needs to happen
		if (angular.isDefined(vmObj)) {
			updateDays(vmObj);
		}
	}

	function deleteWorkPatternDay (vmObj, index) {

		vmObj.workPattern.Days.splice(index, 1);
	}

	function deleteWorkPatternWeek (vmObj, index) {

		vmObj.workPattern.weeks.splice(index, 1);

		updateDays(vmObj);
	}

	function incrementValue (dayObj, vmObj) {

		if (dayObj.Hours + STEP_COUNT > MAX_WORK_PATTERN_HOURS) {
			dayObj.Hours = MAX_WORK_PATTERN_HOURS;
		}
		else {
			dayObj.Hours = dayObj.Hours + STEP_COUNT;
		}

		// Round to 2 decimal places to prevent floating-point precision errors
		dayObj.Hours = Math.round(dayObj.Hours * 100) / 100;

		// Weekly conversion needs to happen
		if (angular.isDefined(vmObj)) {
			updateDays(vmObj);
		}
	}

	function updateDays (vmObj) {

		// Round day hours to 2 decimal places to match database DECIMAL(9,2) precision
		if (vmObj.workPattern.weeks) {
			vmObj.workPattern.weeks.forEach(function (week) {
				week.forEach(function (day) {
					if (day.Hours !== undefined && day.Hours !== null) {
						day.Hours = Math.round(day.Hours * 100) / 100;
					}
				});
			});
		}
		if (vmObj.workPattern.Days) {
			vmObj.workPattern.Days.forEach(function (day) {
				if (day.Hours !== undefined && day.Hours !== null) {
					day.Hours = Math.round(day.Hours * 100) / 100;
				}
			});
		}

		workPatternService.updateDays(vmObj.workPattern);

		if (angular.isFunction(vmObj.onUpdate)) {
			vmObj.onUpdate();
		}
	}

	function hasValidHours(vmObj) {
		return vmObj.workPattern.Days.every(function(day) {
			return day.hasOwnProperty('Hours') && day.Hours >= 0;
		});
	}

	angular.extend($scope, {
		MAX_WORK_PATTERN_DAYS,
		MAX_WORK_PATTERN_HOURS,
		MAX_WORK_PATTERN_WEEKS,
		WORK_PATTERN_DAY_TYPES,
		WORK_PATTERN_GROUPS,
		WORK_PATTERN_BASIS,
		addWorkPatternDay,
		addWorkPatternWeek,
		decrementValue,
		deleteWorkPatternDay,
		deleteWorkPatternWeek,
		hasValidHours,
		incrementValue,
		updateDays
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('workPatternCard', {
	bindings: {
		agencyProfileId: '<',
		canDelete: '=?',
		workPattern: '<',
		onUpdate: '=?'
	},
	controller: 'workPatternCardCtrl',
	controllerAs: 'vm',
	templateUrl: 'components/work-pattern-card/work-pattern-card.component.html'
})
.controller('workPatternCardCtrl', ['$rootScope', '$scope', 'workPatternService', 'WORK_PATTERN_BASIS', 'WORK_PATTERN_DAY_TYPES', 'WORK_PATTERN_GROUPS', function ($rootScope, $scope, workPatternService, WORK_PATTERN_BASIS, WORK_PATTERN_DAY_TYPES, WORK_PATTERN_GROUPS) {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.canDelete = angular.isUndefined($ctrl.canDelete) ? true : $ctrl.canDelete;
		$ctrl.workPattern = workPatternService.decorateWorkPattern($ctrl.workPattern);
	};

	function openWorkPatternForm (workPatternObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'work-pattern',
			title: workPatternObj !== undefined ? 'Edit work pattern' : 'New work pattern',
			workPatternId: workPatternObj !== undefined ? workPatternObj.WorkPatternID : undefined
		});
	}

	function openWorkPatternTeamMembersForm (workPatternObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'work-pattern-team-members',
			workPatternId: workPatternObj.WorkPatternID
		});
	}

	function openWorkPatternDeleteForm (workPatternObj) {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.agencyProfileId,
			callback: $ctrl.onUpdate,
			formKey: 'work-pattern-delete',
			workPatternId: workPatternObj.WorkPatternID
		});
	}

	angular.extend($scope, {
		WORK_PATTERN_BASIS,
		WORK_PATTERN_DAY_TYPES,
		WORK_PATTERN_GROUPS,
		openWorkPatternForm,
		openWorkPatternDeleteForm,
		openWorkPatternTeamMembersForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('workPatternOverview', {
	bindings: {
		index: '<',
		workPattern: '='
	},
	controller: 'workPatternOverviewCtrl',
	templateUrl: 'components/work-pattern-overview/work-pattern-overview.component.html',
	transclude: {
		'actions': '?wpoActions',
	}
})
.controller('workPatternOverviewCtrl', ['$transclude', 'WORK_PATTERN_GROUPS', function ($transclude, WORK_PATTERN_GROUPS) {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		$ctrl.WORK_PATTERN_GROUPS = WORK_PATTERN_GROUPS;

		$ctrl.hasActions = $transclude.isSlotFilled('actions');
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('workerMail', function () {

    return {
        templateUrl: 'components/worker-mail/workerMailComponent.html',
        replace: true,
        scope: {
        	agencyProfileId: '<',
            mailObject: '=',
            noMailsText: '@'
        },
        controller: 'workerMailController'
    };
})

.controller('workerMailController', ['$scope', function ($scope) {

	$scope.noMailsText = $scope.noMailsText !== undefined ? $scope.noMailsText : 'Not sent yet';
	$scope.showDropdown = false;
	$scope.showMails = true;

	$scope.toggleShowMails = function () {
		$scope.showMails = !$scope.showMails;
	};

	$scope.toggleDropdown = function () {
		$scope.showDropdown = !$scope.showDropdown;
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('workflowActivityLog', function () {

	return {
		controller: 'workflowActivityLogCtrl',
		replace: true,
		restrict: 'E',
		scope: {
			logList: '<',
			searchBarOptions: '<',
			wideView: '<?'
		},
		templateUrl: 'components/workflow-activity-log/workflowActivityLogComponent.html'
	};
})

.controller('workflowActivityLogCtrl', ['$scope', 'bulkService', function ($scope, bulkService) {

	function init() {
		/* This component expects a bulk items object, but it could be just a standard list, in which case generate
		   a bulk items object from it, which will add the objects required the template. */
		if (!$scope.logList.all) {
			$scope.logList = bulkService.getBulkItemsObj($scope.logList);
		}
	}

	init();

	angular.extend($scope, {
		// List of terms to emphasise in the log
		workflowActions: 'ACTIVE COMPLETED STARTED STOPPED QUERIED'
	});
}]);
'use strict';

angular.module('paycircleApp')
.component('workflowDeadlineEntry', {
	bindings: {
		entry: '=',
		entryIndex: '<',
		entries: '<',
		onEntryUpdate: '&'
	},
	controller: 'workflowDeadlineEntryCtrl',
	templateUrl: 'components/workflow-deadline-entry/workflow-deadline-entry.component.html'
})
.controller('workflowDeadlineEntryCtrl', [
	'dateService',
	function (
		dateService
	) {

	const $ctrl = this;

	function isOffsetTypeDisabled () {

		if ($ctrl.entryIndex === 0) {
			return false;
		}

		const templateEntryPreviousObj = $ctrl.entries[$ctrl.entryIndex - 1];

		if (templateEntryPreviousObj.IsAfterPayDay) {
			return true;
		}

		return false;
	}

	function onDueDateChange () {

		$ctrl.onEntryUpdate();
	}

	function onOffsetTypeChange () {

		// Don't do anything for last entry
		if ($ctrl.entry.IsAfterPayDay && $ctrl.entryIndex !== $ctrl.entries.length - 1) {

			// Set all proceeding entries value as the same as this one
			for (let procedingEntryIndex = $ctrl.entryIndex + 1; procedingEntryIndex < $ctrl.entries.length; procedingEntryIndex++) {

				const proceedingEntryObj = $ctrl.entries[procedingEntryIndex];

				if (proceedingEntryObj) {
					proceedingEntryObj.IsAfterPayDay = $ctrl.entry.IsAfterPayDay;
				}
			}
		}

		$ctrl.onEntryUpdate();
	}

	angular.extend($ctrl, {

		hours: dateService.getHours(),
		minutes: dateService.getMinutes(),

		isOffsetTypeDisabled,

		onDueDateChange,
		onOffsetTypeChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('workflowStatusBlock', {
	bindings: {
		templateEntryCurrent: '<'
	},
	controller: 'workflowStatusBlockCtrl',
	templateUrl: 'components/workflow-status-block/workflow-status-block.component.html'
})
.controller('workflowStatusBlockCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			icon: $ctrl.templateEntryCurrent.IsOverdue ? 'warning' : 'clock',
			tagLabel: $ctrl.templateEntryCurrent.IsOverdue ? 'Overdue' : 'Due',
			theme: $ctrl.templateEntryCurrent.IsOverdue ? 'is-assertive' : 'is-positive'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('workflowTimeline', {
	bindings: {
		agencyProfileId: '<',
		onUpdate: '=',
		payPeriod: '<?',
		workflowTemplate: '<'
	},
	controller: 'workflowTimelineCtrl',
	templateUrl: 'components/workflow-timeline/workflow-timeline.component.html',
})
.controller('workflowTimelineCtrl', [
	'$rootScope',
	'WORKFLOW_OFFSET_TYPES',
	function (
		$rootScope,
		WORKFLOW_OFFSET_TYPES
	) {
	
	const $ctrl = this;

	function $onInit () {

		for (let entryObj of $ctrl.workflowTemplate.TemplateEntries) {
			if (entryObj.IsAfterPayDay) {
				$ctrl.entries.afterPayDate.push(entryObj);
			}
			else {
				$ctrl.entries.beforePayDate.push(entryObj);
			}
		}
	}

	function openWorkflowDeadlinesForm(workflowTemplate) {
		$rootScope.openSlideInForm({
			agencyProfileId: workflowTemplate.AgencyProfileID,
			callback: $ctrl.onUpdate,
			formKey: 'workflow-deadlines',
			workflowTemplate: workflowTemplate
		});
	}

	angular.extend($ctrl, {
		$onInit,

		entries: {
			afterPayDate: [],
			beforePayDate: []
		},

		openWorkflowDeadlinesForm,
		WORKFLOW_OFFSET_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('workflowTimelineEntry', {
	bindings: {
		entry: '<',
		onUpdate: '=',
		workflowTemplate: '<'
	},
	controller: 'workflowTimelineEntryCtrl',
	templateUrl: 'components/workflow-timeline-entry/workflow-timeline-entry.component.html',
})
.controller('workflowTimelineEntryCtrl', [
	'$rootScope',
	'WORKFLOW_CALENDAR_TYPES',
	'WORKFLOW_OFFSET_TYPES',
	'WORKFLOW_TEMPLATE_ENTRY_STATES',
	function (
		$rootScope,
		WORKFLOW_CALENDAR_TYPES,
		WORKFLOW_OFFSET_TYPES,
		WORKFLOW_TEMPLATE_ENTRY_STATES
	) {

	const $ctrl = this;

	let NOTE_LENGTH_LIMIT = 80;

	function openWorkflowDeadlinesForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.workflowTemplate.AgencyProfileID,
			callback: $ctrl.onUpdate,
			formKey: 'workflow-deadlines',
			workflowTemplate: $ctrl.workflowTemplate
		});
	}

	function openWorkflowCollaboratorForm () {

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.workflowTemplate.AgencyProfileID,
			callback: $ctrl.onUpdate,
			formKey: 'workflow-collaborator',
			title: 'Assign collaborator',
			workflowTemplateEntry: $ctrl.entry
		});
	}

	function extendNoteLengthLimit () {
		$ctrl.NOTE_LENGTH_LIMIT = null;
	}

	angular.extend($ctrl, {
		NOTE_LENGTH_LIMIT,
		WORKFLOW_CALENDAR_TYPES,
		WORKFLOW_OFFSET_TYPES,
		WORKFLOW_TEMPLATE_ENTRY_STATES,
		extendNoteLengthLimit,
		openWorkflowCollaboratorForm,
		openWorkflowDeadlinesForm
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('workflowTaskCard', {
	bindings: {
		agencyPayPeriodId: '<?',
		bulkItems: '=',
		index: '<',
		omitCurrentUser: '<?',
		task: '=',
		refreshTasks: '&?',
		showComplete: '<?',
		showTeamMember: '<?'
	},
	controller: 'workflowTaskCardCtrl',
	templateUrl: 'components/workflow-task-card/workflow-task-card.component.html',
})
.controller('workflowTaskCardCtrl', ['$rootScope', 'bulkService', 'WORKFLOW_TEMPLATE_ENTRY_STATES', function ($rootScope, bulkService, WORKFLOW_TEMPLATE_ENTRY_STATES) {

	const $ctrl = this;

	function getCardTheme (taskObj) {

		let cardTheme = '';

		if (taskIsComplete(taskObj)) {
			cardTheme = 'is-primary is-complete';
		} else {
			if (taskObj.IsOverdue) {
				cardTheme = 'is-assertive';
			} else {
				cardTheme = 'is-secondary';
			}
		}

		return cardTheme;
	}

	function hideMenu () {

		$ctrl.options.showMenu = false;
	}

	function openReassignWorkflowTaskForm (taskObj) {

		$rootScope.openSlideInForm({
			actionerUserId: taskObj.ActionerID,
			agencyProfileId: taskObj.AgencyProfileID,
			callback: $ctrl.refreshTasks(),
			formKey: 'reassign-workflow-task',
			omitCurrentUser: $ctrl.omitCurrentUser,
			showContext: false,
			title: 'Re-assign workflow step',
			workflowTasks: [taskObj]
		});
	}

	function selectionChanged () {

		$ctrl.bulkItems = bulkService.updateBulkItemTotals($ctrl.bulkItems);
	}

	function taskIsComplete (taskObj) {

		return taskObj.State === WORKFLOW_TEMPLATE_ENTRY_STATES.complete;
	}

	$ctrl.$onInit = function () {

		$ctrl.cardTheme = getCardTheme($ctrl.task);
	};

	angular.extend($ctrl, {
		hideMenu,
		openReassignWorkflowTaskForm,
		options: {
			showMenu: false
		},
		selectionChanged,
		taskIsComplete
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('workflowTasksList', function () {

	return {
		replace: true,
		restrict: 'E',
		scope: {
			title: '@',
			workflowTasks: '<'
		},
		templateUrl: 'components/workflow-tasks-list/workflow-tasks-list.component.html'
	};
});

'use strict';

angular.module('paycircleApp')

.directive('workflowTaskSummaryCard', function () {

	return {
		controller: 'workflowTaskSummaryCardCtrl',
		replace: true,
		restrict: 'E',
		scope: {
			cardStyle: '@?',
			clientCount: '=?',
			filterKey: '@?',
			icon: '@?',
			isCompact: '<?',
			status: '@',
			targetState: '@?',
			teamCount: '=?',
			teamMemberCount: '=?',
			totalCount: '=?'
		},
		templateUrl: 'components/workflow-task-summary-card/workflow-task-summary-card.component.html'
	};
})

.controller('workflowTaskSummaryCardCtrl', ['$scope', 'FILTER_KEYS', function ($scope, FILTER_KEYS) {

	let teamMemberKeyList = '';

	function init () {

		/* Build team member key list for 'with team' filter sref. This is used to apply the filter on the
		   workflow companies view to select every team member */
		let filterKeys = [];
		if ($scope.teamMemberCount) {
			for (let i = 0; i < $scope.teamMemberCount; i++) {
				filterKeys.push(FILTER_KEYS.bureauWorkflowTasks.teamMember.assignee + `_${i}`);
			}
			teamMemberKeyList = filterKeys.join();
		}
		angular.extend($scope, {
			teamMemberKeyList
		});
	}

	function showCounts () {
		return $scope.teamCount || $scope.clientCount;
	}

	init();

	angular.extend($scope, {
		isCompact: angular.isUndefined($scope.isCompact) ? false : $scope.isCompact,
		showCounts
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('validatedInputFormField', {
	bindings: {
		// Display 'show password' button. Optional, defaults to false. Ignored when inputType !== password
		allowShowPassword: '<?',
		// Terms not allowed.
		blacklistedTerms: '<?',
		// Existing value for validation. If specified, the input can't be the same as this.
		currentValue: '=?',
		// Disable autocomplete. Defaults to false.
		disableAutocomplete: '<?',
		// Field name for display
		fieldName: '@',
		// Prompt, for display above the criteria. Optional, will default to 'fieldName must:'
		fieldPrompt: '@?',
		// Footnote for the field. Optional.
		fieldFootnote: '@?',
		// Bound variable
		input: '=ngModel',
		// Unique name for input field
		inputName: '@',
		// Rules for validation.
		rules: '<?',
		// One of USERNAME_CHECK_TYPES. Optional, will default to failOnUsernameExists. Ignored when inputType !== password
		usernameCheckType: '<?',
		// Maps directly a key of INPUT_VALIDATION_RULES
		validationType: '@',
	},
	controller: 'validatedInputFormFieldCtrl',
	require: {
		form: '^form'
	},
	/* Section for standard errors. These need to appear directly below the input field for general consistency,
	   so can't simply be added below the validated input field in a template, as then they would appear after
	   the validation list. Hence the transclusion. */
	transclude: {
		viErrors: '?viErrors'
	},
	templateUrl: 'components/validated-input-form-field/validated-input-form-field.component.html'
})
.controller('validatedInputFormFieldCtrl', [
	'$scope',
	'$transclude',
	'inputValidationService',
	'INPUT_VALIDATION_TYPES',
	'USERNAME_CHECK_TYPES',
	function (
		$scope,
		$transclude,
		inputValidationService,
		INPUT_VALIDATION_TYPES,
		USERNAME_CHECK_TYPES
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Determine input type based in validation type: 'text' unless validation type is 'password'.
		let inputType = 'text';
		if ($ctrl.validationType === INPUT_VALIDATION_TYPES.password) {
			inputType = 'password';
		}

		angular.extend($ctrl, {
			allowShowPassword: $ctrl.inputType === 'password' && (angular.isDefined($ctrl.allowShowPassword) ? $ctrl.allowShowPassword : false),
			disableAutocomplete: angular.isDefined($ctrl.disableAutocomplete) ? $ctrl.disableAutocomplete : false,
			fieldPrompt: angular.isDefined($ctrl.fieldPrompt) ? $ctrl.fieldPrompt : `${$ctrl.fieldName} must`,
			hasStandardErrors: $transclude.isSlotFilled('viErrors'),
			inputCheck: inputValidationService.getInitialInputCheck($ctrl.validationType),
			inputType,
			showPassword: false,
			usernameCheckType: angular.isDefined($ctrl.usernameCheckType) ? $ctrl.usernameCheckType : USERNAME_CHECK_TYPES.failOnUsernameExists
		});

		// Keep an eye on current value and check input on change
		$scope.$watch('$ctrl.currentValue', (newCurrentValue, oldCurrentValue) => {
			if (newCurrentValue !== oldCurrentValue) {
				checkInput();
			}
		});
	};


	function checkInput () {

		const inputFormField = $ctrl.form[$ctrl.inputName];

		if (inputFormField) {
			// If an existing value has been specified, check the new isn't the same
			let sameAsExisting = false;
			if (angular.isDefined($ctrl.currentValue)) {
				sameAsExisting = $ctrl.input === $ctrl.currentValue;
				inputFormField.$setValidity('sameasexisting', !sameAsExisting);
			}

			// Do additional validation checks
			$ctrl.inputCheck = inputValidationService.validateInput($ctrl.input, $ctrl.validationType, $ctrl.blacklistedTerms);
			inputFormField.$setValidity('pattern', $ctrl.inputCheck.inputOk);
		}
	}

	function toggleShowPassword () {

		$ctrl.showPassword = !$ctrl.showPassword;
		$ctrl.inputElementType = $ctrl.showPassword ? 'text' : 'password';
	}

	angular.extend($ctrl, {
		INPUT_VALIDATION_TYPES,
		checkInput,
		toggleShowPassword
	});

}]);

'use strict';

angular.module('paycircleApp')
.directive('dateInputField', ['$timeout', 'config', 'utilities', function ($timeout, config, utilities) {

	return {
		templateUrl: 'form-fields/date-input/dateInputField.html',
		scope: {
			fieldDisabled: '=?',
			fieldId: '@',
			fieldMaxDateIso: '=',
			fieldMinDateIso: '=?',
			fieldOnChange: '=?',
			fieldOnChangeFn: '&?',
			fieldOnFocusFn: '&?',
			fieldPlaceholder: '@?',
			fieldReadOnly: '<?',
			fieldRequired: '=?',
			fieldStyle: '@?',
			fieldValueIso: '='
		},
		link: function ($scope) {

			function createJSDateFromISODate (date) {

				return utilities.parseIsoDate(angular.copy(date));
			}

			function parseDateJsToISO (updatedDateObj) {

				$scope.fieldValueIso = updatedDateObj !== undefined && moment(updatedDateObj).isValid() ? moment(updatedDateObj).set({hour:0,minute:0,second:0,millisecond:0}).format('YYYY-MM-DDTHH:mm:ss') : '';
				$scope.fieldPlaceholder = '';
				if (angular.isFunction($scope.fieldOnChange)) {
					$scope.fieldOnChange($scope.fieldValueIso);
				}
				$timeout(() => {
					if (angular.isFunction($scope.fieldOnChangeFn)) {
						$scope.fieldOnChangeFn();
					}
				});
			}

			init();

			$scope.removePlaceholder = function () {

				var input = angular.element(document.getElementById($scope.fieldId));
				$scope.fieldPlaceholder = '';
				input[0].focus();
			};

			function init () {
				$scope.fieldHasPlaceholder = $scope.fieldPlaceholder ? true : false;
				$scope.fieldDisabled = $scope.fieldDisabled ? $scope.fieldDisabled : false;
				$scope.fieldReadOnly = $scope.fieldReadOnly ? $scope.fieldReadOnly : false;
				$scope.fieldRequired = $scope.fieldRequired !== undefined ? $scope.fieldRequired : true;

				$scope.fieldValueJS = createJSDateFromISODate($scope.fieldValueIso);
				$scope.fieldMinDateJS = createJSDateFromISODate($scope.fieldMinDateIso);
				$scope.fieldMaxDateJS = createJSDateFromISODate($scope.fieldMaxDateIso);
			}

			init();

			var fieldValueWatch = $scope.$watch('fieldValueIso', function (newValue, oldValue) {

				if (newValue !== oldValue) {
					$scope.fieldHasPlaceholder = false;
					$scope.fieldValueJS = createJSDateFromISODate(angular.copy(newValue));
				}
				if (newValue !== '') {
					$scope.fieldHasPlaceholder = false;
				}
			});

			$scope.$on('$destroy', function () {

				if (fieldValueWatch !== undefined) {
					fieldValueWatch();
				}
			});

			$scope.$watch('fieldMaxDateIso', function (oldValue, newValue) {

				if (newValue !== oldValue) {
					init();
				}
			});

			$scope.$watch('fieldMinDateIso', function (oldValue, newValue) {

				if (newValue !== oldValue) {
					init();
				}
			});

			$scope.parseDateJsToISO = function (updatedDateObj) {

				parseDateJsToISO(updatedDateObj);
			};
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('durationInput', {
	bindings: {
		fieldDisabled: '<?',
		fieldModel: '=',
		fieldName: '@',
		fieldOnChange: '&?',
		fieldRequired: '<?',
		fieldShowDivisions: '<?',
		fieldValidation: '<?'
	},
	require: {
	    form: '^form'
	},
	controller: 'durationInputCtrl',
	templateUrl: 'form-fields/duration-input/duration-input.component.html'
})
.controller('durationInputCtrl', ['dateService', 'utilities', function (dateService, utilities) {

	const $ctrl = this;

	const VALIDATION = {
		days: 365,
		hours: 23,
		minutes: 59
	};

	const DIVISIONS = dateService.getDivisions();

	function $onInit () {

		const fieldShowDivisions = angular.isDefined($ctrl.fieldShowDivisions) ? $ctrl.fieldShowDivisions : DIVISIONS;

		angular.extend($ctrl, {
			durationDetail: dateService.getDurationWithDivisionsFromMinutes($ctrl.fieldModel, fieldShowDivisions),
			fieldRequired: angular.isDefined($ctrl.fieldRequired) ? $ctrl.fieldRequired : true,
			fieldShowDivisions: fieldShowDivisions
		});

		setValidation($ctrl.fieldValidation);
	}

	function $onChanges (changesObj) {

		if (angular.isDefined(changesObj.fieldValidation)) {
			setValidation(changesObj.fieldValidation.currentValue);
		}
	}

	function getIsValidationObjectValid (fieldValidationObj) {
		// At least one of the object's values must be greater than 0 to be valid
		return Object.values(fieldValidationObj).some(value => value > 0);
	}

	function getMinutesFromDurationDetail (durationObj) {

		const MULTIPLIERS = {
			daysToMinutes: 1440,
			hoursToMinutes: 60
		};

		utilities.setAnyPropertiesToZeroIfEmpty(durationObj);

		let minutesInt = 0;

		if (durationObj.days > 0) {
			minutesInt += durationObj.days * MULTIPLIERS.daysToMinutes;
		}

		if (durationObj.hours > 0) {
			minutesInt += durationObj.hours * MULTIPLIERS.hoursToMinutes;
		}

		if (durationObj.minutes > 0) {
			minutesInt += durationObj.minutes;
		}

		return minutesInt;
	}

	function onChange (ctrlObj) {

		ctrlObj.fieldModel = getMinutesFromDurationDetail(ctrlObj.durationDetail);

		if (angular.isFunction(ctrlObj.fieldOnChange)) {
			ctrlObj.fieldOnChange();
		}
	}

	function setValidation (fieldValidationObj) {

		if (angular.isDefined(fieldValidationObj)) {

			if (getIsValidationObjectValid(fieldValidationObj)) {

				$ctrl.validation = angular.merge(angular.copy(VALIDATION), fieldValidationObj);

			} else {
				$ctrl.validation = VALIDATION;
			}
		}
	}

	angular.extend($ctrl, {
		DIVISIONS,
		$onInit,
		$onChanges,

		onChange
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('mentionInput', ['teamData', 'teamService', 'utilities', 'KEY_CODES', 'MENTION_OPTIONS', 'PERMISSION_TYPES', function (teamData, teamService, utilities, KEY_CODES, MENTION_OPTIONS, PERMISSION_TYPES) {
	return {
		scope: {
			agencyProfileId: '<',
			canMention: '<?',
			mentionList: '=',
			name: '@',
			ngModel: '=',
			required: '<?',
			rows: '@?',
		},
		restrict: 'E',
		require: ['^form', 'ngModel'],
		templateUrl: 'form-fields/mention-input/mention-input.html',
		link: function ($scope, $element) {

			const agencyProfileId = $scope.agencyProfileId;
			const mentionList = $scope.mentionList;
			const element = $element[0];
			const zeroWidthSpace = '​';
			const removeZeroWidthSpaces = new RegExp(zeroWidthSpace, 'g');

			const MENTION_STATES = {
				waiting: 'waiting',
				searching: 'searching'
			};

			function checkCursorSurroundings (vmObj, event) {

				const cursorDetailObj = getCursorSurroundings();

				if (!cursorDetailObj) {
					return;
				}

				removeParentElementStyleAttributes(cursorDetailObj.parentElement);

				if (cursorDetailObj.textBeforeCursor.slice(-1) === MENTION_OPTIONS.mentionCharacter && !cursorDetailObj.parentElement.dataset.isMention) {
					startSearching(vmObj);
					wrapElementAtPosition(vmObj, cursorDetailObj);

				} else {

					if (event.which === KEY_CODES.backspace) {

						if (selectionIsMention(cursorDetailObj)) {
							if (cursorDetailObj.parentElement.dataset.isMention) {
								cursorDetailObj.parentElement.remove();
							} else {
								cursorDetailObj.parentElement.parentElement.remove();
							}
						}

						updateNgModel();

					} else {
						moveCursor(event, cursorDetailObj);
					}
				}
			}

			function createMentionHTML (name) {
				return `<span class="${MENTION_OPTIONS.hiddenClass}" data-bracket="left">${MENTION_OPTIONS.bracketCharacter[0]}</span>${MENTION_OPTIONS.mentionCharacter + name}<span class="${MENTION_OPTIONS.hiddenClass}" data-bracket="right">${MENTION_OPTIONS.bracketCharacter[1]}</span>`;
			}

			function createRange (currentNode, countObj, range) {

				if (!range) {
					range = document.createRange();
					range.selectNode(currentNode);
					range.setStart(currentNode, 0);
				}

				if (countObj.count === 0) {
					range.setEnd(currentNode, countObj.count);

				} else if (currentNode && countObj.count >0) {
					if (currentNode.nodeType === Node.TEXT_NODE) {

						if (currentNode.textContent.length < countObj.count) {
							countObj.count -= currentNode.textContent.length;

						} else {
							range.setEnd(currentNode, countObj.count);
							countObj.count = 0;
						}

					} else {
						for (let childNode of currentNode.childNodes) {
							range = createRange(childNode, countObj, range);

							if (countObj.count === 0) {
								break;
							}
						}
					}
				}

			   return range;
			}

			function getCursorSurroundings () {

				const selectionDetailsObj = getSelectionDetails();

				if (!selectionDetailsObj) {
					return;
				}

				const cursorPosition = selectionDetailsObj.selection.getRangeAt(0).startOffset;

				if (cursorPosition < 0) {
					return;
				}

				const textElementContent = getTextContent(selectionDetailsObj.textElement);
				const textBeforeCursor = textElementContent.substring(0, cursorPosition);
				const textAfterCursor = textElementContent.substring(cursorPosition);

				return {
					cursorPosition,
					parentElement: selectionDetailsObj.parentElement,
					selection: selectionDetailsObj.selection,
					textElement: selectionDetailsObj.textElement,
					textAfterCursor,
					textBeforeCursor
				};
			}

			function getFilteredAdmins (vmObj) {
				return vmObj.adminGroups.map(adminGroupObj => adminGroupObj.filteredAdmins).flat();
			}

			function getMentionInputElement () {
				return document.getElementById('mention-input');
			}

			function getSelectionDetails () {

				const selection = document.getSelection();
				if (!selection) {
					return;
				}

				const textElement = selection.anchorNode;
				if (!textElement || textElement.nodeType !== Node.TEXT_NODE) {
					return;
				}

				const parentElement = textElement.parentNode;
				if (!parentElement) {
					return;
				}

				parentElement.normalize();

				return {
					parentElement,
					selection,
					textElement,
				};
			}

			function getTextContent (element) {
				return typeof element.textContent === 'string' ? element.textContent : element.innerText;
			}

			function init () {

				if ($scope.canMention) {

					if (isAgencyProfileIdInvalid()) {
						onError('Missing/invalid AgencyProfileID');
						return;
					}

					if (angular.isUndefined(mentionList)) {
						onError('Missing mention list attribute');
						return;
					}

					setupInputElement();
				}
			}

			function isAgencyProfileIdInvalid () {
				return !angular.isDefined(agencyProfileId) || !utilities.isValidGuid(agencyProfileId);
			}

			function loadAdmins (vmObj) {

				teamData.getTeamMemberAdminsExtended(agencyProfileId, PERMISSION_TYPES.all).then(adminGroupsObj => {

					const adminGroupsArr = teamService.convertTeamMembeAdminsToArray(adminGroupsObj);
					const adminsArr = Object.values(adminGroupsObj).flat();

					for (let adminGroupObj of adminGroupsArr) {
						adminGroupObj.filteredAdmins = [];
					}

					setIndexsForAdmins(adminsArr);

					for (let adminObj of adminsArr) {
						adminObj.fullName = `${adminObj.Forename} ${adminObj.Surname}`;
					}

					angular.extend(vmObj, {
						hasAdmins: true,
						adminGroups: adminGroupsArr
					});
				});
			}

			function moveCursor (event, cursorDetailObj) {

				switch (cursorDetailObj.parentElement.dataset.bracket) {
					case 'left':
						placeCursorAfterElement(cursorDetailObj.parentElement.parentElement);
						break;

					case 'right':
						if (event.which !== KEY_CODES.backspace) {
							placeCursorBeforeElement(cursorDetailObj.parentElement.parentElement);
						}
						break;

					default:
						if (cursorDetailObj.parentElement) {
							removeParentElementStyleAttributes(cursorDetailObj.parentElement);
						}
						break;
				}
			}

			function moveThroughAdminList (vmObj, isMoveUpOne) {

				const adminsArr = getFilteredAdmins(vmObj);

				if (isMoveUpOne) {

					// If user is at the top of the list, take them to the bottom
					if (vmObj.selectedAdminIndex <= 0) {
						vmObj.selectedAdminIndex = adminsArr.length-1;
					}

					// Move the user up the list
					else {
						vmObj.selectedAdminIndex--;
					}


				} else {

					// If user is at the bottom of the list, take them to the top
					if (vmObj.selectedAdminIndex === adminsArr.length-1) {
						vmObj.selectedAdminIndex = 0;
					}

					// Move user down the list
					else {
						vmObj.selectedAdminIndex++;
					}
				}

				const selectedAdminObj = adminsArr[vmObj.selectedAdminIndex];
				const selectedAdminElement = document.getElementById(`${MENTION_OPTIONS.selectionIdPrefix}-${selectedAdminObj.UserID}`);

				selectedAdminElement.scrollIntoView({
					behavior: 'smooth',
					inline: 'end',
					block: 'end'
				});
			}

			function onClick (vmObj) {

				const selectionDetailsObj = getSelectionDetails();

				switch (vmObj.state) {
					case MENTION_STATES.waiting:
						if (selectionIsMention(selectionDetailsObj)) {
							placeCursorAfterElement(selectionDetailsObj.parentElement);
						}
						break;

					case MENTION_STATES.searching:
						if (!selectionIsActiveMention(selectionDetailsObj)) {
							removeUnusedMentionElement(vmObj);
						}
						break;
				}
			}

			function onError (error) {
				$scope.canMention = false;
				throw new Error(error);
			}

			function onKeyDown (vmObj, event) {

				if (event.which === KEY_CODES.enter) {
					event.stopPropagation();
				}

				switch (vmObj.state) {
					case MENTION_STATES.waiting:
						skipOverMentions(event);
						break;

					case MENTION_STATES.searching:
						preventNavigationWhilstSearching(vmObj, event);
						break;
				}
			}

			function onKeyUp (vmObj, event) {

				switch (vmObj.state) {
					case MENTION_STATES.waiting:
						checkCursorSurroundings(vmObj, event);
						updateNgModel();
						break;

					case MENTION_STATES.searching:

						onMentionType(vmObj, event);
						break;
				}
			}

			function onMentionType (vmObj, event) {

				switch (event.which) {
					case KEY_CODES.upArrow:
						if (!vmObj.disableKeyboardInput) {
							moveThroughAdminList(vmObj, true);
							event.preventDefault();
						}
						break;

					case KEY_CODES.downArrow:
						if (!vmObj.disableKeyboardInput) {
							moveThroughAdminList(vmObj, false);
							event.preventDefault();
						}
						break;

					case KEY_CODES.enter:
						if (vmObj.selectedAdminIndex !== -1) {
							selectAdmin(vmObj, vmObj.selectedAdminIndex);
						}
						event.preventDefault();
						break;

					default:
						const mentionText = vmObj.mentionElement.textContent;
						vmObj.searchTerm = mentionText.replace(MENTION_OPTIONS.mentionCharacter, '');
						break;
				}
			}

			function onMouseLeave (vmObj) {
				vmObj.disableKeyboardInput = false;
			}

			function onMouseOver (vmObj) {
				vmObj.disableKeyboardInput = true;
			}

			function placeCursorAtElement (element) {

				element.tabIndex = 0;
				element.focus();

				const range = document.createRange();
				range.setStart(element.childNodes[0], 1);
				range.setEnd(element.childNodes[0], 1);

				const selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
			}

			function placeCursorAfterElement (element) {

				// If there's not an adjcent element, create an dummy one to focus onto
				if (!element.nextElementSibling) {
					const dummyElement = document.createElement('span');
					dummyElement.appendChild(document.createTextNode(zeroWidthSpace));
					element.parentNode.appendChild(dummyElement);
				}

				placeCursorAtElement(element.nextElementSibling);
			}

			function placeCursorBeforeElement (element) {

				// If there's not an previous element, create an dummy one to focus onto
				if (!element.previousElementSibling) {
					const dummyElement = document.createElement('span');
					dummyElement.appendChild(document.createTextNode(zeroWidthSpace));
					element.parentNode.insertBefore(dummyElement, element);
				}

				placeCursorAtElement(element.previousElementSibling);
			}

			function positionListPopout (vmObj, mentionElement) {

				const mentionArea = mentionElement.getBoundingClientRect();

				const popoutWindowOffset = mentionArea.left + MENTION_OPTIONS.popoutWidth;
				let mentionOffsetLeft = mentionElement.offsetLeft;

				// If popout is going to overflow window take the overflow width and some extra off popout offset
				if (popoutWindowOffset > window.innerWidth) {
					const popoutOverflowWidth = popoutWindowOffset - window.innerWidth;
					mentionOffsetLeft = mentionOffsetLeft - popoutOverflowWidth - 25;
				}

				element.style.setProperty('--popout-position-left', mentionOffsetLeft + 'px');
				element.style.setProperty('--popout-position-top', mentionElement.offsetTop + 'px');

				vmObj.showPopout = true;
			}

			function preventNavigationWhilstSearching (vmObj, event) {

				if ([KEY_CODES.enter, KEY_CODES.upArrow, KEY_CODES.tab].includes(event.which)) {
					event.preventDefault();
				}

				if ([KEY_CODES.escape, KEY_CODES.backspace].includes(event.which)) {

					if (vmObj.mentionElement.textContent === MENTION_OPTIONS.mentionCharacter) {
						removeUnusedMentionElement(vmObj);
						event.preventDefault();
					}

				} else if (event.which === KEY_CODES.leftArrow && vmObj.mentionElement.textContent === MENTION_OPTIONS.mentionCharacter) {
					event.preventDefault();
				}
			}

			function removeUnusedMentionElement (vmObj) {

				resetPopout(vmObj);

				vmObj.mentionElement.classList.remove(MENTION_OPTIONS.selectionClass);

				if (vmObj.mentionElement.parentNode) {
					vmObj.mentionElement.outerHTML = vmObj.mentionElement.textContent;
				}
			}

			function removeParentElementStyleAttributes (element) {

				// clear font problems (i know it's ugly, but it works)
				if (element.id !== 'mention-input') {

					element.removeAttribute('style');
					element.removeAttribute('color');

					if (element.parentElement) {
						removeParentElementStyleAttributes(element.parentElement);
					}
				}
			}

			function resetAdminIndexes (vmObj) {

				const adminsArr = getFilteredAdmins(vmObj);

				setIndexsForAdmins(adminsArr);

				if (vmObj.filteredAdmins.length !== adminsArr.length) {

					vmObj.filteredAdmins = adminsArr;

					if (adminsArr.length === 1) {
						vmObj.selectedAdminIndex = 0;

					} else {
						vmObj.selectedAdminIndex = -1;
					}

				}
			}

			function resetPopout (vmObj) {
				angular.extend(vmObj, {
					searchTerm: '',
					selectedAdminIndex: -1,
					showPopout: false,
					state: MENTION_STATES.waiting,
					disableKeyboardInput: false
				});
			}

			function selectAdmin (vmObj, adminIndex) {

				const adminsArr = getFilteredAdmins(vmObj);
				const selectedAdminObj = adminsArr[adminIndex];

				angular.merge(vmObj.mentionElement, {
					innerHTML: createMentionHTML(selectedAdminObj.fullName),
					dataset: {
						userId: selectedAdminObj.UserID
					}
				});

				delete vmObj.mentionElement.dataset.isActiveMention;

				mentionList.push(selectedAdminObj.UserID);

				updateNgModel();

				placeCursorAfterElement(vmObj.mentionElement);

				resetPopout(vmObj);
			}

			function selectionIsActiveMention (selectionDetailsObj) {
				return selectionDetailsObj && selectionDetailsObj.parentElement && selectionDetailsObj.parentElement.dataset.isActiveMention;
			}

			function selectionIsMention (selectionDetailsObj) {
				return selectionDetailsObj && selectionDetailsObj.parentElement && (selectionDetailsObj.parentElement.dataset.isMention || selectionDetailsObj.parentElement.dataset.bracket);
			}

			function setCursorPosition (cursorDetailObj) {

				const range = createRange(cursorDetailObj.parentElement, { count: cursorDetailObj.cursorPosition });

				if (range) {
					range.collapse(false);
					cursorDetailObj.selection.removeAllRanges();
					cursorDetailObj.selection.addRange(range);
				}
			}

			function setIndexsForAdmins (adminsArr) {
				for (let index = 0; index < adminsArr.length; index++) {
					adminsArr[index].index = index;
				}
			}

			function setSearchIndex (vmObj, index) {
				vmObj.selectedAdminIndex = index;
			}

			function setupInputElement () {

				const inputRows = $scope.rows;

				element.style.setProperty('--popout-width', MENTION_OPTIONS.popoutWidth + 'px');
				if (angular.isDefined(inputRows)) {
					element.style.setProperty('--mention-input-rows', inputRows);
				}

				$scope.message = $scope.ngModel;
			}

			function skipOverMentions (event) {

				const cursorDetailObj = getCursorSurroundings();

				if (cursorDetailObj && cursorDetailObj.parentElement) {
					moveCursor(event, cursorDetailObj);
				}
			}

			function startSearching (vmObj) {

				vmObj.state = MENTION_STATES.searching;

				if (!vmObj.hasAdmins) {
					loadAdmins(vmObj);
				}
			}

			function updateMentionList () {

				const mentionInputElement = getMentionInputElement();
				const mentionsArr = mentionInputElement.innerHTML.match(/data-user-id="[\A-Za-z0-9\-]+"/g);

				if (mentionsArr) {
					const mentionedIdsArr = mentionsArr.map(mentionId => mentionId.replace(/data-user-id="/g, '').replace(/"/g, ''));
					const removedDuplicatesIdsArr = utilities.removeDuplicatesFromArrayOfStrings(mentionedIdsArr);

					mentionList.splice(0);

					for (let mentionedId of removedDuplicatesIdsArr) {
						mentionList.push(mentionedId);
					}

				} else {
					mentionList.splice(0);
				}
			}

			function updateNgModel () {

				updateMentionList();

				const mentionInputElement = getMentionInputElement();

				$scope.ngModel = mentionInputElement.innerText.replace(removeZeroWidthSpaces,'');
			}

			function wrapElementAtPosition (vmObj, cursorDetailObj) {

				const domFragment = document.createDocumentFragment();

				if (cursorDetailObj.cursorPosition !== 0 && cursorDetailObj.textBeforeCursor) {
					const precedingTextElement = document.createTextNode(cursorDetailObj.textBeforeCursor.slice(0, -1));
					domFragment.appendChild(precedingTextElement);
				}

				const mentionElement = document.createElement(MENTION_OPTIONS.selectionElementType);
				mentionElement.appendChild(document.createTextNode(MENTION_OPTIONS.mentionCharacter));
				mentionElement.classList.add(MENTION_OPTIONS.selectionClass);
				domFragment.appendChild(mentionElement);

				if (cursorDetailObj.textAfterCursor) {
					const followingTextElement = document.createTextNode(cursorDetailObj.textAfterCursor);
					domFragment.appendChild(followingTextElement);
				}

				angular.merge(mentionElement.dataset, {
					isMention: true,
					isActiveMention: true,
				});

				vmObj.mentionElement = mentionElement;

				cursorDetailObj.parentElement.replaceChild(domFragment, cursorDetailObj.textElement);

				positionListPopout(vmObj, mentionElement);

				setCursorPosition(cursorDetailObj);
			}

			angular.extend($scope, {
				MENTION_OPTIONS,

				canMention: angular.isDefined($scope.canMention) ? $scope.canMention : true,
				disabled: angular.isDefined($scope.disabled) ? $scope.disabled : false,
				required: angular.isDefined($scope.required) ? $scope.required : true,

				vm: {
					adminGroups: [],
					hasAdmins: false,
					searchTerm: '',
					selectedAdminIndex: -1,
					showPopout: false,
					state: MENTION_STATES.waiting,
					filteredAdmins: []
				},

				onClick,
				onKeyDown,
				onKeyUp,
				onMouseLeave,
				onMouseOver,
				removeUnusedMentionElement,
				setSearchIndex,
				selectAdmin,
				updateNgModel,
			});

			init();

			$scope.$watch('vm.adminGroups', function (newObj, oldObj, scope) {
				resetAdminIndexes(scope.vm);
			}, true);
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.directive('numberSelectorField', [
	'$rootScope',
	'regexService',
	'REGEX',
	function (
		$rootScope,
		regexService,
		REGEX
	) {

	return {
		templateUrl: 'form-fields/number-selector/numberSelectorField.html',
		replace: true,
		require: ['^form', 'ngModel'],
		restrict: 'E',
		scope: {
			fieldName: '@?',
			max: '=?',
			min: '=?',
			ngDisabled: '=?',
			ngModel: '=',
			ngRegexKey: '@?',
			ngReadonly: '=?',
			ngRequired: '=?',
			nsfOnChange: '&?',
			size: '@?',
			step: '<?',
			theme: '@?'
		},
		link: function ($scope, $element, $attrs, $formCtrl) {

			$scope.max    		= $scope.max !== undefined ? $scope.max : 1000;
			$scope.min    		= $scope.min !== undefined ? $scope.min : 0;
			$scope.ngDisabled   = $scope.ngDisabled !== undefined ? $scope.ngDisabled : false;
			$scope.ngPattern   	= getRegexForRegexKey($scope.ngRegexKey);
			$scope.ngReadonly   = $scope.ngReadonly !== undefined ? $scope.ngReadonly : false;
			$scope.ngRequired   = $scope.ngRequired !== undefined ? $scope.ngRequired : true;
			$scope.size 		= $scope.size !== undefined ? $scope.size : '';
			$scope.step 		= $scope.step !== undefined ? parseFloat($scope.step) : 0.25;

			function getRegexForRegexKey (regexKey) {

				if (angular.isUndefined(regexKey)) {
					return null;
				}

				// Try getting the regex pattern from the REGEX constants
				let regexPattern = REGEX[regexKey];

				// If that fails, try the regex service for dynamic regexps
				if (angular.isUndefined(regexPattern)) {
					regexPattern = regexService[regexKey];
				}

				// Regex not found
				if (angular.isUndefined(regexPattern)) {
					$rootScope.paycircleMessage(`<number-selector-field> Unable to get regex pattern for key: ${regexKey}`, 'warn');
					return null;
				}

				return regexPattern;
			}

			function updateDisabledStates () {

				$scope.incrementDisabled = $scope.ngModel >= $scope.max || $scope.ngDisabled || $scope.ngReadonly;
				$scope.decrementDisabled = $scope.ngModel <= $scope.min || $scope.ngDisabled || $scope.ngReadonly;
			}

			updateDisabledStates();

			// Scope
			$scope.decrement = function () {

				if (angular.isUndefined($scope.ngModel) || $scope.ngModel === '') {
					$scope.ngModel = 0;
				}

				if ($scope.ngModel > $scope.min) {
					$scope.ngModel = $scope.ngModel - $scope.step;
				}

				if ($scope.ngModel < $scope.min) {
					$scope.ngModel = $scope.min;
				}

				$formCtrl[0].$setDirty();
				$formCtrl[0][$scope.fieldName].$setDirty();

				updateDisabledStates();
			};

			$scope.increment = function () {

				if (angular.isUndefined($scope.ngModel) || $scope.ngModel === '') {
					$scope.ngModel = 0;
				}

				if ($scope.ngModel < $scope.max) {
					$scope.ngModel = $scope.ngModel + $scope.step;
				}

				if ($scope.ngModel > $scope.max) {
					$scope.ngModel = $scope.max;
				}

				$formCtrl[0].$setDirty();
				$formCtrl[0][$scope.fieldName].$setDirty();

				updateDisabledStates();
			};

			$scope.$watch('ngModel', function (newValue, oldValue) {

				updateDisabledStates();

				if (newValue !== oldValue && newValue !== '' && newValue !== undefined && newValue !== null) {

					if ($scope.nsfOnChange !== undefined) {

						$scope.nsfOnChange();
					}
				}
			});

			$scope.$watch('min', function (newValue, oldValue) {

				if (newValue !== oldValue) {

					updateDisabledStates();
				}
			});

			$scope.$watch('ngDisabled', function (newValue, oldValue) {

				if (newValue !== oldValue) {

					updateDisabledStates();
				}
			});

			$scope.$watch('ngReadonly', function (newValue, oldValue) {

				if (newValue !== oldValue) {

					updateDisabledStates();
				}
			});

			$scope.$watch('ngRequired', function (newValue, oldValue) {

				if (newValue !== oldValue) {

					updateDisabledStates();
				}
			});

			$scope.$watch('max', function (newValue, oldValue) {

				if (newValue !== oldValue) {

					updateDisabledStates();
				}
			});
		}
	};
}]);

'use strict';

angular.module('paycircleApp')
.component('pillInputField', {
	bindings: {
		fieldOptions: '=',
		ngModel: '=',
		ngModelSave: '='
	},
	controller: 'pillInputFieldCtrl',
	require: {
		parentForm: '^form'
	},
	templateUrl: 'form-fields/pill-input-field/pill-input-field.component.html'
})
.controller('pillInputFieldCtrl', ['$timeout', 'utilities', function ($timeout, utilities) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			canSave: true,
			errorMessages: [
				{
					key: 'pattern',
					message: 'Only basic characters are allowed'
				},
				{
					key: 'required',
					message: 'Please enter a label'
				},
				{
					key: 'minlength',
					message: 'Please enter a label with at least 3 characters'
				}
			],
			id: 'newAdjustmentLabel',
			isActive: false,
			isRequired: false,
			label: 'Label for payslip',
			maxItems: 1,
			maxlength: 40,
			minlength: 3,
			name: 'newAdjustmentLabel',
			pillItems: [],
			placeholder: 'Add a custom payslip label',
			saveLabel: 'Save for future use',
			theme: 'primary'
		}, $ctrl.fieldOptions);

		// Setup pills (if value defined). Timeout allows parentForm to be initiated
		$timeout(() => {
			onInputBlur($ctrl);
		});
	}

	function deletePillItem ($ctrl, pillIndex) {

		$ctrl.pillItems.splice(pillIndex, 1);
		$ctrl.ngModel = '';

		utilities.focusOn($ctrl.id);
	}

	function onInputBlur ($ctrl) {

		if ($ctrl.parentForm[$ctrl.name].$valid && angular.isString($ctrl.ngModel) && $ctrl.ngModel !== '') {
			$ctrl.pillItems.push($ctrl.ngModel);
		}
	}

	function onInputFocus ($ctrl) {

		$ctrl.isActive = true;
	}

	angular.extend($ctrl, {
		$onInit,
		deletePillItem,
		onInputBlur,
		onInputFocus
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('searchInput', {
	bindings: {
		id: '@?',
		searchOptions: '=',

		/* These options allow the retention of items after removal, where the platform removes things
		   by effectively settings a removal - or archive - flag, in which case the items still need to
		   be sent to the backend with the removal attribute set */
		searchOptionRemoveAttribute: '@?',
		searchOptionsForRemoval: '=?'
	},
	controller: 'searchInputCtrl',
	templateUrl: 'form-fields/search-input/search-input.component.html'
})
.controller('searchInputCtrl', ['$rootScope', '$timeout', function ($rootScope, $timeout) {

	const MAX_ACTIVE_ITEMS = 1;
	const SEARCH_RESULTS_LIMIT = 10;
	const SEARCH_TERM_MIN_COUNT = 3;

	const $ctrl = this;

	let defaultSearchOptions = {
		filter: () => { return; },
		isActive: false,
		orderBy: null,
		label: 'Search',
		placeholder: 'Start typing to search...',
		searchItems: [],
		searchItemsActive: [],
		searchItemsActiveIds: [],
		searchItemsFiltered: [],
		searchTerm: '',
		theme: 'is-primary',
		MAX_ACTIVE_ITEMS,
		SEARCH_RESULTS_LIMIT,
		SEARCH_TERM_MIN_COUNT,
	};

	function focusOn (elementId) {

		$timeout(() => {
			if (document.getElementById(elementId)) {
				document.getElementById(elementId).focus();
			}
			else {
				$rootScope.paycircleMessage('Unable to apply element focus to #' + elementId + ' as it could not be found.', 'warn');
			}
		});
	}

	function onAdd ($ctrl, searchItemObj) {

		const activeItemObj = $ctrl.searchOptions.searchItemsActive.find(searchItemActiveObj => {
			return searchItemObj.id === searchItemActiveObj.id;
		});

		if (angular.isDefined(activeItemObj)) {
			return;
		}

		// If just a single item is allowed, the search box remains visible and the entry is replaced on search and re-selection
		if ($ctrl.searchOptions.MAX_ACTIVE_ITEMS === 1) {
			$ctrl.searchOptions.searchItemsActive = [searchItemObj];
		}
		else {
			$ctrl.searchOptions.searchItemsActive.push(searchItemObj);
		}

		resetSearchTerm($ctrl);

		focusOn(`searchFieldInput_${$ctrl.id}`);
	}

	function onRemove ($ctrl, index) {

		// Add to removal list if necessary
		if (angular.isDefined($ctrl.searchOptionsForRemoval)) {
			let itemForRemoval = $ctrl.searchOptions.searchItemsActive[index];
			// Set removal flag if defined
			if (angular.isDefined($ctrl.searchOptionRemoveAttribute)) {
				itemForRemoval[$ctrl.searchOptionRemoveAttribute] = true;
			}

			$ctrl.searchOptionsForRemoval.push(itemForRemoval);
		}

		$ctrl.searchOptions.searchItemsActive.splice(index, 1);

		focusOn(`searchFieldInput_${$ctrl.id}`);
	}

	function onSearchFieldInputFocus ($ctrl) {

		$ctrl.searchOptions.isActive = true;
	}

	function onSearchFieldInputBlur ($ctrl) {

		$ctrl.searchOptions.isActive = false;
	}

	function resetSearchTerm ($ctrl) {

		$ctrl.searchOptions.searchTerm = '';
	}

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			onAdd,
			onRemove,
			onSearchFieldInputFocus,
			onSearchFieldInputBlur,
			resetSearchTerm,
			searchOptions: angular.extend({}, defaultSearchOptions, $ctrl.searchOptions),
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary'
		});
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('timeInputField', {
	bindings: {
		fieldName: '@',
		fieldValueIso: '='
	},
	controller: 'timeInputFieldCtrl',
	require: '^form',
	templateUrl: 'form-fields/time-input/time-input-field.component.html',
	link: function (scope, form) {
		scope.form = form;
	}
})
.controller('timeInputFieldCtrl', function () {

	const $ctrl = this;

	function getHours () {

		let hoursArr = [];

		for (let hour = 0; hour < 24; hour++) {

			let hourString = hour.toString();
			hourString = hourString.length === 1 ? `0${hourString}` : hourString;

			hoursArr.push({
				hourDisplay: hourString,
				hour: hour
			});
		}

		return hoursArr;
	}

	function getMinutes () {

		let minutesArr = [];

		for (let minute of ['00', '15', '30', '45']) {

			minutesArr.push({
				minuteDisplay: minute,
				minute: parseInt(minute)
			});
		}

		return minutesArr;
	}

	function onTimeChange (ctrlObj) {
		ctrlObj.fieldValueIso = moment($ctrl.fieldValueIso).hour(ctrlObj.selectedHour).minute(ctrlObj.selectedMinute).format('YYYY-MM-DDTHH:mm:00'); // Format to include minutes
	}

	function $onInit () {

		$ctrl.fieldRequired = $ctrl.fieldRequired || true;

		let fieldValueIso = $ctrl.fieldValueIso;

		if (fieldValueIso) {
			angular.extend($ctrl, {
				selectedHour: moment(fieldValueIso).hour(),
				selectedMinute: (Math.round(moment(fieldValueIso).minute()/15) * 15) % 60 // Round to nearest 15 minute
			});

		} else {
			angular.extend($ctrl, {
				selectedHour: 0,
				selectedMinute: 0
			});
		}
	}

	angular.extend($ctrl, {
		$onInit,
		onTimeChange,

		hours: getHours(),
		minutes: getMinutes(),
	});
});

'use strict';

angular.module('paycircleApp')

.component('toggleButtons', {
	bindings: {
		id: '@',
		label: '=',
		infoText: '=?',
		// Labels for false / true values. Will default to 'No' and 'Yes'
		falseLabel: '=?',
		trueLabel: '=?',
		theme: '@',
		ngModel: '='
	},
	controller: 'toggleButtonsCtrl',
	require: {
		form: '^form'
	},
	templateUrl: 'form-fields/toggle-buttons/toggle-buttons.component.html'
})

.controller('toggleButtonsCtrl', [function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		// Default stuff
		angular.extend($ctrl, {
			hasInfoText: angular.isDefined($ctrl.infoText),
			falseLabel: angular.isDefined($ctrl.falseLabel) ? $ctrl.falseLabel : 'No',
			trueLabel: angular.isDefined($ctrl.trueLabel) ? $ctrl.trueLabel : 'Yes',
			theme: angular.isDefined($ctrl.theme) ? $ctrl.theme : 'is-primary'
		});
	};

	function setValue (ctrlObj, value) {
		ctrlObj.ngModel = value;
	}

	angular.extend($ctrl, {
		setValue
	});

}]);
'use strict';

angular.module('paycircleApp')
.component('toggleInput', {
	bindings: {
		fieldDisabled: '<?', // Disable input
		fieldLabel: '@?', // Show label next to input
		fieldLabelStayActive: '<?', // Label text doesn't fade when fieldModel = false
		fieldModel: '=', // ngModel for checkbox
		fieldName: '@', // For form functionality
		fieldOnChange: '&?', // Runs after toggle
		fieldShowDetail: '=', // Show transcluded content below label
		fieldShowIndicator: '<?', // Show On/Off in toggle (works with fieldStyle = 'is-large')
		fieldStyle: '@?', // Just 'is-large' so far
		fieldThemeActive: '@?', // Optional themes for selected (true) and unselected (false) states
		fieldThemeInactive: '@?' // Optional themes for selected (true) and unselected (false) states
	},
	require: '^form',
	controller: 'toggleInputCtrl',
	templateUrl: 'form-fields/toggle-input/toggle-input.component.html',
	transclude: {
		'detail': '?toggleInputDetail',
	},
})
.controller('toggleInputCtrl', ['$timeout', '$transclude', function ($timeout, $transclude) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.fieldThemeActive = angular.isDefined($ctrl.fieldThemeActive) ? $ctrl.fieldThemeActive : 'is-primary';
		$ctrl.fieldThemeLight = angular.isDefined($ctrl.fieldThemeLight) ? $ctrl.fieldThemeLight : false;
		if (angular.isUndefined($ctrl.fieldThemeInactive)) {
			$ctrl.fieldThemeInactive = $ctrl.fieldThemeLight ? $ctrl.fieldThemeActive : null;
		}
	}

	function onCheckboxClick () {
		if (angular.isDefined($ctrl.fieldOnChange) && angular.isFunction($ctrl.fieldOnChange)) {
			$timeout(() => {
				$ctrl.fieldOnChange();
			});
		}
	}

	angular.extend($ctrl, {
		$onInit,
		onCheckboxClick,
		hasDetail: $transclude.isSlotFilled('detail'),
	});
}]);

'use strict';

angular.module('paycircleApp')
.constant('COMMON_PASSWORDS', [
	'111111',
	'1234',
	'12345',
	'123456',
	'1234567',
	'12345678',
	'abc123',
	'dragon',
	'iloveyou',
	'letmein',
	'monkey',
	'password',
	'qwerty',
	'tequiero',
	'test'
]);

'use strict';

angular.module('paycircleApp')
.component('passwordInput', {
	bindings: {
		// Display show/hide password icon
		allowShowPassword: '<?',
		// When used as a 'confirm password' input, set this to the compare value.
		comparePassword: '=?',
		// Disable autocomplete. Defaults to false.
		disableAutocomplete: '<?',
		// ID and name of input field
		inputId: '@',
		inputName: '@'
	},
	controller: 'passwordInputCtrl',
	require: {
		form: '^form',
		ngModel: '?^ngModel'
	},
	templateUrl: 'modules/security/components/password-input/password-input.component.html'
})
.controller('passwordInputCtrl', [
	function (
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		angular.extend($ctrl, {
			allowShowPassword: angular.isDefined($ctrl.allowShowPassword) ? $ctrl.allowShowPassword : false,
			disableAutoComplete: angular.isDefined($ctrl.disableAutocomplete) ? $ctrl.disableAutocomplete : false,
			inputType: 'password'
		});

		// Initial view update to sync password with input element if ng-model controller set
		if ($ctrl.ngModel) {
			$ctrl.ngModel.$render = () => {
				$ctrl.password = $ctrl.ngModel.$viewValue;
			};
		}
		else {
			$ctrl.password = '';
		}
	};

	function onChangePassword () {

		/* Update ngModel value and mark as dirty / touched if model controller set.
		   Note that any ng-change defined against this password-input component will be
		   fired when the view value is updated */
		if ($ctrl.ngModel) {
			$ctrl.ngModel.$setViewValue($ctrl.password);
			$ctrl.ngModel.$setDirty();
			$ctrl.ngModel.$setTouched();
		}
	}

	function toggleShowPassword () {

		// Toggle between input type text <-> password
		$ctrl.inputType = $ctrl.inputType === 'text' ? 'password' : 'text';
	}

	angular.extend($ctrl, {
		onChangePassword,
		toggleShowPassword
	});

}]);

'use strict';

angular.module('paycircleApp')

.constant('ACCOUNT_SECURITY_TYPES', {
	password: 'password',
	recoveryEmail: 'recoveryEmail',
	username: 'username'
})

.directive('changeAccountSecurityItemForm', function () {

	return {
		controller: 'changeAccountSecurityItemFormCtrl',
		templateUrl: 'modules/security/forms/change-account-security-item/change-account-security-item.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('changeAccountSecurityItemFormCtrl', [
	'ACCOUNT_SECURITY_TYPES',
	'COMPARED_TO_MODES',
	'INPUT_VALIDATION_TYPES',
	'securityData',
	'$rootScope',
	'$scope',
	function (
		ACCOUNT_SECURITY_TYPES,
		COMPARED_TO_MODES,
		INPUT_VALIDATION_TYPES,
		securityData,
		$rootScope,
		$scope
	) {

		const FORM_STATES = {
			error: 'error',
			loading: 'loading',
			ready: 'ready',
			success: 'success'
		};

		// Invalid password response
		const PASSWORD_INVALID_RESPONSE = -2;

		// Validity constant for 'Password invalid'
		const PASSWORD_INVALID = 'passwordInvalid';

		const accountMinimal = $scope.formOptions.accountMinimal;
		const accountSecurityType = $scope.formOptions.accountSecurityType;

		function init () {

			$scope.vm = {

				accountSecurityType,

				securityItems: {

					password: '',
					newPassword: '',
					lastPasswordEntered: '',

					username: accountMinimal.Username,
					newUsername: '',
					confirmNewUsername: '',

					recoveryEmail: accountMinimal.RecoveryEmailAddress,
					newRecoveryEmail: '',
					confirmNewRecoveryEmail: ''
				}
			};
		}

		function getOnUpdateSuccessMessage (accountSecurityType) {

			switch (accountSecurityType) {
				case ACCOUNT_SECURITY_TYPES.password:
					return 'Your new password has been saved and you’ll need to use it the next time you sign in to the Payroll Portal.';
				case ACCOUNT_SECURITY_TYPES.username:
					return 'Your new username has been saved and you’ll need to use it the next time you sign in to the Payroll Portal.';
				case ACCOUNT_SECURITY_TYPES.recoveryEmail:
					return 'Your new recovery email address has been saved and can now be used for account recovery.';
			}
		}

		function getOnUpdateSuccessTitle (accountSecurityType) {

			switch (accountSecurityType) {
				case ACCOUNT_SECURITY_TYPES.password:
					return 'New password saved';
				case ACCOUNT_SECURITY_TYPES.username:
					return 'New username saved';
				case ACCOUNT_SECURITY_TYPES.recoveryEmail:
					return 'New recovery email address saved';
			}
		}

		function onPasswordChange (formObj) {

			const vm = $scope.vm;

			/* If last entered password has been set, compare it and set invalid if it matches. Just avoids repeated
			   calls to security service to check against the same password. */
			if (vm.securityItems.lastPasswordEntered && vm.securityItems.password === vm.securityItems.lastPasswordEntered) {
				formObj['password'].$setValidity(PASSWORD_INVALID, false);
			}
			else {
				// Clear invalid flag on current password
				formObj['password'].$setValidity(PASSWORD_INVALID, true);
			}
		}

		function setFormState (formState) {

			$scope.formState = formState;
		}

		function updateSecurityItem (formObj) {

			formObj.state = 'saving';

			const securityItems = $scope.vm.securityItems;

			// Determine specific API for update
			let updateSecurityItem;
			switch (accountSecurityType) {
				case ACCOUNT_SECURITY_TYPES.password:
					updateSecurityItem = securityData.updateAccountPassword(
						accountMinimal.UserID,
						securityItems.password,
						securityItems.newPassword
					);
					break;
				case ACCOUNT_SECURITY_TYPES.username:
					updateSecurityItem = securityData.updateAccountUsername(
						accountMinimal.UserID,
						securityItems.password,
						securityItems.username,
						securityItems.newUsername
					);
					break;
				case ACCOUNT_SECURITY_TYPES.recoveryEmail:
					updateSecurityItem = securityData.updateAccountRecoveryEmailAddress(
						accountMinimal.UserID,
						securityItems.password,
						securityItems.recoveryEmail,
						securityItems.newRecoveryEmail
					);
					break;
			}

			// Call specific API for update
			updateSecurityItem
			.then((responseCode) => {

				// All might not be well. If the password is invalid, -2 is returned.
				if (responseCode === PASSWORD_INVALID_RESPONSE) {
					formObj['password'].$setValidity(PASSWORD_INVALID, false);
					formObj.state = null;

					/* Save the entered password to shortcut this if they enter the same thing again. Some users may
					   keep trying the same password for a while before the penny drops. */
					securityItems.lastPasswordEntered = securityItems.password;
				}
				else {

					// Refresh current user at application level when username changed
					if (accountSecurityType === ACCOUNT_SECURITY_TYPES.username) {
						$rootScope.currentUser.UserResponseUsername = securityItems.newUsername;
					}

					// All done ...
					formObj.state = 'saved';
					$scope.formOptions.forceCallback();

					// Set success message attributes before invoking success form state
					angular.extend($scope.vm, {
						successTitle: getOnUpdateSuccessTitle(accountSecurityType),
						successMessage: getOnUpdateSuccessMessage(accountSecurityType)
					});
					setFormState(FORM_STATES.success);
				}
			})
			.catch((error) => {
				console.error(error);
				setFormState(FORM_STATES.error);
				formObj.state = null;
			});
		}

		init();

		angular.extend($scope, {

			ACCOUNT_SECURITY_TYPES,
			COMPARED_TO_MODES,
			FORM_STATES,
			INPUT_VALIDATION_TYPES,
			PASSWORD_INVALID,

			formState: FORM_STATES.ready,

			updateSecurityItem,
			onPasswordChange,
			setFormState
		});
	}
]);

'use strict';

angular.module('paycircleApp')

.directive('passwordResetForm', function () {

	return {
		controller: 'passwordResetFormCtrl',
		templateUrl: 'modules/security/forms/password-reset/password-reset.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('passwordResetFormCtrl', [
	'$scope',
	'securityData',
	'teamData',
	function (
		$scope,
		securityData,
		teamData
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		noRecoveryEmail: 'no-recovery-email',
		ready: 'ready',
		success: 'success'
	};

	function init () {

		setPageState(PAGE_STATES.loading);

		teamData.getTeamMemberInformation(
			userId,
			agencyProfileId
		)
		.then(teamMemberInformationObj => {

			$scope.vm = {
				teamMember: teamMemberInformationObj
			};

			// No recovery email address defined
			if (teamMemberInformationObj.Personal.EmailRecovery === '') {
				setPageState(PAGE_STATES.noRecoveryEmail);
				return;
			}

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function sendPasswordReset (vmObj, form) {

		const REDIRECT_TO_PAYROLL = vmObj.teamMember.Company.IsAdmin;

		securityData.createPasswordRequestInternal(
			vmObj.teamMember.Personal.UserID,
			vmObj.teamMember.Personal.EmailReset,
			REDIRECT_TO_PAYROLL
		).then(() => {

			setPageState(PAGE_STATES.success);
		})
		.catch(error =>{
			form.state = null;
			onError(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		sendPasswordReset
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('usernameRetrievalForm', function () {

	return {
		controller: 'usernameRetrievalFormCtrl',
		templateUrl: 'modules/security/forms/username-retrieval/username-retrieval.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('usernameRetrievalFormCtrl', [
	'$scope',
	'securityData',
	'teamData',
	function (
		$scope,
		securityData,
		teamData
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		noRecoveryEmail: 'no-recovery-email',
		ready: 'ready',
		success: 'success'
	};

	function init () {

		setPageState(PAGE_STATES.loading);

		teamData.getTeamMemberInformation(
			userId,
			agencyProfileId
		)
		.then(teamMemberInformationObj => {

			$scope.vm = {
				teamMember: teamMemberInformationObj
			};

			// No recovery email address defined
			if (teamMemberInformationObj.Personal.EmailRecovery === '') {
				setPageState(PAGE_STATES.noRecoveryEmail);
				return;
			}

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function sendUsernameRetrievalRequest (vmObj, form) {

		const REDIRECT_TO_PAYROLL = false;

		securityData.createUsernameRequestInternal(
			vmObj.teamMember.Personal.UserID,
			vmObj.teamMember.Personal.EmailReset,
			REDIRECT_TO_PAYROLL
		).then(() => {

			setPageState(PAGE_STATES.success);
		})
		.catch(error =>{
			form.state = null;
			onError(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		sendUsernameRetrievalRequest
	});

}]);

'use strict';

// Input validation types
const INPUT_VALIDATION_TYPES = {
	password: 'password',
	username: 'username'
};

angular.module('paycircleApp')

.constant('INPUT_VALIDATION_TYPES', INPUT_VALIDATION_TYPES)

// Rules. Should be one set per input validation type
.constant('INPUT_VALIDATION_RULES', {

	// Rules for password validation
	[INPUT_VALIDATION_TYPES.password]: {
		atLeastOneNumber: false,
		atLeastOneSpecialCharacter: true,
		minLength: 12,
		mixOfUpperAndLowercaseCharactersAndNumbers: true,
		mixOfUpperAndLowercaseCharacters: false,
		noCommonWords: true,
		noPaycircleReferences: true,
		blacklistedTerms: [
			'paycircle',
			'payroll'
		],
		specialCharacters: '@$!%*#?&'
	},

	// Rules for username validation
	[INPUT_VALIDATION_TYPES.username]: {
		minLength: 8,
		alphanumericsOnly: true
	}
});

'use strict';

angular.module('paycircleApp')
.service('inputValidationService', [
	'utilities',
	'COMMON_PASSWORDS',
	'INPUT_VALIDATION_RULES',
	function (
		utilities,
		COMMON_PASSWORDS,
		INPUT_VALIDATION_RULES
	) {

	const service = {

		/**
		 * Check input against rules and optional additional blacklisted terms.
		 * @param {string} input - input to check.
		 * @param {INPUT_VALIDATION_TYPES} inputValidationType - validation type
		 * @param {Array<string>} blacklistedTermsArr - array of blacklisted terms. If any are already defined as part of the rules, these will be appended.
		 * @returns Object - results of the form:
		 * {
		 * 		inputOK {boolean} - true if validation passed
		 * 		results: {Array<Object>} - set of results of the form:
		 * 		[
		 * 			description: {string} - description of the criterion
		 * 			init: false - set to allow the UI to determine that this follows a check. This is true on initialisation, so criteria can be
		 * 						  displayed in an initial 'fuzzy' not passed / not failed state before any input has been entered.
		 * 			passed: {boolean} - true if this specific criterion has passed
		 * 		]
		 * }
		 */
		validateInput: (input, inputValidationType, blacklistedTermsArr) => {

			if (input) {

				// Get criteria for rules
				const criteria = service.getInputCriteria(inputValidationType);

				let inputCheck = {
					inputOk: true,
					results: []
				};

				// Go through criteria and check status of each against the specified input
				criteria.forEach(criterion => {

					// Check rule and add result to list
					const passed = service.getHasCriterionPassed(criterion, input, blacklistedTermsArr);

					inputCheck.results.push({
						description: criterion.description,
						init: false, // See getInitialInputCheck()
						passed
					});

					// Overall result
					inputCheck.inputOk = inputCheck.inputOk && passed;
				});

				return inputCheck;
			}
			else {
				// No input, so return initial check for empty input for rules display
				return service.getInitialInputCheck(inputValidationType);
			}
		},

		/**
		 * Check input against a specific criterion
		 * @param {Object} criterion - criterion to check input against.
		 * @param {string} input - input to check.
		 * @param {Array<string>} blacklistedTermsArr
		 * @returns true if criterion passed, false if not
		 */
		getHasCriterionPassed: (rule, input, blacklistedTermsArr) => {

			// Function
			if (angular.isFunction(rule.isValidFn)) {
				return rule.isValidFn(input, blacklistedTermsArr);
			}

			// Regex (default)
			return input.match(rule.regExp) !== null;
		},

		/*
			Get input criteria based on rules for a specified input validation type.
			See INPUT_VALIDATION_TYPES for types, INPUT_VALIDATION_RULES for corresponding rules.
			A specific criterion can be in the form of a regexp, or a special function to check validity.
		*/
		getInputCriteria: (inputValidationType) => {

			let criteria = [];
			const rules = INPUT_VALIDATION_RULES[inputValidationType];
			if (angular.isDefined(rules)) {

				// Min length
				if (angular.isDefined(rules.minLength) && angular.isNumber(rules.minLength) && rules.minLength > 0) {
					criteria.push({
						description: `a minimum of ${utilities.getNumberText(rules.minLength)} character${rules.minLength > 1 ? 's' : ''}`,
						regExp: new RegExp(`^.{${rules.minLength},}$`)
					});
				}

				// Upper & lower case letters
				if (rules.mixOfUpperAndLowercaseCharacters) {
					criteria.push({
						description: 'a mixture of upper and lower case letters',
						regExp: /^(?=.*[a-z])(?=.*[A-Z]).*$/
					});
				}

				// Contains a number
				if (rules.atLeastOneNumber) {
					criteria.push({
						description: 'one or more numbers',
						regExp: /^(?=.*[0-9]).*$/
					});
				}

				// Begin with a letter
				if (rules.beginWithALetter) {
					criteria.push({
						description: 'begin with a letter',
						regExp: /^(?=[a-zA-Z])+.*$/i
					});
				}

				// Contains alphanumeric characters only
				if (rules.alphanumericsOnly) {
					criteria.push({
						description: 'letters or numbers only',
						regExp: /^[a-zA-Z0-9]+$/i
					});
				}

				// Contains letters and numbers
				if (rules.mixOfUpperAndLowercaseCharactersAndNumbers) {
					criteria.push({
						description: 'a mixture of upper and lower case letters, and numbers',
						regExp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/i
					});
				}

				// Contains special character
				if (rules.atLeastOneSpecialCharacter) {
					criteria.push({
						description: `at least one special character (${[...rules.specialCharacters].join(', ')})`,
						regExp: new RegExp(`^(?=.*[${rules.specialCharacters}]).*$`)
					});
				}

				// Contains common words
				if (rules.noCommonWords) {
					criteria.push({
						description: `no commonly used terms, such as 'password', '1234'`,
						isValidFn: inputString => {

							// Lowercase input so it's case insensitive
							const inputStringLowercase = inputString.toLowerCase();

							return !COMMON_PASSWORDS.some(commonPassword => {

								return inputStringLowercase.includes(commonPassword);
							});
						}
					});
				}

				// Contains common words
				if (rules.noPaycircleReferences) {
					criteria.push({
						description: `no references to your Paycircle account`,
						isValidFn: (inputString, paycircleDataArr) => {

							// Lowercase input so it's case insensitive
							const inputStringLowercase = inputString.toLowerCase();

							// Blacklisted terms can be defined dynamically or simply use any defined in the default configuration
							paycircleDataArr = angular.isArray(paycircleDataArr) ? paycircleDataArr.concat(rules.blacklistedTerms) : rules.blacklistedTerms;

							return !paycircleDataArr.some(blacklistedTerm => {

								// Ignore if empty
								if (blacklistedTerm === '') {
									return false;
								}

								return inputStringLowercase.includes(blacklistedTerm);
							});
						}
					});
				}
			}

			return criteria;
		},

		/**
		 * Get initial input check with no pass / fail indications.
		 * This can be used to display rules in advance of the user entering input.
		 * @param {INPUT_VALIDATION_TYPES} inputValidationType - validation type, used to get the validation criteria
		 * @returns
		 */
		getInitialInputCheck: (inputValidationType) => {

			const criteria = service.getInputCriteria(inputValidationType);

			let emptyInputCheck = {
				// Empty input isn't valid
				inputOk: false,
				results: []
			};

			criteria.forEach(criterion => {
				emptyInputCheck.results.push({
					description: criterion.description,
					// Indicator that this check hasn't passed or failed yet
					init: true
				});
			});

			return emptyInputCheck;
		}
	};

	return service;
}]);

'use strict';

angular.module('paycircleApp')

	.component('linkAccountsForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'linkAccountsFormCtrl',
		templateUrl: 'modules/security/forms/link-accounts/link-accounts.form.html',
	})
	.controller('linkAccountsFormCtrl', [
		'$rootScope',
		'securityData',
		'utilities',
		'LOGIN_TYPES',
		function (
			$rootScope,
			securityData,
			utilities,
			LOGIN_TYPES
		) {
			const $ctrl = this;

			const PASSWORD_INVALID = 'passwordInvalid';
			const PASSWORD_INVALID_RESPONSE = -2;
			const ACCOUNT_ALREADY_MIGRATED = -3;
			const ACCOUNTS_NONEIDENTITY = -4;
			const ACCOUNTS_ADMIN_NONEIDENTITY = -5;
			const NOT_SAME_USER = -6;

			const FORM_STATES = {
				loading: 'loading',
				error: 'error',
				success: 'success',
				usernameView: 'usernameView',
				passwordView: 'passwordView',
				cantBeLinkedView: 'cantBeLinkedView',
				accountsNoneIdentity: 'accountsNoneIdentity',
				accountsAdminNoneIdentity: 'accountsAdminNoneIdentity',
				notSameUser: 'notSameUser'
			};

			function $onInit() {

				angular.extend($ctrl, {
					userId: $ctrl.formOptions.userId,
					linkedAccountUsername: '',
					linkedAccountPassword: '',
					lastPasswordEntered: '',
				});

				setFormState($ctrl.FORM_STATES.usernameView);
			}

			function usernameViewSubmit() {
				
				setFormState($ctrl.FORM_STATES.loading);
				// Call the API to see if this user has already migrated to identity
				securityData.getSigninStartType($ctrl.linkedAccountUsername)
					.then((identityData) => {
						if (utilities.toCamelCase(identityData.Type) === LOGIN_TYPES.accessIdentity) {
							setFormState($ctrl.FORM_STATES.cantBeLinkedView);
						} else {
							setFormState($ctrl.FORM_STATES.passwordView);
						}
					})
					.catch((error) => {
						console.error(error);
						setFormState(FORM_STATES.error);
					});
			}

			function onUsernameChange(linkedAccountUsernameFormField) {

				// Don't allow current username to be entered. Who knows what will happen otherwise ...
				const sameAsExisting = $ctrl.linkedAccountUsername === $rootScope.currentUser.UserResponseUsername;
				linkedAccountUsernameFormField.$setValidity('sameAsExisting', !sameAsExisting);
			}

			function onSubmit(formObj) {
				formObj.state = 'saving';
				disableWhileLoading(true);
				securityData.linkAccounts($ctrl.userId, $ctrl.linkedAccountUsername, $ctrl.linkedAccountPassword).then((responseCode) => {

					switch (responseCode) {
						case PASSWORD_INVALID_RESPONSE:
							formObj['linkedAccountPassword'].$setValidity(PASSWORD_INVALID, false);
							formObj.state = null;
							disableWhileLoading(false);
							$ctrl.lastPasswordEntered = $ctrl.linkedAccountPassword;
							break;

						default:
							setFormState(FORM_STATES.success);
							formObj.state = 'saved';
							$ctrl.formOptions.forceCallback();
							$rootScope.$broadcast('refreshLinkedAccounts');
					}
				})
					.catch((error) => {
						console.log(error);
						switch (error.data) {
							case ACCOUNT_ALREADY_MIGRATED:
								setFormState($ctrl.FORM_STATES.cantBeLinkedView);
								break;
							case ACCOUNTS_NONEIDENTITY:
								setFormState($ctrl.FORM_STATES.accountsNoneIdentity);
								break;
							case ACCOUNTS_ADMIN_NONEIDENTITY:
								setFormState($ctrl.FORM_STATES.accountsAdminNoneIdentity);
								break;
							case NOT_SAME_USER:
								setFormState($ctrl.FORM_STATES.notSameUser);
								break;
							default:
								console.error(error);
								setFormState($ctrl.FORM_STATES.error);
								formObj.state = null;
						}

					});
			}

			function onPasswordChange(formObj) {

				if ($ctrl.lastPasswordEntered && $ctrl.linkedAccountPassword === $ctrl.lastPasswordEntered) {
					formObj['linkedAccountPassword'].$setValidity(PASSWORD_INVALID, false);
				}
				else {
					// Clear invalid flag on current password
					formObj['linkedAccountPassword'].$setValidity(PASSWORD_INVALID, true);
				}
			}

			function setFormState(formState) {
				$ctrl.formState = formState;
			}

			function disableWhileLoading(disabled) {
				
				$ctrl.isDisabled = disabled;
			}

			angular.extend($ctrl, {
				FORM_STATES,
				$onInit,
				onUsernameChange,
				onPasswordChange,
				usernameViewSubmit,
				onSubmit
			});
		}
	]);
'use strict';

angular.module('paycircleApp')

	.component('unlinkAccountsForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'unlinkAccountsFormCtrl',
		templateUrl: 'modules/security/forms/unlink-accounts/unlink-accounts.form.html',
	})
	.controller('unlinkAccountsFormCtrl', [
		'$rootScope',
		'securityData',
		function (
			$rootScope,
			securityData
		) {

			const $ctrl = this;

			const FORM_STATES = {
				loading: 'loading',
				error: 'error',
				success: 'success',
				unlink: 'unlinkView'
			};

			function init() {

				setFormState(FORM_STATES.unlink);
			}

			function unlinkAccount() {
				setFormState(FORM_STATES.loading);
				securityData.unlinkAccounts($ctrl.formOptions.userId,  $ctrl.formOptions.linkedAccount.UserID)
					.then(() => {
						setFormState(FORM_STATES.success);
						$ctrl.formOptions.forceCallback();
						$rootScope.$broadcast('refreshLinkedAccounts');
					})
					.catch((error) => {
						console.error(error);
						setFormState(FORM_STATES.error);
					});
			}

			function closeForm() {
				$ctrl.formOptions.closeForm();
			}

			function setFormState(formState) {
				$ctrl.formState = formState;
			}

			init();

			angular.extend($ctrl, {
				FORM_STATES,
				closeForm,
				unlinkAccount
			});
		}
	]);

'use strict';

angular.module('paycircleApp')

.component('appBrowserCompatibilityWarningModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'appBrowserCompatibilityWarningModalController',
	templateUrl: 'modals/app/browser-compatibility-warning/app-browser-compatibility-warning.modal.html'
})

.controller('appBrowserCompatibilityWarningModalController', [
	'coralogixService',
	'BROWSER_COMPATIBILITY_LIST',
	function (
		coralogixService,
		BROWSER_COMPATIBILITY_LIST
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		$ctrl.modalOptions.onClose = () => {
			// Don't show the warning again during this session, but do pester the user next time they visit.
			sessionStorage.setItem('browserWarning', '1');

			// Store tag in any following error logs
			coralogixService.setCustomAttribute('user_dismissed_browser_warning', true);
		};
	};

	angular.extend($ctrl, {
		BROWSER_COMPATIBILITY_LIST
	});

}]);
'use strict';

angular.module('paycircleApp')
.component('smartViewFeedbackModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'smartViewFeedbackModalCtrl',
	templateUrl: 'modals/app/smart-view-feedback/smart-view-feedback.modal.html',
})
.controller('smartViewFeedbackModalCtrl', [
	'messageData',
	'$rootScope',
	function (messageData, $rootScope) {

	const $ctrl = this;

	function $onInit() {
		$ctrl.modalState = 'ready';
		$ctrl.feedback = {
			text: '',
			type: $ctrl.modalOptions.modalData.feedbackType
		};
		$ctrl.characterCount = 0;
		$ctrl.maxCharacters = 200;
		$ctrl.userName = $rootScope.currentUser.UserResponseFirstName;
        $ctrl.showConfetti = false;
	}

	function updateCharacterCount() {
		$ctrl.characterCount = $ctrl.feedback.text.length;
	}

	function submitFeedback() {

        if ($ctrl.modalOptions) {
			if (typeof $ctrl.modalOptions.onSubmit === 'function') {
				$ctrl.modalOptions.onSubmit($ctrl.feedback.text);
			} else if ($ctrl.modalOptions.modalData && typeof $ctrl.modalOptions.modalData.onSubmit === 'function') {
				$ctrl.modalOptions.modalData.onSubmit($ctrl.feedback.text);
			}
			$ctrl.modalState = 'success';
			$ctrl.showConfetti = true;
		} else {
			$ctrl.modalState = 'error';
		}
	}

	angular.extend($ctrl, {
		$onInit,
		updateCharacterCount,
		submitFeedback
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('cookiePreferencesModal', {
	bindings: {
		modalOptions: '<'
	},
	controller: 'cookiePreferencesModalCtrl',
	templateUrl: 'modals/app/cookie-preferences/cookie-preferences.modal.html',
})
.controller('cookiePreferencesModalCtrl', [
	'$scope',
	'config',
	'cookieConsentService',
	'COOKIE_CONSENT_KEYS',
	function (
		$scope,
		config,
		cookieConsentService,
		COOKIE_CONSENT_KEYS
	) {

		const $ctrl = this;

		function getCookieCategories() {

			return [
					{
						key: COOKIE_CONSENT_KEYS.categories.essential,
						name: 'Essential Website Cookies',
						icon: 'shield',
						shortDescription: 'These cookies are necessary for the website to function properly and cannot be disabled. They enable core functionality such as security, network management, and accessibility.',
						description: 'These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.',
						required: true,
					},
					{
						key: COOKIE_CONSENT_KEYS.categories.analytics,
						name: 'Analytics & Performance',
						icon: 'chart-bar',
						shortDescription: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
						description: 'These cookies collect information that is used either in aggregate form to help us understand how our Websites are being used or how effective our marketing campaigns are, or to help us customise our Websites for you.',
						required: false,
					}
			];
		}

		function $onInit () {

			const preferences = cookieConsentService.getConsentPreferences() || {};
				
			$ctrl.showInitialConsent = !cookieConsentService.hasShownBanner();
			
			$ctrl.preferences = {
				[COOKIE_CONSENT_KEYS.categories.essential]: true,
				[COOKIE_CONSENT_KEYS.categories.analytics]: preferences.analytics || false
			};
			
			$ctrl.expandedCategories = {
				[COOKIE_CONSENT_KEYS.categories.essential]: false,
				[COOKIE_CONSENT_KEYS.categories.analytics]: false
			};
			
			$ctrl.cookieCategories = getCookieCategories();
		}

		function setPreferencesAndSave (analytics) {

			$ctrl.preferences[COOKIE_CONSENT_KEYS.categories.analytics] = analytics;
			savePreferences();
		}

		function savePreferences () {

			cookieConsentService.setConsent(COOKIE_CONSENT_KEYS.categories.analytics, $ctrl.preferences[COOKIE_CONSENT_KEYS.categories.analytics]);
			cookieConsentService.setBannerShown();
			
			$scope.$emit('cookieConsentChanged');
			$ctrl.modalOptions.closeModal();
		}

		function acceptAll () {

			setPreferencesAndSave(true);
		}

		function rejectAll () {

			setPreferencesAndSave(false);
		}

		function toggleCategory (categoryKey) {

			$ctrl.expandedCategories[categoryKey] = !$ctrl.expandedCategories[categoryKey];
		}

		function showManagePreferences () {

			$ctrl.showInitialConsent = false;
		}

		function requiredOnly () {

			setPreferencesAndSave(false);
		}

	function acceptAllFromInitial () {

		setPreferencesAndSave(true);
	}
		
	angular.extend($ctrl, {
		$onInit,
		acceptAll,
		acceptAllFromInitial,
		cookiePolicyUrl: config.externalUrls.policyUrls.cookiePolicy,
		rejectAll,
		requiredOnly,
		savePreferences,
		showManagePreferences,
		toggleCategory
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('leaveDateExpiredModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/employment/leave-date-expired/leave-date-expired.modal.html',
});

'use strict';

/**
 * Generic 'information' modal. Simply displays some information and a close button.
 * modalOptions structure should be:
 * {
 * 		title: string -- Title of modal dialog
 * 		type: MODAL_GENERIC_TYPES.information -- Not required for the component itself,
 * 			this is what will cause this component to be instantiated. See modal-cabinet.component.html
 * 		information: [
 * 			{
 * 				type: 'text' or 'list'
 * 				content: string or Array<string> -- for type 'text' (string array will be joined by ' ', this
 * 						 exists only for code formatting, to allow long text to be broken up),
 * 						 Array<string> -- for type 'list'
 * 			}
 * 			... Repeat as required ...
 * 		],
 * 		closeButtonLabel: string -- text to display in Close button. Defaults to 'Close'.
 * 		See modal-options.constant.js for examples.
 * }
 */
angular.module('paycircleApp')
.component('informationModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'informationModalCtrl',
	templateUrl: 'modals/generic/information/information.modal.html'
})

.controller('informationModalCtrl', function () {

	const $ctrl = this;

	$ctrl.$onInit = () => {
		/* Convert text information presented as an array into a single string. The Array<string> option is available
		   just for code formatting. */
		if ($ctrl.modalOptions.information) {
			$ctrl.modalOptions.information.forEach(informationItem => {
				if (informationItem.type === 'text' && angular.isArray(informationItem.content)) {
					informationItem.content = informationItem.content.join(' ');
				}
			});
		}
	};
});
'use strict';

angular.module('paycircleApp')
.component('importsDuplicateMappingHeadersModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'importsDuplicateMappingHeadersModalCtrl',
	templateUrl: 'modals/imports/duplicate-mapping-headers/imports-duplicate-mapping-headers.modal.html',
})
.controller('importsDuplicateMappingHeadersModalCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		$ctrl.modalOptions.modalData.fileColumnsDisplay = getFileColumnsDisplay();
	}

	/**
	 * Populates a simple string array for the bullet list
	**/
	function getFileColumnsDisplay () {

		let returnArr = [];

		$ctrl.modalOptions.modalData.fileColumns.forEach(_ => {
			returnArr.push(_.importMappingColumnText);
		});

		return returnArr;
	}

	angular.extend($ctrl, {
		$onInit
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('importsLeaversModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/imports/leavers/imports-leavers.modal.html',
});

'use strict';

angular.module('paycircleApp')
.component('importsNothingToImportModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/imports/nothing-to-import/imports-nothing-to-import.modal.html',
});

'use strict';

angular.module('paycircleApp')

.component('payrollResetPeriodModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'payrollResetPeriodModalCtrl',
	templateUrl: 'modals/payroll/reset-period/payroll-reset-period.modal.html'
})
.controller('payrollResetPeriodModalCtrl', [
	'SUBMISSION_LOG_TYPE',
	function (
		SUBMISSION_LOG_TYPE
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		submissionLogType: SUBMISSION_LOG_TYPE.payPeriod
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('sessionTimedOutModal', {
	bindings: {
		modalOptions: '=?'
	},
	controller: 'sessionTimedOutModalCtrl',
	templateUrl: 'modals/session/timed-out/session-timed-out.modal.html'
}).controller('sessionTimedOutModalCtrl', [
	'$stateParams',
	'$window',
	'securityData',
	'utilities',
	'LOCAL_STORAGE_KEYS',
	function (
		$stateParams,
		$window,
		securityData,
		utilities,
		LOCAL_STORAGE_KEYS
	) {

	const $ctrl = this;

	function clickSignIn () {

		if ($stateParams.isAccessIdentityAccount) {

			securityData.signInAfterTimeout($stateParams.accountEmailAddress)
				.then((data) => {
					// Save the nonce to the local storage
					utilities.addToStorage(LOCAL_STORAGE_KEYS.nonce, data.Nonce);
					// Redirect to identity
					$window.open(data.IdentityUrl, '_self');
			});
		} else {
			$ctrl.modalOptions.closeModal();
		}
	}

	angular.extend($ctrl, {
		clickSignIn
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('sessionTimeoutWarningModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'sessionTimeoutWarningModalController',
	templateUrl: 'modals/session/timeout-warning/session-timeout-warning.modal.html'
})

.controller('sessionTimeoutWarningModalController', [
	'$interval',
	'session',
	function(
		$interval,
		session
	) {

	const $ctrl = this;

	$ctrl.$onInit = () => {

		$ctrl.interval = getCountdownInterval($ctrl.modalOptions.modalData.timeoutPeriodSeconds);
	};

	function getCountdownInterval (timeoutPeriodSeconds) {

		$ctrl.countdown = timeoutPeriodSeconds;

		return $interval(() => {

			if ($ctrl.countdown > 0) {
				$ctrl.countdown--;
				$ctrl.percentageRemaining = (($ctrl.countdown / timeoutPeriodSeconds) * 100);
			}
			else {
				/* Why nothing like $broadcast(AUTH_EVENTS.sessionTimeout) ? ...
				   Because session timeout management happens in the session service. */
				// This block is here just for the above comment. Do nowt, but don't upset jslint.
				angular.noop();
			}
		}, 1000, timeoutPeriodSeconds);
	}

	function onExtendSession () {

		$ctrl.modalOptions.closeModal();
		session.extend();
	}

	angular.extend($ctrl, {
		onExtendSession
	});

}]);
'use strict';

angular.module('paycircleApp')

.component('settingsJournalCodePreviewInfoModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/settings/journal-code-preview-info/settings-journal-code-preview-info.modal.html'
});

'use strict';

angular.module('paycircleApp')

.component('settingsJournalNominalCodesAllocationReportModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/settings/journal-nominal-codes-allocation-report/settings-journal-nominal-codes-allocation-report.modal.html'
});
'use strict';

angular.module('paycircleApp')
.component('settingsPayElementTypeModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'settingsPayElementTypeModalCtrl',
	templateUrl: 'modals/settings/pay-element-type/settings-pay-element-type.modal.html',
})
.controller('settingsPayElementTypeModalCtrl', [
	'ADJUSTMENT_VALUE_TYPES',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'INTERFACE_TYPES',
	function (
		ADJUSTMENT_VALUE_TYPES,
		ADJUSTMENT_BEHAVIOUR_STATES,
		INTERFACE_TYPES
	) {

	const $ctrl = this;

	angular.extend($ctrl, {
		ADJUSTMENT_VALUE_TYPES,
		ADJUSTMENT_BEHAVIOUR_STATES,
		INTERFACE_TYPES
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('teamAdvancePayPeriodsModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'teamAdvancePayPeriodsModalCtrl',
	templateUrl: 'modals/team/advance-pay-periods/team-advance-pay-periods.modal.html',
})
.controller('teamAdvancePayPeriodsModalCtrl', [function () {

	const $ctrl = this;

	function onContinue () {
		$ctrl.modalOptions.closeModal();
		$ctrl.modalOptions.callback();
	}

	angular.extend($ctrl, {
		onContinue
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('teamBulkDeleteSummaryModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'teamBulkDeleteSummaryModalCtrl',
	templateUrl: 'modals/team/bulk-delete-summary/bulk-delete-summary.modal.html',
})
.controller('teamBulkDeleteSummaryModalCtrl', [
	'$rootScope',
	'bulkService',
	function (
		$rootScope,
		bulkService
	) {

	const $ctrl = this;

	function openDeleteTeamMembersForm () {

		$ctrl.modalOptions.closeModal();

		const selectedTeamMemberIdsArr = bulkService.getValuesFromSelectedItems($ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted, 'UserID');

		$rootScope.openSlideInForm({
			agencyProfileId: $ctrl.modalOptions.modalData.agencyProfileId,
			callback: $ctrl.modalOptions.modalData.callback,
			contextType: selectedTeamMemberIdsArr.length > 1 ? 'company' : 'user',
			formKey: 'delete-team-member',
			title: selectedTeamMemberIdsArr.length > 1 ? 'Delete team members' : null,
			userId: selectedTeamMemberIdsArr.length === 1 ? selectedTeamMemberIdsArr[0] : undefined,
			userIds: selectedTeamMemberIdsArr.length > 1 ? selectedTeamMemberIdsArr : undefined
		});
	}

	angular.extend($ctrl, {
		openDeleteTeamMembersForm
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('teamCorrectionalSubmissionModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'teamCorrectionalSubmissionModalCtrl',
	templateUrl: 'modals/team/correctional-submission/team-correctional-submission.modal.html',
})
.controller('teamCorrectionalSubmissionModalCtrl', [function () {

	const $ctrl = this;

	function onContinue () {
		$ctrl.modalOptions.closeModal();
		$ctrl.modalOptions.callback();
	}

	angular.extend($ctrl, {
		onContinue
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('teamExcludedFromRtiModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/team/excluded-from-rti/team-excluded-from-rti.modal.html',
});

'use strict';

angular.module('paycircleApp')

.component('teamFurloughModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/team/furlough/team-furlough.modal.html'
});
'use strict';

angular.module('paycircleApp')

.component('teamInviteToRegisterModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/team/invite-to-register/team-invite-to-register.modal.html'
});
'use strict';

angular.module('paycircleApp')
.component('teamMarkAsOnHoldOrActiveModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'teamMarkAsOnHoldOrActiveModalCtrl',
	templateUrl: 'modals/team/mark-as-on-hold-or-active/team-mark-as-on-hold-or-active.modal.html',
})
.controller('teamMarkAsOnHoldOrActiveModalCtrl', [function () {

	const $ctrl = this;

	function onContinue () {
		$ctrl.modalOptions.closeModal();
		$ctrl.modalOptions.callback();
	}

	angular.extend($ctrl, {
		onContinue
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('teamSupplementaryPayRunModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/team/supplementary-pay-run/team-supplementary-pay-run.modal.html'
});
'use strict';

angular.module('paycircleApp')

.component('teamManageRolledUpHolidayModal', {
	bindings: {
		modalOptions: '='
	},
	templateUrl: 'modals/team/manage-rolled-up-holiday/team-manage-rolled-up-holiday.modal.html'
});
'use strict';

angular.module('paycircleApp')
.component('teamUnmarkAsAdvancingModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'teamUnmarkAsAdvancingModalCtrl',
	templateUrl: 'modals/team/unmark-as-advancing/team-unmark-as-advancing.modal.html',
})
.controller('teamUnmarkAsAdvancingModalCtrl', [function () {

	const $ctrl = this;

	function onContinue () {
		$ctrl.modalOptions.closeModal();
		$ctrl.modalOptions.callback();
	}

	angular.extend($ctrl, {
		onContinue
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('workflowDraftReportsModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'workflowModalCtrl',
	templateUrl: 'modals/workflow/draft-reports/workflow-draft-reports.modal.html',
});
'use strict';

angular.module('paycircleApp')
.component('workflowPayrollInformationModal', {
	bindings: {
		modalOptions: '='
	},
	controller: 'workflowModalCtrl',
	templateUrl: 'modals/workflow/payroll-information/workflow-payroll-information.modal.html',
});
'use strict';

angular.module('paycircleApp')
.controller('workflowModalCtrl', [
	'growl',
	'messageData',
	'SPLASH_STATES',
	function (
		growl,
		messageData,
		SPLASH_STATES
	) {

	const $ctrl = this;

	function updateWorkflowTemplateEntrySplashState ($ctrl) {

		$ctrl.modalOptions.closeModal();

		// Async to avoid delayed response to close modal
		messageData.updateWorkflowTemplateEntrySplashState($ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.WorkflowTemplateEntryID, SPLASH_STATES.complete).catch(error => {
			console.error(error);
			throw('Unable to update workflow template entry splash state');
		});
	}

	angular.extend($ctrl, {
		updateWorkflowTemplateEntrySplashState
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('askMyAdvisorForm', function () {

	return {
		controller: 'askMyAdvisorFormCtrl',
		templateUrl: 'forms/onboarding/askMyAdvisor/askMyAdvisorForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('askMyAdvisorFormCtrl', ['$rootScope', '$scope', 'companyData', 'onboardingService', 'utilities', function ($rootScope, $scope, companyData, onboardingService, utilities) {

	const RELATIONSHIP_TYPES = [
		{
			name: 'Accountant',
			value: 'Accountant'
		},
		{
			name: 'Advisor',
			value: 'Advisor'
		}
	];

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var forename = $rootScope.currentUser.UserResponseFirstName;

	function init () {

		setPageState('loading');
		companyData.getOnboardingDashboard(agencyProfileId).then(function (onboardingDashboardObj) {

			$scope.vm = {
				name: '',
				email: '',
				relationshipType: null,
				message: onboardingService.getMessageFromSkippedQuestions(onboardingDashboardObj, forename),
				mailTo: utilities.getMailToFromMessage(onboardingDashboardObj, forename)
			};

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.RELATIONSHIP_TYPES = RELATIONSHIP_TYPES;

	$scope.openEmailClient = function (vmObj) {

		var mailToObj = {
			subject: 'Can you help?',
			body: vmObj.message,
			toAddress: vmObj.email
		};

		var mailToUri = utilities.getMailToFromMessage(mailToObj);

		window.location.href = mailToUri;
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauChangeCompanyStateForm', function () {

	return {
		controller: 'bureauChangeCompanyStateFormCtrl',
		templateUrl: 'forms/onboarding/bureauChangeCompanyState/bureauChangeCompanyStateForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauChangeCompanyStateFormCtrl', ['$rootScope', '$scope', '$state', 'companyData', 'COMPANY_STATES', 'securityData', function ($rootScope, $scope, $state, companyData, COMPANY_STATES, securityData) {

	var newCompanyState = $scope.formOptions.newCompanyState;
	var companyObj = $scope.formOptions.company;

	function init () {

		setPageState('loading');

		switch (companyObj.State) {
			case COMPANY_STATES.onboarding:
				setPageState(companyObj.OnboardingPercentComplete < 100 ? 'disabled' : 'confirm');
				break;
			case COMPANY_STATES.firstPeriod:
				setPageState(companyObj.FirstPeriodPercentComplete < 100 ? 'disabled' : 'confirm');
				break;
			default:
				setPageState('confirm');
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.COMPANY_STATES = COMPANY_STATES;
	
	$scope.openOnboardingChecklistForm = function (companyObj) {

		$scope.formOptions.openNewSlideInForm({
			company: companyObj,
			formKey: 'onboarding-bureau-onboarding-checklist',
			title: 'Onboarding checklist',
			contextType: 'company',
			showContext: true
		});
	};

	$scope.updateCompanyState = function (companyObj) {

		switch (newCompanyState) {

			// Move to onboarding
			case COMPANY_STATES.onboarding:

				securityData.onboardingConversion(companyObj.AgencyProfileID).then(function() {
					$scope.formOptions.forceCallback();
					setPageState('saved');
				})
				.catch(function() {
					setPageState('error');
				});
				break;

			// Move to first pay period
			case COMPANY_STATES.firstPeriod:

				securityData.onboardingToFirstPeriod(companyObj.AgencyProfileID).then(function() {
					$scope.formOptions.forceCallback();
					setPageState('saved');
				})
				.catch(function() {
					setPageState('error');
				});
				break;

			// Generic state change
			default:

				var agencyProfileID; // undefined

				companyData.updateOnboardingState($scope.company.OnboardingID, agencyProfileID, $scope.formOptions.newCompanyState).then(function() {
					$scope.formOptions.forceCallback();
					setPageState('saved');
				})
				.catch(function () {
					setPageState('error');
				});
		}
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauNewCompanyForm', function () {

	return {
		controller: 'bureauNewCompanyFormCtrl',
		templateUrl: 'forms/onboarding/bureauNewCompany/bureauNewCompanyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauNewCompanyFormCtrl', ['$scope', 'companyData', 'growl', function ($scope, companyData, growl) {

	var agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	var companyObj = $scope.formOptions.companyObj;
	var isDemonstration = $scope.formOptions.isDemonstration;

	function createOnboardingCompany (companyObj, formObj) {

		formObj.state = 'saving';

		companyData.createOnboardingCompany(agencyProfileParentId, companyObj.Name, companyObj.AdminForename, companyObj.AdminSurname, companyObj.AdminEmail, companyObj.DelaySend, companyObj.Demonstration, companyObj.AdminTelephone).then(function() {

			$scope.formOptions.forceCallback();
			
			formObj.state = 'saved';

			setPageState('saved');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function init () {

		// Onboarding company already created = Invite only
		if (companyObj !== undefined) {

			companyObj.context = 'invite';
			companyObj.DelaySend = false;
			companyObj.Demonstration = false;

			$scope.company = companyObj;
		}

		// New company
		else {

			$scope.company = {
				context: 'create',
				Name: '',
				DelaySend: isDemonstration ? false : true, // Do not send an invitation 
				Demonstration: isDemonstration,
				AdminEmail: '',
				AdminForename: '',
				AdminSurname: '',
				AdminTelephone: ''
			};
		}

		setPageState('ready');
	}

	function reviewCompany (companyObj, formObj) {

		switch (companyObj.context) {
			case 'invite':
				updateOnboardingCompany(companyObj, formObj);
				break;
			case 'create':
				createOnboardingCompany(companyObj, formObj);
				break;
		}
	}

	function updateOnboardingCompany (companyObj, formObj) {

		formObj.state = 'saving';

		companyData.updateOnboardingCompany(companyObj.OnboardingID, agencyProfileParentId, companyObj.Name, companyObj.AdminForename, companyObj.AdminSurname, companyObj.AdminEmail, companyObj.AdminTelephone, companyObj.DelaySend).then(function () {

			$scope.formOptions.forceCallback();

			if (companyObj.DelaySend) {
				growl.success(companyObj.Name + ' has been updated');
			}
			else {
				growl.success(companyObj.AdminForename + ' has been sent an invitation');
			}

			$scope.formOptions.closeForm();
			
			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.reviewCompany = function (companyObj, formObj) {

		reviewCompany(companyObj, formObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauExtendTrialForm', function () {

	return {
		controller: 'bureauExtendTrialFormCtrl',
		templateUrl: 'forms/onboarding/bureauExtendTrial/bureauExtendTrialForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauExtendTrialFormCtrl', ['$scope', 'config', 'companyData', function ($scope, config, companyData) {

	function init () {

		$scope.company = $scope.formOptions.company;

		$scope.pageState = 'ready';
	}

	init();

	$scope.extendFreeTrial = function () {

		companyData.updateOnboardingTrialExpiryDate($scope.company.OnboardingID, config.guidEmpty).then(function() {

			$scope.pageState = 'saved';
			$scope.formOptions.forceCallback();
		})
		.catch(function() {

			$scope.pageState = 'error';
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauEditFirstPeriodForm', function () {

	return {
		controller: 'bureauEditFirstPeriodFormCtrl',
		templateUrl: 'forms/onboarding/bureauEditFirstPeriod/bureauEditFirstPeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauEditFirstPeriodFormCtrl', ['$scope', 'companyData', function ($scope, companyData) {

	function init () {

		$scope.pageState = 'loading';

		$scope.company = $scope.formOptions.company;

		$scope.company.goLiveDateMinIso = moment().format();

		$scope.pageState = 'ready';
	}

	init();

	$scope.saveForm = function (formObj, form) {

		form.state = 'saving';

		companyData.updateOnboardingGoLiveDate($scope.company.AgencyProfileID, $scope.company.GoLiveDateISO).then(function() {

			$scope.formOptions.callback();
			$scope.pageState = 'saved';
			form.state = 'saved';
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauMoveToLiveForm', function () {

	return {
		controller: 'bureauMoveToLiveFormCtrl',
		templateUrl: 'forms/onboarding/bureauMoveToLive/bureauMoveToLiveForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauMoveToLiveFormCtrl', ['$scope', function ($scope) {

	function init () {

		$scope.pageState = 'loading';

		$scope.company = $scope.formOptions.company;

		$scope.pageState = 'ready';
	}

	init();

	$scope.moveCompanyLive = function () {

		$scope.pageState = 'saved';

		$scope.formOptions.forceCallback();
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauDeleteCompanyForm', function () {

	return {
		controller: 'bureauDeleteCompanyFormCtrl',
		templateUrl: 'forms/onboarding/bureauDeleteCompany/bureauDeleteCompanyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauDeleteCompanyFormCtrl', ['$scope', 'companyData', 'growl', 'COMPANY_STATES', function ($scope, companyData, growl, COMPANY_STATES) {

	function deleteAgencyProfile (companyObj, vmObj) {

		companyData.deleteAgencyProfile(companyObj.AgencyProfileID).then(function () {

			setPageState('deleted');

			vmObj.state = 'saved';

			$scope.formOptions.forceCallback();
		})
		.catch(function () {
			growl.error('There was a problem deleting ' + companyObj.Name + '.');
			vmObj.state = null;
		});
	}

	function deleteAgencyProfileDemo (companyObj, vmObj) {

		companyData.deleteAgencyProfileDemo(companyObj.AgencyProfileID).then(function () {

			setPageState('deleted');

			vmObj.state = 'saved';

			$scope.formOptions.forceCallback();
		})
		.catch(function () {
			growl.error('There was a problem deleting ' + companyObj.Name + '.');
			vmObj.state = null;
		});
	}

	function init () {

		setPageState('confirm');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.company = $scope.formOptions.company;
	$scope.vm = {
		state: null
	};

	$scope.deleteCompany = function (companyObj, vmObj) {

		vmObj.state = 'saving';

		switch (companyObj.State) {

			case COMPANY_STATES.demo:
			case COMPANY_STATES.onboarding:
				deleteAgencyProfileDemo(companyObj, vmObj);
				break;
			default:
				deleteAgencyProfile(companyObj, vmObj);
		}
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauOnboardingChecklistForm', function () {

	return {
		controller: 'bureauOnboardingChecklistFormCtrl',
		templateUrl: 'forms/onboarding/bureauOnboardingChecklist/bureauOnboardingChecklistForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bureauOnboardingChecklistFormCtrl', ['$rootScope', '$scope', '$state', 'ADMIN_INVITE_STATES', 'companyData', 'onboardingService', function ($rootScope, $scope, $state, ADMIN_INVITE_STATES, companyData, onboardingService) {


	function init () {

		$scope.pageState = 'loading';
		$scope.ADMIN_INVITE_STATES = ADMIN_INVITE_STATES;
		$scope.company = $scope.formOptions.company;

		companyData.getOnboardingDashboard($scope.company.AgencyProfileID).then(function (onboardingDashboardObj) {

			onboardingDashboardObj = onboardingService.decorateOnboardingDashboardObj(onboardingDashboardObj);
			$scope.company.questions = onboardingDashboardObj.Questions.QuestionGroups;
		})
		.catch(function () {

			$scope.pageState = 'error';
		});

		$scope.pageState = 'ready';
	}

	init();

	$scope.saveForm = function (formObj, form) {

		// Update state
		form.state = 'saving';

		// Force callback
		$scope.formOptions.forceCallback();

		// Close form
		$scope.formOptions.closeForm();

		// Update state
		form.state = 'saved';
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('cancelTrialForm', function () {

	return {
		controller: 'cancelTrialFormCtrl',
		templateUrl: 'forms/onboarding/cancelTrial/cancelTrialForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cancelTrialFormCtrl', ['$rootScope', '$scope', 'companyData', 'growl', function ($rootScope, $scope, companyData, growl) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	$scope.company = $scope.formOptions.company;
	$scope.pageState = 'confirm';

	$scope.vm = {
		state: null
	};

	$scope.deleteCompany = function (companyObj, vmObj) {

		vmObj.state = 'saving';

		companyData.deleteAgencyProfileDemo(agencyProfileId).then(function () {

			growl.error('You have been logged out 👋');
			$rootScope.$broadcast('log-out');
		})
		.catch(function () {
			growl.error('There was a problem deleting ' + $scope.company.Name + '.');
			vmObj.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bureauMoveToOnboardingForm', function () {

	return {
		controller: 'bureauMoveToOnboardingFormCtrl',
		templateUrl: 'forms/onboarding/moveToOnboarding/moveToOnboardingForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('moveToOnboardingFormCtrl', ['$scope', 'securityData', function ($scope, securityData) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		$scope.company = $scope.formOptions.company;

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.moveCompanyToOnboarding = function () {

		securityData.onboardingConversion(agencyProfileId).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(function () {
			setPageState('error');
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('onboardingWizardCompanyForm', function () {

	return {
		controller: 'onboardingWizardCompanyCtrl',
		templateUrl: 'forms/onboarding/onboardingWizardCompany/onboardingWizardCompanyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('onboardingWizardCompanyCtrl', ['$scope', '$timeout', 'companyData', 'dataImportData', 'intercomService', 'onboardingService', 'tracking', 'ONBOARDING_QUESTIONS', 'TRACKING_EVENTS', function ($scope, $timeout, companyData, dataImportData, intercomService, onboardingService, tracking, ONBOARDING_QUESTIONS, TRACKING_EVENTS) {

	const COMPANY_TYPE_OPTIONS = [
		{
			name: 'Limited Liability Partnership (LLP)',
			value: 'Limited Liability Partnership (LLP)'
		},
		{
			name: 'Limited (LTD)',
			value: 'Limited (LTD)'
		},
		{
			name: 'Sole trader',
			value: 'Sole trader'
		},
		{
			name: 'Other',
			value: 'Other'
		}
	];
	const EMPLOYMENT_TYPE_OPTIONS = [
		{
			name: 'All full time',
			value: 'All full time'
		},
		{
			name: 'Mixture of full time and part time',
			value: 'Mixture of full time and part time'
		},
		{
			name: 'All part time',
			value: 'All part time'
		}
	];
	const SALARY_TYPE_OPTIONS = [
		{
			name: 'All paid salaries',
			value: 'All paid salaries'
		},
		{
			name: 'Mixture of salaried and hourly paid',
			value: 'Mixture of salaried and hourly paid'
		},
		{
			name: 'All paid hourly',
			value: 'All paid hourly'
		}
	];

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var formStep = $scope.formOptions.formStep !== undefined ? $scope.formOptions.formStep : 1;

	function constructHmrcCredentials (vmObj) {

		vmObj.hmrcCredentials = vmObj.hmrcUsername && vmObj.hmrcPassword ? `${vmObj.hmrcUsername}~${vmObj.hmrcPassword}` : '';
	}

	function constructPayeReference (vmObj) {

		vmObj.payeReference = vmObj.payeReference1 && vmObj.payeReference2 ? `${vmObj.payeReference1}/${vmObj.payeReference2}` : '';
	}

	function decorateQuestionsObj (vmObj) {

		// Break PAYE Reference down into 2 fields for better validation
		if (vmObj.payeReference !== '') {

			var payeRefParts = vmObj.payeReference.split('/');
			
			vmObj.payeReference1 = payeRefParts[0];
			vmObj.payeReference2 = payeRefParts[1];
		}

		// Break PAYE Reference down into 2 fields for better validation
		if (vmObj.hmrcCredentials && vmObj.hmrcCredentials !== '') {

			var hmrcCredentialsParts = vmObj.hmrcCredentials.split('~');
			
			vmObj.hmrcUsername = hmrcCredentialsParts[0];
			vmObj.hmrcPassword = hmrcCredentialsParts[1];
		}

		return vmObj;
	}

	function decrementActiveStep () {

		$scope.formOptions.activeStep--;
	}

	function getUpdatedQuestionObjByKey (vmObj, key, skipped) {

		return onboardingService.setQuestionValueForQuestionId(vmObj.companyQuestions, ONBOARDING_QUESTIONS.company[key], vmObj[key], skipped);
	}

	function incrementActiveStep () {

		$scope.formOptions.activeStep++;
	}

	function init () {

		setPageState('loading');

		companyData.getOnboardingDashboard(agencyProfileId).then(function (onboardingDashboardObj) {

			var companyQuestionsArray = onboardingService.getOnboardingQuestionsForQuestionGroupKey(onboardingDashboardObj, 'company');

			var vmObj = {
				companyQuestions: companyQuestionsArray,

				// Step 1
				companyType: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'companyType', null),
				companyNumber: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'companyNumber'),
				numberOfDirectors: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'numberOfDirectors', null),

				// Step 2
				employmentTypes: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'employmentTypes', null),
				salaryTypes: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'salaryTypes', null),

				// Step 3
				accountsOfficeReference: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'accountsOfficeReference'),
				accountsOfficeReferenceSkip: false,
				payeReference: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'payeReference'),
				payeReferenceSkip: false,

				// Step 4
				electronicUpdates: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'electronicUpdates', true) === 'true',
				hmrcCredentials: onboardingService.getCompanyQuestionValueForQuestionKey(companyQuestionsArray, 'hmrcCredentials'),
				hmrcCredentialsSkip: false,
				hmrcUsername: '',
				hmrcPassword: ''
			};

			decorateQuestionsObj(vmObj);

			$scope.formOptions.activeStep = formStep;
			$scope.formOptions.totalSteps = 4;
			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function resetHmrcCredentials (vmObj) {

		if (vmObj.hmrcCredentialsSkip) {
			vmObj.hmrcCredentials = '';
		}
	}

	function saveCompanyOnboarding (vmObj, formOptionsObj, form) {

		var updatedQuestionsArray = updateQuestionValues(vmObj, formOptionsObj);

		if (formOptionsObj.activeStep === 4 && vmObj.electronicUpdates && !vmObj.hmrcCredentialsSkip) {
			testHmrcCredentials(vmObj, updatedQuestionsArray, form);
		}
		else {			
			updateOnboardingQuestions(updatedQuestionsArray, form);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function testHmrcCredentials (vmObj, updatedQuestionsArray, form) {

		setPageState('testing-hmrc-credentials');

		// Give user time to digest feedback for testing the HMRC credentials
		$timeout(function () {

			dataImportData.getAreHMRCCredentialsValid(agencyProfileId, vmObj.hmrcUsername, vmObj.hmrcPassword).then(function (validationState) {

				switch (validationState) {
					case -1:
						setPageState('error');
						break;
					case -2:
						setPageState('hmrc-credentials-invalid');
						break;
					case -3:
						setPageState('automatic-updates-not-enabled');
						break;
					default:
						setPageState('ready');
						updateOnboardingQuestions(updatedQuestionsArray, form);
				}
			})
			.catch(function () {
				setPageState('hmrc-credentials-invalid');
			});

		}, 3000);
	}

	function updateOnboardingQuestions (updatedQuestionsArray, form) {

		form.state = 'saving';

		companyData.updateOnboardingQuestions(updatedQuestionsArray).then(function() {
			incrementActiveStep();
		})
		.catch(function () {
			setPageState('error');
		});	
	}

	function updateQuestionValues (vmObj, formOptionsObj) {

		var updatedQuestionsArray = [];

		switch (formOptionsObj.activeStep) {
			case 1:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'companyType'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'companyNumber'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'numberOfDirectors'));
				intercomService.updateCompanyData(agencyProfileId, {
					company_type: vmObj.companyType,
					number_of_directors: vmObj.numberOfDirectors
				});
				break;
			case 2:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'employmentTypes'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'salaryTypes'));
				intercomService.updateCompanyData(agencyProfileId, {
					employment_types: vmObj.employmentTypes,
					salary_types: vmObj.salaryTypes
				});
				break;
			case 3:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'accountsOfficeReference', vmObj.accountsOfficeReferenceSkip));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'payeReference', vmObj.payeReferenceSkip));
				break;
			case 4:
				constructHmrcCredentials(vmObj);
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'electronicUpdates', vmObj.hmrcCredentialsSkip));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'hmrcCredentials', vmObj.hmrcCredentialsSkip));
				tracking.trackEvent(TRACKING_EVENTS.onboardingCompanyCompleted);
				break;
		}

		return updatedQuestionsArray;
	}

	init();

	$scope.COMPANY_TYPE_OPTIONS = COMPANY_TYPE_OPTIONS;
	$scope.EMPLOYMENT_TYPE_OPTIONS = EMPLOYMENT_TYPE_OPTIONS;
	$scope.SALARY_TYPE_OPTIONS = SALARY_TYPE_OPTIONS;

	$scope.constructPayeReference = function (vmObj) {

		constructPayeReference(vmObj);
	};

	$scope.goToPreviousStep = function () {

		decrementActiveStep();
	};

	$scope.resetHmrcCredentials = function (vmObj) {

		resetHmrcCredentials(vmObj);
	};

	$scope.saveCompanyOnboarding = function (vmObj, formOptionsObj, form) {

		saveCompanyOnboarding(vmObj, formOptionsObj, form);
	};

	$scope.setActiveStep = function (activeStep) {

		$scope.formOptions.activeStep = activeStep;
	};

	$scope.setPageState = function (pageState) {

		setPageState(pageState);
	};
}]);


'use strict';

angular.module('paycircleApp')

.directive('onboardingWizardProfileForm', function () {

	return {
		controller: 'onboardingWizardProfileCtrl',
		templateUrl: 'forms/onboarding/onboardingWizardProfile/onboardingWizardProfileForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('onboardingWizardProfileCtrl', ['$scope', 'companyData', 'intercomService', 'onboardingService', 'tracking', 'ONBOARDING_QUESTIONS', 'TRACKING_EVENTS', function ($scope, companyData, intercomService, onboardingService, tracking, ONBOARDING_QUESTIONS, TRACKING_EVENTS) {

	const RELATIONSHIP_TYPE_OPTIONS = [
		{
			name: 'Company owner',
			value: 'Company owner'
		},
		{
			name: 'Company Director',
			value: 'Company Director'
		},
		{
			name: 'Company employee',
			value: 'Company employee'
		},
		{
			name: 'Payroll bureau',
			value: 'Payroll bureau'
		},
		{
			name: 'Accountant/adviser',
			value: 'Accountant/adviser'
		},
		{
			name: 'Other',
			value: 'Other'
		}
	];
	const PAYROLL_EXPERIENCE_OPTIONS = [
		{
			name: 'No experience',
			value: 'No experience'
		},
		{
			name: 'Basic experience',
			value: 'Basic experience'
		},
		{
			name: 'Fairly experienced',
			value: 'Fairly experienced'
		},
		{
			name: 'Very experienced',
			value: 'Very experienced'
		},
		{
			name: 'Qualified/professional',
			value: 'Qualified/professional'
		}
	];
	const INVOLVEMENT_TYPE_OPTIONS = [
		{
			name: 'I will be the only administrator on this account',
			value: 'I will be the only administrator on this account'
		},
		{
			name: 'Someone else in my company will be the main administrator on this account',
			value: 'Someone else in my company will be the main administrator on this account'
		},
		{
			name: 'An external adviser will be the administrator on this account',
			value: 'An external adviser will be the administrator on this account'
		},
		{
			name: 'There will be more than one administrator on this account',
			value: 'There will be more than one administrator on this account'
		}
	];
	const SOFTWARE_OPTIONS = [
		{
			name: 'Sage',
			value: 'Sage'
		},
		{
			name: 'HMRC Basic Tools',
			value: 'HMRC Basic Tools'
		},
		{
			name: 'Moneysoft',
			value: 'Moneysoft'
		},
		{
			name: 'BrightPay',
			value: 'BrightPay'
		},
		{
			name: 'Xero',
			value: 'Xero'
		},
		{
			name: 'Iris',
			value: 'Iris'
		},
		{
			name: 'Other',
			value: 'Other'
		},
		{
			name: 'None',
			value: 'None'
		},
		{
			name: 'Currently outsourced',
			value: 'Currently outsourced'
		},
		{
			name: 'I am setting up a new payroll/new company',
			value: 'I am setting up a new payroll/new company'
		}
	];
	const PAYROLL_COMPLEXITY_OPTIONS = [
		{
			name: 'It\'s very simple - we rarely make changes each pay period',
			value: 'It\'s very simple - we rarely make changes each pay period'
		},
		{
			name: 'It\'s average - we make a few changes each pay period',
			value: 'It\'s average - we make a few changes each pay period'
		},
		{
			name: 'It\'s fairly complex - we make a lot of changes/have complex adjustments',
			value: 'It\'s fairly complex - we make a lot of changes/have complex adjustments'
		},
		{
			name: 'It varies from pay period to pay period',
			value: 'It varies from pay period to pay period'
		}
	];
	const YES_NO_OPTIONS = [
		{
			name: 'Yes',
			value: 'Yes'
		},
		{
			name: 'No',
			value: 'No'
		},
	];
	const MODULE_OPTIONS = {
		payroll: 1,
		pension: 2,
		cis: 4
	};

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var formStep = $scope.formOptions.formStep !== undefined ? $scope.formOptions.formStep : 1;

	function constructActiveModules (vmObj) {

		vmObj.activeModules = 0;

		if (vmObj.isPayrollActive) {
			vmObj.activeModules += MODULE_OPTIONS.payroll;
		}
		if (vmObj.isWorkplacePensionActive) {
			vmObj.activeModules += MODULE_OPTIONS.pension;
		}
		if (vmObj.isCISActive) {
			vmObj.activeModules += MODULE_OPTIONS.cis;
		}

		return vmObj;
	}

	function decorateQuestionsObj (vmObj) {

		var activeModulesBit = vmObj.activeModules.toString();

		// Modules
		/* jshint eqeqeq:false */
		vmObj.isPayrollActive = MODULE_OPTIONS.payroll == (activeModulesBit & MODULE_OPTIONS.payroll.toString());
		vmObj.isWorkplacePensionActive = MODULE_OPTIONS.pension == (activeModulesBit & MODULE_OPTIONS.pension.toString());
		vmObj.isCISActive = MODULE_OPTIONS.cis == (activeModulesBit & MODULE_OPTIONS.cis.toString());
		/* jshint eqeqeq:true */

		return vmObj;
	}

	function decrementActiveStep () {

		$scope.formOptions.activeStep--;
	}

	function getUpdatedQuestionObjByKey (vmObj, key) {

		return onboardingService.setQuestionValueForQuestionId(vmObj.profileQuestions, ONBOARDING_QUESTIONS.profile[key], vmObj[key]);
	}

	function incrementActiveStep () {

		$scope.formOptions.activeStep++;
	}

	function init () {

		setPageState('loading');

		companyData.getOnboardingDashboard(agencyProfileId).then(function (onboardingDashboardObj) {

			var profileQuestionsArray = onboardingService.getOnboardingQuestionsForQuestionGroupKey(onboardingDashboardObj, 'profile');

			$scope.formOptions.activeStep = formStep;
			$scope.formOptions.totalSteps = 5;

			var vmObj = {
				profileQuestions: profileQuestionsArray,

				// Step 1
				relationshipToCompany: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'relationshipToCompany', null),
				payrollExperience: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'payrollExperience', null),

				// Step 2
				payrollInvolvement: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'payrollInvolvement', null),

				// Step 3
				existingPayrollSoftware: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'existingPayrollSoftware', null),
				payrollComplexityRating: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'payrollComplexityRating', null),

				// Step 4
				hasExternalAdvisor: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'hasExternalAdvisor', null),
				externalAdvisorInvolvement: onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'externalAdvisorInvolvement', null),
				activeModules: parseInt(onboardingService.getProfileQuestionValueForQuestionKey(profileQuestionsArray, 'activeModules', 0))
			};

			$scope.vm = decorateQuestionsObj(vmObj);

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function resetElectronicUpdatesEnabled (vmObj) {

		if (vmObj.electronicUpdatesEnabledSkip) {
			vmObj.electronicUpdatesEnabled = null;
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateQuestionValues (vmObj, formOptionsObj) {

		var updatedQuestionsArray = [];

		switch (formOptionsObj.activeStep) {
			case 1:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'relationshipToCompany'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'payrollExperience'));
				intercomService.updateData({
					relationship_to_company: vmObj.relationshipToCompany,
					payroll_experience: vmObj.payrollExperience
				});
				break;
			case 2:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'payrollInvolvement'));
				intercomService.updateData({
					payroll_involvement: vmObj.payrollInvolvement
				});
				break;
			case 3:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'existingPayrollSoftware'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'payrollComplexityRating'));
				intercomService.updateCompanyData(agencyProfileId, {
					existing_payroll_software: vmObj.existingPayrollSoftware,
					payroll_complexity_rating: vmObj.payrollComplexityRating
				});
				break;
			case 4:
				vmObj = constructActiveModules(vmObj);
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'activeModules'));
				break;
			case 5:
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'hasExternalAdvisor'));
				updatedQuestionsArray.push(getUpdatedQuestionObjByKey(vmObj, 'externalAdvisorInvolvement'));
				intercomService.updateCompanyData(agencyProfileId, {
					has_external_advisor: vmObj.hasExternalAdvisor,
					external_advisor_involvement: vmObj.externalAdvisorInvolvement
				});
				tracking.trackEvent(TRACKING_EVENTS.onboardingProfileCompleted);
				break;
		}

		return updatedQuestionsArray;
	}

	init();

	$scope.RELATIONSHIP_TYPE_OPTIONS = RELATIONSHIP_TYPE_OPTIONS;
	$scope.PAYROLL_EXPERIENCE_OPTIONS = PAYROLL_EXPERIENCE_OPTIONS;
	$scope.INVOLVEMENT_TYPE_OPTIONS = INVOLVEMENT_TYPE_OPTIONS;
	$scope.SOFTWARE_OPTIONS = SOFTWARE_OPTIONS;
	$scope.PAYROLL_COMPLEXITY_OPTIONS = PAYROLL_COMPLEXITY_OPTIONS;
	$scope.YES_NO_OPTIONS = YES_NO_OPTIONS;

	$scope.goToPreviousStep = function () {

		decrementActiveStep();
	};

	$scope.resetElectronicUpdatesEnabled = function (vmObj) {

		resetElectronicUpdatesEnabled(vmObj);
	};

	$scope.setActiveStep = function (activeStep) {

		$scope.formOptions.activeStep = activeStep;
	};

	$scope.updateExternalAdvisorInvolvement = function (vmObj) {

		if (vmObj.hasExternalAdvisor === 'No') {
			vmObj.externalAdvisorInvolvement = 'No';
		} else {
			vmObj.externalAdvisorInvolvement = null;
		}
		for (var questionObj of vmObj.profileQuestions) {
			if (questionObj.TaskID === ONBOARDING_QUESTIONS.profile.externalAdvisorInvolvement) {
				questionObj.showBlock = vmObj.hasExternalAdvisor === 'No' ? false : true;
			}
		}
	};

	$scope.saveCompanyOnboarding = function (vmObj, formOptionsObj, form) {

		var updatedQuestionsArray = updateQuestionValues(vmObj, formOptionsObj);

		form.state = 'saving';

		companyData.updateOnboardingQuestions(updatedQuestionsArray).then(function() {

			incrementActiveStep();
		})
		.catch(function () {
			setPageState('error');
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('unlockApprovePayrollForm', function () {

	return {
		controller: 'unlockApprovePayrollFormCtrl',
		templateUrl: 'forms/onboarding/unlockApprovePayroll/unlockApprovePayrollForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('unlockApprovePayrollFormCtrl', ['$scope', 'companyData', 'payrollData', function ($scope, companyData, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.saveForm = function (formObj, form) {

		// Update state
		form.state = 'saving';

		// Service call
		companyData.saveForm(userId, agencyProfileId).then(function () {

			// Force callback
			$scope.formOptions.forceCallback();

			// Close form
			$scope.formOptions.closeForm();

			// Update state
			form.state = 'saved';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';

			// Form state
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.component('alignTeamMemberMappingsIntegrationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'alignTeamMemberMappingsIntegrationFormCtrl',
	templateUrl: 'forms/admin/align-team-member-mappings-integration/align-team-member-mappings-integration.form.html',
})

.controller('alignTeamMemberMappingsIntegrationFormCtrl', [
	'$q',
	'dataTransfer',
	'teamData',
	function (
		$q,
		dataTransfer,
		teamData
	) {

	const view = {
		actions: 'actions',
		confirm: 'confirm',
		processing: 'processing',
		complete: 'complete'
	};

	const $ctrl = this;
	const clickAction = {
		autoMapIncomingEmployees: () => {
			const api = () => 
				teamData.autoMapIncomingEmployees(agencyProfileId)
				.then(res => downloadReturnedFile(res));

			$ctrl.setActionSelected(api);
		},
		clearAllEventsAndDeleteInternalMapping: () => {
			const api = () => 
				teamData.fullEventCleanup(agencyProfileId)
				.then(() => teamData.deleteInternalMapping(agencyProfileId));

			$ctrl.setActionSelected(api);
		},
		clearDocuments: () => {
			$ctrl.clearDocuments();
		},
		employeeMappingReport: () => {
			const api = () => 
				teamData.getEmployeeMappingReport(agencyProfileId)
				.then(res => downloadReturnedFile(res));

			$ctrl.setActionSelected(api);
		},
		employeeMappingExport: () => {
			const api = () => 
				teamData.employeeMappingExport(agencyProfileId)
				.then(res => downloadReturnedFile(res));

			$ctrl.setActionSelected(api);
		},
		employeeMappingImport: () => {
			const api = () => {
				const deferred = $q.defer();

				const doc = $ctrl.documents[0];
				const fileName = doc.file.name;
				const contentType = doc.file.type;
				const reader = new FileReader();

				reader.readAsDataURL(doc._file);
				reader.onload = () => {
					// This is the base64 version of the file
					const content = reader.result.split(',')[1];
					deferred.resolve(
						teamData.employeeMappingImport(agencyProfileId, fileName, contentType, content)
					);
				};
				
				return deferred.promise
					.then(res => downloadReturnedFile(res));
			};

			$ctrl.setActionSelected(api);
		},
		generateInternalMapping: () => {
			const api = () => 
				teamData.generateInternalMapping(agencyProfileId);

			$ctrl.setActionSelected(api);
		},
		incomingEmployeesReport: () => {
			const api = () => 
				teamData.getIncomingEmployeesReport(agencyProfileId)
				.then(res => downloadReturnedFile(res));

			$ctrl.setActionSelected(api);
		},
		mappedEmployeeBulkExportMappingEventsCleanUp: () => {
			const api = () => 
				teamData.mappedEmployeeBulkExportMappingEventsCleanUp(agencyProfileId)
				.then(res => downloadReturnedFile(res));

			$ctrl.setActionSelected(api);
		}
	};
	
	let actionSelected;
	let agencyProfileId;

	function $onInit () {
		actionSelectedReset();
		agencyProfileId = $ctrl.formOptions.agencyProfileId;
		setPageState('ready');
	}

	function actionSelectedReset() {
		actionSelected = $q.resolve();
	}

	function backToActionsView () {
		actionSelectedReset();
		$ctrl.currentView = view.actions;
		clearDocuments();
	}

	function clearDocuments() {
		$ctrl.documents = [];
	}

	function closeAndReload () {
		actionSelectedReset();
		$ctrl.formOptions.callback();
		$ctrl.formOptions.closeForm();
	}

	function confirm () {

		$ctrl.currentView = view.processing;

		// Call the api using a shared function
		$ctrl.actionSelected()
		.catch(err => {
			setPageState('error');
			console.error(err);
		})
		.finally(() => {
			$ctrl.currentView = view.complete;
			actionSelectedReset();
		});
	}

	function downloadReturnedFile (data) {
		return dataTransfer.downloadFileContent(data);
	}

	function setActionSelected(action) {
		$ctrl.actionSelected = action;
		$ctrl.currentView = $ctrl.view.confirm;
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateFiles ($ctrl) {
		console.log('$ctrl', $ctrl);
	}

	angular.extend($ctrl, {
		$onInit,
		actionSelected,
		backToActionsView,
		clickAction,
		clearDocuments,
		closeAndReload,
		confirm,
		downloadReturnedFile,
		setActionSelected,
		updateFiles,

		// Set the start default view
		currentView: view.actions,
		view,
		// Default the documents to be empty
		documents: []
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editPayExperianIntegrationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editPayExperianIntegrationFormCtrl',
	templateUrl: 'forms/admin/edit-pay-experian-integration/edit-pay-experian-integration.form.html',
})

.controller('editPayExperianIntegrationFormCtrl', [
	'$rootScope',
	'companyData',
	'growl',
	function (
		$rootScope,
		companyData,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('ready');

		// Remember the isPayExperianIntegrationEnabled value on load
		$ctrl.isPayExperianIntegrationEnabledOnLoad = $ctrl.formOptions.integrationData.isPayExperianIntegrationEnabled;
	}

	function submitEditPayExperianIntegrationForm (ctrlObj, formObj) {

		formObj.state = 'saving';

		companyData.updateCompanyIntegrations(ctrlObj.formOptions.agencyProfileId, $ctrl.formOptions.integrationData)
		.then(() => {

			growl.success('Digital Employment Verification settings updated');

			// Refresh the company
			$rootScope.$broadcast('set-current-company', ctrlObj.formOptions.agencyProfileId, () => {
				// Close the flyout and reload the data
				ctrlObj.formOptions.callback();
				ctrlObj.formOptions.closeForm();
			});
		})
		.catch(() => {
			setPageState('error');
		});
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		submitEditPayExperianIntegrationForm
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editPeopleHrIntegrationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editPeopleHrIntegrationFormCtrl',
	templateUrl: 'forms/admin/edit-people-hr-integration/edit-people-hr-integration.form.html',
})

.controller('editPeopleHrIntegrationFormCtrl', [
	'$rootScope',
	'companyData', 
	function (
		$rootScope,
		companyData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('ready');

		// Remember the isPeopleHRIntegrationEnabled value on load
		$ctrl.isPeopleHRIntegrationEnabledOnLoad = $ctrl.formOptions.integrationData.isPeopleHRIntegrationEnabled;
	}

	function submitEditPeopleHrIntegrationForm (ctrlObj, formObj) {
		
		formObj.state = 'saving';

		companyData.updateCompanyIntegrations(ctrlObj.formOptions.agencyProfileId, $ctrl.formOptions.integrationData)
		.then(() => {

			// Refresh the company
			$rootScope.$broadcast('set-current-company', ctrlObj.formOptions.agencyProfileId, () => {
				// Close the flyout and reload the data
				ctrlObj.formOptions.callback();
				ctrlObj.formOptions.closeForm();
			});
		})
		.catch(() => {
			setPageState('error');
		});		
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		submitEditPeopleHrIntegrationForm
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editAccountingIntegrationForm', {
	controller: 'editAccountingIntegrationFormCtrl',
	bindings: {
		formOptions: '='
	},
	templateUrl: 'forms/admin/edit-accounting-integration/edit-accounting-integration.form.html',
})

.controller('editAccountingIntegrationFormCtrl', [
	'ACCOUNTING_INTEGRATION_TYPES',
	function (
		ACCOUNTING_INTEGRATION_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		$ctrl.accountIntegrationTypes = [
			{
				AccountingIntegrationType: ACCOUNTING_INTEGRATION_TYPES.xero,
				AccountingIntegrationName: 'Xero',
				AccountingIntegrationImageUrl: '/images/logo/integrations/xero.2x.png'
			}
		];

		if ($ctrl.formOptions.isAccessFinancialsFeatureEnabled) {
			$ctrl.accountIntegrationTypes.splice(0, 0, {
				AccountingIntegrationType: ACCOUNTING_INTEGRATION_TYPES.accessFinancials,
				AccountingIntegrationName: 'Access Financials',
				AccountingIntegrationImageUrl: '/images/logo/integrations/access-financials.2x.png'
			});
		}

		setPageState('ready');
	}

	function openConnectionForm () {
		if ($ctrl.selectedIntegration === ACCOUNTING_INTEGRATION_TYPES.accessFinancials) {
			openAccessFinancialsConnectionForm();
		} else if ($ctrl.selectedIntegration === ACCOUNTING_INTEGRATION_TYPES.xero) {
			openXeroConnectionForm();
		}
	}

	function openXeroConnectionForm () {
		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			callback: $ctrl.formOptions.callback,
			formKey: 'xero',
			title: 'Connect to accounting software'
		});
	}

	function openAccessFinancialsConnectionForm () {
		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			callback: $ctrl.formOptions.callback,
			formKey: 'financials',
			title: 'Connect to accounting software'
		});
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		openConnectionForm,
		ACCOUNTING_INTEGRATION_TYPES
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editEdpIntegrationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editEdpIntegrationFormCtrl',
	templateUrl: 'forms/admin/edit-edp-integration/edit-edp-integration.form.html',
})

.controller('editEdpIntegrationFormCtrl', [
	'$q',
	'$rootScope',
	'companyData',
	'growl',
	function (
		$q,
		$rootScope,
		companyData,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		// Remember the initial connection state
		$ctrl.isEdpIntegrationEnabledOnLoad = $ctrl.formOptions.integrationData.isEdpIntegrationEnabled;

		if ($ctrl.isEdpIntegrationEnabledOnLoad) {
			loadTopics();
		}
		else {
			$ctrl.topics = [];
			$ctrl.topicsOnLoad = [];
			setFormState('ready');
		}
	}

	const TOPIC_DISPLAY_NAMES = {
		'5a374b92-e2ee-429d-80bd-c6ec94da49ba': 'Sickness',
		'a8f3c7d1-4e9a-4f5b-9c2d-3e8f1a7b6d9c': 'Holiday',
		'f5f7e9b5-c5ce-4e62-9ea2-680c46138db2': 'Maternity',
		'2308459b-212f-4562-9ec5-8e4812dab2d1': 'Paternity'
	};

	function getDisplayName (topicKey) {
		if (!topicKey) { return topicKey; }
		return TOPIC_DISPLAY_NAMES[topicKey.toLowerCase()] || topicKey;
	}

	function loadTopics () {

		setFormState('loading');

		companyData.getEdpIntegrationTopics($ctrl.formOptions.agencyProfileId)
		.then((topics) => {

			$ctrl.topics = topics.map(function (topic) {
				topic.DisplayName = getDisplayName(topic.EdpIntegrationTopicKey);
				return topic;
			});

			// Remember the initial enabled state for each topic to detect changes
			$ctrl.topicsOnLoad = topics.map((topic) => ({
				EdpIntegrationTopicKey: topic.EdpIntegrationTopicKey,
				EdpIntegrationTopicIsEnabled: topic.EdpIntegrationTopicIsEnabled
			}));

			setFormState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setFormState('error');
		});
	}

	function getChangedTopics () {

		if (!$ctrl.topics || !$ctrl.topicsOnLoad) {
			return [];
		}

		return $ctrl.topics.filter((topic) => {

			const original = $ctrl.topicsOnLoad.find((t) => t.EdpIntegrationTopicKey === topic.EdpIntegrationTopicKey);

			return original && topic.EdpIntegrationTopicIsEnabled !== original.EdpIntegrationTopicIsEnabled;
		});
	}

	function hasConnectionChanged () {
		return $ctrl.formOptions.integrationData.isEdpIntegrationEnabled !== $ctrl.isEdpIntegrationEnabledOnLoad;
	}

	function hasChanges () {
		return hasConnectionChanged() || getChangedTopics().length > 0;
	}

	function submitEditEdpIntegrationForm (ctrlObj, formObj) {

		if (!hasChanges()) {
			ctrlObj.formOptions.closeForm();
			return;
		}

		formObj.state = 'saving';

		const promises = [];

		// Save connection state change if toggled
		if (hasConnectionChanged()) {
			promises.push(
				companyData.updateCompanyIntegrations(ctrlObj.formOptions.agencyProfileId, ctrlObj.formOptions.integrationData)
			);
		}

		// Save topic changes (only if still connected and topics changed)
		if (ctrlObj.formOptions.integrationData.isEdpIntegrationEnabled) {
			const changedTopics = getChangedTopics();

			changedTopics.forEach((topic) => {
				promises.push(
					companyData.updateEdpIntegrationTopic(
						ctrlObj.formOptions.agencyProfileId,
						topic.EdpIntegrationTopicID,
						topic.EdpIntegrationTopicKey,
						topic.EdpIntegrationTopicIsEnabled
					)
				);
			});
		}

		$q.all(promises)
		.then(() => {

			formObj.state = 'saved';

			growl.success('EDP integration settings updated');

			$rootScope.$broadcast('set-current-company', ctrlObj.formOptions.agencyProfileId, () => {
				ctrlObj.formOptions.callback();
				ctrlObj.formOptions.closeForm();
			});
		})
		.catch(function (error) {
			console.error(error);
			setFormState('error');
		});
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		hasChanges,
		submitEditEdpIntegrationForm
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editRotareadyIntegrationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editRotareadyIntegrationFormCtrl',
	templateUrl: 'forms/admin/edit-rotaready-integration/edit-rotaready-integration.form.html',
})

.controller('editRotareadyIntegrationFormCtrl', [
	'$q',
	'$filter',
	'$rootScope',
	'$state',
	'base',
	'companyData',
	'searchService',
	'teamData',
	'utilities',
	'FEATURE_FLAGS',
	'PAY_PERIOD_TYPES',
	'PAY_PERIOD_TYPES_DESCRIPTIONS',
	'REFERENCE_PERIOD_OFFSET_ANCHOR_OPTIONS',
	'REFERENCE_PERIOD_OFFSET_TARGET_OPTIONS',
	'REFERENCE_PERIODS_PATTERNS',
	'REFERENCE_PERIODS_PATTERNS_DISPLAY',
	function (
		$q,
		$filter,
		$rootScope,
		$state,
		base,
		companyData,
		searchService,
		teamData,
		utilities,
		FEATURE_FLAGS,
		PAY_PERIOD_TYPES,
		PAY_PERIOD_TYPES_DESCRIPTIONS,
		REFERENCE_PERIOD_OFFSET_ANCHOR_OPTIONS,
		REFERENCE_PERIOD_OFFSET_TARGET_OPTIONS,
		REFERENCE_PERIODS_PATTERNS,
		REFERENCE_PERIODS_PATTERNS_DISPLAY
	) {

	const PAGE_STATES = {
		loading: 'loading',
		credentialsInput: 'credentials-input',
		connectionSuccess: 'connection-success',
		connecting: 'connecting',
		connected: 'connected',
		confirmDisconnect: 'confirm-disconnect',
		confirmLinkedSites: 'confirm-linked-sites',
		disconnected: 'disconnected',
		entitySelection: 'entity-selection',
		entityValidationError: 'entity-validation-error',
		error: 'error',
		referencePeriodsValidationError: 'reference-periods-validation-error'
	};

	const ENTITY_SELECTION_TABS = {
		linked: 'linked',
		newSites: 'new',
		removed: 'removed'
	};

	// Longer terms first so that e.g. 'fourweekly' is matched before 'weekly'
	const FREQUENCY_TERMS = [
		{ term: 'annually', payPeriodType: PAY_PERIOD_TYPES.annually },
		{ term: 'biannually', payPeriodType: PAY_PERIOD_TYPES.biannually },
		{ term: 'biweekly', payPeriodType: PAY_PERIOD_TYPES.fortnightly },
		{ term: 'fortnightly', payPeriodType: PAY_PERIOD_TYPES.fortnightly },
		{ term: 'fourweekly', payPeriodType: PAY_PERIOD_TYPES.fourweekly },
		{ term: 'monthly', payPeriodType: PAY_PERIOD_TYPES.monthly },
		{ term: 'quarterly', payPeriodType: PAY_PERIOD_TYPES.quarterly },
		{ term: 'twoweekly', payPeriodType: PAY_PERIOD_TYPES.fortnightly },
		{ term: 'weekly', payPeriodType: PAY_PERIOD_TYPES.weekly }
	].sort((a, b) => b.term.length - a.term.length);

	const $ctrl = this;

	function $onInit () {

		setPageState(PAGE_STATES.loading);
		setConnectionFailed(false);

		angular.extend($ctrl, {
			currentPayPeriodList: [
				`Start date: ${$filter('dateformat')($ctrl.formOptions.currentPayPeriod.StartDateISO)}`,
				`End date: ${$filter('dateformat')($ctrl.formOptions.currentPayPeriod.EndDateISO)}`
			],
			isCalendarOpen: false,
			isManagingLinkedSites: false,
			isMonthlyPayroll: $ctrl.formOptions.currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.monthly,
			isReferencePeriodsEnabled: false,
			isRotareadyIntegrationEnabled: false,
			referencePeriodConfig: decorateReferencePeriodConfig(null),
			referencePeriodDateMax: $ctrl.formOptions.currentPayPeriod.PayDateISO,
			referencePeriodDateMin: null,
		});

		const getAccessRotareadyConnection = companyData.getAccessRotareadyConnection($ctrl.formOptions.agencyProfileId);
		const getReferencePeriodConfigAtCurrentPeriod = companyData.getReferencePeriodConfigAtCurrentPeriod($ctrl.formOptions.agencyProfileId);
		const isRealmSegmentationEnabled = base.isFeatureEnabled($ctrl.formOptions.agencyProfileId, FEATURE_FLAGS.ROTAREADY_REALM_SEGMENTATION);

		$q.all([
			getAccessRotareadyConnection,
			getReferencePeriodConfigAtCurrentPeriod,
			isRealmSegmentationEnabled
		])
		.then(([
			accessRotareadyConnectionObj,
			referencePeriodConfigAtCurrentPeriodObj,
			isRealmSegmentationEnabledObj
		]) => {

			$ctrl.isRealmSegmentationEnabled = isRealmSegmentationEnabledObj;
			$ctrl.referencePeriodConfig = decorateReferencePeriodConfig(referencePeriodConfigAtCurrentPeriodObj);
			$ctrl.isReferencePeriodsEnabled = $ctrl.referencePeriodConfig.Pattern !== REFERENCE_PERIODS_PATTERNS.none;

			$ctrl.originalReferencePeriodConfig = angular.copy(referencePeriodConfigAtCurrentPeriodObj);
			$ctrl.originalConnectionState = angular.copy(accessRotareadyConnectionObj);

			if (accessRotareadyConnectionObj.IsConnected && accessRotareadyConnectionObj.Entities.length > 0) {
				setPageState(PAGE_STATES.connected);
				setIsRotareadyIntegrationEnabled(true);
			}
			else if (accessRotareadyConnectionObj.IsConnected && accessRotareadyConnectionObj.Entities.length === 0) {
				loadEntitySelection();
			}
			else {
				setPageState(PAGE_STATES.credentialsInput);
				setIsRotareadyIntegrationEnabled(false);
			}
		})
		.catch(onError);
	}

	function decorateReferencePeriodConfig (referencePeriodConfigObj) {

		if (angular.isUndefined(referencePeriodConfigObj) || referencePeriodConfigObj === null) {
			return {
				OffsetAnchor: null,
				OffsetDays: 0,
				OffsetTarget: null,
				Pattern: REFERENCE_PERIODS_PATTERNS.none,
				PatternStartDateISO: null
			};
		}

		referencePeriodConfigObj.OffsetAnchor = referencePeriodConfigObj.OffsetAnchor || null;
		referencePeriodConfigObj.OffsetDays = referencePeriodConfigObj.OffsetDays || 0;
		referencePeriodConfigObj.OffsetTarget = referencePeriodConfigObj.OffsetTarget || null;

		return referencePeriodConfigObj;
	}

	function decrementPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.periodIndex === periodDetailsObj.periodIndexMin) {
			return;
		}

		periodDetailsObj.periodIndex--;
	}

	function incrementPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.periodIndex === periodDetailsObj.periodIndexMax) {
			return;
		}

		periodDetailsObj.periodIndex++;
	}

	function connect () {
		setPageState(PAGE_STATES.connecting);

		companyData.createAccessRotareadyConnection($ctrl.formOptions.agencyProfileId, $ctrl.formObject.keyInput, $ctrl.formObject.secretInput, $ctrl.formObject.realmInput).then(() => {
			loadEntitySelection();
		})
		.catch(() => {
			setConnectionFailed(true);
			setPageState(PAGE_STATES.credentialsInput);
		});
	}

	function loadEntitySelection () {

		// If realm segmentation is not enabled, skip the extra loading state
		if ($ctrl.isRealmSegmentationEnabled) {
			setPageState(PAGE_STATES.loading);
		}

		setConnectionFailed(false);
		setIsRotareadyIntegrationEnabled(true);
		getAvailableEntities();
		refreshCompanyDetails();
	}

	function getAvailableEntities () {

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const getEntities = companyData.getAvailableAccessRotareadyEntities(agencyProfileId);
		const getRealmMappings = $ctrl.isRealmSegmentationEnabled ?
			companyData.getRotareadyEntityMappingsForRealm(agencyProfileId) :
			$q.resolve(null);
		const getConnection = $ctrl.isManagingLinkedSites ?
			companyData.getAccessRotareadyConnection(agencyProfileId) :
			$q.resolve(null);

		$q.all([getEntities, getRealmMappings, getConnection])
			.then(([entitiesArr, realmMappingsArr, connectionObj]) => {

				$ctrl.rotareadyEntities = decorateEntitiesWithRealmMappings(entitiesArr, realmMappingsArr, agencyProfileId);

				if ($ctrl.isManagingLinkedSites) {
					decorateLinkedSiteTabs(connectionObj);
					$ctrl.entitySelectionTab = ENTITY_SELECTION_TABS.linked;
					setPageState(PAGE_STATES.entitySelection);
					loadLinkedEmployeeCounts();
				} else if (!$ctrl.isRealmSegmentationEnabled) {
					$ctrl.rotareadyEntities.forEach(x => x.isSelected = true);
					updateEntities();
				} else {
					setPageState(PAGE_STATES.entitySelection);
				}
			})
			.catch(onError);
	}

	function decorateLinkedSiteTabs (connectionObj) {

		const storedEntities = (connectionObj && connectionObj.Entities) || [];
		const liveEntities = $ctrl.rotareadyEntities || [];

		const hasLivePair = (stored) => liveEntities.some(live =>
			live.EntityID === stored.EntityID && live.PayrollCalendarID === stored.PayrollCalendarID);
		const hasStoredPair = (live) => storedEntities.some(stored =>
			stored.EntityID === live.EntityID && stored.PayrollCalendarID === live.PayrollCalendarID);

		$ctrl.linkedRotareadyEntities = storedEntities.filter(hasLivePair).map(stored => {

			const liveEntity = liveEntities.find(live =>
				live.EntityID === stored.EntityID && live.PayrollCalendarID === stored.PayrollCalendarID);

			return angular.extend(angular.copy(stored), {
				employeeCount: null,
				isRenamed: !!liveEntity && liveEntity.EntityName !== stored.EntityName,
				rotareadyEntityName: liveEntity ? liveEntity.EntityName : null,
				isSelected: true
			});
		});

		$ctrl.newRotareadyEntities = liveEntities.filter(live => !hasStoredPair(live));

		const seenSiteKeysArr = utilities.getObjectFromStorage(getSeenSitesStorageKey(), []);

		$ctrl.newRotareadyEntities.forEach(x => {
			x.frequencyWarning = getFrequencyWarning(x.EntityName);
			x.isNew = !seenSiteKeysArr.includes(getSiteKey(x));
			x.isSelected = false;
		});

		$ctrl.removedRotareadyEntities = storedEntities.filter(stored => !hasLivePair(stored)).map(stored =>
			angular.extend(angular.copy(stored), {
				isRemoved: false
			}));

		$ctrl.hasNewNotLinkedSites = $ctrl.newRotareadyEntities.some(x => x.isNew);
	}

	function getFrequencyWarning (entityName) {

		const payrollPayPeriodType = $ctrl.formOptions.currentPayPeriod ? $ctrl.formOptions.currentPayPeriod.PayPeriodType : null;
		const normalisedName = (entityName || '').toLowerCase().replace(/[\s-]/g, '');
		const frequencyTermObj = FREQUENCY_TERMS.find(x => normalisedName.includes(x.term));

		if (!frequencyTermObj || payrollPayPeriodType === null || frequencyTermObj.payPeriodType === payrollPayPeriodType) {
			return null;
		}

		return `Name suggests ${PAY_PERIOD_TYPES_DESCRIPTIONS[frequencyTermObj.payPeriodType]}, but this payroll is ${PAY_PERIOD_TYPES_DESCRIPTIONS[payrollPayPeriodType]}. Please check before linking.`;
	}

	function getSeenSitesStorageKey () {

		return `rotareadySeenSites-${$ctrl.formOptions.agencyProfileId}`;
	}

	function getSiteKey (entity) {

		return `${entity.EntityID}_${entity.PayrollCalendarID}`;
	}

	function saveSeenSites () {

		utilities.addObjectToStorage(getSeenSitesStorageKey(), ($ctrl.rotareadyEntities || []).map(getSiteKey));
	}

	function loadLinkedEmployeeCounts () {

		if (!$ctrl.linkedRotareadyEntities.length) {
			return;
		}

		const entityIds = [...new Set($ctrl.linkedRotareadyEntities.map(x => x.EntityID))];

		companyData.getRotareadyEntityLinkedEmployeeCounts($ctrl.formOptions.agencyProfileId, entityIds)
			.then(countsArr => {

				$ctrl.linkedRotareadyEntities.forEach(entity => {

					const count = (countsArr || []).find(x => x.EntityID === entity.EntityID);
					entity.employeeCount = count ? count.EmployeeCount : 0;
				});
			})
			.catch(error => {

				// The warning count is advisory only, so a failure falls back to the generic unlink warning
				console.error(error);

				$ctrl.linkedRotareadyEntities.forEach(entity => {
					entity.employeeCount = 0;
				});
			});
	}

	function setEntitySelectionTab (tab) {
		$ctrl.entitySelectionTab = tab;
	}

	function getSelectedLinkedSites () {

		return $ctrl.linkedRotareadyEntities.filter(x => x.isSelected)
			.concat($ctrl.newRotareadyEntities.filter(x => x.isSelected))
			.map(x => ({
				EntityID: x.EntityID,
				EntityName: x.isRenamed && x.rotareadyEntityName ? x.rotareadyEntityName : x.EntityName,
				PayrollCalendarID: x.PayrollCalendarID
			}));
	}

	function getRemovedRotareadyEntityIds () {

		return $ctrl.removedRotareadyEntities.filter(x => x.isRemoved).map(x => x.RotareadyEntityID);
	}

	function hasLinkedSiteSelection () {

		if (!$ctrl.linkedRotareadyEntities || !$ctrl.newRotareadyEntities) {
			return false;
		}

		return $ctrl.linkedRotareadyEntities.some(x => x.isSelected) ||
			$ctrl.newRotareadyEntities.some(x => x.isSelected);
	}

	function toggleRemovedEntity (entity) {
		entity.isRemoved = !entity.isRemoved;
	}

	function getFilteredEntities (entitiesArr, searchBarOptionsObj) {

		const searchString = searchBarOptionsObj && searchBarOptionsObj.search ? searchBarOptionsObj.search.string : '';

		if (!searchString) {
			return entitiesArr;
		}

		return $filter('filter')(entitiesArr, { EntityName: searchString });
	}

	function openLinkedSites () {

		angular.extend($ctrl, {
			isManagingLinkedSites: true,
			linkedSitesSearchBarOptions: angular.copy(searchService.rotareadyLinkedSites),
			newSitesSearchBarOptions: angular.copy(searchService.rotareadyLinkedSites),
			removedSitesSearchBarOptions: angular.copy(searchService.rotareadyLinkedSites)
		});

		setPageState(PAGE_STATES.loading);
		getAvailableEntities();
	}

	function getLinkedSiteChanges () {

		const linkedSiteChangesArr = [];

		$ctrl.newRotareadyEntities.filter(x => x.isSelected).forEach(entity => {
			linkedSiteChangesArr.push(`‘${entity.EntityName}’ will be linked`);
		});

		$ctrl.linkedRotareadyEntities.filter(x => x.isSelected && x.isRenamed).forEach(entity => {
			linkedSiteChangesArr.push(`‘${entity.EntityName}’ will be renamed to ‘${entity.rotareadyEntityName}’`);
		});

		$ctrl.linkedRotareadyEntities.filter(x => !x.isSelected).forEach(entity => {

			if (entity.employeeCount > 0) {
				linkedSiteChangesArr.push(`‘${entity.EntityName}’ will be unlinked (${entity.employeeCount} employee${entity.employeeCount === 1 ? '' : 's'} currently linked)`);
				return;
			}

			linkedSiteChangesArr.push(`‘${entity.EntityName}’ will be unlinked`);
		});

		$ctrl.removedRotareadyEntities.filter(x => x.isRemoved).forEach(entity => {
			linkedSiteChangesArr.push(`‘${entity.EntityName}’ will be unlinked (no longer in Rotaready)`);
		});

		return linkedSiteChangesArr;
	}

	function goBackToLinkedSites () {
		setPageState(PAGE_STATES.entitySelection);
	}

	function moveToConfirmLinkedSites () {

		$ctrl.linkedSiteChanges = getLinkedSiteChanges();
		setPageState(PAGE_STATES.confirmLinkedSites);
	}

	function goBackFromLinkedSites () {

		$ctrl.isManagingLinkedSites = false;
		setPageState(PAGE_STATES.connected);
	}

	function updateLinkedSiteSelection () {

		setPageState(PAGE_STATES.loading);

		companyData.updateAccessRotareadyEntitySelection(
			$ctrl.formOptions.agencyProfileId,
			getSelectedLinkedSites(),
			getRemovedRotareadyEntityIds()
		).then((result) => {

			if (result && result.Success === false) {
				$ctrl.entityValidationErrors = result.ValidationErrors || [];
				setPageState(PAGE_STATES.entityValidationError);
				return;
			}

			saveSeenSites();
			$ctrl.isManagingLinkedSites = false;
			$ctrl.formOptions.forceCallback();
			setPageState(PAGE_STATES.connected);
			refreshCompanyDetails();
		})
		.catch(onError);
	}

	function decorateEntitiesWithRealmMappings (entitiesArr, realmMappingsArr, agencyProfileId) {

		if (!realmMappingsArr) {
			return entitiesArr.map(entity => angular.extend(entity, {
				isSelected: false,
				isMappedToOtherCompany: false,
				mappedCompanyName: null
			}));
		}

		return entitiesArr.map(entity => {

			const existingMapping = realmMappingsArr.find(m =>
				m.RotareadyEntityID === entity.EntityID &&
				m.PayrollCalendarID === entity.PayrollCalendarID
			);

			const isMappedToCurrentCompany = existingMapping && existingMapping.AgencyProfileID === agencyProfileId;
			const isMappedToOtherCompany = existingMapping && existingMapping.AgencyProfileID !== agencyProfileId;

			return angular.extend(entity, {
				isSelected: isMappedToCurrentCompany,
				isMappedToOtherCompany: isMappedToOtherCompany,
				mappedCompanyName: isMappedToOtherCompany ? (existingMapping.AgencyProfileName || 'another company') : null
			});
		});
	}

	function getSelectedRotareadyEntities () {

		if (!$ctrl.rotareadyEntities) {
			return [];
		}

		return $ctrl.rotareadyEntities.filter(x => x.isSelected);
	}

	function refreshCompanyDetails () {
		// Refresh so that 'Team > Rotaready updates' page appears / disappears correctly
		$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId);
	}

	function referencePeriodConfigsAreEqual (config1, config2) {
		return config1.Pattern === config2.Pattern &&
			   config1.PatternStartDateISO === config2.PatternStartDateISO &&
			   config1.OffsetAnchor === config2.OffsetAnchor &&
			   config1.OffsetTarget === config2.OffsetTarget &&
			   config1.OffsetDays === config2.OffsetDays;
	}

	function isOffsetConfigComplete () {
		const config = $ctrl.referencePeriodConfig;
		return !!config.OffsetAnchor && !!config.OffsetTarget && angular.isNumber(config.OffsetDays);
	}

	function onToggleReferencePeriods () {

		// If reference periods are not enabled, set pattern to 'none' and start date to null
		if (!$ctrl.isReferencePeriodsEnabled) {
			$ctrl.referencePeriodConfig.Pattern = REFERENCE_PERIODS_PATTERNS.none;
			$ctrl.referencePeriodConfig.PatternStartDateISO = null;
			$ctrl.referencePeriodConfig.OffsetAnchor = null;
			$ctrl.referencePeriodConfig.OffsetTarget = null;
			$ctrl.referencePeriodConfig.OffsetDays = 0;

			// Close calendar preview
			$ctrl.isCalendarOpen = false;
		}
		// Set back to original pattern and start date
		else {
			$ctrl.referencePeriodConfig = angular.copy($ctrl.originalReferencePeriodConfig);
		}
	}

	function onChangeReferencePeriodsPattern (startDate) {

		const currentPeriod = $ctrl.formOptions.currentPayPeriod;
		const isOffset = $ctrl.referencePeriodConfig.Pattern === REFERENCE_PERIODS_PATTERNS.offset;

		if (isOffset) {
			$ctrl.referencePeriodConfig.PatternStartDateISO = null;
		}
		else {
			$ctrl.referencePeriodConfig.OffsetAnchor = null;
			$ctrl.referencePeriodConfig.OffsetTarget = null;
			$ctrl.referencePeriodConfig.OffsetDays = 0;
		}

		// If the user has selected a 445 family pattern then we can calculate the minimum reference period start date possible for this pay period
		if ($ctrl.referencePeriodConfig.Pattern !== REFERENCE_PERIODS_PATTERNS.none && !isOffset) {

			const getCurrentWeeks = (pattern) => {

				switch (pattern) {
					case REFERENCE_PERIODS_PATTERNS.fourFourFive:
					case REFERENCE_PERIODS_PATTERNS.fourFiveFour:
						return 4;
					case REFERENCE_PERIODS_PATTERNS.fiveFourFour:
						return 5;
					default:
						return 0;
				}
			};

			// Get the number of weeks in the current reference period
			const weeks = getCurrentWeeks($ctrl.referencePeriodConfig.Pattern);

			// Calculate the earliest possible start date such that the reference period still overlaps with the current period
			// We do this by subtracting the amount of weeks in the pattern from the current period start date
			$ctrl.referencePeriodDateMin = moment(currentPeriod.StartDateISO).subtract({ weeks: weeks, days: -1 });

			// Calculate the latest possible start date is such that the reference period end date is on or before the current period pay date
			// We do this by subtracting the amount of weeks in the pattern from the current period pay date
			$ctrl.referencePeriodDateMax = moment(currentPeriod.PayDateISO).subtract({ weeks: weeks, days: 0 });
		}
		// If the pattern is not selected, or is an offset pattern, we reset the dates as we cannot determine a valid max/min start date
		else {

			$ctrl.referencePeriodDateMax = currentPeriod.PayDateISO;
			$ctrl.referencePeriodDateMin = null;
		}

		refreshReferencePeriodCalendar(startDate);
	}

	function submitEditRotareadyIntegrationForm (formObj) {

		// Close calendar preview
		$ctrl.isCalendarOpen = false;

		// If integration was enabled and is now disabled, disconnect from Rotaready (it will also archive any reference period config)
		if ($ctrl.originalConnectionState.IsConnected && !$ctrl.isRotareadyIntegrationEnabled) {

			moveToConfirmDisconnect();
			return;
		}

		// If reference period config was changed, update it
		else if (!referencePeriodConfigsAreEqual($ctrl.originalReferencePeriodConfig, $ctrl.referencePeriodConfig)) {

			formObj.state = 'saving';

			const agencyProfileId = $ctrl.formOptions.agencyProfileId;
			const pattern =  $ctrl.referencePeriodConfig.Pattern;
			const isOffset = pattern === REFERENCE_PERIODS_PATTERNS.offset;

			// Process pending events if updating the reference period is successful
			const onUpdateSuccess = () => {

				teamData.processPendingAccessRotareadyEvents(agencyProfileId)
					.then(() => {

						formObj.state = 'saved';

						$ctrl.formOptions.forceCallback();
						setPageState(PAGE_STATES.referencePeriodsUpdated);
						refreshCompanyDetails();
					});
			};

			// Handle failed update
			const onUpdateError = (error) => {

				formObj.state = null;

				if (error === -1) {
					setPageState(PAGE_STATES.referencePeriodsValidationError);
					return;
				}

				onError(error);
			};

			const updateReferencePeriodConfig = isOffset ?
				companyData.updateRotareadyReferencePeriodOffsetConfig(
					agencyProfileId,
					$ctrl.referencePeriodConfig.OffsetAnchor,
					$ctrl.referencePeriodConfig.OffsetDays,
					$ctrl.referencePeriodConfig.OffsetTarget
				) :
				companyData.updateRotareadyReferencePeriodConfig(
					agencyProfileId,
					$ctrl.referencePeriodConfig.PatternStartDateISO,
					pattern
				);

			updateReferencePeriodConfig
				.then(onUpdateSuccess)
				.catch(onUpdateError);

			return;
		}

		// Nothing to do, close form
		closeForm();
	}

	function moveToConfirmDisconnect () {
		setPageState(PAGE_STATES.confirmDisconnect);
	}

	function disconnect () {
		setPageState(PAGE_STATES.loading);

		companyData.deleteAccessRotareadyConnection($ctrl.formOptions.agencyProfileId).then(() => {
			$ctrl.formOptions.forceCallback();
			setPageState(PAGE_STATES.disconnected);
			refreshCompanyDetails();
		})
		.catch(onError);
	}

	function closeForm () {
		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function goBackToCredentialsInput () {
		setPageState(PAGE_STATES.credentialsInput);
	}

	function onError (error) {
		$ctrl.isCalendarOpen = false;
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function setConnectionFailed (failed) {
		$ctrl.connectionFailed = failed;
	}

	function setIsRotareadyIntegrationEnabled (enabled) {
		$ctrl.isRotareadyIntegrationEnabled = enabled;
	}

	function openRotareadyTeamMappingForm () {
		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			callback: $ctrl.formOptions.callback,
			formKey: 'edit-rotaready-team-mapping',
			title: 'Rotaready Team Mapping'
		});
	}

	function openRotareadyPage(){
		$state.go('rotaready-connection.summary', {
			agencyProfileId: $ctrl.formOptions.agencyProfileId
		});
	}

	function updateEntities () {

		setPageState(PAGE_STATES.connecting);

		const selectedRotareadyEntities = getSelectedRotareadyEntities();

		companyData.updateAccessRotareadyEntities($ctrl.formOptions.agencyProfileId, selectedRotareadyEntities).then((result) => {

			if (result && result.Success === false) {
				$ctrl.entityValidationErrors = result.ValidationErrors || [];
				setPageState(PAGE_STATES.entityValidationError);
				return;
			}

			setPageState(PAGE_STATES.connectionSuccess);
			$ctrl.formOptions.canCloseForm = true;
			$ctrl.formOptions.forceCallback();
		})
		.catch(onError);
	}

	function toggleAllEntities (isSelected) {

		$ctrl.rotareadyEntities.forEach(x => {
			if (!x.isMappedToOtherCompany) {
				x.isSelected = isSelected;
			}
		});
	}

	function refreshReferencePeriodCalendar (startDate) {

		const isOffset = $ctrl.referencePeriodConfig.Pattern === REFERENCE_PERIODS_PATTERNS.offset;
		const canPreview = isOffset ? isOffsetConfigComplete() : !!startDate;

		if (!canPreview) {
			$ctrl.isCalendarOpen = false;
			$ctrl.isCalendarLoading = false;

			return;
		}

		if ($ctrl.isCalendarOpen) {

			$ctrl.isCalendarLoading = true;

			const getPreview = isOffset ?
				companyData.getRotareadyReferencePeriodsOffsetPreview(
					$ctrl.formOptions.agencyProfileId,
					$ctrl.referencePeriodConfig.OffsetAnchor,
					$ctrl.referencePeriodConfig.OffsetDays,
					$ctrl.referencePeriodConfig.OffsetTarget
				) :
				companyData.getRotaReadyReferencePeriodsPreview(
					$ctrl.formOptions.agencyProfileId,
					startDate,
					$ctrl.referencePeriodConfig.Pattern
				);

			getPreview
				.then((referencePeriodsArr) => {

					const currentPayPeriodId = $ctrl.formOptions.currentPayPeriod.PayPeriodID;
					const currentPayPeriodIndex = referencePeriodsArr.findIndex(x => x.AgencyPayPeriodID === currentPayPeriodId);
					const index = Math.min(Math.max(currentPayPeriodIndex, 0), referencePeriodsArr.length - 1);

					angular.extend($ctrl, {
						isCalendarLoading: false,
						periodDetails: {
							referencePeriods: referencePeriodsArr,
							periodIndex: index,
							periodIndexMin: 0,
							periodIndexMax: referencePeriodsArr.length - 1,
						}
					});
				})
				.catch(onError);
		}
	}

	function goBack () {

		$onInit();
	}

	function isEditFormValid (formObj) {

		// If reference periods are enabled, check if the form is valid and the pattern is not 'none'
		if ($ctrl.isReferencePeriodsEnabled) {
			return formObj.$valid && $ctrl.referencePeriodConfig.Pattern !== REFERENCE_PERIODS_PATTERNS.none;
		}

		// If reference periods are not enabled, just check if the form is valid
		return formObj.$valid;
	}

	function toggleReferencePeriodCalendar () {

		$ctrl.isCalendarOpen = !$ctrl.isCalendarOpen;
		refreshReferencePeriodCalendar($ctrl.referencePeriodConfig.PatternStartDateISO);
	}

	angular.extend($ctrl, {
		$onInit,

		closeForm,
		connect,
		decrementPeriodIndex,
		disconnect,
		goBack,
		goBackFromLinkedSites,
		goBackToLinkedSites,
		goBackToCredentialsInput,
		getFilteredEntities,
		getSelectedRotareadyEntities,
		hasLinkedSiteSelection,
		incrementPeriodIndex,
		isEditFormValid,
		moveToConfirmDisconnect,
		moveToConfirmLinkedSites,
		submitEditRotareadyIntegrationForm,
		onChangeReferencePeriodsPattern,
		onToggleReferencePeriods,
		openLinkedSites,
		openRotareadyPage,
		openRotareadyTeamMappingForm,
		refreshReferencePeriodCalendar,
		setEntitySelectionTab,
		setPageState,
		toggleAllEntities,
		toggleReferencePeriodCalendar,
		toggleRemovedEntity,
		updateEntities,
		updateLinkedSiteSelection,

		ENTITY_SELECTION_TABS,
		PAGE_STATES,
		REFERENCE_PERIOD_OFFSET_ANCHOR_OPTIONS,
		REFERENCE_PERIOD_OFFSET_TARGET_OPTIONS,
		REFERENCE_PERIODS_PATTERNS,
		REFERENCE_PERIODS_PATTERNS_DISPLAY
	});
}]);
 
'use strict';

angular.module('paycircleApp')

.component('editRotareadyEntityMappingForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editRotareadyEntityMappingFormCtrl',
	templateUrl: 'forms/admin/edit-rotaready-entity-mapping/edit-rotaready-entity-mapping.form.html',
})

.controller('editRotareadyEntityMappingFormCtrl', [
	'BUSINESS_CATEGORY_TYPE_OPTIONS',
	'config',
	'companyData',
	function (
		BUSINESS_CATEGORY_TYPE_OPTIONS,
		config,
		companyData
	) {

	const PAGE_STATE = {
		confirm: 'confirm',
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const TAB = {
		unmapped: 'unmapped',
		mapped: 'mapped'
	};

	const $ctrl = this;

	function $onInit () {

		setPageState(PAGE_STATE.loading);
		$ctrl.activeTab = TAB.unmapped;

		getEntityBusinessCodeMapping();
	}

	function closeForm () {

		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function getEntityBusinessCodeMapping () {

		companyData.getRotareadyEntityBusinessCodeMapping($ctrl.formOptions.agencyProfileId).then(result => {

			$ctrl.businessCodes = result.BusinessCodes;

				const allEntities = result.EntityBusinessCodeMapping.map(entity => {
				const businessCodeId = entity.BusinessCodeID !== config.guidEmpty ? entity.BusinessCodeID : null;
				const businessCode = businessCodeId ? getBusinessCodeById(businessCodeId) : null;

				return {
					RotareadyEntityID: entity.RotareadyEntityID,
					EntityName: entity.EntityName,
					EntityNameRaw: entity.EntityNameRaw,
					PayrollCalendarName: entity.PayrollCalendarName,
					PayrollCalendarStartDateISO: entity.PayrollCalendarStartDateISO,
					EntityGroupName: entity.EntityGroupName,
					BusinessCodeID: businessCodeId,
					originalBusinessCodeID: businessCodeId,
					businessCodeNarrative: businessCode ? businessCode.BusinessCodeNarrative : null,
					businessCodeValue: businessCode ? businessCode.BusinessCodeValue : null,
					businessCategoryTypeDescription: businessCode ? getCategoryTypeDescription(businessCode.BusinessCategoryType, businessCode) : null,
					selectedBusinessCodeID: null
				};
			});

			$ctrl.entitiesMapped = allEntities.filter(e => e.BusinessCodeID);
			$ctrl.entitiesUnmapped = allEntities.filter(e => !e.BusinessCodeID);

			$ctrl.entityMappingsUpdated = [];

			setPageState(PAGE_STATE.ready);
		})
		.catch(onError);
	}

	function getBusinessCodeById (businessCodeId) {

		if (!businessCodeId || !$ctrl.businessCodes) {
			return null;
		}

		return $ctrl.businessCodes.find(function (code) {
			return code.BusinessCodeID === businessCodeId;
		});
	}

	function getCategoryTypeDescription (categoryType, businessCode) {

		if (categoryType === 0 && businessCode) {
			return businessCode.BusinessCategoryName || 'Custom';
		}

		const match = BUSINESS_CATEGORY_TYPE_OPTIONS.find(function (option) {
			return option.value === categoryType;
		});
		return match ? match.description : '';
	}

	function getChangedMappingsCount () {

		return $ctrl.entityMappingsUpdated ? $ctrl.entityMappingsUpdated.length : 0;
	}

	function mapEntity (entity) {

		if (!entity.selectedBusinessCodeID) {
			return;
		}

		const businessCode = getBusinessCodeById(entity.selectedBusinessCodeID);

		entity.BusinessCodeID = entity.selectedBusinessCodeID;
		entity.businessCodeNarrative = businessCode ? businessCode.BusinessCodeNarrative : null;
		entity.businessCodeValue = businessCode ? businessCode.BusinessCodeValue : null;
		entity.businessCategoryTypeDescription = businessCode ? getCategoryTypeDescription(businessCode.BusinessCategoryType, businessCode) : null;
		entity.selectedBusinessCodeID = null;

		$ctrl.entitiesMapped.push(entity);
		$ctrl.entitiesUnmapped = $ctrl.entitiesUnmapped.filter(e => e.RotareadyEntityID !== entity.RotareadyEntityID);

		$ctrl.entityMappingsUpdated = $ctrl.entityMappingsUpdated.filter(e => e.RotareadyEntityID !== entity.RotareadyEntityID);
		$ctrl.entityMappingsUpdated.push(entity);
	}

	function unmapEntity (entity) {

		entity.BusinessCodeID = null;
		entity.businessCodeNarrative = null;
		entity.businessCodeValue = null;
		entity.businessCategoryTypeDescription = null;
		entity.selectedBusinessCodeID = null;

		$ctrl.entitiesMapped = $ctrl.entitiesMapped.filter(e => e.RotareadyEntityID !== entity.RotareadyEntityID);
		$ctrl.entitiesUnmapped.push(entity);

		$ctrl.entityMappingsUpdated = $ctrl.entityMappingsUpdated.filter(e => e.RotareadyEntityID !== entity.RotareadyEntityID);
		$ctrl.entityMappingsUpdated.push(entity);
	}

	function onError () {

		setPageState(PAGE_STATE.error);
	}

	function saveChanges () {

		setPageState(PAGE_STATE.loading);

		const entityBusinessCodes = $ctrl.entityMappingsUpdated.map(function (entity) {
			return {
				RotareadyEntityID: entity.RotareadyEntityID,
				BusinessCodeID: entity.BusinessCodeID || config.guidEmpty
			};
		});

		companyData.updateRotareadyEntityBusinessCodes($ctrl.formOptions.agencyProfileId, entityBusinessCodes).then(function () {
			closeForm();
		})
		.catch(onError);
	}

	function setActiveTab (newTab) {

		$ctrl.activeTab = newTab;
	}

	function setPageState (state) {

		$ctrl.pageState = state;
	}

	angular.extend($ctrl, {
		$onInit,
		closeForm,
		getCategoryTypeDescription,
		getChangedMappingsCount,
		mapEntity,
		PAGE_STATE,
		saveChanges,
		setActiveTab,
		setPageState,
		TAB,
		unmapEntity
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editRotareadyTeamMappingForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editRotareadyTeamMappingFormCtrl',
	templateUrl: 'forms/admin/edit-rotaready-team-mapping/edit-rotaready-team-mapping.form.html',
})

.controller('editRotareadyTeamMappingFormCtrl', [
	'companyData',
	function (
		companyData
	) {

	const PAGE_STATE = {
		confirm: 'confirm',
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const TAB = {
		unmatchedRotaready: 'unmatchedRotaready',
		unmatchedPaycircle: 'unmatchedPaycircle',
		matched: 'matched'
	};

	const $ctrl = this;

	function $onInit () {
		setPageState(PAGE_STATE.loading);
		$ctrl.activeTab = TAB.unmatchedRotaready;
		getTeamMembers();
	}

	function closeForm () {
		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function getTeamMembers () {
		companyData.getAccessRotareadyUserMapping($ctrl.formOptions.agencyProfileId).then(teamMapping => {
			$ctrl.teamMembersMatched = teamMapping.filter(t => t.Paycircle && t.Rotaready);
			$ctrl.teamMembersUnmatchedRotaready = teamMapping.filter(t => !t.Paycircle);
			$ctrl.teamMembersUnmatchedPaycircle = teamMapping.filter(t => !t.Rotaready);

			$ctrl.teamMemberMappingsUpdated = [];
			$ctrl.createInPaycircle = [];
			$ctrl.createInRotaready = [];

			setPageState(PAGE_STATE.ready);
		})
		.catch(onError);
	}

	function onError () {
		setPageState(PAGE_STATE.error);
	}

	function saveChanges () {
		setPageState(PAGE_STATE.loading);
		
		companyData.updateAccessRotareadyUserMapping($ctrl.formOptions.agencyProfileId, $ctrl.teamMemberMappingsUpdated).then(() => {
			closeForm();
		})
		.catch(onError);
	}

	function setActiveTab (newTab) {
		$ctrl.activeTab = newTab;
	}

	function setPageState (state) {
		$ctrl.pageState = state;
	}

	function createPaycircleTeamMember (teamMember) {
		$ctrl.teamMembersMatched.push(teamMember);
		$ctrl.teamMembersUnmatchedRotaready = $ctrl.teamMembersUnmatchedRotaready.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);

		$ctrl.createInPaycircle.push(teamMember);
	}

	function undoCreatePaycircleTeamMember (teamMember) {
		$ctrl.teamMembersMatched = $ctrl.teamMembersMatched.filter(x => x.Rotaready).filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
		$ctrl.teamMembersUnmatchedRotaready.push({Paycircle: null, Rotaready: teamMember.Rotaready});

		$ctrl.createInPaycircle = $ctrl.createInPaycircle.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);
	}

	function createRotareadyTeamMember (teamMember) {
		$ctrl.teamMembersMatched.push(teamMember);
		$ctrl.teamMembersUnmatchedPaycircle = $ctrl.teamMembersUnmatchedPaycircle.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);

		$ctrl.createInRotaready.push(teamMember);
	}

	function undoCreateRotareadyTeamMember (teamMember) {
		$ctrl.teamMembersMatched = $ctrl.teamMembersMatched.filter(x => x.Paycircle).filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
		$ctrl.teamMembersUnmatchedPaycircle.push({Paycircle: teamMember.Paycircle, Rotaready: null});

		$ctrl.createInRotaready = $ctrl.createInRotaready.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
	}

	function matchTeamMembers (teamMember) {
		$ctrl.teamMembersMatched.push(teamMember);
		$ctrl.teamMembersUnmatchedPaycircle = $ctrl.teamMembersUnmatchedPaycircle.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
		$ctrl.teamMembersUnmatchedRotaready = $ctrl.teamMembersUnmatchedRotaready.filter(x => x.Rotaready.Id !== teamMember.Rotaready.Id);

		$ctrl.teamMemberMappingsUpdated = $ctrl.teamMemberMappingsUpdated.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
		$ctrl.teamMemberMappingsUpdated.push(teamMember);
	}

	function unmatchTeamMembers (teamMember) {
		$ctrl.teamMembersMatched = $ctrl.teamMembersMatched.filter(x => x.Paycircle).filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
		$ctrl.teamMembersUnmatchedPaycircle.push({Paycircle: teamMember.Paycircle, Rotaready: null});
		$ctrl.teamMembersUnmatchedRotaready.push({Paycircle: null, Rotaready: teamMember.Rotaready});

		$ctrl.teamMemberMappingsUpdated = $ctrl.teamMemberMappingsUpdated.filter(x => x.Paycircle.Id !== teamMember.Paycircle.Id);
		$ctrl.teamMemberMappingsUpdated.push({Paycircle: teamMember.Paycircle, Rotaready: null});
	}
	
	angular.extend($ctrl, {
		$onInit,
		closeForm,
		createPaycircleTeamMember,
		createRotareadyTeamMember,
		PAGE_STATE,
		matchTeamMembers,
		saveChanges,
		setActiveTab,
		setPageState,
		TAB,
		undoCreatePaycircleTeamMember,
		undoCreateRotareadyTeamMember,
		unmatchTeamMembers
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyBasicForm', function () {

	return {
		controller: 'addNewCompanyBasicFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/basic/addNewCompanyBasicForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyBasicFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'companyData',
	'config',
	'customerCodeService',
	'session',
	'wizardService',
	'PLAYGROUND_CREDENTIALS',
	function (
		$scope,
		$q,
		$timeout,
		companyData,
		config,
		customerCodeService,
		session,
		wizardService,
		PLAYGROUND_CREDENTIALS
	) {

	const isInPlayground = session.isInPlayground();
	const onSuccess = $scope.formOptions.onSuccess;
	const companyObj = wizardService.newCompany;
	const agencyProfileParentId = session.getAgencyProfileParentId();

	function decorateCompanyObj (emptyCompanyObj, isCustomerCodeEnabled, industrySectors) {

		// Defaults
		emptyCompanyObj.IsPayrollActive = true;
		emptyCompanyObj.IsPensionActive = true;
		emptyCompanyObj.IsOffPayrollActive = false;

		// Additional params
		emptyCompanyObj.isElectronicUpdatesEnabled = false;
		emptyCompanyObj.isInPlayground = isInPlayground;
		/* Swtichable only when HR module is turned on, to give user the option of setting up pensions
		   later, when they need to be associated with a pension policy, which won't exist at this point */
		emptyCompanyObj.isPensionSchemeSetupDeferred = false;

		// Apprenticeship levy
		emptyCompanyObj.EmployerDetails.apprenticeshipLevyOption = 'full';

		// Playground (pre-defined values)
		if (emptyCompanyObj.isInPlayground) {
			emptyCompanyObj.EmployerDetails.AccountsOffice 		= PLAYGROUND_CREDENTIALS.accountsOffice;
			emptyCompanyObj.EmployerDetails.TaxOffice 			= PLAYGROUND_CREDENTIALS.taxOffice;
			emptyCompanyObj.EmployerDetails.TaxOfficeReference 	= PLAYGROUND_CREDENTIALS.taxOfficeReference;
			emptyCompanyObj.EmployerDetails.UTR 				= PLAYGROUND_CREDENTIALS.utr;
		}

		emptyCompanyObj.isCustomerCodeEnabled = isCustomerCodeEnabled;
		emptyCompanyObj.industrySectors = industrySectors;

		emptyCompanyObj.IndustrySectorID = null;

		return emptyCompanyObj;
	}

	function init () {

		setPageState('loading');

		// Already a company object set up
		if (companyObj) {
			$scope.company = companyObj;
			formatIndustrySectorDescription(companyObj.IndustrySectorID);

			$timeout(function () {
				setPageState('ready');
			}, 200);
			return;
		}

		const getEmptyCompanySetup = companyData.getEmptyCompanySetup(agencyProfileParentId);
		const getAgencyCustomerCodeEnabledState = companyData.getAgencyCustomerCodeEnabledState(agencyProfileParentId);
		const getIndustrySectors = companyData.getIndustrySectors();

		$q.all([getEmptyCompanySetup, getAgencyCustomerCodeEnabledState, getIndustrySectors]).then(([emptyCompanyObj, customerCodeEnabled, industrySectors]) => {

			$scope.company = decorateCompanyObj(emptyCompanyObj, customerCodeEnabled, industrySectors);

			setPageState('ready');

		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function verifyCustomerCode (companyObj) {

		if (!companyObj.CustomerCode) {
			return;
		}

		$scope.verificationState = 'verifying';

		return customerCodeService.verifyCustomerCode(companyObj.CustomerCode, agencyProfileParentId)
			.then(function(result) {
				$scope.verificationState = result.status;
				if(result.data){
					$scope.company.customerCodeCompanyName = result.data;
				}
			});
	}

	function formatIndustrySectorDescription (sectorID) {

		const sector = $scope.company.industrySectors.find(s => s.IndustrySectorID === sectorID);

		if (!sector || !sector.CategoryDescription) {
			$scope.industrySectorDescription = [];
			return;
		}

		// Split, trim, and filter the description parts
		$scope.industrySectorDescription = sector.CategoryDescription.split('•')
			.map(function(item) { return item.trim(); })
			.filter(function(item) { return item.length > 0; });
	}

	function resetVerificationState () {
		$scope.verificationState = null;
	}

	init();

	function saveNewCompanyBasic (companyObj, form) {

		// Update state
		form.state = 'saving';

		if (companyObj.IndustrySectorID === '' || companyObj.IndustrySectorID === null) {
			companyObj.IndustrySectorID = config.guidEmpty;
		}

		// Update central company object
		wizardService.saveCompany(companyObj);

		// Update central pension object
		wizardService.savePension(companyObj.PensionDetails);

		// On success
		if (onSuccess) {
			onSuccess();
			return;
		}
	}

	angular.extend($scope, {
		formatIndustrySectorDescription,
		resetVerificationState,
		saveNewCompanyBasic,
		verifyCustomerCode
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyModulesForm', function () {

	return {
		controller: 'addNewCompanyModulesFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/modules/addNewCompanyModulesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyModulesFormCtrl', ['$scope', 'config', 'wizardService', function ($scope, config, wizardService) {

	const onSuccess = $scope.formOptions.onSuccess;
	const companyObj = wizardService.newCompany;

	function init () {

		$scope.company = validateModuleSelection(companyObj);

		$scope.pageState = 'ready';
	}

	function saveNewCompanyModules (companyObj, form) {

		// Update state
		form.state = 'saving';

		// If payslip manager then enable payroll in the background
		if (companyObj.IsPayslipManagerActive) {
			companyObj.IsPayrollActive = true;
		}

		// Reset to empty guid
		if (companyObj.PensionDetails.PensionProviderID === '') {
			companyObj.PensionDetails.PensionProviderID = config.guidEmpty;
		}

		// Set is pension only
		companyObj.isPensionOnly = companyObj.IsPensionActive && !companyObj.IsPayrollActive;

		// Update central company object
		wizardService.saveCompany(companyObj);

		// On success
		if (onSuccess) {
			onSuccess();
			return;
		}
	}

	function validateModuleSelection (companyObj) {

		// Payslip Manager (Disable all other modules, Payroll is enabled again on save)
		if (companyObj.IsPayslipManagerActive) {
			angular.extend(companyObj, {
				IsCISActive: false,
				IsHRActive: false,
				IsPayrollActive: false,
				IsPensionActive: false,
				IsOffPayrollActive: false,
				IsExpatActive: false,

				isModuleSelectionValid: true,
				moduleValidState: null
			});

			return companyObj;
		}

		// At least 1 module needs to be active
		if (!companyObj.IsPayrollActive &&
			!companyObj.IsPensionActive &&
			!companyObj.IsCISActive &&
			!companyObj.IsHRActive &&
			!companyObj.IsOffPayrollActive &&
			!companyObj.IsExpatActive) {
			angular.extend(companyObj, {
				isModuleSelectionValid: false,
				moduleValidState: 'no-modules-selected'
			});
		}

		// At least 1 module needs to be active
		// Cannot have CIS without payroll
		else if (companyObj.IsCISActive && companyObj.IsPensionActive && !companyObj.IsPayrollActive) {
			angular.extend(companyObj, {
				isModuleSelectionValid: false,
				moduleValidState: 'no-pension-and-cis-without-payroll'
			});
		}

		// Cannot have HR without payroll
		else if (companyObj.IsHRActive && !companyObj.IsPayrollActive) {
			companyObj.isModuleSelectionValid = false;
			companyObj.moduleValidState = 'no-hr-without-payroll';
		}

		// If Off-payroll is selected, payroll must be selected
		else if (companyObj.IsOffPayrollActive && !companyObj.IsPayrollActive) {
			companyObj.isModuleSelectionValid = false;
			companyObj.moduleValidState = 'no-off-payroll-without-payroll';
		}

		// If Expats is selected, payroll must be selected
		else if (companyObj.IsExpatActive && !companyObj.IsPayrollActive) {
			companyObj.isModuleSelectionValid = false;
			companyObj.moduleValidState = 'no-expats-without-payroll';
		}

		// Default
		else {
			angular.extend(companyObj, {
				isModuleSelectionValid: true,
				moduleValidState: null
			});
		}
		
		return companyObj;
	}

	init();

	angular.extend($scope, {
		saveNewCompanyModules,
		validateModuleSelection
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPayrollForm', function () {

	return {
		controller: 'addNewCompanyPayrollFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/payroll/addNewCompanyPayrollForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPayrollFormCtrl', ['$scope', '$timeout', 'dataImportData', 'wizardService', function ($scope, $timeout, dataImportData, wizardService) {

	var companyObj = wizardService.newCompany;
	var onSuccess = $scope.formOptions.onSuccess;

	function init () {

		$scope.company = companyObj;

		//set default value
		$scope.company.EmployerDetails.IsElectronicUpdatesEnabled = false;

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function testCredentials (companyObj, form) {

		// Update state
		setPageState('testing-hmrc-credentials');

		// Give user time to digest feedback for testing the HMRC crednetials
		$timeout(function () {

			dataImportData.getAreHMRCCredentialsValidPreview(companyObj.EmployerDetails.HMRCUserName, companyObj.EmployerDetails.HMRCPassword).then(function (validationState) {

				switch (validationState) {
					case -1:
						setPageState('error');
						break;
					case -2:
						setPageState('hmrc-credentials-invalid');
						break;
					case -3:
						setPageState('automatic-updates-not-enabled');
						break;
					default:
						updateAgencyEmployerReferences(companyObj, form);
				}
			})
			.catch(function () {
				setPageState('hmrc-credentials-invalid');
			});

		}, 3000);
	}

	function updateAgencyEmployerReferences (companyObj, form) {

		// Update state
		form.state = 'saving';

		// Reset credentials if Electronic updates switched off
		if (!companyObj.EmployerDetails.IsElectronicUpdatesEnabled) {
			companyObj.EmployerDetails.HMRCUserName = '';
			companyObj.EmployerDetails.HMRCPassword = '';
			companyObj.EmployerDetails.DPSImport = false;
		}
		else {
			companyObj.EmployerDetails.DPSImport = true;
		}

		// On success
		if (onSuccess) {
			onSuccess();
			return;
		}

		// Update state
		form.state = 'saved';
	}

	init();

	// Scope functions
	$scope.saveNewCompanyPayroll = function (companyObj, form) {

		companyObj.EmployerDetails.IsElectronicUpdatesEnabled ? testCredentials(companyObj, form) : updateAgencyEmployerReferences(companyObj, form);

		// Update central company object
		wizardService.saveCompany(companyObj);
	};

	$scope.setPageState = function (pageState) {

		$scope.pageState = pageState;
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPayPeriodsForm', function () {

	return {
		controller: 'addNewCompanyPayPeriodsFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pay-periods/addNewCompanyPayPeriodsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPayPeriodsFormCtrl', ['$filter', '$scope', 'companyData', 'payPeriodSetupService', 'wizardService', function ($filter, $scope, companyData, payPeriodSetupService, wizardService) {

	var agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	var companyObj = wizardService.newCompany;
	var periodDetailsObj = wizardService.newCompany.PeriodDetails2;
	var onSuccess = $scope.formOptions.onSuccess;

	function decrementPayPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.payPeriodIndex === periodDetailsObj.payPeriodIndexMin) {
			return;
		}

		periodDetailsObj.payPeriodIndex--;
	}

	function incrementPayPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.payPeriodIndex === periodDetailsObj.payPeriodIndexMax) {
			return;
		}

		periodDetailsObj.payPeriodIndex++;
	}

	function generateTimeline (periodDetailsObj) {

		setupPayPeriodControls(periodDetailsObj);
		periodDetailsObj.isTimelineVisible = true;
	}

	function init () {

		periodDetailsObj.isTimelineVisible = false;

		$scope.agencyProfileID = companyObj.AgencyProfileID;
		$scope.newCompany = companyObj;
		$scope.periodDetails = periodDetailsObj;

		setPageState('ready');
	}

	function saveNewCompanyPayPeriods (newCompanyObj, formObj) {

		formObj.state = 'saving';

		// Assign the agencyProfileParentId
		newCompanyObj.AgencyProfileParentID = agencyProfileParentId;
		newCompanyObj.PeriodDetails2 = payPeriodSetupService.reviewPayPeriodDetails(newCompanyObj.PeriodDetails2);

		// If Payroll is not active we create the company and exit here
		if (companyObj.IsCISActive && !companyObj.IsPayrollActive) {

			// Update central company object
			wizardService.saveCompany(newCompanyObj);

			companyData.createCompany(companyObj).then(() => {

				$scope.formOptions.forceCallback({
					agencyProfileParentId: agencyProfileParentId
				});

				if (onSuccess) {
					onSuccess();
					return;
				}

				return;
			})
			.catch(error => {

				console.error(error);
				setPageState('error');
				formObj.state = null;
			});
		}

		else {

			companyData.createAgencyPayPeriodsPreview(newCompanyObj.PeriodDetails2).then((payPeriodsArr) => {

				if (!angular.isUndefined(payPeriodsArr[0])) {
					newCompanyObj.PeriodDetails2.payDateIso = payPeriodsArr[0].PayDateISO;
				}

				// Update central company object
				wizardService.saveCompany(newCompanyObj);

				if (onSuccess) {
					onSuccess();
					return;
				}

				return;
			})
			.catch(error => {

				console.error(error);
				setPageState('error');
				formObj.state = null;
			});
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setupPayPeriodControls (periodDetailsObj) {

		if (angular.isUndefined(periodDetailsObj.payPeriods)) {
			return;
		}

		periodDetailsObj.payPeriodIndex = 0;
		periodDetailsObj.payPeriodIndexMax = periodDetailsObj.payPeriods.length - 1;
		periodDetailsObj.payPeriodIndexMin = 0;
	}

	function toggleIsTimelineVisible (periodDetailsObj) {

		setupPayPeriodControls(periodDetailsObj);
		periodDetailsObj.isTimelineVisible = !periodDetailsObj.isTimelineVisible;
	}

	init();

	angular.extend($scope, {
		company: companyObj,
		decrementPayPeriodIndex,
		generateTimeline,
		incrementPayPeriodIndex,
		saveNewCompanyPayPeriods,
		toggleIsTimelineVisible
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionAutomationForm', function () {

	return {
		controller: 'addNewCompanyPensionAutomationFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-automation/addNewCompanyPensionAutomationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionAutomationFormCtrl', [
	'$scope',
	'companyData',
	'wizardService',
	function (
		$scope,
		companyData,
		wizardService
	) {

	const onSuccess = $scope.formOptions.onSuccess;

	function decoratePension (pensionObj) {

		return angular.extend(pensionObj, {
			showOverviewDetailsTeam: true,
			showOverviewDetailsConnect: true,
			showOverviewDetailsComms: true,
		});
	}

	function onAssessTeamChange (pensionObj) {

		if (!pensionObj.AssessTeam) {
			pensionObj.ConnectToProvider = false;
		}
	}

	function saveNewCompanyPensionAutomation (pensionObj, formObj) {

		// Update state
		formObj.state = 'saving';

		// Update central pension object
		wizardService.savePension(pensionObj);

		// On success
		if (onSuccess) {
			onSuccess();
		}

		// Update state
		formObj.state = 'saved';
	}

	function toggleShowOverviewDetailsConnect (pensionObj) {
		pensionObj.showOverviewDetailsConnect = !pensionObj.showOverviewDetailsConnect;
	}

	function toggleShowOverviewDetailsComms (pensionObj) {
		pensionObj.showOverviewDetailsComms = !pensionObj.showOverviewDetailsComms;
	}

	function toggleShowOverviewDetailsTeam (pensionObj) {
		pensionObj.showOverviewDetailsTeam = !pensionObj.showOverviewDetailsTeam;
	}

	angular.extend($scope, {
		pension: decoratePension(wizardService.newPension),

		onAssessTeamChange,
		saveNewCompanyPensionAutomation,
		toggleShowOverviewDetailsComms,
		toggleShowOverviewDetailsConnect,
		toggleShowOverviewDetailsTeam
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionGhostForm', function () {

	return {
		controller: 'addNewCompanyPensionGhostFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-ghost/addNewCompanyPensionGhostForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionGhostFormCtrl', [
	'$scope',
	'companyData',
	'config',
	'wizardService',
function (
	$scope,
	companyData,
	config,
	wizardService
) {

	const onSuccess = $scope.formOptions.onSuccess;
	const pensionObj = wizardService.newPension;
	const companyObj = wizardService.newCompany;

	function init () {

		angular.extend($scope, {
			company: companyObj,
			pension: pensionObj
		});

		setPageState('ready');
	}

	// Save new company, deferring pension creation
	function saveNewCompanyPensionDeferred (companyObj, formObj) {
		formObj.state = 'saving';

		// Set pension provider ID to empty guid, since once isn't being selected.
		companyObj.PensionDetails.PensionProviderID = config.guidEmpty;

		companyData.createCompany(companyObj).then(() => {
			if (onSuccess) {
				onSuccess();
			}
		})
		.catch (() => {
			setPageState('error');
			formObj.state = null;
		});
	}

	function saveNewCompanyPensionSettings (pensionObj, form) {

		if (pensionObj.IsGhostPension) {
			// Ensure the selectedPensionProviderObj has no data
			pensionObj.selectedPensionProviderObj = null;
		}

		// Reset to empty guid
		if (pensionObj.PensionProviderID === '') {
			pensionObj.PensionProviderID = config.guidEmpty;
		}

		// Update state
		form.state = 'saving';

		// Update central pension object
		wizardService.savePension(pensionObj);

		// On success
		if (onSuccess) {
			onSuccess();
		}

		// Update state
		form.state = 'saved';
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		saveNewCompanyPensionDeferred,
		saveNewCompanyPensionSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionGroupsForm', function () {

	return {
		controller: 'addNewCompanyPensionGroupsFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-groups/addNewCompanyPensionGroupsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionGroupsFormCtrl', [
	'$scope',
	'companyData',
	'pensionData',
	'pensionService',
	'wizardService',
	'PENSION_TYPES',
function (
	$scope,
	companyData,
	pensionData,
	pensionService,
	wizardService,
	PENSION_TYPES
) {

	const agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	const companyObj = wizardService.newCompany;
	const onSuccess = $scope.formOptions.onSuccess;
	const pensionObj = wizardService.newPension;

	function addNewPensionGroup (vmObj) {
		vmObj.pension.PensionGroups.push(angular.copy(vmObj.defaultPensionGroup));
	}

	function deletePensionGroup (pensionGroupsArr, index) {
		pensionGroupsArr.splice(index, 1);
	}

	function decoratePensionGroups (pensionObj, payeDetailsObj) {
		for (let pensionGroupObj of pensionObj.PensionGroups) {
			pensionService.decorateNewPensionGroup(pensionGroupObj, payeDetailsObj);
		}

		return pensionObj;
	}

	function init () {

		// Get policies if HR is active

		companyData.getPAYEDetailsPreview(companyObj.PeriodDetails2.payDateIso).then(payeDetailsObj => {

			$scope.vm = {
				company: companyObj,
				pension: decoratePensionGroups(pensionObj, payeDetailsObj),
				defaultPensionGroup: pensionService.getDefaultPensionGroup(pensionObj, payeDetailsObj),
			};

			// Since this is the last form we change the text to Finish
			$scope.formOptions.primaryButtonText = 'Finish';

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function saveNewCompanyPensionGroups (vmObj, formObj) {

		formObj.state = 'saving';

		// Update wizard service
		wizardService.saveCompany(companyObj);

		companyData.createCompany(companyObj).then(newCompanyObj => {

			// Attach AgencyEmployerID to new company object
			wizardService.newPension.AgencyEmployerID = newCompanyObj.EmployerDetails.AgencyEmployerID;

			// Create the pension section only after the company has been created successfully
			pensionData.createAgencyEmployerPension(newCompanyObj.AgencyProfileID, agencyProfileParentId, vmObj.pension).then(() => {

				$scope.formOptions.forceCallback({
					agencyProfileParentId: agencyProfileParentId
				});

				wizardService.savePension(pensionObj);

				// On success
				if (onSuccess) {
					onSuccess();
					return;
				}
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PENSION_TYPES,

		addNewPensionGroup,
		deletePensionGroup,
		saveNewCompanyPensionGroups,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionPostponementForm', function () {

	return {
		controller: 'addNewCompanyPensionPostponementFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-postponement/addNewCompanyPensionPostponementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionPostponementFormCtrl', [
	'$scope',
	'companyData',
	'payPeriodService',
	'pensionData',
	'wizardService',
	function (
		$scope,
		companyData,
		payPeriodService,
		pensionData,
		wizardService
	) {

	var agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	var companyObj = wizardService.newCompany;
	var pensionObj = wizardService.newPension;
	var onSuccess = $scope.formOptions.onSuccess;

	function init () {

		var payPeriodType = companyObj.PeriodDetails2.PayPeriodType;

		pensionData.getValidPostponementSettingsLength(payPeriodType).then(postponementSettingsLength => {

			// Scope
			$scope.pension = pensionObj;
			$scope.postponementOptions = payPeriodService.getPostponementOptions(payPeriodType, postponementSettingsLength);

			// Page state
			setPageState('ready');
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
		});
	}

	function saveNewCompanyAndPension (companyObj, pensionObj, formObj) {

		formObj.state = 'saving';

		// Update wizard service
		wizardService.saveCompany(companyObj);

		// todo: move code below to a service - createCompany is now run from 4 different forms
		companyData.createCompany(companyObj).then(newCompanyObj => {

			// Attach AgencyEmployerID to new company object
			wizardService.newPension.AgencyEmployerID = newCompanyObj.EmployerDetails.AgencyEmployerID;

			// Create the pension section only after the company has been created successfully
			pensionData.createAgencyEmployerPension(newCompanyObj.AgencyProfileID, agencyProfileParentId, pensionObj).then(() => {

				$scope.formOptions.forceCallback({
					agencyProfileParentId: agencyProfileParentId
				});

				wizardService.savePension(pensionObj);

				if (onSuccess) {
					onSuccess();
				}
			})
			.catch(error => {

				console.error(error);
				setPageState('error');
				formObj.state = null;
			});
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function saveNewCompanyPensionPostponement (pensionObj, formObj) {

		// Update state
		formObj.state = 'saving';

		// Update central pension object
		wizardService.savePension(pensionObj);

		// On success
		if (onSuccess) {
			onSuccess();
		}
	}

	function saveNewCompanyPensionPostponementForm (companyObj, pensionObj, formObj) {

		if (pensionObj.IsGhostPension) {
			saveNewCompanyAndPension(companyObj, pensionObj, formObj);
		}
		else {
			saveNewCompanyPensionPostponement(pensionObj, formObj);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		company: companyObj,
		saveNewCompanyPensionPostponementForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionProviderForm', function () {

	return {
		controller: 'addNewCompanyPensionProviderFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-provider/addNewCompanyPensionProviderForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionProviderFormCtrl', [
	'$scope',
	'config',
	'pensionData',
	'pensionService',
	'wizardService',
	'PENSION_PROVIDER_APIS',
	'TAX_RELIEF_TYPES',
function (
	$scope,
	config,
	pensionData,
	pensionService,
	wizardService,
	PENSION_PROVIDER_APIS,
	TAX_RELIEF_TYPES
) {

	const agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	const onSuccess = $scope.formOptions.onSuccess;
	const pensionObj = wizardService.newPension;

	function decoratePensionObj (pensionObj) {

		// Reset
		pensionObj.PensionProviderID = '';

		return pensionObj;
	}

	function filterManualProvidersOnly (pensionProviderObj) {

		return !pensionProviderObj.PensionProviderHasAPI;
	}

	function getPensionProviderObj (pensionObj, pensionProvidersArray) {

		return pensionProvidersArray.filter(function (pensionProviderObj) {
			return pensionProviderObj.PensionProviderID === pensionObj.PensionProviderID;
		})[0];
	}

	function init () {

		setPageState('loading');

		pensionData.getPensionProviderDetails(agencyProfileParentId).then(function (pensionProvidersArray) {

			$scope.manualProviders = pensionProvidersArray.filter(filterManualProvidersOnly);
			$scope.pensionProviders = pensionProvidersArray;
			$scope.pension = decoratePensionObj(pensionObj);

			// Return empty if in playground to only show manual pensions
			$scope.directConnectionProviders = pensionProvidersArray.filter(pensionService.filterDirectConnectionProvidersOnly);

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function onPensionProviderSelect (pensionObj, pensionProviderObj) {

		angular.extend(pensionObj, {
			ConnectToProvider: pensionProviderObj.PensionProviderHasAPI,
			UsePensionPolicy: false
		});
	}

	function saveNewCompanyPensionSettings (pensionObj, pensionProvidersArray, form) {

		pensionObj.selectedPensionProviderObj = getPensionProviderObj(pensionObj, pensionProvidersArray);

		// Reset to empty guid
		if (pensionObj.PensionProviderID === '') {
			pensionObj.PensionProviderID = config.guidEmpty;
		}

		// Update state
		form.state = 'saving';

		// Update central pension object
		wizardService.savePension(pensionObj);

		// On success
		if (onSuccess) {
			onSuccess();
		}

		// Update state
		form.state = 'saved';
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleManuallyEnterPension (pensionObj) {

		if (pensionObj.manuallyEnterPension) {
			pensionObj.PensionProviderID = config.guidEmpty;
		}
		else {
			pensionObj.PensionProviderName = '';
		}
	}

	init();

	angular.extend($scope, {
		PENSION_PROVIDER_APIS,
		TAX_RELIEF_TYPES,

		onPensionProviderSelect,
		saveNewCompanyPensionSettings,
		toggleManuallyEnterPension
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionSettingsForm', function () {

	return {
		controller: 'addNewCompanyPensionSettingsFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-settings/addNewCompanyPensionSettingsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionSettingsFormCtrl', [
	'$scope',
	'wizardService',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
	'PENSION_TYPES',
	'TAX_RELIEF_TYPES',
	function (
		$scope,
		wizardService,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES,
		TAX_RELIEF_TYPES
	) {

	const companyObj = wizardService.newCompany;
	const pensionObj = wizardService.newPension;
	const onSuccess = $scope.formOptions.onSuccess;

	function init () {

		const isBeforePeriodDate = pensionObj.IsPensionDateOffsetBeforePeriodDate;
		const pensionDateOffset = pensionObj.PensionDateOffset;
		let pensionDateBeforeOffset = null;
		let pensionDateAfterOffset = null;

		if (isBeforePeriodDate) {
			pensionDateBeforeOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}
		else {
			pensionDateAfterOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}

		const vmObj = {
			company: companyObj,
			pension: pensionObj,
			isBeforePeriodDate: isBeforePeriodDate,
			pensionDateBeforeOffset: pensionDateBeforeOffset,
			pensionDateAfterOffset: pensionDateAfterOffset,
		};

		$scope.vm = vmObj;

		setPageState('ready');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function onOffsetTypeChange (vmObj) {

		if (vmObj.isBeforePeriodDate) {
			vmObj.pensionDateAfterOffset = null;
			vmObj.pensionDateBeforeOffset = vmObj.pensionDateBeforeOffset === null ? 0 : vmObj.pensionDateBeforeOffset;
		}
		else {
			vmObj.pensionDateBeforeOffset = null;
			vmObj.pensionDateAfterOffset = vmObj.pensionDateAfterOffset === null ? 0 : vmObj.pensionDateAfterOffset;
		}
	}

	function saveNewCompanyPensionSettings  (vmObj, formObj) {

		// Update state
		formObj.state = 'saving';

		// Update pension alignment settings
		vmObj.pension.IsPensionDateOffsetBeforePeriodDate = vmObj.isBeforePeriodDate;
		vmObj.pension.PensionDateOffset = vmObj.isBeforePeriodDate ? vmObj.pensionDateBeforeOffset : vmObj.pensionDateAfterOffset;

		// Update central pension object
		wizardService.savePension(vmObj.pension);

		// On success
		if (onSuccess) {
			onSuccess();
		}

		// Update state
		formObj.state = 'saved';
	}

	init();

	angular.extend($scope, {

		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES,
		TAX_RELIEF_TYPES,

		onOffsetTypeChange,
		saveNewCompanyPensionSettings,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyPensionStagingForm', function () {

	return {
		controller: 'addNewCompanyPensionStagingFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/pension-staging/addNewCompanyPensionStagingForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyPensionStagingFormCtrl', [
	'$scope',
	'config',
	'pensionData',
	'pensionService',
	'wizardService',
	function (
		$scope,
		config,
		pensionData,
		pensionService,
		wizardService
	) {

	const onSuccess = $scope.formOptions.onSuccess;
	const companyObj = wizardService.newCompany;
	const pensionObj = wizardService.newPension;

	function getPostponementDateBoundaries (vmObj) {
		vmObj.postponementDateBoundaries = pensionService.getPostponementDateBoundaries(vmObj.pension.StagingDateISO);
	}

	function init () {

		const vmObj = {
			company: companyObj,
			pension: pensionObj,
			postponementDateBoundaries: pensionService.getPostponementDateBoundaries(pensionObj.StagingDateISO),
			stagingDateBoundaries: pensionService.getStagingDateBoundaries()
		};

		validateReenrolmentDate(vmObj);

		$scope.vm = vmObj;

		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function saveNewCompanyPensionStaging (vmObj, formObj) {

		// Update state
		formObj.state = 'saving';

		// Update central pension object
		wizardService.savePension(vmObj.pension);

		// On success
		if (onSuccess) {
			onSuccess();
			return;
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function validateReenrolmentDate (vmObj) {

		if (!vmObj.pension.ReenrolmentAlreadyCompleted) {
			vmObj.pension.ReenrolmentCompletionDateISO = '';
		}

		if (moment(vmObj.pension.StagingDateISO).isValid()) {
			pensionData.isValidReenrolmentDatePreview(vmObj.pension.StagingDateISO, vmObj.pension.ReenrolmentDateISO, vmObj.pension.ReenrolmentCompletionDateISO, vmObj.company.PeriodDetails2.PeriodStartDateISO, vmObj.company.PeriodDetails2.PayPeriodType).then(validationObj => {
				vmObj.validationResults = validationObj;
			})
			.catch(onError);
		}
	}

	init();

	// Scope Functions
	$scope.saveNewCompanyPensionStaging = saveNewCompanyPensionStaging;

	$scope.$watch('vm.pension.StagingDateISO', function (newValue, oldValue, scopeObj) {
		if (newValue !== oldValue) {
			getPostponementDateBoundaries(scopeObj.vm);
			validateReenrolmentDate(scopeObj.vm);
		}
	});

	$scope.$watch('[vm.pension.ReenrolmentDateISO, vm.pension.ReenrolmentCompletionDateISO, vm.pension.ReenrolmentAlreadyCompleted]', function (newDatesArr, oldDatesArr, scopeObj) {

		if (!angular.equals(newDatesArr, oldDatesArr)) {
			validateReenrolmentDate(scopeObj.vm);
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyAdditionalInfoForm', function () {

	return {
		controller: 'addNewCompanyAdditionalInfoFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/additional-info/addNewCompanyAdditionalInfoForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyAdditionalInfoFormCtrl', [
	'$q',
	'$scope',
	'config', 
	'companyData',
	'companyService',
	'wizardService',
	'dataImportData',
	'base',
function (
	$q,
	$scope,
	config, 
	companyData, 
	companyService,
	wizardService,
	dataImportData,
	base
) {

	var companyObj = wizardService.newCompany;
	var onSuccess = $scope.formOptions.onSuccess;
	var agencyProfileParentId = $scope.formOptions.agencyProfileParentId;

	function decorateCompany (companyObj, payeDetailsObj) {

		companyObj.apprenticeshipLevyYTDActive = companyObj.EmployerDetails.PayPeriodGroupPayBillYTD + companyObj.EmployerDetails.PayPeriodGroupAppLevyYTD > 0;
		companyObj.EmployerDetails.CanHaveEmployersAllowanceSector = payeDetailsObj.CanHaveEmploymentAllowanceSector;
		companyObj.EmployerDetails.EmployersAllowanceMax = payeDetailsObj.EmploymentAllowanceMaximum;

		return companyObj;
	}
	
	// Check if the group is linked to an organization and validate customer codes
	function checkGroupOrganizationAndCustomerCodes() {

		$scope.isGroupCreationFeatureEnabled = false;
		$scope.isGroupLinkedToOrganisation = false;
		$scope.organisationCustomerCode = '';
		$scope.companyCustomerCodeMissing = false;
		$scope.customerCodesMatch = false;
		$scope.enableLinkingCompanyToOrganisation = false;

		return dataImportData.getLinkedBureauAgencyProfileIdByGroupId(agencyProfileParentId)
			.then(function(bureauAgencyProfileId) {
				$scope.bureauAgencyProfileId = bureauAgencyProfileId;
				
				if (!bureauAgencyProfileId || bureauAgencyProfileId === config.guidEmpty) {
					return $q.resolve(false);
				}

				return base.isFeatureEnabled(bureauAgencyProfileId, 'GROUP_CREATION_ENABLED');
			})
			.then(function(isFeatureEnabled) {
				$scope.isGroupCreationFeatureEnabled = isFeatureEnabled || false;
				
				if (!$scope.isGroupCreationFeatureEnabled) {
					return $q.resolve();
				}

				// Check if the group is linked to an organization
				return dataImportData.getLinkedOrganisationToGroupCompany(agencyProfileParentId);
			})
			.then(function(linkedOrganisationId) {
				if (!$scope.isGroupCreationFeatureEnabled) {
					return $q.resolve();
				}

				$scope.linkedOrganisationId = linkedOrganisationId;
				$scope.isGroupLinkedToOrganisation = linkedOrganisationId && linkedOrganisationId !== config.guidEmpty;
				
				if (!$scope.isGroupLinkedToOrganisation) {
					return $q.resolve();
				}
				
				// Get organization customer code
				return companyData.getOrganisationCustomerCode($scope.linkedOrganisationId);
			})
			.then(function(organisationCustomerCode) {
				if (!$scope.isGroupCreationFeatureEnabled || !$scope.isGroupLinkedToOrganisation) {
					return $q.resolve();
				}

				$scope.organisationCustomerCode = organisationCustomerCode || '';
				
				// Get the customer code from the company object
				let companyCustomerCode = companyObj.CustomerCode || '';

				$scope.companyCustomerCode = companyCustomerCode;
				
				// Check if company has a customer code
				if (!companyCustomerCode) {
					$scope.companyCustomerCodeMissing = true;
					$scope.customerCodesMatch = false;
				} else {
					// Check if customer codes match
					$scope.customerCodesMatch = companyCustomerCode === $scope.organisationCustomerCode;
				}

				$scope.enableLinkingCompanyToOrganisation = $scope.customerCodesMatch;
			})
			.catch(function(error) {
				console.error('Error checking group organization and customer codes:', error);
			});
	}

	function init () {

		const getBusinessSectorOptions = companyService.getBusinessSectorOptions();
		const getPAYEDetailsPreview = companyData.getPAYEDetailsPreview(companyObj.PeriodDetails2.payDateIso);
		const checkGroupOrgPromise = checkGroupOrganizationAndCustomerCodes();

		$q.all([getBusinessSectorOptions, getPAYEDetailsPreview, checkGroupOrgPromise]).then(([businessSectorOptions, payeDetailsObj]) => {
			$scope.BUSINESS_SECTOR_OPTIONS = businessSectorOptions;
			$scope.company = decorateCompany(companyObj, payeDetailsObj);
			
			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function changeApprenticeshipLevyOption (employerObj, apprenticeshipLevyOption) {

		switch (apprenticeshipLevyOption) {
			case 'full':
				employerObj.ApprenticeshipLevyAmount = config.apprenticeshipLevy;
				employerObj.HasApprenticeshipAllowanceSplit = false;
				break;
			case 'none':
				employerObj.ApprenticeshipLevyAmount = 0;
				employerObj.HasApprenticeshipAllowanceSplit = true;
				break;
			case 'custom':
				employerObj.ApprenticeshipLevyAmount = null;
				employerObj.HasApprenticeshipAllowanceSplit = true;
				break;
		}

		employerObj.apprenticeshipLevyOption = apprenticeshipLevyOption;
	}

	init();

	$scope.changeApprenticeshipLevyOption = function (employerObj, apprenticeshipLevyOption) {

		changeApprenticeshipLevyOption(employerObj, apprenticeshipLevyOption);
	};

	$scope.saveCompanyAdditionalInfoForm = function (company, form) {

		form.state = 'saving';

		// Assign the agencyProfileParentId
		company.AgencyProfileParentID = agencyProfileParentId;

		// Zero PayPeriodGroupPayBillYTD and PayPeriodGroupAppLevyYTD if toggle is off
		if (!companyObj.apprenticeshipLevyYTDActive) {
			angular.extend(company.EmployerDetails, {
				PayPeriodGroupAppLevyYTD: 0,
				PayPeriodGroupPayBillYTD: 0
			});
		}
		// Add only the necessary customer codes and linking info to the company obj to be displayed in finish form
		angular.extend(company, {
			isGroupCreationFeatureEnabled: $scope.isGroupCreationFeatureEnabled,
			isGroupLinkedToOrganisation: $scope.isGroupLinkedToOrganisation,
			organisationCustomerCode: $scope.organisationCustomerCode,
			companyCustomerCode: $scope.companyCustomerCode,
			customerCodesMatch: $scope.customerCodesMatch,
			companyCustomerCodeMissing: $scope.companyCustomerCodeMissing
		});

		if (!company.IsPensionActive) {
			wizardService.newCreatedCompany = angular.copy(company);
			companyData.createCompany(company).then(function (response) {

				if (response && response.AgencyProfileID) {
					wizardService.newCreatedCompany.AgencyProfileID = response.AgencyProfileID;

					if (!$scope.enableLinkingCompanyToOrganisation && $scope.isGroupCreationFeatureEnabled && $scope.isGroupLinkedToOrganisation) {
						return companyData.updateAgencyProfileAgencyProfile(
							response.AgencyProfileID, 
							agencyProfileParentId,
							true
						).then(function() {
							$scope.formOptions.forceCallback({
								agencyProfileParentId: agencyProfileParentId
							});
							
							if (onSuccess) {
								onSuccess();
								return;
							}
						});
					}
					// If customer code matches then link the company to the organization
					else if ($scope.enableLinkingCompanyToOrganisation && $scope.isGroupCreationFeatureEnabled && $scope.isGroupLinkedToOrganisation) {
						return dataImportData.linkCompanyToOrganisation(
							company.CompanyName,
							$scope.linkedOrganisationId
						).then(function(linkedSuccessfully) {
							if (linkedSuccessfully) {
								$scope.formOptions.forceCallback({
									agencyProfileParentId: agencyProfileParentId
								});

								if (onSuccess) {
									onSuccess();
									return;
								}
							}
						});
					}
					else {
						$scope.formOptions.forceCallback({
							agencyProfileParentId: agencyProfileParentId
						});

						if (onSuccess) {
							onSuccess();
							return;
						}
					}
				}

				return;
			})
			.catch(function (error) {
				console.error('Error creating company:', error);
				setPageState('error');
				form.state = null;
			});
		}

		else {

			if (onSuccess) {
				onSuccess();
				return;
			}
		}
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyGroupForm', function () {

	return {
		controller: 'addNewCompanyGroupFormCtrl',
		templateUrl: 'forms/admin/addNewCompanyGroup/addNewCompanyGroupForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyGroupFormCtrl', ['$scope', 'dataImportData', 'companyData', 'config', 'base', function ($scope, dataImportData, companyData, config, base) {

	const agencyProfileParentId = $scope.formOptions.agencyProfileId;
	function addNewCompanyGroup (companyGroup, form) {
		form.state = 'saving';

		const selectedOrganisationId = companyGroup.enableEvoFeatures && angular.isDefined($scope.selectedOrganization) && $scope.selectedOrganization !== null ? $scope.selectedOrganization : config.guidEmpty;
		
		dataImportData.createGroupCompany(agencyProfileParentId, companyGroup.companyGroupName, selectedOrganisationId).then((newGroupAgencyProfileId) => {
			$scope.formOptions.forceCallback();

			form.state = 'saved';

			// If an organization has been selected, get the linked companies and add them to the group
			if (companyGroup.enableEvoFeatures && $scope.selectedOrganization) {
				getLinkedCompaniesAndUpdate($scope.selectedOrganization, newGroupAgencyProfileId);
			} else {
				setPageState('success');
			}
		})
		.catch((error) => {
			setPageState('error');
			console.error(error);
		});
	}

	function getLinkedCompaniesAndUpdate(organisationId, newGroupAgencyProfileId) {
		companyData.getLinkedCompanies(organisationId)
			.then((linkedCompanies) => {
				return companyData.updateAgencyProfileAgencyProfiles(
					linkedCompanies, 
					newGroupAgencyProfileId,
					false
				);
			})
			.then(() => {
				setPageState('success');
			})
			.catch((error) => {
				setPageState('error');
				console.error(error);
			});
	}
	
	function setupSelectedOrganization(option) {
		$scope.selectedOrganization = option;
	}

	function getSelectedOrganizationName(organizationId) {
		if (!organizationId || !$scope.organizations || $scope.organizations.length === 0) {
			return '';
		}
		
		const selectedOrganisation = $scope.organizations.find(org => org.OrganisationID === organizationId);
		return selectedOrganisation ? selectedOrganisation.OrganisationName : '';
	}

	function init () {
		companyData.fetchOrganizations(agencyProfileParentId).then((response) => {
			$scope.organizations = [...response];
		})
		.catch((error) => {
			setPageState('error');
			console.error(error);
		});

		base.isFeatureEnabled(agencyProfileParentId, 'GROUP_CREATION_ENABLED').then(isFeatureEnabled => {
			$scope.IsGroupCreationFeatureEnabled = isFeatureEnabled;
		});
		angular.extend($scope, {
			addNewCompanyGroup,
			setupSelectedOrganization,
			getSelectedOrganizationName,
			companyGroup: {
				companyGroupName: '',
				enableEvoFeatures: false,
				confirmCorrectOrganization: false
			},
			pageState: 'ready',
			organizations: [],
			selectedOrganization: null,
			IsGroupCreationFeatureEnabled: false
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	} 

	init();
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAddOfficeLocationsForm', function () {

	return {
		controller: 'companySettingsAddOfficeLocationsFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/companySettingsAddOfficeLocationsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAddOfficeLocationsFormCtrl', ['$q', '$scope', 'securityData', 'utilities', function ($q, $scope, securityData, utilities) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const ipAddressId = $scope.formOptions.ipAddressId;
	const officeLocationsToDelete = [];

	function addOfficeLocation (ipAddresses) {

		// Create and add a new office location
		ipAddresses.push(angular.copy($scope.ipAddressEmpty));
	}

	function deleteOfficeLocation (ipAddressToDelete, ipAddresses) {

		// Add to removal list
		officeLocationsToDelete.push(ipAddressToDelete.IPAddressID);

		// Remove from list
		$scope.ipAddresses = ipAddresses.filter(ipAddress => {
			return ipAddress !== ipAddressToDelete;
		});
	}

	function init () {

		setPageState('loading');

		// Get a new empty IP object, for creating new locations, and get the IP list for this company
		const getIPAddressEmpty = securityData.getIPAddressEmpty();
		const getIPAddresses = securityData.getIPAddresses(agencyProfileId);

		$q.all([getIPAddressEmpty, getIPAddresses]).then(([ipAddressEmptyObj, ipAddressesArr]) => {

			// Decorate the empty IP address range with the agency ID
			ipAddressEmptyObj.OwnerID = agencyProfileId;

			// Show single office location if ip address ID set - used when editing a specific office location
			if (angular.isDefined(ipAddressId)) {
				$scope.ipAddresses = ipAddressesArr.filter(ipAddress => ipAddress.IPAddressID === ipAddressId);
				$scope.showAddLocation = false;
			}
			else {
				// Sort the list by description
				$scope.ipAddresses = ipAddressesArr.sort(utilities.comparator('Description'));
				$scope.showAddLocation = true;
			}
			$scope.ipAddressEmpty = ipAddressEmptyObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateOfficeLocations (form, ipAddresses) {

		form.state = 'saving';

		// Create update operations; one to update existing, and one each for removal
		let updateOperations = [securityData.updateIPAddresses(agencyProfileId, ipAddresses)];
		officeLocationsToDelete.forEach(ipAddressId => {
			updateOperations.push(securityData.deleteIPAddress(ipAddressId));
		});

		$q.all(updateOperations).then(() => {
			// Success
			form.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('save-success');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		addOfficeLocation,
		deleteOfficeLocation,
		updateOfficeLocations
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAuthenticationSessionForm', function () {

	return {
		controller: 'companySettingsAuthenticationSessionFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/companySettingsAuthenticationSessionForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAuthenticationSessionFormCtrl', ['$scope', 'agency', 'config', 'growl',
	function ($scope, agency, config, growl) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	const SESSION_DURATION_OPTIONS = {
		fifteen: 'session-fifteen',
		thirty: 'session-thirty',
		custom: 'session-custom'
	};

	function getSessionTimeoutForOption (option) {

		switch (option) {
			case SESSION_DURATION_OPTIONS.fifteen:
				return 15;

			case SESSION_DURATION_OPTIONS.thirty:
				return 30;

			case SESSION_DURATION_OPTIONS.custom:
				return 0;
		}
	}

	function getSessionTimeoutOption (companyAuthenticationObj) {

		switch (companyAuthenticationObj.SessionTimeout) {
			case 15:
				return SESSION_DURATION_OPTIONS.fifteen;

			case 30:
				return SESSION_DURATION_OPTIONS.thirty;

			default:
				return SESSION_DURATION_OPTIONS.custom;
		}
	}

	function init () {

		setPageState('loading');

		agency.getCompanyAuthenticationDetails(agencyProfileId).then(companyAuthenticationObj => {

			$scope.vm = {
				companyAuthentication: companyAuthenticationObj,
				sessionTimeoutOption: getSessionTimeoutOption(companyAuthenticationObj)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onSessionTimeoutChange (vmObj, option) {

		vmObj.sessionTimeoutOption = option;

		vmObj.companyAuthentication.SessionTimeout = getSessionTimeoutForOption(option);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateCompanyAuthenticationDetails (vmObj, formObj) {

		const companyAuthenticationObj = vmObj.companyAuthentication;

		formObj.state = 'saving';

		agency.updateCompanyAuthenticationDetails(companyAuthenticationObj).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Session timeout details saved.');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		SESSION_DURATION_OPTIONS,

		onSessionTimeoutChange,
		updateCompanyAuthenticationDetails
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAuthenticationSsoForm', function () {

	return {
		controller: 'companySettingsAuthenticationSsoFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/companySettingsAuthenticationSsoForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAuthenticationSsoFormCtrl', [
	'$q',
	'$scope',
	'agency',
	'growl',
	'teamData',
	'OIDC_OPTIONS',
	'OIDC_SYSTEMS',
function (
	$q,
	$scope,
	agency,
	growl,
	teamData,
	OIDC_OPTIONS,
	OIDC_SYSTEMS
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		$q.all([
			agency.getCompanyAuthenticationDetails(agencyProfileId),
			teamData.getTeamMemberRegisteredAdmins(agencyProfileId)
		])
		.then(([
			companyAuthenticationObj,
			registeredAdmins
		]) => {

			$scope.vm = {
				companyAuthentication: companyAuthenticationObj,
				hasAdmin: registeredAdmins.length >= 1,
			};

			manageSsoScenarios();

			setPageState('ready');
		})
		.catch(onError);
	}

	function manageSsoScenarios () {

		// Reset
		$scope.vm.noteTitle = null;
		$scope.vm.noteContent = null;
		$scope.vm.toggleDisabled = false;
		$scope.vm.saveButtonDisabled = false;

		if ($scope.vm.companyAuthentication.IsIdentityEnabled === false) {
		// Scenario 1
		// NOTE: OIDCEnabled and hasAdmin are not checked as they are not relevant
			return;
		}

		// Identity is on

		if ($scope.vm.companyAuthentication.OIDCEnabled === false) {
			// Scenario 2
			$scope.vm.noteTitle = 'Single sign-on and Access Identity';
			$scope.vm.noteContent = 'Please note that single sign-on is now disabled in Paycircle and should be enabled using Access Identity.';
			$scope.vm.toggleDisabled = true;
			$scope.vm.saveButtonDisabled = true;

			return;
		}

		if ($scope.vm.hasAdmin === true) {
			// Scenario 3
			$scope.vm.noteTitle = 'Single sign-on will be disabled';
			$scope.vm.noteContent = 'Once single sign-on (SSO) is disabled, it will no longer be available in Paycircle and must be configured in Access Identity. After disabling single sign-on (SSO), we recommend reviewing your admin list to ensure all admins are registered in Paycircle. Admins marked as \'Not registered\' will need to be invited to complete their registration to successfully migrate their accounts to Access Identity.';
			$scope.vm.toggleDisabled = false;
			$scope.vm.saveButtonDisabled = false;

			return;
		}

		if ($scope.vm.hasAdmin === false) {
			// Scenario 4
			$scope.vm.noteTitle = 'Single sign-on can\'t be turned off at the moment';
			$scope.vm.noteContent = 'Please note that SSO can\'t be turned off while none of your bureau admins have previously registered for Paycircle. Please ensure that you or another admin registers for Paycircle by inviting them to register before coming back.';
			$scope.vm.toggleDisabled = true;
			$scope.vm.saveButtonDisabled = true;

			return;
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function updateCompanyAuthenticationSsoDetails (vmObj, formObj) {

		formObj.state = 'saving';

		agency.updateCompanyAuthenticationDetails(vmObj.companyAuthentication).then(() => {

			$scope.formOptions.forceCallback();
			growl.success('SSO authentication details saved.');
			$scope.formOptions.closeForm();
			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		OIDC_OPTIONS,
		OIDC_SYSTEMS,

		manageSsoScenarios,
		updateCompanyAuthenticationSsoDetails
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAuthenticationTfaForm', function () {

	return {
		controller: 'companySettingsAuthenticationTfaFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/companySettingsAuthenticationTfaForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAuthenticationTfaFormCtrl', ['$rootScope', '$scope', '$state', 'agency', 'growl', 'TFA_STATES',
	function ($rootScope, $scope, $state, agency, growl, TFA_STATES) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentUserObj = $rootScope.currentUser;

	const DEFAULT_TIME_PERIOD_DAYS = 14;

	function init () {

		setPageState('loading');

		agency.getCompanyAuthenticationDetails(agencyProfileId).then(companyAuthenticationObj => {

			let tfaIsEnabled = (companyAuthenticationObj.TwoFAState !== TFA_STATES.off);

			if (companyAuthenticationObj.IsIdentityEnabled) {
				tfaIsEnabled = false;
			}

			if (!tfaIsEnabled) {
				companyAuthenticationObj.TwoFAState = TFA_STATES.login;
			}

			$scope.vm = {
				isIdentityEnabled: companyAuthenticationObj.IsIdentityEnabled,
				companyAuthentication: companyAuthenticationObj,
				logoutOnSave: (agencyProfileId === currentUserObj.AgencyProfileID && !currentUserObj.Session2FAConfigured),
				tfaIsEnabled: tfaIsEnabled,
				originalTfaIsEnabled: tfaIsEnabled,
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onPeriodTypeChange (vmObj) {

		const companyAuthenticationObj = vmObj.companyAuthentication;

		switch (companyAuthenticationObj.TwoFAState) {
			case TFA_STATES.login:
				companyAuthenticationObj.TwoFATimePeriod = 0;
				break;

			case TFA_STATES.timePeriod:
				companyAuthenticationObj.TwoFATimePeriod = moment.duration(DEFAULT_TIME_PERIOD_DAYS, 'days').asMinutes();
				break;
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateCompanyAuthenticationDetails (vmObj, formObj) {

		formObj.state = 'saving';

		const companyAuthenticationObj = vmObj.companyAuthentication;

		if (!vmObj.tfaIsEnabled) {
			companyAuthenticationObj.TwoFAState = TFA_STATES.off;
		}

		agency.updateCompanyAuthenticationDetails(companyAuthenticationObj).then(() => {

			$scope.formOptions.forceCallback();
			growl.success('Two-factor authentication details saved.');

			if (vmObj.tfaIsEnabled && vmObj.logoutOnSave) {

				$rootScope.$broadcast('log-out');

				growl.info('You have been logged out, please sign in again to reauthenticate yourself.');

			} else {
				$scope.formOptions.closeForm();
			}

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		DEFAULT_TIME_PERIOD_DAYS,
		TFA_STATES,

		onPeriodTypeChange,
		updateCompanyAuthenticationDetails
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAutoApplyTaxRefundsForm', function () {

	return {
		controller: 'companySettingsAutoApplyTaxRefundsFormCtrl',
		templateUrl: 'forms/admin/companySettings/auto-apply-tax-refunds/companySettingsAutoApplyTaxRefundsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAutoApplyTaxRefundsFormCtrl', ['$scope', 'companyData', function ($scope, companyData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateUserAgencyProfileTaxRefund (autoApplyTaxRefund, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyEmployerAutoApplyTaxRefund(agencyProfileId, autoApplyTaxRefund).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($scope, {
		autoApplyTaxRefund: companyObj.AutoApplyTaxRefund,
		updateUserAgencyProfileTaxRefund
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsEditRemoteLocationsForm', function () {

	return {
		controller: 'companySettingsEditRemoteLocationsFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/companySettingsEditRemoteLocationsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsEditRemoteLocationsFormCtrl', ['$scope', 'securityData', 'teamData', 'utilities', function ($scope, securityData, teamData, utilities) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const adminUserId = $scope.formOptions.adminUserId;

	function addRemoteLocation (teamMemberAdmin) {
		teamMemberAdmin.IPAddress = '';
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberAdmins(agencyProfileId).then(teamMemberAdmins => {

			if (angular.isDefined(adminUserId)) {
				// Show IP address for single user - used when editing from a specific remote location card
				$scope.teamMemberAdmins = teamMemberAdmins.filter(teamMemberAdmin => teamMemberAdmin.UserID === adminUserId);
				$scope.showDelete = false;
			}
			else {
				// Sort the list by forename
				$scope.teamMemberAdmins = teamMemberAdmins.sort(utilities.comparator('Forename'));
				$scope.showDelete = true;
			}

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateRemoteLocations (form, teamMemberAdmins) {

		form.state = 'saving';
		securityData.updateIPAddressAdmins(teamMemberAdmins).then(() => {
			// Success
			form.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('save-success');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		addRemoteLocation,
		updateRemoteLocations
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsBacsForm', function () {

	return {
		controller: 'companySettingsBacsFormCtrl',
		templateUrl: 'forms/admin/companySettings/bacs/companySettingsBacsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsBacsFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'bankService',
	'base',
	'companyData',
	'config',
	'growl',
	'payrollData',
	'reportsService',
	'teamData',
	'utilities',
	'BACS_PAYMENT_TYPES',
	'BANK_FILE_FORMATS',
	'BANK_IDS',
	'PAY_PERIOD_TYPES',
	'REPORT_TEMPLATE_IDS',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$timeout,
		bankService,
		base,
		companyData,
		config,
		growl,
		payrollData,
		reportsService,
		teamData,
		utilities,
		BACS_PAYMENT_TYPES,
		BANK_FILE_FORMATS,
		BANK_IDS,
		PAY_PERIOD_TYPES,
		REPORT_TEMPLATE_IDS
	) {

	const AGENCY_PROFILE_ID	= $scope.formOptions.agencyProfileId;
	const formStage = $scope.formOptions.formStage;
	const currentCompanyObj = $scope.formOptions.company;

	let AGENCY_EMPLOYER_ID; // undefined specifically for update service call

	const PAGE_STATES = {
		loading: 'loading',
		ready: 'ready',
		paymentsIncluded: 'payments-included',
		saved: 'saved',
		incompleteTeamMembers: 'incomplete-team-members',
		error: 'error'
	};

	function decorateBankFiles (bankFilesArr) {

		for (let bankFileObj of bankFilesArr) {
			angular.extend(bankFileObj, {
				accountNameRequired: ![BANK_IDS.telleroo].includes(bankFileObj.BankID),
				accountNumberRequired: ![BANK_IDS.telleroo].includes(bankFileObj.BankID),
				sortCodeRequired: ![BANK_IDS.telleroo].includes(bankFileObj.BankID)
			});
		}

		return $filter('orderBy')(bankFilesArr, 'BankName');
	}

	function decorateCompanyBankDetails (companyBankDetailsObj) {

		// Add bool flags for payment options
		companyBankDetailsObj.includeAOE 				= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.aoe);
		companyBankDetailsObj.includeChildcareVouchers 	= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.childcare);
		companyBankDetailsObj.includeHMRC 				= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.hmrc);
		companyBankDetailsObj.includePension1 		 	= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.pension1);
		companyBankDetailsObj.includePension2 		 	= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.pension2);
		companyBankDetailsObj.includePension3 		 	= $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.pension3);

		return companyBankDetailsObj;
	}

	function loadBACSFileCreationForm (vmObj) {

		setPageState(PAGE_STATES.loading);

		const getBankDetailsCompany = base.getBankDetailsCompany(AGENCY_PROFILE_ID);
		const getBankFiles = base.getBankFiles();
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(AGENCY_PROFILE_ID);
		const getDisbursements = base.getDisbursementsForPayElements(AGENCY_PROFILE_ID);

		$q.all([
			getBankDetailsCompany,
			getBankFiles,
			getPayPeriodMinimum,
			getDisbursements
		]).then(([
			companyBankDetailsObj,
			bankFilesArr,
			payPeriodObj,
			disbursementsArr
		]) => {

			angular.extend(vmObj, {
				bankFiles: decorateBankFiles(bankFilesArr),
				company: currentCompanyObj,
				companyBankDetails: decorateCompanyBankDetails(companyBankDetailsObj),
				selectedBankFile: utilities.getArrayItemByPropertyName(bankFilesArr, 'BankID', companyBankDetailsObj.BankFileID),
				payPeriod: payPeriodObj,
				disableSaving: companyBankDetailsObj.BACSEnabled && disbursementsArr.length > 0
			});

			selectBankFileInit(vmObj);

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function init () {

		const vmObj = {};

		$scope.vm = vmObj;

		switch (formStage) {
			case PAGE_STATES.saved:
			case PAGE_STATES.incompleteTeamMembers:
				loadIncompleteTeamMembers(vmObj).then(() => {
					setPageState(formStage);
				});
				break;
			default:
				loadBACSFileCreationForm(vmObj);
		}
	}

	function loadIncompleteTeamMembers (vmObj) {

		setPageState(PAGE_STATES.loading);

		const LEAVERS = false;

		const getTeamMembers = teamData.getTeamMembers(AGENCY_PROFILE_ID, LEAVERS);
		const getUserAgencyProfileForAgencyNoBankDetails = teamData.getUserAgencyProfileForAgencyNoBankDetails(AGENCY_PROFILE_ID);

		return $q((onComplete, onError) => {
			$q.all([getTeamMembers, getUserAgencyProfileForAgencyNoBankDetails]).then(([teamMembersArr, incompleteTeamMembersArr]) => {

				angular.extend(vmObj, {
					teamMembers: teamMembersArr,
					incompleteTeamMembers: incompleteTeamMembersArr
				});

				onComplete();
			})
			.catch(onError);
		});
	}

	function openPaymentDetailsForm (teamMemberObj, returnState) {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: function () {

				$timeout(function () {
					$scope.formOptions.openNewSlideInForm({
						agencyProfileId: AGENCY_PROFILE_ID,
						callback: function () {
							$scope.formOptions.forceCallback();
						},
						formKey: 'company-settings-bacs',
						formStage: returnState,
						title: formStage === PAGE_STATES.incompleteTeamMembers ? 'Incomplete team members' : 'BACS file creation'

					});
				}, 100);

				$scope.formOptions.forceCallback();
			},
			contextType: 'user',
			formKey: 'payment-details',
			userId: teamMemberObj.UserID
		});
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function openEmployeeDetailsReportModal () {

		reportsService.openReportFromReportTemplateId(
			REPORT_TEMPLATE_IDS.employeeDetails,
			{ agencyProfileId: AGENCY_PROFILE_ID }
		);
	}

	function resetCompanyBACSDetails (vmObj, formObj) {

		angular.extend(vmObj.companyBankDetails, {
			BACSIncludedPayments: BACS_PAYMENT_TYPES.none,
			BACSPaymentReference: '',
			BankAccountName: '',
			BankAccountNumber: '',
			BankFileID: config.guidEmpty,
			SortCode: '',
			BankName: '',
			BankTemplateReference: ''
		});

		updateCompanyBACSDetails(vmObj, formObj);
	}

	function reviewCompanyBACSDetails (vmObj, formObj) {

		if (vmObj.companyBankDetails.BACSEnabled) {
			setPageState(PAGE_STATES.paymentsIncluded);

		} else {
			resetCompanyBACSDetails(vmObj, formObj);
		}
	}

	function selectBankFile (vmObj) {

		if (angular.isDefined(vmObj.selectedBankFile)) {

			angular.extend(vmObj.companyBankDetails, {
				BankFileID: vmObj.selectedBankFile.BankID, // Unable to copy whole object over as this property is not consistently named
				BankName: vmObj.selectedBankFile.BankName,
				IsBACSAvailable: vmObj.selectedBankFile.IsBACSAvailable,
				IsFPSAvailable: vmObj.selectedBankFile.IsFPSAvailable,
				IsGdffAvailable: vmObj.selectedBankFile.IsGdffAvailable
			});

			if (!vmObj.selectedBankFile.ShowTemplateReference) {
				vmObj.companyBankDetails.BankTemplateReference = '';
			}
		}
		else {
			vmObj.companyBankDetails.BankFileID = config.guidEmpty;
		}
	}

	function selectBankFileInit (vmObj) {

		selectBankFile(vmObj);

		if (angular.isDefined(vmObj.selectedBankFile)) {

			angular.extend(vmObj.companyBankDetails, {
				BACSFileFormat: bankService.getBankFileFormat(vmObj.selectedBankFile, vmObj.companyBankDetails.BACSFileFormat)
			});
		}
	}

	function selectBankFileUpdate (vmObj) {

		selectBankFile(vmObj);

		if (angular.isDefined(vmObj.selectedBankFile)) {

			angular.extend(vmObj.companyBankDetails, {
				BACSFileFormat: bankService.getDefaultBankFileFormat(vmObj.selectedBankFile)
			});
		}
	}

	function setBacsIncludedPayments (vmObj) {

		let updatedValue = BACS_PAYMENT_TYPES.none;

		if (vmObj.companyBankDetails.includeAOE) 				{ updatedValue += BACS_PAYMENT_TYPES.aoe; }
		if (vmObj.companyBankDetails.includeChildcareVouchers) 	{ updatedValue += BACS_PAYMENT_TYPES.childcare; }
		if (vmObj.companyBankDetails.includeHMRC) 				{ updatedValue += BACS_PAYMENT_TYPES.hmrc; }
		if (vmObj.companyBankDetails.includePension1) 			{ updatedValue += BACS_PAYMENT_TYPES.pension1; }
		if (vmObj.companyBankDetails.includePension2) 			{ updatedValue += BACS_PAYMENT_TYPES.pension2; }
		if (vmObj.companyBankDetails.includePension3) 			{ updatedValue += BACS_PAYMENT_TYPES.pension3; }

		vmObj.companyBankDetails.BACSIncludedPayments = updatedValue;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function isSunNumberApplicable (vmObj) {

		return bankService.isSunNumberApplicable(vmObj.selectedBankFile, {
			bankFileFormat: vmObj.companyBankDetails.BACSFileFormat,
			isGdffAvailable: vmObj.companyBankDetails.IsGdffAvailable
		});
	}

	function isSunNumberRequired (vmObj) {

		return bankService.isSunNumberRequired(vmObj.selectedBankFile, {
			bankFileFormat: vmObj.companyBankDetails.BACSFileFormat,
			isGdffAvailable: vmObj.companyBankDetails.IsGdffAvailable
		});
	}

	function updateCompanyBACSDetails (vmObj, formObj) {

		formObj.state = 'saving';

		base.updateBankDetailsCompany(AGENCY_PROFILE_ID, AGENCY_EMPLOYER_ID, vmObj.companyBankDetails, vmObj.company.PensionDisbursements, vmObj.company.HMRCDisbursement).then(() => {

			// Success state > In case there are incomplete team members
			if (vmObj.companyBankDetails.BACSEnabled) {

				loadIncompleteTeamMembers(vmObj).then(() => {
					formObj.state = 'saved';
					setPageState(PAGE_STATES.saved);
				});
			}

			// Close form
			else {
				growl.success('Company BACS details updated');
				$scope.formOptions.closeForm();
				formObj.state = 'saved';
			}

			// Update company
			$rootScope.$broadcast('set-current-company', AGENCY_PROFILE_ID, function () {
				$scope.formOptions.forceCallback();
			});
		})
		.catch(onError);

		formObj.state = 'saving';
	}

	init();

	angular.extend($scope, {
		BANK_FILE_FORMATS,
		BANK_IDS,
		PAGE_STATES,
		PAY_PERIOD_TYPES,

		AGENCY_PROFILE_ID,

		isSunNumberApplicable,
		isSunNumberRequired,
		openPaymentDetailsForm,
		openEmployeeDetailsReportModal,
		reviewCompanyBACSDetails,
		selectBankFileUpdate,
		setBacsIncludedPayments,
		setPageState,
		updateCompanyBACSDetails,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAddBacsDisbursementForm', function () {

	return {
		controller: 'companySettingsAddBacsDisbursementFormCtrl',
		templateUrl: 'forms/admin/companySettings/bacs-disbursements/addBacsDisbursementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAddBacsDisbursementFormCtrl', [
	'$q',
	'$scope',
	'adjustmentsService',
	'base',
	'config',
	'payrollData',
	function (
		$q,
		$scope,
		adjustmentsService,
		base,
		config,
		payrollData
	) {

	const IS_PREVIOUS_PERIOD = false;

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const disbursementId = $scope.formOptions.disbursementId;

	const context = angular.isDefined(disbursementId) ? 'update' : 'create';

	function init () {

		setPageState('loading');

		const getAgencyAdjustmentGroupCombinedForDisbursements = context === 'update' ? 
			payrollData.getAgencyAdjustmentGroupCombinedForDisbursement(agencyProfileId, disbursementId) : 
			payrollData.getAgencyAdjustmentGroupCombinedForDisbursements(agencyProfileId);

		const getAgencyAdjustmentLabels = payrollData.getAgencyAdjustmentLabels(agencyProfileId);
		const getDisbursements = context === 'update' ? base.getDisbursements(agencyProfileId, disbursementId) : null;
		const getEmptyDisbursement = context === 'create' ? base.getEmptyDisbursement() : null;
		const getEmptyUserPayElementDetail = payrollData.getEmptyUserPayElementDetail(agencyProfileId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD);

		$q.all([
			getAgencyAdjustmentGroupCombinedForDisbursements,
			getAgencyAdjustmentLabels,
			getDisbursements,
			getEmptyDisbursement,
			getEmptyUserPayElementDetail,
			getPayPeriodMinimum
		]).then(([
			adjustmentGroupsObj,
			adjustmentLabelsArr,
			disbursementsArr,
			emptyDisbursementObj,
			emptyUserPayElementDetailObj,
			payPeriodObj
		]) => {

			let companyAdjustmentTypesArr = adjustmentsService.getAdjustmentTypesForCompany(adjustmentGroupsObj, companyObj);

			const disbursementObj = disbursementsArr && disbursementsArr.length ? disbursementsArr[0] : emptyDisbursementObj;

			let vmObj = {
				agencyProfileId: agencyProfileId,
				changeCreatorVm: adjustmentsService.getChangeCreatorVm({
					CAN_MANAGE_TEAM_MEMBERS: false,
					IS_ADJUSTMENT_AMOUNT_APPLICABLE: false,
					IS_ADJUSTMENT_PREVIEW_ENABLED: false,
					IS_APPLICABLE_TO_TEAM_MEMBERS: false,
					IS_PAYSLIP_LABEL_ENABLED: false,
					IS_RECURRING_ENABLED: false,
					IS_TAX_TREATMENT_ENABLED: false,
					CAN_EDIT_ADJUSTMENT: context === 'create', 
					PAY_ELEMENT_LABEL: 'Deduction',
					PAY_ELEMENT_LABEL_PLACEHOLDER: 'Search for a deduction',
					adjustmentLabels: adjustmentsService.decorateLabelsWithAdjustmentTypes(adjustmentLabelsArr, companyAdjustmentTypesArr),
					adjustmentTypes: companyAdjustmentTypesArr,
					adjustmentTypesOriginal: angular.copy(companyAdjustmentTypesArr),
					newAdjustment: angular.copy(adjustmentsService.decorateNewAdjustmentObj(emptyUserPayElementDetailObj)),
					selectedAdjustmentTypeName: disbursementObj.Description !== '' ? disbursementObj.Description : null,
					selectedPayPeriodId: payPeriodObj.PayPeriodID,
				}),
				context: context,
				disbursement: angular.copy(disbursementObj),
				payPeriod: payPeriodObj
			};

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateDisbursement (vmObj, formObj) {

		formObj.state = 'saving';

		vmObj.disbursement.Description = vmObj.changeCreatorVm.newAdjustment.adjustmentType.AgencyAdjustmentGroupEntryText;
		vmObj.changeCreatorVm.newAdjustment.adjustmentType.DisbursementID = vmObj.disbursement.DisbursementID;

		const updateAgencyAdjustmentGroupEntry = payrollData.updateAgencyAdjustmentGroupEntryForDisbursements(vmObj.changeCreatorVm.newAdjustment.adjustmentType);
		const updateDisbursement = base.updateDisbursement(agencyProfileId, vmObj.disbursement);

		$q.all([
			updateAgencyAdjustmentGroupEntry,
			updateDisbursement
		]).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(error => {
			setPageState('error');
			formObj.state = null;
			console.error(error);
		});
	}

	angular.extend($scope, {
		setPageState,
		updateDisbursement
	});

	init();
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsDeleteBacsDisbursementForm', function () {

	return {
		controller: 'companySettingsDeleteBacsDisbursementFormCtrl',
		templateUrl: 'forms/admin/companySettings/bacs-disbursements/deleteBacsDisbursementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsDeleteBacsDisbursementFormCtrl', ['$scope', 'base', function ($scope, base) {

	const disbursementObj = $scope.formOptions.disbursement;

	function deleteDisbursement (disbursementObj, formObj) {

		setPageState('loading');

		formObj.state = 'saving';

		base.deleteDisbursement(disbursementObj.DisbursementID).then(() => {

			$scope.formOptions.forceCallback();

			setPageState('deleted');

			formObj.state = 'saved';
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	angular.extend($scope, {
		deleteDisbursement,
		disbursement: disbursementObj,
		pageState: 'ready'
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsBasicForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsBasicFormCtrl',
	templateUrl: 'forms/admin/companySettings/basic/company-settings-basic.form.html'
})

	.controller('companySettingsBasicFormCtrl', [
	'$q',
	'$rootScope',
	'companyData',
	'customerCodeService',
	'dataImportData',
	'config',
	'growl',
	'base',
	'INTERFACE_TYPES',
	function (
		$q,
		$rootScope,
		companyData,
		customerCodeService,
		dataImportData,
		config,
		growl,
		base,
		INTERFACE_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed($ctrl.formOptions.agencyProfileId);
		const getIndustrySectors = companyData.getIndustrySectors();
		const getAgencyCustomerCodeEnabledState = companyData.getAgencyCustomerCodeEnabledState($ctrl.formOptions.agencyProfileId);

		$q.all([getAgencyProfileCompanyInformationDetailed, getIndustrySectors, getAgencyCustomerCodeEnabledState]).then(([companyObj, industrySectors, isCustomerCodeEnabled]) => {

			if (companyObj.IndustrySectorID === config.guidEmpty) {
				companyObj.IndustrySectorID = null;
			}

			angular.extend($ctrl, {
				company: companyObj,
				industrySectors: industrySectors,
				isCustomerCodeLocked: companyObj.CustomerCode && companyObj.IsEvoEnabled,
				companyIsPayrollOrBureau: companyObj.CompanyType !== INTERFACE_TYPES.group,
				customerCodeEnabled: isCustomerCodeEnabled,
				originalCompanyName: companyObj.CompanyName
			});

			formatIndustrySectorDescription(companyObj.IndustrySectorID);

			// If it's a group do checks for Evo features
			if (companyObj.CompanyType === INTERFACE_TYPES.group) {
				return checkGroupSettings();
			}

			setPageState('ready');
			return $q.resolve();

		}).catch(onError);
	}

	function checkGroupSettings() {
		return checkLinkedOrganisation()
			.then(() => {
				if ($ctrl.bureauAgencyProfileId) {
					return base.isFeatureEnabled($ctrl.bureauAgencyProfileId, 'GROUP_CREATION_ENABLED');
				}

				return $q.resolve(false);
			})
			.then(isFeatureEnabled => {
				$ctrl.IsGroupCreationFeatureEnabled = isFeatureEnabled;

				// Load organizations for dropdown if feature is enabled and the group it's not already linked
				if ($ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation) {
					// Check if companies in the group have the same customer code
					return checkGroupCompaniesCustomerCodes($ctrl.formOptions.agencyProfileId)
						.then(customerCodeCheckResult => {
							$ctrl.haveCommonCustomerCode = customerCodeCheckResult.haveCommonCustomerCode;
							$ctrl.groupCompaniesCustomerCode = customerCodeCheckResult.commonCustomerCode;
							const companiesInGroup = customerCodeCheckResult.companies && customerCodeCheckResult.companies.length > 0;

							// Fetch all organizations
							return companyData.fetchOrganizations($ctrl.bureauAgencyProfileId).then((response) => {
								$ctrl.allOrganizations = [...response];

								if ($ctrl.haveCommonCustomerCode) {
									if (!companiesInGroup) {
										// If there are no companies in group show all organisations
										$ctrl.organizations = [...$ctrl.allOrganizations];
										return;
									} else {
										// Filter by customer code and get the matching organisation by customer code
										return filterOrganizationsByCustomerCode($ctrl.allOrganizations, $ctrl.groupCompaniesCustomerCode)
											.then(filteredOrgs => {
												$ctrl.organizations = [...filteredOrgs];
											});
									}
								} else {
									$ctrl.organizations = [];
								}
							});
						});
				}

				return $q.resolve();
			})
			.then(() => {
				setPageState('ready');
			})
			.catch((error) => {
				console.error(error);
				$ctrl.IsGroupCreationFeatureEnabled = false;
				setPageState('ready');
			});
	}


	function getValidCompanies(companies, INTERFACE_TYPES) {
		return companies.filter(company => {
			const validCompany = company.Company;
			return validCompany &&
				validCompany.AgencyProfileID &&
				validCompany.CompanyType === INTERFACE_TYPES.actualonly;
		});
	}

	function fetchCompanyCustomerCode(companyData, agencyProfileId, companyName) {
		return companyData.getCustomerCodeByAgencyProfileId(agencyProfileId)
			.then(customerCode => ({
				agencyProfileId,
				name: companyName,
				customerCode: customerCode || ''
			}))
			.catch(() => ({
				agencyProfileId,
				name: companyName,
				customerCode: ''
			}));
	}

	function allCompaniesHaveSameCustomerCode(companiesWithCodes) {
		if (companiesWithCodes.length === 0) {
			return {
				haveCommonCustomerCode: true,
				commonCustomerCode: ''
			};
		}

		const firstCode = companiesWithCodes[0].customerCode;
		const sameCustomerCode = companiesWithCodes.every(c => c.customerCode === firstCode);
		return {
			haveCommonCustomerCode: sameCustomerCode,
			commonCustomerCode: firstCode
		};
	}

	function checkGroupCompaniesCustomerCodes(agencyProfileId) {
		// Get all companies in the group
		return companyData.getAgencyProfileAgencyProfilesForParent(
			$rootScope.currentUser.UserResponseUserID,
			agencyProfileId
		)
		.then(companies => {
			if (!companies || companies.length === 0) {
				return {
					haveCommonCustomerCode: true,
					commonCustomerCode: ''
				};
			}

			const validCompanies = getValidCompanies(companies, INTERFACE_TYPES);
			if (validCompanies.length === 0) {
				return {
					haveCommonCustomerCode: true,
					commonCustomerCode: ''
				};
			}

			const customerCodePromises = validCompanies.map(company => {
				const filteredCompanyData = company.Company;
				return fetchCompanyCustomerCode(
					companyData,
					filteredCompanyData.AgencyProfileID,
					filteredCompanyData.Name
				);
			});

			if (customerCodePromises.length === 0) {
				return {
					haveCommonCustomerCode: true,
					commonCustomerCode: ''
				};
			}

			return $q.all(customerCodePromises)
				.then(companiesWithCodes => {
					const result = allCompaniesHaveSameCustomerCode(companiesWithCodes);
					return {
						haveCommonCustomerCode: result.haveCommonCustomerCode,
						commonCustomerCode: result.commonCustomerCode,
						companies: companiesWithCodes
					};
				})
				.catch(error => {
					console.error(error);
					return {
						haveCommonCustomerCode: false,
						commonCustomerCode: '',
						companies: [] };
				});
		})
		.catch(error => {
			console.error('Error getting companies for group:', error);
			return {
				haveCommonCustomerCode: false,
				commonCustomerCode: '',
				companies: []
			};
		});
	}

	function fetchOrganizationCustomerCode(companyData, org) {
		if (!org || !org.OrganisationID) {
			return Promise.resolve(null);
		}

		return companyData.getOrganisationCustomerCode(org.OrganisationID)
			.then(customerCode => ({
				OrganisationID: org.OrganisationID,
				OrganisationName: org.OrganisationName,
				customerCode: customerCode || ''
			}))
			.catch(() => ({
				OrganisationID: org.OrganisationID,
				OrganisationName: org.OrganisationName,
				customerCode: ''
			}));
	}

	function filterOrganizationsByCustomerCode(organizations, targetCustomerCode) {
		if (!organizations || organizations.length === 0 || !targetCustomerCode) {
			return $q.resolve([]);
		}

		const orgCustomerCodePromises = organizations.map(org => fetchOrganizationCustomerCode(companyData, org));

		return $q.all(orgCustomerCodePromises)
			.then(orgsWithCodes => {
				// Get the matching organisation by customer code
				const match = orgsWithCodes.find(org => org && org.customerCode === targetCustomerCode);
				return match ? [match] : [];
			})
			.catch(error => {
				console.error('Error in filtering orgs and customer codes:', error);
				return [];
			});
	}

	function verifyCustomerCode(companyObj) {

		if (!companyObj.CustomerCode) {
			return;
		}

		$ctrl.verificationState = 'verifying';

		return customerCodeService.verifyCustomerCode(companyObj.CustomerCode, $ctrl.formOptions.agencyProfileId)
			.then(function (result) {
				$ctrl.verificationState = result.status;
				if (result.data) {
					$ctrl.company.customerCodeCompanyName = result.data;
				}
			});
	}
	function resetVerificationState () {
		$ctrl.verificationState = null;
	}

	function onError (error) {
		setPageState(error);
		console.error(error);
	}

	function saveCompanyBasicDetails ($ctrl, $form) {

		$form.state = 'saving';

		if ($ctrl.company.IndustrySectorID === '' || $ctrl.company.IndustrySectorID === null) {
			$ctrl.company.IndustrySectorID = config.guidEmpty;
		}

		companyData.updateCompanyInformationBasic($ctrl.company)
			.then(() => {
				// Handle group with Evo feature flag enabled
				if (!$ctrl.companyIsPayrollOrBureau && $ctrl.IsGroupCreationFeatureEnabled) {
					// If linked to organisation, check if name changed before editing the group name
					if ($ctrl.isLinkedToOrganisation) {
						// Only edit it if the company name has changed
						if ($ctrl.company.CompanyName !== $ctrl.originalCompanyName) {
							return dataImportData.editGroupName($ctrl.formOptions.agencyProfileId, $ctrl.company.CompanyName)
							.then(() => {
								$ctrl.formOptions.forceCallback();
								$form.state = 'saved';
								setPageState('success');
								growl.success(`Group information has been saved`);
							})
							.catch((error) => {
								setPageState('error');
								console.error(error);
							});
						} else {
							// Name hasn't changed - complete the operation
							$ctrl.formOptions.forceCallback();
							$form.state = 'saved';
							setPageState('success');
							growl.success(`Group information has been saved`);
							return $q.resolve();
						}
					}
					
					// If not linked but Evo features enabled and organization selected
					if (!$ctrl.isLinkedToOrganisation && 
						$ctrl.companyGroup.enableEvoFeatures &&
						$ctrl.selectedOrganization) {
						// If an Evo organization has been selected get the linked companies and update the existing group
						return getLinkedCompaniesAndUpdate($ctrl.selectedOrganization, $ctrl.formOptions.agencyProfileId)
						.then(() => {
							$ctrl.formOptions.forceCallback();
							$form.state = 'saved';
							setPageState('success');
							growl.success(`Group information has been saved`);
						});
					}
				}
				return $q.resolve();
			})
			.then(() => {
				$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId, () => {
					$ctrl.formOptions.forceCallback();
					$ctrl.formOptions.closeForm();
				});

				growl.success(`${$ctrl.companyIsPayrollOrBureau ? 'Basic' : 'Group'} information has been saved`);

				$form.state = 'saved';
			})
			.catch(onError);
	}

	function formatIndustrySectorDescription (sectorID) {

		const sector = $ctrl.industrySectors.find(s => s.IndustrySectorID === sectorID);

		if (!sector || !sector.CategoryDescription) {
			$ctrl.industrySectorDescription = [];
			return;
		}

		// Split, trim, and filter the description parts
		$ctrl.industrySectorDescription = sector.CategoryDescription.split('•')
			.map(function(item) { return item.trim(); })
			.filter(function(item) { return item.length > 0; });
	}

	function getLinkedCompaniesAndUpdate(organisationId, agencyProfileId) {
		return companyData.getLinkedCompanies(organisationId)
			.then((linkedCompanies) => {
				// Add the companies from the org to the group
				return companyData.updateAgencyProfileAgencyProfiles(
					linkedCompanies,
					agencyProfileId,
					false
				)
				.then(() => {
					// Edit the existing group and link it with the selected organisation
					return dataImportData.editGroupCompany(
						$ctrl.company.CompanyName,
						agencyProfileId,
						organisationId,
						config.guidEmpty,
						$ctrl.bureauAgencyProfileId
					);
				});
			});
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function setupSelectedOrganization(option) {
		$ctrl.selectedOrganization = option;
	}

	function getSelectedOrganizationName(organizationId) {
		if (!organizationId || !$ctrl.organizations || $ctrl.organizations.length === 0) {
			return '';
		}

		const selectedOrganisation = $ctrl.organizations.find(org => org.OrganisationID === organizationId);
		return selectedOrganisation ? selectedOrganisation.OrganisationName : '';
	}

	function checkLinkedOrganisation() {
		if ($ctrl.formOptions.agencyProfileId) {
			return dataImportData.getLinkedOrganisationToGroupCompany($ctrl.formOptions.agencyProfileId)
				.then(organisationId => {
					$ctrl.linkedOrganisationId = organisationId;
					$ctrl.isLinkedToOrganisation = organisationId && organisationId !== config.guidEmpty;

					// Get bureau agencyProfileId
					return dataImportData.getLinkedBureauAgencyProfileIdByGroupId($ctrl.formOptions.agencyProfileId);
				})
				.then(bureauAgencyProfileId => {
					if ((!bureauAgencyProfileId || bureauAgencyProfileId === config.guidEmpty) && !$ctrl.isLinkedToOrganisation)
					{
						if ($rootScope.companies && $rootScope.companies.length > 1) {
							bureauAgencyProfileId = $rootScope.companies[1].AgencyProfileID;
						}
					}

					$ctrl.bureauAgencyProfileId = bureauAgencyProfileId;

					// Get organization name if it's linked
					if ($ctrl.isLinkedToOrganisation && $ctrl.bureauAgencyProfileId) {
						return companyData.fetchOrganizations($ctrl.bureauAgencyProfileId).then((response) => {
							$ctrl.organizations = [...response];

							const linkedOrg = $ctrl.organizations.find(org => org.OrganisationID === $ctrl.linkedOrganisationId);
							$ctrl.linkedOrganisationName = linkedOrg ? linkedOrg.OrganisationName : 'Unknown Organisation';
						});
					}

					return $q.resolve();
				})
				.catch((error) => {
					console.error(error);
					return $q.reject(error);
				});
		}

		return $q.resolve();
	}

	angular.extend($ctrl, {
		$onInit,
		saveCompanyBasicDetails,
		formatIndustrySectorDescription,
		setupSelectedOrganization,
		getSelectedOrganizationName,
		organizations: [],
		allOrganizations: [],
		selectedOrganization: null,
		companyGroup: {
			enableEvoFeatures: false,
			confirmCorrectOrganization: false
		},
		isLinkedToOrganisation: false,
		IsGroupCreationFeatureEnabled: false,
		bureauAgencyProfileId: null,
		haveCommonCustomerCode: false,
		groupCompaniesCustomerCode: '',
		verifyCustomerCode,
		resetVerificationState,

		INTERFACE_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsBikForm', function () {

	return {
		controller: 'companySettingsBikFormCtrl',
		templateUrl: 'forms/admin/companySettings/bik/companySettingsBikForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsBikFormCtrl', ['$scope', 'companyData', 'stateService',	function ($scope, companyData, stateService) {

	const AGENCY_PROFILE_ID	= $scope.formOptions.agencyProfileId;
	const company = $scope.formOptions.company;

	const PAGE_STATES = {
		ready: 'ready',
		saved: 'saved',
		error: 'error'
	};

	function init () {

		$scope.vm = {
			agencyEmployerPayrollBIK: $scope.formOptions.bikSettings.agencyEmployerPayrollBIK,
			agencyEmployerPayrollBIKRegistrationDateISO: $scope.formOptions.bikSettings.agencyEmployerPayrollBIKRegistrationDateISO,
			company
		};

		setPageState(PAGE_STATES.ready);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateCompanyBIKSettings (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyEmployerPayrollBIK(AGENCY_PROFILE_ID, vmObj.agencyEmployerPayrollBIK, vmObj.agencyEmployerPayrollBIKRegistrationDateISO).then(() => {

			stateService.setCompany(AGENCY_PROFILE_ID).then(() => {
				
				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();

				formObj.state = 'saved';
			});
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,
		updateCompanyBIKSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsCalculationMethodForm', function () {

	return {
		controller: 'companySettingsCalculationMethodFormCtrl',
		templateUrl: 'forms/admin/companySettings/calculation-method/companySettingsCalculationMethodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsCalculationMethodFormCtrl', [
	'$q',
	'$scope',
	'companyData',
	'growl',
	'onboardingService',
	'payrollData',
	'CALCULATION_METHODS',
function (
	$q,
	$scope,
	companyData,
	growl,
	onboardingService,
	payrollData,
	CALCULATION_METHODS
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const questionGroupObj = $scope.formOptions.questionGroup;
	const company = $scope.formOptions.company;

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	setPageState('ready');

	function saveCalculationMethod (companyObj, form) {

		const updateCompanyWorkplacePatterns = payrollData.updateCompanyWorkplacePatterns(agencyProfileId,
																						  companyObj.WorkHoursPerWeek,
																						  companyObj.DayRateCalculationMethod,
																						  companyObj.MaximumWorkingDaysInMonth,
																						  companyObj.CalculatePatternOnYearlyBasis,
																						  companyObj.WorkWeeksPerYear);
		let updateOnboardingQuestions = null;

		if (questionGroupObj !== undefined) {

			var updatedQuestionsArray = onboardingService.setQuestionsCompleteForPayrollQuestionKeys(questionGroupObj.Questions, ['dayRateCalculationMethod']);

			updateOnboardingQuestions = companyData.updateOnboardingQuestions(updatedQuestionsArray);
		}
		form.state = 'saving';

		$q.all([updateCompanyWorkplacePatterns, updateOnboardingQuestions]).then(function () {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success('Work hours have been saved');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			form.state = null;
		});
	}

	angular.extend($scope, {

		// Constants
		CALCULATION_METHODS,
		defaultCalculationMethod: CALCULATION_METHODS.find(calculationMethodObj => calculationMethodObj.isDefault).description,
		company,

		// Functions
		saveCalculationMethod
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsCalculationSettingsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsCalculationSettingsFormCtrl',
	templateUrl: 'forms/admin/companySettings/calculation-settings/company-settings-calculation-settings.form.html'
})

.controller('companySettingsCalculationSettingsFormCtrl', [
	'companyData',
	'growl',
	function (
		companyData,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		companyData.getAgencyEmployerNetPayCalculationDetails($ctrl.formOptions.agencyProfileId)
			.then(calculationDetailsObj => {

				angular.extend($ctrl, {
					calculationDetail: calculationDetailsObj
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function updateAgencyEmployerNetPayCalculationDetails ($form) {

		$form.state = 'saving';

		companyData.updateAgencyEmployerNetPayCalculationDetails($ctrl.formOptions.agencyProfileId, $ctrl.calculationDetail)
			.then(() => {
				growl.success('Calculation settings saved');
				$form.state = 'saved';
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		updateAgencyEmployerNetPayCalculationDetails,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsCeasePayeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsCeasePayeFormCtrl',
	templateUrl: 'forms/admin/companySettings/cease-paye/company-settings-cease-paye.form.html'
})

.controller('companySettingsCeasePayeFormCtrl', [
	'$rootScope',
	'companyData',
	'payrollData',
	function (
		$rootScope,
		companyData,
		payrollData
	) {

	const $ctrl = this;

	const PAGE_STATES = {
		companyIsCISOnly: 'cis-only-company',
		companyIsPensionOnly: 'pension-only-company',
		error: 'error',
		incorrectPayrollType: 'incorrect-payroll-type',
		llpCompany: 'llp-company',
		multiplePayrollCompany: 'multiple-payroll-company',
		alreadyCeased: 'already-ceased',
		ready: 'ready'
	};

	const CEASE_STEPS = {
		ceased: 'ceased',
		closeDate: 'close-date',
		confirm: 'confirm',
		intro: 'intro',
		loading: 'loading',
		reOpened: 're-opened'
	};

	function $onInit () {

		// Unable to cease PAYE scheme
		if ($ctrl.formOptions.company.PensionOnly) {
			setPageState(PAGE_STATES.companyIsPensionOnly);
			return;
		}

		// Unable to cease PAYE scheme
		if ($ctrl.formOptions.company.CISOnly) {
			setPageState(PAGE_STATES.companyIsCISOnly);
			return;
		}

		payrollData.getPayPeriodCurrent($ctrl.formOptions.agencyProfileId)
			.then(payPeriodObj => {

				angular.extend($ctrl, {
					activeStep: $ctrl.formOptions.company.PAYECeaseDateISO ? CEASE_STEPS.ceased : CEASE_STEPS.intro,
					ceasePayeDate: $ctrl.formOptions.company.PAYECeaseDateISO,
					ceasePayeDateMax: new moment().add(2, 'year').toISOString(),
					ceasePayeDateMin: $ctrl.formOptions.company.EarliestPAYECeaseDateISO,
					currentPeriod: payPeriodObj,
				});

				setPageState(PAGE_STATES.ready);
			})
			.catch(onError);
	}

	function cancelCeasePAYEScheme () {

		setActiveStep(CEASE_STEPS.loading);

		const deleteCessationDetails = true;

		companyData.updateAgencyProfileCeasePAYEScheme($ctrl.formOptions.agencyProfileId, '', deleteCessationDetails)
			.then(() => {

				$ctrl.formOptions.callback();

				setActiveStep(CEASE_STEPS.reOpened);

				$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId);
			})
			.catch(onError);
	}

	function getWarningPageStateFromResponse (response) {

		switch (response) {

			// Incorrect payroll type (ActualOnly || Agency || Pension only || CIS only)
			case -2:
				return PAGE_STATES.incorrectPayrollType;

			// Multiple payrolls linked to company
			case -3:
				return PAGE_STATES.multiplePayrollCompany;

			// LLP
			case -4:
				return PAGE_STATES.llpCompany;
			// Company has already ceased PAYE scheme
			case -5:
				return PAGE_STATES.alreadyCeased;

		}
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function onCeasePayeDateChange () {
		$ctrl.isCeasePayeDateInCurrentPeriodOrFuture = moment($ctrl.ceasePayeDate).isAfter($ctrl.currentPeriod.StartDateISO);
	}

	function setActiveStep (activeStep) {
		$ctrl.activeStep = activeStep;
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateAgencyProfileCeasePAYEScheme ($form) {

		const deleteCessationDetails = false;

		$form.state = 'saving';

		companyData.updateAgencyProfileCeasePAYEScheme($ctrl.formOptions.agencyProfileId, $ctrl.ceasePayeDate, deleteCessationDetails)
			.then(response => {

				$form.state = 'saved';

				const warningFormState = getWarningPageStateFromResponse(response);

				if (warningFormState) {
					setPageState(warningFormState);
					return;
				}
				else {
					setActiveStep(CEASE_STEPS.ceased);
					$ctrl.formOptions.callback();
				}

				$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId);
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		cancelCeasePAYEScheme,
		onCeasePayeDateChange,
		setActiveStep,
		updateAgencyProfileCeasePAYEScheme,

		CEASE_STEPS,
		PAGE_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsCurrenciesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsCurrenciesFormCtrl',
	templateUrl: 'forms/admin/companySettings/currencies/company-settings-currencies.form.html'
})

.controller('companySettingsCurrenciesFormCtrl', [
	'$q',
	'$timeout',
	'companyData',
	'config',
	'growl',
	function (
		$q,
		$timeout,
		companyData,
		config,
		growl
	) {

	const $ctrl = this;

	const FORM_STATES = {
		editCurrencies: 'edit-currencies',
		error: 'error',
		exchangeRates: 'exchange-rates',
		loading: 'loading',
		noCurrenciesSetup: 'no-currencies-setup'
	};

	function $onInit () {

		setPageState(FORM_STATES.loading);

		const getCurrencies = companyData.getCurrencies($ctrl.formOptions.agencyProfileId);
		const getEmptyCurrency = !$ctrl.formOptions.isEditMode ? companyData.getEmptyCurrency($ctrl.formOptions.agencyProfileId) : null;

		$q.all([
				getCurrencies,
				getEmptyCurrency
			])
				.then(([
					currenciesArr,
					emptyCurrency
				]) => {

					angular.extend($ctrl, {
						currencies: currenciesArr,
						emptyCurrency: emptyCurrency
					});

					if (!$ctrl.formOptions.isEditMode && currenciesArr.length === 0) {
						onAddCurrency($ctrl);
					}

					const initialPageState = getInitialPageState();
					setPageState(initialPageState);
				})
				.catch(onError);
	}

	function getInitialPageState () {

		if ($ctrl.formOptions.isEditMode) {
			if ($ctrl.currencies.length === 0) {
				return FORM_STATES.noCurrenciesSetup;
			}
			else {
				return FORM_STATES.exchangeRates;
			}
		}

		return FORM_STATES.editCurrencies;
	}

	function onAddCurrency () {
		$ctrl.currencies.push(angular.copy($ctrl.emptyCurrency));
	}

	function onCurrencyDelete ($form, $index, currencyObj) {

		if (currencyObj.CurrencyID === config.guidEmpty) {
			$ctrl.currencies.splice($index, 1);
			return;
		}

		$form.state = 'saving';

		companyData.deleteCurrency($ctrl.formOptions.agencyProfileId, currencyObj.CurrencyID)
			.then(() => {

				$form.state = 'saved';

				$ctrl.currencies.splice($index, 1);

				$ctrl.formOptions.initCallbackOnClose = true;

				$timeout(() => {
					$form.state = null;
				}, 2000);
			})
			.catch(onError);
	}

	function onCurrencyLabelChange (currentCurrencyObj, $field) {

		// Currency names should be unique
		const numberOfCurrenciesWithSameLabel = $ctrl.currencies.filter(currencyObj => currencyObj.CurrencyLabel !== '' && currencyObj.CurrencyLabel === currentCurrencyObj.CurrencyLabel).length;

		$field.$setValidity('nonUnique', numberOfCurrenciesWithSameLabel === 1);
	}

	function onError (error) {
		setPageState(FORM_STATES.error);
		console.error(error);
	}

	function updateAgencyPayPeriodCurrencyCheck ($form) {

		$form.state = 'saving';

		companyData.updateAgencyPayPeriodCurrencyCheck($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyPayPeriodId, false)
			.then(() => {
				growl.success(`Exchange rates confirmed`);
				$form.state = 'saved';
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function updateCurrencies ($form) {

		$form.state = 'saving';

		const updateCurrencies = companyData.updateCurrencies($ctrl.formOptions.agencyProfileId, $ctrl.currencies);

		// Confirm currency check if currencies have been updates
		const updateAgencyPayPeriodCurrencyCheck = $ctrl.formOptions.isEditMode ? companyData.updateAgencyPayPeriodCurrencyCheck($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyPayPeriodId, false) : null;

		$q.all([
				updateCurrencies,
				updateAgencyPayPeriodCurrencyCheck
			])
				.then(() => {
					growl.success($ctrl.formOptions.isEditMode ? 'Exchange rates saved and confirmed' : 'Exchange rates saved');
					$form.state = 'saved';
					$ctrl.formOptions.forceCallback();
					$ctrl.formOptions.closeForm();
				})
				.catch(onError);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		onAddCurrency,
		onCurrencyDelete,
		onCurrencyLabelChange,
		setPageState,
		updateAgencyPayPeriodCurrencyCheck,
		updateCurrencies,

		FORM_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('companySettingsCustomerCodesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsCustomerCodesFormCtrl',
	templateUrl: 'forms/admin/companySettings/customer-codes/company-settings-customer-codes.form.html'
})
.controller('companySettingsCustomerCodesFormCtrl',[
	'$scope',
	'companyData',
	'customerCodeService',
	'searchService',
	function (
		$scope,
		companyData,
		customerCodeService,
		searchService
	) {

		const $ctrl = this;

		const FORM_STATES = {
			error: 'error',
			loading: 'loading',
			ready: 'ready',
			saved: 'saved'
		};

		const CONTEXT_TYPE = {
			single: 'single',
			bulk: 'bulk'
		};

		const VERIFICATION_STATES = {
			verifying: 'verifying',
			valid: 'valid',
			invalid: 'invalid',
			verified: 'verified',
			needsValidation: 'needsValidation'
		};

		function $onInit() {

			setFormState(FORM_STATES.loading);

			const customerCode = $ctrl.formOptions.customerCode;
			const customerCodes = $ctrl.formOptions.customerCodes;

			if (customerCode !== null) {
				setContentType(CONTEXT_TYPE.single);
				angular.extend($ctrl, {
					customerCode
				});

			} else if (customerCodes.all.length > 0) {

				setContentType(CONTEXT_TYPE.bulk);

				angular.extend($ctrl, {
					customerCodes,
					searchBarOptions: searchService.customerCodesForm,
				});
			}

			setFormState(FORM_STATES.ready);
		}

		function onSubmit() {

			if ($ctrl.contentType === CONTEXT_TYPE.single) {
				updateCustomerCode($ctrl.customerCode);
			} else {
				updateCustomerCodes($ctrl.customerCodes.all);
			}
		}

		function updateCustomerCode(customerCode) {

			setFormState(FORM_STATES.loading);

			companyData.updateAgencyCustomerCode($ctrl.formOptions.agencyProfileId, customerCode).then(() => {
				// Success
				refreshCards();
				setFormState(FORM_STATES.saved);
			}).catch(onError);
		}

		function updateCustomerCodes(customerCodes) {

			setFormState(FORM_STATES.loading);

			companyData.updateAgencyCustomerCodes($ctrl.formOptions.agencyProfileId, customerCodes).then(() => {
				// Success
				refreshCards();
				setFormState(FORM_STATES.saved);
			}).catch(onError);
		}

		function getLabel(customerCode) {
			return 'CustomerCode' + $ctrl.customerCodes.filtered.indexOf(customerCode);
		}

		function refreshCards() {

			$ctrl.formOptions.callback();
		}

		function onClose() {

			$ctrl.formOptions.closeForm();
		}

		function onError(error) {

			console.error(error);
			setFormState(FORM_STATES.error);
		}

		function setFormState(formState) {

			$ctrl.formState = formState;
		}

		function setContentType(contentType) {

			$ctrl.contentType = contentType;
		}

		function verifyCustomerCode(customerCode) {

			if (!customerCode.CustomerCode) {
				return false;
			}

			customerCode.verificationState = VERIFICATION_STATES.verifying;

			return customerCodeService.verifyCustomerCode(customerCode.CustomerCode, customerCode.AgencyProfileID)
				.then(function (result) {
					customerCode.verificationState = result.status;
					if (result.data) {
						customerCode.customerCodeCompanyName = result.data;
					}
				});
		}

		function resetVerificationState (customerCode) {
			customerCode.verificationState = VERIFICATION_STATES.needsValidation;
		}

		function isSubmitDisabled () {

			const formInvalid = $scope.editCustomerCodesForm && $scope.editCustomerCodesForm.$invalid;
			
			return formInvalid || false;
		}

		angular.extend($ctrl, {
			//Variables
			CONTEXT_TYPE,
			FORM_STATES,
			VERIFICATION_STATES,

			//Functions
			$onInit,
			getLabel,
			isSubmitDisabled,
			onClose,
			onSubmit,
			verifyCustomerCode,
			resetVerificationState,
		});
	}
]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsDirectorsNiForm', function () {

	return {
		controller: 'companySettingsDirectorsNiFormCtrl',
		templateUrl: 'forms/admin/companySettings/directors-ni/companySettingsDirectorsNIForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsDirectorsNiFormCtrl', ['$q', '$scope', 'companyData', 'onboardingService', 'tracking', 'COMPANY_STATES', 'TRACKING_EVENTS', function ($q, $scope, companyData, onboardingService, tracking, COMPANY_STATES, TRACKING_EVENTS) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var questionGroupObj = $scope.formOptions.questionGroup;

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(function (companyDetailedObj) {

			$scope.vm = {
				DirectorNIStandard: companyDetailedObj.Employer.DirectorsNIStandardMethod,
				directorNIStandardSkip: false
			};

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyEmployerDirectorNIStandard (vmObj, form) {

		form.state = 'saving';

		companyData.updateAgencyEmployerDirectorNIStandard(agencyProfileId, vmObj.DirectorNIStandard).then(function () {
			
			form.state = 'saved';

			// Onboarding only
			updateOnboardingQuestions(vmObj);
			
			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
                
				return;
			}

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(function (error) {
			console.error(error);
			form.state = null;
			setPageState('error');
		});		
	}

	function updateOnboardingQuestions (vmObj) {

		// Onboarding only
		if (questionGroupObj !== undefined) {

			var updatedQuestionsArray = [];
			
			updatedQuestionsArray.push(onboardingService.setQuestionValueForPayrollQuestionKey(questionGroupObj.Questions, 'directorsNiCalculationMethod', vmObj.DirectorNIStandard));
			
			companyData.updateOnboardingQuestions(updatedQuestionsArray).then(function () {
				tracking.trackEvent(TRACKING_EVENTS.onboardingPayrollCompleted);
			})
			.catch(function (error) {
				console.error(error);
			});
		}
	}

	init();

	$scope.COMPANY_STATES = COMPANY_STATES;

	$scope.updateAgencyEmployerDirectorNIStandard = function (vmObj, form) {
		updateAgencyEmployerDirectorNIStandard(vmObj, form);
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsEmailNotificationsForm', function () {

	return {
		controller: 'companySettingsEmailNotificationsFormCtrl',
		templateUrl: 'forms/admin/companySettings/email-notifications/companySettingsEmailNotificationsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsEmailNotificationsFormCtrl', ['$scope', 'mailData', function ($scope, mailData) {

	let agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {

		// Page state
		setPageState('loading');

		mailData.getCompanyEmailFrameworkOptions(agencyProfileId).then(companyEmailFrameworkOptions => {

			/* Determine selected framework option, also mark and add labels - the option which corresponds to the current company
			   is 'Custom'. Selecting the current company allows customisation of email settings for this company */
			let selectedFrameworkOption;
			companyEmailFrameworkOptions.forEach(frameworkOption => {
				if (frameworkOption.IsSelected) {
					selectedFrameworkOption = frameworkOption;
				}
				frameworkOption.isCustom = frameworkOption.FrameworkOwnerAgencyProfileID === agencyProfileId;
				frameworkOption.label = frameworkOption.isCustom ? 'Custom' : frameworkOption.FrameworkOwnerAgencyProfileName;
			});

			$scope.companyEmailFrameworkOptions = companyEmailFrameworkOptions;
			$scope.selectedFrameworkOption = selectedFrameworkOption;

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function companyEmailFrameworkChanged(companyEmailFramework) {

		$scope.selectedFrameworkOption = companyEmailFramework;
	}

	function saveEmailNotificationsSettings (form, selectedFrameworkOption) {

		form.state = 'saving';

		mailData.updateCompanyEmailFramework(agencyProfileId, selectedFrameworkOption).then(() => {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			setPageState('success');
		})
		.catch(error => {
			console.error(error);
			form.state = 'error';
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		companyEmailFrameworkChanged,
		saveEmailNotificationsSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsEmployeePortalForm', function () {

	return {
		controller: 'companySettingsEmployeePortalFormCtrl',
		templateUrl: 'forms/admin/companySettings/employee-portal/companySettingsEmployeePortalForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsEmployeePortalFormCtrl', [
	'$scope',
	'companyData',
	'EMPLOYEE_PORTAL_PERMISSIONS_FLAGS',
	'EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS',
function (
	$scope,
	companyData,
	EMPLOYEE_PORTAL_PERMISSIONS_FLAGS,
	EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const permissionsGroup = $scope.formOptions.permissionsGroup;

	// This will be updated with changed permissions
	let permissionValue = $scope.formOptions.permissionValue;

	const PAGE_STATES = {
		ready: 'ready',
		error: 'error'
	};

	function getPermissionDetailBlocks (permissionsGroup) {

		/* Only detail blocks with a switchBit property are of interest; those correspond to actual permissions.
		   Some detail blocks are merely decorative (e.g. dividers). It's assumed there's just a single detail group
		   of interest in each case, as things are this is safe. */
		const permissionsDetailBlocksArr = permissionsGroup.detailGroups[0].details.filter(detail => angular.isDefined(detail.switchBit));

		// Arrange these so they're easily referenced in the template
		const permissionDetailBlocks = {};
		permissionsDetailBlocksArr.forEach(permissionDetailBlock => {
			// Add a unique ID for each based on the switch bit, for the form fields
			permissionDetailBlock.id = `id_${permissionDetailBlock.switchBit}`;
			// Add detail block as property to permissions block object
			permissionDetailBlocks[permissionDetailBlock.switchBit] = permissionDetailBlock;
		});

		return permissionDetailBlocks;
	}

	function init () {

		angular.extend($scope, {
			vm: {
				permissionsGroup: permissionsGroup,
				permissionsDetailBlocks: getPermissionDetailBlocks(permissionsGroup)
			}
		});
		setPageState(PAGE_STATES.ready);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleIsGenderVisible (vmObj) {

		vmObj.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender].value = !vmObj.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender].value;
	}

	function updateEmployeePortalSettings (vmObj, formObj) {

		formObj.state = 'saving';

		// Update permissionValue passed into this form with updated permissions
		Object.keys(vmObj.permissionsDetailBlocks).forEach(permissionsDetailBlockKey => {
			const permissionsDetailBlock = vmObj.permissionsDetailBlocks[permissionsDetailBlockKey];
			if (permissionsDetailBlock.value) {
				// Permission added
				permissionValue |= permissionsDetailBlock.switchBit;
			}
			else {
				// Permission removed
				permissionValue &= ~(permissionsDetailBlock.switchBit);
			}
		});

		companyData.updateAgencyProfileEmployeePortalPermissionValue(agencyProfileId, permissionValue).then(() => {
			formObj.state = null;
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,
		EMPLOYEE_PORTAL_PERMISSIONS_FLAGS,
		EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS,
		toggleIsGenderVisible,
		updateEmployeePortalSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsEmployerForm', function () {

	return {
		controller: 'companySettingsEmployerFormCtrl',
		templateUrl: 'forms/admin/companySettings/employer/companySettingsEmployerForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsEmployerFormCtrl', [
	'$q',
	'$scope',
	'config',
	'companyData',
	'companyService',
	'growl',
	'onboardingService',
	'COMPANY_STATES',
function (
	$q,
	$scope,
	config,
	companyData,
	companyService,
	growl,
	onboardingService,
	COMPANY_STATES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const questionGroupObj = $scope.formOptions.questionGroup;

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(function (companyDetailedObj) {

			// Skip functionality (only applies to companies Onboarding)
			companyDetailedObj.Employer.smallEmployerOriginal = angular.copy(companyDetailedObj.Employer.SmallEmployer);
			companyDetailedObj.Employer.smallEmployerSkip = false;

			companyDetailedObj.Employer.employmentAllowanceSkip = false;
			companyDetailedObj.Employer.employersAllowanceEligibleOriginal = angular.copy(companyDetailedObj.Employer.EmployersAllowanceEligible);
			companyDetailedObj.Employer.employersAllowanceUsedOriginal = angular.copy(companyDetailedObj.Employer.EmployersAllowanceUsed);
			companyDetailedObj.Employer.employersNIForEmployersAllowanceOriginal = angular.copy(companyDetailedObj.Employer.EmployersNIForEmployersAllowance);

			companyDetailedObj.Employer.apprenticeshipLevyOption = companyDetailedObj.Employer.HasApprenticeshipAllowanceSplit ? companyDetailedObj.Employer.ApprenticeshipLevyAmount > 0 ? 'custom' : 'none' : 'full';
			// Set YTD block active if anything's already been entered for PayPeriodGroupPayBillYTD or PayPeriodGroupAppLevyYTD
			companyDetailedObj.Employer.apprenticeshipLevyYTDActive = companyDetailedObj.Employer.PayPeriodGroupPayBillYTD + companyDetailedObj.Employer.PayPeriodGroupAppLevyYTD > 0;

			// Override PAYE credit flag to control UI elements
			companyDetailedObj.Employer.overrideOnboardingPAYECredit = false;

			// Keep original override PAYE settings for restoration if an edit is cancelled
			companyDetailedObj.Employer.originalHasOnboardingPAYECredit = companyDetailedObj.Employer.HasOnboardingPAYECredit;
			companyDetailedObj.Employer.originalOnboardingPAYECredit = companyDetailedObj.Employer.OnboardingPAYECredit;

			$scope.BUSINESS_SECTOR_OPTIONS = companyService.getBusinessSectorOptions();
			$scope.company = companyDetailedObj;

			if (companyDetailedObj.HasRunPayroll) {
				initWarningWatchers(companyDetailedObj);
			}

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleOverrideOnboardingPAYECredit (companyEmployerObj) {

		companyEmployerObj.overrideOnboardingPAYECredit = !companyEmployerObj.overrideOnboardingPAYECredit;

		// If cancelling edit, restore the original values.
		if (!companyEmployerObj.overrideOnboardingPAYECredit) {
			companyEmployerObj.HasOnboardingPAYECredit = companyEmployerObj.originalHasOnboardingPAYECredit;
			companyEmployerObj.OnboardingPAYECredit = companyEmployerObj.originalOnboardingPAYECredit;
		}
	}

	function initWarningWatchers (companyDetailedObj) {

		$scope.$watch('[company.Employer.EmployersAllowanceEligible, company.Employer.EmployersAllowanceUsed, company.Employer.EmployersNIForEmployersAllowance, company.Employer.SmallEmployer]', function (newValues) {

			const newEmployersAllowanceEligible = newValues[0];
			const newEmployersAllowanceUsed = newValues[1];
			const newEmployersNIForEmployersAllowance = newValues[2];
			const newSmallEmployer = newValues[3];

			$scope.showEmploymentAllowanceWarning = (companyDetailedObj.Employer.employersAllowanceEligibleOriginal !== newEmployersAllowanceEligible || (newEmployersAllowanceEligible && companyDetailedObj.Employer.employersAllowanceUsedOriginal !== newEmployersAllowanceUsed) || (newEmployersAllowanceEligible && companyDetailedObj.Employer.employersNIForEmployersAllowanceOriginal !== newEmployersNIForEmployersAllowance));
			$scope.showSmallEmployerWarning = (companyDetailedObj.Employer.smallEmployerOriginal !== newSmallEmployer);
		});
	}

	function changeApprenticeshipLevyOption (employerObj, apprenticeshipLevyOption) {

		switch (apprenticeshipLevyOption) {
			case 'full':
				employerObj.ApprenticeshipLevyAmount = config.apprenticeshipLevy;
				employerObj.HasApprenticeshipAllowanceSplit = false;
				break;
			case 'none':
				employerObj.ApprenticeshipLevyAmount = 0;
				employerObj.HasApprenticeshipAllowanceSplit = true;
				break;
			case 'custom':
				employerObj.ApprenticeshipLevyAmount = null;
				employerObj.HasApprenticeshipAllowanceSplit = true;
				break;
		}

		employerObj.apprenticeshipLevyOption = apprenticeshipLevyOption;
	}

	function toggleSkipSmallEmployer (employerObj) {

		employerObj.SmallEmployer = employerObj.smallEmployerOriginal;
	}

	function toggleSkipEmploymentAllowance (employerObj) {

		employerObj.EmployersAllowanceEligible = employerObj.employersAllowanceEligibleOriginal;
		employerObj.EmployersAllowanceUsed = employerObj.employersAllowanceUsedOriginal;
	}

	function updateAgencyEmployerStatusDetails (employerObj, form) {

		const updateAgencyEmployerReferences = companyData.updateAgencyEmployerStatusDetails(employerObj);
		let updateOnboardingQuestions = null;

		form.state = 'saving';

		// Onboarding only
		if (questionGroupObj !== undefined) {

			let skippedQuestionKeys = [];
			let completedQuestionKeys = [];

			// Small Employer
			if (employerObj.smallEmployerSkip) {
				skippedQuestionKeys.push('smallEmployer');
			}
			else {
				completedQuestionKeys.push('smallEmployer');
			}

			// Employment Allowance
			if (employerObj.employmentAllowanceSkip) {
				skippedQuestionKeys.push('employmentAllowance');
			}
			else {
				completedQuestionKeys.push('employmentAllowance');
			}

			const completedQuestionsArray = onboardingService.setQuestionsCompleteForPayrollQuestionKeys(questionGroupObj.Questions, completedQuestionKeys);
			const skippedQuestionsArray = onboardingService.setQuestionsSkippedForPayrollQuestionKeys(questionGroupObj.Questions, skippedQuestionKeys);

			// Combine arrays
			const updatedQuestionsArray = completedQuestionsArray.concat(skippedQuestionsArray);

			updateOnboardingQuestions = companyData.updateOnboardingQuestions(updatedQuestionsArray);
		}

		// Zero PayPeriodGroupPayBillYTD and PayPeriodGroupAppLevyYTD if toggle is off
		if (!employerObj.apprenticeshipLevyYTDActive) {
			employerObj.PayPeriodGroupPayBillYTD = 0;
			employerObj.PayPeriodGroupAppLevyYTD = 0;
		}

		// Zero PAYE credit if toggle is off
		if (!employerObj.HasOnboardingPAYECredit) {
			employerObj.OnboardingPAYECredit = 0;
		}

		$q.all([updateAgencyEmployerReferences, updateOnboardingQuestions]).then(function () {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Employer status details have been saved');

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {
		COMPANY_STATES,

		confirmPAYECreditOverride: false,

		changeApprenticeshipLevyOption,
		toggleOverrideOnboardingPAYECredit,
		toggleSkipSmallEmployer,
		toggleSkipEmploymentAllowance,
		updateAgencyEmployerStatusDetails
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsEpsForm', function () {

	return {
		controller: 'companySettingsEPSFormCtrl',
		templateUrl: 'forms/admin/companySettings/eps/companySettingsEPSForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsEPSFormCtrl', ['$scope', 'companyData', function ($scope, companyData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;

	function onError (error) {
		
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyEmployerEPSDisabled (agencyEmployerEPSEnabled, formObj) {

		const agencyEmployerEPSDisabled = !agencyEmployerEPSEnabled;

		formObj.state = 'saving';

		companyData.updateAgencyEmployerEPSDisabled(agencyProfileId, agencyEmployerEPSDisabled).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($scope, {
		agencyEmployerEPSEnabled: !companyObj.AgencyEmployerEPSDisabled,
		updateAgencyEmployerEPSDisabled
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsFileUploadsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsFileUploadsFormCtrl',
	templateUrl: 'forms/admin/companySettings/file-uploads/company-settings-file-uploads.form.html'
})

.constant('FILE_UPLOAD_FORMS', {
	deleteFile: 'delete-file',
	importFile: 'import-file',
	importHistory: 'import-history',
	renameFile: 'rename-file',
	uploadFile: 'upload-file'
})

.controller('companySettingsFileUploadsFormCtrl', [
	'$q',
	'$state',
	'base',
	'dataImport',
	'importService',
	'growl',
	'messageData',
	'payrollData',
	'utilities',
	'DOCUMENT_STATES',
	'DOCUMENT_TYPES',
	'DOCUMENT_TYPE_IDS',
	'FILE_UPLOAD_FORMS',
	'MIME_FORMATS',
	function (
		$q,
		$state,
		base,
		dataImport,
		importService,
		growl,
		messageData,
		payrollData,
		utilities,
		DOCUMENT_STATES,
		DOCUMENT_TYPES,
		DOCUMENT_TYPE_IDS,
		FILE_UPLOAD_FORMS,
		MIME_FORMATS
	) {

	const $ctrl = this;

	function $onInit () {

		const formOptionsObj = $ctrl.formOptions;
		const formState = formOptionsObj.formState;

		if (formState === FILE_UPLOAD_FORMS.importHistory) {
			loadImportHistoryForDocument($ctrl);

		} else {
			angular.extend($ctrl, {
				documents: getDocumentsArray(formOptionsObj),
				fileUploaderParams: {
					AgencyProfileID: formOptionsObj.agencyProfileId,
					DocumentTypeID: DOCUMENT_TYPE_IDS.genericUpload
				}
			});

			if (formState === FILE_UPLOAD_FORMS.renameFile) {
				utilities.focusOn('documentName', true);
			}
		}
	}

	function closeForm () {
		$ctrl.formOptions.forceCallback();
		$ctrl.formOptions.closeForm();
	}

	function displayFiles (filesArr) {
		$ctrl.documents = filesArr;
	}

	function deleteAgencyDocuments (documentsArr, formObj, isCancelAction) {

		formObj.state = 'saving';

		const deleteAgencyDocumentPromisesArr = documentsArr.map(agencyDocumentId => base.deleteAgencyDocument(agencyDocumentId));

		$q.all(deleteAgencyDocumentPromisesArr)
			.then(() => {
				if (!isCancelAction) {
					growl.success(deleteAgencyDocumentPromisesArr.length > 1 ? 'Files deleted' : 'File deleted');
				}
			})
			.then(closeForm)
			.catch(onError);
	}

	function deleteFileByIndex (documentListArr, index) {
		documentListArr.splice(index, 1);
	}

	function getDocumentsArray (formOptionsObj) {

		// Bulk delete
		if (angular.isDefined(formOptionsObj.documents)) {
			return formOptionsObj.documents;

		// Single delete
		} else if (angular.isDefined(formOptionsObj.document)) {
			return [formOptionsObj.document.AgencyDocumentID];

		// Upload
		} else {
			return [];
		}
	}

	function loadImportHistoryForDocument (ctrlObj) {

		dataImport.getUserImportGroupsForDocument(ctrlObj.formOptions.document.AgencyDocumentID)
			.then(importHistoryArr => {
				ctrlObj.importHistory = importHistoryArr;
			})
			.catch(onError);
	}

	function messageDocumentTransfer (ctrlObj, formObj) {

		formObj.state = 'saving';

		const agencyProfileId = ctrlObj.formOptions.agencyProfileId;
		const agencyDocumentId = ctrlObj.formOptions.document.AgencyDocumentID;

		payrollData.getPayPeriodMinimum(agencyProfileId).then(payPeriodObj => {

			messageData.messageDocumentTransfer(
				agencyProfileId,
				payPeriodObj.PayPeriodID,
				agencyDocumentId,
				DOCUMENT_TYPE_IDS.fpsImport
			)
			.then(() => {

				$state.go('fps-importer', {
					agencyProfileId: agencyProfileId,
					agencyDocumentId: agencyDocumentId,
					returnState: 'settings.company.file-uploads'
				});

			})
			.catch(onError);
		})
		.catch(onError);
	}

	function onCancelUpload (ctrlObj, formObj) {

		if (ctrlObj.documents.length > 0) {

			// Delete uploaded documents
			const uploadedDocumentIds = ctrlObj.documents.map(documentObj => documentObj.AgencyDocumentID);

			deleteAgencyDocuments(uploadedDocumentIds, formObj, true);

		} else {
			closeForm();
		}
	}

	function onError (error) {
		console.error(error);
		setFormState('error');
	}

	function onUploadComplete () {

		/* Upload(s) starting so enable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$ctrl.formOptions.isCloseFormDisabled = false;
	}

	function onUploadStart () {

		/* Upload(s) starting so disable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$ctrl.formOptions.isCloseFormDisabled = true;
	}

	function setFormState (newState) {
		$ctrl.formOptions.formState = newState;
	}

	function updateAgencyDocumentName (documentObj, formObj) {

		formObj.state = 'saving';

		const newDocumentName = `${documentObj.DocumentName}${documentObj.fileExtensionOriginal}`;

		base.updateAgencyDocumentName(documentObj.AgencyDocumentID, newDocumentName)
			.then(() => {
				growl.success('File name updated');
			})
			.then(closeForm)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		closeForm,
		deleteAgencyDocuments,
		deleteFileByIndex,
		displayFiles,
		goToDataImporterForDocumentType: importService.goToDataImporterForDocumentType,
		messageDocumentTransfer,
		onCancelUpload,
		onUploadComplete,
		onUploadStart,
		setFormState,
		updateAgencyDocumentName,

		DOCUMENT_STATES,
		DOCUMENT_TYPES,
		FILE_UPLOAD_FORMS,
		MIME_FORMATS
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsGenderPayGapDeleteForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsGenderPayGapDeleteFormCtrl',
	templateUrl: 'forms/admin/companySettings/gender-pay-gap-delete/company-settings-gender-pay-gap-delete.form.html',
})

.controller('companySettingsGenderPayGapDeleteFormCtrl', [
	'reportData',
	function (
		reportData
	) {

	const $ctrl = this;

	function $onInit () {
		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		throw new Error(error);
	}

	function onFormSubmit ($form) {

		$form.state = 'saving';

		reportData.deleteGenderPayGapReport($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.report.GenderPayGapReportID)
			.then(() => {

				$ctrl.formOptions.forceCallback();

				setPageState('saved');
			})
			.catch(onError);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		onFormSubmit
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsGenderPayGapEnabledForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsGenderPayGapEnabledFormCtrl',
	templateUrl: 'forms/admin/companySettings/gender-pay-gap-enabled/company-settings-gender-pay-gap-enabled.form.html',
})

.controller('companySettingsGenderPayGapEnabledFormCtrl', [
	'companyData',
	'growl',
	'stateService',
	function (
		companyData,
		growl,
		stateService
	) {

	const $ctrl = this;

	function $onInit () {

		companyData.getCompanyModuleDetails($ctrl.formOptions.agencyProfileId).then(companyModulesObj => {

			$ctrl.isGenderPayGapEnabled = companyModulesObj.IsGenderPayGapReportingActive;

			setPageState('ready');
		})
		.catch(onError);

		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}


	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function onFormSubmit ($form) {

		$form.state = 'saving';

		companyData.updateIsGenderPayGapEnabled($ctrl.formOptions.agencyProfileId, $ctrl.isGenderPayGapEnabled)
			.then(() => {

			// Update currentCompany so menu options are updated
			stateService.setCompany($ctrl.formOptions.agencyProfileId);

			growl.success(`${$ctrl.formOptions.company.isPayrollCompany  ? 'Company' : 'Group'} module options have been updated`);

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			$form.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		onFormSubmit
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsHmrcForm', function () {

	return {
		controller: 'companySettingsHmrcFormCtrl',
		templateUrl: 'forms/admin/companySettings/hmrc/companySettingsHmrcForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsHmrcFormCtrl', ['$scope', '$timeout', 'companyData', 'dataImportData', 'growl', 'session', function ($scope, $timeout, companyData, dataImportData, growl, session) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var isInPlayground = session.isInPlayground();

	function decorateCompanyObj (companyObj) {

		// If DPSImport is set to true we presume the HMRC credentials have been validated
		companyObj.Employer.areHmrcCredentialsEditable = angular.copy(!companyObj.Employer.DPSImport);
		companyObj.Employer.areHmrcCredentialsValid = angular.copy(companyObj.Employer.DPSImport);

		return companyObj;
	}

	function editHMRCCredentials (employerObj) {

		employerObj.areHmrcCredentialsEditable = true;
		employerObj.areHmrcCredentialsValid = false;
		employerObj.HMRCUserName = '';
		employerObj.HMRCPassword = '';
	}

	function enableElectronicUpdatesChanged (companyEmployerObj) {

		// Auto (de)select automatic updates setting
		companyEmployerObj.DPSAutoApply = companyEmployerObj.DPSImport;
	}

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(function (companyObj) {

			$scope.company = decorateCompanyObj(companyObj);
			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function saveCompanyReferences (employerObj, form) {

		!employerObj.DPSImport || employerObj.areHmrcCredentialsValid ? updateAgencyEmployerReferences(employerObj, form) : testCredentials(employerObj, form);
	}

	function testCredentials (employerObj, form) {

		setPageState('testing-hmrc-credentials');

		// Give user time to digest feedback for testing the HMRC crednetials
		$timeout(function () {

			dataImportData.getAreHMRCCredentialsValid(agencyProfileId, employerObj.HMRCUserName, employerObj.HMRCPassword).then(function (validationState) {

				switch (validationState) {
					case -1:
						setPageState('error');
						break;
					case -2:
						setPageState('hmrc-credentials-invalid');
						break;
					case -3:
						setPageState('automatic-updates-not-enabled');
						break;
					default:
						updateAgencyEmployerReferences(employerObj, form);
				}
			})
			.catch(function () {

				setPageState('hmrc-credentials-invalid');
			});

		}, 3000);
	}

	function updateAgencyEmployerReferences (employerObj, form) {

		form.state = 'saving';

		// Service call
		companyData.updateAgencyEmployerReferences(employerObj).then(function () {

			growl.success('Company references have been saved');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {
		// Variables
		isInPlayground,

		// Functions
		editHMRCCredentials,
		enableElectronicUpdatesChanged,
		saveCompanyReferences,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsHolidayPolicyForm', function () {

	return {
		controller: 'companySettingsHolidayPolicyFormCtrl',
		templateUrl: 'forms/admin/companySettings/holiday-policy/companySettingsHolidayPolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsHolidayPolicyFormCtrl', ['$scope', '$rootScope', 'agency', 'config', function ($scope, $rootScope, agency, config) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var holidayPolicyId = $scope.formOptions.holidayPolicyId;

	function init () {

		$scope.pageState = 'loading';
		$scope.agencyProfileId = agencyProfileId;
		if (!holidayPolicyId) {
			agency.getHolidayPolicies(agencyProfileId).then(function (policyObj) {

				var policy = policyObj[0];
				if (policy.HolidayPolicyID === config.guidEmpty) {
					policy.AgencyProfileID = agencyProfileId;
					policy.HolidayPolicyDays = config.policyDefaults.holiday.policyDays;
					policy.HolidayPolicyRolloverDays = config.policyDefaults.holiday.policyRolloverDays;
					policy.HolidayPolicyDefault = true;
				}

				$scope.policy = policy;
				$scope.pageState = 'ready';
			})
			.catch(function () {

				$scope.pageState = 'error';
			});
		} else {
			agency.getHolidayPolicy(holidayPolicyId).then(function (policyObj) {

				$scope.policy = policyObj;
				$scope.pageState = 'ready';
			})
			.catch(function () {

				$scope.pageState = 'error';
			});
		}
	}

	init();

	$scope.addAYear = function (date) {

		$scope.policy.HolidayPolicyDateToISO = moment(date).add(1, 'y').subtract(1, 'd').toISOString();
	};

	$scope.subtractAYear = function (date) {

		$scope.policy.HolidayPolicyDateFromISO = moment(date).subtract(1, 'y').add(1, 'd').toISOString();
	};


	$scope.setYearTo = function (yearType) {

		const currentDate = moment();
		switch (yearType) {
			case 'calendar':
				$scope.policy.HolidayPolicyDateFromISO = moment().startOf('year');
				$scope.policy.HolidayPolicyDateToISO = moment().endOf('year');
				break;
			case 'tax':
				if ((currentDate.month() >= 0 && currentDate.month() < 2) || (currentDate.month() === 3 && currentDate.date() < 6)) {
					$scope.policy.HolidayPolicyDateFromISO = moment().subtract(1, 'y').month('April').date(6);
					$scope.policy.HolidayPolicyDateToISO = moment().month('April').date(5);
				} else {
					$scope.policy.HolidayPolicyDateFromISO = moment().month('April').date(6);
					$scope.policy.HolidayPolicyDateToISO = moment().add(1, 'y').month('April').date(5);
				}
				break;
		}

		if (yearType === 'calendar' || yearType === 'tax') {
			// Convert the dates to ISO strings
			$scope.policy.HolidayPolicyDateFromISO = $scope.policy.HolidayPolicyDateFromISO.toISOString();
			$scope.policy.HolidayPolicyDateToISO = $scope.policy.HolidayPolicyDateToISO.toISOString();
		}
	};

	$scope.saveForm = function (formObj, form, policyObj) {

		form.state = 'saving';

		agency.updateHolidayPolicy(agencyProfileId, policyObj).then(function () {

			form.state = 'saved';

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			$scope.formOptions.forceCallback();
			$scope.pageState = 'saved-policy';

		})
		.catch(function () {

			$scope.pageState = 'error';
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsInactivePeriodForm', function () {

	return {
		controller: 'companySettingsInactivePeriodFormCtrl',
		templateUrl: 'forms/admin/companySettings/inactive-period/companySettingsInactivePeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsInactivePeriodFormCtrl', ['$rootScope', '$scope', 'config', 'companyData', function ($rootScope, $scope, config, companyData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriod = $scope.formOptions.payPeriod;

	function decorateInactivtyPeriodDetailsForInactivity (inactivityDetailsObj) {

		inactivityDetailsObj.inactivePeriodExists = inactivityDetailsObj.HasPeriodOfInactivity;

		return inactivityDetailsObj;
	}

	function inactivePeriodFormSetup () {

		companyData.getAgencyEmployerInactivityDetails(agencyProfileId).then(inactivityDetailsObj => {

			inactivityDetailsObj = decorateInactivtyPeriodDetailsForInactivity(inactivityDetailsObj);

			let vmObj = {
				inactivityDetails: inactivityDetailsObj
			};

			if (!inactivityDetailsObj.inactivePeriodExists) {
				vmObj.firstInactivePeriod = inactivityDetailsObj.UpcomingIncompletePeriods[0],
				vmObj.lastInactivePeriod = null;
			}

			$scope.vm = vmObj;

			setPageState('setup');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		setPageState('loading');

		if (payPeriod) {
			reopenPeriodForm();
		} else {
			inactivePeriodFormSetup();
		}
	}

	function reopenInactivePeriod (vmObj) {

		companyData.updateAgencyEmployerInactivity(agencyProfileId, vmObj.payPeriod.PayPeriodID, config.guidEmpty).then(() => {

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');

			setPageState('reopened');

			$scope.formOptions.forceCallback();
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function reopenPeriodForm () {

		companyData.assessCanReopenSkippedOrInactivePeriod(agencyProfileId, payPeriod.PayPeriodID).then(canAccessReopenForm => {

			$scope.vm = {
				payPeriod: payPeriod
			};

			setPageState(canAccessReopenForm ? 'reopen' : 'cant-reopen');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyEmployerInactivity (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyEmployerInactivity(agencyProfileId, vmObj.firstInactivePeriod.PayPeriodID, vmObj.lastInactivePeriod.PayPeriodID).then(() => {

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');

			formObj.state = 'saved';

			setPageState('saved');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	init();

	$scope.agencyProfileId = agencyProfileId;

	$scope.reopenInactivePeriod = vmObj => {

		reopenInactivePeriod(vmObj);
	};

	$scope.updateAgencyEmployerInactivity = (vmObj, formObj) => {

		updateAgencyEmployerInactivity(vmObj, formObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsAddNominalCodesForm', function () {

	return {
		controller: 'companySettingsAddNominalCodesFormCtrl',
		templateUrl: 'forms/admin/companySettings/journals/companySettingsAddNominalCodesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsAddNominalCodesFormCtrl', ['$scope', 'reportData', function ($scope, reportData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	let nominalCodesArr = removeNominalEntries(angular.copy($scope.formOptions.nominalCodes));

	function addNominalCode (nominalCodesArr) {

		return reportData.getEmptyNominalCode().then(emptyNominalCode => {
			decorateNominalCode(emptyNominalCode);
			nominalCodesArr.push(emptyNominalCode);
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function archiveNominalCode (nominalCode) {

		nominalCode.NominalCodeArchived = true;
	}

	function decorateNominalCode (nominalCode) {

		nominalCode.AgencyProfileID = agencyProfileId;
		// Functionality disabled for future enhancements
		nominalCode.balanceSheetProfitAndLossEnabled = false;
		// Initialise balance sheet / profit and loss switch
		toggleBalanceSheetProfitAndLoss(nominalCode);
	}

	function hasActiveNominalCodes (nominalCodesArr) {

		let returnBool = false;

		nominalCodesArr.forEach(nominalCodeItemObj => {
			if (!nominalCodeItemObj.NominalCodeArchived) {
				returnBool = true;
			}
		});

		return returnBool;
	}

	function init () {

		setPageState('loading');

		$scope.isUpdate = hasActiveNominalCodes(nominalCodesArr);

		// Create and add a new nominal code if there aren't any
		if (nominalCodesArr.length === 0) {
			addNominalCode(nominalCodesArr).then(() => {
				setPageState('ready');
			});
		}
		else {
			setPageState('ready');
		}
	}

	function removeNominalEntries (nominalCodesArr) {

		// Remove nominal entries as they are not required for this update
		nominalCodesArr.forEach(nominalCodeObj => {
			nominalCodeObj.NominalEntries = [];
		});

		return nominalCodesArr;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleBalanceSheetProfitAndLoss (nominalCode) {

		if (angular.isUndefined(nominalCode.balanceSheetProfitAndLoss) || !nominalCode.balanceSheetProfitAndLoss) {
			/* Switch to control NominalCodeBalanceSheet and NominalCodeProfitAndLoss attributes of nominal code,
			   one of which must be true, the other false */
			nominalCode.balanceSheetProfitAndLoss = true;
			nominalCode.NominalCodeBalanceSheet = true;
			nominalCode.NominalCodeProfitAndLoss = false;
		}
		else {
			nominalCode.balanceSheetProfitAndLoss = false;
			nominalCode.NominalCodeBalanceSheet = false;
			nominalCode.NominalCodeProfitAndLoss = true;
		}
	}

	function updateNominalCodes (form, nominalCodesArr, isUpdate) {

		form.state = 'saving';
		reportData.updateNominalCodeList(agencyProfileId, nominalCodesArr).then((updatedNominalCodesList) => {
			form.state = 'saved';
			$scope.formOptions.forceCallback(updatedNominalCodesList);
			setPageState(isUpdate ? 'edit-success' : 'add-success');
		})
		.catch(error => {
			console.error(error);
			form.state = 'error';
			setPageState('error');
		});
	}

	init();

	angular.extend($scope, {
		addNominalCode,
		archiveNominalCode,
		nominalCodes: nominalCodesArr,
		toggleBalanceSheetProfitAndLoss,
		updateNominalCodes
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsDeleteBusinessCategoryForm', function () {

	return {
		controller: 'companySettingsDeleteBusinessCategoryFormCtrl',
		templateUrl: 'forms/admin/companySettings/journals/companySettingsDeleteBusinessCategoryForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsDeleteBusinessCategoryFormCtrl', ['$scope', 'reportData', function ($scope, reportData) {

	let businessCategory = $scope.formOptions.businessCategory;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function deleteBusinessCategory (form, businessCategory) {

		form.state = 'saving';

		// Set archived flag on category to remove on update
		businessCategory.BusinessCategoryArchived = true;
		reportData.updateBusinessCategory(agencyProfileId, businessCategory).then((updatedBusinessCategoriesList) => {
			form.state = 'saved';
			$scope.formOptions.forceCallback(updatedBusinessCategoriesList);
			setPageState('success');
		})
		.catch(error => {
			console.error(error);
			form.state = 'error';
			setPageState('error');
		});
	}

	function init () {

		if (!businessCategory.CanArchive) {
			setPageState('in-use');
		}
		else {
			setPageState('ready');
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		// Variables
		businessCategory,

		// Functions
		deleteBusinessCategory
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsDeleteNominalCodeForm', {
	controller: 'companySettingsDeleteNominalCodeFormCtrl',
	templateUrl: 'forms/admin/companySettings/journals/company-settings-delete-nominal-code.form.html',
	bindings: {
		formOptions: '='
	}
})

.controller('companySettingsDeleteNominalCodeFormCtrl', [
	'reportData',
	'utilities',
	function (
		reportData,
		utilities
	) {

	const $ctrl = this;
	
	function $onInit () {

		// Remove nominal entries
		$ctrl.formOptions.nominalCodes = removeNominalEntries(angular.copy($ctrl.formOptions.nominalCodes));

		// Reference original array index item as update takes in array
		$ctrl.nominalCode = getNominalCodeByIndex($ctrl);

		setFormState('ready');
	}

	function deleteNominalCode (formObj, $ctrl) {

		formObj.state = 'saving';

		$ctrl.nominalCode.NominalCodeArchived = true;

		reportData.updateNominalCodeList($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.nominalCodes).then(() => {
			formObj.state = 'saved';
			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(error => {
			console.error(error);
			formObj.state = 'error';
			setFormState('error');
		});
	}

	function getNominalCodeByIndex ($ctrl) {

		return utilities.getArrayItemByPropertyName($ctrl.formOptions.nominalCodes, 'NominalCodeID', $ctrl.formOptions.nominalCode.NominalCodeID);
	}

	function removeNominalEntries (nominalCodesArr) {

		// Remove nominal entries as they are not required for this update
		nominalCodesArr.forEach(nominalCodeObj => {
			nominalCodeObj.NominalEntries = [];
		});

		return nominalCodesArr;
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		deleteNominalCode
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsDepartmentSubCodeOverridesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'departmentSubCodesOverridesFormCtrl',
	templateUrl: 'forms/admin/companySettings/journals/department-sub-code-overrides/company-settings-department-sub-code-overrides.form.html'
})

.controller('departmentSubCodesOverridesFormCtrl', [
	'$q',
	'config',
	'pensionData',
	'reportData',
	function (
		$q,
		config,
		pensionData,
		reportData
	) {

	const $ctrl = this;

	const PENSION_OVERRIDE_TYPES = {
		single: 0,
		pension: 1
	};

	function $onInit () {

		setFormState('loading');

		const getNominalCodeListForBusinessCode = reportData.getNominalCodeListForBusinessCode($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.businessCode.BusinessCodeID);
		const getEmptyNominalCodeOverride = reportData.getEmptyNominalCodeOverride();
		const getPensionsForAgency = pensionData.getPensionsForAgency($ctrl.formOptions.agencyProfileId);
		
		$q.all([
			getNominalCodeListForBusinessCode,
			getPensionsForAgency,
			getEmptyNominalCodeOverride
		]).then(([
			nominalCodesArr,
			pensionsArr,
			emptyNominalCodeOverrideObj
		]) => {

			emptyNominalCodeOverrideObj.BusinessCodeID = $ctrl.formOptions.businessCode.BusinessCodeID;

			// Decorate
			nominalCodesArr = decorateNominalCodes(nominalCodesArr, pensionsArr, emptyNominalCodeOverrideObj);

			angular.extend($ctrl, {
				nominalCodes: nominalCodesArr.filter(removeUnallocatedNominalCodes),
				nominalCodeOverride: emptyNominalCodeOverrideObj,
				pensions: pensionsArr
			});

			setFormState('ready');
		})
		.catch(onError);
	}

	function cleanupOverrides (nominalCodeObj) {

		// 1. Remove all unsaved overrides
		nominalCodeObj.NominalCodeOverrides = nominalCodeObj.NominalCodeOverrides.filter(nominalCodeOverrideObj => {
			return nominalCodeOverrideObj.NominalCodeOverrideID !== config.guidEmpty;
		});

		// 2. Mark all saved overrides as archived
		nominalCodeObj.NominalCodeOverrides.forEach(nominalCodeOverrideObj => {
			nominalCodeOverrideObj.NominalCodeOverrideArchived = true;
		});
	}

	function decorateNominalCodes (nominalCodesArr, pensionsArr, emptyNominalCodeOverrideObj) {

		nominalCodesArr.forEach(nominalCodeObj => {

			function filterExistingPensionOverrides (pension) {

				return !angular.isDefined(nominalCodeObj.NominalCodeOverrides.find(override => override.AgencyEmployerPensionID === pension.AgencyEmployerPensionID));
			}

			let overrideType = PENSION_OVERRIDE_TYPES.single; // Default to single

			// 1. If overrides already populated, check first to see whether they're per pension
			if (nominalCodeObj.NominalCodeOverrides.length > 0) {

				nominalCodeObj.isOverrideActive = true;

				// 1a. If pension id is set, pension override is applied (all overrides should be the same type)
				if (nominalCodeObj.NominalCodeOverrides[0].AgencyEmployerPensionID !== config.guidEmpty) {
					
					overrideType = PENSION_OVERRIDE_TYPES.pension;

					// 1b. Populate pension label for pre-existing overrides
					nominalCodeObj.NominalCodeOverrides.forEach(nominalCodeOverrideObj => {

						const pensionObj = getPensionProviderByPensionId(pensionsArr, nominalCodeOverrideObj.AgencyEmployerPensionID);

						if (angular.isDefined(pensionObj)) {
							nominalCodeOverrideObj.employerReference = pensionObj.EmployerReference;
							nominalCodeOverrideObj.pensionProviderName = pensionObj.PensionProviderName;
						}
					});

					// 1c. Append pensions that are not included in the pre-existing overrides
					const newNominalCodeOverrides = pensionsArr.filter(filterExistingPensionOverrides).map(pensionObj => {

						let nominalCodeOverrideObj = getDefaultOverrideObj($ctrl, nominalCodeObj, emptyNominalCodeOverrideObj);

						angular.extend(nominalCodeOverrideObj, {
							AgencyEmployerPensionID: pensionObj.AgencyEmployerPensionID,
							employerReference: pensionObj.EmployerReference,
							pensionProviderName: pensionObj.PensionProviderName
						});

						return nominalCodeOverrideObj;
					});

					nominalCodeObj.NominalCodeOverrides = nominalCodeObj.NominalCodeOverrides.concat(newNominalCodeOverrides);
				}
			}

			// Save original value for comparison when saving
			nominalCodeObj.NominalCodeOverrides.forEach(override => override.nominalCodeOverrideValueOriginal = angular.copy(override.NominalCodeOverrideValue));

			angular.extend(nominalCodeObj, {
				overrideType
			});
		});

		return nominalCodesArr;
	}

	function getDefaultOverrideObj ($ctrl, nominalCodeObj, emptyNominalCodeOverrideObj) {

		let nominalCodeOverrideObj = angular.copy(emptyNominalCodeOverrideObj);
		
		angular.extend(nominalCodeOverrideObj, {
			AgencyProfileID: $ctrl.formOptions.agencyProfileId,
			AgencyEmployerPensionID: config.guidEmpty,
			BusinessCodeID: $ctrl.formOptions.businessCode.BusinessCodeID,
			NominalCodeID: nominalCodeObj.NominalCodeID,
			NominalCodeOverrideValue: ''
		});

		return angular.copy(nominalCodeOverrideObj);
	}

	function getNominalCodeOverridesArr ($ctrl) {

		let returnArr = [];

		$ctrl.nominalCodes.forEach(nominalCodeObj => {

			nominalCodeObj.NominalCodeOverrides.forEach(override => {

				// Only return new, updated, or to be archived
				if (override.NominalCodeOverrideID === config.guidEmpty || override.NominalCodeOverrideValue !== override.nominalCodeOverrideValueOriginal || override.NominalCodeOverrideArchived === true) {

					if (override.NominalCodeOverrideValue !== override.nominalCodeOverrideValueOriginal) {
						// Set to empty guid to create a new override
						override.NominalCodeOverrideID = config.guidEmpty;
					}

					returnArr.push(override);
				}
			});
		});

		return returnArr;
	}

	function getPensionProviderByPensionId (pensionsArr, pensionId) {

		return pensionsArr.find(pensionObj => {
			return pensionObj.AgencyEmployerPensionID === pensionId;
		});
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function onNominalCodeOverrideChange (nominalCodeOverrideObj) {

		if (nominalCodeOverrideObj.NominalCodeOverrideValue !== nominalCodeOverrideObj.nominalCodeOverrideValueOriginal) {
			nominalCodeOverrideObj.NominalCodeOverrideID = config.guidEmpty;
		}
	}

	function reviewOverrideType (nominalCodeObj, $ctrl) {

		cleanupOverrides(nominalCodeObj);

		switch (nominalCodeObj.overrideType) {

			case PENSION_OVERRIDE_TYPES.single: {

				let nominalCodeOverrideObj = getDefaultOverrideObj($ctrl, nominalCodeObj, $ctrl.nominalCodeOverride);

				nominalCodeObj.NominalCodeOverrides.push(nominalCodeOverrideObj);

				break;
			}

			case PENSION_OVERRIDE_TYPES.pension: {

				$ctrl.pensions.forEach(pensionObj => {

					let nominalCodeOverrideObj = getDefaultOverrideObj($ctrl, nominalCodeObj, $ctrl.nominalCodeOverride);

					angular.extend(nominalCodeOverrideObj, {
						AgencyEmployerPensionID: pensionObj.AgencyEmployerPensionID,
						employerReference: pensionObj.EmployerReference,
						pensionProviderName: pensionObj.PensionProviderName
					});

					nominalCodeObj.NominalCodeOverrides.push(nominalCodeOverrideObj);
				});

				break;
			}
		}
	}

	function removeUnallocatedNominalCodes (nominalCodeObj) {

		return !nominalCodeObj.IsUnallocatedNominalCode;
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function toggleIsOverrideActive ($ctrl, nominalCodeObj) {

		nominalCodeObj.isOverrideActive = !nominalCodeObj.isOverrideActive;

		if (nominalCodeObj.isOverrideActive) {

			// Reset override type
			nominalCodeObj.overrideType = PENSION_OVERRIDE_TYPES.single;

			let nominalCodeOverrideObj = angular.copy($ctrl.nominalCodeOverride);

			angular.extend(nominalCodeOverrideObj, {
				AgencyProfileID: $ctrl.formOptions.agencyProfileId,
				AgencyEmployerPensionID: config.guidEmpty,
				BusinessCodeID: $ctrl.formOptions.businessCode.BusinessCodeID,
				NominalCodeID: nominalCodeObj.NominalCodeID,
				NominalCodeOverrideValue: '',
				NominalCodeOverrideArchived: false
			});

			nominalCodeObj.NominalCodeOverrides.push(nominalCodeOverrideObj);
		}

		else {

			cleanupOverrides(nominalCodeObj);
		}
	}

	function updateNominalCodeOverrides ($ctrl, formObj) {

		formObj.state = 'saving';

		const nominalCodeOverrides = getNominalCodeOverridesArr($ctrl);
		
		reportData.updateNominalCodeOverrides($ctrl.formOptions.agencyProfileId, nominalCodeOverrides).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		PENSION_OVERRIDE_TYPES,
		$onInit,
		onNominalCodeOverrideChange,
		reviewOverrideType,
		toggleIsOverrideActive,
		updateNominalCodeOverrides
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsSubCodeOverridesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'subCodesOverridesFormCtrl',
	templateUrl: 'forms/admin/companySettings/journals/sub-code-overrides/company-settings-sub-code-overrides.form.html'
})

.controller('subCodesOverridesFormCtrl', [
	'config',
	'reportData',
	function (
		config,
		reportData
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		angular.extend($ctrl, {
			businessCategoryId: getBusinessCategoryIdForEnabledSubCodeOverride($ctrl.formOptions.businessCategories),
			isSubCodeOverridesEnabled: getIsSubCodeOverrideEnabled($ctrl.formOptions.businessCategories)
		});

		setFormState('ready');
	}

	function checkBusinessCategory ($ctrl) {

		if (!$ctrl.isSubCodeOverridesEnabled) {
			$ctrl.businessCategoryId = config.guidEmpty;
		}
	}

	function getBusinessCategoryIdForEnabledSubCodeOverride (businessCategoriesArr) {

		return getEnabledSubCodeOverrideCategoryId(businessCategoriesArr);
	}

	function getEnabledSubCodeOverrideCategoryId (businessCategoriesArr) {

		const subCodeOverrideEnabledBusinessCategory = businessCategoriesArr.find(i => i.BusinessCategoryNominalCodeOverridesEnabled);

		if (angular.isDefined(subCodeOverrideEnabledBusinessCategory)) {
			return subCodeOverrideEnabledBusinessCategory.BusinessCategoryID ;
		}

		return config.guidEmpty;
	}

	function getIsSubCodeOverrideEnabled (businessCategoriesArr) {

		const subCodeOverrideEnabledBusinessCategoryId = getEnabledSubCodeOverrideCategoryId(businessCategoriesArr);
	
		if (subCodeOverrideEnabledBusinessCategoryId !== config.guidEmpty) {
			return true;
		}

		return false;
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function updateNominalCodeOverridesEnabled ($ctrl, formObj) {

		formObj.state = 'saving';

		reportData.updateNominalCodeOverridesEnabled($ctrl.formOptions.agencyProfileId, $ctrl.businessCategoryId).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		checkBusinessCategory,
		updateNominalCodeOverridesEnabled
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsNiUpdatesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsNiUpdatesFormCtrl',
	templateUrl: 'forms/admin/companySettings/ni-updates/company-settings-ni-updates.form.html'
})

.controller('companySettingsNiUpdatesFormCtrl', [
	'growl',
	'companyData',
	function (
		growl,
		companyData
	) {

	const $ctrl = this;

	function $onInit () {
		setFormState('ready');
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function setFormState (pageState) {
		$ctrl.formState = pageState;
	}

	function updateAgencyEmployerAutoApplyNICodeChanges ($form) {

		$form.state = 'saving';

		companyData.updateAgencyEmployerAutoApplyNICodeChanges(
				$ctrl.formOptions.agencyProfileId,
				$ctrl.formOptions.company.AutoApplyNICode
			)
			.then(() => {

			growl.success('Auto-accept NI settings updates');

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			$form.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateAgencyEmployerAutoApplyNICodeChanges
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsNmwCalculationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsNmwCalculationFormCtrl',
	templateUrl: 'forms/admin/companySettings/nmw-calculation/company-settings-nmw-calculation.form.html'
})

.controller('companySettingsNmwCalculationFormCtrl', [
	'companyData',
	'growl',
	'payrollData',
	'NMW_CALCULATION_METHODS',
	function (
		companyData,
		growl,
		payrollData,
		NMW_CALCULATION_METHODS
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfileCompanyDetails($ctrl.formOptions.agencyProfileId)
			.then(companyDetailsObj => {

				angular.extend($ctrl, {
					nmwCalculationMethods: getNMWCalculationMethods(),
					company: companyDetailsObj
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function getNMWCalculationMethods () {
		return [
			NMW_CALCULATION_METHODS.period,
			NMW_CALCULATION_METHODS.annually
		];
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function updateCompanyNMWCalculationMethod ($ctrl, $form) {

		$form.state = 'saving';

		payrollData.updateCompanyNMWCalculationMethod($ctrl.formOptions.agencyProfileId, $ctrl.company.NMWCalculationMethod).
			then(() => {
				growl.success('NMW calculation method updated.');
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		updateCompanyNMWCalculationMethod
	});
}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsP11dSubmissionForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsP11dSubmissionFormCtrl',
		templateUrl: 'forms/admin/companySettings/p11d-submission/company-settings-p11d-submission.form.html'
	})

	.controller('companySettingsP11dSubmissionFormCtrl', [
		'$state',
		'$timeout',
		'$q',
		'config',
		'payrollData',
		'utilities',
		'validationService',
		'SUBMISSION_LOG_TYPE',
		'SUBMISSION_STATES',
		'VALIDATION_WARNINGS',
		function (
			$state,
			$timeout,
			$q,
			config,
			payrollData,
			utilities,
			validationService,
			SUBMISSION_LOG_TYPE,
			SUBMISSION_STATES,
			VALIDATION_WARNINGS
		) {

			const $ctrl = this;

			const FORM_STATES = {
				confirmDelete: 'confirmDelete',
				deleted: 'deleted',
				error: 'error',
				failed: 'failed',
				generating: 'generating',
				loading: 'loading',
				step1: 'step1',
				step2: 'step2',
				step3: 'step3',
				step4: 'step4',
				step5: 'step5',
				submitting: 'submitting',
				submitted: 'submitted',
				validationWarning: 'validationWarning'
			};

			function $onInit () {

				setFormState(FORM_STATES.loading);

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const agencyPayPeriodId = $ctrl.formOptions.agencyPayPeriodId;

				$ctrl.validationWarning = $ctrl.VALIDATION_WARNINGS.none;

				if (angular.isDefined(agencyProfileId) && angular.isDefined(agencyPayPeriodId)) {

					getP11DbSubmissionForAgencyPayPeriod(agencyProfileId, agencyPayPeriodId)
						.then(p11dbSubmission => {

							let formState = getNextFormState(p11dbSubmission);

							setFormState(formState);

							if (formState === FORM_STATES.submitting) {
								pollForSubmissionState();
							}
						});
				}
				else {
					getValidationWarnings()
						.then(() => {
							payrollData.getTaxYearsForP11DbSubmission($ctrl.formOptions.agencyProfileId)
								.then(taxYearsArr => {

									angular.extend($ctrl, {
										adjustAboveFigure: false,
										hasCheckedPaye: false,
										payPeriodId: null,
										isStep1Disabled: false,
										taxYears: taxYearsArr
									});

									setFormState(FORM_STATES.step1);
								})
								.catch(onError);
						});
				}
			}

			function getValidationWarnings () {
				return $q(resolve => {
					const agencyProfileId = $ctrl.formOptions.agencyProfileId;
					const agencyPayPeriodId = angular.isDefined($ctrl.payPeriodId) ? $ctrl.payPeriodId : config.guidEmpty;
					const p11dbSubmissionId = angular.isDefined($ctrl.p11dSubmission) ? $ctrl.p11dSubmission.P11DbSubmissionID : config.guidEmpty;

					setFormState(FORM_STATES.loading);

					return payrollData.getP11DbSubmissionValidationWarnings(agencyProfileId, agencyPayPeriodId, p11dbSubmissionId)
						.then(validationWarning => {
							$ctrl.validationWarning = validationWarning;

							// only continue if there is no validation warning to display
							if (validationWarning === VALIDATION_WARNINGS.none) {
								resolve();
							} else {
								setFormState(FORM_STATES.validationWarning);
							}
						});
				});
			}

			function getNextFormState (p11dbSubmission) {
				switch (p11dbSubmission.P11DbSubmissionFinaliseState) {
					case SUBMISSION_STATES.failed:
						return FORM_STATES.failed;
					case SUBMISSION_STATES.submitting:
						return FORM_STATES.submitting;
					case SUBMISSION_STATES.submitted:
						return FORM_STATES.submitted;
					default:
						return FORM_STATES.step4;
				}
			}

			function getSelectedTaxYear () {
				if(angular.isDefined($ctrl.payPeriodId) && angular.isArray($ctrl.taxYears)) {
					return $ctrl.taxYears.find(taxYear => taxYear.PayPeriodID === $ctrl.payPeriodId);
				}
			}

			function getErrorTitle () {
				switch($ctrl.validationWarning){
					case VALIDATION_WARNINGS.existingDraftSubmission:
						return 'Draft submission pending';
					case VALIDATION_WARNINGS.missingAccountsOfficeReference:
						return 'Accounts Office reference missing';
					case VALIDATION_WARNINGS.missingTaxOfficeReference:
						return 'Tax Office reference missing';
					case VALIDATION_WARNINGS.noTaxYearsAvailable:
						return 'No tax years available';
					case VALIDATION_WARNINGS.outsideSubmissionWindowForTaxYear:
						return 'The submission window isn\'t open';
					case VALIDATION_WARNINGS.p11DbAlreadyExistsForTaxYear:
						return 'Submission already made';
					case VALIDATION_WARNINGS.payrollModuleDisabled:
						return 'Payroll module turned off';
					case VALIDATION_WARNINGS.rtiSubmissionsDisabled:
						return 'RTI submissions turned off';
					case VALIDATION_WARNINGS.submissionInProgress:
						return 'Submission in progress';
				}
			}

			function openPayrollSettingsForm () {

				$state.go('settings.company.payroll-settings');
			}

			function openCompanyModulesForm () {

				$state.go('settings.company.modules');
			}

			function goToStep2 () {

				getValidationWarnings()
					.then(() => {
						if (!angular.isDefined($ctrl.p11dSubmission)) {
							payrollData.getEmptyP11DbSubmission($ctrl.formOptions.agencyProfileId, $ctrl.payPeriodId)
								.then(emptyP11dSubmission => {

									angular.extend(emptyP11dSubmission, {
										P11DbSubmissionNICRate: utilities.setPropertyValueToEmptyIfZero(emptyP11dSubmission.P11DbSubmissionNICRate),
										P11DbSubmissionBenefitsLiable: utilities.setPropertyValueToEmptyIfZero(emptyP11dSubmission.P11DbSubmissionBenefitsLiable),
										P11DbSubmissionAdjustmentDueAmount: utilities.setPropertyValueToEmptyIfZero(emptyP11dSubmission.P11DbSubmissionAdjustmentDueAmount),
										P11DbSubmissionAdjustmentNotDueAmount: utilities.setPropertyValueToEmptyIfZero(emptyP11dSubmission.P11DbSubmissionAdjustmentNotDueAmount)
									});

									angular.extend($ctrl, {
										p11dSubmission: emptyP11dSubmission
									});

									setFormState(FORM_STATES.step2);
								})
								.catch(onError);
						}
						else {
							setFormState(FORM_STATES.step2);
						}

				});
			}

			function saveForm () {

				setFormState(FORM_STATES.generating);

				if (!$ctrl.adjustAboveFigure) {
					angular.extend($ctrl.p11dSubmission, {
						P11DbSubmissionAdjustmentDueAmount: 0,
						P11DbSubmissionAdjustmentNotDueAmount: 0,
						P11DbSubmissionAdjustmentDueDescription: '',
						P11DbSubmissionAdjustmentNotDueDescription: '',
					});
				}

				angular.extend($ctrl.p11dSubmission, {
					P11DbSubmissionNICRate: utilities.setPropertyValueToZeroIfEmpty($ctrl.p11dSubmission.P11DbSubmissionNICRate),
					P11DbSubmissionBenefitsLiable: utilities.setPropertyValueToZeroIfEmpty($ctrl.p11dSubmission.P11DbSubmissionBenefitsLiable),
					P11DbSubmissionAdjustmentDueAmount: utilities.setPropertyValueToZeroIfEmpty($ctrl.p11dSubmission.P11DbSubmissionAdjustmentDueAmount),
					P11DbSubmissionAdjustmentNotDueAmount: utilities.setPropertyValueToZeroIfEmpty($ctrl.p11dSubmission.P11DbSubmissionAdjustmentNotDueAmount)
				});

				if (validationService.isEmptyGuid($ctrl.p11dSubmission.P11DbSubmissionID)) {
					payrollData.createP11DbSubmission($ctrl.p11dSubmission, $ctrl.formOptions.agencyProfileId)
						.then(() => {
							getP11DbSubmissionForAgencyPayPeriod($ctrl.formOptions.agencyProfileId, $ctrl.payPeriodId);
							$timeout(function () {
								setFormState(FORM_STATES.step4);
							},  1000);
							refreshCards();
						})
						.catch(onError);
				} else {
					payrollData.updateP11DbSubmission($ctrl.p11dSubmission, $ctrl.formOptions.agencyProfileId)
						.then(() => {
							getP11DbSubmissionForAgencyPayPeriod($ctrl.formOptions.agencyProfileId, $ctrl.p11dSubmission.AgencyPayPeriodID);
							$timeout(function () {
								setFormState(FORM_STATES.step4);
							},  1000);
						})
						.catch(onError);
				}
			}

			function getP11DbSubmissionForAgencyPayPeriod (agencyProfileId, agencyPayPeriodId) {
				return $q(resolve => payrollData.getP11DbSubmissionForAgencyPayPeriod(agencyProfileId, agencyPayPeriodId)
					.then(p11dSubmission => {

						angular.extend($ctrl, {
							p11dSubmission: p11dSubmission,
							adjustAboveFigure: p11dSubmission.HasAdjustment,
							hasCheckedPaye: true,
							payPeriodId: p11dSubmission.AgencyPayPeriodID,
							isStep1Disabled: true,
							taxYears: []
						});

						resolve(p11dSubmission);

					})
					.catch(onError)
				);
			}

			function submitP11db () {

				getValidationWarnings()
					.then(() => {
						setFormState(FORM_STATES.submitting);

						angular.extend($ctrl, {
							hasConfirmedDeclaration: false
						});

						payrollData.payrollSubmitP11Db($ctrl.formOptions.agencyProfileId, $ctrl.p11dSubmission.P11DbSubmissionID)
							.then(pollForSubmissionState)
							.catch(onError);
					});
			}

			function cancelDelete () {
				setFormState($ctrl.stateBeforeDelete);
			}

			function deleteSubmission () {
				setFormState(FORM_STATES.loading);

				payrollData.deleteP11DbSubmission($ctrl.formOptions.agencyProfileId, $ctrl.p11dSubmission.P11DbSubmissionID).then(() => {
					setFormState(FORM_STATES.deleted);
					refreshCards();
				})
				.catch(onError);
			}

			function pollForSubmissionState () {

				return $q(resolve => {
					var timeToPoll = config.timeToPoll;

					payrollData.getP11DbSubmissionFinaliseState($ctrl.formOptions.agencyProfileId, $ctrl.p11dSubmission.P11DbSubmissionID)
						.then(submissionState => {

							var timer;

							switch (submissionState) {
								case SUBMISSION_STATES.submitting:

									// Poll
									timer = $timeout(function () {
										pollForSubmissionState()
											.then(resolve);
									}, timeToPoll * 1000);
									break;

								case SUBMISSION_STATES.submitted:

									setFormState(FORM_STATES.submitted);

									$timeout.cancel(timer);
									refreshCards();

									// Fire callback
									resolve();
									break;

								case SUBMISSION_STATES.failed:

									setFormState(FORM_STATES.failed);
									refreshCards();

									$timeout.cancel(timer);
									break;

								default:

									$timeout.cancel(timer);
									break;
							}

							return timer;
						});
				});
			}

			function openDeleteConfirmationView () {

				$ctrl.stateBeforeDelete = $ctrl.formState;
				setFormState(FORM_STATES.confirmDelete);
			}

			function openReportPreview () {
				$state.go('p11db-report', {
					agencyProfileId: $ctrl.formOptions.agencyProfileId,
					p11DbSubmissionID: $ctrl.p11dSubmission.P11DbSubmissionID,
					openedFrom:'form'
				});
			}

			function refreshCards () {
				$ctrl.formOptions.callback();
			}

			function onClose () {
				$ctrl.formOptions.closeForm();
			}

			function onError (error) {

				setFormState(FORM_STATES.error);
				console.error(error);
			}

			function setFormState (formState) {

				$ctrl.formState = formState;
			}

			angular.extend($ctrl, {
				FORM_STATES,
				VALIDATION_WARNINGS,

				submissionLogType: SUBMISSION_LOG_TYPE.p11dbSubmission,

				$onInit,
				cancelDelete,
				deleteSubmission,
				getErrorTitle,
				getSelectedTaxYear,
				goToStep2,
				saveForm,
				setFormState,
				submitP11db,
				onClose,
				openCompanyModulesForm,
				openDeleteConfirmationView,
				openPayrollSettingsForm,
				openReportPreview
			});
		}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsP11dbSubmissionDeleteForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsP11dbSubmissionDeleteFormCtrl',
		templateUrl: 'forms/admin/companySettings/p11d-submission/delete/company-settings-p11db-submission-delete.form.html'
	})


	.controller('companySettingsP11dbSubmissionDeleteFormCtrl', [
		'payrollData',

		function (payrollData
		) {

			const $ctrl = this;

			function $onInit() {

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const isConfirmDeleteVisible = $ctrl.formOptions.p11dbSubmission.CanDelete;
				const p11dbSubmissionId = $ctrl.formOptions.p11dbSubmission.P11DbSubmissionID;
				const taxYearDisplay = $ctrl.formOptions.p11dbSubmission.TaxYearDisplay;

				setPageState('ready');

				angular.extend($ctrl, {
					agencyProfileId,
					isConfirmDeleteVisible,
					p11dbSubmissionId,
					taxYearDisplay
				});
			}

			function onError (error) {

				setPageState('error');
				console.error(error);
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			function cancel () {
				$ctrl.formOptions.closeForm();
			}

			function deleteSubmission ($ctrl) {
				setPageState('loading');
				payrollData.deleteP11DbSubmission($ctrl.agencyProfileId, $ctrl.p11dbSubmissionId).then(() => {
					setPageState('deleted');
					$ctrl.formOptions.callback();
				})
				.catch(onError);
			}

			angular.extend($ctrl, {
				$onInit,
				cancel,
				deleteSubmission
			});
		}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsP32PaymentForm', function () {

	return {
		controller: 'companySettingsP32PaymentFormCtrl',
		templateUrl: 'forms/admin/companySettings/p32-payment/companySettingsP32PaymentForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsP32PaymentFormCtrl', ['$q', '$rootScope', '$scope', 'companyData', 'config', 'growl', 'payPeriodService', 'payrollData', 'CONTACT_EXTERNAL_CATEGORIES', 'EMAIL_PREVIEW_TYPES', 'FULL_SCREEN_MODAL_KEYS', 'HMRC_PAYMENT_ACCOUNTS', 'P32_EMAIL_FREQUENCIES', 'PAY_PERIOD_TYPES',
	function ($q, $rootScope, $scope, companyData, config, growl, payPeriodService, payrollData, CONTACT_EXTERNAL_CATEGORIES, EMAIL_PREVIEW_TYPES, FULL_SCREEN_MODAL_KEYS, HMRC_PAYMENT_ACCOUNTS, P32_EMAIL_FREQUENCIES, PAY_PERIOD_TYPES) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function decorateCompanyP32 (companyP32Obj) {

		if (!companyP32Obj.IsAutomatedEmailsEnabled) {
			companyP32Obj.AutomatedEmailFrequency = P32_EMAIL_FREQUENCIES.monthly;
			companyP32Obj.AutomatedEmailDayOfMonth = null;
		}

		return companyP32Obj;
	}

	function decoratePayPeriod (payPeriodObj) {

		const hmrcPaymentDayOfMonth = moment(payPeriodObj.HMRCPaymentDateISO).date();

		angular.extend(payPeriodObj, {
			annualSendDateMaxIso: moment().set('date', hmrcPaymentDayOfMonth).format(config.dateFormatISO),
			hmrcPaymentDayOfMonth,
			sendDate1MinIso: moment().add(1, 'd').format(config.dateFormatISO)
		});
	}

	function init () {

		setPageState('loading');

		const getCompanyP32Management = companyData.getCompanyP32Management(agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([getCompanyP32Management, getPayPeriodCurrent]).then(([companyP32Obj, payPeriodObj]) => {

			const monthlySendDateOptionsArr = payPeriodService.getPaymentOptionsDaysByPeriodType(PAY_PERIOD_TYPES.monthly);

			decoratePayPeriod(payPeriodObj);

			$scope.vm = {
				automatedEmailDayOfMonthOptions: monthlySendDateOptionsArr.filter(removeInvalidSendDateOptions(payPeriodObj)),
				company: decorateCompanyP32(companyP32Obj),
				payPeriod: payPeriodObj,
				personalDataAgreement: companyP32Obj.IsAutomatedEmailsEnabled,
				sendDateValidation: payPeriodService.getPayPeriodsDateValidation(payPeriodObj.PayDateISO, true)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onEmailFrequencyChange (vmObj) {

		resetDateFields(vmObj);

		switch (vmObj.company.AutomatedEmailFrequency) {
			case P32_EMAIL_FREQUENCIES.monthly:
				vmObj.company.AutomatedEmailDayOfMonth = null;
				break;

			case P32_EMAIL_FREQUENCIES.quarterly:
				angular.extend(vmObj.company, {
					AutomatedEmailQ1SendDateISO: null,
					AutomatedEmailQ2SendDateISO: null,
					AutomatedEmailQ3SendDateISO: null,
					AutomatedEmailQ4SendDateISO: null,
				});
				break;

			case P32_EMAIL_FREQUENCIES.annually:
				vmObj.company.AutomatedEmailAnnualSendDateISO = null;
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openAddressBookModal () {
		$rootScope.$broadcast('open-full-screen-modal', {
			agencyProfileId: agencyProfileId,
			modalKey: FULL_SCREEN_MODAL_KEYS.addressBook,
			contactExternalId: CONTACT_EXTERNAL_CATEGORIES.p32EmailRecipient,
			label: 'The email will be automatically sent to'
		});
	}

	function removeInvalidSendDateOptions (payPeriodObj) {
		return sendDateObj => sendDateObj.id <= payPeriodObj.hmrcPaymentDayOfMonth;
	}

	function resetDateFields (vmObj) {
		angular.extend(vmObj.company, {
			AutomatedEmailDayOfMonth: 0,
			AutomatedEmailQ1SendDateISO: '',
			AutomatedEmailQ2SendDateISO: '',
			AutomatedEmailQ3SendDateISO: '',
			AutomatedEmailQ4SendDateISO: '',
			AutomatedEmailAnnualSendDateISO: ''
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateCompanyP32Management (vmObj, formObj) {

		formObj.state = 'saving';

		if (!vmObj.company.IsAutomatedEmailsEnabled) {
			vmObj.company.AutomatedEmailFrequency = P32_EMAIL_FREQUENCIES.none;
			resetDateFields(vmObj);
		}

		companyData.updateCompanyP32Management(vmObj.company).then(() => {

			$scope.formOptions.forceCallback();

			$scope.formOptions.closeForm();

			growl.success('P32 payment settings updated');
		})
		.catch(onError);
	}

	function updateSendDateValidation (date1Iso) {

		const vmObj = $scope.vm;

		vmObj.sendDateValidation = payPeriodService.getPayPeriodsDateValidation(date1Iso, true, vmObj.payPeriod.hmrcPaymentDayOfMonth);
	}

	function validateAnnualSendDate (automatedEmailAnnualSendDateISO) {

		const vmObj = $scope.vm;

		const annualSendDateMoment = moment(automatedEmailAnnualSendDateISO);
		const monthHMRCPaymentDate = moment(automatedEmailAnnualSendDateISO).date(vmObj.payPeriod.hmrcPaymentDayOfMonth);

		if (annualSendDateMoment.isAfter(monthHMRCPaymentDate)) {
			vmObj.companySettingsP32PaymentForm.automatedEmailAnnualSendDateIso.$setValidity('dayOfMonth', false);
			vmObj.annualSendDateMaxDisplay = monthHMRCPaymentDate.format(config.dateFormatISO);

		} else {
			vmObj.companySettingsP32PaymentForm.automatedEmailAnnualSendDateIso.$setValidity('dayOfMonth', true);
		}

	}

	init();

	angular.extend($scope, {
		EMAIL_PREVIEW_TYPES,
		HMRC_PAYMENT_ACCOUNTS,
		P32_EMAIL_FREQUENCIES,

		onEmailFrequencyChange,
		openAddressBookModal,
		updateCompanyP32Management,
		updateSendDateValidation,
		validateAnnualSendDate
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsP60NotificationsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsP60NotificationsFormCtrl',
	templateUrl: 'forms/admin/companySettings/p60-notifications/company-settings-p60-notifications.form.html'
})

.controller('companySettingsP60NotificationsFormCtrl', [
	'$q',
	'companyData',
	'payrollWorker',
	'utilities',
	'INTERFACE_TYPES',
	function (
		$q,
		companyData,
		payrollWorker,
		utilities,
		INTERFACE_TYPES
	) {

	const $ctrl = this;

	const NOTIFICATION_TYPES = {
		custom: 'custom',
		onFinalPayRun: 'on-payroll-run',
		rightAway: 'right-away'
	};

	function $onInit () {

		setFormState('loading');

		companyData.getP60NotificationSettings($ctrl.formOptions.agencyProfileId)
			.then(p60NotificationSettingsObj => {

				angular.extend($ctrl, {
					changeSet: {
						create: [],
						update: [],
						delete: []
					},
					hasFormChanged: false,
					p60NotificationSettings: p60NotificationSettingsObj,
					scheduledNotifications: [],
					sentNotifications: getSentNotifications(p60NotificationSettingsObj),
					unscheduledTaxYears: getUnscheduledTaxYears(p60NotificationSettingsObj)
				});

				getScheduledNotifications(p60NotificationSettingsObj);

				setFormState('ready');
			})
			.catch(onError);
	}

	function deleteNotificationFromChangeset (notificationObj, changeSet) {

		const notificationIndex = changeSet.findIndex(createScheduleObj => createScheduleObj.id === notificationObj.id);

		// Remove from changeset
		changeSet.splice(notificationIndex, 1);
	}

	function getEmptyNotificationObject () {
		return {

			// Used to store current version of notification to restore back to when cancelling an edit
			backupStorage: {},

			// Give each notification an ID to be used to removed notifications when canelling
			id: utilities.guid(),

			// If it's an existing notification, notification will be removed via a service call on save
			isExistingNotification: true,

			// For display purposes
			isDeleted: false,

			// For display purposes
			isInEditMode: false,

			// null = 'When final payroll is run', or is a custom date
			notificationDateIso: null,

			// 'on-payroll-run' || 'custom' || 'right-away'
			notificationType: NOTIFICATION_TYPES.onFinalPayRun,

			// Tax year object for this notification
			taxYear: null
		};
	}

	function getNotificationChangePromisesFromChangeSet () {

		function decorateNotificationBeforeSave (notificationObj) {

			// Set notification date to null when 'When final payroll is run' is selected
			if (notificationObj.notificationType === NOTIFICATION_TYPES.onFinalPayRun) {
				notificationObj.notificationDateIso = null;
			}
		}

		const promisesArr = [];

		// Notifications to create
		for (let notificationObj of $ctrl.changeSet.create) {

			decorateNotificationBeforeSave(notificationObj);

			if ($ctrl.formOptions.company.CompanyType === INTERFACE_TYPES.bureau) {
				promisesArr.push(
					companyData.createParentScheduledP60Notification(
						$ctrl.formOptions.agencyProfileId,
						notificationObj.taxYear.TaxYear,
						notificationObj.notificationDateIso,
						$ctrl.overwriteChildCompaniesSettings
					)
				);
			}
			else {
				promisesArr.push(
					companyData.createScheduledP60Notification(
						$ctrl.formOptions.agencyProfileId,
						notificationObj.taxYear.TaxYear,
						notificationObj.notificationDateIso
					)
				);
			}
		}

		// Notifications to delete
		for (let notificationObj of $ctrl.changeSet.delete) {

			if ($ctrl.formOptions.company.CompanyType === INTERFACE_TYPES.bureau) {
				promisesArr.push(
					companyData.deleteParentScheduledP60Notification(
						$ctrl.formOptions.agencyProfileId,
						notificationObj.taxYear.ScheduledP60Notification.ScheduledP60NotificationID,
						$ctrl.overwriteChildCompaniesSettings
					)
				);
			}
			else {
				promisesArr.push(
					companyData.deleteScheduledP60Notification(
						$ctrl.formOptions.agencyProfileId,
						notificationObj.taxYear.ScheduledP60Notification.ScheduledP60NotificationID
					)
				);
			}

		}

		// Notifications to update
		for (let notificationObj of $ctrl.changeSet.update) {

			decorateNotificationBeforeSave(notificationObj);

			// Send emails straight away (service call is asynchronous)
			if (notificationObj.notificationType === NOTIFICATION_TYPES.rightAway) {
				promisesArr.push(
					payrollWorker.payrollMailP60s(
						$ctrl.formOptions.agencyProfileId,
						notificationObj.taxYear.TaxYear
					)
				);
			}

			else {

				if ($ctrl.formOptions.company.CompanyType === INTERFACE_TYPES.bureau) {
					promisesArr.push(
						companyData.updateParentScheduledP60NotificationDate(
							$ctrl.formOptions.agencyProfileId,
							notificationObj.taxYear.ScheduledP60Notification.ScheduledP60NotificationID,
							notificationObj.notificationDateIso,
							$ctrl.overwriteChildCompaniesSettings
						)
					);
				}
				else {
					promisesArr.push(
						companyData.updateScheduledP60NotificationDate(
							$ctrl.formOptions.agencyProfileId,
							notificationObj.taxYear.ScheduledP60Notification.ScheduledP60NotificationID,
							notificationObj.notificationDateIso
						)
					);
				}

			}
		}

		return promisesArr;
	}

	function getUnscheduledTaxYears (p60NotificationSettingsObj) {
		return p60NotificationSettingsObj.TaxYearSchedule
				.filter(
					taxYearObj =>
						!taxYearObj.HasScheduledP60Notification &&
						taxYearObj.CanAddScheduledP60Notification
				);
	}

	function getNotificationTypeForScheduledNotification (notificationObj) {

		if (!notificationObj.ScheduledP60Notification.NotificationDateISO) {

			if (notificationObj.ScheduledP60Notification.CanManuallySendNow) {
				return NOTIFICATION_TYPES.rightAway;
			}

			return NOTIFICATION_TYPES.onFinalPayRun;
		}

		return NOTIFICATION_TYPES.custom;
	}

	function getNotificationObjectFromExistingNotification (existingNotificationObj) {

		const emptyNotificationObj = getEmptyNotificationObject();

		// Add tax year and existing details to notification
		angular.extend(emptyNotificationObj, {
			notificationDateIso: existingNotificationObj.ScheduledP60Notification.NotificationDateISO,
			notificationType: getNotificationTypeForScheduledNotification(existingNotificationObj),
			taxYear: existingNotificationObj,
			isBureauInherited: existingNotificationObj.ScheduledP60Notification.IsBureauInherited
		});

		return emptyNotificationObj;
	}

	function getScheduledNotifications (p60NotificationSettingsObj) {

		// Get notifications that haven't been sent yet
		const scheduledNotificationsArr = p60NotificationSettingsObj.TaxYearSchedule
											.filter(taxYearObj =>
												taxYearObj.HasScheduledP60Notification &&
												!taxYearObj.ScheduledP60Notification.P60sSent
											);

		for (let scheduledNotificationObj of scheduledNotificationsArr) {

			const notificationObj = getNotificationObjectFromExistingNotification(scheduledNotificationObj);

			updateScheduledNotificationsList(notificationObj);
		}
	}

	function getSentNotifications (p60NotificationSettingsObj) {

		// Get notifications that have been sent
		const returnArr = [];
		const sentNotificationsArr = p60NotificationSettingsObj.TaxYearSchedule
											.filter(taxYearObj =>
												taxYearObj.HasScheduledP60Notification &&
												taxYearObj.ScheduledP60Notification.P60sSent
											);

		for (let sentNotifications of sentNotificationsArr) {

			const notificationObj = getNotificationObjectFromExistingNotification(sentNotifications);

			returnArr.push(notificationObj);
		}

		return returnArr;
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function onNotificationCancel (notificationObj, $index) {

		if (notificationObj.isExistingNotification) {

			// Restore backup
			$ctrl.scheduledNotifications[$index] = angular.copy(notificationObj.backupStorage);

			// Clear backup
			$ctrl.scheduledNotifications[$index].backupStorage = {};

			// Hide inputs
			$ctrl.scheduledNotifications[$index].isInEditMode = false;

			// Remove from update changeset
			deleteNotificationFromChangeset(notificationObj, $ctrl.changeSet.update);
		}
		else {

			// Remove from create changeset
			deleteNotificationFromChangeset(notificationObj, $ctrl.changeSet.create);

			// Remove from list
			$ctrl.scheduledNotifications.splice($index, 1);
		}

		setFormAsChanged();
	}

	function onFormSubmit ($form) {

		$form.state = 'saving';

		// Get all create, update and delete promises for notifications
		const notificationChangePromises = getNotificationChangePromisesFromChangeSet();

		// If there hasn't been an update then go straight to saved state
		if (notificationChangePromises.length === 0) {
			setFormState('saved');
			return;
		}

		$q.all(notificationChangePromises)
			.then(() => {

				$ctrl.formOptions.forceCallback();

				setFormState('saved');
			})
			.catch(onError);
	}

	function onNotificationDelete (notificationObj) {

		// Add notification to delete changeset to delete on save
		$ctrl.changeSet.delete.push(notificationObj);


		notificationObj.isDeleted = true;

		setFormAsChanged();
	}

	function onNotificationEdit (notificationObj) {

		// Store copy of notification to restore back later
		notificationObj.backupStorage = angular.copy(notificationObj);

		// Show inputs
		notificationObj.isInEditMode = true;

		// Add notification to list to update changeset
		$ctrl.changeSet.update.push(notificationObj);

		setFormAsChanged();
	}

	function onScheduleP60Notifications () {

		const emptyNotificationObj = getEmptyNotificationObject();

		// Set defaults
		angular.extend(emptyNotificationObj, {
			isExistingNotification: false,
			isInEditMode: true
		});

		// Add notification to list to create changeset as it doesn't exist yet
		$ctrl.changeSet.create.push(emptyNotificationObj);

		updateScheduledNotificationsList(emptyNotificationObj);

		setFormAsChanged();
	}

	function onNotificationOverride (notificationObj) {

		// Store copy of notification to restore back later
		notificationObj.backupStorage = angular.copy(notificationObj);

		// Show inputs
		notificationObj.isInEditMode = true;

		// Add notification to list to update changeset
		$ctrl.changeSet.create.push(notificationObj);

		setFormAsChanged();
	}

	function setFormAsChanged () {
		$ctrl.hasFormChanged = true;
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	function updateScheduledNotificationsList (notificationObj) {
		$ctrl.scheduledNotifications.push(notificationObj);
	}

	function showDeleteOption () {

		return $ctrl.formOptions.company.CompanyType === INTERFACE_TYPES.bureau &&
			($ctrl.changeSet.create.length > 0 || $ctrl.changeSet.update.length > 0 || $ctrl.changeSet.delete.length > 0);
	}

	function hideOverriddenNotificationElements(isBureauInherited) {

		return $ctrl.formOptions.company.CompanyType === $ctrl.INTERFACE_TYPES.bureau || ( $ctrl.formOptions.company.CompanyType !== $ctrl.INTERFACE_TYPES.bureau && !isBureauInherited);
	}

	function onNotificationCancelDelete (notificationObj) {

		const notificationIndex = $ctrl.changeSet.delete.findIndex(deletedScheduleObj => deletedScheduleObj.id === notificationObj.id);

		// Remove from changeset
		$ctrl.changeSet.delete.splice(notificationIndex, 1);

		notificationObj.isDeleted = false;
	}

	angular.extend($ctrl, {
		overwriteChildCompaniesSettings : false,

		$onInit,

		hideOverriddenNotificationElements,
		onFormSubmit,
		onNotificationCancel,
		onNotificationCancelDelete,
		onNotificationDelete,
		onNotificationEdit,
		onNotificationOverride,
		onScheduleP60Notifications,
		showDeleteOption,

		INTERFACE_TYPES,
		NOTIFICATION_TYPES
	});
}])

.filter('companySettingsP60RemoveUsedTaxYears', function () {

	return function (
		taxYearsArr,
		notificationsArr,
		currentValue
	) {

		// Returns array of TaxYears - Filtering out IDs that appear in existing notifications more than once, unless ID is the current value

		function getUsedTaxYears () {

			const returnArr = [];

			for (let notificationObj of notificationsArr) {

				// Initial value is null, don't include that in this array
				if (notificationObj.taxYear) {
					returnArr.push(notificationObj.taxYear.TaxYear);
				}
			}

			return returnArr;
		}

		function getApplicableTaxYears () {

			function filterOutUsedTaxYears (taxYearObj) {

				// Can only select the Tax Year onnce
				const isTaxYearIsNotAlreadyUsed = !usedTaxYearsArr.includes(taxYearObj.TaxYear);

				// Keep the current value in the array as it would be removed from the dropdown otherwise
				const isTaxYearCurrentValue = taxYearObj.TaxYear === currentValue;

				return isTaxYearIsNotAlreadyUsed || isTaxYearCurrentValue;
			}

			const usedTaxYearsArr = getUsedTaxYears();

			return taxYearsArr.filter(filterOutUsedTaxYears);
		}

		return getApplicableTaxYears();
	};
});


'use strict';

angular.module('paycircleApp')

.directive('companySettingsPayDashboardForm', function () {

	return {
		controller: 'companySettingsPayDashboardFormCtrl',
		templateUrl: 'forms/admin/companySettings/paydashboard/companySettingsPayDashboardForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsPayDashboardFormCtrl', ['$scope', 'companyData', function ($scope, companyData) {

	const agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {
		setPageState('loading');

		// Get company info
		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then((companyInformationObj) => {

			$scope.agencyProfileCompanyInformation = companyInformationObj;
			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyProfileIsPayDashboardEnabled (form) {

		form.state = 'saving';

		// Update company settings
		companyData.updateAgencyProfileIsPayDashboardEnabled(agencyProfileId, $scope.agencyProfileCompanyInformation.IsPayDashboardEnabled).then(() => {
			// Callback and close form
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			form.state = null;
		});
	}

	angular.extend($scope, {
		updateAgencyProfileIsPayDashboardEnabled: updateAgencyProfileIsPayDashboardEnabled
	});

	init();
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsPayrollAutoForm', function () {

	return {
		controller: 'companySettingsPayrollAutoFormCtrl',
		templateUrl: 'forms/admin/companySettings/payroll-settings/company-settings-payroll-auto.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsPayrollAutoFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'companyData',
	'companyService',
	'payrollData',
	'reportData',
	'userData',
	'CONTACT_EXTERNAL_CATEGORIES',
	function (
		$q,
		$rootScope,
		$scope,
		companyData,
		companyService,
		payrollData,
		reportData,
		userData,
		CONTACT_EXTERNAL_CATEGORIES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getAgencyEmployerAutoRun = companyData.getAgencyEmployerAutoRun(agencyProfileId);
		const getPayrollReportsMailReportTemplateCollection = reportData.getPayrollReportsMailReportTemplateCollection(agencyProfileId);

		$q.all([
			getPayPeriodCurrent,
			getAgencyEmployerAutoRun,
			getPayrollReportsMailReportTemplateCollection
		]).then(([
			payPeriodObj,
			isAutoRun,
			reportCollectionObj
		]) => {

			$scope.vm = {
				autoSendPayrollEmailsEnabled: reportCollectionObj.ReportTemplateCollectionEntries.length > 0,
				currentPayPeriod: payPeriodObj,
				email: companyService.getEmailRecipientsArrays(),
				isAutoRun,
				isAutoRunOriginal: isAutoRun,
				passwordProtectionEnabled: reportCollectionObj.ReportTemplateCollectionPassword !== '',
				reportCollection: reportCollectionObj,
				showPassword: false
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onSendPayrollEmailsChange (vmObj) {

		if (!vmObj.autoSendPayrollEmailsEnabled) {
			vmObj.reportCollection.ReportTemplateCollectionEntries = [];
		}
	}

	function saveForm (vmObj, form) {

		form.state = 'saving';

		if (!vmObj.passwordProtectionEnabled) {
			vmObj.reportCollection.ReportTemplateCollectionPassword = '';
		}

		const updateReportTemplateCollection = reportData.updateReportTemplateCollection(agencyProfileId, vmObj.reportCollection);
		const updateAgencyEmployerAutoRun = companyData.updateAgencyEmployerAutoRun(agencyProfileId, vmObj.isAutoRun);
		const updateTeamMemberContactsExternalPayrollMailNew = vmObj.email.contactsExternalNew.length > 0 ? userData.updateTeamMemberContactsExternalPayrollMail(agencyProfileId, vmObj.email.contactsExternalNew, false) : null;
		const updateTeamMemberContactsExternalPayrollMailRemove = vmObj.email.contactsExternalOld.length > 0 ? userData.updateTeamMemberContactsExternalPayrollMail(agencyProfileId, vmObj.email.contactsExternalOld, true) : null;

		$q.all([
			updateAgencyEmployerAutoRun,
			updateTeamMemberContactsExternalPayrollMailNew,
			updateTeamMemberContactsExternalPayrollMailRemove,
			updateReportTemplateCollection
		]).then(() => {

			if (vmObj.isAutoRun) {
				$rootScope.setDemoTaskAsComplete('switchToAutoRun');
			}

			// Reload company to update IsAutoRun flag
			if (vmObj.isAutoRunOriginal !== vmObj.isAutoRun) {
				$rootScope.$broadcast('set-current-company', agencyProfileId, () => {
					$scope.formOptions.forceCallback();
					$scope.formOptions.closeForm();
				});
			}
			else {
				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();
			}

			form.state = 'saved';
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function togglePasswordVisibility (vmObj) {
		vmObj.showPassword = !vmObj.showPassword;
	}

	init();

	angular.extend($scope, {
		CONTACT_EXTERNAL_CATEGORIES,

		onSendPayrollEmailsChange,
		saveForm,
		togglePasswordVisibility
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsPayrollSettingsForm', function () {

	return {
		controller: 'companySettingsPayrollSettingsFormCtrl',
		templateUrl: 'forms/admin/companySettings/payroll-settings/company-settings-payroll-settings.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsPayrollSettingsFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'companyData',
	'growl',
	'onboardingService',
	'payPeriodSetupService',
	'payrollData',
	'teamData',
	'COMPANY_STATES',
	'PAY_PERIOD_SETUP_TYPES',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		companyData,
		growl,
		onboardingService,
		payPeriodSetupService,
		payrollData,
		teamData,
		COMPANY_STATES,
		PAY_PERIOD_SETUP_TYPES,
		SUBMISSION_STATES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentCompanyObj = $rootScope.currentCompany;
	const questionGroupObj = $scope.formOptions.questionGroup;

	function canUpdatePeriods (periodDetailsObj) {

		if (!currentCompanyObj.IsPayslipManagerActive && periodDetailsObj.showChangeWarning) {

			if (!periodDetailsObj.hasAgreedTerms) {
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	function decrementPayPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.payPeriodIndex === periodDetailsObj.payPeriodIndexMin) {
			return;
		}

		periodDetailsObj.payPeriodIndex--;
	}

	function generateTimeline (periodDetailsObj) {

		setupPayPeriodControls(periodDetailsObj);
		periodDetailsObj.isTimelineVisible = true;
	}

	function incrementPayPeriodIndex (periodDetailsObj) {

		if (periodDetailsObj.payPeriodIndex === periodDetailsObj.payPeriodIndexMax) {
			return;
		}

		periodDetailsObj.payPeriodIndex++;
	}

	function goToConfirmStep (form) {
		
		// If the user has agreed to the terms, we show an extra confirmation dialog
		if (form.$valid && canUpdatePeriods($scope.vm.periodDetails)) {
			setPageState('confirm-skip-tax-period');
		}
	}

	function init () {

		setPageState('loading');

		const getPayPeriodDetails2 = companyData.getPayPeriodDetails2(agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getPayPeriodCounts = companyData.getPayPeriodCountsForSettingsView(agencyProfileId);

		$q.all([
			getPayPeriodDetails2,
			getPayPeriodCurrent,
			getPayPeriodCounts
		]).then(([
			periodDetailsObj,
			currentPeriodObj,
			payPeriodCountsObj
		]) => {

			// Decorate
			angular.extend(periodDetailsObj, {
				hasAgreedTerms: false,
				hasActivePeriodChanged: false,
				havePeriodDatesChanged: false,
				showReferencePeriodsWarning: false,
				hasRun: $scope.formOptions.company.HasRunPayroll,
				isTimelineVisible: false,
				showChangeWarning: false
			});

			$scope.vm = {
				periodDetails: periodDetailsObj,
				currentPayPeriod: currentPeriodObj,
				payPeriodCounts: payPeriodCountsObj
			};

			// Period in rollback
			if (currentPeriodObj.IsRollback || currentPeriodObj.PayrollState !== SUBMISSION_STATES.unsubmitted) {
				setPageState('cant-change-settings');
				return;
			}

			// Team members set to 'Advancing' or 'Advanced'
			if (payPeriodCountsObj.NumberOfTeamMembersAdvancingPeriods > 0 || payPeriodCountsObj.NumberOfTeamMembersAdvancedPeriods > 0) {
				setPageState('team-members-advancing');
				return;
			}

			setupPeriodDetailsWatcher($scope.vm, periodDetailsObj);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setupPeriodDetailsWatcher (vmObj, periodDetailsObj) {

		function showChangeWarning (vmObj) {
			return vmObj.periodDetails.hasActivePeriodChanged ||
				   vmObj.periodDetails.havePeriodDatesChanged ||
				   vmObj.periodDetails.showReferencePeriodsWarning;
		}

		/* Watch all of those things that, if changed, should show a warning. These are the attributes of the pay period
		   details object attached to the vm of the current $scope */
		const payPeriodWatchAttributes = `[
			vm.periodDetails.PayPeriodType,
			vm.periodDetails.PeriodStartDateISO,
			vm.periodDetails.PeriodStartDate2ISO,
			vm.periodDetails.PeriodStartDate3ISO,
			vm.periodDetails.PeriodStartDate4ISO
		]`;
		// Create array for comparison. The elements here must correspond exactly to the watch attributes above.
		const originalPeriodDetails = [
			periodDetailsObj.PayPeriodType,
			periodDetailsObj.PeriodStartDateISO,
			periodDetailsObj.PeriodStartDate2ISO,
			periodDetailsObj.PeriodStartDate3ISO,
			periodDetailsObj.PeriodStartDate4ISO
		];
		$scope.$watch(payPeriodWatchAttributes, (updatedPeriodDetails) => {
			vmObj.periodDetails.havePeriodDatesChanged = !angular.equals(originalPeriodDetails, updatedPeriodDetails);
			// Update overall warning flag
			vmObj.periodDetails.showChangeWarning = showChangeWarning(vmObj);
		});

		// Warning if ActivePeriodQBA has changed
		const originalActivePeriodQBA = periodDetailsObj.ActivePeriodQBA;
		$scope.$watch('vm.periodDetails.ActivePeriodQBA', function (newActivePeriodQBA) {
			vmObj.periodDetails.hasActivePeriodChanged = newActivePeriodQBA !== originalActivePeriodQBA;
			// Update overall warning flag
			vmObj.periodDetails.showChangeWarning = showChangeWarning(vmObj);
		});

		// Warning if PayDate has changed and period type is monthly (for Rotaready reference periods)
		if ($rootScope.currentCompany.IsRotareadyIntegrationEnabled) {

			const originalPayPeriodPaymentDay = periodDetailsObj.PayPeriodPaymentDay;
			$scope.$watch(`[vm.periodDetails.PayPeriodPaymentDay, vm.periodDetails.PayPeriodType]`, ([newPayPeriodPaymentDay, newPayPeriodType]) => {

				// Show Rotaready reference period warning if PayPeriodPaymentDay has changed and PayPeriodType is monthly
				vmObj.periodDetails.showReferencePeriodsWarning = newPayPeriodPaymentDay !== originalPayPeriodPaymentDay && newPayPeriodType === PAY_PERIOD_SETUP_TYPES.monthly;
				// Update overall warning flag
				vmObj.periodDetails.showChangeWarning = showChangeWarning(vmObj);
			});
		}
	}

	function showOnlyReferencePeriodsWarning (vmObj) {

		return vmObj.periodDetails.showReferencePeriodsWarning && !vmObj.periodDetails.hasActivePeriodChanged && !vmObj.periodDetails.havePeriodDatesChanged;
	}

	function setupPayPeriodControls (periodDetailsObj) {

		if (angular.isUndefined(periodDetailsObj.payPeriods)) {
			return;
		}

		periodDetailsObj.payPeriodIndex = 0;
		periodDetailsObj.payPeriodIndexMax = periodDetailsObj.payPeriods.length - 1;
		periodDetailsObj.payPeriodIndexMin = 0;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleIsTimelineVisible (periodDetailsObj) {

		setupPayPeriodControls(periodDetailsObj);
		periodDetailsObj.isTimelineVisible = !periodDetailsObj.isTimelineVisible;
	}

	function updatePayPeriodsSettings (periodDetailsObj, form, periodSkipConfirmed) {

		form.state = 'saving';

		periodDetailsObj.PeriodSkipConfirmed = periodSkipConfirmed;
		periodDetailsObj = payPeriodSetupService.reviewPayPeriodDetails(periodDetailsObj);
		
		companyData.createAgencyPayPeriods2(agencyProfileId, periodDetailsObj).then((response) => {

			// If the backend signals a skipped period needs confirmation (-2),
			// switch to the confirmation step and reset the form state.
			// No data is saved at this point; user action is required to proceed.
			if (response === -2) {	
				setPageState('confirm-skip-tax-period');
				form.state = 'ready';
				return;
			}

			// Rotaready enabled > Process pending events
			if ($rootScope.currentCompany.IsRotareadyIntegrationEnabled) {
				teamData.processPendingAccessRotareadyEvents(agencyProfileId).catch(onError);
			}

			// Onboarding only > Must update before wizard intercepts
			if (questionGroupObj !== undefined) {

				const updatedQuestionsArr = onboardingService.setQuestionsCompleteForPayrollQuestionKeys(questionGroupObj.Questions, ['payPeriods']);

				// Update onboarding questions
				companyData.updateOnboardingQuestions(updatedQuestionsArr).catch(onError);
			}

			// Wizard
			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			growl.success('Payroll settings have been saved');
			$rootScope.setDemoTaskAsComplete('changePayrollProcessingDate');

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');
			// Refresh the company name
			$rootScope.$broadcast('set-current-company', agencyProfileId);
		})

		// Null response defines validation error. See https://www.notion.so/paycircle/c209265ee74e43d8b18157678abf3b2f?v=919a1d2d54df4d108f44e18af6d6a14e&p=0e6d6cb888a54c3fbe263eca3fe1f679
		.catch(() => {
			setPageState('validation-error');
		});
	}

	init();

	angular.extend($scope, {
		COMPANY_STATES,
		SUBMISSION_STATES,
		canUpdatePeriods,
		decrementPayPeriodIndex,
		generateTimeline,
		goToConfirmStep,
		showOnlyReferencePeriodsWarning,
		incrementPayPeriodIndex,
		setPageState,
		toggleIsTimelineVisible,
		updatePayPeriodsSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPayslipAdditionalNoteForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsPayslipAdditionalNoteFormCtrl',
	templateUrl: 'forms/admin/companySettings/payslip-additional-note/company-settings-payslip-additional-note.form.html'
})

.controller('companySettingsPayslipAdditionalNoteFormCtrl', [
	'companyData',
	'growl',
	'payslipService',
	'PAYSLIP_ADDITIONAL_NOTE_VISIBLE',
	function (
		companyData,
		growl,
		payslipService,
		PAYSLIP_ADDITIONAL_NOTE_VISIBLE
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			isPayslipAdditionalNoteVisible: payslipService.getAdditionalNoteVisibilityBoolFromEnum($ctrl.formOptions.company.PayslipAdditionalNoteVisible)
		});
	}

	function getAdditionalNoteVisibilityEnumFromBool (payslipAdditionalNoteVisibleBool) {

		if (payslipAdditionalNoteVisibleBool) {
			return PAYSLIP_ADDITIONAL_NOTE_VISIBLE.all;
		}
		else {
			return PAYSLIP_ADDITIONAL_NOTE_VISIBLE.none;
		}
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	function updateAgencyProfilePayslipAdditionalNoticeVisible ($form) {

		$form.state = 'saving';

		const additionalNoteVisibleEnum = getAdditionalNoteVisibilityEnumFromBool($ctrl.isPayslipAdditionalNoteVisible);

		companyData.updateAgencyProfilePayslipAdditionalNoticeVisible($ctrl.formOptions.agencyProfileId, additionalNoteVisibleEnum)
			.then(() => {
				$ctrl.formOptions.closeForm();
				$ctrl.formOptions.forceCallback();
				growl.success('Display Healthcare Levy setting saved.');
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateAgencyProfilePayslipAdditionalNoticeVisible,

		formState: 'ready'
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPayslipDisplayPeriodForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsPayslipDisplayPeriodFormCtrl',
	templateUrl: 'forms/admin/companySettings/payslip-display-period/company-settings-payslip-display-period.form.html'
})

.controller('companySettingsPayslipDisplayPeriodFormCtrl', [
	'companyData',
	'growl',
	'payslipService',
	'PAYSLIP_PERIOD_VISIBLE',
	function (
		companyData,
		growl,
		payslipService,
		PAYSLIP_PERIOD_VISIBLE
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			isPayslipPeriodVisible: payslipService.getPeriodVisiblityBoolFromEnum($ctrl.formOptions.company.PayslipPeriodVisible)
		});
	}

	function getPeriodVisibilityEnumFromBool (payslipPeriodVisibleBool) {

		if (payslipPeriodVisibleBool) {
			return PAYSLIP_PERIOD_VISIBLE.all;
		}
		else {
			return PAYSLIP_PERIOD_VISIBLE.none;
		}
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	function updateAgencyProfilePayslipPeriodVisible ($form) {

		$form.state = 'saving';

		const payslipPeriodVisibleEnum = getPeriodVisibilityEnumFromBool($ctrl.isPayslipPeriodVisible);

		companyData.updateAgencyProfilePayslipPeriodVisible($ctrl.formOptions.agencyProfileId, payslipPeriodVisibleEnum)
			.then(() => {
				$ctrl.formOptions.closeForm();
				$ctrl.formOptions.forceCallback();
				growl.success('Display pay period setting saved.');
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateAgencyProfilePayslipPeriodVisible,

		formState: 'ready'
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPdfDownloadSortingForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pdfDownloadSortingFormCtrl',
	templateUrl: 'forms/admin/companySettings/pdf-download-sorting/company-settings-pdf-download-sorting.form.html'
})

.controller('pdfDownloadSortingFormCtrl', [
	'BUSINESS_CATEGORY_SORT_BY_OPTIONS',
	'PAYSLIP_SORT_BY_OPTIONS',
	'companyData',
	function (
		BUSINESS_CATEGORY_SORT_BY_OPTIONS,
		PAYSLIP_SORT_BY_OPTIONS,
		companyData
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		companyData.getAgencyProfileCompanyDetails($ctrl.formOptions.agencyProfileId).then(companyDetailsObj => {

			angular.extend($ctrl, {
				businessCategorySortByOptionDepartmentId: getBusinessCategorySortByOptionDepartmentId(),
				companyDetails: companyDetailsObj,
				isBusinessCategorySortingEnabled: getIsBusinessCategorySortingEnabled(companyDetailsObj)
			});

			setFormState('ready');
		})
		.catch(onError);
	}

	function getBusinessCategorySortByOptionDepartmentId () {

		const businessCategorySortByOptionObj = BUSINESS_CATEGORY_SORT_BY_OPTIONS.find(sortByOption => sortByOption.key === 'department');

		if (!angular.isObject(businessCategorySortByOptionObj)) {
			throw('getBusinessCategorySortByOptionDepartmentId: Unable to match sort by key');
		}

		return businessCategorySortByOptionObj.id;
	}

	/**
	 * PdfPayslipBusinessCategorySorting ENUM - Set to 0 for it to be disabled
	**/
	function getIsBusinessCategorySortingEnabled (companyDetailsObj) {

		return companyDetailsObj.PdfPayslipBusinessCategorySorting > 0;
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function onBusinessCategorySortingEnabledToggled () {

		// Set to first option
		if ($ctrl.isBusinessCategorySortingEnabled) {
			$ctrl.companyDetails.PdfPayslipBusinessCategorySorting = 1;
		}

		// Set to 'None'
		else {
			$ctrl.companyDetails.PdfPayslipBusinessCategorySorting = 0;
		}
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function updateAgencyProfilePdfPayslipSorting (formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyProfilePdfPayslipSorting($ctrl.formOptions.agencyProfileId, $ctrl.companyDetails.PdfPayslipBusinessCategorySorting, $ctrl.companyDetails.PdfPayslipTeamMemberSorting).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		BUSINESS_CATEGORY_SORT_BY_OPTIONS,
		PAYSLIP_SORT_BY_OPTIONS,
		$onInit,
		onBusinessCategorySortingEnabledToggled,
		updateAgencyProfilePdfPayslipSorting
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPensionCommunicationsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsPensionCommunicationsFormCtrl',
	templateUrl: 'forms/admin/companySettings/pension-communications/company-settings-pension-communications.form.html'
})

.controller('companySettingsPensionCommunicationsFormCtrl', [
	'companyData',
	'growl',
	'PLACEHOLDERS',
	function (
		companyData,
		growl,
		PLACEHOLDERS
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfilePensionSettings($ctrl.formOptions.agencyProfileId)
			.then(pensionSettingsObj => {

				$ctrl.pensionSettings = pensionSettingsObj;

				setComponentState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function updateAgencyProfilePensionCommunicationSettings ($ctrl, formObj) {

		formObj.state = 'saving';

		// Clear email if not enabled
		if (!$ctrl.pensionSettings.Communications.UseDefaultPensionRecipientEmail) {
			$ctrl.pensionSettings.Communications.DefaultPensionRecipientEmail = '';
		}

		companyData.updateAgencyProfilePensionCommunicationSettings($ctrl.formOptions.agencyProfileId, $ctrl.pensionSettings.Communications)
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				growl.success('Pension settings have been saved');

				formObj.state = 'saved';
			})
			.catch(onError);
		}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		PLACEHOLDERS,

		updateAgencyProfilePensionCommunicationSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPensionSubmissionsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsPensionSubmissionsFormCtrl',
	templateUrl: 'forms/admin/companySettings/pension-submissions/company-settings-pension-submissions.form.html'
})

.controller('companySettingsPensionSubmissionsFormCtrl', [
	'companyData',
	function (
		companyData
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfilePensionSettings($ctrl.formOptions.agencyProfileId).then(pensionSettingsObj => {

			angular.extend($ctrl, {
				pensionSettings: pensionSettingsObj
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function updateAgencyProfilePensionSubmissionSettings ($ctrl, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyProfilePensionSubmissionSettings($ctrl.formOptions.agencyProfileId, $ctrl.pensionSettings.Submissions).then(responseState => {

			switch (responseState) {

				// Outstanding submission
				case -2: {
					setComponentState('outstanding-submission');
					break;		
				}

				default: {

					$ctrl.formOptions.forceCallback();
					$ctrl.formOptions.closeForm();

					formObj.state = 'saved';
				}
			}
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		updateAgencyProfilePensionSubmissionSettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsPensionSupRunsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsPensionSupRunsFormCtrl',
	templateUrl: 'forms/admin/companySettings/pension-sup-runs/company-settings-pension-sup-runs.form.html'
})

.controller('companySettingsPensionSupRunsFormCtrl', [
	'companyData',
	function (
		companyData
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfilePensionSettings($ctrl.formOptions.agencyProfileId).then(pensionSettingsObj => {

			angular.extend($ctrl, {
				pensionSettings: pensionSettingsObj
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function updateAgencyProfilePensionSupplementaryPaySettings ($ctrl, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyProfilePensionSupplementaryPaySettings($ctrl.formOptions.agencyProfileId, $ctrl.pensionSettings.SupplementaryPay).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		updateAgencyProfilePensionSupplementaryPaySettings
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsPeriodDisplayTitleForm', function () {

	return {
		controller: 'companySettingsPeriodDisplayTitleFormCtrl',
		templateUrl: 'forms/admin/companySettings/period-display-title/companySettingsPeriodDisplayTitleForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsPeriodDisplayTitleFormCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'growl',
	'payrollData',
function (
	$filter,
	$rootScope,
	$scope,
	growl,
	payrollData
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentCompanyObj = $scope.formOptions.company;

	const MONTHLY_DISPLAY_FORMATS = {
		periodStart: 0,
		range: 1,
		periodEnd: 2
	};

	function getDisplayOptions (currentPeriodObj) {

		const displayOptionsArr = [
			{
				description: $filter('dateformat')(currentPeriodObj.StartDateISO, 'monthYear'),
				// Available if payroll hasn't been run, or if it has, if the current option isn't period end
				enabled: !currentCompanyObj.HasRunPayroll || currentCompanyObj.MonthlyDisplayFormat !== MONTHLY_DISPLAY_FORMATS.periodEnd,
				value: MONTHLY_DISPLAY_FORMATS.periodStart
			},
			{
				description: `${$filter('dateformat')(currentPeriodObj.StartDateISO, 'custom', 'Do MMM')} – ${$filter('dateformat')(currentPeriodObj.EndDateISO, 'custom', 'Do MMM YYYY')}`,
				enabled: true,
				value: MONTHLY_DISPLAY_FORMATS.range
			},
		];

		// Show option for end period if EndDateISO is in different month to StartDateISO
		if (!moment(currentPeriodObj.StartDateISO).isSame(currentPeriodObj.EndDateISO, 'month')) {
			displayOptionsArr.push({
				description: $filter('dateformat')(currentPeriodObj.EndDateISO, 'monthYear'),
				// Available if payroll hasn't been run, or if it has, if the current option isn't period start
				enabled: !currentCompanyObj.HasRunPayroll || currentCompanyObj.MonthlyDisplayFormat !== MONTHLY_DISPLAY_FORMATS.periodStart,
				value: MONTHLY_DISPLAY_FORMATS.periodEnd
			});
		}

		return displayOptionsArr;
	}

	function getInitialPayPeriodDisplay (currentCompanyObj, periodDisplayOptionsArr) {
		return periodDisplayOptionsArr.find(periodDisplayOptionObj => periodDisplayOptionObj.value === currentCompanyObj.MonthlyDisplayFormat).description;
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId)
			.then(currentPeriodObj => {

				const periodDisplayOptionsArr = getDisplayOptions(currentPeriodObj);

				// Set default value for companies
				if (currentCompanyObj.MonthlyDisplayFormat === -1) {
					currentCompanyObj.MonthlyDisplayFormat = MONTHLY_DISPLAY_FORMATS.periodStart;
				}

				$scope.vm = {
					company: currentCompanyObj,
					currentPeriod: currentPeriodObj,
					isTimelineVisible: false,
					payPeriodDisplay: getInitialPayPeriodDisplay(currentCompanyObj, periodDisplayOptionsArr),
					periodDisplayOptions: periodDisplayOptionsArr
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onPeriodDisplayTitleChange (vmObj, periodDisplayOptionObj) {
		vmObj.payPeriodDisplay = periodDisplayOptionObj.description;
	}

	function onError (errorMessage) {
		console.error(errorMessage);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleIsTimelineVisible (vmObj) {
		vmObj.isTimelineVisible = !vmObj.isTimelineVisible;
	}

	function updateCompanyMonthlyDisplayFormat (vmObj, formObj) {

		formObj.state = 'saving';

		payrollData.updateCompanyMonthlyDisplayFormat(agencyProfileId, vmObj.company.MonthlyDisplayFormat)
			.then(() => {

				growl.success('Period display title updated');

				// Update app header
				$rootScope.$broadcast('reset-current-period');

				$scope.formOptions.closeForm();
				$scope.formOptions.forceCallback();
			})
			.catch(onError);
	}

	init();

	angular.extend($scope, {
		onPeriodDisplayTitleChange,
		toggleIsTimelineVisible,
		updateCompanyMonthlyDisplayFormat
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsReferencesForm', function () {

	return {
		controller: 'companySettingsReferencesFormCtrl',
		templateUrl: 'forms/admin/companySettings/references/companySettingsReferencesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsReferencesFormCtrl', ['$scope', '$timeout', 'companyData', 'dataImportData', 'growl', 'session', function ($scope, $timeout, companyData, dataImportData, growl, session) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var isInPlayground = session.isInPlayground();

	function decorateCompanyObj (companyObj) {

		// If DPSImport is set to true we presume the HMRC credentials have been validated
		companyObj.Employer.areHmrcCredentialsEditable = angular.copy(!companyObj.Employer.DPSImport);
		companyObj.Employer.areHmrcCredentialsValid = angular.copy(companyObj.Employer.DPSImport);

		return companyObj;
	}

	function editHMRCCredentials (employerObj) {

		employerObj.areHmrcCredentialsEditable = true;
		employerObj.areHmrcCredentialsValid = false;
		employerObj.HMRCUserName = '';
		employerObj.HMRCPassword = '';
	}

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(function (companyObj) {

			$scope.company = decorateCompanyObj(companyObj);
			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function testCredentials (employerObj, form) {

		setPageState('testing-hmrc-credentials');

		// Give user time to digest feedback for testing the HMRC crednetials
		$timeout(function () {

			dataImportData.getAreHMRCCredentialsValid(agencyProfileId, employerObj.HMRCUserName, employerObj.HMRCPassword).then(function (validationState) {

				switch (validationState) {
					case -1:
						setPageState('error');
						break;
					case -2:
						setPageState('hmrc-credentials-invalid');
						break;
					case -3:
						setPageState('automatic-updates-not-enabled');
						break;
					default:
						updateAgencyEmployerReferences(employerObj, form);
				}
			})
			.catch(function () {

				setPageState('hmrc-credentials-invalid');
			});

		}, 3000);
	}


	function updateAgencyEmployerReferences (employerObj, form) {

		// Reset credentials if Electronic updates switched off
		if (!employerObj.DPSImport) {
			employerObj.HMRCUserName = '';
			employerObj.HMRCPassword = '';
		}

		form.state = 'saving';

		// Service call
		companyData.updateAgencyEmployerReferences(employerObj).then(function () {
			
			growl.success('Company references have been saved');
			
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			
			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	}

	init();

	// Scope variables
	$scope.isInPlayground = isInPlayground;

	// Scope functions
	$scope.editHMRCCredentials = function (employerObj) {

		editHMRCCredentials(employerObj);
	};

	$scope.saveCompanyReferences = function (employerObj, form) {

		!employerObj.DPSImport || employerObj.areHmrcCredentialsValid ? updateAgencyEmployerReferences(employerObj, form) : testCredentials(employerObj, form);
	};

	$scope.setPageState = function (pageState) {

		setPageState(pageState);
	};
}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadyEntityCreateAllBusinessCodesForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadyEntityCreateAllBusinessCodesFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-entity-create-all-business-codes/rotaready-entity-create-all-business-codes.form.html'
	})

	.controller('companySettingsRotareadyEntityCreateAllBusinessCodesFormCtrl', [
		'ROTAREADY_ENTITY_NAMING_STRATEGIES',
		function (ROTAREADY_ENTITY_NAMING_STRATEGIES) {

			const $ctrl = this;

			const NAMING_STRATEGIES = ROTAREADY_ENTITY_NAMING_STRATEGIES;

			const PREFIX_STRATEGIES = [
				NAMING_STRATEGIES.PREFIX,
				NAMING_STRATEGIES.PREFIX_AND_CALENDAR
			];

			function $onInit () {

				const businessCategories = $ctrl.formOptions.businessCategories;
				const selectedCategoryID = $ctrl.formOptions.selectedCategoryID;
				const unmappedCount = $ctrl.formOptions.unmappedCount;

				angular.extend($ctrl, {
					businessCategories,
					formObject: {
						businessCategoryId: selectedCategoryID,
						namingStrategy: NAMING_STRATEGIES.ENTITY_NAME,
						prefix: ''
					},
					NAMING_STRATEGIES,
					unmappedCount
				});

				setPageState('ready');
			}

			function isPrefixRequired () {
				return PREFIX_STRATEGIES.indexOf($ctrl.formObject.namingStrategy) !== -1;
			}

			function onSubmit (form) {

				if (form.$invalid) {
					return;
				}

				$ctrl.formOptions.callback({
					BusinessCategoryID: $ctrl.formObject.businessCategoryId,
					namingStrategy: $ctrl.formObject.namingStrategy,
					prefix: isPrefixRequired() ? $ctrl.formObject.prefix : ''
				});

				$ctrl.formOptions.closeForm();
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			angular.extend($ctrl, {
				$onInit,
				isPrefixRequired,
				onSubmit
			});
		}
	]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadyEntityCreateBusinessCodeForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadyEntityCreateBusinessCodeFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-entity-create-business-code/rotaready-entity-create-business-code.form.html'
	})

	.controller('companySettingsRotareadyEntityCreateBusinessCodeFormCtrl', [

		function () {

			const $ctrl = this;

			function $onInit () {

				const businessCategories = $ctrl.formOptions.businessCategories;
				const selectedCategoryID = $ctrl.formOptions.selectedCategoryID;
				const businessCodes = $ctrl.formOptions.businessCodes || [];

				angular.extend($ctrl, {
					businessCategories,
					businessCodes,
					formObject: {
						businessCategoryId: selectedCategoryID,
						businessCodeNarrative: ''
					},
					isDuplicate: false
				});

				setPageState('ready');
			}

			function checkForDuplicate (form) {

				const narrative = ($ctrl.formObject.businessCodeNarrative || '').trim().toLowerCase();
				const selectedCategoryId = $ctrl.formObject.businessCategoryId;

				$ctrl.isDuplicate = narrative.length > 0 && selectedCategoryId && $ctrl.businessCodes.some(function (code) {
					return code.BusinessCategoryID === selectedCategoryId && (code.BusinessCodeNarrative || '').trim().toLowerCase() === narrative;
				});

				if ($ctrl.isDuplicate && selectedCategoryId) {
					const category = $ctrl.businessCategories.find(function (cat) {
						return cat.BusinessCategoryID === selectedCategoryId;
					});
					$ctrl.duplicateCategoryName = category ? category.BusinessCategoryName : 'business category';
				}

				form.businessCodeNarrative.$setValidity('nonUnique', !$ctrl.isDuplicate);
			}

			function onSubmit (form) {

				if (form.$invalid || $ctrl.isDuplicate) {
					return;
				}

				$ctrl.formOptions.callback({
					BusinessCategoryID: $ctrl.formObject.businessCategoryId,
					BusinessCodeNarrative: $ctrl.formObject.businessCodeNarrative
				});

				$ctrl.formOptions.closeForm();
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			angular.extend($ctrl, {
				$onInit,
				checkForDuplicate,
				onSubmit
			});
		}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadyEntitySaveForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadyEntitySaveFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-entity-save-confirmation/rotaready-entity-save-confirmation.form.html'
	})


	.controller('companySettingsRotareadyEntitySaveFormCtrl', [
		'companyData',

		function (
			companyData
		) {

			const $ctrl = this;

			function $onInit() {

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const entityMappingsPending = $ctrl.formOptions.entityMappingsPending;
				const newBusinessCodes = $ctrl.formOptions.newBusinessCodes || [];
				setPageState('ready');

				angular.extend($ctrl, {
					agencyProfileId,
					entityMappingsPending,
					mappingCount: entityMappingsPending.length,
					newBusinessCodes,
				});
			}

			function onError (error) {

				setPageState('error');
				console.error(error);
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			function cancel () {
				$ctrl.formOptions.closeForm();
			}

			function saveCallback () {

				setPageState('saved');
				$ctrl.formOptions.callback();
			}

			function getSuccessMessage () {

				const suffix = $ctrl.mappingCount > 1 ? 's' : '';

				return 'You have successfully mapped ' + $ctrl.mappingCount + ' site' + suffix + '/department' + suffix + '.';
			}

			function saveEntityMappings () {

				setPageState('loading');

				const entityBusinessCodes = $ctrl.entityMappingsPending.map(function (entity) {
					return {
						RotareadyEntityID: entity.RotareadyEntityID,
						BusinessCodeID: entity.BusinessCodeID
					};
				});

				companyData.updateRotareadyEntityBusinessCodes($ctrl.agencyProfileId, entityBusinessCodes, $ctrl.newBusinessCodes).then(saveCallback).catch(onError);
			}

			angular.extend($ctrl, {
				$onInit,
				getSuccessMessage,
				cancel,
				saveEntityMappings
			});
		}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadyEntityUnmatchForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadyEntityUnmatchFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-entity-unmatch-confirmation/rotaready-entity-unmatch-confirmation.form.html',
	})


	.controller('companySettingsRotareadyEntityUnmatchFormCtrl', [
		'companyData',
		'config',

		function (
			companyData,
			config
		) {

			const $ctrl = this;

			function $onInit() {

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const entity = $ctrl.formOptions.entity;
				setPageState('ready');

				angular.extend($ctrl, {
					agencyProfileId,
					entity,
				});
			}

			function onError (error) {

				setPageState('error');
				console.error(error);
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			function cancel () {
				$ctrl.formOptions.closeForm();
			}

			function saveCallback () {

				setPageState('saved');
				$ctrl.formOptions.callback();
			}

			function unmapEntity () {

				setPageState('loading');

				const entityBusinessCodes = [{
					RotareadyEntityID: $ctrl.entity.RotareadyEntityID,
					BusinessCodeID: config.guidEmpty
				}];

				companyData.updateRotareadyEntityBusinessCodes($ctrl.agencyProfileId, entityBusinessCodes).then(saveCallback).catch(onError);
			}

			angular.extend($ctrl, {
				$onInit,
				cancel,
				unmapEntity
			});
		}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadyUnmatchForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadyUnmatchFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-unmatch-confirmation/rotaready-unmatch-confirmation.form.html',
	})


	.controller('companySettingsRotareadyUnmatchFormCtrl', [
		'rotareadyTeamMembersService',

		function (
			rotareadyTeamMembersService
		) {

			const $ctrl = this;

			function $onInit() {

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const teamMember = $ctrl.formOptions.teamMember;
				setPageState('ready');

				angular.extend($ctrl, {
					agencyProfileId,
					teamMember,
				});
			}

			function onError (error) {

				setPageState('error');
				console.error(error);
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			function cancel () {
				$ctrl.formOptions.closeForm();
			}

			function saveCallback () {

				setPageState('saved');
				$ctrl.formOptions.callback();
			}

			function saveTeamMembersChanges ($ctrl) {

				setPageState('loading');
				$ctrl.teamMember.Rotaready = null;
				// Save all changes to the team members
				rotareadyTeamMembersService.saveTeamMembersChanges($ctrl.agencyProfileId, [$ctrl.teamMember], [], saveCallback, onError);
			}

			angular.extend($ctrl, {
				$onInit,
				cancel,
				saveTeamMembersChanges
			});
		}]);

'use strict';

angular.module('paycircleApp')

	.component('companySettingsRotareadySaveForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'companySettingsRotareadySaveFormCtrl',
		templateUrl: 'forms/admin/companySettings/rotaready-save-confirmation/rotaready-save-confirmation.form.html'
	})


	.controller('companySettingsRotareadySaveFormCtrl', [
		'rotareadyTeamMembersService',

		function (
			rotareadyTeamMembersService
		) {

			const $ctrl = this;

			function $onInit() {

				const agencyProfileId = $ctrl.formOptions.agencyProfileId;
				const teamMembersMappings = $ctrl.formOptions.teamMembersMappings;
				const createrotaReadyMembers =  teamMembersMappings.filter(t => !t.Paycircle);
				const rotareadyMembersIds = createrotaReadyMembers.map(t => t.Rotaready.Id);
				setPageState('ready');

				angular.extend($ctrl, {
					agencyProfileId,
					teamMembersMappings,
					rotareadyMembersIds,
					creationCount: createrotaReadyMembers.length,
					matchCount: teamMembersMappings.filter(t=> t.Paycircle).length,
				});
			}

			function onError (error) {

				setPageState('error');
				console.error(error);
			}

			function setPageState (pageState) {
				$ctrl.pageState = pageState;
			}

			function cancel () {
				$ctrl.formOptions.closeForm();
			}

			function saveCallback (createUsersResult) {

				if (createUsersResult && Array.isArray(createUsersResult)) {
					$ctrl.failedUsers = createUsersResult.filter(user => !user.Success);
					$ctrl.usersWithWarnings = createUsersResult.filter(user => user.Success && user.Warnings && user.Warnings.length > 0);
				} else {
					$ctrl.failedUsers = [];
					$ctrl.usersWithWarnings = [];
				}

				if ($ctrl.failedUsers.length > 0) {
					setPageState('saveError');
				} else {
					setPageState('saved');
				}

				$ctrl.formOptions.callback();
			}

			function getSuccessMessage () {

				const creationSuffix = $ctrl.creationCount > 1 ? 's' : '';
				const matchSuffix = $ctrl.matchCount > 1 ? 's' : '';

				if ($ctrl.creationCount > 0 && $ctrl.matchCount > 0) {
					return `You have successfully created ${$ctrl.creationCount} new Rotaready team member${creationSuffix} and matched ${$ctrl.matchCount} existing Paycircle team member${matchSuffix}.`;
				}
				else if ($ctrl.creationCount > 0) {
					return `You have successfully created ${$ctrl.creationCount} new Rotaready team member${creationSuffix}.`;
				}
				else if ($ctrl.matchCount > 0) {
					return `You have successfully matched ${$ctrl.matchCount} existing Paycircle team member${matchSuffix}.`;
				}
				return '';
			}

			function getTitle () {

				if ($ctrl.creationCount > 0 && $ctrl.matchCount > 0) {
					return 'Are you sure you wish to match and create these team members?';
				}
				else if ($ctrl.creationCount > 0) {
					return `Are you sure you wish to create ${$ctrl.creationCount === 1 ? 'this team member' : 'these team members'}?`;
				}
				else if ($ctrl.matchCount > 0) {
					return `Are you sure you wish to match ${$ctrl.matchCount === 1 ? 'this team member' : 'these team members'}?`;
				}
				return '';
			}

			function saveTeamMembersChanges ($ctrl) {

				setPageState('loading');

				// Save all changes to the team members
				rotareadyTeamMembersService.saveTeamMembersChanges($ctrl.agencyProfileId, $ctrl.teamMembersMappings, $ctrl.rotareadyMembersIds, saveCallback, onError);
			}

			angular.extend($ctrl, {
				$onInit,
				getTitle,
				getSuccessMessage,
				cancel,
				saveTeamMembersChanges
			});
		}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsRtiSubmissionsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsRtiSubmissionsFormCtrl',
	templateUrl: 'forms/admin/companySettings/rti-submissions/company-settings-rti-submissions.form.html'
})

.controller('companySettingsRtiSubmissionsFormCtrl', [
	'companyData',
	'growl',
	function (
		companyData,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed($ctrl.formOptions.agencyProfileId)
			.then(companyDetailedObj => {

				$ctrl.isRTISubmissionDisabled = !companyDetailedObj.IsRTISubmissionDisabled;

				setComponentState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function updateAgencyEmployerDisableRTISubmissions ($ctrl, $form) {

		$form.state = 'saving';

		companyData.updateAgencyEmployerDisableRTISubmissions($ctrl.formOptions.agencyProfileId, !$ctrl.isRTISubmissionDisabled)
			.then(() => {
				growl.success('RTI submission settings updated.');
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		updateAgencyEmployerDisableRTISubmissions
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsSickPayDefaultWorkPattern', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsSickPayDefaultWorkPatternFormCtrl',
	templateUrl: 'forms/admin/companySettings/sick-pay-default-work-pattern/company-settings-sick-pay-default-work-pattern.form.html'
})

.controller('companySettingsSickPayDefaultWorkPatternFormCtrl', [
	'companyData',
	'workPatternService',
	function (
		companyData,
		workPatternService
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getAgencyProfileSickPayDefaultWorkDays($ctrl.formOptions.agencyProfileId)
			.then(workDays => {

				$ctrl.workPattern = workPatternService.getWorkPatternFromWorkDays(workDays);

				setComponentState('ready');
			});
	}

	function updateSickPayDefaultWorkDays ($ctrl, $form) {

		$form.state = 'saving';

		const workDays = workPatternService.getWorkDaysFromWorkPattern($ctrl.workPattern);

		companyData.updateAgencyProfileSickPayDefaultWorkDays($ctrl.formOptions.agencyProfileId, workDays)
			.then(() => {
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
			})
			.catch(onError);
	}

	function isWorkPatternValid (workPattern) {
		
		// Check if the work pattern is valid by ensuring at least one day is selected
		return workPattern && workPattern.filter(day => day.value).length > 0;
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		isWorkPatternValid,
		updateSickPayDefaultWorkDays
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companySettingsSicknessProRationMethod', {
	bindings: {
		formOptions: '='
	},
	controller: 'companySettingsSicknessProRationMethodFormCtrl',
	templateUrl: 'forms/admin/companySettings/sickness-pro-ration-method/company-settings-sickness-pro-ration-method.form.html'
})

.controller('companySettingsSicknessProRationMethodFormCtrl', [
	'companyData',
	'PRO_RATION_METHODS',
	function (
		companyData,
		PRO_RATION_METHODS
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		$ctrl.PRO_RATION_METHODS = PRO_RATION_METHODS;

		companyData.getAgencyProfileSicknessProRationMethod($ctrl.formOptions.agencyProfileId)
			.then(proRationSettings => {

				$ctrl.proRationMethod = proRationSettings.ProRationMethod;
				$ctrl.displayLeaveDaysAsSeparateDeduction = proRationSettings.DisplayLeaveDaysAsSeparateDeduction;

				setComponentState('ready');
			})
			.catch(onError);
	}

	function updateSicknessProRationMethod ($ctrl, $form) {

		$form.state = 'saving';

		companyData.updateAgencyProfileSicknessProRationMethod(
			$ctrl.formOptions.agencyProfileId,
			$ctrl.proRationMethod,
			$ctrl.displayLeaveDaysAsSeparateDeduction
		)
			.then(() => {
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
			})
			.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		updateSicknessProRationMethod
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsSkipPayPeriodsForm', function () {

	return {
		controller: 'companySettingsSkipPayPeriodsFormCtrl',
		templateUrl: 'forms/admin/companySettings/skip-pay-periods/companySettingsSkipPayPeriodsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsSkipPayPeriodsFormCtrl', ['$rootScope', '$scope', 'config', 'companyData', function ($rootScope, $scope, config, companyData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriod = $scope.formOptions.payPeriod;

	function decorateInactivtyPeriodDetailsForSkipped (inactivityDetailsObj) {

		inactivityDetailsObj.inactivePeriodExists = inactivityDetailsObj.HasSkippedPeriods;

		return inactivityDetailsObj;
	}

	function inactivePeriodFormSetup () {

		companyData.getAgencyEmployerInactivityDetails(agencyProfileId).then(inactivityDetailsObj => {

			inactivityDetailsObj = decorateInactivtyPeriodDetailsForSkipped(inactivityDetailsObj);

			let vmObj = {
				inactivityDetails: inactivityDetailsObj
			};

			if (!inactivityDetailsObj.inactivePeriodExists) {
				vmObj.firstInactivePeriod = inactivityDetailsObj.UpcomingIncompletePeriods[0],
				vmObj.lastInactivePeriod = null;
			}

			$scope.vm = vmObj;

			setPageState('setup');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		setPageState('loading');

		if (payPeriod) {
			reopenPeriodForm();
		} else {
			inactivePeriodFormSetup();
		}
	}

	function reopenInactivePeriod (vmObj) {

		companyData.updateAgencyEmployerSkipped(agencyProfileId, vmObj.payPeriod.PayPeriodID, config.guidEmpty).then(() => {

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');

			setPageState('reopened');

			$scope.formOptions.forceCallback();
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function reopenPeriodForm () {

		companyData.assessCanReopenSkippedOrInactivePeriod(agencyProfileId, payPeriod.PayPeriodID).then(canAccessReopenForm => {

			$scope.vm = {
				payPeriod: payPeriod
			};

			setPageState(canAccessReopenForm ? 'reopen' : 'cant-reopen');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyEmployerSkipped (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyEmployerSkipped(agencyProfileId, vmObj.firstInactivePeriod.PayPeriodID, vmObj.lastInactivePeriod.PayPeriodID).then(() => {

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');

			formObj.state = 'saved';
			setPageState('saved');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	init();

	$scope.agencyProfileId = agencyProfileId;

	$scope.reopenInactivePeriod = vmObj => {

		reopenInactivePeriod(vmObj);
	};

	$scope.updateAgencyEmployerSkipped = (vmObj, formObj) => {

		updateAgencyEmployerSkipped(vmObj, formObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsSupportContactForm', function () {

	return {
		controller: 'companySettingsSupportContactFormCtrl',
		templateUrl: 'forms/admin/companySettings/support-contact/companySettingsSupportContactForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsSupportContactFormCtrl', ['$q', '$scope', 'companyData', 'growl', 'onboardingService', function ($q, $scope, companyData, growl, onboardingService) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var questionGroupObj = $scope.formOptions.questionGroup;

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(function (companyObj) {

			$scope.company = companyObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.saveCompanyBasicDetails = function (companyDetails, form) {

		var updateCompanyInformationBasic = companyData.updateCompanyInformationBasic(companyDetails);
		var updateOnboardingQuestions = null;

		// Onboarding only
		if (questionGroupObj !== undefined) {

			var updatedQuestionsArray = onboardingService.setQuestionsCompleteForPayrollQuestionKeys(questionGroupObj.Questions, ['payrollContactDetails']);
			
			updateOnboardingQuestions = companyData.updateOnboardingQuestions(updatedQuestionsArray);
		}

		form.state = 'saving';

		$q.all([updateCompanyInformationBasic, updateOnboardingQuestions]).then(function () {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Basic information has been saved');

			form.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsWorkDurationsForm', function () {

	return {
		controller: 'companySettingsWorkDurationsFormCtrl',
		templateUrl: 'forms/admin/companySettings/work-durations/companySettingsWorkDurationsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsWorkDurationsFormCtrl', [
	'$q',
	'$scope',
	'companyData',
	'config',
	'growl',
	'onboardingService',
	'payrollData',
	'regexService',
function (
	$q,
	$scope,
	companyData,
	config,
	growl,
	onboardingService,
	payrollData,
	regexService
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const questionGroupObj = $scope.formOptions.questionGroup;

	function init () {

		setPageState('loading');

		// Store original amounts for change detection
		companyObj.originalWorkHoursPerWeek = companyObj.WorkHoursPerWeek;
		companyObj.originalWorkWeeksPerYear = companyObj.WorkWeeksPerYear;

		// Change flag
		companyObj.workDurationsChanged = false;

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function onWorkDurationsChange (companyObj) {
		companyObj.workDurationsChanged =
			companyObj.originalWorkHoursPerWeek !== companyObj.WorkHoursPerWeek ||
			companyObj.originalWorkWeeksPerYear !== companyObj.WorkWeeksPerYear;
	}

	function saveWorkDurations (companyObj, form) {

		const updateCompanyWorkplacePatterns = payrollData.updateCompanyWorkplacePatterns(agencyProfileId,
																						  companyObj.WorkHoursPerWeek,
																						  companyObj.DayRateCalculationMethod,
																						  companyObj.MaximumWorkingDaysInMonth,
																						  companyObj.CalculatePatternOnYearlyBasis,
																						  companyObj.WorkWeeksPerYear);
		var updateOnboardingQuestions = null;

		if (questionGroupObj !== undefined) {

			var updatedQuestionsArray = onboardingService.setQuestionsCompleteForPayrollQuestionKeys(questionGroupObj.Questions, ['companyWorkWeekHours']);

			updateOnboardingQuestions = companyData.updateOnboardingQuestions(updatedQuestionsArray);
		}

		form.state = 'saving';

		$q.all([updateCompanyWorkplacePatterns, updateOnboardingQuestions]).then(function () {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success('Work durations have been saved');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		config,
		regexService,

		company: companyObj,

		onWorkDurationsChange,
		saveWorkDurations
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsWorkflowForm', function () {

	return {
		controller: 'companySettingsWorkflowFormCtrl',
		templateUrl: 'forms/admin/companySettings/workflow/companySettingsWorkflowForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsWorkflowFormCtrl', ['$scope', 'companyData', 'messageData', 'stateService', 'WORKFLOW_TEMPLATE_STATES', function ($scope, companyData, messageData, stateService, WORKFLOW_TEMPLATE_STATES) {

	const CREATE_TASK = true;

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var currentCompanyObj = $scope.formOptions.company;
	var workflowAction = $scope.formOptions.workflowAction;
	var workflowTemplateObj = $scope.formOptions.workflowTemplate;

	function disableWorkflow (vmObj, formObj) {

		formObj.state = 'saving';

		messageData.deleteWorkflowTemplate(agencyProfileId, vmObj.workflowTemplate.WorkflowTemplateID).then(() => {

			stateService.setCompany(agencyProfileId).then(() => {
				$scope.formOptions.forceCallback();
			});
			
			setPageState('workflow-disabled');

			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function enableWorkflow (vmObj, formObj) {

		const WORKFLOW_TEMPLATE_ID = '22222222-2222-2222-2222-222222222222';

		// Update state
		formObj.state = 'saving';

		messageData.copyWorkflowTemplate(agencyProfileId, WORKFLOW_TEMPLATE_ID, CREATE_TASK).then(function () {

			stateService.setCompany(agencyProfileId).then(() => {

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();
			});

			formObj.state = 'saved';
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function getActiveTemplateEntry (workflowTemplateObj) {

		if (!workflowTemplateObj) {
			return null;
		}

		const numberOfTemplateEntries = workflowTemplateObj.TemplateEntries.length;
		const today = moment();

		let activeTemplateEntryObj = null;
		let i = 0;

		for (i; i < numberOfTemplateEntries; i++) {

			let templateEntryObj = workflowTemplateObj.TemplateEntries[i];

			if (moment(templateEntryObj.DueDateISO).isAfter(today)) {
				activeTemplateEntryObj = angular.copy(templateEntryObj);
				break;
			}
		}

		return activeTemplateEntryObj;
	}

	function areAllWorkflowTemplateEntriesDueInPast (workflowTemplateObj) {

		const currentTimeMoment = moment();

		const isDueInThePast = workflowTemplateEntryObj => moment(workflowTemplateEntryObj.DueDateISO).isBefore(currentTimeMoment);

		return workflowTemplateObj.TemplateEntries.every(isDueInThePast);
	}

	function init () {

		setPageState('loading');

		$scope.vm = {
			activeWorkflowTemplateEntry: getActiveTemplateEntry(workflowTemplateObj),
			workflowTemplate: workflowTemplateObj
		};

		if (angular.isDefined(workflowAction)) {
			if (workflowAction === 'start-workflow' && areAllWorkflowTemplateEntriesDueInPast(workflowTemplateObj)) {
				setPageState('due-dates-in-past');
			} else {
				setPageState(workflowAction);
			}
		}
		else if (!currentCompanyObj.IsWorkflowEnabled) {
			setPageState('enable-workflow');
		}
		else if (workflowTemplateObj.State === WORKFLOW_TEMPLATE_STATES.complete) {
			setPageState('start-workflow');
		}
		else if (workflowTemplateObj.State === WORKFLOW_TEMPLATE_STATES.active) {
			setPageState('stop-workflow');
		}
		else {
			setPageState('disable-workflow');
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function startWorkflow (vmObj, formObj) {

		formObj.state = 'saving';

		messageData.updateWorkflowTemplateState(vmObj.workflowTemplate.WorkflowTemplateID, WORKFLOW_TEMPLATE_STATES.active).then(function () {

			$scope.formOptions.forceCallback();
			
			setPageState('workflow-started');

			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function stopWorkflow (vmObj, formObj) {

		formObj.state = 'saving';

		messageData.updateWorkflowTemplateState(vmObj.workflowTemplate.WorkflowTemplateID, WORKFLOW_TEMPLATE_STATES.inactive).then(function () {

			$scope.formOptions.forceCallback();
			
			setPageState('workflow-stopped');

			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	init();

	$scope.disableWorkflow = function (vmObj, formObj) {

		disableWorkflow(vmObj, formObj);
	};

	$scope.enableWorkflow = function (vmObj, formObj) {

		enableWorkflow(vmObj, formObj);
	};

	$scope.startWorkflow = function (vmObj, formObj) {

		startWorkflow(vmObj, formObj);
	};

	$scope.stopWorkflow = function (vmObj, formObj) {

		stopWorkflow(vmObj, formObj);
	};
}]);

'use strict';

/*
Bureaus
	- Add new admin (Super User or Team Member)
	- Can change permissions

Company Groups
	- Add new admin (Group admin or Team Member)
	- Can change permissions

Company
	- Add new admin (Company admin, Company admin lite or department admin)
	- Can change permissions
	- Can resend invite
	- Can update admin details
*/

angular.module('paycircleApp')

.directive('addNewAdminForm', function () {

	return {
		controller: 'addNewAdminFormCtrl',
		templateUrl: 'forms/admin/add-new-admin/add-new-admin.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewAdminFormCtrl', [
	'$q',
	'$scope',
	'agency',
	'base',
	'permissionsService',
	'securityData',
	'teamData',
	'utilities',
	'INTERFACE_TYPES',
	'PERMISSION_ROLES',
	'USER_ROLE_IDS',
	'REGISTRATION_INVITATION_STATUSES',
	function (
		$q,
		$scope,
		agency,
		base,
		permissionsService,
		securityData,
		teamData,
		utilities,
		INTERFACE_TYPES,
		PERMISSION_ROLES,
		USER_ROLE_IDS,
		REGISTRATION_INVITATION_STATUSES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const company = $scope.formOptions.company;
	const formContext = $scope.formOptions.formContext;

	let permissionRolesArray;

	const FORM_CONTEXTS = {
		inviteNewAdmin: 'invite-new-admin',
		resendInvite: 'resend-invite'
	};

	const FORM_STATES = {
		ready: 'ready',
		loading: 'loading',
		error: 'error',
		inviteSentExternal: 'invite-sent-external',
		inviteSentInternal: 'invite-sent-internal',
		inviteResent: 'invite-resent',
		adminDetailsUpdated: 'admin-details-updated',
	};

	function addNewAdminSubmit (newAdminObj, formObj) {

		if (formObj !== undefined) {
			formObj.state = 'saving';
		}

		// Re-create full name with forename/surname
		newAdminObj.Fullname = `${newAdminObj.Forename} ${newAdminObj.Surname}`;

		if (formContext === FORM_CONTEXTS.resendInvite) {

			updateExistingAdminDetails(newAdminObj, formObj)
				.then(() => {
					onSave(FORM_STATES.adminDetailsUpdated, formObj);
				})
				.catch(onError);
		}
		else {
			inviteNewAdmin(newAdminObj, formObj);
		}
	}

	function copyVerificationCodeToClipboard (code) {
		utilities.copyToClipboard(code, 'Verification code copied to clipboard');
	}

	function decorateTeamMember (teamMemberObj) {

		angular.extend(teamMemberObj, {
			hasEmailAddress: teamMemberObj.EmailAddress !== '',
			hasPermissionsUpdated: false,
			isPermissionsValid: true,
			RoleDetail: permissionsService.getRoleForCompanyTypeId(permissionRolesArray, company.CompanyType)
		});

		return teamMemberObj;
	}

	function init () {

		setPageState(FORM_STATES.loading);

		base.getPermissionRoles(agencyProfileId).then(permissionRolesObj => {

			permissionRolesArray = permissionRolesObj.Roles;

			switch (formContext) {

				// Resend invite
				case FORM_CONTEXTS.resendInvite:
					initResendAdminInvite();
					break;

				// Invite new admin
				default:
					initInviteNewAdmin(agencyProfileId);
					break;
			}
		})
		.catch(onError);
	}

	function initInviteNewAdmin (agencyProfileId) {

		// Check whether this bureau has SSO enabled.
		agency.getCompanyAuthenticationDetails(agencyProfileId).then(companyAuthenticationObj => {

			$scope.ssoEnabled = companyAuthenticationObj.OIDCEnabled;
			$scope.newAdmin = {
				EmailAddress: '',
				Forename: '',
				Fullname: '',
				Gender: 'Female',
				RoleType: permissionsService.getRoleIdForCompanyTypeId(company.CompanyType),
				RoleDetail: permissionsService.getRoleForCompanyTypeId(permissionRolesArray, company.CompanyType), // TODO: To be replaced with roleDetailObj,
				Surname: '',
				Telephone: '',
				SSOID: '',
				hasPermissionsUpdated: false,
				isPermissionsValid: true
			};

			setPageState(FORM_STATES.ready);
		})
		.catch(onError);
	}

	function initResendAdminInvite () {

		const adminObj = $scope.formOptions.adminObj;

		angular.extend(adminObj, {
			Telephone:  adminObj.TelephoneNumber,
			originalAddress:  adminObj.EmailAddress,
		});

		$scope.newAdmin = decorateTeamMember(adminObj);

		setPageState(FORM_STATES.ready);
	}

	// Used when inviting a new admin who isn't already in the system
	function inviteNewAdmin (newAdminObj, formObj) {

		securityData.sendInvitationMailExternal(agencyProfileId, newAdminObj.EmailAddress, newAdminObj.Fullname, newAdminObj.RoleType, newAdminObj.Telephone, newAdminObj.SSOID).then(newAdminUserId => {

			securityData.getUserRegistrationSummary(newAdminUserId, agencyProfileId)
				.then(userRegistrationSummary => {

					angular.extend($scope, {
						invitation: userRegistrationSummary.Invitation
					});

					if (newAdminObj.hasPermissionsUpdated) {
						base.updatePermissionRoleDetail(agencyProfileId, newAdminObj.RoleDetail, newAdminUserId).then(() => {
							onSave(FORM_STATES.inviteSentExternal, formObj);
						})
						.catch(onError);

					} else {
						onSave(FORM_STATES.inviteSentExternal, formObj);
					}
				})
				.catch(onError);
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState(FORM_STATES.error);
		console.error(error);
	}

	function onSave (pageState, formObj) {

		if (formObj) {
			formObj.state = 'saved';
		}

		$scope.formOptions.forceCallback();

		setPageState(pageState);
	}

	function openRemoveAdminAccessForm (adminObj) {

		$scope.formOptions.openNewSlideInForm ({
			agencyProfileId: agencyProfileId,
			callback: function () {
				$scope.formOptions.forceCallback();
			},
			formKey: 'remove-admin-access',
			userId: adminObj.UserID
		});
	}

	function resendInvite (newAdminObj, $form) {

		newAdminObj.state = 'saving';

		updateExistingAdminDetails(newAdminObj, $form)
			.then(([
				updatedAdminObj
			]) => {

				angular.extend(updatedAdminObj, {
					RoleType: newAdminObj.RoleType,
					Fullname: updatedAdminObj.Forename + ' ' + updatedAdminObj.Surname
				});

				// Resent invite
				securityData.sendInvitationMailInternal(updatedAdminObj.UserID, agencyProfileId, updatedAdminObj.Email, updatedAdminObj.RoleType)
					.then(() => {

						// Get new verification code
						securityData.getUserRegistrationSummary(newAdminObj.UserID, agencyProfileId)
							.then(userRegistrationSummary => {

								angular.extend($scope, {
									invitation: userRegistrationSummary.Invitation
								});

								onSave(FORM_STATES.inviteResent, $form);
							})
							.catch(onError);

					})
					.catch(onError);

			})
			.catch(onError);
	}

	function selectTeamMember (teamMemberObj) {

		if (angular.isDefined(teamMemberObj)) {
			teamMemberObj.RoleDetail = permissionsService.getRoleForCompanyTypeId(permissionRolesArray, company.CompanyType);
			$scope.teamMember = teamMemberObj;

		} else {
			$scope.teamMember = null;
		}

	}

	// Used to send email to a new admin who's in the system already
	function sendAdminInviteToTeamMember (teamMemberObj, formObj) {

		if (formObj !== undefined) {
			formObj.state = 'saving';
		}

		teamMemberObj.Fullname = `${teamMemberObj.Forename} ${teamMemberObj.Surname}`;

		securityData.sendInvitationMailInternal(teamMemberObj.UserID, agencyProfileId, teamMemberObj.EmailAddress, teamMemberObj.RoleType).then(() => {

			if (teamMemberObj.hasPermissionsUpdated) {
				base.updatePermissionRoleDetail(agencyProfileId, teamMemberObj.RoleDetail, teamMemberObj.UserID).then(() => {
					onSave(FORM_STATES.inviteSentInternal, formObj);
				})
				.catch(onError);

			} else {
				onSave(FORM_STATES.inviteSentInternal, formObj);
			}
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleIsDefaultPermissions (newAdminObj) {
		newAdminObj.RoleDetail.IsDefault = !newAdminObj.RoleDetail.IsDefault;
	}

	// Used in the resend invite form to update admin's details and resend invite
	function updateExistingAdminDetails (newAdminObj, $form) {

		if ($form !== undefined) {
			$form.state = 'saving';
		}

		newAdminObj.PhoneNumberPrimary = newAdminObj.Telephone;
		newAdminObj.Email = newAdminObj.EmailAddress;

		const updateTeamMemberPersonal = teamData.updateTeamMemberPersonal(newAdminObj, newAdminObj.UserID, agencyProfileId);
		const updatePermissionRoleDetail = newAdminObj.hasPermissionsUpdated ? base.updatePermissionRoleDetail(agencyProfileId, newAdminObj.RoleDetail, newAdminObj.UserID) : null;

		return $q((onComplete, onError) => {
			$q.all([
				updateTeamMemberPersonal,
				updatePermissionRoleDetail
			])
			.then(onComplete)
			.catch(onError);
		});
	}

	function updatePermissionsForRoleType (newAdminObj) {
		newAdminObj.RoleDetail = permissionsService.getRoleForRoleTypeId(permissionRolesArray, newAdminObj.RoleType);
	}

	init();

	angular.extend($scope, {
		FORM_CONTEXTS,
		FORM_STATES,
		INTERFACE_TYPES,
		PERMISSION_ROLES,
		USER_ROLE_IDS,
		REGISTRATION_INVITATION_STATUSES,

		addNewAdminSubmit,
		agencyProfileId,
		copyVerificationCodeToClipboard,
		initInviteNewAdmin,
		openRemoveAdminAccessForm,
		resendInvite,
		selectTeamMember,
		sendAdminInviteToTeamMember,
		toggleIsDefaultPermissions,
		updatePermissionsForRoleType,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addNewBureauForm', function () {

	return {
		controller: 'addNewBureauFormCtrl',
		templateUrl: 'forms/admin/addNewBureau/addNewBureauForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewBureauFormCtrl', ['$scope', 'dataImportData', function ($scope, dataImportData) {

	// Scope variables
	$scope.bureau = {
		bureauName: ''
	};
	$scope.pageState = 'ready';

	// Scope functions
	$scope.addNewBureau = function (bureau, form) {

		// Update state
		form.state = 'saving';

		dataImportData.createBureauCompany(bureau.bureauName).then(function () {

			// Force callback function to be ran
			$scope.formOptions.forceCallback();

			// Update state
			form.state = 'saved';

			// Page state
			$scope.pageState = 'success';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('adjustmentGroupForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'adjustmentGroupFormCtrl',
	templateUrl: 'forms/admin/adjustment-group/adjustment-group.form.html',
})

.constant('ADJUSTMENT_GROUP_UPDATE_TYPES', {
	duplicateGroup: 'duplicate-group',
	newGroup: 'new-group',
	setDefaultGroup: 'set-default-group',
	updateGroup: 'update-group'
})

.controller('adjustmentGroupFormCtrl', [
	'config',
	'growl',
	'payrollData',
	'ADJUSTMENT_GROUP_UPDATE_TYPES',
	function (
		config,
		growl,
		payrollData,
		ADJUSTMENT_GROUP_UPDATE_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.adjustmentGroupUpdateType = angular.isDefined($ctrl.formOptions.adjustmentGroupUpdateType) ? $ctrl.formOptions.adjustmentGroupUpdateType : ADJUSTMENT_GROUP_UPDATE_TYPES.newGroup;

		$ctrl.adjustmentGroup = decorateAdjustmentGroup($ctrl.formOptions.adjustmentGroupObj);

		if ($ctrl.adjustmentGroupUpdateType === ADJUSTMENT_GROUP_UPDATE_TYPES.setDefaultGroup) {
			setPageState('set-default');
		} else {
			setPageState('ready');
		}
	}

	function decorateAdjustmentGroup (adjustmentGroupObj) {

		// Add agency profile ID
		adjustmentGroupObj.AgencyProfileID = $ctrl.formOptions.agencyProfileId;

		// Copy originals
		angular.extend(adjustmentGroupObj, {
			agencyAdjustmentGroupDescriptionOriginal: angular.copy(adjustmentGroupObj.AgencyAdjustmentGroupDescription),
			agencyAdjustmentGroupNameOriginal: angular.copy(adjustmentGroupObj.AgencyAdjustmentGroupName)
		});

		// New (parent is always base)
		if ($ctrl.adjustmentGroupUpdateType === ADJUSTMENT_GROUP_UPDATE_TYPES.newGroup) {
			adjustmentGroupObj.AgencyAdjustmentParentGroupID = config.guidEmpty;
		}

		// Duplicate (make sure parent is set)
		if ($ctrl.adjustmentGroupUpdateType === ADJUSTMENT_GROUP_UPDATE_TYPES.duplicateGroup) {
			adjustmentGroupObj.AgencyAdjustmentParentGroupID = angular.copy(adjustmentGroupObj.AgencyAdjustmentGroupID);
		}

		// Empty values if new / duplicate (TODO: replace with getEmptyAdjustmentGroup service)
		if (![ADJUSTMENT_GROUP_UPDATE_TYPES.updateGroup, ADJUSTMENT_GROUP_UPDATE_TYPES.setDefaultGroup].includes($ctrl.adjustmentGroupUpdateType)) {
			angular.extend(adjustmentGroupObj, {
				AgencyAdjustmentGroupDefault: false,
				AgencyAdjustmentGroupDescription: '',
				AgencyAdjustmentGroupID: config.guidEmpty,
				AgencyAdjustmentGroupName: ''
			});
		}

		return adjustmentGroupObj;
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function updateAdjustmentGroup ($form) {

		function getSuccessMessage () {

			switch ($ctrl.adjustmentGroupUpdateType) {
				case ADJUSTMENT_GROUP_UPDATE_TYPES.updateGroup:
				case ADJUSTMENT_GROUP_UPDATE_TYPES.setDefaultGroup:
					return 'Pack updated';

				case ADJUSTMENT_GROUP_UPDATE_TYPES.newGroup:
					return 'Pack created';

				case ADJUSTMENT_GROUP_UPDATE_TYPES.duplicateGroup:
					return 'Pack duplicated';
			}
		}

		// Set as default if running set default action
		if ($ctrl.adjustmentGroupUpdateType === ADJUSTMENT_GROUP_UPDATE_TYPES.setDefaultGroup) {
			$ctrl.adjustmentGroup.AgencyAdjustmentGroupDefault = true;
		}

		$form.state = 'saving';

		payrollData.updateAgencyAdjustmentGroup($ctrl.adjustmentGroup)
			.then(responseObj => {

				$ctrl.formOptions.forceCallback(responseObj);
				$ctrl.formOptions.closeForm();

				growl.success(getSuccessMessage());

				$form.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateAdjustmentGroup,

		ADJUSTMENT_GROUP_UPDATE_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('archiveBureauForm', {

	bindings: {
		formOptions: '='
	},
	controller: 'archiveBureauFormCtrl',
	templateUrl: 'forms/admin/archive-bureau/archive-bureau.form.html',
})

.controller('archiveBureauFormCtrl', [
	'companyData',
	'ARCHIVE_REASON_KEYS',
	function (
		companyData,
		ARCHIVE_REASON_KEYS
	) {

	const $ctrl = this;

	const PAGE_STATES = {
		archiveBureau: 'archive-bureau',
		undoArchiveBureau: 'undo-archive-bureau',
		error: 'error'
	};

	$ctrl.$onInit = () => {
		const pageState = $ctrl.formOptions.bureauCompany.IsArchived ? PAGE_STATES.undoArchiveBureau : PAGE_STATES.archiveBureau;
		setPageState(pageState);
	};

	function updateBureauArchiveStatus (bureauCompanyObj, formObj, archive) {

		formObj.state = 'saving';

		companyData.updateAgencyProfileArchive(
			bureauCompanyObj.AgencyProfileID,
			archive,
			ARCHIVE_REASON_KEYS.other
		).then(() => {

			formObj.state = 'saved';

			// Callback and close
			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(error => {

			console.error(error);
			setPageState(PAGE_STATES.error);

			formObj.state = null;
		});
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {

		PAGE_STATES,

		updateBureauArchiveStatus
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('archiveCompanyForm', function () {

	return {
		controller: 'archiveCompanyFormCtrl',
		templateUrl: 'forms/admin/archiveCompany/archiveCompanyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('archiveCompanyFormCtrl', ['$scope', 'companyData', 'teamData', 'ARCHIVE_OPTIONS', function ($scope, companyData, teamData, ARCHIVE_OPTIONS) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var company = $scope.formOptions.company;

	function updateCompanyArchive (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.updateAgencyProfileArchive(agencyProfileId, vmObj.archive, vmObj.archiveReason).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberAdmins(agencyProfileId).then(function (adminsArray) {

			$scope.vm = {
				admins: adminsArray,
				archive: true,
				archiveReason: null
			};

			setPageState(company.IsArchived ? 'undo-archive' : 'archive');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function undoArchiveCompany (vmObj, formObj) {

		vmObj.archive = false;
		vmObj.archiveReason = '';

		updateCompanyArchive(vmObj, formObj);
	}

	init();

	$scope.ARCHIVE_OPTIONS = ARCHIVE_OPTIONS;

	$scope.archiveCompany = function (vmObj, formObj) {

		updateCompanyArchive(vmObj, formObj);
	};

	$scope.setPageState = function (pageState) {

		setPageState(pageState);
	};

	$scope.undoArchiveCompany = function (vmObj, formObj) {

		undoArchiveCompany(vmObj, formObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('autoCreateCompanyForm', function () {

	return {
		controller: 'autoCreateCompanyFormCtrl',
		templateUrl: 'forms/admin/autoCreateCompany/autoCreateCompanyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('autoCreateCompanyFormCtrl', ['$scope', 'dataImportData', function ($scope, dataImportData) {

	var agencyProfileParentId = $scope.formOptions.agencyProfileParentId;

	function init () {

		// Scope
		$scope.testCompany = {
			companyName: ''
		};

		// Page state
		$scope.pageState = 'ready';
	}

	init();

	$scope.formOptions.primaryButtonText = 'Create';

	$scope.addNewTestCompany = function (companyName, form) {

		// Update state
		form.state = 'saving';

		// Service call
		dataImportData.createPlayground(agencyProfileParentId, companyName).then(function () {

			// Force callback function to be ran
			$scope.formOptions.forceCallback({
				agencyProfileParentId: agencyProfileParentId
			});

			// Update state
			form.state = 'saved';

			// Page state
			$scope.pageState = 'created';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';

			// Form state
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('changeAdminStateForm', function () {

	return {
		controller: 'changeAdminStateFormCtrl',
		templateUrl: 'forms/admin/changeAdminState/changeAdminStateForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('changeAdminStateFormCtrl', ['$scope', 'userData', function ($scope, userData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;
	var isExcluding = $scope.formOptions.isExcluding; // false = add to payroll, true = exclude

	$scope.pageState = 'ready';

	$scope.changeAdminState = function () {

		userData.updateUserAgencyProfileExcludeFromPayroll(agencyProfileId, userId, isExcluding).then(function () {

			$scope.formOptions.forceCallback();

			$scope.pageState = 'saved';
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	};


}]);

'use strict';

angular.module('paycircleApp')

.component('clonePayrollForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'clonePayrollFormCtrl',
	templateUrl: 'forms/admin/clone-payroll/clone-payroll.form.html'
})

.controller('clonePayrollFormCtrl', [
	'companyData',
	'growl',
	function (
		companyData,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		companyData.getCompanyClone($ctrl.formOptions.agencyProfileId).then(hasCompanyClone => {

			if ($ctrl.formOptions.formAction === 'delete') {
				setComponentState('confirm-delete');
				return;
			}

			if (hasCompanyClone) {				
				setComponentState('confirm-overwrite');
			}
			else {
				setComponentState('ready');
			}
		})
		.catch(onError);
	}

	function clonePayroll ($ctrl, formObj) {

		setComponentState('cloning');

		if (angular.isDefined(formObj)) {			
			formObj.state = 'saving';
		}

		companyData.createCompanyClone($ctrl.formOptions.agencyProfileId).then(() => {

			setComponentState('clone-success');

			if (angular.isDefined(formObj)) {			
				formObj.state = 'saved';
			}
		})
		.catch(onError);
	}

	function deleteClone ($ctrl) {

		setComponentState('deleting');

		companyData.deleteCompanyClone($ctrl.formOptions.agencyProfileId).then(() => {

			growl.success('Clone successfully deleted');

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		clonePayroll,
		deleteClone
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteOfficeLocationForm', function () {

	return {
		controller: 'deleteOfficeLocationFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/deleteOfficeLocationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteOfficeLocationFormCtrl', ['$scope', 'securityData', function ($scope, securityData) {

	const officeLocation = $scope.formOptions.officeLocation;

	function deleteOfficeLocation (form, officeLocation) {

		form.state = 'saving';

		securityData.deleteIPAddress(officeLocation.IPAddressID).then(function () {

			$scope.formOptions.forceCallback();

			form.state = 'saved';
			setPageState('success');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			form.state = null;
		});
	}

	function init () {

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Variables
		officeLocation,

		// Functions
		deleteOfficeLocation
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteRemoteLocationForm', function () {

	return {
		controller: 'deleteRemoteLocationFormCtrl',
		templateUrl: 'forms/admin/companySettings/access/deleteRemoteLocationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteRemoteLocationFormCtrl', ['$scope', 'securityData', 'teamData', function ($scope, securityData, teamData) {

	const adminUserId = $scope.formOptions.userId;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function deleteRemoteLocation (form, teamMemberAdmins) {

		form.state = 'saving';

		securityData.updateIPAddressAdmins(teamMemberAdmins).then(() => {
			// Success
			form.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberAdmins(agencyProfileId).then(teamMemberAdminsArr => {

			// Remove the IP address of the team member. This won't be saved until 'Delete' is clicked.
			let teamMemberAdmins = teamMemberAdminsArr;
			teamMemberAdmins.forEach(teamMemberAdmin => {
				if (teamMemberAdmin.UserID === adminUserId) {
					// Keep hold of the team member for the UI and clear out the IP address
					$scope.teamMemberAdmin = teamMemberAdmin;
					teamMemberAdmin.IPAddress = '';
				}
			});
			$scope.teamMemberAdmins = teamMemberAdmins;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Functions
		deleteRemoteLocation
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companySettingsBackdatedSalaryElementsForm', function () {

	return {
		controller: 'companySettingsBackdatedSalaryElementsFormCtrl',
		templateUrl: 'forms/admin/companySettings/payroll-settings/company-settings-backdated-salary-elements.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companySettingsBackdatedSalaryElementsFormCtrl', [
	'$scope',
	'companyData',
	'growl',
	function (
		$scope,
		companyData,
		growl
	) {

	let agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		$scope.vm = {
			company: $scope.formOptions.companyDetails,
			originalValue: $scope.formOptions.companyDetails.BackdatedSalaryDerivedElementsEnabled
		};
		setPageState('ready');
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function saveForm (vmObj, form) {

		if (vmObj.company.BackdatedSalaryDerivedElementsEnabled === vmObj.originalValue) {
			$scope.formOptions.closeForm();
			return;
		}

		form.state = 'saving';

		companyData.updateBackdatedSalaryDerivedElementsEnabled(
			agencyProfileId,
			vmObj.company.BackdatedSalaryDerivedElementsEnabled
		).then(function () {
			growl.success('Backdated salary elements setting updated successfully');
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = 'saved';
		}).catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		saveForm: saveForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteAdjustmentGroupForm', function () {

	return {
		controller: 'deleteAdjustmentGroupFormCtrl',
		templateUrl: 'forms/admin/deleteAdjustmentGroup/deleteAdjustmentGroupForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteAdjustmentGroupFormCtrl', ['growl', 'payrollData', '$scope', function (growl, payrollData, $scope) {

	var adjustmentGroupObj = $scope.formOptions.adjustmentGroupObj;

	function getInitialPageState () {

		if (adjustmentGroupObj.AgencyAdjustmentGroupDefault) {
			return 'adjustment-group-is-default';
		}

		if (adjustmentGroupObj.CompaniesUsedBy > 0) {
			return 'adjustment-group-in-use';
		}

		return 'confirmation';
	}

	function init () {

		setPageState('loading');

		$scope.adjustmentGroup = adjustmentGroupObj;

		setPageState(getInitialPageState());
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.deleteAdjustmentGroup = function (adjustmentGroupObj) {

		adjustmentGroupObj.state = 'saving';

		payrollData.deleteAgencyAdjustmentGroup(adjustmentGroupObj.AgencyAdjustmentGroupID).then(function () {

			growl.success('Pack deleted');
			
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			adjustmentGroupObj.state = 'saved';
		})
		.catch(function () {
			$scope.pageState = 'error';
			adjustmentGroupObj.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteBureauForm', function () {

	return {
		controller: 'deleteBureauFormCtrl',
		templateUrl: 'forms/admin/deleteBureau/deleteBureauForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteBureauFormCtrl', [
	'$scope',
	'companyData',
	'growl',
	'utilities',
	'LOCAL_STORAGE_KEYS',
	function (
		$scope,
		companyData,
		growl,
		utilities,
		LOCAL_STORAGE_KEYS
	) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var company	= $scope.formOptions.company;

	function init () {

		// Page state
		$scope.pageState = 'loading';

		if (!company.CanBeDeleted) {

			$scope.pageState = 'cannot-delete';
			return;
		}

		$scope.pageState = 'ready';
	}

	init();

	$scope.deleteBureau = function (bureau) {

		// Update state
		bureau.state = 'saving';

		// Service call
		companyData.deleteAgencyProfile(agencyProfileId).then(function () {

			// Delete stored company group id
			if (utilities.getFromStorage(LOCAL_STORAGE_KEYS.companyGroupId) === agencyProfileId) {
				utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.companyGroupId);
			}

			// Close form
			$scope.formOptions.forceCallback();

			// Update state
			$scope.pageState = 'success';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';

			// Form state
			bureau.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteCompanyGroupForm', function () {

	return {
		controller: 'deleteCompanyGroupFormCtrl',
		templateUrl: 'forms/admin/deleteCompanyGroup/deleteCompanyGroupForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteCompanyGroupFormCtrl', ['$scope', 'companyData', 'config', 'utilities', 'LOCAL_STORAGE_KEYS', function ($scope, companyData, config, utilities, LOCAL_STORAGE_KEYS) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyGroupsArr = $scope.formOptions.companyGroups;

	function deleteCompanyGroup (vmObj, formObj) {

		formObj.state = 'saving';

		if (!vmObj.moveCompaniesToADifferentGroup) {
			vmObj.newAgencyProfileParentId = config.guidEmpty;
		}

		companyData.deleteGroupCompany(agencyProfileId, vmObj.moveCompaniesToADifferentGroup, vmObj.newAgencyProfileParentId).then(() => {

			// Delete stored company group id
			if (utilities.getFromStorage(LOCAL_STORAGE_KEYS.companyGroupId) === agencyProfileId) {
				utilities.deleteFromStorage(LOCAL_STORAGE_KEYS.companyGroupId);
			}

			$scope.formOptions.forceCallback();

			setPageState('success');
		})
		.catch((error) => {
			setPageState('error');
			formObj.state = null;
			console.error(error);
		});
	}

	function init () {

		setPageState('loading');

		angular.extend($scope, {
			vm: {
				companyGroups: companyGroupsArr.all.filter(isNotCurrentCompanyGroup),
				moveCompaniesToADifferentGroup: false,
				newAgencyProfileParentId: null
			},
			deleteCompanyGroup
		});

		setPageState('ready');
	}

	function isNotCurrentCompanyGroup (companyGroupObj) {

		return companyGroupObj.Company.AgencyProfileID !== agencyProfileId;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();
}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePayElementForm', function () {

	return {
		controller: 'deletePayElementFormCtrl',
		templateUrl: 'forms/admin/deletePayElement/deletePayElementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePayElementFormCtrl', ['$scope', 'growl', 'payrollData', function ($scope, growl, payrollData) {

	//var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var payElementObj = $scope.formOptions.payElementObj;

	function init () {

		setPageState('loading');

		$scope.payElement = payElementObj;

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.deletePayElement = function (payElementObj, form) {

		form.state = 'saving';

		payrollData.deleteAgencyAdjustmentGroupEntry(payElementObj.AgencyAdjustmentGroupEntryID).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('The ' + payElementObj.AgencyAdjustmentGroupEntryText + ' pay element has been deleted');

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteTeamMemberForm', function () {

	return {
		controller: 'deleteTeamMemberFormCtrl',
		templateUrl: 'forms/admin/delete-team-member/delete-team-member.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteTeamMemberFormCtrl', [
	'$scope',
	'$state',
	'$timeout',
	'session',
	'teamData',
	function (
		$scope,
		$state,
		$timeout,
		session,
		teamData
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const forceDelete = angular.isDefined($scope.formOptions.forceDelete) ? $scope.formOptions.forceDelete : false;
	const loggedInUserId = session.getUserId();
	const teamMemberObj = $scope.formOptions.context;
	let userId = $scope.formOptions.userId;
	let userIds = $scope.formOptions.userIds;

	function deleteTeamMember (userId) {

		setPageState('deleting');

		teamData.deleteUserProfile(userId, agencyProfileId).then(() => {

			$scope.formOptions.forceCallback();
			setPageState('deleted');
		})
		.catch(error => {

			// -1 response assumes that the delete operation is invalid
			if (error === -1) {
				setPageState('delete-error');

				teamData.getUserPaymentCountsIncludingDraftPayslips(agencyProfileId, userId).then((paymentCounts) => {
					if (paymentCounts.UserPaymentCount === 0 && paymentCounts.DraftUserPaymentCount !== 0) {
						setPageState('delete-error-draft-payslips');
					}
				});
			}

			else {
				console.error(error);
				setPageState('error');
				console.error(error);
			}
		});
	}

	function deleteTeamMembers (userIds, formObj) {

		formObj.state = 'loading';

		// Make sure logged in user cannot delete themself
		userIds = userIds.filter(_ => {
			return _.UserID !== loggedInUserId;
		});

		setPageState('deleting');

		teamData.deleteUserProfiles(agencyProfileId, userIds).then(() => {

			$scope.formOptions.forceCallback();
			setPageState('deleted-bulk');
			formObj.state = null;
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			console.error(error);
		});
	}

	function init () {

		// For bulk delete, validation has to be done in the originating controller
		if (angular.isDefined(userIds)) {

			// Only 1 individual selected, so display as deleting an individual
			if (userIds.length === 1) {
				userId = userIds[0];
			}

			// Bulk delete
			else {
				setPageState('ready-bulk');
				return;
			}
		}

		// Can't delete yourself
		if (userId === loggedInUserId) {

			setPageState('logged-in-user');
			return;
		}

		// Can delete regardless of setup
		if (forceDelete) {

			setPageState('ready');
			return;
		}

		// Has to be in setup mode to delete
		if (teamMemberObj && !teamMemberObj.IsInSetupMode) {

			setPageState('not-in-setup-mode');
			return;
		}

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		deleteTeamMember,
		deleteTeamMembers,
		userId
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('duplicatePayElementForm', function () {

	return {
		controller: 'duplicatePayElementFormCtrl',
		templateUrl: 'forms/admin/duplicatePayElement/duplicatePayElementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('duplicatePayElementFormCtrl', [
	'$rootScope',
	'$scope',
	'base',
	'companyData',
	'config',
	'payElementsService',
	'payrollData',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'ADJUSTMENT_DETAIL_STATES',
	'ADJUSTMENT_VALUE_TYPES',
	'FEATURE_FLAGS',
	'INTERFACE_TYPES',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	function (
		$rootScope,
		$scope,
		base,
		companyData,
		config,
		payElementsService,
		payrollData,
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_DETAIL_STATES,
		ADJUSTMENT_VALUE_TYPES,
		FEATURE_FLAGS,
		INTERFACE_TYPES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const payElementObj = $scope.formOptions.payElementObj;

	const PAY_ELEMENT_PENSION_STATES = {
		company: 0,
		parent: 1
	};

	function init () {

		setPageState('loading');

		payElementObj.originalName = angular.copy(payElementObj.AgencyAdjustmentGroupEntryText);
		payElementObj.AgencyAdjustmentGroupEntryText = `${angular.copy(payElementObj.originalName)} (copy)`;
		payElementObj.isPayElementUsingAlternativeCurrency = false;

		angular.extend($scope, {
			company: companyObj,
			payElement: payElementObj,
			isPayElementPensionableReadOnly: payElementsService.isPayElementPensionableReadOnly(payElementObj, companyObj)
		});

		base.isFeatureEnabled(agencyProfileId, FEATURE_FLAGS.AVERAGE_HOLIDAY_PAY).then(isAverageHolidayPayEnabled => {
			$scope.isAverageHolidayPayEnabled = isAverageHolidayPayEnabled;
		});

		// Load currencies for company
		if (companyObj.isPayrollCompany && companyObj.IsExpatActive && [ADJUSTMENT_VALUE_TYPES.percentage, ADJUSTMENT_VALUE_TYPES.absolute, ADJUSTMENT_VALUE_TYPES.unit].includes(payElementObj.AgencyAdjustmentValueType)) {
			companyData.getCurrencies(agencyProfileId)
				.then(currenciesArr => {

					if (currenciesArr.length > 0) {
						$scope.currencies = currenciesArr;

						payElementObj.isPayElementUsingAlternativeCurrency = (payElementObj.CurrencyID !== config.guidEmpty);

						if (payElementObj.CurrencyID === config.guidEmpty) {
							payElementObj.CurrencyID = null;
						}
					}

					setPageState('ready');
				})
				.catch(onError);
			return;
		}

		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateAgencyAdjustmentGroupEntry (payElementObj, form) {

		const IS_CORE_ELEMENT = companyObj.CompanyType === INTERFACE_TYPES.bureau;

		// Duplicate the element to avoid flashing in the UI
		let newPayElementObj = angular.copy(payElementObj);

		// Review element
		payElementsService.reviewPayElementPension(newPayElementObj);
		payElementsService.reviewPayElementNetPay(newPayElementObj);

		// Reset currency
		if (!payElementObj.isPayElementUsingAlternativeCurrency || !payElementObj.CurrencyID) {
			newPayElementObj.CurrencyID = config.guidEmpty;
		}

		form.state = 'saving';

		payrollData.updateAgencyAdjustmentGroupEntry(newPayElementObj, IS_CORE_ELEMENT).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch((error) => {
			setPageState('error');
			console.error(error);
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_DETAIL_STATES,
		INTERFACE_TYPES,
		PAY_ELEMENT_PENSION_STATES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,

		isPayElementHolidayReadOnly: payElementsService.isPayElementHolidayReadOnly,
		isPayElementNetPayReadOnly: payElementsService.isPayElementNetPayReadOnly,
		isPayElementProrateReadOnly: payElementsService.isPayElementProrateReadOnly,
		isPayElementSalarySacrificeReadOnly: payElementsService.isPayElementSalarySacrificeReadOnly,
		isPayElementPayrollBIKReadOnly: payElementsService.isPayElementPayrollBIKReadOnly,
		reviewPayElementHoliday: payElementsService.reviewPayElementHoliday,
		reviewPayElementNetPay: payElementsService.reviewPayElementNetPay,
		reviewPayElementPension: payElementsService.reviewPayElementPension,
		reviewPayElementProrate: payElementsService.reviewPayElementProrate,
		reviewPayElementSalarySacrifice: payElementsService.reviewPayElementSalarySacrifice,
		reviewPayElementPayrollBIK: payElementsService.reviewPayElementPayrollBIK,
		updateAgencyAdjustmentGroupEntry
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('editBureauBunForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editBureauBunFormCtrl',
	templateUrl: 'forms/admin/edit-bureau-bun/edit-bureau-bun.form.html'
})

.controller('editBureauBunFormCtrl', [
	'agency',
	'growl',
	function (
		agency,
		growl
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		agency.getAgencyEmployerBUN($ctrl.formOptions.agencyProfileId)
			.then(agencyEmployerBun => {

				angular.extend($ctrl, {
					agencyEmployerBun
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function updateAgencyEmployerBUN ($ctrl, $form) {

		$form.state = 'saving';

		agency.updateAgencyEmployerBUN($ctrl.formOptions.agencyProfileId, $ctrl.agencyEmployerBun)
			.then(() => {
				growl.success('BUN updated.');
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		updateAgencyEmployerBUN
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editAdminForm', function () {

	return {
		controller: 'editAdminFormCtrl',
		templateUrl: 'forms/admin/editAdmin/editAdminForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editAdminFormCtrl', [
	'$q',
	'$scope',
	'agency',
	'base',
	'growl',
	'permissionsService',
	'teamData',
	'userData',
	'INTERFACE_TYPES',
	'PERMISSION_ROLE_IDS',
	function (
		$q,
		$scope,
		agency,
		base,
		growl,
		permissionsService,
		teamData,
		userData,
		INTERFACE_TYPES,
		PERMISSION_ROLE_IDS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const roleType = $scope.formOptions.roleType;
	const userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		let permissionRoleId; // undefined

		const getTeamMemberPersonal = userData.getTeamMemberPersonal(agencyProfileId, userId);
		const getPermissionRoleDetail = base.getPermissionRoleDetail(agencyProfileId, permissionRoleId, userId, roleType);
		const getPermissionRoles = base.getPermissionRoles(agencyProfileId);
		const getCompanyAuthenticationDetails = agency.getCompanyAuthenticationDetails(agencyProfileId);

		$q.all([getTeamMemberPersonal, getPermissionRoleDetail, getPermissionRoles, getCompanyAuthenticationDetails]).then(([teamMemberPersonalObj, roleDetailObj, permissionRolesObj, companyAuthenticationObj]) => {

			$scope.vm = {
				admin: teamMemberPersonalObj,
				hasPermissionsUpdated: false,
				isPermissionsValid: true,
				permissionRoles: permissionRolesObj.Roles,
				roleDetail: permissionsService.decorateRole(roleDetailObj),
				ssoEnabled: companyAuthenticationObj.OIDCEnabled
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateAdmin (vmObj, formObj) {

		const updateTeamMemberPersonal = teamData.updateTeamMemberPersonal(vmObj.admin, userId, agencyProfileId);
		const updateUserProfileAgencyProfilePermissionRole = !vmObj.hasPermissionsUpdated ? base.updateUserProfileAgencyProfilePermissionRole(agencyProfileId, vmObj.roleDetail.RoleType, userId) : null;
		const updatePermissionRoleDetail = vmObj.hasPermissionsUpdated ? base.updatePermissionRoleDetail(agencyProfileId, vmObj.roleDetail, userId) : null;

		$q.all([updateUserProfileAgencyProfilePermissionRole, updatePermissionRoleDetail, updateTeamMemberPersonal]).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success(`${$scope.formOptions.context.Forename} has been updated`);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function updatePermissionsForRoleType (vmObj) {
		vmObj.roleDetail = permissionsService.getRoleForRoleTypeId(vmObj.permissionRoles, vmObj.roleDetail.RoleType);
	}

	init();

	angular.extend($scope, {
		INTERFACE_TYPES,
		PERMISSION_ROLE_IDS,

		agencyProfileId,
		userId,

		updateAdmin,
		updatePermissionsForRoleType,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('linkElementForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'linkElementFormCtrl',
	templateUrl: 'forms/admin/link-element/link-element.form.html'
})

.controller('linkElementFormCtrl', [
	'$q',
	'adjustmentsService',
	'config',
	'coralogixService',
	'payrollData',
	'regexService',
	function (
		$q,
		adjustmentsService,
		config,
		coralogixService,
		payrollData,
		regexService
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		// When opened via Imports, only Unit adjustment types apply
		const CONTEXT_KEY = angular.isDefined($ctrl.formOptions.adjustmentTypesContextKey) ? $ctrl.formOptions.adjustmentTypesContextKey : 'link-elements';
		const IS_EDITING = angular.isDefined($ctrl.formOptions.linkElementObj);

		const getAgencyAdjustmentGroupCombined = payrollData.getAgencyAdjustmentGroupCombined($ctrl.formOptions.agencyProfileId);
		const getAgencyAdjustmentLabels = payrollData.getAgencyAdjustmentLabels($ctrl.formOptions.agencyProfileId);
		const getEmptyLinkElement = IS_EDITING ? null : payrollData.getEmptyLinkElement();
		const getEmptyUserPayElementDetail = payrollData.getEmptyUserPayElementDetailForLink();

		$q.all([
			getAgencyAdjustmentGroupCombined,
			getAgencyAdjustmentLabels,
			getEmptyLinkElement,
			getEmptyUserPayElementDetail
		]).then(([
			adjustmentGroupsObj,
			adjustmentLabelsArr,
			linkElementObj,
			emptyUserPayElementDetailObj
		]) => {

			if (IS_EDITING) {
				linkElementObj = $ctrl.formOptions.linkElementObj;
			}

			let companyAdjustmentTypesArr = adjustmentsService.getAdjustmentTypesByContextKey(adjustmentGroupsObj, $ctrl.formOptions.company, CONTEXT_KEY);

			// Default Multiplier to 1
			angular.extend(linkElementObj, {
				LinkElementMultiplier: linkElementObj.LinkElementMultiplier !== 0 ? linkElementObj.LinkElementMultiplier : 1,
				hasGlobalRate: linkElementObj.LinkElementRate > 0 || CONTEXT_KEY === 'link-element-imports',
				isGlobalRateDisabled: CONTEXT_KEY === 'link-element-imports'
			});

			angular.extend($ctrl, {
				changeCreatorVm: adjustmentsService.getChangeCreatorVm({
					CAN_EDIT_ADJUSTMENT: !IS_EDITING,
					CAN_MANAGE_TEAM_MEMBERS: false,
					IS_ADJUSTMENT_AMOUNT_APPLICABLE: false,
					IS_APPLICABLE_TO_TEAM_MEMBERS: false,
					PAY_ELEMENT_LABEL: 'Link to change type',
					PAY_ELEMENT_LABEL_PLACEHOLDER: 'Start typing to search',
					SHOW_PAYSLIP_LABEL: false,
					SHOW_TAX_TREATMENT: false,
					adjustmentLabels: adjustmentsService.decorateLabelsWithAdjustmentTypes(adjustmentLabelsArr, companyAdjustmentTypesArr),
					adjustmentTypes: companyAdjustmentTypesArr,
					adjustmentTypesOriginal: angular.copy(companyAdjustmentTypesArr),
					newAdjustment: angular.copy(adjustmentsService.decorateNewAdjustmentObj(emptyUserPayElementDetailObj)),
					selectedAdjustmentTypeId: linkElementObj.AgencyAdjustmentGroupEntryID,
					//selectedAdjustmentTypeName: disbursementObj.Description !== '' ? disbursementObj.Description : null,
					//selectedPayPeriodId: payPeriodObj.PayPeriodID,
				}),
				linkElementGroupId: $ctrl.formOptions.linkElementGroupId,
				linkElement: linkElementObj,
				globalRateOption: 0,
				globalRateOptions: [
					{
						id: 0,
						description: 'As a fixed value'
					},
					{
						id: 1,
						description: 'Using a pay scale'
					}
				]
			});

			/**
			 * Validate associated adjustment object to make sure it is available to the user
			 * - Adjustment type might have been deleted after Link Element is created
			 * - Adjustment type can be removed from pay element group that has been associated to the user
			**/
			if ($ctrl.formOptions.actionType !== 'delete' && !adjustmentsService.isAdjustmentTypeValid(linkElementObj.AgencyAdjustmentGroupEntryID, companyAdjustmentTypesArr, 'AgencyAdjustmentGroupEntryID')) {
				setComponentState('adjustment-type-mismatch');
				coralogixService.noticeError('Link Element Form > Unable to match adjustment type for link element');
				return;
			}

			switch ($ctrl.formOptions.actionType) {

				case 'delete': {				
					setComponentState('confirm-delete');
					return;
				}
				case 'duplicate': {

					// Remove ID and append (copy) to name
					angular.extend($ctrl.linkElement, {
						LinkElementName: angular.copy($ctrl.linkElement.LinkElementName) + ' (copy)',
						LinkElementID: config.guidEmpty
					});

					setComponentState('ready');
					return;
				}
				default: {
					setComponentState('ready');
				}
			}
		})
		.catch(onError);
	}

	function deleteLinkElement ($ctrl, formObj) {

		formObj.state = 'saving';

		payrollData.deleteLinkElement($ctrl.formOptions.agencyProfileId, $ctrl.linkElement.LinkElementID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function populateLinkElementObj ($ctrl) {

		const selectedChangeType = $ctrl.changeCreatorVm.newAdjustment.adjustmentType;

		angular.extend($ctrl.linkElement, {
			AgencyAdjustmentGroupEntryID: adjustmentsService.getAgencyAdjustmentGroupEntryId(selectedChangeType),
			LinkElementAdjustmentName: selectedChangeType.AgencyAdjustmentGroupEntryText,
			IsDeduction: selectedChangeType.IsDeduction
		});

		return $ctrl;
	}

	function reviewGlobalRate ($ctrl) {

		if (!$ctrl.linkElement.hasGlobalRate) {
			$ctrl.linkElement.LinkElementRate = 0;
		}
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function updateLinkElement ($ctrl, formObj) {

		formObj.state = 'saving';

		populateLinkElementObj($ctrl);

		payrollData.updateLinkElement($ctrl.linkElementGroupId, $ctrl.linkElement).then(() => {

			$ctrl.formOptions.initCallbackOnClose = true;
			$ctrl.formOptions.closeForm({
				actionType: 'updated'
			});

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		deleteLinkElement,
		regexService,
		reviewGlobalRate,
		updateLinkElement
	});
}]);

'use strict';

angular.module('paycircleApp')
.component('manageMentionsAccessForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'manageMentionsAccessFormCtrl',
	templateUrl: 'forms/admin/manage-mentions-access/manage-mentions-access.form.html',
})

.controller('manageMentionsAccessFormCtrl', [
	'growl',
	'teamData',
	'userData',
	function (
		growl,
		teamData,
		userData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		teamData.getTeamMemberAdmins($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId)
			.then(adminsArr => {

				// Filter out selected admin
				angular.extend($ctrl, {
					admins: adminsArr.filter(adminObj => adminObj.UserID !== $ctrl.formOptions.userId)
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function toggleAllAdmins ($ctrl, isCompanyVisible) {
		for (let admin of $ctrl.admins) {
			admin.HasMentionsAccess = isCompanyVisible;
		}
	}

	function updateIsSelectedForDuplicates ($ctrl, updatedAdminObj) {
		for (let adminObj of $ctrl.admins) {
			if (adminObj.UserID === updatedAdminObj.UserID) {
				adminObj.HasMentionsAccess = updatedAdminObj.HasMentionsAccess;
			}
		}
	}

	function updateTeamMemberAdminMentions ($ctrl, $form) {

		$form.state = 'saving';

		userData.updateTeamMemberAdminMentions($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId, $ctrl.admins)
			.then(() => {

				$form.state = 'saved';

				growl.success('Mentions access updated');

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateIsSelectedForDuplicates,
		toggleAllAdmins,
		updateTeamMemberAdminMentions,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('inviteToRegisterForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'inviteToRegisterFormCtrl',
	templateUrl: 'forms/admin/invite-to-register/invite-to-register.form.html'
})

.controller('inviteToRegisterFormCtrl', [
	'securityData',
	'teamData',
	'PLACEHOLDERS',
	'USER_ROLE_IDS',
	function (
		securityData,
		teamData,
		PLACEHOLDERS,
		USER_ROLE_IDS
	) {

	const $ctrl = this;

	const COMPONENT_STATES = {
		bulkInvite: 'bulk-invite',
		bulkSuccess: 'bulk-success',
		error: 'error',
		individualInvite: 'individual-invite',
		individualSuccess: 'individual-success',
		loading: 'loading'
	};

	function $onInit () {

		setComponentState(COMPONENT_STATES.loading);

		if (angular.isDefined($ctrl.formOptions.userIds)) {
			setComponentState(COMPONENT_STATES.bulkInvite);

		} else {
			initIndividualInviteForm($ctrl);
		}
	}

	function getHasEmailAddress (teamMemberObj) {

		return !(teamMemberObj.Personal.DummyEmail || teamMemberObj.Personal.Email === '');
	}

	function initIndividualInviteForm ($ctrl) {

		teamData.getTeamMemberInformation($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId).then(teamMemberObj => {

			const hasEmailAddress = getHasEmailAddress(teamMemberObj);

			angular.extend($ctrl, {
				addAlternativeEmail: !hasEmailAddress,
				alternativeEmailAddress: '',
				hasEmailAddress: hasEmailAddress,
				teamMember: teamMemberObj,
			});

			setComponentState(COMPONENT_STATES.individualInvite);
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState(COMPONENT_STATES.error);
		console.error(error);
	}

	function sendInvitationMailInternal ($ctrl, $form) {

		const emailAddressToSendInviteTo = $ctrl.addAlternativeEmail ? $ctrl.alternativeEmailAddress : $ctrl.teamMember.Personal.Email;

		$form.state = 'saving';

		securityData.sendInvitationMailInternal($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId, emailAddressToSendInviteTo, USER_ROLE_IDS.worker).then(() => {
			$ctrl.sentAddress = angular.copy(emailAddressToSendInviteTo);
			$ctrl.formOptions.forceCallback();
			setComponentState(COMPONENT_STATES.individualSuccess);
		})
		.catch(onError);
	}

	function sendInvitationMailInternalBulk ($ctrl, $form) {

		$form.state = 'saving';

		securityData.sendInvitationMailInternalBulk($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userIds).then(() => {
			$ctrl.formOptions.forceCallback();
			setComponentState(COMPONENT_STATES.bulkSuccess);
		})
		.catch(onError);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function toggleAddAlternativeEmail  ($ctrl) {

		$ctrl.addAlternativeEmail = !$ctrl.addAlternativeEmail;
	}

	angular.extend($ctrl, {
		$onInit,

		COMPONENT_STATES,
		PLACEHOLDERS,

		sendInvitationMailInternal,
		sendInvitationMailInternalBulk,
		toggleAddAlternativeEmail
	});
}]);


'use strict';

angular.module('paycircleApp')

.directive('inviteSsoAdminToFullyRegisterForm', function () {

	return {
		controller: 'inviteSsoAdminToFullyRegisterFormCtrl',
		templateUrl: 'forms/admin/invite-to-register/invite-sso-admin-to-fully-register.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})
.controller('inviteSsoAdminToFullyRegisterFormCtrl', [
	'$scope',
	'securityData',
	'PLACEHOLDERS',
	'utilities',
	function (
		$scope,
		securityData,
		PLACEHOLDERS,
		utilities
	) {

	const COMPONENT_STATES = {
		error: 'error',
		individualInvite: 'individual-invite',
		individualSuccess: 'individual-success',
		loading: 'loading'
	};

	function init () {
		setComponentState(COMPONENT_STATES.individualInvite);
	}

	function onError (error) {

		setComponentState(COMPONENT_STATES.error);
		console.error(error);
	}

	function sendRegistrationEmailForSsoAdmin ($form) {

		$form.state = 'saving';
		securityData.sendRegistrationEmailForSsoAdmin($scope.formOptions.userId, $scope.formOptions.agencyProfileId).then((resp) => {
			$scope.invitation = resp.Invitation;
			setComponentState(COMPONENT_STATES.individualSuccess);
		})
		.catch(onError);
	}

	function setComponentState (componentState) {

		$scope.componentState = componentState;
	}

	function copyVerificationCodeToClipboard (code) {
		utilities.copyToClipboard(code, 'Verification code copied to clipboard');
	}

	init();
	angular.extend($scope, {
		COMPONENT_STATES,
		PLACEHOLDERS,
		pageState: 'ready',

		copyVerificationCodeToClipboard,
		sendRegistrationEmailForSsoAdmin
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('manageAdminsForm', function () {

	return {
		controller: 'manageAdminsFormCtrl',
		templateUrl: 'forms/admin/manageAdmins/manageAdminsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('manageAdminsFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'agency',
	'dataTransfer',
	'permissionsService',
	'reportData',
	'securityData',
	'teamData',
	'INTERFACE_TYPES',
	'PERMISSION_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		agency,
		dataTransfer,
		permissionsService,
		reportData,
		securityData,
		teamData,
		INTERFACE_TYPES,
		PERMISSION_TYPES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function downloadPermissionsReport () {

		$scope.permissionReportDownloadState = 'loading';

		reportData.createPermissionsReportDownload(agencyProfileId).then(permissionReportUrl => {

			dataTransfer.downloadFile(permissionReportUrl, 'PermissionsReport.xlsx');

			$scope.permissionReportDownloadState = null;
		})
		.catch(error => {
		    console.error(error);
		});
	}

	function init () {

		setPageState('loading');

		const getTeamMemberAdminsExtended = teamData.getTeamMemberAdminsExtended(agencyProfileId, PERMISSION_TYPES.all);
		const getCompanyAuthenticationDetails = agency.getCompanyAuthenticationDetails(agencyProfileId);
		const getTeamMemberAdminAccounts = securityData.getTeamMemberAdminAccounts(agencyProfileId).catch(() => []);

		$q.all([getTeamMemberAdminsExtended, getCompanyAuthenticationDetails, getTeamMemberAdminAccounts]).then(([adminGroupsObj, companyAuthenticationObj, adminAccountsArr]) => {

			const accountEmailMap = {};

			if (adminAccountsArr) {
				adminAccountsArr.forEach((account) => {
					accountEmailMap[account.UserID] = account.AccountEmailAddress;
				});
			}

			['BureauAdmins', 'GroupAdmins', 'CompanyAdmins'].forEach((group) => {
				if (adminGroupsObj[group]) {
					adminGroupsObj[group].forEach((admin) => {
						if (accountEmailMap[admin.UserID]) {
							admin.AccountEmailAddress = accountEmailMap[admin.UserID];
						}
					});
				}
			});

			$scope.adminGroups = adminGroupsObj;
			$scope.ssoEnabled = companyAuthenticationObj.OIDCEnabled;

			setPageState('ready');
		})
		.catch(function () {

			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.INTERFACE_TYPES = INTERFACE_TYPES;
	$scope.canEditAdmin = permissionsService.getCanEditAdminPermissionForCompany($scope.formOptions.company);
	$scope.agencyProfileId = agencyProfileId;
	$scope.permissionReportDownloadState = null;

	$scope.downloadPermissionsReport = function () {

	    downloadPermissionsReport();
	};

	$scope.refreshAdmins = function () {

		init();
	};

	$scope.openAddNewAdminForm = function () {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'new-admin'
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('averageHolidayPayOptionsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'averageHolidayPayOptionsFormCtrl',
	templateUrl: 'forms/admin/average-holiday-pay-options/average-holiday-pay-options.form.html'
})

.controller('averageHolidayPayOptionsFormCtrl', [
	'$rootScope',
	'bulkService',
	'filterService',
	'reportData',
	'searchService',
	'AVERAGE_HOLIDAY_PAY_RATE_TYPES',
	'INTERFACE_TYPES',
	function (
		$rootScope,
		bulkService,
		filterService,
		reportData,
		searchService,
		AVERAGE_HOLIDAY_PAY_RATE_TYPES,
		INTERFACE_TYPES
	) {

	const $ctrl = this;

	const PAGE_STATES = {
		edit: 'edit',
		detecting: 'detecting',
		selectCompanies: 'select-companies',
		companyElements: 'company-elements',
		error: 'error',
		success: 'success'
	};

	// How many overridden element names a company card shows inline before collapsing the rest
	// behind a "See more" link - roughly what fits in two rows at the drawer's width.
	const MAX_INLINE_ELEMENT_NAMES = 2;

	function $onInit () {

		const selectedPayElements = $ctrl.formOptions.selectedPayElements || [];
		const firstPayElement = selectedPayElements[0] || {};

		// Pre-population: if every selected element shares a value, adopt it; otherwise fall back to
		// the domain defaults (inclusion off, Other rate type). This is a cheap in-memory pass.
		const allShareInclusion = selectedPayElements.every(payElement =>
			payElement.IncludeIn52WeekAverage === firstPayElement.IncludeIn52WeekAverage);
		const allShareRateType = selectedPayElements.every(payElement =>
			payElement.RateType === firstPayElement.RateType);

		const isBureau = $rootScope.currentCompany.CompanyType === INTERFACE_TYPES.bureau;

		angular.extend($ctrl, {
			AVERAGE_HOLIDAY_PAY_RATE_TYPES,
			form: {
				includeIn52WeekAverage: allShareInclusion ? firstPayElement.IncludeIn52WeekAverage : false,
				// When the selection has differing rate types, clear it (null) so nothing is pre-selected -
				// the user must make a deliberate choice rather than see a misleading partial state.
				rateType: allShareRateType ? firstPayElement.RateType : null
			},
			isBureau,
			// Bureau users see 'Next', which detects divergent companies before saving; company users
			// save directly, as there's nothing to push down to.
			primaryButtonText: isBureau ? 'Next' : 'Save',
			searchBarOptions: searchService.companyPayElementOverrides,
			selectedCount: selectedPayElements.length,
			selectedPayElements
		});

		setPageState(PAGE_STATES.edit);
	}

	function onPrimaryAction (form) {

		if ($ctrl.isBureau) {
			detectOverrides();
			return;
		}

		save(form);
	}

	function save (form) {

		form.state = 'saving';

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;

		const payElementSettings = $ctrl.selectedPayElements.map(payElement =>
			buildSettingRow(agencyProfileId, payElement.AgencyAdjustmentGroupEntryID));

		reportData.updatePayElementReportSettings(agencyProfileId, payElementSettings).then(result => {

			if (result === -1) {
				onError(new Error('UpdatePayElementReportSettings returned -1'));
				return;
			}

			form.state = 'saved';

			// Refresh the list behind the drawer so the updated tags show without a manual reload.
			$ctrl.formOptions.forceCallback();

			setPageState(PAGE_STATES.success);
		})
		.catch(onError);
	}

	// Finds the bureau's child companies that won't automatically inherit the selected elements
	// (because they've renamed/duplicated one, or already saved their own setting for it).
	function detectOverrides () {

		setPageState(PAGE_STATES.detecting);

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;

		const selectedElements = $ctrl.selectedPayElements.map(payElement => payElement.AgencyAdjustmentGroupEntryID);

		reportData.getCompaniesWithOverriddenPayElements(agencyProfileId, selectedElements).then(overridesArr => {

			angular.extend($ctrl, {
				companies: bulkService.getBulkItemsObj(buildCompanies(overridesArr)),
				filterBarOptions: filterService.getFilterBarOptionsCompanyPayElementOverrides($ctrl.selectedPayElements)
			});

			$ctrl.formOptions.title = 'Push settings to companies';

			setPageState(PAGE_STATES.selectCompanies);
		})
		.catch(onError);
	}

	function backToEdit () {

		$ctrl.formOptions.title = 'Manage options';

		setPageState(PAGE_STATES.edit);
	}

	// Groups the (company x element) detection rows to company grain for the push-down cards. A
	// company can have several divergent elements/versions within the current selection.
	function buildCompanies (overridesArr) {

		const companiesById = {};

		overridesArr.forEach(overrideObj => {

			let companyObj = companiesById[overrideObj.CompanyAgencyProfileID];

			if (!companyObj) {
				companyObj = companiesById[overrideObj.CompanyAgencyProfileID] = {
					CompanyAgencyProfileID: overrideObj.CompanyAgencyProfileID,
					CompanyName: overrideObj.CompanyName,
					elementNames: [],
					overrides: [],
					isSelected: false
				};
			}

			companyObj.overrides.push(overrideObj);

			if (companyObj.elementNames.indexOf(overrideObj.ElementName) === -1) {
				companyObj.elementNames.push(overrideObj.ElementName);
			}
		});

		return Object.keys(companiesById).map(companyId => companiesById[companyId]).map(companyObj => angular.extend(companyObj, {
			inlineElementNames: companyObj.elementNames.slice(0, MAX_INLINE_ELEMENT_NAMES),
			hasMoreElementNames: companyObj.elementNames.length > MAX_INLINE_ELEMENT_NAMES
		}));
	}

	function onCheckboxToggle () {

		bulkService.updateBulkItemTotals($ctrl.companies);
	}

	function onSelectAllToggle () {

		bulkService.updateItemsSelectedState($ctrl.companies);
	}

	// A company matches the search if its name matches, or any of its overridden pay element names
	// match - lets a bureau with many affected companies find "who has Car Allowance overridden"
	// just as easily as "find Acme Ltd".
	function matchesSearch (companyObj) {

		const searchString = (($ctrl.searchBarOptions.search || {}).string || '').toLowerCase();

		if (!searchString) {
			return true;
		}

		if (companyObj.CompanyName.toLowerCase().indexOf(searchString) !== -1) {
			return true;
		}

		return companyObj.elementNames.some(elementName => elementName.toLowerCase().indexOf(searchString) !== -1);
	}

	// Opens the full, scrollable list of a company's overridden element names, for companies with
	// more than fit inline on the card.
	function viewElements (companyObj) {

		$ctrl.viewingCompany = companyObj;

		setPageState(PAGE_STATES.companyElements);
	}

	function backToCompanyList () {

		$ctrl.viewingCompany = null;

		setPageState(PAGE_STATES.selectCompanies);
	}

	// One combined save: the bureau's rows plus, for every selected company, one row per element
	// version it diverged on - all carrying the same chosen inclusion/rate type. A company keeps its
	// own row after this (matching the bureau's new values) rather than reverting to inheritance;
	// its Average Holiday Pay list will show that element as its own setting, not "Inherited from
	// bureau" - correct, since it genuinely still has an explicit setting of its own.
	function pushDown (form) {

		form.state = 'saving';

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;

		const bureauRows = $ctrl.selectedPayElements.map(payElement =>
			buildSettingRow(agencyProfileId, payElement.AgencyAdjustmentGroupEntryID));

		const selectedCompanies = bulkService.getSelectedItems($ctrl.companies.all);

		const companyRows = selectedCompanies.reduce((rowsArr, companyObj) =>
			rowsArr.concat(companyObj.overrides.map(overrideObj =>
				buildSettingRow(companyObj.CompanyAgencyProfileID, overrideObj.AgencyAdjustmentGroupEntryID))), []);

		reportData.updatePayElementReportSettings(agencyProfileId, bureauRows.concat(companyRows)).then(result => {

			if (result === -1) {
				onError(new Error('UpdatePayElementReportSettings returned -1'));
				return;
			}

			form.state = 'saved';

			// For the success copy: how many company-level element versions were actually pushed (a
			// company can diverge on more than one version of a selected element), and to how many
			// companies. Reporting both avoids the count reading as "1 element" when e.g. a duplicated
			// element meant 2 rows were written for that 1 company.
			angular.extend($ctrl, {
				pushedCompanyCount: selectedCompanies.length,
				pushedElementCount: companyRows.length
			});

			$ctrl.formOptions.forceCallback();

			setPageState(PAGE_STATES.success);
		})
		.catch(onError);
	}

	function buildSettingRow (agencyProfileId, agencyAdjustmentGroupEntryId) {

		return {
			AgencyProfileID: agencyProfileId,
			AgencyAdjustmentGroupEntryID: agencyAdjustmentGroupEntryId,
			IncludeIn52WeekAverage: $ctrl.form.includeIn52WeekAverage,
			RateType: $ctrl.form.rateType
		};
	}

	function onError (error) {

		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		backToCompanyList,
		backToEdit,
		matchesSearch,
		onCheckboxToggle,
		onPrimaryAction,
		onSelectAllToggle,
		pushDown,
		setPageState,
		viewElements
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('managePayElementsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'managePayElementsFormCtrl',
	templateUrl: 'forms/admin/manage-pay-elements/manage-pay-elements.form.html',
})

.controller('managePayElementsFormCtrl', [
	'$q',
	'adjustmentsService',
	'base',
	'config',
	'companyData',
	'growl',
	'payElementsService',
	'payrollData',
	'reportData',
	'searchService',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'ADJUSTMENT_DETAIL_STATES',
	'FEATURE_FLAGS',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	function (
		$q,
		adjustmentsService,
		base,
		config,
		companyData,
		growl,
		payElementsService,
		payrollData,
		reportData,
		searchService,
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_DETAIL_STATES,
		FEATURE_FLAGS,
		PAYMENT_SCHEDULE_PENSION_OPTIONS
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const getAgencyProfileCompanyDetails = companyData.getAgencyProfileCompanyDetails($ctrl.formOptions.agencyProfileId);
		const getAgencyAdjustmentGroupsCompany = payrollData.getAgencyAdjustmentGroups($ctrl.formOptions.agencyProfileId);
		const getAgencyAdjustmentGroupsPackDetail = payrollData.getAgencyAdjustmentGroupsPackDetail($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyProfileParentId);
		const getJournalFrameworkForAgency = reportData.getJournalFrameworkForAgency($ctrl.formOptions.agencyProfileId);

		$q.all([
			getAgencyProfileCompanyDetails,
			getAgencyAdjustmentGroupsCompany,
			getAgencyAdjustmentGroupsPackDetail,
			getJournalFrameworkForAgency
		]).then(([
			agencyProfileCompanyDetails,
			payElementPacksArr,
			agencyAdjustmentGroupsPackDetailArr,
			journalFrameworkObj
		]) => {

			angular.extend($ctrl, {
				agencyProfileCompanyDetails,
				journalFramework: journalFrameworkObj,
				newPack: null,
				payElementPacks: payElementPacksArr,
				payElementPacksAssignable: getAssignablePayElementPacks(payElementPacksArr, agencyAdjustmentGroupsPackDetailArr),
				searchBarOptions: searchService.managePayElements
			});

			setAddPackState('add-pack');

			if (payElementPacksArr.length === 0) {
				setPageState('no-pay-element-packs');
				return;
			}

			setPageState('pay-element-packs');
		})
		.catch(onError);

		base.isFeatureEnabled($ctrl.formOptions.agencyProfileId, FEATURE_FLAGS.AVERAGE_HOLIDAY_PAY).then(isAverageHolidayPayEnabled => {
			$ctrl.isAverageHolidayPayEnabled = isAverageHolidayPayEnabled;
		});
	}

	function assignNewPack (payElementPackObj, formObj) {

		let newPayElementPackObj = angular.copy(payElementPackObj);

		angular.extend(newPayElementPackObj, {
			AgencyAdjustmentParentGroupID: payElementPackObj.AgencyAdjustmentGroupID,
			AgencyAdjustmentGroupID: config.guidEmpty,
			AgencyProfileID: $ctrl.formOptions.agencyProfileId
		});

		formObj.state = 'saving';

		payrollData.updateAgencyAdjustmentGroup(newPayElementPackObj).then(() => {

			$ctrl.formOptions.forceCallback();

			$onInit();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function closePayElement () {

		setActivePayElement(null);
		setPageState('pay-element-pack');
	}

	function closePayElementPack () {

		setActivePayElementPack(null);
		setPageState('pay-element-packs');
	}

	function countFilteredPayElements (activePayElementPackObj) {

		let count = 0;

		activePayElementPackObj.GroupEntries.forEach(payElementCategoryObj => {

			count += payElementCategoryObj.payElementsFiltered.length;
		});

		return count;
	}

	function decoratePayElement (payElementObj) {

		// Can be duplicated
		switch (payElementObj.Category) {
			case 'CIS':
				payElementObj.canEdit = false;
				break;
			default:
				payElementObj.canEdit = true;
		}

		return payElementObj;
	}

	function decoratePayElementPack (groupObj) {

		if (groupObj.GroupEntries.length > 0) {
			groupObj.GroupEntries.filter(decoratePayElement);
		}

		// Decorate with theme
		switch (groupObj.Category) {
			case 'Deductions':
				groupObj.theme = 'assertive';
				groupObj.order = 'd';
				break;
			case 'SalarySacrifice':
				groupObj.theme = 'assertive';
				groupObj.order = 'c';
				break;
			case 'BIK':
				groupObj.theme = 'greyscale';
				groupObj.order = 'e';
				break;
			case 'Additions':
				groupObj.theme = 'positive';
				groupObj.order = 'b';
				break;
			default:
				groupObj.theme = 'positive';
				groupObj.order = 'a';
		}

		angular.extend(groupObj, {
			payElementsFiltered: []
		});

		return groupObj;
	}

	function getAssignablePayElementPacks (payElementPacksArr, agencyPayElementPackDetailsArr) {

		return agencyPayElementPackDetailsArr.filter(payElementPackObj => {

			payElementPackObj.isAssignable = true;

			// Read only groups cannot be assigned
			if (payElementPackObj.IsReadOnly) {
				payElementPackObj.isAssignable = false;
			}

			payElementPacksArr.forEach(companyAdjustmentGroupObj => {

				// Already assigned
				if (companyAdjustmentGroupObj.AgencyAdjustmentGroupID === payElementPackObj.AgencyAdjustmentGroupID) {
					payElementPackObj.isAssignable = false;
				}
			});

			return payElementPackObj.isAssignable;
		});
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setActivePayElement (payElementObj) {

		$ctrl.activePayElement = payElementObj;
	}

	function setActivePayElementPack (payElementPackObj) {

		$ctrl.activePayElementPack = payElementPackObj;
	}

	function setActivePayElementPackById (payElementPackObj) {

		setPageState('loading');

		payrollData.getAgencyAdjustmentGroup(payElementPackObj.AgencyAdjustmentGroupID).then(payElementPackDetailsObj => {

			// Decorate
			payElementPackDetailsObj.GroupEntries = payElementPackDetailsObj.GroupEntries.filter(decoratePayElementPack);

			angular.extend(payElementPackObj, payElementPackDetailsObj);

			setActivePayElementPack(payElementPackObj);

			setPageState('pay-element-pack');
		})
		.catch(onError);
	}

	function setAddPackState (addPackState) {

		$ctrl.addPackState = addPackState;
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	function unassignAdjustmentGroup (agencyAdjustmentGroupObj) {

		agencyAdjustmentGroupObj.state = 'saving';

		payrollData.deleteAgencyAdjustmentGroup(agencyAdjustmentGroupObj.AgencyAdjustmentGroupID).then(() => {

			$ctrl.formOptions.forceCallback();

			$onInit();

			agencyAdjustmentGroupObj.state = 'saved';
		})
		.catch(error => {
			onError(error);
		})
		.finally(() => {
			agencyAdjustmentGroupObj.state = null;
		});
	}

	function updatePayElement (payElementObj, payElementPackObj, formObj) {

		formObj.state = 'saving';

		// Update pay element
		payrollData.updateAgencyAdjustmentGroupEntry(payElementObj).then(updatedPayElementObj => {

			angular.extend(payElementObj, updatedPayElementObj);

			const getAgencyAdjustmentGroups = payrollData.getAgencyAdjustmentGroups($ctrl.formOptions.agencyProfileId);
			const getAgencyAdjustmentGroup = payrollData.getAgencyAdjustmentGroup(payElementObj.AgencyAdjustmentGroupID);

			// Refresh pay element packs and pay element pack
			$q.all([
				getAgencyAdjustmentGroups,
				getAgencyAdjustmentGroup
			]).then(([
				payElementPacksArr,
				updatedPayElementPackObj
			]) => {

				// Decorate
				updatedPayElementPackObj.GroupEntries = updatedPayElementPackObj.GroupEntries.filter(decoratePayElementPack);

				angular.extend(payElementPackObj, updatedPayElementPackObj);

				setActivePayElementPack(payElementPackObj);

				$ctrl.payElementPacks = payElementPacksArr;

				setPageState('pay-element-pack');

				growl.success(updatedPayElementObj.AgencyAdjustmentGroupEntryText + ' has been updated');

				formObj.state = 'saved';
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function viewPayElement (payElementObj, payElementPackObj) {

		setActivePayElement(payElementObj);
		setActivePayElementPack(payElementPackObj);
		setPageState('pay-element-type');
	}

	angular.extend($ctrl, {
		$onInit,
		ADJUSTMENT_BEHAVIOUR_STATES,
		ADJUSTMENT_DETAIL_STATES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		assignNewPack,
		closePayElement,
		closePayElementPack,
		countFilteredPayElements,
		isPayElementHolidayReadOnly: payElementsService.isPayElementHolidayReadOnly,
		isPayElementNetPayReadOnly: payElementsService.isPayElementNetPayReadOnly,
		isPayElementNMWReadOnly: payElementsService.isPayElementNMWReadOnly,
		isPayElementPayrollBIKReadOnly: payElementsService.isPayElementPayrollBIKReadOnly,
		isPayElementPensionableReadOnly: payElementsService.isPayElementPensionableReadOnly,
		isPayElementProrateReadOnly: payElementsService.isPayElementProrateReadOnly,
		isPayElementSalarySacrificeReadOnly: payElementsService.isPayElementSalarySacrificeReadOnly,
		reviewPayElementHoliday: payElementsService.reviewPayElementHoliday,
		reviewPayElementNetPay: payElementsService.reviewPayElementNetPay,
		reviewPayElementNMW: payElementsService.reviewPayElementNMW,
		reviewPayElementPayrollBIK: payElementsService.reviewPayElementPayrollBIK,
		reviewPayElementPension: payElementsService.reviewPayElementPension,
		reviewPayElementProrate: payElementsService.reviewPayElementProrate,
		reviewPayElementSalarySacrifice: payElementsService.reviewPayElementSalarySacrifice,
		setActivePayElementPackById,
		setAddPackState,
		setPageState,
		unassignAdjustmentGroup,
		updatePayElement,
		viewPayElement
	});

}]);

'use strict';

angular.module('paycircleApp')
.component('managePayElementsPensionForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'managePayElementsPensionFormCtrl',
	templateUrl: 'forms/admin/manage-pay-elements-pension/manage-pay-elements-pension.form.html',
})
.controller('managePayElementsPensionFormCtrl', [
	'$timeout',
	'$filter',
	'growl',
	'payElementsService',
	'payrollData',
	'searchService',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	'PENSION_TYPES',
	function (
		$timeout,
		$filter,
		growl,
		payElementsService,
		payrollData,
		searchService,
		ADJUSTMENT_BEHAVIOUR_STATES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		PENSION_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		payrollData.getAgencyAdjustmentGroupsForPension($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyEmployerPensionId).then(payElementPacksArr => {

			angular.extend($ctrl, {
				payElementPacks: payElementPacksArr,
				searchBarOptions: searchService.managePayElements
			});

			if (payElementPacksArr.length === 0) {
				setFormState('no-pay-element-packs');
				return;
			}

			setFormState('pay-element-packs');
		})
		.catch(onError);
	}

	function closePayElement () {

		setActivePayElement(null);
		setFormState('pay-element-pack');
	}

	function closePayElementPack ($ctrl) {

		$ctrl.activePayElementPack = null;

		setFormState('pay-element-packs');
	}

	function countFilteredPayElements (activePayElementPackObj) {

		let count = 0;

		activePayElementPackObj.GroupEntries.forEach(payElementCategoryObj => {

			count += payElementCategoryObj.payElementsFiltered.length;
		});

		return count;
	}

	function decoratePayElement (payElementObj) {

		// Can be duplicated
		switch (payElementObj.Category) {
			case 'CIS':
				payElementObj.canEdit = false;
				break;
			default:
				payElementObj.canEdit = true;
		}

		payElementObj.payElementDescription = $filter('adjustmentGroupEntryDescription')(payElementObj);

		return payElementObj;
	}

	function decoratePayElementPack (groupObj) {

		if (groupObj.GroupEntries.length > 0) {
			groupObj.GroupEntries.filter(decoratePayElement);
		}

		// Decorate with theme
		switch (groupObj.Category) {
			case 'Deductions':
				groupObj.theme = 'assertive';
				groupObj.order = 'd';
				break;
			case 'SalarySacrifice':
				groupObj.theme = 'assertive';
				groupObj.order = 'c';
				break;
			case 'BIK':
				groupObj.theme = 'greyscale';
				groupObj.order = 'e';
				break;
			case 'Additions':
				groupObj.theme = 'positive';
				groupObj.order = 'b';
				break;
			default:
				groupObj.theme = 'positive';
				groupObj.order = 'a';
		}

		angular.extend(groupObj, {
			payElementsFiltered: []
		});

		return groupObj;
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function setActivePayElement (payElementObj) {

		$ctrl.activePayElement = payElementObj;
	}

	function setActivePayElementPack (payElementPackObj) {

		$ctrl.activePayElementPack = payElementPackObj;
	}

	function setActivePayElementPackById (payElementPackObj) {

		setFormState('loading');

		payrollData.getAgencyAdjustmentGroupCombinedForPension($ctrl.formOptions.agencyProfileId, payElementPackObj.AgencyEmployerPensionGroupID).then(payElementPackDetailsObj => {

			angular.extend(payElementPackObj, {
				GroupEntries: payElementPackDetailsObj.GroupEntries.filter(decoratePayElementPack)
			});

			setActivePayElementPack(payElementPackObj);

			setFormState('pay-element-pack');
		})
		.catch(error => {
			setFormState('error');
			console.error(error);
		});
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function toggleGroupOpen (groupObj) {

		groupObj.isOpen = !groupObj.isOpen;
	}

	function updatePayElement ($ctrl, payElementPackObj, formObj) {

		formObj.state = 'saving';

		setFormState('loading');

		// Update pay element
		payrollData.updateAgencyAdjustmentGroupEntryPension($ctrl.formOptions.agencyProfileId, $ctrl.activePayElementPack.AgencyEmployerPensionGroupID, $ctrl.activePayElement).then(updatedPayElementObj => {

			angular.extend($ctrl.activePayElement, updatedPayElementObj);

			// Reload pay element packs to refresh counts
			payrollData.getAgencyAdjustmentGroupsForPension($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyEmployerPensionId).then(payElementPacksArr => {

				angular.extend($ctrl, {
					payElementPacks: payElementPacksArr
				});

				// Reload group entries
				setActivePayElementPackById($ctrl.activePayElementPack);

				growl.success(updatedPayElementObj.AgencyAdjustmentGroupEntryText + ' has been updated');

				formObj.state = 'saved';
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function viewPayElement (payElementType, payElementTypeGroup) {

		angular.extend($ctrl, {
			activePayElement: angular.copy(payElementType),
			activePayElementTypeGroup: payElementTypeGroup,
		});

		setFormState('pay-element');
	}

	angular.extend($ctrl, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		PENSION_TYPES,

		$onInit,
		closePayElement,
		closePayElementPack,
		countFilteredPayElements,
		isPayElementPensionableReadOnly: payElementsService.isPayElementPensionableReadOnly,
		reviewPayElementPension: payElementsService.reviewPayElementPension,
		setActivePayElementPackById,
		setFormState,
		toggleGroupOpen,
		updatePayElement,
		viewPayElement
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('managePermissionsForm', function () {

	return {
		controller: 'managePermissionsFormCtrl',
		templateUrl: 'forms/admin/managePermissions/managePermissionsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('managePermissionsFormCtrl', ['$scope', 'base', 'config', 'growl', 'permissionsService', 'session', 'PERMISSION_ROLES',
	function ($scope, base, config, growl, permissionsService, session, PERMISSION_ROLES) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const callback = $scope.formOptions.callback;
	const loggedInUserId = session.getUserId();
	const userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		base.getPermissionRoleDetail(agencyProfileId, config.guidEmpty, userId).then(roleDetailObj => {

			$scope.vm = {
				isPermissionsValid: true,
				roleDetail: permissionsService.decorateRole(roleDetailObj),
				permissionsUpdated: false
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function openEditAdminForm (roleDetailObj) {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			callback,
			formKey: 'edit-admin',
			roleType: roleDetailObj.RoleType,
			userId: userId
		});
	}

	function saveForm (vmObj, formObj) {

		formObj.state = 'saving';

		vmObj.roleDetail.IsDefault = false;

		base.updatePermissionRoleDetail(agencyProfileId, vmObj.roleDetail, userId).then(function () {

			// If logged in user reload the page
			if (userId === loggedInUserId) {
				growl.error('Your permissions have been updated, reloading page…');
				window.location.reload();

			} else {
				growl.success($scope.formOptions.context.Forename + '\'s permissions have been updated');

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();

				formObj.state = 'saved';
			}

		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PERMISSION_ROLES,

		openEditAdminForm,
		saveForm,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('manageVisibilityForm', function () {

	return {
		controller: 'manageVisibilityFormCtrl',
		templateUrl: 'forms/admin/manageVisibility/manageVisibilityForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('manageVisibilityFormCtrl', ['$q', '$scope', 'base', 'teamData', 'INTERFACE_TYPES',
	function ($q, $scope, base, teamData, INTERFACE_TYPES) {

	const agencyProfileParentId = $scope.formOptions.agencyProfileParentId;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function decorateAdmins (adminsArr) {

		for (let adminObj of adminsArr) {
			adminObj.originalIsCompanyVisible = adminObj.IsCompanyVisible;
		}

		return adminsArr;
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberAdminsVisibility(agencyProfileParentId, agencyProfileId).then(adminGroupsObj => {

			const adminsArr = Object.values(adminGroupsObj).flat();

			$scope.vm = {
				adminGroups: adminGroupsObj,
				admins: decorateAdmins(adminsArr),
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleAdminGroup (adminsArr, isCompanyVisible) {
		for (let admin of adminsArr) {
			admin.IsCompanyVisible = isCompanyVisible;
		}
	}

	function updateIsSelectedForDuplicates (vmObj, updatedAdminObj) {
		for (let adminObj of vmObj.admins) {
			if (adminObj.UserID === updatedAdminObj.UserID) {
				adminObj.IsCompanyVisible = updatedAdminObj.IsCompanyVisible;
			}
		}
	}

	function updateUserProfileAgencyProfileVisibleList (vmObj, formObj) {

		formObj.state = 'saving';

		const GIVE_ACCESS = 0;
		const REMOVE_ACCESS = -1;

		const updatedTeamMembersArr = vmObj.admins.filter(adminObj => adminObj.IsCompanyVisible !== adminObj.originalIsCompanyVisible);

		const teamMembersToGiveAccessArr = updatedTeamMembersArr.filter(adminObj => adminObj.IsCompanyVisible).map(adminObj => adminObj.UserID);
		const teamMembersToRemoveAccessArr = updatedTeamMembersArr.filter(adminObj => !adminObj.IsCompanyVisible).map(adminObj => adminObj.UserID);

		const giveAccessPromise = teamMembersToGiveAccessArr.length > 0 ? base.updateUserProfileAgencyProfileVisibleList(agencyProfileId, teamMembersToGiveAccessArr, GIVE_ACCESS) : null;
		const removeAccessPromise = teamMembersToRemoveAccessArr.length > 0 ? base.updateUserProfileAgencyProfileVisibleList(agencyProfileId, teamMembersToRemoveAccessArr, REMOVE_ACCESS) : null;

		$q.all([giveAccessPromise, removeAccessPromise]).then(() => {

			formObj.state = 'saved';

			setPageState('saved');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		INTERFACE_TYPES,

		updateIsSelectedForDuplicates,
		toggleAdminGroup,
		updateUserProfileAgencyProfileVisibleList,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('removeAdminAccessForm', function () {

	return {
		controller: 'removeAdminAccessFormCtrl',
		templateUrl: 'forms/admin/removeAdminAccess/removeAdminAccessForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('removeAdminAccessFormCtrl', [
	'$scope',
	'$q',
	'growl',
	'securityData',
	'teamData',
	function (
		$scope,
		$q,
		growl,
		securityData,
		teamData
	) {

	const adminObj = $scope.formOptions.context;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	// Scope variables
	$scope.pageState = 'ready';

	// Scope functions
	function revokeAdminAccess () {

		// Update state
		$scope.loadingState = 'deleting';
		const deleteTeamMemberAdminPromise = teamData.deleteTeamMemberAdmin(adminObj.UserID, agencyProfileId);
		const unlinkAccessAccounts = securityData.unlinkAccessAccount(adminObj.UserID, agencyProfileId);

		$q.all([
			deleteTeamMemberAdminPromise,
			unlinkAccessAccounts
		])
		.then(() => {

			// Show success message
			growl.success(adminObj.Forename + '\'s admin access has been removed.');

			// Force callback and close form
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(() => {

			// Page state
			$scope.pageState = 'error';

			// Form state
			$scope.loadingState = null;
		});
	}

	angular.extend($scope, {

		pageState: 'ready',

		revokeAdminAccess
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('unlinkAccessAccountForm', function () {

	return {
		controller: 'unlinkAccessAccountFormCtrl',
		templateUrl: 'forms/admin/unlinkAccessAccount/unlinkAccessAccountForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('unlinkAccessAccountFormCtrl', [
	'$scope',
	'$q',
	'growl',
	'securityData',
	'teamData',
	function (
		$scope,
		$q,
		growl,
		securityData
	) {
	const adminObj = $scope.formOptions.context;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	// Scope variables
	$scope.pageState = 'ready';

	function unlinkAccessAccount () {

		// Update state
		$scope.loadingState = 'deleting';
		const unlinkAccessAccounts = securityData.unlinkAccessAccount(adminObj.UserID, agencyProfileId);

		unlinkAccessAccounts
			.then(() => {
				// Show success message
				growl.success('Access account successfully unlinked');

				// Force callback and close form
				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();
			})
			.catch(() => {
				// Show error message
				growl.failed('Access account unlinking failed');
				// Page state
				$scope.pageState = 'error';
				// Form state
				$scope.loadingState = null;
			});
	}

	angular.extend($scope, {

		pageState: 'ready',

		unlinkAccessAccount
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('resetAuthAccessForm', function () {

	return {
		controller: 'resetAuthAccessFormCtrl',
		templateUrl: 'forms/admin/resetAuthAccess/resetAuthAccessForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('resetAuthAccessFormCtrl', ['$scope', 'growl', 'securityData',
	function ($scope, growl, securityData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const adminObj = $scope.formOptions.adminObj;
	$scope.fullName = adminObj.fullName;

	const RESET_TYPES = {
		tfa: 'tfa-reset',
		lockout: 'lockout-reset'
	};

	function init () {

		setPageState('loading');

		$scope.vm = {
			resetType: RESET_TYPES.tfa
		};

		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function reset2fa () {

		securityData.reset2fa(agencyProfileId, adminObj.UserID).then(() => {

			$scope.formOptions.closeForm();

			growl.success(`Two-factor authentication has been reset for ${adminObj.Forename}.`);
		})
		.catch(onError);
	}

	function resetAuth (vmObj, formObj) {

		formObj.state = 'saving';

		switch (vmObj.resetType) {
			case RESET_TYPES.tfa:
				reset2fa();
				break;

			case RESET_TYPES.lockout:
				resetLoginAttemptCount();
				break;
		}
	}

	function resetLoginAttemptCount () {

		securityData.resetLoginAttemptCount(agencyProfileId, adminObj.UserID).then(() => {

			$scope.formOptions.closeForm();

			growl.success(`Lockout period has been reset for ${adminObj.Forename}.`);
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		RESET_TYPES,
		resetAuth
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('viewRoleForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'viewRoleFormCtrl',
	templateUrl: 'forms/admin/view-role/view-role.form.html'
})

.controller('viewRoleFormCtrl', [
	'$rootScope',
	'$state',
	'base',
	'permissionsService',
	function (
		$rootScope,
		$state,
		base,
		permissionsService
	) {

	const $ctrl = this;

	const FORM_CONTEXT = {
		role: 'role',
		user: 'user'
	};

	function $onInit () {

		setComponentState('loading');

		// User based
		if ($ctrl.formOptions.userId) {
			setupViewUserRoleForm($ctrl);

		// Role based
		} else if (angular.isDefined($ctrl.formOptions.role)) {
			setupViewRoleForm($ctrl);

		} else {
			onError('No UserID or RoleType passed in to form');
		}
	}

	function getInitialFormStateForUserRole (permissionRoleDetailObj) {

		const currentPrimaryRoleType = permissionsService.getRoleTypeForRoleKey($rootScope.currentUser.primaryRole);
		const currentUserRoleOrder = permissionsService.getPermissionRoleOrderForUserRoleId(currentPrimaryRoleType);

		// Show state if selected role type is less than current role type (departmentadmin: 5, cal: 4)
		if (currentUserRoleOrder > permissionRoleDetailObj.roleOrder) {
			return 'do-not-have-permission';
		}

		return 'ready';
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function onSave ($ctrl, $form) {

		$form.state = 'saving';

		$ctrl.formOptions.closeForm();

		permissionsService.enableAdminViewMode(
			$ctrl.permissionRoleDetail,
			$ctrl.formOptions.agencyProfileId,
			$ctrl.formOptions.company.Name,

			// Optional for when viewing a user's role
			$ctrl.formOptions.adminFullName,
			$ctrl.formOptions.userId
		);
	}

	function decoratePermissionRole ($ctrl, permissionRoleDetailObj) {

		// Attach admin name to use in app header bar
		angular.extend(permissionRoleDetailObj, {
			adminFullName: $ctrl.formOptions.adminFullName,
		});

		return permissionsService.decorateRole(permissionRoleDetailObj);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	function setupViewRoleForm ($ctrl) {

		angular.extend($ctrl, {
			permissionRoleDetail: decoratePermissionRole($ctrl, $ctrl.formOptions.role),
			formContext: FORM_CONTEXT.role
		});

		setComponentState('ready');
	}

	function setupViewUserRoleForm ($ctrl) {

		base.getPermissionRoleAsViewer($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId)
			.then(permissionRoleDetailObj => {

				angular.extend($ctrl, {
					permissionRoleDetail: decoratePermissionRole($ctrl, permissionRoleDetailObj),
					formContext: FORM_CONTEXT.user
				});

				const intialFormState = getInitialFormStateForUserRole(permissionRoleDetailObj);

				setComponentState(intialFormState);
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		FORM_CONTEXT,
		onSave
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editCompanyGroupForm', function () {

	return {
		controller: 'editCompanyGroupFormCtrl',
		templateUrl: 'forms/admin/editCompanyGroup/editCompanyGroupForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editCompanyGroupFormCtrl', ['$scope', '$rootScope', 'companyData', 'dataImportData', 'config', function ($scope, $rootScope, companyData, dataImportData, config) {
    
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function setupSelectedOrganization(option) {
		$scope.selectedOrganization = option;
	}

	function updateCompanyGroup(form) {
		form.state = 'saving';

		const previousOrganizationId = $scope.linkedOrganization && $scope.linkedOrganization !== config.guidEmpty ? $scope.linkedOrganization : null;
			
		const companyName = $scope.formOptions.companyGroupName;
			
		dataImportData.editGroupCompany(companyName, agencyProfileId, $scope.selectedOrganization, previousOrganizationId)
			.then(() => {
				$scope.formOptions.forceCallback();
				form.state = 'saved';
				setPageState('success');
			})
			.catch((error) => {
				setPageState('error');
				console.error(error);
			});
	}

	function init() {
		setPageState('loading');
		
		const agencyProfileParentId = $rootScope.currentCompany.AgencyProfileID;
		
		dataImportData.getLinkedOrganisationToGroupCompany(agencyProfileId)
			.then((linkedOrganization) => {
				$scope.linkedOrganization = linkedOrganization;
				
				return companyData.fetchOrganizations(agencyProfileParentId);
			})
			.then((response) => {
				$scope.organizations = [...response];
				
				if ($scope.linkedOrganization && 
					$scope.linkedOrganization.OrganisationID && 
					$scope.linkedOrganization.OrganisationID !== config.guidEmpty) {
					setupSelectedOrganization($scope.linkedOrganization.OrganisationID);
				}
				
				setPageState('ready');
			})
			.catch((error) => {
				setPageState('error');
				console.error(error);
			});

		angular.extend($scope, {
			updateCompanyGroup,
			setupSelectedOrganization,
			companyGroup: {},
			pageState: 'loading',
			organizations: [],
			selectedOrganization: null
		});
	}

	function setPageState(pageState) {
		$scope.pageState = pageState;
	} 

	init();
}]);
'use strict';

angular.module('paycircleApp')

.directive('addressForm', function () {

	return {
		controller: 'addressFormCtrl',
		templateUrl: 'forms/personal/address/address.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addressFormCtrl', [
    '$q',
    '$scope',
    'config',
    'growl',
    'teamData',
    'travel',
    'utilities',
    'wizardService',
	function (
	    $q,
	    $scope,
	    config,
	    growl,
	    teamData,
	    travel,
	    utilities,
	    wizardService
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	function addUKAddress (teamMemberObj) {

		teamMemberObj.HasUKAddress = true;
	}

	function decorateTeamMemberObj (teamMemberObj) {

		// Create Boolean value from HasUKAddress / HasForeignAddress for radio field.
		// Note: Uses HasForeignAddress flag as HasUKAddress can be true when a foreign address is active
		angular.extend(teamMemberObj, {
			isAddressSkipped: false,
			isUKAddress: !teamMemberObj.HasForeignAddress
		});

		// This overrides the situation where a CIS Subcontractor has an address to complete setup, but it's not an actual address
		// For details see: https://www.notion.so/paycircle/Testing-QA-CIS-address-tick-box-5e69e50e98544bc7b6a2c8af66441ba5
		teamMemberObj.Address.HasAddress = teamMemberObj.HasUKAddress;

		// Make sure HasUKAddress is set for new team members as it's false by default, particularly important for CIS > Skip address > Add address flow
		if (teamMemberObj.isUKAddress) {
			teamMemberObj.HasUKAddress = true;
		}

		return teamMemberObj;
	}

	function getAddressServices (teamMemberObj) {

		let servicesArr = [];

		// CIS subcontractors can skip adding an address
		if (teamMemberObj.isAddressSkipped) {
			angular.extend(teamMemberObj, {
				HasForeignAddress: false,
				HasUKAddress: false
			});
		}

		// UK ADDRESS
		// Update address (needs to update empty address if skipped to set address complete flags for CIS Subcontractors)
		if (teamMemberObj.HasUKAddress) {
			servicesArr.push(travel.updateTeamMemberAddress(teamMemberObj.Address, userId, agencyProfileId));
		}

		// Delete address if saved previously
		else if (isExistingAddress(teamMemberObj.Address)) {
			servicesArr.push(travel.deleteTeamMemberAddress(teamMemberObj.Address.AddressID, agencyProfileId));
		}	

		// FOREIGN ADDRESS
		// Update foreign address
		if (teamMemberObj.HasForeignAddress) {

			teamMemberObj.ForeignAddress.AddressForeign = true;

			// Save foreign address, making sure AddressForeign flag is true
			servicesArr.push(travel.updateTeamMemberAddress(teamMemberObj.ForeignAddress, userId, agencyProfileId));
		}
		
		// Delete foreign address if saved previously
		else if (isExistingAddress(teamMemberObj.ForeignAddress)) {
			servicesArr.push(travel.deleteTeamMemberAddress(teamMemberObj.ForeignAddress.AddressID, agencyProfileId));
		}

		return servicesArr;
	}

	function init () {

		setPageState('loading');

		wizardService.getTeamMemberInformation($scope.formOptions).then(teamMemberObj => {

			$scope.teamMember = decorateTeamMemberObj(teamMemberObj);

			setPageState('ready');
		})
		.catch(onError);
	}

	function isExistingAddress (addressObj) {

		return utilities.isPopulatedGuid(addressObj.AddressID);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onUpdateIsAddressSkipped (teamMemberObj) {

		if (teamMemberObj.isAddressSkipped) {
			angular.extend(teamMemberObj, {
				HasForeignAddress: false,
				HasUKAddress: false
			});
		}
		else {
			angular.extend(teamMemberObj, {
				HasForeignAddress: false,
				HasUKAddress: true,
				isUKAddress: true
			});
		}
	}

	function onUpdateIsUkAddress (teamMemberObj) {

		if (teamMemberObj.isUKAddress) {

			angular.extend(teamMemberObj, {
				HasForeignAddress: false,
				HasUKAddress: true
			});

			teamMemberObj.Address.AddressForeign = false;
		}
		else {
			angular.extend(teamMemberObj, {
				HasForeignAddress: true,
				HasUKAddress: false
			});
		}
	}

	function removeUKAddress (teamMemberObj) {

		teamMemberObj.HasUKAddress = false;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateTeamMemberAddresses (teamMemberObj, form) {

		const addressServices = getAddressServices(teamMemberObj);

		form.state = 'saving';

		$q.all(addressServices).then(() => {

			// For CIS subcontractors, address needs to be updated to set complete flag even though there's no address
			if (teamMemberObj.Company.IsCISSubcontractor && !teamMemberObj.HasUKAddress && !teamMemberObj.HasForeignAddress && !teamMemberObj.AddressSetupComplete) {

				travel.updateTeamMemberAddress(teamMemberObj.Address, userId, agencyProfileId).catch(onError);
			}

			// Form wizard
			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success(teamMemberObj.Personal.Forename + '\'s address has been updated.');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($scope, {
		addUKAddress,
		onUpdateIsAddressSkipped,
		onUpdateIsUkAddress,
		removeUKAddress,
		updateTeamMemberAddresses
	});

	init();
}]);

'use strict';

angular.module('paycircleApp')

.directive('emailForm', function () {

	return {
		controller: 'emailFormCtrl',
		templateUrl: 'forms/personal/email/emailForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('emailFormCtrl', [
	'$scope',
	'growl',
	'session',
	'teamData',
	'wizardService',
	function (
		$scope,
		growl,
		session,
		teamData,
		wizardService
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	
	var backupEmailDetails = {};

	function init () {

		setPageState('loading');

		wizardService.getTeamMemberInformation($scope.formOptions).then(teamMemberObj => {

			// Make form appear untouched if unsaved
			if (!teamMemberObj.EmailSetupComplete) {
				teamMemberObj.Personal.DummyEmail = false;
			} 

			$scope.teamMember = teamMemberObj;
			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onFormSkip () {
		resetFormOptionProperties();
		$scope.formOptions.skip();
	}

	function resetFormOptionProperties () {
		// Reset availableWhenCompanyPAYESchemeCeased for forms going forward within the wizard
		// Replace this with a proper fix within https://www.notion.so/paycircle/Refactor-formWizard-component-to-fix-incorrect-properties-being-passed-between-forms-46ae24352e04464fa485795b8d43f81b
		$scope.formOptions.availableWhenCompanyPAYESchemeCeased = false;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateUserContactEmail (teamMember, form) {

		form.state = 'saving';

		teamData.updateUserContactEmail(teamMember.Personal.Email, teamMember.Personal.DummyEmail, userId, agencyProfileId).then(() => {
			
			if ($scope.formOptions.isWizard) {
				resetFormOptionProperties();
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success(teamMember.Personal.Forename + '\'s email details have been updated.');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(onError);
	}

	function usingDummyEmail (formObj) {

		formObj.$setPristine();
		formObj.$setUntouched();

		if ($scope.teamMember.Personal.DummyEmail) {
			backupEmailDetails.Email = $scope.teamMember.Personal.Email;
			$scope.teamMember.Personal.Email = '';
		}
		else {
			$scope.teamMember.Personal.Email = backupEmailDetails.Email;
		}
	}

	init();

	angular.extend($scope, {
		onFormSkip,
		updateUserContactEmail,
		usingDummyEmail
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('paymentDetailsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'paymentDetailsFormCtrl',
	templateUrl: 'forms/personal/payment-details/payment-details.form.html'
})

.controller('paymentDetailsFormCtrl', [
	'$q',
	'companyData',
	'config',
	'growl',
	'teamData',
	'wizardService',
	'BUSINESS_TYPES',
	function (
		$q,
		companyData,
		config,
		growl,
		teamData,
		wizardService,
		BUSINESS_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const getTeamMemberInformation = wizardService.getTeamMemberInformation($ctrl.formOptions);
		const getCurrencies = $ctrl.formOptions.company.IsExpatActive ? companyData.getCurrencies($ctrl.formOptions.agencyProfileId) : null;

		$q.all([
			getTeamMemberInformation,
			getCurrencies
		])
		.then(([
			teamMemberObj,
			currenciesArr
		]) => {

			angular.extend($ctrl, {
				currencies: currenciesArr,
				teamMember: decorateTeamMember($ctrl, teamMemberObj, currenciesArr)
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function decorateTeamMember ($ctrl, teamMemberObj, currenciesArr) {

		angular.extend(teamMemberObj.Bank, {
			bankType: teamMemberObj.Bank.BuildingSocietyReference !== '' ? 'building-society' : 'bank',
			isPaymentInCurrency: teamMemberObj.Bank.CurrencyID !== config.guidEmpty,
			noAccountDetails: teamMemberObj.BankSetupComplete && teamMemberObj.Bank.BankAccountNumber === ''
		});

		// Find selected currency or clear it
		if (teamMemberObj.Bank.isPaymentInCurrency && currenciesArr.length > 0) {
			teamMemberObj.Bank.selectedCurrency = currenciesArr.find(currencyObj => currencyObj.CurrencyID === teamMemberObj.Bank.CurrencyID);
		} else {
			teamMemberObj.Bank.selectedCurrency = null;
		}

		// CIS Company?
		teamMemberObj.isCompany = teamMemberObj.Company.IsCISSubcontractor && (teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust);
		teamMemberObj.nameToUse = teamMemberObj.isCompany ? teamMemberObj.CIS.BusinessDetails.TradingName : $ctrl.formOptions.context.Forename;

		return teamMemberObj;
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function updateBankDetails (teamMemberObj) {

		// Remove bank details if specified
		if (teamMemberObj.Bank.noAccountDetails) {
			angular.extend(teamMemberObj.Bank, {
				SortCode: '',
				BankAccountNumber: '',
				BankIBAN: '',
				BuildingSocietyReference: ''
			});
		}

		// If bank then remove Building Society Reference
		if (teamMemberObj.Bank.bankType === 'bank') {
			teamMemberObj.Bank.BuildingSocietyReference = '';
		}

		// If not international account, clear currency
		if (teamMemberObj.Bank.BankIBAN === '') {
			teamMemberObj.Bank.isPaymentInCurrency = false;
		}

		// If payment is not in a currency, clear the ID
		if (teamMemberObj.Bank.isPaymentInCurrency) {
			teamMemberObj.Bank.CurrencyID = teamMemberObj.Bank.selectedCurrency.CurrencyID;
		} else {
			teamMemberObj.Bank.CurrencyID = config.guidEmpty;
		}
	}

	function updateTeamMemberBank ($ctrl, $form) {

		updateBankDetails($ctrl.teamMember);

		$form.state = 'saving';

		teamData.updateTeamMemberBank($ctrl.teamMember.Bank, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				$ctrl.formOptions.forceCallback();

				growl.success($ctrl.teamMember.Personal.Forename + '\'s bank details have been updated.');

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateBankDetails,
		updateTeamMemberBank
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('personalForm', function () {

	return {
		controller: 'personalFormCtrl',
		templateUrl: 'forms/personal/personal/personal.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('personalFormCtrl', [
	'$rootScope',
	'$state',
	'$scope',
	'applicationService',
	'config',
	'growl',
	'securityData',
	'teamData',
	'teamService',
	'utilities',
	'wizardService',
	'AGE_VALIDATION',
	'BUSINESS_TYPES',
	'COMPANY_STATES',
	'FORM_WIZARD_KEYS',
	'SALUTATIONS',
	'SUBMISSION_STATES',
	'TAX_TREATMENT_OPTIONS',
	'TEAM_MEMBER_SETUP_STATES',
	
	function (
		$rootScope,
		$state,
		$scope,
		applicationService,
		config,
		growl,
		securityData,
		teamData,
		teamService,
		utilities,
		wizardService,
		AGE_VALIDATION,
		BUSINESS_TYPES,
		COMPANY_STATES,
		FORM_WIZARD_KEYS,
		SALUTATIONS,
		SUBMISSION_STATES,
		TAX_TREATMENT_OPTIONS,
		TEAM_MEMBER_SETUP_STATES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const company = $scope.formOptions.company;
	const userId = $scope.formOptions.userId;
	const SCHEME_TYPES = {
		paye: 0,
		cis: 1,
		offPayroll: 2
	};

	const NI_NUMBER_VALIDATION_STATES = {
		unknownError: -1,
		noIssue: 0,
		invalidNINumber: 1
	};

	function createNewTeamMember (teamMember, form) {

		let company = teamMember.Company;
		let personal = teamMember.Personal;
		let isMale = personal.Gender === 'Male'; // Change to Boolean

		// Empty UTR if not supplied
		if (teamMember.Personal.UTRPending) {
			teamMember.Personal.UTR = '';
		}

		// Empty NI Number if set to pending
		if (teamMember.Personal.NINumberPending) {
			teamMember.Personal.NINumber = '';
		}

		// CIS Companies
		if (teamMember.Company.IsCISSubcontractor && [BUSINESS_TYPES.company, BUSINESS_TYPES.trust].includes(teamMember.CIS.BusinessDetails.BusinessType) && teamMember.CISCompanyAddressPending) {
			teamMember.CISCompanyAddress.AddressCountry = '';
		}

		// Update form state
		form.state = 'saving';

		teamData.createNewTeamMember(agencyProfileId,
									 personal.NINumber,
									 personal.Forename,
									 personal.Middlenames,
									 personal.Surname,
									 isMale,
									 personal.DOBISO,
									 company.IsStarter,
									 company.IsCISSubcontractor,
									 personal.UTR,
									 teamMember.CIS,
									 teamMember.CISCompanyAddress,
									 personal.Title,
									 company.IsOffPayrollWorker).then(function (teamMemberInformation) {

			// Update form state
			form.state = 'saved';

			// Is CIS company or trust
			teamMemberInformation.isCompany = teamMember.Company.IsCISSubcontractor && (teamMemberInformation.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMemberInformation.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust);

			// Update existing user
			$scope.existingUser = teamMemberInformation;

			// If successful go to profile
			switch (teamMemberInformation.TeamMemberSetupStatus) {

				case TEAM_MEMBER_SETUP_STATES.userCreated:
				case TEAM_MEMBER_SETUP_STATES.userExistsInPaycircle:

					// Show feedback
					growl.success(teamMemberInformation.isCompany ? teamMemberInformation.CIS.BusinessDetails.TradingName + ' has been added.' : personal.Forename + ' has been added to the team.');

					// Callback (UserID is created and passed through)
					$scope.formOptions.forceCallback();

					// Pass IsCISSubcontractor through wizard context
					if (teamMemberInformation.Company.IsCISSubcontractor) {
						teamMemberInformation.Personal.IsCISSubcontractor = true;
					}

					// Wizard
					if ($scope.formOptions.isWizard) {
						if (teamMemberInformation.isCompany) {
							$scope.formOptions.openNewFormWizard({
								contextType: 'user',
								showContext: true,
								agencyProfileId: agencyProfileId,
								wizardKey: FORM_WIZARD_KEYS.cisCompany,
								userId: teamMemberInformation.Personal.UserID,
								activeStepIndex: 1,
								callback: function () {
									$scope.formOptions.forceCallback();
								}
							});
							return;
						} else {
							$scope.formOptions.context = teamMemberInformation.Personal;
							$scope.formOptions.showContext = true;
							$scope.formOptions.contextType = 'user';
							$scope.formOptions.userId = teamMemberInformation.Personal.UserID;
							$scope.formOptions.onSuccess();
							return;
						}
					}

					$scope.formOptions.closeForm();

					break;


				case TEAM_MEMBER_SETUP_STATES.userIsLeaverForCompany:

					setPageState('user-is-leaver');
					break;

				default:

					setPageState(getPageStateForSetupStatus(teamMemberInformation.TeamMemberSetupStatus));
			}
		})
		.catch(onError);
	}

	function decorateTeamMember (teamMember) {

		// User context
		teamMember.userContext = userId ? 'existing-user' : 'new-user';

		// CIS
		if (teamMember.CIS) {
			teamMember.CIS.lastContracted = 'less-than-2-years';
			teamMember.CIS.isVATRegistered = teamMember.CIS.VATRegistrationNumber !== '';
			teamMember.CIS.dateVerifiedISOMin = moment().subtract(2, 'years').format();
			teamMember.CIS.dateVerifiedISOMax = moment().format();
		}

		// User min/max age. Min age is now zero.
		teamMember.Personal.DOBISOMin = moment().subtract(config.userMaxAge, 'years').format();
		teamMember.Personal.DOBISOMax = moment().format();

		// DOB & NI are not required fields for CIS Subcontractors (Sole Trader / Partnerships)
		if (teamMember.Company.IsCISSubcontractor && (teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.soletrader || teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership)) {
			teamMember.isNIRequired = false;
			teamMember.isDOBRequired = false;
		}
		else {
			teamMember.isNIRequired = true;
			teamMember.isDOBRequired = true;
		}

		if (teamMember.Personal.NINumber) {
			teamMember.Personal.NINumberPending = false;
		}

		setIsUtrRequired(teamMember);

		return teamMember;
	}

	function getPageStateForSetupStatus (setupStatus) {

		switch (setupStatus) {

			case TEAM_MEMBER_SETUP_STATES.userMismatch:
				return 'user-mismatch';
			case TEAM_MEMBER_SETUP_STATES.userExistsForCompany:
				return 'user-exists-for-company';
			case TEAM_MEMBER_SETUP_STATES.userIsLeaverForCompany:
				return 'user-is-leaver';
		}
	}

	function init () {

		userId ? loadTeamMember() : setupNewTeamMember();
	}

	function inviteToRegister (userId, form) {

		form.state = 'saving';

		securityData.inviteUserToRegister(userId, agencyProfileId).then(function () {

			setPageState('invite-sent');

			// Form state
			form.state = 'saved';
		})
		.catch(onError);
	}

	function loadTeamMember () {

		setPageState('loading');

		wizardService.getTeamMemberInformation($scope.formOptions).then(teamMemberObj => {

			// Create a copy of the original NI Number to check if changed when saved
			teamMemberObj.Personal.NINumberOriginal = angular.copy(teamMemberObj.Personal.NINumber);

			// If test company, force NI Number Pending & UTR Pending
			if (company.AgencyProfileDummy) {
				teamMemberObj.Personal.NINumberPending = true;
				teamMemberObj.Personal.UTRPending = true;
			}

			// Pre-select 'Select title...'
			if (teamMemberObj.Personal.Title === '') {
				teamMemberObj.Personal.Title = null;
			}

			// Scope
			$scope.teamMember = decorateTeamMember(teamMemberObj);

			setPageState('personal');

			onDateOfBirthChange(teamMemberObj);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onNINumberUpdate (teamMemberNINumberValidationObj) {

		function onTeamMemberMatch () {

			// Show success message
			growl.success($scope.teamMember.Personal.Forename + '\'s personal details have been updated.');

			// Redirect to matched profile
			$state.go($state.current.name, {
				agencyProfileId: agencyProfileId,
				userId: teamMemberNINumberValidationObj.UserID
			});
		}

		function onNINumberSave () {

			// Force callback
			$scope.formOptions.forceCallback();

			// Show success message
			growl.success($scope.teamMember.Personal.Forename + '\'s personal details have been updated.');

			// Personal wizard
			if ($scope.formOptions.isWizard) {

				// Pass properties into form wizard to use in later form steps
				angular.extend($scope.formOptions, {
					context: $scope.teamMember.Personal,
					contextType: 'user',
					showContext: true,
					userId: $scope.teamMember.Personal.UserID,
				});

				// Go to next step
				$scope.formOptions.onSuccess();
				return;
			}

			// Close form
			$scope.formOptions.closeForm();
		}

		// Redirect user to correct page if team member has been matched with an existing, registred  user in the system
		if (
			applicationService.isStateActive('team.profile') &&
			teamMemberNINumberValidationObj.UserID !== userId
		) {
			onTeamMemberMatch(teamMemberNINumberValidationObj);
			return;
		}

		switch (teamMemberNINumberValidationObj.ValidationState) {

			// Duplicate NI number in the system and the profile information doesn't match
			case NI_NUMBER_VALIDATION_STATES.invalidNINumber:
				setPageState('user-mismatch');
				break;

			case NI_NUMBER_VALIDATION_STATES.noIssue:
				onNINumberSave();
				break;

			case NI_NUMBER_VALIDATION_STATES.unknownError:
			default:
				onError();
		}
	}

	function onNiNumberPendingChange (teamMemberObj) {

		// Empty NI Number if set to pending
		if (teamMemberObj.Personal.NINumberPending) {
			teamMemberObj.Personal.NINumber = '';
		}
		else {
			utilities.focusOn('niNumber');
		}
	}

	function onDateOfBirthChange (teamMember) {

		// Checks age range
		$scope.formOptions.ageValidation = 0;
		teamData.getAgeRange(teamMember.Personal.DOBISO, teamMember.Gender, agencyProfileId)
		.then(value => $scope.formOptions.ageValidation = value)
		.catch(onError);
    }

	function reOpenSetupForm (teamMember) {

		// Change form
		setPageState('select-scheme');

		// Update form step
		teamMember.formStep = 1;
	}

	function reviewTeamMember (teamMember, form) {

		// Go to next step
		if (teamMember.formStep === 1) {

			// CIS Companies
			if (teamMember.Company.IsCISSubcontractor) {

				// Reset UTR when changing between business types
				teamMember.Personal.UTRPending = company.AgencyProfileDummy ? true : false;

				// Limited / Trust
				if (teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust) {

					teamMember.CIS.hasAddress = false;

					// Change form
					setPageState('cis-company');

					// Update form step
					teamMember.formStep = 2;

					return;
				}

				// Sole Trader / Partnership
				else {
					teamMember.isNIRequired = false;
					teamMember.isDOBRequired = false;
				}
			}

			// Everyone else
			else {
				teamMember.isNIRequired = true;
				teamMember.isDOBRequired = true;
			}

			// Change form
			setPageState('personal');

			// Update form step
			teamMember.formStep = 2;

			return;
		}

		// Update existing user
		if (teamMember.userContext === 'existing-user') {
			updateTeamMember(teamMember, form);
		}

		// Create new team member
		if (teamMember.userContext === 'new-user') {
			createNewTeamMember(teamMember, form);
		}
	}

	function reviewTitleSelection (teamMemberObj) {

		teamMemberObj.Personal.Gender = teamService.getGenderForTitle(teamMemberObj.Personal.Title);
	}

	function setIsUtrRequired (teamMemberObj) {

		if (teamMemberObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.soletrader) {
			// Sole trader. Base soley on AgencyProfileDummy (true => playground company)
			teamMemberObj.isUtrRequired = !company.AgencyProfileDummy;
		}
		else {
			// Non sole-trader, UTR disabled if UTR is pending or this is a playground company
			teamMemberObj.isUtrRequired = !(teamMemberObj.Personal.UTRPending || company.AgencyProfileDummy);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setTeamMemberFormStep (teamMember, formStep) {

		teamMember.formStep = formStep;
	}

	function setupNewTeamMember () {

		setPageState('loading');

		let teamMember = {
			Personal: {
				DOBISO: undefined,
				Forename: '',
				Gender: null,
				Middlenames: '',
				NINumber: '',
				NINumberOriginal: '',
				NINumberPending: company.AgencyProfileDummy ? true : false, // If test company, force NI Number Pending
				Surname: '',
				UTR: company.AgencyProfileDummy ? '2234567890' : '',
				UTRPending: company.AgencyProfileDummy ? true : false
			},
			CIS: {
				BusinessDetails: {
					BusinessType: 0,
					PartnershipUTR: '',
					TradingName: ''
				},
				DateVerifiedISO: '',
				IsVerified: false,
				TaxTreatment: 0,
				VATRegistrationNumber: '',
				VerificationReference: '',
				VerificationState: SUBMISSION_STATES.unsubmitted
			},
			CISCompanyAddressPending: false,
			CISCompanyAddress: {
				AddressCity: '',
				AddressCountry: '',
				AddressCounty: '',
				AddressID: '00000000-0000-0000-0000-000000000000',
				AddressName: '',
				AddressNumber: '',
				AddressPostcode: '',
				AddressStreet: ''
			},
			Company: {
				IsStarter: company.HasRunPayroll, // Make New Starter if company has run a live payroll
				// Set to CIS if company is CISOny, otherwise default to PAYE
				schemeType: company.CISOnly ? SCHEME_TYPES.cis : SCHEME_TYPES.paye,
				// See comments in updateTeamMemberScheme below
				IsCISSubcontractor: company.CISOnly ? true : false,
				IsOffPayrollWorker: false
			},
			formStep: (company.IsCISActive || company.IsOffPayrollActive) ? 1 : 2,
			isNIRequired: true,
			isDOBRequired: true
		};

		// Scope
		$scope.teamMember = decorateTeamMember(teamMember);

		// Page state
		setPageState(teamMember.formStep === 1 ? 'select-scheme' : 'personal');
	}

	function updateTeamMember (teamMember, form) {

		form.state = 'saving';

		teamData.updateTeamMemberPersonal(teamMember.Personal, userId, agencyProfileId).then(function () {

			// Empty NI Number if set to pending
			if (teamMember.Personal.NINumberPending) {
				teamMember.Personal.NINumber = '';
			}

			// Ni number not changed
			if (teamMember.Personal.NINumber === teamMember.Personal.NINumberOriginal) {

				// Force callback
				$scope.formOptions.forceCallback();

				// Show success message
				growl.success(teamMember.Personal.Forename + '\'s personal details have been updated.');

				// Wizard
				if ($scope.formOptions.isWizard) {
					$scope.formOptions.context = teamMember.Personal;
					$scope.formOptions.showContext = true;
					$scope.formOptions.contextType = 'user';
					$scope.formOptions.userId = teamMember.Personal.UserID;
					$scope.formOptions.onSuccess();
					return;
				}

				// Close form
				$scope.formOptions.closeForm();

				// Form state
				form.state = 'saved';

				return;
			}

			// If it's an update and the NI Number has changed then update the NI Number specially
			teamData.updateTeamMemberNINumber(teamMember.Personal.NINumber, userId, agencyProfileId)
				.then(onNINumberUpdate)
				.catch(onError);
		})
		.catch(onError);
	}

	function updateTeamMemberScheme (schemeType, teamMemberObj) {

		/* schemeType maps to these actual model attributes:
			paye = 		 IsCISSubcontractor = false, IsOffPayrollWorker = false
			cis  = 		 IsCISSubcontractor = true,  IsOffPayrollworker = false
			offPayroll = IsCISSubcontrator = false, isOffPayrllWorker = true
		*/
		angular.extend(teamMemberObj.Company, {
			IsCISSubcontractor: (schemeType === SCHEME_TYPES.cis),
			IsOffPayrollWorker: (schemeType === SCHEME_TYPES.offPayroll)
		});
	}

	init();

	angular.extend($scope, {

		// Constants
		AGE_VALIDATION,
		BUSINESS_TYPES,
		COMPANY_STATES,
		SALUTATIONS,
		TAX_TREATMENT_OPTIONS,
		SCHEME_TYPES,

		// Variables
		agencyProfileId,

		// Functions
		inviteToRegister,
		onNiNumberPendingChange,
		onDateOfBirthChange,
		reOpenSetupForm,
		reviewTeamMember,
		reviewTitleSelection,
		setIsUtrRequired,
		setPageState,
		setTeamMemberFormStep,
		updateTeamMemberScheme,
		vm: {
			isNiNoteVisible: true,
		}
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('personalOverviewForm', function () {

	return {
		controller: 'personalOverviewFormCtrl',
		templateUrl: 'forms/personal/personal-overview/personalOverviewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('personalOverviewFormCtrl', ['$rootScope', '$scope', 'teamData', 'FORM_WIZARD_KEYS',
	function ($rootScope, $scope, teamData, FORM_WIZARD_KEYS) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		teamData.getTeamMemberInformation(userId, agencyProfileId).then(function (teamMemberObj) {

			$scope.teamMember = teamMemberObj;

			var taskListGroupsArray = [
				{
					groupTitle: 'Personal Details',
					taskList: [
						{
							title: 'Title',
							value: teamMemberObj.Personal.Title,
							isComplete: teamMemberObj.Personal.Title !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'First name',
							value: teamMemberObj.Personal.Forename,
							isComplete: teamMemberObj.Personal.Forename !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Middle names',
							value: teamMemberObj.Personal.Middlenames,
							isComplete: teamMemberObj.Personal.Middlenames !== '',
							isMandatory: false,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Gender',
							value: teamMemberObj.Personal.Gender,
							isComplete: teamMemberObj.Personal.Gender !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Date of birth',
							value: teamMemberObj.Personal.DOBISO,
							isComplete: teamMemberObj.Personal.DOBISO !== '',
							isMandatory: true,
							valueType: 'date',
							wizardFormStepIndex: 0
						},
						{
							title: 'National Insurance number',
							value: teamMemberObj.Personal.NINumberPending ? 'Waiting for NI Number' : teamMemberObj.Personal.NINumber,
							isComplete: teamMemberObj.Personal.NINumberPending || teamMemberObj.Personal.NINumber !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 0
						}
					]
				},
				{
					groupTitle: 'Email',
					taskList: [
						{
							title: 'Email address',
							value: teamMemberObj.Personal.DummyEmail ? 'Doesn\'t have an email' : teamMemberObj.Personal.Email,
							isComplete: teamMemberObj.Personal.DummyEmail || teamMemberObj.Personal.Email !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 1
						}
					]
				},
				{
					groupTitle: 'Address',
					taskList: [
						{
							title: 'Home address',
							value: teamMemberObj.AddressSetupComplete ? teamMemberObj.Address : '',
							isComplete: teamMemberObj.AddressSetupComplete,
							isMandatory: false,
							valueType: teamMemberObj.AddressSetupComplete ? 'address' : 'value',
							wizardFormStepIndex: 2
						}
					]
				},
				{
					groupTitle: 'Contact details',
					taskList: [
						{
							title: 'Main contact number',
							value: teamMemberObj.TelephoneSetupComplete ? teamMemberObj.Personal.PhoneNumberPrimary : '',
							isComplete: teamMemberObj.TelephoneSetupComplete,
							isMandatory: false,
							valueType: 'value',
							wizardFormStepIndex: 3
						},
						{
							title: 'Other contact number',
							value: teamMemberObj.Personal.PhoneNumberSecondary !== '' ? teamMemberObj.Personal.PhoneNumberSecondary : '',
							isComplete: teamMemberObj.Personal.PhoneNumberSecondary,
							isMandatory: false,
							valueType: 'value',
							wizardFormStepIndex: 3
						}
					]
				},
				{
					groupTitle: 'Payment details',
					taskList: [] // Populated below
				},
				/*
				{
					groupTitle: 'Company details',
					taskList: [
						{
							title: 'Job title',
							value: teamMemberObj.Company.JobTitle,
							isComplete: teamMemberObj.Company.JobTitle !== '',
							isMandatory: false,
							valueType: 'value',
							wizardFormStepIndex: 4
						},
						{
							title: 'Start date',
							value: teamMemberObj.Company.StartDateISO,
							isComplete: teamMemberObj.Company.StartDateISO !== '',
							isMandatory: teamMemberObj.Company.IsStarter,
							valueType: teamMemberObj.Company.StartDateISO !== '' ? 'date' : 'value',
							wizardFormStepIndex: 4
						},
						{
							title: 'Payroll ID',
							value: teamMemberObj.Company.StaffNumber,
							isComplete: teamMemberObj.Company.StaffNumber !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 4
						},
						{
							title: 'HMRC Submission ID',
							value: teamMemberObj.Company.PayrollNumber !== '' && (teamMemberObj.Company.PayrollNumber !== teamMemberObj.Company.StaffNumber) ? teamMemberObj.Company.PayrollNumber : 'No',
							isComplete: teamMemberObj.Company.PayrollNumber !== '',
							isMandatory: true,
							valueType: 'value',
							wizardFormStepIndex: 4
						},
						{
							title: 'Company Director',
							value: teamMemberObj.Company.IsDirector,
							isComplete: teamMemberObj.Company.IsDirector !== '',
							isMandatory: true,
							valueType: 'boolean',
							wizardFormStepIndex: 4
						},
						{
							title: 'Apprentice',
							value: teamMemberObj.Company.IsApprentice,
							isComplete: teamMemberObj.Company.IsApprentice !== '',
							isMandatory: true,
							valueType: 'boolean',
							wizardFormStepIndex: 4
						}
					]
				},
				{
					groupTitle: 'Salary details',
					taskList: [
						{
							title: 'Salary Type',
							value: teamMemberObj.Salary.SalaryType,
							isComplete: teamMemberObj.Salary.SalaryType !== '',
							isMandatory: false,
							valueType: 'salary-type',
							wizardFormStepIndex: 5
						},
						{
							title: 'Employment Type',
							value: teamMemberObj.Salary.IsPartTime ? 'Part Time' : 'Full Time',
							isComplete: teamMemberObj.Salary.IsPartTime !== '',
							isMandatory: false,
							valueType: 'value',
							wizardFormStepIndex: 5
						}
					]
				}
				*/
			];

			// Payment details
			if (teamMemberObj.Bank.BankAccountNumber !== '') {
				taskListGroupsArray[4].taskList.push(
					{
						title: 'Bank / Building Society',
						value: teamMemberObj.Bank.BuildingSocietyReference === '' ? 'Bank' : 'Building Society',
						isComplete: teamMemberObj.Bank.BankAccountNumber !== '',
						isMandatory: true,
						valueType: 'value',
						wizardFormStepIndex: 4
					},
					{
						title: 'Bank account number',
						value: teamMemberObj.Bank.BankAccountNumber,
						isComplete: teamMemberObj.Bank.BankAccountNumber !== '',
						isMandatory: true,
						valueType: 'value',
						wizardFormStepIndex: 4
					},
					{
						title: 'Sort code',
						value: teamMemberObj.Bank.SortCode,
						isComplete: teamMemberObj.Bank.SortCode !== '',
						isMandatory: true,
						valueType: 'value',
						wizardFormStepIndex: 4
					}
				);
			}
			else {
				taskListGroupsArray[4].taskList.push(
					{
						title: 'Bank / Building Society',
						value: teamMemberObj.BankSetupComplete ? 'Doesn\'t have any account details' : '',
						isComplete: teamMemberObj.BankSetupComplete,
						isMandatory: false,
						valueType: 'value',
						wizardFormStepIndex: 4
					}
				);
			}

			// Salary
			/*
			switch (teamMemberObj.Salary.SalaryType) {
				case PAYMENT_TYPES.salary:
					taskListGroupsArray[5].taskList.push(
						{
							title: 'Salary',
							value: teamMemberObj.Salary.SalaryYearly,
							isComplete: teamMemberObj.Salary.SalaryYearly !== 0,
							isMandatory: false,
							valueType: 'monetise',
							wizardFormStepIndex: 5
						}
					);
					break;
				case PAYMENT_TYPES.hourly:
					taskListGroupsArray[5].taskList.push(
						{
							title: 'Hourly Pay',
							value: $filter('monetise')(teamMemberObj.Salary.SalaryHourlyRate) + '/hr, ' + teamMember.Salary.SalaryHours + ' hrs/week',
							isComplete: teamMemberObj.Salary.SalaryHourlyRate !== 0,
							isMandatory: false,
							valueType: 'salary-type',
							wizardFormStepIndex: 5
						}
					);
					break;
				case PAYMENT_TYPES.net:
					taskListGroupsArray[5].taskList.push(
						{
							title: 'Net pay',
							value: teamMemberObj.Salary.SalaryYearly,
							isComplete: teamMemberObj.Salary.SalaryYearly !== 0,
							isMandatory: false,
							valueType: 'monetise',
							wizardFormStepIndex: 5
						}
					);
					break;
			}
			*/

			$scope.taskListGroups = taskListGroupsArray;

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.openEditTeamMemberWizard = function (activeStepIndex) {

		$scope.formOptions.openNewFormWizard({
			activeStepIndex: activeStepIndex,
			wizardKey: FORM_WIZARD_KEYS.teamMemberEditPersonal,
			agencyProfileId: agencyProfileId,
			userId: userId
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('passportForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'passportFormCtrl',
	templateUrl: 'forms/personal/passport/passport.form.html'
})

.controller('passportFormCtrl', [
	'growl',
	'teamData',
	'NATIONALITIES',
	function (
		growl,
		teamData,
		NATIONALITIES
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		teamData.getTeamMemberInformation($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(teamMemberObj => {

				angular.extend($ctrl, {
					teamMember: teamMemberObj
				});


				if ($ctrl.formOptions.formState === 'delete-information') {
					setFormState('delete-information');

				} else {
					setFormState('ready');
				}
			})
			.catch(onError);
	}

	function onDeletePassportInformation ($form) {

		// Reset fields
		angular.extend($ctrl.teamMember.Personal, {
			Nationality: '',
			PassportExpiryDateISO: '',
			PassportNumber: '',
			UKArrivalDateISO: '',
			VisaExpiryDateISO: '',
			VisaNumber: '',
		});

		// Save
		updateTeamMemberPassportInformation($form);
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	function updateTeamMemberPassportInformation ($form) {

		$form.state = 'saving';

		teamData.updateTeamMemberPersonal($ctrl.teamMember.Personal, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {
				growl.success('Passport and Visa details updated');
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		onDeletePassportInformation,
		updateTeamMemberPassportInformation,

		NATIONALITIES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('telephoneForm', function () {

	return {
		controller: 'telephoneFormCtrl',
		templateUrl: 'forms/personal/telephone/telephoneForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('telephoneFormCtrl', ['$scope', 'teamData', function ($scope, teamData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		teamData.getTeamMemberInformation(userId, agencyProfileId).then(function (teamMemberObj) {

			$scope.teamMemberObj = teamMemberObj;

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function saveTelephoneDetails (teamMemberObj, form) {

		form.state = 'saving';

		teamData.updateTeamMemberPersonal(teamMemberObj.Personal, userId, agencyProfileId).then(function () {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			$scope.formOptions.callback();
			$scope.formOptions.closeForm();
			form.state = 'saved';

		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.saveTelephoneDetails = function (teamMemberObj, form) {

		saveTelephoneDetails(teamMemberObj, form);
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('unregisterUserForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'unregisterUserFormCtrl',
	templateUrl: 'forms/personal/unregister-user/unregister-user.form.html'
})

.controller('unregisterUserFormCtrl', [
	'$q',
	'securityData',
	function (
		$q,
		securityData
	) {

	const $ctrl = this;

	function $onInit () {
		setPageState('ready');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function unregisterUser ($form) {

		$form.state = 'saving';

		const unlinkAccessAccounts = securityData.unlinkAccessAccount($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId);  

		const userUnregister = securityData.userUnregister($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId);

		$q.all([unlinkAccessAccounts, userUnregister]).then(() => {

				setPageState('success');

				$ctrl.formOptions.forceCallback();
			})
			.catch(onError);	
	}

	angular.extend($ctrl, {
		$onInit,
		unregisterUser,

		confirmInformation: false
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('userDocumentsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'userDocumentsFormCtrl',
	templateUrl: 'forms/personal/user-documents/user-documents.form.html'
})

.constant('UPLOADS_DOCUMENTS_FORMS', {
	deleteFile: 'delete-file',
	editFile: 'edit-file',
	uploadFile: 'upload-file'
})

.controller('userDocumentsFormCtrl', [
	'$timeout',
	'config',
	'dataTransfer',
	'growl',
	'libraries',
	'teamData',
	'utilities',
	'UPLOADS_DOCUMENTS_FORMS',
	'USER_DOCUMENT_IDS',
	'USER_DOCUMENT_STATES',
	function (
		$timeout,
		config,
		dataTransfer,
		growl,
		libraries,
		teamData,
		utilities,
		UPLOADS_DOCUMENTS_FORMS,
		USER_DOCUMENT_IDS,
		USER_DOCUMENT_STATES
	) {

	const $ctrl = this;

	const FILE_TYPE_GLOBAL_OPTIONS = {
		differentForEachFile: 'different-for-each-file',
		sameForAllFiles: 'same-for-all-files'
	};

	const FILE_TYPE_OPTIONS = [
		{
			label: 'Other',
			key: USER_DOCUMENT_IDS.other,
		},
		{
			label: 'Payslip',
			key: USER_DOCUMENT_IDS.manualPayStatement,
		},
		{
			label: 'CIS pay statement',
			key: USER_DOCUMENT_IDS.cisPayStatement,
		},
		{
			label: 'P60',
			key: USER_DOCUMENT_IDS.p60,
		},
		{
			label: 'P45',
			key: USER_DOCUMENT_IDS.p45,
		},
		{
			label: 'MATB1',
			key: USER_DOCUMENT_IDS.matb1,
		},
		{
			label: 'P11D',
			key: USER_DOCUMENT_IDS.p11d,
		},
	];

	function $onInit () {

		angular.extend($ctrl, {
			documents: [],
			globalFileTypeOption: FILE_TYPE_GLOBAL_OPTIONS.sameForAllFiles,
			globalFileType: USER_DOCUMENT_IDS.manualPayStatement,
		});

		if ($ctrl.formOptions.formState === UPLOADS_DOCUMENTS_FORMS.editFile) {

			angular.extend($ctrl.formOptions.document, {
				taxYearDate: getTaxYearDateDetail(),
				available: ($ctrl.formOptions.document.UserDocumentState === USER_DOCUMENT_STATES.visibleInUserPortal),
			});

			// Tax year select
			if ([USER_DOCUMENT_IDS.p60, USER_DOCUMENT_IDS.p11d].includes($ctrl.formOptions.document.UserDocumentTypeID)) {

				const dateRangeArr = $ctrl.formOptions.document.UserDocumentLabel.split('-');

				angular.extend($ctrl.formOptions.document.taxYearDate, {
					endDate: parseInt(dateRangeArr[1]),
					startDate: parseInt(dateRangeArr[0])
				});
			}
		}
	}

	function closeForm () {
		$ctrl.formOptions.forceCallback();
		$ctrl.formOptions.closeForm();
	}

	function decorateDocumentPreUpload (documentObj) {

		// Change label based on file type
		documentObj.params.label = getDocumentLabelPreUpload(documentObj);

		// Clear single date for tax year files
		if ([USER_DOCUMENT_IDS.p60, USER_DOCUMENT_IDS.p11d].includes(documentObj.params.filetype)) {
			documentObj.params.date = '';
		}

		// Attch document upload urls to documents
		documentObj.url = libraries.httpHandler.upload.userDocument;
		documentObj.formData = [dataTransfer.getRequestBodyDetailDefault(documentObj.params)];

		return documentObj;
	}

	function deleteUserDocument ($ctrl, $form) {

		$form.state = 'saving';

		teamData.deleteUserDocument($ctrl.formOptions.document.AgencyDocumentID, $ctrl.formOptions.agencyProfileId)
			.then(() => {
				growl.success('Document deleted');
			})
			.then(closeForm)
			.catch(onError);
	}

	function getDocumentLabelPreUpload (documentObj) {

		if (documentObj.params) {
			switch (documentObj.params.filetype) {
				case USER_DOCUMENT_IDS.other:
					return documentObj.params.label;

				case USER_DOCUMENT_IDS.p60:
				case USER_DOCUMENT_IDS.p11d:
					return `${documentObj.taxYearDate.startDate}-${documentObj.taxYearDate.endDate}`;

				default:
					return getFileLabel(documentObj);
			}

		} else {

			switch (documentObj.UserDocumentTypeID) {
				case USER_DOCUMENT_IDS.other:
					return documentObj.UserDocumentLabel;

				case USER_DOCUMENT_IDS.p60:
				case USER_DOCUMENT_IDS.p11d:
					return `${documentObj.taxYearDate.startDate}-${documentObj.taxYearDate.endDate}`;

				default:
					return getFileLabel(documentObj);
			}
		}
	}

	function getFileLabel (documentObj) {
		return documentObj.DocumentName.replace(/\.[^/.]+$/, '');
	}

	function getTaxYearDateDetail () {

		const taxTearStartDateISO = utilities.getTaxYearStartDateForDate(moment(), true);
		const taxTearEndDateISO = utilities.getTaxYearEndDateForDate(false, true, moment());

		return {
			endDate: parseInt(moment(taxTearEndDateISO).format('YYYY')),
			startDate: parseInt(moment(taxTearStartDateISO).format('YYYY'))
		};
	}

	function onDocumentTypeChange (documentObj) {
		if (documentObj.UserDocumentTypeID === USER_DOCUMENT_IDS.other) {
			documentObj.UserDocumentLabel = '';
		}
	}

	function onTaxYearStartDateChange (documentObj) {
		documentObj.taxYearDate.endDate = parseInt(moment(documentObj.taxYearDate.startDate, 'YYYY').add(1, 'years').format('YYYY'));
	}

	function onError (error) {
		console.error(error);
		setFormState('error');
	}

	function setDocumentsFileTypeToGlobal ($ctrl) {

		for (let documentObj of $ctrl.documents) {
			documentObj.params.filetype = $ctrl.globalFileType;
		}
	}

	function setFormState (newState) {
		$ctrl.formOptions.formState = newState;
	}

	function updateFiles ($ctrl) {

		const currentDateMoment = moment();

		for (let documentObj of $ctrl.documents) {

			if (angular.isUndefined(documentObj.params)) {

				// Decoate document with parameters for uploads
				documentObj.params = {
					agencyprofileid: $ctrl.formOptions.agencyProfileId,
					available: false,
					date: currentDateMoment.format(config.dateFormatISO),
					filename: documentObj.DocumentName,
					filetype: $ctrl.globalFileType,
					label: getFileLabel(documentObj),
					userid: $ctrl.formOptions.context.UserID
				};

				// Attaxh tax date properties
				documentObj.taxYearDate = getTaxYearDateDetail();

			}
		}
	}

	function decorateDocumentPreUpdate (documentObj) {

		angular.extend(documentObj, {
			// Available in portal
			UserDocumentState: documentObj.available ? USER_DOCUMENT_STATES.visibleInUserPortal : USER_DOCUMENT_STATES.hiddenInUserPortal,
			UserDocumentLabel: getDocumentLabelPreUpload(documentObj)
		});

		// Clear single date for tax year files
		if ([USER_DOCUMENT_IDS.p60, USER_DOCUMENT_IDS.p11d].includes(documentObj.UserDocumentTypeID)) {
			angular.extend(documentObj, {
				UserDocumentManualDateISO: moment().format(config.dateFormatISO),
				UserDocumentData: documentObj.UserDocumentLabel
			});

		} else {
			angular.extend(documentObj, {
				UserDocumentManualYearFrom: '',
				UserDocumentManualYearTo: ''
			});
		}
	}

	function updateUserDocument ($ctrl, $form) {

		$form.state = 'saving';

		decorateDocumentPreUpdate($ctrl.formOptions.document);

		teamData.updateUserDocument($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.document)
			.then(() => {
				growl.success('Document updated');
			})
			.then(closeForm)
			.catch(onError);
	}

	function uploadDocuments ($ctrl, $form) {

		$form.state = 'saving';

		$ctrl.documents = $ctrl.documents.filter(decorateDocumentPreUpload);

		// Get uploader attached to first file, attached by FileUploader
		const $uploader = $ctrl.documents[0].uploader;
		if (!$uploader) {
			onError();
			return;
		}

		// Upload documents
		$uploader.uploadAll(0);


		// Because of the way the API works, file uploads are always "successful" even if the file didn't get uploaded
		$uploader.onSuccessItem = (documentObj, responseArr) => {

			// If file upload is successful
			if (responseArr.length > 0) {
				growl.success(`${documentObj.DocumentName} successfully uploaded`);
			}

			// If file upload is unsuccessful (file size too bug/contains virus)
			else {
				growl.error(`${documentObj.DocumentName} is invalid`);
			}
		};

		// Close form once all files have been processed
		$uploader.onCompleteAll = () => {

			$form.state = 'saved';

			$timeout(closeForm, 1000);
		};
	}

	angular.extend($ctrl, {
		$onInit,
		closeForm,
		deleteUserDocument,
		onDocumentTypeChange,
		onTaxYearStartDateChange,
		setDocumentsFileTypeToGlobal,
		setFormState,
		updateFiles,
		updateUserDocument,
		uploadDocuments,

		FILE_TYPE_GLOBAL_OPTIONS,
		FILE_TYPE_OPTIONS,
		UPLOADS_DOCUMENTS_FORMS,
		USER_DOCUMENT_IDS
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('userDownloadsDocumentForm',  {
	bindings: {
		formOptions: '='
	},
	controller: 'userDownloadsDocumentFormCtrl',
	templateUrl: 'forms/personal/user-download-documents/user-download-documents.form.html'
})

.controller('userDownloadsDocumentFormCtrl', [
	'dataTransfer',
	'reportData',
	'USER_DOCUMENT_IDS',
	function (
		dataTransfer,
		reportData,
		USER_DOCUMENT_IDS
	) {

		const $ctrl = this;

		function $onInit () {

			setPageState('loading');

			const agencyProfileId = $ctrl.formOptions.agencyProfileId;
			const userIds = $ctrl.formOptions.userIds;

			reportData.getBulkDocumentDownloadDetails(agencyProfileId, userIds)
				.then((bulkDocumentDownloadDetailsObj) => {

					bulkDocumentDownloadDetailsObj.PayslipsPeriods.forEach(decoratePayPeriod);
					bulkDocumentDownloadDetailsObj.CISPeriods.forEach(decoratePayPeriod);
					bulkDocumentDownloadDetailsObj.P45Periods.forEach(decoratePayPeriod);
					bulkDocumentDownloadDetailsObj.P60Periods.forEach(decoratePayPeriod);

					const fileTypeOptions = getFileTypeOptions(bulkDocumentDownloadDetailsObj);

					if (fileTypeOptions.length === 0) {
						setPageState('no-documents');
						return;
					}

					angular.extend($ctrl, {
						bulkDocumentDownloadDetails: bulkDocumentDownloadDetailsObj,
						passwordProtectionEnabled: false,
						showPassword: false,
						FILE_TYPE_OPTIONS: fileTypeOptions,
						globalFileType: fileTypeOptions[0].key,
					});
		
					onFileTypeChange();

					setPageState('ready');
				})
				.catch(onError);
		}

		function decoratePayPeriod (payPeriodObj) {

			payPeriodObj.startDateUnix = moment(payPeriodObj.StartDateISO).format('x');
		}

		function refreshPayPeriods () {

			let newPayPeriodsTo = angular.copy($ctrl.periods);
	
			$ctrl.periodFrom = $ctrl.periodFromId ? $ctrl.periods.find(payPeriod => payPeriod.PayPeriodID === $ctrl.periodFromId) : null;
			$ctrl.periodTo 	= $ctrl.periodToId ? $ctrl.periods.find(payPeriod => payPeriod.PayPeriodID === $ctrl.periodToId) : null;
	
			// Get from and to pay periods, maximum 12 months between them
			$ctrl.periodsTo = newPayPeriodsTo.filter(payPeriod => {
	
				if (!$ctrl.periodFrom) {
					return true;
				}
	
				const fromPeriodM = moment($ctrl.periodFrom.StartDateISO);
				const toPeriodM = moment(payPeriod.StartDateISO);

				if (toPeriodM.isSameOrAfter(fromPeriodM) && toPeriodM.diff(fromPeriodM, 'months') < 12) {
					return true;
				}
	
				return;
			});
		}

		function getFileTypeOptions (bulkDocumentDownloadDetailsObj) {

			const fileTypeOptions = [];

			if (bulkDocumentDownloadDetailsObj.CanDownloadPayslips) {
				fileTypeOptions.push({ label: 'Payslip', key: USER_DOCUMENT_IDS.payStatement });
			}

			if (bulkDocumentDownloadDetailsObj.CanDownloadCIS) {
				fileTypeOptions.push({ label: 'CIS pay statement', key: USER_DOCUMENT_IDS.payrollCisStatement });
			}

			if (bulkDocumentDownloadDetailsObj.CanDownloadP45) {
				fileTypeOptions.push({ label: 'P45', key: USER_DOCUMENT_IDS.payrollP45 });
			}

			if (bulkDocumentDownloadDetailsObj.CanDownloadP60) {
				fileTypeOptions.push({ label: 'P60', key: USER_DOCUMENT_IDS.payrollP60 });
			}

			return fileTypeOptions;
		}

		function onError (error) {

			console.error(error);
			setPageState('error');
		}

		function onFileTypeChange () {

			if (!$ctrl.globalFileType) {
				return;
			}

			let periods = $ctrl.periods; 

			switch($ctrl.globalFileType) {

				case USER_DOCUMENT_IDS.payStatement:
					periods = $ctrl.bulkDocumentDownloadDetails.PayslipsPeriods;
					break;

				case USER_DOCUMENT_IDS.payrollCisStatement:
					periods = $ctrl.bulkDocumentDownloadDetails.CISPeriods;
					break;

				case USER_DOCUMENT_IDS.payrollP45:
					periods = $ctrl.bulkDocumentDownloadDetails.P45Periods;
					break;

				case USER_DOCUMENT_IDS.payrollP60:
					periods = $ctrl.bulkDocumentDownloadDetails.P60Periods;
					break;
			}

			angular.extend($ctrl, {
				periods,
				periodsFrom: angular.copy(periods),
				periodsTo: angular.copy(periods),
				periodFromId: undefined,
				periodToId: undefined
			});
		}

		function setPageState (newState) {

			$ctrl.pageState = newState;
		}

		function togglePasswordVisibility () {

			$ctrl.showPassword = !$ctrl.showPassword;
		}

		function downloadFile () {

			setPageState('zip-documents');

			reportData.createUserDocumentZipDownload($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userIds, $ctrl.globalFileType, $ctrl.periodFromId, $ctrl.periodToId, $ctrl.password)
				.then(documentZipDownloadUrl => {
					dataTransfer.downloadFile(documentZipDownloadUrl).then(() => {
						$ctrl.formOptions.closeForm();
					});
				})
				.catch(onError);
		}

		angular.extend($ctrl, {
			$onInit,

			downloadFile,
			onFileTypeChange,
			refreshPayPeriods,
			togglePasswordVisibility,
		});
	}]);

'use strict';

angular.module('paycircleApp')

	.component('addToBusinessCategoryForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'addToBusinessCategoryFormCtrl',
		templateUrl: 'forms/employment/add-to-business-category/add-to-business-category.form.html'
	})

	.controller('addToBusinessCategoryFormCtrl', [
		'$q',
		'config',
		'journalsService',
		'reportData',
		'user',
		'userData',
		function (
			$q,
			config,
			journalsService,
			reportData,
			user,
			userData
		) {

			const $ctrl = this;

			const EMPTY_BUSINESS_CATEGORY_CHANGE = {
				BusinessCategory: null,
				BusinessCodeID: null
			};

			function $onInit () {

				setFormState('loading');

				const getBusinessCategoryListForAgency = reportData.getBusinessCategoryListForAgency($ctrl.formOptions.agencyProfileId);
				const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();
				// Used for the case when we want to set a business code to "No - allocated"
				const getEmptyBusinessCodeMember =  userData.getEmptyBusinessCodeMember();

				$q.all([
					getBusinessCategoryListForAgency,
					getEmptyUserAgencyProfileBusinessCode,
					getEmptyBusinessCodeMember
				]).then(
				([
					businessCategoriesArr,
					emptyUserAgencyProfileBusinessCodeObj,
					emptyBusinessCodeMemberObj
				]) => {

					const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(emptyUserAgencyProfileBusinessCodeObj, $ctrl.formOptions.agencyProfileId, config.guidEmpty, config.guidEmpty);
					const businessCategories = getApplicableBusinessCategories(businessCategoriesArr);

					const userAgencyProfileBusinessCodes = journalsService.getEmptyUserAgencyProfileBusinessCodes(config.guidEmpty);

					angular.extend($ctrl, {
						businessCategories: journalsService.decorateBusinessCategories(businessCategories, userAgencyProfileBusinessCodes.UserAgencyProfileBusinessCodes),
						businessCategoryChanges: [],
						businessCodes: userAgencyProfileBusinessCodes,
						emptyUserAgencyProfileBusinessCode,
						businessCategoriesForCostSplit: [],
						emptyBusinessCodeMember: emptyBusinessCodeMemberObj
					});

					onAddAnother();

					setFormState('ready');
				})
				.catch(onError);
			}

			function businessCodeSelected () {

				function isBusinessCodeSelected (businessCategoryChange) {
					return angular.isDefined(businessCategoryChange.BusinessCategory) &&
						businessCategoryChange.BusinessCategory !== null &&
						businessCategoryChange.BusinessCategory.selectedBusinessCode !== null &&
						businessCategoryChange.BusinessCategory.selectedBusinessCode.BusinessCodeID !== null &&
						businessCategoryChange.BusinessCategory.selectedBusinessCode.BusinessCodeID !== config.guidEmpty;

				}

				return $ctrl.businessCategoryChanges.some(isBusinessCodeSelected);
			}

			function getApplicableBusinessCategories (businessCategoriesArr) {

				// Remove business categories with no business codes
				const applicableBusinessCategoriesArr = businessCategoriesArr.filter(businessCategoryObj => businessCategoryObj.BusinessCodes.length !== 0);

				// Add unallocated business code to category
				for (let businessCategoryObj of applicableBusinessCategoriesArr) {
					businessCategoryObj.BusinessCodes.unshift({
						BusinessCodeID: config.guidEmpty,
						BusinessCodeNarrative: `No ${businessCategoryObj.BusinessCategoryName} allocated`
					});
				}

				return applicableBusinessCategoriesArr;
			}

			function getUserBusinessCodeForSave () {

				let userBusinessCodes = [];
				let updateServices = [];

				// For each user, create a new business code allocation
				for (let userId of $ctrl.formOptions.userIds) {

					const businessCodes = angular.copy($ctrl.businessCodes);

					// If the user has a cost split business category, add the business codes to the userBusinessCodes array
					userBusinessCodes = userBusinessCodes.concat(getCostSplitsUserBusinessCodes(businessCodes, userId));

					//If there are primary business codes add them
					if ($ctrl.businessCategoryChanges.length > 0) {

						for (let change of $ctrl.businessCategoryChanges) {

							if (!userBusinessCodes.some(businessCode => businessCode.BusinessCodeID === change.BusinessCategory.selectedBusinessCode.BusinessCodeID && businessCode.UserID === userId)) {

								const newUserAgencyProfileBusinessCode = angular.copy($ctrl.emptyUserAgencyProfileBusinessCode);

								if (change.BusinessCategory.selectedBusinessCode.BusinessCodeID !== config.guidEmpty) {

									angular.extend(newUserAgencyProfileBusinessCode, {
										BusinessCategoryID: change.BusinessCategory.BusinessCategoryID,
										BusinessCodeID: change.BusinessCategory.selectedBusinessCode.BusinessCodeID,
										UserAgencyProfileBusinessCodeArchived: false,
										serAgencyProfileBusinessCodePercent: 100,
										UserAgencyProfileBusinessCodePrimary: true,
										UserAgencyProfileBusinessCodeID: config.guidEmpty,
										UserID: userId
									});

									userBusinessCodes.push(newUserAgencyProfileBusinessCode);
								}
							}
						}
					}
				}

				// add update services for business codes that are removed
				updateServices= [].concat(getBusinessCodeMembersUpdateServicesArrayForCategories());

				// add update services for business codes that are set to a value
				if (userBusinessCodes.length > 0) {

					updateServices.push(getUpdateUserAgencyProfileBusinessCodesService(userBusinessCodes));
				}

				return updateServices;
			}

			function getBusinessCodeMembersUpdateServicesArrayForCategories () {

				// Returns array of services calls for each business category type entered

				const businessCategoryUpdateServices = [];

				for (let businessCategoryObj of $ctrl.businessCategoryChanges) {

					if (businessCategoryObj.BusinessCategory !== null &&
						businessCategoryObj.BusinessCategory.selectedBusinessCode !== null &&
						businessCategoryObj.BusinessCategory.selectedBusinessCode.BusinessCodeID === config.guidEmpty) {

						const businessCodeMemberForCategoryArr = getMembersArrayForCategory(businessCategoryObj);

						const businessCategoryUpdateServiceForCategory = getUpdateBusinessCodeMembersForBusinessCategoryService(businessCategoryObj.BusinessCategory.BusinessCategoryID, businessCodeMemberForCategoryArr);

						businessCategoryUpdateServices.push(businessCategoryUpdateServiceForCategory);
					}
				}

				return businessCategoryUpdateServices;
			}

			function getMembersArrayForCategory (businessCategoryObj) {

				// Returns array of business code members with UserID and BusinessCodeID attached for each business category

				const businessCodeMemberForCategory = [];

				for (let userId of $ctrl.formOptions.userIds) {

					const businessCodeMemberForUserIdObj = angular.copy($ctrl.emptyBusinessCodeMember);

					angular.extend(businessCodeMemberForUserIdObj, {
						UserID: userId,
						BusinessCodeID: businessCategoryObj.BusinessCategory.BusinessCodeID
					});

					businessCodeMemberForCategory.push(businessCodeMemberForUserIdObj);
				}

				return businessCodeMemberForCategory;
			}

			function getUpdateBusinessCodeMembersForBusinessCategoryService (businessCategoryId, businessCodeMembersArr) {

				return userData.updateBusinessCodeMembersForBusinessCategory($ctrl.formOptions.agencyProfileId, businessCategoryId, businessCodeMembersArr);
			}

			function getUpdateUserAgencyProfileBusinessCodesService (userBusinessCodes) {

				return user.updateUserAgencyProfileBusinessCodes($ctrl.formOptions.agencyProfileId, userBusinessCodes);
			}

			function getCostSplitsUserBusinessCodes (businessCode, userId) {

				const userCostSplits = [];

				// If the user has a cost split business category, add the business codes to the userBusinessCodes array
				if (businessCode.BusinessCodeCostSplit.BusinessCategoryID !== config.guidEmpty) {

					for (let businessCodeSplit of businessCode.BusinessCodeCostSplit.UserAgencyProfileBusinessCodes) {

						businessCodeSplit.UserID = userId;
						businessCodeSplit.UserAgencyProfileBusinessCodePercent = parseFloat(businessCodeSplit.UserAgencyProfileBusinessCodePercent) || 0;

						userCostSplits.push(businessCodeSplit);
					}
				}
				return userCostSplits;
			}

			function isSelectedCostSplitBusinessCategory (businessCategoryChangeObj) {

				return businessCategoryChangeObj.BusinessCategory !== null && businessCategoryChangeObj.BusinessCategory.BusinessCategoryID === $ctrl.businessCodes.BusinessCodeCostSplit.BusinessCategoryID;
			}

			function onAddAnother () {

				$ctrl.businessCategoryChanges.push(angular.copy(EMPTY_BUSINESS_CATEGORY_CHANGE));
			}

			function onAddCostSplitClick () {

				const businessCategory = $ctrl.businessCategoryChanges.filter(category =>
					category.BusinessCategory !== null &&
					category.BusinessCategory.selectedBusinessCode !== null &&
					category.BusinessCategory.selectedBusinessCode.BusinessCodeID !== config.guidEmpty)[0].BusinessCategory;

				angular.extend($ctrl.businessCodes.BusinessCodeCostSplit, {
					BusinessCategoryID: businessCategory.BusinessCategoryID,
					UserAgencyProfileBusinessCodes: []
				});
			}

			function onBusinessCategoryChange () {

				const categoriesForCostSplit = [];
				for (let change of $ctrl.businessCategoryChanges) {

					if (change.BusinessCategory !== null &&
						change.BusinessCategory.selectedBusinessCode !== null &&
						change.BusinessCategory.selectedBusinessCode.BusinessCodeID !== config.guidEmpty) {

						categoriesForCostSplit.push(angular.copy(change.BusinessCategory));
					}
				}
				$ctrl.businessCategoriesForCostSplit = [].concat(categoriesForCostSplit);
			}

			function onBusinessCategoryChangeDelete ($index) {

				if ($ctrl.businessCategoryChanges[$index].BusinessCategory !== null) {

					if ($ctrl.businessCategoriesForCostSplit.some(change => change.BusinessCategoryID === $ctrl.businessCategoryChanges[$index].BusinessCategory.BusinessCategoryID)) {

						$ctrl.businessCategoriesForCostSplit = $ctrl.businessCategoriesForCostSplit.filter(change => change.BusinessCategoryID !== $ctrl.businessCategoryChanges[$index].BusinessCategory.BusinessCategoryID);
					}

					$ctrl.businessCategoryChanges[$index].BusinessCategory.selectedBusinessCode = null;
				}

				$ctrl.businessCategoryChanges.splice($index, 1);
			}

			function onError (error) {

				setFormState('error');
				console.log(error);
				throw new Error(error);
			}

			function setFormState (newState) {
				$ctrl.formState = newState;
			}
			function updateBusinessCodeMembersForBusinessCategory ($form) {

				$form.state = 'saving';

				$q.all(getUserBusinessCodeForSave())
					.then(() => {

						$ctrl.formOptions.forceCallback();

						setFormState('success');
					})
					.catch(onError);
			}

	angular.extend($ctrl, {
		$onInit,
		businessCodeSelected,
		isSelectedCostSplitBusinessCategory,
		onAddAnother,
		onAddCostSplitClick,
		onBusinessCategoryChange,
		onBusinessCategoryChangeDelete,
		updateBusinessCodeMembersForBusinessCategory
	});
}])

.filter('addToBusinessCategoryRemoveUsedCategories', function () {

	return function (
		businessCategoriesArr,
		businessCategoryChangesArr,
		currentValue
	) {

		// Returns array of Business Categories - Filtering out IDs that appear in updatesList more than once, unless ID is the current value

		function getUsedBusinessCategories () {

			const returnArr = [];

			for (let businessCategoryChangeObj of businessCategoryChangesArr) {

				// Initial value is null, don't include that in this array
				if (businessCategoryChangeObj.BusinessCategory) {
					returnArr.push(businessCategoryChangeObj.BusinessCategory.BusinessCategoryID);
				}
			}

			return returnArr;
		}

		function getApplicableBusinessIds () {

			function filterOutUsedBusinessCategories (businessCategoryObj) {

				// Can only select the business category type once
				const isBusinessCategoryIsNotAlreadyUsed = !usedBusinessCategoriesArr.includes(businessCategoryObj.BusinessCategoryID);

				// Keep the current value in the array as it would be removed from the dropdown otherwise
				const isBusinessCategoryCurrentValue = businessCategoryObj.BusinessCategoryID === currentValue;

				return isBusinessCategoryIsNotAlreadyUsed || isBusinessCategoryCurrentValue;
			}

			const usedBusinessCategoriesArr = getUsedBusinessCategories();

			return businessCategoriesArr.filter(filterOutUsedBusinessCategories);
		}

		return getApplicableBusinessIds();
	};
});

'use strict';

angular.module('paycircleApp')

.component('addTaxUpdateForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'addTaxUpdateFormCtrl',
	templateUrl: 'forms/employment/add-tax-update/add-tax-update.form.html'
})

.controller('addTaxUpdateFormCtrl', [
	'$q',
	'base',
	'config',
	'payrollData',
	'taxUpdatesService',
	'teamData',
	'utilities',
	'NI_CATEGORY_LETTER',
	'STUDENT_LOAN_PLANS',
	'TAX_CODES',
	'TAX_CODES_FIXED',
	function (
		$q,
		base,
		config,
		payrollData,
		taxUpdatesService,
		teamData,
		utilities,
		NI_CATEGORY_LETTER,
		STUDENT_LOAN_PLANS,
		TAX_CODES,
		TAX_CODES_FIXED
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const isEditMode = $ctrl.formOptions.isEditMode;
		const userId = $ctrl.formOptions.userId;

		const getNationalInsuranceLetters = base.getNationalInsuranceLetters(agencyProfileId, userId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([getNationalInsuranceLetters, getTeamMemberInformation])
			.then(([nationalInsuranceLettersArr, teamMemberObj]) => {

				const latestTaxUpdate = taxUpdatesService.getLatestTaxUpdate($ctrl.formOptions.taxUpdates);
				const teamMember = decorateTeamMember(teamMemberObj, latestTaxUpdate);

				if (!isEditMode) {

					// Check if the user can add a new tax update (cannot add before an existing update and cannot add future updates)
					const currentPeriodPayDate = moment($ctrl.formOptions.currentPayPeriod.PayDateISO);
					const manualUpdate = taxUpdatesService.getLatestManualTaxUpdate($ctrl.formOptions.taxUpdates);
					const minDates = [moment(manualUpdate.EffectiveDateISO), moment(teamMember.Tax.TaxChangeEffectiveDateMinISO)];

					if (moment.max(minDates).isSameOrAfter(currentPeriodPayDate, 'day')) {
						setFormState('cant-add-update');
						return;
					}
				}

				if (moment(latestTaxUpdate.EffectiveDateISO).isSame(teamMember.Tax.TaxChangeEffectiveDateMinISO, 'day')) {
					teamMember.Tax.TaxChangeEffectiveDateMinISO = moment(teamMember.Tax.TaxChangeEffectiveDateMinISO).add(1, 'days').toISOString();
				}

				const canEditBackdatedNI = teamMember.Tax.CanAddBackdatedNI || (isEditMode && latestTaxUpdate.HasBackdatedNI);
				const effectiveDateMaxISO = isEditMode ? latestTaxUpdate.EffectiveDateISO : $ctrl.formOptions.currentPayPeriod.PayDateISO;
				const effectiveDateMinISO = isEditMode ? latestTaxUpdate.EffectiveDateISO : teamMember.Tax.TaxChangeEffectiveDateMinISO;
				const taxUpdate = decorateTaxUpdate(latestTaxUpdate, teamMember);

				angular.extend($ctrl, {
					canEditBackdatedNI,
					editBlocksOpen: 0,
					effectiveDateMaxISO,
					effectiveDateMinISO,
					taxUpdate,
					taxUpdateCopy: angular.copy(taxUpdate),
					teamMember
				});

				setupTaxCodes($ctrl.formOptions.context.Gender, nationalInsuranceLettersArr);

				setFormState('ready');
			})
			.catch(onError);
	}

	function addTaxUpdate (teamMember, taxUpdate, form, isEdit) {

		form.state = 'saving';

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const userId = $ctrl.formOptions.userId;

		if (!teamMember.Tax.HasBackdatedNI) {
			teamMember.Tax.NICodeChangeEffectiveDateISO = '';
		}

		const newTaxUpdate = angular.extend(
			{},
			teamMember.Tax,
			{
				CivilianStartDateISO: taxUpdate.CivilianStartDateISO,
				HasNICodeChange: angular.isDefined(taxUpdate.NICodeChange) && taxUpdate.NICodeChange !== taxUpdate.NICode,
				HasTaxChangeEffectiveDate: true,
				NICode: taxUpdate.NICode,
				NICodeChange: taxUpdate.NICodeChange,
				PostGraduateLoan: taxUpdate.HasPostGraduateLoan,
				StudentLoan: taxUpdate.HasStudentLoan,
				StudentLoanPlan1: taxUpdate.HasStudentLoanPlan1,
				StudentLoanPlan2: taxUpdate.HasStudentLoanPlan2,
				StudentLoanPlan4: taxUpdate.HasStudentLoanPlan4,
				StudentLoanPlan5: taxUpdate.HasStudentLoanPlan5,
				TaxChangeEffectiveDateISO: taxUpdate.EffectiveDateISO,
				TaxCode: taxUpdate.TaxCode,
				TaxCodeM1W1: taxUpdate.TaxCodeM1W1,
				TaxInfoID: isEdit ? taxUpdate.TaxInfoID : undefined,
				UserTaxInfoID: isEdit ? taxUpdate.UserTaxInfoID : undefined
			}
		);

		const updateTeamMemberTax = isEdit ?
			teamData.updateTeamMemberTaxExisting(newTaxUpdate, userId, agencyProfileId) :
			teamData.updateTeamMemberTax(newTaxUpdate, userId, agencyProfileId);

		updateTeamMemberTax
			.then(() => {
				setFormState('saved');
			})
			.catch(onError);
	}

	function checkBackdatedNIStatus (niCodeChange, niCodeChangeEffectiveDateISO) {

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const teamMember = $ctrl.teamMember;
		const userId = $ctrl.formOptions.userId;

		// Recalculate if backdated NI status is set
		if (teamMember.Tax.HasBackdatedNI) {
			teamMember.Tax.calculatingBackdatedNI = true;
			payrollData.getTeamMemberBackdatedNI(userId, agencyProfileId, niCodeChange, niCodeChangeEffectiveDateISO).then((backdatedNIResponse) => {

				let backdatedNI = backdatedNIResponse.BackdatedNI;

				teamMember.Tax.backdatedNI = backdatedNI;
				// Update team member with total NIEE.
				teamMember.Tax.BackdatedNIEEAmount = backdatedNIResponse.BackdatedNIAmount;

				teamMember.Tax.calculatingBackdatedNI = false;
			})
			.catch(onError);
		}
	}

	function decorateTaxUpdate (taxUpdate, teamMemberObj) {

		// Student Loan
		taxUpdate = setupStudentLoan(taxUpdate, teamMemberObj);

		angular.extend(taxUpdate, {
			IsYTDInformationRequired: $ctrl.formOptions.currentPayPeriod.IsYTDInformationRequired,

			// NI calculations aside
			showBackdatedNICalculations: false,

			// Flag to indicate that backdated NI is being calculated.
			calculatingBackdatedNI: false,

			// Populate model with current ni code
			NICodeChange: taxUpdate.NICode,

			// Tax code
			taxCode: taxUpdate.TaxCode + (taxUpdate.TaxCodeW1M1 ? ' ' + config.w1m1Label : ''),

			// Alternative name
			TaxCodeM1W1: taxUpdate.TaxCodeW1M1,

			// Tax code change
			showTaxChangeDate: false,

			// Reset effective date
			EffectiveDateISO: $ctrl.formOptions.isEditMode ? taxUpdate.EffectiveDateISO : undefined,
		});

		return taxUpdate;
	}

	function decorateTeamMember (teamMember, latestTaxUpdate) {

		angular.extend(teamMember.Tax, {
			HasBackdatedNI: $ctrl.formOptions.isEditMode ? latestTaxUpdate.HasBackdatedNI : false,
			NICodeChangeEffectiveDateISO: $ctrl.formOptions.isEditMode ? latestTaxUpdate.BackdatedDateEffectiveISO : ''
		});

		return teamMember;
	}

	function niCodeOnChange (niCodeChange, niCodeChangeEffectiveDateISO) {

		if (niCodeChangeEffectiveDateISO) {
			checkBackdatedNIStatus (niCodeChange, niCodeChangeEffectiveDateISO);
		}
	}

	function niEffectiveFromDateOnChange (niCodeChange, niCodeChangeEffectiveDateISO) {

		if (niCodeChange) {
			checkBackdatedNIStatus (niCodeChange, niCodeChangeEffectiveDateISO);
		}
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function resetNICode (taxUpdateObj, taxUpdateCopyObj) {

		// Reset ni code change
		taxUpdateObj.NICodeChange = taxUpdateCopyObj.NICodeChange;

		updateEditBlockCount(-1);
		return taxUpdateObj;
	}

	function resetPostgraduateLoan (taxUpdateObj, taxUpdateCopyObj) {

		// Reset postgraduate loan flag
		taxUpdateObj.HasPostGraduateLoan = taxUpdateCopyObj.HasPostGraduateLoan;

		updateEditBlockCount(-1);
		return taxUpdateObj;
	}

	function resetStudentLoan (taxUpdateObj, taxUpdateCopyObj) {

		// Reset all student loan flags
		taxUpdateObj.HasStudentLoan = taxUpdateCopyObj.HasStudentLoan;
		taxUpdateObj.HasStudentLoanPlan1 = taxUpdateCopyObj.HasStudentLoanPlan1;
		taxUpdateObj.HasStudentLoanPlan2 = taxUpdateCopyObj.HasStudentLoanPlan2;
		taxUpdateObj.HasStudentLoanPlan4 = taxUpdateCopyObj.HasStudentLoanPlan4;
		taxUpdateObj.HasStudentLoanPlan5 = taxUpdateCopyObj.HasStudentLoanPlan5;
		taxUpdateObj.studentLoanPlanOption = taxUpdateCopyObj.studentLoanPlanOption;

		updateEditBlockCount(-1);
		return taxUpdateObj;
	}

	function resetTaxCode (taxUpdateObj, taxUpdateCopyObj) {

		// Reset tax code fields
		taxUpdateObj.TaxCode = taxUpdateCopyObj.TaxCode;
		taxUpdateObj.TaxCodeM1W1 = taxUpdateCopyObj.TaxCodeM1W1;
		taxUpdateObj.TaxCodeW1M1 = taxUpdateCopyObj.TaxCodeW1M1;

		updateEditBlockCount(-1);
		return taxUpdateObj;
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function setupStudentLoan (taxUpdateObj, teamMemberObj) {

		angular.extend(taxUpdateObj, {
			// Set visibility flags for student loan plans and postgraduate loan
			canShowStudentLoan: taxUpdatesService.canShowStudentLoanForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowStudentLoanPlan1: taxUpdatesService.canShowStudentLoanPlan1ForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowStudentLoanPlan2: taxUpdatesService.canShowStudentLoanPlan2ForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowStudentLoanPlan1and2: taxUpdatesService.canShowStudentLoanPlan1and2ForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowStudentLoanPlan4: taxUpdatesService.canShowStudentLoanPlan4ForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowStudentLoanPlan5: taxUpdatesService.canShowStudentLoanPlan5ForTaxUpdate(teamMemberObj, taxUpdateObj),
			canShowPostgraduateLoan: taxUpdatesService.canShowPostgraduateLoanForTaxUpdate(teamMemberObj, taxUpdateObj),
			// Get plan option for display
			studentLoanPlanOption: taxUpdatesService.getStudentLoanPlanOption(taxUpdateObj.HasStudentLoanPlan1, taxUpdateObj.HasStudentLoanPlan2, taxUpdateObj.HasStudentLoanPlan4, taxUpdateObj.HasStudentLoanPlan5)
		});

		return taxUpdateObj;
	}

	function setupTaxCodes (gender, nationalInsuranceLettersArr) {

		function niCategoryFilter (niCategory) {

			const isMale 		= utilities.isMale(gender);
			const isNiCategoryB	= niCategory === 'B';
			const isNiCategoryT = niCategory === 'T';

			// Males cannot have T or B NI Categories
			if (isMale && (isNiCategoryB || isNiCategoryT)) {
				return;
			}

			return niCategory;
		}

		angular.extend($ctrl, {
			NI_CATEGORY_LETTER:		NI_CATEGORY_LETTER,
			TAX_CODES:				TAX_CODES,
			TAX_CODES_FIXED:		TAX_CODES_FIXED,
			niCategoryLetters:		nationalInsuranceLettersArr.filter(niCategoryFilter)
		});
	}

	function toggleShowBackdatedNICalculations (teamMember) {

		teamMember.Tax.showBackdatedNICalculations = !teamMember.Tax.showBackdatedNICalculations;
	}

	function updateEditBlockCount (count) {

		$ctrl.editBlocksOpen += count;
	}

	function updateStudentLoan (taxUpdateObj) {

		// Unset all student loan flags
		taxUpdateObj.HasStudentLoanPlan1 = false;
		taxUpdateObj.HasStudentLoanPlan2 = false;
		taxUpdateObj.HasStudentLoanPlan4 = false;
		taxUpdateObj.HasStudentLoanPlan5 = false;

		// If student loan selected, turn them on according to selected option
		if (taxUpdateObj.HasStudentLoan) {
			// Switch on according to selected option
			switch (taxUpdateObj.studentLoanPlanOption) {
				case STUDENT_LOAN_PLANS.plan1and2: {
					taxUpdateObj.HasStudentLoanPlan1 = true;
					taxUpdateObj.HasStudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan1: {
					taxUpdateObj.HasStudentLoanPlan1 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan2: {
					taxUpdateObj.HasStudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan4: {
					taxUpdateObj.HasStudentLoanPlan4 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan5: {
					taxUpdateObj.HasStudentLoanPlan5 = true;
					break;
				}
			}
		} else {
			taxUpdateObj.studentLoanPlanOption = null;
		}

		return taxUpdateObj;
	}

	angular.extend($ctrl, {
		$onInit,
		addTaxUpdate,
		niCodeOnChange,
		niEffectiveFromDateOnChange,
		onError,
		resetNICode,
		resetPostgraduateLoan,
		resetStudentLoan,
		resetTaxCode,
		STUDENT_LOAN_PLANS,
		taxUpdatesService,
		toggleShowBackdatedNICalculations,
		updateEditBlockCount,
		updateStudentLoan,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('additionalPostForm', function () {
	return {
		controller: 'additionalPostFormCtrl',
		templateUrl: 'forms/employment/additionalPost/additionalPostForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('additionalPostFormCtrl', [
	'$q',
	'$scope',
	'companyData',
	'config',
	'journalsService',
	'payrollData',
	'policyService',
	'reportData',
	'salaryService',
	'teamData',
	'user',
	'userData',
	'BACKDATED_SALARY_CALCULATION_METHODS',
	'CALCULATION_METHODS',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POST_IDENTIFIER_UNIQUE',
	'SALARY_POLICY_FORM_FIELD_MODES',
	'SALARY_TYPES',
function (
	$q,
	$scope,	
	companyData,
	config,
	journalsService,
	payrollData,
	policyService,
	reportData,
	salaryService,
	teamData,
	user,
	userData,
	BACKDATED_SALARY_CALCULATION_METHODS,
	CALCULATION_METHODS,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES,
	POST_IDENTIFIER_UNIQUE,
	SALARY_POLICY_FORM_FIELD_MODES,
	SALARY_TYPES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;
	const userId = $scope.formOptions.userId;
	const userObj = $scope.formOptions.context;
	/* Switch to show the form as a wizard (used during setup mode) or single form (used post-payroll run
	   for detail block editing), defaults to true */
	const showFormAsWizard = angular.isDefined($scope.formOptions.showFormAsWizard) ? $scope.formOptions.showFormAsWizard : true;

	// Keep these two in sync for a happier life
	const PAGE_STEPS = {
		companyDetails: 1,
		payPolicyInformation: 2
	};
	const TOTAL_PAGE_STEPS = 2;

	const PAGE_STATES = {
		loading: 0,
		ready: 1,
		success: 2,
		error: 3
	};

	// Empty salary policy for creation of new policies
	let emptySalaryPolicy;

	function addAnnualAllowancePolicy (vmObj) {

		// Create a new annual allowance salary policy from the empty
		const annualAllowanceSalaryPolicy = angular.copy(emptySalaryPolicy);
		angular.extend(annualAllowanceSalaryPolicy, {

			PolicyPayBasis: POLICY_PAY_BASES.annualAllowance,

			// Use effective date of annual salary policy if it's a new one (not been paid), otherwise force entry
			EffectiveDateISO: !vmObj.additionalPost.SalaryPolicy.HasBeenPaid ? vmObj.additionalPost.SalaryPolicy.EffectiveDateISO : '',

			/* Copy policy CWTs to this allowance policy. If not set, the platform will stuff them with company settings
			   values, which we don't want to happen. */
			PolicyHoursPerWeek: vmObj.additionalPost.SalaryPolicy.payPolicy.PolicyHoursPerWeek,
			PolicyWeeksPerYear: vmObj.additionalPost.SalaryPolicy.payPolicy.PolicyWeeksPerYear,

			/* Mark as 'isNew', to indicate that on deletion it can be removed locally; the platform doesn't need to know
			   anything about this. */
			isNew: true
		});
		vmObj.additionalPost.SalaryPolicy.AllowancePolicies.push(annualAllowanceSalaryPolicy);
	}

	function addAnnualAllowanceChange (annualAllowancePolicyObj) {

		// Create a copy of the annual allowance policy to use as a template for the change
		const annualAllowancePolicyUpdate = createSalaryPolicyUpdate(annualAllowancePolicyObj);

		/* Attach the update as SiblingPolicy on the allowance. This mirrors how the platform structures
		   annual salary policy updates. A separate UI reference (policyChange) is maintained for display. */
		annualAllowancePolicyObj.policyChange = annualAllowancePolicyUpdate;
		annualAllowancePolicyObj.SiblingPolicy = annualAllowancePolicyUpdate;
	}

	function addAnnualSalaryPolicyChange (annualSalaryPolicyObj) {

		// Create a copy of the salary policy to use as a template for the change
		const annualSalaryPolicyUpdate = createSalaryPolicyUpdate(annualSalaryPolicyObj);
		/* Attach to original policy. This is how the platform structures an annual salary policy update, though
		   it's saved separately, this is how it's represented on the platform. */
		annualSalaryPolicyObj.SiblingPolicy = annualSalaryPolicyUpdate;
	}

	// Utility method to create a new annual salary or allowance policy update from an existing salary policy.
	function createSalaryPolicyUpdate (salaryPolicyObj) {

		// Create a copy of the salary policy to use as a template for the update
		const salaryPolicyUpdate = angular.copy(salaryPolicyObj);
		angular.extend(salaryPolicyUpdate, {
			EffectiveDateISO: '',
			HasBeenPaid: false,
			isSalaryPolicyUpdate: true,
			// Needed to determine correct API when saving. Brand new updates use OverrideSalaryPolicy.
			isNewUpdate: true
		});
		// Force selection of new band
		delete(salaryPolicyUpdate.Band);

		return salaryPolicyUpdate;
	}

	function decorateAdditionalPost (additionalPost) {

		additionalPost.SalaryPolicy = decorateAnnualSalaryPolicy(additionalPost.SalaryPolicy);

		return additionalPost;
	}

	function decorateAnnualSalaryPolicy (annualSalaryPolicyObj) {

		/* For each salary policy, if a SiblingPolicy exists, add a flag to indicate its status for deletion.
		   For each annual allowance policy, any update will exist as SiblingPolicy. Check those too and decorate
		   accordingly. */
		if (angular.isDefined(annualSalaryPolicyObj.SiblingPolicy) && annualSalaryPolicyObj.SiblingPolicy !== null) {

			/* Add decorators. Annual salary policy updates are deleted in a separate operation, hence the need for this
			   mark for deletion flag. (Annual allowance policy deletion is controlled by the platform with a flag it's
			   aware of; IsSalaryPolicyDelete) */
			angular.extend(annualSalaryPolicyObj.SiblingPolicy, {
				isSalaryPolicyUpdate: true,
				isMarkedForDeletion: false
			});
		}

		// Set flag to show pending update, and do the same for any annual allowance policies
		const showPolicyUpdateInfo = (salaryPolicy => salaryPolicy.IsPolicyUpdatePending);
		annualSalaryPolicyObj.showPolicyUpdateInfo = showPolicyUpdateInfo(annualSalaryPolicyObj);

		/* Check for annual allowance policy updates. These now exist as SiblingPolicy on their respective
		   original annual allowance policies */
		annualSalaryPolicyObj.AllowancePolicies.forEach(allowancePolicy => {
			allowancePolicy.showPolicyUpdateInfo = showPolicyUpdateInfo(allowancePolicy);
			if (angular.isDefined(allowancePolicy.SiblingPolicy) && allowancePolicy.SiblingPolicy !== null) {
				/* Attach the update to the allowance policy as a separate object for the UI. If it's 'deleted' later,
				   this attachment can be removed while the SiblingPolicy remains for the platform to handle deletion. */
				allowancePolicy.SiblingPolicy.isSalaryPolicyUpdate = true;
				allowancePolicy.policyChange = allowancePolicy.SiblingPolicy;
			}
		});

		return annualSalaryPolicyObj;
	}

	function decorateSalary (salaryObj, policyObj) {

		/* Set pro rating method values at top level salary object. This is centralised so all policies can listen for changes to
		   the pro rating method (specifically Period pro rating) and update any backdated salary accordingly.
		   This will be applied to all policies on saving. Get it from whichever policy is passed in, otherwise set to default */
		if (policyObj.PolicyID !== config.guidEmpty) {
			salaryObj.periodProRatingMethod = policyObj.PeriodProRatingMethod;
			salaryObj.elementProRatingMethod = policyObj.ElementProRatingMethod;
		}
		else {
			salaryObj.periodProRatingMethod = -1;
			salaryObj.elementProRatingMethod = -1;
		}

		return salaryObj;
	}

	function deleteAnnualAllowancePolicy (additionalPostObj, additionalPostAnnualAllowancePolicyObj) {

		/* If this is a brand-spanking new annual allowance that hasn't been saved yet, just get rid of it. Otherwise
		   flag it for deletion. */
		if (additionalPostAnnualAllowancePolicyObj.isNew) {
			additionalPostObj.SalaryPolicy.AllowancePolicies.splice(additionalPostObj.SalaryPolicy.AllowancePolicies.indexOf(additionalPostAnnualAllowancePolicyObj), 1);
		}
		else {
			additionalPostAnnualAllowancePolicyObj.IsSalaryPolicyDelete = true;
		}
	}

	function deleteAnnualAllowancePolicyChange (annualAllowancePolicyObj) {

		if (annualAllowancePolicyObj.policyChange.isNewUpdate) {
			/* Brand new, unsaved change — drop it locally. The platform doesn't know about it,
			   and leaving the SiblingPolicy attached would cause the parent allowance to be
			   deleted on save (the sibling inherits the parent's SalaryPolicyID from angular.copy). */
			delete(annualAllowancePolicyObj.SiblingPolicy);
			delete(annualAllowancePolicyObj.policyChange);
		}
		else {
			// Mark the update for deletion. The platform will deal with this.
			annualAllowancePolicyObj.policyChange.IsSalaryPolicyDelete = true;
			/* Remove the UI reference. SiblingPolicy is kept with IsSalaryPolicyDelete = true
			   so the platform can process the deletion via the SiblingPolicy check in Salary.cs. */
			delete(annualAllowancePolicyObj.policyChange);
		}
	}

	function deleteAnnualSalaryPolicyChange (vmObj, annualSalaryPolicyObj) {
		// There should be an update object on the policy, but to be sure, to be sure...
		if (angular.isDefined(annualSalaryPolicyObj.SiblingPolicy)) {
			// If it exists in the database, add to list of salary policy IDs for deletion
			if (!annualSalaryPolicyObj.SiblingPolicy.isNewUpdate) {
				vmObj.policyIdsForDeletion.push(annualSalaryPolicyObj.SiblingPolicy.SalaryPolicyID);
			}
			// Remove it from the associated policy
			delete(annualSalaryPolicyObj.SiblingPolicy);
		}
	}

	function goToPageStep (vmObj, pageStep) {

		// Determine page title for this step
		let pageStepTitle = vmObj.isNewAdditionalPost ? 'Add post' : 'Edit post';
		let pageStepTitleSuffix;
		switch (pageStep) {
			case PAGE_STEPS.companyDetails: {
				pageStepTitleSuffix = ' - Company details';
				break;
			}
			case PAGE_STEPS.payPolicyInformation: {
				pageStepTitleSuffix = ' - Pay policy information';
				break;
			}
			default: {
				pageStepTitleSuffix = '';
				break;
			}
		}

		// Set active step index in formOptions and update to include wizard-like progress bar
		angular.extend($scope.formOptions, {
			activeStep: pageStep,
			title: `${pageStepTitle}${pageStepTitleSuffix}`,
			showProgressBar: showFormAsWizard,
			totalSteps: TOTAL_PAGE_STEPS
		});
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		let additionalPost = $scope.formOptions.additionalPost;

		const INCLUDE_LEGACY_POLICIES = false;
		const INCLUDE_UPDATES = true;

		const getTeamMemberCompanyDetails = teamData.getTeamMemberCompanyDetails(userId, agencyProfileId);
		const getTeamMemberSalary = payrollData.getTeamMemberSalary(agencyProfileId, userId, false);
		const getPolicies = policyService.getPoliciesForCategory(agencyProfileId, POLICY_CATEGORIES.pay, INCLUDE_LEGACY_POLICIES, INCLUDE_UPDATES);
		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
		const getEmptyTeamMemberSalaryPolicyPost = payrollData.getEmptyTeamMemberSalaryPolicyPost();
		const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();
		const getPolicyGrades = companyData.getPolicyGrades(agencyProfileId);
		// Optionally get business codes for the additional post when available
		let getUserAgencyProfileBusinessCodesForSalaryPolicyPost = null;
		if (angular.isDefined(additionalPost)) {
			getUserAgencyProfileBusinessCodesForSalaryPolicyPost = user.getUserAgencyProfileBusinessCodesForSalaryPolicyPost(userId, agencyProfileId, additionalPost.SalaryPolicyPostID);
		}

		$q.all([
			getTeamMemberCompanyDetails,
			getTeamMemberSalary,
			getPolicies,
			getBusinessCategoriesList,
			getEmptyTeamMemberSalaryPolicyPost,
			getEmptyUserAgencyProfileBusinessCode,
			getUserAgencyProfileBusinessCodesForSalaryPolicyPost,
			getPolicyGrades,
		]).then(([
			teamMemberCompanyObj,
			teamMemberSalaryObj,
			payPoliciesArr,
			businessCategoriesArr,
			emptyTeamMemberSalaryPolicyPostObj,
			emptyUserAgencyProfileBusinessCodeRet,
			userAgencyProfileBusinessCodes,
			policyGradesArr
		]) => {

			//..Collecting posts throughout the system uses the current "revelant" salaryID, which if there is a pending update, will be the future salary ID.
			//..Currently the system is limited to adding updates within the current period, no later, so this will work for now. If this changes, the logic for determining the relevant salary ID will need to be updated.
			const relevantSalaryID = hasFutureChange(teamMemberSalaryObj) ? teamMemberSalaryObj.SalaryFutureChanges[0].SalaryID : teamMemberSalaryObj.SalaryID;

			// The empty salary policy is used for pay policy salary type. Some of its attributes can be set here.
			angular.extend(emptyTeamMemberSalaryPolicyPostObj.SalaryPolicy, {
				CalculationMethod: BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod,
				SalaryType: SALARY_TYPES.payPolicy,
				SalaryID: relevantSalaryID,
				SalaryPolicyID: config.guidEmpty,
				// Set effective date to start date for starters, otherwise use start date of current period.
				EffectiveDateISO: teamMemberCompanyObj.IsStarter ? teamMemberCompanyObj.StartDateISO : currentPayPeriodObj.StartDateISO
			});

			// Hold onto empty salary policy for pay policy employment type.
			emptySalaryPolicy = emptyTeamMemberSalaryPolicyPostObj.SalaryPolicy;

			// Get counts of annual salary and annual allowance policies
			const annualSalaryPoliciesCount = payPoliciesArr.reduce((count, payPolicy) => (payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary ? count + 1 : count), 0);
			const annualAllowancePoliciesCount = payPoliciesArr.reduce((count, payPolicy) => (payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance ? count + 1 : count), 0);

			// Now see if there are existing policies for this additional post available. If not, set initial state to single empty annual salary policy
			let isNewAdditionalPost = false;
			if (angular.isUndefined(additionalPost)) {
				/* There's no annual salary policy for the additional post, (which implies there's no annual allowance policy either; that
				   can't exist on its own). So create a new annual salary policy from the empty for editing. An annual can be optionally added
				   in the UI */
				additionalPost = angular.copy(emptyTeamMemberSalaryPolicyPostObj);
				angular.extend(additionalPost.SalaryPolicy, {
					FTEApply: true,
					ElementProRatingMethod: -1,
					PeriodProRatingMethod: -1,
					PolicyPayBasis: POLICY_PAY_BASES.annualSalary
				});
				isNewAdditionalPost = true;
			}

			const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(emptyUserAgencyProfileBusinessCodeRet, agencyProfileId, userId, additionalPost.SalaryPolicyPostID);

			if (userAgencyProfileBusinessCodes === null) {
				userAgencyProfileBusinessCodes = journalsService.getEmptyUserAgencyProfileBusinessCodes(userId);
			}

			// Add dummy 'none' option to policy grades if there are any. Or job grades, as the UI likes to call them
			if (policyGradesArr.length !== 0) {
				policyGradesArr.push({
					PolicyGradeID: config.guidEmpty,
					PolicyGradeName: '-- Select job grade --'
				});
			}

			const vmObj = {
				additionalPost: decorateAdditionalPost(additionalPost),
				agencyProfileId,
				annualAllowancePoliciesCount,
				annualSalaryPoliciesCount,
				businessCategories: journalsService.decorateBusinessCategories(businessCategoriesArr, userAgencyProfileBusinessCodes.UserAgencyProfileBusinessCodes, userAgencyProfileBusinessCodes.BusinessCodeCostSplit),
				company: companyObj,
				backdatedSalaryDerivedElementsEnabled: false, //Backdated elements for additional posts not yet supported
				currentPayPeriod: currentPayPeriodObj,
				emptyUserAgencyProfileBusinessCode,
				isNewAdditionalPost,
				pageStep: PAGE_STEPS.companyDetails,
				payPolicies: payPoliciesArr,
				policyGrades: policyGradesArr,
				policyIdsForDeletion: [],
				showFormAsWizard,
				teamMember: {
					company: teamMemberCompanyObj,
					personal: userObj,
					salary: decorateSalary(teamMemberSalaryObj, additionalPost.SalaryPolicy)
				},
				userAgencyProfileBusinessCodes
			};

			$scope.vm = vmObj;

			goToPageStep(vmObj, angular.isDefined($scope.formOptions.activeStep) ? $scope.formOptions.activeStep : PAGE_STEPS.companyDetails);
			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function hasFutureChange (salary) {
		return (salary.SalaryFutureChanges !== null &&
				salary.SalaryFutureChanges.length !== 0 &&
				salary.SalaryFutureChanges[0].SalaryID !== config.guidEmpty);
	}

	function showCostSplitButton () {

		return $scope.vm.businessCategories.some(businessCategory => businessCategory.selectedBusinessCode !== null);
	}

	function onBusinessCategoryChange () {

		$scope.vm.businessCategories = [].concat($scope.vm.businessCategories);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function onStartDateChange (vmObj) {
		/* If the user has added some policy stuff, then they return to update the start date, any allowance policies need to be updated
		   with the new start date */
		vmObj.additionalPost.SalaryPolicy.EffectiveDateISO = vmObj.additionalPost.StartDateISO;
		vmObj.additionalPost.SalaryPolicy.AllowancePolicies.forEach(allowancePolicy => {
			allowancePolicy.EffectiveDateISO = vmObj.additionalPost.StartDateISO;
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleConfirmDeleteAnnualAllowancePolicy (annualAllowancePolicyObj) {
		annualAllowancePolicyObj.confirmDelete = !annualAllowancePolicyObj.confirmDelete;
	}

	function onAddCostSplitClick (businessCodesObj) {

		// Get the first selected business category
		const businessCategory = $scope.vm.businessCategories.filter((businessCategoryObj) => businessCategoryObj.selectedBusinessCode !== null)[0];

		angular.extend(businessCodesObj.BusinessCodeCostSplit, {
			BusinessCategoryID: businessCategory.BusinessCategoryID,
			UserAgencyProfileBusinessCodes: []
		});
	}

	function getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj) {
		return salaryService.getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj);
	}

	function handleCompanyDetailsStep(vmObj) {
		goToPageStep(vmObj, PAGE_STEPS.payPolicyInformation);
	}

	function handlePayPolicyInformationStep(vmObj, additionalPost, salaryObj, additionalPostForm) {
		/* Ensure all pro-rating values are in sync. This IS necessary because the platform's sibling path in
		   UpdateSalaryPolicyWithAllowances copies PeriodProRatingMethod from the parent allowance, not the container. */
		const proRatingMethods = {
			PeriodProRatingMethod: salaryObj.periodProRatingMethod,
			ElementProRatingMethod: salaryObj.elementProRatingMethod
		};
		angular.extend(vmObj.additionalPost.SalaryPolicy, proRatingMethods);

		if (angular.isDefined(vmObj.additionalPost.SalaryPolicy.AllowancePolicies) && vmObj.additionalPost.SalaryPolicy.AllowancePolicies !== null) {
			vmObj.additionalPost.SalaryPolicy.AllowancePolicies.forEach(allowancePolicy => {
				angular.extend(allowancePolicy, proRatingMethods);
				if (angular.isDefined(allowancePolicy.SiblingPolicy) && allowancePolicy.SiblingPolicy !== null) {
					angular.extend(allowancePolicy.SiblingPolicy, proRatingMethods);
				}
			});
		}

		additionalPostForm.state = 'saving';

		// Updating the main salary policy. If there are any allowance updates in there, those will be included.
		payrollData.createOrUpdateTeamMemberSalaryPolicyPost(agencyProfileId, userId, additionalPost).then((updatedSalaryPolicyObj) => {

			// Collection of APIs to save business categories and do whatever else is required for the update
			const salaryPolicyUpdates = [];

			// Map business codes
			const additionalPostBusinessCategoryUpdates = journalsService.getBusinessCodesFromBusinessCategories(vmObj.businessCategories, vmObj.emptyUserAgencyProfileBusinessCode, vmObj.userAgencyProfileBusinessCodes.BusinessCodeCostSplit);

			additionalPostBusinessCategoryUpdates.forEach(businessCode => {
				businessCode.SalaryPolicyPostID = updatedSalaryPolicyObj.SalaryPolicyPostID;
			});

			// If there are any business code updates, add to set of APIs
			if (additionalPostBusinessCategoryUpdates.length !== 0) {
				salaryPolicyUpdates.push(user.updateUserAgencyProfileBusinessCodes(agencyProfileId, additionalPostBusinessCategoryUpdates));
			}

			/* Build API call list to save annual salary update. This can include a delete operation (if the update has been
			   removed), and / or a create/update operation, or nothing at all */
			/* If there's anything for deletion, add here. There should be one thing in this list, but it's an array
			   because it used to include annual allowance updates for deletion. Left as is for versatility. */
			if (vmObj.policyIdsForDeletion.length !== 0) {
				vmObj.policyIdsForDeletion.forEach(salaryPolicyId => {
					salaryPolicyUpdates.push(payrollData.deleteSalaryPolicy(agencyProfileId, salaryPolicyId));
				});
			}
			/* Now add the create (overrideSalaryPolicy) or update (updateSalaryPolicy) operation for the additional
			   post if required */
			const additionalPostAnnualSalaryPolicyUpdate = additionalPost.SalaryPolicy.SiblingPolicy;
			if (angular.isDefined(additionalPostAnnualSalaryPolicyUpdate) && additionalPostAnnualSalaryPolicyUpdate !== null) {
				if (additionalPostAnnualSalaryPolicyUpdate.isNewUpdate) {
					salaryPolicyUpdates.push(payrollData.overrideSalaryPolicy(userId, agencyProfileId, additionalPostAnnualSalaryPolicyUpdate));
				}
				else {
					salaryPolicyUpdates.push(payrollData.updateSalaryPolicy(userId, agencyProfileId, additionalPostAnnualSalaryPolicyUpdate));
				}
			}

			$q.all(salaryPolicyUpdates).then(() => {
				$scope.formOptions.showProgressBar = false;
				additionalPostForm.state = 'saved';
				$scope.formOptions.forceCallback();
				setPageState(PAGE_STATES.success);
			})
			.catch(error => {
				additionalPostForm.state = null;
				onError(error);
			});
		})
		.catch(error => {
			additionalPostForm.state = null;
			onError(error);
		});
	}

	function updateAdditionalPost (vmObj, additionalPost, salaryObj, additionalPostForm) {
		if ($scope.formOptions.activeStep === PAGE_STEPS.companyDetails && vmObj.showFormAsWizard) {
			handleCompanyDetailsStep(vmObj);
			return;
		}

		handlePayPolicyInformationStep(vmObj, additionalPost, salaryObj, additionalPostForm);
	}

	init();

	angular.extend($scope, {
		CALCULATION_METHODS,
		PAGE_STATES,
		PAGE_STEPS,
		POLICY_PAY_BASES,
		POST_IDENTIFIER_UNIQUE,
		SALARY_POLICY_FORM_FIELD_MODES,
		SALARY_TYPES,

		addAnnualAllowancePolicy,
		addAnnualAllowanceChange,
		addAnnualSalaryPolicyChange,
		deleteAnnualAllowancePolicy,
		deleteAnnualAllowancePolicyChange,
		deleteAnnualSalaryPolicyChange,
		getBackdatedSalaryDerivedElementValueForDisplay,
		goToPageStep,
		onAddCostSplitClick,
		onError,
		onBusinessCategoryChange,
		onStartDateChange,
		showCostSplitButton,
		toggleConfirmDeleteAnnualAllowancePolicy,
		updateAdditionalPost
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('cancelLeavingAdditionalPostForm', function () {

	return {
		controller: 'cancelLeavingAdditionalPostFormCtrl',
		templateUrl: 'forms/employment/additionalPost/cancelLeavingAdditionalPostForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cancelLeavingAdditionalPostFormCtrl', [
	'$scope',
	'payrollData',
function (
	$scope,
	payrollData
 ) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const additionalPost = $scope.formOptions.additionalPost;
	const userId = $scope.formOptions.userId;

	function cancelLeavingAdditionalPost (cancelLeavingAdditionalPostForm, vmObj) {
		cancelLeavingAdditionalPostForm.state = 'saving';

		// Clear leave date and 'IsLeaving' flag
		const IS_LEAVING = false;
		payrollData.updateSalaryPolicyPostLeaveDate(agencyProfileId,
													userId,
													vmObj.additionalPost.SalaryPolicyPostID,
													'',
													IS_LEAVING)
		.then(() => {
			cancelLeavingAdditionalPostForm.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(error => {
			cancelLeavingAdditionalPostForm.state = null;
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		angular.extend($scope, {
			vm: {
				additionalPost
			}
		});
		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		cancelLeavingAdditionalPost
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteAdditionalPostForm', function () {

	return {
		controller: 'deleteAdditionalPostFormCtrl',
		templateUrl: 'forms/employment/additionalPost/deleteAdditionalPostForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteAdditionalPostFormCtrl', [
	'$scope',
	'payrollData',
function (
	$scope,
	payrollData
 ) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const salaryPolicyPostId = $scope.formOptions.salaryPolicyPostId;

	function deleteAdditionalPost (deleteAdditionalPostForm) {

		deleteAdditionalPostForm.state = 'saving';

		payrollData.deleteSalaryPolicyPost(agencyProfileId, salaryPolicyPostId).then(() => {

			deleteAdditionalPostForm.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(error => {
			deleteAdditionalPostForm.state = null;
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		deleteAdditionalPost
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('leaveAdditionalPostForm', function () {

	return {
		controller: 'leaveAdditionalPostFormCtrl',
		templateUrl: 'forms/employment/additionalPost/leaveAdditionalPostForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('leaveAdditionalPostFormCtrl', [
	'$q',
	'$scope',
	'payrollData',
function (
	$q,
	$scope,
	payrollData
 ) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriod = $scope.formOptions.currentPayPeriod;
	const additionalPost = $scope.formOptions.additionalPost;
	const teamMember = $scope.formOptions.teamMember;
	const userId = $scope.formOptions.userId;

	function checkLeaveDate (vmObj) {
		vmObj.isLeaveDateInPast = angular.isDefined(vmObj.leaveDateISO) &&
								  moment(vmObj.leaveDateISO).isValid() &&
								  moment(vmObj.currentPayPeriod.StartDateISO).isAfter(vmObj.leaveDateISO);
		vmObj.isLeaveDateBeforeLastPayDate = angular.isDefined(vmObj.teamMember.Payment.PaymentDateISO) &&
											 moment(vmObj.teamMember.Payment.PaymentDateISO).isValid() &&
											 moment(vmObj.teamMember.Payment.PaymentDateISO).isAfter(vmObj.leaveDateISO);
	}

	function leaveAdditionalPost (leaveAdditionalPostForm, vmObj) {

		leaveAdditionalPostForm.state = 'saving';

		// This may require more than one API call
		const leaveAdditionalPost = [];

		// Add call to set leaving date and 'IsLeaving' flag
		const IS_LEAVING = true;
		leaveAdditionalPost.push(
			payrollData.updateSalaryPolicyPostLeaveDate(agencyProfileId,
														userId,
														vmObj.additionalPost.SalaryPolicyPostID,
														vmObj.leaveDateISO,
														IS_LEAVING)
		);

		$q.all(leaveAdditionalPost).then(() => {
			leaveAdditionalPostForm.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(error => {
			leaveAdditionalPostForm.state = null;
			console.error(error);
			setPageState('error');
		});
	}

	function init () {

		angular.extend($scope, {
			vm: {
				currentPayPeriod,
				leaveDateMax: currentPayPeriod.EndDateISO,
				leaveDateMin: additionalPost.SalaryPolicy.EffectiveDateISO,
				additionalPost,
				teamMember
			}
		});
		setPageState('ready');
	}

	function onLeaveDateChange (vmObj) {
		checkLeaveDate(vmObj);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		leaveAdditionalPost,
		onLeaveDateChange
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('backdatedNiCalculationView', {
	bindings: {
		backdatedNi: '<',
		busy: '<?'
	},
	controller: 'backdatedNICalculationViewController',
	templateUrl: 'forms/employment/backdatedNI/backdatedNICalculationView.html'
})

.controller('backdatedNICalculationViewController', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		processBackdatedNI($ctrl.backdatedNi);
	};

	$ctrl.$onChanges = function () {

		processBackdatedNI ($ctrl.backdatedNi);
	};

	function processBackdatedNI (backdatedNI) {

		if (backdatedNI) {

			let totalNetPayDifference = 0;
			let totalNIEEDifference = 0;
			let totalNIERDifference = 0;

			backdatedNI.forEach((backdatedNIPeriod) => {
				backdatedNIPeriod.NetPayDifference = backdatedNIPeriod.NetPayCorrected - backdatedNIPeriod.NetPay;
				backdatedNIPeriod.NIEEDifference = backdatedNIPeriod.NIEECorrected - backdatedNIPeriod.NIEE;
				backdatedNIPeriod.NIERDifference = backdatedNIPeriod.NIERCorrected - backdatedNIPeriod.NIER;

				totalNetPayDifference += backdatedNIPeriod.NetPayDifference;
				totalNIEEDifference += backdatedNIPeriod.NIEEDifference;
				totalNIERDifference += backdatedNIPeriod.NIERDifference;
			});

			backdatedNI.TotalNetPay = totalNetPayDifference;
			backdatedNI.TotalNIEE = totalNIEEDifference;
			backdatedNI.TotalNIER = totalNIERDifference;
		}
	}

	angular.extend($ctrl, {
		busy: angular.isUndefined($ctrl.busy) ? false : $ctrl.busy
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('backdatedNiViewForm', function () {

	return {
		controller: 'backdatedNIViewFormCtrl',
		templateUrl: 'forms/employment/backdatedNI/backdatedNIViewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '=',
			showBackdatedNICalculations: '<?'
		}
	};
})

.controller('backdatedNIViewFormCtrl', ['$scope', 'payrollData', function ($scope, payrollData) {

	let adjustmentId = $scope.formOptions.adjustmentId;
	let agencyProfileId = $scope.formOptions.agencyProfileId;
	let teamMember = $scope.formOptions.context;
	let userId = $scope.formOptions.userId;

	function init() {

		setPageState('loading');

		payrollData.getTeamMemberBackdatedNIForAdjustment(userId, agencyProfileId, adjustmentId).then((backdatedNI) => {
			angular.extend($scope, {
				backdatedNI
			});
			setPageState('ready');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleShowBackdatedNICalculations () {

		$scope.showBackdatedNICalculations = !$scope.showBackdatedNICalculations;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		showBackdatedNICalculations: angular.isUndefined($scope.showBackdatedNICalculations) ? false: $scope.showBackdatedNICalculations,
		teamMember,
		toggleShowBackdatedNICalculations,
		userId
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('backdatedSalaryCalculationView', {
	bindings: {
		backdatedSalary: '<',
		busy: '<?'
	},
	controller: 'backdatedSalaryCalculationViewController',
	templateUrl: 'forms/employment/backdated-salary/backdated-salary-calculation-view.form.html'
})

.controller('backdatedSalaryCalculationViewController', [function () {

	const $ctrl = this;

	$ctrl.$onInit = function () {

		processBackdatedSalary($ctrl.backdatedSalary);
	};

	$ctrl.$onChanges = function () {

		processBackdatedSalary($ctrl.backdatedSalary);
	};

	function processBackdatedSalary (backdatedSalary) {

		// Error in backdated salary calculation -> Report to Coralogix to be reviewed
		if (backdatedSalary.BackdatedSalary.length === 0) {
			console.error('backdatedSalaryCalculationView: No backdated salary calculations to display');
		}

		for (let backdatedSalaryPeriod of backdatedSalary.BackdatedSalary) {
			backdatedSalaryPeriod.GrossDifference = backdatedSalaryPeriod.GrossCorrected - backdatedSalaryPeriod.Gross;
			backdatedSalaryPeriod.TaxDifference = backdatedSalaryPeriod.TaxCorrected - backdatedSalaryPeriod.Tax;
			backdatedSalaryPeriod.NIEEDifference = backdatedSalaryPeriod.NIEECorrected - backdatedSalaryPeriod.NIEE;
			backdatedSalaryPeriod.NIERDifference = backdatedSalaryPeriod.NIERCorrected - backdatedSalaryPeriod.NIER;
			backdatedSalaryPeriod.EmployeePensionDifference = backdatedSalaryPeriod.EmployeePensionCorrected - backdatedSalaryPeriod.EmployeePension;
			backdatedSalaryPeriod.EmployerPensionDifference = backdatedSalaryPeriod.EmployerPensionCorrected - backdatedSalaryPeriod.EmployerPension;
			backdatedSalaryPeriod.StudentLoanDifference = backdatedSalaryPeriod.StudentLoanCorrected - backdatedSalaryPeriod.StudentLoan;
			backdatedSalaryPeriod.PostgraduateLoanDifference = backdatedSalaryPeriod.PostgraduateLoanCorrected - backdatedSalaryPeriod.PostgraduateLoan;
			backdatedSalaryPeriod.NetPayDifference = backdatedSalaryPeriod.NetPayCorrected - backdatedSalaryPeriod.NetPay;
		}

		return backdatedSalary;
	}

	angular.extend($ctrl, {
		busy: angular.isUndefined($ctrl.busy) ? false : $ctrl.busy
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('backdatedSalaryViewForm', function () {

	return {
		controller: 'backdatedSalaryViewFormCtrl',
		templateUrl: 'forms/employment/backdated-salary/backdated-salary-view.form.html',
		restrict: 'E',
		scope: {
			formOptions: '=',
			showBackdatedSalaryCalculations: '<?'
		}
	};
})

.controller('backdatedSalaryViewFormCtrl', [
	'$q',
	'$scope',
	'payrollData',
	'teamData',
	'BACKDATED_SALARY_CALCULATION_METHODS',
	function (
		$q,
		$scope,
		payrollData,
		teamData,
		BACKDATED_SALARY_CALCULATION_METHODS
	) {

	const adjustmentId = $scope.formOptions.adjustmentId;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getTeamMemberBackdatedSalaryForAdjustment = payrollData.getTeamMemberBackdatedSalaryForAdjustment(userId, agencyProfileId, adjustmentId);
		const getTeamMemberCompanyDetails = teamData.getTeamMemberCompanyDetails(userId, agencyProfileId);

		$q.all([
			getPayPeriodCurrent,
			getTeamMemberBackdatedSalaryForAdjustment,
			getTeamMemberCompanyDetails
		]).then(([
			currentPayPeriodObj,
			backdatedSalaryObj,
			teamMemberCompanyObj
		]) => {

			angular.extend($scope, {
				backdatedSalary: backdatedSalaryObj,
				// Lure out the salary change part for convenience
				salaryChange: backdatedSalaryObj.Salary.SalaryFutureChanges[0],
				teamMemberCompany: teamMemberCompanyObj,
				isNewStarterStartDateInPast: teamMemberCompanyObj.IsStarter && moment(teamMemberCompanyObj.StartDateISO).isBefore(currentPayPeriodObj.StartDateISO),
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {
		
		$scope.pageState = pageState;
	}

	function toggleShowBackdatedSalaryCalculations () {
		
		$scope.showBackdatedSalaryCalculations = !$scope.showBackdatedSalaryCalculations;
	}

	init();

	angular.extend($scope, {
		// Constants
		BACKDATED_SALARY_CALCULATION_METHODS,

		// Variables
		agencyProfileId,
		userId,

		// Functions
		showBackdatedSalaryCalculations: angular.isUndefined($scope.showBackdatedSalaryCalculations) ? false: $scope.showBackdatedSalaryCalculations,
		toggleShowBackdatedSalaryCalculations
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyDetailsForm', function () {

	return {
		controller: 'companyDetailsFormCtrl',
		templateUrl: 'forms/employment/companyDetails/companyDetailsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyDetailsFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'companyData',
	'config',
	'growl',
	'journalsService',
	'payrollData',
	'reportData',
	'teamData',
	'userData',
	'EMPLOYMENT_TYPES',
	'PAYROLL_MOVE_STATUSES',
	'POST_IDENTIFIER_UNIQUE',
	'POLICY_TYPES',
	'SALARY_TYPES',
	'TEAM_MEMBER_COMPANY_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		companyData,
		config,
		growl,
		journalsService,
		payrollData,
		reportData,
		teamData,
		userData,
		EMPLOYMENT_TYPES,
		PAYROLL_MOVE_STATUSES,
		POST_IDENTIFIER_UNIQUE,
		POLICY_TYPES,
		SALARY_TYPES,
		TEAM_MEMBER_COMPANY_STATES
	) {

	const AGENCY_PROFILE_ID = $scope.formOptions.agencyProfileId;
	const USER_ID = $scope.formOptions.userId;
	const companyObj = $scope.formOptions.company;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;

	let emptyUserAgencyProfileBusinessCode;

	function decorateTeamMember (teamMemberObj, currentPayPeriodObj) {

		angular.extend(teamMemberObj.Company, {
			// Start date validation
			startDateMaxISO: moment().add(10, 'years').endOf('month').format(config.dateFormatISO),
			startDateMinISO: moment().subtract(100, 'years').startOf('month').format(config.dateFormatISO),

			/* Set flag for payroll move status === InwardPending for convenience. This indicates that the team member
			   is in the process of moving from another payroll to this one, thereby disabling certain fields and displaying
			   a note about that */
			isMovingPayrollsInwardPending: (teamMemberObj.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending),

			// Decorate with default flag for new starter
			isNewStarter: teamMemberObj.Company.IsStarter,
			isNewStarterQuestionVisible: getIsNewStarterQuestionVisible(teamMemberObj),

			// Show appointment end date
			directorNIStandardOriginal: teamMemberObj.Company.DirectorNIStandard,

			// Save original director flag to show comms if changed
			isDirectorInTaxYearOriginal: teamMemberObj.Company.IsDirectorInTaxYear,

			// Display note if new starter anmd start date in past
			isNewStarterStartDateInPast: isNewStarterStartDateInPast(teamMemberObj, currentPayPeriodObj)
		});

		// if company isn't in setup mode, assume the person is a new starter
		if (!teamMemberObj.CompanySetupComplete && (companyObj.HasRunPayroll || companyObj.IsNewCompany)) {
			teamMemberObj.Company.IsStarter = true;
		}

		// Fields are only mandatory if team member is a non-leaver or a leaver not in setup mode with a complete setup
		teamMemberObj.isTeamMemberSetupFieldsRequired = !(teamMemberObj.IsInSetupMode && teamMemberObj.Company.IsLeaver && !teamMemberObj.TeamMemberSetupComplete);

		return teamMemberObj;
	}

	function decorateSicknessPolicies (sicknessPoliciesArr) {

		// Filter out policies with no code
		const sicknessPolicies = sicknessPoliciesArr
			.filter(policy => policy.PolicyCode && policy.PolicyCode.trim() !== '');

		if (sicknessPolicies.length !== 0) {

			sicknessPolicies.forEach(policy => policy.name = policy.PolicyCode);

			// Add empty option
			sicknessPolicies.push({
				name: '-- Select occupational sick policy code --',
				PolicyCode: ''
			});
		}

		return sicknessPolicies;
	}

	function showCostSplitButton () {

		return $scope.businessCategories.some(businessCategory => businessCategory.selectedBusinessCode !== null);
	}

	function getIsNewStarterQuestionVisible (teamMemberObj) {
		// See https://www.notion.so/paycircle/Can-set-someone-who-has-been-run-before-as-new-starter-4fcd23facc254965892f0257f97b87f1 for test scenarios

		// Rejoiners must be set as new starters to avoid mis-alignments
		if (teamMemberObj.Company.IsRestarter) {
			return false;
		}

		// Company is setting up payroll
		if (!companyObj.HasRunPayroll) {
			return true;
		}

		// Company has ran payroll and adding a new starter (enabled to allow people to select new starter if they need to)
		if (companyObj.HasRunPayroll && teamMemberObj.IsInSetupMode) {
			return true;
		}

		return false;
	}

	function getIsNewStarterStartDateInPast (teamMemberObj, currentPayPeriodObj) {
		teamMemberObj.Company.isNewStarterStartDateInPast = isNewStarterStartDateInPast(teamMemberObj, currentPayPeriodObj);
	}

	function isNewStarterStartDateInPast (teamMemberObj, currentPayPeriodObj) {
		return teamMemberObj.Company.IsStarter && teamMemberObj.Company.StartDateISO && moment(teamMemberObj.Company.StartDateISO).isBefore(currentPayPeriodObj.StartDateISO);
	}

	function init () {

		setPageState('loading');

		const getAgencyDepartments = companyData.getAgencyDepartments(AGENCY_PROFILE_ID);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(USER_ID, AGENCY_PROFILE_ID);
		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(AGENCY_PROFILE_ID);
		const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();
		const getPolicyGrades = companyData.getPolicyGrades(AGENCY_PROFILE_ID);
		const getSicknessPolicies = companyData.getPolicies(AGENCY_PROFILE_ID, POLICY_TYPES.sickness, false);

		$q.all([
			getAgencyDepartments,
			getTeamMemberInformation,
			getBusinessCategoriesList,
			getEmptyUserAgencyProfileBusinessCode,
			getPolicyGrades,
			getSicknessPolicies
		]).then(
		([
			departmentsArr,
			teamMemberObj,
			businessCategoriesArr,
			emptyUserAgencyProfileBusinessCodeRet,
			policyGradesArr,
			sicknessPoliciesArr
		]) => {

			// Populate empty user agency profile business code with knowns. This is used when saving allocated business codes.
			emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(emptyUserAgencyProfileBusinessCodeRet, AGENCY_PROFILE_ID, USER_ID, config.guidEmpty);

			// Add dummy 'none' option to policy grades if there are any. Or job grades, as the UI likes to call them
			if (policyGradesArr.length !== 0) {
				policyGradesArr.push({
					PolicyGradeID: config.guidEmpty,
					PolicyGradeName: '-- Select job grade --'
				});
			}

			angular.extend($scope, {
				currentPayPeriod: currentPayPeriodObj,
				departments: departmentsArr,
				emptyUserAgencyProfileBusinessCode,
				businessCategories: journalsService.decorateBusinessCategories(businessCategoriesArr, teamMemberObj.Company.BusinessCodes.UserAgencyProfileBusinessCodes, teamMemberObj.Company.BusinessCodes.BusinessCodeCostSplit),
				policyGrades: policyGradesArr,
				sicknessPolicies: decorateSicknessPolicies(sicknessPoliciesArr),
				teamMember: decorateTeamMember(teamMemberObj, currentPayPeriodObj)
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onBusinessCategoryChange () {

		$scope.businessCategories =  [].concat($scope.businessCategories);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onStartDateChange (teamMemberObj, currentPayPeriodObj) {
		getIsNewStarterStartDateInPast(teamMemberObj, currentPayPeriodObj);
	}

	function reviewHasExistingSubmissionId (teamMemberObj, currentPayPeriodObj) {

		// Update is starter in past
		getIsNewStarterStartDateInPast(teamMemberObj, currentPayPeriodObj);

		// Default to PayrollNumber if new starter or not entered or existing worker changes to new starter
		if (companyObj.PensionOnly || teamMemberObj.Company.IsStarter || teamMemberObj.Company.HasNoExistingSubmissionID || teamMemberObj.Company.isNewStarter !== teamMemberObj.Company.IsStarter) {
			teamMemberObj.Company.PayrollNumber = '';
			return;
		}
	}

	function reviewIsExpatriate (teamMemberObj) {

		// Reset values if not an Expatriate
		if (!teamMemberObj.Company.IsExpatriate) {
			angular.extend(teamMemberObj.Company, {
				IsSeconded: false
			});
		}

		reviewIsSeconded(teamMemberObj);
	}

	function reviewIsSeconded (teamMemberObj) {

		// Reset values if not seconded
		if (!teamMemberObj.Company.IsSeconded) {
			angular.extend(teamMemberObj.Company, {
				IsEEACitizen: false,
				IsEPM6: false
			});
		}
	}

	function setCompanyDetailsPreUpdate (teamMemberObj, businessCategoriesArr) {

		// Directorship
		// If team member is director then they cannot be an apprentice
		if (teamMemberObj.Company.IsDirectorInTaxYear) {
			teamMemberObj.Company.IsApprentice = false;

			// Clear end date if directorship is not ending this tax year
			if (!teamMemberObj.Company.HasDirectorEndDateInTaxYear) {
				teamMemberObj.Company.DirectorEndDateISO = '';
			}
		}
		// Reset values if not a director
		else {
			angular.extend(teamMemberObj.Company, {
				DirectorEndDateISO: '',
				DirectorStartDateISO: '',
				HasDirectorEndDateInTaxYear: false
			});
		}

		// Starter
		// Reset flag if team member is new starter
		if (teamMemberObj.Company.IsStarter) {
			teamMemberObj.Company.HasNoExistingSubmissionID = false;
		}

		// Map business codes
		teamMemberObj.Company.BusinessCodes.UserAgencyProfileBusinessCodes = journalsService.getBusinessCodesFromBusinessCategories(businessCategoriesArr, emptyUserAgencyProfileBusinessCode, teamMemberObj.Company.BusinessCodes.BusinessCodeCostSplit);

		teamMemberObj.Company.BusinessCodes.BusinessCodeCostSplit = null;
	}
	
	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function onAddCostSplitClick (businessCodesObj) {

		// Get the first selected business category
		const businessCategory = $scope.businessCategories.filter((businessCategoryObj) => businessCategoryObj.selectedBusinessCode !== null)[0];

		angular.extend(businessCodesObj.BusinessCodeCostSplit, {
			BusinessCategoryID: businessCategory.BusinessCategoryID,
			UserAgencyProfileBusinessCodes: []
		});
	}

	function updateTeamMemberCompany (teamMemberObj, businessCategoriesArr, formObj) {

		formObj.state = 'saving';

		setCompanyDetailsPreUpdate(teamMemberObj, businessCategoriesArr);

		/* The start date may have been changed for a new starter with assigned policies, if the user has returned to this form
		   *after* setting up policy pay information. Those need to be updated with the new date. */
		if (teamMemberObj.Salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy) {
			console.log('update required');
		}

		teamData.updateTeamMemberCompany(teamMemberObj.Company, USER_ID, AGENCY_PROFILE_ID).then(updatedTeamMemberCompanyObj => {

			switch (updatedTeamMemberCompanyObj.TeamMemberCompanyStatus) {

				// Duplicate Payroll ID (on PAYE scheme, not just company - could apply across multiple companies with same PAYE scheme)
				case TEAM_MEMBER_COMPANY_STATES.payrollIdInUse:

					setPageState('hmrc-submission-id-exists-in-scheme');

					break;

					// Duplicate HMRC Submission ID
				case TEAM_MEMBER_COMPANY_STATES.shortIdInUse:

					setPageState('payroll-id-exists-in-scheme');

					break;

				default:

					// Wizard: Go to next step
					if ($scope.formOptions.isWizard) {

						// Refresh page if new starter value changes
						if ($state.is('team.profile.overview') && teamMemberObj.Company.isNewStarter !== updatedTeamMemberCompanyObj.IsStarter) {
							$scope.formOptions.forceCallback();
						}

						$scope.formOptions.onSuccess();
						return;
					}

					$scope.formOptions.forceCallback();
					$scope.formOptions.closeForm();

					growl.success(teamMemberObj.Personal.Forename + '\'s company details have been updated.');

					formObj.state = 'saved';
			}
		})
		.catch(error => {
			setPageState('error');
			formObj.state = '';
			throw(error);
		});
	}

	init();

	angular.extend($scope, {
		PAYROLL_MOVE_STATUSES,
		POST_IDENTIFIER_UNIQUE,
		SALARY_TYPES,

		company: companyObj,

		getIsNewStarterStartDateInPast,
		onAddCostSplitClick,
		onBusinessCategoryChange,
		onStartDateChange,
		reviewHasExistingSubmissionId,
		reviewIsExpatriate,
		reviewIsSeconded,
		setPageState,
		showCostSplitButton,
		updateTeamMemberCompany
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companyVehicleForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companyVehicleFormCtrl',
	templateUrl: 'forms/employment/company-vehicle/company-vehicle.form.html'
})

.controller('companyVehicleFormCtrl', [
	'$q', 
	'adjustmentsService', 
	'config', 
	'paymentScheduleService', 
	'payrollData', 
	'utilities', 
	'PAYMENT_SCHEDULE_CATEGORIES', 
	'REPAYMENT_SCHEDULE_TYPES', 
function (
	$q, 
	adjustmentsService, 
	config, 
	paymentScheduleService, 
	payrollData, 
	utilities, 
	PAYMENT_SCHEDULE_CATEGORIES, 
	REPAYMENT_SCHEDULE_TYPES
) {

	const $ctrl = this;

	const CO2_THRESHOLD = 50;
	const CAR_REGISTRATION_DATE_THRESHOLD_MOMENT = moment('1998-01-01');
	const ENGINE_SIZES = [
		{
			value: 0,
			label: 'Unknown'
		},
		{
			value: 1,
			label: '0 to 1400cc'
		},
		{
			value: 2,
			label: '1401cc to 2000cc'
		},
		{
			value: 3,
			label: 'Over 2000cc'
		},
		{
			value: 4,
			label: 'Rotary'
		}
	];
	const FUEL_TYPES = {
		other: 0,
		diesel: 1,
		dieselEuro6d: 2,
		electric: 3
	};
	const FUEL_TYPE_OPTIONS = [
		{
			value: FUEL_TYPES.other,
			label: 'All other cars'
		},
		{
			value: FUEL_TYPES.diesel,
			label: 'Diesel'
		},
		{
			value: FUEL_TYPES.dieselEuro6d,
			label: 'Diesel Euro 6d'
		},
		{
			value: FUEL_TYPES.electric,
			label: 'Pure Electric'
		}
	];
	const NUMBER_FIELDS = [
		'CarBenefitAccessories',
		'CarBenefitAmountForegone',
		'CarBenefitCapitalContribution',
		'CarBenefitCashEquivalent',
		'CarBenefitCO2',
		'CarBenefitFuelAmountForegone',
		'CarBenefitFuelCashEquivalent',
		'CarBenefitFuelPaidYTD',
		'CarBenefitPaidYTD',
		'CarBenefitPrice',
		'CarBenefitPrivateUse',
		'CarBenefitVanShare',
		'CarBenefitVanShareAvailablePercent',
		'CarBenefitZeroEmissionsMileage'
	];

	function $onInit () {

		const PAYMENT_SCHEDULE_GROUP_ID = angular.isDefined($ctrl.formOptions.paymentScheduleGroupId) ? $ctrl.formOptions.paymentScheduleGroupId : config.guidEmpty;

		setComponentState('loading');

		const getPaymentScheduleGroup = payrollData.getPaymentScheduleGroup($ctrl.formOptions.agencyProfileId, PAYMENT_SCHEDULE_GROUP_ID);
		const getPaymentScheduleTypes = payrollData.getPaymentScheduleTypes($ctrl.formOptions.agencyProfileId, PAYMENT_SCHEDULE_CATEGORIES.car);
		const getCarBenefit = utilities.isValidGuid($ctrl.formOptions.paymentScheduleGroupId) ? payrollData.getCarBenefit($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.carBenefitId) : payrollData.getEmptyCarBenefit($ctrl.formOptions.agencyProfileId);

		$q.all([getCarBenefit, getPaymentScheduleTypes, getPaymentScheduleGroup]).then(([carBenefitObj, paymentScheduleTypesArr, paymentScheduleGroupObj]) => {

			carBenefitObj = decorateCarBenefitObj(carBenefitObj);
			paymentScheduleGroupObj = paymentScheduleService.decoratePaymentScheduleGroup(paymentScheduleGroupObj);
			let paymentScheduleTypeObj = paymentScheduleTypesArr.find(type => type.PaymentScheduleTypeID === REPAYMENT_SCHEDULE_TYPES.carBenefitInKind);

			if (!carBenefitObj.isEditing) {
				paymentScheduleGroupObj.PaymentScheduleGroupPayrollBIKState = paymentScheduleTypeObj.PaymentScheduleTypePayrollBIKState;
				paymentScheduleGroupObj.PaymentScheduleGroupPayrollBIKState = paymentScheduleTypeObj.PaymentScheduleTypePayrollBIKState;
			}

			angular.extend($ctrl, {
				carBenefit: carBenefitObj,
				formFields: getFormFields($ctrl, carBenefitObj, paymentScheduleGroupObj),
				labelOptions: {
					canSave: false
				},
				paymentScheduleGroup: paymentScheduleGroupObj,
				paymentScheduleType: paymentScheduleTypeObj
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function calculatePaymentScheduleGroup ($ctrl, formObj) {

		formObj.state = 'saving';

		// Make sure all empty values are set to zero in case needed for calculations
		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.carBenefit, NUMBER_FIELDS);

		// Populate the paymentScheduleGroup object from the various other objects
		populatePaymentScheduleGroup($ctrl);

		// Calculate on the server
		payrollData.calculatePaymentScheduleGroup($ctrl.paymentScheduleGroup).then(updatedPaymentScheduleObj => {

			angular.extend($ctrl.paymentScheduleGroup, updatedPaymentScheduleObj);

			formObj.state = null;

			goToNextStep($ctrl);
		})
		.catch(onError);
	}

	function decorateCarBenefitObj (carBenefitObj) {

		carBenefitObj.isRegistrationDateAfterThreshold = getIsRegistrationDateAfterThreshold(carBenefitObj);
		carBenefitObj.isEditing = utilities.isValidGuid(carBenefitObj.CarBenefitID);
		
		carBenefitObj.carBenefitHasContributionPrivateUse = carBenefitObj.CarBenefitPrivateUse !== 0;
		carBenefitObj.carBenefitHasZeroCO2 = carBenefitObj.CarBenefitCO2 === 0;
		carBenefitObj.carBenefitCO2Unknown = false;

		if (!carBenefitObj.isEditing) {			
			utilities.setPropertiesValuesToEmptyIfZero(carBenefitObj, NUMBER_FIELDS);
		}

		return carBenefitObj;
	}

	function getFormFields ($ctrl, carBenefitObj, paymentScheduleGroupObj) {

		return {
			carBenefitAccessories: {
				fieldType: 'number',
				id: 'accessories',
				isRequired: false,
				label: 'Taxable accessories',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitAmountForegone: {
				fieldType: 'number',
				id: 'amountForegone',
				label: 'Amount foregone for car',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitAvailableFromISO: {
				fieldType: 'date',
				id: 'availableFrom',
				isDisabled: paymentScheduleGroupObj.hasPaidScheduleEntry,
				label: 'Car available from',
				minDateIso: carBenefitObj.CarBenefitAvailableFromMinISO,
				onChange: reviewAvailableFrom
			},
			carBenefitAvailableToISO: {
				fieldType: 'date',
				id: 'availableTo',
				isDisabled: paymentScheduleGroupObj.hasPaidScheduleEntry,
				isRequired: false,
				label: 'Car available to',
				minDateIso: carBenefitObj.CarBenefitAvailableFromISO,
				onChange: reviewAvailableTo
			},
			carBenefitCapitalContribution: {
				fieldType: 'number',
				id: 'capitalContribution',
				isRequired: false,
				label: 'Capital contribution',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitCashEquivalent: {
				fieldType: 'number',
				id: 'cashEquivalent',
				label: 'Taxable vehicle benefit',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitCO2: {
				fieldType: 'number',
				id: 'CO2Emissions',
				label: 'CO2 emissions',
				onChange: reviewCarDetails,
				patternRegexKey: 'numbersPositiveWhole',
				placeholder: '0',
				suffix: 'gpkm'
			},
			carBenefitCO2Unknown: {
				fieldType: 'checkbox',
				id: 'co2Unknown',
				label: 'CO2 emissions unknown',
				onChange: reviewCarDetails
			},
			carBenefitDaysUnavailable: {
				fieldType: 'number',
				id: 'daysUnavailable',
				label: 'Days unavailable',
				patternRegexKey: 'numbersPositiveWhole',
				placeholder: '0'
			},
			carBenefitEngineSize: {
				fieldType: 'select',
				id: 'engineSize',
				label: 'Engine capacity',
				options: ENGINE_SIZES
			},
			carBenefitFuelAmountForegone: {
				fieldType: 'number',
				id: 'amountForegoneFuel',
				label: 'Amount forgone for fuel',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitFuelCashEquivalent: {
				fieldType: 'number',
				id: 'fuelCashEquivalent',
				label: 'Taxable fuel benefit',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitFuelDateProvidedISO: {
				fieldType: 'date',
				id: 'fuelDateProvided',
				label: 'Free fuel provided from',
				maxDateIso: carBenefitObj.CarBenefitAvailableToISO,
				minDateIso: carBenefitObj.CarBenefitAvailableFromISO,
				onChange: reviewFuelProvidedDate
			},
			carBenefitFuelDateWithdrawnISO: {
				fieldType: 'date',
				id: 'fuelDateWithdrawn',
				isRequired: false,
				label: 'Free fuel withdrawn on',
				maxDateIso: carBenefitObj.CarBenefitAvailableToISO,
				minDateIso: carBenefitObj.CarBenefitFuelDateProvidedISO
			},
			carBenefitFuelPaidYTD: {
				fieldType: 'number',
				id: 'fuelPaidYTD',
				label: 'Fuel benefit paid YTD',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitFuelProvided: {
				fieldType: 'checkbox',
				id: 'fuelProvided',
				label: 'Free fuel will be provided for private use',
				onChange: reviewFuelProvided
			},
			carBenefitFuelType: {
				fieldType: 'select',
				id: 'fuelType',
				label: 'Fuel type',
				onChange: reviewFuelType,
				options: FUEL_TYPE_OPTIONS
			},
			carBenefitMake: {
				id: 'makeOfCar',
				label: 'Make and model of car',
				maxlength: 35,
				patternRegexKey: 'carMakeModel'
			},
			carBenefitOpRA: {
				fieldType: 'radios',
				id: 'opr',
				label: 'Is the car provided via an OpRA arrangement?',
				options: [
					{
						key: 'oprYes',
						label: 'Yes',
						value: true
					},
					{
						key: 'oprNo',
						label: 'No',
						value: false
					}
				]
			},
			carBenefitPaidYTD: {
				fieldType: 'number',
				id: 'paidYTD',
				label: 'Vehicle benefit paid YTD',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitPrice: {
				fieldType: 'number',
				id: 'listPrice',
				label: 'List price',
				patternRegexKey: 'number8Digits2Decimal',
				placeholder: '0'
			},
			carBenefitPrivateUse: {
				fieldType: 'number',
				id: 'paymentTowardsPrivateUse',
				isRequired: false,
				label: 'Payment towards private use (pa)',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0'
			},
			carBenefitRegisteredDateISO: {
				fieldType: 'date',
				id: 'dateFirstRegistered',
				label: 'Date first registered',
				onChange: reviewCarDetails
			},
			carBenefitRegNo: {
				id: 'registrationNumber',
				label: 'Registration number',
				maxlength: 10
			},
			carBenefitZeroEmissionsMileage: {
				fieldType: 'number',
				id: 'zeroEmissionsMileage',
				isRequired: false,
				label: 'Zero emissions mileage',
				patternRegexKey: 'number7Digits2Decimal',
				placeholder: '0',
				suffix: 'miles'
			},

			// Van
			carBenefitVan: {
				fieldType: 'radios',
				hasHeader: true,
				label: 'Select the type of vehicle',
				id: 'vehicleTypeCar',
				isDisabled: carBenefitObj.isEditing,
				options: [
					{
						key: 'vehicleTypeCar',
						label: 'Car',
						value: false
					},
					{
						key: 'vehicleTypeVan',
						label: 'Van',
						value: true
					}
				]
			},
			carBenefitVanAvailableFromISO: {
				fieldType: 'date',
				id: 'availableFrom',
				isDisabled: paymentScheduleGroupObj.hasPaidScheduleEntry,
				label: 'Van available from',
				minDateIso: carBenefitObj.CarBenefitAvailableFromMinISO,
				onChange: reviewVanAvailableFrom
			},
			carBenefitVanAvailableToISO: {
				fieldType: 'date',
				id: 'availableTo',
				isDisabled: paymentScheduleGroupObj.hasPaidScheduleEntry,
				isRequired: false,
				minDateIso: carBenefitObj.CarBenefitVanAvailableFromISO,
				label: 'Van available to'
			},
			carBenefitVanCapitalContribution: {
				fieldType: 'money',
				id: 'capitalContribution',
				label: 'Contribution amount',
				placeholder: '0'
			},
			carBenefitVanContributionPrivateUse: {
				fieldType: 'radios',
				id: 'contributionPrivateUseTrue',
				label: `Does ${$ctrl.formOptions.context.Forename} make a contribution for private use?`,
				onChange: reviewBenefitContributionPrivateUse,
				options: [
					{
						key: 'contributionPrivateUseTrue',
						label: 'Yes',
						value: true
					},
					{
						key: 'contributionPrivateUseFalse',
						label: 'No',
						value: false
					}
				]
			},
			carBenefitVanDaysUnavailable: {
				fieldType: 'number',
				id: 'daysUnavailable',
				label: 'Days unavailable',
				patternRegexKey: 'numbersPositiveWhole',
				placeholder: '0'
			},
			carBenefitVanShare: {
				fieldType: 'radios',
				id: 'carBenefitVanShareTrue',
				label: `Does ${$ctrl.formOptions.context.Forename} share the van with other people?`,
				onChange: reviewVanShare,
				options: [
					{
						key: 'carBenefitVanShareTrue',
						label: 'Yes',
						value: true
					},
					{
						key: 'carBenefitVanShareFalse',
						label: 'No',
						value: false
					}
				]
			},
			carBenefitVanShareAvailablePercent: {
				class: 's',
				fieldType: 'percentage',
				id: 'shareAvailablePercent',
				label: `What percentage of the time does ${$ctrl.formOptions.context.Forename} use the van?`,
				patternRegexKey: 'numberMax100',
				placeholder: '100'
			},
			carBenefitVanZeroCO2: {
				fieldType: 'radios',
				id: 'zeroCO2True',
				label: `Does the van have zero CO2 emissions?`,
				options: [
					{
						key: 'zeroCO2True',
						label: 'Yes',
						value: true
					},
					{
						key: 'zeroCO2False',
						label: 'No',
						value: false
					}
				]
			},
		};
	}

	function getIsRegistrationDateAfterThreshold (carBenefitObj) {

		return moment(carBenefitObj.CarBenefitRegisteredDateISO).isAfter(CAR_REGISTRATION_DATE_THRESHOLD_MOMENT);
	}

	function goToNextStep ($ctrl) {

		$ctrl.formOptions.activeStep++;
	}

	function goToPreviousStep ($ctrl) {

		$ctrl.formOptions.activeStep--;
	}

	function goToStep ($ctrl, step) {

		$ctrl.formOptions.activeStep = step;
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function populatePaymentScheduleGroup ($ctrl) {

		angular.extend($ctrl.paymentScheduleGroup, {
			CarBenefitID: $ctrl.carBenefit.CarBenefitID,
			TotalAmount: $ctrl.carBenefit.CarBenefitCashEquivalent + $ctrl.carBenefit.CarBenefitFuelCashEquivalent,
			TotalBroughtForward: $ctrl.carBenefit.CarBenefitPaidYTD + $ctrl.carBenefit.CarBenefitFuelPaidYTD,
			PaymentScheduleTypeID: $ctrl.paymentScheduleType.PaymentScheduleTypeID,
			PaymentScheduleTypeDescription: $ctrl.paymentScheduleType.PaymentScheduleTypeDescription,        
			AgencyProfileID: $ctrl.formOptions.agencyProfileId,
			UserID: $ctrl.formOptions.userId,
			PaymentScheduleGroupPayrollBIKBehaviour: adjustmentsService.getAdjustmentBehaviourForBool($ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState)
		});
	}

	function recalculatePaymentScheduleGroup ($ctrl, formObj) {

		const PAUSE_COUNT = 0;
		const STORE_RESULT = false;

		formObj.state = 'saving';

		// Make sure all empty values are set to zero in case needed for calculations
		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.carBenefit, NUMBER_FIELDS);

		// Populate the paymentScheduleGroup object from the various other objects
		populatePaymentScheduleGroup($ctrl);

		// Recalculate on the server
		payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT).then((updatedPaymentScheduleObj) => {

			angular.extend($ctrl.paymentScheduleGroup, updatedPaymentScheduleObj);

			formObj.state = null;

			goToNextStep($ctrl);
		})
		.catch(onError);
	}

	function reviewAvailableFrom () {

		$ctrl.formFields.carBenefitAvailableToISO.minDateIso = $ctrl.carBenefit.CarBenefitAvailableFromISO;
		if ($ctrl.carBenefit.CarBenefitFuelProvided) {
			$ctrl.formFields.carBenefitFuelDateProvidedISO.minDateIso = $ctrl.carBenefit.CarBenefitAvailableFromISO;
		}
	}

	function reviewAvailableTo () {

		if ($ctrl.carBenefit.CarBenefitFuelProvided) {
			$ctrl.formFields.carBenefitFuelDateProvidedISO.maxDateIso = $ctrl.carBenefit.CarBenefitAvailableToISO;
			$ctrl.formFields.carBenefitFuelDateWithdrawnISO.maxDateIso = $ctrl.carBenefit.CarBenefitAvailableToISO;
		}
	}

	function reviewBenefitContributionPrivateUse () {

		// Clear CarBenefitPrivateUse when value of carBenefitHasContributionPrivateUse changes to prompt re-entry
		$ctrl.carBenefit.CarBenefitPrivateUse = '';
	}

	function reviewCalculatePaymentScheduleGroup ($ctrl, formObj) {

		// Recalculate
		if ($ctrl.carBenefit.isEditing) {
			recalculatePaymentScheduleGroup($ctrl, formObj);
		}

		// Calculate
		else {
			calculatePaymentScheduleGroup($ctrl, formObj);
		}
	}

	function reviewCarDetails () {

		const isRegistrationDateAfterThreshold = getIsRegistrationDateAfterThreshold($ctrl.carBenefit);

		$ctrl.formFields.carBenefitEngineSize.isRequired = !isRegistrationDateAfterThreshold;
		$ctrl.carBenefit.isRegistrationDateAfterThreshold = isRegistrationDateAfterThreshold;

		// Before threshold
		if (!isRegistrationDateAfterThreshold) {

			// Fields not applicable, so reset
			angular.extend($ctrl.carBenefit, {
				CarBenefitCO2: '',
				carBenefitCO2Unknown: false,
				CarBenefitZeroEmissionsMileage: ''
			});

			// Engine size is required
			setupEngineSize(true);
		}

		// After threshold
		else {

			// CO2 Emissions unknown
			if ($ctrl.carBenefit.carBenefitCO2Unknown) {

				// CO2 Emissions
				angular.extend($ctrl.formFields.carBenefitCO2, {
					isDisabled: true,
					isRequired: false,
					placeholder: ''
				});
				$ctrl.carBenefit.CarBenefitCO2 = '';
				
				// Engine size is required
				setupEngineSize(true);
			}

			// CO2 Emissions known
			else {
				angular.extend($ctrl.formFields.carBenefitCO2, {
					isDisabled: false,
					isRequired: true,
					placeholder: '0'
				});

				// Engine size is not required
				setupEngineSize(false);
			}
		}

		$ctrl.formFields.carBenefitZeroEmissionsMileage.isRequired = $ctrl.carBenefit.CarBenefitCO2 <= CO2_THRESHOLD;
	}

	function reviewFuelProvided () {

		// Reset date values when unchecked
		if (!$ctrl.carBenefit.CarBenefitFuelProvided) {
			$ctrl.carBenefit.CarBenefitFuelDateProvidedISO = '';
			$ctrl.formFields.CarBenefitFuelDateProvidedISO.maxDateIso = '';
			$ctrl.formFields.CarBenefitFuelDateProvidedISO.minDateIso = '';
			$ctrl.carBenefit.CarBenefitFuelDateWithdrawnISO = '';
			$ctrl.formFields.carBenefitFuelDateWithdrawnISO.maxDateIso = '';
			$ctrl.formFields.carBenefitFuelDateWithdrawnISO.minDateIso = '';
		}
		else {
			reviewAvailableFrom();
			reviewAvailableTo();
		}
	}

	function reviewFuelProvidedDate () {

		$ctrl.formFields.carBenefitFuelDateWithdrawnISO.minDateIso = $ctrl.carBenefit.CarBenefitFuelDateProvidedISO;
	}

	function reviewFuelType () {

		if ($ctrl.carBenefit.CarBenefitFuelType === FUEL_TYPES.electric) {

			// Reset CO2
			$ctrl.carBenefit.CarBenefitCO2 = '';
			$ctrl.formFields.carBenefitCO2.isRequired = false;
			$ctrl.formFields.carBenefitCO2.isDisabled = true;

			$ctrl.carBenefit.CarBenefitZeroEmissionsMileage = '';
			$ctrl.carBenefit.CarBenefitEngineSize = 0;
		}

		else {
			$ctrl.formFields.carBenefitCO2.isRequired = true;
			$ctrl.formFields.carBenefitCO2.isDisabled = false;
		}
	}

	function reviewVanAvailableFrom () {

		$ctrl.formFields.carBenefitVanAvailableToISO.minDateIso = $ctrl.carBenefit.CarBenefitAvailableFromISO;
	}

	function reviewVanShare () {

		// Clear CarBenefitVanShareAvailablePercent when value of CarBenefitVanShare changes to prompt re-entry
		$ctrl.carBenefit.CarBenefitVanShareAvailablePercent = '';
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setupEngineSize (isRequired) {

		if (isRequired) {

			// If CO2 Emissions are unknown then engine size is required (cannot be unknown)
			let ENGINE_SIZES_NEW = angular.copy(ENGINE_SIZES);
			
			// Remove 'Unknown' option
			ENGINE_SIZES_NEW = ENGINE_SIZES_NEW.slice(1);

			angular.extend($ctrl.formFields.carBenefitEngineSize, {
				isRequired: true,
				options: ENGINE_SIZES_NEW
			});

			if ($ctrl.carBenefit.CarBenefitEngineSize === 0) {
				$ctrl.carBenefit.CarBenefitEngineSize = 1;
			}
		}

		else {
			angular.extend($ctrl.formFields.carBenefitEngineSize, {
				isRequired: false,
				options: ENGINE_SIZES
			});
		}
	}

	function updateCarBenefit ($ctrl, formObj) {

		formObj.state = 'saving';

		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.carBenefit, NUMBER_FIELDS);
		utilities.setPropertiesValuesToZeroIfNull($ctrl.carBenefit, NUMBER_FIELDS);

		// Van > Zero Co2 emissions > Set to 1 if CO2 emissions are not zero (see https://www.notion.so/paycircle/Van-can-t-figure-out-the-values-being-shown-b2cf1fdbbc6545d59bf907c963732dd7)
		if ($ctrl.carBenefit.CarBenefitVan) {
			$ctrl.carBenefit.CarBenefitCO2 = $ctrl.carBenefit.carBenefitHasZeroCO2 ? 0 : 1;
		}

		payrollData.updateCarBenefit($ctrl.formOptions.agencyProfileId, $ctrl.carBenefit).then(responseObj => {

			angular.extend($ctrl.carBenefit, responseObj);

			if ($ctrl.carBenefit.HasInvalidVehicleDetails) {
				$ctrl.formOptions.showContext = false;
				$ctrl.formOptions.showProgressBar = false;
				setComponentState('company-vehicle-invalid');
				return;
			}
			
			goToNextStep($ctrl);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function updatePaymentScheduleGroup ($ctrl, formObj) {

		const PAUSE_COUNT = 0;
		const STORE_RESULT = true;

		formObj.state = 'saving';

		const updateCarBenefitTotals = payrollData.updateCarBenefitTotals($ctrl.formOptions.agencyProfileId, $ctrl.carBenefit);
		const updatePaymentScheduleGroup = $ctrl.carBenefit.isEditing ? payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT) : payrollData.updatePaymentScheduleGroup($ctrl.paymentScheduleGroup);

		$q.all([updateCarBenefitTotals, updatePaymentScheduleGroup]).then(() => {

			formObj.state = 'saving';
			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		FUEL_TYPES,
		PAYMENT_SCHEDULE_CATEGORIES,
		$onInit,
		calculatePaymentScheduleGroup,
		goToNextStep,
		goToPreviousStep,
		goToStep,
		reviewCalculatePaymentScheduleGroup,
		updateCarBenefit,
		updatePaymentScheduleGroup
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('companyVehicleViewForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'companyVehicleViewFormCtrl',
	templateUrl: 'forms/employment/company-vehicle-view/company-vehicle-view.form.html'
})

.controller('companyVehicleViewFormCtrl', ['paymentScheduleService', 'payrollData', function (paymentScheduleService, payrollData) {

	const $ctrl = this;

	const PAUSE_OPTIONS = [
		{
			description: '1 period',
			value: 1
		},
		{
			description: '2 periods',
			value: 2
		},
		{
			description: '3 periods',
			value: 3
		},
		{
			description: '4 periods',
			value: 4
		},
		{
			description: '5 periods',
			value: 5
		}
	];

	function $onInit () {

		setComponentState('loading');

		payrollData.getPaymentScheduleGroup($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.paymentScheduleGroupId).then(paymentScheduleGroupObj => {

			angular.extend($ctrl, {
				paymentScheduleGroup: paymentScheduleService.decoratePaymentScheduleGroup(paymentScheduleGroupObj),
				isDeleteConfirmed: false,
				pauseCount: null
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function cancelDelete ($ctrl) {

		$ctrl.isDeleteConfirmed = false;
		setComponentState('ready');
	}

	function deletePaymentScheduleGroup ($ctrl, formObj) {

		if (!$ctrl.isDeleteConfirmed) {
			$ctrl.isDeleteConfirmed = true;
			return;
		}
		
		formObj.state = 'saving';

		payrollData.deletePaymentScheduleGroup($ctrl.formOptions.agencyProfileId, $ctrl.paymentScheduleGroup.PaymentScheduleGroupID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function openCompanyVehicleForm ($ctrl) {

		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			callback: $ctrl.formOptions.callback,
			formKey: 'company-vehicle',
			carBenefitId: $ctrl.paymentScheduleGroup.CarBenefitID,
			paymentScheduleGroupId: $ctrl.paymentScheduleGroup.PaymentScheduleGroupID,
			userId: $ctrl.formOptions.userId
		});
	}

	function pausePaymentScheduleGroup ($ctrl, formObj) {

		const STORE_RESULT = true;
		
		formObj.state = 'saving';

		// Pause and store updated schedule
		payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, $ctrl.pauseCount, STORE_RESULT).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function resumePaymentScheduleGroup ($ctrl, formObj) {
		
		const PAUSE_COUNT = 0; // Not required
		const STORE_RESULT = true;

		formObj.state = 'saving';

		// Resume schedule
		payrollData.updatePaymentScheduleGroupStart($ctrl.paymentScheduleGroup.PaymentScheduleGroupID).then(() => {

			// Recalculate schedule
			payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT).then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		PAUSE_OPTIONS,
		$onInit,
		cancelDelete,
		deletePaymentScheduleGroup,
		openCompanyVehicleForm,
		pausePaymentScheduleGroup,
		resumePaymentScheduleGroup,
		setComponentState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('continuousEmploymentForm', function () {

	return {
		controller: 'continuousEmploymentFormCtrl',
		templateUrl: 'forms/employment/continuous-employment/continuous-employment.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('continuousEmploymentFormCtrl', ['$scope', 'growl', 'teamData', function ($scope, growl, teamData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	const formState = $scope.formOptions.formState;

	function deletePreviousEmployment () {

		setPageState('delete-employment');
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberCompanyContinuousEmployment(userId, agencyProfileId).then(continuousEmploymentObj => {

			$scope.vm = {
				continuousEmployment: continuousEmploymentObj,
				// Offer delete option if any continuous employment info is available
				showDelete: continuousEmploymentObj.ContinuousEmploymentEmployerName || continuousEmploymentObj.ContinuousEmploymentStartDateISO
			};

			if (formState === 'delete-employment') {
				setPageState('delete-employment');

			} else {
				setPageState('ready');
			}
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateTeamMemberCompanyContinuousEmployment (vmObj, formObj) {

		formObj.state = 'saving';

		const continuousEmploymentObj = vmObj.continuousEmployment;

		if ($scope.pageState === 'delete-employment') {
			angular.extend(continuousEmploymentObj, {
				ContinuousEmploymentEmployerName: '',
				ContinuousEmploymentStartDateISO: ''
			});
		}

		teamData.updateTeamMemberCompanyContinuousEmployment(userId, agencyProfileId, continuousEmploymentObj).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Continuous employment details updated');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		deletePreviousEmployment,
		updateTeamMemberCompanyContinuousEmployment
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('deleteTaxUpdateForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'deleteTaxUpdateFormCtrl',
	templateUrl: 'forms/employment/delete-tax-update/delete-tax-update.form.html'
})

.controller('deleteTaxUpdateFormCtrl', [
	'userData',
	function (
		userData
	) {

	const $ctrl = this;

	function $onInit () {

		// Page state
		$ctrl.formState = 'loading';

		if ($ctrl.formOptions.taxUpdate.IsPeriodFinalised) {

			$ctrl.formState = 'cannot-delete';
			return;
		}

		$ctrl.formState = 'ready';
	}

	function deleteTaxUpdate (form) {

		// Update state
		form.state = 'saving';

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const userId = $ctrl.formOptions.userId;
		const userTaxInfoId = $ctrl.formOptions.taxUpdate.UserTaxInfoID;

		// Service call
		userData.deleteUserTaxUpdate(agencyProfileId, userId, userTaxInfoId).then(() => {

			$ctrl.formState = 'success';
		})
		.catch(onError);
	}

	function onError (error) {

		$ctrl.formState = 'error';
		console.error(error);
	}

	angular.extend($ctrl, {
		$onInit,
		deleteTaxUpdate
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('healthcareForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'healthcareFormCtrl',
	templateUrl: 'forms/employment/healthcare/healthcare.form.html'
})

.controller('healthcareFormCtrl', ['$q', 'adjustmentsService', 'config', 'paymentScheduleService', 'payrollData', 'utilities', 'PAYMENT_SCHEDULE_CATEGORIES', 'REPAYMENT_SCHEDULE_TYPES', function ($q, adjustmentsService, config, paymentScheduleService, payrollData, utilities, PAYMENT_SCHEDULE_CATEGORIES, REPAYMENT_SCHEDULE_TYPES) {

	const $ctrl = this;

	const NUMBER_FIELDS = [
		'HealthBenefitCashEquivalent',
		'HealthBenefitPaidYTD',
		'HealthBenefitCost',
		'HealthBenefitContribution',
		'HealthBenefitDependantCount',
		'HealthBenefitDependantContribution'
	];

	function $onInit () {

		const PAYMENT_SCHEDULE_GROUP_ID = angular.isDefined($ctrl.formOptions.paymentScheduleGroupId) ? $ctrl.formOptions.paymentScheduleGroupId : config.guidEmpty;

		setComponentState('loading');

		const getPaymentScheduleGroup = payrollData.getPaymentScheduleGroup($ctrl.formOptions.agencyProfileId, PAYMENT_SCHEDULE_GROUP_ID);
		const getPaymentScheduleTypes = payrollData.getPaymentScheduleTypes($ctrl.formOptions.agencyProfileId, PAYMENT_SCHEDULE_CATEGORIES.health);
		const getHealthBenefit = utilities.isValidGuid($ctrl.formOptions.paymentScheduleGroupId) ? payrollData.getHealthBenefit($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.healthBenefitId) : payrollData.getEmptyHealthBenefit();

		$q.all([getHealthBenefit, getPaymentScheduleTypes, getPaymentScheduleGroup]).then(([healthBenefitObj, paymentScheduleTypesArr, paymentScheduleGroupObj]) => {

			healthBenefitObj = decorateHealthBenefitObj(healthBenefitObj);
			paymentScheduleGroupObj = paymentScheduleService.decoratePaymentScheduleGroup(paymentScheduleGroupObj);
			let paymentScheduleTypeObj = paymentScheduleTypesArr.find(type => type.PaymentScheduleTypeID === REPAYMENT_SCHEDULE_TYPES.healthcare);

			if (!healthBenefitObj.isEditing) {
				paymentScheduleGroupObj.PaymentScheduleGroupPayrollBIKState = paymentScheduleTypeObj.PaymentScheduleTypePayrollBIKState;
			}

			angular.extend($ctrl, {
				healthBenefit: healthBenefitObj,
				formFields: getFormFields($ctrl, healthBenefitObj),
				labelOptions: {
					canSave: false
				},	
				paymentScheduleGroup: paymentScheduleGroupObj,
				paymentScheduleType: paymentScheduleTypeObj
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function calculatePaymentScheduleGroup ($ctrl, formObj) {

		formObj.state = 'saving';

		// Make sure all empty values are set to zero in case needed for calculations
		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.healthBenefit, NUMBER_FIELDS);

		// Populate the paymentScheduleGroup object from the various other objects
		populatePaymentScheduleGroup($ctrl);

		// Calculate on the server
		payrollData.calculatePaymentScheduleGroup($ctrl.paymentScheduleGroup).then(updatedPaymentScheduleObj => {

			angular.extend($ctrl.paymentScheduleGroup, updatedPaymentScheduleObj);

			formObj.state = null;

			goToNextStep($ctrl);
		})
		.catch(onError);
	}

	function decorateHealthBenefitObj (healthBenefitObj) {

		healthBenefitObj.healthBenefitContributes = true;
		healthBenefitObj.isEditing = utilities.isValidGuid(healthBenefitObj.HealthBenefitID);

		if (!healthBenefitObj.isEditing) {			
			utilities.setPropertiesValuesToEmptyIfZero(healthBenefitObj, NUMBER_FIELDS);
		}
		else {
			if (healthBenefitObj.HealthBenefitContribution === 0) {
				healthBenefitObj.healthBenefitContributes = false;
			}
		}

		return healthBenefitObj;
	}

	function getFormFields ($ctrl, healthBenefitObj) {

		return {
			healthBenefitCost: {
				fieldType: 'money',
				id: 'cost',
				label: 'Cost to employer'
			},
			healthBenefitContributes: {
				fieldType: 'radios',
				id: 'contributes',
				label: `Does ${$ctrl.formOptions.context.Forename} make a contribution to the cost?`,
				onChange: reviewContributes,
				options: [
					{
						key: 'contributesYes',
						label: 'Yes',
						value: true
					},
					{
						key: 'contributesNo',
						label: 'No',
						value: false
					}
				]
			},
			healthBenefitContribution: {
				fieldType: 'money',
				id: 'contribution',
				label: 'Contribution amount'
			},
			healthBenefitPolicyStartDateISO: {
				fieldType: 'date',
				id: 'policyStartDate',
				isDisabled: healthBenefitObj.isEditing,
				label: 'Policy start date',
				minDateIso	: moment().set({year:1753,month:0,date:1}).format(config.dateFormatISO),
				onChange: reviewPolicyStartDate
			},
			healthBenefitPolicyEndDateISO: {
				fieldType: 'date',
				id: 'policyEndDate',
				isDisabled: healthBenefitObj.isEditing,
				label: 'Policy end date',
				minDateIso: healthBenefitObj.HealthBenefitPolicyStartDateISO
			},
			healthBenefitCashEquivalent: {
				fieldType: 'money',
				id: 'cashEquivalent',
				label: 'Taxable benefit'
			},
			healthBenefitPaidYTD: {
				fieldType: 'money',
				id: 'paidYTD',
				label: 'Benefit paid YTD'
			}
		};
	}

	function goToNextStep ($ctrl) {

		$ctrl.formOptions.activeStep++;
	}

	function goToPreviousStep ($ctrl) {

		$ctrl.formOptions.activeStep--;
	}

	function goToStep ($ctrl, step) {

		$ctrl.formOptions.activeStep = step;
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function populatePaymentScheduleGroup ($ctrl) {

		angular.extend($ctrl.paymentScheduleGroup, {
			AgencyProfileID: $ctrl.formOptions.agencyProfileId,
			HealthBenefitID: $ctrl.healthBenefit.HealthBenefitID,
			PaymentScheduleTypeID: $ctrl.paymentScheduleType.PaymentScheduleTypeID,
			PaymentScheduleTypeDescription: $ctrl.paymentScheduleType.PaymentScheduleTypeDescription,        
			TotalAmount: $ctrl.healthBenefit.HealthBenefitCashEquivalent,
			TotalBroughtForward: $ctrl.healthBenefit.HealthBenefitPaidYTD,
			UserID: $ctrl.formOptions.userId,
			PaymentScheduleGroupPayrollBIKBehaviour: adjustmentsService.getAdjustmentBehaviourForBool($ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState)
		});
	}

	function recalculatePaymentScheduleGroup ($ctrl, formObj) {

		const PAUSE_COUNT = 0;
		const STORE_RESULT = false;

		formObj.state = 'saving';

		// Make sure all empty values are set to zero in case needed for calculations
		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.healthBenefit, NUMBER_FIELDS);

		// Populate the paymentScheduleGroup object from the various other objects
		populatePaymentScheduleGroup($ctrl);

		// Calculate on the server
		payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT).then(updatedPaymentScheduleObj => {

			angular.extend($ctrl.paymentScheduleGroup, updatedPaymentScheduleObj);

			formObj.state = null;

			goToNextStep($ctrl);
		})
		.catch(onError);
	}

	function reviewCalculatePaymentScheduleGroup ($ctrl, formObj) {

		// Recalculate
		if ($ctrl.healthBenefit.isEditing) {
			recalculatePaymentScheduleGroup($ctrl, formObj);
		}

		// Calculate
		else {
			calculatePaymentScheduleGroup($ctrl, formObj);
		}
	}

	function reviewPolicyStartDate () {
		$ctrl.formFields.healthBenefitPolicyEndDateISO.minDateIso = $ctrl.healthBenefit.HealthBenefitPolicyStartDateISO;
	}

	function reviewContributes () {
	
		if (!$ctrl.healthBenefit.healthBenefitContributes) {
			$ctrl.healthBenefit.HealthBenefitContribution = '';
		}
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function updateHealthBenefit ($ctrl, formObj) {

		formObj.state = 'saving';

		utilities.setPropertiesValuesToZeroIfEmpty($ctrl.healthBenefit, NUMBER_FIELDS);
		utilities.setPropertiesValuesToZeroIfNull($ctrl.healthBenefit, NUMBER_FIELDS);

		payrollData.updateHealthBenefit($ctrl.formOptions.agencyProfileId, $ctrl.healthBenefit).then(responseObj => {

			angular.extend($ctrl.healthBenefit, responseObj);

			goToNextStep($ctrl);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function updatePaymentScheduleGroup ($ctrl, formObj) {

		const PAUSE_COUNT = 0;
		const STORE_RESULT = true;

		formObj.state = 'saving';

		const updateHealthBenefitTotals = payrollData.updateHealthBenefitTotals($ctrl.formOptions.agencyProfileId, $ctrl.healthBenefit);
		const updatePaymentScheduleGroup = $ctrl.healthBenefit.isEditing ? payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT) : payrollData.updatePaymentScheduleGroup($ctrl.paymentScheduleGroup);

		$q.all([updateHealthBenefitTotals, updatePaymentScheduleGroup]).then(() => {

			formObj.state = 'saving';
			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		PAYMENT_SCHEDULE_CATEGORIES,
		$onInit,
		goToNextStep,
		goToPreviousStep,
		goToStep,
		reviewCalculatePaymentScheduleGroup,
		updateHealthBenefit,
		updatePaymentScheduleGroup
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('healthcareViewForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'healthcareViewFormCtrl',
	templateUrl: 'forms/employment/healthcare-view/healthcare-view.form.html'
})

.controller('healthcareViewFormCtrl', ['paymentScheduleService', 'payrollData', function (paymentScheduleService, payrollData) {

	const $ctrl = this;

	const PAUSE_OPTIONS = [
		{
			description: '1 period',
			value: 1
		},
		{
			description: '2 periods',
			value: 2
		},
		{
			description: '3 periods',
			value: 3
		},
		{
			description: '4 periods',
			value: 4
		},
		{
			description: '5 periods',
			value: 5
		}
	];

	function $onInit () {

		setComponentState('loading');

		payrollData.getPaymentScheduleGroup($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.paymentScheduleGroupId).then(paymentScheduleGroupObj => {

			angular.extend($ctrl, {
				paymentScheduleGroup: paymentScheduleService.decoratePaymentScheduleGroup(paymentScheduleGroupObj),
				isDeleteConfirmed: false,
				pauseCount: null
			});

			setComponentState('ready');
		})
		.catch(onError);
	}

	function cancelDelete ($ctrl) {

		$ctrl.isDeleteConfirmed = false;
		setComponentState('ready');
	}

	function deletePaymentScheduleGroup ($ctrl, formObj) {

		if (!$ctrl.isDeleteConfirmed) {
			$ctrl.isDeleteConfirmed = true;
			return;
		}
		
		formObj.state = 'saving';

		payrollData.deletePaymentScheduleGroup($ctrl.formOptions.agencyProfileId, $ctrl.paymentScheduleGroup.PaymentScheduleGroupID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function openHealthcareForm ($ctrl) {

		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			callback: $ctrl.formOptions.callback,
			formKey: 'healthcare',
			healthBenefitId: $ctrl.paymentScheduleGroup.HealthBenefitID,
			paymentScheduleGroupId: $ctrl.paymentScheduleGroup.PaymentScheduleGroupID,
			userId: $ctrl.formOptions.userId
		});
	}

	function pausePaymentScheduleGroup ($ctrl, formObj) {

		const STORE_RESULT = true;
		
		formObj.state = 'saving';

		// Recalculate and store updated schedule
		payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, $ctrl.pauseCount, STORE_RESULT).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function resumePaymentScheduleGroup ($ctrl, formObj) {
		
		const PAUSE_COUNT = 0; // Not required
		const STORE_RESULT = true;

		formObj.state = 'saving';

		// Resume schedule
		payrollData.updatePaymentScheduleGroupStart($ctrl.paymentScheduleGroup.PaymentScheduleGroupID).then(() => {

			// Recalculate schedule
			payrollData.recalculatePaymentScheduleAllPeriods($ctrl.paymentScheduleGroup, PAUSE_COUNT, STORE_RESULT).then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		PAUSE_OPTIONS,
		$onInit,
		cancelDelete,
		deletePaymentScheduleGroup,
		openHealthcareForm,
		pausePaymentScheduleGroup,
		resumePaymentScheduleGroup,
		setComponentState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('linkRateForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'linkRateFormCtrl',
	templateUrl: 'forms/employment/link-rate/link-rate.form.html'
})

.controller('linkRateFormCtrl', [
	'$q',
	'adjustmentsService',
	'config',
	'payrollData',
	'regexService',
	'salaryService',
	'session',
	'ADJUSTMENT_VALUE_TYPES',
	function (
		$q,
		adjustmentsService,
		config,
		payrollData,
		regexService,
		salaryService,
		session,
		ADJUSTMENT_VALUE_TYPES
	) {

	const $ctrl = this;

	const loggedInUserId = session.getUserId();

	function $onInit () {

		const IS_BULK = angular.isDefined($ctrl.formOptions.userIds) && $ctrl.formOptions.userIds.length > 1;
		const IS_EDITING = angular.isDefined($ctrl.formOptions.linkRateObj);

		setComponentState('loading');

		angular.extend($ctrl, {
			isBulk: IS_BULK,
			isEditing: IS_EDITING
		});

		if (IS_BULK) {
			initForBulk($ctrl);
		}

		else {
			initForIndividual($ctrl);
		}

	}

	function deleteUserPayElement ($ctrl, formObj) {

		formObj.state = 'saving';

		payrollData.deleteUserPayElement(
			$ctrl.formOptions.agencyProfileId,
			undefined,
			$ctrl.userPayElement.UserPayElementID,
			loggedInUserId
		)
		.then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	function filterAppliedLinkRates ($ctrl) {

		if (angular.isUndefined($ctrl.formOptions.appliedLinkRates)) {
			return;
		}

		// Create array of LinkElementID's that are already in use
		const appliedLinkRateIds = $ctrl.formOptions.appliedLinkRates.map(linkRateObj => {
			return linkRateObj.LinkElementID;
		});

		// Filter out Link Rates that are already used
		$ctrl.linkElementDetails.LinkElements = $ctrl.linkElementDetails.LinkElements.filter(linkElementObj => {
			return !appliedLinkRateIds.includes(linkElementObj.LinkElementID);
		});
	}

	function initForBulk ($ctrl) {

		const getLinkElements = payrollData.getLinkElements($ctrl.formOptions.agencyProfileId);
		const getUserPayElementDetail = payrollData.getEmptyUserPayElementDetailForLink();

		$q.all([
			getLinkElements,
			getUserPayElementDetail
		])
		.then(([
			linkElementsObj,
			userPayElementDetailObj
		]) => {

			// No company link elements
			if (linkElementsObj.LinkElements.length === 0) {
				setComponentState('no-link-elements');
				return;
			}

			angular.extend($ctrl, {
				linkElementDetails: linkElementsObj,
				userPayElement: userPayElementDetailObj
			});

			setupBulkRates($ctrl);

			setComponentState('ready');
		})
		.catch(onError);
	}

	function initForIndividual ($ctrl) {

		const getLinkElements = payrollData.getLinkElements($ctrl.formOptions.agencyProfileId);
		const getTeamMemberSalaries = payrollData.getTeamMemberSalariesForPostsWithCalculatedRates($ctrl.formOptions.agencyProfileId, config.guidEmpty, $ctrl.formOptions.userId);
		const getUserPayElementDetail = $ctrl.isEditing ? $ctrl.formOptions.linkRateObj : payrollData.getEmptyUserPayElementDetailForLink();

		$q.all([
			getLinkElements,
			getTeamMemberSalaries,
			getUserPayElementDetail
		])
		.then(([
			linkElementsObj,
			teamMemberSalariesObj,
			userPayElementDetailObj
		]) => {

			// No company link elements
			if (linkElementsObj.LinkElements.length === 0) {
				setComponentState('no-link-elements');
				return;
			}

			var teamMemberSalaryObj = salaryService.getSalaryDetailsWithRatesForPost(teamMemberSalariesObj, config.guidEmpty);

			angular.extend($ctrl, {
				linkElementDetails: linkElementsObj,
				salaryOriginal: angular.copy(teamMemberSalaryObj),
				salary: teamMemberSalaryObj,
				userPayElement: userPayElementDetailObj
			});

			filterAppliedLinkRates($ctrl);

			if ($ctrl.isEditing) {
				populateLinkElementAndRate($ctrl);
			}

			switch ($ctrl.formOptions.actionType) {

				case 'delete': {
					setComponentState('confirm-delete');
					return;
				}
				default: {
					setComponentState('ready');
				}
			}
		})
		.catch(onError);
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function populateLinkElementAndRate ($ctrl) {

		$ctrl.selectedLinkElement = angular.copy($ctrl.userPayElement.linkElement);

		reviewLinkElement($ctrl);

		$ctrl.selectedRate = salaryService.getSalaryRateForUserPayElement($ctrl.salary, $ctrl.userPayElement);
	}

	function populateUserPayElementObj ($ctrl) {

		if($ctrl.selectedLinkElement.LinkElementAdjustmentValueType === $ctrl.ADJUSTMENT_VALUE_TYPES.unit){
			reviewStandardUnits($ctrl);
		}

		angular.extend($ctrl.userPayElement, {
			AddStandardUnits: $ctrl.userPayElement.AddStandardUnits,
			LinkElementID: $ctrl.selectedLinkElement.LinkElementID,
			Recurring: true,
			UserID: $ctrl.formOptions.userId,
			UseLinkElementRate: $ctrl.selectedRate.SalaryRateID === 'global-rate',
			Value: adjustmentsService.getAdjustmentUnitValue($ctrl.userPayElement)
		});

		return $ctrl;
	}

	function reviewLinkElement ($ctrl) {

		if (!$ctrl.selectedLinkElement) {
			return;
		}

		// Bulk
		if ($ctrl.isBulk) {
			setupBulkRates($ctrl);
		}

		// Individual
		else {

			// Reset salary obj (to reset salary rates)
			$ctrl.salary = angular.copy($ctrl.salaryOriginal);

			// Add global rate option, if applicable
			salaryService.addSalaryRateLinkElementGlobalRate($ctrl.salary, $ctrl.selectedLinkElement);
		}

		reviewUserPayElement($ctrl);
	}

	function reviewStandardUnits ($ctrl) {

		if (!$ctrl.userPayElement.AddStandardUnits) {
			$ctrl.userPayElement.Units = 0;
		}
	}

	function reviewUserPayElement ($ctrl) {

		if (!$ctrl.selectedLinkElement || !$ctrl.selectedRate) {
			return;
		}

		angular.extend($ctrl.userPayElement, {
			UnitValue: angular.copy($ctrl.selectedRate.SalaryRateValue),
			UnitValueMultiplier: angular.copy($ctrl.selectedLinkElement.LinkElementMultiplier),
			UserPayElementIsSalaryDerivedRatedElement: false,
			RateType: $ctrl.selectedRate.RateType
		});

		if (!$ctrl.isBulk && $ctrl.selectedRate.SalaryRateID && salaryService.getSalaryRateTypeIsSalaryDerivedRate($ctrl.selectedRate)) {
			angular.extend($ctrl.userPayElement, {
				UserPayElementIsSalaryDerivedRatedElement: true
			});
		}
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function setupBulkRates ($ctrl) {

		let ratesArr = [];

		// Global rates (if applicable)
		if ($ctrl.selectedLinkElement && $ctrl.selectedLinkElement.LinkElementRate > 0) {
			ratesArr.push(salaryService.getGlobalRateForLinkElement($ctrl.selectedLinkElement));
		}

		// Custom rate
		ratesArr.push(salaryService.getCustomRate());

		$ctrl.rates = ratesArr;
	}

	function updateUserPayElements ($ctrl, formObj) {

		var PAY_PERIOD_ID; // Undefined

		formObj.state = 'saving';

		populateUserPayElementObj($ctrl);

		// Bulk
		if ($ctrl.isBulk) {

			payrollData.updateUserPayElementsBulk(
				$ctrl.formOptions.agencyProfileId,
				PAY_PERIOD_ID,
				$ctrl.userPayElement,
				$ctrl.formOptions.userIds
			)
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
		}

		// Individual
		else {
			payrollData.updateUserPayElements(
				$ctrl.formOptions.agencyProfileId,
				PAY_PERIOD_ID,
				[$ctrl.userPayElement]
			)
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
		}
	}

	angular.extend($ctrl, {

		regexService,

		ADJUSTMENT_VALUE_TYPES,

		$onInit,
		deleteUserPayElement,
		reviewLinkElement,
		reviewStandardUnits,
		reviewUserPayElement,
		updateUserPayElements
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('movedPayrollsWarningForm', function () {

	return {
		controller: 'movedPayrollsWarningFormCtrl',
		templateUrl: 'forms/employment/movedPayrollsWarning/movedPayrollsWarningForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('movedPayrollsWarningFormCtrl', ['$scope', '$timeout', function ($scope, $timeout) {

	function dismissWarning () {
		$scope.formOptions.closeForm();
		$timeout(() => {
			$scope.formOptions.forceCallback();
		}, 200);
	}

	angular.extend($scope, {
		dismissWarning
	});
}]);
'use strict';

angular.module('paycircleApp')

.directive('newStarterInformationForm', function () {

	return {
		controller: 'newStarterInformationFormCtrl',
		templateUrl: 'forms/employment/new-starter-information/new-starter-information.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('newStarterInformationFormCtrl', [
	'$q',
	'$scope',
	'payrollData',
	'teamData',
	'utilities',
	'SECONDED_STATES',
	function (
		$q,
		$scope,
		payrollData,
		teamData,
		utilities,
		SECONDED_STATES
	) {

	const NEW_STARTER_DOCUMENT_TYPES = {
		declaration: 0,
		p45: 1,
		p6: 2
	};

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;
	const userId = $scope.formOptions.userId;

	function decorateTeamMember (teamMemberObj) {

		// Set starter document type depending on team member object attributes
		if (teamMemberObj.Tax.IsP45Available) {
			teamMemberObj.newStarterDocumentType = NEW_STARTER_DOCUMENT_TYPES.p45;
		}
		else if (teamMemberObj.Tax.IsP6Available) {
			teamMemberObj.newStarterDocumentType = NEW_STARTER_DOCUMENT_TYPES.p6;
		}
		else {
			// No P45 or P6, so document type is a declaration
			teamMemberObj.newStarterDocumentType = NEW_STARTER_DOCUMENT_TYPES.declaration;
		}

		// Hold the original document type to detect changes
		teamMemberObj.originalNewStarterDocumentType = teamMemberObj.newStarterDocumentType;

		// Hide note for changing document type initially
		teamMemberObj.showDocumentTypeChangeWarning = false;

		// Clear SecondedState if none is set to force user to update setting before saving
		if (teamMemberObj.Company.IsSeconded && teamMemberObj.Tax.SecondedState === SECONDED_STATES.none) {
			teamMemberObj.Tax.SecondedState = '';
		}

		return teamMemberObj;
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberInformation(userId, agencyProfileId).then(teamMemberObj => {

			// Min date for leave date (P45 only)
			teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISOMin = utilities.getTaxYearStartDateISO(moment(currentPayPeriodObj.PayDateISO), true);

			$scope.teamMember = decorateTeamMember(teamMemberObj);

			// Page state
			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		throw(error);
	}

	function onStarterDocumentChange (teamMemberObj) {

		// Show note for changing document type if applicable
		teamMemberObj.showDocumentTypeChangeWarning = (teamMemberObj.originalNewStarterDocumentType !== teamMemberObj.newStarterDocumentType);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateNewStarterInformation (teamMemberObj, formObj) {

		formObj.state = 'saving';

		// Reset attributes according to document type selection
		if (teamMemberObj.newStarterDocumentType !== NEW_STARTER_DOCUMENT_TYPES.declaration) {
			// Reset leave date if P6 selected - not applicable
			if (teamMemberObj.newStarterDocumentType === NEW_STARTER_DOCUMENT_TYPES.p6) {
				teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISO = '';
			}
		}
		else {
			// Declaration selected, YTD stuff irrelevant
			teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISO = '';
			teamMemberObj.YTD.YTDGrossPreviousEmployment = 0;
			teamMemberObj.YTD.YTDTaxPreviousEmployment = 0;
		}

		payrollData.updateUserTaxInfoStarterDetails(userId,
													agencyProfileId,
													teamMemberObj.YTD.YTDGrossPreviousEmployment,
													teamMemberObj.YTD.YTDTaxPreviousEmployment,
													teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISO,
													teamMemberObj.Tax.StarterDeclaration).then(() => {

			formObj.state = 'saved';
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		NEW_STARTER_DOCUMENT_TYPES,
		SECONDED_STATES,

		onStarterDocumentChange,
		updateNewStarterInformation
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('paymentsToDateForm', function () {

	return {
		controller: 'paymentsToDateFormCtrl',
		templateUrl: 'forms/employment/paymentsToDate/paymentsToDateForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('paymentsToDateFormCtrl', [
	'$q',
	'$scope',
	'base',
	'growl',
	'teamData',
	'utilities',
	'INTERFACE_TYPES',
	'PAYROLL_MOVE_STATUSES',
	function (
		$q,
		$scope,
		base,
		growl,
		teamData,
		utilities,
		INTERFACE_TYPES,
		PAYROLL_MOVE_STATUSES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	const payPeriodObj = $scope.formOptions.currentPayPeriod;

	const TABS = {
		postRTIInclusion: 'post-rti-inclusion',
		preRTIInclusion: 'pre-rti-inclusion'
	};

	function checkPropertyValues (ytdObj) {

		// Additional payments
		if (!ytdObj.hasAdditionalPayments) {
			angular.extend(ytdObj, {
				YTDSAPCurrentEmployment: 0,
				YTDSMPCurrentEmployment: 0,
				YTDSNCPCurrentEmployment: 0,
				YTDSPBPCurrentEmployment: 0,
				YTDSPPCurrentEmployment: 0,
				YTDSSPCurrentEmployment: 0,
				YTDShPPCurrentEmployment: 0,
				YTDPostGraduateLoanCurrentEmployment: 0,
				YTDStudentLoanCurrentEmployment: 0,
			});
		}

		// Pension contributions
		if (!ytdObj.hasPensionContributions) {
			angular.extend(ytdObj, {
				YTDPensionContributionEmployee: 0,
				YTDPensionContributionEmployer: 0,
				YTDPensionContributionVoluntary: 0,
				YTDPensionContributionEmployeeNonAE: 0,
				YTDPensionContributionEmployerNonAE: 0,
				YTDPensionContributionVoluntaryNonAE: 0
			});
		}

		// Payrolled BIK year to dates
		if (!ytdObj.hasBIKYTDs) {
			ytdObj.YTDPayrollBIK = 0;
		}

		// Previous employment payments
		if (!ytdObj.hasPreviousEmploymentPay) {
			angular.extend(ytdObj, {
				YTDGrossPreviousEmployment: 0,
				YTDTaxPreviousEmployment: 0,
			});
		}

		// Tax exempt YTDs
		if (!ytdObj.hasTaxExcemptYtds) {
			angular.extend(ytdObj, {
				YTDTaxExemptIncome: 0,
				YTDTaxExemptGrossUp: 0
			});
		}

		// Foreign tax credits
		if (!ytdObj.hasForeignTaxCredits) {
			angular.extend(ytdObj, {
				YTDForeignTaxCredit: 0,
				YTDForeignTaxOffset: 0
			});
		}

		// Taxable earnings UK & abroad
		if (!ytdObj.hasEarningsTaxableUKAndAbroad) {
			angular.extend(ytdObj, {
				YTDEarningsTaxableInUKandAbroad: 0
			});
		}

		// Foreign tax paid
		if (!ytdObj.hasTotalForeignTaxPaidYTD) {
			angular.extend(ytdObj, {
				YTDForeignTaxPaid: 0
			});
		}

		// YTD NI LELS
		if (!ytdObj.hasYTDNILELs) {
			angular.extend(ytdObj, {
				YTDNIatLEL: 0,
				YTDNILELtoPT: 0,
				YTDNIPTtoUEL: 0,
				YTDNIAboveUEL: 0,

				// Director NI LELs
				YTDDirectorNIatLEL: 0,
				YTDDirectorNILELtoPT:0,
				YTDDirectorNIPTtoUEL: 0,
				YTDDirectorNIAboveUEL: 0
			});
		}

		// Second YTD NI Code
		if (!ytdObj.hasSecondNICLetterCode) {
			angular.extend(ytdObj, {
				YTDNICode2: '',
				YTDEENICurrentEmployment2: 0,
				YTDERNICurrentEmployment2: 0,
				YTDNIatLEL2: 0,
				YTDNILELtoPT2: 0,
				YTDNIPTtoUEL2: 0,
				YTDNIAboveUEL2: 0,

				YTDDirectorEENICurrentEmployment2: 0,
				YTDDirectorERNICurrentEmployment2: 0,

				// Director NI LELs
				YTDDirectorNIatLEL2: 0,
				YTDDirectorNILELtoPT2:0,
				YTDDirectorNIPTtoUEL2: 0,
				YTDDirectorNIAboveUEL2: 0
			});
		}

		// Second YTD NI Code LELS
		if (!ytdObj.hasYTDNILELs2) {
			angular.extend(ytdObj, {
				YTDNIatLEL2: 0,
				YTDNILELtoPT2: 0,
				YTDNIPTtoUEL2: 0,
				YTDNIAboveUEL2: 0,

				// Director NI LELs
				YTDDirectorNIatLEL2: 0,
				YTDDirectorNILELtoPT2:0,
				YTDDirectorNIPTtoUEL2: 0,
				YTDDirectorNIAboveUEL2: 0
			});
		}

		return ytdObj;
	}

	function decorateTeamMember (teamMemberObj) {

		/* Set flag for payroll move status === InwardPending for convenience. This indicates that the team member
   		   is in the process of moving from another payroll to this one, thereby disabling certain fields and displaying
		   a note about that */
		teamMemberObj.Company.isMovingPayrollsInwardPending = (teamMemberObj.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending);

		// Fields are only mandatory if team member is a non-leaver or a leaver not in setup mode
		teamMemberObj.isTeamMemberSetupFieldsRequired = !(teamMemberObj.IsInSetupMode && teamMemberObj.Company.IsLeaver && !teamMemberObj.TeamMemberSetupComplete);

		let ytdObj = teamMemberObj.YTD;

		// Additional payments
		angular.extend(ytdObj, {
			hasSAP: ytdObj.YTDSAPCurrentEmployment !== 0, // Statutory adoption pay
			hasSMP: ytdObj.YTDSMPCurrentEmployment !== 0, // Statutory maternity pay
			hasSNCP: ytdObj.YTDSNCPCurrentEmployment !== 0, // Statutory neonatal care pay
			hasSPBP: ytdObj.YTDSPBPCurrentEmployment !== 0, // Statutory parental bereavement pay
			hasSPP: ytdObj.YTDSPPCurrentEmployment !== 0, // Statutory paternity pay
			hasShPP: ytdObj.YTDShPPCurrentEmployment !== 0, // Statutory shared parental pay
			hasSSP: ytdObj.YTDSSPCurrentEmployment !== 0, // Statutory sick pay
			hasPostgradLoan: ytdObj.YTDPostGraduateLoanCurrentEmployment !== 0, // Postgraduate loan
			hasStudentLoan: ytdObj.YTDStudentLoanCurrentEmployment !== 0, // Student loan

			hasBIKYTDs: ytdObj.YTDPayrollBIK !== 0, // BIK YTDs
			hasEarningsTaxableUKAndAbroad: ytdObj.YTDEarningsTaxableInUKandAbroad !== 0,
			hasForeignTaxCredits: ytdObj.YTDForeignTaxCredit !== 0 || ytdObj.YTDForeignTaxOffset !== 0,
			hasPreviousEmploymentPay: ytdObj.YTDGrossPreviousEmployment !== 0 || ytdObj.YTDTaxPreviousEmployment !== 0, // Previous employment payments
			hasPensionContributions: ytdObj.YTDPensionContributionEmployee !== 0 ||
									 ytdObj.YTDPensionContributionEmployer !== 0 ||
									 ytdObj.YTDPensionContributionVoluntary !== 0 ||
									 ytdObj.YTDPensionContributionEmployeeNonAE !== 0 ||
									 ytdObj.YTDPensionContributionEmployerNonAE  !== 0 ||
									 ytdObj.YTDPensionContributionVoluntaryNonAE !== 0, // Pension contributions - set to true if there are any
			hasTaxExcemptYtds: ytdObj.YTDTaxExemptIncome !== 0 || ytdObj.YTDTaxExemptGrossUp !== 0,
			hasTotalForeignTaxPaidYTD: ytdObj.YTDForeignTaxPaid !== 0
		});

		// Additional payments
		angular.extend(ytdObj, {
			canHaveSAP: ytdObj.hasSAP || teamMemberObj.CanAddAdoptionPay, // Statutory adoption pay
			canHaveSMP: ytdObj.hasSMP || teamMemberObj.CanAddMaternityPay, // Statutory maternity pay
			canHaveSNCP: ytdObj.hasSNCP || teamMemberObj.CanAddNeonatalCarePay, // Statutory neonatal care pay
			canHaveSPBP: ytdObj.hasSPBP || teamMemberObj.CanAddParentalBereavementPay, // Statutory parental bereavement pay
			canHaveSPP: ytdObj.hasSPP || teamMemberObj.CanAddPaternityPay, // Statutory paternity pay
			canHaveShPP: ytdObj.hasShPP || teamMemberObj.CanAddSharedParentalPay, // Statutory shared parental pay

			hasAdditionalPayments: ytdObj.hasSAP || ytdObj.hasSMP || ytdObj.hasSNCP || ytdObj.hasSPBP || ytdObj.hasSPP || ytdObj.hasShPP || ytdObj.hasSSP || ytdObj.hasPostgradLoan || ytdObj.hasStudentLoan, // Additional payments
		
			additionalPaymentsCopy: getAdditionalPaymentsCopy (teamMemberObj)
		});

		// Empty any properties set to 0 so they are actually entered
		if (teamMemberObj.IsInSetupMode && !teamMemberObj.YTDSetupComplete && payPeriodObj.IsYTDInformationRequired) {
			utilities.setAnyPropertiesToEmptyIfZero(ytdObj);
		}

		// Set additional payments to empty if no YTD isn't required
		if (!payPeriodObj.IsYTDInformationRequired) {
			angular.extend(ytdObj, {
				YTDSAPCurrentEmployment: '',
				YTDSMPCurrentEmployment: '',
				YTDSNCPCurrentEmployment: '',
				YTDSPBPCurrentEmployment: '',
				YTDSPPCurrentEmployment: '',
				YTDShPPCurrentEmployment: '',
				YTDSSPCurrentEmployment: '',
				YTDPostGraduateLoanCurrentEmployment: '',
				YTDStudentLoanCurrentEmployment: '',
			});
		}

		// Show NI LELs if they exist
		let hasYTDNILELs = getHasNIEarningThesholdsEnabled(teamMemberObj);

		angular.extend(ytdObj, {
			YTDNICode: utilities.setPropertyValueToNullIfEmptyString(ytdObj.YTDNICode),
			hasYTDNILELs: hasYTDNILELs
		});

		if (!hasYTDNILELs) {
			angular.extend(ytdObj, {
				YTDNIatLEL: '',
				YTDNILELtoPT: '',
				YTDNIPTtoUEL: '',
				YTDNIAboveUEL: '',

				// Directors NI LELs
				YTDDirectorNIatLEL: '',
				YTDDirectorNILELtoPT: '',
				YTDDirectorNIPTtoUEL: '',
				YTDDirectorNIAboveUEL: '',
			});
		}

		// Second YTD NI code
		let hasSecondNICLetterCode = ytdObj.YTDNICode2 !== '';
		let hasYTDNILELs2 = (
			(
				ytdObj.YTDNIatLEL2 !== 0 ||
				ytdObj.YTDNILELtoPT2 !== 0 ||
				ytdObj.YTDNIPTtoUEL2 !== 0 ||
				ytdObj.YTDNIAboveUEL2 !== 0
			) || (
				ytdObj.YTDDirectorNIatLEL2 !== 0 ||
				ytdObj.YTDDirectorNILELtoPT2 !== 0 ||
				ytdObj.YTDDirectorNIPTtoUEL2 !== 0 ||
				ytdObj.YTDDirectorNIAboveUEL2 !== 0
			)
		);

		angular.extend(ytdObj, {
			hasSecondNICLetterCode: hasSecondNICLetterCode,
			hasYTDNILELs2: hasYTDNILELs2,
		});

		if (!hasSecondNICLetterCode) {
			angular.extend(ytdObj, {
				YTDNICode2: null,
				YTDEENICurrentEmployment2: '',
				YTDERNICurrentEmployment2: '',
				YTDNIatLEL2: '',
				YTDNILELtoPT2: '',
				YTDNIPTtoUEL2: '',
				YTDNIAboveUEL2: '',

				YTDDirectorEENICurrentEmployment2: '',
				YTDDirectorERNICurrentEmployment2: '',

				// Director NI LELs
				YTDDirectorNIatLEL2: '',
				YTDDirectorNILELtoPT2:'',
				YTDDirectorNIPTtoUEL2: '',
				YTDDirectorNIAboveUEL2: ''
			});
		}

		if (!hasYTDNILELs2) {
			angular.extend(ytdObj, {
				YTDNIatLEL2: '',
				YTDNILELtoPT2: '',
				YTDNIPTtoUEL2: '',
				YTDNIAboveUEL2: '',

				// Director NI LELs
				YTDDirectorNIatLEL2: '',
				YTDDirectorNILELtoPT2:'',
				YTDDirectorNIPTtoUEL2: '',
				YTDDirectorNIAboveUEL2: ''
			});
		}

		// Pre-RTI Inclusion YTDs
		if (teamMemberObj.HasYTDnonRTI) {

			const startOfTaxYear = moment(utilities.getTaxYearStartDateISO(moment())).format('YY');

			angular.extend(teamMemberObj, {
				hidePreRTIAdditionalPayments: true,
				nonRTIPayments: getYTDPaymentsArrayFromYTDs(teamMemberObj),
				preRtiTaxYearDisplay: startOfTaxYear+'-'+(parseInt(startOfTaxYear)+1)
			});
		}

		// Update object
		teamMemberObj.YTD = ytdObj;

		return teamMemberObj;
	}

	function getAdditionalPaymentsCopy (teamMemberObj) {

		const listItemsArr = [];

		if (teamMemberObj.CanAddStudentLoan) {
			listItemsArr.push('Student Loan');
		}

		if (teamMemberObj.CanAddPostgraduateLoan) {
			listItemsArr.push('Postgraduate Loan');
		}

		listItemsArr.push('Sick Pay');

		if (teamMemberObj.CanAddMaternityPay) {
			listItemsArr.push('Maternity Pay');
		}

		if (teamMemberObj.CanAddPaternityPay) {
			listItemsArr.push('Paternity Pay');
		}

		if (teamMemberObj.CanAddAdoptionPay) {
			listItemsArr.push('Adoption Pay');
		}

		if (teamMemberObj.CanAddSharedParentalPay) {
			listItemsArr.push('Shared Parental Pay');
		}

		if (teamMemberObj.CanAddParentalBereavementPay) {
			listItemsArr.push('Parental Bereavement Pay');
		}

		if (teamMemberObj.CanAddNeonatalCarePay) {
			listItemsArr.push('Neonatal Care Pay');
		}

		let additionalPaymentsCopy = '';
		let listItemsArrLength = listItemsArr.length;

		for (let i = 0; i < listItemsArrLength; i++) {

			if (i > 0) {
				additionalPaymentsCopy = additionalPaymentsCopy.concat(i === listItemsArrLength - 1 ? ' or ' : ', ');
			}

			additionalPaymentsCopy = additionalPaymentsCopy.concat(listItemsArr[i]);
		}

		return additionalPaymentsCopy;
	}

	function getHasNIEarningThesholdsEnabled (teamMemberObj) {

		if (teamMemberObj.IsInSetupMode && !teamMemberObj.YTDSetupComplete) {
			return !teamMemberObj.Company.IsStarter;

		} else {
			return (
				teamMemberObj.YTD.YTDNIatLEL !== 0 ||
				teamMemberObj.YTD.YTDNILELtoPT !== 0 ||
				teamMemberObj.YTD.YTDNIPTtoUEL !== 0 ||
				teamMemberObj.YTD.YTDNIAboveUEL !== 0
			) || (
				teamMemberObj.YTD.YTDDirectorNIatLEL !== 0 ||
				teamMemberObj.YTD.YTDDirectorNILELtoPT !== 0 ||
				teamMemberObj.YTD.YTDDirectorNIPTtoUEL !== 0 ||
				teamMemberObj.YTD.YTDDirectorNIAboveUEL !== 0
			);
		}
	}

	function getYTDPaymentsArrayFromYTDs (teamMemberObj) {

		const ytdObj = teamMemberObj.YTDnonRTI;

		const paymentsArr = [
			{
				paymentAmount: ytdObj.YTDGrossCurrentEmploymentforTax,
				paymentLabel: 'Gross pay'
			},
			{
				paymentAmount: ytdObj.YTDTaxCurrentEmployment,
				paymentLabel: 'Tax'
			},
			{
				paymentAmount: ytdObj.YTDEENICurrentEmployment,
				paymentLabel: 'Employee\'s NI'
			},
			{
				paymentAmount: ytdObj.YTDERNICurrentEmployment,
				paymentLabel: 'Employer\'s NI'
			},

			// Additional payments
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDStudentLoanCurrentEmployment,
				paymentLabel: 'Student loan'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDPostGraduateLoanCurrentEmployment,
				paymentLabel: 'Postgraduate loan'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDSMPCurrentEmployment,
				paymentLabel: 'Statutory maternity pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDSAPCurrentEmployment,
				paymentLabel: 'Statutory adoption pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDSPPCurrentEmployment,
				paymentLabel: 'Statutory paternity pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDShPPCurrentEmployment,
				paymentLabel: 'Statutory shared parental pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDSPBPCurrentEmployment,
				paymentLabel: 'Statutory parental bereavement pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDSNCPCurrentEmployment,
				paymentLabel: 'Statutory neonatal care pay'
			},
			{
				isAdditionalPayment: true,
				paymentAmount: ytdObj.YTDPayrollBIK,
				paymentLabel: 'Benefit in kind'
			}
		];

		// Expats
		if (teamMemberObj.Company.IsExpatriate) {
			paymentsArr.push(
				{
					isAdditionalPayment: true,
					paymentAmount: ytdObj.YTDTaxExemptIncome,
					paymentLabel: 'Exempt income',
				},
				{
					isAdditionalPayment: true,
					paymentAmount: ytdObj.YTDTaxExemptGrossUp,
					paymentLabel: 'Exempt gross up',
				},
				{
					isAdditionalPayment: true,
					paymentAmount: ytdObj.YTDForeignTaxCredit,
					paymentLabel: 'Foreign tax credit',
				},
				{
					isAdditionalPayment: true,
					paymentAmount: ytdObj.YTDForeignTaxOffset,
					paymentLabel: 'Foreign tax offset',
				}
			);
		}

		return paymentsArr;
	}

	function init () {

		setPageState('loading');

		const getNationalInsuranceLetters = base.getNationalInsuranceLetters();
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
				getNationalInsuranceLetters,
				getTeamMemberInformation,
			])
			.then(([
				niCategoryLettersArr,
				teamMemberObj
			]) => {

				angular.extend($scope, {
					niCategoryLetters: niCategoryLettersArr,
					teamMember: decorateTeamMember(teamMemberObj)
				});

				if (!teamMemberObj.IsInSetupMode) {
					setPageState('confirm-edit');
				}
				else {
					setPageState('ready');
				}
			})
			.catch(function (error) {
				console.error(error);
				setPageState('error');
			});
	}

	function setActiveTab (newTab) {
		$scope.activeTab = newTab;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleIsConfirmed (teamMemberObj) {
		teamMemberObj.isConfirmed = !teamMemberObj.isConfirmed;
	}

	function togglePreRTIAdditionalPayments (teamMemberObj) {
		teamMemberObj.hidePreRTIAdditionalPayments = !teamMemberObj.hidePreRTIAdditionalPayments;
	}

	function toggleSecondNICLetterCode (teamMemberObj) {
		teamMemberObj.YTD.hasSecondNICLetterCode = !teamMemberObj.YTD.hasSecondNICLetterCode;
	}

	function updateTeamMemberYTD (teamMemberObj, form) {

		// Reset any empty values to 0
		utilities.setAnyPropertiesToZeroIfEmpty(teamMemberObj.YTD);

		// Check values
		teamMemberObj.YTD = checkPropertyValues(teamMemberObj.YTD);

		form.state = 'saving';

		teamData.updateTeamMemberYTDWithNICalculation(teamMemberObj.YTD, userId, agencyProfileId, teamMemberObj.YTD.hasYTDNILELs).then(function () {

			// Wizard: Go to next step
			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success(teamMemberObj.Personal.Forename + '\'s year to date details have been updated.');

			$scope.formOptions.closeForm();
			$scope.formOptions.forceCallback();

			form.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			form.state = '';
		});
	}

	init();

	angular.extend($scope, {
		INTERFACE_TYPES,
		TABS,

		activeTab: TABS.postRTIInclusion,
		startOfTaxYear: utilities.getTaxYearStartDate(),

		setActiveTab,
		setPageState,
		toggleIsConfirmed,
		toggleSecondNICLetterCode,
		togglePreRTIAdditionalPayments,
		updateTeamMemberYTD
	});
}])

.filter('paymentsToDatePreRTIShowAdditionalPayments', function () {

	return (paymentsArr, hidePreRTIAdditionalPayments) => {

		if (hidePreRTIAdditionalPayments) {
			return paymentsArr.filter(paymentObj => !paymentObj.isAdditionalPayment);
		}

		return paymentsArr;
	};
});


'use strict';

angular.module('paycircleApp')

.component('rtiSubmissionForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'rtiSubmissionFormCtrl',
	templateUrl: 'forms/employment/rti-submission/rti-submission.form.html'
})

.controller('rtiSubmissionFormCtrl', [
	'teamData',
	function (
		teamData
	) {

	const $ctrl = this;

	const FORM_STATES = {
		confirmExclude: 'confirm-exclude',
		confirmInclude: 'confirm-include',
		error: 'error',
		excludeSuccess: 'exclude-successs',
		includeSuccess: 'include-success'
	};

	function $onInit () {

		if ($ctrl.formOptions.isExcludedFromRti) {
			setFormState(FORM_STATES.confirmInclude);
		}
		else {
			setFormState(FORM_STATES.confirmExclude);
		}
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function updateTeamMemberIncludeInRTI ($ctrl, $form) {

		$form.state = 'saving';

		teamData.updateTeamMemberIncludeInRTI(
				$ctrl.formOptions.userId,
				$ctrl.formOptions.agencyProfileId,
				!$ctrl.formOptions.isExcludedFromRti
			)
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$form.state = 'saved';

				if ($ctrl.formOptions.isExcludedFromRti) {
					setFormState(FORM_STATES.includeSuccess);
				}
				else {
					setFormState(FORM_STATES.excludeSuccess);
				}

			})
			.catch(onError);
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,

		updateTeamMemberIncludeInRTI,

		FORM_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('payInformationForm', function () {

	return {
		controller: 'payInformationFormCtrl',
		templateUrl: 'forms/employment/payInformation/payInformationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('payInformationFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'base',
	'companyData',
	'config',
	'dateService',
	'growl',
	'journalsService',
	'payrollData',
	'policyService',
	'reportData',
	'salaryService',
	'regexService',
	'teamData',
	'userData',
	'utilities',
	'workPatternService',
	'BACKDATED_SALARY_CALCULATION_METHODS',
	'CALCULATION_METHODS',
	'COMPANY_STATES',
	'EMPLOYMENT_PAYMENT_TYPES',
	'EMPLOYMENT_RATE_TYPES',
	'EMPLOYMENT_TYPES',
	'NMW_CATEGORIES',
	'PAYMENT_TYPES',
	'POLICY_PAY_BASES',
	'SALARY_POLICY_FORM_FIELD_MODES',
	'POLICY_CATEGORIES',
	'REGEX',
	'SALARY_INTERVAL_TYPES',
	'SALARY_RATE_TYPES',
	'SALARY_TYPES',
	'WORK_PATTERN_BASIS',
	'WORK_PATTERN_GROUPS',
function (
	$filter,
	$q,
	$rootScope,
	$scope,
	$timeout,
	base,
	companyData,
	config,
	dateService,
	growl,
	journalsService,
	payrollData,
	policyService,
	reportData,
	salaryService,
	regexService,
	teamData,
	userData,
	utilities,
	workPatternService,
	BACKDATED_SALARY_CALCULATION_METHODS,
	CALCULATION_METHODS,
	COMPANY_STATES,
	EMPLOYMENT_PAYMENT_TYPES,
	EMPLOYMENT_RATE_TYPES,
	EMPLOYMENT_TYPES,
	NMW_CATEGORIES,
	PAYMENT_TYPES,
	POLICY_PAY_BASES,
	SALARY_POLICY_FORM_FIELD_MODES,
	POLICY_CATEGORIES,
	REGEX,
	SALARY_INTERVAL_TYPES,
	SALARY_RATE_TYPES,
	SALARY_TYPES,
	WORK_PATTERN_BASIS,
	WORK_PATTERN_GROUPS
) {

	const MAX_RATE_CHANGES = 0;
	const MAX_SALARY_CHANGES = 1;
	const MAX_WORK_PATTERNS = 2;

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;
	const userId = $scope.formOptions.userId;
	const userObj = $scope.formOptions.context;
	const companyObj = $scope.formOptions.company;

	const SALARY_FUTURE_CHANGE_TYPES = {
		policy: 'policy',
		rate: 'rate',
		salary: 'salary'
	};

	const SALARY_CHANGE_TYPES = {
		fixedValue: 'fixed-value',
		percentage: 'percentage'
	};

	// Used to create new posts for pay policy employment type
	let emptySalaryPolicy;
	// User to create salary future changes
	let emptyTeamMemberSalaryMinimum;

	// Add an allowance change. This is only applicable to pay policy paid team members (enforced in the template)
	function addAnnualAllowanceChange (annualAllowancePolicyObj) {

		// Create a copy of the allowance policy to use as a template for the update
		const allowancePolicyUpdate = angular.copy(annualAllowancePolicyObj);
		angular.extend(allowancePolicyUpdate, {
			EffectiveDateISO: '',
			HasBeenPaid: false,
			isSalaryPolicyUpdate: true,
			// Needed to determine correct API when saving. Brand new updates use OverrideSalaryPolicy.
			isNewUpdate: true
		});
		// Force selection of new band
		delete(allowancePolicyUpdate.Band);

		// Attach as SiblingPolicy on the allowance. This is how the platform structures allowance updates.
		annualAllowancePolicyObj.SiblingPolicy = allowancePolicyUpdate;
		// Attach to annual allowance policy. This is how the UI wants it. The UI will display this.
		annualAllowancePolicyObj.policyChange = allowancePolicyUpdate;
	}

	function addAnnualAllowancePolicy (teamMemberObj, salaryObj) {
		// Create new annual allowance salary policy and add it to team member salary -> AllowancePolicies collection
		const newAnnualAllowancePolicy = angular.copy(emptySalaryPolicy);

		angular.extend(newAnnualAllowancePolicy, {

			PolicyPayBasis: POLICY_PAY_BASES.annualAllowance,

			// Effective date == start date for new starters, otherwise it needs to be set by the user
			EffectiveDateISO: teamMemberObj.company.IsStarter ? teamMemberObj.company.StartDateISO : '',

			/* Copy policy CWTs to this allowance policy. If not set, the platform will stuff them with company settings
			   values, which we don't want to happen. */
			PolicyHoursPerWeek: salaryObj.annualSalaryPolicy.payPolicy.PolicyHoursPerWeek,
			PolicyWeeksPerYear: salaryObj.annualSalaryPolicy.payPolicy.PolicyWeeksPerYear,

			/* Mark as 'isNew', to indicate that on deletion it can be removed locally; the platform doesn't need to know
			   anything about this. */
			isNew: true
		});

		salaryObj.AllowancePolicies.push(newAnnualAllowancePolicy);
	}

	function addSalaryChange (vmObj, changeType, isRequired) {

		if (vmObj.teamMember.salary.SalaryFutureChanges.length === MAX_SALARY_CHANGES) {
			$rootScope.paycircleMessage('Maximum number of salary changes reached - ' + MAX_SALARY_CHANGES, 'warning');
			return;
		}

		/* Create a SalaryFutureChange object from the empty team member salary minimum object. This is called 'salaryFutureChangeObj' to make it clear
		   that it lives in the SalaryFutureChanges collection. It's not necessarily a future change, it could be a retrospective change. */
		let salaryFutureChangeObj = angular.copy(emptyTeamMemberSalaryMinimum);
		// Set is required. Salary change is required when changing employment type from net / hourly to pattern
		salaryFutureChangeObj.isRequired = angular.isDefined(isRequired) ? isRequired : false;
		// Mark as a salary change, since otherwise it's indistinguishable from a standard salary object
		salaryFutureChangeObj.isSalaryChange = true;

		let isBackdatedElementsEnabled = vmObj.backdatedSalaryDerivedElementsEnabled;
		salaryFutureChangeObj.BackdateSalaryDerivedElements = isBackdatedElementsEnabled;
		// If required, the effective date is from the start of the current period (and non-editable). Otherwise it remains empty.
		if (salaryFutureChangeObj.isRequired) {
			salaryFutureChangeObj.SalaryEffectiveDateISO = vmObj.currentPayPeriod.StartDateISO;
			/* If salary effective date is the same as the result from above then the change can only apply to the following day
			   (otherwise it's not a change - the salary just needs to be updated) */
			if (moment(vmObj.teamMember.salary.SalaryEffectiveDateISO).isSame(moment(salaryFutureChangeObj.salaryEffectiveDateISOMin), 'day')) {
				salaryFutureChangeObj.salaryEffectiveDateISOMin = moment(salaryFutureChangeObj.salaryEffectiveDateISOMin).add(1, 'day').format();
			}
		}

		// Default calculation method - though only applicable to backdated salary changes
		salaryFutureChangeObj.SalaryYearly = '';
		salaryFutureChangeObj.breakdown = null;

		if (changeType === SALARY_FUTURE_CHANGE_TYPES.rate) {
			salaryFutureChangeObj.SalaryDailyRatePartTime = '';
			salaryFutureChangeObj.SalaryHourlyRatePartTime = '';
		}
		if (changeType === SALARY_FUTURE_CHANGE_TYPES.policy) {
			// Create a new salary policy object for the pay change, and copy over what we already know
			const salaryObj = vmObj.teamMember.salary;
			const annualSalaryPolicyObj = salaryObj.annualSalaryPolicy;
			const salaryPolicyPayChangeObj = angular.copy(emptySalaryPolicy);
			angular.extend(salaryPolicyPayChangeObj, {
				ElementProRatingMethod: annualSalaryPolicyObj.ElementProRatingMethod,
				// Mark as a salary policy update
				isSalaryPolicyUpdate: true,
				IsPrimary: annualSalaryPolicyObj.IsPrimary,
				PeriodProRatingMethod: annualSalaryPolicyObj.PeriodProRatingMethod,
				PolicyID: annualSalaryPolicyObj.PolicyID,
				PolicyName: annualSalaryPolicyObj.PolicyName,
				PolicyPayBasis: annualSalaryPolicyObj.PolicyPayBasis,
				HoursPerWeek: annualSalaryPolicyObj.HoursPerWeek,
				WeeksPerYear: annualSalaryPolicyObj.WeeksPerYear,
				BackdateSalaryDerivedElements: isBackdatedElementsEnabled
			});
			salaryFutureChangeObj.Policy = salaryPolicyPayChangeObj;
		}

		angular.extend(salaryFutureChangeObj, {
			CalculationMethod: BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod,
			effectiveDateMinISO: vmObj.teamMember.salary.SalaryChangeEffectiveDateMinISO,
			isNewSalaryChange: true,
			isSalaryChangePercentageIncrease: true,
			salaryChangeType: SALARY_CHANGE_TYPES.fixedValue,
			salaryEffectiveDateISOMax: moment().add(1, 'year').format()
		});

		vmObj.teamMember.salary.SalaryFutureChanges.push(salaryFutureChangeObj);
	}

	function addSalaryRate (teamMemberSalaryArray, isAdditionalRate) {

		const newSalaryRateObj = getSalaryRateObject(false, isAdditionalRate);

		teamMemberSalaryArray.push(newSalaryRateObj);
	}

	function addWorkPatternChange (vmObj) {

		const newWorkPatternObj = getNewWorkPatternObj(vmObj);

		vmObj.teamMember.workPatterns.forEach((wp) => {
			wp.isEditing = false;
		});

		newWorkPatternObj.isEditing = true;

		vmObj.teamMember.workPatterns.push(newWorkPatternObj);

		setupCompanyWorkPatternsForEmploymentType(vmObj);

		onWorkPatternChange(vmObj);
	}

	function checkEmploymentTypeChangeWarning (vmObj) {

		// Flag to force salary entry, used when changing from hourly, net or policy to pattern
		let forceSalaryChange = false;

		// For clarity ...
		const employmentTypeFrom = vmObj.teamMember.salary.employmentTypeOriginal;
		const employmentTypeTo = vmObj.teamMember.salary.EmploymentType;

		let employmentTypeChangedWarningMessage ;
		if (employmentTypeFrom !== employmentTypeTo) {
			// Only changing between standard and non-standard allows for editable effective dates
			// All other changes will default to current period start date
			// The message should only be visible when there are policies available if changed to policy
			if ((![EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(employmentTypeFrom) ||
				 ![EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(employmentTypeTo)) &&
				(employmentTypeTo !== EMPLOYMENT_TYPES.payPolicy || vmObj.annualSalaryPoliciesCount !== 0)) {

				employmentTypeChangedWarningMessage = `Please note that if you change ${$scope.formOptions.context.Forename}'s
					employment type from '${vmObj.employmentTypes[employmentTypeFrom]}' to '${vmObj.employmentTypes[employmentTypeTo]}',
					it will be applied from the start of your current pay period (${vmObj.currentPayPeriod.PayPeriodDisplay})
					once you click 'Save'.`;

				if ([EMPLOYMENT_TYPES.standard, EMPLOYMENT_TYPES.nonStandard].includes(employmentTypeTo)) {
					// The team member is being changed from non-pattern to pattern. So a current annual salary must be entered.
					forceSalaryChange = true;
				}
			}
		}

		// Add a required salary change if required.
		vmObj.teamMember.salary.forceSalaryChange = forceSalaryChange;
		if (forceSalaryChange) {
			addSalaryChange(vmObj, SALARY_FUTURE_CHANGE_TYPES.salary, true);
		}
		else {
			// Remove the compulsory salary change
			vmObj.teamMember.salary.SalaryFutureChanges = vmObj.teamMember.salary.SalaryFutureChanges.filter(salaryFutureChange => {
				return !salaryFutureChange.isRequired;
			});
		}

		// Set message (may be undefined) and indication flag
		vmObj.teamMember.salary.employmentTypeChangedWarningMessage = employmentTypeChangedWarningMessage;
		vmObj.teamMember.salary.showEmploymentTypeChangedWarningMessage = angular.isDefined(employmentTypeChangedWarningMessage);
	}

	function checkNMWHourlyRate (rateObj, salaryObj) {

		rateObj.isBelowNMW = rateObj.SalaryRateValue > 0 && rateObj.SalaryRateValue < salaryObj.SalaryMinimumWageDetails.SalaryNationalMinimumWage;
	}

	function decorateSalary (salaryObj, payPeriodObj, teamMemberCompanyObj, businessCategoriesArr) {

		salaryObj.employmentTypeOriginal = angular.copy(salaryObj.EmploymentType);
		salaryObj.hasSalary = !userObj.IsInSetupMode && salaryObj.SalaryYearly > 0; // TODO: Review whether this is still necessary
		salaryObj.paymentTypeOriginal = angular.copy(salaryObj.PaymentType);

		// Store original effective date in case it's updated and then reset
		salaryObj.salaryEffectiveDateISOOriginal = angular.copy(salaryObj.SalaryEffectiveDateISO);
		salaryObj.salaryEffectiveDateISOMax = moment().add(1, 'year').format();
		salaryObj.salaryEffectiveDateISOMin = utilities.getLaterDateISO(teamMemberCompanyObj.StartDateISO, payPeriodObj.StartDateISO);

		// Store original salary to know when salary changes
		salaryObj.salaryYearlyOriginal = angular.copy(salaryObj.SalaryYearly);

		// Enforce entering a number if zero
		salaryObj.SalaryDailyRatePartTime = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryDailyRatePartTime);
		salaryObj.SalaryHours = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryHours);
		salaryObj.SalaryHourlyRate = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryHourlyRate);
		salaryObj.SalaryHourlyRatePartTime = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryHourlyRatePartTime);
		salaryObj.SalaryYearly = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryYearly);

		// Overtime Rates
		salaryObj.hasSalaryHourlyRateOvertime = salaryObj.SalaryHourlyRateOvertime > 0;
		salaryObj.hasSalaryDailyRateOvertime = salaryObj.SalaryDailyRateOvertime > 0;
		salaryObj.SalaryDailyRateOvertime = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryDailyRateOvertime);
		salaryObj.SalaryHourlyRateOvertime = utilities.setPropertyValueToEmptyIfZero(salaryObj.SalaryHourlyRateOvertime);

		/* Set pro rating method values at top level salary object. This is centralised so all policies can listen for changes to
		   the pro rating method (specifically Period pro rating) and update any backdated salary accordingly.
		   This will be applied to all policies on saving. Get it from the first policy, otherwise set to default */
		if (angular.isArray(salaryObj.Policies) && salaryObj.Policies.length !== 0) {
			salaryObj.periodProRatingMethod = salaryObj.Policies[0].PeriodProRatingMethod;
			salaryObj.elementProRatingMethod = salaryObj.Policies[0].ElementProRatingMethod;
		}
		else {
			salaryObj.periodProRatingMethod = -1;
			salaryObj.elementProRatingMethod = -1;
		}


		// Default StarterCalculationInclude to checked
		if (userObj.IsInSetupMode && !salaryObj.SalaryYearly) {
			salaryObj.StarterCalculationInclude = true;
		}

		// Salary Rates
		if (salaryObj.EmploymentType === EMPLOYMENT_TYPES.paidHourly) {

			// Check NMW for individiual salary rates
			if (salaryObj.SalaryRates.length > 0) {
				salaryObj.SalaryRates.forEach((salaryRateObj) => {

					checkNMWHourlyRate(salaryRateObj, salaryObj);

					setExistingBusinessCodes(salaryRateObj, businessCategoriesArr);
				});
			}

			reviewDefaultSalaryRate(salaryObj);
		}

		// Pay policy salary
		if (salaryObj.EmploymentType === EMPLOYMENT_TYPES.payPolicy) {

			// Grab the 'IsPrimary' annual salary policy. (There should be one).
			const annualSalaryPolicy = salaryObj.Policies.find(policy => policy.IsPrimary);

			salaryObj.AllowancePolicies.forEach(allowancePolicy => {
				if (angular.isDefined(allowancePolicy.SiblingPolicy) && allowancePolicy.SiblingPolicy !== null) {
					/* Attach the update to the allowance policy as a separate object for the UI. If it's 'deleted' later,
					   this attachment can be removed while the SiblingPolicy remains for the platform to handle deletion. */
					allowancePolicy.SiblingPolicy.isSalaryPolicyUpdate = true;
					allowancePolicy.policyChange = allowancePolicy.SiblingPolicy;
				}
			});

			// Attach to salary object for template
			salaryObj.annualSalaryPolicy = annualSalaryPolicy;
		}

		// Decorate future changes if there are any
		if (salaryObj.SalaryFutureChanges) {
			decorateSalaryFutureChanges(salaryObj, payPeriodObj, teamMemberCompanyObj);
		}

		return salaryObj;
	}

	function setExistingBusinessCodes (rate, businessCategoriesArr) {

		rate.overrideBusinessCategories = rate.UserAgencyProfileBusinessCodeOverrides.length > 0;

		if (rate.overrideBusinessCategories) {

			const businessCategories = angular.copy(businessCategoriesArr);

			rate.businessCategories = journalsService.decorateBusinessCategories(businessCategories, rate.UserAgencyProfileBusinessCodeOverrides);
		}
	}

	function deleteAnnualAllowancePolicy (salaryObj, annualAllowancePolicyObj) {

		/* If this is a brand-spanking new annual allowance that hasn't been saved yet, just get rid of it. Otherwise
		   flag it for deletion. */
		if (annualAllowancePolicyObj.isNew) {
			salaryObj.AllowancePolicies.splice(salaryObj.AllowancePolicies.indexOf(annualAllowancePolicyObj), 1);
		}
		else {
			annualAllowancePolicyObj.IsSalaryPolicyDelete = true;
		}
	}

	function deletePayPolicyChange (salaryObj) {

		salaryObj.SalaryFutureChanges = [];
	}

	function decorateSalaryFutureChanges (salaryObj, payPeriodObj, teamMemberCompanyObj) {

		// Keep an original copy of SalaryFutureChanges, used to restore when switching employment types
		salaryObj.salaryFutureChangesOriginal = angular.copy(salaryObj.SalaryFutureChanges);

		salaryObj.SalaryFutureChanges.forEach((salaryFutureChangeObj) => {

			salaryFutureChangeObj = decorateSalary(salaryFutureChangeObj, payPeriodObj, teamMemberCompanyObj);

			// Override the min date for saved future salary changes to the start of the current period i.e. don't allow a future change to become backdated
			salaryFutureChangeObj.effectiveDateMinISO = payPeriodObj.StartDateISO;

			// Set default calculation method and change type
			angular.extend(salaryFutureChangeObj, {
				CalculationMethod: BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod,
				isNewSalaryChange: false,
				isSalaryChange: true,
				salaryChangeType: SALARY_CHANGE_TYPES.fixedValue
			});

			// Mark annual salary policy change as an update if it exists. So the UI can present it as such.
			if (angular.isDefined(salaryFutureChangeObj.Policy) && salaryFutureChangeObj.Policy !== null) {
				salaryFutureChangeObj.Policy.isSalaryPolicyUpdate = true;
			}
		});
	}

	function deleteAnnualAllowanceChange (annualAllowancePolicyObj, annualAllowancePolicyChangeObj) {

		if (annualAllowancePolicyChangeObj.isNewUpdate) {
			/* Brand new, unsaved change — drop it locally. The platform doesn't know about it,
			   and leaving the SiblingPolicy attached would cause the parent allowance to be
			   deleted on save (the sibling inherits the parent's SalaryPolicyID from angular.copy). */
			delete(annualAllowancePolicyObj.SiblingPolicy);
			delete(annualAllowancePolicyObj.policyChange);
		}
		else {
			// Mark the allowance change for deletion
			annualAllowancePolicyChangeObj.IsSalaryPolicyDelete = true;
			/* Remove the UI reference. SiblingPolicy is kept with IsSalaryPolicyDelete = true
			   so the platform can process the deletion via the SiblingPolicy check in Salary.cs. */
			delete(annualAllowancePolicyObj.policyChange);
		}
	}

	/**
	 * Calculate and attach breakdown object to main salary object
	**/
	function getBreakdownForSalaryPromise (salaryObj) {

		return $q((resolve, reject) => {

			// Don't do this if there's no SalaryYearly set.
			if (!salaryObj.SalaryYearly) {
				resolve(null);
				return;
			}

			teamData.getSalaryForPeriodsCalculation(
				userId,
				agencyProfileId,
				salaryObj.SalaryYearly,
				SALARY_INTERVAL_TYPES.annually,
				salaryObj.ProRatingType
			)
			.then(salaryBreakdownObj => {
				resolve(salaryBreakdownObj);
			})
			.catch(reject);
		});
	}

	/**
	 * Calculate and attach breakdown object to main salary object
	**/
	function getBreakdownsForSalaryFutureChangesPromise (salaryObj) {

		return $q((resolve, reject) => {

			const getSalaryFutureChangesBreakdowns = [];

			// Not necessary if there's no salary future changes
			if (!salaryObj.SalaryFutureChanges) {
				resolve(getSalaryFutureChangesBreakdowns);
				return;
			}

			// Add calls to get breakdowns for the future salary changes. There should really only be one.
			salaryObj.SalaryFutureChanges.forEach(salaryFutureChangeObj => {

				// Add a placeholder if there's no SalaryYearly set to make sure arrays align
				if (!salaryFutureChangeObj.SalaryYearly) {
					getSalaryFutureChangesBreakdowns.push(null);
					return;
				}

				// Calculate breakdown for all valid future changes
				getSalaryFutureChangesBreakdowns.push(
					teamData.getSalaryForPeriodsCalculation(
						userId,
						agencyProfileId,
						salaryFutureChangeObj.SalaryYearly,
						SALARY_INTERVAL_TYPES.annually,
						salaryObj.ProRatingType
					)
				);
			});

			$q.all(getSalaryFutureChangesBreakdowns).then(salaryFutureChangesBreakdownsArr => {
				resolve(salaryFutureChangesBreakdownsArr);
			})
			.catch(reject);
		});
	}

	function decorateSalaryWithCalculatedBreakdowns (salaryObj) {

		return $q((resolve, reject) => {

			const getBreakdownForSalary = getBreakdownForSalaryPromise(salaryObj);
			const getBreakdownsForSalaryFutureChanges = getBreakdownsForSalaryFutureChangesPromise(salaryObj);

			$q.all([
				getBreakdownForSalary,
				getBreakdownsForSalaryFutureChanges
			]).then(([
				salaryBreakdownObj,
				salaryFutureChangesBreakdownsArr
			]) => {

				// Main salary obj
				salaryObj.breakdown = salaryBreakdownObj;

				// Salary future changes objects
				salaryObj.SalaryFutureChanges.forEach((salaryFutureChangeObj, index) => {

					salaryFutureChangeObj.breakdown = salaryFutureChangesBreakdownsArr[index];
				});

				resolve(salaryObj);
			})
			.catch(reject);
		});
	}

	function deleteSalaryChange (salaryChangesArr, index) {

		salaryChangesArr.splice(index, 1);
	}

	function deleteSalaryRate (rates, salaryRateId) {

		var index = utilities.getArrayItemIndexByPropertyName(rates, 'SalaryRateID', salaryRateId);

		// Null check to avoid truthy check as 0 = false
		if (index !== null) {
			rates.splice(index, 1);
		}
	}

	function deleteWorkPattern (vmObj, index) {

		vmObj.teamMember.workPatterns.splice(index, 1);

		onWorkPatternChange(vmObj);
	}

	function getEffectiveDateOptions (payPeriod) {

		var dates = [
			{
				description: 'Please select...',
				dateISO: '',
				month: undefined
			}
		];
		var date 	= moment(payPeriod.StartDateISO);
		var dateTo 	= moment(payPeriod.EndDateISO).add(2, 'months');

		while (date.isBefore(dateTo)) {

			var dateISO = date.format();

			dates.push({
				description: $filter('dateformat')(date),
				dateISO: dateISO.substring(0, dateISO.indexOf('+')),
				month: date.format('MMMM')
			});
			date = date.add(1, 'day');
		}

		return dates;
	}

	function getIsOnMaternityLeave (statutoryPaymentObj) {

		if (!statutoryPaymentObj.MaternityPay || statutoryPaymentObj.MaternityPay.length === 0) {
			return false;
		}

		let isOnMaternityLeave = false;

		statutoryPaymentObj.MaternityPay.forEach(function (maternityPayObj) {

			var matPayStartDateMoment = moment(maternityPayObj.StartDateISO);
			var matPayEndDateMoment = moment(maternityPayObj.EndDateISO);
			var now = moment();

			if (now.isBetween(matPayStartDateMoment, matPayEndDateMoment)) {
				isOnMaternityLeave = true;
			}
		});

		return isOnMaternityLeave;
	}

	function getIsOnSickLeave (statutoryPaymentObj) {

		if (!statutoryPaymentObj.SicknessPay || statutoryPaymentObj.SicknessPay.length === 0) {
			return false;
		}

		return statutoryPaymentObj.SicknessPay.some(sicknessPayObj =>
			!sicknessPayObj.HasEnded
		);
	}

	function getNewWorkPatternObj (vmObj) {

		let newWorkPatternObj = angular.copy(vmObj.teamMember.workPatterns[0]);

		// Add a day from the original work pattern (in case there is a work pattern for the current period & a work pattern change)
		let newEffectiveDateIsoMin;

		if (newWorkPatternObj.EffectiveDateISO === '') {
			newEffectiveDateIsoMin = vmObj.currentPayPeriod.StartDateISO;
		}

		else {
			newEffectiveDateIsoMin = utilities.getLaterDateISO(moment(newWorkPatternObj.EffectiveDateISO).add(1, 'day').format(), vmObj.currentPayPeriod.StartDateISO);
		}

		newWorkPatternObj.WorkPatternID = config.guidEmpty;
		newWorkPatternObj.EffectiveDateISO = '';
		newWorkPatternObj.effectiveDateISOMax = vmObj.currentPayPeriod.EndDateISO;
		newWorkPatternObj.effectiveDateISOMin = newEffectiveDateIsoMin;

		newWorkPatternObj.UpdatedDateISO = new Date().toISOString();

		return newWorkPatternObj;
	}

	function getSalaryRateObject (isDefaultRate, isAdditionalRate) {

		return {
			SalaryRateDefault: isDefaultRate !== undefined ? isDefaultRate : false,
			SalaryRateDescription: isAdditionalRate ? 'Additional rate' : 'Standard rate',
			SalaryRateHours: 0,
			SalaryRateID: utilities.guid(),
			RateType: EMPLOYMENT_RATE_TYPES.hourly,
			SalaryRateValue: null,
			UserAgencyProfileBusinessCodeOverrides: []
		};
	}

	function getWorkPatternEffectiveDateOptions (payPeriodStartDateIso, companyStartDateIso) {

		var dateFromIso = utilities.getLaterDateISO(companyStartDateIso, payPeriodStartDateIso);
		var dateToIso = moment(dateFromIso).add(2, 'months').format();

		return dateService.getDateRange(dateFromIso, dateToIso);
	}

	function hasSalaryChanged (vmObj) {

		var hasSalaryChanged = vmObj.teamMember.salary.SalaryYearly !== '' && vmObj.teamMember.salary.SalaryYearly !== vmObj.teamMember.salary.salaryYearlyOriginal;

		// Effective date only applicable if not in setup mode or in setup mode and not a new starter
		if (hasSalaryChanged) {

			// Salary Effective date
			if (!userObj.IsInSetupMode || (userObj.IsInSetupMode && !vmObj.teamMember.company.IsStarter)) {

				var salaryEffectiveDateM = moment(vmObj.teamMember.salary.SalaryEffectiveDateISO);
				var payPeriodStartDateM = moment(vmObj.currentPayPeriod.StartDateISO);

				// For readability
				var isEffectiveDateBeforePeriodStart = salaryEffectiveDateM.isBefore(payPeriodStartDateM, 'day');

				// If effective date is before start of period set to period start date
				if (isEffectiveDateBeforePeriodStart) {
					vmObj.teamMember.salary.SalaryEffectiveDateISO = vmObj.currentPayPeriod.StartDateISO;
				}
			}
		}

		// Reset the effective date to whatever it was when loaded
		else {
			vmObj.teamMember.salary.SalaryEffectiveDateISO = angular.copy(vmObj.teamMember.salary.salaryEffectiveDateISOOriginal);
		}

		return hasSalaryChanged;
	}

	function hideBackdatedSalaryCalculations (salaryObj) {

		salaryObj.showBackdatedSalaryCalculations = false;
	}

	function hideCalendar (vmObj) {

		vmObj.isCalendarVisible = false;
	}

	function init () {

		if (userObj.IsFurloughed) {
			setPageState('team-member-furloughed');
			return;
		}

		setPageState('loading');

		const INCLUDE_LEGACY_POLICIES = false;
		const INCLUDE_UPDATES = true;

		const getWorkPatternsForCompany = companyData.getWorkPatternsForAgency(agencyProfileId);
		const getTeamMemberCompanyDetails = teamData.getTeamMemberCompanyDetails(userId, agencyProfileId);
		const getTeamMemberSalary = payrollData.getTeamMemberSalary(agencyProfileId, userId, false);
		const getTeamMemberStatutoryPay = teamData.getTeamMemberStatutoryPay(userId, agencyProfileId);
		const getPolicies = policyService.getPoliciesForCategory(agencyProfileId, POLICY_CATEGORIES.pay, INCLUDE_LEGACY_POLICIES, INCLUDE_UPDATES);
		const getEmptySalaryPolicy = payrollData.getEmptySalaryPolicy();
		const getEmptyTeamMemberSalaryMinimum = payrollData.getEmptyTeamMemberSalaryMinimum();
		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
		const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();
		const getCompanyInformation = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);

		$q.all([
			getTeamMemberSalary,
			getTeamMemberCompanyDetails,
			getWorkPatternsForCompany,
			getTeamMemberStatutoryPay,
			getPolicies,
			getEmptySalaryPolicy,
			getEmptyTeamMemberSalaryMinimum,
			getBusinessCategoriesList,
			getEmptyUserAgencyProfileBusinessCode,
			getCompanyInformation
		])
		.then(([
			teamMemberSalaryObj,
			teamMemberCompanyObj,
			companyWorkPatternsArr,
			teamMemberStatutoryPayObj,
			payPoliciesArr,
			emptySalaryPolicyObj,
			emptyTeamMemberSalaryMinimumObj,
			businessCategoriesArr,
			emptyUserAgencyProfileBusinessCodeObj,
			companyInformation
		]) => {

			// The empty salary policy is used for pay policy salary type. Some of its attributes can be set here.
			angular.extend(emptySalaryPolicyObj, {
				SalaryID: teamMemberSalaryObj.SalaryID,
				SalaryPolicyID: config.guidEmpty,
				EffectiveDateISO: '',
				IneffectiveDateISO: ''
			});
			// Hold onto empty salary policy for pay policy employment type.
			emptySalaryPolicy = emptySalaryPolicyObj;

			// The empty team member salary minimum object is used for salary future changes. Some of its attributes can be set here.
			angular.extend(emptyTeamMemberSalaryMinimumObj, {
				SalaryID: teamMemberSalaryObj.SalaryID,
				// This isn't coming from the platform, but is needed to enable backdated salary calculations
				CanAddBackdatedSalary: teamMemberSalaryObj.CanAddBackdatedSalary
			});
			// Hang onto that for salary future changes
			emptyTeamMemberSalaryMinimum = emptyTeamMemberSalaryMinimumObj;

			// Separate annual salary and annual allowance policies
			const annualSalaryPoliciesCount = payPoliciesArr.reduce((count, payPolicy) => (payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary ? count + 1 : count), 0);
			const annualAllowancePoliciesCount = payPoliciesArr.reduce((count, payPolicy) => (payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance ? count + 1 : count), 0);

			const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(emptyUserAgencyProfileBusinessCodeObj, agencyProfileId, userId, config.guidEmpty);

			teamMemberSalaryObj = decorateSalary(teamMemberSalaryObj, currentPayPeriodObj, teamMemberCompanyObj, businessCategoriesArr);

			// Calculate breakdown(s)
			decorateSalaryWithCalculatedBreakdowns(teamMemberSalaryObj).then(teamMemberSalaryObj => {
				companyData.getWorkPatterns(agencyProfileId, userId).then(teamMemberWorkPatternsArr => {

					// Decorate
					companyWorkPatternsArr = workPatternService.decorateCompanyWorkPatterns(companyWorkPatternsArr);
					teamMemberWorkPatternsArr = workPatternService.decorateTeamMemberWorkPatterns(teamMemberWorkPatternsArr);

					let vmObj = {
						agencyProfileId,
						annualSalaryPoliciesCount,
						annualAllowancePoliciesCount,
						businessCategories: businessCategoriesArr,
						company: companyObj,
						companyWorkPatterns: companyWorkPatternsArr,
						companyWorkPatternsFiltered: [], // Set below
						currentPayPeriod: currentPayPeriodObj,
						effectiveDateOptions: getEffectiveDateOptions(currentPayPeriodObj),
						emptySalaryPolicy,
						backdatedSalaryDerivedElementsEnabled: companyInformation.BackdatedSalaryDerivedElementsEnabled, //..The company setting that controls whether derived elements can be included in backdated salary calculations
						isCalendarVisible: false,
						isNewStarterStartDateInPast: teamMemberCompanyObj.IsStarter && moment(teamMemberCompanyObj.StartDateISO).isBefore(currentPayPeriodObj.StartDateISO),
						isWorkPatternsApplicable: workPatternService.isWorkPatternsApplicable(currentPayPeriodObj),
						payPolicies: payPoliciesArr,
						teamMember: {
							personal: userObj,
							isOnMaternityLeave: getIsOnMaternityLeave(teamMemberStatutoryPayObj),
							isOnSickLeave: getIsOnSickLeave(teamMemberStatutoryPayObj),
							isTeamMemberSetupFieldsRequired: !(userObj.IsInSetupMode && teamMemberCompanyObj.IsLeaver && !userObj.IsSetupComplete), // Fields are only mandatory if team member is a non-leaver or a leaver not in setup mode
							salary: teamMemberSalaryObj,
							company: teamMemberCompanyObj,
							workPatterns: teamMemberWorkPatternsArr
						},
						workPatternEffectiveDates: getWorkPatternEffectiveDateOptions(currentPayPeriodObj.StartDateISO, teamMemberCompanyObj.StartDateISO), // TODO: Review what this uses
						emptyUserAgencyProfileBusinessCode
					};

					// Add employment types with descriptions to VM for messages and dropdown
					const employmentTypes = {
						[EMPLOYMENT_TYPES.standard]: vmObj.isWorkPatternsApplicable ? 'Standard pattern' : 'Salary',
						[EMPLOYMENT_TYPES.nonStandard]: 'Non-standard pattern',
						[EMPLOYMENT_TYPES.netPay]: 'Net pay',
						[EMPLOYMENT_TYPES.paidHourly]: 'Paid hourly'
					};
					// Pay policy option visible only when HR is active, and only for Paycircle users
					if (vmObj.company.IsHRActive) {
						employmentTypes[EMPLOYMENT_TYPES.payPolicy] = 'Pay policy';
					}
					vmObj.employmentTypes = employmentTypes;

					setupCompanyWorkPatternsForEmploymentType(vmObj);
					setupTeamMemberWorkPatterns(vmObj);

					// Calculate backpay
					if (vmObj.teamMember.salary.SalaryYearly) {
						updateBreakdownFromSalaryYearly(vmObj, vmObj.teamMember.salary);
					}

					// This will ensure that the change constitutes a backdated salary change
					reviewBackdatedSalaryCalculation(vmObj);

					$scope.vm = vmObj;

					setCalendarState($scope.vm, 'ready');
					setPageState('ready');
				})
				.catch(onError);
			})
			.catch(onError);
		})
		.catch(onError);
	}

	/**
	 *
	 * @param {Object} vmObj
	 * @param {Object} salaryObj
	 * @description {salaryObj} can be either the root salary object or the subset SalaryFutureChanges object
	 */
	function onAnnualSalaryChange (vmObj, salaryObj) {

		updateBreakdownFromSalaryYearly(vmObj, salaryObj);

		reviewBackdatedSalaryCalculation(vmObj);
	}

	function onBusinessCategoriesOverrideChange (rateObj) {

		const businessCategories = angular.copy($scope.vm.businessCategories);

		const rateBusinessCategories = rateObj.overrideBusinessCategories ? journalsService.decorateBusinessCategories(businessCategories, rateObj.UserAgencyProfileBusinessCodeOverrides) : [];

		rateObj.businessCategories = rateBusinessCategories;
	}

	function onDayRateCalculationUpdate (vmObj) {

		// Update root salary obj breakdown calculations
		updateBreakdownFromSalaryYearly(vmObj, vmObj.teamMember.salary);

		// Update future salary changes breakdown calculations
		if (vmObj.teamMember.salary.SalaryFutureChanges.length > 0) {

			vmObj.teamMember.salary.SalaryFutureChanges.forEach(futureSalaryChangeObj => {
				updateBreakdownFromSalaryYearly(vmObj, futureSalaryChangeObj);
			});
		}

		// Recalculate backpay to use new calculation method
		reviewBackdatedSalaryCalculation(vmObj);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onNiCalculationUpdate (vmObj, salaryObj) {

		updateBreakdownFromSalaryYearly(vmObj, salaryObj);

		reviewBackdatedSalaryCalculation(vmObj);
	}

	function onSalaryChangePercentageChange (vmObj, salaryChangeObj) {

		// Change multiplier to negative if it's a decrease
		const multiplier = salaryChangeObj.isSalaryChangePercentageIncrease ? salaryChangeObj.salaryChangePercentage : salaryChangeObj.salaryChangePercentage * -1;

		salaryChangeObj.SalaryYearly = vmObj.teamMember.salary.SalaryYearly + ((multiplier * vmObj.teamMember.salary.SalaryYearly) / 100);

		updateBreakdownFromSalaryYearly(vmObj, salaryChangeObj);

		reviewBackdatedSalaryCalculation(vmObj);
	}

	function onWorkPatternChange (vmObj) {

		// Round TotalHours to 2 decimal places to prevent display of excessive decimal places
		vmObj.teamMember.workPatterns.forEach(function (workPattern) {
			if (workPattern.TotalHours !== undefined && workPattern.TotalHours !== null && workPattern.TotalHours !== '') {
				const totalHours = parseFloat(workPattern.TotalHours);
				if (!isNaN(totalHours)) {
					workPattern.TotalHours = Math.round(totalHours * 100) / 100;
				}
			}
		});

		reloadCalendar(vmObj);
		setWorkPatternHasChanged(vmObj);
	}

	function openCalendar (vmObj) {

		vmObj.isCalendarVisible = true;
	}

	function reloadCalendar (vmObj) {

		// Only applies if open
		if (!vmObj.isCalendarVisible) {
			return;
		}

		setCalendarState(vmObj, 'loading');

		$timeout(() => {
			setCalendarState(vmObj, 'ready');
		}, 400);
	}

	function resetEmptySalaryValues (salaryObj) {

		salaryObj.SalaryYearly 				= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryYearly);
		salaryObj.SalaryHours 				= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryHours);
		salaryObj.SalaryHourlyRate 			= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryHourlyRate);
		salaryObj.SalaryDailyRatePartTime 	= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryDailyRatePartTime);
		salaryObj.SalaryHourlyRatePartTime 	= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryHourlyRatePartTime);
		salaryObj.SalaryDailyRateOvertime 	= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryDailyRateOvertime);
		salaryObj.SalaryHourlyRateOvertime 	= utilities.setPropertyValueToZeroIfEmpty(salaryObj.SalaryHourlyRateOvertime);

		// Reset rate values if not applicable
		if (salaryObj.EmploymentType === EMPLOYMENT_TYPES.standard || salaryObj.PaymentType === EMPLOYMENT_PAYMENT_TYPES.annualSalary) {
			salaryObj.SalaryDailyRatePartTime = 0;
			salaryObj.SalaryHourlyRatePartTime = 0;
			salaryObj.SalaryYearly = utilities.setPropertyValueToZeroIfNull(salaryObj.SalaryYearly);
		}

		return salaryObj;
	}

	/***
	 * @description This function checks whether backdated salary derived elements should be shown for a salary change. 
	 * This is based on the company setting to allow derived elements in backdated salary calculations, whether the salary change is backdated and the calculation method for the backdated salary.
	 * @param {Object} vmObj The view model object which contains the company setting for backdated salary derived elements.
	 * @param {Object} salaryFutureChange A TeamMemberSalaryMinimum object which may have had a backdated salary mapped to it.
	 * @see reviewBackdatedSalaryCalculation method for mapping of backdated salary value.
	 */
	function getShowBackdatedSalaryDerivedElements (vmObj, salaryFutureChange) {
		return vmObj.backdatedSalaryDerivedElementsEnabled && 
		salaryFutureChange.backdatedSalary && 
		salaryFutureChange.backdatedSalary.BackdatedElements &&
		salaryFutureChange.backdatedSalary.BackdatedElements.length && 
		salaryFutureChange.CalculationMethod === BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod;
	}

	function getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj) {
		return salaryService.getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj);
	}

	function reviewBackdatedSalaryCalculation (vmObj, closePreview) {

		closePreview = angular.isUndefined(closePreview) ? false : closePreview;

		// New starter with start date in the past (backpay applied to period run in previous software)
		if (vmObj.isNewStarterStartDateInPast && angular.isNumber(vmObj.teamMember.salary.SalaryYearly)) {

			vmObj.teamMember.salary.backdatedSalaryState = 'loading';

			payrollData.getTeamMemberBackdatedSalaryNewStarter(
				userId,
				agencyProfileId,
				vmObj.teamMember.salary.SalaryYearly,
				vmObj.teamMember.company.StartDateISO,
				vmObj.teamMember.salary.StarterCalculationMethod,
				vmObj.teamMember.salary.ProRatingType
			).then(backdatedSalaryAmount => {

				angular.extend(vmObj.teamMember.salary, {
					backdatedSalaryAmount,
					backdatedSalaryState: 'ready'
				});
			});
		}

		// No salary changes
		if (!vmObj.teamMember.salary.SalaryFutureChanges.length) {
			return;
		}

		vmObj.teamMember.salary.SalaryFutureChanges.forEach(salaryFutureChangeObj => {

			// Close preview window
			if (closePreview) {
				hideBackdatedSalaryCalculations(salaryFutureChangeObj);
			}

			let backdateElements = vmObj.backdatedSalaryDerivedElementsEnabled;
			if (angular.isDefined(salaryFutureChangeObj.BackdateSalaryDerivedElements)) {
				backdateElements = salaryFutureChangeObj.BackdateSalaryDerivedElements;
			}

			if (salaryFutureChangeObj.CanAddBackdatedSalary && salaryFutureChangeObj.SalaryEffectiveDateISO !== '' &&
				salaryFutureChangeObj.SalaryYearly !== '' && angular.isDefined(salaryFutureChangeObj.CalculationMethod)) {

				// Is the effective change date before the start of the current period? If so, this constitutes a backdated change
				salaryFutureChangeObj.isBackdatedSalary = moment(salaryFutureChangeObj.SalaryEffectiveDateISO).isBefore(vmObj.currentPayPeriod.StartDateISO);

				if (salaryFutureChangeObj.isBackdatedSalary) {
					salaryFutureChangeObj.backdatedSalaryState = 'loading';

					payrollData.getTeamMemberBackdatedSalary(
						userId,
						agencyProfileId,
						salaryFutureChangeObj.SalaryYearly,
						salaryFutureChangeObj.SalaryEffectiveDateISO,
						salaryFutureChangeObj.CalculationMethod,
						vmObj.teamMember.salary.ProRatingType, // Day rate calculation is set for all salaries and not a per salary change update
						backdateElements
					)
					.then(backdatedSalary => {
						salaryFutureChangeObj.backdatedSalary = backdatedSalary;
						salaryFutureChangeObj.backdatedSalaryState = 'ready';
					})
					.catch(error => {
						salaryFutureChangeObj.backdatedSalaryState = 'error';
						onError(error);
					});
				}
			}
		});
	}

	function reviewDefaultSalaryRate (salaryObj) {

		// If no salary rates defined, set one up
		if (salaryObj.SalaryRates.length === 0) {

			const IS_DEFAULT_RATE = true;
			const defaultSalaryRateObj = getSalaryRateObject(IS_DEFAULT_RATE);

			salaryObj.SalaryRates.push(angular.copy(defaultSalaryRateObj));
		}

		// Make sure a default salary rate is defined (otherwise nothing is displayed)
		else {

			const defaultSalaryRateObj = salaryObj.SalaryRates.find(salaryRateObj => salaryRateObj.SalaryRateDefault);

			// If no default salary rates defined, make first rate default
			if (angular.isUndefined(defaultSalaryRateObj)) {
				salaryObj.SalaryRates[0].SalaryRateDefault = true;
			}
		}
	}

	/**
	 *
	 * @param {Object} vmObj
	 */
	function selectEmploymentType (vmObj) {

		const RESET_WORK_PATTERNS = true;

		setupCompanyWorkPatternsForEmploymentType(vmObj);
		setupTeamMemberWorkPatterns(vmObj, RESET_WORK_PATTERNS);

		// Reset future changes
		vmObj.teamMember.salary.SalaryFutureChanges = [];
		vmObj.teamMember.salary.SalaryType = SALARY_TYPES.grossPay; // Reset salary type -> Required while migrating

		// Reset values
		switch (vmObj.teamMember.salary.EmploymentType) {

			// Paid Hourly
			case EMPLOYMENT_TYPES.paidHourly:

				// Reset salary
				vmObj.teamMember.salary.SalaryYearly = 0;
				updateBreakdownFromSalaryYearly(vmObj, vmObj.teamMember.salary);
				vmObj.teamMember.salary.SalaryYearly = '';

				// Add default hourly rate
				reviewDefaultSalaryRate(vmObj.teamMember.salary);

				break;

			// Net
			case EMPLOYMENT_TYPES.netPay:

				// Reset flag
				vmObj.teamMember.salary.IsPaidHourly = false;

				// Remove hourly rates
				vmObj.teamMember.salary.SalaryRates = [];

				// Change salary type
				vmObj.teamMember.salary.SalaryType = SALARY_TYPES.netPay;

				break;

			// Pay policy
			case EMPLOYMENT_TYPES.payPolicy:

				/* Existing policies should be re-established, in case the user is clicking aimlessly about the place.
				   If there aren't any, create a new annual salary policy for editing */
				if (vmObj.teamMember.salary.Policies.length === 0) {
					// No existing policies. Make a new one for editing.
					const newAnnualSalaryPolicy = angular.copy(emptySalaryPolicy);
					angular.extend(newAnnualSalaryPolicy, {
						PolicyPayBasis: POLICY_PAY_BASES.annualSalary,
						/* Set effective date on salary policy. If a new starter, this is their start date, if not a new starter,
						   this is the start date of the current period. Either way, it's not editable. (In the latter case, it
						   will also be invisible in the UI) */
						EffectiveDateISO: vmObj.teamMember.company.IsStarter ? vmObj.teamMember.company.StartDateISO : vmObj.currentPayPeriod.StartDateISO,
						FTEApply: true,
						// This must be the primary policy
						IsPrimary: true
					});

					vmObj.teamMember.salary.Policies.push(newAnnualSalaryPolicy);
					// Attach to separate reference for editing in template
					vmObj.teamMember.salary.annualSalaryPolicy = newAnnualSalaryPolicy;
					/* For pay policy-based salaries, set fixed options for backdated salary. Options for calculation type
					   ('How do you wish to include tax and NI?) and 'Include in next pay run' are fixed to
					   BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod and true respectively */
					vmObj.teamMember.company.IncludeBackpay = true;
					vmObj.teamMember.salary.StarterCalculationMethod = BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod;

					// Default day rate calculation methods to 'Not set' - i.e. to use company settings
					angular.extend(vmObj.teamMember.salary, {
						periodProRatingMethod: -1,
						elementProRatingMethod: -1
					});
				}

				// Change salary type
				vmObj.teamMember.salary.SalaryType = SALARY_TYPES.payPolicy;

				/* Wondering where the 'break;' is? Lack of a 'break' here is intentional. Drop through to reset hourly stuff.
				   Leave the following comment to shut up jshint.*/
			/* falls through */
			default:

				// Reset flag
				vmObj.teamMember.salary.IsPaidHourly = false;

				// Remove hourly rates
				vmObj.teamMember.salary.SalaryRates = [];

				break;
		}

		// Work Pattern Updates
		switch (vmObj.teamMember.salary.EmploymentType) {
			case EMPLOYMENT_TYPES.standard:
			case EMPLOYMENT_TYPES.nonStandard:
				setWorkPatternHasChanged(vmObj);
				break;
		}

		// Calendar
		hideCalendar(vmObj);

		// Decide on employment change warning
		checkEmploymentTypeChangeWarning(vmObj);
	}

	function selectPaymentType (vmObj) {

		// Reset future changes if payment type has been changed back to original
		if (vmObj.teamMember.salary.PaymentType === vmObj.teamMember.paymentTypeOriginal) {
			vmObj.teamMember.salary.SalaryFutureChanges = angular.copy(vmObj.teamMember.salary.salaryFutureChangesOriginal);
		}
		else {
			vmObj.teamMember.salary.SalaryFutureChanges = [];
		}

		// Re-add required salary change if required.
		if (vmObj.teamMember.salary.forceSalaryChange && vmObj.teamMember.salary.PaymentType === EMPLOYMENT_PAYMENT_TYPES.annualSalary) {
			addSalaryChange(vmObj, SALARY_FUTURE_CHANGE_TYPES.salary, true);
		}
	}

	function selectWorkPattern (vmObj, workPatternObj) {

		angular.extend(workPatternObj, workPatternObj.companyWorkPattern);

		setWorkPatternHasChanged(vmObj);
	}

	function setCalendarState (vmObj, calendarState) {

		vmObj.calendarState = calendarState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setupCompanyWorkPatternsForEmploymentType (vmObj) {

		if (!vmObj.companyWorkPatterns.length) {
			return vmObj.companyWorkPatterns;
		}

		let companyWorkPatternsArrFiltered = workPatternService.getCompanyWorkPatternsForEmploymentType(vmObj.companyWorkPatterns, vmObj.teamMember.salary.EmploymentType);

		vmObj.companyWorkPatternsFiltered = companyWorkPatternsArrFiltered;
	}

	function setupTeamMemberWorkPatterns (vmObj, RESET_WORK_PATTERNS) {

		RESET_WORK_PATTERNS = angular.isDefined(RESET_WORK_PATTERNS) ? RESET_WORK_PATTERNS : false;

		// Salary type has changed so remove any Work Patterns that aren't of the same employment type
		if (RESET_WORK_PATTERNS) {

			vmObj.teamMember.workPatterns = [];
		}

		// If no work patterns are defined take first company work pattern for same Employment Type (Group)
		if (vmObj.teamMember.workPatterns.length === 0) {

			// Employment type specific work patterns are required
			if (vmObj.companyWorkPatternsFiltered.length === 0) {
				const employmentTypeDescription = $filter('employmentTypeDescription')(vmObj.teamMember.salary.EmploymentType);
				$rootScope.paycircleMessage(`No work patterns available for employment type: ${employmentTypeDescription}`);
				return;
			}

			vmObj.teamMember.workPatterns.push(angular.copy(vmObj.companyWorkPatternsFiltered[0]));
		}

		// Set up work patterns
		vmObj.teamMember.workPatterns.forEach((teamMemberWorkPatternObj, index) => {

			angular.extend(teamMemberWorkPatternObj, {
				companyWorkPattern: null,
				effectiveDateISOMax: angular.copy(vmObj.currentPayPeriod.EndDateISO),
				effectiveDateISOMin: angular.copy(vmObj.currentPayPeriod.StartDateISO),
				isEditing: vmObj.teamMember.personal.IsInSetupMode && (vmObj.teamMember.workPatterns.length === index + 1)
			});

			// Attach company work pattern to team work pattern for company work pattern selection
			vmObj.companyWorkPatterns.forEach(companyWorkPatternObj => {

				if (teamMemberWorkPatternObj.WorkPatternID === companyWorkPatternObj.WorkPatternID) {
					teamMemberWorkPatternObj.companyWorkPattern = angular.copy(companyWorkPatternObj);
				}
			});

			// Set to first company work pattern
			if (!teamMemberWorkPatternObj.companyWorkPattern) {
				teamMemberWorkPatternObj.companyWorkPattern = angular.copy(vmObj.companyWorkPatterns[0]);
			}
		});
	}

	function setWorkPatternHasChanged (vmObj) {

		vmObj.teamMember.hasWorkPatternsChanged = true;
	}

	function showBackdatedSalaryCalculations (salaryObj) {

		salaryObj.showBackdatedSalaryCalculations = true;
	}

	function showIsCalendarVisible (vmObj) {

		if (vmObj.isCalendarVisible) {
			vmObj.isCalendarVisible = false;

			$timeout(() => {
				vmObj.isCalendarVisible = true;
			}, 300);

			return;
		}

		vmObj.isCalendarVisible = true;
	}

	function toggleConfirmDeleteAdditionalHourlyRate (hourlyRateObj) {
		hourlyRateObj.confirmDelete = !hourlyRateObj.confirmDelete;
	}

	function toggleConfirmDeleteAnnualAllowancePolicy (annualAllowancePolicyObj) {
		annualAllowancePolicyObj.confirmDelete = !annualAllowancePolicyObj.confirmDelete;
	}

	function toggleHasOvertimeRateHourly (vmObj) {

		vmObj.teamMember.salary.hasSalaryHourlyRateOvertime = !vmObj.teamMember.salary.hasSalaryHourlyRateOvertime;

		if (!vmObj.teamMember.salary.hasSalaryHourlyRateOvertime) {
			vmObj.teamMember.salary.SalaryHourlyRateOvertime = 0;
		}
		else {
			vmObj.teamMember.salary.SalaryHourlyRateOvertime = utilities.setPropertyValueToEmptyIfZero(vmObj.teamMember.salary.SalaryHourlyRateOvertime);
		}
	}

	function toggleHasOvertimeRateDaily (vmObj) {

		vmObj.teamMember.salary.hasSalaryDailyRateOvertime = !vmObj.teamMember.salary.hasSalaryDailyRateOvertime;

		if (!vmObj.teamMember.salary.hasSalaryDailyRateOvertime) {
			vmObj.teamMember.salary.SalaryDailyRateOvertime = 0;
		}
		else {
			vmObj.teamMember.salary.SalaryDailyRateOvertime = utilities.setPropertyValueToEmptyIfZero(vmObj.teamMember.salary.SalaryDailyRateOvertime);
		}
	}

	function toggleIsCalendarVisible (vmObj) {

		vmObj.isCalendarVisible = !vmObj.isCalendarVisible;
	}

	function toggleIsSalaryBreakdownVisible (salaryObj) {

		salaryObj.isSalaryBreakdownVisible = !salaryObj.isSalaryBreakdownVisible;
	}

	function togglePatternBasis (vmObj, workPatternObj) {

		workPatternObj.Basis = workPatternService.togglePatternBasis(workPatternObj.Basis);

		// Weekly basis work patterns
		if (workPatternObj.Basis === WORK_PATTERN_BASIS.weekly) {

			// Make sure weekly basis has 7 days
			if (workPatternObj.Days.length < 7) {

				workPatternObj.Days = workPatternService.generateDaysForWeeks(workPatternObj.Days);
				workPatternObj.weeks = workPatternService.convertDaysToWeeks(workPatternObj.Days);
			}

			// Update days to match weekly values -> Required for calendar preview to match values
			workPatternObj = workPatternService.updateDays(workPatternObj);
		}

		onWorkPatternChange(vmObj);
	}

	function toggleRateType (salaryObj) {

		salaryObj.RateType = salaryObj.RateType === EMPLOYMENT_RATE_TYPES.daily ? EMPLOYMENT_RATE_TYPES.hourly : EMPLOYMENT_RATE_TYPES.daily;

		switch (salaryObj.RateType) {
			case EMPLOYMENT_RATE_TYPES.daily:
				salaryObj.SalaryDailyRatePartTime = salaryObj.SalaryHourlyRatePartTime;
				salaryObj.SalaryHourlyRatePartTime = 0;
				break;
			case EMPLOYMENT_RATE_TYPES.hourly:
				salaryObj.SalaryHourlyRatePartTime = salaryObj.SalaryDailyRatePartTime;
				salaryObj.SalaryDailyRatePartTime = 0;
				break;
		}
	}

	function toggleSalaryChangePercentageMultiplier (vmObj, salaryChangeObj) {

		salaryChangeObj.isSalaryChangePercentageIncrease = !salaryChangeObj.isSalaryChangePercentageIncrease;

		onSalaryChangePercentageChange(vmObj, salaryChangeObj);
	}

	function toggleShowBackdatedCalculations (salaryObj) {

		salaryObj.showBackdatedSalaryCalculations = !salaryObj.showBackdatedSalaryCalculations;
	}

	function toggleWorkPatternIsCustom (vmObj, workPatternIndex) {

		let workPatternObj = vmObj.teamMember.workPatterns[workPatternIndex];

		if (workPatternObj.IsCustomWorkPattern) {
			workPatternObj.Description = 'Custom';
			workPatternObj.WorkPatternID = config.guidEmpty;
		}
		else {
			let commonEffectiveDate = workPatternObj.EffectiveDateISO;
			angular.extend(workPatternObj, workPatternObj, vmObj.companyWorkPatternsFiltered[0]);
			workPatternObj.EffectiveDateISO = commonEffectiveDate;
		}

		onWorkPatternChange(vmObj);
	}

	function toggleWorkPatternIsEditing (vmObj, workPatternIndex) {

		vmObj.teamMember.workPatterns[workPatternIndex].UpdatedDateISO = new Date().toISOString();
		vmObj.teamMember.workPatterns[workPatternIndex].isEditing = !vmObj.teamMember.workPatterns[workPatternIndex].isEditing;
	}

	function isSubmitButtonDisabled (vmObj) {

		    // Check if the EmploymentType is payPolicy and there are no annualSalaryPolicies
			const isPayPolicyWithoutAnnualSalaryPolicies = vmObj.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy && vmObj.annualSalaryPoliciesCount === 0;

			// Check if any SalaryRate has overrideBusinessCategories set to true
			const hasOverrideBusinessCategories = vmObj.teamMember.salary.SalaryRates.some(rate => rate.overrideBusinessCategories === true);

			// Check if there are no Business Codes set
			const allBusinessCategoriesHaveNoBusinessCodes = vmObj.businessCategories.every(businessCategory => businessCategory.BusinessCodes.length === 0);

			// Check based on the toggle if at least 1 business code has been set
			const allBusinessCodesNotSet = vmObj.teamMember.salary.SalaryRates
				.filter(rate => rate.overrideBusinessCategories === true && rate.businessCategories)
				.some(rate => rate.businessCategories.every(businessCategory => !businessCategory.selectedBusinessCode));

			// Return true if either isPayPolicyWithoutAnnualSalaryPolicies is true, or both hasOverrideBusinessCategories and (allBusinessCategoriesHaveNoBusinessCodes or allBusinessCodesNotSet) are true
			return isPayPolicyWithoutAnnualSalaryPolicies || (hasOverrideBusinessCategories && (allBusinessCategoriesHaveNoBusinessCodes || allBusinessCodesNotSet));
	}

	function updateBreakdownFromSalaryYearly (vmObj, salaryObj) {

		const salaryYearly = salaryObj.SalaryYearly;

		// Can only run if SalaryYearly is available. It might be an empty string ...
		if (!salaryYearly) {
			// Hide the backdated salary as it isn't currently applicable - the form is probably invalid
			salaryObj.backdatedSalaryAmount = 0;
			return;
		}

		teamData.getSalaryForPeriodsCalculation(
			userId,
			agencyProfileId,
			salaryYearly,
			SALARY_INTERVAL_TYPES.annually,
			vmObj.teamMember.salary.ProRatingType
		).then(calculationObj => {

			angular.extend(salaryObj, {
				breakdown: calculationObj
			});
		})
		.catch(onError);
	}

	function updateBreakdownFromValue (salaryObj, salaryPropertyName, salaryIntervalType) {

		teamData.getSalaryForPeriodsCalculation(
			userId,
			agencyProfileId,
			salaryObj.breakdown[salaryPropertyName],
			salaryIntervalType,
			salaryObj.ProRatingType
		)
		.then((calculationObj) => {
			salaryObj.breakdown = calculationObj;
			updateSalaryYearlyFromBreakdown(salaryObj);
		})
		.catch(onError);
	}

	function updateSalaryYearlyFromBreakdown (salaryObj) {

		salaryObj.SalaryYearly = salaryObj.breakdown.Yearly;

		return salaryObj;
	}

	function getBusinessCodes (rate, emptyUserAgencyProfileBusinessCode) {

		rate.UserAgencyProfileBusinessCodeOverrides = journalsService.getOnlySelectedBusinessCodesFromBusinessCategories(rate.businessCategories, emptyUserAgencyProfileBusinessCode);

		return rate;
	}

	function updateTeamMemberSalary (vmObj, form) {

		var agencyPayPeriodId; // Undefined so it defaults to current period

		form.state = 'saving';

		// Reset values to 0 if empty
		vmObj.teamMember.salary = resetEmptySalaryValues(vmObj.teamMember.salary);
		vmObj.teamMember.salary.SalaryFutureChanges.filter(resetEmptySalaryValues);

		// Set business codes
		vmObj.teamMember.salary.SalaryRates.map(rate => getBusinessCodes(rate, vmObj.emptyUserAgencyProfileBusinessCode));

		// If pay policy payment type, copy pro-rating values across all policies
		if (vmObj.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy) {
			const proRatingMethods = {
				PeriodProRatingMethod: vmObj.teamMember.salary.periodProRatingMethod,
				ElementProRatingMethod: vmObj.teamMember.salary.elementProRatingMethod
			};
			// There should be a single policy in here these days, but the model doesn't prohibit multiple ...
			vmObj.teamMember.salary.Policies.forEach(salaryPolicy => {
				angular.extend(salaryPolicy, proRatingMethods);
			});
			// Do the same for annual allowance policies and their pending updates (SiblingPolicy)
			vmObj.teamMember.salary.AllowancePolicies.forEach(allowancePolicy => {
				angular.extend(allowancePolicy, proRatingMethods);
				if (angular.isDefined(allowancePolicy.SiblingPolicy) && allowancePolicy.SiblingPolicy !== null) {
					angular.extend(allowancePolicy.SiblingPolicy, proRatingMethods);
				}
			});
		}

		let updateWorkPatterns = null;
		if (vmObj.companyWorkPatterns.length && (vmObj.teamMember.hasWorkPatternsChanged || userObj.IsInSetupMode)) {
			updateWorkPatterns = companyData.updateWorkPatterns(agencyProfileId, vmObj.teamMember.workPatterns, userId);
		}

		// Work patterns must be updated before salary so salary calculations are correct
		// $q used so that null can be passed if Work Patterns are not changed
		$q.all([updateWorkPatterns]).then(() => {
			// Perform the following API calls
			$q.all([
				teamData.updateTeamMemberSalary(
					vmObj.teamMember.salary,
					userId,
					agencyProfileId,
					agencyPayPeriodId,
					vmObj.teamMember.company.IncludeBackpay
				),
				teamData.updateTeamMemberCompany(
					vmObj.teamMember.company,
					userId,
					agencyProfileId
				)
			])
			.then(() => {
				// Complete task
				$rootScope.setDemoTaskAsComplete('editSalary', vmObj.teamMember.personal.Forename);

				// Wizard: Go to next step
				if ($scope.formOptions.isWizard) {
					$scope.formOptions.onSuccess();
					return;
				}

				growl.success(vmObj.teamMember.personal.Forename + '\'s pay information has been updated.');

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();

				form.state = 'saved';
			})
			.catch(onError);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		BACKDATED_SALARY_CALCULATION_METHODS,
		CALCULATION_METHODS,
		COMPANY_STATES,
		EMPLOYMENT_TYPES,
		EMPLOYMENT_PAYMENT_TYPES,
		EMPLOYMENT_RATE_TYPES,
		MAX_RATE_CHANGES,
		MAX_SALARY_CHANGES,
		MAX_WORK_PATTERNS,
		NMW_CATEGORIES,
		POLICY_PAY_BASES,
		SALARY_POLICY_FORM_FIELD_MODES,
		PAYMENT_TYPES,
		REGEX,
		SALARY_FUTURE_CHANGE_TYPES,
		SALARY_CHANGE_TYPES,
		SALARY_RATE_TYPES,
		WORK_PATTERN_BASIS,
		WORK_PATTERN_GROUPS,

		config,
		regexService,

		hourOptions: {
			minHours: 1,
			maxHours: 168,
			stepCount: 0.25
		},
		weekOptions: {
			minWeeks: 1,
			maxWeeks: 52,
			stepCount: 1
		},

		addAnnualAllowanceChange,
		addAnnualAllowancePolicy,
		addSalaryChange,
		addSalaryRate,
		addWorkPatternChange,
		checkNMWHourlyRate,
		deleteAnnualAllowancePolicy,
		deleteAnnualAllowanceChange,
		deletePayPolicyChange,
		deleteSalaryChange,
		deleteSalaryRate,
		deleteWorkPattern,
		getBackdatedSalaryDerivedElementValueForDisplay,
		getShowBackdatedSalaryDerivedElements,
		hasSalaryChanged, // TODO: Test to make sure this still works
		isSubmitButtonDisabled,
		onAnnualSalaryChange,
		onBusinessCategoriesOverrideChange,
		onDayRateCalculationUpdate,
		onNiCalculationUpdate,
		onSalaryChangePercentageChange,
		onWorkPatternChange,
		openCalendar,
		reviewBackdatedSalaryCalculation,
		selectEmploymentType,
		selectPaymentType,
		selectWorkPattern,
		showBackdatedSalaryCalculations,
		showIsCalendarVisible,
		toggleConfirmDeleteAdditionalHourlyRate,
		toggleConfirmDeleteAnnualAllowancePolicy,
		toggleHasOvertimeRateDaily,
		toggleHasOvertimeRateHourly,
		toggleIsCalendarVisible,
		toggleIsSalaryBreakdownVisible,
		togglePatternBasis,
		toggleRateType,
		toggleSalaryChangePercentageMultiplier,
		toggleShowBackdatedCalculations,
		toggleWorkPatternIsCustom,
		toggleWorkPatternIsEditing,
		updateBreakdownFromValue,
		updateBreakdownFromSalaryYearly,
		updateTeamMemberSalary,
		onError
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('starterInformationForm', function () {

	return {
		controller: 'starterInformationCtrl',
		templateUrl: 'forms/employment/starter-information/starter-information.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('starterInformationCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'base',
	'growl',
	'payrollData',
	'taxUpdatesService',
	'teamData',
	'utilities',
	'NI_CATEGORY_LETTER',
	'SECONDED_STATES',
	'STUDENT_LOAN_PLANS',
	function (
		$q,
		$rootScope,
		$scope,
		base,
		growl,
		payrollData,
		taxUpdatesService,
		teamData,
		utilities,
		NI_CATEGORY_LETTER,
		SECONDED_STATES,
		STUDENT_LOAN_PLANS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	// Flag to indicate that tax code has been overridden; so it can be defaulted first time
	let taxCodeOveridden = false;

	function decorateTeamMember (teamMemberObj, currentPayPeriodObj) {

		angular.extend(teamMemberObj.Tax, {

			// If not in set up mode P45 details are being added retrospectively so the 'Has P45?' question isn't required
			IsP45Available: teamMemberObj.IsInSetupMode ? teamMemberObj.Tax.IsP45Available : true,

			// Pass period IsYTDInformationRequired to team member
			IsYTDInformationRequired: currentPayPeriodObj.IsYTDInformationRequired
		});

		// Student Loan
		teamMemberObj.Tax = setupStudentLoan(teamMemberObj.Tax, teamMemberObj);

		// If company administrator mark team member as a starter
		if ($rootScope.userHasRole('companyadministrator')) {
			// Assumed new starter
			teamMemberObj.Company.IsStarter = true;
		}

		// Add validation to P45 leave date
		teamMemberObj.YTD.YTDLeaveDatePreviousEmploymentISOMin = utilities.getTaxYearStartDateForDate(currentPayPeriodObj.PayDateISO, true);

		// Fields are only mandatory if team member is a non-leaver or a leaver not in setup mode
		teamMemberObj.isTeamMemberSetupFieldsRequired = !(teamMemberObj.IsInSetupMode && teamMemberObj.Company.IsLeaver && !teamMemberObj.TeamMemberSetupComplete);

		// Clear SecondedState if none is set to force user to update setting before saving
		if (teamMemberObj.Company.IsSeconded && teamMemberObj.Tax.SecondedState === SECONDED_STATES.none) {
			teamMemberObj.Tax.SecondedState = '';
		}

		return teamMemberObj;
	}

	function init () {

		setPageState('loading');

		const getNationalInsuranceLetters = base.getNationalInsuranceLetters();
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([
			getNationalInsuranceLetters,
			getTeamMemberInformation,
			getPayPeriodCurrent
		]).then(([
			niCategoryLettersArr,
			teamMemberObj,
			currentPayPeriodObj
		]) => {

			angular.extend($scope, {
				niCategoryLetters: niCategoryLettersArr,
				teamMember: decorateTeamMember(teamMemberObj, currentPayPeriodObj)
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onFormSave () {

		// Wizard: Go to next step
		if ($scope.formOptions.isWizard) {
			$scope.formOptions.onSuccess();
			return;
		}

		// Force callback
		$scope.formOptions.forceCallback();

		// Show success message
		growl.success($scope.formOptions.context.Forename + '\'s starter information has been updated.');

		// Close form
		$scope.formOptions.closeForm();
	}

	function onStarterDeclarationChange (taxObj) {

		// Turn off tax / NI override if starter declaration isn't 'D'
		if (taxObj.StarterDeclaration !== 'D') {
			taxObj.IsStarterDefaultOverridden = false;
		}

		// 'D' Declaration only
		else {

			// Default the tax code if it hasn't already been set
			if (!taxCodeOveridden) {
				taxObj.TaxCode = '0T';
				taxCodeOveridden = true;
			}

			// Make sure W1M1 is true by default if 'D' is selected and not overridden
			if (!taxObj.IsStarterDefaultOverridden) {
				taxObj.TaxCodeM1W1 = true;
			}
		}
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	function setTeamMemberPropertiesBeforeSave (teamMemberObj) {

		// Reset starter declaration to empty if P45 is available
		if (teamMemberObj.Tax.IsP45Available) {
			teamMemberObj.Tax.StarterDeclaration = '';
		}

		// Unset all student loan flags
		teamMemberObj.Tax.StudentLoanPlan1 = false;
		teamMemberObj.Tax.StudentLoanPlan2 = false;
		teamMemberObj.Tax.StudentLoanPlan4 = false;
		teamMemberObj.Tax.StudentLoanPlan5 = false;

		// If student loan selected, turn them on according to selected option
		if (teamMemberObj.Tax.StudentLoan) {
			// Switch on according to selected option
			switch (teamMemberObj.Tax.studentLoanPlanOption) {
				case STUDENT_LOAN_PLANS.plan1and2: {
					teamMemberObj.Tax.StudentLoanPlan1 = true;
					teamMemberObj.Tax.StudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan1: {
					teamMemberObj.Tax.StudentLoanPlan1 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan2: {
					teamMemberObj.Tax.StudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan4: {
					teamMemberObj.Tax.StudentLoanPlan4 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan5: {
					teamMemberObj.Tax.StudentLoanPlan5 = true;
					break;
				}
			}
		}

		// Set start submitted flag if new starter or not
		teamMemberObj.Tax.IsStartSubmitted = !teamMemberObj.Company.IsStarter;
	}

	function setupStudentLoan (taxObj, teamMemberObj) {

		angular.extend(taxObj, {
			// Set visibility flags for student loan plans and postgraduate loan
			canShowStudentLoan: taxUpdatesService.canShowStudentLoan(teamMemberObj, taxObj),
			canShowStudentLoanPlan1: taxUpdatesService.canShowStudentLoanPlan1(teamMemberObj, taxObj),
			canShowStudentLoanPlan2: taxUpdatesService.canShowStudentLoanPlan2(teamMemberObj, taxObj),
			canShowStudentLoanPlan1and2: taxUpdatesService.canShowStudentLoanPlan1and2(teamMemberObj, taxObj),
			canShowStudentLoanPlan4: taxUpdatesService.canShowStudentLoanPlan4(teamMemberObj, taxObj),
			canShowStudentLoanPlan5: taxUpdatesService.canShowStudentLoanPlan5(teamMemberObj, taxObj),
			canShowPostgraduateLoan: taxUpdatesService.canShowPostgraduateLoan(teamMemberObj, taxObj),
			// Get plan option for display
			studentLoanPlanOption: taxUpdatesService.getStudentLoanPlanOption(taxObj.StudentLoanPlan1, taxObj.StudentLoanPlan2, taxObj.StudentLoanPlan4, taxObj.StudentLoanPlan5)
		});

		return taxObj;
	}

	function updateTeamMemberTax  (teamMemberObj, form) {

		form.state = 'saving';

		setTeamMemberPropertiesBeforeSave(teamMemberObj);

		teamData.updateTeamMemberTax(teamMemberObj.Tax, userId, agencyProfileId)
			.then(() => {

				if (teamMemberObj.Tax.IsP45Available && teamMemberObj.Company.IsStarter) {
					teamData.updateTeamMemberYTD(teamMemberObj.YTD, userId, agencyProfileId)
						.then(onFormSave)
						.catch(onError);
					return;
				}

				onFormSave();
			})
			.catch(onError);
	}

	init();

	angular.extend($scope, {
		NI_CATEGORY_LETTER,
		SECONDED_STATES,
		STUDENT_LOAN_PLANS,
		taxUpdatesService,
		onStarterDeclarationChange,
		updateTeamMemberTax
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('taxStatusForm', function () {

	return {
		controller: 'taxStatusFormCtrl',
		templateUrl: 'forms/employment/taxStatus/taxStatusForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('taxStatusFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'base',
	'growl',
	'payrollData',
	'taxUpdatesService',
	'teamData',
	'utilities',
	'NI_CATEGORY_LETTER',
	'PAYROLL_MOVE_STATUSES',
	'STUDENT_LOAN_PLANS',
	'TAX_CODES',
	'TAX_CODES_FIXED',
	function (
		$q,
		$rootScope,
		$scope,
		base,
		growl,
		payrollData,
		taxUpdatesService,
		teamData,
		utilities,
		NI_CATEGORY_LETTER,
		PAYROLL_MOVE_STATUSES,
		STUDENT_LOAN_PLANS,
		TAX_CODES,
		TAX_CODES_FIXED
	) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;
	var currentPayPeriod = $scope.formOptions.currentPayPeriod;

	function addNICategoryChange (teamMember) {

		teamMember.Tax.HasNICodeChange = true;
		// Ensure default 'Select...' option is selected in form
		teamMember.Tax.NICodeChange = null;
	}

	function niCodeOnChange (niCodeChange) {

		let teamMember = $scope.teamMember;
		if (teamMember.Tax.NICodeChangeEffectiveDateISO) {
			checkBackdatedNIStatus (niCodeChange, teamMember.Tax.NICodeChangeEffectiveDateISO);
		}
	}

	function niEffectiveFromDateOnChange (niCodeChangeEffectiveDateISO) {

		/* Note that passing the team member object to this function gives rise to an infinite digest loop if the API
		   call is made (checkBackdatedNIStatus). It's not completely clear why this happens, so for now just get the
		   teamMember object from the $scope */
		let teamMember = $scope.teamMember;
		if (teamMember.Tax.NICodeChange) {
			checkBackdatedNIStatus (teamMember.Tax.NICodeChange, niCodeChangeEffectiveDateISO);
		}
	}

	function checkBackdatedNIStatus (niCodeChange, niCodeChangeEffectiveDateISO) {

		let teamMember = $scope.teamMember;

		// Recalculate if backdated NI status is set
		if (teamMember.Tax.HasBackdatedNI) {
			teamMember.Tax.calculatingBackdatedNI = true;
			payrollData.getTeamMemberBackdatedNI(userId, agencyProfileId, niCodeChange, niCodeChangeEffectiveDateISO).then((backdatedNIResponse) => {

				let backdatedNI = backdatedNIResponse.BackdatedNI;

				teamMember.Tax.backdatedNI = backdatedNI;
				// Update team member with total NIEE.
				teamMember.Tax.BackdatedNIEEAmount = backdatedNIResponse.BackdatedNIAmount;

				teamMember.Tax.calculatingBackdatedNI = false;
			})
			.catch(error => {
				console.error(error);
				setPageState('error');
			});
		}
	}

	function deleteBackdatedNICategoryChange (teamMember) {

		teamMember.Tax.BackdatedNIEEAmount = 0;
		teamMember.Tax.HasBackdatedNI = false;
		teamMember.Tax.HasNICodeChange = false;
		teamMember.Tax.NICodeChange = null;
		teamMember.Tax.NICodeChangeEffectiveDateISO = '';
	}

	function decorateTeamMember (teamMember, niCategoryLettersArr) {

		// Student Loan
		teamMember = setupStudentLoan(teamMember, teamMember.Tax);

		angular.extend(teamMember.Tax, {
			IsYTDInformationRequired: currentPayPeriod.IsYTDInformationRequired,

			// NI calculations aside
			showBackdatedNICalculations: false,

			// Flag to indicate that backdated NI is being calculated.
			calculatingBackdatedNI: false,

			// Remove existing NI category from available category list - selecting the existing code has no effect
			newNICodeList: niCategoryLettersArr.filter(niCategory => (niCategory !== teamMember.Tax.NICode)),

			// Tax code change
			showTaxChangeDate: false,
		});

		// Fields are only mandatory if team member is a non-leaver or a leaver not in setup mode
		teamMember.isTeamMemberSetupFieldsRequired = !(teamMember.IsInSetupMode && teamMember.Company.IsLeaver && !teamMember.TeamMemberSetupComplete);

		return teamMember;
	}

	function toggleShowBackdatedNICalculations (teamMember) {

		teamMember.Tax.showBackdatedNICalculations = !teamMember.Tax.showBackdatedNICalculations;
	}

	function init () {

		setPageState('loading');

		const getNationalInsuranceLetters = base.getNationalInsuranceLetters(agencyProfileId, userId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
				getNationalInsuranceLetters,
				getTeamMemberInformation,
			])
			.then(([
				niCategoryLettersArr,
				teamMemberObj
			]) => {

				// Scope
				$scope.teamMember = decorateTeamMember(teamMemberObj, niCategoryLettersArr);
				$scope.showTaxChangeDate = false;

				// Setup tax codes
				setupTaxCodes(teamMemberObj, niCategoryLettersArr);

				// Process backdated NI if there is any
				if ($scope.teamMember.Tax.HasBackdatedNI && $scope.teamMember.Tax.NICodeChange && $scope.teamMember.Tax.NICodeChangeEffectiveDateISO) {
					checkBackdatedNIStatus($scope.teamMember.Tax.NICodeChange, $scope.teamMember.Tax.NICodeChangeEffectiveDateISO);
				}

				if (teamMemberObj.Tax.CanAddTaxChangeEffectiveDate) {
					initTeamMemberChangeWatcher(teamMemberObj);
				}

				setPageState('ready');
			})
			.catch(error => {
				console.error(error);
				setPageState('error');
			});
	}

	function initTeamMemberChangeWatcher (teamMemberObj) {

		const originalTeamMemberObj = angular.copy(teamMemberObj);

		$scope.$watch('teamMember', function (updatedTeamMemberObj) {
			$scope.showTaxChangeDate = !angular.equals(updatedTeamMemberObj, originalTeamMemberObj);
		}, true);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setupTaxCodes (teamMember, niCategoryLettersArr) {

		function niCategoryFilter (niCategory) {

			var isMale 			= utilities.isMale(teamMember.Personal.Gender);
			var isNiCategoryB	= niCategory === 'B';
			var isNiCategoryT 	= niCategory === 'T';

			// Males cannot have T or B NI Categories
			if (isMale && (isNiCategoryB || isNiCategoryT)) {
				return;
			}

			return niCategory;
		}

		// Scope constants
		$scope.niCategoryLetters 	= niCategoryLettersArr.filter(niCategoryFilter);

		$scope.TAX_CODES 			= TAX_CODES;
		$scope.TAX_CODES_FIXED 		= TAX_CODES_FIXED;
	}

	function setupStudentLoan (teamMemberObj, taxObj) {

		angular.extend(taxObj, {
			// Set visibility flags for student loan plans and postgraduate loan
			canShowStudentLoan: taxUpdatesService.canShowStudentLoan(teamMemberObj, taxObj),
			canShowStudentLoanPlan1: taxUpdatesService.canShowStudentLoanPlan1(teamMemberObj, taxObj),
			canShowStudentLoanPlan2: taxUpdatesService.canShowStudentLoanPlan2(teamMemberObj, taxObj),
			canShowStudentLoanPlan1and2: taxUpdatesService.canShowStudentLoanPlan1and2(teamMemberObj, taxObj),
			canShowStudentLoanPlan4: taxUpdatesService.canShowStudentLoanPlan4(teamMemberObj, taxObj),
			canShowStudentLoanPlan5: taxUpdatesService.canShowStudentLoanPlan5(teamMemberObj, taxObj),
			canShowPostgraduateLoan: taxUpdatesService.canShowPostgraduateLoan(teamMemberObj, taxObj),
			// Get plan option for display
			studentLoanPlanOption: taxUpdatesService.getStudentLoanPlanOption(taxObj.StudentLoanPlan1, taxObj.StudentLoanPlan2, taxObj.StudentLoanPlan4, taxObj.StudentLoanPlan5)
		});

		return teamMemberObj;
	}

	function taxCodeFilter (value) {

		// Hide 'D2' and 'D3' options for all but scottish tax codes
		if ($scope.teamMember.Tax.isTaxCodeScottish) {
			return true;

		} else {
			return (value !== 'D2' && value !== 'D3');
		}
	}

	function updateStudentLoan (teamMemberObj) {

		// Unset all student loan flags
		teamMemberObj.Tax.StudentLoanPlan1 = false;
		teamMemberObj.Tax.StudentLoanPlan2 = false;
		teamMemberObj.Tax.StudentLoanPlan4 = false;
		teamMemberObj.Tax.StudentLoanPlan5 = false;

		// If student loan selected, turn them on according to selected option
		if (teamMemberObj.Tax.StudentLoan) {
			// Switch on according to selected option
			switch (teamMemberObj.Tax.studentLoanPlanOption) {
				case STUDENT_LOAN_PLANS.plan1and2: {
					teamMemberObj.Tax.StudentLoanPlan1 = true;
					teamMemberObj.Tax.StudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan1: {
					teamMemberObj.Tax.StudentLoanPlan1 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan2: {
					teamMemberObj.Tax.StudentLoanPlan2 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan4: {
					teamMemberObj.Tax.StudentLoanPlan4 = true;
					break;
				}
				case STUDENT_LOAN_PLANS.plan5: {
					teamMemberObj.Tax.StudentLoanPlan5 = true;
					break;
				}
			}
		}

		return teamMemberObj;
	}

	init();

	function updateTaxCode (teamMember) {

		var isTaxCodeScottish = teamMember.Tax.isTaxCodeScottish;
		var isTaxCodeWelsh = teamMember.Tax.isTaxCodeWelsh;
		var taxCodeNumber = teamMember.Tax.taxCodeNumber;
		var taxCodeLetter = teamMember.Tax.taxCodeLetter;
		var updatedTaxCode = '';

		// Scottish/Welsh tax codes
		if (taxCodeLetter !== 'NT') {
			if (isTaxCodeScottish) {
				updatedTaxCode += 'S';
			} else if (isTaxCodeWelsh) {
				updatedTaxCode += 'C';
			}
		}

		// K Codes (prefix)
		if (taxCodeLetter === 'K') {
			updatedTaxCode += 'K';
			updatedTaxCode += taxCodeNumber !== undefined ? taxCodeNumber : '';
		}

		// Fixed tax codes
		else if (TAX_CODES_FIXED.indexOf(taxCodeLetter) > -1) {

			// Make sure tax code number is empty
			taxCodeNumber = '';

			// Append fixed tax code
			updatedTaxCode += taxCodeLetter;
		}

		// Non fixed tax code (suffix)
		else {

			updatedTaxCode += taxCodeNumber !== undefined ? taxCodeNumber : '';
			updatedTaxCode += taxCodeLetter;
		}

		// NT codes
		if (taxCodeLetter === 'NT') {
			teamMember.Tax.isTaxCodeScottish = false;
			teamMember.Tax.isTaxCodeWelsh = false;
		}

		// Clear TaxCode if there isn't a tax code leetter
		if (!taxCodeLetter) {
			updatedTaxCode = '';
		}

		// Update tax code
		teamMember.Tax.TaxCode = updatedTaxCode;

		// Update team member
		$scope.teamMember = teamMember;
	}

	function updateTeamMemberTax (teamMember, form) {

		form.state = 'saving';

		// Remove effective NI code change date if backdated wasn't selected
		if (!teamMember.Tax.HasBackdatedNI) {
			teamMember.Tax.NICodeChangeEffectiveDateISO = '';
		}

		teamData.updateTeamMemberTax(teamMember.Tax, userId, agencyProfileId).then(() => {

			// Complete demo task
			$rootScope.setDemoTaskAsComplete('editTaxCode', teamMember.Personal.Forename);

			// Wizard: Go to next step
			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			// Force callback
			$scope.formOptions.forceCallback();

			// Show success message
			growl.success(teamMember.Personal.Forename + '\'s tax details have been updated.');

			// Close form
			$scope.formOptions.closeForm();

			// Form state
			form.state = 'saved';
		})
		.catch(function () {

			// Page state
			setPageState('error');

			// Form state
			form.state = '';
		});
	}

	angular.extend($scope, {
		// Constants
		NI_CATEGORY_LETTER,
		PAYROLL_MOVE_STATUSES,
		STUDENT_LOAN_PLANS,

		// Services
		taxUpdatesService,

		// Functions
		addNICategoryChange,
		checkBackdatedNIStatus,
		currentPayPeriod,
		deleteBackdatedNICategoryChange,
		niCodeOnChange,
		niEffectiveFromDateOnChange,
		taxCodeFilter,
		toggleShowBackdatedNICalculations,
		updateStudentLoan,
		updateTaxCode,
		updateTeamMemberTax
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('viewWorkPatternForm', function () {

	return {
		controller: 'viewWorkPatternFormCtrl',
		templateUrl: 'forms/employment/viewWorkPattern/viewWorkPatternForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('viewWorkPatternFormCtrl', [
	'$q',
	'$scope',
	'$timeout',
	'companyData',
	'payrollData',
	'workPatternService',
	'WORK_PATTERN_BASIS',
	function (
		$q,
		$scope,
		$timeout,
		companyData,
		payrollData,
		workPatternService,
		WORK_PATTERN_BASIS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const teamMemberObj = $scope.formOptions.context;
	const userId = $scope.formOptions.userId;

	function getCompanyWorkPatternsForEmploymentType (companyWorkPatternsArr, teamMemberSalaryObj) {

		if (!companyWorkPatternsArr.length) {
			return companyWorkPatternsArr;
		}

		return workPatternService.getCompanyWorkPatternsForEmploymentType(companyWorkPatternsArr, teamMemberSalaryObj.EmploymentType);
	}

	function init () {

		if (teamMemberObj.IsCISSubcontractor) {
			setPageState('is-cis');
			return;
		}

		setPageState('loading');

		const getWorkPatternsForCompany = companyData.getWorkPatternsForAgency(agencyProfileId);
		const getWorkPatternsForUser = companyData.getWorkPatterns(agencyProfileId, userId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getTeamMemberSalary = payrollData.getTeamMemberSalary(agencyProfileId, userId, false);

		$q.all([
			getWorkPatternsForCompany,
			getWorkPatternsForUser,
			getPayPeriodCurrent,
			getTeamMemberSalary
		])
		.then(([
			companyWorkPatternsArr,
			teamMemberWorkPatternsArr,
			currentPayPeriodObj,
			teamMemberSalaryObj
		]) => {

			if (!workPatternService.isWorkPatternsApplicable(currentPayPeriodObj)) {
				setPageState('not-applicable');
				return;
			}

			workPatternService.decorateCompanyWorkPatterns(companyWorkPatternsArr);
			const companyWorkPatternsFilteredArr = getCompanyWorkPatternsForEmploymentType(companyWorkPatternsArr, teamMemberSalaryObj);

			// Decorate
			const vmObj = {
				currentPayPeriod: currentPayPeriodObj,
				isCalendarVisible: false,
				teamMemberSalary: teamMemberSalaryObj,
				workPatterns: workPatternService.decorateTeamMemberWorkPatterns(teamMemberWorkPatternsArr)
			};

			setupTeamMemberWorkPatterns(teamMemberObj, teamMemberWorkPatternsArr, companyWorkPatternsFilteredArr, currentPayPeriodObj);

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function showIsCalendarVisible (vmObj) {

		if (vmObj.isCalendarVisible) {
			vmObj.isCalendarVisible = false;

			$timeout(() => {
				vmObj.isCalendarVisible = true;
			}, 300);

			return;
		}

		vmObj.isCalendarVisible = true;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}
	
	function setupTeamMemberWorkPatterns (teamMemberObj, teamMemberWorkPatternsArr, companyWorkPatternsArr, currentPeriodObj) {

		// If no work patterns are defined take first company work pattern for same Employment Type (Group)
		if (!teamMemberWorkPatternsArr.length) {

			// Company work patterns are required for pattern employment types
			if (companyWorkPatternsArr.length) {
				teamMemberWorkPatternsArr.push(angular.copy(companyWorkPatternsArr[0]));
			}
		}

		// Set up work patterns
		teamMemberWorkPatternsArr.forEach((teamMemberWorkPatternObj, index) => {

			teamMemberWorkPatternObj.companyWorkPattern = null;

			// Effective date validation
			teamMemberWorkPatternObj.effectiveDateISOMax = angular.copy(currentPeriodObj.EndDateISO);
			teamMemberWorkPatternObj.effectiveDateISOMin = angular.copy(currentPeriodObj.StartDateISO);

			// Show as editable
			teamMemberWorkPatternObj.isEditing = teamMemberObj.IsInSetupMode && (teamMemberWorkPatternsArr.length === index + 1);

			// Attach company work pattern to team work pattern for company work pattern selection
			companyWorkPatternsArr.forEach((companyWorkPatternObj) => {

				if (teamMemberWorkPatternObj.WorkPatternID === companyWorkPatternObj.WorkPatternID) {
					teamMemberWorkPatternObj.companyWorkPattern = angular.copy(companyWorkPatternObj);
				}
			});

			// Set to first company work pattern
			if (!teamMemberWorkPatternObj.companyWorkPattern) {
				teamMemberWorkPatternObj.companyWorkPattern = angular.copy(companyWorkPatternsArr[0]);
			}
		});
	}

	function toggleIsCalendarVisible (vmObj) {
		vmObj.isCalendarVisible = !vmObj.isCalendarVisible;
	}

	init();

	angular.extend($scope, {
		WORK_PATTERN_BASIS,
		showIsCalendarVisible,
		toggleIsCalendarVisible
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('workplaceInformationForm', function () {

	return {
		controller: 'workplaceInformationFormCtrl',
		templateUrl: 'forms/employment/workplace-information/workplace-information.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workplaceInformationFormCtrl', [
    '$scope', 
    'growl', 
    'teamData', 
    function (
        $scope, 
        growl, 
        teamData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	const formState = $scope.formOptions.formState;

	function deleteWorkplaceInformation () {

		setPageState('delete-information');
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberCompanyWorkplaceInformation(userId, agencyProfileId).then(workplaceInformationObj => {

			$scope.vm = {
				workplaceInformation: workplaceInformationObj,
				// Offer delete option if any workplace information data is available
				showDelete: workplaceInformationObj.WorkplacePostcode
			};

			if (formState === 'delete-information') {
				setPageState('delete-information');

			} else {
				setPageState('ready');
			}
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateTeamMemberCompanyWorkplaceInformation (vmObj, formObj) {

		formObj.state = 'saving';

		const workplaceInformationObj = vmObj.workplaceInformation;

		if ($scope.pageState === 'delete-information') {
			angular.extend(workplaceInformationObj, {
				WorkplacePostcode: ''
			});
		}

		teamData.updateTeamMemberCompanyWorkplaceInformation(userId, agencyProfileId, workplaceInformationObj).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Workplace information details updated');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		deleteWorkplaceInformation,
		updateTeamMemberCompanyWorkplaceInformation
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addPayPolicyUpdateForm', function () {

	return {
		controller: 'addPayPolicyUpdateFormCtrl',
		templateUrl: 'forms/hr/addPayPolicyUpdateForm/addPayPolicyUpdateForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addPayPolicyUpdateFormCtrl', [
	'$q',
	'$scope',
	'bulkService',
	'config',
	'growl',
	'payrollData',
	'policyService',
	'regexService',
	'searchService',
	'utilities',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_PENSION_STATES',
	'POLICY_STATES',
function (
	$q,
	$scope,
	bulkService,
	config,
	growl,
	payrollData,
	policyService,
	regexService,
	searchService,
	utilities,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES,
	POLICY_PENSION_STATES,
	POLICY_STATES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	// Pay policy ID relates to the original policy that is receiving the update.
	const payPolicyId = $scope.formOptions.payPolicyId;

	const PAGE_STATES = {
		loading: 'loading',
		ready: 'ready',
		error: 'error'
	};

	const SUMMARY_TABS = {
		current: 'current',
		update: 'update'
	};

	// Pages displayed for entering pay policy info
	const UPDATE_STEPS = {
		// Update not permitted. Not part of the normal steps
		updateNotPermitted: -1,

		// Start at 1. That's important.
		confirmUpdate: 1,
		policySettings: 2,
		policyBands: 3,
		summary: 4,
		deleteOrphanWarning: 5
	};

	function addPayPolicyBand (policyUpdateObj) {
		// Add band and mark name as editable
		policyService.createPolicyBand(policyUpdateObj).then(policyBandObj => {
			policyBandObj.allowNameEdit = true;
		});
	}

	function addPayPolicyUpdate (policyUpdateObj, form) {

		form.state = 'saving';

		// Determine which API to use. If this is an update being updated, use UpdatePolicy, otherwise OverridePolicyPay
		let updatePolicy;
		if (policyUpdateObj.PolicyState === POLICY_STATES.update) {
			updatePolicy = payrollData.updatePolicy(agencyProfileId, policyUpdateObj);
		}
		else {
			updatePolicy = payrollData.overridePolicyPay(agencyProfileId, policyUpdateObj);
		}

		updatePolicy.then(() => {

			growl.success(`Pay policy update added`);
			form.state = null;
			$scope.formOptions.forceCallback();

			/* init will now set up this form as if viewing an existing policy update, since the update should now exist. This is important since
			   the saved update will include attributes not available to the UI at this point; CreatedBy, CreatedDateISO, UpdateEffectiveDateISO
			   (the latter passed in as PolicyEffectiveDateISO but returned as UpdateEffectiveDateISO) */
			init();
		})
		.catch(error => {
			onError(error);
			form.state = null;
		});
	}

	function applyUplift (vmObj) {

		if (!vmObj.upliftPercentage || vmObj.upliftPercentage < 0 || vmObj.upliftPercentage > 100) {
			return;
		}

		vmObj.isApplyingUplift = true;
		vmObj.upliftPreview = null;

		payrollData.calculatePayPolicyUplift(agencyProfileId, payPolicyId, vmObj.upliftPercentage)
			.then(upliftResult => {
				
				if (!upliftResult.SuccessfulUplift) {
					growl.error('Unable to apply uplift. Please try again or contact support if the issue persists.');
					vmObj.isApplyingUplift = false;
					return;
				}

				vmObj.upliftPreview = upliftResult;
				if (upliftResult && upliftResult.PolicyBands) {
					updatePolicyBandsFromUplift(vmObj, upliftResult);
				}

				vmObj.isApplyingUplift = false;
			})
			.catch(error => {
				onError(error);
				vmObj.isApplyingUplift = false;
			});
	}

	/**
	* Locates the bands from the uplift result by their stored OriginalPolicyBandID (see policyService.copyPolicy) and updates their values. Storing original values on the object for comparison display.
	* @param {object} vmObj - view model
	* @param {PayPolicyUplift} upliftResult - the result returned from the calculatePayPolicyUplift API, containing uplifted values to apply to the bands in the update policy
	*/
	function updatePolicyBandsFromUplift (vmObj, upliftResult) {
		if (!vmObj.percentageUpliftEnabled) {
			return;
		}

		vmObj.payPolicyUpdate.PolicyBands.forEach(updateBand => {
			// Match uplift result band via OriginalPolicyBandID (set by policyService.copyPolicy for new updates,
			// or mapped in init for existing updates)
			const upliftBand = upliftResult.PolicyBands.find(
				ub => ub.PolicyBandID === updateBand.OriginalPolicyBandID
			);
			// Get matching current policy band for storing original comparison values
			const currentBand = vmObj.payPolicyCurrent.PolicyBands.find(
				cb => cb.PolicyBandID === updateBand.OriginalPolicyBandID
			);

			if (upliftBand && currentBand) {
				if (vmObj.payPolicyUpdate.PolicyPayBasis === POLICY_PAY_BASES.annualSalary) {
					updateBand.OriginalPolicyBandAnnualSalary = currentBand.PolicyBandAnnualSalary;
					updateBand.PolicyBandAnnualSalary = upliftBand.UpliftedAnnualSalary;
				} else {
					updateBand.OriginalPolicyBandAnnualAllowance = currentBand.PolicyBandAnnualAllowance;
					updateBand.PolicyBandAnnualAllowance = upliftBand.UpliftedAnnualSalary;
				}
				updateBand.OriginalPolicyBandHourlyRate = currentBand.PolicyBandHourlyRate;
				updateBand.PolicyBandHourlyRate = upliftBand.UpliftedHourlyRate;
			}
		});
	}

	function resetBandValues (vmObj) {
		vmObj.payPolicyUpdate.PolicyBands.forEach(policyBand => {
			if (vmObj.payPolicyUpdate.PolicyPayBasis === POLICY_PAY_BASES.annualSalary) {
				policyBand.PolicyBandAnnualSalary = angular.isDefined(policyBand.OriginalPolicyBandAnnualSalary) ? policyBand.OriginalPolicyBandAnnualSalary : policyBand.PolicyBandAnnualSalary;
			} else {
				policyBand.PolicyBandAnnualAllowance = angular.isDefined(policyBand.OriginalPolicyBandAnnualAllowance) ? policyBand.OriginalPolicyBandAnnualAllowance : policyBand.PolicyBandAnnualAllowance;
			}
			policyBand.PolicyBandHourlyRate = angular.isDefined(policyBand.OriginalPolicyBandHourlyRate) ? policyBand.OriginalPolicyBandHourlyRate : policyBand.PolicyBandHourlyRate;
		});
	}

	function clearUpliftPreview (vmObj) {
		vmObj.upliftPreview = null;

		resetBandValues(vmObj);
	}

	function changeSummaryTab (summaryTab, vmObj) {
		// Switch to policy of interest for display in summary
		if (summaryTab === SUMMARY_TABS.current) {
			vmObj.summaryActivePolicy = vmObj.payPolicyCurrent;
		}
		else {
			vmObj.summaryActivePolicy = vmObj.payPolicyUpdate;
		}
		vmObj.summaryActiveTab = summaryTab;
	}

	function deletePayPolicyUpdate(formObj, policyUpdateObj, formOptionsObj) {

		formObj.state = 'saving';
		payrollData.deletePolicyPay(agencyProfileId, policyUpdateObj.PolicyID).then(result => {
			formObj.state = 'saved';
			formOptionsObj.forceCallback();

			if (result.Success) {
				formOptionsObj.closeForm();
			} else {
				$scope.vm.deletionFailureMessages = result.FailureMessages;
				setUpdateStep(UPDATE_STEPS.deleteOrphanWarning);
			}
		})
		.catch(onError);
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		// Start by getting the original policy.
		policyService.getPolicy(agencyProfileId, payPolicyId).then(payPolicy => {

			// Now get other stuff required, including any pay policy that already exists.
			const isExistingPolicyUpdate = payPolicy.UpdatePolicyID !== config.guidEmpty;
			const getPolicyUpdate = isExistingPolicyUpdate ? policyService.getPolicy(agencyProfileId, payPolicy.UpdatePolicyID) : null;
			const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);
			const getSalaryFutureChangesForPolicy = payrollData.getSalaryFutureChangesForPolicy(agencyProfileId, payPolicyId);

			$q.all([
				getPolicyUpdate,
				getPayPeriodMinimum,
				getSalaryFutureChangesForPolicy
			])
			.then(([
				payPolicyUpdate,
				currentPayPeriod,
				salaryFutureChangesForPolicy
			]) => {

				/* If this is a new update, Use a copy of the current policy for the update, otherwise the payPolicyUpdate
				   will have already been set from the getPolicyUpdate API call above */
				if (!isExistingPolicyUpdate) {
					const FOR_POLICY_UPDATE = true;
					payPolicyUpdate = policyService.copyPolicy(payPolicy, FOR_POLICY_UPDATE);
				}

				// Mark existing bands so their names can't be edited. Only new bands added have name editing enabled.
				payPolicyUpdate.PolicyBands.forEach(policyBand => policyBand.allowNameEdit = false);

				mapExistingUpdateBands(isExistingPolicyUpdate, payPolicyUpdate, payPolicy);

				$scope.vm = {
					agencyProfileId,
					currentPayPeriod,
					isTeamMembersViewActive: false,
					payPolicyCurrent: payPolicy,
					payPolicyUpdate,
					policyTeamMembers: bulkService.getBulkItemsObj(payPolicy.TeamMembers),
					policyTeamMembersSearchOptions: searchService.policyTeamMembers,
					percentageUpliftEnabled: getPercentageUpliftEnabled(payPolicy),

					// When viewing an existing update, default to update tab in summary with updated policy, otherwise current
					summaryActiveTab: isExistingPolicyUpdate ? SUMMARY_TABS.update : SUMMARY_TABS.current,
					summaryActivePolicy: isExistingPolicyUpdate ? payPolicyUpdate : payPolicy
				};

				// Set first update step, depending on whether there are any pending future changes, or whether this is an existing update.
				if (isExistingPolicyUpdate) {
					// Go to setting step; this is an update that already exists
					setUpdateStep(UPDATE_STEPS.summary);
				}
				else if (angular.isDefined(salaryFutureChangesForPolicy) && angular.isArray(salaryFutureChangesForPolicy) && salaryFutureChangesForPolicy.length === 0) {
					// Go to first bonafide step, for user confirmation
					setUpdateStep(UPDATE_STEPS.confirmUpdate);
				}
				else {
					// This 'invalid' step is a dead end
					setUpdateStep(UPDATE_STEPS.updateNotPermitted);
				}

				setPageState(PAGE_STATES.ready);
			});
		})
		.catch(onError);
	}

	/**
	 * For existing updates loaded from the API, map each update band to its corresponding current policy band.
	 * This re-establishes OriginalPolicyBandID (normally set by policyService.copyPolicy for new updates)
	 * so that uplift calculations can correctly target the update bands without overwriting their IDs.
	 * @param {bool} isExistingPolicyUpdate 
	 * @param {PayPolicy} payPolicyUpdate 
	 * @param {PayPolicy} currentPayPolicy 
	 * @error Will log an error if an update band doesn't have a matching current band, but this should never happen since the API should only return update bands that match current bands
	 */
	function mapExistingUpdateBands (isExistingPolicyUpdate, payPolicyUpdate, currentPayPolicy)
	{
		if (isExistingPolicyUpdate) {
			payPolicyUpdate.PolicyBands.forEach(updateBand => {
				const matchingCurrentBand = currentPayPolicy.PolicyBands.find(
					currentBand => currentBand.PolicyBandName === updateBand.PolicyBandName
				);
				if (matchingCurrentBand) {
					updateBand.OriginalPolicyBandID = matchingCurrentBand.PolicyBandID;
				} else {
					// This should never happen, but if it does, log an error so we can investigate
					onError(`No matching current band found for update band: ${updateBand.PolicyBandName}`);
				}
			});
		}
	}

	function getPercentageUpliftEnabled (policyObj) {
		return policyObj.policyCategory === POLICY_CATEGORIES.pay;
	}

	function moveToNextUpdateStep (updateStep, policyObj) {

		/* For annual salary pay policies only: If this is the policy settings step, and bands exist, the hourly rates on those
		   may need to be updated if contracted work times have changed. Do that here, regardless. */
		if (
			updateStep === UPDATE_STEPS.policySettings &&
			policyObj.policyCategory === POLICY_CATEGORIES.pay &&
			policyObj.PolicyPayBasis === POLICY_PAY_BASES.annualSalary
		) {
			policyService.setAllPayPolicyBandHourlyRates(policyObj);
		}

		setUpdateStep(++updateStep);
	}

	function moveToPreviousUpdateStep (editStep) {
		setUpdateStep(--editStep);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setUpdateStep (updateStep) {
		$scope.updateStep = updateStep;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleIsTeamMemberViewActive (vmObj) {
		vmObj.isTeamMembersViewActive = !vmObj.isTeamMembersViewActive;
	}

	function viewTeamMembers (teamMembersArr, vmObj) {

		vmObj.policyTeamMembers = bulkService.getBulkItemsObj(teamMembersArr);
		vmObj.isTeamMembersViewActive = true;
	}

	init();

	angular.extend($scope, {

		config,
		policyService,
		regexService,
		utilities,

		PAGE_STATES,
		POLICY_PAY_BASES,
		POLICY_PENSION_STATES,
		SUMMARY_TABS,
		UPDATE_STEPS,

		addPayPolicyBand,
		addPayPolicyUpdate,
		applyUplift,
		changeSummaryTab,
		clearUpliftPreview,
		deletePayPolicyUpdate,
		moveToNextUpdateStep,
		moveToPreviousUpdateStep,
		setPageState,
		setUpdateStep,
		toggleIsTeamMemberViewActive,
		viewTeamMembers
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteJobGradeForm', function () {

	return {
		controller: 'deleteJobGradeFormCtrl',
		templateUrl: 'forms/hr/deleteJobGradeForm/deleteJobGradeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteJobGradeFormCtrl', [
	'$scope',
	'bulkService',
	'companyData',
	'growl',
	'searchService',
function (
	$scope,
	bulkService,
	companyData,
	growl,
	searchService
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const jobGrade = $scope.formOptions.jobGrade;

	const PAGE_STATES = {
		error: 'error',
		ready: 'ready'
	};

	function deleteJobGrade (jobGradeObj, form) {

		form.state = 'saving';
		companyData.deletePolicyGrade(jobGradeObj.PolicyGradeID).then(() => {
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = null;

			growl.success(`Job grade ${jobGrade.PolicyGradeName} has been deleted`);
		})
		.catch(error => {
			onError(error);
			form.state = null;
		});
	}

	function init () {
		setPageState(PAGE_STATES.ready);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		vm: {
			agencyProfileId,
			isJobGradeInUse: jobGrade.TeamMembers.length !== 0,
			jobGrade,
			jobGradeTeamMembers: bulkService.getBulkItemsObj(jobGrade.TeamMembers),
			searchBarOptions: searchService.jobGradeTeamMembers
		},

		deleteJobGrade
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePolicyForm', function () {

	return {
		controller: 'deletePolicyFormCtrl',
		templateUrl: 'forms/hr/deletePolicyForm/deletePolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePolicyFormCtrl', [
	'$scope',
	'companyData',
	'growl',
	'policyService',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
function (
	$scope,
	companyData,
	growl,
	policyService,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES_DESCRIPTIONS
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const policyId = $scope.formOptions.policyId;

	const PAGE_STATES = {
		loading: 'loading',
		error: 'error',
		ready: 'ready'
	};

	function deletePolicy (policyObj, form) {

		form.state = 'saving';
		companyData.deletePolicy(agencyProfileId, policyObj.PolicyID).then(() => {
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = null;

			growl.success(`Policy ${policyObj.PolicyName} has been deleted`);
		})
		.catch(error => {
			onError(error);
			form.state = null;
		});
	}

	function init () {
		setPageState(PAGE_STATES.loading);
		/* Get policy. Note that the policy object can't be passed into this form from a GetPolicies call since that
		   doesn't include information about dependants (PensionSchemes for pension policies, TeamMembers for pay) */
		policyService.getPolicy(agencyProfileId, policyId).then(policyObj => {
			$scope.vm = {
				agencyProfileId,
				policy: policyObj
			};
			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Constants
		PAGE_STATES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,

		// Functions
		deletePolicy
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('jobGradeTeamMembersForm', function () {

	return {
		controller: 'jobGradeTeamMembersFormCtrl',
		templateUrl: 'forms/hr/jobGradeTeamMembersForm/jobGradeTeamMembersForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('jobGradeTeamMembersFormCtrl', ['$scope', '$state', '$timeout', 'bulkService', 'searchService', function ($scope, $state, $timeout, bulkService, searchService) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const jobGrade = $scope.formOptions.jobGrade;

	function goToTeam (agencyProfileId) {
		$scope.formOptions.closeForm();

		// Give the slide-in-form a chance to disappear. It looks cleaner this way.
		$timeout(() => {
			$state.go('team.members', {agencyProfileId});
		}, 250);
	}

	angular.extend($scope, {
		vm: {
			agencyProfileId,
			jobGrade,
			jobGradeTeamMembers: bulkService.getBulkItemsObj(jobGrade.TeamMembers),
			searchBarOptions: searchService.jobGradeTeamMembers
		},

		goToTeam
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('payPolicyHistoryForm', function () {

	return {
		controller: 'payPolicyHistoryFormCtrl',
		templateUrl: 'forms/hr/payPolicyHistoryForm/payPolicyHistoryForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('payPolicyHistoryFormCtrl', [
	'$scope',
	'companyData',
	'config',
	'policyService',
	'utilities',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
function (
	$scope,
	companyData,
	config,
	policyService,
	utilities,
	POLICY_CATEGORIES,
	POLICY_PAY_BASES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPolicy = $scope.formOptions.payPolicy;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		viewHistory: 'viewHistory',
		viewPolicy: 'viewPolicy'
	};

	function init () {

		companyData.getPolicyGroup(agencyProfileId, payPolicy.PolicyGroupID).then(policyGroup => {
			/* Decorate policies. They're coming from salary-related objects so won't be decorated in the way
			   that UI components require. */
			policyGroup.forEach(policy => policyService.decoratePolicy(policy, POLICY_CATEGORIES.pay));
			$scope.vm = {
				policyGroup: policyGroup.sort(utilities.comparator('PolicyVersionNumber'))
			};
		});

		setPageState(PAGE_STATES.viewHistory);
	}

	function onViewSettings (vmObj, payPolicyObj) {

		vmObj.historicPayPolicy = payPolicyObj;
		setPageState(PAGE_STATES.viewPolicy);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		config,

		PAGE_STATES,
		POLICY_PAY_BASES,

		onViewSettings,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('updateJobGradeForm', function () {

	return {
		controller: 'updateJobGradeFormCtrl',
		templateUrl: 'forms/hr/updateJobGradeForm/updateJobGradeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('updateJobGradeFormCtrl', ['$scope', 'companyData', 'growl', function ($scope, companyData, growl) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const jobGrade = $scope.formOptions.jobGrade;
	const jobGrades = $scope.formOptions.jobGrades;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const JOB_GRADE_NAME_NOT_UNIQUE = 'job-grade-not-unique';

	function checkJobGradeName (jobGradeObj, jobGradesArr, jobGradeNameFormField) {

		// Ensure job grade name is unique
		const jobGradeNameNotUnique = jobGradesArr.some(jobGrade => jobGrade.PolicyGradeName === jobGradeObj.PolicyGradeName);
		jobGradeNameFormField.$setValidity(JOB_GRADE_NAME_NOT_UNIQUE, !jobGradeNameNotUnique);
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		// If this is being invoked for creating a new one (no jobGrade in formOptions), get an empty one for populating.
		if (angular.isUndefined(jobGrade)) {
			companyData.getEmptyPolicyGrade().then(emptyJobGrade => {
				/* This empty job grade also has an empty user attached. That's pointless here as there's no
				   user association that's going to happen, and immediately it looks in the UI as if a single
				   user is attached to the job grade. So get rid of it. */
				emptyJobGrade.TeamMembers = [];
				$scope.vm = {
					jobGrade: emptyJobGrade,
					jobGrades
				};

				setPageState(PAGE_STATES.ready);
			})
			.catch(onError);
		}
		else {
			/* The job grades array is used to ensure name uniqueness. Unfortunately it will include the
			   job grade being edited. So ... get rid of it. */
			const jobGradesFiltered = jobGrades.filter(jobGradeObj => jobGradeObj.PolicyGradeName !== jobGrade.PolicyGradeName);

			$scope.vm = {
				jobGrade,
				jobGrades: jobGradesFiltered
			};

			setPageState(PAGE_STATES.ready);
		}
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateJobGrade (jobGradeObj, form) {

		form.state = 'saving';
		companyData.updatePolicyGrade(agencyProfileId, jobGradeObj).then(() => {
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = null;

			growl.success(`Job grade ${jobGradeObj.PolicyGradeName} has been saved`);
		})
		.catch(error => {
			onError(error);
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {
		JOB_GRADE_NAME_NOT_UNIQUE,
		PAGE_STATES,

		checkJobGradeName,
		updateJobGrade
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('updatePolicyForm', function () {

	return {
		controller: 'updatePolicyFormCtrl',
		templateUrl: 'forms/hr/updatePolicyForm/updatePolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('updatePolicyFormCtrl', [
	'$q',
	'$scope',
	'$state',
	'bulkService',
	'config',
	'growl',
	'payrollData',
	'policyService',
	'regexService',
	'searchService',
	'utilities',
	'DOCUMENT_TYPES',
	'POLICY_BAND_CALCULATION_TYPES',
	'POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS',
	'POLICY_BAND_RATE_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_CATEGORY_TYPES',
	'POLICY_NAME_EXISTS',
	'POLICY_NAME_TYPE_REQUIRED',
	'POLICY_CODE_EXISTS',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_PAY_BASES',
	'POLICY_PENSION_STATES',
	'POLICY_SERVICE_ENTITLEMENTS',
	'POLICY_TYPE_NAMES',
	'POLICY_TYPES',
	'POLICY_YEAR_BASES',
	'POLICY_YEAR_BASES_DESCRIPTIONS',
	'UPDATE_POLICY_MODES',
function (
	$q,
	$scope,
	$state,
	bulkService,
	config,
	growl,
	payrollData,
	policyService,
	regexService,
	searchService,
	utilities,
	DOCUMENT_TYPES,
	POLICY_BAND_CALCULATION_TYPES,
	POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS,
	POLICY_BAND_RATE_TYPES,
	POLICY_CATEGORIES,
	POLICY_CATEGORY_TYPES,
	POLICY_NAME_EXISTS,
	POLICY_NAME_TYPE_REQUIRED,
	POLICY_CODE_EXISTS,
	POLICY_PAY_BASES_DESCRIPTIONS,
	POLICY_PAY_BASES,
	POLICY_PENSION_STATES,
	POLICY_SERVICE_ENTITLEMENTS,
	POLICY_TYPE_NAMES,
	POLICY_TYPES,
	POLICY_YEAR_BASES,
	POLICY_YEAR_BASES_DESCRIPTIONS,
	UPDATE_POLICY_MODES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	// Policy category for this form
	const policyCategory = $scope.formOptions.policyCategory;

	// Mode of operation. Default to 'create new' mode. This can change.
	let updatePolicyMode = angular.isDefined($scope.formOptions.updatePolicyMode) ? $scope.formOptions.updatePolicyMode : UPDATE_POLICY_MODES.create;

	const PAGE_STATES = {
		edit: 'edit',
		error: 'error',
		loading: 'loading',
		saved: 'saved',
		view: 'view'
	};

	// Pages displayed for entering pay policy info
	const EDIT_STEPS = {
		// Start at 1. That's important. These confirm steps are just used when duplicating or editing an existing policy
		confirmDuplication: 1,
		confirmEdit: 2,
		// Select pay policy basis exclusive to pay policies
		selectPolicyPayBasis: 3,
		policySettings: 4,
		policyBands: 5,

		// Count of steps. Update if steps are added or removed above
		EDIT_STEPS_COUNT: 5
	};

	function editPolicy (vmObj, formOptionsObj) {

		// Ensure any fly-outs are closed
		angular.extend(vmObj, {
			isTeamMembersViewActive: false,
			isPensionSchemeViewActive: false
		});

		// Enter edit mode
		formOptionsObj.title = `Edit ${policyCategory} policy`;
		updatePolicyMode = UPDATE_POLICY_MODES.edit;
		setPageState(PAGE_STATES.edit);
	}

	function goToImporter () {

		function getImportMappingDataStringForPolicy () {

			/*
			[0] Policy Pay Basis (Annual Salary = 1, Annual Allowance = 2)
			[1] Policy Name
			[1] Contracted Hours Per Week
			[2] Contracted Weeks Per Year
			[3] Allowance Pensionable
			*/

			const policyObj = $scope.vm.policy;

			const unSerialisedDataArr = [
				policyObj.PolicyPayBasis,
				policyObj.PolicyName,
				policyObj.PolicyHoursPerWeek,
				policyObj.PolicyWeeksPerYear,
				policyObj.PolicyPensionActive
			];

			// Return serealised string of data
			return encodeURIComponent(JSON.stringify(unSerialisedDataArr));
		}

		$state.go('data-importer.upload-file', {
			agencyDocumentType: DOCUMENT_TYPES.policyImport,
			agencyProfileId: agencyProfileId,
			form: 'hr.policies.' + policyCategory,
			importMappingData: getImportMappingDataStringForPolicy()
		});
	}

	function hidePensionSchemesView (vmObj) {
		vmObj.isPensionSchemeViewActive = false;
	}

	function hideTeamMembersView (vmObj) {
		vmObj.isTeamMembersViewActive = false;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		const policies = $scope.formOptions.policies;

		// Decide how to get the policy. It's new, it's a duplicate, or it's existing.
		const policy = $scope.formOptions.policy;
		let getPolicy;
		if ([UPDATE_POLICY_MODES.create, UPDATE_POLICY_MODES.import].includes(updatePolicyMode)) {
			// Create new
			getPolicy = policyService.createPolicy(policyCategory, companyObj);
		}
		else if (updatePolicyMode === UPDATE_POLICY_MODES.duplicate) {
			// Duplicate
			getPolicy = policyService.duplicatePolicy(policy, policies);
		}
		else {
			/* Get existing policy. This may have additional info not included in the original call that got it
			   (typically GetPolicies). This is for edit or view mode. */
			getPolicy = policyService.getPolicy(agencyProfileId, policy.PolicyID);
		}

		// Current pay period info needed for effective date validation
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);

		// Get the  policy. This could be a duplicate or a new one, or existing. When viewing, it'll always be an existing policy.
		$q.all([
			getPolicy,
			getPayPeriodMinimum
		])
		.then(([
			policy,
			currentPayPeriod
		]) => {

			/* Get a list of the available policy types for user selection. Applicable if there is more than
				one type associated with the category. Note that this is all controlled
				by the entries in POLICY_CATEGORIES. Change that if another needs to be added */
			const policyTypes = [];
			const policyCategoryTypes = POLICY_CATEGORY_TYPES[policyCategory];
			if (policyCategoryTypes.length > 1) {
				// There's more than one type for this category. Create a list for user selection
				policyCategoryTypes.forEach(policyType => {
					policyTypes.push({
						policyType,
						description: POLICY_TYPE_NAMES[policyType]
					});
				});
				// Mark policy so the UI shows the 'Policy Type' select
				policy.showPolicyType = true;
			}
			else {
				// Don't show policy type selection. This will be fixed (set by the policy service)
				policy.showPolicyType = false;
			}

			// Available policy year bases types. 'None' not included
			const policyYearBasesTypes = [];
			Object.values(POLICY_YEAR_BASES).forEach(policyYearBasis => {
				if (policyYearBasis !== POLICY_YEAR_BASES.none) {
					policyYearBasesTypes.push({
						policyYearBasis,
						description: POLICY_YEAR_BASES_DESCRIPTIONS[policyYearBasis]
					});
				}
			});

			// Display contracted working time settings when importing
			if (updatePolicyMode === UPDATE_POLICY_MODES.import) {
				policy.hasContractedWorkingTime = true;
			}

			// Slap all of that on a vm object
			$scope.vm = {
				agencyProfileId,
				currentPayPeriod,
				policy,
				policyCategory,
				policies,
				policyBandCalculationTypes: policyService.getPolicyBandCalculationTypesForSelection(),
				policyPensionSchemesSearchOptions: searchService.policyPensionSchemes,
				policyTeamMembersSearchOptions: searchService.policyTeamMembers,
				policyTypes,
				policyYearBasesTypes: policyService.getPolicyYearBasesTypesForSelection(),
				// Policy locked warning. Shown when attempting to edit a locked policy
				showPolicyLockedWarning: false,
				// Policy update pending warning. Shown when attempting to duplicate a policy that has a pending update
				showPolicyUpdatePendingWarning: false,
				updatePolicyMode
			};

			// Set page state depending on view mode and policy status.
			let pageState;
			if (updatePolicyMode === UPDATE_POLICY_MODES.view) {
				pageState = PAGE_STATES.view;
			}
			else {
				pageState = PAGE_STATES.edit;
				if (updatePolicyMode === UPDATE_POLICY_MODES.edit && policy.IsPolicyRestricted) {
					// User selected 'edit' for a locked policy. Change to 'view' and show warning
					pageState = PAGE_STATES.view;

					// Get team members to display below warning and set flag to show it
					angular.extend($scope.vm, {
						showPolicyLockedWarning: true,
						policyTeamMembers: bulkService.getBulkItemsObj(policy.TeamMembers)
					});
				}
				if (updatePolicyMode === UPDATE_POLICY_MODES.duplicate && policy.IsUpdatePending) {
					// User selected 'duplicate' for a policy with a pending update. Change to 'view' and show warning
					pageState = PAGE_STATES.view;
					$scope.vm.showPolicyUpdatePendingWarning = true;
				}
			}

			setPageState(pageState);
		})
		.catch(onError);
	}

	function moveToNextStep (editStep, policyObj) {
		/* If editing or duplicating and moving from the confirmation step, go straight to the details.
		   The basis type if applicable has already been determined by the source pay policy. */
		if (editStep === EDIT_STEPS.confirmDuplication || editStep === EDIT_STEPS.confirmEdit) {
			setEditStep(EDIT_STEPS.policySettings);
		}

		// If importing pay policies, go straight to the importer
		else if (
			editStep === EDIT_STEPS.policySettings &&
			policyCategory === POLICY_CATEGORIES.pay &&
			updatePolicyMode === UPDATE_POLICY_MODES.import)
		{
			goToImporter();
		}

		else {
			/* For annual salary pay policies only: If this is the policy settings step, and bands exist, the hourly rates on those
			   may need to be updated if contracted work times have changed. Do that here, regardless. */
			if (
				editStep === EDIT_STEPS.policySettings &&
				policyObj.policyCategory === POLICY_CATEGORIES.pay &&
				policyObj.PolicyPayBasis === POLICY_PAY_BASES.annualSalary
			) {
				policyService.setAllPayPolicyBandHourlyRates(policyObj);
			}

			// Move to the next step
			setEditStep(++editStep);
		}
	}

	function moveToPreviousStep (editStep) {
		setEditStep(--editStep);
	}

	function onBaseBandsOnLengthOfServiceChange (policyObj) {
		if (!policyObj.baseBandsOnLengthOfService) {
			// Valid option - 'none', though hidden
			policyObj.PolicyServiceEntitlement = POLICY_SERVICE_ENTITLEMENTS.none;
		}
		else {
			// Force entitlement selection
			delete(policyObj.PolicyServiceEntitlement);
		}
	}

	function onHasEffectiveDateChange (policyObj) {
		// Clear out effective date if option switched off
		if (!policyObj.hasEffectiveDate) {
			policyObj.PolicyEffectiveDateISO = '';
		}
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function onPolicyBandRateChange (policyObj, policyBandRate) {
		/* Ensure both PolicyBandRateTypeEmployer and PolicyBandRateTypeEmployee are set to this value.
		   Currently this only applies to pension policies.
		   https://www.notion.so/paycircle/Occupational-Policies-Pension-a34f440721494cefa8a7b75305292652 */
		policyObj.PolicyBandRateTypeEmployer = policyBandRate;
		policyObj.PolicyBandRateTypeEmployee = policyBandRate;
	}

	function refreshPolicyAfterUpdate (policyObj) {

		// For new policies, just show view state
		if (policyObj.PolicyID === config.guidEmpty) {
			setPageState(PAGE_STATES.view);
			return $q.when();
		}

		// For existing policies, fetch fresh data from server
		return policyService.getPolicy(agencyProfileId, policyObj.PolicyID).then(refreshedPolicy => {
			$scope.vm.policy = refreshedPolicy;
			setPageState(PAGE_STATES.view);
		})
		.catch(error => {
			console.error('Failed to refresh policy after update:', error);
			// Update succeeded but refresh failed - show success state with saved policy name
			$scope.vm.savedPolicyName = policyObj.PolicyName;
			setPageState(PAGE_STATES.saved);
		});
	}

	function setEditStep (editStep) {
		$scope.editStep = editStep;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;

		// Determine edit step based on update mode and policy type. Default to policy settings.
		let editStep = EDIT_STEPS.policySettings;
		if (pageState === PAGE_STATES.edit) {
			if (updatePolicyMode === UPDATE_POLICY_MODES.duplicate) {
				editStep = EDIT_STEPS.confirmDuplication;
			}
			else if ([UPDATE_POLICY_MODES.create, UPDATE_POLICY_MODES.import].includes(updatePolicyMode) && policyCategory === POLICY_CATEGORIES.pay) {
				// When creating a new pay policy, first the user has to select the policy basis
				editStep = EDIT_STEPS.selectPolicyPayBasis;
			}
			else if (updatePolicyMode === UPDATE_POLICY_MODES.edit && ([POLICY_CATEGORIES.sickness, POLICY_CATEGORIES.parental].includes(policyCategory))) {
				// Confirm edit for parental and sickness policies (those that may be in use for statutory pay schedules)
				editStep = EDIT_STEPS.confirmEdit;
			}
		}

		// Set edit step
		setEditStep(editStep);
	}

	function showPensionSchemesView (vmObj, pensionSchemesArr) {
		vmObj.policyPensionSchemes = bulkService.getBulkItemsObj(pensionSchemesArr);
		vmObj.isPensionSchemeViewActive = true;
	}

	function showTeamMembersView (vmObj, teamMembersArr) {
		vmObj.policyTeamMembers = bulkService.getBulkItemsObj(teamMembersArr);
		vmObj.isTeamMembersViewActive = true;
	}

	function updatePolicy (policyObj, form) {

		form.state = 'saving';

		policyService.updatePolicy(agencyProfileId, policyObj).then(() => {

			form.state = null;
			setPageState(PAGE_STATES.loading);
			
			// Refresh the individual policy from server first
			const refreshPolicy = refreshPolicyAfterUpdate(policyObj);

			// Refresh parent policies list
			$scope.formOptions.forceCallback();

			// After page loads, clear form state, show message, then refresh parent list
			refreshPolicy.then(() => {
				growl.success(`${utilities.toSentenceCase(policyCategory)} policy saved`);
			});
		})
		.catch(error => {
			onError(error);
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {

		config,
		policyService,
		regexService,
		utilities,

		EDIT_STEPS,
		PAGE_STATES,
		POLICY_BAND_CALCULATION_TYPES,
		POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS,
		POLICY_BAND_RATE_TYPES,
		POLICY_CATEGORIES,
		POLICY_NAME_EXISTS,
		POLICY_NAME_TYPE_REQUIRED,
		POLICY_CODE_EXISTS,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_PAY_BASES,
		POLICY_PENSION_STATES,
		POLICY_SERVICE_ENTITLEMENTS,
		POLICY_TYPES,
		POLICY_TYPE_NAMES,
		UPDATE_POLICY_MODES,

		editPolicy,
		hidePensionSchemesView,
		hideTeamMembersView,
		moveToNextStep,
		moveToPreviousStep,
		onBaseBandsOnLengthOfServiceChange,
		onHasEffectiveDateChange,
		onPolicyBandRateChange,
		showPensionSchemesView,
		showTeamMembersView,
		updatePolicy
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('viewPensionPolicyForm', function () {

	return {
		controller: 'viewPensionPolicyFormCtrl',
		templateUrl: 'forms/hr/viewPensionPolicyForm/viewPensionPolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('viewPensionPolicyFormCtrl', [
	'$scope',
	'policyService',
	'POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS',
	function (
		$scope,
		policyService,
		POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function init () {

		setPageState(PAGE_STATES.loading);

		// Get the policy
		const policyId = $scope.formOptions.policyId;
		policyService.getPolicy(agencyProfileId, policyId).then(policyObj => {
			$scope.vm = {
				agencyProfileId,
				policy: policyObj
			};
			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		PAGE_STATES,
		POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('cancelUserImportForm', function () {

	return {
		controller: 'cancelUserImportFormCtrl',
		templateUrl: 'forms/imports/cancel-user-import/cancelUserImportForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cancelUserImportFormCtrl', ['$scope', 'dataImport', 'payrollData', function ($scope, dataImport, payrollData) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			$scope.currentPayPeriod = currentPayPeriodObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.cancelImport = function (currentPayPeriod) {

		currentPayPeriod.state = 'saving';

		dataImport.cancelUserImport(currentPayPeriod.PayPeriodID).then(function () {

			$scope.formOptions.forceCallback();

			setPageState('success');

			currentPayPeriod.state = 'saved';
		})
		.catch(function () {

			setPageState('error');

			currentPayPeriod.state = null;
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteImportMappingForm', function () {

	return {
		controller: 'deleteImportMappingFormCtrl',
		templateUrl: 'forms/imports/delete-import-mapping/deleteImportMappingForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteImportMappingFormCtrl', ['$filter', '$scope', 'dataImport', function ($filter, $scope, dataImport) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const importMappingTemplate = $scope.formOptions.importMappingTemplate;

	function deleteImportMapping (importMappingTemplateObj, formObj) {
		
		formObj.state = 'saving';
		
		dataImport.deleteImportMappingForCompanySettings(agencyProfileId, importMappingTemplateObj.ImportMappingID).then(() => {
			
			$scope.formOptions.forceCallback();
			formObj.state = 'saved';
			setPageState('success');
		})
		.catch(onError);
	}

	function getMetaItemsForMappingType (importMappingTemplateObj) {

		return [
			{
				label: 'Import Type',
				value: $filter('importMappingTypeDescription')(importMappingTemplateObj.MappingType)
			},
			{
				label: 'Mapped headers',
				value: importMappingTemplateObj.HeaderCount
			}
		];
	}

	function init () {

		$scope.metaItems = getMetaItemsForMappingType(importMappingTemplate);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Variables
		importMappingTemplate,

		// Functions
		deleteImportMapping
	});

	setPageState('ready');
}]);

'use strict';

angular.module('paycircleApp')

.directive('editImportLayoutForm', function () {

	return {
		controller: 'editImportLayoutFormCtrl',
		templateUrl: 'forms/imports/edit-import-layout/editImportLayoutForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editImportLayoutFormCtrl', ['$scope', 'agency', function ($scope, agency) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		agency.getAgencyProfileImportOrientationVertical(agencyProfileId).then(vertical => {

			$scope.vm.vertical = vertical;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function updateImportLayout (vmObj, editImportLayoutForm) {

		editImportLayoutForm.state = 'saving';
		agency.updateCompanyImportOrientation(agencyProfileId, vmObj.vertical).then(() => {
			editImportLayoutForm.state = 'saved';
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		vm: {
			updateImportLayout
		}
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('editTeamImportsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'editTeamImportsFormCtrl',
	templateUrl: 'forms/imports/edit-team-imports/edit-team-imports.form.html'
})

.controller('editTeamImportsFormCtrl', [
	'agency',
	function (
		agency
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		agency.getAgencyProfileImportAutoComplete($ctrl.formOptions.agencyProfileId).then(isImportAutoComplete => {

			angular.extend($ctrl, {
				isImportAutoComplete
			});

			setFormState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
		console.error(error);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function updateTeamImports ($ctrl, editTeamImportsForm) {

		editTeamImportsForm.state = 'saving';

		agency.updateAgencyProfileImportAutoComplete($ctrl.formOptions.agencyProfileId, $ctrl.isImportAutoComplete).then(() => {

			editTeamImportsForm.state = 'saved';

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		updateTeamImports
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('importHistoryForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'importHistoryFormCtrl',
	templateUrl: 'forms/imports/import-history/import-history.form.html'
})

.controller('importHistoryFormCtrl', [
	'$q',
	'dataImport',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		dataImport,
		IMPORT_MAPPING_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		const INCLUDE_DELETED = false;
		const INCLUDE_TEAM_IMPORTS = true;
		const INCLUDE_PERIOD_IMPORTS = false;

		const getMainPayRunImportGroup = dataImport.getUserImportGroups(
			$ctrl.formOptions.agencyProfileId,
			$ctrl.formOptions.payPeriod.PayPeriodID,
			INCLUDE_DELETED,
			INCLUDE_TEAM_IMPORTS,
			INCLUDE_PERIOD_IMPORTS,
			IMPORT_MAPPING_TYPES.payslipManager
		);

		$q.all([getMainPayRunImportGroup])
			.then(([mainRunGroupsArr]) => {

				angular.extend($ctrl, {
					mainRunGroups: mainRunGroupsArr
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function deleteUserPayElementImportGroup ($ctrl, $form) {

		$form.state = 'saving';

		dataImport.deleteUserPayElementImportGroup($ctrl.groupToBeDeleted.UserImportGroupID)
			.then(() => {
				setComponentState('import-undone');
				$ctrl.formOptions.forceCallback();
			})
			.catch(onError);
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function onImportGroupUndo ($ctrl, importGroupObj) {

		$ctrl.groupToBeDeleted = importGroupObj;

		setComponentState('confirm-undo');
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		deleteUserPayElementImportGroup,
		onImportGroupUndo,
		setComponentState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('mappingTemplateForm', {
	controller: 'mappingTemplateFormCtrl',
	templateUrl: 'forms/imports/mapping-template/mapping-template.form.html',
	bindings: {
		formOptions: '='
	}
})

.controller('mappingTemplateFormCtrl', ['$filter', 'config', 'dataImport', 'growl', 'INTERFACE_TYPES', function ($filter, config, dataImport, growl, INTERFACE_TYPES) {

	const $ctrl = this;
	
	function $onInit () {

		setPageState('loading');

		// Decorate
		let importMappingTemplate = decorateImportMappingTemplate($ctrl.formOptions.importMappingTemplate, $ctrl.formOptions.actionType);

		angular.extend($ctrl, {
			actionType: $ctrl.formOptions.actionType,
			agencyDocumentId: $ctrl.formOptions.agencyDocumentId,
			columns: $ctrl.formOptions.fileColumns,
			importMappingTemplate,
			metaItems: getMetaItemsForMappingType(importMappingTemplate, $ctrl.formOptions.headerCount)
		});

		setPageState('ready');
	}

	function decorateImportMappingTemplate (importMappingTemplateObj, actionType) {

		// Empty name if creating a new mapping based on an existing mapping
		if (actionType === 'create') {
			importMappingTemplateObj.Name = '';
		}

		angular.extend(importMappingTemplateObj, {
			mappingTypeDescription: $filter('importMappingTypeDescription')(importMappingTemplateObj.MappingType)
		});

		return importMappingTemplateObj;
	}

	function getMetaItemsForMappingType (importMappingTemplateObj, headerCount) {

		return [
			{
				label: 'Import Type',
				value: importMappingTemplateObj.mappingTypeDescription
			},
			{
				label: 'Mapped headers',
				value: headerCount
			}
		];
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function reviewSaveMappingTemplate ($ctrl, formObj) {

		switch ($ctrl.actionType) {

			case 'update':
			case 'create': {			
				updateImportMappingTemplateWithColumns($ctrl, formObj);
				break;
			}
			case 'duplicate': {				
				updateImportMappingTemplate($ctrl, formObj);
				break;
			}
		}
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	function updateImportMappingTemplate ($ctrl, formObj) {

		formObj.state = 'saving';

		if ($ctrl.importMappingTemplate.IsDefault) {
			dataImport.updateImportMappingTemplateDefault($ctrl.formOptions.agencyProfileId, $ctrl.importMappingTemplate.ImportMappingID, $ctrl.importMappingTemplate.MappingType, false);
		}

		dataImport.updateImportMappingTemplate($ctrl.formOptions.agencyProfileId, $ctrl.importMappingTemplate.AgencyDocumentID, $ctrl.importMappingTemplate.ImportMappingID, $ctrl.importMappingTemplate.Name, $ctrl.importMappingTemplate.IsDefault).then(() => {
			
			$ctrl.formOptions.forceCallback({
				updatedMappingTemplate: $ctrl.importMappingTemplate
			});
			$ctrl.formOptions.closeForm();

			growl.success(`The mapping template ${$ctrl.importMappingTemplate.Name} has been saved`);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function updateImportMappingTemplateWithColumns ($ctrl, formObj) {

		formObj.state = 'saving';

		const UPDATE = $ctrl.actionType === 'update';

		dataImport.updateImportMappingTemplateWithColumns($ctrl.formOptions.agencyProfileId, $ctrl.agencyDocumentId, $ctrl.importMappingTemplate.Name, $ctrl.columns, $ctrl.importMappingTemplate.ImportMappingID, $ctrl.importMappingTemplate.IsDefault, UPDATE).then(() => {

			$ctrl.formOptions.forceCallback({
				updatedMappingTemplate: $ctrl.importMappingTemplate
			});
			$ctrl.formOptions.closeForm();

			growl.success(`The mapping template ${$ctrl.importMappingTemplate.Name} has been saved`);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		INTERFACE_TYPES,
		reviewSaveMappingTemplate
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('matchChangeTypeForm', function () {

	return {
		controller: 'matchChangeTypeFormCtrl',
		templateUrl: 'forms/imports/match-change-type/match-change-type.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('matchChangeTypeFormCtrl', [
	'$scope',
	'adjustmentsService',
	'utilities',
	'IMPORT_MAPPING_TYPES',
	'IMPORT_RATE_TYPES',
	function (
		$scope,
		adjustmentsService,
		utilities,
		IMPORT_MAPPING_TYPES,
		IMPORT_RATE_TYPES
	) {

	const ADJUSTMENT_TYPE_FILTER_KEYS = {
		additions: 'additions',
		deductions: 'deductions'
	};
	const SEARCH_TERM_MIN_COUNT = 3;
	const SEARCH_RESULTS_LIMIT = 20;
	const SEARCH_RESULTS_INCREMENT_COUNT = 20;

	var adjustmentLabel = $scope.formOptions.adjustmentLabel;
	var adjustmentLabelsArr = $scope.formOptions.adjustmentLabels;
	var adjustmentType = $scope.formOptions.adjustmentType;
	var adjustmentTypesArr = $scope.formOptions.adjustmentTypes;
	var importMappingType = $scope.formOptions.importMappingType;
	var isNetImport = angular.isDefined($scope.formOptions.isNetImport) ? $scope.formOptions.isNetImport : false;
	var payElementRateType = $scope.formOptions.payElementRateType;

	function changeAdjustmentTypeFilter (vmObj, filterKey) {

		vmObj.adjustmentTypesFilter = adjustmentsService.getAdjustmentsFilterByKey(filterKey);
		vmObj.adjustmentTypesFilterKey = filterKey;
	}

	function closeForm () {

		$scope.formOptions.forceCallback({
			responseState: 'cancel'
		});
		$scope.formOptions.closeForm();

	}

	function deselectAdjustmentType (vmObj) {

		vmObj.adjustmentTypeSelected = null;
	}

	function getAdjustmentLabel (vmObj) {

		if (vmObj.adjustmentLabelSelected !== '') {
			return vmObj.adjustmentLabelSelected;
		}

		if (vmObj.adjustmentLabelSearchTerm !== '') {
			return vmObj.adjustmentLabelSearchTerm;
		}

		return '';
	}

	function init () {

		const adjustmentTypesCountsObj = adjustmentsService.getAdjustmentTypesCounts(adjustmentTypesArr);
		const adjustmentTypesFilterKey = adjustmentTypesCountsObj.totalAdditions > 0 ? ADJUSTMENT_TYPE_FILTER_KEYS.additions : ADJUSTMENT_TYPE_FILTER_KEYS.deductions;

		setPageState('loading');

		adjustmentTypesArr = adjustmentsService.getAdjustmentTypesForImportMappingType(adjustmentTypesArr, importMappingType);

		// Add tooltips to adjustment types
		adjustmentTypesArr = adjustmentsService.decorateAdjustmentTypes(adjustmentTypesArr);

		$scope.vm = {

			// Labels
			adjustmentLabels: adjustmentLabelsArr,
			adjustmentLabelsFilter: null,
			adjustmentLabelsFiltered: [],
			adjustmentLabelSearchTerm: '',
			adjustmentLabelSelected: adjustmentLabel,

			// Adjustment Types
			adjustmentTypeSelected: adjustmentType,
			adjustmentTypes: adjustmentTypesArr,
			adjustmentTypesCount: adjustmentTypesCountsObj,
			adjustmentTypesFilter: adjustmentsService.getAdjustmentsFilterByKey(adjustmentTypesFilterKey),
			adjustmentTypesFilterKey: adjustmentTypesFilterKey,
			adjustmentTypesFiltered: [],
			adjustmentTypesSearchIsFocused: false,
			adjustmentTypesSearchTerm: '',

			// Net to gross
			isNetImport,
			// Rate type
			payElementRateType,

			showPayElementRateType: getShowPayElementRateType(importMappingType),
			showPayslipLabelResults: false,
		};

		angular.extend($scope, {
			ADJUSTMENT_TYPE_FILTER_KEYS,
			SEARCH_TERM_MIN_COUNT,
			SEARCH_RESULTS_LIMIT,
			SEARCH_RESULTS_INCREMENT_COUNT
		});

		setPageState('ready');

		utilities.focusOn('adjustmentTypesSearchTerm');
	}

	function resetAdjustmentLabel (vmObj) {

		vmObj.adjustmentLabelSelected = '';
		vmObj.adjustmentLabelSearchTerm = '';
	}

	function resetAdjustmentTypeSearchTerm () {

		$scope.vm.adjustmentTypesSearchTerm = '';
	}

	function getIsNetImport (vmObj) {

		// Always false if Net to Gross is not applicable
		if (!vmObj.adjustmentTypeSelected.AgencyAdjustmentNetToGross) {
			return false;
		}

		return vmObj.isNetImport;
	}

	function getShowPayElementRateType (importMappingType) {
		return importMappingType === IMPORT_MAPPING_TYPES.payElementsRatedUnitsHorizontal;
	}

	function saveForm (vmObj) {

		vmObj.adjustmentLabelSelected = getAdjustmentLabel(vmObj);

		// Map Label text onto adjustment type
		vmObj.adjustmentTypeSelected.AgencyAdjustmentValueLabel = vmObj.adjustmentLabelSelected;

		$scope.formOptions.forceCallback({
			responseState: 'update',
			adjustmentType: vmObj.adjustmentTypeSelected,
			adjustmentLabel: vmObj.adjustmentLabelSelected,
			isNetImport: getIsNetImport(vmObj),
			isPayElementNetable: vmObj.adjustmentTypeSelected.AgencyAdjustmentNetToGross,
			payElementRateType: vmObj.payElementRateType
		});
		$scope.formOptions.closeForm();
	}

	function selectAdjustmentLabel (vmObj, adjustmentLabelObj) {

		vmObj.adjustmentLabelSelected = adjustmentLabelObj.AgencyAdjustmentLabelText;
	}

	function selectAdjustmentType (vmObj, adjustmentTypeObj) {

		vmObj.adjustmentTypeSelected = adjustmentTypeObj;

		resetAdjustmentTypeSearchTerm();
	}

	function selectAdjustmentTypeFromAdjustmentLabel (vmObj, adjustmentLabelObj) {

		selectAdjustmentLabel(vmObj, adjustmentLabelObj);
		selectAdjustmentType(vmObj, adjustmentLabelObj.adjustmentType);

		resetAdjustmentTypeSearchTerm();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleSearchTermLabelsFocus (vmObj, newValue) {

		if (newValue !== undefined) {
			vmObj.searchTermAdjustmentLabelsFocused = newValue;
		}
		else {
			vmObj.searchTermAdjustmentLabelsFocused = !vmObj.searchTermAdjustmentLabelsFocused;
		}
	}

	function toggleShowPayslipLabelResults (vmObj, newValue) {

		if (newValue !== undefined) {
			vmObj.showPayslipLabelResults = newValue;
		}
		else {
			vmObj.showPayslipLabelResults = !vmObj.showPayslipLabelResults;
		}

	}

	init();

	angular.extend($scope, {
		changeAdjustmentTypeFilter,
		closeForm,
		deselectAdjustmentType,
		resetAdjustmentLabel,
		resetAdjustmentTypeSearchTerm,
		saveForm,
		selectAdjustmentType,
		selectAdjustmentTypeFromAdjustmentLabel,
		toggleSearchTermLabelsFocus,
		toggleShowPayslipLabelResults,

		IMPORT_RATE_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('matchLinkElementForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'matchLinkElementFormCtrl',
	templateUrl: 'forms/imports/match-link-element/match-link-element.form.html',
})

.controller('matchLinkElementFormCtrl', ['$filter', '$rootScope', 'payrollData', function ($filter, $rootScope, payrollData) {

	const $ctrl = this;

	function $onInit () {

		$ctrl.linkElement = null;

		switch ($ctrl.formOptions.layoutType) {

			// Uses mapping headers array
			case 'vertical':

				$ctrl.filteredMappingHeaders = $ctrl.formOptions.mappingHeaders.filter(filterUnusedMappingHeaders);

				setComponentState($ctrl.filteredMappingHeaders.length === 0 ? 'no-link-elements' : 'ready');

				break;

			// Uses link elements array
			case 'horizontal':

				setComponentState($ctrl.formOptions.linkElements.length === 0 ? 'no-link-elements' : 'ready');

				break;
		}
	}

	function filterUnusedMappingHeaders (mappingHeaderObj) {

		return !mappingHeaderObj.isInUse;
	}

	function matchLinkElement ($ctrl) {

		$ctrl.formOptions.forceCallback({
			linkElement: $ctrl.linkElement
		});
		$ctrl.formOptions.closeForm();
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function openLinkElementForm () {

		payrollData.getLinkElements($ctrl.formOptions.agencyProfileId).then(linkElementDetailsObj => {

			$ctrl.formOptions.openNewSlideInForm({
				agencyProfileId: $ctrl.formOptions.agencyProfileId,
				callback: $ctrl.formOptions.callback,
				formKey: 'link-element',
				linkElementGroupId: linkElementDetailsObj.LinkElementGroupID,
				adjustmentTypesContextKey: 'link-element-imports'
			});
		})
		.catch(onError);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		matchLinkElement,
		openLinkElementForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('matchPayslipLabelForm', function () {

	return {
		controller: 'matchPayslipLabelFormCtrl',
		templateUrl: 'forms/imports/match-payslip-label/matchPayslipLabelForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('matchPayslipLabelFormCtrl', ['$scope', 'utilities', function ($scope, utilities) {

	const adjustmentLabel = angular.isDefined($scope.formOptions.adjustmentLabel) ? $scope.formOptions.adjustmentLabel : '';

	function init () {

		const SELECT_ALL = true;

		$scope.vm = {
			adjustmentLabel: adjustmentLabel
		};

		utilities.focusOn('newAdjustmentLabel', SELECT_ALL);
	}

	function matchPayslipLabel (vmObj) {

		$scope.formOptions.forceCallback({
			adjustmentLabel: vmObj.adjustmentLabel
		});
		$scope.formOptions.closeForm();
	}

	init();

	angular.extend($scope, {
		matchPayslipLabel
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('matchPolicyDetailsForm', function () {

	return {
		controller: 'matchPolicyDetailsFormCtrl',
		templateUrl: 'forms/imports/match-policy-details/match-policy-details.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('matchPolicyDetailsFormCtrl', [
	'$q',
	'$scope',
	'companyData',
	'config',
	'payrollData',
	'policyService',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_PENSION_STATES',
	'POLICY_TYPES',
	function (
		$q,
		$scope,
		companyData,
		config,
		payrollData,
		policyService,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_PENSION_STATES,
		POLICY_TYPES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function closeForm () {

		// If the policy can't be updated (locked/pending update/future changes),
		// send 'skip' so the parent controller can mark it as handled and exclude it from the import.
		const responseState = ($scope.vm && !$scope.vm.canUpdate) ? 'skip' : 'cancel';

		$scope.formOptions.forceCallback({
			responseState: responseState
		});
		$scope.formOptions.closeForm();
	}

	function init () {

		setPageState('loading');

		const policyName = $scope.formOptions.policyName;

		// Company and pay period are loaded by the form cabinet (via agencyProfileId + isPayPeriodMinimumRequired)
		const company = $scope.formOptions.company;
		const currentPayPeriod = $scope.formOptions.currentPayPeriod;

		// Fetch existing pay policies and create a new pay policy to get company default contracted times.
		// This reuses the same approach as the Add pay policy form (updatePolicyForm), where policyService.createPolicy
		// populates PolicyHoursPerWeek and PolicyWeeksPerYear from the company work pattern settings.
		const getPolicies = companyData.getPolicies(agencyProfileId, POLICY_TYPES.pay, true);
		const getNewPolicy = policyService.createPolicy(POLICY_CATEGORIES.pay, company);

		$q.all([getPolicies, getNewPolicy]).then(function (results) {

			const policiesArr = results[0];
			const newPolicyDefaults = results[1];

			// Find matching existing policy (case-insensitive)
			const existingPolicy = policiesArr.find(function (p) {
				return p.PolicyName.toLowerCase().trim() === policyName.toLowerCase().trim();
			});

			const isExistingPolicy = !!existingPolicy;
			const isLocked = isExistingPolicy && existingPolicy.IsPolicyRestricted;
			const hasPendingUpdate = isExistingPolicy && existingPolicy.UpdatePolicyID !== config.guidEmpty;

			// Existing policy (update): use the policy's own contracted times, same as addPayPolicyUpdateForm.
			// New policy (create): use company defaults from policyService.createPolicy, same as updatePolicyForm.
			const defaultHoursPerWeek = (isExistingPolicy && existingPolicy.PolicyHoursPerWeek > 0) ? existingPolicy.PolicyHoursPerWeek : newPolicyDefaults.PolicyHoursPerWeek;
			const defaultWeeksPerYear = (isExistingPolicy && existingPolicy.PolicyWeeksPerYear > 0) ? existingPolicy.PolicyWeeksPerYear : newPolicyDefaults.PolicyWeeksPerYear;

			// Check for future salary changes if this is an existing policy
			const getFutureChanges = isExistingPolicy ? payrollData.getSalaryFutureChangesForPolicy(agencyProfileId, existingPolicy.PolicyID) : $q.when([]);

			getFutureChanges.then(function (futureChanges) {

				const hasFutureChanges = angular.isDefined(futureChanges) && angular.isArray(futureChanges) && futureChanges.length > 0;
				// A locked policy (being used/paid) can still be updated via import —
				// only a pending update or future salary changes should block the import.
				const canUpdate = !hasPendingUpdate && !hasFutureChanges;

				// Default pensionState: 'Yes' (active) to match the Add pay policy form behaviour.
				// When re-opening the flyout, restore the previously selected pension state from formOptions.
				const defaultPensionState = ($scope.formOptions.pensionState != null) ? $scope.formOptions.pensionState : POLICY_PENSION_STATES.active;

				// For existing policies, pre-populate and lock policy type from the existing policy.
				// This prevents type mismatch — the user cannot change the type of an existing policy.
				const defaultPayBasis = isExistingPolicy ? existingPolicy.PolicyPayBasis : ($scope.formOptions.policyPayBasis || null);

				$scope.vm = {
					policyName: policyName,
					policyPayBasis: $scope.formOptions.policyPayBasis || defaultPayBasis,
					effectiveDateISO: $scope.formOptions.effectiveDateISO || '',
					hoursPerWeek: angular.isNumber($scope.formOptions.hoursPerWeek) ? $scope.formOptions.hoursPerWeek : defaultHoursPerWeek,
					weeksPerYear: angular.isNumber($scope.formOptions.weeksPerYear) ? $scope.formOptions.weeksPerYear : defaultWeeksPerYear,
					pensionState: defaultPensionState,
					isExistingPolicy: isExistingPolicy,
					isLocked: isLocked,
					hasPendingUpdate: hasPendingUpdate,
					hasFutureChanges: hasFutureChanges,
					canUpdate: canUpdate,
					currentPayPeriod: currentPayPeriod
				};

				setPageState('ready');
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function saveForm (vmObj) {

		$scope.formOptions.forceCallback({
			responseState: 'update',
			policyPayBasis: vmObj.policyPayBasis,
			effectiveDateISO: vmObj.effectiveDateISO,
			hoursPerWeek: vmObj.hoursPerWeek,
			weeksPerYear: vmObj.weeksPerYear,
			isPensionable: vmObj.pensionState === POLICY_PENSION_STATES.active,
			pensionState: vmObj.pensionState,
			isExistingPolicy: vmObj.isExistingPolicy,
			isPolicyRestricted: vmObj.isLocked
		});
		$scope.formOptions.closeForm();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	// Wait for form cabinet to finish loading company and pay period data before initialising
	$scope.$watch('formOptions.contextDataLoaded', function (isLoaded) {

		if (isLoaded) {
			init();
		}
	});

	angular.extend($scope, {
		closeForm,
		config,
		saveForm,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_PENSION_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('payElementNetToGrossForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'payElementNetToGrossFormCtrl',
	templateUrl: 'forms/imports/pay-element-net-to-gross/pay-element-net-to-gross.form.html'
})

.controller('payElementNetToGrossFormCtrl', [function () {

	const $ctrl = this;

	function $onInit () {

		// Make sure fileColumn object is available
		if (angular.isUndefined($ctrl.formOptions.fileColumn)) {
			console.error('fileColumnObj is required');
			setComponentState('error');
			return;
		}

		// Make sure mappingHeader object has been attached to fileColumn for reference
		if (angular.isUndefined($ctrl.formOptions.fileColumn.mappingHeader)) {
			console.error('mappingHeaderObj is required');
			setComponentState('error');
			return;
		}

		angular.extend($ctrl, {
			isNetImport: $ctrl.formOptions.fileColumn.AgencyAdjustmentNetToGross
		});

		setComponentState('ready');
	}

	function updateNetToGrossEnabled () {

		$ctrl.formOptions.forceCallback({
			isNetImport: $ctrl.isNetImport
		});
		$ctrl.formOptions.closeForm();
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		updateNetToGrossEnabled
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('payElementRateTypeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'payElementRateTypeFormCtrl',
	templateUrl: 'forms/imports/pay-element-rate-type/pay-element-rate-type.form.html'
})

.controller('payElementRateTypeFormCtrl', [
	'IMPORT_RATE_TYPES',
	function (
		IMPORT_RATE_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		// Make sure fileColumn object is available
		if (angular.isUndefined($ctrl.formOptions.fileColumn)) {
			console.error('fileColumnObj is required');
			setFormState('error');
			return;
		}

		// Make sure mappingHeader object has been attached to fileColumn for reference
		if (angular.isUndefined($ctrl.formOptions.fileColumn.mappingHeader)) {
			console.error('mappingHeaderObj is required');
			setFormState('error');
			return;
		}

		angular.extend($ctrl, {
			payElementRateType: $ctrl.formOptions.fileColumn.AgencyAdjustmentRateType
		});

		setFormState('ready');
	}

	function updatePayElementRateType () {

		$ctrl.formOptions.forceCallback({
			payElementRateType: $ctrl.payElementRateType
		});

		$ctrl.formOptions.closeForm();
	}

	function setFormState (componentState) {
		$ctrl.formState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		IMPORT_RATE_TYPES,
		updatePayElementRateType
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('payElementMatchingForm', function () {

	return {
		controller: 'payElementMatchingFormCtrl',
		controllerAs: '$ctrl',
		templateUrl: 'forms/imports/pay-element-matching-form/pay-element-matching-form.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('payElementMatchingFormCtrl', [
	'$scope',
	'config',
	'utilities',
	'VALIDATION_TYPES',
	function (
		$scope,
		config,
		utilities,
		VALIDATION_TYPES
	) {

	const $ctrl = this;

	function init () {
		setFormState('loading');
		
		let validationResult = $scope.formOptions.validationResult;
		let matchedPayElements = [];
		// Parse ValidationResultImportValue to extract matched pay elements
		if (validationResult && validationResult.ValidationResultImportValue) {
			try {
				let ValidationResultImportValue = angular.isString(validationResult.ValidationResultImportValue) ?
					JSON.parse(validationResult.ValidationResultImportValue) :
					validationResult.ValidationResultImportValue;
				if (ValidationResultImportValue && angular.isArray(ValidationResultImportValue)) {
					matchedPayElements = ValidationResultImportValue;
				} else if (ValidationResultImportValue) {
					matchedPayElements = [ValidationResultImportValue];
				}
			} catch (e) {
				onError(e);
			}
		}

		let validationType = validationResult && validationResult.ValidationType ?
			validationResult.ValidationType.ValidationTypeID :
			null;

		let isMultipleMatches = validationType === VALIDATION_TYPES.payElementHasMultipleMatches;
		let isSingleMatch = validationType === VALIDATION_TYPES.payElementWillBeUpdated;

		$ctrl.vm = {
			matchedPayElements: matchedPayElements,
			selectedPayElement: matchedPayElements.length === 1 ? matchedPayElements[0] : null,
			createAsNew: false,
			isMultipleMatches: isMultipleMatches,
			isSingleMatch: isSingleMatch,
			validationType: validationType,
			importValue: validationResult ? validationResult.ValidationResultImportValue : '',
			validationTypeID: $scope.formOptions.validationResult.ValidationResultTypeID
		};

		setFormState('ready');

		if (isMultipleMatches) {
			utilities.focusOn('payElementSelect');
		}
	}

	function selectPayElement (vmObj, payElement) {

		vmObj.selectedPayElement = payElement;		
		vmObj.validationTypeID = VALIDATION_TYPES.payElementWillBeUpdated;
		vmObj.createAsNew = false;
	}

	function selectToUpdated (vmObj, payElement) {

		vmObj.selectedPayElement = payElement;
		vmObj.validationTypeID = VALIDATION_TYPES.payElementWillBeUpdated;
	}

	function setCreateAsNew (vmObj) {

		vmObj.selectedPayElement = null;
		vmObj.createAsNew = true;
		vmObj.validationTypeID = VALIDATION_TYPES.payElementWillBeCreated;
	}

	function submitForm (vmObj) {

		let resolution = {
			IsResolved: true,
			SelectedPayElementId: vmObj.selectedPayElement ? vmObj.selectedPayElement.UserPayElementID : config.guidEmpty,
			SelectedElementRecurringID: vmObj.selectedPayElement ? vmObj.selectedPayElement.UserPayElementRecurringID : config.guidEmpty,
			CreateAsNew: vmObj.createAsNew,
			SkipRow: false
		};

		let validationResult = angular.copy($scope.formOptions.validationResult);
		validationResult.ValidationResultTypeID = vmObj.validationTypeID;
		validationResult.ValidationType.ValidationTypeID = vmObj.validationTypeID;
		
		$scope.formOptions.forceCallback({
			callbackAction: 'pay-element-match-resolution',
			resolution: resolution,
			rowObj: $scope.formOptions.rowObj,
			validationResult: validationResult
		});
		$scope.formOptions.closeForm();
	}

	function skipRow () {

		let resolution = {
			IsResolved: true,
			SelectedPayElementId: null,
			SelectedElementRecurringID: null,
			CreateAsNew: false,
			SkipRow: true
		};

		$scope.formOptions.forceCallback({
			callbackAction: 'pay-element-match-resolution',
			resolution: resolution,
			rowObj: $scope.formOptions.rowObj,
			validationResult: $scope.formOptions.validationResult
		});
		$scope.formOptions.closeForm();
	}

	function closeForm () {

		$scope.formOptions.closeForm();
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function isFormValid (vmObj) {

		return vmObj.selectedPayElement !== null || vmObj.createAsNew;
	}

	init();

	angular.extend($ctrl, {
		closeForm,
		isFormValid,
		selectPayElement,
		selectToUpdated,
		setCreateAsNew,
		skipRow,
		submitForm,
		VALIDATION_TYPES,
		rowObj: $scope.formOptions.rowObj
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('undoImportForm', function () {

	return {
		controller: 'undoImportFormCtrl',
		templateUrl: 'forms/imports/undo-import/undoImportForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('undoImportFormCtrl', ['$scope', 'companyData', 'dataImport', 'payrollData', function ($scope, companyData, dataImport, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {

		// Page state
		$scope.pageState = 'loading';

		payrollData.getPayPeriodCurrent(agencyProfileId).then(function (currentPayPeriodObj) {

			// Scope
			$scope.currentPayPeriod = currentPayPeriodObj;

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();

	$scope.undoImport = function (payPeriod) {

		// Update state
		payPeriod.state = 'saving';

		// Service call
		dataImport.undoImport(payPeriod.PayPeriodID).then(function () {

			// Force callback
			$scope.formOptions.forceCallback();

			// Page state
			$scope.pageState = 'success';

			// Update state
			payPeriod.state = 'saved';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';

			// Form state
			payPeriod.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.component('undoImportCompanyDataForm', {
	controller: 'undoImportCompanyDataFormCtrl',
	templateUrl: 'forms/imports/undo-import-company-data/undo-import-company-data.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('undoImportCompanyDataFormCtrl', [
	'dataImport',
	'user',
	'IMPORT_MAPPING_TYPES',
	function (
		dataImport,
		user,
		IMPORT_MAPPING_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const userImportGroupObj = $ctrl.formOptions.userImportGroupObj;

		if (userImportGroupObj.ImportType === IMPORT_MAPPING_TYPES.businessCategories ||
			userImportGroupObj.ImportType === IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories) {
			
			user.assessCanUndoBusinessCodeImport(agencyProfileId, userImportGroupObj.UserImportGroupID).then(canUndoImport => {
				
				if (canUndoImport) {
					setComponentState('ready');
				} else {
					setComponentState('cannot-undo-business-code-import');
				}
			})
			.catch(onError);
		} else {
			setComponentState('ready');
		}
	}

	function deleteUserImportGroup (userImportGroupObj, formObj) {

		formObj.state = 'saving';

		dataImport.deleteUserImportGroup(userImportGroupObj.UserImportGroupID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(error => {
			formObj.state = null;
			onError(error);
		});
	}

	function onError (error) {
		
		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		deleteUserImportGroup,
		IMPORT_MAPPING_TYPES
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('undoImportPayElementForm', {
	controller: 'undoImportPayElementFormCtrl',
	templateUrl: 'forms/imports/undo-import-pay-element/undo-import-pay-element.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('undoImportPayElementFormCtrl', ['dataImport', function (dataImport) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('ready');
	}

	function deleteUserPayElementImportGroup (userImportGroupObj, formObj) {

		formObj.state = 'saving';

		dataImport.deleteUserPayElementImportGroup(userImportGroupObj.UserImportGroupID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(error => {
			setComponentState('error');
			formObj.state = null;
			console.error(error);
		});
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		deleteUserPayElementImportGroup
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('undoImportPayPolicyForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'undoImportPayPolicyFormCtrl',
	templateUrl: 'forms/imports/undo-import-pay-policy/undo-import-pay-policy.form.html'
})

.controller('undoImportPayPolicyFormCtrl', [
	'dataImport',
	'IMPORT_MAPPING_TYPES',
	function (
		dataImport,
		IMPORT_MAPPING_TYPES
	) {

	const $ctrl = this;

	const IMPORT_ACTIONS = {
		created: 0,
		editedInPlace: 1,
		pendingVersionCreated: 2
	};

	function $onInit () {

		setComponentState('loading');

		dataImport.getPayPolicyImportUndoPreview($ctrl.formOptions.userImportGroupObj.UserImportGroupID).then(function (previewDetails) {

			const blockedDetails = previewDetails.filter(function (detail) {
				return detail.CannotUndoReason && detail.CannotUndoReason.length > 0;
			});

			$ctrl.previewDetails = previewDetails;
			$ctrl.blockedDetails = blockedDetails;
			$ctrl.canUndoAll = blockedDetails.length === 0 && previewDetails.length > 0;

			setComponentState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setComponentState('error');
		});
	}

	function getImportActionDescription (importAction) {

		switch (importAction) {
			case IMPORT_ACTIONS.created:
				return 'Created';
			case IMPORT_ACTIONS.editedInPlace:
				return 'Edited';
			case IMPORT_ACTIONS.pendingVersionCreated:
				return 'Pending update created';
			default:
				return 'Unknown';
		}
	}

	function resetPayPolicyImportGroup (userImportGroupObj, formObj) {

		formObj.state = 'saving';

		setComponentState('undoing');

		dataImport.resetUserImportGroup($ctrl.formOptions.agencyProfileId, userImportGroupObj.UserImportGroupID, IMPORT_MAPPING_TYPES.policyImport).then(function () {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(function (error) {
			setComponentState('error');
			formObj.state = null;
			console.error(error);
		});
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		getImportActionDescription,
		IMPORT_ACTIONS,
		resetPayPolicyImportGroup
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('undoImportPostsPayPoliciesForm', {
	controller: 'undoImportPostsPayPoliciesFormCtrl',
	templateUrl: 'forms/imports/undo-import-posts-pay-policies/undo-import-posts-pay-policies.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('undoImportPostsPayPoliciesFormCtrl', [
	'$q',
	'dataImport',
	function (
		$q,
		dataImport
	) {

	const $ctrl = this;

	function resetUserImportGroup (userImportGroupObj, formObj) {

		formObj.state = 'saving';

		setComponentState('undoing');

		const undoImportService = dataImport.resetUserImportGroup($ctrl.formOptions.agencyProfileId, userImportGroupObj.UserImportGroupID, userImportGroupObj.ImportType);

		$q.all([undoImportService])
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(error => {
				setComponentState('error');
				formObj.state = null;
				console.error(error);
			});
	}

	function init () {

		setComponentState('ready');
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	init();

	angular.extend($ctrl, {
		resetUserImportGroup
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('undoImportTeamForm', {
	controller: 'undoImportTeamFormCtrl',
	templateUrl: 'forms/imports/undo-import-team/undo-import-team.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('undoImportTeamFormCtrl', [
	'$q',
	'dataImport',
	'IMPORT_MAPPING_TYPES',
	function (
		$q,
		dataImport,
		IMPORT_MAPPING_TYPES
	) {

	const $ctrl = this;

	function resetUserImportGroup (userImportGroupObj, formObj) {

		formObj.state = 'saving';

		setComponentState('undoing');

		const undoImportService = $ctrl.formOptions.isPeriodImport ?
									dataImport.deleteUserImportGroup(userImportGroupObj.UserImportGroupID) :
									dataImport.resetUserImportGroup($ctrl.formOptions.agencyProfileId, userImportGroupObj.UserImportGroupID, userImportGroupObj.ImportType);

		$q.all([undoImportService])
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(error => {
				setComponentState('error');
				formObj.state = null;
				console.error(error);
			});
	}

	function init () {

		setComponentState('ready');
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	init();

	angular.extend($ctrl, {
		IMPORT_MAPPING_TYPES,
		resetUserImportGroup
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('uploadToImporterForm', function () {

	return {
		controller: 'uploadToImporterFormCtrl',
		templateUrl: 'forms/imports/upload-to-importer/uploadToImporterForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('uploadToImporterFormCtrl', ['$scope', 'messageData', 'payrollData', 'SUBMISSION_STATES', function ($scope, messageData, payrollData, SUBMISSION_STATES) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const agencyPayPeriodId = $scope.formOptions.agencyPayPeriodId;

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodSpecific(agencyPayPeriodId).then(currentPeriodObj => {

			setPageState(currentPeriodObj.PayrollState === SUBMISSION_STATES.submitted ? 'unable-to-import' : 'ready');
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
		});
	}

	function messageDocumentTransfer (fileObj, formObj) {

		formObj.state = 'saving';

		messageData.messageDocumentTransfer(agencyProfileId, agencyPayPeriodId, fileObj.AgencyDocumentID).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.messageDocumentTransfer = function (fileObj, formObj) {

		messageDocumentTransfer(fileObj, formObj);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('updatePayelementValidationResultForm', function () {

	return {
		controller: 'updatePayelementValidationResultFormCtrl',
		templateUrl: 'forms/imports/update-payelement-validation-result/update-payelement-validation-result.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('updatePayelementValidationResultFormCtrl', [
	'$scope',
	'utilities',
	function (
		$scope,
		utilities
	) {

	function init () {

		const SELECT_ALL = true;

		utilities.focusOn('payElementValidationResult', SELECT_ALL);
	}

	function updatePayElementValidationResultValue (formOptions) {

		$scope.formOptions.forceCallback({
			callbackAction: 'update-payelement-validation-result',
			rowObj: formOptions.rowObj,
			validationResult: formOptions.validationResult
		});
		$scope.formOptions.closeForm();
	}

	init();

	angular.extend($scope, {
		updatePayElementValidationResultValue
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('updateValidationResultForm', function () {

	return {
		controller: 'updateValidationResultFormCtrl',
		templateUrl: 'forms/imports/update-validation-result/update-validation-result.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('updateValidationResultFormCtrl', [
	'$scope',
	'utilities',
	function (
		$scope,
		utilities
	) {

	function init () {

		const SELECT_ALL = true;

		utilities.focusOn('validationResult', SELECT_ALL);
	}

	function updateValidationResultValue (formOptions) {

		$scope.formOptions.forceCallback({
			callbackAction: 'update-validation-result',
			rowObj: formOptions.rowObj,
			validationResult: formOptions.validationResult
		});
		$scope.formOptions.closeForm();
	}

	init();

	angular.extend($scope, {
		updateValidationResultValue
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('validateDataForm', function () {

	return {
		controller: 'validateDataFormCtrl',
		templateUrl: 'forms/imports/validate-data/validateDataForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('validateDataFormCtrl', [
	'$scope',
	'teamData',
	'VALIDATION_TYPES',
	function (
		$scope,
		teamData,
		VALIDATION_TYPES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const rowObj = $scope.formOptions.rowObj;

	function init () {

		if (!angular.isDefined(rowObj.validationResult)) {
			initUserDoesNotExist();
			return;
		}

		switch (rowObj.validationResult.ValidationType.ValidationTypeID) {

			// Unable to match user
			case VALIDATION_TYPES.userDoesNotExist:
				initUserDoesNotExist();
				break;

			case VALIDATION_TYPES.dobInWrongFormat:
				setPageState();
				break;

			case VALIDATION_TYPES.userWithSubmissionIDAlreadyExists:
				setPageState('submission-id-in-use');
				break;

			case VALIDATION_TYPES.userSubmissionIDLockedAfterPayroll:
				setPageState('submission-id-locked');
				break;

			case VALIDATION_TYPES.userWithPayrollIDAlreadyExists:
				setPageState('payroll-id-in-use');
				break;

			case VALIDATION_TYPES.userWithNINumberAlreadyExists:
				setPageState('ni-number-in-use');
				break;

			case VALIDATION_TYPES.userWithNINumberAlreadyExistsInPaycircle:
				setPageState('ni-number-in-use-paycircle');
				break;

			case VALIDATION_TYPES.userWithNINumberAlreadyExistsOnPayeScheme:
				setPageState('ni-number-in-use-on-paye-scheme');
				break;

			default:
				setPageState('unknown-validation-type');
		}
	}

	function initUserDoesNotExist () {

		const INCLUDE_INCOMPLETE = true;
		const INCLUDE_LEAVERS = true;
		const IGNORE_FUTURE_STARTERS = false;

		let IGNORE_ADMINS; // undefined -> Use system default

		setPageState('loading');

		teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(agencyProfileId, INCLUDE_LEAVERS, IGNORE_FUTURE_STARTERS, IGNORE_ADMINS, INCLUDE_INCOMPLETE).then((teamMembersArr) => {

			$scope.vm = {
				teamMembers: teamMembersArr,
				selectedTeamMember: null
			};

			if (!teamMembersArr.length) {
				setPageState('no-team-members');
			}
			else {
				setPageState('ready');
			}
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function matchTeamMember (vmObj) {

		$scope.formOptions.closeForm();
		$scope.formOptions.forceCallback({
			callbackAction: 'update-user-id',
			rowOriginalIndex: rowObj.originalIndex,
			userObj: vmObj.selectedTeamMember
		});
	}

	function restartImport () {

		$scope.formOptions.closeForm();
		$scope.formOptions.forceCallback({
			callbackAction: 'restart'
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		matchTeamMember,
		restartImport
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeAuthoriseNestForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeAuthoriseNestFormCtrl',
	templateUrl: 'forms/pension/scheme/authorise-nest/pension-scheme-authorise-nest.form.html'
})

.controller('pensionSchemeAuthoriseNestFormCtrl', ['pensionData', 'NEST_AUTHORISATION_RESPONSES',
	function (pensionData, NEST_AUTHORISATION_RESPONSES) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		angular.extend($ctrl, {
			password: '',
			passwordInputType: 'password',
			username: ''
		});

		setPageState('ready');
	}

	function authoriseNestPension ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.getAreNestCredentialsValid($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyEmployerPensionId, $ctrl.username, $ctrl.password)
			.then(response => {

				setPageState(getPageStateFromNestResponse(response));

				if (response === NEST_AUTHORISATION_RESPONSES.successful) {
					$ctrl.formOptions.forceCallback();
				}

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function getPageStateFromNestResponse (response) {

		switch (response) {
			case NEST_AUTHORISATION_RESPONSES.generalError:
				return 'general-error';
			case NEST_AUTHORISATION_RESPONSES.invalidCredentials:
				return 'invalid-credentials';
			case NEST_AUTHORISATION_RESPONSES.noAccess:
				return 'no-access';
			case NEST_AUTHORISATION_RESPONSES.accountLocked:
				return 'account-locked';
			case NEST_AUTHORISATION_RESPONSES.successful:
				return 'success';
			case NEST_AUTHORISATION_RESPONSES.invalidEmployerReference:
				return 'invalid-employer-reference';
		}
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function togglePasswordInputType ($ctrl) {
		$ctrl.passwordInputType = $ctrl.passwordInputType === 'text' ? 'password' : 'text';
	}

	angular.extend($ctrl, {
		$onInit,

		authoriseNestPension,
		setPageState,
		togglePasswordInputType
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeAuthorisePeoplesPensionForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeAuthorisePeoplesPensionFormCtrl',
	templateUrl: 'forms/pension/scheme/authorise-peoples-pension/pension-scheme-authorise-peoples-pension.form.html'
})

.controller('pensionSchemeAuthorisePeoplesPensionFormCtrl', ['pensionData', 'SMART_PENSION_ROLES',
	function (pensionData, SMART_PENSION_ROLES) {

	const PAGE_STATES = {
		awaitingAuthorisation: 'awaiting-authorisation',
		connectError: 'connect-error',
		error: 'error',
		loading: 'loading',
		ready: 'ready',
		success: 'success'
	};

	const $ctrl = this;

	function $onInit () {
		setPageState(PAGE_STATES.ready);
	}

	function authorisePeoplesPension ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.getPeoplesPensionAuthoriseURI($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyEmployerPensionId)
			.then(redirectUrl => {

				if (!redirectUrl) {
					setPageState(PAGE_STATES.connectError);
					return;
				}

				window.open(redirectUrl, '_blank');

				setPageState(PAGE_STATES.awaitingAuthorisation);

				formObj.state = null;
			})
			.catch(onError);
	}

	function closeForm () {
		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		PAGE_STATES,
		SMART_PENSION_ROLES,

		authorisePeoplesPension,
		closeForm,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeAuthoriseSmartForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeAuthoriseSmartFormCtrl',
	templateUrl: 'forms/pension/scheme/authorise-smart/pension-scheme-authorise-smart.form.html'
})

.controller('pensionSchemeAuthoriseSmartFormCtrl', ['pensionData', 'SMART_PENSION_ROLES',
	function (pensionData, SMART_PENSION_ROLES) {

	const PAGE_STATES = {
		awaitingAuthorisation: 'awaiting-authorisation',
		connectError: 'connect-error',
		error: 'error',
		loading: 'loading',
		ready: 'ready',
		success: 'success'
	};

	const $ctrl = this;

	function $onInit () {

		setPageState(PAGE_STATES.loading);

		angular.extend($ctrl, {
			smartRoleType: SMART_PENSION_ROLES.employer
		});

		setPageState(PAGE_STATES.ready);
	}

	function authoriseSmartPension ($ctrl, form) {

		form.state = 'saving';

		pensionData.getSmartPensionAuthoriseURI($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyEmployerPensionId, $ctrl.smartRoleType)
			.then(redirectUrl => {

				if (!redirectUrl) {
					setPageState(PAGE_STATES.connectError);
					return;
				}

				window.open(redirectUrl, '_blank');

				setPageState(PAGE_STATES.awaitingAuthorisation);

				form.state = null;
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		PAGE_STATES,
		SMART_PENSION_ROLES,

		authoriseSmartPension,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeAutomationForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeAutomationFormCtrl',
	templateUrl: 'forms/pension/scheme/automation/pension-scheme-automation.form.html'
})

.controller('pensionSchemeAutomationFormCtrl', [
	'$q',
	'growl',
	'pensionData',
	'PENSION_PROVIDER_IDS',
	'PENSION_SUBMISSION_STATES',
	function (
		$q,
		growl,
		pensionData,
		PENSION_PROVIDER_IDS,
		PENSION_SUBMISSION_STATES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		const getAgencyEmployerPensionDetails = pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId);
		const getAgencyEmployerPensionSummary = pensionData.getAgencyEmployerPensionSummary(agencyProfileId, agencyEmployerPensionId);

		$q.all([getAgencyEmployerPensionDetails, getAgencyEmployerPensionSummary])
			.then(([pensionDetailsObj, pensionSummaryObj]) => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					connectToProviderOriginal: pensionDetailsObj.PensionAutomationDetails.ConnectToProvider,
					isReferenceValid: true,
					pensionOriginal: angular.copy(pensionDetailsObj),
					pensionSummary: pensionSummaryObj,
					pension: pensionDetailsObj		
				});

				setPageState('ready');		
			})
			.catch(onError);
	}

	function onAssessTeamChange (pensionObj) {
		if (!pensionObj.PensionAutomationDetails.AssessTeam) {
			pensionObj.PensionAutomationDetails.ConnectToProvider = false;
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function reviewConfirmation ($ctrl, formObj) {

		const hasConnectToProviderBeenSwitchedOn = !$ctrl.pensionOriginal.PensionAutomationDetails.ConnectToProvider && $ctrl.pension.PensionAutomationDetails.ConnectToProvider;
		const hasConnectToProviderBeenSwitchedOff = $ctrl.pensionOriginal.PensionAutomationDetails.ConnectToProvider && !$ctrl.pension.PensionAutomationDetails.ConnectToProvider;
		const isInDelayedSubmissionState = $ctrl.pensionSummary.PensionSubmitState === PENSION_SUBMISSION_STATES.requesting;

		if (isInDelayedSubmissionState) {

			if (hasConnectToProviderBeenSwitchedOn) {
				setPageState('confirm-schedule');
				return;
			}

			if (hasConnectToProviderBeenSwitchedOff) {
				setPageState('confirm-cancellation');
				return;
			}
		}

		updateCompanyPensionAutomation($ctrl, formObj);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function toggleShowOverviewDetailsConnect ($ctrl) {
		$ctrl.showOverviewDetailsConnect = !$ctrl.showOverviewDetailsConnect;
	}

	function toggleShowOverviewDetailsComms ($ctrl) {
		$ctrl.showOverviewDetailsComms = !$ctrl.showOverviewDetailsComms;
	}

	function toggleShowOverviewDetailsTeam ($ctrl) {
		$ctrl.showOverviewDetailsTeam = !$ctrl.showOverviewDetailsTeam;
	}

	function updateCompanyPensionAutomation ($ctrl, formObj) {

		formObj.state = 'saving';

		const hasEmployerReferenceChanged = $ctrl.pension.PensionSettingDetails.EmployerReference !==  $ctrl.pensionOriginal.PensionSettingDetails.EmployerReference;
        const updatePensionSettingDetails = hasEmployerReferenceChanged ? pensionData.updatePensionSettingDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionSettingDetails) : null;
		const updatePensionAutomationDetails = pensionData.updatePensionAutomationDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionAutomationDetails);

		$q.all([updatePensionSettingDetails, updatePensionAutomationDetails])
			.then(() => {

				growl.success('Pension automation settings have been updated');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function onConnectToProviderChange () {

		const isNestPension = PENSION_PROVIDER_IDS.nest === $ctrl.pension.PensionProviderDetails.PensionProviderID;
		if (!(isNestPension && $ctrl.pension.PensionAutomationDetails.CanConnectToProvider)) {
			return;
		}

		pensionData.isValidNestEmployerReference($ctrl.pension.PensionSettingDetails.EmployerReference)
			.then(isReferenceValid => {
				if (!isReferenceValid) {
					$ctrl.pension.PensionSettingDetails.EmployerReference = '';
				}
				$ctrl.isReferenceValid = isReferenceValid; 
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		onAssessTeamChange,
		onConnectToProviderChange,
		reviewConfirmation,
		toggleShowOverviewDetailsComms,
		toggleShowOverviewDetailsConnect,
		toggleShowOverviewDetailsTeam,
		updateCompanyPensionAutomation,

		showOverviewDetailsConnect: true,
		showOverviewDetailsComms: true,
		showOverviewDetailsTeam: true
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeDeleteForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeDeleteFormCtrl',
	templateUrl: 'forms/pension/scheme/delete/pension-scheme-delete.form.html'
})

.controller('pensionSchemeDeleteFormCtrl', [
	'$rootScope',
	'$scope',
	'pensionData',
	'PENSION_TYPES',
	function (
		$rootScope,
		$scope,
		pensionData,
		PENSION_TYPES
	) {

	const $ctrl = this;

	function $onInit () {
		setPageState('ready');
	}

	function deletePension ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.deletePensionForAgency($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.pension.AgencyEmployerPensionID)
			.then(onDeletePension)
			.catch(onError);
	}

	function onDeletePension () {

		/* Reset company info - to update pension variables in there (particularly HasCompanyPension - in case the last
		   pension just got removed). When done, do the form callback and close the form. */
		$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId, function () {
			$ctrl.formOptions.forceCallback();
			setPageState('success');
		 });
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		deletePension,

		PENSION_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeGroupsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeGroupsFormCtrl',
	templateUrl: 'forms/pension/scheme/groups/pension-scheme-groups.form.html'
})

.controller('pensionSchemeGroupsFormCtrl', [
	'$q', 
	'companyData',
	'config', 
	'growl', 
	'pensionData', 
	'pensionService', 
	'PENSION_TYPES',
function (
	$q, 
	companyData,
	config, 
	growl, 
	pensionData, 
	pensionService, 
	PENSION_TYPES
) {

	const $ctrl = this;

	function addNewPensionGroup ($ctrl) {
		$ctrl.pension.PensionGroupDetails.PensionGroups.push(angular.copy($ctrl.defaultPensionGroup));
	}

	function deletePensionGroup ($ctrl, index) {

		const pensionGroupsArr = $ctrl.pension.PensionGroupDetails.PensionGroups;

		const pensionGroupObj = pensionGroupsArr[index];

		if (pensionGroupObj.CanBeDeleted) {
			pensionGroupsArr.splice(index, 1);

		} else {

			$ctrl.undeleteablePensionGroup = pensionGroupObj;

			setPageState('group-cant-be-deleted');
		}
	}

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		const getAgencyEmployerPensionDetails = pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId);
		const getPAYEDetails = companyData.getPAYEDetails(agencyProfileId);
		const getEmptyPensionSetup = pensionData.getEmptyPensionSetup(agencyProfileId, config.guidEmpty);

		$q.all([getAgencyEmployerPensionDetails, getPAYEDetails, getEmptyPensionSetup])
			.then(([pensionDetailsObj, payeDetailsObj, emptyPensionObj]) => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					defaultPensionGroup: pensionService.getDefaultPensionGroup(emptyPensionObj, payeDetailsObj),
					pension: pensionDetailsObj,
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function saveCompanyPensionGroups ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updatePensionGroupDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionGroupDetails)
			.then(() => {

				if (pensionService.isNonAEPension($ctrl.pension.PensionProviderDetails)) {
					growl.success('Contribution bands have been updated');

				} else {
					growl.success('Pension groups have been updated');
				}

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		PENSION_TYPES,

		addNewPensionGroup,
		deletePensionGroup,
		saveCompanyPensionGroups,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemePeriodForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemePeriodFormCtrl',
	templateUrl: 'forms/pension/scheme/period/pension-scheme-period.form.html'
})

.controller('pensionSchemePeriodFormCtrl', [
	'$q',
	'growl',
	'payrollData',
	'pensionData',
	function (
		$q,
		growl,
		payrollData,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyPayPeriodId = $ctrl.formOptions.agencyPayPeriodId;

		payrollData.getPayPeriod(agencyProfileId, agencyPayPeriodId)
			.then(pensionObj => {

				angular.extend($ctrl, {
					agencyPayPeriodId,
					agencyProfileId,
					pension: pensionObj,
				});

				validatePensionDates($ctrl, undefined);
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionPeriod ($ctrl, formObj) {

		formObj.state = 'saving';

		const updatePensionPeriod = payrollData.updateAgencyPayPeriodPensionDates($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.agencyPayPeriodId, $ctrl.pension.PensionStartDateISO, $ctrl.pension.PensionEndDateISO);

		$q.all([updatePensionPeriod])
			.then(() => {

				growl.success('Pension period has been updated');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function validatePensionDates($ctrl, $field) {

		if(!moment($ctrl.pension.PensionStartDateISO).isValid() || !moment($ctrl.pension.PensionEndDateISO).isValid()) 
		{
			return;
		}

		pensionData.isValidPensionDates(
			$ctrl.agencyProfileId, 
			$ctrl.agencyPayPeriodId,
			$ctrl.pension.PeriodType,
			$ctrl.pension.PensionStartDateISO,
			$ctrl.pension.PensionEndDateISO
		).then(validationObj => {
			$ctrl.validationResults = validationObj;

			if($field !== undefined) {
				if ($ctrl.validationResults.IsEndDateEditable) {
					validateIsEndDateExceeding($ctrl.validationResults, $field);
				} else {
					$ctrl.pension.PensionEndDateISO = $ctrl.validationResults.EndDateMaxISO;
				}
			}

			if ($ctrl.pageState !== 'ready') { setPageState('ready'); }

		}).catch(onError);
	}
	
	function validateIsEndDateExceeding(validationResults, $field) {
		if (validationResults.IsEndDateExceeding) {
			$field.$setValidity('isEndDateExceeding', false);
			$field.$setDirty();
			$field.$setTouched();
		} else {
			$field.$setValidity('isEndDateExceeding', true);
		}
	}

	angular.extend($ctrl, {
		$onInit,

		updatePensionPeriod,
		validatePensionDates
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('pensionSchemePeriodAlignmentForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemePeriodAlignmentFormCtrl',
	templateUrl: 'forms/pension/scheme/period-alignment/pension-scheme-period-alignment.form.html'
})

.controller('pensionSchemePeriodAlignmentFormCtrl', [
	'growl',
	'pensionData',
	function (
		growl,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('ready');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const hasPensionDateOffset = $ctrl.formOptions.hasPensionDateOffset;
		const isBeforePeriodDate = $ctrl.formOptions.isBeforePeriodDate;
		const pensionDateOffset = $ctrl.formOptions.pensionDateOffset;

		let pensionDateBeforeOffset= null;
		let pensionDateAfterOffset= null;

		if (isBeforePeriodDate) {
			pensionDateBeforeOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}
		else {
			pensionDateAfterOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}

		angular.extend($ctrl, {
			agencyProfileId,
			hasPensionDateOffset,
			isBeforePeriodDate,
			pensionDateBeforeOffset,
			pensionDateAfterOffset
		});
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function onOffsetTypeChange () {

		if ($ctrl.isBeforePeriodDate) {
			angular.extend($ctrl, {
				pensionDateAfterOffset: null,
				pensionDateBeforeOffset: $ctrl.pensionDateBeforeOffset === null ? 0 : $ctrl.pensionDateBeforeOffset
			});
		}
		else {
			angular.extend($ctrl, {
				pensionDateBeforeOffset: null,
				pensionDateAfterOffset: $ctrl.pensionDateAfterOffset === null ? 0 : $ctrl.pensionDateAfterOffset
			});
		}
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionPeriodAlignment ($ctrl, formObj) {

		pensionData.updateAgencyPayPeriodPensionDateOffset (
			$ctrl.agencyProfileId,
			$ctrl.hasPensionDateOffset,
			$ctrl.isBeforePeriodDate,
			$ctrl.isBeforePeriodDate ? $ctrl.pensionDateBeforeOffset : $ctrl.pensionDateAfterOffset
		).then(() => {
			growl.success('Pension period has been updated');

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';

		}).catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		onOffsetTypeChange,
		updatePensionPeriodAlignment
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemePostponementForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemePostponementFormCtrl',
	templateUrl: 'forms/pension/scheme/postponement/pension-scheme-postponement.form.html'
})

.controller('pensionSchemePostponementFormCtrl', [
	'$q',
	'$rootScope',
	'growl',
	'payrollData',
	'payPeriodService',
	'pensionData',
	function (
		$q,
		$rootScope,
		growl,
		payrollData,
		payPeriodService,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);
		const getAgencyEmployerPensionDetails = pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId);

		$q.all([getPayPeriodCurrent, getAgencyEmployerPensionDetails])
			.then(([currentPayPeriodObj, pensionObj]) => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					pension: pensionObj,
					postponementOptions: payPeriodService.getPostponementOptions(currentPayPeriodObj.PayPeriodType, pensionObj.PensionPostponementDetails.PostponementSettingsLength),
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionPostponementDetails ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updatePensionPostponementDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionPostponementDetails)
			.then(() => {

				growl.success('Pension team postponement settings have been updated');

				$rootScope.setDemoTaskAsComplete('updateTeamPostponementSettings');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updatePensionPostponementDetails
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeProviderForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeProviderFormCtrl',
	templateUrl: 'forms/pension/scheme/provider/pension-scheme-provider.form.html'
})

.controller('pensionSchemeProviderFormCtrl', ['$q', 'config', 'growl', 'pensionData',
	function ($q, config, growl, pensionData) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		const getAgencyEmployerPensionDetails = pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId);
		const getPensionProviderDetails = pensionData.getPensionProviderDetails(agencyProfileId);

		$q.all([getAgencyEmployerPensionDetails, getPensionProviderDetails])
			.then(([pensionObj, pensionProvidersArr]) => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					directConnectionProviders: pensionProvidersArr.filter(pensionProviderObj => pensionProviderObj.PensionProviderHasAPI),
					manualProviders: pensionProvidersArr.filter(pensionProviderObj => !pensionProviderObj.PensionProviderHasAPI),
					pension: pensionObj,
					pensionProviders: pensionProvidersArr
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateCompanyPensionProvider ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updatePensionProviderDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionProviderDetails)
			.then(() => {

				growl.success('Pension provider settings have been updated');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function toggleManuallyEnterPension ($ctrl) {

		if ($ctrl.manuallyEnterPension) {
			$ctrl.pension.PensionProviderDetails.PensionProviderID = config.guidEmpty;

		} else {
			$ctrl.pension.PensionProviderDetails.PensionProviderName = '';
		}
	}

	angular.extend($ctrl, {
		$onInit,

		manuallyEnterPension: false,

		updateCompanyPensionProvider,
		toggleManuallyEnterPension,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeSettingsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeSettingsFormCtrl',
	templateUrl: 'forms/pension/scheme/settings/pension-scheme-settings.form.html'
})

.controller('pensionSchemeSettingsFormCtrl', [
	'$q',
	'growl',
	'pensionData',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
	'PENSION_TYPES',
	'TAX_RELIEF_TYPES',
	function (
		$q,
		growl,
		pensionData,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES,
		TAX_RELIEF_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId)
			.then(pensionObj => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					originalPensionProviderName: pensionObj.PensionProviderDetails.PensionProviderName,
					pension: pensionObj,
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onHasSchemeReferenceChange(pensionObj) {
		// Default scheme reference display type when switching on scheme reference
		if (pensionObj.PensionSettingDetails.HasSchemeReference) {
			pensionObj.PensionSettingDetails.SchemeReferenceDisplayType = PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference;
		}
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionSettingDetails ($ctrl, formObj) {

		formObj.state = 'saving';

		const updatePensionSettingDetails = pensionData.updatePensionSettingDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionSettingDetails);
		const updatePensionProviderDetails = $ctrl.originalPensionProviderName !== $ctrl.pension.PensionProviderDetails.PensionProviderName ? pensionData.updatePensionProviderDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionProviderDetails) : null;

		$q.all([updatePensionSettingDetails, updatePensionProviderDetails])
			.then(() => {

				growl.success('Pension settings have been updated');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		PENSION_TYPES,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		TAX_RELIEF_TYPES,

		onHasSchemeReferenceChange,
		updatePensionSettingDetails
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeStagingForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeStagingFormCtrl',
	templateUrl: 'forms/pension/scheme/staging/pension-scheme-staging.form.html'
})

.controller('pensionSchemeStagingFormCtrl', [
	'$rootScope',
	'$scope',
	'growl',
	'pensionData',
	'pensionService',
	function (
		$rootScope,
		$scope,
		growl,
		pensionData,
		pensionService
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		pensionData.getAgencyEmployerPensionDetails(agencyProfileId, agencyEmployerPensionId).then(pensionObj => {

			angular.extend($ctrl, {
				agencyEmployerPensionId,
				agencyProfileId,
				pension: pensionObj,
				stagingDateBoundaries: pensionService.getStagingDateBoundaries(),
				validationResults: null
			});

			getPostponementDateBoundaries($ctrl);

			validateReenrolmentDate($ctrl);

			setPageState('ready');
		})
		.catch(onError);
	}

	function getPostponementDateBoundaries ($ctrl) {

		const postponementDateBoundariesObj = pensionService.getPostponementDateBoundaries($ctrl.pension.PensionStagingDetails.StagingDateISO);

		if (postponementDateBoundariesObj) {
			angular.extend($ctrl.pension.PensionStagingDetails, {
				PostponementDateMaxISO: postponementDateBoundariesObj.postponedDateMaxISO,
				PostponementDateMinISO: postponementDateBoundariesObj.postponedDateMinISO
			});		
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionStagingDetails ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updatePensionStagingDetails($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.pension.PensionStagingDetails).then(() => {

			growl.success('Pension staging settings have been updated');

			$rootScope.setDemoTaskAsComplete('updateTeamPostponementSettings');

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function validateReenrolmentDate ($ctrl) {

		if (!$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted) {
			$ctrl.pension.PensionStagingDetails.ReenrolmentCompletionDateISO = '';
		}

		if (moment($ctrl.pension.StagingDateISO).isValid()) {

			pensionData.isValidReenrolmentDate($ctrl.agencyProfileId, $ctrl.pension.PensionStagingDetails.StagingDateISO, $ctrl.pension.PensionStagingDetails.ReenrolmentDateISO, $ctrl.pension.PensionStagingDetails.ReenrolmentCompletionDateISO).then(validationObj => {
				$ctrl.validationResults = validationObj;
			})
			.catch(onError);

		}
	}

	angular.extend($ctrl, {
		$onInit,

		updatePensionStagingDetails
	});

	$scope.$watch('$ctrl.pension.PensionStagingDetails.StagingDateISO', (newValue, oldValue) => {
		if (newValue !== oldValue) {
			validateReenrolmentDate($ctrl);
		}
	});

	$scope.$watch('$ctrl.pension.PensionStagingDetails.StagingDateISO', (newValue, oldValue) => {
		if (newValue !== oldValue) {
			getPostponementDateBoundaries($ctrl);
			validateReenrolmentDate($ctrl);
		}
	});

	$scope.$watch('[$ctrl.pension.PensionStagingDetails.ReenrolmentDateISO, $ctrl.pension.PensionStagingDetails.ReenrolmentCompletionDateISO, $ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted]', (newDatesArr, oldDatesArr) => {
		if (!angular.equals(newDatesArr, oldDatesArr)) {
			validateReenrolmentDate($ctrl);
		}
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeTeamForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeTeamFormCtrl',
	templateUrl: 'forms/pension/scheme/team/pension-scheme-team.form.html'
})

.controller('pensionSchemeTeamFormCtrl', [
	'$q',
	'config',
	'pensionData',
	'PENSION_TYPES',
	function (
		$q,
		config,
		pensionData,
		PENSION_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const agencyProfileId = $ctrl.formOptions.agencyProfileId;

		pensionData.getTeamMembersNotInPension(
			agencyProfileId,
			agencyEmployerPensionId
		)
		.then(teamMembersArr => {

			angular.extend($ctrl, {
				agencyEmployerPensionId,
				agencyProfileId,
				selectedTeamMembers: [],
				teamMembers: decorateTeamMembers(teamMembersArr)
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function decorateTeamMembers (teamMembersArr) {
		teamMembersArr.forEach((teamMember, index) => {
			/* Add unique ID for team member (UserID isn't enough on its own since these may be repeated
			   when there are additional posts) and isAdditionalPost flag */
			angular.extend(teamMember, {
				id: `${teamMember.UserID}_${index}`,
				isAdditionalPost: teamMember.SalaryPolicyPostID !== config.guidEmpty
			});
		});
		return teamMembersArr;
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function toggleAllTeamMembers (changeToBool) {

		for (let teamMemberObj of $ctrl.teamMembers) {
			teamMemberObj.isSelected = changeToBool;
		}

		updateSelectedTeamMembers();
	}

	function updateSelectedTeamMembers () {

		const selectedTeamMembers = [];

		for (let teamMemberObj of $ctrl.teamMembers) {
			if (teamMemberObj.isSelected) {
				selectedTeamMembers.push(teamMemberObj);
			}
		}

		$ctrl.selectedTeamMembers = selectedTeamMembers;
	}

	function updateTeamMembersInPension (formObj) {

		formObj.state = 'saving';

		const IS_IN_PENSION = true;

		/* Update main post pensions using bulk UpdateTeamMembersInPension API.
		   Use single UpdateTeamMemberInPension API (which accepts SalaryPolicyPostID) for each additional post pension assignment. */
		const mainPostUserIds = [];
		const teamMembersForAdditionalPost = [];
		$ctrl.selectedTeamMembers.forEach(teamMember => {
			// Is this a main post?
			if (teamMember.SalaryPolicyPostID === config.guidEmpty) {
				// It is ...
				mainPostUserIds.push(teamMember.UserID);
			}
			else {
				// It's an additional post
				teamMembersForAdditionalPost.push(teamMember);
			}
		});

		// Put together the calls required for the update
		const updateTeamMembersInPension = [];
		// Bulk call for main posts
		if (mainPostUserIds.length !== 0) {
			updateTeamMembersInPension.push(
				pensionData.updateTeamMembersInPension(
					$ctrl.agencyProfileId,
					mainPostUserIds,
					$ctrl.agencyEmployerPensionId,
					IS_IN_PENSION
				)
			);
		}
		// Individual calls for additional posts
		if (teamMembersForAdditionalPost.length !== 0) {
			teamMembersForAdditionalPost.forEach(teamMemberForAdditionalPost => {
				updateTeamMembersInPension.push(
					pensionData.updateTeamMemberInPension(
						$ctrl.agencyProfileId,
						$ctrl.agencyEmployerPensionId,
						teamMemberForAdditionalPost.UserID,
						IS_IN_PENSION,
						teamMemberForAdditionalPost.SalaryPolicyPostID
					)
				);
			});
		}

		// Call all of that to do the complete update
		$q.all(updateTeamMembersInPension)
		.then(() => {

			$ctrl.formOptions.forceCallback();

			setPageState('saved');

			formObj.state = 'saved';

		})
		.catch(onError);
	}

	angular.extend($ctrl, {

		PENSION_TYPES,

		$onInit,
		toggleAllTeamMembers,
		updateSelectedTeamMembers,
		updateTeamMembersInPension,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeFailedPensionManuallySubmitWarningForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeFailedPensionManuallySubmitWarningFormCtrl',
	templateUrl: 'forms/pension/scheme/warnings/pension-scheme-failed-pension-manually-submit-warning.form.html'
})

.controller('pensionSchemeFailedPensionManuallySubmitWarningFormCtrl', ['growl', 'pensionData',
	function (growl, pensionData) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		pensionData.getAgencyEmployerPensionSummary(agencyProfileId, agencyEmployerPensionId)
			.then(pensionObj => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					pension: pensionObj,
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error){
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionManualSubmission ($ctrl, formObj) {

		formObj.state = 'saving';

		
		pensionData.updatePensionManualSubmission($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId)
			.then(() => {

				formObj.state = 'saved';

				$ctrl.formOptions.forceCallback();

				growl.success('Pension warning dismissed');

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updatePensionManualSubmission
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionSchemeQueuedPensionCancelWarningForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionSchemeQueuedPensionCancelWarningFormCtrl',
	templateUrl: 'forms/pension/scheme/warnings/pension-scheme-queued-pension-cancel-warning.form.html'
})

.controller('pensionSchemeQueuedPensionCancelWarningFormCtrl', ['growl', 'pensionData',
	function (growl, pensionData) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;

		pensionData.getAgencyEmployerPensionSummary(agencyProfileId, agencyEmployerPensionId)
			.then(pensionObj => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					agencyProfileId,
					pension: pensionObj,
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error){
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updatePensionFailedSubmission ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updatePensionFailedSubmission($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId)
			.then(() => {

				formObj.state = 'saved';

				$ctrl.formOptions.forceCallback();

				growl.success('Pension warning dismissed');

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updatePensionFailedSubmission
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyPensionConnectorForm', function () {

	return {
		controller: 'companyPensionConnectorFormCtrl',
		templateUrl: 'forms/company/pension-connector/companyPensionConnectorForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyPensionConnectorFormCtrl', [
	'$q',
	'$scope',
	'companyData',
	'config',
	'payPeriodService',
	'pensionData',
	'pensionService',
	'policyService',
	'session',
	'stateService',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS',
	'PENSION_SCHEME_REFERENCE_DISPLAY_TYPES',
	'PENSION_TYPES',
	'POLICY_BAND_CALCULATION_TYPES',
	'POLICY_CATEGORIES',
	'TAX_RELIEF_TYPES',
	function (
		$q,
		$scope,
		companyData,
		config,
		payPeriodService,
		pensionData,
		pensionService,
		policyService,
		session,
		stateService,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES,
		POLICY_BAND_CALCULATION_TYPES,
		POLICY_CATEGORIES,
		TAX_RELIEF_TYPES
	) {

	const formOptionsObj = $scope.formOptions;
	const agencyEmployerPensionId = angular.isDefined(formOptionsObj.agencyEmployerPensionId) ? formOptionsObj.agencyEmployerPensionId : config.guidEmpty;
	const agencyProfileId = formOptionsObj.agencyProfileId;
	const currentCompanyObj = formOptionsObj.company;

	const agencyProfileParentId = session.getAgencyProfileParentId();

	const CONNECTOR_FORMS = {
		pensionType: 0,
		pensionGhost: 1,
		pensionProvider: 2,
		pensionAutomation: 3,
		pensionStagingDate: 4,
		pensionSettings: 5,
		pensionTeam: 6,
		pensionGroups: 7
	};

	const FORM_ORDER = [
		CONNECTOR_FORMS.pensionType,
		CONNECTOR_FORMS.pensionGhost,
		CONNECTOR_FORMS.pensionProvider,
		CONNECTOR_FORMS.pensionAutomation,
		CONNECTOR_FORMS.pensionStagingDate,
		CONNECTOR_FORMS.pensionSettings,
		CONNECTOR_FORMS.pensionTeam,
		CONNECTOR_FORMS.pensionGroups,
	];

	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function addNewPensionGroup (vmObj) {
		vmObj.pension.PensionGroups.push(angular.copy(vmObj.defaultPensionGroup));
	}

	function connectPension (vmObj, formObj) {

		formObj.state = 'saving';

		// Always make sure Pension Provider ID is set to a GUID
		if (vmObj.pension.PensionProviderID === '') {
			vmObj.pension.PensionProviderID = config.guidEmpty;
		}

		// Update pension alignment settings
		vmObj.pension.IsPensionDateOffsetBeforePeriodDate = vmObj.isBeforePeriodDate;
		vmObj.pension.PensionDateOffset = vmObj.isBeforePeriodDate ? vmObj.pensionDateBeforeOffset : vmObj.pensionDateAfterOffset;

		pensionData.createAgencyEmployerPension(agencyProfileId, agencyProfileParentId, vmObj.pension, agencyEmployerPensionId).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			stateService.setCompany(agencyProfileId);

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function decoratePension (pensionObj, pensionDetailsObj, payeDetailsObj, pensionPoliciesArr) {

		// Set correct policy object against pension if defined
		let policy;
		if (pensionObj.PolicyID !== config.guidEmpty) {
			policy = pensionPoliciesArr.find(pensionPolicy => pensionPolicy.PolicyID === pensionObj.PolicyID);
		}

		angular.extend(pensionObj, {
			PensionProviderID: pensionObj.PensionProviderID !== config.guidEmpty ? pensionObj.PensionProviderID : '',
			policy,

			// If the existing pension is a Ghost Pension, it will be changing to a 'normal' pension on save ...
			IsGhostPension: false
		});

		// Get defaults for pension groups
		for (let pensionGroupObj of pensionObj.PensionGroups) {
			pensionService.decorateNewPensionGroup(pensionGroupObj, payeDetailsObj);
		}

		// Can only add a AE pension if no ghost pensions exist
		if (!isPensionSetupPreviously(pensionObj) && !pensionDetailsObj.CanAddAEPension) {
			pensionService.setDefaultsForNonAEPension(pensionObj);
		}

		return pensionObj;
	}

	function deletePensionGroup (pensionGroupsArr, index) {
		pensionGroupsArr.splice(index, 1);
	}

	function getFormStepBasedOnInt (vmObj, isBackButtonClick) {

		updateActiveStep(vmObj, isBackButtonClick);

		// Skip forms that arent applicable for pension type
		while (getFormStepExcludeReason(vmObj, FORM_ORDER[vmObj.activeStep])) {
			updateActiveStep(vmObj, isBackButtonClick);
		}

		return vmObj.activeStep;
	}

	function getFormStepExcludeReason (vmObj, formStepInt) {

		const pensionObj = vmObj.pension;

		switch (formStepInt) {

			case CONNECTOR_FORMS.pensionType:
				return isPensionSetupPreviously(pensionObj) || !vmObj.pensionDetails.CanAddNonAEPension;

			case CONNECTOR_FORMS.pensionGhost:
				return pensionService.isNonAEPension(pensionObj) || currentCompanyObj.HasPension;

			case CONNECTOR_FORMS.pensionProvider:
				return pensionService.isNonAEPension(pensionObj) || pensionObj.IsGhostPension;

			case CONNECTOR_FORMS.pensionAutomation:
				return pensionService.isNonAEPension(pensionObj);

			case CONNECTOR_FORMS.pensionStagingDate:
				return pensionService.isNonAEPension(pensionObj) || pensionObj.HasTPRStagingInformation;

			case CONNECTOR_FORMS.pensionSettings:
				return pensionObj.IsGhostPension;

			case CONNECTOR_FORMS.pensionTeam:
				return pensionService.isNonAEPension(pensionObj);

			case CONNECTOR_FORMS.pensionGroups:
				return pensionObj.IsGhostPension;

			default:
				return false;
		}
	}

	function getInitialFormStep (vmObj) {

		// Find first non-excluded form step
		vmObj.activeStep = FORM_ORDER.find(formStep => !getFormStepExcludeReason(vmObj, formStep));
	}

	function getPostponementDateBoundaries (vmObj) {
		vmObj.postponementDateBoundaries = pensionService.getPostponementDateBoundaries(vmObj.pension.StagingDateISO);
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		const getEmptyPensionSetup = pensionData.getEmptyPensionSetup(agencyProfileId, agencyEmployerPensionId);
		const getPensionProviderDetails = pensionData.getPensionProviderDetails(agencyProfileId);
		const getPAYEDetails = companyData.getPAYEDetails(agencyProfileId);
		const getPensionDetailsForAgency = pensionData.getPensionDetailsForAgency(agencyProfileId);
		const getPensionPolicies = policyService.getPoliciesForCategory(agencyProfileId, POLICY_CATEGORIES.pension);

		$q.all([getEmptyPensionSetup, getPensionProviderDetails, getPAYEDetails, getPensionDetailsForAgency, getPensionPolicies]).then(
			([pensionObj, pensionProvidersArr, payeDetailsObj, pensionDetailsObj, pensionPoliciesArr]) => {

			const vmObj = {
				company: currentCompanyObj,
				defaultPensionGroup: pensionService.getDefaultPensionGroup(pensionObj, payeDetailsObj),
				directConnectionProviders: pensionProvidersArr.filter(pensionProviderObj => pensionProviderObj.PensionProviderHasAPI),
				isBackButtonDisplayed: false,
				isFinalFormStep: false,
				manuallyEnterPension: false,
				manualProviders: pensionProvidersArr.filter(pensionProviderObj => !pensionProviderObj.PensionProviderHasAPI),
				pension: decoratePension(pensionObj, pensionDetailsObj, payeDetailsObj),
				pensionDetails: pensionDetailsObj,
				pensionPolicies: pensionPoliciesArr,
				postponementDateBoundaries: pensionService.getPostponementDateBoundaries(pensionObj.StagingDateISO),
				postponementOptions: payPeriodService.getPostponementOptions(pensionObj.PayPeriodType, pensionObj.PostponementSettingsLength),
				selectedPensionProvider: null,
				showOverviewDetailsComms: false,
				showOverviewDetailsConnect: false,
				showOverviewDetailsTeam: false,
				stagingDateBoundaries: pensionService.getStagingDateBoundaries()
			};

			setUpPeriodAlignment(vmObj);

			validateReenrolmentDate(vmObj);

			getInitialFormStep(vmObj);

			updateFormActions(vmObj);

			$scope.vm = vmObj;

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function isPensionSetupPreviously (pensionObj) {
		return pensionObj.AgencyEmployerPensionID !== config.guidEmpty;
	}

	function loadStep (vmObj, isBackButtonClick, formObj) {

		if (!isBackButtonClick && vmObj.isFinalFormStep) {
			connectPension(vmObj, formObj);
			return;
		}

		vmObj.activeStep = getFormStepBasedOnInt(vmObj, isBackButtonClick);

		updateFormActions(vmObj);

		scrollToFormTop();
	}

	function onAssessTeamChange (pensionObj) {

		if (!pensionObj.AssessTeam) {
			pensionObj.ConnectToProvider = false;
		}
	}

	function onConnectToProviderChange (pensionObj) {
		// Defaults for scheme reference settings when changing 'Connect to provider'
		pensionObj.SchemeReferenceDisplayType = PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference;
		pensionObj.HasSchemeReference = true;
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function onManualPensionInputChange (vmObj) {
		if (vmObj.manuallyEnterPension) {
			vmObj.pension.PensionProviderID = '';
		}
	}

	function onPensionPolicyChange (pensionObj) {
		// Sync policy ID with selected
		pensionObj.PolicyID = pensionObj.policy.PolicyID;
	}

	function onPensionProviderSelect (vmObj, pensionProviderObj) {

		vmObj.selectedPensionProvider = pensionProviderObj;

		angular.extend(vmObj.pension, {
			ConnectToProvider: pensionProviderObj.PensionProviderHasAPI,
			UsePensionPolicy: false
		});

		/* Connect to provider may have changed ... the scheme reference needs to be reset, whether it has or not,
		   Since a new provider has been selected */
		onConnectToProviderChange(vmObj.pension);
	}

	function onPensionTypeChange (pensionObj) {

		if (pensionService.isNonAEPension(pensionObj)) {
			pensionService.setDefaultsForNonAEPension(pensionObj);

		} else {
			for (let pensionGroupObj of pensionObj.PensionGroups) {
				pensionGroupObj.IsDefault = false;
			}
		}
	}

	function onStagingDateChange (vmObj) {
		getPostponementDateBoundaries(vmObj);
		validateReenrolmentDate(vmObj);
	}

	function onUsePensionPolicyChange (pensionObj) {
		if (pensionObj.UsePensionPolicy) {
			// Unset PolicyID to force policy selection
			pensionObj.PolicyID = '';
		}
		else {
			// Set to empty guid so the pension will save without platform barfage
			pensionObj.PolicyID = config.guidEmpty;
		}

	}

	function scrollToFormTop () {
		document.getElementById('slide-in-form-body').scrollTop = 0;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleShowOverviewDetailsComms (vmObj) {
		vmObj.showOverviewDetailsComms = !vmObj.showOverviewDetailsComms;
	}

	function toggleShowOverviewDetailsConnect (vmObj) {
		vmObj.showOverviewDetailsConnect = !vmObj.showOverviewDetailsConnect;
	}

	function toggleShowOverviewDetailsTeam (vmObj) {
		vmObj.showOverviewDetailsTeam = !vmObj.showOverviewDetailsTeam;
	}

	function updateActiveStep (vmObj, isBackButtonClick) {
		vmObj.activeStep = isBackButtonClick ? vmObj.activeStep-1 : vmObj.activeStep+1;
	}

	function updateFormActions (vmObj) {

		// If a previous form step is not excluded then return true

		const previousFormStepsArr = FORM_ORDER.filter(formStep => formStep < vmObj.activeStep);
		const nextFormStepsArr = FORM_ORDER.filter(formStep => formStep > vmObj.activeStep);

		angular.extend(vmObj, {
			isBackButtonDisplayed: previousFormStepsArr.some(formStep => !getFormStepExcludeReason(vmObj, formStep)),
			isFinalFormStep: nextFormStepsArr.every(formStep => getFormStepExcludeReason(vmObj, formStep)),
		});
	}

	function validateReenrolmentDate (vmObj) {

		if (!vmObj.pension.ReenrolmentAlreadyCompleted) {
			vmObj.pension.ReenrolmentCompletionDateISO = '';
		}

		if (moment(vmObj.pension.StagingDateISO).isValid()) {
			pensionData.isValidReenrolmentDate(agencyProfileId, vmObj.pension.StagingDateISO, vmObj.pension.ReenrolmentDateISO, vmObj.pension.ReenrolmentCompletionDateISO).then(validationObj => {
				vmObj.validationResults = validationObj;
			})
			.catch(onError);
		}
	}

	function setUpPeriodAlignment(vmObj) {

		const isBeforePeriodDate = vmObj.pension.IsPensionDateOffsetBeforePeriodDate;
		const pensionDateOffset = vmObj.pension.PensionDateOffset;
		let pensionDateBeforeOffset = null;
		let pensionDateAfterOffset = null;

		if (isBeforePeriodDate) {
			pensionDateBeforeOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}
		else {
			pensionDateAfterOffset = pensionDateOffset > 0 ? pensionDateOffset : 0;
		}

		angular.extend(vmObj, {
			isBeforePeriodDate: isBeforePeriodDate,
			pensionDateAfterOffset: pensionDateAfterOffset,
			pensionDateBeforeOffset: pensionDateBeforeOffset,
		});
	}

	function onOffsetTypeChange (vmObj) {

		if (vmObj.isBeforePeriodDate) {
			vmObj.pensionDateAfterOffset = null;
			vmObj.pensionDateBeforeOffset = vmObj.pensionDateBeforeOffset === null ? 0 : vmObj.pensionDateBeforeOffset;
		}
		else {
			vmObj.pensionDateBeforeOffset = null;
			vmObj.pensionDateAfterOffset = vmObj.pensionDateAfterOffset === null ? 0 : vmObj.pensionDateAfterOffset;
		}
	}

	init();

	angular.extend($scope, {
		CONNECTOR_FORMS,
		PAGE_STATES,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS,
		PENSION_SCHEME_REFERENCE_DISPLAY_TYPES,
		PENSION_TYPES,
		POLICY_BAND_CALCULATION_TYPES,
		TAX_RELIEF_TYPES,

		addNewPensionGroup,
		deletePensionGroup,
		goToGhostPensionSettings: pensionService.goToGhostPensionSettings,
		loadStep,
		onAssessTeamChange,
		onConnectToProviderChange,
		onManualPensionInputChange,
		onOffsetTypeChange,
		onPensionPolicyChange,
		onPensionProviderSelect,
		onPensionTypeChange,
		onStagingDateChange,
		onUsePensionPolicyChange,
		toggleShowOverviewDetailsComms,
		toggleShowOverviewDetailsConnect,
		toggleShowOverviewDetailsTeam,
		validateReenrolmentDate
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamContributionsAeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamContributionsAeFormCtrl',
	templateUrl: 'forms/pension/team/contributions-ae/pension-team-contributions-ae.form.html',
})

.controller('pensionTeamContributionsAeFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'companyData',
	'config',
	'growl',
	'pensionData',
	'pensionService',
	'policyService',
	'POLICY_BAND_CALCULATION_TYPES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		companyData,
		config,
		growl,
		pensionData,
		pensionService,
		policyService,
		POLICY_BAND_CALCULATION_TYPES
	) {

	const $ctrl = this;

	const PAGE_STATES = {
		error: 'error',
		excluded: 'excluded',
		loading: 'loading',
		locked: 'locked',
		noPensionGroup: 'no-pension-group',
		pensionAuthorisationRequired: 'pension-authorisation-required',
		pensionPolicyBandSummary: 'pension-policy-band-summary',
		ready: 'ready'
	};

	function $onInit () {

		setPageState(PAGE_STATES.loading);

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getPAYEDetails = companyData.getPAYEDetails(agencyProfileId);
		const getPensionGroupsForAgency = pensionData.getPensionGroupsForAgency(agencyProfileId, agencyEmployerPensionId, userId);
		const getTeamMemberPension = pensionData.getTeamMemberPensionWithFte(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);

		$q.all([
			getPensionGroupsForAgency,
			getTeamMemberPension,
			getPAYEDetails
		])
		.then(([
			pensionGroupsArr,
			teamMemberPensionObj,
			payeDetailsObj
		]) => {

			/* Validation: If no pension groups, and pension isn't policy based, pension requires authorisation
			   (needs to execute before calculations are made as calculations require group rates) */
			if (pensionGroupsArr.length === 0 && !teamMemberPensionObj.UsePensionPolicy) {
				setPageState(PAGE_STATES.pensionAuthorisationRequired);
				return;
			}

			const selectedPensionGroupObj = pensionService.getTeamMemberSelectedPensionGroup(pensionGroupsArr, teamMemberPensionObj);

			angular.extend($ctrl, {
				payeDetails: payeDetailsObj,
				pension: teamMemberPensionObj,
				pensionGroup: selectedPensionGroupObj,
				pensionWarningState: ''
			});

			// Validation: No company group selected
			if (teamMemberPensionObj.PensionGroupID === config.guidEmpty && !teamMemberPensionObj.UsePensionPolicy) {
				setPageState(PAGE_STATES.noPensionGroup);
				return;
			}

			// Validation: Excluded from pension
			if (teamMemberPensionObj.PensionIsExcluded) {
				setPageState(PAGE_STATES.excluded);
				return;
			}

			// Watch for custom pension rate changes
			if (teamMemberPensionObj.HasCustomContributionPercent) {
				$ctrl.thresholdWatcher = getThresholdWatcher($ctrl);
			}

			// Set page state depending on UsePensionPolicy. If set, contribution rates can't be customised.
			if (teamMemberPensionObj.UsePensionPolicy) {

				// Get the policy, it's required for information on the form
				policyService.getPolicy(agencyProfileId, teamMemberPensionObj.PolicyID).then(pensionPolicyObj => {

					$ctrl.pensionPolicy = pensionPolicyObj;

					// Decorate pension with band amounts depending on contribution rate type
					// HasFixedEmployeeContribution implies HasFixedEmployerContribution, so no separate check on that
					if (teamMemberPensionObj.HasFixedEmployeeContribution) {
						angular.extend(teamMemberPensionObj, {
							employeeAmount: $filter('monetise')(teamMemberPensionObj.PensionEmployeeFixedAmount),
							employerAmount: $filter('monetise')(teamMemberPensionObj.PensionEmployerFixedAmount)
						});
					}
					else {
						angular.extend(teamMemberPensionObj, {
							employeeAmount: `${teamMemberPensionObj.PensionEmployeePercent}%`,
							employerAmount: `${teamMemberPensionObj.PensionEmployerPercent}%`
						});
					}
					setPageState(PAGE_STATES.pensionPolicyBandSummary);
				})
				.catch(onError);
			}
			else {
				setPageState(PAGE_STATES.ready);
			}
		})
		.catch(onError);
	}

	function getPensionState ($ctrl) {

		// 1. Percentage employee - Percentage employer
		if (!$ctrl.pension.HasFixedEmployeeContribution && !$ctrl.pension.HasFixedEmployerContribution) {
			return (($ctrl.pension.PensionEmployeePercent + $ctrl.pension.PensionEmployerPercent) < $ctrl.pensionGroup.totalPercent) ? 'percentage' : null;
		}
		// 2. Percentage employee - Fixed employer
		// 3. Fixed employee - Percentage employer
		// 4. Fixed employee - Fixed employer
		if ($ctrl.pension.HasFixedEmployeeContribution || $ctrl.pension.HasFixedEmployerContribution) {
			return 'fixed';
		}
	}

	function getThresholdWatcher ($ctrl) {

		return $scope.$watch('$ctrl.pension', function () {
			updatePensionWarningState($ctrl);
		}, true);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function resetPensionToGroup ($ctrl) {

		pensionService.resetTeamMemberPensionToGroup($ctrl.pension, $ctrl.pensionGroup);

		updatePensionWarningState($ctrl);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function toggleCustomRates ($ctrl) {

		if ($ctrl.pension.HasCustomContributionPercent) {
			$ctrl.thresholdWatcher = getThresholdWatcher($ctrl);

		} else {

			$ctrl.thresholdWatcher = null;
			resetPensionToGroup($ctrl);
		}
	}

	function updatePensionWarningState ($ctrl) {
		$ctrl.pensionWarningState = getPensionState($ctrl);
	}

	function updateTeamMemberPensionContributions ($ctrl, formObj) {

		formObj.state = 'saving';

		if (!$ctrl.pension.HasCustomContributionPercent) {
			pensionService.setTeamMemberPensionValuesToGroup($ctrl.pension, $ctrl.pensionGroup);
		}

		pensionData.updateTeamMemberPensionContributions($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				growl.success($ctrl.formOptions.context.Forename + '\'s pension details have been updated.');

				// Complete demo
				$rootScope.setDemoTaskAsComplete('updateEmployeePensionContributions', $ctrl.formOptions.context.Forename);

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		PAGE_STATES,
		POLICY_BAND_CALCULATION_TYPES,

		toggleCustomRates,
		toggleTeamMemberCustomEmployeeContributionType: pensionService.toggleTeamMemberCustomEmployeeContributionType,
		toggleTeamMemberCustomEmployerContributionType: pensionService.toggleTeamMemberCustomEmployerContributionType,
		updateTeamMemberPensionContributions
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamContributionsNonAeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamContributionsNonAeFormCtrl',
	templateUrl: 'forms/pension/team/contributions-non-ae/pension-team-contributions-non-ae.form.html'
})

.controller('pensionTeamContributionsNonAeFormCtrl', [
	'$q',
	'pensionData',
	'pensionService',
	'PENSION_ENROLMENT_STATES',
	function (
		$q,
		pensionData,
		pensionService,
		PENSION_ENROLMENT_STATES
	) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getPensionGroupsForAgency = pensionData.getPensionGroupsForAgency(agencyProfileId, agencyEmployerPensionId, userId);
		const getTeamMemberPension = pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);

		$q.all([getPensionGroupsForAgency, getTeamMemberPension])
			.then(([pensionGroupsArr, teamMemberPensionObj]) => {

				const selectedPensionGroupObj = getSelectedPensionGroup(pensionGroupsArr, teamMemberPensionObj);

				angular.extend($ctrl, {
					pensionGroups: pensionGroupsArr,
					pensionGroup: selectedPensionGroupObj,
					pension: teamMemberPensionObj,
					hasEarlierJoinDate: teamMemberPensionObj.PensionJoinedDateISO !== ''
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function getSelectedPensionGroup (pensionGroupsArr, teamMemberPensionObj) {

		// 1. Pension group assingned to team member
		let selectedPensionGroupObj = pensionService.getTeamMemberSelectedPensionGroup(pensionGroupsArr, teamMemberPensionObj);

		// 2. Default group in scheme
		if (!selectedPensionGroupObj) {
			selectedPensionGroupObj = pensionGroupsArr.find(pensionGroupObj => pensionGroupObj.IsDefault);
		}

		// 3. First group returned
		if (!selectedPensionGroupObj) {
			selectedPensionGroupObj = pensionGroupsArr[0];
		}

		return selectedPensionGroupObj;
	}

	function onContributionTypeChange ($ctrl) {

		if (!$ctrl.pension.HasCustomContributionPercent) {
			pensionService.resetTeamMemberPensionToGroup($ctrl.pension, $ctrl.pensionGroup);
		}
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function setTeamMemberPensionRejoined ($ctrl, formObj) {

		$ctrl.pension.PensionState = PENSION_ENROLMENT_STATES.rejoined;

		pensionData.updateTeamMemberPension($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				$ctrl.formOptions.forceCallback();

				setComponentState('saved');

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function updateTeamMemberPension ($ctrl, formObj) {

		formObj.state = 'saving';

		if (!$ctrl.pension.HasCustomContributionPercent) {
			pensionService.setTeamMemberPensionValuesToGroup($ctrl.pension, $ctrl.pensionGroup);
		}

		// If team member has been removed, rejoin them
		if ($ctrl.pension.PensionState === PENSION_ENROLMENT_STATES.removed) {
			setTeamMemberPensionRejoined($ctrl, formObj);
			return;
		}

		if (!$ctrl.hasEarlierJoinDate) {
			$ctrl.pension.PensionJoinedDateISO = '';
		}

		pensionData.updateTeamMemberPension($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				$ctrl.formOptions.forceCallback();

				setComponentState('saved');

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	function setComponentState (componentState) {

		$ctrl.componentState = componentState;
	}

	function toggleTeamMemberCustomContributionType ($ctrl) {
		pensionService.toggleTeamMemberCustomEmployeeContributionType($ctrl.pension, $ctrl.pensionGroup);
		pensionService.toggleTeamMemberCustomEmployerContributionType($ctrl.pension, $ctrl.pensionGroup);
	}

	angular.extend($ctrl, {
		$onInit,

		PENSION_ENROLMENT_STATES,

		onContributionTypeChange,
		toggleTeamMemberCustomContributionType,
		updateTeamMemberPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamBandsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamBandsFormCtrl',
	templateUrl: 'forms/pension/team/bands/pension-team-bands.form.html'
})

.controller('pensionTeamBandsFormCtrl', [
	'$q',
	'config',
	'growl',
	'pensionData',
	'policyService',
	'wizardService',
	'POLICY_BAND_CALCULATION_TYPES',
	function (
		$q,
		config,
		growl,
		pensionData,
		policyService,
		wizardService,
		POLICY_BAND_CALCULATION_TYPES
	) {

	const $ctrl = this;

	const PAGE_STATES = {
		error: 'error',
		excluded: 'excluded',
		loading: 'loading',
		ready: 'ready'
	};

	$ctrl.$onInit = () => {

		setPageState(PAGE_STATES.loading);

		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getTeamMemberPension = pensionData.getTeamMemberPensionWithFte(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);
		const getPensionForAgency = pensionData.getPensionForAgency(agencyProfileId, agencyEmployerPensionId);

		$q.all([getTeamMemberPension, getPensionForAgency]).then(([teamMemberPensionObj, pensionObj]) => {

				// Set page state if excluded from pension, nothing more to do
				if (teamMemberPensionObj.PensionIsExcluded) {
					setPageState(PAGE_STATES.excluded);
				}
				else {
					// Get corresponding pension policy
					policyService.getPolicy(agencyProfileId, teamMemberPensionObj.PolicyID).then(pensionPolicyObj => {

						// Unset policy band ID if one needs to be selected; this will be an empty Guid if selection is required
						if (pensionPolicyObj.PolicyBandCalculation === POLICY_BAND_CALCULATION_TYPES.manual && teamMemberPensionObj.PolicyBandID === config.guidEmpty) {
							delete(teamMemberPensionObj.PolicyBandID);
						}

						// The full-time equivalent salary is system-calculated server-side for FTE-based bands and returned on the pension
						// object, along with a flag telling us when the member's pay type has no FTE salary to calculate from and the
						// value has to be entered manually instead
						angular.extend($ctrl, {
							agencyEmployerPensionId,
							agencyProfileId,
							scheme: pensionObj,
							pension: teamMemberPensionObj,
							pensionPolicy: pensionPolicyObj,
							userId
						});
						setPageState(PAGE_STATES.ready);
					})
					.catch(onError);
				}
			})
			.catch(onError);
	};

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function onPolicyBandCardClick (pensionObj, policyBandObj) {
		pensionObj.PolicyBandID = policyBandObj.PolicyBandID;
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMemberPensionContributions (ctrlObj, formObj) {

		formObj.state = 'saving';

		pensionData.updateTeamMemberPensionContributions(ctrlObj.pension, ctrlObj.userId, ctrlObj.agencyProfileId).then(() => {
			formObj.state = 'saved';

			// Save using wizard service if necessary and move to next step, otherwise close
			if (ctrlObj.formOptions.isWizard) {
				wizardService.savePension(ctrlObj.pension);
				ctrlObj.formOptions.onSuccess();
			}
			else {
				growl.success(`${$ctrl.formOptions.context.Forename}'s pension band details have been updated.`);
				ctrlObj.formOptions.forceCallback();
				ctrlObj.formOptions.closeForm();
			}
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		PAGE_STATES,
		POLICY_BAND_CALCULATION_TYPES,

		onPolicyBandCardClick,
		updateTeamMemberPensionContributions
	});
}]);
'use strict';

angular.module('paycircleApp')

.component('pensionTeamGroupsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamGroupsFormCtrl',
	templateUrl: 'forms/pension/team/groups/pension-team-groups.form.html'
})

.controller('pensionTeamGroupsFormCtrl', [
	'$q',
	'growl',
	'pensionData',
	function (
		$q,
		growl,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getTeamMemberPension = pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);
		const getPensionGroupsForAgency = pensionData.getPensionGroupsForAgency(agencyProfileId, agencyEmployerPensionId, userId);
		const getPensionForAgency = pensionData.getPensionForAgency(agencyProfileId, agencyEmployerPensionId);

		$q.all([getTeamMemberPension, getPensionGroupsForAgency, getPensionForAgency])
			.then(([teamMemberPensionObj, pensionGroupsArr, pensionObj]) => {

				angular.extend($ctrl, {
					scheme: pensionObj,
					pensionGroups: pensionGroupsArr,
					pension: decoratePension(teamMemberPensionObj, pensionGroupsArr)
				});

				// Validation: Excluded from pension
				if (teamMemberPensionObj.PensionIsExcluded) {
					setPageState('excluded');

				} else {
					setPageState('ready');
				}
			})
			.catch(onError);
	}

	function decoratePension (pension, pensionGroups) {
		// If there's just a single choice of one pension group, auto-select it
		if (pensionGroups.length === 1) {
			pension.PensionGroupID = pensionGroups[0].PensionGroupID;
		}
		return pension;
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMemberPension ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updateTeamMemberPension($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				growl.success(`${$ctrl.formOptions.context.Forename}'s pension group details have been updated.`);

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
		}

	angular.extend($ctrl, {
		$onInit,

		updateTeamMemberPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamManagePensionsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamManagePensionsFormCtrl',
	templateUrl: 'forms/pension/team/manage-pensions/pension-team-manage-pensions.form.html'
})

.controller('pensionTeamManagePensionsFormCtrl', [
	'pensionData',
	function (
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		const includeInactive = true;

		pensionData.getPensionsForTeamMember($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId, includeInactive)
			.then(pensionsArr => {

				angular.extend($ctrl, {
					pensions: pensionsArr,
					selectedPension: null
				});

				setFormState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setFormState('error');
		console.error(error);
	}

	function openPensionTeamFormByKey ($ctrl, pensionObj, formKey) {

		$ctrl.formOptions.openNewSlideInForm({
			agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			pensionAdditionalPostId: pensionObj.SalaryPolicyPostID,
			callback: $ctrl.formOptions.forceCallback,
			formKey: formKey,
			returnAction: formOptionsObj => {
				formOptionsObj.openNewSlideInForm({
					agencyEmployerPensionId: pensionObj.AgencyEmployerPensionID,
					agencyProfileId: $ctrl.formOptions.agencyProfileId,
					callback: $ctrl.formOptions.forceCallback,
					formKey: 'pension-team-manage-pensions',
					userId: $ctrl.formOptions.userId
				});
			},
			showPensionSwitch: true,
			title: 'Manage pensions',
			userId: $ctrl.formOptions.userId
		});
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,

		openPensionTeamFormByKey
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamPostponementForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamPostponementFormCtrl',
	templateUrl: 'forms/pension/team/postponement/pension-team-postponement.form.html'
})

.controller('pensionTeamPostponementFormCtrl', [
	'$filter',
	'$q',
	'growl',
	'pensionData',
	function (
		$filter,
		$q,
		growl,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getPensionPostponementForPension = pensionData.getPensionPostponementForPension(agencyProfileId, agencyEmployerPensionId);
		const getTeamMemberPension = pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);

		$q.all([getPensionPostponementForPension, getTeamMemberPension])
			.then(([postponementSettingsObj, teamMemberPensionObj]) => {

				angular.extend($ctrl, {
					payPeriodTypeDescriptionPlural: $filter('payPeriodTypeDescription')(postponementSettingsObj.PayPeriodType, 'months'),
					payPeriodTypeDescriptionSingular: $filter('payPeriodTypeDescription')(postponementSettingsObj.PayPeriodType, 'month'),
					postponementLengthOptions: getPostponementLengthOptions(postponementSettingsObj),
					postponementSettings: postponementSettingsObj,
					pension: teamMemberPensionObj
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function getPostponementLengthOptions (postponementSettingsObj) {

		// Return array with length of PostponementSettingsLength including zero, eg: 3 = [0, 1, 2, 3]
		const returnArr = new Array(postponementSettingsObj.PostponementSettingsLength+1);

		for(let index = 0; index < returnArr.length; index++){
			returnArr[index] = index;
		}

		return returnArr;
	}

	function onError (error) {
		
		setPageState('error');
		throw(error);
	}

	function savePensionPostponement ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updateTeamMemberPensionPostpone($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId, $ctrl.pension)
			.then(() => {

				formObj.state = 'saved';

				growl.success($ctrl.formOptions.context.Forename + '\'s postponement settings have been saved.');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
		}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		savePensionPostponement,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamRemoveForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamRemoveFormCtrl',
	templateUrl: 'forms/pension/team/remove/pension-team-remove.form.html'
})

.controller('pensionTeamRemoveFormCtrl', [
	'pensionData',
	'pensionService',
	'PENSION_ENROLMENT_STATES',
	function (
		pensionData,
		pensionService,
		PENSION_ENROLMENT_STATES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId)
			.then(teamMemberPensionObj => {

				angular.extend($ctrl, {
					agencyEmployerPensionId,
					pensionAdditionalPostId,
					agencyProfileId,
					isNonAeNotEnrolledView: pensionService.isNonAEPension(teamMemberPensionObj) && teamMemberPensionObj.PensionState === PENSION_ENROLMENT_STATES.notEnrolled,
					teamMemberPension: teamMemberPensionObj,
					userId
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		
		setPageState('error');
		throw(error);
	}

	function onFormSave () {
		setPageState('saved');
		$ctrl.formOptions.forceCallback();
	}

	function saveForm ($ctrl, formObj) {

		if ($ctrl.isNonAeNotEnrolledView || $ctrl.teamMemberPension.CanRemoveFromPension) {
			updateTeamMemberInPension($ctrl, formObj);

		} else if ($ctrl.teamMemberPension.CanArchiveFromPension) {
			updateTeamMemberPensionArchived ($ctrl, formObj);

		} else {
			onError();
		}
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMemberInPension ($ctrl, formObj) {

		const isInPension = false;

		pensionData.updateTeamMemberInPension($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.userId, isInPension, $ctrl.pensionAdditionalPostId)
			.then(() => {
				onFormSave($ctrl, formObj);
			})
			.catch(onError);
	}

	function updateTeamMemberPensionArchived ($ctrl, formObj) {

		const isArchived = true;

		pensionData.updateTeamMemberPensionArchived($ctrl.agencyProfileId, $ctrl.agencyEmployerPensionId, $ctrl.userId, isArchived, $ctrl.pensionAdditionalPostId)
			.then(() => {
				onFormSave($ctrl, formObj);
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		saveForm
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamSalarySacrificeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamSalarySacrificeFormCtrl',
	templateUrl: 'forms/pension/team/salary-sacrifice/pension-team-salary-sacrifice.form.html',
})

.controller('pensionTeamSalarySacrificeFormCtrl', [
	'growl',
	'pensionData',
	function (
		growl,
		pensionData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId)
			.then(teamMemberPensionObj => {

				$ctrl.pension = teamMemberPensionObj;

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMemberPension ($ctrl, formObj) {

		formObj.state = 'saving';

		pensionData.updateTeamMemberPension($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				growl.success($ctrl.formOptions.context.Forename + '\'s pension salary sacrifice settings has been updated.');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateTeamMemberPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamSchemeAeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamSchemeAeFormCtrl',
	templateUrl: 'forms/pension/team/scheme-ae/pension-team-scheme-ae.form.html'
})

.controller('pensionTeamSchemeAeFormCtrl', [
	'$q',
	'config',
	'growl',
	'pensionData',
	'pensionService',
	'teamData',
	'PENSION_STATUSES',
	function (
		$q,
		config,
		growl,
		pensionData,
		pensionService,
		teamData,
		PENSION_STATUSES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const userId = $ctrl.formOptions.userId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;

		// No pension
		if (!$ctrl.formOptions.company.HasPension) {
			setPageState('no-pension');
			return;
		}

		const getPensionsForAgency = pensionData.getPensionsForAgency(agencyProfileId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([getPensionsForAgency, getTeamMemberInformation])
			.then(([pensionsArr, teamMemberObj]) => {

				/* Try getting the AE pension based on identifiers. It could be set-up or not set-up, or for the main post or the additional post.
				   This will simply return the first AE pension if no identifiers have been provided */
				const selectedPension = pensionService.getTeamMemberAEPension(teamMemberObj.Pensions, agencyEmployerPensionId, pensionAdditionalPostId);

				angular.extend($ctrl, {
					agencyProfileId,
					isPensionSwitchEnabled: pensionService.getCanSwitchAEPension(teamMemberObj, pensionsArr),
					pensions: pensionsArr.filter(pensionService.isAEPension),
					selectedPension,
					userId
				});

				if ($ctrl.pensions.length === 0) {
					setPageState('no-pension');
					return;
				}

				setDefaultPension($ctrl);

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onAddedToPension () {

		// Wizard: Go to next step
		if ($ctrl.formOptions.isWizard) {

			angular.extend($ctrl.formOptions, {
				// Make sure agencyEmployerPensionId is kept in sync for Wizard
				agencyEmployerPensionId: $ctrl.selectedPension.AgencyEmployerPensionID,
				// Reset form context
				contextDataLoaded: false
			});

			// Excluded > Drop out of wizard
			if (!$ctrl.isNonAEPensionMode && $ctrl.selectedPension.PensionIsExcluded) {
				$ctrl.formOptions.closeWizard();
				$ctrl.formOptions.forceCallback();
				return;
			}

			$ctrl.formOptions.onSuccess();
			return;
		}

		growl.success($ctrl.formOptions.context.Forename + '\'s pension settings has been updated.');

		$ctrl.formOptions.forceCallback();
		$ctrl.formOptions.closeForm();
	}

	function setDefaultPension ($ctrl) {

		if ($ctrl.selectedPension.AgencyEmployerPensionID === config.guidEmpty) {
			$ctrl.selectedPension.AgencyEmployerPensionID = $ctrl.pensions[0].AgencyEmployerPensionID;
		}
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMemberPension ($ctrl) {

		$ctrl.$form.state = 'saving';

 		if ($ctrl.selectedPension.PensionIsExcluded) {
			$ctrl.selectedPension.PensionState = PENSION_STATUSES.excluded;
		}

		pensionData.updateTeamMemberPension($ctrl.selectedPension, $ctrl.userId, $ctrl.agencyProfileId)
			.then(onAddedToPension)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateTeamMemberPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamSchemeNonAeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamSchemeNonAeFormCtrl',
	templateUrl: 'forms/pension/team/scheme-non-ae/pension-team-scheme-non-ae.form.html'
})

.controller('pensionTeamSchemeNonAeFormCtrl', [
	'$q',
	'growl',
	'pensionData',
	'pensionService',
	'teamData',
	function (
		$q,
		growl,
		pensionData,
		pensionService,
		teamData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const userId = $ctrl.formOptions.userId;

		// No pension
		if (!$ctrl.formOptions.company.HasPension) {
			setPageState('no-pension');
			return;
		}

		const getPensionsForAgency = pensionData.getPensionsForAgency(agencyProfileId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([getPensionsForAgency, getTeamMemberInformation])
			.then(([pensionsArr, teamMemberObj]) => {

				angular.extend($ctrl, {
					agencyProfileId,
					pensions: pensionsArr.filter(getFilteredPensions(teamMemberObj)),
					selectedPension: null,
					userId
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function getFilteredPensions (teamMemberObj) {

		// Filter to get NonAE Pensions that team member isn't already a part of
		return companyPensionObj => {
			if (pensionService.isNonAEPension(companyPensionObj)) {
				return !pensionService.getTeamMemberPensionById(teamMemberObj.Pensions, companyPensionObj.AgencyEmployerPensionID);
			}
		};
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onAddedToPension () {

		// Wizard: Go to next step
		if ($ctrl.formOptions.isWizard) {

			angular.extend($ctrl.formOptions, {
				// Make sure agencyEmployerPensionId is kept in sync for Wizard
				agencyEmployerPensionId: $ctrl.selectedPension.AgencyEmployerPensionID,
				// Reset form context
				contextDataLoaded: false
			});

			$ctrl.formOptions.onSuccess();
			return;
		}

		growl.success($ctrl.formOptions.context.Forename + '\'s pension settings has been updated.');

		$ctrl.formOptions.forceCallback();
		$ctrl.formOptions.closeForm();
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateTeamMembersInPension ($ctrl) {

		$ctrl.$form.state = 'saving';

		const isInPension = true;

		pensionData.updateTeamMembersInPension($ctrl.agencyProfileId, [$ctrl.userId], $ctrl.selectedPension.AgencyEmployerPensionID, isInPension)
			.then(onAddedToPension)
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		updateTeamMembersInPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('pensionTeamStatusForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'pensionTeamStatusFormCtrl',
	templateUrl: 'forms/pension/team/status/pension-team-status.form.html'
})

.controller('pensionTeamStatusFormCtrl', [
	'$q',
	'$rootScope',
	'growl',
	'pensionData',
	'teamData',
	'utilities',
	'PENSION_STATUSES',
	function (
		$q,
		$rootScope,
		growl,
		pensionData,
		teamData,
		utilities,
		PENSION_STATUSES
	) {

	const $ctrl = this;

	function $onInit () {

		if (!$ctrl.formOptions.company.HasPension) {
			setPageState('no-pension');
			return;
		}

		setPageState('loading');

		const agencyProfileId = $ctrl.formOptions.agencyProfileId;
		const agencyEmployerPensionId = $ctrl.formOptions.agencyEmployerPensionId;
		const pensionAdditionalPostId = $ctrl.formOptions.pensionAdditionalPostId;
		const userId = $ctrl.formOptions.userId;

		const getTeamMemberCompanyDetails = teamData.getTeamMemberCompanyDetails(userId, agencyProfileId);
		const getTeamMemberPension = pensionData.getTeamMemberPension(agencyProfileId, agencyEmployerPensionId, userId, pensionAdditionalPostId);

		$q.all([getTeamMemberPension, getTeamMemberCompanyDetails])
			.then(([teamMemberPensionObj, teamMemberCompanyObj]) => {

				angular.extend($ctrl, {
					pension: teamMemberPensionObj,
					teamMemberCompany: teamMemberCompanyObj
				});

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function updateTeamMemberPension ($ctrl, formObj) {

		formObj.state = 'saving';

		// If team member is in pension but did not supply enrolment date we need to use either the start date or start date
		if (!$ctrl.pension.PensionIsExcluded && $ctrl.pension.PensionState !== PENSION_STATUSES.notEnrolled && $ctrl.pension.PensionEnrolledDateISO === '') {
			$ctrl.pension.PensionEnrolledDateISO = utilities.getLaterDateISO($ctrl.teamMemberCompany.StartDateISO, $ctrl.formOptions.company.StagingDateISO);
		}

		pensionData.updateTeamMemberPension($ctrl.pension, $ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				// Wizard: Go to next step
				if ($ctrl.formOptions.isWizard) {
					$ctrl.formOptions.onSuccess();
					return;
				}

				// Complete demo teamMemberObj
				$rootScope.setDemoTaskAsComplete('updateEmployeesPensionState', $ctrl.formOptions.context.Forename);

				growl.success($ctrl.formOptions.context.Forename + '\'s pension status has been updated.');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				formObj.state = 'saved';
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		PENSION_STATUSES,

		updateTeamMemberPension
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addPayslipLabelForm', function () {

	return {
		controller: 'addPayslipLabelFormCtrl',
		templateUrl: 'forms/company/addPayslipLabel/addPayslipLabelForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addPayslipLabelFormCtrl', ['$scope', '$timeout', 'adjustmentsService', 'config', 'payrollData', function ($scope, $timeout, adjustmentsService, config, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var emptyPayslipLabelModel = {
		AgencyAdjustmentLabelID: config.guidEmpty,
		AgencyProfileID: agencyProfileId,
		AgencyAdjustmentGroupEntryID: config.guidEmpty,
		AgencyAdjustmentLabelText: '',
		AdjustmentText: '',
		AgencyAdjustmentLabelVisible: true,
		Addition: true,
		CreatedDateISO: ''
	};

	function focusOn (elementId) {

		$timeout(function () {
			document.getElementById(elementId).focus();
		});
	}

	function init () {

		setPageState('loading');

		payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId).then(function (adjustmentGroupObj) {

			$scope.adjustmentTypes = adjustmentsService.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupObj.GroupEntries);

			setActiveTab('additions');
			setPageState('ready');
			focusOn('searchTermAdjustmentTypes');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function resetActiveAdjustmentType () {

		$scope.newAdjustmentLabel.adjustmentType = null;
	}

	function resetAdjustmentSearchTerm () {

		$scope.newAdjustmentLabel.searchTermAdjustmentTypes = '';
	}

	function resetLabelName (newAdjustmentLabelObj) {

		newAdjustmentLabelObj.adjustmentLabel.AgencyAdjustmentLabelText = '';
	}

	function setActiveAdjustmentType (adjustmentTypeObj) {

		var groupEntryId = adjustmentTypeObj.AgencyAdjustmentGroupEntryID === config.guidEmpty ? adjustmentTypeObj.AgencyAdjustmentParentGroupEntryID : adjustmentTypeObj.AgencyAdjustmentGroupEntryID;

		$scope.newAdjustmentLabel.adjustmentLabel.AgencyAdjustmentGroupEntryID = groupEntryId;
		$scope.newAdjustmentLabel.adjustmentType = adjustmentTypeObj;

		resetAdjustmentSearchTerm();
	}

	function setActiveTab (activeTabKey) {

		switch (activeTabKey) {
			case 'additions':
				$scope.deductionFilter = function (value) {
					return !value.IsDeduction;
				};
				break;
			case 'deductions':
				$scope.deductionFilter = function (value) {
					return value.IsDeduction;
				};
				break;
		}

		$scope.activeTab = activeTabKey;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.newAdjustmentLabel = {
		adjustmentLabel: angular.copy(emptyPayslipLabelModel),
		adjustmentLabelInputActive: false,
		adjustmentType: null,
		searchTermAdjustmentTypes: '',
		searchTermAdjustmentTypesFocused: true,
		searchResultsLimit: 20,
	};

	$scope.changeTab = function (activeTabKey) {

		setActiveTab(activeTabKey);
	};

	$scope.createNewAdjustmentLabel = function (newAdjustmentLabelObj, form) {

		form.state = 'saving';

		payrollData.updateAgencyAdjustmentLabel(newAdjustmentLabelObj).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = 'saved';
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	};

	$scope.resetActiveAdjustmentType = function (newAdjustmentLabelObj) {

		resetActiveAdjustmentType();
		resetLabelName(newAdjustmentLabelObj);
		focusOn('searchTermAdjustmentTypes');
	};

	$scope.showAllResults = function (newAdjustmentLabelObj) {

		newAdjustmentLabelObj.searchResultsLimit = null;
	};

	$scope.setActiveAdjustmentType = function (activeAdjustmentTypeObj) {
		
		setActiveAdjustmentType(activeAdjustmentTypeObj);
		focusOn('newAdjustmentLabel');
	};

	$scope.toggleSearchTermFocus = function (newAdjustmentLabelObj, newValue) {

		newAdjustmentLabelObj.searchTermAdjustmentTypesFocused = newValue;
	};

	$scope.toggleLabelInputFocus = function (newAdjustmentLabelObj, newValue) {

		newAdjustmentLabelObj.adjustmentLabelInputActive = newValue;
	};

}]);

'use strict';

angular.module('paycircleApp')
.component('bacsPennyTestForm', {
	controller: 'bacsPennyTestFormCtrl',
	templateUrl: 'forms/company/bacs-penny-test/bacs-penny-test.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('bacsPennyTestFormCtrl', [
	'$filter',
	'$q',
	'bankService',
	'base',
	'config',
	'reportData',
	'utilities',
	'BANK_FILE_FORMATS',
	function (
		$filter,
		$q,
		bankService,
		base,
		config,
		reportData,
		utilities,
		BANK_FILE_FORMATS
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		const getBankFiles = base.getBankFiles();
		const getEmptyTeamMemberBank = base.getEmptyTeamMemberBank();
		const getEmptyBankDetails = base.getEmptyBankDetails();

		$q.all([
			getBankFiles,
			getEmptyTeamMemberBank,
			getEmptyBankDetails
		]).then(([
			bankFilesArr,
			bankObj,
			companyBankObj
		]) => {

			// Attach to payee bank details to display in bank summary card
			bankObj.bacsPaymentDateIso = moment().toISOString();

			angular.extend($ctrl, {
				AGENCY_PROFILE_ID: $ctrl.formOptions.agencyProfileId,
				bankFiles: $filter('orderBy')(bankFilesArr, 'BankName'),
				payeeBank: bankObj,
				companyBank: companyBankObj,
				selectedBankFile: utilities.getArrayItemByPropertyName(bankFilesArr, 'BankID', companyBankObj.BankFileID)
			});

			selectBankFileInit($ctrl);

			setPageState('ready');
		})
		.catch(onError);
	}

	function generateTestPaymentFile ($ctrl, formObj) {

		formObj.state = 'saving';

		reportData.generateTestPaymentFile($ctrl.AGENCY_PROFILE_ID, $ctrl.companyBank, $ctrl.payeeBank, $ctrl.payeeBank.bacsPaymentDateIso, $ctrl.companyBank.BankFileID).then(bacsDownloadUrl => {

			$ctrl.bacsDownloadUrl = bacsDownloadUrl;

			setPageState('generated');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function selectBankFile ($ctrl) {

		if (angular.isDefined($ctrl.selectedBankFile)) {

			angular.extend($ctrl.companyBank, {
				BankFileID: $ctrl.selectedBankFile.BankID, // Unable to copy whole object over as this property is not consistently named
				BankName: $ctrl.selectedBankFile.BankName,
				IsBACSAvailable: $ctrl.selectedBankFile.IsBACSAvailable,
				IsFPSAvailable: $ctrl.selectedBankFile.IsFPSAvailable,
				IsGdffAvailable: $ctrl.selectedBankFile.IsGdffAvailable
			});
		}
		else {
			$ctrl.companyBank.BankFileID = config.guidEmpty;
		}
	}

	function selectBankFileInit ($ctrl) {

		selectBankFile($ctrl);

		if (angular.isDefined($ctrl.selectedBankFile)) {

			angular.extend($ctrl.companyBank, {
				BACSFileFormat: bankService.getBankFileFormat($ctrl.selectedBankFile, $ctrl.companyBank.BACSFileFormat)
			});
		}
	}

	function selectBankFileUpdate ($ctrl) {

		selectBankFile($ctrl);

		if (angular.isDefined($ctrl.selectedBankFile)) {

			angular.extend($ctrl.companyBank, {
				BACSFileFormat: bankService.getDefaultBankFileFormat($ctrl.selectedBankFile)
			});
		}
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	function isSunNumberApplicable ($ctrl) {

		return bankService.isSunNumberApplicable($ctrl.selectedBankFile, {
			bankFileFormat: $ctrl.companyBank.BACSFileFormat,
			isGdffAvailable: $ctrl.companyBank.IsGdffAvailable
		});
	}

	function isSunNumberRequired ($ctrl) {

		return bankService.isSunNumberRequired($ctrl.selectedBankFile, {
			bankFileFormat: $ctrl.companyBank.BACSFileFormat,
			isGdffAvailable: $ctrl.companyBank.IsGdffAvailable
		});
	}

	angular.extend($ctrl, {
		$onInit,
		BANK_FILE_FORMATS,
		generateTestPaymentFile,
		isSunNumberApplicable,
		isSunNumberRequired,
		selectBankFileUpdate,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('billingEnabledForm', function () {

	return {
		controller: 'billingEnabledFormCtrl',
		templateUrl: 'forms/company/billing-enabled/billingEnabledForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('billingEnabledFormCtrl', ['$rootScope', '$scope', 'payrollData', 'stateService', 'INTERFACE_TYPES', function ($rootScope, $scope, payrollData, stateService, INTERFACE_TYPES) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	setPageState('ready');

	$scope.INTERFACE_TYPES = INTERFACE_TYPES;

	$scope.updateIsBillingEnabled = function (isBillingEnabled, form) {

		form.state = 'saving';

		payrollData.updateIsBillingEnabled(agencyProfileId, isBillingEnabled).then(function () {

			// Update currentCompany so menu options are updated
			stateService.setCompany(agencyProfileId);

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('bulkAddToCompanyGroupForm', function () {

	return {
		controller: 'bulkAddToCompanyGroupFormCtrl',
		templateUrl: 'forms/company/bulkAddToCompanyGroup/bulkAddToCompanyGroupForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('bulkAddToCompanyGroupFormCtrl', ['$q', '$scope', 'companyData', 'config' , 'dataImportData', 'growl', 'session', 'base', 'INTERFACE_TYPES', function ($q, $scope, companyData, config, dataImportData, growl, session, base, INTERFACE_TYPES) {

	var agencyProfileIdList 	= $scope.formOptions.agencyProfileIdList;
	var agencyProfileParentId 	= $scope.formOptions.agencyProfileParentId;
	var loggedInUserId 			= session.getUserId();
	var interfaceType 			= INTERFACE_TYPES.group;

	function addCompaniesToCompanyGroup (companyGroup, form) {

		var removeFromGroup = false;

		// Update state
		form.state = 'saving';

		if (!$scope.isGroupCreationFeatureEnabled || !$scope.isGroupLinkedToOrganisation) {
			return companyData.updateAgencyProfileAgencyProfiles(agencyProfileIdList, companyGroup.Company.AgencyProfileID, removeFromGroup)
				.then(function() {
					$scope.pageState = 'success';
					$scope.formOptions.forceCallback();
					form.state = 'saved';
				});
		}

		// If both flags are enabled, check if the org is linked and get customer codes
		checkGroupOrganizationAndCustomerCodes(companyGroup, true)
			.then(function () {
				// Check each company's customer code against the organization's customer code
				var promises = [];
				var successfulCompanies = [];
				var failedCompanies = [];
				
				$scope.companies.forEach(function(company) {
					// If customer code is empty or doesn't match, add to failed companies
					if (!company.customerCode || company.customerCode !== $scope.organisationCustomerCode) {
						// Customer code doesn't match or is missing then mark as failed with the reason
						failedCompanies.push({
							name: company.name,
							agencyProfileId: company.agencyProfileId,
							customerCode: company.customerCode,
							reason: company.customerCode ? 'mismatch' : 'missing'
						});
					} else {
						// Customer code matches then link to the organization
						promises.push(
							dataImportData.linkCompanyToOrganisation(
								company.name,
								$scope.linkedOrganisationId
							)
							.then(function() {
								successfulCompanies.push({
									name: company.name,
									agencyProfileId: company.agencyProfileId
								});
							})
						);
					}
				});

				return $q.all(promises)
					.then(function() {
						$scope.successfulCompanies = successfulCompanies;
						$scope.failedCompanies = failedCompanies;

						if (failedCompanies.length > 0) {
							$scope.pageState = 'partial-success';
						} else {
							$scope.pageState = 'success';
						}

						var successfulAgencyProfileIds = successfulCompanies.map(function(company) {
							return company.agencyProfileId;
						});
						
						// Add only the successful companies to the group
						return companyData.updateAgencyProfileAgencyProfiles(successfulAgencyProfileIds, companyGroup.Company.AgencyProfileID, removeFromGroup);
					})
					.then(function() {
						$scope.formOptions.forceCallback();
						form.state = 'saved';
					});
			})
			.catch(function (error) {
				console.error('Error processing companies for group:', error);
				$scope.pageState = 'error';
				form.state = null;
			});
	}	
	
	// Fetch customer code and company details
	function fetchCompanyCustomerCode(agencyProfileId) {
		return companyData.getAgencyProfileCompanyDetails(agencyProfileId)
			.then(function(companyDetails) {
				const companyName = companyDetails && companyDetails.Name ? companyDetails.Name : 'Unknown Company';
				
				// Get customer code for the company
				return companyData.getCustomerCodeByAgencyProfileId(agencyProfileId)
					.then(function(customerCode) {
						return {
							agencyProfileId: agencyProfileId,
							name: companyName,
							customerCode: customerCode || ''
						};
					})
					.catch(function(error) {
						// If the customer code couldn't be retrieved, return the company details in order to be displayed in failedCompanies
						console.error('Error fetching customer code:', error);
						return {
							agencyProfileId: agencyProfileId,
							name: companyName,
							customerCode: ''
						};
					});
			})
			.catch(function(error) {
				console.error('Error fetching company details:', error);
				return {
					agencyProfileId: agencyProfileId,
					name: 'Unknown Company',
					customerCode: ''
				};
			});
	}

	// Check if the group is linked to an organization and validate customer codes
	function checkGroupOrganizationAndCustomerCodes(companyGroup, forSubmission) {
		if (!companyGroup) {
			$scope.isGroupLinkedToOrganisation = false;
			$scope.customerCodesMatch = true;
			$scope.organisationCustomerCode = '';
			return $q.resolve();
		}

		$scope.isGroupChecking = true;
		$scope.isGroupLinkedToOrganisation = false;
		$scope.organisationCustomerCode = '';
		$scope.companies = [];

		return base.isFeatureEnabled(agencyProfileParentId, 'GROUP_CREATION_ENABLED')
			.then(function(isFeatureEnabled) {
				$scope.isGroupCreationFeatureEnabled = isFeatureEnabled;
				
				if (!isFeatureEnabled) {
					return $q.resolve();
				}

				// Check if the group is linked to an organization
				return dataImportData.getLinkedOrganisationToGroupCompany(companyGroup.Company.AgencyProfileID);
			})
			.then(function(linkedOrganisationId) {
				if (!$scope.isGroupCreationFeatureEnabled) {
					return $q.resolve();
				}

				$scope.linkedOrganisationId = linkedOrganisationId;
				$scope.isGroupLinkedToOrganisation = linkedOrganisationId && linkedOrganisationId !== config.guidEmpty;
				
				if (!$scope.isGroupLinkedToOrganisation) {
					return $q.resolve();
				}

				if (forSubmission) {
					// Get customer codes and company details for all companies
					var customerCodePromises = agencyProfileIdList.map(function(id) {
						return fetchCompanyCustomerCode(id);
					});
					
					return $q.all(customerCodePromises)
						.then(function(companiesWithCodes) {
							$scope.companies = companiesWithCodes;
							
							// Get organization customer code
							return companyData.getOrganisationCustomerCode($scope.linkedOrganisationId);
						});
				} else {
					return companyData.getOrganisationCustomerCode($scope.linkedOrganisationId);
				}
			})
			.then(function(organisationCustomerCode) {
				if (!$scope.isGroupCreationFeatureEnabled || !$scope.isGroupLinkedToOrganisation) {
					return $q.resolve();
				}

				$scope.organisationCustomerCode = organisationCustomerCode || '';
			})
			.catch(function(error) {
				console.error('Error checking group organization and customer codes:', error);
			})
			.finally(function() {
				$scope.isGroupChecking = false;
			});
	}

	function init () {

		// Page state
		$scope.pageState = 'loading';

		companyData.getAgencyProfileAgencyProfilesForParent(loggedInUserId, agencyProfileParentId, interfaceType).then(function (availableGroupsArray) {

			// Assign to scope
			$scope.availableGroups = availableGroupsArray;

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();

	// Scope variables
	$scope.model = {
		companyGroup: null
	};
	$scope.agencyProfileIdList = agencyProfileIdList;
	$scope.isGroupCreationFeatureEnabled = false;
	$scope.isGroupLinkedToOrganisation = false;
	$scope.isGroupChecking = false;
	$scope.organisationCustomerCode = '';
	$scope.successfulCompanies = [];
	$scope.failedCompanies = [];
	$scope.companies = [];

	// Scope functions
	$scope.addCompaniesToCompanyGroup = function (companyGroup, form) {

		addCompaniesToCompanyGroup(companyGroup, form);
	};

	$scope.$watch('model.companyGroup', function(newVal) {
		checkGroupOrganizationAndCustomerCodes(newVal, false);
	});

	$scope.setPageState = function (pageState) {

		$scope.pageState = pageState;
	};
	
	$scope.closeForm = function() {
		$scope.formOptions.closeForm();
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('businessCodeForm', function () {

	return {
		controller: 'businessCodeFormCtrl',
		templateUrl: 'forms/company/business-code/business-code.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('businessCodeFormCtrl', [
	'$filter',
	'$scope',
	'agency',
	'config',
	'reportData',
	'userData',
	'utilities',
	'BUSINESS_CODE_FORM_STATES',
	function (
		$filter,
		$scope,
		agency,
		config,
		reportData,
		userData,
		utilities,
		BUSINESS_CODE_FORM_STATES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const businessCategoryObj = $scope.formOptions.businessCategory;
	const businessCodeId = $scope.formOptions.businessCodeId;
	const formState = $scope.formOptions.formState;

	function decorateBusinessCategory (businessCategoryObj) {

		angular.extend(businessCategoryObj, {
			businessCategoryNameCapitalised: $filter('capitalise')(businessCategoryObj.BusinessCategoryName),
			businessCategoryNameLowercase: $filter('lowercase')(businessCategoryObj.BusinessCategoryName)
		});

		businessCategoryObj.BusinessCodes.forEach(decorateBusinessCode);

		return businessCategoryObj;
	}

	function decorateBusinessCode (businessCodeObj) {

		angular.extend(businessCodeObj, {
			businessCodeNarrativeOriginal: angular.copy(businessCodeObj.BusinessCodeNarrative),
			isValid: true
		});
	}

	function decorateDepartmentAdmins (departmentAdminsArr) {

		for (let departmentAdminObj of departmentAdminsArr) {
			angular.extend(departmentAdminObj, {
				originalIsVisible: !departmentAdminObj.IsVisible
			});
		}

		return departmentAdminsArr;
	}

	function decorateTeamMemberObj (teamMemberObj) {

		angular.extend(teamMemberObj, {
			businessCodeIDOriginal: angular.copy(teamMemberObj.BusinessCodeID),
			moveToBusinessCode: null,
			isAdditionalPost: angular.isDefined(teamMemberObj.SalaryPolicyPostID) && teamMemberObj.SalaryPolicyPostID !== config.guidEmpty,
			isEditing: false
		});
	}

	function decorateTeamMembers (teamMembersArr) {

		teamMembersArr.forEach(decorateTeamMemberObj);

		return teamMembersArr;
	}

	function getBusinessCodeById (businessCategoryObj, businessCodeId) {

		const businessCodeObj = businessCategoryObj.BusinessCodes.find(bc => bc.BusinessCodeID === businessCodeId);

		businessCodeObj.isValid = true;

		return businessCodeObj;
	}

	function getIsBusinessCodeNarrativeValid (vmObj) {

		const numberOfBusinessCodes = vmObj.businessCategory.BusinessCodes.length;
		let i = 0;

		for (i; i < numberOfBusinessCodes; i++) {

			const businessCodeObj = vmObj.businessCategory.BusinessCodes[i];

			// Ignore when invalid for other reasons
			if (angular.isUndefined(vmObj.businessCode.BusinessCodeNarrative)) {
				return true;
			}

			// Ignore when empty
			if (vmObj.businessCode.BusinessCodeNarrative === '') {
				return true;
			}

			// Ignore current business code
			if (businessCodeObj.BusinessCodeID === vmObj.businessCode.BusinessCodeID) {
				continue;
			}

			// Flag duplicate name
			if (businessCodeObj.businessCodeNarrativeOriginal.toLowerCase() === vmObj.businessCode.BusinessCodeNarrative.toLowerCase()) {
				return false;
			}
		}

		return true;
	}

	function init () {

		setPageState(BUSINESS_CODE_FORM_STATES.loading);

		switch (formState) {

			case BUSINESS_CODE_FORM_STATES.create:
				initBusinessCodeCreate();
				break;

			case BUSINESS_CODE_FORM_STATES.delete:
				initBusinessCodeDelete();
				break;

			case BUSINESS_CODE_FORM_STATES.edit:
				initBusinessCodeEdit();
				break;

			case BUSINESS_CODE_FORM_STATES.manageTeamMembers:
				initBusinessCodeManageTeamMembers();
				break;

			case BUSINESS_CODE_FORM_STATES.manageVisibility:
				initBusinessCodeManageVisibility();
				break;
		}
	}

	function initBusinessCodeCreate () {

		reportData.getEmptyBusinessCode().then(emptyBusinessCodeObj => {

			emptyBusinessCodeObj.isValid = true;

			$scope.vm = {
				businessCategory: decorateBusinessCategory(businessCategoryObj),
				businessCode: emptyBusinessCodeObj
			};

			setPageState(BUSINESS_CODE_FORM_STATES.create);

			utilities.focusOn('businessCodeNarrative');
		})
		.catch(onError);
	}

	function initBusinessCodeDelete () {

		let businessCodeObj = getBusinessCodeById(businessCategoryObj, businessCodeId);

		businessCodeObj.BusinessCodeArchived = true;

		$scope.vm = {
			businessCategory: decorateBusinessCategory(businessCategoryObj),
			businessCode: businessCodeObj
		};

		setPageState(businessCodeObj.CanArchive ? BUSINESS_CODE_FORM_STATES.delete : BUSINESS_CODE_FORM_STATES.cannotDelete);
	}

	function initBusinessCodeEdit () {

		$scope.vm = {
			businessCategory: decorateBusinessCategory(businessCategoryObj),
			businessCode: getBusinessCodeById(businessCategoryObj, businessCodeId)
		};

		setPageState(BUSINESS_CODE_FORM_STATES.create);
	}

	function initBusinessCodeManageTeamMembers () {

		userData.getBusinessCodeMembers(agencyProfileId, businessCategoryObj.BusinessCategoryID, businessCodeId).then(teamMembersArr => {

			$scope.vm = {
				businessCategory: decorateBusinessCategory(businessCategoryObj),
				businessCode: getBusinessCodeById(businessCategoryObj, businessCodeId),
				hasChangeBeenMade: false,
				teamMembers: decorateTeamMembers(teamMembersArr)
			};

			setPageState(BUSINESS_CODE_FORM_STATES.manageTeamMembers);
		})
		.catch(onError);
	}

	function initBusinessCodeManageVisibility () {

		const businessCodeObj = getBusinessCodeById(businessCategoryObj, businessCodeId);

		agency.getAgencyDepartmentVisible(agencyProfileId, businessCodeObj.AgencyDepartmentID).then(departmentAdminsArr => {

			$scope.vm = {
				businessCategory: decorateBusinessCategory(businessCategoryObj),
				businessCode: businessCodeObj,
				departmentAdmins: decorateDepartmentAdmins(departmentAdminsArr),
				hasChangeBeenMade: false
			};

			setPageState(BUSINESS_CODE_FORM_STATES.manageVisibility);
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState(BUSINESS_CODE_FORM_STATES.error);
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleDepartmentVisibility (vmObj, isCompanyVisible) {

		for (let admin of vmObj.departmentAdmins) {
			admin.IsVisible = isCompanyVisible;
		}
	}

	function toggleIsEditing (vmObj, teamMemberObj) {

		teamMemberObj.isEditing = !teamMemberObj.isEditing;

		// Reset business code ID if no longer editing
		if (!teamMemberObj.isEditing) {
			teamMemberObj.BusinessCodeID = teamMemberObj.businessCodeIDOriginal;

			updateHasChangeBeenMade(vmObj);
		}
	}

	function updateAgencyDepartmentVisible (vmObj, formObj) {

		formObj.state = 'saving';

		agency.updateAgencyDepartmentVisible(agencyProfileId, vmObj.departmentAdmins).then(() => {

			setPageState(BUSINESS_CODE_FORM_STATES.visibilityUpdated);

			$scope.formOptions.forceCallback();
		})
		.catch(onError);
	}

	function updateBusinessCategory (vmObj, formObj) {

		formObj.state = 'saving';

		// Add new business code to list of business codes
		if (formState === BUSINESS_CODE_FORM_STATES.create) {
			vmObj.businessCategory.BusinessCodes.push(vmObj.businessCode);
		}

		reportData.updateBusinessCategory(agencyProfileId, vmObj.businessCategory).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(error => {
			onError(error);
			formObj.state = 'error';
		});
	}

	function updateTeamMemberBusinessCode (vmObj, teamMemberObj) {

		if (teamMemberObj.moveToBusinessCode) {

			teamMemberObj.BusinessCodeID = teamMemberObj.moveToBusinessCode;
		}

		updateHasChangeBeenMade(vmObj);
	}

	function updateBusinessCodeMembers (vmObj, formObj) {

		formObj.state = 'saving';

		userData.updateBusinessCodeMembers(agencyProfileId, vmObj.businessCode.BusinessCodeID, vmObj.businessCategory.BusinessCategoryID, vmObj.teamMembers).then(() => {

			setPageState(BUSINESS_CODE_FORM_STATES.teamUpdated);

			$scope.formOptions.forceCallback();

			formObj.state = 'saved';
		})
		.catch(error => {
			onError(error);
			formObj.state = 'error';
		});
	}

	function updateHasChangeBeenMade (vmObj) {

		function getHasChangeBeenMadeForPageState () {

			switch (formState) {
				case BUSINESS_CODE_FORM_STATES.manageTeamMembers:
					return vmObj.teamMembers.some(teamMemberObj => teamMemberObj.BusinessCodeID !== teamMemberObj.businessCodeIDOriginal);

				case BUSINESS_CODE_FORM_STATES.manageVisibility:
					return !vmObj.departmentAdmins.some(departmentAdminObj => departmentAdminObj.originalIsVisible !== departmentAdminObj.IsVisible);
			}
		}

		vmObj.hasChangeBeenMade = getHasChangeBeenMadeForPageState();
	}

	function validateBusinessCodeNarrative (vmObj) {

		vmObj.businessCode.isValid = getIsBusinessCodeNarrativeValid(vmObj);
	}

	init();

	angular.extend($scope, {
		BUSINESS_CODE_FORM_STATES,
		toggleDepartmentVisibility,
		toggleIsEditing,
		updateAgencyDepartmentVisible,
		updateBusinessCategory,
		updateBusinessCodeMembers,
		updateHasChangeBeenMade,
		updateTeamMemberBusinessCode,
		validateBusinessCodeNarrative
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyModulesForm', function () {

	return {
		controller: 'companyModulesFormCtrl',
		templateUrl: 'forms/company/companyModules/companyModulesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyModulesFormCtrl', ['$q', '$rootScope', '$scope', 'companyData', 'growl', function ($q, $rootScope, $scope, companyData, growl) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		companyData.getCompanyModuleDetails(agencyProfileId).then(companyModulesObj => {

			validateModuleSelection(companyModulesObj);
			$scope.companyModules = companyModulesObj;

			setPageState('ready');
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
		});

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateCompanyModules (companyModulesObj, formObj) {

		formObj.state = 'saving';

		companyData.updateCompanyModules(agencyProfileId, companyModulesObj).then(() => {

			$rootScope.$broadcast('set-current-company', agencyProfileId, () => {

				growl.success('Company module options have been updated');

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();

				formObj.state = null;
			});
		})
		.catch(error => {

			console.error(error);
			setPageState('error');
		});
	}

	function validateModuleSelection (companyModulesObj) {

		// At least 1 module needs to be active
		if (!companyModulesObj.IsPayrollActive && !companyModulesObj.IsPensionActive && !companyModulesObj.IsCISActive && !companyModulesObj.isHRActive && !companyModulesObj.IsOffPayrollActive && !companyModulesObj.IsExpatActive) {
			companyModulesObj.isModuleSelectionValid = false;
			companyModulesObj.moduleValidState = 'no-modules-selected';
		}

		// Cannot have CIS without payroll
		else if (companyModulesObj.IsCISActive && companyModulesObj.IsPensionActive && !companyModulesObj.IsPayrollActive) {
			companyModulesObj.isModuleSelectionValid = false;
			companyModulesObj.moduleValidState = 'no-pension-and-cis-without-payroll';
		}

		// Cannot have HR without payroll
		else if (companyModulesObj.IsHRActive && !companyModulesObj.IsPayrollActive) {
			companyModulesObj.isModuleSelectionValid = false;
			companyModulesObj.moduleValidState = 'no-hr-without-payroll';
		}

		// If Off-payroll is selected, payroll must be selected
		else if (companyModulesObj.IsOffPayrollActive && !companyModulesObj.IsPayrollActive) {
			companyModulesObj.isModuleSelectionValid = false;
			companyModulesObj.moduleValidState = 'no-off-payroll-without-payroll';
		}

		else {
			companyModulesObj.isModuleSelectionValid = true;
			companyModulesObj.moduleValidState = null;
		}

		return companyModulesObj;
	}

	init();

	$scope.updateCompanyModules = function (companyModulesObj, formObj) {

	    updateCompanyModules(companyModulesObj, formObj);
	};

	// Scope Watchers
	$scope.$watch('companyModules.IsPayrollActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});

	$scope.$watch('companyModules.IsPensionActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});

	$scope.$watch('companyModules.IsCISActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});

	$scope.$watch('companyModules.IsOffPayrollActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});

	$scope.$watch('companyModules.isHRActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});

	$scope.$watch('companyModules.IsExpatActive', function (oldValue, newValue) {
		if (newValue !== oldValue) {
			$scope.companyModules = validateModuleSelection($scope.companyModules);
		}
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyOverviewForm', function () {

	return {
		controller: 'companyOverviewFormCtrl',
		templateUrl: 'forms/company/companyOverview/companyOverviewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyOverviewFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$timeout',
	'agency',
	'companyData',
	'growl',
	'payrollData',
	'payrollWorker',
	'reportData',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		$timeout,
		agency,
		companyData,
		growl,
		payrollData,
		payrollWorker,
		reportData,
		STATE_TYPES,
		SUBMISSION_STATES
	) {

	const AGENCY_PROFILE_ID	= $scope.formOptions.agencyProfileId;
	const AGENCY_PROFILE_PARENT_ID = $scope.formOptions.agencyProfileParentId;
	const POLL_INTERVAL_PAYROLL = 5; // Seconds
	const POLL_INTERVAL_REPORTS = 2; // Seconds
	const SUB_STATES_TOTAL = 5;
	const isReportingVisible = $rootScope.currentUser.Permissions.isReportingVisible;

	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;

	let callback = $scope.formOptions.callback;

	function checkReportStatus (currentPayPeriodObj) {

		agency.getAgencyPayPeriodState(currentPayPeriodObj.PayPeriodID, STATE_TYPES.report).then(function (reportState) {

			// Update pay period
			currentPayPeriodObj.ReportState = reportState;

			switch (reportState) {
				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.submitting:

					$timeout(function () {
						checkReportStatus(currentPayPeriodObj);
					}, POLL_INTERVAL_REPORTS * 1000);

					break;
				case SUBMISSION_STATES.failed:

					setPageState('report-generation-failed');
					$rootScope.paycircleMessage('Company Overview: Pay period reports were unable to be calculated', 'error');

					break;
				default:

					// Show page
					refreshPayPeriod(currentPayPeriodObj);
			}
		});
	}

	function deleteCompany (companyObj) {

		setPageState('deleting-company');

		companyData.deleteAgencyProfile(companyObj.Company.AgencyProfileID).then(() => {
			
			// Redirect to companies and reload to remove deleted company
			$state.go('companies', {}, {
				reload: true
			});
		})
		.catch(() => {
			growl.error('There was a problem deleting ' + companyObj.Company.Name + '.');
		});
	}

	function cancelConfirmDeleteCompany () {

		$scope.formOptions.showContext = false;

		setPageState('ready');
	}

	function confirmDeleteCompany () {

		$scope.formOptions.showContext = true;

		setPageState('confirm-delete-company');
	}

	function generateReports (currentPayPeriodObj) {

		payrollWorker.payrollCreateReports(AGENCY_PROFILE_ID, currentPayPeriodObj.PayPeriodID).then(() => {

			checkReportStatus(currentPayPeriodObj);
		})
		.catch(function () {
			growl.warning('We were unable to generate your reports. Reload to try again.');
		});
	}

	function init () {

		setPageState('loading');

		companyData.getAgencyProfileAgencyProfile(AGENCY_PROFILE_ID).then(companyObj => {

			// Only fetch reports when the user can view reporting; report generation is separate and still runs.
			const getReports = isReportingVisible ? reportData.getReports(AGENCY_PROFILE_ID, companyObj.PayPeriod.PayPeriodID) : $q.when([]);

			getReports
				.then(reportsArr => {

					// Scope
					angular.extend($scope, {
						company: companyObj,
						reports: reportsArr,
					});

					setActivePeriodType('current');

					loadPage(companyObj.PayPeriod);
				})
				.catch(onError);
		})
		.catch(onError);
	}

	function loadPage (currentPayPeriodObj) {

		// Check report state
		if (currentPayPeriodObj.ReportState !== SUBMISSION_STATES.submitted) {
			generateReports(currentPayPeriodObj);
		}
		else {

			$scope.company.PayPeriod = currentPayPeriodObj;

			setPageState('ready');

			// Kick off polling for payroll state
			if (currentPayPeriodObj.PayrollState === SUBMISSION_STATES.submitting) {
				pollPayrollState(currentPayPeriodObj);
			}
		}
	}

	function openAddAChangeForm (companyObj) {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			callback: callback,
			currentPayPeriod: currentPayPeriodObj,
			formKey: 'add-a-change',
			payPeriod: companyObj.PayPeriod
		});
	}

	function openManageAdminsForm () {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			formKey: 'manage-admins'
		});
	}

	function openManageVisibilityForm () {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: AGENCY_PROFILE_ID,
			agencyProfileParentId: AGENCY_PROFILE_PARENT_ID,
			formKey: 'manage-visibility'
		});
	}

	function openRunPayrollForm (companyObj) {

		$scope.formOptions.openNewSlideInForm({
		    agencyProfileId: AGENCY_PROFILE_ID,
			callback: callback,
			formKey: 'run-payroll',
			title: companyObj.Company.PensionOnly ? 'Run period' : null
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
		$scope.formOptions.showHeader = true;
	}

	function pollPayrollState (currentPayPeriodObj) {

		// Load Pay Period state
		agency.getAgencyPayPeriodState(currentPayPeriodObj.PayPeriodID, STATE_TYPES.finalise).then(function (payPeriodState) {

			switch (payPeriodState) {

				case SUBMISSION_STATES.submitting:

					$timeout(function () {
						pollPayrollState(currentPayPeriodObj);
					}, POLL_INTERVAL_PAYROLL * 1000);

					currentPayPeriodObj.PayrollState = payPeriodState;

					break;

				case SUBMISSION_STATES.submitted:
				case SUBMISSION_STATES.failed:

					$timeout(function () {

						$scope.payPeriodSubState = SUB_STATES_TOTAL;

						currentPayPeriodObj.PayrollState = payPeriodState;

						refreshPayPeriod(currentPayPeriodObj);
					}, 2000);

					break;

				default:

					currentPayPeriodObj.PayrollState = payPeriodState;
			}

		})
		.catch(onError);
	}

	function refreshCompanyData () {

		// Update company card
		callback();

		init();
	}

	function refreshPayPeriod (currentPayPeriodObj) {

		payrollData.getPayPeriodSpecific(currentPayPeriodObj.PayPeriodID).then(function (updatedPayPeriodObj) {

			const getReports = isReportingVisible ? reportData.getReports(AGENCY_PROFILE_ID, currentPayPeriodObj.PayPeriodID) : $q.when([]);

			getReports
				.then(reportsArr => {

					$scope.reports = reportsArr;

					// Load page
					loadPage(updatedPayPeriodObj);
				})
				.catch(onError);
		})
		.catch(onError);
	}

	function setActivePeriodType (periodTypeKey) {
		$scope.activePeriodType = periodTypeKey;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		AGENCY_PROFILE_ID,
		SUBMISSION_STATES,

		cancelConfirmDeleteCompany,
		confirmDeleteCompany,
		deleteCompany,
		generateReports,
		openAddAChangeForm,
		openManageAdminsForm,
		openManageVisibilityForm,
		openRunPayrollForm,
		refreshCompanyData,
		setActivePeriodType,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyBankDetailsForm', function () {

	return {
		controller: 'companyBankDetailsFormCtrl',
		templateUrl: 'forms/company/companyBankDetails/companyBankDetailsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyBankDetailsFormCtrl', ['$scope', 'config', 'payrollData', function ($scope, config, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		payrollData.getCompanyDirectDebitMandate(agencyProfileId).then(function (directDebitMandateObj) {

			$scope.directDebit = directDebitMandateObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.updateCompanyDirectDebitMandateBank = function (updatedDirectDebitMandateObj, form) {

		form.state = 'saving';

		payrollData.updateCompanyDirectDebitMandateBank(agencyProfileId, updatedDirectDebitMandateObj.Bank).then(function () {
			
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			setPageState('success');
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};

	$scope.setPageState = function (pageState) {

		setPageState(pageState);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('companyBillingDetailsForm', function () {

	return {
		controller: 'companyBillingDetailsFormCtrl',
		templateUrl: 'forms/company/companyBillingDetails/companyBillingDetailsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyBillingDetailsFormCtrl', ['$scope', 'config', 'payrollData', function ($scope, config, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		payrollData.getCompanyDirectDebitMandate(agencyProfileId).then(function (directDebitMandateObj) {

			$scope.directDebit = directDebitMandateObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.updateGoCardlessDirectDebit = function (directDebitObj, form) {

		form.state = 'saving';

		payrollData.updateCompanyGoCardlessDetails(agencyProfileId, directDebitObj).then(function () {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			setPageState('success');
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};

	$scope.setPageState = function (pageState) {

		setPageState(pageState);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('companyBillingNameForm', function () {

	return {
		controller: 'companyBillingNameFormCtrl',
		templateUrl: 'forms/company/companyBillingName/companyBillingNameForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyBillingNameFormCtrl', ['$scope', 'growl', 'payrollData', function ($scope, growl, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;

	function init () {
		
		setPageState('loading');

        payrollData.getCompanyDirectDebitMandate(agencyProfileId).then(function (directDebitMandateObj) {

			$scope.directDebit = directDebitMandateObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.updateGoCardlessBillingName = function (directDebitObj, form) {

		form.state = 'saving';

		payrollData.updateGoCardlessDetailsBillingName(agencyProfileId, directDebitObj.CompanyName).then(function () {

			growl.success('Billing name has been updated.');
			
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('companyPayrollOverviewForm', function () {

	return {
		controller: 'companyPayrollOverviewFormCtrl',
		templateUrl: 'forms/company/payroll-overview/companyPayrollOverviewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('companyPayrollOverviewFormCtrl', ['$filter', '$q', '$rootScope', '$scope', 'companyData', 'onboardingService', 'payPeriodService', 'FORM_WIZARD_KEYS', 'PAY_PERIOD_TYPES_DESCRIPTIONS', 'PAYSLIP_DELIVERY_METHODS',
	function ($filter, $q, $rootScope, $scope, companyData, onboardingService, payPeriodService, FORM_WIZARD_KEYS, PAY_PERIOD_TYPES_DESCRIPTIONS, PAYSLIP_DELIVERY_METHODS) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var callback = $scope.formOptions.callback;
	var initCallbackOnClose	= $scope.formOptions.initCallbackOnClose;
	var questionGroupObj = $scope.formOptions.questionGroup;

	function getPayslipDeliveryMethodDescription (payslipDeliveryMethod) {

		var description = '';
		var descriptions = [];

		// Portal
		if ($filter('bitwiseCompare')(payslipDeliveryMethod, PAYSLIP_DELIVERY_METHODS.portal)) {
			descriptions.push('Email and view in secure portal');
		}

		// Portal
		if ($filter('bitwiseCompare')(payslipDeliveryMethod, PAYSLIP_DELIVERY_METHODS.emailPdf)) {
			descriptions.push('Email PDF');
		}

		// Portal
		if ($filter('bitwiseCompare')(payslipDeliveryMethod, PAYSLIP_DELIVERY_METHODS.print)) {
			descriptions.push('Print and hand deliver');
		}

		if (descriptions.length) {
			descriptions.forEach(function (descriptionItem, index) {

				description += descriptionItem;

				if (index !== descriptions.length - 1) {
					description += ', ';
				}
			});
		}

		else {
			description = 'No delivery methods';
		}

		return description;
	}

	function init () {

		var getPayPeriodDetails = companyData.getPayPeriodDetails(agencyProfileId);
		var getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);

		$q.all([getAgencyProfileCompanyInformationDetailed, getPayPeriodDetails]).then(function (data) {

			var companyDetailedObj = data[0];
			var companyPayPeriodDetailsObj = data[1];

			var questions = {
				payPeriods: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'payPeriods'),
				payrollContactDetails: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'payrollContactDetails'),
				payslipLogo: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'payslipLogo'),
				companyWorkWeekHours: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'companyWorkWeekHours'),
				smallEmployer: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'smallEmployer'),
				dayRateCalculationMethod: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'dayRateCalculationMethod'),
				employmentAllowance: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'employmentAllowance'),
				directorsNiCalculationMethod: onboardingService.getPayrollQuestionObjForQuestionKey(questionGroupObj.Questions, 'directorsNiCalculationMethod')
			};

			var taskListGroupsArray = [
				{
					groupTitle: 'Pay Periods',
					taskList: [
						{
							title: 'Frequency',
							value: PAY_PERIOD_TYPES_DESCRIPTIONS[companyPayPeriodDetailsObj.PayPeriodType],
							isComplete: questions.payPeriods.Complete,
							isMandatory: true,
							isSkipped: questions.payPeriods.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Start date of first period',
							value: companyPayPeriodDetailsObj.PeriodStartDateISO,
							isComplete: questions.payPeriods.Complete,
							isMandatory: true,
							isSkipped: questions.payPeriods.Skipped,
							valueType: 'date',
							wizardFormStepIndex: 0
						},
						{
							title: 'Payroll processing date',
							value: payPeriodService.getPaymentOptionById(companyPayPeriodDetailsObj.PayPeriodType, companyPayPeriodDetailsObj.PayPeriodPaymentDay) + (companyPayPeriodDetailsObj.PayPeriodPayInArrears ? ' (in arrears)' : ''),
							isComplete: questions.payPeriods.Complete,
							isMandatory: true,
							isSkipped: questions.payPeriods.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Pay date',
							value: payPeriodService.getPaymentOptionById(companyPayPeriodDetailsObj.PayPeriodType, companyPayPeriodDetailsObj.PayPeriodPayslipDisplayDay) + (companyPayPeriodDetailsObj.PayPeriodPayslipDisplayDayInArrears ? ' (in arrears)' : ''),
							isComplete: questions.payPeriods.Complete,
							isMandatory: true,
							isSkipped: questions.payPeriods.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 0
						},
						{
							title: 'Date to send pay notifications',
							value: payPeriodService.getPaymentOptionById(companyPayPeriodDetailsObj.PayPeriodType, companyPayPeriodDetailsObj.PayPeriodPayslipDay) + (companyPayPeriodDetailsObj.PayPeriodPayslipDayInArrears ? ' (in arrears)' : ''),
							isComplete: questions.payPeriods.Complete,
							isMandatory: true,
							isSkipped: questions.payPeriods.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 0
						}
					]
				},
				{
					groupTitle: 'Payslips',
					taskList: [
						{
							title: 'Payslip logo',
							value: questions.payslipLogo.Value,
							isComplete: questions.payslipLogo.Complete,
							isMandatory: questions.payslipLogo.Mandatory,
							isSkipped: questions.payslipLogo.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 1
						},
						{
							title: 'Payslip delivery method',
							value: getPayslipDeliveryMethodDescription(companyDetailedObj.Employer.PayslipDeliveryMethod),
							isComplete: questions.payslipLogo.Complete,
							isMandatory: questions.payslipLogo.Mandatory,
							isSkipped: questions.payslipLogo.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 1
						},
					]
				},
				{
					groupTitle: 'Payroll support contact',
					taskList: [
						{
							title: 'First name',
							value: companyDetailedObj.Contact.Forename,
							isComplete: questions.payrollContactDetails.Complete,
							isMandatory: questions.payrollContactDetails.Mandatory,
							isSkipped: questions.payrollContactDetails.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 2
						},
						{
							title: 'Last name',
							value: companyDetailedObj.Contact.Surname,
							isComplete: questions.payrollContactDetails.Complete,
							isMandatory: questions.payrollContactDetails.Mandatory,
							isSkipped: questions.payrollContactDetails.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 2
						},
						{
							title: 'Email',
							value: companyDetailedObj.Contact.EmailAddress,
							isComplete: questions.payrollContactDetails.Complete,
							isMandatory: questions.payrollContactDetails.Mandatory,
							isSkipped: questions.payrollContactDetails.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 2
						},
					]
				},
				{
					groupTitle: 'Standard work hours per week',
					taskList: [
						{
							title: 'Number of hours in a standard week',
							value: companyDetailedObj.WorkHoursPerWeek + ' hours',
							isComplete: questions.companyWorkWeekHours.Complete,
							isMandatory: questions.companyWorkWeekHours.Mandatory,
							isSkipped: questions.companyWorkWeekHours.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 3
						}
					]
				},
				{
					groupTitle: 'Day rate calculation',
					taskList: [
						{
							title: 'Method used',
							value: $filter('calculationMethodDescription')(companyDetailedObj.DayRateCalculationMethod),
							isComplete: questions.companyWorkWeekHours.Complete,
							isMandatory: questions.companyWorkWeekHours.Mandatory,
							isSkipped: questions.companyWorkWeekHours.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 4
						}
					]
				},
				{
					groupTitle: 'Small employer',
					taskList: [
						{
							title: 'Is a small employer',
							value: companyDetailedObj.Employer.SmallEmployer,
							isComplete: questions.smallEmployer.Complete,
							isMandatory: questions.smallEmployer.Mandatory,
							isSkipped: questions.smallEmployer.Skipped,
							valueType: 'boolean',
							wizardFormStepIndex: 5
						}
					]
				},
				{
					groupTitle: 'Employment allowance',
					taskList: [
						{
							title: 'Is entitled to employment allowance',
							value: companyDetailedObj.Employer.EmployersAllowanceEligible,
							isComplete: questions.employmentAllowance.Complete,
							isMandatory: questions.employmentAllowance.Mandatory,
							isSkipped: questions.employmentAllowance.Skipped,
							valueType: 'boolean',
							wizardFormStepIndex: 5
						},
						{
							title: 'Employment allowance claimed amount',
							value: companyDetailedObj.Employer.EmployersAllowanceUsed,
							isComplete: questions.employmentAllowance.Complete,
							isMandatory: questions.employmentAllowance.Mandatory,
							isHidden: !companyDetailedObj.Employer.EmployersAllowanceEligible,
							isSkipped: questions.employmentAllowance.Skipped,
							valueType: 'monetise',
							wizardFormStepIndex: 5
						}
					]
				},
				{
					groupTitle: 'Apprenticeship levy',
					taskList: [
						{
							title: 'Split the allowance with partner companies',
							value: companyDetailedObj.Employer.HasApprenticeshipAllowanceSplit,
							isComplete: questions.employmentAllowance.Complete,
							isMandatory: questions.employmentAllowance.Mandatory,
							isSkipped: questions.employmentAllowance.Skipped,
							valueType: 'boolean',
							wizardFormStepIndex: 5
						},
						{
							title: 'Allowance allocated',
							value: companyDetailedObj.Employer.ApprenticeshipLevyAmount,
							isComplete: questions.employmentAllowance.Complete,
							isMandatory: questions.employmentAllowance.Mandatory,
							isHidden: !companyDetailedObj.Employer.EmployersAllowanceEligible,
							isSkipped: questions.employmentAllowance.Skipped,
							valueType: 'monetary',
							wizardFormStepIndex: 5
						}
					]
				},
				{
					groupTitle: 'Directors NI calculation method',
					taskList: [
						{
							title: 'Calculation method used',
							value: companyDetailedObj.Employer.DirectorsNIStandardMethod ? 'Standard (cumulative)' : 'Alternative (non-cumulative)',
							isComplete: questions.directorsNiCalculationMethod.Complete,
							isMandatory: questions.directorsNiCalculationMethod.Mandatory,
							isSkipped: questions.directorsNiCalculationMethod.Skipped,
							valueType: 'value',
							wizardFormStepIndex: 6
						}
					]
				}
			];

			$scope.taskListGroups = taskListGroupsArray;

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.openEditCompanyPayrollWizard = function (activeStepIndex) {

		$scope.formOptions.openNewFormWizard({
			activeStepIndex: activeStepIndex,
			agencyProfileId: agencyProfileId,
			callback: callback,
			initCallbackOnClose: initCallbackOnClose,
			questionGroup: questionGroupObj,
			wizardKey: FORM_WIZARD_KEYS.companyPayroll
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('crossPeriodReportForm', function () {

	return {
		controller: 'crossPeriodReportFormCtrl',
		templateUrl: 'forms/company/crossPeriodReport/crossPeriodReportForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('crossPeriodReportFormCtrl', [
	'$scope',
	'dataTransfer',
	'payPeriodService',
	'payrollData',
	'reportsService',
	'utilities',
	'SUBMISSION_STATES',
	function (
		$scope,
		dataTransfer,
		payPeriodService,
		payrollData,
		reportsService,
		utilities,
		SUBMISSION_STATES
	) {

	const AGENCY_PROFILE_ID = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	let originalPayPeriods = [];

 	function generateReport (selectedPayPeriods, fileFormat) {

		reportsService.generateCostingsReportCrossPeriodXLS(selectedPayPeriods.payPeriodStart.PayPeriodID, selectedPayPeriods.payPeriodEnd.PayPeriodID, fileFormat).then(downloadUrl => {

			dataTransfer.downloadFile(downloadUrl, reportsService.getCostingsReportCrossPeriodReportName(selectedPayPeriods.payPeriodStart, selectedPayPeriods.payPeriodEnd, companyObj, fileFormat));
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		payrollData.getPayPeriods(AGENCY_PROFILE_ID, SUBMISSION_STATES.submitted).then(payPeriodsArr => {

			payPeriodsArr = payPeriodsArr.filter(payPeriodObj => payPeriodObj.PayrollState === SUBMISSION_STATES.submitted);

			if (payPeriodsArr.length < 2) {
				setPageState('not-available');
				return;
			}

			angular.extend($scope, {
				startPayPeriods: angular.copy(payPeriodsArr),
				endPayPeriods: angular.copy(payPeriodsArr),
			});

			// Remove last pay period as there are no future pay periods available to create cross period report
			$scope.startPayPeriods.pop();

			// Save to backup variable
			originalPayPeriods = angular.copy(payPeriodsArr);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function refreshEndPayPeriods (startPayPeriod) {

		let copyOfOriginalPayPeriods = angular.copy(originalPayPeriods);

		$scope.endPayPeriods = payPeriodService.getPayPeriodsAfterDateIso(copyOfOriginalPayPeriods, startPayPeriod.EndDateISO);
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.merge($scope, {
		fileFormat: 'excel',
		formOptions: {
			title: 'Create cross period report',
		},
		selectedPayPeriods: {
			payPeriodStart: null,
			payPeriodEnd: null
		},

		generateReport,
		refreshEndPayPeriods
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('customisationForm', function () {

	return {
		controller: 'customisationFormCtrl',
		templateUrl: 'forms/company/customisation/customisationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('customisationFormCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$state',
	'$timeout',
	'companyData',
	'customisationService',
	'intercomService',
	'session',
	'settingsService',
	'CUSTOMISATION_TYPES',
function (
	$filter,
	$rootScope,
	$scope,
	$state,
	$timeout,
	companyData,
	customisationService,
	intercomService,
	session,
	settingsService,
	CUSTOMISATION_TYPES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const loggedInUserParentCompanyId = session.user.AgencyProfileParentID;

	function refreshIfInCurrentCompany () {

		if (loggedInUserParentCompanyId === agencyProfileId) {
			window.location.reload();
		}
	}

	function init () {

		$scope.pageState = 'loading';

		$scope.formOptions.initCallbackOnClose = true; // Initialise callback on form close

		// Load customisation
		companyData.getCompanyCustomisation(agencyProfileId).then(function (customisationObj) {

			$scope.customisation = $filter('customisation')(customisationObj);
			$scope.intercomFormState = customisationObj.Intercom.AppID !== '' ? 'view' : 'edit';
			$scope.pageState = 'ready';

			if (customisationObj.Intercom.AppID !== '') {
				$rootScope.$broadcast('INTERCOM_CHANGE_STATE', 'connected');
			}
		})
		.catch(function () {
			$scope.pageState = 'error';
		});
	}

	function liveUpdate (updatedValue, propertyKey, subPropertyKey) {

		const returnObj = {
			updatedValue: angular.copy(updatedValue),
			propertyKey: propertyKey,
			subPropertyKey: subPropertyKey
		};

		$scope.formOptions.forceCallback(returnObj);
	}

	function refresh () {

		companyData.getCompanyCustomisation(agencyProfileId).then(function (customisationObj) {

			$scope.customisation = $filter('customisation')(customisationObj);
			$scope.formOptions.forceCallback();
		})
		.catch(function () {
			$scope.pageState = 'error';
		});
	}

	function refreshImages (propertyKey, subPropertyKey) {

		companyData.getCompanyCustomisation(agencyProfileId).then(function (customisationObj) {

			const updatedValue = $filter('cacheBust')(angular.copy(customisationObj[propertyKey][subPropertyKey]));

			$scope.customisation[propertyKey][subPropertyKey] = updatedValue;

			var returnObj = {
				updatedValue: angular.copy(updatedValue),
				propertyKey: propertyKey,
				subPropertyKey: subPropertyKey
			};

			$scope.formOptions.forceCallback(returnObj);
		})
		.catch(function () {
			$scope.pageState = 'error';
		});
	}

	function disconnectIntercomApp (intercomDetails) {

		intercomDetails.AppID = '';
		intercomDetails.VerificationSecret = '';

		companyData.updateCompanyCustomisationIntercom(agencyProfileId, intercomDetails).then(function () {

			$scope.formOptions.forceCallback();
			$rootScope.$broadcast('INTERCOM_CHANGE_STATE', 'connect');
		})
		.catch(function () {
			$scope.pageState = 'error';
		});
	}

	function testIntercomConnection (customisationObj) {

		customisationObj.testConnectionState = 'loading';

		intercomService.shutdownIntercom();
		intercomService.bootIntercomPublic(customisationObj);
		intercomService.showNewMessage();

		$rootScope.$broadcast('INTERCOM_CHANGE_STATE', null);

		$timeout(function () {
			customisationObj.testConnectionState = null;
		}, 1200);
	}

	function updateCompanyCustomisationBranding (brandingDetails, form) {

		form.state = 'saving';

		companyData.updateCompanyCustomisationBranding(agencyProfileId, brandingDetails).then(function () {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			refreshIfInCurrentCompany();
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function updateCompanyCustomisationEmail (emailDetails, form) {

		form.state = 'saving';

		companyData.updateCompanyCustomisationEmail(agencyProfileId, emailDetails).then(function () {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function updateCompanyCustomisationIntercom (intercomDetails, form) {

		form.state = 'saving';

		companyData.updateCompanyCustomisationIntercom(agencyProfileId, intercomDetails).then(function () {

			form.state = 'saved';
			intercomService.resetIntercom(session.user, session.customisation);
			$scope.formOptions.forceCallback();
			$rootScope.$broadcast('INTERCOM_CHANGE_STATE', 'connected');
			refreshIfInCurrentCompany();
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function updateCompanyCustomisationLogin (loginDetails, form) {

		form.state = 'saving';

		companyData.updateCompanyCustomisationLogin(agencyProfileId, loginDetails).then(function () {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			refreshIfInCurrentCompany();
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function updateCompanyCustomisationPayslip (payslipDetails, contactDetails, form) {

		form.state = 'saving';

		companyData.updateCompanyCustomisationPayslip(agencyProfileId, payslipDetails, contactDetails).then(function () {
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			refreshIfInCurrentCompany();
		})
		.catch(function () {
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	init();

	angular.extend($scope, {

		CUSTOMISATION_TYPES,

		agencyProfileId,
		customisationTab: $scope.formOptions.featureKey !== undefined ? $scope.formOptions.featureKey : 'login',
		carouselItems: customisationService.getCustomisationFeatures(companyObj.CompanyType),
		exitNgHref: settingsService.getNgHrefForSettingsState('customisation', companyObj),
		intercomTestSuccess: null,

		disconnectIntercomApp,
		liveUpdate,
		refresh,
		refreshImages,
		testIntercomConnection,
		updateCompanyCustomisationBranding,
		updateCompanyCustomisationEmail,
		updateCompanyCustomisationIntercom,
		updateCompanyCustomisationLogin,
		updateCompanyCustomisationPayslip
	});

	$scope.$on('$destroy', function () {
		intercomService.resetIntercom(session.user, session.customisation);
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePayslipLabelForm', function () {

	return {
		controller: 'deletePayslipLabelFormCtrl',
		templateUrl: 'forms/company/deletePayslipLabel/deletePayslipLabelForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePayslipLabelFormCtrl', ['$scope', 'payrollData', function ($scope, payrollData) {

	$scope.deletePayslipLabel = function (adjustmentLabelObj, adjustmentLabelDeletionState) {

		adjustmentLabelDeletionState = 'saving';

		adjustmentLabelObj.AgencyAdjustmentLabelVisible = false; // This flag is essentially the 'delete' trigger

		payrollData.updateAgencyAdjustmentLabel(adjustmentLabelObj).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			adjustmentLabelDeletionState = 'saved';
		})
		.catch(function () {
			$scope.pageState = 'error';
			adjustmentLabelDeletionState = null;
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('directDebitForm', function () {

	return {
		controller: 'directDebitFormCtrl',
		templateUrl: 'forms/company/directDebit/directDebitForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('directDebitFormCtrl', ['$q', '$scope', 'config', 'companyData', 'payrollData', function ($q, $scope, config, companyData, payrollData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var basicCompanyDetails	= $scope.formOptions.company;

	function init () {

		setPageState('loading');

		var getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);
		var getEmptyCompanyDirectDebitMandate = payrollData.getEmptyCompanyDirectDebitMandate(agencyProfileId);

		$q.all([getAgencyProfileCompanyInformationDetailed, getEmptyCompanyDirectDebitMandate]).then(function (data) {

			var companyObj = data[0];
			var emptyDirectDebitMandateObj = data[1];

			emptyDirectDebitMandateObj.useCompanyName = false;

			populateExistingCompanyDetails(emptyDirectDebitMandateObj, companyObj);

			$scope.company = companyObj;
			$scope.directDebit = emptyDirectDebitMandateObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function populateExistingCompanyDetails (emptyDirectDebitMandateObj, companyObj) {

		var existingAddress = angular.copy(companyObj.Address);

		existingAddress.AddressID = config.guidEmpty; // Remove address ID to prevent updates to original address

		emptyDirectDebitMandateObj.BillingAddress = existingAddress;
		emptyDirectDebitMandateObj.CompanyName = angular.copy(basicCompanyDetails.Name);
		emptyDirectDebitMandateObj.PrimaryContact.Forename = angular.copy(companyObj.Contact.Forename);
		emptyDirectDebitMandateObj.PrimaryContact.Surname = angular.copy(companyObj.Contact.Surname);
		emptyDirectDebitMandateObj.PrimaryContact.EmailAddress = angular.copy(companyObj.Contact.EmailAddress);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setPreviousPageState () {

		$scope.previousPageState = angular.copy($scope.pageState);
	}

	function toggleUseCompanyName (directDebitObj) {

		directDebitObj.useCompanyName = !directDebitObj.useCompanyName;
	}

	init();

	$scope.closeForm = function () {

		$scope.formOptions.forceCallback();
		$scope.formOptions.closeForm();
	};

	$scope.createGoCardlessDirectDebit = function (directDebitObj, form) {

		// Reset values
		if (directDebitObj.useCompanyName) {
			directDebitObj.PrimaryContact.Forename = '';
			directDebitObj.PrimaryContact.Forename = '';
		}
		else {
			directDebitObj.CompanyName = '';
		}

		form.state = 'saving';

		payrollData.createGoCardlessDirectDebit(agencyProfileId, directDebitObj).then(function () {
			
			$scope.formOptions.initCallbackOnClose = true;
			form.state = 'saved';
			setPageState('success');
		})
		.catch(function () {
			setPageState('error');
			form.state = null;
		});
	};

	$scope.setPageState = function (pageState) {
		setPreviousPageState();
		setPageState(pageState);
	};

	$scope.toggleUseCompanyName = function (directDebitObj) {

		toggleUseCompanyName(directDebitObj);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('historicTaxPeriodForm', function () {

	return {
		controller: 'historicTaxPeriodFormCtrl',
		templateUrl: 'forms/company/historicTaxPeriod/historicTaxPeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('historicTaxPeriodFormCtrl', [
	'$q', 
	'$scope', 
	'payrollData',
	function(
		$q, 
		$scope, 
		payrollData
	) {

	const company = $scope.formOptions.company;
	const historicPayPeriodId = $scope.formOptions.historicPayPeriodId;

	const FORM_EDIT_STATES = {
		createNew: 'createNew',
		viewOrEdit: 'viewOrEdit'
	};

	function saveHistoricTaxPeriod (form, agencyPaymentObj) {
		form.state = 'saving';
		payrollData.updateAgencyPaymentHistorical(company.AgencyProfileID, agencyPaymentObj).then((result) => {
			if (result === 0) {
				$scope.formOptions.forceCallback();
				form.state = 'saved';
				setPageState('success');
			}
			else {
				form.state = 'error';
				setPageState('error');
			}
		})
		.catch(error => {
			form.state = 'error';
			console.error(error);
			setPageState('error');
		});

	}

	function init () {

		setPageState('loading');

		// Get set of historical pay periods
		const getHistoricalTaxPeriods = payrollData.getHistoricalTaxPeriods(company.AgencyProfileID);

		// View/edit, or create new? If there's an historic pay period in formOptions, it's edit.
		if (angular.isDefined(historicPayPeriodId)) {

			// It's view/edit
			$scope.formEditState = FORM_EDIT_STATES.viewOrEdit;

			// Get existing agency payment object for populating with goodness
			const getAgencyPayment = payrollData.getAgencyPayment(historicPayPeriodId);

			$q.all([getHistoricalTaxPeriods, getAgencyPayment]).then(([historicalTaxPeriods, agencyPayment]) => {

				historicalTaxPeriods = historicalTaxPeriods.filter(historicalTaxPeriod => {
					return historicalTaxPeriod.TaxPeriodID === agencyPayment.AgencyPayPeriodID;
				});

				agencyPayment.payPeriods = historicalTaxPeriods;
				agencyPayment.selectedPayPeriod = angular.isDefined(historicalTaxPeriods[0]) ? historicalTaxPeriods[0] : null;

				// Add the pay period display to the agency payment.
				angular.extend($scope, {
					agencyPayment
				});

				// Refresh the calculated total
				recalculateHMRCDueAmount(agencyPayment);

				// Get the pay period from the pretend AgencyProfileID
				setPageState('ready');
			})
			.catch(onError);
		}
		else {
			// It's create new
			$scope.formEditState = FORM_EDIT_STATES.createNew;

			// Get an empty agency payment object for populating with goodness
			const getAgencyPaymentEmpty = payrollData.getAgencyPaymentEmpty();

			$q.all([getHistoricalTaxPeriods, getAgencyPaymentEmpty]).then(([historicalTaxPeriods, agencyPaymentEmpty]) => {

				let agencyPayment = agencyPaymentEmpty;

				/* Remove extant pay periods from the historical period options. You can't create a historical pay period
				for a pay period that already exists. Obviously. */
				let extantPayPeriodIds = $scope.formOptions.extantPayPeriods.map(extantPayPeriod => {
					return extantPayPeriod.AgencyPayPeriodID;
				});
				historicalTaxPeriods = historicalTaxPeriods.filter(historicalTaxPeriod => {
					return !extantPayPeriodIds.includes(historicalTaxPeriod.TaxPeriodID);
				});

				agencyPayment.payPeriods = historicalTaxPeriods;
				agencyPayment.selectedPayPeriod = null;

				// Add to scope
				angular.extend($scope, {
					agencyPayment
				});

				if (agencyPayment.payPeriods.length === 0) {
					setPageState('no-historic-periods');
				}
				else {
					setPageState('ready');
				}
			})
			.catch(onError);
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function recalculateHMRCDueAmount (agencyPaymentObj) {

		let totalDue = 0;
		// https://www.notion.so/paycircle/Historic-P32-Numbers-2c462a7f6cae4f6fb84d38201977c7bc#628e9ffbd1094e498ee23986c7f394f4
		/* jshint ignore:start */
		/* This has been arranged to explicitly show what is added and what is subtracted as part of the total calculation. Default any
           undefined or null values to zero */
		totalDue = agencyPaymentObj.AgencyPaymentTax
				 + agencyPaymentObj.AgencyPaymentEENI
				 + agencyPaymentObj.AgencyPaymentERNI
				 + agencyPaymentObj.AgencyPaymentSL
				 + agencyPaymentObj.AgencyPaymentPGL
				 - agencyPaymentObj.AgencyPaymentEmployerAllowance
				 - agencyPaymentObj.AgencyPaymentSMPRecovered
				 - agencyPaymentObj.AgencyPaymentSPPRecovered
				 - agencyPaymentObj.AgencyPaymentSAPRecovered
				 - agencyPaymentObj.AgencyPaymentShPPRecovered
				 - agencyPaymentObj.AgencyPaymentSPBPRecovered
				 - agencyPaymentObj.AgencyPaymentSNCPRecovered
				 + agencyPaymentObj.AgencyPaymentAdvanceFundingReclaimed
				 + agencyPaymentObj.AgencyPaymentCISDeduction
				 - agencyPaymentObj.AgencyPaymentCISDeductionSuffered
				 + agencyPaymentObj.AgencyPaymentLevyAmount
		/* jshint ignore:end */

		agencyPaymentObj.totalDue = totalDue;
	}

	function selectedPayPeriodChange (agencyPaymentObj, payPeriodObj) {

		// Set corresponding attributes on agencyPayment
		agencyPaymentObj.AgencyPayPeriodID = payPeriodObj.TaxPeriodID;
		agencyPaymentObj.AgencyPaymentDateISO = payPeriodObj.TaxPeriodPayDateISO;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		// Constants
		FORM_EDIT_STATES,

		// Functions
		recalculateHMRCDueAmount,
		saveHistoricTaxPeriod,
		selectedPayPeriodChange
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('journalCodeFormatForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'journalCodeFormatFormCtrl',
	templateUrl: 'forms/company/journal-code-format/journal-code-format.form.html'
})

.controller('journalCodeFormatFormCtrl', [
	'$q',
	'journalsService',
	'reportData',
	'utilities',
	'JOURNAL_CODE_DELIMITER_TYPES',
	function (
		$q,
		journalsService,
		reportData,
		utilities,
		JOURNAL_CODE_DELIMITER_TYPES
	) {

	const $ctrl = this;

	let lastSelectedDelimiter = JOURNAL_CODE_DELIMITER_TYPES.dash;

	function $onInit () {

		setFormState('loading');

		const getJournalCodeFormatForAgency = reportData.getJournalCodeFormatForAgency($ctrl.formOptions.agencyProfileId);
		const getNominalCodeListForAgency = reportData.getNominalCodeListForAgency($ctrl.formOptions.agencyProfileId);
		const getBusinessCategoryListForAgency = reportData.getBusinessCategoryListForAgency($ctrl.formOptions.agencyProfileId);

		$q.all([
			getJournalCodeFormatForAgency,
			getNominalCodeListForAgency,
			getBusinessCategoryListForAgency
		]).then(([
			journalCodeFormatObj,
			nominalCodesArr,
			businessCategoriesArr
		]) => {

			const journalCodesArr = journalsService.getJournalCodesByFormat(journalCodeFormatObj);

			angular.extend($ctrl, {
				businessCategories: businessCategoriesArr,
				DELIMITER_SELECT_OPTIONS: [
					{
						description: 'Dash',
						value: JOURNAL_CODE_DELIMITER_TYPES.dash
					},
					{
						description: 'Forward slash',
						value: JOURNAL_CODE_DELIMITER_TYPES.forwardSlash
					},
					{
						description: 'Space',
						value: JOURNAL_CODE_DELIMITER_TYPES.space
					}
				],
				journalCodes: journalCodesArr,
				journalCodesActive: angular.copy(journalCodesArr.filter(_ => _.isActive)),
				journalCodesHidden: angular.copy(journalCodesArr.filter(_ => _.isHidden)),
				journalCodeFormat: journalsService.decorateJournalCodeFormat(journalCodeFormatObj),
				nominalCodes: journalsService.sortNominalCodes(nominalCodesArr)
			});

			journalsService.generateFullJournalCodePreview($ctrl.journalCodesActive, $ctrl.nominalCodes, $ctrl.businessCategories);

			setFormState('ready');
		})
		.catch(onError);
	}

	function decrementCodePosition ($ctrl, $index) {

		// Unable to increment if first
		if ($index === ($ctrl.journalCodesActive.length - 1)) {
			return;
		}

		$ctrl.journalCodesActive = utilities.moveItemInArray($ctrl.journalCodesActive, $index, $index + 1);

		reOrderJournalCodes($ctrl);

		journalsService.generateFullJournalCodePreview($ctrl.journalCodesActive, $ctrl.nominalCodes, $ctrl.businessCategories);
	}

	function getJournalCodeFormatByJournalCodes (journalCodeFormatObj, journalCodesActiveArr, journalCodesHiddenArr) {

		// Update original format obj
		journalCodesActiveArr.forEach(journalCodeObj => {
			journalCodeFormatObj[journalCodeObj.key] = journalCodeObj.value;
		});

		// Update hidden flags
		journalCodesHiddenArr.forEach(journalCodeObj => {
			journalCodeFormatObj[journalCodeObj.key] = -1;
		});

		return journalCodeFormatObj;
	}

	function incrementCodePosition ($ctrl, $index) {

		// Unable to increment if last
		if ($index === 0) {
			return;
		}

		$ctrl.journalCodesActive = utilities.moveItemInArray($ctrl.journalCodesActive, $index, $index - 1);

		reOrderJournalCodes($ctrl);

		journalsService.generateFullJournalCodePreview($ctrl.journalCodesActive, $ctrl.nominalCodes, $ctrl.businessCategories);
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function reOrderJournalCodes ($ctrl) {

		$ctrl.journalCodesActive.forEach((journalCodeObj, $index) => {
			journalCodeObj.value = $index;
		});
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function unhideJournalCode ($ctrl, originalIndex) {

		let journalCodeIndex = utilities.getArrayItemIndexByPropertyName($ctrl.journalCodesHidden, 'originalIndex', originalIndex);
		let journalCodeObj = $ctrl.journalCodesHidden[journalCodeIndex];

		journalCodeObj.value = $ctrl.journalCodesActive.length;

		$ctrl.journalCodesActive.push(journalCodeObj);
		$ctrl.journalCodesHidden.splice(journalCodeIndex, 1);

		reOrderJournalCodes($ctrl);

		journalsService.generateFullJournalCodePreview($ctrl.journalCodesActive, $ctrl.nominalCodes, $ctrl.businessCategories);
	}

	function hideJournalCode ($ctrl, originalIndex) {

		let journalCodeIndex = utilities.getArrayItemIndexByPropertyName($ctrl.journalCodesActive, 'originalIndex', originalIndex);
		let journalCodeObj = $ctrl.journalCodesActive[journalCodeIndex];

		journalCodeObj.value = -1;

		$ctrl.journalCodesHidden.unshift(journalCodeObj);
		$ctrl.journalCodesActive.splice(journalCodeIndex, 1);

		reOrderJournalCodes($ctrl);

		journalsService.generateFullJournalCodePreview($ctrl.journalCodesActive, $ctrl.nominalCodes, $ctrl.businessCategories);
	}

	function reviewDelimiter ($ctrl) {

		if ($ctrl.journalCodeFormat.JournalCodeFormatDelimiter !== JOURNAL_CODE_DELIMITER_TYPES.none) {
			// Prevent user needing to re-select delimiter if they toggle 'Use delimiter' off then on again
			lastSelectedDelimiter = $ctrl.journalCodeFormat.JournalCodeFormatDelimiter;
		}

		if (!$ctrl.journalCodeFormat.isDelimited) {
			$ctrl.journalCodeFormat.JournalCodeFormatDelimiter = JOURNAL_CODE_DELIMITER_TYPES.none;
		}
		else if ($ctrl.journalCodeFormat.JournalCodeFormatDelimiter === JOURNAL_CODE_DELIMITER_TYPES.none) {
			$ctrl.journalCodeFormat.JournalCodeFormatDelimiter = lastSelectedDelimiter;
		}

		$ctrl.journalCodeFormat = journalsService.decorateJournalCodeFormat($ctrl.journalCodeFormat);
	}

	function updateJournalCodeFormat ($ctrl, formObj) {

		// Update state
		formObj.state = 'saving';

		$ctrl.journalCodeFormat = getJournalCodeFormatByJournalCodes($ctrl.journalCodeFormat, $ctrl.journalCodesActive, $ctrl.journalCodesHidden);

		// Service call
		reportData.updateJournalCodeFormat($ctrl.formOptions.agencyProfileId, $ctrl.journalCodeFormat).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		decrementCodePosition,
		hideJournalCode,
		incrementCodePosition,
		reviewDelimiter,
		unhideJournalCode,
		updateJournalCodeFormat
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('journalCodeFinancialsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'journalCodeFinancialsFormCtrl',
	templateUrl: 'forms/company/journal-code-financials/journal-code-financials.form.html'
})

.controller('journalCodeFinancialsFormCtrl', [
	'$q',
	'journalsService',
	'reportData',
	'BUSINESS_CATEGORY_TYPES',
	function (
		$q,
		journalsService,
		reportData,
		BUSINESS_CATEGORY_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		const getAccessFinancialsJournalCodePreview = reportData.getAccessFinancialsJournalCodePreview($ctrl.formOptions.agencyProfileId);
		const getAccessFinancialsNominalCategories = reportData.getAccessFinancialsNominalCategories($ctrl.formOptions.agencyProfileId);
		const getBusinessCategoryListForAgency = reportData.getBusinessCategoryListForAgency($ctrl.formOptions.agencyProfileId);
		const getJournalCodeFormatForAgency = reportData.getJournalCodeFormatForAgency($ctrl.formOptions.agencyProfileId);

		$q.all([
			getAccessFinancialsJournalCodePreview,
			getAccessFinancialsNominalCategories,
			getBusinessCategoryListForAgency,
			getJournalCodeFormatForAgency,
		]).then(([
			accessFinancialsJournalCodePreviewObj,
			accessFinancialsCategoriesArr,
			businessCategoriesArr,
			journalCodeFormatObj
		]) => {

			angular.extend($ctrl, {
				accessFinancialsCategories: decorateAccessFinancialsCategories(accessFinancialsCategoriesArr, businessCategoriesArr),
				financialsJournalCode: accessFinancialsJournalCodePreviewObj,
				journalCodeFormat: journalsService.decorateJournalCodeFormat(journalCodeFormatObj),
				journalCodePreview: '',
				paycircleCategories: businessCategoriesArr
			});

			updateJournalCodePreview();

			setFormState('ready');
		})
		.catch(onError);
	}

	function decorateAccessFinancialsCategories (accessCategoriesArr, paycircleCategoriesArr) {
		
		accessCategoriesArr.forEach(accessCatObj => {

			accessCatObj.paycircleCategory = paycircleCategoriesArr
				.find(paycircleCatObj => paycircleCatObj.BusinessCategoryType === accessCatObj.MappedType);

			if (accessCatObj.paycircleCategory) {
				accessCatObj.paycircleCategory.hasControlAccountCode = accessCatObj.paycircleCategory.BusinessCategoryDefaultCodeValue !== '';
			}
		});

		return accessCategoriesArr.sort(sortByCodePosition);
	}

	function sortByCodePosition (a, b) {

		if (a.CodePosition < b.CodePosition) {			
			return -1;
		}
		else if (a.CodePosition > b.CodePosition) {		
			return 1;
		}
		else {		
			return 0;
		}
	}

	function selectPaycircleCategory (formObj, accessFinancialsCategory) {
		
		$ctrl.accessFinancialsCategories.forEach(financialsCategoryObj => {
			
			if (financialsCategoryObj.ID === accessFinancialsCategory.ID) {
				// Assign the type of the mapped Paycircle category to the financials category
				financialsCategoryObj.MappedType = financialsCategoryObj.paycircleCategory.BusinessCategoryType;
			}
			else if (financialsCategoryObj.paycircleCategory &&
				financialsCategoryObj.paycircleCategory.BusinessCategoryType === accessFinancialsCategory.paycircleCategory.BusinessCategoryType) {
				// Unmap any other Financials categories mapped to the Paycircle category
				financialsCategoryObj.paycircleCategory = undefined;
				formObj['selectField-' + financialsCategoryObj.ID].$setTouched(true);
			}
		});

		updateJournalCodePreview($ctrl, accessFinancialsCategory);
	}

	function updateJournalCodePreview () {

		$ctrl.journalCodePreview = '';

		$ctrl.accessFinancialsCategories.forEach(financialsCategoryObj => {
			
			if (financialsCategoryObj.CodePosition > 0) {
				
				if (financialsCategoryObj.CodePosition > 1) {
					$ctrl.journalCodePreview += $ctrl.journalCodeFormat.delimiterChar;
				}

				if (financialsCategoryObj.IsNominalDetailCategory) {
					$ctrl.journalCodePreview += 'NC';
				}
				else if (financialsCategoryObj.paycircleCategory) {
					$ctrl.journalCodePreview += getJournalCodePreviewPart(financialsCategoryObj.paycircleCategory);
				}
				else {
					$ctrl.journalCodePreview += '[?]';
				}
			}
		});
	}

	function getJournalCodePreviewPart (businessCategory) {

		switch (businessCategory.BusinessCategoryType) {
			case BUSINESS_CATEGORY_TYPES.role:
				return 'ROLE';
			case BUSINESS_CATEGORY_TYPES.department:
				return 'DPT';
			case BUSINESS_CATEGORY_TYPES.branch:
				return 'BR';
			case BUSINESS_CATEGORY_TYPES.costCentre:
				return 'CC';
			case BUSINESS_CATEGORY_TYPES.sector:
				return 'SEC';
			default:
				return '';
		} 
	}

	function updateFinancialsCategoryMappings ($ctrl, formObj) {
		
		formObj.state = 'saving';

		let updatedBusinessCategories = [];
		$ctrl.accessFinancialsCategories.forEach(financialsCategoryObj => {

			if (financialsCategoryObj.paycircleCategory) {

				if (!financialsCategoryObj.paycircleCategory.hasControlAccountCode) {
					financialsCategoryObj.paycircleCategory.BusinessCategoryDefaultCodeValue = '';
				}

				updatedBusinessCategories.push(financialsCategoryObj.paycircleCategory);
			}
		});

		const updateAccessFinancialsNominalCategoryMappings = reportData.updateAccessFinancialsNominalCategoryMappings($ctrl.formOptions.agencyProfileId, $ctrl.accessFinancialsCategories);
		const UpdateBusinessCategoriesDefaultCodeValue = reportData.updateBusinessCategoriesDefaultCodeValue($ctrl.formOptions.agencyProfileId, updatedBusinessCategories);

		$q.all([
			updateAccessFinancialsNominalCategoryMappings,
			UpdateBusinessCategoriesDefaultCodeValue
		]).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		selectPaycircleCategory,
		updateFinancialsCategoryMappings
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('journalPostTemporalDataForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'journalPostTemporalDataFormCtrl',
	templateUrl: 'forms/company/journal-post-temporal-data/journal-post-temporal-data.form.html'
})

.controller('journalPostTemporalDataFormCtrl', [
	'config',
	'reportData',
	'SUBMISSION_STATES',
	function (
		config,
		reportData,
		SUBMISSION_STATES
	) {

	const $ctrl = this;
	const TEMPORAL_DATA_ENUM = {
		payroll: 0,
		latest: 1
	};

	function $onInit () {

		setFormState('loading');

		if ($ctrl.formOptions.postContext === 'add') {
			$ctrl.formOptions.postGroup.JournalPostID = config.guidEmpty;
		}

		if ($ctrl.formOptions.postContext !== 'edit' && hasUnsubmittedPost($ctrl.formOptions.postGroup) ) {
			setFormState('post-outstanding');
		}
		else {
			setFormState('ready');
		}
	}

	function hasUnsubmittedPost (postGroupObj) {

		const numberOfPosts = postGroupObj.posts.length;
		let i = 0;

		for (i; i < numberOfPosts; i++) {
			switch (postGroupObj.posts[i].JournalPostState) {

				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.failed:
					return true;
				default:
					return false;
			}
		}

		return false;
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	function updateJournalPostSettings (postGroupObj, formObj) {

		formObj.state = 'saving';

		// Convert Enum to boolean
		postGroupObj.JournalPostOverrideTemporalData = postGroupObj.journalPostOverrideTemporalDataEnum === TEMPORAL_DATA_ENUM.latest;

		reportData.updateJournalPost($ctrl.formOptions.agencyProfileId, postGroupObj).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,
		updateJournalPostSettings,
		TEMPORAL_DATA_ENUM
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('payslipManagerForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'payslipManagerFormCtrl',
	templateUrl: 'forms/company/payslip-manager/payslip-manager.form.html'
})

.controller('payslipManagerFormCtrl', [
	'$scope',
	'$state',
	'companyData',
	'growl',
	'DOCUMENT_TYPES',
	function (
		$scope,
		$state,
		companyData,
		growl,
		DOCUMENT_TYPES
	) {

	const $ctrl = this;

	function $onInit () {
		setPageState($ctrl.formOptions.formState);
	}

	function goToBulkImporter ($ctrl) {

		$state.go('data-importer.upload-file', {
			agencyDocumentType: DOCUMENT_TYPES.payslipManagerFullRun,
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			form: 'payslip-manager',
			payPeriodId: $ctrl.formOptions.payPeriodId
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function updateAgencyProfileIsPayslipManagerSetupComplete ($ctrl, $form) {

		$form.state = 'saving';

		const isSetupComplete = true;

		companyData.updateAgencyProfileIsPayslipManagerSetupComplete($ctrl.formOptions.agencyProfileId, isSetupComplete)
			.then(() => {

				growl.success('Bulk import skipped');
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		goToBulkImporter,
		updateAgencyProfileIsPayslipManagerSetupComplete
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('peopleHrUpdatesDataForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'peopleHrUpdatesDataCtrl',
	templateUrl: 'forms/company/people-hr-updates-data/people-hr-updates-data.form.html'
})

.controller('peopleHrUpdatesDataCtrl', [
	'$filter',
	'$q',
	'$timeout',
	'growl',
	'PEOPLE_HR_UPDATES_EVENT_STATUS',
	'PEOPLE_HR_UPDATES_EVENT_NAMES',
	'EDP_UPDATES_FRIENDLY_ERROR_MAP',
	'REGEX',
	'teamData',
	function (
		$filter,
		$q,
		$timeout,
		growl,
		PEOPLE_HR_UPDATES_EVENT_STATUS,
		PEOPLE_HR_UPDATES_EVENT_NAMES,
		EDP_UPDATES_FRIENDLY_ERROR_MAP,
		REGEX,
		teamData
	) {

	const $ctrl = this;

	// EDP payload dates arrive as ISO-like strings with seconds and no trailing 'Z'
	// (e.g. 2026-07-30T00:00:00), so REGEX.dateIso does not match them.
	const EDP_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

	const FORM_CONTEXT = {
		default: 'default',
		confirmRetry: 'confirmRetry',
		retry: 'retry',
		retryResults: 'retryResults',
		error: 'error'
	};

	const FORM_STATE = {
		ready: 'ready',
		loading: 'loading'
	};

	function buildErrorMessageList () {
		const msgList = $ctrl.data.ErrorMessage.split(',');
		return msgList;
	}

	function confirmRetry () {
		setPageContext(FORM_CONTEXT.confirmRetry);
	}

	function loadEventData (refreshPeopleHrPageEvents) {

		setPageState(FORM_STATE.loading);

		if ($ctrl.isBulk) {
			confirmRetry();
			setPageState(FORM_STATE.ready);
			return;
		}

		if ($ctrl.isEdp) {
			loadEdpEventData();
			return;
		}

		setPageContext(FORM_CONTEXT.default);
		$ctrl.formOptions.isCloseFormDisabled = false;

		teamData.getIntegrationEvent($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.messageId)
			.then(dataObj => {
				// Get the data for this event
				$ctrl.data = dataObj;

				// Process the body data
				$ctrl.processedBodyData = processBodyData($ctrl.data.Body);

				// Update the event specific key names of the processed body data
				$ctrl.processedBodyData = updateEventSpecificKeyNames($ctrl.data, $ctrl.processedBodyData);

				setPageState(FORM_STATE.ready);

				if ($ctrl.data.ErrorMessage.length >= 1) {
					// Convert the error messages into an array
					$ctrl.errorMessageList = buildErrorMessageList();
				}

				if (refreshPeopleHrPageEvents) {
					// Refresh the peopleHR page using this callback function
					$ctrl.formOptions.callback();
				}
			})
			.catch(onError);
	}

	function onError (error) {
		setPageContext(FORM_CONTEXT.error);
		setPageState(FORM_STATE.ready);
		$ctrl.formOptions.isCloseFormDisabled = false;
		console.error(error);
	}

	function onCancelClick () {
		if ($ctrl.isBulk) {
			$ctrl.formOptions.closeForm();
			return;
		}

		$ctrl.setPageContext($ctrl.FORM_CONTEXT.default);
	}

	function performRetry () {

		if ($ctrl.isMixed) {
			performMixedRetry();
			return;
		}

		if ($ctrl.isEdp) {
			performEdpRetry();
			return;
		}

		setPageState(FORM_STATE.loading);
		setPageContext(FORM_CONTEXT.retry);
		// Disable the form close button while the retry is happening
		$ctrl.formOptions.isCloseFormDisabled = true;

		const messageIds = $ctrl.isBulk ? $ctrl.formOptions.messageId : [$ctrl.formOptions.messageId];

		teamData.retryMultipleIntegrationEvents($ctrl.formOptions.agencyProfileId, messageIds)
			.then(() => {
				checkEventStatus($ctrl.formOptions.agencyProfileId, messageIds);
			})
			.catch(onError);
	}

	function loadEdpEventData () {

		setPageContext(FORM_CONTEXT.default);
		$ctrl.formOptions.isCloseFormDisabled = false;

		teamData.getEdpEvent($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.eventId)
			.then(eventData => {

				$ctrl.data = eventData;
				$ctrl.parsedPayload = processEdpPayloadData(eventData.EdpEventBody);
				$ctrl.canRetry = eventData.EdpEventStatus === PEOPLE_HR_UPDATES_EVENT_STATUS.failed ||
					eventData.EdpEventStatus === PEOPLE_HR_UPDATES_EVENT_STATUS.skipped;

				// Surface any error/warning as a friendly message, mirroring the PeopleHR data screen.
				const edpMessages = eventData.EdpEventErrorMessage ? eventData.EdpEventErrorMessage.split(/\r?\n/).filter(Boolean) : [];
				$ctrl.edpErrorMessageList = edpMessages.map(message => EDP_UPDATES_FRIENDLY_ERROR_MAP[message] || message);

				setPageState(FORM_STATE.ready);
			})
			.catch(onError);
	}

	function processEdpPayloadData (payloadJson) {

		if (!payloadJson) {
			return [];
		}

		try {
			const parsed = angular.fromJson(payloadJson);
			return flattenEdpObject(parsed);
		}
		catch (e) {
			console.error('Failed to parse EDP event payload:', e);
			return [];
		}
	}

	function flattenEdpObject (obj, prefix) {

		let result = [];

		angular.forEach(obj, function (value, key) {

			const heading = prefix ? prefix + '.' + key : key;

			if (angular.isObject(value) && !angular.isArray(value) && value !== null) {
				result = result.concat(flattenEdpObject(value, heading));
			}
			else {
				result.push({
					// Show a readable label from the leaf key only (drop any nested path prefix).
					heading: processEdpPayloadKeyText(key),
					value: formatEdpPayloadValue(value)
				});
			}
		});

		return result;
	}

	function formatEdpPayloadValue (value) {

		if (angular.isArray(value)) {
			return angular.toJson(value);
		}

		const stringValue = String(value);

		// Format ISO date values to a readable date, consistent with the PeopleHR data table.
		return EDP_DATE_REGEX.test(stringValue) ? $filter('dateformat')(stringValue, 'numeric') : stringValue;
	}

	function processEdpPayloadKeyText (key) {

		const mapKeyText = {
			absenceId: 'Absence ID',
			actualBirthDate: 'Actual Birth Date',
			actualEndDate: 'Actual End Date',
			actualStartDate: 'Actual Start Date',
			durationUnit: 'Duration Unit',
			endDate: 'End Date',
			endDateFraction: 'End Date Fraction',
			expectedDueDate: 'Expected Due Date',
			isToil: 'Is TOIL',
			payrollCompanyId: 'Payroll Company',
			reason: 'Reason',
			startDate: 'Start Date',
			startDateFraction: 'Start Date Fraction',
			totalDays: 'Total Days',
			totalHours: 'Total Hours',
			totalMinutes: 'Total Minutes'
		};

		return mapKeyText[key] ? mapKeyText[key] : key;
	}

	function performEdpRetry () {

		setPageState(FORM_STATE.loading);
		setPageContext(FORM_CONTEXT.retry);
		$ctrl.formOptions.isCloseFormDisabled = true;

		const eventIds = $ctrl.isBulk ? $ctrl.formOptions.eventId : [$ctrl.formOptions.eventId];

		teamData.retryEdpEvents($ctrl.formOptions.agencyProfileId, eventIds)
			.then(() => {

				growl.success($ctrl.isBulk ? eventIds.length + ' events queued for retry.' : 'Event queued for retry.');
				$ctrl.formOptions.isCloseFormDisabled = false;

				if ($ctrl.formOptions.callback) {
					$ctrl.formOptions.callback();
				}

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function performMixedRetry () {

		setPageState(FORM_STATE.loading);
		setPageContext(FORM_CONTEXT.retry);
		$ctrl.formOptions.isCloseFormDisabled = true;

		const eventIds = $ctrl.formOptions.eventId;
		const messageIds = $ctrl.formOptions.messageId;

		$q.all([
			teamData.retryEdpEvents($ctrl.formOptions.agencyProfileId, eventIds),
			teamData.retryMultipleIntegrationEvents($ctrl.formOptions.agencyProfileId, messageIds)
		])
			.then(() => {

				growl.success((eventIds.length + messageIds.length) + ' events queued for retry.');
				$ctrl.formOptions.isCloseFormDisabled = false;

				if ($ctrl.formOptions.callback) {
					$ctrl.formOptions.callback();
				}

				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function checkEventStatus (agencyProfileID, messageIds, attempt) {
		attempt = attempt || 1;
		const pollDelay = 3; // seconds
		const maxAttempts = 10;

		teamData.getRetriedEvents(agencyProfileID, messageIds)
			.then(eventData => {
				if (eventData.HasCompletedProcessing) {
					setPageState(FORM_STATE.ready);
					setPageContext(FORM_CONTEXT.retryResults);
					$ctrl.formOptions.isCloseFormDisabled = false;

					angular.extend($ctrl, {
						countOfEvents: eventData.IntegrationEvents.length,
						countOfFailedEvents: eventData.IntegrationEvents.filter(e => e.Status === PEOPLE_HR_UPDATES_EVENT_STATUS.failed).length,
						countOfSuccessfulEvents: eventData.IntegrationEvents.filter(e => e.Status === PEOPLE_HR_UPDATES_EVENT_STATUS.complete).length,
						integrationEvents: eventData.IntegrationEvents
					});
				}
				else if (attempt >= maxAttempts) {
					onError(new Error('The event status check timed out after approximately 30 seconds.'));
				}
				else {
					$ctrl.checkEventStatusTimeout = $timeout(() => {
						checkEventStatus(agencyProfileID, messageIds, attempt + 1);
					}, pollDelay * 1000);
				}
			})
			.catch(onError);
	}

	function processBodyData (bodyJson) {

		if (!bodyJson) {
			return [];
		}

		let bodyObj;

		try {
			// Convert the body into an object as it is a JSON string
			bodyObj = JSON.parse(bodyJson);
		}
		catch (e) {
			console.error('Failed to parse integration event body:', e);
			return [];
		}

		let bodyArr = [];

		for (const key in bodyObj) {

			if (key) {
				const value = bodyObj[key];

				// Check for a value that is an object
				if (angular.isObject(value)) {
					// This value is an object
					for (const keyInner in value) {
						if (keyInner) {
							bodyArr.push({
								key: `${key}${keyInner}`,
								value: value[keyInner]
							});
						}
					}
				} else {
					bodyArr.push({key, value });
				}
			}
		}

		//  Remove any items where the value is null
		bodyArr = bodyArr.filter(item => item.value !== null);

		// Loop through all items in the array
		for (const item of bodyArr) {
			const currValue = item.value;
			// Check if this value matches the date format 2023-07-01T00:00Z
			if (REGEX.dateIso.test(currValue)) {
				item.value = $filter('dateformat')(currValue, 'numeric');
			}
		}

		return bodyArr;
	}

	function processBodyKeyText (key) {

		const mapKeyText = {
			AccountName: 'Account Name',
			AccountNumber: 'Account Number',
			AddressCountry: 'Country',
			AddressCountyState: 'County',
			AddressLine1: 'Address Line 1',
			AddressLine2: 'Address Line 2',
			AddressPostCode: 'Postcode',
			AddressTownCity: 'City',
			BankCode: 'Bank Code',
			BankName: 'Bank Name',
			ContractedHours: 'Contracted Hours',
			DateOfBirth: 'Date Of Birth',
			DeductionId: 'Deduction ID',
			EffectiveFrom: 'Effective From',
			EmployeeId: 'Employee ID',
			EmployeeName: 'Employee Name',
			Entitlement: 'Addition',
			EntitlementId: 'Addition ID',
			FinalEmployeeDate: 'Final Employee Date',
			FirstName: 'First Name',
			Id: 'ID',
			IncludeInSalary: 'Include In Salary',
			JobRole: 'Job Role',
			LastName: 'Last Name',
			NiNumber: 'NI Number',
			// This property is spelt incorrectly in the JSON body that it returned.
			// The correct spelling is added here below just incase it is fixed later
			OrginalEffectiveFrom: 'Original Effective From',
			OriginalEffectiveFrom: 'Original Effective From',
			OriginalEmployeeId: 'Original Employee ID',
			OriginalPayrollCompany: 'Original Payroll Company',
			OtherNames: 'Other Names',
			PaycircleSubscriptionId: 'Paycircle Subscription ID',
			PaymentDate: 'Payment Date',
			PaymentFrequency: 'Payment Frequency',
			PaymentId: 'Addition ID',
			PayrollCompany: 'Payroll Company',
			PersonalEmail: 'Personal Email',
			PersonalPhone: 'Personal Phone',
			ReasonForLeaving: 'Reason For Leaving',
			SalaryAmount: 'Salary Amount',
			SalarySalaryType: 'Salary Type',
			SalaryType: 'Salary Type',
			StartDate: 'Start Date',
			WorkPhone: 'Work Phone'
		};

		return mapKeyText[key] ? mapKeyText[key] : key;
	}

	function updateEventSpecificKeyNames (eventData, processedBodyData) {
		if (eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentCreated ||
			eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentDeleted ||
			eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffPaymentUpdated) {
			// Modify the key of the PayElementName to Addition
			processedBodyData = processedBodyData.map(item => {
				if (item.key === 'PayElementName') {
					item.key = 'Addition';
				}
				return item;
			});
		}
		else if (eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionCreated ||
			eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionDeleted ||
			eventData.Name === PEOPLE_HR_UPDATES_EVENT_NAMES.oneOffDeductionUpdated) {
			// Modify the key of the PayElementName to Deduction
			processedBodyData = processedBodyData.map(item => {
				if (item.key === 'PayElementName') {
					item.key = 'Deduction';
				}
				return item;
			});
		}
		return processedBodyData;
	}

	function setPageContext (context) {
		$ctrl.pageContext = context;
	}

	function setPageState (formState) {
		$ctrl.pageState = formState;
	}

	function $onInit () {

		const hasEdp = angular.isDefined($ctrl.formOptions.eventId);
		const hasPeopleHr = angular.isDefined($ctrl.formOptions.messageId);

		// A bulk retry selection can contain both EDP and PeopleHR events. isEdp stays
		// reserved for a pure-EDP flow (single event review + EDP-only retry).
		const isMixed = hasEdp && hasPeopleHr;
		const isEdp = hasEdp && !hasPeopleHr;
		const isBulk = angular.isArray($ctrl.formOptions.eventId) || angular.isArray($ctrl.formOptions.messageId);

		const edpCount = angular.isArray($ctrl.formOptions.eventId) ? $ctrl.formOptions.eventId.length : 0;
		const peopleHrCount = angular.isArray($ctrl.formOptions.messageId) ? $ctrl.formOptions.messageId.length : 0;

		angular.extend($ctrl, {
			bulkRetryCount: edpCount + peopleHrCount,
			isBulk,
			isEdp,
			isMixed
		});

		if ($ctrl.isBulk) {
			$ctrl.formOptions.title = isEdp ? 'Retry EDP updates' : 'Retry updates';
		}

		loadEventData(false);
	}

	function $onDestroy () {
		if ($ctrl.checkEventStatusTimeout) {
			$timeout.cancel($ctrl.checkEventStatusTimeout);
			$ctrl.checkEventStatusTimeout = null;
		}
	}

	angular.extend($ctrl, {
		$onInit,
		$onDestroy,
		FORM_CONTEXT,
		FORM_STATE,
		PEOPLE_HR_UPDATES_EVENT_STATUS,
		confirmRetry,
		edpErrorMessageList: [],
		errorMessageList: [],
		onCancelClick,
		performRetry,
		processBodyKeyText
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('postToXeroForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'postToXeroFormCtrl',
	templateUrl: 'forms/company/post-to-xero/post-to-xero.form.html'
})

.controller('postToXeroFormCtrl', [
	'$q',
	'payrollData',
	'reportData',
	function (
		$q,
		payrollData,
		reportData
	) {

	const $ctrl = this;
	const JOURNAL_POST_RESPONSES = {
		success: 0,
		failedToConnect: 1,
		failedToPost: 2
	};
	const XERO_POST_STATES = {
		draft: 1,
		final: 0
	};

	function $onInit () {

		setFormState('loading');

		const getXeroConnection = reportData.getXeroConnection($ctrl.formOptions.agencyProfileId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum($ctrl.formOptions.agencyProfileId);

		$q.all([getXeroConnection, getPayPeriodMinimum]).then(
			([xeroConnectionObj, payPeriodObj]) => {

				if (!xeroConnectionObj.IsCompanyStateValidForConnection) {
					// View should be unreachable without a valid connection
					setFormState('error');
				} else {
					$ctrl.formOptions.postObj.submitAsFinalEnum = $ctrl.formOptions.postObj.SubmitAsFinal ? XERO_POST_STATES.final : XERO_POST_STATES.draft;

					angular.extend($ctrl, {
						XERO_POST_STATES,
						payPeriod: payPeriodObj
					});

					setFormState('ready');
				}
			})
			.catch(onError);
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function postToXero ($ctrl) {

		setFormState('posting');

		const submitAsFinalBool = $ctrl.formOptions.postObj.submitAsFinalEnum === XERO_POST_STATES.final;

		reportData.postJournal($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.postObj.AgencyPayPeriodID, $ctrl.formOptions.postObj.SupplementaryPaymentID, submitAsFinalBool).then(postJournalResponseObj => {

			$ctrl.postJournalResponse = postJournalResponseObj;

			switch (postJournalResponseObj.Response) {

				case JOURNAL_POST_RESPONSES.failedToConnect:

					setFormState('failed-to-connect');
					break;

				case JOURNAL_POST_RESPONSES.failedToPost:

					$ctrl.formOptions.forceCallback();

					setFormState('failed-to-post');
					break;

				case JOURNAL_POST_RESPONSES.success:

					$ctrl.formOptions.forceCallback();

					setFormState('posted');
					break;
			}
		})
		.catch(onError);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		postToXero
	});
}]);

'use strict';

angular
.module('paycircleApp')

.component('postToFinancialsForm', {
	bindings: {
		formOptions: '=',
	},
	controller: 'postToFinancialsFormCtrl',
	templateUrl: 'forms/company/post-to-financials/post-to-financials.form.html',
})

.controller('postToFinancialsFormCtrl', [
	'$q',
	'payrollData',
	'reportData',
	function (
		$q,
		payrollData,
		reportData
	) {
	const $ctrl = this;
	
	const JOURNAL_POST_RESPONSES = {
		success: 0,
		failedToConnect: 1,
		failedToPost: 2,
	};
	
	function $onInit() {
		setFormState('loading');

		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(
			$ctrl.formOptions.agencyProfileId
		);

		$q.all([getPayPeriodMinimum])
			.then(([payPeriodObj]) => {

				angular.extend($ctrl, {
					payPeriod: payPeriodObj,
				});

				setFormState('ready');
			})
			.catch(onError);
	}

	function onError(error) {
		setFormState('error');
		console.error(error);
	}

	function postToFinancials($ctrl) {
		setFormState('posting');

		const submitAsFinalBool = false; // Always post to Financials as draft

		reportData
			.postJournal(
				$ctrl.formOptions.agencyProfileId,
				$ctrl.formOptions.postObj.AgencyPayPeriodID,
				$ctrl.formOptions.postObj.SupplementaryPaymentID,
				submitAsFinalBool
			)
			.then((postJournalResponseObj) => {
				$ctrl.postJournalResponse = postJournalResponseObj;

				switch (postJournalResponseObj.Response) {
					case JOURNAL_POST_RESPONSES.failedToConnect:
						setFormState('failed-to-connect');
						break;

					case JOURNAL_POST_RESPONSES.failedToPost:
						$ctrl.formOptions.forceCallback();
						setFormState('failed-to-post');
						break;

					case JOURNAL_POST_RESPONSES.success:
						$ctrl.formOptions.forceCallback();
						setFormState('posted');
						break;
				}
			})
			.catch(onError);
	}

	function setFormState(formState) {
		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		postToFinancials,
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('resolvePayPeriodDatesForm', {
	bindings: {
		formOptions: '<'
	},
	controller: 'resolvePayPeriodDatesFormCtrl',
	templateUrl: 'forms/company/resolve-pay-period-dates/resolve-pay-period-dates.form.html'
})

.controller('resolvePayPeriodDatesFormCtrl', [
	'$timeout',
	'payPeriodDateResolutionService',
	function (
		$timeout,
		payPeriodDateResolutionService
	) {

	const $ctrl = this;

	const ITEMS_PER_PAGE = 10;

	// Dates are resolved as the start date is entered, so requests are held back while it is being typed
	const RESOLUTION_DELAY = 500;

	let resolutionTimeout;

	function $onInit () {

		setPageState('loading');
		setResolutionState('empty');

		const normalisedPeriodsObj = payPeriodDateResolutionService.normalisePeriods($ctrl.formOptions.periods);

		$ctrl.invalidPeriods = normalisedPeriodsObj.invalidPeriods;
		$ctrl.periods = normalisedPeriodsObj.periods;

		/* Resolving dates for only some of the periods would silently leave the caller without
		   dates for those periods, so anything we can't understand stops the whole form */
		if ($ctrl.invalidPeriods.length) {
			setPageState('invalid-periods');
			return;
		}

		if (!$ctrl.periods.length) {
			setPageState('no-periods');
			return;
		}

		$ctrl.anchorPeriod = payPeriodDateResolutionService.getAnchorPeriod($ctrl.periods);
		$ctrl.anchorPeriodLabel = payPeriodDateResolutionService.getPeriodLabel($ctrl.anchorPeriod);

		setPageState('ready');
	}

	function $onDestroy () {

		cancelPendingResolution();
	}

	function cancelPendingResolution () {

		if (resolutionTimeout) {
			$timeout.cancel(resolutionTimeout);
			resolutionTimeout = null;
		}
	}

	function confirmDates (formObj) {

		if (!$ctrl.resolution) {
			return;
		}

		formObj.state = 'saving';

		$ctrl.formOptions.forceCallback({
			maximumPeriodNumber: $ctrl.resolution.maximumPeriodNumber,
			payPeriodType: $ctrl.resolution.payPeriodType,
			resolvedPeriods: $ctrl.resolution.resolvedPeriods,
			resolvedPeriodsByKey: $ctrl.resolution.resolvedPeriodsByKey,
			startDateISO: $ctrl.startDateISO
		});

		formObj.state = 'saved';

		$ctrl.formOptions.closeForm();
	}

	function onResolutionFailure (failureObj) {

		console.error(failureObj.error || failureObj.message);

		$ctrl.resolutionMessage = failureObj.message;

		setResolutionState('error');
	}

	function onStartDateChange (startDateIso) {

		cancelPendingResolution();

		$ctrl.resolution = null;

		if (!startDateIso) {
			setResolutionState('empty');
			return;
		}

		setResolutionState('resolving');

		resolutionTimeout = $timeout(() => {
			resolvePayPeriodDates(startDateIso);
		}, RESOLUTION_DELAY);
	}

	function resolvePayPeriodDates (startDateIso) {

		payPeriodDateResolutionService.resolvePayPeriodDates(startDateIso, $ctrl.formOptions.agencyProfileId, $ctrl.periods)
			.then(resolutionObj => {

				$ctrl.resolution = resolutionObj;
				$ctrl.currentPageNumber = 1;

				setResolutionState('resolved');
			})
			.catch(onResolutionFailure);
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	function setResolutionState (resolutionState) {

		$ctrl.resolutionState = resolutionState;
	}

	angular.extend($ctrl, {
		$onDestroy,
		$onInit,
		confirmDates,
		currentPageNumber: 1,
		itemsPerPage: ITEMS_PER_PAGE,
		onStartDateChange,
		startDateISO: ''
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('rotareadyUpdatesDataForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'rotareadyUpdatesDataCtrl',
	templateUrl: 'forms/company/rotaready-updates-data/rotaready-updates-data.form.html'
})

.controller('rotareadyUpdatesDataCtrl', [
	'$filter',
	'ROTAREADY_UPDATES_EVENT_STATUS',
	'ROTAREADY_UPDATES_MAX_RETRY_COUNT',
	'REGEX',
	'teamData',
	function (
		$filter,
		ROTAREADY_UPDATES_EVENT_STATUS,
		ROTAREADY_UPDATES_MAX_RETRY_COUNT,
		REGEX,
		teamData
	) {

	const $ctrl = this;

	const FORM_CONTEXT = {
		default: 'default',
		confirmRetry: 'confirmRetry',
		retry: 'retry',
		retryLimitExceeded: 'retryLimitExceeded',
		error: 'error'
	};

	const FORM_STATE = {
		ready: 'ready',
		loading: 'loading'
	};

	function buildErrorMessageList () {
		const messagesByLevel = {
			critical: [],
			error: [],
			warning: [],
			info: []
		};
		
		$ctrl.data.Messages.forEach(function(message) {
			if (!message.MessageText.endsWith('.')) {
				message.MessageText = message.MessageText + '.';
			}
			switch(message.MessageLevel) {
				case 3: // Critical
					if (message.DismissedAtISO !== '') {
						message.DismissedAtDate = moment(message.DismissedAtISO).format('Do MMMM');
						message.DismissedAtTime = moment(message.DismissedAtISO).format('HH:mm');
					}
					messagesByLevel.critical.push(message);
					break;
				case 2: // Error
					messagesByLevel.error.push(message.MessageText);
					break;
				case 1: // Warning
					messagesByLevel.warning.push(message.MessageText);
					break;
				case 0: // Info
					messagesByLevel.info.push(message.MessageText);
					break;
			}
		});
		
		return messagesByLevel;
	}

	function confirmRetry () {
		setPageContext(FORM_CONTEXT.confirmRetry);
	}

	function dismissAllMessages () {

		$ctrl.isDismissingAll = true;

		teamData.dismissAccessRotareadyEventMessages($ctrl.formOptions.agencyProfileId, $ctrl.data.RotareadyWebhookEventID)
			.then(function () {
				$ctrl.isDismissingAll = false;
				loadEventData(true);
			})
			.catch(function (error) {
				$ctrl.isDismissingAll = false;
				onError(error);
			});
	}

	function dismissMessage (message) {

		message.isDismissing = true;

		teamData.dismissAccessRotareadyEventMessage($ctrl.formOptions.agencyProfileId, $ctrl.data.RotareadyWebhookEventID, message.RotareadyWebhookEventMessageID)
			.then(function () {
				loadEventData(true);
			})
			.catch(function (error) {
				message.isDismissing = false;
				onError(error);
			});
	}

	function getHasMultipleNonDismissedCriticalMessages () {
		if (!$ctrl.errorMessageList || !$ctrl.errorMessageList.critical || $ctrl.errorMessageList.critical.length <= 1) {
			return false;
		}
		return $ctrl.errorMessageList.critical.some(function (message) {
			return !getIsDismissed(message);
		});
	}

	function getIsDismissed (message) {
		return message.DismissedAtISO && message.DismissedAtISO !== '';
	}

	function loadEventData (refreshRotareadyPageEvents) {

		setPageState(FORM_STATE.loading);

		if ($ctrl.isBulk) {
			if ($ctrl.isOverRetryLimit) {
				setPageContext(FORM_CONTEXT.retryLimitExceeded);
			}
			else {
				confirmRetry();
			}
			setPageState(FORM_STATE.ready);
			return;
		}

		setPageContext(FORM_CONTEXT.default);
		$ctrl.formOptions.isCloseFormDisabled = false;

		teamData.getAccessRotareadyEvent($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.eventId)
			.then(dataObj => {
				$ctrl.data = dataObj;

				$ctrl.processedBodyData = processBodyData($ctrl.data.Body);

				setPageState(FORM_STATE.ready);

				if ($ctrl.data.Messages.length >= 1) {
					$ctrl.errorMessageList = buildErrorMessageList();
				}

				if (refreshRotareadyPageEvents) {
					$ctrl.formOptions.callback();
				}
			})
			.catch(onError);
	}

	function onError (error) {
		setPageContext(FORM_CONTEXT.error);
		setPageState(FORM_STATE.ready);
		$ctrl.formOptions.isCloseFormDisabled = false;
		console.error(error);
	}

	function onCancelClick () {
		if ($ctrl.isBulk) {
			$ctrl.formOptions.closeForm();
			return;
		}

		setPageContext(FORM_CONTEXT.default);
	}

	function performRetry () {

		setPageState(FORM_STATE.loading);
		setPageContext(FORM_CONTEXT.retry);
		$ctrl.formOptions.isCloseFormDisabled = true;

		const eventIds = $ctrl.isBulk ? $ctrl.formOptions.eventId : [$ctrl.formOptions.eventId];

		teamData.processFailedAccessRotareadyEvents($ctrl.formOptions.agencyProfileId, eventIds)
			.then(() => {
				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function processBodyData (bodyJson) {
		// creates a flattened array of the json body e.g. [ { key, value } ] 
		// key is . delimited list of all parent objects starting from root e.g. 'personal.address.line1'
		let outputArr = []; 

		const bodyObj = JSON.parse(bodyJson);
		
		for (const key in bodyObj) {
			if (bodyObj.hasOwnProperty(key)) {
				if (!key) {
					continue;
				}

				const value = bodyObj[key];

				if (angular.isObject(value)) {
					processNestedObject(key, value, 0, outputArr);
				} else if (value !== null) {
					processSimpleValue(key, value, outputArr);
				}
			}
		}
		
		return outputArr;
	}

	function processNestedObject(key, value, depth, outputArr) {
		depth = depth || 0;
		for (const keyInner in value) {
			if (value.hasOwnProperty(keyInner)) {
				if (!keyInner || value[keyInner] === null) {
					continue;
				}
				
				const innerValue = value[keyInner];
				
				if (angular.isObject(innerValue)) {
					processNestedObject(`${key}.${keyInner}`, innerValue, depth + 1, outputArr);
				} else {
					processSimpleValue(`${key}.${keyInner}`, innerValue, outputArr);
				}
			}
		}
	}

	function processSimpleValue(key, value, outputArr) {
		const keyObj = lookupKey(key);

		if (!keyObj) {
			// not something we want to show, so skip
			return;
		}

		let processedValue = value;
		if (REGEX.dateIso.test(processedValue)) {
			processedValue = $filter('dateformat')(processedValue, 'numeric');
		}

		outputArr.push({heading: keyObj.heading, value: processedValue});
	}

	function lookupKey (key) {
		// a list of keys we want to include, alongside respective display heading
		const keyDict = [
			// all:
			{ key: 'id', heading: 'Id' },
			// user events:
			{ key: 'firstName', heading: 'First name' },
			{ key: 'lastName', heading: 'Last name' },
			{ key: 'appointment.entityId', heading: 'Entity Id' },
			{ key: 'personal.dob', heading: 'Date of birth' },
			{ key: 'personal.email', heading: 'Email' },
			{ key: 'personal.otherNames', heading: 'Other names' },
			{ key: 'personal.addressLine1', heading: 'Address line 1' },
			{ key: 'personal.addressLine2', heading: 'Address line 2' },
			{ key: 'personal.addressCity', heading: 'Address city' },
			{ key: 'personal.addressCounty', heading: 'Address county' },
			{ key: 'personal.addressCountry', heading: 'Address country' },
			{ key: 'personal.addressPostCode', heading: 'Address postcode' },
			{ key: 'employment.dateStart', heading: 'Employment start date' },
			{ key: 'employment.dateEnd', heading: 'Employment end date' },
			{ key: 'employment.employeeNumber', heading: 'Employee number' },
			{ key: 'employment.ukStarterDeclaration', heading: 'Starter declaration' },
			// sign-off events:
			{ key: 'entityId', heading: 'Entity Id' },
			{ key: 'date', heading: 'Date' }
		];
		return keyDict.find(x => x.key === key);
	}

	function setPageContext (context) {
		$ctrl.pageContext = context;
	}

	function setPageState (formState) {
		$ctrl.pageState = formState;
	}

	function $onInit () {
		angular.extend($ctrl, {
			isBulk: angular.isArray($ctrl.formOptions.eventId)
		});

		if ($ctrl.isBulk) {
			$ctrl.formOptions.title = 'Retry updates';
			$ctrl.isOverRetryLimit = $ctrl.formOptions.eventId.length > ROTAREADY_UPDATES_MAX_RETRY_COUNT;
		}

		loadEventData(false);
	}

	angular.extend($ctrl, {
		$onInit,
		FORM_CONTEXT,
		FORM_STATE,
		ROTAREADY_UPDATES_EVENT_STATUS,
		ROTAREADY_UPDATES_MAX_RETRY_COUNT,
		confirmRetry,
		dismissAllMessages,
		dismissMessage,
		errorMessageList: [],
		getHasMultipleNonDismissedCriticalMessages,
		getIsDismissed,
		isDismissingAll: false,
		isOverRetryLimit: false,
		onCancelClick,
		performRetry
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('rotareadyUpdatesDismissAllForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'rotareadyUpdatesDismissAllCtrl',
	templateUrl: 'forms/company/rotaready-updates-dismiss-all/rotaready-updates-dismiss-all.form.html'
})

.controller('rotareadyUpdatesDismissAllCtrl', [
	'growl',
	'teamData',
	function (
		growl,
		teamData
	) {

	const $ctrl = this;

	function $onInit () {

		angular.extend($ctrl, {
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			eventIds: $ctrl.formOptions.eventIds,
			isConfirmed: false,
			totalCriticalMessages: $ctrl.formOptions.totalCriticalMessages
		});

		setPageState('ready');
	}

	function cancel () {
		$ctrl.formOptions.closeForm();
	}

	function confirmDismissAll () {

		setPageState('loading');

		teamData.dismissMultipleAccessRotareadyEventMessages($ctrl.agencyProfileId, $ctrl.eventIds)
			.then(function () {
				setPageState('complete');
				growl.success('Critical messages dismissed successfully.');
				$ctrl.formOptions.callback();
			})
			.catch(function () {
				growl.error('Failed to dismiss critical messages. Please try again.');
				setPageState('ready');
			});
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		cancel,
		confirmDismissAll
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('switchToLiveForm', function () {

	return {
		controller: 'switchToLiveFormCtrl',
		templateUrl: 'forms/company/switchToLive/switchToLiveForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('switchToLiveFormCtrl', ['$rootScope', '$scope', 'companyData',
	function ($rootScope, $scope, companyData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;

	function getInitialPageStep () {

		// Cannot be made test company - Has run a live payroll
		if (!companyObj.CanBeMadeTest) {
			return 'live-payroll-ran';
		}

		// State based on current mode
		return companyObj.IsInTestMode ? 'switch-to-live' : 'switch-to-test';
	}

	function init () {

		const initialPageState = getInitialPageStep();

		setPageState(initialPageState);
	}

	function onError (error) {
		console.error(error);
		setPageState(error);
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	function switchToLive (formObj) {

		formObj.state = 'saving';

		const isInTestMode = false;

		companyData.updateAgencyProfileIsInTestMode(agencyProfileId, isInTestMode).then(function () {

			setPageState('switched-to-live');

			$scope.formOptions.forceCallback();

			$rootScope.$broadcast('company-switch-to-live');
		})
		.catch(onError);
	}

	function switchToTest (formObj) {

		formObj.state = 'saving';

		const isInTestMode = true;

		companyData.updateAgencyProfileIsInTestMode(agencyProfileId, isInTestMode).then(function () {

			setPageState('switched-to-test');

			$scope.formOptions.forceCallback();

			$rootScope.$broadcast('company-switch-to-test');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		switchToLive,
		switchToTest
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('manageCompanyGroupsForm', function () {

	return {
		controller: 'manageCompanyGroupsFormCtrl',
		templateUrl: 'forms/company/manageCompanyGroups/manageCompanyGroupsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('manageCompanyGroupsFormCtrl', ['$q', '$scope', 'companyData', 'config', 'dataImportData', 'growl', 'session', 'base', 'INTERFACE_TYPES', function ($q, $scope, companyData, config, dataImportData, growl, session, base, INTERFACE_TYPES) {

	var agencyProfileId 		= $scope.formOptions.agencyProfileId;
	var agencyProfileParentId 	= $scope.formOptions.agencyProfileParentId;
	var loggedInUserId 			= session.getUserId();
	var interfaceType 			= INTERFACE_TYPES.group;

	function addToCompanyGroup (companyGroup, form) {

		var removeFromGroup = false;

		// Update state
		form.state = 'saving';

		companyData.updateAgencyProfileAgencyProfile(agencyProfileId, companyGroup.Company.AgencyProfileID, removeFromGroup)
		.then(function () {
			// If the group is linked to an organization with matching customer code, link the company to it
			if ($scope.isGroupLinkedToOrganisation && $scope.customerCodesMatch) {
				return dataImportData.linkCompanyToOrganisation(
					$scope.formOptions.company.Name,
					$scope.linkedOrganisationId
				);
			}
			return $q.resolve();
		})
		.then(function () {
			// Refresh page
			init();

			// Update state
			form.state = null;

			// Remove selected group
			$scope.model.companyGroup = null;

			// Reset form
			form.$setPristine();
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	function filterAvailableGroups (allGroups, companyGroups) {

		var companyGroupsIds = [];

		for (var i = 0; i < companyGroups.length; i++) {
			companyGroupsIds.push(companyGroups[i].AgencyProfileID);
		}

		return allGroups.filter(function (availableGroup) {

			var availableGroupId = availableGroup.Company.AgencyProfileID;

			if (companyGroupsIds.indexOf(availableGroupId) === -1) {
				return availableGroup;
			}
		});
	}

	function init () {

		// Page state
		$scope.pageState = 'loading';

		const getAgencyProfileAgencyProfilesForChild = companyData.getAgencyProfileAgencyProfilesForChild(agencyProfileId, interfaceType);
		const getAgencyProfileAgencyProfilesForParent = companyData.getAgencyProfileAgencyProfilesForParent(loggedInUserId, agencyProfileParentId, interfaceType);

		$q.all([
			getAgencyProfileAgencyProfilesForChild,
			getAgencyProfileAgencyProfilesForParent
		])
		.then(function (data) {

			var companyGroupsArray 		= data[0];
			var availableGroupsArray 	= data[1];

			// Assign to scope
			$scope.availableGroups 	= filterAvailableGroups(availableGroupsArray, companyGroupsArray);
			$scope.companyGroups 	= companyGroupsArray;

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	function removeFromCompanyGroup (companyGroup) {

		var removeFromGroup = true;

		companyGroup.state = 'saving';

		companyData.updateAgencyProfileAgencyProfile(agencyProfileId, companyGroup.AgencyProfileID, removeFromGroup).then(function () {

			// Refresh page
			init();

			// force callback
			$scope.formOptions.forceCallback();

			// Update state
			companyGroup.state = null;
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();
	// Check if the group is linked to an organization and validate customer codes
	function checkGroupOrganizationAndCustomerCodes(companyGroup) {
		if (!companyGroup) {
			$scope.isGroupLinkedToOrganisation = false;
			$scope.customerCodesMatch = true;
			$scope.companyCustomerCode = '';
			$scope.organisationCustomerCode = '';
			return $q.resolve();
		}

		$scope.isGroupChecking = true;
		$scope.isGroupLinkedToOrganisation = false;
		$scope.customerCodesMatch = false;
		$scope.companyCustomerCode = '';
		$scope.organisationCustomerCode = '';

		return base.isFeatureEnabled(agencyProfileParentId, 'GROUP_CREATION_ENABLED')
		.then(function(isFeatureEnabled) {
			$scope.isGroupCreationFeatureEnabled = isFeatureEnabled;
			
			if (!isFeatureEnabled) {
				$scope.customerCodesMatch = true;
				return $q.resolve();
			}

			// Check if the group is linked to an organization
			return dataImportData.getLinkedOrganisationToGroupCompany(companyGroup.Company.AgencyProfileID);
		})
		.then(function(linkedOrganisationId) {
			if (!$scope.isGroupCreationFeatureEnabled) {
				return $q.resolve();
			}

			$scope.linkedOrganisationId = linkedOrganisationId;
			$scope.isGroupLinkedToOrganisation = linkedOrganisationId && linkedOrganisationId !== config.guidEmpty;
			
			if (!$scope.isGroupLinkedToOrganisation) {
				$scope.customerCodesMatch = true;
				return $q.resolve();
			}
			
			// Get customer code of the company
			return companyData.getCustomerCodeByAgencyProfileId(agencyProfileId);
		})
		.then(function(companyCustomerCode) {
			if (!$scope.isGroupCreationFeatureEnabled || !$scope.isGroupLinkedToOrganisation) {
				return $q.resolve();
			}

			$scope.companyCustomerCode = companyCustomerCode || '';
			
			// Get organization customer code
			return companyData.getOrganisationCustomerCode($scope.linkedOrganisationId);
		})
		.then(function(organisationCustomerCode) {
			if (!$scope.isGroupCreationFeatureEnabled || !$scope.isGroupLinkedToOrganisation) {
				return $q.resolve();
			}

			$scope.organisationCustomerCode = organisationCustomerCode || '';
			
			// Check if customer codes match
			if ($scope.organisationCustomerCode && $scope.companyCustomerCode) {
				$scope.customerCodesMatch = $scope.companyCustomerCode === $scope.organisationCustomerCode;
			} else if ($scope.organisationCustomerCode && !$scope.companyCustomerCode) {
				$scope.customerCodesMatch = false;
				$scope.companyCustomerCodeMissing = true;
			} else {
				$scope.customerCodesMatch = false;
			}
		})
		.catch(function(error) {
			console.error('Error checking group organization and customer codes:', error);
		})
		.finally(function() {
			$scope.isGroupChecking = false;
		});
	}

	// Scope variables
	$scope.model = {
		companyGroup: null
	};
	$scope.newCompanyGroup = {
		name: ''
	};
	$scope.isGroupCreationFeatureEnabled = false;
	$scope.isGroupLinkedToOrganisation = false;
	$scope.isGroupChecking = false;
	$scope.customerCodesMatch = true;
	$scope.companyCustomerCode = '';
	$scope.organisationCustomerCode = '';
	$scope.companyCustomerCodeMissing = false;

	// Scope functions
	$scope.addToCompanyGroup = function (companyGroup, form) {

		addToCompanyGroup(companyGroup, form);
	};
	
	// Watch for changes in the selected company group
	$scope.$watch('model.companyGroup', function(newVal) {
		checkGroupOrganizationAndCustomerCodes(newVal);
	});

	$scope.openCreateNewCompanyGroupForm = function () {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileParentId,
			formKey: 'add-new-company-group'
		});
	};

	$scope.removeCompanyGroup = function (companyGroup) {

		$scope.selectedCompanyGroup = companyGroup;

		$scope.pageState = 'confirm-remove-from-group';
	};

	$scope.removeFromCompanyGroup = function (companyGroup) {

		removeFromCompanyGroup(companyGroup);
	};

	$scope.setPageState = function (pageState) {

		$scope.pageState = pageState;
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('workPatternForm', function () {

	return {
		controller: 'workPatternFormCtrl',
		templateUrl: 'forms/company/work-pattern/workPatternForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workPatternFormCtrl', ['$q', '$scope', '$timeout', 'companyData', 'config', 'growl', 'payrollData', 'workPatternService', 'WORK_PATTERN_GROUPS', 'WORK_PATTERN_BASIS', function ($q, $scope, $timeout, companyData, config, growl, payrollData, workPatternService, WORK_PATTERN_GROUPS, WORK_PATTERN_BASIS) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentCompanyObj = $scope.formOptions.company;
	const workPatternId = $scope.formOptions.workPatternId;

	const isNewWorkPattern = angular.isUndefined(workPatternId);

	function closeIsCalendarVisible (vmObj) {

		vmObj.isCalendarVisible = false;
	}

	function init () {

		setPageState('loading');

		const getWorkPattern = isNewWorkPattern ? companyData.getEmptyWorkPattern() : companyData.getWorkPattern(workPatternId);
		const getPayPeriodCurrent = payrollData.getPayPeriodCurrent(agencyProfileId);

		$q.all([getWorkPattern, getPayPeriodCurrent]).then((data) => {

			let workPatternObj = data[0];
			const payPeriodObj = data[1];

			// Default Total Hours to Company settings -> Work Hours per week
			if (isNewWorkPattern) {
				workPatternObj.TotalHours = currentCompanyObj.WorkHoursPerWeek;
			}

			// Decorate to make sure DayNumber is populated (required for calendar to work)
			workPatternObj = workPatternService.decorateWorkPattern(workPatternObj);

			$scope.vm = {
				isNewWorkPattern: isNewWorkPattern,
				payPeriod: payPeriodObj,
				workPattern: workPatternObj,
				workPatternOriginal: angular.copy(workPatternObj)
			};

			setCalendarState($scope.vm, 'ready');
			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function openWorkPatternTeamMembersForm (workPatternObj) {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: init,
			formKey: 'work-pattern-team-members',
			workPatternId: workPatternObj.WorkPatternID
		});
	}

	function reloadCalendar (vmObj) {

		// Only applies if open
		if (!vmObj.isCalendarVisible) {
			return;
		}

		setCalendarState(vmObj, 'loading');

		$timeout(() => {
			setCalendarState(vmObj, 'ready');
		}, 400);
	}

	function roundTotalHours (vmObj) {

		// Round TotalHours to 2 decimal places to prevent display of excessive decimal places
		if (vmObj.workPattern.TotalHours !== undefined && vmObj.workPattern.TotalHours !== null && vmObj.workPattern.TotalHours !== '') {
			const totalHours = parseFloat(vmObj.workPattern.TotalHours);
			if (!isNaN(totalHours)) {
				vmObj.workPattern.TotalHours = Math.round(totalHours * 100) / 100;
			}
		}
	}

	function reviewWorkPattern (vmObj) {

		// Reset to original > If additional weeks have been added this will reset them
		let resetWorkPattern = angular.copy(vmObj.workPatternOriginal);

		angular.extend(resetWorkPattern, {
			Basis: workPatternService.getWorkPatternBasis(vmObj.workPattern),
			Group: vmObj.workPattern.Group,
			theme: workPatternService.getWorkPatternTheme(vmObj.workPattern)
		});

		vmObj.workPattern = angular.copy(resetWorkPattern);

		reloadCalendar(vmObj);
	}

	function setCalendarState (vmObj, calendarState) {

		vmObj.calendarState = calendarState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function toggleIsCalendarVisible (vmObj) {

		vmObj.isCalendarVisible = !vmObj.isCalendarVisible;
	}

	function togglePatternBasis (vmObj) {
		
		vmObj.workPattern.Basis = workPatternService.togglePatternBasis(vmObj.workPattern.Basis);

		// Update days to match weekly values -> Required for calendar preview to match values
		if (vmObj.workPattern.Basis === WORK_PATTERN_BASIS.weekly) {
			vmObj.workPattern = workPatternService.updateDays(vmObj.workPattern);
		}

		reloadCalendar(vmObj);
	}

	function updateWorkPattern (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.updateWorkPatternForAgency(agencyProfileId, vmObj.workPattern).then(() => {

			growl.success('Work Pattern has been saved');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	init();

	angular.extend($scope, {
		WORK_PATTERN_GROUPS,
		WORK_PATTERN_BASIS,
		closeIsCalendarVisible,
		openWorkPatternTeamMembersForm,
		reloadCalendar,
		reviewWorkPattern,
		roundTotalHours,
		toggleIsCalendarVisible,
		togglePatternBasis,
		updateWorkPattern
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('workPatternDeleteForm', function () {

	return {
		controller: 'workPatternDeleteFormCtrl',
		templateUrl: 'forms/company/work-pattern-delete/workPatternDeleteForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workPatternDeleteFormCtrl', ['$scope', 'companyData', 'growl', function ($scope, companyData, growl) {

	const workPatternId = $scope.formOptions.workPatternId;

	function deleteWorkPattern (vmObj, formObj) {

		formObj.state = 'saving';

		companyData.deleteWorkPattern(workPatternId).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			growl.success('Work Pattern has been deleted');

			formObj.state = 'saved';
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function init () {

		setPageState('loading');

		companyData.getWorkPattern(workPatternId).then((workPatternObj) => {

			$scope.vm = {
				workPattern: workPatternObj
			};

			// Work Pattern in use
			if (workPatternObj.TeamMemberCount > 0) {
				setPageState('in-use');
				return;
			}

			setPageState('ready');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		deleteWorkPattern
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('workPatternTeamMembersForm', function () {

	return {
		controller: 'workPatternTeamMembersFormCtrl',
		templateUrl: 'forms/company/work-pattern-team-members/workPatternTeamMembersForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workPatternTeamMembersFormCtrl', ['$q', '$scope', 'companyData', 'WORK_PATTERN_GROUPS', function ($q, $scope, companyData, WORK_PATTERN_GROUPS) {

	var workPatternId = $scope.formOptions.workPatternId;

	function init () {

		setPageState('loading');

		var getWorkPattern = companyData.getWorkPattern(workPatternId);
		var getWorkPatternUsers = companyData.getWorkPatternUsers(workPatternId);

		$q.all([getWorkPattern, getWorkPatternUsers]).then(function (data) {

			var workPatternObj = data[0];
			var teamMembersArray = data[1];

			$scope.vm = {
				teamMembers: teamMembersArray,
				workPattern: workPatternObj
			};

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.WORK_PATTERN_GROUPS = WORK_PATTERN_GROUPS;
}]);

'use strict';

angular.module('paycircleApp')

.directive('workflowCollaboratorForm', function () {

	return {
		controller: 'workflowCollaboratorFormCtrl',
		templateUrl: 'forms/company/workflow-collaborator/workflowCollaboratorForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workflowCollaboratorFormCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'$timeout',
	'messageData',
	'teamData',
	'utilities',
	'USER_ROLES',
	function (
		$filter,
		$rootScope,
		$scope,
		$timeout,
		messageData,
		teamData,
		utilities,
		USER_ROLES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentUserObj = $rootScope.currentUser;
	const workflowTemplateEntryObj = $scope.formOptions.workflowTemplateEntry;

	function decorateWorkflowTemplate (workflowTemplateEntryObj) {

		workflowTemplateEntryObj.Note = $filter('emojify')(workflowTemplateEntryObj.Note);

		return workflowTemplateEntryObj;
	}

	function deselectAdmin (vmObj) {

		vmObj.admins.forEach((adminObj) => {
			adminObj.isActive = false;
		});

		vmObj.activeAdmin = null;
		vmObj.workflowTemplateEntry.ActionerID = '';
	}

	function getActiveAdminFromAdminsArr (adminsArr, workflowTemplateEntryObj) {

		if (!workflowTemplateEntryObj || !angular.isDefined(workflowTemplateEntryObj) || adminsArr.length === 0) {
			return null;
		}

		return utilities.getArrayItemByPropertyName(adminsArr, 'UserID', workflowTemplateEntryObj.ActionerID);
	}

	function init () {

		setPageState('loading');

		const restrictVisibility = true;
		const excludeDepartmentAdmin = true;

		teamData.getTeamMemberAdminsExtended(agencyProfileId, 0, restrictVisibility, excludeDepartmentAdmin).then((adminGroupsObj) => {

			// Get all admins from each group
			const adminsArr = Object.values(adminGroupsObj).flat();

			const activeAdminObj = getActiveAdminFromAdminsArr(adminsArr, workflowTemplateEntryObj);

			let vmObj = {
				activeAdmin: null,
				admins: adminsArr,
				adminGroups: adminGroupsObj,
				currentUser: currentUserObj,
				workflowTemplateEntry: decorateWorkflowTemplate(workflowTemplateEntryObj)
			};

			// Pre-select active admin
			if (activeAdminObj) {
				selectAdmin(vmObj, activeAdminObj);
			}

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function selectAdmin (vmObj, adminObj) {

		vmObj.activeAdmin = adminObj;
		vmObj.workflowTemplateEntry.ActionerID = adminObj ? adminObj.UserID : '';

		vmObj.admins.forEach((adminObj) => {
			adminObj.isActive = false;
		});

		adminObj.isActive = true;

		setupNotePlaceholder(vmObj);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setupNotePlaceholder (vmObj) {

		vmObj.workflowTemplateEntry.notePlaceholder = `Hi ${vmObj.activeAdmin.Forename}, we're ready for you to share your payroll data with us. As usual, let us know if you have any bonuses, commission and over time and any new starters you've got this month.

Thanks!
${vmObj.currentUser.UserResponseFirstName} 😊`;
	}

	function updateHasNote (vmObj) {

		if (vmObj.workflowTemplateEntry.HasNote) {

			vmObj.workflowTemplateEntry.Note = angular.copy(vmObj.workflowTemplateEntry.notePlaceholder);

			$timeout(() => {
				document.getElementById('welcomeNote').focus();
			});
		}
	}

	function updateWorkflowTemplateEntry (vmObj, formObj) {

		formObj.state = 'saving';

		// Convert emoji's to text
		vmObj.workflowTemplateEntry.Note = $filter('emojify')(vmObj.workflowTemplateEntry.Note, 'demojify');

		messageData.updateWorkflowTemplateEntry(agencyProfileId, vmObj.workflowTemplateEntry).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		deselectAdmin,
		selectAdmin,
		updateHasNote,
		updateWorkflowTemplateEntry,

		USER_ROLES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('workflowDeadlinesForm', function () {

	return {
		controller: 'workflowDeadlinesFormCtrl',
		templateUrl: 'forms/company/workflow-deadlines/workflowDeadlinesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('workflowDeadlinesFormCtrl', [
	'$q',
	'$scope',
	'messageData',
	'WORKFLOW_CALENDAR_TYPES',
	'WORKFLOW_OFFSET_TYPES',
	function (
		$q,
		$scope,
		messageData,
		WORKFLOW_CALENDAR_TYPES,
		WORKFLOW_OFFSET_TYPES
	) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var workflowTemplateObj = $scope.formOptions.workflowTemplate;

	function getCalendarTypeOptions () {
		return [
			{
				description: 'Calendar days',
				value: WORKFLOW_CALENDAR_TYPES.calendarDays
			},
			{
				description: 'Working days',
				value: WORKFLOW_CALENDAR_TYPES.workingDays
			}
		];
	}

	function getOffsetTypeOptions () {
		return [
			{
				description: 'Don\'t move them',
				value: WORKFLOW_OFFSET_TYPES.none
			},
			{
				description: 'Move them to the last working day prior',
				value: WORKFLOW_OFFSET_TYPES.lastWorkingDay
			},
			{
				description: 'Move them to the next working day',
				value: WORKFLOW_OFFSET_TYPES.nextWorkingDay
			}
		];
	}

	function init () {

		$scope.vm = {
			calendarTypeOptions: getCalendarTypeOptions(),
			calendarTypeOriginal: workflowTemplateObj.CalendarType,
			offsetTypeOptions: getOffsetTypeOptions(),
			offsetTypeOriginal: workflowTemplateObj.OffsetType,
			workflowTemplate: workflowTemplateObj
		};

		onDeadlineEntryChange();

		setPageState('ready');
	}

	function onDeadlineEntryChange () {

		function getIsTemplateEntryDueDaysValid (currentTemplateEntryObj, previousTemplateEntryObj) {

			if (!previousTemplateEntryObj || angular.isUndefined(currentTemplateEntryObj.DueDaysConstant) || currentTemplateEntryObj.DueDaysConstant === '') {
				return true;
			}

			// All days should be sequential
			return moment(currentTemplateEntryObj.dueDateIso).isAfter(previousTemplateEntryObj.dueDateIso);
		}

		function getIsTemplateEntryValid (currentTemplateEntryObj, previousTemplateEntryObj) {

			const isTemplateEntryDueDaysValid = getIsTemplateEntryDueDaysValid (currentTemplateEntryObj, previousTemplateEntryObj);

			return isTemplateEntryDueDaysValid;
		}

		function getTemplateEntryDueDate (currentTemplateEntryObj) {

			let dueDateMoment = moment().startOf('year').hours(currentTemplateEntryObj.DueTimeHour).minutes(currentTemplateEntryObj.DueTimeMinutes);

			if (angular.isUndefined(currentTemplateEntryObj.DueDaysConstant)) {
				return dueDateMoment;
			}

			// Add days after date
			if (currentTemplateEntryObj.IsAfterPayDay) {
				return dueDateMoment.add(currentTemplateEntryObj.DueDaysConstant, 'days').format();
			}

			// Take days off date
			return dueDateMoment.subtract(currentTemplateEntryObj.DueDaysConstant, 'days').format();
		}

		for (
			let templateEntryIndex = 0;
			templateEntryIndex < $scope.vm.workflowTemplate.TemplateEntries.length;
			templateEntryIndex++
		) {

			const currentTemplateEntryObj = $scope.vm.workflowTemplate.TemplateEntries[templateEntryIndex];
			const previousTemplateEntryObj = $scope.vm.workflowTemplate.TemplateEntries[templateEntryIndex-1];

			currentTemplateEntryObj.dueDateIso = getTemplateEntryDueDate(currentTemplateEntryObj);

			currentTemplateEntryObj.isValid = getIsTemplateEntryValid(currentTemplateEntryObj, previousTemplateEntryObj);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateWorkflowTemplateEntries (vmObj, formObj) {

		formObj.state = 'saving';

		for (let templateEntryObj of vmObj.workflowTemplate.TemplateEntries) {
			templateEntryObj.DueDays = templateEntryObj.DueDaysConstant;
		}

		const updateWorkflowTemplateEntries = messageData.updateWorkflowTemplateEntries(agencyProfileId, vmObj.workflowTemplate.TemplateEntries, vmObj.workflowTemplate.OffsetType, vmObj.workflowTemplate.CalendarType);
		const updateWorkflowTemplateCalendarType = vmObj.calendarTypeOriginal !== vmObj.workflowTemplate.CalendarType ? messageData.updateWorkflowTemplateCalendarType(vmObj.workflowTemplate.WorkflowTemplateID, vmObj.workflowTemplate.CalendarType) : null;
		const updateWorkflowTemplateOffsetType = vmObj.offsetTypeOriginal !== vmObj.workflowTemplate.OffsetType ? messageData.updateWorkflowTemplateOffsetType(vmObj.workflowTemplate.WorkflowTemplateID, vmObj.workflowTemplate.OffsetType) : null;

		$q.all([updateWorkflowTemplateEntries, updateWorkflowTemplateCalendarType, updateWorkflowTemplateOffsetType]).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(error => {
			setPageState('error');
			formObj.state = null;
			throw(error);
		});
	}

	init();

	angular.extend($scope, {
		updateWorkflowTemplateEntries,

		onDeadlineEntryChange,

		WORKFLOW_CALENDAR_TYPES,
		WORKFLOW_OFFSET_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('xeroForm', {
	controller: 'xeroFormCtrl',
	bindings: {
		formOptions: '='
	},
	templateUrl: 'forms/company/xero/xero.form.html'
})

.controller('xeroFormCtrl', [
	'$timeout',
	'agency',
	'base',
	'reportData',
	function (
		$timeout,
		agency,
		base,
		reportData
	) {

	const PAGE_STATES = {
		confirmConnect: 'confirm-connect',
		confirmDisconnect: 'confirm-disconnect',
		connected: 'connected',
		connectError: 'connect-error',
		disconnected: 'disconnected',
		error: 'error',
		identityConfirm2faPolicy: 'identity-confirm-2fa-policy',
		loading: 'loading',
		pollingAuthorisation: 'polling-authorisation',
		ready: 'ready',
		twoFaWarning: '2fa-warning'
	};

	const $ctrl = this;

	function $onInit () {

		setPageState(PAGE_STATES.loading);
		getXeroConnection('init');
	}

	function closeForm () {

		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function connectToXero ($ctrl) {

		base.getXeroAuthUrl($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.company.Name).then(authUrl => {

			if (!authUrl) {
				setPageState(PAGE_STATES.connectError);
				return;
			}

			window.open(authUrl, '_blank');

			setPageState(PAGE_STATES.pollingAuthorisation);

			pollXeroConnection();
		})
		.catch(onError);
	}

	function disconnectXero ($ctrl, formObj) {

		formObj.state = 'saving';

		base.disconnectXero($ctrl.formOptions.agencyProfileId).then(() => {

			$ctrl.formOptions.forceCallback();

			setPageState(PAGE_STATES.disconnected);
		})
		.catch(onError);
	}

	function getXeroConnection (fetchState) {

		reportData.getXeroConnection($ctrl.formOptions.agencyProfileId).then(xeroConnection => {

			$ctrl.xeroConnection = xeroConnection;
			// Only set first time to know what's changed
			switch (fetchState) {

				case 'init': {

					$ctrl.pollCount = 0;
					$ctrl.xeroConnectionOriginal = angular.copy(xeroConnection);
					if (xeroConnection.IsConnected) {
						setPageState(PAGE_STATES.confirmDisconnect);
					}
					else {
						if (xeroConnection.IsCompanyStateValidForConnection) {
							setPageState(PAGE_STATES.confirmConnect);
						} else if (xeroConnection.IsCompanyUsingIdentity) {
							$ctrl.IdentityConfirmTwoFAPolicyState = false;
							setPageState(PAGE_STATES.identityConfirm2faPolicy);
						} else {
							setPageState(PAGE_STATES.twoFaWarning);
						}
					}
					break;
				}

				case 'polling': {

					$ctrl.pollCount = $ctrl.pollCount + 1;

					if (hasConnectionStateChanged($ctrl)) {
						setPageState(xeroConnection.IsConnected ? PAGE_STATES.connected : PAGE_STATES.disconnected);
						return;
					}

					pollXeroConnection();
				}
			}
		})
		.catch(onError);
	}

	function hasConnectionStateChanged ($ctrl) {

		if (angular.isUndefined($ctrl.xeroConnectionOriginal)) {
			return false;
		}

		return $ctrl.xeroConnectionOriginal.IsConnected !== $ctrl.xeroConnection.IsConnected;
	}

	function confirmIdentityTwoFAPolicyState($ctrl) {
		agency.updateCompanyIdentityTwoFAPolicyConfirmationState($ctrl.formOptions.agencyProfileId, $ctrl.IdentityConfirmTwoFAPolicyState)
		.then(() => {
			if ($ctrl.xeroConnection.xeroTennantName !== '')
			{
				// Already connected, just confirming 2fa state so can close the form
				setPageState(PAGE_STATES.connected);
			}
			else
			{
				// Successfully set confirm state, now recheck connection state
				setPageState(PAGE_STATES.loading);
				getXeroConnection('init');
			}

		})
		.catch(onError);
	}

	function onError (error) {

		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function pollXeroConnection () {

		// Set maximum poll count
		if ($ctrl.pollCount >= 30) {
			setPageState(PAGE_STATES.error);
			return;
		}

		// 5 second poll to check connection status
		$timeout(() => {

			getXeroConnection('polling');

		}, 5000);
	}

	function setPageState (pageState) {

		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,

		PAGE_STATES,
		pageState: PAGE_STATES.ready,

		closeForm,
		confirmIdentityTwoFAPolicyState,
		connectToXero,
		disconnectXero,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('financialsForm', {
	controller: 'financialsFormCtrl',
	bindings: {
		formOptions: '='
	},
	templateUrl: 'forms/company/financials/financialsForm.html'
})

.controller('financialsFormCtrl', [
	'bulkService',
	'reportData',
	'searchService',
	function (
		bulkService,
		reportData,
		searchService
	) {

	const PAGE_STATES = {
		ready: 'ready',
		loading: 'loading',
		confirmConnect: 'confirm-connect',
		confirmDisconnect: 'confirm-disconnect',
		connected: 'connected',
		disconnected: 'disconnected',
		instanceSelection: 'instanceSelection',
		error: 'error'
	};

	const $ctrl = this;

	function $onInit () {
		setPageState(PAGE_STATES.loading);
		getConnectionState();
	}

	function connect () {
		setPageState(PAGE_STATES.loading);

		reportData.createAccessFinancialsConnection($ctrl.formOptions.agencyProfileId).then(() => {

			reportData.getAccessFinancialsTenants($ctrl.formOptions.agencyProfileId).then(accessFinancialsTenants => {
				
				$ctrl.accessFinancialsTenants = bulkService.getBulkItemsObj(accessFinancialsTenants);
		
				setPageState(PAGE_STATES.instanceSelection);
			})
			.catch(onError);
		})
		.catch(onError);
}

	function disconnect ($ctrl, formObj) {
		formObj.state = 'saving';

		reportData.deleteAccessFinancialsConnection($ctrl.formOptions.agencyProfileId).then(() => {
			$ctrl.formOptions.forceCallback();
			setPageState(PAGE_STATES.disconnected);
		})
		.catch(onError);
	}

	function getConnectionState () {
		reportData.getAccessFinancialsConnection($ctrl.formOptions.agencyProfileId).then(connectionState => {
			
			if (connectionState.IsConnected) {
				setPageState(PAGE_STATES.confirmDisconnect);
			}
			else {
				setPageState(PAGE_STATES.confirmConnect);
			}
		})
		.catch(onError);
	}

	function updateAccessFinancialsInstance (tenant) {
		setPageState(PAGE_STATES.loading);

		reportData.updateAccessFinancialsInstance($ctrl.formOptions.agencyProfileId, tenant.ID, tenant.Name).then(() => {

			$ctrl.formOptions.forceCallback();

			setPageState(PAGE_STATES.connected);
		})
		.catch(onError);
	}

	function closeForm () {
		$ctrl.formOptions.closeForm();
		$ctrl.formOptions.forceCallback();
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		$onInit,
		closeForm,
		connect,
		disconnect,
		PAGE_STATES,
		searchBarOptions: searchService.accessFinancialsTenants,
		setPageState,
		updateAccessFinancialsInstance
	});
}]);

'use strict';

angular.module('paycircleApp')
.directive('addAChangeForm', function () {

	return {
		controller: 'addAChangeFormCtrl',
		templateUrl: 'forms/payroll/addAChange/addAChangeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})
.controller('addAChangeFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'adjustmentsService',
	'companyData',
	'config',
	'growl',
	'journalsService',
	'payrollData',
	'pensionData',
	'pensionService',
	'regexService',
	'reportData',
	'salaryService',
	'teamData',
	'teamService',
	'userData',
	'utilities',
	'ADJUSTMENT_CATEGORY_TYPES',
	'ADJUSTMENT_PAYMENT_TYPES',
	'ADJUSTMENT_SPECIAL_TYPES',
	'ADJUSTMENT_VALUE_TYPES',
	'EMPLOYMENT_TYPES',
	'PAY_ELEMENTS',
	'PAYMENT_TYPES',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$timeout,
		adjustmentsService,
		companyData,
		config,
		growl,
		journalsService,
		payrollData,
		pensionData,
		pensionService,
		regexService,
		reportData,
		salaryService,
		teamData,
		teamService,
		userData,
		utilities,
		ADJUSTMENT_CATEGORY_TYPES,
		ADJUSTMENT_PAYMENT_TYPES,
		ADJUSTMENT_SPECIAL_TYPES,
		ADJUSTMENT_VALUE_TYPES,
		EMPLOYMENT_TYPES,
		PAY_ELEMENTS,
		PAYMENT_TYPES,
		SUBMISSION_STATES
	) {

	const adjustmentId = $scope.formOptions.adjustmentId;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const isFutureAdjustment = $scope.formOptions.isFutureAdjustment;
	const payPeriodId = $scope.formOptions.payPeriodId;
	const userId = $scope.formOptions.userId;
	const userObj = $scope.formOptions.context;

	const isEditAdjustment = adjustmentId !== undefined;
	const isEditTeamMember = userId !== null;

	let companyAdjustmentTypesArray = [];
	let emptyAdjustmentObj;

	const CAN_ADD_DEPARTMENT_CHANGES = false;
	let IGNORE_ADMINS; // undefined -> Use system default
	const IGNORE_FUTURE_STARTERS = $scope.formOptions.ignoreFutureStarters !== undefined ? $scope.formOptions.ignoreFutureStarters : false;
	const INCLUDE_ADMIN_ACCESS_ENTRIES = true;
	let INCLUDE_BACKPAY; // undefined -> Use system default
	const INCLUDE_INCOMPLETE = isEditTeamMember ? true : false;
	const INCLUDE_LEAVERS = $scope.formOptions.includeLeavers !== undefined ? $scope.formOptions.includeLeavers : false;
	const REDIRECT_TO_TEAM = $scope.formOptions.redirectToTeam !== undefined ? $scope.formOptions.redirectToTeam : false;
	const SEARCH_RESULTS_INCREMENT_COUNT = 20;
	const SEARCH_RESULTS_LIMIT = 20;
	const SEARCH_TERM_MIN_COUNT = 3;

	function addChange (vmObj) {

		vmObj.newAdjustments = [];

		// Reset values if empty strings
		vmObj.newAdjustment = adjustmentsService.resetNewAdjustmentValues(vmObj.newAdjustment);

		// Attach Adjustment Type ID / Agency Adjustment ID
		vmObj.newAdjustment.AgencyAdjustmentGroupEntryID = adjustmentsService.getAgencyAdjustmentGroupEntryId(vmObj.selectedAdjustmentType);
		vmObj.newAdjustment.AgencyAdjustmentID = vmObj.selectedAdjustmentType.AgencyAdjustmentID;

		// Default to don't apply to additional post
		vmObj.newAdjustment.applyToAdditionalPost = false;

		// Reset recurring period count
		if (!vmObj.recurForXPayPeriods) {
			vmObj.newAdjustment.RecurringPeriodCount = 0;
		}

		// Clear recurring end date if period count has been changed by the user
		if (vmObj.originalRecurringPeriodCount !== undefined &&
			vmObj.newAdjustment.RecurringPeriodCount !== vmObj.originalRecurringPeriodCount) {
			vmObj.newAdjustment.RecurringEndDateISO = '';
		}

		// Duplicate adjustment type for all selected team members and attach User ID's
		var i = 0;
		var numberOfSelectedTeamMembers = vmObj.selectedTeamMembers.length;

		for (i; i < numberOfSelectedTeamMembers; i++) {

			var teamMember = vmObj.selectedTeamMembers[i];
			var teamMemberAdjustment = angular.copy(vmObj.newAdjustment);

			// Attach UserID
			teamMemberAdjustment.UserID = teamMember.UserID;
			teamMemberAdjustment.PayPeriodID = vmObj.selectedPayPeriodId;

			// Attach teamMember object
			teamMemberAdjustment.teamMember = teamMember;

			// If payment is not in a currency, clear the ID
			if (teamMemberAdjustment.isPaymentInCurrency) {
				teamMemberAdjustment.CurrencyID = teamMemberAdjustment.selectedCurrency.CurrencyID;
			} else {
				teamMemberAdjustment.CurrencyID = config.guidEmpty;
			}

			// Add business code overrides
			const salaryPolicyPostId = angular.isDefined(teamMemberAdjustment.additionalPost) ? teamMemberAdjustment.additionalPost.SalaryPolicyPostID : config.guidEmpty;
			const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(vmObj.emptyUserAgencyProfileBusinessCode, agencyProfileId, teamMember.UserID, salaryPolicyPostId);
			teamMemberAdjustment.UserAgencyProfileBusinessCodeOverrides = journalsService.getBusinessCodesFromBusinessCategories(teamMemberAdjustment.businessCategories, emptyUserAgencyProfileBusinessCode);

			// Add to adjustments array
			vmObj.newAdjustments.push(teamMemberAdjustment);
		}

		updateUserPayElements(vmObj);

		if (vmObj.saveLabel) {
			createNewAdjustmentLabel(vmObj);
		}
	}

	function calculateAdjustmentValue (newAdjustmentObj) {
		newAdjustmentObj.Value = adjustmentsService.getAdjustmentUnitValue(newAdjustmentObj);
	}

	function calculatePercentageValue (vmObj) {
		vmObj.newAdjustment.Value = adjustmentsService.getAdjustmentPercentageValue(vmObj.newAdjustment);
	}

	function changeAdjustmentTypeFilter (filterKey) {

		$rootScope.$broadcast('close-tooltip-card');
		$scope.vm.adjustmentTypeFilter = adjustmentsService.getAdjustmentsFilterByKey(filterKey);
		$scope.vm.adjustmentTypeFilterKey = filterKey;
	}

	function reviewNetToGross (vmObj, newValue, reset) {

		vmObj.newAdjustment.NetToGross = newValue;

		// Force a recalculation
		if (angular.isDefined(reset) && reset) {
			vmObj.newAdjustment.grossAmount = null;
		}

		if (newValue || vmObj.selectedAdjustmentType.AgencyAdjustmentNetToGrossOnly) {

			if (vmObj.newAdjustment.Value && !vmObj.newAdjustment.grossAmount) {

				setNetToGrossLoadingState('loading');

				payrollData.getGrossForNetAdjustment(agencyProfileId, vmObj.selectedPayPeriodId, vmObj.selectedTeamMembers[0].UserID, vmObj.newAdjustment.Value).then(grossAmount => {

					vmObj.newAdjustment.grossAmount = grossAmount;

					setNetToGrossLoadingState('ready');
				})
				.catch(function (error) {
					$rootScope.paycircleMessage('Unable to calculate Net to Gross for team member.', 'info');
					console.error(error);
					setPageState('error');
				});
			}
		}
		else {

			vmObj.newAdjustment.grossAmount = null;
		}
	}

	function createNewAdjustmentLabel (vmObj) {

		var emptyPayslipLabelModel = {
			AgencyAdjustmentLabelID: config.guidEmpty,
			AgencyProfileID: agencyProfileId,
			AgencyAdjustmentGroupEntryID: config.guidEmpty,
			AgencyAdjustmentLabelText: '',
			AdjustmentText: '',
			AgencyAdjustmentLabelVisible: true,
			Addition: true,
			CreatedDateISO: ''
		};

		var newAdjustmentLabelObj = angular.copy(emptyPayslipLabelModel);

		newAdjustmentLabelObj.AgencyProfileID = agencyProfileId;
		newAdjustmentLabelObj.AgencyAdjustmentGroupEntryID = vmObj.newAdjustment.AgencyAdjustmentGroupEntryID;
		newAdjustmentLabelObj.AgencyAdjustmentLabelText = vmObj.newAdjustment.Label;

		payrollData.updateAgencyAdjustmentLabel(newAdjustmentLabelObj).catch(function (error) {
			$rootScope.paycircleMessage('Unable to save payslip label', 'info');
			growl.info('We were unable to save that payslip label');
			console.error(error);
		});
	}

	function decorateNewAdjustmentObj (newAdjustmentObj, selectedTeamMembersArr, currenciesArr, businessCategoriesArr) {

		// Set to set preselected option and avoid empty select box selection
		angular.extend(newAdjustmentObj, {
			applyToAdditionalPost: angular.isDefined(newAdjustmentObj.SalaryPolicyPostID) && newAdjustmentObj.SalaryPolicyPostID !== '' && newAdjustmentObj.SalaryPolicyPostID !== config.guidEmpty,
			isPaymentInCurrency: newAdjustmentObj.CurrencyID !== config.guidEmpty,
			RecurringPeriodCount: newAdjustmentObj.RecurringPeriodCount !== 0 ? newAdjustmentObj.RecurringPeriodCount : 1,
			selectedRate: null,
			overrideBusinessCategories: newAdjustmentObj.UserAgencyProfileBusinessCodeOverrides.length > 0,
			businessCategories: journalsService.decorateBusinessCategories(businessCategoriesArr, newAdjustmentObj.UserAgencyProfileBusinessCodeOverrides)
		});

		/* If the SalaryPolicyPostID is empty Guid, it should be removed, as that looks like a valid selection
		   as far as the UI is concerned. */
		if (newAdjustmentObj.SalaryPolicyPostID === config.guidEmpty) {
			delete(newAdjustmentObj.SalaryPolicyPostID);
		}
		else {
			// Target ID is a valid Guid, so attach the relevant additional post to the adjustment
			newAdjustmentObj.additionalPost = selectedTeamMembersArr[0].AdditionalPosts.find(additionalPost => additionalPost.SalaryPolicyPostID === newAdjustmentObj.SalaryPolicyPostID);
		}

		// Expats - Find selected currency or clear it
		if (newAdjustmentObj.isPaymentInCurrency && currenciesArr.length > 0) {
			newAdjustmentObj.selectedCurrency = currenciesArr.find(currencyObj => currencyObj.CurrencyID === newAdjustmentObj.CurrencyID);
		} else {
			newAdjustmentObj.selectedCurrency = null;
		}

		return newAdjustmentObj;
	}

	function deselectAdjustmentType (vmObj) {

		angular.extend(vmObj, {
			pensionState: null,
			selectedAdjustmentType: null
		});

		// Reset Net to Gross
		resetNetToGrossEnabled(vmObj);

		resetPayslipLabel(vmObj);
		setCalculationState(null);
	}

	function deselectTeamMember (vmObj, index) {

		vmObj.selectedTeamMembers.splice(index, 1);

		deselectAdjustmentType(vmObj); // Reset form
		focusOn('searchTermTeamMembers');
	}

	function focusAdjustmentType (adjustmentTypeObj) {

		switch (adjustmentTypeObj.AgencyAdjustmentValueType) {
			case ADJUSTMENT_VALUE_TYPES.absolute:
				focusOn('adjustmentTotalValue');
				break;
			case ADJUSTMENT_VALUE_TYPES.linked:
				focusOn('salaryRate');
				break;
			case ADJUSTMENT_VALUE_TYPES.unit:
			case ADJUSTMENT_VALUE_TYPES.percentage:
				focusOn('adjustmentUnits');
				break;
		}
	}

	function focusOn (elementId) {

		$timeout(function () {
			if (document.getElementById(elementId)) {
				document.getElementById(elementId).focus();
			}
			else {
				$rootScope.paycircleMessage('Unable to apply element focus to #' + elementId + ' as it could not be found.', 'warn');
			}
		});
	}

	function getPayPeriodForPeriodCount (vmObj) {

		vmObj.recurringPayPeriodDisplay = '';

		if (!vmObj.newAdjustment.RecurringPeriodCount || vmObj.newAdjustment.RecurringPeriodCount < 1) {
			return;
		}

		payrollData.getPayPeriodForPeriodCount(agencyProfileId, vmObj.newAdjustment.RecurringPeriodCount)
			.then(payPeriodObj => {
				vmObj.recurringPayPeriodDisplay = payPeriodObj.PayPeriodDisplay;
			})
			.catch(error => {
				console.error(error);
				setPageState('error');
			});
	}

	function getTeamMemberHolidayAccrual (vmObj) {

		// Team member must be selected
		if (vmObj.selectedTeamMembers.length === 0) {
			setPageState('error');
			growl.error('No team members have been selected');
			$rootScope.paycircleMessage('A calculated/percentage change type requires a team member to have been selected to work.', 'info');
			return;
		}

		var getTeamMemberHolidayAccrual = vmObj.selectedTeamMembers[0].HolidayAccrual === undefined ? teamData.getUserAccruedHolidayPay(vmObj.selectedTeamMembers[0].UserID, agencyProfileId) : null;

		if (getTeamMemberHolidayAccrual) {

			setHolidayAccrualState('loading');

			getTeamMemberHolidayAccrual.then(teamMemberHolidayAccrualAmount => {

				vmObj.selectedTeamMembers[0].HolidayAccrual = teamMemberHolidayAccrualAmount;

				focusOn('adjustmentTotalValue');

				setHolidayAccrualState('ready');
			})
			.catch(function (error) {
				console.error(error);
				setHolidayAccrualState('error');
			});
		}
		else {
			focusOn('adjustmentTotalValue');
		}
	}

	function getTeamMemberSalary (vmObj, adjustmentObj) {

		// Team member must be selected
		if (vmObj.selectedTeamMembers.length === 0) {
			setPageState('error');
			growl.error('No team members have been selected');
			$rootScope.paycircleMessage('A calculated/percentage change type requires a team member to have been selected to work.', 'info');
			return;
		}

		// Cannot apply to multiple team members
		if (vmObj.selectedTeamMembers.length > 1) {
			setPageState('error');
			growl.error('Calculated/Percentage change types can only be applied to one team member at a time');
			$rootScope.paycircleMessage('A calculated/percentage change type has been selected for multiple team members. This is not allowed.', 'info');
			return;
		}

		let getTeamMemberSalaries = null;
		if (angular.isUndefined(vmObj.selectedTeamMembers[0].Salaries)) {
			getTeamMemberSalaries = payrollData.getTeamMemberSalariesForPostsWithCalculatedRates(agencyProfileId, payPeriodId, vmObj.selectedTeamMembers[0].UserID);
		}

		// Only load salary once
		vmObj.selectedTeamMembers[0].salaryState = 'loading';

		// Load salaries obj
		$q.all([getTeamMemberSalaries]).then(([teamMemberSalariesObj]) => {

			// Use cached copy
			if (!teamMemberSalariesObj) {
				// Use cached copy
				teamMemberSalariesObj = vmObj.selectedTeamMembers[0].Salaries;
			}

			const applyToAdditionalPost = angular.isDefined(adjustmentObj) && adjustmentObj.applyToAdditionalPost;

			const salaryPolicyPostId = applyToAdditionalPost ? adjustmentObj.SalaryPolicyPostID : config.guidEmpty;

			var teamMemberSalaryObj = salaryService.getSalaryDetailsWithRatesForPost(teamMemberSalariesObj, salaryPolicyPostId);

			/* If the user has selected a rate, then apply to additional post, the selected rate will get nuked.
				So reinstate it if that's the case. */
			if (adjustmentObj.selectedRate) {
				// Find the corresponding rate in the new set of rates.
				const newSelectedRate = teamMemberSalaryObj.SalaryRatesWithCalculated.find(salaryRate => salaryRate.SalaryRateID === adjustmentObj.selectedRate.SalaryRateID);
				// If found, set it, otherwise nullify to force selection
				if (newSelectedRate) {
					adjustmentObj.selectedRate = newSelectedRate;
					selectSalaryRate(vmObj);
				}
				else {
					adjustmentObj.selectedRate = null;
				}
			}

			vmObj.selectedTeamMembers[0].Salary = teamMemberSalaryObj;
			vmObj.selectedTeamMembers[0].Salaries = teamMemberSalariesObj;
			vmObj.selectedTeamMembers[0].salaryState = 'ready';

		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function getPensionsForTeamMember (vmObj) {

		setPensionState('loading');

		pensionData.getPensionsForTeamMember(vmObj.selectedTeamMembers[0].UserID, agencyProfileId)
			.then(teamMemberPensionsArr => {

				// Decorate pension with label
				for (let pensionObj of teamMemberPensionsArr) {
					let pensionLabel = `${pensionObj.PensionProviderName} ${pensionObj.EmployerReference}`;
					// Append additional post title if applicable
					if (pensionObj.IsAdditionalPost) {
						pensionLabel += ` (${pensionObj.SalaryPolicyPostTitle})`;
					}
					pensionObj.pensionLabel = pensionLabel;
				}

				vmObj.selectedTeamMembers[0].pensions = teamMemberPensionsArr;

				if (teamMemberPensionsArr.length === 0) {
					setCalculationState('not-allowed');

				} else {

					if (vmObj.newAdjustment.AgencyEmployerPensionID === config.guidEmpty) {
						const defaultPension =  pensionService.getDefaultPensionForAdjustment(teamMemberPensionsArr);
						angular.extend(vmObj.newAdjustment, {
							// Set pension IDs
							AgencyEmployerPensionID: defaultPension.AgencyEmployerPensionID,
							WorkplacePensionID: defaultPension.WorkplacePensionID
						});
					}

					setPensionState('ready');
				}

			})
			.catch(error => {
				console.error(error);
				setPensionState('error');
			});
	}

	function incrementSearchResultsAdjustmentTypes (vmObj) {

		vmObj.searchResultsLimitAdjustmentTypes = vmObj.searchResultsLimitAdjustmentTypes + SEARCH_RESULTS_INCREMENT_COUNT;
	}

	function incrementSearchResultsTeam (vmObj) {

		vmObj.searchResultsLimitTeam = vmObj.searchResultsLimitTeam + SEARCH_RESULTS_INCREMENT_COUNT;
	}

	function init () {

		setPageState('loading');

		const getAgencyDepartments = companyData.getAgencyDepartments(agencyProfileId);
		const getAgencyAdjustmentGroupCombined = payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId, INCLUDE_ADMIN_ACCESS_ENTRIES);
		const getAgencyAdjustmentLabels = payrollData.getAgencyAdjustmentLabels(agencyProfileId);
		const getEmptyUserPayElementDetail = payrollData.getEmptyUserPayElementDetail(agencyProfileId);
		const getPayPeriods = payrollData.getPayPeriods(agencyProfileId, SUBMISSION_STATES.unsubmitted);
		const getUserAgencyProfilesForAgencyTeamMemberMinimum = teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(agencyProfileId, INCLUDE_LEAVERS, IGNORE_FUTURE_STARTERS, IGNORE_ADMINS, INCLUDE_INCOMPLETE, INCLUDE_BACKPAY, userId);
		const getCurrencies = companyObj.IsExpatActive ? companyData.getCurrencies(agencyProfileId) : null;
		const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
		const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();

		$q.all([getUserAgencyProfilesForAgencyTeamMemberMinimum, getAgencyDepartments, getAgencyAdjustmentGroupCombined, getEmptyUserPayElementDetail, getAgencyAdjustmentLabels, getPayPeriods, getCurrencies, getBusinessCategoriesList, getEmptyUserAgencyProfileBusinessCode])
			.then(([teamMembersArr, departmentsArray, adjustmentGroupsObj, newAdjustmentObj, adjustmentLabelsArray, payPeriodsArray, currenciesArr, businessCategoriesArr, emptyUserAgencyProfileBusinessCodeObj]) => {

			teamMembersArr = teamService.decorateAndFilterTeamMembers(teamMembersArr, { ExcludeFromPayroll: true, IsOnHold: true, IsOffPayrollWorker: true, IsAdvancingFuturePeriods: true, HasAdvancedFuturePeriods: true });

			var adjustmentTypesArrayStandard = adjustmentsService.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupsObj.GroupEntries);
			var adjustmentTypesArrayCIS = adjustmentsService.getAdjustmentTypesFromAdjustmentGroups(adjustmentGroupsObj.GroupEntriesCIS);

			// Convert adjustment types into single array
			companyAdjustmentTypesArray = adjustmentTypesArrayStandard.concat(adjustmentTypesArrayCIS);

			// Add tooltips to adjustment types
			companyAdjustmentTypesArray = adjustmentsService.decorateAdjustmentTypes(companyAdjustmentTypesArray);

			// Decorate labels with their related adjustment type
			adjustmentLabelsArray = adjustmentsService.decorateLabelsWithAdjustmentTypes(adjustmentLabelsArray, companyAdjustmentTypesArray);

			// Create a backup obj
			emptyAdjustmentObj = angular.copy(decorateNewAdjustmentObj(newAdjustmentObj, teamMembersArr, currenciesArr, businessCategoriesArr));

			// Remove first pay period (current)
			if (isFutureAdjustment) {
				payPeriodsArray.shift();
			}

			// Generate options for pay period count
			const payPeriodCountOptions = [];
			for (let payPeriodCount = 1; payPeriodCount <= 10; payPeriodCount++) {
				const pluralise = payPeriodCount > 1 ? 's' : '';
				payPeriodCountOptions.push({
					description: `${payPeriodCount} pay period${pluralise}`,
					value: payPeriodCount
				});
			}

			$scope.departments = departmentsArray;
			$scope.isEditAdjustment = isEditAdjustment;
			$scope.isEditTeamMember = isEditTeamMember;
			$scope.payPeriods = payPeriodsArray;
			$scope.vm = {
				adjustmentTypeFilterKey: '',
				adjustmentTypeFilter: function (v) {
					return v;
				},
				adjustmentTypeSearchFilter: function (v) {
					return v;
				},
				businessCategories: businessCategoriesArr,
				calculationViewState: 'calculated',
				currencies: currenciesArr,
				currentPayPeriod: payPeriodsArray[0],
				emptyUserAgencyProfileBusinessCode: emptyUserAgencyProfileBusinessCodeObj,
				labelFilter: null,
				newAdjustment: angular.copy(emptyAdjustmentObj),
				recurringPayPeriodDisplay: '',
				saveLabel: false,
				searchResultsLimitAdjustmentTypes: SEARCH_RESULTS_INCREMENT_COUNT,
				searchResultsLimitTeam: SEARCH_RESULTS_INCREMENT_COUNT,
				searchTermAdjustmentLabels: '',
				searchTermAdjustmentLabelsFocused: false,
				searchTermAdjustmentTypes: '',
				searchTermAdjustmentTypesFocused: false,
				searchTermTeamMembers: '',
				searchTermTeamMembersFocused: false,
				selectedAdjustmentLabel: null,
				selectedAdjustmentLabelSave: false,
				selectedAdjustmentType: null,
				selectedPayPeriodId: payPeriodId !== undefined ? payPeriodId : payPeriodsArray[0].PayPeriodID,
				selectedTeamMembers: [],
				showPaymentTypeInformation: false,
				showPayslipLabelResults: false,
				showTaxTreatment: false,
				recurForXPayPeriods: false,
			};
			$scope.teamMembers = teamMembersArr;
			$scope.adjustmentLabels = adjustmentLabelsArray;

			// No team members
			if (teamMembersArr.length === 0) {
				setPageState('no-team-members');
				return;
			}

			// No adjustment types
			if (companyAdjustmentTypesArray.length === 0) {
				setPageState('no-adjustment-types');
				return;
			}

			// Pre-load user and adjustment type
			if (userId && adjustmentId) {
				selectTeamMemberById($scope.teamMembers, userId);
				setupExistingAdjustment($scope.vm, adjustmentId, companyAdjustmentTypesArray, businessCategoriesArr);
			}
			// Pre-load user
			else if (userId) {
				selectTeamMemberById($scope.teamMembers, userId);
				setPageState('ready');
				focusOn('searchTermAdjustmentTypes');
			}
			// New adjustment
			else {
				setPageState('ready');
				focusOn('searchTermTeamMembers');
			}
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function isBusinessCategoriesInvalid (vmObj) {

		return journalsService.isBusinessCategoriesInvalid(vmObj.newAdjustment);
	}

	function isNetToGrossCalculation (adjustmentObj) {

		return adjustmentObj.NetToGross && angular.isDefined(adjustmentObj.grossAmount);
	}

	function onAdditionalPostChange (vmObj, adjustmentObj) {

		// Sync target ID on new adjustment.
		adjustmentObj.SalaryPolicyPostID = adjustmentObj.additionalPost.SalaryPolicyPostID;

		// Re-calculate salary rates
		getTeamMemberSalary(vmObj, adjustmentObj);
	}

	function onApplyToAdditionalPostChange (vmObj, adjustmentObj) {

		/* Clear target ID of adjustment and additional post. This removes the additional post association with the adjustment.
		   When 'apply to additional post' is being switched on, this forces reselection. */
		delete(vmObj.newAdjustment.SalaryPolicyPostID);
		delete(vmObj.newAdjustment.additionalPost);

		// Recalc salary rates for main post if switched off
		if (!adjustmentObj.applyToAdditionalPost) {
			getTeamMemberSalary(vmObj, adjustmentObj);
		}
	}

	function onBusinessCategoriesOverrideChange (vmObj) {

		// reset the selected business code for every business category
		if (vmObj.newAdjustment.businessCategories) {
			vmObj.newAdjustment.businessCategories.forEach(businessCategory => {
				businessCategory.selectedBusinessCode = null;
			});
		}
	}

	function onIsPaymentInCurrencyChange (vmObj) {

		if (!vmObj.newAdjustment.isPaymentInCurrency) {
			vmObj.newAdjustment.selectedCurrency = null;
		}
	}

	function onPensionChange (vmObj, teamMemberPensionsArr) {

		// For convenience
		const newAdjustmentObj = vmObj.newAdjustment;

		// Find the pension based on selected WorkplacePensionID
		const teamMemberPension = teamMemberPensionsArr.find(pensionObj => pensionObj.WorkplacePensionID === newAdjustmentObj.WorkplacePensionID);

		// That should have been found. Add additional attributes to the adjustment
		if (angular.isDefined(teamMemberPension)) {
			angular.extend(newAdjustmentObj, {
				AgencyEmployerPensionID: teamMemberPension.AgencyEmployerPensionID,
				SalaryPolicyPostID: teamMemberPension.SalaryPolicyPostID
			});
		}
	}

	function resetAdjustmentLabelSearchTerm () {

		$scope.vm.searchTermAdjustmentLabels = '';
	}

	function resetAdjustmentTypeSearchTerm () {

		$scope.vm.searchTermAdjustmentTypes = '';
	}

	function resetNetToGrossEnabled (vmObj) {

		vmObj.newAdjustment.NetToGross = false;
		vmObj.newAdjustment.grossAmount = null;
	}

	function resetPayslipLabel (vmObj) {

		setAdjustmentLabel('');
		vmObj.saveLabel = false;
	}

	function resetTeamMemberSearchTerm () {

		$scope.vm.searchTermTeamMembers = '';
	}

	function reviewPeriodOverride (vmObj) {

		if (vmObj.newAdjustment.IsPeriodOverride) {
			reviewNetToGross(vmObj, false);
		}
		else {
			angular.extend(vmObj.newAdjustment, {
				Value: angular.copy(vmObj.newAdjustment.RecurringValue),
				Units: angular.copy(vmObj.newAdjustment.RecurringUnits),
				UnitValue: angular.copy(vmObj.newAdjustment.RecurringUnitValue),
				UnitValueMultiplier: angular.copy(vmObj.newAdjustment.RecurringUnitValueMultiplier)
			});
		}
	}

	function selectAdjustmentLabel (adjustmentLabelObj) {

		setAdjustmentLabel(adjustmentLabelObj.AgencyAdjustmentLabelText);
	}

	function selectAdjustmentType(vmObj, adjustmentTypeObj, resetValues) {

		// close tooltip (if open)
		$rootScope.$broadcast('close-tooltip-card');

		resetValues = resetValues !== undefined ? resetValues : true;

		vmObj.selectedAdjustmentType = adjustmentTypeObj;

		resetAdjustmentTypeSearchTerm();

		// Adjustment type not matched
		if (!adjustmentTypeObj) {
			return;
		}

		if (resetValues) {
			setupAdjustmentType(vmObj, adjustmentTypeObj);
		}

		// Attach default currency if there is no currency set
		if (vmObj.newAdjustment.CurrencyID === config.guidEmpty) {
			setupSelectedCurrency(vmObj, adjustmentTypeObj, vmObj.newAdjustment);
		}

		// Default PaymentType to Regular if a leaver.
		if (vmObj.selectedTeamMembers[0].IsLeaver && vmObj.newAdjustment.PaymentType === ADJUSTMENT_PAYMENT_TYPES.notPayAfterLeaving) {
			vmObj.newAdjustment.PaymentType = ADJUSTMENT_PAYMENT_TYPES.regular;
		}

		// Make sure values are consistent between selected adjustment type and new adjustment object
		angular.extend(vmObj.newAdjustment, {
			ValueType: angular.copy(adjustmentTypeObj.AgencyAdjustmentValueType),
			Deduction: adjustmentTypeObj.IsDeduction
		});

		switch (adjustmentTypeObj.AgencyAdjustmentValueType) {

			// Absolute
			case ADJUSTMENT_VALUE_TYPES.absolute:

				// When editing and NetToGross is enabled, fetch NetToGross calculation
				if (vmObj.newAdjustment.NetToGross || vmObj.selectedAdjustmentType.AgencyAdjustmentNetToGrossOnly) {
					reviewNetToGross(vmObj, vmObj.newAdjustment.NetToGross);
				}
				break;

			// Percentage / linked types require salary object
			case ADJUSTMENT_VALUE_TYPES.percentage:
			case ADJUSTMENT_VALUE_TYPES.linked:
				getTeamMemberSalary(vmObj, vmObj.newAdjustment);
				break;
		}

		// Special adjustment types
		// Accrued holiday
		if (adjustmentTypeObj.AgencyAdjustmentSpecialType === ADJUSTMENT_SPECIAL_TYPES.accruedHoliday) {
			getTeamMemberHolidayAccrual(vmObj);
			return;
		}

		// Load pensions for team member
		if (adjustmentTypeObj.IsEmployeePension || adjustmentTypeObj.IsEmployerPension) {
			getPensionsForTeamMember(vmObj);
		}

		// Focus on element
		focusAdjustmentType(adjustmentTypeObj);
	}

	function selectAdjustmentTypeById (vmObj, adjustmentId, adjustmentTypesArray) {

		var selectedAdjustmentTypeObj = adjustmentsService.getAdjustmentTypeById('AgencyAdjustmentGroupEntryID', adjustmentId, adjustmentTypesArray);

		selectAdjustmentType(vmObj, selectedAdjustmentTypeObj, false);
	}

	function selectAdjustmentTypeFromAdjustmentLabel (vmObj, adjustmentLabelObj, resetValues) {

		setAdjustmentLabel(adjustmentLabelObj.AgencyAdjustmentLabelText);
		selectAdjustmentType(vmObj, adjustmentLabelObj.adjustmentType, resetValues);
		resetAdjustmentTypeSearchTerm();
	}

	function selectSalaryRate (vmObj) {

		if (!vmObj.newAdjustment.selectedRate) {
			vmObj.newAdjustment.Value = null;
			return;
		}

		adjustmentsService.selectSalaryRate(vmObj.selectedAdjustmentType, vmObj.newAdjustment);

		if (vmObj.newAdjustment.selectedRate.SalaryRateID === 'custom') {
			focusOn('adjustmentUnitValue');
		}

		calculateAdjustmentValue(vmObj.newAdjustment);
	}

	function selectTeamMember (teamMemberObj, elementId) {

		let originalAdjustmentTypesArray = angular.copy(companyAdjustmentTypesArray);

		$scope.vm.selectedTeamMembers = [teamMemberObj];

		resetTeamMemberSearchTerm();

		if (teamMemberObj.IsCISSubcontractor) {
			//changeAdjustmentTypeFilter('cis');
			setupAdjustmentTypesForUserType(originalAdjustmentTypesArray, 'cis');
		}
		else {
			setupAdjustmentTypesForUserType(originalAdjustmentTypesArray);
		}

		if (angular.isDefined(elementId)) {
			focusOn(elementId);
		}

		if (teamMemberObj.IsLeaver) {
			payrollData.getTaxInfoForPeriod(teamMemberObj.UserID, agencyProfileId, $scope.vm.selectedPayPeriodId)
				.then(taxCodeInfo => {
					$scope.vm.taxCode = taxCodeInfo;
				}).catch((error) => {
					console.error(error);
					setPageState('error');
				});
		}
	}

	function selectTeamMemberByDepartment (teamMembersArray) {

		// To do... filter out team members with a matching department ID

		$scope.vm.selectedTeamMembers = teamMembersArray;
		resetTeamMemberSearchTerm();
	}

	function selectTeamMemberById (teamMembersArray, userId) {

		const index = utilities.getArrayItemIndexByPropertyName(teamMembersArray, 'UserID', userId);

		// Unable to find user by UserID (e.g. leaver) > So use the user object directly
		// Note: Specifically uses null check as 0 index value results as 'truthy')
		if (index === null) {
			selectTeamMember(userObj);
			$rootScope.paycircleMessage('addAChangeForm.js:selectTeamMemberById: Unable to select team member by ID, using individual object instead', 'warn');
			return;
		}

		selectTeamMember(teamMembersArray[index]);
	}

	function setAdjustmentValueToAccruedHolidayTotal (vmObj) {

		vmObj.newAdjustment.Value = angular.copy(vmObj.selectedTeamMembers[0].HolidayAccrual);
	}

	function setAdjustmentLabel (adjustmentLabel) {

		$scope.vm.selectedAdjustmentLabel = adjustmentLabel;
		$scope.vm.newAdjustment.Label = adjustmentLabel;
	}

	function setCalculationState (calculationState) {

		$scope.calculationState = calculationState;
	}

	function setHolidayAccrualState (holidayAccrualState) {

		$scope.holidayAccrualState = holidayAccrualState;
	}

	function setNetToGrossLoadingState (netToGrossLoadingState) {

		$scope.netToGrossLoadingState = netToGrossLoadingState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setPensionState (pensionState) {

		$scope.pensionState = pensionState;
	}

	function setPercentageCalculationToSalary (vmObj) {

		vmObj.newAdjustment.UnitValue = angular.copy(vmObj.selectedTeamMembers[0].Salary.SalaryYearly);
		calculatePercentageValue(vmObj);
	}

	function setupAdjustmentType (vmObj, adjustmentTypeObj) {

		adjustmentsService.setDefaultAdjustmentValues(adjustmentTypeObj, vmObj.newAdjustment);
		setupLabelFilter(vmObj);
	}

	function setupAdjustmentTypesForUserType (companyAdjustmentTypesArray, userType) {

		var returnedAdjustmentTypesArr = [];

		switch (userType) {
			case 'cis':
				returnedAdjustmentTypesArr = companyAdjustmentTypesArray.filter(function (adjustmentTypeObj) {
					return adjustmentTypeObj.Category === 'CIS';
				});
				break;
			default:
				returnedAdjustmentTypesArr = companyAdjustmentTypesArray.filter(function (adjustmentTypeObj) {
					return adjustmentTypeObj.Category !== 'CIS';
				});
		}

		// No adjustment types
		if (returnedAdjustmentTypesArr.length === 0) {
			setPageState('no-adjustment-types');
			return;
		}

		const adjustmentTypesCountObj = adjustmentsService.getAdjustmentTypesCounts(returnedAdjustmentTypesArr);

		$scope.adjustmentTypes = returnedAdjustmentTypesArr;
		$scope.adjustmentTypesCount = adjustmentTypesCountObj;

		changeAdjustmentTypeFilter(adjustmentTypesCountObj.totalAdditions > 0 ? 'additions' : 'deductions');
	}

	function setupExistingAdjustment (vmObj, adjustmentId, adjustmentTypesArray, businessCategoriesArr) {

		payrollData.getUserPayElementDetail(agencyProfileId, adjustmentId)
			.then(existingAdjustmentObj => {

			if (!existingAdjustmentObj || existingAdjustmentObj === undefined) {
				$rootScope.paycircleMessage('Existing adjustment could not be loaded, new adjustment will be created', 'warn');
				return;
			}

			// Reset label if same as description
			if (existingAdjustmentObj.Label === existingAdjustmentObj.Description) {
				existingAdjustmentObj.Label = '';
			}
			else {
				setAdjustmentLabel(existingAdjustmentObj.Label);
			}

			// If recurring period count set then default to that option
			if (existingAdjustmentObj.RecurringPeriodCount > 0) {
				vmObj.recurForXPayPeriods = true;
			}

			vmObj.newAdjustment = decorateNewAdjustmentObj(existingAdjustmentObj, vmObj.selectedTeamMembers, vmObj.currencies, businessCategoriesArr);

			vmObj.originalRecurringPeriodCount = existingAdjustmentObj.RecurringPeriodCount;

			// Unable to match adjustment type
			selectAdjustmentTypeById(vmObj, existingAdjustmentObj.AgencyAdjustmentGroupEntryID, adjustmentTypesArray);

			// Attach default currency if there is no currency set
			setupSelectedCurrency(vmObj, existingAdjustmentObj, existingAdjustmentObj);

			// Person doesn't have access to adjustment type
			if (!vmObj.selectedAdjustmentType) {
				setPageState('no-access-to-adjustment-type');
				return;
			}

			setPageState('ready');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setupLabelFilter (vmObj) {

		if (vmObj.selectedAdjustmentType) {

			vmObj.labelFilter = function (value) {

				return value.AgencyAdjustmentGroupEntryID === vmObj.selectedAdjustmentType.AgencyAdjustmentGroupEntryID || value.AgencyAdjustmentGroupEntryID === vmObj.selectedAdjustmentType.AgencyAdjustmentParentGroupEntryID;
			};
			return;
		}

		vmObj.labelFilter = null;
	}

	function setupSalaryAdjustmentValues (vmObj) {

		if (vmObj.selectedTeamMembers[0].Salary !== undefined) {

			// Salary
			if (vmObj.selectedTeamMembers[0].Salary.SalaryType === PAYMENT_TYPES.salary) {
				vmObj.newAdjustment.UnitValue = vmObj.calculation.Daily;
				vmObj.newAdjustment.Value = parseFloat(parseFloat(vmObj.newAdjustment.Units * vmObj.calculation.Daily).toFixed(2));
			}

			// Hourly
			else {
				vmObj.newAdjustment.UnitValue = vmObj.calculation.Hourly;
				vmObj.newAdjustment.Value = vmObj.newAdjustment.Units * vmObj.calculation.Hourly;
			}
		}
	}

	function setupSelectedCurrency (vmObj, adjustmentTypeObj, adjustmentObj) {

		if (adjustmentTypeObj.CurrencyID !== config.guidEmpty) {
			angular.extend(adjustmentObj, {
				isPaymentInCurrency: true,
				selectedCurrency: vmObj.currencies.find(currencyObj => currencyObj.CurrencyID === adjustmentTypeObj.CurrencyID)
			});

		} else {
			angular.extend(adjustmentObj, {
				isPaymentInCurrency: false,
				selectedCurrency: null
			});
		}
	}

	function toggleCalculationViewState (vmObj, calculationViewState) {

		if (calculationViewState !== undefined) {
			vmObj.calculationViewState = calculationViewState;
			return;
		}
		else {
			vmObj.calculationViewState = vmObj.calculationViewState === 'calculated' ? 'manual' : 'calculated';

			// For manual Backpay amount set Units and UnitValue to 0. Empty value so it can be provided.
			if (vmObj.calculationViewState === 'manual') {
				vmObj.newAdjustment.Units = 0;
				vmObj.newAdjustment.UnitValue = 0;
				vmObj.newAdjustment.Value = '';
			}
			else {
				setupSalaryAdjustmentValues(vmObj);
			}
		}
	}

	function togglePaymentTypeInformation () {
		$scope.vm.showPaymentTypeInformation = !$scope.vm.showPaymentTypeInformation;
	}

	function toggleRecurring (newAdjustmentObj) {

		newAdjustmentObj.Recurring = !newAdjustmentObj.Recurring;
	}

	function toggleSearchTermLabelsFocus (vmObj, newValue) {

		if (newValue !== undefined) {
			vmObj.searchTermAdjustmentLabelsFocused = newValue;
		}
		else {
			vmObj.searchTermAdjustmentLabelsFocused = !vmObj.searchTermAdjustmentLabelsFocused;
		}
	}

	function toggleSearchTermTeamMembersFocus (vmObj, newValue) {

		$rootScope.$broadcast('close-tooltip-card');
		vmObj.searchTermTeamMembersFocused = newValue;
	}

	function toggleSearchTermTypesFocus(vmObj, newValue) {

		$rootScope.$broadcast('close-tooltip-card');
		vmObj.searchTermAdjustmentTypesFocused = newValue;
	}

	function toggleShowPayslipLabelResults (vmObj, newValue) {

		if (newValue !== undefined) {
			vmObj.showPayslipLabelResults = newValue;
		}
		else {
			vmObj.showPayslipLabelResults = !vmObj.showPayslipLabelResults;
		}
	}

	function updateUserPayElements (vmObj) {

		setPageState('loading');

		payrollData.updateUserPayElements(agencyProfileId, vmObj.selectedPayPeriodId, vmObj.newAdjustments).then(function () {

			setPageState('success');

			$scope.formOptions.forceCallback({
				payPeriodId: vmObj.selectedPayPeriodId,
				userId: vmObj.selectedTeamMembers[0].UserID,
				REDIRECT_TO_TEAM
			});
			$scope.formOptions.closeForm();

			// Demo tasks
			for (var adjustment of vmObj.newAdjustments) {

				switch (adjustment.AgencyAdjustmentID) {
					case PAY_ELEMENTS.annualBonus:
					case PAY_ELEMENTS.annualBonusPercent:
					case PAY_ELEMENTS.bonus:
					case PAY_ELEMENTS.bonusPercent:
					case PAY_ELEMENTS.christmasBonus:
					case PAY_ELEMENTS.christmasBonusPercent:
					case PAY_ELEMENTS.referralBonus:
					case PAY_ELEMENTS.referralBonusPercent:
					case PAY_ELEMENTS.signOnBonus:
					case PAY_ELEMENTS.signOnBonusPercent:
						$rootScope.setDemoTaskAsComplete('addBonus', adjustment.teamMember.Forename);
						break;
					case PAY_ELEMENTS.accommodationExpenses:
					case PAY_ELEMENTS.expenses:
					case PAY_ELEMENTS.internetExpenses:
					case PAY_ELEMENTS.mileageExpenses:
					case PAY_ELEMENTS.mobilePhoneExpenses:
					case PAY_ELEMENTS.subsistenceExpenses:
					case PAY_ELEMENTS.travelExpenses:
						if (adjustment.Label !== '') {
							$rootScope.setDemoTaskAsComplete('addExpense', adjustment.teamMember.Forename);
						}
				}
			}
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setRecurringPeriodCount(vmObj) {
		if ($scope.vm.recurForXPayPeriods) {
			vmObj.newAdjustment.RecurringPeriodCount = 1;
		}
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_CATEGORY_TYPES,
		ADJUSTMENT_PAYMENT_TYPES,
		ADJUSTMENT_SPECIAL_TYPES,
		ADJUSTMENT_VALUE_TYPES,
		CAN_ADD_DEPARTMENT_CHANGES,
		EMPLOYMENT_TYPES,
		PAYMENT_TYPES,
		SEARCH_RESULTS_LIMIT,
		SEARCH_TERM_MIN_COUNT,

		config,
		regexService,

		addChange,
		calculateAdjustmentValue,
		calculatePercentageValue,
		changeAdjustmentTypeFilter,
		deselectAdjustmentType,
		deselectTeamMember,
		getPayPeriodForPeriodCount,
		incrementSearchResultsAdjustmentTypes,
		incrementSearchResultsTeam,
		isBusinessCategoriesInvalid,
		isNetToGrossCalculation,
		onAdditionalPostChange,
		onApplyToAdditionalPostChange,
		onBusinessCategoriesOverrideChange,
		onIsPaymentInCurrencyChange,
		onPensionChange,
		resetAdjustmentLabelSearchTerm,
		resetAdjustmentTypeSearchTerm,
		resetNetToGrossEnabled,
		resetPayslipLabel,
		resetTeamMemberSearchTerm,
		reviewNetToGross,
		reviewPeriodOverride,
		selectAdjustmentLabel,
		selectAdjustmentType,
		selectAdjustmentTypeFromAdjustmentLabel,
		selectSalaryRate,
		selectTeamMember,
		selectTeamMemberByDepartment,
		setAdjustmentValueToAccruedHolidayTotal,
		setPercentageCalculationToSalary,
		setRecurringPeriodCount,
		toggleCalculationViewState,
		togglePaymentTypeInformation,
		toggleRecurring,
		toggleSearchTermLabelsFocus,
		toggleSearchTermTeamMembersFocus,
		toggleSearchTermTypesFocus,
		toggleShowPayslipLabelResults
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addLeaveForm', function () {

	return {
		controller: 'addLeaveFormCtrl',
		templateUrl: 'forms/payroll/addLeave/addLeaveForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addLeaveFormCtrl', ['$scope', 'agency', 'growl', 'holidaySicknessService', 'LEAVE_TYPES', 'LEAVE_TYPE_DESCRIPTIONS', function ($scope, agency, growl, holidaySicknessService, LEAVE_TYPES, LEAVE_TYPE_DESCRIPTIONS) {

	const AGENCY_PROFILE_ID = $scope.formOptions.agencyProfileId;
	const USER_ID = $scope.formOptions.userId;
	const LEAVE_TYPE = $scope.formOptions.leaveType;

	const newLeave = holidaySicknessService.getEmptyLeave();

	function canAddSelectedLeaveType (selectedLeaveType) {

		if (!selectedLeaveType) {
			return false;
		}

		return true;
	}

	function addNewLeave (newLeaveObj, formObj) {

		if (!canAddSelectedLeaveType(newLeaveObj.selectedLeaveType)) {
			return;
		}

		formObj.state = 'saving';

		if (newLeaveObj.selectedLeaveType.id === LEAVE_TYPE_DESCRIPTIONS.sickLeave) {

			agency.getEmptySicknessDetail().then(sickLeaveObj => {

				sickLeaveObj = holidaySicknessService.decorateNewSicknessDetail(sickLeaveObj, newLeaveObj);

				agency.updateSicknessDetail(USER_ID, AGENCY_PROFILE_ID, sickLeaveObj).then(updatedLeaveObj => {

					growl.success(`You have added ${updatedLeaveObj.SicknessDays} days sick leave for ${$scope.formOptions.context.Forename}.`);

					saveForm(formObj);
				})
				.catch(onError);
			})
			.catch(onError);

		} else {

			agency.getEmptyHolidayDetail().then(holidayLeaveObj => {

				holidayLeaveObj = holidaySicknessService.decorateNewHolidayDetail(holidayLeaveObj, newLeaveObj);

				agency.updateHolidayDetail(USER_ID, AGENCY_PROFILE_ID, holidayLeaveObj).then(updatedLeaveObj => {

					growl.success(`You have added ${updatedLeaveObj.HolidayDays} days holiday for ${$scope.formOptions.context.Forename}.`);

					saveForm(formObj);
				})
				.catch(onError);
			})
			.catch(onError);
		}
	}

	function init () {

		setPageState('loading');

		newLeave.selectedLeaveType = LEAVE_TYPE === 'sickness' ? LEAVE_TYPES.sickness[0] : null;

		$scope.$watch('[newLeave.startDateIso, newLeave.endDateIso, newLeave.selectedLeaveType]', function () {

			if (newLeave.startDateIso && !newLeave.endDateIso) {
				newLeave.endDateIso = newLeave.startDateIso;
			}

			if (newLeave.startDateIso && newLeave.endDateIso && newLeave.selectedLeaveType) {
				holidaySicknessService.calculateLeaveLength(newLeave);
			}
		});

		setPageState('ready');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function saveForm (formObj) {
		formObj.state = 'saved';
		$scope.formOptions.forceCallback();
		$scope.formOptions.closeForm();
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		LEAVE_TYPES: LEAVE_TYPES[LEAVE_TYPE],
		LEAVE_TYPE_DESCRIPTIONS,

		newLeave,

		addHalfDayFrom: holidaySicknessService.addHalfDayFrom,
		addHalfDayTo: holidaySicknessService.addHalfDayTo,
		addNewLeave
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('addPeriodNoteForm', function () {

	return {
		controller: 'addPeriodNoteFormCtrl',
		templateUrl: 'forms/payroll/addPeriodNote/addPeriodNoteForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addPeriodNoteFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$sanitize',
	'$scope',
	'growl',
	'messageData',
	'payrollData',
	'DOCUMENT_TYPE_IDS',
	'MENTION_OPTIONS',
	'REGEX',
	function (
		$filter,
		$q,
		$rootScope,
		$sanitize,
		$scope,
		growl,
		messageData,
		payrollData,
		DOCUMENT_TYPE_IDS,
		MENTION_OPTIONS,
		REGEX
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;

	function checkForMentions (vmObj, formObj) {

		const mentionsArr = vmObj.note.Text.match(REGEX.mention);

		if (mentionsArr === null) {
			setPageState('no-mention');
		}
		else {
			createMessage(vmObj, formObj);
		}
	}

	function createMessage (vmObj, formObj) {

		setPageState('loading');

		// Update state
		if (formObj !== undefined)
		{
			formObj.state = 'saving';
		}
		// Sanitize text
		vmObj.note.Text = $sanitize(vmObj.note.Text);

		vmObj.note.Text = $filter('emojify')(vmObj.note.Text, 'demojify');

		messageData.createMessage(agencyProfileId, currentPayPeriodObj.PayPeriodID, vmObj.note).then(() => {

			if (formObj !== undefined)
			{
				formObj.state = 'saved';
			}

			growl.success('Note saved 👍');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	function deleteFileByIndex (documentListArr, index) {
		documentListArr.splice(index, 1);
	}

	function displayFiles (filesArr) {
		$scope.vm.note.DocumentList = filesArr;
	}

	function init () {

		setPageState('loading');

		messageData.getMessageNew().then(noteObj => {

			$scope.vm = {
				note: noteObj,
				fileUploaderParams: {
					AgencyProfileID: agencyProfileId,
					DocumentData: noteObj.MessageID,
					DocumentTypeID: DOCUMENT_TYPE_IDS.message
				}
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
	    console.error(error);
	}

	function onUploadComplete () {

		/* Upload(s) starting so enable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$scope.formOptions.isCloseFormDisabled = false;
	}

	function onUploadStart () {

		/* Upload(s) starting so disable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$scope.formOptions.isCloseFormDisabled = true;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function goBack () {

		setPageState('ready');
	}


	init();

	angular.extend($scope, {
		MENTION_OPTIONS,

		checkForMentions,
		createMessage,
		deleteFileByIndex,
		displayFiles,
		goBack,
		onError,
		onUploadComplete,
		onUploadStart
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('addPeriodTaskForm', function () {

	return {
		controller: 'addPeriodTaskFormCtrl',
		templateUrl: 'forms/payroll/addPeriodTask/addPeriodTaskForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addPeriodTaskFormCtrl', [
	'$filter',
	'$q',
	'$sanitize',
	'$scope',
	'growl',
	'messageData',
	'payrollData',
	'session',
	'teamData',
	'DOCUMENT_TYPE_IDS',
	'MENTION_OPTIONS',
	'MESSAGE_TYPES',
	'PERMISSION_TYPES',
	'REGEX',
	function (
		$filter,
		$q,
		$sanitize,
		$scope,
		growl,
		messageData,
		payrollData,
		session,
		teamData,
		DOCUMENT_TYPE_IDS,
		MENTION_OPTIONS,
		MESSAGE_TYPES,
		PERMISSION_TYPES,
		REGEX
	) {

	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;
	const currentUser = session.user;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const noteObj = $scope.formOptions.note;
	const oldTaskObj = $scope.formOptions.task;
	const reassignBool = $scope.formOptions.reassign;

	function assignTaskToAdmin (vmObj, adminObj) {

		vmObj.task.RecipientID = adminObj.UserID;
		vmObj.selectedAdmin = adminObj;
	}

	function createMessage (vmObj, formObj) {

		messageData.createMessage(agencyProfileId, currentPayPeriodObj.PayPeriodID, vmObj.task).then(() => {

			formObj.state = 'saved';

			growl.success('Task saved 👍');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	function decorateAdmins (adminsObj) {

		let adminsArr = adminsObj.BureauAdmins.concat(adminsObj.CompanyAdmins);

		// If current user isn't in list then add to top
		if (!adminsArr.find(adminObj => adminObj.UserID === currentUser.UserResponseUserID)) {
			adminsArr.unshift({
				UserID: currentUser.UserResponseUserID,
				Forename: currentUser.UserResponseFirstName,
				Surname: currentUser.UserResponseLastName,
				EmailAddress: currentUser.UserResponseUsername,
				isCurrentUser: true
			});
		}

		return adminsArr;
	}

	function deleteFileByIndex (documentListArr, index) {

		documentListArr.splice(index, 1);
	}

	function displayFiles (filesArr) {

		$scope.vm.task.DocumentList = filesArr;
	}

	function getFileUploaderParams (taskObj) {
		return {
			AgencyProfileID: agencyProfileId,
			DocumentData: taskObj.MessageID,
			DocumentTypeID: DOCUMENT_TYPE_IDS.message
		};
	}

	function init () {

		setPageState('loading');

		if (oldTaskObj) {
			initEditTaskForm(oldTaskObj);

		} else if (noteObj) {
			initNewTaskFromNoteFrom(noteObj);

		} else {
			initNewTaskForm();
		}
	}

	function initEditTaskForm (taskObj) {

		teamData.getTeamMemberAdminsExtended(agencyProfileId, PERMISSION_TYPES.hasAddTaskPermission).then(teamMemberAdminsObj => {

			const teamMemberAdminsArr = decorateAdmins(teamMemberAdminsObj);

			taskObj.Text = $filter('emojify')($sanitize(taskObj.Text));

			$scope.vm = {
				admins: teamMemberAdminsArr,
				selectedAdmin: noteObj || reassignBool ? null : teamMemberAdminsArr.find(adminObj => adminObj.UserID === taskObj.RecipientID),
				task: taskObj,
				fileUploaderParams: getFileUploaderParams(taskObj)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function initNewTaskForm () {

		let getMessageNew = messageData.getMessageNew();
		let getTeamMemberAdminsExtended = teamData.getTeamMemberAdminsExtended(agencyProfileId, PERMISSION_TYPES.hasAddTaskPermission);

		$q.all([
			getMessageNew,
			getTeamMemberAdminsExtended
		]).then(([
			taskObj,
			teamMemberAdmins
		]) => {

			taskObj.Type = MESSAGE_TYPES.tasks;

			$scope.vm = {
				admins: decorateAdmins(teamMemberAdmins),
				selectedAdmin: null,
				task: taskObj,
				fileUploaderParams: getFileUploaderParams(taskObj)
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function initNewTaskFromNoteFrom () {

		messageData.copyMessage(agencyProfileId, noteObj.MessageID, MESSAGE_TYPES.tasks).then(newTaskObj => {

			newTaskObj.MentionList = [];

			const mentionsArr = newTaskObj.Text.match(REGEX.mention);

			if (angular.isArray(mentionsArr)) {

		 		for (let mention of mentionsArr) {

		 			let mentionNoBrackets = mention.replace(MENTION_OPTIONS.bracketCharacter[0], '')
		 									 .replace(MENTION_OPTIONS.bracketCharacter[1], '');

		 			newTaskObj.Text = newTaskObj.Text.replace(mention, mentionNoBrackets);
				}
	 		}

			initEditTaskForm(newTaskObj);
		})
		.catch(onError);
	}

	function onCancelClick () {

		// User may have deleted files before pressing 'Cancel'. So ensure the view is updated as if changes have been made.
		$scope.formOptions.forceCallback();
		$scope.formOptions.closeForm();
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onUploadComplete () {

		/* Upload(s) starting so enable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$scope.formOptions.isCloseFormDisabled = false;
	}

	function onUploadStart () {

		/* Upload(s) starting so disable form close using built-in slide in form icon button.
		   (this also affects the Cancel button in this form's template) */
		$scope.formOptions.isCloseFormDisabled = true;
	}

	function reassignTask (vmObj) {

		vmObj.task.RecipientID = '';
		vmObj.selectedAdmin = null;
	}

	function saveForm (vmObj, formObj) {

		setPageState('loading');

		// Update state
		formObj.state = 'saving';

		// Sanitize text
		vmObj.task.Text = $sanitize(vmObj.task.Text);

		vmObj.task.Text = $filter('emojify')(vmObj.task.Text, 'demojify');

		if (oldTaskObj) {
			updateMessage(vmObj, formObj);
		} else {
			createMessage(vmObj, formObj);
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateMessage (vmObj, formObj) {

		messageData.updateMessage(vmObj.task).then(() => {

			formObj.state = 'saved';

			growl.success('Task updated 👍');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		assignTaskToAdmin,
		createMessage,
		deleteFileByIndex,
		displayFiles,
		onCancelClick,
		onError,
		onUploadComplete,
		onUploadStart,
		reassignTask,
		saveForm
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('advanceFuturePeriodsForm', function () {

	return {
		controller: 'advanceFuturePeriodsFormCtrl',
		templateUrl: 'forms/payroll/advance-future-periods/advance-future-periods.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('advanceFuturePeriodsFormCtrl', [
	'$scope',
	'agency',
	'userData',
	'utilities',
function (
	$scope,
	agency,
	userData,
	utilities
) {

	const PAGE_STATES = {
		complete: 'complete',
		confirmation: 'confirmation',
		error: 'error',
		loading: 'loading',
		noFuturePeriods: 'no-future-periods',
		ready: 'ready'
	};

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriod = $scope.formOptions.currentPayPeriod;

	function advanceFuturePeriods (advanceFuturePeriodsContextObj, formObj) {

		formObj.state = 'saving';

		const ADVANCE = true;

		userData.updateUserAgencyProfilesAdvancePeriods(
			agencyProfileId,
			advanceFuturePeriodsContextObj.userIds,
			ADVANCE,
			advanceFuturePeriodsContextObj.periodsToAdvance
		).then(function () {

			formObj.state = 'saved';
			setPageState(PAGE_STATES.complete);

			$scope.formOptions.forceCallback();
		})
		.catch(onError);
	}

	function createAdvanceFuturePeriodsContextObj (formOptionsObj, advancePayPeriodsArr) {

		const advanceFuturePeriodsContextObj = {
			applicableTo: formOptionsObj.userIds.length === 1 ? formOptionsObj.context.Forename : 'the selected team members',
			periodsToAdvance: 1,
			periodsToAdvanceMax: advancePayPeriodsArr.length,
			periodsToAdvanceMin: 1,
			// This will be a singleton array for 'user' context, multiple for bulk operation and 'company' context
			userIds: formOptionsObj.userIds
		};

		// This form can be invoked in the context of 'user' (used for single) or 'company' (for bulk operations)
		if (angular.isDefined(formOptionsObj.userId)) {
			// This is a single user operation. Text is the user's forename from the form options context obj.
			angular.extend(advanceFuturePeriodsContextObj, {
				isBulk: false,
				text: formOptionsObj.context.Forename
			});
		}
		else {
			/* This is a bulk operation. Text is generic 'x team members'. There should never be a bulk operation
			   for a single team member, since that situation invoked from the UI will default to 'user' context */
			const userIds = formOptionsObj.userIds;
			angular.extend(advanceFuturePeriodsContextObj, {
				isBulk: true,
				text: `${utilities.getNumberText(userIds.length)} team members`
			});
		}

		return advanceFuturePeriodsContextObj;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		/* This form always requires a userIds array, even for a single user, just for consistency. So account for that
		   here. If userIds isn't defined in the formOptions, create it from the userId */
		if (angular.isUndefined($scope.formOptions.userIds)) {
			$scope.formOptions.userIds = [$scope.formOptions.userId];
		}

		agency.getPayPeriodsForAdvancePeriods(agencyProfileId).then(advanceFuturePeriodsArr => {

			if (advanceFuturePeriodsArr.length === 0) {
				setPageState(PAGE_STATES.noFuturePeriods);
			}

			else {

				$scope.vm = {
					advanceFuturePeriods: advanceFuturePeriodsArr,
					advanceFuturePeriodsContext: createAdvanceFuturePeriodsContextObj($scope.formOptions, advanceFuturePeriodsArr),
					confirmInformation: false,
					currentPayPeriod
				};

				setPageState(PAGE_STATES.confirmation);
			}
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function onPeriodsToAdvanceChange (vmObj) {

		// Keep hold of the last advance period for later display
		const advanceFuturePeriodsContext = vmObj.advanceFuturePeriodsContext;
		advanceFuturePeriodsContext.lastAdvancePeriodDisplay = vmObj.advanceFuturePeriods[advanceFuturePeriodsContext.periodsToAdvance - 1].PayPeriodDisplay;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		utilities,

		advanceFuturePeriods,
		onPeriodsToAdvanceChange,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('applyTaxRefundForm', function () {

	return {
		controller: 'applyTaxRefundFormCtrl',
		templateUrl: 'forms/payroll/applyTaxRefund/applyTaxRefundForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('applyTaxRefundFormCtrl', ['$scope', 'payrollData', 'userData', function ($scope, payrollData, userData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;
	var company = $scope.formOptions.company;

	function init () {

		setPageState('loading');

		if (company.IsInTestMode) {
			setPageState('test-mode');
			return;
		}

		var calculateTaxRefund = true;

		payrollData.getTeamMemberPayroll(agencyProfileId, userId, calculateTaxRefund).then(function (teamMemberObj) {

			if (teamMemberObj.TaxPayable < 0) {
				$scope.teamMember = teamMemberObj;
				setPageState('ready');

			} else {
				setPageState('no-refund-due');

			}
		})
		.catch(function () {

			setPageState('error');
		});
	}

	function updateTaxRefund (teamMemberObj, formObj) {

		formObj.state = 'saving';

		if (teamMemberObj.IsTaxRefund) {
			teamMemberObj.TaxPayable = 0;
		}

		userData.updateUserAgencyProfileTaxRefund(agencyProfileId, userId, teamMemberObj.TaxPayable).then(function () {

			formObj.state = 'saved';
			setPageState('saved');

			$scope.formOptions.forceCallback();
		})
		.catch(function () {

			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.updateTaxRefund = function (teamMemberObj, formObj) {

		updateTaxRefund(teamMemberObj, formObj);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('attachmentOfEarningsForm', function () {

	return {
		controller: 'attachmentOfEarningsFormCtrl',
		templateUrl: 'forms/payroll/attachment-of-earnings/attachment-of-earnings.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('attachmentOfEarningsFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'base',
	'config',
	'disbursementService',
	'payrollData',
	'session',
	'teamData',
	'utilities',
	'AOE_ORDER_TYPES',
	'BACS_PAYMENT_TYPES',
	'PAY_PERIOD_TYPES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		$timeout,
		base,
		config,
		disbursementService,
		payrollData,
		session,
		teamData,
		utilities,
		AOE_ORDER_TYPES,
		BACS_PAYMENT_TYPES,
		PAY_PERIOD_TYPES
	) {

	const UNIT_TYPE_IDS = {
		percent: 1,
		absolute: 2
	};
	const UNIT_TYPES = [
		{
			id: UNIT_TYPE_IDS.percent,
			description: '%'
		},
		{
			id: UNIT_TYPE_IDS.absolute,
			description: '£'
		}
	];

	var activeStep = $scope.formOptions.activeStep;
	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var currentPayPeriod = $scope.formOptions.currentPayPeriod;
	var aoeId = $scope.formOptions.aoeId;
	var isInEditMode = aoeId !== undefined;
	var totalSteps = 6;
	var userId = $scope.formOptions.userId;

	function createAttachmentOfEarnings (aoeObj, form) {

		form.state = 'saving';

		var agencyPayPeriodID = currentPayPeriod.PayPeriodID;

		// Reset to zero if not populated
		aoeObj.AmountPaid = aoeObj.AmountPaid === '' ? 0 : aoeObj.AmountPaid;
		aoeObj.FixedAmountValue = aoeObj.FixedAmountValue === '' ? 0 : aoeObj.FixedAmountValue;
		aoeObj.ProtectedEarningsValue = aoeObj.ProtectedEarningsValue === '' ? 0 : aoeObj.ProtectedEarningsValue;
		aoeObj.TotalAmount = aoeObj.TotalAmount === '' || aoeObj.TotalAmount === null ? 0 : aoeObj.TotalAmount;

		aoeObj.OrderDateISO        = moment(aoeObj.OrderDateISO).format(config.dateFormatISO);
		aoeObj.OrderDateAddedISO   = moment().format(config.dateFormatISO);

		if (aoeObj.DisbursementDetail.ManualPayment) {
			aoeObj.DisbursementDetail = disbursementService.resetDisbursementBankInfo(aoeObj.DisbursementDetail);
		}

		aoeObj.IsManualPayment = aoeObj.DisbursementDetail.ManualPayment;
		aoeObj.DisbursementDetail.BankInfo.BACSPaymentReference = aoeObj.PaymentReference;

		// Tempoary fix for bank detail issue
		if (angular.isDefined(aoeObj.Bank)) {
			aoeObj.Bank = angular.copy(aoeObj.DisbursementDetail.BankInfo);
		}

		teamData.createAttachmentOfEarnings(userId, agencyProfileId, agencyPayPeriodID, aoeObj).then(() => {

			form.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			goToStep(7);
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function goToNextStep () {

		if ($scope.activeStep <= totalSteps) {
			$scope.activeStep++;
		}
	}

	function goToPreviousStep () {

		$scope.activeStep--;
	}

	function goToStep (stepNumber) {

		$scope.activeStep = stepNumber;
	}

	function init () {

		setPageState('loading');

		const getAttachmentOrderDetails = teamData.getAttachmentOrderDetails(aoeId);
		const getAttachmentOrderTypes = teamData.getAttachmentOrderTypes();
		const getBankDetailsCompany = base.getBankDetailsCompany(agencyProfileId);

		$q.all([
			getAttachmentOrderDetails,
			getAttachmentOrderTypes,
			getBankDetailsCompany
		]).then(([
			aoeObj,
			orderTypes,
			companyBankDetailsObj
		]) => {

			// Decorate
			aoeObj.hasTotalAmount = true;
			aoeObj.isFixedAmountRequired = false;
			aoeObj.isNewOrder = true; // To know whether 'Remaining Amount' field is required
			aoeObj.orderDateISOMax = moment().add(1, 'year').format(); // Set order max validation date to today + 1yr
            aoeObj.originalAmountPaid = angular.copy(aoeObj.AmountPaid);
            currentPayPeriod.PeriodType = currentPayPeriod.PayPeriodType;

			// Force selection to reveal options
			if (aoeObj.AttachmentOrderType.AttachmentOrderRateID === config.guidEmpty) {
				aoeObj.AttachmentOrderType = null;
			}

			// Empty total amount if zero to make sure it's manually entered
			aoeObj.adminChargeText = 'Apply ' + $filter('monetisedown')(aoeObj.AdminChargeValue) + ' admin charge';
			aoeObj.AmountPaid = aoeObj.AmountPaid !== 0 ? aoeObj.AmountPaid : '';
			aoeObj.FixedAmountValue = aoeObj.FixedAmountValue !== 0 ? aoeObj.FixedAmountValue : '';
			aoeObj.ProtectedEarningsValue = aoeObj.ProtectedEarningsValue !== 0 ? aoeObj.ProtectedEarningsValue : '';
			aoeObj.TotalAmount = aoeObj.TotalAmount !== 0 ? aoeObj.TotalAmount : '';

			// Scope
			$scope.aoe = aoeObj;
			$scope.currentPayPeriod = currentPayPeriod;
			$scope.orderTypes = orderTypes;
			$scope.isInEditMode = isInEditMode;
			$scope.isAoeBacsEnabled = (companyBankDetailsObj.BACSEnabled && $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.aoe));

			setPageState('ready');

			// If editing AOE, go straight to edit details
			if (isInEditMode) {

				if (activeStep !== undefined) {
					goToStep(activeStep);
				}
				else {
					goToStep(3);
				}
				return;
			}
			else {
				goToStep(0);
			}
		})
		.catch(error => {
			$scope.pageState = 'error';
			console.error(error);
		});
	}

	function resetOrderType (aoeObj) {

		// Empty daily rate value by default
		if (aoeObj.AttachmentOrderType.AttachmentOrderRateID === AOE_ORDER_TYPES.cmaScotland) {
			aoeObj.DailyRateValue = '';
		}

		// Always reset to 0 if not applicable
		else {
			aoeObj.DailyRateValue = 0;
		}

		aoeObj.hasTotalAmount = true; 
	}

	function resetTotalAmount (aoeObj) {

		if (!aoeObj.hasTotalAmount) {
			aoeObj.TotalAmount = '';
		}
	}

	function reviewAoeDetailsStep (aoeObj, payPeriodObj) {

		// For DEO AOE's, a fixed value is required if no total amount is provided
		if (aoeObj.AttachmentOrderType.AttachmentOrderRateID === AOE_ORDER_TYPES.deo) {
			aoeObj.isFixedAmountRequired = true;
			aoeObj.HasFixedValue = true;
		}
		else {
			aoeObj.isFixedAmountRequired = false;
			aoeObj.HasFixedValue = false;
		}

		// End date validation > Cannot be earlier than the later of [order start date] or [start of current period]
		aoeObj.orderEndDateISOMin = utilities.getLaterDateISO(aoeObj.OrderDateISO, payPeriodObj.StartDateISO);

		goToNextStep(aoeObj);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function validateAoeEligibility (aoeObj) {

		if (aoeObj.isNewOrder) {

			goToStep(1);

			$timeout(() => {

				teamData.getAttachmentOrderInformation(userId, agencyProfileId).then(aoeInformationObj => {

					$scope.aoeInformation = aoeInformationObj;
					setPageState('ready');

					if (!aoeInformationObj.IsEligible) {
						goToStep(2);
					}
					else {
						goToStep(3);
					}
				})
				.catch(error => {
					setPageState('error');
					console.error(error);
				});
			}, 5000);
		}

		else {

			setPageState('loading');

			teamData.getAttachmentOrderInformation(userId, agencyProfileId).then(aoeInformationObj => {

				$scope.aoeInformation = aoeInformationObj;
				setPageState('ready');

				goToStep(3);
			})
			.catch(error => {
				setPageState('error');
				console.error(error);
			});
		}
	}

	init();

	angular.extend($scope, {
		PAY_PERIOD_TYPES,
		AOE_ORDER_TYPES,
		UNIT_TYPE_IDS,
		UNIT_TYPES,

		createAttachmentOfEarnings,
		goToNextStep,
		goToPreviousStep,
		goToStep,
		resetOrderType,
		resetTotalAmount,
		reviewAoeDetailsStep,
		validateAoeEligibility,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('attachmentOfEarningsViewForm', function () {

	return {
		controller: 'attachmentOfEarningsViewFormCtrl',
		templateUrl: 'forms/payroll/attachment-of-earnings/attachment-of-earnings-view.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('attachmentOfEarningsViewFormCtrl', [
	'$filter',
	'$scope',
	'$rootScope',
	'$q',
	'base',
	'disbursementService',
	'payrollData',
	'teamData',
	'AOE_ORDER_STATES',
	'AOE_ORDER_TYPES',
	'BACS_PAYMENT_TYPES',
	function (
		$filter,
		$scope,
		$rootScope,
		$q,
		base,
		disbursementService,
		payrollData,
		teamData,
		AOE_ORDER_STATES,
		AOE_ORDER_TYPES,
		BACS_PAYMENT_TYPES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const aoeId = $scope.formOptions.aoeId;
	const callback = $scope.formOptions.callback;
	const userId = $scope.formOptions.userId;

	let activeTab = 'details';

	function cancelAoe (aoeObj, formObj) {

		formObj.state = 'saving';

		// Delete
		if (aoeObj.IsEditable) {

			teamData.deleteAttachmentOrder(aoeObj.AttachmentOrderID).then(() => {

				formObj.state = 'saved';

				$scope.formOptions.forceCallback();

				setPageState('cancelled');
			})
			.catch(onError);
		}

		// Cancel
		else {

			teamData.cancelAttachmentOrder(aoeObj.AttachmentOrderID, aoeObj.CancelledReason.ReasonState).then(() => {

				formObj.state = 'saved';

				$scope.formOptions.forceCallback();

				setPageState('cancelled');
			})
			.catch(onError);
		}
	}

	function changeTab (tabKey) {
		$scope.activeTab = tabKey;
	}

	function init () {

		setPageState('loading');

		const getAttachmentOrderDetails = teamData.getAttachmentOrderDetails(aoeId);
		const getAttachmentOrderPaymentHistory = teamData.getAttachmentOrderPaymentHistory(aoeId);
		const getBankDetailsCompany = base.getBankDetailsCompany(agencyProfileId);
		const getCancelledReasonDetails = teamData.getCancelledReasonDetails();

		$q.all([
			getAttachmentOrderDetails,
			getAttachmentOrderPaymentHistory,
			getCancelledReasonDetails,
			getBankDetailsCompany
		]).then(([
			aoeObj,
			aoePaymentsObj,
			cancellationReasonsArr,
			companyBankDetailsObj
		]) => {

			const isAoeBacsEnabled = (companyBankDetailsObj.BACSEnabled && $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.aoe));

			if (isAoeBacsEnabled) {
				aoeObj.bacsPaymentInfoText = disbursementService.getBACSPaymentInfoText(aoeObj.DisbursementDetail);
			}

			// Add flag to indicate whether or not the AOE has bank details. These could all be empty strings, so no 'isUndefined'
			const bankInfo = aoeObj.DisbursementDetail.BankInfo;
			aoeObj.hasBankDetails = bankInfo.BankAccountName || bankInfo.SortCode || bankInfo.BankAccountNumber;

			angular.extend($scope,  {
				aoe: aoeObj,
				aoePayments: aoePaymentsObj.OrderPayments,
				cancellationReasons: cancellationReasonsArr,
				finalPayment: aoePaymentsObj.OrderPayments.length ? aoePaymentsObj.OrderPayments[aoePaymentsObj.OrderPayments.length - 1] : null,
				isAoeBacsEnabled: isAoeBacsEnabled
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		
		setPageState('error');
		console.error(error);
	}

	function openViewAttachmentOfEarningsForm (aoe, activeStep) {
		
		$scope.formOptions.openNewSlideInForm({
			formKey: 'attachment-of-earnings',
			activeStep: activeStep,
			aoeId: aoe.AttachmentOrderID,
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			userId: userId
		});
	}

	function updateAttachmentOrderPaused (aoeObj, isPaused, formObj) {

		formObj.state = 'saving';

		teamData.updateAttachmentOrderPaused(aoeObj.AttachmentOrderID, isPaused)
			.then(() => {
				init();
				$scope.formOptions.forceCallback();
			})
			.catch(onError);
	}

	function setPageState (pageState) {
		
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		AOE_ORDER_STATES,
		AOE_ORDER_TYPES,

		activeTab,
		cancelAoe,
		changeTab,
		openViewAttachmentOfEarningsForm,
		setPageState,
		updateAttachmentOrderPaused,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('calculatePayrollForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'calculatePayrollFormCtrl',
	templateUrl: 'forms/payroll/calculate-payroll/calculate-payroll.form.html'
})

.controller('calculatePayrollFormCtrl', [
	'$q',
	'$rootScope',
	'aiServices',
	'config',
	'messageData',
	'payrollData',
	'teamData',
	'DRAFT_PAYSLIP_TASK_STATES',
	function (
		$q,
		$rootScope,
		aiServices,
		config,
		messageData,
		payrollData,
		teamData,
		DRAFT_PAYSLIP_TASK_STATES
	) {

	const $ctrl = this;

	const FORM_STATES = {
		loading: 'loading',
		calculatePayroll: 'calculate-payroll',
		uncalculatePayroll: 'uncalculate-payroll',
		error: 'error'
	};

	function $onInit () {

		setPageState(FORM_STATES.loading);

		// Load pay calculations for pay period
		const getPayPeriodCISDeductions = payrollData.getPayPeriodCISDeductions($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId);
		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific($ctrl.formOptions.payPeriodId);
		const getDraftPayslipsState = aiServices.getDraftPayslipsState($ctrl.formOptions.payPeriodId);

		$q.all([
			getPayPeriodCISDeductions,
			getPayPeriodSpecific,
			getDraftPayslipsState
		])
		.then(([
			cisDeductionsObj,
			payPeriodObj,
			draftPayslipsStateObj
		]) => {

			angular.extend($ctrl, {
				cisDeductions: cisDeductionsObj,
				payPeriod: payPeriodObj,
				draftPayslipsState: draftPayslipsStateObj,
				// Use empty Guid if workflow template ID is not specified. Payroll is being (un)locked for a non-workflow company
				workflowTemplateId: angular.isDefined($ctrl.formOptions.workflowTemplateId) ? $ctrl.formOptions.workflowTemplateId : config.guidEmpty
			});

			switch ($ctrl.formOptions.actionType) {
				case 'uncalculate':

					// Check stage here and if reports show different form (see page 22 of designs) // unlock-payroll-reports
					setPageState(FORM_STATES.uncalculatePayroll);

					break;

				default:
					setPageState(FORM_STATES.calculatePayroll);
			}
		})
		.catch(onError);
	}

	function calculatePayroll ($ctrl, $form) {

		const IS_LOCKED = true;

		$form.state = 'saving';

		const updateWorkflowTemplatePayrollLocked = messageData.updateWorkflowTemplatePayrollLocked($ctrl.formOptions.agencyProfileId, $ctrl.workflowTemplateId, IS_LOCKED);

		// If form has changed, call the service
		const updateAgencyPayPeriodCISDeductions = $form.$dirty ? payrollData.updateAgencyPayPeriodCISDeductions($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId, $ctrl.cisDeductions) : null;

		$q.all([
			updateWorkflowTemplatePayrollLocked,
			updateAgencyPayPeriodCISDeductions
		])
		.then(onFormSave)
		.catch(onError);
	}

	function onError (error) {
		setPageState(FORM_STATES.error);
		console.error(error);
	}

	function onFormSave () {
		$ctrl.formOptions.forceCallback();
		$ctrl.formOptions.closeForm();

		// Refresh current period in app header
		$rootScope.$broadcast('refresh-current-period');
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	function uncalculatePayroll ($form) {

		const IS_LOCKED = false;

		$form.state = 'saving';

		const updateWorkflowTemplatePayrollLocked = messageData.updateWorkflowTemplatePayrollLocked($ctrl.formOptions.agencyProfileId, $ctrl.workflowTemplateId, IS_LOCKED);
		const processPendingRotareadyEvents = $rootScope.currentCompany.IsRotareadyIntegrationEnabled ? teamData.processPendingAccessRotareadyEvents($ctrl.formOptions.agencyProfileId) : null;
	
		$q.all([
			updateWorkflowTemplatePayrollLocked,
			processPendingRotareadyEvents
		])
		.then(onFormSave)
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		calculatePayroll,
		uncalculatePayroll,

		DRAFT_PAYSLIP_TASK_STATES,
		FORM_STATES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('cancelMovePayrollsForm', function () {

	return {
		controller: 'cancelMovePayrollsFormCtrl',
		templateUrl: 'forms/payroll/cancel-move-payrolls/cancelMovePayrollsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cancelMovePayrollsFormCtrl', [
	'$scope',
	'$state',
	'userData',
	'PAYROLL_MOVE_VALID_STATUSES',
	function (
		$scope,
		$state,
		userData,
		PAYROLL_MOVE_VALID_STATUSES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const teamMember = $scope.formOptions.teamMember;

	const CANCEL_MOVE_PAYROLL_PAGE_STATES = {
		cancelInvalid: 'cancel-invalid',
		confirmCancel: 'confirm-cancel',
		error: 'error',
		loading: 'loading',
		success: 'success'
	};

	function init () {

		setPageState(CANCEL_MOVE_PAYROLL_PAGE_STATES.loading);

		userData.assessIsValidCancelPayrollMove(teamMember.Personal.UserID, agencyProfileId)
			.then(cancelPayrollMoveStatus => {

			$scope.teamMember = teamMember;

			// Check validity of cancel operation
			if (cancelPayrollMoveStatus === PAYROLL_MOVE_VALID_STATUSES.IsValid) {
				setPageState(CANCEL_MOVE_PAYROLL_PAGE_STATES.confirmCancel);
			}
			else {
				$scope.invalidCancelReason = cancelPayrollMoveStatus;
				setPageState(CANCEL_MOVE_PAYROLL_PAGE_STATES.cancelInvalid);
			}
		})
		.catch(onError);
	}

	init();

	function cancelMovePayrolls (teamMemberObj, agencyProfileId, form) {

		form.state = 'saving';
		userData.cancelUserPayrollMove(teamMemberObj.Personal.UserID, agencyProfileId).then(() => {
			form.state = 'saved';
			setPageState(CANCEL_MOVE_PAYROLL_PAGE_STATES.success);
		})
		.catch(onError);
	}

	function closeForm() {
		$scope.formOptions.closeForm();
		// Go to the team member in their new home
		$state.go('team.members', {agencyProfileId: agencyProfileId});
	}

	function onError (error) {
		console.error(error);
		setPageState(CANCEL_MOVE_PAYROLL_PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	angular.extend($scope, {
		CANCEL_MOVE_PAYROLL_PAGE_STATES,
		PAYROLL_MOVE_VALID_STATUSES,
		agencyProfileId,
		cancelMovePayrolls,
		closeForm,
		setPageState
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('cancelRejoinLeaverForm', function () {

	return {
		controller: 'cancelRejoinLeaverFormCtrl',
		templateUrl: 'forms/payroll/cancelRejoinLeaver/cancelRejoinLeaverForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cancelRejoinLeaverFormCtrl', [
	'$scope',
	'userData',
	function (
		$scope,
		userData
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	function init () {
		setPageState('ready');
	}

	function cancelUserAgencyProfileRestart ($form) {

		$form.state = 'saving';

		userData.cancelUserAgencyProfileRestart(agencyProfileId, userId).then(function () {

			$scope.formOptions.forceCallback();

			setPageState('success');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		cancelUserAgencyProfileRestart
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('changeEmployeePayrollTypeForm', () => {

	return {
		controller: 'changeEmployeePayrollTypeCtrl',
		templateUrl: 'forms/payroll/change-employee-payroll-type/changeEmployeePayrollTypeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('changeEmployeePayrollTypeCtrl', ['$scope', 'teamData', 'EMPLOYMENT_PAYROLL_TYPES', function ($scope, teamData, EMPLOYMENT_PAYROLL_TYPES) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const employeePayrollType = $scope.formOptions.employeePayrollType;
	const userId = $scope.formOptions.userId;

	const CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	function changeEmployeePayrollType(form) {
		form.state = 'saving';
		teamData.updateTeamMemberEmploymentType(userId, agencyProfileId, employeePayrollType).then(() => {
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = null;
		})
		.catch(onError);
	}

	function init () {
		setPageState(CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES.ready);
	}

	function onError (error) {
		console.error(error);
		setPageState(CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES.error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES,
		EMPLOYMENT_PAYROLL_TYPES,

		changeEmployeePayrollType,
		employeePayrollType
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('childcareVouchersForm', function () {

	return {
		controller: 'childcareVouchersFormCtrl',
		templateUrl: 'forms/payroll/childcareVouchers/childcareVouchersForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('childcareVouchersFormCtrl', [
	'$filter',
	'$q',
	'$rootScope',
	'$scope',
	'base',
	'disbursementService',
	'payrollData',
	'pensionService',
	'utilities',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'BACS_PAYMENT_TYPES',
	'PAYMENT_SCHEDULE_CATEGORIES',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	'PAY_PERIOD_TYPES',
	'SUBMISSION_STATES',
	function (
		$filter,
		$q,
		$rootScope,
		$scope,
		base,
		disbursementService,
		payrollData,
		pensionService,
		utilities,
		ADJUSTMENT_BEHAVIOUR_STATES,
		BACS_PAYMENT_TYPES,
		PAYMENT_SCHEDULE_CATEGORIES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		PAY_PERIOD_TYPES,
		SUBMISSION_STATES) {

	const agencyProfileId	= $scope.formOptions.agencyProfileId;
	const paymentScheduleGroupId = $scope.formOptions.paymentScheduleGroupId;
	const userId = $scope.formOptions.userId;

	function decoratePaymentScheduleGroup (paymentScheduleGroupObj, paymentScheduleTypesArr) {

		angular.extend(paymentScheduleGroupObj, {
			AgencyProfileID: agencyProfileId,
			FixedRepaymentAmount: utilities.setPropertyValueToEmptyIfZero(paymentScheduleGroupObj.FixedRepaymentAmount),
			PaymentScheduleTypeID: paymentScheduleTypesArr[0].PaymentScheduleTypeID,
			ScheduleEntries: paymentScheduleGroupObj.ScheduleEntries.filter(_ => _.IsPaid),
			UserID: userId
		});

		// Reorder pensions to bring AE pension to the beginning
		pensionService.getOrderedPensionsArray(paymentScheduleGroupObj.PaymentScheduleGroupPension);

		return paymentScheduleGroupObj;
	}

	function init () {

		setPageState('loading');

		const getBankDetailsCompany = base.getBankDetailsCompany(agencyProfileId);
		const getPaymentScheduleGroup = payrollData.getPaymentScheduleGroup(agencyProfileId, paymentScheduleGroupId, userId);
		const getPaymentScheduleTypes = payrollData.getPaymentScheduleTypes(agencyProfileId, PAYMENT_SCHEDULE_CATEGORIES.childcare);
		const getPayPeriods = payrollData.getPayPeriods(agencyProfileId, SUBMISSION_STATES.unsubmitted);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId);

		$q.all([getPaymentScheduleGroup, getPaymentScheduleTypes, getPayPeriods, getBankDetailsCompany, getPayPeriodMinimum])
			.then(([paymentScheduleGroupObj, paymentScheduleTypesArr, payPeriodsArray, companyBankDetailsObj, payPeriodObj]) =>{

			// BACS
			let isBacsChildcareVouchersEnabled = companyBankDetailsObj.BACSEnabled && $filter('bitwiseCompare')(companyBankDetailsObj.BACSIncludedPayments, BACS_PAYMENT_TYPES.childcare);
			if (isBacsChildcareVouchersEnabled) {
				paymentScheduleGroupObj.bacsPaymentInfoText = disbursementService.getBACSPaymentInfoText(paymentScheduleGroupObj.DisbursementDetail);
			}

			// Has bank details?
			const bankInfo = paymentScheduleGroupObj.DisbursementDetail.BankInfo;
			const hasBankDetails = bankInfo.BankAccountName || bankInfo.SortCode || bankInfo.BankAccountNumber || bankInfo.BACSPaymentReference;

			$scope.vm = {
				companyBankDetails: companyBankDetailsObj,
				hasBankDetails,
				formView: 'details',
				payPeriod: payPeriodObj,
				payPeriods: payPeriodsArray,
				paymentScheduleGroup: decoratePaymentScheduleGroup(paymentScheduleGroupObj, paymentScheduleTypesArr),
				payslipLabelFocused: false,
				payslipLabelSave: false,
				selectedPayPeriod: angular.copy(payPeriodsArray[0]),
				isBacsChildcareVouchersEnabled,
				isChildcareVoucherPensionDisabled: getIsChildcareVoucherPensionDisabled(paymentScheduleGroupObj, $rootScope.currentCompany)
			};

			updateSelectedPayPeriod($scope.vm);

			setPageState(angular.isDefined(paymentScheduleGroupId) ? 'view' : 'setup');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function getIsChildcareVoucherPensionDisabled (paymentScheduleGroupObj, currentCompanyObj)  {

		// Companies that do not have a pension set up
		if (currentCompanyObj.isPayrollCompany && !currentCompanyObj.HasPension) {
			return true;
		}

		// Locked
		switch (paymentScheduleGroupObj.PaymentScheduleGroupPensionBehaviour) {

			case ADJUSTMENT_BEHAVIOUR_STATES.offLocked:
			case ADJUSTMENT_BEHAVIOUR_STATES.onLocked:
				return true;
		}

		return false;
	}

	function reviewChildcareVoucherPension (paymentScheduleGroupObj) {

		paymentScheduleGroupObj.PaymentScheduleGroupPensionBehaviour = paymentScheduleGroupObj.PaymentScheduleGroupPensionState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;

		// Update all schemes
		for (let schemeObj of paymentScheduleGroupObj.PaymentScheduleGroupPension) {
			angular.extend(schemeObj, {
				PaymentScheduleGroupPensionBehaviour: paymentScheduleGroupObj.PaymentScheduleGroupPensionBehaviour,
				PaymentScheduleGroupPensionState: paymentScheduleGroupObj.PaymentScheduleGroupPensionState
			});
		}
	}

	function saveChildcareVoucher (vmObj, form) {

		form.state = 'saving';

		if (vmObj.paymentScheduleGroup.DisbursementDetail.ManualPayment) {
			vmObj.paymentScheduleGroup.DisbursementDetail = disbursementService.resetDisbursementBankInfo(vmObj.paymentScheduleGroup.DisbursementDetail);
		}

		payrollData.updatePaymentScheduleGroup(vmObj.paymentScheduleGroup).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function stopChildcareVoucherPayments (vmObj, form) {

		form.state = 'saving';

		payrollData.deletePaymentScheduleGroup(agencyProfileId, vmObj.paymentScheduleGroup.PaymentScheduleGroupID).then(function () {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			form.state = 'saved';
		})
		.catch(function (error) {
			console.error(error);
			$scope.pageState = 'error';
			form.state = null;
		});
	}

	function togglePayslipLabelFocused (vmObj, newValue) {

		if (newValue !== undefined) {
			vmObj.payslipLabelFocused = newValue;
		}
		else {
			vmObj.payslipLabelFocused = !vmObj.payslipLabelFocused;
		}
	}

	function updateSelectedPayPeriod (vmObj) {

		if (!vmObj.selectedPayPeriod) {
			return;
		}

		vmObj.paymentScheduleGroup.FirstPayPeriodID = vmObj.selectedPayPeriod.PayPeriodID;
		vmObj.paymentScheduleGroup.FirstPayPeriodDescription = vmObj.selectedPayPeriod.PayPeriodDescription;
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		PAY_PERIOD_TYPES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,

		reviewChildcareVoucherPension,
		saveChildcareVoucher,
		setPageState,
		stopChildcareVoucherPayments,
		togglePayslipLabelFocused,
		updateSelectedPayPeriod,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('cisSufferedForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'cisSufferedFormCtrl',
	templateUrl: 'forms/payroll/cis-suffered/cis-suffered.form.html',
})

.controller('cisSufferedFormCtrl', [
	'$q',
	'$rootScope',
	'payPeriodService',
	'payrollData',
	'utilities',
	'STATE_TYPES',
	'SUBMISSION_LOG_TYPE',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		payPeriodService,
		payrollData,
		utilities,
		STATE_TYPES,
		SUBMISSION_LOG_TYPE,
		SUBMISSION_STATES
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		// Load pay calculations for pay period
		const getPayPeriodCISDeductions = payrollData.getPayPeriodCISDeductions($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId);
		const getPayPeriod = payrollData.getPayPeriod($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId);

		$q.all([
			getPayPeriodCISDeductions,
			getPayPeriod
		])
		.then(([
			cisDeductionsObj,
			payPeriodObj
		]) => {

			if (!cisDeductionsObj.CanUpdateCISDeductions) {
				setPageState('deadline-passed');
				return;
			}

			angular.extend($ctrl, {
				cisDeductions: cisDeductionsObj,
				payPeriod: decoratePayPeriod(payPeriodObj)
			});

			// EA auto-reclaim alert
			if (utilities.getIsPreviousTaxYearSubmission(payPeriodObj.TaxYear, $rootScope.currentPeriod.TaxYear)) {
				setPageState('alert');
				return;
			}

			setPageState('ready');
		})
		.catch(onError);
	}

	function decoratePayPeriod (payPeriodObj) {

		return angular.extend(payPeriodObj, {
			EPSState: payPeriodObj.EPSState === SUBMISSION_STATES.submitted ? SUBMISSION_STATES.unsubmitted : payPeriodObj.EPSState, // As we are re-submitting EPS, the state is likely to be 'submitted', so set it to unsubmitted
		});
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function onSubmissionFailedBack () {
		$ctrl.payPeriod.EPSState = SUBMISSION_STATES.unsubmitted;
	}

	function updateCISDeductions ($form) {

		$ctrl.cisDeductions.HasCISSubcontractorDeductions = $ctrl.cisDeductions.CISSubcontractorDeductions !== 0;

		$form.state = 'saving';

		setPageState('submitted');
		$ctrl.payPeriod.EPSState = SUBMISSION_STATES.submitting;

		// Update CIS Deductions
		payrollData.updateAgencyPayPeriodCISDeductions($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId, $ctrl.cisDeductions)
			.then(() => {

			// Submit EPS
			payrollData.payrollSubmitEPS($ctrl.formOptions.agencyProfileId, $ctrl.payPeriod.PayPeriodID)
				.then(() => {

					$ctrl.formOptions.forceCallback();

					// Kick off EPS polling
					payPeriodService.pollForSubmissionState($ctrl.payPeriod, STATE_TYPES.eps, 'EPSState', $ctrl.formOptions.agencyProfileId);

					$form.state = 'saved';
				})
				.catch(onError);
		})
		.catch(onError);
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		setPageState,
		updateCISDeductions,
		onSubmissionFailedBack,

		SUBMISSION_STATES,

		submissionLogEntries: null,
		submissionLogType: SUBMISSION_LOG_TYPE.cisSuffered
	});
}]);

'use strict';

angular.module('paycircleApp')

	.component('correctionalSubmissionForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'correctionalSubmissionFormCtrl',
		templateUrl: 'forms/payroll/correctional-submission/correctional-submission.form.html'
	})

	.controller('correctionalSubmissionFormCtrl', [
		'$filter',
		'$q',
		'$timeout',
		'base',
		'config',
		'payrollData',
		'payrollWorker',
		'utilities',
		'CORRECTIONAL_SUBMISSION_TYPES',
		'REGEX',
		'SUBMISSION_STATES',
		function (
			$filter,
			$q,
			$timeout,
			base,
			config,
			payrollData,
			payrollWorker,
			utilities,
			CORRECTIONAL_SUBMISSION_TYPES,
			REGEX,
			SUBMISSION_STATES
		) {

		const $ctrl = this;

		const FORM_STATES = {
			allIgnored: 'all-ignored',
			allSkipped: 'all-skipped',
			allSkippedAndIgnored: 'all-skipped-and-ignored',
			cantUpdateTeamMember: 'cant-update-teammember',
			error: 'error',
			loading: 'loading',
			notEnoughHistoryEYU: 'not-enough-history-eyu',
			notEnoughHistoryYTDFPS: 'not-enough-history-ytd-fps',
			previousTaxYear: 'previous-tax-year',
			selectTaxYear: 'select-tax-year',
			showPayments: 'show-payments',
			submissionFailed: 'submission-failed',
			submittedEYU: 'submitted-eyu',
			submittedYTDFPS: 'submitted-eyu-fps',
			submitting: 'submitting',
			summary: 'summary'
		};

		const SUMMARY_VIEWS = {
			ignored: 'ignored',
			skipped: 'skipped',
			updated: 'updated'
		};

		function $onInit () {

			setFormState(FORM_STATES.loading);

			angular.extend($ctrl, {
				isBulkUpdate: ($ctrl.formOptions.userIds.length > 1),
				isDifferenceColumnVisible: ($ctrl.formOptions.correctionalSubmissionType === CORRECTIONAL_SUBMISSION_TYPES.EYU),
				submissionService: getServiceForCorrectionType()
			});

			const getTaxYearsForEndOfYearUpdate = payrollData.getTaxYearsForEndOfYearUpdate($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.correctionalSubmissionType);
			const getEmptyEndOfYearUpdateNIDetail = payrollData.getEmptyEndOfYearUpdateNIDetail();
			const getNationalInsuranceLetters = base.getNationalInsuranceLetters();

			$q.all([
					getTaxYearsForEndOfYearUpdate,
					getEmptyEndOfYearUpdateNIDetail,
					getNationalInsuranceLetters
				])
				.then(([
					taxYearsArr,
					emptyNICategoryObj,
					niCategoryLettersArr
				]) => {

					angular.extend($ctrl, {
						emptyNICategory: decorateEmptyNICategory(emptyNICategoryObj),
						niCategoryLetters: niCategoryLettersArr,
						taxYears: taxYearsArr
					});

					setFormState(getInitialFormState(taxYearsArr));
				})
				.catch(onError);
		}

		function decorateEmptyNICategory (emptyNICategoryObj) {

			// Clear NI code so form displays the placeholder, set new category to show different title
			return angular.extend(emptyNICategoryObj, {
				isNewCategory: true,
				NICode: null,
			});
		}

		function decorateTeamMembers (teamMembersArr) {

			for (let teamMemberObj of teamMembersArr) {

				angular.extend(teamMemberObj, {
					isDetailsVisible: $ctrl.isBulkUpdate ? false : true,
					isSkipped: false
				});

				if (teamMemberObj.IsIgnored) {
					teamMemberObj.ignoredMessage = getIgnoredTeamMemberMessage(teamMemberObj);
				}
				else {
					// Setup payment groups for team member
					getPaymentGroupsForTeamMember(teamMemberObj);
				}
			}

			return teamMembersArr;
		}

		function decorateUpdatedForTeamMember (teamMemberObj) {

			const updatedPaymentGroups = [];

			// Main payments
			if (teamMemberObj.updatedPayments.length > 0) {
				updatedPaymentGroups.push({
					payments: teamMemberObj.updatedPayments
				});
			}

			// NI Payments
			for (let niCategoryObj of teamMemberObj.NICurrentEmployment) {
				if (niCategoryObj.updatedPayments.length > 0) {
					updatedPaymentGroups.push({
						title: `NI category: ${niCategoryObj.NICode}`,
						payments: niCategoryObj.updatedPayments
					});
				}
			}

			// Additional payments
			if (teamMemberObj.updatedAdditionalPayments.length > 0) {
				updatedPaymentGroups.push({
					payments: teamMemberObj.updatedAdditionalPayments
				});
			}

			return updatedPaymentGroups;
		}

		function getIgnoredTeamMemberMessage (teamMemberObj) {

			const ignoredMessagesObj = {
				isIncomplete: {
					[CORRECTIONAL_SUBMISSION_TYPES.EYU]: `As ${ teamMemberObj.Forename }'s profile is incomplete, you can't make an earlier year update. Please go to their profile and finish adding their details before trying again.`,
					[CORRECTIONAL_SUBMISSION_TYPES.YTDFPS]: `As ${ teamMemberObj.Forename }'s profile is incomplete, you can't submit a Earlier Year FPS. Please go to their profile and finish adding their details before trying again.`,
					summary: 'Profile incomplete'
				},
				isCISSubcontractor: {
					[CORRECTIONAL_SUBMISSION_TYPES.EYU]: `You can't make an earlier year update for ${ teamMemberObj.Forename } as they are a subcontractor under the Construction Industry Scheme (CIS).`,
					[CORRECTIONAL_SUBMISSION_TYPES.YTDFPS]: `You can't submit a Earlier Year FPS for ${ teamMemberObj.Forename }  as they are a subcontractor under the Construction Industry Scheme (CIS).`,
					summary: 'CIS subcontractor'
				},
				isLeaver: {
					[CORRECTIONAL_SUBMISSION_TYPES.EYU]: `${ teamMemberObj.Forename }'s leave date was ${ $filter('dateformat')(teamMemberObj.LeaveDateISO) } which is sooner than the selected tax year. Click the edit icon above to choose a tax year before they left ${ $ctrl.formOptions.company.Name }.`,
					[CORRECTIONAL_SUBMISSION_TYPES.YTDFPS]: `${ teamMemberObj.Forename }'s leave date was ${ $filter('dateformat')(teamMemberObj.LeaveDateISO) } which is sooner than the selected tax year. Click the edit icon above to choose a tax year before they left ${ $ctrl.formOptions.company.Name }.`,
					summary: `Leave date sooner than tax year ${ $ctrl.taxYear.TaxYearDisplay }`
				},
				isStarter: {
					[CORRECTIONAL_SUBMISSION_TYPES.EYU]: `${ teamMemberObj.Forename }'s start date was ${ $filter('dateformat')(teamMemberObj.StartDateISO) } which is later than the selected tax year. Click the edit icon above to choose a tax year after they joined ${ $ctrl.formOptions.company.Name }.`,
					[CORRECTIONAL_SUBMISSION_TYPES.YTDFPS]: `${ teamMemberObj.Forename }'s start date was ${ $filter('dateformat')(teamMemberObj.StartDateISO) } which is later than the selected tax year. Click the edit icon above to choose a tax year after they joined ${ $ctrl.formOptions.company.Name }.`,
					summary: `Start date later than tax year ${ $ctrl.taxYear.TaxYearDisplay }`
				}
			};

			if (teamMemberObj.IsIncomplete) {
				return {
					detailed: ignoredMessagesObj.isIncomplete[$ctrl.formOptions.correctionalSubmissionType],
					summary: ignoredMessagesObj.isIncomplete.summary
				};

			} else {

				if (teamMemberObj.IsCISSubcontractor) {
					return {
						detailed: ignoredMessagesObj.isCISSubcontractor[$ctrl.formOptions.correctionalSubmissionType],
						summary: ignoredMessagesObj.isCISSubcontractor.summary
					};

				} else {

					if (teamMemberObj.IsLeaver) {
						return {
							detailed: ignoredMessagesObj.isLeaver[$ctrl.formOptions.correctionalSubmissionType],
							summary: ignoredMessagesObj.isLeaver.summary
						};
					}

					if (teamMemberObj.IsStarter) {
						return {
							detailed: ignoredMessagesObj.isStarter[$ctrl.formOptions.correctionalSubmissionType],
							summary: ignoredMessagesObj.isStarter.summary
						};
					}
				}
			}
		}

		function getInitialFormState (taxYearsArr) {

			if (taxYearsArr.length >= 1) {
				return FORM_STATES.previousTaxYear;

			} else {
				switch ($ctrl.formOptions.correctionalSubmissionType) {
					case CORRECTIONAL_SUBMISSION_TYPES.EYU:
						return FORM_STATES.notEnoughHistoryEYU;

					case CORRECTIONAL_SUBMISSION_TYPES.YTDFPS:
						return FORM_STATES.notEnoughHistoryYTDFPS;
				}
			}
		}

		function getPaymentGroupsForTeamMember (teamMemberObj) {

			function getPaymentGroupAdditonalForTeamMember (teamMemberObj) {

				const additionalPaymentsArr = [
					getPaymentObject(teamMemberObj, 'Student loan', 'YTDStudentLoanCurrentEmployment', 'NewStudentLoanCurrentEmployment', REGEX.number5Digits, config.number5Digits),
				];

				if (teamMemberObj.CanUpdatePostgradLoan || teamMemberObj.YTDPostgradLoanCurrentEmployment !== 0 || teamMemberObj.NewPostgradLoanCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Postgraduate loan', 'YTDPostgradLoanCurrentEmployment', 'NewPostgradLoanCurrentEmployment', REGEX.number5Digits, config.number5Digits)
					);
				}

				if (teamMemberObj.CanUpdateSMP || teamMemberObj.YTDSMPCurrentEmployment !== 0 || teamMemberObj.NewSMPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Statutory maternity pay', 'YTDSMPCurrentEmployment', 'NewSMPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				if (teamMemberObj.CanUpdateSPP || teamMemberObj.YTDSPPCurrentEmployment !== 0 || teamMemberObj.NewSPPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Statutory paternity pay', 'YTDSPPCurrentEmployment', 'NewSPPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				if (teamMemberObj.CanUpdateSAP || teamMemberObj.YTDSAPCurrentEmployment !== 0 || teamMemberObj.NewSAPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Statutory adoption pay', 'YTDSAPCurrentEmployment', 'NewSAPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				if (teamMemberObj.CanUpdateShPP || teamMemberObj.YTDShPPCurrentEmployment !== 0 || teamMemberObj.NewShPPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Shared parental leave and pay', 'YTDShPPCurrentEmployment', 'NewShPPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				if (teamMemberObj.CanUpdateSPBP || teamMemberObj.YTDSPBPCurrentEmployment !== 0 || teamMemberObj.NewSPBPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Statutory Parental Bereavement Pay', 'YTDSPBPCurrentEmployment', 'NewSPBPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				if (teamMemberObj.CanUpdateSNCP || teamMemberObj.YTDSNCPCurrentEmployment !== 0 || teamMemberObj.NewSNCPCurrentEmployment !== 0) {
					additionalPaymentsArr.push(
						getPaymentObject(teamMemberObj, 'Statutory Neonatal Care Pay', 'YTDSNCPCurrentEmployment', 'NewSNCPCurrentEmployment', REGEX.number6Digits2Decimal, config.number6Digits2Decimal)
					);
				}

				additionalPaymentsArr.push(
					getPaymentObject(teamMemberObj, 'Payrolled benefit in kind', 'YTDBIKCurrentEmployment', 'NewBIKCurrentEmployment', REGEX.number9Digits2Decimal, config.number9Digits2Decimal)
				);

				return additionalPaymentsArr;
			}

			function getPaymentGroupMainForTeamMember (teamMemberObj) {
				return [
					getPaymentObject(teamMemberObj, 'Taxable pay', 'YTDGrossCurrentEmploymentForTax', 'NewGrossCurrentEmploymentForTax', REGEX.number9Digits2Decimal, config.number9Digits2Decimal),
					getPaymentObject(teamMemberObj, 'UK tax', 'YTDTaxCurrentEmployment', 'NewTaxCurrentEmployment', REGEX.number9Digits2Decimal, config.number9Digits2Decimal)
				];
			}

			angular.extend(teamMemberObj, {
				payments: getPaymentGroupMainForTeamMember(teamMemberObj),
				additionalPayments: getPaymentGroupAdditonalForTeamMember(teamMemberObj)
			});

			// NI categories
			for (let niCategoryObj of teamMemberObj.NICurrentEmployment) {
				niCategoryObj.payments = getPaymentGroupForNICategory(niCategoryObj);
			}
		}

		function getPaymentGroupForNICategory (niCategoryObj) {

			return [
				getPaymentObject(niCategoryObj, 'NIable pay', 'YTDGrossCurrentEmploymentForNI', 'NewGrossCurrentEmploymentForNI', REGEX.number9Digits2Decimal, config.number9Digits2Decimal),
				getPaymentObject(niCategoryObj, 'Employee\'s NI', 'YTDEENICurrentEmployment', 'NewEENICurrentEmployment', REGEX.number9Digits2Decimal, config.number9Digits2Decimal),
				getPaymentObject(niCategoryObj, 'Employer\'s NI', 'YTDERNICurrentEmployment', 'NewERNICurrentEmployment', REGEX.number9Digits2Decimal, config.number9Digits2Decimal),
				getPaymentObject(niCategoryObj, 'Earnings at the LEL', 'YTDAtLELCurrentEmployment', 'NewAtLELCurrentEmployment', REGEX.number4Digits, config.number4Digits),
				getPaymentObject(niCategoryObj, 'Earnings above LEL and up to PT', 'YTDLELtoPTCurrentEmployment', 'NewLELtoPTCurrentEmployment', REGEX.number4Digits2Decimal, config.number4Digits2Decimal),
				getPaymentObject(niCategoryObj, 'Earnings above PT, up to and including the UEL', 'YTDPTtoUELCurrentEmployment', 'NewPTtoUELCurrentEmployment', REGEX.number5Digits2Decimal, config.number5Digits2Decimal),
				getPaymentObject(niCategoryObj, 'Earnings above the UEL', 'YTDAboveUELCurrentEmployment', 'NewAboveUELCurrentEmployment', REGEX.number9Digits2Decimal, config.number9Digits2Decimal)
			];
		}

		function getPaymentObject (dataObj, label, oldAmountField, newAmountField, patternRegex , patternConfig) {
			return {
				paymentAmount: dataObj[oldAmountField],
				paymentLabel: label,
				paymentNewAmount: dataObj[newAmountField] ? dataObj[newAmountField] : null,
				paymentOnSave: newAmount => dataObj[newAmountField] = newAmount,
				paymentOriginalNewAmount: dataObj[newAmountField],
				paymentPatternConfig: patternConfig,
				paymentPatternRegex: patternRegex
			};
		}

		function getPaymentsFormState () {

			if ($ctrl.submissionDetail.EndOfYearUpdateDetails.every(teamMemberObj => teamMemberObj.IsIgnored)) {

				if ($ctrl.isBulkUpdate) {
					return FORM_STATES.allIgnored;
				}

				return FORM_STATES.cantUpdateTeamMember;
			}

			return FORM_STATES.showPayments;
		}

		function getServiceForCorrectionType () {

			switch ($ctrl.formOptions.correctionalSubmissionType) {
				case CORRECTIONAL_SUBMISSION_TYPES.EYU:
					return payrollWorker.payrollSubmitEYU;

				case CORRECTIONAL_SUBMISSION_TYPES.YTDFPS:
					return payrollWorker.payrollSubmitYearToDateFPS;
			}
		}

		function getTeamMemberPaymentsForTaxYear () {

			setFormState(FORM_STATES.loading);

			payrollData.getEndOfYearUpdateForTaxYear($ctrl.formOptions.agencyProfileId, $ctrl.taxYear.PayPeriodID, $ctrl.formOptions.correctionalSubmissionType, $ctrl.formOptions.userIds)
				.then(submissionDetailObj => {

					angular.extend($ctrl, {
						submissionDetail: submissionDetailObj,
						team: decorateTeamMembers(submissionDetailObj.EndOfYearUpdateDetails),
						teamMemberIndex: 0
					});

					setTeamMember();

					setFormState(getPaymentsFormState());
				})
				.catch(onError);
		}

		function getUpdatedPaymentsForTeamMember (teamMemberObj) {

			function getValidPaymentsFromGroup (paymentGroupObj) {
				return paymentGroupObj.filter(paymentObj => paymentObj.isValid);
			}

			let updatedPaymentsCount = 0;

			// Ignore team member if they are skipped or ignored
			if (teamMemberObj.IsIgnored || teamMemberObj.isSkipped) {
				teamMemberObj.countOfUpdatedPayments = 0;
			}
			else {

				// Get updated payments from main group
				teamMemberObj.updatedPayments = getValidPaymentsFromGroup(teamMemberObj.payments);
				updatedPaymentsCount += teamMemberObj.updatedPayments.length;

				// Get updated payments from additional group
				teamMemberObj.updatedAdditionalPayments = getValidPaymentsFromGroup(teamMemberObj.additionalPayments);
				updatedPaymentsCount += teamMemberObj.updatedAdditionalPayments.length;

				// Get updated payments from NI categories
				for (let niCategoryObj of teamMemberObj.NICurrentEmployment) {
					niCategoryObj.updatedPayments = getValidPaymentsFromGroup(niCategoryObj.payments);
					updatedPaymentsCount += niCategoryObj.updatedPayments.length;
				}

				// Get number of payments that have changed
				teamMemberObj.countOfUpdatedPayments = updatedPaymentsCount;
			}
		}

		function getUpdatedTeamPreSave () {

			function setPaymentValuesInGroup (paymentGroupObj) {

				for (let paymentObj of paymentGroupObj) {
					paymentObj.paymentOnSave(paymentObj.paymentNewAmountInteger);
				}
			}

			// Updated new/override properties in team member object
			for (let teamMemberObj of $ctrl.teamSummary.updated) {

				// Set main payments
				setPaymentValuesInGroup(teamMemberObj.updatedPayments);

				// Set additional payments
				setPaymentValuesInGroup(teamMemberObj.updatedAdditionalPayments);

				// Remove new NI categories with no updated payments
				teamMemberObj.NICurrentEmployment = teamMemberObj.NICurrentEmployment.filter(niCategoryObj => !(niCategoryObj.isNewCategory && niCategoryObj.updatedPayments.length === 0));

				// Set NI payments
				for (let niCategoryObj of teamMemberObj.NICurrentEmployment) {
					setPaymentValuesInGroup(niCategoryObj.updatedPayments);
				}
			}

			return $ctrl.teamSummary.updated;
		}

		function getTeamSummary () {

			const teamSummaryObj = {
				updated: [],
				skipped: [],
				ignored: []
			};

			// Sort team members into groups
			for (let teamMemberObj of $ctrl.team) {

				if (teamMemberObj.IsIgnored) {
					teamSummaryObj.ignored.push(teamMemberObj);
				}
				else if (teamMemberObj.isSkipped || teamMemberObj.countOfUpdatedPayments === 0) {
					teamSummaryObj.skipped.push(teamMemberObj);
				}
				else {

					// Split payments out into groups
					teamMemberObj.updatedPaymentGroups = decorateUpdatedForTeamMember(teamMemberObj);

					teamSummaryObj.updated.push(teamMemberObj);
				}
			}

			return teamSummaryObj;
		}

		function goToSummary () {

			const teamSummaryObj = getTeamSummary();

			// Show details for single active team member
			if (teamSummaryObj.updated.length === 1) {
				teamSummaryObj.updated[0].isDetailsVisible = true;
			}

			$ctrl.teamSummary = teamSummaryObj;

			if (teamSummaryObj.skipped.length === $ctrl.team.length) {
				setFormState(FORM_STATES.allSkipped);
			}
			else if (teamSummaryObj.ignored.length + teamSummaryObj.skipped.length === $ctrl.team.length) {
				setFormState(FORM_STATES.allSkippedAndIgnored);
			}
			else {
				setFormState(FORM_STATES.summary);
			}
		}

		function onChangeTeamMember (isNextTeamMemberClick) {

			if (isNextTeamMemberClick) {
				$ctrl.teamMemberIndex++;
			}
			else {
				$ctrl.teamMemberIndex--;
			}

			setTeamMember();
		}

		function onAddNICategory () {

			const newNICategoryObj = angular.copy($ctrl.emptyNICategory);

			// Attach payments to new NI category
			newNICategoryObj.payments = getPaymentGroupForNICategory(newNICategoryObj);

			// Display new NI category
			$ctrl.teamMember.NICurrentEmployment.push(newNICategoryObj);
		}

		function onConfirmSubmission ($form) {

			$form.state = 'saving';

			const submissionDetailToSubmitObj = angular.copy($ctrl.submissionDetail);

			submissionDetailToSubmitObj.EndOfYearUpdateDetails = getUpdatedTeamPreSave();

			$ctrl.submissionService($ctrl.formOptions.agencyProfileId, $ctrl.taxYear.PayPeriodID, submissionDetailToSubmitObj)
				.then(onSubmission)
				.catch(onError);
		}

		function onDeleteNICategory (niCategoryIndex) {

			$ctrl.teamMember.NICurrentEmployment.splice(niCategoryIndex, 1);

			isTeamMemberValid();
		}

		function onError (error) {
			console.error(error);
			setFormState(FORM_STATES.error);
		}

		function onPaymentChange () {
			isTeamMemberValid();
		}

		function onSkipTeamMember () {

			$ctrl.teamMember.isSkipped = !$ctrl.teamMember.isSkipped;

			isTeamMemberValid();
		}

		function onSubmission () {

			$ctrl.formOptions.canCloseForm = false;

			setFormState(FORM_STATES.submitting);

			pollEYUState();
		}

		function onTaxYearEdit () {

			// Reset form
			angular.extend($ctrl, {
				submissionDetail: null,
				team: null,
				teamMember: null,
			});

			setFormState(FORM_STATES.selectTaxYear);
		}

		function onTeamMemberDetailsToggle (teamMemberObj) {
			teamMemberObj.isDetailsVisible = !teamMemberObj.isDetailsVisible;
		}

		function isTeamMemberValid () {

			getUpdatedPaymentsForTeamMember($ctrl.teamMember);

			$ctrl.teamMember.isValid = ($ctrl.teamMember.countOfUpdatedPayments >= 1 || $ctrl.teamMember.isSkipped || $ctrl.teamMember.IsIgnored);

			// Check if form is valid yet
			validateForm();
		}

		function pollEYUState () {

			payrollData.getEndOfYearUpdateState($ctrl.formOptions.agencyProfileId, $ctrl.submissionDetail.EndOfYearUpdateID)
				.then(eyuState =>  {

					switch (eyuState) {
						case SUBMISSION_STATES.submitting:

							$timeout(() => {
								pollEYUState();
							}, config.timeToPoll * 1000);

							break;

						case SUBMISSION_STATES.submitted:

							switch ($ctrl.formOptions.correctionalSubmissionType) {
								case CORRECTIONAL_SUBMISSION_TYPES.EYU:
									setFormState(FORM_STATES.submittedEYU);
									break;

								case CORRECTIONAL_SUBMISSION_TYPES.YTDFPS:
									setFormState(FORM_STATES.submittedYTDFPS);
									break;
							}

							$ctrl.formOptions.canCloseForm = true;

							break;

						default:

							setFormState(FORM_STATES.submissionFailed);

							$ctrl.formOptions.canCloseForm = true;
							break;
					}
				})
				.catch(onError);
		}

		function setFormState (newState) {
			$ctrl.formState = newState;
		}

		function setSummaryView (newView) {
			$ctrl.summaryView = newView;
		}

		function setTeamMember () {

			$ctrl.teamMember = $ctrl.team[$ctrl.teamMemberIndex];

			isTeamMemberValid();
		}

		function validateForm () {
			$ctrl.formValid = $ctrl.team.every(teamMemberObj => teamMemberObj.isValid);
		}

		angular.extend($ctrl, {
			$onInit,

			CORRECTIONAL_SUBMISSION_TYPES,
			FORM_STATES,
			SUMMARY_VIEWS,

			getTeamMemberPaymentsForTaxYear,
			goToSummary,
			onChangeTeamMember,
			onConfirmSubmission,
			onAddNICategory,
			onDeleteNICategory,
			onPaymentChange,
			onSkipTeamMember,
			onTaxYearEdit,
			onTeamMemberDetailsToggle,
			setFormState,
			setSummaryView,

			formValid: false,
			summaryView: SUMMARY_VIEWS.updated,
			taxYear: null
		});

	}]);


'use strict';

angular.module('paycircleApp')

.directive('deleteChangeForm', function () {

	return {
		controller: 'deleteChangeFormCtrl',
		templateUrl: 'forms/payroll/deleteChange/deleteChangeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteChangeFormCtrl', ['$scope', 'payrollData', 'session', function ($scope, payrollData, session) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var loggedInUserId = session.getUserId();

	function deleteAdjustment (adjustmentObj) {

		payrollData.deleteUserPayElement(agencyProfileId, adjustmentObj.PayPeriodID, adjustmentObj.UserPayElementID, loggedInUserId).then(function () {

			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	setPageState('ready');

	$scope.deleteAdjustment = function (adjustmentObj) {

		deleteAdjustment(adjustmentObj);
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('deleteHistoricPayPeriodForm', function () {

	return {
		controller: 'deleteHistoricPayPeriodFormCtrl',
		templateUrl: 'forms/payroll/deleteHistoricTaxPeriod/deleteHistoricPayPeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deleteHistoricPayPeriodFormCtrl', ['$scope', 'payrollData', function ($scope, payrollData) {

	var payPeriod = $scope.formOptions.payPeriod;

	function deleteHistoricPayPeriod (form, payPeriodObj) {

		form.state = 'saving';

		payrollData.deleteAgencyPaymentHistorical(payPeriodObj.AgencyPaymentID).then(function () {

			$scope.formOptions.forceCallback();

			form.state = 'saved';
			setPageState('success');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			form.state = null;
		});
	}

	function init () {

		setPageState('ready');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Variables
		payPeriod,

		// Functions
		deleteHistoricPayPeriod
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePayrollAlertForm', function () {

	return {
		controller: 'deletePayrollAlertFormCtrl',
		templateUrl: 'forms/payroll/deletePayrollAlert/deletePayrollAlertForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePayrollAlertFormCtrl', ['$scope', 'base', 'growl', function ($scope, base, growl) {

	const ARCHIVE_ALERT = true;
	
	const alertObj = $scope.formOptions.alert;

	function deletePayrollAlert () {

		base.updateAlertArchived(alertObj.AlertID, alertObj.AgencyLogID, ARCHIVE_ALERT).then(() => {

			growl.success('Payroll alert dismissed for this period');

			// Reload all alerts
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	setPageState('ready');

	angular.extend($scope, {
		deletePayrollAlert
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePeriodNoteForm', function () {

	return {
		controller: 'deletePeriodNoteFormCtrl',
		templateUrl: 'forms/payroll/deletePeriodNote/deletePeriodNoteForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePeriodNoteFormCtrl', ['$scope', 'growl', 'messageData', 'MESSAGE_STATUS', function ($scope, growl, messageData, MESSAGE_STATUS) {

	const noteObj = $scope.formOptions.note;

	function init () {

		setPageState('ready');
	}

	function deletePeriodNote () {

		messageData.updateMessageStatus(noteObj.MessageID, MESSAGE_STATUS.deleted).then(() => {

			growl.success('Note deleted 👍');
			$scope.formOptions.forceCallback(noteObj);
			$scope.formOptions.closeForm();
		})
		.catch(error => {
			setPageState('error');
		    console.error(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.deletePeriodNote = () =>{

		deletePeriodNote();
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('deletePeriodTaskForm', function () {

	return {
		controller: 'deletePeriodTaskFormCtrl',
		templateUrl: 'forms/payroll/deletePeriodTask/deletePeriodTaskForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('deletePeriodTaskFormCtrl', ['$scope', 'growl', 'messageData', 'MESSAGE_STATUS', function ($scope, growl, messageData, MESSAGE_STATUS) {

	const taskObj = $scope.formOptions.task;

	function init () {

		setPageState('ready');
	}

	function deletePeriodTask () {

		messageData.updateMessageStatus(taskObj.MessageID, MESSAGE_STATUS.deleted).then(() => {

			growl.success('Task deleted 👍');
			$scope.formOptions.forceCallback(taskObj);
			$scope.formOptions.closeForm();
		})
		.catch(error => {
			setPageState('error');
		    console.error(error);
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.deletePeriodTask = () =>{

		deletePeriodTask();
	};

}]);

'use strict';

angular.module('paycircleApp')

.component('deleteSupplementaryPayRunForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'deleteSupplementaryPayRunFormCtrl',
	templateUrl: 'forms/payroll/delete-supplementary-pay-run/delete-supplementary-pay-run.form.html'
})

.controller('deleteSupplementaryPayRunFormCtrl', [
	'$state',
	'payrollData',
	function (
		$state,
		payrollData
	) {

	const $ctrl = this;

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function deleteSupplementaryPayRun ($ctrl, formObj) {

		formObj.state = 'saving';

		payrollData.deleteSupplementaryPayment($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.supplementaryPayment.SupplementaryPaymentID).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		deleteSupplementaryPayRun
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editHolidayPolicyForm', function () {

	return {
		controller: 'editHolidayPolicyFormCtrl',
		templateUrl: 'forms/payroll/editHolidayPolicy/editHolidayPolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editHolidayPolicyFormCtrl', ['$scope', 'user', function ($scope, user) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		$scope.pageState = 'loading';

		user.getTeamMemberHolidaySickness(userId, agencyProfileId).then(function (holidaySicknessObj) {

			$scope.holidaySickness = holidaySicknessObj;
			$scope.pageState = 'ready';
		})
		.catch(function() {

			$scope.pageState = 'error';
		});
	}

	init();

	$scope.saveForm = function (formObj, form) {

		// Update state
		form.state = 'saving';

		user.updateTeamMemberHolidaySickness(userId, agencyProfileId, $scope.holidaySickness).then(function (){

			$scope.pageState = 'saved-policy';
			$scope.formOptions.forceCallback();
		})
		.catch(function() {

			$scope.pageState = 'error';
			form.state = null;
		});
	};

	$scope.closeForm = function () {

		if ($scope.formOptions.returnToHSForm) {
			$scope.formOptions.openNewSlideInForm({
				title: 'Holiday and sickness',
				agencyProfileId: agencyProfileId,
				userId: userId,
				callback: $scope.formOptions.returnCallback,
				contextType: 'user',
				formView: 'holiday',
				formKey: 'holiday-sickness',
			});
		} else {
			$scope.formOptions.closeForm();
		}
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('editPayNotificationDateForm', function () {

	return {
		controller: 'editPayNotificationDateFormCtrl',
		templateUrl: 'forms/payroll/editPayNotificationDate/editPayNotificationDateForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editPayNotificationDateFormCtrl', [
	'$q',
	'$scope',
	'payrollData',
	'payrollWorker',
	'PAY_PERIOD_TYPES',
function (
	$q,
	$scope,
	payrollData,
	payrollWorker,
	PAY_PERIOD_TYPES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriod = $scope.formOptions.payPeriod;

	function decoratePayPeriod (payPeriodObj) {

		// Minimum payslip notification date is tomorrow
		payPeriodObj.payslipDateMinimumISO = moment().add(1, 'day').format();

		// Max depends on pay period type. Q/B/A is processing date + 1 month, otherwise use the value provided by the platform
		if ([PAY_PERIOD_TYPES.quarterly, PAY_PERIOD_TYPES.biannually, PAY_PERIOD_TYPES.annually].includes(payPeriodObj.PayPeriodType)) {
			payPeriodObj.payslipDateMaximumISO = moment(payPeriodObj.PayslipDateISO).add(1, 'month').format();
		}
		else {
			payPeriodObj.payslipDateMaximumISO = payPeriodObj.PayslipDateMaximumISO;
		}
	}

	function init () {

		decoratePayPeriod (payPeriod);

		$scope.vm = {
			// Choose a day option is selected by default, along with the payslip date
			chooseDate: true,
			payPeriod
		};

		setPageState('ready');
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updatePayNotificationDate (form, payPeriodObj, vmObj) {

		form.state = 'saving';


		// If 'notify immediately', update the pay notification date to today. Also requires an additional call to
		if (!vmObj.chooseDate) {
			payPeriodObj.PayslipDateISO = moment().format();
		}

		// One or two API calls are required
		const updateAgencyPayPeriodPayslipDate = [payrollData.updateAgencyPayPeriodPayslipDate(payPeriodObj.PayPeriodID, payPeriodObj.PayslipDateISO)];

		// If 'notify immediately', also make call to mail payslips
		if (!vmObj.chooseDate) {
			updateAgencyPayPeriodPayslipDate.push(payrollWorker.payrollMailPayslips(agencyProfileId, payPeriodObj.PayPeriodID));
		}

		$q.all(updateAgencyPayPeriodPayslipDate).then(() => {

			form.state = 'saved';
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		updatePayNotificationDate
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('editRepaymentScheduleForPeriodForm', function () {

	return {
		controller: 'editRepaymentScheduleForPeriodFormCtrl',
		templateUrl: 'forms/payroll/editRepaymentScheduleForPeriod/editRepaymentScheduleForPeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editRepaymentScheduleForPeriodFormCtrl', [
	'$rootScope',
	'$scope',
	'$timeout',
	'payrollData',
	'pensionService',
	'LOAN_DEDUCTION_TYPES',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	function (
		$rootScope,
		$scope,
		$timeout,
		payrollData,
		pensionService,
		LOAN_DEDUCTION_TYPES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const paymentScheduleGroupId = $scope.formOptions.paymentScheduleGroupId;
	const userId = $scope.formOptions.userId;

	function decoratePaymentSchedule (paymentScheduleObj, unpaidScheduleEntries) {

		// Reorder pensions to bring AE pension to the beginning
		pensionService.getOrderedPensionsArray(paymentScheduleObj.PaymentScheduleGroupPension);

		return angular.extend(paymentScheduleObj, {
			nextPayment: unpaidScheduleEntries[0],
			deductionType: paymentScheduleObj.PeriodRepaymentCount > 0 ? LOAN_DEDUCTION_TYPES.SPLIT : LOAN_DEDUCTION_TYPES.FIXED,
			newDeductionAmount: '',
		});
	}

	function getUnpaidPayments (paymentObj) {
		return !paymentObj.IsPaid;
	}

	function init () {

		setPageState('loading');

		payrollData.getPaymentScheduleGroup(agencyProfileId, paymentScheduleGroupId, userId)
			.then(paymentScheduleObj => {

				const unpaidScheduleEntries = paymentScheduleObj.ScheduleEntries.filter(getUnpaidPayments);

				if (unpaidScheduleEntries.length === 0) {
					$rootScope.paycircleMessage('There are no unpaid payments in this schedule', 'warn');
					setPageState('error');
					return;
				}

				$scope.paymentSchedule = decoratePaymentSchedule(paymentScheduleObj, unpaidScheduleEntries);

				setPageState('ready');
				setRecalculateState(paymentScheduleObj, null);
			})
			.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function recalculateRepaymentSchedule (paymentScheduleObj, form) {

		const storeResult = false;

		form.state = 'saving';
		setRecalculateState(paymentScheduleObj, 'recalculating');

		$timeout(function () {
			payrollData.recalculatePaymentSchedule(paymentScheduleObj.PaymentScheduleGroupID, paymentScheduleObj.newDeductionAmount, storeResult)
				.then(recalculatedScheduleEntriesArray => {

					setRecalculateState(paymentScheduleObj, 'recalculated');
					paymentScheduleObj.ScheduleEntries = recalculatedScheduleEntriesArray;

					form.state = null;
				})
				.catch(() => {
					setRecalculateState(paymentScheduleObj, null);
		            setPageState('invalid-schedule');
				});
		}, 1000);
	}

	function saveRecalculatedRepaymentSchedule (paymentScheduleObj, form) {

		const storeResult = true;

		form.state = 'saving';

		// Give user time to digest recalculation
		payrollData.recalculatePaymentSchedule(paymentScheduleObj.PaymentScheduleGroupID, paymentScheduleObj.newDeductionAmount, storeResult)
			.then(recalculatedScheduleEntriesArray => {

				paymentScheduleObj.ScheduleEntries = recalculatedScheduleEntriesArray;

				form.state = 'saved';

				setPageState('success');
				setRecalculateState(paymentScheduleObj, null);

				$scope.formOptions.forceCallback();
			})
			.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setRecalculateState (paymentScheduleObj, recalculationState) {
		paymentScheduleObj.recalculationState = recalculationState;
	}

	init();

	angular.extend($scope, {
		LOAN_DEDUCTION_TYPES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,

		recalculateRepaymentSchedule,
		saveRecalculatedRepaymentSchedule
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editRepaymentScheduleFixedForPeriodForm', function () {

	return {
		controller: 'editRepaymentScheduleFixedForPeriodFormCtrl',
		templateUrl: 'forms/payroll/editRepaymentScheduleFixedForPeriod/editRepaymentScheduleFixedForPeriodForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editRepaymentScheduleFixedForPeriodFormCtrl', [
	'$scope',
	'payrollData',
	'pensionService',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	function (
		$scope,
		payrollData,
		pensionService,
		PAYMENT_SCHEDULE_PENSION_OPTIONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const paymentScheduleGroupId = $scope.formOptions.paymentScheduleGroupId;
	const paymentScheduleId = $scope.formOptions.paymentScheduleId;
	const userId = $scope.formOptions.userId;

	function decoratePaymentSchedule (paymentScheduleObj) {

		// Reorder pensions to bring AE pension to the beginning
		pensionService.getOrderedPensionsArray(paymentScheduleObj.PaymentScheduleGroupPension);

		return paymentScheduleObj;
	}


	function init () {

		setPageState('loading');

		payrollData.getPaymentScheduleGroup(agencyProfileId, paymentScheduleGroupId, userId)
			.then(paymentScheduleGroupObj => {

				$scope.vm = {
					paymentScheduleGroup: decoratePaymentSchedule(paymentScheduleGroupObj)
				};

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updatePaymentScheduleValue (vmObj, formObj) {

		formObj.state = 'saving';

		setPageState('loading');

		payrollData.updatePaymentScheduleValue(paymentScheduleId, vmObj.paymentScheduleGroup.ValueForCurrentPeriod)
			.then(() => {

				formObj.state = 'saved';

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();
			})
			.catch(onError);
	}

	init();

	angular.extend($scope, {
		PAYMENT_SCHEDULE_PENSION_OPTIONS,

		updatePaymentScheduleValue
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editSicknessPolicyForm', function () {

	return {
		controller: 'editSicknessPolicyFormCtrl',
		templateUrl: 'forms/payroll/editSicknessPolicy/editSicknessPolicyForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editSicknessPolicyFormCtrl', ['$scope', 'growl', 'SICKNESS_TYPES', 'user', function ($scope, growl, SICKNESS_TYPES, user) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		$scope.pageState = 'loading';
		$scope.SICKNESS_TYPES = SICKNESS_TYPES;

		user.getTeamMemberHolidaySickness(userId, agencyProfileId).then(function (holidaySicknessObj) {

			$scope.holidaySickness = holidaySicknessObj;
			$scope.pageState = 'ready';
		})
		.catch(function() {

			$scope.pageState = 'error';
		});
	}

	init();

	$scope.saveForm = function (formObj, form) {

		// Update state
		form.state = 'saving';

		user.updateTeamMemberHolidaySickness(userId, agencyProfileId, $scope.holidaySickness).then(function (){

			$scope.pageState = 'saved-policy';
			$scope.formOptions.forceCallback();

		})
		.catch(function() {

			$scope.pageState = 'error';
			form.state = null;
		});
	};

	$scope.closeForm = function () {

		if ($scope.formOptions.returnToHSForm) {
			$scope.formOptions.openNewSlideInForm({
				title: 'Holiday and sickness',
				agencyProfileId: agencyProfileId,
				userId: userId,
				callback: $scope.formOptions.returnCallback,
				contextType: 'user',
				formView: 'sickness',
				formKey: 'holiday-sickness',
			});
		} else {
			$scope.formOptions.closeForm();
		}
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('excludeFromPayrollForm', function () {

	return {
		controller: 'excludeFromPayrollFormCtrl',
		templateUrl: 'forms/payroll/excludeFromPayroll/excludeFromPayrollForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('excludeFromPayrollFormCtrl', ['$scope', 'growl', 'session', 'teamData', 'userData', function ($scope, growl, session, teamData, userData) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var onSuccess 		= $scope.formOptions.onSuccess;
	var userId 			= $scope.formOptions.userId;

	function init () {

		teamData.getTeamMemberInformation(userId, agencyProfileId).then(function (teamMemberObj) {

			// Scope
			$scope.teamMember = teamMemberObj;

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function() {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();

	// Scope functions
	$scope.saveExcludeFromPayroll = function (teamMember, form) {

		userData.updateUserAgencyProfileExcludeFromPayroll(agencyProfileId, userId, teamMember.Company.ExcludeFromPayroll).then(function () {

			// Update state
			form.state = 'saving';

			// Force callback
			$scope.formOptions.forceCallback();

			// Show feedback
			var message = teamMember.Company.ExcludeFromPayroll ? teamMember.Personal.Forename + ' has been excluded from payroll' : teamMember.Personal.Forename + ' has been added back onto payroll';
			growl.success(message);

			// Close form
			$scope.formOptions.closeForm();

			// On success
			if (onSuccess) {
				onSuccess();
				return;
			}

			// Update state
			form.state = 'saved';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('furloughForm', function () {

	return {
		controller: 'furloughFormCtrl',
		templateUrl: 'forms/payroll/furlough/furloughForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('furloughFormCtrl', ['$q', '$scope', 'config', 'payPeriodService', 'payrollData', 'SALARY_TYPES',
	function ($q, $scope, config, payPeriodService, payrollData, SALARY_TYPES) {

	const formOptionsObj = $scope.formOptions;
	const agencyProfileId = formOptionsObj.agencyProfileId;
	const lastPayPeriodDateISO = formOptionsObj.lastPayPeriodDateISO;
	const userId = formOptionsObj.userId;
	const userIds = formOptionsObj.userIds;
	const userObj = formOptionsObj.context;
	const IS_BULK_FURLOUGH = !userId;

	const PAGE_STATES = {
		loading: 'loading',
		error: 'error',
		ready: 'ready',
		view: 'view',
		individualSaved: 'individual-saved',
		editDates: 'edit-dates',
		unfurloughConfirm: 'unfurlough-confirm',
		unfurloughed: 'unfurloughed',
		bulkSaved: 'bulk-furloughed',
		markedAsLeaving: 'marked-as-leaving'
	};

	function calculateFurloughPay (teamMemberSalaryObj, yearlyGrossPay, payPeriodObj) {

		const periodDivisorInt = getDivisorForPayPeriodType(teamMemberSalaryObj, payPeriodObj);
		const periodFurloughCapInt = getSalaryCapForPeriodType(payPeriodObj.PeriodType);

		const percentageOfSalaryInt = ((yearlyGrossPay / 100) * config.furlough.monthlyPayCapPercent) / periodDivisorInt;

		angular.extend(teamMemberSalaryObj, {
			totalPay: yearlyGrossPay / periodDivisorInt,
			percentagePay: percentageOfSalaryInt,
			furloughPay: percentageOfSalaryInt < periodFurloughCapInt ? percentageOfSalaryInt : periodFurloughCapInt,
			periodCap: periodFurloughCapInt,
			showFurloughSalaryPay: true
		});
	}

	function decorateFurlough (furloughDetailObj, userObj) {

		// Set indicator for part time furlough for convenience
		const isPartTime = angular.isDefined(furloughDetailObj.PartTimeDateISO) && furloughDetailObj.PartTimeDateISO !== '';
		furloughDetailObj.isPartTime = isPartTime;

		// Set indicator for readonly start date. It can't be edited if the user isn't onboarding, and it falls before the last pay date
		const lastPayPeriodDateDefined = angular.isDefined(lastPayPeriodDateISO) && lastPayPeriodDateISO !== '';
		furloughDetailObj.startDateReadonly = (lastPayPeriodDateDefined && moment(furloughDetailObj.StartDateISO).isBefore(lastPayPeriodDateISO) && !userObj.IsInSetupMode) || userObj.IsFurloughedEnded;

		return furloughDetailObj;
	}

	function decoratePayPeriodDetails (payPeriodDetailsArr, userObj) {

		// For users not in set-up mode, limit the list of pay periods to those that are not complete.
		if (!userObj.IsInSetupMode) {
			payPeriodDetailsArr = payPeriodDetailsArr.filter(payPeriodDetail => !payPeriodDetail.PeriodComplete);
		}

		return payPeriodDetailsArr;
	}

	function decorateSalary (teamMemberSalaryObj, payPeriodObj) {

		if (teamMemberSalaryObj.SalaryType === SALARY_TYPES.grossPay) {
			calculateFurloughPay(teamMemberSalaryObj, teamMemberSalaryObj.SalaryYearly, payPeriodObj);

		} else {
			teamMemberSalaryObj.grossPayAmount = null;
		}

		return teamMemberSalaryObj;
	}

	function getDivisorForPayPeriodType (teamMemberSalaryObj, payPeriodObj) {

		if (teamMemberSalaryObj.SalaryType === SALARY_TYPES.grossPay) {
			return payPeriodService.getDivisorForPayPeriodType(payPeriodObj.PeriodType);

		} else {
			return 1;
		}
	}

	function getEmptyFurloughDetail (payPeriodObj) {
		return {
			EndDateISO: '',
			PeriodType: payPeriodObj.PeriodType,
			SalaryForPeriod: null,
			StartDateISO: '',
			TopupAmount: null,
		};
	}

	function getFurloughPayForNonGrossPaySalary (vmObj) {

		if (vmObj.teamMemberSalary.grossPayAmount > 0) {
			calculateFurloughPay(vmObj.teamMemberSalary, vmObj.teamMemberSalary.grossPayAmount, vmObj.payPeriod);

		} else {
			vmObj.teamMemberSalary.showFurloughSalaryPay = false;
		}
	}

	function getSalaryCapForPeriodType (payPeriodType) {
		return config.furlough.payCapByPeriodType[payPeriodType];
	}

	function init () {

		setPageState(PAGE_STATES.loading);


		if (IS_BULK_FURLOUGH) {
			initBulkFurloughForm();

		} else {
			if (userObj.IsLeaving) {
				setPageState(PAGE_STATES.markedAsLeaving);

			} else if (userObj.IsFurloughed || userObj.IsFurloughedEnded) {
				initTeamMemberFurloughViewForm();

			} else {
				initTeamMemberFurloughForm();
			}
		}
	}

	function initBulkFurloughForm () {

		const IS_PREVIOUS_PERIOD = false;

		payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD).then(payPeriodObj => {

			$scope.vm = {
				furloughDetail: getEmptyFurloughDetail(payPeriodObj),
				payPeriod: payPeriodObj,
				periodCap: getSalaryCapForPeriodType(payPeriodObj.PeriodType),
				showAddTopUp: false
			};

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function initTeamMemberFurloughForm () {

		const IS_PREVIOUS_PERIOD = false;

		const getTeamMemberSalaryForPeriod = payrollData.getTeamMemberSalaryForPeriod(agencyProfileId, userId);
		const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD);
		const getUserPayPeriodDetails = payrollData.getUserPayPeriodDetails(agencyProfileId, config.guidEmpty, userId);

		$q.all([getTeamMemberSalaryForPeriod, getPayPeriodMinimum, getUserPayPeriodDetails]).then(([teamMemberSalaryObj, payPeriodObj, payPeriodDetailsArr]) => {

			const emptyFurloughDetail = getEmptyFurloughDetail(payPeriodObj);

			$scope.vm = {
				furloughDetail: emptyFurloughDetail,
				payAmount: null,
				payPeriod: payPeriodObj,
				payPeriodDetails: decoratePayPeriodDetails(payPeriodDetailsArr, userObj),
				showAddTopUp: false,
				showPartTimeFurloughPay: false,
				showSalaryOverride: false,
				teamMemberSalary: decorateSalary(teamMemberSalaryObj, payPeriodObj),
			};

			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function initTeamMemberFurloughViewForm () {

		const getTeamMemberSalaryFurloughed = payrollData.getTeamMemberSalaryFurloughed(agencyProfileId, userId);
		const getUserPayPeriodDetails = payrollData.getUserPayPeriodDetails(agencyProfileId, config.guidEmpty, userId);

		$q.all([getTeamMemberSalaryFurloughed, getUserPayPeriodDetails]).then(([furloughDetailObj, payPeriodDetailsArr]) => {

			$scope.vm = {
				furloughDetail: decorateFurlough(furloughDetailObj, userObj),
				payPeriodDetails: payPeriodDetailsArr
			};

			// Initially display part time UI based on isPartTime value (determined in decorateFurlough)
			$scope.vm.showPartTimeFurloughPay = $scope.vm.furloughDetail.isPartTime;

			setPageState(PAGE_STATES.view);
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function payPeriodDetailFilter (payPeriodDetailObj) {

		// Filter out pay periods before the furlough start date if there is one
		const furloughPartTimeDateISO = $scope.vm.furloughDetail.PartTimeDateISO;
		if (angular.isDefined(furloughPartTimeDateISO) && furloughPartTimeDateISO !== '') {
			return moment(payPeriodDetailObj.PeriodStartISO).isSameOrAfter($scope.vm.furloughDetail.PartTimeDateISO);
		}
		else {
			return payPeriodDetailObj;
		}
	}

	function saveUpdateFurloughForm (vmObj, formObj) {

		if (IS_BULK_FURLOUGH) {
			updateTeamMemberSalaryFurloughedBulk(vmObj, formObj);

		} else {
			updateTeamMemberSalaryFurloughed(vmObj, formObj);
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function showPartTimeFurloughPayChanged (vmObj) {

		if (vmObj.showPartTimeFurloughPay) {
			// These options aren't available if part-time furlough pay is selected
			vmObj.showAddTopUp = false;
			vmObj.showSalaryOverride = false;

			// Part time start date - default to first available period if not already set
			if (!angular.isDefined(vmObj.furloughDetail.PartTimeDateISO) || vmObj.furloughDetail.PartTimeDateISO === '') {
				vmObj.furloughDetail.PartTimeDateISO = vmObj.payPeriodDetails[0].PeriodStartISO;
			}
		}
		else {
			// Part time start date not applicable
			vmObj.furloughDetail.PartTimeDateISO = '';
		}
	}

	function updateTeamMemberSalaryFurloughed (vmObj, formObj) {

		formObj.state = 'saving';

		if (!vmObj.showAddTopUp) {
			vmObj.furloughDetail.TopupAmount = 0;
		}

		if (!vmObj.showSalaryOverride) {
			vmObj.furloughDetail.SalaryForPeriod = parseFloat(vmObj.teamMemberSalary.furloughPay.toFixed(2));
		}

		if (!vmObj.showPartTimeFurloughPay) {
			vmObj.furloughDetail.PartTimeDateISO = '';
		}

		const updateTeamMemberSalaryFurloughed = payrollData.updateTeamMemberSalaryFurloughed(agencyProfileId, userId, vmObj.furloughDetail, vmObj.showPartTimeFurloughPay);
		// API call to update pay period details only if part time furlough has been selected
		const updateUserPayPeriodDetails = vmObj.showPartTimeFurloughPay ? payrollData.updateUserPayPeriodDetails(agencyProfileId, config.guidEmpty, vmObj.payPeriodDetails) : null;

		$q.all([updateTeamMemberSalaryFurloughed, updateUserPayPeriodDetails]).then(() => {

			formObj.state = 'saved';

			$scope.formOptions.initCallbackOnClose = true;

			setPageState(PAGE_STATES.individualSaved);
		})
		.catch(onError);
	}

	function updateTeamMemberSalaryFurloughedBulk (vmObj, formObj) {

		formObj.state = 'saving';

		if (!vmObj.showAddTopUp) {
			vmObj.furloughDetail.TopupAmount = 0;
		}

		payrollData.updateTeamMemberSalaryFurloughedBulk(agencyProfileId, userIds, vmObj.furloughDetail.StartDateISO, vmObj.furloughDetail.EndDateISO, vmObj.furloughDetail.TopupAmount).then(() => {

			formObj.state = 'saved';

			$scope.formOptions.initCallbackOnClose = true;

			setPageState(PAGE_STATES.bulkSaved);
		})
		.catch(onError);
	}

	function updateTeamMemberSalaryFurloughedCancel (vmObj, formObj) {

		formObj.state = 'saving';

		payrollData.updateTeamMemberSalaryFurloughedCancel(agencyProfileId, userId).then(() => {

			formObj.state = 'saved';

			$scope.formOptions.initCallbackOnClose = true;

			setPageState(PAGE_STATES.unfurloughed);
		})
		.catch(onError);
	}

	function updateTeamMemberSalaryFurloughedInProgress (vmObj, formObj) {

		const updateTeamMemberSalaryFurloughedInProgress = payrollData.updateTeamMemberSalaryFurloughedInProgress(agencyProfileId, userId, vmObj.furloughDetail);
		// API call to update pay period details only if part time furlough has been selected
		const updateUserPayPeriodDetails = vmObj.showPartTimeFurloughPay ? payrollData.updateUserPayPeriodDetails(agencyProfileId, config.guidEmpty, vmObj.payPeriodDetails) : null;

		$q.all([updateTeamMemberSalaryFurloughedInProgress, updateUserPayPeriodDetails]).then(() => {

			formObj.state = 'saved';

			$scope.formOptions.initCallbackOnClose = true;

			setPageState(PAGE_STATES.individualSaved);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		IS_BULK_FURLOUGH,
		PAGE_STATES,
		SALARY_TYPES,

		user: userObj,

		getFurloughPayForNonGrossPaySalary,
		payPeriodDetailFilter,
		saveUpdateFurloughForm,
		setPageState,
		showPartTimeFurloughPayChanged,
		updateTeamMemberSalaryFurloughedCancel,
		updateTeamMemberSalaryFurloughedInProgress,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('generateP45Form', {
	bindings: {
		formOptions: '='
	},
	controller: 'generateP45FormCtrl',
	templateUrl: 'forms/payroll/generate-p45/generate-p45.form.html'
})

.controller('generateP45FormCtrl', [
	'reportData',
	'teamData',
	function (
		reportData,
		teamData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		teamData.getTeamMemberInformation($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId)
			.then(teamMemberObj => {

				$ctrl.teamMember = teamMemberObj;

				if (!teamMemberObj.Company.LeaveDateISO) {
					setPageState('no-leave-date');
					return;
				}

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error){
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	function payrollRegenerateP45 ($ctrl, $form) {

		$form.state = 'saving';

		reportData.payrollRegenerateP45($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId).then(() => {
			$form.state = 'saved';
			$ctrl.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		$onInit,

		payrollRegenerateP45
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('holidaySicknessForm', function () {

	return {
		controller: 'holidaySicknessFormCtrl',
		templateUrl: 'forms/payroll/holidaySickness/holidaySicknessForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('holidaySicknessFormCtrl', ['$q', '$rootScope', '$scope', 'agency', 'config', 'growl', 'holidaySicknessService', 'LEAVE_TYPES', 'LEAVE_TYPE_DESCRIPTIONS', function ($q, $rootScope, $scope, agency, config, growl, holidaySicknessService, LEAVE_TYPES, LEAVE_TYPE_DESCRIPTIONS) {

	const AGENCY_PROFILE_ID = $scope.formOptions.agencyProfileId;
	const USER_ID = $scope.formOptions.userId;

	function canAddSelectedLeaveType (selectedLeaveType) {

		if (!selectedLeaveType || !selectedLeaveType.id) {
			return false;
		}

		return true;
	}

	function addNewLeave (HSObj, formObj) {

		if (!canAddSelectedLeaveType(HSObj.addLeave.selectedLeaveType)) {
			return;
		}

		HSObj.dateWatcher();

		formObj.state = 'saving';

		setCallbackOnClose();

		if (HSObj.addLeave.selectedLeaveType.id === LEAVE_TYPE_DESCRIPTIONS.sickLeave) {

			agency.getEmptySicknessDetail().then(sickLeaveObj => {

				sickLeaveObj = holidaySicknessService.decorateNewSicknessDetail(sickLeaveObj, HSObj.addLeave);

				agency.updateSicknessDetail(USER_ID, AGENCY_PROFILE_ID, sickLeaveObj).then(newSicknessObj => {

					growl.success(`You have added ${newSicknessObj.SicknessDays} days sick leave for ${$scope.formOptions.context.Forename}.`);

					// Complete demo task
					$rootScope.setDemoTaskAsComplete('addSickness', $scope.formOptions.context.Forename);

					HSObj.sickness.all.push(newSicknessObj);
					HSObj.sickness.Sickness.TotalSickness = HSObj.sickness.Sickness.TotalSickness + newSicknessObj.SicknessDays;

					resetNewLeave(HSObj);

					formObj.state = 'saved';
					setTimeout(function () {
						formObj.state = 'null';
					}, 1500);
				})
				.catch(onError);

			})
			.catch(onError);

		} else {

			agency.getEmptyHolidayDetail().then(holidayLeaveObj => {

				holidayLeaveObj = holidaySicknessService.decorateNewHolidayDetail(holidayLeaveObj, HSObj.addLeave);

				agency.updateHolidayDetail(USER_ID, AGENCY_PROFILE_ID, holidayLeaveObj).then(function (newHolidayObj) {

					growl.success(`You have added ${newHolidayObj.HolidayDays} days annual leave for ${$scope.formOptions.context.Forename}.`);

					// Complete demo task
					$rootScope.setDemoTaskAsComplete('addHoliday', $scope.formOptions.context.Forename);
					$rootScope.setDemoTaskAsComplete('editHoliday', $scope.formOptions.context.Forename);

					HSObj.holiday.Holidays.HolidayDetails.push(newHolidayObj);
					HSObj.holiday = holidaySicknessService.decorateHolidayDetails(HSObj.holiday);

					resetNewLeave(HSObj);

					formObj.state = 'saved';
					setTimeout(function () {
						formObj.state = 'null';
					}, 1500);
				})
				.catch(onError);
			})
			.catch(onError);
		}
	}

	function init () {

		setPageState('loading');

		const getHolidaySummary = agency.getHolidaySummary(AGENCY_PROFILE_ID, USER_ID);
		const getSicknessSummary = agency.getSicknessSummary(AGENCY_PROFILE_ID, USER_ID);

		$q.all([getHolidaySummary, getSicknessSummary]).then(function (data) {

			let holidayObj = data[0];
			let sicknessObj = data[1];

			$scope.HS = {
				addLeave: holidaySicknessService.getEmptyLeave(),
				formView:  $scope.formOptions.formView ? $scope.formOptions.formView : 'overview',
				holiday: holidaySicknessService.decorateHolidayDetails(holidayObj),
				sickness: holidaySicknessService.decorateSicknessDetails(sicknessObj),
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function initDateWatcher (HSObj) {

		HSObj.dateWatcher = $scope.$watch('[HS.addLeave.startDateIso, HS.addLeave.endDateIso]', function () {

			if (HSObj.addLeave.startDateIso && !HSObj.addLeave.endDateIso) {
				HSObj.addLeave.endDateIso = HSObj.addLeave.startDateIso;
			}

			if (HSObj.addLeave.startDateIso && HSObj.addLeave.endDateIso) {
				holidaySicknessService.calculateLeaveLength(HSObj.addLeave);
			}
		});
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onLeaveDelete () {

		init();
		setCallbackOnClose();
	}

	function openAddLeave (HSObj) {

		initDateWatcher(HSObj);

		if (HSObj.formView === 'sickness') {
			HSObj.addLeave.selectedLeaveType = LEAVE_TYPES.sickness[0];

		} else {
			HSObj.addLeave.selectedLeaveType = null;
		}

		HSObj.showAddLeave = true;
	}

	function openSlideInForm (formOptionsObj) {

		let defaultFormOptionsObj = {
			agencyProfileId: AGENCY_PROFILE_ID,
			userId: USER_ID,
			callback: init,
			contextType: 'user',
			returnToHSForm: true,
			returnCallback: function () {
				$scope.formOptions.forceCallback();
			}
		};

		$scope.formOptions.openNewSlideInForm(angular.extend(defaultFormOptionsObj, formOptionsObj));
	}

	function openEditHolidayPolicyForm () {

		openSlideInForm({
			title: 'Edit holiday policy',
			formKey: 'edit-holiday-policy',
		});
	}

	function openEditSicknessPolicyForm () {

		openSlideInForm({
			title: 'Edit sickness policy',
			formKey: 'edit-sickness-policy',
		});
	}

	function resetNewLeave (HSObj) {
		angular.merge(HSObj, {
			showAddLeave: false,
			addLeave: holidaySicknessService.getEmptyLeave()
		});
	}

	function setCallbackOnClose () {
		$scope.formOptions.initCallbackOnClose = true;
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	init();

	angular.extend($scope, {
		LEAVE_TYPES,
		addHalfDayFrom: holidaySicknessService.addHalfDayFrom,
		addHalfDayTo: holidaySicknessService.addHalfDayTo,
		addNewLeave,
		onLeaveDelete,
		openAddLeave,
		openEditHolidayPolicyForm,
		openEditSicknessPolicyForm,
		resetNewLeave
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('hourlyTotalsForm', function () {

	return {
		controller: 'hourlyTotalsFormCtrl',
		templateUrl: 'forms/payroll/hourlyTotals/hourlyTotalsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('hourlyTotalsFormCtrl', ['$scope', 'config', 'growl', 'payrollData', 'searchService', 'teamData',
	function ($scope, config, growl, payrollData, searchService, teamData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriodId = $scope.formOptions.payPeriodId;

	function getTeamMemberSalaryTotals (teamMemberObj) {

		// Calculate totals based on SalaryRates
		const salaryTotalsObj = teamMemberObj.SalaryRates.reduce((salaryTotalsObj, rateObj) => {

			salaryTotalsObj.totalGross += rateObj.SalaryRateHoursForPeriod * rateObj.SalaryRateValue;
			salaryTotalsObj.totalHours += rateObj.SalaryRateHoursForPeriod;

			return salaryTotalsObj;

		}, {
			totalGross: 0,
			totalHours: 0,
		});

		// For search bar
		teamMemberObj.fullname = `${teamMemberObj.Forename} ${teamMemberObj.Surname}`;

		return angular.merge(teamMemberObj, salaryTotalsObj);
	}

	function init () {

		setPageState('loading');

		let userId; // Available if updating one individual specifically (not used currently)

		payrollData.getTeamMemberSalariesHourlyPaid(agencyProfileId, userId, payPeriodId).then(teamMembersArray => {

			if (teamMembersArray.length === 0) {
				setPageState('no-hourly-paid-team-members');
				return;
			}

			$scope.teamMembers = teamMembersArray.filter(getTeamMemberSalaryTotals);

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (newState) {
		$scope.pageState = newState;
	}

	function updateSalaryRates (teamMembersArr, formObj) {

		formObj.state = 'saving';

		const rateDetailsArr = teamMembersArr.map(teamMemberObj => teamMemberObj.SalaryRates).flat();

		teamData.updateSalaryRates(agencyProfileId, payPeriodId, rateDetailsArr).then(() => {

			growl.success(`Hourly totals updated.`);

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		config,
		searchBarOptions: searchService.hourlyTotals,
		updateSalaryRates
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('leaverMadeInErrorForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'leaverMadeInErrorFormCtrl',
	templateUrl: 'forms/payroll/leaverMadeInError/leaver-made-in-error.form.html'
})

.controller('leaverMadeInErrorFormCtrl', [
	'reportData',
	function (
		reportData
	) {

	const COMPONENT_STATES = {
		error: 'error',
		confirm: 'confirm',
		complete: 'complete',
		loading: 'loading'
	};

	const $ctrl = this;

	let userId;
	let agencyProfileId;

	$ctrl.$onInit = () => {
		setComponentState(COMPONENT_STATES.confirm);

		// Grab the team member object and some IDs for convenience and readability
		agencyProfileId = $ctrl.formOptions.agencyProfileId;
		userId = $ctrl.formOptions.userId;

		$ctrl.teamMember =  $ctrl.formOptions.context;
	};

	function leaverMadeInError (formObj, teamMemberObj) {

		const NO_REGENERATE_P45 = true;
		/* CanUpdateLeaveStatus == FALSE indicates that OverrideLeaveSubmitted should be set
		   https://www.notion.so/paycircle/Team-Option-to-reinstate-a-leaver-for-leaver-made-in-error-ee9c5e6d98954b6ba2c6a80bf9c18ffb */
		const OVERRIDE_LEAVE_SUBMITTED = !teamMemberObj.CanUpdateLeaveStatus;

		formObj.state = 'saving';

		// These values don't matter, they will be reset, but the API wants something.
		const LEAVE_DATE_ISO = '';
		const LEAVE_REASON = 0;
		const LEAVE_NOTE = '';
		const LEAVE_SUBMIT = false;
		const LEAVE_SUBMITTED = false;

		reportData.payrollUpdateLeaveDateAndRegenerateP45(agencyProfileId,
														  userId,
														  LEAVE_DATE_ISO,
														  LEAVE_REASON,
														  LEAVE_NOTE,
														  LEAVE_SUBMIT,
														  LEAVE_SUBMITTED,
														  NO_REGENERATE_P45,
														  OVERRIDE_LEAVE_SUBMITTED).then(() => {

			$ctrl.formOptions.forceCallback();
			formObj.state = '';
		})
		.catch(error => {
			console.error(error);
			setComponentState(COMPONENT_STATES.error);
		});

		setComponentState(COMPONENT_STATES.complete);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		COMPONENT_STATES,

		leaverMadeInError
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('linkRatesForm', {
	controller: 'linkRatesFormCtrl',
	templateUrl: 'forms/payroll/link-rates/link-rates.form.html',
	bindings: {
		formOptions: '='
	}
})
.controller('linkRatesFormCtrl', ['adjustmentsService', 'growl', 'payrollData', 'payElementsService', 'searchService', 'ADJUSTMENT_VALUE_TYPES', function (adjustmentsService, growl, payrollData, payElementsService, searchService, ADJUSTMENT_VALUE_TYPES) {

	const $ctrl = this;

	function $onInit () {

		const LINK_ELEMENTS = true;

		var USER_IMPORT_GROUP_ID;
		var FUTURE_ADJUSTMENTS;

		setPageState('loading');

		payrollData.getUserPayElements($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId, $ctrl.formOptions.userId, FUTURE_ADJUSTMENTS, USER_IMPORT_GROUP_ID, LINK_ELEMENTS).then(teamMembersArr => {

			let teamMembers = payElementsService.filterUserPayElementsByValueType(teamMembersArr, 'unit');
			teamMembers = payElementsService.decorateUserPayElements(teamMembersArr);
			$ctrl.teamMembers = teamMembers;

			// No filtered results
			if ($ctrl.teamMembers.length === 0) {
				setPageState('no-link-rates');
			}

			else {
				setPageState('ready');
			}
		})
		.catch(onError);
	}

	function calculateTotal (payElement) {

		payElement.Value = adjustmentsService.getAdjustmentUnitValue(payElement);
	}

	function getPayElementsArr (teamMembersArr) {

		let returnArr = [];

		teamMembersArr.forEach(_ => {

			// Update period override flag for updated values
			_.PayElements.forEach(payElementObj => {
				if (payElementObj.Units !== payElementObj.RecurringUnits) {
					payElementObj.IsPeriodOverride = true;
				}
			});

			// We only what the list of pay elements
			returnArr = returnArr.concat(_.PayElements);
		});

		return returnArr;
	}

	function onError (error) {

		console.error(error);
		setPageState('error');
	}

	function setPageState (newState) {

		$ctrl.pageState = newState;
	}

	function updateLinkRates ($ctrl, formObj) {

		formObj.state = 'saving';

		const payElementsArr = getPayElementsArr($ctrl.teamMembers);

		payrollData.updateUserPayElementsUnitsBulk(payElementsArr).then(() => {

			growl.success('Link rates updated');

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();
		})
		.catch(onError);
	}

	angular.extend($ctrl, {
		ADJUSTMENT_VALUE_TYPES,
		$onInit,
		calculateTotal,
		searchBarOptions: searchService.teamGeneric,
		updateLinkRates
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('manageRolledUpHolidayForm', function () {

	return {
		controller: 'manageRolledUpHolidayFormCtrl',
		templateUrl: 'forms/payroll/manage-rolled-up-holiday/manage-rolled-up-holiday.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('manageRolledUpHolidayFormCtrl', [
	'$scope',
	'companyData', 
	'userData',
function (
	$scope,
	companyData,
	userData
) {

	function init () {
		$scope.pageState = 'ready';
		$scope.formOptions.isRolledUpHoliday = false;
		$scope.formOptions.excludeSalaryFromRolledUpHoliday = false;

		if (!$scope.formOptions.payeDetails) {
			companyData.getPAYEDetails($scope.formOptions.agencyProfileId).then(function(response) {
				$scope.formOptions.payeDetails = response;
			});
		}	
	}

	init();

	$scope.$watch('formOptions.isRolledUpHoliday', function (isRolledUpHoliday) {
		if (!isRolledUpHoliday) {
			$scope.formOptions.excludeSalaryFromRolledUpHoliday = false;
		}
	});

	$scope.saveForm = function (form) {

		const agencyProfileId	= $scope.formOptions.agencyProfileId;
		const userIds = $scope.formOptions.userIds;
		const isRolledUpHoliday = $scope.formOptions.isRolledUpHoliday;
		const excludeSalaryFromRolledUpHoliday = $scope.formOptions.isRolledUpHoliday ? $scope.formOptions.excludeSalaryFromRolledUpHoliday : false;
		form.state = 'saving';

		userData.updateUserAgencyProfilesRolledUpHoliday(agencyProfileId, userIds, isRolledUpHoliday, excludeSalaryFromRolledUpHoliday)
		.then(function (){
			$scope.formOptions.forceCallback();
			form.state = 'saved';
			$scope.pageState = 'success';
		})
		.catch(function() {
			$scope.pageState = 'error';
			form.state = null;
		});
	};

	$scope.closeForm = function () {
		$scope.formOptions.closeForm();
	};

}]);

'use strict';

angular.module('paycircleApp')

.directive('advanceMaternityFundingForm', () => {

	return {
		controller: 'advanceMaternityFundingFormCtrl',
		templateUrl: 'forms/payroll/maternityPay/advanceMaternityFunding/advanceMaternityFundingForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('advanceMaternityFundingFormCtrl', [
	'$q',
	'$scope',
	'edpTopicService',
	'teamData',
	'utilities',
	function (
		$q,
		$scope,
		edpTopicService,
		teamData,
		utilities
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const maternityScheduleId = $scope.formOptions.maternityScheduleId;
	const userId = $scope.formOptions.userId;

	function convertAdvanceFundingPaymentsToZeroIfNull (maternityPayObj) {

		if (maternityPayObj.AdvanceFunding.length) {
			maternityPayObj.AdvanceFunding.forEach((paymentObj) => {
				paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfNull(paymentObj.PaymentAmount);
			});
		}
	}

	function convertAdvanceFundingPaymentsToEmptyIfZero (maternityPayObj) {

		if (maternityPayObj.AdvanceFunding.length) {
			maternityPayObj.AdvanceFunding.forEach((paymentObj) => {
				paymentObj.PaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentObj.PaymentAmount);
			});
		}
	}

	function init () {

		setPageState('loading');

		const getMaternityAdvanceFunding = teamData.getTeamMemberMaternityAdvanceFundingDetailsForSchedule(maternityScheduleId);
		const getMaternityTopicEnabled = edpTopicService.isTopicEnabled(agencyProfileId, edpTopicService.TOPIC_KEYS.maternity);

		$q.all([getMaternityAdvanceFunding, getMaternityTopicEnabled]).then(([maternityObj, isEdpMaternityTopicEnabled]) => {

			$scope.isEdpMaternityTopicEnabled = isEdpMaternityTopicEnabled;

			convertAdvanceFundingPaymentsToEmptyIfZero(maternityObj);

			$scope.maternityPay = maternityObj;

			if (maternityObj.AdvanceFunding.length === 0) {
				setPageState('unable-to-add');
			}
			else {
				setPageState('ready');
			}
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function updateTeamMemberMaternityAdvanceFunding (maternityObj, formObj) {

		formObj.state = 'saving';

		convertAdvanceFundingPaymentsToZeroIfNull(maternityObj);

		teamData.updateTeamMemberMaternityAdvanceFunding(agencyProfileId, userId, maternityObj).then(() => {

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		updateTeamMemberMaternityAdvanceFunding
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('maternityPayForm', () => {

	return {
		controller: 'maternityPayFormCtrl',
		templateUrl: 'forms/payroll/maternityPay/maternityPayForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('maternityPayFormCtrl', [
	'$q',
	'$scope',
	'$timeout',
	'config',
	'policyService',
	'salaryService',
	'statutoryPaymentService',
	'teamData',
	'teamService',
	'userData',
	'utilities',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'PAY_PERIOD_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_TYPES',
	'PRO_RATION_METHODS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	'STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS',
	'STATUTORY_PAY_CALCULATION_METHODS',
	function (
		$q,
		$scope,
		$timeout,
		config,
		policyService,
		salaryService,
		statutoryPaymentService,
		teamData,
		teamService,
		userData,
		utilities,
		ADJUSTMENT_BEHAVIOUR_STATES,
		PAY_PERIOD_TYPES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_TYPES,
		PRO_RATION_METHODS,
		STAT_PAYMENT_SCHEDULE_STATES,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		STATUTORY_PAY_CALCULATION_METHODS
	) {

	// Steps. 2 and 3 are conditional and can be stepped over, depending on state.
	const MATERNITY_PAY_STEPS = {
		calculate: 1,
		enterPaymentDetails: 2,
		addSupplementaryOccupationalMaternityPay: 3,
		reviewSchedule: 4
	};
	const TOTAL_STEPS = 4;

	const TODAY_ISO = moment().format();

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const scheduleId = $scope.formOptions.scheduleId;
	const userId = $scope.formOptions.userId;

	const isEditing = angular.isDefined(scheduleId) && scheduleId !== null && scheduleId !== '';

	function createNilSchedule (maternityPayObj) {

		angular.extend(maternityPayObj, {
			isPaymentStepIgnored: getIsPaymentStepIgnored(maternityPayObj)
		});

		goToNextStep(maternityPayObj);
		setPageState('ready');
	}

	function decorateMaternityPay (maternityPayObj, teamMemberObj) {

		angular.extend(maternityPayObj, {
			Policy: maternityPayObj.Policy ? policyService.decoratePolicy(maternityPayObj.Policy, POLICY_CATEGORIES.parental) : maternityPayObj.Policy,
			dueDateISOMax: moment().add(config.parentalDueDateMaxWeeksInFuture, 'weeks').format(),
			hasStartDateBeenCalculated: isEditing,
			isEndDateCommsDismissed: false,
			isEndDateCommsVisible: false,
			isEndDateEditable: isEditing,
			maternityPayEligibilityDateMinIso: teamService.getTeamMemberEarliestStartDateIso(teamMemberObj),
			reviewScheduleView: 'payments',
			step: MATERNITY_PAY_STEPS.calculate,
		});

		return maternityPayObj;
	}

	function decorateTeamMemberObj (teamMemberObj) {

		angular.extend(teamMemberObj, {
			hasValidGrossSalary: salaryService.getHasValidGrossSalary(teamMemberObj.Salary)
		});

		return teamMemberObj;
	}

	function getIsPaymentStepIgnored (maternityPayObj) {

		// Ignore payment details step
		return statutoryPaymentService.getIsEligibilityIndependentOfEarnings(maternityPayObj.TeamMemberMaternityStatus);
	}

	function getMaternityDateBoundaries (maternityPayObj) {

		angular.extend(maternityPayObj, {
			hasStartDateBeenCalculated: false
		});

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternityDates(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				hasStartDateBeenCalculated: true,
				IsHistoricSchedule: angular.copy(updatedMaternityPayObj.IsHistoricSchedule),
				IsInProgressSchedule: angular.copy(updatedMaternityPayObj.IsInProgressSchedule),
				StartDateMaxISO: angular.copy(updatedMaternityPayObj.StartDateMaxISO),
				StartDateMinISO: angular.copy(updatedMaternityPayObj.StartDateMinISO),
				TeamMemberMaternityStatus: angular.copy(updatedMaternityPayObj.TeamMemberMaternityStatus)
			});

			utilities.focusOn('startdate');

			setPageState(statutoryPaymentService.getPageStateForStatus(maternityPayObj.TeamMemberMaternityStatus));
		})
		.catch(onError);
	}

	function getMaternitySalaryPayments (maternityPayObj, formObj) {

		formObj.state = 'saving';

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternitySalaryPayments(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				EndDateISO: angular.copy(updatedMaternityPayObj.EndDateISO),
				EndDateMaxISO: angular.copy(updatedMaternityPayObj.EndDateMaxISO),
				IsHistoricSchedule: updatedMaternityPayObj.IsHistoricSchedule,
				IsInProgressSchedule: updatedMaternityPayObj.IsInProgressSchedule,
				SalaryPayments: angular.copy(updatedMaternityPayObj.SalaryPayments),
				TeamMemberMaternityErrors: angular.copy(updatedMaternityPayObj.TeamMemberMaternityErrors),
				TeamMemberMaternityStatus: angular.copy(updatedMaternityPayObj.TeamMemberMaternityStatus),
				advanceFundingTotalAmount: 0,
				isPaymentStepIgnored: updatedMaternityPayObj.IsHistoricSchedule && maternityPayObj.IsPaidInFull,

				// Policy step is ignored if there are no policies, or if the schedule is historic
				isPoliciesApplicable: !maternityPayObj.IsHistoricSchedule && maternityPayObj.CanUsePolicy
			});

			// Empty zero payments
			statutoryPaymentService.convertSalaryPaymentsToEmptyIfZero(maternityPayObj);

			// Calculate Advance Funding
			if (maternityPayObj.AdvanceFunding.length) {
				maternityPayObj.AdvanceFunding.forEach(advanceFundingItem => {
					maternityPayObj.advanceFundingTotalAmount += advanceFundingItem.PaymentAmount;
				});
			}

			formObj.state = 'saved';

			// Maternity status is only updated after payment step, so check is not always needed
			if (maternityPayObj.TeamMemberMaternityStatus === STAT_PAYMENT_SCHEDULE_STATES.ready) {
				goToNextStep(maternityPayObj);
			}
			else {
				setPageState(statutoryPaymentService.getPageStateForStatus(maternityPayObj.TeamMemberMaternityStatus));
			}
		})
		.catch(onError);
	}

	function getMaternitySchedulePayments (maternityPayObj) {

		maternityPayObj.loadingStateSchedulePayments = 'loading';

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternitySchedulePayments(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				IsPaidInFull: angular.copy(updatedMaternityPayObj.IsPaidInFull),
				PaidInFullPayDateISO: angular.copy(updatedMaternityPayObj.PaidInFullPayDateISO),
				SchedulePayments: angular.copy(updatedMaternityPayObj.SchedulePayments),
				StartPayPeriodDisplay: angular.copy(updatedMaternityPayObj.StartPayPeriodDisplay),
				TeamMemberMaternityErrors: angular.copy(updatedMaternityPayObj.TeamMemberMaternityErrors),
				TeamMemberMaternityStatus: angular.copy(updatedMaternityPayObj.TeamMemberMaternityStatus),
				TotalAmount: angular.copy(updatedMaternityPayObj.TotalAmount),
				TotalAmountPaid: angular.copy(updatedMaternityPayObj.TotalAmountPaid),
				TotalAmountRemaining: angular.copy(updatedMaternityPayObj.TotalAmountRemaining),
				TotalBroughtForward: angular.copy(updatedMaternityPayObj.TotalBroughtForward),
				loadingStateSchedulePayments: 'ready'
			});
		})
		.catch(onError);
	}

	function getMaternityPolicies (vmObj, maternityPayObj) {

		const deferred = $q.defer();

		// Policies aren't relevant
		if (!maternityPayObj.CanUsePolicy) {
			deferred.resolve();
			return deferred.promise;
		}

		// Policy not used
		if (!maternityPayObj.UsePolicy) {
			deferred.resolve();
			return deferred.promise;
		}

		// Policies have already been loaded
		if (vmObj.maternityPolicies.length > 0) {
			deferred.resolve();
			return deferred.promise;
		}

		policyService.getPoliciesForType(agencyProfileId, POLICY_TYPES.maternity).then(maternityPoliciesArr => {

			deferred.resolve(maternityPoliciesArr);
		})
		.catch(error => {
			deferred.reject(error);
		});

		return deferred.promise;
	}

	function getTeamMemberMaternityDetailsForAdvanceFunding (maternityPayObj) {

		if (!maternityPayObj.HasAdvanceFunding) {
			maternityPayObj.AdvanceFunding = [];
			return;
		}

		maternityPayObj.advanceFundingState = 'loading';

		reviewEmptyValues(maternityPayObj);

		userData.getTeamMemberMaternityDetailsForAdvanceFunding(agencyProfileId, userId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				AdvanceFunding: angular.copy(updatedMaternityPayObj.AdvanceFunding),
				advanceFundingState: 'ready',
			});

			statutoryPaymentService.convertAdvanceFundingPaymentsToEmptyIfZero(maternityPayObj);
		})
		.catch(onError);
	}

	function goToNextStep (maternityPayObj) {
		progressStep(maternityPayObj, +1);
	}

	function goToPreviousStep (maternityPayObj) {
		progressStep(maternityPayObj, -1);
	}

	function init () {

		setPageState('loading');

		const getMaternityPay = teamData.getTeamMemberMaternityPay(userId, agencyProfileId, scheduleId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
			getMaternityPay,
			getTeamMemberInformation
		]).then(([
			maternityPayObj,
			teamMemberObj
		]) => {

			angular.extend($scope, {
				maternityPay: decorateMaternityPay(maternityPayObj, teamMemberObj),
				teamMember: decorateTeamMemberObj(teamMemberObj),
				vm: {
					loadingStatePolicies: 'ready',
					maternityPolicies: []
				}
			});

			// An integration-owned schedule already carries valid, server-calculated dates from
			// the EDP event (and its date fields are read-only), so there's no live date-picker
			// interaction left to move this out of 'loading' - default straight to 'ready'.
			setMaternityDatesState(maternityPayObj, maternityPayObj.IsFromIntegration ? 'ready' : 'loading');
			setPageState('ready');

			// When creating new schedule, focus on first field
			if (!isEditing) {
				$timeout(() => {
					utilities.focusOn('duedate');
				}, 200);
			}
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onMaternityPayBirthDateChange (maternityPayObj) {

		setMaternityDatesState(maternityPayObj, 'loading');

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternityDates(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				EarlyStartDateISO: updatedMaternityPayObj.EarlyStartDateISO
			});

			setMaternityDatesState(maternityPayObj, 'ready');
		})
		.catch(onError);
	}

	function onMaternityPayStartDateChange (maternityPayObj) {

		setMaternityDatesState(maternityPayObj, 'loading');

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternityDates(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				BirthDateMinISO: angular.copy(updatedMaternityPayObj.BirthDateMinISO),
				EndDateISO: angular.copy(updatedMaternityPayObj.EndDateISO),
				EndDateMaxISO: angular.copy(updatedMaternityPayObj.EndDateMaxISO),
				EndDateMinISO: angular.copy(updatedMaternityPayObj.EndDateMinISO),
				IsHistoricSchedule: angular.copy(updatedMaternityPayObj.IsHistoricSchedule),
				IsInProgressSchedule: angular.copy(updatedMaternityPayObj.IsInProgressSchedule),
				isEndDateEditable: true
			});

			resetPaymentsBroughtForward(maternityPayObj);

			setMaternityDatesState(maternityPayObj, 'ready');
		})
		.catch(onError);
	}

	function onMaternityPayEndDateChange (maternityPayObj) {

		setMaternityDatesState(maternityPayObj, 'loading');

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternityDates(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				IsInProgressSchedule: angular.copy(updatedMaternityPayObj.IsInProgressSchedule),
				IsHistoricSchedule: angular.copy(updatedMaternityPayObj.IsHistoricSchedule),
			});

			resetPaymentsBroughtForward(maternityPayObj);

			setMaternityDatesState(maternityPayObj, 'ready');
		})
		.catch(onError);
	}

	function onSelectMaternityPolicy (maternityPayObj, teamMemberObj) {

		validatePayPolicy(maternityPayObj, teamMemberObj);
	}

	function onUsePolicyChange (vmObj, maternityPayObj) {

		vmObj.loadingStatePolicies = 'loading';

		getMaternityPolicies(vmObj, maternityPayObj).then(payPoliciesArr => {

			// No need to update if not changed
			if (angular.isDefined(payPoliciesArr)) {
				vmObj.maternityPolicies = payPoliciesArr;
			}

			vmObj.loadingStatePolicies = 'ready';
		})
		.catch(onError);
	}

	function onUsePolicyInit (vmObj, maternityPayObj, teamMemberObj) {

		// Review whether pay policies are required
		onUsePolicyChange(vmObj, maternityPayObj);

		// Review whether pay policy is applied
		onSelectMaternityPolicy(maternityPayObj, teamMemberObj);
	}

	/*
	 * Move forward or back a step. stepCount can be +ve or -ve; it'll always be interpreted as +ve (forward one) or -ve (back one), keeping
	 * within the bounds of the available steps. It will also decide whether a step is valid and, if it isn't, it'll recall this function to
	 * move over it. That in turn could be skipped, etc.
	 */
	function progressStep (maternityPayObj, stepDirection) {

		const stepJump = Math.sign(stepDirection);

		// Don't pander to idiocy
		if (stepJump === 0) {
			return;
		}

		// Get the next step
		let nextStep = maternityPayObj.step + stepJump;

		// Say within bounds
		if (nextStep < 1) {
			nextStep = 1;
		}
		if (nextStep > TOTAL_STEPS) {
			nextStep = TOTAL_STEPS;
		}

		// Set that and decide whether, under the current circumstances, it's a valid step for the user to see
		maternityPayObj.step = nextStep;

		// Jump non-applicable steps in whichever direction we're travelling in
		switch (maternityPayObj.step) {

			// Policy step not applicable for historic schedules, or when there are no policies to choose from
			case MATERNITY_PAY_STEPS.addSupplementaryOccupationalMaternityPay:

				if (!maternityPayObj.isPoliciesApplicable) {
					progressStep(maternityPayObj, stepDirection);
				}

				break;

			case MATERNITY_PAY_STEPS.enterPaymentDetails:

				if (maternityPayObj.isPaymentStepIgnored) {
					progressStep(maternityPayObj, stepDirection);
				}

				break;
		}
	}

	function resetDueDate (maternityPayObj) {

		angular.extend(maternityPayObj, {
			DueDate: '',
			StartDateISO: '',
			hasStartDateBeenCalculated: false,
			isEndDateEditable: false
		});

		resetPaymentsBroughtForward(maternityPayObj);

		setMaternityDatesState(maternityPayObj, null);

		utilities.focusOn('duedate');
	}

	function reviewMaternitySchedulePayments (maternityPayObj, formObj) {

		formObj.state = 'saving';

		reviewEmptyValues(maternityPayObj);

		teamData.getTeamMemberMaternitySchedulePayments(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

			angular.extend(maternityPayObj, {
				IsPaidInFull: angular.copy(updatedMaternityPayObj.IsPaidInFull),
				PaidInFullPayDateISO: angular.copy(updatedMaternityPayObj.PaidInFullPayDateISO),
				SchedulePayments: angular.copy(updatedMaternityPayObj.SchedulePayments),
				StartPayPeriodDisplay: angular.copy(updatedMaternityPayObj.StartPayPeriodDisplay),
				TeamMemberMaternityErrors: angular.copy(updatedMaternityPayObj.TeamMemberMaternityErrors),
				TeamMemberMaternityStatus: angular.copy(updatedMaternityPayObj.TeamMemberMaternityStatus),
				TotalAmount: angular.copy(updatedMaternityPayObj.TotalAmount),
				TotalAmountPaid: angular.copy(updatedMaternityPayObj.TotalAmountPaid),
				TotalAmountRemaining: angular.copy(updatedMaternityPayObj.TotalAmountRemaining),
				TotalBroughtForward: angular.copy(updatedMaternityPayObj.TotalBroughtForward)
			});

			formObj.state = 'saved';

			// Check for errors and set the page state based on the response
			setPageState(statutoryPaymentService.getPageStateForStatus(maternityPayObj.TeamMemberMaternityStatus));

			// Move to next step if all ok
			if (maternityPayObj.TeamMemberMaternityStatus === STAT_PAYMENT_SCHEDULE_STATES.ready) {
				goToNextStep(maternityPayObj);
			}
		})
		.catch(onError);
	}

	function resetPaymentsBroughtForward (maternityPayObj) {

		angular.extend(maternityPayObj, {
			AmountBroughtForwardMethod: STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount,
			HasAmountBroughtForward: false,
			PaymentsBroughtForward: [],
			TotalBroughtForward: ''
		});
	}

	function reviewBroughtForwardMethod (maternityPayObj) {

		if (maternityPayObj.AmountBroughtForwardMethod === STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount) {

			angular.extend(maternityPayObj, {
				PaymentsBroughtForward: [],
				TotalBroughtForward: ''
			});
		}
		else {

			angular.extend(maternityPayObj, {
				paymentsBroughtForwardState: 'loading',
				TotalBroughtForward: 0
			});

			reviewEmptyValues(maternityPayObj);

			teamData.getTeamMemberMaternityDetailsBroughtForward(userId, agencyProfileId, maternityPayObj).then(updatedMaternityPayObj => {

				angular.extend(maternityPayObj, {
					PaymentsBroughtForward: updatedMaternityPayObj.PaymentsBroughtForward
				});

				statutoryPaymentService.convertBroughtForwardPaymentsToEmptyIfZero(maternityPayObj);

				if (maternityPayObj.PaymentsBroughtForward.length === 0) {
					maternityPayObj.paymentsBroughtForwardState = 'empty';
					return;
				}

				maternityPayObj.paymentsBroughtForwardState = 'ready';
			})
			.catch((error) => {
				onError(error);
				maternityPayObj.paymentsBroughtForwardState = null;
			});
		}
	}

	function reviewEmptyValues (maternityPayObj) {

		statutoryPaymentService.convertAdvanceFundingPaymentsToZeroIfNull(maternityPayObj);
		statutoryPaymentService.convertBroughtForwardPaymentsToZeroIfEmpty(maternityPayObj);
		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(maternityPayObj);

		maternityPayObj.TotalBroughtForward = utilities.setPropertyValueToZeroIfEmpty(maternityPayObj.TotalBroughtForward);
	}

	function setIsEndDateCommsVisible (maternityPayObj, isEndDateCommsVisible, isEndDateCommsDismissed) {

		// Ignore once dismissed
		if (maternityPayObj.isEndDateCommsDismissed) {
			return;
		}

		// Update dismissed if set
		if (angular.isDefined(isEndDateCommsDismissed)) {
			maternityPayObj.isEndDateCommsDismissed = isEndDateCommsDismissed;
		}

		maternityPayObj.isEndDateCommsVisible = isEndDateCommsVisible;
	}

	function setMaternityDatesState (maternityPayObj, maternityDatesState) {

		maternityPayObj.maternityDatesState = maternityDatesState;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateMaternityDates (maternityPayObj) {

		maternityPayObj.step = MATERNITY_PAY_STEPS.calculate;
	}

	function updateTeamMemberMaternitySchedulePayments (maternityPayObj, formObj) {

		formObj.state = 'saving';

		reviewEmptyValues(maternityPayObj);

		teamData.updateTeamMemberMaternitySchedulePayments(userId, agencyProfileId, maternityPayObj).then(() => {

			formObj.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('success');
		})
		.catch(onError);
	}

	function validatePayPolicy (maternityPayObj, teamMemberObj) {

		// Get selected policy for convenience
		let maternityPolicy = maternityPayObj.Policy;

		// If set, do some validation
		if (maternityPolicy) {

			// Selection OK by default
			angular.extend(maternityPolicy, {
				isValid: true,
				noAnnualSalarySaved: false
			});

			/* "% of annual salary" policies require a valid salary */
			if (maternityPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalaryPercent && !teamMemberObj.hasValidGrossSalary) {

				angular.extend(maternityPolicy, {
					isValid: false,
					noAnnualSalarySaved: true
				});
			}
		}
	}

	init();

	angular.extend($scope, {

		// Constants
		ADJUSTMENT_BEHAVIOUR_STATES,
		MATERNITY_PAY_STEPS,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		STAT_PAYMENT_SCHEDULE_STATES,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		STATUTORY_PAY_CALCULATION_METHODS,
		TODAY_ISO,

		// Services
		policyService,
		utilities,

		// Functions
		createNilSchedule,
		getIsStatPaymentSalarySacrificeReadOnly: statutoryPaymentService.getIsStatPaymentSalarySacrificeReadOnly,
		getMaternityDateBoundaries,
		getMaternitySalaryPayments,
		getMaternitySchedulePayments,
		getTeamMemberMaternityDetailsForAdvanceFunding,
		goToNextStep,
		goToPreviousStep,
		onMaternityPayBirthDateChange,
		onMaternityPayEndDateChange,
		onMaternityPayStartDateChange,
		onSelectMaternityPolicy,
		onUsePolicyChange,
		onUsePolicyInit,
		resetDueDate,
		reviewBroughtForwardMethod,
		reviewMaternitySchedulePayments,
		reviewStatPaymentSalarySacrifice: statutoryPaymentService.reviewStatPaymentSalarySacrifice,
		setIsEndDateCommsVisible,
		setPageState,
		updateMaternityDates,
		updateTeamMemberMaternitySchedulePayments
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('maternityPayViewForm', function () {

	return {
		controller: 'maternityPayViewFormCtrl',
		templateUrl: 'forms/payroll/maternityPay/maternityPayViewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('maternityPayViewFormCtrl', [
	'$q',
	'$scope',
	'edpTopicService',
	'policyService',
	'statutoryPaymentService',
	'teamData',
	'teamService',
	'userData',
	'utilities',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'PRO_RATION_METHODS',
	'SCHEDULE_UPDATE_REASONS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	function (
		$q,
		$scope,
		edpTopicService,
		policyService,
		statutoryPaymentService,
		teamData,
		teamService,
		userData,
		utilities,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		STAT_PAYMENT_SCHEDULE_STATES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const callback = $scope.formOptions.callback;
	let scheduleId = $scope.formOptions.scheduleID;
	const userId = $scope.formOptions.userId;
	const TODAY_ISO = moment().format();

	$scope.STAT_PAYMENT_SCHEDULE_STATES = STAT_PAYMENT_SCHEDULE_STATES;
	$scope.TODAY_ISO = TODAY_ISO;

	function convertSalaryPaymentsToZeroIfEmpty (maternityPayObj) {

		if (!maternityPayObj.SalaryPayments || !maternityPayObj.SalaryPayments.length) {
			return;
		}

		maternityPayObj.SalaryPayments.forEach((paymentObj) => {
			paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfEmpty(paymentObj.PaymentAmount);
		});
	}

	function convertSalaryPaymentsToEmptyIfZero (maternityPayObj) {

		maternityPayObj.SalaryPayments.forEach((paymentObj) => {
			paymentObj.PaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentObj.PaymentAmount);
		});
	}

	function deleteTeamMemberStatutoryPay (maternityPayObj, formObj) {

		// Delete is blocked silently (back to 'ready') rather than with the error banner used
		// elsewhere, since the Delete action shouldn't be reachable at all for a locked record.
		if (isIntegrationOwned(maternityPayObj)) {
			setPageState('ready');
			return;
		}

		formObj.state = 'saving';

		teamData.deleteTeamMemberStatutoryPay(agencyProfileId, maternityPayObj.PaymentScheduleGroupID).then(() => {

			formObj.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('deleted');
		})
		.catch((error) => {
			console.error(error);
			setPageState('error');
			formObj.state = null;
		});
	}

	function isIntegrationOwned (maternityPayObj) {

		return !!maternityPayObj.IsFromIntegration;
	}

	// Shared guard for the mutation actions below: an integration-owned record is blocked from any
	// manual mutation, surfaced as the same error state everywhere it's checked ($scope.edpTopicMessage
	// carries the reason and is rendered by the error state itself, not logged to the console).
	function guardNotIntegrationOwned (maternityPayObj) {

		if (!isIntegrationOwned(maternityPayObj)) {
			return false;
		}

		setPageState('error');

		return true;
	}

	// The EDP-sourced dates stay locked for an integration-owned record, so only the payroll-only
	// update reasons (which never touch a date) are offered; everything else is filtered out.
	function getMaternityUpdateOptions (maternityPayObj) {

		const allOptions = statutoryPaymentService.getScheduleUpdateOptions('maternity', $scope.formOptions.context);

		if (!isIntegrationOwned(maternityPayObj)) {
			return allOptions;
		}

		const payrollOnlyReasons = [SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.SalaryUpdate];

		return allOptions.filter((option) => payrollOnlyReasons.includes(option.value));
	}

	function getPayPeriodIdForUpdateReasonType (maternityPayObj) {

		switch (maternityPayObj.updateReason) {
			case SCHEDULE_UPDATE_REASONS.IsLeaving:
			case SCHEDULE_UPDATE_REASONS.Redundancy:
				return maternityPayObj.lastPaymentPeriodId;
			default:
				return;
		}
	}

	function init () {

		setPageState('loading');

		const getMaternityPay = teamData.getTeamMemberMaternitySchedulePaymentsForSchedule(agencyProfileId, userId, scheduleId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
			getMaternityPay,
			getTeamMemberInformation
		]).then(function (results) {

			const maternityPayObj = results[0];
			const teamMemberObj = results[1];

			// Update reason selected (if any) for schedule update
			angular.extend(maternityPayObj, {
				Policy: maternityPayObj.Policy ? policyService.decoratePolicy(maternityPayObj.Policy, POLICY_CATEGORIES.parental) : maternityPayObj.Policy,
				advanceFundingTotalAmount: 0,
				endDateIsoOriginal: angular.copy(maternityPayObj.EndDateISO),
				isEndDateCommsDismissed: false,
				isEndDateCommsVisible: false,
				maternityPayEligibilityDateMinIso: teamService.getTeamMemberEarliestStartDateIso(teamMemberObj),
				reviewScheduleView: 'payments',
				updateReason: null
			});

			// Clear out salary payments values to force entry
			convertSalaryPaymentsToEmptyIfZero(maternityPayObj);

			// Calculate Advance Funding
			if (maternityPayObj.AdvanceFunding.length) {
				maternityPayObj.AdvanceFunding.forEach((advanceFundingPayment) => {
					maternityPayObj.advanceFundingTotalAmount += advanceFundingPayment.PaymentAmount;
				});
			}

			// Set up pending pay periods if update is made requiring a pay period
			maternityPayObj.pendingPayments = statutoryPaymentService.getPendingPaymentsForSchedule(maternityPayObj);
			maternityPayObj.lastPaymentPeriodId = null;

			// Save original values for propetries so that they can be used once schedule has been updated
			angular.extend($scope, {
				canBeDeletedOriginal: maternityPayObj.CanBeDeleted,
				canBeExtendedOriginal: maternityPayObj.CanBeExtended,
				canCancelExtensionOriginal: maternityPayObj.CanCancelExtension,
				canUndoUpdateInProgressOriginal: maternityPayObj.CanUndoUpdateInProgress,
				canUpdateInProgressOriginal: maternityPayObj.CanUpdateInProgress,
				edpTopicMessage: maternityPayObj.IsFromIntegration ? edpTopicService.getPaymentScheduleMessage(edpTopicService.TOPIC_KEYS.maternity) : '',
				isExtendedOriginal: maternityPayObj.IsExtended,
				isUpdatedOriginal: maternityPayObj.IsUpdated,
				MATERNITY_UPDATE_OPTIONS: getMaternityUpdateOptions(maternityPayObj)
			});

			$scope.maternityPay = maternityPayObj;
			$scope.teamMember = teamMemberObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onExtendScheduleClick (maternityPayObj) {

		if (guardNotIntegrationOwned(maternityPayObj)) {
			return;
		}

		setPageState('loading');

		convertSalaryPaymentsToZeroIfEmpty(maternityPayObj);

		teamData.getTeamMemberMaternitySchedulePaymentsForScheduleUpdate(agencyProfileId, userId, maternityPayObj).then((updatedMaternityPayObj) => {

			angular.extend(maternityPayObj, updatedMaternityPayObj);

			setPageState('extend-schedule');

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function onUpdateScheduleClick (maternityPayObj) {

		// Reachable for an integration-owned record too: the reason dropdown it opens is
		// already filtered down to the payroll-only reasons for those records (see init()).
		setPageState('loading');

		convertSalaryPaymentsToZeroIfEmpty(maternityPayObj);

		teamData.getTeamMemberMaternitySchedulePaymentsForScheduleUpdate(agencyProfileId, userId, maternityPayObj).then((updatedMaternityPayObj) => {

			angular.extend(maternityPayObj, updatedMaternityPayObj);

			maternityPayObj.updateReason = null;

			setPageState('update-in-progress-schedule');	

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function openAdvanceMaternityFundingForm (maternityScheduleId) {

		// Advance funding is HMRC financial data, not EDP-sourced, so it stays editable
		// regardless of provenance.
		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'advance-maternity-funding',
			maternityScheduleId: maternityScheduleId,
			userId: userId
		});
	}

	function openEditMaternityPayForm (maternityPayObj) {

		// Reachable for an integration-owned record too: maternityPayForm keeps the EDP-sourced
		// dates read-only while leaving the rest of the wizard editable (see maternityPayForm.js).
		$scope.formOptions.openNewSlideInForm({
			formKey: 'maternity-pay',
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			scheduleId: maternityPayObj.PaymentScheduleGroupID,
			userId: userId
		});
	}

	function setIsEndDateCommsVisible (maternityPayObj, isEndDateCommsVisible, isEndDateCommsDismissed) {

		// Ignore once dismissed
		if (maternityPayObj.isEndDateCommsDismissed) {
			return;
		}

		// Update dismissed if set
		if (angular.isDefined(isEndDateCommsDismissed)) {
			maternityPayObj.isEndDateCommsDismissed = isEndDateCommsDismissed;
		}

		maternityPayObj.isEndDateCommsVisible = isEndDateCommsVisible;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateTeamMemberMaternityScheduleInProgress (maternityPayObj, formObj, updateKey) {

		// The 'extend-schedule' updateKey is only reachable via onExtendScheduleClick, which still
		// guards integration-owned records; the reason-driven path is UI-filtered in init() instead.
		formObj.state = 'saving';

		let agencyPayPeriodId = getPayPeriodIdForUpdateReasonType(maternityPayObj);

		convertSalaryPaymentsToZeroIfEmpty(maternityPayObj);

		if (updateKey === 'extend-schedule') {
			maternityPayObj.updateReason = SCHEDULE_UPDATE_REASONS.CorrectEndDate;
		}

		teamData.updateTeamMemberMaternityScheduleInProgress(agencyProfileId, userId, maternityPayObj, agencyPayPeriodId, maternityPayObj.updateReason).then((updatedMaternityPayObj) => {

			formObj.state = 'saved';

			angular.extend(maternityPayObj, updatedMaternityPayObj);

			switch (updateKey) {
				case 'extend-schedule':
					setPageState('confirm-extend-schedule');
					break;

				default:
					setPageState('ready');
					break;
			}
		})
		.catch((error) => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberMaternityScheduleInProgressReset (maternityPayObj, formObj) {

		formObj.state = 'saving';

		teamData.updateTeamMemberMaternityScheduleInProgressReset(agencyProfileId, userId, maternityPayObj.PaymentScheduleGroupID).then(() => {

			formObj.state = 'saved';

			// The reset API saves the restored schedule, so use callback to tell underlying page to update
			$scope.formOptions.callback();

			init();
		})
		.catch((error) => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberMaternitySchedulePayments (maternityPayObj, formObj) {

		// Shared by the update-in-progress "Save & finish" (UI-filtered to payroll-only reasons for
		// an integration-owned record) and the extend-schedule confirm (still guarded at
		// onExtendScheduleClick, so unreachable here for a locked record).
		formObj.state = 'saving';

		convertSalaryPaymentsToZeroIfEmpty(maternityPayObj);

		teamData.updateTeamMemberMaternitySchedulePayments(userId, agencyProfileId, maternityPayObj).then(maternityPayObj => {

			formObj.state = 'saved';

			$scope.maternityPay = maternityPayObj;
			$scope.newScheduleSaved = true;

			// A not-started schedule is persisted by delete-and-recreate, so it comes back with a new
			// PaymentScheduleGroupID. Re-point scheduleId at it before init() reloads, otherwise the
			// reload fetches the deleted group and shows a blank, no-longer-integration-owned record.
			// For in-place updates (started save & finish, extend) this is the same id, so it's a no-op.
			scheduleId = maternityPayObj.PaymentScheduleGroupID;

			$scope.formOptions.callback();

			init();
		})
		.catch(error => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberSchedulePaymentsProRatingMethod (maternityPayObj, formObj) {

		// Pro-ration method is a payroll-only setting, not EDP-sourced data, so it stays
		// editable regardless of provenance.
		formObj.state = 'saving';

		userData.updateTeamMemberSchedulePaymentsProRatingMethod(maternityPayObj.PaymentScheduleGroupID, maternityPayObj.ProRatingMethod).then(() => {

			setPageState('ready');
			formObj.state = 'saved';
		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	init();

	angular.extend($scope, {
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		deleteTeamMemberStatutoryPay,
		init,
		onExtendScheduleClick,
		onUpdateScheduleClick,
		openAdvanceMaternityFundingForm,
		openEditMaternityPayForm,
		setIsEndDateCommsVisible,
		setPageState,
		updateTeamMemberMaternityScheduleInProgress,
		updateTeamMemberMaternityScheduleInProgressReset,
		updateTeamMemberMaternitySchedulePayments,
		updateTeamMemberSchedulePaymentsProRatingMethod
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('movePayrollsForm', () => {

	return {
		controller: 'movePayrollsFormCtrl',
		templateUrl: 'forms/payroll/move-payrolls/move-payrolls.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('movePayrollsFormCtrl', [
	'$scope',
	'$state',
	'companyData',
	'userData',
	'INTERFACE_TYPES',
	'PAY_PERIOD_TYPES_OPTIONS',
	'PAYROLL_MOVE_VALID_STATUSES',
	function (
		$scope,
		$state,
		companyData,
		userData,
		INTERFACE_TYPES,
		PAY_PERIOD_TYPES_OPTIONS,
		PAYROLL_MOVE_VALID_STATUSES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	const MOVE_PAYROLL_PAGE_STATES = {
		success: 'success',
		confirmMove: 'confirm-move',
		error: 'error',
		loading: 'loading',
		moveInvalid: 'move-invalid',
		noCompaniesWithSamePAYEScheme: 'no-companies-with-same-paye-scheme',
		selectCompany: 'select-company'
	};

	let parentBureauAgencyProfileId;

	function closeForm() {
		$scope.formOptions.closeForm();
		$state.go('team.moved-payrolls', {
			agencyProfileId: agencyProfileId
		});
	}

	function init () {

		setPageState(MOVE_PAYROLL_PAGE_STATES.loading);

		const INCLUDE_TARGET_PROFILE = false;

		// Get company bureau info, required to get companies on same PAYE scheme
		companyData.getAgencyProfileAgencyProfilesForChild(agencyProfileId, INTERFACE_TYPES.bureau).then(parentBureauInfo => {
			parentBureauAgencyProfileId = parentBureauInfo[0].AgencyProfileID;

			companyData.getPayrollsOnSamePAYEScheme(agencyProfileId, parentBureauAgencyProfileId, INCLUDE_TARGET_PROFILE).then(payrollInfoArr => {

				if (payrollInfoArr.length > 0) {
					// Pull out the required info from the payroll info array
					let companies = [];
					payrollInfoArr.forEach(payrollInfo => {
						let payPeriodType = PAY_PERIOD_TYPES_OPTIONS.find(payPeriodType => {
							return payPeriodType.id === payrollInfo.PayPeriod.PayPeriodType;
						});
						companies.push({
							AgencyProfileID: payrollInfo.Company.AgencyProfileID,
							CompanyName: payrollInfo.Company.Name,
							PayrollFrequency: payPeriodType.name
						});
					});
					$scope.companies = companies;
					setPageState(MOVE_PAYROLL_PAGE_STATES.selectCompany);
					$scope.vm = {
						selectedCompany: null
					};
				}
				else {
					setPageState(MOVE_PAYROLL_PAGE_STATES.noCompaniesWithSamePAYEScheme);
				}
			});
		})
		.catch(onError);
	}

	function moveToNextStep (pageState, vmObj, form) {
		switch (pageState) {
			case (MOVE_PAYROLL_PAGE_STATES.selectCompany): {
				setPageState(MOVE_PAYROLL_PAGE_STATES.loading);
				userData.assessIsValidPayrollMove(userId, agencyProfileId, vmObj.selectedCompany.AgencyProfileID).then(payrollMoveValid => {

					if (payrollMoveValid === PAYROLL_MOVE_VALID_STATUSES.IsValid) {
						setPageState(MOVE_PAYROLL_PAGE_STATES.confirmMove);
					}
					else {
						vmObj.invalidMoveReason = payrollMoveValid;
						setPageState(MOVE_PAYROLL_PAGE_STATES.moveInvalid);
					}
				});
				break;
			}
			case (MOVE_PAYROLL_PAGE_STATES.confirmMove): {
				form.state = 'saving';
				userData.userPayrollMove(userId, agencyProfileId, vmObj.selectedCompany.AgencyProfileID).then(() => {
					setPageState(MOVE_PAYROLL_PAGE_STATES.success);
					form.state = 'saved';
				})
				.catch(onError);
				break;
			}
		}
	}

	function onError (error) {
		console.error(error);
		setPageState(MOVE_PAYROLL_PAGE_STATES.error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		// Constants
		MOVE_PAYROLL_PAGE_STATES,
		PAYROLL_MOVE_VALID_STATUSES,

		// Functions
		closeForm,
		moveToNextStep,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('niCategoryUpdatesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'niCategoryUpdatesFormCtrl',
	templateUrl: 'forms/payroll/niCategoryUpdates/ni-category-updates.form.html'
})

.controller('niCategoryUpdatesFormCtrl', ['payrollData',
	function (payrollData) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		payrollData.getTeamMembersWithNICodeUpdates($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId)
			.then(teamMembersArr => {

				angular.extend($ctrl, {
					niUpdatesCount: 0,
					teamMembers: teamMembersArr.filter(decorateTeamMembers)
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function decorateTeamMembers (teamMemberObj) {

		teamMemberObj.UpdateAccepted = false;

		return teamMemberObj;
	}

	function onError (error) {

		setComponentState('error');
		console.error(error);
	}

	function updateTeamMembersNICodes ($ctrl, formObj) {

		formObj.state = 'saving';

		payrollData.updateTeamMembersNICodes($ctrl.formOptions.agencyProfileId, $ctrl.teamMembers).then(() => {

			$ctrl.formOptions.forceCallback();

			setComponentState('saved');
		})
		.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	function updateNiUpdatesCount ($ctrl) {
		$ctrl.niUpdatesCount = $ctrl.teamMembers.filter(teamMemberObj => teamMemberObj.UpdateAccepted).length;
	}

	angular.extend($ctrl, {
		$onInit,

		updateNiUpdatesCount,
		updateTeamMembersNICodes,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('onHoldForm', function () {

	return {
		controller: 'onHoldFormCtrl',
		templateUrl: 'forms/payroll/onHold/onHoldForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('onHoldFormCtrl', ['$scope', 'companyData', 'userData', 'utilities',
	function ($scope, companyData, userData, utilities) {

	const CONTEXTS = {
		bulkOnHold: 'bulk-on-hold',
		bulkActive: 'bulk-active',
		individualOnHold: 'individual-on-hold',
		individualActive: 'individual-active'
	};

	const ON_HOLD_TYPES = {
		indefinite: 'indefinite',
		periodCount: 'period-coint'
	};

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const isOnHold = $scope.formOptions.isOnHold;
	const userId = $scope.formOptions.userId;
	const userIds = $scope.formOptions.userIds;

	function agreeTerms (vmObj) {
		vmObj.isConfirmed = true;
	}

	function focusOnPeriodCount () {
		utilities.focusOn('onHoldPeriodCount');
	}

	function getContextForForm (userIds) {

		// Bulk
		if (angular.isDefined(userIds)) {

			return isOnHold ? CONTEXTS.bulkOnHold : CONTEXTS.bulkActive;
		}

		return isOnHold ? CONTEXTS.individualOnHold : CONTEXTS.individualActive;
	}

	function init () {

		const contextKey = getContextForForm(userIds);

		$scope.vm = {
			context: contextKey,
			isOnHold: isOnHold,
			onHoldType: ON_HOLD_TYPES.indefinite,
			onHoldPeriodCount: null,
			userId: userId,
			userIds: userIds
		};

		// Doesn't require confirmation
		if ([CONTEXTS.individualOnHold, CONTEXTS.bulkOnHold].includes(contextKey)) {
			agreeTerms($scope.vm);
		}

		setPageState('ready');
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateOnHoldStatus (vmObj, formObj) {

		formObj.state = 'saving';

		// Set on hold flag
		vmObj.isOnHold = !vmObj.isOnHold;

		// Transform individual UserID into userId's array
		if ([CONTEXTS.individualOnHold, CONTEXTS.individualActive].includes(vmObj.context)) {
			vmObj.userIds = [userId];
		}

		// Reset period count if indefinite
		if (vmObj.onHoldType === ON_HOLD_TYPES.indefinite) {
			vmObj.onHoldPeriodCount = -1;
		}

		// Reset period count when marking as active
		if (!vmObj.isOnHold) {
			vmObj.onHoldPeriodCount = 0;
		}

		userData.updateUserAgencyProfilesOnHold(agencyProfileId, vmObj.userIds, vmObj.isOnHold, vmObj.onHoldPeriodCount).then(() => {

			$scope.formOptions.forceCallback();

			formObj.state = 'saved';

			setPageState('success');
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		CONTEXTS,
		ON_HOLD_TYPES,

		agreeTerms,
		focusOnPeriodCount,
		updateOnHoldStatus,
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('paternityPayForm', function () {

	return {
		controller: 'paternityPayFormCtrl',
		templateUrl: 'forms/payroll/paternityPay/paternityPayForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('paternityPayFormCtrl', [
	'$q',
	'$scope',
	'$timeout',
	'config',
	'policyService',
	'salaryService',
	'statutoryPaymentService',
	'teamData',
	'teamService',
	'utilities',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_TYPES',
	'PRO_RATION_METHODS',
	'STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS',
	'STATUTORY_PAY_CALCULATION_METHODS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	function (
		$q,
		$scope,
		$timeout,
		config,
		policyService,
		salaryService,
		statutoryPaymentService,
		teamData,
		teamService,
		utilities,
		ADJUSTMENT_BEHAVIOUR_STATES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_TYPES,
		PRO_RATION_METHODS,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		STATUTORY_PAY_CALCULATION_METHODS,
		STAT_PAYMENT_SCHEDULE_STATES
	) {

	// Steps. 2 and 3 are conditional and can be stepped over, depending on state.
	const PATERNITY_PAY_STEPS = {
		calculate: 1,
		enterPaymentDetails: 2,
		addSupplementaryOccupationalPaternityPay: 3,
		reviewSchedule: 4
	};
	const TOTAL_STEPS = 4;

	const TODAY_ISO = moment().format();

	const agencyProfileId	= $scope.formOptions.agencyProfileId;
	const scheduleId 		= $scope.formOptions.scheduleId;
	const userId 			= $scope.formOptions.userId;

	const isEditing 		= angular.isDefined(scheduleId) && scheduleId !== null && scheduleId !== '';

	function createNilSchedule (paternityPayObj) {

		angular.extend(paternityPayObj, {
			isPaymentStepIgnored: getIsPaymentStepIgnored(paternityPayObj)
		});

		goToNextStep(paternityPayObj);
		setPageState('ready');
	}

	function decoratePaternityPay (paternityPayObj, teamMemberObj) {

		angular.extend(paternityPayObj, {
			Policy: paternityPayObj.Policy ? policyService.decoratePolicy(paternityPayObj.Policy, POLICY_CATEGORIES.parental) : paternityPayObj.Policy,
			dueDateISOMax: moment().add(config.parentalDueDateMaxWeeksInFuture, 'weeks').format(),
			isEndDateCommsDismissed: false,
			isEndDateCommsVisible: false,
			isEndDateEditable: isEditing,
			isStartDateEditable: isEditing,
			paternityPayEligibilityDateMinIso: teamService.getTeamMemberEarliestStartDateIso(teamMemberObj),
			reviewScheduleView: 'payments',
			step: PATERNITY_PAY_STEPS.calculate,
		});

		return paternityPayObj;
	}

	function decorateTeamMemberObj (teamMemberObj) {

		angular.extend(teamMemberObj, {
			hasValidGrossSalary: salaryService.getHasValidGrossSalary(teamMemberObj.Salary)
		});

		return teamMemberObj;
	}

	function getIsPaymentStepIgnored (paternityPayObj) {

		// Ignore payment details step
		return statutoryPaymentService.getIsEligibilityIndependentOfEarnings(paternityPayObj.TeamMemberPaternityStatus);
	}

	function getPaternityDateBoundaries (paternityPayObj) {

		angular.extend(paternityPayObj, {
			isStartDateEditable: false,
			isEndDateEditable: false
		});

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternityDates(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				EndDateMinISO: updatedPaternityPayObj.EndDateMinISO,
				EndDateMaxISO: updatedPaternityPayObj.EndDateMaxISO,
				StartDateMinISO: updatedPaternityPayObj.StartDateMinISO,
				StartDateMaxISO: updatedPaternityPayObj.StartDateMaxISO,
				TeamMemberPaternityStatus: updatedPaternityPayObj.TeamMemberPaternityStatus,
				isStartDateEditable: true
			});

			const pageState = statutoryPaymentService.getPageStateForStatus(paternityPayObj.TeamMemberPaternityStatus);

			setPageState(pageState);

			utilities.focusOn('startdate');
		})
		.catch(onError);
	}

	function getPaternitySalaryPayments (paternityPayObj, formObj) {

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternitySalaryPayments(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				EndDateISO: updatedPaternityPayObj.EndDateISO,
				EndDateMaxISO: updatedPaternityPayObj.EndDateMaxISO,
				IsHistoricSchedule: updatedPaternityPayObj.IsHistoricSchedule,
				IsInProgressSchedule: updatedPaternityPayObj.IsInProgressSchedule,
				SalaryPayments: updatedPaternityPayObj.SalaryPayments,
				TeamMemberPaternityStatus: updatedPaternityPayObj.TeamMemberPaternityStatus,
				TeamMemberPaternityErrors: updatedPaternityPayObj.TeamMemberPaternityErrors,
				isPaymentStepIgnored: updatedPaternityPayObj.IsHistoricSchedule && paternityPayObj.IsPaidInFull,

				// Policy step is ignored if there are no policies, or if the schedule is historic
				isPoliciesApplicable: !updatedPaternityPayObj.IsHistoricSchedule && updatedPaternityPayObj.CanUsePolicy
			});

			// Empty zero payments
			statutoryPaymentService.convertSalaryPaymentsToEmptyIfZero(paternityPayObj);

			// If payments aren't required, go straight to overview
			if (paternityPayObj.isPaymentStepIgnored) {
				getPaternitySchedulePayments(paternityPayObj, formObj);
				return;
			}

			const pageState = statutoryPaymentService.getPageStateForStatus(paternityPayObj.TeamMemberPaternityStatus);

			if (pageState === 'ready') {
				goToNextStep(paternityPayObj);
			}
			else {
				setPageState(pageState);
			}
		})
		.catch(onError);
	}

	function getPaternitySchedulePayments (paternityPayObj) {

		paternityPayObj.loadingStateSchedulePayments = 'loading';

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternitySchedulePayments(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				IsPaidInFull: updatedPaternityPayObj.IsPaidInFull,
				PaidInFullPayDateISO: updatedPaternityPayObj.PaidInFullPayDateISO,
				SchedulePayments: updatedPaternityPayObj.SchedulePayments,
				StartPayPeriodDisplay: updatedPaternityPayObj.StartPayPeriodDisplay,
				TeamMemberPaternityStatus: updatedPaternityPayObj.TeamMemberPaternityStatus,
				TeamMemberPaternityErrors: updatedPaternityPayObj.TeamMemberPaternityErrors,
				TotalAmount: updatedPaternityPayObj.TotalAmount,
				TotalAmountPaid: updatedPaternityPayObj.TotalAmountPaid,
				TotalAmountRemaining: updatedPaternityPayObj.TotalAmountRemaining,
				TotalBroughtForward: updatedPaternityPayObj.TotalBroughtForward,
				loadingStateSchedulePayments: 'ready',
				step: PATERNITY_PAY_STEPS.reviewSchedule,
			});
		})
		.catch(onError);
	}

	function getPaternityPolicies (vmObj, paternityPayObj) {

		const deferred = $q.defer();

		// Policies aren't relevant
		if (!paternityPayObj.CanUsePolicy) {
			deferred.resolve();
			return deferred.promise;
		}

		// Policy not used
		if (!paternityPayObj.UsePolicy) {
			deferred.resolve();
			return deferred.promise;
		}

		// Policies have already been loaded
		if (vmObj.paternityPolicies.length > 0) {
			deferred.resolve();
			return deferred.promise;
		}

		policyService.getPoliciesForType(agencyProfileId, POLICY_TYPES.paternity).then(paternityPoliciesArr => {

			deferred.resolve(paternityPoliciesArr);
		})
		.catch(error => {
			deferred.reject(error);
		});

		return deferred.promise;
	}

	function goToNextStep (paternityPayObj) {
		progressStep(paternityPayObj, +1);
	}

	function goToPreviousStep (paternityPayObj) {
		progressStep(paternityPayObj, -1);
	}

	function goToStep (paternityPayObj, step) {
		paternityPayObj.step = step;
	}

	function init () {

		setPageState('loading');

		const getPaternityPay = teamData.getTeamMemberPaternityPay(userId, agencyProfileId, scheduleId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
			getPaternityPay,
			getTeamMemberInformation
		]).then(([
			paternityPayObj,
			teamMemberObj
		]) => {

			angular.extend($scope, {
				paternityPay: decoratePaternityPay(paternityPayObj, teamMemberObj),
				teamMember: decorateTeamMemberObj(teamMemberObj),
				vm: {
					loadingStatePolicies: 'ready',
					paternityPolicies: []
				}
			});

			setPaternityDatesState($scope.paternityPay, 'ready');
			setPageState('ready');

			// When creating new schedule, focus on first field
			if (!isEditing) {
				$timeout(() => {
					utilities.focusOn('duedate');
				}, 200);
			}
		})
		.catch(onError);
	}

	function onChangePaternityPayBirthDate (paternityPayObj) {

		// Reset values
		angular.extend(paternityPayObj, {
			EndDateISO: '',
			StartDateISO: '',
			isEndDateEditable: false,
			isStartDateEditable: false
		});

		setPaternityDatesState(paternityPayObj, null);

		utilities.focusOn('startdate');
	}

	function onChangePaternityPayEndDate (paternityPayObj) {

		setPaternityDatesState(paternityPayObj, 'loading');

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternityDates(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				IsInProgressSchedule: updatedPaternityPayObj.IsInProgressSchedule,
				IsHistoricSchedule: updatedPaternityPayObj.IsHistoricSchedule,
			});

			resetPaymentsBroughtForward(paternityPayObj);

			setPaternityDatesState(paternityPayObj, 'ready');
		})
		.catch(onError);
	}

	function onChangePaternityPayStartDate (paternityPayObj) {

		setPaternityDatesState(paternityPayObj, 'loading');

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternityDates(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				EndDateISO: updatedPaternityPayObj.EndDateISO,
				EndDateMinISO: updatedPaternityPayObj.EndDateMinISO,
				EndDateMaxISO: updatedPaternityPayObj.EndDateMaxISO,
				IsInProgressSchedule: updatedPaternityPayObj.IsInProgressSchedule,
				IsHistoricSchedule: updatedPaternityPayObj.IsHistoricSchedule,
				isEndDateEditable: true
			});

			resetPaymentsBroughtForward(paternityPayObj);

			setPaternityDatesState(paternityPayObj, 'ready');

			utilities.focusOn('enddate');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onSelectPaternityPolicy (paternityPayObj, teamMemberObj) {

		validatePayPolicy(paternityPayObj, teamMemberObj);
	}

	function onUsePolicyChange (vmObj, paternityPayObj) {

		vmObj.loadingStatePolicies = 'loading';

		getPaternityPolicies(vmObj, paternityPayObj).then(payPoliciesArr => {

			// No need to update if not changed
			if (angular.isDefined(payPoliciesArr)) {
				vmObj.paternityPolicies = payPoliciesArr;
			}

			vmObj.loadingStatePolicies = 'ready';
		})
		.catch(onError);
	}

	function onUsePolicyInit (vmObj, paternityPayObj, teamMemberObj) {

		// Review whether pay policies are required
		onUsePolicyChange(vmObj, paternityPayObj);

		// Review whether pay policy is applied
		onSelectPaternityPolicy(paternityPayObj, teamMemberObj);
	}

	/*
	 * Move forward or back a step. stepCount can be +ve or -ve; it'll always be interpreted as +ve (forward one) or -ve (back one), keeping
	 * within the bounds of the available steps. It will also decide whether a step is valid and, if it isn't, it'll recall this function to
	 * move over it. That in turn could be skipped, etc.
	 */
	function progressStep (paternityPayObj, stepDirection) {

		const stepJump = Math.sign(stepDirection);

		// Don't pander to idiocy
		if (stepJump === 0) {
			return;
		}

		// Get the next step
		let nextStep = paternityPayObj.step + stepJump;

		// Say within bounds
		if (nextStep < 1) {
			nextStep = 1;
		}
		if (nextStep > TOTAL_STEPS) {
			nextStep = TOTAL_STEPS;
		}

		// Set that and decide whether, under the current circumstances, it's a valid step for the user to see
		paternityPayObj.step = nextStep;

		// Jump non-applicable steps in whichever direction we're travelling in
		if (paternityPayObj.step === PATERNITY_PAY_STEPS.addSupplementaryOccupationalPaternityPay && (paternityPayObj.IsHistoricSchedule || !paternityPayObj.CanUsePolicy)) {
			// Policy step not applicable for historic schedules, or when there are no policies to choose from
			progressStep(paternityPayObj, stepDirection);
		}
		else if (paternityPayObj.step === PATERNITY_PAY_STEPS.enterPaymentDetails && paternityPayObj.isPaymentStepIgnored) {
			// Payment step not applicable
			progressStep(paternityPayObj, stepDirection);
		}

		// Jump non-applicable steps in whichever direction we're travelling in
		switch (paternityPayObj.step) {

			// Policy step not applicable for historic schedules, or when there are no policies to choose from
			case PATERNITY_PAY_STEPS.addSupplementaryOccupationalPaternityPay:

				if (!paternityPayObj.isPoliciesApplicable) {
					progressStep(paternityPayObj, stepDirection);
				}

				break;

			case PATERNITY_PAY_STEPS.enterPaymentDetails:

				if (paternityPayObj.isPaymentStepIgnored) {
					progressStep(paternityPayObj, stepDirection);
				}

				break;
		}
	}

	function resetPaymentsBroughtForward (paternityPayObj) {

		angular.extend(paternityPayObj, {
			AmountBroughtForwardMethod: STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount,
			HasAmountBroughtForward: false,
			PaymentsBroughtForward: [],
			TotalBroughtForward: ''
		});
	}

	function reviewBroughtForwardMethod (paternityPayObj) {

		if (paternityPayObj.AmountBroughtForwardMethod === STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount) {

			angular.extend(paternityPayObj, {
				PaymentsBroughtForward: [],
				TotalBroughtForward: ''
			});
		}
		else {

			angular.extend(paternityPayObj, {
				paymentsBroughtForwardState: 'loading',
				TotalBroughtForward: 0
			});

			reviewEmptyValues(paternityPayObj);

			teamData.getTeamMemberPaternityDetailsBroughtForward(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

				angular.extend(paternityPayObj, {
					PaymentsBroughtForward: updatedPaternityPayObj.PaymentsBroughtForward
				});

				statutoryPaymentService.convertBroughtForwardPaymentsToEmptyIfZero(paternityPayObj);

				if (!updatedPaternityPayObj.PaymentsBroughtForward || updatedPaternityPayObj.PaymentsBroughtForward.length === 0) {
					paternityPayObj.paymentsBroughtForwardState = 'empty';
					return;
				}

				paternityPayObj.paymentsBroughtForwardState = 'ready';
			})
			.catch((error) => {
				onError(error);
				paternityPayObj.paymentsBroughtForwardState = null;
			});
		}
	}

	function reviewEmptyValues (paternityPayObj) {

		statutoryPaymentService.convertBroughtForwardPaymentsToZeroIfEmpty(paternityPayObj);
		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		paternityPayObj.TotalBroughtForward = utilities.setPropertyValueToZeroIfEmpty(paternityPayObj.TotalBroughtForward);
	}

	function reviewPaternitySchedulePayments (paternityPayObj, formObj) {

		formObj.state = 'saving';

		reviewEmptyValues(paternityPayObj);

		teamData.getTeamMemberPaternitySchedulePayments(userId, agencyProfileId, paternityPayObj).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				IsPaidInFull: updatedPaternityPayObj.IsPaidInFull,
				PaidInFullPayDateISO: updatedPaternityPayObj.PaidInFullPayDateISO,
				SchedulePayments: updatedPaternityPayObj.SchedulePayments,
				StartPayPeriodDisplay: updatedPaternityPayObj.StartPayPeriodDisplay,
				TeamMemberPaternityStatus: updatedPaternityPayObj.TeamMemberPaternityStatus,
				TeamMemberPaternityErrors: updatedPaternityPayObj.TeamMemberPaternityErrors,
				TotalAmount: updatedPaternityPayObj.TotalAmount,
				TotalAmountPaid: updatedPaternityPayObj.TotalAmountPaid,
				TotalAmountRemaining: updatedPaternityPayObj.TotalAmountRemaining,
				TotalBroughtForward: updatedPaternityPayObj.TotalBroughtForward,
			});

			formObj.state = 'saved';

			// Check for errors and set the page state based on the response
			setPageState(statutoryPaymentService.getPageStateForStatus(paternityPayObj.TeamMemberPaternityStatus));

			// Move to next step if all ok
			if (paternityPayObj.TeamMemberPaternityStatus === STAT_PAYMENT_SCHEDULE_STATES.ready) {
				goToNextStep(paternityPayObj);
			}
		})
		.catch(onError);
	}

	function setIsEndDateCommsVisible (paternityPayObj, isEndDateCommsVisible, isEndDateCommsDismissed) {

		// Ignore once dismissed
		if (paternityPayObj.isEndDateCommsDismissed) {
			return;
		}

		// Update dismissed if set
		if (angular.isDefined(isEndDateCommsDismissed)) {
			paternityPayObj.isEndDateCommsDismissed = isEndDateCommsDismissed;
		}

		paternityPayObj.isEndDateCommsVisible = isEndDateCommsVisible;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setPaternityDatesState (paternityPayObj, paternityDatesState) {

		paternityPayObj.paternityDatesState = paternityDatesState;
	}

	function updatePaternityDates (paternityPayObj) {

		goToStep(paternityPayObj, 1);
	}

	function updateTeamMemberPaternitySchedulePayments (paternityPayObj, form) {

		form.state = 'saving';

		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		teamData.updateTeamMemberPaternitySchedulePayments(userId, agencyProfileId, paternityPayObj).then(() => {

			form.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('success');
		})
		.catch(onError);
	}

	function validatePayPolicy (paternityPayObj, teamMemberObj) {

		// Get selected policy for convenience
		let paternityPolicy = paternityPayObj.Policy;

		// If set, do some validation
		if (paternityPolicy) {

			// Selection OK by default
			angular.extend(paternityPolicy, {
				isValid: true,
				noAnnualSalarySaved: false
			});

			/* "% of annual salary" policies require a valid salary */
			if (paternityPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalaryPercent && !teamMemberObj.hasValidGrossSalary) {

				angular.extend(paternityPolicy, {
					isValid: false,
					noAnnualSalarySaved: true
				});
			}
		}
	}

	init();

	angular.extend($scope, {

		// Constants
		ADJUSTMENT_BEHAVIOUR_STATES,
		PATERNITY_PAY_STEPS,
		POLICY_PAY_BASES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		STAT_PAYMENT_SCHEDULE_STATES,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		STATUTORY_PAY_CALCULATION_METHODS,
		TODAY_ISO,

		// Services
		policyService,
		utilities,

		// Functions
		createNilSchedule,
		getIsStatPaymentSalarySacrificeReadOnly: statutoryPaymentService.getIsStatPaymentSalarySacrificeReadOnly,
		getPaternityDateBoundaries,
		getPaternitySalaryPayments,
		getPaternitySchedulePayments,
		goToNextStep,
		goToPreviousStep,
		goToStep,
		onChangePaternityPayBirthDate,
		onChangePaternityPayStartDate,
		onChangePaternityPayEndDate,
		onSelectPaternityPolicy,
		onUsePolicyChange,
		onUsePolicyInit,
		reviewBroughtForwardMethod,
		reviewPaternitySchedulePayments,
		reviewStatPaymentSalarySacrifice: statutoryPaymentService.reviewStatPaymentSalarySacrifice,
		setIsEndDateCommsVisible,
		setPageState,
		updatePaternityDates,
		updateTeamMemberPaternitySchedulePayments
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('paternityPayViewForm', function () {

	return {
		controller: 'paternityPayViewFormCtrl',
		templateUrl: 'forms/payroll/paternityPay/paternityPayViewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('paternityPayViewFormCtrl', [
	'$q',
	'$scope',
	'edpTopicService',
	'policyService',
	'statutoryPaymentService',
	'teamData',
	'teamService',
	'userData',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'PRO_RATION_METHODS',
	'SCHEDULE_UPDATE_REASONS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	function (
		$q,
		$scope,
		edpTopicService,
		policyService,
		statutoryPaymentService,
		teamData,
		teamService,
		userData,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		STAT_PAYMENT_SCHEDULE_STATES
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const callback = $scope.formOptions.callback;
	let scheduleId = $scope.formOptions.scheduleID;
	const userId = $scope.formOptions.userId;
	const TODAY_ISO = moment().format();

	$scope.STAT_PAYMENT_SCHEDULE_STATES = STAT_PAYMENT_SCHEDULE_STATES;
	$scope.TODAY_ISO = TODAY_ISO;

	function isIntegrationOwned (paternityPayObj) {

		return !!paternityPayObj.IsFromIntegration;
	}

	function guardNotIntegrationOwned (paternityPayObj) {

		if (!isIntegrationOwned(paternityPayObj)) {
			return false;
		}

		setPageState('error');

		return true;
	}

	function getPaternityUpdateOptions (paternityPayObj) {

		const allOptions = statutoryPaymentService.getScheduleUpdateOptions('paternity', $scope.formOptions.context);

		if (!isIntegrationOwned(paternityPayObj)) {
			return allOptions;
		}

		const payrollOnlyReasons = [SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.SalaryUpdate];

		return allOptions.filter((option) => payrollOnlyReasons.includes(option.value));
	}

	function deletePaternityPay (paternityPay, form) {

		if (isIntegrationOwned(paternityPay)) {
			setPageState('ready');
			return;
		}

		form.state = 'saving';

		teamData.deleteTeamMemberStatutoryPay(agencyProfileId, paternityPay.PaymentScheduleGroupID).then(function () {

			form.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('deleted');
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		const getPaternityPay = teamData.getTeamMemberPaternitySchedulePaymentsForSchedule(agencyProfileId, userId, scheduleId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
			getPaternityPay,
			getTeamMemberInformation
		]).then(([
			paternityPayObj,
			teamMemberObj
		]) => {

			angular.extend(paternityPayObj, {
				Policy: paternityPayObj.Policy ? policyService.decoratePolicy(paternityPayObj.Policy, POLICY_CATEGORIES.parental) : paternityPayObj.Policy,
				endDateIsoOriginal: angular.copy(paternityPayObj.EndDateISO),
				isEndDateCommsDismissed: false,
				isEndDateCommsVisible: false,
				isInProgressUpdate: false, // To differentiate between state change and server update when updating 'in-progress' schedules
				paternityPayEligibilityDateMinIso: teamService.getTeamMemberEarliestStartDateIso(teamMemberObj),
				pendingPayments: statutoryPaymentService.getPendingPaymentsForSchedule(paternityPayObj),
				reviewScheduleView: 'payments'
			});

			// Save original values for properties so that they can be used once schedule has been updated
			angular.extend($scope, {
				canBeDeletedOriginal: paternityPayObj.CanBeDeleted,
				canBeExtendedOriginal: paternityPayObj.CanBeExtended,
				canCancelExtensionOriginal: paternityPayObj.CanCancelExtension,
				canUndoUpdateInProgressOriginal: paternityPayObj.CanUndoUpdateInProgress,
				canUpdateInProgressOriginal: paternityPayObj.CanUpdateInProgress,
				edpTopicMessage: paternityPayObj.IsFromIntegration ? edpTopicService.getPaymentScheduleMessage(edpTopicService.TOPIC_KEYS.paternity) : '',
				isExtendedOriginal: paternityPayObj.IsExtended,
				isUpdatedOriginal: paternityPayObj.IsUpdated,
				PATERNITY_UPDATE_OPTIONS: getPaternityUpdateOptions(paternityPayObj)
			});

			$scope.paternityPay = paternityPayObj;
			$scope.teamMember = teamMemberObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onExtendScheduleClick (paternityPayObj) {

		if (guardNotIntegrationOwned(paternityPayObj)) {
			return;
		}

		setPageState('loading');

		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		teamData.getTeamMemberPaternitySchedulePaymentsForScheduleUpdate(agencyProfileId, userId, paternityPayObj).then((updatedPaternityPayObj) => {

			angular.extend(paternityPayObj, updatedPaternityPayObj);

			setPageState('extend-schedule');

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function onUpdateScheduleClick (paternityPayObj) {

		setPageState('loading');

		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		teamData.getTeamMemberPaternitySchedulePaymentsForScheduleUpdate(agencyProfileId, userId, paternityPayObj).then((updatedPaternityPayObj) => {

			angular.extend(paternityPayObj, updatedPaternityPayObj);

			paternityPayObj.updateReason = null;

			setPageState('update-in-progress-schedule');	

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setIsEndDateCommsVisible (paternityPayObj, isEndDateCommsVisible, isEndDateCommsDismissed) {

		// Ignore once dismissed
		if (paternityPayObj.isEndDateCommsDismissed) {
			return;
		}

		// Update dismissed if set
		if (angular.isDefined(isEndDateCommsDismissed)) {
			paternityPayObj.isEndDateCommsDismissed = isEndDateCommsDismissed;
		}

		paternityPayObj.isEndDateCommsVisible = isEndDateCommsVisible;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updatePaternityPay (paternityPay) {

		// Reachable for an integration-owned record too: paternityPayForm keeps the EDP-sourced
		// dates read-only while leaving the rest of the wizard editable (see paternityPayForm.js).
		$scope.formOptions.openNewSlideInForm({
			formKey: 'paternity-pay',
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			scheduleId: paternityPay.PaymentScheduleGroupID,
			userId: userId
		});
	}

	function updateTeamMemberPaternityScheduleInProgress (paternityPayObj, formObj, updateKey) {

		formObj.state = 'saving';

		let agencyPayPeriodId = statutoryPaymentService.getPayPeriodIdForUpdateReasonType(paternityPayObj);

		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		if (updateKey === 'extend-schedule') {
			paternityPayObj.updateReason = SCHEDULE_UPDATE_REASONS.CorrectEndDate;
		}

		teamData.updateTeamMemberPaternityScheduleInProgress(agencyProfileId, userId, paternityPayObj, agencyPayPeriodId, paternityPayObj.updateReason).then(updatedPaternityPayObj => {

			formObj.state = 'saved';

			angular.extend(paternityPayObj, updatedPaternityPayObj);

			paternityPayObj.isInProgressUpdate = true;

			switch (updateKey) {
				case 'extend-schedule':
					setPageState('confirm-extend-schedule');
					break;

				default:
					setPageState('ready');
					break;
			}
		})
		.catch((error) => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberPaternityScheduleInProgressReset (paternityPayObj, formObj) {

		formObj.state = 'saving';

		teamData.updateTeamMemberPaternityScheduleInProgressReset(agencyProfileId, userId, paternityPayObj.PaymentScheduleGroupID).then(() => {

			formObj.state = 'saved';

			// The reset API saves the restored schedule, so use callback to tell underlying page to update
			$scope.formOptions.callback();

			init();
		})
		.catch((error) => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberPaternitySchedulePayments (paternityPayObj, formObj) {

		formObj.state = 'saving';

		statutoryPaymentService.convertSalaryPaymentsToZeroIfEmpty(paternityPayObj);

		teamData.updateTeamMemberPaternitySchedulePayments(userId, agencyProfileId, paternityPayObj, paternityPayObj.updateReason).then(updatedPaternityPayObj => {

			angular.extend(paternityPayObj, {
				SchedulePayments: updatedPaternityPayObj.SchedulePayments
			});

			angular.extend($scope, {
				newScheduleSaved: true
			});

			// A not-started schedule is persisted by delete-and-recreate, so it comes back with a new
			// PaymentScheduleGroupID. Re-point scheduleId at it before init() reloads, otherwise the
			// reload fetches the deleted group and shows a blank, no-longer-integration-owned record.
			// For in-place updates (started save & finish, extend) this is the same id, so it's a no-op.
			scheduleId = updatedPaternityPayObj.PaymentScheduleGroupID;

			$scope.formOptions.callback();

			init();

			formObj.state = 'saved';
		})
		.catch(error => {
			onError(error);
			formObj.state = null;
		});
	}

	function updateTeamMemberSchedulePaymentsProRatingMethod (paternityPayObj, formObj) {

		formObj.state = 'saving';

		userData.updateTeamMemberSchedulePaymentsProRatingMethod(paternityPayObj.PaymentScheduleGroupID, paternityPayObj.ProRatingMethod).then(() => {

			setPageState('ready');
			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		deletePaternityPay,
		init,
		onExtendScheduleClick,
		onUpdateScheduleClick,
		setIsEndDateCommsVisible,
		setPageState,
		updatePaternityPay,
		updateTeamMemberPaternityScheduleInProgress,
		updateTeamMemberPaternityScheduleInProgressReset,
		updateTeamMemberPaternitySchedulePayments,
		updateTeamMemberSchedulePaymentsProRatingMethod,
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('payStatementForm', function () {

	return {
		controller: 'payStatementFormCtrl',
		templateUrl: 'forms/payroll/payStatement/payStatementForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('payStatementFormCtrl', [
	'$filter',
	'$rootScope',
	'$scope',
	'config',
	'dataTransfer',
	'teamData',
	'userData',
	'utilities',
	'BUSINESS_TYPES',
	'INTERFACE_TYPES',
	'PAYMENT_TYPES',
	'PENSION_TYPES',
	function (
		$filter,
		$rootScope,
		$scope,
		config,
		dataTransfer,
		teamData,
		userData,
		utilities,
		BUSINESS_TYPES,
		INTERFACE_TYPES,
		PAYMENT_TYPES,
		PENSION_TYPES
	) {

	const agencyPayPeriodId = $scope.formOptions.agencyPayPeriodId;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const company = $scope.formOptions.company;
	const formState = $scope.formOptions.formState;
	/* List of team members, more akin to team member payments, this can be specified when the form has a team member corousel available,
	   i.e. when in 'history' or 'preview' modes */
	const teamMembersArr = $scope.formOptions.teamMembers;
	/* Single team member payment, specified when in 'personal' mode. This is set from the above array when in 'history' or 'preview'
	   (team carousel) modes, so can vary in those cases */
	let teamMemberPayment = $scope.formOptions.teamMemberPayment;
	// Similarly, this can vary when in 'history' or 'preview' modes, switching back and forth between users in carousel
	let userId = $scope.formOptions.userId;

	let searchBarOptions = $scope.formOptions.searchBarOptions;

	function decorateHistoryTeamMember (teamMember) {

		teamMember.PersonalDetails = {
			Forename: teamMember.Forename,
			Surname: teamMember.Surname,
			Gender: teamMember.Gender,
			UserID: teamMember.UserID,
			AvatarID: teamMember.AvatarID
		};

		return teamMember;
	}

	function decoratePayment (paymentObj, teamMemberUserId) {

		teamMemberUserId = teamMemberUserId ? teamMemberUserId : userId;

		angular.extend(paymentObj, {
			activeField: null,
			agencyPayPeriodId,
			isCompany: paymentObj.Personal.IsCISSubcontractor && (paymentObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company || paymentObj.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.trust),
			userId: teamMemberUserId
		});
		// Add text for each pension heading
		paymentObj.Pensions.forEach(pension => {
			let title = `${pension.PensionName}`;
			if (pension.EmployerReference) {
				title += ` - ${pension.EmployerReference}`;
			}
			if (pension.IsAdditionalPost) {
				title += ` (${pension.SalaryPolicyPostTitle})`;
			}
			pension.title = title;
		});

		return paymentObj;
	}

	function getPayment(userId) {

		// Is this a supplementary payment of some sort (combined or single?)
		if (teamMemberPayment.SupplementaryPaymentID && teamMemberPayment.SupplementaryPaymentID !== config.guidEmpty) {
			// Supplementary pay statement - single or combined
			return userData.getTeamMemberSupplementaryPayStatement(userId, agencyProfileId, teamMemberPayment.SupplementaryPaymentID, teamMemberPayment.UserDocumentTypeID);
		}
		else {
			// Standard pay statement.
			return userData.getTeamMemberPayStatement(agencyProfileId, userId, agencyPayPeriodId, teamMemberPayment.UserPaymentID);
		}
	}

	function loadPayStatementPersonal () {

		setPageState('loading');

		getPayment(userId).then(paymentObj => {

			// Make sure UserID is attached for payslip
			paymentObj.Personal.UserID = userId;

			$scope.payment = paymentObj;
			$scope.payStatementState = 'ready';

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function loadPayStatementHistory (userId) {

		setPageState('loading');

		getPayment(userId).then(paymentObj => {

			// Rationalise service calls to make sure each team member obj has a child PersonalDetails property
			teamMembersArr.forEach(decorateHistoryTeamMember);

			angular.extend($scope, {
				payment: paymentObj,
				teamMembers: $filter('orderBy')(teamMembersArr, searchBarOptions.orderBy, searchBarOptions.orderByReverse),
				payStatementState: 'ready'
			});

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function loadPayStatementHistoryForUser (userId) {

		setPayStatementState('loading');

		getPayment(userId).then(paymentObj => {

			// Make sure UserID is attached for payslip
			paymentObj.Personal.UserID = userId;

			$scope.payment = paymentObj;

			setPayStatementState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function loadPayStatementPreview () {

		setPageState('loading');

		angular.extend($scope, {
			teamMembers: $filter('orderBy')(teamMembersArr, searchBarOptions.orderBy, searchBarOptions.orderByReverse)
		});

		setPayStatementState('loading');
		setPageState('ready');
	}

	function loadPayStatementPreviewForUser (userId, forceCallback) {

		/* Default forceCallback to false. When set, this ensures that the parent view is refreshed *after* the
		   slide-in form, since the parent call to GetTeamMemberPayroll can result in sync issues if it's called
		   concurrently with GetTeamMemberPayrollDetailed. */
		if (angular.isUndefined(forceCallback)) {
			forceCallback = false;
		}

		setPayStatementState('loading');

		teamData.getTeamMemberPayrollDetailed(agencyProfileId , agencyPayPeriodId, userId).then(paymentsArr => {

			$scope.payment = decoratePayment(paymentsArr[0], userId);

			setPayStatementState('ready');

			// Now the slide-in form has been updated, do the callback to refresh the parent if required.
			if (forceCallback) {
				$scope.formOptions.forceCallback(userId);
			}
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function init () {

		// Can probably be centralised in a search bar service as replicating logic within the search bar component
		if (searchBarOptions && searchBarOptions.orderByOptions) {

			var storedOrderByKey = utilities.getFromStorage(searchBarOptions.storageKeys.orderBy);
			var orderByOption = utilities.getObjectFromArrayByKey(searchBarOptions.orderByOptions, storedOrderByKey);

			orderByOption = orderByOption ? orderByOption : searchBarOptions.orderByOptions[0];

			searchBarOptions.orderBy = orderByOption.field;
			searchBarOptions.orderByObj = orderByOption;
			searchBarOptions.orderByReverse = orderByOption.reverse;
		}

		switch (formState) {
			/* When showing the form for all team members (in a carousel), i.e. when 'history' or 'preview', ensure
			   the team member payment object is set for the current userId */
			case 'preview':
				setTeamMemberPayment(userId);
				loadPayStatementPreview();
				break;
			case 'history':
				setTeamMemberPayment(userId);
				loadPayStatementHistory(userId);
				break;
			case 'personal':
				loadPayStatementPersonal();
				break;
		}
	}

	function onUpdatePayStatement (payStatementObj) {

		// Refresh the pay statement preview. forceCallback = true to refresh the parent view afterwards.
		loadPayStatementPreviewForUser(payStatementObj.userId, true);
	}

	function setMember (userId) {
		// Update UserID in scope and get the corresponding team member (payment) object from the array
		$scope.userId = userId;
		setTeamMemberPayment(userId);

		switch (formState) {
			case 'preview':
				loadPayStatementPreviewForUser(userId);
				break;
			case 'history':
				loadPayStatementHistoryForUser(userId);
				break;
		}
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setPayStatementState (payStatementState) {

		$scope.payStatementState = payStatementState;
	}

	function setTeamMemberPayment (userId) {
		// Find the corresponding user in the team members array and set that as the current payment
		teamMemberPayment = teamMembersArr.find(teamMember => teamMember.UserID === userId);
		angular.extend($scope, {
			teamMemberPayment
		});
	}

	init();

	angular.extend($scope, {
		PAYMENT_TYPES,
		PENSION_TYPES,

		config,

		agencyProfileId,
		agencyPayPeriodId,
		canEditFigures: (formState === 'preview' && !company.AgencyProfileDummy) && $rootScope.currentUser.Permissions.Payroll.canEditPayStatementPreviewFigures,
		canEditPensionFigures: (formState === 'preview' && company.CompanyType !== INTERFACE_TYPES.agency) && $rootScope.currentUser.Permissions.Payroll.canEditPayStatementPreviewFigures,
		downloadFile: dataTransfer.downloadFile,
		formState,
		onUpdatePayStatement,
		setMember,
		teamMemberPayment,
		userId
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('refreshSelectedChangesForm', function () {

	return {
		controller: 'refreshSelectedChangesFormCtrl',
		templateUrl: 'forms/payroll/refreshSelectedChanges/refreshSelectedChangesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('refreshSelectedChangesFormCtrl', [
	'$scope',
	'agency', 
	function (
		$scope,
		agency
	) {

	let refreshChangesData = [];

	function init () {

		setPageState('loading');

		agency.getPayrollRefreshChangesOptions().then(function (refreshChangesOptionsResponse) {

			refreshChangesData = refreshChangesOptionsResponse.map(changeObj => {
				return {
					Value: changeObj.value,
					Key: changeObj.key,
					IsChecked: false
				};
			});

			// Update the scope variable
			$scope.refreshChangesData = refreshChangesData;
			setPageState('ready');
		})
		.catch(function (error) {
			onError(error);
		});
	}

	function refreshChanges () {

		// Close the fly out form
		$scope.formOptions.closeForm();

		// Filter the changes data to only include the checked ones
		refreshChangesData = refreshChangesData.filter(changeObj => {
			return changeObj.IsChecked;
		});

		let selectedChanges = refreshChangesData.map(changeObj => {
			return changeObj.Key;
		});

		const combinedSelectedChangesFlags = selectedChanges.reduce((acc, obj) => acc | obj, 0);

		// Call the callback function set in the parent scope and pass the combined flags of the filtered data keys
		$scope.formOptions.callback(combinedSelectedChangesFlags);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function isChecked () {

		return $scope.refreshChangesData.some(x => x.IsChecked);
	}

	init();

	angular.extend($scope, {
		isChecked,
		onError,
		refreshChanges,
		refreshChangesData
	});
}]);
'use strict';

angular.module('paycircleApp')

.directive('regenerateBacsFileForm', function () {

	return {
		controller: 'regenerateBacsFileFormCtrl',
		restrict: 'E',
		scope: {
			formOptions: '='
		},
		templateUrl: 'forms/payroll/regenerateBacsFile/regenerateBacsFileForm.html'
	};
})

.controller('regenerateBacsFileFormCtrl', ['$scope', 'payrollData', 'reportData',
	function ($scope, payrollData, reportData) {

	let formOptions = $scope.formOptions;
	let company = formOptions.company;
	let payPeriodId = formOptions.payPeriodId;
	let agencyDocumentId = formOptions.agencyDocumentId;

	function init () {

		setPageState('loading');

		payrollData.getPayPeriodSpecific(payPeriodId)
			.then(payPeriodObj => {

				$scope.payPeriod = payPeriodObj;

				setPageState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function regenerateBacs (companyObj, payPeriodObj, form) {

		form.state = 'saving';

		// Build up a set of document regeneration requests based on user-selected options
		reportData.payrollRegenerateBACS(companyObj.AgencyProfileID, agencyDocumentId).then(regenerateBacsResponse => {

			if (regenerateBacsResponse === 0) {
				form.state = 'saved';
				formOptions.forceCallback();
				formOptions.closeForm();
			}
			else {
				form.state = 'error';
			}
		})
		.catch(onError);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {

		// Variables
		company,

		// Functions
		regenerateBacs
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('regenerateDocumentsForm', function () {

	return {
		controller: 'regenerateDocumentsFormCtrl',
		restrict: 'E',
		scope: {
			formOptions: '='
		},
		templateUrl: 'forms/payroll/regenerateDocuments/regenerateDocumentsForm.html'
	};
})

.controller('regenerateDocumentsFormCtrl', ['$q', '$scope', 'reportData', function ($q, $scope, reportData) {

	let userId = $scope.formOptions.userId;
	let agencyProfileId = $scope.formOptions.agencyProfileId;

	$scope.vm = {};

	function decoratePayPeriod (payPeriodObj) {

		payPeriodObj.startDateUnix = moment(payPeriodObj.StartDateISO).format('x');
	}

	function documentTypeSelectionChanged (regenerateDocumentsOptions) {
		// Ensure at least one option is selected
		$scope.vm.selectionsAreValid = Object.keys(regenerateDocumentsOptions.documentTypes).some(key => regenerateDocumentsOptions.documentTypes[key]);
		$scope.vm.selectionsChanged = true;
	}

	function init () {

		setPageState('loading');

		reportData.getDocumentRegenerationDetails(agencyProfileId, userId).then(regenerationDetails => {

			if (!regenerationDetails.CanRegenerateP45 && !regenerationDetails.CanRegenerateP60 && (!regenerationDetails.CanRegeneratePayslips || regenerationDetails.PayslipPeriods.length === 0)) {
				setPageState('no-documents-to-regenerate');
				return;
			}

			if (!regenerationDetails.PayslipPeriods) {
				regenerationDetails.PayslipPeriods = [];
			}

			regenerationDetails.PayslipPeriods.forEach(decoratePayPeriod);

			regenerationDetails.periodsFrom = angular.copy(regenerationDetails.PayslipPeriods);
			regenerationDetails.periodsTo = angular.copy(regenerationDetails.PayslipPeriods);

			angular.extend($scope.vm, {
				regenerationDetails,
				regenerateDocumentsOptions: {
					documentTypes: {
						p45: false,
						p60: false,
						payslips: false
					},
					periodFromId: null,
					periodFrom: null,
					periodToId: null,
					periodTo: null
				}
			});

			setPageState('ready');
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function refreshPayPeriods (vmObj) {

		let newPayPeriodsTo = angular.copy(vmObj.regenerationDetails.PayslipPeriods);

		vmObj.regenerateDocumentsOptions.periodFrom = vmObj.regenerateDocumentsOptions.periodFromId ? vmObj.regenerationDetails.PayslipPeriods.find(payPeriod => payPeriod.PayPeriodID === vmObj.regenerateDocumentsOptions.periodFromId) : null;
		vmObj.regenerateDocumentsOptions.periodTo 	= vmObj.regenerateDocumentsOptions.periodToId ? vmObj.regenerationDetails.PayslipPeriods.find(payPeriod => payPeriod.PayPeriodID === vmObj.regenerateDocumentsOptions.periodToId) : null;

		// Get from and to pay periods
		vmObj.regenerationDetails.periodsTo = newPayPeriodsTo.filter(payPeriod => {

			if (!vmObj.regenerateDocumentsOptions.periodFrom) {
				return payPeriod;
			}

			const fromPeriodM = moment(vmObj.regenerateDocumentsOptions.periodFrom.StartDateISO);

			if (moment(payPeriod.StartDateISO).isSameOrAfter(fromPeriodM)) {
				return payPeriod;
			}

			return;
		});
	}


	function regenerateDocuments (regenerateDocumentsOptions, form) {

		form.state = 'saving';

		// Build up a set of document regeneration requests based on user-selected options
		let regenerateDocumentRequests = [];
		if (regenerateDocumentsOptions.documentTypes.payslips) {
			regenerateDocumentRequests.push(reportData.payrollRegeneratePayslip(agencyProfileId, userId, regenerateDocumentsOptions.periodFromId,
				regenerateDocumentsOptions.periodToId));
		}
		if (regenerateDocumentsOptions.documentTypes.p45) {
			regenerateDocumentRequests.push(reportData.payrollRegenerateP45(agencyProfileId, userId));
		}
		if (regenerateDocumentsOptions.documentTypes.p60) {
			regenerateDocumentRequests.push(reportData.payrollRegenerateP60(agencyProfileId, userId));
		}
		$q.all(regenerateDocumentRequests).then(data => {

			// Get overall result by summing outcomes of all API calls
			let overallResult = data.reduce((acc, next) => {
				return acc + next;
			});
			if (overallResult !== 0) {
				setPageState('error');
			}
			form.state = 'saved';
			setPageState('success');
			$scope.formOptions.forceCallback();
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope.vm, {
		documentTypeSelectionChanged,
		refreshPayPeriods,
		regenerateDocuments,
		selectionsAreValid: false,
		selectionsChanged: false
	});
}]);
'use strict';

angular.module('paycircleApp')

.directive('rejoinLeaverForm', function () {

	return {
		controller: 'rejoinLeaverFormCtrl',
		templateUrl: 'forms/payroll/rejoinLeaver/rejoinLeaverForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('rejoinLeaverFormCtrl', ['$scope', 'userData', function ($scope, userData) {

	var agencyProfileId	= $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		setPageState('ready');
	}

	function rejoinLeaver () {

		userData.updateUserAgencyProfileRestart(agencyProfileId, userId).then(function () {
			
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			
			setPageState('success');
		})
		.catch(function (error) {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.rejoinLeaver = function () {

		rejoinLeaver();
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('removePayslipNotesForm', function () {

	return {
		controller: 'removePayslipNotesFormCtrl',
		templateUrl: 'forms/payroll/removePayslipNotes/removePayslipNotesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('removePayslipNotesFormCtrl', ['$filter', '$q', '$scope', 'mailData', 'teamData', function ($filter, $q, $scope, mailData, teamData) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var payPeriod = $scope.formOptions.payPeriod;
	var searchBarOptions = $scope.formOptions.searchBarOptions;
	var userIds = $scope.formOptions.userIds;
	var teamMembers = [];

	function decorateTeamMember (teamMember) {

		var existingDetails = userIds ? teamMember : teamMember.Personal;

		teamMember.PersonalDetails = {
			UserID: existingDetails.UserID,
			AvatarID: existingDetails.AvatarID,
			Gender: existingDetails.Gender,
			Forename: existingDetails.Forename,
			Surname: existingDetails.Surname
		};

		return teamMember;
	}

	function loadFormForBulk () {

		let IGNORE_LEAVERS; 
		let IGNORE_BACKPAY; 
		let IGNORE_FUTURE_STARTERS;
		let IGNORE_ADMINS; 
		const INCLUDE_INCOMPLETE = true;

		teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(agencyProfileId, IGNORE_LEAVERS, IGNORE_FUTURE_STARTERS, IGNORE_ADMINS, INCLUDE_INCOMPLETE, IGNORE_BACKPAY).then(function(teamMembersObj) {

			for (var i = userIds.length - 1; i >= 0; i--) {
				for (var x = teamMembersObj.length - 1; x >= 0; x--) {
					if (teamMembersObj[x].UserID === userIds[i]) {
						teamMembers.push(decorateTeamMember(teamMembersObj[x]));
					}
				}
			}

			teamMembers = $filter('orderBy')(teamMembers, searchBarOptions.orderBy, searchBarOptions.orderByReverse);
			$scope.teamMembers = teamMembers;
			setMember(teamMembers[0].UserID);
		})
		.catch(function () {

			$scope.pageState = 'error';
		});
	}

	function setMember (userID) {

		for (var i = teamMembers.length - 1; i >= 0; i--) {
			if (teamMembers[i].UserID === userID) {
				$scope.teamMember = teamMembers[i];
			}
		}
		$scope.pageState = 'ready';
	}

	function init () {

		$scope.pageState = 'loading';
		if (userIds.length > 1) {
			$scope.bulkRemoval = true;
		}
		loadFormForBulk();
	}

	function clearPayslipNotes (teamMember) {

		teamMember.PayslipNote.Text = null;
		teamMember.PayslipNote.TextMerged = null;
		teamMember.PayslipNote.Emoji = null;

		return teamMember;
	}

	init();

	$scope.removePayslipNotes = function (formObj, form) {

		form.state = 'saving';

		mailData.getTeamMemberPayslipNotes(userIds, payPeriod.PayPeriodID, agencyProfileId).then(function (payslipNotesObj) {

			payslipNotesObj.filter(clearPayslipNotes);

			mailData.updateTeamMemberPayslipNotes(payslipNotesObj).then(function () {

				$scope.pageState = 'saved';
				$scope.formOptions.forceCallback();
			})
			.catch(function () {

				$scope.pageState = 'error';
			});
		})
		.catch(function () {

			$scope.pageState = 'error';
		});

	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('repaymentSchedulesForm', function () {

	return {
		controller: 'repaymentSchedulesFormCtrl',
		templateUrl: 'forms/payroll/repaymentSchedules/repaymentSchedulesForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('repaymentSchedulesFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'config',
	'paymentScheduleService',
	'payrollData',
	'pensionService',
	'utilities',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'LOAN_DEDUCTION_TYPES',
	'PAY_PERIOD_TYPES',
	'PAYMENT_SCHEDULE_CATEGORIES',
	'PAYMENT_SCHEDULE_PENSION_OPTIONS',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		config,
		paymentScheduleService,
		payrollData,
		pensionService,
		utilities,
		ADJUSTMENT_BEHAVIOUR_STATES,
		LOAN_DEDUCTION_TYPES,
		PAY_PERIOD_TYPES,
		PAYMENT_SCHEDULE_CATEGORIES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		SUBMISSION_STATES) {

	const agencyProfileId	= $scope.formOptions.agencyProfileId;
	const isEditMode = $scope.formOptions.paymentScheduleGroupId !== undefined && $scope.formOptions.paymentScheduleGroupId;
	const paymentScheduleGroupId = isEditMode ? $scope.formOptions.paymentScheduleGroupId : config.guidEmpty;
	const userId = $scope.formOptions.userId;

	function calculateRepaymentSchedule (paymentScheduleObj, payPeriodsArray, paymentScheduleTypesArray, formObj) {

		formObj.state = 'saving';

		// Reset repayment count based on deduction type
		resetPaymentScheduleValues(paymentScheduleObj);

		payrollData.calculatePaymentScheduleGroup(paymentScheduleObj).then(function (updatedPaymentScheduleObj) {

			// Persist some values from original selection
			setupPaymentScheduleValues(updatedPaymentScheduleObj, payPeriodsArray, paymentScheduleTypesArray);
			paymentScheduleObj.firstPayPeriod = angular.copy(paymentScheduleObj.firstPayPeriod);
			updatedPaymentScheduleObj.state = 'calculated';

			$scope.paymentSchedule = updatedPaymentScheduleObj;

			formObj.state = 'saving';
			setPageState('save-schedule');
		})
		.catch(error => {
            setPageState('invalid-schedule');
            console.error(error);
        });
	}

	function deletePaymentScheduleGroup (paymentScheduleObj, pageState) {

		setPageState('loading');

		payrollData.deletePaymentScheduleGroup(agencyProfileId, paymentScheduleObj.PaymentScheduleGroupID).then(function () {

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState(pageState);
		})
		.catch(onError);
	}

	function editSchedule () {

		setPageState('calculate-schedule');
	}

	function generateNumberOfPayPeriodsArray (payPeriodsArray) {

		let payPeriodType = payPeriodsArray[0].PayPeriodType;

		let count = getPayPeriodsForCompanyType(payPeriodType);
		let numberOfPayPeriodsArray = [];

		for (let i = 1; i < count; i++) {

			let payPeriodDescription = i > 1 ? ' pay periods' : ' pay period';
			let payPeriodItem = {
				description: i + payPeriodDescription,
				value: i
			};

			numberOfPayPeriodsArray.push(payPeriodItem);
		}

		return numberOfPayPeriodsArray;
	}

	function getPayPeriodsForCompanyType (payPeriodType) {

		switch (payPeriodType) {
			case PAY_PERIOD_TYPES.weekly:
				return 53;
			case PAY_PERIOD_TYPES.fortnightly:
				return 27;
			case PAY_PERIOD_TYPES.fourweekly:
				return 14;
			case PAY_PERIOD_TYPES.monthly:
				return 13;
			case PAY_PERIOD_TYPES.quarterly:
				return 5;
			case PAY_PERIOD_TYPES.biannually:
				return 2;
			case PAY_PERIOD_TYPES.annually:
				return 2;
			case PAY_PERIOD_TYPES.hourly:
				return 53;
			case PAY_PERIOD_TYPES.daily:
				return 366;
		}
	}

	function getRepaymentAmountValidation (paymentScheduleObj, formObj) {

		if (formObj && formObj.$valid) {

			// Reset dates and validation
			resetPaymentAmountValidation(paymentScheduleObj, formObj);

			payrollData.calculatePaymentScheduleGroup(paymentScheduleObj)
				.then(updatedPaymentScheduleObj => {
					formObj.fixedDeductionAmount.$setValidity('overLimit', true);
					paymentScheduleObj.LastPayPeriodDisplay = updatedPaymentScheduleObj.LastPayPeriodDisplay;
				})
				.catch(() => {
					formObj.fixedDeductionAmount.$setValidity('overLimit', false);
				});
		}
	}

	function init () {

		setPageState('loading');

		const getPaymentScheduleGroup = payrollData.getPaymentScheduleGroup(agencyProfileId, paymentScheduleGroupId, userId);
		const getPaymentScheduleTypes = payrollData.getPaymentScheduleTypes(agencyProfileId, PAYMENT_SCHEDULE_CATEGORIES.repayment);
		const getPayPeriods = payrollData.getPayPeriods(agencyProfileId, SUBMISSION_STATES.unsubmitted);

		$q.all([getPaymentScheduleGroup, getPayPeriods, getPaymentScheduleTypes]).then(([paymentScheduleGroupObj, payPeriodsArray, paymentScheduleTypesArray]) => {

			// Setup default values
			setupPaymentScheduleValues(paymentScheduleGroupObj, payPeriodsArray, paymentScheduleTypesArray, true);

			$scope.numberOfPayPeriods = generateNumberOfPayPeriodsArray(payPeriodsArray);
			$scope.paymentSchedule = paymentScheduleGroupObj;
			$scope.canEditPaymentSchedule = paymentScheduleService.getCanEditPaymentSchedule(paymentScheduleGroupObj);
			$scope.paymentScheduleTypes = paymentScheduleTypesArray;
			$scope.payPeriods = payPeriodsArray;

			setPageState(!isEditMode ? 'calculate-schedule' : 'save-schedule');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function resetPaymentAmountValidation (paymentScheduleObj, formObj) {
		formObj.fixedDeductionAmount.$setValidity('overLimit', null);
		paymentScheduleObj.LastPayPeriodDisplay = '';
	}

	function resetPaymentScheduleValues (paymentScheduleObj) {

		// Reset values
		paymentScheduleObj.FixedRepaymentAmount = utilities.setPropertyValueToZeroIfEmpty(paymentScheduleObj.FixedRepaymentAmount);
		paymentScheduleObj.TotalAmount = utilities.setPropertyValueToZeroIfEmpty(paymentScheduleObj.TotalAmount);
		paymentScheduleObj.TotalBroughtForward = utilities.setPropertyValueToZeroIfEmpty(paymentScheduleObj.TotalBroughtForward);

		resetPaymentScheduleRepaymentValues(paymentScheduleObj);
	}

	function resetPaymentScheduleRepaymentValues (paymentScheduleObj) {

		if (paymentScheduleObj.deductionType === LOAN_DEDUCTION_TYPES.FIXED) {
			paymentScheduleObj.PeriodRepaymentCount = 0;
		}
		if (paymentScheduleObj.deductionType === LOAN_DEDUCTION_TYPES.SPLIT) {
			paymentScheduleObj.FixedRepaymentAmount = 0;
		}
	}

	function saveRepaymentSchedule  (paymentScheduleObj, form) {

		// Reset values back to 0 if not set
		resetPaymentScheduleValues(paymentScheduleObj);

		form.state = 'saving';

		payrollData.updatePaymentScheduleGroup(paymentScheduleObj).then(function () {

			form.state = 'saving';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('success');
		})
		.catch(onError);
	}

	function selectPayPeriodById (paymentScheduleObj, payPeriodsArray) {

		// Selected period
		if (paymentScheduleObj.FirstPayPeriodID !== config.guidEmpty) {
			return utilities.getArrayItemByPropertyName(payPeriodsArray, 'PayPeriodID', paymentScheduleObj.FirstPayPeriodID);
		}

		// Current period
		return payPeriodsArray[0];
	}

	function selectPaymentScheduleTypeById (paymentScheduleObj, paymentScheduleTypesArray) {

		// Selected schedule type
		if (paymentScheduleObj.PaymentScheduleTypeID !== config.guidEmpty) {
			return utilities.getArrayItemByPropertyName(paymentScheduleTypesArray, 'PaymentScheduleTypeID', paymentScheduleObj.PaymentScheduleTypeID);
		}

		// Select first
		return paymentScheduleTypesArray[0];
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setPaymentScheduleRepaymentDefaults (paymentScheduleObj, formObj) {

		resetPaymentScheduleRepaymentValues(paymentScheduleObj);

		if (paymentScheduleObj.deductionType === LOAN_DEDUCTION_TYPES.FIXED) {
			formObj.fixedDeductionAmount.$setUntouched();
			paymentScheduleObj.FixedRepaymentAmount = null;
		}
		if (paymentScheduleObj.deductionType === LOAN_DEDUCTION_TYPES.SPLIT) {
			formObj.splitDeductionPeriodCount.$setUntouched();
			paymentScheduleObj.PeriodRepaymentCount = null;
		}
	}

	function setSchemePaymentScheduleGroupPensionState (paymentScheduleObj, value) {
		for (let schemeObj of paymentScheduleObj.PaymentScheduleGroupPension) {
			schemeObj.PaymentScheduleGroupPensionState = value;
		}
	}

	function setupPaymentScheduleValues (paymentScheduleObj, payPeriodsArray, paymentScheduleTypesArray, initDefaults) {

		let selectedPayPeriodObj = selectPayPeriodById(paymentScheduleObj, payPeriodsArray);
		let selectedPaymentScheduleTypeObj = selectPaymentScheduleTypeById(paymentScheduleObj, paymentScheduleTypesArray);

		// UI states
		paymentScheduleObj.adjustmentLabelFocus = false;
		paymentScheduleObj.deductionType = paymentScheduleObj.PeriodRepaymentCount > 0 ? LOAN_DEDUCTION_TYPES.SPLIT : LOAN_DEDUCTION_TYPES.FIXED;

		// Setup default values
		paymentScheduleObj.FixedRepaymentAmount = utilities.setPropertyValueToEmptyIfZero(paymentScheduleObj.FixedRepaymentAmount);
		paymentScheduleObj.PeriodRepaymentCount = paymentScheduleObj.PeriodRepaymentCount > 0 ? paymentScheduleObj.PeriodRepaymentCount : 1; // Default to 1 so that select shows as pre-selected
		// These default values on init only - otherwise returning back to this step will remove zero entered values
		if (initDefaults) {
			paymentScheduleObj.TotalAmount = utilities.setPropertyValueToEmptyIfZero(paymentScheduleObj.TotalAmount);
			paymentScheduleObj.TotalBroughtForward = utilities.setPropertyValueToEmptyIfZero(paymentScheduleObj.TotalBroughtForward);
		}

		// Setup active pay period
		if (selectedPayPeriodObj !== undefined) {
			paymentScheduleObj.firstPayPeriod = selectedPayPeriodObj;
		}
		else {
			paymentScheduleObj.firstPayPeriod = payPeriodsArray[0];
		}

		if (!isEditMode) {

			// Apply selected pay period
			setupSelectedPayPeriod(paymentScheduleObj);

			// Schedule type
			paymentScheduleObj.paymentScheduleType = paymentScheduleTypesArray[0];
		}

		// Reorder pensions to bring AE pension to the beginning
		pensionService.getOrderedPensionsArray(paymentScheduleObj.PaymentScheduleGroupPension);

		// Setup active schedule type
		paymentScheduleObj.paymentScheduleType = selectedPaymentScheduleTypeObj;
		setupSelectedScheduleType(paymentScheduleObj, $rootScope.currentCompany);

		// Additional info
		paymentScheduleObj.AgencyProfileID = paymentScheduleObj.AgencyProfileID !== config.guidEmpty ? paymentScheduleObj.AgencyProfileID : agencyProfileId;
		paymentScheduleObj.UserID = userId;

		// State
		paymentScheduleObj.state = isEditMode ? 'viewing' : 'calculated';
	}

	function setupSelectedPayPeriod (paymentScheduleObj, formObj) {

		paymentScheduleObj.FirstPayPeriodDisplay = paymentScheduleObj.firstPayPeriod.PayPeriodDisplay;
		paymentScheduleObj.FirstPayPeriodID = paymentScheduleObj.firstPayPeriod.PayPeriodID;

		getRepaymentAmountValidation(paymentScheduleObj, formObj);
	}

	function setupSelectedScheduleType (paymentScheduleObj, currentCompanyObj, formObj) {

		angular.extend(paymentScheduleObj, {
			PaymentScheduleTypeDescription: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypeDescription,
			PaymentScheduleTypeID: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypeID
		});

		if (paymentScheduleObj.AgencyProfileID === config.guidEmpty ) {
			angular.extend(paymentScheduleObj, {
				PaymentScheduleGroupPensionBehaviour: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviour,
				PaymentScheduleGroupPensionBehaviourAttributes: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviourAttributes,
				PaymentScheduleGroupPensionState: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionState,
			});

			// Update all schemes
			for (let schemeObj of paymentScheduleObj.PaymentScheduleGroupPension) {
				angular.extend(schemeObj, {
					PaymentScheduleGroupPensionBehaviour: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviour,
					PaymentScheduleGroupPensionBehaviourAttributes: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviourAttributes,
					PaymentScheduleGroupPensionState: paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionState,
				});
			}
		}

		/*
			Update 'Pensionable' status. This can be editable, or non-editable and locked to 'on' or 'off'. Also, if the company
			doesn't have a pension set-up, this has to be locked and set to 'off'.
	 	 */
		if (currentCompanyObj.isPayrollCompany && !currentCompanyObj.HasPension) {
			// No pension set up for the current company so off and locked by default
			paymentScheduleObj.PaymentScheduleGroupPensionState = false;
			setSchemePaymentScheduleGroupPensionState(paymentScheduleObj, false);

			paymentScheduleObj.pensionableStatusEditable = false;
		}
		else if (paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviour === ADJUSTMENT_BEHAVIOUR_STATES.onLocked) {
			// Behaviour state is on and locked
			paymentScheduleObj.PaymentScheduleGroupPensionState = true;
			setSchemePaymentScheduleGroupPensionState(paymentScheduleObj, true);

			paymentScheduleObj.pensionableStatusEditable = false;
		}
		else if (paymentScheduleObj.paymentScheduleType.PaymentScheduleTypePensionBehaviour === ADJUSTMENT_BEHAVIOUR_STATES.offLocked) {
			// Behaviour state is off and locked
			paymentScheduleObj.PaymentScheduleGroupPensionState = false;
			setSchemePaymentScheduleGroupPensionState(paymentScheduleObj, false);

			paymentScheduleObj.pensionableStatusEditable = false;
		}
		else {
			// Behaviour state is on or off (whatever the current state is) and editable
			paymentScheduleObj.pensionableStatusEditable = true;

			// This could have happened without user intervention, so ensure behaviour and state are synced.
			updateRepaymentSchedulePensionable (paymentScheduleObj);
		}

		getRepaymentAmountValidation(paymentScheduleObj, formObj);
	}

	function toggleAdjustmentLabelFocus (paymentScheduleObj, newValue) {
		paymentScheduleObj.adjustmentLabelFocus = newValue;
	}

	function updateRepaymentSchedulePensionable (paymentScheduleGroupObj) {

		/* Ensure pension behaviour is synced with the status. This is important as the UI can get into a conflicted state,
			because behaviour also contains the state if the behaviour is 'on' (state = true) or 'off' (state = false). So
			in effect the same property is stored in two places in the same object ... */
		paymentScheduleGroupObj.PaymentScheduleGroupPensionBehaviour = paymentScheduleGroupObj.PaymentScheduleGroupPensionState ? ADJUSTMENT_BEHAVIOUR_STATES.on : ADJUSTMENT_BEHAVIOUR_STATES.off;

		// Update all schemes
		for (let schemeObj of paymentScheduleGroupObj.PaymentScheduleGroupPension) {
			angular.extend(schemeObj, {
				PaymentScheduleGroupPensionBehaviour: paymentScheduleGroupObj.PaymentScheduleGroupPensionBehaviour,
				PaymentScheduleGroupPensionState: paymentScheduleGroupObj.PaymentScheduleGroupPensionState
			});
		}
	}

	init();

	angular.extend($scope, {
		ADJUSTMENT_BEHAVIOUR_STATES,
		LOAN_DEDUCTION_TYPES,
		PAYMENT_SCHEDULE_PENSION_OPTIONS,
		isEditMode,

		calculateRepaymentSchedule,
		deletePaymentScheduleGroup,
		editSchedule,
		getRepaymentAmountValidation,
		resetPaymentAmountValidation,
		saveRepaymentSchedule,
		setPageState,
		setPaymentScheduleRepaymentDefaults,
		setupSelectedPayPeriod,
		setupSelectedScheduleType,
		toggleAdjustmentLabelFocus,
		updateRepaymentSchedulePensionable
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('reversedHmrcTaxUpdatesForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'reversedHmrcTaxUpdatesForm',
	templateUrl: 'forms/payroll/reversedHmrcTaxUpdates/reversed-hmrc-tax-updates.form.html'
})

.controller('reversedHmrcTaxUpdatesForm', ['payrollData',
	function (payrollData) {

	const $ctrl = this;

	function $onInit () {

		setComponentState('loading');

		payrollData.getReversedHmrcTaxUpdates($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId)
			.then(teamMembersArr => {

				angular.extend($ctrl, {
					distinctTeamMemberCount: new Set(teamMembersArr.map(u => u.UserID)).size,
					teamMembers: teamMembersArr
				});

				setComponentState('ready');
			})
			.catch(onError);
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('recallDraftPayslipsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'recallDraftPayslipsFormCtrl',
	templateUrl: 'forms/payroll/recall-draft-payslips/recall-draft-payslips.form.html'
})

.controller('recallDraftPayslipsFormCtrl', [
	'aiServices',
	'growl',
	function (
		aiServices,
		growl
	) {

	const $ctrl = this;

	function $onInit () {
		setComponentState('ready');
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function recallDraftPayslips ($form) {
		$form.state = 'submitting';
		
		aiServices.recallDraftPayslips($ctrl.formOptions.payPeriod.PayPeriodID)
			.then(responseObj => {

				$ctrl.formOptions.forceCallback(responseObj);
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
				
				growl.success('Recalling draft payslips');
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		recallDraftPayslips
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('rollbackPeriodForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'rollbackPeriodFormCtrl',
	templateUrl: 'forms/payroll/rollback-period/rollback-period.form.html'
})

.controller('rollbackPeriodFormCtrl', [
	'$q',
	'$rootScope',
	'companyData',
	'payrollData',
	'utilities',
	'ROLLBACK_STATES',
	function (
		$q,
		$rootScope,
		companyData,
		payrollData,
		utilities,
		ROLLBACK_STATES
	) {

	const $ctrl = this;

	const FORM_STATES = {
		ready: 'ready',
		loading: 'loading',
		success: 'success',
		error: 'error',
		notAllowed: 'not-allowed',
		alert: 'alert'
	};

	function $onInit () {

		setFormState(FORM_STATES.loading);

		const assessCanRollbackAgencyPayPeriod = companyData.assessCanRollbackAgencyPayPeriod($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId);
		const getPayPeriod = payrollData.getPayPeriod($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId);

		$q.all([
			assessCanRollbackAgencyPayPeriod,
			getPayPeriod
		])
		.then(([
			canRollbackState,
			payPeriodObj
		]) => {

			angular.extend($ctrl, {
				canRollbackState,
				payPeriod: payPeriodObj
			});

			// Not allowed to rollback
			if (canRollbackState !== ROLLBACK_STATES.canRollback) {
				setFormState(FORM_STATES.notAllowed);
				return;
			}

			// EA auto-reclaim alert
			if (utilities.getIsPreviousTaxYearSubmission(payPeriodObj.TaxYear, $rootScope.currentPeriod.TaxYear)) {
				setFormState(FORM_STATES.alert);
				return;
			}

			setFormState(FORM_STATES.ready);
		})
		.catch(onError);
	}

	function onError (error) {

		setFormState(FORM_STATES.error);
		console.error(error);
	}

	function rollbackPeriod ($form) {

		$form.state = 'saving';

		companyData.updateAgencyPayPeriodRollback($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId).then(() => {

			$ctrl.formOptions.forceCallback();

			// Refresh current period in app header
			$rootScope.$broadcast('refresh-current-period');

			// Refresh current company to update HasRunPayroll state
			$rootScope.$broadcast('set-current-company', $ctrl.formOptions.agencyProfileId);

			setFormState(FORM_STATES.success);
		})
		.catch(onError);
	}

	function setFormState (newState) {

		$ctrl.formState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		rollbackPeriod,
		setFormState,

		FORM_STATES,
		ROLLBACK_STATES,

		confirm: false
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('runPayrollForm', function () {

	return {
		controller: 'runPayrollFormCtrl',
		templateUrl: 'forms/payroll/runPayroll/runPayrollForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('runPayrollFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'base',
	'companyData',
	'config',
	'intercomService',
	'messageData',
	'payPeriodService',
	'payrollData',
	'tracking',
	'MESSAGE_STATUS',
	'PAYROLL_ERROR_STATES',
	'PRESET_FILTER_KEYS',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'TRACKING_EVENTS',
	function (
		$q,
		$rootScope,
		$scope,
		base,
		companyData,
		config,
		intercomService,
		messageData,
		payPeriodService,
		payrollData,
		tracking,
		MESSAGE_STATUS,
		PAYROLL_ERROR_STATES,
		PRESET_FILTER_KEYS,
		STATE_TYPES,
		SUBMISSION_STATES,
		TRACKING_EVENTS
	) {

	const FORM_STATES = {
		demoIncomplete: 'demo-incomplete',
		error: 'error',
		hasPayrollErrors: 'has-payroll-errors',
		loading: 'loading',
		outsideDateRange: 'outside-date-range',
		outsideTimePeriod: 'outside-time-period',
		payeCessationDateInFuture: 'paye-cessation-date-in-future',
		payeCessationDateInPast: 'paye-cessation-date-in-past',
		payeSchemeClosed: 'paye-scheme-closed',
		payslipsGenerating: 'payslips-generating',
		pensionNotActive: 'pension-not-active',
		pensionSubmissionFailure: 'pension-submission-failure',
		pensionSubmissionPending: 'pension-submission-pending',
		pensionUnauthorized: 'pension-unauthorized',
		ready: 'ready',
		rotareadyCriticalErrors: 'rotaready-critical-errors',
		reportGenerationFailed: 'report-generation-failed',
		reportsGenerating: 'reports-generating',
		retrospectivePensionIncomplete: 'retrospective-pension-incomplete',
		unableToRunPayroll: 'unable-to-run-payroll',
		unableToRunPayrollDefault: 'unable-to-run-payroll-default',
		userUnauthorised: 'user-unauthorised',
		firstPayRun: 'first-pay-run'	
	};

	const BACS_DATE_OPTIONS = {
		option1: 'bacsDateOption1',
		option2: 'bacsDateOption2',
		custom: 'bacsDateCustom'
	};

	const RUN_PAYROLL_STEPS = {
		payrollSummary: 1,
		advancePayrollsConfirmation: 2,
		runPayroll: 3
	};

	const PAY_DATE_OPTIONS = {
		option1: 'payDateOption1',
		option2: 'payDateOption2',
		custom: 'payDateCustom'
	};

	const PAYSLIP_DATE_OPTIONS = {
		custom: 'custom',
		notificationDate: 'notification-date',
		now: 'now'
	};

	const PAYROLL_STATE_PROPERTY_KEY = 'PayrollState';
	const PAYROLL_STATE_TYPE = STATE_TYPES.finalise;
	const RUN_PAYROLL_UNAUTHORISED_CODE = -2;

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;

	if (!angular.isDefined($scope.formOptions.confirmFirstPayRun)) {
		$scope.formOptions.confirmFirstPayRun = false;
	}

	function changeBacsDateOption (payPeriodObj, option) {

		payPeriodObj.bacsDateOption = option;

		if (payPeriodObj.bacsDateOption !== BACS_DATE_OPTIONS.custom) {
			payPeriodObj.BACSDateISO = payPeriodObj[payPeriodObj.bacsDateOption];
		}
	}

	function changePayDateOption (payPeriodObj, option) {

		payPeriodObj.payDateOption = option;

		if (payPeriodObj.payDateOption !== PAY_DATE_OPTIONS.custom) {
			payPeriodObj.PayDateISO = payPeriodObj[payPeriodObj.payDateOption];
		}
	}

	function changePayslipDate (payPeriodObj, option) {

		payPeriodObj.payslipDateOption = option;

		// Set payslip send date
		switch (option) {

			case PAYSLIP_DATE_OPTIONS.now:
				// Set payslip date to todays date
				payPeriodObj.PayslipDateISO = moment().format(config.dateFormatISO);

				break;

			case PAYSLIP_DATE_OPTIONS.notificationDate:
				// Default to display date
				payPeriodObj.PayslipDateISO = payPeriodObj.PayslipDisplayDateISO;

				break;
		}
	}

	function decoratePayPeriodObject (payPeriodObj, payPeriodCountsObj) {

		angular.extend(payPeriodObj, {
			// Payslip Date
			payslipDateOption: PAYSLIP_DATE_OPTIONS.notificationDate,
			payslipDateISOMin: moment().add(1, 'days').format(config.dateFormatISO),

			// BACS
			bacsDateOption: BACS_DATE_OPTIONS.option1,
			bacsDateISOMin: moment().startOf('day').format(config.dateFormatISO),
			bacsDateOriginal: payPeriodObj.BACSDateISO,

			// PayDate (Rollback)
			showPayDateOptions: false,
			payDateOriginal: angular.copy(payPeriodObj.PayDateISO),

			// Has advancing team members + confirmation flag
			hasAdvancingTeamMembers: payPeriodCountsObj.NumberOfTeamMembersAdvancingPeriods !== 0,
			confirmAdvancingPeriods: payPeriodCountsObj.NumberOfTeamMembersAdvancingPeriods === 0,
			runPayrollStep: RUN_PAYROLL_STEPS.payrollSummary
		});

		// Set default pay date option in rollback
		if (payPeriodObj.IsRollback) {
			changePayDateOption(payPeriodObj, PAY_DATE_OPTIONS.custom);
		}

		return payPeriodObj;
	}

	function getCanUpdatePayslipDate (payPeriodObj, companyBankDetailsObj) {

		// Always update if BACS is enabled
		if (companyBankDetailsObj.BACSEnabled) {
			return true;
		}

		// If payslip date has changed
		switch (payPeriodObj.payslipDateOption) {
			case PAYSLIP_DATE_OPTIONS.custom:
			case PAYSLIP_DATE_OPTIONS.now:
				return true;
		}

		// PayDate (Rollback)
		if (payPeriodObj.PayDateISO !== payPeriodObj.payDateOriginal) {
			return true;
		}

		// BACS Date
		if (payPeriodObj.BACSDateISO !== payPeriodObj.bacsDateOriginal) {
			return true;
		}

		return false;
	}

	function getFPSLateReasons (currentPayPeriodObj, payPeriodCountsObj, periodAlertsCountObj, canRunPayrollObj) {

		payrollData.getFPSLateReasons().then(lateReasonsArr => {

			$scope.lateReasons = lateReasonsArr;

			currentPayPeriodObj.lateReasonCode = config.defaultFPSLateReason;

			loadPage(currentPayPeriodObj, payPeriodCountsObj, periodAlertsCountObj, canRunPayrollObj);

		})
		.catch(onError);
	}

	function getIsLateFPSSubmissionApplicable (currentPayPeriodObj, companyObj) {

		// Not displayed when RTI submission turned off
		if (companyObj.IsRTISubmissionDisabled) {
			return false;
		}

		// Only applies to payroll enabled companies (not CIS/Pension only companies)
		if (!companyObj.IsPayrollActive) {
			return false;
		}

		// Doesn't apply to rolled back periods
		if (currentPayPeriodObj.IsRollback) {
			return false;
		}

		// Only applies if overdue
		if (currentPayPeriodObj.PayDayDaysOverdue === 0) {
			return false;
		}

		return true;
	}

	function goToPayrollStep (payPeriodObj, step) {
		payPeriodObj.runPayrollStep = step;
	}

	function continueFirstPayRun () {
		$scope.firstPayRunConfirmed = true;
		fetchAllPayrollData();
	}

	function init() {
		
		setPageState(FORM_STATES.loading);
		$scope.firstPayRunConfirmed = false;

		const shouldProceedPromise = (!companyObj.IsInTestMode && companyObj.CanBeMadeTest) ?
			companyData.assessHasRunLivePeriod(agencyProfileId, currentPayPeriodObj.PayPeriodID)
				.then(hasRunLivePeriod => {
					if (!hasRunLivePeriod) {
						setPageState(FORM_STATES.firstPayRun);
						return false;
					}
					return true;
				})
			: $q.resolve(true);

		shouldProceedPromise
			.then(shouldProceed => {
				if (shouldProceed) {
					fetchAllPayrollData();
				}
			})
			.catch(onError);
	}

	function fetchAllPayrollData () {

		setPageState(FORM_STATES.loading);

		// Demo completed
		$rootScope.setDemoTaskAsComplete('runPayroll');

		const getBankDetailsCompany = base.getBankDetailsCompany(agencyProfileId);
		const getPayPeriodCounts = companyData.getPayPeriodCountsForRunPayrollView(agencyProfileId, currentPayPeriodObj.PayPeriodID);
		const getPeriodAlertCount = messageData.getPeriodAlertCount(agencyProfileId, currentPayPeriodObj.PayPeriodID);
		const getMessageStatusCount = messageData.getMessageStatusCount(agencyProfileId, MESSAGE_STATUS.incomplete);
		const getPayPeriodCISDeductions = payrollData.getPayPeriodCISDeductions(agencyProfileId, currentPayPeriodObj.PayPeriodID);
		const getReversedHmrcTaxUpdates = payrollData.getReversedHmrcTaxUpdates(agencyProfileId, currentPayPeriodObj.PayPeriodID);
		const getCanRunPayroll = payrollData.getCanRunPayroll(agencyProfileId);
		
		$q.all([
			getBankDetailsCompany,
			getPayPeriodCounts,
			getPeriodAlertCount,
			getMessageStatusCount,
			getPayPeriodCISDeductions,
			getReversedHmrcTaxUpdates,
			getCanRunPayroll
		])
		.then(([
			companyBankDetailsObj,
			payPeriodCountsObj,
			periodAlertsCountObj,
			messsageStatusCountObj,
			cisDeductionsObj,
			reversedHmrcTaxUpdatesObj,
			canRunPayrollObj
		]) => {		
			setPayDateOptions(currentPayPeriodObj, companyBankDetailsObj);

			const reversedHmrcTaxUpdatesCount = reversedHmrcTaxUpdatesObj ? new Set(reversedHmrcTaxUpdatesObj.map(u => u.UserID)).size : 0;

			angular.extend($scope, {
				cisDeductions: cisDeductionsObj,
				companyBankDetails: companyBankDetailsObj,
				messsageStatusCounts: messsageStatusCountObj,
				payPeriodCounts: payPeriodCountsObj,
				payrollAlertCounts: periodAlertsCountObj,
				reversedHmrcTaxUpdatesCount
			});

			// Load FPS late reasons if payroll overdue
			if (getIsLateFPSSubmissionApplicable(currentPayPeriodObj, companyObj)) {
				getFPSLateReasons(currentPayPeriodObj, payPeriodCountsObj, periodAlertsCountObj, canRunPayrollObj);

			} else {
				// Check report state
				loadPage(currentPayPeriodObj, payPeriodCountsObj, periodAlertsCountObj, canRunPayrollObj);
			}
		})
		.catch(onError);
	}

	function loadPage (payPeriodObj, payPeriodCountsObj, periodAlertsCountObj, canRunPayrollObj) {

		// Scope
		$scope.currentPayPeriod = decoratePayPeriodObject(payPeriodObj, payPeriodCountsObj);

		// Can't run if there are errors
		if (periodAlertsCountObj.ErrorCount > 0) {
			setPageState(FORM_STATES.hasPayrollErrors);
			return;
		}

		// Check state of payroll
		switch (canRunPayrollObj.CanRunPayrollState) {

			case PAYROLL_ERROR_STATES.pensionUnauthorized:
				setPageState(FORM_STATES.pensionUnauthorized);
				return;

			case PAYROLL_ERROR_STATES.pensionSubmissionFailure:
				setPageState(FORM_STATES.pensionSubmissionFailure);
				return;

			case PAYROLL_ERROR_STATES.payeCessationDateInFuture:
				setPageState(FORM_STATES.payeCessationDateInFuture);
				return;

			case PAYROLL_ERROR_STATES.pensionSubmissionPending:
				setPageState(FORM_STATES.pensionSubmissionPending);
				return;

			case PAYROLL_ERROR_STATES.pensionNotActive:
				setPageState(FORM_STATES.pensionNotActive);
				return;

			case PAYROLL_ERROR_STATES.payeSchemeClosed:
				setPageState(FORM_STATES.payeSchemeClosed);
				return;

			case PAYROLL_ERROR_STATES.outsideDateRange:
				setPageState(FORM_STATES.outsideDateRange);
				return;

			case PAYROLL_ERROR_STATES.payeCessationDateInPast:
				setPageState(FORM_STATES.payeCessationDateInPast);
				return;

			case PAYROLL_ERROR_STATES.demoIncomplete:
				setPageState(FORM_STATES.demoIncomplete);
				return;

			case PAYROLL_ERROR_STATES.reportsGenerating:
				setPageState(FORM_STATES.reportsGenerating);
				return;

			case PAYROLL_ERROR_STATES.payslipsGenerating:
				setPageState(FORM_STATES.payslipsGenerating);
				return;

			case PAYROLL_ERROR_STATES.retrospectivePensionIncomplete:
				setPageState(FORM_STATES.retrospectivePensionIncomplete);
				return;
	
			case PAYROLL_ERROR_STATES.paymentOverdue:
			case PAYROLL_ERROR_STATES.companyArchived:
				setPageState(FORM_STATES.unableToRunPayroll);
				return;

			case PAYROLL_ERROR_STATES.rotareadyCriticalErrors:
				setPageState(FORM_STATES.rotareadyCriticalErrors);
				return;
		}

		// Cannot run payroll
		if (!canRunPayrollObj.CanRunPayroll) {
			setPageState(FORM_STATES.unableToRunPayrollDefault);
			return;
		}

		// Running payroll in close succession
		if (payPeriodObj.IsOutsideTimePeriod) {
			setPageState(FORM_STATES.outsideTimePeriod);
			return;
		}

		pollForPayrollState(payPeriodObj);
	}

	function onError (error) {

		setPageState(FORM_STATES.error);
		throw(error);
	}

	function onPayDateContentToggle (payPeriodObj) {

		// On cancel, set defaults
		if (!payPeriodObj.showPayDateOptions) {
			angular.extend(payPeriodObj, {
				PayDateISO: payPeriodObj.payDateOriginal,
				payDateOption: PAY_DATE_OPTIONS.custom
			});
		}
	}

	function onBacsDateContentToggle (payPeriodObj) {

		// On cancel, set defaults
		if (!payPeriodObj.showBacsDateOptions) {
			angular.extend(payPeriodObj, {
				BACSDateISO: payPeriodObj.bacsDateOriginal,
				bacsDateOption: BACS_DATE_OPTIONS.option1
			});
		}
	}

	function openBacsSettingsForm () {
		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			formKey: 'company-settings-bacs',
			formStage: 'incomplete-team-members',
			title: 'Incomplete team members'
		});
	}

	function reviewPayroll (payPeriodObj, companyBankDetailsObj, formObj) {

		// Advance future periods confirmation
		if (payPeriodObj.runPayrollStep !== RUN_PAYROLL_STEPS.advancePayrollsConfirmation && payPeriodObj.hasAdvancingTeamMembers) {
			goToPayrollStep(payPeriodObj, RUN_PAYROLL_STEPS.advancePayrollsConfirmation);
			return;
		}

		// Update payslip and run payroll
		if (getCanUpdatePayslipDate(payPeriodObj, companyBankDetailsObj)) {
			updatePayslipDateAndRunPayroll(payPeriodObj, formObj);
		}

		// Run payroll
		else {
			payPeriodObj.runPayrollStep = RUN_PAYROLL_STEPS.runPayroll;
			runPayroll(payPeriodObj, formObj);
		}
	}

	function pollForPayrollState (payPeriodObj) {

		setPageState(FORM_STATES.ready);

		// Kick off polling for payroll state
		if ([SUBMISSION_STATES.submitting, SUBMISSION_STATES.requesting].includes(payPeriodObj.PayrollState)) {
			payPeriodService.pollForSubmissionState(payPeriodObj, PAYROLL_STATE_TYPE, PAYROLL_STATE_PROPERTY_KEY, agencyProfileId);
		}
	}

	function runPayroll (payPeriodObj, formObj) {

		formObj.state = 'saving';

		payPeriodObj.PayrollState = 1;

		payrollData.payrollRunEasyEnrol(agencyProfileId, payPeriodObj.PayPeriodID, payPeriodObj.lateReasonCode).then(response => {

			formObj.state = 'saved';

			if (response === RUN_PAYROLL_UNAUTHORISED_CODE) {
				setPageState(FORM_STATES.userUnauthorised);
				return;
			}

			$scope.formOptions.forceCallback(payPeriodObj);

			payPeriodService.pollForSubmissionState(payPeriodObj, PAYROLL_STATE_TYPE, PAYROLL_STATE_PROPERTY_KEY, agencyProfileId);

			// Tracking
			updateTracking();
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function setPayDateOptions (payPeriodObj, companyBankDetailsObj) {

		// Rollback
		if (payPeriodObj.IsRollback) {
			angular.extend(payPeriodObj, {
				[PAY_DATE_OPTIONS.option1]: moment(payPeriodObj.PayDateISO).subtract(2, 'd').format(config.dateFormatISO),
				[PAY_DATE_OPTIONS.option2]: moment(payPeriodObj.PayDateISO).subtract(1, 'd').format(config.dateFormatISO),
			});
		}

		// BACS
		if (companyBankDetailsObj.BACSEnabled) {
			angular.extend(payPeriodObj, {
				[BACS_DATE_OPTIONS.option1]: payPeriodObj.BACSDateISO,
				[BACS_DATE_OPTIONS.option2]: moment(payPeriodObj.BACSDateISO).add(1, 'd').format(config.dateFormatISO),
			});
		}
	}

	function updatePayslipDateAndRunPayroll (payPeriodObj, formObj) {

		// Update state
		formObj.state = 'saving';

		const payslipDateString = moment(payPeriodObj.PayslipDateISO).format(config.dateFormatPrimary);
		const payDateString = moment(payPeriodObj.PayDateISO).format(config.dateFormatPrimary);
		const bacsDate = moment(payPeriodObj.BACSDateISO).format(config.dateFormatPrimary);

		// Update payslip date
		payrollData.updateAgencyPayPeriodPayslipDate(payPeriodObj.PayPeriodID, payslipDateString, payDateString, bacsDate)
			.then(() => {
				runPayroll(payPeriodObj, formObj);
			})
			.catch(onError);
	}

	function updateTracking () {

		if (companyObj.IsInTestMode) {

			tracking.trackEvent(TRACKING_EVENTS.runTestPayroll);

			intercomService.updateCompanyData(agencyProfileId, {
				has_run_payroll_in_test_mode: true
			});

		} else {

			tracking.trackEvent(TRACKING_EVENTS.runLivePayroll);

			intercomService.updateCompanyData(agencyProfileId, {
				has_run_payroll: true
			});
		}
	}

	function viewReversedHmrcTaxUpdates () {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId,
			contextType: 'company',
			formKey: 'reversed-hmrc-tax-updates',
			payPeriodId: currentPayPeriodObj.PayPeriodID
		});
	}

	init();

	angular.extend($scope, {
		BACS_DATE_OPTIONS,
		FORM_STATES,
		PAY_DATE_OPTIONS,
		PAYSLIP_DATE_OPTIONS,
		PRESET_FILTER_KEYS,
		RUN_PAYROLL_STEPS,
		SUBMISSION_STATES,

		agencyProfileId: agencyProfileId,
		company: companyObj,
		currentDate: moment().format(config.dateFormatISO),

		changeBacsDateOption,
		changePayDateOption,
		changePayslipDate,
		continueFirstPayRun,
		onBacsDateContentToggle,
		onPayDateContentToggle,
		openBacsSettingsForm,
		pollForPayrollState,
		reviewPayroll,
		viewReversedHmrcTaxUpdates
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('runPayrollBulkForm', function () {

	return {
		controller: 'runPayrollBulkFormCtrl',
		templateUrl: 'forms/payroll/runPayrollBulk/runPayrollBulkForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('runPayrollBulkFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'companyData',
	'config',
	'growl',
	'messageData',
	'payrollData',
	'session',
	'tracking',
	'TRACKING_EVENTS',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		companyData,
		config,
		growl,
		messageData,
		payrollData,
		session,
		tracking,
		TRACKING_EVENTS
	) {

	const agencyProfilesArr = $scope.formOptions.agencyProfiles;
	const agencyProfilesIdArray = $scope.formOptions.agencyProfilesIdArray;
	const responseCodes = {
		genericError: -1,
		runPayrollUnauthorised: -2,

	};
	const userId = session.getUserId();

	function bulkRunPayroll (vmObj) {

		setPageState('running');

		const companiesAndPeriodsArr = getCompaniesAndPeriodsArray(vmObj.companiesThatCanRun);

		payrollData.payrollRunEasyEnrolBulk(userId, companiesAndPeriodsArr).then(responseCode => {

			switch (responseCode) {

				// Incorrect permissions
				case responseCodes.runPayrollUnauthorised: {

					growl.error('Unable to bulk run payroll. Incorrect permissions to run payroll');
					break;
					
				}

				// Generic error
				case responseCodes.genericError: {

					growl.error('There was a problem bulk running payrolls');
					break;
					
				}

				// Success
				default: {

					$scope.formOptions.forceCallback(vmObj.companiesThatCanRun);

					tracking.trackEvent(TRACKING_EVENTS.bulkPayrollsRan);

					setPageState('success');

				}
			}
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function cancelBulkPayrollSetup (vmObj) {

		$scope.formOptions.closeForm();
		vmObj.cancelSetup = true;
	}

	function getCanRunPayrollDetailsForCompanies (vmObj)  {

		const companiesSummaryObj = {
			companiesThatCanRun: [],
			companiesWithErrors: []
		};

		return $q((resolveQueue, rejectQueue) => loadNextCompany(vmObj, companiesSummaryObj, resolveQueue, rejectQueue));
	}

	function getCompaniesAndPeriodsArray (companiesThatCanRunArr) {

		let returnArr = [];

		companiesThatCanRunArr.forEach(companyObj => {
			returnArr.push({
				AgencyProfileID: companyObj.Company.AgencyProfileID,
				AgencyPayPeriodID: companyObj.PayPeriod.PayPeriodID
			});
		});

		return returnArr;
	}

	function getAlertsDetailsForCompany (companyObj) {

		return $q((resolve, reject) => {

			// Data is not required but called to make sure calculation is up to date
			payrollData.getTeamMembersPayroll(companyObj.Company.AgencyProfileID).then(() => {

				const CALCULATED = false;

				messageData.getPeriodAlertCount(companyObj.Company.AgencyProfileID, companyObj.PayPeriod.PayPeriodID, CALCULATED).then(alertsObj => {

					resolve(alertsObj);
				})
				.catch(error => {
					console.error(error);
					reject(error);
				});
			})
			.catch(error => {
				console.error(error);
				reject(error);
			});
		});
	}

	function goToCurrentPeriodAlertsForCompany (companyObj) {

		$rootScope.$broadcast('set-current-company', companyObj.Company.AgencyProfileID, function () {

			$state.go('payroll.current-period.alerts', {
				agencyProfileId: companyObj.Company.AgencyProfileID
			});
		});
	}

	function init () {

		const vmObj = {
			agencyProfiles: agencyProfilesArr,
			agencyProfilesIds: agencyProfilesIdArray,
			cancelSetup: false,
			companiesChecked: 0,
			companiesRan: 0,
			companyListLimit: 5,
			showCompanyErrors: false
		};

		$scope.vm = vmObj;

		$scope.formOptions.canCloseForm = false;

		setPageState('loading');

		getCanRunPayrollDetailsForCompanies(vmObj).then(companiesSummaryObj => {

			angular.extend(vmObj, companiesSummaryObj);

			$scope.formOptions.canCloseForm = true;

			setPageState('ready');
		})
		.catch(error => {
			setPageState('error');
			console.error(error);
		});
	}

	function loadNextCompany (vmObj, companiesSummaryObj, resolveQueue, rejectQueue) {

		if (vmObj.cancelSetup) {
			// Stop processing if bulk payroll is cancelled
			return;
		}

		const companyObj = vmObj.agencyProfiles[vmObj.companiesChecked];

		getAlertsDetailsForCompany(vmObj.agencyProfiles[vmObj.companiesChecked]).then(alertsObj => {

			if (alertsObj.ErrorCount > 0 || companyObj.Company.IsPayslipManagerSetupComplete) {
				companiesSummaryObj.companiesWithErrors.push(companyObj);
				companyObj.errorCount = alertsObj.ErrorCount;

			} else {
				companiesSummaryObj.companiesThatCanRun.push(companyObj);
			}

			vmObj.companiesChecked++;
		})
		.catch(error => {
			console.error(error);
			rejectQueue(error);
		})
		.finally(() => {

			if (vmObj.companiesChecked === vmObj.agencyProfilesIds.length) {
				resolveQueue(companiesSummaryObj);

			} else {
				loadNextCompany(vmObj, companiesSummaryObj, resolveQueue, rejectQueue);
			}
		});
	}

	function setPageState (newState) {

		$scope.pageState = newState;
	}

	function toggleErrors (vmObj) {

		vmObj.showCompanyErrors = !vmObj.showCompanyErrors;
	}

	function toggleShowMore (vmObj) {

		vmObj.companyListLimit = vmObj.companyListLimit === 5 ? NaN : 5;
	}

	init();

	$scope.bulkRunPayroll = function (vmObj) {

		bulkRunPayroll(vmObj);
	};

	$scope.cancelBulkPayrollSetup = function (vmObj) {

	    cancelBulkPayrollSetup(vmObj);
	};

	$scope.goToCurrentPeriodAlertsForCompany = function (companyObj) {

	    goToCurrentPeriodAlertsForCompany(companyObj);
	};

	$scope.setPageState = function (newState) {

	    setPageState(newState);
	};

	$scope.toggleErrors = function (vmObj) {

		toggleErrors(vmObj);
	};

	$scope.toggleShowMore = function (vmObj) {

		toggleShowMore(vmObj);
	};
}]);

'use strict';

angular.module('paycircleApp')

.component('salaryChangeForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'salaryChangeFormCtrl',
	templateUrl: 'forms/payroll/salary-change/salary-change.form.html'
})

.controller('salaryChangeFormCtrl', [
	'payrollData',
	function (
		payrollData
	) {

	const $ctrl = this;

	function $onInit () {

		setPageState('loading');

		if ($ctrl.formOptions.useProvidedSalaryChange && $ctrl.formOptions.salaryChange) {
			getSalaryDetailFromSalaryChange();
		}
		else {
			getSalaryDetailForPeriod();
		}
	}

	function getSalaryDetailForPeriod () {

		payrollData.getTeamMemberSalariesForPeriod($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriodId, $ctrl.formOptions.userId)
		 	.then(teamMemberFutureSalaryObj => {

		 		angular.extend($ctrl, {
					currentSalary: teamMemberFutureSalaryObj[0],
					futureSalary: teamMemberFutureSalaryObj[1]
		 		});

				loadForm();
			})
			.catch(onError);
	}

	function getSalaryDetailFromSalaryChange () {

		angular.extend($ctrl, {
			currentSalary: {
				SalaryYearly: $ctrl.formOptions.salaryChange.SalaryYearlyCurrent
			},
			futureSalary: {
				SalaryEffectiveDateISO: $ctrl.formOptions.salaryChange.SalaryEffectiveDateChangeISO,
				SalaryYearly: $ctrl.formOptions.salaryChange.SalaryYearlyChange,
			}
 		});

		loadForm();
	}

	function loadForm () {
		setPageState('ready');
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (newState) {
		$ctrl.pageState = newState;
	}

	angular.extend($ctrl, {
		$onInit,
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('sendDraftPayslipsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'sendDraftPayslipsFormCtrl',
	templateUrl: 'forms/payroll/send-draft-payslips/send-draft-payslips.form.html'
})

.controller('sendDraftPayslipsFormCtrl', [
	'aiServices',
	'growl',
	function (
		aiServices,
		growl
	) {

	const $ctrl = this;

	function $onInit () {
		setComponentState('ready');
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function sendDraftPayslips ($form) {
		$form.state = 'submitting';
		
		aiServices.generateDraftPayslips($ctrl.formOptions.payPeriod.PayPeriodID)
			.then(responseObj => {

				$ctrl.formOptions.forceCallback(responseObj);
				$ctrl.formOptions.closeForm();
				$form.state = 'saved';
				
				growl.success('Sending draft payslips');
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,
		sendDraftPayslips
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('sendNotificationsForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'sendNotificationsFormCtrl',
	templateUrl: 'forms/payroll/sendNotifications/send-notifications.form.html'
})

.controller('sendNotificationsFormCtrl', [
	'payrollWorker',
	'PAYSLIP_MANAGER_STATE',
	function (
		payrollWorker,
		PAYSLIP_MANAGER_STATE
	) {

	const $ctrl = this;

	function $onInit () {
		setComponentState('ready');
	}

	function onError (error) {
		setComponentState('error');
		console.error(error);
	}

	function payrollMailPayslips ($ctrl, $form) {

		$form.state = 'saving';

		payrollWorker.payrollMailPayslips($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.payPeriod.PayPeriodID)
			.then(() => {

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();

				$form.state = 'saved';
			})
			.catch(onError);
	}

	function setComponentState (componentState) {
		$ctrl.componentState = componentState;
	}

	angular.extend($ctrl, {
		$onInit,

		payrollMailPayslips,

		PAYSLIP_MANAGER_STATE
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('sickPayForm', function () {

	return {
		controller: 'sickPayFormCtrl',
		templateUrl: 'forms/payroll/sickPay/sickPayForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('sickPayFormCtrl', [
	'$q',
	'$scope',
	'$timeout',
	'companyData',
	'config',
	'policyService',
	'salaryService',
	'statutoryPaymentService',
	'teamData',
	'utilities',
	'workPatternService',
	'ADJUSTMENT_BEHAVIOUR_STATES',
	'EMPLOYMENT_TYPES',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'POLICY_PAY_BASES',
	'POLICY_SERVICE_ENTITLEMENTS',
	'POLICY_YEAR_BASES_DESCRIPTIONS',
	'PRO_RATION_METHODS',
	'SICK_PAY_TYPES',
	'SIMPLE_WORK_PATTERN_DAYS',
	'STAT_PAYMENT_SCHEDULE_STATES',
	'STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS',
	'STATUTORY_PAY_CALCULATION_METHODS',
	function (
		$q,
		$scope,
		$timeout,
		companyData,
		config,
		policyService,
		salaryService,
		statutoryPaymentService,
		teamData,
		utilities,
		workPatternService,
		ADJUSTMENT_BEHAVIOUR_STATES,
		EMPLOYMENT_TYPES,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_PAY_BASES,
		POLICY_SERVICE_ENTITLEMENTS,
		POLICY_YEAR_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SICK_PAY_TYPES,
		SIMPLE_WORK_PATTERN_DAYS,
		STAT_PAYMENT_SCHEDULE_STATES,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		STATUTORY_PAY_CALCULATION_METHODS
	) {

	// Steps. 3 is conditional and can be stepped over, depending on state.
	const SICKNESS_PAY_STEPS = {
		calculate: 1,
		enterPaymentDetails: 2,
		addSupplementaryOccupationalSickPay: 3,
		reviewSchedule: 4
	};
	const TOTAL_STEPS = 4;

	const TODAY_ISO = moment().format();

	/* Page states can also assume the value of any STAT_PAYMENT_SCHEDULE_STATES value. Those are platform-defined numeric values,
	   so there will never be any conflict. */
	const PAGE_STATES = {
		error: 'error',
		loading: 'loading',
		ready: 'ready',
		success: 'success'
	};

	const agencyProfileId	= $scope.formOptions.agencyProfileId;
	const scheduleId 		= $scope.formOptions.scheduleId;
	const userId 			= $scope.formOptions.userId;

	const isEditing = angular.isDefined(scheduleId) && scheduleId !== null && scheduleId !== '';

	let entitlementFetchPromise = null;

	function createNilSchedule (vmObj, sicknessPayObj, formObj) {

		sicknessPayObj.isNilSchedule = true;

		// Payments already loaded
		if (sicknessPayObj.SchedulePayments.length) {
			setPageState(PAGE_STATES.ready);
			goToNextStep(sicknessPayObj);

			return;
		}

		getSicknessSchedulePayments(vmObj, sicknessPayObj, formObj);
	}

	function decorateSicknessPay (sicknessPayObj, useWorkDayOverride, workDays) {

		// Default to waiting days 'off'.
		angular.extend(sicknessPayObj, {
			Policy: sicknessPayObj.Policy ? policyService.decoratePolicy(sicknessPayObj.Policy, POLICY_CATEGORIES.sickness) : sicknessPayObj.Policy,
			disableSicknessDates: false,
			isNilSchedule: false,
			reviewScheduleView: 'payments',
			step: SICKNESS_PAY_STEPS.calculate,
			UseWorkDayOverride: useWorkDayOverride
		});

		workPatternService.setSicknessPayWorkPatternFromWorkDays(sicknessPayObj, workDays);

		setSickPayLoadingState(sicknessPayObj, 'ready');

		return sicknessPayObj;
	}

	function decorateTeamMemberObj (teamMemberObj) {

		angular.extend(teamMemberObj, {
			hasValidGrossSalary: salaryService.getHasValidGrossSalary(teamMemberObj.Salary),
			hasValidStartDate: angular.isDefined(teamMemberObj.Company.StartDateISO) && teamMemberObj.Company.StartDateISO !== '',
			hasValidContinuousEmploymentStartDate: angular.isDefined(teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO) && teamMemberObj.Company.ContinuousEmployment.ContinuousEmploymentStartDateISO !== ''
		});

		return teamMemberObj;
	}

	function getEndDateMaxDateIso (sicknessPayObj) {

		sicknessPayObj.maxEndDateIso = sicknessPayObj.ScheduleLengthMax >= 0 ? moment(sicknessPayObj.SickDateISO).add(sicknessPayObj.ScheduleLengthMax-1, 'days').format(config.dateFormatISO) : null;
	}

	/* Map sickness status to page state directly, or set page state to ready (if status is OK) or error (if sick pay status not recognised).
	   Valid page states include stat pay states in addition to the standard 'ready', 'error' etc. set */
	function getPageStateForSickPayStatus (vmObj, sickPayObj) {

		const sicknessStatus = sickPayObj.TeamMemberSicknessStatus;

		// If status is ready, page state is ready
		if (sicknessStatus === STAT_PAYMENT_SCHEDULE_STATES.ready) {
			return PAGE_STATES.ready;
		}
		else {
			// Otherwise map the non-OK status to the page state if it's a valid schedule state
			if (Object.values(STAT_PAYMENT_SCHEDULE_STATES).includes(sicknessStatus)) {

				/* If status is scheduleLengthError, only allow OPP and policy selection if there are any sickness policies that
				   don't have PolicyPayBasis === POLICY_PAY_BASES.averageWeeklyPercent */
				if (sicknessStatus === STAT_PAYMENT_SCHEDULE_STATES.scheduleLengthError) {
					// Filter out average weekly percent sickness policies
					const sicknessPoliciesFilter = (sicknessPolicy => sicknessPolicy.PolicyPayBasis !== POLICY_PAY_BASES.averageWeeklyPercent);
					vmObj.sicknessPoliciesFilter = sicknessPoliciesFilter;
					// Set policies applicable flag based on number of available sickness policies
					sickPayObj.isPolicyApplicable = vmObj.sicknessPolicies.filter(sicknessPoliciesFilter).length !== 0;
				}
				else {
					// Filter nothing
					vmObj.policiesFilter = {};
				}

				// The sickness status is a valid page status
				return sicknessStatus;
			}
			else {
				// Unrecognised sick pay status.
				setPageState(PAGE_STATES.error);
			}
		}
	}

	function getSicknessSalaryPayments (vmObj, sicknessPayObj, formObj) {

		setFormState(formObj, 'saving');
		setSickPayLoadingState(sicknessPayObj, 'loading');

		statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

		teamData.getTeamMemberSicknessSalaryPayments(userId, agencyProfileId, sicknessPayObj).then(updatedSickPayObj => {

			angular.extend(sicknessPayObj, {
				CanAddWaitingDays: updatedSickPayObj.CanAddWaitingDays,
				EndDateISO: updatedSickPayObj.EndDateISO,
				EndDateMaxISO: updatedSickPayObj.EndDateMaxISO,
				IsHistoricSchedule: updatedSickPayObj.IsHistoricSchedule,
				IsInProgressSchedule: updatedSickPayObj.IsInProgressSchedule,
				SalaryPayments: updatedSickPayObj.SalaryPayments,
				ScheduleLengthMax: updatedSickPayObj.ScheduleLengthMax,
				SickDateISO: updatedSickPayObj.SickDateISO,
				SicknessType: updatedSickPayObj.SicknessType,
				StartDateISO: updatedSickPayObj.StartDateISO,
				StartDateMinISO: updatedSickPayObj.StartDateMinISO,
				TeamMemberSicknessErrors: updatedSickPayObj.TeamMemberSicknessErrors,
				TeamMemberSicknessStatus: updatedSickPayObj.TeamMemberSicknessStatus,
				WaitingDaysMax: updatedSickPayObj.WaitingDaysMax,

				/* Policy step is ignored if the schedule is historic, or if the platform dicates that a policy can't be used.
				   This can change later depending on stat pay schedule status */
				isPolicyApplicable: !updatedSickPayObj.IsHistoricSchedule && updatedSickPayObj.CanUsePolicy
			});

			// Empty zero payments
			statutoryPaymentService.convertSalaryPaymentsToEmptyIfZero(sicknessPayObj);

			// States
			setPageState(getPageStateForSickPayStatus(vmObj, sicknessPayObj));
			setSickPayLoadingState(sicknessPayObj, 'ready');

			if ($scope.pageState === 'ready') {
				goToNextStep(sicknessPayObj);
			}
		})
		.catch(error => {
			setPageState(PAGE_STATES.error);
			console.error(error);
		});
	}

	function getSicknessSchedulePayments (vmObj, sicknessPayObj, formObj, skipStatusCheck) {

		setFormState(formObj, 'saving');

		/* A check on the sickness status only happens when this is first called, status check can be skipped
		   using skipStatus check. Defaults to false. */
		skipStatusCheck = angular.isDefined(skipStatusCheck) ? skipStatusCheck : false;

		statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

		teamData.getTeamMemberSicknessSchedulePayments(userId, agencyProfileId, sicknessPayObj).then(updatedSickPayObj => {

			angular.extend(sicknessPayObj, {
				IsPaidInFull: updatedSickPayObj.IsPaidInFull,
				PaidInFullPayDateISO: updatedSickPayObj.PaidInFullPayDateISO,
				SchedulePayments: updatedSickPayObj.SchedulePayments,
				StartPayPeriodDisplay: updatedSickPayObj.StartPayPeriodDisplay,
				TeamMemberSicknessStatus: updatedSickPayObj.TeamMemberSicknessStatus,
				TeamMemberSicknessErrors: updatedSickPayObj.TeamMemberSicknessErrors,
				TotalAmount: angular.copy(updatedSickPayObj.TotalAmount),
				TotalAmountPaid: angular.copy(updatedSickPayObj.TotalAmountPaid),
				TotalAmountRemaining: angular.copy(updatedSickPayObj.TotalAmountRemaining),
				TotalBroughtForward: updatedSickPayObj.TotalBroughtForward
			});

			/* If nil schedule is being created, or skip status check is set, set page state to ready,
			   otherwise set page state based on stat payment status */
			let pageState;
			if (sicknessPayObj.isNilSchedule || skipStatusCheck) {
				pageState = PAGE_STATES.ready;
			}
			else {
				// Get page state based on sickness status
				pageState = getPageStateForSickPayStatus(vmObj, sicknessPayObj);
			}
			setPageState(pageState);

			// Progress if page state is ready
			if (pageState === PAGE_STATES.ready) {
				progressStep(sicknessPayObj, 1);
			}

			setFormState(formObj, 'saved');
		})
		.catch(error => {
			setFormState(formObj, null);
			onError(error);
		});
	}

	function getTeamMemberSicknessDates (sicknessPayObj) {

		sicknessPayObj.disableSicknessDates = true;

		if (!sicknessPayObj.IsFromIntegration) {
			angular.extend(sicknessPayObj, {
				SickDateISO: null,
				EndDateISO: null
			});
		}

		statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

		teamData.getTeamMemberSicknessDates(agencyProfileId, userId, sicknessPayObj).then(updatedSicknessPayObj => {

			angular.extend(sicknessPayObj, {
				CanAddWaitingDays: updatedSicknessPayObj.CanAddWaitingDays,
				EndDateISO: updatedSicknessPayObj.EndDateISO,
				ScheduleLengthMax: updatedSicknessPayObj.ScheduleLengthMax,
				SickDateISO: updatedSicknessPayObj.SickDateISO,
				SicknessType: updatedSicknessPayObj.SicknessType,
				StartDateISO: updatedSicknessPayObj.StartDateISO,
				WaitingDaysMax: updatedSicknessPayObj.WaitingDaysMax,
			});

			$timeout(() => {
				sicknessPayObj.disableSicknessDates = false;
			}, 500);
		})
		.catch(onError);
	}

	function goToNextStep (sicknessPayObj) {
		progressStep(sicknessPayObj, +1);
	}

	function goToPreviousStep (sicknessPayObj) {
		progressStep(sicknessPayObj, -1);
	}

	function goToStep (sicknessPayObj, step) {
		sicknessPayObj.step = step;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		const getTeamMemberSicknessPay = teamData.getTeamMemberSicknessPay(userId, agencyProfileId, scheduleId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);
		const getAgencyProfileSickPayDefaultWorkDays = companyData.getAgencyProfileSickPayDefaultWorkDays(agencyProfileId);
		const getAgencyProfileSicknessProRationMethod = companyData.getAgencyProfileSicknessProRationMethod(agencyProfileId);
		/* Need to get policies up front, since for scheduleLengthError status, only non-average weekly policies are applicable, and if none exist,
		   the policy option isn't available. So we need the set of policies in advance of making that decision. */
		const INCLUDE_LEGACY_POLICIES = false;
		const getSicknessPolicies =	policyService.getPoliciesForCategory(agencyProfileId, POLICY_CATEGORIES.sickness, INCLUDE_LEGACY_POLICIES);

		$q.all([
			getTeamMemberSicknessPay,
			getTeamMemberInformation,
			getSicknessPolicies,
			getAgencyProfileSickPayDefaultWorkDays,
			getAgencyProfileSicknessProRationMethod
		]).then(([
			sicknessPayObj,
			teamMemberObj,
			sicknessPoliciesArr,
			sickPayDefaultWorkDays,
			sicknessProRationSettings
		]) => {

			// Force work day override from company settings if paid hourly
			const useWorkDayOverride = teamMemberObj.Salary.EmploymentType === EMPLOYMENT_TYPES.paidHourly;

			// Get work pattern from sick pay default work days
			let workDays = useWorkDayOverride ? sickPayDefaultWorkDays : workPatternService.getDefaultWorkDays();

			// If scheduleId is set, this is an existing schedule, so get the work days from the schedule
			if (isEditing) {
				workDays = workPatternService.getWorkDaysFromSicknessPay(sicknessPayObj);
			}

			// If scheduleId not set and team member has an occupational sick policy code, pre-select that policy
			if (!isEditing && teamMemberObj.Company.OccupationalSicknessPolicyCode) {

				const matchingPolicy = sicknessPoliciesArr.find(policy => policy.PolicyCode === teamMemberObj.Company.OccupationalSicknessPolicyCode);

				if (matchingPolicy) {
					sicknessPayObj.UsePolicy = true;
					sicknessPayObj.Policy = matchingPolicy;
				}
			}

			// If scheduleId not set (new schedule), default pro-ration method from company settings
			if (!isEditing) {
				sicknessPayObj.ProRatingMethod = sicknessProRationSettings.ProRationMethod;
				sicknessPayObj.DisplayLeaveDaysAsSeparateDeduction = sicknessProRationSettings.DisplayLeaveDaysAsSeparateDeduction;
			}

			angular.extend($scope, {
				vm: {
					sicknessPay: decorateSicknessPay(sicknessPayObj, useWorkDayOverride, workDays),
					teamMember: decorateTeamMemberObj(teamMemberObj),
					sicknessPolicies: sicknessPoliciesArr,
					workPattern: workPatternService.getWorkPatternFromWorkDays(workDays),
					disableWorkDayOverrideToggle: useWorkDayOverride,
				}
			});

			setPageState(PAGE_STATES.ready);

			if (!isEditing) {
				$timeout(() => {
					utilities.focusOn('sickdate');
				}, 200);
			}
		})
		.catch(onError);
	}

	function onError (error) {
		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function onUpdateWorkPattern(value){
		$scope.vm.workPattern[value.day]=value.value;
		switch(value.day){
			case SIMPLE_WORK_PATTERN_DAYS.monday:
				$scope.vm.sicknessPay.WorksMonday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.tuesday:
				$scope.vm.sicknessPay.WorksTuesday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.wednesday:
				$scope.vm.sicknessPay.WorksWednesday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.thursday:
				$scope.vm.sicknessPay.WorksThursday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.friday:
				$scope.vm.sicknessPay.WorksFriday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.saturday:
				$scope.vm.sicknessPay.WorksSaturday = value.value;
				break;
			case SIMPLE_WORK_PATTERN_DAYS.sunday:
				$scope.vm.sicknessPay.WorksSunday = value.value;
				break;
		}
	}

	function onSelectSickPayPolicy (sickPayObj, teamMemberObj, isInit) {

		validateSicknessPolicy(sickPayObj, teamMemberObj);

		// Fetch calculated entitlement used when policy is selected
		if (sickPayObj.Policy && sickPayObj.Policy.PolicyID) {
			fetchSicknessEntitlementUsed(sickPayObj, isInit);
		}
	}

	function fetchSicknessEntitlementUsed (sickPayObj, isInit) {

		// Use the sick date if available, otherwise use today's date
		const sicknessDateISO = sickPayObj.SickDateISO || moment().format();
		
		// Exclude current schedule if editing an existing one
		const excludeScheduleId = sickPayObj.OccupationalPaymentScheduleGroupID || null;

		entitlementFetchPromise = teamData.getTeamMemberSicknessEntitlementUsed(
			agencyProfileId,
			userId,
			sickPayObj.Policy.PolicyID,
			sicknessDateISO,
			excludeScheduleId
		).then(entitlementResult => {
			if (entitlementResult && entitlementResult.EntitlementUsedDays !== undefined && entitlementResult.IsOverridden !== undefined) {
				if (!isInit || !entitlementResult.IsOverridden) {
					sickPayObj.OccupationalEntitlementUsed = entitlementResult.EntitlementUsedDays;
				}
				
				// Store the full result for reference (policy year dates, etc.)
				sickPayObj.EntitlementCalculationResult = entitlementResult;
			}
		}).catch(error => {
			console.error('Error fetching sickness entitlement:', error);
		}).finally(() => {
			entitlementFetchPromise = null;
		});
	}

	/*
	 * Move forward or back a step. stepCount can be +ve or -ve; it'll always be interpreted as +ve (forward one) or -ve (back one), keeping
	 * within the bounds of the available steps. It will also decide whether a step is valid and, if it isn't, it'll recall this function to
	 * move over it. That in turn could be skipped, etc.
	 */
	function progressStep (sicknessPayObj, stepDirection) {

		const stepJump = Math.sign(stepDirection);

		// Don't pander to idiocy
		if (stepJump === 0) {
			return;
		}

		// Get the next step
		let nextStep = sicknessPayObj.step + stepJump;

		// Say within bounds
		if (nextStep < 1) {
			nextStep = 1;
		}
		if (nextStep > TOTAL_STEPS) {
			nextStep = TOTAL_STEPS;
		}

		// Set that and decide whether, under the current circumstances, it's a valid step for the user to see
		sicknessPayObj.step = nextStep;

		// Jump non-applicable steps in whichever direction we're travelling in
		if (sicknessPayObj.step === SICKNESS_PAY_STEPS.addSupplementaryOccupationalSickPay && (sicknessPayObj.IsHistoricSchedule || !sicknessPayObj.isPolicyApplicable)) {
			// Policy step not applicable for historic schedules, or when there are no policies to choose from
			progressStep(sicknessPayObj, stepDirection);
		}
		else if (sicknessPayObj.step === SICKNESS_PAY_STEPS.enterPaymentDetails) {
			/* When entering (or passing over) the payment details step, reset the nil schedule indicator, since the status of the schedule
			   could change if the user is going back to edit information. */
			sicknessPayObj.isNilSchedule = false;
			if (sicknessPayObj.TeamMemberSicknessStatus === STAT_PAYMENT_SCHEDULE_STATES.scheduleLengthError) {
				// Payment details not applicable when schedule length is too short
				progressStep(sicknessPayObj, stepDirection);
			}
			else if ([STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient, STAT_PAYMENT_SCHEDULE_STATES.continuousEmploymentInsufficient].includes(sicknessPayObj.TeamMemberSicknessStatus)) {
				// Payment details not applicable
				progressStep(sicknessPayObj, stepDirection);
			}
		}
	}

	function resetPaymentsBroughtForward (sicknessPayObj) {

		angular.extend(sicknessPayObj, {
			AmountBroughtForwardMethod: STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount,
			HasAmountBroughtForward: false,
			PaymentsBroughtForward: [],
			TotalBroughtForward: ''
		});
	}

	function reviewBroughtForwardMethod (sicknessPayObj) {

		if (sicknessPayObj.AmountBroughtForwardMethod === STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount) {
			angular.extend(sicknessPayObj, {
				PaymentsBroughtForward: [],
				TotalBroughtForward: ''
			});
		}
		else {
			sicknessPayObj.paymentsBroughtForwardState = 'loading';

			statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

			teamData.getTeamMemberSicknessDetailsBroughtForward(userId, agencyProfileId, sicknessPayObj).then(updatedSicknessPayObj => {

				sicknessPayObj.PaymentsBroughtForward = updatedSicknessPayObj.PaymentsBroughtForward;

				statutoryPaymentService.convertBroughtForwardPaymentsToEmptyIfZero(sicknessPayObj);

				if (updatedSicknessPayObj.PaymentsBroughtForward.length === 0) {
					sicknessPayObj.paymentsBroughtForwardState = 'empty';
					return;
				}

				sicknessPayObj.paymentsBroughtForwardState = 'ready';
			})
			.catch((error) => {
				sicknessPayObj.paymentsBroughtForwardState = null;
				onError(error);
			});
		}
	}

	function saveSicknessPay (sicknessPayObj, formObj) {

		formObj.state = 'saving';

		statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

		var doSave = () => {
				teamData.updateTeamMemberSicknessSchedulePayments(userId, agencyProfileId, sicknessPayObj).then(() => {

				formObj.state = 'saved';

				// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
				$scope.formOptions.initCallbackOnClose = true;

				setPageState(PAGE_STATES.success);
			})
			.catch(onError);
		};

		 if (entitlementFetchPromise) {
			entitlementFetchPromise.finally(doSave);
		} else {
			doSave();
		}
	}

	function setFormState (formObj, state) {

		formObj.state = state;
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function setSickPayLoadingState (sicknessPayObj, state) {

		sicknessPayObj.loadingState = state;
	}

	function sickPayEndDateChanged (sicknessPayObj) {

		setSickPayLoadingState(sicknessPayObj, 'loading');

		statutoryPaymentService.reviewEmptyValues(sicknessPayObj);

		teamData.getTeamMemberSicknessDates(agencyProfileId, userId, sicknessPayObj).then(updatedSicknessPayObj => {

			angular.extend(sicknessPayObj, {
				IsInProgressSchedule: updatedSicknessPayObj.IsInProgressSchedule,
				IsHistoricSchedule: updatedSicknessPayObj.IsHistoricSchedule
			});

			resetPaymentsBroughtForward(sicknessPayObj);

			setSickPayLoadingState(sicknessPayObj, 'ready');
		})
		.catch(onError);
	}

	function sickPayStartDateChanged (sicknessPayObj) {

		resetPaymentsBroughtForward(sicknessPayObj);
	}

	function validateSicknessPolicy (sickPayObj, teamMemberObj) {

		// Get selected policy for convenience
		let sickPayPolicy = sickPayObj.Policy;

		// If set, do some validation
		if (sickPayPolicy) {

			// Selection OK by default
			angular.extend(sickPayPolicy, {
				isValid: true,
				noAnnualSalarySaved: false,
				noStartOrContinuousEmploymentDateSaved: false
			});

			/* "% of annual salary" policies require a valid salary */
			if (sickPayPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalaryPercent && !teamMemberObj.hasValidGrossSalary) {

				angular.extend(sickPayPolicy, {
					isValid: false,
					noAnnualSalarySaved: true
				});
			}

			/* If policy is length of service based but the team member has no defined start date and no continuous
			   employment start date, that's an invalid selection */
			if (sickPayPolicy.PolicyServiceEntitlement !== POLICY_SERVICE_ENTITLEMENTS.none && !teamMemberObj.hasValidStartDate && !teamMemberObj.hasValidContinuousEmploymentStartDate) {

				angular.extend(sickPayPolicy, {
					isValid: false,
					noStartOrContinuousEmploymentDateSaved: true
				});
			}
		}
	}

	init();

	angular.extend($scope, {

		// Constants
		ADJUSTMENT_BEHAVIOUR_STATES,
		PAGE_STATES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		POLICY_SERVICE_ENTITLEMENTS,
		POLICY_YEAR_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SICKNESS_PAY_STEPS,
		STAT_PAYMENT_SCHEDULE_STATES,
		SICK_PAY_TYPES,
		STATUTORY_PAY_CALCULATION_METHODS,
		STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS,
		TODAY_ISO,

		// Services
		policyService,
		utilities,

		// Functions
		createNilSchedule,
		getEndDateMaxDateIso,
		getIsStatPaymentSalarySacrificeReadOnly: statutoryPaymentService.getIsStatPaymentSalarySacrificeReadOnly,
		getSicknessSalaryPayments,
		getSicknessSchedulePayments,
		getTeamMemberSicknessDates,
		goToNextStep,
		goToPreviousStep,
		goToStep,
		onSelectSickPayPolicy,
		reviewBroughtForwardMethod,
		reviewStatPaymentSalarySacrifice: statutoryPaymentService.reviewStatPaymentSalarySacrifice,
		saveSicknessPay,
		setPageState,
		sickPayStartDateChanged,
		sickPayEndDateChanged,
		onUpdateWorkPattern
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('sickPayViewForm', function () {

	return {
		controller: 'sickPayViewFormCtrl',
		templateUrl: 'forms/payroll/sickPay/sickPayViewForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('sickPayViewFormCtrl', [
	'$scope',
	'config',
	'edpTopicService',
	'policyService',
	'statutoryPaymentService',
	'teamData',
	'userData',
	'utilities',
	'POLICY_CATEGORIES',
	'POLICY_PAY_BASES_DESCRIPTIONS',
	'PRO_RATION_METHODS',
	'SCHEDULE_UPDATE_REASONS',
	'SIMPLE_WORK_PATTERN_DAYS',
	function (
		$scope,
		config,
		edpTopicService,
		policyService,
		statutoryPaymentService,
		teamData,
		userData,
		utilities,
		POLICY_CATEGORIES,
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		SIMPLE_WORK_PATTERN_DAYS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const callback = $scope.formOptions.callback;
	const scheduleId = $scope.formOptions.scheduleID;
	const userId = $scope.formOptions.userId;

	function convertSalaryPaymentsToZeroIfEmpty (sicknessPayObj) {

		sicknessPayObj.SalaryPayments.forEach((paymentObj) => {
			paymentObj.PaymentAmount = utilities.setPropertyValueToZeroIfEmpty(paymentObj.PaymentAmount);
		});
	}

	function deleteSicknessPay (vmObj, formObj) {

		if (vmObj.sicknessPay.IsFromIntegration) {
			setPageState('ready');
			return;
		}

		formObj.state = 'saving';

		teamData.deleteTeamMemberStatutoryPay(agencyProfileId, vmObj.sicknessPay.PaymentScheduleGroupID).then(() => {

			formObj.state = 'saved';

			// Force the callback on close, otherwise the state change in the callback will trigger closing of the form
			$scope.formOptions.initCallbackOnClose = true;

			setPageState('deleted');
		})
		.catch(onError);
	}

	function getSicknessUpdateOptions (sicknessPayObj) {

		const allOptions = statutoryPaymentService.getScheduleUpdateOptions('sick', $scope.formOptions.context);

		if (!sicknessPayObj.IsFromIntegration) {
			return allOptions;
		}

		const payrollOnlyReasons = [SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.SalaryUpdate];

		return allOptions.filter((option) => payrollOnlyReasons.includes(option.value));
	}

	function init (_scheduleID) {

		setPageState('loading');

		const getSicknessSchedule = teamData.getTeamMemberSicknessSchedulePaymentsForSchedule(agencyProfileId, userId, _scheduleID);

		getSicknessSchedule.then(sicknessPayObj => {

			const workPattern =
				[
					{day:SIMPLE_WORK_PATTERN_DAYS.monday, value: sicknessPayObj.WorksMonday},
					{day:SIMPLE_WORK_PATTERN_DAYS.tuesday, value: sicknessPayObj.WorksTuesday},
					{day:SIMPLE_WORK_PATTERN_DAYS.wednesday, value: sicknessPayObj.WorksWednesday},
					{day:SIMPLE_WORK_PATTERN_DAYS.thursday, value: sicknessPayObj.WorksThursday},
					{day:SIMPLE_WORK_PATTERN_DAYS.friday, value: sicknessPayObj.WorksFriday},
					{day:SIMPLE_WORK_PATTERN_DAYS.saturday, value: sicknessPayObj.WorksSaturday},
					{day:SIMPLE_WORK_PATTERN_DAYS.sunday, value: sicknessPayObj.WorksSunday}
				];


			angular.extend(sicknessPayObj, {
				Policy: sicknessPayObj.Policy ? policyService.decoratePolicy(sicknessPayObj.Policy, POLICY_CATEGORIES.sickness) : sicknessPayObj.Policy,
				endDateIsoOriginal: angular.copy(sicknessPayObj.EndDateISO),
				reviewScheduleView: 'payments'
			});

			$scope.vm = {
				// Save original values for propetries so that they can be used once schedule has been updated
				canBeDeletedOriginal: sicknessPayObj.CanBeDeleted,
				canBeExtendedOriginal: sicknessPayObj.CanBeExtended,
				canCancelExtensionOriginal: sicknessPayObj.CanCancelExtension,
				canUndoUpdateInProgressOriginal: sicknessPayObj.CanUndoUpdateInProgress,
				canUpdateInProgressOriginal: sicknessPayObj.CanUpdateInProgress,
				edpTopicMessage: sicknessPayObj.IsFromIntegration ? edpTopicService.getPaymentScheduleMessage(edpTopicService.TOPIC_KEYS.sickness) : '',
				isEdpSicknessSchedule: !!sicknessPayObj.IsFromIntegration,
				isExtendedOriginal: sicknessPayObj.IsExtended,
				isUpdatedOriginal: sicknessPayObj.IsUpdated,

				sicknessPay: sicknessPayObj,
				updateReason: null,
				workPattern: workPattern
			};

			$scope.SICKNESS_UPDATE_OPTIONS = getSicknessUpdateOptions(sicknessPayObj);
			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onExtendScheduleClick (vmObj) {

		if (vmObj.sicknessPay.IsFromIntegration) {
			setPageState('ready');
			return;
		}

		setPageState('loading');

		convertSalaryPaymentsToZeroIfEmpty(vmObj.sicknessPay);

		teamData.getTeamMemberSicknessSchedulePaymentsForScheduleUpdate(agencyProfileId, userId, vmObj.sicknessPay).then((updatedSicknessPayObj) => {

			angular.extend(vmObj.sicknessPay, updatedSicknessPayObj);

			setPageState('extend-schedule');

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function onUpdateReasonChange (sicknessPayObj) {
		sicknessPayObj.EndDateISO = '';
	}

	function onUpdateScheduleCancelClick (sicknessPayObj) {

		sicknessPayObj.EndDateISO = sicknessPayObj.endDateIsoOriginal;

		setPageState('ready');
	}

	function onUpdateScheduleClick (vmObj) {

		setPageState('loading');

		convertSalaryPaymentsToZeroIfEmpty(vmObj.sicknessPay);

		teamData.getTeamMemberSicknessSchedulePaymentsForScheduleUpdate(agencyProfileId, userId, vmObj.sicknessPay).then((updatedSicknessPayObj) => {

			angular.extend(vmObj.sicknessPay, updatedSicknessPayObj);
			
			angular.extend(vmObj.sicknessPay, {
				endDateMinIso: moment(vmObj.sicknessPay.EndDateISO).add(1, 'day').format(config.dateFormatISO),
				endDateMaxIso: moment(vmObj.sicknessPay.EndDateISO).subtract(1, 'day').format(config.dateFormatISO),
				endDateIsoOriginal: angular.copy(vmObj.sicknessPay.EndDateISO),
				EndDateISO: ''
			});

			vmObj.updateReason = null;

			setPageState('update-in-progress-schedule');	

		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateSicknessPay (sicknessPayObj) {

		$scope.formOptions.openNewSlideInForm({
			formKey: 'sick-pay',
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			scheduleId: sicknessPayObj.PaymentScheduleGroupID,
			userId: userId
		});
	}

	function updateTeamMemberSchedulePaymentsProRatingMethod (sicknessPayObj, formObj) {

		formObj.state = 'saving';

		userData.updateTeamMemberSchedulePaymentsProRatingMethod(sicknessPayObj.PaymentScheduleGroupID, sicknessPayObj.ProRatingMethod, sicknessPayObj.DisplayLeaveDaysAsSeparateDeduction).then(() => {

			setPageState('ready');
			formObj.state = 'saved';
		}).catch((error) => {
			console.error(error);
			setPageState('error');
		});
	}

	function updateTeamMemberSicknessScheduleInProgress (vmObj, formObj, updateKey) {

		if (updateKey === 'extend-schedule' && vmObj.sicknessPay.IsFromIntegration) {
			setPageState('ready');
			return;
		}

		formObj.state = 'saving';

		if (vmObj.updateReason === SCHEDULE_UPDATE_REASONS.CorrectGrossPay) {
			vmObj.sicknessPay.EndDateISO = vmObj.sicknessPay.endDateIsoOriginal;
		}

		if (updateKey === 'extend-schedule') {
			vmObj.updateReason = SCHEDULE_UPDATE_REASONS.CorrectEndDate;
		}

		teamData.updateTeamMemberSicknessScheduleInProgress(agencyProfileId, userId, vmObj.sicknessPay, vmObj.updateReason).then(updatedSicknessPayObj => {

			formObj.state = 'saved';

			angular.extend(vmObj.sicknessPay, updatedSicknessPayObj);


			switch (updateKey) {
				case 'extend-schedule':
					setPageState('confirm-extend-schedule');
					break;

				default:
					setPageState('ready');
					break;
			}
		})
		.catch(onError);
	}

	function updateTeamMemberSicknessScheduleInProgressReset (vmObj, formObj) {

		formObj.state = 'saving';

		teamData.updateTeamMemberSicknessScheduleInProgressReset(agencyProfileId, userId, vmObj.sicknessPay.PaymentScheduleGroupID).then(() => {

			formObj.state = 'saved';

			$scope.formOptions.callback();
			init(vmObj.sicknessPay.PaymentScheduleGroupID);
		})
		.catch(onError);
	}

	function updateTeamMemberSicknessSchedulePayments (vmObj) {

		convertSalaryPaymentsToZeroIfEmpty(vmObj.sicknessPay);

		teamData.updateTeamMemberSicknessSchedulePayments(userId, agencyProfileId, vmObj.sicknessPay, vmObj.updateReason).then(response => {

			$scope.formOptions.callback();
			init(response.PaymentScheduleGroupID);
		})
		.catch(onError);
	}

	init(scheduleId);

	angular.extend($scope, {
		POLICY_PAY_BASES_DESCRIPTIONS,
		PRO_RATION_METHODS,
		SCHEDULE_UPDATE_REASONS,
		SICKNESS_UPDATE_OPTIONS: [],

		deleteSicknessPay,
		init,
		onExtendScheduleClick,
		onUpdateReasonChange,
		onUpdateScheduleCancelClick,
		onUpdateScheduleClick,
		setPageState,
		updateSicknessPay,
		updateTeamMemberSchedulePaymentsProRatingMethod,
		updateTeamMemberSicknessScheduleInProgress,
		updateTeamMemberSicknessScheduleInProgressReset,
		updateTeamMemberSicknessSchedulePayments
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('submitChangesTableForm', function () {

	return {
		controller: 'submitChangesTableFormCtrl',
		templateUrl: 'forms/payroll/submitChangesTable/submitChangesTableForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('submitChangesTableFormCtrl', [
	'$scope',
	'growl',
	'messageData',
	'WORKFLOW_CHANGES_TABLE_STATES',
function (
	$scope,
	growl,
	messageData,
	WORKFLOW_CHANGES_TABLE_STATES
) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('ready');
	}

	function submitChangesTable (form) {

		form.state = 'saving';

		/* Mark the changes table as submitted; this is for a non-workflow company. The changes table submission is being piggy-backed
		   on the workflow functionality */
		messageData.updateWorkflowTemplateChangesTableState(agencyProfileId, WORKFLOW_CHANGES_TABLE_STATES.submitted).then(() => {
			form.state = 'saved';
			growl.success('Your changes have been submitted for review');
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(error => {
			form.state = '';
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		submitChangesTable
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('submitEpsForm', function () {

	return {
		controller: 'submitEpsFormCtrl',
		templateUrl: 'forms/payroll/submitEps/submitEpsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('submitEpsFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'agency',
	'config',
	'payrollData',
	'payrollWorker',
	'session',
	'utilities',
	'BUSINESS_SECTORS',
	'SUBMISSION_STATES',
	function (
		$q,
		$rootScope,
		$scope,
		$timeout,
		agency,
		config,
		payrollData,
		payrollWorker,
		session,
		utilities,
		BUSINESS_SECTORS,
		SUBMISSION_STATES
	) {

	const EPS_POLL_INTERVAL_SECONDS = 3;

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriodId = $scope.formOptions.payPeriodId;

	function cancelSubmitEps (manualEpsObj) {

		// Delete the manual EPS entry if one has been created
		if (angular.isDefined(manualEpsObj.ManualEPSID) && manualEpsObj.ManualEPSID !== config.guidEmpty) {
			setPageState('cancelling');
			payrollData.deleteManualEPS(manualEpsObj.ManualEPSID).then(() => {
				$scope.formOptions.closeForm();
			})
			.catch(onError);
		}
		else {
			$scope.formOptions.closeForm();
		}
	}

	function decorateManualSubmission (manualEpsObj) {

		angular.extend(manualEpsObj, {
			// EPS is not submitted in some scenarios (eg, EA difference only)
			isEPSSubmissionRequired: true
		});
	}

	function init () {

		setPageState('loading');

		const getManualEPSForPeriod = payrollData.getManualEPSForPeriod(payPeriodId);
		const getNamesOfOtherCompaniesOnPAYEScheme = agency.getNamesOfOtherCompaniesOnPAYEScheme(agencyProfileId, session.getAgencyProfileParentId(), false);

		$q.all([
			getManualEPSForPeriod,
			getNamesOfOtherCompaniesOnPAYEScheme
		])
		.then(([
			manualEpsObj,
			otherCompaniesArr
		]) => {

			decorateManualSubmission(manualEpsObj);

			angular.extend($scope, {
				manualEps: manualEpsObj,
				otherCompanies: otherCompaniesArr,
			});

			// EA auto-reclaim alert
			if (utilities.getIsPreviousTaxYearSubmission(manualEpsObj.ManualEPSTaxYear, $rootScope.currentPeriod.TaxYear)) {
				setPageState('alert');
				return;
			}

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function onFormSubmit (manualEpsObj, agencyProfileId,  payPeriodId) {

		// Show comms about EA-only difference, if only the EA field has a value higher or lower than zero
		if (manualEpsObj.showManualEPSEAWarning) {

			// Prevent submission later
			manualEpsObj.isEPSSubmissionRequired = false;

			setPageState('eps-wont-be-submitted');
			return;
		} else {

			// Enable submission again
			manualEpsObj.isEPSSubmissionRequired = true;
		}

		submitEps(manualEpsObj, agencyProfileId,  payPeriodId);
	}

	function pollEpsSubmissionState (manualEpsObj) {

		payrollData.getManualEPSSubmissionState(manualEpsObj.ManualEPSID).then(submissionState => {

			// Update submission state on EPS object
			manualEpsObj.ManualEPSSubmissionState = submissionState;

			// Retry after a delay if still submitting
			if (submissionState === SUBMISSION_STATES.unsubmitted || submissionState === SUBMISSION_STATES.submitting) {
				$timeout(() => {
					pollEpsSubmissionState(manualEpsObj);
				}, EPS_POLL_INTERVAL_SECONDS * 1000);
			}
		})
		.catch(onError);
	}

	function resetSubmissionState (manualEpsObj) {
		manualEpsObj.ManualEPSSubmissionState = SUBMISSION_STATES.unsubmitted;
		setPageState('ready');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function submitEps (manualEpsObj, agencyProfileId, payPeriodId) {

		// Give instant feedback in the UI that submission is underway
		if (manualEpsObj.isEPSSubmissionRequired) {
			setPageState('submitted');
		} else {
			setPageState('loading');
		}


		// Start by updating / saving the manual EPS object
		payrollData.updateManualEPS(manualEpsObj).then(() => {

			if (manualEpsObj.isEPSSubmissionRequired) {
				// Now get the eps object (if it's new, new IDs will be available here)
				payrollData.getManualEPSForPeriod(payPeriodId).then(manualEpsObjUpdated => {

					// Update the ManualEPSID. This is the only bit we're really interested in
					manualEpsObj.ManualEPSID = manualEpsObjUpdated.ManualEPSID;

					// Finally submit the EPS
					payrollWorker.payrollSubmitManualEPS(manualEpsObj.ManualEPSID, agencyProfileId).then(() => {

						// Start polling the submission state
						pollEpsSubmissionState(manualEpsObj);
					});
				});
			}
			else {
				// Go direct to submitted state if no submission is necessary
				manualEpsObj.ManualEPSSubmissionState = SUBMISSION_STATES.submitted;
				setPageState('submitted');
			}

		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {

		// Constants
		BUSINESS_SECTORS,
		SUBMISSION_STATES,

		// Variables
		agencyProfileId,
		payPeriodId,

		// Functions
		cancelSubmitEps,
		init,
		onFormSubmit,
		resetSubmissionState,
		setPageState,
		submitEps
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('supplementaryPayRunForm', function () {

	return {
		controller: 'supplementaryPayRunFormCtrl',
		templateUrl: 'forms/payroll/supplementary-pay-run/supplementary-pay-run.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('supplementaryPayRunFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$state',
	'$timeout',
	'adjustmentsService',
	'companyData',
	'config',
	'journalsService',
	'payrollData',
	'payrollWorker',
	'pensionService',
	'reportData',
	'reportsService',
	'teamData',
	'userData',
	'utilities',
	'SUBMISSION_LOG_TYPE',
	'SUBMISSION_STATES',
	'SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES',
	function (
		$q,
		$rootScope,
		$scope,
		$state,
		$timeout,
		adjustmentsService,
		companyData,
		config,
		journalsService,
		payrollData,
		payrollWorker,
		pensionService,
		reportData,
		reportsService,
		teamData,
		userData,
		utilities,
		SUBMISSION_LOG_TYPE,
		SUBMISSION_STATES,
		SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES
	) {

	var   IGNORE_ADMINS; // Undefined > Use default
	const IGNORE_FUTURE_STARTERS = false;
	const INCLUDE_BACKPAY = true;
	var   INCLUDE_INCOMPLETE; // Undefined > Use default
	const INCLUDE_LEAVERS = true;
	const IS_PREVIOUS_PERIOD = true;
	const OLDER_SUPPLEMENTARY_PAYMENT_ERROR_MESSAGE = 'This draft is for a past period. Supplementary runs can only be completed for the latest period. Roll back to make that period current, or start a new supplementary run for the latest period.';
	const UPDATE_OLDER_SUPPLEMENTARY_PAYMENT_ERROR = 'SupplementaryPayment is related to an older period than most recently submitted period';	

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const supplementaryPaymentId = $scope.formOptions.supplementaryPaymentId;
	const userIds = $scope.formOptions.userIds;
	const isDownloadReports = $scope.formOptions.isDownloadReports;

	function addActiveAdjustmentToSupplementaryPayments (vmObj) {

		let activeTeamMemberObj = vmObj.teamMembers[vmObj.activeTeamMemberIndex];

		// Add business code overrides
		const salaryPolicyPostId = angular.isDefined(vmObj.activeAdjustment.newAdjustment.SalaryPolicyPostID) ? vmObj.activeAdjustment.newAdjustment.SalaryPolicyPostID : config.guidEmpty;
		const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(vmObj.emptyUserAgencyProfileBusinessCode, agencyProfileId, activeTeamMemberObj.UserID, salaryPolicyPostId);

		// Any adjustments updated in the UI can be edited (as opposed to Backpay elements)
		angular.extend(vmObj.activeAdjustment.newAdjustment, {
			canDelete: true,
			canEdit: true,
			UserAgencyProfileBusinessCodeOverrides: journalsService.getOnlySelectedBusinessCodesFromBusinessCategories(vmObj.activeAdjustment.newAdjustment.businessCategories, emptyUserAgencyProfileBusinessCode)
		});

		// Update
		if (vmObj.activeAdjustment.isEditing) {
			activeTeamMemberObj.adjustments[vmObj.activeAdjustmentIndex] = angular.copy(vmObj.activeAdjustment.newAdjustment);
		}

		// Add
		else {
			activeTeamMemberObj.adjustments.push(angular.copy(vmObj.activeAdjustment.newAdjustment));
		}

		// Apply to everyone else
		if (vmObj.activeAdjustment.newAdjustment.isApplyToAll) {

			vmObj.teamMembers.forEach(teamMemberObj => {

				if (teamMemberObj.UserID !== activeTeamMemberObj.UserID) {
					teamMemberObj.adjustments.push(angular.copy(vmObj.activeAdjustment.newAdjustment));
				}
			});
		}

		// Attach tooltips for Pension elements
		for (let adjustmentObj of activeTeamMemberObj.adjustments) {
			if (adjustmentObj.AgencyEmployerPensionID !== config.guidEmpty) {

				const selectedPensionObj = activeTeamMemberObj.pensions.find(teamMemberPensionObj => teamMemberPensionObj.AgencyEmployerPensionID === adjustmentObj.AgencyEmployerPensionID);

				let pensionTooltipLabel = `${selectedPensionObj.PensionProviderName} ${selectedPensionObj.EmployerReference}`;
				// Append additional post title if applicable
				if (selectedPensionObj.IsAdditionalPost) {
					pensionTooltipLabel += ` (${selectedPensionObj.SalaryPolicyPostTitle})`;
				}

				adjustmentObj.Tooltip = pensionTooltipLabel;
			}
		}

		calculateTotalCounts(vmObj);

		setPageState('adjustments-overview');
	}

	function addPayElementForTeamMember (vmObj, teamMemberIndex) {

		setActiveAdjustment(vmObj, teamMemberIndex);
		setPageState('adjustment-builder');
	}

	function calculateTotalCounts (vmObj) {

		angular.extend(vmObj, {
			isBulkOperation: false,
			totalAdjustmentCount: 0,
			totalTeamMembersCount: 0
		});

		vmObj.teamMembers.forEach(teamMemberObj => {
			vmObj.totalAdjustmentCount += teamMemberObj.adjustments.length;

			// To know whether this is a bulk process
			if (teamMemberObj.adjustments.length > 0) {
				vmObj.totalTeamMembersCount += 1;
			}
		});

		if (vmObj.totalTeamMembersCount > 1) {
			vmObj.isBulkOperation = true;
		}
	}

	function decorateTeamMember (teamMemberObj) {

		teamMemberObj.adjustments = [];
		teamMemberObj.isChecked = false;

		// Backpay
		if (teamMemberObj.Backpay.length > 0) {

			teamMemberObj.Backpay.forEach(backPayElement => {

				angular.extend(backPayElement, {
					canDelete: true,
					canEdit: false
				});
			});

			teamMemberObj.adjustments = teamMemberObj.adjustments.concat(teamMemberObj.Backpay);
		}
	}

	function deleteAdjustment (vmObj, teamMemberIndex, adjustmentIndex) {

		vmObj.teamMembers[teamMemberIndex].adjustments.splice(adjustmentIndex, 1);

		calculateTotalCounts(vmObj);
	}

	function deleteSupplementaryPayment (vmObj, formObj) {

		formObj.state = 'saving';

		payrollData.deleteSupplementaryPayment(vmObj.agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID).then(() => {
			$scope.formOptions.closeForm();

			$state.go('payroll.history.supplementary-pay-runs', {
				agencyProfileId: vmObj.agencyProfileId
			}, {
				reload: true
			});
		})
		.catch(onError);
	}

	function editAdjustment (vmObj, teamMemberIndex, adjustmentIndex) {

		setActiveAdjustment(vmObj, teamMemberIndex, adjustmentIndex);

		setPageState('adjustment-builder');
	}

	function editSelectedLeavers (vmObj) {

		// Reset leavers array to original list
		vmObj.leavers = angular.copy(vmObj.leaversOriginal);

		setPageState('review-leavers');
	}

	function filterTeamMembersByUserIds (vmObj, applicableUserIds, INCLUDE_STARTERS_AND_LEAVERS) {

		const teamMembersAllArr = vmObj.teamMembers.filter(teamMemberObj => {

			if (applicableUserIds.includes(teamMemberObj.UserID)) {

				decorateTeamMember(teamMemberObj);

				return teamMemberObj;
			}
		});

		angular.extend(vmObj, {
			excludedFromRti: angular.copy(teamMembersAllArr.filter(_ => _.IsExcludedFromRTI)),
			leaversOriginal: INCLUDE_STARTERS_AND_LEAVERS ? angular.copy(teamMembersAllArr).filter(_ => _.IsLeaving) : [], // Take a snapshot in case the leavers list is edited
			leavers: INCLUDE_STARTERS_AND_LEAVERS ? angular.copy(teamMembersAllArr).filter(_ => _.IsLeaving) : [],
			starters: INCLUDE_STARTERS_AND_LEAVERS ? angular.copy(teamMembersAllArr).filter(_ => _.IsStarting) : [],
			teamMembers: teamMembersAllArr
		});
	}

	function generateReports (vmObj) {
		reportData.createSupplementaryPaymentReports(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID).then(reportsArr => {
			vmObj.reports = reportsArr;

			setPageState('review-reports');
		})
		.catch(onError);
	}

	function getAdjustmentCountLabel (vmObj) {

		if (vmObj.totalAdjustmentCount === 1) {
			return `1 change`;
		}

		return `${vmObj.totalAdjustmentCount} changes`;
	}

	function getAdjustmentDescription (adjustmentObj) {

		if (adjustmentObj.Label !== '') {
			return adjustmentObj.Label;
		}

		if (adjustmentObj.Description !== '') {
			return adjustmentObj.Description;
		}

		if (angular.isDefined(adjustmentObj.adjustmentType)) {
			return adjustmentObj.adjustmentType.AgencyAdjustmentGroupEntryText;
		}

		return '';
	}

	function getAdjustmentValueDisplayClass(adjustmentObj) {
		let cssClass;
		if (adjustmentObj.Deduction) {
			cssClass = adjustmentObj.Value < 0 ? 'is-positive' : 'is-assertive';
		} else {
			cssClass = adjustmentObj.Value > 0 ? 'is-positive' : 'is-assertive';
		}

		return cssClass;
	}

	function getLabel (vmObj, labelKey) {

		switch (labelKey) {
			case 'leavers':
				return vmObj.leavers.length + (vmObj.leavers.length === 1 ? ' leaver' : ' leavers');
			case 'starters':
				return vmObj.starters.length + (vmObj.starters.length === 1 ? ' new starter' : ' new starters');
		}
	}

	function getLabelForAdjustmentObj (adjustmentObj) {

		// If adjustment type is not attached it's an existing adjustment, so use the Label defined
		if (angular.isDefined(adjustmentObj.adjustmentType)) {

			return adjustmentObj.Label ? adjustmentObj.Label : adjustmentObj.adjustmentType.AgencyAdjustmentGroupEntryText;
		}

		return adjustmentObj.Label;
	}

	function getNextPageState () {

		if ($scope.pageState === 'bacs-files-options' ||
			$scope.pageState === 'loading' ||
			$scope.pageState === 'rti-submission-disabled' ||
			$scope.pageState === 'previous-tax-year' ||
			$scope.pageState === 'pension-submitted') {
			return 'generating-documents';
		}

		if ($scope.pageState === 'report-options') {
			return $scope.formOptions.company.IsBACSEnabled ?
				'bacs-files-options' :
				'generating-documents';
		}
	}

	function getPayElementDetailForAdjustment (vmObj, teamMemberIndex, adjustmentIndex) {

		const teamMemberObj = vmObj.teamMembers[teamMemberIndex];

		if (angular.isUndefined(teamMemberObj)) {
			throw('Team member is not defined');
		}

		const adjustmentObj = teamMemberObj.adjustments[adjustmentIndex];

		if (angular.isUndefined(adjustmentObj)) {
			throw('Adjustment is not defined');
		}

		// Reset apply to all toggle
		adjustmentObj.isApplyToAll = false;

		return adjustmentObj;
	}

	function getPreviousPageState () {

		if ($scope.pageState === 'review-reports') {
			return $scope.formOptions.company.IsBACSEnabled ?
				'bacs-files-options' :
				'report-options';
		}

		if ($scope.pageState === 'review-reports') {
			return 'report-options';
		}
	}

	function getReportsForSupplementaryPayment (vmObj) {

		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific(vmObj.supplementaryPayment.AgencyPayPeriodID);
		const getClassicReports = reportData.getClassicReports(agencyProfileId, vmObj.supplementaryPayment.AgencyPayPeriodID, vmObj.supplementaryPayment.SupplementaryPaymentID);
		const getCustomReports = reportData.getCustomReports(agencyProfileId, vmObj.supplementaryPayment.AgencyPayPeriodID, vmObj.supplementaryPayment.SupplementaryPaymentID);

		return $q((onComplete, onError) => {
			$q.all([
				getPayPeriodSpecific,
				getClassicReports,
				getCustomReports
			]).then(([
				reportPeriodObj,
				classicReportsArr,
				customReportsArr
			]) => {

				angular.extend(vmObj, {
					classicReports: classicReportsArr,
					combinedReports: customReportsArr,
					reportPeriod: reportPeriodObj
				});

			})
			.finally(onComplete)
			.catch(onError);
		});

	}

	function getSupplementaryAdjustments (vmObj) {

		let returnArr = [];

		// Team members
		vmObj.teamMembers.forEach(teamMemberObj => {

			// Pay elements
			teamMemberObj.adjustments.forEach(adjustment => {

				// Add business code overrides
				const salaryPolicyPostId = angular.isDefined(adjustment.SalaryPolicyPostID) ? adjustment.SalaryPolicyPostID : config.guidEmpty;
				const emptyUserAgencyProfileBusinessCode = journalsService.decorateEmptyUserAgencyProfileBusinessCode(vmObj.emptyUserAgencyProfileBusinessCode, agencyProfileId, teamMemberObj.UserID, salaryPolicyPostId);

				// Convert pay element to Sup. pay element. (adjustmentType is only available for new or edited pay elements - that have passed through the <change-creator> component)
				returnArr.push(angular.extend(adjustment, {
					AgencyProfileID: vmObj.agencyProfileId,
					AgencyAdjustmentGroupEntryID: angular.isDefined(adjustment.adjustmentType) ? adjustmentsService.getAgencyAdjustmentGroupEntryId(adjustment.adjustmentType) : adjustment.AgencyAdjustmentGroupEntryID,
					Label: getLabelForAdjustmentObj(adjustment),
					PayPeriodID: vmObj.payPeriodPrevious.PayPeriodID,
					Units: utilities.setPropertyValueToZeroIfEmpty(adjustment.Units),
					UnitValue: utilities.setPropertyValueToZeroIfEmpty(adjustment.UnitValue),
					UserAgencyProfileBusinessCodeOverrides: journalsService.getOnlySelectedBusinessCodesFromBusinessCategories(adjustment.businessCategories, emptyUserAgencyProfileBusinessCode),
					UserForename: angular.copy(teamMemberObj.Forename),
					UserSurname: angular.copy(teamMemberObj.Surname),
					UserID: angular.copy(teamMemberObj.UserID),
					Value: utilities.setPropertyValueToZeroIfEmpty(adjustment.Value)
				}));
			});
		});

		return returnArr;
	}

	function getSupplementaryPayDescription (vmObj) {

		let returnString = '';

		// Changes
		if (vmObj.totalAdjustmentCount === 1) {
			returnString += `${vmObj.totalAdjustmentCount} change`;
		}
		else {
			returnString += `${vmObj.totalAdjustmentCount} changes`;
		}

		// Leavers
		if (vmObj.leavers.length > 0) {
			if (vmObj.leavers.length === 1) {
				returnString += `, 1 leaver`;
			}
			else {
				returnString += `, ${vmObj.leavers.length} leavers`;
			}
		}

		// Starters
		if (vmObj.starters.length > 0) {
			if (vmObj.starters.length === 1) {
				returnString += `, 1 starter`;
			}
			else {
				returnString += `, ${vmObj.leavers.length} starters`;
			}
		}

		return returnString;
	}

	function getUserIdsFromSupplementaryPayment (vmObj) {

		let returnArr = [];

		// Pay Elements
		vmObj.supplementaryPayment.SupplementaryPaymentElements.forEach(payElementObj => {
			if (!returnArr.includes(payElementObj.UserID)) {
				returnArr.push(payElementObj.UserID);
			}
		});

		// Starters
		vmObj.supplementaryPayment.StartersToSubmit.forEach(starterUserId => {
			if (!returnArr.includes(starterUserId)) {
				returnArr.push(starterUserId);
			}
		});

		// Leavers
		vmObj.supplementaryPayment.LeaversToSubmit.forEach(leaverUserId => {
			if (!returnArr.includes(leaverUserId)) {
				returnArr.push(leaverUserId);
			}
		});

		return returnArr;
	}

	function goToAdjustmentsOverview () {

		setPageState('adjustments-overview');
	}

	function isBusinessCategoriesInvalid (vmObj) {

		return journalsService.isBusinessCategoriesInvalid(vmObj.activeAdjustment.newAdjustment);
	}

	function initDownloadReportsForm () {

		setPageState('loading');

		payrollData.getSupplementaryPayment(agencyProfileId, supplementaryPaymentId)
			.then(supplementaryPaymentObj => {

				const vmObj = {
					supplementaryPayment: supplementaryPaymentObj
				};

				$scope.vm = vmObj;

				getReportsForSupplementaryPayment(vmObj)
					.then(() => {
						setPageState('report-downloads', vmObj);
					})
					.catch(onError);
			})
			.catch(onError);
	}

	function init () {

		const IS_EDITING = angular.isDefined(supplementaryPaymentId);

		// Disallow if no User ID's are provided for a new sup run
		if (!IS_EDITING && userIds.length === 0) {
			setPageState('no-team-members-selected');
			return;
		}

		// No need to load all services to get the reports
		if (IS_EDITING && isDownloadReports) {
			initDownloadReportsForm();
			return;
		}

		setPageState('loading');

		// Ensure there isn't a supplementary payment already in progress
		payrollData.getAgencyHasInProgressSupplementaryPayment(agencyProfileId).then(hasInProgressSupplementaryPayment => {

			// Flag to determine whether to show link to supplementary pay runs. No point showing it if the user is already there.
			const showLinkToSupplementaryPayRuns = $state.current.name !== 'payroll.history.supplementary-pay-runs';

			/* Disallow if there's already a supplementary payment in progress, and a new one is being created. Only one can be in progress
			   at any one time */
			if (hasInProgressSupplementaryPayment && !IS_EDITING) {
				$scope.vm = {
					agencyProfileId,
					showLinkToSupplementaryPayRuns
				};
				setPageState('already-in-progress');
				return;
			}

			const getAgencyAdjustmentGroupCombinedForSupplementaryPayment = payrollData.getAgencyAdjustmentGroupCombinedForSupplementaryPayment(agencyProfileId);
			const getAgencyAdjustmentLabels = payrollData.getAgencyAdjustmentLabels(agencyProfileId);
			const getSupplementaryPayment = IS_EDITING ? payrollData.getSupplementaryPayment(agencyProfileId, supplementaryPaymentId) : payrollData.getEmptySupplementaryPayment();
			const getSupplementaryPaymentDisbursements = payrollData.getSupplementaryPaymentDisbursements(agencyProfileId, supplementaryPaymentId);
			const getEmptyUserPayElementDetailObj = payrollData.getEmptyUserPayElementDetail(agencyProfileId);
			const getPayPeriodMinimum = payrollData.getPayPeriodMinimum(agencyProfileId, IS_PREVIOUS_PERIOD);
			const getUserAgencyProfilesForAgencyTeamMemberMinimum = teamData.getUserAgencyProfilesForAgencyTeamMemberMinimum(agencyProfileId, INCLUDE_LEAVERS, IGNORE_FUTURE_STARTERS, IGNORE_ADMINS, INCLUDE_INCOMPLETE, INCLUDE_BACKPAY);
			const getBusinessCategoriesList = reportData.getBusinessCategoryListForAgency(agencyProfileId);
			const getEmptyUserAgencyProfileBusinessCode = userData.getEmptyUserAgencyProfileBusinessCode();

			$q.all([
				getAgencyAdjustmentGroupCombinedForSupplementaryPayment,
				getAgencyAdjustmentLabels,
				getSupplementaryPayment,
				getSupplementaryPaymentDisbursements,
				getEmptyUserPayElementDetailObj,
				getPayPeriodMinimum,
				getUserAgencyProfilesForAgencyTeamMemberMinimum,
				getBusinessCategoriesList,
				getEmptyUserAgencyProfileBusinessCode
			]).then(([
				adjustmentGroupsObj,
				adjustmentLabelsArr,
				supplementaryPaymentObj,
				supplementaryPaymentDisbursementsArr,
				emptyUserPayElementDetailObj,
				payPeriodObj,
				teamMembersArr,
				businessCategoriesArr,
				emptyUserAgencyProfileBusinessCodeObj
			]) => {

				const IS_PENSION_SUBMITTED = pensionService.getIsPensionSubmittedForPeriod(payPeriodObj);
				const IS_PREVIOUS_TAX_YEAR = utilities.getIsPreviousTaxYearSubmission(payPeriodObj.TaxYear, $scope.formOptions.currentPayPeriod.TaxYear);
				let companyAdjustmentTypesArr = adjustmentsService.getAdjustmentTypesForCompany(adjustmentGroupsObj, companyObj);

				const hmrcDisbursement = $scope.formOptions.company.HMRCDisbursement;
				const supplementaryPaymentDisbursements = [];

				if (!utilities.isEmptyGuid(hmrcDisbursement.DisbursementID)) {

					const emptyHmrcDisbursement = {
						DisbursementID: hmrcDisbursement.DisbursementID,
						IsEnabled: true,
						IsSeparate: false,
						Name: hmrcDisbursement.Description,
						PaymentDateISO: null
					};

					const savedDisbursement = supplementaryPaymentDisbursementsArr.find(d => d.DisbursementID === hmrcDisbursement.DisbursementID);

					supplementaryPaymentDisbursements.push(angular.extend(emptyHmrcDisbursement, savedDisbursement));
				}

				$scope.vm = {
					IS_EDITING,
					IS_PENSION_SUBMITTED,
					IS_PREVIOUS_TAX_YEAR,
					SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES,
					adjustmentLabels: adjustmentLabelsArr,
					adjustmentTypes: companyAdjustmentTypesArr,
					agencyProfileId,
					emptyUserPayElementDetailObj,
					isBulkOperation: userIds.length > 1,
					paymentSummaryTab: 'changes',
					payElementsSkippedCount: 0,
					payPeriodPrevious: payPeriodObj,
					showLinkToSupplementaryPayRuns,
					isSavePayRunOnly: companyObj.IsRTISubmissionDisabled || teamMembersArr.some(teamMemberObj => teamMemberObj.IsExcludedFromRTI),
					supplementaryPayment: supplementaryPaymentObj,
					supplementaryPaymentDisbursements,
					teamMembers: teamMembersArr,
					totalAdjustmentCount: 0,
					businessCategories : businessCategoriesArr,
					emptyUserAgencyProfileBusinessCode: emptyUserAgencyProfileBusinessCodeObj
				};

				if (companyObj.IsRTISubmissionDisabled) {
					setPageState('rti-submission-disabled');
					return;
				}

				if (IS_PREVIOUS_TAX_YEAR) {
					setPageState('previous-tax-year');
					return;
				}

				if (IS_PENSION_SUBMITTED) {
					setPageState('pension-submitted');
					return;
				}

				reviewInit($scope.vm);
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function initSupplementaryPayRunCreate (vmObj) {

		const INCLUDE_STARTERS_AND_LEAVERS = true;

		// Filter team members array to only selected User ID's passed into form
		filterTeamMembersByUserIds(vmObj, userIds, INCLUDE_STARTERS_AND_LEAVERS);

		// Calculate totals
		calculateTotalCounts(vmObj);

		// Excluded from RTI
		if (!vmObj.excludedFromRtiContinued && vmObj.excludedFromRti.length > 0) {
			setPageState('excluded-from-rti');
			return;
		}

		// Populate StartersToSubmit array from starters in filtered team members
		if (vmObj.starters.length > 0) {
			setupStartersToSubmitForSupplementaryPayment(vmObj);
		}

		// Leavers are reviewed before automatically being included to submit
		if (vmObj.leavers.length > 0) {
			setPageState('review-leavers');
		}

		// If no leavers, continue to set up adjustments
		else {
			setPageState('adjustments-overview');
		}
	}

	function initSupplementaryPayRunEdit (vmObj) {

		// Populate team members included in Sup run, from pay elements
		populateTeamMemberDetails(vmObj);

		// Review sup run submission state
		switch (vmObj.supplementaryPayment.SupplementaryPaymentState) {

			case SUBMISSION_STATES.submitted:
			case SUBMISSION_STATES.submitting:
				setPageState('submitting');
				pollPaymentState(vmObj);
				return;

			case SUBMISSION_STATES.failed:
				setPageState('error-submitting');
				return;
		}

		// Update and regenerate reports to make sure they're up to date
		updateSupplementaryPayment(vmObj);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function onPreviousTaxYearContinue (vmObj) {

		if (vmObj.IS_PENSION_SUBMITTED) {
			setPageState('pension-submitted');
			return;
		}

		reviewInit(vmObj);
	}

	function onRTISubmissionContinue (vmObj) {

		if (vmObj.IS_PREVIOUS_TAX_YEAR) {
			setPageState('previous-tax-year');
			return;
		}

		if (vmObj.IS_PENSION_SUBMITTED) {
			setPageState('pension-submitted');
			return;
		}

		reviewInit(vmObj);
	}

	function onTeamMemberOmittedContinue (vmObj) {

		vmObj.excludedFromRtiContinued = true;

		reviewInit(vmObj);
	}

	function payrollSubmitSupplementaryPayment (vmObj, formObj) {

		setPageState('submitting');

		payrollWorker.payrollSubmitSupplementaryPayment(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID).then(() => {
			pollPaymentState(vmObj);
		})
		.catch(error => {
			setPageState('error-submitting');
			formObj.state = null;
			console.error(error);
		});
	}

	function pollPaymentState (vmObj) {

		payrollData.getSupplementaryPaymentState(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID).then(updatedState => {

			switch (updatedState) {

				case SUBMISSION_STATES.submitted:

					$timeout(() => {
						getReportsForSupplementaryPayment(vmObj)
							.then(() => {

								// Callback only applies if leavers have been submitted (as they will be moved to Leavers tab)
								$scope.formOptions.forceCallback({
									hasSubmittedLeavers: vmObj.leavers.length > 0,
									hasSubmittedStarters: vmObj.starters.length > 0
								});

								setPageState('success', vmObj);
							})
							.catch(error => {
								setPageState('error-submitting');
								console.error(error);
							});
					});
					break;

				case SUBMISSION_STATES.failed:

					refreshFailedSupplementaryPayroll(vmObj);
					break;

				default:

					$timeout(() => {
						pollPaymentState(vmObj);
					}, utilities.getTimeToPoll('milliseconds'));
					break;
			}
		});
	}

	function populateTeamMemberDetails (vmObj) {

		const INCLUDE_STARTERS_AND_LEAVERS = false;

		let applicableUserIds = getUserIdsFromSupplementaryPayment(vmObj);

		filterTeamMembersByUserIds(vmObj, applicableUserIds, INCLUDE_STARTERS_AND_LEAVERS);

		// Populate adjustments arrays for team members
		populateTeamMemberDetailsAdjustments(vmObj);

		// Populate starters if starters are included
		populateTeamMemberDetailsStarters(vmObj);

		// Populate leavers if leavers are included
		populateTeamMemberDetailsLeavers(vmObj);

		// Calculate totals
		calculateTotalCounts(vmObj);
	}

	function populateTeamMemberDetailsAdjustments (vmObj) {

		vmObj.supplementaryPayment.SupplementaryPaymentElements.forEach(supplementaryPaymentElementObj => {

			const teamMemberIndex = utilities.getArrayItemIndexByPropertyName(vmObj.teamMembers, 'UserID', supplementaryPaymentElementObj.UserID);

			// Can't edit backdated salaries
			angular.extend(supplementaryPaymentElementObj, {
				canEdit: supplementaryPaymentElementObj.ValueType !== -1,
				canDelete: true
			});

			vmObj.teamMembers[teamMemberIndex].adjustments.push(angular.copy(supplementaryPaymentElementObj));
		});
	}

	function populateTeamMemberDetailsLeavers (vmObj) {

		vmObj.supplementaryPayment.LeaversToSubmit.forEach(leaverUserId => {

			const teamMemberIndex = utilities.getArrayItemIndexByPropertyName(vmObj.teamMembers, 'UserID', leaverUserId);

			vmObj.leavers.push(angular.copy(vmObj.teamMembers[teamMemberIndex]));
		});

		// Required to allow editing of selected leavers
		vmObj.leaversOriginal = angular.copy(vmObj.leavers);
	}

	function populateTeamMemberDetailsStarters (vmObj) {

		vmObj.supplementaryPayment.StartersToSubmit.forEach(starterUserId => {

			const teamMemberIndex = utilities.getArrayItemIndexByPropertyName(vmObj.teamMembers, 'UserID', starterUserId);

			vmObj.starters.push(angular.copy(vmObj.teamMembers[teamMemberIndex]));
		});
	}

	function refreshFailedSupplementaryPayroll (vmObj) {

		payrollData.getSupplementaryPayment(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID).then(updatedSupplementaryPaymentObj => {

			angular.extend(vmObj, {
				supplementaryPayment: updatedSupplementaryPaymentObj
			});

			setPageState('error-submitting');

			$scope.formOptions.forceCallback();
		})
		.catch(onError);
	}

	function reviewInit (vmObj) {

		// Editing > Populate adjustments for editing
		if (vmObj.IS_EDITING) {
			initSupplementaryPayRunEdit(vmObj);
		}

		// New > Set up adjustments for adding new
		else {
			initSupplementaryPayRunCreate(vmObj);
		}
	}

	function saveForLater (vmObj) {

		function displaySaveForLaterState () {
			// Change page state to show informational message prior to close
			setPageState('saved-for-later');

			// In case submission has been re-attempted within form
			$scope.formOptions.forceCallback();
		}

		if ($scope.pageState === 'review-reports') {

			/* Change page state to show informational message prior to close. Nothing else needs to be done,
			   since at this point, the supplementary pay run has already been saved. */

			displaySaveForLaterState();
			return;
		}

		// Save supplementary paypayment disbursements
		payrollData.updateSupplementaryPaymentDisbursements(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID, vmObj.supplementaryPaymentDisbursements).then(() => {

			displaySaveForLaterState();
		})
		.catch(onError);
	}

	function setActiveAdjustment (vmObj, teamMemberIndex, adjustmentIndex) {

		const isEditing = angular.isDefined(adjustmentIndex);
		const teamMemberObj = vmObj.teamMembers[teamMemberIndex];

		let newAdjustmentObj = isEditing ? getPayElementDetailForAdjustment(vmObj, teamMemberIndex, adjustmentIndex) : angular.copy(vmObj.emptyUserPayElementDetailObj);

		angular.extend(newAdjustmentObj, {
			overrideBusinessCategories: newAdjustmentObj.UserAgencyProfileBusinessCodeOverrides.length > 0,
			businessCategories: journalsService.decorateBusinessCategories(vmObj.businessCategories, newAdjustmentObj.UserAgencyProfileBusinessCodeOverrides)
		});

		angular.extend(vmObj, {
			activeAdjustment: adjustmentsService.getChangeCreatorVm({
				CAN_ATTACH_PENSION_SCHEME: true,
				CAN_APPLY_TO_ALL: vmObj.teamMembers.length > 1,
				CAN_MANAGE_TEAM_MEMBERS: false,
				IS_PENSION_SUBMITTED: vmObj.IS_PENSION_SUBMITTED,
				IS_SET_TO_SALARY_ENABLED: true,
				adjustmentLabels: adjustmentsService.decorateLabelsWithAdjustmentTypes(vmObj.adjustmentLabels, vmObj.adjustmentTypes),
				adjustmentTypes: vmObj.adjustmentTypes,
				adjustmentTypesOriginal: angular.copy(vmObj.adjustmentTypes),
				businessCategories: vmObj.businessCategories,
				isEditing,
				newAdjustment: newAdjustmentObj,
				payPeriod: vmObj.payPeriodPrevious,
				selectedAdjustmentTypeId: newAdjustmentObj.AgencyAdjustmentGroupEntryID,
				selectedPayPeriodId: vmObj.payPeriodPrevious.PayPeriodID,
				teamMembers: vmObj.teamMembers,
				userIds: [teamMemberObj.UserID]
			}),
			activeAdjustmentIndex: adjustmentIndex,
			activeTeamMemberIndex: teamMemberIndex,
			agencyProfileId
		});
	}

	function setPageState (pageState) {

		let activeStep = null;
		let totalSteps = $scope.formOptions.company.IsBACSEnabled ? 5 : 4;

		switch (pageState) {
			case 'adjustments-overview':
				activeStep = 1;
				break;
			case 'adjustment-builder':
				activeStep = 1;
				break;
			case 'report-options':
				activeStep = 2;
				break;
			case 'bacs-files-options':
				activeStep = 3;
				break;
			case 'review-reports':
				activeStep = totalSteps - 1;
				break;
			case 'submission-summary':
				activeStep = totalSteps;
				break;
			case 'in-progress':
				activeStep = totalSteps + 1;
				break;
			default:
				totalSteps = null;
				break;
		}

		$scope.formOptions.activeStep = activeStep;
		$scope.formOptions.totalSteps = totalSteps;
		$scope.pageState = pageState;
	}

	function setPaymentSummaryTab (vmObj, key) {

		vmObj.paymentSummaryTab = key;
	}

	function setupAdjustmentsForSupplementaryPayment (vmObj) {

		angular.extend(vmObj.supplementaryPayment, {
			AgencyProfileID: vmObj.agencyProfileId,
			SupplementaryPaymentElements: getSupplementaryAdjustments(vmObj)
			//AgencyPayPeriodID: vmObj.changeCreatorVm.selectedPayPeriodId; // Not required
		});

		setPageState('report-options');
	}

	function setupLeaversToSubmitForSupplementaryPayment (vmObj) {

		vmObj.supplementaryPayment.LeaversToSubmit = [];

		// Populate LeaversToSubmit array
		vmObj.leavers.forEach(leaverObj => {

			if (leaverObj.isChecked) {
				vmObj.supplementaryPayment.LeaversToSubmit.push(leaverObj.UserID);
			}
		});

		// Filter leavers to only persist the selected ones
		vmObj.leavers = vmObj.leavers.filter(leaverObj => {

			return leaverObj.isChecked;
		});

		setPageState('adjustments-overview');
	}

	function setupStartersToSubmitForSupplementaryPayment (vmObj) {

		vmObj.supplementaryPayment.StartersToSubmit = [];

		// Populate StartersToSubmit array
		vmObj.starters.forEach(starterObj => {

			vmObj.supplementaryPayment.StartersToSubmit.push(starterObj.UserID);
		});
	}

	function toggleAdjustmentConfirmDelete (adjustmentObj) {

		adjustmentObj.confirmDelete = !adjustmentObj.confirmDelete;
	}

	function updateSupplementaryPayment (vmObj) {

		// Add actioner ID
		vmObj.supplementaryPayment.SupplementaryPaymentActionerID = $rootScope.currentUser.UserResponseUserID;

		vmObj.supplementaryPayment.SupplementaryPaymentElements.forEach(payElementObj => {
			// Reset guid
			payElementObj.UserAgencyProfileBusinessCodeOverrides.forEach(businessCode => businessCode.UserAgencyProfileBusinessCodeID = config.guidEmpty);
		});

		setPageState(getNextPageState());

		payrollData.updateSupplementaryPayment(agencyProfileId, vmObj.supplementaryPayment).then(updatedSupplementaryPaymentObj => {

			vmObj.isEditing = true;

			angular.extend(vmObj.supplementaryPayment, {
				SupplementaryPaymentID: updatedSupplementaryPaymentObj.SupplementaryPaymentID,
				AgencyPayPeriodID: updatedSupplementaryPaymentObj.AgencyPayPeriodID
			});

			if ($scope.pageState === 'generating-documents') {
				generateReports(vmObj);
			}
		})
		.catch(error => {
			if (error.data.ErrorMessage === UPDATE_OLDER_SUPPLEMENTARY_PAYMENT_ERROR)
			{
				angular.extend(vmObj, {
					errorMessage: OLDER_SUPPLEMENTARY_PAYMENT_ERROR_MESSAGE
				});
			}
			onError(error);
		});
	}

	function updateSupplementaryPaymentDisbursements (vmObj) {

		setPageState('generating-documents');

		payrollData.updateSupplementaryPaymentDisbursements(agencyProfileId, vmObj.supplementaryPayment.SupplementaryPaymentID, vmObj.supplementaryPaymentDisbursements).then(() => {
			generateReports(vmObj);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		SUBMISSION_STATES,

		submissionLogType: SUBMISSION_LOG_TYPE.supplementaryPayRun,

		addActiveAdjustmentToSupplementaryPayments,
		addPayElementForTeamMember,
		deleteAdjustment,
		deleteSupplementaryPayment,
		editAdjustment,
		editSelectedLeavers,
		getAdjustmentCountLabel,
		getAdjustmentDescription,
		getAdjustmentValueDisplayClass,
		getLabel,
		getPreviousPageState,
		getSupplementaryPayDescription,
		goToAdjustmentsOverview,
		isBusinessCategoriesInvalid,
		onPreviousTaxYearContinue,
		onRTISubmissionContinue,
		onTeamMemberOmittedContinue,
		payrollSubmitSupplementaryPayment,
		reviewInit,
		saveForLater,
		setPageState,
		setPaymentSummaryTab,
		setupAdjustmentsForSupplementaryPayment,
		setupLeaversToSubmitForSupplementaryPayment,
		toggleAdjustmentConfirmDelete,
		updateSupplementaryPayment,
		updateSupplementaryPaymentDisbursements
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('taxUpdatesForm', function () {

	return {
		controller: 'taxUpdatesFormCtrl',
		templateUrl: 'forms/payroll/tax-updates/tax-updates.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('taxUpdatesFormCtrl', [
	'$q',
	'$scope',
	'$timeout',
	'agency',
	'companyData',
	'payrollData',
	'taxUpdatesService',
	'SUBMISSION_STATES',
	'STATE_TYPES',
	function (
		$q,
		$scope,
		$timeout,
		agency,
		companyData,
		payrollData,
		taxUpdatesService,
		SUBMISSION_STATES,
		STATE_TYPES
	) {

	const agencyProfileId	= $scope.formOptions.agencyProfileId;
	const payPeriodObj = $scope.formOptions.payPeriod;
	const payrollPollInterval = 5;

	function checkForTaxUpdates () {

		setPageState('checking');
		$scope.formOptions.canCloseForm = false;

		payrollData.payrollDPSImport(agencyProfileId).then(() => {

			$timeout(() => {
				pollPayrollState();
			}, payrollPollInterval * 1000);
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		const getAgencyProfileCompanyInformationDetailed = companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId);
		const getAgencyLogTaxUpdates = agency.getAgencyLogTaxUpdates(agencyProfileId, payPeriodObj.PayPeriodID);

		$q.all([
			getAgencyProfileCompanyInformationDetailed,
			getAgencyLogTaxUpdates
		]).then(([
			companyObj,
			taxUpdatesObj
		]) => {

			taxUpdatesService.decorateTaxUpdatesLogs(taxUpdatesObj);

			$scope.vm = {
				taxUpdates: taxUpdatesObj,
				company: companyObj,
				payPeriod: payPeriodObj
			};

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function pollPayrollState () {

		agency.getAgencyPayPeriodState(payPeriodObj.PayPeriodID, STATE_TYPES.taxUpdates).then(payPeriodState => {

			switch (payPeriodState) {

				// Submitting
				case SUBMISSION_STATES.submitting:

					$timeout(() => {
						pollPayrollState();
					}, payrollPollInterval * 1000);
					break;

				// Submitted
				case SUBMISSION_STATES.submitted:

					init();
					$scope.formOptions.canCloseForm = true;
					break;

				// Failed
				default:
				case SUBMISSION_STATES.failed:

					setPageState('failed');
					$scope.vm.taxUpdateFailed = true;
					$scope.formOptions.canCloseForm = true;
					break;
			}
		})
		.catch(onError);
	}


	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		checkForTaxUpdates,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('taxUpdatesConfirmationForm', function () {

	return {
		controller: 'taxUpdatesConfirmationFormCtrl',
		templateUrl: 'forms/payroll/tax-updates/tax-updates-confirmation.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('taxUpdatesConfirmationFormCtrl', [
	'$scope',
	'$timeout',
	'agency',
	'companyData',
	'payrollData',
	'taxUpdatesService',
	'DPS_STATES',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	'USER_TAX_INFO_STATES',
	function (
		$scope,
		$timeout,
		agency,
		companyData,
		payrollData,
		taxUpdatesService,
		DPS_STATES,
		STATE_TYPES,
		SUBMISSION_STATES,
		USER_TAX_INFO_STATES
	) {

	const POLL_INTERVAL = 4;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriodId = $scope.formOptions.payPeriodId;

	const PAGE_STATES = {
		electronicUpdatesNotAvailableInPensionOnly: 'electronicUpdatesNotAvailableInPensionOnly',
		electronicUpdatesNotAvailableInTestMode: 'electronicUpdatesNotAvailableInTestMode',
		electronicUpdatesNotEnabled: 'electronicUpdatesNotEnabled',
		error: 'error',
		loading: 'loading',
		noTaxUpdates: 'noTaxUpdates',
		queryingPayroll: 'queryingPayroll',
		queryPayrollFailed: 'queryPayrollFailed',
		ready: 'ready',
		readyForManualAccept: 'readyForManualAccept',
		taxUpdatesSaved: 'taxUpdatesSaved'
	};

	function checkForTaxUpdates (dpsAutoApply) {

		setPageState(PAGE_STATES.queryingPayroll);

		payrollData.payrollDPSImport(agencyProfileId).then(() => {
			queryPayrollState(dpsAutoApply);
		})
		.catch(onError);
	}

	function getAcceptedCount (teamMemberTaxList) {

		return teamMemberTaxList.reduce((count, teamMemberTax) => {
			return count + (teamMemberTax.isAccepted ? 1 : 0);
		}, 0);
	}

	function getAutomaticTaxUpdates () {

		agency.getAgencyLogTaxUpdates(agencyProfileId, payPeriodId).then(taxUpdatesObj => {

			// No tax updates
			if (taxUpdatesObj.LogEntries.length === 0) {
				setPageState(PAGE_STATES.noTaxUpdates);
				return;
			}
			
			taxUpdatesService.decorateTaxUpdatesLogs(taxUpdatesObj);

			$scope.taxUpdates = taxUpdatesObj;
			
			setPageState(PAGE_STATES.ready);
		})
		.catch(onError);
	}

	function getManualTaxUpdates () {

		// Get pending tax changes (i.e. those that need approval)
		payrollData.getTeamMemberTaxListForState(agencyProfileId, USER_TAX_INFO_STATES.pending).then(teamMemberTaxList => {

			angular.extend($scope, {
				teamMemberTaxList
			});

			if (teamMemberTaxList.length === 0) {
				setPageState(PAGE_STATES.noTaxUpdates);
			}
			else {
				setPageState(PAGE_STATES.readyForManualAccept);
			}
		})
		.catch(onError);
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		companyData.getAgencyProfileCompanyInformationDetailed(agencyProfileId).then(companyObj => {

			if ($scope.formOptions.company.PensionOnly) {
				// Electronic updates not available in pension only
				setPageState(PAGE_STATES.electronicUpdatesNotAvailableInPensionOnly);
			}
			else if ($scope.formOptions.company.IsInTestMode) {
				// Electronic updates are enabled but the company is in test mode
				setPageState(PAGE_STATES.electronicUpdatesNotAvailableInTestMode);
			}
			else if (!companyObj.Employer.DPSImport) {
				// Electronic updates aren't enabled
				setPageState(PAGE_STATES.electronicUpdatesNotEnabled);
			}
			else {
				checkForTaxUpdates(companyObj.Employer.DPSAutoApply);
			}
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState(PAGE_STATES.error);
		console.error(error);
	}

	function queryPayrollState (dpsAutoApply) {

		agency.getAgencyPayPeriodState(payPeriodId, STATE_TYPES.taxUpdates).then(payPeriodState => {

			switch (payPeriodState) {

				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.submitting:
					// Check again after defined interval
					$timeout(() => {
						queryPayrollState(dpsAutoApply);
					}, POLL_INTERVAL * 1000);
					break;

				case SUBMISSION_STATES.submitted:
					// Payroll submitted. If DPSAutoApply is set, get tax updates, otherwise get pending tax updates for manual review.
					if (dpsAutoApply) {
						getAutomaticTaxUpdates();
					}
					else {
						getManualTaxUpdates();
					}
					break;

				case SUBMISSION_STATES.failed:
					/* falls through */
				default:

					// Something went awry. Get the specific error via DPSState in GetPayPeriodMinimum
					payrollData.getPayPeriodMinimum(agencyProfileId).then(payPeriodObj => {

						// Determine error information for display
						let failureInfoObj;
						switch (payPeriodObj.DPSState) {
							case DPS_STATES.unauthorised: {
								failureInfoObj = {
									title: 'You\'re not authorised to retrieve tax code information',
									message: `You're not authorised to retrieve tax code information for ${$scope.formOptions.company.Name}. ` +
										'We suggest logging in to your HMRC PAYE account to request authorisation and, ' +
										'once that has been confirmed, you can try retrieving tax updates again.'
								};
								break;
							}
							case DPS_STATES.invalidCredentials: {
								failureInfoObj = {
									title: 'Your credentials are invalid',
									message: 'The credentials you\'re using to access your HMRC PAYE account are invalid. ' +
										'Please check they\'re correct and update them as required before trying to retrieve tax updates again.'
								};
								break;
							}
							default: {
								/* Default, assuming this represents DPS_STATES.hmrcFault, to ensure an invalid
								   DPSState value still displays a message */
								failureInfoObj = {
									title: 'HMRC\'s PAYE Notice system is not responding',
									message: 'There seems to be a problem retrieving your tax updates so your data could not be updated. ' +
										'We suggest waiting a few minutes and coming back to try again. If the problem persists, or you need to make the changes now, ' +
										'we suggest logging in to your HMRC PAYE account to find the notices due and apply them manually.'
								};
							}
						}
						$scope.failureInfoObj = failureInfoObj;
						setPageState(PAGE_STATES.queryPayrollFailed);
					});
					break;
			}
		})
		.catch(onError);
}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function updateTeamMemberTaxList (form, teamMemberTaxList) {

		form.state = 'saving';

		payrollData.updateTeamMemberTaxListForState(agencyProfileId, teamMemberTaxList).then(() => {

			form.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState(PAGE_STATES.taxUpdatesSaved);
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {

		// Constants
		PAGE_STATES,
		POLL_INTERVAL,
		USER_TAX_INFO_STATES,

		// Variables
		dpsState: -1,

		// Functions
		checkForTaxUpdates,
		getAcceptedCount,
		updateTeamMemberTaxList
	});

}]);

'use strict';

angular.module('paycircleApp')

.directive('unmarkAsAdvancingForm', function () {

	return {
		controller: 'unmarkAsAdvancingFormCtrl',
		templateUrl: 'forms/payroll/unmark-as-advancing/unmark-as-advancing.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('unmarkAsAdvancingFormCtrl', [
	'$scope',
	'userData',
	'utilities',
function (
	$scope,
	userData,
	utilities
) {

	const PAGE_STATES = {
		complete: 'complete',
		error: 'error',
		loading: 'loading',
		ready: 'ready'
	};

	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function createUnmarkAsAdvancingContextObj (formOptionsObj) {

		const unmarkAsAdvancingContextObj = {
			// This will be a singleton array for 'user' context, multiple for bulk operation and 'company' context
			userIds: formOptionsObj.userIds
		};

		// This form can be invoked in the context of 'user' (used for single) or 'company' (for bulk operations)
		if (angular.isDefined(formOptionsObj.userId)) {
			// This is a single user operation. Text is the user's forename from the form options context obj.
			angular.extend(unmarkAsAdvancingContextObj, {
				isBulk: false,
				text: formOptionsObj.context.Forename
			});
		}
		else {
			/* This is a bulk operation. Text is generic 'x team members'. There should never be a bulk operation
			   for a single team member, since that situation invoked from the UI will default to 'user' context */
			const userIds = formOptionsObj.userIds;
			angular.extend(unmarkAsAdvancingContextObj, {
				isBulk: true,
				text: `${utilities.getNumberText(userIds.length)} team members`
			});
		}

		return unmarkAsAdvancingContextObj;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		/* This form always requires a userIds array, even for a single user, just for consistency. So account for that
		   here. If userIds isn't defined in the formOptions, create it from the userId */
		if (angular.isUndefined($scope.formOptions.userIds)) {
			$scope.formOptions.userIds = [$scope.formOptions.userId];
		}

		$scope.vm = {
			unmarkAsAdvancingContext: createUnmarkAsAdvancingContextObj($scope.formOptions)
		};

		setPageState(PAGE_STATES.ready);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function unmarkAsAdvancing (unmarkAsAdvancingContextObj, formObj) {

		formObj.state = 'saving';

		const ADVANCE = false;

		userData.updateUserAgencyProfilesAdvancePeriods(
			agencyProfileId,
			unmarkAsAdvancingContextObj.userIds,
			ADVANCE
		).then(function () {

			formObj.state = 'saved';
			setPageState(PAGE_STATES.complete);

			$scope.formOptions.forceCallback();
		})
		.catch(onError);
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		PAGE_STATES,

		utilities,

		unmarkAsAdvancing
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('unmarkAsLeaverForm', function () {

	return {
		controller: 'unmarkAsLeaverFormCtrl',
		templateUrl: 'forms/payroll/unmarkAsLeaver/unmarkAsLeaverForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('unmarkAsLeaverFormCtrl', ['$scope', 'reportData', 'teamData', function ($scope, reportData, teamData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		teamData.getTeamMemberInformation(userId, agencyProfileId).then((teamMemberObj) => {

			$scope.teamMember = teamMemberObj;

			if (teamMemberObj.Company.CanUpdateLeaveStatus) {
				setPageState('ready');

			} else {
				setPageState('company-in-rollback');
			}
		})
		.catch(error => {
			console.error(error);
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	function payrollUpdateLeaveDateAndRegenerateP45 (teamMemberObj, form) {

		form.state = 'saving';

		// Clear out all leave info to unmark user as leaver
		teamMemberObj.Company.LeaveDateISO = '';
		teamMemberObj.Company.LeaveReason = 0;
		teamMemberObj.Company.LeaveNote = '';

		reportData.payrollUpdateLeaveDateAndRegenerateP45(agencyProfileId, userId, teamMemberObj.Company.LeaveDateISO, teamMemberObj.Company.LeaveReason, teamMemberObj.Company.LeaveNote).then(() => {

			form.state = 'saved';
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(() => {
			setPageState('error');
		});
	}

	init();

	angular.extend($scope, {

		// Functions
		payrollUpdateLeaveDateAndRegenerateP45
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('updateGrossPayForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'updateGrossPayFormCtrl',
	templateUrl: 'forms/payroll/updateGrossPay/update-gross-pay.form.html'
})

.controller('updateGrossPayFormCtrl', [
	'growl',
	'payrollData',
	'teamData',
	'SALARY_TYPES',
	'SUBMISSION_STATES',
	function (
		growl,
		payrollData,
		teamData,
		SALARY_TYPES,
		SUBMISSION_STATES
	) {

	const $ctrl = this;

	const FORM_STATES = {
		error: 'error',
		loading: 'loading',
		locked: 'locked',
		notAvailable: 'not-available',
		notUnsubmitted: 'not-unsubmitted',
		paidHourly: 'paid-hourly',
		ready: 'ready'
	};

	function $onInit () {

		const currentPayPeriodObj = $ctrl.formOptions.currentPayPeriod;

		setFormState(FORM_STATES.loading);

		teamData.getTeamMemberInformation($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId).then(teamMemberObj => {

			angular.extend($ctrl, {
				currentPayPeriod: currentPayPeriodObj,
				grossPay: '',
				isProRatedApplicable: getIsProRatedApplicable(teamMemberObj, currentPayPeriodObj),
				isSalaryOnlyForPeriod: true,
				teamMember: teamMemberObj,
			});

			setFormState(getInitialPageState($ctrl));
		})
		.catch(onError);
	}

	function getInitialPageState ($ctrl) {

		// Check to make sure current pay period is 'unsubmitted' and not processing/failed
		if ($ctrl.currentPayPeriod.PayrollState !== SUBMISSION_STATES.unsubmitted) {
			return FORM_STATES.notUnsubmitted;
		}

		// Hourly paid worker
		if ($ctrl.teamMember.Salary.SalaryType === SALARY_TYPES.hourlyPay) {
			return FORM_STATES.paidHourly;
		}

		// Cant update gross pay
		if (!$ctrl.teamMember.CanUpdateGrossPay) {
			return FORM_STATES.notAvailable;
		}

		return FORM_STATES.ready;
	}

	function getIsProRatedApplicable (teamMemberObj, currentPayPeriodObj) {

		const teamMemberStartDateMoment = moment(teamMemberObj.Company.StartDateISO);
		const payPeriodStartDateMoment = moment(currentPayPeriodObj.StartDateISO);

		return teamMemberStartDateMoment.isAfter(payPeriodStartDateMoment, 'day');
	}

	function onError (error) {
		setFormState(FORM_STATES.error);
		console.error(error);
	}

	function updateGrossPay ($ctrl, $form) {

		$form.state = 'saving';

		// Update Yearly Salary in Salary object (ignore fact it's Salary Yearly - Server re-calculates)
		$ctrl.teamMember.Salary.SalaryYearly = $ctrl.grossPay;

		payrollData.updateTeamMemberSalaryForPeriod($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.userId, $ctrl.teamMember.Salary, $ctrl.isSalaryOnlyForPeriod)
			.then(() => {

				growl.success($ctrl.formOptions.context.Forename + '\'s gross pay has been updated');

				$ctrl.formOptions.forceCallback();
				$ctrl.formOptions.closeForm();
			})
			.catch(onError);
	}

	function setFormState (formState) {
		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,

		updateGrossPay,

		FORM_STATES,
		SALARY_TYPES
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('updateLeaverStatusForm', function () {

	return {
		controller: 'updateLeaverStatusFormCtrl',
		templateUrl: 'forms/payroll/updateLeaverStatus/updateLeaverStatusForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('updateLeaverStatusFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'payrollData',
	'reportData',
	'teamData',
	'user',
	'utilities',
	'AOE_ORDER_STATES',
	'LEAVING_REASONS',
	function (
		$q,
		$rootScope,
		$scope,
		payrollData,
		reportData,
		teamData,
		user,
		utilities,
		AOE_ORDER_STATES,
		LEAVING_REASONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const userId = $scope.formOptions.userId;
	const forUpdate = $scope.formOptions.forUpdate;

	const PAGE_STATES = {
		alreadyLeft: 'already-left',
		companyInRollback: 'company-in-rollback',
		error: 'error',
		leaveDateInvalid: 'leave-date-invalid',
		loading: 'loading',
		noStartDate: 'no-start-date',
		ready: 'ready',
		success: 'success'
	};

	function checkLeaveDate (teamMemberObj, currentPayPeriodObj) {

		if (!teamMemberObj.Company.IsCISSubcontractor) {
			teamMemberObj.Company.isLeaveDateInPast = teamMemberObj.Company.LeaveDateISO && moment(teamMemberObj.Company.LeaveDateISO).isValid() &&
													  (moment(currentPayPeriodObj.StartDateISO).isAfter(teamMemberObj.Company.LeaveDateISO));
			teamMemberObj.Company.isLeaveDateBeforeLastPayDate = teamMemberObj.Payment.PaymentDateISO && moment(teamMemberObj.Payment.PaymentDateISO).isAfter(teamMemberObj.Company.LeaveDateISO);
			teamMemberObj.Company.isLeaveDateAfterEndDate = moment(teamMemberObj.Company.LeaveDateISO).isAfter(currentPayPeriodObj.EndDateISO);
		}
	}

	function decorateTeamMemberObj (teamMemberObj, currentPayPeriodObj) {

		if (teamMemberObj.Company.IsCISSubcontractor) {
			angular.extend(teamMemberObj.Company, {
				leaveDateISOMax: moment(currentPayPeriodObj.PayDateISO).add(3, 'months').format()
			});

		} else {
			angular.extend(teamMemberObj.Company, {
				isLeaveDateAfterEndDate: false,
				leaveDateISOMax: moment(currentPayPeriodObj.PayDateISO).add(3, 'months').format(),
				leaveDateISOMin: teamMemberObj.Company.StartDateISO
			});

			checkLeaveDate(teamMemberObj, currentPayPeriodObj);
		}

		angular.extend(teamMemberObj.Company, {
			LeaveReason: teamMemberObj.Company.LeaveReason,
			noP45Generation: teamMemberObj.Company.IsLeaving || teamMemberObj.Company.IsLeaver ? !teamMemberObj.Tax.IsP45Generated : false
		});

		// If start date is missing then set previously submitted as a leaver field set to 'Yes' and disable it
		if (teamMemberObj.Company.StartDateISO === '') {
			teamMemberObj.Company.IsLeaverManuallySet = true;
		}

		// Set flags to hide or show what can't and can be edited
		const submitLeaverFormOptions = {
			showPreviouslySubmittedAsLeaver: false,
			showLeaveInformation: false,
			showLeaveDate: false,
			showP45Generation: false
		};

		// Is this a leaver?
		if (teamMemberObj.Company.IsLeaver) {
			if (teamMemberObj.Company.IsCISSubcontractor) {
				// Leave date only available for CIS subcontractors
				submitLeaverFormOptions.showLeaveDate = true;
				teamMemberObj.Company.noP45Generation = true;
			}
			else if (teamMemberObj.Company.IsLeaverManuallySet) {
				// Leaver manually set and not a CIS subcontractor, so can edit leave information and date
				submitLeaverFormOptions.showLeaveInformation = true;
				submitLeaverFormOptions.showLeaveDate = true;
			}
			else {
				// Paycircle submitted leaver.
				submitLeaverFormOptions.showLeaveInformation = true;
				submitLeaverFormOptions.showLeaveDate = true;

				// Regenerate P45 option available only if P45 has already been generated
				if (teamMemberObj.Tax.IsP45Generated) {
					submitLeaverFormOptions.showP45Generation = true;
					// Default regenerate option to 'yes'
					teamMemberObj.Company.noP45Generation = false;
				}
			}
		}
		else {
			/* Not a leaver yet, but marked as leaving. All as if doing this for the first time.
			   CIS subcontractors get just the leave date. */
			submitLeaverFormOptions.showPreviouslySubmittedAsLeaver = !teamMemberObj.Company.IsCISSubcontractor;
			submitLeaverFormOptions.showLeaveInformation = !teamMemberObj.Company.IsCISSubcontractor;
			submitLeaverFormOptions.showLeaveDate = true;
			submitLeaverFormOptions.showP45Generation = !teamMemberObj.Company.IsCISSubcontractor;
		}

		// Attach to team member object
		teamMemberObj.submitLeaverFormOptions = submitLeaverFormOptions;

		return teamMemberObj;
	}

	function filterAttachmentOfEarnings (aoeObj) {

		// Sum the amounts outstanding for attachment orders and attach to the object
		aoeObj.totalAoeAmountRemaining = aoeObj.AttachmentOrders.reduce((total, aoe) => {
			// Only count AOEs that are active (i.e. ignore complete or cancelled)
			const amountRemaining = aoe.OrderState === AOE_ORDER_STATES.active ? aoe.AmountRemaining : 0;
			return total + amountRemaining;
		}, 0);

		return aoeObj;
	}

	function getInitialPageState (teamMemberObj) {

		// Warning displayed if start date not added yet
		if (teamMemberObj.Company.StartDateISO === '') {
			return PAGE_STATES.noStartDate;
		}

		// Can't mark as leaver company is in rollback
		if (teamMemberObj.Company.IsLeaving && !teamMemberObj.Company.CanUpdateLeaveStatus) {
			return PAGE_STATES.companyInRollback;
		}

		return PAGE_STATES.ready;
	}

	function init () {

		setPageState(PAGE_STATES.loading);

		$q.all([
				teamData.getAttachmentOrderInformation(userId, agencyProfileId),
				payrollData.getPayPeriodCurrent(agencyProfileId),
				teamData.getTeamMemberInformation(userId, agencyProfileId)
			])
			.then(([aoeObj, currentPayPeriodObj, teamMemberObj]) => {

				angular.extend($scope, {
					aoe: filterAttachmentOfEarnings(aoeObj),
					isP45OptionToRegenerate: forUpdate && teamMemberObj.Company.IsLeaver,
					payPeriod: currentPayPeriodObj,
					teamMember: decorateTeamMemberObj(teamMemberObj, currentPayPeriodObj)
				});

				setPageState(getInitialPageState(teamMemberObj));
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState(PAGE_STATES.error);
	}

	function onLeaverManuallySetChange (teamMemberObj) {

		// If leaver is manually set, hide P45 generation
		teamMemberObj.submitLeaverFormOptions.showP45Generation = !teamMemberObj.Company.IsLeaverManuallySet;
		/* Set P45 generation to 'yes' is leaver is not manually set, 'no' otherwise (in the latter case this
		   is not editable because of the above line) */
		teamMemberObj.Company.noP45Generation = teamMemberObj.Company.IsLeaverManuallySet;
	}

	function openCompanyDetailsForm (teamMemberObj) {

		$scope.formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			contextType: 'user',
			formKey: 'company-details',
			userId: teamMemberObj.Personal.UserID
		});
	}

	function updateLeaverInformation (teamMemberObj, form) {

		const OVERRIDE_LEAVE_SUBMITTED = false;

		form.state = 'saving';

		// Different APIs used depending on whether the team member is a submitted leaver (IsLeaver == true).
		if (teamMemberObj.Company.IsLeaver) {

			user.updateUserAgencyProfileLeaveDetails(
				userId,
				agencyProfileId,
				teamMemberObj.Company.LeaveDateISO,
				teamMemberObj.Company.LeaveReason,
				teamMemberObj.Company.LeaveNote).then(updateUserAgencyProfileLeaveDetailsResponseCode => {

				// Leave date is before last payroll payment date
				if (updateUserAgencyProfileLeaveDetailsResponseCode === -2) {
					setPageState(PAGE_STATES.leaveDateInvalid);
					return;
				}

				// Regenerate P45 if that's been selected
				if (!teamMemberObj.Company.noP45Generation) {
					reportData.payrollRegenerateP45(agencyProfileId, userId).then(() => {
						form.state = 'saved';
						$scope.formOptions.forceCallback();
						setPageState(PAGE_STATES.success);
					})
					.catch(onError);
				}
				else {
					form.state = 'saved';
					$scope.formOptions.forceCallback();
					setPageState(PAGE_STATES.success);
				}
			})
			.catch(onError);
		}
		else {
			reportData.payrollUpdateLeaveDateAndRegenerateP45(
				agencyProfileId,
				userId,
				teamMemberObj.Company.LeaveDateISO,
				teamMemberObj.Company.LeaveReason,
				teamMemberObj.Company.LeaveNote,
				teamMemberObj.Company.IsLeaverManuallySet,
				teamMemberObj.Company.LeaveSubmit,
				teamMemberObj.Company.noP45Generation,
				OVERRIDE_LEAVE_SUBMITTED).then(responseCode => {

				// Leave date is before last payroll payment date
				if (responseCode === -2) {
					setPageState(PAGE_STATES.leaveDateInvalid);
					return;
				}

				form.state = 'saved';
				$scope.formOptions.forceCallback();
				setPageState(PAGE_STATES.success);

				if (teamMemberObj.Company.IsLeaving) {
					$rootScope.setDemoTaskAsComplete('makeLeaver', $scope.formOptions.context.Forename);
				}
			})
			.catch(onError);
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		LEAVING_REASONS,
		PAGE_STATES,

		forUpdate,

		checkLeaveDate,
		onLeaverManuallySetChange,
		openCompanyDetailsForm,
		updateLeaverInformation,
		setPageState
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('viewChangesForm', function () {

	return {
		controller: 'viewChangesFormCtrl',
		templateUrl: 'forms/payroll/view-changes/view-changes.form.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('viewChangesFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'payrollData',
	function (
		$q,
		$rootScope,
		$scope,
		payrollData
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const callback = $scope.formOptions.callback;
	const contextType = $scope.formOptions.contextType;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;

	let userId = $scope.formOptions.userId ? $scope.formOptions.userId : undefined;

	function init () {

		// Ability to specifically ask for all company changes
		if (contextType && contextType === 'company') {
			userId = undefined;
		}

		setPageState('loading');

		payrollData.getAgencyPaymentAdjustmentDetailList(agencyProfileId, userId, currentPayPeriodObj.PayPeriodID).then(teamMembersArray => {

			angular.extend($scope, {
				currentPayPeriod: currentPayPeriodObj,
				showTeamMemberNames: angular.isDefined(userId),
				teamMembers: teamMembersArray
			});

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {

		setPageState('error');
		console.error(error);
	}

	function openAddAChangeFormOptions () {

		if (userId) {
			$scope.formOptions.openNewSlideInForm({
				agencyProfileId,
				callback,
				contextType: 'user',
				formKey: 'add-a-change',
				includeLeavers: true,
				payPeriod: currentPayPeriodObj,
				userId: userId
			});
		}
		else {
			$scope.formOptions.openNewSlideInForm({
				agencyProfileId,
				callback,
				formKey: 'add-a-change',
				payPeriod: currentPayPeriodObj
			});
		}
	}

	function refreshTeamMembers () {

		setPageState('loading');

		payrollData.getAgencyPaymentAdjustmentDetailList(agencyProfileId, userId, currentPayPeriodObj.PayPeriodID).then(teamMembers => {

			$scope.teamMembers = teamMembers;
			setPageState('ready');
		})
		.catch(onError);

		$scope.formOptions.forceCallback();
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	angular.extend($scope, {
		agencyProfileId,
		openAddAChangeFormOptions,
		refreshTeamMembers
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('completeStepForm', function () {

	return {
		controller: 'completeStepFormCtrl',
		templateUrl: 'forms/workflow/complete-step/completeStepForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('completeStepFormCtrl', [
	'$filter',
	'$q',
	'$scope',
	'growl',
	'messageData',
	'MESSAGE_SUBJECT_TYPES',
	'MESSAGE_TYPES',
	'WORKFLOW_STEPS',
	'WORKFLOW_TEMPLATE_ENTRY_STATES',
	'WORKFLOW_CHANGES_TABLE_STATES',
function (
	$filter,
	$q,
	$scope,
	growl,
	messageData,
	MESSAGE_SUBJECT_TYPES,
	MESSAGE_TYPES,
	WORKFLOW_STEPS,
	WORKFLOW_TEMPLATE_ENTRY_STATES,
	WORKFLOW_CHANGES_TABLE_STATES
) {

	const actionType = $scope.formOptions.actionType;
	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const payPeriodObj = $scope.formOptions.payPeriod;
	const workflowTemplateId = $scope.formOptions.workflowTemplateId;
	const workflowTemplateEntryObj = $scope.formOptions.workflowTemplateEntry;

	function completeStep (vmObj, formObj) {

		formObj.state = 'saving';

		const completeWorkflowStep = [messageData.updateWorkflowTemplateEntryState(vmObj.workflowTemplateEntry.WorkflowTemplateEntryID, WORKFLOW_TEMPLATE_ENTRY_STATES.complete)];
		// If this is the Payroll Information step, also submit the changes table changes
		if (workflowTemplateEntryObj.Number === WORKFLOW_STEPS.payrollInformation) {
			completeWorkflowStep.push(messageData.updateWorkflowTemplateChangesTableState(agencyProfileId, WORKFLOW_CHANGES_TABLE_STATES.submitted));
		}

		$q.all(completeWorkflowStep).then(() => {

			$scope.formOptions.forceCallback();

			setPageState('step-completed');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function completeStepOnBehalf (vmObj, formObj) {

		formObj.state = 'saving';

		// Replace emojis with unicode string
		vmObj.newMessage.Text = $filter('emojify')(vmObj.newMessage.Text, 'demojify');

		const completeWorkflowStepOnBehalf = [];
		completeWorkflowStepOnBehalf.push(messageData.createMessage(vmObj.agencyProfileId, vmObj.payPeriod.PayPeriodID, vmObj.newMessage));
		completeWorkflowStepOnBehalf.push(messageData.updateWorkflowTemplateEntryState(vmObj.workflowTemplateEntry.WorkflowTemplateEntryID, WORKFLOW_TEMPLATE_ENTRY_STATES.complete));

		// If this is the Payroll Information step, also submit the changes table changes
		if (workflowTemplateEntryObj.Number === WORKFLOW_STEPS.payrollInformation) {
			completeWorkflowStepOnBehalf.push(messageData.updateWorkflowTemplateChangesTableState(agencyProfileId, WORKFLOW_CHANGES_TABLE_STATES.submitted));
		}

		$q.all(completeWorkflowStepOnBehalf).then(()=> {

			$scope.formOptions.forceCallback();

			setPageState('step-completed');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function goBack (formObj) {

		formObj.state = 'saving';

		const reverseWorkflowStep = [];
		reverseWorkflowStep.push(messageData.updateWorkflowTemplateEntryState(workflowTemplateEntryObj.WorkflowTemplateEntryID, WORKFLOW_TEMPLATE_ENTRY_STATES.active));

		// If this is the confirm calculation step, move the changes table back to 'incomplete' state
		if (workflowTemplateEntryObj.Number === WORKFLOW_STEPS.payrollCalculation) {
			reverseWorkflowStep.push(messageData.updateWorkflowTemplateChangesTableState(agencyProfileId, WORKFLOW_CHANGES_TABLE_STATES.incomplete));
		}

		$q.all(reverseWorkflowStep).then(()=> {

			$scope.formOptions.forceCallback();

			growl.success('Period moved back to previous step');

			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function init () {

		setPageState('loading');

		if (actionType === 'go-back') {
			setPageState('go-back');
			return;
		}

		messageData.getMessageNew().then(newMessageObj => {

			newMessageObj.Type = MESSAGE_TYPES.note;

			$scope.vm = {
				agencyProfileId: agencyProfileId,
				newMessage: newMessageObj,
				payPeriod: payPeriodObj,
				workflowTemplateEntry: workflowTemplateEntryObj
			};

			switch (actionType) {

				case 'query-reports':

					$scope.vm.newMessage.SubjectType = MESSAGE_SUBJECT_TYPES.query;

					setPageState('query-reports');

					break;

				default:

					// Actioner
					if (workflowTemplateEntryObj.IsActioner) {
						setPageState('complete-step');
					}

					// Complete on behalf
					else {
						setPageState('complete-step-on-behalf');
					}
			}
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function updateWorkflowTemplateQueried (vmObj, formObj) {

		const IS_QUERIED = true;

		formObj.state = 'saving';

		vmObj.newMessage.Text = $filter('emojify')(vmObj.newMessage.Text, 'demojify');

		const createMessage = messageData.createMessage(vmObj.agencyProfileId, vmObj.payPeriod.PayPeriodID, vmObj.newMessage);
		const updateWorkflowTemplateQueried = messageData.updateWorkflowTemplateQueried(workflowTemplateId, IS_QUERIED);

		$q.all([createMessage, updateWorkflowTemplateQueried]).then(() => {

			$scope.formOptions.forceCallback();

			setPageState('query-sent');

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		goBack,
		completeStep,
		completeStepOnBehalf,
		updateWorkflowTemplateQueried,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('reassignWorkflowTaskForm', function () {

	return {
		controller: 'reassignWorkflowTaskFormCtrl',
		templateUrl: 'forms/workflow/reassign-workflow-task/reassignWorkflowTaskForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('reassignWorkflowTaskFormCtrl', [
	'$rootScope',
	'$scope',
	'config',
	'messageData',
	'session',
	'teamData',
	'USER_ROLES',
	function (
		$rootScope,
		$scope,
		config,
		messageData,
		session,
		teamData,
		USER_ROLES
	) {

	const workflowTasks = $scope.formOptions.workflowTasks;
	const agencyProfileId = $scope.formOptions.agencyProfileId;

	function init () {

		setPageState('loading');

		const restrictVisibility = true;
		const excludeDepartmentAdmin = true;

		teamData.getTeamMemberAdminsExtended(agencyProfileId, 0, restrictVisibility, excludeDepartmentAdmin)
			.then(adminGroupsObj => {

				/* If the form options dictate, remove the current user from the admin list. In the scenario where the reassign is
				   invoked from the 'My Tasks' page, it makes sense to assume that the tasks are going to be reassigned to a user other
				   than the current. */
				if ($scope.formOptions.omitCurrentUser) {
					removeCurrentUserFromGroups(adminGroupsObj);
				}

				// Get all admins from each group
				const adminsArr = Object.values(adminGroupsObj).flat();

				if (adminsArr.length === 0) {
					// No actioners for re-assignment
					setPageState('no-company-admins');
				}
				else {

					$scope.vm = {
						admins: adminsArr,
						adminGroups: adminGroupsObj,
						actionerSelected: false
					};

					setPageState('ready');
				}

			})
			.catch(onError);
	}

	function removeCurrentUserFromGroups (adminGroupsObj) {

		for (let adminGroupKey of Object.keys(adminGroupsObj)) {
			adminGroupsObj[adminGroupKey] = adminGroupsObj[adminGroupKey].filter(adminObj => adminObj.UserID !== config.guidEmpty && adminObj.UserID !== session.getUserId());
		}
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleActionerIsSelected (vmObj, teamMemberAdminObj) {

		let actionerUserId = (teamMemberAdminObj.UserID);

		/* Deselect all and find the user by Id, selecting it if it isn't already selected. A null actionerUserId
		   means all will be deselected */
		vmObj.selectedActioner = null;

		vmObj.admins.forEach((teamMemberAdmin) => {
			if (teamMemberAdmin.UserID === actionerUserId && !teamMemberAdmin.isSelected) {
				teamMemberAdmin.isSelected = true;
				vmObj.selectedActioner = teamMemberAdmin;
			}
			else {
				teamMemberAdmin.isSelected = false;
			}
		});
	}

	function updateActioner (taskObjs, actioner) {

		// Build task ID list for API
		let taskIdList = taskObjs.map(taskObj => taskObj.WorkflowTemplateEntryID);
		messageData.updateWorkflowTemplateEntryActioner(agencyProfileId, taskIdList, actioner.UserID).then(() => {
			$scope.formOptions.forceCallback();
			setPageState('success');
		})
		.catch(onError);
	}

	angular.extend($scope, {
		workflowTasks,
		toggleActionerIsSelected,
		updateActioner,

		USER_ROLES
	});

	init();

}]);

'use strict';

angular.module('paycircleApp')

.component('deleteReportTemplateForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'deleteReportTemplateFormCtrl',
	templateUrl: 'forms/reporting/delete-report-template/delete-report-template.form.html'
})

.controller('deleteReportTemplateFormCtrl', [
	'reportData',
	function (
		reportData
	) {

	const $ctrl = this;

	function deleteReportTemplate ($form) {

		$form.state = 'saving';

		reportData.deleteReportTemplate($ctrl.formOptions.reportTemplate.ReportTemplateID, $ctrl.formOptions.agencyProfileId)
			.then(() => {

				setPageState('saved');

				$ctrl.formOptions.forceCallback();
			})
			.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function setPageState (pageState) {
		$ctrl.pageState = pageState;
	}

	angular.extend($ctrl, {
		deleteReportTemplate,

		pageState: 'ready'
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('downloadReportsForm', function () {

	return {
		controller: 'downloadReportsFormCtrl',
		templateUrl: 'forms/reporting/download-reports/downloadReportsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('downloadReportsFormCtrl', [
	'$filter',
	'$q',
	'$scope',
	'$timeout',
	'agency',
	'dataTransfer',
	'payrollData',
	'payrollWorker',
	'reportData',
	'STATE_TYPES',
	'SUBMISSION_STATES',
	function (
		$filter,
		$q,
		$scope,
		$timeout,
		agency,
		dataTransfer,
		payrollData,
		payrollWorker,
		reportData,
		STATE_TYPES,
		SUBMISSION_STATES
	) {

	const POLL_INTERVAL_PAYSLIPS = 3; // Seconds

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const companyObj = $scope.formOptions.company;
	const hasGeneratedPayslips = angular.isDefined($scope.formOptions.hasGeneratedPayslips) ? $scope.formOptions.hasGeneratedPayslips : false;
	const isHistoricPeriod = angular.isDefined($scope.formOptions.isHistoricPeriod) ? $scope.formOptions.isHistoricPeriod : true;
	const payPeriodId = $scope.formOptions.payPeriodId;
	let payslipTimeout = null;

	function checkPayslipStatus (vmObj) {

		agency.getAgencyPayPeriodState(vmObj.payPeriod.PayPeriodID, STATE_TYPES.payslip).then(payslipState => {

			// Update pay period
			vmObj.payPeriod.PayslipState = payslipState;

			switch (payslipState) {

				// Poll until ready or failed
				case SUBMISSION_STATES.unsubmitted:
				case SUBMISSION_STATES.submitting:

					setPageState('generating-payslips');

					payslipTimeout = $timeout(() => {
						checkPayslipStatus(vmObj);
					}, POLL_INTERVAL_PAYSLIPS * 1000);
					break;

				case SUBMISSION_STATES.failed:

					setPageState('generating-payslips-failed');
					throw('Paycircle: Pay period reports were unable to be calculated');

				default:

					$scope.formOptions.forceCallback();
					setPageState('ready');
			}
		})
		.catch(onError);
	}

	function createPayslips (vmObj) {

		setPageState('generating-payslips');

		vmObj.payPeriod.PayslipState = SUBMISSION_STATES.submitting;

		payrollWorker.payrollCreatePayslips(agencyProfileId, vmObj.payPeriod.PayPeriodID).then(() => {

			vmObj.hasGeneratedPayslips = true;

			checkPayslipStatus(vmObj);
		})
		.catch(onError);
	}

	function exportReports (vmObj, form) {

		form.state = 'saving';

		setPageState('generating');

		if (!vmObj.isPasswordProtected) {
			vmObj.reportCollection.ReportTemplateCollectionPassword = '';
		}

		reportData.updateReportTemplateCollection(agencyProfileId, vmObj.reportCollection).then(() => {

			reportData.createPeriodReportsZipDownload(agencyProfileId, vmObj.payPeriod.PayPeriodID).then(downloadUrl => {

				const fallbackFileName = `${companyObj.Name} ${$filter('dateformat')(vmObj.payPeriod.StartDateISO, 'custom', 'YYYY-MM-DD')}_TO_${$filter('dateformat')(vmObj.payPeriod.EndDateISO, 'custom', 'YYYY-MM-DD')}.zip`;

				dataTransfer.downloadFile(downloadUrl, fallbackFileName);

				$scope.formOptions.forceCallback();
				$scope.formOptions.closeForm();

				form.state = 'saved';

			}).catch(onError);
		}).catch(onError);
	}

	function init () {

		if (!payPeriodId) {
			onError('No PayPeriodID has been provided');
			return;
		}

		setPageState('loading');

		const getPayPeriodSpecific = payrollData.getPayPeriodSpecific(payPeriodId);
		const getPeriodReportsDownloadReportTemplateCollection = reportData.getPeriodReportsDownloadReportTemplateCollection(agencyProfileId, payPeriodId);

		$q.all([
			getPayPeriodSpecific,
			getPeriodReportsDownloadReportTemplateCollection
		]).then(([
			payPeriodObj,
			reportCollectionObj
		]) => {

			let vmObj = {
				payPeriod: payPeriodObj,
				reportCollection: reportCollectionObj,
				isPasswordProtected: reportCollectionObj.ReportTemplateCollectionPassword !== ''
			};

			reviewPayslipState(vmObj);

			$scope.vm = vmObj;
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function reviewPayslipState (vmObj) {

		// Ignore historic periods
		if (isHistoricPeriod) {
			setPageState('ready');
			return;
		}

		// If payslips haven't been generated yet, make sure they are generated in case any changes have been made
		if (!hasGeneratedPayslips) {

			createPayslips(vmObj);
			return;
		}

		/**
		 * We only need to kick off the generation of payslips if they're unsubmitted.
		 * All other states will simply need to review the state and poll if necessary
		**/
		switch (vmObj.payPeriod.PayslipState) {

			case SUBMISSION_STATES.submitted: {

				setPageState('ready');
				break;
			}

			case SUBMISSION_STATES.unsubmitted: {

				createPayslips(vmObj);
				break;
			}

			default: {

				checkPayslipStatus(vmObj);
			}
		}
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function toggleShowPassword (vmObj) {
		vmObj.showPassword = !vmObj.showPassword;
	}

	init();

	// Cancel any pending timeouts
	$scope.$on('$destroy', () => {
		$timeout.cancel(payslipTimeout);
	});

	angular.extend($scope, {
		SUBMISSION_STATES,

		createPayslips,
		exportReports,
		toggleShowPassword,
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('manageReportPacksForm', function () {

	return {
		controller: 'manageReportPacksFormCtrl',
		templateUrl: 'forms/reporting/manage-report-packs/manageReportPacksForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('manageReportPacksFormCtrl', ['$q', '$rootScope', '$scope', 'growl', 'reportData', 'reportsService', function ($q, $rootScope, $scope, growl, reportData, reportsService) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const agencyProfileParentId = $scope.formOptions.agencyProfileParentId;

	function assignNewPack (agencyReportGroupObj, formObj) {

		formObj.state = 'saving';

		reportData.assignReportTemplateGroup(agencyProfileId, agencyReportGroupObj).then(() => {

			init();

			$scope.formOptions.forceCallback();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function closeReportPack (vmObj) {
		vmObj.activeReportGroup = null;
		setPageState('report-groups');
	}

	function decorateReportTemplatesPreUpdate (reportObj) {

		reportObj.Accessibility = reportsService.getAccessibilityForReport(reportObj);

		return reportObj;
	}

	function getAssignableReportGroups (companyReportTemplateGroupsArr, parentReportTemplateGroupsArr) {

		let assignableParentReportPacksArr = parentReportTemplateGroupsArr.filter(parentReportGroupObj => {
			return !parentReportGroupObj.IsOrphanTemplateGroup && !companyReportTemplateGroupsArr.find(companyReportPackObj => companyReportPackObj.ReportTemplateParentGroupID === parentReportGroupObj.ReportTemplateGroupID);
		});

		let hiddenCompanyReportPacksArr = companyReportTemplateGroupsArr.filter(reportTemplateGroupObj => !reportTemplateGroupObj.IsVisible);

		return assignableParentReportPacksArr.concat(hiddenCompanyReportPacksArr);
	}

	function decorateReportGroups (reportGroupObj) {

		reportGroupObj.ReportTemplates = reportsService.getTemplatesFromReportCategories(reportGroupObj.ReportTemplates);

		for (let reportTemplateObj of reportGroupObj.ReportTemplates) {
			reportsService.getAccessibilityForReportTemplate(reportTemplateObj);
		}

		return reportGroupObj;
	}

	function init () {

		setPageState('loading');

		let getReportTemplateGroupsParent = reportData.getReportTemplateGroups(agencyProfileParentId);
		let getReportTemplateGroupsCompany = reportData.getReportTemplateGroups(agencyProfileId);

		$q.all([getReportTemplateGroupsParent, getReportTemplateGroupsCompany]).then(
			([parentReportTemplateGroupsArr, companyReportTemplateGroupsArr]) => {

			parentReportTemplateGroupsArr = parentReportTemplateGroupsArr.filter(decorateReportGroups);
			companyReportTemplateGroupsArr = companyReportTemplateGroupsArr.filter(decorateReportGroups);

			$scope.vm = {
				assignableReportPacks: getAssignableReportGroups(companyReportTemplateGroupsArr, parentReportTemplateGroupsArr),
				companyReportPacks: companyReportTemplateGroupsArr.filter(reportTemplateGroupObj => reportTemplateGroupObj.IsVisible),
				newPack: null
			};

			setAddGroupState('add-pack');

			if (companyReportTemplateGroupsArr.length) {
				setPageState('report-groups');
			}
			else {
				setPageState('no-report-groups');
			}

		})
		.catch(onError);
	}

	function onError (error) {
		setPageState('error');
		console.error(error);
	}

	function setActiveReportGroupById (vmObj, reportTemplateGroupObj) {
		vmObj.activeReportGroup = reportTemplateGroupObj;
		setPageState('report-group');
	}

	function setAddGroupState (addGroupState) {
		$scope.vm.addGroupState = addGroupState;
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	function unassignReportGroup (vmObj) {

		vmObj.saveState = 'saving';

		reportData.deleteReportTemplateGroup(agencyProfileId, vmObj.activeReportGroup).then(() => {

			vmObj.saveState = 'saved';

			$scope.formOptions.forceCallback();

			init();
		})
		.catch(onError);
	}

	function updateReportTemplateVisibilityDetailsForPack (vmObj, formObj) {

		formObj.state = 'saving';

		let activeReportGroupObj = vmObj.activeReportGroup;

		activeReportGroupObj.ReportTemplates = activeReportGroupObj.ReportTemplates.filter(decorateReportTemplatesPreUpdate);

		reportData.updateReportTemplateVisibilityDetailsForPack(agencyProfileId, activeReportGroupObj.ReportTemplateGroupID, activeReportGroupObj.ReportTemplates).then(() => {

			const getReportTemplateGroup = reportData.getReportTemplateGroup(activeReportGroupObj.ReportTemplateGroupID);
			const getReportTemplateGroups = reportData.getReportTemplateGroups(agencyProfileId);

			$q.all([getReportTemplateGroup, getReportTemplateGroups]).then(
				([newActiveReportGroupObj, companyReportTemplateGroupsArr]) => {

				formObj.state = 'saved';

				angular.extend(vmObj, {
					activeReportGroup: decorateReportGroups(newActiveReportGroupObj),
					companyReportPacks: companyReportTemplateGroupsArr.filter(decorateReportGroups)
				});

				setPageState('report-group');

				$scope.formOptions.forceCallback();

				growl.success(`${vmObj.activeReportTemplate.ReportTemplateName} has been updated`);
			})
			.catch(onError);
		})
		.catch(onError);
	}

	function viewReportTemplate (vmObj, reportTemplateObj) {

		vmObj.activeReportTemplate = reportTemplateObj;
		setPageState('report-template');
	}

	init();

	angular.extend($scope, {
		assignNewPack,
		closeReportPack,
		setActiveReportGroupById,
		setAddGroupState,
		setPageState,
		unassignReportGroup,
		updateReportTemplateVisibilityDetailsForPack,
		viewReportTemplate
	});
}]);

'use strict';

angular.module('paycircleApp')

.component('reportTemplateGroupForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'reportTemplateGroupFormCtrl',
	templateUrl: 'forms/reporting/report-template-group/report-template-group.form.html'
})

.constant('REPORT_TEMPLATE_GROUP_FORM_VIEWS', {
	delete: 'delete',
	duplicate: 'duplicate',
	new: 'new',
	update: 'update',
	viewInheritorsCompanies: 'view-inheritors-companies',
	viewInheritorsGroups: 'view-inheritors-groups'
})

.controller('reportTemplateGroupFormCtrl', [
	'growl',
	'reportData',
	'reportsService',
	'REPORT_TEMPLATE_GROUP_FORM_VIEWS',
	function (
		growl,
		reportData,
		reportsService,
		REPORT_TEMPLATE_GROUP_FORM_VIEWS
	) {

	const $ctrl = this;

	const FORM_STATES = {
		confirmDelete: 'confirm-delete',
		error: 'error',
		groupInUse: 'group-in-use',
		groupNotInUse: 'group-not-in-use',
		loading: 'loading',
		processGroupActions: 'process-group-actions',
		viewGroupInheritors: 'view-group-inheritors',
	};

	function $onInit () {

		setFormState(FORM_STATES.loading);

		$ctrl.reportTemplateGroupFormView = angular.isDefined($ctrl.formOptions.reportTemplateGroupFormView) ? $ctrl.formOptions.reportTemplateGroupFormView : REPORT_TEMPLATE_GROUP_FORM_VIEWS.new;

		switch ($ctrl.reportTemplateGroupFormView) {
			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.new:
				initNewReportTemplateGroupForm();
				break;

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.update:
				loadForm($ctrl.formOptions.reportTemplateGroup);
				break;

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.duplicate:
				initDuplicateReportTemplateGroupForm();
				break;

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete:
			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies:
			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups:
				initViewReportTemplateGroupInheritorsForm();
		}
	}

	function getGroupInheritorsSearchOptions () {

		// Not needed for group delete view
		if ($ctrl.reportTemplateGroupFormView === REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete) {
			return;
		}

		function getGroupInheritorLabelForType () {

			switch ($ctrl.reportTemplateGroupFormView) {
				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies:
					return {
						singular: 'company',
						plural: 'companies'
					};

				case REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups:
					return {
						singular: 'company group',
						plural: 'company groups'
					};
			}
		}

		const groupInheritorTypeLabelObj = getGroupInheritorLabelForType();

		return {
			id: 'report-template-group-form',
			orderByOptions: [
				{
					key: 'name-asc',
					field: 'AgencyProfileName',
					reverse: false,
					title: 'Name A-Z'
				},
				{
					key: 'name-desc',
					field: 'AgencyProfileName',
					reverse: true,
					title: 'Name Z-A'
				}
			],
			search: {
				terms: {
					placeholder: `Search ${groupInheritorTypeLabelObj.plural}...`,
					singular: '1 ' + groupInheritorTypeLabelObj.singular,
					plural: '{} ' + groupInheritorTypeLabelObj.plural
				}
			}
		};
	}

	function getInitialFormStateForIniheritorsView (reportTemplateGroupInheritorsObj) {

		// Show warning if pack it not in use when viewing inheritors
		if (
			(
				$ctrl.reportTemplateGroupFormView === REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies &&
				reportTemplateGroupInheritorsObj.Companies.length === 0
			) ||
			(
				$ctrl.reportTemplateGroupFormView === REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups &&
				reportTemplateGroupInheritorsObj.CompanyGroups.length === 0
			)
		) {
			return FORM_STATES.groupNotInUse;
		}

		// Show warning when group is in use when deleteing a group
		if ($ctrl.reportTemplateGroupFormView === REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete) {

			if (reportTemplateGroupInheritorsObj.CompanyGroups.length + reportTemplateGroupInheritorsObj.Companies.length !== 0) {
				return FORM_STATES.groupInUse;
			}
			else {
				return FORM_STATES.confirmDelete;
			}
		}

		return FORM_STATES.viewGroupInheritors;
	}

	function getReportTemplateGroupPromise () {

		switch ($ctrl.reportTemplateGroupFormView) {
			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.new:
				return {
					promise: reportData.createReportTemplateGroup,
					confirm: 'Report pack created'
				};

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.update:
				return {
					promise: reportData.updateReportTemplateGroup,
					confirm: 'Report pack updated'
				};

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.duplicate:
				return {
					promise: reportData.duplicateReportTemplateGroup,
					confirm: 'Report pack created'
				};

			case REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete:
				return {
					promise: reportData.deleteReportTemplateGroup,
					confirm: 'Report pack deleted'
				};
		}
	}

	function initDuplicateReportTemplateGroupForm () {

		angular.extend($ctrl.formOptions.reportTemplateGroup, {
			reportTemplateGroupNameOriginal: angular.copy($ctrl.formOptions.reportTemplateGroup.ReportTemplateGroupName),
			ReportTemplateGroupDefault: false,
		});

		loadForm($ctrl.formOptions.reportTemplateGroup);
	}

	function initNewReportTemplateGroupForm () {

		reportData.getEmptyReportTemplateGroup()
			.then(emptyReportTemplateGroupObj => {

				emptyReportTemplateGroupObj.AgencyProfileID = $ctrl.formOptions.agencyProfileId;

				loadForm(emptyReportTemplateGroupObj);
			})
			.catch(onError);
	}

	function initViewReportTemplateGroupInheritorsForm () {

		reportData.getReportTemplateGroupInheritors($ctrl.formOptions.agencyProfileId, $ctrl.formOptions.reportTemplateGroup.ReportTemplateGroupID)
			.then(reportTemplateGroupInheritorsObj => {

				angular.extend($ctrl, {
					formState: getInitialFormStateForIniheritorsView(reportTemplateGroupInheritorsObj),
					reportTemplateGroup: $ctrl.formOptions.reportTemplateGroup,
					reportTemplateGroupInheritors: reportTemplateGroupInheritorsObj,
					searchBarOptions: getGroupInheritorsSearchOptions()
				});

			})
			.catch(onError);
	}

	function loadForm (reportTemplateGroupObj) {

		$ctrl.reportTemplateGroup = reportTemplateGroupObj;

		setFormState(FORM_STATES.processGroupActions);
	}

	function onError (error) {
		setFormState(FORM_STATES.error);
		console.error(error);
	}

	function onFormSubmit ($form) {

		$form.state = 'saving';

		const templateGroupPromiseDetails = getReportTemplateGroupPromise();

		templateGroupPromiseDetails.promise($ctrl.formOptions.agencyProfileId, $ctrl.reportTemplateGroup)
			.then(responseObj => {

				$ctrl.formOptions.forceCallback(responseObj);
				$ctrl.formOptions.closeForm();

				growl.success(templateGroupPromiseDetails.confirm);

				$form.state = 'saved';
			})
			.catch(onError);
	}

	function onViewInheritors (reportTemplateFormViewKey) {

		$ctrl.formOptions.openNewSlideInForm({
			agencyProfileId: $ctrl.formOptions.agencyProfileId,
			formKey: 'report-template-group',
			reportTemplateGroup: $ctrl.formOptions.reportTemplateGroup,
			reportTemplateGroupFormView: reportTemplateFormViewKey,
			title: reportsService.getReportTemplateGroupFormTitleForView(reportTemplateFormViewKey)
		});
	}

	function setFormState (newState) {
		$ctrl.formState = newState;
	}

	angular.extend($ctrl, {
		$onInit,

		onFormSubmit,
		onViewInheritors,

		FORM_STATES,
		REPORT_TEMPLATE_GROUP_FORM_VIEWS
	});
}]);

'use strict';

angular.module('paycircleApp')

	.component('bacsDownloadConfirmForm', {
		bindings: {
			formOptions: '='
		},
		controller: 'bacsDownloadConfirmFormCtrl',
		templateUrl: 'forms/reporting/bacs-download-confirmation/bacs-download-confirmation.form.html'
	})

	.controller('bacsDownloadConfirmFormCtrl', [
		'reportsService',
		function (
			reportsService
		) {

			const $ctrl = this;

			function $onInit () {
				setPageState('ready');
			}

			function setPageState (newState) {
				$ctrl.pageState = newState;
			}

			function exportBacs (reportObj) {
				reportsService.exportReportDTO(reportObj);
				$ctrl.formOptions.closeForm();
			}

			angular.extend($ctrl, {
				$onInit,
				exportBacs
			});
		}
	]);

'use strict';

angular.module('paycircleApp')

.directive('addNewCompanyFinishedForm', function () {

	return {
		controller: 'addNewCompanyFinishedFormCtrl',
		templateUrl: 'forms/admin/addNewCompany/finished/addNewCompanyFinishedForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addNewCompanyFinishedFormCtrl', ['$scope', 'session', 'wizardService', function ($scope, session, wizardService) {

	// Scope
	$scope.company = wizardService.newCreatedCompany || wizardService.newCompany;
	$scope.pageState = 'ready';
}]);

'use strict';

angular.module('paycircleApp')

.directive('addTeamMemberFinishedForm', function () {

	return {
		controller: 'addTeamMemberFinishedFormCtrl',
		templateUrl: 'forms/personal/finished/addTeamMemberFinishedForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('addTeamMemberFinishedFormCtrl', ['$rootScope', '$scope', '$state', 'COMPANY_STATES', 'FORM_WIZARD_KEYS',
	function ($rootScope, $scope, $state, COMPANY_STATES, FORM_WIZARD_KEYS) {

	const formOptions = $scope.formOptions;
	const agencyProfileId = formOptions.agencyProfileId;
	const wizardKey = formOptions.wizardKey;
	const callback = formOptions.forceCallback;
	const teamMember = formOptions.context;

	function init () {

		if (callback) {
			callback();
		}

		let formView;
		let title;

		switch (wizardKey) {
			case FORM_WIZARD_KEYS.teamMemberAdd:
			case FORM_WIZARD_KEYS.teamMemberEditPersonal:
				title = 'Personal information';
				formView = teamMember.IsCISSubcontractor ? 'personal-cis' : 'personal';
				break;
			case FORM_WIZARD_KEYS.teamMemberEditEmployment:
				title = 'Employment information';
				formView = 'employment';
				break;
			case FORM_WIZARD_KEYS.teamMemberEditAEPension:
				title = 'Pension information';
				formView = 'ae-pension';
				break;
			case FORM_WIZARD_KEYS.teamMemberEditNonAEPension:
				title = 'Pension information';
				formView = 'non-ae-pension';
				break;
			case FORM_WIZARD_KEYS.cisCompany:
				title = 'Company information';
				formView = 'cis-company';
				break;
			case FORM_WIZARD_KEYS.cisSubcontractor:
				title = 'CIS information';
				formView = 'cis-subcontractor';
		}

		$scope.formOptions.title = title;
		$scope.formView = formView;
		$scope.teamMember = teamMember;
		$scope.hasPension = formOptions.company.IsPensionActive && formOptions.company.HasPension;
	}

	function openAddTeamMemberWizard () {

		$state.go('team.members', { agencyProfileId: agencyProfileId }).then(function () {

			const teamRefreshCallback = function() {
				if (callback) {
					callback();
				}
				$rootScope.$broadcast('refresh-team-view');
			};

			formOptions.openNewFormWizard({
				agencyProfileId: agencyProfileId,
				wizardKey: FORM_WIZARD_KEYS.teamMemberAdd,
				callback: teamRefreshCallback
			});
		});
	}

	function openCISVerificationForm () {

		formOptions.openNewSlideInForm({
			agencyProfileId: agencyProfileId,
			callback: callback,
			contextType: 'user',
			formKey: 'cis-verification',
			userId: teamMember.UserID
		});
	}

	function openNewFormWizard (newWizardKey) {

		formOptions.openNewFormWizard({
			contextType: 'user',
			showContext: true,
			activeStepIndex: 0,
			agencyProfileId: agencyProfileId,
			callback: callback,
			userId: teamMember.UserID,
			wizardKey: newWizardKey,
			disableCallback: true,
			currentPayPeriod: formOptions.currentPayPeriod
		});
	}

	init();

	angular.extend($scope, {

		// Constants
		COMPANY_STATES,
		FORM_WIZARD_KEYS,

		// Functions
		openAddTeamMemberWizard,
		openCISVerificationForm,
		openNewFormWizard
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('cisBusinessTypeForm', function () {

	return {
		controller: 'cisBusinessTypeFormCtrl',
		templateUrl: 'forms/cis/business-type/cisBusinessTypeForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cisBusinessTypeFormCtrl', ['$scope', 'growl', 'teamData', 'BUSINESS_TYPES', function ($scope, growl, teamData, BUSINESS_TYPES) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var user = $scope.formOptions.context;
	var userId = $scope.formOptions.userId;

	function decorateCISDetails (cisDetailsObj) {

		cisDetailsObj.lastContracted = 'less-than-2-years';
		cisDetailsObj.isVATRegistered = cisDetailsObj.VATRegistrationNumber !== '';
		cisDetailsObj.dateVerifiedISOMin = moment().subtract(2, 'years').format();
		cisDetailsObj.dateVerifiedISOMax = moment().format();

		// CIS Business Details
		cisDetailsObj.BusinessDetails.TradingName = cisDetailsObj.BusinessDetails.TradingName !== '' ? cisDetailsObj.BusinessDetails.TradingName : user.Forename + ' ' + user.Surname; // Set trading name to person's forename if not set

		return cisDetailsObj;
	}

	function init () {

		$scope.pageState = 'loading';

		teamData.getTeamMemberCISDetails(userId, agencyProfileId).then(function(cisDetailsObj) {

			// Scope
			$scope.cisDetails = decorateCISDetails(cisDetailsObj);

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	$scope.formOptions.title = user.BusinessDetails.BusinessType === BUSINESS_TYPES.soletrader ? 'Sole Trader details' : 'Partnership details';
	init();

	// Scope constants
	$scope.BUSINESS_TYPES = BUSINESS_TYPES;

	// Scope functions
	$scope.updateTeamMemberCISBusiness = function (cisDetails, form) {

		form.state = 'saving';

		teamData.updateTeamMemberCISBusiness(userId, agencyProfileId, cisDetails).then(function() {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			// Show success message
			growl.success('CIS details have been updated');

			// Force callback
			$scope.formOptions.forceCallback();

			// Close form
			$scope.formOptions.closeForm();

			// Form state
			form.state = 'saved';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('cisCompanyContactForm', function () {

	return {
		controller: 'cisCompanyContactFormCtrl',
		templateUrl: 'forms/cis/company-contact/cisCompanyContactForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cisCompanyContactFormCtrl', ['$q', '$scope', 'companyData', 'teamData', 'growl', 'BUSINESS_TYPES', 'SALUTATIONS', function ($q, $scope, companyData, teamData, growl, BUSINESS_TYPES, SALUTATIONS) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		var getTeamMemberContact = teamData.getTeamMemberContact(agencyProfileId, userId);
		var getTeamMemberCISCompanyDetails = teamData.getTeamMemberCISCompanyDetails(agencyProfileId, userId);

		$q.all([getTeamMemberContact, getTeamMemberCISCompanyDetails]).then(function (data) {

			var contactObj = data[0];
			var cisCompanyObj = data[1];

			$scope.cisCompany = cisCompanyObj;
			$scope.contact = contactObj;

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	// Scope constants
	$scope.BUSINESS_TYPES = BUSINESS_TYPES;
	$scope.SALUTATIONS = SALUTATIONS;

	// Scope functions
	$scope.updateCisCompanyContact = function (contactObj, form) {

		teamData.updateTeamMemberCISCompanyContact(agencyProfileId, userId, contactObj).then(function() {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success('CIS company contact details have been updated');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
		});
	};

	$scope.usingDummyEmail = function (contactObj, formObj) {

		formObj.$setPristine();
		formObj.$setUntouched();

		if (contactObj.DummyEmail) {
			contactObj.originalEmail = angular.copy(contactObj.Email);
			contactObj.Email = '';
		}
		else {
			contactObj.Email = contactObj.originalEmail !== undefined ? angular.copy(contactObj.originalEmail) : '';
		}
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('cisCompanyDetailsForm', function () {

	return {
		controller: 'cisCompanyDetailsFormCtrl',
		templateUrl: 'forms/cis/company-details/cisCompanyDetailsForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cisCompanyDetailsFormCtrl', ['$scope', 'config', 'growl', 'teamData', 'validationService', 'BUSINESS_TYPES', 'SALUTATIONS', function ($scope, config, growl, teamData, validationService, BUSINESS_TYPES, SALUTATIONS) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var company = $scope.formOptions.company;
	var userId = $scope.formOptions.userId;

	function decorateCISCompanyObj (cisCompanyObj) {

		cisCompanyObj.addressDetailsPending = !cisCompanyObj.hasAddress;

		return cisCompanyObj;
	}

	function init () {

		setPageState('loading');

		teamData.getTeamMemberCISCompanyDetails(agencyProfileId, userId).then(function(cisCompanyObj) {

			// If in playground, force NI Number Pending & UTR Pending
			cisCompanyObj.UTR = company.AgencyProfileDummy ? '2234567890' : cisCompanyObj.UTR;
			cisCompanyObj.UTRPending = company.AgencyProfileDummy ? true : false;

			// Check if an address exists on load
			cisCompanyObj.hasAddress = !validationService.isEmptyGuid(cisCompanyObj.AddressDetails.AddressID);

			$scope.cisCompany = decorateCISCompanyObj(cisCompanyObj);

			setPageState('ready');
		})
		.catch(function () {
			setPageState('error');
		});
	}

	function setPageState (pageState) {

		$scope.pageState = pageState;
	}

	init();

	$scope.BUSINESS_TYPES = BUSINESS_TYPES;
	$scope.SALUTATIONS = SALUTATIONS;

	$scope.updateCISCompanyContact = function (cisDetails, form) {

		form.state = 'saving';

		// CIS Companies
		if (cisDetails.addressDetailsPending) {
			angular.extend(cisDetails.AddressDetails, {
				AddressCountry: '',
				AddressID: config.guidEmpty
			});
		}

		teamData.updateTeamMemberCISCompanyDetails(agencyProfileId, userId, cisDetails).then(function() {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success('CIS details have been updated');

			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
			form.state = 'saved';
		})
		.catch(function () {
			setPageState('error');
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('cisVatForm', function () {

	return {
		controller: 'cisVatFormCtrl',
		templateUrl: 'forms/cis/vat/cisVATForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cisVatFormCtrl', ['$scope', 'growl', 'teamData', 'BUSINESS_TYPES', function ($scope, growl, teamData, BUSINESS_TYPES) {

	var agencyProfileId = $scope.formOptions.agencyProfileId;
	var userId 			= $scope.formOptions.userId;

	function decorateCISDetails (cisDetailsObj) {

		cisDetailsObj.lastContracted = 'less-than-2-years';
		cisDetailsObj.isVATRegistered = cisDetailsObj.VATRegistrationNumber !== '';
		cisDetailsObj.dateVerifiedISOMin = moment().subtract(2, 'years').format();
		cisDetailsObj.dateVerifiedISOMax = moment().format();

		return cisDetailsObj;
	}

	function init () {

		$scope.pageState = 'loading';

		teamData.getTeamMemberCISDetails(userId, agencyProfileId).then(function(cisDetailsObj) {

			// Scope
			$scope.cisDetails = decorateCISDetails(cisDetailsObj);

			// Page state
			$scope.pageState = 'ready';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	}

	init();

	// Scope constants
	$scope.BUSINESS_TYPES = BUSINESS_TYPES;

	// Scope functions
	$scope.updateTeamMemberCISVAT = function (cisDetails, form) {

		form.state = 'saving';

		teamData.updateTeamMemberCISVAT(userId, agencyProfileId, cisDetails).then(function() {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			// Show success message
			growl.success('CIS details have been updated');

			// Force callback
			$scope.formOptions.forceCallback();

			// Close form
			$scope.formOptions.closeForm();

			// Form state
			form.state = 'saved';
		})
		.catch(function () {

			// Page state
			$scope.pageState = 'error';
		});
	};
}]);

'use strict';

angular.module('paycircleApp')

.directive('cisVerificationForm', function () {

	return {
		controller: 'cisVerificationFormCtrl',
		templateUrl: 'forms/cis/verification/cisVerificationForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('cisVerificationFormCtrl', [
	'$q',
	'$rootScope',
	'$scope',
	'$timeout',
	'growl',
	'payrollData',
	'teamData',
	'userData',
	'BUSINESS_TYPES',
	'SUBMISSION_STATES',
	'TAX_TREATMENT_OPTIONS',
	function (
		$q,
		$rootScope,
		$scope,
		$timeout,
		growl,
		payrollData,
		teamData,
		userData,
		BUSINESS_TYPES,
		SUBMISSION_STATES,
		TAX_TREATMENT_OPTIONS
	) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriodObj = $scope.formOptions.currentPayPeriod;
	const isReverify = $scope.formOptions.isReverify;
	const userId = $scope.formOptions.userId;
	const userObj = $scope.formOptions.context;

	const FORM_STATES = {
		error: 'error',
		loading: 'loading',
		notReady: 'not-ready',
		ready: 'ready',
		reverify: 'reverify',
		verified: 'verified',
		verifyFailed: 'verify-failed',
		verifying: 'verifying'
	};

	const LAST_CONTACTED_OPTIONS = {
		lessThanTwoYears: 'less-than-2-years',
		moreThanTwoYears: 'more-than-2-years',
		firstTime: 'first-time'
	};

	const TIME_TO_POLL = 3; // Seconds

	function init () {

		setPageState(FORM_STATES.loading);

		const getTeamMemberCISDetails = teamData.getTeamMemberCISDetails(userId, agencyProfileId);
		const getTeamMemberInformation = teamData.getTeamMemberInformation(userId, agencyProfileId);

		$q.all([
			getTeamMemberCISDetails,
			getTeamMemberInformation
		]).then(([
			cisDetailsObj,
			teamMemberObj
		]) => {

			$scope.vm = {
				cisDetails: cisDetailsObj,
				dateVerifiedISOMax: moment().format(),
				dateVerifiedISOMin: moment().subtract(2, 'years').format(),
				isCompany: userObj.IsCISSubcontractor && (userObj.BusinessDetails.BusinessType === BUSINESS_TYPES.company || userObj.BusinessDetails.BusinessType === BUSINESS_TYPES.trust),
				lastContracted: LAST_CONTACTED_OPTIONS.lessThanTwoYears
			};

			setPageState(getPageStateByVerificationState(cisDetailsObj, teamMemberObj));
		})
		.catch(onError);
	}

	function getPageStateByVerificationState (cisDetailsObj, teamMemberObj, isProcessing) {

		teamMemberObj = teamMemberObj ? teamMemberObj : null;

		if (teamMemberObj && (!teamMemberObj.AddressSetupComplete || !teamMemberObj.BusinessSetupComplete)) {
			return FORM_STATES.notReady;
		}

		switch (cisDetailsObj.VerificationState) {

			case SUBMISSION_STATES.submitting:
				return FORM_STATES.verifying;

			case SUBMISSION_STATES.submitted:

				// Allow already verified to be reverified
				if (isProcessing || !isReverify) {
					return FORM_STATES.verified;
				} else {
					return FORM_STATES.reverify;
				}

				break;

			case SUBMISSION_STATES.failed:
				return FORM_STATES.verifyFailed;

			default:
				return isReverify ? FORM_STATES.reverify : FORM_STATES.ready;
		}
	}

	function onError (error) {
		setPageState(FORM_STATES.error);
		console.error(error);
	}

	function payrollVerifySubcontractors (vmObj) {

		// Set page state to verifying
		setPageState(FORM_STATES.verifying);

		// Reset CIS details
		angular.extend(vmObj.cisDetails, {
			VerificationReference: '',
			DateVerifiedISO: '',
			TaxTreatment: 0
		});

		// Update CIS details
		teamData.updateTeamMemberCISDetails(userId, agencyProfileId, vmObj.cisDetails).then(() => {

			// Verify person
			payrollData.payrollVerifySubcontractors(agencyProfileId, currentPayPeriodObj.PayPeriodID, userId).then(() => {

				// Kick off polling for verification state
				$timeout(() => {
					pollForVerificationState(vmObj.cisDetails);
				}, TIME_TO_POLL * 1000);

			})
			.catch(onError);
		})
		.catch(onError);
	}

	function pollForVerificationState (cisDetailsObj) {

		userData.getCISSubmissionState(agencyProfileId, userId).then(latestCisSubmissionState => {

			let timer;

			// update scope
			cisDetailsObj.VerificationState = latestCisSubmissionState;

			// Update page state
			const isProcessing = true;
			setPageState(getPageStateByVerificationState(cisDetailsObj, null, isProcessing));

			switch (cisDetailsObj.VerificationState) {
				case SUBMISSION_STATES.submitting:

					// Poll
					timer = $timeout(function () {
						pollForVerificationState(cisDetailsObj);
					}, TIME_TO_POLL * 1000);

					break;
				case SUBMISSION_STATES.submitted:
				case SUBMISSION_STATES.failed:

					// Force callback
					$scope.formOptions.forceCallback();

					// Cancel timout
					$timeout.cancel(timer);

					break;
				default:

					// Cancel timout
					$timeout.cancel(timer);
			}

			return timer;
		})
		.catch(onError);
	}

	function setPageState (newState) {
		
		$scope.pageState = newState;
	}

	function updateTeamMemberCISVerification (vmObj, formObj) {

		formObj.state = 'saving';

		teamData.updateTeamMemberCISVerification(userId, agencyProfileId, vmObj.cisDetails).then(() => {

			if ($scope.formOptions.isWizard) {
				$scope.formOptions.onSuccess();
				return;
			}

			growl.success('CIS details have been updated');

			$scope.formOptions.forceCallback();

			$scope.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	init();

	angular.extend($scope, {
		FORM_STATES,
		LAST_CONTACTED_OPTIONS,
		TAX_TREATMENT_OPTIONS,

		payrollVerifySubcontractors,
		setPageState,
		updateTeamMemberCISVerification
	});
}]);

'use strict';

angular.module('paycircleApp')

.directive('editDeemedPaymentForm', function () {

	return {
		controller: 'editDeemedPaymentFormCtrl',
		templateUrl: 'forms/off-payroll/editDeemedPaymentForm.html',
		restrict: 'E',
		scope: {
			formOptions: '='
		}
	};
})

.controller('editDeemedPaymentFormCtrl', ['$q', '$scope', 'config', 'payrollData', function ($q, $scope, config, payrollData) {

	const agencyProfileId = $scope.formOptions.agencyProfileId;
	const currentPayPeriod = $scope.formOptions.currentPayPeriod;
	const deemedPaymentAdjustmentId = $scope.formOptions.deemedPaymentAdjustmentId;
	const userId = $scope.formOptions.userId;

	function init () {

		setPageState('loading');

		// Is this a new deemed payment?
		const isNewDeemedPayment = angular.isUndefined(deemedPaymentAdjustmentId);

		let getUserPayElementDetail;
		// If this is for an existing deemed payment, get it
		if (isNewDeemedPayment) {
			// Get empty user pay element detail
			getUserPayElementDetail = payrollData.getEmptyUserPayElementDetail(agencyProfileId);
		}
		else {
			// Get user pay elements, to pick out the deemed payment
			const FUTURE_ADJUSTMENTS = false;
			getUserPayElementDetail = payrollData.getUserPayElements(agencyProfileId, currentPayPeriod.PayPeriodID, userId, FUTURE_ADJUSTMENTS);
		}

		// Get all available adjustment groups
		const getAgencyAdjustmentGroupCombined = payrollData.getAgencyAdjustmentGroupCombined(agencyProfileId, false);

		let userPayElementDetail;
		$q.all([getAgencyAdjustmentGroupCombined, getUserPayElementDetail]).then(([adjustmentGroupCombinedObj, userPayElementDetailResponse]) => {

			// Show error if deemed payment is missing (company has no deemed payment in their pack)
			if (adjustmentGroupCombinedObj.GroupEntriesDeemed.length === 0 || adjustmentGroupCombinedObj.GroupEntriesDeemed[0].GroupEntries.length === 0) {
				setPageState('unable-to-find-payment');
				return;
			}

			// Grab the deemed payment adjustment type. That's all we're interested in.
			const deemedPaymentAdjustmentGroupEntry = adjustmentGroupCombinedObj.GroupEntriesDeemed[0].GroupEntries[0];

			if (isNewDeemedPayment) {
				// Determine the adjustment group ID; if it's an empty Guid, use the parent ID
				let agencyAdjustmentGroupEntryId;

				if (deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentGroupEntryID === config.guidEmpty) {
					agencyAdjustmentGroupEntryId = deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentParentGroupEntryID;
				}
				else {
					agencyAdjustmentGroupEntryId = deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentGroupEntryID;
				}

				/* The userPayElementDetailResponse is an empty UserPayElementDetail object.
				   Slap in relevant fields from one t'other. The UserPayElementDetail object is what's being edited in the UI here. */
				angular.extend(userPayElementDetailResponse, {
					AdjustmentSpecialType: deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentSpecialType,
					AgencyAdjustmentGroupEntryID: agencyAdjustmentGroupEntryId,
					AgencyAdjustmentID: deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentID,
					Deduction: deemedPaymentAdjustmentGroupEntry.IsDeduction,
					NetToGross: deemedPaymentAdjustmentGroupEntry.AgencyAdjustmentNetToGross,
					PayPeriodID: currentPayPeriod.PayPeriodID,
					Recurring: false,
					UserID: $scope.formOptions.context.UserID,
					Value: 0
				});

				userPayElementDetail = userPayElementDetailResponse;
			}
			else {
				// The userPayElementDetailResponse is an array of items each with an array of pay elements. Find the one that needs to be edited; i.e. the deemed payment
				userPayElementDetailResponse.forEach(adjustmentGroup => {
					adjustmentGroup.PayElements.forEach(payElement => {
						if (payElement.UserPayElementID === deemedPaymentAdjustmentId) {
							userPayElementDetail = payElement;
						}
					});
				});
			}

			// Add to scope vm with other bits required
			const vmObj = {
				agencyProfileId,
				deemedPaymentAdjustmentGroupEntry,
				payPeriodId: currentPayPeriod.PayPeriodID,
				userPayElementDetail,
				// Flag for recurring option. RecurringCount === 0 means recur for every pay period (if Recurring is selected).
				recurEveryPayPeriod: userPayElementDetail.RecurringPeriodCount === 0,
				showTaxTreatment: false
			};

			$scope.vm = vmObj;

			setPageState('ready');
		})
		.catch(onError);
	}

	function onError (error) {
		console.error(error);
		setPageState('error');
	}

	function updateDeemedPayment (agencyProfileId, payPeriodId, userPayElementDetailObj, formObj) {

		formObj.state = 'saving';
		payrollData.updateUserPayElements(agencyProfileId, payPeriodId, [userPayElementDetailObj]).then(() => {
			formObj.state = 'saved';
			$scope.formOptions.forceCallback();
			$scope.formOptions.closeForm();
		})
		.catch(onError);
	}

	function setPageState (pageState) {
		$scope.pageState = pageState;
	}

	init();

	function updateRecurEveryPayPeriod(vmObj, userPayElementDetailObj, recurEveryPayPeriod) {
		angular.extend(vmObj, {
			recurEveryPayPeriod,
			recurringPeriodCountMax: recurEveryPayPeriod ? undefined : userPayElementDetailObj.RecurringPeriodCountMax,
			recurringPeriodCountMin: recurEveryPayPeriod ? undefined : 1,
			recurringPeriodCountRequired: !recurEveryPayPeriod
		});
	}

	angular.extend($scope, {
		updateDeemedPayment,
		updateRecurEveryPayPeriod
	});

}]);

'use strict';

angular.module('paycircleApp')

.component('templateForm', {
	bindings: {
		formOptions: '='
	},
	controller: 'templateFormCtrl',
	templateUrl: 'forms/_template-form/_template.form.html'
})

.controller('templateFormCtrl', [
	'companyData',
	'config',
	'LOG_DATA_TYPES',
	'LOG_TYPES',
	function (
		companyData,
		config,
		LOG_DATA_TYPES,
		LOG_TYPES
	) {

	const $ctrl = this;

	function $onInit () {

		setFormState('loading');

		$ctrl.formObject = {
			FORM_SELECT_OPTIONS: [
				{
					description: 'Option 1',
					value: 1
				},
				{
					description: 'Option 2',
					value: 1
				}
			],
			address: {
				AddressCity: '',
				AddressCountry: '',
				AddressCounty: '',
				AddressForeign: false,
				AddressID: config.guidEmpty,
				AddressName: '',
				AddressNumber: '',
				AddressPostcode: '',
				AddressStreet: ''
			},
			addressManual: {
				AddressCity: '',
				AddressCountry: '',
				AddressCounty: '',
				AddressForeign: true,
				AddressID: config.guidEmpty,
				AddressName: '',
				AddressNumber: '',
				AddressPostcode: '',
				AddressStreet: ''
			},
			checkboxField: false,
			checkboxRows: [
				{
					Forename: 'Tom',
					Surname: 'Frowlen',
					isChecked: false
				},
				{
					Forename: 'With',
					Surname: 'Avatar',
					isChecked: true
				},
				{
					Forename: 'With',
					Surname: 'Meta description',
					isChecked: true
				}
			],
			code: '123456',
			dateFieldISO: '1986-02-19T00:00:00',
			dateOfBirth: '1986-02-19T00:00:00',
			dateFieldISOMax: '1986-02-28T00:00:00',
			dateFieldISOMin: '1986-02-01T00:00:00',
			durationField: 20160,
			extendedCheckbox1: true,
			extendedCheckbox2: false,
			extendedCheckbox3: false,
			extendedRadio: 1,
			extendedRadioClickAnywhere: 1,
			radioList: 2,
			radioListItem: 2,
			formAccordion: false,
			carouselInput: {
				currentIndex: 0,
				maxIndex: 5
			},
			list: [
				'List item 1',
				'List item 2',
				'List item 3'
			],
			logEntries: [
				{
					'ActionActor': 'Action Actor',
					'CategoryID': 'f6aa7d62-82c1-4f92-b0b7-ac78d7cfb06d',
					'CompanyName': '',
					'DataType': LOG_DATA_TYPES.absolute,
					'LogDateISO': '2020-11-22T12:30:17',
					'LogEntryTitle': 'Log entry title',
					'LogType': 20,
					'TargetActor': 'Target Actor',
					'TargetID': '00000000-0000-0000-0000-000000000000',
					'ValueFrom': 'Ms Target Actor',
					'ValueTo': '',
					'dateUnix': '1595589077',
					'logMeta': {
					  'icon': 'add-user',
					  'id': 20,
					  'description': 'log entry description',
					  'theme': 'primary',
					  'apostrophise': false
					},
					'logKey': 'USER_CREATED',
					'showContent': 'Ms Target Actor'
				  },
				  {
					'ActionActor': 'Alan Simpson',
					'CategoryID': 'f6aa7d62-82c1-4f92-b0b7-ac78d7cfb06d',
					'CompanyName': '',
					'DataType': LOG_DATA_TYPES.fromTo,
					'LogDateISO': '2020-05-12T18:55:57',
					'LogEntryTitle': 'Adjustment removed',
					'LogType': LOG_TYPES.ADJUSTMENT_REMOVED.id,
					'TargetActor': 'Harold Steptoe',
					'TargetID': '00000000-0000-0000-0000-000000000000',
					'ValueFrom': 'Attachment of Earnings - DEO: £10.00',
					'ValueTo': '',
					'dateUnix': '1593539757',
					'logMeta': {
					  'icon': 'minus',
					  'id': 30,
					  'description': 'had a change removed',
					  'theme': 'assertive',
					  'apostrophise': false
					},
					'logKey': 'ADJUSTMENT_REMOVED',
					'showContent': 'Attachment of Earnings - DEO: £10.00'
				  }
			],
			metaItems: [
				{
					value: 'Value 1',
					label: 'Label 1'
				},
				{
					value: 'Value 2',
					label: 'Label 2'
				}
			],
			monetiseField: 0,
			numberField: 0,
			percentageInput: 11,
			radioCards: 1,
			radioCardsList: 'A',
			radioCardsListSplit: 1,
			radioCardsListSplitInline: 1,
			radioRowsList: 0,
			repaymentCards: [
				{
					PaymentScheduleGroupPensionState: true,
					PaymentScheduleTypeDescription: 'Childcare Vouchers',
					PaymentScheduleTypeID: '25433c7d-1b10-4971-a9eb-10800de3a8b6',
					PayslipLabel: 'Nursery fee',
					TotalAmount: 247,
					TotalAmountRemaining: 247,
					canEdit: true,
					onEdit: () => {
						window.alert('On edit');
					},
					viewType: 'payment',
					theme: 'is-primary'
				},
				{
					PaymentScheduleGroupPensionState: true,
					PaymentScheduleTypeDescription: 'Childcare Vouchers',
					PaymentScheduleTypeID: '25433c7d-1b10-4971-a9eb-10800de3a8b6',
					PayslipLabel: '',
					TotalAmount: 247,
					TotalAmountRemaining: 247,
					canEdit: false,
					onEdit: null,
					viewType: 'payment',
					theme: 'is-primary'
				},
				{
					PaymentScheduleGroupPayrollBIKBehaviour: 1,
					PaymentScheduleGroupPensionState: true,
					PaymentScheduleTypeDescription: 'Cycle to Work scheme',
					PaymentScheduleTypeID: '4fb9214c-e66b-4ae0-9245-27b7fb412281',
					PayslipLabel: 'Nursery fee',
					TotalAmount: 3855,
					TotalAmountRemaining: 3855,
					canEdit: true,
					onEdit: () => {
						window.alert('On edit');
					},
					viewType: 'schedule',
					theme: 'is-quarternary'
				},
				{
					PaymentScheduleGroupPensionState: true,
					PaymentScheduleTypeDescription: 'Cycle to Work scheme',
					PaymentScheduleTypeID: '4fb9214c-e66b-4ae0-9245-27b7fb412281',
					PayslipLabel: '',
					TotalAmount: 3855,
					TotalAmountRemaining: 3855,
					viewType: 'schedule',
					theme: 'is-quarternary'
				}
			],
			selectField: null,
			settingsRow: false,
			textField: '',
			toggleButtonsField: false,
			toggleButtonsCustomLabelsField: false,
			toggleField: false
		};

		setFormState('ready');
	}

	function onError (error) {

		setFormState('error');
		console.error(error);
	}

	function saveForm ($ctrl, formObj) {

		// Update state
		formObj.state = 'saving';

		// Service call
		companyData.saveForm($ctrl.formOptions.userId, $ctrl.formOptions.agencyProfileId, $ctrl).then(() => {

			$ctrl.formOptions.forceCallback();
			$ctrl.formOptions.closeForm();

			formObj.state = 'saved';
		})
		.catch(onError);
	}

	function setFormState (formState) {

		$ctrl.formState = formState;
	}

	angular.extend($ctrl, {
		$onInit,
		saveForm
	});
}]);

angular.module('paycircleApp').run(['$templateCache', function($templateCache) {$templateCache.put('404.html','<!DOCTYPE html>\n<html lang="en">\n\t<head>\n\t\t<meta charset="utf-8">\n\t\t<title>Page Not Found :(</title>\n\t\t<style>\n\t\t\t::-moz-selection {\n\t\t\t\tbackground: #b3d4fc;\n\t\t\t\ttext-shadow: none;\n\t\t\t}\n\n\t\t\t::selection {\n\t\t\t\tbackground: #b3d4fc;\n\t\t\t\ttext-shadow: none;\n\t\t\t}\n\n\t\t\thtml {\n\t\t\t\tpadding: 30px 10px;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 1.4;\n\t\t\t\tcolor: #737373;\n\t\t\t\tbackground: #f0f0f0;\n\t\t\t\t-webkit-text-size-adjust: 100%;\n\t\t\t\t-ms-text-size-adjust: 100%;\n\t\t\t}\n\n\t\t\thtml,\n\t\t\tinput {\n\t\t\t\tfont-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n\t\t\t}\n\n\t\t\tbody {\n\t\t\t\tmax-width: 500px;\n\t\t\t\t_width: 500px;\n\t\t\t\tpadding: 30px 20px 50px;\n\t\t\t\tborder: 1px solid #b3b3b3;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tmargin: 0 auto;\n\t\t\t\tbox-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n\t\t\t\tbackground: #fcfcfc;\n\t\t\t}\n\n\t\t\th1 {\n\t\t\t\tmargin: 0 10px;\n\t\t\t\tfont-size: 50px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\t\t\th1 span {\n\t\t\t\tcolor: #bbb;\n\t\t\t}\n\n\t\t\th3 {\n\t\t\t\tmargin: 1.5em 0 0.5em;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tmargin: 1em 0;\n\t\t\t}\n\n\t\t\tul {\n\t\t\t\tpadding: 0 0 0 40px;\n\t\t\t\tmargin: 1em 0;\n\t\t\t}\n\n\t\t\t.container {\n\t\t\t\tmax-width: 380px;\n\t\t\t\t_width: 380px;\n\t\t\t\tmargin: 0 auto;\n\t\t\t}\n\n\t\t\t/* google search */\n\n\t\t\t#goog-fixurl ul {\n\t\t\t\tlist-style: none;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t#goog-fixurl form {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t#goog-wm-qt,\n\t\t\t#goog-wm-sb {\n\t\t\t\tborder: 1px solid #bbb;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: normal;\n\t\t\t\tvertical-align: top;\n\t\t\t\tcolor: #444;\n\t\t\t\tborder-radius: 2px;\n\t\t\t}\n\n\t\t\t#goog-wm-qt {\n\t\t\t\twidth: 220px;\n\t\t\t\theight: 20px;\n\t\t\t\tpadding: 5px;\n\t\t\t\tmargin: 5px 10px 0 0;\n\t\t\t\tbox-shadow: inset 0 1px 1px #ccc;\n\t\t\t}\n\n\t\t\t#goog-wm-sb {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: 32px;\n\t\t\t\tpadding: 0 10px;\n\t\t\t\tmargin: 5px 0 0;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tcursor: pointer;\n\t\t\t\tbackground-color: #f5f5f5;\n\t\t\t\tbackground-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n\t\t\t\tbackground-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n\t\t\t\tbackground-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n\t\t\t\tbackground-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n\t\t\t\t-webkit-appearance: none;\n\t\t\t\t-moz-appearance: none;\n\t\t\t\tappearance: none;\n\t\t\t\t*overflow: visible;\n\t\t\t\t*display: inline;\n\t\t\t\t*zoom: 1;\n\t\t\t}\n\n\t\t\t#goog-wm-sb:hover,\n\t\t\t#goog-wm-sb:focus {\n\t\t\t\tborder-color: #aaa;\n\t\t\t\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n\t\t\t\tbackground-color: #f8f8f8;\n\t\t\t}\n\n\t\t\t#goog-wm-qt:hover,\n\t\t\t#goog-wm-qt:focus {\n\t\t\t\tborder-color: #105cb6;\n\t\t\t\toutline: 0;\n\t\t\t\tcolor: #222;\n\t\t\t}\n\n\t\t\tinput::-moz-focus-inner {\n\t\t\t\tpadding: 0;\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t</style>\n\t</head>\n\t<body>\n\t\t<div class="container">\n\t\t\t<h1>Not found <span>:(</span></h1>\n\t\t\t<p>Sorry, but the page you were trying to view does not exist.</p>\n\t\t\t<p>It looks like this was the result of either:</p>\n\t\t\t<ul>\n\t\t\t\t<li>a mistyped address</li>\n\t\t\t\t<li>an out-of-date link</li>\n\t\t\t</ul>\n\t\t\t<script>\n\t\t\t\tvar GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n\t\t\t</script>\n\t\t\t<script src="//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js"></script>\n\t\t</div>\n\t</body>\n</html>\n');
$templateCache.put('accesssdks.html','<script src="https://cookie.access-evo.com/consent/access-cookie-policies-js/"></script>');
$templateCache.put('accesssdksdev.html','<script src="https://cookie.dev.access-evo.com/consent/access-cookie-policies-js/"></script>');
$templateCache.put('fonts/paycircle-icons/demo.html','<!doctype html>\n<html>\n<head>\n    <meta charset="utf-8">\n    <title>IcoMoon Demo</title>\n    <meta name="description" content="An Icon Font Generated By IcoMoon.io">\n    <meta name="viewport" content="width=device-width,initial-scale=1">\n    <link rel="stylesheet" href="demo-files/demo.css">\n    <link rel="stylesheet" href="style.css"></head>\n<body>\n    <div class="bgc1 clearfix">\n        <h1 class="mhmm mvm"><span class="fgc1">Font Name:</span> paycircle <small class="fgc1">(Glyphs:&nbsp;168)</small></h1>\n    </div>\n    <div class="clearfix mhl ptl">\n        <h1 class="mvm mtn fgc1">Grid Size: 20</h1>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cookie"></span>\n                <span class="mls"> icon-cookie</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a7" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a7;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-copilot"></span>\n                <span class="mls"> icon-copilot</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a4" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a4;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-thumbs-up"></span>\n                <span class="mls"> icon-thumbs-up</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a5" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a5;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-thumbs-down"></span>\n                <span class="mls"> icon-thumbs-down</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a6" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a6;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-search-alt"></span>\n                <span class="mls"> icon-search-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a3" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a3;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-close"></span>\n                <span class="mls"> icon-close</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a2" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a2;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-switch"></span>\n                <span class="mls"> icon-switch</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a1" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a1;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-international"></span>\n                <span class="mls"> icon-international</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e9a0" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe9a0;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-single-header-row"></span>\n                <span class="mls"> icon-single-header-row</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-multi-header-row"></span>\n                <span class="mls"> icon-multi-header-row</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-left-pane"></span>\n                <span class="mls"> icon-left-pane</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-binoculars"></span>\n                <span class="mls"> icon-binoculars</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-play"></span>\n                <span class="mls"> icon-play</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-link"></span>\n                <span class="mls"> icon-link</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e99a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe99a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cross-alt"></span>\n                <span class="mls"> icon-cross-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e997" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe997;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-healthcare"></span>\n                <span class="mls"> icon-healthcare</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e999" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe999;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-company-vehicle"></span>\n                <span class="mls"> icon-company-vehicle</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e998" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe998;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-login"></span>\n                <span class="mls"> icon-login</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e996" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe996;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-location"></span>\n                <span class="mls"> icon-location</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e995" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe995;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-remote-access"></span>\n                <span class="mls"> icon-remote-access</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e994" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe994;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-virus"></span>\n                <span class="mls"> icon-virus</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e993" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe993;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-sad"></span>\n                <span class="mls"> icon-sad</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e992" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe992;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-drag-handle"></span>\n                <span class="mls"> icon-drag-handle</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e991" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe991;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-merge-rows"></span>\n                <span class="mls"> icon-merge-rows</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e990" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe990;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-workflow-alt"></span>\n                <span class="mls"> icon-workflow-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-expand-all"></span>\n                <span class="mls"> icon-expand-all</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-submission-history"></span>\n                <span class="mls"> icon-submission-history</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e981" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe981;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-workflow"></span>\n                <span class="mls"> icon-workflow</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-pin"></span>\n                <span class="mls"> icon-pin</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-split"></span>\n                <span class="mls"> icon-split</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-save"></span>\n                <span class="mls"> icon-save</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e98d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe98d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-chat"></span>\n                <span class="mls"> icon-chat</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e988" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe988;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-attachment"></span>\n                <span class="mls"> icon-attachment</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e989" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe989;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-print"></span>\n                <span class="mls"> icon-print</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e987" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe987;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cloud"></span>\n                <span class="mls"> icon-cloud</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e983" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe983;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-archive"></span>\n                <span class="mls"> icon-archive</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e984" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe984;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-part-time"></span>\n                <span class="mls"> icon-part-time</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e985" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe985;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-full-time"></span>\n                <span class="mls"> icon-full-time</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e986" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe986;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-rocket"></span>\n                <span class="mls"> icon-rocket</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e982" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe982;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-materials"></span>\n                <span class="mls"> icon-materials</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e980" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe980;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-rosette"></span>\n                <span class="mls"> icon-rosette</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cycle-to-work"></span>\n                <span class="mls"> icon-cycle-to-work</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-season-ticket"></span>\n                <span class="mls"> icon-season-ticket</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-undo"></span>\n                <span class="mls"> icon-undo</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-edit"></span>\n                <span class="mls"> icon-edit</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e967" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe967;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-arrow-right"></span>\n                <span class="mls"> icon-arrow-right</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e968" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe968;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-columns"></span>\n                <span class="mls"> icon-columns</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e969" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe969;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-full-screen"></span>\n                <span class="mls"> icon-full-screen</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-csv"></span>\n                <span class="mls"> icon-csv</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-excel"></span>\n                <span class="mls"> icon-excel</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-duplicate"></span>\n                <span class="mls"> icon-duplicate</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-percentage-value"></span>\n                <span class="mls"> icon-percentage-value</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-carousel1"></span>\n                <span class="mls"> icon-carousel1</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e96f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe96f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-minus-alt1"></span>\n                <span class="mls"> icon-minus-alt1</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e970" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe970;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-information"></span>\n                <span class="mls"> icon-information</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e971" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe971;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-playground"></span>\n                <span class="mls"> icon-playground</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e972" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe972;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-bug"></span>\n                <span class="mls"> icon-bug</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e973" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe973;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-fixed-value"></span>\n                <span class="mls"> icon-fixed-value</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e974" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe974;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-holiday"></span>\n                <span class="mls"> icon-holiday</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e975" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe975;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-wrench"></span>\n                <span class="mls"> icon-wrench</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e976" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe976;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-paintpot"></span>\n                <span class="mls"> icon-paintpot</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e977" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe977;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-hidden"></span>\n                <span class="mls"> icon-hidden</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e978" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe978;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-roles"></span>\n                <span class="mls"> icon-roles</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e979" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe979;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-visible"></span>\n                <span class="mls"> icon-visible</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-label"></span>\n                <span class="mls"> icon-label</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e97b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe97b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-minus-alt"></span>\n                <span class="mls"> icon-minus-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e965" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe965;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-carousel"></span>\n                <span class="mls"> icon-carousel</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e966" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe966;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-add"></span>\n                <span class="mls"> icon-add</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e901" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe901;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-add-user"></span>\n                <span class="mls"> icon-add-user</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e900" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe900;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-adjustment"></span>\n                <span class="mls"> icon-adjustment</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e902" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe902;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-admins"></span>\n                <span class="mls"> icon-admins</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-back"></span>\n                <span class="mls"> icon-back</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e903" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe903;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-bank"></span>\n                <span class="mls"> icon-bank</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e958" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe958;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-billing"></span>\n                <span class="mls"> icon-billing</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e904" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe904;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-birthday"></span>\n                <span class="mls"> icon-birthday</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e905" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe905;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-building-society"></span>\n                <span class="mls"> icon-building-society</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e955" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe955;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-calculator"></span>\n                <span class="mls"> icon-calculator</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e906" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe906;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-calendar"></span>\n                <span class="mls"> icon-calendar</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e907" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe907;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cards"></span>\n                <span class="mls"> icon-cards</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e950" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe950;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cease-membership"></span>\n                <span class="mls"> icon-cease-membership</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e908" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe908;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-check"></span>\n                <span class="mls"> icon-check</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e946" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe946;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-chevron-down"></span>\n                <span class="mls"> icon-chevron-down</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-chevron-left"></span>\n                <span class="mls"> icon-chevron-left</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-chevron-right"></span>\n                <span class="mls"> icon-chevron-right</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-chevron-up"></span>\n                <span class="mls"> icon-chevron-up</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cis"></span>\n                <span class="mls"> icon-cis</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e961" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe961;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-clipboard"></span>\n                <span class="mls"> icon-clipboard</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-clock"></span>\n                <span class="mls"> icon-clock</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e90f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe90f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-company"></span>\n                <span class="mls"> icon-company</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e910" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe910;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-company-groups"></span>\n                <span class="mls"> icon-company-groups</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-connection"></span>\n                <span class="mls"> icon-connection</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e911" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe911;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-cross"></span>\n                <span class="mls"> icon-cross</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e912" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe912;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-dashboard"></span>\n                <span class="mls"> icon-dashboard</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e913" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe913;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-document"></span>\n                <span class="mls"> icon-document</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e914" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe914;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-document-1"></span>\n                <span class="mls"> icon-document-1</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e915" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe915;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-download"></span>\n                <span class="mls"> icon-download</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e916" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe916;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-ellipses"></span>\n                <span class="mls"> icon-ellipses</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e960" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe960;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-email"></span>\n                <span class="mls"> icon-email</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e917" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe917;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-expense-approved"></span>\n                <span class="mls"> icon-expense-approved</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e918" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe918;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-external-link"></span>\n                <span class="mls"> icon-external-link</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e963" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe963;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-female"></span>\n                <span class="mls"> icon-female</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-filter"></span>\n                <span class="mls"> icon-filter</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e951" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe951;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-franchisees"></span>\n                <span class="mls"> icon-franchisees</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-group"></span>\n                <span class="mls"> icon-group</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e919" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe919;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-history"></span>\n                <span class="mls"> icon-history</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-joiners"></span>\n                <span class="mls"> icon-joiners</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-leaver"></span>\n                <span class="mls"> icon-leaver</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-leavers"></span>\n                <span class="mls"> icon-leavers</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-light-bulb"></span>\n                <span class="mls"> icon-light-bulb</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-loading"></span>\n                <span class="mls"> icon-loading</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e91f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe91f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-logout"></span>\n                <span class="mls"> icon-logout</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e920" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe920;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-male"></span>\n                <span class="mls"> icon-male</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e959" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe959;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-maternity"></span>\n                <span class="mls"> icon-maternity</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e921" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe921;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-menu"></span>\n                <span class="mls"> icon-menu</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e923" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe923;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-menu-alt"></span>\n                <span class="mls"> icon-menu-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e952" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe952;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-menu-close"></span>\n                <span class="mls"> icon-menu-close</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e922" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe922;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-menu-left"></span>\n                <span class="mls"> icon-menu-left</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e924" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe924;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-menu-right"></span>\n                <span class="mls"> icon-menu-right</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e925" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe925;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-minus"></span>\n                <span class="mls"> icon-minus</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e962" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe962;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-mobile"></span>\n                <span class="mls"> icon-mobile</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e926" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe926;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-money"></span>\n                <span class="mls"> icon-money</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e927" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe927;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-national-insurance"></span>\n                <span class="mls"> icon-national-insurance</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e928" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe928;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-notice-sent"></span>\n                <span class="mls"> icon-notice-sent</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-notification"></span>\n                <span class="mls"> icon-notification</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e929" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe929;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-padlock"></span>\n                <span class="mls"> icon-padlock</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-passport"></span>\n                <span class="mls"> icon-passport</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e964" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe964;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-pay-periods"></span>\n                <span class="mls"> icon-pay-periods</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-payslip"></span>\n                <span class="mls"> icon-payslip</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-play-alt"></span>\n                <span class="mls"> icon-play-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-plus"></span>\n                <span class="mls"> icon-plus</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e956" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe956;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-postponed"></span>\n                <span class="mls"> icon-postponed</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e92f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe92f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-project-imported"></span>\n                <span class="mls"> icon-project-imported</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e930" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe930;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-question-mark"></span>\n                <span class="mls"> icon-question-mark</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e957" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe957;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-rate-change"></span>\n                <span class="mls"> icon-rate-change</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e931" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe931;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-receipt"></span>\n                <span class="mls"> icon-receipt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e932" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe932;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-reference-number"></span>\n                <span class="mls"> icon-reference-number</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e933" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe933;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-resume-membership"></span>\n                <span class="mls"> icon-resume-membership</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e934" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe934;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-right"></span>\n                <span class="mls"> icon-right</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e935" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe935;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-roll-back"></span>\n                <span class="mls"> icon-roll-back</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e936" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe936;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-rows"></span>\n                <span class="mls"> icon-rows</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e953" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe953;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-salary-change"></span>\n                <span class="mls"> icon-salary-change</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e938" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe938;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-search"></span>\n                <span class="mls"> icon-search</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e937" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe937;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-settings"></span>\n                <span class="mls"> icon-settings</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e939" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe939;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-setup"></span>\n                <span class="mls"> icon-setup</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-setup-user"></span>\n                <span class="mls"> icon-setup-user</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-shift-imported"></span>\n                <span class="mls"> icon-shift-imported</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-sick"></span>\n                <span class="mls"> icon-sick</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-smiley"></span>\n                <span class="mls"> icon-smiley</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-sort"></span>\n                <span class="mls"> icon-sort</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e954" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe954;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-stats"></span>\n                <span class="mls"> icon-stats</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-student-loan"></span>\n                <span class="mls"> icon-student-loan</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e93f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe93f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-submitted"></span>\n                <span class="mls"> icon-submitted</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e940" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe940;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-support"></span>\n                <span class="mls"> icon-support</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e941" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe941;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-tax-code-change"></span>\n                <span class="mls"> icon-tax-code-change</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e942" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe942;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-team"></span>\n                <span class="mls"> icon-team</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e943" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe943;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-team-alt"></span>\n                <span class="mls"> icon-team-alt</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e95b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe95b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-telephone"></span>\n                <span class="mls"> icon-telephone</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e944" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe944;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-threshold-change"></span>\n                <span class="mls"> icon-threshold-change</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e945" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe945;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-tick"></span>\n                <span class="mls"> icon-tick</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e909" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe909;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-tick-square"></span>\n                <span class="mls"> icon-tick-square</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e947" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe947;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-toggle-off"></span>\n                <span class="mls"> icon-toggle-off</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e948" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe948;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-toggle-on"></span>\n                <span class="mls"> icon-toggle-on</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e949" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe949;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-trash"></span>\n                <span class="mls"> icon-trash</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94a" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94a;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-up"></span>\n                <span class="mls"> icon-up</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94c" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94c;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-upload"></span>\n                <span class="mls"> icon-upload</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94b" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94b;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-user"></span>\n                <span class="mls"> icon-user</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94e" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94e;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-wallet"></span>\n                <span class="mls"> icon-wallet</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94d" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94d;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n        <div class="glyph fs1">\n            <div class="clearfix bshadow0 pbs">\n                <span class="icon-warning"></span>\n                <span class="mls"> icon-warning</span>\n            </div>\n            <fieldset class="fs0 size1of1 clearfix hidden-false">\n                <input type="text" readonly="readonly" value="e94f" class="unit size1of2">\n                <input type="text" maxlength="1" readonly="readonly" value="&#xe94f;" class="unitRight size1of2 talign-right">\n            </fieldset>\n            <div class="fs0 bshadow0 clearfix hidden-true">\n                <span class="unit pvs fgc1">liga: </span>\n                <input type="text" readonly="readonly" value="" class="liga unitRight">\n            </div>\n        </div>\n    </div>\n\n    <!--[if gt IE 8]><!-->\n    <div class="mhl clearfix mbl">\n        <h1>Font Test Drive</h1>\n        <label>\n            Font Size: <input id="fontSize" type="number" class="textbox0 mbm" min="8" value="48">\n            px\n        </label>\n        <input id="testText" type="text" class="phl size1of1 mvl" placeholder="Type some text to test..." value="">\n        <div id="testDrive" class="icon-" style="font-family: paycircle">&nbsp;\n        </div>\n    </div>\n    <!--<![endif]-->\n    <div class="bgc1 clearfix">\n        <p class="mhl">Generated by <a href="https://icomoon.io/app">IcoMoon</a></p>\n    </div>\n\n    <script src="demo-files/demo.js"></script>\n</body>\n</html>\n');
$templateCache.put('form-fields/date-input/dateInputField.html','<span ng-class="{\'date-input-placeholder-layout\':fieldPlaceholder}">\n\t<input autocomplete="off" class="calendar {{fieldStyle}}" data-cy="{{fieldId}}" id="{{fieldId}}" name="{{fieldId}}" ng-change="parseDateJsToISO(fieldValueJS)" ng-disabled="fieldDisabled" ng-max="fieldMaxDateJS" ng-min="fieldMinDateJS" ng-model-options="{updateOn: \'blur\'}" ng-model="fieldValueJS" ng-focus="fieldOnFocusFn()" ng-readonly="fieldReadOnly" ng-required="fieldRequired" type="date">\n\t<span class="date-input-placeholder" ng-if="fieldHasPlaceholder" ng-click="removePlaceholder()">{{fieldPlaceholder}}</span>\n</span>\n');
$templateCache.put('form-fields/duration-input/duration-input.component.html','<div class="form-field-group-no-spacing">\n\n\t<div class="form-field" ng-if="$ctrl.fieldShowDivisions.includes($ctrl.DIVISIONS.days)">\n\t\t<div class="form-field-header">\n\t\t\t<label for="{{$ctrl.fieldName + \'Days\'}}" ng-class="{\'required\': $ctrl.fieldRequired}">Days:</label>\n\t\t</div>\n\t\t<div class="form-field-main">\n\t\t\t<input class="s" type="number" step="1" ng-change="$ctrl.onChange($ctrl)" ng-required="$ctrl.fieldRequired" ng-disabled="$ctrl.fieldDisabled" min="0" max="{{$ctrl.validation.days}}" id="{{$ctrl.fieldName + \'Days\'}}" name="{{$ctrl.fieldName + \'Days\'}}" ng-model="$ctrl.durationDetail.days">\n\t\t</div>\n\t</div>\n\n\t<div class="form-field" ng-if="$ctrl.fieldShowDivisions.includes($ctrl.DIVISIONS.hours)">\n\t\t<div class="form-field-header">\n\t\t\t<label for="{{$ctrl.fieldName + \'Hours\'}}" ng-class="{\'required\': $ctrl.fieldRequired}">Hours:</label>\n\t\t</div>\n\t\t<div class="form-field-main">\n\t\t\t<input class="s" type="number" step="1" ng-change="$ctrl.onChange($ctrl)" ng-required="$ctrl.fieldRequired" ng-disabled="$ctrl.fieldDisabled" min="0" max="{{$ctrl.validation.hours}}" id="{{$ctrl.fieldName + \'Hours\'}}" name="{{$ctrl.fieldName + \'Hours\'}}" ng-model="$ctrl.durationDetail.hours">\n\t\t</div>\n\t</div>\n\n\t<div class="form-field" ng-if="$ctrl.fieldShowDivisions.includes($ctrl.DIVISIONS.minutes)">\n\t\t<div class="form-field-header">\n\t\t\t<label for="{{$ctrl.fieldName + \'Minutes\'}}" ng-class="{\'required\': $ctrl.fieldRequired}">Minutes:</label>\n\t\t</div>\n\t\t<div class="form-field-main">\n\t\t\t<input class="s" type="number" step="1" ng-change="$ctrl.onChange($ctrl)" ng-required="$ctrl.fieldRequired" ng-disabled="$ctrl.fieldDisabled" min="0" max="{{$ctrl.validation.minutes}}" id="{{$ctrl.fieldName + \'Minutes\'}}" name="{{$ctrl.fieldName + \'Minutes\'}}" ng-model="$ctrl.durationDetail.minutes">\n\t\t</div>\n\t</div>\n\n</div>\n\n<div class="fadeIn" ng-messages="$ctrl.form[$ctrl.fieldName + \'Days\'].$error" ng-if="$ctrl.form[$ctrl.fieldName + \'Days\'].$invalid" role="alert">\n\t<p class="assertive is-small" ng-message="max">Please enter {{$ctrl.validation.days}} or less days</p>\n\t<p class="assertive is-small" ng-message="min || required">Please enter 0 or more days</p>\n\t<p class="assertive is-small" ng-message="step">Please enter whole days only</p>\n</div>\n\n<div class="fadeIn" ng-messages="$ctrl.form[$ctrl.fieldName + \'Hours\'].$error" ng-if="$ctrl.form[$ctrl.fieldName + \'Hours\'].$invalid" role="alert">\n\t<p class="assertive is-small" ng-message="max">Please enter {{$ctrl.validation.hours}} or less hours</p>\n\t<p class="assertive is-small" ng-message="min || required">Please enter 0 or more hours</p>\n\t<p class="assertive is-small" ng-message="step">Please enter whole hours only</p>\n</div>\n\n<div class="fadeIn" ng-messages="$ctrl.form[$ctrl.fieldName + \'Minutes\'].$error" ng-if="$ctrl.form[$ctrl.fieldName + \'Minutes\'].$invalid" role="alert">\n\t<p class="assertive is-small" ng-message="max">Please enter {{$ctrl.validation.minutes}} or less minutes</p>\n\t<p class="assertive is-small" ng-message="min || required">Please enter 0 or more minutes</p>\n\t<p class="assertive is-small" ng-message="step">Please enter whole minutes only</p>\n</div>\n');
$templateCache.put('form-fields/number-selector/numberSelectorField.html','<div class="number-selector-field {{theme}} {{size}}" ng-class="{\'disabled\': ngDisabled}">\n\t<input class="number-selector-input {{theme}}" data-cy="{{fieldName}}" id="{{fieldName}}" name="{{fieldName}}" ng-disabled="ngDisabled" ng-max="max" ng-min="min" ng-model="ngModel" ng-pattern="ngPattern" ng-readonly="ngReadonly" ng-required="ngRequired" type="number">\n\t<a aria-label="Increase number" class="number-selector-control number-selector-increment" data-cy="{{fieldName}}-increment-number" href="" ng-class="{\n\t\t\t\'disabled\': incrementDisabled || ngDisabled\n\t\t}" ng-click="increment()">\n\t\t<i class="number-selector-chevron icon-plus"></i>\n\t</a>\n\t<a aria-label="Decrease number" class="number-selector-control number-selector-decrement" data-cy="{{fieldName}}-decrement-number" href="" ng-class="{\n\t\t\t\'disabled\': decrementDisabled || ngDisabled\n\t\t}" ng-click="decrement()">\n\t\t<i class="number-selector-chevron icon-minus-alt"></i>\n\t</a>\n</div>\n');
$templateCache.put('form-fields/pill-input-field/pill-input-field.component.html','<div class="pill-input-field" ng-class="[$ctrl.theme, {\'is-active\': $ctrl.isActive}]">\n\t<div class="pill-input-field_header">\n\t\t<label for="{{$ctrl.id}}" class="pill-input-field-label">\n\t\t\t<i class="icon-label"></i> {{$ctrl.label}}&nbsp;<span ng-if="!$ctrl.isRequired">(optional)</span>\n\t\t</label>\n\t</div>\n\n\t<!-- Text Input -->\n\t<div class="pill-input-field_main fadeIn" ng-show="$ctrl.pillItems.length < $ctrl.maxItems">\n\t\t<input class="pill-input-field-input" type="text" id="{{$ctrl.id}}" name="{{$ctrl.name}}" ng-model="$ctrl.ngModel" ng-focus="$ctrl.onInputFocus($ctrl)" ng-blur="$ctrl.onInputBlur($ctrl)" placeholder="{{$ctrl.placeholder}}" ng-required="$ctrl.isRequired" maxlength="{{$ctrl.maxlength}}" minlength="{{$ctrl.minlength}}" ng-pattern="$root.REGEX.description" autocomplete="off">\n\t</div>\n\n\t<!-- Errors -->\n\t<div class="pill-input-field-errors" ng-messages="$ctrl.parentForm[$ctrl.name].$error" ng-if="!$ctrl.parentForm[$ctrl.name].$valid && $ctrl.parentForm[$ctrl.name].$touched" role="alert">\n\t\t<p ng-message="{{::error.key}}" ng-repeat="error in $ctrl.errorMessages">{{::error.message}}</p>\n\t</div>\n\n\t<!-- Selected Label -->\n\t<div class="pill-input-field-items fadeIn" ng-if="$ctrl.pillItems.length">\n\t\t<div class="pill-input-field-item" ng-class="$ctrl.theme" ng-repeat="(pillItemIndex, pillItem) in $ctrl.pillItems">\n\t\t\t<span>{{pillItem}}</span>\n\t\t\t<a href="" ng-click="$ctrl.deletePillItem($ctrl, pillItemIndex)" class="pill-input-field-item-delete"><i class="icon-plus"></i></a>\n\t\t</div>\n\t</div>\n\n\t<!-- Save -->\n\t<div class="pill-input-details" ng-if="$ctrl.canSave">\n\t\t<input type="checkbox" id="{{$ctrl.id}}_save" name="{{$ctrl.id}}_save" ng-model="$ctrl.ngModelSave" label-text="$ctrl.saveLabel" checkbox>\n\t</div>\n</div>');
$templateCache.put('form-fields/search-input/search-input.component.html','\n<div class="search-input" ng-class="{\'is-active\': $ctrl.searchOptions.isActive}">\n\n\t<label class="search-input_label" for="searchFieldInput_{{$ctrl.id}}"><!--<i class="icon-adjustment"></i> -->{{$ctrl.searchOptions.label}}:</label>\n\t<input class="search-input_input fadeIn" id="searchFieldInput_{{$ctrl.id}}" type="text" ng-model="$ctrl.searchOptions.searchTerm" ng-focus="$ctrl.onSearchFieldInputFocus($ctrl)" ng-blur="$ctrl.onSearchFieldInputBlur($ctrl)" placeholder="{{$ctrl.searchOptions.placeholder}}" autocomplete="off" ng-show="$ctrl.searchOptions.MAX_ACTIVE_ITEMS === 1 || $ctrl.searchOptions.searchItemsActive.length < $ctrl.searchOptions.MAX_ACTIVE_ITEMS">\n\n\t<!-- Selected Change -->\n\t<div class="search-input_active-results" ng-show="$ctrl.searchOptions.searchItemsActive.length">\n\t\t<div class="search-input_active-result fadeIn {{activeSearchItem.isLocked ? \'is-not-deleteable\' : \'\'}}" ng-repeat="(activeSearchItemIndex, activeSearchItem) in $ctrl.searchOptions.searchItemsActive">\n\t\t\t<span>{{activeSearchItem.description}}</span>\n\t\t\t<a href="" ng-click="$ctrl.onRemove($ctrl, activeSearchItemIndex)" class="search-input_active-result-delete" aria-label="Delete item"><i class="icon-plus"></i></a>\n\t\t</div>\n\t</div>\n\n\t<!-- Search results -->\n\t<div class="search-input_results dropIn" ng-show="$ctrl.searchOptions.searchTerm.length >= $ctrl.searchOptions.SEARCH_TERM_MIN_COUNT" click-anywhere-but-here="$ctrl.resetSearchTerm($ctrl)" is-active="$ctrl.searchOptions.searchTerm.length >= $ctrl.searchOptions.SEARCH_TERM_MIN_COUNT">\n\n\t\t<div class="search-input_results-group {{searchResult.theme}}" ng-if="$ctrl.searchOptions.searchItems.length">\n\t\t\t<!--<p class="search-input_results-subheading">{{$ctrl.searchLabel}}</p>-->\n\t\t\t<button class="is-clear search-input_result {{$ctrl.searchOptions.theme}} fadeIn {{searchResult.theme}}" ng-click="$ctrl.onAdd($ctrl, searchItem)" ng-repeat="(searchItemIndex, searchItem) in $ctrl.searchOptions.searchItemsFiltered = ( $ctrl.searchOptions.searchItems | filter: $ctrl.searchOptions.searchTerm | filter: $ctrl.searchOptions.searchItemsActiveIds.indexOf(searchResult.id) > -1 ) | orderBy:$ctrl.searchOptions.orderBy | limitTo:$ctrl.searchOptions.SEARCH_RESULTS_LIMIT track by searchItem.id">\n\t\t\t\t<!--<span class="search-input_result-icon"><i class="icon-label"></i></span>-->\n\t\t\t\t<p class="search-input_result-description">{{searchItem.description}} <span>{{searchItem.subDescription}}</span></p>\n\t\t\t\t<a href="" class="search-input_result-action"><i class="icon-plus"></i></a>\n\t\t\t</button>\n\t\t\t<p ng-if="!$ctrl.searchOptions.searchItemsFiltered.length"><span class="caption">No search results found</span></p>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('form-fields/time-input/time-input-field.component.html','<div class="time-input-field">\n\t<div class="time-input-field_layout">\n\t\t<div class="time-input-field_input is-hours">\n\t\t\t<select class="m" id="{{::$ctrl.fieldName}}-timeHours" name="{{::$ctrl.fieldName}}-timeHours" ng-change="$ctrl.onTimeChange($ctrl)" ng-model="$ctrl.selectedHour" ng-options="hour.hour as hour.hourDisplay for hour in $ctrl.hours"></select>\n\t\t</div>\n\n\t\t<div class="time-input-field_spacer">:</div>\n\n\t\t<div class="time-input-field_input is-minutes">\n\t\t\t<select class="m" id="{{::$ctrl.fieldName}}-timeMinutes" name="{{::$ctrl.fieldName}}-timeMinutes" ng-change="$ctrl.onTimeChange($ctrl)" ng-model="$ctrl.selectedMinute" ng-options="minute.minute as minute.minuteDisplay for minute in $ctrl.minutes"></select>\n\t\t</div>\n\t</div>\n</div>\n\n');
$templateCache.put('form-fields/toggle-buttons/toggle-buttons.component.html','<div class="form-field">\n\t<div class="form-field-header">\n\t\t<label>{{$ctrl.label}}</label>\n\t\t<div class="toggle-buttons_info-text" ng-if="$ctrl.hasInfoText">\n\t\t\t{{$ctrl.infoText}}\n\t\t</div>\n\t</div>\n\t<div class="form-field-main">\n\t\t<div class="toggle-buttons">\n\t\t\t<input class="toggle-button_checkbox" type="checkbox" ng-model="$ctrl.ngModel">\n\t\t\t<a class="toggle-button is-left" href="" ng-class="[\n\t\t\t\t\t$ctrl.theme,\n\t\t\t\t\t{ \'is-active\' : !$ctrl.ngModel }\n\t\t\t\t]" ng-click="$ctrl.setValue($ctrl, false)">\n\t\t\t\t{{$ctrl.falseLabel}}\n\t\t\t</a>\n\t\t\t<a class="toggle-button is-right" href="" ng-class="[\n\t\t\t\t\t$ctrl.theme,\n\t\t\t\t\t{ \'is-active\' : $ctrl.ngModel }\n\t\t\t\t]" ng-click="$ctrl.setValue($ctrl, true)">\n\t\t\t\t{{$ctrl.trueLabel}}\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('form-fields/toggle-input/toggle-input.component.html','<div class="toggle-input" data-cy="{{$ctrl.fieldName}}-{{$ctrl.fieldModel ? \'on\' : \'off\'}}" ng-class="[\n\t\t{\n\t\t\t\'has-active-label\': $ctrl.fieldLabelStayActive,\n\t\t\t\'has-indicator\': $ctrl.fieldShowIndicator,\n\t\t\t\'has-label\':  $ctrl.fieldLabel,\n\t\t\t\'is-disabled\': $ctrl.fieldDisabled,\n\t\t\t\'is-selected\': $ctrl.fieldModel,\n\t\t\t\'is-light\': $ctrl.fieldThemeLight\n\t\t},\n\t\t$ctrl.fieldModel ? $ctrl.fieldThemeActive : $ctrl.fieldThemeInactive,\n\t\t$ctrl.fieldStyle,\n\t]">\n\n\t<input aria-label="Toggle field" class="toggle-input_checkbox" type="checkbox" ng-click="$ctrl.onCheckboxClick()" name="{{$ctrl.fieldName}}" data-cy="{{::$ctrl.fieldName}}" id="{{$ctrl.fieldName}}" ng-model="$ctrl.fieldModel" ng-disabled="$ctrl.fieldDisabled">\n\t<label class="toggle-input_toggle" for="{{$ctrl.fieldName}}" ng-class="$ctrl.fieldThemeActive"></label>\n\t<label class="toggle-input_label" for="{{$ctrl.fieldName}}" ng-if="$ctrl.fieldLabel">{{$ctrl.fieldLabel}}</label>\n\t<div class="toggle-input_detail fadeIn" ng-transclude="detail" ng-if="$ctrl.hasDetail && $ctrl.fieldShowDetail"></div>\n</div>\n');
$templateCache.put('forms/_template-form/_template.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="templateForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.saveForm($ctrl, templateForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">An nice little form introduction explaining the steps in plain English</p>\n\t</div>\n\n\t<!-- Textual Inputs -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Textual inputs</h5>\n\t\t</div>\n\n\t\t<!-- Text -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="textField">Text field:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="textField" name="textField" ng-model="$ctrl.formObject.textField" ng-pattern="$root.REGEX.lettersOnly" placeholder="Type here..." required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.textField.$touched" ng-messages="templateForm.textField.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">A validation error message for the fields pattern matching</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">Optional supporting information for a form field</p>\n\t\t</div>\n\n\t\t<!-- Disabled -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="textField">Disabled field:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="textField" name="textField" ng-model="$ctrl.formObject.textField" ng-pattern="$root.REGEX.lettersOnly" placeholder="Type here..." disabled="disabled" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Number -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="numberField">Number field:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="numberField" maxlength="10" name="numberField" ng-model="$ctrl.formObject.formNumberField" placeholder="0.00" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.numberField.$touched" ng-messages="templateForm.numberField.$error" role="alert">\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Monetise -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="monetiseField">Number field (.monetise):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="monetise" id="monetiseField" maxlength="10" name="monetiseField" ng-model="$ctrl.formObject.formNumberField" placeholder="0.00" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.monetiseField.$touched" ng-messages="templateForm.monetiseField.$error" role="alert">\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="dateField">Date field:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="dateField" field-max-date-iso="dateField.dateFieldISOMax" field-placeholder="Select a date..." field-min-date-iso="dateField.dateFieldISOMin" field-value-iso="dateField.dateFieldISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.dateField.$touched" ng-messages="templateForm.dateField.$error" role="alert">\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="max">Please enter a date up to {{dateField.dateFieldISOMax | dateformat}}</p>\n\t\t\t\t<p ng-message="min">Please enter a date from {{dateField.dateFieldISOMin | dateformat}}</p>\n\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- %age -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="percentageInput">Percentage:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="percentage s" id="percentageInput" max="100" maxlength="10" min="0" name="percentageInput" ng-model="$ctrl.formObject.percentageInput" ng-pattern="$root.REGEX.decimal" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form.percentageInput.$error" ng-show="$ctrl.form.percentageInput.$touched" role="alert">\n\t\t\t\t<p ng-message="max">Percentage cannot exceed 100</p>\n\t\t\t\t<p ng-message="min">Percentage should be no less than 0</p>\n\t\t\t\t<p ng-message="pattern">Please enter a ercentage up to 2 decimal places</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Search -->\n\t\t<div class="form-field">\n\t\t\t<search-input id="searchInput" search-options="$ctrl.formObject.searchOptions"></search-input>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Other Inputs -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Other inputs</h5>\n\t\t</div>\n\n\t\t<!-- Select -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="selectField">Select field:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="l-alt" id="selectField" name="selectField" ng-model="$ctrl.formObject.selectField" ng-options="option.value as option.description for option in $ctrl.formObject.FORM_SELECT_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.selectField.$touched" ng-messages="templateForm.selectField.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Checkbox -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="checkboxField" label-text="\'The checkbox text goes in here...\'" name="checkboxField" ng-model="$ctrl.formObject.checkboxField" type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Toggle Input -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="The toggle label goes here" field-model="$ctrl.formObject.toggleField" field-name="toggleField"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Toggle A -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<a href="" class="toggle-a s" ng-class="{\n\t\t\t\t\t\t\'primary\': $ctrl.formObject.toggleField,\n\t\t\t\t\t\t\'active tertiary\': !$ctrl.formObject.toggleField\n\t\t\t\t\t}" ng-click="$ctrl.formObject.toggleField = !$ctrl.formObject.toggleField"></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Birth date  -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<birth-date-input id="dateOfBirth" ng-model="$ctrl.formObject.dateOfBirth">\n\t\t\t\t</birth-date-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Extended Toggle -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<extended-toggle-input field-label="The toggle label goes here" field-model="$ctrl.formObject.toggleField" field-name="toggleField">\n\t\t\t\t\t<field-content>\n\n\t\t\t\t\t\t<!-- Date -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="dateField">Date field:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="dateField" field-max-date-iso="dateField.dateFieldISOMax" field-min-date-iso="dateField.dateFieldISOMin" field-value-iso="dateField.dateFieldISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="templateForm.dateField.$touched" ng-messages="templateForm.dateField.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a date up to {{dateField.dateFieldISOMax | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date from {{dateField.dateFieldISOMin | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Toggle buttons basic -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-buttons id="toggleButtonFieldVisibility" label="\'Toggle buttons\'" ng-model="$ctrl.formObject.toggleButtonsField">\n\t\t\t\t</toggle-buttons>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Toggle buttons custom labels / theme -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-buttons false-label="\'Hidden\'" id="toggleButtonFieldVisibility" label="\'Toggle buttons - custom labels and theme\'" ng-model="$ctrl.formObject.toggleButtonsCustomLabelsField" theme="is-tertiary" true-label="\'Visible\'">\n\t\t\t\t</toggle-buttons>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>Option tabs</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t<a class="option-tab active" href="">\n\t\t\t\t\t\tOption 1\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="option-tab" href="">\n\t\t\t\t\t\tOption 2\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="option-tab" href="">\n\t\t\t\t\t\tOption 3\n\t\t\t\t\t</a>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Extended checkboxes -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="textField">Extended checkboxes:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-checkbox_wrapper">\n\t\t\t\t<extended-checkbox name="extendedCheckbox1" ng-model="$ctrl.formObject.extendedCheckbox1">\n\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended checkbox</h6>\n\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex, illum!</p>\n\t\t\t\t\t</checkbox-label>\n\n\t\t\t\t\t<checkbox-content>\n\t\t\t\t\t\t<note note-icon="icon-support" note-title="Default note" note-theme="is-primary has-border">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</checkbox-content>\n\t\t\t\t</extended-checkbox>\n\n\n\t\t\t\t<extended-checkbox always-show-content="true" name="extendedCheckbox2" ng-model="$ctrl.formObject.extendedCheckbox2">\n\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended checkbox with content always visible</h6>\n\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex, illum!</p>\n\t\t\t\t\t</checkbox-label>\n\n\t\t\t\t\t<checkbox-content>\n\t\t\t\t\t\t<note note-icon="icon-support" note-title="Default note" note-theme="is-primary has-border">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</checkbox-content>\n\t\t\t\t</extended-checkbox>\n\n\n\t\t\t\t<extended-checkbox name="extendedCheckbox3" ng-model="$ctrl.formObject.extendedCheckbox3">\n\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended checkbox with no content</h6>\n\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex, illum!</p>\n\t\t\t\t\t</checkbox-label>\n\t\t\t\t</extended-checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Checkbox cards -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsOption1">Checkbox cards:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="checkbox-cards">\n\n\t\t\t\t\t<!-- Checkbox card 1 -->\n\t\t\t\t\t<div class="checkbox-card quarternary">\n\t\t\t\t\t\t<input class="checkbox-card-input" id="checkboxCard1" name="checkboxCard1" ng-model="$ctrl.formObject.checkboxCard1" type="checkbox">\n\t\t\t\t\t\t<label class="checkbox-card-label" for="checkboxCard1">\n\t\t\t\t\t\t\t<div class="checkbox-card-header">\n\t\t\t\t\t\t\t\t<i class="icon-clock checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Checkbox 1</h5>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="checkbox-card-text">Checkbox card text goes here...</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Checkbox card 2 -->\n\t\t\t\t\t<div class="checkbox-card secondary">\n\t\t\t\t\t\t<input class="checkbox-card-input" id="checkboxCard2" name="checkboxCard2" ng-model="$ctrl.formObject.checkboxCard2" type="checkbox">\n\t\t\t\t\t\t<label class="checkbox-card-label" for="checkboxCard2">\n\t\t\t\t\t\t\t<div class="checkbox-card-header">\n\t\t\t\t\t\t\t\t<i class="icon-money checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Checkbox 2</h5>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="checkbox-card-text">Checkbox card text goes here...</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Checkbox rows list -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsOption1">Checkbox rows list:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="checkbox-rows-list">\n\t\t\t\t\t<div class="checkbox-row" ng-repeat="(checkboxRowIndex, checkboxRow) in $ctrl.formObject.checkboxRows">\n\t\t\t\t\t\t<label class="checkbox-row_label" for="checkbox-row_{{checkboxRowIndex}}">\n\t\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" id="checkbox-row_{{checkboxRowIndex}}" name="checkbox-row_{{checkboxRowIndex}}" ng-model="checkboxRow.isSelected" type="checkbox">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{checkboxRow.Forename[0]}}" avatar-size="is-small" class="checkbox-row_avatar" ng-if="$last || checkboxRowIndex === 1"></avatar>\n\t\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t\t<h6>\n\t\t\t\t\t\t\t\t\t<name forename="{{checkboxRow.Forename}}" surname="{{checkboxRow.Surname}}"></name>\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale" ng-if="$last">\n\t\t\t\t\t\t\t\t\t<name forename="{{checkboxRow.Forename}}" surname="{{checkboxRow.Surname}}"></name>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Radios -->\n\t<fieldset>\n\n\t\t<!-- Radio Cards -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsOption1">Radio cards:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsOption1" name="radioCards" ng-model="$ctrl.formObject.radioCards" ng-value="1" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsOption1">\n\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Option 1</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsOption2" name="radioCards" ng-model="$ctrl.formObject.radioCards" ng-value="2" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsOption2">\n\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Option 2</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Radio Cards List -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsListOption1">Radio cards list:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list">\n\n\t\t\t\t\t<!-- Option A -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsListOption1" name="radioCardsList" ng-model="$ctrl.formObject.radioCardsList" ng-value="\'A\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListOption1">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">A</span>\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title">Option A</p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">A bit of information about option A</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Option B -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsListOption2" name="radioCardsList" ng-model="$ctrl.formObject.radioCardsList" ng-value="\'B\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListOption2">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">B</span>\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title">Option B</p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">A bit of information about option B</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Option C -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsListOption3" name="radioCardsList" ng-model="$ctrl.formObject.radioCardsList" ng-value="\'C\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListOption3">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">C</span>\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title">Option C</p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">A bit of information about option C</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Option D -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="radioCardsListOption4" name="radioCardsList" ng-model="$ctrl.formObject.radioCardsList" ng-value="\'C\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListOption4">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">D</span>\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title">Option D</p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">A bit of information about option C</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Radio Cards List Split -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsListSplitOption1">Radio cards list split:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitOption1" name="radioCardsListSplit" ng-model="$ctrl.formOptions.radioCardsListSplit" ng-value="1" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitOption1">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 1</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitOption2" name="radioCardsListSplit" ng-model="$ctrl.formOptions.radioCardsListSplit" ng-value="2" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitOption2">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 2</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitOption3" name="radioCardsListSplit" ng-model="$ctrl.formOptions.radioCardsListSplit" ng-value="3" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitOption3">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 3</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitOption4" name="radioCardsListSplit" ng-model="$ctrl.formOptions.radioCardsListSplit" ng-value="4" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitOption4">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 4</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n \t\t<!-- Radio Cards List Split (inline) -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="radioCardsListSplitInlineOption1">Radio cards list split (inline):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitInlineOption1" name="radioCardsListSplitInline" ng-model="$ctrl.formOptions.radioCardsListSplitInline" ng-value="1" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitInlineOption1">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 1</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitInlineOption2" name="radioCardsListSplitInline" ng-model="$ctrl.formOptions.radioCardsListSplitInline" ng-value="2" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitInlineOption2">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 2</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="radioCardsListSplitInlineOption3" name="radioCardsListSplitInline" ng-model="$ctrl.formOptions.radioCardsListSplitInline" ng-value="3" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="radioCardsListSplitInlineOption3">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Option 3</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t\t<!-- Radio Rows List -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">Choose an option below?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="radioRowsListOption1" name="radioRowsList" ng-model="$ctrl.formObject.radioRowsList" ng-value="0" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="radioRowsListOption1">\n\t\t\t\t\t\t\t<p class="radio-row-title">Option 1</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="radioRowsListOption2" name="radioRowsList" ng-model="$ctrl.formObject.radioRowsList" ng-value="1" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="radioRowsListOption2">\n\t\t\t\t\t\t\t<p class="radio-row-title">Option 2</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="radioRowsListOption3" name="radioRowsList" ng-model="$ctrl.formObject.radioRowsList" ng-value="2" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="radioRowsListOption3">\n\t\t\t\t\t\t\t<p class="radio-row-title">Option 3</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Radio list -->\n\t\t<div class="form-field">\n\t\t\t<label for="radioListOption1" class="required">Radio list:</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input class="b" id="radioListOption1" name="radioList" ng-model="$ctrl.formObject.radioList" ng-value="1" type="radio">\n\t\t\t\t\t<label for="radioListOption1">Option 1</label>\n\n\t\t\t\t\t<input class="b" id="radioListOption2" name="radioList" ng-model="$ctrl.formObject.radioList" ng-value="2" type="radio">\n\t\t\t\t\t<label for="radioListOption2">Option 2</label>\n\n\t\t\t\t\t<input class="b" id="radioListOption3" name="radioList" ng-model="$ctrl.formObject.radioList" ng-value="3" type="radio">\n\t\t\t\t\t<label for="radioListOption3">Option 3</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Radio list items -->\n\t\t<div class="form-field">\n\t\t\t<label for="radioListItemsOption1" class="required">Radio list items:</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="radioListItemsOption1" name="radioListItem" ng-model="$ctrl.formObject.radioListItem" ng-value="1" type="radio">\n\t\t\t\t\t\t<label for="radioListItemsOption1">Option 1</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="radioListItemsOption2" name="radioListItem" ng-model="$ctrl.formObject.radioListItem" ng-value="2" type="radio">\n\t\t\t\t\t\t<label for="radioListItemsOption2">Option 2</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="radioListItemsOption3" name="radioListItem" ng-model="$ctrl.formObject.radioListItem" ng-value="3" type="radio">\n\t\t\t\t\t\t<label for="radioListItemsOption3">Option 3</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Extended radio -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="extendedRadio">Extended radios:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t<extended-radio name="extendedRadio" ng-model="$ctrl.formObject.extendedRadio" value="1">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended radio</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<note note-icon="icon-support" note-title="Default note" note-theme="has-border">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio always-show-content="true" name="extendedRadio" ng-model="$ctrl.formObject.extendedRadio" value="2">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended radio with content always visible</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<note note-icon="icon-support" note-title="Default note" note-theme="has-border">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio name="extendedRadio" ng-model="$ctrl.formObject.extendedRadio" value="3">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended radio with no content</h6>\n\t\t\t\t\t</radio-label>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio name="extendedRadio" ng-model="$ctrl.formObject.extendedRadio" value="4">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended radio with field</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-field>\n\t\t\t\t\t\t<select class="l" id="selectField" name="selectField" ng-model="$ctrl.formObject.selectField" ng-options="option.value as option.description for option in $ctrl.formObject.FORM_SELECT_OPTIONS" required>\n\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</radio-field>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<note note-icon="icon-support" note-title="Default note" note-theme="has-border">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="extendedRadio">Extended radios (click anywhere):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t<extended-radio always-show-content="true" has-click-anywhere="true" name="extendedRadioHasClickAnywhere" ng-model="$ctrl.formObject.extendedRadioClickAnywhere" not-empty-guid theme="is-primary has-hover" value="1">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended Radio - click anywhere  - option 1</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tExtended radio content.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio always-show-content="true" has-click-anywhere="true" name="extendedRadioHasClickAnywhere" ng-model="$ctrl.formObject.extendedRadioClickAnywhere" not-empty-guid theme="is-primary has-hover" value="2">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Extended Radio - click anywhere - option 2</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tExtended radio content.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Notes -->\n\t<fieldset>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- A basic default note -->\n\t\t\t<note note-icon="icon-support" note-title="Default note">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">The basic note</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- A basic default note -->\n\t\t\t<note note-icon="icon-warning" note-theme="assertive" note-title="Default note">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">A warning note</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- A note with columns -->\n\t\t\t<note note-icon="icon-support" note-title="Note with columns">\n\t\t\t\t<note-columns>\n\t\t\t\t\t<div class="note-column">\n\t\t\t\t\t\t<p class="is-small">Note column 1</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-column">\n\t\t\t\t\t\t<p class="is-small">Note column 2</p>\n\t\t\t\t\t</div>\n\t\t\t\t</note-columns>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- A note that can be dismissed -->\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="A dismissable note">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">A note that can be dismissed but will re-appear as soon as the page/form is re-opened</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- A note that can be dismissed and persisted -->\n\t\t\t<note note-dismiss-key="template-form" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="A dismissable note">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">A note that can be dismissed and will not show again until cookies are reset or the user logs out</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Message Blocks -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Message blocks</h5>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="primary">\n\t\t\t\t<p><span class="tag primary inverse has-margin-right">Primary</span>A primary message block <a href="" class="primary underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="secondary">\n\t\t\t\t<p><span class="tag secondary inverse has-margin-right">Secondary</span>A secondary message block <a href="" class="secondary underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="tertiary">\n\t\t\t\t<p><span class="tag tertiary inverse has-margin-right">Tertiary</span>A tertiary message block <a href="" class="tertiary underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="quarternary">\n\t\t\t\t<p><span class="tag quarternary inverse has-margin-right">Quarternary</span>A quarternary message block <a href="" class="quarternary underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="greyscale">\n\t\t\t\t<p><span class="tag greyscale inverse has-margin-right">Greyscale</span>A greyscale message block <a href="" class="greyscale underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="positive">\n\t\t\t\t<p><span class="tag positive inverse has-margin-right">Positive</span>A positive message block <a href="" class="positive underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="indifferent">\n\t\t\t\t<p><span class="tag indifferent inverse has-margin-right">Indifferent</span>An indifferent message block <a href="" class="indifferent underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block theme="assertive">\n\t\t\t\t<p><span class="tag assertive inverse has-margin-right">Assertive</span>An assertive message block <a href="" class="assertive underline">with a link</a></p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Message Blocks (alternative) -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Message blocks (alternative)</h5>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block icon="tick" theme="is-positive is-inline is-alternative">\n\t\t\t\t<p>{{\'\' | loremIpsum:\'medium\'}}</p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block icon="warning" theme="is-assertive is-inline is-alternative">\n\t\t\t\t<p>{{\'\' | loremIpsum:\'medium\'}}</p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block icon="information" theme="indifferent is-inline is-alternative">\n\t\t\t\t<p>{{\'\' | loremIpsum:\'medium\'}}</p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<message-block icon="question-mark" theme="indifferent is-inline">\n\t\t\t\t<p>{{\'\' | loremIpsum:\'medium\'}}</p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Message Blocks -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Message bars</h5>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<!-- Assertive -->\n\t\t\t<message-bar theme="assertive">\n\t\t\t\t<p>Where did all the team members go? \uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F</p>\n\t\t\t</message-bar>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Info blocks -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Info blocks</h5>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<info-block ib-theme="primary" ib-title="Default primary info block..."></info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<info-block ib-theme="is-primary has-icon has-border">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-wallet primary info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Lorem ipsum, dolor sit amet.</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde quas numquam, quia minus eos recusandae soluta vero.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\n\t\t\t<info-block ib-theme="is-secondary has-icon has-border">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-wallet primary info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Lorem ipsum, dolor sit amet.</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde quas numquam, quia minus eos recusandae soluta vero.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\n\t\t\t<info-block ib-theme="is-tertiary has-icon has-border">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-wallet primary info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Lorem ipsum, dolor sit amet.</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde quas numquam, quia minus eos recusandae soluta vero.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\n\t\t\t<info-block ib-theme="is-quaternary has-icon has-border">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-wallet primary info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Lorem ipsum, dolor sit amet.</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde quas numquam, quia minus eos recusandae soluta vero.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<info-block ib-theme="primary" ib-title="Default primary info block..."></info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<info-block ib-theme="primary" ib-title="Default primary info block..."></info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<info-block ib-theme="primary has-large-title" ib-title="Default primary info block with a large title..."></info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\n\t\t\t<info-block ib-icon-dot="icon-adjustment" ib-theme="primary has-border has-large-title" ib-title="Info block with an icon dot and main area...">\n\t\t\t\t<ib-main>\n\t\t\t\t\tInfo block main transclude\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Value cards -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Value cards</h5>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-primary" title="Primary value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-secondary" title="Secondary value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-tertiary" title="Tertiary value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-quarternary" title="Quaternary value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-assertive" title="Assertive value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-indifferent" title="Indifferent value" value="500"></value-card>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<value-card theme="is-greyscale" title="Greyscale value" value="500"></value-card>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Code -->\n\t<fieldset>\n\t\t<code-field code="$ctrl.formObject.code"></code-field>\n\t</fieldset>\n\n\t<!-- Settings Row -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Settings row</h5>\n\t\t</div>\n\t\t<div class="settings-rows">\n\t\t\t<settings-row ng-model="$ctrl.formObject.settingsRow" sr-field-name="settings-row1">\n\t\t\t\t<sr-label>Primary settings row (default)</sr-label>\n\t\t\t\t<sr-description>A settings row that allows you to toggle a boolean option on or off</sr-description>\n\t\t\t</settings-row>\n\t\t\t<settings-row ng-model="$ctrl.formObject.settingsRow" sr-field-name="settings-row2" sr-icon="smiley" sr-theme="secondary">\n\t\t\t\t<sr-label>Secondary settings row (with icon)</sr-label>\n\t\t\t\t<sr-description>A settings row that allows you to toggle a boolean option on or off</sr-description>\n\t\t\t</settings-row>\n\t\t\t<settings-row ng-model="$ctrl.formObject.settingsRow" sr-field-name="settings-row3" sr-theme="tertiary">\n\t\t\t\t<sr-label>Tertiary settings row</sr-label>\n\t\t\t\t<sr-description>A settings row that allows you to toggle a boolean option on or off</sr-description>\n\t\t\t</settings-row>\n\t\t\t<settings-row ng-model="$ctrl.formObject.settingsRow" sr-disabled="true" sr-field-name="settings-row4" sr-theme="tertiary">\n\t\t\t\t<sr-label>Disabled settings row</sr-label>\n\t\t\t\t<sr-description>A settings row that is disabled</sr-description>\n\t\t\t</settings-row>\n\t\t\t<settings-row ng-model="$ctrl.formObject.settingsRow" sr-field-name="settings-row5" sr-theme="quarternary">\n\t\t\t\t<sr-label>Quarternary settings row (with content)</sr-label>\n\t\t\t\t<sr-description>A settings row that allows you to toggle a boolean option on or off</sr-description>\n\t\t\t\t<sr-content ng-if="$ctrl.formObject.settingsRow">\n\t\t\t\t\t<p class="is-small">Anything can go here and it will be displayed when the setting is switched on</p>\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Duration input-->\n\t<fieldset>\n\t\t<duration-input field-model="$ctrl.formObject.durationField" field-name="durationInput"></duration-input>\n\t</fieldset>\n\n\t<!-- Form accordion -->\n\t<section class="form-field">\n\t\t<form-accordion show-content="$ctrl.formObject.formAccordion" icon="icon-money">\n\t\t\t<fa-title>\n\t\t\t\t<h6>Form accordion</h6>\n\t\t\t</fa-title>\n\n\t\t\t<fa-content>\n\t\t\t\t<h6 class="form-section-subheading">form accordion content</h6>\n\t\t\t</fa-content>\n\t\t</form-accordion>\n\t</section>\n\n\t<!-- Form accordion alternative -->\n\t<section class="form-field">\n\t\t<form-accordion-alternative>\n\t\t\t<faa-title-closed>\n\t\t\t\t<h6>Form accordion alternative</h6>\n\t\t\t</faa-title-closed>\n\n\t\t\t<faa-title-open>\n\t\t\t\t<h5>Edit form accordion</h5>\n\t\t\t</faa-title-open>\n\n\t\t\t<faa-content>\n\t\t\t\t<h6 class="form-section-subheading">form accordion alternative content</h6>\n\t\t\t</faa-content>\n\t\t</form-accordion-alternative>\n\t</section>\n\n\t<!-- Other -->\n\t<fieldset>\n\t\t<meta-data-card meta-items="$ctrl.formObject.metaItems"></meta-data-card>\n\t</fieldset>\n\n\t<!-- Progress steps -->\n\t<fieldset>\n\t\t<progress-steps active-step="2" step-count="3"></progress-steps>\n\t</fieldset>\n\t<fieldset>\n\t\t<progress-steps active-step="2" has-spacers="true" step-count="3" theme="is-large is-primary"></progress-steps>\n\t</fieldset>\n\n\t<!-- Action bar -->\n\t<fieldset>\n\t\t<h5>Action bar</h5>\n\t\t<p>For display across the top of the page</p>\n\t</fieldset>\n\t<fieldset>\n\t\t<action-bar subtitle="Action bar title">\n\t\t\t<action-bar-right>\n\t\t\t\t<a href="" class="link-with-icon tertiary">\n\t\t\t\t\t<i class="icon-cross"></i>Action\n\t\t\t\t</a>\n\t\t\t</action-bar-right>\n\t\t</action-bar>\n\t</fieldset>\n\t<fieldset>\n\t\t<action-bar class="dropIn" subtitle="Action bar with button">\n\t\t\t<action-bar-right>\n\t\t\t\t<button>Action</button>\n\t\t\t</action-bar-right>\n\t\t</action-bar>\n\t</fieldset>\n\n\t<!-- Action card -->\n\t<fieldset>\n\t\t<h5>Action card</h5>\n\t</fieldset>\n\t<fieldset>\n\t\t<action-card ac-icon="icon-setup-user" ac-steps-complete="3" ac-steps-total="5" ac-theme="primary" ac-title="Action card title">\n\t\t\t<ac-main>\n\t\t\t\t<ul class="tick-list primary">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a href="" class="underline" ng-click="">Step 1 description (incomplete)</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="complete">\n\t\t\t\t\t\t<a href="" class="underline" ng-click="">Step 2 description</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="complete">\n\t\t\t\t\t\t<a href="" class="underline" ng-click="">Step 3 description</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a href="" class="underline" ng-click="">Step 4 description (incomplete)</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="complete">\n\t\t\t\t\t\t<a href="" class="underline" ng-click="">Step 5 description</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</ac-main>\n\t\t</action-card>\n\t</fieldset>\n\n\t<!-- Activity log -->\n\t<fieldset>\n\t\t<h5>Activity log</h5>\n\t\t<activity-log log-entry="logEntry" ng-repeat="logEntry in formObject.logEntries"></activity-log>\n\t</fieldset>\n\n\t<!-- Progress Bars -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Progress bars</h5>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>Default</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<progress-bar pb-percentage="89"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>With value</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<progress-bar pb-theme="is-tertiary has-value" pb-percentage="45"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>With white base</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<progress-bar pb-theme="is-quarternary is-base-white" pb-percentage="24"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>With light grey base</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<progress-bar pb-theme="is-quarternary is-base-greyscale-lighter" pb-percentage="80"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>Large</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<progress-bar pb-percentage="12" pb-size="is-large" pb-theme="is-secondary"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Repayment Card -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Repayment card</h5>\n\t\t</div>\n\t\t<div class="form-field" ng-repeat="repayment in $ctrl.formObject.repaymentCards">\n\t\t\t<repayment-card can-edit="repayment.canEdit" on-edit="repayment.onEdit" rc-theme="{{repayment.theme}}" rc-view-type="{{repayment.viewType}}" repayment="repayment"></repayment-card>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Address lookup (UK-only) -->\n\t<fieldset>\n\t\t<ng-form data-cy="ui-kit-address-lookup-uk-only-form" name="uiKitAddressLookupUKOnlyForm">\n\t\t\t<fieldset data-cy="ui-kit-address-lookup-uk-only">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<h5>Address lookup (UK-only)</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<address-lookup address="$ctrl.formObject.address" id="ui-kit-address-lookup-uk-only" is-required="true" is-uk-only="true"></address-lookup>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t\t<fieldset>\n\t\t\t\t<!-- Save (for checking component validity) -->\n\t\t\t\t<submit-button button-id="ui-kit-address-lookup-uk-only-form-submit" disable-button="uiKitAddressLookupUKOnlyForm.$invalid" display-text="\'Save\'"></submit-button>\n\t\t\t</fieldset>\n\t\t</ng-form>\n\t</fieldset>\n\n\t<!-- Address lookup (manual only) -->\n\t<fieldset>\n\t\t<ng-form data-cy="ui-kit-address-lookup-manual-form" name="uiKitAddressLookupManualForm">\n\t\t\t<fieldset data-cy="ui-kit-address-lookup-manual">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<h5>Address lookup (manual entry)</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<address-lookup address="$ctrl.formObject.addressManual" id="ui-kit-address-lookup-manual" is-required="true" manual-entry-only="true"></address-lookup>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t\t<fieldset>\n\t\t\t\t<!-- Save (for checking component validity) -->\n\t\t\t\t<submit-button button-id="ui-kit-address-lookup-manual-form-submit" disable-button="uiKitAddressLookupManualForm.$invalid" display-text="\'Save\'"></submit-button>\n\t\t\t</fieldset>\n\t\t</ng-form>\n\t</fieldset>\n\n\t<!-- Icon Dots -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Icon Dots</h5>\n\t\t</div>\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Default themes</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-secondary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-tertiary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-quarternary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-assertive"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-indifferent"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-greyscale"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Default themes + hover</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-primary has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-secondary has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-tertiary has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-quarternary has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-assertive has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-indifferent has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-greyscale has-hover"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Light themes</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-primary is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-secondary is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-tertiary is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-quarternary is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-assertive is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-indifferent is-light"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-greyscale is-light"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Light themes + hover</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-primary is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-secondary is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-tertiary is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-quarternary is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-assertive is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-indifferent is-light has-hover"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-greyscale is-light has-hover"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Sizes</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-tiny is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-small is-secondary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-medium is-tertiary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-large is-quarternary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-extra-large is-assertive"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" theme="is-giant is-indifferent"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Bullet List -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>Bullet List</h5>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-spaced-out"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-bold"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-italicised"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-primary"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-secondary"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-tertiary is-greyscale-dark"></bullet-list>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<bullet-list bl-items="$ctrl.formObject.list" bl-theme="is-small is-spaced-out is-quarternary is-greyscale-darkened"></bullet-list>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<carousel-input current-index="$ctrl.formObject.carouselInput.currentIndex" max-index="$ctrl.formObject.carouselInput.maxIndex"></carousel-input>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<icon-card-basic contents="Company name" icon="icon-company"></icon-card-basic>\n\t</fieldset>\n\n\t<!-- Side bar item -->\n\t<fieldset class="side-bar-item_wrapper">\n\n\t\t<side-bar-item heading="\'is-greyscale\'"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary\'" theme="is-primary"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-active\'" is-active="true" theme="is-primary"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-secondary\'" theme="is-secondary"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-tertiary\'" theme="is-tertiary"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-quarternary\'" theme="is-quarternary"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary has-description\'" theme="is-primary">\n\t\t\t<side-bar-item-description>\n\t\t\t\tside-bar-item-description\n\t\t\t</side-bar-item-description>\n\t\t</side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-disabled\'" theme="is-primary" is-disabled="true"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-plain\'" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-plain is-active\'" theme="is-primary" is-active="true" variant="is-plain"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-secondary is-plain\'" theme="is-secondary" variant="is-plain"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-plain has-icon\'" icon="icon-document" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-plain has-icon is-active\'" icon="icon-document" is-active="true" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t<side-bar-item heading="\'is-primary is-plain has-icon is-disabled\'" icon="icon-document" is-disabled="true" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t</fieldset>\n\n\t<!-- Colours -->\n\t<fieldset>\n\n\t\t<!-- Primary / Blue -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-primary-100">\n\t\t\t\tprimary-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-primary-200">\n\t\t\t\tprimary-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-primary-300">\n\t\t\t\tprimary-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-primary-400">\n\t\t\t\tprimary-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-primary-500">\n\t\t\t\tprimary-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Secondary / Green -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-secondary-100">\n\t\t\t\tsecondary-100<br> positive-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-secondary-200">\n\t\t\t\tsecondary-200<br> positive-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-secondary-300">\n\t\t\t\tsecondary-300<br> positive-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-secondary-400">\n\t\t\t\tsecondary-400<br> positive-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-secondary-500">\n\t\t\t\tsecondary-500<br> positive-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Tertiary / Pink -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-tertiary-100">\n\t\t\t\ttertiary-100<br> attentive-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-tertiary-200">\n\t\t\t\ttertiary-200<br> attentive-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-tertiary-300">\n\t\t\t\ttertiary-300<br> attentive-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-tertiary-400">\n\t\t\t\ttertiary-400<br> attentive-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-tertiary-500">\n\t\t\t\ttertiary-500<br> attentive-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Quaternary / Purple -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-quaternary-100">\n\t\t\t\tquaternary-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quaternary-200">\n\t\t\t\tquaternary-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quaternary-300">\n\t\t\t\tquaternary-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quaternary-400">\n\t\t\t\tquaternary-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quaternary-500">\n\t\t\t\tquaternary-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Assertive / Red -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-quinary-100">\n\t\t\t\tquinary-100<br> assertive-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quinary-200">\n\t\t\t\tquinary-200<br> assertive-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quinary-300">\n\t\t\t\tquinary-300<br> assertive-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quinary-400">\n\t\t\t\tquinary-400<br> assertive-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-quinary-500">\n\t\t\t\tquinary-500<br> assertive-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Indifferent / Yellow -->\n\t\t<div class="colour-square_wrapper">\n\t\t\t<div class="colour-square is-indifferent-100">\n\t\t\t\tindifferent-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-indifferent-200">\n\t\t\t\tindifferent-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-indifferent-300">\n\t\t\t\tindifferent-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-indifferent-400">\n\t\t\t\tindifferent-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-indifferent-500">\n\t\t\t\tindifferent-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Grey -->\n\t\t<div class="colour-square_wrapper has-margin-top">\n\t\t\t<div class="colour-square is-greyscale-100">\n\t\t\t\tgreyscale-100\n\t\t\t</div>\n\t\t\t<div class="colour-square is-greyscale-200">\n\t\t\t\tgreyscale-200\n\t\t\t</div>\n\t\t\t<div class="colour-square is-greyscale-300">\n\t\t\t\tgreyscale-300\n\t\t\t</div>\n\t\t\t<div class="colour-square is-greyscale-400">\n\t\t\t\tgreyscale-400\n\t\t\t</div>\n\t\t\t<div class="colour-square is-greyscale-500">\n\t\t\t\tgreyscale-500\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Senary -->\n\t\t<div class="colour-square_wrapper has-margin-top">\n\t\t\t<div class="colour-square is-senary-light">\n\t\t\t\tsenary-light\n\t\t\t</div>\n\t\t\t<div class="colour-square is-senary-lightened">\n\t\t\t\tsenary-lightened\n\t\t\t</div>\n\t\t\t<div class="colour-square is-senary">\n\t\t\t\tsenary\n\t\t\t</div>\n\t\t\t<div class="colour-square is-senary-darkened">\n\t\t\t\tsenary-darkened\n\t\t\t</div>\n\t\t\t<div class="colour-square is-senary-dark">\n\t\t\t\tsenary-dark\n\t\t\t</div>\n\t\t\t<div class="colour-square is-senary-darker">\n\t\t\t\tsenary-darker\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Buttons -->\n\t<fieldset>\n\t\t<div class="button-group stacked">\n\t\t\t<button class="is-medium">Default</button>\n\t\t\t<button class="is-medium is-primary">Primary</button>\n\t\t\t<button class="is-medium is-secondary">Secondary</button>\n\t\t\t<button class="is-medium is-tertiary">Tertiary</button>\n\t\t\t<button class="is-medium is-quarternary">Quaternary</button>\n\t\t\t<button class="is-medium is-quinary">Quinary</button>\n\t\t</div>\n\n\t\t<div class="button-group stacked margin-top">\n\t\t\t<button disabled="disabled">Disabled</button>\n\t\t\t<button class="is-clear">Clear</button>\n\t\t</div>\n\n\t\t<div class="button-group stacked margin-top">\n\t\t\t<button class="is-white">White</button>\n\t\t\t<button class="is-white is-primary">White (primary)</button>\n\t\t\t<button class="is-white is-primary-100">White (primary-100)</button>\n\t\t\t<button class="is-white is-secondary">White (secondary)</button>\n\t\t\t<button class="is-white is-tertiary">White (tertiary)</button>\n\t\t\t<button class="is-white is-quarternary">White (quaternary)</button>\n\t\t</div>\n\n\t\t<div class="button-group stacked margin-top">\n\t\t\t<button>Default</button>\n\t\t\t<button class="is-tiny">Tiny</button>\n\t\t\t<button class="is-small">Small</button>\n\t\t\t<button class="is-medium">Medium</button>\n\t\t\t<button class="is-medium-large">Medium-large</button>\n\t\t\t<button class="is-large">Large</button>\n\t\t\t<button class="is-giant">Giant</button>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Text -->\n\t<fieldset>\n\t\t<div>\n\t\t\t<h1>Heading 1</h1>\n\t\t\t<h2>Heading 2</h2>\n\t\t\t<h3>Heading 3</h3>\n\t\t\t<h4>Heading 4</h4>\n\t\t\t<h5>Heading 5</h5>\n\t\t\t<h6>Heading 6</h6>\n\t\t</div>\n\n\t\t<div>\n\t\t\t<h3 class="is-primary">Heading (primary)</h3>\n\t\t\t<h3 class="is-primary-light">Heading (primary-light)</h3>\n\t\t\t<h3 class="is-primary-dark">Heading (primary-dark)</h3>\n\t\t\t<h3 class="is-secondary">Heading (secondary)</h3>\n\t\t\t<h3 class="is-secondary-light">Heading (secondary-light)</h3>\n\t\t\t<h3 class="is-secondary-lightened">Heading (secondary-lightened)</h3>\n\t\t\t<h3 class="is-strong-light">Heading (strong-light)</h3>\n\t\t\t<h3 class="is-tertiary">Heading (tertiary)</h3>\n\t\t\t<h3 class="is-positive">Heading (positive)</h3>\n\t\t\t<h3 class="is-indifferent">Heading (indifferent)</h3>\n\t\t\t<h3 class="is-assertive">Heading (assertive)</h3>\n\t\t\t<h3 class="is-quarternary">Heading (quaternary)</h3>\n\t\t\t<h3 class="is-greyscale">Heading (greyscale)</h3>\n\t\t</div>\n\n\t\t<div>\n\t\t\t<h3 class="is-light">Heading (light)</h3>\n\t\t\t<h3 class="is-medium">Heading (medium)</h3>\n\t\t\t<h3 class="is-strong">Heading (strong)</h3>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Cheeses -->\n\t<fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Default Cheeses</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<span class="tag is-primary">primary</span>\n\t\t\t\t\t<span class="tag is-secondary">secondary</span>\n\t\t\t\t\t<span class="tag is-tertiary">tertiary</span>\n\t\t\t\t\t<span class="tag is-quarternary">quarternary</span>\n\t\t\t\t\t<span class="tag is-quinary">quinary</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<span class="tag is-strong">strong</span>\n\t\t\t\t\t<span class="tag is-positive">positive</span>\n\t\t\t\t\t<span class="tag is-attentive">attentive</span>\n\t\t\t\t\t<span class="tag is-informative">informative</span>\n\t\t\t\t\t<span class="tag is-assertive">assertive</span>\n\t\t\t\t\t<span class="tag is-indifferent">indifferent</span>\n\t\t\t\t\t<span class="tag is-greyscale">greyscale</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Lighter Cheeses</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<span class="tag is-primary-lighter">primary-lighter</span>\n\t\t\t\t\t<span class="tag is-secondary-lighter">secondary-lighter</span>\n\t\t\t\t\t<span class="tag is-greyscale-lighter">greyscale-lighter</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Inverse Cheeses</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<span class="tag is-inverse is-primary">primary</span>\n\t\t\t\t\t<span class="tag is-inverse is-secondary">secondary</span>\n\t\t\t\t\t<span class="tag is-inverse is-tertiary">tertiary</span>\n\t\t\t\t\t<span class="tag is-inverse is-quarternary">quarternary</span>\n\t\t\t\t\t<span class="tag is-inverse is-quinary">quinary</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<span class="tag is-inverse is-strong">strong</span>\n\t\t\t\t\t<span class="tag is-inverse is-positive">positive</span>\n\t\t\t\t\t<span class="tag is-inverse is-attentive">attentive</span>\n\t\t\t\t\t<span class="tag is-inverse is-informative">informative</span>\n\t\t\t\t\t<span class="tag is-inverse is-assertive">assertive</span>\n\t\t\t\t\t<span class="tag is-inverse is-indifferent">indifferent</span>\n\t\t\t\t\t<span class="tag is-inverse is-greyscale">greyscale</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\n\t\t<fieldset>\n\t\t\t<ul class="todo-list">\n\t\t\t\t<li class="todo-list-item complete">\n\t\t\t\t\t<i class="icon-tick tada"></i> Calculating and finalising payroll\n\t\t\t\t</li>\n\t\t\t\t<li class="todo-list-item">\n\t\t\t\t\t<i class="icon-loading spin"></i> Sending the data to HMRC\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>Tooltips</h6>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Top (Default)" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Right" tooltip-position="right" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Left" tooltip-position="left" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Bottom" tooltip-position="bottom" theme="is-large is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Bottom left" tooltip-position="bottom-left" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Bottom right" tooltip-position="bottom-far-right" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Top left" tooltip-position="top-left" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Top far right" tooltip-position="top-far-right" theme="is-large is-primary"></icon-dot>\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Top far left" tooltip-position="top-far-left" theme="is-large is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t<icon-dot icon="icon-smiley" tooltip-text="Narrow" tooltip-theme="narrow" theme="is-large is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="templateForm.state === \'saved\'" state="templateForm.state">\n\t\t\t<p>Feedback option 1: A bit of feedback to say the form has been saved successfully inline and the form is still open</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" data-cy="open-form-ui-kit-close" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!templateForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="templateForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<button class="tertiary-action" ng-click="$ctrl.formOptions.skip()" ng-if="$ctrl.formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\t</button></fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Feedback option 2" ng-if="$ctrl.formState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A new state for the form to navigate to</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setFormState(\'ready\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/off-payroll/editDeemedPaymentForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- CIS - VAT -->\n<form class="fadeIn" name="editDeemedPaymentForm" ng-if="pageState === \'ready\'" ng-submit="updateDeemedPayment(vm.agencyProfileId, vm.payPeriodId, vm.userPayElementDetail, editDeemedPaymentForm)" novalidate>\n\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<p class="s">For \u2018Off payroll\u2019 team members, a single deemed payment amount can be added each pay period.\n\t\t\t\tYou can update this amount any time before you run payroll.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Total deemed payment for period -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="totalDeemedPayment">\n\t\t\t\t\tTotal deemed payment for period:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="field">\n\t\t\t\t<input class="m monetise" id="totalDeemedPayment" name="totalDeemedPayment" ng-model="vm.userPayElementDetail.Value" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="editDeemedPaymentForm.totalDeemedPayment.$touched" role="alert" ng-messages="editDeemedPaymentForm.totalDeemedPayment.$error">\n\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Is recurring -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<extended-toggle-input field-label="Use the same value for future periods" field-model="vm.userPayElementDetail.Recurring" field-name="recurring">\n\t\t\t\t\t<field-content>\n\n\t\t\t\t\t\t<input class="b" id="recurEveryPayPeriodTrue" name="recurEveryPayPeriod" ng-change="updateRecurEveryPayPeriod(vm, vm.userPayElementDetail, vm.recurEveryPayPeriod)" ng-model="vm.recurEveryPayPeriod" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="recurEveryPayPeriodTrue">Every pay period</label>\n\n\t\t\t\t\t\t<input class="b" id="recurEveryPayPeriodFalse" name="recurEveryPayPeriod" ng-change="updateRecurEveryPayPeriod(vm, vm.userPayElementDetail, vm.recurEveryPayPeriod)" ng-model="vm.recurEveryPayPeriod" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="recurEveryPayPeriodFalse">For</label>\n\n\t\t\t\t\t\t<input class="s-alt" id="recurringPeriodCount" name="recurringPeriodCount" ng-disabled="vm.recurEveryPayPeriod" ng-max="vm.recurringPeriodCountMax" ng-model="vm.userPayElementDetail.RecurringPeriodCount" ng-required="vm.recurringPeriodCountRequired" ng-min="vm.recurringPeriodCountMin" type="number">\n\n\t\t\t\t\t\t<label class="is-inline is-medium" for="recurForXPayPeriods">&nbsp;pay periods</label>\n\n\t\t\t\t\t\t<div class="form-field-footer fadeIn" ng-if="!recurEveryPayPeriod">\n\t\t\t\t\t\t\t<p class="form-message fadeIn" ng-if="editDeemedPaymentForm.recurringPeriodCount.$valid">\n\t\t\t\t\t\t\t\tThis deemed payment can recur for a maximum of {{vm.userPayElementDetail.RecurringPeriodCountMax}} pay periods\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editDeemedPaymentForm.recurringPeriodCount.$invalid" role="alert" ng-messages="editDeemedPaymentForm.recurringPeriodCount.$error">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 1</p>\n\t\t\t\t\t\t\t\t<p ng-message="max">This deemed payment can recur for a maximum of {{vm.userPayElementDetail.RecurringPeriodCountMax}} pay periods</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<hr class="xl">\n\n\t\t<div class="form-field">\n\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t<button class="is-clear detail-blocks-toggle clickable" ng-class="{\'active\' : vm.showTaxTreatment } " ng-click="vm.showTaxTreatment = !vm.showTaxTreatment" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-chevron-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t{{vm.showTaxTreatment ? \'Hide\' : \'Show\'}} tax treatment\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : vm.showTaxTreatment } ">\n\t\t\t\t\t<tax-treatment-list adjustment-group-entry="vm.deemedPaymentAdjustmentGroupEntry"></tax-treatment-list>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="button secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button display-text="\'Save\'" state="editDeemedPaymentForm.state" disable-button="editDeemedPaymentForm.$invalid">\n\t\t</submit-button>\n\t</fieldset>\n</form>\n\n<!-- Unable to find payment -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to edit deemed payment" ng-if="pageState === \'unable-to-find-payment\'">\n\t<fs-main>\n\t\t<p class="is-small">Please add the \u2018Deemed Payment\u2019 pay element to one of the pay element packs assigned to {{::formOptions.company.Name}} to continue editing the deemed payment.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window">\n</error-block>\n');
$templateCache.put('components/_template-component/template-component.component.html','<div class="template-component">\n\t\n\t<!-- Component HTML goes here... -->\n\t<div class="template-component_section">\n\t\t{{$ctrl.foo}}\n\t</div>\n\n\t<!-- Optional transcludes -->\n\t<div class="template-component-left" ng-transclude="left"></div>\n\t<div class="template-component-right" ng-transclude="right"></div>\n</div>\n');
$templateCache.put('components/access-card/access-card.component.html','<div class="access-card">\n\t<img alt="Access" class="access-card_logo" src="/images/access-logo.png">\n\t<p>As a Paycircle user you will benefit from Access Identity security - the single sign on solution for Access Group products. For more information, and to view our FAQ guide, click the link below.</p>\n\t<a class="access-card_button is-secondary" data-cy="access-card-link-more" href="https://accessgroup.my.site.com/Support/s/article/Paycircle-Access-Identity-overview" target="_blank" rel="noopener" title="What is Access Identity?">\n\t\t<i class="icon-external-link"></i>\n\t\t<span>What is Access Identity?</span>\n\t</a>\n\n</div>\n');
$templateCache.put('components/access-info-links/access-info-links.component.html','<div class="access-info-links">\n\t<a class="is-primary" data-cy="login-link-how-do-i-know-if-I-already" ng-if="!$ctrl.forSso" href="{{externalUrls.accessIdentityUrls.migrateAccount2}}" target="_blank" title="How do I know if I already have an Access account?">\n\t\t<i class="icon-external-link"></i>\n\t\t<span>How do I know if I already have an Access account?</span>\n\t</a>\n\t<a class="is-primary" data-cy="login-link-what-if-i-have-an-admin" ng-if="!$ctrl.forSso" href="{{externalUrls.accessIdentityUrls.migrateAccount1}}" target="_blank" title="What if I have an admin and an employee account?">\n\t\t<i class="icon-external-link"></i>\n\t\t<span>What if I have an admin and an employee account?</span>\n\t</a>\n\t<a class="is-primary" data-cy="login-link-what-is-access-identity" href="{{externalUrls.accessIdentityUrls.overview}}" ng-if="$ctrl.showOverviewLink" target="_blank" title="What is Access Identity?">\n\t\t<i class="icon-external-link"></i>\n\t\t<span>What is Access Identity?</span>\n\t</a>\n\t<a class="is-primary" data-cy="login-link-what-if-i-have-an-admin" ng-if="$ctrl.forSso" href="{{externalUrls.accessIdentityUrls.configureSSO}}" target="_blank" title="Configure Access Identity single sign on.">\n\t\t<i class="icon-external-link"></i>\n\t\t<span>Configure Access Identity single sign on.</span>\n\t</a>\n</div>\n');
$templateCache.put('components/accordion-item/accordion-item.component.html','<div class="accordion-item {{$ctrl.aiTheme}} {{$ctrl.aiTemplate !== undefined ? \'accordion-item--\' + $ctrl.aiTemplate : \'\'}}" data-cy="payslip-item-{{$ctrl.aiId}}" ng-class="{\n\t\t\'is-active\': $ctrl.isOpen,\n\t\t\'has-label\': $ctrl.aiLabel,\n\t\t\'has-toggle\': $ctrl.aiHasHiddenContent\n\t}">\n\n\t<a aria-label="Toggle content" class="accordion-item_click" data-cy="payslip-item-{{$ctrl.aiId}}-toggle-content" href="" ng-click="$ctrl.toggleOpen()" ng-if="$ctrl.aiHasHiddenContent"></a>\n\n\t<div class="accordion-item_content-wrapper">\n\t\t<!-- LHS icon -->\n\t\t<div class="accordion-item_icon" ng-if="$ctrl.aiIcon">\n\t\t\t<i ng-class="[\n\t\t\t\t\t\'icon-{{$ctrl.aiIcon}}\',\n\t\t\t\t\t$ctrl.aiTheme\n\t\t\t\t]"></i>\n\t\t</div>\n\n\t\t<!-- Main (central) content -->\n\t\t<div class="accordion-item_content">\n\t\t\t<div data-cy="payslip-item-{{$ctrl.aiId}}-description" ng-class="$ctrl.aiDescriptionStylesClasses">\n\t\t\t\t<span ng-class="$ctrl.aiDescriptionMarkerStylesClasses" ng-if="$ctrl.aiDescriptionMarkerStylesClasses"></span>\n\t\t\t\t{{$ctrl.aiDescription}}\n\t\t\t\t<i class="accordion-item_info-tooltip icon-information" data-cy="payslip-item-{{$ctrl.aiId}}-info-tooltip" ng-if="$ctrl.aiInfoTooltip" tooltip tooltip-position="bottom" tooltip-text="{{$ctrl.aiInfoTooltip}}"></i>\n\t\t\t</div>\n\t\t\t<div class="accordion-item_label" data-cy="payslip-item-{{$ctrl.aiId}}-label" ng-if="$ctrl.aiLabel != \'\'">\n\t\t\t\t{{$ctrl.aiLabel}}\n\t\t\t</div>\n\t\t\t<div class="accordion-item_attributes">\n\t\t\t\t<icon-dot ng-repeat="attribute in $ctrl.aiAttributes" tooltip-text="{{attribute.tooltip}}" icon="{{attribute.icon}}" label="{{attribute.label}}" theme="{{$ctrl.aiTheme}} has-hover is-light"></icon-dot>\n\t\t\t</div>\n\t\t\t<div class="accordion-item_detail" data-cy="payslip-item-{{$ctrl.aiId}}-detail" ng-class="[$ctrl.aiTheme]">\n\t\t\t\t{{$ctrl.aiDetail}}\n\t\t\t</div>\n\t\t\t<div class="accordion-item_value" data-cy="payslip-item-{{$ctrl.aiId}}-value">\n\t\t\t\t{{$ctrl.aiValue}}\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- RHS chevron (indicates hidden content)-->\n\t\t<div class="accordion-item_chevron">\n\t\t\t<i aria-label="Toggle content" class="icon-chevron-down" data-cy="payslip-item-{{$ctrl.aiId}}-toggle-content-chevron" ng-class="[$ctrl.aiTheme]" ng-click="$ctrl.toggleOpen()" ng-if="$ctrl.aiHasHiddenContent"></i>\n\t\t</div>\n\t</div>\n\n\t<div aria-label="Toggle content" class="accordion-item_hiddencontent" ng-click="$ctrl.toggleOpen()" ng-if="$ctrl.aiHasHiddenContent">\n\t\t<div class="hiddenstats {{$ctrl.aiTheme}} {{$ctrl.aiTemplate !== undefined ? \'hiddenstats--\' + $ctrl.aiTemplate : \'\'}}" ng-class="{\n\t\t\t\t\'hiddenstats--active\': $ctrl.isOpen\n\t\t\t}">\n\t\t\t<div class="hiddenstats__actionbar" ng-if="!$ctrl.aiHiddenSections.hiddenContent.hiddenStats.actionBar">\n\t\t\t\t<a class="hiddenstats__action" href="">\n\t\t\t\t\t<i class="icon-back l"></i>Back\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="hiddenstats__header" ng-if="!$ctrl.aiHiddenSections.hiddenContent.hiddenStats.header">\n\t\t\t\t<i class="hiddenstats__headericon xl" ng-class="[\n\t\t\t\t\t\t\'icon-{{$ctrl.aiIcon}}\',\n\t\t\t\t\t\t$ctrl.aiTheme\n\t\t\t\t\t]"></i>\n\t\t\t\t<h6 class="hiddenstats__headertitle">{{$ctrl.aiDescription}}</h6>\n\t\t\t\t<h1 class="hiddenstats__headervalue">{{$ctrl.aiValue}}</h1>\n\t\t\t</div>\n\t\t\t<div class="hiddenstats__main" ng-transclude="aiContent"></div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/action-bar/action-bar.component.html','<div class="action-bar">\n\t<div class="action-bar_left" ng-if="::$ctrl.showLogo">\n\t\t<div class="action-bar_logo logo-slogan">\n\t\t\t<img class="action-bar_logo-icon" src="/images/paycircle-logo_small.png" alt="Paycircle" height="28">\n\t\t\t<h5 class="action-bar_title tertiary strapline">{{$ctrl.subtitle || \'Paycircle\'}}</h5>\n\t\t</div>\n\t</div>\n\t<div class="action-bar_left" ng-transclude="left" ng-if="::!$ctrl.showLogo">\n\t</div>\n\t<div class="action-bar_right" ng-transclude="right">\n\t</div>\n</div>\n');
$templateCache.put('components/action-block/action-block.component.html','<div class="action-block fadeIn" ng-class="[\n\t\t$ctrl.abTheme,\n\t\t$ctrl.abLayout\n\t]">\n\t<div class="action-block_icon" ng-if="$ctrl.hasIcon">\n\t\t<div class="icon-dot" ng-class="[\n\t\t\t\t$ctrl.abIconTheme,\n\t\t\t\t$ctrl.abIconSize\n\t\t\t]">\n\t\t\t<i ng-if="$ctrl.abIcon" ng-class="[\n\t\t\t\t\t$ctrl.abIcon\n\t\t\t\t]"></i>\n\t\t</div>\n\t</div>\n\t<div class="action-block_header" ng-if="$ctrl.hasHeader" ng-transclude="header"></div>\n\t<div class="action-block_main" ng-transclude="main" ng-if="$ctrl.hasMain"></div>\n\t<div class="action-block_footer" ng-if="$ctrl.hasFooter" ng-transclude="footer"></div>\n\t<div class="action-block_actions" ng-if="$ctrl.hasActions" ng-transclude="actions"></div>\n\t<div class="action-block_loader" ng-if="$ctrl.abShowLoading">\n\t\t<circle-loader class="l"></circle-loader>\n\t</div>\n</div>\n');
$templateCache.put('components/action-card/action-card.component.html','<div class="action-card" ng-class="[$ctrl.acTheme, $ctrl.acVariant]">\n\n\t<header class="action-card_header">\n\t\t<div class="action-card_title">\n\t\t\t<div class="action-card_title-icon">\n\t\t\t\t<icon-dot icon="{{$ctrl.acIcon}}" theme="{{$ctrl.acTheme}}"></icon-dot>\n\t\t\t</div>\n\t\t\t<div class="action-card_title-text">{{$ctrl.acTitle}}</div>\n\t\t</div>\n\t</header>\n\t<main class="action-card_main" ng-if="$ctrl.showMain" ng-transclude="main">\n\t</main>\n\t<footer class="action-card_footer" ng-if="$ctrl.showProgressBar">\n\t\t<div class="action-card_progress">\n\t\t\t<!-- Incomplete -->\n\t\t\t<span class="action-card_progress-label s fadeIn" ng-if="$ctrl.acStepsComplete < $ctrl.acStepsTotal">{{$ctrl.acStepsComplete}}/{{$ctrl.acStepsTotal}} steps complete</span>\n\n\t\t\t<!-- Complete -->\n\t\t\t<span class="action-card_progress-label s tada">\n\t\t\t\t<i class="icon-tick m" ng-class="[$ctrl.acTheme]" ng-if="$ctrl.acStepsComplete >= $ctrl.acStepsTotal"></i>&nbsp;&nbsp;All done!\n\t\t\t</span>\n\n\t\t\t<!-- Progress -->\n\t\t\t<progress-bar pb-percentage="(100 / $ctrl.acStepsTotal) * $ctrl.acStepsComplete" pb-theme="{{$ctrl.acTheme | cemify}} is-base-white"></progress-bar>\n\t\t</div>\n\t</footer>\n\t<footer class="action-card_footer" ng-transclude="footer" ng-if="$ctrl.showFooter"></footer>\n</div>\n');
$templateCache.put('components/activity-block/activity-block.component.html','<div class="activity-block" ng-class="$ctrl.theme">\n\n\t<!-- Header -->\n\t<div class="activity-block_header">\n\t\t<h6 class="activity-block_title">\n\t\t\tActivity\n\t\t</h6>\n\t\t<div class="activity-block_filters">\n\t\t\t<button class="filter-button activity-block_filter" ng-class="{\n\t\t\t\t\t\'is-active\': logCategory.id === $ctrl.logCategoryActive.id\n\t\t\t\t}" ng-click="$ctrl.loadLogsForCategory(logCategory)" ng-repeat="logCategory in $ctrl.logCategories" type="button">\n\t\t\t\t{{logCategory.label}}\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<!-- Body -->\n\t<div class="activity-block_main" ng-switch="$ctrl.componentState">\n\n\t\t<!-- Loading -->\n\t\t<div ng-switch-when="loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\n\t\t<!-- Ready -->\n\t\t<div ng-switch-when="ready">\n\n\t\t\t<!-- Logs -->\n\t\t\t<activity-log al-style="{\n\t\t\t\t\t\'animation-delay\': ($index * 0.05) + \'s\'\n\t\t\t\t}" layout="is-inline" log-entry="logEntry" ng-repeat="\n\t\t\t\t\tlogEntry in $ctrl.logCategoryActive.logEntries |\n\t\t\t\t\torderBy: \'-dateUnix\'\n\t\t\t\t" theme="{{$last ? \'is-last\' : \'\'}} activity-log_fade-in"></activity-log>\n\n\t\t\t<div class="activity-log-placeholder" ng-if="$ctrl.logCategoryActive.logEntries.length > 0">\n\t\t\t\t<a class="is-small" ng-click="$ctrl.openActivitySideBar()" ng-if="$root.userHasRole([\n\t\t\t\t\t\t$ctrl.USER_ROLES.paycircle,\n\t\t\t\t\t\t$ctrl.USER_ROLES.bureaumanager,\n\t\t\t\t\t\t$ctrl.USER_ROLES.bureau,\n\t\t\t\t\t\t$ctrl.USER_ROLES.groupadmin,\n\t\t\t\t\t\t$ctrl.USER_ROLES.groupuser\n\t\t\t\t\t])">\n\t\t\t\t\tView all activity\n\t\t\t\t\t<i class="icon-arrow-right has-margin-left"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- No logs -->\n\t\t\t<div ng-if="$ctrl.logCategoryActive.logEntries.length === 0">\n\n\t\t\t\t<!-- Payroll -->\n\t\t\t\t<placeholder ng-if="$ctrl.logCategoryActive.id === $ctrl.LOG_CATEGORIES.payroll" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t\t\t\t<placeholder-title>\n\t\t\t\t\t\tNo payroll activity\n\t\t\t\t\t</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tStart adding changes to your\n\t\t\t\t\t\t\t<a class="underline" href="" ng-href="{{$root.currentCompany.ngHref.payroll}}">\n\t\t\t\t\t\t\t\tcurrent period\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\tand your activity will start to appear here.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\n\t\t\t\t<!-- Team -->\n\t\t\t\t<placeholder ng-if="$ctrl.logCategoryActive.id === $ctrl.LOG_CATEGORIES.user" placeholder-graphic-size="l" placeholder-graphic="team">\n\t\t\t\t\t<placeholder-title>\n\t\t\t\t\t\tNo team activity\n\t\t\t\t\t</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tStart editing your\n\t\t\t\t\t\t\t<a class="underline" ui-sref="team.members({\n\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tteam\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\tand your activity will start to appear here.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\n\t\t\t\t<!-- Pension -->\n\t\t\t\t<div ng-if="$ctrl.logCategoryActive.id === $ctrl.LOG_CATEGORIES.pension">\n\n\t\t\t\t\t<!-- No pension set up -->\n\t\t\t\t\t<placeholder ng-if="!$root.currentCompany.HasPension" placeholder-graphic-size="l" placeholder-graphic="no-pension-history">\n\t\t\t\t\t\t<placeholder-title>\n\t\t\t\t\t\t\tNo pensions set up\n\t\t\t\t\t\t</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tThe Pension module for {{$root.currentCompany.Name}} is turned on but a pension hasn\u2019t been added to your\n\t\t\t\t\t\t\t\t<a class="underline" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId\n\t\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\t\tPensions area\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\tyet.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\n\t\t\t\t\t<!-- Has pension -->\n\t\t\t\t\t<placeholder ng-if="$root.currentCompany.HasPension" placeholder-graphic-size="l" placeholder-graphic="no-pension-history">\n\t\t\t\t\t\t<placeholder-title>\n\t\t\t\t\t\t\tNo pension activity\n\t\t\t\t\t\t</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tAs you start to make changes to your\n\t\t\t\t\t\t\t\t<a class="underline" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId\n\t\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\t\tpension\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\tany activity will start to appear here.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/activity-log/activity-log.component.html','<div class="activity-log {{$ctrl.logEntry.logMeta.theme}}" ng-class="[\n\t\t$ctrl.layout,\n\t\t$ctrl.theme\n\t]" ng-style="$ctrl.alStyle">\n\n\t<!-- Detail -->\n\t<div class="activity-log_detail-block">\n\n\t\t<!-- Icon -->\n\t\t<icon-dot class="activity-log_icon" icon="icon-{{$ctrl.logEntry.logMeta.icon}}" icon-size="is-smedium" theme="is-{{$ctrl.logEntry.logMeta.theme}} is-larger is-light"></icon-dot>\n\n\t\t<div class="activity-log_detail" ng-switch="$ctrl.logEntry.DataType">\n\n\t\t\t<!-- Title -->\n\t\t\t<p class="activity-log_title">\n\t\t\t\t<span class="activity-log_title-strong" ng-if="$ctrl.logEntry.TargetActor !== \'\'">{{$ctrl.logEntry.TargetActor}}<span ng-if="$ctrl.logEntry.logMeta.apostrophise">\'s</span>&nbsp;</span>{{$ctrl.logEntry.logMeta.description}}\n\t\t\t</p>\n\n\t\t\t<!-- From > To -->\n\t\t\t<div ng-if="::$root.currentUser.Permissions.Team.canEditPersonalDetails" ng-switch="$ctrl.logEntry.LogType" pc-switch-when="$ctrl.LOG_DATA_TYPES.fromTo">\n\n\t\t\t\t<!-- Address updated -->\n\t\t\t\t<div class="activity-log_address-changed activity-log_from-to" pc-switch-when="$ctrl.LOG_TYPES.ADDRESS_UPDATED.id">\n\t\t\t\t\t<address class="activity-log_address activity-log_address-inline activity-log_from">\n\t\t\t\t\t\t<span class="activity-log_address-line" ng-repeat="addressLine in $ctrl.logEntry.ValueFrom track by $index">\n\t\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</address>\n\t\t\t\t\t<address class="activity-log_address activity-log_address-inline activity-log_to">\n\t\t\t\t\t\t<span class="activity-log_address-line" ng-repeat="addressLine in $ctrl.logEntry.ValueTo track by $index">\n\t\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</address>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Everything else -->\n\t\t\t\t<div ng-switch-default>\n\t\t\t\t\t<p class="activity-log_meta activity-log_from-to">\n\t\t\t\t\t\t<span class="activity-log_from" ng-if="$ctrl.logEntry.ValueFrom !== \'\'">\n\t\t\t\t\t\t\t{{$ctrl.logEntry.ValueFrom}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class="activity-log_to" ng-if="$ctrl.logEntry.ValueTo !== \'\'">\n\t\t\t\t\t\t\t{{$ctrl.logEntry.ValueTo}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Absolute -->\n\t\t\t<div ng-if="::$root.currentUser.Permissions.Team.canEditPersonalDetails" ng-switch="$ctrl.logEntry.LogType" pc-switch-when="$ctrl.LOG_DATA_TYPES.absolute">\n\n\t\t\t\t<!-- Address updated -->\n\t\t\t\t<div pc-switch-when="$ctrl.LOG_TYPES.ADDRESS_UPDATED.id">\n\t\t\t\t\t<address class="activity-log_address">\n\t\t\t\t\t\t<span class="activity-log_address-line" ng-repeat="addressLine in $ctrl.logEntry.ValueFrom track by $index">\n\t\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</address>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Everything else -->\n\t\t\t\t<div class="activity-log_meta activity-log-absolute" ng-switch-default>\n\t\t\t\t\t<p>{{$ctrl.logEntry.ValueTo !== \'\' ? $ctrl.logEntry.ValueTo : $ctrl.logEntry.ValueFrom}}</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Date / Actioner -->\n\t<div class="activity-log_date">\n\t\t<p>\n\t\t\t<span ng-if="$ctrl.logEntry.LogDateISO">\n\t\t\t\tBy {{$ctrl.logEntry.ActionActor}} on {{$ctrl.logEntry.LogDateISO | dateformat}} at {{$ctrl.logEntry.LogDateISO | datetimeformat:\'time12\'}}\n\t\t\t</span>\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/add-team-members/add-team-members.component.html','<overlay-form on-close="$ctrl.onClose()">\n\t<overlay-form-header>\n\t\t<h2><i class="icon-team-alt primary gradient overlay-form_header-icon"></i>Add your team members</h2>\n\t\t<p>Add profile and employment information for each team member. It should take around 2 minutes for each team member and you can skip anything you can\u2019t answer right now.</p>\n\t</overlay-form-header>\n\t<overlay-form-pre-main ng-if="$ctrl.areTeamMembersComplete">\n\t\t<div class="confirmation-block has-border has-info {{$ctrl.onboardingDashboard.IsTeamComplete ? \'positive\' : \'primary\'}}">\n\t\t\t<input type="checkbox" id="confirmTeamMembersCompleteB" name="confirmTeamMembersCompleteB" class="{{$ctrl.onboardingDashboard.IsTeamComplete ? \'positive\' : \'\'}}" ng-model="$ctrl.onboardingDashboard.IsTeamComplete" ng-change="$ctrl.toggleTeamCompleteState($ctrl.onboardingDashboard)" label-text="\'I\\\'ve added all my team members\'" checkbox>\n\t\t\t<a href="" class="confirmation-block-info {{$ctrl.onboardingDashboard.IsTeamComplete ? \'positive\' : \'\'}}" ng-click="$root.toggleModalIsOpen($root.modalOptions.addingTeamMembers)" aria-label="Toggle modal"><i class="icon-information l"></i></a>\n\t\t</div>\n\t</overlay-form-pre-main>\n\t<overlay-form-main>\n\n\t\t<!-- Loading -->\n\t\t<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n\t\t<!-- Ready -->\n\t\t<div class="team-onboarding fadeIn" ng-if="$ctrl.componentState === \'ready\'">\n\n\t\t\t<header class="team-onboarding-header">\n\t\t\t\t<h6><ng-pluralize count="$ctrl.teamMembers.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></h6>\n\n\t\t\t\t<div class="team-onboarding-header-actions fadeIn" ng-if="!$ctrl.onboardingDashboard.IsTeamComplete">\n\t\t\t\t\t<a href="" class="button primary" ng-click="$ctrl.openAddTeamMemberWizard()">+ New team member</a>\n\t\t\t\t</div>\n\t\t\t</header>\n\n\t\t\t<!-- Team Members -->\n\t\t\t<section class="team-onboarding-card" ng-class="{\'is-active\': teamMember.showMenu}" ng-repeat="teamMember in $ctrl.teamMembers | orderBy:\'Forename\'" ng-mouseleave="$ctrl.hideMenu(teamMember)">\n\t\t\t\t<span class="team-onboarding-card-demo" tooltip-plus tp-options="$ctrl.willAdminBeOnPayrollTooltip" tp-on-click="$ctrl.setExcludeFromPayroll(teamMember, true)" ng-if="$root.currentUser.UserResponseUserID === teamMember.UserID"></span>\n\t\t\t\t<a href="" class="team-onboarding-card-title" ng-click="$ctrl.openEditTeamMemberWizard(teamMember)" ng-if="!$ctrl.onboardingDashboard.IsTeamComplete">{{teamMember.Forename}} {{teamMember.Surname}}</a>\n\t\t\t\t<p class="team-onboarding-card-title" ng-if="$ctrl.onboardingDashboard.IsTeamComplete">{{teamMember.Forename}} {{teamMember.Surname}}</p>\n\t\t\t\t<p class="team-onboarding-card-email" ng-class="{\'team-onboarding-card-email--blank\' : teamMember.DummyEmail }">{{ teamMember.DummyEmail ? \'Email not added\' : teamMember.Email }}</p>\n\n\t\t\t\t<div class="team-onboarding-card-tags">\n\t\t\t\t\t<span class="tag tertiary" ng-if="teamMember.IsAdmin">Admin</span>\n\t\t\t\t\t<span class="tag tertiary team-onboarding-card-tag" ng-if="teamMember.IsImported">Imported</span>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="team-onboarding-card-progress">\n\t\t\t\t\t<span class="team-onboarding-card-progress-amount">{{teamMember.PercentComplete}}%</span>\n\t\t\t\t\t<progress-bar class="team-onboarding-card-progress-bar" pb-percentage="teamMember.PercentComplete" pb-size="is-large" pb-theme="is-primary has-gradient"></progress-bar>\n\t\t\t\t</div>\n\n\t\t\t\t<dropdown-menu class="team-onboarding-card-action-menu fadeIn" menu-show="teamMember.showMenu" menu-size="l" menu-icon="icon-setup" menu-show-chevron="false" ng-if="!$ctrl.onboardingDashboard.IsTeamComplete">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openEditTeamMemberWizard(teamMember)">Edit</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openChangeAdminStateForm(teamMember, true)" ng-if="teamMember.IsAdmin">Exclude from payroll</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openRemoveAdminAccessForm(teamMember)" ng-if="teamMember.IsAdmin && teamMember.UserID !== $root.currentUser.UserResponseUserID">Remove admin access</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="dropdown-group" ng-if="teamMember.UserID !== $root.currentUser.UserResponseUserID">\n\t\t\t\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeleteTeamMemberForm(teamMember)">Delete team member</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\t\t\t</section>\n\n\t\t\t<footer class="team-onboarding-footer">\n\t\t\t\t<h6 ng-if="$ctrl.teamAdmins.length"><ng-pluralize count="$ctrl.teamAdmins.length" when="{\'1\': \'1 admin\', \'other\': \'{} admins\'}"></ng-pluralize></h6>\n\t\t\t\t<p class="team-onboarding-footer-action s"><a href="" ng-click="$ctrl.openNewAdminForm()"><i class="icon-admins m"></i>&nbsp;&nbsp;Invite an admin</a></p>\n\t\t\t</footer>\n\n\t\t\t<!-- Admins -->\n\t\t\t<section class="team-onboarding-card {{teamAdmin.showMenu ? \'is-active\' : \'\'}}" ng-repeat="teamAdmin in $ctrl.teamAdmins | orderBy:\'Forename\'">\n\t\t\t\t<a href="" class="team-onboarding-card-title" ng-click="$ctrl.openEditAdminForm(teamAdmin)">{{teamAdmin.Forename}} {{teamAdmin.Surname}}</a>\n\t\t\t\t<p class="team-onboarding-card-email" ng-class="{\'team-onboarding-card-email--blank\' : teamAdmin.EmailAddress === \'\'}">{{teamAdmin.EmailAddress !== \'\' ? teamAdmin.EmailAddress : \'Email not added\'}}</p>\n\n\t\t\t\t<div class="team-onboarding-card-tags">\n\t\t\t\t\t<span class="tag tertiary">Admin</span>\n\t\t\t\t</div>\n\n\t\t\t\t<dropdown-menu class="team-onboarding-card-action-menu fadeIn" menu-show="teamAdmin.showMenu" menu-size="l" menu-icon="icon-setup" menu-show-chevron="false" ng-if="!$ctrl.onboardingDashboard.IsTeamComplete">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openEditAdminForm(teamAdmin)">Edit</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.setExcludeFromPayroll(teamAdmin, false)">Add to payroll</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openRemoveAdminAccessForm(teamAdmin)" ng-if="teamAdmin.UserID !== $root.currentUser.UserResponseUserID">Remove admin access</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\t\t\t</section>\n\t\t</div>\n\t</overlay-form-main>\n</overlay-form>\n');
$templateCache.put('components/address-book/address-book.component.html','<div class="address-book slide-in-form">\n\t<form name="addressBookForm" ng-submit="$ctrl.saveForm($ctrl, addressBookForm)" class="marginless" novalidate>\n\n\t\t<div class="address-book_header">\n\n\t\t\t<div class="address-book_header-title">\n\t\t\t\t<h5 class="address-book_header-heading">{{$ctrl.categoryTitle}}</h5>\n\t\t\t</div>\n\n\t\t\t<div class="address-book_header-actions">\n\t\t\t\t<a href="" ng-click="$ctrl.addressBookOptions.closeModal()" class="address-book_header-action button is-small">Cancel</a>\n\t\t\t\t<submit-button class="address-book_header-action is-primary-action" display-text="\'  Save  \'" state="addressBookForm.state" disable-button="addressBookForm.$invalid"></submit-button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<section class="address-book_content">\n\t\t\t<email-contacts agency-profile-id="$ctrl.addressBookOptions.agencyProfileId" contact-external-id="$ctrl.addressBookOptions.contactExternalId" new-contacts="$ctrl.contacts.contactsExternalNew" old-contacts="$ctrl.contacts.contactsExternalOld" form="addressBookForm" label="{{$ctrl.addressBookOptions.label}}" is-in-address-book="true"></email-contacts>\n\t\t</section>\n\n\t</form>\n</div>\n');
$templateCache.put('components/address-lookup/address-lookup.component.html','<fieldset ng-switch="$ctrl.viewState">\n\n\t<!-- View -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.VIEW_STATES.view">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header" ng-if="$ctrl.showLabel">\n\t\t\t\t<label>{{$ctrl.label}}:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<note>\n\t\t\t\t\t<note-columns>\n\t\t\t\t\t\t<print-address class="address c" address="$ctrl.address"></print-address>\n\t\t\t\t\t</note-columns>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="spacer xs"></div>\n\t\t<a class="underline s" data-cy="use-alternative_{{$ctrl.id}}" href="" ng-click="$ctrl.setViewState($ctrl, $ctrl.address.AddressForeign ? $ctrl.VIEW_STATES.manual : $ctrl.VIEW_STATES.lookup)">Use an alternative address</a>\n\t</div>\n\n\t<!-- Lookup -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.VIEW_STATES.lookup">\n\n\t\t<!-- Hidden input to invalidate control (when isRequired is set) during lookup. This is only relevant\n\t\t     when the view state is \'lookup\'. As soon as an address is selected the view state changes and this\n\t\t\t form control disappears, no longer contributing to any validity check. -->\n\t\t<input type="hidden" ng-required="$ctrl.isRequired" ng-model="$ctrl.requiredCheck">\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header" ng-if="$ctrl.showLabel">\n\t\t\t\t<label for="{{$ctrl.ids.addressLookup}}" ng-class="{disabled: $ctrl.isDisabled, \'required\': $ctrl.isRequired}">{{$ctrl.label}}:</label>\n\t\t\t</header>\n\n\t\t\t<div class="form-field-main">\n\t\t\t\t<!-- Search Dropdown -->\n\t\t\t\t<div class="search-dropdown">\n\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="nope" class="align-left" click-anywhere-but-here="$ctrl.showLookupAddressResults = false" data-cy="{{::$ctrl.ids.addressLookup}}" id="{{::$ctrl.ids.addressLookup}}" is-active="$ctrl.showLookupAddressResults" name="lookup" ng-change="$ctrl.lookupAddress($ctrl, $ctrl.addressSearchString)" ng-disabled="$ctrl.isDisabled" ng-focus="$ctrl.showLookupAddressResults = true" ng-model-options="{ debounce:500 }" ng-model="$ctrl.addressSearchString" ng-required="$ctrl.isRequired" placeholder="Start typing the address..." type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="search-dropdown-results fadeIn" data-cy="{{::$ctrl.ids.addressSearchResults}}" id="search-dropdown-results" ng-show="$ctrl.addressLookupState !== $ctrl.ADDRESS_LOOKUP_STATES.hidden && $ctrl.showLookupAddressResults">\n\t\t\t\t\t\t<div class="search-dropdown-result" ng-if="$ctrl.addressLookupState === $ctrl.ADDRESS_LOOKUP_STATES.loading">\n\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.addressLookupState === $ctrl.ADDRESS_LOOKUP_STATES.loaded">\n\t\t\t\t\t\t\t<div ng-if="$ctrl.addressResults.length > 0" data-cy="search-results_{{$ctrl.id}}">\n\t\t\t\t\t\t\t\t<a class="search-dropdown-result" data-cy="{{::$ctrl.ids.addressLookup + $index}}" href="" id="search-dropdown-result-{{$index}}" ng-click="$ctrl.selectAddress($ctrl, address)" ng-repeat="address in $ctrl.addressResults">\n\t\t\t\t\t\t\t\t\t<span class="search-dropdown-result-column" title="{{address.addressInfo}}">{{address.addressInfo}}</span>\n\t\t\t\t\t\t\t\t\t<span class="search-dropdown-result-column" title="{{address.postcodeInfo}}">{{address.localeInfo}}</span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="search-dropdown-no-results" data-cy="no-search-results_{{$ctrl.id}}" ng-if="$ctrl.addressResults.length === 0">Nothing found</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p ng-if="!$ctrl.isAddressPopulated && $ctrl.addressLookupState === $ctrl.ADDRESS_LOOKUP_STATES.error">\n\t\t\t\t\t\tWe\'re unable to load any addresses at this time. Please try entering an address again or come back in a few minutes to try.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLookup].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLookup].$error" role="alert">\n\t\t\t\t<p ng-message="required">Please start typing an address</p>\n\t\t\t</div>\n\t\t\t<div class="spacer xs"></div>\n\t\t\t<p class="s">Address not found<span ng-if="!$ctrl.isUkOnly">, or a non-UK address</span>?\n\t\t\t\t<a class="underline" data-cy="enter-manually_{{$ctrl.id}}" href="" ng-click="$ctrl.setViewState($ctrl, $ctrl.VIEW_STATES.manual)">Enter it manually</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Manual Entry (options) -->\n\t<fieldset pc-switch-when="$ctrl.VIEW_STATES.manual">\n\t\t<!-- Manual Entry (UK) -->\n\t\t<fieldset class="fadeIn" ng-disabled="$ctrl.isDisabled" ng-if="$ctrl.isUkOnly">\n\t\t\t<!-- Name / Number -->\n\t\t\t<section class="form-field-group">\n\n\t\t\t\t<!-- Name -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="{{$ctrl.ids.addressName}}" ng-class="{\'required\': $ctrl.address.AddressNumber === \'\'}">House name:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressName}}" id="{{::$ctrl.ids.addressName}}" name="{{::$ctrl.ids.addressName}}" ng-model="$ctrl.address.AddressName" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressName].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressName].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the house name</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="{{$ctrl.ids.addressNumber}}" ng-class="{\'required\': $ctrl.address.AddressName === \'\'}">House number:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressNumber}}" id="{{::$ctrl.ids.addressNumber}}" name="{{::$ctrl.ids.addressNumber}}" ng-model="$ctrl.address.AddressNumber" ng-required="$ctrl.address.AddressName === \'\'" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressNumber].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressNumber].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the house number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</section>\n\n\t\t\t<!-- Street -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressStreet}}" class="required">Street:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressStreet}}" id="{{::$ctrl.ids.addressStreet}}" name="{{::$ctrl.ids.addressStreet}}" ng-model="$ctrl.address.AddressStreet" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressStreet].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressStreet].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the street</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- City -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressCity}}">Town/City:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressCity}}" id="{{::$ctrl.ids.addressCity}}" name="{{::$ctrl.ids.addressCity}}" ng-model="$ctrl.address.AddressCity" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- County -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressCounty}}">County:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressCounty}}" id="{{::$ctrl.ids.addressCounty}}" name="{{::$ctrl.ids.addressCounty}}" ng-model="$ctrl.address.AddressCounty" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Postcode -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressPostcode}}" class="required">Postcode:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressPostcode}}" id="{{::$ctrl.ids.addressPostcode}}" name="{{::$ctrl.ids.addressPostcode}}" ng-model="$ctrl.address.AddressPostcode" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressPostcode].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressPostcode].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a postcode</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Country -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.ids.addressCountry}}">Country:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressCountry}}" class="primary-flat" id="{{::$ctrl.ids.addressCountry}}" name="{{::$ctrl.ids.addressCountry}}" ng-model="$ctrl.address.AddressCountry" ng-readonly="true" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="spacer s"></div>\n\t\t\t<a class="underline s" data-cy="search-for-uk-address_{{$ctrl.id}}" href="" ng-click="$ctrl.setViewState($ctrl, $ctrl.VIEW_STATES.lookup)" ng-if="!$ctrl.manualEntryOnly">Search for a UK address instead</a>\n\t\t</fieldset>\n\n\t\t<!-- Manual Entry (foreign) -->\n\t\t<fieldset class="fadeIn" ng-disabled="$ctrl.isDisabled" ng-if="!$ctrl.isUkOnly">\n\t\t\t<!-- Foreign Address line 1 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine1}}" class="required">Address Line 1:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine1}}" id="{{$ctrl.ids.addressLine1}}" name="{{$ctrl.ids.addressLine1}}" ng-model="$ctrl.address.AddressName" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLine1].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLine1].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the first line of the address</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Address line 2 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine2}}" class="required">Address Line 2:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine2}}" id="{{::$ctrl.ids.addressLine2}}" name="{{::$ctrl.ids.addressLine2}}" ng-model="$ctrl.address.AddressNumber" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLine2].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLine2].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the second line of the address</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Address line 3 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine3}}" class="required">Address Line 3:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine3}}" id="{{::$ctrl.ids.addressLine3}}" name="{{::$ctrl.ids.addressLine3}}" ng-model="$ctrl.address.AddressStreet" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLine3].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLine3].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the third line of the address</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Address line 4 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine4}}" ng-class="{\n\t\t\t\t\t\t\t\'required\' : !$ctrl.isCompanyAddress\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tAddress Line 4:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine4}}" id="{{::$ctrl.ids.addressLine4}}" name="{{::$ctrl.ids.addressLine4}}" ng-model="$ctrl.address.AddressCity" ng-required="!$ctrl.isCompanyAddress" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLine4].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLine4].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the fourth line of the address</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Address line 5 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine5}}">Address Line 5:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine5}}" id="{{::$ctrl.ids.addressLine5}}" name="{{::$ctrl.ids.addressLine5}}" ng-model="$ctrl.address.AddressCounty" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Address line 6 -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.ids.addressLine6}}">Address Line 6:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="nope" data-cy="{{::$ctrl.ids.addressLine6}}" id="{{::$ctrl.ids.addressLine6}}" name="{{::$ctrl.ids.addressLine6}}" ng-model="$ctrl.address.AddressPostcode" maxlength="50" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.ids.addressLine6].$touched" ng-messages="$ctrl.form[$ctrl.ids.addressLine6].$error" role="alert">\n\t\t\t\t\t<p ng-message="maxlength">Only 50 characters are allowed</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Foreign Country -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.ids.addressCountry}}">Country:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="{{::$ctrl.ids.addressCountry}}" data-cy="{{::$ctrl.ids.addressCountry}}" name="{{::$ctrl.ids.addressCountry}}" ng-model="$ctrl.address.AddressCountry" ng-options="country.value as country.name for country in $ctrl.countries" required></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Switch to UK address lookup if possible-->\n\t\t\t<div class="spacer s"></div>\n\t\t\t<a class="underline s" href="" ng-click="$ctrl.setViewState($ctrl, $ctrl.VIEW_STATES.lookup)" ng-if="!$ctrl.manualEntryOnly">Search for a UK address instead</a>\n\t\t</fieldset>\n\t</fieldset>\n</fieldset>\n');
$templateCache.put('components/adjustment-summary-card/adjustment-summary-card.component.html','<div class="adjustment-summary-card {{$ctrl.adjustment.adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}}">\n\n\t<div class="adjustment-summary-card_pre" ng-if="$ctrl.adjustmentLabel">\n\t\t<span class="badge is-secondary is-small adjustment-summary-card_pre-badge">\n\t\t\t<i class="icon-clock"></i>\n\t\t</span>\n\t\t<p class="adjustment-summary-card_pre-description">{{$ctrl.adjustmentLabel}}</p>\n\t\t<p class="adjustment-summary-card_pre-context">{{$ctrl.adjustmentLabelContext}}</p>\n\t</div>\n\n\t<header class="adjustment-summary-card_header">\n\t\t<h6 class="adjustment-summary-card_description">{{$ctrl.adjustment.adjustmentType.AgencyAdjustmentGroupEntryText}}<span ng-if="$ctrl.adjustment.NetToGross">&nbsp;(Net)&nbsp;</span><span class="adjustment-summary-card_description-meta" ng-if="$ctrl.adjustment.Recurring"><i class="icon-loading adjustment-summary-card_recurring fadeIn"></i><span ng-if="$ctrl.adjustment.recurForXPayPeriods"><ng-pluralize count="$ctrl.adjustment.RecurringPeriodCount" when="{\'1\': \'1 period\', \'other\': \'{} periods\'}"></ng-pluralize></span><span ng-if="!$ctrl.adjustment.recurForXPayPeriods">Every period</span></span></h6>\n\t\t<h6 class="adjustment-summary-card_value">\n\t\t\t{{\n\t\t\t\t$ctrl.adjustment |\n\t\t\t\tadjustmentValue :\n\t\t\t\tnull : {\n\t\t\t\t\tHIDE_CURRENCY_LABEL: true\n\t\t\t\t}\n\t\t\t}}\n\t\t</h6>\n\t</header>\n\n\t<div class="adjustment-summary-card_main" ng-switch="$ctrl.adjustment.adjustmentType.AgencyAdjustmentValueType">\n\n\t\t<!-- Payslip Label -->\n\t\t<p class="adjustment-summary-card_label">{{$ctrl.adjustment.Label === \'\' ? \'No payslip label\' : $ctrl.adjustment.Label}}</p>\n\n\t\t<!-- Absolute (net to gross) -->\n\t\t<p class="adjustment-summary-card_meta fadeIn" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.absolute" ng-switch="$ctrl.adjustment.netToGrossLoadingState" ng-if="$ctrl.adjustment.NetToGross">\n\t\t\t<span class="fadeIn" ng-switch-when="loading"><circle-loader class="m"></circle-loader></span>\n\t\t\t<span class="fadeIn" ng-switch-default>({{$ctrl.adjustment.grossAmount | monetise : null : null : { HIDE_CURRENCY_LABEL: true } }} Gross)</span>\n\t\t</p>\n\n\t\t<!-- Absolute (accrued holiday) -->\n\t\t<p class="adjustment-summary-card_meta fadeIn" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.absolute" ng-if="vm.selectedTeamMembers[0].HolidayAccrual > 0">(of <span class="underline" tooltip tooltip-text="{{vm.selectedTeamMembers[0].Forename}} has accrued {{vm.selectedTeamMembers[0].HolidayAccrual | monetise  : null : null : { HIDE_CURRENCY_LABEL: true } }} in holiday pay" tooltip-position="top-left" tooltip-size="m">{{vm.selectedTeamMembers[0].HolidayAccrual | monetise : null : null : { HIDE_CURRENCY_LABEL: true } }}</span> accrued)</p>\n\t\t<!-- Linked | Percentage | Units -->\n\t\t<p class="adjustment-summary-card_meta fadeIn" pc-switch-when="[$ctrl.ADJUSTMENT_VALUE_TYPES.linked, $ctrl.ADJUSTMENT_VALUE_TYPES.percentage, $ctrl.ADJUSTMENT_VALUE_TYPES.unit]">{{$ctrl.adjustment | adjustmentValueTypeCalculation : null : { HIDE_CURRENCY_LABEL: true } }}</p>\n\t</div>\n</div>\n');
$templateCache.put('components/adjustment-type-tax-treatment/adjustment-type-tax-treatment.component.html','<div class="adjustment-type-tax-treatment" data-cy="adjustment-type-tax-treatment">\n\n\t<div class="tag-list" data-cy="adjustment-type-tax-treatment-tag-list">\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.Taxable}" data-cy="adjustment-type-tax-treatment-tag-list-item-taxable">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-taxable">Taxable</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-taxable">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.Taxable}" data-cy="adjustment-type-tax-treatment-tag-taxable">{{::$ctrl.adjustmentType.Taxable | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.IsNIable}" data-cy="adjustment-type-tax-treatment-tag-list-item-niable">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-niable">National Insurance</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-niable">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.IsNIable}" data-cy="adjustment-type-tax-treatment-tag-niable">{{::$ctrl.adjustmentType.IsNIable | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.IsNotional}" data-cy="adjustment-type-tax-treatment-tag-list-item-notional">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-notional">Notional payment</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-notional">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.IsNotional}" data-cy="adjustment-type-tax-treatment-tag-notional">{{::$ctrl.adjustmentType.IsNotional | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.IsBIK}" data-cy="adjustment-type-tax-treatment-tag-list-item-bik">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-bik">Benefit in kind</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-bik">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.IsBIK}" data-cy="adjustment-type-tax-treatment-tag-bik">{{::$ctrl.adjustmentType.IsBIK | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.IsSalarySacrifice}" data-cy="adjustment-type-tax-treatment-tag-list-item-salary-sacrifice">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-salary-sacrifice">Salary sacrifice</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-salary-sacrifice">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.IsSalarySacrifice}" data-cy="adjustment-type-tax-treatment-tag-salary-sacrifice">{{::$ctrl.adjustmentType.IsSalarySacrifice | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryNetPayState}" data-cy="adjustment-type-tax-treatment-tag-list-item-net-pay">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-net-pay">Net Pay calculation</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-net-pay">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryNetPayState}" data-cy="adjustment-type-tax-treatment-tag-net-pay">{{::$ctrl.adjustmentType.AgencyAdjustmentGroupEntryNetPayState | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryPayrollBIKState}" data-cy="adjustment-type-tax-treatment-tag-list-item-payroll-bik">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-payroll-bik">Payrolled benefit</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-payroll-bik">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryPayrollBIKState}" data-cy="adjustment-type-tax-treatment-tag-payroll-bik">{{::$ctrl.adjustmentType.AgencyAdjustmentGroupEntryPayrollBIKState | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryHolidayState}" data-cy="adjustment-type-tax-treatment-tag-list-item-holiday-payable">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-holiday-payable">Holiday Pay</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-holiday-payable">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryHolidayState}" data-cy="adjustment-type-tax-treatment-tag-holiday-payable">{{::$ctrl.adjustmentType.AgencyAdjustmentGroupEntryHolidayState | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="tag-list_item" ng-class="{\'is-active\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryProrateState}" data-cy="adjustment-type-tax-treatment-tag-list-item-prorate">\n\t\t\t<h6 class="tag-list_item-title" data-cy="adjustment-type-tax-treatment-tag-list-item-title-prorate">Prorate</h6>\n\t\t\t<div class="tag-list_item-tag" data-cy="adjustment-type-tax-treatment-tag-list-item-tag-prorate">\n\t\t\t\t<div class="tag l" ng-class="{\'is-indifferent\' : $ctrl.adjustmentType.AgencyAdjustmentGroupEntryProrateState}" data-cy="adjustment-type-tax-treatment-tag-prorate">{{::$ctrl.adjustmentType.AgencyAdjustmentGroupEntryProrateState | yesNo}}</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/adjustments-list/adjustments-list.component.html','<div>\n\t<div class="adjustments-list_group" ng-repeat="adjustmentGroup in $ctrl.adjustmentDetailSummary.adjustmentGroups | orderBy: \'name\'">\n\t\t<!-- Group name (if shown)-->\n\t\t<div class="adjustments-list_group-header" ng-if="adjustmentGroup.name">\n\t\t\t<div class="adjustments-list_group-header-title" title="{{adjustmentGroup.name}}">{{adjustmentGroup.name}}</div>\n\t\t</div>\n\t\t<!-- Adjustment group - adjustments list -->\n\t\t<div class="adjustments-list_group-main">\n\t\t\t<!-- Count of changes, if required -->\n\t\t\t<div class="adjustments-list_group-main-count" ng-if="$ctrl.showAdjustmentsCount">\n\t\t\t\t<ng-pluralize count="adjustmentGroup.adjustments.length" when="{\'0\': \'No changes\', \'1\': \'1 change\', \'other\': \'{} changes\'}"></ng-pluralize>\n\t\t\t</div>\n\t\t\t<!-- Adjustments list -->\n\t\t\t<ul class="adjustments-list {{$ctrl.canUpdate ? \'can-delete\' : \'\'}}" ng-class="theme">\n\t\t\t\t<li class="adjustments-list-item {{adjustment.state}}" ng-class="[\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\'is-active\': adjustment.state !== \'ready\' && adjustment.state.length\n\t\t\t\t\t\t},\n\t\t\t\t\t\ttheme\n\t\t\t\t\t]" ng-repeat="adjustment in adjustmentGroup.adjustments | orderBy: [\n\t\t\t\t\t\t\'!canEdit\',\n\t\t\t\t\t\t\'AdjustmentDescription\',\n\t\t\t\t\t\t\'AdjustmentGross\'\n\t\t\t\t\t]" ng-switch="adjustment.state">\n\t\t\t\t\t<!-- Editable -->\n\t\t\t\t\t<a class="adjustments-list-item_label" href="" ng-click="$ctrl.openEditChangeForm($ctrl, adjustment)" ng-if="adjustment.canEdit" title="Edit {{adjustment.AdjustmentDescription}}">\n\t\t\t\t\t\t<adjustments-list-item-details adjustment="adjustment"></adjustments-list-item-details>\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- Not Editable -->\n\t\t\t\t\t<span class="adjustments-list-item_label is-not-editable" ng-if="!adjustment.canEdit">\n\t\t\t\t\t\t<adjustments-list-item-details adjustment="adjustment"></adjustments-list-item-details>\n\t\t\t\t\t\t<i class="icon-information" data-cy="adjustments-list-item-integration-info" ng-if="adjustment.IsFromIntegration" tooltip tooltip-position="right" tooltip-text="This adjustment is managed by a source system and cannot be edited here."></i>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t<span class="adjustments-list-item_amount fadeIn {{$ctrl.getAdjustmentValueDisplayClass(adjustment)}}" data-cy="adjustments-list-item-amount-{{::adjustment.AdjustmentLabel | slugify}}" pc-switch-when="$ctrl.ADJUSTMENT_STATES.ready">\n\t\t\t\t\t\t{{adjustment | adjustmentValue}}\n\n\t\t\t\t\t\t<!-- Delete -->\n\t\t\t\t\t\t<a aria-label="Delete" class="adjustments-list-item_delete" href="" ng-click="$ctrl.onAdjustmentDelete($ctrl, adjustment)" ng-if="adjustment.canDelete && $root.currentUser.Permissions.Payroll.canUpdateAdjustments"><i class="icon-trash"></i></a>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<!-- Confirm delete -->\n\t\t\t\t\t<span class="fadeIn adjustments-list-item_delete-confirmation" pc-switch-when="$ctrl.ADJUSTMENT_STATES.confirmDelete">\n\t\t\t\t\t\tDelete this change?&nbsp;&nbsp;\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.deleteAdjustment($ctrl, $ctrl.adjustmentDetailSummary, adjustment)">Yes</a>\n\t\t\t\t\t\t&nbsp;&nbsp;|&nbsp;&nbsp;\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.setAdjustmentState(adjustment, $ctrl.ADJUSTMENT_STATES.ready)">No</a>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<!-- Deleting -->\n\t\t\t\t\t<span class="fadeIn" pc-switch-when="$ctrl.ADJUSTMENT_STATES.deleting">\n\t\t\t\t\t\t<em>Deleting...</em>\n\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<!-- Failed -->\n\t\t\t\t\t<span class="fadeIn" pc-switch-when="$ctrl.ADJUSTMENT_STATES.error">\n\t\t\t\t\t\tFailed to delete - try again?&nbsp;&nbsp;\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.deleteAdjustment($ctrl, $ctrl.adjustmentDetailSummary, adjustment)">Yes</a>\n\t\t\t\t\t\t&nbsp;&nbsp;|&nbsp;&nbsp;\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.setAdjustmentState(adjustment, $ctrl.ADJUSTMENT_STATES.ready)">No</a>\n\t\t\t\t\t</span>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/adjustments-list-item-details/adjustments-list-item-details.component.html','<span>\n\n\t<!-- Icon -->\n\t<i class="adjustments-list-item_icon is-before icon-{{$ctrl.adjustment.adjustmentIcon}}" ng-if="$ctrl.adjustment.adjustmentIcon"></i>\n\n\t<!-- Recurring Icon (before) -->\n\t<i class="icon-loading adjustments-list-item_icon is-before" ng-if="!$ctrl.adjustment.adjustmentIcon && $ctrl.adjustment.AdjustmentRecurring" title="This change is recurring and will be applied every month automatically"></i>\n\n\t<!-- Prorated Icon (before) -->\n\t<i class="icon-calendar adjustments-list-item_icon is-before" ng-if="$ctrl.adjustment.AdjustmentProrate" title="This pay element will be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period"></i>\n\n\t<!-- Description -->\n\t<span data-cy="adjustments-list-item-details-{{::$ctrl.adjustment.label | slugify}}">\n\t\t{{$ctrl.adjustment.label}}\n\t</span>\n\t<!-- Calculation -->\n\t<span>{{$ctrl.adjustment | adjustmentValueTypeCalculation}}</span>\n\t<i class="adjustments-list-item_info-tooltip icon-information" data-cy="adjustments-list-item-details-{{::$ctrl.adjustment.label | slugify}}-info-tooltip" ng-if="$ctrl.adjustment.AdjustmentTooltip" tooltip tooltip-position="bottom" tooltip-text="{{$ctrl.adjustment.AdjustmentTooltip}}"></i>\n\n</span>\n');
$templateCache.put('components/admin-card/adminCard.html','<div class="admin-card fadeIn {{admin.showMenu ? \'is-menu-open\' : \'\'}}">\n\n\t<div class="admin-card__header">\n\t\t<div class="admin-card__details">\n\t\t\t<avatar class="admin-card__avatar" avatar-initial="{{admin.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{admin.UserID}}"></avatar>\n\n\t\t\t<div class="admin-card__persona">\n\t\t\t\t<p class="admin-card__name"><name forename="{{admin.Forename}}" surname="{{admin.Surname}}"></name></p>\n\t\t\t\t<p class="admin-card__email">\n\t\t\t\t\t<truncate text="admin.Username" truncate-amount="25" on-empty-display="No username"></truncate>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="admin-card__role">\n\t\t\t<span class="tag l quarternary"><i class="icon-roles"></i>&nbsp;&nbsp;&nbsp;{{admin.RoleType | roleTypeMeta:\'name\'}}</span>\n\t\t</div>\n\n\t\t<dropdown-menu class="admin-card__action-menu" menu-icon="icon-setup" menu-id="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-menu" menu-on-open="onMenuOpen(admin)" menu-show="admin.showMenu" menu-size="xl" ng-if="canEditAdmin">\n\t\t\t<div class="dropdown-group" ng-if="!ssoEnabled">\n\t\t\t\t<div ng-switch="registrationSummaryDownloadState">\n\t\t\t\t\t<div class="centered-contents fadeIn" pc-switch-when="REGISTRATION_SUMMARY_STATES.loading">\n\t\t\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="fadeIn" ng-switch="invitation.InvitationStatus" pc-switch-when="REGISTRATION_SUMMARY_STATES.ready">\n\n\t\t\t\t\t\t<!-- Registered -->\n\t\t\t\t\t\t<div class="admin-card__invitation-status" ng-if="isRegistered">\n\t\t\t\t\t\t\t<icon-dot icon="icon-tick" is-light="true" theme="is-secondary"></icon-dot>\n\n\t\t\t\t\t\t\t<p class="admin-card__invitation-message is-small is-font-greyscale-300">\n\t\t\t\t\t\t\t\tRegistered at {{registeredDateISO | dateformat:\'timeDate24\'}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Invited -->\n\t\t\t\t\t\t<div class="admin-card__invitation-status" ng-if="!isRegistered" pc-switch-when="REGISTRATION_INVITATION_STATUSES.ok">\n\t\t\t\t\t\t\t<icon-dot icon="icon-clock" is-light="true" theme="is-indifferent"></icon-dot>\n\n\t\t\t\t\t\t\t<p class="admin-card__invitation-message is-small is-font-greyscale-300">\n\t\t\t\t\t\t\t\tInvited at {{invitation.InvitationSentDateISO | dateformat:\'timeDate24\'}} with verification code:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<p class="admin-card__invitation-code is-small">\n\t\t\t\t\t\t\t\t<a class="is-font-greyscale-500" href="" ng-click="onCodeClick(invitation)">\n\t\t\t\t\t\t\t\t\t{{invitation.InvitationVerificationCode}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Expired invite -->\n\t\t\t\t\t\t<div class="admin-card__invitation-status" ng-if="canManageAccounts && !isRegistered" pc-switch-when="[\n\t\t\t\t\t\t\t\tREGISTRATION_INVITATION_STATUSES.expired,\n\t\t\t\t\t\t\t\tREGISTRATION_INVITATION_STATUSES.notFound,\n\t\t\t\t\t\t\t\tREGISTRATION_INVITATION_STATUSES.attemptsExceeded\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t<icon-dot icon="icon-warning" is-light="true" theme="is-assertive"></icon-dot>\n\n\t\t\t\t\t\t\t<p class="admin-card__invitation-message is-small is-font-greyscale-300">\n\t\t\t\t\t\t\t\tInvitation expired. Click &lsquo;Resend invite&rsquo; to send again.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-resend-invite" href="" ng-click="openResendInviteForm(admin)" ng-if="canManageAccounts && !admin.IsRegistered && !ssoEnabled">\n\t\t\t\t\tResend invite\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-invite-to-fully-register" href="" ng-click="openInviteToFullyRegisterForm(admin)" ng-if="canManageAccounts && ssoEnabled && !admin.IsRegistered">\n\t\t\t\t\tInvite to register\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-edit-details" href="" ng-click="openEditAdminForm(admin)" ng-if="admin.ExcludeFromPayroll && (admin.IsRegistered || ssoEnabled)">\n\t\t\t\t\tEdit details\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-manage-permissions" href="" ng-click="openManagePermissionsForm(admin)" ng-if="admin.IsRegistered || ssoEnabled">\n\t\t\t\t\tManage permissions\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-reset-access" href="" ng-click="openResetAuthAccessForm(admin)" ng-if="::$root.currentUser.Permissions.Admin.canManageAccess && (admin.IsRegistered || ssoEnabled)">\n\t\t\t\t\tReset access\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-send-password-reset-link" href="" ng-click="openSendPasswordResetLinkForm(admin)" ng-if="admin.IsRegistered">\n\t\t\t\t\tSend password reset link\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-manage-mentions-access" href="" ng-click="openManageMentionsAccessForm(admin)" ng-if="::canManageMentionsAccess && $root.currentUser.Permissions.Admin.canManageMentionsAccess && (admin.IsRegistered || ssoEnabled)">\n\t\t\t\t\tManage mentions access\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-view-role" href="" ng-click="openViewRoleForm(admin)" ng-if="!admin.isLoggedInUser && !$root.currentUser.hasTempPermissions">\n\t\t\t\t\tView role\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-go-to-profile" ui-sref="team.profile.overview({agencyProfileId: admin.AgencyProfileID, userId: admin.UserID})" ng-if="!admin.ExcludeFromPayroll && canAddToTeam && admin.IsRegistered">\n\t\t\t\t\tGo to profile\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-unlink-access-account" href="" ng-click="openUnlinkAccessAccountForm(admin)" ng-if="canManageAccounts && !admin.isLoggedInUser && linkedUserProfile">\n\t\t\t\t\tUnlink Access account\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="dropdown-group" ng-if="!admin.isLoggedInUser">\n\t\t\t\t<a data-cy="admin-{{ ::admin.Forename | slugify }}-{{ :: admin.Surname | slugify }}-remove-admin-access" href="" ng-click="openRemoveAdminAccessForm(admin)" class="assertive">Remove admin access</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t</div>\n\n\t<div class="admin-card__footer">\n\t\t<div>\n\t\t\t<div ng-if="admin.IsRegistered && !ssoEnabled">\n\t\t\t\t<span class="tag is-large positive">Registered</span>\n\t\t\t</div>\n\n\t\t\t<div ng-if="!admin.IsRegistered && !ssoEnabled">\n\t\t\t\t<span class="tag is-large indifferent">Not Registered</span>\n\t\t\t</div>\n\n\t\t\t<div ng-if="ssoEnabled">\n\t\t\t\t<p class="s greyscale">SSO enabled</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div>\n\t\t\t<p class="is-small is-greyscale" data-cy="admin-card-recovery-email">\n\t\t\t\tRecovery email: {{::admin.RecoveryEmailAddress}}\n\t\t\t</p>\n\t\t\t<p class="is-small is-greyscale" data-cy="admin-card-access-account">\n\t\t\t\tAccess account: {{::admin.AccountEmailAddress}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/admin-card-workflow/admin-card-workflow.component.html','<div class="admin-card-workflow fadeIn">\n\n\t<div class="admin-card-workflow_header">\n\n\t\t<div class="admin-card-workflow_details">\n\t\t\t<avatar class="admin-card-workflow_avatar" avatar-initial="{{$ctrl.admin.Forename[0]}}" avatar-size="is-small" avatar-user-id="{{$ctrl.admin.UserID}}"></avatar>\n\t\t\t<div class="admin-card-workflow_persona">\n\t\t\t\t<p class="admin-card-workflow_name"><name forename="{{$ctrl.admin.Forename}}" surname="{{$ctrl.admin.Surname}}"></name></p>\n\t\t\t\t<p class="admin-card-workflow_company" ng-if="$ctrl.admin.CompanyName">{{$ctrl.admin.CompanyName}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="admin-card-workflow_action" ng-transclude="action"></div>\n\t</div>\n</div>\n');
$templateCache.put('components/admin-validation-code/admin-validation-code.component.html','<div class="admin-validation-code">\n\t{{$ctrl.code}}\n</div>\n');
$templateCache.put('components/app-header/app-header.component.html','<header class="app-header" ng-class="{\n\t\t\'is-menu-visible\': $ctrl.companies.length > $ctrl.MAX_BREADCRUMBS_LENGTH\n\t}">\n\t<div class="app-header_decorator">\n\t\t<gradient-bar colour1="$ctrl.session.customisation.Branding.Colour1" colour2="$ctrl.session.customisation.Branding.Colour2" height="3"></gradient-bar>\n\t</div>\n\n\t<div class="app-header_main" ng-class="{\'main-evo\': $ctrl.currentUser.IsEvoNative}">\n\n\t\t<!-- Access Evo container -->\n\t\t<div class="access-button"></div>\n\t\t<!-- Company -->\n\t\t<div class="app-header_company">\n\n\t\t\t<!-- Logo -->\n\t\t\t<a class="app-header_logo" href="" ng-click="$ctrl.goToDefaultLandingPageForUser($ctrl.currentUser)" ng-if="!$ctrl.currentUser.IsEvoNative">\n\t\t\t\t<img alt="{{$ctrl.session.customisation.AgencyProfileName}}" class="app-header_logo-media" ng-src="{{$ctrl.session.customisation.LogoUrls.Icon}}">\n\t\t\t</a>\n\n\t\t\t<!-- Menu Toggle -->\n\t\t\t<div class="app-header_toggles" ng-if="\n\t\t\t\t\t$root.isNavActive &&\n\t\t\t\t\t$ctrl.currentUser.isAppNavEnabled\n\t\t\t\t">\n\t\t\t\t<a aria-label="Toggle side menu" class="app-header_toggle hidden-phone" href="" ng-class="{\n\t\t\t\t\t\t\'is-active\': $root.isNavOpen\n\t\t\t\t\t}" ng-click="$ctrl.toggleNav()">\n\t\t\t\t\t<i class="icon-menu-alt"></i>\n\t\t\t\t</a>\n\t\t\t\t<a aria-label="Toggle side menu" class="app-header_toggle visible-phone" href="" ng-class="{\n\t\t\t\t\t\t\'is-active\': $root.isNavOpenMobile\n\t\t\t\t\t}" ng-click="$ctrl.toggleNavMobile()">\n\t\t\t\t\t<i class="icon-menu-alt"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<!-- Company (Non-mobile) -->\n\t\t\t<div class="app-header_title" ng-if="!$ctrl.currentUser.IsEvoNative">\n\t\t\t\t<h6 class="app-header_heading" data-cy="app-header-user-company" ng-if="$ctrl.companies.length === 1">\n\t\t\t\t\t{{$ctrl.currentUser.AgencyProfileName}}\n\t\t\t\t</h6>\n\t\t\t\t<a class="app-header_heading app-header_link is-strong" data-cy="app-header-user-company-link" href="" ng-click="$ctrl.goToListPageForCompany($ctrl, $ctrl.companies[0], 0)" ng-if="$ctrl.companies.length > 1">\n\t\t\t\t\t{{$ctrl.currentUser.AgencyProfileName}}\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- User -->\n\t\t<div class="app-header_user">\n\n\t\t\t<!-- Actions -->\n\t\t\t<div class="app-header_actions" ng-if="::!$ctrl.currentUser.IsInPlayground">\n\n\t\t\t\t<!-- CAL / GAL -->\n\t\t\t\t<div class="app-header_action" ng-if="\n\t\t\t\t\t\t$ctrl.currentPeriod &&\n\t\t\t\t\t\t$root.currentUser.Permissions.isHistoryVisible &&\n\t\t\t\t\t\t$root.userHasRole([\n\t\t\t\t\t\t\t$ctrl.USER_ROLES.groupadminlite,\n\t\t\t\t\t\t\t$ctrl.USER_ROLES.companyadministratorlite\n\t\t\t\t\t\t])\n\t\t\t\t\t">\n\t\t\t\t\t<a class="app-header_action-link app-header_link fadeIn" ng-if="!$ctrl.isAnyStateActive($ctrl.PAYROLL_HISTORY_STATES)" ui-sref="payroll.history.pay-periods({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tView payroll history&nbsp;<i class="icon-chevron-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-header_action-link app-header_link fadeIn" ng-if="$ctrl.isAnyStateActive($ctrl.PAYROLL_HISTORY_STATES)" ui-sref="payroll.current-period.notes({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tView current period&nbsp;<i class="icon-chevron-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Payroll Assistant -->\n\t\t\t\t<div class="app-header_action app-header_payroll-assistant" ng-if="$ctrl.isPayrollAssistantEnabled">\n\t\t\t\t\t<button class="app-header_payroll-assistant_button" data-cy="app-header-payroll-assistant-trigger" ng-click="$ctrl.openPayrollAssistant()" type="button">\n\t\t\t\t\t\t<img src="images/icons/sparkles.svg" alt="" class="app-header_payroll-assistant_icon">\n\t\t\t\t\t\t<span class="app-header_payroll-assistant_text">Payroll Assistant</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Help & Support -->\n\t\t\t\t<div class="app-header_action" ng-if="$root.userHasRole($ctrl.helpAndSupportRoles)">\n\t\t\t\t\t<a aria-label="Open Help and Support" class="is-greyscale is-hover-tertiary" href="" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isHelpAndSupportOpen\n\t\t\t\t\t\t}" ng-click="$ctrl.openHelpAndSupport()">\n\t\t\t\t\t\t<i class="icon-support is-large"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Notifications -->\n\t\t\t\t<div class="app-header_action popIn" ng-if="$root.userHasRole([\n\t\t\t\t\t\t$ctrl.USER_ROLES.paycircle,\n\t\t\t\t\t\t$ctrl.USER_ROLES.bureau,\n\t\t\t\t\t\t$ctrl.USER_ROLES.bureaumanager\n\t\t\t\t\t])">\n\t\t\t\t\t<notification-popout agency-profile-id="$ctrl.currentUser.AgencyProfileID" user-id="$ctrl.currentUser.UserResponseUserID"></notification-popout>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Search -->\n\t\t\t\t<div class="app-header_action" ng-if="\n\t\t\t\t\t\t$ctrl.currentUser.IsMultipleCompanyAdmin &&\n\t\t\t\t\t\t!$root.userHasRole($ctrl.USER_ROLES.groupadminlite)\n\t\t\t\t\t">\n\t\t\t\t\t<a aria-label="Open search" class="is-greyscale is-hover-tertiary" data-cy="app-header-fast-search-trigger" href="" ng-click="$ctrl.showFastSearch()">\n\t\t\t\t\t\t<i class="icon-search-alt is-large"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- User Menu -->\n\t\t\t<nav class="app-header_user-content" click-anywhere-but-here="$ctrl.showUserMenu = false" is-active="$ctrl.showUserMenu">\n\t\t\t\t<!-- Persona -->\n\t\t\t\t<a class="app-header_user-menu" data-cy="app-header-user-menu" href="" id="app-header_user-persona" ng-click="$ctrl.toggleUserMenu($ctrl)">\n\t\t\t\t\t<div class="app-header_user-avatar" ng-if="!$ctrl.currentUser.IsEvoNative" ng-class="{\n\t\t\t\t\t\t\t\'is-menu-open\': $ctrl.showUserMenu\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<avatar avatar-initial="{{$ctrl.currentUser.UserResponseFirstName[0]}}" avatar-size="is-tiny" avatar-theme="is-primary {{ $ctrl.showUserMenu ? \'is-active\' : \'\'}}" avatar-user-id="{{$ctrl.currentUser.UserResponseUserID}}" class="is-link"></avatar>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="app-header_user-avatar app-header_user-avatar--chevron-up" ng-if="$ctrl.currentUser.IsEvoNative" ng-class="{\n\t\t\t\t\t\t\t\'is-menu-open\': $ctrl.showUserMenu\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="icon-setup-user is-large"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Dropdown -->\n\t\t\t\t<section class="app-header_user-dropdown dropdown xxl fadeInFast" ng-click="$ctrl.showUserMenu = false" ng-show="$ctrl.showUserMenu">\n\t\t\t\t\t<nav>\n\n\t\t\t\t\t\t<!-- Persona -->\n\t\t\t\t\t\t<div class="app-header_user-dropdown-user" ng-if="!$ctrl.currentUser.IsEvoNative">\n\t\t\t\t\t\t\t<div class="app-header_user-dropdown-user-avatar" ng-if="!$ctrl.currentUser.IsEvoNative">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{$ctrl.currentUser.UserResponseFirstName[0]}}" avatar-size="is-small" avatar-user-id="{{$ctrl.currentUser.UserResponseUserID}}"></avatar>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="app-header_user-dropdown-user-content">\n\t\t\t\t\t\t\t\t<h6 class="app-header_user-dropdown-user-title">\n\t\t\t\t\t\t\t\t\t<truncate text="$ctrl.currentUser.UserResponseFirstName" truncate-amount="20">\n\t\t\t\t\t\t\t\t\t</truncate>\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<p class="app-header_user-dropdown-user-detail">Joined: {{$ctrl.currentUser.UserResponseCreationDate | simple}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Account -->\n\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t<a ng-if="$ctrl.isAccountSettingsVisible && !$ctrl.currentUser.IsEvoNative" ng-click="$ctrl.goToAccountSettings()">\n\t\t\t\t\t\t\t\t<i class="icon-settings"></i> Account settings\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a href="" id="user-menu_switch-user-playground" ng-click="$ctrl.togglePlayground()" ng-if="::$ctrl.currentUser.IsPlaygroundSwitchEnabled">\n\t\t\t\t\t\t\t\t<i class="icon-playground"></i> {{$ctrl.currentUser.IsInPlayground ? \'Go to live\' : \'Go to playground\'}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a href="" ng-href="mailto:{{::$root.CONFIG.bugReportEmail}}" ng-if="::$ctrl.currentUser.AgencyProfileCanReportBugs">\n\t\t\t\t\t\t\t\t<i class="icon-bug"></i> Report a bug\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.goLinkAccounts()" ng-if="::$ctrl.currentUser.IsAccessIdentityAccount && $ctrl.IsLinkingAdminsFeatureEnabled">\n\t\t\t\t\t\t\t\t<i class="icon-split"></i> Manage linked accounts\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a href="" ng-if="!$ctrl.currentUser.IsEvoNative" ng-click="$ctrl.logout()">\n\t\t\t\t\t\t\t\t<i class="icon-logout"></i>Sign out\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Account switching  -->\n\t\t\t\t\t\t<div class="dropdown-group" ng-if="$ctrl.accountsList.length > 0 && $ctrl.IsLinkingAdminsFeatureEnabled && !$ctrl.currentUser.IsEvoNative">\n\t\t\t\t\t\t\t<p class="dropdown-subtitle">Switch account</p>\n\t\t\t\t\t\t\t<div ng-repeat="account in $ctrl.shortAccountList track by account.UserID">\n\t\t\t\t\t\t\t\t<a class="switch-account-item-wrapper" href="" ng-click="$ctrl.switchAccount(account)">\n\t\t\t\t\t\t\t\t\t<switch-account-item account="account">\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<a href="" ui-sref="switch-account({userId:$ctrl.currentUser.UserResponseUserID})" ng-if="$ctrl.accountsList.length > $ctrl.maxAccountsVisible">\n\t\t\t\t\t\t\t\t<i class="icon-right"></i> View all linked accounts\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Paycircle Admin Actions -->\n\t\t\t\t\t\t<div class="dropdown-group" ng-if="$root.isDevelopment">\n\t\t\t\t\t\t\t<p class="dropdown-subtitle">Paycircle admins</p>\n\t\t\t\t\t\t\t<a class="tertiary" ui-sref="paycircle-dashboard.onboarding-stats">\n\t\t\t\t\t\t\t\tPaycircle Dashboard\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="tertiary" href="fonts/paycircle-icons/demo.html" target="_blank">\n\t\t\t\t\t\t\t\tIcons\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="tertiary" ng-if="!$ctrl.currentUser.IsInPlayground" target="_blank" ui-sref="trial-signup({\n\t\t\t\t\t\t\t\t\tcompanyKey: \'fsb\'\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tInvite to FSB Demo\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="tertiary" ng-if="!$ctrl.currentUser.IsInPlayground" target="_blank" ui-sref="trial-signup({\n\t\t\t\t\t\t\t\t\tcompanyKey: \'paycircle\'\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tInvite to Paycircle Onboarding\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="tertiary" ng-click="$ctrl.togglePayircleTools()" ng-if="$ctrl.currentUser.IsInPlayground" href>\n\t\t\t\t\t\t\t\t{{$root.showPaycircleTools ? \'Hide\' : \'Show\'}}&nbsp;Paycircle tools\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- UI kit form, for UI dev + testing. Hidden for non-Paycircle users, but still part of the DOM\n\t\t\t\t\t\t     for all users, so it can be invoked for Cypress tests, even though it\'s not visible. -->\n\t\t\t\t\t\t<div class="dropdown-group" ng-hide="!$root.isDevelopment">\n\t\t\t\t\t\t\t<p class="dropdown-subtitle">Paycircle UI Kit</p>\n\t\t\t\t\t\t\t<a class="tertiary" data-cy="open-form-ui-kit" ng-click="$ctrl.openTemplateForm()" href>Open form UI Kit</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</nav>\n\t\t\t\t</section>\n\n\t\t\t</nav>\n\n\t\t</div>\n\t</div>\n\n\t<!-- Footer -->\n\t<nav class="app-header_footer" ng-class="{\n\t\t\t\'is-active\': $ctrl.isAppHeaderFooterVisible()\n\t\t}">\n\t\t<!-- List (Mobile / Companies over set limit) -->\n\t\t<div class="app-header_list fadeIn" click-anywhere-but-here="$ctrl.toggleCollapsedMenu($ctrl)" is-active="$ctrl.showCollapsedBreadcrumbs" ng-if="$ctrl.companies.length > $ctrl.MAX_BREADCRUMBS_LENGTH">\n\t\t\t<!-- Toggle -->\n\t\t\t<a aria-label="Show hidden companies" class="app-header_list-trigger" data-cy="app-header-breadcrumb-menu" href="" ng-class="{\n\t\t\t\t\t\'is-active\': $ctrl.showCollapsedBreadcrumbs\n\t\t\t\t}" ng-click="$ctrl.toggleCollapsedMenu($ctrl)">\n\t\t\t\t<i class="app-header_list-icon icon-ellipses"></i>\n\t\t\t</a>\n\n\t\t\t<!-- Dropdown -->\n\t\t\t<section class="app-header_list-dropdown dropdown xl fadeInFast" ng-class="{\n\t\t\t\t\t\'is-active\': $ctrl.showCollapsedBreadcrumbs\n\t\t\t\t}">\n\t\t\t\t<nav>\n\t\t\t\t\t<a class="app-header_item tertiary" data-cy="app-header-breadcrumb-menu-company-{{$index}}" href="" ng-class="{\n\t\t\t\t\t\t\t\'visible-phone\' : $first\n\t\t\t\t\t\t}" ng-click="$ctrl.goToListPageForCompany($ctrl, company, $index)" ng-if="!$last" ng-repeat="company in $ctrl.companies track by company.AgencyProfileID">\n\t\t\t\t\t\t<span class="app-header_chevron" ng-if="!$first">\n\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class="app-header_item-title app-header_link">{{company.Name}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\t\t\t</section>\n\n\t\t\t<span class="app-header_chevron" ng-if="!$last">\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</span>\n\n\t\t\t<!-- Current company -->\n\t\t\t<div class="app-header_item">\n\t\t\t\t<div class="app-header_item-title" data-cy="app-header-breadcrumb-menu-current-company" title="{{$ctrl.currentCompany.Name}}">\n\t\t\t\t\t{{$ctrl.currentCompany.Name}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Breadcrumbs -->\n\t\t<div class="app-header_breadcrumbs fadeIn" ng-if="\n\t\t\t\t$ctrl.companies.length <= $ctrl.MAX_BREADCRUMBS_LENGTH ||\n\t\t\t\t!$ctrl.currentUser.IsMultipleCompanyAdmin\n\t\t\t">\n\t\t\t<div class="app-header_item" ng-class="{\n\t\t\t\t\t\'hidden-phone\' : !$last,\n\t\t\t\t\t\'visible-phone\' : $first\n\t\t\t\t}" ng-repeat="company in $ctrl.companies track by company.AgencyProfileID" title="{{company.Name}}">\n\t\t\t\t<div class="app-header_item-title" ng-class="{\n\t\t\t\t\t\t\'app-header_link\' : !$last\n\t\t\t\t\t}">\n\t\t\t\t\t<span ng-if="$last" data-cy="app-header-breadcrumb-current-company">\n\t\t\t\t\t\t{{company.Name}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<a class="app-header_link" data-cy="app-header-breadcrumb-company-{{$index}}" href="" ng-click="$ctrl.goToListPageForCompany($ctrl, company, $index)" ng-if="!$last">\n\t\t\t\t\t\t{{company.Name}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<span class="app-header_chevron" ng-if="!$last">\n\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="app-header_footer-actions fadeIn" ng-if="$ctrl.currentCompany.isPayrollCompany">\n\n\t\t\t<!-- Current period -->\n\t\t\t<a class="app-header_footer-action app-header_link fadeIn" ng-href="{{$ctrl.currentCompany.ngHref.payroll}}" ng-if="\n\t\t\t\t\t[\n\t\t\t\t\t\t$ctrl.COMPANY_STATES.live,\n\t\t\t\t\t\t$ctrl.COMPANY_STATES.demo\n\t\t\t\t\t].includes($ctrl.currentCompany.State) &&\n\t\t\t\t\t$ctrl.currentPeriod &&\n\t\t\t\t\t!$root.userHasRole(\n\t\t\t\t\t[\n\t\t\t\t\t\t$ctrl.USER_ROLES.groupadminlite,\n\t\t\t\t\t\t$ctrl.USER_ROLES.companyadministratorlite\n\t\t\t\t\t])\n\t\t\t\t" title="Current period">\n\t\t\t\t<span class="app-header_footer-title">{{$ctrl.currentPeriod.PayPeriodDisplay}}&nbsp;</span>\n\t\t\t\t<i class="icon-right is-smedium"></i>\n\t\t\t</a>\n\n\t\t\t<!-- Onboarding -->\n\t\t\t<a class="app-header_footer-action app-header_link fadeIn" href="" ng-class="{\n\t\t\t\t\t\'is-active\': $ctrl.sideBarOptions.activeMenu === \'onboarding\' && $ctrl.sideBarOptions.isOpen\n\t\t\t\t}" ng-click="$ctrl.toggleSideBarMenu(\'onboarding\')" ng-if="\n\t\t\t\t\t![\n\t\t\t\t\t\t$ctrl.COMPANY_STATES.live,\n\t\t\t\t\t\t$ctrl.COMPANY_STATES.demo\n\t\t\t\t\t].includes($ctrl.currentCompany.State) &&\n\t\t\t\t\t!$root.userHasRole([\n\t\t\t\t\t\t$ctrl.USER_ROLES.groupadminlite,\n\t\t\t\t\t\t$ctrl.USER_ROLES.companyadministratorlite\n\t\t\t\t\t])\n\t\t\t\t" title="Onboarding">\n\t\t\t\t<i class="icon-admins is-smedium"></i>\n\t\t\t\t<span class="app-header_footer-title">Onboarding</span>\n\t\t\t</a>\n\n\t\t\t<!-- Activity -->\n\t\t\t<a class="app-header_footer-action app-header_link fadeIn" href="" ng-class="{\n\t\t\t\t\t\'is-active\': $ctrl.sideBarOptions.activeMenu === \'activity\' && $ctrl.sideBarOptions.isOpen\n\t\t\t\t}" ng-click="$ctrl.toggleSideBarMenu(\'activity\')" ng-if="\n\t\t\t\t\t$ctrl.currentCompany.State !== $ctrl.COMPANY_STATES.demo &&\n\t\t\t\t\t!$root.userHasRole([\n\t\t\t\t\t\t$ctrl.USER_ROLES.groupadminlite,\n\t\t\t\t\t\t$ctrl.USER_ROLES.companyadministratorlite\n\t\t\t\t\t])\n\t\t\t\t" title="Activity">\n\t\t\t\t<i class="icon-history is-smedium"></i>\n\t\t\t\t<span class="app-header_footer-title">Activity</span>\n\t\t\t</a>\n\n\t\t</div>\n\t</nav>\n</header>\n');
$templateCache.put('components/app-navigation/app-navigation.component.html','<div class="app-navigation fadeIn" ng-switch="$ctrl.navigationState">\n\n\t<div ng-switch="$ctrl.currentCompany.CompanyType" pc-switch-when="$ctrl.NAVIGATION_STATES.companyDefined">\n\n\t\t<!-- Paycircle -->\n\t\t<div ng-if="$ctrl.currentCompany.AgencyProfileID === $root.CONFIG.paycircleBureauId" pc-switch-when="$ctrl.INTERFACE_TYPES.bureau">\n\n\t\t\t<!-- Default -->\n\t\t\t<div class="fadeIn">\n\n\t\t\t\t<nav class="app-navigation_menu" id="app-nav-enterprise">\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-enterprise-dashboard" ui-sref-active="is-active" ui-sref="dashboard({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-dashboard m"></i>\n\t\t\t\t\t\t<span>Dashboard</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-my-tasks" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'my-tasks\')\n\t\t\t\t\t\t}" ui-sref="my-tasks.workflow({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-tick-square m"></i>\n\t\t\t\t\t\t<span>My tasks</span>\n\t\t\t\t\t\t<span class="app-navigation_counter tag tertiary inverse" ng-class="{\'tada\': $root.userTasks}" ng-if="\n\t\t\t\t\t\t\t\t!$root.userTasks ||\n\t\t\t\t\t\t\t\t$root.userTasks.dueCount > 0\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="!$root.userTasks"></i>\n\t\t\t\t\t\t\t<span ng-if="$root.userTasks">{{$root.userTasks.dueCount | nineMax}}</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-workflow" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'workflow\')\n\t\t\t\t\t\t}" ui-sref="workflow.overview({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-workflow-alt m"></i>\n\t\t\t\t\t\t<span>Workflow</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-enterprise-bureaus" ui-sref-active="is-active" ui-sref="bureaus({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-franchisees m"></i>\n\t\t\t\t\t\t<span>Bureaus</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<nav class="app-navigation_sub-menu fadeIn" ng-if="$ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\'bureaus\',\n\t\t\t\t\t\t\t\'bureaus-archived\'\n\t\t\t\t\t\t])">\n\t\t\t\t\t\t<a class="app-navigation_sub-menu-item" id="app-nav-enterprise-bureaus-archived" ui-sref-active="is-active" ui-sref="bureaus-archived({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t\t<a class="app-navigation_menu-item has-sub-menu" id="app-nav-enterprise-companies" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\t\'companies-archived\'\n\t\t\t\t\t\t\t])}" ui-sref="companies({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-company m"></i>\n\t\t\t\t\t\t<span>Companies</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t\t<nav class="app-navigation_sub-menu fadeIn" ng-if="$ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\t\'companies-archived\'\n\t\t\t\t\t\t\t])">\n\t\t\t\t\t\t\t<a class="app-navigation_sub-menu-item" id="app-nav-enterprise-companies-archived" ui-sref-active="is-active" ui-sref="companies-archived({\n\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</nav>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-enterprise-company-groups" ui-sref-active="is-active" ui-sref="company-groups({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-company-groups m"></i>\n\t\t\t\t\t\t<span>Company groups</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-enterprise-onboarding" ng-if="$root.currentUser.CanAccessOnboarding" ui-sref-active="is-active" ui-sref="bureau-onboarding({\n\t\t\t\t\t\t\tagencyProfileId:$root.CONFIG.paycircleOnboardingId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-rocket m"></i>\n\t\t\t\t\t\t<span>Onboarding</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-enterprise-settings" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive([\'settings\'])\n\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.Admin.canManageBureauSettings" ui-sref="settings.bureau.overview({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-settings m"></i>\n\t\t\t\t\t\t<span>Settings</span>\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Bureau -->\n\t\t<div ng-if="$ctrl.currentCompany.AgencyProfileID !== $root.CONFIG.paycircleBureauId" pc-switch-when="$ctrl.INTERFACE_TYPES.bureau">\n\n\t\t\t<!-- Default -->\n\t\t\t<div class="fadeIn">\n\n\t\t\t\t<!-- Go to previous company -->\n\t\t\t\t<div class="app-navigation_context" ng-if="$ctrl.companies.length > 1">\n\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-bureaus" href="" ng-click="$ctrl.goToPreviousCompany()">\n\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t<span class="app-navigation_context-title">Bureaus</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<nav class="app-navigation_menu" id="app-nav-bureau">\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-bureau-dashboard" ui-sref-active="is-active" ui-sref="dashboard({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-dashboard m"></i>\n\t\t\t\t\t\t<span>Dashboard</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-my-tasks" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'my-tasks\')\n\t\t\t\t\t\t}" ui-sref="my-tasks.workflow({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-tick-square m"></i>\n\t\t\t\t\t\t<span>My tasks</span>\n\t\t\t\t\t\t<span class="app-navigation_counter tag tertiary inverse" ng-class="{\n\t\t\t\t\t\t\t\t\'tada\': $root.userTasks\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="!$root.userTasks"></i>\n\t\t\t\t\t\t\t<span ng-if="$root.userTasks">{{$root.userTasks.dueCount | nineMax}}</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-workflow" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'workflow\')\n\t\t\t\t\t\t}" ui-sref="workflow.overview({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-workflow-alt m"></i>\n\t\t\t\t\t\t<span>Workflow</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item has-sub-menu" id="app-nav-bureau-companies" ng-class="{\n\t\t\t\t\t\t\t\'is-active\' : $ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\t\'companies-archived\',\n\t\t\t\t\t\t\t\t\'companies-cloned\'\n\t\t\t\t\t\t\t])}" ui-sref="companies({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-company m"></i>\n\t\t\t\t\t\t<span>Companies</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<nav class="app-navigation_sub-menu fadeIn" ng-if="$ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\'companies-archived\',\n\t\t\t\t\t\t\t\'companies-cloned\'\n\t\t\t\t\t\t])">\n\t\t\t\t\t\t<a class="app-navigation_sub-menu-item" id="app-nav-bureau-companies-archived" ui-sref-active="is-active" ui-sref="companies-archived({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_sub-menu-item" id="app-nav-bureau-companies-cloned" ui-sref-active="is-active" ui-sref="companies-cloned({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tClones\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-bureau-company-groups" ui-sref-active="is-active" ui-sref="company-groups({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-company-groups m"></i>\n\t\t\t\t\t\t<span>Company groups</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-reporting" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'reporting\')\n\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.isReportingVisible" title="Reporting" ui-sref="reporting.summary({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-stats m"></i>\n\t\t\t\t\t\t<span>Reporting</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-bureau-onboarding" ng-if="$root.currentUser.CanAccessOnboarding" ui-sref-active="is-active" ui-sref="bureau-onboarding({\n\t\t\t\t\t\t\tagencyProfileId:$root.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-rocket m"></i>\n\t\t\t\t\t\t<span>Onboarding</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-bureau-bureau-settings" ng-if="$root.currentUser.Permissions.Admin.canManageBureauSettings" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive([\'settings\'])\n\t\t\t\t\t\t}" ui-sref="settings.bureau.overview({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-settings m"></i>\n\t\t\t\t\t\t<span>Bureau settings</span>\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company Group -->\n\t\t<div pc-switch-when="$ctrl.INTERFACE_TYPES.group">\n\n\t\t\t<!-- Default -->\n\t\t\t<div class="fadeIn">\n\n\t\t\t\t<!-- Go to previous company -->\n\t\t\t\t<div class="app-navigation_context" ng-if="$ctrl.companies.length > 1">\n\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-company-groups" href="" ng-click="$ctrl.goToPreviousCompany()">\n\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t<span class="app-navigation_context-title">Company groups</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<nav class="app-navigation_menu" id="app-nav-company-group">\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-group-dashboard" ui-sref-active="is-active" ui-sref="dashboard({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-dashboard m"></i>\n\t\t\t\t\t\t<span>Dashboard</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item has-sub-menu" id="app-nav-group-companies" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\t\'companies-archived\'\n\t\t\t\t\t\t\t])\n\t\t\t\t\t\t}" ui-sref="companies({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-company m"></i>\n\t\t\t\t\t\t<span>Companies</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<nav class="app-navigation_sub-menu fadeIn" ng-if="$ctrl.isAnyStateActive([\n\t\t\t\t\t\t\t\'companies\',\n\t\t\t\t\t\t\t\'companies-archived\'\n\t\t\t\t\t\t])">\n\t\t\t\t\t\t<a class="app-navigation_sub-menu-item greyscale" id="app-nav-group-companies-archived" ui-sref-active="is-active" ui-sref="companies-archived({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-reporting" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'reporting\')\n\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.isReportingVisible" title="Reporting" ui-sref="reporting.summary({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-stats m"></i>\n\t\t\t\t\t\t<span>Reporting</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-group-settings" ng-if="$root.currentUser.Permissions.Admin.canManageCompanyGroupSettings" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive([\'settings\'])\n\t\t\t\t\t\t}" ui-sref="settings.group.overview({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-settings m"></i>\n\t\t\t\t\t\t<span>Group settings</span>\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company -->\n\t\t<div ng-switch-default>\n\n\t\t\t<!-- Normal Company -->\n\t\t\t<div ng-if="!$ctrl.currentCompany.IsPayslipManagerActive">\n\n\t\t\t\t<!-- Default -->\n\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.isAnyStateActive([\n\t\t\t\t\t\t\'payroll\',\n\t\t\t\t\t\t\'team\',\n\t\t\t\t\t\t\'hr\'\n\t\t\t\t\t])">\n\n\t\t\t\t\t<!-- Go to previous company -->\n\t\t\t\t\t<div class="app-navigation_context" ng-if="$ctrl.companies.length > 1">\n\t\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-companies" href="" ng-click="$ctrl.goToPreviousCompany()">\n\t\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t\t<span class="app-navigation_context-title">Companies</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<nav class="app-navigation_menu" id="app-nav-company">\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-dashboard" title="Dashboard" ui-sref-active="is-active" ui-sref="company-dashboard({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-dashboard m"></i>\n\t\t\t\t\t\t\t<span>Dashboard</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item has-child-menu" id="app-nav-company-payroll" ng-href="{{$ctrl.currentCompany.ngHref.payroll}}" ng-if="\n\t\t\t\t\t\t\t\t$root.currentUser.Permissions.isPayrollVisible ||\n\t\t\t\t\t\t\t\t$root.currentUser.Permissions.isHistoryVisible\n\t\t\t\t\t\t\t" title="Payroll" ui-sref-active="is-active">\n\t\t\t\t\t\t\t<i class="icon-clock m"></i>\n\t\t\t\t\t\t\t<span>Payroll</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-pension" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'pensions\')\n\t\t\t\t\t\t\t}" ng-if="\n\t\t\t\t\t\t\t\t$ctrl.currentCompany.IsPensionActive &&\n\t\t\t\t\t\t\t\t$root.currentUser.Permissions.isPensionVisible\n\t\t\t\t\t\t\t" title="Pensions" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-money m"></i>\n\t\t\t\t\t\t\t<span ng-class="{\n\t\t\t\t\t\t\t\t\t\'is-highlighted\': $ctrl.currentCompany.IsPensionActive && !$ctrl.currentCompany.HasPension\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tPensions\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item has-child-menu" id="app-nav-company-team" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'team\')\n\t\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.isTeamVisible" title="Team" ui-sref="team.members({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-user m"></i>\n\t\t\t\t\t\t\t<span>Team</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item has-child-menu" id="app-nav-company-hr" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive(\'hr\')\n\t\t\t\t\t\t\t}" ng-if="\n\t\t\t\t\t\t\t\t$root.currentUser.Permissions.isHRVisible &&\n\t\t\t\t\t\t\t\t$ctrl.currentCompany.IsHRActive\n\t\t\t\t\t\t\t" title="HR" ui-sref="hr.policies.sickness({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-team m"></i>\n\t\t\t\t\t\t\t<span>HR</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-reporting" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'reporting\')\n\t\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.isReportingVisible" title="Reporting" ui-sref="reporting.summary({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-stats m"></i>\n\t\t\t\t\t\t\t<span>Reporting</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-company" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isStateActive(\'settings\')\n\t\t\t\t\t\t\t}" ng-if="\n\t\t\t\t\t\t\t\t$ctrl.currentCompany.CanAccessCompanySettings &&\n\t\t\t\t\t\t\t\t$root.currentUser.Permissions.isCompanySettingsVisible\n\t\t\t\t\t\t\t" title="Company" ui-sref="settings.company.overview({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-settings m"></i>\n\t\t\t\t\t\t\t<span>Settings</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company > Payroll -->\n\t\t\t\t<div class="fadeIn" ng-if="$ctrl.isStateActive(\'payroll\')">\n\n\t\t\t\t\t<!-- Go to dashboard -->\n\t\t\t\t\t<div class="app-navigation_context">\n\t\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-dashboard" ui-sref-active="is-active" ui-sref="company-dashboard({agencyProfileId: $ctrl.currentCompany.AgencyProfileID})">\n\t\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t\t<span class="app-navigation_context-title">Payroll</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<nav class="app-navigation_menu" id="app-nav-company-payroll">\n\t\t\t\t\t\t<a class="app-navigation_menu-item" ng-if="$root.currentUser.Permissions.isPayrollVisible && !$ctrl.currentCompany.IsArchived" id="app-nav-company-payroll-current-period" ng-class="{\'is-active\': $ctrl.isAnyStateActive([\'payroll.current-period\', \'payroll.run-payroll\'])}" ng-href="{{$ctrl.currentCompany.ngHref.payroll}}" ui-sref-active="is-active">\n\t\t\t\t\t\t\tCurrent period\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-future-changes" ng-if="$root.currentUser.Permissions.isPayrollVisible && !$ctrl.currentCompany.IsArchived" ui-sref-active="is-active" ui-sref="payroll.future-changes({agencyProfileId: $ctrl.currentCompany.AgencyProfileID})">\n\t\t\t\t\t\t\tFuture changes\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-history" ng-class="{\n\t\t\t\t\t\t\t\t\'is-active\': $ctrl.isAnyStateActive($ctrl.PAYROLL_HISTORY_STATES)\n\t\t\t\t\t\t\t}" ng-if="$root.currentUser.Permissions.isHistoryVisible" ui-sref="payroll.history.pay-periods({agencyProfileId: $ctrl.currentCompany.AgencyProfileID})">\n\t\t\t\t\t\t\tHistory\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company > Team -->\n\t\t\t\t<div class="fadeIn" ng-if="$ctrl.isStateActive(\'team\')">\n\n\t\t\t\t\t<!-- Go to dashboard -->\n\t\t\t\t\t<div class="app-navigation_context">\n\t\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-dashboard" ng-if="!$root.userHasRole(\'departmentadmin\')" ui-sref-active="is-active" ui-sref="company-dashboard({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t\t<span class="app-navigation_context-title">Team</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<nav id="app-nav-company-team" class="app-navigation_menu">\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-team-members" ui-sref-active="is-active" ui-sref="team.members({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tTeam members\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-team-leavers" ui-sref-active="is-active" ui-sref="team.leavers({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tLeavers\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-team-moved-payrolls" ng-if="!$root.userHasRole(\'departmentadmin\')" ui-sref-active="is-active" ui-sref="team.moved-payrolls({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tMoved payrolls\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-team-imports" ng-if="!$root.userHasRole(\'departmentadmin\')" ui-sref-active="is-active" ui-sref="team.imports({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tImports\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" ng-if="($ctrl.currentCompany.IsPeopleHRIntegrationEnabled || $ctrl.currentCompany.IsEdpIntegrationEnabled) && !$root.userHasRole(\'departmentadmin\')" ui-sref-active="is-active" ui-sref="team.people-hr-updates({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tPeopleHR updates\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" data-cy="app-navigation_rotaready-updates" ng-if="$ctrl.currentCompany.IsRotareadyIntegrationEnabled && !$root.userHasRole(\'departmentadmin\')" ui-sref-active="is-active" ui-sref="team.rotaready-updates({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tRotaready updates\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company > HR -->\n\t\t\t\t<div class="fadeIn" ng-if="$ctrl.isStateActive(\'hr\')">\n\n\t\t\t\t\t<!-- Go to dashboard -->\n\t\t\t\t\t<div class="app-navigation_context">\n\t\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-dashboard" ui-sref-active="is-active" ui-sref="company-dashboard({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t\t<span class="app-navigation_context-title">HR</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<nav class="app-navigation_menu" id="app-nav-company-team">\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-hr-policies" ng-class="{\'is-active\': $ctrl.isStateActive(\'hr.policies\')}" ui-sref="hr.policies.sickness({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tPolicies\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-job-grades" ui-sref-active="is-active" ui-sref="hr.job-grades({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tJob grades\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-hr-holiday-sickness" ui-sref-active="is-active" ui-sref="hr.holiday-sickness({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tHoliday and sickness\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-hr-imports" ui-sref-active="is-active" ui-sref="hr.imports({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tImports\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Payslip Manager Company -->\n\t\t\t<div ng-if="$ctrl.currentCompany.IsPayslipManagerActive">\n\n\t\t\t\t<!-- Go to previous company -->\n\t\t\t\t<div class="app-navigation_context" ng-if="$ctrl.companies.length > 1">\n\t\t\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-companies" href="" ng-click="$ctrl.goToPreviousCompany()">\n\t\t\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t\t\t<span class="app-navigation_context-title">Companies</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<nav class="app-navigation_menu" id="app-nav-payslip-company">\n\t\t\t\t\t<a class="app-navigation_menu-item" ui-sref-active="is-active" id="app-nav-company-payslip-manager" title="Team manager" ui-sref="payslip-manager({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-payslip m"></i>\n\t\t\t\t\t\t<span>Payslip manager</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="app-navigation_menu-item" id="app-nav-company-team" ng-class="{\'is-active\': $ctrl.isStateActive(\'team\')}" ng-if="$root.currentUser.Permissions.isTeamVisible" title="Team" ui-sref="team.manager({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\t<i class="icon-team-alt m"></i>\n\t\t\t\t\t\t<span>Team manager</span>\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<!-- User -->\n\t<div pc-switch-when="$ctrl.NAVIGATION_STATES.accountSettings">\n\n\t\t<div class="app-navigation_context">\n\t\t\t<a class="app-navigation_context-reset" data-cy="app-navigation_back-to-previous-page" ui-sref-active="is-active" ng-click="$ctrl.goToDefaultLandingPageForUser($root.currentUser)">\n\t\t\t\t<i class="icon-chevron-left app-navigation_context-icon"></i>\n\t\t\t\t<span class="app-navigation_context-title">Account Settings</span>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<nav class="app-navigation_menu" id="app-nav-account-settings">\n\t\t\t<a class="app-navigation_menu-item" id="app-nav-user-settings" ui-sref-active="is-active" ui-sref="account-settings({\n\t\t\t\t\tuserId: $root.currentUser.UserResponseUserID,\n\t\t\t\t\tagencyProfileId: $root.currentUser.AgencyProfileID\n\t\t\t\t})">\n\t\t\t\tSettings\n\t\t\t</a>\n\t\t</nav>\n\t</div>\n\n\t<!-- Sub Navigation -->\n\t<div class="app-navigation_secondary-menu">\n\t\t<a class="app-navigation_secondary-menu-item" data-cy="app-navigation_sub-menu_help-and-support" href="" ng-if="$root.userHasRole([$ctrl.USER_ROLES.paycircle, $ctrl.USER_ROLES.bureaumanager, $ctrl.USER_ROLES.bureau])" ui-ref-active="is-active" ui-sref-opts="{reload: true}" ui-sref="help-and-support({agencyProfileId: $ctrl.currentCompany.AgencyProfileID, articleKey: \'\', categoryId: \'\'})">\n\t\t\tHelp and Support\n\t\t</a>\n\t\t<a class="app-navigation_secondary-menu-item" data-cy="app-navigation_sub-menu_community-forum" ng-href="{{$root.URLS.paycircle.communityForum.aha}}" ng-if="!$root.userHasRole([$ctrl.USER_ROLES.companyadministratorlite, $ctrl.USER_ROLES.groupadminlite])" target="_blank">\n\t\t\tPaycircle Ideas Portal\n\t\t</a>\n\t\t<a class="app-navigation_secondary-menu-item" data-cy="app-navigation_sub-menu_blog" href="" ng-href="{{$root.CONFIG.blogUrl}}" target="_blank">\n\t\t\tBlog\n\t\t</a>\n\t\t<a class="app-navigation_secondary-menu-item" data-cy="app-navigation_sub-menu_privacy" href="" ng-href="{{$root.URLS.paycircle.website.privacy}}" target="_blank">\n\t\t\tPrivacy\n\t\t</a>\n\t\t<a class="app-navigation_secondary-menu-item" data-cy="app-navigation_sub-menu_cookie-policy" href="" ng-href="{{$ctrl.externalUrls.policyUrls.cookiePolicy}}" target="_blank">\n\t\t\tOur Cookie Policy\n\t\t</a>\n\t\t<span class="app-navigation_version-label">v{{::$root.CONFIG.version}}</span>\n\t</div>\n\n\t<div class="app-navigation_tools" ng-if="$root.isDevelopment">\n\t\t<paycircle-permission-tool current-user="$root.currentUser"></paycircle-permission-tool>\n\t</div>\n</div>\n');
$templateCache.put('components/app-side-bar/app-side-bar.component.html','<div class="app-side-bar" ng-switch="$ctrl.sideBarOptions.activeMenu">\n\n\t<div class="app-side-bar_header">\n\t\t<h4 class="app-side-bar_title">\n\t\t\t{{$ctrl.sideBarOptions.title}}\n\t\t</h4>\n\t\t<a aria-label="Close side bar" class="is-primary app-side-bar_toggle" href="" ng-click="$ctrl.onCloseSidebarMenu()">\n\t\t\t<i class="icon-chevron-right"></i>\n\t\t</a>\n\t</div>\n\n\t<!-- Activity -->\n\t<div class="app-side-bar_content" ng-switch-when="activity">\n\t\t<company-activity agency-profile-id="$ctrl.sideBarOptions.currentCompany.AgencyProfileID" side-bar-options="$ctrl.sideBarOptions"></company-activity>\n\t</div>\n\n\t<!-- Onboarding -->\n\t<div class="app-side-bar_content" ng-switch-when="onboarding">\n\t\t<company-onboarding-status agency-profile-id="$ctrl.sideBarOptions.currentCompany.AgencyProfileID" side-bar-options="$ctrl.sideBarOptions"></company-onboarding-status>\n\t</div>\n\n</div>\n');
$templateCache.put('components/app-user-message-bar/app-user-message-bar.component.html','<div class="app-user-message-bar" ng-if="$ctrl.userMessageBarState" ng-switch="$ctrl.userMessageBarState">\n\n\t<!-- Viewing role permissions -->\n\t<div pc-switch-when="$ctrl.USER_MESSAGE_BAR_STATES.viewingRolePermisisons" class="app-user-message-bar_layout">\n\t\t<div class="app-user-message-bar_content">\n\t\t\t<i class="icon-binoculars l"></i>&nbsp;&nbsp;\n\t\t\t<span>You are viewing as a</span>&nbsp;&nbsp;\n\t\t\t<span class="tag l quarternary"><i class="icon-roles"></i>&nbsp;&nbsp;&nbsp;{{$root.currentUser.viewingAs.roleType | roleTypeMeta:\'name\'}}</span>\n\t\t</div>\n\n\t\t<a class="app-user-message-bar_action link-with-icon" href="" ng-click="$ctrl.disableAdminViewMode()"><i class="icon-back"></i> Exit admin view</a>\n\t</div>\n\n\t<!-- Viewing user permissions -->\n\t<div pc-switch-when="$ctrl.USER_MESSAGE_BAR_STATES.viewingUserPermissions" class="app-user-message-bar_layout">\n\t\t<div class="app-user-message-bar_content">\n\t\t\t<i class="icon-binoculars l"></i>&nbsp;&nbsp;\n\t\t\t<span>You are viewing as <strong>{{$root.currentUser.viewingAs.name}}</strong></span>&nbsp;&nbsp;\n\t\t\t<span class="tag l quarternary"><i class="icon-roles"></i>&nbsp;&nbsp;&nbsp;{{$root.currentUser.viewingAs.roleType | roleTypeMeta:\'name\'}}</span>\n\t\t</div>\n\n\t\t<a class="app-user-message-bar_action link-with-icon" href="" ng-click="$ctrl.disableAdminViewMode()"><i class="icon-back"></i> Exit admin view</a>\n\t</div>\n\n\t<!-- Timeout warning -->\n\t<div pc-switch-when="$ctrl.USER_MESSAGE_BAR_STATES.timeoutWarning" class="app-user-message-bar_layout is-long-warning" ng-hide="$ctrl.timeoutWarningTimeContraint && $ctrl.timeoutWarningTimeContraintExpired">\n\t\t<div class="app-user-message-bar_content">\n\t\t\t<div class="app-user-message-bar_icon">\n\t\t\t\t<i class="icon-warning l"></i>&nbsp;&nbsp;\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\tIMPORTANT UPDATE: {{$root.CONFIG.appTimeoutMessage}}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/arc-de-chart/arcDeChartComponent.html','<div class="arc-de-chart">\n\t<span class="arc-de-chart-wrapper" style="transform: scale({{arcScale}})">\n\t\t<svg class="arc-de-chart-svg" width="200" height="200" viewBox="0 0 300 300" preserveAspectRatio="xMinYMin meet">\n\t\t\t<circle class="arc-de-chart-circle-plot" stroke="{{barColor}}" stroke-width="{{strokeWidth}}" fill="transparent" stroke-linecap="round" r="125" cx="150" cy="150" style="stroke-dashoffset: 200;"></circle>\n\t\t\t<circle class="arc-de-chart-circle-bar" stroke="{{barColor}}" stroke-width="{{strokeWidth}}" fill="transparent" stroke-linecap="round" r="125" cx="150" cy="150" style="stroke-dashoffset: {{displayValue >= 200 ? displayValue : 200}};"></circle>\n\t\t</svg>\n\t</span>\n</div>\n');
$templateCache.put('components/avatar/avatar.component.html','<div class="avatar" data-cy="avatar-{{$ctrl.avatarInitial}}" ng-class="[$ctrl.avatarTheme, $ctrl.avatarSize]">\n\t<div class="avatar_fallback">\n\t\t<h6 class="avatar_initial">{{$ctrl.avatarInitial}}</h6>\n\t\t<div class="avatar_fallback-background"></div>\n\t</div>\n\n\t<!--\n\t<div class="avatar__media">\n\t\t<img class="avatar__image" ng-src="{{$ctrl.avatarUrl}}" alt="{{$ctrl.avatarInitial}}" />\n\t</div>\n\t-->\n</div>\n');
$templateCache.put('components/bacs-card/bacs-card.component.html','<div class="bacs-card fadeIn" ng-class="{selected: $ctrl.bacsFile.isSelected}" ng-mouseleave="$ctrl.hideMenu($ctrl)">\n\n\t<div class="bacs-card_disabled fadeIn" ng-if="$ctrl.bacsFile.isLoading">\n\t\t<circle-loader></circle-loader>\n\t</div>\n\n\t<div class="bacs-card_header">\n\t\t<div class="bacs-card_checkbox">\n\t\t\t<div class="checkbox-field">\n\t\t\t\t<input aria-label="Select {{::$ctrl.bacsFile.CompanyName}}" type="checkbox" id="{{$ctrl.bacsFile.AgencyDocumentID}}" ng-model="$ctrl.bacsFile.isSelected" ng-change="$ctrl.onCheckboxToggle($ctrl.bulkItems)">\n\t\t\t\t<label class="checkbox-field-tickbox" for="{{$ctrl.bacsFile.AgencyDocumentID}}"></label>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="bacs-card_content">\n\t\t\t<div class="bacs-card_detail">\n\t\t\t\t<h6><a ui-sref="company-dashboard({agencyProfileId: $ctrl.bacsFile.AgencyProfileID})">{{$ctrl.bacsFile.CompanyName}}</a></h6>\n\t\t\t\t<p class="bacs-card_period is-small">{{$ctrl.bacsFile.PeriodDisplayDate}}</p>\n\t\t\t</div>\n\n\t\t\t<span class="tag primary-lighter" ng-if="$ctrl.bacsFile.HasBeenRegenerated">Regenerated</span>\n\t\t</div>\n\n\t\t<div class="bacs-card_stat">\n\t\t\t<p class="bacs-card_filename greyscale-dark s">{{$ctrl.bacsFile.FileName}}</p>\n\t\t\t<p class="bacs-card_text is-small">File</p>\n\t\t</div>\n\n\t\t<div class="bacs-card_stat">\n\t\t\t<p class="greyscale-dark is-small">{{$ctrl.bacsFile.PaymentDateISO | dateformat }}</p>\n\t\t\t<p class="bacs-card_text is-small">Payment date</p>\n\t\t</div>\n\n\t\t<div class="bacs-card_stat">\n\t\t\t<p class="greyscale-dark is-small" ng-if="$ctrl.bacsFile.BACSFileValue === -1">View receipt file</p>\n\t\t\t<p class="greyscale-dark is-small" ng-if="$ctrl.bacsFile.BACSFileValue > 0">{{$ctrl.bacsFile.BACSFileValue | monetise }}</p>\n\t\t\t<p class="bacs-card_text is-small">Total value</p>\n\t\t</div>\n\n\t\t<div class="bacs-card_menu">\n\t\t\t<dropdown-menu menu-size="m" menu-theme="primary" menu-show-chevron="false" menu-icon="icon-setup" menu-show="$ctrl.showMenu">\n\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" ng-click="$ctrl.downloadBacsFile($ctrl)">Download</a>\n\t\t\t\t\t<a href="" ng-if="$ctrl.bacsFile.State !== $ctrl.DOCUMENT_STATES.available" ng-click="$ctrl.updateBacsDocumentState($ctrl, $ctrl.DOCUMENT_STATES.available)">Move to \u2018Available\u2019</a>\n\t\t\t\t\t<a href="" ng-if="$ctrl.bacsFile.State !== $ctrl.DOCUMENT_STATES.pending" ng-click="$ctrl.updateBacsDocumentState($ctrl, $ctrl.DOCUMENT_STATES.pending)">Move to \u2018Pending\u2019</a>\n\t\t\t\t\t<a href="" ng-if="$ctrl.bacsFile.State !== $ctrl.DOCUMENT_STATES.processed" ng-click="$ctrl.updateBacsDocumentState($ctrl, $ctrl.DOCUMENT_STATES.processed)">Move to \u2018Processed\u2019</a>\n\t\t\t\t</div>\n\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<div class="bacs-card_footer" ng-if="$ctrl.bacsFile.LastUpdatedBy">\n\t\t<div class="bacs-card_avatar">\n\t\t\t<avatar class="admin-card__avatar" avatar-initial="{{$ctrl.bacsFile.LastUpdatedBy[0]}}" avatar-size="is-tiny"></avatar>\n\t\t</div>\n\n\t\t<div class="bacs-card_actioner">\n\t\t\t<p class="bacs-card_text is-small italic">\n\t\t\t\tMoved to \u2018{{$ctrl.bacsFile.documentStateDescription}}\u2019 by {{$ctrl.bacsFile.LastUpdatedBy}} at {{$ctrl.bacsFile.LastUpdatedDateISO | datetimeformat:\'readable\'}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/bacs-disbursement/bacs-disbursement.component.html','<fieldset>\n\n\t<!-- Don\'t show for HMRC Payments -->\n\t<fieldset ng-if="!$ctrl.isHmrcPayment">\n\n\t\t<!-- Account name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.formId}}-bankAccountName" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled,\n\t\t\t\t\t\t\'required\' : $ctrl.bacsEnabled && !$ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\tAccount name:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.formId}}-bankAccountName" name="{{$ctrl.formId}}-bankAccountName" ng-disabled="$ctrl.disabled" ng-model="$ctrl.disbursement.BankInfo.BankAccountName" ng-pattern="$root.REGEX.lettersAndNumbers" ng-required="$ctrl.bacsEnabled && !$ctrl.disabled" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-bankAccountName\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-bankAccountName\'].$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a bank account name.</p>\n\t\t\t\t<p ng-message="pattern">Please enter numbers and letters only</p>\n\t\t\t</div>\n\t\t\t<p class="form-message" ng-if="$ctrl.isAoePayment">\n\t\t\t\tNormally the name of the council issuing the order\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Account Number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.formId}}-bankAccountNumber" ng-class="{\n\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled,\n\t\t\t\t\t\t\t\'required\' : $ctrl.bacsEnabled && !$ctrl.disabled\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tAccount number:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="m" id="{{$ctrl.formId}}-bankAccountNumber" maxlength="8" name="{{$ctrl.formId}}-bankAccountNumber" ng-disabled="$ctrl.disabled" ng-maxlength="8" ng-minlength="8" ng-model="$ctrl.disbursement.BankInfo.BankAccountNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="$ctrl.bacsEnabled && !$ctrl.disabled" placeholder="12345678" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-bankAccountNumber\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-bankAccountNumber\'].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a bank account number</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 8 digits</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\t8 digits, no symbols\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Sort code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="{{$ctrl.formId}}-sortCode" ng-class="{\n\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled,\n\t\t\t\t\t\t\t\'required\' : $ctrl.bacsEnabled && !$ctrl.disabled\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tSort code:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<sort-code sort-code-disabled="$ctrl.disabled" sort-code-name="{{$ctrl.formId}}-sortcode" sort-code-required="$ctrl.bacsEnabled && !$ctrl.disabled" sort-code="$ctrl.disbursement.BankInfo.SortCode"></sort-code>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-sortcode\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-sortcode\'].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\t6 digits, no symbols\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- IBAN -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.formId}}-bankIBAN" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\tIBAN:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.formId}}-bankIBAN" maxlength="50" name="{{$ctrl.formId}}-bankIBAN" ng-model="$ctrl.disbursement.BankInfo.BankIBAN" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- BIC -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="bankBIC" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\tBIC:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="{{$ctrl.formId}}-bankBIC" name="{{$ctrl.formId}}-bankBIC" ng-model="$ctrl.disbursement.BankInfo.BankBIC" ng-pattern="$root.REGEX.bic" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-bankBIC\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-bankBIC\'].$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid BIC</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="{{$ctrl.formId}}-bacsPaymentReference" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\tPayment reference:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.formId}}-bacsPaymentReference" name="{{$ctrl.formId}}-bacsPaymentReference" ng-disabled="$ctrl.disabled" ng-model="$ctrl.disbursement.BankInfo.BACSPaymentReference" ng-pattern="$root.REGEX.description" ng-required="!$ctrl.disabled" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.bacsPaymentReference + \'-bankAccountNumber\'].$touched" ng-messages="$ctrl.form[$ctrl.bacsPaymentReference + \'-bankAccountNumber\'].$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a payment reference</p>\n\t\t\t\t<p ng-message="pattern">Please enter letters, numbers and basic symbols only</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- HMRC: Payment Details -->\n\t<fieldset ng-if="$ctrl.isHmrcPayment">\n\n\t\t<div class="stat-list primary plain-text">\n\t\t\t<p class="stat-list__header is-small">\n\t\t\t\tPayments to HMRC go to the following bank account:\n\t\t\t</p>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Account name:</span>\n\t\t\t\t<span class="stat-list__value">{{$ctrl.hmrcBankAccount.accountName}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Sort code:</span>\n\t\t\t\t<span class="stat-list__value">{{$ctrl.hmrcBankAccount.sortCode}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Account number:</span>\n\t\t\t\t<span class="stat-list__value">{{$ctrl.hmrcBankAccount.accountNumber}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__footer">Please note that the Accounts Office Reference for {{$ctrl.companyName}} will be used as the payment reference.</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- BACS Enabled -->\n\t<fieldset ng-if="$ctrl.bacsEnabled">\n\t\t\t<div class="form-intro" ng-class="{\n\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t}">\n\n\t\t\t\t<h4 ng-if="$ctrl.showBacsTitle">BACS</h4>\n\n\t\t\t\t<!-- Show for non-hmrc payments or when HMRC payment isn\'t in a biannual or annual payroll -->\n\t\t\t\t<p ng-if="\n\t\t\t\t\t!$ctrl.isHmrcPayment ||\n\t\t\t\t\t$ctrl.isHmrcPayment &&\n\t\t\t\t\t![\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.biannually,\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.annually\n\t\t\t\t\t].includes($ctrl.payPeriod.PeriodType)">\n\t\t\t\t\tBy default, these payments will be included in your main BACS file.\n\t\t\t\t\tYou can create a separate BACS file with a different payment date below.\n\t\t\t\t</p>\n\n\t\t\t\t<!-- Show when HMRC payment is in a biannual or annual payroll  -->\n\t\t\t\t<p ng-if="\n\t\t\t\t\t$ctrl.isHmrcPayment &&\n\t\t\t\t\t[\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.biannually,\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.annually\n\t\t\t\t\t].includes($ctrl.payPeriod.PeriodType)">\n\t\t\t\t\tYour pay frequency is set to {{$ctrl.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} in your payroll settings.\n\t\t\t\t\tBy default, these payments will be included in your main BACS file.\n\t\t\t\t\tYou can create a separate BACS file with a different payment date below.\n\t\t\t\t</p>\n\n\t\t\t</div>\n\n\t\t<!-- Create separate BACS file -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-disabled="$ctrl.disabled" field-label="Create separate BACS file" field-model="$ctrl.disbursement.SeparateBACS" field-name="{{$ctrl.formId}}-separateBacs" field-on-change="$ctrl.onSeparateBACSChange()"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn" ng-if="$ctrl.disbursement.SeparateBACS">\n\n\t\t\t<fieldset ng-if="!$ctrl.isHmrcPayment">\n\t\t\t\t<div class="form-intro" ng-class="{\n\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t}">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tYour pay frequency is set to {{$ctrl.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} in your payroll settings,\n\t\t\t\t\t\tand your next pay day will be {{$ctrl.payPeriod.PayDateISO | dateformat:\'full\'}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- BACS Payment Date options -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-bacsPaymentDateOption" ng-class="{\n\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tHow do you want to set up the BACS payment date?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list radio-list--inline" ng-switch="$ctrl.payPeriod.PeriodType">\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-bacsPaymentDateOption-relative" name="{{$ctrl.formId}}-bacsPaymentDateOption" ng-change="$ctrl.resetPaymentOptions()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.bacsPaymentDateOption" ng-value="$ctrl.DISBURSEMENT_CONTEXT_TYPES.relativeDays" type="radio">\n\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-relative">Relative to pay frequency</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item" pc-switch-when="[\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.monthly,\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.weekly,\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.fortnightly,\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.fourweekly\n\t\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-bacsPaymentDateOption-recurring" name="{{$ctrl.formId}}-bacsPaymentDateOption" ng-change="$ctrl.resetPaymentOptions()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.bacsPaymentDateOption" ng-value="$ctrl.DISBURSEMENT_CONTEXT_TYPES.dayOfMonth" type="radio">\n\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-recurring">Recurring day of the month</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item" pc-switch-when="[\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.quarterly,\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.biannually,\n\t\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.annually]">\n\t\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-bacsPaymentDateOption-specific" name="{{$ctrl.formId}}-bacsPaymentDateOption" ng-change="$ctrl.resetPaymentOptions()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.bacsPaymentDateOption" ng-value="$ctrl.DISBURSEMENT_CONTEXT_TYPES.paymentDates" type="radio">\n\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-specific" ng-if="$ctrl.payPeriod.PeriodType !== $ctrl.PAY_PERIOD_TYPES.annually">\n\t\t\t\t\t\t\t\t\tSpecific dates\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-specific" ng-if="$ctrl.payPeriod.PeriodType === $ctrl.PAY_PERIOD_TYPES.annually">\n\t\t\t\t\t\t\t\t\tSpecific date\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- HMRC: Payment frequency -->\n\t\t\t<div class="form-field" ng-if="\n\t\t\t\t\t$ctrl.isHmrcPayment &&\n\t\t\t\t\t![\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.biannually,\n\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.annually\n\t\t\t\t\t].includes($ctrl.payPeriod.PeriodType)\n\t\t\t\t">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-bacsPaymentDateOption">\n\t\t\t\t\t\tHow frequently do you pay HMRC?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-list radio-list--inline is-not-spaced">\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-bacsPaymentDateOption-monthly" name="{{$ctrl.formId}}-bacsPaymentDateOption" ng-change="$ctrl.resetPaymentOptions()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.bacsPaymentDateOption" ng-value="$ctrl.DISBURSEMENT_CONTEXT_TYPES.dayOfMonth" type="radio">\n\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-monthly">Monthly</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-bacsPaymentDateOption-quarterly" name="{{$ctrl.formId}}-bacsPaymentDateOption" ng-change="$ctrl.resetPaymentOptions()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.bacsPaymentDateOption" ng-value="$ctrl.DISBURSEMENT_CONTEXT_TYPES.paymentDates" type="radio">\n\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-bacsPaymentDateOption-quarterly">Quarterly</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset ng-switch="$ctrl.bacsPaymentDateOption">\n\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.DISBURSEMENT_CONTEXT_TYPES.relativeDays">\n\n\t\t\t\t\t<!-- Relative Payment date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" ng-class="{\n\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tPayment date:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-list contains-input">\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-relativeDateOption-afterPayDay" name="{{$ctrl.formId}}-relativeDateOption-afterPayDay" ng-disabled="$ctrl.disabled" ng-model="$ctrl.relativeOptions.state" ng-value="$ctrl.RELATIVE_PAYMENT_OPTIONS.afterPayDay" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-relativeDateOption-afterPayDay">&nbsp;</label>\n\n\t\t\t\t\t\t\t\t\t<number-selector-field class="s" field-name="{{$ctrl.formId}}-afterDayCount" ng-disabled="$ctrl.disabled || $ctrl.relativeOptions.state !== $ctrl.RELATIVE_PAYMENT_OPTIONS.afterPayDay" ng-model-options="{\n\t\t\t\t\t\t\t\t\t\t\tdebounce:400\n\t\t\t\t\t\t\t\t\t\t}" ng-model="$ctrl.relativeOptions.afterDayCount" nsf-on-change="$ctrl.updateDisbursementRelativeDays()" step="1"></number-selector-field>\n\t\t\t\t\t\t\t\t\t<span>&nbsp;days after pay day</span>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" id="{{$ctrl.formId}}-relativeDateOption-onPayDay" name="{{$ctrl.formId}}-relativeDateOption-onPayDay" ng-change="$ctrl.updateDisbursementRelativeDays()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.relativeOptions.state" ng-value="$ctrl.RELATIVE_PAYMENT_OPTIONS.onPayDay" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="{{$ctrl.formId}}-relativeDateOption-onPayDay">&nbsp;on pay day</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.DISBURSEMENT_CONTEXT_TYPES.dayOfMonth">\n\n\t\t\t\t\t<!-- Recurring Payment date  -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-dayOfMonth" ng-class="{\n\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tPayment date:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select class="l-alt" id="{{$ctrl.formId}}-dayOfMonth" name="{{$ctrl.formId}}-dayOfMonth" ng-disabled="$ctrl.disabled" ng-model="$ctrl.disbursement.DayOfMonth" ng-options="option.id as option.name for option in $ctrl.recuringOptions" ng-required="!$ctrl.disabled">\n\t\t\t\t\t\t\t\t <option value="" selected="selected" hidden disabled="disabled">Select a date\u2026</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" ng-switch="$ctrl.payPeriod.PeriodType" pc-switch-when="$ctrl.DISBURSEMENT_CONTEXT_TYPES.paymentDates">\n\n\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t<!-- Specific Payment date (1) -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-date1ISO" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t\t}" ng-switch="$ctrl.payPeriod.PeriodType">\n\t\t\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.PAY_PERIOD_TYPES.annually">Payment date:</span>\n\t\t\t\t\t\t\t\t\t<span ng-switch-default>Payment date 1:</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-disabled="$ctrl.disabled" field-id="{{$ctrl.formId}}-date1ISO" field-min-date-iso="$ctrl.payPeriod.PayDateISO" field-on-change="$ctrl.updatePaymentDateValidation" field-required="!$ctrl.disabled" field-value-iso="$ctrl.disbursement.Date1ISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-date1ISO\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-date1ISO\'].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the first payment date</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after the current pay date ({{$ctrl.payPeriod.PayDateISO | dateformat}})</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Specific Payment date (2) -->\n\t\t\t\t\t\t<div class="form-field" pc-switch-when="[\n\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.biannually,\n\t\t\t\t\t\t\t\t$ctrl.PAY_PERIOD_TYPES.quarterly\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t<div class="form-field-header" for="{{$ctrl.formId}}-date2ISO">\n\t\t\t\t\t\t\t\t<label class="required" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tPayment date 2:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-disabled="$ctrl.disabled" field-id="{{$ctrl.formId}}-date2ISO" field-max-date-iso="$ctrl.paymentDateValidation.date2.maxIso" field-min-date-iso="$ctrl.paymentDateValidation.date2.minIso" field-required="!$ctrl.disabled" field-value-iso="$ctrl.disbursement.Date2ISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-date2ISO\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-date2ISO\'].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the second payment date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{$ctrl.paymentDateValidation.date2.minIso | dateformat}} and {{$ctrl.paymentDateValidation.date2.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field-group" pc-switch-when="$ctrl.PAY_PERIOD_TYPES.quarterly">\n\n\t\t\t\t\t\t<!-- Specific Payment date (3 -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-date3ISO" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tPayment date 3:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-disabled="$ctrl.disabled" field-id="{{$ctrl.formId}}-date3ISO" field-max-date-iso="$ctrl.paymentDateValidation.date3.maxIso" field-min-date-iso="$ctrl.paymentDateValidation.date3.minIso" field-required="!$ctrl.disabled" field-value-iso="$ctrl.disbursement.Date3ISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-date3ISO\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-date3ISO\'].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the third payment date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{$ctrl.paymentDateValidation.date3.minIso | dateformat}} and {{$ctrl.paymentDateValidation.date3.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Specific Payment date (4) -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="{{$ctrl.formId}}-date4ISO" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'disabled\' : $ctrl.disabled\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tPayment date 4:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-disabled="$ctrl.disabled" field-id="{{$ctrl.formId}}-date4ISO" field-max-date-iso="$ctrl.paymentDateValidation.date4.maxIso" field-min-date-iso="$ctrl.paymentDateValidation.date4.minIso" field-required="!$ctrl.disabled" field-value-iso="$ctrl.disbursement.Date4ISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.formId + \'-date4ISO\'].$touched" ng-messages="$ctrl.form[$ctrl.formId + \'-date4ISO\'].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the forth payment date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{$ctrl.paymentDateValidation.date4.minIso | dateformat}} and {{$ctrl.paymentDateValidation.date4.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Invalid payment date behaviour -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="selectField" class="required">\n\t\t\t\t\t\tWhen the payment date falls on a weekend or Bank Holiday:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="l-alt" id="{$ctrl.formId}}-invalidPaymentDateBehaviour" name="{$ctrl.formId}}-invalidPaymentDateBehaviour" ng-model="$ctrl.disbursement.InvalidPaymentDateBehaviour" ng-options="option.value as option.description for option in $ctrl.PAY_PERIOD_OFFSET_OPTIONS" required></select>\n\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t</option>\n\t\t\t\t\t\n\t\t\t\t</main>\n\t\t\t</div>\n\n\n\t\t</fieldset>\n\n\t</fieldset>\n\n</fieldset>\n');
$templateCache.put('components/bank-summary-card/bank-summary-card.component.html','<div class="bank-summary-card is-primary">\n\n\t<div class="bank-summary-card_header">\n\n\t\t<div class="bank-summary-card_title">\n\t\t\t<i class="icon-bank is-primary xl bank-summary-card_title-icon"></i>\n\t\t\t<h5>{{::$ctrl.bankTitle}}</h5>\n\t\t</div>\n\n\t\t<a href="" ng-click="$ctrl.onEdit()" class="is-large is-primary-light" aria-label="Edit bank"><i class="icon-edit"></i></a>\n\n\t</div>\n\n\t<div class="bank-summary-card_section">\n\n\t\t<div class="bank-summary-card_section-item">\n\t\t\t<p class="bank-summary-card_label">Account name</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.BankAccountName}}</p>\n\t\t</div>\n\n\t\t<div class="bank-summary-card_section-item is-logo" ng-if="$ctrl.bank.BankFileID && $ctrl.bank.BankFileID !== $root.CONFIG.guidEmpty">\n\t\t\t<img src="{{::$ctrl.bank | bankLogoUrl}}" alt="{{::$ctrl.bank.BankName | capitalise}}" height="80">\n\t\t</div>\n\t</div>\n\n\t<div class="bank-summary-card_section">\n\n\t\t<div class="bank-summary-card_section-item">\n\t\t\t<p class="bank-summary-card_label">Account number</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.BankAccountNumber}}</p>\n\t\t</div>\n\n\t\t<div class="bank-summary-card_section-item">\n\t\t\t<p class="bank-summary-card_label">Sort code</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.SortCode}}</p>\n\t\t</div>\n\n\t\t<div class="bank-summary-card_section-item" ng-if="$ctrl.bank.BankFileID && $ctrl.bank.BACSSUNNumber !== \'\'">\n\t\t\t<p class="bank-summary-card_label">SUN number</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.BACSSUNNumber}}</p>\n\t\t</div>\n\n\t\t<div class="bank-summary-card_section-item" ng-if="$ctrl.bank.bacsPaymentDateIso">\n\t\t\t<p class="bank-summary-card_label">Payment date</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.bacsPaymentDateIso | dateformat}}</p>\n\t\t</div>\n\t</div>\n\n\t<!-- International -->\n\t<div class="bank-summary-card_section is-aligned-start">\n\t\t<div class="bank-summary-card_section-item is-width-fixed-medium">\n\t\t\t<p class="bank-summary-card_label">IBAN</p>\n\t\t\t<p class="bank-summary-card_value" ng-if="::$ctrl.bank.BankIBAN">\n\t\t\t\t{{::$ctrl.bank.BankIBAN}}\n\t\t\t</p>\n\t\t\t<p class="bank-summary-card_value is-value-empty" ng-if="::!$ctrl.bank.BankIBAN">\n\t\t\t\tNot added\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="bank-summary-card_section-item">\n\t\t\t<p class="bank-summary-card_label">BIC</p>\n\t\t\t<p class="bank-summary-card_value" ng-if="::$ctrl.bank.BankBIC">\n\t\t\t\t{{::$ctrl.bank.BankBIC}}\n\t\t\t</p>\n\t\t\t<p class="bank-summary-card_value is-value-empty" ng-if="::!$ctrl.bank.BankBIC">\n\t\t\t\tNot added\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- GDFF -->\n\t<div class="bank-summary-card_section" ng-if="($ctrl.bank.GdffClientIdentifier && $ctrl.bank.GdffClientIdentifier !== \'\') || ($ctrl.bank.GdffOriginatorsAccountNumber && $ctrl.bank.GdffOriginatorsAccountNumber !== \'\')">\n\n\t\t<div class="bank-summary-card_section-item is-width-fixed-medium" ng-if="$ctrl.bank.GdffClientIdentifier && $ctrl.bank.GdffClientIdentifier !== \'\'">\n\t\t\t<p class="bank-summary-card_label">Client identifier</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.GdffClientIdentifier}}</p>\n\t\t</div>\n\t\t\n\t\t<div class="bank-summary-card_section-item is-width-fixed-medium" ng-if="$ctrl.bank.GdffOriginatorsAccountNumber && $ctrl.bank.GdffOriginatorsAccountNumber !== \'\'">\n\t\t\t<p class="bank-summary-card_label">Customer account number</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.GdffOriginatorsAccountNumber}}</p>\n\t\t</div>\n\t</div>\n\n\t<!-- References -->\n\t<div class="bank-summary-card_section" ng-if="($ctrl.bank.BACSPaymentReference && $ctrl.bank.BACSPaymentReference !== \'\') || ($ctrl.bank.BankTemplateReference && $ctrl.bank.BankTemplateReference !== \'\')">\n\n\t\t<div class="bank-summary-card_section-item is-width-fixed-medium" ng-if="$ctrl.bank.BACSPaymentReference && $ctrl.bank.BACSPaymentReference !== \'\'">\n\t\t\t<p class="bank-summary-card_label">Payment reference</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.BACSPaymentReference}}</p>\n\t\t</div>\n\t\t\n\t\t<div class="bank-summary-card_section-item is-width-fixed-medium" ng-if="$ctrl.bank.BankTemplateReference && $ctrl.bank.BankTemplateReference !== \'\'">\n\t\t\t<p class="bank-summary-card_label">Template reference</p>\n\t\t\t<p class="bank-summary-card_value">{{$ctrl.bank.BankTemplateReference}}</p>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/birth-date-input/birth-date-input.component.html','<fieldset class="birth-date-input" role="group">\n\t<div class="birth-date-input_layout" id="{{::$ctrl.id}}">\n\n\t\t<!-- Day -->\n\t\t<div class="birth-date-input_item">\n\t\t\t<div class="birth-date-input_field-group">\n\t\t\t\t<label class="birth-date-input_label" for="{{$ctrl.segments.date.id}}" ng-class="{ \'required\' : $ctrl.required }">\n\t\t\t\t\tDay:\n\t\t\t\t</label>\n\t\t\t\t<input class="birth-date-input_field width-2" id="{{$ctrl.segments.date.id}}" inputmode="numeric" max="31" maxlength="2" minlength="1" name="{{$ctrl.segments.date.id}}" ng-change="$ctrl.onSegmentChange()" ng-model-options="{ debounce: $ctrl.debounce }" ng-model="$ctrl.segments.date.ngModel" ng-required="$ctrl.required" placeholder="DD" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Month -->\n\t\t<div class="birth-date-input_item">\n\t\t\t<div class="birth-date-input_field-group">\n\t\t\t\t<label class="birth-date-input_label" for="{{$ctrl.segments.month.id}}" ng-class="{ \'required\' : $ctrl.required }">\n\t\t\t\t\tMonth:\n\t\t\t\t</label>\n\t\t\t\t<input class="birth-date-input_field width-2" id="{{$ctrl.segments.month.id}}" inputmode="numeric" maxlength="2" minlength="1" name="{{$ctrl.segments.month.id}}" ng-change="$ctrl.onSegmentChange()" ng-model-options="{ debounce: $ctrl.debounce }" ng-model="$ctrl.segments.month.ngModel" ng-required="$ctrl.required" placeholder="MM" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Year -->\n\t\t<div class="birth-date-input_item">\n\t\t\t<div class="birth-date-input_field-group">\n\t\t\t\t<label class="birth-date-input_label" for="{{$ctrl.segments.year.id}}" ng-class="{ \'required\' : $ctrl.required }">\n\t\t\t\t\tYear:\n\t\t\t\t</label>\n\t\t\t\t<input class="birth-date-input_field width-4" id="{{$ctrl.segments.year.id}}" inputmode="numeric" maxlength="4" minlength="4" name="{{$ctrl.segments.year.id}}" ng-change="$ctrl.onSegmentChange()" ng-model-options="{ debounce: $ctrl.debounce }" ng-model="$ctrl.segments.year.ngModel" ng-required="$ctrl.required" placeholder="YYYY" type="text">\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="birth-date-input_footer">\n\n        <!-- Errors - Day -->\n        <div ng-if="$ctrl.form[$ctrl.segments.date.id].$touched && $ctrl.form[$ctrl.segments.date.id].$invalid" ng-messages="$ctrl.form[$ctrl.segments.date.id].$error">\n            <p class="error" ng-message="required">Please enter a day</p>\n            <p class="error" ng-message="maxlength || minlength">Please enter a valid day (eg, 20)</p>\n        </div>\n\n        <!-- Errors - Month -->\n        <div ng-if="$ctrl.form[$ctrl.segments.month.id].$touched && $ctrl.form[$ctrl.segments.month.id].$invalid" ng-messages="$ctrl.form[$ctrl.segments.month.id].$error">\n            <p class="error" ng-message="required">Please enter a month</p>\n            <p class="error" ng-message="maxlength || minlength">Please enter a valid month (eg, 6)</p>\n        </div>\n\n        <!-- Errors - Year -->\n        <div ng-if="$ctrl.form[$ctrl.segments.year.id].$touched && $ctrl.form[$ctrl.segments.year.id].$invalid" ng-messages="$ctrl.form[$ctrl.segments.year.id].$error" role="alert">\n            <p class="error" ng-message="required">Please enter a year</p>\n            <p class="error" ng-message="maxlength || minlength">Please enter a valid year (eg, 1997)</p>\n        </div>\n\n        <!-- Date doesn\'t exist -->\n        <div ng-switch="$ctrl.validationState">\n            <p pc-switch-when="$ctrl.VALIDATION_STATES.dateDoesntExist" class="error">Please enter a real date</p>\n            <p pc-switch-when="$ctrl.VALIDATION_STATES.dateIsAfterMax" class="error">Birth date can\'t be after {{$ctrl.maxDateIso | dateformat}}</p>\n            <p pc-switch-when="$ctrl.VALIDATION_STATES.dateIsBeforeMin" class="error">Birth date can\'t be before {{$ctrl.minDateIso | dateformat}}</p>\n        </div>\n\n</div></fieldset>\n');
$templateCache.put('components/bullet-list/bullet-list.component.html','<ul class="bullet-list" ng-class="$ctrl.blTheme" ng-transclude="items">\n\t<li class="bullet-list_item" ng-repeat="item in $ctrl.listItemsDecorated"><span ng-class="item.class">{{::item.text}}</span></li>\n</ul>\n');
$templateCache.put('components/bureau-card/bureau-card.component.html','<div class="bureau-card fadeIn">\n\n\t<div class="bureau-card-header">\n\t\t<i class="icon-franchisees bureau-card-icon"></i>\n\t\t<a class="bureau-card-name" ui-sref="companies({\n\t\t\t\tagencyProfileId: $ctrl.bureau.Company.AgencyProfileID\n\t\t\t})">\n\t\t\t{{$ctrl.bureau.Company.Name}}\n\t\t</a>\n\t\t<p class="s bureau-card-phone">\n\t\t\t<ng-pluralize count="$ctrl.bureau.Company.CompanyCount" when="{\n\t\t\t\t\t\'1\': \'1 company\',\n\t\t\t\t\t\'other\': \'{} companies\'\n\t\t\t\t}"></ng-pluralize>\n\t\t</p>\n\t</div>\n\n\t<dropdown-menu class="bureau-card-action-menu" menu-icon="icon-setup" menu-show="$ctrl.showMenu" menu-size="l">\n\t\t<div class="dropdown-group" ng-if="!$ctrl.bureau.Company.IsArchived">\n\t\t\t<a ui-sref="dashboard({\n\t\t\t\t\tagencyProfileId: $ctrl.bureau.Company.AgencyProfileID\n\t\t\t\t})">\n\t\t\t\tGo to bureau\n\t\t\t</a>\n\t\t\t<a ng-if="::$root.currentUser.Permissions.Admin.canManageCompanies" ui-sref="bureau-onboarding({\n\t\t\t\t\tagencyProfileId: $ctrl.bureau.Company.AgencyProfileID\n\t\t\t\t})">\n\t\t\t\tOnboarding\n\t\t\t</a>\n\t\t\t<a href="" ng-click="$ctrl.openAddCompanyWizard()" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t\tCreate company\n\t\t\t</a>\n\t\t\t<a href="" ng-click="$ctrl.openAutoCreateCompanyForm()" ng-if="\n\t\t\t\t\t::$root.currentUser.Permissions.Admin.canManageCompanies &&\n\t\t\t\t\t$ctrl.bureau.Company.AgencyProfileDummy\n\t\t\t\t">\n\t\t\t\tAuto-create company\n\t\t\t</a>\n\t\t\t<a href="" ng-click="$ctrl.openManageAdminsForm()" ng-if="::$root.currentUser.Permissions.Admin.canManageBureauAdmins">\n\t\t\t\tManage admins\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="::$root.userHasRole(\'paycircle\')">\n\t\t\t<a class="greyscale" href="" ng-click="$ctrl.openArchiveBureauForm()">\n\t\t\t\t<span ng-if="$ctrl.bureau.Company.IsArchived">Undo archive</span>\n\t\t\t\t<span ng-if="!$ctrl.bureau.Company.IsArchived">Archive bureau</span>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="\n\t\t\t\t::$root.userHasRole(\'paycircle\') &&\n\t\t\t\t$ctrl.bureau.Company.CanBeDeleted\n\t\t\t">\n\t\t\t<a class="assertive" href="" ng-click="$ctrl.openDeleteBureauForm()">\n\t\t\t\tDelete bureau\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/business-categories-override/business-categories-override.component.html','<div class="fadeIn">\n\t<div class="empty-placeholder" ng-if="$ctrl.businessCategories.length === 0">\n\t\t<div class="empty-placeholder_content">\n\t\t\t<icon-dot icon="icon-warning" theme="is-tertiary">\n\t\t\t</icon-dot>\n\t\t\t<h5>\n\t\t\t\tNo business categories exist\n\t\t\t</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tHead to the \'Business categories\' area of your company settings to start adding them.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<div ng-if="$ctrl.businessCategories.length > 0">\n\t\t<div class="business-categories-override-form-field_intro">\n\t\t\t<p class="form-field-sub is-small">\n\t\t\t\tSelect a different set of business categories to those saved in {{$ctrl.userForename}}\'s company details. 100% of this cost will be allocated to them for journals.\n\t\t\t</p>\n\t\t</div>\n\t\t<div>\n\t\t\t<div class="business-categories-override-form-field" ng-repeat="businessCategory in $ctrl.businessCategories">\n\t\t\t\t<div>\n\t\t\t\t\t<label for="businessCategory_{{$index}}">\n\t\t\t\t\t\t<i class="icon-group is-primary"></i>\n\t\t\t\t\t\t{{ ::businessCategory.BusinessCategoryName }}:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="business-categories-override-form-field_select">\n\t\t\t\t\t<select id="businessCategory_{{$index}}" name="businessCategory_{{$index}}" ng-model="businessCategory.selectedBusinessCode" ng-options="businessCode as businessCode.BusinessCodeNarrative for businessCode in businessCategory.BusinessCodes | orderBy: \'BusinessCodeNarrative\'">\n\t\t\t\t\t\t<option value="">\n\t\t\t\t\t\t\t-- No {{ ::businessCategory.BusinessCategoryName | lowercase }} allocated --\n\t\t\t\t\t\t</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/business-category/business-category.component.html','<div id="business-category-{{$ctrl.index}}" class="business-category">\n\n\t<!-- Header -->\n\t<div class="business-category_header" ng-class="{ \'is-expanded\': $ctrl.isExpanded }">\n\t\t<i class="{{$ctrl.isExpanded ? \'icon-chevron-up\' : \'icon-chevron-down\'}} business-category_icon"></i>\n\t\t<div class="business-category_title">{{$ctrl.businessCategory.BusinessCategoryName}}</div>\n\t\t<div class="business-category_meta">\n\t\t\t<div class="tag is-primary inverse business-category_meta-tag" ng-if="$ctrl.businessCategory.BusinessCategoryNominalCodeOverridesEnabled">Overrides</div>\n\t\t\t<span class="strong">\n\t\t\t\t<ng-pluralize count="$ctrl.businessCategory.BusinessCodes.length" when="{ \'1\': \'1 code\', \'other\': \'{} codes\'}"></ng-pluralize>\n\t\t\t</span>\n\t\t</div>\n\t\t<a href="" class="primary-darkened business-category_action-overlay" ng-click="$ctrl.toggleIsExpanded()"></a>\n\t</div>\n\n\t<!-- Main -->\n\t<div class="business-category_main fadeIn" ng-show="$ctrl.isExpanded">\n\t\t<div class="business-category_codes" ng-if="$ctrl.businessCategory.BusinessCodes.length > 0">\n\t\t\t<div class="business-category_code" ng-repeat="businessCode in $ctrl.businessCategory.BusinessCodes" ng-if="!businessCode.BusinessCodeArchived">\n\t\t\t\t<div class="business-category_code-detail">\n\t\t\t\t\t<div class="business-category_code-value" title="{{businessCode.BusinessCodeValue || \'N/A\'}}">\n\t\t\t\t\t\t{{businessCode.BusinessCodeValue || \'N/A\'}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="business-category_code-narrative" title="{{businessCode.BusinessCodeNarrative}}">\n\t\t\t\t\t\t{{businessCode.BusinessCodeNarrative}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="business-category_code-actions" ng-if="$ctrl.businessCategory.BusinessCategoryNominalCodeOverridesEnabled">\n\t\t\t\t\t<span class="business-category_code-count" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': businessCode.NominalCodeOverrideCount > 0\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t{{businessCode.NominalCodeOverrideCount}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<a aria-label="Edit" class="business-category_code-edit is-primary-light" href="" ng-click="$ctrl.openDepartmentSubCodeOverridesForm(businessCode)">\n\t\t\t\t\t\t<i class="icon-edit is-smedium"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<p class="caption business-category_placeholder" ng-if="$ctrl.businessCategory.BusinessCodes.length === 0">\n\t\t\tAdd {{$ctrl.businessCategory.BusinessCategoryName | businessCategoryPlural | lowercase}} in the business categories area in your company settings and they will appear here.\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/business-code-card/business-code-card.component.html','<div class="business-code-card fadeIn" data-cy="business-code-card" ng-class="{\n\t\t\'is-active\' : $ctrl.showMenu,\n\t\t\'is-indifferent\' : $ctrl.businessCode.IsUnallocatedBusinessCode,\n\t\t\'is-primary\' : !$ctrl.businessCode.IsUnallocatedBusinessCode\n\t}" ng-mouseleave="$ctrl.hideMenu($ctrl)">\n\t<div class="business-code-card_layout">\n\n\t\t<div class="business-code-card_icon">\n\t\t\t<icon-dot ng-if="::$ctrl.businessCode.IsUnallocatedBusinessCode" icon="icon-question-mark" theme="is-large is-indifferent"></icon-dot>\n\t\t\t<icon-dot ng-if="::!$ctrl.businessCode.IsUnallocatedBusinessCode" icon="icon-group" theme="is-large is-primary"></icon-dot>\n\t\t</div>\n\n\t\t<div class="business-code-card_content">\n\t\t\t<h6 class="business-code-card_heading" data-cy="business-code-name">\n\t\t\t\t{{::$ctrl.businessCode.IsUnallocatedBusinessCode ? \'Unallocated\' : $ctrl.businessCode.BusinessCodeNarrative}}\n\t\t\t</h6>\n\t\t</div>\n\n\t\t<div class="business-code-card_meta" ng-if="$ctrl.showExtras">\n\n\t\t\t<div class="business-code-card_meta-items">\n\t\t\t\t<div class="business-code-card_meta-item" ng-if="::$ctrl.businessCode.IsUnallocatedBusinessCode">\n\t\t\t\t\t<i class="icon-team-alt is-medium business-code-card_meta-item-icon"></i>\n\t\t\t\t\t<p class="business-code-card_meta-item-value">{{$ctrl.businessCode.UserAgencyProfileBusinessCodeCount}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="business-code-card_meta-item" ng-class="{\'is-hidden\': !$ctrl.businessCode.BusinessCodeValue}" ng-if="::!$ctrl.businessCode.IsUnallocatedBusinessCode">\n\t\t\t\t\t<i class="icon-csv is-medium business-code-card_meta-item-icon"></i>\n\t\t\t\t\t<p alt="{{$ctrl.businessCode.BusinessCodeValue}}" class="business-code-card_meta-item-value" data-cy="business-code-value">\n\t\t\t\t\t\t{{$ctrl.businessCode.BusinessCodeValue}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="business-code-card_menu" ng-if="$ctrl.showExtras">\n\n\t\t\t\t<dropdown-menu class="business-code-card-action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.showMenu" menu-size="l" menu-theme="{{ $ctrl.businessCode.IsUnallocatedBusinessCode ? \'indifferent\' : \'primary\' }}">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-if="!$ctrl.businessCode.IsUnallocatedBusinessCode && $ctrl.businessCode.CanEdit" ng-click="$ctrl.openBusinessCodeEditForm($ctrl)">Edit</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openBusinessCodeManageTeamMembersForm($ctrl)">Manage team members</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openBusinessCodeManageVisibilityForm($ctrl)" ng-if="$ctrl.businessCategory.BusinessCategoryType === $ctrl.BUSINESS_CATEGORY_TYPES.department">Manage visibility</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="dropdown-group" ng-if="::!$ctrl.businessCode.IsUnallocatedBusinessCode">\n\t\t\t\t\t\t<a href="" class="assertive" ng-click="$ctrl.openBusinessCodeDeleteForm($ctrl)">Delete</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/business-code-form-field/business-code-form-field.component.html','<div class="business-code-form-field">\n\t<div class="business-code-form-field_action" ng-if="$ctrl.showActions">\n\t\t<i class="icon-padlock" class="business-code_delete" title="Unable to delete as assigned to team members" ng-if="!$ctrl.businessCode.CanArchive"></i>\n\t\t<div class="business-code_delete" ng-if="!$ctrl.businessCode.confirmDelete && $ctrl.businessCode.CanArchive">\n\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeleteBusinessCode($ctrl.businessCode)" data-cy="delete-business-code"><i class="icon-trash"></i></a>\n\t\t</div>\n\t\t<div class="business-code-confirm-delete" ng-if="$ctrl.businessCode.confirmDelete">\n\t\t\t<p class="s strong">\n\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t<a href="" ng-click="$ctrl.deleteBusinessCode($ctrl.businessCode)" data-cy="delete-business-code-yes">Yes</a>\n\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeleteBusinessCode($ctrl.businessCode)" data-cy="delete-business-code-no">No</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\t<div class="form-field-group">\n\t\t<div class="form-field business-code-form-field_code">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.businessCodeValueFormFieldId}}" class="required">Code</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.businessCodeValueFormFieldId}}" name="{{$ctrl.businessCodeValueFormFieldId}}" ng-change="$ctrl.onBusinessCodeAttributeChange(\'businessCodeValue\', \'BusinessCodeValue\')" ng-disabled="!$ctrl.businessCode.CanEdit" ng-model-options="{ debounce: 250 }" ng-model="$ctrl.businessCode.BusinessCodeValue" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.businessCodeValueFormFieldId].$error" ng-show="$ctrl.form[$ctrl.businessCodeValueFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a business code</p>\n\t\t\t\t<p ng-message="nonUnique">Please ensure that all business codes are unique</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.businessCodeNarrativeFormFieldId}}" class="required">Narrative</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.businessCodeNarrativeFormFieldId}}" name="{{$ctrl.businessCodeNarrativeFormFieldId}}" ng-change="$ctrl.onBusinessCodeAttributeChange(\'businessCodeNarrative\', \'BusinessCodeNarrative\')" ng-disabled="!$ctrl.businessCode.CanEdit" ng-model-options="{ debounce: 250 }" ng-model="$ctrl.businessCode.BusinessCodeNarrative" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.businessCodeNarrativeFormFieldId].$error" ng-show="$ctrl.form[$ctrl.businessCodeNarrativeFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a narrative</p>\n\t\t\t\t<p ng-message="nonUnique">Please ensure that all narrative values are unique</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('components/button-card/button-card.component.html','<div class="button-card">\n\t<div class="button-card_layout">\n\t\t<a class="button-card_content" href="{{$ctrl.buttonLink}}" target="_blank">\n\t\t\t<img alt="" class="button-card_image" src="{{$ctrl.imgSrc}}">\n\t\t\t<p class="stronger s">{{$ctrl.title}}</p>\n\t\t\t<p class="greyscale xs">{{$ctrl.subtitle}}</p>\n\t\t</a>\n\t\t<div class="tag tertiary inverse button-card_banner" ng-if="$ctrl.bannerText">{{$ctrl.bannerText}}</div>\n\t</div>\n</div>\n');
$templateCache.put('components/calculation-card/calculation-card.component.html','<div class="calculation-card" ng-class="{ \'is-assertive\' : ($ctrl.amount < 0), \'is-positive\' : ($ctrl.amount > 0) }">\n\t<p class="calculation-card_title">{{$ctrl.title}}</p>\n\t<p class="calculation-card_amount" ng-if="!$ctrl.busy">{{$ctrl.amount | monetise: 2:\'signed\'}}</p>\n\t<p class="calculation-card_busy xs" ng-if="$ctrl.busy"><i class="icon-loading spin m"></i></p>\n</div>\n');
$templateCache.put('components/carousel-input/carousel-input.component.html','<div class="carousel-input" ng-class="$ctrl.theme">\n\t<div class="carousel-input_layout">\n\t\t<div class="carousel-input_arrow">\n\t\t\t<button aria-label="Decrease value" class="carousel-input_button" type="button" id="{{$id}}-decrease" ng-click="$ctrl.decreaseIndex($ctrl)" ng-class="{ \'is-inactive\' : $ctrl.currentIndex === 0 }" ng-disabled="$ctrl.currentIndex === 0">\n\t\t\t\t<i class="carousel-input_icon icon-chevron-left"></i>\n\t\t\t</button>\n\t\t</div>\n\n\t\t<div class="carousel-input_detail" ng-if="$ctrl.showDetail">\n\t\t\t{{$ctrl.currentIndex+1}} of {{::$ctrl.maxIndex}}\n\t\t</div>\n\n\t\t<div class="carousel-input_arrow">\n\t\t\t<button aria-label="Increase value" class="carousel-input_button" type="button" id="{{$id}}-increase" ng-click="$ctrl.increaseIndex($ctrl)" ng-class="{ \'is-inactive\' : $ctrl.currentIndex === $ctrl.maxIndex-1 }" ng-disabled="$ctrl.currentIndex === $ctrl.maxIndex-1">\n\t\t\t\t<i class="carousel-input_icon icon-chevron-right"></i>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/change-creator/change-creator.component.html','<div class="change-creator" ng-switch="$ctrl.componentState">\n\n\t<div ng-switch-when="ready">\n\n\t\t<!-- Select team member/members -->\n\t\t<section class="change-creator_section" ng-if="::$ctrl.vm.IS_APPLICABLE_TO_TEAM_MEMBERS">\n\n\t\t\t<!-- Search team members -->\n\t\t\t<section class="change-creator_section">\n\t\t\t\t<div class="pill-input-field primary" ng-class="{\'active\': $ctrl.vm.searchTermTeamMembersFocused}">\n\n\t\t\t\t\t<!-- Search Team Members -->\n\t\t\t\t\t<label for="searchTermTeamMembers" class="pill-input-field-label"><i class="icon-user"></i> Add change for</label>\n\t\t\t\t\t<input class="pill-input-field-input fadeIn" id="searchTermTeamMembers" type="text" ng-model="$ctrl.vm.searchTermTeamMembers" ng-focus="$ctrl.vm.toggleSearchTermTeamMembersFocus($ctrl, true)" ng-blur="$ctrl.vm.toggleSearchTermTeamMembersFocus($ctrl, false)" placeholder="Search for a team member or department" autocomplete="off" ng-if="$ctrl.vm.CAN_MANAGE_TEAM_MEMBERS && ($ctrl.vm.selectedTeamMembers.length < $ctrl.vm.MAX_TEAM_MEMBERS || $ctrl.vm.MAX_TEAM_MEMBERS === -1)">\n\n\t\t\t\t\t<!-- Selected Team Members -->\n\t\t\t\t\t<div class="pill-input-field-items" ng-if="$ctrl.vm.selectedTeamMembers.length">\n\t\t\t\t\t\t<div class="pill-input-field-item fadeIn" ng-class="{\'not-deleteable\': !$ctrl.vm.CAN_MANAGE_TEAM_MEMBERS}" ng-repeat="teamMember in $ctrl.vm.selectedTeamMembers | limitTo:1 track by $index">\n\n\t\t\t\t\t\t\t<!-- Single -->\n\t\t\t\t\t\t\t<span ng-if="$ctrl.vm.selectedTeamMembers.length === 1">{{teamMember.Forename}} {{teamMember.Surname}}</span>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.vm.deselectTeamMember($ctrl, $index)" class="pill-input-field-item-delete" ng-if="$ctrl.vm.selectedTeamMembers.length === 1 && $ctrl.vm.CAN_MANAGE_TEAM_MEMBERS" aria-label="Unselect team member"><i class="icon-plus"></i></a>\n\n\t\t\t\t\t\t\t<!-- Multiple -->\n\t\t\t\t\t\t\t<span ng-if="$ctrl.vm.selectedTeamMembers.length > 1">{{$ctrl.vm.selectedTeamMembers.length}} team members</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="pill-input-search-results dropIn" ng-show="$ctrl.vm.searchTermTeamMembers.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT" click-anywhere-but-here="$ctrl.vm.resetTeamMemberSearchTerm($ctrl)" is-active="$ctrl.vm.searchTermTeamMembers.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t\t\t<!-- Team Members -->\n\t\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Team members</p>\n\t\t\t\t\t\t\t<button aria-label="Select team member" type="button" class="pill-input-search-result is-clear primary" ng-click="$ctrl.vm.selectTeamMember($ctrl, teamMember)" ng-repeat="teamMember in $ctrl.vm.teamMembersFiltered = ($ctrl.vm.teamMembers | filter: $ctrl.vm.searchTermTeamMembers) | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT" ng-if="$ctrl.vm.teamMembersFiltered.length">\n\t\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-{{teamMember.Gender | lowercase}}" is-light="true" theme="is-medium is-primary"></icon-dot>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{teamMember.Forename}} {{teamMember.Surname}}</p>\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<p ng-if="!$ctrl.vm.teamMembersFiltered.length"><span class="caption">No team members found</span></p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Departments -->\n\t\t\t\t\t\t<div class="pill-input-search-results-group" ng-if="$ctrl.vm.CAN_ADD_DEPARTMENT_CHANGES">\n\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Departments</p>\n\t\t\t\t\t\t\t<button aria-label="Select department" type="button" class="pill-input-search-result is-clear quarternary clickable" ng-click="$ctrl.vm.selectTeamMembersByDepartment($ctrl.vm.teamMembers, department.AgencyDepartmentID)" ng-repeat="department in $ctrl.vm.departmentsFiltered = ($ctrl.vm.departments | filter: $ctrl.vm.searchTermTeamMembers) | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT" ng-if="filteredTeamMembers.length">\n\t\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-team-alt" is-light="true" theme="is-medium is-quarternary"></icon-dot>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{department.AgencyDepartmentName}}</p>\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<p ng-if="!filteredDepartments.length"><span class="caption">No departments found</span></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Manually select team member from list -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="!$ctrl.vm.selectedTeamMembers.length">\n\n\t\t\t\t<div class="change-creator_section tight">\n\t\t\t\t\t<p class="s">Or select from below:</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="change-creator_section">\n\t\t\t\t\t<div class="item-selection-cards">\n\n\t\t\t\t\t\t<!-- Team Members -->\n\t\t\t\t\t\t<button aria-label="Select team member" type="button" id="add-change-team-member-{{$index}}" class="item-selection-card is-clear primary clickable {{teamMember.isCompany ? \'is-company\' : \'\'}}" ng-click="$ctrl.vm.selectTeamMember($ctrl, teamMember)" ng-repeat="teamMember in $ctrl.vm.teamMembers | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT_TEAM">\n\t\t\t\t\t\t\t<div class="item-selection-card_gender">\n\t\t\t\t\t\t\t\t<i class="icon-{{teamMember.Gender | lowercase}}" ng-if="!teamMember.isCompany"></i>\n\t\t\t\t\t\t\t\t<i class="icon-{{teamMember.cisIconType}}" ng-if="teamMember.isCompany"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="item-selection-card_forename">{{teamMember.Forename}}</p>\n\t\t\t\t\t\t\t<p class="item-selection-card_surname">{{teamMember.Surname}}</p>\n\t\t\t\t\t\t\t<a href="" class="item-selection-card_action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<!-- Departments -->\n\t\t\t\t\t\t<button aria-label="Select department" type="button" class="item-selection-card is-clear quarternary clickable" ng-click="$ctrl.vm.selectTeamMembersByDepartment(teamMembers, department.AgencyDepartmentID)" ng-repeat="department in $ctrl.vm.departments | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT_DEPARTMENT" ng-if="$ctrl.vm.CAN_ADD_DEPARTMENT_CHANGES">\n\t\t\t\t\t\t\t<i class="icon-team-alt item-selection-card_icon"></i>\n\t\t\t\t\t\t\t<p class="item-selection-card_description">{{department.AgencyDepartmentName}}</p>\n\t\t\t\t\t\t\t<a href="" class="item-selection-card_action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Load more -->\n\t\t\t\t\t<div class="item-selection-cards-load-more" ng-if="$ctrl.vm.SEARCH_RESULTS_LIMIT_TEAM < $ctrl.vm.teamMembers.length">\n\t\t\t\t\t\t<a href="" class="button white" ng-click="$ctrl.vm.incrementSearchResultsTeam($ctrl)"><i class="icon-add m"></i>&nbsp;Show more</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</section>\n\n\t\t<!-- Adjustment Type -->\n\t\t<section class="change-creator_section fadeIn" ng-if="!$ctrl.vm.IS_APPLICABLE_TO_TEAM_MEMBERS || ($ctrl.vm.IS_APPLICABLE_TO_TEAM_MEMBERS && $ctrl.vm.selectedTeamMembers.length)">\n\n\t\t\t<!-- Search adjustment types -->\n\t\t\t<section class="change-creator_section">\n\t\t\t\t<div class="pill-input-field primary" ng-class="{\n\t\t\t\t\t\'assertive\': $ctrl.vm.newAdjustment.adjustmentType && $ctrl.vm.newAdjustment.adjustmentType.IsDeduction,\n\t\t\t\t\t\'positive\': $ctrl.vm.newAdjustment.adjustmentType && !$ctrl.vm.newAdjustment.adjustmentType.IsDeduction,\n\t\t\t\t\t\'active\': $ctrl.vm.searchTermAdjustmentTypesFocused}">\n\n\t\t\t\t\t<!-- Search Adjustment Types -->\n\t\t\t\t\t<label for="searchTermAdjustmentTypes" class="pill-input-field-label"><i class="icon-adjustment"></i> {{::$ctrl.vm.PAY_ELEMENT_LABEL}}</label>\n\t\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" id="searchTermAdjustmentTypes" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-if="!$ctrl.vm.newAdjustment.adjustmentType && !$ctrl.vm.selectedAdjustmentLabel" ng-model="$ctrl.vm.searchTermAdjustmentTypes" placeholder="{{::$ctrl.vm.PAY_ELEMENT_LABEL_PLACEHOLDER}}" type="text">\n\n\t\t\t\t\t<!-- Selected Change -->\n\t\t\t\t\t<div class="pill-input-field-items">\n\t\t\t\t\t\t<div class="pill-input-field-item {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn" ng-class="{\'not-deleteable\': !$ctrl.vm.CAN_EDIT_ADJUSTMENT}" ng-if="$ctrl.vm.newAdjustment.adjustmentType">\n\t\t\t\t\t\t\t<span>{{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentLabelText ? $ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentLabelText : $ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentGroupEntryText}}</span>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.vm.deselectAdjustmentType($ctrl)" class="pill-input-field-item-delete" ng-if="$ctrl.vm.CAN_EDIT_ADJUSTMENT" aria-label="Deselect adjustment type"><i class="icon-plus"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Search results -->\n\t\t\t\t\t<div class="pill-input-search-results dropIn" ng-show="$ctrl.vm.searchTermAdjustmentTypes.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT" ng-if="!$ctrl.vm.newAdjustment.adjustmentType" click-anywhere-but-here="$ctrl.vm.resetAdjustmentTypeSearchTerm($ctrl)" is-active="$ctrl.vm.searchTermAdjustmentTypes.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t\t\t<div class="pill-input-search-results-group" ng-if="$ctrl.vm.adjustmentLabels.length">\n\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Payslip labels</p>\n\t\t\t\t\t\t\t<button aria-label="Select payslip label" type="button" class="pill-input-search-result is-clear secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel($ctrl, adjustmentLabel)" ng-repeat="adjustmentLabel in filteredAdjustmentLabels = ( $ctrl.vm.adjustmentLabels | filter: $ctrl.vm.searchTermAdjustmentTypes ) | orderBy:[\'IsDeduction\', \'AgencyAdjustmentGroupEntryText\'] | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT">\n\t\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-label" is-light="true" theme="is-medium {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}"></icon-dot>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{adjustmentLabel.AgencyAdjustmentLabelText}} <span>{{adjustmentLabel.AdjustmentText}}</span></p>\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<p ng-if="!filteredAdjustmentLabels.length"><span class="caption">No payslip labels found</span></p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Changes -->\n\t\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Changes</p>\n\t\t\t\t\t\t\t<button aria-label="Select change" type="button" class="pill-input-search-result is-clear fadeIn {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-click="$ctrl.vm.selectAdjustmentType($ctrl, adjustmentType)" ng-repeat="adjustmentType in adjustmentTypesFiltered = ( $ctrl.vm.adjustmentTypes | filter: $ctrl.vm.adjustmentTypeSearchFilter | filter: {AgencyAdjustmentGroupEntryText: $ctrl.vm.searchTermAdjustmentTypes} ) | orderBy:\'AgencyAdjustmentGroupEntryText\' | limitTo:$ctrl.vm.SEARCH_RESULTS_LIMIT">\n\t\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-{{adjustmentType.IsDeduction ? \'minus\' : \'add\'}}" is-light="true" theme="is-medium {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}"></icon-dot>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{adjustmentType.AgencyAdjustmentGroupEntryText}}</p>\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<p ng-if="!adjustmentTypesFiltered.length"><span class="caption">No changes found</span></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Change type details -->\n\t\t\t\t\t<div class="pill-input-details" ng-if="$ctrl.vm.IS_ADJUSTMENT_AMOUNT_APPLICABLE && $ctrl.vm.newAdjustment.adjustmentType" ng-switch="$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentValueType">\n\n\t\t\t\t\t\t<!-- Absolute -->\n\t\t\t\t\t\t<div class="pill-input-detail-items" pc-switch-when="$ctrl.vm.ADJUSTMENT_VALUE_TYPES.absolute" ng-switch="$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentSpecialType">\n\n\t\t\t\t\t\t\t<!-- Accrued Holiday -->\n\t\t\t\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.vm.ADJUSTMENT_SPECIAL_TYPES.accruedHoliday" ng-switch="$ctrl.holidayAccrualState">\n\n\t\t\t\t\t\t\t\t<div ng-switch-when="loading">\n\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div ng-switch-when="ready">\n\n\t\t\t\t\t\t\t\t\t<!-- Has holiday accrued -->\n\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-items fadeIn" ng-if="$ctrl.vm.selectedTeamMembers[0].HolidayAccrual > 0">\n\n\t\t\t\t\t\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentTotalValue" class="pill-input-detail-item_label required">Amount:</label>\n\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input monetise {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentTotalValue" maxlength="10" name="adjustmentTotalValue" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.resetNetToGrossEnabled($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-max="$ctrl.vm.selectedTeamMembers[0].HolidayAccrual" ng-min="0" ng-model="$ctrl.vm.newAdjustment.Value" ng-pattern="$root.REGEX.decimal" placeholder="Enter amount..." required type="number">\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentTotalValue.$error" ng-if="$ctrl.form.adjustmentTotalValue.$dirty && $ctrl.form.adjustmentTotalValue.$invalid" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">{{$ctrl.vm.selectedTeamMembers[0].HolidayAccrual | monetise}} is the maximum payable</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Accrual -->\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-field pill-input-detail-field-copy">\n\t\t\t\t\t\t\t\t\t\t\t<p class="s">of <a href ng-click="setAdjustmentValueToAccruedHolidayTotal($ctrl)" class="positive underline" tooltip tooltip-text="{{$ctrl.vm.selectedTeamMembers[0].Forename}} has accrued {{$ctrl.vm.selectedTeamMembers[0].HolidayAccrual | monetise}} in holiday pay" tooltip-position="top-left" tooltip-size="m">{{$ctrl.vm.selectedTeamMembers[0].HolidayAccrual | monetise}}</a> accrued</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- No holiday accrued -->\n\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.vm.selectedTeamMembers[0].HolidayAccrual < 1">\n\t\t\t\t\t\t\t\t\t\t<p class="s"><i class="icon-warning m tertiary"></i>&nbsp;&nbsp;{{$ctrl.vm.selectedTeamMembers[0].Forename}} has <strong>{{$ctrl.vm.selectedTeamMembers[0].HolidayAccrual | monetise}}</strong> of accrued holiday available</p>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="$ctrl.vm.doesNotExist" value="" required>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- General fixed adjustment -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-items fadeIn" ng-switch-default>\n\n\t\t\t\t\t\t\t\t<div class="pill-input-detail-block fadeIn">\n\t\t\t\t\t\t\t\t\t<label for="adjustmentTotalValue" class="pill-input-detail-item_label required">Amount:</label>\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input monetise {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentTotalValue" name="adjustmentTotalValue" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.reviewNetToGross($ctrl, $ctrl.vm.newAdjustment.NetToGross, true)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.vm.newAdjustment.Value" ng-pattern="$root.REGEX.decimal" placeholder="Enter amount..." required type="number">\n\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentTotalValue.$error" ng-if="$ctrl.form.adjustmentTotalValue.$touched && !$ctrl.form.adjustmentTotalValue.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="pill-input-detail-block fadeIn" ng-if="$ctrl.vm.CAN_APPLY_TO_ALL && !($ctrl.vm.newAdjustment.adjustmentType.IsEmployeePension || $ctrl.vm.newAdjustment.adjustmentType.IsEmployerPension)">\n\t\t\t\t\t\t\t\t\t<toggle-input field-label="Add same amount for all team members in pay run" field-model="$ctrl.vm.newAdjustment.isApplyToAll" field-name="applyToAll" field-style="is-small"></toggle-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Units -->\n\t\t\t\t\t\t<div class="pill-input-detail-items fadeIn" pc-switch-when="$ctrl.vm.ADJUSTMENT_VALUE_TYPES.unit">\n\n\t\t\t\t\t\t\t<!-- Unit label (dynamic) -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t<label for="adjustmentUnits" class="pill-input-detail-item_label required">{{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentUnitLabel}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnits" maxlength="10" ng-model="$ctrl.vm.newAdjustment.Units" name="adjustmentUnits" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.calculateAdjustmentValue($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-pattern="$root.REGEX.decimal" placeholder="Enter {{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentUnitLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentUnits.$error" ng-if="$ctrl.form.adjustmentUnits.$touched && !$ctrl.form.adjustmentUnits.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Value label (dynamic) -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t<label for="adjustmentUnitValue" class="pill-input-detail-item_label required">{{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentValueLabel}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.calculateAdjustmentValue($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="$ctrl.vm.newAdjustment.UnitValue" ng-pattern="$root.REGEX.decimal" placeholder="Enter {{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentValueLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentUnitValue.$error" ng-if="$ctrl.form.adjustmentUnitValue.$touched && !$ctrl.form.adjustmentUnitValue.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Percentage (only available when 1 team member is selected) -->\n\t\t\t\t\t\t<div class="pill-input-detail-items fadeIn" pc-switch-when="$ctrl.vm.ADJUSTMENT_VALUE_TYPES.percentage">\n\n\t\t\t\t\t\t\t<!-- Percentage value -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input percentage {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnits" maxlength="10" name="adjustmentUnits" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.calculatePercentageValue($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="$ctrl.vm.newAdjustment.Units" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentUnits.$error" ng-if="$ctrl.form.adjustmentUnits.$touched && !$ctrl.form.adjustmentUnits.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<span class="pill-input-detail-field-divider">of</span>\n\n\t\t\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field has-action">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input monetise {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.calculatePercentageValue($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="$ctrl.vm.newAdjustment.UnitValue" ng-pattern="$root.REGEX.decimal" required type="number">\n\n\t\t\t\t\t\t\t\t<!-- Set to salary (only applicable to team members paid a salary) -->\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-detail-field-action {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-click="$ctrl.vm.setPercentageCalculationToSalary($ctrl)" ng-if="$ctrl.vm.canSetToSalary($ctrl)">Set to salary</a>\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentUnitValue.$error" ng-if="$ctrl.form.adjustmentUnitValue.$touched && !$ctrl.form.adjustmentUnitValue.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Linked -->\n\t\t\t\t\t\t<div pc-switch-when="$ctrl.vm.ADJUSTMENT_VALUE_TYPES.linked">\n\n\t\t\t\t\t\t\t<circle-loader class="s" ng-if="$ctrl.vm.selectedTeamMembers[0].salaryState === \'loading\'"></circle-loader>\n\n\t\t\t\t\t\t\t<div ng-if="$ctrl.vm.selectedTeamMembers[0].salaryState === \'ready\'">\n\n\t\t\t\t\t\t\t\t<!-- Has rates defined -->\n\t\t\t\t\t\t\t\t<div ng-if="$ctrl.vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated.length">\n\n\t\t\t\t\t\t\t\t\t<!-- Select rate -->\n\t\t\t\t\t\t\t\t\t<div class="change-creator_section">\n\t\t\t\t\t\t\t\t\t\t<select name="salaryRate" id="salaryRate" ng-change="$ctrl.vm.selectSalaryRate($ctrl)" ng-model="$ctrl.vm.newAdjustment.selectedRate" ng-options="rate as rate.SalaryRateDisplay for rate in $ctrl.vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated" required>\n\t\t\t\t\t\t\t\t\t\t\t<option value="">Select a rate...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.salaryRate.$error" ng-if="$ctrl.form.salaryRate.$touched && !$ctrl.form.salaryRate.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a rate</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="change-creator_section fadeIn" ng-if="$ctrl.vm.newAdjustment.selectedRate">\n\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-items is-inline fadeIn">\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentUnits" class="required pill-input-detail-item_label">Units:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<number-selector-field size="is-block" theme="{{$ctrl.vm.newAdjustment.adjustentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-model="$ctrl.vm.newAdjustment.Units" ng-model-options="{ debounce:400 }" field-name="adjustmentUnits" nsf-on-change="$ctrl.vm.calculateAdjustmentValue($ctrl)"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked fadeIn" ng-if="$ctrl.vm.newAdjustment.selectedRate.SalaryRateID === \'custom\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentUnitValue" class="required pill-input-detail-item_label">Rate:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise pill-input-detail-item_input {{$ctrl.vm.newAdjustment.adjustentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, false)" ng-change="$ctrl.vm.calculateAdjustmentValue($ctrl)" ng-focus="$ctrl.vm.toggleSearchTermTypesFocus($ctrl, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="$ctrl.vm.newAdjustment.UnitValue" ng-pattern="::regexService.salaryRatesRegEx" placeholder="Enter {{$ctrl.vm.newAdjustment.adjustentType.AgencyAdjustmentValueLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="$ctrl.form.adjustmentUnitValue.$error" ng-if="$ctrl.form.adjustmentUnitValue.$touched && !$ctrl.form.adjustmentUnitValue.$valid" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentMultiplyRate" class="required pill-input-detail-item_label">Multiply rate by:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<number-selector-field size="is-block" theme="{{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-model="$ctrl.vm.newAdjustment.UnitValueMultiplier" ng-model-options="{ debounce:400 }" field-name="adjustmentMultiplyRate" nsf-on-change="$ctrl.vm.calculateAdjustmentValue($ctrl)"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\n\t\t\t\t\t\t\t\t\t\t<p class="caption">Note: the rates available are based on the pay information in {{$ctrl.vm.selectedTeamMembers[0].Forename}}\'s profile</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- No rates defined -->\n\t\t\t\t\t\t\t\t<div ng-if="!$ctrl.vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated.length">\n\t\t\t\t\t\t\t\t\t<p class="caption">There are no rates set up for {{$ctrl.vm.selectedTeamMembers[0].Forename}}</p>\n\t\t\t\t\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="$ctrl.vm.doesNotExist" value="" required>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Net to Gross -->\n\t\t\t\t\t\t<div class="pill-input-detail-toggle fadeIn" pc-switch-when="[$ctrl.vm.ADJUSTMENT_VALUE_TYPES.absolute, $ctrl.vm.ADJUSTMENT_VALUE_TYPES.unit]" ng-if="$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentNetToGross">\n\t\t\t\t\t\t\t<div class="toggle-tab positive">\n\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.vm.reviewNetToGross($ctrl, false)" class="toggle-tab-option" ng-class="{\'active\' : !$ctrl.vm.newAdjustment.NetToGross}">Gross</a>\n\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.vm.reviewNetToGross($ctrl, true)" class="toggle-tab-option" ng-class="{\'active\' : $ctrl.vm.newAdjustment.NetToGross}">Net</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Manually select adjustment type from list -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="!$ctrl.vm.newAdjustment.adjustmentType">\n\t\t\t\t<div class="change-creator_section">\n\t\t\t\t\t<p class="s">Or select from below:</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="change-creator_section" ng-if="$ctrl.vm.adjustmentTypesCategories.length > 1">\n\t\t\t\t\t<nav class="tabs">\n\t\t\t\t\t\t<a data-cy="change-creator_category_{{category.key}}" href="" ng-class="{\'active\': category.key === $ctrl.vm.adjustmentTypesCategory.key}" ng-click="$ctrl.vm.selectAdjustmentTypeCategory($ctrl, categoryIndex)" ng-if="category.isEnabled" ng-repeat="(categoryIndex, category) in $ctrl.vm.adjustmentTypesCategories">{{::category.name}}</a>\n\t\t\t\t\t</nav>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="change-creator_section" ng-if="$ctrl.vm.adjustmentTypes.length">\n\t\t\t\t\t<div class="adjustment-type-cards">\n\n\t\t\t\t\t\t<!-- Change Types -->\n\t\t\t\t\t\t<div class="adjustment-type-card is-clear {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} clickable" id="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-repeat="adjustmentType in $ctrl.vm.adjustmentTypesFiltered = (\n\t\t\t\t\t\t\t\t\t$ctrl.vm.adjustmentTypes |\n\t\t\t\t\t\t\t\t\tfilter: $ctrl.vm.adjustmentTypesCategory.filter |\n\t\t\t\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\tlimitTo: $ctrl.vm.SEARCH_RESULTS_LIMIT_ADJUSTMENT_TYPES">\n\t\t\t\t\t\t\t<div role="button" class="adjustment-type-card_main" ng-click="$ctrl.vm.selectAdjustmentType($ctrl, adjustmentType)">\n\t\t\t\t\t\t\t\t<span class="adjustment-type-card_action"><i class="icon-chevron-right"></i></span>\n\t\t\t\t\t\t\t\t<p class="adjustment-type-card_description">{{adjustmentType.AgencyAdjustmentGroupEntryText}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<a href ng-click="$root.$broadcast(\'toggle-tooltip-card\', adjustmentType.tooltip)" aria-label="Open modal" class="adjustment-type-card_info-action">\n\t\t\t\t\t\t\t\t<i class="icon-information is-medium {{adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}} adjustment-type-card_info-action-icon"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Load more -->\n\t\t\t\t\t<div class="adjustment-type-cards-load-more" ng-if="$ctrl.vm.SEARCH_RESULTS_LIMIT_ADJUSTMENT_TYPES < $ctrl.vm.adjustmentTypesFiltered.length">\n\t\t\t\t\t\t<a href="" class="button white" ng-click="$ctrl.vm.incrementSearchResultsAdjustmentTypes($ctrl)"><i class="icon-add m"></i>&nbsp;Show more</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="change-creator_section" ng-if="!$ctrl.vm.adjustmentTypes.length">\n\t\t\t\t\t<div class="info-block primary">\n\t\t\t\t\t\t<p class="s">There are no pay elements available</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</section>\n\n\t\t<!-- Payslip Label / Recurring / Preview / Tax treatment (needs adjustment type to be selected) -->\n\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.newAdjustment.adjustmentType">\n\n\t\t\t<!-- Apply to additional post (where applicable). Show if there\'s a single team member, and that team member\n\t\t\t     has one or more additional posts to choose from. -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="\n\t\t\t\t\t$ctrl.vm.selectedTeamMembers.length === 1 &&\n\t\t\t\t\t$ctrl.vm.selectedTeamMembers[0].AdditionalPosts.length !== 0 &&\n\t\t\t\t\t!$ctrl.vm.newAdjustment.adjustmentType.IsEmployeePension &&\n\t\t\t\t\t!$ctrl.vm.newAdjustment.adjustmentType.IsEmployerPension\n\t\t\t\t">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<extended-toggle-input field-label="Apply to additional post" field-model="$ctrl.vm.newAdjustment.applyToAdditionalPost" field-name="applyToAdditionalPost" field-on-change="$ctrl.vm.onApplyToAdditionalPostChange($ctrl)">\n\t\t\t\t\t\t\t<field-content>\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select id="additionalPost" name="additionalPost" ng-change="$ctrl.vm.onAdditionalPostChange($ctrl)" ng-model="$ctrl.vm.newAdjustment.additionalPost" ng-options="additionalPost as additionalPost.JobTitle for additionalPost in $ctrl.vm.selectedTeamMembers[0].AdditionalPosts | orderBy: \'JobTitle\'" required>\n\t\t\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.vm.form.additionalPost.$invalid" role="alert" ng-messages="$ctrl.vm.form.additionalPost.$error">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select an additional post</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</field-content>\n\t\t\t\t\t\t</extended-toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Pension Submitted -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.IS_PENSION_SUBMITTED && ($ctrl.vm.newAdjustment.adjustmentType.IsEmployeePension || $ctrl.vm.newAdjustment.adjustmentType.IsEmployerPension)">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Your pension has been submitted">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tYour pension file for {{::$ctrl.vm.payPeriod.PayPeriodDisplay}} has already been submitted. If you add any pension-related changes in this supplementary pay run you\u2019ll need to upload them to your pension\n\t\t\t\t\t\t\tportal manually.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</section>\n\n\t\t\t<!-- Stat payments - Gross Pay -->\n\t\t\t<div class="change-creator_section fadeIn" ng-if="$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentCategory === $ctrl.vm.ADJUSTMENT_CATEGORY_TYPES.statutoryPayment">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Original gross pay will be overridden">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note when applying a statutory pay element to an employee, the original gross pay will be overridden. If you would like to update the gross pay, you will need to\n\t\t\t\t\t\t\tadd further pay elements.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Stat payments - EPS and P32 -->\n\t\t\t<div class="change-creator_section fadeIn" ng-if="$ctrl.vm.newAdjustment.adjustmentType.IsStatutoryParentalPay && $ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentCategory !== $ctrl.vm.ADJUSTMENT_CATEGORY_TYPES.occupational">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Statutory elements linked to EPS and P32">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tStatutory pay elements will be reported on the EPS and will also be displayed on the P32 report.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Tax treatment: Redundancy payments -->\n\t\t\t<div class="form-field" ng-if="$ctrl.vm.newAdjustment.adjustmentType.IsRedundancyPay">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Tax treatment on redundancy payments">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tOnly amounts over \xA330,000.00 will be subject to tax and Employer\'s Class 1A NICs.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Tax treatment: Testimonial payments -->\n\t\t\t<div class="form-field" ng-if="$ctrl.vm.newAdjustment.adjustmentType.IsTestimonialPay">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Tax treatment on testimonial payments">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tOnly amounts over \xA3100,000.00 will be subject to tax and Employer\'s Class 1A NICs.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Payslip Label -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.IS_PAYSLIP_LABEL_ENABLED">\n\t\t\t\t<div class="pill-input-field {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-class="{\'active\': $ctrl.vm.searchTermAdjustmentLabelsFocused}">\n\t\t\t\t\t<label for="newAdjustmentLabel" class="pill-input-field-label"><i class="icon-label"></i> Label for payslip <span>optional</span></label>\n\t\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" id="newAdjustmentLabel" maxlength="40" minlength="3" name="newAdjustmentLabel" ng-blur="toggleSearchTermLabelsFocus($ctrl, false)" ng-focus="toggleSearchTermLabelsFocus($ctrl, true); toggleShowPayslipLabelResults($ctrl, true);" ng-if="!$ctrl.vm.selectedAdjustmentLabel" ng-model="$ctrl.vm.newAdjustment.Label" ng-pattern="$root.REGEX.description" ng-required="$ctrl.vm.saveLabel" placeholder="Add a custom label for this change" type="text">\n\t\t\t\t\t<div class="pill-input-field-errors" ng-messages="$ctrl.form.newAdjustmentLabel.$error" ng-if="!$ctrl.form.newAdjustmentLabel.$valid && $ctrl.form.newAdjustmentLabel.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter a label</p>\n\t\t\t\t\t\t<p ng-message="minlength">Please enter a label with at least 3 characters</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Selected Label -->\n\t\t\t\t\t<div class="pill-input-field-items" ng-if="$ctrl.vm.selectedAdjustmentLabel">\n\t\t\t\t\t\t<div class="pill-input-field-item {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn">\n\t\t\t\t\t\t\t<span>{{$ctrl.vm.selectedAdjustmentLabel}}</span>\n\t\t\t\t\t\t\t<a href="" ng-click="resetPayslipLabel($ctrl)" class="pill-input-field-item-delete" aria-label="Reset payslip label"><i class="icon-plus"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Save for future use -->\n\t\t\t\t\t<div class="pill-input-details fadeIn" ng-show="$ctrl.form.newAdjustmentLabel.$valid && $ctrl.vm.newAdjustment.Label.length > $ctrl.vm.SEARCH_TERM_MIN_COUNT && !$ctrl.vm.selectedAdjustmentLabel">\n\t\t\t\t\t\t<input type="checkbox" class="{{!$ctrl.vm.newAdjustment.adjustmentType ? \'secondary\' : $ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="saveLabel" name="saveLabel" ng-model="$ctrl.vm.saveLabel" label-text="\'Save for future use\'" checkbox>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Search results -->\n\t\t\t\t\t<div class="pill-input-search-results has-action dropIn" ng-show="$ctrl.vm.newAdjustment.Label.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT && !$ctrl.vm.selectedAdjustmentLabel && $ctrl.vm.showPayslipLabelResults" ng-if="$ctrl.vm.adjustmentLabels.length" click-anywhere-but-here="toggleShowPayslipLabelResults($ctrl, false)" is-active="$ctrl.vm.newAdjustment.Label.length >= $ctrl.vm.SEARCH_TERM_MIN_COUNT && !$ctrl.vm.selectedAdjustmentLabel">\n\n\t\t\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Payslip labels</p>\n\t\t\t\t\t\t\t<button aria-label="Select payslip label" type="button" class="pill-input-search-result is-clear secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel($ctrl, adjustmentLabel, false)" ng-repeat="adjustmentLabel in filteredAdjustmentLabels = ( $ctrl.vm.adjustmentLabels | filter: $ctrl.vm.labelFilter | filter: $ctrl.vm.newAdjustment.Label ) | orderBy:[\'IsDeduction\', \'AgencyAdjustmentGroupEntryText\']">\n\t\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-label" is-light="true" theme="is-medium {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}"></icon-dot>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{adjustmentLabel.AgencyAdjustmentLabelText}} <span>{{adjustmentLabel.AdjustmentText}}</span></p>\n\t\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<p ng-if="!filteredAdjustmentLabels.length"><span class="caption">No &lsquo;{{$ctrl.vm.newAdjustment.adjustmentType.AgencyAdjustmentGroupEntryText}}&rsquo; payslip labels found</span></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Pension -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.CAN_ATTACH_PENSION_SCHEME && ($ctrl.vm.newAdjustment.adjustmentType.IsEmployeePension || $ctrl.vm.newAdjustment.adjustmentType.IsEmployerPension)">\n\n\t\t\t\t<!-- Select pension for adjustment -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="!$ctrl.pensionState || ($ctrl.pensionState && $ctrl.vm.selectedTeamMembers[0].pensions.length > 0)">\n\t\t\t\t\t<div class="pill-input-field {{$ctrl.vm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}">\n\t\t\t\t\t\t<label for="agencyEmployerPensionId" class="pill-input-field-label"><i class="icon-money"></i> Pension scheme</label>\n\n\t\t\t\t\t\t<div ng-switch="$ctrl.pensionState">\n\n\t\t\t\t\t\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="fadeIn" ng-switch-when="ready">\n\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<select id="agencyEmployerPensionId" name="agencyEmployerPensionId" ng-model="$ctrl.vm.newAdjustment.AgencyEmployerPensionID" ng-disabled="$ctrl.vm.selectedTeamMembers[0].pensions.length === 1" ng-options="pension.AgencyEmployerPensionID as pension.pensionLabel for pension in $ctrl.vm.selectedTeamMembers[0].pensions" required>\n\t\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Select a pension scheme</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addAChangeForm.agencyEmployerPensionId.$error" ng-if="addAChangeForm.agencyEmployerPensionId.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a pension</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Team member isn\'t in a pension -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.pensionState && $ctrl.vm.selectedTeamMembers[0].pensions.length === 0">\n\t\t\t\t\t<note note-title="Pension scheme" note-icon="icon-warning" note-theme="tertiary is-form-field">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">Please note that {{$ctrl.vm.selectedTeamMembers[0].Forename}} isn\u2019t a member of a pension scheme so the selected type of change can\u2019t be used.</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Recurring -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.IS_RECURRING_ENABLED">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<extended-toggle-input field-label="Make this change recurring" field-model="$ctrl.vm.newAdjustment.Recurring" field-name="isRecurring">\n\t\t\t\t\t\t\t<field-content>\n\n\t\t\t\t\t\t\t\t<input type="radio" name="recurForXPayPeriods" id="recurForXPayPeriodsFalse" class="b" ng-value="false" ng-model="$ctrl.vm.recurForXPayPeriods">\n\t\t\t\t\t\t\t\t<label for="recurForXPayPeriodsFalse">Every pay period</label>\n\n\t\t\t\t\t\t\t\t<input type="radio" name="recurForXPayPeriods" id="recurForXPayPeriodsTrue" class="b" ng-value="true" ng-model="$ctrl.vm.recurForXPayPeriods">\n\t\t\t\t\t\t\t\t<label for="recurForXPayPeriodsTrue">For</label>\n\n\t\t\t\t\t\t\t\t<input class="s-alt" type="number" name="recurringPeriodCount" id="recurringPeriodCount" required min="1" ng-model="$ctrl.vm.newAdjustment.RecurringPeriodCount" ng-disabled="!$ctrl.vm.recurForXPayPeriods" ng-blur="$ctrl.vm.getPayPeriodForPeriodCount($ctrl.vm)" ng-max="$ctrl.vm.newAdjustment.RecurringPeriodCountMax">\n\n\t\t\t\t\t\t\t\t<label class="is-inline is-medium" for="recurForXPayPeriodsTrue">&nbsp;&nbsp;&nbsp;pay periods</label>\n\n\t\t\t\t\t\t\t\t<div class="form-field-footer fadeIn" ng-if="$ctrl.vm.recurForXPayPeriods">\n\t\t\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.vm.recurringPayPeriodDisplay">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">The final change will be added to payroll in the {{vm.recurringPayPeriodDisplay}} period</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.vm.recurringPayPeriodDisplay">\n\t\t\t\t\t\t\t\t\t\t<p class="form-message fadeIn" ng-if="$ctrl.vm.form.recurringPeriodCount.$valid">\n\t\t\t\t\t\t\t\t\t\t\tYour change can recur for a maximum of {{$ctrl.vm.newAdjustment.RecurringPeriodCountMax}} pay periods\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.vm.form.recurringPeriodCount.$error" ng-if="$ctrl.vm.form.recurringPeriodCount.$invalid" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 1</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">This change can recur for a maximum of {{$ctrl.vm.newAdjustment.RecurringPeriodCountMax}} pay periods</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</field-content>\n\t\t\t\t\t\t</extended-toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</section>\n\n\t\t\t<!-- Override business categories -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.newAdjustment.businessCategories !== undefined">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<extended-toggle-input field-label="Override business categories" field-model="$ctrl.vm.newAdjustment.overrideBusinessCategories" field-on-change="$ctrl.vm.onBusinessCategoriesOverrideChange($ctrl)" field-name="overrideBusinessCategories">\n\t\t\t\t\t\t\t<field-content>\n\t\t\t\t\t\t\t\t<business-categories-override business-categories="$ctrl.vm.newAdjustment.businessCategories" user-forename="$ctrl.vm.selectedTeamMembers[0].Forename">\n\t\t\t\t\t\t\t\t</business-categories-override>\n\t\t\t\t\t\t\t</field-content>\n\t\t\t\t\t\t</extended-toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</section>\n\n\t\t\t<!-- Preview -->\n\t\t\t<section class="change-creator_section fadeIn" ng-if="$ctrl.vm.IS_ADJUSTMENT_PREVIEW_ENABLED && $ctrl.vm.newAdjustment.Value">\n\t\t\t\t<adjustment-summary-card adjustment="$ctrl.vm.newAdjustment" adjustment-label="$ctrl.adjustmentLabel" adjustment-label-context="$ctrl.vm.teamDescriptionLabel"></adjustment-summary-card>\n\t\t\t</section>\n\n\t\t\t<!-- Tax treatment -->\n\t\t\t<section class="change-creator_section has-separator-top fadeIn" ng-if="$ctrl.vm.IS_TAX_TREATMENT_ENABLED">\n\n\t\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t\t<button type="button" class="detail-blocks-toggle is-clear clickable" ng-class="{\'active\' : $ctrl.vm.showTaxTreatment } " ng-click="$ctrl.vm.showTaxTreatment = !$ctrl.vm.showTaxTreatment">\n\t\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t\t<i class="icon-chevron-up"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t\t{{$ctrl.vm.showTaxTreatment ? \'Hide\' : \'Show\'}} tax treatment\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : $ctrl.vm.showTaxTreatment}">\n\n\t\t\t\t\t\t<adjustment-type-tax-treatment adjustment-type="$ctrl.vm.newAdjustment.adjustmentType"></adjustment-type-tax-treatment>\n\n\t\t\t\t\t\t<div class="detail-blocks-hidden_footer">\n\t\t\t\t\t\t\t<em class="is-small">You can review pension treatment for pay elements by clicking the &lsquo;Manage pay elements&rsquo; action in your pension schemes.</em>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</section>\n\n\t</div>\n\n\t<!-- No team members -->\n\t<div ng-switch-when="no-team-members">\n\t\t<message-bar theme="assertive">\n\t\t\t<p>Where did all the team members go? \uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F</p>\n\t\t</message-bar>\n\t\t<hr class="l">\n\t</div>\n\n\t<!-- No adjustment types -->\n\t<div ng-switch-when="no-adjustment-types">\n\t\t<message-bar theme="assertive">\n\t\t\t<p>Where did all the adjustments go? \uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F</p>\n\t\t</message-bar>\n\t\t<hr class="l">\n\t</div>\n</div>\n');
$templateCache.put('components/changes-imported/changes-imported.component.html','<div class="changes-imported">\n\t<div class="changes-imported_layout">\n\t\t<div class="changes-imported_content">\n\t\t\t<div class="changes-imported_block is-plain">\n\t\t\t\t<div class="changes-imported_header is-spl">\n\t\t\t\t\t<h6 class="changes-imported_heading">\n\t\t\t\t\t\t<i class="icon-excel is-primary">&nbsp;&nbsp;Changes table</i>\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t\t<p class="changes-imported_paragraph">{{$ctrl.changesTableMessage}}</p>\n\t\t\t\t<a href="" class="is-small strong" ng-if="$ctrl.changesTableCanBeSubmitted" ng-click="$ctrl.submitChanges($ctrl)">\n\t\t\t\t\t<i class="icon-arrow-right is-medium"></i><span class="m">&nbsp;&nbsp;Submit</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="changes-imported_section">\n\t\t\t<a href="" ng-click="$ctrl.openChangesTable($ctrl)" class="changes-imported_block has-footer is-secondary">\n\t\t\t\t<div class="changes-imported_header is-split">\n\t\t\t\t\t<h6 class="changes-imported_heading">\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.payElements.additions.count" when="{\'1\': \'1 addition\', \'other\': \'{} additions\'}"></ng-pluralize>\n\t\t\t\t\t</h6>\n\n\t\t\t\t\t<div class="changes-imported_arrow">\n\t\t\t\t\t\t<i class="changes-imported_content icon-chevron-right"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="changes-imported_footer">\n\t\t\t\t\t<span class="changes-imported_content">\n\t\t\t\t\t\tTotal:\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<span class="changes-imported_content">\n\t\t\t\t\t\t{{$ctrl.payElements.additions.value | monetise}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="changes-imported_section">\n\t\t\t<a href="" ng-click="$ctrl.openChangesTable($ctrl)" class="changes-imported_block has-footer is-assertive">\n\t\t\t\t<div class="changes-imported_header is-split">\n\t\t\t\t\t<h6 class="changes-imported_heading">\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.payElements.deductions.count" when="{\'1\': \'1 deduction\', \'other\': \'{} deductions\'}"></ng-pluralize>\n\t\t\t\t\t</h6>\n\n\t\t\t\t\t<div class="changes-imported_arrow">\n\t\t\t\t\t\t<i class="changes-imported_content icon-chevron-right"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="changes-imported_footer">\n\t\t\t\t\t<span class="changes-imported_content">\n\t\t\t\t\t\tTotal:\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<span class="changes-imported_content">\n\t\t\t\t\t\t{{$ctrl.payElements.deductions.value | monetise}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/changes-table/changes-table.component.html','<div class="changes-table">\n\n\t<div class="changes-table_container" ng-switch="$ctrl.componentState">\n\n\t\t<!-- Loading -->\n\t\t<div class="changes-table_section fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\n\t\t<!-- Error -->\n\t\t<div class="changes-table_section fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t\t<error-block></error-block>\n\t\t</div>\n\n\t\t<!-- No team members -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.payrollPartiallySubmitted">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<i class="changes-table_state-icon icon-warning is-tertiary xxl"></i>\n\t\t\t\t\t<h6 class="changes-table_state-heading">Payroll was only partially submitted</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content">\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\tYour {{$ctrl.submittedFiles.submittedSubmissonsDisplay}} for {{$root.currentPeriod.PayPeriodDisplay}} {{ $ctrl.submittedFiles.submittedSubmissons.length > 1 ? \'have\' : \'has\' }} been successfully submitted but your full submission has failed.\n\t\t\t\t\t\tIf you need to make changes that would affect the data that has already been submitted, please contact support.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- No team members -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.noTeamMembers">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<i class="changes-table_state-icon icon-warning is-primary xxl"></i>\n\t\t\t\t\t<h6 class="changes-table_state-heading">You have no team members available to add changes to</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content" ng-if="$root.currentUser.Permissions.isTeamVisible">\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\tThis may be because their profile is incomplete, they\'re excluded from payroll, or they\'re marked as \'On hold\', \'Off payroll\', or \'Advancing\'.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Import confirmation -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.confirmImport">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<icon-dot icon="icon-question-mark" theme="is-giant is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<h6 class="changes-table_state-heading">Are you sure you wish to import these changes?</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content">\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\tOnce these changes have been imported you won\u2019t be able to access the changes table again for this period.\n\t\t\t\t\t\tIf you realise you\u2019ve forgotten to include a change it will need to be added manually. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="changes-table_state-actions">\n\t\t\t\t\t\t<a href="" class="changes-table_button button is-small" ng-click="$ctrl.setComponentState($ctrl.COMPONENT_STATES.ready)">Cancel</a>\n\t\t\t\t\t\t<a href="" class="changes-table_button button is-small tertiary" ng-click="$ctrl.onConfirmImport($ctrl)">Confirm</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- No adjustments available -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.noAdjustmentsAvailable">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<i class="changes-table_state-icon icon-warning is-tertiary xxl"></i>\n\t\t\t\t\t<h6 class="changes-table_state-heading">Unable to view changes table</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content">\n\t\t\t\t\t<p class="changes-table_state-paragraph" ng-if="($ctrl.missingPayElementDescriptions.length === 0)">\n\t\t\t\t\t\tNo pay elements available in pay element packs assigned to {{::$root.currentCompany.Name}}.\t\t\t\t\t\t\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="changes-table_state-paragraph" ng-if="($ctrl.missingPayElementDescriptions.length > 0)">\n\t\t\t\t\t\tOne or more pay elements that were previously used to add changes are no longer available in one of the pay element packs assigned to {{::$root.currentCompany.Name}}. \n\t\t\t\t\t\tPlease add the following pay elements to one of the pay element packs to view the changes table:\n\t\t\t\t\t</p>\n\t\t\t\t\t<bullet-list bl-items="$ctrl.missingPayElementDescriptions" bl-theme="is-small is-primary is-spaced-out" ng-class="[\'missing-pay-elements-list\']" ng-if="($ctrl.missingPayElementDescriptions.length > 0)">\n\t\t\t\t\t</bullet-list>\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\t<a href="" class="is-primary is-underline" ng-click="$ctrl.changesOptions.closeModal()">\n\t\t\t\t\t\t\tOk, close this window\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Importing -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.importing">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<circle-loader size="l"></circle-loader>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<h6 class="changes-table_state-heading">Your changes are being imported\u2026</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content">\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\tThis should only take a few moments. <br>\n\t\t\t\t\t\tPlease don\u2019t close your browser.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Imported -->\n\t\t<div class="changes-table_section fadeIn changes-table_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.imported">\n\n\t\t\t<div class="changes-table_state">\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<icon-dot icon="icon-tick" theme="is-giant is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-header">\n\t\t\t\t\t<h6 class="changes-table_state-heading">Your changes have been imported!</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="changes-table_state-content">\n\t\t\t\t\t<p class="changes-table_state-paragraph">\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.payElementSavedCount" when="{\'1\': \'1 change has\', \'other\': \'{} changes have\'}"></ng-pluralize>&nbsp;been imported to your payroll<br>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.goToCompanyState($ctrl, \'payroll.current-period.changes\')" class="primary underline">Go to changes</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\n\t\t<!-- Ready -->\n\t\t<form name="$ctrl.changesTableForm" autocomplete="off" ng-submit="$ctrl.updateUserPayElementsForImportGroup($ctrl)" class="changes-table_section fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\n\t\t\t<div class="changes-table_header" ng-switch="$ctrl.headerState">\n\n\t\t\t\t<div class="changes-table_header-layout fadeIn is-split" ng-switch-default>\n\t\t\t\t\t<div class="changes-table_header-section">\n\t\t\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<label for="teamMemberViewOptions">Display:</label>\n\t\t\t\t\t\t\t\t<select class="changes-table_header-display-options" id="teamMemberViewOptions" name="teamMemberViewOptions" ng-model="$ctrl.teamMemberView" ng-options="option.prop as option.display for option in $ctrl.TEAM_MEMBER_VIEW_TYPES">\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<span ng-if="$ctrl.payElementSavedCount >= 1">{{$ctrl.payElementSavedCount}} saved</span>\n\t\t\t\t\t\t\t\t<span ng-if="$ctrl.payElementSavedCount === 0">No changes saved</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="changes-table_header-section">\n\t\t\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<a href="" class="button primary is-small fadeIn" ng-click="$ctrl.setComponentState($ctrl.COMPONENT_STATES.confirmImport)" ng-if="$root.userHasRole([\'paycircle\', \'bureau\', \'bureaumanager\'])">Import changes</a>\n\t\t\t\t\t\t\t\t<submit-button button-theme="\'tertiary is-small changes-table_button\'" display-text="\'Save\'" state="$ctrl.changesTableForm.state" disable-button="$ctrl.changesTableForm.$invalid"></submit-button>\n\t\t\t\t\t\t\t\t<a href="" class="button is-small" ng-click="$ctrl.onCancelClick($ctrl)">Close</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<a href="" class="link-with-icon greyscale" ng-click="$ctrl.setHeaderState($ctrl.HEADER_STATES.delete)">\n\t\t\t\t\t\t\t\t\t<i class="icon-trash s"></i> Delete all\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="changes-table_header-layout fadeIn is-centered" pc-switch-when="$ctrl.HEADER_STATES.cancel">\n\t\t\t\t\t<h6 class="changes-table_header-heading">You have unsaved changes, are you sure you wish to cancel?</h6>\n\t\t\t\t\t<a href="" class="changes-table_button button is-small tertiary" ng-click="$ctrl.changesOptions.closeModal()">Yes</a>\n\t\t\t\t\t<a href="" class="changes-table_button button is-small" ng-click="$ctrl.setHeaderState($ctrl.HEADER_STATES.default)">No</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="changes-table_header-layout fadeIn is-centered" pc-switch-when="$ctrl.HEADER_STATES.delete">\n\t\t\t\t\t<h6 class="changes-table_header-heading">Are you sure you wish to delete all changes? This cannot be undone</h6>\n\t\t\t\t\t<a href="" class="changes-table_button button is-small tertiary" ng-click="$ctrl.deleteUserImportGroup($ctrl)">Yes</a>\n\t\t\t\t\t<a href="" class="changes-table_button button is-small" ng-click="$ctrl.setHeaderState($ctrl.HEADER_STATES.default)">No</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="changes-table_wrapper">\n\n\t\t\t\t<div class="changes-table_grid">\n\n\t\t\t\t\t<div class="changes-table_grid-header changes-table_grid-row">\n\n\t\t\t\t\t\t<div class="changes-table_grid-cell changes-table_grid-heading changes-table_grid-filters">\n\t\t\t\t\t\t\t<div class="changes-table_grid-entry is-in-corner">\n\t\t\t\t\t\t\t\t<p class="changes-table_grid-heading-text" ng-if="!$ctrl.showSearch"><ng-pluralize count="$ctrl.teamMembersFiltered.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></p>\n\t\t\t\t\t\t\t\t<input ng-if="$ctrl.showSearch" id="changes-table-search" type="search" class="fadeIn block small" results="5" ng-model="$ctrl.searchOptions.search.string" placeholder="Search team...">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="changes-table_grid-cell changes-table_grid-options">\n\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleSearch($ctrl)" class="changes-table_grid-search">\n\t\t\t\t\t\t\t\t\t<i ng-class="{\'icon-search\' : !$ctrl.showSearch, \'icon-cross\' : $ctrl.showSearch} "></i>&nbsp;&nbsp;<span ng-if="$ctrl.showSearch">Close search</span>\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<dropdown-menu class="primary" menu-show="$ctrl.searchOptions.showOrderByMenu" menu-text="{{$ctrl.searchOptions.orderByObj.title}}">\n\t\t\t\t\t\t\t\t\t<a href="" class="primary" ng-repeat="orderByOption in $ctrl.searchOptions.orderByOptions" ng-click="$ctrl.changeOrderBy($ctrl.searchOptions, orderByOption)" ng-class="{\'active\': $ctrl.searchOptions.orderByObj.key === orderByOption.key}">{{orderByOption.title}}</a>\n\t\t\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="changes-table_grid-content">\n\n\t\t\t\t\t\t\t<div class="changes-table_grid-cell changes-table_grid-heading" ng-repeat="payElement in $ctrl.payElements" ng-class="::{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }" style="--column-width: {{::payElement.columnWidth}}px;">\n\t\t\t\t\t\t\t\t<div class="changes-table_grid-entry">\n\t\t\t\t\t\t\t\t\t{{::payElement.AgencyAdjustmentGroupEntryText}}\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="changes-table_grid-cell changes-table_grid-values is-in-header" ng-switch="payElement.AgencyAdjustmentValueType">\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tTotal (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.unit">\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\t{{::payElement.AgencyAdjustmentUnitLabel}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\t{{::payElement.AgencyAdjustmentValueLabel}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tTotal (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.percentage">\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\t% Age\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tValue (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tTotal (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.linked">\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header is-select">\n\t\t\t\t\t\t\t\t\t\t\tRate\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tValue (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tUnits\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tMultiplier\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-in-header">\n\t\t\t\t\t\t\t\t\t\t\tTotal (\xA3)\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="changes-table_grid-body" style="--row-count: {{$ctrl.teamMembersFiltered.length}};">\n\n\t\t\t\t\t\t<!-- Empty search -->\n\t\t\t\t\t\t<div class="changes-table_grid-row fadeIn" ng-if="$ctrl.teamMembersFiltered.length === 0">\n\t\t\t\t\t\t\t<div class="changes-table_grid-cell is-warning">\n\t\t\t\t\t\t\t\t<p class="s">Unfortunately your search returned no results! Try searching again or changing your filters.</p>\n\t\t\t\t\t\t\t\t<button class="changes-table_grid-clear" ng-click="$ctrl.searchOptions.search.string = \'\'">Clear search</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="changes-table_grid-row fadeIn" ng-repeat="teamMember in $ctrl.teamMembersFiltered = ( $ctrl.teamMembers | filter : $ctrl.searchOptions.search.string) | orderBy : $ctrl.searchOptions.orderBy : $ctrl.searchOptions.results.reverse">\n\n\t\t\t\t\t\t\t<div class="changes-table_grid-cell is-in-body changes-table_grid-person">\n\t\t\t\t\t\t\t\t<div class="changes-table_grid-avatar">\n\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{::teamMember.fullname[0]}}" avatar-size="is-tiny" avatar-theme="is-primary"></avatar>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="changes-table_grid-person-info">\n\t\t\t\t\t\t\t\t\t<h6 class="changes-table_grid-name">{{teamMember[$ctrl.teamMemberView] | checkEmpty:\'Unknown\'}}</h6>\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-job-title" ng-if="teamMember.jobTitle" title="{{teamMember.jobTitle}}">\n\t\t\t\t\t\t\t\t\t\t{{teamMember.jobTitle}}\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="changes-table_grid-content">\n\t\t\t\t\t\t\t\t<div class="changes-table_grid-cell is-in-body" ng-repeat="payElement in $ctrl.payElements" style="--column-width: {{::payElement.columnWidth}}px;">\n\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-default" ng-if="!$ctrl.updatedPayElements[teamMember.postId][payElement.id]">\n\t\t\t\t\t\t\t\t\t\t<a href="" class="link-with-icon changes-table_grid-icon clickable" ng-click="$ctrl.addNewPayElementForTeamMember($ctrl, teamMember, payElement)"><i class="icon-add"></i> Add</a>\n\t\t\t\t\t\t\t\t\t\t<span class="changes-table_grid-demo" tooltip-plus tp-options="$ctrl.TOOLTIPS.addingChanges" tp-on-click="$ctrl.openMarkAsActiveTooltip($ctrl)" ng-if="$first && $parent.$parent.$first"></span>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-values" ng-if="$ctrl.updatedPayElements[teamMember.postId][payElement.id]" ng-switch="payElement.AgencyAdjustmentValueType">\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessagesTotals" id="{{::teamMember.postId + payElement.id}}" name="adjustmentTotalValue" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Value" ng-pattern="$root.REGEX.number9Digits2Decimal" type="text" required>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.unit">\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" id="{{::teamMember.postId + payElement.id}}" name="adjustmentUnits" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Units" ng-pattern="$root.REGEX.number7Digits4Decimal" type="text" required>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" name="adjustmentUnitValue" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].UnitValue" ng-pattern="$root.REGEX.number7Digits4Decimal" type="text" required>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="inline-block" readonly="readonly" name="adjustmentTotalValue" ng-class="::{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Value" type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.percentage">\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" id="{{::teamMember.postId + payElement.id}}" name="adjustmentUnits" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Units" ng-pattern="$root.REGEX.number7Digits4Decimal" type="text" required>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" name="adjustmentUnitValue" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].UnitValue" ng-pattern="$root.REGEX.number7Digits4Decimal" type="text" required>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="inline-block" name="adjustmentTotalValue" ng-class="::{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Value" readonly="readonly" type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-items" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.linked">\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item is-select">\n\t\t\t\t\t\t\t\t\t\t\t\t<select class="changes-table-select" error-field error-messages="$ctrl.errorMessagesRate" id="{{::teamMember.postId + payElement.id}}" name="salaryRate" ng-change="$ctrl.selectSalaryRate($ctrl, teamMember, payElement)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].selectedRate" ng-options="rate as (rate.SalaryRateDisplay) for rate in $ctrl.rates[teamMember.postId].SalaryRatesWithCalculated track by rate.SalaryRateID" required>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="">Select a rate...</option>\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item" ng-if="$ctrl.updatedPayElements[teamMember.postId][payElement.id].selectedRate.SalaryRateID === \'custom\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" name="adjustmentUnitValue" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\': ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].UnitValue" ng-model-options="{ debounce:500 }" ng-pattern="$root.REGEX.number7Digits4Decimal" required type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item" ng-if="$ctrl.updatedPayElements[teamMember.postId][payElement.id].selectedRate.SalaryRateID !== \'custom\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="inline-block" name="adjustmentUnitValue" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].UnitValue" ng-model-options="{ debounce:500 }" readonly="readonly" type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessages" name="adjustmentUnits" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Units" ng-model-options="{ debounce:500 }" ng-pattern="$root.REGEX.number7Digits4Decimal" required type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="inline-block" error-field error-messages="$ctrl.errorMessagesMultiplier" name="adjustmentMultiplier" ng-change="$ctrl.onCellChange($ctrl)" ng-class="{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction, \'is-read-only\' : ($ctrl.updatedPayElements[teamMember.postId][payElement.id].state === $ctrl.PAY_ELEMENT_STATES.edited ) }" ng-click="$ctrl.onTableCellClick($ctrl, teamMember, payElement)" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].UnitValueMultiplier" ng-model-options="{ debounce:500 }" ng-pattern="$root.REGEX.number7Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="changes-table_grid-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="inline-block" name="adjustmentTotalValue" ng-class="::{\'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }" ng-model="$ctrl.updatedPayElements[teamMember.postId][payElement.id].Value" readonly="readonly" type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<a aria-label="Delete pay element" class="changes-table_grid-action changes-table_grid-icon" href="#" ng-click="$ctrl.deletePayElementFromTeamMember($ctrl, teamMember, payElement)">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="changes-table_grid-footer changes-table_grid-row">\n\t\t\t\t\t\t<div class="changes-table_grid-totals is-in-footer changes-table_grid-cell">\n\t\t\t\t\t\t\tTotal\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="changes-table_grid-content">\n\t\t\t\t\t\t\t<div class="changes-table_grid-cell is-in-footer" style="--column-width: {{::payElement.columnWidth}}px;" ng-repeat="payElement in $ctrl.payElements" ng-class="{ \'is-greyscale\': payElement.totalValue === 0, \'is-positive\': !payElement.IsDeduction, \'is-assertive\': payElement.IsDeduction }">\n\t\t\t\t\t\t\t\t{{payElement.totalValue | monetise:$root.CONFIG.precision.salaryRates}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</form>\n\n\t</div>\n\n</div>\n');
$templateCache.put('components/circle-loader/circleLoaderComponent.html','<div class="circle-loader {{size}}">\n\t<div class="one"></div>\n\t<div class="two"></div>\n\t<div class="three"></div>\n</div>');
$templateCache.put('components/code-field/code-field.component.html','<div class="code-field" ng-class="[$ctrl.theme, {\'is-disabled\' : $ctrl.fieldDisabled }]">\n\n\t<!-- Header -->\n\t<header class="code-field_header" ng-if="$ctrl.title">\n\t\t<h5 class="code-field_title">{{$ctrl.title}}</h5>\n\t</header>\n\n\t<!-- Individual digits -->\n\t<div class="code-field_layout" ng-mouseover="$ctrl.onMouseOver($ctrl)" ng-mouseleave="$ctrl.onMouseLeave($ctrl)">\n\t\t<div class="code-field_section" ng-class="{\'is-active\': $ctrl.isMouseOver || $ctrl.isFocussed }">\n\t\t\t<input aria-label="Code field character 1" autocomplete="off" class="code-field_input" id="field1" maxlength="1" minlength="1" name="field1" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model="$ctrl.fields.field1" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" required type="text">\n\n\t\t\t<input aria-label="Code field character 2" autocomplete="off" class="code-field_input" id="field2" maxlength="1" minlength="1" name="field2" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model="$ctrl.fields.field2" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" required type="text">\n\n\t\t\t<input aria-label="Code field character 3" autocomplete="off" class="code-field_input" id="field3" maxlength="1" minlength="1" name="field3" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model="$ctrl.fields.field3" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" ni-forward-target="field4" required type="text">\n\t\t</div>\n\n\t\t<div class="code-field_section" ng-class="{\'is-active\': $ctrl.isMouseOver || $ctrl.isFocussed }">\n\t\t\t<input aria-label="Code field character 4" autocomplete="off" class="code-field_input" id="field4" maxlength="1" minlength="1" name="field4" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model="$ctrl.fields.field4" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" ni-backward-target="field3" required type="text">\n\n\t\t\t<input aria-label="Code field character 5" autocomplete="off" class="code-field_input" id="field5" maxlength="1" minlength="1" name="field5" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model="$ctrl.fields.field5" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" required type="text">\n\n\t\t\t<input aria-label="Code field character 6" autocomplete="off" class="code-field_input" id="field6" maxlength="1" minlength="1" name="field6" next-input ng-blur="$ctrl.onBlur($ctrl)" ng-change="$ctrl.onChange($ctrl)" ng-disabled="$ctrl.fieldDisabled" ng-focus="$ctrl.onFocus($ctrl)" ng-model-options="{ debounce:500 }" ng-model="$ctrl.fields.field6" ng-paste="$ctrl.onPaste($ctrl, $event)" ng-pattern="$root.REGEX.numbersOnly" required type="text">\n\t\t</div>\n\t</div>\n\n\t<!-- Footer -->\n\t<div class="code-field_footer fadeIn" ng-if="$ctrl.hasFooter && $ctrl.showFooter" ng-transclude="footer"></div>\n\n\t<!-- For validation -->\n\t<input type="text" ng-model="$ctrl.code" hidden aria-hidden="true">\n</div>\n');
$templateCache.put('components/collapsible-list/collapsible-list.component.html','<div class="collapsible-list">\n\t<div class="collapsible-list_header">\n\t\t<span class="collapsible-list_header-label">\n\t\t\t{{$ctrl.label}}\n\t\t</span>\n\t\t<a class="button is-white" href ng-click="$ctrl.toggleIsActive($ctrl)">\n\t\t\t<span>{{$ctrl.isActive ? \'Hide\' : \'Show\'}}</span>\n\t\t</a>\n\t\t<div class="collapsible-list_header-actions" ng-if="$ctrl.hasActions" ng-transclude="collapsibleListActions"></div>\n\t</div>\n\t<div class="collapsible-list_content fadeIn" ng-if="$ctrl.isActive" ng-transclude="collapsibleListContent"></div>\n</div>\n');
$templateCache.put('components/colour-picker/colourPickerComponent.html','<div class="colour-picker">\n\t<input type="text" name="{{cpId}}" ng-model="colour" ng-change="onChange(colour)" ng-pattern="$root.REGEX.hex" maxlength="7" class="colour-picker__input">\n\t<label for="{{cpId}}" class="colour-picker__colour" ng-style="{\'background-color\': colour, \'empty\': !colour || colour === \'\'}"></label>\n\t<aside class="colour-picker__popout">\n\t\t<div class="colour-picker__layout">\n\t\t\t<div class="colour-picker__spectrum">\n\t\t\t\t<button class="colour-picker__cursor colour-picker__cursor--spectrum"></button>\n\t\t\t\t<canvas class="colour-picker__canvas colour-picker__canvas--spectrum"></canvas>\n\t\t\t</div>\n\t\t\t<div class="colour-picker__hue">\n\t\t\t\t<button class="colour-picker__cursor colour-picker__cursor--hue"></button>\n\t\t\t\t<canvas class="colour-picker__canvas colour-picker__canvas--hue"></canvas>\n\t\t\t</div>\n\t\t</div>\n\t</aside>\n\t<div class="colour-picker__background"></div>\n</div>\n');
$templateCache.put('components/communications-timeline/communicationsTimelineComponent.html','<div class="communications-timeline fadeIn">\n\n\t<header>\n\t\t<h6>Pension communications timeline</h6>\n\t\t<p class="s">Paycircle sends these communications at the following times. Select one for more info.</p>\n\t\t<a href="" ng-click="" class=""></a>\n\t</header>\n\n\t<main>\n\t\t<div class="communication hidden-phone" ng-repeat="communication in pensionComms" ng-class="{\'open\': selected === $index}" ng-hide="communication.id === \'postponement-notice\' && !companyPostponed">\n\t\t\t<div class="popup dropIn fast {{communication.popupPosition}}" ng-if="selected === $index">\n\t\t\t\t<h5>{{communication.name}}</h5>\n\t\t\t\t<p class="s">{{communication.description}}<span class="s" ng-if="communication.auto">&nbsp;Paycircle will automatically send this email on your behalf if it hasn\'t been sent already.</span></p>\n\n\t\t\t\t<ul class="actions" ng-if="communication.canPreview">\n\t\t\t\t\t<li><a ui-sref="email-preview({agencyProfileId: agencyProfileId, mailtypeid: communication.mailTypeId})">Preview email</a></li>\n\t\t\t\t\t<li><a ui-sref="document-preview({agencyProfileId: agencyProfileId, agencyEmployerPensionId: agencyEmployerPensionId, agencyEmployerPensionId: agencyEmployerPensionId, mailtypeid: communication.mailTypeId})">View printable version</a></li>\n\t\t\t\t</ul>\n\t\t\t\t<a href="" class="close" ng-click="toggleSelected($index)" aria-label="Toggle communication"><i class="icon-cross m"></i></a>\n\t\t\t</div>\n\t\t\t<a class="description" href="" ng-click="toggleSelected($index)">{{communication.name}}</a>\n\t\t\t<a class="counter a l" href="" ng-class="{\'primary\': selected !== $index, \'tertiary\': selected === $index}" ng-click="toggleSelected($index)"><i class="icon-add"></i><span class="marker xs tertiary" ng-if="communication.canSendManually"></span></a>\n\t\t\t<span class="date">{{communication.date}}</span>\n\t\t</div>\n\t</main>\n\n\t<footer>\n\t\t<p class="s"><span class="marker xs tertiary"></span>&nbsp;&nbsp;Can be sent manually before the automatic send date</p>\n\t</footer>\n</div>\n');
$templateCache.put('components/communications-timeline/communicationsTimelineComponentMobile.html','<div class="communications-timeline-mobile">\n\n\t<div ng-if="selected === -1">\n\t\t<h6>Communication Timeline</h6>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="s">Paycircle will automatically email communications to your employees, on certain dates, so your compliance duties are met and your team are aware of what\'s happening with the pension.</p>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="s"><em>Click a communication for more info</em></p>\n\t</div>\n\n\t<div class="fadeIn" ng-repeat="communication in pensionComms" ng-if="selected === $index">\n\t\t<p class="s strong"><span class="primary">Communication {{$index + 1}}:</span>&nbsp;{{communication.name}}</p>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="s">{{communication.description}}</p>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="s strong" ng-if="communication.canPreview">\n\t\t\t<a class="underline" ui-sref="email-preview({agencyProfileId: agencyProfileId, mailtypeid: communication.mailTypeId})">Preview email</a>&nbsp;&nbsp;&nbsp;\n\t\t\t<a class="underline" ui-sref="document-preview({agencyProfileId: agencyProfileId, agencyEmployerPensionId: agencyEmployerPensionId, mailtypeid: communication.mailTypeId})">View printable version</a>\n\t\t</p>\n\t</div>\n\n\t<div class="spacer xl"></div>\n\n\t<section class="timeline-bar">\n\t\t<div class="timeline-item" ng-repeat="communication in pensionComms" ng-hide="communication.id === \'postponement-notice\' && !companyPostponed">\n\t\t\t<a href="" class="counter a l" ng-click="toggleSelected($index)" ng-class="{\'tertiary\': selected === $index, \'primary\': selected !== $index}" aria-label="Toggle communication"><i class="icon-add"></i></a>\n\t\t</div>\n\t</section>\n</div>\n');
$templateCache.put('components/company-activity/company-activity.component.html','<div class="company-activity" ng-switch="pageState">\n\n\t<div ng-switch-when="loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<div ng-switch-when="ready">\n\n\t\t<div class="company-activity_header" ng-if="vm.logCategories.length > 1">\n\t\t\t<select class="block" ng-model="vm.logCategoryId" ng-options="logCategory.id as logCategory.name for logCategory in vm.logCategories | orderBy : name"></select>\n\t\t</div>\n\n\t\t<div ng-if="vm.logEntries.length">\n\n\t\t\t<activity-log al-style="{\n\t\t\t\t\t\'animation-delay\': ($index * 0.05) + \'s\'\n\t\t\t\t}" log-entry="logEntry" ng-repeat="logEntry in filteredLogEntries = (\n\t\t\t\t\tvm.logEntries |\n\t\t\t\t\tfilter: {\n\t\t\t\t\t\tCategoryID: vm.logCategoryId\n\t\t\t\t\t} |\n\t\t\t\t\torderBy:\'-dateUnix\'\n\t\t\t\t)" theme="{{$last ? \'is-last\' : \'\'}} activity-log_fade-in"></activity-log>\n\n\t\t\t<p class="s fadeIn" ng-if="!filteredLogEntries.length">\n\t\t\t\tThere\'s no recent activity to show.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<p class="is-small fadeIn" ng-if="!vm.logEntries.length">\n\t\t\tThere\'s no recent activity to show.\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/company-archived-card/companyArchivedCard.html','<div class="company-archived-card fadeIn" ng-mouseleave="hideMenus()">\n\n\t<header class="company-archived-card-header">\n\t\t<a ui-sref="company-dashboard({agencyProfileId: company.Company.AgencyProfileID})" class="company-archived-card-name" title="{{company.Company.Name}}">{{company.Company.Name}}</a>\n\t\t<p class="company-archived-card-meta">\n\t\t\t<span ng-if="::company.Company.ArchiveDateISO !== \'\'">Archived: {{company.Company.ArchiveDateISO | dateformat}}</span>\n\t\t\t<span ng-if="::company.Company.ArchiveDateISO === \'\'">Archived: Unknown</span>\n\t\t</p>\n\t</header>\n\n\t<main class="company-archived-card-main">\n\t\t<p class="company-archived-card-description">{{company.Company.ArchiveReason}}</p>\n\t\t<p class="company-archived-card-meta">Reason</p>\n\t</main>\n\n\t<dropdown-menu class="company-archived-card-menu" menu-size="l" menu-show-chevron="false" menu-icon="icon-setup" menu-show="options.showMenu">\n\n\t\t<!-- General -->\n\t\t<div class="dropdown-group">\n\t\t\t<a ui-sref="company-dashboard({agencyProfileId: company.Company.AgencyProfileID})" title="Go to company">Go to company</a>\n\t\t\t<a href="" ng-click="openManageAdminsForm(company)" title="Manage admins">Manage admins</a>\n\t\t\t<a href="" ng-click="openUndoArchiveCompanyForm(company)" title="Undo archive">Undo archive</a>\n\t\t\t<!--<a href="" ng-click="openExportDataForm(company)" title="Export data">Export data</a>-->\n\t\t</div>\n\n\t\t<!-- Delete\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="openDeleteCompanyForm(company)" class="assertive" title="Delete company">Delete company</a>\n\t\t</div>-->\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/company-card/company-card.component.html','<div class="company-card fadeIn" data-cy="company-{{ ::$ctrl.company.Company.Name | slugify }}" ng-class="{\n\t\t\'is-basic-view\': $ctrl.isBasicView,\n\t\t\'payslip-manager-company\': $ctrl.company.Company.IsPayslipManagerActive,\n\t\t\'selected\': $ctrl.company.isSelected,\n\t\t\'test-company\': $ctrl.company.Company.IsInTestMode && !$ctrl.company.Company.AgencyProfileDummy && !$ctrl.isBasicView\n\t}" ng-mouseleave="$ctrl.hideMenus()">\n\n\t<div class="company-card-header" ng-class="{\n\t\t\t\'has-checkbox\': $ctrl.isBulkSelectionEnabled\n\t\t}">\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="checkbox-field company-card-checkbox" ng-if="::$ctrl.isBulkSelectionEnabled">\n\t\t\t<input aria-label="Select {{$ctrl.company.Company.Name}}" id="{{$ctrl.company.Company.AgencyProfileID}}" ng-change="$ctrl.onCheckboxToggle($ctrl)" ng-model="$ctrl.company.isSelected" type="checkbox">\n\t\t\t<label class="checkbox-field-tickbox" for="{{$ctrl.company.Company.AgencyProfileID}}"></label>\n\t\t</div>\n\n\t\t<!-- Company Name -->\n\t\t<a class="company-card-name" data-cy="company-card_name" title="{{$ctrl.company.Company.Name}}" ui-sref="company-dashboard({\n\t\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t\t})">{{$ctrl.company.Company.Name}}</a>\n\n\t\t<!-- PAYE Reference -->\n\t\t<p class="company-card-meta" ng-if="::!$ctrl.company.Company.CISOnly && !$ctrl.company.Company.IsPayslipManagerActive">\n\t\t\tPAYE Ref: {{$ctrl.company.Company.PAYERef === \'/\' ? \'\' : $ctrl.company.Company.PAYERef | checkEmpty:\'Unknown\'}}\n\t\t</p>\n\n\t\t<!-- UTR -->\n\t\t<p class="company-card-meta" ng-if="::$ctrl.company.Company.CISOnly">\n\t\t\tUTR: {{$ctrl.company.Company.UTR | checkEmpty:\'unknown\'}}\n\t\t</p>\n\n\t\t<!-- Team Count -->\n\t\t<div class="company-card-team-count" ng-if="!$root.userHasRole($ctrl.USER_ROLES.groupadminlite)">\n\t\t\t<i class="icon-team-alt l"></i>{{$ctrl.company.Company.TeamMemberCount}}\n\t\t</div>\n\t</div>\n\n\t<div class="company-card-main" ng-if="!$ctrl.company.Company.IsPayslipManagerActive">\n\n\t\t<!-- Payroll -->\n\t\t<section class="company-card-section">\n\t\t\t\n\t\t\t<!-- Current Period (non group managers) -->\n\t\t\t<p class="company-card-section-heading" ng-class="{\n\t\t\t\t\t\'inactive\': $ctrl.company.Company.PensionOnly\n\t\t\t\t}">\n\t\t\t\t{{$ctrl.company.PayPeriod.PayPeriodDisplay | checkEmpty:\'No periods set up\'}}\n\t\t\t\t<span ng-if="$ctrl.shouldShowTaxPeriod($ctrl.company.PayPeriod)">\n\t\t\t\t\t{{$ctrl.getPeriodDisplayText($ctrl.company.PayPeriod)}}\n\t\t\t\t</span>\n\t\t\t</p>\n\t\t\t<p class="company-card-meta" ng-class="{\n\t\t\t\t\t\'inactive\': $ctrl.company.Company.PensionOnly\n\t\t\t\t}">\n\t\t\t\tCurrent period\n\t\t\t</p>\n\n\t\t\t<div class="company-card-states" ng-if="!$root.userHasRole($ctrl.USER_ROLES.groupadminlite)">\n\n\t\t\t\t<!-- Payroll State -->\n\t\t\t\t<payroll-state cease-paye-scheme-complete="$ctrl.company.Company.CeasePAYESchemeComplete" ceased-date="$ctrl.company.Company.PAYECeaseDateISO" class="company-card-state" pay-period="$ctrl.company.PayPeriod"></payroll-state>\n\n\t\t\t\t<!-- Auto run -->\n\t\t\t\t<div class="company-card-state is-autorun" ng-if="$ctrl.company.Company.IsAutoRun && !$ctrl.company.PayPeriod.IsCompulsorySubmission && $root.currentUser.canSeeAutoRun">\n\t\t\t\t\t<i class="icon-clock quarternary is-small"></i>&nbsp; Auto run\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Compulsory submission -->\n\t\t\t<div class="company-card-warning" ng-if="$ctrl.company.PayPeriod.IsCompulsorySubmission && !$root.userHasRole($ctrl.USER_ROLES.groupadminlite)">\n\t\t\t\t<i class="icon-warning assertive company-card-warning-icon"></i>&nbsp; Warning\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Pay day -->\n\t\t<section class="company-card-section has-no-aside" ng-class="{\n\t\t\t\t\'invisible\' : $ctrl.company.PayPeriod.PayPeriodDisplay === \'\'\n\t\t\t}">\n\t\t\t<p class="company-card-section-heading">\n\t\t\t\t{{$ctrl.company.PayPeriod.PayDateISO | dateformat:\'custom\':\'Do MMM\'}}\n\t\t\t</p>\n\t\t\t<p class="company-card-meta">Pay day</p>\n\t\t</section>\n\n\t\t<!-- Pension -->\n\t\t<section class="company-card-section" ng-if="!$root.userHasRole($ctrl.USER_ROLES.groupadminlite)">\n\t\t\t<p class="company-card-section-heading" ng-class="{\n\t\t\t\t\t\'inactive\': !$ctrl.company.Company.HasPension\n\t\t\t\t}" title="{{::$ctrl.company.Company.HasPension ? $ctrl.company.Pension.ProviderName : \'Not connected\'}}">\n\t\t\t\t{{::$ctrl.company.Company.HasPension ? $ctrl.company.Pension.ProviderName : \'Not connected\'}}\n\t\t\t</p>\n\t\t\t<p class="company-card-meta" ng-class="{\n\t\t\t\t\t\'inactive\': !$ctrl.company.Company.HasPension\n\t\t\t\t}">\n\t\t\t\tPension\n\t\t\t</p>\n\n\t\t\t<!-- Not Running Pension -->\n\t\t\t<div class="company-card-states">\n\n\t\t\t\t<!-- Inactive -->\n\t\t\t\t<span class="tag greyscale company-card-state" ng-if="!$ctrl.company.Company.HasPension">\n\t\t\t\t\tInactive\n\t\t\t\t</span>\n\n\t\t\t\t<!-- Not Authorised / Rejected -->\n\t\t\t\t<pension-scheme-state class="company-card-state" ng-if="::$ctrl.company.Company.HasPension && [\n\t\t\t\t\t\t\t$ctrl.PENSION_STATES.unauthorised,\n\t\t\t\t\t\t\t$ctrl.PENSION_STATES.rejected,\n\t\t\t\t\t\t\t$ctrl.PENSION_STATES.reenrolment\n\t\t\t\t\t\t].includes($ctrl.company.Pension.State)\n\t\t\t\t\t" state="$ctrl.company.Pension.State"></pension-scheme-state>\n\n\t\t\t\t<!-- Running Pension -->\n\t\t\t\t<div ng-if="::$ctrl.company.Company.HasPension" ng-switch="$ctrl.company.PayPeriod.PensionSubmitState">\n\t\t\t\t\t<span class="tag tertiary company-card-state" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t<i class="icon-loading spin"></i> Pending\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="tag secondary company-card-state" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\t\t\tComplete\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="tag assertive inverse company-card-state" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\t\t\tFailed\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="tag tertiary company-card-state" pc-switch-when="$ctrl.SUBMISSION_STATES.resubmit">\n\t\t\t\t\t\t<i class="icon-loading spin"></i> Pending\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</section>\n\t</div>\n\n\t<div class="company-card-main" ng-if="$ctrl.company.Company.IsPayslipManagerActive">\n\t\t<section class="company-card-section align-middle">\n\t\t\t<span class="is-small">\n\t\t\t\t<i class="icon-payslip primary n"></i>&nbsp;&nbsp;Payslip manager\n\t\t\t</span>\n\t\t</section>\n\n\t\t<div class="company-card-section"></div>\n\t</div>\n\n\t<!-- States -->\n\t<div class="company-card-footer" ng-if="::$root.userHasRole(\'paycircle\') && !$ctrl.isBasicView">\n\n\t\t<div class="company-card-footer-header">\n\t\t\t<p>Submissions</p>\n\t\t</div>\n\n\t\t<div class="company-card-footer-main">\n\n\t\t\t<!-- Payroll -->\n\t\t\t<section class="company-card-footer_section">\n\n\t\t\t\t<!-- FPS -->\n\t\t\t\t<div class="company-card-submission-state" ng-switch="$ctrl.company.PayPeriod.FPSState">\n\t\t\t\t\t<p class="tertiary" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t<i class="icon-loading spin"></i>FPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="positive" title="Sent on: {{$ctrl.company.PayPeriod.RTISubmissionDateISO | dateformat:\'long\'}}" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<i class="icon-tick"></i>FPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="assertive" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<i class="icon-cross"></i>FPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="company-card-submission-state-placeholder" ng-switch-default title="Not processed yet or other state ({{$ctrl.company.PayPeriod.FPSState}})">\n\t\t\t\t\t\t<i class="icon-clock"></i>FPS\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- EPS -->\n\t\t\t\t<div class="company-card-submission-state" ng-switch="$ctrl.company.PayPeriod.EPSState">\n\t\t\t\t\t<p class="tertiary" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t<i class="icon-loading spin"></i>EPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="positive" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted" title="Sent on: {{$ctrl.company.PayPeriod.RTISubmissionDateISO | dateformat:\'long\'}}">\n\t\t\t\t\t\t<i class="icon-tick"></i>EPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="assertive" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<i class="icon-cross"></i>EPS\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="company-card-submission-state-placeholder" ng-switch-default title="Not processed yet or other state ({{$ctrl.company.PayPeriod.EPSState}})">\n\t\t\t\t\t\t<i class="icon-clock"></i>EPS\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Report -->\n\t\t\t\t<div class="company-card-submission-state" ng-switch="$ctrl.company.PayPeriod.ReportState">\n\t\t\t\t\t<p class="tertiary" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t<i class="icon-loading spin"></i>Reports\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="positive" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<i class="icon-tick"></i>Reports\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="assertive" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<i class="icon-cross"></i>Reports\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="company-card-submission-state-placeholder" ng-switch-default title="Not processed yet or other state ({{$ctrl.company.PayPeriod.ReportState}})">\n\t\t\t\t\t\t<i class="icon-clock"></i>Reports\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Pay Day (Blank) -->\n\t\t\t<section class="company-card-footer_section is-empty">\n\t\t\t\t<!--  -->\n\t\t\t</section>\n\n\t\t\t<!-- Pension -->\n\t\t\t<section class="company-card-footer_section">\n\n\t\t\t\t<div class="company-card-submission-state" ng-switch="$ctrl.company.PayPeriod.PensionSubmitState">\n\t\t\t\t\t<p class="tertiary" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t<i class="icon-loading spin"></i>Pension\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="positive" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<i class="icon-tick"></i>Pension\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="assertive" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<i class="icon-cross"></i>Pension\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="company-card-submission-state-placeholder" ng-switch-default title="Not processed yet or other state ({{$ctrl.company.PayPeriod.PensionSubmitState}})">\n\t\t\t\t\t\t<i class="icon-clock"></i>Pension\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<div class="company-card-footer_link" ng-if="$ctrl.company.PayPeriod.rtiErrorType > -1">\n\t\t\t<a class="s underline strong" href="" ng-click="$ctrl.showResetPeriodConfirmation($ctrl)">\n\t\t\t\tReset\n\t\t\t</a>\n\t\t</div>\n\t</div>\n\n\t<!-- Workflow -->\n\t<div class="company-card-workflow" ng-if="$ctrl.company.Company.IsWorkflowActive">\n\n\t\t<div class="company-card-workflow_primary">\n\t\t\t<p>\n\t\t\t\t<i class="icon-workflow-alt primary"></i>&nbsp;&nbsp;\n\t\t\t\t<span class="company-card-workflow_label">\n\t\t\t\t\t{{$ctrl.company.Company.WorkflowStage}}\n\t\t\t\t</span>&nbsp;&nbsp;&nbsp;\n\t\t\t\t<span class="tag company-card-workflow_tag" ng-class="$ctrl.company.Company.IsWorkflowOverdue ? \'assertive\' : \'positive\'">\n\t\t\t\t\t<i class="icon-clock s"></i>&nbsp;Due: {{$ctrl.company.Company.WorkflowDueDateISO | datetimeformat:\'long\'}}\n\t\t\t\t</span>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Non PM Company -->\n\t<div ng-if="!$ctrl.isBasicView">\n\n\t\t<i class="icon-ellipses company-card-menus-placeholder"></i>\n\n\t\t<!-- Company Menu -->\n\t\t<div class="company-card-menus" ng-if="$ctrl.company.PayPeriod.PayrollState !== $ctrl.SUBMISSION_STATES.submitting">\n\n\t\t\t<!-- Payroll -->\n\t\t\t<dropdown-menu class="company-card-menu a" data-cy="company-card-menu" menu-icon="icon-setup" menu-id="company-card-menu" menu-show-chevron="false" menu-show="$ctrl.options.showMenu" menu-size="l">\n\n\t\t\t\t<!-- General -->\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a class="positive" data-cy="company-card-menu-open-next-period" href="" ng-click="$ctrl.reloadCompany()" ng-if="$ctrl.company.PayPeriod.PayrollState === $ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\t\t\tOpen next period\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="company-card_menu-company-overview" data-cy="company-card-menu-overview" href="" ng-click="$ctrl.openCompanyOverviewForm($ctrl.company)">\n\t\t\t\t\t\tCompany overview\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-go-to-company" title="Go to company" ui-sref="company-dashboard({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tGo to company\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-manage-groups" href="" ng-click="$ctrl.openManageCompanyGroupsForm($ctrl.company)" ng-if="$root.currentUser.Permissions.Admin.canManageCompanyGroups" title="Manage groups">\n\t\t\t\t\t\tManage groups\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-manage-admins" href="" ng-click="$ctrl.openManageAdminsForm($ctrl.company)" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPermissions">\n\t\t\t\t\t\tManage admins\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-manage-visibility" href="" ng-click="$ctrl.openManageVisibilityForm()" ng-if="$root.currentUser.Permissions.Admin.canManageBureauAdmins || $root.currentUser.Permissions.Admin.canManageCompanyGroupAdmins">\n\t\t\t\t\t\tManage visibility\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-manage-pay-elements" href="" ng-click="$ctrl.openManagePayElementsForm($ctrl.company)" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPayroll">\n\t\t\t\t\t\tManage pay elements\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-manage-reports" href="" ng-click="$ctrl.openManageReportPacksForm($ctrl.company)" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports">\n\t\t\t\t\t\tManage reports\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-journals-settings" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports" ui-sref="settings.company.journals.nominal-codes({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tJournal settings\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-workflow-settings" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPayroll" ui-sref="settings.company.workflow({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tWorkflow settings\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-clone-payroll" href="" ng-click="$ctrl.openClonePayrollForm($ctrl.company)" ng-if="::!$ctrl.isClone && !$root.userHasRole($ctrl.USER_ROLES.groupuser)">\n\t\t\t\t\t\tClone payroll\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-bacs-penny-test" href="" ng-click="$ctrl.openBacsPennyTestForm($ctrl.company)" ng-if="::$ctrl.isClone">\n\t\t\t\t\t\tBACS penny test\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-reset-payroll" href="" ng-click="$ctrl.showResetPeriodConfirmation($ctrl)" ng-if="::($root.currentUser.Permissions.Payroll.canRunPayroll && $ctrl.company.PayPeriod.rtiErrorType > -1)">\n\t\t\t\t\t\tReset payroll\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Unsubmitted Payrolls Only -->\n\t\t\t\t<div class="dropdown-group" ng-if="$ctrl.company.PayPeriod.PayrollState === $ctrl.SUBMISSION_STATES.unsubmitted && $ctrl.company.Company.PAYECeaseDateISO === \'\'">\n\t\t\t\t\t<a data-cy="company-card-menu-view-changes" href="" ng-click="$ctrl.openViewChangesForm($ctrl.company)" ng-if="$ctrl.company.PayPeriod.NumberOfAdjustments > 0">\n\t\t\t\t\t\tView changes\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-add-a-change" href="" ng-click="$ctrl.openAddAChangeForm($ctrl.company)" ng-if="$ctrl.company.PayPeriod.NumberOfAdjustments === 0 && $root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\t\t\tAdd a change\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="company-card-menu-run-period" href="" ng-click="$ctrl.openRunPayrollForm($ctrl.company)" ng-if="::!$ctrl.company.Company.IsWorkflowEnabled && $root.currentUser.Permissions.Payroll.canRunPayroll">\n\t\t\t\t\t\t<span ng-if="$ctrl.company.Company.TeamMemberCount === 0">\n\t\t\t\t\t\t\tRun nil payroll\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="$ctrl.company.Company.TeamMemberCount > 0">\n\t\t\t\t\t\t\t{{$ctrl.company.Company.PensionOnly ? \'Run period\' : \'Run payroll\'}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Test / Live Mode -->\n\t\t\t\t<div class="dropdown-group" ng-if="!$ctrl.company.Company.AgencyProfileDummy && $ctrl.company.Company.CanBeMadeTest && $root.currentUser.Permissions.isCompanySettingsVisible">\n\n\t\t\t\t\t<!-- In Test Mode -->\n\t\t\t\t\t<div ng-if="$ctrl.company.Company.IsInTestMode">\n\t\t\t\t\t\t<p class="dropdown-label is-small is-tertiary">\n\t\t\t\t\t\t\t<span class="marker s tertiary"></span> In Test Mode\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a data-cy="company-card-menu-switch-to-live-mode" href="" ng-click="$ctrl.openSwitchToLiveForm($ctrl.company)">\n\t\t\t\t\t\t\tSwitch to Live Mode\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- In Live Mode -->\n\t\t\t\t\t<div class="dropdown-group" ng-if="!$ctrl.company.Company.IsInTestMode">\n\t\t\t\t\t\t<p class="dropdown-label positive">\n\t\t\t\t\t\t\t<span class="marker s positive"></span> In Live Mode\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a data-cy="company-card-menu-switch-to-test-mode" href="" ng-click="$ctrl.openSwitchToTestForm($ctrl.company)">\n\t\t\t\t\t\t\tSwitch to Test Mode\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Archive -->\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a class="is-assertive" data-cy="company-card-menu-delete-clone" href="" ng-click="$ctrl.openDeleteCloneForm($ctrl.company)" ng-if="::$ctrl.isClone">\n\t\t\t\t\t\tDelete clone\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="greyscale" data-cy="company-card-menu-close-paye-scheme" href="" ng-click="$ctrl.openCeasePayeForm($ctrl.company)" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPayroll && $ctrl.company.Company.PAYECeaseDateISO === \'\'">\n\t\t\t\t\t\tClose PAYE scheme\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="greyscale" data-cy="company-card-menu-archive-company" href="" ng-click="$ctrl.openArchiveCompanyForm($ctrl.company)">\n\t\t\t\t\t\tArchive company\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="is-assertive" data-cy="company-card-menu-delete-company" href="" id="company-overview_delete-company" ng-click="$ctrl.deleteCompany()" ng-if="!$ctrl.isClone && $ctrl.company.Company.CanBeDeleted && $root.currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t\t\t\tDelete company\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\n\t\t\t<!-- Reports -->\n\t\t\t<dropdown-menu class="company-card-menu b" menu-icon="icon-download" menu-id="company-card-reports-menu" menu-on-open="$ctrl.getReportsForCompany($ctrl)" menu-show-chevron="false" menu-show="$ctrl.options.showReportMenu" menu-size="l" ng-if="!$ctrl.isBasicView && $root.currentUser.Permissions.isReportingVisible">\n\t\t\t\t<div ng-switch="$ctrl.reportDownloadState" ng-class="{\n\t\t\t\t\t\t\'dropdown-group\' : $ctrl.reportDownloadState === \'loading\' || ($ctrl.costingReports.length > 0 || $ctrl.pensionReports.length > 0 || $ctrl.p32Reports.length > 0)}\n\t\t\t\t\t">\n\t\t\t\t\t<div class="centered-contents fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="fadeIn" ng-switch-when="ready">\n\n\t\t\t\t\t\t<!-- Costings -->\n\t\t\t\t\t\t<div ng-show="$ctrl.costingReports.length > 0">\n\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Costings report:</p>\n\t\t\t\t\t\t\t<report-export-item report="costingReport" ng-repeat="costingReport in $ctrl.costingReports = ($ctrl.reports | reportCategories:\'costings-url\')"></report-export-item>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pension -->\n\t\t\t\t\t\t<div ng-show="$ctrl.pensionReports.length > 0">\n\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Pension report:</p>\n\t\t\t\t\t\t\t<report-export-item report="pensionReport" ng-repeat="pensionReport in $ctrl.pensionReports = ($ctrl.reports | reportCategories:\'pension-url\')"></report-export-item>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- P32 -->\n\t\t\t\t\t\t<div ng-show="$ctrl.p32Reports.length > 0">\n\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">P32 report:</p>\n\t\t\t\t\t\t\t<report-export-item report="p32Report" ng-repeat="p32Report in $ctrl.p32Reports = ($ctrl.reports | reportCategories:\'p32-url\')"></report-export-item>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" ng-click="$ctrl.openCrossPeriodReportForm($ctrl.company)">\n\t\t\t\t\t\tCross period report\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\n\t\t<!-- Test/Live Mode -->\n\t\t<div ng-if="!$ctrl.company.Company.AgencyProfileDummy">\n\n\t\t\t<!-- Running parallel -->\n\t\t\t<span class="marker s tertiary company-card-marker" ng-if="$ctrl.company.Company.IsInTestMode" title="In Test Mode"></span>\n\n\t\t\t<!-- First live payroll -->\n\t\t\t<span class="marker s positive company-card-marker" ng-if="!$ctrl.company.Company.IsInTestMode && $ctrl.company.Company.CanBeMadeTest" title="First live payroll"></span>\n\t\t</div>\n\t</div>\n\n\t<!-- PM Company -->\n\t<div ng-if="$ctrl.company.Company.IsPayslipManagerActive">\n\n\t\t<i class="icon-ellipses company-card-menus-placeholder"></i>\n\n \t\t<div class="company-card-menus">\n\t\t\t<dropdown-menu class="company-card-menu a" data-cy="company-card-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.options.showMenu" menu-size="l">\n\n\t\t\t\t<!-- General -->\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a title="Go to company" ui-sref="company-dashboard({\n\t\t\t\t\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tGo to company\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Archive/Delete -->\n\t\t\t\t<div class="dropdown-group" ng-if="$ctrl.company.PayPeriod.PayrollState !== $ctrl.SUBMISSION_STATES.submitting && $root.currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t\t\t<a class="assertive" href="" id="company-overview_delete-company" ng-click="$ctrl.deleteCompany()" ng-if="$ctrl.company.Company.CanBeDeleted">\n\t\t\t\t\t\tDelete company\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="greyscale" href="" ng-click="$ctrl.openArchiveCompanyForm($ctrl.company)" ng-if="!$ctrl.company.Company.CanBeDeleted">\n\t\t\t\t\t\tArchive company\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n \t\t</div>\n\t</div>\n\n\t<!-- GAL -->\n\t<a aria-label="Go to company" ng-if="$root.userHasRole($ctrl.USER_ROLES.groupadminlite)" ui-sref="company-dashboard({\n\t\t\tagencyProfileId: $ctrl.company.Company.AgencyProfileID\n\t\t})">\n\t\t<i class="icon-chevron-right company-card-menus-action is-primary"></i>\n\t</a>\n\n\t<!-- Loading Mask -->\n\t<div class="company-card-loader" ng-if="$ctrl.company.PayPeriod.ReportState === $ctrl.SUBMISSION_STATES.submitting || $ctrl.company.PayPeriod.PayrollState === $ctrl.SUBMISSION_STATES.submitting || $ctrl.isCompanyBeingDeleted">\n\t\t<p class="company-card-loader-info">\n\t\t\t<circle-loader></circle-loader>\n\t\t\t<span ng-if="$ctrl.company.PayPeriod.ReportState === $ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\tGenerating reports...\n\t\t\t</span>\n\t\t\t<span ng-if="$ctrl.company.PayPeriod.PayrollState === $ctrl.SUBMISSION_STATES.submitting">\n\t\t\t\tRunning {{$ctrl.company.Company.PensionOnly ? \'period\' : \'payroll\'}}...\n\t\t\t</span>\n\t\t\t<span ng-if="$ctrl.isCompanyBeingDeleted">\n\t\t\t\tDeleting company...\n\t\t\t</span>\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/company-group-card/company-group-card.component.html','<div class="company-group-card fadeIn" data-cy="company-group-{{ ::$ctrl.companyGroup.Company.Name | slugify }}" ng-class="{\n\t\t\'menu-open\': $ctrl.showMenu\n\t}" ng-mouseleave="$ctrl.hideMenu($ctrl)">\n\n\t<header class="company-group-card-header">\n\t\t<i class="icon-company-groups company-group-card-icon"></i>\n\t\t<a class="company-group-card-name" data-cy="company-group-card-heading" ui-sref="companies({agencyProfileId: $ctrl.companyGroup.Company.AgencyProfileID})">\n\t\t\t{{$ctrl.companyGroup.Company.Name}}\n\t\t</a>\n\t\t<p class="s company-group-card-phone"><ng-pluralize count="$ctrl.companyGroup.Company.CompanyCount" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize></p>\n\t</header>\n\n\t<dropdown-menu class="company-group-card-action-menu" menu-icon="icon-setup" menu-id="company-group-menu" menu-show="$ctrl.showMenu" menu-size="l">\n\t\t<div class="dropdown-group">\n\t\t\t<a data-cy="company-group-menu-go-to-group" ui-sref="dashboard({agencyProfileId: $ctrl.companyGroup.Company.AgencyProfileID})">Go to group</a>\n\t\t\t<a data-cy="company-group-menu-create-company" href="" ng-click="$ctrl.openAddCompanyWizard($ctrl)" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanies">Create company</a>\n\t\t\t<a data-cy="company-group-menu-auto-create-company" href="" ng-click="$ctrl.openAutoCreateCompanyForm($ctrl)" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanies && $ctrl.companyGroup.Company.AgencyProfileDummy">Auto-create company</a>\n\t\t\t<a data-cy="company-group-menu-manage-admins" href="" ng-click="$ctrl.openManageAdminsForm($ctrl)" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroupSettings && $root.currentUser.Permissions.Admin.canManageCompanyGroupAdmins">Manage admins</a>\n\t\t\t<a data-cy="company-group-menu-manage-reports" href="" ng-click="$ctrl.openManageReportPacksForm($ctrl)" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroupSettings">Manage reports</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroups">\n\t\t\t<a data-cy="company-group-menu-delete-group" href="" class="assertive" ng-click="$ctrl.openDeleteCompanyGroupForm($ctrl)">Delete group</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/company-group-card-basic/companyGroupCardBasic.html','<div class="company-group-card company-group-card-basic fadeIn" ng-class="{\'menu-open\': vm.showMenu}">\n\n\t<header class="company-group-card-header">\n\t\t<i class="icon-company-groups company-group-card-icon"></i>\n\t\t<p class="company-group-card-name">{{companyGroup.Name}}</p>\n\t</header>\n\n\t<a href="" class="company-group-card-action" ng-click="removeCompanyGroup(companyGroup)" aria-label="Remove group"><i class="icon-cross"></i></a>\n\n\t<!--\n\t<dropdown-menu class="company-group-card-action-menu" menu-show="vm.showMenu" menu-size="l" menu-icon="icon-setup">\n\t\t<a href="" class="assertive" ng-click="removeFromGroup(companyGroup)">Remove from group</a>\n\t</dropdown-menu>\n\t-->\n</div>\n');
$templateCache.put('components/company-message-bar/company-message-bar.component.html','<section class="company-message-bar">\n\n\t<!-- Archived -->\n\t<message-block class="company-message-bar-message" ng-if="$ctrl.company.IsArchived" theme="greyscale">\n\t\t<p>\n\t\t\t<span class="tag greyscale inverse has-margin-right">\n\t\t\t\tArchived\n\t\t\t</span>\n\t\t\t{{$ctrl.company.Name}} was archived\n\t\t\t<span ng-if="$ctrl.company.ArchiveDateISO !== \'\'">\n\t\t\t\tat {{$ctrl.company.ArchiveDateISO | datetimeformat:\'time12\'}}\n\t\t\t</span>\n\t\t\ton {{$ctrl.company.ArchiveDateISO | dateformat:\'long\'}}.\n\t\t\t<a ui-sref="companies-archived({\n\t\t\t\t\tagencyProfileId: $ctrl.parentCompany.AgencyProfileID\n\t\t\t\t})" class="greyscale underline" ng-if="$ctrl.parentCompany && $root.currentUser.Permissions.isCompanySettingsVisible">\n\t\t\t\tView archived companies\n\t\t\t</a>\n\t\t</p>\n\t</message-block>\n\n\t<!-- PAYE Ceased -->\n\t<message-block class="company-message-bar-message" ng-if="$ctrl.company.CeasePAYESchemeComplete" theme="assertive">\n\t\t<p>\n\t\t\t<span class="tag assertive inverse has-margin-right">\n\t\t\t\tClosed\n\t\t\t</span>\n\t\t\t<strong>{{$ctrl.company.PAYERef}}</strong> - this PAYE scheme was closed on {{$ctrl.company.PAYECeaseDateISO | dateformat}}\n\t\t</p>\n\t</message-block>\n\n\t<!-- PAYE set to Cease -->\n\t<message-block class="company-message-bar-message" ng-if="!$ctrl.company.CeasePAYESchemeComplete && $ctrl.company.PAYECeaseDateISO !== \'\'" theme="indifferent">\n\t\t<p>\n\t\t\t<span class="tag indifferent inverse has-margin-right">Closing</span>\n\t\t\t<strong>{{$ctrl.company.PAYERef}}</strong> - this PAYE scheme is set to close on {{$ctrl.company.PAYECeaseDateISO | dateformat}}\n\t\t</p>\n\t</message-block>\n\n\t<!-- In test mode -->\n\t<message-block class="company-message-bar-message" ng-if="$ctrl.company.IsInTestMode && !$ctrl.company.AgencyProfileDummy" theme="tertiary">\n\t\t<p>\n\t\t\t<span class="tag tertiary inverse has-margin-right">Test</span>\n\t\t\t{{$ctrl.company.Name}} are running in Test Mode.\n\t\t\t<a class="underline tertiary" href="" ng-click="$ctrl.openSwitchToLiveForm($ctrl.company)" ng-if="$root.currentUser.Permissions.isCompanySettingsVisible">\n\t\t\t\tSwitch to Live Mode\n\t\t\t</a>\n\t\t</p>\n\t</message-block>\n\n\t<!-- First live payroll run -->\n\t<message-block class="company-message-bar-message" ng-if="!$ctrl.company.AgencyProfileDummy && $ctrl.company.CanBeMadeTest" theme="secondary">\n\t\t<p>\n\t\t\t<span class="tag secondary inverse has-margin-right">Live</span>\n\t\t\tThis is the first live period for {{$ctrl.company.Name}}.&nbsp;\n\t\t\t<span ng-if="(\n\t\t\t\t$root.currentUser.Permissions.isCompanySettingsVisible &&\n\t\t\t\t!$root.userHasRole([\n\t\t\t\t\t\'groupadminlite\',\n\t\t\t\t\t\'companyadministratorlite\']\n\t\t\t\t))">\n\t\t\t\tNot ready?&nbsp;\n\t\t\t\t<a class="secondary underline" href="" ng-click="$ctrl.openSwitchToLiveForm($ctrl.company)">\n\t\t\t\t\tSwitch back to Test Mode\n\t\t\t\t</a>\n\t\t\t</span>\n\t\t</p>\n\t</message-block>\n\n\t<!-- Cloned -->\n\t<message-block class="company-message-bar-message" ng-if="$ctrl.company.IsClone" theme="quarternary">\n\t\t<p>\n\t\t\t<span class="tag quarternary inverse has-margin-right">Clone</span>\n\t\t\t{{$ctrl.company.Name}} was cloned at {{$ctrl.company.CloneDateISO | datetimeformat:\'detailed\'}}&nbsp;\n\t\t\t<a class="underline is-quarternary" ui-sref="companies-cloned({agencyProfileId: $ctrl.parentCompany.AgencyProfileID})">\n\t\t\t\tView cloned payrolls\n\t\t\t</a>\n\t\t</p>\n\t</message-block>\n</section>\n');
$templateCache.put('components/company-onboarding-card/companyOnboardingCard.html','<div class="company-onboarding-card">\n\t<div class="company-onboarding-card__layout">\n\t\t<div class="company-onboarding-card__details">\n\t\t\t<div class="company-onboarding-card__context" ng-if="company.IsCompanyCreated">\n\t\t\t\t<a ui-sref="company-dashboard({agencyProfileId: company.AgencyProfileID})" class="company-onboarding-card__name" title="{{company.Name}}">{{company.Name}}</a>\n\t\t\t\t<p class="company-onboarding-card__period-type">{{company.PeriodType | payPeriodTypeDescription:\'monthly\' | capitalise}} payroll</p>\n\t\t\t</div>\n\t\t\t<div class="company-onboarding-card__context" title="{{company.Name}}" ng-if="!company.IsCompanyCreated">\n\t\t\t\t<p class="company-onboarding-card__name">{{company.Name}}</p>\n\t\t\t</div>\n\t\t\t<div class="company-onboarding-card__date" ng-switch="company.AdminInviteState">\n\t\t\t\t<div pc-switch-when="ADMIN_INVITE_STATES.registered">\n\t\t\t\t\t<p>{{company.CreatedDateISO | dateformat:\'simple\'}}</p>\n\t\t\t\t\t<p class="company-onboarding-card__date-label">Registered</p>\n\t\t\t\t</div>\n\t\t\t\t<div ng-switch-default>\n\t\t\t\t\t<p class="company-onboarding-card__date-label">Not registered yet</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="company-onboarding-card__status">\n\t\t\t<div class="company-onboarding-card__progress" ng-switch="company.State">\n\t\t\t\t<progress-bar pc-switch-when="COMPANY_STATES.demo" pb-size="is-large" pb-theme="is-primary has-gradient" pb-percentage="company.DemoPercentComplete"></progress-bar>\n\t\t\t\t<progress-bar pc-switch-when="COMPANY_STATES.onboarding" pb-size="is-large" pb-theme="is-tertiary has-gradient" pb-percentage="company.OnboardingPercentComplete"></progress-bar>\n\t\t\t\t<progress-bar pc-switch-when="COMPANY_STATES.firstPeriod" pb-size="is-large" pb-theme="is-secondary has-gradient" pb-percentage="company.OnboardingPercentComplete"></progress-bar>\n\t\t\t\t<progress-bar pc-switch-when="COMPANY_STATES.readyToRun" pb-size="is-large" pb-theme="is-quarternary has-gradient" pb-percentage="company.OnboardingPercentComplete"></progress-bar>\n\t\t\t</div>\n\t\t\t<div class="company-onboarding-card__state" ng-switch="company.State">\n\t\t\t\t<span pc-switch-when="COMPANY_STATES.demo"><a href="" class="tag primary" tooltip tooltip-text="{{company.DaysToExpiry > 0 ? company.DaysToExpiry + \' days left\' : \'30 days left\'}}">Demo</a></span>\n\t\t\t\t<span pc-switch-when="COMPANY_STATES.onboarding" class="tag tertiary">Onboarding</span>\n\t\t\t\t<span pc-switch-when="COMPANY_STATES.firstPeriod"><a href="" class="tag secondary" tooltip tooltip-text="{{company.IsInTestMode ? \'Test mode\' : \'Live mode\'}}">First Period</a></span>\n\t\t\t\t<span pc-switch-when="COMPANY_STATES.readyToRun" class="tag quarternary">Ready to Run</span>\n\t\t\t</div>\n\t\t\t<div class="company-onboarding-card__state">\n\t\t\t\t<span class="tag primary inverse" ng-if="company.IsExpired">Expired</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="company-onboarding-card__menu">\n\t\t\t<dropdown-menu class="a" menu-size="l" menu-show-chevron="false" menu-icon="icon-setup">\n\n\t\t\t\t<div class="dropdown-group" ng-switch="company.State">\n\n\t\t\t\t\t<!-- Demo -->\n\t\t\t\t\t<div pc-switch-when="COMPANY_STATES.demo">\n\t\t\t\t\t\t<a href="" ng-click="resendInvite(company)" ng-if="company.AdminInviteState !== ADMIN_INVITE_STATES.registered">Resend invite&nbsp;<circle-loader class="s" ng-if="company.inviteSendingState"></circle-loader></a>\n\t\t\t\t\t\t<a href="" ng-click="openOnboardingChecklistForm(company)">View demo checklist</a>\n\t\t\t\t\t\t<a href="" ng-click="openChangeCompanyStateForm(company, COMPANY_STATES.onboarding)">Move to onboarding</a>\n\t\t\t\t\t\t<a href="" ng-click="openExtendTrialForm(company)" ng-if="company.CanExtendTrial">Extend trial</a>\n\t\t\t\t\t\t<a ui-sref="company-dashboard({agencyProfileId: company.AgencyProfileID})">Go to company</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Onboarding (registered) -->\n\t\t\t\t\t<div pc-switch-when="COMPANY_STATES.onboarding">\n\t\t\t\t\t\t<a href="" ng-click="openBureauNewCompanyForm(company)" ng-if="company.AdminInviteState !== ADMIN_INVITE_STATES.registered">Invite to register</a>\n\t\t\t\t\t\t<a href="" ng-click="openOnboardingChecklistForm(company)">View onboarding checklist</a>\n\t\t\t\t\t\t<a href="" ng-click="openChangeCompanyStateForm(company, COMPANY_STATES.firstPeriod)">Move to first pay period</a>\n\t\t\t\t\t\t<a ui-sref="company-dashboard({agencyProfileId: company.AgencyProfileID})">Go to company</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- First period -->\n\t\t\t\t\t<div pc-switch-when="COMPANY_STATES.firstPeriod">\n\t\t\t\t\t\t<a href="" ng-click="openChangeCompanyStateForm(company, COMPANY_STATES.readyToRun)">Mark as \u2018Ready to run\u2019</a>\n\t\t\t\t\t\t<a href="" ng-click="openOnboardingChecklistForm(company)">View onboarding checklist</a>\n\t\t\t\t\t\t<a href="" ng-click="openEditFirstPeriodForm(company)" ng-if="company.GoLiveDateISO">Edit first pay period</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group" ng-if="company.AdminInviteState === ADMIN_INVITE_STATES.registered">\n\t\t\t\t\t<a href="" ng-click="openManageAdminsForm(company)">Manage admins</a>\n\t\t\t\t\t<a href="" ng-click="openManagePayElementsForm(company)">Manage pay elements</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" class="assertive" ng-click="openDeleteCompanyForm(company)">Delete company</a>\n\t\t\t\t</div>\n\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/company-onboarding-status/companyOnboardingStatusComponent.html','<div class="company-onboarding-status" ng-switch="pageState">\n\n\t<div ng-switch-when="loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<div ng-switch-when="ready">\n\n\t\t<!-- Admins -->\n\t\t<div class="company-onboarding-status-block">\n\t\t\t<h5 class="company-onboarding-status-title">Admins</h5>\n\t\t\t<p class="s" ng-if="!companyAdmins.length">There are no admins</p>\n\t\t\t<div class="company-onboarding-status-admins" ng-if="companyAdmins.length">\n\t\t\t\t<p class="company-onboarding-status-admin" ng-repeat="companyAdmin in companyAdmins">\n\t\t\t\t\t<i class="icon-admins company-onboarding-status-admin-icon"></i> {{companyAdmin.Forename}} {{companyAdmin.Surname}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<p class="s"><a href="" ng-click="openAddTeamMembers()" ng-if="::$root.currentUser.Permissions.isAdminVisible"><i class="icon-chevron-right"></i> Manage admins</a></p>\n\t\t</div>\n\n\t\t<!-- Skipped questions -->\n\t\t<div class="company-onboarding-status-block">\n\t\t\t<header class="company-onboarding-status-header">\n\t\t\t\t<h5 class="company-onboarding-status-title">Skipped questions</h5>\n\t\t\t\t<p class="company-onboarding-status-subtitle" ng-if="totalSkippedQuestions > 0">Click a question to edit</p>\n\t\t\t</header>\n\n\t\t\t<div class="company-onboarding-status-intro" ng-if="totalSkippedQuestions === 0">\n\t\t\t\t<p class="s">Any questions you skip will appear here so you can quickly edit them later. You may be able to ask your current payroll adviser for help with these.</p>\n\t\t\t\t<!-- <p class="s">Or you could <a href="" class="quarternary underline" ng-click="$root.openSupportTab()">contact Paycircle about onboarding support</a>.</p> -->\n\t\t\t</div>\n\n\t\t\t<div class="company-onboarding-status-skipped-blocks">\n\n\t\t\t\t<!-- Company -->\n\t\t\t\t<div class="company-onboarding-status-skipped-block {{skippedQuestions.company.isOpen ? \'is-active\' : \'\'}}" ng-if="skippedQuestions.company.questions.length">\n\t\t\t\t\t<h6><a class="company-onboarding-status-skipped-title" href="" ng-click="toggleIsOpen(skippedQuestions.company)">Company <span class="company-onboarding-status-skipped-meta">({{skippedQuestions.company.questions.length}})</span><i class="icon-chevron-up company-onboarding-status-skipped-icon"></i></a></h6>\n\t\t\t\t\t<div class="company-onboarding-status-skipped-questions fadeIn" ng-if="skippedQuestions.company.isOpen">\n\t\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openOnboardingWizardCompanyForm(skippedQuestion)" ng-repeat="skippedQuestion in skippedQuestions.company.questions">- {{skippedQuestion.QuestionName}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Payroll -->\n\t\t\t\t<div class="company-onboarding-status-skipped-block {{skippedQuestions.payroll.isOpen ? \'is-active\' : \'\'}}" ng-if="skippedQuestions.payroll.questions.length">\n\t\t\t\t\t<h6><a class="company-onboarding-status-skipped-title" href="" ng-click="toggleIsOpen(skippedQuestions.payroll)">Payroll <span class="company-onboarding-status-skipped-meta">({{skippedQuestions.payroll.questions.length}})</span><i class="icon-chevron-up company-onboarding-status-skipped-icon"></i></a></h6>\n\t\t\t\t\t<div class="company-onboarding-status-skipped-questions fadeIn" ng-if="skippedQuestions.payroll.isOpen">\n\t\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openOnboardingWizardPayrollForm(skippedQuestion, onboardingDashboardObj)" ng-repeat="skippedQuestion in skippedQuestions.payroll.questions">- {{skippedQuestion.QuestionName}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Ask advisor -->\n\t\t\t<div class="company-onboarding-status-advisor-block">\n\t\t\t\t<p class="s">Need help with the above questions?</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<a href="" class="button quarternary" ng-click="openAskMyAdvisorForm(company)">Ask my advisor <i class="icon-chevron-right"></i></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Skipped Team Questions -->\n\t\t<div class="company-onboarding-status-block">\n\t\t\t<div class="company-onboarding-status-skipped-block" ng-repeat="incompleteTeamMember in incompleteTeamMembers" ng-class="{\'is-active\' : incompleteTeamMember.isOpen }" ng-if="incompleteTeamMembers.length">\n\t\t\t\t<h6><a class="company-onboarding-status-skipped-title" href="" ng-click="toggleIsOpen(incompleteTeamMember)">{{incompleteTeamMember.Forename}} {{incompleteTeamMember.Surname}} <span class="company-onboarding-status-skipped-meta">({{incompleteTeamMember.incompleteTaskCount}})</span><i class="icon-chevron-up company-onboarding-status-skipped-icon"></i></a></h6>\n\t\t\t\t<div class="company-onboarding-status-skipped-questions fadeIn" ng-if="incompleteTeamMember.isOpen">\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openPersonalForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.PersonalSetupComplete">- Name, date of birth, NI Number</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openAddressForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.AddressSetupComplete">- Address</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openPaymentDetailsForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.BankSetupComplete">- Bank</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openTelephoneForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.TelephoneSetupComplete">- Contact details</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openCompanyDetailsForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.CompanySetupComplete">- Employment info</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openEmailAddressForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.EmailSetupComplete">- Email</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openPayInformationForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.SalarySetupComplete">- Salary details</a>\n\t\t\t\t\t<a href="" class="company-onboarding-status-skipped-question" ng-click="openTaxStatusForm(incompleteTeamMember)" ng-if="!incompleteTeamMember.TaxSetupComplete">- Tax details</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n');
$templateCache.put('components/company-onboarding-summary/companyOnboardingSummaryComponent.html','<overlay-form on-close="onClose">\n\t<overlay-form-header>\n\t\t<h2>Onboarding summary</h2>\n\t\t<p>Your onboarding summary shows you everything that has been answered during onboarding in one place so you can check you\'re ready for going live.</p>\n\t</overlay-form-header>\n\t<overlay-form-main>\n\n\t\t<!-- Loading -->\n\t\t<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n\t\t<!-- Ready -->\n\t\t<div ng-if="pageState === \'ready\'">\n\n\t\t\t<!-- Details -->\n\t\t\t<nav class="overlay-form-nav">\n\t\t\t\t<a href="" class="overlay-form-nav-item">Profile</a>\n\t\t\t\t<a href="" class="overlay-form-nav-item">Company</a>\n\t\t\t\t<a href="" class="overlay-form-nav-item">Team</a>\n\t\t\t\t<a href="" class="overlay-form-nav-item">Payroll</a>\n\t\t\t\t<a href="" class="overlay-form-nav-item">Workplace Pension</a>\n\t\t\t</nav>\n\n\t\t\t<!-- Main content -->\n\t\t\t<div class="overlay-form-main has-nav">\n\n\t\t\t\t<!-- Form -->\n\t\t\t\t<section class="team-info-capture-form">\n\t\t\t\t\tTeam\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</div>\n\t</overlay-form-main>\n</overlay-form>\n');
$templateCache.put('components/company-pension-summary/companyPensionSummaryComponent.html','<div class="company-pension-summary" ng-switch="pension.PensionType">\n\n\t<!-- Logo -->\n\t<div class="company-pension-summary-media">\n\t\t<a href="" ui-sref="pensions.scheme.status({agencyProfileId: agencyProfileId, agencyEmployerPensionId: pension.AgencyEmployerPensionID})">\n\t\t\t<span class="company-pension-summary-highlight" ng-if="pension.TotalIncomplete" tooltip tooltip-text="Incomplete team members">\n\t\t\t\t<span>{{pension.TotalIncomplete}}</span>\n\t\t\t</span>\n\n\t\t\t<span class="company-pension-summary-highlight" ng-if="pension.TotalEligible" tooltip tooltip-text="Eligible team members">\n\t\t\t\t<span>{{pension.TotalEligible}}</span>\n\t\t\t</span>\n\n\t\t\t<div class="company-pension-summary-logo">\n\t\t\t\t<img ng-src="{{pension.PensionProviderImageUrl}}" alt="{{pension.PensionProviderName}}" ng-if="::pension.PensionProviderImageUrl !== \'\'">\n\t\t\t\t<i class="icon-money primary xxl" ng-if="::pension.PensionProviderImageUrl === \'\'"></i>\n\t\t\t</div>\n\t\t</a>\n\t</div>\n\n\t<!-- Details -->\n\t<div class="company-pension-summary-details">\n\n\t\t<h6 class="company-pension-summary-provider">{{pension.PensionProviderName}}</h6>\n\t\t<p class="company-pension-summary-reference" ng-if="!pension.IsGhostPension">{{pension.EmployerReference}}</p>\n\t\t<p class="company-pension-summary-connection" ng-if="!pension.IsGhostPension">\n\t\t\t<i class="icon-{{pension.ConnectToProvider ? \'submitted\' : \'wrench\'}}"></i>&nbsp;&nbsp;\n\t\t\t<span>{{pension.ConnectToProvider ? \'Direct\' : \'Manual\'}}</span>\n\t\t</p>\n\n\t\t<!-- State -->\n\t\t<div class="company-pension-summary-state">\n\t\t\t<pension-state state="pension.PensionState" ng-if="!pension.IsGhostPension" pc-switch-when="PENSION_TYPES.autoEnrolment"></pension-state>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/confetti/confetti.component.html','<canvas id="{{$ctrl.confettiId}}" class="confetti-tick" style="position: fixed; top: 0px; left: 0px; pointer-events: none; z-index: 100;"></canvas>\n');
$templateCache.put('components/copilot-button/copilot-button.component.html','<!-- Translation Button -->\n<button class="copilot-button" ng-click="$ctrl.handleClick()" ng-disabled="$ctrl.isLoading" type="button">\n\t<span class="copilot-button_link" ng-if="!$ctrl.isLoading">\n\t\t<i class="icon-copilot"></i>\n\t\t<p class="is-small">{{$ctrl.buttonText}}</p>\n\t</span>\n\t<circle-loader ng-if="$ctrl.isLoading" size="\'m\'">\n\t</circle-loader>\n</button>\n');
$templateCache.put('components/copilot-feedback/copilot-feedback.component.html','<div class="copilot-feedback" data-cy="copilot-feedback">\n\t<span class="copilot-feedback_text">{{$ctrl.labelText}}</span>\n\t<div class="copilot-feedback_buttons" ng-if="$ctrl.showButtons">\n\t\t<button class="copilot-feedback_button" data-cy="copilot-feedback-thumbs-up" ng-click="submitFeedback($ctrl.copilotFeature || \'Unknown\', \'positive\')" type="button">\n\t\t\t<i class="icon-thumbs-up"></i>\n\t\t</button>\n\t\t<button class="copilot-feedback_button" data-cy="copilot-feedback-thumbs-down" ng-click="submitFeedback($ctrl.copilotFeature || \'Unknown\', \'negative\')" type="button">\n\t\t\t<i class="icon-thumbs-down"></i>\n\t\t</button>\n\t</div>\n</div>\n');
$templateCache.put('components/copilot-response-card/copilot-response-card.component.html','<div class="copilot-response-card">\n\t<div class="copilot-response-card_heading">\n\t\t<i class="icon-copilot"></i>\n\t\t<p class="is-small">{{$ctrl.title}}</p>\n\t</div>\n\n\t<!-- Simple content (backward compatibility and transclude) -->\n\t<div ng-if="!$ctrl.isError">\n\t\t<!-- If transcluded content is provided, render it here -->\n\t\t<div class="copilot-response-card_text is-small" ng-if="$ctrl.hasContent" ng-transclude="content"></div>\n\t\t<span class="italic is-small">This is a Copilot generated response.</span>\n\t</div>\n\n\t<div class="copilot-response-card_error" ng-if="$ctrl.isError">\n\t\t<div class="copilot-response-card_heading-error">\n\t\t\t<i class="icon-warning"></i>\n\t\t\t<h5>We couldn\'t load your translation</h5>\n\t\t</div>\n\n\t\t<p class="copilot-response-card_error-text is-small">\n\t\t\tThis may be due to connectivity issues or because Copilot is down.<br>\n\t\t\tClick \'Reload\' to try again. If the problem persists, contact Support.\n\t\t</p>\n\t</div>\n\n\t<div class="copilot-response-card_actions" ng-class="!$ctrl.isError ? \'success-state\' : \'error-state\'">\n\t\t<copilot-feedback copilot-feature="{{$ctrl.copilotFeatureContext || $ctrl.COPILOT_FEATURES.copilotResponseCard}}" label-text="Do you find this helpful?" ng-if="!$ctrl.isError && !$ctrl.isFeedbackRequired" on-feedback-click="$ctrl.onFeedbackClick({copilotFeature: copilotFeature, feedbackType: feedbackType, onSubmitComplete: onSubmitComplete})" show-buttons="!$ctrl.isFeedbackRequired">\n\t\t</copilot-feedback>\n\t\t<button class="copilot-response-card_secondary-action" data-cy="copilot-response-card-reload-button" ng-click="!$ctrl.onReloadClick()" ng-if="$ctrl.isError" type="button">\n\t\t\tReload\n\t\t</button>\n\t</div>\n</div>\n');
$templateCache.put('components/correctional-submission-fieldset/correctional-submission-fieldset.component.html','<tr class="fadeIn">\n\n\t<!-- Label -->\n\t<td class="submission-table_cell is-label">\n\t\t<label for="{{paymentId}}" class="strong">{{payment.paymentLabel}}:</label>\n\t</td>\n\n\t<!-- Original Amount -->\n\t<td class="submission-table_cell is-field" data-fieldname="{{taxYear.TaxYearDisplay}}">\n\t\t<input class="is-primary-lighter-flat" id="paymentAmount-{{paymentId}}" name="paymentAmount-{{paymentId}}" ng-value="payment.paymentAmount" readonly="readonly" tabindex="-1" type="text">\n\t</td>\n\n\t<!-- New Amount -->\n\t<td class="submission-table_cell is-field" data-fieldname="New value">\n\t\t<input autocomplete="off" class="monetise monetise-smaller" id="paymentNewAmount-{{paymentId}}" name="paymentNewAmount-{{paymentId}}" ng-change="onNewPaymentAmountChange()" ng-model="payment.paymentNewAmount" ng-model-options="{ debounce: 500 }" ng-pattern="payment.paymentPatternRegex" placeholder="Enter value" type="text">\n\n\t\t<div class="submission-table_errors form-errors fadeIn" role="alert" ng-messages="form[\'paymentNewAmount-\'+paymentId].$error" ng-show="form[\'paymentNewAmount-\'+paymentId].$error">\n\t\t\t<p ng-message="pattern">{{paymentConfig}}</p>\n\t\t</div>\n\t</td>\n\n\t<!-- Difference -->\n\t<td class="submission-table_cell is-field" data-fieldname="Difference" ng-if="isDifferenceColumnVisible">\n\t\t<input id="paymentDifference-{{paymentId}}" name="paymentDifference-{{paymentId}}" ng-class="{\n\t\t\t\t\'is-positive-200-flat\': payment.paymentIsIncrease,\n\t\t\t\t\'is-assertive-200-flat\': payment.paymentIsDecrease,\n\t\t\t\t\'is-primary-200-flat\': !payment.paymentIsDecrease && !payment.paymentIsIncrease\n\t\t\t}" ng-value="payment.paymentDifferenceLabel" readonly="readonly" tabindex="-1" type="text">\n\t</td>\n</tr>\n');
$templateCache.put('components/cost-split-form-field/cost-split-form-field.component.html','<div class="cost-split-form-field">\n\n\t<div class="cost-split-form-field_header">\n\t\t<div class="form-intro">\n\t\t\t<h5>Cost split</h5>\n\t\t</div>\n\n\t\t<div class="fadeIn" ng-if="!$ctrl.confirmDelete">\n\t\t\t<a class="primary" href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)" aria-label="Delete cost split">\n\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="fadeIn" ng-if="$ctrl.confirmDelete">\n\t\t\t<p class="s strong">\n\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t<a href="" ng-click="$ctrl.onDelete()">\n\t\t\t\t\tYes\n\t\t\t\t</a>\n\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)">\n\t\t\t\t\tNo\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Business Category drop down -->\n\t<div class="form-field">\n\t\t<p class="form-field-sub is-small">\n\t\t\tGross costs for {{$ctrl.user.forename || \'the selected team members\'}} can be split by a single business category type. The total allocation should equal 100%.\n\t\t</p>\n\t</div>\n\n\t<!-- Business Category drop down -->\n\t<div class="form-field cost-split-form-field_wrapper">\n\t\t<header class="form-field-header">\n\t\t\t<label for="splitCostsBy" class="required">\n\t\t\t\tSplit costs by:\n\t\t\t</label>\n\t\t</header>\n\n\t\t<div class="form-field-main">\n\t\t\t<!-- Determine the dropdown options from array passed by the parent, when option is selected we save the business category in the holding obj coming from the parent -->\n\t\t\t<select id="splitCostsBy" name="splitCostsBy" ng-change="$ctrl.onBusinessCategoryChange($ctrl.selectedBusinessCategory)" ng-model="$ctrl.selectedBusinessCategory" ng-options="category as category.BusinessCategoryName for category in $ctrl.businessCategories | orderBy: \'BusinessCategoryName\'"></select>\n\t\t</div>\n\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form.splitCostsBy.$error" ng-show="$ctrl.form.splitCostsBy.$touched" role="alert">\n\t\t\t<p ng-message="required">Please select a business category</p>\n\t\t</div>\n\t</div>\n\n\t<hr>\n\n\t<!-- Multiple business codes based on the selection above -->\n\t<div ng-repeat="businessCodeChange in $ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes">\n\t\t<div class="cost-split-form-field_group">\n\n\t\t\t<div class="cost-split-form-field_input-group">\n\n\t\t\t\t<div class="cost-split-form-field_select">\n\t\t\t\t\t<!-- Dropdown with relevant options based on the selected business category-->\n\n\t\t\t\t\t<div ng-if="businessCodeChange.BusinessCodeID === $ctrl.primaryBusinessCode.BusinessCodeID">\n\t\t\t\t\t\t<label for="primaryBusinessCode">\n\t\t\t\t\t\t\t<i class="icon-group is-primary"></i>\n\t\t\t\t\t\t\t{{$ctrl.primaryBusinessCode.BusinessCodeNarrative}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="cost-split-form-field_select-input-wrapper" ng-if="businessCodeChange.BusinessCodeID !== $ctrl.primaryBusinessCode.BusinessCodeID">\n\t\t\t\t\t\t<select id="{{$ctrl.businessCodeFormFieldId}}_{{$index}}" name="{{businessCodeFormFieldId}}_{{$index}}" ng-change="$ctrl.onBusinessCodeChange()" ng-model="businessCodeChange.BusinessCodeID" ng-options="businessCode.BusinessCodeID as businessCode.BusinessCodeNarrative for businessCode in $ctrl.selectedBusinessCategory.BusinessCodes | addToBusinessCodesRemoveUsedCodes:$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes:businessCodeChange.BusinessCodeID">\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t-- Select a category --\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="cost-split-form-field_percentage">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="percentage s cost-split-form-field_percentage-input" decimal-mask decimal-places="4" allow-zero="false" id="businessCodePercentage_{{$index}}" max="100" maxlength="10" min="0" name="businessCodePercentage_{{$index}}" ng-change="$ctrl.onBusinessCodePercentageChange()" ng-disabled="!businessCodeChange.BusinessCodeID" ng-model="businessCodeChange.UserAgencyProfileBusinessCodePercent" ng-pattern="$root.REGEX.decimalFourPlaces" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<button class="is-white is-primary is-small" data-cy="cost-split-form-field-button-add-business-category" ng-click="$ctrl.addBusinessCode()" ng-disabled="$ctrl.businessCodesCostSplit.UserAgencyProfileBusinessCodes.length === $ctrl.selectedBusinessCategory.BusinessCodes.length" ng-if="businessCodeChange.BusinessCodeID === $ctrl.primaryBusinessCode.BusinessCodeID" type="button">\n\t\t\t\t\t<i class="icon-plus primary no-margin right"></i>\n\t\t\t\t</button>\n\n\t\t\t\t<button class="is-white is-primary is-small" ng-click="$ctrl.onBusinessCodeChangeDelete($index)" ng-show="businessCodeChange.BusinessCodeID !== $ctrl.primaryBusinessCode.BusinessCodeID && $index > 1" type="button">\n\t\t\t\t\t<i class="icon-trash primary no-margin right"></i>\n\t\t\t\t</button>\n\n\t\t\t</div>\n\n\t\t\t<div class="cost-split-form-field_error form-errors fadeIn" ng-if="businessCodeChange.BusinessCodeID && $ctrl.form[\'businessCodePercentage_\' + $index].$touched && $ctrl.form[\'businessCodePercentage_\' + $index].$invalid" ng-messages="$ctrl.form[\'businessCodePercentage_\' + $index].$error" role="alert">\n\t\t\t\t<p ng-message="decimalValidator">Must be greater than 0.0000</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<hr>\n\t</div>\n\n\t<div class="cost-split-form-field_footer">\n\t\t<value-card class="cost-split-form-field_value-card" theme="{{ $ctrl.isMaxValue ? \'is-secondary\': \'is-assertive\' }}" title="Total allocation:" value="$ctrl.totalPercentage" zero-value-text="Not set">\n\t\t</value-card>\n\t</div>\n</div>\n');
$templateCache.put('components/current-tax-status/current-tax-status.component.html','<div class="current-tax-status">\n\t<div class="current-tax-status_title">\n\t\t<h5 data-cy="current-tax-status_title">\n\t\t\tCurrent tax status\n\t\t</h5>\n\t</div>\n\n\t<div class="current-tax-status_content">\n\t\t<div class="current-tax-status_tax-sections">\n\t\t\t<div class="current-tax-status_section">\n\t\t\t\t<div class="current-tax-status_section-name">Tax Code</div>\n\t\t\t\t<div class="current-tax-status_section-value">\n\t\t\t\t\t<i class="icon-tax-code-change m is-primary"></i>\n\t\t\t\t\t<h6 class="is-strong" data-cy="current-tax-status_tax-code">\n\t\t\t\t\t\t{{::$ctrl.taxCode}}\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="current-tax-status_section">\n\t\t\t\t<div class="current-tax-status_section-name">NI category</div>\n\t\t\t\t<div class="current-tax-status_section-value">\n\t\t\t\t\t<i class="icon-national-insurance m is-primary"></i>\n\t\t\t\t\t<h6 class="is-strong" data-cy="current-tax-status_ni-code">\n\t\t\t\t\t\t{{::$ctrl.teamMember.Tax.NICode}}\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="current-tax-status_section" ng-if="!$ctrl.teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="current-tax-status_section-name">Student loan</div>\n\t\t\t\t<div class="current-tax-status_section-value">\n\t\t\t\t\t<i class="icon-student-loan m is-primary"></i>\n\t\t\t\t\t<h6 class="is-strong" data-cy="current-tax-status_student-loan">\n\t\t\t\t\t\t{{::$ctrl.teamMember.Tax.StudentLoanDisplay}}\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="current-tax-status_section" ng-if="!$ctrl.teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="current-tax-status_section-name">Postgraduate loan</div>\n\t\t\t\t<div class="current-tax-status_section-value">\n\t\t\t\t\t<i class="icon-student-loan m is-primary"></i>\n\t\t\t\t\t<h6 class="is-strong" data-cy="current-tax-status_postgraduate-loan">\n\t\t\t\t\t\t{{::$ctrl.teamMember.Tax.PostGraduateLoanDisplay}}\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="current-tax-status_footer" ng-if="$ctrl.teamMember.Tax.NICode === $ctrl.NI_CATEGORY_LETTER.v" data-cy="current-tax-status_civilian-employment-start-date">\n\t\tStart date of first civilian employment: {{ $ctrl.teamMember.Tax.CivilianStartDateISO | dateformat | checkEmpty: \'Not added\' }}\n\t</div>\n</div>\n');
$templateCache.put('components/custom-textarea/custom-textarea.component.html','<div>\n\t<!-- Div used as input to be able to use ng-bind-html -->\n\t<div aria-multiline="true" aria-rowcount="{{$ctrl.rows}}" placeholder="{{$ctrl.placeholder}}" class="custom-textarea" contenteditable="plaintext-only" data-cy="{{$ctrl.name}}-textarea-input" id="{{$ctrl.name}}-textarea-input" ng-bind-html="$ctrl.text" ng-class="{\'ng-invalid\' : $ctrl.form[$ctrl.name].$invalid }" ng-blur="$ctrl.updateNgModel()" ng-model="$ctrl.text" role="textbox" tabindex="0">\n\t</div>\n\n\t<!-- Input (For Validation) -->\n\t<textarea aria-hidden="true" class="custom-textarea_input" id="{{::$ctrl.name}}" name="{{::$ctrl.name}}" ng-model="$ctrl.text" ng-required="{{$ctrl.required}}">\n\t</textarea>\n</div>\n');
$templateCache.put('components/customer-codes-card/customer-codes-card.component.html','<div class="customer-codes-card">\n\t<div class="customer-codes-card_title">\n\t\t<i class="icon-company primary is-medium has-margin-right"></i>\n\t\t<h6>{{$ctrl.customerCode.CompanyName}}</h6>\n\t</div>\n\n\t<div class="customer-codes-card_icon" ng-if="$ctrl.customerCode.isLocked">\n\t\t<icon-dot icon="icon-padlock" tooltip-text="Verified with the \'{{$ctrl.customerCode.CompanyName}}\' Evo organisation" theme="is-tertiary"></icon-dot>\n\t</div>\n\n\t<div class="customer-codes-card_info">\n\t\t<div class="customer-codes-card_code">\n\t\t\t<p class="is-medium italic is-font-greyscale-300" ng-if="!$ctrl.customerCode.CustomerCode">\n\t\t\t\tNo code added\n\t\t\t</p>\n\t\t\t<p class="is-medium is-font-greyscale-500" ng-if="$ctrl.customerCode.CustomerCode">\n\t\t\t\t{{$ctrl.customerCode.CustomerCode}}\n\t\t\t</p>\n\t\t</div>\n\t\t<dropdown-menu menu-size="l" menu-show-chevron="false" menu-icon="icon-setup">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a class="primary" ng-click="$ctrl.editCustomerCode($ctrl.customerCode)" title="Edit code">\n\t\t\t\t\tEdit code\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t</div>\n\n</div>\n');
$templateCache.put('components/customisation-image-uploader/customisationImageUploaderComponent.html','<div class="image-uploader {{fuTheme}} {{fuTemplate}} {{fuState}}" ng-class="{active: fuState === \'uploading\'}" ng-switch="fuState">\n\n\t<div ng-switch-when="upload">\n\t\t<label class="image-uploader-label">\n\t\t\t<input id="fileUpload" class="image-uploader-input" type="file" accept="{{fuAllowedFileTypes}}" nv-file-select uploader="uploader">\n\t\t\t<span class="image-uploader-label-text"><i class="icon-upload image-uploader-icon"></i> {{fuMessage}}</span>\n\t\t</label>\n\t\t<div class="image-uploader-background"></div>\n\t</div>\n\n\t<div ng-switch-when="uploading" class="image-uploader-working">\n\t\t<circle-loader></circle-loader>\n\t\t<p class="image-uploader-state-label">Uploading...</p>\n\t</div>\n\n\t<div ng-switch-when="uploaded">\n\t\t<img alt="Uploaded image" src="" ng-src="{{fuModel}}" class="file-uploaded-image">\n\t\t<p class="file-uploaded-url" title="{{fuModel}}">{{fuModel}}</p>\n\t\t<a href="" class="image-uploader-delete" ng-click="confirmDeleteFileUpload()" aria-label="Confirm delete uploaded file"><i class="{{deleteState === \'deleting\' ? \'icon-loading spin\' : \'icon-trash\'}}"></i></a>\n\t</div>\n\n\t<div class="image-uploader-confirm" ng-switch-when="confirm-delete">\n\t\t<p class="image-uploader-state-subtitle">Are you sure?</p>\n\t\t<p class="image-uploader-confirm-actions"><a href="" ng-click="deleteFileUpload()" class="assertive">Yes, delete</a><a href="" ng-click="cancelDeleteFileUpload()">No</a></p>\n\t</div>\n\n\t<div ng-switch-when="deleting" class="image-uploader-working">\n\t\t<circle-loader></circle-loader>\n\t\t<p class="image-uploader-state-label">Deleting...</p>\n\t</div>\n\n\t<div ng-switch-when="delete-error">\n\t\t<div class="image-uploader-message-block">\n\t\t\t<i class="icon-warning image-uploader-message-block-icon"></i>\n\t\t\t<p class="image-uploader-message-block-title">Unable to delete</p>\n\t\t\t<a href="" ng-click="setState(\'uploaded\')" class="image-uploader-message-block-action">Try again</a>\n\t\t</div>\n\t\t<div class="image-uploader-background"></div>\n\t</div>\n\n\t<div ng-switch-when="upload-error">\n\t\t<div class="image-uploader-message-block">\n\t\t\t<i class="icon-warning image-uploader-message-block-icon"></i>\n\t\t\t<p class="image-uploader-message-block-title">Not uploaded</p>\n\t\t\t<a href="" ng-click="setState(\'upload\')" class="image-uploader-message-block-action">Try again</a>\n\t\t</div>\n\t\t<div class="image-uploader-background"></div>\n\t</div>\n\n\t<div ng-switch-when="invalid-file-size">\n\t\t<div class="image-uploader-message-block">\n\t\t\t<i class="icon-warning image-uploader-message-block-icon"></i>\n\t\t\t<p class="image-uploader-message-block-title">File size too big</p>\n\t\t\t<a href="" ng-click="setState(\'upload\')" class="image-uploader-message-block-action">Try again</a>\n\t\t</div>\n\t\t<div class="image-uploader-background"></div>\n\t</div>\n\n\t<div ng-switch-when="invalid-file">\n\t\t<div class="image-uploader-message-block">\n\t\t\t<i class="icon-warning image-uploader-message-block-icon"></i>\n\t\t\t<p class="image-uploader-message-block-title">Invalid file</p>\n\t\t\t<a href="" ng-click="setState(\'upload\')" class="image-uploader-message-block-action">Try again</a>\n\t\t</div>\n\t\t<div class="image-uploader-background"></div>\n\t</div>\n\n\t<div class="image-uploader-overlay"></div>\n</div>\n');
$templateCache.put('components/dashboard-carousel/dashboardCarouselComponent.html','<div class="dashboard-carousel-component">\n\t<header class="dashboard-carousel-header">\n\t\t<div class="dashboard-carousel-info">\n\t\t\t<ng-pluralize count="itemsCount ? itemsCount : companyData.companyList.length" when="itemDescription"></ng-pluralize>\n\t\t</div>\n\t\t<div class="dashboard-carousel-pagination" ng-if="paginationList.length < 10">\n\t\t\t<ul ng-if="companyData.companyLists.length">\n\t\t\t\t<li ng-repeat="list in companyData.companyLists track by $index" class="dashboard-carousel-pagination-pip">\n\t\t\t\t\t<button ng-click="changeCategory($index)" class="dashboard-carousel-pagination-pip-button dashboard-carousel-pagination-pip-button-pill dashboard-carousel-pagination-pip-button-{{theme}}" ng-class="{active: activeList === list.title}">{{list.title}}</button>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<ul ng-if="!companyData.companyLists.length && paginationList.length > 1">\n\t\t\t\t<li ng-repeat="pip in paginationList" class="dashboard-carousel-pagination-pip">\n\t\t\t\t\t<button ng-click="navigateToPage(pip-1)" class="dashboard-carousel-pagination-pip-button dashboard-carousel-pagination-pip-button-{{theme}}" ng-class="{active: paginationIndex === pip-1}"><span class="accessible">{{pip}} of {{paginationList.length}}</span></button>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t\t<!--<a ui-sref="companies({presetfilterkey: presetFilterKey})" class="dashboard-carousel-view-all {{theme}}" ng-if="presetFilterKey">View all <i class="icon-chevron-right"></i></a>-->\n\t</header>\n\t<button class="dashboard-carousel-control dashboard-carousel-control-{{theme}} dashboard-carousel-control-backwards" ng-click="navigateToPage(paginationIndex - 1)" ng-if="paginationList.length > 1" aria-label="Go back"><i class="icon-chevron-left"></i></button>\n\t<ul class="dashboard-carousel-items company-cards cards" ng-class="{cleared: animateOut, toLeft: animateBackwards}">\n\t\t<li class="dashboard-carousel-item company-card {{theme}}" ng-repeat="item in companyData.companyList track by $index" ng-if="$index <= displayBounds.max && $index >= displayBounds.min" ng-style="{\'animation-delay\': ($index*15-(displayBounds.min*15))+\'ms\'}">\n\t\t\t<header class="company-card-header {{theme}}">\n\t\t\t\t<a ng-click="navigateTo(item.AgencyProfileID, item.CompanyName, item.UserID)" href="">\n\t\t\t\t\t<span ng-if="!isTeamMemberList">{{item.CompanyName}}</span>\n\t\t\t\t\t<span ng-if="isTeamMemberList">{{item.Forename}} {{item.Surname}}</span>\n\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t</a>\n\t\t\t</header>\n\t\t\t<div class="company-card-main">\n\t\t\t\t<span ng-if="!isTeamMemberList">{{infoLabel}} {{item[info]}}</span>\n\t\t\t\t<span ng-if="isTeamMemberList">NI Number: {{item.NINumber !== \'\' ? item.NINumber : \'Waiting\'}}</span>\n\t\t\t\t<span class="tag {{theme}} inverse company-card-tag" ng-if="!isTeamMemberList && info === \'CurrentPeriod\' && tagType === \'daysTo\'">{{item.DaysToProcessDay}} DAYS</span>\n\t\t\t\t<span class="tag {{theme}} inverse company-card-tag" ng-if="!isTeamMemberList && info === \'CurrentPeriod\' && tagType === \'isApproved\' && item.PayPeriodIsApproved">READY</span>\n\t\t\t\t<span class="tag {{theme}} inverse company-card-tag" ng-if="info === \'PAYEReference\' && item.DPSState === DPS_STATES.invalidCredentials">Invalid</span>\n\t\t\t\t<span class="tag {{theme}} inverse company-card-tag" ng-if="info === \'PAYEReference\' && item.DPSState === DPS_STATES.unauthorised">Not authorised</span>\n\t\t\t\t<span class="tag {{theme}} inverse company-card-tag" ng-if="info === \'PAYEReference\' && item.DPSState === DPS_STATES.hmrcFault">Unresponsive</span>\n\t\t\t\t<p class="dashboard-carousel-item-company-group" ng-if="!isTeamMemberList && item.CompanyGroup"><i class="icon-company-groups"></i>{{item.CompanyGroup}}</p>\n\t\t\t\t<p class="dashboard-carousel-item-company-group" ng-if="isTeamMemberList && item.CompanyName"><i class="icon-company"></i>{{item.CompanyName}}</p>\n\t\t\t</div>\n\t\t</li>\n\t</ul>\n\t<button class="dashboard-carousel-control dashboard-carousel-control-{{theme}} dashboard-carousel-control-forwards" ng-click="navigateToPage(paginationIndex + 1)" ng-if="paginationList.length > 1" aria-label="Go forward"><i class="icon-chevron-right"></i></button>\n</div>\n');
$templateCache.put('components/date-range-filter/date-range-filter.component.html','<div class="date-range-filter">\n\t<div class="date-range-filter_field">\n\t\t<div class="date-range-filter_field-header">\n\t\t\t<label for="date-range-filter-from-{{$ctrl.filterGroup.name}}">From:</label>\n\t\t</div>\n\t\t<div class="date-range-filter_field-main">\n\t\t\t<date-input-field field-id="date-range-filter-from-{{$ctrl.filterGroup.name}}" field-max-date-iso="$ctrl.toDateIso" field-required="false" field-style="l" field-value-iso="$ctrl.fromDateIso"></date-input-field>\n\t\t</div>\n\t</div>\n\t<div class="date-range-filter_field">\n\t\t<div class="date-range-filter_field-header">\n\t\t\t<label for="date-range-filter-to-{{$ctrl.filterGroup.name}}">To:</label>\n\t\t</div>\n\t\t<div class="date-range-filter_field-main">\n\t\t\t<date-input-field field-id="date-range-filter-to-{{$ctrl.filterGroup.name}}" field-min-date-iso="$ctrl.fromDateIso" field-required="false" field-style="l" field-value-iso="$ctrl.toDateIso"></date-input-field>\n\t\t</div>\n\t</div>\n\t<div class="form-errors" ng-if="$ctrl.fromDateIso && $ctrl.toDateIso && !$ctrl.isDateRangeValid()">\n\t\t<p>\'To\' date must not be before \'From\' date</p>\n\t</div>\n\t<div class="date-range-filter_actions">\n\t\t<div class="inline-links">\n\t\t\t<a data-cy="date-range-filter-apply" href="" ng-class="{\'is-disabled\': !$ctrl.fromDateIso || !$ctrl.toDateIso || !$ctrl.isDateRangeValid()}" ng-click="$ctrl.fromDateIso && $ctrl.toDateIso && $ctrl.isDateRangeValid() && $ctrl.onApplyClick()">Apply</a>\n\t\t\t<a data-cy="date-range-filter-clear" href="" ng-click="$ctrl.onClearClick()" ng-if="$ctrl.fromDateIso || $ctrl.toDateIso">Clear</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/demo-completed/demoCompletedComponent.html','<div class="demo-completed fadeIn" ng-if="showMessage">\n\t<div class="demo-completed__icon">\n\t\t<i class="icon-check demo-completed__check"></i>\n\t</div>\n\t<p class="demo-completed__message">\n\t\t{{demoCompletedMessage}}&nbsp;<a href ng-click="backToDashboard()" class="demo-completed__action">{{demoLinkCopy}} <i class="icon-chevron-right"></i></a>\n\t</p>\n</div>\n');
$templateCache.put('components/description-card/description-card.component.html','<div class="description-card" ng-class="$ctrl.theme">\n\t<i class="icon-{{$ctrl.icon}} description-card-icon" ng-class="$ctrl.theme"></i>\n\t<h5 class="description-card-title" ng-transclude></h5>\n</div>\n');
$templateCache.put('components/detail-block/detail-block.component.html','<div class="detail-block {{$ctrl.dbDetails.theme ? $ctrl.dbDetails.theme : \'primary\'}} {{$ctrl.dbDetails.layout}}">\n\t<header class="detail-block-header">\n\n\t\t<div class="detail-block-header-image" ng-if="$ctrl.dbDetails.image">\n\t\t\t<img alt="Image for {{$ctrl.dbDetails.title}}" class="detail-block-header-media" src="{{$ctrl.dbDetails.image}}">\n\t\t</div>\n\n\t\t<div class="detail-block-header-title-block">\n\t\t\t<i class="icon-{{$ctrl.dbDetails.icon}} detail-block-icon" ng-if="$ctrl.dbDetails.icon"></i>\n\n\t\t\t<div>\n\t\t\t\t<h6 class="detail-block-title">{{$ctrl.dbDetails.title}}</h6>\n\t\t\t\t<p class="detail-block-description" ng-if="$ctrl.dbDetails.description">\n\t\t\t\t\t{{$ctrl.dbDetails.description}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="detail-block-header-action" ng-if="$ctrl.dbDetails.headerActions">\n\t\t\t<div class="detail-block-header-action-icon">\n\t\t\t\t<i class="m" ng-class="[\n\t\t\t\t\t\t$ctrl.dbDetails.headerActions.icon,\n\t\t\t\t\t\t$ctrl.dbDetails.headerActions.iconTheme\n\t\t\t\t\t]"></i>\n\t\t\t</div>\n\t\t\t<div class="detail-block-header-action-link" ng-repeat="action in $ctrl.dbDetails.headerActions.actions">\n\t\t\t\t<a class="is-font-primary-400 underline" href="" ng-click="action.actionFunction()" ng-hide="action.actionHide">\n\t\t\t\t\t{{action.actionCopy}}\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if="$ctrl.dbDetails.hasBeenUpdated">\n\t\t\t<span class="tag tertiary inverse">Update</span>\n\t\t</div>\n\t</header>\n\n\t<main class="detail-block-main" ng-if="$ctrl.dbDetails.detailGroups">\n\t\t<div class="detail-block-group" ng-repeat="detailGroup in detailGroupsFiltered = ($ctrl.dbDetails.detailGroups | filter : { show: \'!false\' })">\n\n\t\t\t<div class="detail-block-group-title" ng-if="detailGroup.title">\n\t\t\t\t{{detailGroup.title}}\n\t\t\t</div>\n\n\t\t\t<div class="detail-block-cta" ng-if="detailGroup.groupCta">\n\t\t\t\t<div class="info-block has-plain-type" ng-class="[\n\t\t\t\t\t\tdetailGroup.groupCta.theme,\n\t\t\t\t\t\tdetailGroup.groupCta.customClass ? \'info-block-\' + detailGroup.groupCta.customClass : \'\',\n\t\t\t\t\t]">\n\t\t\t\t\t<span class="inline" ng-class="detailGroup.groupCta.copyTheme ? detailGroup.groupCta.copyTheme : \'stronger\'">\n\t\t\t\t\t\t<span class="group-cta-cheese tag inverse is-medium" ng-class="detailGroup.groupCta.theme" ng-if="detailGroup.groupCta.viewAction">\n\t\t\t\t\t\t\t{{detailGroup.groupCta.viewLabel}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class="s">\n\t\t\t\t\t\t\t{{detailGroup.groupCta.copy}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="info-block-cta" ng-if="detailGroup.groupCta.editAction">\n\t\t\t\t\t\t<a class="s" ng-class="[\n\t\t\t\t\t\t\t\tdetailGroup.groupCta.theme,\n\t\t\t\t\t\t\t\tdetailGroup.groupCta.customClass ? \'action-\' + detailGroup.groupCta.customClass : undefined\n\t\t\t\t\t\t\t]" ng-click="detailGroup.groupCta.editAction()" href>\n\t\t\t\t\t\t\t{{detailGroup.groupCta.editCopy}} \n\t\t\t\t\t\t\t<i ng-class="{\n\t\t\t\t\t\t\t\t\t\'icon-chevron-right\': !detailGroup.groupCta.customClass, \n\t\t\t\t\t\t\t\t\t\'icon-right\': detailGroup.groupCta.customClass \n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="detail-block-layout">\n\n\t\t\t\t<span class="detail-block-demo" ng-if="detailGroup.editAction && $ctrl.dbCanEdit" td-id="{{detailGroup.demoTooltip}}" tooltip-demo></span>\n\n\t\t\t\t<!-- Edit action if available -->\n\t\t\t\t<a class="detail-block-group-edit {{$ctrl.dbDetails.theme ? $ctrl.dbDetails.theme : \'primary\'}}" data-cy="{{::detailGroup.id}}" href="" ng-click="detailGroup.editAction()" ng-if="detailGroup.editAction && $ctrl.dbCanEdit">\n\t\t\t\t\t{{$ctrl.dbEditText}}<i class="icon-chevron-right"></i>\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Action menu if specified and can edit -->\n\t\t\t\t<dropdown-menu class="detail-block_action-menu" menu-icon="icon-setup" menu-show="detailGroup.showMenu" menu-size="l" ng-if="detailGroup.actionMenuItems">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="actionMenuItem.action()" ng-repeat="actionMenuItem in detailGroup.actionMenuItems">\n\t\t\t\t\t\t\t{{actionMenuItem.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\n\t\t\t\t<div class="detail-block-feedback" ng-if="$first && $ctrl.dbShowFeedback && $ctrl.dbFeedbackPosition === \'top\'" ng-transclude="feedback"></div>\n\n\t\t\t\t<div class="detail-block-upload" ng-if="detailGroup.fileUpload">\n\t\t\t\t\t<div class="detail-block-upload-image" td-id="{{detailGroup.demoTooltip}}" tooltip-demo>\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="detailGroup.uploadDetails.agencyProfileId" fu-customisation-type="detailGroup.uploadDetails.customisationType" fu-max-file-size="750" fu-model="detailGroup.uploadDetails.model" fu-on-update="detailGroup.uploadDetails.callback()" fu-template="stacked"></customisation-image-uploader>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="detail-block-upload-content" ng-transclude="content"></div>\n\t\t\t\t</div>\n\n\t\t\t\t<ul class="detail-block-list" ng-class="{\n\t\t\t\t\t\t\'has-multiple-children\': detailGroup.details.length > 1\n\t\t\t\t\t}">\n\t\t\t\t\t<li class="detail-block-item" ng-class="{\n\t\t\t\t\t\t\t\'is-heading-block\' : detail.type === \'heading\'\n\t\t\t\t\t\t}" ng-if="!detail.isHidden" ng-repeat="detail in detailGroup.details" ng-switch="detail.type">\n\t\t\t\t\t\t<p class="detail-block-label" data-cy="{{ :: detail.label | slugify }}" ng-if="detail.label">\n\t\t\t\t\t\t\t{{detail.label}}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Heading -->\n\t\t\t\t\t\t<div class="detail-block-heading" ng-switch-when="heading">\n\t\t\t\t\t\t\t<h6 class="detail-block-heading-title">{{detail.value}}</h6>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Address -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value.AddressID === $root.CONFIG.guidEmpty ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="address">\n\t\t\t\t\t\t\t<print-address address="detail.value" class="address inline" display-as-foreign="detail.displayAsForeign" ng-if="detail.value.AddressID !== $root.CONFIG.guidEmpty"></print-address>\n\t\t\t\t\t\t\t<span ng-if="detail.value.AddressID === $root.CONFIG.guidEmpty">\n\t\t\t\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Boolean -->\n\t\t\t\t\t\t<div class="detail-block-value" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-when="boolean">\n\t\t\t\t\t\t\t{{detail.value ? \'Yes\' : \'No\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Buttons -->\n\t\t\t\t\t\t<div class="detail-block_buttons" ng-switch-when="buttons">\n\t\t\t\t\t\t\t<button class="is-white detail-block_button" ng-click="button.onClick()" ng-repeat="button in detail.buttons" type="button">\n\t\t\t\t\t\t\t\t{{button.label}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Date -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-when="date">\n\t\t\t\t\t\t\t<span ng-if="detail.value !== \'\'">{{detail.value | dateformat}}</span>\n\t\t\t\t\t\t\t<span ng-if="detail.value === \'\'">{{$root.CONFIG.defaultEmptyText}}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Divider -->\n\t\t\t\t\t\t<hr class="detail-block-divider" ng-switch-when="divider">\n\n\t\t\t\t\t\t<!-- Email -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-when="email">\n\t\t\t\t\t\t\t<a href="mailto:{{detail.value}}" ng-if="detail.value !== \'\'">\n\t\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<span ng-if="detail.value === \'\'">{{$root.CONFIG.defaultEmptyText}}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Image -->\n\t\t\t\t\t\t<div class="detail-block-value" ng-switch-when="image">\n\t\t\t\t\t\t\t<div class="detail-block-image">\n\t\t\t\t\t\t\t\t<img alt="{{detail.imageDescription}}" class="detail-block-image-media" ng-if="detail.value !== \'\'" src="{{detail.value}}">\n\t\t\t\t\t\t\t\t<i class="icon-{{detail.fallbackIcon}} detail-block-image-icon" ng-if="detail.value === \'\' && detail.fallbackIcon"></i>\n\t\t\t\t\t\t\t\t<p class="detail-block-image-description" ng-if="detail.imageDescription">\n\t\t\t\t\t\t\t\t\t{{detail.imageDescription}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Monetise -->\n\t\t\t\t\t\t<p class="detail-block-value" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-when="monetise">\n\t\t\t\t\t\t\t<i class="icon-{{detail.icon}} detail-block-value-icon" ng-if="detail.icon"></i>\n\t\t\t\t\t\t\t{{detail.value | monetise:detail.precision:null: { CURRENCY_LABEL : detail.currency } }}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Not Applicable -->\n\t\t\t\t\t\t<p class="detail-block-value detail-block-value-unknown" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-when="not-applicable">\n\t\t\t\t\t\t\tNot applicable\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Pension groups -->\n\t\t\t\t\t\t<div class="detail-block-pension-group" ng-switch-when="pension-group">\n\t\t\t\t\t\t\t<h5 class="detail-block-pension-group-title secondary">{{detail.group.PensionGroupName}}</h5>\n\t\t\t\t\t\t\t<p class="greyscale-darkened s">\n\t\t\t\t\t\t\t\t{{detail.group.EmployeePercent}}% employee\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;<span class="greyscale-lightened">|</span>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t{{detail.group.EmployerPercent}}% employer\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class="stat-list s basic greyscale">\n\t\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t\t<span class="stat-list__key">Salary sacrifice:</span>\n\t\t\t\t\t\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t\t\t\t\t\t{{detail.group.IsSalarySacrifice ? \'Yes\' : \'No\'}}\n\t\t\t\t\t\t\t\t\t\t<span ng-if="(\n\t\t\t\t\t\t\t\t\t\t\t\tdetail.group.HasEarningsLimitDisregard ||\n\t\t\t\t\t\t\t\t\t\t\t\tdetail.group.IsSalarySacrifice) &&\n\t\t\t\t\t\t\t\t\t\t\t\tdetail.group.ApplyEmployerNISavings && detail.group.EmployerNISavingsPercent\n\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t\t({{detail.group.EmployerNISavingsPercent}}% of Employer NI savings added to employee contribution)\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="stat-list__row" ng-if="detail.group.pensionType !== $ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\t\t\t\t\t<span class="stat-list__key">Contribution basis:</span>\n\t\t\t\t\t\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t\t\t\t\t\t{{detail.group.ContributionBasisDisplay}}\n\t\t\t\t\t\t\t\t\t\t<span ng-if="detail.group.HasEarningsLimitDisregard">\n\t\t\t\t\t\t\t\t\t\t\t({{detail.group.EarningsLimitDisregard | earningsLimitDisregardDescription}})\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="tag indifferent-lighter" ng-if="detail.group.pensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment && detail.group.IsDefault">\n\t\t\t\t\t\t\t\tDefault\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pension policy -->\n\t\t\t\t\t\t<div class="detail-block-value" ng-switch-when="pension-policy">\n\t\t\t\t\t\t\t{{detail.policy.name}}&nbsp;\n\t\t\t\t\t\t\t<a class="is-secondary underline" href="" ng-click="detail.policy.viewAction()">View</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Phone -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="phone">\n\t\t\t\t\t\t\t<a href="tel:{{detail.value}}" ng-if="detail.value !== \'\'">\n\t\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<span ng-if="detail.value === \'\'">Not added</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Postponement Length -->\n\t\t\t\t\t\t<div class="detail-block-value" ng-switch-when="postponement-length">\n\t\t\t\t\t\t\t<ng-pluralize count="detail.value" when="{\n\t\t\t\t\t\t\t\t\t\'0\': \'None\',\n\t\t\t\t\t\t\t\t\t\'1\': \'Postpone for 1 period\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Postpone for {} periods\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Switch -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'positive\' : \'assertive\'}}" ng-switch-when="switch">\n\t\t\t\t\t\t\t{{detail.value ? \'On\' : \'Off\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Read-only / Editable switch -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'assertive\' : \'primary\'}}" ng-switch-when="switch-editable">\n\t\t\t\t\t\t\t{{detail.value ? \'Editable\' : \'Read-only\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Custom switch -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'positive\' : \'assertive\'}}" ng-switch-when="switch-custom">\n\t\t\t\t\t\t\t{{detail.value ? detail.labelTrue : detail.labelFalse}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Custom switch -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'positive\' : \'quarternary\'}}" ng-switch-when="switch-custom-purple">\n\t\t\t\t\t\t\t{{detail.value ? detail.labelTrue : detail.labelFalse}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Visible / Hidden switch -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'primary\' : \'quarternary\'}}" ng-switch-when="switch-visible">\n\t\t\t\t\t\t\t{{detail.value ? \'Visible\' : \'Hidden\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Visible / Hidden switch (reversed) -->\n\t\t\t\t\t\t<div class="detail-block-tag tag {{detail.value ? \'quarternary\' : \'primary\'}}" ng-switch-when="switch-visible-reversed">\n\t\t\t\t\t\t\t{{detail.value ? \'Hidden\' : \'Visible\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- URL -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="url">\n\t\t\t\t\t\t\t<a href="{{detail.value | linkify}}" ng-if="detail.value !== \'\'" target="_blank">\n\t\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<span ng-if="detail.value === \'\'">{{$root.CONFIG.defaultEmptyText}}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Action Link -->\n\t\t\t\t\t\t<div class="detail-block-value {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="action-link">\n\t\t\t\t\t\t\t<a class="is-font-primary-400 underline" ng-click="detail.actionFunction()" ng-if="detail.value !== \'\'">\n\t\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<span ng-if="detail.value === \'\'">{{$root.CONFIG.defaultEmptyText}}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Slack -->\n\t\t\t\t\t\t<div class="detail-block-value slack {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="slack">\n\t\t\t\t\t\t\t<img alt="Slack Logo" class="detail-block-slackbadge" src="/images/logo/slack-badge.png">\n\t\t\t\t\t\t\t{{detail.value !== \'\' ? detail.value : \'Not added\'}}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pluralize -->\n\t\t\t\t\t\t<p class="detail-block-value" ng-switch-when="pluralize">\n\t\t\t\t\t\t\t<i class="icon-{{detail.icon}} detail-block-value-icon" ng-if="detail.icon"></i>\n\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t<ng-pluralize count="detail.value" when="{\'1\': detail.pluralValues.single, \'other\': detail.pluralValues.plural}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Placeholder -->\n\t\t\t\t\t\t<p class="detail-block-value detail-block-value-unknown" ng-switch-when="placeholder">\n\t\t\t\t\t\t\t<i class="icon-{{detail.icon}} detail-block-value-icon" ng-if="detail.icon"></i>\n\t\t\t\t\t\t\t{{detail.value !== \'\' ? detail.value : $root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Multiline text -->\n\t\t\t\t\t\t<p class="detail-block-multiline-text {{detail.value === \'\' ? \'detail-block-value-unknown\' : \'\'}}" ng-switch-when="multiline-text">\n\t\t\t\t\t\t\t<i class="icon-{{detail.icon}} detail-block-value-icon" ng-if="detail.icon"></i>\n\t\t\t\t\t\t\t{{detail.value !== \'\' ? detail.value : $root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Customisation / Colour -->\n\t\t\t\t\t\t<div class="detail-block-value has-overflow" ng-switch-when="customisation-colour">\n\t\t\t\t\t\t\t<div class="customisation_colour" style="--background-colour: {{detail.value}}"></div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Customisation / Shade -->\n\t\t\t\t\t\t<div class="detail-block-value has-overflow" ng-switch-when="customisation-shade">\n\t\t\t\t\t\t\t<div class="customisation_shade" ng-class="{\'is-light\' : detail.value === $ctrl.CUSTOMISATION_SHADES.light }">\n\t\t\t\t\t\t\t\t{{detail.value}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Customisation / Gradient -->\n\t\t\t\t\t\t<div class="detail-block-value has-overflow" ng-switch-when="customisation-gradient">\n\t\t\t\t\t\t\t<div class="customisation_gradient">\n\t\t\t\t\t\t\t\t<gradient-bar colour1="detail.value.Colour1" colour2="detail.value.Colour2" height="10" template="inline"></gradient-bar>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- HTML -->\n\t\t\t\t\t\t<div class="detail-block-value is-full-width" ng-switch-when="html" ng-transclude="html"></div>\n\n\t\t\t\t\t\t<!-- Default -->\n\t\t\t\t\t\t<p class="detail-block-value{{detail.upperFirstLetter === true ? \' upper-first-letter\' : \'\'}}{{detail.value === \'\' ? \' detail-block-value-unknown\' : \'\'}}" data-cy="{{ :: detail.label | slugify }}-value" ng-switch-default>\n\t\t\t\t\t\t\t<i class="icon-{{detail.icon}} detail-block-value-icon" ng-if="detail.icon"></i>\n\t\t\t\t\t\t\t{{detail.value !== \'\' ? detail.value : detail.emptyText ? detail.emptyText : $root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Email preview -->\n\t\t\t\t\t\t<a class="link-with-icon detail-block-preview" ng-if="detail.mailTypeId" ui-sref="email-preview({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.currentCompany.AgencyProfileID,\n\t\t\t\t\t\t\t\tmailtypeid: detail.mailTypeId,\n\t\t\t\t\t\t\t\tpreviewType: $ctrl.EMAIL_PREVIEW_TYPES.notificationSettingsPreview\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-external-link n"></i> Preview email\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- Additional info text if there is any -->\n\t\t\t\t\t\t<div class="detail-block-info-text" ng-if="detail.infoText">\n\t\t\t\t\t\t\t{{detail.infoText}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<div class="detail-block-feedback is-positioned-bottom" ng-if="$first && $ctrl.dbShowFeedback && $ctrl.dbFeedbackPosition === \'bottom\'" ng-transclude="feedback"></div>\n\n\t\t\t</div>\n\t\t</div>\n\t</main>\n</div>\n');
$templateCache.put('components/disbursement-card/disbursement-card.component.html','<div class="disbursement-card fadeIn">\n\t<div class="disbursement-card_top">\n\t\t<h5 class="disbursement-card_title">{{disbursement.BankInfo.BankAccountName}}</h5>\n\t\t<div>\n\t\t\t<span class="disbursement-card_date"><span ng-if="disbursement.paymentContext !== DISBURSEMENT_CONTEXT_TYPES.noSeparateBacsFile">Payment date:&nbsp;</span>{{::disbursement | bacsDisbursementPaymentDescription:true}}</span>\n\t\t</div>\n\t</div>\n\t<dropdown-menu menu-theme="is-assertive" menu-size="m" menu-show-chevron="false" menu-icon="icon-setup" menu-show="showMenu" class="disbursement-card_action-menu">\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="openEditBacsDisbursementForm(company, disbursement)">Edit</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" class="assertive" ng-click="openDeleteBacsDisbursementForm(company, disbursement)">Delete</a>\n\t\t</div>\n\t</dropdown-menu>\n\t<div class="disbursement-card_bottom">\n\t\t<div class="disbursement-card_type"><i class="icon-minus disbursement-card_icon"></i>&nbsp;&nbsp;<span class="disbursement-card_type-description">{{disbursement.Description}}</span><span class="disbursement-card_ref">Payment ref: {{disbursement.BankInfo.BACSPaymentReference}}</span></div>\n\t\t<div class="disbursement-card_status-info">Saved by {{disbursement.CreatedBy}} on {{disbursement.CreatedDateISO | dateformat}} at {{disbursement.CreatedDateISO | datetimeformat:\'time12\'}}</div>\n\t</div>\n</div>\n');
$templateCache.put('components/document-upload-card/document-upload-card.component.html','<div class="document-upload-card" data-cy="document-upload-{{::$ctrl.documentIndex}}" ng-class="[$ctrl.document.theme]">\n\t<div class="document-upload-card_header">\n\t\t<div class="document-upload-card_icon">\n\t\t\t<i ng-class="[$ctrl.document.icon]"></i>\n\t\t</div>\n\t\t<p class="document-upload-card_type" data-cy="document-upload-format">\n\t\t\t{{$ctrl.document.MIMEFormat}}\n\t\t</p>\n\t\t<div class="document-upload-card_actions" ng-transclude="actions" ng-if="$ctrl.hasActions"></div>\n\t</div>\n\t<div class="document-upload-card_details">\n\t\t<p class="document-upload-card_filename" data-cy="document-upload-name">\n\t\t\t{{$ctrl.document.DocumentName}}\n\t\t</p>\n\t\t<!--<p class="document-upload-card_meta" title="{{document.CreatedDateISO | datetimeformat}}">Added {{document.CreatedDateISO | datetimeformat:\'fromNow\'}} by {{document.CreatedBy}}</p>-->\n\t</div>\n\n\t<a class="greyscale document-upload-card_delete" data-cy="document-upload-delete" href="" ng-click="$ctrl.confirmDeleteDocument($ctrl.document)">\n\t\t<i class="icon-trash"></i> Delete\n\t</a>\n\n\t<div class="document-upload-card_confirm fadeIn" ng-if="$ctrl.document.state === \'confirm\'">\n\t\t<p class="document-upload-card_confirm-copy dropIn">\n\t\t\tAre you sure?&nbsp;&nbsp;&nbsp;\n\t\t\t<a data-cy="document-upload-delete-confirm" href="" ng-click="$ctrl.deleteDocument($ctrl.document)">Yes</a>&nbsp;&nbsp;&nbsp;\n\t\t\t<a data-cy="document-upload-delete-cancel" href="" ng-click="$ctrl.resetDocumentState($ctrl.document)">Cancel</a>\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/document-upload-row/document-upload-row.component.html','<div class="document-upload-row fadeIn" click-anywhere-but-here="$ctrl.showMenu = false" is-active="$ctrl.showMenu" ng-class="{\n\t\t\'is-selected\': $ctrl.document.isSelected,\n\t\t\'disable-hover\': !ctrl.refreshPage\n\t}">\n\t<div class="document-upload-row_layout">\n\t\t<div class="document-upload-row_action" ng-if="$ctrl.bulkItems">\n\t\t\t<input checkbox id="{{::$ctrl.document.AgencyDocumentID}}" ng-change="$ctrl.onCheckboxToggle($ctrl)" ng-model="$ctrl.document.isSelected" type="checkbox">\n\t\t</div>\n\n\t\t<div class="document-upload-row_media">\n\t\t\t<div class="document-upload-row_icon-wrapper">\n\t\t\t\t<i class="document-upload-row_icon" ng-class="$ctrl.document.icon || \'icon-document\'"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="document-upload-row_content">\n\t\t\t<div class="document-upload-row_details">\n\t\t\t\t<h6 class="document-upload-row_subtitle">\n\t\t\t\t\t{{$ctrl.document.MIMEFormat}}\n\t\t\t\t</h6>\n\n\t\t\t\t<div class="document-upload-row_title">\n\t\t\t\t\t<h5 class="document-upload-row_heading">\n\t\t\t\t\t\t{{$ctrl.document.DocumentName}}\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<span class="document-upload-row_meta">\n\t\t\t\t\tUploaded by {{$ctrl.document.CreatedBy}} at {{$ctrl.document.CreatedDateISO | datetimeformat:\'readable\'}}\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<div class="document-upload-row_tag" ng-switch="$ctrl.document.MIMEFormat === $ctrl.MIME_FORMATS.csv && $ctrl.document.DocumentState">\n\t\t\t\t<span class="tag tertiary inverse" pc-switch-when="$ctrl.DOCUMENT_STATES.unchecked">\n\t\t\t\t\tNot validated\n\t\t\t\t</span>\n\t\t\t\t<span class="tag primary inverse" pc-switch-when="$ctrl.DOCUMENT_STATES.checked">\n\t\t\t\t\tValidated\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="document-upload-row_menu" ng-if="$ctrl.refreshPage">\n\t\t\t<dropdown-menu menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.showMenu" menu-size="l" menu-theme="is-primary">\n\t\t\t\t<div class="dropdown-group" ng-switch="$ctrl.document.MIMEFormat">\n\t\t\t\t\t<a href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.document, $ctrl.DOCUMENT_TYPES.teamImport, $ctrl.agencyProfileId)" ng-if="$root.currentUser.Permissions.Team.canImportTeamData" pc-switch-when="$ctrl.MIME_FORMATS.csv">\n\t\t\t\t\t\tImport team data\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.document, $ctrl.DOCUMENT_TYPES.periodImport, $ctrl.agencyProfileId)" ng-if="$root.currentUser.Permissions.Team.canImportTeamData" pc-switch-when="$ctrl.MIME_FORMATS.csv">\n\t\t\t\t\t\tImport payroll data\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.openFileUploadsForm($ctrl, $ctrl.FILE_UPLOAD_FORMS.importFile)" ng-if="$root.currentUser.Permissions.Team.canImportTeamData" pc-switch-when="$ctrl.MIME_FORMATS.fps">\n\t\t\t\t\t\tImport team data\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.openFileUploadsForm($ctrl, $ctrl.FILE_UPLOAD_FORMS.renameFile)">\n\t\t\t\t\t\tEdit file label\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.openFileUploadsForm($ctrl, $ctrl.FILE_UPLOAD_FORMS.importHistory)" pc-switch-when="[$ctrl.MIME_FORMATS.csv, $ctrl.MIME_FORMATS.fps]">\n\t\t\t\t\t\tImport history\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.downloadDocument($ctrl)">\n\t\t\t\t\t\tDownload\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a class="assertive" href="" ng-click="$ctrl.openFileUploadsForm($ctrl, $ctrl.FILE_UPLOAD_FORMS.deleteFile)">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/download-link-card/download-link-card.component.html','<div class="download-link-card">\n\n\t<h6>{{$ctrl.text}}</h6>\n\n\t<a href="" ng-click="$ctrl.downloadFile($ctrl.url)" target="_blank" class="link-with-icon">\n\t\t<i class="icon-download"></i>Download\n\t</a>\n</div>\n');
$templateCache.put('components/dropdown-menu/dropdown-menu.component.html','<div class="dropdown-menu" ng-class="[$ctrl.menuAlign, $ctrl.menuSize, $ctrl.menuTheme]" click-anywhere-but-here="$ctrl.menuShow = false" is-active="$ctrl.menuShow">\n\n\t<span class="dropdown-menu_demo" tooltip-demo td-id="{{$ctrl.menuDemoId}}" td-active="!$ctrl.menuShow"></span>\n\n\t<a aria-label="Toggle menu" href="" class="dropdown-menu_link" data-cy="{{$ctrl.menuId}}" ng-click="$ctrl.toggleMenu($ctrl)" ng-class="{\'active\': $ctrl.menuShow}">\n\t\t<i class="dropdown-menu_icon" ng-class="[$ctrl.menuIconSize, $ctrl.menuIcon]" ng-if="$ctrl.menuIcon"></i><span class="dropdown-menu_label" title="{{$ctrl.menuText}}" ng-if="$ctrl.menuText">{{$ctrl.menuText}}</span><i class="icon-chevron-down dropdown-menu_link-chevron" ng-if="$ctrl.menuShowChevron"></i>\n\t</a>\n\n\t<div class="dropdown-menu_wrapper" ng-if="$ctrl.menuShow">\n\t\t<div class="dropdown" ng-class="$ctrl.menuSize">\n\t\t\t<ng-transclude></ng-transclude>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/editable-label/editable-label.component.html','<div class="editable-label" click-anywhere-but-here="$ctrl.cancelEditMode($ctrl)">\n\t<!-- Edit mode -->\n\t<div class="editable-label-content">\n\t\t<div class="editable-label-input-wrapper">\n\t\t\t<!-- Editable input -->\n\t\t\t<input class="editable-label-input monetise" id="{{$ctrl.fieldName}}" name="{{$ctrl.fieldName}}" ng-if="$ctrl.editMode" ng-model="$ctrl.ngModel" required type="number">\n\t\t\t<!-- Read only input. View mode. It\'s an input so it takes up the same space as the real input above -->\n\t\t\t<input class="editable-label-input non-editable" id="{{$ctrl.fieldName}}" name="{{$ctrl.fieldName}}" ng-if="!$ctrl.editMode" value="{{$ctrl.ngModel | monetise}}">\n\t\t\t<span ng-if="$ctrl.isEditable">\n\t\t\t\t<a aria-label="Close edit mode" class="is-primary" href="" ng-click="$ctrl.cancelEditMode($ctrl)" ng-if="$ctrl.editMode">&nbsp;<i class="icon-tick"></i></a>\n\t\t\t\t<a aria-label="Enter edit mode" class="is-primary-light" href="" ng-click="$ctrl.enterEditMode($ctrl)" ng-if="!$ctrl.editMode">&nbsp;<i class="icon-edit"></i></a>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/email-card/email-card.component.html','<div class="email-card fadeIn {{$ctrl.email.IsActive ? $ctrl.cardTheme : \'greyscale\'}}">\n\t<div class="email-card_active" ng-if="$ctrl.email.Group !== MAIL_GROUP_TYPES.system">\n\t\t<a href="" ng-click="toggleEmailIsActive($ctrl.email)" class="email-card_active-toggle" ng-if="!$ctrl.email.IsReadonly">\n\t\t\t<div class="toggle-b {{$ctrl.email.IsActive ? \'active\' : \'\'}} {{$ctrl.email.IsActive ? $ctrl.cardTheme : \'greyscale\'}}"></div>\n\t\t</a>\n\t\t<div class="toggle-b readonly {{$ctrl.email.IsActive ? \'active\' : \'\'}} {{$ctrl.email.IsActive ? $ctrl.cardTheme : \'greyscale\'}}" ng-if="$ctrl.email.IsReadonly"></div>\n\t</div>\n\t<div class="email-card_summary">\n\t\t<div class="email-card_title">{{$ctrl.email.Title}}</div>\n\t\t<div class="email-card_info"><span class="strong">Subject:</span>&nbsp;{{$ctrl.email.Subject}}</div>\n\t\t<div class="email-card_info"><span class="strong">Sent:</span>&nbsp;{{$ctrl.email.Description}}</div>\n\t\t<div class="email-card_info"><span class="strong">To:</span>&nbsp;{{$ctrl.email.IsSentToRecoveryEmailAddress ? \'Recovery email\' : \'Email\'}}</div>\n\t</div>\n\t<div class="email-card_preview">\n\t\t<span class="email-card_warning" tooltip tooltip-text="This email contains sensitive data"><icon-dot icon="icon-warning" theme="{{$ctrl.email.IsActive ? \'is-assertive\' : \'greyscale\'}}" ng-if="$ctrl.email.IsSensitive"></icon-dot></span>\n\t\t<a ui-sref="email-preview({agencyProfileId: $ctrl.agencyProfileId, mailtypeid: $ctrl.email.MailTypeID, previewType: EMAIL_PREVIEW_TYPES.notificationSettingsPreview})" class="email-card_preview-link"><i class="icon-external-link m"></i>&nbsp;Preview</a>\n\t</div>\n</div>\n');
$templateCache.put('components/email-contacts/email-contacts.component.html','<fieldset ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading" class="centered-contents fadeIn">\n\t\t<circle-loader class="m"></circle-loader>\n\t</div>\n\n\t<!-- Ready -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.ready" class="fadeIn">\n\n\t\t<div class="form-section" ng-class="{\'larger-margin\' : $ctrl.isInAddressBook}">\n\n\t\t\t<!-- Payroll Admins -->\n\t\t\t<fieldset class="fadeIn" ng-if="$ctrl.teamMemberAdmins.length > 0" ng-class="{\'form-fieldset-divider-top is-primary-lighter\' : !$ctrl.isInAddressBook}">\n\n\t\t\t\t<div ng-class="{\'form-section\' : $ctrl.showPayrollAdmins }">\n\t\t\t\t\t<p class="s"><i class="icon-team-alt primary m"></i> {{$ctrl.label}} <a href ng-click="$ctrl.toggleShowPayrollAdmins($ctrl)" class="primary"><ng-pluralize count="$ctrl.teamMemberAdmins.length" when="{\'1\': \'1 payroll admin\', \'other\': \'{} payroll admins\'}"></ng-pluralize>&nbsp;<i ng-class="$ctrl.showPayrollAdmins ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i></a></p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" ng-show="$ctrl.showPayrollAdmins">\n\t\t\t\t\t<search-bar options="$ctrl.searchBarOptionsAdmins" count="$ctrl.teamMemberAdmins.length"></search-bar>\n\n\t\t\t\t\t<div class="profile-card_wrapper">\n\t\t\t\t\t\t<profile-card name="admin.Forename + \' \' + admin.Surname" avatar-size="is-small" meta="admin.EmailAddress" theme="is-primary" ng-repeat="admin in $ctrl.teamMemberAdmins"></profile-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t\t<!-- Saved external recipients -->\n\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter fadeIn">\n\n\t\t\t\t<div ng-class="{\'form-section\' : $ctrl.showExternalContacts }" ng-if="$ctrl.externalContactsForType.length > 0">\n\t\t\t\t\t<p class="s"><i class="icon-team-alt primary m"></i> {{$ctrl.label}} <a href ng-click="$ctrl.toggleshowExternalContacts($ctrl)" class="primary"><ng-pluralize count="$ctrl.externalContactsForType.length" when="{\'1\': \'1 external recipient\', \'other\': \'{} external recipients\'}"></ng-pluralize>&nbsp;<i ng-class="$ctrl.showExternalContacts ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i></a></p>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="$ctrl.externalContactsForType.length === 0">\n\t\t\t\t\t<p class="s"><i class="icon-team-alt primary m"></i> {{$ctrl.label}} 0 external recipients</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" ng-show="$ctrl.showExternalContacts" ng-if="$ctrl.externalContactsForType.length > 0">\n\t\t\t\t\t<search-bar options="$ctrl.searchBarOptionsExternal" count="$ctrl.externalContactsForType.length"></search-bar>\n\n\t\t\t\t\t<div class="profile-card_wrapper">\n\t\t\t\t\t\t<profile-card name="contact.Forename + \' \' + contact.Surname" avatar-size="is-small" meta="contact.Email" theme="is-primary" ng-repeat="contact in $ctrl.externalContactsForType">\n\t\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.deleteSavedContact($ctrl, $index)" class="is-primary-light" aria-label="Delete contact"><i class="icon-trash"></i></a>\n\t\t\t\t\t\t\t</action>\n\t\t\t\t\t\t</profile-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t\t<!-- New external recipients -->\n\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter has-action fadeIn" ng-if="$ctrl.newContacts.length > 0" ng-repeat="(contactIndex, contact) in $ctrl.newContacts" ng-switch="contact.externalContactType">\n\n\t\t\t\t<a href="" ng-click="$ctrl.deleteUnsavedContact($ctrl, contactIndex)" class="form-fieldset-action is-primary-light" aria-label="Delete contact"><i class="icon-trash"></i></a>\n\n\t\t\t\t<fieldset pc-switch-when="$ctrl.CONTACT_TYPES.new">\n\n\t\t\t\t\t<!-- Name -->\n\t\t\t\t\t<section class="form-field-group">\n\n\t\t\t\t\t\t<!-- First Name -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="forename{{contactIndex}}" class="required">First name:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input type="text" id="forename{{contactIndex}}" name="forename{{contactIndex}}" ng-model="contact.Forename" ng-pattern="$root.REGEX.name" minlength="2" required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'forename\' + contactIndex].$error" ng-if="$ctrl.form[\'forename\' + contactIndex].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Last name -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="surname{{contactIndex}}" class="required">Last name:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input type="text" id="surname{{contactIndex}}" name="surname{{contactIndex}}" ng-model="contact.Surname" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'surname\' + contactIndex].$error" ng-if="$ctrl.form[\'surname\' + contactIndex].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Last names can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Personal Email -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="email{{contactIndex}}" class="required">Email address:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input type="email" id="email{{contactIndex}}" name="email{{contactIndex}}" ng-model="contact.Email" ng-pattern="$root.REGEX.email" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'email\' + contactIndex].$error" ng-if="$ctrl.form[\'email\' + contactIndex].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please make sure the email is valid</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<fieldset pc-switch-when="$ctrl.CONTACT_TYPES.existing">\n\n\t\t\t\t\t<!-- Select contact -->\n\t\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="existingContact{{contactIndex}}" class="required">Select contact:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t<select class="l-alt" name="existingContact{{contactIndex}}" id="existingContact{{contactIndex}}" ng-model="contact.existingContact" ng-change="$ctrl.onExternalContactSelect($ctrl, contactIndex, contact)" ng-options="externalContact as externalContact.fullName for externalContact in $ctrl.unusedExternalContacts" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'existingContact\'+ contactIndex ].$error" ng-if="$ctrl.form[\'existingContact\'+ contactIndex ].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- External contact type -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.unusedExternalContacts.length > 0">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list is-inline">\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="externalContactType{{contactIndex}}" id="externalContactType{{contactIndex}}-exiting" class="b" ng-value="$ctrl.CONTACT_TYPES.existing" ng-change="$ctrl.onExternalContactTypeChange(contact)" ng-model="contact.externalContactType">\n\t\t\t\t\t\t\t\t<label for="externalContactType{{contactIndex}}-exiting">Select existing contact</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="externalContactType{{contactIndex}}" id="externalContactType{{contactIndex}}-quarterly" class="b" ng-value="$ctrl.CONTACT_TYPES.new" ng-change="$ctrl.onExternalContactTypeChange(contact)" ng-model="contact.externalContactType">\n\t\t\t\t\t\t\t\t<label for="externalContactType{{contactIndex}}-quarterly">Add new contact</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<button class="is-white is-medium-large is-block" ng-class="{\n\t\t\t\t\t\'is-primary-100\' : !$ctrl.isInAddressBook\n\t\t\t\t}" ng-click="$ctrl.onAddExternalContact($ctrl)" type="button">\n\t\t\t<i class="icon-add m button_icon-pre"></i> Add external recipient\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<!-- Error -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error" class="fadeIn">\n\t\t<error-block></error-block>\n\t</div>\n</fieldset>\n');
$templateCache.put('components/empty-search/empty-search.component.html','<div class="empty-search fadeIn">\n\n\t<img alt="" class="empty-search_graphic" src="images/graphics/no-search-results.png">\n\n\t<div class="empty-search_info" data-cy="empty-search-info">\n\t\t<h4 class="empty-search_title" data-cy="empty-search-title">\n\t\t\tNothing to see here\n\t\t</h4>\n\t\t<div>\n\t\t\t<p class="s">Unfortunately your search returned no results!</p>\n\t\t\t<p class="s">Try searching again or changing your filters.</p>\n\t\t</div>\n\t\t<div class="empty-search_actions" data-cy="empty-search-actions">\n\t\t\t<a class="button action fadeIn" data-cy="empty-search-clear-search" href="" ng-click="$ctrl.searchBarOptions.clearSearch()" ng-if="$ctrl.searchBarOptions.search.string !== \'\'">\n\t\t\t\tClear search\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/eps-form-field/eps-form-field.component.html','<div class="form-field">\n\t<div class="eps-form-field" ng-class="{ \'has-labels\': $ctrl.showLabels, \'is-disabled\' : $ctrl.isDisabled}">\n\t\t<header class="eps-form-field_header">\n\t\t\t<label ng-class="{ \'required\': !$ctrl.epsFormField.isCalculated }" for="{{$ctrl.epsFieldName}}_current">{{$ctrl.epsFormField.description}}:</label>\n\t\t</header>\n\t\t<div class="eps-form-field_part">\n\t\t\t<label class="eps-form-field_part-label" for="{{$ctrl.epsFormField.currentValueField}}" ng-if="$ctrl.showLabels">Current value</label>\n\t\t\t<input class="monetise is-readonly" id="{{$ctrl.epsFormField.currentValueField}}" name="{{$ctrl.epsFormField.currentValueField}}" ng-model-options="{ debounce: 200 }" ng-model="$ctrl.epsDetail[$ctrl.epsFormField.currentValueField]" placeholder="0" type="number" disabled="disabled">\n\t\t</div>\n\t\t<div class="eps-form-field_part">\n\t\t\t<label class="eps-form-field_part-label" for="{{$ctrl.epsFormField.differenceField}}" ng-if="$ctrl.showLabels">Difference</label>\n\t\t\t<input class="monetise" id="{{$ctrl.epsFormField.differenceField}}" name="{{$ctrl.epsFormField.differenceField}}" ng-attr-placeholder="{{$ctrl.epsFormField.isCalculated ? \'0\' : \'Enter value\'}}" ng-attr-required="!$ctrl.epsFormField.isCalculated" ng-change="$ctrl.differenceOnChange($ctrl)" ng-class="{ \'is-readonly\': $ctrl.epsFormField.isCalculated || $ctrl.isDisabled }" ng-disabled="$ctrl.epsFormField.isCalculated || $ctrl.isDisabled" ng-model-options="{ debounce: 200 }" ng-model="$ctrl.epsDetail[$ctrl.epsFormField.differenceField]" ng-pattern="$ctrl.epsFormField.integersOnly ? $root.REGEX.number9DigitsAllowNegative : $root.REGEX.number6Digits2DecimalAllowNegative" type="number">\n\t\t</div>\n\t\t<div class="eps-form-field_part">\n\t\t\t<label class="eps-form-field_part-label" for="{{$ctrl.epsFormField.newValueField}}" ng-if="$ctrl.showLabels">New value</label>\n\t\t\t<input class="monetise is-readonly" id="{{$ctrl.epsFormField.newValueField}}" name="{{$ctrl.epsFormField.newValueField}}" ng-model-options="{ debounce: 200 }" ng-model="$ctrl.epsDetail[$ctrl.epsFormField.newValueField]" placeholder="0" type="number" disabled="disabled">\n\t\t</div>\n\t</div>\n\t<div class="eps-form-field_errors form-errors fadeIn" ng-messages="$ctrl.epsForm[$ctrl.epsFormField.differenceField].$error" ng-show="$ctrl.epsForm[$ctrl.epsFormField.differenceField].$touched" role="alert">\n\t\t<p class="align-right" ng-message="pattern">\n\t\t\t{{$ctrl.epsFormField.integersOnly ? \'Please enter a whole value (without decimal places) up to \xA3999,999,999 for \': \'Maximum of \xA3999,999.99 for \'}}\n\t\t\t{{$ctrl.epsFormField.description}}\n\t\t</p>\n\t\t<p class="align-center" ng-message="required">Please enter a value</p>\n\t\t<p class="align-right" ng-message="epsFormFieldNegative">Please ensure that new values don\'t become negative</p>\n\t</div>\n</div>\n');
$templateCache.put('components/eps-form-fieldset/eps-form-fieldset.component.html','<ng-form name="epsForm">\n\t<fieldset class="eps-form-fieldset">\n\n\t\t<header class="form-intro eps-form-fieldset_header">\n\t\t\t<div class="eps-form-fieldset_header-prompt">\n\t\t\t\tYou\'re about to {{$ctrl.eps.IsResubmission ? \'re-submit\' : \'submit\'}} an EPS for the period\n\t\t\t</div>\n\t\t\t<div class="eps-form-fieldset_header-period">\n\t\t\t\t{{ ::$ctrl.eps.EPSDetail.EPSTaxMonthStartISO | dateformat:\'monthYear\' }}\n\t\t\t</div>\n\t\t</header>\n\n\t\t<div class="form-section">\n\t\t\t<p class="s">If you need to reduce a current value for your submission, enter a minus sign before the difference you wish to enter.\n\t\t\t\tIf you want to submit this EPS without making any changes, tick the box below.\n\t\t\t</p>\n\t\t</div>\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input checkbox id="canBeSubmittedWithoutChanges" label-text="\'Submit this EPS without making any changes\'" label-text-class="is-small" name="checkboxField" ng-change="$ctrl.onEPSCanBeSubmittedWithoutChangesChange($ctrl.eps)" ng-model="$ctrl.eps.canBeSubmittedWithoutChanges" type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<eps-form-field eps-detail="$ctrl.eps.EPSDetail" eps-form-field="epsFormField" is-disabled="$ctrl.eps.canBeSubmittedWithoutChanges" ng-repeat="epsFormField in $ctrl.eps.epsFormFields" on-change="$ctrl.epsFormFieldOnChange(epsForm, $ctrl.eps, epsFormField)" show-labels="$first"></eps-form-field>\n\n\t\t<div class="form-section">\n\t\t\t<div class="form-errors fadeIn" ng-show="!$ctrl.eps.hasChanges && !$ctrl.eps.canBeSubmittedWithoutChanges">\n\t\t\t\t<p class="s assertive">Please change at least one value</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n</ng-form>\n');
$templateCache.put('components/error-block/error-block.component.html','<div aria-describedby="error-block-title" class="error-block fadeIn" ng-class="{\n\t\t\'has-margin\' : $ctrl.hasGutter\n\t}" role="alertdialog">\n\t<div class="error-block_layout">\n\t\t<img alt="" class="error-block_media" src="/images/graphics/placeholders/error-in-app.2x.png">\n\n\t\t<h5 class="error-block_title" id="error-block-title">\n\t\t\t{{$ctrl.title}}\n\t\t</h5>\n\n\t\t<div class="error-block_content">\n\t\t\t<ng-transclude>\n\t\t\t\t<p ng-if="!$ctrl.errorMessage">\n\t\t\t\t\tWe\u2019re unable to load your data at this time.\n\t\t\t\t\t<a href="" class="underline" ng-click="$ctrl.reloadPage()">\n\t\t\t\t\t\tTry refreshing the page\n\t\t\t\t\t</a>\n\t\t\t\t\tor please try again shortly.\n\t\t\t\t</p>\n\t\t\t\t<p ng-if="$ctrl.errorMessage">\n\t\t\t\t\t{{$ctrl.errorMessage}}\n\t\t\t\t</p>\n\t\t\t</ng-transclude>\n\t\t</div>\n\n\t\t<div class="error-block_secondary-actions" ng-if="$ctrl.secondaryAction && $ctrl.secondaryActionText">\n\t\t\t<a class="s underline" href="" ng-click="$ctrl.secondaryAction()">\n\t\t\t\t{{$ctrl.secondaryActionText}}\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/extended-checkbox/extended-checkbox.component.html','<div class="extended-checkbox" ng-class="{\n\t\t\'is-disabled\' : $ctrl.disabled,\n\t\t\'has-border\': $ctrl.hasBorder,\n\t\t\'is-selected\': $ctrl.ngModel\n\t}">\n\t<div class="extended-checkbox_layout">\n\t\t<div class="extended-checkbox_checkbox">\n\t\t   <input class="pc-checkbox" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-click="$ctrl.onCheckboxChange()" ng-disabled="$ctrl.disabled" ng-model="$ctrl.ngModel" ng-required="$ctrl.required" type="checkbox">\n\t\t</div>\n\n\t\t<div class="extended-checkbox_area">\n\t\t\t<label class="extended-checkbox_label" for="{{$ctrl.name}}" ng-transclude="label"></label>\n\n\t\t\t<div class="extended-checkbox_content fadeIn" ng-if="$ctrl.hasContent && ($ctrl.ngModel || $ctrl.alwaysShowContent)" ng-transclude="content">\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/extended-radio/extended-radio.component.html','<div class="extended-radio" data-cy="extended-radio-{{$ctrl.name}}-{{$ctrl.value}}" ng-class="[$ctrl.theme, {\'is-selected\': $ctrl.ngModel === $ctrl.value, \'has-click-anywhere\' : $ctrl.hasClickAnywhere }]">\n\t<div class="extended-radio_layout">\n\t\t<div class="extended-radio_button" ng-class="{ \'is-centered\' : !$ctrl.hasContent }">\n\t\t\t<input class="b extended-radio_input" data-cy="{{:: $ctrl.id }}" id="{{$ctrl.name}}-{{$ctrl.value}}" name="{{$ctrl.name}}" ng-change="$ctrl.onRadioChange($ctrl)" ng-class="$ctrl.theme" ng-disabled="$ctrl.disabled" ng-model="$ctrl.ngModel" ng-required="$ctrl.required" ng-value="$ctrl.value" type="radio">\n\t\t\t<label class="extended-radio_label" for="{{$ctrl.name}}-{{$ctrl.value}}" ng-if="!$ctrl.hasClickAnywhere">&nbsp;</label>\n\t\t\t<label class="extended-radio_click-anywhere" for="{{$ctrl.name}}-{{$ctrl.value}}" ng-if="$ctrl.hasClickAnywhere">&nbsp;</label>\n\t\t</div>\n\n\t\t<div class="extended-radio_area">\n\t\t\t<div class="extended-radio_header">\n\t\t\t\t<label class="extended-radio_label" for="{{$ctrl.name}}-{{$ctrl.value}}" ng-class="{\'is-disabled\' : $ctrl.disabled }" ng-transclude="label"></label>\n\t\t\t\t<div class="extended-radio_field" data-cy="extended-radio_field" ng-if="$ctrl.hasField" ng-transclude="field"></div>\n\t\t\t</div>\n\t\t\t<div class="extended-radio_content fadeIn" ng-if="$ctrl.hasContent && ($ctrl.alwaysShowContent || $ctrl.showContentWhenChecked && $ctrl.ngModel === $ctrl.value)" ng-transclude="content"></div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/extended-toggle-input/extended-toggle-input.component.html','<div class="extended-toggle-input" ng-class="{\'is-selected\': $ctrl.fieldModel}">\n\t<div class="extended-toggle-input_layout">\n\t\t<div class="extended-toggle-input_toggle">\n\t\t   <toggle-input field-disabled="$ctrl.fieldDisabled" field-label-stay-active="$ctrl.fieldLabelStayActive" field-label="{{$ctrl.fieldLabel}}" field-model="$ctrl.fieldModel" field-name="{{$ctrl.fieldName}}" field-on-change="$ctrl.onFieldChange($ctrl)" field-theme-light="$ctrl.fieldThemeLight"></toggle-input>\n\t\t</div>\n\n\t\t<div class="extended-toggle-input_description" ng-if="$ctrl.hasDescription">\n\t\t\t<p class="extended-toggle-input_paragraph" ng-transclude="description"></p>\n\t\t</div>\n\n\t\t<div class="extended-toggle-input_area">\n\t\t\t<div class="extended-toggle-input_content fadeIn" ng-if="$ctrl.hasContent && ($ctrl.fieldModel || $ctrl.alwaysShowContent)" ng-transclude="content">\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/fast-search/fast-search.component.html','<form class="fast-search" name="fastSearchForm" ng-submit="$ctrl.updateSearch($ctrl.searchString)" novalidate role="search">\n\n\t<!-- Search Bar -->\n<div class="fast-search_controls" id="paycircle-fast-search-controls" ng-class="{\n\t\t\t\'slideOutTop\': $ctrl.componentState === \'closing\',\n\t\t\t\'slideInTop\': $ctrl.componentState === \'opening\',\n\t\t\t\'fast-search_controls--active\': $ctrl.categoryMenuOpen || $ctrl.fieldMenuOpen\n\t\t}">\n\t\t<div class="fast-search_controls-container">\n\t\t\t<div class="fast-search_controls-container_actions">\n\t\t\t\t<menu-button class="fast-search_controls-menu-button" menu-button-add-icon="false" menu-button-id="category-selection-button" menu-button-open="$ctrl.categoryMenuOpen" menu-button-size="m" menu-button-text="{{$ctrl.activeCategory.Label}}" menu-button-theme="is-white is-white-alt">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="" ng-repeat="(key, value) in $ctrl.CATEGORIES" ng-click="$ctrl.setActiveCategory(value)">{{::value.Label}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t</menu-button>\n\n\t\t\t\t<menu-button class="fast-search_controls-menu-button" menu-button-add-icon="false" menu-button-id="field-selection-button" menu-button-open="$ctrl.fieldMenuOpen" menu-button-size="m" menu-button-text="{{$ctrl.activeField.Label}}" menu-button-theme="is-white is-white-alt">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="" ng-repeat="(key, value) in $ctrl.activeCategory.Fields" ng-click="$ctrl.setActiveField(value)">{{::value.Label}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t</menu-button>\n\t\t\t</div>\n\n\t\t\t<div class="fast-search_controls-input-container">\n\t\t\t\t<input class="search-input-bar_input fast-search_controls-input" data-cy="fast-search-search-string" id="paycircle-fast-search-input" maxlength="{{$ctrl.MAX_SEARCH_LENGTH}}" name="paycircleFastSearchInput" ng-minlength="$ctrl.MIN_SEARCH_LENGTH" ng-pattern="$ctrl.getInputPattern()" ng-model="$ctrl.searchString" pc-keypress pc-keypress-action="$ctrl.closeFastSearch()" pc-keypress-key="escape" placeholder="Enter at least 3 characters" required type="search">\n\t\t\t</div>\n\n\t\t\t<submit-button button-id="fast-search-button" button-theme="\'grey\'" disable-button="fastSearchForm.$invalid" display-text="\'Search\'" state="$ctrl.searchState">\n\t\t\t</submit-button>\n\n\t\t</div>\n\t\t<a aria-label="Close search" class="fast-search_controls-close" href="" ng-click="$ctrl.closeFastSearch()">\n\t\t\t<i class="icon-cross fast-search_controls-close-icon"></i>\n\t\t</a>\n\t</div>\n\n\t<!-- Results -->\n<section class="fast-search_results-container" id="paycircle-fast-search-results" ng-class="{\n\t\t\'fadeIn\': $ctrl.searchState === \'ready\',\n\t\t\'fadeOut\': $ctrl.componentState === \'closing\'\n\t}" ng-show="$ctrl.searchState === $ctrl.COMPONENT_STATES.ready">\n\n\t\t<div ng-switch="$ctrl.searchData.Category.Name">\n\t\t\t<!-- Team Members -->\n\t\t\t<div class="fast-search_results-category-container" pc-switch-when="$ctrl.CATEGORIES.teamMembers.Name">\n\t\t\t\t<div ng-class="{ \'is-active\': $ctrl.searchData.Category === $ctrl.CATEGORIES.teamMembers }" ng-switch="$ctrl.searchData.State">\n\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t\t<lb-description>Searching team members for <strong class="italic">&lsquo;{{$ctrl.searchData.SearchString}}&rsquo;</strong></lb-description>\n\t\t\t\t\t\t</loading-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\t\t\t\t\t\t<!--Results-->\n\t\t\t\t\t\t<div class="fast-search_results-category" ng-if="$ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t<header class="fast-search_results-category-header">\n\t\t\t\t\t\t\t\t<p data-cy="fast-search-team-member-results-header">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.searchData.SearchResults.length" when="{\n\t\t\t\t\t\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>&nbsp;with &lsquo;<strong class="italic">{{$ctrl.searchData.SearchString}}</strong>&rsquo;\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="fast-search_results-items">\n\t\t\t\t\t\t\t\t<div class="fast-search_results-item fadeIn" ng-repeat="\n\t\t\t\t\t\t\t\t\t\tteamMember in $ctrl.searchData.SearchResults |\n\t\t\t\t\t\t\t\t\t\torderBy: \'Forename\' |\n\t\t\t\t\t\t\t\t\t\tlimitTo: $ctrl.searchData.ResultsLimit\n\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t<header class="fast-search_results-item-header">\n\n\t\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Forename[0] || teamMember.CompanyName[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.UserID}}" class="fast-search_results-item-avatar">\n\t\t\t\t\t\t\t\t\t\t</avatar>\n\t\t\t\t\t\t\t\t\t\t<h5 class="fast-search_results-item-name" ng-bind-html="(teamMember.Forename + \' \' + teamMember.Surname) | highlight: $ctrl.searchData.SearchString">\n\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t<p class="fast-search_results-item-header-meta" ng-bind-html="(\'NI Number: \' + (teamMember.NINumber ? (teamMember.NINumber | highlight: $ctrl.searchData.SearchString) : \'Unknown\'))"></p>\n\t\t\t\t\t\t\t\t\t\t<div class="fast-search_results-item-header-badge" ng-if="teamMember.CompanyBureau" tooltip tooltip-position="left" tooltip-text="{{teamMember.CompanyBureau}}">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-franchisees"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t<footer class="fast-search_results-item-footer">\n\t\t\t\t\t\t\t\t\t\t<div class="fast-search_meta-items">\n\t\t\t\t\t\t\t\t\t\t\t<span class="fast-search_meta-item" title="{{::teamMember.CompanyName}}" tooltip tooltip-position="top" tooltip-text="{{::teamMember.CompanyName}}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-company"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="teamMember.CompanyName | highlight: $ctrl.searchData.SearchString"></span>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t<span class="fast-search_meta-item" ng-if="::teamMember.CompanyGroup" title="{{::teamMember.CompanyGroup}}" tooltip tooltip-position="top" tooltip-text="{{::teamMember.CompanyGroup}}" tooltip-visible="{{teamMember.CompanyGroup.length > 10}}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-company-groups"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="teamMember.CompanyGroup | highlight:$ctrl.searchData.SearchString"></span>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<a class="fast-search_action-link fast-search_results-item-footer-action" ng-click="$ctrl.navigateToTeamMember(teamMember.UserID, teamMember.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t\t\tView profile\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<footer class="fast-search_results-items-footer" ng-show="$ctrl.searchData.ResultsLimit <= $ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t\t\t<a class="button is-clear fast-search_results-show-more" data-cy="fast-search-load-more-team-members-button" href="" ng-click="$ctrl.showMoreResults()">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-add is-medium has-margin-right"></i>Load more\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!--No results. Show when no results and search string is not empty.-->\n\t\t\t\t\t\t<div class="fast-search_results-no-results" ng-show="!$ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t<placeholder placeholder-graphic-size="l" placeholder-graphic="no-results">\n\t\t\t\t\t\t\t\t<placeholder-title>No results found for <strong class="italic">&lsquo;{{$ctrl.searchData.SearchString}}&rsquo;</strong></placeholder-title>\n\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t<p>Unfortunately your search returned no team members.</p>\n\t\t\t\t\t\t\t\t\t<p>Try searching again if you were hoping to find one!</p>\n\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t\t\t\t\t<error-block has-gutter="true"></error-block>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Companies -->\n\t\t\t<div class="fast-search_results-category-container" pc-switch-when="$ctrl.CATEGORIES.companies.Name">\n\t\t\t\t<div ng-class="{\'is-active\': $ctrl.searchData.Category === $ctrl.CATEGORIES.companies}">\n\t\t\t\t\t<div ng-switch="$ctrl.searchData.State">\n\t\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t\t\t<lb-description>Searching companies for <strong class="italic">&lsquo;{{$ctrl.searchData.SearchString}}&rsquo;</strong></lb-description>\n\t\t\t\t\t\t\t</loading-block>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\t\t\t\t\t\t\t<!-- Results -->\n\t\t\t\t\t\t\t<div class="fast-search_results-category" ng-if="$ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t\t<header class="fast-search_results-category-header">\n\t\t\t\t\t\t\t\t\t<p data-cy="fast-search-company-results-header-text">\n\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.searchData.SearchResults.length" when="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'1\': \'1 company\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'other\': \'{} companies\'\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t</ng-pluralize>&nbsp;with &lsquo;<strong class="italic">{{$ctrl.searchData.SearchString}}</strong>&rsquo;\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<div class="fast-search_results-items">\n\t\t\t\t\t\t\t\t\t<div class="fast-search_results-item" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'is-disabled\': company.IsArchived\n\t\t\t\t\t\t\t\t\t\t}" ng-repeat="\n\t\t\t\t\t\t\t\t\t\t\tcompany in $ctrl.searchData.SearchResults |\n\t\t\t\t\t\t\t\t\t\t\torderBy: \'CompanyName\' |\n\t\t\t\t\t\t\t\t\t\t\tlimitTo: $ctrl.searchData.ResultsLimit\n\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t<header class="fast-search_results-item-header">\n\t\t\t\t\t\t\t\t\t\t\t<div class="fast-search_results-item-badge">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-company"></i>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<h5 class="fast-search_results-item-name">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="company.CompanyName | highlight: $ctrl.searchData.SearchString"></span>\n\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t<p class="fast-search_results-item-header-meta" ng-bind-html="company.PAYEReference | highlight: $ctrl.searchData.SearchString" ng-if="!company.IsArchived">\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p class="fast-search_results-item-header-meta" ng-if="company.IsArchived">\n\t\t\t\t\t\t\t\t\t\t\t\tArchived: {{::company.ArchiveDateISO | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<div class="fast-search_results-item-header-badge" ng-if="company.CompanyBureau" tooltip tooltip-position="left" tooltip-text="{{company.CompanyBureau}}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-franchisees"></i>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<footer class="fast-search_results-item-footer">\n\t\t\t\t\t\t\t\t\t\t\t<div class="fast-search_meta-items">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="fast-search_meta-item" ng-if="::!company.IsArchived" tooltip-position="top" tooltip-text="{{company.CompanyGroup}}" tooltip-visible="{{company.CompanyGroup.length > 10}}" tooltip>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-company-groups"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="company.CompanyGroup ? (company.CompanyGroup | highlight:$ctrl.searchData.SearchString) : \'None\'"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="fast-search_meta-item" ng-if="::company.IsArchived" title="{{::company.CompanyName}} was archived on {{::company.ArchiveDateISO | dateformat}}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-archive"></i>{{::company.ArchiveDateISO | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<a class="fast-search_action-link fast-search_results-item-footer-action" data-cy="fast-search-view-company-{{$index}}" ng-click="$ctrl.navigateToCompany(company.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t\t\t\tView company\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<footer class="fast-search_results-items-footer" ng-show="$ctrl.searchData.ResultsLimit <= $ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t\t\t\t<a class="button is-clear fast-search_results-show-more" data-cy="fast-search-load-more-companies-button" href="" ng-click="$ctrl.showMoreResults()">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-add is-medium has-margin-right"></i>Load more\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- No results. Show when no results and search string is not empty. -->\n\t\t\t\t\t\t\t<div class="fast-search_results-no-results" ng-show="!$ctrl.searchData.SearchResults.length">\n\t\t\t\t\t\t\t\t<placeholder placeholder-graphic="no-results" placeholder-graphic-size="l">\n\t\t\t\t\t\t\t\t\t<placeholder-title>No results found for <strong class="italic">&lsquo;{{$ctrl.searchData.SearchString}}&rsquo;</strong></placeholder-title>\n\t\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t\t<p>Unfortunately your search returned no companies.</p>\n\t\t\t\t\t\t\t\t\t\t<p>Try searching again if you were hoping to find one!</p>\n\t\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t\t\t<placeholder-secondary-actions>\n\t\t\t\t\t\t\t\t\t\t<a class="fast-search_action-link" ng-click="$ctrl.closeFastSearch()" ui-sref="companies({\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId\n\t\t\t\t\t\t\t\t\t\t\t\t\t})">View all companies</a>\n\t\t\t\t\t\t\t\t\t</placeholder-secondary-actions>\n\t\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t\t\t\t\t\t\t<error-block has-gutter="true"></error-block>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<powered-by-paycircle class="fast-search_powered-by-paycircle"></powered-by-paycircle>\n\t</section>\n</form>\n');
$templateCache.put('components/feature-carousel/featureCarouselComponent.html','<div class="feature-carousel {{fcTheme || \'primary\'}}">\n\t<a href="" class="feature-carousel-icon feature-carousel-previous" ng-click="goToPreviousItem()" ng-show="activeItemIndex > 0" aria-label="Go to previous item">\n\t\t<i class="icon-chevron-left"></i>\n\t</a>\n\t<div class="feature-carousel-item" ng-class="{\'fadeInRight\': carouselState === \'next\', \'fadeOutLeft\': carouselState === \'closeNext\', \'fadeOutRight\': carouselState === \'closePrevious\', \'fadeInLeft\': carouselState === \'previous\', \'fadeIn\': !carouselState}" ng-repeat="fcItem in fcItems" ng-show="$index === activeItemIndex">\n\t\t<img alt="" class="feature-carousel-graphic" ng-src="images/graphics/{{fcDirectory}}/{{$index}}.png">\n\t\t<p class="feature-carousel-title">{{fcItem.title}}</p>\n\t</div>\n\t<a href="" class="feature-carousel-icon feature-carousel-next" ng-click="goToNextItem()" ng-show="activeItemIndex < (fcItems.length - 1)" aria-label="Go to next item">\n\t\t<i class="icon-chevron-right"></i>\n\t</a>\n</div>\n');
$templateCache.put('components/feature-sentiment/feature-sentiment.component.html','<div class="feature-sentiment" data-cy="feature-sentiment" ng-show="$ctrl.isEvoEnabled">\n\t<div class="feature-sentiment_container" data-cy="feature-sentiment-container"></div>\n</div>\n');
$templateCache.put('components/file-card/file-card.component.html','<div class="file-card fadeIn" ng-class="::[$ctrl.fileTheme, $ctrl.fileSize]">\n\t<div class="file-card_layout">\n\t\t<div class="file-card_icon"><i ng-class="$ctrl.icon"></i></div>\n\n\t\t<div class="file-card_content">\n\t\t\t<h6 class="file-card_heading">{{::$ctrl.file.DocumentName}}</h6>\n\t\t\t<p class="file-card_paragraph">{{::$ctrl.file.DocumentSize | fileSize}}</p>\n\t\t</div>\n\n\t\t<div class="file-card_actions">\n\t\t\t<a href="" ng-click="$ctrl.downloadFile($ctrl.downloadUrl, $ctrl.file.DocumentName)" class="file-card_action" ng-class="$ctrl.fileTheme" tooltip tooltip-text="Download" ng-if="$ctrl.hasDownload" aria-label="Download file"><i class="icon-download is-medium"></i></a>\n\t\t\t<a href="" ng-click="$ctrl.deleteFile($ctrl.file)" class="file-card_action" ng-class="$ctrl.fileTheme" tooltip tooltip-text="Delete file" ng-if="$ctrl.onDelete" aria-label="Delete file"><i class="icon-trash is-medium"></i></a>\n\t\t</div>\n\t</div>\n\n\t<div class="file-card_footer" ng-if="$ctrl.hasFooter" ng-transclude="footer">\n\n\t</div>\n</div>\n');
$templateCache.put('components/file-uploader/file-uploader-queued.component.html','<div class="file-uploader-queued {{$ctrl.getComponentClass($ctrl.componentState)}}">\n\n\t<div class="file-uploader-queued_state {{$ctrl.getComponentClass($ctrl.componentState)}}" ng-switch="$ctrl.componentState">\n\n\t\t<!-- Upload -->\n\t\t<label class="fadeIn file-uploader-queued_label" pc-switch-when="$ctrl.COMPONENT_STATES.upload">\n\t\t\t<div class="file-uploader-queued_label-container">\n\t\t\t\t<input accept="{{$ctrl.fuAllowedFileTypes}}" class="file-uploader-queued_label-input" id="fileUpload" nv-file-select type="file" uploader="$ctrl.uploader">\n\t\t\t\t<span class="file-uploader-queued_label-text">\n\t\t\t\t\t<i class="icon-upload file-uploader-queued_label-icon"></i>\n\t\t\t\t\t<span data-cy="file-uploader-message">{{$ctrl.fuMessage}}</span>\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</label>\n\n\t\t<!-- Uploading -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.uploading">\n\t\t\t<circle-loader class="file-uploader-queued_circle-loader"></circle-loader>\n\t\t</div>\n\n\t\t<!-- Uploaded -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.uploaded">\n\t\t\t<i class="icon-tick xl positive file-uploader-queued_state-icon"></i>\n\t\t</div>\n\n\t\t<!-- Upload Error -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.uploadError">\n\t\t\t<div class="file-uploader-queued_message-block">\n\t\t\t\t<i class="icon-warning file-uploader-queued_message-block-icon"></i>\n\t\t\t\t<p class="file-uploader-queued_message-block-title">Not uploaded\n\t\t\t\t\t<a class="file-uploader-queued_message-block-action" href="" ng-click="$ctrl.setComponentState($ctrl.COMPONENT_STATES.upload)">\n\t\t\t\t\t\tTry again\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- File size too big -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.invalidFileSize">\n\t\t\t<div class="file-uploader-queued_message-block">\n\t\t\t\t<i class="icon-warning file-uploader-queued_message-block-icon"></i>\n\t\t\t\t<p class="file-uploader-queued_message-block-title">File size too big\n\t\t\t\t\t<a class="file-uploader-queued_message-block-action" href="" ng-click="$ctrl.setComponentState($ctrl.COMPONENT_STATES.upload)">\n\t\t\t\t\t\tTry again\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="file-uploader-queued_overlay"></div>\n</div>\n');
$templateCache.put('components/file-uploader/file-uploader.component.html','<div class="file-uploader">\n\n\t<!-- Hidden input for setting validity of this form control. When the overall uploader\n\t     status is \'complete\', something will get stuffed in $ctrl.validity to render this\n\t\t input valid. Otherwise it will be empty, invalidating the parent form. -->\n\t<input ng-model="$ctrl.validStatus" required="true" type="hidden">\n\n\t<!-- Full screen dropzone -->\n\t<div class="file-uploader_dropzone fadeInFast" id="file-uploader-dropzone" ng-class="{\n\t\t\t\'nv-file-over\': $ctrl.showDropzone\n\t\t}" nv-file-drop nv-file-over uploader="$ctrl.uploader">\n\t\t<!-- Separate inputs for multiple and non-multiple, based on fuAllowMultiple attribute.\n\t\t\t If there\'s a better way to do this, that would be nice, but ng-attr-multiple doesn\'t\n\t\t\t seem to be a viable option for valueless attributes like this. -->\n\t\t<input accept="{{$ctrl.fuAllowedFileTypes}}" class="file-uploader_container-input" multiple="multiple" ng-if="$ctrl.fuAllowMultiple" type="file" uploader="$ctrl.uploader">\n\t\t<input accept="{{$ctrl.fuAllowedFileTypes}}" class="file-uploader_container-input" ng-if="!$ctrl.fuAllowMultiple" type="file" uploader="$ctrl.uploader">\n\n\t\t<div class="file-uploader_dropzone-prompt">\n\t\t\t<div class="file-uploader_dropzone-icon">\n\t\t\t\t<i class="icon-upload xxl"></i>\n\t\t\t\t<div class="file-uploader_dropzone-icon-label">\n\t\t\t\t\tDrop files\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="file-uploader_container" ng-class="{\n\t\t\t\'is-disabled\': !$ctrl.isEnabled\n\t\t}">\n\t\t<label class="file-uploader_container-label">\n\t\t\t<!-- Separate inputs for multiple and non-multiple, based on fuAllowMultiple attribute.\n\t\t\t\t If there\'s a better way to do this, that would be nice, but ng-attr-multiple doesn\'t\n\t\t\t\t seem to be a viable option for valueless attributes like this. -->\n\t\t\t<input accept="{{$ctrl.fuAllowedFileTypes}}" class="file-uploader_container-input" data-cy="file-uploader-input" multiple="multiple" ng-if="$ctrl.fuAllowMultiple" nv-file-select type="file" uploader="$ctrl.uploader">\n\t\t\t<input accept="{{$ctrl.fuAllowedFileTypes}}" class="file-uploader_container-input" data-cy="file-uploader-input" ng-if="!$ctrl.fuAllowMultiple" nv-file-select type="file" uploader="$ctrl.uploader">\n\n\t\t\t<div class="file-uploader_icon">\n\t\t\t\t<i class="icon-upload is-smedium"></i>\n\t\t\t</div>\n\t\t\t<div class="file-uploader_container-label-text">\n\t\t\t\t<div class="file-uploader_container-label-text-title">\n\t\t\t\t\t{{$ctrl.fuLabel}}\n\t\t\t\t</div>\n\t\t\t\t<div class="file-uploader_container-label-text-subtitle">\n\t\t\t\t\tMaximum file size is {{$ctrl.fuMaxFileSize | fileSize}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</label>\n\t</div>\n\n\t<div class="file-uploader_info">\n\t\t<p class="is-caption">\n\t\t\tYou can upload {{$ctrl.fuAllowedFileTypesDescription}} files only.\n\t\t</p>\n\t</div>\n\n\t<div class="file-uploader_files" ng-if="$ctrl.fuFileList.length !== 0">\n\t\t<div class="file-uploader_files-header">\n\t\t\t<div class="file-uploader_files-summary">\n\t\t\t\t{{$ctrl.getUploadedCount($ctrl.fuFileList)}} of {{$ctrl.fuFileList.length}} uploaded\n\t\t\t</div>\n\t\t\t<div class="file-uploader_files-cancel" ng-if="$ctrl.uploaderStatus === $ctrl.UPLOADER_STATUSES.uploading">\n\t\t\t\t<a class="is-primary is-small" href="" ng-click="$ctrl.onCancelClick()">\n\t\t\t\t\t<i class="icon-cross is-smedium"></i>&nbsp;&nbsp;Cancel\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="file-uploader_file" ng-repeat="file in $ctrl.fuFileList">\n\t\t\t<!-- File info, shown when not uploading; so complete, or failed, etc. -->\n\t\t\t<div class="file-uploader_file-info" ng-if="file.status !== $ctrl.FILE_UPLOAD_STATUSES.uploading">\n\t\t\t\t<div class="file-uploader_icon" ng-class="{\n\t\t\t\t\t\t\'is-error\': file.status === $ctrl.FILE_UPLOAD_STATUSES.error,\n\t\t\t\t\t\t\'is-success\': file.status === $ctrl.FILE_UPLOAD_STATUSES.success\n\t\t\t\t\t}" ng-switch="file.status">\n\t\t\t\t\t<i class="{{file.icon}}"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="file-uploader_file-label">\n\t\t\t\t\t<div class="file-uploader_file-label-name">\n\t\t\t\t\t\t{{file.DocumentName}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="file-uploader_file-label-size" data-cy="file-uploader-document-size" ng-if="file.status !== $ctrl.FILE_UPLOAD_STATUSES.error">\n\t\t\t\t\t\t{{file.DocumentSize | fileSize}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="file-uploader_file-label-error" data-cy="file-uploader-error" ng-if="file.status === $ctrl.FILE_UPLOAD_STATUSES.error">\n\t\t\t\t\t\t{{file.errorMessage}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="file-uploader_file-actions">\n\t\t\t\t\t<div class="file-uploader_file-action" ng-if="file.allowRetry">\n\t\t\t\t\t\t<a class="greyscale-lightened" href="" ng-click="$ctrl.onRetryClick(file)">\n\t\t\t\t\t\t\t<i class="icon-loading is-medium"></i>&nbsp;&nbsp;Retry\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="file-uploader_file-action">\n\t\t\t\t\t\t<a class="greyscale-lightened" href="" ng-click="$ctrl.onDeleteClick(file)">\n\t\t\t\t\t\t\t<i class="is-medium" ng-class="{\n\t\t\t\t\t\t\t\t\t\'icon-cross\': file.status === $ctrl.FILE_UPLOAD_STATUSES.error,\n\t\t\t\t\t\t\t\t\t\'icon-trash\': file.status !== $ctrl.FILE_UPLOAD_STATUSES.error\n\t\t\t\t\t\t\t\t}"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Uploading throbber -->\n\t\t\t<div class="file-uploader_file-uploading" ng-if="file.status === $ctrl.FILE_UPLOAD_STATUSES.uploading">\n\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/filter-bar/filter-bar.component.html','<div class="filter-bar">\n\n\t<div class="filter-bar_layout filter-bar_layout-desktop">\n\t\t<div class="filter-bar_filters">\n\t\t\t<form class="filter-bar_type" click-anywhere-but-here="vm.toggleMenu(filterGroup)" is-active="filterGroup.menuOpen" name="filterGroup.form" ng-repeat="filterGroup in vm.filterBarOptions.filterGroups" novalidate>\n\n\t\t\t\t<button class="filter-button filter-bar_button" ng-class="{\n\t\t\t\t\t\t\'is-filter-active\' : filterGroup.count > 0,\n\t\t\t\t\t\t\'is-menu-open\' : filterGroup.menuOpen,\n\t\t\t\t\t\t\'is-invalid\': filterGroup.form.$invalid\n\t\t\t\t\t}" ng-click="vm.toggleMenu(filterGroup)" type="button">\n\t\t\t\t\t{{filterGroup.displayText || filterGroup.name}}\n\t\t\t\t\t<span class="filter-bar_counter" ng-show="filterGroup.count > 0 && filterGroup.form.$valid && !filterGroup.displayText">\n\t\t\t\t\t\t{{filterGroup.count}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="filter-bar_counter" ng-show="filterGroup.form.$invalid">\n\t\t\t\t\t\t!\n\t\t\t\t\t</span>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="filter-bar_menu" ng-class="{\'filter-bar_menu-active\' : filterGroup.menuOpen}" ng-switch="filterGroup.filterAction">\n\n\t\t\t\t\t<!-- Date range filter -->\n\t\t\t\t\t<date-range-filter filter-group="filterGroup" ng-switch-when="dateRange" on-apply="vm.applyDateRange(filterGroup)" on-clear="vm.clearDateRange(filterGroup)"></date-range-filter>\n\n\t\t\t\t\t<div class="filter-bar_option" ng-repeat="filterOption in filterGroup.filterOptions">\n\n\t\t\t\t\t\t<!-- Radio (or) -->\n\t\t\t\t\t\t<div class="radio-field" ng-switch-when="or">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="filter-bar-desktop-{{filterOption.key}}" name="filter-bar-desktop-{{filterOption.key}}" ng-change="vm.saveFilterGroupOptions(filterGroup, true)" ng-model="filterGroup.activeFilterKey" ng-value="filterOption.key" type="radio">\n\t\t\t\t\t\t\t<label class="filter-bar_label" for="filter-bar-desktop-{{filterOption.key}}">{{filterOption.name}}</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Checkbox (and) -->\n\t\t\t\t\t\t<div class="checkbox-field" ng-switch-default>\n\t\t\t\t\t\t\t<input id="filter-bar-desktop-{{filterOption.key}}" name="filter-bar-desktop-{{filterOption.key}}" ng-change="vm.saveFilterGroupOptions(filterGroup, true)" ng-model="filterOption.isActive" type="checkbox">\n\t\t\t\t\t\t\t<label class="filter-bar_label" for="filter-bar-desktop-{{filterOption.key}}">{{filterOption.name}}</label>\n\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="filter-bar-desktop-{{filterOption.key}}"></label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Inputs -->\n\t\t\t\t\t\t<div class="filter-bar_field fadeIn" ng-if="filterGroup.activeFilterKey === filterOption.key && filterOption.inputType" ng-switch="filterOption.inputType">\n\n\t\t\t\t\t\t\t<!-- Date input -->\n\t\t\t\t\t\t\t<div class="filter-bar_field-layout" pc-switch-when="vm.FILTER_OPTION_SPECIAL_TYPES.date">\n\t\t\t\t\t\t\t\t<div class="filter-bar_field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="filter-bar-date-field-{{filterOption.key}}">{{:: filterOption.inputLabel ? filterOption.inputLabel : \'Date\'}}:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="filter-bar_field-main">\n\t\t\t\t\t\t\t\t\t<date-input-field field-id="filter-bar-date-field-{{filterOption.key}}" field-on-change-fn="vm.saveFilterGroupOptions(filterGroup)" field-style="l" field-value-iso="filterOption.dateIso"></date-input-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="filter-bar_actions" ng-switch-when="or">\n\t\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t\t<a href ng-click="vm.deselectAllFilterGroupOptions(filterGroup)">Show all</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="filter-bar_actions" ng-switch-default>\n\t\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t\t<a href ng-click="vm.selectAllFilterGroupOptions(filterGroup)">Select all</a>\n\t\t\t\t\t\t\t<a href ng-click="vm.deselectAllFilterGroupOptions(filterGroup)">Clear all</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\n\t\t<a class="filter-bar_clear fadeIn" href="" ng-click="vm.clearFilters(vm)" ng-if="vm.filterBarOptions.totalCount > 0">\n\t\t\t<i class="icon-cross"></i>\n\t\t\t<span>&nbsp;Clear filters</span>\n\t\t</a>\n\t</div>\n\n\t<div class="filter-bar_layout filter-bar_layout-mobile">\n\t\t<div class="filter-bar_filters">\n\t\t\t<div class="filter-bar_type" ng-class="{\'filter-bar_type-active\' : vm.filterBarOptions.totalCount > 0}">\n\t\t\t\t<a href class="filter-button filter-bar_button" ng-click="vm.toggleMobileMenu(vm)">\n\t\t\t\t\tFilters\n\t\t\t\t\t<span class="filter-bar_counter" ng-show="vm.filterBarOptions.totalCount > 0">\n\t\t\t\t\t\t{{vm.filterBarOptions.totalCount}}\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<a href class="filter-bar_clear" ng-click="vm.clearFilters(vm)" ng-if="vm.filterBarOptions.totalCount > 0">\n\t\t\t<i class="icon-cross"></i>\n\t\t\t<span>&nbsp;Clear filters</span>\n\t\t</a>\n\n\t\t<modal-mobile modal-open="vm.filterBarOptions.modalOpen" modal-submit-text="\'Apply filters\'" modal-submit="vm.toggleMobileMenu(vm)" modal-close="vm.toggleMobileMenu(vm)">\n\t\t\t<mm-actions>\n\t\t\t\t<a href ng-click="vm.clearFilters(vm)" ng-if="vm.filterBarOptions.totalCount > 0">\n\t\t\t\t\tClear filters\n\t\t\t\t</a>\n\t\t\t</mm-actions>\n\n\t\t\t<mm-body>\n\t\t\t\t<div class="filter-bar__mobile">\n\t\t\t\t\t<div class="filter-bar_section" ng-switch="filterGroup.filterAction" ng-repeat="filterGroup in vm.filterBarOptions.filterGroups">\n\t\t\t\t\t\t<h5 class="filter-bar_title">{{filterGroup.name}}\n\t\t\t\t\t\t\t<span class="filter-bar_counter filter-bar_counter--large" ng-if="filterGroup.count > 0">{{filterGroup.count}}</span>\n\t\t\t\t\t\t</h5>\n\n\t\t\t\t\t\t<div class="filter-bar_option" ng-repeat="filterOption in filterGroup.filterOptions">\n\t\t\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t\t\t<input type="checkbox" id="filter-bar-mobile-{{filterOption.key}}" name="filter-bar-mobile-{{filterOption.key}}" ng-model="filterOption.isActive">\n\t\t\t\t\t\t\t\t<label class="filter-bar_label" for="filter-bar-mobile-{{filterOption.key}}">{{filterOption.name}}</label>\n\t\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="filter-bar-mobile-{{filterOption.key}}"></label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="inline-links" ng-switch-default>\n\t\t\t\t\t\t\t<a href ng-click="vm.selectAllFilterGroupOptions(filterGroup)">Select all</a>\n\t\t\t\t\t\t\t<a href ng-click="vm.deselectAllFilterGroupOptions(filterGroup)">Clear all</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</mm-body>\n\t\t</modal-mobile>\n\t</div>\n</div>\n');
$templateCache.put('components/filter-bar-basic/filter-bar-basic.component.html','<div class="filter-bar-basic">\n\n\t<div class="filter-bar-basic_filters">\n\t\t<a class="filter-bar-basic_filter" href="" ng-class="{\'is-active\': filter.key === $ctrl.filterBarOptions.filterKey}" ng-click="$ctrl.setFilterExp($ctrl, filter)" ng-repeat="filter in $ctrl.filterBarOptions.filters">{{::filter.name}}</a>\n\t</div>\n\n\t<div class="filter-bar-basic_controls">\n\n\t\t<div class="filter-bar-basic_control filter-bar-basic_search" ng-class="{\'is-active\': $ctrl.filterBarOptions.isSearchActive}">\n\n\t\t\t<!-- Open -->\n\t\t\t<input autocomplete="off" class="small filter-bar-basic_search-input fadeIn" id="filter-bar-basic_search-input" name="filter-bar-basic_search-input" ng-blur="$ctrl.toggleIsSearchActiveOnBlur($ctrl)" ng-model="$ctrl.filterBarOptions.searchString" ng-class="{\n\t\t\t\t\t\'is-active\': $ctrl.filterBarOptions.isSearchActive\n\t\t\t\t}" type="text">\n\n\t\t\t<!-- Closed -->\n\t\t\t<a aria-label="Toggle search" class="filter-bar-basic_search-button fadeIn" href="" ng-click="$ctrl.toggleIsSearchActive($ctrl)">\n\t\t\t\t<i class="icon-search"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="filter-bar-basic_control filter-bar-basic_display-options" ng-if="::$ctrl.filterBarOptions.displayOptions.length">\n\t\t\t<a aria-label="Set layout to: {{displayOption.name}}" class="filter-bar-basic_display-option" href="" ng-class="{\n\t\t\t\t\t\'is-active\': displayOption.key === $ctrl.filterBarOptions.displayOption.key\n\t\t\t\t}" ng-click="$ctrl.setDisplayKey($ctrl, displayOption)" ng-repeat="displayOption in $ctrl.filterBarOptions.displayOptions">\n\t\t\t\t<i class="icon-{{::displayOption.icon}}"></i>\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/form-accordion/form-accordion.component.html','<div class="form-accordion">\n\t<div class="form-accordion_header">\n\t\t<div class="form-accordion_icon">\n\t\t\t<icon-dot icon="{{$ctrl.showContent ? \'icon-edit\' : $ctrl.icon}}" theme="{{$ctrl.theme}}" is-light="$ctrl.showContent"></icon-dot>\n\t\t</div>\n\n\t\t<div class="form-accordion_title" ng-if="$ctrl.hasTitle" ng-transclude="title">\n\n\t\t</div>\n\n\t\t<div class="form-accordion_action" ng-if="$ctrl.hasContent">\n\t\t\t<a href="" class="fadeIn greyscale" ng-click="$ctrl.toggleContent()" ng-if="!$ctrl.showContent" aria-label="Open content"><i class="icon-edit"></i></a>\n\t\t\t<a href="" class="fadeIn is-small is-stronger" ng-click="$ctrl.toggleContent()" ng-if="$ctrl.showContent">Cancel</a>\n\t\t</div>\n\t</div>\n\n\t<div class="form-accordion_content fadeIn" ng-if="$ctrl.hasContent && $ctrl.showContent" ng-transclude="content">\n\n\t</div>\n</div>\n');
$templateCache.put('components/form-accordion-alternative/form-accordion-alternative.component.html','<div class="form-accordion-alternative" ng-class="{ \'is-tertiary\': $ctrl.isReadOnly }">\n\n\t<div class="form-accordion-alternative_header">\n\t\t<div class="form-accordion-alternative_title fadeIn" ng-if="!$ctrl.showContent" ng-transclude="titleClosed"></div>\n\n\t\t<div class="form-accordion-alternative_title fadeIn" ng-if="$ctrl.showContent" ng-transclude="titleOpen"></div>\n\n\t\t<div class="form-accordion-alternative_action">\n\t\t\t<div ng-if="!$ctrl.isReadOnly">\n\t\t\t\t<a aria-label="Open content" class="fadeIn primary" data-cy="{{$ctrl.editId}}" href="" ng-click="$ctrl.toggleContent()" ng-if="!$ctrl.showContent">\n\t\t\t\t\t<i class="icon-edit"></i>\n\t\t\t\t\tEdit\n\t\t\t\t</a>\n\t\t\t\t<a class="fadeIn primary" data-cy="{{$ctrl.cancelId}}" href="" ng-click="$ctrl.toggleContent()" ng-if="$ctrl.showContent">\n\t\t\t\t\t<i class="icon-cross"></i>\n\t\t\t\t\tCancel\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div ng-if="$ctrl.isReadOnly">\n\t\t\t\t<span class="fadeIn" ng-class="{ \'is-font-tertiary-400\': $ctrl.isReadOnly }">\n\t\t\t\t\t<i class="icon-padlock"></i>\n\t\t\t\t\tLocked\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-accordion-alternative_subtitle" ng-if="$ctrl.hasSubtitle && !$ctrl.showContent" ng-transclude="subtitle"></div>\n\n\t<div class="form-accordion-alternative_content fadeIn" ng-if="$ctrl.hasContent && $ctrl.showContent" ng-transclude="content"></div>\n</div>\n');
$templateCache.put('components/form-cabinet/formCabinet.html','<slide-in-form form-options="formOptions">\n\t<div ng-switch="pageState">\n\n\t\t<!-- Loading -->\n\t\t<div pc-switch-when="CABINET_STATES.loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\n\t\t<!-- Ready (Not indented to avoid merge conflits) -->\n\t\t<div pc-switch-when="CABINET_STATES.ready">\n\n\t\t\t<!-- Progress Bar -->\n\t\t\t<section class="form-progress-bar fadeIn" ng-if="formOptions.showProgressBar && formOptions.totalSteps > 1 && (formOptions.activeStep <= formOptions.totalSteps)">\n\t\t\t\t<p>Step {{formOptions.activeStep}} of {{formOptions.totalSteps}}</p>\n\t\t\t</section>\n\n\t\t\t<!-- User Context -->\n\t\t\t<section class="form-context fadeIn" ng-if="!formOptions.subHeading && formOptions.contextType === \'user\' && formOptions.showContext">\n\t\t\t\t<avatar class="form-context-avatar" avatar-initial="{{formOptions.context.Forename[0] || formOptions.context.BusinessDetails.TradingName[0]}}" avatar-size="is-medium" avatar-user-id="{{formOptions.context.UserID}}"></avatar>\n\t\t\t\t<p class="form-context-name is-text-default">\n\t\t\t\t\t<truncate id="form-context-name" text="formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename + \' \' + formOptions.context.Surname" truncate-amount="30">\n\t\t\t\t\t</truncate>\n\t\t\t\t</p>\n\t\t\t\t<a href="" ng-href="{{USER_GUIDES[formOptions.userGuideKey].url}}" class="link-with-icon user-guide" target="_blank" ng-if="formOptions.userGuideKey"><i class="icon-document m"></i>User Guide</a>\n\t\t\t</section>\n\n\t\t\t<!-- Company Context -->\n\t\t\t<section class="form-context fadeIn" ng-if="!formOptions.subHeading && formOptions.contextType === \'company\' && formOptions.showContext">\n\t\t\t\t<i class="icon-company form-context-icon"></i>\n\t\t\t\t<p class="form-context-name">{{formOptions.company.Name}}</p>\n\t\t\t\t<a href="" ng-href="{{USER_GUIDES[formOptions.userGuideKey].url}}" class="link-with-icon user-guide" target="_blank" ng-if="formOptions.userGuideKey"><i class="icon-document m"></i>User Guide</a>\n\t\t\t</section>\n\n\t\t\t<!-- Pension Context -->\n\t\t\t<section class="form-context fadeIn" ng-if="formOptions.showPensionContext">\n\t\t\t\t<pension-scheme-detail variant="is-media-borderless is-media-medium" pension="formOptions.pension" show-labels="true">\n\t\t\t\t\t<psd-action ng-if="formOptions.showPensionSwitch && formOptions.returnAction">\n\t\t\t\t\t\t<a href="" class="primary link-with-icon" ng-click="formOptions.returnAction(formOptions)">\n\t\t\t\t\t\t    <i class="icon-switch m"></i> Switch\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</psd-action>\n\t\t\t\t</pension-scheme-detail>\n\t\t\t</section>\n\n\t\t\t<!-- Sub Heading -->\n\t\t\t<section class="form-sub-heading fadeIn" ng-if="formOptions.subHeading">\n\t\t\t\t<p>{{formOptions.subHeading}}</p>\n\t\t\t\t<a href="" ng-href="{{USER_GUIDES[formOptions.userGuideKey].url}}" class="link-with-icon user-guide" target="_blank" ng-if="formOptions.userGuideKey"><i class="icon-document m"></i>User Guide</a>\n\t\t\t</section>\n\n\t\t\t<!-- Wizard States -->\n\t\t\t<add-new-company-finished-form ng-if="formOptions.formKey === \'finished-adding-new-company\'" form-options="formOptions"></add-new-company-finished-form>\n\t\t\t<add-team-member-finished-form ng-if="formOptions.formKey === \'finished-adding-team-member\'" form-options="formOptions"></add-team-member-finished-form>\n\n\t\t\t<!-- Add new Company -->\n\t\t\t<add-new-bureau-form ng-if="formOptions.formKey === \'add-new-bureau\'" form-options="formOptions"></add-new-bureau-form>\n\t\t\t<add-new-company-basic-form ng-if="formOptions.formKey === \'add-new-company\'" form-options="formOptions"></add-new-company-basic-form>\n\t\t\t<add-new-company-modules-form ng-if="formOptions.formKey === \'add-new-company-modules\'" form-options="formOptions"></add-new-company-modules-form>\n\t\t\t<add-new-company-payroll-form ng-if="formOptions.formKey === \'add-new-company-payroll\'" form-options="formOptions"></add-new-company-payroll-form>\n\t\t\t<add-new-company-pay-periods-form ng-if="formOptions.formKey === \'add-new-company-pay-periods\'" form-options="formOptions"></add-new-company-pay-periods-form>\n\t\t\t<add-new-company-pension-automation-form ng-if="formOptions.formKey === \'add-new-company-pension-automation\'" form-options="formOptions"></add-new-company-pension-automation-form>\n\t\t\t<add-new-company-pension-ghost-form ng-if="formOptions.formKey === \'add-new-company-pension-ghost\'" form-options="formOptions"></add-new-company-pension-ghost-form>\n\t\t\t<add-new-company-pension-groups-form ng-if="formOptions.formKey === \'add-new-company-pension-groups\'" form-options="formOptions"></add-new-company-pension-groups-form>\n\t\t\t<add-new-company-pension-postponement-form ng-if="formOptions.formKey === \'add-new-company-pension-postponement\'" form-options="formOptions"></add-new-company-pension-postponement-form>\n\t\t\t<add-new-company-pension-provider-form ng-if="formOptions.formKey === \'add-new-company-pension-provider\'" form-options="formOptions"></add-new-company-pension-provider-form>\n\t\t\t<add-new-company-pension-settings-form ng-if="formOptions.formKey === \'add-new-company-pension-settings\'" form-options="formOptions"></add-new-company-pension-settings-form>\n\t\t\t<add-new-company-pension-staging-form ng-if="formOptions.formKey === \'add-new-company-pension-staging\'" form-options="formOptions"></add-new-company-pension-staging-form>\n\t\t\t<add-new-company-pension-type-form ng-if="formOptions.formKey === \'add-new-company-pension-type\'" form-options="formOptions"></add-new-company-pension-type-form>\n\t\t\t<add-new-company-additional-info-form ng-if="formOptions.formKey === \'add-new-company-additional-info\'" form-options="formOptions"></add-new-company-additional-info-form>\n\t\t\t<add-new-company-group-form ng-if="formOptions.formKey === \'add-new-company-group\'" form-options="formOptions"></add-new-company-group-form>\n\n\t\t\t<!-- App Integration removal -->\n\t\t\t<align-team-member-mappings-integration-form ng-if="formOptions.formKey === \'align-team-member-mappings-integration\'" form-options="formOptions"></align-team-member-mappings-integration-form>\n\t\t\t<edit-edp-integration-form ng-if="formOptions.formKey === \'edit-edp-integration\'" form-options="formOptions"></edit-edp-integration-form>\n\t\t\t<edit-pay-experian-integration-form ng-if="formOptions.formKey === \'edit-pay-experian-integration\'" form-options="formOptions"></edit-pay-experian-integration-form>\n\t\t\t<edit-people-hr-integration-form ng-if="formOptions.formKey === \'edit-people-hr-integration\'" form-options="formOptions"></edit-people-hr-integration-form>\n\t\t\t<edit-accounting-integration-form ng-if="formOptions.formKey === \'edit-accounting-integration\'" form-options="formOptions"></edit-accounting-integration-form>\n\t\t\t<edit-rotaready-integration-form ng-if="formOptions.formKey === \'edit-rotaready-integration\'" form-options="formOptions"></edit-rotaready-integration-form>\n\t\t\t<edit-rotaready-team-mapping-form ng-if="formOptions.formKey === \'edit-rotaready-team-mapping\'" form-options="formOptions"></edit-rotaready-team-mapping-form>\n\t\t\t<edit-rotaready-entity-mapping-form ng-if="formOptions.formKey === \'edit-rotaready-entity-mapping\'" form-options="formOptions"></edit-rotaready-entity-mapping-form>\n\n\t\t\t<!-- Company Settings -->\n\t\t\t<company-settings-add-nominal-codes-form ng-if="formOptions.formKey === \'company-settings-add-nominal-codes\'" form-options="formOptions"></company-settings-add-nominal-codes-form>\n\t\t\t<company-settings-authentication-session-form ng-if="formOptions.formKey === \'company-settings-authentication-session\'" form-options="formOptions"></company-settings-authentication-session-form>\n\t\t\t<company-settings-authentication-sso-form ng-if="formOptions.formKey === \'company-settings-authentication-sso\'" form-options="formOptions"></company-settings-authentication-sso-form>\n\t\t\t<company-settings-authentication-tfa-form ng-if="formOptions.formKey === \'company-settings-authentication-tfa\'" form-options="formOptions"></company-settings-authentication-tfa-form>\n\t\t\t<company-settings-add-office-locations-form ng-if="formOptions.formKey === \'company-settings-add-office-locations\'" form-options="formOptions"></company-settings-add-office-locations-form>\n\t\t\t<company-settings-add-bacs-disbursement-form ng-if="formOptions.formKey === \'company-settings-add-bacs-disbursement\'" form-options="formOptions"></company-settings-add-bacs-disbursement-form>\n\t\t\t<company-settings-auto-apply-tax-refunds-form ng-if="formOptions.formKey === \'company-settings-auto-apply-tax-refunds\'" form-options="formOptions"></company-settings-auto-apply-tax-refunds-form>\n\t\t\t<company-settings-bacs-form ng-if="formOptions.formKey === \'company-settings-bacs\'" form-options="formOptions"></company-settings-bacs-form>\n\t\t\t<company-settings-basic-form ng-if="formOptions.formKey === \'company-settings-basic\'" form-options="formOptions"></company-settings-basic-form>\n\t\t\t<company-settings-bik-form ng-if="formOptions.formKey === \'company-settings-bik\'" form-options="formOptions"></company-settings-bik-form>\n\t\t\t<company-settings-calculation-method-form ng-if="formOptions.formKey === \'company-settings-calculation-method\'" form-options="formOptions"></company-settings-calculation-method-form>\n\t\t\t<company-settings-calculation-settings-form ng-if="formOptions.formKey === \'company-settings-calculation-settings\'" form-options="formOptions"></company-settings-calculation-settings-form>\n\t\t\t<company-settings-cease-paye-form ng-if="formOptions.formKey === \'company-settings-cease-paye\'" form-options="formOptions"></company-settings-cease-paye-form>\n\t\t\t<company-settings-currencies-form ng-if="formOptions.formKey === \'company-settings-currencies\'" form-options="formOptions"></company-settings-currencies-form>\n\t\t\t<company-settings-customer-codes-form ng-if="formOptions.formKey === \'company-settings-customer-codes\'" form-options="formOptions"></company-settings-customer-codes-form>\n\t\t\t<company-settings-delete-bacs-disbursement-form ng-if="formOptions.formKey === \'company-settings-delete-bacs-disbursement\'" form-options="formOptions"></company-settings-delete-bacs-disbursement-form>\n\t\t\t<company-settings-delete-business-category-form ng-if="formOptions.formKey === \'company-settings-delete-business-category\'" form-options="formOptions"></company-settings-delete-business-category-form>\n\t\t\t<company-settings-delete-nominal-code-form ng-if="formOptions.formKey === \'company-settings-delete-nominal-code\'" form-options="formOptions"></company-settings-delete-nominal-code-form>\n\t\t\t<company-settings-department-sub-code-overrides-form ng-if="formOptions.formKey === \'company-settings-department-sub-code-overrides\'" form-options="formOptions"></company-settings-department-sub-code-overrides-form>\n\t\t\t<company-settings-directors-ni-form ng-if="formOptions.formKey === \'company-settings-directors-ni\'" form-options="formOptions"></company-settings-directors-ni-form>\n\t\t\t<company-settings-edit-remote-locations-form ng-if="formOptions.formKey === \'company-settings-edit-remote-locations\'" form-options="formOptions"></company-settings-edit-remote-locations-form>\n\t\t\t<company-settings-email-notifications-form ng-if="formOptions.formKey === \'company-settings-email-notifications\'" form-options="formOptions"></company-settings-email-notifications-form>\n\t\t\t<company-settings-employee-portal-form ng-if="formOptions.formKey === \'company-settings-employee-portal\'" form-options="formOptions"></company-settings-employee-portal-form>\n\t\t\t<company-settings-employer-form ng-if="formOptions.formKey === \'company-settings-employer\'" form-options="formOptions"></company-settings-employer-form>\n\t\t\t<company-settings-eps-form ng-if="formOptions.formKey === \'company-settings-eps\'" form-options="formOptions"></company-settings-eps-form>\n\t\t\t<company-settings-file-uploads-form ng-if="formOptions.formKey === \'company-settings-file-uploads\'" form-options="formOptions"></company-settings-file-uploads-form>\n\t\t\t<company-settings-gender-pay-gap-delete-form ng-if="formOptions.formKey === \'company-settings-gender-pay-gap-delete\'" form-options="formOptions"></company-settings-gender-pay-gap-delete-form>\n\t\t\t<company-settings-gender-pay-gap-enabled-form ng-if="formOptions.formKey === \'company-settings-gender-pay-gap-enabled\'" form-options="formOptions"></company-settings-gender-pay-gap-enabled-form>\n\t\t\t<company-settings-hmrc-form ng-if="formOptions.formKey === \'company-settings-hmrc\'" form-options="formOptions"></company-settings-hmrc-form>\n\t\t\t<company-settings-inactive-period-form ng-if="formOptions.formKey === \'company-settings-inactive-period\'" form-options="formOptions"></company-settings-inactive-period-form>\n\t\t\t<company-settings-p11d-submission-form ng-if="formOptions.formKey === \'company-settings-p11d-submission\'" form-options="formOptions"></company-settings-p11d-submission-form>\n\t\t\t<company-settings-p11db-submission-delete-form ng-if="formOptions.formKey === \'company-settings-p11db-submission-delete\'" form-options="formOptions"></company-settings-p11db-submission-delete-form>\n\t\t\t<company-settings-p32-payment-form ng-if="formOptions.formKey === \'company-settings-p32-payment\'" form-options="formOptions"></company-settings-p32-payment-form>\n\t\t\t<company-settings-p60-notifications-form ng-if="formOptions.formKey === \'company-settings-p60-notifications\'" form-options="formOptions"></company-settings-p60-notifications-form>\n\t\t\t<company-settings-pay-dashboard-form ng-if="formOptions.formKey === \'company-settings-paydashboard-settings\'" form-options="formOptions"></company-settings-pay-dashboard-form>\n\t\t\t<company-settings-ni-updates-form ng-if="formOptions.formKey === \'company-settings-ni-updates\'" form-options="formOptions"></company-settings-ni-updates-form>\n\t\t\t<company-settings-nmw-calculation-form ng-if="formOptions.formKey === \'company-settings-nmw-calculation\'" form-options="formOptions"></company-settings-nmw-calculation-form>\n\t\t\t<company-settings-payroll-auto-form ng-if="formOptions.formKey === \'company-settings-payroll-auto\'" form-options="formOptions"></company-settings-payroll-auto-form>\n\t\t\t<company-settings-payroll-settings-form ng-if="formOptions.formKey === \'company-settings-payroll-settings\'" form-options="formOptions"></company-settings-payroll-settings-form>\n\t\t\t<company-settings-payslip-additional-note-form ng-if="formOptions.formKey === \'company-settings-payslip-additional-note\'" form-options="formOptions"></company-settings-payslip-additional-note-form>\n\t\t\t<company-settings-payslip-display-period-form ng-if="formOptions.formKey === \'company-settings-payslip-display-period\'" form-options="formOptions"></company-settings-payslip-display-period-form>\n\t\t\t<company-settings-pdf-download-sorting-form ng-if="formOptions.formKey === \'company-settings-pdf-download-sorting\'" form-options="formOptions"></company-settings-pdf-download-sorting-form>\n\t\t\t<company-settings-pension-communications-form ng-if="formOptions.formKey === \'company-settings-pension-communications\'" form-options="formOptions"></company-settings-pension-communications-form>\n\t\t\t<company-settings-pension-submissions-form ng-if="formOptions.formKey === \'company-settings-pension-submissions\'" form-options="formOptions"></company-settings-pension-submissions-form>\n\t\t\t<company-settings-pension-sup-runs-form ng-if="formOptions.formKey === \'company-settings-pension-sup-runs\'" form-options="formOptions"></company-settings-pension-sup-runs-form>\n\t\t\t<company-settings-period-display-title-form ng-if="formOptions.formKey === \'company-settings-period-display-title\'" form-options="formOptions"></company-settings-period-display-title-form>\n\t\t\t<company-settings-rotaready-entity-create-all-business-codes-form ng-if="formOptions.formKey === \'company-settings-rotaready-entity-create-all-business-codes\'" form-options="formOptions"></company-settings-rotaready-entity-create-all-business-codes-form>\n\t\t\t<company-settings-rotaready-entity-create-business-code-form ng-if="formOptions.formKey === \'company-settings-rotaready-entity-create-business-code\'" form-options="formOptions"></company-settings-rotaready-entity-create-business-code-form>\n\t\t\t<company-settings-rotaready-entity-save-form ng-if="formOptions.formKey === \'company-settings-rotaready-entity-save\'" form-options="formOptions"></company-settings-rotaready-entity-save-form>\n\t\t\t<company-settings-rotaready-entity-unmatch-form ng-if="formOptions.formKey === \'company-settings-rotaready-entity-unmatch\'" form-options="formOptions"></company-settings-rotaready-entity-unmatch-form>\n\t\t\t<company-settings-rotaready-unmatch-form ng-if="formOptions.formKey === \'company-settings-rotaready-unmatch\'" form-options="formOptions"></company-settings-rotaready-unmatch-form>\n\t\t\t<company-settings-references-form ng-if="formOptions.formKey === \'company-settings-references\'" form-options="formOptions"></company-settings-references-form>\n\t\t\t<company-settings-rotaready-save-form ng-if="formOptions.formKey === \'company-settings-rotaready-save\'" form-options="formOptions"></company-settings-rotaready-save-form>\n\t\t\t<company-settings-rti-submissions-form ng-if="formOptions.formKey === \'company-settings-rti-submissions\'" form-options="formOptions"></company-settings-rti-submissions-form>\n\t\t\t<company-settings-backdated-salary-elements-form ng-if="formOptions.formKey === \'company-settings-backdated-salary-elements\'" form-options="formOptions"></company-settings-backdated-salary-elements-form>\n\t\t\t<company-settings-skip-pay-periods-form ng-if="formOptions.formKey === \'company-settings-skip-pay-periods\'" form-options="formOptions"></company-settings-skip-pay-periods-form>\n\t\t\t<company-settings-sub-code-overrides-form ng-if="formOptions.formKey === \'company-settings-sub-code-overrides\'" form-options="formOptions"></company-settings-sub-code-overrides-form>\n\t\t\t<company-settings-support-contact-form ng-if="formOptions.formKey === \'company-settings-support-contact\'" form-options="formOptions"></company-settings-support-contact-form>\n\t\t\t<company-settings-work-durations-form ng-if="formOptions.formKey === \'company-settings-work-durations\'" form-options="formOptions"></company-settings-work-durations-form>\n\t\t\t<company-settings-workflow-form ng-if="formOptions.formKey === \'company-settings-workflow\'" form-options="formOptions"></company-settings-workflow-form>\n\t\t\t<company-settings-sick-pay-default-work-pattern ng-if="formOptions.formKey === \'company-settings-sick-pay-default-work-pattern\'" form-options="formOptions"></company-settings-sick-pay-default-work-pattern>\n\t\t\t<company-settings-sickness-pro-ration-method ng-if="formOptions.formKey === \'company-settings-sickness-pro-ration-method\'" form-options="formOptions"></company-settings-sickness-pro-ration-method>\n\n\t\t\t<!-- Admins -->\n\t\t\t<adjustment-group-form ng-if="formOptions.formKey === \'adjustment-group\'" form-options="formOptions"></adjustment-group-form>\n\t\t\t<archive-bureau-form ng-if="formOptions.formKey === \'archive-bureau\'" form-options="formOptions"></archive-bureau-form>\n\t\t\t<archive-company-form ng-if="formOptions.formKey === \'archive-company\'" form-options="formOptions"></archive-company-form>\n\t\t\t<auto-create-company-form ng-if="formOptions.formKey === \'auto-create-company\'" form-options="formOptions"></auto-create-company-form>\n\t\t\t<change-admin-state-form ng-if="formOptions.formKey === \'change-admin-state\'" form-options="formOptions"></change-admin-state-form>\n\t\t\t<clone-payroll-form ng-if="formOptions.formKey === \'clone-payroll\'" form-options="formOptions"></clone-payroll-form>\n\t\t\t<delete-adjustment-group-form ng-if="formOptions.formKey === \'delete-adjustment-group\'" form-options="formOptions"></delete-adjustment-group-form>\n\t\t\t<delete-bureau-form ng-if="formOptions.formKey === \'delete-bureau\'" form-options="formOptions"></delete-bureau-form>\n\t\t\t<delete-company-group-form ng-if="formOptions.formKey === \'delete-company-group\'" form-options="formOptions"></delete-company-group-form>\n\t\t\t<delete-office-location-form ng-if="formOptions.formKey === \'delete-office-location\'" form-options="formOptions"></delete-office-location-form>\n\t\t\t<delete-pay-element-form ng-if="formOptions.formKey === \'delete-pay-element\'" form-options="formOptions"></delete-pay-element-form>\n\t\t\t<delete-remote-location-form ng-if="formOptions.formKey === \'delete-remote-location\'" form-options="formOptions"></delete-remote-location-form>\n\t\t\t<delete-team-member-form ng-if="formOptions.formKey === \'delete-team-member\'" form-options="formOptions"></delete-team-member-form>\n\t\t\t<edit-admin-form ng-if="formOptions.formKey === \'edit-admin\'" form-options="formOptions"></edit-admin-form>\n\t\t\t<edit-company-group-form ng-if="formOptions.formKey === \'edit-company-group\'" form-options="formOptions"></edit-company-group-form>\n\t\t\t<manage-admins-form ng-if="formOptions.formKey === \'manage-admins\'" form-options="formOptions"></manage-admins-form>\n\t\t\t<duplicate-pay-element-form ng-if="formOptions.formKey === \'duplicate-pay-element\'" form-options="formOptions"></duplicate-pay-element-form>\n\t\t\t<edit-bureau-bun-form ng-if="formOptions.formKey === \'edit-bureau-bun\'" form-options="formOptions"></edit-bureau-bun-form>\n\t\t\t<link-element-form ng-if="formOptions.formKey === \'link-element\'" form-options="formOptions"></link-element-form>\n\t\t\t<manage-mentions-access-form ng-if="formOptions.formKey === \'manage-mentions-access\'" form-options="formOptions"></manage-mentions-access-form>\n\t\t\t<average-holiday-pay-options-form ng-if="formOptions.formKey === \'average-holiday-pay-options\'" form-options="formOptions"></average-holiday-pay-options-form>\n\t\t\t<manage-pay-elements-form ng-if="formOptions.formKey === \'manage-pay-elements\'" form-options="formOptions"></manage-pay-elements-form>\n\t\t\t<manage-pay-elements-pension-form ng-if="formOptions.formKey === \'manage-pay-elements-pension\'" form-options="formOptions"></manage-pay-elements-pension-form>\n\t\t\t<manage-permissions-form ng-if="formOptions.formKey === \'manage-permissions\'" form-options="formOptions"></manage-permissions-form>\n\t\t\t<manage-visibility-form ng-if="formOptions.formKey === \'manage-visibility\'" form-options="formOptions"></manage-visibility-form>\n\t\t\t<manually-send-payments-form ng-if="formOptions.formKey === \'manually-send-payments\'" form-options="formOptions"></manually-send-payments-form>\n\t\t\t<remove-admin-access-form ng-if="formOptions.formKey === \'remove-admin-access\'" form-options="formOptions"></remove-admin-access-form>\n\t\t\t<unlink-access-account-form ng-if="formOptions.formKey === \'unlink-access-account\'" form-options="formOptions"></unlink-access-account-form>\n\t\t\t<reset-auth-access-form ng-if="formOptions.formKey === \'reset-auth-access\'" form-options="formOptions"></reset-auth-access-form>\n\t\t\t<run-payroll-form ng-if="formOptions.formKey === \'run-payroll\'" form-options="formOptions"></run-payroll-form>\n\t\t\t<run-payroll-bulk-form ng-if="formOptions.formKey === \'run-payroll-bulk\'" form-options="formOptions"></run-payroll-bulk-form>\n\t\t\t<view-role-form ng-if="formOptions.formKey === \'view-role\'" form-options="formOptions"></view-role-form>\n\n\t\t\t<!-- Personal -->\n\t\t\t<address-form ng-if="formOptions.formKey === \'address\'" form-options="formOptions"></address-form>\n\t\t\t<payment-details-form ng-if="formOptions.formKey === \'payment-details\'" form-options="formOptions"></payment-details-form>\n\t\t\t<email-form ng-if="formOptions.formKey === \'email-address\'" form-options="formOptions"></email-form>\n\t\t\t<personal-form ng-if="formOptions.formKey === \'personal\'" form-options="formOptions"></personal-form>\n\t\t\t<personal-overview-form ng-if="formOptions.formKey === \'personal-overview\'" form-options="formOptions"></personal-overview-form>\n\t\t\t<passport-form ng-if="formOptions.formKey === \'passport\'" form-options="formOptions"></passport-form>\n\t\t\t<password-reset-form ng-if="formOptions.formKey === \'password-reset\'" form-options="formOptions"></password-reset-form>\n\t\t\t<telephone-form ng-if="formOptions.formKey === \'telephone\'" form-options="formOptions"></telephone-form>\n\t\t\t<unregister-user-form ng-if="formOptions.formKey === \'unregister-user\'" form-options="formOptions"></unregister-user-form>\n\t\t\t<user-documents-form ng-if="formOptions.formKey === \'user-documents\'" form-options="formOptions"></user-documents-form>\n\t\t\t<username-retrieval-form ng-if="formOptions.formKey === \'username-retrieval\'" form-options="formOptions"></username-retrieval-form>\n\t\t\t<user-downloads-document-form ng-if="formOptions.formKey === \'user-downloads-document\'" form-options="formOptions"></user-downloads-document-form>\n\n\t\t\t<!-- Security -->\n\t\t\t<change-account-security-item-form ng-if="formOptions.formKey === \'change-account-security-item\'" form-options="formOptions"></change-account-security-item-form>\n\t\t\t<link-accounts-form ng-if="formOptions.formKey === \'link-accounts\'" form-options="formOptions"></link-accounts-form>\n\t\t\t<unlink-accounts-form ng-if="formOptions.formKey === \'unlink-accounts\'" form-options="formOptions"></unlink-accounts-form>\n\n\t\t\t<!-- Employment -->\n\t\t\t<add-tax-update-form ng-if="formOptions.formKey === \'add-tax-update\'" form-options="formOptions"></add-tax-update-form>\n\t\t\t<add-to-business-category-form ng-if="formOptions.formKey === \'add-to-business-category\'" form-options="formOptions"></add-to-business-category-form>\n\t\t\t<additional-post-form ng-if="formOptions.formKey === \'additional-post-form\'" form-options="formOptions"></additional-post-form>\n\t\t\t<backdated-ni-view-form ng-if="formOptions.formKey === \'backdated-ni-view\'" form-options="formOptions"></backdated-ni-view-form>\n\t\t\t<backdated-salary-view-form ng-if="formOptions.formKey === \'backdated-salary-view\'" form-options="formOptions"></backdated-salary-view-form>\n\t\t\t<cancel-leaving-additional-post-form ng-if="formOptions.formKey === \'cancel-leaving-additional-post\'" form-options="formOptions"></cancel-leaving-additional-post-form>\n\t\t\t<company-details-form ng-if="formOptions.formKey === \'company-details\'" form-options="formOptions"></company-details-form>\n\t\t\t<company-vehicle-form ng-if="formOptions.formKey === \'company-vehicle\'" form-options="formOptions"></company-vehicle-form>\n\t\t\t<company-vehicle-view-form ng-if="formOptions.formKey === \'company-vehicle-view\'" form-options="formOptions"></company-vehicle-view-form>\n\t\t\t<continuous-employment-form ng-if="formOptions.formKey === \'continuous-employment\'" form-options="formOptions"></continuous-employment-form>\n\t\t\t<delete-additional-post-form ng-if="formOptions.formKey === \'delete-additional-post\'" form-options="formOptions"></delete-additional-post-form>\n\t\t\t<delete-tax-update-form ng-if="formOptions.formKey === \'delete-tax-update\'" form-options="formOptions"></delete-tax-update-form>\n\t\t\t<healthcare-form ng-if="formOptions.formKey === \'healthcare\'" form-options="formOptions"></healthcare-form>\n\t\t\t<healthcare-view-form ng-if="formOptions.formKey === \'healthcare-view\'" form-options="formOptions"></healthcare-view-form>\n\t\t\t<leave-additional-post-form ng-if="formOptions.formKey === \'leave-additional-post\'" form-options="formOptions"></leave-additional-post-form>\n\t\t\t<link-rate-form ng-if="formOptions.formKey === \'link-rate\'" form-options="formOptions"></link-rate-form>\n\t\t\t<moved-payrolls-warning-form ng-if="formOptions.formKey === \'moved-payrolls-warning\'" form-options="formOptions"></moved-payrolls-warning-form>\n\t\t\t<new-starter-information-form ng-if="formOptions.formKey === \'new-starter-information\'" form-options="formOptions"></new-starter-information-form>\n\t\t\t<pay-information-form ng-if="formOptions.formKey === \'pay-information\'" form-options="formOptions"></pay-information-form>\n\t\t\t<payments-to-date-form ng-if="formOptions.formKey === \'payments-to-date\'" form-options="formOptions"></payments-to-date-form>\n\t\t\t<rti-submission-form ng-if="formOptions.formKey === \'rti-submission\'" form-options="formOptions"></rti-submission-form>\n\t\t\t<tax-status-form ng-if="formOptions.formKey === \'tax-status\'" form-options="formOptions"></tax-status-form>\n\t\t\t<starter-information-form ng-if="formOptions.formKey === \'starter-information\'" form-options="formOptions"></starter-information-form>\n\t\t\t<view-work-pattern-form ng-if="formOptions.formKey === \'view-work-pattern\'" form-options="formOptions"></view-work-pattern-form>\n\t\t\t<workplace-information-form ng-if="formOptions.formKey === \'workplace-information\'" form-options="formOptions"></workplace-information-form>\n\n\t\t\t<!-- Pension -->\n\t\t\t\t<!-- Scheme -->\n\t\t\t\t<pension-scheme-authorise-nest-form ng-if="formOptions.formKey === \'pension-scheme-authorise-nest\'" form-options="formOptions"></pension-scheme-authorise-nest-form>\n\t\t\t\t<pension-scheme-authorise-peoples-pension-form ng-if="formOptions.formKey === \'pension-scheme-authorise-peoples-pension\'" form-options="formOptions"></pension-scheme-authorise-peoples-pension-form>\n\t\t\t\t<pension-scheme-authorise-smart-form ng-if="formOptions.formKey === \'pension-scheme-authorise-smart\'" form-options="formOptions"></pension-scheme-authorise-smart-form>\n\t\t\t\t<pension-scheme-automation-form ng-if="formOptions.formKey === \'pension-scheme-automation\'" form-options="formOptions"></pension-scheme-automation-form>\n\t\t\t\t<pension-scheme-delete-form ng-if="formOptions.formKey === \'pension-scheme-delete\'" form-options="formOptions"></pension-scheme-delete-form>\n\t\t\t\t<pension-scheme-failed-pension-manually-submit-warning-form ng-if="formOptions.formKey === \'pension-scheme-failed-pension-manually-submit-warning\'" form-options="formOptions"></pension-scheme-failed-pension-manually-submit-warning-form>\n\t\t\t\t<pension-scheme-groups-form ng-if="formOptions.formKey === \'pension-scheme-groups\'" form-options="formOptions"></pension-scheme-groups-form>\n\t\t\t\t<pension-scheme-postponement-form ng-if="formOptions.formKey === \'pension-scheme-postponement\'" form-options="formOptions"></pension-scheme-postponement-form>\n\t\t\t\t<pension-scheme-period-form ng-if="formOptions.formKey === \'pension-scheme-period\'" form-options="formOptions"></pension-scheme-period-form>\n\t\t\t\t<pension-scheme-period-alignment-form ng-if="formOptions.formKey === \'pension-scheme-period-alignment\'" form-options="formOptions"></pension-scheme-period-alignment-form>\n\t\t\t\t<pension-scheme-provider-form ng-if="formOptions.formKey === \'pension-scheme-provider\'" form-options="formOptions"></pension-scheme-provider-form>\n\t\t\t\t<pension-scheme-queued-pension-cancel-warning-form ng-if="formOptions.formKey === \'pension-scheme-queued-pension-cancel-warning\'" form-options="formOptions"></pension-scheme-queued-pension-cancel-warning-form>\n\t\t\t\t<pension-scheme-settings-form ng-if="formOptions.formKey === \'pension-scheme-settings\'" form-options="formOptions"></pension-scheme-settings-form>\n\t\t\t\t<pension-scheme-staging-form ng-if="formOptions.formKey === \'pension-scheme-staging\'" form-options="formOptions"></pension-scheme-staging-form>\n\t\t\t\t<pension-scheme-team-form ng-if="formOptions.formKey === \'pension-scheme-team\'" form-options="formOptions"></pension-scheme-team-form>\n\n\t\t\t\t<!-- Team -->\n\t\t\t\t<pension-team-contributions-ae-form ng-if="formOptions.formKey === \'pension-team-contributions-ae\'" form-options="formOptions"></pension-team-contributions-ae-form>\n\t\t\t\t<pension-team-contributions-non-ae-form ng-if="formOptions.formKey === \'pension-team-contributions-non-ae\'" form-options="formOptions"></pension-team-contributions-non-ae-form>\n\t\t\t\t<pension-team-bands-form ng-if="formOptions.formKey === \'pension-team-bands\'" form-options="formOptions"></pension-team-bands-form>\n\t\t\t\t<pension-team-groups-form ng-if="formOptions.formKey === \'pension-team-groups\'" form-options="formOptions"></pension-team-groups-form>\n\t\t\t\t<pension-team-manage-pensions-form ng-if="formOptions.formKey === \'pension-team-manage-pensions\'" form-options="formOptions"></pension-team-manage-pensions-form>\n\t\t\t\t<pension-team-postponement-form ng-if="formOptions.formKey === \'pension-team-postponement\'" form-options="formOptions"></pension-team-postponement-form>\n\t\t\t\t<pension-team-remove-form ng-if="formOptions.formKey === \'pension-team-remove\'" form-options="formOptions"></pension-team-remove-form>\n\t\t\t\t<pension-team-salary-sacrifice-form ng-if="formOptions.formKey === \'pension-team-salary-sacrifice\'" form-options="formOptions"></pension-team-salary-sacrifice-form>\n\t\t\t\t<pension-team-scheme-ae-form ng-if="formOptions.formKey === \'pension-team-scheme-ae\'" form-options="formOptions"></pension-team-scheme-ae-form>\n\t\t\t\t<pension-team-scheme-non-ae-form ng-if="formOptions.formKey === \'pension-team-scheme-non-ae\'" form-options="formOptions"></pension-team-scheme-non-ae-form>\n\t\t\t\t<pension-team-status-form ng-if="formOptions.formKey === \'pension-team-status\'" form-options="formOptions"></pension-team-status-form>\n\n\t\t\t<!-- Payroll -->\n\t\t\t<add-a-change-form ng-if="formOptions.formKey === \'add-a-change\'" form-options="formOptions"></add-a-change-form>\n\t\t\t<add-period-note-form ng-if="formOptions.formKey === \'add-period-note\'" form-options="formOptions"></add-period-note-form>\n\t\t\t<add-period-task-form ng-if="formOptions.formKey === \'add-period-task\'" form-options="formOptions"></add-period-task-form>\n\t\t\t<advance-future-periods-form ng-if="formOptions.formKey === \'advance-future-periods\'" form-options="formOptions"></advance-future-periods-form>\n\t\t\t<advance-maternity-funding-form ng-if="formOptions.formKey === \'advance-maternity-funding\'" form-options="formOptions"></advance-maternity-funding-form>\n\t\t\t<apply-tax-refund-form ng-if="formOptions.formKey === \'apply-tax-refund\'" form-options="formOptions"></apply-tax-refund-form>\n\t\t\t<attachment-of-earnings-form ng-if="formOptions.formKey === \'attachment-of-earnings\'" form-options="formOptions"></attachment-of-earnings-form>\n\t\t\t<attachment-of-earnings-view-form ng-if="formOptions.formKey === \'view-attachment-of-earnings\'" form-options="formOptions"></attachment-of-earnings-view-form>\n\t\t\t<cancel-move-payrolls-form ng-if="formOptions.formKey === \'cancel-move-payrolls\'" form-options="formOptions"></cancel-move-payrolls-form>\n\t\t\t<cancel-rejoin-leaver-form ng-if="formOptions.formKey === \'cancel-rejoin-leaver\'" form-options="formOptions"></cancel-rejoin-leaver-form>\n\t\t\t<change-employee-payroll-type-form ng-if="formOptions.formKey === \'change-employee-payroll-type\'" form-options="formOptions"></change-employee-payroll-type-form>\n\t\t\t<childcare-vouchers-form ng-if="formOptions.formKey === \'childcare-vouchers\'" form-options="formOptions"></childcare-vouchers-form>\n\t\t\t<cis-suffered-form ng-if="formOptions.formKey === \'cis-suffered\'" form-options="formOptions"></cis-suffered-form>\n\t\t\t<correctional-submission-form ng-if="formOptions.formKey === \'correctional-submission\'" form-options="formOptions"></correctional-submission-form>\n\t\t\t<delete-change-form ng-if="formOptions.formKey === \'delete-change\'" form-options="formOptions"></delete-change-form>\n\t\t\t<delete-historic-pay-period-form ng-if="formOptions.formKey === \'delete-historic-pay-period\'" form-options="formOptions"></delete-historic-pay-period-form>\n\t\t\t<delete-payroll-alert-form ng-if="formOptions.formKey === \'delete-payroll-alert\'" form-options="formOptions"></delete-payroll-alert-form>\n\t\t\t<delete-period-note-form ng-if="formOptions.formKey === \'delete-period-note\'" form-options="formOptions"></delete-period-note-form>\n\t\t\t<delete-period-task-form ng-if="formOptions.formKey === \'delete-period-task\'" form-options="formOptions"></delete-period-task-form>\n\t\t\t<delete-supplementary-pay-run-form ng-if="formOptions.formKey === \'delete-supplementary-pay-run\'" form-options="formOptions"></delete-supplementary-pay-run-form>\n\t\t\t<edit-pay-notification-date-form ng-if="formOptions.formKey === \'edit-pay-notification-date\'" form-options="formOptions"></edit-pay-notification-date-form>\n\t\t\t<edit-repayment-schedule-for-period-form ng-if="formOptions.formKey === \'edit-repayment-schedule-for-period\'" form-options="formOptions"></edit-repayment-schedule-for-period-form>\n\t\t\t<edit-repayment-schedule-fixed-for-period-form ng-if="formOptions.formKey === \'edit-repayment-schedule-fixed-for-period\'" form-options="formOptions"></edit-repayment-schedule-fixed-for-period-form>\n\t\t\t<exclude-from-payroll-form ng-if="formOptions.formKey === \'exclude-from-payroll\'" form-options="formOptions"></exclude-from-payroll-form>\n\t\t\t<furlough-form ng-if="formOptions.formKey === \'furlough\'" form-options="formOptions"></furlough-form>\n\t\t\t<generate-p45-form ng-if="formOptions.formKey === \'generate-p45\'" form-options="formOptions"></generate-p45-form>\n\t\t\t<hourly-totals-form ng-if="formOptions.formKey === \'hourly-totals\'" form-options="formOptions"></hourly-totals-form>\n\t\t\t<invite-to-register-form ng-if="formOptions.formKey === \'invite-to-register\'" form-options="formOptions"></invite-to-register-form>\n\t\t\t<invite-sso-admin-to-fully-register-form ng-if="formOptions.formKey === \'invite-sso-admin-to-fully-register\'" form-options="formOptions"></invite-sso-admin-to-fully-register-form>\n\t\t\t<leaver-made-in-error-form ng-if="formOptions.formKey === \'leaver-made-in-error\'" form-options="formOptions"></leaver-made-in-error-form>\n\t\t\t<link-rates-form ng-if="formOptions.formKey === \'link-rates\'" form-options="formOptions"></link-rates-form>\n\t\t\t<lock-payroll-form ng-if="formOptions.formKey === \'lock-payroll\'" form-options="formOptions"></lock-payroll-form>\n\t\t\t<manage-rolled-up-holiday-form ng-if="formOptions.formKey === \'manage-rolled-up-holiday\'" form-options="formOptions"></manage-rolled-up-holiday-form>\n\t\t\t<maternity-pay-form ng-if="formOptions.formKey === \'maternity-pay\'" form-options="formOptions"></maternity-pay-form>\n\t\t\t<maternity-pay-view-form ng-if="formOptions.formKey === \'view-maternity-pay\'" form-options="formOptions"></maternity-pay-view-form>\n\t\t\t<move-payrolls-form ng-if="formOptions.formKey === \'move-payrolls-form\'" form-options="formOptions"></move-payrolls-form>\n\t\t\t<ni-category-updates-form ng-if="formOptions.formKey === \'ni-category-updates\'" form-options="formOptions"></ni-category-updates-form>\n\t\t\t<on-hold-form ng-if="formOptions.formKey === \'on-hold\'" form-options="formOptions"></on-hold-form>\n\t\t\t<paternity-pay-form ng-if="formOptions.formKey === \'paternity-pay\'" form-options="formOptions"></paternity-pay-form>\n\t\t\t<paternity-pay-view-form ng-if="formOptions.formKey === \'view-paternity-pay\'" form-options="formOptions"></paternity-pay-view-form>\n\t\t\t<pay-statement-form ng-if="formOptions.formKey === \'pay-statement\'" form-options="formOptions"></pay-statement-form>\n\t\t\t<refresh-selected-changes-form ng-if="formOptions.formKey === \'refresh-selected-changes\'" form-options="formOptions"></refresh-selected-changes-form>\n\t\t\t<recall-draft-payslips-form ng-if="formOptions.formKey === \'recall-draft-payslips\'" form-options="formOptions"></recall-draft-payslips-form>\n\t\t\t<remove-payslip-notes-form ng-if="formOptions.formKey === \'remove-payslip-notes\'" form-options="formOptions"></remove-payslip-notes-form>\n\t\t\t<regenerate-bacs-file-form ng-if="formOptions.formKey === \'regenerate-bacs-file\'" form-options="formOptions"></regenerate-bacs-file-form>\n\t\t\t<regenerate-documents-form ng-if="formOptions.formKey === \'regenerate-documents\'" form-options="formOptions"></regenerate-documents-form>\n\t\t\t<rejoin-leaver-form ng-if="formOptions.formKey === \'rejoin-leaver\'" form-options="formOptions"></rejoin-leaver-form>\n\t\t\t<repayment-schedules-form ng-if="formOptions.formKey === \'repayment-schedules\'" form-options="formOptions"></repayment-schedules-form>\n\t\t\t<reversed-hmrc-tax-updates-form ng-if="formOptions.formKey === \'reversed-hmrc-tax-updates\'" form-options="formOptions"></reversed-hmrc-tax-updates-form>\n\t\t\t<rollback-period-form ng-if="formOptions.formKey === \'rollback-period\'" form-options="formOptions"></rollback-period-form>\n\t\t\t<salary-change-form ng-if="formOptions.formKey === \'salary-change\'" form-options="formOptions"></salary-change-form>\n\t\t\t<send-notifications-form ng-if="formOptions.formKey === \'send-notifications\'" form-options="formOptions"></send-notifications-form>\n\t\t\t<send-draft-payslips-form ng-if="formOptions.formKey === \'send-draft-payslips\'" form-options="formOptions"></send-draft-payslips-form>\n\t\t\t<sick-pay-form ng-if="formOptions.formKey === \'sick-pay\'" form-options="formOptions"></sick-pay-form>\n\t\t\t<sick-pay-view-form ng-if="formOptions.formKey === \'view-sick-pay\'" form-options="formOptions"></sick-pay-view-form>\n\t\t\t<submit-changes-table-form ng-if="formOptions.formKey === \'submit-changes-table\'" form-options="formOptions"></submit-changes-table-form>\n\t\t\t<submit-eps-form ng-if="formOptions.formKey === \'submit-eps\'" form-options="formOptions"></submit-eps-form>\n\t\t\t<supplementary-pay-run-form ng-if="formOptions.formKey === \'supplementary-pay-run\'" form-options="formOptions"></supplementary-pay-run-form>\n\t\t\t<tax-updates-form ng-if="formOptions.formKey === \'tax-updates\'" form-options="formOptions"></tax-updates-form>\n\t\t\t<tax-updates-confirmation-form ng-if="formOptions.formKey === \'tax-updates-confirmation\'" form-options="formOptions"></tax-updates-confirmation-form>\n\t\t\t<unmark-as-advancing-form ng-if="formOptions.formKey === \'unmark-as-advancing\'" form-options="formOptions"></unmark-as-advancing-form>\n\t\t\t<unmark-as-leaver-form ng-if="formOptions.formKey === \'unmark-as-leaver\'" form-options="formOptions"></unmark-as-leaver-form>\n\t\t\t<update-gross-pay-form ng-if="formOptions.formKey === \'update-gross-pay\'" form-options="formOptions"></update-gross-pay-form>\n\t\t\t<update-leaver-status-form ng-if="formOptions.formKey === \'update-leaver-status\'" form-options="formOptions"></update-leaver-status-form>\n\n\t\t\t<!-- Workflow -->\n\t\t\t<calculate-payroll-form ng-if="formOptions.formKey === \'calculate-payroll\'" form-options="formOptions"></calculate-payroll-form>\n\t\t\t<complete-step-form ng-if="formOptions.formKey === \'complete-step\'" form-options="formOptions"></complete-step-form>\n\t\t\t<reassign-workflow-task-form ng-if="formOptions.formKey === \'reassign-workflow-task\'" form-options="formOptions"></reassign-workflow-task-form>\n\n\t\t\t<!-- Company -->\n\t\t\t<add-new-admin-form ng-if="formOptions.formKey === \'new-admin\'" form-options="formOptions"></add-new-admin-form>\n\t\t\t<add-payslip-label-form ng-if="formOptions.formKey === \'add-payslip-label\'" form-options="formOptions"></add-payslip-label-form>\n\t\t\t<bacs-penny-test-form ng-if="formOptions.formKey === \'bacs-penny-test\'" form-options="formOptions"></bacs-penny-test-form>\n\t\t\t<billing-enabled-form ng-if="formOptions.formKey === \'billing-enabled\'" form-options="formOptions"></billing-enabled-form>\n\t\t\t<bulk-add-to-company-group-form ng-if="formOptions.formKey === \'bulk-add-to-company-group\'" form-options="formOptions"></bulk-add-to-company-group-form>\n\t\t\t<business-code-form ng-if="formOptions.formKey === \'business-code\'" form-options="formOptions"></business-code-form>\n\t\t\t<cis-company-contact-form ng-if="formOptions.formKey === \'cis-company-contact\'" form-options="formOptions"></cis-company-contact-form>\n\t\t\t<cis-company-details-form ng-if="formOptions.formKey === \'cis-company-details\'" form-options="formOptions"></cis-company-details-form>\n\t\t\t<company-modules-form ng-if="formOptions.formKey === \'company-modules\'" form-options="formOptions"></company-modules-form>\n\t\t\t<company-overview-form ng-if="formOptions.formKey === \'company-overview\'" form-options="formOptions"></company-overview-form>\n\t\t\t<company-payroll-overview-form ng-if="formOptions.formKey === \'company-payroll-overview\'" form-options="formOptions"></company-payroll-overview-form>\n\t\t\t<cross-period-report-form ng-if="formOptions.formKey === \'cross-period-report\'" form-options="formOptions"></cross-period-report-form>\n\t\t\t<customisation-form ng-if="formOptions.formKey === \'customisation\'" form-options="formOptions"></customisation-form>\n\t\t\t<delete-payslip-label-form ng-if="formOptions.formKey === \'delete-payslip-label\'" form-options="formOptions"></delete-payslip-label-form>\n\t\t\t<direct-debit-form ng-if="formOptions.formKey === \'direct-debit\'" form-options="formOptions"></direct-debit-form>\n\t\t\t<company-bank-details-form ng-if="formOptions.formKey === \'company-bank-details\'" form-options="formOptions"></company-bank-details-form>\n\t\t\t<company-billing-details-form ng-if="formOptions.formKey === \'company-billing-details\'" form-options="formOptions"></company-billing-details-form>\n\t\t\t<company-billing-name-form ng-if="formOptions.formKey === \'company-billing-name\'" form-options="formOptions"></company-billing-name-form>\n\t\t\t<manage-company-groups-form ng-if="formOptions.formKey === \'manage-company-groups\'" form-options="formOptions"></manage-company-groups-form>\n\t\t\t<company-pension-connector-form ng-if="formOptions.formKey === \'company-pension-connector\'" form-options="formOptions"></company-pension-connector-form>\n\n\t\t\t<historic-tax-period-form ng-if="formOptions.formKey === \'historic-tax-period\'" form-options="formOptions"></historic-tax-period-form>\n\t\t\t<journal-code-format-form ng-if="formOptions.formKey === \'journal-code-format\'" form-options="formOptions"></journal-code-format-form>\n\t\t\t<journal-code-financials-form ng-if="formOptions.formKey === \'journal-code-financials\'" form-options="formOptions"></journal-code-financials-form>\n\t\t\t<journal-post-temporal-data-form ng-if="formOptions.formKey === \'journal-post-temporal-data\'" form-options="formOptions"></journal-post-temporal-data-form>\n\t\t\t<payslip-manager-form ng-if="formOptions.formKey === \'payslip-manager\'" form-options="formOptions"></payslip-manager-form>\n\t\t\t<people-hr-updates-data-form ng-if="formOptions.formKey === \'people-hr-updates-data\'" form-options="formOptions"></people-hr-updates-data-form>\n\t\t\t<post-to-xero-form ng-if="formOptions.formKey === \'post-to-xero\'" form-options="formOptions"></post-to-xero-form>\n\t\t\t<post-to-financials-form ng-if="formOptions.formKey === \'post-to-financials\'" form-options="formOptions"></post-to-financials-form>\n\t\t\t<rotaready-updates-data-form ng-if="formOptions.formKey === \'rotaready-updates-data\'" form-options="formOptions"></rotaready-updates-data-form>\n\t\t\t<rotaready-updates-dismiss-all-form ng-if="formOptions.formKey === \'rotaready-updates-dismiss-all\'" form-options="formOptions"></rotaready-updates-dismiss-all-form>\n\t\t\t<switch-to-live-form ng-if="formOptions.formKey === \'switch-to-live\'" form-options="formOptions"></switch-to-live-form>\n\t\t\t<view-changes-form ng-if="formOptions.formKey === \'view-changes\'" form-options="formOptions"></view-changes-form>\n\t\t\t<view-transcript-form ng-if="formOptions.formKey === \'view-transcript\'" form-options="formOptions"></view-transcript-form>\n\t\t\t<work-pattern-form ng-if="formOptions.formKey === \'work-pattern\'" form-options="formOptions"></work-pattern-form>\n\t\t\t<work-pattern-delete-form ng-if="formOptions.formKey === \'work-pattern-delete\'" form-options="formOptions"></work-pattern-delete-form>\n\t\t\t<work-pattern-team-members-form ng-if="formOptions.formKey === \'work-pattern-team-members\'" form-options="formOptions"></work-pattern-team-members-form>\n\t\t\t<workflow-collaborator-form ng-if="formOptions.formKey === \'workflow-collaborator\'" form-options="formOptions"></workflow-collaborator-form>\n\t\t\t<workflow-deadlines-form ng-if="formOptions.formKey === \'workflow-deadlines\'" form-options="formOptions"></workflow-deadlines-form>\n\t\t\t<xero-form ng-if="formOptions.formKey === \'xero\'" form-options="formOptions"></xero-form>\n\t\t\t<financials-form ng-if="formOptions.formKey === \'financials\'" form-options="formOptions"></financials-form>\n\n\t\t\t<!-- CIS Scheme -->\n\t\t\t<cis-business-type-form ng-if="formOptions.formKey === \'cis-business-type\'" form-options="formOptions"></cis-business-type-form>\n\t\t\t<cis-vat-form ng-if="formOptions.formKey === \'cis-vat\'" form-options="formOptions"></cis-vat-form>\n\t\t\t<cis-verification-form ng-if="formOptions.formKey === \'cis-verification\'" form-options="formOptions"></cis-verification-form>\n\n\t\t\t<!-- Off payroll -->\n\t\t\t<edit-deemed-payment-form ng-if="formOptions.formKey === \'edit-deemed-payment\'" form-options="formOptions"></edit-deemed-payment-form>\n\n\t\t\t<!-- Imports -->\n\t\t\t<cancel-user-import-form ng-if="formOptions.formKey === \'cancel-user-import\'" form-options="formOptions"></cancel-user-import-form>\n\t\t\t<delete-import-mapping-form ng-if="formOptions.formKey === \'delete-import-mapping\'" form-options="formOptions"></delete-import-mapping-form>\n\t\t\t<edit-import-layout-form ng-if="formOptions.formKey === \'edit-import-layout\'" form-options="formOptions"></edit-import-layout-form>\n\t\t\t<edit-team-imports-form ng-if="formOptions.formKey === \'edit-team-imports\'" form-options="formOptions"></edit-team-imports-form>\n\t\t\t<import-history-form ng-if="formOptions.formKey === \'import-history\'" form-options="formOptions"></import-history-form>\n\t\t\t<mapping-template-form ng-if="formOptions.formKey === \'mapping-template\'" form-options="formOptions"></mapping-template-form>\n\t\t\t<match-change-type-form ng-if="formOptions.formKey === \'match-change-type\'" form-options="formOptions"></match-change-type-form>\n\t\t\t<match-link-element-form ng-if="formOptions.formKey === \'match-link-element\'" form-options="formOptions"></match-link-element-form>\n\t\t\t<match-payslip-label-form ng-if="formOptions.formKey === \'match-payslip-label\'" form-options="formOptions"></match-payslip-label-form>\n\t\t\t<match-policy-details-form ng-if="formOptions.formKey === \'match-policy-details\'" form-options="formOptions"></match-policy-details-form>\n\t\t\t<pay-element-net-to-gross-form ng-if="formOptions.formKey === \'pay-element-net-to-gross\'" form-options="formOptions"></pay-element-net-to-gross-form>\n\t\t\t<pay-element-rate-type-form ng-if="formOptions.formKey === \'pay-element-rate-type\'" form-options="formOptions"></pay-element-rate-type-form>\n\t\t\t<pay-element-matching-form ng-if="formOptions.formKey === \'pay-element-matching\'" form-options="formOptions"></pay-element-matching-form>\n\t\t\t<resolve-pay-period-dates-form ng-if="formOptions.formKey === \'resolve-pay-period-dates\'" form-options="formOptions"></resolve-pay-period-dates-form>\n\t\t\t<undo-import-form ng-if="formOptions.formKey === \'undo-import\'" form-options="formOptions"></undo-import-form>\n\t\t\t<undo-import-company-data-form ng-if="formOptions.formKey === \'undo-import-company-data\'" form-options="formOptions"></undo-import-company-data-form>\n\t\t\t<undo-import-pay-element-form ng-if="formOptions.formKey === \'undo-import-pay-element\'" form-options="formOptions"></undo-import-pay-element-form>\n\t\t\t<undo-import-pay-policy-form ng-if="formOptions.formKey === \'undo-import-pay-policy\'" form-options="formOptions"></undo-import-pay-policy-form>\n\t\t\t<undo-import-posts-pay-policies-form ng-if="formOptions.formKey === \'undo-import-posts-pay-policies\'" form-options="formOptions"></undo-import-posts-pay-policies-form>\n\t\t\t<undo-import-team-form ng-if="formOptions.formKey === \'undo-import-team\'" form-options="formOptions"></undo-import-team-form>\n\t\t\t<upload-to-importer-form ng-if="formOptions.formKey === \'upload-to-importer\'" form-options="formOptions"></upload-to-importer-form>\n\t\t\t<update-payelement-validation-result-form ng-if="formOptions.formKey === \'update-payelement-validation-result\'" form-options="formOptions"></update-payelement-validation-result-form>\n\t\t\t<update-validation-result-form ng-if="formOptions.formKey === \'update-validation-result\'" form-options="formOptions"></update-validation-result-form>\n\t\t\t<validate-data-form ng-if="formOptions.formKey === \'validate-data\'" form-options="formOptions"></validate-data-form>\n\n\t\t\t<!-- HR -->\n\t\t\t<add-leave-form ng-if="formOptions.formKey === \'add-leave\'" form-options="formOptions"></add-leave-form>\n\t\t\t<add-pay-policy-update-form ng-if="formOptions.formKey === \'add-pay-policy-update\'" form-options="formOptions"></add-pay-policy-update-form>\n\t\t\t<company-settings-holiday-policy-form ng-if="formOptions.formKey === \'company-settings-holiday-policy\'" form-options="formOptions"></company-settings-holiday-policy-form>\n\t\t\t<delete-job-grade-form ng-if="formOptions.formKey === \'delete-job-grade\'" form-options="formOptions"></delete-job-grade-form>\n\t\t\t<delete-policy-form ng-if="formOptions.formKey === \'delete-policy\'" form-options="formOptions"></delete-policy-form>\n\t\t\t<edit-holiday-policy-form ng-if="formOptions.formKey === \'edit-holiday-policy\'" form-options="formOptions"></edit-holiday-policy-form>\n\t\t\t<edit-sickness-policy-form ng-if="formOptions.formKey === \'edit-sickness-policy\'" form-options="formOptions"></edit-sickness-policy-form>\n\t\t\t<holiday-sickness-form ng-if="formOptions.formKey === \'holiday-sickness\'" form-options="formOptions"></holiday-sickness-form>\n\t\t\t<job-grade-team-members-form ng-if="formOptions.formKey === \'job-grade-team-members\'" form-options="formOptions"></job-grade-team-members-form>\n\t\t\t<pay-policy-history-form ng-if="formOptions.formKey === \'pay-policy-history\'" form-options="formOptions"></pay-policy-history-form>\n\t\t\t<update-job-grade-form ng-if="formOptions.formKey === \'update-job-grade\'" form-options="formOptions"></update-job-grade-form>\n\t\t\t<update-pay-policy-form ng-if="formOptions.formKey === \'update-pay-policy\'" form-options="formOptions"></update-pay-policy-form>\n\t\t\t<update-policy-form ng-if="formOptions.formKey === \'update-policy\'" form-options="formOptions"></update-policy-form>\n\t\t\t<view-pension-policy-form ng-if="formOptions.formKey === \'view-pension-policy\'" form-options="formOptions"></view-pension-policy-form>\n\n\t\t\t<!-- Onboarding -->\n\t\t\t<ask-my-advisor-form ng-if="formOptions.formKey === \'ask-my-advisor\'" form-options="formOptions"></ask-my-advisor-form>\n\t\t\t<bureau-change-company-state-form ng-if="formOptions.formKey === \'onboarding-bureau-change-company-state\'" form-options="formOptions"></bureau-change-company-state-form>\n\t\t\t<bureau-new-company-form ng-if="formOptions.formKey === \'onboarding-bureau-new-company\'" form-options="formOptions"></bureau-new-company-form>\n\t\t\t<bureau-extend-trial-form ng-if="formOptions.formKey === \'onboarding-bureau-extend-trial\'" form-options="formOptions"></bureau-extend-trial-form>\n\t\t\t<bureau-edit-first-period-form ng-if="formOptions.formKey === \'onboarding-bureau-edit-first-period\'" form-options="formOptions"></bureau-edit-first-period-form>\n\t\t\t<bureau-move-to-live-form ng-if="formOptions.formKey === \'onboarding-bureau-move-to-live\'" form-options="formOptions"></bureau-move-to-live-form>\n\t\t\t<bureau-delete-company-form ng-if="formOptions.formKey === \'onboarding-bureau-delete-company\'" form-options="formOptions"></bureau-delete-company-form>\n\t\t\t<bureau-onboarding-checklist-form ng-if="formOptions.formKey === \'onboarding-bureau-onboarding-checklist\'" form-options="formOptions"></bureau-onboarding-checklist-form>\n\t\t\t<cancel-trial-form ng-if="formOptions.formKey === \'onboarding-cancel-trial\'" form-options="formOptions"></cancel-trial-form>\n\t\t\t<move-to-onboarding-form ng-if="formOptions.formKey === \'onboarding-move-to-onboarding\'" form-options="formOptions"></move-to-onboarding-form>\n\t\t\t<onboarding-wizard-company-form ng-if="formOptions.formKey === \'onboarding-wizard-company\'" form-options="formOptions"></onboarding-wizard-company-form>\n\t\t\t<onboarding-wizard-profile-form ng-if="formOptions.formKey === \'onboarding-wizard-profile\'" form-options="formOptions"></onboarding-wizard-profile-form>\n\t\t\t<unlock-approve-payroll-form ng-if="formOptions.formKey === \'unlock-approve-payroll\'" form-options="formOptions"></unlock-approve-payroll-form>\n\n\t\t\t<!-- Reporting -->\n\t\t\t<delete-report-template-form ng-if="formOptions.formKey === \'delete-report-template\'" form-options="formOptions"></delete-report-template-form>\n\t\t\t<download-reports-form ng-if="formOptions.formKey === \'download-reports\'" form-options="formOptions"></download-reports-form>\n\t\t\t<manage-report-packs-form ng-if="formOptions.formKey === \'manage-report-packs\'" form-options="formOptions"></manage-report-packs-form>\n\t\t\t<report-template-group-form ng-if="formOptions.formKey === \'report-template-group\'" form-options="formOptions"></report-template-group-form>\n\t\t\t<bacs-download-confirm-form ng-if="formOptions.formKey === \'bacs-download-confirmation\'" form-options="formOptions"></bacs-download-confirm-form>\n\n\t\t\t<!-- Paycircle Development -->\n\t\t\t<template-form ng-if="formOptions.formKey === \'template\'" form-options="formOptions"></template-form>\n\t\t</div>\n\n\t\t<!-- Error -->\n\t\t<div pc-switch-when="CABINET_STATES.error">\n\t\t\t<error-block secondary-action="formOptions.closeForm()" secondary-action-text="Close this form"></error-block>\n\t\t</div>\n\n\t\t<!-- User doesn\'t have permissions to action this form -->\n\t\t<div pc-switch-when="CABINET_STATES.noPermissions">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-icon="warning" fs-title="This feature isn\'t available">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">You don\'t have the correct permissions to use this feature. If this appears incorrect, please contact your administrator or contact support.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Not available in playground -->\n\t\t<div pc-switch-when="CABINET_STATES.notAvailableInPlayground">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-icon="warning" fs-title="This feature isn\'t available in your playground">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">It will become available when you switch over to your live account. If you have any questions please contact support.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Team member is \'On hold\' -->\n\t\t<div pc-switch-when="CABINET_STATES.teamMemberOnHold">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-icon="warning" fs-title="{{formOptions.context.Forename}} is marked as \'On hold\'">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Please note that while team members are marked as &lsquo;On hold&rsquo; some actions are not available. Please mark {{formOptions.context.Forename}} as &lsquo;Active on payroll&rsquo; before trying again.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Team member is \'Advancing\' or \'Advanced\' -->\n\t\t<div pc-switch-when="CABINET_STATES.teamMemberAdvancingOrAdvanced">\n\t\t\t<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="{{formOptions.context.Forename}} is marked as {{formOptions.context.IsAdvancingFuturePeriods ? \'\u2018Advancing\u2019\' : \'\u2018Advanced\u2019\'}}">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPlease note that while team members are marked as {{formOptions.context.IsAdvancingFuturePeriods ? \'\u2018Advancing\u2019\' : \'\u2018Advanced\u2019\'}}\n\t\t\t\t\t\tsome actions are not available. {{formOptions.context.Forename}} will appear on payroll again after the {{formOptions.context.AdvancePeriodsEndPeriodDisplay}} period\n\t\t\t\t\t\tand you\u2019ll be able to manage their profile as normal.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Company archived -->\n\t\t<div pc-switch-when="CABINET_STATES.companyArchived">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-theme="tertiary" fs-icon="warning" fs-title="This company has been archived">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">{{formOptions.company.Name}} was archived at {{formOptions.company.ArchiveDateISO | datetimeformat:\'time12\'}} on {{formOptions.company.ArchiveDateISO | dateformat:\'long\'}}. <a ui-sref="companies-archived" class="underline" ng-if="::$root.currentUser.Permissions.isCompanySettingsVisible">View archived companies</a></p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Company is clone -->\n\t\t<div pc-switch-when="CABINET_STATES.companyIsClone">\n\t\t\t<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This feature isn\u2019t available for cloned payrolls">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note that some features aren\u2019t available for cloned payrolls including:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Data submitted to or received from any third party including RTI, DPS, direct pension providers, CIS submissions, and CIS verification\',\n\t\t\t\t\t\t\t\t\'All system emails including invitations to register and workflow notifications\',\n\t\t\t\t\t\t\t\t\'Any changes to roles or permissions\',\n\t\t\t\t\t\t\t\t\'NI Numbers and email addresses for team members and admins\',\n\t\t\t\t\t\t\t\t\'Managing company groups\',\n\t\t\t\t\t\t\t\t\'Employee portal\',\n\t\t\t\t\t\t\t\t\'Autorun and auto sending of payroll reports\'\n\t\t\t\t\t\t\t]" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t</div>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- PAYE scheme ceased -->\n\t\t<div pc-switch-when="CABINET_STATES.payeSchemeCeased">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-icon="warning" fs-title="This company\u2019s PAYE scheme has been ceased">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">{{formOptions.company.Name}}\'s PAYE scheme was closed on {{formOptions.company.PAYECeaseDateISO | dateformat}}.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Payroll processing -->\n\t\t<div pc-switch-when="CABINET_STATES.payrollNotUnsubmitted">\n\t\t\t<form-state form-options="formOptions" class="fadeIn" fs-icon="warning" fs-title="Payroll is currently processing">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Payroll for {{formOptions.currentPayPeriod.PayPeriodDisplay}} is currently being processed and you can\'t make any changes. This may take a few minutes to complete.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Payroll partially submitted -->\n\t\t<div pc-switch-when="CABINET_STATES.payrollPartiallySubmitted">\n\t\t\t<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-theme="assertive" fs-title="Payroll was only partially submitted">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour {{submittedFiles.submittedSubmissonsDisplay}} for {{formOptions.currentPayPeriod.PayPeriodDisplay}} {{ submittedFiles.submittedSubmissons.length > 1 ? \'have\' : \'has\' }} been successfully submitted but your full submission has failed. If you need to make changes that would affect the data that has already been submitted, please contact support.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Payroll failed -->\n\t\t<div pc-switch-when="CABINET_STATES.payrollFailed">\n\t\t\t<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-theme="assertive" fs-title="Payroll has failed">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tCertain actions aren\u2019t available while payroll has failed. Head to your current period to review your submission errors before resetting payroll. You can then undo your payroll calculation before trying again.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Period calculated -->\n\t\t<div pc-switch-when="CABINET_STATES.periodCalculated">\n\t\t\t<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Payroll has been calculated">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tCertain actions aren\u2019t available while payroll has been calculated so that the calculation and your draft reports aren\u2019t affected. If you need to make changes, head to your\n\t\t\t\t\t\tcurrent period and undo your payroll calculation before trying again.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Period in rollback -->\n\t\t<div pc-switch-when="CABINET_STATES.periodInRollback">\n\t\t\t<form-state form-options="formOptions" fs-theme="tertiary" class="fadeIn" fs-icon="warning" fs-title="Payroll is currently in rollback">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">Please note that once you\'ve run payroll again for {{::formOptions.currentPayPeriod.PayPeriodDisplay}} this action will be available as normal.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<!-- Company payroll module is off-->\n\t\t<div pc-switch-when="CABINET_STATES.companyHasNoPayroll">\n\t\t\t<form-state form-options="formOptions" fs-theme="tertiary" class="fadeIn" fs-icon="warning" fs-title="These settings are currently unavailable">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">Please note that some of your payroll settings aren\'t available as the Payroll module isn\'t turned on.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t</div>\n</slide-in-form>\n');
$templateCache.put('components/form-feedback/formFeedback.html','<section class="form-actions-feedback riseIn">\n\t<div class="message-bar inline success">\n\n\t\t<ng-transclude></ng-transclude>\n\n\t</div>\n</section>');
$templateCache.put('components/form-field/form-field.component.html','<div class="form-field" ng-switch="$ctrl.formFieldOptions.fieldType" ng-if="$ctrl.componentState === \'ready\'">\n\n\t<div class="form-field-header" ng-if="$ctrl.hasHeader($ctrl.formFieldOptions)">\n\t\t<label for="{{::$ctrl.formFieldOptions.id}}" ng-class="{\'required\': $ctrl.formFieldOptions.isRequired, \'disabled\': $ctrl.formFieldOptions.isDisabled}">{{$ctrl.formFieldOptions.label}}:</label>\n\t</div>\n\n\t<!-- Text (default) -->\n\t<div class="form-field-main" ng-class="{\'has-suffix\': $ctrl.formFieldOptions.suffix}" pc-switch-when="$ctrl.FIELD_TYPES.text">\n\t\t<input id="{{::$ctrl.formFieldOptions.id}}" name="{{::$ctrl.formFieldOptions.name}}" placeholder="{{::$ctrl.formFieldOptions.placeholder}}" type="text" ng-change="$ctrl.onChange()" ng-class="$ctrl.formFieldOptions.class" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-maxlength="$ctrl.formFieldOptions.maxlength" ng-minlength="$ctrl.formFieldOptions.minlength" ng-model="$ctrl.ngModel" ng-pattern="$ctrl.formFieldOptions.patternRegex" ng-required="$ctrl.formFieldOptions.isRequired">\n\t\t<span class="form-field-main_suffix" ng-class="{\'is-disabled\': $ctrl.formFieldOptions.isDisabled}" ng-if="::$ctrl.formFieldOptions.suffix">{{::$ctrl.formFieldOptions.suffix}}</span>\n\t</div>\n\n\t<!-- Number -->\n\t<div class="form-field-main" ng-class="{\'has-suffix\': $ctrl.formFieldOptions.suffix}" pc-switch-when="$ctrl.FIELD_TYPES.number">\n\t\t<input id="{{::$ctrl.formFieldOptions.id}}" name="{{::$ctrl.formFieldOptions.name}}" placeholder="{{::$ctrl.formFieldOptions.placeholder}}" type="number" ng-change="$ctrl.onChange()" ng-class="$ctrl.formFieldOptions.class" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-model="$ctrl.ngModel" ng-pattern="$ctrl.formFieldOptions.patternRegex" ng-required="$ctrl.formFieldOptions.isRequired">\n\t\t<span class="form-field-main_suffix" ng-class="{\'is-disabled\': $ctrl.formFieldOptions.isDisabled}" ng-if="::$ctrl.formFieldOptions.suffix">{{::$ctrl.formFieldOptions.suffix}}</span>\n\t</div>\n\n\t<!-- Money -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.money">\n\t\t<input class="monetise" id="{{::$ctrl.formFieldOptions.id}}" name="{{::$ctrl.formFieldOptions.name}}" placeholder="{{::$ctrl.formFieldOptions.placeholder}}" type="number" ng-change="$ctrl.onChange()" ng-class="$ctrl.formFieldOptions.class" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-model="$ctrl.ngModel" ng-pattern="$ctrl.formFieldOptions.patternRegex" ng-required="$ctrl.formFieldOptions.isRequired">\n\t</div>\n\n\t<!-- Percentage -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.percentage">\n\t\t<input class="percentage" id="{{::$ctrl.formFieldOptions.id}}" name="{{::$ctrl.formFieldOptions.name}}" placeholder="{{::$ctrl.formFieldOptions.placeholder}}" type="number" ng-change="$ctrl.onChange()" ng-class="$ctrl.formFieldOptions.class" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-max="100" ng-min="0" ng-model="$ctrl.ngModel" ng-pattern="$ctrl.formFieldOptions.patternRegex" ng-required="$ctrl.formFieldOptions.isRequired">\n\t</div>\n\n\t<!-- Checkbox -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.checkbox">\n\t\t<input id="{{::$ctrl.formFieldOptions.id}}" name="{{::$ctrl.formFieldOptions.name}}" type="checkbox" ng-change="$ctrl.onChange()" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-model="$ctrl.ngModel" checkbox label-text="$ctrl.formFieldOptions.label">\n\t</div>\n\n\t<!-- Date -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.date">\n\t\t<date-input-field field-disabled="$ctrl.formFieldOptions.isDisabled" field-id="{{$ctrl.formFieldOptions.id}}" field-max-date-iso="$ctrl.formFieldOptions.maxDateIso" field-min-date-iso="$ctrl.formFieldOptions.minDateIso" field-on-change-fn="$ctrl.onChange()" field-required="$ctrl.formFieldOptions.isRequired" field-value-iso="$ctrl.ngModel">\n\t\t</date-input-field>\n\t</div>\n\n\t<!-- Radios (inline, round) -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.radios">\n\t\t<span ng-repeat="option in $ctrl.formFieldOptions.options">\n\t\t\t<input class="b" id="{{::option.key}}" name="{{::option.key}}" type="radio" ng-change="$ctrl.onChange()" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-model="$ctrl.ngModel" ng-value="option.value" required>\n\t\t\t<label for="{{option.key}}">{{::option.label}}</label>\n\t\t</span>\n\t</div>\t\n\n\t<!-- Select -->\n\t<div class="form-field-main" pc-switch-when="$ctrl.FIELD_TYPES.select">\n\t\t<select name="{{::$ctrl.formFieldOptions.id}}" id="{{::$ctrl.formFieldOptions.id}}" ng-change="$ctrl.onChange()" ng-disabled="$ctrl.formFieldOptions.isDisabled" ng-model="$ctrl.ngModel" ng-options="option.value as option.label for option in $ctrl.formFieldOptions.options" ng-required="$ctrl.formFieldOptions.isRequired"></select>\n\t</div>\t\n\n\t<!-- Other -->\n\t<div class="form-field-main" ng-switch-default ng-transclude="main"></div>\n\n\t<div class="form-errors fadeIn" ng-messages="$ctrl.parentForm[$ctrl.formFieldOptions.id].$error" ng-if="$ctrl.parentForm[$ctrl.formFieldOptions.id].$touched" role="alert">\n\t\t<p ng-message="{{::error.key}}" ng-repeat="error in $ctrl.formFieldOptions.errorMessages">{{::error.message}}</p>\n\t\t<p ng-message="number">Please enter a valid value</p>\n\t\t<p ng-message="min || max">Please enter a valid date</p>\n\t</div>\n\t<p class="form-message fadeIn" ng-if="::$ctrl.formFieldOptions.message">{{::$ctrl.formFieldOptions.message}}</p>\n</div>\n\n');
$templateCache.put('components/form-field-errors/form-field-errors.component.html','<div class="form-field_errors fadeIn" ng-if="$ctrl.form[$ctrl.inputName].$invalid && $ctrl.form[$ctrl.inputName].$touched" ng-messages="$ctrl.form[$ctrl.inputName].$error">\n\t<p class="form-field_error" ng-message="{{errorType.key}}" ng-repeat="errorType in $ctrl.errorTypes">\n\t\t{{::errorType.message}}\n\t</p>\n</div>\n');
$templateCache.put('components/form-group/formGroupComponent.html','<div class="form-group">\n\t<a href="" class="form-group-toggle" ng-click="toggleOpen()"><i class="icon-{{fgIsOpen ? \'up\' : \'right\'}}"></i>{{fgTitle}}</a>\n\t<div class="form-group-content fadeIn" ng-show="fgIsOpen">\n\t\t<ng-transclude></ng-transclude>\n\t</div>\n</div>\n');
$templateCache.put('components/form-header/form-header.component.html','<div class="form-header" ng-class="$ctrl.theme">\n\t<h1 class="form-header_title" ng-if="$ctrl.fhShowTitle">\n\t\t<span class="secondary strong">Payroll</span>&nbsp;<span class="regular">portal</span>\n\t</h1>\n\t<h3 class="form-header_subtitle" ng-if="$ctrl.fhSubtitle">\n\t\t{{$ctrl.fhSubtitle}}\n\t</h3>\n\t<div class="form-header_intro" ng-if="$ctrl.hasIntro" ng-transclude="formHeaderIntro"></div>\n</div>\n\n\n\n');
$templateCache.put('components/form-state/form-state.component.html','<section class="form-state fadeIn {{$ctrl.fsTheme}}">\n\n\t<!-- Pre header -->\n\t<div class="form-state-pre" ng-if="$ctrl.showPreHeader" ng-transclude="preheader"></div>\n\n\t<!-- Header -->\n\t<header class="form-state-header" ng-if="$ctrl.fsTitle">\n\t\t<i class="icon-{{$ctrl.fsIcon}} xxl {{$ctrl.iconTheme}}" data-cy="form-state-header-icon"></i>\n\t\t<h4 data-cy="form-state-header-title-text">{{$ctrl.fsTitle}}</h4>\n\t</header>\n\n\t<!-- Main -->\n\t<main class="form-state-main" data-cy="form-state-main" ng-transclude="main"></main>\n\n\t<!-- Footer -->\n\t<footer class="form-state-footer" ng-if="$ctrl.fsShowClose">\n\t\t<p class="s strong">\n\t\t\t<a class="strong" data-cy="form-state-close-button" href="" id="slide-in-form-close-link" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\tOk, close this window\n\t\t\t</a>\n\t\t</p>\n\t</footer>\n\n\t<!-- Form Actions -->\n\t<div class="form-actions" ng-if="$ctrl.showFormActions" ng-transclude="actions"></div>\n\n</section>\n');
$templateCache.put('components/form-wizard/formWizard.html','<div>\n\t<div ng-if="pageState === \'ready\'">\n\t\t<form-cabinet form-options="wizardOptions"></form-cabinet>\n\t</div>\n</div>\n');
$templateCache.put('components/full-page-controls/full-page-controls.component.html','<div class="full-page-controls fadeIn" ng-class="$ctrl.theme">\n\n\t<div class="full-page-controls_layout" ng-class="{\n\t\t\t\'is-primary-only\': !$ctrl.hasSecondaryActions && !$ctrl.hasTertiaryActions && $ctrl.hasPrimaryActions\n\t\t}">\n\n\t\t<!-- Secondary (Aligned left) -->\n\t\t<div class="full-page-controls_secondary-actions fadeIn" ng-if="$ctrl.hasSecondaryActions" ng-transclude="secondaryActions">\n\t\t</div>\n\n\t\t<!-- Tertiary (Aligned right) -->\n\t\t<div class="full-page-controls_tertiary-actions fadeIn" ng-if="$ctrl.hasTertiaryActions" ng-transclude="tertiaryActions">\n\t\t</div>\n\n\t\t<!-- Primary (Aligned right) -->\n\t\t<div class="full-page-controls_primary-actions fadeIn" ng-if="$ctrl.hasPrimaryActions" ng-transclude="primaryActions">\n\t\t</div>\n\t</div>\n\n\n</div>\n');
$templateCache.put('components/full-screen-modal/full-screen-modal.component.html','<div class="full-screen-modal" ng-class="$ctrl.modalOptions.styles">\n\n\t<div class="full-screen-modal_modal fadeIn">\n\t\t<header class="full-screen-modal_modal-header">\n\n\t\t\t<h6 class="full-screen-modal_header-heading" data-cy="full-screen-modal-title">\n\t\t\t\t{{$ctrl.modalOptions.title ? $ctrl.modalOptions.title : \'Preview\'}}\n\t\t\t</h6>\n\n\t\t\t<div class="full-screen-modal_header-element" ng-if="$ctrl.modalOptions.hasModalHeaderElement" ng-switch="$ctrl.modalOptions.modalKey">\n\n\t\t\t\t<!-- Gender pay gap -->\n\t\t\t\t<div pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.genderPayGapReport">\n\t\t\t\t\t<span class="is-font-white hidden-phone">Step {{$ctrl.modalOptions.steps.activeStep}} of {{$ctrl.modalOptions.steps.stepCount}}</span>&nbsp;&nbsp;\n\t\t\t\t\t<progress-steps active-step="$ctrl.modalOptions.steps.activeStep" step-count="$ctrl.modalOptions.steps.stepCount" theme="is-white is-inactive-primary-500 is-fixed-width"></progress-steps>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<a aria-label="Close modal" class="full-screen-modal_header-action fadeIn" data-cy="full-screen-modal-close" href="" ng-click="$ctrl.closeModal()" ng-if="$ctrl.modalOptions.showClose">\n\t\t\t\t<i class="icon-cross l"></i>\n\t\t\t</a>\n\n\t\t</header>\n\n\t\t<div class="full-screen-modal_main" ng-switch="$ctrl.modalOptions.modalKey">\n\n\t\t\t<!-- Address book -->\n\t\t\t<address-book pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.addressBook" address-book-options="$ctrl.modalOptions"></address-book>\n\n\t\t\t<!-- Changes table -->\n\t\t\t<changes-table pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.changesTable" changes-options="$ctrl.modalOptions"></changes-table>\n\n\t\t\t<!-- Gender pay gap -->\n\t\t\t<gender-pay-gap-report-creator pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.genderPayGapReport" report-options="$ctrl.modalOptions"></gender-pay-gap-report-creator>\n\n\t\t\t<!-- Payroll Assistant -->\n\t\t\t<payroll-assistant-full-screen pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.payrollAssistant" payroll-assistant-options="$ctrl.modalOptions"></payroll-assistant-full-screen>\n\n\t\t\t<!-- Payslip Notes -->\n\t\t\t<payslip-notes pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.payslipNotes" payslip-notes-options="$ctrl.modalOptions"></payslip-notes>\n\n\t\t\t<!-- Payslip Preview -->\n\t\t\t<payslip-preview pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.payslipPreview" payslip-preview-options="$ctrl.modalOptions"></payslip-preview>\n\n\t\t\t<!-- Report Template Creator -->\n\t\t\t<report-template-creator pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.reportTemplateCreator" report-template-creator-options="$ctrl.modalOptions"></report-template-creator>\n\n\t\t\t<!-- Report -->\n\t\t\t<div pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.report">\n\t\t\t\t<report report-options="$ctrl.modalOptions"></report>\n\t\t\t</div>\n\n\t\t\t<!-- Error -->\n\t\t\t<div pc-switch-when="$ctrl.FULL_SCREEN_MODAL_KEYS.error">\n\t\t\t\t<error-block></error-block>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/furlough-part-time-form-field/furlough-part-time-form-field.component.html','<div class="furlough-part-time-form-field" ng-class="{ \'is-paid\' : $ctrl.isPaid }">\n\t<div class="furlough-part-time-form-field_pay-period"><i class="icon-calendar m"></i>&nbsp;&nbsp;{{$ctrl.payPeriodDetail.PayPeriodDisplay}}</div>\n\t<div class="tag secondary inverse furlough-part-time-form-field_paid-tag" ng-if="$ctrl.isPaid">PAID</div>\n\t<div class="furlough-part-time-form-field_input-fields">\n\t\t<div class="furlough-part-time-form-field_input">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required has-no-margin" for="contractedHours{{$ctrl.index}}">Contracted Hours:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<number-selector-field ng-if="!$ctrl.isPaid" ng-required="true" ng-min="1" ng-model="$ctrl.payPeriodDetail.TotalHours" field-name="contractedHours{{$ctrl.index}}"></number-selector-field>\n\t\t\t\t<div name="contractedHours{{$ctrl.index}}" class="furlough-part-time-form-field_readonly-hours" ng-if="$ctrl.isPaid">{{$ctrl.payPeriodDetail.TotalHours}}</div>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'contractedHours\' + $ctrl.index].$error" ng-if="$ctrl.form[\'contractedHours\' + $ctrl.index].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a number.</p>\n\t\t\t\t<p ng-message="min">There must be at least 1 contracted hour.</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="furlough-part-time-form-field_input">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required has-no-margin" for="furloughedHours{{$ctrl.index}}">Furlough Hours:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<number-selector-field ng-if="!$ctrl.isPaid" ng-required="true" ng-min="0" ng-max="$ctrl.payPeriodDetail.TotalHours" ng-model="$ctrl.payPeriodDetail.FurloughedHours" field-name="furloughedHours{{$ctrl.index}}"></number-selector-field>\n\t\t\t\t<div name="furloughedHours{{$ctrl.index}}" class="furlough-part-time-form-field_readonly-hours" ng-if="$ctrl.isPaid">{{$ctrl.payPeriodDetail.FurloughedHours}}</div>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'furloughedHours\' + $ctrl.index].$error" ng-if="$ctrl.form[\'furloughedHours\' + $ctrl.index].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a number.</p>\n\t\t\t\t<p ng-message="max">Please ensure furloughed hours are fewer than contracted.</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-card/gender-pay-gap-report-card.component.html','<div class="gender-pay-gap-report-card fadeIn">\n\t<!-- Main content -->\n\t<div class="gender-pay-gap-report-card_main">\n\n\t\t<!-- Header - Icon and Name -->\n\t\t<div class="gender-pay-gap-report-card_header">\n\t\t\t<!-- Icon -->\n\t\t\t<div class="gender-pay-gap-report-card_icon">\n\t\t\t\t<icon-dot icon="{{ $ctrl.genderPayGapReport.GenderPayGapReportCreationComplete ? \'icon-document\' : \'icon-loading\' }}" theme="is-larger is-primary" is-light="!$ctrl.genderPayGapReport.GenderPayGapReportCreationComplete"></icon-dot>\n\t\t\t</div>\n\n\t\t\t<!-- Name and snapshot date -->\n\t\t\t<div class="gender-pay-gap-report-card_content">\n\t\t\t\t<div>\n\t\t\t\t\t<h6 class="gender-pay-gap-report-card_name" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_name">\n\t\t\t\t\t\t{{::$ctrl.genderPayGapReport.GenderPayGapReportName}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="gender-pay-gap-report-card_snapshot-date is-small" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_snapshot-date">\n\t\t\t\t\t\tSnapshot date: {{::$ctrl.genderPayGapReport.GenderPayGapReportSnapshotDateISO | dateformat : \'dayMonthYear\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Menu -->\n\t\t<div class="gender-pay-gap-report-card_menu">\n\t\t\t<dropdown-menu menu-id="gender-pay-gap-report-card-{{::$ctrl.index}}_cog-menu" menu-icon="icon-setup" menu-size="m" menu-show-chevron="false">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a class="primary is-semibold" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_continue" ng-click="$ctrl.openGenderPayGapWizard()" ng-if="!$ctrl.genderPayGapReport.GenderPayGapReportCreationComplete" title="Continue">\n\t\t\t\t\t\tContinue\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="primary is-semibold" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_view" ng-click="$ctrl.openGenderPayGapWizard(true)" ng-if="$ctrl.genderPayGapReport.GenderPayGapReportCreationComplete" title="View">\n\t\t\t\t\t\tView\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="assertive is-semibold" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_delete" ng-click="$ctrl.openDeleteGenderPayGapReportForm()" title="Delete">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<!-- Footer -->\n\t<footer class="gender-pay-gap-report-card_footer">\n\t\t<p class="is-small italic" data-cy="gender-pay-gap-report-card-{{::$ctrl.index}}_footer">\n\t\t\tCreated by {{::$ctrl.genderPayGapReport.GenderPayGapReportCreatedBy}} on {{::$ctrl.genderPayGapReport.GenderPayGapReportCreationDateISO | datetimeformat: \'detailed\'}}\n\t\t</p>\n\t</footer>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-combine-reports/gender-pay-gap-report-combine-reports.component.html','<div class="gender-pay-gap-report-combine-reports" ng-class="{\n\t\t\'is-selected\': $ctrl.report.isIncluded\n\t}">\n\t<form class="gender-pay-gap-report-combine-reports_layout no-margin fadeIn" name="$ctrl.combineReportsForm" ng-submit="$ctrl.onSubmit()" novalidate>\n\n\t\t<fieldset class="gender-pay-gap-report-combine-reports_content is-form-container">\n\n\t\t\t<div class="gender-pay-gap-report-combine-reports_title">\n\t\t\t\t<div class="checkbox-input primary-alt gender-pay-gap-report-combine-reports_checkbox">\n\t\t\t\t\t<input aria-label="Select {{::$ctrl.report.AgencyProfileName}}" class="checkbox-input-field" id="isIncluded-{{::$ctrl.index}}" name="isIncluded-{{::$ctrl.index}}" ng-model="$ctrl.report.isIncluded" type="checkbox">\n\t\t\t\t\t<label class="checkbox-input-label" for="isIncluded-{{::$ctrl.index}}"></label>\n\t\t\t\t</div>\n\t\t\t\t<i class="icon-company primary is-medium has-margin-right"></i>\n\t\t\t\t<h6>{{ $ctrl.report.AgencyProfileName }}</h6>\n\t\t\t</div>\n\n\t\t\t<div class="gender-pay-gap-report-combine-reports_details">\n\t\t\t\t<p class="is-font-greyscale-500">{{ $ctrl.report.GenderPayGapReportName}}</p>\n\t\t\t\t<p class="is-small is-font-greyscale-300">Report Name</p>\n\t\t\t</div>\n\t\t</fieldset>\n\t</form>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-creator/gender-pay-gap-report-creator.component.html','<div class="gender-pay-gap-report-creator page-template-a" ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t<div class="gender-pay-gap-report-creator_state">\n\t\t\t<div class="gender-pay-gap-report-creator_state-content">\n\t\t\t\t<div class="gender-pay-gap-report-creator_state-media">\n\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Error -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n\n\t<!-- Calculating -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.calculating">\n\t\t<div class="gender-pay-gap-report-creator_state">\n\t\t\t<div class="gender-pay-gap-report-creator_state-content">\n\t\t\t\t<div class="gender-pay-gap-report-creator_state-media">\n\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-creator_state-content">\n\t\t\t\t\t<h6>Calculating</h6>\n\t\t\t\t\t<p clas="is-small is-font-greyscale-300">This should only take a moment. Please don\'t click back or close your browser window.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="gender-pay-gap-report-creator_container fadeIn slide-in-form" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\t\t<form class="gender-pay-gap-report-creator_layout has-no-margin" name="$ctrl.genderPayGapReportForm" ng-submit="$ctrl.onFormSubmit()" novalidate>\n\n\t\t\t<header class="gender-pay-gap-report-creator_header">\n\n\t\t\t\t<div class="gender-pay-gap-report-creator_header-title" ng-if="![$ctrl.WIZARD_STEPS.settings].includes($ctrl.wizardStep)">\n\t\t\t\t\t<h6><truncate text="$ctrl.report.GenderPayGapReportName" truncate-amount="50"></truncate></h6>\n\t\t\t\t\t<p class="is-small is-font-greyscale-300">Snapshot date: {{ $ctrl.report.GenderPayGapReportSnapshotDateISO | dateformat }}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-creator_header-actions">\n\n\t\t\t\t\t<!-- Back -->\n\t\t\t\t\t<button class="fadeIn" data-cy="gpg-back-button" ng-click="$ctrl.onBackClick()" ng-if="![$ctrl.WIZARD_STEPS.settings, $ctrl.WIZARD_STEPS.noTeamMembers].includes($ctrl.wizardStep)" type="button">\n\t\t\t\t\t\tBack\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<!-- Cancel -->\n\t\t\t\t\t<button data-cy="gpg-cancel-button" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\t\t\tClose\n\t\t\t\t\t</button>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-creator_header-actions">\n\n\t\t\t\t\t<!-- Submit -->\n\t\t\t\t\t<submit-button button-id="gpg-submit-button" disable-button="$ctrl.genderPayGapReportForm.$invalid || $ctrl.isSaveActionsDisabled()" display-text="\'Save & Next\'" ng-if="$ctrl.wizardStep !== $ctrl.WIZARD_STEPS.viewReport" state="$ctrl.genderPayGapReportForm.state"></submit-button>\n\n\t\t\t\t</div>\n\n\t\t\t</header>\n\n\t\t\t<!-- Steps -->\n\t\t\t<div class="gender-pay-gap-report-creator_content" ng-switch="$ctrl.wizardStep">\n\n\t\t\t\t<!-- Settings -->\n\t\t\t\t<div class="fadeIn gender-pay-gap-report-creator_step is-form-container" data-cy="gpg-settings" pc-switch-when="$ctrl.WIZARD_STEPS.settings">\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro">\n\t\t\t\t\t\t\t<h5 class="gender-pay-gap-report-creator_intro-heading" data-cy="gpg-settings-title">Settings</h5>\n\t\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-settings-paragraph" ng-if="!$ctrl.isBulkReport">\n\t\t\t\t\t\t\t\tEnter a snapshot date and report name before moving on to review team members and their pay and weekly hours.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-settings-paragraph" ng-if="$ctrl.isBulkReport">\n\t\t\t\t\t\t\t\tEnter a snapshot date and report name before moving on to select the company reports you wish to combine.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="settingsSnapshotDate">Snapshot date:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="settingsSnapshotDate" field-required="true" field-value-iso="$ctrl.report.GenderPayGapReportSnapshotDateISO"></date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.genderPayGapReportForm.settingsSnapshotDate.$touched" ng-messages="$ctrl.genderPayGapReportForm.settingsSnapshotDate.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date (dd/mm/yyyy)</p>\n\t\t\t\t\t\t\t\t<p data-cy="gpg-settings-snapshot-date-validation-required" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter a snapshot date\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="settingsReportName">Report name:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input id="settingsReportName" name="settingsReportName" ng-model="$ctrl.report.GenderPayGapReportName" placeholder="Enter report name" required type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.genderPayGapReportForm.settingsReportName.$touched" ng-messages="$ctrl.genderPayGapReportForm.settingsReportName.$error" role="alert">\n\t\t\t\t\t\t\t\t<p data-cy="gpg-settings-report-name-validation-required" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter a report name\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No team members -->\n\t\t\t\t<div class="fadeIn gender-pay-gap-report-creator_step is-placeholder-container" data-cy="gpg-ntm" pc-switch-when="$ctrl.WIZARD_STEPS.noTeamMembers">\n\t\t\t\t\t<placeholder placeholder-graphic="team">\n\t\t\t\t\t\t<placeholder-title>No team members set up</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>Once you set up and pay your team members you\'ll be able to start including them in gender pay gap reporting.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay Elements (non-bulk) -->\n\t\t\t\t<div class="fadeIn" data-cy="gpg-pe" pc-switch-when="$ctrl.WIZARD_STEPS.payElements">\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro">\n\t\t\t\t\t\t<h5 class="gender-pay-gap-report-creator_intro-heading" data-cy="gpg-pe-title">Pay elements</h5>\n\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-pe-paragraph">\n\t\t\t\t\t\t\tWe\'ve included some pay elements in bonus and ordinary pay by default but you can make any adjustments you need to before moving on.\n\t\t\t\t\t\t\t<a class="is-underline" ng-click="$ctrl.toggleShowMore()">\n\t\t\t\t\t\t\t\t{{$ctrl.showMore ? \'Show less\' : \'Show more\'}} info\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Show More info -->\n\t\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro-more-info fadeIn" ng-if="$ctrl.showMore">\n\t\t\t\t\t\t\t<note note-theme="primary has-border">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tPay elements have been included in bonus pay by default if:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\t\t\'the pay element name contains \\\'bonus\\\'\']" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tPay elements have been included in ordinary pay by default if:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\t\t\'it attracts Employee NI\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'and it\u2019s not salary sacrifice\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'and it\u2019s not a Benefit in Kind\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'and it\u2019s not a pension-related pay element\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'and the pay element name does not contain \u2018overtime\u2019 or \\\'bonus\\\' \']" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<search-bar count="$ctrl.filteredPayElements.length" options="$ctrl.searchBarOptions.payElements"></search-bar>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-pay-element_wrapper">\n\n\t\t\t\t\t\t<gender-pay-gap-report-pay-element index="$index" dir-paginate="payElement in $ctrl.filteredPayElements = ($ctrl.payElements |\n\t\t\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.payElements.search.string\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.payElements.results.itemsPerPage\n\t\t\t\t\t\t\t" pay-element="payElement"></gender-pay-gap-report-pay-element>\n\n\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t<empty-search ng-show="$ctrl.filteredPayElements.length === 0" search-bar-options="$ctrl.searchBarOptions.payElements"></empty-search>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.payElements.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No pay elements -->\n\t\t\t\t<div class="fadeIn gender-pay-gap-report-creator_step is-placeholder-container" data-cy="gpg-npe" pc-switch-when="$ctrl.WIZARD_STEPS.noPayElements">\n\t\t\t\t\t<placeholder placeholder-graphic="no-pay-elements">\n\t\t\t\t\t\t<placeholder-title>No pay elements found</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>We couldn\'t find any pay elements to include in your report. This may be because you haven\'t made any payments to team members.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Combine reports (bulk) -->\n\t\t\t\t<div class="fadeIn" data-cy="gpg-cr" pc-switch-when="$ctrl.WIZARD_STEPS.combineReports">\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro">\n\t\t\t\t\t\t<h5 class="gender-pay-gap-report-creator_intro-heading" data-cy="gpg-cr-title">Combine reports</h5>\n\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-cr-paragraph">\n\t\t\t\t\t\t\tSelect the companies you\'d like to combine gender pay gap data for.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<search-bar count="$ctrl.genderPayGapReports.filtered.length" bulk-items="$ctrl.genderPayGapReports" options="$ctrl.searchBarOptions.companies"></search-bar>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-combine-reports_wrapper">\n\t\t\t\t\t\t<gender-pay-gap-report-combine-reports index="$index" dir-paginate="report in $ctrl.genderPayGapReports.filtered = ($ctrl.genderPayGapReports.all\n\t\t\t\t\t\t\t\t\t\t| filter : { AgencyProfileName: $ctrl.searchBarOptions.companies.search.string })\n\t\t\t\t\t\t\t\t\t\t| orderBy : $ctrl.searchBarOptions.companies.orderBy : $ctrl.searchBarOptions.companies.results.reverse\n\t\t\t\t\t\t\t\t\t\t| itemsPerPage : $ctrl.searchBarOptions.companies.results.itemsPerPage" report="report"></gender-pay-gap-report-combine-reports>\n\n\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t<empty-search ng-show="!$ctrl.genderPayGapReports.filtered.length" search-bar-options="$ctrl.searchBarOptions.companies"></empty-search>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.companies.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Excluded team -->\n\t\t\t\t<div class="fadeIn" data-cy="gpg-etm" pc-switch-when="$ctrl.WIZARD_STEPS.excludeTeamMembers">\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro">\n\t\t\t\t\t\t<h5 class="gender-pay-gap-report-creator_intro-heading" data-cy="gpg-etm-title">Excluded team members</h5>\n\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-etm-paragraph">\n\t\t\t\t\t\t\t<span ng-if="$ctrl.excludedTeamMembers.length > 0">Override any team members on statutory schedules to include them in your report.</span>\n\t\t\t\t\t\t\t<span ng-if="$ctrl.excludedTeamMembers.length !== $ctrl.team.length">Some team members may be automatically excluded based on how they\'re paid. Click \'Add team member\' to exclude anyone else.</span>\n\t\t\t\t\t\t\t<a class="is-underline" ng-click="$ctrl.toggleShowMore()">\n\t\t\t\t\t\t\t\t{{$ctrl.showMore ? \'Show less\' : \'Show more\'}} info\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Show More info -->\n\t\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro-more-info fadeIn" ng-if="$ctrl.showMore">\n\t\t\t\t\t\t\t<note note-theme="primary has-border">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tTeam members will be excluded by default if:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'they are marked as \\\'CIS\\\'\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'they are marked as \\\'Off payroll\\\'\']" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_section" ng-if="$ctrl.excludedTeamMembers.length !== $ctrl.team.length" ng-switch="$ctrl.addTeamMemberState">\n\n\t\t\t\t\t\t<!-- Inactive -->\n\t\t\t\t\t\t<div class="fadeIn" pc-switch-when="[$ctrl.ADD_TEAM_MEMBER_STATES.inactive, $ctrl.ADD_TEAM_MEMBER_STATES.loading]">\n\t\t\t\t\t\t\t<button class="is-white" data-cy="gpg-etm-add-team-member-button" ng-click="$ctrl.onAddTeamMemberClick()" ng-disabled="$ctrl.addTeamMemberState === $ctrl.ADD_TEAM_MEMBER_STATES.loading" type="button">\n\t\t\t\t\t\t\t\t<i class="icon-add button_icon-pre"></i> Add team member\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Active -->\n\t\t\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.ADD_TEAM_MEMBER_STATES.active">\n\t\t\t\t\t\t\t<gender-pay-gap-report-team-member index="\'new\'" on-delete="$ctrl.setAddTeamMemberState($ctrl.ADD_TEAM_MEMBER_STATES.inactive)" on-save="$ctrl.onNewTeamMemberSave()" team-members="$ctrl.team"></gender-pay-gap-report-team-member>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_section fadeIn" ng-show="$ctrl.excludedTeamMembers.length > 0">\n\n\t\t\t\t\t\t<search-bar count="$ctrl.excludedTeamMembers.length" options="$ctrl.searchBarOptions.teamExcludedTeamMembers"></search-bar>\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-team-member_wrapper">\n\n\t\t\t\t\t\t\t<gender-pay-gap-report-team-member index="$index" dir-paginate="teamMember in $ctrl.excludedTeamMembers = ($ctrl.team |\n\t\t\t\t\t\t\t\t\t\tgenderPayGapExcludedUsersForStep3 |\n\t\t\t\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.teamExcludedTeamMembers.search.string\n\t\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.teamExcludedTeamMembers.orderBy : $ctrl.searchBarOptions.teamExcludedTeamMembers.results.reverse |\n\t\t\t\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.teamExcludedTeamMembers.results.itemsPerPage\n\t\t\t\t\t\t\t\t" team-member="teamMember"></gender-pay-gap-report-team-member>\n\n\t\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t\t<empty-search ng-show="$ctrl.excludedTeamMembers.length === 0" search-bar-options="$ctrl.searchBarOptions.teamExcludedTeamMembers"></empty-search>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.teamExcludedTeamMembers.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay and weekly hours -->\n\t\t\t\t<div class="fadeIn" data-cy="gpg-pwh" pc-switch-when="$ctrl.WIZARD_STEPS.payAndHours">\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro">\n\t\t\t\t\t\t<h5 class="gender-pay-gap-report-creator_intro-heading" data-cy="gpg-pwh-title">Pay and weekly hours</h5>\n\t\t\t\t\t\t<p class="gender-pay-gap-report-creator_intro-paragraph" data-cy="gpg-pwh-paragraph">\n\t\t\t\t\t\t\tTeam members are displayed based on payments received and their employment type. Click \'Edit\' to override any values.\n\t\t\t\t\t\t\t<a class="is-underline" ng-click="$ctrl.toggleShowMore()">\n\t\t\t\t\t\t\t\t{{$ctrl.showMore ? \'Show less\' : \'Show more\'}} info\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Show More info -->\n\t\t\t\t\t\t<div class="gender-pay-gap-report-creator_intro-more-info fadeIn" ng-if="$ctrl.showMore">\n\t\t\t\t\t\t\t<note note-theme="primary has-border">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tTeam members are set to full-pay relevant by default unless:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'they received any statutory payments within your snapshot pay period\']" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tWeekly hours are based on a team member\'s employment type as follows:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'Standard pattern: The weekly hours saved in their work pattern\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'Pay policy: The contracted hours per week saved in their pay information\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'Non-standard pattern: The average hours for 12 weeks that ends with the last full week of the snapshot pay period\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'Net pay/Paid hourly: Displayed as \\\'0\\\' by default as weekly hour data is not held for them\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'Weekly hour data is also not held for team members of companies that only have the CIS module turned on, or only have the Pension module turned on.\']" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tPlease note that if a bonus was paid to a team member for a different time frame to your snapshot pay period, it hasn\'t been prorated and may need adjusting manually.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-creator_section fadeIn">\n\n\t\t\t\t\t\t<filter-bar filter-bar-options="$ctrl.filterBarOptions.teamOverrides"></filter-bar>\n\n\t\t\t\t\t\t<search-bar count="$ctrl.filteredIncludedTeamMembers.length" options="$ctrl.searchBarOptions.teamPayAndHours"></search-bar>\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_wrapper">\n\n\t\t\t\t\t\t\t<gender-pay-gap-report-team-member-override index="$index" on-delete="$ctrl.onTeamMemberDelete($index)" dir-paginate="teamMember in $ctrl.filteredIncludedTeamMembers = ($ctrl.team |\n\t\t\t\t\t\t\t\t\t\tgenderPayGapIncludedUsersOnly |\n\t\t\t\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.teamPayAndHours.search.string |\n\t\t\t\t\t\t\t\t\t\tfilter : $ctrl.filterBarOptions.teamOverrides.appliedFilter\n\t\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.teamPayAndHours.orderBy : $ctrl.searchBarOptions.teamPayAndHours.results.reverse |\n\t\t\t\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.teamPayAndHours.results.itemsPerPage\n\t\t\t\t\t\t\t\t" team-member="teamMember"></gender-pay-gap-report-team-member-override>\n\n\t\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t\t<empty-search ng-show="$ctrl.filteredIncludedTeamMembers.length === 0" search-bar-options="$ctrl.searchBarOptions.teamPayAndHours"></empty-search>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.teamPayAndHours.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- View report -->\n\t\t\t\t<div class="fadeIn" data-cy="gpg-vr" pc-switch-when="$ctrl.WIZARD_STEPS.viewReport">\n\t\t\t\t\t<gender-pay-gap-report-viewer report="$ctrl.report"></gender-pay-gap-report-viewer>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</form>\n\t</div>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-pay-element/gender-pay-gap-report-pay-element.component.html','<div class="gender-pay-gap-report-pay-element" data-cy="gpg-pay-element-{{$ctrl.index}}">\n\t<div class="gender-pay-gap-report-pay-element_layout">\n\n\t\t<div class="gender-pay-gap-report-pay-element_icon">\n\t\t\t<i class="icon-adjustment is-primary is-medium"></i>\n\t\t</div>\n\n\t\t<div class="gender-pay-gap-report-pay-element_title">\n\t\t\t<h6 class="gender-pay-gap-report-pay-element_heading">{{ $ctrl.payElement.Name }}</h6>\n\t\t</div>\n\n\t\t<!-- Ordinary Pay -->\n\t\t<div class="gender-pay-gap-report-pay-element_action">\n\t\t\t<toggle-input field-label="Include in ordinary pay" field-model="$ctrl.payElement.IsIncludedInOrdinaryPay" field-name="gpg-pay-element-{{ $ctrl.index }}-include-in-ordinary-pay" field-on-change="$ctrl.onToggleChange()"></toggle-input>\n\t\t</div>\n\n\t\t<!-- Bonus Pay -->\n\t\t<div class="gender-pay-gap-report-pay-element_action">\n\t\t\t<toggle-input field-label="Include in bonus pay" field-model="$ctrl.payElement.IsIncludedInBonusPay" field-name="gpg-pay-element-{{ $ctrl.index }}-include-in-bonus-pay" field-on-change="$ctrl.onToggleChange()"></toggle-input>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-team-member/gender-pay-gap-report-team-member.component.html','<div class="gender-pay-gap-report-team-member" ng-class="{\n\t\t\'is-primary\': $ctrl.includeInReport,\n\t\t\'is-form-container\': $ctrl.componentState === $ctrl.COMPONENT_STATES.editing\n\t}" ng-switch="$ctrl.componentState" data-cy="gpg-team-member-{{$ctrl.index}}">\n\t<form class="gender-pay-gap-report-team-member_layout no-margin fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.editing" name="$ctrl.editTeamMemberForm" ng-submit="$ctrl.onAddTeamMemberSubmit()" novalidate>\n\n\t\t<fieldset class="gender-pay-gap-report-team-member_content is-form-container">\n\n\t\t\t<div class="gender-pay-gap-report-team-member_field form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required is-small" for="searchTeamTeamMembers-{{$ctrl.index}}">Team member:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="pill-input-field is-compact has-icon is-primary has-darkened-border has-invalid-theme">\n\n\t\t\t\t\t\t<div class="pill-input-field-icon">\n\t\t\t\t\t\t\t<i class="icon-search"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<input autocomplete="off" autofocus class="pill-input-field-input fadeIn" id="searchTeamTeamMembers-{{$ctrl.index}}" name="searchTeamTeamMembers-{{$ctrl.index}}" ng-hide="$ctrl.teamMember" ng-model="$ctrl.searchValue" ng-required="!$ctrl.teamMember" placeholder="Search team members" type="text">\n\n\t\t\t\t\t\t<div class="pill-input-field-items" ng-if="$ctrl.teamMember">\n\t\t\t\t\t\t\t<div class="pill-input-field-item fadeIn">\n\t\t\t\t\t\t\t\t<span>{{ $ctrl.teamMember.Name }}</span>\n\n\t\t\t\t\t\t\t\t<button aria-label="Deselect team menber" class="pill-input-field-item-delete is-clear" data-cy="gpg-team-member-{{$ctrl.index}}-deselect" ng-click="$ctrl.onTeamMemberDeselectClick()" type="button">\n\t\t\t\t\t\t\t\t\t<i class="icon-plus"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="pill-input-search-results is-alternate fadeIn" click-anywhere-but-here="$ctrl.resetTeamMemberSearchTerm()" is-active="$ctrl.searchValue.length >= $ctrl.SEARCH_TERM_MIN_COUNT" ng-show="$ctrl.searchValue.length >= $ctrl.SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Team members</p>\n\t\t\t\t\t\t\t\t<button aria-label="Select team member" class="pill-input-search-result is-clear is-primary" data-cy="gpg-team-member-{{$ctrl.index}}-select-{{teamMemberIndex}}" ng-click="$ctrl.onTeamMemberClick(teamMember)" ng-if="$ctrl.filteredTeamMembers.length" ng-repeat="(teamMemberIndex, teamMember) in $ctrl.filteredTeamMembers = ($ctrl.teamMembers |\n\t\t\t\t\t\t\t\t\t\t\tgenderPayGapExclusionIncludedUsersForSearch |\n\t\t\t\t\t\t\t\t\t\t\tfilter: $ctrl.searchValue\n\t\t\t\t\t\t\t\t\t\t) | limitTo:$ctrl.SEARCH_RESULTS_LIMIT" type="button">\n\t\t\t\t\t\t\t\t\t<span class="pill-input-search-result-avatar">\n\t\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Name[0]}}" avatar-size="is-tiny" avatar-theme="is-primary" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{teamMember.Name}}</p>\n\t\t\t\t\t\t\t\t\t<span class="pill-input-search-result-action">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<p ng-if="!$ctrl.filteredTeamMembers.length"><span class="caption">No team members found</span></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.editTeamMemberForm[\'searchTeamTeamMembers-\'+ $ctrl.index].$touched" ng-messages="$ctrl.editTeamMemberForm[\'searchTeamTeamMembers-\'+ $ctrl.index].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please add a team member</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Select -->\n\t\t\t<div class="gender-pay-gap-report-team-member_field form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required is-small" for="reasonForExclusion-{{$ctrl.index}}">Reason for exclusion:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select class="gender-pay-gap-report-team-member_select" id="reasonForExclusion-{{$ctrl.index}}" name="reasonForExclusion-{{$ctrl.index}}" ng-model="$ctrl.exclusionType" ng-options="option.value as option.label for option in $ctrl.GENDER_PAY_GAP_EXCLUSION_REASON_OPTIONS" required>\n\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">\n\t\t\t\t\t\t\t-- Select a reason ---\n\t\t\t\t\t\t</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.editTeamMemberForm[\'reasonForExclusion-\'+ $ctrl.index].$touched" ng-messages="$ctrl.editTeamMemberForm[\'reasonForExclusion-\'+ $ctrl.index].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<div class="gender-pay-gap-report-team-member_actions">\n\n\t\t\t<submit-button button-id="gpg-team-member-{{$ctrl.index}}-add" button-theme="\'is-white\'" disable-button="$ctrl.editTeamMemberForm.$invalid" display-text="\'Add\'"></submit-button>\n\n\t\t\t<button class="is-white" ng-click="$ctrl.onCancelClick()" type="button" data-cy="gpg-team-member-{{$ctrl.index}}-Cancel">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t</div>\n\t</form>\n\n\t<div class="gender-pay-gap-report-team-member_layout fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.active">\n\n\t\t<div class="gender-pay-gap-report-team-member_content is-centered">\n\n\t\t\t<div class="gender-pay-gap-report-team-member_avatar">\n\t\t\t\t<avatar avatar-initial="{{$ctrl.teamMember.Name[0]}}" avatar-size="is-small" avatar-theme="is-primary" avatar-user-id="{{$ctrl.teamMember.UserID}}"></avatar>\n\t\t\t</div>\n\n\t\t\t<div class="gender-pay-gap-report-team-member_title">\n\t\t\t\t<h6>{{ $ctrl.teamMember.Name }}</h6>\n\t\t\t</div>\n\n\t\t\t<div class="gender-pay-gap-report-team-member_details">\n\n\t\t\t\t<!-- Originally excluded team members -->\n\t\t\t\t<p ng-if="$ctrl.teamMember.Original.ExclusionType !== $ctrl.GENDER_PAY_GAP_EXCLUSION_REASONS.none">{{ $ctrl.teamMember.Original.ExclusionType | genderPayGapExclusionReasonLabel | checkEmpty : \'Empty\' }}</p>\n\n\t\t\t\t<!-- Newly excluded team members -->\n\t\t\t\t<p ng-if="$ctrl.teamMember.Original.ExclusionType === $ctrl.GENDER_PAY_GAP_EXCLUSION_REASONS.none">{{ $ctrl.teamMember.ExclusionType | genderPayGapExclusionReasonLabel | checkEmpty : \'Empty\' }}</p>\n\n\t\t\t\t<p class="gender-pay-gap-report-team-member_meta is-small">Reason</p>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="gender-pay-gap-report-team-member_actions">\n\n\t\t\t<!-- Delete -->\n\t\t\t<div class="gender-pay-gap-report-team-member_action fadeIn" ng-if="!$ctrl.isDeleting">\n\t\t\t\t<a aria-label="Delete team member" class="gender-pay-gap-report-team-member_delete" data-cy="gpg-team-member-{{$ctrl.index}}-delete" ng-click="$ctrl.isDeleting = true" type="button">\n\t\t\t\t\t<i class="icon-trash m"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="gender-pay-gap-report-team-member_action fadeIn" ng-if="$ctrl.isDeleting">\n\t\t\t\t<p>\n\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t<a href="" ng-click="$ctrl.onDeleteTeamMemberClick()" data-cy="gpg-team-member-{{$ctrl.index}}-confirm">Yes</a>\n\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t<a href="" ng-click="$ctrl.isDeleting = false" data-cy="gpg-team-member-{{$ctrl.index}}-cancel">No</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-team-member-override/gender-pay-gap-report-team-member-override.component.html','<div class="gender-pay-gap-report-team-member-override" data-cy="gpg-tmo-{{$ctrl.index}}">\n\t<form class="gender-pay-gap-report-team-member-override_layout no-margin fadeIn" name="$ctrl.teamMemberOverrideForm" ng-submit="$ctrl.onSubmit()" novalidate>\n\n\t\t<fieldset class="gender-pay-gap-report-team-member-override_content">\n\n\t\t\t<div class="gender-pay-gap-report-team-member-override_profile">\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_avatar">\n\t\t\t\t\t<avatar avatar-initial="{{$ctrl.teamMember.Name[0]}}" avatar-size="is-small" avatar-theme="is-primary" avatar-user-id="{{$ctrl.teamMember.UserID}}"></avatar>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_title">\n\t\t\t\t\t<h6><truncate text="$ctrl.teamMember.Name" truncate-amount="50"></truncate></h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Edit mode -->\n\t\t\t<div class="gender-pay-gap-report-team-member-override_segments fadeIn" ng-if="$ctrl.teamMember.isEditing">\n\n\t\t\t\t<!-- Employee type -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required is-small" for="employeeType-{{ $ctrl.index }}">Employee type:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select class="gender-pay-gap-report-team-member-override_input" data-cy="gpg-tmo-{{$ctrl.index}}-employee-type" id="employeeType-{{ $ctrl.index }}" name="employeeType-{{ $ctrl.index }}" ng-model="$ctrl.teamMember.Category" ng-options="option.value as option.label for option in $ctrl.GENDER_PAY_GAP_EMPLOYEE_TYPE_OPTIONS" required>\n\t\t\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.teamMemberOverrideForm[\'employeeType-\' + $ctrl.index].$touched" ng-messages="$ctrl.teamMemberOverrideForm[\'employeeType-\' + $ctrl.index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-employee-type-validation-required" ng-message="required">Please select an option</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Orinary pay -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required is-small" for="ordinaryPay-{{ $ctrl.index }}">Ordinary pay:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="gender-pay-gap-report-team-member-override_input" data-cy="gpg-tmo-{{$ctrl.index}}-ordinary-pay" id="ordinaryPay-{{ $ctrl.index }}" name="ordinaryPay-{{ $ctrl.index }}" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="0" ng-model="$ctrl.teamMember.OrdinaryPaySnapshot" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.teamMemberOverrideForm[\'ordinaryPay-\' + $ctrl.index].$touched" ng-messages="$ctrl.teamMemberOverrideForm[\'ordinaryPay-\' + $ctrl.index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-ordinary-pay-validation-max" ng-message="max">Max. of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-ordinary-pay-validation-min" ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-ordinary-pay-validation-number" ng-message="number || pattern">Please enter a valid number (2 d.p)</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-ordinary-pay-validation-required" ng-message="required">Enter a value</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bonus pay (period) -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required is-small" for="bonusPayPeriod-{{ $ctrl.index }}">Bonus pay (period):</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="gender-pay-gap-report-team-member-override_input" data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-period" id="bonusPayPeriod-{{ $ctrl.index }}" name="bonusPayPeriod-{{ $ctrl.index }}" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="0" ng-model="$ctrl.teamMember.BonusPaySnapshot" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.teamMemberOverrideForm[\'bonusPayPeriod-\' + $ctrl.index].$touched" ng-messages="$ctrl.teamMemberOverrideForm[\'bonusPayPeriod-\' + $ctrl.index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-period-validation-max" ng-message="max">Max. of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-period-validation-min" ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-period-validation-number" ng-message="number || pattern">Please enter a valid number (2 d.p)</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-period-validation-required" ng-message="required">Enter a value</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required is-small" for="bonusPayYear-{{ $ctrl.index }}">Bonus pay (12 mos):</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="gender-pay-gap-report-team-member-override_input" data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-year" id="bonusPayYear-{{ $ctrl.index }}" name="bonusPayYear-{{ $ctrl.index }}" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="0" ng-model="$ctrl.teamMember.BonusPayAnnual" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.teamMemberOverrideForm[\'bonusPayYear-\' + $ctrl.index].$touched" ng-messages="$ctrl.teamMemberOverrideForm[\'bonusPayYear-\' + $ctrl.index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-year-validation-max" ng-message="max">Max. of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-year-validation-min" ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-year-validation-number" ng-message="number || pattern">Please enter a valid number (2 d.p)</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-bonus-pay-year-validation-required" ng-message="required">Enter a value</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required is-small" for="weeklyHours-{{ $ctrl.index }}">Weekly hours:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="gender-pay-gap-report-team-member-override_input" data-cy="gpg-tmo-{{$ctrl.index}}-weekly-hours" id="weeklyHours-{{ $ctrl.index }}" maxlength="10" name="weeklyHours-{{ $ctrl.index }}" ng-max="$root.CONFIG.maxHoursPerWeek" ng-min="0" ng-model="$ctrl.teamMember.WeeklyWorkingHours" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.teamMemberOverrideForm[\'weeklyHours-\' + $ctrl.index].$touched" ng-messages="$ctrl.teamMemberOverrideForm[\'weeklyHours-\' + $ctrl.index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-weekly-hours-validation-max" ng-message="max">Max. {{$root.CONFIG.maxHoursPerWeek}}</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-weekly-hours-validation-min" ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-weekly-hours-validation-number" ng-message="number || pattern">Please enter a valid number (2 d.p)</p>\n\t\t\t\t\t\t\t<p data-cy="gpg-tmo-{{$ctrl.index}}-weekly-hours-validation-required" ng-message="required">Enter a value</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Display -->\n\t\t\t<div class="gender-pay-gap-report-team-member-override_segments fadeIn" ng-if="!$ctrl.teamMember.isEditing">\n\n\t\t\t\t<!-- Employee Type -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_display">\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn" data-cy="gpg-tmo-{{ $ctrl.index }}-value-employee-type" ng-if="!$ctrl.canUpdate || $ctrl.teamMember.Category === $ctrl.teamMember.Original.Category">{{ $ctrl.teamMember.Category | genderPayGapEmployeeTypeLabel }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn is-highlighted" data-cy="gpg-tmo-{{ $ctrl.index }}-value-employee-type" ng-if="$ctrl.canUpdate && $ctrl.teamMember.Category !== $ctrl.teamMember.Original.Category" tooltip tooltip-text="Changed from: {{ $ctrl.teamMember.Original.Category | genderPayGapEmployeeTypeLabel }}">{{ $ctrl.teamMember.Category | genderPayGapEmployeeTypeLabel }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-label">Employee type</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Ordinary pay -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_display">\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn" data-cy="gpg-tmo-{{ $ctrl.index }}-value-ordinary-pay" ng-if="!$ctrl.canUpdate || $ctrl.teamMember.OrdinaryPaySnapshot === $ctrl.teamMember.Original.OrdinaryPaySnapshot">{{ $ctrl.teamMember.OrdinaryPaySnapshot | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn is-highlighted" data-cy="gpg-tmo-{{ $ctrl.index }}-value-ordinary-pay" ng-if="$ctrl.canUpdate &&$ctrl.teamMember.OrdinaryPaySnapshot !== $ctrl.teamMember.Original.OrdinaryPaySnapshot" tooltip tooltip-text="Changed from: {{ $ctrl.teamMember.Original.OrdinaryPaySnapshot | monetise }}">{{ $ctrl.teamMember.OrdinaryPaySnapshot | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-label">Ordinary pay</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bonus pay (period) -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_display">\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn" data-cy="gpg-tmo-{{ $ctrl.index }}-value-bonus-pay-period" ng-if="!$ctrl.canUpdate || $ctrl.teamMember.BonusPaySnapshot === $ctrl.teamMember.Original.BonusPaySnapshot">{{ $ctrl.teamMember.BonusPaySnapshot | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn is-highlighted" data-cy="gpg-tmo-{{ $ctrl.index }}-value-bonus-pay-period" ng-if="$ctrl.canUpdate && $ctrl.teamMember.BonusPaySnapshot !== $ctrl.teamMember.Original.BonusPaySnapshot" tooltip tooltip-text="Changed from: {{ $ctrl.teamMember.Original.BonusPaySnapshot | monetise }}">{{ $ctrl.teamMember.BonusPaySnapshot | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-label">Bonus pay (period)</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bonus pay (12 mos) -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_display">\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn" data-cy="gpg-tmo-{{ $ctrl.index }}-value-bonus-pay-year" ng-if="!$ctrl.canUpdate || $ctrl.teamMember.BonusPayAnnual === $ctrl.teamMember.Original.BonusPayAnnual">{{ $ctrl.teamMember.BonusPayAnnual | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn is-highlighted" data-cy="gpg-tmo-{{ $ctrl.index }}-value-bonus-pay-year" ng-if="$ctrl.canUpdate && $ctrl.teamMember.BonusPayAnnual !== $ctrl.teamMember.Original.BonusPayAnnual" tooltip tooltip-text="Changed from: {{ $ctrl.teamMember.Original.BonusPayAnnual | monetise }}">{{ $ctrl.teamMember.BonusPayAnnual | monetise }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-label">Bonus pay (12 mos)</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Weekly hours -->\n\t\t\t\t<div class="gender-pay-gap-report-team-member-override_segment">\n\t\t\t\t\t<div class="gender-pay-gap-report-team-member-override_display">\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn" data-cy="gpg-tmo-{{ $ctrl.index }}-value-weekly-hours" ng-if="!$ctrl.canUpdate || $ctrl.teamMember.WeeklyWorkingHours === $ctrl.teamMember.Original.WeeklyWorkingHours">{{ $ctrl.teamMember.WeeklyWorkingHours }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-value fadeIn is-highlighted" data-cy="gpg-tmo-{{ $ctrl.index }}-value-weekly-hours" ng-if="$ctrl.canUpdate && $ctrl.teamMember.WeeklyWorkingHours !== $ctrl.teamMember.Original.WeeklyWorkingHours" tooltip tooltip-text="Changed from: {{ $ctrl.teamMember.Original.WeeklyWorkingHours }}">{{ $ctrl.teamMember.WeeklyWorkingHours }}</p>\n\n\t\t\t\t\t\t<p class="gender-pay-gap-report-team-member-override_display-label">Weekly hours</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<div class="gender-pay-gap-report-team-member-override_actions is-editing-mode" ng-if="$ctrl.teamMember.isEditing">\n\n\t\t\t<submit-button button-id="gpg-tmo-{{$ctrl.index}}-add" button-theme="\'is-white\'" disable-button="$ctrl.teamMemberOverrideForm.$invalid" display-text="\'Save\'"></submit-button>\n\n\t\t\t<button class="is-white" data-cy="gpg-tmo-{{$ctrl.index}}-cancel" ng-click="$ctrl.onCancelClick()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t</div>\n\n\t\t<div class="gender-pay-gap-report-team-member-override_actions" ng-if="$ctrl.canUpdate && !$ctrl.teamMember.isEditing">\n\n\t\t\t<button class="is-white" data-cy="gpg-tmo-{{$ctrl.index}}-edit" ng-click="$ctrl.onEditClick()" type="button">\n\t\t\t\tEdit\n\t\t\t</button>\n\n\t\t</div>\n\t</form>\n</div>\n');
$templateCache.put('components/gender-pay-gap-report-viewer/gender-pay-gap-report-viewer.component.html','<div class="gender-pay-gap-report-viewer">\n\t<div class="gender-pay-gap-report-viewer_tabs">\n\t\t<tab-bar on-tab-selected="$ctrl.setActiveTab" tab-bar-def="$ctrl.tabBarDef"></tab-bar>\n\t</div>\n\n\t<div class="gender-pay-gap-report-viewer_content" ng-switch="$ctrl.activeTab">\n\n\t\t<!-- Hourly/Bonus pay -->\n\t\t<div class="gender-pay-gap-report-viewer_page fadeIn" pc-switch-when="$ctrl.TABS.hourlyBonusPay">\n\n\t\t\t<div class="gender-pay-gap-report-viewer_layout">\n\t\t\t\t<div class="gender-pay-gap-report-viewer_header">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_header-title">\n\t\t\t\t\t\t<h5>Hourly pay</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_header-download-button">\n\t\t\t\t\t\t<!-- Print -->\n\t\t\t\t\t\t<button class="is-tertiary" data-cy="gpg-download-button" ng-click="$root.print()" type="button">\n\t\t\t\t\t\t\tDownload\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Mean hourly Pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary has-print-border" data-cy="gpg-report-mean-hourly-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t<h6>Mean hourly pay</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-hourly-pay-female">{{ $ctrl.report.MeanAvgHourlyPayFemale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Female</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-hourly-pay-male">{{ $ctrl.report.MeanAvgHourlyPayMale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Male</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-top">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-hourly-pay-difference">\n\t\t\t\t\t\t\t\t\t\t<span class="gender-pay-gap-report-viewer_stat-difference" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': $ctrl.report.MeanAvgHourlyPayPercentageDifference > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-secondary\': $ctrl.report.MeanAvgHourlyPayPercentageDifference === 0\n\t\t\t\t\t\t\t\t\t\t\t}" tooltip tooltip-text="{{:: $ctrl.getTooltopText($ctrl.report.MeanAvgHourlyPayPercentageDifference, $ctrl.TOOLTIP_COMMS_TYPE.hourly) }}">{{ ($ctrl.report.MeanAvgHourlyPayPercentageDifference > 0 ? \'+\' : \'\') + $ctrl.report.MeanAvgHourlyPayPercentageDifference }}%</span>\n\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Difference</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Median hourly pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary has-print-border" data-cy="gpg-report-median-hourly-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t<h6>Median hourly pay</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-hourly-pay-female">{{ $ctrl.report.MedianAvgHourlyPayFemale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Female</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-hourly-pay-male">{{ $ctrl.report.MedianAvgHourlyPayMale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Male</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-top">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-hourly-pay-difference">\n\t\t\t\t\t\t\t\t\t\t<span class="gender-pay-gap-report-viewer_stat-difference" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': $ctrl.report.MedianAvgHourlyPayPercentageDifference > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-secondary\': $ctrl.report.MedianAvgHourlyPayPercentageDifference === 0\n\t\t\t\t\t\t\t\t\t\t\t}" tooltip tooltip-text="{{:: $ctrl.getTooltopText($ctrl.report.MedianAvgHourlyPayPercentageDifference, $ctrl.TOOLTIP_COMMS_TYPE.hourly) }}">{{ ($ctrl.report.MedianAvgHourlyPayPercentageDifference > 0 ? \'+\' : \'\') + $ctrl.report.MedianAvgHourlyPayPercentageDifference }}%</span>\n\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Difference</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Upper quarter -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-quarter is-secondary" data-cy="gpg-report-upper-quarter">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Upper quarter</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoints">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary">\n\t\t\t\t\t\t\t\t\t\tFemale: <span data-cy="gpg-report-upper-quarter-female-count">{{ $ctrl.report.UpperQuartileFemaleCount }}</span> (<span data-cy="gpg-report-upper-quarter-female-percentage">{{ $ctrl.report.UpperQuartilePercentageFemale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary is-light">\n\t\t\t\t\t\t\t\t\t\tMale: <span data-cy="gpg-report-upper-quarter-male-count">{{ $ctrl.report.UpperQuartileMaleCount }}</span> (<span data-cy="gpg-report-upper-quarter-male-percentage">{{ $ctrl.report.UpperQuartilePercentageMale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Total: <span data-cy="gpg-report-upper-quarter-total">{{ $ctrl.report.UpperQuartileFemaleCount + $ctrl.report.UpperQuartileMaleCount }}</span></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-upper-quarter"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Upper-middle quarter -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-quarter is-secondary" data-cy="gpg-report-upper-middle-quarter">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Upper-middle quarter</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoints">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary">\n\t\t\t\t\t\t\t\t\t\tFemale: <span data-cy="gpg-report-upper-middle-quarter-female-count">{{ $ctrl.report.UpperMiddleQuartileFemaleCount }}</span> (<span data-cy="gpg-report-upper-middle-quarter-female-percentage">{{ $ctrl.report.UpperMiddleQuartilePercentageFemale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary is-light">\n\t\t\t\t\t\t\t\t\t\tMale: <span data-cy="gpg-report-upper-middle-quarter-male-count">{{ $ctrl.report.UpperMiddleQuartileMaleCount }}</span> (<span data-cy="gpg-report-upper-middle-quarter-male-percentage">{{ $ctrl.report.UpperMiddleQuartilePercentageMale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Total: <span data-cy="gpg-report-upper-middle-quarter-total">{{ $ctrl.report.UpperMiddleQuartileFemaleCount + $ctrl.report.UpperMiddleQuartileMaleCount }}</span></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-upper-middle-quarter"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Lower-middle quarter -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-quarter is-secondary" data-cy="gpg-report-lower-middle-quarter">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Lower-middle quarter</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoints">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary">\n\t\t\t\t\t\t\t\t\t\tFemale: <span data-cy="gpg-report-lower-middle-quarter-female-count">{{ $ctrl.report.LowerMiddleQuartileFemaleCount }}</span> (<span data-cy="gpg-report-lower-middle-quarter-female-percentage">{{ $ctrl.report.LowerMiddleQuartilePercentageFemale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary is-light">\n\t\t\t\t\t\t\t\t\t\tMale: <span data-cy="gpg-report-lower-middle-quarter-male-count">{{ $ctrl.report.LowerMiddleQuartileMaleCount }}</span> (<span data-cy="gpg-report-lower-middle-quarter-male-percentage">{{ $ctrl.report.LowerMiddleQuartilePercentageMale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Total: <span data-cy="gpg-report-lower-middle-quarter-total">{{ $ctrl.report.LowerMiddleQuartileFemaleCount + $ctrl.report.LowerMiddleQuartileMaleCount }}</span></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-lower-middle-quarter"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Lower quarter -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-quarter is-secondary" data-cy="gpg-report-lower-quarter">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Lower quarter</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoints">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary">\n\t\t\t\t\t\t\t\t\t\tFemale: <span data-cy="gpg-report-lower-quarter-female-count">{{ $ctrl.report.LowerQuartileFemaleCount }}</span> (<span data-cy="gpg-report-lower-quarter-female-percentage">{{ $ctrl.report.LowerQuartilePercentageFemale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_datapoint is-secondary is-light">\n\t\t\t\t\t\t\t\t\t\tMale: <span data-cy="gpg-report-lower-quarter-male-count">{{ $ctrl.report.LowerQuartileMaleCount }}</span> (<span data-cy="gpg-report-lower-quarter-male-percentage">{{ $ctrl.report.LowerQuartilePercentageMale }}</span>%)\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Total: <span data-cy="gpg-report-lower-quarter-total">{{ $ctrl.report.LowerQuartileFemaleCount + $ctrl.report.LowerQuartileMaleCount }}</span></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-lower-quarter"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="gender-pay-gap-report-viewer_header">\n\t\t\t\t\t<h5>Bonus pay</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Mean bonus Pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary has-print-border" data-cy="gpg-report-mean-bonus-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t<h6>Mean bonus pay</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-bonus-pay-female">{{ $ctrl.report.MeanAvgBonusPayFemale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Female</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-bonus-pay-male">{{ $ctrl.report.MeanAvgBonusPayMale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Male</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-top">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-mean-bonus-pay-difference">\n\t\t\t\t\t\t\t\t\t\t<span class="gender-pay-gap-report-viewer_stat-difference" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': $ctrl.report.MeanAvgBonusPayPercentageDifference > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-secondary\': $ctrl.report.MeanAvgBonusPayPercentageDifference === 0\n\t\t\t\t\t\t\t\t\t\t\t}" tooltip tooltip-text="{{:: $ctrl.getTooltopText($ctrl.report.MeanAvgBonusPayPercentageDifference, $ctrl.TOOLTIP_COMMS_TYPE.bonus) }}">{{ ($ctrl.report.MeanAvgBonusPayPercentageDifference > 0 ? \'+\' : \'\') + $ctrl.report.MeanAvgBonusPayPercentageDifference }}%</span>\n\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Difference</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Median bonus pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary has-print-border" data-cy="gpg-report-median-bonus-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t<h6>Median bonus pay</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-bonus-pay-female">{{ $ctrl.report.MedianAvgBonusPayFemale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Female</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-bonus-pay-male">{{ $ctrl.report.MedianAvgBonusPayMale | monetise }}</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Male</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-top">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-median-bonus-pay-difference">\n\t\t\t\t\t\t\t\t\t\t<span class="gender-pay-gap-report-viewer_stat-difference" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': $ctrl.report.MedianAvgBonusPayPercentageDifference > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-secondary\': $ctrl.report.MedianAvgBonusPayPercentageDifference === 0\n\t\t\t\t\t\t\t\t\t\t\t}" tooltip tooltip-text="{{:: $ctrl.getTooltopText($ctrl.report.MedianAvgBonusPayPercentageDifference, $ctrl.TOOLTIP_COMMS_TYPE.bonus) }}">{{ ($ctrl.report.MedianAvgBonusPayPercentageDifference > 0 ? \'+\' : \'\') + $ctrl.report.MedianAvgBonusPayPercentageDifference }}%</span>\n\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">Difference</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Number receiving bonus pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary" data-cy="gpg-report-number-receiving-bonus-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Number receiving bonus pay</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-number-receiving-bonus-pay-female">{{ $ctrl.report.BonusPayRecipientsFemaleCount }}</h4>\n\t\t\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">\n\t\t\t\t\t\t\t\t\t\t\t\t</p><div class="gender-pay-gap-report-viewer_datapoint is-primary">\n\t\t\t\t\t\t\t\t\t\t\t\t\tFemale\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-number-receiving-bonus-pay-male">{{ $ctrl.report.BonusPayRecipientsMaleCount }}</h4>\n\t\t\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">\n\t\t\t\t\t\t\t\t\t\t\t\t</p><div class="gender-pay-gap-report-viewer_datapoint is-primary is-light">\n\t\t\t\t\t\t\t\t\t\t\t\t\tMale\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-number-receiving-bonus-pay"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Percentage receiving bonus pay -->\n\t\t\t\t<div class="gender-pay-gap-report-viewer_card is-size-half is-primary" data-cy="gpg-report-percentage-receiving-bonus-pay">\n\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-content">\n\n\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves">\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-large">\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_card-header">\n\t\t\t\t\t\t\t\t\t<h6>Percentage receiving bonus pay</h6>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments">\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment">\n\t\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-percentage-receiving-bonus-pay-female">{{ ($ctrl.report.BonusPayRecipientsFemalePercentage > 0 ? \'+\' : \'\') + $ctrl.report.BonusPayRecipientsFemalePercentage }}%</h4>\n\t\t\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">\n\t\t\t\t\t\t\t\t\t\t\t\t</p><div class="gender-pay-gap-report-viewer_datapoint is-primary">\n\t\t\t\t\t\t\t\t\t\t\t\t\tFemale\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_segments-segment has-print-border-left">\n\t\t\t\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_stat">\n\t\t\t\t\t\t\t\t\t\t\t<h4 class="gender-pay-gap-report-viewer_stat-value" data-cy="gpg-report-percentage-receiving-bonus-pay-male">{{ ($ctrl.report.BonusPayRecipientsMalePercentage > 0 ? \'+\' : \'\') + $ctrl.report.BonusPayRecipientsMalePercentage }}%</h4>\n\t\t\t\t\t\t\t\t\t\t\t<p class="gender-pay-gap-report-viewer_label">\n\t\t\t\t\t\t\t\t\t\t\t\t</p><div class="gender-pay-gap-report-viewer_datapoint is-primary is-light">\n\t\t\t\t\t\t\t\t\t\t\t\t\tMale\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="gender-pay-gap-report-viewer_halves-half is-chart">\n\t\t\t\t\t\t\t\t<canvas class="gender-pay-gap-report-viewer_doughnut" id="gpg-percentage-receiving-bonus-pay"></canvas>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Team members -->\n\t\t<div class="gender-pay-gap-report-viewer_page fadeIn" pc-switch-when="$ctrl.TABS.teamMembers">\n\n\t\t\t<div class="gender-pay-gap-report-viewer_header">\n\t\t\t\t<div class="gender-pay-gap-report-viewer_header-title">\n\t\t\t\t\t<h5>Team members</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="gender-pay-gap-report-viewer_header-download-button">\n\t\t\t\t\t<!-- Print -->\n\t\t\t\t\t<button class="is-tertiary" data-cy="gpg-download-button" ng-click="$root.print()" type="button">\n\t\t\t\t\t\tDownload\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<search-bar count="$ctrl.filteredUsers.length" options="$ctrl.searchBarOptions"></search-bar>\n\n\t\t\t<div class="gender-pay-gap-report-team-member-override_wrapper no-print">\n\n\t\t\t\t<gender-pay-gap-report-team-member-override can-update="false" index="$index" dir-paginate="teamMember in $ctrl.filteredUsers = ($ctrl.report.Users |\n\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" team-member="teamMember"></gender-pay-gap-report-team-member-override>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="$ctrl.filteredUsers.length === 0" search-bar-options="$ctrl.searchBarOptions"></empty-search>\n\n\t\t\t</div>\n\n\t\t\t<!-- For printing only - list all team members -->\n\t\t\t<div class="gender-pay-gap-report-team-member-override_wrapper print-only">\n\t\t\t\t<gender-pay-gap-report-team-member-override can-update="false" index="$index" ng-repeat="teamMember in $ctrl.report.Users | orderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse" team-member="teamMember"></gender-pay-gap-report-team-member-override>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</div>\n\n\t</div>\n</div>\n');
$templateCache.put('components/gradient-bar/gradientBarComponent.html','<div class="gradient-bar" ng-class="template" ng-style="{\n\t\t\'height\': height + \'px\'\n\t}">\n\t<div class="gradient-bar__solid" ng-if="colour1 && !colour2" style="--gradient-bar-background-color: {{colour1}};\n\t\t\theight: {{height}}px;"></div>\n\n\t<div class="gradient-bar__solid" ng-if="colour2 && !colour1" style="--gradient-bar-background-color: {{colour2}};\n\t\t\theight: {{height}}px;"></div>\n\n\t<div class="gradient-bar__gradient" ng-if="colour1 && colour2" style="--gradient-bar-background-color-1: {{colour1}};\n\t\t\t--gradient-bar-background-color-2: {{colour2}};\n\t\t\theight: {{height}}px;"></div>\n\n</div>\n');
$templateCache.put('components/graphic-card/graphic-card.component.html','<div class="graphic-card" ng-class="[$ctrl.theme, $ctrl.layout]" ng-switch="$ctrl.layout">\n\n\t<div class="graphic-card_wrapper" ng-switch-when="is-inline">\n\t\n\t\t<!-- Copy -->\n\t\t<article class="graphic-card_copy">\n\t\t\t<div ng-transclude="copy"></div>\n\t\t</article>\n\n\t\t<!-- Graphic -->\n\t\t<div class="graphic-card_graphic">\n\t\t\t<img alt="" class="graphic-card_graphic-img" src="images/graphics/{{$ctrl.graphicKey}}.png">\n\t\t</div>\n\t</div>\n\n\t<div class="graphic-card_wrapper" ng-switch-when="is-stacked">\n\n\t\t<!-- Graphic -->\n\t\t<div class="graphic-card_graphic">\n\t\t\t<img alt="" class="graphic-card_graphic-img" src="images/graphics/{{$ctrl.graphicKey}}.png">\n\t\t</div>\n\t\n\t\t<!-- Copy -->\n\t\t<article class="graphic-card_copy">\n\t\t\t<div ng-transclude="copy"></div>\n\t\t</article>\n\t</div>\n\n</div>\n');
$templateCache.put('components/help-and-support-panel/help-and-support-panel.component.html','<div class="help-and-support-panel page-template-e fadeIn {{$ctrl.displayMode}}" ng-class="{\n\t\t\'is-closed\': $ctrl.isClosed\n\t}">\n\t<button aria-label="Set display mode" class="help-and-support-panel_close is-clear is-icon-only" ng-click="$ctrl.closePanel($ctrl)" ng-if="$ctrl.displayMode !== $ctrl.HELP_AND_SUPPORT_DISPLAY_OPTIONS.fullPage" type="button">\n\t\t<i class="icon-chevron-{{$ctrl.displayMode === $ctrl.HELP_AND_SUPPORT_DISPLAY_OPTIONS.inlineLeft ? \'left\' : \'right\'}} xl"></i>\n\t</button>\n\t<div class="page-template-e_wrapper">\n\n\t\t<header class="page-template-e_header">\n\t\t\t<form class="fadeIn help-and-support-panel_search" name="helpAndSupportSearchForm" ng-submit="$ctrl.search($ctrl, $ctrl.searchTerm)" novalidate>\n\t\t\t\t<h2 class="page-template-e_header-title">\n\t\t\t\t\t<i class="icon-support page-template-e_header-title-icon"></i>\n\t\t\t\t\t<span class="page-template-e_header-title-name">Help and Support</span>\n\t\t\t\t</h2>\n\t\t\t\t<div class="page-template-e_header-search-bar">\n\t\t\t\t\t<search-box input-id="help-and-support-search-box" ng-model="$ctrl.searchTerm" on-clear="$ctrl.goHome($ctrl)" search-for="articles" show-clear="true"></search-box>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</header>\n\n\t\t<loading-block class="help-and-support-panel_loading" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.loading"></loading-block>\n\n\t\t<div class="help-and-support-panel_content" ng-if="\n\t\t\t\t$ctrl.componentState === $ctrl.COMPONENT_STATES.ready ||\n\t\t\t\t$ctrl.componentState === $ctrl.COMPONENT_STATES.secondaryContentLoading\n\t\t\t">\n\t\t\t<!-- Back to search results link. Applicable when a search has been made, and the current view isn\'t the search results -->\n\t\t\t<div class="help-and-support-panel_navigation">\n\t\t\t\t<a href="" ng-click="$ctrl.returnToSearchResults($ctrl)" ng-if="$ctrl.canReturnToSearchResults && $ctrl.viewState !== $ctrl.HELP_AND_SUPPORT_VIEWS.search">\n\t\t\t\t\t<i class="icon-back m is-primary"></i>&nbsp;&nbsp;Back to search results\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- Breadcrumb. Only applicable when there\'s more than one item; i.e. don\'t show at the top Help and Support level.\n\t\t\t\t (This can also be completely disabled in helpAndSupportOptions) -->\n\t\t\t<div class="help-and-support-panel_breadcrumb" ng-if="$ctrl.breadcrumb.length > 1 && $ctrl.showBreadcrumb && $ctrl.helpAndSupportOptions.showBreadcrumb">\n\t\t\t\t<div class="help-and-support-panel_breadcrumb-item" ng-repeat="category in $ctrl.breadcrumb">\n\t\t\t\t\t<a aria-label="Change category" class="underline" href="" ng-bind-html="category.name" ng-click="$ctrl.changeCategory($ctrl, category.id)" ng-if="!$last"></a>\n\t\t\t\t\t<span ng-bind-html="category.name" ng-if="$last"></span>\n\t\t\t\t\t<div class="help-and-support-panel_breadcrumb-separator" ng-if="!$last">\n\t\t\t\t\t\t<icon class="icon-chevron-right"></icon>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Browse categories -->\n\t\t\t<div class="help-and-support-panel_main" ng-if="$ctrl.viewState === $ctrl.HELP_AND_SUPPORT_VIEWS.browse">\n\t\t\t\t<div class="help-and-support-panel_main">\n\t\t\t\t\t<!-- Help and support headline categories (Not displayed for inline help and support) -->\n\t\t\t\t\t<div class="help-and-support-panel_section" ng-if="\n\t\t\t\t\t\t\t$ctrl.headlineCategories.length > 0 &&\n\t\t\t\t\t\t\t!$ctrl.isInline\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<div class="help-and-support-panel_category-cards is-headline">\n\t\t\t\t\t\t\t<support-category-card category="category" layout="$ctrl.layout" ng-repeat="category in $ctrl.headlineCategories" on-category-click="$ctrl.changeCategory($ctrl, category.id)"></support-category-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Help and support categories. (Not displayed for inline help and support) -->\n\t\t\t\t\t<div class="help-and-support-panel_section" ng-if="\n\t\t\t\t\t\t\t$ctrl.filteredCategories.length > 0 &&\n\t\t\t\t\t\t\t!$ctrl.isInline\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title" ng-if="$ctrl.currentCategory.id === 0">\n\t\t\t\t\t\t\tCategories\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title" ng-if="$ctrl.currentCategory.id !== 0">\n\t\t\t\t\t\t\t<span ng-bind-html="$ctrl.currentCategory.name"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_category-cards" ng-if="$ctrl.filteredCategories.length > 0 && !$ctrl.isInline">\n\t\t\t\t\t\t\t<support-category-card category="category" layout="$ctrl.layout" ng-repeat="category in $ctrl.filteredCategories" on-category-click="$ctrl.changeCategory($ctrl, category.id)">\n\t\t\t\t\t\t\t</support-category-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Popular articles (when at top category level) or articles for current category (when category selected) -->\n\t\t\t\t\t<div class="help-and-support-panel_section">\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title" ng-if="$ctrl.currentCategory.id === 0">\n\t\t\t\t\t\t\tPopular support articles\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title" ng-if="\n\t\t\t\t\t\t\t\t$ctrl.currentCategory.id !== 0 &&\n\t\t\t\t\t\t\t\t$ctrl.supportArticles.length !== 0 &&\n\t\t\t\t\t\t\t\t!$ctrl.currentCategory.isPrivate\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<span ng-bind-html="$ctrl.currentCategory.name"></span>\n\t\t\t\t\t\t\t<span ng-if="!$ctrl.currentCategory.isHeadline">&nbsp;articles</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<loading-block ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.secondaryContentLoading"></loading-block>\n\t\t\t\t\t\t<div ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.ready">\n\t\t\t\t\t\t\t<div ng-if="$ctrl.supportArticles.length > 0">\n\t\t\t\t\t\t\t\t<div class="help-and-support-panel_support-article-cards">\n\t\t\t\t\t\t\t\t\t<support-article-card ng-repeat="supportArticle in $ctrl.supportArticles" on-click="$ctrl.openHelpAndSupportArticle($ctrl, supportArticle)" support-article="supportArticle" view-mode="$ctrl.isInline ? $ctrl.SUPPORT_ARTICLE_CARD_VIEW_MODES.horizontal : $ctrl.SUPPORT_ARTICLE_CARD_VIEW_MODES.responsive"></support-article-card>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- No articles or categories -->\n\t\t\t\t\t\t\t<placeholder ng-if="$ctrl.supportArticles.length === 0 && $ctrl.filteredCategories.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-search-results">\n\t\t\t\t\t\t\t\t<placeholder-title>Nothing found in category\n\t\t\t\t\t\t\t\t\t<strong class="italic">\n\t\t\t\t\t\t\t\t\t\t&lsquo;<span ng-bind-html="$ctrl.currentCategory.name"></span>&rsquo;\n\t\t\t\t\t\t\t\t\t</strong>\n\t\t\t\t\t\t\t\t</placeholder-title>\n\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t<p>Unfortunately there are no articles or subcategories to see here.</p>\n\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t\t\t\t<a class="is-primary strong s" href="" ng-click="$ctrl.changeCategory($ctrl, $ctrl.currentCategory.parentId)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-chevron-left"></i>&nbsp;&nbsp;Go back\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Latest articles view -->\n\t\t\t<div class="help-and-support-panel_main" ng-if="$ctrl.viewState === $ctrl.HELP_AND_SUPPORT_VIEWS.latest">\n\t\t\t\t<div class="help-and-support-panel_section">\n\t\t\t\t\t<div class="help-and-support-panel_section-title">Latest features and updates</div>\n\t\t\t\t\t<div class="help-and-support-panel_group" ng-repeat="articleGroup in $ctrl.latestSupportArticleGroups">\n\t\t\t\t\t\t<div class="help-and-support-panel_group-heading">\n\t\t\t\t\t\t\t<span class="tag is-primary">{{articleGroup.title}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_support-article-cards four">\n\t\t\t\t\t\t\t<support-article-card ng-repeat="supportArticle in articleGroup.articles" on-click="$ctrl.openHelpAndSupportArticle($ctrl, supportArticle, $ctrl.HELP_AND_SUPPORT_SPECIAL_CATEGORY_IDS.latest)" support-article="supportArticle" view-mode="$ctrl.SUPPORT_ARTICLE_CARD_VIEW_MODES.vertical"></support-article-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Tags -->\n\t\t\t<div class="help-and-support-panel_main" ng-if="$ctrl.viewState === $ctrl.HELP_AND_SUPPORT_VIEWS.tags">\n\t\t\t\t<div class="help-and-support-panel_section" ng-if="$ctrl.supportArticles.length !== 0">\n\t\t\t\t\t<div class="help-and-support-panel_section-title">Suggested articles for this area</div>\n\t\t\t\t\t<div class="help-and-support-panel_support-article-cards">\n\t\t\t\t\t\t<support-article-card ng-repeat="supportArticle in $ctrl.supportArticles" on-click="$ctrl.openHelpAndSupportArticle($ctrl, supportArticle)" support-article="supportArticle"></support-article-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No results for tags -->\n\t\t\t\t<placeholder ng-if="$ctrl.supportArticles.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-search-results">\n\t\t\t\t\t<placeholder-title>There are currently no suggested articles for this area</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>Please use the search bar to find the articles you are looking for, or if you need help, please contact our support team.</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\n\t\t\t<!-- Article display -->\n\t\t\t<div class="help-and-support-panel_main" ng-if="$ctrl.viewState === $ctrl.HELP_AND_SUPPORT_VIEWS.article">\n\t\t\t\t<div class="help-and-support-panel_article">\n\t\t\t\t\t<div class="help-and-support-panel_navigation">\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.goHome($ctrl)" ng-if="$ctrl.currentCategory.isPrivate">\n\t\t\t\t\t\t\t<i class="icon-back m is-primary"></i>&nbsp;&nbsp;Back to articles\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<support-article article="$ctrl.article" category-id="$ctrl.currentCategory.id" is-inline="$ctrl.isInline" show-link-to-full-page="$ctrl.helpAndSupportOptions.showLinkToFullPage"></support-article>\n\t\t\t\t\t<loading-block ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.secondaryContentLoading"></loading-block>\n\t\t\t\t\t<div class="help-and-support-panel_section" ng-if="\n\t\t\t\t\t\t\t$ctrl.helpAndSupportOptions.showRelated &&\n\t\t\t\t\t\t\t$ctrl.supportArticles.length !== 0 &&\n\t\t\t\t\t\t\t$ctrl.componentState === $ctrl.COMPONENT_STATES.ready\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title">Related</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_support-article-cards">\n\t\t\t\t\t\t\t<support-article-card ng-repeat="supportArticle in $ctrl.supportArticles" on-click="$ctrl.openHelpAndSupportArticle($ctrl, supportArticle)" support-article="supportArticle" view-mode="$ctrl.SUPPORT_ARTICLE_CARD_VIEW_MODES.vertical"></support-article-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Search results -->\n\t\t\t<div class="help-and-support-panel_main" ng-if="$ctrl.viewState === $ctrl.HELP_AND_SUPPORT_VIEWS.search">\n\t\t\t\t<div class="help-and-support-panel_section">\n\t\t\t\t\t<div class="help-and-support-panel_section-header">\n\t\t\t\t\t\t<div class="help-and-support-panel_section-title">Search results for \'{{$ctrl.searchString}}\'</div>\n\t\t\t\t\t\t<div class="help-and-support-panel_section-action">\n\t\t\t\t\t\t\t<a class="is-primary strong s" href="" ng-click="$ctrl.goHome($ctrl)">\n\t\t\t\t\t\t\t\t<i class="icon-loading"></i>&nbsp;&nbsp;Reset search\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="help-and-support-panel_support-article-cards" ng-if="$ctrl.supportArticles.length">\n\t\t\t\t\t\t<support-article-card ng-repeat="supportArticle in $ctrl.supportArticles" on-click="$ctrl.openHelpAndSupportArticle($ctrl, supportArticle)" support-article="supportArticle"></support-article-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<placeholder ng-if="$ctrl.supportArticles.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-search-results">\n\t\t\t\t\t<placeholder-title>0 results found for <strong class="italic">&lsquo;{{$ctrl.searchString}}&rsquo;</strong></placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>Unfortunately your search returned no support articles.</p>\n\t\t\t\t\t\t<p>Try searching again if you were hoping to find one!</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t<a class="is-primary strong s" href="" ng-click="$ctrl.goHome($ctrl)">\n\t\t\t\t\t\t\t<i class="icon-loading"></i>&nbsp;&nbsp;Reset search\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.error"></error-block>\n');
$templateCache.put('components/icon-card-basic/icon-card-basic.component.html','<div class="icon-card-basic">\n\t<div class="icon-card-basic_layout">\n\n\t\t<div class="icon-card-basic_icon" ng-if="$ctrl.icon">\n\t\t\t<i class="is-medium" ng-class="[\n\t\t\t\t\t$ctrl.icon,\n\t\t\t\t\t$ctrl.theme\n\t\t\t\t]"></i>\n\t\t</div>\n\n\t\t<div class="icon-card-basic_heading" ng-if="$ctrl.contents">\n\t\t\t{{$ctrl.contents}}\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/icon-dot/icon-dot.component.html','<div>\n\t<div ng-if="$ctrl.tooltipText" tooltip tooltip-position="{{$ctrl.tooltipPosition}}" tooltip-text="{{$ctrl.tooltipText}}" tooltip-theme="{{$ctrl.tooltipTheme}}">\n\t\t<icon-dot icon="{{$ctrl.icon}}" label="{{$ctrl.label}}" is-light="$ctrl.isLight" theme="{{$ctrl.theme}}"></icon-dot>\n\t</div>\n\n\t<div class="icon-dot" ng-class="[\n\t\t\t$ctrl.theme,\n\t\t\t{\n\t\t\t\t\'is-light\': $ctrl.isLight\n\t\t\t}\n\t\t]" ng-if="!$ctrl.tooltipText">\n\t\t<i ng-if="$ctrl.icon" ng-class="[\n\t\t\t\t$ctrl.icon,\n\t\t\t\t$ctrl.iconSize\n\t\t\t]"></i>\n\t\t<span class="icon-dot_letter" ng-if="!$ctrl.icon">\n\t\t\t{{$ctrl.char}}\n\t\t</span>\n\t</div>\n</div>\n');
$templateCache.put('components/image-focus-panel/image-focus-panel.component.html','<div class="image-focus-panel" ng-class="{ \'fadeOut\' : $ctrl.isClosing }">\n\t<div class="image-focus-panel_container fadeIn">\n\t\t<img alt="" class="image-focus-panel_image" src="{{$ctrl.image.src}}">\n\t\t<div class="image-focus-panel_caption">{{$ctrl.image.alt}}</div>\n\t</div>\n\t<button type="button" aria-label="Close image" class="is-clear image-focus-panel_close" ng-click="$ctrl.closeImageFocusPanel($ctrl)">\n\t\t<i class="icon-menu-close xl"></i>\n\t</button>\n</div>\n');
$templateCache.put('components/import-history-item/import-history-item.component.html','<div class="import-history-item fadeIn" ng-class="::$ctrl.import.Undone ? \'is-greyscale\' : \'is-secondary\'">\n\t<div class="import-history-item_main">\n\t\t<div class="import-history-item_icon">\n\t\t\t<i ng-class="$ctrl.import.ImportType | importMappingTypeIcon"></i>\n\t\t</div>\n\n\t\t<div class="import-history-item_content">\n\t\t\t<div class="import-history-item_title">\n\t\t\t\t<h6 class="import-history-item_description">{{::$ctrl.import.ImportType | importMappingTypeDescription}}</h6>\n\t\t\t\t<p class="import-history-item_filename">{{::$ctrl.import.ImportedFileName}}</p>\n\t\t\t</div>\n\n\t\t\t<div class="import-history-item_stats" ng-if="::!$ctrl.import.Undone">\n\t\t\t\t<span class="import-history-item_stat"><strong>{{::$ctrl.import.NumberImported}}</strong>&nbsp;created</span>\n\t\t\t\t<span class="import-history-item_stat"><strong>{{::$ctrl.import.NumberUpdated}}</strong>&nbsp;updated</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<span class="import-history-item_no-changes" data-cy="import-history-item-no-changes" ng-if="!$ctrl.import.Undone && $ctrl.hasNoChanges && (($ctrl.agencyProfileId && $ctrl.onUpdate) || $ctrl.onUndo)" title="Nothing to undo \u2014 no values were changed by this import">No changes</span>\n\n\t\t<a class="import-history-item_action" data-cy="import-history-item-undo" href="" ng-click="$ctrl.reviewUndoImportForm($ctrl)" ng-if="!$ctrl.import.Undone && !$ctrl.hasNoChanges && (($ctrl.agencyProfileId && $ctrl.onUpdate) || $ctrl.onUndo)" title="Undo this import"><i class="icon-undo"></i>Undo</a>\n\t</div>\n\t<footer class="import-history-item_footer">\n\t\t<p ng-if="!$ctrl.import.Undone">Imported by {{$ctrl.import.ImportedBy}} on {{$ctrl.import.ImportedDateISO | dateformat:\'long\'}}</p>\n\t\t<p ng-if="$ctrl.import.Undone">Undone by {{$ctrl.import.UndoneBy}} on {{$ctrl.import.UndoneDateISO | dateformat:\'long\'}}</p>\n\t</footer>\n</div>\n');
$templateCache.put('components/import-mapping-card/import-mapping-card.component.html','<div class="import-mapping-card">\n\t<div class="import-mapping-card_info">\n\t\t<div class="import-mapping-card_description">{{$ctrl.importMapping.Name}}</div>\n\t\t<div class="import-mapping-card_created" ng-if="!($root.currentCompany.isPayrollCompany && $ctrl.importMapping.IsGlobalTemplate)">Created on {{$ctrl.importMapping.CreatedDateISO | dateformat}} by {{$ctrl.importMapping.CreatedBy}}</div>\n\t</div>\n\t<div class="import-mapping-card_status" tooltip tooltip-size="s" tooltip-text="Bureau-managed mapping" ng-if="::$ctrl.importMapping.IsGlobalTemplate && $root.currentCompany.isPayrollCompany">\n\t\t<icon-dot icon="icon-company-groups" theme="is-large is-tertiary"></icon-dot>\n\t</div>\n\t<div class="import-mapping-card_type">{{$ctrl.importMapping.MappingType | importMappingTypeDescription}}</div>\n\t<div class="import-mapping-card_header-count"><ng-pluralize count="$ctrl.importMapping.HeaderCount" when="{\'1\': \'1 header\', \'other\': \'{} headers\'}"></ng-pluralize></div>\n\t<dropdown-menu class="import-mapping-card_action-menu" menu-theme="is-primary" menu-show-chevron="false" menu-show="$ctrl.showMenu" menu-size="l" menu-icon="icon-setup">\n\t\t<div class="dropdown-group">\n\t\t\t<a ng-href="{{$ctrl.getEditNgHref($ctrl)}}" ng-if="$ctrl.getCanEditMapping($ctrl)">Edit</a>\n\t\t\t<a href="" ng-click="$ctrl.openDuplicateImportMappingForm($ctrl, $ctrl.importMapping)">Duplicate</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="$ctrl.getCanDeleteMapping($ctrl)">\n\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeleteImportMappingForm($ctrl, $ctrl.importMapping)">Delete</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/import-summary/import-summary.component.html','<div class="import-summary" data-cy="import-summary">\n\n\t<div class="import-summary_header">\n\t\t<h5>Import summary</h5>\n\t</div>\n\n\t<div class="import-summary_layout">\n\n\t\t<!-- Created (pay element) -->\n\t\t<div class="import-summary_item import-summary_count" ng-if="::$ctrl.importSummary.Created > 0 && $ctrl.isPayElementImport">\n\t\t\t<div class="import-summary_tag">\n\t\t\t\t<div class="tag is-tertiary inverse" data-pc="import-summary-created-count">\n\t\t\t\t\t{{:: $ctrl.importSummary.Created }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="import-summary_copy">\n\t\t\t\tUpdated\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Created (non-pay element) -->\n\t\t<div class="import-summary_item import-summary_count" ng-if="::$ctrl.importSummary.Created > 0 && !$ctrl.isPayElementImport">\n\t\t\t<div class="import-summary_tag">\n\t\t\t\t<div class="tag is-secondary inverse" data-pc="import-summary-created-count">\n\t\t\t\t\t{{:: $ctrl.importSummary.Created }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="$ctrl.importSummary.Created" when="{ \'1\': \'Team member\', \'other\': \'Team members\'}"></ng-pluralize> created\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Creations -->\n\t\t<div class="import-summary_item import-summary_count" ng-if="::$ctrl.importSummary.Creations.length > 0 && creation.Created > 0" ng-repeat="creation in $ctrl.importSummary.Creations">\n\t\t\t<div class="import-summary_tag">\n\t\t\t\t<div class="tag is-secondary inverse" data-pc="import-summary-created-count-{{:: creation.ImportType | importMappingTypeDescription | slugify}}">\n\t\t\t\t\t{{:: creation.Created }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div ng-if="creation.VariantName == \'NotSet\'" class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="creation.Created" ng-init="singular = \'singular\'" when="{ \n\t\t\t\t\t\t\'1\': \'{{:: creation.ImportType | importMappingTypeDescription:singular }}\', \n\t\t\t\t\t\t\'other\': \'{{:: creation.ImportType | importMappingTypeDescription }}\'\n\t\t\t\t\t}"></ng-pluralize> created\n\t\t\t</div>\n\n\t\t\t<div ng-if="creation.VariantName != \'NotSet\'" class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="creation.Created" ng-init="singular = \'singular\'" when="{ \n\t\t\t\t\t\t\'1\': \'{{:: creation.VariantName }}\', \n\t\t\t\t\t\t\'other\': \'{{:: creation.VariantName }}s\'\n\t\t\t\t\t}"></ng-pluralize> created\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Updated -->\n\t\t<div class="import-summary_item import-summary_count" ng-if="::$ctrl.importSummary.Updates.length > 0 && update.Updated > 0" ng-repeat="update in $ctrl.importSummary.Updates">\n\t\t\t<div class="import-summary_tag">\n\t\t\t\t<div class="tag is-tertiary inverse" data-pc="import-summary-updated-count-{{:: update.ImportType | importMappingTypeDescription | slugify}}">\n\t\t\t\t\t{{:: update.Updated }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div ng-if="update.VariantName == \'NotSet\'" class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="update.Updated" ng-init="singular = \'singular\'" when="{\n\t\t\t\t\t\t\'1\': \'{{:: update.ImportType | importMappingTypeDescription:singular }}\',\n\t\t\t\t\t\t\'other\': \'{{:: update.ImportType | importMappingTypeDescription }}\'\n\t\t\t\t\t}"></ng-pluralize> updated\n\t\t\t</div>\n\t\t\t<div ng-if="update.VariantName != \'NotSet\'" class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="update.Updated" ng-init="singular = \'singular\'" when="{\n\t\t\t\t\t\t\'1\': \'{{:: update.VariantName }}\',\n\t\t\t\t\t\t\'other\': \'{{:: update.VariantName }}s\'\n\t\t\t\t\t}"></ng-pluralize> updated\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Warnings -->\n\t\t<div class="import-summary_item" ng-if="::$ctrl.importSummary.Warnings.length > 0" ng-repeat="warning in $ctrl.importSummary.Warnings" ng-switch="warning.WarningType">\n\n\t\t\t<!-- Age Warning -->\n\t\t\t<div data-pc="import-summary-warnings-age-warning" pc-switch-when="$ctrl.IMPORT_WARNING_TYPES.ageWarning">\n\t\t\t\t<info-block ib-theme="has-icon is-simple">\n\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t\t<i class="icon-warning is-tertiary info-block-icon"></i>\n\t\t\t\t\t\t\t<h6 class="stronger">Review the date of birth of <ng-pluralize count="warning.RecordsCount" when="{ \'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-header>\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tBased on the next pay date and the dates of birth in your file, you\'ve imported <ng-pluralize count="warning.RecordsCount" when="{ \'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize> who will be under 13, under 16, or over the state pension age on payday.\n\t\t\t\t\t\t\tYou can review these team members in the alerts area of your current period.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- PHR employee ID Warning -->\n\t\t\t<div data-pc="import-summary-warnings-age-warning" pc-switch-when="$ctrl.IMPORT_WARNING_TYPES.phrWarning">\n\t\t\t\t<info-block ib-theme="has-icon is-simple">\n\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t\t<i class="icon-warning is-tertiary info-block-icon"></i>\n\t\t\t\t\t\t\t<h6 class="stronger">Review the PeopleHR Employee IDs for <ng-pluralize count="warning.RecordsCount" when="{ \'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-header>\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tWe couldn\'t import the below PeopleHR Employee IDs as they\'re already in use by existing team members. They will need to be updated in your import file before trying again.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t\t<bullet-list bl-items="warning.WarningItems" bl-theme="is-small is-tertiary is-spaced-out">\n\t\t\t\t\t\t</bullet-list>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- Recurring import Warning -->\n\t\t\t<div data-pc="import-summary-warnings-age-warning" pc-switch-when="$ctrl.IMPORT_WARNING_TYPES.recurringElementImportWorking">\n\t\t\t\t<info-block ib-theme="has-icon is-simple">\n\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t\t<i class="icon-warning is-tertiary info-block-icon"></i>\n\t\t\t\t\t\t\t<h6 class="stronger">Review the recurring element settings for <ng-pluralize count="warning.RecordsCount" when="{ \'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-header>\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tWe couldn\'t import the below data. They will need to be updated in your import file before trying again.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t\t<bullet-list bl-items="warning.WarningItems" bl-theme="is-small is-tertiary is-spaced-out">\n\t\t\t\t\t\t</bullet-list>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Skips -->\n\t\t<div class="import-summary_item import-summary_count" ng-if="::$ctrl.importSummary.Skips.length > 0 && skip.Skipped > 0" ng-repeat="skip in $ctrl.importSummary.Skips">\n\t\t\t<div class="import-summary_tag">\n\t\t\t\t<div class="tag is-tertiary inverse" data-pc="import-summary-skipped-count-{{:: skip.ImportType | importMappingTypeDescription | slugify}}">\n\t\t\t\t\t{{:: skip.Skipped }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="import-summary_copy">\n\t\t\t\t<ng-pluralize count="skip.Skipped" ng-init="singular = \'singular\'" when="{ \n\t\t\t\t\t\t\'1\': \'{{:: skip.ImportType | importMappingTypeDescription:singular }}\', \n\t\t\t\t\t\t\'other\': \'{{:: skip.ImportType | importMappingTypeDescription }}\'\n\t\t\t\t\t}"></ng-pluralize> skipped\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/info-block/infoBlock.html','<div class="info-block" ng-class="[ ibTheme, { \'align-center\' : ibAlign === \'center\', \'has-icon-dot\': ibIconDot } ]">\n\t<div class="info-block-icon-dot" ng-if="ibIconDot">\n\t\t<icon-dot icon="{{ibIconDot}}" theme="{{ibTheme}} is-extra-large"></icon-dot>\n\t</div>\n\t<header class="info-block-header" ng-if="hasHeader" ng-transclude="ibHeader"></header>\n\t<h4 class="info-block-title" ng-if="hasTitle">{{ibTitle}}</h4>\n\t<div class="info-block-main" ng-if="hasMain" ng-transclude="ibMain"></div>\n\t<footer class="info-block-footer" ng-if="hasFooter" ng-transclude="ibFooter"></footer>\n</div>\n\n');
$templateCache.put('components/intercom-form/intercomFormBlock.html','<aside class="intercom-form" ng-switch="state">\n\n\t<div class="intercom-form__box intercom-form__box--arrow" ng-switch-when="connect">\n\t\t<div class="intercom-form__content">\n\t\t\t<img src="images/logo/intercom.svg" alt="" class="intercom-form__logo">\n\t\t\t<div class="intercom-form__copy">\n\t\t\t\t<h6>Waiting to test connection...</h6>\n\t\t\t\t<p>Enter your App ID and Identity verification Secret and click \'Test connection\' to test your account details.</p>\n\t\t\t\t<h6>Need an Intercom account? <a href="" ng-href="{{$root.URLS.intercom.website}}" class="link" target="_blank">Get one here</a></h6>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="intercom-form__box" ng-switch-when="connected">\n\t\t<div class="intercom-form__content">\n\t\t\t<img src="images/logo/intercom.svg" alt="" class="intercom-form__logo">\n\t\t\t<div class="intercom-form__copy">\n\t\t\t\t<h6>Intercom connected</h6>\n\t\t\t\t<p>Hi {{$root.currentUser.UserResponseFirstName}}, your Intercom account has been connected to Paycircle and live for your clients.</p>\n\t\t\t\t<p>The Paycircle Team</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="intercom-form__circle fadeIn" ng-if="state">\n\t\t<div class="intercom-form__icon">\n\t\t\t<span class="icon {{state === \'waiting\' || state === \'connecting\' ? \'icon-question-mark\' : \'icon-tick\'}}"></span>\n\t\t</div>\n\t</div>\n</aside>\n');
$templateCache.put('components/job-grade-card/job-grade-card.component.html','<div class="job-grade-card is-primary">\n\t<icon-dot icon="icon-threshold-change" theme="is-primary has-box-shadow"></icon-dot>\n\t<div class="job-grade-card_name">{{$ctrl.jobGrade.PolicyGradeName}}</div>\n\t<div class="job-grade-card_team-members"><i class="icon-team-alt is-primary m"></i>&nbsp;&nbsp;{{$ctrl.jobGrade.TeamMembers.length}}</div>\n\t<div ng-if="::$root.currentUser.Permissions.HR.canManageJobGrades">\n\t\t<dropdown-menu data-cy="job-grade-card-{{$ctrl.index}}-action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="vm.showActionMenu" menu-size="l" menu-theme="is-primary s">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a data-cy="job-grade-card-{{$ctrl.index}}-action-menu-edit" href="" ng-click="$ctrl.editJobGrade($ctrl.jobGrade, $ctrl.jobGrades, $ctrl)">Edit</a>\n\t\t\t\t<a data-cy="job-grade-card-{{$ctrl.index}}-action-menu-view-team-members" href="" ng-click="$ctrl.viewTeamMembers($ctrl.jobGrade, $ctrl)">View team members</a>\n\t\t\t</div>\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a class="assertive" data-cy="job-grade-card-{{$ctrl.index}}-action-menu-delete" href="" ng-click="$ctrl.deleteJobGrade($ctrl.jobGrade, $ctrl)">Delete</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t</div>\n</div>\n');
$templateCache.put('components/journal-code-preview/journal-code-preview.component.html','<div class="journal-code-preview">\n\n\t<p class="is-small journal-code-preview_title">Full journal code format:</p>\n\n\t<!-- Journal code preview -->\n\t<div class="journal-code-preview_block is-indifferent">\n\t\t<h4 class="journal-code-preview_segments" data-cy="journal-code-preview">\n\t\t\t<span class="journal-code-preview_segment" data-cy="journal-code-preview-segment-{{$index}}" ng-repeat="journalCode in $ctrl.journalCodesActive" title="{{journalCode.name}}">\n\t\t\t\t{{!$first ? $ctrl.journalCodeFormat.delimiterChar : \'\'}}{{journalCode.preview}}\n\t\t\t</span>\n\t\t</h4>\n\t</div>\n\n\t<div class="journal-code-preview_footer">\n\t\t<a class="strong" data-cy="edit-journal-code-format" href="" ng-click="$ctrl.openJournalFormatForm()" ng-if="!$ctrl.disabled && !$ctrl.isFinancialsIntegrated"><i class="icon-edit has-margin-right"></i>Edit format</a>\n\t\t<a class="strong" data-cy="map-financials-categories" href="" ng-click="$ctrl.openJournalCodeFinancialsForm()" ng-if="!$ctrl.disabled && $ctrl.isFinancialsIntegrated"><i class="icon-edit has-margin-right"></i>Map categories</a>\n\t\t<a href="" ng-click="$ctrl.openJournalCodePreviewInfoModal()" class="is-small italic is-greyscale">What\'s this?</a>\n\t</div>\n</div>\n');
$templateCache.put('components/ip-address/ip-address.component.html','<div class="ip-address">\n\t<div class="ip-address_field">\n\t\t<input class="ip-address_input" type="text" name="{{$ctrl.name}}" ng-required="$ctrl.ipAddressRequired" ng-pattern="$root.REGEX.ipAddress" ng-disabled="$ctrl.ipAddressDisabled" ng-change="$ctrl.ipAddressOnChange($ctrl, ipAddressForm)" ng-model="$ctrl.ipAddress">\n\t</div>\n</div>\n');
$templateCache.put('components/leave-card/leaveCard.html','<div data-cy="leave-{{index}}" class="leave-card fadeIn {{cardTheme}}" ng-class="{\'leave-card--taken\' : leave.isTaken}">\n\t<div class="leave-card__dot-layout">\n\t\t<span class="leave-card__dot"></span>\n\t</div>\n\t<div class="leave-card__date-range">\n\t\t{{startDate | dateformat:\'dayMonth\'}} <i class="icon-arrow-right leave-card__arrow"></i> {{endDate | dateformat:\'dayMonth\'}}\n\t</div>\n\t<div class="leave-card__length">\n\t\t<ng-pluralize count="leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>\n\t</div>\n\t<div class="leave-card__integration" ng-if="isLocked">\n\t\t<i class="icon-information leave-card__integration-icon" data-cy="leave-integration-info" tooltip tooltip-position="left" tooltip-text="{{integrationMessage}}"></i>\n\t</div>\n\t<div class="leave-card__delete" ng-if="!isLocked" ng-switch="leave.state">\n\t\t<span class="leave-card__confirm fadeIn" ng-switch-when="confirm">\n\t\t\tDelete this {{leaveType}} leave?&nbsp;&nbsp;<a data-cy="leave-delete-yes" href="" ng-click="deleteLeave(leave)" class="leave-card__link">Yes</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a data-cy="leave-delete-no" href="" ng-click="leave.state = false" class="leave-card__link">No</a>\n\t\t</span>\n\t\t<span class="leave-card__confirm fadeIn" ng-switch-when="deleting">\n\t\t\tDeleting...\n\t\t</span>\n\t\t<span class="leave-card__confirm fadeIn" ng-switch-when="error">\n\t\t\tFailed to delete - try again?&nbsp;&nbsp;<a href="" ng-click="deleteLeave(leave)" class="leave-card__link">Yes</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="" ng-click="leave.state = false" class="leave-card__link">No</a>\n\t\t</span>\n\t\t<i data-cy="leave-delete" class="icon-trash leave-card__bin fadeIn" ng-switch-default ng-click="leave.state = \'confirm\'"></i>\n\t</div>\n</div>\n');
$templateCache.put('components/link-element-card/link-element-card.component.html','<div class="link-element-card" ng-class="[\n\t\t$ctrl.linkElement.theme,\n\t\t{\n\t\t\t\'is-active\': $ctrl.linkElement.isMenuOpen\n\t\t}\n\t]">\n\t<p class="link-element-card_name">\n\t\t<i class="icon-link link-element-card_name-icon"></i>\n\t\t{{::$ctrl.linkElement.LinkElementName}}\n\t</p>\n\t<p class="link-element-card_reference">\n\t\t<i class="icon-{{::$ctrl.linkElement.IsDeduction ? \'minus\' : \'add\'}} link-element-card_reference-icon"></i>\n\t\t{{::$ctrl.linkElement.LinkElementAdjustmentName}}\n\t</p>\n\t<p class="link-element-card_meta" ng-if="$ctrl.linkElement.LinkElementRate > 0">\n\t\t{{::$ctrl.linkElement.LinkElementRate | monetise:$root.CONFIG.precision.salaryRates}} (x{{::$ctrl.linkElement.LinkElementMultiplier}})\n\t</p>\n\t<p class="link-element-card_meta" ng-if="$ctrl.linkElement.LinkElementRate === 0">\n\t\tx{{::$ctrl.linkElement.LinkElementMultiplier}}\n\t</p>\n\t<dropdown-menu class="link-element-card_menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.linkElement.isMenuOpen" menu-theme="{{$ctrl.linkElement.theme}}">\n\t\t<div class="dropdown-group">\n\t\t\t<a data-cy="link-element_edit" href="" ng-click="$ctrl.openEditLinkElementForm($ctrl)">\n\t\t\t\tEdit\n\t\t\t</a>\n\t\t\t<a data-cy="link-element_duplicate" href="" ng-click="$ctrl.openDuplicateLinkElementForm($ctrl)">\n\t\t\t\tDuplicate\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a class="is-assertive" data-cy="link-element_delete" href="" ng-click="$ctrl.openDeleteLinkElementForm($ctrl)">\n\t\t\t\tDelete\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/link-rate-card/link-rate-card.component.html','<div class="link-rate-card" ng-class="[$ctrl.linkRate.theme, {\'is-active\': $ctrl.linkRate.isMenuOpen}]">\n\t<p class="link-rate-card_name">\n\t\t<i class="icon-link link-rate-card_name-icon"></i>\n\t\t{{::$ctrl.linkRate.linkElement.LinkElementName}}\n\t</p>\n\t<p class="link-rate-card_reference">\n\t\t<i class="icon-{{::$ctrl.linkRate.Deduction ? \'minus\' : \'add\'}} link-rate-card_reference-icon"></i>\n\t\t{{::$ctrl.linkRate.linkElement.LinkElementAdjustmentName}}\n\t</p>\n\t<p class="link-rate-card_meta">\n\t\t   <span ng-if="$ctrl.linkRate.Units > 0 && $ctrl.linkRate.ValueType === $ctrl.ADJUSTMENT_VALUE_TYPES.unit">{{::$ctrl.linkRate.Units}} x&nbsp;</span><!--\n\t\t--><span ng-if="$ctrl.linkRate.UnitValue > 0">{{::$ctrl.linkRate.UnitValue | monetise:$root.CONFIG.precision.salaryRates}} (x{{::$ctrl.linkRate.linkElement.LinkElementMultiplier}})&nbsp;</span><!--\n\t\t--><span ng-if="$ctrl.linkRate.UnitValue === 0">x{{::$ctrl.linkRate.linkElement.LinkElementMultiplier}}</span>\n\t</p>\n\t<dropdown-menu class="link-rate-card_menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.linkRate.isMenuOpen" menu-theme="{{$ctrl.linkRate.theme}}">\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="$ctrl.openEditLinkRateForm($ctrl)" data-cy="link-element_edit">Edit</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="$ctrl.openDeleteLinkRateForm($ctrl)" class="is-assertive" data-cy="link-element_delete">Delete</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/loading-block/loadingBlock.html','<div class="loading-block {{size}}">\n\t<p class="loading-block-description before" ng-transclude="description" ng-if="showDescription && position === \'before\'"></p>\n\t<circle-loader></circle-loader>\n\t<p class="loading-block-description after" ng-transclude="description" ng-if="showDescription && position === \'after\'"></p>\n</div>\n\n');
$templateCache.put('components/log-card/logCardComponent.html','<div class="log-card {{log.logMeta.theme}}" data-cy="{{::log.LogEntryTitle | slugify}}" ng-class="{\'log-card--small\' : !log.showContent}">\n\t<header class="log-card-header">\n\t\t<p class="log-card-label" ng-class="log.logMeta.theme">\n\t\t\t<span class="bullet-point xs log-card-bullet-point" ng-class="log.logMeta.theme">\n\t\t\t</span>\n\t\t\t<span class="log-card-actor" ng-if="log.TargetActor !== \'\' && showLogActor">\n\t\t\t\t{{log.TargetActor}}&nbsp;<i class="icon-chevron-right"></i>&nbsp;\n\t\t\t</span>\n\t\t\t<span class="log-card-title">\n\t\t\t\t{{logDescription}}\n\t\t\t</span>\n\t\t</p>\n\t\t<span class="log-card-actioned-by" ng-class="log.logMeta.theme" title="By {{log.ActionActor}} at {{log.LogDateISO | datetimeformat}}">By {{log.ActionActor}} on {{log.LogDateISO | dateformat}} at {{log.LogDateISO | datetimeformat:\'time12\'}}\n\t\t</span>\n\t</header>\n\t<div class="log-card-main" ng-if="::$root.currentUser.Permissions.Team.canEditPersonalDetails && log.showContent" ng-switch="log.DataType">\n\t\t<!-- From > To -->\n\t\t<div class="log-card-type-from-to" ng-switch="log.LogType" pc-switch-when="LOG_DATA_TYPES.fromTo">\n\t\t\t<!-- Address -->\n\t\t\t<div class="log-card-address-changed" pc-switch-when="LOG_TYPES.ADDRESS_UPDATED.id">\n\t\t\t\t<address class="log-card-address">\n\t\t\t\t\t<p class="log-card-value" ng-repeat="addressLine in log.ValueFrom track by $index">\n\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t</p>\n\t\t\t\t</address>\n\t\t\t\t<span class="icon-chevron-right log-type-from-to-arrow" ng-class="log.logMeta.theme">\n\t\t\t\t</span>\n\t\t\t\t<address class="log-card-address">\n\t\t\t\t\t<p class="log-card-value" ng-repeat="addressLine in log.ValueTo track by $index">\n\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t</p>\n\t\t\t\t</address>\n\t\t\t</div>\n\n\t\t\t<!-- Everything else -->\n\t\t\t<p class="log-card-value" ng-switch-default>\n\t\t\t\t{{log.ValueFrom}}\n\t\t\t\t<span class="icon-chevron-right log-type-from-to-arrow" ng-class="log.logMeta.theme">\n\t\t\t\t</span>\n\t\t\t\t{{log.ValueTo}}\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Absolute -->\n\t\t<div class="log-card-type-updated-value" ng-switch="log.LogType" pc-switch-when="LOG_DATA_TYPES.absolute">\n\t\t\t<!-- Address Added -->\n\t\t\t<div pc-switch-when="LOG_TYPES.ADDRESS_UPDATED.id">\n\t\t\t\t<address class="log-card-address">\n\t\t\t\t\t<p class="log-card-value" ng-repeat="addressLine in log.ValueFrom track by $index">\n\t\t\t\t\t\t{{addressLine}}\n\t\t\t\t\t</p>\n\t\t\t\t</address>\n\t\t\t</div>\n\n\t\t\t<p class="log-card-value" ng-if="log.ValueFrom" ng-switch-default>\n\t\t\t\t{{log.ValueFrom}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/menu-button/menu-button.component.html','<div class="menu-button" click-anywhere-but-here="$ctrl.menuButtonOpen = false" is-active="$ctrl.menuButtonOpen" ng-class="[\n\t\t$ctrl.menuButtonAlign === \'right\' ? \'is-right-aligned\' : \'is-left-aligned\',\n\t\t$ctrl.menuButtonSize,\n\t\t$ctrl.menuButtonTheme,\n\t\t$ctrl.menuButtonType === \'fluid\' ? \'is-fluid\' : \'is-fixed\',\n\t\t{ \'is-open\' : $ctrl.menuButtonOpen }\n\t]">\n\n\t<button class="menu-button_primary-action" data-cy="{{::$ctrl.menuButtonId}}" href="" id="{{$ctrl.menuButtonId}}" ng-class="[$ctrl.menuButtonTheme, { \'has-chevron\' : $ctrl.menuButtonHasChevron }]" ng-click="$ctrl.menuButtonOpen = !$ctrl.menuButtonOpen" type="button">\n\t\t<span ng-show="$ctrl.menuButtonAddIcon">\n\t\t\t<i ng-class="$ctrl.menuButtonIcon"></i>&nbsp;\n\t\t</span>\n\t\t{{$ctrl.menuButtonText}}\n\t</button>\n\n\t<div class="dropdown menu-button_dropdown fadeInFast" ng-if="$ctrl.menuButtonOpen" ng-transclude>\n\n\t</div>\n</div>\n');
$templateCache.put('components/message-bar/messageBarComponent.html','<div class="message-bar inline {{type}} {{theme}} {{tagLabel ? \'has-tag-label\' : \'\'}}">\n\t<div class="tag-label {{tagLabelTheme ? tagLabelTheme : theme}} message-bar-tag-label" ng-if="tagLabel"><i class="icon-{{tagLabelIcon}} tag-label-icon" ng-if="tagLabelIcon"></i>{{tagLabel}}</div>\n\t<div ng-transclude></div>\n</div>\n');
$templateCache.put('components/message-block/message-block.component.html','<div class="message-block" ng-class="[\n\t\t$ctrl.theme,\n\t\t{\n\t\t\t\'dropIn\' : $ctrl.hasDropIn,\n\t\t\t\'has-icon\': $ctrl.hasIcon\n\t\t}\n\t]">\n\t<div class="message-block_body">\n\t\t<div class="message-block_main">\n\t\t\t<i class="is-medium message-block_icon" ng-class="[$ctrl.theme, \'icon-\' + $ctrl.icon]" ng-if="::$ctrl.hasIcon"></i>\n\t\t\t<ng-transclude></ng-transclude>\n\t\t</div>\n\t\t<div class="message-block_action" ng-if="::$ctrl.hasAction">\n\t\t\t<a href="" class="is-small" ng-class="[$ctrl.actionTheme]" ng-click="$ctrl.onActionClick($ctrl)">\n\t\t\t\t<i ng-class="[\'icon-\' + $ctrl.actionIcon]" ng-if="::$ctrl.hasActionIcon"></i>\n\t\t\t\t&nbsp;{{::$ctrl.actionText}}\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/meta-data-card/meta-data-card.component.html','<div class="meta-data-card" ng-class="$ctrl.theme">\n\t<div class="meta-data-card_header" ng-if="::$ctrl.metaTitle">\n\t\t<i class="is-large meta-data-card_header-icon" ng-class="[$ctrl.icon, $ctrl.theme]" ng-if="::$ctrl.icon"></i>\n\t\t<h6 class="meta-data-card_header-title">{{::$ctrl.metaTitle}}</h6>\n\t</div>\n\t<div class="meta-data-card_meta-items">\n\t\t<div class="meta-data-card_meta-item" ng-repeat="metaItem in $ctrl.metaItems">\n\t\t\t<p class="meta-data-card_meta-item-label">{{::metaItem.label}}</p>\n\t\t\t<p class="meta-data-card_meta-item-value">{{::metaItem.value}}</p>\n\t\t</div>\n\t</div>\n</div>\n\n');
$templateCache.put('components/meta-tags/meta-tags.component.html','<div class="meta-tags" ng-if="$ctrl.metaTags.length" ng-class="{ \'align-right\' : $ctrl.alignRight }">\n\t<div class="meta-tags_item" ng-class="metaTag.theme" ng-repeat="metaTag in $ctrl.metaTags">\n\t\t<i class="meta-tags_item-icon" ng-class="::metaTag.icon"></i>\n\t\t<span class="meta-tags_item-text" ng-if="metaTag.text">{{::metaTag.text}}</span>\n\t</div>\n</div>\n<div class="meta-tags" ng-if="$ctrl.metaTags.length === 0 && $ctrl.showIfEmpty"><div class="meta-tags_item"></div></div>\n');
$templateCache.put('components/mobile-menu/mobile-menu.component.html','<div class="mobile-menu fadeIn">\n\t<div class="mobile-menu_items" ng-style="{\n\t\t\t\'padding-top\': $ctrl.appHeaderPixelHeight\n\t\t}">\n\t\t<header class="mobile-menu_items-header">\n\t\t\t{{$ctrl.mmTitle}}\n\t\t</header>\n\t\t<ng-transclude></ng-transclude>\n\t</div>\n</div>\n');
$templateCache.put('components/modal/modal.component.html','<div class="modal" ng-class="[\n\t\t$ctrl.modalOptions.size,\n\t\t$ctrl.modalOptions.theme,\n\t\t$ctrl.modalOptions.template,\n\t\t$ctrl.modalOptions.animation,\n\t\t{\n\t\t\t\'is-entire-screen\': $ctrl.modalOptions.isEntireScreen\n\t\t}\n\t]">\n\n\t<!-- Overlay for \'legacy\', non-modal cabinet modals. See comments in controller. This can go\n\t\t when all modals have been refactored to the new cabinet structure -->\n\t<div class="modal_overlay" ng-if="!$ctrl.isModalCabinet"></div>\n\n\t<div class="modal_window">\n\n\t\t<header class="modal_header" ng-if="$ctrl.modalOptions.showHeader">\n\t\t\t<h4 class="modal_title" data-cy="modal-title">{{$ctrl.modalOptions.title}}</h4>\n\t\t\t<!-- When all modals have been refactored, ng-click here can call $ctrl.modalOptions.closeModal()\n\t\t\t\t directly, and the closeModal provided in modal.component.js can be removed. -->\n\t\t\t<a aria-label="Close modal" class="modal_close" data-cy="modal-btn-close" href="" ng-click="$ctrl.closeModal()" ng-if="$ctrl.modalOptions.canClose">\n\t\t\t\t<i class="icon-cross is-large"></i>\n\t\t\t</a>\n\t\t</header>\n\n\t\t<div class="modal_body" ng-transclude="modalBody"></div>\n\n\t\t<footer class="modal_footer" ng-if="$ctrl.hasPrimaryActions || $ctrl.hasSecondaryActions">\n\n\t\t\t<!-- Secondary Actions -->\n\t\t\t<div class="modal_secondary-actions" ng-if="$ctrl.hasSecondaryActions" ng-transclude="secondaryActions"></div>\n\n\t\t\t<!-- Primary Actions -->\n\t\t\t<div class="modal_primary-actions" ng-if="$ctrl.hasPrimaryActions" ng-transclude="primaryActions"></div>\n\t\t</footer>\n\t</div>\n</div>\n');
$templateCache.put('components/modal-cabinet/modal-cabinet.component.html','<div class="modal-cabinet">\n\n\t<app-browser-compatibility-warning-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'app-browser-compatibility-warning\'"></app-browser-compatibility-warning-modal>\n\n\t<leave-date-expired-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'leave-date-expired\'"></leave-date-expired-modal>\n\n\t<imports-duplicate-mapping-headers-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'imports-duplicate-mapping-headers\'"></imports-duplicate-mapping-headers-modal>\n\n\t<imports-leavers-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'imports-leavers\'"></imports-leavers-modal>\n\n\t<imports-nothing-to-import-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'imports-nothing-to-import\'"></imports-nothing-to-import-modal>\n\n\t<information-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.type === $ctrl.MODAL_GENERIC_TYPES.information"></information-modal>\n\n\t<payroll-reset-period-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'payroll-reset-period\'"></payroll-reset-period-modal>\n\n\t<session-timed-out-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'session-timed-out\'"></session-timed-out-modal>\n\n\t<session-timeout-warning-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'session-timeout-warning\'"></session-timeout-warning-modal>\n\n\t<settings-journal-code-preview-info-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'settings-journal-code-preview-info\'"></settings-journal-code-preview-info-modal>\n\n\t<settings-journal-nominal-codes-allocation-report-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'settings-journal-nominal-codes-allocation-report\'"></settings-journal-nominal-codes-allocation-report-modal>\n\n\t<settings-pay-element-type-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'settings-pay-element-type\'"></settings-pay-element-type-modal>\n\n\t<team-advance-pay-periods-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-advance-pay-periods\'"></team-advance-pay-periods-modal>\n\n\t<team-bulk-delete-summary-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-bulk-delete-summary\'"></team-bulk-delete-summary-modal>\n\n\t<team-correctional-submission-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-correctional-submission\'"></team-correctional-submission-modal>\n\n\t<team-excluded-from-rti-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-excluded-from-rti\'"></team-excluded-from-rti-modal>\n\n\t<team-furlough-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-furlough\'"></team-furlough-modal>\n\n\t<team-invite-to-register-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-invite-to-register\'"></team-invite-to-register-modal>\n\n\t<team-mark-as-on-hold-or-active-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-mark-as-on-hold-or-active\'"></team-mark-as-on-hold-or-active-modal>\n\n\t<team-supplementary-pay-run-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-supplementary-pay-run\'"></team-supplementary-pay-run-modal>\n\n\t<team-manage-rolled-up-holiday-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-manage-rolled-up-holiday\'"></team-manage-rolled-up-holiday-modal>\n\n\t<team-unmark-as-advancing-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'team-unmark-as-advancing\'"></team-unmark-as-advancing-modal>\n\n\t<workflow-payroll-information-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'workflow-payroll-information\'"></workflow-payroll-information-modal>\n\n\t<workflow-draft-reports-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'workflow-draft-reports\'"></workflow-draft-reports-modal>\n\n\t<smart-view-feedback-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'smart-view-feedback\'"></smart-view-feedback-modal>\n\n\t<cookie-preferences-modal modal-options="$ctrl.modalOptions" ng-if="$ctrl.modalOptions.modalKey === \'cookie-preferences\'"></cookie-preferences-modal>\n\n</div>\n');
$templateCache.put('components/modal-dialog/modal-dialog.component.html','<div class="modal-dialog fadeIn" ng-class="[\n\t\t$ctrl.modalOptions.size,\n\t\t$ctrl.modalOptions.theme,\n\t\t$ctrl.modalOptions.themeMode,\n\t\t{\n\t\t\t\'is-light-mode\': !$ctrl.isDarkMode\n\t\t}\n\t]">\n\t<div class="modal-dialog_main">\n\n\t\t<!-- Header -->\n\t\t<div class="modal-dialog_header" ng-class="">\n\t\t\t<h4 class="modal-dialog_header-title" ng-bind="$ctrl.modalOptions.title"></h4>\n\t\t\t<a aria-label="Close modal" class="modal-dialog_header-action" href ng-click="$ctrl.modalOptions.closeModal()">\n\t\t\t\t<i class="icon-cross is-large"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Body -->\n\t\t<div class="modal-dialog_body" ng-class="{\n\t\t\t\t\'has-no-footer\': !hasFooter\n\t\t\t}" ng-transclude="modalBody"></div>\n\n\t\t<!-- Footer -->\n\t\t<footer class="modal-dialog_footer" ng-if="hasFooter">\n\n\t\t\t<!-- Secondary Actions -->\n\t\t\t<div class="modal_secondary-actions" ng-if="hasSecondaryActions" ng-transclude="secondaryActions"></div>\n\n\t\t\t<!-- Primary Actions -->\n\t\t\t<div class="modal_primary-actions" ng-if="hasPrimaryActions" ng-transclude="primaryActions"></div>\n\n\t\t</footer>\n\n\t</div>\n</div>\n');
$templateCache.put('components/modal-mobile/modal-mobile.component.html','<div class="modal-mobile" ng-class="{\n\t\t\'is-open\' : modalOpen\n\t}">\n\t<div class="modal-mobile_header">\n\t\t<button aria-label="Close modal" class="modal-mobile_back is-clear is-icon-only" ng-click="modalClose()">\n\t\t\t<i class="icon-back"></i>\n\t\t</button>\n\t\t<div class="modal-mobile_actions" ng-transclude="modalActions">\n\t\t</div>\n\t</div>\n\t<div class="modal-mobile_body" ng-transclude="modalBody">\n\t</div>\n\t<div class="modal-mobile_footer" ng-if="modalSubmitText">\n\t\t<a href class="button s tertiary modal-mobile_button" ng-click="submit()">\n\t\t\t{{modalSubmitText}}\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/name/nameComponent.html','<span class="name" ng-switch="nameType">\n\n\t<span class="name" title="{{::companyName}}" ng-switch-when="company">\n\t\t<span class="company-name">{{::companyName}}</span>\n\t</span>\n\n\t<span class="name" title="{{::fullName}}" ng-switch-when="full-name">\n\t\t<span class="full-name">{{::fullName}}</span>\n\t</span>\n\n\t<span class="name" title="{{::forename}} {{::surname}}" ng-switch-default>\n\t\t<span class="forename">\n\t\t\t<truncate text="forename" truncate-amount="50">\n\t\t\t</truncate>\n\t\t</span>\n\t\t<span class="surname">\n\t\t\t<truncate text="surname" truncate-amount="50">\n\t\t\t</truncate>\n\t\t</span>\n\t</span>\n</span>\n');
$templateCache.put('components/navigation-tabs/navigationTabsComponent.html','<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen" ng-transclude></nav>\n');
$templateCache.put('components/ni-number/ni-number.component.html','<div class="ni-number">\n\t<input class="upcase m" data-cy="{{$ctrl.niNumberName}}" id="{{$ctrl.niNumberName}}" maxlength="9" minlength="9" name="{{$ctrl.niNumberName}}" ng-change="$ctrl.onChange()" ng-disabled="$ctrl.niNumberDisabled" ng-model="$ctrl.niNumber" ng-pattern="$root.REGEX.NI" ng-required="$ctrl.niNumberRequired" type="text">\n</div>\n');
$templateCache.put('components/nominal-code-form-field/nominal-code-form-field.component.html','<div class="nominal-code-form-field">\n\t<div class="nominal-code-form-field_action" ng-if="$ctrl.showActions">\n\t\t<div class="nominal-code_delete" ng-if="!$ctrl.nominalCode.confirmDelete"><a href="" ng-click="$ctrl.toggleConfirmDeleteNominalCode($ctrl.nominalCode)" class="is-primary-light" data-cy="delete-nominal-code" aria-label="Delete nominal code"><i class="icon-trash"></i></a></div>\n\t\t<div class="nominal-code-confirm-delete" ng-if="$ctrl.nominalCode.confirmDelete"><p class="s strong">Are you sure?&nbsp;<a href="" ng-click="$ctrl.deleteNominalCode($ctrl.nominalCode)" data-cy="delete-nominal-code-yes">Yes</a><span class="greyscale">&nbsp;|&nbsp;</span><a href="" ng-click="$ctrl.toggleConfirmDeleteNominalCode($ctrl.nominalCode)" data-cy="delete-nominal-code-no">No</a></p></div>\n\t</div>\n\t<div class="form-field-group">\n\t\t<div class="form-field nominal-code-form-field_code">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.nominalCodeValueFormFieldId}}" class="required">Code</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.nominalCodeValueFormFieldId}}" name="{{$ctrl.nominalCodeValueFormFieldId}}" ng-model="$ctrl.nominalCode.NominalCodeValue" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.nominalCodeValueFormFieldId].$error" ng-show="$ctrl.form[$ctrl.nominalCodeValueFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a nominal code</p>\n\t\t\t\t<p ng-message="nonUnique">Please ensure that all nominal codes are unique</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.nominalCodeNarrativeFormFieldId}}" class="required">Narrative</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="{{$ctrl.nominalCodeNarrativeFormFieldId}}" name="{{$ctrl.nominalCodeNarrativeFormFieldId}}" ng-change="$ctrl.onNarrativeChange($ctrl.nominalCode, \'nominalCodeNarrative\')" ng-model="$ctrl.nominalCode.NominalCodeNarrative" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.nominalCodeNarrativeFormFieldId].$error" ng-show="$ctrl.form[$ctrl.nominalCodeNarrativeFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a narrative</p>\n\t\t\t\t<p ng-message="nonUnique">Please ensure that all narrative values are unique</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="form-field-group" ng-if="$ctrl.isFinancialsIntegrated || $ctrl.hasExistingControlAccounts">\n\t\t<div class="nominal-code-form-field_footer">\n\t\t\t<div class="nominal-code-form-field_footer-toggle">\n\t\t\t\t<toggle-input field-disabled="!$ctrl.isFinancialsIntegrated && !$ctrl.nominalCode.originalNominalCodeOverrideJournalCode" field-label="Use for control account" field-model="$ctrl.nominalCode.NominalCodeOverrideJournalCode" field-name="{{$ctrl.nominalCodeOverrideJournalCodeFormFieldId}}" field-style="has-active-label" field-theme-active="is-primary" field-theme-inactive="is-primary-200"></toggle-input>\n\t\t\t\t<p class="nominal-code-form-field_footer-detail s fadeIn" ng-if="$ctrl.nominalCode.NominalCodeOverrideJournalCode">\n\t\t\t\t\tPayments to this nominal code will use the control account codes set against business categories, instead of employees\u2019 business category codes.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/nominal-code-preview/nominal-code-preview-code.component.html','<div class="nominal-code-preview-code {{ $ctrl.isExpanded ? \'is-expanded\' : \'\' }}">\n\t<div class="nominal-code-preview-code_header">\n\t\t<div class="nominal-code-preview-code_name"><span ng-if="$ctrl.nominalCode.NominalCodeValue">{{$ctrl.nominalCode.NominalCodeValue}}&nbsp;-&nbsp;</span>{{$ctrl.nominalCode.NominalCodeNarrative}}</div>\n\t\t<div class="nominal-code-preview-code_count"><ng-pluralize count="$ctrl.nominalCode.NominalEntries.length" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize></div>\n\t\t<a href="" ng-click="$ctrl.toggleIsExpanded($ctrl)" aria-label="Toggle expanded preview code">\n\t\t\t<i class="icon-chevron-up" ng-if="$ctrl.isExpanded"></i>\n\t\t\t<i class="icon-chevron-down" ng-if="!$ctrl.isExpanded"></i>\n\t\t</a>\n\t</div>\n\t<div class="nominal-code-preview-code_entry-list fadeIn" ng-if="$ctrl.nominalCode.NominalEntries.length > 0 && $ctrl.isExpanded">\n\t\t<div class="nominal-code-preview-code_entry-list-header">PAY ELEMENT</div>\n\t\t<div class="nominal-code-preview-code_entry-list-name" ng-repeat="nominalEntry in $ctrl.nominalCode.NominalEntries">{{nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText}}</div>\n\t</div>\n</div>\n');
$templateCache.put('components/nominal-code-preview/nominal-code-preview.component.html','<div class="nominal-code-preview">\n\t<nominal-code-preview-code ng-repeat="nominalCode in $ctrl.nominalCodesList" nominal-code="nominalCode"></nominal-code-preview-code>\n</div>');
$templateCache.put('components/note/note.component.html','<section class="note" ng-class="[$ctrl.noteAnimation, $ctrl.noteTheme, {\'animate-out\': !$ctrl.isNoteVisible, \'is-emphasised\': $ctrl.noteEmphasise}]">\n\t<div class="note-layout">\n\t\t<h6 ng-if="$ctrl.noteTitle || $ctrl.hasNoteHeader" class="note-title stronger s">\n\t\t\t<div class="checkbox-input primary-alt note-confirmation-checkbox" ng-if="$ctrl.noteHasConfirmation">\n\t\t\t\t<input class="checkbox-input-field note-confirmation-checkbox-input-field" id="{{$ctrl.noteId}}" name="{{$ctrl.noteId}}" ng-model="$ctrl.noteConfirmationField" type="checkbox" required>\n\t\t\t\t<label class="checkbox-input-label note-confirmation-checkbox-label" for="{{$ctrl.noteId}}">&nbsp;&nbsp;</label>\n\t\t\t</div>\n\t\t\t<i class="note-icon" ng-class="[$ctrl.noteIcon, $ctrl.noteTheme, $ctrl.noteIconSize]" ng-if="$ctrl.noteIcon"></i>\n\t\t\t<div class="note-title-content" ng-if="!$ctrl.hasHoteHeader && $ctrl.noteTitle">\n\t\t\t\t<div data-cy="note-title" ng-if="!$ctrl.hasNoteHeader && $ctrl.noteTitle">{{$ctrl.noteTitle}}</div>\n\t\t\t\t<div ng-if="$ctrl.hasNoteCheese" class="tag inverse" ng-class="[$ctrl.noteTheme]">{{$ctrl.noteCheese}}</div>\n\t\t\t</div>\n\t\t\t<span ng-if="$ctrl.hasNoteHeader" ng-transclude="noteHeader"></span>\n\t\t</h6>\n\n\t\t<a class="note-dismiss s" href="" ng-class="$ctrl.noteTheme" ng-click="$ctrl.dismissNote($ctrl)" ng-if="$ctrl.noteDismiss">Dismiss</a>\n\n\t\t<div class="note-action" ng-if="$ctrl.noteHasAction && $ctrl.noteAction">\n\t\t\t<div ng-if="!$ctrl.showActionConfirm" class="fadeIn note-action_icon">\n\t\t\t\t<a href="" ng-click="$ctrl.toggleActionConfirm($ctrl)" ng-class="$ctrl.noteTheme" aria-label="Perform action">\n\t\t\t\t\t<i ng-class="$ctrl.noteActionIcon"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div ng-if="$ctrl.showActionConfirm" class="fadeIn note-action_confirm">\n\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t<a class="note-action_option" href="" ng-click="$ctrl.noteAction()">Yes</a>\n\t\t\t\t<a class="note-action_option" href="" ng-click="$ctrl.toggleActionConfirm($ctrl)">No</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="note-items" ng-if="$ctrl.hasNoteItems" ng-transclude="noteItems"></div>\n\n\t    <div class="note-columns" ng-if="$ctrl.hasNoteColumns" ng-transclude="noteColumns"></div>\n\n\t    <div data-cy="note-content" ng-if="$ctrl.hasNoteContent" ng-transclude="noteContent"></div>\n\t</div>\n</section>\n');
$templateCache.put('components/notification-bar/notification-bar.component.html','<div class="notification-bar" ng-class="$ctrl.tagTheme">\n\t\n\t<!-- Tag -->\n\t<div class="notification-bar_tag">\n\t\t<i class="icon-{{$ctrl.tagIcon}} is-smedium notification-bar_tag-icon"></i>\n\t\t<span class="is-small notification-bar_tag-copy">{{$ctrl.tagCopy}}</span>\n\t</div>\n\n\t<!-- Notification -->\n\t<div class="notification-bar_copy">\n\t\t<p class="is-small" ng-transclude></p>\n\t</div>\n</div>\n');
$templateCache.put('components/notification-block/notification-block.component.html','<div class="notification-block">\n\n\t<div class="notification-block_main">\n\t\n\t\t<!-- Icon -->\n\t\t<div class="notification-block_icon">\n\t\t\t<icon-dot icon="icon-{{$ctrl.icon}}" theme="{{$ctrl.iconTheme}} is-larger"></icon-dot>\n\t\t</div>\n\n\t\t<!-- Details -->\n\t\t<div class="notification-block_details" ng-transclude="nbDetails"></div>\n\t</div>\n\n\t<!-- Actions / Meta -->\n\t<div class="notification-block_actions" ng-if="$ctrl.hasActions" ng-transclude="nbActions"></div>\n\n</div>\n');
$templateCache.put('components/notification-card/notification-card.component.html','<div class="notification-card" ng-class="[$ctrl.theme, {\'has-icon\': $ctrl.hasIcon}]">\n\t<i class="icon-{{$ctrl.icon}} notification-card_icon m" ng-if="$ctrl.hasIcon"></i>\n\t<div class="notification-card_description" ng-transclude="description" ng-if="$ctrl.hasDescription"></div>\n\t<div class="notification-card_action" ng-transclude="action" ng-if="$ctrl.hasAction"></div>\n</div>\n');
$templateCache.put('components/notification-popout/notification-popout.component.html','<div class="notification-popout" is-active="$ctrl.popoutOpen" click-anywhere-but-here="$ctrl.onClickElsewhere($ctrl)">\n\n\t<a aria-label="Toggle notifications" class="notification-popout_toggle is-greyscale is-hover-tertiary" href="" ng-class="{\n\t\t\t\'is-highlighted\': $ctrl.hasNewNotifications,\n\t\t\t\'is-active\': $ctrl.popoutOpen\n\t\t}" ng-click="$ctrl.togglePopout($ctrl)">\n\t\t\t<i class="icon-notification is-large notification-popout_toggle-icon"></i>\n\t</a>\n\n\t<div class="notification-popout_popout fadeIn popout" ng-if="$ctrl.popoutOpen">\n\n\t\t<div class="notification-popout_header">\n\t\t\t<div class="notification-popout_title">\n\t\t\t\t<div class="notification-popout_icon">\n\t\t\t\t\t<i class="icon-notification is-tertiary"></i>\n\t\t\t\t</div>\n\t\t\t\t<h6 class="notification-popout_heading">Notifications</h6>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<nav class="notification-popout_nav tabs">\n\t\t\t<a class="tabs-item" href="" ng-class="{\n\t\t\t\t\t\'active\' : $ctrl.activeTab === $ctrl.POPOUT_TABS.myMentions,\n\t\t\t\t\t\'has-counter\' : $ctrl.totalMyMentions > 0\n\t\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl, $ctrl.POPOUT_TABS.myMentions)">\n\t\t\t\tMy mentions\n\t\t\t\t<span class="tabs-item-counter tag tertiary inverse" ng-if="$ctrl.totalMyMentions > 0">{{$ctrl.totalMyMentions}}</span>\n\t\t\t</a>\n\t\t\t<a class="tabs-item" href="" ng-if="$ctrl.teamAdmins.length > 0" ng-class="{\'active\' : $ctrl.activeTab === $ctrl.POPOUT_TABS.teamMentions}" ng-click="$ctrl.setActiveTab($ctrl, $ctrl.POPOUT_TABS.teamMentions)">\n\t\t\t\tTeam mentions\n\t\t\t</a>\n\t\t\t<a class="tabs-item" href="" ng-class="{\n\t\t\t\t\t\'active\' : $ctrl.activeTab === $ctrl.POPOUT_TABS.updates,\n\t\t\t\t\t\'has-counter\' : $ctrl.totalUpdates > 0\n\t\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl, $ctrl.POPOUT_TABS.updates)">\n\t\t\t\tUpdates\n\t\t\t\t<span class="tabs-item-counter tag tertiary inverse" ng-if="$ctrl.totalUpdates > 0">{{$ctrl.totalUpdates}}</span>\n\t\t\t</a>\n\t\t\t<a class="tabs-item" href="" ng-class="{\n\t\t\t\t\t\'active\' : $ctrl.activeTab === $ctrl.POPOUT_TABS.autoRunWarnings,\n\t\t\t\t\t\'has-counter\' : $ctrl.totalAutoRunWarnings > 0\n\t\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl, $ctrl.POPOUT_TABS.autoRunWarnings)">\n\t\t\t\tAuto run warnings\n\t\t\t\t<span class="tabs-item-counter tag tertiary inverse" ng-if="$ctrl.totalAutoRunWarnings > 0">{{$ctrl.totalAutoRunWarnings}}</span>\n\t\t\t</a>\n\t\t</nav>\n\n\t\t<div ng-if="!$ctrl.hasError" class="notification-popout_content popout_content" ng-switch="$ctrl.activeTab">\n\n\t\t\t<!-- My Mentions -->\n\t\t\t<div class="notification-popout_tab has-actions fadeIn" pc-switch-when="$ctrl.POPOUT_TABS.myMentions">\n\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.myMentions">\n\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t<lb-description>Loading mentions</lb-description>\n\t\t\t\t\t</loading-block>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Mentions -->\n\t\t\t\t<div class="notification-popout_tab-content notification-popout_item-layout fadeIn" ng-if="$ctrl.myMentions.length > 0">\n\n\t\t\t\t\t<div class="notification-popout_item" ng-repeat="(mentionIndex, mention) in $ctrl.myMentions">\n\t\t\t\t\t\t<div class="notification-popout_item-wrapper">\n\t\t\t\t\t\t\t<div class="notification-popout_item-avatar">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{mention.Sender[0]}}" avatar-size="is-tiny"></avatar>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="notification-popout_item-content">\n\t\t\t\t\t\t\t\t<a href="" class="notification-popout_item-heading" ng-click="$ctrl.goToCompany($ctrl, \'payroll.current-period.notes\', mention.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t{{mention.Sender}} <span class="notification-popout_item-subheading">- {{mention.CompanyName}}</span>\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<p class="notification-popout_item-paragraph italic" ng-bind-html="mention.Text | truncate:$ctrl.MENTION_OPTIONS.popoutMaxTextLength:true | mentions:\'is-greyscale\'"></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<a href="" class="notification-popout_item-clear" ng-click="$ctrl.updateMessageStatus($ctrl, mention, mentionIndex, $ctrl.myMentions)" aria="Mark as read"><i class="icon-cross"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No mentions -->\n\t\t\t\t<div class="notification-popout_state fadeIn" ng-if="$ctrl.myMentions.length === 0">\n\n\t\t\t\t\t<div class="notification-popout_state-layout">\n\t\t\t\t\t\t<div class="notification-popout_state-icon">\n\t\t\t\t\t\t\t<i class="icon-sad is-primary xxl"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="notification-popout_state-content">\n\t\t\t\t\t\t\t<h6>No new mentions</h6>\n\t\t\t\t\t\t\t<p class="greyscale-darkened is-small">It looks like nobody needs your attention right now.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bulk actions -->\n\t\t\t\t<div class="notification-popout_tab-actions" ng-switch="$ctrl.clearAllActionState" ng-if="$ctrl.myMentions.length">\n\n\t\t\t\t\t<!-- Action -->\n\t\t\t\t\t<p class="s"><a href="" class="is-greyscale notification-popout_tab-action" ng-click="$ctrl.confirmClearAllMessage($ctrl)" ng-switch-default><i class="icon-cross notification-popout_tab-action-icon"></i>Clear all</a></p>\n\n\t\t\t\t\t<!-- Confirm -->\n\t\t\t\t\t<p class="s fadeIn" ng-switch-when="confirm-clear">Are you sure? <a href="" ng-click="$ctrl.clearAllMessages($ctrl)">Yes</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="" ng-click="$ctrl.resetClearAllActionState()">No</a></p>\n\n\t\t\t\t\t<!-- Loading -->\n\t\t\t\t\t<p class="s" ng-switch-when="loading"><circle-loader class="s"></circle-loader></p>\n\n\t\t\t\t\t<!-- Error -->\n\t\t\t\t\t<p class="s is-assertive fadeIn" ng-switch-when="error">There was a problem clearing all mentions. <a href="" ng-click="$ctrl.resetClearAllActionState()">Try again?</a></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Team Mentions -->\n\t\t\t<div class="notification-popout_tab fadeIn" pc-switch-when="$ctrl.POPOUT_TABS.teamMentions">\n\n\t\t\t\t<div class="notification-popout_tab-content" ng-hide="$ctrl.selectedAdmin">\n\t\t\t\t\t<div class="notification-popout_tab-title">\n\t\t\t\t\t\t<h6 class="notification-popout_tab-heading">SELECT A TEAM MEMBER</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="notification-popout_admins">\n\t\t\t\t\t\t<a aria-label="Show notifications for {{admin.Forename}} {{admin.Surname}}" class="notification-popout_admin" href="" ng-click="$ctrl.loadMentionsForAdmin($ctrl, admin)" ng-repeat="admin in $ctrl.teamAdmins">\n\t\t\t\t\t\t\t<div class="notification-popout_admin-avatar">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{admin.Forename[0]}}" avatar-size="is-tiny"></avatar>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="notification-popout_admin-detail">\n\t\t\t\t\t\t\t\t{{admin.Forename}} {{admin.Surname}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="notification-popout_admin-action">\n\t\t\t\t\t\t\t\t<i class="notification-popout_admin-icon icon-add"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="notification-popout_tab-content" ng-show="$ctrl.selectedAdmin">\n\t\t\t\t\t<div class="notification-popout_tab-title">\n\t\t\t\t\t\t<h6 class="notification-popout_tab-heading">SHOWING MENTIONS FOR</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="notification-popout_admins">\n\t\t\t\t\t\t<a aria-label="Hide notifications for admin" class="notification-popout_admin is-active" href="" ng-click="$ctrl.resetTeamMentions($ctrl)">\n\t\t\t\t\t\t\t<div class="notification-popout_admin-avatar">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{$ctrl.selectedAdmin.Forename[0]}}" avatar-size="is-tiny"></avatar>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="notification-popout_admin-detail">\n\t\t\t\t\t\t\t\t{{$ctrl.selectedAdmin.Forename}} {{$ctrl.selectedAdmin.Surname}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="notification-popout_admin-action">\n\t\t\t\t\t\t\t\t<i class="notification-popout_admin-icon icon-cross"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-if="!$ctrl.selectedAdmin.mentions">\n\t\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t\t<lb-description>Loading mentions</lb-description>\n\t\t\t\t\t\t</loading-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="fadeIn notification-popout_item-layout" ng-if="$ctrl.selectedAdmin.mentions.length > 0">\n\n\t\t\t\t\t\t<div class="notification-popout_item has-border-top" ng-repeat="(mentionIndex, mention) in $ctrl.selectedAdmin.mentions">\n\t\t\t\t\t\t\t<div class="notification-popout_item-wrapper">\n\t\t\t\t\t\t\t\t<div class="notification-popout_item-avatar">\n\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{mention.Sender[0]}}" avatar-size="is-tiny"></avatar>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="notification-popout_item-content">\n\t\t\t\t\t\t\t\t\t<a href="" class="notification-popout_item-heading" ng-click="$ctrl.goToCompany($ctrl, \'payroll.current-period.notes\', mention.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t\t{{mention.Sender}} <span class="notification-popout_item-subheading">- {{mention.CompanyName}}</span>\n\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t<p class="notification-popout_item-paragraph italic" ng-bind-html="mention.Text | truncate:$ctrl.MENTION_OPTIONS.popoutMaxTextLength:true | mentions:\'is-greyscale\'"></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="notification-popout_state is-small fadeIn" ng-if="$ctrl.selectedAdmin.mentions.length === 0">\n\n\t\t\t\t\t\t<div class="notification-popout_state-layout">\n\t\t\t\t\t\t\t<div class="notification-popout_state-icon">\n\t\t\t\t\t\t\t\t<i class="icon-sad is-primary xxl"></i>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="notification-popout_state-content">\n\t\t\t\t\t\t\t\t<h6>No mentions</h6>\n\t\t\t\t\t\t\t\t<p class="greyscale-darkened is-small">It looks like {{$ctrl.selectedAdmin.Forename}} doesn\'t have any mentions right now.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Updates -->\n\t\t\t<div class="notification-popout_tab has-actions fadeIn" pc-switch-when="$ctrl.POPOUT_TABS.updates">\n\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.updates">\n\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t<lb-description>Loading updates</lb-description>\n\t\t\t\t\t</loading-block>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="notification-popout_tab-content notification-popout_item-layout notification-popout_tab-items fadeIn" ng-if="$ctrl.updates.length !== 0">\n\n\t\t\t\t\t<div class="notification-popout_item" ng-repeat="(updateIndex, update) in $ctrl.updates">\n\t\t\t\t\t\t<div class="notification-popout_item-wrapper">\n\t\t\t\t\t\t\t<div class="notification-popout_item-avatar">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{update.Sender[0]}}" avatar-size="is-tiny"></avatar>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="notification-popout_item-content">\n\t\t\t\t\t\t\t\t<a href="" class="notification-popout_item-heading" ng-click="$ctrl.goToCompany($ctrl, \'payroll.current-period.notes\', update.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t{{update.Sender}} <span class="notification-popout_item-subheading">- {{update.CompanyName}}</span>\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<p class="notification-popout_item-paragraph" ng-bind-html="update.Text"></p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<a href="" class="notification-popout_item-clear" ng-click="$ctrl.updateMessageStatus($ctrl, update, updateIndex, $ctrl.updates)"><i class="icon-cross"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No updates -->\n\t\t\t\t<div class="notification-popout_state fadeIn" ng-if="$ctrl.updates.length === 0">\n\n\t\t\t\t\t<div class="notification-popout_state-layout">\n\t\t\t\t\t\t<div class="notification-popout_state-icon">\n\t\t\t\t\t\t\t<i class="icon-information is-primary xxl"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="notification-popout_state-content">\n\t\t\t\t\t\t\t<h6>No updates</h6>\n\t\t\t\t\t\t\t<p class="greyscale-darkened is-small">There are no updates to show right now.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bulk actions -->\n\t\t\t\t<div class="notification-popout_tab-actions" ng-switch="$ctrl.clearAllActionState" ng-if="$ctrl.updates.length !== 0">\n\n\t\t\t\t\t<!-- Action -->\n\t\t\t\t\t<p class="s"><a href="" class="is-greyscale notification-popout_tab-action" ng-click="$ctrl.confirmClearAllUpdates($ctrl)" ng-switch-default><i class="icon-cross notification-popout_tab-action-icon"></i>Clear all</a></p>\n\n\t\t\t\t\t<!-- Confirm -->\n\t\t\t\t\t<p class="s fadeIn" ng-switch-when="confirm-clear">Are you sure? <a href="" ng-click="$ctrl.clearAllUpdates($ctrl)">Yes</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="" ng-click="$ctrl.resetClearAllActionState()">No</a></p>\n\n\t\t\t\t\t<!-- Loading -->\n\t\t\t\t\t<p class="s" ng-switch-when="loading"><circle-loader class="s"></circle-loader></p>\n\n\t\t\t\t\t<!-- Error -->\n\t\t\t\t\t<p class="s is-assertive fadeIn" ng-switch-when="error">There was a problem clearing all updates. <a href="" ng-click="$ctrl.resetClearAllActionState()">Try again?</a></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Auto Run Warnings -->\n\t\t\t<div class="notification-popout_tab fadeIn" pc-switch-when="$ctrl.POPOUT_TABS.autoRunWarnings">\n\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.autoRunWarnings">\n\t\t\t\t\t<loading-block>\n\t\t\t\t\t\t<lb-description>Loading warnings</lb-description>\n\t\t\t\t\t</loading-block>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" ng-if="$ctrl.autoRunWarnings.length > 0">\n\n\t\t\t\t\t<div class="notification-popout_item" ng-class="{ \'is-assertive\': warning.Type === $ctrl.MESSAGE_TYPES.warning }" ng-repeat="warning in $ctrl.autoRunWarnings">\n\t\t\t\t\t\t<div class="notification-popout_item-wrapper">\n\t\t\t\t\t\t\t<div class="notification-popout_item-avatar">\n\t\t\t\t\t\t\t\t<avatar ng-if="warning.Sender !== \'\'" avatar-initial="{{warning.Sender[0]}}" avatar-size="is-tiny" avatar-theme="is-tertiary"></avatar>\n\t\t\t\t\t\t\t\t<icon-dot ng-if="warning.Sender === \'\' && warning.Type !== $ctrl.MESSAGE_TYPES.warning" icon="icon-company" theme="notification-popout_item-icon is-tertiary"></icon-dot>\n\t\t\t\t\t\t\t\t<icon-dot ng-if="warning.Sender === \'\' && warning.Type === $ctrl.MESSAGE_TYPES.warning" icon="icon-warning" theme="notification-popout_item-icon is-assertive"></icon-dot>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="notification-popout_item-content">\n\t\t\t\t\t\t\t\t<a href="" class="notification-popout_item-heading is-tertiary" ng-click="$ctrl.goToCompany($ctrl, \'payroll.current-period.team\', warning.AgencyProfileID)">\n\t\t\t\t\t\t\t\t\t<span ng-if="warning.Sender !== \'\'">{{warning.Sender}} <span class="notification-popout_item-subheading">- {{warning.CompanyName}}</span></span>\n\t\t\t\t\t\t\t\t\t<span ng-if="warning.Sender === \'\'">{{warning.CompanyName}}</span>\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<div class="notification-popout_item-cutoff">\n\t\t\t\t\t\t\t\t\t<p class="notification-popout_item-paragraph italic">\n\t\t\t\t\t\t\t\t\t\t{{warning.Text}}\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="notification-popout_state fadeIn" ng-if="$ctrl.autoRunWarnings.length === 0">\n\n\t\t\t\t\t<div class="notification-popout_state-layout">\n\t\t\t\t\t\t<div class="notification-popout_state-icon">\n\t\t\t\t\t\t\t<i class="icon-smiley is-secondary xxl"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="notification-popout_state-content">\n\t\t\t\t\t\t\t<h6>No warnings</h6>\n\t\t\t\t\t\t\t<p class="greyscale-darkened is-small">Everything looks fine with your companies set to Auto run.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div ng-if="$ctrl.hasError" class="notification-popout_content popout_content">\n\t\t\t<error-block></error-block>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/number-picker/numberPickerComponent.html','<div class="number-picker" ng-class="[theme, { \'is-disabled\' : isDisabled }]">\n\t<div class="number-picker-display">\n\n\t\t<!-- Editable -->\n\t\t<div class="number-picker-input-wrapper" ng-show="isEditable">\n\t\t\t<input class="number-picker-input" id="{{fieldName}}" name="{{fieldName}}" ng-disabled="isDisabled" ng-max="max" ng-min="min" ng-model="ngModel" ng-pattern="ngPattern" required type="number">\n\t\t</div>\n\n\t\t<!-- Non-editable -->\n\t\t<h2 class="strong" ng-if="!isEditable">{{ngModel}}{{figureType === \'percentage\' ? \'%\' : \'\'}}</h2>\n\n\t\t<p class="strong s">{{heading}}</p>\n\t\t<p class="s" ng-if="subHeading">{{subHeading}}</p>\n\t</div>\n\t<div class="number-picker-controls">\n\t\t<a href="" class="number-picker-control number-picker-increment" data-cy="{{fieldName}}-increment" ng-class="{\'disabled\': incrementDisabled}" ng-click="increment()" aria-label="Increase number"><i class="number-picker-chevron icon-chevron-up m"></i></a>\n\t\t<a href="" class="number-picker-control number-picker-decrement" data-cy="{{fieldName}}-decrement" ng-class="{\'disabled\': decrementDisabled}" ng-click="decrement()" aria-label="Decrease number"><i class="number-picker-chevron icon-chevron-down m"></i></a>\n\t</div>\n</div>\n');
$templateCache.put('components/office-location-card/office-location-card.component.html','<div class="office-location-card">\n\t<dropdown-menu class="office-location-card_action-menu primary" menu-theme="is-primary" menu-size="l" menu-show-chevron="false" menu-icon="icon-setup" menu-show="$ctrl.showActionMenu">\n\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="$ctrl.openEditDetailsForm($ctrl, $ctrl.ipAddress.IPAddressID)">Edit details</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeleteOfficeLocationForm($ctrl, $ctrl.ipAddress)">Delete</a>\n\t\t</div>\n\n\t</dropdown-menu>\n\n\t<div class="office-location-card_header">\n\t\t<div class="office-location-card_icon">\n\t\t\t<icon-dot theme="primary is-extra-large" icon="icon-company"></icon-dot>\n\t\t</div>\n\t</div>\n\t<div class="office-location-card_footer">\n\t\t<div class="office-location-card_description">\n\t\t\t{{$ctrl.ipAddress.Description}}\n\t\t</div>\n\t\t<div class="office-location-card_ip-address-range">\n\t\t\t{{$ctrl.ipAddress.ValueStart}}&nbsp;&nbsp;<i class="icon-arrow-right primary m"></i>&nbsp;&nbsp;{{$ctrl.ipAddress.ValueEnd}}\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/office-location-form-field/office-location-form-field.component.html','<div class="office-location-form-field">\n\n\t<div class="office-location-form-field_delete" ng-if="$ctrl.showDelete">\n\t\t<a class="greyscale" href="" ng-click="$ctrl.toggleConfirmDeleteOfficeLocation($ctrl.ipAddress)" ng-if="!$ctrl.ipAddress.confirmOfficeLocationDelete" aria-label="Delete office location"><i class="icon-trash"></i></a>\n\t\t<div ng-if="$ctrl.ipAddress.confirmOfficeLocationDelete"><p class="s strong">Are you sure?&nbsp;\n\t\t\t<a href="" ng-click="$ctrl.deleteOfficeLocation($ctrl)">Yes</a><span class="greyscale">&nbsp;|&nbsp;</span><a href="" ng-click="$ctrl.toggleConfirmDeleteOfficeLocation($ctrl.ipAddress)">No</a></p></div>\n\t</div>\n\n\t<div class="form-field-group">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.descriptionFieldName}}" class="required">Location name</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="text" name="{{$ctrl.descriptionFieldName}}" ng-model="$ctrl.ipAddress.Description" ng-model-options="{ debounce: 250 }" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.descriptionFieldName].$error" ng-show="$ctrl.form[$ctrl.descriptionFieldName].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a location name</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-field-group">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.valueStartFieldName}}" class="required">IP address range</label>\n\t\t\t</header>\n\t\t\t<div class="office-location-form-field_ip-address-range">\n\t\t\t\t<div class="office-location-form-field_ip-address">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<ip-address ip-address="$ctrl.ipAddress.ValueStart" name="{{$ctrl.valueStartFieldName}}" on-change="$ctrl.onIPAddressRangeChange($ctrl, $ctrl.ipAddress.ValueStart, $ctrl.ipAddress.ValueEnd)" ip-address-required="true"></ip-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.valueStartFieldName].$error" ng-show="$ctrl.form[$ctrl.valueStartFieldName].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">A valid IP address is required</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an IP address</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="office-location-form-field_ip-address-range-separator">\n\t\t\t\t\t<i class="icon-arrow-right primary m"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="office-location-form-field_ip-address">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<ip-address ip-address="$ctrl.ipAddress.ValueEnd" name="{{$ctrl.valueEndFieldName}}" on-change="$ctrl.onIPAddressRangeChange($ctrl, $ctrl.ipAddress.ValueStart, $ctrl.ipAddress.ValueEnd)" ip-address-required="true"></ip-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.valueEndFieldName].$error" ng-show="$ctrl.form[$ctrl.valueEndFieldName].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">A valid IP address is required</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an IP address</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn office-location-form-field_invalid-range" ng-messages="$ctrl.form[$ctrl.valueStartFieldName].$error" ng-show="$ctrl.form[$ctrl.valueStartFieldName].$touched" role="alert">\n\t\t\t\t<p ng-message="ipAddressRangeInvalid">Please enter a valid IP address range</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/onboarding-card/onboardingCardComponent.html','<a href="" class="onboarding-card clickable {{onboardingQuestionGroup.theme}}" ng-click="onClick(onboardingQuestionGroup)" ng-class="{\'onboarding-card--active\' : onboardingActions.showTasksFor === onboardingQuestionGroup.OnboardingQuestionGroupID }">\n\t<div class="onboarding-card__card">\n\t\t<div class="onboarding-card__background"></div>\n\t\t<div class="onboarding-card__arrow"></div>\n\t\t<div class="onboarding-card__layout">\n\t\t\t<div class="onboarding-card__header">\n\t\t\t\t<i class="icon-{{onboardingQuestionGroup.icon}} onboarding-card__icon {{onboardingActions.showTasksFor !== onboardingQuestionGroup.OnboardingQuestionGroupID ? \'gradient \' + onboardingQuestionGroup.theme : \'\'}}"></i>\n\t\t\t\t<h4 class="onboarding-card__title">{{onboardingQuestionGroup.GroupName}}</h4>\n\t\t\t</div>\n\t\t\t<div class="onboarding-card__progress">\n\t\t\t\t<div class="onboarding-card__progress-ring" ng-if="onboardingQuestionGroup.OnboardingQuestionGroupID !== ONBOARDING_QUESTION_GROUPS.team" tooltip tooltip-text="{{onboardingQuestionGroup.percentageComplete < 100 && onboardingQuestionGroup.percentageComplete >= 0 ? onboardingQuestionGroup.totalQuestionsRemaining + \' questions left to answer\' : \'All questions answered\'}}">\n\t\t\t\t\t<progress-ring pr-percentage="onboardingQuestionGroup.percentageComplete" pr-show-percentage="true" pr-theme-complete="{{onboardingQuestionGroup.theme}}" pr-theme-incomplete="{{onboardingActions.showTasksFor === onboardingQuestionGroup.OnboardingQuestionGroupID ? \'clear\' : \'greyscale\' }}"></progress-ring>\n\t\t\t\t</div>\n\t\t\t\t<div class="onboarding-card__progress-team" ng-if="onboardingQuestionGroup.OnboardingQuestionGroupID === ONBOARDING_QUESTION_GROUPS.team">\n\t\t\t\t\t<p class="onboarding-card__progress-count">{{onboardingTeamMembersCount}}</p>\n\t\t\t\t\t<p class="s">added</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="onboarding-card__contents" ng-switch="onboardingQuestionGroup.OnboardingQuestionGroupID">\n\t\t\t\t<h6 class="onboarding-card__sub" pc-switch-when="ONBOARDING_QUESTION_GROUPS.team">\n\t\t\t\t\t7 steps/team member\n\t\t\t\t</h6>\n\t\t\t\t<h6 class="onboarding-card__sub" ng-switch-default>\n\t\t\t\t\t<ng-pluralize count="onboardingQuestionGroup.Questions.length" when="onboardingQuestionGroup.questionCountCopy"></ng-pluralize>\n\t\t\t\t</h6>\n\t\t\t\t<p class="onboarding-card__copy">{{onboardingQuestionGroup.description}}</p>\n\t\t\t\t<div class="onboarding-card__time">\n\t\t\t\t\t<i class="icon-clock onboarding-card__time-icon"></i> Time : {{onboardingQuestionGroup.timeToComplete}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<i class="icon-chevron-down onboarding-card__toggle"></i>\n\t\t</div>\n\t</div>\n</a>\n');
$templateCache.put('components/overlay-form/overlay-form.component.html','<div class="overlay-form">\n\t<div class="overlay-form_container">\n\n\t\t<a href="" ng-click="$ctrl.onClose()" class="overlay-form_close" ng-if="$ctrl.hasClose">\n\t\t\t<i class="icon-arrow-right overlay-form_close-icon"></i>\n\t\t\t<p class="overlay-form_close-copy">back</p>\n\t\t</a>\n\n\t\t<header class="overlay-form_header" ng-transclude="header"></header>\n\n\t\t<div class="overlay-form_pre-main" ng-transclude="preMain"></div>\n\n\t\t<div class="overlay-form_main-wrapper">\n\t\t\t<div class="overlay-form_main" ng-transclude="main"></div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/overview-card/overview-card.component.html','<div class="overview-card" ng-class="$ctrl.theme" ng-switch="$ctrl.details.header.layout">\n\n\t<div class="overview-card_main">\n\n\t\t<!-- Header -->\n\t\t<div class="overview-card_header">\n\n\t\t\t<div class="overview-card_header-block">\n\n\t\t\t\t<div class="overview-card_title-wrapper">\n\n\t\t\t\t\t<!-- Title block -->\n\t\t\t\t\t<div class="overview-card_title-block">\n\t\t\t\t\t\t<icon-dot class="overview-card_title-block-icon" icon="icon-{{::$ctrl.details.header.icon}}" icon-size="is-medium" theme="is-extra-extra-large {{::$ctrl.details.header.iconTheme}}"></icon-dot>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<p class="overview-card_title">{{::$ctrl.details.header.title}}</p>\n\t\t\t\t\t\t\t<p class="overview-card_subtitle">{{::$ctrl.details.header.subtitle}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Tag (only to accompany doughnut layout) -->\n\t\t\t\t\t<div class="overview-card_header-meta" ng-switch-when="doughnut">\n\n\t\t\t\t\t\t<!-- Tag -->\n\t\t\t\t\t\t<div class="tag is-primary inverse">\n\t\t\t\t\t\t\t{{::$ctrl.details.header.tag}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Stat block -->\n\t\t\t\t<div>\n\n\t\t\t\t\t<!-- Tag -->\n\t\t\t\t\t<div class="tag is-tertiary inverse" ng-switch-when="bar">\n\t\t\t\t\t\t{{::$ctrl.details.header.tag}}\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Pie chart -->\n\t\t\t\t\t<div class="overview-card_header-chart" ng-switch-when="doughnut">\n\t\t\t\t\t\t<canvas height="100" id="overview-card_doughnut" width="100"></canvas>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Body -->\n\t\t<div class="overview-card_body" ng-switch-when="bar">\n\t\t\t<div class="overview-card_progress-bar">\n\t\t\t\t<progress-bar pb-percentage="$ctrl.details.main.barPercentage" pb-theme="is-tertiary is-base-white-transparent"></progress-bar>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Footer -->\n\t<div class="overview-card_footer">\n\t\t<div class="overview-card_stats" ng-if="$ctrl.details.stats.length">\n\t\t\t<div class="overview-card_stat" ng-class="{\n\t\t\t\t\t\'is-number\': stat.type === \'number\'\n\t\t\t\t}" ng-repeat="stat in $ctrl.details.stats" ng-switch="stat.type">\n\t\t\t\t<p class="overview-card_stat-value">{{stat.value}}</p>\n\n\t\t\t\t<!-- Static text -->\n\t\t\t\t<p class="overview-card_stat-description" ng-switch-default>\n\t\t\t\t\t{{stat.description}}\n\t\t\t\t</p>\n\n\t\t\t\t<!-- Click event -->\n\t\t\t\t<p class="overview-card_stat-link" ng-switch-when="click">\n\t\t\t\t\t<a href="" ng-click="stat.onClick()">\n\t\t\t\t\t\t{{stat.description}}\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="overview-card_footer-actions" ng-if="$ctrl.hasFooterActions" ng-transclude="footerActions"></div>\n\t</div>\n</div>\n');
$templateCache.put('components/overview-data/overviewDataComponent.html','<div class="task-list-groups">\n\t<div class="task-list-group" ng-repeat="overviewGroup in overviewGroups">\n\t\t<h5 class="task-list-group-title">{{overviewGroup.groupTitle}}</h5>\n\n\t\t<div class="task-list has-margin">\n\t\t\t<div class="task-list-item" ng-class="{\'is-complete\': task.isComplete, \'is-skipped\': task.isSkipped, \'is-not-entered\': !task.isMandatory && !task.isComplete, \'required\': task.isMandatory}" ng-hide="task.isHidden" ng-repeat="task in overviewGroup.taskList">\n\t\t\t\t<label class="task-list-item-label" ng-class="{\'required\': task.isMandatory}">{{task.title}}</label>\n\n\t\t\t\t<!-- Skipped -->\n\t\t\t\t<p class="task-list-item-value" ng-if="task.isSkipped">Skipped</p>\n\n\t\t\t\t<!-- Not skipped -->\n\t\t\t\t<div ng-switch="task.valueType" ng-if="!task.isSkipped">\n\t\t\t\t\t<div class="task-list-item-value" ng-switch-when="address">\n\t\t\t\t\t\t<print-address address="task.value"></print-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="boolean">{{task.value ? \'Yes\' : \'No\'}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="date">{{task.value | dateformat}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="monetise">{{task.value | monetise}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="salary-type">{{task.value | paymentTypeDescription}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-default>{{task.value !== \'\' ? task.value : \'Not entered\'}}</p>\n\t\t\t\t</div>\n\t\t\t\t<a href="" ng-click="onEdit(task.wizardFormStepIndex)" class="task-list-item-edit" aria-label="Edit"><i class="icon-edit"></i></a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/p11db-submissions-card/p11db-submissions-card.html','<div class="p11db-submissions-card fadeIn" ng-class="$ctrl.theme">\n\t<div class="p11db-submissions-card_main">\n\n\t\t<!-- Icon -->\n\t\t<div class="p11db-submissions-card_icon">\n\t\t\t<icon-dot icon="icon-billing" icon-size="is-medium" theme="is-larger {{$ctrl.theme}}"></icon-dot>\n\t\t</div>\n\n\t\t<!-- Main content -->\n\t\t<div class="p11db-submissions-card_content">\n\t\t\t<div>\n\t\t\t\t<h6 class="p11db-submissions-card_description">\n\t\t\t\t\t{{::$ctrl.p11dbSubmission.TaxYearDisplay }}\n\t\t\t\t</h6>\n\t\t\t\t<p class="p11db-submissions-card_state">\n\t\t\t\t\t{{::$ctrl.state }}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="p11db-submissions-card_stats">\n\t\t\t<h6 class="p11db-submissions-card_main_stat">\n\t\t\t\t{{::$ctrl.p11dbSubmission.P11DbSubmissionNICPayable | monetise}}\n\t\t\t</h6>\n\t\t\t<p class="p11db-submissions-card_secondary_stat">\n\t\t\t\tClass 1A NICs payable\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Card Menu -->\n\t\t<div class="p11db-submissions-card_menu">\n\t\t\t<dropdown-menu menu-icon="icon-setup" menu-on-open="$ctrl.getReportForP11Db()" menu-size="l" menu-show-chevron="false" menu-theme="{{$ctrl.theme}}">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a class="primary" ng-click="$ctrl.editP11DbSubmission($ctrl.p11dbSubmission)" ng-if="$ctrl.isContinueOptionVisible" title="Continue">\n\t\t\t\t\t\tContinue\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="primary" title="Download P11D(b) Report" ui-sref="p11db-report({\n\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.p11dbSubmission.AgencyProfileID,\n\t\t\t\t\t\t\t\tp11DbSubmissionID: $ctrl.p11dbSubmission.P11DbSubmissionID,\n\t\t\t\t\t\t\t\topenedFrom:\'card\'\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\tDownload P11D(b) Report\n\t\t\t\t\t</a>\n\t\t\t\t\t<div ng-if="$ctrl.isViewSubmissionFileOptionVisible" ng-switch="$ctrl.reportViewState">\n\t\t\t\t\t\t<div class="centered-contents" ng-switch-when="loading">\n\t\t\t\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-switch-when="ready">\n\t\t\t\t\t\t\t<a class="primary" ng-click="$ctrl.viewSubmissionFile($ctrl.reports[0])" title="View submission file">\n\t\t\t\t\t\t\t\tView submission file\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<a class="assertive" ng-click="$ctrl.openDeleteConfirmationView()" ng-if="$ctrl.isContinueOptionVisible" title="Delete">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<!-- Card Footer -->\n\t<footer class="p11db-submissions-card_footer">\n\t\t<i class="p11db-submissions-card_footer_icon" ng-class="\'icon-loading\'">\n\t\t</i>&nbsp;\n\t\t<p class="is-small italic">\n\t\t\t{{$ctrl.state === \'Draft\' ? \'Updated by\' : \'Submitted by\'}} {{$ctrl.p11dbSubmission.P11DbSubmissionActionerName}} at {{$ctrl.p11dbSubmission.P11DbSubmissionLastUpdatedDateISO | datetimeformat:\'detailed\'}}\n\t\t</p>\n\t</footer>\n</div>\n');
$templateCache.put('components/page-template-a-header/pageTemplateAHeaderComponent.html','<header class="page-template-a-header" ng-class="theme">\n\t<div class="page-template-a-title-container">\n\t\t<h2 class="page-template-a-title">\n\t\t\t<i class="icon-{{icon}} page-template-a-icon" ng-if="icon"></i>\n\t\t\t<span class="page-template-a-emoji" ng-if="emoji">{{emoji}}</span>\n\t\t\t<span class="page-template-a-title" data-cy="page-template-title">\n\t\t\t\t{{pageTitle}}\n\t\t\t</span>\n\t\t\t<span class="page-template-a-breadcrumb" ng-transclude="breadcrumb" ng-if="hasBreadcrumb && showBreadcrumb"></span>\n\t\t\t<span class="page-template-a-subtitle" ng-if="hasSubTitle">{{pageSubTitle}}</span>\n\t\t</h2>\n\t\t<div class="page-template-a-title-menu" ng-transclude="titleMenu" ng-if="hasTitleMenu"></div>\n\t</div>\n\t<div class="page-template-a-subheading" ng-transclude="subHeading" ng-if="hasSubHeading"></div>\n\t<div class="page-template-a-secondary {{secondaryContentType}}" ng-transclude="secondaryContent" ng-if="hasSecondaryContent && showSecondaryContent"></div>\n</header>\n');
$templateCache.put('components/page-template-c-header/pageTemplateCHeaderComponent.html','<header class="page-template-c-header">\n\t<div class="page-template-c-header-tertiary {{tertiaryContentType}}" ng-transclude="tertiaryContent" ng-if="hasTertiaryContent && showTertiaryContent"></div>\n\t<div class="page-template-c-title-container">\n\t\t<h2 class="page-template-c-title">\n\t\t\t<i class="icon-{{icon}} page-template-c-icon" ng-if="icon"></i>\n\t\t\t<span class="page-template-c-emoji" ng-if="emoji">{{emoji}}</span>\n\t\t\t<span class="page-template-c-title" data-cy="page-template-title">\n\t\t\t\t{{pageTitle}}\n\t\t\t</span>\n\t\t\t<span class="page-template-c-breadcrumb" ng-transclude="breadcrumb" ng-if="hasBreadcrumb && showBreadcrumb"></span>\n\t\t\t<span class="page-template-c-subtitle" ng-if="hasSubTitle">{{pageSubTitle}}</span>\n\t\t</h2>\n\t\t<div class="page-template-c-title-label" ng-if="hasTotalCost">\n\t\t\t<h2 class="page-template-c-title-label-value" ng-transclude="totalCost"></h2>\n\t\t\t<span class="page-template-c-title-label-description">Total cost</span>\n\t\t</div>\n\t</div>\n\t<div class="page-template-c-subheading" ng-transclude="subHeading" ng-if="hasSubHeading"></div>\n\t<div class="page-template-c-action-menu" ng-transclude="actionMenu" ng-if="hasActionMenu"></div>\n\t<div class="page-template-c-header-secondary {{secondaryContentType}}" ng-transclude="secondaryContent" ng-if="hasSecondaryContent && showSecondaryContent"></div>\n</header>\n');
$templateCache.put('components/pay-element-toggle-card/payElementToggleCardComponent.html','<div class="pay-element-type-card {{payElementType.Category === \'Deductions\' ? \'assertive\' : \'positive\'}}" data-cy="pay-element-type-card">\n\t<i class="icon-{{payElementType.Category === \'Deductions\' ? \'minus\' : \'add\'}} pay-element-type-card-icon" data-cy="pay-element-icon"></i>\n\t<p class="pay-element-type-card-name" title="{{payElementType.AgencyAdjustmentGroupEntryText}}" data-cy="pay-element-name-{{::payElementType.AgencyAdjustmentGroupEntryText| slugify}}">{{payElementType.AgencyAdjustmentGroupEntryText}}</p>\n\t<p class="pay-element-type-card-description" data-cy="pay-element-category-{{::payElementType.Category| slugify}}">{{payElementType.Category}}</p>\n\t<div class="pay-element-type-card-right" data-cy="pay-element-navigate"><i class="icon-chevron-right"></i></div>\n</div>\n');
$templateCache.put('components/pay-element-type-card/pay-element-type-card-basic.component.html','<div class="pay-element-type-card" ng-class="::[\n\t\t$ctrl.theme,\n\t\t{\n\t\t\t\'is-assertive\': $ctrl.isDeduction,\n\t\t\t\'is-positive\': !$ctrl.isDeduction\n\t\t}\n\t]">\n\t<span class="pay-element-type-card-icon">\n\t\t<i class="icon-{{::$ctrl.isDeduction ? \'minus\' : \'add\'}}"></i>\n\t</span>\n\t<p class="pay-element-type-card-name" title="{{payElementType.AgencyAdjustmentGroupEntryText}}">\n\t\t{{::$ctrl.label}}\n\t</p>\n\t<p class="pay-element-type-card-description" ng-if="::$ctrl.description">\n\t\t{{::$ctrl.description}}\n\t</p>\n</div>\n');
$templateCache.put('components/pay-element-type-card/pay-element-type-card.component.html','<div class="pay-element-type-card {{payElementType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-class="{\n\t\t\'has-actions\': hasActions,\n\t\t\'has-menu-open\': vm.showMenu\n\t}">\n\t<span class="pay-element-type-card-icon">\n\t\t<i class="icon-duplicate" ng-if="payElementType.NonStandard"></i>\n\t\t<i class="icon-{{payElementType.IsDeduction ? \'minus\' : \'add\'}}" ng-if="!payElementType.NonStandard"></i>\n\t</span>\n\t<p class="pay-element-type-card-name" title="{{payElementType.AgencyAdjustmentGroupEntryText}}">\n\t\t{{payElementType.AgencyAdjustmentGroupEntryText}}\n\t</p>\n\t<p class="pay-element-type-card-description">\n\t\t{{::payElementType.payElementDescription}}\n\t</p>\n\t<div class="pay-element-type-card-right">\n\t\t<i class="icon-chevron-right"></i>\n\t</div>\n\n\t<dropdown-menu class="pay-element-type-card-actions" menu-icon="icon-setup" menu-show-chevron="false" menu-show="vm.showMenu" menu-size="l" ng-if="hasActions" data-cy="pay-element-dropdown-menu-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t<div class="dropdown-group" data-cy="pay-element-dropdown-group-duplicate-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t<a href="" ng-click="openDuplicatePayElementForm(payElementType)" ng-if="\n\t\t\t\t\t!payElementType.NonStandard &&\n\t\t\t\t\tpayElementType.canDuplicate &&\n\t\t\t\t\t(\n\t\t\t\t\t\t$root.currentCompany.CompanyType !== INTERFACE_TYPES.bureau ||\n\t\t\t\t\t\t($root.currentCompany.CompanyType === INTERFACE_TYPES.bureau && $root.currentUser.Permissions.Admin.canDuplicatePayElements)\n\t\t\t\t\t)" data-cy="pay-element-duplicate-element-link-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t\tDuplicate element\n\t\t\t</a>\n\t\t\t<a href="" ng-click="onViewDetails(payElementType)" data-cy="pay-element-view-details-link-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t\tView details\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="\n\t\t\t\tpayElementType.NonStandard && (\n\t\t\t\t\t$root.currentCompany.CompanyType !== INTERFACE_TYPES.bureau ||\n\t\t\t\t\t($root.currentCompany.CompanyType === INTERFACE_TYPES.bureau && $root.currentUser.Permissions.Admin.canDeleteDuplicatedPayElements)\n\t\t\t\t)" data-cy="pay-element-dropdown-group-delete-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t<a class="assertive" href="" ng-click="openDeletePayElementForm(payElementType)" data-cy="pay-element-delete-element-link-{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t\tDelete element\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/pay-element-type-row/payElementTypeRowComponent.html','<div class="pay-element-type-row" data-cy="pay-element-type-{{::payElementTypeIndex}}" ng-class="{\n\t\t\'is-assertive\': payElementType.IsDeduction,\n\t\t\'is-positive\': !payElementType.IsDeduction,\n\t}">\n\n\t<div class="pay-element-type-row_meta">\n\t\t<div class="pay-element-type-row_icon">\n\t\t\t<i ng-class="{\n\t\t\t\t\t\'icon-minus\': payElementType.IsDeduction,\n\t\t\t\t\t\'icon-add\': !payElementType.IsDeduction\n\t\t\t\t}"></i>\n\t\t</div>\n\n\t\t<span class="pay-element-type-row_name">\n\t\t\t{{payElementType.AgencyAdjustmentGroupEntryText}}\n\t\t</span>\n\t</div>\n\n\t<div class="pay-element-type-row_attributes">\n\n\t\t<!-- Pensionable -->\n\t\t<icon-dot icon="icon-money" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntryPensionState" theme="is-quaternary has-hover" tooltip-text="Pensionable"></icon-dot>\n\n\t\t<!-- Net Pay -->\n\t\t<icon-dot icon="icon-wallet" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntryNetPayState && !isPensionOnly" theme="is-quaternary has-hover" tooltip-text="Net Pay calculations"></icon-dot>\n\n\t\t<!-- Salary Sacrifice -->\n\t\t<icon-dot icon="icon-salary-change" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntrySalarySacrificeState" theme="is-quaternary has-hover" tooltip-text="Included in salary sacrifice calculation"></icon-dot>\n\n\t\t<icon-dot icon="icon-clock" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntryPayrollBIKState" theme="is-quaternary has-hover" tooltip-text="Payrolled Benefit in Kind"></icon-dot>\n\n\t\t<!-- Holiday Accrual -->\n\t\t<icon-dot icon="icon-holiday" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntryHolidayState" theme="is-quaternary has-hover" tooltip-text="Included in holiday pay calculations"></icon-dot>\n\n\t\t<!-- Prorate -->\n\t\t<icon-dot icon="icon-calendar" is-light="true" ng-if="payElementType.AgencyAdjustmentGroupEntryProrateState" theme="is-quaternary has-hover" tooltip-text="Proration enabled"></icon-dot>\n\n\t\t<!-- Visible -->\n\t\t<icon-dot icon="icon-{{payElementType.AgencyAdjustmentGroupEntryVisible ? \'visible\' : \'hidden\'}}" is-light="true" ng-if="!isPensionOnly" theme="{{payElementType.AgencyAdjustmentGroupEntryVisible ? \'is-primary\' : \'is-tertiary\'}} has-hover" tooltip-text="{{payElementType.AgencyAdjustmentGroupEntryVisible ? \'Visible\' : \'Hidden\'}}"></icon-dot>\n\t</div>\n\n\t<div class="pay-element-type-row_action">\n\t\t<a aria-label="Edit pay element" class="pay-element-type-row_edit greyscale" data-cy="pay-element-type-edit" href="" ng-click="onEditPayElement(payElementType, payElementTypeGroup)" ng-if="payElementType.canEdit">\n\t\t\t<i class="icon-edit"></i>\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/pay-information-calculations-fieldset/pay-information-calculations-fieldset.component.html','<fieldset ng-switch="$ctrl.componentState">\n\n\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\n\t\t<div class="form-section form-field-highlight is-primary">\n\n\t\t\t<div class="form-intro has-action" ng-switch="$ctrl.overrideState">\n\t\t\t\t<h5>Calculation settings</h5>\n\t\t\t\t<p class="is-small fadeIn" ng-if="$ctrl.teamMember.salary.UseCompanyDefaults">\n\t\t\t\t\tThe below company settings can be overridden for {{::$ctrl.teamMember.personal.Forename}}:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small fadeIn" ng-if="!$ctrl.teamMember.salary.UseCompanyDefaults">\n\t\t\t\t\tAny changes to settings will only be applied for {{::$ctrl.teamMember.personal.Forename}}.\n\t\t\t\t</p>\n\n\t\t\t\t<!-- Company Defaults -->\n\t\t\t\t<a class="form-intro_action link-with-icon is-primary-light fadeIn" data-cy="calculation-settings-override" href="" ng-click="$ctrl.onOverrideCompanyDefaults()" pc-switch-when="$ctrl.OVERRIDE_STATE.companyDefaults">\n\t\t\t\t\t<i class="icon-edit is-smedium"></i> Override\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Overridden -->\n\t\t\t\t<a class="form-intro_action link-with-icon is-primary-light fadeIn" data-cy="calculation-settings-delete" href="" ng-click="$ctrl.onDeleteOverride()" pc-switch-when="$ctrl.OVERRIDE_STATE.overridden">\n\t\t\t\t\t<i class="icon-trash is-smedium"></i> Delete\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Confirm Undo -->\n\t\t\t\t<span class="form-intro_action is-small fadeIn" pc-switch-when="$ctrl.OVERRIDE_STATE.confirmUndo">\n\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t<a data-cy="calculation-settings-delete-yes" href="" ng-click="$ctrl.onConfirmUndoContinue()">Yes</a>\n\t\t\t\t\t<span class="is-greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t<a data-cy="calculation-settings-delete-no" href="" ng-click="$ctrl.onConfirmUndoCancel($)">No</a>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<!-- Company defaults -->\n\t\t\t<div class="fadeIn" ng-if="$ctrl.teamMember.salary.UseCompanyDefaults">\n\n\t\t\t\t<!-- Calculation order -->\n\t\t\t\t<fieldset>\n\n\t\t\t\t\t<h6>Calculation order</h6>\n\n\t\t\t\t\t<div class="stat-list is-primary-darkened align-value-right basic">\n\t\t\t\t\t\t<div class="stat-list__row fadeIn">\n\t\t\t\t\t\t\t<span class="stat-list__key" data-cy="calculation-settings-calculate-gross-to-net-elements-first">Calculate gross to net elements of pay before net to gross:</span>\n\t\t\t\t\t\t\t<span class="stat-list__value" data-cy="calculation-settings-calculate-gross-to-net-elements-first-value">{{ ::$ctrl.companyCalculationDetail.CalculateGrossToNetElementsFirst | yesNo }}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Net to gross calculations -->\n\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-padding">\n\n\t\t\t\t\t<h6>Net to gross calculations</h6>\n\n\t\t\t\t\t<div class="stat-list is-primary-darkened align-value-right basic">\n\t\t\t\t\t\t<!-- National Insurance -->\n\t\t\t\t\t\t<div class="stat-list__row fadeIn" ng-if="$ctrl.teamMember.salary.CalculationDetails.HasNetToGrossEENIPaidByEmployer">\n\t\t\t\t\t\t\t<span class="stat-list__key" data-cy="calculation-settings-net-to-gross-eeni-paid-by-employer">Gross up for Employee NI:</span>\n\t\t\t\t\t\t\t<span class="stat-list__value" data-cy="calculation-settings-net-to-gross-eeni-paid-by-employer-value">{{ ::$ctrl.companyCalculationDetail.NetToGrossEENIPaidByEmployer | yesNo }}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Pension Contributions -->\n\t\t\t\t\t\t<div class="stat-list__row fadeIn">\n\t\t\t\t\t\t\t<span class="stat-list__key" data-cy="calculation-settings-net-to-gross-pension-paid-by-employer">Gross up for pension contributions:</span>\n\t\t\t\t\t\t\t<span class="stat-list__value" data-cy="calculation-settings-net-to-gross-pension-paid-by-employer-value">{{ ::$ctrl.companyCalculationDetail.NetToGrossPensionPaidByEmployer | yesNo }}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Student Loans -->\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key" data-cy="calculation-settings-net-to-gross-sl-paid-by-employer">Gross up for student loans (Plan 1, 2, 4, and 5):</span>\n\t\t\t\t\t\t\t<span class="stat-list__value" data-cy="calculation-settings-net-to-gross-sl-paid-by-employer-value">{{ ::$ctrl.companyCalculationDetail.NetToGrossSLPaidByEmployer | yesNo }}</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Postgraduate Loans -->\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key" data-cy="calculation-settings-net-to-gross-pgl-paid-by-employer">Gross up for postgraduate loans:</span>\n\t\t\t\t\t\t\t<span class="stat-list__value" data-cy="calculation-settings-net-to-gross-pgl-paid-by-employer-value">{{ ::$ctrl.companyCalculationDetail.NetToGrossPGLPaidByEmployer | yesNo }}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t</div>\n\n\t\t\t<!-- Team member override -->\n\t\t\t<fieldset class="fadeIn" ng-if="!$ctrl.teamMember.salary.UseCompanyDefaults">\n\n\t\t\t\t<fieldset>\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<h5>Calculation order</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="calculateGrossToNetElementsFirstYes">Calculate gross to net elements before net to gross:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="calculateGrossToNetElementsFirstYes" name="calculateGrossToNetElementsFirst" ng-model="$ctrl.teamMember.salary.CalculationDetails.CalculateGrossToNetElementsFirst" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="calculateGrossToNetElementsFirstYes">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="calculateGrossToNetElementsFirstNo" name="calculateGrossToNetElementsFirst" ng-model="$ctrl.teamMember.salary.CalculationDetails.CalculateGrossToNetElementsFirst" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="calculateGrossToNetElementsFirstNo">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Net to gross calculations -->\n\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-gap">\n\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<h5>Net to gross calculations</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- NI -->\n\t\t\t \t\t<div class="form-field" ng-if="$ctrl.teamMember.salary.CalculationDetails.HasNetToGrossEENIPaidByEmployer">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="netToGrossEENIPaidByEmployerYes">Gross up for Employee NI:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossEENIPaidByEmployerYes" name="netToGrossEENIPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossEENIPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossEENIPaidByEmployerYes">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossEENIPaidByEmployerNo" name="netToGrossEENIPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossEENIPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossEENIPaidByEmployerNo">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t\t\t<!-- Pension -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="netToGrossPensionPaidByEmployerYes">Gross up for pension contributions:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPensionPaidByEmployerYes" name="netToGrossPensionPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossPensionPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPensionPaidByEmployerYes">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPensionPaidByEmployerNo" name="netToGrossPensionPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossPensionPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPensionPaidByEmployerNo">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t \t\t<!-- Student Loan -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="netToGrossSLPaidByEmployerYes">Gross up for student loans (Plan 1, 2, 4, and 5):</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossSLPaidByEmployerYes" name="netToGrossSLPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossSLPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossSLPaidByEmployerYes">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossSLPaidByEmployerNo" name="netToGrossSLPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossSLPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossSLPaidByEmployerNo">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t \t\t<!-- Postgradute Loan -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="netToGrossPGLPaidByEmployerYes">Gross up for postgraduate loans:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPGLPaidByEmployerYes" name="netToGrossPGLPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossPGLPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPGLPaidByEmployerYes">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPGLPaidByEmployerNo" name="netToGrossPGLPaidByEmployer" ng-model="$ctrl.teamMember.salary.CalculationDetails.NetToGrossPGLPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPGLPaidByEmployerNo">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t</fieldset>\n\t\t</div>\n\n\t</div>\n\n\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n\n</fieldset>\n');
$templateCache.put('components/pay-information-currencies-fieldset/pay-information-currencies-fieldset.component.html','<fieldset class="form-field-highlight is-primary fadeInFast" ng-if="$ctrl.currencies.length > 0">\n\n\t<div class="form-intro">\n\t\t<h5>Currency</h5>\n\t\t<p class="is-small">\n\t\t\tToggle the switch below to enter {{::$ctrl.teamMember.personal.Forename}}\u2019s pay information in a different currency.\n\t\t</p>\n\t</div>\n\n\t<!-- Use Currency -->\n\t<div class="form-field">\n\t\t<div class="form-field-main">\n\t\t\t<toggle-input field-label="Use currency" field-model="$ctrl.isPaymentInCurrency" field-name="isPaymentInCurrency" field-on-change="$ctrl.onUseCurrencyChange()" field-theme-light="true"></toggle-input>\n\t\t</div>\n\t</div>\n\n\t<!-- Selected Currency -->\n\t<div class="form-field fadeIn" ng-if="$ctrl.isPaymentInCurrency">\n\t\t<div class="form-field-header">\n\t\t\t<label for="currencyId" ng-class="{\n\t\t\t\t\t\'required\' : $ctrl.isRequired\n\t\t\t\t}">\n\t\t\t\tCurrency:\n\t\t\t</label>\n\t\t</div>\n\t\t<div class="form-field-main">\n\t\t\t<select class="xl" id="currencyId" name="currencyId" ng-change="$ctrl.onCurrencyChange()" ng-model="$ctrl.selectedCurrency" ng-options="currency as currency.CurrencyLabel for currency in $ctrl.currencies" ng-required="$ctrl.isRequired">\n\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\tPlease select...\n\t\t\t\t</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form.currencyId.$touched" ng-messages="$ctrl.form.currencyId.$error" role="alert">\n\t\t\t<p data-cy="pay-information-currency-id-validation-required-message" ng-message="required">\n\t\t\t\tPlease select an option\n\t\t\t</p>\n\t\t</div>\n\t\t<p class="form-message primary fadeIn" data-cy="pay-information-currency-id-message" ng-if="$ctrl.selectedCurrency">\n\t\t\t\xA3 to {{$ctrl.selectedCurrency.CurrencyLabel}} exchange rate: {{$ctrl.selectedCurrency.CurrencyValue}}\n\t\t</p>\n\t</div>\n\n</fieldset>\n');
$templateCache.put('components/pay-information-rolled-up-fieldset/pay-information-rolled-up-fieldset.component.html','<fieldset data-cy="pay-information-rolled-up-holiday-component">\n\n\t<div class="fadeIn">\n\t\t<div class="form-section form-field-highlight is-primary">\n\t\t\t<div class="form-intro has-action">\n\t\t\t\t<h5 data-cy="pay-information-rolled-up-holiday-title-rolled">Rolled up holiday</h5>\n\t\t\t\t<p class="is-small fadeIn" ng-if="$ctrl.teamMember.salary.UseCompanyDefaults" data-cy="pay-information-rolled-up-holiday-parapraph-text-this">\n\t\t\t\t\tThis will calculate {{$ctrl.payeDetails.PAYERolledUpHolidayPayRate}}% of gross salary, plus any pay elements with \'Holiday Pay\' toggled on,\n\t\t\t\t\tand add a \'Rolled Up Holiday Pay\' amount to each pay period. Salary can be excluded from the calculation if required.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small fadeIn" ng-if="!$ctrl.teamMember.salary.UseCompanyDefaults" data-cy="pay-information-rolled-up-holiday-parapraph-text-any">\n\t\t\t\t\tAny changes to settings will only be applied for {{::$ctrl.teamMember.personal.Forename}}.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Calculate and pay every period? -->\n\t\t\t<fieldset data-cy="pay-information-rolled-up-holiday-calculate-text-calculate">\n\t\t\t\t<label for="calculateAndPay" ng-class="{\n\t\t\t\t\t\t\'required\' : $ctrl.isRequired\n\t\t\t\t\t}">\n\t\t\t\t\t<h6>Calculate and pay every period?</h6>\n\t\t\t\t</label>\n\n\t\t\t\t<div class="stat-list is-primary-darkened align-value-right basic">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input class="b" data-cy="pay-information-rolled-up-holiday-input-false" id="isRollUpFalse" name="isRollUpHoliday" ng-change="$ctrl.onIsRollUpHolidayChange()" ng-model="$ctrl.teamMember.company.IsRollUpHoliday" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="isRollUpFalse">No</label>\n\t\t\t\t\t\t<input class="b" data-cy="pay-information-rolled-up-holiday-input-true" id="isRollUpTrue" name="isRollUpHoliday" ng-change="$ctrl.onIsRollUpHolidayChange()" ng-model="$ctrl.teamMember.company.IsRollUpHoliday" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="isRollUpTrue">Yes</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t\t<div class="spacer m"></div>\n\t\t\t<toggle-input field-label="Exclude salary" field-model="$ctrl.teamMember.company.ExcludeSalaryFromRolledUpHoliday" field-name="excludeSalary" ng-if="$ctrl.teamMember.company.IsRollUpHoliday"></toggle-input>\n\t\t</div>\n\t</div>\n</fieldset>\n');
$templateCache.put('components/pay-information-tax-ni-fieldset/pay-information-tax-ni-fieldset.component.html','<fieldset class="form-field-highlight is-primary">\n\n\t<div class="form-intro">\n\t\t<h5>Tax and NI settings</h5>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- EE NI Exempt -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="Exempt from Employee\u2019s NI" field-model="$ctrl.teamMember.salary.EENIExcluded" field-name="eeniExcluded" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- ER NI Exempt -->\n\t\t<div class="form-field less-margin">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="Exempt from Employer\u2019s NI" field-model="$ctrl.teamMember.salary.ERNIExcluded" field-name="erniExcluded" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- EE NI Paid by Employer -->\n\t\t<div class="form-field fadeIn" ng-if="!$ctrl.teamMember.salary.EENIExcluded">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="eeniPaidByEmployerFalse">\n\t\t\t\t\tEmployee\u2019s NI is paid by:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="eeniPaidByEmployerFalse" name="eeniPaidByEmployer" ng-model="$ctrl.teamMember.salary.EENIPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="eeniPaidByEmployerFalse">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Employee</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="eeniPaidByEmployerTrue" name="eeniPaidByEmployer" ng-model="$ctrl.teamMember.salary.EENIPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="eeniPaidByEmployerTrue">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Employer</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-gap">\n\n\t\t<!-- Is %age of pay tax exempt -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="A percentage of pay is tax exempt" field-model="$ctrl.isPercentageOfPayTaxExempt" field-name="isPercentageOfPayTaxExempt" field-on-change="$ctrl.onPercentageOfPayTaxExemptToggle()" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Tax exempt %age -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.isPercentageOfPayTaxExempt">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="taxExcemptPercent" ng-class="{\n\t\t\t\t\t\t\'required\' : $ctrl.isRequired\n\t\t\t\t\t}">\n\t\t\t\t\tTax exempt percentage:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="percentage s" id="taxExcemptPercent" max="100" maxlength="10" min="0" name="taxExcemptPercent" ng-model="$ctrl.teamMember.salary.TaxExcemptPercent" ng-pattern="$root.REGEX.decimal" ng-required="$ctrl.isRequired" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form.taxExcemptPercent.$error" ng-show="$ctrl.form.taxExcemptPercent.$touched" role="alert">\n\t\t\t\t<p ng-message="max">Tax exempt percentage cannot exceed 100</p>\n\t\t\t\t<p ng-message="min">Tax exempt percentage should be no less than 0</p>\n\t\t\t\t<p ng-message="pattern">Please enter a Tax exempt percentage up to 2 decimal places</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-gap">\n\n\t\t<!-- Can exceed 50% -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="Allow tax to be greater than 50% of taxable pay" field-model="$ctrl.teamMember.salary.TaxCanExceed50Percent" field-name="taxCanExceed50Percent" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tTurning this on means that {{::$ctrl.teamMember.personal.Forename}}\u2019s tax won\u2019t be capped at\n\t\t\t\t\t50% of their pay and you won\u2019t see the alert in your current period.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n</fieldset>\n');
$templateCache.put('components/pay-period-card/pay-period-card.component.html','<div class="pay-period-card fadeIn" ng-class="{\'has-warning is-assertive\' : $ctrl.payPeriod.IsCompulsorySubmission, \'is-historic\': $ctrl.payPeriod.isHistoric}">\n\n\t<div class="pay-period-card_content">\n\n\t\t<div class="pay-period-card_title">\n\n\t\t\t<!-- Pay Period -->\n\t\t\t<h5 ng-if="::!$ctrl.payPeriod.IsAutoSubmitPeriod">\n\t\t\t\t<a data-cy="pay-period-link" ng-if="!$ctrl.payPeriod.payPeriodIsDisabled" ui-sref="payroll.pay-period({agencyProfileId: $ctrl.agencyProfileId, payPeriodId: $ctrl.payPeriod.PayPeriodID})">\n\t\t\t\t\t{{$ctrl.payPeriod.PayPeriodDisplay}}<i class="icon-chevron-right"></i>\n\t\t\t\t</a>\n\t\t\t\t<span ng-class="{\n\t\t\t\t\t\'greyscale-darkened\': !$ctrl.payPeriod.isHistoric && !$root.currentCompany.IsPayslipManagerActive,\n\t\t\t\t\t\'greyscale-darkened\': $ctrl.payPeriod.isHistoric,\n\t\t\t\t\t\'primary\': $root.currentCompany.IsPayslipManagerActive\n\t\t\t\t}" ng-if="$ctrl.payPeriod.payPeriodIsDisabled">{{$ctrl.payPeriod.PayPeriodDisplay}}</span>\n\t\t\t</h5>\n\n\t\t\t<!-- Download -->\n\t\t\t<h5 ng-if="::$ctrl.payPeriod.IsAutoSubmitPeriod">\n\t\t\t\t<a href="" ng-click="$ctrl.openEPSReportModal($ctrl)">{{$ctrl.payPeriod.PayPeriodDisplay}}</a>\n\t\t\t</h5>\n\n\t\t</div>\n\n\t\t<!-- Payslip Manager Inactive -->\n\t\t<div class="pay-period-card_actions" ng-if="!$root.currentCompany.IsPayslipManagerActive">\n\n\t\t\t<div class="pay-period-card_detail is-number-stat" ng-if="$ctrl.payPeriod.YearToDateFPSCount > 0">\n\t\t\t\t<i class="icon-document primary n"></i>\n\t\t\t\t<span class="is-small"><ng-pluralize count="$ctrl.payPeriod.YearToDateFPSCount" when="{\'1\': \'1 Earlier Year FPS\', \'other\': \'{} Earlier Year FPS\\\'\'}"></ng-pluralize></span>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-card_detail" ng-if="!$root.userHasRole([\'groupadminlite\', \'companyadministratorlite\']) && !$ctrl.payPeriod.IsAutoSubmitPeriod">\n\t\t\t\t<span class="tag quarternary" ng-if="$ctrl.payPeriod.IsRunAutoRun && $root.currentUser.canSeeAutoRun">Auto Run</span>\n\t\t\t\t<span class="tag assertive" ng-if="$ctrl.payPeriod.IsRunCompulsory">Compulsory</span>\n\t\t\t\t<span class="tag tertiary" ng-if="$ctrl.payPeriod.IsRunTest">Test Run</span>\n\t\t\t\t<span class="tag primary inverse" ng-if="$ctrl.payPeriod.IsRunRollback">Rollback</span>\n\t\t\t\t<span class="tag indifferent-lighter" ng-if="$ctrl.payPeriod.IsRunReassessment">Re-enrolment</span>\n\t\t\t\t<span class="tag tertiary inverse" ng-if="$ctrl.payPeriod.IsRunInactivity">Inactivity</span>\n\t\t\t\t<span class="tag greyscale-dark" ng-if="$ctrl.payPeriod.IsRunSkipped">Skipped</span>\n\t\t\t\t<span class="tag primary" ng-if="$ctrl.payPeriod.isHistoric">Historic</span>\n\t\t\t\t<span class="tag secondary inverse" ng-if="$ctrl.payPeriod.IsRTISubmissionDisabled">RTI Off</span>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-card_detail" ng-if="::$ctrl.payPeriod.IsAutoSubmitPeriod">\n\t\t\t\t<p class="caption">Submitted at {{$ctrl.payPeriod.ProcessDateISO | datetimeformat:\'detailed\'}}</p>\n\t\t\t</div>\n\n\t\t\t<dropdown-menu class="pay-period-card_menu" menu-icon="icon-setup" menu-on-open="$ctrl.getReportsForPeriod($)" menu-size="l" ng-if="!$root.userHasRole([\'groupadminlite\', \'companyadministratorlite\'])">\n\n\t\t\t\t<!-- Active Period -->\n\t\t\t\t<div ng-if="!$ctrl.payPeriod.payPeriodIsDisabled">\n\n\t\t\t\t\t<!-- Other actions -->\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a ng-if="::!$ctrl.payPeriod.IsAutoSubmitPeriod" ui-sref="payroll.pay-period({agencyProfileId: $ctrl.agencyProfileId, payPeriodId: $ctrl.payPeriod.PayPeriodID})">View period</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openSubmitEpsForm($ctrl)" ng-if="::$ctrl.payPeriod.CanSubmitEPS && [$ctrl.INTERFACE_TYPES.agency, $ctrl.INTERFACE_TYPES.actualonly].includes($root.currentCompany.CompanyType) && $root.currentUser.Permissions.Payroll.canRunPayroll">Submit EPS</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openRollbackPeriodForm($ctrl)" ng-if="::$ctrl.payPeriod.IsMostRecentlyRunPeriod && $root.currentUser.Permissions.Payroll.canRollbackPayroll">Rollback period</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openCISSufferedForm($ctrl)" ng-if="::$ctrl.payPeriod.CanUpdateCISDeductions">Submit CIS deductions</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openEPSReportModal($ctrl)" ng-if="::$ctrl.payPeriod.IsAutoSubmitPeriod">View EPS File</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-if="::!$ctrl.payPeriod.IsAutoSubmitPeriod" ng-switch="$ctrl.reportDownloadState" ng-class="{\n\t\t\t\t\t\t\t\'dropdown-group\':\n\t\t\t\t\t\t\t\t$ctrl.reportDownloadState === \'loading\' ||\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t$ctrl.reportDownloadState === \'ready\' &&\n\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t$ctrl.payslips.length > 0 ||\n\t\t\t\t\t\t\t\t\t\t$ctrl.p60s.length > 0 ||\n\t\t\t\t\t\t\t\t\t\t$ctrl.payDashboardReports.length > 0\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t<div ng-switch-when="loading" class="centered-contents">\n\t\t\t\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div ng-switch-when="ready">\n\t\t\t\t\t\t\t<div ng-show="$ctrl.payslips.length > 0">\n\t\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Download payslips:</p>\n\t\t\t\t\t\t\t\t<report-export-item report="report" ng-repeat="report in $ctrl.payslips = ($ctrl.reports | reportCategories:\'payslip\')"></report-export-item>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div ng-show="$ctrl.p60s.length > 0">\n\t\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Download P60s:</p>\n\t\t\t\t\t\t\t\t<report-export-item report="report" ng-repeat="report in $ctrl.p60s = ($ctrl.reports | reportCategories:\'p60\')"></report-export-item>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div ng-show="$ctrl.payDashboardReports.length > 0">\n\t\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Download PayDashboard file:</p>\n\t\t\t\t\t\t\t\t<report-export-item report="report" ng-repeat="report in $ctrl.payDashboardReports = ($ctrl.reports | reportCategories:\'pay-dashboard\')"></report-export-item>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Options for historical pay periods -->\n\t\t\t\t<div ng-if="$ctrl.payPeriod.isHistoric">\n\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openHistoricPeriodForm($ctrl)">View and edit</a>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.openP32ReportModal($ctrl)">View P32 report</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeleteHistoricPayPeriodForm($ctrl)">Delete</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<a href="" ng-click="$ctrl.openReopenPeriodForm($ctrl)" ng-if="$ctrl.payPeriod.payPeriodIsDisabled && !$ctrl.payPeriod.isHistoric">Reopen period</a>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\n\t\t<!-- Payslip Manager -->\n\t\t<div class="pay-period-card_actions" ng-if="$root.currentCompany.IsPayslipManagerActive">\n\n\t\t\t<div class="pay-period-card_detail link-with-icon">\n\t\t\t\t<i class="icon-payslip l primary"></i><span class="is-small is-strong">{{$ctrl.payPeriod.PayslipManagerCount}}</span>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-card_detail has-fixed-width" ng-switch="$ctrl.payPeriod.PayslipManagerState">\n\t\t\t\t<span class="tag greyscale" pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.awaitingUpload">No Payslips</span>\n\t\t\t\t<span class="tag indifferent-lighter" pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.notificationsNotSent">Not Sent</span>\n\t\t\t\t<span class="tag secondary" pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.notificationsSent">Sent</span>\n\t\t\t</div>\n\n\t\t\t<dropdown-menu class="pay-period-card_menu" menu-icon="icon-setup" menu-size="xl">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" ng-click="$ctrl.checkCanImportMainRun($ctrl)">Import main run</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.checkCanImportSupplementaryRun($ctrl)">Import supplementary pay run</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.openImportHistoryForm($ctrl)">View import history</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" ng-click="$ctrl.openSendNotificationsForm($ctrl)">Send notificiations</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\n\t\t</div>\n\n\t</div>\n\n\t<div class="pay-period-card_footer" ng-if="::!$ctrl.payPeriod.IsAutoSubmitPeriod" ng-class="{\'is-assertive\' : $ctrl.payPeriod.IsCompulsorySubmission}">\n\n\t\t<p ng-if="$ctrl.payPeriod.isHistoric">Added by {{$ctrl.payPeriod.CreatedBy}} {{$ctrl.payPeriod.CreatedDateISO | datetimeformat: \'detailed\'}}</p>\n\n\t\t<div ng-if="!$ctrl.payPeriod.isHistoric">\n\t\t\t<p>Payday: {{$ctrl.payPeriod.PayDateISO | dateformat:\'long\'}} ({{$ctrl.payPeriod.TaxPeriod | taxPeriodDescription:$ctrl.payPeriod.PeriodType | capitalise}})</p>\n\n\t\t\t<div class="pay-period-card_footer-warning is-assertive" ng-if="$ctrl.payPeriod.IsCompulsorySubmission">\n\t\t\t\t<i class="icon-warning"></i>&nbsp; <span>Automatically submitted</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/pay-period-dates/payPeriodDatesComponent.html','<fieldset class="form-section fadeIn" ng-switch="periodDetails.PayPeriodType">\n\n\t<!-- Pay period frequency -->\n\t<div class="form-field">\n\t\t<header class="form-field-header">\n\t\t\t<label for="payPeriodType" class="required">Frequency:</label>\n\t\t</header>\n\t\t<div class="field">\n\t\t\t<select name="payPeriodType" id="payPeriodType" class="l" ng-model="periodDetails.PayPeriodType" ng-options="option.id as option.name for option in PAY_PERIOD_SETUP_TYPES_OPTIONS" ng-change="setupPayPeriodType(periodDetails)" required></select>\n\t\t</div>\n\t\t<div class="form-errors fadeIn" ng-messages="form.payPeriodType.$error" ng-if="form.payPeriodType.$touched" role="alert">\n\t\t\t<p ng-message="required">Please select the pay period frequency</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Pay period start / end dates -->\n\t<fieldset class="fadeIn" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.monthly, PAY_PERIOD_SETUP_TYPES.weekly, PAY_PERIOD_SETUP_TYPES.twoWeekly, PAY_PERIOD_SETUP_TYPES.fourWeekly]">\n\n\t\t<div class="slide-in-form_item" ng-class="form.periodStartDate.$valid ? \'form-fields-from-to primary\' : \'form-field-group\'">\n\n\t\t\t<!-- Start date -->\n\t\t\t<div class="form-field" ng-class="form.periodStartDate.$valid ? \'form-fields-from-to_item\' : \'\'">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="periodStartDate">Start date of first period:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="periodStartDate" field-max-date-iso="periodDetails.PeriodStartDateISOMax" field-min-date-iso="periodDetails.PeriodStartDateISOMin" field-on-change="generateEndDateFromStartDateIso" field-value-iso="periodDetails.PeriodStartDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.periodStartDate.$error" ng-if="form.periodStartDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t<p ng-message="max">Please enter a date up to {{periodDetails.PeriodStartDateISOMax | dateformat}}</p>\n\t\t\t\t\t<p ng-message="min">Please enter a date from {{periodDetails.PeriodStartDateISOMin | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- End date -->\n\t\t\t<div class="form-field form-fields-from-to_item slideInLeft" ng-if="form.periodStartDate.$valid">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="periodEndDate">End date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-read-only="true" field-id="periodEndDate" field-max-date-iso="periodDetails.periodEndDateISOMax" field-min-date-iso="periodDetails.periodEndDateISOMin" field-value-iso="periodDetails.periodEndDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.periodEndDate.$error" ng-if="form.periodEndDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t<p ng-message="max">Please enter a date up to {{periodDetails.PeriodStartDateISOMax | dateformat}}</p>\n\t\t\t\t\t<p ng-message="min">Please enter a date from {{periodDetails.PeriodStartDateISOMin | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Preview -->\n\t\t<div class="slide-in-form_item">\n\t\t\t<a href="" ng-click="togglePayPeriodCalendar(periodDetails)" class="link-with-icon" ng-class="{\'is-disabled\': !form.payPeriodPaymentDay.$valid}"><i class="icon-{{periodDetails.isTimelineVisible ? \'right\' : \'back\'}}"></i>{{periodDetails.isTimelineVisible ? \'Close pay period calendar\' : \'Open pay period calendar\'}}</a>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Pay period schedule -->\n\t<fieldset class="fadeIn" ng-if="form.payPeriodType.$valid && form.periodStartDate.$valid">\n\n\t\t<div class="form-field-highlight primary" ng-switch="periodDetails.PayPeriodType">\n\n\t\t\t<!-- \uD83C\uDF89 Payday (Monthly) -->\n\t\t\t<div class="form-field fadeIn" pc-switch-when="PAY_PERIOD_SETUP_TYPES.monthly">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payPeriodPaymentDay" class="required">The team are paid on the:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select name="payPeriodPaymentDay" id="payPeriodPaymentDay" class="xl" ng-change="reviewPreview(periodDetails)" ng-model="periodDetails.PayPeriodPaymentDay" ng-options="option.id as option.name for option in PAY_DATE_OPTIONS.monthly | orderBy: [\'order\', \'id\']" required>\n\t\t\t\t\t\t<option value="">Select a date\u2026</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payPeriodPaymentDay.$error" ng-if="form.payPeriodPaymentDay.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select the pay day</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message primary">Payday! This date will go on the FPS and will be shown on payslips. If you select 29th, 30th or 31st, February will default to the last day of the month, as will months with 30 days if you select the 31st.</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<div class="dropIn" ng-if="form.payPeriodPaymentDay.$valid">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input type="radio" name="paidInArrears" id="isPaidInArrears0" class="b" ng-value="PAY_PERIOD_ARREARS_TYPES.samePeriod" ng-change="updateArrearsType(periodDetails)" ng-model="periodDetails.payPeriodArrearsType" required>\n\t\t\t\t\t\t\t<label for="isPaidInArrears0">for the same period</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input type="radio" name="paidInArrears" id="isPaidInArrears1" class="b" ng-value="PAY_PERIOD_ARREARS_TYPES.custom" ng-change="updateArrearsType(periodDetails)" ng-model="periodDetails.payPeriodArrearsType" required>\n\t\t\t\t\t\t\t<label for="isPaidInArrears1">\n\t\t\t\t\t\t\t\t<select name="payPeriodArrearsCount" id="payPeriodArrearsCount" class="s inline" ng-change="reviewPreview(periodDetails)" ng-model="periodDetails.PayPeriodArrearsCount" ng-options="option.value as option.description for option in PAY_PERIOD_ARREARS_OPTIONS" ng-disabled="periodDetails.payPeriodArrearsType !== PAY_PERIOD_ARREARS_TYPES.custom" required></select>\n\t\t\t\t\t\t\t\t<span>&nbsp;&nbsp;<ng-pluralize count="periodDetails.PayPeriodArrearsCount" when="{\'1\': \'period later\', \'other\': \'periods later\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- \uD83C\uDF89 Payday (Weekly / Two-weekly / Four-weekly) -->\n\t\t\t<div class="form-field fadeIn" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.weekly, PAY_PERIOD_SETUP_TYPES.twoWeekly, PAY_PERIOD_SETUP_TYPES.fourWeekly]">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payPeriodPaymentDay" class="required">The team are paid on the:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select name="payPeriodPaymentDay" id="payPeriodPaymentDay" class="inline" ng-change="reviewPayPeriodPaymentDay(periodDetails)" ng-model="periodDetails.payPeriodPaymentDayDisplay" ng-options="option.id as option.name for option in PAY_DATE_OPTIONS.weekly | orderBy: [\'order\', \'id\']" required>\n\t\t\t\t\t\t<option value="">Select a day\u2026</option>\n\t\t\t\t\t</select>\n\n\t\t\t\t\t<!-- Two weekly -->\n\t\t\t\t\t<span ng-if="periodDetails.PayPeriodType === PAY_PERIOD_SETUP_TYPES.twoWeekly">\n\t\t\t\t\t\t&nbsp;&nbsp;of&nbsp;&nbsp;\n\t\t\t\t\t\t<select name="payPeriodWeekNumber" id="payPeriodWeekNumber" class="inline" ng-change="reviewPayPeriodPaymentDay(periodDetails)" ng-model="periodDetails.weekNumber" ng-options="option.value as option.description for option in WEEK_NUMBER_OPTIONS_TWO_WEEKLY" required></select>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<!-- Four weekly -->\n\t\t\t\t\t<span ng-if="periodDetails.PayPeriodType === PAY_PERIOD_SETUP_TYPES.fourWeekly">\n\t\t\t\t\t\t&nbsp;&nbsp;of&nbsp;&nbsp;\n\t\t\t\t\t\t<select name="payPeriodWeekNumber" id="payPeriodWeekNumber" class="inline" ng-change="reviewPayPeriodPaymentDay(periodDetails)" ng-model="periodDetails.weekNumber" ng-options="option.value as option.description for option in WEEK_NUMBER_OPTIONS_FOUR_WEEKLY" required></select>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payPeriodPaymentDay.$error" ng-if="form.payPeriodPaymentDay.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select the pay day</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message primary">Payday! This is also the date shown on payslips.</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<div class="dropIn" ng-if="form.payPeriodPaymentDay.$valid">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input type="radio" name="paidInArrears" id="isPaidInArrears0" class="b" ng-value="PAY_PERIOD_ARREARS_TYPES.samePeriod" ng-change="updateArrearsType(periodDetails)" ng-model="periodDetails.payPeriodArrearsType" required>\n\t\t\t\t\t\t\t<label for="isPaidInArrears0">for the same period</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input type="radio" name="paidInArrears" id="isPaidInArrears1" class="b" ng-value="PAY_PERIOD_ARREARS_TYPES.custom" ng-change="updateArrearsType(periodDetails)" ng-model="periodDetails.payPeriodArrearsType" required>\n\t\t\t\t\t\t\t<label for="isPaidInArrears1">\n\t\t\t\t\t\t\t\t<select name="payPeriodArrearsCount" id="payPeriodArrearsCount" ng-change="reviewPreview(periodDetails)" class="s inline" ng-model="periodDetails.PayPeriodArrearsCount" ng-options="option.value as option.description for option in PAY_PERIOD_ARREARS_OPTIONS" ng-disabled="periodDetails.payPeriodArrearsType !== PAY_PERIOD_ARREARS_TYPES.custom" required></select>\n\t\t\t\t\t\t\t\t<span>&nbsp;&nbsp;<ng-pluralize count="periodDetails.PayPeriodArrearsCount" when="{\'1\': \'period later\', \'other\': \'periods later\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- \uD83C\uDF89 Monthly / Weekly / Two weekly / Four weekly -->\n\t\t\t<fieldset class="dropIn" ng-if="form.payPeriodPaymentDay.$valid" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.monthly, PAY_PERIOD_SETUP_TYPES.weekly, PAY_PERIOD_SETUP_TYPES.twoWeekly, PAY_PERIOD_SETUP_TYPES.fourWeekly]">\n\n\t\t\t\t<!-- \uD83D\uDE80 Date to run payroll -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="payPeriodProcessingDayTypeCustom" class="required">And payroll is processed:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payPeriodProcessingDayType" id="payPeriodProcessingDayTypeCustom" class="b" ng-change="reviewProcessingDay(periodDetails)" ng-model="periodDetails.payPeriodProcessingDayType" ng-value="PAY_PERIOD_PROCESSING_DATE_TYPES.custom" required>\n\t\t\t\t\t\t\t\t<label for="payPeriodProcessingDayTypeCustom">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="PayPeriodProcessingDayOffset" class="xs" ng-model="periodDetails.payPeriodProcessingDayOffsetDisplay" nsf-on-change="reviewProcessingDay(periodDetails)" ng-required="periodDetails.payPeriodProcessingDayType === PAY_PERIOD_PROCESSING_DATE_TYPES.custom" ng-readonly="periodDetails.payPeriodProcessingDayType !== PAY_PERIOD_PROCESSING_DATE_TYPES.custom" step="1" min="1" max="maxPayPeriodProcessingDayOffset"></number-selector-field>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<span ng-if="periodDetails.payPeriodProcessingDayOffsetDisplay"><ng-pluralize count="periodDetails.payPeriodProcessingDayOffsetDisplay" when="{\'0\': \'days before pay day (on the same day)\', \'1\': \'day before pay day\', \'other\': \'days before pay day\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t\t\t<span ng-if="!periodDetails.payPeriodProcessingDayOffsetDisplay">days before pay day</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.PayPeriodProcessingDayOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please select or enter a maximum of {{maxPayPeriodProcessingDayOffset}} days</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payPeriodProcessingDayType" id="payPeriodProcessingDayTypePayDay" class="b" ng-change="reviewProcessingDay(periodDetails)" ng-model="periodDetails.payPeriodProcessingDayType" ng-value="PAY_PERIOD_PROCESSING_DATE_TYPES.payday" required>\n\t\t\t\t\t\t\t\t<label for="payPeriodProcessingDayTypePayDay">on pay day</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message primary">Maximum of {{maxPayPeriodProcessingDayOffset}} days before pay day. Also the date that payroll will be run if you enable Auto run.</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- \u2709\uFE0F Date to send pay notifications -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="payNotificationDatePayday" class="required">And the team are notified:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payNotificationDate" id="payNotificationDatePayday" class="b" ng-change="reviewPayslipDay(periodDetails)" ng-model="periodDetails.payPeriodPayslipDayType" ng-value="PAY_PERIOD_PAYSLIP_DATE_TYPES.payday" required>\n\t\t\t\t\t\t\t\t<label for="payNotificationDatePayday">on pay day</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payNotificationDate" id="payNotificationDateAfterPayDay" class="b" ng-change="reviewPayslipDay(periodDetails)" ng-model="periodDetails.payPeriodPayslipDayType" ng-value="PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay" required>\n\t\t\t\t\t\t\t\t<label for="payNotificationDateAfterPayDay">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="payslipDayAfterOffset" class="xs" ng-model="periodDetails.payPeriodPayslipDayAfterOffsetDisplay" nsf-on-change="reviewPayslipDay(periodDetails)" ng-readonly="periodDetails.payPeriodPayslipDayType !== PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay" ng-required="periodDetails.payPeriodPayslipDayType === PAY_PERIOD_PAYSLIP_DATE_TYPES.afterPayDay" step="1" min="1" max="10"></number-selector-field>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<span ng-if="periodDetails.payPeriodPayslipDayAfterOffsetDisplay"><ng-pluralize count="periodDetails.payPeriodPayslipDayAfterOffsetDisplay" when="{\'1\': \'day after pay day\', \'other\': \'days after pay day\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t\t\t<span ng-if="!periodDetails.payPeriodPayslipDayAfterOffsetDisplay">days after pay day</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payNotificationDate" id="payNotificationDateBeforePayDay" class="b" ng-change="reviewPayslipDay(periodDetails)" ng-model="periodDetails.payPeriodPayslipDayType" ng-value="PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay" required>\n\t\t\t\t\t\t\t\t<label for="payNotificationDateBeforePayDay">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="payslipDayBeforeOffset" class="xs" ng-model="periodDetails.payPeriodPayslipDayBeforeOffsetDisplay" nsf-on-change="reviewPayslipDay(periodDetails)" ng-readonly="periodDetails.payPeriodPayslipDayType !== PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay" ng-required="periodDetails.payPeriodPayslipDayType === PAY_PERIOD_PAYSLIP_DATE_TYPES.beforePayDay" step="1" min="1" max="10"></number-selector-field>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<span ng-if="periodDetails.payPeriodPayslipDayBeforeOffsetDisplay"><ng-pluralize count="periodDetails.payPeriodPayslipDayBeforeOffsetDisplay" when="{\'1\': \'day before pay day\', \'other\': \'days before pay day\', \'0\': \'days before pay day\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t\t\t<span ng-if="!periodDetails.payPeriodPayslipDayBeforeOffsetDisplay">days before pay day</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="payNotificationDate" id="payNotificationDatePayroll" class="b" ng-change="reviewPayslipDay(periodDetails)" ng-model="periodDetails.payPeriodPayslipDayType" ng-value="PAY_PERIOD_PAYSLIP_DATE_TYPES.processingDay" required>\n\t\t\t\t\t\t\t\t<label for="payNotificationDatePayroll">when payroll is processed</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message primary">This can be changed for a specific period, when payroll is run</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- \u2194\uFE0F Offset -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="payPeriodOffsetType" class="required">And when pay day falls on a weekend or Bank Holiday:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select name="payPeriodOffsetType" id="payPeriodOffsetType" class="xl" ng-change="reviewPreview(periodDetails)" ng-model="periodDetails.PayPeriodOffsetType" ng-options="option.value as option.description for option in PAY_PERIOD_OFFSET_OPTIONS" required></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\t\t</div>\n\n\t</fieldset>\n\n\n\t<!-- \uD83C\uDF89 Quarterly / Bi-annually / Annually -->\n\t<fieldset class="fadeIn" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.quarterly, PAY_PERIOD_SETUP_TYPES.biAnnually, PAY_PERIOD_SETUP_TYPES.annually]">\n\n\t\t<div class="form-field-highlight primary" ng-switch="periodDetails.PayPeriodType">\n\t\t\t<div class="form-intro">\n\n\t\t\t\t<!-- Quarterly -->\n\t\t\t\t<p class="s primary" pc-switch-when="PAY_PERIOD_SETUP_TYPES.quarterly">Enter four pay dates within the tax year that you want team members to be paid. These are the dates that will go on the FPS and will be shown on payslips, and pay day notifications will be sent as soon as you run payroll. These are also the dates payroll will run if you enable Autorun.</p>\n\n\t\t\t\t<!-- Bi-annually -->\n\t\t\t\t<p class="s primary" pc-switch-when="PAY_PERIOD_SETUP_TYPES.biAnnually">Enter two pay dates within the tax year that you want team members to be paid. These are the dates that will go on the FPS and will be shown on payslips, and pay day notifications will be sent as soon as you run payroll. These are also the dates payroll will run if you enable Autorun.</p>\n\n\t\t\t\t<!-- Annually -->\n\t\t\t\t<p class="s primary" pc-switch-when="PAY_PERIOD_SETUP_TYPES.annually">Enter a pay date within the tax year that you want team members to be paid. This date will go on the FPS and will be shown on payslips, and pay day notifications will be sent as soon as you run payroll. This is also the date payroll will run if you enable Autorun.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Pay date 1 -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payDate1">Pay date{{periodDetails.PayPeriodType === PAY_PERIOD_SETUP_TYPES.annually ? \'\' : \' 1\'}}:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="payDate1" field-on-change-fn="onDate1Change(periodDetails,form.payDate1)" field-read-only="periodDetails.payDateReadOnly.payDate1" field-value-iso="periodDetails.PeriodStartDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t<p class="is-small italic is-font-greyscale-300">From {{periodDetails.DateRanges[0].PayDateMinISO | dateformat:\'dayMonthFull\'}} to {{periodDetails.DateRanges[0].PayDateMaxISO | dateformat:\'dayMonthFull\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payDate1.$error" ng-if="form.payDate1.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="betweenDate1Range">Must be from {{periodDetails.DateRanges[0].PayDateMinISO | dateformat:\'dayMonthYear\'}} to {{periodDetails.DateRanges[0].PayDateMaxISO | dateformat:\'dayMonthYear\'}}</p>\n\t\t\t\t\t\t<p ng-message="validDate">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay date 2 -->\n\t\t\t\t<div class="form-field fadeIn" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.biAnnually, PAY_PERIOD_SETUP_TYPES.quarterly]">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payDate2">Pay date 2:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-disabled="periodDetails.isOptionsDisabled || !form.payDate1.$touched || periodDetails.isOptionsDisabled == null" field-id="payDate2" field-min-date-iso="periodDetails.DateRanges[1].PayDateMinISO" field-max-date-iso="periodDetails.DateRanges[1].PayDateMaxISO" field-read-only="periodDetails.payDateReadOnly.payDate2" field-value-iso="periodDetails.PeriodStartDate2ISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t<p class="is-small italic is-font-greyscale-300">From {{periodDetails.DateRanges[1].PayDateMinISO | dateformat:\'dayMonthFull\'}} to {{periodDetails.DateRanges[1].PayDateMaxISO | dateformat:\'dayMonthFull\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payDate2.$error" ng-if="form.payDate2.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the second payment date</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t<p ng-message="min || max">Must be from {{periodDetails.DateRanges[1].PayDateMinISO | dateformat:\'dayMonthYear\'}} to {{periodDetails.DateRanges[1].PayDateMaxISO | dateformat:\'dayMonthYear\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group fadeIn" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.quarterly]">\n\n\t\t\t\t<!-- Pay date 3 -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payDate3">Pay date 3:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-disabled="periodDetails.isOptionsDisabled || !form.payDate1.$touched || periodDetails.isOptionsDisabled == null" field-id="payDate3" field-min-date-iso="periodDetails.DateRanges[2].PayDateMinISO" field-max-date-iso="periodDetails.DateRanges[2].PayDateMaxISO" field-read-only="periodDetails.payDateReadOnly.payDate3" field-value-iso="periodDetails.PeriodStartDate3ISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t<p class="is-small italic is-font-greyscale-300">From {{periodDetails.DateRanges[2].PayDateMinISO | dateformat:\'dayMonthFull\'}} to {{periodDetails.DateRanges[2].PayDateMaxISO | dateformat:\'dayMonthFull\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payDate3.$error" ng-if="form.payDate3.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the third payment date</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t<p ng-message="min || max">Must be from {{periodDetails.DateRanges[2].PayDateMinISO | dateformat:\'dayMonthYear\'}} to {{periodDetails.DateRanges[2].PayDateMaxISO | dateformat:\'dayMonthYear\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay date 4 -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payDate4">Pay date 4:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-disabled="periodDetails.isOptionsDisabled || !form.payDate1.$touched || periodDetails.isOptionsDisabled == null" field-id="payDate4" field-min-date-iso="periodDetails.DateRanges[3].PayDateMinISO" field-max-date-iso="periodDetails.DateRanges[3].PayDateMaxISO" field-read-only="periodDetails.payDateReadOnly.payDate4" field-value-iso="periodDetails.PeriodStartDate4ISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t<p class="is-small italic is-font-greyscale-300">From {{periodDetails.DateRanges[3].PayDateMinISO | dateformat:\'dayMonthFull\'}} to {{periodDetails.DateRanges[3].PayDateMaxISO | dateformat:\'dayMonthFull\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.payDate4.$error" ng-if="form.payDate4.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the fourth payment date</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t<p ng-message="min || max">Must be from {{periodDetails.DateRanges[3].PayDateMinISO | dateformat:\'dayMonthYear\'}} to {{periodDetails.DateRanges[3].PayDateMaxISO | dateformat:\'dayMonthYear\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- First date to run -->\n\t\t\t<div class="form-field fadeIn" ng-if="periodDetails.activePeriodOptions" pc-switch-when="[PAY_PERIOD_SETUP_TYPES.biAnnually, PAY_PERIOD_SETUP_TYPES.quarterly]">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="activePeriodQba" class="required">First pay date to run in Paycircle:</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="l-alt" field-id="activePeriodQba" name="activePeriodQba" ng-disabled="periodDetails.isOptionsDisabled || !form.payDate1.$touched || periodDetails.isOptionsDisabled == null" ng-model="periodDetails.ActivePeriodQBA" ng-options="qbaOption.value as qbaOption.description for qbaOption in periodDetails.activePeriodOptions" required>\n\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="form.activePeriodQba.$error" role="alert">\n\t\t\t\t\t<p ng-message="taxPeriod">Please select a pay date for a tax period that hasn\'t already been run</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n</fieldset>\n');
$templateCache.put('components/pay-period-note/pay-period-note.component.html','<div class="pay-period-note" ng-class="[$ctrl.cardTheme, {\'is-sent-note\' : $ctrl.note.IsSender }]">\n\t<div class="pay-period-note_layout">\n\t\t<div class="pay-period-note_avatar">\n\t\t\t<span class="pay-period-note_avatar-online" ng-if="::$ctrl.note.SenderLoggedIn && !$ctrl.note.IsSender"></span>\n\t\t\t<avatar avatar-size="is-medium" avatar-theme="{{$ctrl.cardTheme}}" avatar-initial="{{$ctrl.note.Sender[0]}}"></avatar>\n\t\t</div>\n\n\t\t<div class="pay-period-note_card" ng-class="$ctrl.cardTheme">\n\t\t\t<div class="pay-period-note_header">\n\t\t\t\t<h6 class="pay-period-note_meta">\n\t\t\t\t\t<span class="pay-period-note_meta-details">{{$ctrl.note.Sender}} at {{$ctrl.note.DateSentISO | dateformat:\'timeDate\'}}</span>\n\t\t\t\t\t<span class="tag is-indifferent pay-period-note_meta-tag" ng-if="$ctrl.note.SubjectType === $ctrl.MESSAGE_SUBJECT_TYPES.query">Query</span>\n\t\t\t\t</h6>\n\n\t\t\t\t<div class="pay-period-note_delete" ng-if="::$ctrl.note.IsSender">\n\t\t\t\t\t<a href="" class="pay-period-note_link" ng-class="$ctrl.cardTheme" ng-click="$ctrl.openDeletePeriodNoteForm($ctrl.note)" aria-label="Delete note"><i class="icon-trash"></i></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-note_content">\n\t\t\t\t<p class="pay-period-note_paragraph" ng-bind-html="$ctrl.note.Text | mentions:$ctrl.cardTheme"></p>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-note_files file-card_wrapper rows" ng-if="::$ctrl.note.DocumentList.length > 0">\n\t\t\t\t<file-card agency-profile-id="$ctrl.agencyProfileId" pay-period-id="$ctrl.agencyPayPeriodId" file="file" file-theme="{{$ctrl.cardTheme}}" has-upload-to-importer="true" has-download="true" ng-repeat="file in $ctrl.note.DocumentList"></file-card>\n\t\t\t</div>\n\n\t\t\t<div class="pay-period-note_footer" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateTasks && $ctrl.note.SubjectType === $ctrl.MESSAGE_SUBJECT_TYPES.none">\n\t\t\t\t<a href="" ng-click="$ctrl.openAddPeriodTaskForm($ctrl.note)" ng-class="$ctrl.cardTheme" class="link-with-icon pay-period-note_link"><i class="icon-tick-square n"></i> Add task</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/pay-period-tabs/payPeriodTabsComponent.html','<div class="pay-period-tabs">\n\n\t<loading-block ng-if="componentState === \'loading\'"></loading-block>\n\n\t<div class="pay-period-tabs-wrapper" ng-if="componentState === \'ready\'">\n\n\t\t<section class="pay-period-tabs-overview fadeIn" ng-if="payPeriod.ReportState === SUBMISSION_STATES.submitted">\n\t\t\t<payroll-payment-summary is-cis-only="company.CISOnly" pay-period="payPeriod" show-pension-info="company.IsPensionActive">\n\t\t\t</payroll-payment-summary>\n\t\t</section>\n\n\t\t<!-- BACS -->\n\t\t<section class="pay-period-tabs-section align-center" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPayroll">\n\n\t\t\t<div class="piped-list">\n\n\t\t\t\t<!-- BACS -->\n\t\t\t\t<span class="piped-list_item is-small" ng-if="!company.IsBACSEnabled && !isInPlayground">\n\t\t\t\t\t<a data-cy="pay-period-tabs-bacs-form" href="" ng-click="openBACSFileCreationForm()">\n\t\t\t\t\t\tTurn on BACS\n\t\t\t\t\t</a> to make your payments in one go.\n\t\t\t\t</span>\n\n\t\t\t\t<!-- Sox Report -->\n\t\t\t\t<span class="piped-list_item is-small" ng-if="payPeriod.PayrollState !== SUBMISSION_STATES.submitted">\n\t\t\t\t\t<a data-cy="pay-period-tabs-sox-report" ui-sref="sox-report({\n\t\t\t\t\t\t\tagencyProfileId: company.AgencyProfileID,\n\t\t\t\t\t\t\tpayPeriodId: payPeriod.PayPeriodID\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tPrint SOX Compliant Sign-off Report\n\t\t\t\t\t</a>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t</section>\n\n\t\t<!-- Tabs Nav -->\n\t\t<nav class="pay-period-tabs-nav tab-bar is-centered" ng-class="{\n\t\t\t\t\'is-open\': isOpen\n\t\t\t}">\n\t\t\t<div class="tab-bar_container">\n\t\t\t\t<a class="tab-bar_tab is-current-tab visible-phone" data-cy="pay-period-tabs-mobile-dropdown" href="" ng-click="toggleDropdown()">\n\t\t\t\t\t{{activeTab.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-smart-view-tab" href="" ng-class="{active: activeTab.id === TABS.smartView.id}" ng-click="setActiveTab(TABS.smartView)" ng-if="isSmartViewFeatureEnabled">\n\t\t\t\t\t<img src="images/icons/smart-view-icon.png" alt="Smart View" class="tab-icon"> {{TABS.smartView.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-reports-tab" href="" ng-class="{active: activeTab.id === TABS.reports.id}" ng-click="setActiveTab(TABS.reports)" ng-if="::tabVisibility.reports">\n\t\t\t\t\t{{TABS.reports.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-team-tab" href="" ng-class="{active: activeTab.id === TABS.team.id}" ng-click="setActiveTab(TABS.team)" ng-if="::tabVisibility.team">\n\t\t\t\t\t{{TABS.team.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-changes-tab" href="" ng-class="{active: activeTab.id === TABS.changes.id}" ng-click="setActiveTab(TABS.changes)" ng-if="::tabVisibility.changes">\n\t\t\t\t\t{{TABS.changes.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-receipts-tab" href="" ng-class="{active: activeTab.id === TABS.receipts.id}" ng-click="setActiveTab(TABS.receipts)" ng-if="::tabVisibility.receipts">\n\t\t\t\t\t{{TABS.receipts.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-period-notes-tab" href="" ng-class="{active: activeTab.id === TABS.periodNotes.id}" ng-click="setActiveTab(TABS.periodNotes)" ng-if="::tabVisibility.periodNotes">\n\t\t\t\t\t{{TABS.periodNotes.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-period-tasks-tab" href="" ng-class="{active: activeTab.id === TABS.periodTasks.id}" ng-click="setActiveTab(TABS.periodTasks)" ng-if="::tabVisibility.periodTasks">\n\t\t\t\t\t{{TABS.periodTasks.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab" data-cy="pay-period-tabs-pensions-tab" href="" ng-class="{active: activeTab.id === TABS.pensions.id}" ng-click="setActiveTab(TABS.pensions)" ng-if="::tabVisibility.pensions">\n\t\t\t\t\t{{TABS.pensions.label}}\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_tab pay-period-tabs-nav_tab has-counter" data-cy="pay-period-tabs-alerts-tab" href="" ng-class="{active: activeTab.id === TABS.alerts.id}" ng-click="setActiveTab(TABS.alerts)" ng-if="::tabVisibility.alerts">\n\t\t\t\t\t{{TABS.alerts.label}}\n\t\t\t\t\t<span ng-if="alertsState === \'loading\' || payrollAlerts" class="tab-bar_tab-counter" ng-class="{\n\t\t\t\t\t\t\t\'assertive inverse\' : payrollAlerts.hasErrors,\n\t\t\t\t\t\t\t\'primary\' : !payrollAlerts.hasErrors,\n\t\t\t\t\t\t\t\'inverse\' : activeTab.id === TABS.alerts.id,\n\t\t\t\t\t\t\t\'tada\' : alertsState === \'ready\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="alertsState === \'loading\'"></i>\n\t\t\t\t\t\t<span ng-if="alertsState === \'ready\'">{{payrollAlerts.alertsCount | nineMax}}</span>\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\n\t\t\t</div>\n\t\t</nav>\n\n\t\t<!-- Tabs -->\n\t\t<section ng-switch="activeTab.id">\n\n\t\t\t<!-- Smart View -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.smartView.id" ng-if="isSmartViewFeatureEnabled">\n\t\t\t\t<section class="pay-period-tabs-section">\n\t\t\t\t\t<div class="smart-view-line smart-view-header-with-feedback" data-cy="pay-period-tabs-smart-view-subtitle">\n\t\t\t\t\t\t<p>{{smartViewSections.subtitleSection.subtitleText}}</p>\n\n\t\t\t\t\t<!-- Smart View Feedback Section -->\n\t\t\t\t\t\t<div ng-style="{\'transition\':\'opacity 0.3s\',\'opacity\': smartViewFeedbackFading ? 0 : 1}">\n\t\t\t\t\t\t\t<copilot-feedback copilot-feature="{{COPILOT_FEATURES.smartView}}" data-cy="smart-view-feedback" label-text="{{!payPeriod.FeedbackSubmitted ? \'Like our new Smart View?\' : \'Thanks for your feedback!\'}}" ng-class="{\'is-disabled\': submittingFeedback}" on-feedback-click="handleSmartViewFeedback(copilotFeature, feedbackType, onSubmitComplete)" on-feedback-submitted="handleFeedbackSubmitted()" show-buttons="!payPeriod.FeedbackSubmitted"></copilot-feedback>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="smart-view-line summary-header">\n\t\t\t\t\t\t<h5>Summary</h5>\n\t\t\t\t\t\t<div class="summary-toggle">\n\t\t\t\t\t\t\t<span class="toggle-label">&pound;</span>\n\t\t\t\t\t\t\t<a href="" class="toggle-a s" data-cy="pay-period-tabs-smart-view-summary-percentage-toggle" ng-class="{\'primary\': !smartViewSections.summarySection.percentageMode, \'active tertiary\': smartViewSections.summarySection.percentageMode}" ng-click="togglePercentageMode()"></a>\n\t\t\t\t\t\t\t<span class="toggle-label">&#37;</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="smart-view-line" data-cy="pay-period-tabs-smart-view-summary-loading" ng-if="smartViewSections.summarySection.state === \'loading\'">\n\t\t\t\t\t\t<loading-block></loading-block>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div data-cy="pay-period-tabs-smart-view-summary-ready" ng-if="smartViewSections.summarySection.state === \'ready\'">\n\t\t\t\t\t\t<div class="smart-view-line">\n\t\t\t\t\t\t\t<div class="payroll-comparison-dashboard">\n\t\t\t\t\t\t\t\t<div class="payroll-metric-card">\n\t\t\t\t\t\t\t\t\t\t<a class="smart-view-info-icon" data-cy="pay-period-tabs-smart-view-summary-info-gross" href="" ng-click="openSmartViewInfoModal(\'gross-pay\')"><i class="icon-information"></i></a>\n\t\t\t\t\t\t\t\t\t\t<h4 class="payroll-metric-title" data-cy="pay-period-tabs-smart-view-summary-title-gross">Gross pay</h4>\n\t\t\t\t\t\t\t\t\t<div class="payroll-metric-amount-row">\n\t\t\t\t\t\t\t\t\t\t<h2 class="payroll-metric-amount" data-cy="pay-period-tabs-smart-view-summary-current-gross">{{smartViewSections.summarySection.fields.grossPay.currentValue}}</h2>\n\t\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-summary-difference-gross" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-neutral\' : smartViewSections.summarySection.fields.grossPay.direction === \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : smartViewSections.summarySection.fields.grossPay.direction !== \'down\' && smartViewSections.summarySection.fields.grossPay.direction !== \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : smartViewSections.summarySection.fields.grossPay.direction === \'down\'\n\t\t\t\t\t\t\t\t\t\t\t}">{{(smartViewSections.summarySection.percentageMode ? \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.grossPay.percentageChange : \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.grossPay.monetaryChange)}}</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="payroll-metric-explanation" data-cy="pay-period-tabs-smart-view-summary-explanations-gross">{{smartViewSections.summarySection.fields.grossPay.explanations}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="payroll-metric-card">\n\t\t\t\t\t\t\t\t\t\t<a class="smart-view-info-icon" data-cy="pay-period-tabs-smart-view-summary-info-net" href="" ng-click="openSmartViewInfoModal(\'net-pay\')"><i class="icon-information"></i></a>\n\t\t\t\t\t\t\t\t\t\t<h4 class="payroll-metric-title" data-cy="pay-period-tabs-smart-view-summary-title-net">Net pay</h4>\n\t\t\t\t\t\t\t\t\t<div class="payroll-metric-amount-row">\n\t\t\t\t\t\t\t\t\t\t<h2 class="payroll-metric-amount" data-cy="pay-period-tabs-smart-view-summary-current-net">{{smartViewSections.summarySection.fields.netPay.currentValue}}</h2>\n\t\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-summary-difference-net" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-neutral\' : smartViewSections.summarySection.fields.netPay.direction === \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : smartViewSections.summarySection.fields.netPay.direction !== \'down\' && smartViewSections.summarySection.fields.netPay.direction !== \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : smartViewSections.summarySection.fields.netPay.direction === \'down\'\n\t\t\t\t\t\t\t\t\t\t\t}">{{(smartViewSections.summarySection.percentageMode ? \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.netPay.percentageChange : \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.netPay.monetaryChange)}}</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="payroll-metric-explanation" data-cy="pay-period-tabs-smart-view-summary-explanations-net">{{smartViewSections.summarySection.fields.netPay.explanations}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="payroll-metric-card">\n\t\t\t\t\t\t\t\t\t\t<a class="smart-view-info-icon" data-cy="pay-period-tabs-smart-view-summary-info-paye" href="" ng-click="openSmartViewInfoModal(\'paye\')"><i class="icon-information"></i></a>\n\t\t\t\t\t\t\t\t\t\t<h4 class="payroll-metric-title" data-cy="pay-period-tabs-smart-view-summary-title-paye">PAYE</h4>\n\t\t\t\t\t\t\t\t\t<div class="payroll-metric-amount-row">\n\t\t\t\t\t\t\t\t\t\t<h2 class="payroll-metric-amount" data-cy="pay-period-tabs-smart-view-summary-current-paye">{{smartViewSections.summarySection.fields.paye.currentValue}}</h2>\n\t\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-summary-difference-paye" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-neutral\' : smartViewSections.summarySection.fields.paye.direction === \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : smartViewSections.summarySection.fields.paye.direction !== \'down\' && smartViewSections.summarySection.fields.paye.direction !== \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : smartViewSections.summarySection.fields.paye.direction === \'down\'\n\t\t\t\t\t\t\t\t\t\t\t}">{{(smartViewSections.summarySection.percentageMode ? \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.paye.percentageChange : \n\t\t\t\t\t\t\t\t\t\t\tsmartViewSections.summarySection.fields.paye.monetaryChange)}}</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="payroll-metric-explanation" data-cy="pay-period-tabs-smart-view-summary-explanations-paye">{{smartViewSections.summarySection.fields.paye.explanations}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="smart-view-line">\n\t\t\t\t\t\t\t<div class="payroll-metric-amount-row">\n\t\t\t\t\t\t\t\t<h6 data-cy="pay-period-tabs-smart-view-summary-headcount-text">\n\t\t\t\t\t\t\t\t\t<img src="images/icons/smart-view-headcount.png" alt="Headcount">\n\t\t\t\t\t\t\t\t\t<strong>Headcount:</strong> <span style="font-weight: 400;">{{smartViewSections.summarySection.fields.employeeCount.currentValue}} team members included in this pay run</span>\n\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-summary-headcount-difference" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'is-neutral\' : smartViewSections.summarySection.fields.employeeCount.direction === \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : smartViewSections.summarySection.fields.employeeCount.direction !== \'decreased\' && smartViewSections.summarySection.fields.employeeCount.direction !== \'none\',\n\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : smartViewSections.summarySection.fields.employeeCount.direction === \'decreased\'\n\t\t\t\t\t\t\t\t\t\t}">{{smartViewSections.summarySection.fields.employeeCount.countDifference}}</span>\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="smart-view-line">\n\t\t\t\t\t\t\t<accordion-item ai-description="{{netPayVariance.highChangeCount <= 5 ? netPayVariance.highChangeCount : \'Top 5\'}} {{netPayVariance.highChangeCount === 1 ? \'team member\' : \'team members\'}} with 5%+ change in net pay" ai-description-styles="netPayVariance.aiSettings.highChange.aiDescriptionStyles" ai-description-marker-styles="netPayVariance.aiSettings.highChange.aiDescriptionMarkerStyles" ai-has-hidden-content="netPayVariance.highChangeCount !== 0" ai-hide-sections="netPayVariance.aiSettings.highChange.aiHideSections" ai-id="summary-high-change" ai-theme="primary" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-accordion">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-cards">\n\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-card" ng-repeat="employee in netPayVariance.highChange">\n\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_persona">\n\t\t\t\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{employee.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{employee.UserID}}" class="smart-view-employee-card_avatar" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-avatar"></avatar>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="smart-view-employee-card_name" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.Forename}} {{employee.Surname}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_amounts">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-change-amount" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : employee.NetPayChange >= 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : employee.NetPayChange < 0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{(smartViewSections.summarySection.percentageMode ? \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(employee.VariancePercentage | decimalise) + \'%\' : \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(employee.NetPayChange | monetise))}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="smart-view-employee-card_total" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-total-amount">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.TotalNetPay | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_description">\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" data-cy="pay-period-tabs-smart-view-net-pay-variance-high-employee-description">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.PayChangeDescription}}\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\n\t\t\t\t\t\t\t<accordion-item ai-description="{{netPayVariance.mediumChangeCount <= 5 ? netPayVariance.mediumChangeCount : \'Top 5\'}} {{netPayVariance.mediumChangeCount === 1 ? \'team member\' : \'team members\'}} with 2-5% change in net pay" ai-description-styles="netPayVariance.aiSettings.mediumChange.aiDescriptionStyles" ai-description-marker-styles="netPayVariance.aiSettings.mediumChange.aiDescriptionMarkerStyles" ai-has-hidden-content="netPayVariance.mediumChangeCount !== 0" ai-hide-sections="netPayVariance.aiSettings.mediumChange.aiHideSections" ai-id="summary-medium-change" ai-theme="primary" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-accordion">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-cards">\n\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-card" ng-repeat="employee in netPayVariance.mediumChange">\n\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_persona">\n\t\t\t\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{employee.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{employee.UserID}}" class="smart-view-employee-card_avatar" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-avatar"></avatar>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="smart-view-employee-card_name" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.Forename}} {{employee.Surname}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_amounts">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="tag" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-change-amount" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-positive\' : employee.NetPayChange >= 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\' : employee.NetPayChange < 0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{(smartViewSections.summarySection.percentageMode ? \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(employee.VariancePercentage | decimalise) + \'%\' : \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(employee.NetPayChange | monetise))}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="smart-view-employee-card_total" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-total-amount">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.TotalNetPay | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="smart-view-employee-card_description">\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" data-cy="pay-period-tabs-smart-view-net-pay-variance-medium-employee-description">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{employee.PayChangeDescription}}\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="smart-view-line" ng-if="smartViewSections.summarySection.state === \'error\'">\n\t\t\t\t\t\t<error-block data-cy="pay-period-tabs-smart-view-summary-error-no-args" ng-if="!smartViewSections.summarySection.copilotError">\n\t\t\t\t\t\t</error-block>\n\t\t\t\t\t\t<error-block data-cy="pay-period-tabs-smart-view-summary-error-with-title-and-message" ng-if="smartViewSections.summarySection.copilotError" title="\'There seems to be a problem with Copilot\'">\n\t\t\t\t\t\t\t<p data-cy="pay-period-tabs-smart-view-summary-first-error-copilot-message" ng-if="smartViewSections.summarySection.copilotFirstErrorMessage">\n\t\t\t\t\t\t\t\tSummary is taking longer than expected to analyse your payroll data.\n\t\t\t\t\t\t\t\t<a class="underline" href="" ng-click="reloadSmartView()">\n\t\t\t\t\t\t\t\t\tPlease refresh the section to try again\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\tor contact support if the issue persists.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-period-tabs-smart-view-summary-second-error-copilot-message" ng-if="!smartViewSections.summarySection.copilotFirstErrorMessage">\n\t\t\t\t\t\t\t\tSummary is taking longer than expected to analyse your payroll data.\n\t\t\t\t\t\t\t\t<a class="underline" href="" ng-click="reloadPage()">\n\t\t\t\t\t\t\t\t\tTry refreshing the page\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\tor contact support if the issue persists.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</error-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Draft Payslips Section -->\n\t\t\t\t\t<div class="smart-view-line" data-cy="pay-period-tabs-smart-view-draft-payslips" ng-if="smartViewSections.draftPayslipsSection.state === \'ready\' && smartViewSections.draftPayslipsSection.canGenerateDraftPayslips">\n\t\t\t\t\t\t<!-- None State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.none">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<p class="is-small" data-cy="pay-period-tabs-smart-view-draft-payslips-message">\n\t\t\t\t\t\t\t\t\tSend team members a draft copy of their payslip to review in their Pay Portal before payroll is finalised.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<a class="smart-view-action-link" data-cy="pay-period-tabs-smart-view-draft-payslips-send-action" href="" ng-click="generateDraftPayslips()">\n\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right primary s"></i> Send draft payslips to Pay Portals\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t\t<!-- Pending or Processing State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="isProcessingState(smartViewSections.draftPayslipsSection.taskState)">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<loading-block position="after" size="s">\n\t\t\t\t\t\t\t\t\t<lb-description>\n\t\t\t\t\t\t\t\t\t\t<span ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.pending || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.processing || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.retryPending || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.retryProcessing">\n\t\t\t\t\t\t\t\t\t\t\tSending draft payslips\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<span ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.cancelPending || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.cancelProcessing">\n\t\t\t\t\t\t\t\t\t\t\tCancelling\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<span ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.recallPending || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.recallProcessing || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.recallComplete">\n\t\t\t\t\t\t\t\t\t\t\tRecalling draft payslips\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</lb-description>\n\t\t\t\t\t\t\t\t</loading-block>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t\t<!-- Complete State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.complete">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips <span class="tag is-inverse is-tertiary">SENT</span></h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<p class="is-small" data-cy="pay-period-tabs-smart-view-draft-payslips-sent-message">\n\t\t\t\t\t\t\t\t\tDraft payslips were sent by {{smartViewSections.draftPayslipsSection.userFullName}} at {{smartViewSections.draftPayslipsSection.updatedTime}} on {{smartViewSections.draftPayslipsSection.updatedDate}}.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<a class="smart-view-action-link" data-cy="pay-period-tabs-smart-view-draft-payslips-sent-recall-action" href="" ng-click="recallDraftPayslips()">\n\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right flip primary s"></i> Recall draft payslips\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t\t<!-- Failed State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.failed || smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.error">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<action-block ab-theme="primary" ab-layout="column compact" ab-icon="icon-warning" ab-icon-theme="assertive" ab-icon-size="is-larger">\n\t\t\t\t\t\t\t\t\t<ab-header>\n\t\t\t\t\t\t\t\t\t\t<h5 data-cy="pay-period-tabs-smart-view-draft-payslips-failed-title">\n\t\t\t\t\t\t\t\t\t\t\tDraft payslips not sent\n\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t</ab-header>\n\t\t\t\t\t\t\t\t\t<ab-main>\n\t\t\t\t\t\t\t\t\t\t<p class="is-medium" data-cy="pay-period-tabs-smart-view-draft-payslips-failed-message">\n\t\t\t\t\t\t\t\t\t\t\tPlease try again. If the problem persists, please contact support.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</ab-main>\n\t\t\t\t\t\t\t\t\t<ab-actions>\n\t\t\t\t\t\t\t\t\t\t<div class="spaced-links align-center">\n\t\t\t\t\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="button is-small" data-cy="pay-period-tabs-smart-view-draft-payslips-failed-cancel-action" href="" ng-click="cancelSendDraftPayslips()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-cross has-margin-right"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Cancel</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="button is-primary is-small" data-cy="pay-period-tabs-smart-view-draft-payslips-failed-retry-action" href="" ng-click="retrySendDraftPayslips()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-loading has-margin-right"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Try again</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</ab-actions>\n\t\t\t\t\t\t\t\t</action-block>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t\t<!-- Recall Failed State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.recallFailed">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<action-block ab-theme="primary" ab-layout="column compact" ab-icon="icon-warning" ab-icon-theme="assertive" ab-icon-size="is-larger">\n\t\t\t\t\t\t\t\t\t<ab-header>\n\t\t\t\t\t\t\t\t\t\t<h5 data-cy="pay-period-tabs-smart-view-draft-payslips-recall-failed-title">\n\t\t\t\t\t\t\t\t\t\t\tDraft payslips not recalled\n\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t</ab-header>\n\t\t\t\t\t\t\t\t\t<ab-main>\n\t\t\t\t\t\t\t\t\t\t<p class="is-medium" data-cy="pay-period-tabs-smart-view-draft-payslips-recall-failed-message">\n\t\t\t\t\t\t\t\t\t\t\tPlease try again. If the problem persists, please contact support.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</ab-main>\n\t\t\t\t\t\t\t\t\t<ab-actions>\n\t\t\t\t\t\t\t\t\t\t<div class="spaced-links align-center">\n\t\t\t\t\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="button is-primary is-small" data-cy="pay-period-tabs-smart-view-draft-payslips-recall-failed-retry-action" href="" ng-click="retryRecallDraftPayslips()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-loading has-margin-right"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Try again</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</ab-actions>\n\t\t\t\t\t\t\t\t</action-block>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t\t<!-- No Team Members State -->\n\t\t\t\t\t\t<info-block ib-theme="primary has-icon has-border has-plain-type" ng-if="smartViewSections.draftPayslipsSection.taskState === DRAFT_PAYSLIP_TASK_STATES.noTeamMembers">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip primary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Draft payslips</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<action-block ab-theme="primary" ab-layout="column compact" ab-icon="icon-information" ab-icon-theme="primary" ab-icon-size="is-larger">\n\t\t\t\t\t\t\t\t\t<ab-header>\n\t\t\t\t\t\t\t\t\t\t<h5 data-cy="pay-period-tabs-smart-view-draft-payslips-no-team-members-title">\n\t\t\t\t\t\t\t\t\t\t\tNo team members active on payroll\n\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t</ab-header>\n\t\t\t\t\t\t\t\t\t<ab-main>\n\t\t\t\t\t\t\t\t\t\t<p class="is-medium" data-cy="pay-period-tabs-smart-view-draft-payslips-no-team-members-message">\n\t\t\t\t\t\t\t\t\t\t\tThis may be because they\'re all on hold or have been advanced a number of future periods.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</ab-main>\n\t\t\t\t\t\t\t\t</action-block>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</section>\n\n\t\t\t\t<!-- TODO: upcoming feature -->\n\t\t\t\t<!-- <section class="pay-period-tabs-section">\n\t\t\t\t\t<div class="smart-view-box" data-cy="pay-period-tabs-smart-view-next-month">\n\t\t\t\t\t\t<h6>A look at next month</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</section> -->\n\n\t\t\t\t<!-- TODO: upcoming feature -->\n\t\t\t\t<!-- <section class="pay-period-tabs-section">\n\t\t\t\t\t<div class="smart-view-box" data-cy="pay-period-tabs-smart-view-smart-moves">\n\t\t\t\t\t\t<h6>Smart moves</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</section> -->\n\t\t\t</div>\n\n\t\t\t<!-- Summary reports -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.reports.id">\n\n\t\t\t\t<loading-block ng-if="reportsState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="reportsState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="reportsState === \'ready\' && tabVisibility.reports">\n\n\t\t\t\t\t<!-- Preview Report Warning -->\n\t\t\t\t\t<section class="pay-period-tabs-section" ng-if="payPeriod.PayrollState !== SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<p class="is-small is-strong">\n\t\t\t\t\t\t\t<span class="is-tertiary">WARNING:</span> These are draft reports. Please do not pay your team or HMRC using the data in these reports.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Generating reports -->\n\t\t\t\t\t<loading-block ng-if="payPeriod.ReportState === SUBMISSION_STATES.submitting">Generating reports...</loading-block>\n\n\t\t\t\t\t<!-- Reports -->\n\t\t\t\t\t<section class="pay-period-tabs-section" ng-if="payPeriod.ReportState !== SUBMISSION_STATES.submitting">\n\n\t\t\t\t\t\t<!-- RTI submission disabled -->\n\t\t\t\t\t\t<section class="pay-period-tabs-section" ng-if="payPeriod.IsRTISubmissionDisabled && payPeriod.PayrollState === SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t\t<p class="is-small is-strong">\n\t\t\t\t\t\t\t\t<span class="is-secondary">RTI submission OFF:</span> Your FPS and EPS were not submitted to HMRC\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<section class="pay-period-tabs-section">\n\n\t\t\t\t\t\t\t<!-- Supplementary Pay Runs -->\n\t\t\t\t\t\t\t<div class="supplementary-pay-run-cards" ng-if="supplementaryPayRuns.length > 0">\n\t\t\t\t\t\t\t\t<div class="supplementary-pay-run-card" ng-class="[\n\t\t\t\t\t\t\t\t\t\tsupplementaryPayRun.theme,\n\t\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\t\t\'is-odd\': $even,\n\t\t\t\t\t\t\t\t\t\t\t\'is-last\': $last\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t]" ng-repeat="supplementaryPayRun in supplementaryPayRuns">\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<p class="supplementary-pay-run-card_label">\n\t\t\t\t\t\t\t\t\t\t\tSupplementary pay run - {{supplementaryPayRun.SupplementaryPaymentState | supplementaryPaymentStateLabel}}\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<p class="supplementary-pay-run-card_title">\n\t\t\t\t\t\t\t\t\t\t\t{{supplementaryPayRun.SupplementaryPaymentTitle}}\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<span class="supplementary-pay-run-card_action">\n\t\t\t\t\t\t\t\t\t\tView pay run<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<a class="supplementary-pay-run-card_overlay" data-cy="pay-period-tabs-reports-view-supp-pay-run={{$index}}" ui-sref="payroll.supplementary-pay-run.reports({\n\t\t\t\t\t\t\t\t\t\t\tpayPeriodId: supplementaryPayRun.AgencyPayPeriodID,\n\t\t\t\t\t\t\t\t\t\t\tsupplementaryPaymentId: supplementaryPayRun.SupplementaryPaymentID\n\t\t\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="report-download-card_wrapper" ng-if="reports.length > 0">\n\t\t\t\t\t\t\t\t<report-download-card agency-profile-id="company.AgencyProfileID" form-options="formOptions" ng-repeat="report in reports | orderBy: [\'-CanDownload\', \'DisplayName\'] " on-update="onPayPeriodChange()" pay-period="payPeriod" report="report">\n\t\t\t\t\t\t\t\t</report-download-card>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- No Reports -->\n\t\t\t\t\t\t\t<div class="sub-page-template-a-section" ng-if="reports.length === 0">\n\t\t\t\t\t\t\t\t<placeholder placeholder-graphic="generic-files">\n\t\t\t\t\t\t\t\t\t<placeholder-title>No reports available</placeholder-title>\n\t\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t\t<p>No reports are available as they haven\u2019t been assigned to or added for {{company.Name}} yet.</p>\n\t\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t\t\t\t\t<a class="link-with-icon primary" data-cy="pay-period-tabs-reports-go-to-report-templates" href="" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports" ui-sref="settings.company.reports.custom({\n\t\t\t\t\t\t\t\t\t\t\t\tagencyProfileId: company.AgencyProfileID\n\t\t\t\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\t\t\t\tGo to report templates<i class="icon-chevron-right is-smedium"></i>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="payPeriod.ReportsGeneratedDateISO !== \'\'">\n\t\t\t\t\t\t\t<em>Created on {{payPeriod.ReportsGeneratedDateISO | datetimeformat}}</em>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Team -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.team.id">\n\n\t\t\t\t<loading-block ng-if="teamState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="teamState === \'error\'"></error-block>\n\n\t\t\t\t<section class="pay-period-tabs-section" ng-if="teamState === \'ready\' && teamMembers.all.length">\n\n\t\t\t\t\t<!-- Filter Bar -->\n\t\t\t\t\t<filter-bar filter-bar-options="filterBarOptions.teamHistory"></filter-bar>\n\n\t\t\t\t\t<!-- Search -->\n\t\t\t\t\t<search-bar bulk-items="teamMembers" options="searchBarOptions.teamHistory"></search-bar>\n\n\t\t\t\t\t<!-- Team Cards -->\n\t\t\t\t\t<section class="team-cards-history" ng-class="searchBarOptions.teamHistory.layout">\n\n\t\t\t\t\t\t<team-card-history agency-profile-id="company.AgencyProfileID" bulk-items="teamMembers" current-page="searchBarOptions.teamHistory.currentPageNumber" dir-paginate="teamMember in teamMembers.filtered = (\n\t\t\t\t\t\t\t\t\tteamMembers.all |\n\t\t\t\t\t\t\t\t\tfilter : searchBarOptions.teamHistory.search.string |\n\t\t\t\t\t\t\t\t\tfilter : filterBarOptions.teamHistory.appliedFilter\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy : searchBarOptions.teamHistory.orderBy : searchBarOptions.teamHistory.results.reverse |\n\t\t\t\t\t\t\t\titemsPerPage : searchBarOptions.teamHistory.results.itemsPerPage\n\t\t\t\t\t\t\t" pay-period="payPeriod" search-bar-options="searchBarOptions.teamHistory" team-member="teamMember" team-members="teamMembers.all"></team-card-history>\n\n\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t<empty-search ng-show="teamMembers.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.teamHistory.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- No team members -->\n\t\t\t\t<placeholder ng-if="teamState === \'ready\' && !teamMembers.all.length" placeholder-graphic-size="l" placeholder-graphic="team">\n\t\t\t\t\t<placeholder-title>No team members processed this pay period</placeholder-title>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\n\t\t\t<!-- Changes -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.changes.id">\n\n\t\t\t\t<loading-block ng-if="adjustmentsState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="adjustmentsState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="adjustmentsState === \'ready\'">\n\n\t\t\t\t\t<!-- Unsubmitted -->\n\t\t\t\t\t<placeholder ng-if="!adjustmentDetailList.length && !payPeriod.IsPayrollLocked && payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t\t\t\t\t<placeholder-title>No changes have been made yet</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>As you start adding changes they will start to appear here.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t<placeholder-primary-actions ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\t\t\t\t<a class="button is-primary" data-cy="pay-period-tabs-changes-add-a-change" href="" ng-click="openAddAChangeForm()">\n\t\t\t\t\t\t\t\t<i class="icon-plus"></i>\n\t\t\t\t\t\t\t\t<span>Add a change</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t</placeholder>\n\n\t\t\t\t\t<!-- Submitted -->\n\t\t\t\t\t<placeholder ng-if="!adjustmentDetailList.length && (payPeriod.IsPayrollLocked || payPeriod.PayrollState === SUBMISSION_STATES.submitted)" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t\t\t\t\t<placeholder-title>No payroll changes for this pay period</placeholder-title>\n\t\t\t\t\t</placeholder>\n\n\t\t\t\t\t<!-- Has changes -->\n\t\t\t\t\t<div ng-if="adjustmentDetailList.length">\n\n\t\t\t\t\t\t<!-- Search -->\n\t\t\t\t\t\t<search-bar count="changesFiltered.length" options="searchBarOptions.changes"></search-bar>\n\n\t\t\t\t\t\t<!-- Adjustments List (paginated) -->\n\t\t\t\t\t\t<div class="team-card-changes" current-page="searchBarOptions.changes.currentPageNumber" dir-paginate="adjustmentDetail in changesFiltered = (\n\t\t\t\t\t\t\t\t\tadjustmentDetailList |\n\t\t\t\t\t\t\t\t\tfilter : searchBarOptions.changes.search.string\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy : searchBarOptions.changes.orderBy : searchBarOptions.changes.results.reverse |\n\t\t\t\t\t\t\t\titemsPerPage : searchBarOptions.changes.results.itemsPerPage\n\t\t\t\t\t\t\t">\n\n\t\t\t\t\t\t\t<div class="team-card-changes_person">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{adjustmentDetail.UserForename[0]}}" avatar-size="is-medium" avatar-user-id="{{adjustmentDetail.UserID}}" class="team-card-changes_avatar"></avatar>\n\t\t\t\t\t\t\t\t<a data-cy="pay-period-tabs-changes-go-to-profile-{{$index}}" ui-sref="team.profile.overview({\n\t\t\t\t\t\t\t\t\t\tagencyProfileId: company.AgencyProfileID,\n\t\t\t\t\t\t\t\t\t\tuserId: adjustmentDetail.UserID\n\t\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\t\t{{::adjustmentDetail.UserForename}} {{::adjustmentDetail.UserSurname}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t \t\t<!-- Team Member Adjustments -->\n\t\t\t\t\t\t\t<adjustments-list adjustment-detail-summary="adjustmentDetail" agency-profile-id="{{company.AgencyProfileID}}" callback="onPayPeriodChange" can-update="payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted && !payPeriod.IsPayrollLocked" class="team-card-changes_changes" form-options="formOptions" pay-period="payPeriod" theme="is-block" user-id="{{adjustmentDetail.UserID}}"></adjustments-list>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t<empty-search ng-show="changesFiltered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.changes.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Submission receipts -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.receipts.id">\n\n\t\t\t\t<ul class="check-list" ng-if="payPeriod.IRMarkEPS !== \'\' || payPeriod.IRMarkFPS !== \'\' || payPeriod.IRMarkCIS300 !== \'\'">\n\t\t\t\t\t<li class="check-list-item" ng-if="payPeriod.IRMarkEPS !== \'\'">\n\t\t\t\t\t\tEPS Reference (IR Mark): <strong>{{payPeriod.IRMarkEPS}}</strong>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="check-list-item" ng-if="payPeriod.IRMarkFPS !== \'\'">\n\t\t\t\t\t\tFPS Reference (IR Mark): <strong>{{payPeriod.IRMarkFPS}}</strong>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="check-list-item" ng-if="payPeriod.IRMarkCIS300 !== \'\'">\n\t\t\t\t\t\tCIS 300 (IR Mark): <strong>{{payPeriod.IRMarkCIS300}}</strong>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<p class="is-small" ng-if="payPeriod.IRMarkEPS === \'\' && payPeriod.IRMarkFPS === \'\' && payPeriod.IRMarkCIS300 === \'\'">\n\t\t\t\t\tThere are no submission receipts to show for this period.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payroll alerts -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.alerts.id">\n\n\t\t\t\t<loading-block ng-if="alertsState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="alertsState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="alertsState === \'ready\' && payrollAlerts.alertsCount">\n\t\t\t\t\t<filter-bar apply-filter-keys="applyFilter" filter-bar-options="filterBarOptions.payrollAlerts" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t\t\t\t<search-bar count="payrollAlerts.alertsCount" options="searchBarOptions.payrollAlerts">\n\t\t\t\t\t\t<sb-actions>\n\t\t\t\t\t\t\t<div ng-switch="alertDownloadState">\n\t\t\t\t\t\t\t\t<a class="link-with-icon" data-cy="pay-period-tabs-alerts-alerts-report" href="" ng-click="createAlertReportDownload(company, payPeriod)" ng-switch-default>\n\t\t\t\t\t\t\t\t\t<i class="icon-download"></i> Alerts report\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<span ng-switch-when="loading">\n\t\t\t\t\t\t\t\t\t<circle-loader size="s"></circle-loader>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</sb-actions>\n\t\t\t\t\t</search-bar>\n\n\t\t\t\t\t<payroll-alerts-level agency-pay-period-id="payPeriod.PayPeriodID" agency-profile-id="company.AgencyProfileID" level="level" ng-repeat="level in payrollAlerts.filteredLevels = (\n\t\t\t\t\t\t\tpayrollAlerts.levels |\n\t\t\t\t\t\t\tfilter : searchBarOptions.payrollAlerts.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.payrollAlerts.appliedFilter\n\t\t\t\t\t\t)" reload-alerts="onPayPeriodChange()" search-bar-options="searchBarOptions.payrollAlerts" set-tab="setActiveTab"></payroll-alerts-level>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search ng-show="payrollAlerts.filteredLevels.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t\t</div>\n\n\t\t\t\t<placeholder ng-if="alertsState === \'ready\' && !payrollAlerts.alertsCount" placeholder-graphic-size="l" placeholder-graphic="alerts">\n\t\t\t\t\t<placeholder-title>No alerts for this pay period</placeholder-title>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\n\t\t\t<!-- Period Notes -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.periodNotes.id">\n\n\t\t\t\t<loading-block ng-if="notesState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="notesState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="notesState === \'ready\' && periodNotes.length">\n\n\t\t\t\t\t<search-bar count="periodNotes.length" options="searchBarOptions.notes"></search-bar>\n\n\t\t\t\t\t<div class="pay-period-note_wrapper rows">\n\t\t\t\t\t\t<pay-period-note agency-pay-period-id="payPeriod.PayPeriodID" agency-profile-id="company.AgencyProfileID" ng-repeat="periodNote in filtered = (\n\t\t\t\t\t\t\t\t\tperiodNotes |\n\t\t\t\t\t\t\t\t\tfilter : searchBarOptions.notes.search.string\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy : searchBarOptions.notes.orderBy : searchBarOptions.notes.results.reverse\n\t\t\t\t\t\t\t" note="periodNote" refresh-notes="refreshNotes()"></pay-period-note>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<placeholder ng-if="notesState === \'ready\' && !periodNotes.length" placeholder-graphic-size="l" placeholder-graphic="notes">\n\t\t\t\t\t<placeholder-title>No notes for this pay period</placeholder-title>\n\t\t\t\t</placeholder>\n\n\t\t\t</div>\n\n\t\t\t<!-- Period Tasks -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.periodTasks.id">\n\n\t\t\t\t<loading-block ng-if="tasksState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="tasksState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="tasksState === \'ready\' && periodTasks.all.length">\n\n\t\t\t\t\t<filter-bar apply-filter-keys="applyFilter" filter-bar-options="filterBarOptions.periodTasks" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t\t\t\t<search-bar count="periodTasks.filtered.length" options="searchBarOptions.periodTasks">\n\t\t\t\t\t\t<sb-actions>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<span class="is-small greyscale-dark" data-cy="pay-period-tabs-period-tasks-show-complete" ng-click="toggleShowCompleteTasks()">\n\t\t\t\t\t\t\t\t\t<span class="toggle-d" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'active\' : showCompleteTasks\n\t\t\t\t\t\t\t\t\t\t}"></span>&nbsp;&nbsp;Show complete\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</sb-actions>\n\t\t\t\t\t</search-bar>\n\n\t\t\t\t\t<div class="period-task-card_wrapper">\n\t\t\t\t\t\t<period-task-card agency-pay-period-id="payPeriod.PayPeriodID" ng-repeat="task in periodTasks.filtered = (\n\t\t\t\t\t\t\t\tperiodTasks.all |\n\t\t\t\t\t\t\t\tfilter : searchBarOptions.periodTasks.search.string |\n\t\t\t\t\t\t\t\tfilter : filterBarOptions.periodTasks.appliedFilter |\n\t\t\t\t\t\t\t\ttasksOrder:showCompleteTasks\n\t\t\t\t\t\t\t)" refresh-tasks="refreshTasks" task="task"></period-task-card>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search ng-show="periodTasks.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t\t</div>\n\n\t\t\t\t<placeholder ng-if="tasksState === \'ready\' && !periodTasks.all.length" placeholder-graphic-size="l" placeholder-graphic="tasks">\n\t\t\t\t\t<placeholder-title>No tasks for this pay period</placeholder-title>\n\t\t\t\t</placeholder>\n\n\t\t\t</div>\n\n\t\t\t<!-- Pension history -->\n\t\t\t<div class="pay-period-tab fadeIn" pc-switch-when="TABS.pensions.id">\n\n\t\t\t\t<loading-block ng-if="pensionsState === \'loading\'"></loading-block>\n\n\t\t\t\t<error-block ng-if="pensionsState === \'error\'"></error-block>\n\n\t\t\t\t<div ng-if="pensionsState === \'ready\' && pensionLogEntries.length > 0">\n\n\t\t\t\t\t<!-- Search Bar -->\n\t\t\t\t\t<search-bar count="pensionLogEntries.length" options="searchBarOptions.pensionHistory"></search-bar>\n\n\t\t\t\t\t<!-- Log Cards -->\n\t\t\t\t\t<section class="log-cards" ng-class="searchBarOptions.layout">\n\t\t\t\t\t\t<log-card class="slideIn" dir-paginate="logEntry in filteredLogs = (\n\t\t\t\t\t\t\t\tpensionLogEntries |\n\t\t\t\t\t\t\t\tfilter : searchBarOptions.pensionHistory.search.string |\n\t\t\t\t\t\t\t\torderBy : log.logMeta.dateUnix : searchBarOptions.pensionHistory.results.reverse |\n\t\t\t\t\t\t\t\titemsPerPage : searchBarOptions.pensionHistory.results.itemsPerPage\n\t\t\t\t\t\t\t)" log="logEntry" show-log-actor="true"></log-card>\n\n\t\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t\t<empty-search ng-show="filteredLogs.length === 0" search-bar-options="searchBarOptions.pensionHistory"></empty-search>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="pensionsState === \'ready\' && pensionLogEntries.length === 0">\n\t\t\t\t\t<placeholder placeholder-graphic="no-pension-history" placeholder-graphic-size="l">\n\t\t\t\t\t\t<placeholder-title>No history for this period</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>A history of changes to your pension schemes or team member pension settings that occur in this period will appear here.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\t</div>\n\n\t<error-block has-gutter="true" ng-if="componentState === \'error\'"></error-block>\n</div>\n');
$templateCache.put('components/pay-period-workflow/pay-period-workflow.component.html','<div class="pay-period-workflow dropIn" ng-class="$ctrl.isOpen ? \'is-open\' : \'is-closed\'">\n\n\t<div class="pay-period-workflow_timeline" ng-class="$ctrl.isOpen ? \'is-open\' : \'is-closed\'">\n\n\t\t<div class="pay-period-workflow_timeline-steps">\n\t\t\t<div class="pay-period-workflow_timeline-step" ng-class="{\'is-active\': templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.current}" ng-repeat="(templateEntryIndex, templateEntry) in $ctrl.workflowTemplate.TemplateEntries">\n\t\t\t\t<div class="pay-period-workflow_timeline-progress" ng-class="{\'is-penultimate\': templateEntryIndex === $ctrl.workflowTemplate.TemplateEntries.length - 2, \'is-last\': $last, \'is-positive\': templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.complete, \'is-assertive\': templateEntry.IsOverdue}">\n\t\t\t\t\t<div class="pay-period-workflow_timeline-progress-bar" style="width:{{templateEntry.TimePercent}}%" ng-class="{\'is-positive\': templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.complete}"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="badge is-extra-small is-primary pay-period-workflow_timeline-step-badge" ng-class="{\'is-placeholder\': templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.active, \'is-positive\': templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.complete, \'is-assertive\': templateEntry.IsOverdue}">\n\t\t\t\t\t<i class="icon-{{templateEntry.IsOverdue ? \'warning\' : templateEntry.State === $ctrl.WORKFLOW_TEMPLATE_ENTRY_STATES.complete ? \'check\' : \'loading\'}}"></i>\n\t\t\t\t</div>\n\t\t\t\t<p class="pay-period-workflow_timeline-step-title">{{templateEntry.Title}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<a href="" ng-click="$ctrl.toggleIsOpen($ctrl)" class="pay-period-workflow_timeline-tab" ng-class="$ctrl.isOpen ? \'is-open\' : \'is-closed\'">\n\n\t\t\t<!-- Bureau / Actioner -->\n\t\t\t<span ng-if="$ctrl.workflowTemplate.TemplateEntryCurrent.BureauDisplay || $ctrl.workflowTemplate.TemplateEntryCurrent.IsActioner">Step {{$ctrl.workflowTemplate.TemplateEntryCurrent.Number}}: {{$ctrl.workflowTemplate.TemplateEntryCurrent.Title}}</span>\n\n\t\t\t<!-- Other -->\n\t\t\t<span ng-if="!$ctrl.workflowTemplate.TemplateEntryCurrent.BureauDisplay && !$ctrl.workflowTemplate.TemplateEntryCurrent.IsActioner" ng-switch="$ctrl.workflowTemplate.TemplateEntryCurrent.Number">\n\t\t\t\t<span ng-switch-when="1|3" ng-switch-when-separator="|">Step {{$ctrl.workflowTemplate.TemplateEntryCurrent.Number}}: {{$ctrl.workflowTemplate.TemplateEntryCurrent.Title}}</span>\n\t\t\t\t<span ng-switch-when="2"><i class="icon-loading spin m"></i>&nbsp;&nbsp;Your draft reports are being prepared</span>\n\t\t\t\t<span ng-switch-when="4">Your payroll will be run on {{$ctrl.workflowTemplate.TemplateEntryCurrent.DueDateISO | dateformat:\'dayMonth\'}}</span>\n\t\t\t</span>\n\t\t</a>\n\t</div>\n\n\t<!-- Bureau display -->\n\t<div class="pay-period-workflow_summary" ng-if="$ctrl.workflowTemplate.TemplateEntryCurrent.BureauDisplay">\n\n\t\t<div class="pay-period-workflow_summary-secondary-actions" ng-if="$ctrl.workflowTemplate.TemplateEntryCurrent.Number > 1 || $ctrl.workflowTemplate.IsApproveAvailable">\n\n\t\t\t<!-- Go back -->\n\t\t\t<a href="" ng-click="$ctrl.openCompleteStepForm($ctrl, \'go-back\')" class="button white" ng-if="$ctrl.workflowTemplate.TemplateEntryCurrent.Number > 1 && $root.userHasRole([$ctrl.USER_ROLES.paycircle, $ctrl.USER_ROLES.bureau, $ctrl.USER_ROLES.bureaumanager])"><i class="icon-arrow-right flip m"></i>&nbsp;<span class="strong">Go back</span></a>\n\n\t\t\t<!-- Query reports -->\n\t\t\t<a href="" ng-click="$ctrl.openCompleteStepForm($ctrl, \'query-reports\')" class="button white" ng-if="$ctrl.workflowTemplate.IsApproveAvailable"><span class="strong">Query reports</span></a>\n\n\t\t</div>\n\n\t\t<div class="pay-period-workflow_summary-container">\n\n\t\t\t<!-- Actioner > Company -->\n\t\t\t<div class="pay-period-workflow_summary-actioner">\n\t\t\t\t<avatar avatar-initial="{{$ctrl.workflowTemplate.TemplateEntryCurrent.Actioner[0]}}" avatar-size="is-tiny" avatar-theme="is-primary" class="pay-period-workflow_summary-actioner-avatar"></avatar>\n\t\t\t\t<span>Assigned to: {{$ctrl.workflowTemplate.TemplateEntryCurrent.Actioner}}</span>\n\t\t\t\t<span class="tag l {{$ctrl.workflowTemplate.TemplateEntryCurrent.IsOverdue ? \'assertive\' : \'secondary\'}} pay-period-workflow_summary-actioner-due" ng-if="$ctrl.workflowTemplate.TemplateEntryCurrent.DueDateISO !== \'\'"><i class="icon-clock s"></i> Due: {{$ctrl.workflowTemplate.TemplateEntryCurrent.DueDateISO | datetimeformat:\'long\'}}</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="pay-period-workflow_summary-primary-actions" ng-if="!$ctrl.workflowTemplate.IsRunAvailable || ($ctrl.workflowTemplate.IsRunAvailable && $ctrl.loggedInUser.Permissions.Payroll.canRunPayroll)">\n\n\t\t\t<!-- Reassign step -->\n\t\t\t<a href="" ng-click="$ctrl.openReassignStepForm($ctrl)" class="button white" ng-if="!$ctrl.workflowTemplate.IsRunAvailable && $root.userHasRole([$ctrl.USER_ROLES.companyadministrator, $ctrl.USER_ROLES.groupadminlite, $ctrl.USER_ROLES.companyadministratorlite, $ctrl.USER_ROLES.groupuser, $ctrl.USER_ROLES.bureaumanager, $ctrl.USER_ROLES.bureau])"><span class="strong"><i class="icon-team-alt m"></i>&nbsp;Re-assign</span></a>\n\n\t\t\t<!-- Complete Step -->\n\t\t\t<a href="" ng-click="$ctrl.openCompleteStepForm($ctrl)" class="button {{$ctrl.workflowTemplate.TemplateEntryCurrent.IsOverdue ? \'assertive\' : \'secondary\'}}" ng-class="{\'disabled\': $ctrl.workflowTemplate.IsCalculateAvailable && !$ctrl.workflowTemplate.IsPayrollLocked}" ng-if="!$ctrl.workflowTemplate.IsRunAvailable">{{$ctrl.workflowTemplate.TemplateEntryCurrent.primaryActionText}}&nbsp;&nbsp;<i class="icon-arrow-right m"></i></a>\n\n\t\t\t<!-- Run Payroll -->\n\t\t\t<a href="" ng-click="$ctrl.openRunPayrollForm($ctrl)" class="button {{$ctrl.workflowTemplate.TemplateEntryCurrent.IsOverdue ? \'assertive\' : \'secondary\'}}" ng-if="$ctrl.workflowTemplate.IsRunAvailable && $ctrl.loggedInUser.Permissions.Payroll.canRunPayroll">Run payroll&nbsp;&nbsp;<i class="icon-arrow-right m"></i></a>\n\n\t\t</div>\n\t</div>\n\n\t<!-- Non bureau display -->\n\t<div class="pay-period-workflow_summary" ng-if="!$ctrl.workflowTemplate.TemplateEntryCurrent.BureauDisplay">\n\n\t\t<!-- Query reports -->\n\t\t<div class="pay-period-workflow_summary-secondary-actions" ng-if="$ctrl.workflowTemplate.showWorkflowActions && $ctrl.workflowTemplate.TemplateEntryCurrent.Number === 3">\n\t\t\t<a href="" ng-click="$ctrl.openCompleteStepForm($ctrl, \'query-reports\')" class="button"><i class="icon-arrow-right flip m"></i>&nbsp;&nbsp;Query reports</a>\n\t\t</div>\n\n\t\t<div class="pay-period-workflow_summary-container" ng-if="$ctrl.workflowTemplate.showWorkflowActions">\n\t\t\t<p class="s">If you\'ve forgotten to add something, leave a note below</p>\n\t\t</div>\n\n\t\t<!-- Complete Step -->\n\t\t<div class="pay-period-workflow_summary-primary-actions" ng-if="$ctrl.workflowTemplate.showWorkflowActions && $ctrl.workflowTemplate.TemplateEntryCurrent.IsActioner">\n\t\t\t<a href="" ng-click="$ctrl.openCompleteStepForm($ctrl)" class="button {{$ctrl.workflowTemplate.TemplateEntryCurrent.IsOverdue ? \'assertive\' : \'secondary\'}}">{{$ctrl.workflowTemplate.TemplateEntryCurrent.primaryActionText}}&nbsp;&nbsp;<i class="icon-arrow-right m"></i></a>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/pay-policy-form-field/pay-policy-form-field.component.html','<div class="pay-policy-form-field form-field-highlight primary">\n\n\t<div class="pay-policy-form-field_delete" ng-if="$ctrl.allowDelete">\n\t\t<div class="fadeIn" ng-if="!$ctrl.confirmDelete">\n\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)" class="greyscale" aria-label="Delete policy"><i class="icon-trash"></i>&nbsp;&nbsp;Delete</a>\n\t\t</div>\n\t\t<div class="fadeIn" ng-if="$ctrl.confirmDelete">\n\t\t\t<p class="s strong">\n\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t<a href="" ng-click="$ctrl.onDeletePolicy($ctrl)">Yes</a>\n\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)">No</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Edit mode -->\n\t<div ng-if="$ctrl.mode === $ctrl.PAY_POLICY_FORM_FIELD_MODES.edit" class="pay-policy-form-field-main fadeIn">\n\t\t<div class="form-field-header" ng-if="$ctrl.salaryPolicy.IsSalaryPolicyUpdate">\n\t\t\t<h5>Pay Change</h5>\n\t\t</div>\n\n\t\t<!-- Policy selection, only applicable for non-pay change editing (IsSalaryPolicyUpdate == false) -->\n\t\t<div class="form-field" ng-if="!$ctrl.salaryPolicy.IsSalaryPolicyUpdate">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.payPolicyFormFieldId}}" class="required">Policy:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="{{::$ctrl.payPolicyFormFieldId}}" name="{{::$ctrl.payPolicyFormFieldId}}" ng-change="$ctrl.onPayPolicyFormFieldPolicyChange($ctrl, $ctrl.salaryPolicy)" ng-model="$ctrl.salaryPolicy.payPolicy" ng-options="policy as policy.PolicyName for policy in $ctrl.payPolicies | orderBy: \'PolicyName\'">\n\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.payPolicyFormFieldId].$error" ng-show="$ctrl.form[$ctrl.payPolicyFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a pay policy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.policyBandFormFieldId}}" class="required">Pay point:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="{{::$ctrl.policyBandFormFieldId}}" name="{{::$ctrl.policyBandFormFieldId}}" ng-change="$ctrl.onPayPolicyFormFieldPolicyBandChange($ctrl)" ng-model="$ctrl.salaryPolicy.Band" ng-options="policyBand as policyBand.description for policyBand in $ctrl.salaryPolicy.payPolicy.PolicyBands | orderBy: \'description\'" required>\n\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.policyBandFormFieldId].$error" ng-show="$ctrl.form[$ctrl.policyBandFormFieldId].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a pay point</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Contracted hours per week and weeks per year applicable only to annual salary policy. Only available when these are zero in policy definition -->\n\t\t<fieldset ng-if="$ctrl.isAnnualSalaryPolicy && $ctrl.salaryPolicy.allowContractedWorkingTimeEdit">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-label="Set contracted working time" field-model="$ctrl.salaryPolicy.showContractedWorkingTime" field-name="{{::$ctrl.showContractedWorkingTimeFieldId}}" field-on-change="$ctrl.onShowContractedWorkingTimeChange($ctrl, $ctrl.salaryPolicy)"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field-group fadeIn" ng-if="$ctrl.salaryPolicy.showContractedWorkingTime">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="{{::$ctrl.hoursPerWeekFieldId}}">Contracted hours per week:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<number-selector-field field-name="{{::$ctrl.hoursPerWeekFieldId}}" ng-model="$ctrl.salaryPolicy.HoursPerWeek" nsf-on-change="$ctrl.onPayPolicyFormFieldContractedWorkTimeChange($ctrl)" max="$ctrl.hourOptions.maxHours" min="$ctrl.hourOptions.minHours" step="$ctrl.hourOptions.stepCount"></number-selector-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.hoursPerWeekFieldId].$touched" ng-messages="$ctrl.form[$ctrl.hoursPerWeekFieldId].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{$ctrl.hourOptions.maxHours}} hours</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{$ctrl.hourOptions.minHours}} hours</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="{{::$ctrl.weeksPerYearFieldId}}">Contracted weeks per year:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<number-selector-field field-name="{{::$ctrl.weeksPerYearFieldId}}" ng-model="$ctrl.salaryPolicy.WeeksPerYear" nsf-on-change="$ctrl.onPayPolicyFormFieldContractedWorkTimeChange($ctrl)" max="$ctrl.weekOptions.maxWeeks" min="$ctrl.weekOptions.minWeeks" step="$ctrl.weekOptions.stepCount"></number-selector-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.weeksPerYearFieldId].$touched" ng-messages="$ctrl.form[$ctrl.weeksPerYearFieldId].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{$ctrl.weekOptions.maxWeels}} weeks</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{$ctrl.weekOptions.minWeeks}} weeks</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Effective date (edit pay change only) -->\n\t\t<fieldset ng-if="$ctrl.mode === $ctrl.PAY_POLICY_FORM_FIELD_MODES.editPayChange">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="{{::$ctrl.effectiveDateFieldId}}" class="required">Effective date:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="{{::$ctrl.effectiveDateFieldId}}" field-min-date-iso="$ctrl.salaryPolicy.minEffectiveDateIso" field-required="true" field-value-iso="$ctrl.salaryPolicy.effectiveDateIso">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.effectiveDateFormFieldId].$error" ng-if="$ctrl.form[$ctrl.effectiveDateFormFieldId].$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the first payment date</p>\n\t\t\t\t\t<p ng-message="min">Please enter a date on or after the current pay date ({{$ctrl.salaryPolicy.minEffectiveDateIso | dateformat}})</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Insert new starter stuff if present -->\n\t\t<fieldset ng-if="$ctrl.hasNewStarterInfo">\n\t\t\t<div ng-transclude="newStarterInfo"></div>\n\t\t</fieldset>\n\n\t\t<!-- Calculate at FTE option (edit mode, annual allowance pay policy only) -->\n\t\t<fieldset ng-if="!$ctrl.isAnnualSalaryPolicy && $ctrl.mode === $ctrl.PAY_POLICY_FORM_FIELD_MODES.edit">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t<input id="{{::$ctrl.fteApplyFieldId}}" name="checkboxField" ng-change="$ctrl.onFTEApplyChange($ctrl)" ng-model="$ctrl.salaryPolicy.FTEApply" type="checkbox">\n\t\t\t\t\t<label class="checkbox-field-label" for="{{::$ctrl.fteApplyFieldId}}">{{$ctrl.fteLabel}}</label>\n\t\t\t\t\t<label class="checkbox-field-tickbox" for="{{::$ctrl.fteApplyFieldId}}"></label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Footer calculations - annual salary pay policy -->\n\t\t<div class="pay-policy-form-field_footer" ng-if="$ctrl.isAnnualSalaryPolicy">\n\t\t\t<div class="pay-policy-form-field_list">\n\t\t\t\t<div class="pay-policy-form-field_listitem">\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-name">Full time equivalent %:</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="!$ctrl.salaryPolicy.fteEquivalents.isUpdating">{{$ctrl.salaryPolicy.fteEquivalents.ftePercent.toFixed(4)}}</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.isUpdating"><i class="icon-loading s spin"></i></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="pay-policy-form-field_listitem">\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-name">Annual salary:</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="!$ctrl.salaryPolicy.fteEquivalents.isUpdating">{{$ctrl.salaryPolicy.fteEquivalents.annualSalary | monetise}}</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.isUpdating"><i class="icon-loading s spin"></i></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="pay-policy-form-field_listitem">\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-name">Hourly rate:</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="!$ctrl.salaryPolicy.fteEquivalents.isUpdating">{{$ctrl.salaryPolicy.fteEquivalents.hourlyRate | monetise}}</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.isUpdating"><i class="icon-loading s spin"></i></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Footer calculations - annual allowance pay policy -->\n\t\t<div class="pay-policy-form-field_footer" ng-if="!$ctrl.isAnnualSalaryPolicy">\n\t\t\t<div class="pay-policy-form-field_list">\n\t\t\t\t<div class="pay-policy-form-field_listitem">\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-name">Annual allowance:</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="!$ctrl.salaryPolicy.fteEquivalents.isUpdating">{{$ctrl.salaryPolicy.fteEquivalents.annualAllowance | monetise}}</div>\n\t\t\t\t\t<div class="pay-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.isUpdating"><i class="icon-loading s spin"></i></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Insert backdated salary info if present -->\n\t\t<fieldset ng-if="$ctrl.hasBackdatedSalaryOptions">\n\t\t\t<div ng-transclude="backdatedSalaryOptions"></div>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- View mode -->\n\t<div ng-if="$ctrl.mode === $ctrl.PAY_POLICY_FORM_FIELD_MODES.view" class="pay-policy-form-field-main fadeIn">\n\t\t<div class="pay-policy-form-field_view-title">\n\t\t\t{{$ctrl.isAnnualSalaryPolicy ? \'Current salary:\' : \'Current allowance:\'}}\n\t\t</div>\n\t\t<div class="pay-policy-form-field_view-subtitle">\n\t\t\t{{($ctrl.isAnnualSalaryPolicy ? $ctrl.salaryPolicy.Band.PolicyBandAnnualSalary : $ctrl.salaryPolicy.Band.PolicyBandAnnualAllowance) | monetise}}\n\t\t\t<span class="pay-policy-form-field_view-subtitle-info" ng-if="$ctrl.salaryPolicy.EffectiveDateISO">\n\t\t\t\t&nbsp;(effective {{$ctrl.salaryPolicy.EffectiveDateISO | dateformat}})\n\t\t\t</span>\n\t\t</div>\n\t\t<div class="pay-policy-form-field_view-properties">\n\t\t\t<div class="pay-policy-form-field_view-property">\n\t\t\t\t<div class="pay-policy-form-field_view-property-name">Policy:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-property-value">{{$ctrl.salaryPolicy.PolicyName}}</div>\n\t\t\t</div>\n\t\t\t<div class="pay-policy-form-field_view-property">\n\t\t\t\t<div class="pay-policy-form-field_view-property-name">Pay point:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-property-value">\n\t\t\t\t\t{{$ctrl.salaryPolicy.Band.PolicyBandName}}&nbsp;\n\t\t\t\t\t({{($ctrl.isAnnualSalaryPolicy ? $ctrl.salaryPolicy.Band.PolicyBandAnnualSalary : $ctrl.salaryPolicy.Band.PolicyBandAnnualAllowance) | monetise}})\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<a class="pay-policy-form-field_view-show-more-toggle" href="" ng-click="$ctrl.toggleShowMore($ctrl)" ng-if="$ctrl.isAnnualSalaryPolicy">\n\t\t\t<i class="pay-policy-form-field_view-show-more-icon icon-chevron-down" ng-class="{ \'flip\': $ctrl.showMore }"></i>&nbsp;{{$ctrl.showMore ? \'Show less\' : \'Show more\'}}\n\t\t</a>\n\t\t<div class="pay-policy-form-field_view-attributes fadeIn" ng-if="$ctrl.showMore">\n\t\t\t<div class="pay-policy-form-field_view-attribute">\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-name">Hourly rate:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.Band.PolicyBandHourlyRate | monetise}}</div>\n\t\t\t</div>\n\t\t\t<div class="pay-policy-form-field_view-attribute">\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-name">Full time equivalent %:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.FTEPercent}}%</div>\n\t\t\t</div>\n\t\t\t<div class="pay-policy-form-field_view-attribute">\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-name">Contracted hours per week:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.HoursPerWeek}}</div>\n\t\t\t</div>\n\t\t\t<div class="pay-policy-form-field_view-attribute">\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-name">Contracted weeks per year:</div>\n\t\t\t\t<div class="pay-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.WeeksPerYear}}</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="pay-policy-form-field_view-note" ng-if="!$ctrl.isAnnualSalaryPolicy && $ctrl.salaryPolicy.FTEApply">\n\t\t\tCalculated at full time equivalent ({{$ctrl.salaryPolicy.FTEPercent}}%)\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/pay-policy-history-card/pay-policy-history-card.component.html','<div class="pay-policy-history-card" ng-class="{\n\t\t\'is-update\' : $ctrl.payPolicy.PolicyState === $ctrl.POLICY_STATES.update\n\t}">\n\t<div class="pay-policy-history-card_header">\n\t\t<div class="pay-policy-history-card_header-title" ng-if="$ctrl.payPolicy.PolicyVersionNumber === 1">\n\t\t\t<i class="icon-tick-square is-secondary l"></i>\n\t\t\t<span class="pay-policy-history-card_header-title-info">New policy</span>\n\t\t</div>\n\t\t<div class="pay-policy-history-card_header-title" ng-if="$ctrl.payPolicy.PolicyVersionNumber !== 1 && $ctrl.payPolicy.PolicyState !== $ctrl.POLICY_STATES.update">\n\t\t\t<i class="icon-calendar is-primary l"></i>\n\t\t\t<span class="pay-policy-history-card_header-title-info">Effective: {{$ctrl.payPolicy.PolicyEffectiveDateISO | dateformat}}</span>\n\t\t</div>\n\t\t<div class="pay-policy-history-card_header-title" ng-if="$ctrl.payPolicy.PolicyVersionNumber !== 1 && $ctrl.payPolicy.PolicyState === $ctrl.POLICY_STATES.update">\n\t\t\t<i class="icon-loading is-tertiary l"></i>\n\t\t\t<span class="pay-policy-history-card_header-title-info">Effective: {{$ctrl.payPolicy.PolicyEffectiveDateISO | dateformat}}&nbsp;&nbsp;&nbsp;&nbsp;</span>\n\t\t\t<span class="tag is-tertiary inverse">Pending</span>\n\t\t</div>\n\t\t<div class="pay-policy-history-card_header-action" ng-if="$ctrl.showActions">\n\t\t\t<a class="is-greyscale" href="" ng-click="$ctrl.onViewSettingsClick($ctrl)">\n\t\t\t\t<i class="icon-visible"></i>&nbsp;&nbsp;View settings\n\t\t\t</a>\n\t\t</div>\n\t</div>\n\t<div class="pay-policy-history-card_info">\n\t\t<p>Added by {{$ctrl.payPolicy.CreatedBy}} at {{$ctrl.payPolicy.CreatedDateISO | datetimeformat:\'detailed\'}}</p>\n\t</div>\n</div>\n');
$templateCache.put('components/pay-statement-field/pay-statement-field.component.html','<div class="pay-statement-item" ng-switch="$ctrl.fieldState">\n\t<span class="pay-statement-label" data-cy="pay-statement-label-{{$ctrl.paymentLabel | slugify}}">{{$ctrl.paymentLabel}}</span>\n\n\t<div pc-switch-when="$ctrl.PAYMENT_STATE.editing" class="pay-statement-edit-field fadeIn">\n\t\t<input class="pay-statement-edit-input monetise" error-field error-messages="$ctrl.errorMessages" error-position="left" id="{{:: $ctrl.paymentId }}-input" name="{{:: $ctrl.paymentId }}-input" ng-min="$ctrl.paymentMin" ng-model="$ctrl.paymentOverride" ng-pattern="$root.REGEX.numbersOnly" pc-keypress pc-keypress-key="enter" pc-keypress-action="$ctrl.savePayment($ctrl)" type="number">\n\t</div>\n\n\t<span class="pay-statement-edited-field fadeIn" pc-switch-when="$ctrl.PAYMENT_STATE.saved">\n\t\t<span data-cy="{{:: $ctrl.paymentId }}-override" tooltip tooltip-text="Changed from: {{$ctrl.paymentOriginal | monetise}}" tooltip-position="top-right">{{$ctrl.paymentOverride | monetise}}</span>\n\t</span>\n\n\t<span class="pay-statement-value" data-cy="{{:: $ctrl.paymentId }}-original" pc-switch-when="$ctrl.PAYMENT_STATE.unedited">\n\t\t<span ng-if="$ctrl.paymentLabel===\'Rolled Up Holiday Pay\'" tooltip tooltip-text="{{($ctrl.paymentOriginal === 0 && $ctrl.payment.HasStatutoryPay) ? \'Rolled Up Holiday Pay not calculated when receiving statutory pay, add manually with an override\' : \'\'}}" tooltip-position="top-right">{{$ctrl.paymentOriginal | monetise}}</span>\n\n\t\t<span ng-if="$ctrl.paymentLabel!==\'Rolled Up Holiday Pay\'">{{$ctrl.paymentOriginal | monetise}}</span>\n\t</span>\n\n\t<span ng-if="$ctrl.paymentCanEdit" class="pay-statement-edit">\n\t\t<a aria-label="Edit payment" class="fadeIn" data-cy="{{:: $ctrl.paymentId }}-edit-payment" href="" ng-class="{\n\t\t\t\t\'disabled\' : $ctrl.form.$invalid\n\t\t\t}" ng-click="$ctrl.editPayment($ctrl)" pc-switch-when="[\n\t\t\t\t$ctrl.PAYMENT_STATE.unedited,\n\t\t\t\t$ctrl.PAYMENT_STATE.saved\n\t\t\t]">\n\t\t\t<i class="icon-edit"></i>\n\t\t</a>\n\t\t<a aria-label="Save payment" class="fadeIn" data-cy="{{:: $ctrl.paymentId }}-save-payment" href="" ng-class="{\n\t\t\t\t\'disabled\' : $ctrl.form[$ctrl.paymentId+\'-input\'].$invalid\n\t\t\t}" ng-click="$ctrl.savePayment($ctrl)" pc-switch-when="$ctrl.PAYMENT_STATE.editing">\n\t\t\t<i class="icon-tick"></i>\n\t\t</a>\n\t\t<circle-loader class="pay-statement-edit-loader fadeIn" size="s" pc-switch-when="$ctrl.PAYMENT_STATE.loading"></circle-loader>\n\t</span>\n</div>\n');
$templateCache.put('components/paycircle-permission-tool/paycircle-permission-tool.component.html','<div class="paycircle-permission-tool">\n\n\t<!-- Recorder -->\n\t<div class="paycircle-permission-tool_section" ng-switch="$ctrl.recorderState">\n\n\t\t<div class="fadeIn button-group" pc-switch-when="$ctrl.RECORDER_STATES.waiting">\n\t\t\t<button class="is-small" ng-click="$ctrl.onRecordingStart()" type="button">\n\t\t\t\tRecord\n\t\t\t</button>\n\n\t\t\t<div class="fadeIn" ng-if="$ctrl.getStoredPermissionLength() > 0">\n\t\t\t\t<button class="is-small is-secondary" ng-click="$ctrl.onRecordingOutput()" type="button">\n\t\t\t\t\tOutput\n\t\t\t\t</button>\n\n\t\t\t\t<button class="is-small is-assertive" ng-click="$ctrl.onRecordingReset()" type="button">\n\t\t\t\t\tClear\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.RECORDER_STATES.recording">\n\t\t\t<button class="is-small is-assertive" ng-click="$ctrl.onRecordingEnd()" type="button">\n\t\t\t\tEnd\n\t\t\t</button>\n\n\t\t\t<div>\n\t\t\t\tPermissions checked: {{$ctrl.getStoredPermissionLength()}}\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n');
$templateCache.put('components/payment-card/paymentCardComponent.html','<div class="payment-card greyscale fadeIn" title="Click to view this payslip online">\n\t<h6 class="payment-card-type">{{isCisPayment ? \'Online pay statement\' : \'Online payslip\' + payslipSuffix}}</h6>\n\t<i class="payment-card-icon icon-external-link l"></i>\n\t<p class="payment-card-info">{{payment.UserPaymentPayPeriodDateFromDisplay | simple}} - {{payment.UserPaymentPayPeriodDateToDisplay | simple}}</p>\n\t<p class="payment-card-created-on">Created on {{payment.UserPaymentPayPeriodCompletedDateDisplay | simple}}</p>\n\t<a ui-sref="payslip({\n\t\t\t\'agencyProfileId\': agencyProfileId,\n\t\t\t\'userId\': userId,\n\t\t\t\'payPeriodId\': payment.AgencyPayPeriodID,\n\t\t\t\'userPaymentId\': payment.UserPaymentID,\n\t\t\t\'supplementaryPaymentId\': payment.SupplementaryPaymentID,\n\t\t\t\'userDocumentTypeId\': payment.UserDocumentTypeID\n\t\t})" target="_blank" class="payment-card-link"></a>\n\n</div>\n');
$templateCache.put('components/payment-info-card/payment-info-card.component.html','<div class="payment-info-card {{\'is-layout-\' + $ctrl.cardLayout}} {{$ctrl.cardTheme}}">\n\t<main class="payment-info-card-main">\n\t\t<p class="payment-info-card-title"><i class="icon-{{$ctrl.cardIcon}} m payment-info-card-icon"></i>{{$ctrl.cardTitle || \'No title provided\'}}</p>\n\t\t<h2 id="{{$ctrl.cardId}}" class="payment-info-card-value">{{$ctrl.cardValue | monetise}}</h2>\n\t</main>\n\t<footer class="payment-info-card-footer" ng-transclude></footer>\n</div>\n');
$templateCache.put('components/payment-schedule/payment-schedule.component.html','<div ng-switch="$ctrl.statutoryPayCalculationMethod">\n\n\t<!-- Period Dates -->\n\t<table class="primary payment-schedule-table" pc-switch-when="$ctrl.STATUTORY_PAY_CALCULATION_METHODS.periodDates">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Pay Period</th>\n\t\t\t\t<th>&nbsp;</th>\n\t\t\t\t<th class="align-right" ng-if="$ctrl.showOccupationalPolicyPaymentValues">\n\t\t\t\t\t{{$ctrl.occupationalPaymentLabel}}\n\t\t\t\t</th>\n\t\t\t\t<th class="align-right">{{$ctrl.schedulePaymentLabel}}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr data-cy="payment-schedule-payment-{{$index}}" ng-class="{ \'is-historical\': payment.IsHistorical }" ng-repeat="payment in $ctrl.schedulePayments">\n\t\t\t\t<td>\n\t\t\t\t\t<strong data-cy="payment-schedule-payment-{{$index}}-display">{{payment.PayPeriodDisplay}}</strong>&nbsp;\n\t\t\t\t\t<em><ng-pluralize count="payment.PayDaysApplicable" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></em>\n\t\t\t\t</td>\n\t\t\t\t<td class="align-right">\n\t\t\t\t\t<span class="tag positive" ng-if="payment.HasBeenPaid">Paid</span>\n\t\t\t\t\t<span class="tag assertive" ng-if="payment.IsCancelled">Cancelled</span>\n\t\t\t\t</td>\n\t\t\t\t<td class="align-right" ng-if="$ctrl.showOccupationalPolicyPaymentValues">\n\t\t\t\t\t<editable-label field-name="{{$ctrl.schedulePaymentLabel | slugify}}" is-editable="$ctrl.canEditOccupationalPaymentValues" ng-model="payment.OccupationalPaymentAmount"></editable-label>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<strong data-cy="payment-schedule-payment-{{$index}}-amount">{{payment.PaymentAmount | monetise}}</strong>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n\t<!-- Weekly -->\n\t<table class="primary payment-schedule-table" pc-switch-when="$ctrl.STATUTORY_PAY_CALCULATION_METHODS.weekly">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Pay Period</th>\n\t\t\t\t<th>&nbsp;</th>\n\t\t\t\t<th class="align-right" ng-if="$ctrl.showOccupationalPolicyPaymentValues">\n\t\t\t\t\t{{$ctrl.occupationalPaymentLabel}}\n\t\t\t\t</th>\n\t\t\t\t<th>{{$ctrl.schedulePaymentLabel}}</th>\n\t\t\t</tr>\n\t\t</thead>\n\n\t\t<tbody>\n\t\t\t<!-- Summary row -->\n\t\t\t<tr class="payment-schedule-table_summary-row" data-cy="payment-schedule-payment-{{$index}}" ng-class="{ \'is-historical\': paymentGroup.IsHistorical }" ng-repeat-start="paymentGroup in $ctrl.schedulePayments">\n\t\t\t\t<td colspan="2">\n\t\t\t\t\t<strong data-cy="payment-schedule-payment-{{$index}}-period-display">{{paymentGroup.payPeriodDisplay}}</strong>&nbsp;\n\t\t\t\t\t<em ng-if="!paymentGroup.IsHistorical"><ng-pluralize count="paymentGroup.payPeriodsCount" when="{\'1\': \'1 week\', \'other\': \'{} weeks\'}"></ng-pluralize></em>\n\t\t\t\t</td>\n\t\t\t\t<td class="align-right" ng-if="$ctrl.showOccupationalPolicyPaymentValues">\n\t\t\t\t\t<strong>{{paymentGroup.totalOccupationalPaymentAmount | monetise}}</strong>\n\t\t\t\t</td>\n\t\t\t\t<td><strong data-cy="payment-schedule-payment-{{$index}}-total-amount">{{paymentGroup.totalPaymentAmount | monetise}}</strong></td>\n\t\t\t</tr>\n\n\t\t\t<!-- Payments -->\n\t\t\t<tr class="payment-schedule-table_breakdown-row" ng-class="{ \'is-historical\': payment.IsHistorical }" ng-repeat="payment in paymentGroup.payments" ng-repeat-end>\n\t\t\t\t<td>\n\t\t\t\t\t{{payment.StartDateISO | dateformat: \'numericShortYear\'}}&nbsp;&dash;&nbsp;{{payment.EndDateISO | dateformat: \'numericShortYear\' }}\n\t\t\t\t</td>\n\t\t\t\t<td class="align-right">\n\t\t\t\t\t<span class="tag positive" ng-if="payment.HasBeenPaid">Paid</span>\n\t\t\t\t\t<span class="tag assertive" ng-if="payment.IsCancelled">Cancelled</span>\n\t\t\t\t</td>\n\t\t\t\t<td class="align-right" ng-if="$ctrl.showOccupationalPolicyPaymentValues">\n\t\t\t\t\t<editable-label is-editable="$ctrl.canEditOccupationalPaymentValues" ng-model="payment.OccupationalPaymentAmount" on-edit="$ctrl.recalculatePaymentGroup(paymentGroup)"></editable-label>\n\t\t\t\t</td>\n\t\t\t\t<td data-cy="payment-schedule-payment-{{$index}}-amount">{{payment.PaymentAmount | monetise}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n</div>');
$templateCache.put('components/payroll-alert-card/payroll-alert-card-basic.component.html','<div class="payroll-alert-card is-basic fadeIn" ng-class="::$ctrl.theme">\n    <div class="payroll-alert-card_layout">\n        <div class="payroll-alert-card_icon"><icon-dot icon="{{::$ctrl.icon}}" theme="{{::$ctrl.theme}} has-box-shadow"></icon-dot></div>\n        <div class="payroll-alert-card_content">\n            <h6 class="payroll-alert-card_title" ng-if="$ctrl.hasTitle" ng-transclude="title"></h6>\n            <p class="payroll-alert-card_detail" ng-if="$ctrl.hasDetail" ng-transclude="detail"></p>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('components/payroll-alert-card/payroll-alert-card.component.html','<div class="payroll-alert-card fadeIn" ng-class="$ctrl.alertTheme">\n\t<div class="payroll-alert-card_layout">\n\t\t<div class="payroll-alert-card_icon"><icon-dot icon="{{$ctrl.icon}}" theme="{{$ctrl.alertTheme}}"></icon-dot></div>\n\n\t\t<div class="payroll-alert-card_avatar" ng-if="$ctrl.alert.Icon === $ctrl.ICON_STATES.avatar">\n\t\t\t<avatar avatar-initial="{{$ctrl.alert.Target[0]}}" avatar-size="is-medium" avatar-theme="{{$ctrl.alertTheme}}"></avatar>\n\t\t</div>\n\n\t\t<div class="payroll-alert-card_content">\n\t\t\t<h6 class="payroll-alert-card_title">{{$ctrl.alert.Target}}<span ng-if="$ctrl.alert.Heading" class="payroll-alert-card_heading">&nbsp;-&nbsp;{{$ctrl.alert.Heading}}</span></h6>\n\n\t\t\t<p class="payroll-alert-card_detail">\n\t\t\t\t{{$ctrl.alert.Detail}} <a href="" class="payroll-alert-card_link underline" ng-href="{{$ctrl.alert.HelpURI}}" target="_blank" ng-if="$ctrl.alert.HelpURI">{{$ctrl.alert.HelpURIText}}</a>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="payroll-alert-card_action" ng-if="$ctrl.alert.Action" ng-switch="$ctrl.alert.Action">\n\t\t\t<div pc-switch-when="$ctrl.ALERT_ACTIONS.pending"><i class="icon-loading spin"></i>&nbsp;Pending</div>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToProfile" class="payroll-alert-card_link" ui-sref="team.profile.overview({agencyProfileId: $ctrl.agencyProfileId, userId: $ctrl.alert.TargetID})">Go to profile <i class="icon-chevron-right"></i></a>\n\t\t\t<a href="" pc-switch-when="[$ctrl.ALERT_ACTIONS.dismiss, $ctrl.ALERT_ACTIONS.dismissBulk]" class="payroll-alert-card_link" ng-click="$ctrl.openDeletePayrollAlertForm($ctrl)">Dismiss</a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToPensions" class="payroll-alert-card_link" ui-sref="pensions.summary({agencyProfileId: $ctrl.agencyProfileId})">Go to pensions <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToTeam" class="payroll-alert-card_link" ui-sref="team.members({agencyProfileId: $ctrl.agencyProfileId, presetfilterkey: $ctrl.alert.alertPresetKey})">View team members <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToBilling" class="payroll-alert-card_link" ui-sref="settings.company.billing({agencyProfileId: $ctrl.agencyProfileId})">Go to billing <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToCompany" class="payroll-alert-card_link" ui-sref="settings.company.overview({agencyProfileId: $ctrl.agencyProfileId})">View company settings <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToPension" class="payroll-alert-card_link" ui-sref="pensions.scheme.status({agencyProfileId: $ctrl.agencyProfileId, agencyEmployerPensionId: $ctrl.alert.TargetID})">Go to pension <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.viewChanges" class="payroll-alert-card_link" ng-click="$ctrl.viewChanges()">View changes<i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToPensionSettings" class="payroll-alert-card_link" ui-sref="pensions.scheme.settings({agencyProfileId: $ctrl.agencyProfileId, agencyEmployerPensionId: $ctrl.alert.TargetID})">Go to pension settings <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToHistory" class="payroll-alert-card_link" ui-sref="payroll.history.pay-periods({agencyProfileId: $ctrl.agencyProfileId})">Go to history <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToPendingChanges" class="payroll-alert-card_link" ng-click="$ctrl.openPendingChangesForm($ctrl)">Review updates</a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToNIUpdates" class="payroll-alert-card_link" ng-click="$ctrl.openNICategoryUpdatesForm($ctrl)">Review updates <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.submitPension" class="button is-assertive" ng-class="{\'is-disabled\': $ctrl.pensionAeState === \'loading\'}" ng-click="$ctrl.payrollResubmitAE($ctrl)" ng-switch="$ctrl.pensionAeState">\n\t\t\t\t<span ng-switch-when="loading"><i class="icon-loading spin"></i></span>\n\t\t\t\t<span ng-switch-default>Submit now</span>\n\t\t\t</a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToSupplementaryPayRuns" class="payroll-alert-card_link" ui-sref="payroll.history.supplementary-pay-runs({agencyProfileId: $ctrl.agencyProfileId})">Go to supplementary pay runs <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToPeopleHrUpdates" class="payroll-alert-card_link" ui-sref="team.people-hr-updates({agencyProfileId: $ctrl.agencyProfileId})">Go to PeopleHR updates <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.viewReversedHMRCTaxUpdates" class="payroll-alert-card_link" ng-click="$ctrl.viewReversedHmrcTaxUpdates($ctrl)">Review updates <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToRotareadyUpdates" class="payroll-alert-card_link" ui-sref="team.rotaready-updates({agencyProfileId: $ctrl.agencyProfileId})">Go to Rotaready updates <i class="icon-chevron-right"></i></a>\n\t\t\t<a pc-switch-when="$ctrl.ALERT_ACTIONS.goToEdpUpdates" class="payroll-alert-card_link" ui-sref="team.people-hr-updates({agencyProfileId: $ctrl.agencyProfileId})">Go to EDP updates <i class="icon-chevron-right"></i></a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/payroll-alerts-level/payroll-alerts-level.component.html','<div class="payroll-alerts-level fadeIn" ng-class="$ctrl.level.theme" ng-if="$ctrl.level.alerts.length">\n\t<div class="payroll-alerts-level_header">\n\t\t<span class="payroll-alerts-level_bullet"></span>\n\n\t\t<div class="payroll-alerts-level_category">\n\t\t\t<h6 class="payroll-alerts-level_title"><ng-pluralize count="$ctrl.level.alerts.length" when="{\'1\': \'1 \' + $ctrl.level.title, \'other\': \'{} \' + $ctrl.level.title + \'s\'}"></ng-pluralize></h6>\n\t\t</div>\n\t</div>\n\n\t<div class="payroll-alert-card_wrapper">\n\t\t<payroll-alert-card agency-pay-period-id="$ctrl.agencyPayPeriodId" agency-profile-id="$ctrl.agencyProfileId" alert="alert" dir-paginate="alert in $ctrl.level.filteredAlerts = ( $ctrl.level.alerts | filter : $ctrl.searchBarOptions.search.string ) | itemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage" icon="{{$ctrl.level.icon}}" pagination-id="$ctrl.level.title" reload-alerts="$ctrl.reloadAlerts" theme="{{$ctrl.level.theme}}" set-tab="$ctrl.setTab"></payroll-alert-card>\n\t</div>\n\n\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-if="$ctrl.level.filteredAlerts.length > $ctrl.searchBarOptions.results.itemsPerPage" pagination-id="$ctrl.level.title"></dir-pagination-controls>\n</div>\n');
$templateCache.put('components/payroll-assistant-full-screen/payroll-assistant-full-screen.component.html','<div class="payroll-assistant-full-screen">\n\t<loading-block ng-if="$ctrl.isLoading"></loading-block>\n\t<div class="payroll-assistant-full-screen_error" ng-if="$ctrl.hasError">\n\t\t<p>Unable to load Payroll Assistant. Please try again later.</p>\n\t</div>\n\t<div class="payroll-assistant-full-screen_container" ng-show="!$ctrl.isLoading && !$ctrl.hasError"></div>\n</div>\n');
$templateCache.put('components/payroll-payment-summary/payroll-payment-summary.component.html','<div class="payment-info-cards {{!$ctrl.showPensionInfo ? \'two\' : \'\'}}">\n\t<payment-info-card card-icon="wallet" card-id="payment-info-total-salaries" card-layout="card" card-theme="primary" card-title="{{$ctrl.isCisOnly ? \'Payments\' : \'Salaries\'}}" card-value="$ctrl.payPeriod.TotalSalaries">\n\t\t<p>Pay day {{$ctrl.payPeriod.PayDateISO | dateformat}}</p>\n\t</payment-info-card>\n\t<payment-info-card card-icon="tax-code-change" card-id="payment-info-total-hmrc" card-layout="card" card-theme="secondary" card-title="HMRC" card-value="$ctrl.payPeriod.TotalHMRC">\n\t\t<p ng-if="$ctrl.payPeriod.HMRCPaymentDateISO">\n\t\t\t<span ng-if="$ctrl.payPeriod.TotalHMRC > 0">Due on {{$ctrl.payPeriod.HMRCPaymentDateISO | dateformat}}</span>\n\t\t\t<span ng-if="$ctrl.payPeriod.TotalHMRC <= 0">Credit, no payment due</span>\n\t\t</p>\n\t\t<p ng-if="!$ctrl.payPeriod.HMRCPaymentDateISO">Paid by Bank Transfer</p>\n\t</payment-info-card>\n\t<payment-info-card card-icon="money" card-id="payment-info-total-pension" card-layout="card" card-theme="quarternary" card-title="Workplace pension" card-value="$ctrl.payPeriod.TotalPension" ng-if="$ctrl.showPensionInfo">\n\t\t<p>Paid by Direct Debit</p>\n\t</payment-info-card>\n</div>\n');
$templateCache.put('components/payroll-state/payrollStateComponent.html','<span class="payroll-state" ng-switch="payPeriod.PayrollState">\n\n\t<span class="tag assertive inverse" ng-if="ceasePayeSchemeComplete" title="Closed on {{ceasedDate | dateformat}}">Closed</span>\n\t<span class="tag assertive inverse" ng-if="!ceasePayeSchemeComplete && ceasedDate !== \'\'" title="Closing on {{ceasedDate | dateformat}}">Closing</span>\n\n\t<span ng-if="ceasedDate === \'\'">\n\n\t\t<!-- Payroll Submitting / Submitted / Failed -->\n\t\t<span pc-switch-when="SUBMISSION_STATES.submitting" class="tag tertiary"><i class="icon-loading spin"></i> Pending</span>\n\t\t<span pc-switch-when="SUBMISSION_STATES.submitted" class="tag secondary">Complete</span>\n\t\t<span pc-switch-when="SUBMISSION_STATES.failed" class="tag assertive inverse">Failed</span>\n\t</span>\n</span>\n');
$templateCache.put('components/payslip/payslip.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar here -->\n\t<div class="payslip_action-bar dropIn">\n\t\t<div class="payslip_action-bar-left">\n\t\t\t<div class="payslip_action-bar-section">\n\t\t\t\t<!-- online / printable toggle -->\n\t\t\t\t<h3 class="payslip_action-bar-strapline" ng-class="{\n\t\t\t\t\t\t\'tertiary\': !vm.viewPrintablePayslip,\n\t\t\t\t\t\t\'is-greyscale\': vm.viewPrintablePayslip\n\t\t\t\t\t}">\n\t\t\t\t\t<span tooltip-plus tp-options="PAYSLIP_TOOLTIPS.onlineView" tp-on-click="showPrintableTooltip(vm)"></span>\n\t\t\t\t\tOnline payslip&nbsp;&nbsp;\n\t\t\t\t</h3>\n\t\t\t\t<toggle-input ng-if="!vm.isCISPayStatement" field-label-stay-active="true" field-name="viewPrintablePayslip" field-model="vm.viewPrintablePayslip" field-theme-inactive="is-tertiary" field-theme-active="is-primary"></toggle-input>\n\t\t\t\t<h3 ng-if="!vm.isCISPayStatement" class="strapline payslip_action-bar-strapline" ng-class="{\n\t\t\t\t\t\t\'primary\': vm.viewPrintablePayslip,\n\t\t\t\t\t\t\'is-greyscale\': !vm.viewPrintablePayslip\n\t\t\t\t\t}">\n\t\t\t\t\t<span tooltip-plus tp-on-click="showDownloadTooltip(vm)" tp-options="PAYSLIP_TOOLTIPS.printableView" ng-if="vm.showPrintableTooltip"></span>\n\t\t\t\t\t&nbsp;&nbsp;Printable payslip&nbsp;&nbsp;\n\t\t\t\t</h3>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="payslip_action-bar-right">\n\t\t\t<div class="payslip_action-bar-section">\n\t\t\t\t<button class="small" ng-click="downloadFile(vm.payslip.PayslipPDFURL)" ng-if="vm.payslip.CanDownload && vm.payslip.PayslipPDFURL && vm.allowPDFDownload" type="button">\n\t\t\t\t\tDownload\n\t\t\t\t</button>\n\t\t\t\t<button ng-if="!vm.isCISPayStatement" class="small is-primary" ng-click="openBrowserPrintDialog(vm)" type="button">\n\t\t\t\t\tSave or Print\n\t\t\t\t\t<span tooltip-plus tp-options="PAYSLIP_TOOLTIPS.download" ng-if="vm.showDownloadTooltip"></span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<div class="payslip_action-bar-section is-close-link">\n\t\t\t\t<a class="button-clear is-greyscale" href="" ng-click="goBack()">\n\t\t\t\t\t<i class="icon-cross is-before"></i><span class="hidden-phone">&nbsp;&nbsp;Close</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Online payslip view -->\n\t<div class="payslip" ng-show="!vm.viewPrintablePayslip">\n\t\t<div class="payslip__layout">\n\n\t\t\t<!-- Company / Contact -->\n\t\t\t<div class="payslip-header">\n\t\t\t\t<div class="payslip-header__brand" ng-if="::payslip.showLogoForPrintablePayslip !== \'\'">\n\t\t\t\t\t<img alt="{{vm.payslip.CompanyName}}" ng-if="vm.payslip.showLogoForPrintablePayslip" ng-src="{{vm.customisation.Payslips.LogoURL}}">\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-header__content" ng-if="::vm.payslip.NoteForPayslip.TextMerged">\n\t\t\t\t\t{{vm.payslip.NoteForPayslip.TextMerged | emojify }}\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-header__content" ng-if="::vm.customisation.Payslips.CustomMessage !== \'\' && !vm.payslip.NoteForPayslip.TextMerged">\n\t\t\t\t\t<p>{{::vm.customisation.Payslips.CustomMessage}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-header__contact">\n\t\t\t\t\t<!-- Tablet+ -->\n\t\t\t\t\t<div class="hidden-phone" ng-if="::vm.customisation.Payslips.IsContactVisible && vm.customisation.Contact.Forename !== \'\'">\n\t\t\t\t\t\t<h5>Contact</h5>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t{{::vm.customisation.Contact.Forename}}&nbsp;{{::vm.customisation.Contact.Surname || \'\'}}<br>\n\t\t\t\t\t\t\t<a class="contact-meta" href="mailto:{{::vm.customisation.Contact.EmailAddress}}" ng-if="::vm.customisation.Contact.EmailAddress !== \'\'">\n\t\t\t\t\t\t\t\t{{::vm.customisation.Contact.EmailAddress}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t<a class="contact-meta" href="tel:{{::vm.customisation.Contact.Phone}}" ng-if="::vm.customisation.Contact.Phone !== \'\'">\n\t\t\t\t\t\t\t\t{{::vm.customisation.Contact.Phone}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Phone -->\n\t\t\t\t\t<div class="visible-phone" ng-if="::vm.customisation.Payslips.IsContactVisible && vm.customisation.Contact.Forename !== \'\'">\n\t\t\t\t\t\t<div class="action-toggle">\n\t\t\t\t\t\t\t<a href="" ng-click="toggleDropdown(vm.customisation.Contact, \'contact\')">\n\t\t\t\t\t\t\t\tView contact details\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="hiddenstats hiddenstats--basic hiddenstats--active" ng-if="activeDropdown === \'contact\'">\n\t\t\t\t\t\t\t<div class="hiddenstats__actionbar">\n\t\t\t\t\t\t\t\t<a class="hiddenstats__action" href="" ng-click="closeDropdown(vm.customisation.Contact)">\n\t\t\t\t\t\t\t\t\t<i class="icon-back l"></i>Back\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="hiddenstats__header">\n\t\t\t\t\t\t\t\t<h6 class="hiddenstats__headertitle">Contact</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="hiddenstats__main">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t{{::vm.customisation.Contact.Forename}}&nbsp;{{::vm.customisation.Contact.Surname || \'\'}}<br>\n\t\t\t\t\t\t\t\t\t<a class="contact-meta" href="mailto:{{::vm.customisation.Contact.EmailAddress}}">\n\t\t\t\t\t\t\t\t\t\t{{::vm.customisation.Contact.EmailAddress}}\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t\t<a class="contact-meta" href="tel:{{::vm.customisation.Contact.Phone}}">\n\t\t\t\t\t\t\t\t\t\t{{::vm.customisation.Contact.Phone}}\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Hours Worked / Net Pay -->\n\t\t\t<div class="payslip-stats hidden-print">\n\t\t\t\t<div class="payslip-stats__item" ng-if="::!vm.isCISPayStatement || (vm.isCISPayStatement && !vm.isPayslipPeriodVisible)">\n\t\t\t\t\t<div ng-if="::vm.payslip.IsHolidayPayAccruedVisible">\n\t\t\t\t\t\t<h5 class="payslip-stats__title">Accrued holiday pay</h5>\n\t\t\t\t\t\t<p class="payslip-stats__value">\n\t\t\t\t\t\t\t{{vm.payslip.HolidayPayAccrued | monetise}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-stats__item" ng-if="::vm.isCISPayStatement && vm.isPayslipPeriodVisible">\n\t\t\t\t\t<h5 class="payslip-stats__title">For this period</h5>\n\t\t\t\t\t<p class="payslip-stats__value">\n\t\t\t\t\t\t{{vm.payslip.PayPeriod.StartDateISO | dateformat:\'dayMonth\'}} - {{vm.payslip.PayPeriod.EndDateISO | dateformat:\'dayMonth\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-stats__item">\n\t\t\t\t\t<h5 class="payslip-stats__title">{{::vm.payslip.PayPeriod.IsPartnership ? \'Net Drawings\' : vm.isCISPayStatement ? \'Amount payable\' : \'Net Pay\'}}</h5>\n\t\t\t\t\t<p class="payslip-stats__value" data-cy="payslip-stats-title-value">\n\t\t\t\t\t\t{{vm.payslip.NetPay | monetise}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Overview -->\n\t\t\t<div class="payslip-tiles" ng-class="{\'payslip-tiles--three\': vm.payslip.EmployeePension === 0}">\n\t\t\t\t<!-- Pay -->\n\t\t\t\t<div class="payslip-tiles__item">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--primary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-wallet"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">\n\t\t\t\t\t\t\t\t{{::vm.payslip.PayPeriod.IsPartnership ? \'Profit share\' : \'Salary\'}}\n\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value" data-cy="payslip-grosspay-value">\n\t\t\t\t\t\t\t\t{{vm.payslip.GrossPay | monetise}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Adjustments -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::!vm.isCISPayStatement">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--secondary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-adjustment"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">Adjustments</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value" data-cy="payslip-adjusment-value">\n\t\t\t\t\t\t\t\t{{vm.payslip.Adjustments ? vm.payslip.Adjustments.length : 0}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::vm.payslip.EmployeePension > 0 || !vm.isCISPayStatement && !vm.payslip.Personal.IsOffPayrollWorker">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--tertiary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-clock"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">Pension</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value" data-cy="payslip-pension-value">\n\t\t\t\t\t\t\t\t{{vm.payslip.EmployeePension | monetise}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Tax -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::!vm.isCISPayStatement">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--quarternary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-tax-code-change quarternary"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">{{::vm.payslip.PayPeriod.IsPartnership ? \'Tax reserve\' : \'Tax\'}}</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value" data-cy="payslip-tax-value">\n\t\t\t\t\t\t\t\t{{ vm.payslip.TaxPaid | monetise}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- CIS Cost of materials -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::vm.isCISPayStatement && vm.payslip.CIS.costOfMaterials >= 0">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--secondary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-materials"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">Cost of materials</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value">{{vm.payslip.CIS.costOfMaterials | monetise}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- CIS Liable to deduction -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::vm.isCISPayStatement && vm.payslip.CISLiableAmount >= 0">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--tertiary">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-wallet"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">Liable to deduction</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value">{{vm.payslip.CISLiableAmount | monetise}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- CIS Deduction -->\n\t\t\t\t<div class="payslip-tiles__item" ng-if="::vm.isCISPayStatement && vm.payslip.CIS.deduction">\n\t\t\t\t\t<div class="payslip-tiles__tile payslip-tiles__tile--assertive">\n\t\t\t\t\t\t<div class="payslip-tiles__content">\n\t\t\t\t\t\t\t<div class="payslip-tiles__icon">\n\t\t\t\t\t\t\t\t<i class="icon-minus"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<h5 class="payslip-tiles__title">Deduction ({{vm.payslip.CIS.DeductionRate}}%)</h5>\n\t\t\t\t\t\t\t<p class="payslip-tiles__value">{{vm.payslip.CIS.deduction | monetise}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Payslip -->\n\t\t\t<div class="accordion">\n\n\t\t\t\t<!-- Payments -->\n\t\t\t\t<div class="accordion_layout" ng-switch="$root.currentCompany.CompanyType">\n\t\t\t\t\t<h5 class="accordion_title">Payments</h5>\n\n\t\t\t\t\t<!-- Agencies - Bookings/Jobs & Worksheets -->\n\t\t\t\t\t<section pc-switch-when="INTERFACE_TYPES.agency">\n\t\t\t\t\t\t<accordion-item ai-description="{{job.JobRoleName}}" ai-detail="{{job.jobDetail}}" ai-has-hidden-content="true" ai-icon="wallet" ai-id="payments-{{$index}}" ai-label="{{job.JobLabel}}" ai-theme="primary" ai-value="{{job.JobWorksheetsTotalGross | monetise : config.precision.salaryRates}}" ng-repeat="job in vm.payslip.Jobs">\n\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t<table class="hiddenstats__summary is-table" ng-if="job.JobFine > 0 || job.JobBonus > 0 || job.JobExpensesTotal > 0">\n\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th class="equal-width">Bookings</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="equal-width">Status</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="equal-width">Deductions</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="equal-width">Bonuses</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="equal-width">Expenses</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="equal-width" data-title="Bookings">{{job.JobTotalDays}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td class="equal-width" data-title="Approved">{{JOB_STATUS_LABELS[job.JobStatus]}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td class="equal-width" data-title="Deductions">{{job.JobFine | monetise : config.precision.salaryRates}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td class="equal-width" data-title="Bonuses">{{job.JobBonus | monetise : config.precision.salaryRates}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td class="equal-width" data-title="Expenses">{{job.JobExpensesTotal | monetise : config.precision.salaryRates}}</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t<table class="hiddenstats__details">\n\t\t\t\t\t\t\t\t\t<tr ng-repeat="worksheet in job.JobWorksheets">\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__date">\n\t\t\t\t\t\t\t\t\t\t\t{{worksheet.WorksheetDateISO | dateformat:\'long\'}}<span ng-if="worksheet.WorksheetHours > 0">{{worksheet.WorksheetHours}}hrs</span>\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Daily Rate -->\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage" ng-if="worksheet.WorksheetDailyRate > 0">\n\t\t\t\t\t\t\t\t\t\t\t{{worksheet.WorksheetDailyRate | monetise : config.precision.salaryRates}}/day\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Hourly Rate -->\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage" ng-if="worksheet.WorksheetDailyRate === 0">\n\t\t\t\t\t\t\t\t\t\t\t{{worksheet.WorksheetHourlyRate | monetise : config.precision.salaryRates}}/hr\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t</accordion-item>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Everyone else - Salary -->\n\t\t\t\t\t<section ng-switch-default>\n\n\t\t\t\t\t\t<!-- CIS -->\n\t\t\t\t\t\t<section ng-if="vm.isCISPayStatement">\n\n\t\t\t\t\t\t\t<!-- Payments -->\n\t\t\t\t\t\t\t<accordion-item ai-description="{{adjustment.AdjustmentOnlineLabel}}" ai-detail="{{adjustment.adjustmentDetail}}" ai-has-hidden-content="adjustment.isToggleEnabled" ai-icon="{{adjustment.icon}}" ai-id="cis-{{$index}}" ai-theme="primary" ai-unit-value="{{adjustment.AdjustmentUnitValue | monetise : config.precision.salaryRates}}" ai-units="{{adjustment.AdjustmentUnits}}" ai-value="{{adjustment.AdjustmentValue | monetise : config.precision.salaryRates}}" ng-if="!adjustment.AdjustmentDeduction" ng-repeat="adjustment in vm.payslip.Adjustments | orderBy:[\'AdjustmentDeduction\', \'AdjustmentLabel\']">\n\t\t\t\t\t\t\t\t<ai-content ng-switch="adjustment.AdjustmentDetailID">\n\n\t\t\t\t\t\t\t\t\t<!-- Cost of materials -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="ADJUSTMENT_TYPES.costOfMaterials">\n\t\t\t\t\t\t\t\t\t\t<table class="hiddenstats__details">\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__date">Materials</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage">{{adjustment.AdjustmentValue | monetise : config.precision.salaryRates}}</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__date">VAT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage">{{adjustment.AdjustmentVAT | monetise : config.precision.salaryRates}}</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<accordion-item ai-description="{{::vm.payslip.salaryLabel}}" ai-detail="{{vm.payslip.salaryDetail}}" ai-icon="wallet" ai-id="salary-gross-pay" ai-theme="primary" ai-value="{{vm.payslip.SalaryGrossPay | monetise}}" ng-if="!vm.isCISPayStatement"></accordion-item>\n\n\t\t\t\t\t\t<accordion-item ai-attributes="adjustment.attributes" ai-description="{{::adjustment.AdjustmentOnlineLabel}}" ai-icon="wallet" ai-id="pay-point-{{$index}}" ai-theme="primary" ai-value="{{adjustment.AdjustmentValue | monetise}}" ng-if="!vm.isCISPayStatement" ng-repeat="adjustment in vm.payslip.PayPointAdjustments"></accordion-item>\n\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Adjustments -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.Adjustments.length && !vm.isCISPayStatement">\n\n\t\t\t\t\t<h5 class="accordion_title">Adjustments</h5>\n\n\t\t\t\t\t<accordion-item ai-attributes="adjustment.attributes" ai-description="{{adjustment.AdjustmentOnlineLabel}}" ai-detail="{{adjustment.adjustmentDetail}}" ai-has-hidden-content="adjustment.isToggleEnabled" ai-has-units="adjustment.AdjustmentHasUnits" ai-icon="{{adjustment.icon}}" ai-id="adjustment-{{$index}}" ai-info-tooltip="{{adjustment.AdjustmentTooltip}}" ai-theme="{{adjustment.AdjustmentDeduction ? \'assertive\' : \'positive\'}}" ai-unit-value="{{adjustment.AdjustmentUnitValue | monetise : config.precision.salaryRates}}" ai-units="{{adjustment.AdjustmentUnits}}" ai-value="{{adjustment.AdjustmentValue | monetise : config.precision.salaryRates}}" ng-if="adjustment.AdjustmentDetailID !== REPAYMENT_SCHEDULE_TYPES.childcareVouchers" ng-repeat="adjustment in vm.payslip.Adjustments | orderBy:[\'AdjustmentDeduction\', \'AdjustmentDescription\']">\n\t\t\t\t\t\t<ai-content ng-switch="adjustment.AdjustmentDetailID">\n\n\t\t\t\t\t\t\t<!-- Company car BIK -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.carBenefitInKind">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="scheduledPayment in (vm.payslip.ScheduledPayments | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Company vehicle benefit</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountTotal | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="scheduledPayment.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Healthcare BIK -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.healthcare">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="scheduledPayment in (vm.payslip.ScheduledPayments | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Healthcare benefit</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountTotal | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="scheduledPayment.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Sick Pay / SSP -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.sickPay">\n\t\t\t\t\t\t\t\t<!-- Here the entries in SicknessPay that don\'t correspond to the adjustment are filtered out. Otherwise Sick Pay entries are duplicated in each block. -->\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="sickPay in (vm.payslip.SicknessPay | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Start date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sickPay.StartDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">End date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sickPay.EndDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Amount paid</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sickPay.AmountPaid | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sickPay.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="sickPay.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Maternity Pay / SMP -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.maternityPay">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="maternityPay in (vm.payslip.MaternityPay | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Start date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{maternityPay.StartDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">End date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{maternityPay.EndDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Amount paid</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{maternityPay.AmountPaid | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{maternityPay.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="maternityPay.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Paternity Pay / SPP -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.paternityPay">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="paternityPay in (vm.payslip.PaternityPay | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Start date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{paternityPay.StartDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">End date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{paternityPay.EndDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Amount paid</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{paternityPay.AmountPaid | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{paternityPay.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="paternityPay.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Shared Parental Pay / ShPP -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.sharedParentalPay">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="sharedParentalPay in (vm.payslip.SharedParentalPay | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Start date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sharedParentalPay.StartDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">End date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sharedParentalPay.EndDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Amount paid</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sharedParentalPay.AmountPaid | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{sharedParentalPay.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="sharedParentalPay.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Adoption Pay / SAP -->\n\t\t\t\t\t\t\t<div pc-switch-when="REPAYMENT_SCHEDULE_TYPES.adoptionPay">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="adoptionPay in (vm.payslip.AdoptionPay | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Start date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{adoptionPay.StartDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">End date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{adoptionPay.EndDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Amount paid</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{adoptionPay.AmountPaid | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{adoptionPay.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="adoptionPay.ProgressPercentage" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="secondary"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Attachment of Earnings -->\n\t\t\t\t\t\t\t<div pc-switch-when="ADJUSTMENT_TYPES.attachmentOrder">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="attachmentOrder in vm.payslip.AttachmentOrders">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Issuer</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{attachmentOrder.Bank.BankAccountName}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Reference</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{attachmentOrder.PaymentReference}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Total to recover</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{attachmentOrder.TotalAmount | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{attachmentOrder.AmountRemaining | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="attachmentOrder.ProgressPercentage" pr-size="small" pr-theme-complete="assertive" pr-theme-incomplete="assertive"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Cycle to work / Company loan / Season ticket loan -->\n\t\t\t\t\t\t\t<div pc-switch-when="[\n\t\t\t\t\t\t\t\tREPAYMENT_SCHEDULE_TYPES.cycleToWorkScheme,\n\t\t\t\t\t\t\t\tREPAYMENT_SCHEDULE_TYPES.companyLoan,\n\t\t\t\t\t\t\t\tREPAYMENT_SCHEDULE_TYPES.seasonTicketLoan\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary" ng-repeat="scheduledPayment in (vm.payslip.ScheduledPayments | filter : { PaymentScheduleGroupID: adjustment.PaymentScheduleGroupID })">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Total amount</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountTotal | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-right" ng-if="!vm.isDraftPayslip">\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Still to pay</div>\n\t\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{scheduledPayment.AmountOutstanding | monetise}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item is-progress">\n\t\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="scheduledPayment.ProgressPercentage" pr-size="small" pr-theme-complete="assertive" pr-theme-incomplete="assertive"></progress-ring>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Expenses -->\n\t\t\t\t\t\t\t<div pc-switch-when="ADJUSTMENT_TYPES.expenses">\n\t\t\t\t\t\t\t\t<table class="hiddenstats__details">\n\t\t\t\t\t\t\t\t\t<tr ng-repeat="expense in vm.payslip.Expenses">\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__date">{{expense.ExpenseDescription}}</td>\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage">{{expense.ExpenseTotal | monetise}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Shift Breakdown (Rotaready) -->\n\t\t\t\t\t\t\t<div ng-if="adjustment.Components && adjustment.Components.length > 0">\n\t\t\t\t\t\t\t\t<table class="hiddenstats__details">\n\t\t\t\t\t\t\t\t\t<tr data-cy="shift-component-{{$index}}" ng-repeat="component in adjustment.Components">\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__date" data-cy="shift-component-label-{{$index}}">{{component.Label}} {{component.ComponentDate | dateformat:\'numeric\'}}</td>\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage" data-cy="shift-component-units-{{$index}}">{{component.Units}} {{component.unitLabel}} @ {{component.UnitValue | monetise}}{{component.rateLabel}}</td>\n\t\t\t\t\t\t\t\t\t\t<td class="hiddenstats__wage" data-cy="shift-component-value-{{$index}}">{{component.Value | monetise}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t</accordion-item>\n\n\t\t\t\t\t<!-- Childcare Vouchers -->\n\t\t\t\t\t<accordion-item ai-description="Childcare Vouchers" ai-detail="{{adjustment.adjustmentDetail}}" ai-icon="{{adjustment.icon}}" ai-id="childcare-voucher-{{$index}}" ai-theme="assertive" ai-value="{{adjustment.AdjustmentValue | monetise: config.precision.salaryRates}}" ng-if="adjustment.AdjustmentDetailID == REPAYMENT_SCHEDULE_TYPES.childcareVouchers" ng-repeat="adjustment in vm.payslip.Adjustments | orderBy:[\'AdjustmentDeduction\', \'AdjustmentDescription\']">\n\t\t\t\t\t</accordion-item>\n\n\t\t\t</div>\n\n\t\t\t\t<!-- Total Shift Hours -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.totalShiftHours > 0 || vm.payslip.totalShiftDays > 0">\n\t\t\t\t\t<h5 class="accordion_title">Total shift units</h5>\n\n\t\t\t\t\t<accordion-item ai-description="Hours worked" ai-icon="clock" ai-id="total-shift-hours" ai-theme="primary" ai-value="{{vm.payslip.totalShiftHours}} hrs" ng-if="vm.payslip.totalShiftHours > 0"></accordion-item>\n\t\t\t\t\t<accordion-item ai-description="Days worked" ai-icon="clock" ai-id="total-shift-days" ai-theme="primary" ai-value="{{vm.payslip.totalShiftDays}} days" ng-if="vm.payslip.totalShiftDays > 0"></accordion-item>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- CIS deductions -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.isCISPayStatement">\n\t\t\t\t\t<h5 class="accordion_title">Deductions</h5>\n\n\t\t\t\t\t<accordion-item ai-description="CIS {{vm.payslip.CIS.DeductionRateDescription}} ({{vm.payslip.CIS.DeductionRate}}%)" ai-icon="{{adjustment.icon}}" ai-id="deductions-{{$index}}" ai-label="{{adjustment.AdjustmentOnlineLabel}}" ai-theme="assertive" ai-value="{{adjustment.AdjustmentValue | monetise}}" ng-if="adjustment.AdjustmentDeduction" ng-repeat="adjustment in vm.payslip.Adjustments | orderBy:[\'AdjustmentDeduction\', \'AdjustmentDescription\']"></accordion-item>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Gross up adjustments -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.grossUpAdjustments.length > 0">\n\t\t\t\t\t<h5 class="accordion_title">Total gross up adjustments</h5>\n\n\t\t\t\t\t<accordion-item ai-description="{{adjustment.label}}" ai-icon="adjustment" ai-id="gross-up-adjustment-{{$index}}" ai-theme="primary" ai-value="{{adjustment.value | monetise}}" ng-repeat="adjustment in vm.payslip.grossUpAdjustments"></accordion-item>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension lists -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.EmployeePension > 0 && !vm.isCISPayStatement && !vm.payslip.Personal.IsOffPayrollWorker && pensionList.pensions.length !== 0" ng-repeat="pensionList in vm.payslip.pensionLists">\n\t\t\t\t\t<h5 class="accordion_title">{{pensionList.heading}}</h5>\n\n\t\t\t\t\t<!-- Hidden as no history of actual percentage used at time of payment (TBD) -->\n\t\t\t\t\t<accordion-item ai-description="{{pension.PensionName}}" ai-has-hidden-content="true" ai-icon="group" ai-id="pension-{{$index}}" ai-theme="tertiary" ai-value="{{pension.EmployeesPensionPayment | monetise}}" ng-repeat="pension in pensionList.pensions">\n\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t<div class="hiddenstats__summary">\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-centre flex-fill-available-space" ng-if="pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Status</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{pension.PensionState | capitalise}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-centre flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">{{pension.PensionType === PENSION_TYPES.autoEnrolment ? \'Group\' : \'Contribution band\'}}</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{pension.PensionGroupName}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-centre flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Employer contribution</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{pension.EmployersPensionPayment | monetise}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-centre flex-fill-available-space" ng-if="pension.HasPensionPaymentEmployersNISaving">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Employer NI savings ({{pension.PensionPaymentEmployersNISavingPercent}}%)</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{pension.PensionPaymentEmployersNISaving | monetise}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item text-centre flex-fill-available-space">\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-label">Total contribution</div>\n\t\t\t\t\t\t\t\t\t<div class="hiddenstats__summary-item-value">{{pension.TotalPensionPayment | monetise}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t</accordion-item>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension Adjustments -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.PensionAdjustments.length > 0">\n\t\t\t\t\t<h5 class="accordion_title">Pension adjustments</h5>\n\n\t\t\t\t\t<accordion-item ai-description="{{adjustment.AdjustmentOnlineLabel}}" ai-has-units="adjustment.AdjustmentHasUnits" ai-icon="group" ai-id="pension-adjustment-{{$index}}" ai-theme="tertiary" ai-unit-value="{{adjustment.AdjustmentUnitValue | monetise}}" ai-units="{{adjustment.AdjustmentUnits}}" ai-value="{{adjustment.AdjustmentValue | monetise}}" ng-repeat="adjustment in vm.payslip.PensionAdjustments | orderBy:[\'AdjustmentDeduction\', \'AdjustmentDescription\']"></accordion-item>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Student Loan -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.Tax.StudentLoan && !vm.isCISPayStatement">\n\t\t\t\t\t<h5 class="accordion_title">{{vm.payslip.PayPeriod.IsPartnership ? \'Student Loan reserve\' : \'Student Loan\'}}</h5>\n\n\t\t\t\t\t<accordion-item ai-description="{{vm.payslip.PayPeriod.IsPartnership ? \'Student Loan reserve\' : \'Student Loan\'}}" ai-icon="student-loan" ai-id="student-loan" ai-theme="tertiary" ai-value="{{vm.payslip.StudentLoanPaid | monetise}}"></accordion-item>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Postgraduate Loan -->\n\t\t\t\t<div class="accordion_layout" ng-if="vm.payslip.PostGraduateLoanPaid > 0 && !vm.isCISPayStatement">\n\t\t\t\t\t<h5 class="accordion_title">{{vm.payslip.PayPeriod.IsPartnership ? \'Postgraduate Loan reserve\' : \'Postgraduate Loan\'}}</h5>\n\n\t\t\t\t\t<accordion-item ai-description="{{vm.payslip.PayPeriod.IsPartnership ? \'Postgraduate Loan reserve\' : \'Postgraduate Loan\'}}" ai-icon="student-loan" ai-id="postgraduate-loan" ai-theme="tertiary" ai-value="{{vm.payslip.PostGraduateLoanPaid | monetise}}"></accordion-item>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Tax -->\n\t\t\t\t<div class="accordion_layout" ng-if="!vm.isCISPayStatement">\n\t\t\t\t\t<h5 class="accordion_title">{{vm.payslip.PayPeriod.IsPartnership ? \'Tax reserve\' : \'Tax\'}}</h5>\n\n\t\t\t\t\t<!-- Tax -->\n\t\t\t\t\t<accordion-item ai-description="{{::vm.payslip.PayPeriod.IsPartnership ? \'Income Tax reserve\' : \'Income Tax\'}}" ai-icon="tax-code-change" ai-id="tax-paid" ai-theme="quarternary" ai-value="{{(vm.payslip.Personal.IsExpatriate ? vm.payslip.UKTaxPaid : vm.payslip.TaxPaid) | monetise}}"></accordion-item>\n\n\t\t\t\t\t<!-- Foreign Tax Offset (Expat only) -->\n\t\t\t\t\t<accordion-item ai-description="Foreign tax offset" ai-icon="tax-code-change" ai-id="foreign-tax-offset" ai-theme="quarternary" ai-value="{{vm.payslip.ForeignTaxOffset | monetise}}" ng-if="vm.payslip.Personal.IsExpatriate"></accordion-item>\n\n\t\t\t\t\t<!-- National Insurance -->\n\t\t\t\t\t<accordion-item ai-description="{{::vm.payslip.PayPeriod.IsPartnership ? \'National Insurance reserve\' : \'National Insurance\'}}" ai-icon="national-insurance" ai-id="ni" ai-theme="quarternary" ai-value="{{vm.payslip.NI | monetise}}"></accordion-item>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Net Pay -->\n\t\t\t<div class="payslip-stats">\n\t\t\t\t<div class="payslip-stats__item">\n\t\t\t\t</div>\n\t\t\t\t<div class="payslip-stats__item">\n\t\t\t\t\t<h5 class="payslip-stats__title">{{::vm.payslip.PayPeriod.IsPartnership ? \'Net Drawings\' : \'Net Pay\'}}</h5>\n\t\t\t\t\t<p class="payslip-stats__value" data-cy="payslip-stats-netpay-value">\n\t\t\t\t\t\t{{vm.payslip.NetPay | monetise}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Personal Details -->\n\t\t\t<div class="person">\n\t\t\t\t<div class="person__layout">\n\t\t\t\t\t<div class="person__image">\n\t\t\t\t\t\t<avatar avatar-alt="{{::vm.payslip.Personal.Forename}} {{::vm.payslip.Personal.Surname}}\'s avatar" avatar-gender="{{::vm.payslip.Personal.Gender}}" avatar-id="{{::vm.payslip.Personal.AvatarID}}" avatar-initial="{{::vm.payslip.Personal.Forename[0]}}" avatar-type="smiley"></avatar>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="person__contact">\n\t\t\t\t\t\t<h6 class="strong" data-cy="payslip-employee-name" ng-bind="vm.payslip.Personal.Forename + \' \' + vm.payslip.Personal.Surname"></h6>\n\t\t\t\t\t\t<p class="s" data-cy="payslip-employee-company">\n\t\t\t\t\t\t\t{{::$root.currentCompany.CompanyName}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" data-cy="payslip-employee-email">\n\t\t\t\t\t\t\t{{vm.payslip.Personal.EmailAddress | checkEmpty:\'No email address\'}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="person__details" ng-class="{\'person__details--cis\': vm.isCISPayStatement}">\n\t\t\t\t\t\t<div class="accordion">\n\n\t\t\t\t\t\t\t<!-- Tax Code -->\n\t\t\t\t\t\t\t<accordion-item ai-description="Tax code" ai-has-hidden-content="true" ai-id="tax-code" ai-template="basic" ng-if="!vm.isCISPayStatement">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>NI Number</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Payroll ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Tax code</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-cy="payslip-ninumber-value" data-title="NI Number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.Personal.NINumber | checkEmpty}}\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-cy="payslip-payrollid-value" data-title="Payroll ID">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.Personal.PayrollID | checkEmpty}}\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Tax code" width="100">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span data-cy="payslip-taxcode-value" ng-bind="vm.payslip.Tax.TaxCode + (vm.payslip.Tax.TaxCodeM1W1 ? \' \' + config.w1m1Label : \'\')" ng-bind="vm.payslip.Tax.TaxCode + (vm.payslip.Tax.TaxCodeM1W1 ? \' \' + config.w1m1Label : \'\')" ng-class="{\'new\': vm.payslip.Tax.IsTaxCodeNew}"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\n\t\t\t\t\t\t\t<!-- CIS info -->\n\t\t\t\t\t\t\t<accordion-item ai-description="CIS info" ai-has-hidden-content="true" ai-id="cis-info" ai-template="basic" ng-if="vm.isCISPayStatement">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Unique Taxpayer Reference</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Verification number</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Deduction rate</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Unique Taxpayer Reference">{{vm.payslip.Personal.UTR | checkEmpty}}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Verification number">{{vm.payslip.CIS.VerificationReference | checkEmpty}}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Deduction rate">{{vm.payslip.CIS.DeductionRateDescription}} ({{vm.payslip.CIS.DeductionRate}}%)</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Contractor Details -->\n\t\t\t<div class="person person--cis" ng-if="vm.isCISPayStatement">\n\t\t\t\t<div class="accordion">\n\t\t\t\t\t<accordion-item ai-description="Contractor info" ai-has-hidden-content="true" ai-hidden-content-theme="person__layout" ai-id="contractor-info" ai-template="basic">\n\t\t\t\t\t\t<ai-content class="person__layout">\n\t\t\t\t\t\t\t<div class="person__image">\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="person__contact">\n\t\t\t\t\t\t\t\t<p class="strong s">Contractor info</p>\n\t\t\t\t\t\t\t\t<print-address address="vm.company.Address" class="person__address" ng-if="vm.company.Address.AddressPostcode !== \'\'"></print-address>\n\t\t\t\t\t\t\t\t<p ng-if="vm.company.Address.AddressPostcode === \'\'">{{::$root.currentCompany.CompanyName}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="person__details person__details--cis">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Employer PAYE reference</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Accounts office reference</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>&nbsp;</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Employer PAYE reference">{{vm.company.Employer.PAYERef | checkEmpty}}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td data-title="Accounts office reference">{{vm.company.Employer.AccountsOffice | checkEmpty}}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t</accordion-item>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Payment Info -->\n\t\t\t<div class="payslip-details" ng-if="!vm.isCISPayStatement">\n\t\t\t\t<div class="payslip-details__layout">\n\t\t\t\t\t<div class="payslip-details__item">\n\t\t\t\t\t\t<div class="accordion">\n\n\t\t\t\t\t\t\t<!-- Payment Info -->\n\t\t\t\t\t\t\t<accordion-item ai-description="Payment Info" ai-has-hidden-content="true" ai-id="payment-info" ai-template="basic">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<table class="payslip-details__table">\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Payment date:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payment-info-payment-date">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.PayPeriod.PayslipDisplayDateISO | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr ng-if="::vm.isPayslipPeriodVisible">\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Pay period:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payment-info-pay-period-date-range">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.PayPeriod.StartDateISO | dateformat}} - {{vm.payslip.PayPeriod.EndDateISO | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Tax period:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payment-info-tax-period">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.PayPeriod.TaxPeriod}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Bank account:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payment-info-bank-account">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.Bank.BankAccountNumber | checkEmpty}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Payment method:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payment-info-payment-method">\n\t\t\t\t\t\t\t\t\t\t\t\tBACS\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Year To Date -->\n\t\t\t\t\t<div class="payslip-details__item">\n\t\t\t\t\t\t<div class="accordion">\n\n\t\t\t\t\t\t\t<!-- Tax YTD -->\n\t\t\t\t\t\t\t<accordion-item ai-description="Payments to date" ai-has-hidden-content="true" ai-id="payments-to-date" ai-template="basic">\n\t\t\t\t\t\t\t\t<ai-content>\n\t\t\t\t\t\t\t\t\t<table class="payslip-details__table">\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Gross profit share\' : \'Gross pay\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-gross-current-employment-total">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDGrossCurrentEmploymentTotal | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Gross remuneration all engagements\' : \'Taxable pay all employments\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-taxable-pay-all-employments">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDGrossCurrentEmploymentforTax + vm.payslip.YTD.YTDGrossPreviousEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Income Tax reserve all engagements\' : \'Tax paid all employments\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" ng-if="!vm.payslip.Personal.IsExpatriate" data-cy="payslip-payments-to-date-tax-paid-all-employments">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDTaxCurrentEmployment + vm.payslip.YTD.YTDTaxPreviousEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" ng-if="vm.payslip.Personal.IsExpatriate" data-cy="payslip-payments-to-date-uk-tax-current-employment">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDUKTaxCurrentEmployment + vm.payslip.YTD.YTDTaxPreviousEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Gross remuneration previous engagements\' : \'Taxable pay previous employment\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-gross-previous-employment">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDGrossPreviousEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Income Tax reserve previous engagements\' : \'Tax paid previous employment\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-tax-previous-employment">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDTaxPreviousEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Foreign tax credit:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-foreign-tax-credit">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDForeignTaxCredit | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Foreign tax offset:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-foreign-tax-offset">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDForeignTaxOffset | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'National Insurance reserve\' : \'Employee\\\'s National Insurance\'}}:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-ee-ni-current-employment">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDEENICurrentEmployment | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Pension contributions AE (incl. Salary Sacrifice):\' : \'Employee pension AE (incl. Salary Sacrifice):\'}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-pension-contribution-employee">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDPensionContributionEmployee | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">{{::vm.payslip.PayPeriod.IsPartnership ? \'Pension contributions non-AE (incl. Salary Sacrifice):\' : \'Employee pension non-AE (incl. Salary Sacrifice):\'}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-pension-contribution-employee-non-ae">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDPensionContributionEmployeeNonAE | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Employer pension AE:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-pension-contribution-employer">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDPensionContributionEmployer | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t\t\t\t<td class="payslip-details__key">Employer pension non-AE:</td>\n\t\t\t\t\t\t\t\t\t\t\t<td align="right" class="payslip-details__value" data-cy="payslip-payments-to-date-pension-contribution-employer-non-ae">\n\t\t\t\t\t\t\t\t\t\t\t\t{{vm.payslip.YTD.YTDPensionContributionEmployerNonAE | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</ai-content>\n\t\t\t\t\t\t\t</accordion-item>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Notices -->\n\t\t\t<div class="payslip_notice" ng-if="::vm.isAdditionalNoteVisible && vm.payslip.HMRCNotice">\n\t\t\t\t<p class="payslip_notice-text">\n\t\t\t\t\t{{::vm.payslip.HMRCNotice}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\n\t\t</div>\n\t</div>\n\n\t<!-- Printable payslip view -->\n\t<div class="printable-payslip" ng-show="vm.viewPrintablePayslip">\n\n\t\t<div class="printable-payslip_view fadeIn">\n\n\t\t\t<!-- Paginated pages - repeat for each page -->\n\t\t\t<div class="printable-payslip_page" ng-repeat="page in vm.payslip.paginatedPayslip.pages track by page.pageNumber">\n\n\t\t\t\t<div class="printable-payslip_header">\n\t\t\t\t\t<!-- Header stuff -->\n\t\t\t\t\t<div class="printable-payslip_cell no-border printable-payslip_data-employee-address">\n\t\t\t\t\t\t<div ng-bind="vm.payslip.Personal.Forename + \' \' + vm.payslip.Personal.Surname"></div>\n\t\t\t\t\t\t<div ng-if="vm.address.AddressName">{{vm.address.AddressName}}</div>\n\t\t\t\t\t\t<div ng-if="vm.address.AddressNumber || vm.address.AddressStreet">{{vm.address.AddressNumber}} {{vm.address.AddressStreet}}</div>\n\t\t\t\t\t\t<div ng-if="vm.address.AddressCity">{{vm.address.AddressCity}}</div>\n\t\t\t\t\t\t<div ng-if="vm.address.AddressCounty">{{vm.address.AddressCounty}}</div>\n\t\t\t\t\t\t<div ng-if="vm.address.AddressPostcode">{{vm.address.AddressPostcode}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-payslip_cell no-border align-vertically printable-payslip_data-payslip-note">\n\t\t\t\t\t\t<div class="printable-payslip_cell-payslip-note no-break" ng-if="vm.payslip.NoteForPayslip.TextMerged">\n\t\t\t\t\t\t\t{{vm.payslip.NoteForPayslip.TextMerged}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-payslip_cell no-border align-vertically printable-payslip_data-company-logo">\n\t\t\t\t\t\t<img alt="{{vm.payslip.CompanyName}}" class="printable-payslip_cell-company-logo" ng-if="vm.payslip.showLogoForPrintablePayslip" ng-src="{{vm.customisation.Payslips.LogoURL}}">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="printable-payslip_main">\n\n\t\t\t\t\t<!-- Top row info headers -->\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header border-right printable-payslip_data-employee-no">Payroll ID</div>\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header border-right printable-payslip_data-employee-name">Employee</div>\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header border-right printable-payslip_data-paydate">Date</div>\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header printable-payslip_data-ni-number">National Insurance No.</div>\n\t\t\t\t\t<!-- Top row info values -->\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-employee-no">{{::vm.payslip.Personal.PayrollID | checkEmpty}}</div>\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-employee-name" ng-bind="vm.payslip.Personal.Forename + \' \' + vm.payslip.Personal.Surname"></div>\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-paydate">{{::vm.payslip.PayPeriod.PayslipDisplayDateISO | dateformat}}</div>\n\t\t\t\t\t<div class="printable-payslip_cell printable-payslip_data-ni-number">{{::vm.payslip.Personal.NINumber | checkEmpty}}&nbsp;&nbsp;&nbsp;{{::vm.payslip.Tax.NICode}}</div>\n\n\t\t\t\t\t<!-- Payments (lhs list) and adjustments (rhs list) headers -->\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header border-right printable-payslip_data-list">\n\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Payments</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">Amount</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header printable-payslip_data-list">\n\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Adjustments</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">Amount</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Payments (lhs list) - uses paginated row data -->\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-list">\n\t\t\t\t\t\t<div class="printable-payslip_cell-lists">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-list is-expanding">\n\t\t\t\t\t\t\t\t<div ng-repeat="row in page.lhsRows track by $index">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="row.type === \'adjustment\'">\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name" data-cy="payslip-adjustment-description-{{$index}}">{{::row.description}}\n\t\t\t\t\t\t\t\t\t\t\t<span ng-if="::row.isBIK">*</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" data-cy="payslip-adjustment-value-{{$index}}">{{::row.displayValue}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem is-component" data-cy="printable-shift-component-lhs-{{$index}}" ng-if="row.type === \'component\'">\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::row.component.Label}} {{::row.component.ComponentDate | dateformat:\'numeric\'}} {{::row.component.Units}} {{::row.component.unitLabel}} @ {{::row.component.UnitValue.toFixed(2)}}{{::row.component.rateLabel}}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::row.component.Value.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="page.lhsHasBIK">&nbsp;</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="page.lhsHasBIK">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">* = Benefit in Kind</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- Show totals on all pages -->\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-list">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name is-bold">Total payments</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.GrossPayment.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Adjustments (rhs list) - uses paginated row data -->\n\t\t\t\t\t<div class="printable-payslip_cell printable-payslip_data-list">\n\t\t\t\t\t\t<div class="printable-payslip_cell-lists">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-list is-expanding">\n\t\t\t\t\t\t\t\t<div ng-repeat="row in page.rhsRows track by $index">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="row.type === \'adjustment\'">\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name" data-cy="payslip-adjustment-description-{{$index}}">\n\t\t\t\t\t\t\t\t\t\t\t{{::row.description}}\n\t\t\t\t\t\t\t\t\t\t\t<span ng-if="::row.isBIK">*</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" data-cy="payslip-adjustment-value-{{$index}}">\n\t\t\t\t\t\t\t\t\t\t\t{{::row.displayValue}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem is-component" data-cy="printable-shift-component-rhs-{{$index}}" ng-if="row.type === \'component\'">\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::row.component.Label}} {{::row.component.ComponentDate | dateformat:\'numeric\'}} {{::row.component.Units}} {{::row.component.unitLabel}} @ {{::row.component.UnitValue.toFixed(2)}}{{::row.component.rateLabel}}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::row.component.Value.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="page.rhsHasBIK">&nbsp;</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="page.rhsHasBIK">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">* = Benefit in Kind</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!-- Show totals on all pages -->\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="page.rhsRows.length !== 0">&nbsp;</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name is-bold">Total adjustments</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.rhs.totalValue.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- Tax - show on all pages -->\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-list">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-list-heading">\n\t\t\t\t\t\t\t\t\tTax<span ng-if="vm.payslip.PayPeriod.IsPartnership">&nbsp;reserve</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'Income Tax reserve\' : \'Income Tax\'}}</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{vm.payslip.Personal.IsExpatriate ? vm.payslip.UKTaxPaid.toFixed(2) : vm.payslip.TaxPaid.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="::vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Foreign tax offset</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.ForeignTaxOffset.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'National Insurance reserve\' : \'National Insurance\'}}</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.NI.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Tax.StudentLoan">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'Student Loan reserve\' : \'Student Loan\'}}</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.StudentLoanPaid.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Tax.PostGraduateLoan">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'Postgraduate Loan reserve\' : \'Postgraduate Loan\'}}</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.PostGraduateLoanPaid.toFixed(2)}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">&nbsp;</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name is-bold">\n\t\t\t\t\t\t\t\t\t\tTotal tax<span ng-if="vm.payslip.PayPeriod.IsPartnership">&nbsp;reserve</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">\n\t\t\t\t\t\t\t\t\t\t{{::\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t(vm.payslip.Personal.IsExpatriate ?\n\t\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.UKTaxPaid :\n\t\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.TaxPaid\n\t\t\t\t\t\t\t\t\t\t\t\t) +\n\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.ForeignTaxOffset +\n\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.NI +\n\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.StudentLoanPaid +\n\t\t\t\t\t\t\t\t\t\t\t\tvm.payslip.PostGraduateLoanPaid\n\t\t\t\t\t\t\t\t\t\t\t).toFixed(2)\n\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Totals headers - show on all pages -->\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header border-right printable-payslip_data-list">Totals this period</div>\n\t\t\t\t\t<div class="printable-payslip_cell is-cell-header printable-payslip_data-list">Totals year to date</div>\n\t\t\t\t\t<!-- Totals values, partnership or non-partnership - show on all pages -->\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-list">\n\t\t\t\t\t\t<!-- Parnership -->\n\t\t\t\t\t\t<div class="printable-payslip_cell-list" ng-if="vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Gross profit share</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.GrossPay.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Income Tax reserve</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.TaxPaid.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">National Insurance reserve</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.NI.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Pension contributions AE (incl. Salary Sacrifice):</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployeePensionAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Pension contributions non-AE (incl. Salary Sacrifice):</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployeePensionNonAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- Non-partnership -->\n\t\t\t\t\t\t<div class="printable-payslip_cell-list" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Gross pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.GrossPay.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Taxable pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.GrossPayForTax.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Tax paid</div>\n\n\t\t\t\t\t\t\t\t<!-- Non-Expat -->\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" ng-if="!vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t{{::vm.payslip.TaxPaid.toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Expat -->\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t{{::vm.payslip.UKTaxPaid.toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">NIable pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.GrossPayForNI.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer\'s National Insurance</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.NIER.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension AE</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployerPensionAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension AE AVC</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployerPensionAdditionalAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension non-AE</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployerPensionNonAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension non-AE AVC</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.EmployerPensionAdditionalNonAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Foreign tax credit</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.ForeignTaxCredit.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Foreign tax offset</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.ForeignTaxOffset.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Totals values YTD, some partnership, some non-partnership, some both - show on all pages -->\n\t\t\t\t\t<div class="printable-payslip_cell printable-payslip_data-list">\n\t\t\t\t\t\t<div class="printable-payslip_cell-list">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Gross profit share</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDGrossCurrentEmploymentTotal.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Income Tax reserve</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDTaxCurrentEmployment.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">National Insurance reserve</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDEENICurrentEmployment.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Gross Pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDGrossCurrentEmploymentTotal.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Taxable pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::(vm.payslip.YTD.YTDGrossCurrentEmploymentforTax + vm.payslip.YTD.YTDGrossPreviousEmployment).toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Tax paid</div>\n\n\t\t\t\t\t\t\t\t<!-- Non-Expat -->\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" ng-if="!vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t{{::(vm.payslip.YTD.YTDTaxCurrentEmployment + vm.payslip.YTD.YTDTaxPreviousEmployment).toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Expat -->\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t\t{{::(vm.payslip.YTD.YTDUKTaxCurrentEmployment + vm.payslip.YTD.YTDTaxPreviousEmployment).toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">NIable pay</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDGrossCurrentEmploymentforNIC.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name" data-cy="payslip-ytd-name-employer-ni">\n\t\t\t\t\t\t\t\t\tEmployer\'s National Insurance\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" data-cy="payslip-ytd-value-employer-ni">\n\t\t\t\t\t\t\t\t\t{{::vm.payslip.YTD.YTDERNICurrentEmployment.toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name" data-cy="payslip-ytd-name-employee-ni">\n\t\t\t\t\t\t\t\t\tEmployee\'s National Insurance\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value" data-cy="payslip-ytd-value-employee-ni">\n\t\t\t\t\t\t\t\t\t{{::vm.payslip.YTD.YTDEENICurrentEmployment.toFixed(2)}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'Pension contributions AE (incl. Salary Sacrifice)\' : \'Employee pension AE (incl. Salary Sacrifice)\'}}</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDPensionContributionEmployee.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">{{::vm.payslip.PayPeriod.IsPartnership ? \'Pension contributions non-AE (incl. Salary Sacrifice)\' : \'Employee pension non-AE (incl. Salary Sacrifice)\'}}</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDPensionContributionEmployeeNonAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension AE</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDPensionContributionEmployer.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="!vm.payslip.PayPeriod.IsPartnership">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Employer pension non-AE</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDPensionContributionEmployerNonAE.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Foreign tax credit</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDForeignTaxCredit.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem" ng-if="vm.payslip.Personal.IsExpatriate">\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-name">Foreign tax offset</div>\n\t\t\t\t\t\t\t\t<div class="printable-payslip_cell-listitem-value">{{::vm.payslip.YTD.YTDForeignTaxOffset.toFixed(2)}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Summary -->\n\t\t\t\t\t<div class="printable-payslip_cell align-vertically border-right printable-payslip_data-summary">\n\t\t\t\t\t\t<div class="printable-payslip_cell-summary">\n\t\t\t\t\t\t\t<div>{{::vm.payslip.CompanyName}}</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="printable-payslip_cell-summary">\n\t\t\t\t\t\t\t<div>Tax code:<br> <span ng-bind="(vm.payslip.Tax.TaxCode | checkEmpty) + (vm.payslip.Tax.TaxCodeM1W1 ? \' \' + config.w1m1Label : \'\')"></span></div>\n\t\t\t\t\t\t\t<div>Tax period:<br>{{::vm.payslip.PayPeriod.TaxPeriod | checkEmpty}}</div>\n\t\t\t\t\t\t\t<div ng-if="::vm.isPayslipPeriodVisible">Pay period:<br>{{::vm.payslip.PayPeriod.PayPeriodDisplay}}</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<span ng-if="::vm.payslip.IsHolidayPayAccruedVisible">Accrued holiday pay:<br>{{::vm.payslip.HolidayPayAccrued.toFixed(2)}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-payslip_cell border-right printable-payslip_data-net-pay-icon">\n\t\t\t\t\t\t<div class="printable-payslip_cell-net-pay">\n\t\t\t\t\t\t\t<div class="printable-payslip_cell-net-pay-icon"><i class="icon-wallet l"></i></div>\n\t\t\t\t\t\t\t<div>NET</div>\n\t\t\t\t\t\t\t<div>{{::vm.payslip.PayPeriod.IsPartnership ? \'DRAWINGS\' : \'PAY\'}}</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-payslip_cell align-vertically is-large printable-payslip_data-net-pay">\n\t\t\t\t\t\t<div class="align-right" data-cy="payslip-net-pay">\n\t\t\t\t\t\t\t{{::vm.payslip.NetPay.toFixed(2)}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Page number -->\n\t\t\t\t<div class="printable-payslip_page-number" ng-if="vm.payslip.paginatedPayslip.totalPages > 1">\n\t\t\t\t\tPage {{page.pageNumber}} of {{page.totalPages}}\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Footer - only show on last page -->\n\t\t\t\t<div class="printable-payslip_footer" ng-if="page.isLastPage && vm.isAdditionalNoteVisible && vm.payslip.HMRCNotice">\n\t\t\t\t\t<div class="align-right">\n\t\t\t\t\t\t{{::vm.payslip.HMRCNotice}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('components/payslip-notes/payslip-notes.component.html','<div class="payslip-notes" ng-switch="$ctrl.pageState">\n\n\t<!-- Loading -->\n\t<div class="fadeIn" ng-switch-when="loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<form class="fadeIn payslip-notes_form" name="editPayslipNotesForm" ng-submit="$ctrl.saveForm($ctrl, editPayslipNotesForm)" ng-switch-when="ready" novalidate>\n\n\t\t<div class="payslip-notes_header">\n\t\t\t<team-member-carousel active-team-member-user-id="{{$ctrl.teamMember.PersonalDetails.UserID}}" functions="$ctrl.functions" on-team-member-change="$ctrl.setMember" team-members="$ctrl.team"></team-member-carousel>\n\t\t</div>\n\n\t\t<fieldset class="payslip-notes_layout">\n\t\t\t<div class="payslip-notes_container">\n\n\t\t\t\t<div class="payslip-notes_input-container" ng-class="{\n\t\t\t\t\t\t\'payslip-notes_input-container-arrow\': $ctrl.formState === \'menu\' || $ctrl.formState === \'more\',\n\t\t\t\t\t\t\'payslip-notes_input-container-invalid\' : !$ctrl.teamMember.isValid\n\t\t\t\t\t}">\n\t\t\t\t\t<div class="payslip-notes_input" contenteditable="plaintext-only" data-cy="payslip-notes-input" ng-model="$ctrl.teamMember.payslipNote" payslip-notes payslip-notes-options="$ctrl"></div>\n\t\t\t\t\t<a class="payslip-notes_hidemenu" data-cy="payslip-notes-hidemenu-button" href="" ng-if="$ctrl.formState !== \'menu\'" ng-click="$ctrl.changeState(\'menu\')"></a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="payslip-notes_tooltip" ng-if="$ctrl.formState == \'ready\'">\n\t\t\t\t\t<i class="icon-edit primary"></i>&nbsp;&nbsp;Start typing your note in here\n\t\t\t\t</div>\n\n\t\t\t\t<div class="payslip-notes_option-menu fadeIn" ng-if="$ctrl.formState == \'menu\'">\n\n\t\t\t\t\t<div class="payslip-notes_option-set payslip-notes_option-set-{{type.optionTheme}}" ng-if="($ctrl.team.length === 1 && type.optionKey !== \'tags\') || $ctrl.team.length > 1" ng-repeat="type in $ctrl.options">\n\t\t\t\t\t\t<h6 class="payslip-notes_option-label">{{type.optionLabel}}</h6>\n\t\t\t\t\t\t<div class="payslip-notes_option-list">\n\n\t\t\t\t\t\t\t<a class="payslip-notes_option-tag payslip-notes_option-tag-{{type.optionTheme}}" href="" ng-class="$ctrl.tags[type.optionKey][$index].optionTheme" ng-click="$ctrl.addTagToPayslipNote($ctrl.tags[type.optionKey][$index], type.optionTheme)" ng-repeat="option in $ctrl.tags[type.optionKey].constructor(type.optionsOnFirstPage) track by $index">\n\t\t\t\t\t\t\t\t{{$ctrl.tags[type.optionKey][$index].optionLabel}}\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<div class="payslip-notes_option-action">\n\t\t\t\t\t\t\t\t<a class="payslip-notes_option-more" href="" ng-click="$ctrl.goToExpandedView($ctrl, type.optionKey)" ng-if="type.optionExtras">\n\t\t\t\t\t\t\t\t\t<i class="icon-chevron-right primary"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="payslip-notes_option-set payslip-notes_option-set-checkbox" ng-if="$ctrl.team.length > 1">\n\t\t\t\t\t\t<toggle-input field-label="&nbsp;&nbsp;&nbsp;Add same note for all selected team members" field-on-change="!$ctrl.teamMember.hasDefault && $ctrl.giveTeamMembersSameNote($ctrl)" field-model="$ctrl.teamMembersHaveSameNote" field-disabled="$ctrl.hasDefault" field-name="teamMembersHaveSameNote"></toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="payslip-notes_option-menu fadeIn" ng-if="$ctrl.formState == \'more\'">\n\n\t\t\t\t\t<div class="payslip-notes_option-set">\n\t\t\t\t\t\t<p class="strong">\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.changeState(\'menu\')">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-left"></i> Back\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="payslip-notes_option-set" ng-switch="$ctrl.optionKey">\n\n\t\t\t\t\t\t<div class="payslip-notes_option-list payslip-notes_option-list-all payslip-notes_option-list-emoji" ng-switch-when="emoji">\n\t\t\t\t\t\t\t<a class="payslip-notes_option-tag payslip-notes_option-tag-emoji" href="" ng-click="$ctrl.addTagToPayslipNote(emoji, \'emojis\')" ng-repeat="emoji in $ctrl.emojis">\n\t\t\t\t\t\t\t\t{{emoji.code | emojify:\'codeToString\'}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="payslip-notes_option-list payslip-notes_option-list-all" ng-switch-when="tags">\n\t\t\t\t\t\t\t<a class="payslip-notes_option-tag payslip-notes_option-tag-tag" href="" ng-class="$ctrl.tags.tags[$index].optionTheme" ng-click="$ctrl.addTagToPayslipNote($ctrl.tags.tags[$index], \'tag\')" ng-repeat="option in $ctrl.tags.tags track by $index">\n\t\t\t\t\t\t\t\t{{$ctrl.tags.tags[$index].optionLabel}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="payslip-notes_option-list payslip-notes_option-list-all" ng-switch-when="favourites">\n\t\t\t\t\t\t\t<a class="payslip-notes_option-tag payslip-notes_option-tag-pill" href="" ng-class="$ctrl.tags.favourites[$index].optionTheme" ng-click="$ctrl.addTagToPayslipNote($ctrl.tags.favourites[$index], \'favourites\')" ng-repeat="option in $ctrl.tags.favourites track by $index">\n\t\t\t\t\t\t\t\t{{$ctrl.tags.favourites[$index].optionLabel}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<img alt="" class="payslip-notes_logo" ng-src="{{$ctrl.customisation.Payslips.LogoURL !== \'\' ? $ctrl.customisation.Payslips.LogoURL : \'images/paycircle-logo-stacked.png\'}}" src="">\n\t\t\t<img class="payslip-notes_graphic" src="images/graphics/payslip-notes.svg">\n\n\t\t</fieldset>\n\n\t\t<div class="payslip-notes_footer">\n\n\t\t\t<div class="payslip-notes_footer-title" ng-if="$ctrl.team.length > 1">\n\t\t\t\t<p class="s stronger">{{$ctrl.teamMember.teamIndex}} of {{$ctrl.team.length}} team members</p>\n\t\t\t</div>\n\n\t\t\t<div class="payslip-notes_footer-actions">\n\t\t\t\t<submit-button class="payslip-notes_footer-action" display-text="formOptions.primaryButtonText" ng-if="$ctrl.teamMember.teamIndex === $ctrl.team.length" state="editPayslipNotesForm.state"></submit-button>\n\t\t\t\t<a class="button payslip-notes_footer-action tertiary" data-cy="payslip-notes-go-next-button" href="" ng-click="$ctrl.functions.nextMember()" ng-if="$ctrl.teamMember.teamIndex !== $ctrl.team.length">\n\t\t\t\t\tNext\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<div class="fadeIn payslip-notes_state-wrapper" ng-switch-when="saved">\n\n\t\t<div class="payslip-notes_state">\n\t\t\t<div class="payslip-notes_state-header">\n\t\t\t\t<div class="payslip-notes_state-icon"><i class="icon-tick xxl is-primary"></i></div>\n\t\t\t\t<h6 class="payslip-notes_state-heading" data-cy="payslips-saved-heading">\n\t\t\t\t\tPayslip notes saved\n\t\t\t\t</h6>\n\t\t\t</div>\n\t\t\t<div class="payslip-notes_state-content">\n\t\t\t\t<p class="payslip-notes_state-paragraph">\n\t\t\t\t\tYour payslip notes have been saved for {{$ctrl.team.length}}&nbsp;team&nbsp;\n\t\t\t\t\t<ng-pluralize count="$ctrl.team.length" when="{\n\t\t\t\t\t\t\t\'1\': \'member\',\n\t\t\t\t\t\t\t\'other\': \'members\'\n\t\t\t\t\t\t}"></ng-pluralize>&nbsp;\n\t\t\t\t\tand will be displayed on their payslips for {{$ctrl.payPeriodDisplay}}.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="payslip-notes_state-footer">\n\t\t\t\t<a href="" ng-click="$ctrl.payslipNotesOptions.closeModal()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<!-- Error -->\n\t<div ng-switch-when="error">\n\t\t<error-block></error-block>\n\t</div>\n\n</div>\n');
$templateCache.put('components/payslip-preview/payslip-preview.component.html','<div class="fadeIn payslip-preview">\n\n\t<div class="payslip-preview_layout">\n\t\t<img alt="Custom logo for {{$ctrl.payslipPreviewOptions.payslipType}} payslip" class="payslip-preview_logo payslip-preview_logo-{{$ctrl.payslipPreviewOptions.payslipType}}" ng-if="$ctrl.payslipPreviewOptions.logoToUse" ng-src="{{$ctrl.payslipPreviewOptions.logoToUse}}" src>\n\t\t<img alt="Default logo for {{$ctrl.payslipPreviewOptions.payslipType}} payslip" class="payslip-preview_logo payslip-preview_logo-{{$ctrl.payslipPreviewOptions.payslipType}}" ng-if="!$ctrl.payslipPreviewOptions.logoToUse" src="images/paycircle-logo-stacked.png">\n\t\t<img alt="" class="payslip-preview_graphic" ng-src="images/graphics/payslip-preview-{{$ctrl.payslipPreviewOptions.payslipType}}.png" src>\n\t</div>\n\n</div>\n\n\n');
$templateCache.put('components/pension-scheme-card/pension-scheme-card.component.html','<div class="pension-scheme-card" data-cy="pension-scheme-{{$ctrl.index}}" ng-mouseleave="$ctrl.hideMenus()">\n\t<div class="pension-scheme-card_header">\n\t\t<a class="pension-scheme-card_media clickable" data-cy="pensions-summary-scheme" href="" ui-sref="pensions.scheme.status({agencyProfileId: $ctrl.agencyProfileId, agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID})">\n\t\t\t<!-- Incomplete team member -->\n\t\t\t<div class="pension-scheme-card_highlight" ng-if="::!$ctrl.pension.IsGhostPension && $ctrl.pension.TotalIncomplete" tooltip-text="Incomplete team members" tooltip>\n\t\t\t\t<span>{{::$ctrl.pension.TotalIncomplete}}</span>\n\t\t\t</div>\n\n\t\t\t<!-- Eligble team members (Ghost Pension) -->\n\t\t\t<div class="pension-scheme-card_highlight" ng-if="::$ctrl.pension.IsGhostPension && $ctrl.pension.TotalEligible" tooltip-text="Eligible team members" tooltip>\n\t\t\t\t<span>{{::$ctrl.pension.TotalEligible}}</span>\n\t\t\t</div>\n\n\t\t\t<div class="pension-scheme-card_logo">\n\t\t\t\t<img alt="{{::$ctrl.pension.PensionProviderName}}" ng-if="::!$ctrl.pension.IsGhostPension && $ctrl.pension.PensionProviderImageUrl !== \'\'" ng-src="{{::$ctrl.pension.PensionProviderImageUrl}}">\n\t\t\t\t<i class="icon-money primary-light xxl" ng-if="::$ctrl.pension.IsGhostPension || $ctrl.pension.PensionProviderImageUrl === \'\'"></i>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class="pension-scheme-card_states" ng-switch="$ctrl.pension.PensionType">\n\t\t\t<!-- AE -->\n\t\t\t<div class="pension-scheme-card_states-layout" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t<span class="tag is-primary is-border-white">AE</span>\n\n\t\t\t\t<pension-scheme-state has-border="true" ng-if="::!$ctrl.pension.IsGhostPension" state="$ctrl.pension.PensionState"></pension-scheme-state>\n\t\t\t</div>\n\n\t\t\t<!-- Non-AE -->\n\t\t\t<div pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t<span class="tag is-primary is-border-white">Non-AE</span>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="pension-scheme-card_menu">\n\n\t\t\t<dropdown-menu menu-id="pension-scheme-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.showMenu" menu-size="l" menu-theme="primary">\n\t\t\t\t<div class="dropdown-group" ng-switch="$ctrl.pension.PensionProviderAPI">\n\t\t\t\t\t<a data-cy="pension-scheme-menu-go-to-pension" ui-sref="pensions.scheme.status({agencyProfileId: $ctrl.agencyProfileId, agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID})">\n\t\t\t\t\t\tGo to pension\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" data-cy="pension-scheme-menu-add-team-members" ng-click="$ctrl.openPensionTeamForm()" ng-if="::$ctrl.totalNotAllocated > 0">\n\t\t\t\t\t\tAdd team members\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="pension-scheme-menu-pension-settings" ui-sref="pensions.scheme.settings({agencyProfileId: $ctrl.agencyProfileId, agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID})">\n\t\t\t\t\t\tPension settings\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="pension-scheme-menu-visit-website" ng-href="{{$ctrl.pension.PensionProviderWebsiteUrl}}" ng-if="::$ctrl.pension.PensionProviderWebsiteUrl" target="_blank">\n\t\t\t\t\t\t{{$ctrl.pension.PensionProviderName}}\'s website\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- PensionSync -->\n\t\t\t\t\t<a data-cy="pension-scheme-menu-visit-pension-sync" href="" ng-click="$ctrl.getURLRedirect($ctrl.pension.PensionSyncSmtUrl)" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.pensionSync">\n\t\t\t\t\t\tView in PensionSync\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- Unauthorised -->\n\t\t\t\t\t<div ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_STATES.unauthorised">\n\n\t\t\t\t\t\t<!-- NEST -->\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-nest" href="" ng-click="$ctrl.openAuthoriseNestForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.nest">\n\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- PensionSync -->\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-autorise-pension-sync" href="" ng-click="$ctrl.getURLRedirect($ctrl.pension.PensionSyncAuthUrl)" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.pensionSync">\n\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- Peoples -->\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-peoples-pension" href="" ng-click="$ctrl.openAuthorisePeoplesPensionForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.peoplesPension">\n\t\t\t\t\t\t\tAuthorise me\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- Smart -->\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-smart-pension" href="" ng-click="$ctrl.openAuthoriseSmartForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.smart">\n\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group" ng-if="::($root.currentUser.Permissions.Team.canUpdateTeamPensionSettings && $ctrl.pension.CanBeDeleted)">\n\t\t\t\t\t<a class="assertive" data-cy="pension-scheme-menu-delete-pension" href="" ng-click="$ctrl.openDeletePensionForm()">\n\t\t\t\t\t\tDelete pension\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t</dropdown-menu>\n\n\t\t</div>\n\t</div>\n\n\t<div class="pension-scheme-card_contents">\n\n\t\t<div class="pension-scheme-card_title">\n\t\t\t<h6 class="pension-scheme-card_provider">{{::$ctrl.pension.PensionProviderName}}</h6>\n\t\t</div>\n\n\t\t<div class="pension-scheme-card_details" ng-if="::!$ctrl.pension.IsGhostPension">\n\t\t\t<h6 class="pension-scheme-card_reference" ng-if="::$ctrl.pension.EmployerReference">\n\t\t\t\t{{::$ctrl.pension.EmployerReference}}\n\t\t\t</h6>\n\n\t\t\t<div class="pension-scheme-card_connection">\n\t\t\t\t<i class="icon-{{$ctrl.pension.ConnectToProvider ? \'submitted\' : \'wrench\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t<span>{{::$ctrl.pension.ConnectToProvider ? \'Direct\' : \'Manual\'}}</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="pension-scheme-card_description-container" ng-if="::$ctrl.pension.IsGhostPension || (!$ctrl.pension.IsGhostPension && $ctrl.pension.PensionDescription)">\n\t\t\t<p class="pension-scheme-card_description s" ng-if="::!$ctrl.pension.IsGhostPension && $ctrl.pension.PensionDescription">\n\t\t\t\t{{::$ctrl.pension.PensionDescription}}\n\t\t\t</p>\n\t\t\t<p class="pension-scheme-card_description s" ng-if="::$ctrl.pension.IsGhostPension">\n\t\t\t\tTeam members are regularly assessed\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="pension-scheme-card_stats">\n\t\t\t<div class="pension-scheme-card_stat">\n\t\t\t\t<i class="icon-team-alt m"></i> {{::$ctrl.pension.TotalInPension}}\n\t\t\t</div>\n\n\t\t\t<div class="pension-scheme-card_stat" ng-if="::!$ctrl.pension.IsGhostPension">\n\t\t\t\t<i class="icon-money m"></i> {{::$ctrl.pension.TotalContribution | monetise }}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/pension-scheme-detail/pension-scheme-detail.component.html','<div class="pension-scheme-detail fadeIn" ng-class="[\n\t\t$ctrl.theme,\n\t\t$ctrl.variant\n\t]">\n\t<div class="pension-scheme-detail_media">\n\t\t<div class="pension-scheme-detail_logo">\n\t\t\t<img alt="{{$ctrl.pension.PensionProviderName}}" class="pension-scheme-detail_image fadeIn" height="60" ng-if="$ctrl.pension.PensionProviderImageUrl !== \'\'" ng-src="../{{$ctrl.pension.PensionProviderImageUrl}}">\n\n\t\t\t<i ng-class="{\n\t\t\t\t\t\'secondary\' : $ctrl.PENSION_TYPES.autoEnrolment,\n\t\t\t\t\t\'primary\' : $ctrl.PENSION_TYPES.nonAutoEnrolment\n\t\t\t\t}" ng-if="$ctrl.pension.PensionProviderImageUrl === \'\'" class="icon-money xxl fadeIn"></i>\n\t\t</div>\n\t</div>\n\n\t<div class="pension-scheme-detail_content">\n\t\t<h6>{{$ctrl.pension.PensionProviderName}}</h6>\n\n\t\t<p class="is-small is-text-default is-greyscale-darkened fadeIn" ng-if="!$ctrl.pension.IsGhostPension && $ctrl.pension.EmployerReference">\n\t\t\t{{$ctrl.pension.EmployerReference}}\n\t\t</p>\n\n\t\t<p class="is-small is-text-default is-greyscale fadeIn" ng-if="$ctrl.showLabels && !$ctrl.pension.IsGhostPension">\n\t\t\t{{$ctrl.pension.PensionDescription | checkEmpty:\' \'}}\n\t\t</p>\n\t</div>\n\n\t<div class="pension-scheme-detail_status" ng-if="$ctrl.showStatus && $ctrl.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment">\n\t\t<pension-team-state pension-state="$ctrl.pension.PensionState"></pension-team-state>\n\t\t<span class="pension-scheme-detail_status-label" ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_ENROLMENT_STATES.enrolled">&nbsp;on {{$ctrl.pension.PensionEnrolledDateISO | dateformat}}</span>\n\t</div>\n\n\t<div class="pension-scheme-detail_status" ng-if="$ctrl.showStatus && $ctrl.pension.PensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t<span class="pension-scheme-detail_status-label" ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_ENROLMENT_STATES.rejoined">\n\t\t\tRejoined on {{$ctrl.pension.PensionRejoinedDateISO | dateformat}}\n\t\t</span>\n\t\t<span class="pension-scheme-detail_status-label" ng-if="($ctrl.pension.PensionState !== $ctrl.PENSION_ENROLMENT_STATES.rejoined) && $ctrl.pension.PensionJoinedDateISO">\n\t\t\tJoined on {{$ctrl.pension.PensionJoinedDateISO | dateformat}}\n\t\t</span>\n\t</div>\n\n\t<div class="pension-scheme-detail_action fadeIn" ng-if="$ctrl.hasAction" ng-transclude="action"></div>\n</div>\n');
$templateCache.put('components/pension-scheme-employer-reference-field/pension-scheme-employer-reference-field.component.html','<div class="form-field">\n\t<div class="form-field-header" ng-switch="$ctrl.pensionType">\n\t\t<label class="required" for="{{$ctrl.EMPLOYER_REFERENCE_FIELD_NAME}}" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\tEmployer pension scheme reference:\n\t\t</label>\n\t\t<label for="{{$ctrl.EMPLOYER_REFERENCE_FIELD_NAME}}" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\tPension scheme reference:\n\t\t</label>\n\t</div>\n\n\t<div class="form-field-main">\n\t\t<input class="m-alt" id="{{$ctrl.EMPLOYER_REFERENCE_FIELD_NAME}}" name="{{$ctrl.EMPLOYER_REFERENCE_FIELD_NAME}}" ng-model-options="{ debounce: 500 }" ng-model="$ctrl.employerReference" ng-required="$ctrl.pensionType === $ctrl.PENSION_TYPES.autoEnrolment" type="text">\n\t</div>\n\n\t<p class="form-message" ng-if="$ctrl.isNestPension && $ctrl.isValidationRequired">\n\t\t\'EMP\' followed by a series of numbers (e.g. EMP123456789).\n\t</p>\n\n\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.EMPLOYER_REFERENCE_FIELD_NAME].$touched" ng-messages="$ctrl.form[$ctrl.EMPLOYER_REFERENCE_FIELD_NAME].$error" role="alert">\n\t\t<p data-cy="pension-employer-reference-validation-required-message" ng-message="required">\n\t\t\tPlease enter employer pension scheme reference\n\t\t</p>\n\n\t\t<!-- Employer Reference Validation -->\n\t\t<div data-cy="pension-employer-reference-validation-service-message" ng-if="::$ctrl.isValidationRequired" ng-message="{{$ctrl.EMPLOYER_REFERENCE_VALIDATOR_NAME}}" ng-switch="$ctrl.pensionProviderId">\n\t\t\t<p data-cy="pension-employer-reference-validation-service-nest-message" pc-switch-when="$ctrl.PENSION_PROVIDER_IDS.nest">\n\t\t\t\tPlease enter a valid NEST employer pension scheme reference. It should look like this: \'EMP123456789\'\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/pension-scheme-group/pension-scheme-group.component.html','<div class="pension-scheme-group fadeIn" data-cy="pension-scheme-group-{{::$ctrl.index}}" ng-switch="$ctrl.pensionType">\n\n\t<a class="pension-scheme-group_delete greyscale-darkened fadeIn" data-cy="pension-scheme-group-delete" href="" ng-if="\n\t\t\t$ctrl.pensionGroups.length > 1 &&\n\t\t\t(\n\t\t\t\t$ctrl.pensionType === $ctrl.PENSION_TYPES.autoEnrolment ||\n\t\t\t\t$ctrl.pensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment && !$ctrl.group.IsDefault\n\t\t\t) &&\n\t\t\t$ctrl.group.CanBeDeleted\n\t\t" ng-click="$ctrl.onGroupDelete()">\n\t\t<i class="icon-trash"></i>\n\t\t<span class="hidden-phone">&nbsp;&nbsp;Delete</span>\n\t</a>\n\n\t<!-- Pension group name -->\n\t<div class="form-field">\n\t\t<header class="form-field-header">\n\t\t\t<label class="required" for="{{\'groupName-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdatePensionGroupName }" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\tGroup name:\n\t\t\t</label>\n\t\t\t<label class="required" for="{{\'groupName-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdatePensionGroupName }" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\tName:\n\t\t\t</label>\n\t\t</header>\n\t\t<div class="form-field-main">\n\t\t\t<input class="l-alt" id="{{\'groupName-\' + $ctrl.index}}" name="{{\'groupName-\' + $ctrl.index}}" ng-disabled="!$ctrl.group.CanUpdatePensionGroupName" ng-model-options="{allowInvalid:true}" ng-model="$ctrl.group.PensionGroupName" required autocomplete="off" type="text">\n\t\t</div>\n\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'groupName-\' + $ctrl.index].$error" ng-if="$ctrl.form[\'groupName-\' + $ctrl.index].$touched" role="alert">\n\t\t\t<p ng-message="required">Please enter a pension group name</p>\n\t\t\t<p ng-message="duplicate">A pension group with that name already exists</p>\n\t\t</div>\n\t\t<p class="form-message" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">Please enter the group name exactly as it appears on the pension provider\'s website.</p>\n\t\t<p class="form-message" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">E.g. department name, job role or other label for a group of team members</p>\n\t</div>\n\n\t<!-- Group contribution percentages -->\n\t<div class="form-field fadeIn">\n\t\t<header class="form-field-header">\n\t\t\t<label class="required" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdatePercentages }" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\tGroup contribution percentages:\n\t\t\t</label>\n\t\t\t<label class="required" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdatePercentages }" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\tContribution percentages:\n\t\t\t</label>\n\t\t</header>\n\t\t<div class="form-field-main">\n\t\t\t<div class="form-field-group">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<number-picker field-name="{{\'pensionEmployeePercent-\' + $ctrl.index}}" heading="% Employee" is-disabled="!$ctrl.group.CanUpdatePercentages" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="0" ng-model="$ctrl.group.EmployeePercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution"></number-picker>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'pensionEmployeePercent-\' + $ctrl.index].$error" ng-if="$ctrl.form[\'pensionEmployeePercent-\' + $ctrl.index].$dirty" role="alert">\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of 0%</p>\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<number-picker field-name="{{\'pensionEmployerPercent-\' + $ctrl.index}}" heading="% Employer" is-disabled="!$ctrl.group.CanUpdatePercentages" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="0" ng-model="$ctrl.group.EmployerPercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution"></number-picker>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'pensionEmployerPercent-\' + $ctrl.index].$error" ng-if="$ctrl.form[\'pensionEmployerPercent-\' + $ctrl.index].$dirty" role="alert">\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of 0%</p>\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<p class="form-message" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment"><strong>Note:</strong> these percentages will be applied to all employees in this group.</p>\n\t</div>\n\n\t<!-- Salary sacrifice? -->\n\t<div class="form-field">\n\t\t<header class="form-field-header">\n\t\t\t<label class="required" for="{{\'salary-sacrifice-true-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdateSalarySacrifice }" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\tIs this a salary sacrifice pension group?\n\t\t\t</label>\n\t\t\t<label class="required" for="{{\'salary-sacrifice-true-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdateSalarySacrifice }" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\tIs this a salary sacrifice contribution band?\n\t\t\t</label>\n\t\t</header>\n\t\t<div class="field">\n\t\t\t<div class="radio-list">\n\t\t\t\t<input class="b" id="{{\'salary-sacrifice-true-\' + $ctrl.index}}" name="{{\'salary-sacrifice-true-\' + $ctrl.index}}" ng-disabled="!$ctrl.group.CanUpdateSalarySacrifice" ng-model="$ctrl.group.IsSalarySacrifice" ng-value="true" type="radio">\n\t\t\t\t<label for="{{\'salary-sacrifice-true-\' + $ctrl.index}}">Yes</label>\n\n\t\t\t\t<input class="b" id="{{\'salary-sacrifice-false-\' + $ctrl.index}}" name="{{\'salary-sacrifice-false-\' + $ctrl.index}}" ng-disabled="!$ctrl.group.CanUpdateSalarySacrifice" ng-model="$ctrl.group.IsSalarySacrifice" ng-value="false" type="radio">\n\t\t\t\t<label for="{{\'salary-sacrifice-false-\' + $ctrl.index}}">No</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Has employers NI Saving -->\n\t<div class="form-field fadeIn" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment" ng-if="$ctrl.group.IsSalarySacrifice">\n\t\t<div class="form-field-main">\n\t\t\t<toggle-input field-disabled="!$ctrl.group.CanUpdateSalarySacrifice" field-label="Add percentage of Employer\'s NI Savings to employee contributions?" field-model="$ctrl.group.ApplyEmployerNISavings" field-name="{{\'applyEmployerNISavings-\' + $ctrl.index}}"></toggle-input>\n\t\t</div>\n\t</div>\n\n\t<!-- Employers NI Saving -->\n\t<div class="form-field-group fadeIn" ng-if="$ctrl.group.IsSalarySacrifice && $ctrl.group.ApplyEmployerNISavings">\n\t\t<div class="form-field fadeIn">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<number-picker field-name="{{\'employersNISavingsPercent-\' + $ctrl.index}}" heading="% of employers" is-disabled="!$ctrl.group.CanUpdateSalarySacrifice" is-editable="true" max="100" min="0" ng-model="$ctrl.group.EmployerNISavingsPercent" ng-pattern="$root.REGEX.decimalFourPlaces" step="10" sub-heading="NI savings"></number-picker>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'employersNISavingsPercent-\' + $ctrl.index].$error" ng-if="$ctrl.form[\'employersNISavingsPercent-\' + $ctrl.index].$dirty" role="alert">\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t<p ng-message="min">Minimum of 0%</p>\n\t\t\t\t<p ng-message="max">Maximum of 100%</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field"></div>\n\t</div>\n\n\t<!-- Contribution Basis -->\n\t<div class="form-field" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t<div class="form-field-header">\n\t\t\t<label for="{{\'contribution-basis-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdateContributionBasis }">Group contribution Basis:</label>\n\t\t</div>\n\t\t<div class="form-field-main">\n\t\t\t<select class="l-alt" id="{{\'contribution-basis-\' + $ctrl.index}}" name="{{\'contribution-basis-\' + $ctrl.index}}" ng-disabled="!$ctrl.group.CanUpdateContributionBasis" ng-model="$ctrl.group.ContributionBasis" ng-options="option.value as option.text for option in $ctrl.CONTRIBUTION_BASIS_OPTIONS"></select>\n\t\t</div>\n\t</div>\n\n\t<div class="form-field">\n\n\t\t<note note-title="Pensionable pay elements" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t<note-content>\n\n\t\t\t\t<!-- AE -->\n\t\t\t\t<p class="s" ng-if="$ctrl.pensionType === $ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t\tDepending on the contribution basis selected, you may wish to manage which pay elements are pensionable for this group. You can do so from the &lsquo;Manage pay elements&rsquo;\n\t\t\t\t\taction in the main page for this scheme.\n\t\t\t\t</p>\n\n\t\t\t\t<!-- Non AE -->\n\t\t\t\t<p class="s" ng-if="$ctrl.pensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\tTo manage which pay elements are pensionable for this band, you can use the &lsquo;Manage pay elements&rsquo; action in the main page for this scheme.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Default group -->\n\t<div class="form-field" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t<div class="form-field-main">\n\t\t\t<input checkbox id="{{\'is-default-\' + $ctrl.index}}" label-text="\'This is the default contribution band\'" name="{{\'is-default-\' + $ctrl.index}}" ng-change="$ctrl.onGroupIsDefaultChange($ctrl)" ng-disabled="$ctrl.pensionGroups.length === 1" ng-required="!$ctrl.group.pensionSchemeHasDefaultGroup" ng-model="$ctrl.group.IsDefault" type="checkbox">\n\t\t</div>\n\t</div>\n\n\t<!-- Disregard upper / lower earnings limits -->\n\t<div class="form-field" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment" ng-if="$ctrl.group.ContributionBasis === $ctrl.CONTRIBUTION_BASIS.qualifyingEarnings">\n\t\t<extended-checkbox disabled="!$ctrl.group.CanUpdateContributionBasis" has-border="false" name="{{\'pension-disregard-\' + $ctrl.index}}" ng-model="$ctrl.group.HasEarningsLimitDisregard" on-change="$ctrl.reviewPensionDisregard($ctrl.group)">\n\t\t\t<checkbox-label>\n\t\t\t\t<h6 class="is-medium is-greyscale-dark">Pension disregard</h6>\n\t\t\t\t<p class="is-small is-greyscale-darkened is-medium">Check this box if you wish to disregard the upper or lower earnings limit.</p>\n\t\t\t</checkbox-label>\n\n\t\t\t<checkbox-content>\n\n\t\t\t\t<!-- Earnings limit -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="{{\'earnings-limit-\' + $ctrl.index}}" ng-class="{ \'disabled\' : !$ctrl.group.CanUpdateContributionBasis }" class="required">Earnings limit:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<select class="l-alt" id="{{\'earnings-limit-\' + $ctrl.index}}" name="{{\'earnings-limit-\' + $ctrl.index}}" ng-disabled="!$ctrl.group.CanUpdateContributionBasis" ng-model="$ctrl.group.EarningsLimitDisregard" ng-options="option.value as option.description for option in $ctrl.PENSION_GROUP_EARNINGS_LIMIT_OPTIONS" required notzero></select>\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[\'earnings-limit-\' + $ctrl.index].$error" ng-if="$ctrl.form[\'earnings-limit-\' + $ctrl.index].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required || notzero">Please select an option</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</checkbox-content>\n\t\t</extended-checkbox>\n\t</div>\n\n</div>\n');
$templateCache.put('components/pension-scheme-header/pension-scheme-header.component.html','<div class="pension-scheme-header">\n\t<div class="pension-scheme-header_header">\n\t\t<div class="pension-scheme-header_media">\n\t\t\t<div class="pension-scheme-header_logo">\n\t\t\t\t<img alt="{{::$ctrl.pension.PensionProviderName}}" height="80" ng-if="::$ctrl.pension.PensionProviderImageUrl !== \'\'" ng-src="../{{::$ctrl.pension.PensionProviderImageUrl}}">\n\t\t\t\t<i class="icon-money primary xxl" ng-if="::$ctrl.pension.PensionProviderImageUrl === \'\'"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="pension-scheme-header_contents" ng-switch="$ctrl.pension.PensionType">\n\t\t<div class="pension-scheme-header_details">\n\t\t\t<div class="pension-scheme-header_provider">\n\t\t\t\t<h2>{{$ctrl.pension.PensionProviderName}}</h2>\n\n\t\t\t\t<div class="pension-scheme-header_states" ng-switch="$ctrl.pension.PensionType">\n\t\t\t\t\t<!-- AE -->\n\t\t\t\t\t<div class="pension-scheme-header_states-layout" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t\t<span class="tag is-primary">AE</span>\n\n\t\t\t\t\t\t<pension-scheme-state ng-if="::!$ctrl.pension.IsGhostPension" state="$ctrl.pension.PensionState"></pension-scheme-state>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Non-AE -->\n\t\t\t\t\t<div pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\t\t<span class="tag is-primary">Non-AE</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<p class="pension-scheme-header_detail" ng-if="!$ctrl.pension.IsGhostPension && $ctrl.pension.EmployerReference">\n\t\t\t\t<span>{{$ctrl.pension.EmployerReference}}</span>\n\t\t\t</p>\n\n\t\t\t<p class="pension-scheme-header_detail" ng-if="!$ctrl.pension.IsGhostPension && $ctrl.pension.PensionDescription">\n\t\t\t\t{{$ctrl.pension.PensionDescription}}\n\t\t\t</p>\n\n\t\t\t<p class="pension-scheme-header_detail" ng-if="$ctrl.pension.IsGhostPension">\n\t\t\t\tTeam members are regularly assessed\n\t\t\t</p>\n\n\t\t\t<div class="pension-scheme-header_connection">\n\t\t\t\t<div class="pension-scheme-header_stat" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t<i class="icon-calendar m pension-scheme-header_stat-icon"></i>\n\t\t\t\t\tStart date: {{$ctrl.pension.StagingDateISO | dateformat:\'monthYear\'}}\n\t\t\t\t</div>\n\n\t\t\t\t<div class="pension-scheme-header_stat" ng-if="!$ctrl.pension.IsGhostPension">\n\t\t\t\t\t<i class="m pension-scheme-header_stat-icon" ng-class="{\n\t\t\t\t\t\t\t\'icon-group\': !$ctrl.pension.UsePensionPolicy,\n\t\t\t\t\t\t\t\'icon-menu-alt\': $ctrl.pension.UsePensionPolicy\n\t\t\t\t\t\t}"></i>\n\t\t\t\t\t<ng-pluralize count="$ctrl.pension.PensionGroupCount" ng-if="!$ctrl.pension.UsePensionPolicy" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment" when="{\n\t\t\t\t\t\t\t\'1\': \'1 group\',\n\t\t\t\t\t\t\t\'other\': \'{} groups\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t<ng-pluralize count="$ctrl.pension.PensionPolicyBandCount" ng-if="$ctrl.pension.UsePensionPolicy" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment" when="{\'1\': \'1 policy band\', \'other\': \'{} policy bands\'}">\n\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t<ng-pluralize count="$ctrl.pension.PensionGroupCount" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment" when="{\'1\': \'1 contribution band\', \'other\': \'{} contribution bands\'}">\n\t\t\t\t\t</ng-pluralize>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="pension-scheme-header_stat" ng-if="!$ctrl.pension.IsGhostPension">\n\t\t\t\t\t<i class="icon-{{$ctrl.pension.ConnectToProvider ? \'submitted\' : \'wrench\'}} m pension-scheme-header_stat-icon"></i>\n\t\t\t\t\t{{$ctrl.pension.ConnectToProvider ? \'Direct\' : \'Manual\'}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="pension-scheme-header_actions">\n\t\t\t<div class="pension-scheme-header_menu">\n\t\t\t\t<dropdown-menu menu-icon="icon-setup" menu-id="pension-scheme-menu" menu-size="xl" menu-text="Actions" menu-theme="right greyscale">\n\t\t\t\t\t<div class="dropdown-group" ng-switch="$ctrl.pension.PensionProviderAPI">\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-add-team-members" href="" ng-click="$ctrl.openPensionTeamForm()">\n\t\t\t\t\t\t\tAdd team members\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-download-doc" href="" ng-href="{{$ctrl.pension.ReportPensionsDoCURL}}" ng-if="$ctrl.pension.ReportPensionsDoCURL" target="_blank">\n\t\t\t\t\t\t\tDownload Declaration of Compliance\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-go-to-provider-website" ng-href="{{$ctrl.pension.PensionProviderWebsiteUrl}}" ng-if="$ctrl.pension.PensionProviderWebsiteUrl" target="_blank">\n\t\t\t\t\t\t\t{{$ctrl.pension.PensionProviderName}} website\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- PensionSync -->\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-view-in-pensionsync" href="" ng-click="$ctrl.getURLRedirect($ctrl.pension.PensionSyncSmtUrl)" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.pensionSync">\n\t\t\t\t\t\t\tView in PensionSync\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- Unauthorised -->\n\t\t\t\t\t\t<div ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_STATES.unauthorised">\n\n\t\t\t\t\t\t\t<!-- NEST -->\n\t\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-nest" href="" ng-click="$ctrl.openAuthoriseNestForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.nest">\n\t\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<!-- PensionSync -->\n\t\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-pensionsync" href="" ng-click="$ctrl.getURLRedirect($ctrl.pension.PensionSyncAuthUrl)" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.pensionSync">\n\t\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<!-- Smart -->\n\t\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-smart" href="" ng-click="$ctrl.openAuthoriseSmartForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.smart">\n\t\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<!-- Peoples -->\n\t\t\t\t\t\t\t<a data-cy="pension-scheme-menu-authorise-peoples" href="" ng-click="$ctrl.openAuthorisePeoplesPensionForm()" pc-switch-when="$ctrl.PENSION_PROVIDER_APIS.peoplesPension">\n\t\t\t\t\t\t\t\tAuthorise\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-manage-pay-elements" href="" ng-click="$ctrl.openManagePayElementsPensionForm()">\n\t\t\t\t\t\t\tManage pay elements\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.Team.canUpdateTeamPensionSettings && $ctrl.pension.CanBeDeleted">\n\t\t\t\t\t\t<a data-cy="pension-scheme-menu-delete-pension" class="assertive" href="" ng-click="$ctrl.openDeletePensionForm()">\n\t\t\t\t\t\t\tDelete pension\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/pension-scheme-row/pension-scheme-row.component.html','<div class="pension-scheme-row" ng-class="\n\t{\n\t\t\'is-active\' : $ctrl.ngModel === $ctrl.pension.AgencyEmployerPensionID,\n\t\t\'is-disabled\' : $ctrl.fieldDisabled\n\t}">\n\t<div class="pension-scheme-row_icon" ng-if="$ctrl.pension.IsAdditionalPost">\n\t\t<icon-dot icon="icon-setup-user" is-light="true" theme="is-primary has-hover" tooltip-position="left" tooltip-text="{{$ctrl.pension.SalaryPolicyPostTitle}}"></icon-dot>\n\t</div>\n\n\t<div class="pension-scheme-row_content">\n\n\t\t<div class="pension-scheme-row_input">\n\t\t\t<input class="b" data-cy="pension-scheme-{{:: $ctrl.pensionIndex }}" id="{{$ctrl.fieldName + \'-\' + $ctrl.pension.AgencyEmployerPensionID}}" name="{{$ctrl.fieldName}}" ng-disabled="$ctrl.fieldDisabled" ng-model="$ctrl.ngModel" ng-required="$ctrl.fieldRequired" ng-value="$ctrl.pension.AgencyEmployerPensionID" type="radio">\n\t\t\t<label for="{{$ctrl.fieldName + \'-\' + $ctrl.pension.AgencyEmployerPensionID}}" class="pension-scheme-row_radio"></label>\n\t\t</div>\n\n\t\t<div class="pension-scheme-row_meta">\n\t\t\t<pension-scheme-detail pension="$ctrl.pension" show-labels="true" variant="is-media-borderless is-media-medium"></pension-scheme-detail>\n\t\t</div>\n\n\t\t<label for="{{$ctrl.fieldName + \'-\' + $ctrl.pension.AgencyEmployerPensionID}}" class="pension-scheme-row_label"></label>\n\t</div>\n\n\t<div class="pension-scheme-row_accordion fadeIn" ng-transclude="content" ng-if="$ctrl.hasContent && $ctrl.ngModel === $ctrl.pension.AgencyEmployerPensionID">\n\t</div>\n</div>\n');
$templateCache.put('components/pension-scheme-state/pension-scheme-state.component.html','<span class="tag" ng-class="[$ctrl.class, { \'border-white\': $ctrl.hasBorder }]">\n\t{{$ctrl.label}}\n</span>\n');
$templateCache.put('components/pension-team-group/pension-team-group.component.html','<div class="pension-team-group" ng-class="$ctrl.theme">\n\t<div class="pension-team-group_main">\n\t\t<p class="pension-team-group_item">\n\t\t\t<span class="pension-team-group_context">{{::$ctrl.formOptions.context.Forename}} ({{$ctrl.pensionGroup.EmployeePercent}}%)</span>\n\t\t\t<span class="pension-team-group_value">{{$ctrl.pensionGroup.EmployeeContribution | monetise}}</span>\n\t\t</p>\n\t\t<p class="pension-team-group_item">\n\t\t\t<span class="pension-team-group_context">{{::$ctrl.formOptions.company.Name}} ({{$ctrl.pensionGroup.EmployerPercent}}%)</span>\n\t\t\t<span class="pension-team-group_value">{{$ctrl.pensionGroup.EmployerContribution | monetise}}</span>\n\t\t</p>\n\t\t<p class="pension-team-group_item">\n\t\t\t<span class="pension-team-group_context">Total</span>\n\t\t\t<span class="pension-team-group_value">{{$ctrl.pensionGroup.EmployeeContribution + $ctrl.pensionGroup.EmployerContribution | monetise}}</span>\n\t\t</p>\n\t</div>\n\t<div class="pension-team-group_footer">\n\t\t<div class="pension-team-group_stats stat-list s basic greyscale">\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Salary sacrifice:</span>\n\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t{{$ctrl.pensionGroup.IsSalarySacrifice ? \'Yes\' : \'No\'}}\n\t\t\t\t\t<span ng-if="($ctrl.pensionGroup.HasEarningsLimitDisregard || $ctrl.pensionGroup.IsSalarySacrifice) && $ctrl.pensionGroup.ApplyEmployerNISavings && $ctrl.pensionGroup.EmployerNISavingsPercent">\n\t\t\t\t\t\t({{$ctrl.pensionGroup.EmployerNISavingsPercent}}% of Employer NI savings added to employee contribution)\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row" ng-if="$ctrl.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t<span class="stat-list__key">Contribution basis:</span>\n\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t{{$ctrl.pensionGroup.ContributionBasisDisplay}}\n\t\t\t\t\t<span ng-if="$ctrl.pensionGroup.HasEarningsLimitDisregard">\n\t\t\t\t\t\t({{$ctrl.pensionGroup.EarningsLimitDisregard | earningsLimitDisregardDescription}})\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/pension-team-state/pension-team-state.component.html','<span>\n\t<a class="tag {{$ctrl.styleClass}}" href="" ng-click="$ctrl.onClick()" ng-if="$ctrl.isClickable">\n\t\t{{$ctrl.pensionState}}\n\t</a>\n\t<span class="tag {{$ctrl.styleClass}}" ng-if="!$ctrl.isClickable">\n\t\t{{$ctrl.pensionState}}\n\t</span>\n</span>\n');
$templateCache.put('components/people-hr-updates-card/people-hr-updates-card.component.html','<div class="people-hr-updates-card fadeIn" ng-class="[$ctrl.cardTheme, {\'remove-hover-effect\': $ctrl.removeHoverEffect, \'is-selected\' : $ctrl.eventData.isSelected}]">\n\t<div class="people-hr-updates-card_main">\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="checkbox-input assertive people-hr-updates-card_main_checkbox" ng-if="$ctrl.bulkItems">\n\t\t\t<input aria-label="Select event" class="checkbox-input-field" data-cy="select-people-hr-update-{{$ctrl.index}}-checkbox" id="{{::$ctrl.eventId}}" ng-change="$ctrl.onCheckboxToggle()" ng-disabled="$ctrl.eventData.cannotBeSelected" ng-model="$ctrl.eventData.isSelected" type="checkbox">\n\t\t\t<label class="checkbox-input-label" for="{{::$ctrl.eventId}}"></label>\n\t\t</div>\n\n\t\t<div class="people-hr-updates-card_icon">\n\t\t\t<icon-dot icon="{{$ctrl.icon}}" is-light="$ctrl.status === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.new" theme="{{$ctrl.cardTheme}} is-larger">\n\t\t\t</icon-dot>\n\t\t</div>\n\n\t\t<div class="people-hr-updates-card_content">\n\t\t\t<div>\n\t\t\t\t<h6>{{$ctrl.cardTitle}}</h6>\n\t\t\t\t<p class="people-hr-updates-card_employee-id" data-cy="people-hr-updates-card-{{$ctrl.index}}-employee-id" ng-if="$ctrl.showEmployeeId && $ctrl.eventData.EmployeeID" tooltip tooltip-position="top-left" tooltip-text="{{$ctrl.employeeIdTooltip}}"><span class="people-hr-updates-card_employee-id-label">Employee ID</span>: {{$ctrl.employeeId}}</p>\n\t\t\t\t<p class="people-hr-updates-card_description">{{$ctrl.eventText}}</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<div class="people-hr-updates-card_warning" ng-if="$ctrl.showWarningIcon">\n\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="is-tertiary has-hover" tooltip-position="left" tooltip-text="Update warnings: {{$ctrl.errorMessage}}">\n\t\t\t\t\t\t</icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="people-hr-updates-card_action" ng-if="$ctrl.hideAction !== true">\n\t\t\t\t\t<dropdown-menu menu-icon="icon-setup" menu-show-chevron="false" menu-size="l" menu-theme="{{$ctrl.isStatusNew ? \'\' : $ctrl.cardTheme}}">\n\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openEventDataForm()">Review data</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</dropdown-menu>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\t<footer class="people-hr-updates-card_footer" ng-if="$ctrl.showFooter && !$ctrl.hideFooter">\n\t\t{{$ctrl.footerText}}\n\t</footer>\n\n</div>\n');
$templateCache.put('components/period-task-card/period-task-card.component.html','<div class="period-task-card fadeIn" ng-class="$ctrl.cardTheme">\n\t<div class="period-task-card_layout">\n\t\t<div class="period-task-card_checkbox-wrapper" tooltip tooltip-text="Mark as {{$ctrl.task.IsComplete ? \'incomplete\' : \'complete\'}}" tooltip-position="top-far-right">\n\t\t\t<input class="period-task-card_checkbox-default is-medium" type="checkbox" name="{{$ctrl.task.MessageID}}" id="{{$ctrl.task.MessageID}}" ng-model="$ctrl.task.IsComplete" ng-change="$ctrl.updateMessageStatus($ctrl)" ng-class="$ctrl.cardTheme">\n\n\t\t\t<label class="period-task-card_checkbox-new" for="{{$ctrl.task.MessageID}}">\n\t\t\t\t<i class="icon-check"></i>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class="period-task-card_main">\n\t\t\t<div class="period-task-card_header">\n\t\t\t\t<div class="period-task-card_persona" ng-if="::!$ctrl.showTaskCompany">\n\t\t\t\t\t<avatar class="period-task-card_avatar" avatar-initial="{{$ctrl.task.Recipient[0]}}" avatar-size="is-tiny" avatar-theme="{{$ctrl.cardTheme}}"></avatar>\n\n\t\t\t\t\t<h5 class="period-task-card_assignee">Assigned to {{$ctrl.task.Recipient}}</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="period-task-card_persona" ng-if="::$ctrl.showTaskCompany">\n\t\t\t\t\t<i class="period-task-card_icon icon-company"></i>\n\n\t\t\t\t\t<a href="" ui-sref="payroll.current-period.tasks({agencyProfileId: $ctrl.task.AgencyProfileID})" class="period-task-card_company">{{$ctrl.task.CompanyName}}</a>\n\t\t\t\t</div>\n\n\t\t\t\t<h6 class="period-task-card_date" ng-if="::$ctrl.task.DateDueISO">\n\t\t\t\t\t<i class="icon-clock n"></i>&nbsp;&nbsp;\n\t\t\t\t\t<span class="strong">\n\t\t\t\t\t\t{{$ctrl.task.IsOverdue ? \'Overdue\' : \'Due\'}}:\n\t\t\t\t\t</span>\n\t\t\t\t\t&nbsp;{{$ctrl.task.DateDueISO | dateformat:\'dateTime\'}}\n\t\t\t\t</h6>\n\t\t\t</div>\n\n\t\t\t<div class="period-task-card_content">\n\t\t\t\t<p class="period-task-card_paragraph" ng-bind-html="$ctrl.task.Text | emojify"></p>\n\t\t\t</div>\n\n\t\t\t<div class="period-task-card_files file-card_wrapper rows" ng-if="::$ctrl.task.DocumentList.length > 0">\n\t\t\t\t<file-card agency-profile-id="$ctrl.task.AgencyProfileID" pay-period-id="$ctrl.agencyPayPeriodId" file="file" file-theme="{{$ctrl.cardTheme}}" has-upload-to-importer="true" has-download="true" ng-repeat="file in $ctrl.task.DocumentList"></file-card>\n\t\t\t</div>\n\n\t\t\t<div class="period-task-card_footer">\n\t\t\t\t<p class="period-task-card_footer-copy" ng-if="::$ctrl.showTaskCompany">\n\t\t\t\t\t<i class="period-task-card_period icon-calendar"></i> &nbsp;&nbsp;{{$ctrl.task.PayPeriod}}\n\t\t\t\t</p>\n\n\t\t\t\t<div class="period-task-card_footer-split" ng-if="::$ctrl.showTaskCompany"></div>\n\n\t\t\t\t<p class="period-task-card_footer-copy">\n\t\t\t\t\tAdded by {{$ctrl.task.Sender}} at {{$ctrl.task.DateSentISO | dateformat:\'timeDate\'}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="period-task-card_menu">\n\t\t\t<dropdown-menu menu-icon="period-task-card_cog icon-setup" menu-show-chevron="false">\n\n\t\t\t\t<div class="dropdown-group" ng-if="!$ctrl.task.IsComplete">\n\t\t\t\t\t<a href="" ng-click="$ctrl.openEditPeriodTaskForm($ctrl.task, true)">Re-assign</a>\n\t\t\t\t\t<a href="" ng-click="$ctrl.openEditPeriodTaskForm($ctrl.task, false)">Edit</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeletePeriodTaskForm($ctrl.task)">Delete</a>\n\t\t\t\t</div>\n\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/permissions-selector/permissions-selector.component.html','<div class="permissions-selector" ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div class="fadeIn" ng-switch-when="loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Permission Groups -->\n\t<div ng-switch-when="ready">\n\t\t<div class="permissions-selector_group fadeIn" ng-repeat="permissionGroup in $ctrl.filteredGroups = ( $ctrl.roleDetail.Groups | rolePermissions : $ctrl.roleDetail.RoleType | orderBy:\'GroupName\' )">\n\n\t\t\t<div class="permissions-selector_header">\n\t\t\t\t<a class="permissions-selector_toggle" data-cy="permission-group-{{ ::permissionGroup.GroupName | slugify }}-toggle-accordion-action" href="" ng-click="$ctrl.toggleShowPermissionGroup(permissionGroup)" ng-class="{\'is-open\' : permissionGroup.showGroup, \'has-children\' : permissionGroup.GroupPermissionActions.length > 0 && $ctrl.filteredGroups.length > 1 }">\n\t\t\t\t\t<h5 class="permissions-selector_title">{{permissionGroup.GroupName}}<span data-cy="permission-group-{{ ::permissionGroup.GroupName | slugify }}-total-active-count" ng-if="permissionGroup.GroupPermissionActions.length > 0">&nbsp;({{permissionGroup.groupTotalActive}})</span></h5>\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Visible switch -->\n\t\t\t\t<div class="permissions-selector_action toggle-control fadeIn" ng-if="permissionGroup.showVisibilityToggleFor.includes($ctrl.roleDetail.RoleType) && $ctrl.filteredGroups.length > 1">\n\t\t\t\t\t<span class="toggle-control-label" ng-class="{\'active\': permissionGroup.GroupVisible}"><i class="icon-visible toggle-control-icon"></i> Visible</span>\n\t\t\t\t\t<a data-cy="permission-group-{{ ::permissionGroup.GroupName | slugify }}-toggle-visibility-action" href="" ng-click="$ctrl.togglePermissionGroupVisibility($ctrl, permissionGroup)" class="toggle-a s toggle-control-toggle {{!permissionGroup.GroupVisible ? \'active tertiary\': \'primary\'}}"></a>\n\t\t\t\t\t<span class="toggle-control-label" ng-class="{\'active tertiary\': !permissionGroup.GroupVisible}"><i class="icon-hidden toggle-control-icon"></i> Hidden</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="permissions-selector_cards fadeIn" ng-show="permissionGroup.showGroup || $ctrl.filteredGroups.length === 1" ng-if="permissionGroup.GroupPermissionActions.length">\n\n\t\t\t\t<!-- Permissions -->\n\t\t\t\t<button type="button" data-cy="permission-group-{{ ::permissionGroup.GroupName | slugify }}-permission-{{ ::permission.Description | slugify}}" class="is-clear permissions-selector_card" ng-click="$ctrl.togglePermission($ctrl, permission, permissionGroup)" ng-repeat="permission in permissionGroup.GroupPermissionActions" ng-class="{\'is-active quarternary\': permissionGroup.GroupVisible && permission.IsActive, \'is-disabled\': !permissionGroup.GroupVisible || permission.isLocked, \'is-locked\' : permission.isLocked }" title="{{permission.Description}}">\n\t\t\t\t\t<div class="permissions-selector_card-icon">\n\t\t\t\t\t\t<i class="icon-{{permission.isLocked ? \'padlock\' : !permissionGroup.GroupVisible ? \'hidden\' : permission.IsActive ? \'check\' : \'menu-close\'}}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="permissions-selector_card-description">\n\t\t\t\t\t\t<h6 class="permissions-selector_card-heading" title="{{::permission.Description}}">\n\t\t\t\t\t\t\t{{::permission.Description}}\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="fadeIn" ng-if="!$ctrl.isValid">\n\t\t\t<p class="is-small assertive">At least one permission has to be enabled for the "{{$ctrl.roleDetail.roleName}}" role.</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Error -->\n\t<div class="fadeIn" ng-switch-when="error">\n\t\t<error-block></error-block>\n\t</div>\n</div>\n');
$templateCache.put('components/placeholder/placeholder.component.html','<div class="placeholder fadeIn" ng-class="[$ctrl.placeholderLayout]">\n\t<div class="placeholder-content">\n\t\t<div class="placeholder-content-wrapper">\n\t\t\t<img alt="" class="placeholder-graphic {{$ctrl.placeholderGraphicSize}}" ng-if="::$ctrl.hasGraphic" src="images/graphics/placeholders/{{$ctrl.placeholderGraphic}}.2x.png">\n\t\t\t<div class="placeholder-info-wrapper">\n\t\t\t\t<h4 class="placeholder-title" ng-transclude="title" ng-if="::$ctrl.hasTitle"></h4>\n\t\t\t\t<div class="placeholder-copy" ng-transclude="copy" ng-if="::$ctrl.hasCopy"></div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="placeholder-secondary-actions" ng-transclude="secondaryActions" ng-if="::$ctrl.hasSecondaryActions"></div>\n\t\t<div class="placeholder-primary-actions" ng-transclude="primaryActions" ng-if="::$ctrl.hasPrimaryActions"></div>\n\t</div>\n</div>\n');
$templateCache.put('components/playground-action-box/playgroundActionBoxComponent.html','<section class="playground-information">\n\n\t<!-- Message Box -->\n\t<div class="intro-message-box" id="intro-message-box" ng-if="isPlaygroundModalVisible">\n\n\t\t<!-- Overlay -->\n\t\t<div class="intro-message-box-overlay"></div>\n\n\t\t<!-- Modal -->\n\t\t<div class="intro-message-box-modal fadeIn">\n\t\t\t<header class="intro-message-box-header">\n\t\t\t\t<h2 class="intro-message-box-title">Hi {{loggedInUser.UserResponseFirstName}}</h2>\n\t\t\t\t<h4 class="intro-message-box-subtitle tertiary">Welcome to your playground</h4>\n\t\t\t</header>\n\t\t\t<main class="intro-message-box-main">\n\t\t\t\t<p>\n\t\t\t\t\tWe\'ve populated your playground with a sample company running payroll with a workplace pension connected.\n\t\t\t\t\tAs this is a playground, you may find that some functionality has been disabled but it will, of course, be available in your live account!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tIf you need help or have any feedback while you\'re having a play,\n\t\t\t\t\t contact us on live chat.\n\t\t\t\t</p>\n\t\t\t</main>\n\t\t\t<footer class="intro-message-box-footer">\n\t\t\t\t<a class="button tertiary intro-message-box-primary-action" href="" id="intro-message-box_primary-action" ng-click="startPlaying()">\n\t\t\t\t\tStart playing\n\t\t\t\t</a>\n\t\t\t\t<a href="" class="greyscale intro-message-box-secondary-action" ng-click="switchToLive()">\n\t\t\t\t\tGo to your live account <i class="icon-chevron-right"></i>\n\t\t\t\t</a>\n\t\t\t</footer>\n\t\t</div>\n\t</div>\n\n\t<!-- Action Box -->\n\t<div class="playground-action-box riseIn" ng-class="{\n\t\t\t\'is-closed\': isPlaygroundActionBoxOpen\n\t\t}" ng-if="isPlaygroundActionBoxVisible">\n\t\t<button class="is-clear is-block playground-action-box-toggle clickable" ng-click="togglePlaygroundActionBox()" type="button">\n\t\t\t<p class="playground-action-box-toggle-paragraph">You\'re viewing your playground</p>\n\t\t\t<i class="playground-action-box-toggle-icon m" ng-class="{\n\t\t\t\t\t\'icon-chevron-up\': isPlaygroundActionBoxOpen,\n\t\t\t\t\t\'icon-chevron-down\': !isPlaygroundActionBoxOpen\n\t\t\t\t}"></i>\n\t\t</button>\n\n\t\t<main class="playground-action-box-main">\n\t\t\t<div class="playground-action-box-main-paragraph">\n\t\t\t\t<p>Need help? Got feedback? Chat to us</p>\n\t\t\t</div>\n\t\t\t<div class="playground-action-box-primary-action">\n\t\t\t\t<button class="is-tertiary is-tiny" ng-click="switchToLive()" type="button">\n\t\t\t\t\tGo to live <i class="icon-chevron-right button_icon-post"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</main>\n\t</div>\n</section>\n');
$templateCache.put('components/policy-band-card/policy-band-card.component.html','<!-- Parental policy band card -->\n<div class="policy-band-card" ng-class="{\n\t\t\'is-highlighted\': $ctrl.isHighlighted,\n\t\t\'is-selectable\': $ctrl.isSelectable\n\t}" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.parental">\n\t<div class="policy-band-card_header">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}\n\t</div>\n\n\t<div class="policy-band-card_info three-items">\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Duration</div>\n\t\t\t<div class="policy-band-card_info-item-value">\n\t\t\t\t<ng-pluralize count="$ctrl.policyBand.PolicyBandDuration" when="{ \'1\': \'1 week\', \'other\': \'{} weeks\'}">\n\t\t\t\t</ng-pluralize>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item">\n\n\t\t\t<div class="policy-band-card_info-item-name" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.maternity">SMP</div>\n\t\t\t<div class="policy-band-card_info-item-name" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.paternity">SPP</div>\n\t\t\t<div class="policy-band-card_info-item-value">\n\t\t\t\t{{$ctrl.policyBand.PolicyBandStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.included ? \'Included\' : \'Additional\'}}\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Pay</div>\n\t\t\t<div class="policy-band-card_info-item-value">\n\t\t\t\t<span ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.fixedAmount">\n\t\t\t\t\t{{$ctrl.policyBand.PolicyBandPayAmount | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="[$ctrl.POLICY_PAY_BASES.averageWeeklyPercent, $ctrl.POLICY_PAY_BASES.annualSalaryPercent].includes($ctrl.policy.PolicyPayBasis)">\n\t\t\t\t\t{{$ctrl.policyBand.PolicyBandPayAmount}}%\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="$ctrl.policyBand.PolicyBandStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && $ctrl.policyBand.PolicyBandPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPay">\n\t\t\t\t\t(capped)\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="$ctrl.policyBand.PolicyBandStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && $ctrl.policyBand.PolicyBandPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPayCombined">\n\t\t\t\t\t(combined capped)\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Pay policy band card -->\n<div class="policy-band-card" ng-class="{\n\t\t\'is-highlighted\': $ctrl.isHighlighted,\n\t\t\'is-selectable\': $ctrl.isSelectable\n\t}" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay">\n\n\t<div class="policy-band-card_header">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}\n\t</div>\n\n\t<div class="policy-band-card_info two-items">\n\t\t<div class="policy-band-card_info-item" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualSalary">\n\t\t\t<div class="policy-band-card_info-item-name">Annual salary</div>\n\t\t\t<div class="policy-band-card_info-item-value">{{$ctrl.policyBand.PolicyBandAnnualSalary | formatDecimal : $ctrl.config.precision.salaryRates: true: true}}</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualSalary">\n\t\t\t<div class="policy-band-card_info-item-name">Hourly rate</div>\n\t\t\t<div class="policy-band-card_info-item-value">{{$ctrl.policyBand.PolicyBandHourlyRate | formatDecimal : $ctrl.config.precision.salaryRates: false: true}}</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualAllowance">\n\t\t\t<div class="policy-band-card_info-item-name">Annual allowance</div>\n\t\t\t<div class="policy-band-card_info-item-value">{{$ctrl.policyBand.PolicyBandAnnualAllowance | formatDecimal : $ctrl.config.precision.salaryRates: true: true}}</div>\n\t\t</div>\n\t</div>\n\n</div>\n\n<!-- Pension policy band card -->\n<div class="policy-band-card" ng-class="{\n\t\t\'is-highlighted\': $ctrl.isHighlighted,\n\t\t\'is-selectable\': $ctrl.isSelectable\n\t}" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pension">\n\t<div class="policy-band-card_header" ng-if="$ctrl.policyBand.PolicyBandValueTo !== -1">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}&nbsp;-&nbsp;{{$ctrl.policyBand.PolicyBandValueFrom | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}\n\t\t<i class="icon-arrow-right policy-band-card_header-range-separator primary s"></i>&nbsp;{{$ctrl.policyBand.PolicyBandValueTo | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}\n\t</div>\n\n\t<div class="policy-band-card_header" ng-if="$ctrl.policyBand.PolicyBandValueTo === -1">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}&nbsp;-&nbsp;{{$ctrl.policyBand.PolicyBandValueFrom | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}&nbsp;and above\n\t</div>\n\n\t<div class="policy-band-card_info two-items">\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Employee contribution</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="$ctrl.policy.PolicyBandRateTypeEmployee === $ctrl.POLICY_BAND_RATE_TYPES.percentage">{{$ctrl.policyBand.PolicyBandEmployeeAmount}}%</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="$ctrl.policy.PolicyBandRateTypeEmployee === $ctrl.POLICY_BAND_RATE_TYPES.fixedValue">{{$ctrl.policyBand.PolicyBandEmployeeAmount | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Employer contribution</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="$ctrl.policy.PolicyBandRateTypeEmployer === $ctrl.POLICY_BAND_RATE_TYPES.percentage">{{$ctrl.policyBand.PolicyBandEmployerAmount}}%</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="$ctrl.policy.PolicyBandRateTypeEmployer === $ctrl.POLICY_BAND_RATE_TYPES.fixedValue">{{$ctrl.policyBand.PolicyBandEmployerAmount | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}</div>\n\t\t</div>\n\t</div>\n\n</div>\n\n<!-- Sickness policy band card -->\n<div class="policy-band-card" ng-class="{\n\t\t\'is-highlighted\': $ctrl.isHighlighted,\n\t\t\'is-selectable\': $ctrl.isSelectable\n\t}" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.sickness">\n\t<div class="policy-band-card_header" ng-if="$ctrl.policyBand.PolicyBandValueTo !== -1 && $ctrl.policy.baseBandsOnLengthOfService">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}&nbsp;-&nbsp;{{$ctrl.policyBand.PolicyBandValueFrom }}\n\t\t<i class="icon-arrow-right policy-band-card_header-range-separator primary s"></i>&nbsp;{{$ctrl.policyBand.PolicyBandValueTo}}&nbsp;months service\n\t</div>\n\n\t<div class="policy-band-card_header" ng-if="$ctrl.policyBand.PolicyBandValueTo === -1 && $ctrl.policy.baseBandsOnLengthOfService">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}&nbsp;-&nbsp;{{$ctrl.policyBand.PolicyBandValueFrom}}&nbsp;months service and above\n\t</div>\n\n\t<div class="policy-band-card_header" ng-if="!$ctrl.policy.baseBandsOnLengthOfService">\n\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.policyBand.PolicyBandName}}\n\t</div>\n\n\t<div class="policy-band-card_info three-items" ng-repeat="policyBandEntitlementPeriod in $ctrl.policyBand.PolicyBandEntitlementPeriods | filter : { \'PolicyBandEntitlementPeriodDelete\': \'false\' }">\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Entitlement</div>\n\t\t\t<div class="policy-band-card_info-item-value">\n\t\t\t\t<ng-pluralize count="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodItemDuration" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">SSP</div>\n\t\t\t<div class="policy-band-card_info-item-value">\n\t\t\t\t{{policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.included ? \'Included\' : \'Additional\'}}\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="policy-band-card_info-item">\n\t\t\t<div class="policy-band-card_info-item-name">Pay</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="[$ctrl.POLICY_PAY_BASES.averageWeeklyPercent, $ctrl.POLICY_PAY_BASES.annualSalaryPercent].includes($ctrl.policy.PolicyPayBasis)">\n\t\t\t\t{{policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayPercentage}}%&nbsp;\n\t\t\t\t<span ng-if="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPay">\n\t\t\t\t\t(capped)\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPayCombined">\n\t\t\t\t\t(combined capped)\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="policy-band-card_info-item-value" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.fixedAmount">\n\t\t\t\t{{policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayAmount | formatDecimal: $ctrl.config.precision.salaryRates: true: true}}&nbsp;\n\t\t\t\t<span ng-if="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPay">\n\t\t\t\t\t(capped)\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional && policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayLimit === $ctrl.POLICY_BAND_PAY_LIMIT_TYPES.fullPayCombined">\n\t\t\t\t\t(combined capped)\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/policy-band-form-field/policy-band-form-field.component.html','<div class="policy-band-form-field">\n\n\t<div class="policy-band-form-field_header">\n\t\t<div class="policy-band-form-field_header-title">\n\t\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.utilities.toSentenceCase($ctrl.policy.policyBandDescription)}}&nbsp;{{$ctrl.index + 1}}\n\t\t</div>\n\t\t<div class="policy-band-form-field_header-action" ng-if="$ctrl.showActions && $ctrl.componentState === $ctrl.COMPONENT_STATES.edit">\n\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeletePolicyBand($ctrl, $ctrl.policyBand)" class="is-primary-light" data-cy="delete-policy-band">\n\t\t\t\t<i class="icon-trash"></i>&nbsp;Delete\n\t\t\t</a>\n\t\t</div>\n\t</div>\n\n\t<!-- Form fields specific to policy type -->\n\t<!-- Pay -->\n\t<div class="policy-band-form-field_main" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay">\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field salary-policy-form-field_name">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandNameFormFieldId}}">Name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="{{$ctrl.policyBandNameFormFieldId}}" name="{{$ctrl.policyBandNameFormFieldId}}" ng-change="$ctrl.onPolicyBandNameChange($ctrl.form, $ctrl.policy)" ng-class="{ \'is-read-only\' : !$ctrl.allowNameEdit }" ng-model="$ctrl.policyBand.PolicyBandName" ng-readonly="!$ctrl.allowNameEdit" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandNameFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandNameFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a name</p>\n\t\t\t\t\t<p ng-message="nonUnique">Please enter a unique name</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualSalary">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandAnnualSalaryFormFieldId}}">Annual salary:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise" type="number" id="{{$ctrl.policyBandAnnualSalaryFormFieldId}}" name="{{$ctrl.policyBandAnnualSalaryFormFieldId}}" ng-change="$ctrl.onPayPolicyBandAnnualSalaryChange($ctrl.policy, $ctrl.policyBand)" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-min="$ctrl.config.numberMin" ng-model="$ctrl.policyBand.PolicyBandAnnualSalary" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandAnnualSalaryFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandAnnualSalaryFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of &pound;{{$ctrl.config.occupationalPoliciesMaxSalary | number:4}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.config.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" ng-if="$ctrl.upliftPreview">Up from: {{$ctrl.policyBand.OriginalPolicyBandAnnualSalary | monetise: 4}}</p>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualSalary">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandHourlyRateFormFieldId}}">Hourly rate:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise is-read-only" type="number" id="{{$ctrl.policyBandHourlyRateFormFieldId}}" name="{{$ctrl.policyBandHourlyRateFormFieldId}}" ng-model="$ctrl.policyBand.PolicyBandHourlyRate" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandHourlyRateFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandHourlyRateFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" ng-if="$ctrl.upliftPreview">Up from: {{$ctrl.policyBand.OriginalPolicyBandHourlyRate | monetise: 4}}</p>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandAnnualAllowanceFormFieldId}}">Annual allowance:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise" type="number" id="{{$ctrl.policyBandAnnualAllowanceFormFieldId}}" name="{{$ctrl.policyBandAnnualAllowanceFormFieldId}}" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-min="$ctrl.config.numberMin" ng-model="$ctrl.policyBand.PolicyBandAnnualAllowance" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandAnnualAllowanceFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandAnnualAllowanceFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of &pound;{{$ctrl.config.occupationalPoliciesMaxSalary | number:4}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.config.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" ng-if="$ctrl.upliftPreview">Up from: {{$ctrl.policyBand.OriginalPolicyBandAnnualAllowance | monetise: 4}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- View dependent team members - only applicable to pay policy bands -->\n\t<div class="policy-band-form-field_footer" ng-if="$ctrl.policyBand.TeamMembers.length === 0 && $ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay">\n\t\t<p class="s is-primary-light italic">{{$ctrl.utilities.toSentenceCase($ctrl.policy.policyBandDescription)}} not in use</p>\n\t</div>\n\t<div class="policy-band-form-field_footer" ng-if="$ctrl.policyBand.TeamMembers.length !== 0">\n\t\t<a href="" ng-click="$ctrl.viewTeamMembers($ctrl)">\n\t\t\t<p class="s strong is-pimary">\n\t\t\t\t<i class="icon-chevron-left s"></i>&nbsp;View\n\t\t\t\t<ng-pluralize count="$ctrl.policyBand.TeamMembers.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize> using pay point\n\t\t\t</p>\n\t\t</a>\n\t</div>\n\n\t<!-- Parental -->\n\t<div class="policy-band-form-field_main" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.parental">\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandDurationFormFieldId}}">Duration (wks)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<number-selector-field field-name="{{$ctrl.policyBandDurationFormFieldId}}" ng-model="$ctrl.policyBand.PolicyBandDuration"></number-selector-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-if="[$ctrl.POLICY_PAY_BASES.averageWeeklyPercent, $ctrl.POLICY_PAY_BASES.annualSalaryPercent].includes($ctrl.policy.PolicyPayBasis)">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandPayFormFieldId}}">Pay (%)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="percentage s" id="{{$ctrl.policyBandPayFormFieldId}}" name="{{$ctrl.policyBandPayFormFieldId}}" ng-max="100" ng-min="0" ng-model="$ctrl.policyBand.PolicyBandPayAmount" ng-pattern="$root.REGEX.decimalFourPlaces" required step="0.25" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandPayFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandPayFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="max">Please enter no more than 100%</p>\n\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t<p ng-message="required">Please enter the pay percentage</p>\n\t\t\t\t\t<p ng-message="step">Please enter multiples of 0.25</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.fixedAmount">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandPayFormFieldId}}">Pay (\xA3)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="policy-band-form-field_input" id="{{$ctrl.policyBandPayFormFieldId}}" name="{{$ctrl.policyBandPayFormFieldId}}" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-min="0" ng-model="$ctrl.policyBand.PolicyBandPayAmount" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandPayFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandPayFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="max">The maximum value is {{$ctrl.config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t<p ng-message="required">Please enter the pay amount</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t<div class="policy-band-form-field_options">\n\t\t\t<div class="policy-band-form-field_options-stat-pay">\n\t\t\t\t<label for="{{$ctrl.policyBandStatPayIncludedFormFieldId}}" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.maternity">SMP:&nbsp;&nbsp;</label>\n\t\t\t\t<label for="{{$ctrl.policyBandStatPayIncludedFormFieldId}}" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.paternity">SPP:&nbsp;&nbsp;</label>\n\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t<input class="b" id="{{$ctrl.policyBandStatPayIncludedFormFieldId}}" name="{{$ctrl.policyBandStatPayGroupId}}" ng-model="$ctrl.policyBand.PolicyBandStatutoryPay" ng-value="$ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.included" required type="radio">\n\t\t\t\t\t<label for="{{$ctrl.policyBandStatPayIncludedFormFieldId}}">Included</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t<input class="b" id="{{$ctrl.policyBandStatPayAdditionalFormFieldId}}" name="{{$ctrl.policyBandStatPayGroupId}}" ng-model="$ctrl.policyBand.PolicyBandStatutoryPay" ng-value="$ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional" required type="radio">\n\t\t\t\t\t<label for="{{$ctrl.policyBandStatPayAdditionalFormFieldId}}">Additional</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t\t<div class="policy-band-form-field_options fadeIn" ng-if="$ctrl.policyBand.PolicyBandStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="{{$ctrl.policyBandPayLimitFormFieldId}}">Pay cap:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select aria-label="Pay limit type" data-cy="policy-band-pay-limit-select" id="{{$ctrl.policyBandPayLimitFormFieldId}}" name="{{$ctrl.policyBandPayLimitFormFieldId}}" ng-model="$ctrl.policyBand.PolicyBandPayLimit" ng-options="option.value as option.label for option in $ctrl.POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t</div>\n\n\t<!-- Pension -->\n\t<div class="policy-band-form-field_main" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pension">\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandValueFromFormFieldId}}" ng-switch="$ctrl.policy.PolicyBandCalculation">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod">\n\t\t\t\t\t\t\tPensionable pay for period:\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod">\n\t\t\t\t\t\t\tAnnualised pensionable pay for period:\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\t\t\t\tFull-time equivalent salary:\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t\t\t\t\tActual pensionable pay:\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-band-form-field_range">\n\t\t\t\t\t<div class="policy-band-form-field_range-values">\n\t\t\t\t\t\t<!-- \'from\' field is fixed, so no pattern and no validation -->\n\t\t\t\t\t\t<div class="policy-band-form-field_range-value">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<!-- Fixed value is 1p above \'to\' field of previous band -->\n\t\t\t\t\t\t\t\t<input class="policy-band-form-field_input is-read-only" type="number" id="{{$ctrl.policyBandValueFromFormFieldId}}" name="{{$ctrl.policyBandValueFromFormFieldId}}" ng-disabled="true" ng-value="($ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + .01 : 0)\n\t\t\t\t\t\t\t\t\t\t | formatDecimal: $ctrl.config.precision.salaryRates: true">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="policy-band-form-field_range-separator" ng-if="!$ctrl.policyBand.isUpperRangeInfinite">\n\t\t\t\t\t\t\t<i class="icon-arrow-right primary m"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="policy-band-form-field_range-value" ng-if="!$ctrl.policyBand.isUpperRangeInfinite">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input class="policy-band-form-field_input" type="number" id="{{$ctrl.policyBandValueToFormFieldId}}" name="{{$ctrl.policyBandValueToFormFieldId}}" ng-class="{ \'is-hidden\' : $ctrl.policyBand.isUpperRangeInfinite }" ng-model="$ctrl.policyBand.PolicyBandValueTo" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-min="$ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + .02 : .01" required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.policyBandValueToFormFieldId].$error" ng-show="$ctrl.form[$ctrl.policyBandValueToFormFieldId].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">The maximum value is {{$ctrl.config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a value greater than {{$ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + .01 : 0}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-band-form-field_range-toggle" ng-if="$ctrl.policyBand.isLast">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<toggle-input field-label="and above" field-model="$ctrl.policyBand.isUpperRangeInfinite" field-name="{{$ctrl.policyBandIsUpperRangeInfiniteFieldId}}" field-on-change="$ctrl.onIsUpperRangeInfiniteChange($ctrl.policyBand)"></toggle-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- EE / ER Contributions - percentage -->\n\t\t<div class="form-field-group" ng-if="$ctrl.policy.PolicyBandRateTypeEmployer === $ctrl.POLICY_BAND_RATE_TYPES.percentage">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandEmployeeContributionFormFieldId}}">Employee contribution (%)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<number-selector-field field-name="{{$ctrl.policyBandEmployeeContributionFormFieldId}}" ng-model="$ctrl.policyBand.PolicyBandEmployeeAmount" ng-regex-key="decimalFourPlaces"></number-selector-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandEmployeeContributionFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandEmployeeContributionFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t<p ng-message="required">Please enter the employee contribution</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandEmployerContributionFormFieldId}}">Employer contribution (%)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<number-selector-field field-name="{{$ctrl.policyBandEmployerContributionFormFieldId}}" ng-if="!$ctrl.policy.useSameEmployerContributionRateForAllBands" ng-model="$ctrl.policyBand.PolicyBandEmployerAmount" ng-regex-key="decimalFourPlaces"></number-selector-field>\n\t\t\t\t\t<!-- Fixed when \'use same ER contribution for all bands is selected -->\n\t\t\t\t\t<input class="policy-band-form-field_input is-read-only" ng-disabled="true" ng-if="$ctrl.policy.useSameEmployerContributionRateForAllBands" ng-model="$ctrl.policyBand.PolicyBandEmployerAmount" ng-value="$ctrl.policy.fixedEmployerContribution" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandEmployerContributionFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandEmployerContributionFormFieldId].$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t<p ng-message="required">Please enter the employer contribution</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- EE / ER Contributions - fixed values -->\n\t\t<div class="form-field-group" ng-if="$ctrl.policy.PolicyBandRateTypeEmployer === $ctrl.POLICY_BAND_RATE_TYPES.fixedValue">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandEmployeeContributionFormFieldId}}">Employee contribution (\xA3)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="policy-band-form-field_input" id="{{$ctrl.policyBandEmployeeContributionFormFieldId}}" name="{{$ctrl.policyBandEmployeeContributionFormFieldId}}" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-model="$ctrl.policyBand.PolicyBandEmployeeAmount" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" required type="number">\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.policyBandEmployeeContributionFormFieldId].$error" ng-show="$ctrl.form[$ctrl.policyBandEmployeeContributionFormFieldId].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="max">The maximum value is {{$ctrl.config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employee contribution</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandEmployerContributionFormFieldId}}">Employer contribution (\xA3)</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="policy-band-form-field_input" id="{{$ctrl.policyBandEmployerContributionFormFieldId}}" name="{{$ctrl.policyBandEmployerContributionFormFieldId}}" ng-if="!$ctrl.policy.useSameEmployerContributionRateForAllBands" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-model="$ctrl.policyBand.PolicyBandEmployerAmount" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" type="number">\n\t\t\t\t\t<!-- Fixed when \'use same ER contribution for all bands is selected -->\n\t\t\t\t\t<input class="policy-band-form-field_input is-read-only" id="{{$ctrl.policyBandEmployerContributionFormFieldId}}" name="{{$ctrl.policyBandEmployerContributionFormFieldId}}" ng-disabled="true" ng-if="$ctrl.policy.useSameEmployerContributionRateForAllBands" ng-model="$ctrl.policyBand.PolicyBandEmployerAmount" ng-value="$ctrl.policy.fixedEmployerContribution" type="number">\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.policyBandEmployerContributionFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.policyBandEmployerContributionFormFieldId].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">The maximum value is {{$ctrl.config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employer contribution</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Sickness -->\n\t<div class="policy-band-form-field_main" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.sickness">\n\t\t<div class="form-field-group" ng-if="$ctrl.policy.baseBandsOnLengthOfService">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{$ctrl.policyBandLengthOfServiceFromFormFieldId}}">Length of service (months):</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-band-form-field_range">\n\t\t\t\t\t<div class="policy-band-form-field_range-values">\n\t\t\t\t\t\t<!-- \'from\' field is fixed, so no pattern and no validation -->\n\t\t\t\t\t\t<div class="policy-band-form-field_range-value">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<!-- Fixed value is 1 month above \'to\' field of previous band -->\n\t\t\t\t\t\t\t\t<input class="policy-band-form-field_input is-read-only" type="number" id="{{$ctrl.policyBandLengthOfServiceFromFormFieldId}}" name="{{$ctrl.policyBandLengthOfServiceFromFormFieldId}}" ng-disabled="true" ng-value="$ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + 1 : 0">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="policy-band-form-field_range-separator" ng-if="!$ctrl.policyBand.isUpperRangeInfinite">\n\t\t\t\t\t\t\t<i class="icon-arrow-right primary m"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="policy-band-form-field_range-value" ng-if="!$ctrl.policyBand.isUpperRangeInfinite">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<number-selector-field field-name="{{$ctrl.policyBandLengthOfServiceToFormFieldId}}" min="$ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + 2 : 1" ng-model="$ctrl.policyBand.PolicyBandValueTo" ng-regex-key="number" ng-required="true" step="1"></number-selector-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.policyBandLengthOfServiceToFormFieldId].$error" ng-show="$ctrl.form[$ctrl.policyBandLengthOfServiceToFormFieldId].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a value greater than {{$ctrl.previousPolicyBand ? $ctrl.previousPolicyBand.PolicyBandValueTo + 1 : 0}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-band-form-field_range-toggle" ng-if="$ctrl.policyBand.isLast">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<toggle-input field-label="and above" field-model="$ctrl.policyBand.isUpperRangeInfinite" field-name="toggleField" field-on-change="$ctrl.onIsUpperRangeInfiniteChange($ctrl.policyBand)"></toggle-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Entitlement periods -->\n\t\t<div class="policy-band-form-field_sections">\n\t\t\t<div class="policy-band-form-field_section" ng-repeat="policyBandEntitlementPeriod in $ctrl.policyBand.PolicyBandEntitlementPeriods | filter : { \'PolicyBandEntitlementPeriodDelete\': \'false\' }">\n\t\t\t\t<div class="policy-band-form-field_section-header">\n\t\t\t\t\t<div>Payment period {{$index + 1}}</div>\n\t\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeletePolicyBandEntitlementPeriod(policyBandEntitlementPeriod)" ng-if="$index !== 0 && !policyBandEntitlementPeriod.confirmDelete" class="policy-band-form-field_section-action" data-cy="delete-pension-policy-band">\n\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;Delete\n\t\t\t\t\t</a>\n\t\t\t\t\t<div class="policy-band-form-field_section-confirm-delete fadeIn" ng-if="policyBandEntitlementPeriod.confirmDelete">\n\t\t\t\t\t\t<p class="s strong">\n\t\t\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.policyService.deletePolicyBandEntitlementPeriod($ctrl.policy, $ctrl.policyBand, policyBandEntitlementPeriod)">Yes</a>\n\t\t\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeletePolicyBandEntitlementPeriod(policyBandEntitlementPeriod)">No</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{policyBandEntitlementPeriod.id}}_Duration">Entitlement (days)</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field class="policy-band-form-field_input" field-name="{{policyBandEntitlementPeriod.id}}_Duration" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodItemDuration" min="1" step="1"></number-selector-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field" ng-if="[$ctrl.POLICY_PAY_BASES.averageWeeklyPercent, $ctrl.POLICY_PAY_BASES.annualSalaryPercent].includes($ctrl.policy.PolicyPayBasis)">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{policyBandEntitlementPeriod.id}}_Amount">Pay (%)</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="policy-band-form-field_input percentage s" id="{{policyBandEntitlementPeriod.id}}_Amount" name="{{policyBandEntitlementPeriod.id}}_Amount" ng-max="100" ng-min="0" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayPercentage" ng-pattern="$root.REGEX.decimalFourPlaces" required step="0.25" type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[policyBandEntitlementPeriod.id + \'_Amount\'].$touched" ng-messages="$ctrl.form[policyBandEntitlementPeriod.id + \'_Amount\'].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Please enter no more than 100%</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the pay percentage</p>\n\t\t\t\t\t\t\t<p ng-message="step">Please enter multiples of 0.25</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field" ng-if="$ctrl.policy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.fixedAmount">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{policyBandEntitlementPeriod.id}}_Amount">Pay (\xA3)</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="policy-band-form-field_input" id="{{policyBandEntitlementPeriod.id}}_Amount" name="{{policyBandEntitlementPeriod.id}}_Amount" ng-max="$ctrl.config.occupationalPoliciesMaxSalary" ng-min="0" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayAmount" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[policyBandEntitlementPeriod.id + \'_Amount\'].$touched" ng-messages="$ctrl.form[policyBandEntitlementPeriod.id + \'_Amount\'].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">The maximum value is {{$ctrl.config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a number greater than 0</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{$ctrl.config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the pay amount</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-band-form-field_options">\n\t\t\t\t\t<div class="policy-band-form-field_options-stat-pay">\n\t\t\t\t\t\t<label for="{{policyBandEntitlementPeriod.statPayIncludedFormFieldId}}">SSP:&nbsp;&nbsp;</label>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="{{policyBandEntitlementPeriod.id}}_StatPayIncluded" name="{{policyBandEntitlementPeriod.id}}_StatPayIncluded" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay" ng-value="$ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.included" required type="radio">\n\t\t\t\t\t\t\t<label for="{{policyBandEntitlementPeriod.id}}_StatPayIncluded">Included</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="{{policyBandEntitlementPeriod.id}}_StatPayAdditional" name="{{policyBandEntitlementPeriod.id}}_StatPayAdditional" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay" ng-value="$ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional" required type="radio">\n\t\t\t\t\t\t\t<label for="{{policyBandEntitlementPeriod.id}}_StatPayAdditional">Additional</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\t<div class="policy-band-form-field_options fadeIn" ng-if="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodStatutoryPay === $ctrl.POLICY_BAND_STAT_PAYMENT_TYPES.additional">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="{{policyBandEntitlementPeriod.id}}_PayLimit">Pay cap:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select aria-label="Entitlement period pay limit type" data-cy="entitlement-period-pay-limit-select" id="{{policyBandEntitlementPeriod.id}}_PayLimit" name="{{policyBandEntitlementPeriod.id}}_PayLimit" ng-model="policyBandEntitlementPeriod.PolicyBandEntitlementPeriodPayLimit" ng-options="option.value as option.label for option in $ctrl.POLICY_BAND_PAY_LIMIT_TYPE_OPTIONS">\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_sections-action">\n\t\t\t\t<a href="" ng-click="$ctrl.policyService.createPolicyBandEntitlementPeriod($ctrl.policyBand)">\n\t\t\t\t\t<i class="icon-add m"></i>&nbsp;&nbsp;Add payment period\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Can\'t delete -->\n\t<div class="policy-band-form-field_overlay fadeInFast" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.cannotDelete">\n\t\t<div class="policy-band-form-field_overlay-content">\n\t\t\t<div class="policy-band-form-field_header">\n\t\t\t\t<div class="policy-band-form-field_header-title"><i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.utilities.toSentenceCase($ctrl.policy.policyBandDescription)}} {{$ctrl.index + 1}}</div>\n\t\t\t\t<div class="policy-band-form-field_header-action">\n\t\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeletePolicyBand($ctrl, $ctrl.policyBand)" class="is-greyscale-lightened" data-cy="delete-policy-band">\n\t\t\t\t\t\t<i class="icon-cross"></i>&nbsp;&nbsp;Cancel\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_overlay-content-prompt" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay">\n\t\t\t\t<i class="icon-warning tertiary m"></i>&nbsp;&nbsp;This {{$ctrl.policy.policyBandDescription}} is in use\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_overlay-content-main">\n\t\t\t\t<p class="s">\n\t\t\t\t\tThis {{$ctrl.policy.policyBandDescription}} can\'t be deleted as it\'s currently being used by\n\t\t\t\t\t<ng-pluralize count="$ctrl.policyBand.TeamMembers.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>. Assign them\n\t\t\t\t\tto a new {{$ctrl.policy.policyBandDescription}} before deleting this one.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_overlay-content-footer">\n\t\t\t\t<a href="" ng-click="$ctrl.viewTeamMembers($ctrl)">\n\t\t\t\t\t<p class="s strong is-pimary">\n\t\t\t\t\t\t<i class="icon-chevron-left s"></i>&nbsp;View\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.policyBand.TeamMembers.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize> using pay point\n\t\t\t\t\t</p>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Confirm delete -->\n\t<div class="policy-band-form-field_overlay fadeInFast" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.confirmDelete">\n\t\t<div class="policy-band-form-field_overlay-content">\n\t\t\t<div class="policy-band-form-field_header">\n\t\t\t\t<div class="policy-band-form-field_header-title">\n\t\t\t\t\t<i class="icon-menu-alt primary m"></i>&nbsp;{{$ctrl.utilities.toSentenceCase($ctrl.policy.policyBandDescription)}} {{$ctrl.index + 1}}\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-band-form-field_header-action">\n\t\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDeletePolicyBand($ctrl, $ctrl.policyBand)" class="is-greyscale-lightened" data-cy="delete-policy-band">\n\t\t\t\t\t\t<i class="icon-cross"></i>&nbsp;&nbsp;Cancel\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="policy-band-form-field_overlay-content-prompt">\n\t\t\t\t<i class="icon-question-mark is-primary m"></i>&nbsp;&nbsp;Are you sure?\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_overlay-content-main">\n\t\t\t\t<p class="s">Once deleted this cannot be undone. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t\t</div>\n\t\t\t<div class="policy-band-form-field_overlay-content-footer">\n\t\t\t\t<a href="" ng-click="$ctrl.policyService.deletePolicyBand($ctrl.policy, $ctrl.policyBand)">\n\t\t\t\t\t<p class="s strong is-primary">Confirm</p>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/policy-card/policy-card.component.html','<div class="policy-card {{$ctrl.policy.policyTheme}}">\n\t<div class="policy-card_content">\n\t\t<div class="policy-card_header">\n\t\t\t<icon-dot icon="{{$ctrl.policy.policyIcon}}" theme="{{$ctrl.policy.policyTheme}} has-box-shadow"></icon-dot>\n\t\t\t<div class="policy-card_name" title="{{$ctrl.policy.PolicyName}}">{{$ctrl.policy.PolicyName}}</div>\n\t\t</div>\n\t\t<div class="policy-card_info" ng-if="!$ctrl.policy.isLegacyPolicy">\n\t\t\t<!-- Keep the grid structure, even though some sections aren\'t applicable, so ng-ifs aren\'t on the parent divs in each case -->\n\t\t\t<div class="policy-card_info-item-outer policy-card_info-item-locked">\n\t\t\t\t<div class="policy-card_info-item">\n\t\t\t\t\t<icon-dot icon="icon-padlock" ng-if="$ctrl.policy.IsPolicyRestricted" theme="is-tertiary has-box-shadow" tooltip-text="Policy locked"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="policy-card_info-item-outer">\n\t\t\t\t<!-- Show dependants (team members) for pay policies -->\n\t\t\t\t<div class="policy-card_info-item" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.pay">\n\t\t\t\t\t<i class="policy-card_info-item-icon icon-team-alt is-primary m"></i>\n\t\t\t\t\t<span>{{$ctrl.policy.TeamMembers.length}}</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="policy-card_info-item-outer">\n\t\t\t\t<!-- Show basis for pay policies -->\n\t\t\t\t<div class="policy-card_info-item" ng-if="$ctrl.policy.PolicyType === $ctrl.POLICY_TYPES.pay">\n\t\t\t\t\t<i class="policy-card_info-item-icon icon-wallet is-primary m"></i>\n\t\t\t\t\t<span>{{$ctrl.POLICY_PAY_BASES_DESCRIPTIONS[$ctrl.policy.PolicyPayBasis]}}</span>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Show type for parental policies -->\n\t\t\t\t<div class="policy-card_info-item" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.parental">\n\t\t\t\t\t<i class="policy-card_info-item-icon icon-document is-primary m"></i>\n\t\t\t\t\t<span>{{$ctrl.POLICY_TYPE_NAMES[$ctrl.policy.PolicyType]}}</span>\n\t\t\t\t</div>\n\t\t\t\t<!-- Show code for sickness policies -->\n\t\t\t\t<div class="policy-card_info-item" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.sickness && $ctrl.policy.PolicyCode">\n\t\t\t\t\t<i class="policy-card_info-item-icon icon-label is-primary m"></i>\n\t\t\t\t\t<span>{{$ctrl.policy.PolicyCode}}</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="policy-card_info-item-outer">\n\t\t\t\t<div class="policy-card_info-item">\n\t\t\t\t\t<i class="policy-card_info-item-icon icon-menu-alt is-primary m"></i>\n\t\t\t\t\t<span class="s">\n\t\t\t\t\t\t<pc-pluralise count="$ctrl.policy.PolicyBands.length" single="{{$ctrl.policy.policyBandDescription}}" multiple="{{$ctrl.policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- Empty info section for legacy policies, just to set everything correctly in position -->\n\t\t<div class="policy-card_info" ng-if="$ctrl.policy.isLegacyPolicy"></div>\n\t\t<!-- Action menu (legacy policy); \'Edit\' option only. Hidden if user doesn\'t have correct permisions-->\n\t\t<dropdown-menu class="policy-card_action-menu" data-cy="policy-card-{{$ctrl.index}}-action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.showActionMenu" menu-size="l" menu-theme="{{$ctrl.policy.policyTheme}} s" ng-if="$ctrl.policy.isLegacyPolicy && $root.currentUser.Permissions.HR.canManagePolicies">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-edit" href="" ng-click="$ctrl.openPolicy($ctrl, $ctrl.policy, $ctrl.policies, $ctrl.UPDATE_POLICY_MODES.edit)">Edit</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t\t<!-- Action menu (non-legacy policy) -->\n\t\t<dropdown-menu class="policy-card_action-menu" data-cy="policy-card-{{$ctrl.index}}-action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.showActionMenu" menu-size="l" menu-theme="{{$ctrl.policy.policyTheme}} s" ng-if="!$ctrl.policy.isLegacyPolicy">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-view" href="" ng-click="$ctrl.openPolicy($ctrl, $ctrl.policy, $ctrl.policies, $ctrl.UPDATE_POLICY_MODES.view)">\n\t\t\t\t\tView\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-edit" href="" ng-click="$ctrl.openPolicy($ctrl, $ctrl.policy, $ctrl.policies, $ctrl.UPDATE_POLICY_MODES.edit)" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t\t\t\tEdit\n\t\t\t\t</a>\n\t\t\t\t<!-- \'Add policy update\' restricted to \'locked\' (IsPolicyRestricted) pay policies only, and those that don\'t already have an update pending -->\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-edit" href="" ng-click="$ctrl.addPolicyUpdate($ctrl, $ctrl.policy)" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies && $ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay\n\t\t\t\t\t\t\t && $ctrl.policy.IsPolicyRestricted && !$ctrl.policy.IsUpdatePending">\n\t\t\t\t\tAdd policy update\n\t\t\t\t</a>\n\t\t\t\t<!-- Policy history (record of policy updates), pay policies only -->\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-history" href="" ng-click="$ctrl.openPayPolicyHistory($ctrl.policy, $ctrl)" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies && $ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay">\n\t\t\t\t\tPolicy history\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="policy-card-{{$ctrl.index}}-action-menu-duplicate" href="" ng-click="$ctrl.openPolicy($ctrl, $ctrl.policy, $ctrl.policies, $ctrl.UPDATE_POLICY_MODES.duplicate)" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t\t\t\tDuplicate\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t\t\t<a class="assertive" data-cy="policy-card-{{$ctrl.index}}-action-menu-delete" href="" ng-click="$ctrl.deletePolicy($ctrl, $ctrl.policy)">\n\t\t\t\t\tDelete\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t</div>\n\t<!-- Updates pending warning, applicable only to pay policies with IsUpdatePending -->\n\t<div class="policy-card_note is-tertiary" ng-if="$ctrl.policy.policyCategory === $ctrl.POLICY_CATEGORIES.pay && $ctrl.policy.IsUpdatePending">\n\t\t<div class="policy-card_note-icon">\n\t\t\t<i class="icon-loading l is-tertiary"></i>\n\t\t</div>\n\t\t<div class="policy-card_note-content">\n\t\t\t<div class="policy-card_note-content-title">Update pending</div>\n\t\t\t<div class="policy-card_note-content-subtitle">Effective date: {{$ctrl.policy.UpdateEffectiveDateISO | dateformat}}</div>\n\t\t</div>\n\t\t<div class="policy-card_note-action">\n\t\t\t<a class="is-tertiary" href="" ng-click="$ctrl.viewPayPolicyPendingUpdate($ctrl, $ctrl.policy)">\n\t\t\t\tView update\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/policy-pension-scheme-card/policy-pension-scheme-card.component.html','<div class="policy-pension-scheme-card is-primary">\n\t<div class="policy-pension-scheme-card_logo">\n\t\t<img alt="Logo for {{::$ctrl.pensionScheme.PensionProviderName}}" ng-src="{{$ctrl.pensionScheme.PensionProviderImageURL}}">\n\t</div>\n\t<div class="policy-pension-scheme-card_main">\n\t\t<div class="policy-pension-scheme-card_name">{{$ctrl.pensionScheme.PensionProviderName}}</div>\n\t\t<div class="policy-pension-scheme-card_info" ng-if="$ctrl.pensionScheme.EmployerReference">\n\t\t\t{{$ctrl.pensionScheme.EmployerReference}}\n\t\t</div>\n\t\t<div class="policy-pension-scheme-card_subinfo">{{$ctrl.pensionScheme.PensionName}}</div>\n\t</div>\n\t<div class="policy-pension-scheme-card_goto-scheme fadeIn">\n\t\t<a href="" ng-click="$ctrl.goToScheme($ctrl.pensionScheme, $ctrl)">View&nbsp;<i class="icon-chevron-right"></i>\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/powered-by-paycircle/poweredByPaycircleComponent.html','\n<div class="powered-by-paycircle {{theme}}">\n\t<img src="images/powered-by-paycircle.svg" width="150" alt="Powered by Paycircle">\n</div>\n');
$templateCache.put('components/print-address/printAddressComponent.html','<address>\n\t<p ng-if="$ctrl.address.AddressName">{{$ctrl.address.AddressName}}</p>\n\t<p ng-if="!$ctrl.displayAsForeign && ($ctrl.address.AddressNumber || $ctrl.address.AddressStreet)">{{$ctrl.address.AddressNumber}} {{$ctrl.address.AddressStreet}}</p>\n\t<p ng-if="$ctrl.displayAsForeign && $ctrl.address.AddressNumber">{{$ctrl.address.AddressNumber}}</p>\n\t<p ng-if="$ctrl.displayAsForeign && $ctrl.address.AddressStreet">{{$ctrl.address.AddressStreet}}</p>\n\t<p ng-if="$ctrl.address.AddressCity">{{$ctrl.address.AddressCity}}</p>\n\t<p ng-if="$ctrl.address.AddressCounty">{{$ctrl.address.AddressCounty}}</p>\n\t<p ng-if="$ctrl.address.AddressPostcode">{{$ctrl.address.AddressPostcode}}</p>\n\t<p ng-if="$ctrl.showCountry">{{$ctrl.address.AddressCountry}}</p>\n</address>\n');
$templateCache.put('components/profile-card/profile-card.component.html','<div class="profile-card" ng-class="[$ctrl.theme, $ctrl.hasMeta ? \'has-meta\' : \'no-meta\']">\n\t<avatar class="profile-card_avatar" avatar-initial="{{$ctrl.name[0]}}" avatar-size="{{$ctrl.avatarSize}}" avatar-user-id="{{vm.activeWorkflowTemplateEntry.ActionerID}}"></avatar>\n\t<name class="profile-card_name" full-name="$ctrl.name" name-type="full-name"></name>\n\t<span class="profile-card_meta" ng-if="$ctrl.hasMeta">{{$ctrl.meta}}</span>\n\t<span class="profile-card_action" ng-transclude="action" ng-if="$ctrl.hasAction">{{$ctrl.meta}}</span>\n</div>');
$templateCache.put('components/profile-data-block/profile-data-block.component.html','<div class="profile-data-block">\n\n\t<!-- Groups -->\n\t<div class="profile-data-block_group" data-cy="profile-data-block-{{:: group.id }}" ng-class="::group.theme" ng-repeat="group in $ctrl.pdbGroups">\n\n\t\t<!-- Group Header -->\n\t\t<div class="profile-data-block_header" ng-if="::group.heading">\n\n\t\t\t<!-- Group Icon -->\n\t\t\t<div class="profile-data-block_icon" ng-if="::group.icon">\n\t\t\t\t<i ng-class="::[\n\t\t\t\t\tgroup.icon,\n\t\t\t\t\tgroup.theme\n\t\t\t\t]"></i>\n\t\t\t</div>\n\n\t\t\t<!-- Group Heading -->\n\t\t\t<div class="profile-data-block_heading">\n\t\t\t\t<h6>{{::group.heading}}</h6>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Content -->\n\t\t<div class="profile-data-block_contents" ng-if="::group.data.length > 0">\n\t\t\t<div class="stat-list plain-text is-clear is-greyscale-darkened">\n\t\t\t\t<div class="stat-list__row" ng-repeat="dataItem in group.data">\n\t\t\t\t\t<span class="stat-list__key">{{::dataItem.label}}:</span>\n\t\t\t\t\t<span class="stat-list__value" ng-if="::dataItem.value">{{::dataItem.value}}</span>\n\t\t\t\t\t<span class="stat-list__value italic" ng-if="::!dataItem.value">Unknown</span>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Actions -->\n\t\t<div class="profile-data-block_actions" ng-if="::group.actions">\n\t\t\t<div class="spaced-links">\n\t\t\t\t<div class="spaced-links__item" ng-repeat="action in group.actions">\n\t\t\t\t\t<a class="is-strong link-with-icon" data-cy="profile-data-block-action-{{:: action.copy | slugify }}" href="" ng-click="action.onClick()">\n\t\t\t\t\t\t<i class="is-smedium" ng-class="::action.icon" ng-if="::action.icon"></i>\n\t\t\t\t\t\t{{::action.copy}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n</div>\n');
$templateCache.put('components/progress-bar/progress-bar.component.html','<div aria-label="Progress" aria-valuenow="{{$ctrl.pbPercentage}}" aria-valuemax="100" aria-valuemin="0" class="progress-bar" ng-class="[\n\t\t$ctrl.pbTheme,\n\t\t$ctrl.pbSize,\n\t\t$ctrl.pbTemplate,\n\t\t{\n\t\t\t\'has-value\': $ctrl.pbHasValue\n\t\t}\n\t]" role="progressbar">\n\t<div class="progress-bar_progress" ng-style="{ width: $ctrl.pbPercentage + \'%\' }"></div>\n\t<span class="xs progress-bar_value" ng-if="$ctrl.pbHasValue">{{$ctrl.pbPercentage}}%</span>\n</div>\n');
$templateCache.put('components/progress-card/progress-card.component.html','<div class="progress-card" data-cy="progress-card-{{:: $ctrl.title | slugify }}" ng-class="[$ctrl.theme]">\n\n\t<header class="progress-card_title-panel">\n\t\t<div class="progress-card_title">\n\t\t\t<div class="progress-card_title-icon">\n\t\t\t\t<icon-dot icon="{{$ctrl.icon}}" theme="{{$ctrl.theme}} is-extra-large has-box-shadow"></icon-dot>\n\t\t\t</div>\n\t\t\t<div class="progress-card_title-text">{{$ctrl.title}}</div>\n\t\t</div>\n\t</header>\n\n\t<div class="progress-card_body">\n\t\t<div class="progress-card_groups">\n\t\t\t<div class="progress-card_group" ng-repeat="(groupIndex, progressGroup) in $ctrl.progressGroups">\n\t\t\t\t<!-- Group header - additional post -->\n\t\t\t\t<div class="progress-card_group-header" ng-if="progressGroup.id === $ctrl.PROGRESS_GROUP_IDS.additionalPost">\n\t\t\t\t\t<div class="progress-card_group-title" title="{{progressGroup.data.additionalPost.SalaryPolicyPostTitle}}">{{progressGroup.data.additionalPost.SalaryPolicyPostTitle}}</div>\n\t\t\t\t\t<div class="progress-card_actions">\n\t\t\t\t\t\t<a class="progress-card_action" data-cy="progress-card-group-{{:: groupIndex}}-additional-post-delete" href="" ng-click="$ctrl.onGroupClick($ctrl, progressGroup, $ctrl.PROGRESS_GROUP_ACTION_IDS.employment.deletePost)" ng-class="[$ctrl.linkTheme]">\n\t\t\t\t\t\t\t<i class="icon-trash"></i><span class="progress-card_action-text">&nbsp;Delete post</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension header -->\n\t\t\t\t<div class="progress-card_group-header" ng-if="$ctrl.type === $ctrl.PROGRESS_CARD_TYPES.pension\n\t\t\t\t\t\t   && progressGroup.data.pension">\n\t\t\t\t\t<!-- Title is pension name and ref for setup complete and not excluded-->\n\t\t\t\t\t<div class="progress-card_group-title" ng-if="\n\t\t\t\t\t\t\tprogressGroup.data.pension.PensionSchemeSetupComplete &&\n\t\t\t\t\t\t\t!progressGroup.data.pension.PensionIsExcluded &&\n\t\t\t\t\t\t\t!progressGroup.data.pension.IsGhostPension\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<span class="progress-card_group-title-emphasised">{{progressGroup.data.pension.PensionProviderName}}</span>\n\t\t\t\t\t\t<span class="progress-card_group-title-standard">{{progressGroup.data.pension.EmployerReference}}</span>\n\t\t\t\t\t\t<span class="progress-card_group-title-standard" ng-if="progressGroup.id === $ctrl.PROGRESS_GROUP_IDS.additionalPostAEPension">\n\t\t\t\t\t\t\t({{progressGroup.data.pension.SalaryPolicyPostTitle}})\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Title for no pension selected, for main post -->\n\t\t\t\t\t<div class="progress-card_group-title" ng-if="\n\t\t\t\t\t\t\t!progressGroup.data.pension.PensionSchemeSetupComplete &&\n\t\t\t\t\t\t\t!progressGroup.data.pension.PensionIsExcluded &&\n\t\t\t\t\t\t\tprogressGroup.id === $ctrl.PROGRESS_GROUP_IDS.additionalPostAEPension\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<span class="progress-card_pension-provider">{{progressGroup.data.pension.SalaryPolicyPostTitle}}</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Title for excluded pension-->\n\t\t\t\t\t<div class="progress-card_group-title" ng-if="progressGroup.data.pension.PensionIsExcluded">\n\t\t\t\t\t\t<span class="progress-card_pension-provider">Excluded from AE pensions</span>\n\t\t\t\t\t\t<span ng-if="progressGroup.data.pension.IsAdditionalPost" class="progress-card_group-title-standard">\n\t\t\t\t\t\t\t&nbsp;({{progressGroup.data.pension.SalaryPolicyPostTitle}})\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Title for ghost pension -->\n\t\t\t\t\t<div class="progress-card_group-title" ng-if="progressGroup.data.pension.IsGhostPension">\n\t\t\t\t\t\t<span class="progress-card_pension-provider">Ghost pension</span>\n\t\t\t\t\t\t<span ng-if="progressGroup.data.pension.IsAdditionalPost" class="progress-card_group-title-standard">\n\t\t\t\t\t\t\t&nbsp;({{progressGroup.data.pension.SalaryPolicyPostTitle}})\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="progress-card_actions">\n\t\t\t\t\t\t<!-- Add AE scheme action for additional post pensions -->\n\t\t\t\t\t\t<a class="progress-card_action" data-cy="progress-card-group-{{:: groupIndex}}-add-to-ae-pension" href="" ng-click="$ctrl.onGroupClick($ctrl, progressGroup, $ctrl.PROGRESS_GROUP_ACTION_IDS.pension.editPension)" ng-class="[$ctrl.linkTheme]" ng-if="\n\t\t\t\t\t\t\t\t!progressGroup.data.pension.PensionSchemeSetupComplete &&\n\t\t\t\t\t\t\t\tprogressGroup.id === $ctrl.PROGRESS_GROUP_IDS.additionalPostAEPension\n\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<i class="icon-edit"></i><span class="progress-card_action-text">&nbsp;Add AE scheme</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Top level edit pension action. Show only when the CTA block isn\'t visible, based on PensionSchemeSetupComplete-->\n\t\t\t\t\t\t<a class="progress-card_action" data-cy="progress-card-group-{{:: groupIndex}}-edit-ae-scheme" href="" ng-click="$ctrl.onGroupClick($ctrl, progressGroup, $ctrl.PROGRESS_GROUP_ACTION_IDS.pension.editPension)" ng-class="[$ctrl.linkTheme]" ng-if="progressGroup.data.pension.PensionSchemeSetupComplete">\n\t\t\t\t\t\t\t<i class="icon-edit"></i><span class="progress-card_action-text">&nbsp;Edit AE scheme</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="progress-card_action" data-cy="progress-card-group-{{:: groupIndex}}-delete-ae-scheme" href="" ng-click="$ctrl.onGroupClick($ctrl, progressGroup, $ctrl.PROGRESS_GROUP_ACTION_IDS.pension.deletePension)" ng-class="[$ctrl.linkTheme]" ng-if="progressGroup.data.pension.PensionSchemeSetupComplete && progressGroup.id === $ctrl.PROGRESS_GROUP_IDS.additionalPostAEPension">\n\t\t\t\t\t\t\t<i class="icon-trash"></i><span class="progress-card_action-text">&nbsp;Delete AE scheme</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension - excluded from pensions -->\n\t\t\t\t<div class="progress-card_group-main-content" ng-if="$ctrl.type === $ctrl.PROGRESS_CARD_TYPES.pension\n\t\t\t\t\t\t\t&& progressGroup.data.pension.PensionIsExcluded">\n\t\t\t\t\t{{$ctrl.teamMember.Personal.Forename}} has been excluded from all AE pensions. Excluded team members will still be assessed as normal,\n\t\t\t\t\tthey just won\'t ever be enrolled or be entitled to ask to join the pension.\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension - ghost pension -->\n\t\t\t\t<div class="progress-card_group-main-content" ng-if="$ctrl.type === $ctrl.PROGRESS_CARD_TYPES.pension\n\t\t\t\t\t\t\t&& progressGroup.data.pension.IsGhostPension">\n\t\t\t\t\t{{$ctrl.teamMember.Personal.Forename}} is currently being assessed by a Ghost Pension. You\u2019ll be notified when a team member becomes\n\t\t\t\t\teligible and a pension provider needs to be selected.\n\t\t\t\t\t<a class="underline" href="" ng-class="[$ctrl.theme]" ng-if="!userHasRole(\'departmentadmin\')" ui-sref="pensions.summary({agencyProfileId: $root.currentCompany.AgencyProfileID})">Go to your Pensions page</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Main content - optional pane, progress steps and progress bar. Not shown when one of the above pension\n\t\t\t\t     states is valid. Also hidden for additional post pensions until a scheme has been selected. -->\n\t\t\t\t<div class="progress-card_group-main" ng-if="\n\t\t\t\t\t \t$ctrl.type !== $ctrl.PROGRESS_CARD_TYPES.pension ||\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\t$ctrl.type === $ctrl.PROGRESS_CARD_TYPES.pension &&\n\t\t\t\t\t\t\t!progressGroup.data.pension.PensionIsExcluded &&\n\t\t\t\t\t\t\t!progressGroup.data.pension.IsGhostPension &&\n\t\t\t\t\t\t\t!(progressGroup.data.pension.IsAdditionalPost && !progressGroup.data.pension.PensionSchemeSetupComplete)\n\t\t\t\t\t\t)\n\t\t\t\t\t">\n\t\t\t\t\t<!-- Keep (optional) pane with steps, and progress in separate containers for responsive styles -->\n\t\t\t\t\t<div class="progress-card_group-main-left">\n\t\t\t\t\t\t<!-- Optional Pane inserted depending on type. -->\n\t\t\t\t\t\t<div class="progress-card_pane" ng-if="$ctrl.type === $ctrl.PROGRESS_CARD_TYPES.pension\n\t\t\t\t\t\t\t\t\t&& progressGroup.data.pension\n\t\t\t\t\t\t\t\t\t&& !progressGroup.data.pension.PensionIsExcluded">\n\t\t\t\t\t\t\t<!-- Pension - with AE pension assigned, including a ghost pension -->\n\t\t\t\t\t\t\t<div class="progress-card_pension" ng-if="progressGroup.data.pension.PensionSchemeSetupComplete">\n\t\t\t\t\t\t\t\t<div class="progress-card_pane-logo">\n\t\t\t\t\t\t\t\t\t<img alt="{{progressGroup.data.pension.PensionProviderName}}" class="progress-card_pane-logo-image" ng-if="progressGroup.data.pension.PensionProviderImageUrl !== \'\'" ng-src="../{{progressGroup.data.pension.PensionProviderImageUrl}}">\n\t\t\t\t\t\t\t\t\t<i class="icon-money secondary xxl fadeIn" ng-if="progressGroup.data.pension.PensionProviderImageUrl === \'\'"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Pension - no AE assigned -->\n\t\t\t\t\t\t\t<button class="progress-card_tile is-clear is-placeholder" data-cy="progress-card-group-{{::groupIndex}}-select-a-scheme" ng-click="$ctrl.onGroupClick($ctrl, progressGroup, $ctrl.PROGRESS_GROUP_ACTION_IDS.pension.editPension)" ng-if="!progressGroup.data.pension.PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t\t&& !progressGroup.data.pension.IsGhostPension" type="button">\n\t\t\t\t\t\t\t\t<div class="progress-card_tile-placeholder-action">\n\t\t\t\t\t\t\t\t\t<i class="icon-add m"></i>&nbsp;&nbsp;Select a scheme\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Steps. Not applicable in pension mode for non-exclusion, non ghost pensions. Instead full content is used (see above) -->\n\t\t\t\t\t\t<div class="progress-card_group-steps" ng-class="{ \'with-pane\': $ctrl.hasPane }">\n\n\t\t\t\t\t\t\t<div class="progress-card_group-notice" ng-if="progressGroup.notice">\n\t\t\t\t\t\t\t\t{{progressGroup.notice}}\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<ul class="progress-card_group-step-list" ng-class="[{ \'two-columns\' : !$ctrl.hasPane }, $ctrl.theme]">\n\t\t\t\t\t\t\t\t<li class="progress-card_group-step-listitem" ng-class="{ \'complete\': step.complete, \'disabled\': step.disabled }" ng-repeat="step in progressGroup.steps">\n\t\t\t\t\t\t\t\t\t<a class="progress-card_group-step-link" data-cy="progress-card-group-{{:: groupIndex}}-step-{{:: $index }}" href="" ng-click="$ctrl.onStepClick($ctrl, progressGroup, step.wizardStepIndex)">\n\t\t\t\t\t\t\t\t\t\t{{step.name}} <i class="progress-card_group-step-icon icon-arrow-right is-small"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Progress for non-exclusion, non ghost pensions-->\n\t\t\t\t\t<div class="progress-card_group-progress" ng-if="!progressGroup.data.pension.PensionIsExcluded\n\t\t\t\t\t\t\t\t&& !progressGroup.data.pension.IsGhostPension">\n\t\t\t\t\t\t<div class="progress-card_group-progress-bar">\n\t\t\t\t\t\t\t<span class="progress-card_group-progress-bar-label s fadeIn" ng-if="!progressGroup.complete">{{progressGroup.completedSteps}}/{{progressGroup.totalSteps}} steps complete</span>\n\t\t\t\t\t\t\t<span class="progress-card_group-progress-bar-label s tada" ng-if="progressGroup.complete">\n\t\t\t\t\t\t\t\t<i class="icon-tick m" ng-class="[$ctrl.theme]"></i>&nbsp;&nbsp;All done!\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<progress-bar pb-percentage="progressGroup.percentComplete" pb-theme="{{$ctrl.theme | cemify}}"></progress-bar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="progress-card_footer" ng-if="$ctrl.showFooter" ng-transclude="footer"></div>\n\t</div>\n</div>\n');
$templateCache.put('components/progress-ring/progress-ring.component.html','<div aria-label="Progress" aria-valuenow="{{$ctrl.prPercentage}}" aria-valuemax="100" aria-valuemin="0" class="progress-ring" ng-class="$ctrl.prSize" style="--circumference: {{$ctrl.ringOptions.circumference}};\n\t\t--ringPercentage: {{$ctrl.prPercentage}};\n\t\t--boxSize: {{$ctrl.ringOptions.boxSize}}px;\n\t\t--strokeWidth: {{$ctrl.ringOptions.strokeWidth}}px;" role="progressbar">\n\t<h6 class="progress-ring_percent" ng-class="$ctrl.prThemeIncomplete" ng-if="$ctrl.prShowPercentage">{{$ctrl.prPercentage}}%</h6>\n\n\t<div class="progress-ring_content" ng-class="$ctrl.prThemeComplete" ng-if="$ctrl.hasContent" ng-transclude="prContent"></div>\n\n\t<div class="progress-ring_content" ng-if="$ctrl.prIcon">\n\t\t<i class="progress-ring_icon" ng-class="[$ctrl.prIcon, $ctrl.prThemeComplete]"></i>\n\t</div>\n\n\t<div class="progress-ring_content" ng-if="$ctrl.prBadge">\n\t\t<image-badge class="progress-ring_badge" image-alt="Loading" image-key="{{$ctrl.prBadge}}" image-size="is-smedium" image-type="integrations"></image-badge>\n\t</div>\n\n\t<svg class="progress-ring_wrapper" ng-if="$ctrl.ringOptions" ng-attr-width="{{$ctrl.ringOptions.boxSize}}" ng-attr-height="{{$ctrl.ringOptions.boxSize}}">\n\t\t<circle ng-attr-class="progress-ring_background {{$ctrl.prThemeIncomplete}}" fill="transparent" ng-attr-stroke-width="{{$ctrl.ringOptions.strokeWidth}}" ng-attr-r="{{$ctrl.ringOptions.radius}}" ng-attr-cx="{{$ctrl.ringOptions.circle}}" ng-attr-cy="{{$ctrl.ringOptions.circle}}"/>\n\n\t\t<circle class="progress-ring_bar {{$ctrl.prThemeComplete | uncemify}}" fill="transparent" ng-attr-stroke-width="{{$ctrl.ringOptions.strokeWidth}}" stroke-linecap="round" ng-attr-r="{{$ctrl.ringOptions.radius}}" ng-attr-cx="{{$ctrl.ringOptions.circle}}" ng-attr-cy="{{$ctrl.ringOptions.circle}}"/>\n\t</svg>\n</div>\n');
$templateCache.put('components/progress-steps/progress-steps.component.html','<div aria-label="Breadcrumb" class="progress-steps" ng-class="$ctrl.theme">\n\t<span class="progress-steps_step" ng-repeat-start="step in $ctrl.steps track by $index" aria-current="{{$ctrl.activeStep - 1 ? true : false}}" ng-class="{\n\t\t\t\'is-active\': $index === ($ctrl.activeStep - 1),\n\t\t\t\'is-complete\': $index < ($ctrl.activeStep - 1)\n\t\t}"></span>\n\t<span class="progress-steps_spacer" ng-repeat-end ng-if="$ctrl.hasSpacers && !$last" ng-class="{\n\t\t\t\'is-complete\': $index < ($ctrl.activeStep - 1)\n\t\t}"></span>\n</div>\n');
$templateCache.put('components/question-block-bureau/questionBlockBureauComponent.html','<button type="button" class="is-clear question-block-bureau {{qbGroup.theme}}" ng-class="{\'active\' : qbGroup.showQuestions }" ng-click="qbGroup.showQuestions = !qbGroup.showQuestions">\n\t<div class="question-block-bureau__card">\n\t\t<div class="question-block-bureau__icon">\n\t\t\t<i class="icon-{{qbGroup.icon}} gradient {{qbGroup.theme}}"></i>\n\t\t</div>\n\t\t<div class="question-block-bureau__details">\n\t\t\t<h6 class="question-block-bureau__name">{{qbGroup.GroupName}}</h6>\n\t\t\t<p class="question-block-bureau__remaining">\n\t\t\t\t<ng-pluralize count="qbGroup.Questions.length" when="{\'1\': \'1 question\', \'other\': \'{} questions\'}"></ng-pluralize>\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="question-block-bureau__progress">\n\t\t\t<progress-ring pr-percentage="qbGroup.percentageComplete" pr-show-percentage="true" pr-theme-complete="{{qbGroup.theme}}" pr-secondary-theme="{{qbGroup.showQuestions ? \'greyscale\' : qbGroup.theme}}"></progress-ring>\n\t\t</div>\n\t\t<div class="question-block-bureau__toggle">\n\t\t\t<i class="icon-chevron-down {{qbGroup.theme}}"></i>\n\t\t</div>\n\t</div>\n\t<div class="question-block-bureau__questions" ng-class="{\'question-block-bureau__questions--active\' : qbGroup.showQuestions}">\n\t\t<p>\n\t\t\tThe following {{qbGroup.GroupName | lowercase}} questions have been answered:\n\t\t</p>\n\t\t<div class="question-block-bureau__tasks">\n\t\t\t<task-item ti-text="{{question.QuestionName}}" ti-is-complete="question.Complete" ti-required="question.Mandatory" ng-repeat="question in qbGroup.Questions"></task-item>\n\t\t</div>\n\t</div>\n</button>\n');
$templateCache.put('components/question-block-demo/questionBlockDemoComponent.html','<div class="question-block-demo {{qbGroup.theme}}" ng-class="{\'question-block-demo--active\' : qbGroup.showTasks }">\n\t<div class="question-block-demo__bar"></div>\n\t<button type="button" class="is-clear question-block-demo__card" ng-click="qbGroup.showTasks = !qbGroup.showTasks">\n\t\t<div class="question-block-demo__icon">\n\t\t\t<i class="gradient {{qbGroup.theme}} icon-{{qbGroup.totalQuestionsRemaining === 0 ? \'check\' : qbGroup.icon}}"></i>\n\t\t</div>\n\t\t<div class="question-block-demo__details">\n\t\t\t<h4 class="question-block-demo__name">{{qbGroup.GroupName}}</h4>\n\t\t\t<p class="question-block-demo__copy">\n\t\t\t\t{{qbGroup.copy}}\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="question-block-demo__progress-wrapper" tooltip tooltip-text="{{qbGroup.totalQuestionsRemaining === 0 ? \'All tasks completed\' : qbGroup.totalQuestionsRemaining + \' tasks to complete\'}}">\n\t\t\t<div class="question-block-demo__progress">\n\t\t\t\t<div class="question-block-demo__progress-step" ng-class="{\'complete\' : task.Complete}" ng-repeat="task in qbGroup.Questions | orderBy:\'Complete\':true"></div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="question-block-demo__toggle">\n\t\t\t<i class="icon-chevron-down {{qbGroup.theme}}"></i>\n\t\t</div>\n\t</button>\n\t<div class="question-block-demo__hiddencontent" ng-class="{\'question-block-demo__hiddencontent--visible\' : qbGroup.showTasks}">\n\t\t<a href="" class="question-block-demo__task" ng-class="{\'question-block-demo__task--complete\' : task.Complete }" ng-repeat="task in qbGroup.Questions" ng-click="goToTask(task, qbGroup.OnboardingQuestionGroupID)">\n\t\t\t<input type="checkbox" checkbox readonly="readonly" name="{{task.OnboardingQuestionID}}" id="task.OnboardingQuestionID" ng-model="task.Complete" class="question-block-demo__task-check gradient {{qbGroup.theme}} xs">\n\t\t\t<div class="question-block-demo__task-name">\n\t\t\t\t<span>{{task.QuestionName}}</span><i class="icon-chevron-right"></i>\n\t\t\t</div>\n\t\t\t<div class="question-block-demo__task-guide">\n\n\t\t\t</div>\n\t\t</a>\n\t\t<div class="question-block-demo__reset" ng-if="qbGroup.totalQuestionsRemaining !== qbGroup.Questions.length">\n\t\t\t<a href ng-click="resetAllTasksInGroup(qbGroup)"><i class="icon-loading"></i>&nbsp;Reset tasks</a>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/question-block-onboarding/questionBlockOnboardingComponent.html','<div class="question-block-onboarding">\n\t<onboarding-card on-click="openOnboardingQuestions" onboarding-team-members-count="onboardingDashboard.teamMembers.length" onboarding-question-group="onboardingQuestionGroup" onboarding-actions="onboardingActions" ng-repeat="onboardingQuestionGroup in onboardingQuestionGroups"></onboarding-card>\n\t<div class="question-block-onboarding__tasks {{activeGroup.theme}}" style="--mobile-order: {{activeGroup.mobileTaskPosition}}" ng-class="{\'question-block-onboarding__tasks--active\' : onboardingActions.showTasksFor === activeGroup.OnboardingQuestionGroupID}">\n\t\t<div class="question-block-onboarding__layout">\n\t\t\t<div class="question-block-onboarding__main" ng-switch="activeGroup.OnboardingQuestionGroupID">\n\n\t\t\t\t<!-- Team -->\n\t\t\t\t<div class="question-block-onboarding__content" pc-switch-when="ONBOARDING_QUESTION_GROUPS.team">\n\t\t\t\t\t<p class="question-block-onboarding__copy">\n\t\t\t\t\t\tWork through the steps below for each team member. You can skip anything you can\'t answer right now and come back to it later\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="question-block-onboarding__list">\n\t\t\t\t\t\t<div class="bullet-lists-split bullet-lists-split--unfold-on-mobile">\n\t\t\t\t\t\t\t<ul class="bullet-list is-small is-primary-darkened">\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 1</span> - Name, Date of birth, NI Number</li>\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 2</span> - Email address</li>\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 3</span> - Address</li>\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 4</span> - Payment details</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<ul class="bullet-list s primary-darkened">\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 5</span> - Company details</li>\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 6</span> - Pay information</li>\n\t\t\t\t\t\t\t\t<li class="bullet-list_item"><span class="primary-darkened stronger">Step 7</span> - Starter information</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!--\n\t\t\t\t\t<div class="question-block-onboarding__guide">\n\t\t\t\t\t\t<a ng-click="" class="quick-guide-video">\n\t\t\t\t\t\t\t<img\n\t\t\t\t\t\t\t\talt=""\n\t\t\t\t\t\t\t\tsrc="images/quick-guides/bulk-change.png"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t-->\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Everything else -->\n\t\t\t\t<div class="question-block-onboarding__content" ng-switch-default>\n\t\t\t\t\t<p class="question-block-onboarding__copy">\n\t\t\t\t\t\tQuestions marked <span class="tertiary">*</span> are mandatory to run your first pay period but some can be skipped and answered later.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="question-block-onboarding__list">\n\t\t\t\t\t\t<div class="task-lists-split">\n\t\t\t\t\t\t\t<div class="task-list tight">\n\t\t\t\t\t\t\t\t<div class="task-list-item" ng-class="{\'is-complete\': question.Complete || question.Skipped, \'required\': question.Mandatory, \'is-skipped\': question.Skipped}" ng-repeat="question in activeGroup.Questions | orderBy:\'order\' | limitTo: activeGroup.groupSize">\n\t\t\t\t\t\t\t\t\t<p class="task-list-item-label" ng-class="{\'is-mandatory\': question.Mandatory}">{{question.QuestionName}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="task-list tight">\n\t\t\t\t\t\t\t\t<div class="task-list-item" ng-class="{\'is-complete\': question.Complete || question.Skipped, \'required\': question.Mandatory, \'is-skipped\': question.Skipped}" ng-repeat="question in activeGroup.Questions | orderBy:\'order\' | limitTo: (activeGroup.groupSize - activeGroup.Questions.length)">\n\t\t\t\t\t\t\t\t\t<p class="task-list-item-label" ng-class="{\'is-mandatory\': question.Mandatory}">{{question.QuestionName}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!--\n\t\t\t\t\t<div class="question-block-onboarding__guide">\n\t\t\t\t\t\t<a ng-click="" class="quick-guide-video">\n\t\t\t\t\t\t\t<img\n\t\t\t\t\t\t\t\talt=""\n\t\t\t\t\t\t\t\tsrc="images/quick-guides/bulk-change.png"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t-->\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="question-block-onboarding__footer">\n\t\t\t\t<div class="question-block-onboarding__time">\n\t\t\t\t\t<i class="icon-clock question-block-onboarding__time-icon"></i> Estimated completion time  : {{activeGroup.timeToComplete}}\n\t\t\t\t</div>\n\t\t\t\t<div class="question-block-onboarding__action" ng-switch="activeGroup.OnboardingQuestionGroupID">\n\t\t\t\t\t<div ng-switch="activeGroup.OnboardingQuestionGroupID">\n\t\t\t\t\t\t<p class="question-block-onboarding__remaining" pc-switch-when="ONBOARDING_QUESTION_GROUPS.team">\n\t\t\t\t\t\t\t<span ng-if="activeGroup.totalPercentageComplete === 0">Ready to add team members?</span>\n\t\t\t\t\t\t\t<span ng-if="activeGroup.totalPercentageComplete !== 0">{{onboardingDashboard.teamMembers.length}} team members added</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="question-block-onboarding__remaining" ng-switch-default>\n\t\t\t\t\t\t\t<span ng-if="activeGroup.percentageComplete === 0">Ready to add your settings?</span>\n\t\t\t\t\t\t\t<span ng-if="activeGroup.percentageComplete < 100 && activeGroup.percentageComplete > 0">{{activeGroup.totalQuestionsRemaining}} questions left to answer</span>\n\t\t\t\t\t\t\t<span ng-if="activeGroup.percentageComplete === 100">All questions answered!</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Company -->\n\t\t\t\t\t<a href="" ng-click="openOnboardingWizardCompanyForm(activeGroup)" class="button l {{activeGroup.theme}}" pc-switch-when="ONBOARDING_QUESTION_GROUPS.company">{{activeGroup.buttonCopy}}</a>\n\t\t\t\t\t<!-- Profile -->\n\t\t\t\t\t<a href="" ng-click="openOnboardingWizardProfileForm(activeGroup)" class="button l {{activeGroup.theme}}" pc-switch-when="ONBOARDING_QUESTION_GROUPS.profile">{{activeGroup.buttonCopy}}</a>\n\t\t\t\t\t<!-- Team -->\n\t\t\t\t\t<a href="" ng-click="onboardingActions.toggleShowAddTeamMembers(onboardingActions)" class="button l {{activeGroup.theme}}" pc-switch-when="ONBOARDING_QUESTION_GROUPS.team">{{activeGroup.buttonCopy}}</a>\n\t\t\t\t\t<!-- Pension -->\n\t\t\t\t\t<a href="" ng-click="openCompanyPensionConnectorForm()" class="button l {{activeGroup.theme}}" pc-switch-when="ONBOARDING_QUESTION_GROUPS.workplacePension">{{activeGroup.buttonCopy}}</a>\n\t\t\t\t\t<!-- Payroll -->\n\t\t\t\t\t<a href="" ng-click="openCompanyPayrollWizard(activeGroup)" class="button l {{activeGroup.theme}}" pc-switch-when="ONBOARDING_QUESTION_GROUPS.payroll">{{activeGroup.buttonCopy}}</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/remote-location-card/remote-location-card.component.html','<div class="remote-location-card">\n\n\t<div class="remote-location-card_persona">\n\t\t<div class="remote-location_avatar">\n\t\t\t<avatar avatar-initial="{{$ctrl.teamMemberAdmin.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{$ctrl.teamMemberAdmin.UserID}}"></avatar>\n\t\t</div>\n\t\t<div class="remote-location-card_info">\n\t\t\t<div class="remote-location-card_info-name">{{$ctrl.teamMemberAdmin.Forename}}&nbsp;{{$ctrl.teamMemberAdmin.Surname}}</div>\n\t\t\t<div class="remote-location-card_info-email">{{$ctrl.teamMemberAdmin.EmailAddress}}</div>\n\t\t</div>\n\t</div>\n\n\t<div class="remote-location-card_ip-address">\n\t\t<span class="s italic greyscale" ng-if="!$ctrl.teamMemberAdmin.IPAddress"><i class="icon-location m"></i>&nbsp;&nbsp;No IP address added</span>\n\t\t<span ng-if="$ctrl.teamMemberAdmin.IPAddress"><i class="icon-location primary m"></i>&nbsp;&nbsp;{{$ctrl.teamMemberAdmin.IPAddress}}</span>\n\t</div>\n\n\t<dropdown-menu class="remote-location-card_action-menu primary" menu-size="l" menu-show-chevron="false" menu-icon="icon-setup" menu-show="$ctrl.showActionMenu">\n\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ng-click="$ctrl.openEditDetailsForm($ctrl, $ctrl.teamMemberAdmin.UserID)">{{$ctrl.hasIPAddress ? \'Edit\' : \'Add\'}} IP address</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="$ctrl.hasIPAddress">\n\t\t\t<a href="" class="assertive" ng-click="$ctrl.openDeleteRemoteLocationForm($ctrl, $ctrl.teamMemberAdmin.UserID)">Delete IP address</a>\n\t\t</div>\n\n\t</dropdown-menu>\n</div>');
$templateCache.put('components/remote-location-form-field/remote-location-form-field.component.html','<div class="remote-location-form-field">\n\n\t<div class="remote-location-form-field_persona">\n\t\t<div class="remote-location_avatar">\n\t\t\t<avatar avatar-initial="{{$ctrl.teamMemberAdmin.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{$ctrl.teamMemberAdmin.UserID}}"></avatar>\n\t\t</div>\n\t\t<div class="remote-location-form-field_info">\n\t\t\t<div class="remote-location-form-field_info-name">{{$ctrl.teamMemberAdmin.Forename}}&nbsp;{{$ctrl.teamMemberAdmin.Surname}}</div>\n\t\t\t<div class="remote-location-form-field_info-email">{{$ctrl.teamMemberAdmin.EmailAddress}}</div>\n\t\t</div>\n\t</div>\n\n\t<div class="remote-location-form-field_ip-address">\n\t\t<div class="form-field remote-location-form-field_ip-address-field" ng-if="$ctrl.teamMemberAdmin.hasIPAddress || !$ctrl.showDelete">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{$ctrl.ipAddressFieldName}}" class="remote-location-form-field_ip-address-label required">IP address:</label>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<ip-address ip-address="$ctrl.teamMemberAdmin.IPAddress" name="{{$ctrl.ipAddressFieldName}}" ip-address-required="true"></ip-address>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.ipAddressFieldName].$error" ng-show="$ctrl.form[$ctrl.ipAddressFieldName].$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid IP address</p>\n\t\t\t\t\t<p ng-message="required">Please enter an IP address</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="remote-location-form-field_ip-address-delete" ng-if="$ctrl.showDelete">\n\t\t\t\t<a class="greyscale" href="" ng-click="$ctrl.toggleConfirmDeleteIPAddress($ctrl.teamMemberAdmin)" ng-if="!$ctrl.teamMemberAdmin.confirmIPAddressDelete" aria-label="Delete IP address"><i class="icon-trash"></i></a>\n\t\t\t\t<div ng-if="$ctrl.teamMemberAdmin.confirmIPAddressDelete"><p class="s strong">Are you sure?&nbsp;\n\t\t\t\t\t<a href="" ng-click="$ctrl.toggleHasIPAddress($ctrl.teamMemberAdmin)">Yes</a><span class="greyscale">&nbsp;|&nbsp;</span><a href="" ng-click="$ctrl.toggleConfirmDeleteIPAddress($ctrl.teamMemberAdmin)">No</a></p></div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if="!$ctrl.teamMemberAdmin.hasIPAddress && $ctrl.showDelete">\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.toggleHasIPAddress($ctrl.teamMemberAdmin)" type="button">\n\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add IP address\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/repayment-card/repayment-card.component.html','<div class="repayment-card" ng-class="$ctrl.rcTheme">\n\n\t<div class="repayment-card_main" ng-class="{\'has-edit\': $ctrl.canEdit}" ng-switch="$ctrl.rcViewType">\n\n\t\t<div class="repayment-card_icon">\n\t\t\t<i class="icon-{{$ctrl.repayment.PaymentScheduleTypeID | paymentScheduleTypeIcon}} xl"></i>\n\t\t</div>\n\n\t\t<!-- Schedule -->\n\t\t<div class="repayment-card_details" ng-switch-when="schedule">\n\t\t\t<div class="repayment-card_meta is-full-width">\n\t\t\t\t<h5 class="repayment-card_label">Loan type</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.PaymentScheduleTypeDescription}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Loan amount</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmount | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Still to pay</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmountRemaining | monetise}}</h6>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Benefit\n\t\t<div class="repayment-card_details" ng-switch-when="benefit">\n\t\t\t<div class="repayment-card_meta is-full-width">\n\t\t\t\t<h5 class="repayment-card_label">{{$ctrl.repayment.PaymentScheduleTypeDescription}}</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmount + $ctrl.repayment.TotalBroughtForward | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Still to pay</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmountRemaining | monetise}}</h6>\n\t\t\t</div>\n\t\t</div>-->\n\n\t\t<!-- Benefit -->\n\t\t<div class="repayment-card_details" ng-switch-when="benefit">\n\t\t\t<div class="repayment-card_meta is-full-width">\n\t\t\t\t<!--<h5 class="repayment-card_label">{{$ctrl.repayment.PaymentScheduleTypeDescription}}</h5>-->\n\t\t\t\t<h5 class="repayment-card_label">Total</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmount | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Brought forward</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalBroughtForward | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Remaining</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmountRemaining | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="repayment-card_meta">\n\t\t\t\t<h5 class="repayment-card_label">Paid</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmountPaid | monetise}}</h6>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Amount Remaining -->\n\t\t<div class="repayment-card_details" ng-switch-when="payment">\n\t\t\t<div class="repayment-card_meta is-full-width">\n\t\t\t\t<h5 class="repayment-card_label">{{::$ctrl.rcLabel}}</h5>\n\t\t\t\t<h6 class="repayment-card_amount">{{$ctrl.repayment.TotalAmountRemaining | monetise}}</h6>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<a href="" ng-click="$ctrl.onEdit()" class="repayment-card_main-edit" ng-class="$ctrl.rcTheme" ng-if="$ctrl.canEdit" aria-label="Edit"><i class="icon-edit is-medium"></i></a>\n\n\t</div>\n\n\t<div class="repayment-card_footer">\n\t\t<div class="repayment-card_paysliplabel">\n\t\t\t<i class="icon-label m repayment-card_paysliplabel-tag"></i>\n\t\t\t<span class="repayment-card_paysliplabel-name">\n\t\t\t\t{{$ctrl.repayment.PayslipLabel ? $ctrl.repayment.PayslipLabel : \'No payslip label\'}}\n\t\t\t</span>\n\t\t</div>\n\n\t\t<div class="repayment-card_statuses" ng-if="$ctrl.isPayrollBenefit($ctrl.repayment)">\n\t\t\t<div class="repayment-card_status" tooltip tooltip-text="Payroll benefit" ng-if="$ctrl.isPayrollBenefit($ctrl.repayment)">\n\t\t\t\t<icon-dot icon="icon-clock" theme="has-hover {{::$ctrl.rcTheme}}"></icon-dot>\n\t\t\t</div>\n\t\t\t<!-- Salary sacrifice -->\n\t\t\t<div class="repayment-card_status" ng-if="$ctrl.repayment.PaymentScheduleGroupSalarySacrificeState" tooltip tooltip-position="left" tooltip-text="Included in salary sacrifice calculations">\n\t\t\t\t<icon-dot icon="icon-salary-change" theme="{{::$ctrl.rcTheme}} has-hover"></icon-dot>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n</div>\n');
$templateCache.put('components/report/report.component.html','<div class="report page-template-a" ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Error -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n\n\t<!-- No pay periods -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.noPayPeriods">\n\t\t<placeholder placeholder-graphic="no-report-packs">\n\t\t\t<placeholder-title>Payroll hasn\'t been run yet</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As soon as you run your first payroll, reports will become available here.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- No report data -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.noPreviousPeriod">\n\t\t<placeholder placeholder-graphic="report">\n\t\t\t<placeholder-title>There are no previous periods to compare</placeholder-title>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\n\t\t<section class="report_section" ng-class="{\n\t\t\t\t\'is-disabled\' : $ctrl.reportOptions.isReportFilterBarActive\n\t\t\t}" ng-if="$ctrl.reportOptions.isPayPeriodUnsubmitted">\n\t\t\t<p class="s strong">\n\t\t\t\t<span class="tertiary">WARNING:</span> These are draft reports. Please do not pay your team or HMRC using the data in these reports.\n\t\t\t\tThe data in this report is subject to change until payroll has been finalised and submitted to HMRC.\n\t\t\t</p>\n\t\t</section>\n\n\t\t<section class="report_section is-header" ng-class="{\n\t\t\t\t\'is-disabled\' : $ctrl.reportOptions.isReportFilterBarActive\n\t\t\t}">\n\t\t\t<page-template-a-header icon="stats" page-title="{{::$ctrl.reportDTO.DisplayName}}">\n\t\t\t\t<pt-secondary>\n\t\t\t\t\t<div class="report_actions">\n\t\t\t\t\t\t<div class="report_actions-item" ng-if="$ctrl.hasActions" ng-transclude="actions"></div>\n\n\t\t\t\t\t\t<button class="report_actions-item white" data-cy="report-toggle-full-screen" ng-click="$ctrl.onToggleFullScreen()" ng-if="$root.isFullScreenEnabled" type="button">\n\t\t\t\t\t\t\t<i class="icon-full-screen button_icon-pre"></i>\n\t\t\t\t\t\t\tToggle full screen\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<div class="report_actions-item">\n\t\t\t\t\t\t\t<report-exports ng-if="::$ctrl.reportDTO.ReportTemplate.ReportTemplateID !== $root.CONFIG.guidEmpty" report-dto="$ctrl.reportDTO" report-options="$ctrl.reportOptions" report-request="$ctrl.reportRequest" report-request-options="$ctrl.reportRequestOptions"></report-exports>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</pt-secondary>\n\t\t\t</page-template-a-header>\n\t\t\t<report-notice report-dto="$ctrl.reportDTO"></report-notice>\n\t\t</section>\n\n\t\t<!-- Filters -->\n\t\t<section class="report_section" ng-if="::$ctrl.reportOptions.filtersVisibilityDetail.isReportViewerFiltersVisible" data-cy="report-filters">\n\t\t\t<report-filter-bar active-filter-key="$ctrl.reportOptions.activeFilterKey" draft-report-request="$ctrl.draftReportRequest" report-dto="$ctrl.reportDTO" report-options="$ctrl.reportOptions" report-request-options="$ctrl.reportRequestOptions" report-request="$ctrl.reportRequest" setup-report="$ctrl.getReportFromRequest()"></report-filter-bar>\n\t\t</section>\n\n\t\t<!-- Report -->\n\t\t<section class="report_section fadeIn" data-cy="report-viewer" ng-hide="$ctrl.reportOptions.isReportFilterBarActive" ng-if="$ctrl.reportRequest">\n\t\t\t<report-viewer report-additional-data="$ctrl.reportAdditionalData" report-dto="$ctrl.reportDTO" report-options="$ctrl.reportOptions" report-request="$ctrl.reportRequest"></report-viewer>\n\t\t</section>\n\n\t\t<!-- Report loading -->\n\t\t<section class="report_section fadeIn" ng-hide="$ctrl.reportOptions.isReportFilterBarActive" ng-if="!$ctrl.reportRequest">\n\t\t\t<loading-block></loading-block>\n\t\t</section>\n\t</div>\n</div>\n');
$templateCache.put('components/report-card/report-card.component.html','<div class="report-card fadeIn" data-cy="report-card-{{$ctrl.report.DisplayName | slugify}}" ng-class="$ctrl.report.theme">\n\t<div class="report-card_bar"></div>\n\n\t<div class="report-card_header">\n\t\t<i class="report-card_icon" ng-class="$ctrl.report.icon"></i>\n\n\t\t<h6 class="report-card_heading">{{$ctrl.report.ReportTemplate.Category.ReportTemplateCategoryName}}</h6>\n\n\t\t<i class="report-card_tooltip icon-information m" ng-if="::$ctrl.report.ReportTemplate.ReportTemplateDescription" tooltip tooltip-text="{{$ctrl.report.ReportTemplate.ReportTemplateDescription}}" tooltip-position="is-icon"></i>\n\t</div>\n\n\t<div class="report-card_content">\n\t\t<h5 class="report-card_title">{{$ctrl.report.DisplayName}}</h5>\n\t</div>\n\n\t<div class="report-card_footer">\n\t\t<div class="report-card_action">\n\t\t\t<a href="" ui-sref="reporting.report({\n\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId,\n\t\t\t\t\treportDTO: $ctrl.report,\n\t\t\t\t\treportTemplateId: $ctrl.report.ReportTemplate.ReportTemplateID\n\t\t\t\t})" ui-sref-opts="{reload: true}" class="is-small is-strong" ng-class="$ctrl.report.theme">\n\t\t\t\t<i class="icon-right"></i>&nbsp;&nbsp;Open report\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="report-card_tags" ng-switch="$ctrl.report.ReportTemplate.Accessibility">\n\t\t\t<div class="tag" ng-class="$ctrl.report.theme" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.draft]">Draft</div>\n\t\t\t<div class="tag" ng-class="$ctrl.report.theme" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.final]">Final</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/report-card-clickable/report-card-clickable.component.html','<div class="clickable-report-card">\n\t<a ng-click="$ctrl.action()">\n\t\t<div class="clickable-report-card_content">\n\t\t\t<div class="float-right">\n\t\t\t\t<i class="{{$ctrl.icon}} is-large is-primary">\n\t\t\t\t</i>\n\t\t\t</div>\n\t\t\t<p class="is-strong">\n\t\t\t\t{{$ctrl.title}}\n\t\t\t</p>\n\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t{{$ctrl.subtitle}}\n\t\t\t</p>\n\t\t</div>\n\t</a>\n</div>\n');
$templateCache.put('components/report-column-filters/report-column-filters.component.html','<div class="report-column-filters" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}" ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div class="fadeInFast" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t<circle-loader size="\'m\'"></circle-loader>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="report-column-filters_wrapper fadeInFast" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\t\t<div class="report-column-filters_subheading" ng-if="$ctrl.isRootFilterGroup && $ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.length + $ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.length === 0">\n\t\t\t<p class="caption">\n\t\t\t\tClick &lsquo;Add&rsquo; to select from the filterable data in your report template\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="report-column-filters_content report-column-filters_items fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clauses" ng-if="$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.length > 0">\n\n\t\t\t<div class="report-column-filters_item is-clause fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}" ng-repeat="reportTemplateFilterClause in $ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses">\n\n\t\t\t\t<div class="report-column-filters_item-operator" ng-switch="$index">\n\t\t\t\t\t<div data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-operator" ng-switch-when="0">\n\t\t\t\t\t\tWhere\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-switch-when="1">\n\t\t\t\t\t\t<select class="s report-column-filters_item-operator-select" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-operator" id="reportTemplateFilterClauseOperator-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseOperator-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="$ctrl.reportTemplateFilterGroup.ReportTemplateFilterGroupOperator" ng-options="option.value as option.label for option in $ctrl.REPORT_TEMPLATE_FILTER_OPERATORS" required>\n\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-operator" ng-switch-default>\n\t\t\t\t\t\t{{ $ctrl.reportTemplateFilterGroup.ReportTemplateFilterGroupOperator | reportColumnFiltersOperationLabel }}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-column-filters_item-content">\n\n\t\t\t\t\t<div class="report-column-filters_clause">\n\n\t\t\t\t\t\t<!-- Column -->\n\t\t\t\t\t\t<div class="report-column-filters_clause-item">\n\t\t\t\t\t\t\t<select data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-column" class="report-column-filters_clause-dropdown inline-block" id="reportTemplateColumnId-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateColumnId-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-change="$ctrl.onClauseColumnChange(reportTemplateFilterClause)" ng-model="reportTemplateFilterClause.ReportTemplateColumnID" ng-options="option.ReportColumnID as option.ReportColumnName for option in $ctrl.reportTemplateColumns | reportColumnFiltersCorrectReportColumns" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Condition -->\n\t\t\t\t\t\t<div class="report-column-filters_clause-item fadeInFast" ng-if="reportTemplateFilterClause.ReportTemplateColumnID" ng-show="reportTemplateFilterClause.clauseConditions">\n\t\t\t\t\t\t\t<select data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-condition" class="report-column-filters_clause-dropdown is-greyscale inline-block" id="reportTemplateFilterClauseCondition-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseCondition-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseCondition" ng-options="option.ID as option.displayLabel for option in reportTemplateFilterClause.clauseConditions = $ctrl.getClauseConditionsForColumn(reportTemplateFilterClause)" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t<div class="report-column-filters_clause-item is-value fadeInFast" ng-if="reportTemplateFilterClause.clauseConditions && $ctrl.getClauseValueIsVisible(reportTemplateFilterClause)" ng-switch="$ctrl.getClauseValueTypeForCondition(reportTemplateFilterClause)">\n\n\t\t\t\t\t\t\t<!-- Text (Default) -->\n\t\t\t\t\t\t\t<input class="report-column-filters_clause-input inline-block fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-text" id="reportTemplateFilterClauseValueText-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseValueText-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseValue" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.text" placeholder="Value" required type="text">\n\n\t\t\t\t\t\t\t<!-- Select -->\n\t\t\t\t\t\t\t<select class="report-column-filters_clause-input inline-block fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-select" id="reportTemplateFilterClauseValueSelect-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseValueSelect-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseValue" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.select" ng-options="value for value in reportTemplateFilterClause.clauseValueOptions" required>\n\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t</select>\n\n\t\t\t\t\t\t\t<!-- Number -->\n\t\t\t\t\t\t\t<input class="report-column-filters_clause-input inline-block fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-numberic" id="reportTemplateFilterClauseValueNumberic-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseValueNumberic-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseValue" ng-pattern="$root.REGEX.numbersOnly" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.numberic" placeholder="Value" required type="text">\n\n\t\t\t\t\t\t\t\t<div class="report-column-filters_clause-errors fadeIn" ng-if="$ctrl.form[\'reportTemplateFilterClauseValueNumberic-\' + $ctrl.reportFilterGroupId + \'-\' + $index].$touched" ng-messages="$ctrl.form[\'reportTemplateFilterClauseValueNumberic-\' + $ctrl.reportFilterGroupId + \'-\' + $index].$error" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.numberic" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t<input autocomplete="off" class="report-column-filters_clause-input percentage fadeInFast s" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-percentage" id="reportTemplateFilterClauseValuePercentage-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseValuePercentage-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseValue" ng-pattern="$root.REGEX.decimal" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.percentage" placeholder="Value" type="text">\n\n\t\t\t\t\t\t\t<!-- Date -->\n\t\t\t\t\t\t\t<date-input-field field-id="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-date" field-style="report-column-filters_clause-input inline-block" field-value-iso="reportTemplateFilterClause.ReportTemplateFilterClauseValue" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.date"></date-input-field>\n\n\t\t\t\t\t\t\t<!-- Boolean -->\n\t\t\t\t\t\t\t<select class="report-column-filters_clause-dropdown inline-block" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-boolean" id="reportTemplateFilterClauseValueBoolean-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterClauseValueBoolean-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="reportTemplateFilterClause.ReportTemplateFilterClauseValue" pc-switch-when="$ctrl.CLAUSE_VALUE_TYPE.boolean" required>\n\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t<option value="True">True</option>\n\t\t\t\t\t\t\t\t<option value="False">False</option>\n\t\t\t\t\t\t\t</select>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-column-filters_item-action">\n\t\t\t\t\t<button aria-label="Delete clause" class="is-white is-icon-only is-greyscale" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-clause-{{$index}}-delete" ng-click="$ctrl.onClauseDelete($index)" type="button">\n\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="report-column-filters_items fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-groups" ng-if="$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups.length > 0">\n\n\t\t\t<div class="report-column-filters_item is-group fadeInFast" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-{{$index}}" ng-repeat="reportTemplateFilterGroup in $ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterGroups">\n\n\t\t\t\t<div class="report-column-filters_item-operator" ng-switch="$ctrl.reportTemplateFilterGroup.ChildReportTemplateFilterClauses.length+$index">\n\t\t\t\t\t<div data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-{{$index}}-operator" ng-switch-when="0">\n\t\t\t\t\t\tWhere\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-switch-when="1">\n\t\t\t\t\t\t<select class="s report-column-filters_item-operator-select" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-{{$index}}-operator" id="reportTemplateFilterGroupOperator-{{::$ctrl.reportFilterGroupId}}-{{$index}}" name="reportTemplateFilterGroupOperator-{{::$ctrl.reportFilterGroupId}}-{{$index}}" ng-model="$ctrl.reportTemplateFilterGroup.ReportTemplateFilterGroupOperator" ng-options="option.value as option.label for option in $ctrl.REPORT_TEMPLATE_FILTER_OPERATORS" required>\n\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">\n\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-{{$index}}-operator" ng-switch-default>\n\t\t\t\t\t\t{{ $ctrl.reportTemplateFilterGroup.ReportTemplateFilterGroupOperator | reportColumnFiltersOperationLabel }}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-column-filters_item-content">\n\t\t\t\t\t<report-column-filters on-delete-last-clause="$ctrl.onGroupDelete($index)" report-filter-components="$ctrl.reportFilterComponents" report-filter-empty-clause="$ctrl.reportFilterEmptyClause" report-filter-empty-group="$ctrl.reportFilterEmptyGroup" report-filter-group-id="$ctrl.reportFilterGroupId + \'-\' + $index" report-template-columns="$ctrl.reportTemplateColumns" report-template-filter-group="reportTemplateFilterGroup"></report-column-filters>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-column-filters_item-action">\n\t\t\t\t\t<button aria-label="Delete group" class="is-white is-icon-only is-greyscale" data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-{{$index}}-delete" ng-click="$ctrl.onGroupDelete($index)" type="button">\n\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="report-column-filters_footer" click-anywhere-but-here="$ctrl.showAddMenu = false" is-active="$ctrl.showAddMenu">\n\t\t\t<dropdown-menu menu-id="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-menu" menu-align="left" menu-icon-size="n" menu-icon="icon-add" menu-show="$ctrl.showAddMenu" menu-size="m" menu-text="Add" menu-theme="primary">\n\t\t\t\t<a data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-menu-filter" href="" ng-click="$ctrl.onAddReportFilterClause()">\n\t\t\t\t\tFilter\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="report-template-filter-group-{{::$ctrl.reportFilterGroupId}}-group-menu-filter-group" href="" ng-click="$ctrl.onAddReportFilterGroup()">\n\t\t\t\t\tFilter group\n\t\t\t\t</a>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<!-- Error -->\n\t<div class="fadeInFast" pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n</div>\n');
$templateCache.put('components/report-company-filters/report-company-filters.component.html','<div class="report-company-filters">\n\n\t<!-- Hidden input to disable the form if the selection is invalid -->\n\t<input hidden id="isCompanyFilterSelectionValid" name="isCompanyFilterSelectionValid" ng-model="$ctrl.isCompanyFilterSelectionValid" required type="checkbox">\n\n\t<div class="report-company-filters_header">\n\n\t\t<div class="report-company-filters_header-title">\n\t\t\t<i class="icon-company report-company-filters_header-icon"></i>\n\n\t\t\t<h5 class="report-company-filters_header-heading">\n\t\t\t\t<ng-pluralize count="$ctrl.selectedCompanyOptions.length" when="{\n\t\t\t\t\t\t\'0\': \'No companies selected\',\n\t\t\t\t\t\t\'1\': \'1 company selected\',\n\t\t\t\t\t\t\'other\': \'{} companies selected\',\n\t\t\t\t\t\t[$ctrl.reportRequestOptions.CompanyOptions.length]: \'All companies selected\'\n\t\t\t\t\t}"></ng-pluralize>\n\t\t\t</h5>\n\t\t</div>\n\n\t\t<div class="report-company-filters_header-actions">\n\t\t\t<div class="report-company-filters_header-action">\n\t\t\t\t<input class="report-company-filters_actions-search small" data-cy="report-company-filters-search" id="report-company-filters-search-input" name="report-company-filters-search-input" ng-model="$ctrl.searchBarOptions.string" placeholder="Search groups and companies\u2026" type="search">\n\t\t\t</div>\n\n\t\t\t<div class="report-company-filters_header-action report-company-filters_actions-links inline-links">\n\t\t\t\t<a data-cy="report-company-filters-select-all" href ng-click="$ctrl.onAllCompanyToggle(true)" ng-if="!$ctrl.isCompanyCountGreaterThanMaxAllowedCompanies">\n\t\t\t\t\tSelect all\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="report-company-filters-clear-all" href ng-click="$ctrl.onAllCompanyToggle(false)">\n\t\t\t\t\tClear all\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="report-company-filters_header-action">\n\t\t\t\t<input checkbox class="s" data-cy="report-company-filters-exclude-archived-companies" id="excludeArchivedCompanies" label-text="\'Exclude archived\'" name="excludeArchivedCompanies" ng-change="$ctrl.onExcludeArchivedChange()" ng-model="$ctrl.excludeArchivedCompanies" type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<!-- Max company selection warning -->\n\t<div class="report-company-filters_warning" ng-if="$ctrl.isCompanyCountGreaterThanMaxAllowedCompanies">\n\t\t<message-block has-drop-in="false" icon="information" theme="indifferent is-inline">\n\t\t\t<p>\n\t\t\t\tPlease note that this report can be run for a maximum of\n\t\t\t\t<ng-pluralize count="$ctrl.reportRequestOptions.MaxCompanySelections" when="{\n\t\t\t\t\t\t\'1\': \'1 company\',\n\t\t\t\t\t\t\'other\': \'{} companies\'\n\t\t\t\t\t}"></ng-pluralize>.\n\t\t\t</p>\n\t\t</message-block>\n\t</div>\n\n\t<div class="report-company-filters_list">\n\n\t\t<div class="report-company-filters_list-group fadeIn" ng-repeat="companyType in $ctrl.companyTypes.types" ng-show="companyType.typeListFiltered.length > 0">\n\t\t\t<h6 class="report-company-filters_group-heading">{{companyType.typeName}}:</h6>\n\n\t\t\t<div class="report-company-filters_group-content cards">\n\n\t\t\t\t<a class="report-company-filters_group-item fadeIn" data-cy="report-company-filters-{{companyType.typeName | slugify}}-{{$index}}" ng-click="$ctrl.onCompanyClick(company)" ng-class="{ \'is-selected\' : company.isSelected, \'is-group\': company.isCompanyGroup} " dir-paginate="company in companyType.typeListFiltered =\n\t\t\t\t\t\t( companyType.typeList |\n\t\t\t\t\t\t\treportingExcludeArchived:$ctrl.excludeArchivedCompanies |\n\t\t\t\t\t\t\tfilter : {\'CompanyName\': $ctrl.searchBarOptions.string }\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : \'CompanyName\' |\n\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.itemsPerPage" pagination-id="companyType.typeId">\n\t\t\t\t\t<div class="report-company-filters_item-checkbox checkbox-field">\n\t\t\t\t\t\t<input id="{{company.CompanyID}}" name="{{company.CompanyID}}" ng-model="company.isSelected" type="checkbox">\n\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="{{company.CompanyID}}"></label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="report-company-filters_item-header">\n\t\t\t\t\t\t<span class="report-company-filters_item-name">\n\t\t\t\t\t\t\t<truncate text="company.CompanyName" truncate-amount="35"></truncate>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<span class="report-company-filters_item-description" ng-if="company.isCompanyGroup">\n\t\t\t\t\t\t\t<ng-pluralize count="(company.ChildInformation.childCompanies | reportingExcludeArchived:$ctrl.excludeArchivedCompanies).length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</a>\n\n\t\t\t</div>\n\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" pagination-id="companyType.typeId"></dir-pagination-controls>\n\t\t</div>\n\n\t</div>\n</div>\n');
$templateCache.put('components/report-download-card/report-download-card.component.html','<div class="report-download-card" click-anywhere-but-here="$ctrl.menuShow = false" is-active="$ctrl.menuShow">\n\t<!-- Classic report -->\n\t<div ng-if="::$ctrl.report.ReportTemplate.IsClassicReport">\n\n\t\t<h5 class="report-download-card_title">{{::$ctrl.report.DisplayName}}</h5>\n\t\t<h6 class="report-download-card_meta" ng-if="$ctrl.showCreatedDate">Created at {{::$ctrl.report.CreatedDateISO | datetimeformat:\'detailed\'}}\n\t\t</h6>\n\n\t\t<!-- Preview standard report -->\n\t\t<div ng-if="::$ctrl.report.CanView">\n\t\t\t<i class="icon-chevron-right report-download-card_icon"></i>\n\t\t\t<a data-cy="{{::$ctrl.getDisplayNameFormatForId()}}-preview-link" href="" ng-click="$ctrl.viewReport()" class="report-download-card_action" aria-label="View report">\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Download standard report-->\n\t\t<div ng-if="$ctrl.report.CanDownload">\n\t\t\t<div ng-if="!$ctrl.canRegenerateBacs || ($ctrl.canRegenerateBacs && $ctrl.report.ReportTemplate.ReportTemplateID !== $ctrl.REPORT_TEMPLATE_IDS.bacs)">\n\t\t\t\t<i class="icon-download report-download-card_icon"></i>\n\t\t\t\t<a aria-label="Export report" class="report-download-card_action" data-cy="{{::$ctrl.getDisplayNameFormatForId()}}-download-link" href="" ng-click="$ctrl.exportReportDTO($ctrl.report)">\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- Load or regenerate -->\n\t\t\t<div ng-if="$ctrl.canRegenerateBacs && $ctrl.report.ReportTemplate.ReportTemplateID === $ctrl.REPORT_TEMPLATE_IDS.bacs">\n\n\t\t\t\t<!-- Regenerated -->\n\t\t\t\t<div class="tag primary inverse report-download-card_regenerated-tag" ng-if="$ctrl.report.HasBeenRegenerated" tooltip tooltip-text="{{$ctrl.payPeriod.BACSRegeneratedBy}} at {{$ctrl.payPeriod.BACSRegeneratedDateISO | dateformat: \'timeDate24\'}}">\n\t\t\t\t\tREGENERATED\n\t\t\t\t</div>\n\n\t\t\t\t<dropdown-menu class="report-download-card_action-menu" menu-size="l" menu-icon="icon-setup" menu-show="$ctrl.menuShow">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a data-cy="{{::$ctrl.getDisplayNameFormatForId()}}-download-action" href="" ng-click="$ctrl.report.IsDownloadConfirmationRequired ?\n\t\t\t\t\t\t\t$ctrl.openBacsConfirmationForm($ctrl.report) :\n\t\t\t\t\t\t\t$ctrl.exportReportDTO($ctrl.report)">\n\t\t\t\t\t\t\tDownload\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="{{::$ctrl.getDisplayNameFormatForId()}}-regenerate-action" href="" ng-click="$ctrl.openRegenerateBACSFileForm($ctrl)" ng-if="!$ctrl.report.IsDownloadConfirmationRequired">\n\t\t\t\t\t\t\tRegenerate\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Custom report -->\n\t<div ng-if="::!$ctrl.report.ReportTemplate.IsClassicReport">\n\t\t<p class="report-download-card_title">{{::$ctrl.report.DisplayName}}</p>\n\t\t<i class="icon-chevron-right report-download-card_icon"></i>\n\t\t<a aria-label="View report" class="report-download-card_action" data-cy="{{::$ctrl.getDisplayNameFormatForId()}}-preview-link" href="" ng-click="$ctrl.viewReport()">\n\t\t</a>\n\t</div>\n\n</div>\n');
$templateCache.put('components/report-downloads/report-downloads.component.html','<div class="report-downloads" ng-switch="$ctrl.componentState">\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.loading" class="centered-contents fadeIn">\n\t\t<circle-loader class="m"></circle-loader>\n\t</div>\n\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.ready" class="fadeIn">\n\n\t\t<div class="report-downloads_row is-header-row">\n\t\t\t<div class="report-downloads_title report-downloads_label">Name</div>\n\n\t\t\t<div class="report-downloads_option report-downloads_label" ng-repeat="reportFormat in $ctrl.reportFormats">\n\t\t\t\t<a class="report-downloads_label-type" ng-click="$ctrl.onFormatClick($ctrl, reportFormat)">{{::reportFormat.ReportTemplateFormatTypeName}}</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="report-downloads_row report-downloads_card" ng-repeat="reportTemplate in $ctrl.reportTemplates | orderBy:\'Category.ReportTemplateCategoryID\'" ng-class="{\'is-active\': reportTemplate.isActive}">\n\n\t\t\t<div class="report-downloads_title report-downloads_card-title">\n\t\t\t\t<a class="report-downloads_title report-downloads_card-name" ng-click="$ctrl.onReportTemplateClick($ctrl, reportTemplate)">{{::reportTemplate.ReportTemplateName}}</a>\n\t\t\t</div>\n\n\t\t\t<div class="report-downloads_option report-downloads_checkbox" ng-class="{\'is-hidden\': !reportFormat.showFormatInTemplate }" ng-repeat="reportFormat in reportTemplate.ReportTemplateFormats">\n\n\t\t\t\t<input checkbox id="{{::reportFormat.reportTemplateFormatId}}" name="{{::reportFormat.reportTemplateFormatId}}" ng-change="$ctrl.onReportFormatCheckboxChange($ctrl, reportTemplate)" ng-disabled="::!reportFormat.showFormatInTemplate" ng-model="reportFormat.includeReportInDownload" ng-readonly="::!reportFormat.showFormatInTemplate" type="checkbox">\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error" class="fadeIn">\n\t\t<error-block></error-block>\n\t</div>\n</div>\n');
$templateCache.put('components/report-entry/report-entry.component.html','<div class="report-entry" data-pc="report-entry-wrapper" ng-class="[\n\t\t$ctrl.reportOptions.reportTheme,\n\t\t{\n\t\t\t\'has-multiple-entries\': $ctrl.reportOptions.hasMultipleEntries,\n\t\t\t\'is-collapsed\': $ctrl.reportOptions.hasMultipleEntries && !$ctrl.customReportEntry.showFullEntry\n\t\t}\n\t]">\n\n\t<div class="report-entry_container">\n\t\t<div data-pc="report-entry-data-grid"></div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/report-export-item/report-export-item.component.html','<a class="fadeIn" data-cy="report-export-item-{{ ::$ctrl.displayName | slugify }}" href="" ng-click="$ctrl.componentState === $ctrl.COMPONENT_STATES.waiting ? $ctrl.exportReportDTO() : null" ng-switch="$ctrl.componentState">\n\t<i ng-class="$ctrl.report.exportIcon"></i>\n\t<span pc-switch-when="$ctrl.COMPONENT_STATES.waiting">{{ ::$ctrl.displayName }}</span>\n\t<span pc-switch-when="$ctrl.COMPONENT_STATES.loading"><circle-loader size="\'s\'"></circle-loader></span>\n</a>\n');
$templateCache.put('components/report-exports/report-exports.component.html','<menu-button menu-button-add-icon="false" menu-button-id="report-exports-button" menu-button-size="s" menu-button-text="Export as" menu-button-theme="{{!$ctrl.reportRequest || !$ctrl.reportDto.ExportOptions.length ? \'disabled\' : \'primary\' }}">\n\n\t<div>\n\t\t<report-export-item ng-repeat="report in $ctrl.reportDto.ExportOptions | orderBy:\'FormatTypeDisplayName\'" report-request-options="$ctrl.reportRequestOptions" report-request="$ctrl.reportRequest" report="report" show-full-name="false"></report-export-item>\n\t</div>\n\n</menu-button>\n');
$templateCache.put('components/report-filter-bar/report-filter-bar.component.html','<div class="report-filter-bar">\n\n\t<section class="report-filter-bar_buttons fadeIn" ng-if="!$ctrl.reportOptions.isReportFilterBarActive">\n\n\t\t<!-- Columns -->\n\t\t<button class="report-filter-bar_button is-white is-icon-only" data-cy="report-filter-bar-toggle-columns" ng-click="$ctrl.onFilterTypeClick($ctrl.FILTER_TYPES.columns)" ng-if="::$ctrl.reportOptions.filtersVisibilityDetail.isColumnFilterVisible" type="button">\n\t\t\t<span class="report-filter-bar_button-layout fadeIn">\n\t\t\t\t<i class="report-filter-bar_button-icon icon-filter"></i>\n\t\t\t\t<h6 class="report-filter-bar_button-heading">\n\t\t\t\t\t<ng-pluralize count="($ctrl.draftReportRequest.ReportTemplateFilter.ReportTemplateFilterGroup | reportFilterGroupClauseCount)" when="{\n\t\t\t\t\t\t\t\'0\': \'No filters\',\n\t\t\t\t\t\t\t\'1\': \'1 filter\',\n\t\t\t\t\t\t\t\'other\': \'{} filters\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</h6>\n\t\t\t\t<i class="report-filter-bar_button-action icon-chevron-down"></i>\n\t\t\t</span>\n\t\t</button>\n\n\t\t<!-- Periods -->\n\t\t<button class="report-filter-bar_button is-white is-icon-only" data-cy="report-filter-bar-toggle-periods-$index" ng-click="$ctrl.onFilterTypeClick($ctrl.FILTER_TYPES.periods, $index)" ng-if="::$ctrl.reportOptions.filtersVisibilityDetail.isPeriodFilterVisible" ng-repeat="periodOption in $ctrl.draftReportRequest.PeriodOptions" type="button">\n\t\t\t<span class="report-filter-bar_button-layout fadeIn">\n\t\t\t\t<i class="report-filter-bar_button-icon icon-calendar"></i>\n\t\t\t\t<h6 class="report-filter-bar_button-heading" ng-bind-html="::periodOption | reportFilterPeriodDisplay : $ctrl.reportRequest : $ctrl.reportRequestOptions"></h6>\n\t\t\t\t<i class="report-filter-bar_button-action icon-chevron-down"></i>\n\t\t\t</span>\n\t\t</button>\n\n\t\t<!-- Companies -->\n\t\t<button class="report-filter-bar_button is-white is-icon-only" data-cy="report-filter-bar-toggle-companies" ng-click="$ctrl.onFilterTypeClick($ctrl.FILTER_TYPES.companies)" ng-if="::$ctrl.reportOptions.filtersVisibilityDetail.isCompanyFilterVisible" type="button">\n\t\t\t<span class="report-filter-bar_button-layout fadeIn">\n\t\t\t\t<i class="report-filter-bar_button-icon icon-company"></i>\n\t\t\t\t<h6 class="report-filter-bar_button-heading">\n\t\t\t\t\t<ng-pluralize count="$ctrl.draftReportRequest.CompanyIDs.length" when="{\n\t\t\t\t\t\t\t\'0\': \'No companies selected\',\n\t\t\t\t\t\t\t\'1\': \'1 company selected\',\n\t\t\t\t\t\t\t\'other\': \'{} companies selected\',\n\t\t\t\t\t\t\t[$ctrl.reportRequestOptions.CompanyOptions.length]: \'All companies selected\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</h6>\n\t\t\t\t<i class="report-filter-bar_button-action icon-chevron-down"></i>\n\t\t\t</span>\n\t\t</button>\n\n\t\t<!-- Additional -->\n\t\t<button class="report-filter-bar_button is-white is-icon-only" data-cy="report-filter-bar-toggle-additional-$index" ng-click="$ctrl.onFilterTypeClick($ctrl.FILTER_TYPES.additional, $index)" ng-if="::$ctrl.reportOptions.filtersVisibilityDetail.isAdditionalFilterVisible" ng-repeat="additionalOption in $ctrl.reportRequestOptions.AdditionalOptions" type="button">\n\t\t\t<span class="report-filter-bar_button-layout fadeIn">\n\t\t\t\t<i class="report-filter-bar_button-icon icon-settings"></i>\n\t\t\t\t<h6 class="report-filter-bar_button-heading">{{additionalOption.Title}}: {{ ::additionalOption | reportFilterValueDisplay : $ctrl.draftReportRequest.AdditionalOptions[$index] }}</h6>\n\t\t\t\t<i class="report-filter-bar_button-action icon-chevron-down"></i>\n\t\t\t</span>\n\t\t</button>\n\n\t</section>\n\n\t<form class="report-filter-bar_selector fadeIn" name="reportFilterBarForm" ng-if="$ctrl.reportOptions.isReportFilterBarActive" ng-submit="$ctrl.onSubmit(reportFilterBarForm)" ng-switch="$ctrl.activeFilterType.key" novalidate>\n\n\t\t<!-- Additional -->\n\t\t<section class="report-filter-bar_content fadeIn" pc-switch-when="$ctrl.FILTER_TYPES.additional.key">\n\n\t\t\t<div ng-if="$ctrl.activeFilterType.activeIndex === $index" ng-repeat="additionalOption in $ctrl.reportRequestOptions.AdditionalOptions">\n\t\t\t\t<div class="report-filter-bar_header">\n\t\t\t\t\t<div class="report-filter-bar_header-title">\n\t\t\t\t\t\t<i class="icon-settings report-filter-bar_header-icon"></i>\n\t\t\t\t\t\t<h5 class="report-filter-bar_header-heading">\n\t\t\t\t\t\t\t{{::additionalOption.Title}}\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p class="report-filter-bar_header-paragraph">{{::additionalOption.Description}}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<report-filter-inputs report-active-filter-option="additionalOption" report-request-filter-option="$ctrl.draftReportRequest.AdditionalOptions[$index]"></report-filter-inputs>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Columns -->\n\t\t<section class="report-filter-bar_content fadeIn" pc-switch-when="$ctrl.FILTER_TYPES.columns.key">\n\n\t\t\t<div class="report-filter-bar_header">\n\t\t\t\t<div class="report-filter-bar_header-title">\n\t\t\t\t\t<i class="icon-filter report-filter-bar_header-icon"></i>\n\t\t\t\t\t<h5 class="report-filter-bar_header-heading">\n\t\t\t\t\t\tFilters\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<p class="report-filter-bar_header-paragraph">Editing filters will only apply to your current view and not the original report template</p>\n\t\t\t</div>\n\n\t\t\t<report-column-filters is-root-filter-group="true" report-template-columns="$ctrl.reportDto.ReportTemplate.ReportTemplateColumns" report-template-filter-group="$ctrl.draftReportRequest.ReportTemplateFilter.ReportTemplateFilterGroup"></report-column-filters>\n\t\t</section>\n\n\t\t<!-- Companies -->\n\t\t<section class="report-filter-bar_content fadeIn" pc-switch-when="$ctrl.FILTER_TYPES.companies.key">\n\t\t\t<report-company-filters report-request-options="$ctrl.reportRequestOptions" selected-company-options="$ctrl.draftReportRequest.CompanyIDs"></report-company-filters>\n\t\t</section>\n\n\t\t<!-- Periods -->\n\t\t<section class="report-filter-bar_content fadeIn" pc-switch-when="$ctrl.FILTER_TYPES.periods.key">\n\n\t\t\t<div class="report-filter-bar_header">\n\t\t\t\t<div class="report-filter-bar_header-title">\n\t\t\t\t\t<i class="icon-calendar report-filter-bar_header-icon"></i>\n\t\t\t\t\t<h5 class="report-filter-bar_header-heading">\n\t\t\t\t\t\tView report as\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<report-period-filters ng-if="$ctrl.activeFilterType.activeIndex === $index" ng-repeat="periodOption in $ctrl.draftReportRequest.PeriodOptions" report-request-options="$ctrl.reportRequestOptions" report-request-period-option="periodOption"></report-period-filters>\n\t\t</section>\n\n\t\t<div class="report-filter-bar_footer">\n\n\t\t\t<submit-button button-id="report-filter-bar-submit" button-theme="\'is-small is-primary\'" disable-button="reportFilterBarForm.$invalid || ($ctrl.activeFilterType.isSubmitDisabled && $ctrl.activeFilterType.isSubmitDisabled())" display-text="$ctrl.reportRequest ? \'Update report\' : \'View report\'" icon="icon-loading" icon-position="left" state="reportFilterBarForm.state"></submit-button>\n\n\t\t\t<button class="button is-small" data-cy="report-filter-bar-cancel" ng-disabled="$ctrl.activeFilterType.isCancelDisabled && $ctrl.activeFilterType.isCancelDisabled()" ng-click="$ctrl.onCancel()" ng-if="$ctrl.reportRequest" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t</div>\n\t</form>\n</div>\n');
$templateCache.put('components/report-filter-inputs/report-filter-inputs.component.html','<div class="report-filter-inputs" ng-switch="$ctrl.reportActiveFilterOption.Type">\n\n\t<!-- Single Dropdown List -->\n\t<div class="report-filter-inputs_field fadeIn" pc-switch-when="$ctrl.REPORT_PERIOD_OPTION_TYPE.singleDropDownList">\n\t\t<select class="l" data-cy="report-filter-inputs-single-dropdown-value" id="value" name="value" ng-change="$ctrl.onFilterValueChange()" ng-model="$ctrl.reportRequestFilterOption.Value" ng-options="item.Value as item.Name for item in $ctrl.reportActiveFilterOption.Items" required>\n\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\tSelect an option...\n\t\t\t</option>\n\t\t</select>\n\t</div>\n\n\t<!-- Range Dropdown List -->\n\t<div class="report-filter-inputs_field fadeIn" pc-switch-when="$ctrl.REPORT_PERIOD_OPTION_TYPE.rangeDropDownLists">\n\t\t<select class="l" data-cy="report-filter-inputs-range-dropdown-value-one" id="valueOne" name="valueOne" ng-model="$ctrl.reportRequestFilterOption.Values[0]" ng-options="item.Value as item.Name for item in $ctrl.reportActiveFilterOption.Items" ng-change="$ctrl.getApplicableSecondValueListForRange()" required>\n\n\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\tSelect an option...\n\t\t\t</option>\n\t\t</select>\n\n\t\t<div class="report-filter-inputs_divider">\n\t\t\t<i class="icon-arrow-right is-medium is-primary"></i>\n\t\t</div>\n\n\t\t<select class="l" data-cy="report-filter-inputs-range-dropdown-value-two" id="valueTwo" name="valueTwo" ng-change="$ctrl.onFilterValueChange()" ng-model="$ctrl.reportRequestFilterOption.Values[1]" ng-options="item.Value as item.Name for item in $ctrl.reportActiveFilterOption.valueTwoItems" required>\n\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\tSelect an option...\n\t\t\t</option>\n\t\t</select>\n\t</div>\n\n\t<!-- Date Range -->\n\t<div class="report-filter-inputs_field fadeIn" pc-switch-when="$ctrl.REPORT_PERIOD_OPTION_TYPE.rangeCalendarDatePickers">\n\t\t<div class="date-range">\n\t\t\t<div class="date-range__input">\n\t\t\t\t<date-input-field field-id="report-filter-inputs-date-range-value-one" field-on-change-fn="$ctrl.onFilterValueChange()" field-style="l" field-value-iso="$ctrl.reportRequestFilterOption.Values[0]" field-placeholder="Select a date..." field-required="true"></date-input-field>\n\t\t\t</div>\n\n\t\t\t<div class="date-range__icon">\n\t\t\t\t<i class="icon-arrow-right is-medium is-primary"></i>\n\t\t\t</div>\n\n\t\t\t<div class="date-range__input">\n\t\t\t\t<date-input-field field-id="report-filter-inputs-date-range-value-two" field-on-change-fn="$ctrl.onFilterValueChange()" field-style="l" field-value-iso="$ctrl.reportRequestFilterOption.Values[1]" field-placeholder="Select a date..." field-required="true"></date-input-field>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Radios -->\n\t<ul class="report-filter-inputs_field is-radios fadeIn" pc-switch-when="$ctrl.REPORT_PERIOD_OPTION_TYPE.radioButton">\n\t\t<li class="report-filter-inputs_radio" ng-repeat="item in $ctrl.reportActiveFilterOption.Items">\n\t\t\t<input class="b is-small" id="{{item.Value | slugify}}" ng-change="$ctrl.onFilterValueChange()" ng-model="$ctrl.reportRequestFilterOption.Value" ng-value="item.Value" type="radio">\n\t\t\t<label class="report-filter-inputs_radio-label" for="{{item.Value | slugify}}">\n\t\t\t\t{{::item.Name}}\n\t\t\t</label>\n\t\t</li>\n\n\t</ul>\n\n</div>\n');
$templateCache.put('components/report-notice/report-notice.component.html','\n<note ng-if="$ctrl.noticeInfo" note-dismiss="true" note-icon="icon-warning" note-theme="assertive" note-title="{{::$ctrl.noticeInfo.title}}">\n\t<note-content>\n\t\t<p class="s" ng-bind-html="$ctrl.noticeInfo.notice"></p>\n\t</note-content>\n</note>');
$templateCache.put('components/report-pack-row/report-pack-row.component.html','<div class="report-pack-row">\n\t<div class="report-pack-row_detail">\n\t\t<div class="report-pack-row_icon">\n\t\t\t<i class="m" ng-class="[$ctrl.reportTemplate.theme, $ctrl.reportTemplate.icon]"></i>\n\t\t</div>\n\t\t<div class="report-pack-row_title">\n\t\t\t<h6 class="report-pack-row_heading">{{$ctrl.reportTemplate.ReportTemplateName}}</h6>\n\t\t</div>\n\t</div>\n\t<div class="report-pack-row_actions">\n\n\t\t<div class="report-pack-row_tags" ng-switch="$ctrl.reportTemplate.Accessibility">\n\t\t\t<div class="report-pack-row_tag" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.draft]">\n\t\t\t\t<span ng-class="$ctrl.reportTemplate.theme" class="tag" tooltip tooltip-text="Visible in draft payroll reports">Draft</span>\n\t\t\t</div>\n\t\t\t<div class="report-pack-row_tag" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.final]">\n\t\t\t\t<span ng-class="$ctrl.reportTemplate.theme" class="tag" tooltip tooltip-text="Visible in final payroll reports">Final</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="report-pack-row_action" ng-class="[$ctrl.reportTemplate.theme, {\'is-hidden\' : !$ctrl.reportTemplate.IsVisible }]" tooltip tooltip-text="{{$ctrl.reportTemplate.IsVisible ? \'Visible\' : \'Hidden\'}}">\n\t\t\t<i class="icon-{{$ctrl.reportTemplate.IsVisible ? \'visible\' : \'hidden\'}} m"></i>\n\t\t</div>\n\n\t\t<a href="" ng-if="$ctrl.onTemplateEdit" ng-click="$ctrl.onTemplateEdit()" class="report-pack-row_action is-greyscale" aria-label="Edit pack">\n\t\t\t<i class="icon-edit l"></i>\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/report-period-filters/report-period-filters.component.html','<div class="report-period-filters">\n\n\t<!-- Hidden input to disable the form if selection is invalid -->\n\t<input hidden id="isPeriodFilterSelectionValid" name="isPeriodFilterSelectionValid" ng-model="$ctrl.isPeriodFilterSelectionValid" required type="checkbox">\n\n\t<!-- Available Period Options -->\n\t<section class="report-period-filters_section" ng-if="$ctrl.reportRequestOptions.PeriodOptions.length > 1">\n\n\t\t<ul class="report-period-filters_radios">\n\n\t\t\t<li class="report-period-filters_radios-radio" ng-repeat="periodOption in $ctrl.reportRequestOptions.PeriodOptions">\n\t\t\t\t<input class="b" data-cy="report-period-filters-period-option-{{periodOption.Title | slugify}}" id="{{periodOption.Key}}" name="reportRequestKey" ng-change="$ctrl.onReportRequestPeriodOptionKeyChange()" ng-model="$ctrl.reportRequestPeriodOption.Key" ng-value="periodOption.Key" type="radio">\n\t\t\t\t<label class="report-period-filters_radios-radio-label" for="{{periodOption.Key}}">\n\t\t\t\t\t{{periodOption.Title}}\n\t\t\t\t</label>\n\t\t\t</li>\n\n\t\t</ul>\n\n\t</section>\n\n\t<!-- Comparison report label -->\n\t<section class="report-period-filters_section" ng-if="::$ctrl.reportRequestOptions.comparisonReportCurrentPeriod">\n\t\t<div class="report-period-filters_heading">\n\t\t\t<label for="comparisonStartDate">Compare {{::$ctrl.reportRequestOptions.comparisonReportCurrentPeriod.Name}} to</label>\n\t\t</div>\n\t</section>\n\n\t<!-- Inputs -->\n\t<section class="report-period-filters_section">\n\n\t\t<report-filter-inputs on-filter-value-change="$ctrl.onPeriodFilterValueChange()" report-active-filter-option="$ctrl.activeFilterOption" report-request-filter-option="$ctrl.reportRequestPeriodOption"></report-filter-inputs>\n\n\t</section>\n\n\t<!-- Period warning -->\n\t<section class="report-period-filters_section fadeIn" ng-if="\n\t\t\t$ctrl.reportRequestOptions.MaxDateRangeMonths &&\n\t\t\t[\n\t\t\t\t$ctrl.REPORT_PERIOD_FILTER_KEYS.dateRange,\n\t\t\t\t$ctrl.REPORT_PERIOD_FILTER_KEYS.periodRange\n\t\t\t].includes($ctrl.activeFilterOption.Key)\n\t\t">\n\t\t<message-block has-drop-in="false" icon="information" theme="indifferent is-inline">\n\t\t\t<p>\n\t\t\t\tPlease note that this report can be run for a maximum of\n\t\t\t\t<ng-pluralize count="$ctrl.reportRequestOptions.MaxDateRangeMonths" when="{\n\t\t\t\t\t\t\'1\': \'1 pay period\',\n\t\t\t\t\t\t\'other\': \'{} pay periods\'\n\t\t\t\t\t}"></ng-pluralize>.\n\t\t\t</p>\n\t\t</message-block>\n\t</section>\n</div>\n');
$templateCache.put('components/report-settings-card/report-settings-card.component.html','<div class="report-settings-card" ng-class="$ctrl.report.reportTheme">\n\t<div class="report-settings-card_header">\n\t\t<a class="report-settings-card_heading">{{$ctrl.report.ReportName}} <i class="icon-chevron-right"></i></a>\n\n\t\t<div class="report-settings-card_action"><i class="icon-trash"></i></div>\n\t</div>\n\n\t<div class="report-settings-card_content">\n\t\t<div class="report-settings-card_stats">\n\n\t\t\t<div class="report-settings-card_stat">\n\t\t\t\t<i class="report-settings-card_stat-icon icon-stats"></i>\n\t\t\t\t<span class="report-settings-card_stat-text">{{$ctrl.report.ReportTypeDisplay}}</span>\n\t\t\t</div>\n\n\t\t\t<div class="report-settings-card_stat">\n\t\t\t\t<i class="report-settings-card_stat-icon icon-company"></i>\n\n\t\t\t\t<span class="report-settings-card_stat-text">\n\t\t\t\t\t<ng-pluralize count="$ctrl.report.ReportCompanyCount" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<p class="report-settings-card_detail">\n\t\t\tSaved by {{$ctrl.report.ReportCreator}} at {{$ctrl.report.ReportCreationDateISO | dateformat:\'timeDate\'}}\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/report-template-card/report-template-card.component.html','<div class="report-template-card fadeIn" data-cy="report-template-card-{{::$ctrl.reportTemplate.ReportTemplateName | slugify}}" ng-class="$ctrl.reportTemplate.theme">\n\n\t<div class="report-template-card_header">\n\t\t<div class="report-template-card_icon"><i ng-class="$ctrl.reportTemplate.icon"></i></div>\n\n\t\t<h6 class="report-template-card_heading" data-cy="report-template-card-template-name">\n\t\t\t{{$ctrl.reportTemplate.ReportTemplateName}}\n\t\t</h6>\n\n\t\t<dropdown-menu class="report-template-card_menu" menu-icon="icon-setup" menu-id="report-template-card-menu" menu-show-chevron="false" menu-show="vm.showActionMenu" menu-size="l" menu-theme="{{$ctrl.reportTemplate.theme}}" ng-if="!$ctrl.reportTemplate.IsClassicReport">\n\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a data-cy="report-template-card-menu-action-edit" href="" ng-click="$ctrl.openReportTemplateForm(true)" ng-if="$ctrl.reportTemplate.CanEditAndDeleteTemplate && $ctrl.reportTemplate.companyOwnsReport">\n\t\t\t\t\tEdit\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="report-template-card-menu-action-preview" href="" ng-click="$ctrl.openReportPreview()">\n\t\t\t\t\tPreview\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="report-template-card-menu-action-duplicate" href="" ng-click="$ctrl.openReportTemplateForm(false, true)" ng-if="$ctrl.reportTemplate.CanDuplicateTemplate">\n\t\t\t\t\tDuplicate\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="dropdown-group" ng-if="$ctrl.reportTemplate.CanEditAndDeleteTemplate && $ctrl.reportTemplate.companyOwnsReport">\n\t\t\t\t<a class="assertive" data-cy="report-template-card-menu-action-delete" href="" ng-click="$ctrl.openDeleteReportTemplateForm()">\n\t\t\t\t\tDelete\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t</dropdown-menu>\n\t</div>\n\n\t<div class="report-template-card_content">\n\t\t<p class="report-template-card_paragraph" data-cy="report-template-card-template-description">\n\t\t\t{{$ctrl.reportTemplate.ReportTemplateDescription}}\n\t\t</p>\n\t</div>\n\n\t<div class="report-template-card_footer">\n\t\t<div class="report-template-card_stat-wrapper" ng-if="$ctrl.reportTemplate.ColumnCount > 0">\n\n\t\t\t<!-- Column Count -->\n\t\t\t<div class="report-template-card_stat">\n\t\t\t\t<i class="icon-columns report-template-card_stat-icon"></i>\n\t\t\t\t<span class="report-template-card_stat-stat" data-cy="report-template-card-template-column-count">\n\t\t\t\t\t{{$ctrl.reportTemplate.ColumnCount}}\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<!-- Filters -->\n\t\t\t<div class="report-template-card_stat" data-cy="report-template-card-template-has-filter" ng-if="$ctrl.reportTemplate.HasFilter">\n\t\t\t\t<i class="icon-filter report-template-card_stat-icon"></i>\n\t\t\t</div>\n\n\t\t\t<!-- Split By -->\n\t\t\t<div class="report-template-card_stat" data-cy="report-template-card-template-split-by" ng-if="$ctrl.reportTemplate.hasSplitBy">\n\t\t\t\t<i class="icon-split report-template-card_stat-icon"></i>\n\t\t\t</div>\n\n\t\t\t<!-- Group By -->\n\t\t\t<div class="report-template-card_stat" data-cy="report-template-card-template-group-by" ng-if="$ctrl.reportTemplate.hasGroupBy">\n\t\t\t\t<i class="icon-merge-rows report-template-card_stat-icon"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="report-template-card_tags" ng-switch="$ctrl.reportTemplate.Accessibility">\n\t\t\t<div class="tag" data-cy="report-template-card-template-accessibility-draft" ng-class="$ctrl.reportTemplate.theme" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.draft]">\n\t\t\t\tDraft\n\t\t\t</div>\n\t\t\t<div class="tag" data-cy="report-template-card-template-accessibility-final" ng-class="$ctrl.reportTemplate.theme" pc-switch-when="[$ctrl.REPORT_TEMPLATE_ACCESSIBILITY.finalAndDraft, $ctrl.REPORT_TEMPLATE_ACCESSIBILITY.final]">\n\t\t\t\tFinal\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/report-template-columns/report-template-columns.component.html',' <div class="report-template-columns">\n\t<div class="report-template-columns_layout">\n\n\t\t<!-- Category columns -->\n\t\t<div class="report-template-columns_area">\n\n\t\t\t<div class="report-template-columns_area-header">\n\t\t\t\t<h4 class="report-template-columns_area-title">Available <span class="report-template-columns_area-counter">({{$ctrl.totalAvailableColumns}})</span></h4>\n\n\t\t\t\t<div class="report-template-columns_area-aside">\n\n\t\t\t\t\t<a aria-label="Toggle search" class="report-template-columns_area-aside-item" href="" data-cy="report-template-columns-search-toggle" ng-click="$ctrl.toggleSearch()">\n\t\t\t\t\t\t<i class="icon-search"></i>\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- Repeat columns -->\n\t\t\t\t\t<div class="report-template-columns_area-aside-item" click-anywhere-but-here="$ctrl.showAddMenu = false" is-active="$ctrl.showAddMenu" ng-if="$ctrl.reportCategory.repeatColumns.length > 0">\n\n\t\t\t\t\t\t<dropdown-menu menu-icon-size="n" menu-icon="icon-add" menu-id="report-template-columns-add-menu" menu-show="$ctrl.showAddMenu" menu-size="m" menu-text="Add" menu-theme="primary">\n\t\t\t\t\t\t\t<a data-cy="report-template-columns-add-menu-column-{{column.ReportColumnName | slugify}}" href="" ng-click="$ctrl.addRepeatColumnToReport(column)" ng-repeat="column in $ctrl.reportCategory.repeatColumns">\n\t\t\t\t\t\t\t\t{{::column.ReportColumnName}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="report-template-columns_area-search fadeIn" ng-if="$ctrl.showSearch">\n\t\t\t\t<div class="report-template-columns_area-search-input">\n\t\t\t\t\t<input class="small block" data-cy="report-template-columns-search-input" id="search-input" name="search-input" ng-change="$ctrl.onSearchChange()" ng-model="$ctrl.searchTerm" placeholder="Search columns..." type="search">\n\t\t\t\t</div>\n\n\t\t\t\t<a aria-label="Toggle search" class="report-template-columns_area-search-action" data-cy="report-template-columns-search-close" href="" ng-click="$ctrl.toggleSearch()">\n\t\t\t\t\t<i class="n icon-cross"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="report-template-columns_area-content" data-cy="report-template-columns-unselected-groups">\n\n\t\t\t\t<div class="report-template-columns_unselected-list fadeIn" data-cy="report-template-columns-unselected-group-{{group.ReportColumnGroupName | slugify}}" ng-repeat="group in $ctrl.reportCategory.ColumnGroups" ng-show="group.filteredReportColumns.length > 0">\n\n\t\t\t\t\t<div class="report-template-columns_unselected-header">\n\t\t\t\t\t\t<h5 class="report-template-columns_unselected-title">{{::group.ReportColumnGroupName}}</h5>\n\n\t\t\t\t\t\t<div class="report-template-columns_unselected-actions fadeIn" ng-if="group.filteredReportColumns.length > 1">\n\t\t\t\t\t\t\tSelect:\n\t\t\t\t\t\t\t<a data-cy="report-template-columns-unselected-group-{{group.ReportColumnGroupName | slugify}}-select-all" href="" ng-click="$ctrl.toggleAllColumnsInGroup(group, true)">\n\t\t\t\t\t\t\t\tAll\n\t\t\t\t\t\t\t</a>&nbsp;|&nbsp;\n\t\t\t\t\t\t\t<a data-cy="report-template-columns-unselected-group-{{group.ReportColumnGroupName | slugify}}-select-none" href="" ng-click="$ctrl.toggleAllColumnsInGroup(group, false)">\n\t\t\t\t\t\t\t\tNone\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<ul>\n\n\t\t\t\t\t\t<li class="report-template-columns_unselected fadeIn" data-cy="report-template-columns-unselected-column" ng-repeat="column in group.filteredReportColumns = (group.ReportColumns | filter : { ReportColumnName: $ctrl.searchTerm })">\n\t\t\t\t\t\t\t<input class="pc-checkbox" data-cy="report-template-columns-unselected-column-{{group.ReportColumnGroupName | slugify}}-column-{{column.ReportColumnName | slugify}}-select" id="sorting-{{column.ReportColumnID}}" label-text="column.ReportColumnName" name="{{column.ReportColumnID}}" ng-change="$ctrl.toggleIsColumnSelected(column)" ng-model="column.isSelected" type="checkbox">\n\n\t\t\t\t\t\t\t<label class="report-template-columns_unselected-label" for="sorting-{{column.ReportColumnID}}">\n\t\t\t\t\t\t\t\t{{::column.ReportColumnName}}\n\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t<i class="report-template-columns_icon icon-split" ng-if="::column.ReportColumnCanSplit"></i>\n\n\t\t\t\t\t\t\t<i class="report-template-columns_icon icon-merge-rows" ng-if="::column.ReportColumnCanGroup"></i>\n\t\t\t\t\t\t</li>\n\n\t\t\t\t\t</ul>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-template-columns_area-placeholder fadeIn" ng-if="$ctrl.isSearchReturningZeroColumns">\n\t\t\t\t\t<div class="report-template-columns_area-placeholder-icon">\n\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="primary is-extra-large"></icon-dot>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="report-template-columns_area-placeholder-message">\n\t\t\t\t\t\t<h6>No results found</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Report columns -->\n\t\t<div class="report-template-columns_area">\n\n\t\t\t<div class="report-template-columns_area-header">\n\t\t\t\t<h4 class="report-template-columns_area-title">\n\t\t\t\t\tSelected\n\t\t\t\t\t<span class="report-template-columns_area-counter">({{$ctrl.report.ReportTemplateColumns.length}})</span>\n\t\t\t\t</h4>\n\n\t\t\t\t<h6 class="report-template-columns_area-aside italic">(Drag to reorder)</h6>\n\t\t\t</div>\n\n\t\t\t<div class="report-template-columns_area-content" data-cy="report-template-columns-selected-columns">\n\n\t\t\t\t<ng-form class="report-template-columns_selected-list marginless fadeIn" name="$ctrl.form.selectedColumnsForm" ng-if="$ctrl.report.ReportTemplateColumns.length">\n\n\t\t\t\t\t<ul list-data="$ctrl.report.ReportTemplateColumns" list-item-id="ReportTemplateColumnEntryID" list-sort>\n\n\t\t\t\t\t\t<li class="report-template-columns_selected fadeInFast" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}" ng-class="{\n\t\t\t\t\t\t\t\t\'is-edit-visible\': column.isColumnEditVisible,\n\t\t\t\t\t\t\t\t\'is-column-hidden\': column.isColumnHidden\n\t\t\t\t\t\t\t}" list-item-id="{{column.ReportTemplateColumnEntryID}}" ng-attr-draggable="{{$ctrl.form.selectedColumnsForm.$valid ? \'true\' : \'false\'}}" ng-repeat="column in $ctrl.report.ReportTemplateColumns track by $index">\n\n\t\t\t\t\t\t\t<div class="report-template-columns_selected-header" ng-class="{\n\t\t\t\t\t\t\t\t\t\'clickable\' : $ctrl.form.selectedColumnsForm.$valid\n\t\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t\t<!-- Show override if it exists but fixed name when being edited -->\n\t\t\t\t\t\t\t\t<h3 class="report-template-columns_selected-label" data-cy="report-template-columns-selected-column-label" ng-if="!column.isColumnEditVisible">\n\t\t\t\t\t\t\t\t\t{{ $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) }}\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<h3 class="report-template-columns_selected-label" data-cy="report-template-columns-selected-column-label" ng-if="column.isColumnEditVisible">\n\t\t\t\t\t\t\t\t\t{{:: $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) }}\n\t\t\t\t\t\t\t\t</h3>\n\n\t\t\t\t\t\t\t\t<div class="report-template-columns_selected-actions" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'is-inactive\' : $ctrl.form.selectedColumnsForm.$invalid,\n\t\t\t\t\t\t\t\t\t\t\'invisible\' : column.isColumnEditVisible\n\t\t\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t\t\t<!-- Hidden column -->\n\t\t\t\t\t\t\t\t\t<span aria-label="Column is hidden" class="report-template-columns_selected-icon fadeIn" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-is-hidden" ng-if="column.isColumnHidden">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-hidden is-normal"></i>\n\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t<!-- Open edit mode -->\n\t\t\t\t\t\t\t\t\t<button aria-label="Edit column" class="is-clear report-template-columns_selected-icon is-action" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-action-edit" ng-click="$ctrl.onColumnEditClick(column)" type="button">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-edit is-normal"></i>\n\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t<!-- Duplicate -->\n\t\t\t\t\t\t\t\t\t<button class="is-clear report-template-columns_selected-icon is-action" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-action-duplicate" ng-click="$ctrl.onColumnDuplicateClick(column, $index)" type="button">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-duplicate is-normal"></i>\n\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t<!-- Deselect column -->\n\t\t\t\t\t\t\t\t\t<button aria-label="Deselect column" class="is-clear report-template-columns_selected-icon is-action" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-action-deselect" ng-click="$ctrl.onColumnDelselectClick(column)" type="button">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-cross is-normal"></i>\n\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Used to make parent form invalid when edit mode is on, valid but not saved -->\n\t\t\t\t\t\t\t\t<input hidden name="{{column.ReportTemplateColumnEntryID}}-columnEditIsOpen" ng-model="column.isColumnValid" required type="checkbox">\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<form class="report-template-columns_selected-area fadeIn marginless" id="{{column.ReportTemplateColumnEntryID}}-entryForm" name="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\']" ng-if="column.isColumnEditVisible" ng-submit="$ctrl.onColumnEditSubmit(column)">\n\t\t\t\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t\t\t\t<div class="form-section-subheading">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\t\t\t\t\tOriginal name: {{::column.ReportColumnName}}\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Column Name Override -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="is-small" for="{{column.ReportTemplateColumnEntryID}}-columnNameOverride" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'required\': column.isDuplicatedColumn\n\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\tColumn name override:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<input data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-name-override" id="{{column.ReportTemplateColumnEntryID}}-columnNameOverride" name="columnNameOverride" ng-change="$ctrl.onColumnNameOverrideChange(column, $ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].columnNameOverride)" ng-model="column.columnNameOverride" ng-pattern="$root.REGEX.lettersAndNumbers" ng-required="column.isDuplicatedColumn" type="text">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].columnNameOverride.$touched" ng-messages="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].columnNameOverride.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Column name override required</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter only letters and numbers</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="nonUnique">Unique column name required</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Column Visibility -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="is-small has-no-margin" for="{{column.ReportTemplateColumnEntryID}}-columnVisibilityVisible">\n\t\t\t\t\t\t\t\t\t\t\t\tVisibility:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t<p>Hidden columns can still be used to filter</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list is-inline">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b is-small" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-visibility-visible" id="{{column.ReportTemplateColumnEntryID}}-columnVisibilityVisible" name="columnVisibility" ng-model="column.isColumnHidden" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="{{column.ReportTemplateColumnEntryID}}-columnVisibilityVisible">Visible</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b is-small" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-visibility-hidden" id="{{column.ReportTemplateColumnEntryID}}-columnVisibilityHidden" name="columnVisibility" ng-model="column.isColumnHidden" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="{{column.ReportTemplateColumnEntryID}}-columnVisibilityHidden">Hidden</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Column Formats -->\n\t\t\t\t\t\t\t\t\t<div class="form-field" ng-if="::column.ReportColumnSelectableFormats.length > 1">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="is-small" for="{{::column.ReportTemplateColumnEntryID}}-columnEntryFormat">\n\t\t\t\t\t\t\t\t\t\t\t\tFormat:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item" ng-repeat="columnFormat in column.ReportColumnSelectableFormats | orderBy: \'-ReportTemplateColumnFormatIsDefault\' ">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b is-small" data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-format-{{columnFormat.ReportTemplateColumnFormatSpecifier | slugify}}" id="{{::column.ReportTemplateColumnEntryID}}-columnEntryFormat-{{::columnFormat.ReportTemplateColumnFormatID}}" name="{{::column.ReportTemplateColumnEntryID}}-columnEntryFormat" ng-model="column.reportTemplateColumnEntryFormat" ng-value="columnFormat" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="{{::column.ReportTemplateColumnEntryID}}-columnEntryFormat-{{::columnFormat.ReportTemplateColumnFormatID}}">{{columnFormat.ReportTemplateColumnFormatDescription}}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Column Specified Text -->\n\t\t\t\t\t\t\t\t\t<div class="form-field" ng-if="::column.ReportColumnCanSetSpecifiedText">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="is-small" for="{{::column.ReportTemplateColumnEntryID}}-reportTemplateColumnEntrySpecifiedText">\n\t\t\t\t\t\t\t\t\t\t\t\tContent:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<input data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-specified-text" id="{{::column.ReportTemplateColumnEntryID}}-reportTemplateColumnEntrySpecifiedText" name="reportTemplateColumnEntrySpecifiedText" ng-model="column.reportTemplateColumnEntrySpecifiedText" ng-pattern="$root.REGEX.lettersAndNumbers" type="text">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].reportTemplateColumnEntrySpecifiedText.$touched" ng-messages="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].reportTemplateColumnEntrySpecifiedText.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter only letters and numbers.</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="report-template-columns_selected-footer">\n\t\t\t\t\t\t\t\t\t\t<button data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-submit" class="button primary" type="submit" ng-disabled="$ctrl.form[column.ReportTemplateColumnEntryID + \'-entryForm\'].$invalid">\n\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button data-cy="report-template-columns-selected-column-{{column.ReportColumnName | slugify}}-cancel" ng-click="$ctrl.onColumnEditCancel(column)" type="button">\n\t\t\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t</form>\n\n\t\t\t\t\t\t</li>\n\n\t\t\t\t\t</ul>\n\n\t\t\t\t</ng-form>\n\n\t\t\t\t<div class="report-template-columns_placeholder fadeIn" ng-if="!$ctrl.report.ReportTemplateColumns.length">\n\n\t\t\t\t\t<img alt="Select from the available columns to include them in this template" class="report-template-columns_placeholder-media" src="images/graphics/report-template-empty.jpg">\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t</div>\n</div>\n');
$templateCache.put('components/report-template-creator/report-template-creator.component.html','<div class="report-template-creator">\n\n\t<div class="report-template-creator_container" ng-switch="$ctrl.componentState">\n\n\t\t<!-- Loading -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\n\t\t<!-- Error -->\n\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t\t<error-block></error-block>\n\t\t</div>\n\n\t\t<!-- Ready -->\n\t\t<div class="report-template-creator_wrapper slide-in-form fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\n\t\t\t<form autocomplete="off" class="report-template-creator_layout fadeIn no-margin" name="$ctrl.reportTemplateCreatorForm" ng-submit="$ctrl.saveForm()">\n\n\t\t\t\t<nav class="report-template-creator_layout-nav report-template-creator_nav" data-cy="report-template-creator-nav">\n\n\t\t\t\t\t<div class="side-bar-item_wrapper">\n\n\t\t\t\t\t\t<side-bar-item heading="\'Name\'" icon="icon-document-1" id="report-template-tab-name" is-active="$ctrl.activeTab === $ctrl.TABS.name" on-click="$ctrl.setActiveTab($ctrl.TABS.name)" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t\t\t\t\t<side-bar-item heading="\'Columns\'" icon="icon-columns" id="report-template-tab-columns" is-active="$ctrl.activeTab === $ctrl.TABS.columns" is-disabled="!$ctrl.reportCategory.ColumnGroups" on-click="$ctrl.setActiveTab($ctrl.TABS.columns)" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t\t\t\t\t<side-bar-item heading="\'Settings\'" icon="icon-settings" id="report-template-tab-settings" is-active="$ctrl.activeTab === $ctrl.TABS.settings" is-disabled="!$ctrl.reportCategory.ColumnGroups" on-click="$ctrl.setActiveTab($ctrl.TABS.settings)" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t\t\t\t\t<side-bar-item heading="\'Filters\'" icon="icon-filter" id="report-template-tab-filters" is-active="$ctrl.activeTab === $ctrl.TABS.filters" is-disabled="!$ctrl.getIsReportViewerFiltersColumnFilterVisible($ctrl.reportTemplate, true)" on-click="$ctrl.setActiveTab($ctrl.TABS.filters)" theme="is-primary" variant="is-plain"></side-bar-item>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</nav>\n\n\t\t\t\t<div class="report-template-creator_layout-header report-template-creator_header">\n\n\t\t\t\t\t<div class="report-template-creator_header-layout">\n\n\t\t\t\t\t\t<div class="report-template-creator_header-section" ng-switch="$ctrl.activeTab">\n\n\t\t\t\t\t\t\t<!-- Name -->\n\t\t\t\t\t\t\t<p class="fadeIn is-small" pc-switch-when="$ctrl.TABS.name">\n\t\t\t\t\t\t\t\tChoose a report type and enter a name for your template:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Columns -->\n\t\t\t\t\t\t\t<p class="fadeIn is-small" pc-switch-when="$ctrl.TABS.columns">\n\t\t\t\t\t\t\t\tSelect the columns to include in your template:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Settings -->\n\t\t\t\t\t\t\t<p class="fadeIn is-small" pc-switch-when="$ctrl.TABS.settings">\n\t\t\t\t\t\t\t\tConfigure payroll and display settings for your template:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Filters -->\n\t\t\t\t\t\t\t<p class="fadeIn is-small" pc-switch-when="$ctrl.TABS.filters">\n\t\t\t\t\t\t\t\tAdd any filters you wish to apply to your template:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="report-template-creator_header-section has-actions">\n\n\t\t\t\t\t\t\t<button class="is-small" data-cy="report-template-close" ng-click="$ctrl.reportTemplateCreatorOptions.closeModal()" type="button">\n\t\t\t\t\t\t\t\tClose\n\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t<button class="is-small" data-cy="report-template-preview" ng-click="$ctrl.openReportPreview()" ng-disabled="$ctrl.reportTemplateCreatorForm.$invalid || $ctrl.reportTemplate.ReportTemplateColumns.length === 0" type="button">\n\t\t\t\t\t\t\t\tPreview\n\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t<submit-button button-id="report-template-save" button-theme="\'tertiary is-small\'" disable-button="$ctrl.reportTemplateCreatorForm.$invalid || $ctrl.reportTemplate.ReportTemplateColumns.length === 0" display-text="\'Save\'" state="$ctrl.reportTemplateCreatorForm.state"></submit-button>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="report-template-creator_layout-body report-template-creator_body" ng-class="{\n\t\t\t\t\t\t\'has-no-overflow\': $ctrl.activeTab === $ctrl.TABS.columns\n\t\t\t\t\t}">\n\t\t\t\t\t<div class="report-template-creator_body-container">\n\n\t\t\t\t\t\t<!-- Name -->\n\t\t\t\t\t\t<div class="report-template-creator_body-tab fadeIn" ng-show="$ctrl.activeTab === $ctrl.TABS.name">\n\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset is-narrow">\n\n\t\t\t\t\t\t\t\t<!-- Report type -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="reportCategory" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'disabled\' : !$ctrl.canChangeCategory\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\tReport type:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select class="xl" data-cy="report-template-category" id="reportTemplateCategoryId" name="reportTemplateCategoryId" ng-change="$ctrl.onReportCategoryChange()" ng-disabled="!$ctrl.canChangeCategory" ng-model="$ctrl.reportTemplate.Category.ReportTemplateCategoryID" ng-options="category.ReportTemplateCategoryID as category.ReportTemplateCategoryName for category in $ctrl.reportCategories | orderBy:\'ReportTemplateCategoryName\'" required>\n\t\t\t\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="reportTemplateForm.reportCategory.$touched" ng-messages="$ctrl.reportTemplateCreatorForm.reportCategory.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a report type</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Report name -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="reportTemplateName">\n\t\t\t\t\t\t\t\t\t\t\tReport name:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input data-cy="report-template-name" id="reportTemplateName" name="reportTemplateName" ng-model="$ctrl.reportTemplate.ReportTemplateName" placeholder="Type here..." required type="text">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="reportTemplateForm.reportTemplateName.$touched" ng-messages="$ctrl.reportTemplateCreatorForm.reportTemplateName.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a name for this report template</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Report description -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="reportTemplateDescription">Description:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<textarea data-cy="report-template-description" id="reportTemplateDescription" maxlength="250" name="reportTemplateDescription" ng-model="$ctrl.reportTemplate.ReportTemplateDescription" placeholder="Type here..." rows="3"></textarea>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="reportTemplateForm.reportTemplateDescription.$touched" ng-messages="$ctrl.reportTemplateCreatorForm.reportTemplateDescription.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="maxlength">Only 250 characters are allowed</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.reportCategory && $ctrl.reportCategory.ColumnGroups">\n\t\t\t\t\t\t\t\t\t<a class="is-strong is-primary is-small" href="" ng-click="$ctrl.setActiveTab($ctrl.TABS.columns)" type="button">\n\t\t\t\t\t\t\t\t\t\tMove on to select columns <i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Columns -->\n\t\t\t\t\t\t<div class="report-template-creator_body-tab fadeIn" ng-if="$ctrl.reportCategory && $ctrl.reportCategory.ColumnGroups" ng-show="$ctrl.activeTab === $ctrl.TABS.columns">\n\n\t\t\t\t\t\t\t<report-template-columns report="$ctrl.reportTemplate" report-category="$ctrl.reportCategory"></report-template-columns>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Settings -->\n\t\t\t\t\t\t<div class="report-template-creator_body-tab report-template-creator_split fadeIn" ng-show="$ctrl.activeTab === $ctrl.TABS.settings">\n\n\t\t\t\t\t\t\t<!-- Downloads -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-clock"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Payroll reporting</h4>\n\t\t\t\t\t\t\t\t\t<p class="form-fieldset-header_paragraph">\n\t\t\t\t\t\t\t\t\t\tUse this report for payroll as well as displaying it in the general reporting area.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Display as draft -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Display in DRAFT reports after payroll has been calculated" field-model="$ctrl.reportTemplate.accessibilityIsDraft" field-name="report-template-accessibility-display-draft"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Display as final -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Display in FINAL reports after payroll has been submitted" field-model="$ctrl.reportTemplate.accessibilityIsFinal" field-name="report-template-accessibility-display-final"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Include in report downloads -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Include as download option in payroll reports ZIP and auto-sending of payroll reports" field-model="$ctrl.reportTemplate.CanAddToCollection" field-name="report-templte-can-add-to-collection"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<!-- Headers -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-excel"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Headers</h4>\n\t\t\t\t\t\t\t\t\t<p class="form-fieldset-header_paragraph">\n\t\t\t\t\t\t\t\t\t\tShow or hide the header row for downloadable reports.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Hide headers -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Hide headers for downloads and auto-sending of payroll reports" field-model="$ctrl.reportTemplate.ReportTemplateHideHeaders" field-name="report-template-hide-headers"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<!-- Display -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset" ng-if="$ctrl.reportCategory.ReportTemplateCategoryHasComparison || $ctrl.reportCategory.ReportTemplateCategoryHasTotals">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-expand-all"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Totals display</h4>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Show comparison -->\n\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.reportCategory.ReportTemplateCategoryHasComparison">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Use this report to compare values" field-model="$ctrl.reportTemplate.ShowComparison" field-name="report-template-show-comparison"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Show totals -->\n\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.reportCategory.ReportTemplateCategoryHasTotals">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Show \u2018Totals\u2019 row at the foot of tables" field-model="$ctrl.showTotals" field-name="report-template-show-totals" field-show-detail="$ctrl.reportTemplate.ShowComparison && $ctrl.showTotals">\n\t\t\t\t\t\t\t\t\t\t\t<toggle-input-detail>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list is-inline">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-show-totals-sum" id="showTotalsSum" name="showTotals" ng-model="$ctrl.reportTemplate.ShowTotals" ng-value="$ctrl.REPORT_TEMPLATE_TOTALS_TYPE.sum" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="showTotalsSum">Sum</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-show-totals-difference-decimal" id="showTotalsDifferenceDecimal" name="showTotals" ng-model="$ctrl.reportTemplate.ShowTotals" ng-value="$ctrl.REPORT_TEMPLATE_TOTALS_TYPE.differenceDecimal" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="showTotalsDifferenceDecimal">Difference (decimal)</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-show-totals-difference-percentage" id="showTotalsDifferencePercent" name="showTotals" ng-model="$ctrl.reportTemplate.ShowTotals" ng-value="$ctrl.REPORT_TEMPLATE_TOTALS_TYPE.differencePercentage" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="showTotalsDifferencePercent">Difference (%)</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</toggle-input-detail>\n\t\t\t\t\t\t\t\t\t\t</toggle-input>\n\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<!-- Sort by -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset" ng-show="$ctrl.reportTemplate.ReportTemplateColumns.length > 0">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-sort"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Sort by</h4>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select class="xl" data-cy="report-template-order-by-column" id="orderByColumn" name="orderByColumn" ng-model="$ctrl.reportTemplate.orderByColumn" ng-options="column as $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) for column in $ctrl.reportTemplate.ReportTemplateColumns">\n\t\t\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select a column...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-order-by-ascending" id="isOrderedDescendingFalse" name="isOrderedDescending" ng-model="$ctrl.reportTemplate.isOrderedDescending" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="isOrderedDescendingFalse">Ascending</label>\n\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-order-by-descending" id="isOrderedDescendingTrue" name="isOrderedDescending" ng-model="$ctrl.reportTemplate.isOrderedDescending" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="isOrderedDescendingTrue">Descending</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<!-- Table splitting -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset" ng-show="$ctrl.splittableReportTemplateColumns.length > 0">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-split"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Table Splitting</h4>\n\t\t\t\t\t\t\t\t\t<p class="form-fieldset-header_paragraph">\n\t\t\t\t\t\t\t\t\t\tSplit this report into separate tables instead of displaying as a single table. Only one header can be selected.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t\t\t<div class="radio-list">\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-table-splitting-none" id="no-splitting" name="tableSplitting" ng-model="$ctrl.reportTemplate.splitByColumn" ng-value="null" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="no-splitting">No splitting</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item fadeIn" ng-repeat="column in $ctrl.splittableReportTemplateColumns = (\n\t\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.reportTemplate.ReportTemplateColumns |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tReportColumnCanSplit: true\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t)">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-table-splitting-{{ $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) | slugify}}" id="splitting-{{column.ReportTemplateColumnEntryID}}" name="tableSplitting" ng-model="$ctrl.reportTemplate.splitByColumn" ng-value="column" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="splitting-{{column.ReportTemplateColumnEntryID}}">Split by {{ $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) }}</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<!-- Row merging -->\n\t\t\t\t\t\t\t<fieldset class="report-template-creator_fieldset" ng-show="$ctrl.mergeableReportTemplateColumns.length > 0">\n\n\t\t\t\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t\t\t\t<div class="form-fieldset-header_icon"><i class="icon-merge-rows"></i></div>\n\t\t\t\t\t\t\t\t\t<h4 class="form-fieldset-header_heading">Row merging</h4>\n\t\t\t\t\t\t\t\t\t<p class="form-fieldset-header_paragraph">\n\t\t\t\t\t\t\t\t\t\tMerge table rows into a single row containing a total amount. Only one header can be selected.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t\t\t<div class="radio-list">\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-row-merging-none" id="no-merging" name="rowMerging" ng-model="$ctrl.reportTemplate.groupByColumn" ng-value="null" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="no-merging">No merging</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item fadeIn" ng-repeat="column in $ctrl.mergeableReportTemplateColumns = (\n\t\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.reportTemplate.ReportTemplateColumns |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tReportColumnCanGroup: true\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t)">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="report-template-row-merging-{{ $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) | slugify}}" id="grouping-{{column.ReportTemplateColumnEntryID}}" name="rowMerging" ng-model="$ctrl.reportTemplate.groupByColumn" ng-value="column" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="grouping-{{column.ReportTemplateColumnEntryID}}">Merge by {{ $ctrl.getReportTemplateSelectedColumnEditModeDisplayLabel(column) }}</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Filters -->\n\t\t\t\t\t\t<div class="report-template-creator_body-tab fadeIn" ng-if="$ctrl.getIsReportViewerFiltersColumnFilterVisible($ctrl.reportTemplate, true)" ng-show="$ctrl.activeTab === $ctrl.TABS.filters" ng-switch="$ctrl.filterState">\n\n\t\t\t\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\t\t\t\t\t\t\t\t<report-column-filters is-root-filter-group="true" is-within-report-creator="true" report-template-columns="$ctrl.reportTemplate.ReportTemplateColumns" report-template-filter-group="$ctrl.reportTemplateFilter.ReportTemplateFilterGroup"></report-column-filters>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t\t\t\t\t\t\t<loading-block></loading-block>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</form>\n\n\t\t</div>\n\n\t\t<!-- Preview -->\n\t\t<div class="report-template-creator_preview fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.preview">\n\t\t\t<report report-options="$ctrl.reportPreviewOptions">\n\t\t\t\t<report-actions>\n\t\t\t\t\t<a class="report_header-action button white" data-cy="report-template-creator-back-to-settings" href="" ng-click="$ctrl.onBackToTemplateSettings()">\n\t\t\t\t\t\t<i class="icon-back"></i>\n\t\t\t\t\t\tBack to template settings\n\t\t\t\t\t</a>\n\t\t\t\t</report-actions>\n\t\t\t</report>\n\t\t</div>\n\n\t\t<!-- Saved -->\n\t\t<div class="report-template-creator_state-wrapper" pc-switch-when="$ctrl.COMPONENT_STATES.saved">\n\n\t\t\t<div class="report-template-creator_state" data-cy="report-template-creator-saved">\n\t\t\t\t<div class="report-template-creator_state-header">\n\t\t\t\t\t<div class="report-template-creator_state-icon">\n\t\t\t\t\t\t<i class="icon-tick xxl is-primary"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h6 class="report-template-creator_state-heading">Template saved</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="report-template-creator_state-content">\n\t\t\t\t\t<p class="report-template-creator_state-paragraph" ng-if="$ctrl.isBulkReport">\n\t\t\t\t\t\tYour report template has been saved and can be used by all companies it has been assigned to.\n\t\t\t\t\t\tYou can preview your template at any time from your report settings page.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="report-template-creator_state-paragraph" ng-if="!$ctrl.isBulkReport">\n\t\t\t\t\t\tYour report template has been saved. You can preview your template at any time from your report settings page.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="report-template-creator_state-footer">\n\t\t\t\t\t<a class="is-small stronger" data-cy="report-template-creator-saved-action" href="" ng-click="$ctrl.reportTemplateCreatorOptions.closeModal()">\n\t\t\t\t\t\tOk, close this window\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t</div>\n\n</div>\n');
$templateCache.put('components/report-viewer/report-viewer.component.html','<section ng-switch="$ctrl.reportState">\n\n\t<!-- Loading -->\n\t<div pc-switch-when="$ctrl.REPORT_STATES.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Error -->\n\t<div pc-switch-when="$ctrl.REPORT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n\n\t<!-- No Data -->\n\t<div pc-switch-when="$ctrl.REPORT_STATES.reportEmpty">\n\n\t\t<placeholder placeholder-graphic="report">\n\t\t\t<placeholder-title>There\'s no data to show</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Try changing the search criteria to view a different period.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t</div>\n\n\t<!-- Ready -->\n\t<div pc-switch-when="$ctrl.REPORT_STATES.ready">\n\n\n\t\t<search-bar count=" $ctrl.reportOptions.hasMultipleEntries ? $ctrl.report.filteredCustomReportEntries.length : $ctrl.reportRowCount" options="$ctrl.searchBarOptions" on-search="$ctrl.onDataGridSearch($ctrl.searchBarOptions.search.string)">\n\t\t\t<sb-actions ng-if="$ctrl.reportOptions.hasMultipleEntries || $ctrl.canRegenerateReport()">\n\t\t\t\t<button class="is-clear" data-cy="report-viewer-toggle-all-report-entries" ng-click="$ctrl.toggleAllReportEntries()" ng-if="$ctrl.reportOptions.hasMultipleEntries" type="button">\n\t\t\t\t\t{{$ctrl.expandedEntriesCount === $ctrl.report.CustomReportEntries.length ? \'Collapse all\' : \'Expand all\'}}\n\t\t\t\t</button>\n\t\t\t\t<button class="is-white" data-cy="report-viewer-regenerate-report" ng-click="$ctrl.regenerateReport()" ng-if="$ctrl.canRegenerateReport()" type="button">\n\t\t\t\t\t<i class="icon-loading n"></i> Regenerate\n\t\t\t\t</button>\n\t\t\t</sb-actions>\n\t\t</search-bar>\n\n\t\t<div class="fadeIn" ng-repeat="customReportEntry in $ctrl.report.filteredCustomReportEntries = ( $ctrl.report.CustomReportEntries | reportViewerEntriesSearch : $ctrl.reportOptions.hasMultipleEntries : $ctrl.searchBarOptions.search.string )" ng-if="$ctrl.report.filteredCustomReportEntries.length > 0" ng-class="[\n\t\t\t\t$ctrl.reportOptions.reportTheme,\n\t\t\t\t{\n\t\t\t\t\t\'report-viewer_entry\' : $ctrl.reportOptions.hasMultipleEntries\n\t\t\t\t}\n\t\t\t]">\n\n\t\t\t<div class="report-viewer_entry-header" ng-class="{\n\t\t\t\t\t\'has-content\' : customReportEntry.CustomReportEntryTable.TotalRow.TotalRowCells.length > 0 || customReportEntry.showFullEntry\n\t\t\t\t}" ng-if="$ctrl.reportOptions.hasMultipleEntries">\n\t\t\t\t<h6 class="report-viewer_entry-heading">{{customReportEntry.CustomReportEntryLabel}}</h6>\n\n\t\t\t\t<button aria-label="Toggle entry" class="report-viewer_entry-action is-clear" data-cy="report-viewer-toggle-full-report-entry-content" ng-class="{\n\t\t\t\t\t\t\'is-active\': !customReportEntry.showFullEntry\n\t\t\t\t\t}" ng-click="$ctrl.toggleFullReportEntryContent(customReportEntry)" type="button">\n\t\t\t\t\t<i class="icon-chevron-up is-large" ng-class="$ctrl.reportOptions.reportTheme"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t\t<div class="report-viewer_table" ng-class="{\'table-watermark-draft\': $ctrl.reportOptions.isPayPeriodUnsubmitted && $ctrl.report.filteredCustomReportEntries.length > 0 }">\n\n\t\t\t\t<report-entry custom-report-entry="customReportEntry" report-options="$ctrl.reportOptions" current-search="$ctrl.searchBarOptions.search.string"></report-entry>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</section>\n');
$templateCache.put('components/rollback-status-block/rollback-status-block.component.html','<div class="rollback-status-block">\n\t\n\t<notification-bar tag-copy="Rollback" tag-icon="roll-back" tag-theme="is-tertiary">\n\t\tPayroll for {{::$ctrl.payPeriod.PayPeriodDisplay}} is currently in rollback.\n\t</notification-bar>\n</div>\n');
$templateCache.put('components/rotaready-employees-card/rotaready-employees-card.component.html','<div class="rotaready-employee-card" ng-class="{\'is-active\': $ctrl.isActive}">\n\t<div class="rotaready-employee-card_wrapper">\n\t\t<h6>\n\t\t\t{{$ctrl.employee.FullName}}\n\t\t\t<span class="tag is-informative" ng-if="!$ctrl.employee.IsActive">\n\t\t\t\tLeaver\n\t\t\t</span>\n\t\t</h6>\n\t\t<div>\n\t\t\t<div class="rotaready-employee-card_field">\n\t\t\t\t<p class="is-small is-greyscale-300">NI Number:</p>\n\t\t\t\t<p class="is-small is-greyscale-300" ng-if="$ctrl.employee.Nino">\n\t\t\t\t\t{{$ctrl.employee.Nino}}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" ng-if="!$ctrl.employee.Nino">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="rotaready-employee-card_field">\n\t\t\t\t<p class="is-small is-greyscale-300">\n\t\t\t\t\tDOB:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" ng-if="$ctrl.employee.DateOfBirthIso">\n\t\t\t\t\t{{$ctrl.employee.DateOfBirthIso | dateformat }}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" ng-if="!$ctrl.employee.DateOfBirthIso">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300">\n\t\t\t\t\t| Gender:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" ng-if="$ctrl.employee.Gender">\n\t\t\t\t\t{{$ctrl.employee.Gender}}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" ng-if="!$ctrl.employee.Gender">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="rotaready-employee-card_field">\n\t\t\t\t<p class="is-small is-greyscale-300">Email:</p>\n\t\t\t\t<p class="is-small is-greyscale-300" ng-if="$ctrl.employee.Email">\n\t\t\t\t\t{{$ctrl.employee.Email}}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" ng-if="!$ctrl.employee.Email">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n');
$templateCache.put('components/rotaready-match-employees/rotaready-match-employees.component.html','<div class="rotaready-match-employees">\n\t<search-bar bulk-items="$ctrl.bulkItems" options="$ctrl.searchBarOptions"></search-bar>\n\n\t<div class="rotaready-match-employees_header" ng-if="($ctrl.isPendingTab && ($ctrl.teamMembersMapped.length > 0 || $ctrl.createInPaycircle.length > 0)) || (!$ctrl.isPendingTab && $ctrl.bulkItems.filtered.length > 0)">\n\t\t<div class="rotaready-match-employees_header-title" ng-class="{\'available-match\': !$ctrl.isPendingTab, \'pending-match\': $ctrl.isPendingTab}">\n\t\t\t<div class="rotaready-match-employees_header-item">\n\t\t\t\t<h6>From Rotaready</h6>\n\t\t\t</div>\n\t\t\t<div class="rotaready-match-employees_header-item">\n\t\t\t\t<h6>In Paycircle</h6>\n\t\t\t</div>\n\t\t</div>\n\t\t<button class="rotaready-match-employees_header-button is-primary" data-cy="rotaready-match-employees-create-all-as-new" ng-click="$ctrl.onCreateAllAsNewClick()" ng-disabled="$ctrl.isPayrollLocked" ng-if="!$ctrl.isPendingTab && $ctrl.bulkItems.all.length > 0" title="{{$ctrl.isPayrollLocked ? \'Cannot create new team members when payroll is calculated\' : \'\'}}" type="button">\n\t\t\tCreate all as new\n\t\t</button>\n\t\t<button class="rotaready-match-employees_header-button is-primary" data-cy="rotaready-match-employees-undo-all" ng-click="$ctrl.onUndoAll()" ng-if="$ctrl.isPendingTab && $ctrl.teamMembersMapped.length > 0" type="button">\n\t\t\tUndo all\n\t\t</button>\n\t</div>\n\n\t<div class="rotaready-employee-cards" current-page="$ctrl.searchBarOptions.currentPageNumber" ng-if="!$ctrl.isPendingTab" dir-paginate="teamMember in $ctrl.bulkItems.filtered = (\n\t\t\t\t$ctrl.bulkItems.all |\n\t\t\t\tfilterBy : $ctrl.searchBarOptions.search.filterOption.filterKeys : $ctrl.searchBarOptions.search.string\n\t\t\t) |\n\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse |\n\t\t\titemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage" ng-class="{\'is-disabled\': $ctrl.isRowDisabled && !teamMember.Paycircle, \'is-locked-row\': teamMember.IsLocked }">\n\t\t<!-- Employee Card -->\n\t\t<rotaready-employees-card employee="teamMember.Rotaready" is-active="teamMember.Paycircle !== null">\n\t\t</rotaready-employees-card>\n\n\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t<!-- Search Pill Input -->\n\t\t<rotaready-team-member-search-card employee="teamMember" index="$index" is-payroll-locked="$ctrl.isPayrollLocked" is-row-disabled="$ctrl.isRowDisabled" on-unmatch-click="$ctrl.onUnmatchClick(teamMember)" paycircle-team-members="$ctrl.paycircleTeamMembers" reset-flags="$ctrl.resetFlags($ctrl)" update-team-member-state="$ctrl.updateTeamMemberState({ teamMember: teamMember, action: action })">\n\t\t</rotaready-team-member-search-card>\n\t</div>\n\n\t<div class="rotaready-employee-cards" current-page="$ctrl.searchBarOptions.currentPageNumber" ng-if="$ctrl.isPendingTab" dir-paginate="teamMember in $ctrl.bulkItems.filtered = (\n\t\t\t\t\t$ctrl.bulkItems.all |\n\t\t\t\t\tfilterBy : $ctrl.searchBarOptions.search.filterOption.filterKeys : $ctrl.searchBarOptions.search.string\n\t\t\t\t) |\n\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage">\n\t\t<!-- Employee Card -->\n\t\t<rotaready-employees-card employee="teamMember.Rotaready"></rotaready-employees-card>\n\n\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t<!-- Matched card -->\n\t\t<rotaready-team-member-matched-card index="$index" on-cancel-click="$ctrl.updateTeamMemberState({ teamMember: teamMember, action: action})" on-unmatch-click="$ctrl.updateTeamMemberState({ teamMember: teamMember, action: action})" team-member="teamMember">\n\t\t</rotaready-team-member-matched-card>\n\t</div>\n\n\t<!-- Pagination -->\n\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-if="$ctrl.bulkItems.all.length > 0" on-page-change="$ctrl.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t<placeholder placeholder-graphic="no-job-grades" placeholder-graphic-size="l" ng-if="$ctrl.teamMembersMapped.length === 0 && $ctrl.createInPaycircle.length === 0 && $ctrl.isPendingTab">\n\t\t<placeholder-title>No pending changes yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Pending changes will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\t<placeholder placeholder-graphic="no-job-grades" placeholder-graphic-size="l" ng-if="$ctrl.rotareadyTeamMembers.length === 0 && !$ctrl.isPendingTab">\n\t\t<placeholder-title>No team members available to match</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Unmatched team members will show up here</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\t<!-- No search results -->\n\t<empty-search ng-if="$ctrl.bulkItems.filtered.length === 0 && $ctrl.bulkItems.all.length > 0" search-bar-options="$ctrl.searchBarOptions">\n\t</empty-search>\n</div>\n');
$templateCache.put('components/rotaready-team-card-basic/rotaready-team-card-basic.component.html','<div class="rotaready-team-card-basic">\n\t<div class="rotaready-team-card-basic_main">\n\t\t<icon-dot icon="icon-add" ng-if="$ctrl.hasIcon" theme="secondary is-extra-large">\n\t\t</icon-dot>\n\t\t<avatar avatar-initial="{{$ctrl.teamMember.FullName[0]}}" avatar-size="{{$ctrl.isSmall ? \'is-small\' : \'is-medium\'}}" avatar-theme="is-primary" avatar-user-id="{{$ctrl.teamMember.Id}}" ng-if="!$ctrl.hasIcon"></avatar>\n\t\t<div class="rotaready-team-card-basic_info">\n\t\t\t<div>\n\t\t\t\t<name class="strong" forename="{{$ctrl.teamMember.Forename}}" surname="{{$ctrl.teamMember.Surname}}">\n\t\t\t\t</name>\n\t\t\t\t<div class="is-informative rotaready-team-card-basic_inactive tag" ng-if="!$ctrl.teamMember.IsActive">\n\t\t\t\t\tLeaver\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-team-card-basic_field">\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-ni-number-lable-{{$ctrl.index}}">\n\t\t\t\t\tNI Number:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" ng-if="$ctrl.teamMember.Nino" data-cy="rotaready-team-card-basic-ni-number-{{$ctrl.index}}">\n\t\t\t\t\t{{$ctrl.teamMember.Nino}}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" ng-if="!$ctrl.teamMember.Nino" data-cy="rotaready-team-card-basic-ni-number-unknown-{{$ctrl.index}}">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-team-card-basic_field">\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-dob-label-{{$ctrl.index}}">\n\t\t\t\t\tDOB:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-dob-{{$ctrl.index}}" ng-if="$ctrl.teamMember.DateOfBirthIso">\n\t\t\t\t\t{{$ctrl.teamMember.DateOfBirthIso | dateformat }}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" data-cy="rotaready-team-card-basic-dob-unknown-{{$ctrl.index}}" ng-if="!$ctrl.teamMember.DateOfBirthIso">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-gender-label-{{$ctrl.index}}">\n\t\t\t\t\t| Gender:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-gender-{{$ctrl.index}}" ng-if="$ctrl.teamMember.Gender">\n\t\t\t\t\t{{$ctrl.teamMember.Gender }}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" data-cy="rotaready-team-card-basic-gender-unknown-{{$ctrl.index}}" ng-if="!$ctrl.teamMember.Gender">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="rotaready-team-card-basic_field">\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-email-label-{{$ctrl.index}}">\n\t\t\t\t\tEmail:\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-card-basic-email-{{$ctrl.index}}" ng-if="$ctrl.teamMember.Email">\n\t\t\t\t\t{{$ctrl.teamMember.Email }}\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-greyscale-300 italic" data-cy="rotaready-team-card-basic-email-unknown-{{$ctrl.index}}" ng-if="!$ctrl.teamMember.Email">\n\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="rotaready-team-card-basic_action" ng-if="$ctrl.hasActions" ng-transclude="actions">\n\t</div>\n</div>\n');
$templateCache.put('components/rotaready-team-member-matched-card/rotaready-team-member-matched-card.component.html','<div class="rotaready-team-member-matched-card">\n\t<div class="rotaready-team-member-matched-card_wrapper">\n\t\t<p class="is-small is-greyscale" data-cy="rotaready-team-member-matched-card-state-{{$ctrl.index}}" ng-if="$ctrl.teamMember.Paycircle && !$ctrl.isMatchedView">\n\t\t\tWill be matched:\n\t\t</p>\n\t\t<p class="is-small is-greyscale" data-cy="rotaready-team-member-matched-card-state-{{$ctrl.index}}" ng-if="!$ctrl.teamMember.Paycircle && !$ctrl.isMatchedView">\n\t\t\tWill be created as a new employee:\n\t\t</p>\n\n\t\t<p class="is-small is-greyscale" data-cy="rotaready-team-member-matched-card-state-{{$ctrl.index}}" ng-if="$ctrl.isMatchedView">\n\t\t\tIs matched to:\n\t\t</p>\n\n\t\t<rotaready-team-card-basic team-member="$ctrl.teamMember.Paycircle ? $ctrl.teamMember.Paycircle : $ctrl.teamMember.Rotaready" is-small="false" has-icon="!$ctrl.teamMember.Paycircle">\n\t\t\t<tc-actions>\n\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-team-member-unmatch-{{$ctrl.index}}" ng-click="$ctrl.onUnmatchClick({teamMember: $ctrl.teamMember, action: \'unmatch\'})" ng-if="$ctrl.teamMember.Paycircle" type="button">\n\t\t\t\t\tUnmatch\n\t\t\t\t</button>\n\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-team-member-cancel-{{$ctrl.index}}" ng-click="$ctrl.onCancelClick({teamMember: $ctrl.teamMember, action: \'cancelCreate\'})" ng-if="!$ctrl.teamMember.Paycircle" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</tc-actions>\n\t\t</rotaready-team-card-basic>\n\t</div>\n\n</div>\n');
$templateCache.put('components/rotaready-team-member-search-card/rotaready-team-member-search-card.component.html','<div class="rotaready-team-member-search-card" ng-class="{\'is-active\': $ctrl.employee.Paycircle !== null}" ng-if="!$ctrl.employee.IsLocked">\n\t<div class="rotaready-team-member-search-card_input pill-input-field is-compact has-icon is-primary has-darkened-border" ng-class="{\'is-disabled\': $ctrl.employee.Paycircle || $ctrl.paycircleTeamMembers.length === 0}">\n\t\t<div class="pill-input-field-icon">\n\t\t\t<i class="icon-search"></i>\n\t\t</div>\n\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" data-cy="rotaready-team-member-search-input-{{$ctrl.index}}" id="searchTeamTeamMembers-{{$ctrl.index}}" name="searchTeamTeamMembers-{{$ctrl.index}}" ng-disabled="$ctrl.employee.Paycircle || $ctrl.paycircleTeamMembers.length === 0" ng-model="$ctrl.employee.searchValue" placeholder="Search for a team member" type="text">\n\t\t<div class="pill-input-search-results is-alternate fadeIn" click-anywhere-but-here="$ctrl.resetTeamMemberSearchTerm($ctrl.employee)" is-active="$ctrl.employee.searchValue.length >= $ctrl.SEARCH_TERM_MIN_COUNT" ng-show="$ctrl.employee.searchValue.length >= $ctrl.SEARCH_TERM_MIN_COUNT">\n\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t<p class="pill-input-search-results-subheading" ng-if="$ctrl.filteredTeamMembers.length > 0">\n\t\t\t\t\t<ng-pluralize count="$ctrl.filteredTeamMembers.length" when="{\'1\': \'1 employee\', \'other\': \'{} employees\'}"></ng-pluralize>&nbsp;found\n\t\t\t\t</p>\n\t\t\t\t<button aria-label="Select team member" class="pill-input-search-result is-clear is-primary" data-cy="rotaready-team-member-search-result-{{$ctrl.index}}" ng-click="$ctrl.onTeamMemberClick($ctrl.employee, teamMember)" ng-if="$ctrl.filteredTeamMembers.length" ng-repeat="teamMember in $ctrl.filteredTeamMembers = ($ctrl.paycircleTeamMembers |\n\t\t\t\t\t\t\t\t\t filter: $ctrl.employee.searchValue\n\t\t\t\t\t\t\t\t\t) | limitTo:$ctrl.SEARCH_RESULTS_LIMIT" type="button">\n\t\t\t\t\t<span class="pill-input-search-result-avatar">\n\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Paycircle.FullName[0]}}" avatar-size="is-small" avatar-theme="is-primary" avatar-user-id="{{teamMember.Paycircle.Id}}"></avatar>\n\t\t\t\t\t</span>\n\t\t\t\t\t<div class="rotaready-team-member-search-card_result_detail">\n\t\t\t\t\t\t<h3 class="rotaready-team-member-search-card_result_title" data-cy="rotaready-team-member-search-result-name-{{$ctrl.index}}">\n\t\t\t\t\t\t\t{{teamMember.Paycircle.FullName}}\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<h4 class="rotaready-team-member-search-card_result_subtitle" data-cy="rotaready-team-member-search-result-detail-{{$ctrl.index}}">\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\tNI Number:\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="teamMember.Paycircle.Nino">\n\t\t\t\t\t\t\t\t{{teamMember.Paycircle.Nino}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="italic" ng-if="!teamMember.Paycircle.Nino">\n\t\t\t\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t| DOB:\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="teamMember.Paycircle.DateOfBirthIso">\n\t\t\t\t\t\t\t\t{{teamMember.Paycircle.DateOfBirthIso | dateformat }}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="italic" ng-if="!teamMember.Paycircle.DateOfBirthIso">\n\t\t\t\t\t\t\t\t{{$root.CONFIG.defaultEmptyText}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</h4>\n\t\t\t\t\t</div>\n\t\t\t\t\t<span class="rotaready-team-member-search-card_search-action">\n\t\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t</span>\n\t\t\t\t</button>\n\t\t\t\t<p ng-if="!$ctrl.filteredTeamMembers.length" data-cy="rotaready-team-member-search-no-results-{{$ctrl.index}}"><span class="caption">No team members found</span></p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="rotaready-team-member-search-card_search-footer" ng-if="!$ctrl.employee.Paycircle">\n\t\t<div class="rotaready-team-member-search-card_search-footer_left-content" ng-if="$ctrl.employee.Rotaready.possibleMatches.length">\n\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-team-member-possible-matches-text-{{$ctrl.index}}">Possible match:</p>\n\t\t\t<ul class="rotaready-team-member-search-card_search-footer_list">\n\t\t\t\t<li ng-repeat="match in $ctrl.employee.Rotaready.possibleMatches">\n\t\t\t\t\t<a class="is-small strong is-inline" data-cy="rotaready-team-member-possible-match-name-{{$ctrl.index}}-{{$index}}" href="" ng-click="$ctrl.onTeamMemberClick($ctrl.employee, match)">\n\t\t\t\t\t\t<i class="icon-add is-primary s"></i>\n\t\t\t\t\t\t<span>{{match.Paycircle.FullName}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t\t<button class="rotaready-team-member-search-card_search-footer_right-content is-white is-primary" data-cy="rotaready-team-member-create-as-new-{{$ctrl.index}}" ng-click="$ctrl.updateTeamMemberState({ teamMember: $ctrl.employee, action: \'create\' });" ng-disabled="$ctrl.isPayrollLocked" title="{{$ctrl.isPayrollLocked ? \'Cannot create new team members when payroll is calculated\' : \'\'}}" type="button">\n\t\t\tCreate as new\n\t\t</button>\n\t</div>\n\t<div ng-if="$ctrl.employee.Paycircle">\n\t\t<rotaready-team-card-basic team-member="$ctrl.employee.Paycircle" is-small="true" index="$ctrl.index">\n\t\t\t<tc-actions>\n\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-team-member-match-{{$ctrl.index}}" ng-click="$ctrl.onMatch($ctrl.employee)" type="button">\n\t\t\t\t\tMatch\n\t\t\t\t</button>\n\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-team-member-clear-{{$ctrl.index}}" type="button" ng-click="$ctrl.onTeamMemberDeselectClick($ctrl.employee)">\n\t\t\t\t\tClear\n\t\t\t\t</button>\n\t\t\t</tc-actions>\n\t\t</rotaready-team-card-basic>\n\t</div>\n</div>\n\n<div class="rotaready-team-member-search-card is-locked" ng-if="$ctrl.employee.IsLocked">\n\t<div class="rotaready-team-member-search-card_locked">\n\t\t<icon-dot icon="icon-padlock" theme="is-tertiary is-large"></icon-dot>\n\t\t<p>Employee already matched on another payroll</p><p>\n\t</p></div>\n</div>\n');
$templateCache.put('components/rotaready-updates-card/rotaready-updates-card.component.html','<div class="rotaready-updates-card fadeIn" ng-class="[$ctrl.cardTheme, {\'remove-hover-effect\': $ctrl.removeHoverEffect, \'is-selected\' : $ctrl.eventData.isSelected}]">\n\t<div class="rotaready-updates-card_main">\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="checkbox-input assertive rotaready-updates-card_main_checkbox" ng-if="$ctrl.displayBulkActions">\n\t\t\t<input aria-label="Select event" class="checkbox-input-field" data-cy="select-rotaready-update-{{$ctrl.index}}-checkbox" id="{{::$ctrl.eventData.RotareadyWebhookEventID}}" ng-change="$ctrl.onCheckboxToggle()" ng-disabled="$ctrl.eventData.cannotBeSelected" ng-model="$ctrl.eventData.isSelected" type="checkbox">\n\t\t\t<label class="checkbox-input-label" for="{{::$ctrl.eventData.RotareadyWebhookEventID}}"></label>\n\t\t</div>\n\n\t\t<div class="rotaready-updates-card_icon">\n\t\t\t<icon-dot icon="{{$ctrl.icon}}" is-light="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.processing || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.held" theme="{{$ctrl.cardTheme}} is-larger">\n\t\t\t</icon-dot>\n\t\t</div>\n\n\t\t<div class="rotaready-updates-card_content">\n\t\t\t<div>\n\t\t\t\t<h6 data-cy="rotaready-updates-card-name-{{$ctrl.index}}">{{$ctrl.eventData.TargetName}}</h6>\n\t\t\t\t<p class="rotaready-updates-card_description" data-cy="rotaready-updates-card-description-{{$ctrl.index}}">{{$ctrl.eventText}}</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<div class="rotaready-updates-card_warning" ng-if="!$ctrl.hideWarningIcon && $ctrl.eventData.Status !== $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && $ctrl.eventData.CriticalMessagesCount >= 1 && !$ctrl.hasAllCriticalsDismissed">\n\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="is-assertive has-hover" tooltip-position="left" tooltip-text="{{$ctrl.eventData.CriticalMessagesCount}} critical issue(s)">\n\t\t\t\t\t\t</icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="rotaready-updates-card_warning" ng-if="!$ctrl.hideWarningIcon && $ctrl.eventData.Status !== $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && $ctrl.eventData.WarningMessagesCount >= 1">\n\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="is-tertiary has-hover" tooltip-position="left" tooltip-text="{{$ctrl.eventData.WarningMessagesCount}} warning(s)">\n\t\t\t\t\t\t</icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="rotaready-updates-card_action" ng-if="$ctrl.hideAction !== true">\n\t\t\t\t\t<dropdown-menu menu-icon="icon-setup" menu-show-chevron="false" menu-size="l" menu-theme="{{$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.held ? \'\' : $ctrl.cardTheme}}" data-cy="rotaready-update-dropdown-{{$ctrl.index}}">\n\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openEventDataForm($ctrl.agencyProfileId, $ctrl.eventData.RotareadyWebhookEventID)" data-cy="rotaready-update-review-data">Review data</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</dropdown-menu>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<footer class="rotaready-updates-card_footer" ng-if="$ctrl.displayFooter">\n\t\t<div data-cy="rotaready-updates-card-info-{{$ctrl.index}}" ng-if="($ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.held) && ($ctrl.displayBulkActions || $ctrl.eventData.InfoMessagesCount === 1)">\n\t\t\t{{ :: $ctrl.footerInfoMessage }}\n\t\t</div>\n\t\t<div data-cy="rotaready-updates-card-info-{{$ctrl.index}}" ng-if="($ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.held) && !$ctrl.displayBulkActions && $ctrl.eventData.InfoMessagesCount > 1">\n\t\t\t{{ :: $ctrl.footerInfoMessage }}:\n\t\t\t<div class="spacer s"></div>\n\t\t\t<bullet-list bl-items="$ctrl.messages.infos" bl-theme="is-small is-primary-lightened is-spaced-out"></bullet-list>\n\t\t</div>\n\t\t<div data-cy="rotaready-updates-card-critical-{{$ctrl.index}}" ng-if="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && !$ctrl.displayBulkActions && $ctrl.totalCriticalMessagesCount >= 1">\n\t\t\t{{ :: $ctrl.footerCriticalMessage }}\n\t\t</div>\n\t\t<div data-cy="rotaready-updates-card-critical-{{$ctrl.index}}" ng-if="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && $ctrl.displayBulkActions && $ctrl.totalCriticalMessagesCount >= 1">\n\t\t\t<div data-cy="rotaready-updates-card-critical-message-{{$ctrl.index}}-{{index}}" class="rotaready-updates-card_critical-message" ng-repeat="message in $ctrl.criticalMessages">\n\t\t\t\t<span class="tag is-inverse is-assertive">Critical</span>\n\t\t\t\t<span class="rotaready-updates-card_critical-message_text">{{message.MessageText}}</span>\n\t\t\t</div>\n\t\t\t<div data-cy="rotaready-updates-card-critical-messages-dismissed-note" ng-if="$ctrl.dismissedCriticalMessagesCount === 1">\n\t\t\t\t<span ng-repeat="message in $ctrl.dismissedCriticalMessages">\n\t\t\t\t\t{{message.MessageText}} (dismissed)\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div data-cy="rotaready-updates-card-critical-messages-dismissed-note" ng-if="$ctrl.dismissedCriticalMessagesCount > 1">\n\t\t\t\t<span>{{$ctrl.dismissedCriticalMessagesCount}} dismissed critical messages</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div data-cy="rotaready-updates-card-warning-{{$ctrl.index}}" ng-if="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && ($ctrl.displayBulkActions || $ctrl.eventData.ErrorMessagesCount === 1)">\n\t\t\t{{ :: $ctrl.footerErrorMessage }}\n\t\t</div>\n\t\t<div data-cy="rotaready-updates-card-warning-{{$ctrl.index}}" ng-if="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed && !$ctrl.displayBulkActions && $ctrl.eventData.ErrorMessagesCount > 1">\n\t\t\t{{ :: $ctrl.footerErrorMessage }}\n\t\t\t<div class="spacer s"></div>\n\t\t\t<bullet-list bl-items="$ctrl.messages.errors" bl-theme="is-small is-assertive-lightened is-spaced-out"></bullet-list>\n\t\t</div>\n\t</footer>\n</div>\n');
$templateCache.put('components/rotaready-updates-grouped-card/rotaready-updates-grouped-card.component.html','<div class="rotaready-updates-card rotaready-updates-grouped-card fadeIn" ng-class="[$ctrl.cardTheme, {\'is-expanded\': $ctrl.isExpanded}]">\n\t<div class="rotaready-updates-card_main">\n\n\t\t<div class="rotaready-updates-card_icon">\n\t\t\t<icon-dot icon="{{$ctrl.icon}}" is-light="$ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.new || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.processing || $ctrl.eventData.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.held" theme="{{$ctrl.cardTheme}} is-larger"></icon-dot>\n\t\t</div>\n\n\t\t<div class="rotaready-updates-card_content">\n\t\t\t<div>\n\t\t\t\t<h6 data-cy="rotaready-updates-grouped-card-name-{{$ctrl.index}}">{{$ctrl.eventData.TargetName}}</h6>\n\t\t\t\t<p class="rotaready-updates-card_description" data-cy="rotaready-updates-grouped-card-message-{{$ctrl.index}}">{{$ctrl.eventData.MessageText}}</p>\n\t\t\t\t<p class="rotaready-updates-card_description" data-cy="rotaready-updates-grouped-card-date-range-{{$ctrl.index}}">\n\t\t\t\t\t{{$ctrl.eventData.FirstReceivedTimeISO | dateformat:\'numeric\'}} - {{$ctrl.eventData.LastReceivedTimeISO | dateformat:\'numeric\'}}\n\t\t\t\t\t(<ng-pluralize count="$ctrl.eventData.affectedDaysCount" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>)\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="rotaready-updates-grouped-card_meta">\n\t\t\t\t<span class="tag inverse" data-cy="rotaready-updates-grouped-card-severity-{{$ctrl.index}}" ng-class="$ctrl.cardTheme">{{$ctrl.severityText}}</span>\n\t\t\t\t<span class="tag" data-cy="rotaready-updates-grouped-card-occurrences-{{$ctrl.index}}">\n\t\t\t\t\t<ng-pluralize count="$ctrl.eventData.OccurrenceCount" when="{\'1\': \'1 occurrence\', \'other\': \'{} occurrences\'}"></ng-pluralize>\n\t\t\t\t</span>\n\t\t\t\t<button class="is-white is-primary is-small" data-cy="rotaready-updates-grouped-card-expand-{{$ctrl.index}}" ng-click="$ctrl.toggleIsExpanded()" type="button">\n\t\t\t\t\t<i class="{{$ctrl.isExpanded ? \'icon-chevron-up\' : \'icon-chevron-down\'}}"></i>\n\t\t\t\t\t{{$ctrl.isExpanded ? \'Hide occurrences\' : \'Show occurrences\'}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<footer class="rotaready-updates-card_footer fadeIn" ng-if="$ctrl.isExpanded">\n\t\t<div class="rotaready-updates-grouped-card_occurrence" data-cy="rotaready-updates-grouped-card-occurrence-{{$ctrl.index}}-{{$index}}" ng-repeat="occurrence in $ctrl.occurrences track by $index">\n\t\t\t<span>{{$ctrl.getOccurrenceText(occurrence)}}</span>\n\t\t\t<span class="rotaready-updates-grouped-card_occurrence-message">\n\t\t\t\t{{$ctrl.getOccurrenceMessage(occurrence)}}\n\t\t\t</span>\n\t\t</div>\n\t</footer>\n</div>\n');
$templateCache.put('components/salary-breakdown/salaryBreakdownComponent.html','<div>\n\n\t<!-- Monthly / Four-weekly -->\n\t<div class="form-field-group">\n\n\t\t<!-- Monthly -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.monthlySalaryId}}">Monthly salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.monthlySalaryId}}" name="{{::$ctrl.monthlySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'Monthly\', $ctrl.SALARY_INTERVAL_TYPES.monthly)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.Monthly" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.monthlySalaryId].$error" ng-show="$ctrl.form[$ctrl.monthlySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Four-weekly -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.fourWeeklySalaryId}}">Four-weekly salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.fourWeeklySalaryId}}" name="{{::$ctrl.fourWeeklySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'FourWeekly\', $ctrl.SALARY_INTERVAL_TYPES.fourweekly)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.FourWeekly" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.fourWeeklySalaryId].$error" ng-show="$ctrl.form[$ctrl.fourWeeklySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Bi-weekly / Weekly -->\n\t<div class="form-field-group">\n\n\t\t<!-- Bi-weekly -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.twoWeeklySalaryId}}">Two-weekly salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.twoWeeklySalaryId}}" name="{{::$ctrl.twoWeeklySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'TwoWeekly\', $ctrl.SALARY_INTERVAL_TYPES.fortnightly)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.TwoWeekly" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.twoWeeklySalaryId].$error" ng-show="$ctrl.form[$ctrl.twoWeeklySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Weekly -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.weeklySalaryId}}">Weekly salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.weeklySalaryId}}" name="{{::$ctrl.weeklySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'Weekly\', $ctrl.SALARY_INTERVAL_TYPES.weekly)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.Weekly" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.weeklySalaryId].$error" ng-show="$ctrl.form[$ctrl.weeklySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Daily / Hourly -->\n\t<div class="form-field-group" ng-if="!teamMember.$ctrl.salary.IsPartTime">\n\t\t<!-- Daily -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.dailySalaryId}}">Daily salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.dailySalaryId}}" name="{{::$ctrl.dailySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'Daily\', $ctrl.SALARY_INTERVAL_TYPES.daily)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.Daily" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.dailySalaryId].$error" ng-show="$ctrl.form[$ctrl.dailySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Hourly -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="{{::$ctrl.hourlySalaryId}}">Hourly salary:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input autocomplete="off" class="monetise primary-dark" id="{{::$ctrl.hourlySalaryId}}" name="{{::$ctrl.hourlySalaryId}}" ng-change="$ctrl.onSalaryValueChanged($ctrl.salary, \'Hourly\', $ctrl.SALARY_INTERVAL_TYPES.hourly)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{ debounce:500 }" ng-model="$ctrl.salary.breakdown.Hourly" ng-readonly="$ctrl.disabled" type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.hourlySalaryId].$error" ng-show="$ctrl.form[$ctrl.hourlySalaryId].$touched" role="alert">\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/salary-policy-form-field/salary-policy-form-field.component.html','<div>\n\t<div class="salary-policy-form-field form-field-highlight primary">\n\t\t<div class="salary-policy-form-field_delete" ng-if="$ctrl.allowDelete">\n\t\t\t<div class="fadeIn" ng-if="!$ctrl.confirmDelete">\n\t\t\t\t<a class="greyscale" href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)">\n\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="fadeIn" ng-if="$ctrl.confirmDelete">\n\t\t\t\t<p class="s strong">\n\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t<a href="" ng-click="$ctrl.onDeletePolicy($ctrl)">Yes</a>\n\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t<a href="" ng-click="$ctrl.toggleConfirmDelete($ctrl)">No</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Edit mode -->\n\t\t<div ng-if="[\n\t\t\t\t$ctrl.SALARY_POLICY_FORM_FIELD_MODES.edit,\n\t\t\t\t$ctrl.SALARY_POLICY_FORM_FIELD_MODES.addChange\n\t\t\t].includes($ctrl.mode)\n\t\t\t" class="salary-policy-form-field-main fadeIn">\n\t\t\t<div class="form-field-header salary-policy-form-field_heading" ng-if="$ctrl.salaryPolicy.isSalaryPolicyUpdate">\n\t\t\t\t<h5>{{$ctrl.isAnnualSalaryPolicy ? \'Pay\' : \'Allowance\'}} change</h5>\n\t\t\t</div>\n\n\t\t\t<!-- Policy selection, only applicable for normal edit mode, and then when this doesn\'t represent a policy update.\n\t\t\t\t A retrospective (pre-current period) policy update will end up here due to a quirk of the system, which means\n\t\t\t\t that any backdated updates appear as the normal, main salary; i.e. not in SalaryFutureChanges. In the case of\n\t\t\t\t a policy update being applied, it shouldn\'t be possible for the user to edit the policy. -->\n\t\t\t<div class="form-field" ng-if="\n\t\t\t\t\t$ctrl.mode === $ctrl.SALARY_POLICY_FORM_FIELD_MODES.edit &&\n\t\t\t\t\t!$ctrl.salaryPolicy.IsPolicyUpdatePending\n\t\t\t\t">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="{{::$ctrl.salaryPolicyFormFieldId}}" class="required">\n\t\t\t\t\t\tPolicy:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="{{::$ctrl.salaryPolicyFormFieldId}}" name="{{::$ctrl.salaryPolicyFormFieldId}}" ng-change="$ctrl.onPolicyChange($ctrl, $ctrl.salaryPolicy, $ctrl.salaryPolicy.payPolicy)" ng-model="$ctrl.salaryPolicy.payPolicy" ng-options="policy as policy.PolicyName for policy in $ctrl.payPoliciesForSelection | orderBy: \'PolicyName\'">\n\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.salaryPolicyFormFieldId].$error" ng-show="$ctrl.form[$ctrl.salaryPolicyFormFieldId].$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a pay policy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="{{::$ctrl.policyBandFormFieldId}}">\n\t\t\t\t\t\tPay point:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="{{::$ctrl.policyBandFormFieldId}}" name="{{::$ctrl.policyBandFormFieldId}}" ng-change="$ctrl.onPolicyBandChange($ctrl)" ng-model="$ctrl.salaryPolicy.Band" ng-options="policyBand as policyBand.description for policyBand in $ctrl.salaryPolicy.payPolicy.PolicyBands | orderBy: \'description\'" required>\n\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">\n\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form[$ctrl.policyBandFormFieldId].$error" ng-show="$ctrl.form[$ctrl.policyBandFormFieldId].$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a pay point</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Contracted hours per week and weeks per year applicable only to annual salary policy. -->\n\t\t\t<fieldset ng-if="\n\t\t\t\t$ctrl.isAnnualSalaryPolicy &&\n\t\t\t\t$ctrl.salaryPolicy.payPolicy\n\t\t\t">\n\t\t\t\t<div class="form-field-group fadeIn">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{::$ctrl.hoursPerWeekFieldId}}">\n\t\t\t\t\t\t\t\tContracted hours per week:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field field-name="{{::$ctrl.hoursPerWeekFieldId}}" ng-model="$ctrl.salaryPolicy.HoursPerWeek" nsf-on-change="$ctrl.onContractedWorkTimeChange($ctrl)" max="$ctrl.config.workTimeLimits.hoursPerWeek.max" min="$ctrl.config.workTimeLimits.hoursPerWeek.min" ng-regex-key="contractedWorkingTimesRegEx" step="$ctrl.config.workTimeLimits.hoursPerWeek.step"></number-selector-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.hoursPerWeekFieldId].$touched" ng-messages="$ctrl.form[$ctrl.hoursPerWeekFieldId].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{$ctrl.config.workTimeLimits.hoursPerWeek.max}} hours</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.config.workTimeLimits.hoursPerWeek.min" when="{\n\t\t\t\t\t\t\t\t\t\t\'1\': \'1 hour\',\n\t\t\t\t\t\t\t\t\t\t\'other\': \'{} hours\'\n\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{$ctrl.config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="{{::$ctrl.weeksPerYearFieldId}}">\n\t\t\t\t\t\t\t\tContracted weeks per year:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<number-selector-field field-name="{{::$ctrl.weeksPerYearFieldId}}" ng-model="$ctrl.salaryPolicy.WeeksPerYear" nsf-on-change="$ctrl.onContractedWorkTimeChange($ctrl)" max="$ctrl.config.workTimeLimits.weeksPerYear.max" min="$ctrl.config.workTimeLimits.weeksPerYear.min" ng-regex-key="contractedWorkingTimesRegEx" step="$ctrl.config.workTimeLimits.weeksPerYear.step"></number-selector-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.weeksPerYearFieldId].$touched" ng-messages="$ctrl.form[$ctrl.weeksPerYearFieldId].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{$ctrl.config.workTimeLimits.weeksPerYear.max}} weeks</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.config.workTimeLimits.weeksPerYear.min" when="{\n\t\t\t\t\t\t\t\t\t\t\'1\': \'1 week\',\n\t\t\t\t\t\t\t\t\t\t\'other\': \'{} weeks\'\n\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{$ctrl.config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Effective date (when editable) -->\n\t\t\t<fieldset ng-if="$ctrl.allowEditEffectiveDate">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="{{::$ctrl.effectiveDateFormFieldId}}" class="required">\n\t\t\t\t\t\t\tEffective date:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="{{::$ctrl.effectiveDateFormFieldId}}" field-min-date-iso="$ctrl.minEffectiveDateIso" field-max-date-iso="$ctrl.currentPayPeriod.EndDateISO" field-on-change-fn="$ctrl.onEffectiveDateChange($ctrl)" field-required="true" field-value-iso="$ctrl.salaryPolicy.EffectiveDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="$ctrl.form[$ctrl.effectiveDateFormFieldId].$touched" ng-messages="$ctrl.form[$ctrl.effectiveDateFormFieldId].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the first payment date</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{$ctrl.minEffectiveDateIso | dateformat}}</p>\n\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{$ctrl.currentPayPeriod.EndDateISO | dateformat}}</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-note">\n\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\tMust be on or before the end date of your current pay period ({{$ctrl.currentPayPeriod.EndDateISO | dateformat}})\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Start date (shown if effective date is not editable, and show effective date is set to be displayed)-->\n\t\t\t<div class="form-field" ng-if="\n\t\t\t\t\t!$ctrl.allowEditEffectiveDate &&\n\t\t\t\t\t$ctrl.showEffectiveDate\n\t\t\t\t">\n\t\t\t\t<div class="fadeIn">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="{{::$ctrl.effectiveDateFormFieldId}}">\n\t\t\t\t\t\t\t{{$ctrl.teamMember.company.IsStarter ? \'Start\' : \'Effective\'}} date:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field-main salary-policy-form-field_effective-date-readonly">\n\t\t\t\t\t\t<input class="is-read-only" id="{{::$ctrl.effectiveDateFormFieldId}}" name="{{::$ctrl.effectiveDateFormFieldId}}" readonly="readonly" type="text" value="{{$ctrl.salaryPolicy.EffectiveDateISO | dateformat: \'numeric\'}}">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Calculate at FTE option (annual allowance pay policy only) -->\n\t\t\t<fieldset ng-if="!$ctrl.isAnnualSalaryPolicy &&\n\t\t\t\t\t\t[\n\t\t\t\t\t\t\t$ctrl.FTE_EQUIVALENTS_STATUS.complete,\n\t\t\t\t\t\t\t$ctrl.FTE_EQUIVALENTS_STATUS.updating\n\t\t\t\t\t\t].includes($ctrl.salaryPolicy.fteEquivalents.status)\n\t\t\t\t">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t<input id="{{::$ctrl.fteApplyFieldId}}" name="checkboxField" ng-change="$ctrl.onFTEApplyChange($ctrl)" ng-model="$ctrl.salaryPolicy.FTEApply" type="checkbox">\n\t\t\t\t\t\t<label class="checkbox-field-label" for="{{::$ctrl.fteApplyFieldId}}">\n\t\t\t\t\t\t\t{{$ctrl.fteLabel}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="{{::$ctrl.fteApplyFieldId}}"></label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Footer -->\n\t\t\t<div class="salary-policy-form-field_footer" ng-if="[\n\t\t\t\t\t$ctrl.FTE_EQUIVALENTS_STATUS.complete,\n\t\t\t\t\t$ctrl.FTE_EQUIVALENTS_STATUS.updating\n\t\t\t\t].includes($ctrl.salaryPolicy.fteEquivalents.status)">\n\t\t\t\t<!-- Footer calculations - annual salary pay policy -->\n\t\t\t\t<div class="fadeIn form-fieldset-divider-top is-primary-lighter smaller-padding" ng-if="$ctrl.isAnnualSalaryPolicy">\n\t\t\t\t\t<div class="salary-policy-form-field_list">\n\t\t\t\t\t\t<div class="salary-policy-form-field_listitem">\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-name">Full time equivalent %:</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.complete">\n\t\t\t\t\t\t\t\t{{$ctrl.salaryPolicy.fteEquivalents.ftePercent.toFixed(4)}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.updating">\n\t\t\t\t\t\t\t\t<i class="icon-loading s spin"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="salary-policy-form-field_listitem">\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-name">Annual salary:</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.complete">\n\t\t\t\t\t\t\t\t{{$ctrl.salaryPolicy.fteEquivalents.annualSalary | monetise}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.updating">\n\t\t\t\t\t\t\t\t<i class="icon-loading s spin"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="salary-policy-form-field_listitem">\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-name">Hourly rate:</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.complete">\n\t\t\t\t\t\t\t\t{{$ctrl.salaryPolicy.Band.PolicyBandHourlyRate | monetise: $ctrl.config.precision.salaryRates}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.updating"><i class="icon-loading s spin"></i></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Footer calculations - annual allowance pay policy -->\n\t\t\t\t<div class="fadeIn form-fieldset-divider-top is-primary-lighter smaller-padding" ng-if="!$ctrl.isAnnualSalaryPolicy">\n\t\t\t\t\t<div class="salary-policy-form-field_list">\n\t\t\t\t\t\t<div class="salary-policy-form-field_listitem">\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-name">Annual allowance:</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.complete">\n\t\t\t\t\t\t\t\t{{$ctrl.salaryPolicy.fteEquivalents.annualAllowance | monetise}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="salary-policy-form-field_listitem-value" ng-if="$ctrl.salaryPolicy.fteEquivalents.status === $ctrl.FTE_EQUIVALENTS_STATUS.updating">\n\t\t\t\t\t\t\t\t<i class="icon-loading s spin"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset class="fadeIn form-fieldset-divider-top is-primary-lighter smaller-padding" ng-if="$ctrl.hasBackdatedSalary">\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tBased on the effective date the following backdated {{$ctrl.isAnnualSalaryPolicy ? \'salary\' : \'allowance\'}} is owed to\n\t\t\t\t\t\t\t{{::$ctrl.teamMember.personal.Forename}} and will be added as a \'{{$ctrl.salaryPolicy.backdatedSalaryLabel}}\'\n\t\t\t\t\t\t\tchange to your current period:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<calculation-card amount="$ctrl.salaryPolicy.backdatedSalaryAmount" busy="$ctrl.salaryPolicy.backdatedSalaryState === \'loading\'" title="{{$ctrl.salaryPolicy.backdatedSalaryLabel}}"></calculation-card>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<settings-row ng-if="$ctrl.getBackdatedSalaryDerivedElementsEnabled($ctrl)" ng-model="$ctrl.salaryPolicy.BackdateSalaryDerivedElements" on-update="$ctrl.onBackdatedSettingsChange($ctrl)" sr-field-name="backdateSalaryDerivedElements" sr-label="Backdated salary derived elements">\n\t\t\t\t\t\t\t<sr-description>Select whether to proceed with any identified backdated salary derived elements for this salary change. These additional changes can be updated or removed afterwards if necessary</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t\t<div class="form-field" ng-if="$ctrl.getShowBackdatedSalaryDerivedElements($ctrl, $ctrl.salaryPolicy) && $ctrl.salaryPolicy.BackdateSalaryDerivedElements">\n\t\t\t\t\t\t<div ng-repeat="backdatedElement in $ctrl.salaryPolicy.backdatedSalary.BackdatedElements">\n\t\t\t\t\t\t\t<calculation-card amount="$ctrl.getBackdatedSalaryDerivedElementValueForDisplay({backdatedElementObj: backdatedElement})" busy="$ctrl.salaryPolicy.backdatedSalaryState === \'loading\'" title="{{backdatedElement.Label}}"></calculation-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- View mode -->\n\t\t<div ng-if="$ctrl.mode === $ctrl.SALARY_POLICY_FORM_FIELD_MODES.view" class="salary-policy-form-field-main fadeIn">\n\t\t\t<div class="salary-policy-form-field_view-title">\n\t\t\t\t{{$ctrl.isAnnualSalaryPolicy ? \'Current salary:\' : \'Current allowance:\'}}\n\t\t\t</div>\n\t\t\t<div class="salary-policy-form-field_view-subtitle">\n\t\t\t\t<!-- If calculated at FTE, use FTEAnnualSalary -->\n\t\t\t\t<span ng-if="$ctrl.salaryPolicy.FTEApply">\n\t\t\t\t\t{{$ctrl.salaryPolicy.FTEAnnualSalary | monetise}}\n\t\t\t\t</span>\n\t\t\t\t<!-- If not calculated at FTE, use full band annual value, sourced depending on policy type -->\n\t\t\t\t<span ng-if="!$ctrl.salaryPolicy.FTEApply">\n\t\t\t\t\t{{($ctrl.isAnnualSalaryPolicy ? $ctrl.salaryPolicy.Band.PolicyBandAnnualSalary : $ctrl.salaryPolicy.Band.PolicyBandAnnualAllowance) | monetise}}\n\t\t\t\t</span>\n\t\t\t\t<span class="salary-policy-form-field_view-subtitle-info" ng-if="$ctrl.salaryPolicy.EffectiveDateISO">\n\t\t\t\t\t&nbsp;(effective {{$ctrl.salaryPolicy.EffectiveDateISO | dateformat}})\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="salary-policy-form-field_view-properties">\n\t\t\t\t<div class="salary-policy-form-field_view-property">\n\t\t\t\t\t<div class="salary-policy-form-field_view-property-name">Policy:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-property-value">{{$ctrl.salaryPolicy.PolicyName}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="salary-policy-form-field_view-property">\n\t\t\t\t\t<div class="salary-policy-form-field_view-property-name">Pay point:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-property-value">\n\t\t\t\t\t\t{{$ctrl.salaryPolicy.Band.PolicyBandName}}&nbsp;\n\t\t\t\t\t\t({{($ctrl.isAnnualSalaryPolicy ? $ctrl.salaryPolicy.Band.PolicyBandAnnualSalary : $ctrl.salaryPolicy.Band.PolicyBandAnnualAllowance) | monetise}})\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<a class="salary-policy-form-field_view-show-more-toggle" href="" ng-click="$ctrl.toggleShowMore($ctrl)" ng-if="$ctrl.isAnnualSalaryPolicy">\n\t\t\t\t<i class="salary-policy-form-field_view-show-more-icon icon-chevron-down" ng-class="{\n\t\t\t\t\t\t\'flip\': $ctrl.showMore\n\t\t\t\t\t}"></i>&nbsp;{{$ctrl.showMore ? \'Show less\' : \'Show more\'}}\n\t\t\t</a>\n\t\t\t<div class="salary-policy-form-field_view-attributes fadeIn" ng-if="$ctrl.showMore">\n\t\t\t\t<div class="salary-policy-form-field_view-attribute">\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-name">Hourly rate:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.Band.PolicyBandHourlyRate | monetise: $ctrl.config.precision.salaryRates}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="salary-policy-form-field_view-attribute">\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-name">Full time equivalent %:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.FTEPercent}}%</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="salary-policy-form-field_view-attribute">\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-name">Contracted hours per week:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.HoursPerWeek}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="salary-policy-form-field_view-attribute">\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-name">Contracted weeks per year:</div>\n\t\t\t\t\t<div class="salary-policy-form-field_view-attribute-value">{{$ctrl.salaryPolicy.WeeksPerYear}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="salary-policy-form-field_view-note" ng-if="\n\t\t\t\t\t!$ctrl.isAnnualSalaryPolicy &&\n\t\t\t\t\t$ctrl.salaryPolicy.FTEApply\n\t\t\t\t">\n\t\t\t\tCalculated at full time equivalent ({{$ctrl.salaryPolicy.FTEPercent}}%)\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<!-- Add update option  -->\n\t<div class="form-field-footer" ng-if="$ctrl.showAddChange">\n\t\t<a href="" class="is-primary" ng-click="$ctrl.onAddChangeClick($ctrl)">\n\t\t\t<p class="s is-strong">\n\t\t\t\t<i class="icon-add"></i>&nbsp;&nbsp;Add {{$ctrl.salaryPolicy.PolicyPayBasis === $ctrl.POLICY_PAY_BASES.annualSalary ? \'pay\' : \'allowance\'}} change\n\t\t\t</p>\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/schedule-overview-card/schedule-overview-card.component.html','\n<div class="schedule-overview-card" data-cy="schedule-{{:: $ctrl.index}}" ng-class="[\n\t\t$ctrl.schedule.theme,\n\t\t{\n\t\t\t\'has-notification\': $ctrl.schedule.PaymentScheduleTypeID === $ctrl.REPAYMENT_SCHEDULE_TYPES.maternityPay\n\t\t}\n\t]">\n\n\t<div class="schedule-overview-card_container">\n\n\t\t<progress-ring class="schedule-overview-card_progress" ng-if="$ctrl.schedule.hasProgressRing" pr-icon="{{$ctrl.schedule.iconType}}" pr-percentage="$ctrl.schedule.ProgressPercentage" pr-size="small" pr-theme-complete="{{$ctrl.schedule.theme}}"></progress-ring>\n\n\t\t<div class="schedule-overview-card_icon" ng-if="!$ctrl.schedule.hasProgressRing">\n\t\t\t<i class="{{$ctrl.schedule.iconType}} l {{$ctrl.schedule.theme}}"></i>\n\t\t</div>\n\n\t\t<h6 class="schedule-overview-card_type">{{$ctrl.schedule.description}}\n\t\t\t<span class="tag {{$ctrl.schedule.statusTheme}}" ng-if="$ctrl.schedule.statusDisplay">{{$ctrl.schedule.statusDisplay}}</span>\n\t\t</h6>\n\n\t\t<div class="schedule-overview-card_label">\n\t\t\t<i class="{{$ctrl.schedule.overviewIcon}} {{$ctrl.schedule.theme}}" ng-if="$ctrl.schedule.overviewIcon">&nbsp;</i>\n\t\t\t<p class="schedule-overview-card_label-text">{{$ctrl.schedule.overviewLabel}}</p>\n\t\t</div>\n\n\t\t<span class="s strong schedule-overview-card_action" ng-class="[$ctrl.schedule.theme]">\n\t\t\t<span ng-if="$ctrl.schedule.showEditPrompt">Edit&nbsp;</span><i class="icon-chevron-right l"></i>\n\t\t</span>\n\n\t\t<div class="schedule-overview-card_remaining" ng-if="$ctrl.schedule.showRemaining">\n\t\t\t<p class="schedule-overview-card_remaining-value">{{$ctrl.schedule.overviewRemainingValue}}</p>\n\t\t\t<p class="schedule-overview-card_remaining-label">{{$ctrl.schedule.overviewRemainingLabel}}</p>\n\t\t</div>\n\n\t\t<a class="schedule-overview-card_action-overlay" data-cy="schedule-click-action" href="" ng-click="$ctrl.onCardClick()"></a>\n\t</div>\n\n\t<notification-card class="schedule-overview-card_notification" ng-if="$ctrl.schedule.PaymentScheduleTypeID === $ctrl.REPAYMENT_SCHEDULE_TYPES.maternityPay && !$ctrl.schedule.HasAdvanceFunding" theme="is-tertiary-alt is-alt-1">\n\t\t<nc-description>Received advance maternity funding for {{$ctrl.teamMember.Personal.Forename}}?</nc-description>\n\t\t<nc-action>\n\t\t\t<a data-cy="schedule-add-funding-amount" href="" ng-click="$ctrl.openAdvanceMaternityFundingForm($ctrl.schedule.PaymentScheduleGroupID)">Add funding amount</a>\n\t\t</nc-action>\n\t</notification-card>\n\n\t<notification-card class="schedule-overview-card_notification" ng-if="$ctrl.schedule.PaymentScheduleTypeID === $ctrl.REPAYMENT_SCHEDULE_TYPES.maternityPay && $ctrl.schedule.HasAdvanceFunding" theme="is-tertiary-alt is-alt-1">\n\t\t<nc-description>\n\t\t\t<p>\n\t\t\t\t<span ng-repeat="amount in $ctrl.schedule.AdvanceFunding">\n\t\t\t\t\t<span ng-if="!$first">/</span>{{amount.PaymentAmount | monetise}} ({{amount.TaxYearDisplay}})\n\t\t\t\t</span>\n\t\t\t\t<span>&nbsp;advance maternity funding applied for {{$ctrl.teamMember.Personal.Forename}}</span>\n\t\t\t</p>\n\t\t</nc-description>\n\t\t<nc-action>\n\t\t\t<a data-cy="schedule-edit-funding-amount" href="" ng-click="$ctrl.openAdvanceMaternityFundingForm($ctrl.schedule.PaymentScheduleGroupID)">Edit funding amount</a>\n\t\t</nc-action>\n\t</notification-card>\n\n</div>\n');
$templateCache.put('components/search-bar/search-bar.component.html','<div>\n\t<!-- Search Sort (Desktop) -->\n\t<section class="search-bar search-bar--desktop" ng-if="vm.viewMode === vm.VIEW_MODES.desktop">\n\n\t\t<div class="search-bar__left">\n\n\t\t\t<div class="search-bar__bulk-actions fadeInFast" ng-if="vm.hasBulkActions">\n\n\t\t\t\t<!-- Checkbox -->\n\t\t\t\t<div class="search-bar__checkbox">\n\t\t\t\t\t<a aria-label="Select all items" class="multiple-select-checkbox" data-cy="search-bar-select-all-items" href="" ng-class="{\n\t\t\t\t\t\t\t\'disabled\': vm.isCheckboxDisabled(),\n\t\t\t\t\t\t\t\'checked\': !vm.isCheckboxDisabled() && vm.bulkItems.totalSelected > 0 && vm.bulkItems.totalSelected === vm.bulkItems.total,\n\t\t\t\t\t\t\t\'indeterminate\': !vm.isCheckboxDisabled() && vm.bulkItems.totalSelected > 0 && vm.bulkItems.totalSelected < vm.bulkItems.total\n\t\t\t\t\t\t}" ng-click="vm.toggleSelectedItems(vm.bulkItems)">\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Bulk Actions -->\n\t\t\t\t<div class="search-bar__actions fadeInFast" ng-if="vm.bulkItems.totalSelected > 0">\n\t\t\t\t\t<menu-button menu-button-icon="icon-setup" menu-button-id="search-bar-actions" menu-button-text="Actions" menu-button-theme="primary">\n\t\t\t\t\t\t<div ng-transclude="bulkActions"></div>\n\t\t\t\t\t</menu-button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Count -->\n\t\t\t<div class="search-bar__count" data-cy="search-bar-count">\n\t\t\t\t<span ng-if="vm.hasBulkActions && vm.bulkItems.totalSelected > 0">{{vm.getTotalSelected()}} of&nbsp;</span><ng-pluralize count="vm.bulkItems !== undefined ? vm.bulkItems.filtered.length : vm.count" when="{\'0\': vm.options.search.terms.noResults, \'1\': vm.options.search.terms.singular, \'other\': vm.options.search.terms.plural}"></ng-pluralize>\n\t\t\t</div>\n\n\t\t\t<!-- Items per page -->\n\t\t\t<div ng-if="vm.options.results.canChangeItemsPerPage && vm.options.itemsPerPageOptions.length > 1" class="search-bar__display">\n\t\t\t\t<dropdown-menu menu-id="search-bar-items-per-page-menu" menu-show="vm.options.showItemsPerPageMenu" menu-text="{{vm.options.itemsPerPageOption.display}}" menu-theme="primary">\n\t\t\t\t\t<a href="" data-cy="search-bar-items-per-page-option-{{itemsPerPageOption.key}}" ng-class="{\n\t\t\t\t\t\t\t\'active\': vm.options.itemsPerPageOption.key === itemsPerPageOption.key\n\t\t\t\t\t\t}" ng-click="vm.changeItemsPerPage(vm.options, itemsPerPageOption)" ng-repeat="itemsPerPageOption in vm.options.itemsPerPageOptions">\n\t\t\t\t\t\t{{itemsPerPageOption.display}}\n\t\t\t\t\t</a>\n\t\t\t\t</dropdown-menu>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="search-bar__right">\n\n\t\t\t<!-- Left Actions -->\n\t\t\t<div class="search-bar__actions" ng-if="vm.hasLeftActions" ng-transclude="leftActions"></div>\n\n\t\t\t<!-- Search -->\n\t\t\t<div class="search-bar__option fadeIn" ng-if="!vm.options.search.hide">\n\t\t\t\t<search-field search-options="vm.options" is-search-active="vm.options.showMobileSearch"></search-field>\n\t\t\t</div>\n\n\t\t\t<!-- Sort -->\n\t\t\t<div class="search-bar__option" ng-if="vm.options.orderByOptions">\n\t\t\t\t<dropdown-menu menu-id="search-bar-sort-menu" menu-show="vm.options.showOrderByMenu" menu-text="{{vm.options.orderByObj.title}}" menu-theme="primary">\n\t\t\t\t\t<a href="" data-cy="search-bar-items-sort-option-{{orderByOption.key}}" ng-class="{\n\t\t\t\t\t\t\t\'active\': vm.options.orderByObj.key === orderByOption.key\n\t\t\t\t\t\t}" ng-click="vm.changeOrderBy(vm.options, orderByOption)" ng-repeat="orderByOption in vm.options.orderByOptions">\n\t\t\t\t\t\t{{orderByOption.title}}\n\t\t\t\t\t</a>\n\t\t\t\t</dropdown-menu>\n\t\t\t</div>\n\n\t\t\t<!-- Custom -->\n\t\t\t<div class="search-bar__option" ng-if="vm.options.customOptions">\n\t\t\t\t<dropdown-menu menu-id="search-bar-custom-menu" menu-show="vm.options.showCustomMenu" menu-text="{{vm.options.customObj.title}}" menu-theme="primary">\n\t\t\t\t\t<a href="" data-cy="search-bar-items-custom-option-{{customOption.key}}" ng-class="{\n\t\t\t\t\t\t\t\'active\': vm.options.customObj.key === customOption.key\n\t\t\t\t\t\t}" ng-click="vm.changeCustom(vm.options, customOption)" ng-repeat="customOption in vm.options.customOptions">\n\t\t\t\t\t\t{{customOption.title}}\n\t\t\t\t\t</a>\n\t\t\t\t</dropdown-menu>\n\t\t\t</div>\n\n\t\t\t<!-- Layout -->\n\t\t\t<div class="search-bar__option" ng-if="vm.options.layoutOptions">\n\t\t\t\t<div class="search-bar__layouts">\n\t\t\t\t\t<button aria-label="Set layout option: {{layoutOption.title}}" class="search-bar__layouts-option is-white is-icon-only" data-cy="search-bar-layout-{{layoutOption.key}}" ng-click="vm.changeLayout(vm.options, layoutOption)" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': vm.options.layoutObj.key === layoutOption.key\n\t\t\t\t\t\t}" ng-repeat="layoutOption in vm.options.layoutOptions" type="button">\n\t\t\t\t\t\t<i class="icon-{{layoutOption.key}} m"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Right Actions -->\n\t\t\t<div class="search-bar__actions is-right-aligned" ng-if="vm.hasRightActions" ng-transclude="rightActions"></div>\n\n\t\t\t<!-- Actions (buttons in desktop view)-->\n\t\t\t<div class="search-bar__actions is-right-aligned" ng-if="vm.showSearchBarActions">\n\t\t\t\t<a data-cy="search-bar-action-{{searchBarAction.key}}" href="" ng-class="[\'button\', \'is-small\', \'{{searchBarAction.theme}}\', searchBarAction.disabled ? \'disabled\' : \'\']" ng-click="searchBarAction.disabled || vm.searchBarActionSelected(vm.options, searchBarAction.key)" ng-repeat="searchBarAction in vm.options.actions" tooltip tooltip-position="top" tooltip-size="s" tooltip-text="{{searchBarAction.tooltipText}}">\n\t\t\t\t\t\t<i class="{{searchBarAction.icon}}" ng-if="searchBarAction.icon"></i>\n\t\t\t\t\t{{searchBarAction.label}}\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t</div>\n\n\t</section>\n\n\t<!-- Search / Sort (Phone) -->\n\t<section class="search-bar search-bar--mobile" ng-if="vm.viewMode === vm.VIEW_MODES.mobile">\n\n\t\t<!-- Controls -->\n\t\t<div class="search-bar__row">\n\t\t\t<div class="search-bar__left">\n\n\t\t\t\t<!-- Checkbox -->\n\t\t\t\t<div class="search-bar__checkbox" ng-if="vm.hasBulkActions">\n\t\t\t\t\t<a aria-label="Select all items" href="" class="multiple-select-checkbox" ng-class="{\n\t\t\t\t\t\t\t\'disabled\': vm.isCheckboxDisabled(),\n\t\t\t\t\t\t\t\'checked\': !vm.isCheckboxDisabled() && vm.bulkItems.totalSelected === vm.bulkItems.total,\n\t\t\t\t\t\t\t\'indeterminate\': !vm.isCheckboxDisabled() && vm.bulkItems.totalSelected > 0 && vm.bulkItems.totalSelected < vm.bulkItems.total\n\t\t\t\t\t\t}" ng-click="vm.toggleSelectedItems(vm.bulkItems)"></a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Count -->\n\t\t\t\t<div class="search-bar__count" data-cy="search-bar-count-mobile" ng-if="vm.count">\n\t\t\t\t\t<ng-pluralize count="vm.count" when="{\'0\': vm.options.search.terms.noResults, \'1\': vm.options.search.terms.singular, \'other\': vm.options.search.terms.plural}"></ng-pluralize>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="search-bar__right">\n\n\t\t\t\t<!-- Left Actions -->\n\t\t\t\t<div class="search-bar__actions" ng-if="vm.hasLeftActions" ng-transclude="leftActions"></div>\n\n\t\t\t\t<a href="" class="button white is-icon-only search-bar__option" ng-click="vm.toggleMobileItemsPerPage(vm.options)" ng-class="{\'active\': vm.options.showMobileItemsPerPage}" ng-if="vm.options.results.canChangeItemsPerPage && vm.options.itemsPerPageOptions.length > 1">{{vm.options.itemsPerPageOption.display}}</a>\n\t\t\t\t<a href="" class="button white is-icon-only search-bar__option" data-cy="search-toggle" ng-click="vm.toggleMobileSearch(vm.options)" ng-class="{\'active\': vm.options.showMobileSearch}" ng-if="!vm.options.search.hide" aria-label="Toggle search"><i class="icon-search"></i></a>\n\t\t\t\t<a href="" class="button white is-icon-only search-bar__option" ng-click="vm.toggleMobileSort(vm.options)" ng-if="vm.options.orderByOptions" aria-label="Toggle sort"><i class="icon-sort"></i></a>\n\t\t\t\t<a href="" class="button white is-icon-only search-bar__option" ng-click="vm.toggleMobileCustom(vm.options)" ng-if="vm.options.customOptions" aria-label="Toggle settings"><i class="icon-filter"></i></a>\n\t\t\t\t<!--\n\t\t\t\t\tHidden for the time being. Mobile menu needs some work. Defaulting to desktop buttons style (see below)\n\t\t\t\t-->\n\t\t\t\t<!-- <a href="" class="button white is-icon-only search-bar__option is-inverse" ng-click="vm.toggleMobileActions(vm.options)" ng-if="vm.showSearchBarActions"><i class="icon-setup"></i></a> -->\n\n\t\t\t\t<!-- Sort Menu -->\n\t\t\t\t<mobile-menu mm-title="Sort" ng-if="vm.options.showMobileSort">\n\t\t\t\t\t<a href="" ng-repeat="orderByOption in vm.options.orderByOptions" ng-click="vm.changeOrderBy(vm.options, orderByOption)" ng-class="{\'active\': vm.options.orderByObj.key === orderByOption.key}">{{orderByOption.title}}</a>\n\t\t\t\t</mobile-menu>\n\n\t\t\t\t<!-- Items per page Menu -->\n\t\t\t\t<mobile-menu mm-title="Items per page" ng-if="vm.options.showMobileItemsPerPage">\n\t\t\t\t\t<a href="" ng-repeat="itemsPerPageOption in vm.options.itemsPerPageOptions" ng-click="vm.changeItemsPerPage(vm.options, itemsPerPageOption)" ng-class="{\'active\': vm.options.itemsPerPageOption.key === itemsPerPageOption.key}">{{itemsPerPageOption.display}}</a>\n\t\t\t\t</mobile-menu>\n\n\t\t\t\t<!-- Custom Menu -->\n\t\t\t\t<mobile-menu mm-title="Custom" ng-if="vm.options.showMobileCustom">\n\t\t\t\t\t<a href="" ng-repeat="customOption in vm.options.customOptions" ng-click="vm.changeCustom(vm.options, customOption)" ng-class="{\'active\': vm.options.customObj.key === customOption.key}">{{customOption.title}}</a>\n\t\t\t\t</mobile-menu>\n\n\t\t\t\t<!-- Right Actions -->\n\t\t\t\t<div class="search-bar__actions is-right-aligned" ng-if="vm.hasRightActions" ng-transclude="rightActions"></div>\n\n\t\t\t\t<!-- Action menu -->\n\t\t\t\t<!--\n\t\t\t\t\tHidden for the time being. Mobile menu needs some work.\n\t\t\t\t-->\n\t\t\t\t<!-- <mobile-menu menu-title="Actions" ng-if="vm.options.showMobileActions">\n\t\t\t\t\t<a href="" ng-repeat="searchBarAction in vm.options.actions" ng-click="vm.searchBarActionSelected(vm.options, searchBarAction.key)">{{searchBarAction.label}}</a>\n\t\t\t\t</mobile-menu> -->\n\n\t\t\t\t<!-- Show actions as desktop -->\n\t\t\t\t<div class="search-bar__actions is-right-aligned" ng-if="vm.showSearchBarActions">\n\t\t\t\t\t<a data-cy="search-bar-action-{{searchBarAction.key}}" href="" ng-class="[\'button\', \'is-small\', \'{{searchBarAction.theme}}\', searchBarAction.disabled ? \'disabled\' : \'\']" ng-click="searchBarAction.disabled || vm.searchBarActionSelected(vm.options, searchBarAction.key)" ng-repeat="searchBarAction in vm.options.actions" tooltip tooltip-position="top" tooltip-size="s" tooltip-text="{{searchBarAction.tooltipText}}">\n\t\t\t\t\t\t<i class="{{searchBarAction.icon}}" ng-if="searchBarAction.icon"></i>\n\t\t\t\t\t\t{{searchBarAction.label}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="search-bar__row fadeIn" ng-if="vm.bulkItems.totalSelected > 0">\n\t\t\t<menu-button class="search-bar__actions" menu-button-text="Actions" menu-button-theme="primary" menu-button-icon="icon-setup">\n\t\t\t\t<div ng-transclude="bulkActions"></div>\n\t\t\t</menu-button>\n\t\t</div>\n\n\t\t<!-- Search -->\n\t\t<div class="search-bar__row fadeIn" ng-if="vm.options.showMobileSearch">\n\t\t\t<search-field search-options="vm.options" is-search-active="true"></search-field>\n\t\t</div>\n\t</section>\n</div>\n');
$templateCache.put('components/search-box/search-box.component.html','<!-- Clickable, but ensure the outer search-box can\'t get focus. -->\n<div class="search-box is-primary" tabindex="-1">\n\t<search-box_tag-list class="search-box_tag-list" ng-if="$ctrl.tagList.length > 0">\n\t\t<div class="search-box_tag" ng-repeat="tag in $ctrl.tagList">{{tag.name}}&nbsp;<a href="" class="search-box_tag-remove" ng-click="$ctrl.removeTag($ctrl, $index)">&Cross;</a></div>\n\t</search-box_tag-list>\n\t<input id="{{$ctrl.inputId}}" class="search-box_input" ng-model="$ctrl.ngModel" placeholder="{{$ctrl.placeholder}}" ng-if="$ctrl.tagList.length === 0">\n\t<button type="button" class="is-clear search-box_clear" ng-click="$ctrl.clearSearch($ctrl)" ng-if="$ctrl.showClear && ($ctrl.ngModel !== \'\' || $ctrl.tagList.length !== 0)"></button>\n</div>');
$templateCache.put('components/search-field/search-field.component.html','<div class="search-field {{$ctrl.searchOptions.isSearchActive ? \'is-active\' : \'is-not-active\'}}" ng-class="{\'has-filters\': $ctrl.searchOptions.search.filterOptions.length}">\n\t\n\t<!-- Search -->\n\t<div class="search-field_search" ng-show="$ctrl.searchOptions.isSearchActive">\n\n\t\t<!-- Input -->\n\t\t<input autocomplete="off" class="small search-field_input" data-cy="{{$ctrl.searchOptions.id}}" id="{{$ctrl.searchOptions.id}}" name="search-field_input" placeholder="{{$ctrl.searchOptions.search.terms.placeholder}}" type="text" ng-change="$ctrl.searchOptions.onSearchChange($ctrl.searchOptions)" ng-model="$ctrl.searchOptions.search.string" pc-keypress pc-keypress-key="escape" pc-keypress-action="$ctrl.hideSearch($ctrl)">\n\n\t\t<a href="" class="search-field_clear" ng-click="$ctrl.clearOrHideSearch($ctrl)" aria-label="Close search"><i class="icon-cross"></i></a>\n\n\t\t<!-- Search filters -->\n\t\t<div class="search-field_filters" ng-if="$ctrl.searchOptions.search.filterOptions.length">\n\t\t\t<dropdown-menu menu-align="is-aligned-right is-justified" menu-show="$ctrl.searchOptions.filterOptionsMenuOpen" menu-size="sm" menu-theme="is-primary-alt" menu-text="{{$ctrl.searchOptions.search.filterOption.description}}">\n\t\t\t\t<a href="" ng-repeat="option in $ctrl.searchOptions.search.filterOptions" ng-click="$ctrl.changeFilter($ctrl, option)" ng-class="{\'active\': $ctrl.searchOptions.search.filterOption.id === option.id}">{{option.description}}</a>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\t\n\t<!-- Search toggle -->\n\t<a href="" class="search-field_button" data-cy="search-toggle" ng-class="$ctrl.searchOptions.search.iconTheme" ng-click="$ctrl.toggleIsSearchActive($ctrl)" ng-show="!$ctrl.searchOptions.isSearchActive" aria-label="Toggle search"><i class="icon-search"></i></a>\n\n</div>\n');
$templateCache.put('components/search-select/search-select.component.html','<div class="search-select">\n\t<div class="search-select_input pill-input-field is-compact has-icon is-primary has-darkened-border" ng-class="{\'is-disabled\': isDisabled}">\n\t\t<div class="pill-input-field-icon">\n\t\t\t<i class="icon-search"></i>\n\t\t</div>\n\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" data-cy="search-select-input" ng-change="onSearchTextChange()" ng-disabled="isDisabled" ng-model="searchText" placeholder="Search..." type="text">\n\t\t<div class="pill-input-search-results is-alternate fadeIn" click-anywhere-but-here="reset()" is-active="isOpen" ng-show="isOpen">\n\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t<p class="pill-input-search-results-subheading" ng-if="filteredItems.length > 0">\n\t\t\t\t\t<ng-pluralize count="filteredItems.length" when="{\'1\': \'1 {{labelSingular}}\', \'other\': \'{} {{labelPlural}}\'}"></ng-pluralize>&nbsp;found\n\t\t\t\t</p>\n\t\t\t\t<button aria-label="Select item" class="search-select-result is-clear is-primary" data-cy="search-select-result-{{$index}}" ng-click="onItemClick(ssItem)" ng-if="filteredItems.length" ng-repeat="ssItem in filteredItems" type="button">\n\t\t\t\t\t<div search-select-item="ssItem"></div>\n\t\t\t\t</button>\n\t\t\t\t<p ng-if="!filteredItems.length">\n\t\t\t\t\t<span class="caption">No results found</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/secondary-loading-mask/secondary-loading-mask.component.html','<div class="secondary-loading-mask fadeIn" ng-if="$ctrl.loadingMaskOptions.showMask">\n\n\t<div class="secondary-loading-mask_content">\n\t\t<div class="secondary-loading-mask_loader">\n\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t</div>\n\n\t\t<p class="secondary-loading-mask_copy" ng-if="$ctrl.loadingMaskOptions.message">\n\t\t\t{{$ctrl.loadingMaskOptions.message}}\n\t\t</p>\n\t</div>\n\n</div>\n');
$templateCache.put('components/settings-overview-card/settings-overview-card.component.html','<div data-cy="{{::$ctrl.settingsOverviewGroup.title | slugify}}-card" class="settings-overview-card">\n\n\t<!-- Header -->\n\t<div class="settings-overview-card_header">\n\t\t<icon-dot icon="icon-{{::$ctrl.settingsOverviewGroup.icon}}" theme="is-extra-large is-primary settings-overview-card_header-icon"></icon-dot>\n\t\t<h5 class="settings-overview-card_header-title">{{::$ctrl.settingsOverviewGroup.title}}</h5>\n\t</div>\n\n\t<!-- Optional transcludes -->\n\t<div class="settings-overview-card_main">\n\t\t<div class="settings-overview-card_items">\n\t\t\t<div class="settings-overview-card_item" ng-repeat="item in $ctrl.settingsOverviewGroup.settingsGroups">\n\t\t\t\t<a href="{{::item.ngHref}}" class="settings-overview-card_item-link" data-cy="{{::item.key}}">{{::item.name}}</a>\n\t\t\t\t<div class="settings-overview-card_item-meta" ng-switch="item.type">\n\n\t\t\t\t\t<!-- Percentage Complete -->\n\t\t\t\t\t<div class="settings-overview-card_item-percentage-complete" ng-switch-when="percentage-complete">\n\t\t\t\t\t\t<progress-bar pb-has-value="true" pb-percentage="item.value" pb-template="is-primary is-base-greyscale-lighter" pb-theme="{{item.theme | cemify}}"></progress-bar>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Count -->\n\t\t\t\t\t<div ng-switch-when="count">\n\t\t\t\t\t\t<span class="tag is-primary-lighter">{{::item.value}}</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Tag -->\n\t\t\t\t\t<div ng-switch-when="tag">\n\t\t\t\t\t\t<span class="tag" ng-class="[item.theme]">{{::item.value}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/settings-row/settings-row.component.html','<div class="settings-row" ng-class="[$ctrl.srTheme, {\'is-active\': $ctrl.ngModel}, {\'is-disabled\': $ctrl.srDisabled}, {\'is-collapsed\': $ctrl.srContentCollapsed}]">\n\n\t<div class="settings-row_field">\n\t\t<h6 class="settings-row_field-label">\n\t\t\t<i class="icon-{{::$ctrl.srIcon}} is-medium settings-row_field-icon" ng-class="$ctrl.srTheme" ng-if="$ctrl.hasIcon"></i>\n\t\t\t<span ng-transclude="label">{{$ctrl.srLabel}}</span>\n\t\t</h6>\n\t\t<p class="settings-row_field-description" ng-transclude="description"></p>\n\n\t\t<!-- Toggle -->\n\t\t<div class="settings-row_field-toggle">\n\t\t\t<toggle-input field-on-change="$ctrl.toggleSetting($ctrl)" field-name="{{$ctrl.srFieldName}}" field-model="$ctrl.ngModel" field-disabled="$ctrl.srDisabled" field-theme-active="{{$ctrl.srTheme}}" field-theme-light="true" field-style="is-large" field-show-indicator="true"></toggle-input>\n\t\t</div>\n\t</div>\n\n\t<section class="settings-row_content" ng-transclude="content" ng-if="$ctrl.hasContent"></section>\n</div>\n');
$templateCache.put('components/setup-block/setup-block.component.html','<section class="setup-block {{$ctrl.sbTheme}}">\n\t<div class="setup-block_layout">\n\t\t<div class="setup-block_graphic">\n\t\t\t<img alt="" class="setup-block_image" src="{{$ctrl.sbGraphic}}">\n\t\t</div>\n\t\t<div class="setup-block_header" ng-transclude="header"></div>\n\t\t<div class="setup-block_content" ng-transclude="content"></div>\n\t</div>\n</section>\n');
$templateCache.put('components/shade-picker/shade-picker.component.html','<div class="shade-picker">\n\t<input type="radio" name="shade" id="dark" ng-model="$ctrl.spModel" ng-value="$ctrl.CUSTOMISATION_SHADES.dark" ng-change="$ctrl.onChange()" class="shade-picker_radio">\n\t<label for="dark" class="shade-picker_shade">Dark</label>\n\n\t<input type="radio" name="shade" id="light" ng-model="$ctrl.spModel" ng-value="$ctrl.CUSTOMISATION_SHADES.light" ng-change="$ctrl.onChange()" class="shade-picker_radio">\n\t<label for="light" class="shade-picker_shade is-light">Light</label>\n</div>\n');
$templateCache.put('components/side-bar-item/side-bar-item.component.html','<button class="side-bar-item is-clear" data-cy="{{$ctrl.id}}" ng-disabled="$ctrl.isDisabled" ng-class="[\n\t\t$ctrl.theme,\n\t\t$ctrl.variant,\n\t\t{ \'is-active\': $ctrl.isActive }\n\t]" ng-click="$ctrl.onClick()" type="button">\n\n\t<i class="side-bar-item_icon" ng-class="$ctrl.icon" ng-if="$ctrl.icon"></i>\n\n\t<span class="side-bar-item_content">\n\n\t\t<truncate class="side-bar-item_heading" text="$ctrl.heading" truncate-amount="18"></truncate>\n\n\t\t<p class="side-bar-item_description" ng-if="$ctrl.hasDescription" ng-transclude="description"></p>\n\n\t</span>\n\n\t<i class="side-bar-item_chevron icon-chevron-right"></i>\n\n</button>\n');
$templateCache.put('components/signed-amount-tag/signedAmountTagComponent.html','<div class="signed-amount-tag" ng-class="{ \'is-negative\' : amount < 0, \'is-positive\' : amount > 0}">{{amount | monetise: 2:\'signed\'}}</div>');
$templateCache.put('components/simple-work-pattern/simple-work-pattern.component.html','<div class="simple-work-pattern-builder">\n\t<section>\n\t\t<div class="simple-work-pattern-builder_group dropIn">\n\t\t\t<div class="simple-work-pattern-builder_cards">\n\t\t\t\t<label class="simple-work-pattern-builder_card is-weekly is-primary" ng-class="{\'is-disabled\': !day.value}" ng-repeat="day in $ctrl.workPattern track by $index">\n\t\t\t\t\t<header class="simple-work-pattern-builder_card-header">\n\t\t\t\t\t\t<p class="simple-work-pattern-builder_card-label" data-cy="simple-work-pattern-builder-card-{{day.day | slugify}}">\n\t\t\t\t\t\t\t{{day.day}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="simple-work-pattern-builder_card-checkbox">\n\t\t\t\t\t\t\t<input id="{{day.day + $index}}" checkbox-input checkbox-input-theme="primary" data-cy="simple-work-pattern-builder-card-{{day.day | slugify}}-input" name="day.day + $index" ng-model="day.value" ng-change="$ctrl.onUpdateDay(day)" type="checkbox">\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</header>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n</div>\n');
$templateCache.put('components/simple-work-pattern-summary/simple-work-pattern-summary.component.html','<div class="simple-work-pattern-schedule is-primary">\n\n\t<div class="simple-work-pattern-schedule_items">\n\t\t<div class="simple-work-pattern-schedule_label">M</div>\n\t\t<div class="simple-work-pattern-schedule_label">T</div>\n\t\t<div class="simple-work-pattern-schedule_label">W</div>\n\t\t<div class="simple-work-pattern-schedule_label">T</div>\n\t\t<div class="simple-work-pattern-schedule_label">F</div>\n\t\t<div class="simple-work-pattern-schedule_label">S</div>\n\t\t<div class="simple-work-pattern-schedule_label">S</div>\n\t</div>\n\n\t<!-- Working Days -->\n\t<div class="simple-work-pattern-schedule_items">\n\t\t<div class="simple-work-pattern-schedule_item" ng-class="{\n\t\t\t\t\'is-disabled\': !day.value\n\t\t\t}" ng-repeat="day in $ctrl.workPattern track by $index">\n\t\t\t{{day.value ? (0 | workPatternDayType) :( 1 | workPatternDayType)}}\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/slide-in-form/slideInFormComponent.html','<div class="slide-in-form {{formOptions.size}}" ng-if="formOptions.isOpen">\n\t<div class="slide-in-form-body {{formOptions.size}}" id="slide-in-form-body" ng-class="{\'fadeInRight\' : !formOptions.isClosing, \'fadeOutRight\': formOptions.isClosing}">\n\t\t<header class="slide-in-form-header" ng-if="formOptions.showHeader">\n\t\t\t<h5 class="slide-in-form-title" data-cy="slide-in-form-title" ng-bind="formOptions.title || \'No title provided\'" title="{{formOptions.title || \'No title provided\'}}"></h5>\n\t\t\t<a aria-label="Open Help and Support" class="slide-in-form-action" href="" id="slide-in-form-support" ng-click="formOptions.openInlineHelpAndSupport()" ng-if="::$root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureaumanager, USER_ROLES.bureau])">\n\t\t\t\t<i class="icon-support"></i>\n\t\t\t</a>\n\t\t\t<a aria-label="Close form" class="slide-in-form-action" ng-class="{\n\t\t\t\t\t\'is-disabled\' : formOptions.isCloseFormDisabled\n\t\t\t\t}" href="" id="slide-in-form-close" ng-click="formOptions.isWizard ? formOptions.closeWizard() : formOptions.closeForm()" ng-if="formOptions.canCloseForm">\n\t\t\t\t<i class="icon-{{formOptions.closeIcon || \'cross\'}}"></i>\n\t\t\t</a>\n\t\t</header>\n\n\t\t<main class="slide-in-form-main" id="slideInFormContent" ng-transclude></main>\n\t</div>\n</div>\n');
$templateCache.put('components/sort-code/sort-code.component.html','<div class="sort-code">\n\t<input class="s" data-cy="{{$ctrl.sortCodeName}}" maxlength="6" minlength="6" name="{{$ctrl.sortCodeName}}" ng-disabled="$ctrl.sortCodeDisabled" ng-model="$ctrl.sortCode" ng-pattern="$root.REGEX.sortcode" ng-required="$ctrl.sortCodeRequired" placeholder="123456" type="text">\n</div>\n');
$templateCache.put('components/split-pane/split-pane.component.html','<div class="split-pane template-{{$ctrl.spTemplate}} fadeIn" ng-switch="$ctrl.spTemplate">\n\n\t<div class="split-pane-left">\n\n\t\t<div class="split-pane-left_logo-container">\n\t\t\t<img alt="Paycircle Logo" class="split-pane-left_logo" height="34" ng-switch-when="paycircle" src="/images/paycircle-logo.png">\n\t\t</div>\n\n\t\t<div class="split-pane-left-container" ng-class="$ctrl.spLeftTheme" ng-transclude="spLeft"></div>\n\t</div>\n\n\t<!-- Customisation -->\n\t<div class="split-pane-right {{$root.session.customisation.Login.TextShade}}" ng-style="{\n\t\t\t\'background-color\': $root.session.customisation.Login.BackgroundColour\n\t\t}" ng-switch-when="customisation">\n\t\t<div class="split-pane-right-container">\n\t\t\t<div class="split-pane-customisation">\n\t\t\t\t<img alt="{{$root.session.customisation.AgencyProfileName}} logo" class="split-pane-customisation-logo" ng-if="::$root.session.customisation.Login.LogoURL !== \'\'" ng-src="{{$root.session.customisation.Login.LogoURL}}">\n\t\t\t\t<div class="split-pane-customisation-details" ng-if="::$root.session.customisation.Login.IsAddressVisible || $root.session.customisation.Login.IsPhoneVisible || $root.session.customisation.Login.IsEmailAddressVisible">\n\t\t\t\t\t<div ng-if="::$root.session.customisation.Login.IsAddressVisible">\n\t\t\t\t\t\t<h5 class="split-pane-customisation-name">\n\t\t\t\t\t\t\t{{$root.session.customisation.AgencyProfileName}}\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t<print-address address="$root.session.customisation.Login.Address" class="split-pane-customisation-address"></print-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<a class="underline split-pane-customisation-phone" href="tel:{{$root.session.customisation.Login.Phone}}" ng-if="::$root.session.customisation.Login.IsPhoneVisible">\n\t\t\t\t\t\t{{$root.session.customisation.Login.Phone}}\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="underline split-pane-customisation-email" href="mailto:{{$root.session.customisation.Login.EmailAddress}}" ng-if="::$root.session.customisation.Login.IsEmailAddressVisible">\n\t\t\t\t\t\t{{$root.session.customisation.Login.EmailAddress}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Paycircle -->\n\t<div class="split-pane-right" ng-switch-when="paycircle">\n\t\t<div class="split-pane-right-container">\n\t\t\t<div class="split-pane-right-contents">\n\t\t\t\t<img alt="Cloud technology" class="split-pane-right-image" src="images/graphics/cloud-tech.2x.png">\n\t\t\t\t<h1 class="split-pane-right-title">\n\t\t\t\t\tHello, welcome to your<br>payroll portal\n\t\t\t\t</h1>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/stat-card-actions/stat-card-actions.component.html','<div class="stat-card-actions" ng-class="{\'stat-card-actions_inline-actions\': $ctrl.isInline}">\n\t<div class="stat-card-actions_content">\n\t\t<div class="stat-card-actions_header">\n\t\t\t<icon-dot icon="{{$ctrl.isPositive ? \'icon-tick\' : \'icon-warning\'}}" is-light="true" theme="{{$ctrl.isPositive ? \'is-secondary\' : \'is-assertive\'}}">\n\t\t\t</icon-dot>\n\t\t\t<h6 class="stat-card-actions_title" data-cy="{{$ctrl.cytext}}-title">\n\t\t\t\t{{$ctrl.cardTitle}}\n\t\t\t</h6>\n\t\t</div>\n\t\t<div class="stat-card-actions_main">\n\t\t\t<p class="is-small" data-cy="{{$ctrl.cytext}}-description">\n\t\t\t\t{{$ctrl.cardDescription}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\t<div class="stat-card-actions_actions">\n\t\t<button data-cy="{{$ctrl.cytext}}-{{action.label}}" ng-class="{\n\t\t\t\t\'button is-default\': !action.isPrimary,\n\t\t\t\t\'button is-primary\': action.isPrimary\n\t\t\t}" ng-repeat="action in $ctrl.actions" ng-click="action.onClick()" ng-disabled="action.isDisabled">\n\t\t\t{{action.label}}\n\t\t</button>\n\t</div>\n</div>\n');
$templateCache.put('components/stat-payment-summary-card/stat-payment-summary-card.component.html','<div class="stat-payment-summary-card is-primary">\n\t<div class="stat-payment-summary-card_header">\n\t\t<i class="icon-{{$ctrl.icon}} stat-payment-summary-card_icon"></i>\n\t\t<div class="stat-payment-summary-card_date-range">\n\t\t\t<div class="stat-payment-summary-card_date-from">\n\t\t\t\t<h6>Start date:</h6>\n\t\t\t\t<p data-cy="stat-payment-start-date" ng-if="!$ctrl.statPayment.WasBabyBornEarly">\n\t\t\t\t\t{{$ctrl.statPayment.StartDateISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t\t<p data-cy="stat-payment-start-date" ng-if="$ctrl.statPayment.WasBabyBornEarly">\n\t\t\t\t\t{{$ctrl.statPayment.EarlyStartDateISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="stat-payment-summary-card_date-to">\n\t\t\t\t<h6>End date:</h6>\n\t\t\t\t<p data-cy="stat-payment-end-date">{{$ctrl.statPayment.EndDateISO | dateformat}}</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<a href="" class="stat-payment-summary-card_action" data-cy="stat-payment-edit-action" ng-click="$ctrl.onEdit($ctrl.statPayment)" ng-if="$ctrl.canEdit"><i class="icon-edit"></i></a>\n\t</div>\n\t<div class="stat-payment-summary-card_footer">\n\t\t<div class="stat-payment-summary-card_meta">\n\n\t\t\t<!-- Due date -->\n\t\t\t<div class="stat-payment-summary-card_date" ng-if="$ctrl.statPayment.DueDateISO">\n\t\t\t\t<p class="stat-payment-summary-card_label">Due date</p>\n\t\t\t\t<p data-cy="stat-payment-due-date" class="stat-payment-summary-card_value">\n\t\t\t\t\t{{$ctrl.statPayment.DueDateISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Total pay due -->\n\t\t\t<div class="stat-payment-summary-card_amount">\n\t\t\t\t<p class="stat-payment-summary-card_label">Total pay due</p>\n\t\t\t\t<p data-cy="stat-payment-total-amount" class="stat-payment-summary-card_value">\n\t\t\t\t\t{{$ctrl.statPayment.TotalAmount | monetise}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Paid to date -->\n\t\t\t<div class="stat-payment-summary-card_amount">\n\t\t\t\t<p class="stat-payment-summary-card_label">Paid to date</p>\n\t\t\t\t<p data-cy="stat-payment-total-amount-paid" class="stat-payment-summary-card_value">\n\t\t\t\t\t{{$ctrl.statPayment.TotalAmountPaid | monetise}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Still to pay -->\n\t\t\t<div class="stat-payment-summary-card_amount">\n\t\t\t\t<p class="stat-payment-summary-card_label">Still to pay</p>\n\t\t\t\t<p data-cy="stat-payment-total-amount-remaining" class="stat-payment-summary-card_value">\n\t\t\t\t\t{{$ctrl.statPayment.TotalAmountRemaining | monetise}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="stat-payment-summary-card_footer-main">\n\t\t\t<div>\n\t\t\t\t<p data-cy="stat-payment-footer-message" class="stat-payment-summary-card_footer-text">\n\t\t\t\t\t<span ng-if="$ctrl.statPayment.WasBabyBornEarly">Start date before early birth: {{$ctrl.statPayment.StartDateISO | dateformat}}<br></span>\n\t\t\t\t\tSchedule calculated on a {{$ctrl.statPayment.CalculationMethod | statutoryPayCalculationMethodDescription}} basis\n\t\t\t\t</p>\n\t\t\t\t<p class="s" data-cy="stat-payment-update-reason" ng-if="[\n\t\t\t\t\t\t$ctrl.SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased,\n\t\t\t\t\t\t$ctrl.SCHEDULE_UPDATE_REASONS.ReturnToWork,\n\t\t\t\t\t\t$ctrl.SCHEDULE_UPDATE_REASONS.SharedParentalLeave\n\t\t\t\t\t].includes($ctrl.statPayment.updateReason)">\n\t\t\t\t\tBased on an early end date of {{$ctrl.statPayment.EndDateISO | dateformat}}.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small stat-payment-summary-card_footer-action" ng-if="$ctrl.statPayment.SalaryPayments.length">\n\t\t\t\t\t<a data-cy="stat-payment-gross-payments-action" href="" ng-click="$ctrl.toggleShowGrossPayments($ctrl)">\n\t\t\t\t\t\t<i class="icon-chevron-{{$ctrl.isGrossPaymentsVisible ? \'up\' : \'down\'}}"></i>&nbsp;{{$ctrl.isGrossPaymentsVisible ? \'Hide\' : \'Show\'}} gross payments entered\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="stat-payment-summary-card_footer-states" ng-if="$ctrl.statPayment.SalarySacrificeState">\n\n\t\t\t\t<!-- Salary sacrifice -->\n\t\t\t\t<div class="stat-payment-summary-card_footer-state" data-cy="stat-payment-salary-sacrifice-icon" tooltip tooltip-position="left" tooltip-text="Included in salary sacrifice calculations">\n\t\t\t\t\t<icon-dot icon="icon-salary-change" theme="primary has-hover is-alt-1"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="payment-list is-primary stat-payment-summary-card_footer-payments fadeIn" ng-if="$ctrl.isGrossPaymentsVisible">\n\t\t\t<div class="payment-list_item" ng-repeat="salaryPayment in $ctrl.statPayment.SalaryPayments">\n\t\t\t\t<span class="payment-list_item-description" data-cy="stat-payment-payment-{{$index}}-date">\n\t\t\t\t\t{{::salaryPayment.PaymentDateISO | dateformat}}\n\t\t\t\t</span>\n\t\t\t\t<span class="payment-list_item-value" data-cy="stat-payment-payment-{{$index}}-amount">\n\t\t\t\t\t{{::salaryPayment.PaymentAmount | monetise}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/state/stateComponent.html','<div class="step" ng-class="{\'finished\': finished, \'active\': active }">\n\t<span class="step-counter" ng-if="!finished">{{step}}</span>\n\t<span class="step-counter" ng-if="finished"><i class="icon-check"></i></span>\n\t<p>{{stepName}}</p>\n</div>\n\n');
$templateCache.put('components/statutory-parental-pay-not-eligible/statutory-parental-pay-not-eligible.component.html','<div class="form-state-section" ng-switch="$ctrl.payStatus">\n\t<div class="form-state-section-textblock">\n\t\t<p class="s">\n\t\t\tIt looks like {{$ctrl.forename}} doesn\'t meet the eligibility criteria for\n\t\t\tStatutory {{$ctrl.payTypeLabel}} Pay.\n\t\t</p>\n\t\t<p class="s" pc-switch-when="[$ctrl.STAT_PAYMENT_SCHEDULE_STATES.earningsInsufficient, $ctrl.STAT_PAYMENT_SCHEDULE_STATES.earningsPartiallyInsufficient]">\n\t\t\t{{$ctrl.forename}} needs to have earned an average of {{$ctrl.payErrors.AverageWeeklyEarningsMin | monetise}} per week to meet the eligibility criteria.\n\t\t</p>\n\t\t<div ng-switch-default>\n\t\t\t<p class="s">\n\t\t\t\t{{$ctrl.forename}} needs to have been in continuous employment between {{$ctrl.payErrors.StartDateMaxISO | dateformat}} until\n\t\t\t\t{{$ctrl.payErrors.LeaveDateMinISO | dateformat}} to meet the statutory continuous employment criteria. Their employment dates are\n\t\t\t\t{{$ctrl.eligibilityDateMinIso | dateformat}} until {{$ctrl.endDateIso | dateformat : \'now\'}}.\n\t\t\t</p>\n\t\t\t<p class="s" ng-if="$ctrl.isMaternity">\n\t\t\t\tIf you believe that {{$ctrl.forename}} is eligible for Statutory Maternity Pay, you may wish to review the start date or continuous employment date in the\n\t\t\t\tInformation area of their profile.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n\n<div class="form-state-section" ng-if="$ctrl.payStatus !== $ctrl.STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient">\n\t<table class="primary payments-table" ng-if="$ctrl.salaryPayments.length">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Pay date</th>\n\t\t\t\t<th>Payment</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat="payment in $ctrl.salaryPayments track by $index">\n\t\t\t\t<td>{{payment.PaymentDateISO | dateformat}}</td>\n\t\t\t\t<td>{{payment.PaymentAmount | monetise}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\n<div class="form-state-section">\n\t<div class="form-state-section-textblock">\n\t\t<h6>What happens now?</h6>\n\t\t<p class="s">\n\t\t\tYou need to let {{$ctrl.forename}} know within 7 days that they are not eligible for Statutory {{$ctrl.payTypeLabel}}\n\t\t\tPay and the reason that they are not eligible. You also need to give them a\n\t\t\tcompleted <a class="underline" data-cy="statutory-pay-not-eligible-form-link" href="" ng-href="{{$ctrl.formUrl}}" target="_blank">{{$ctrl.formName}}</a> so that they can\n\t\t\tmake a claim for {{$ctrl.allowanceLabel}}.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tYou may decide to pay {{$ctrl.forename}} even though they don\'t qualify.\n\t\t\t<span ng-if="$ctrl.isMaternity">In which case, don\'t issue them with an SMP1 form.</span>\n\t\t\tInstead you can pay {{$ctrl.forename}} a voluntary payment for the whole of or any part of their {{$ctrl.parentalType}} absence.\n\t\t\tThis is entirely at your discretion. This is a voluntary employer payment and is classed as occupational {{$ctrl.parentalType}} pay. Unlike Statutory {{$ctrl.payTypeLabel}} Pay,\n\t\t\tvoluntary payments cannot be claimed back from HMRC.\n\t\t</p>\n\t</div>\n</div>\n\n<div class="form-state-section has-border-top" ng-if="$ctrl.isPoliciesApplicable">\n\t<div class="form-state-section-textblock">\n\t\t<h5>Need to add occupational {{$ctrl.parentalType}} pay?</h5>\n\t\t<p class="s">\n\t\t\tYou can select a {{$ctrl.parentalType}} policy to use in the next step if you still wish to make occupational payments to {{$ctrl.forename}} even\n\t\t\tthough they won&rsquo;t receive any statutory payments.\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/submission-logs/submission-logs.component.html','<div class="submission-logs" ng-switch="$ctrl.componentState">\n\n\t<!-- Loading -->\n\t<div class="centered-contents fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.loading">\n\t\t<circle-loader size="\'m\'"></circle-loader>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.COMPONENT_STATES.ready">\n\n\t\t<!-- Logs -->\n\t\t<form class="submission-logs_container no-margin" ng-submit="$ctrl.onResetPeriodSubmit($ctrl)">\n\t\t\t<div class="submission-logs_header">\n\n\t\t\t\t<div class="submission-logs_detail" ng-if="$ctrl.submissionLogEntries.length > 0">\n\t\t\t\t\t<h5 class="submission-logs_heading">Submission error {{$ctrl.logIndex+1}} of {{$ctrl.submissionLogEntries.length}}</h5>\n\t\t\t\t\t<p class="submission-logs_meta">\n\t\t\t\t\t\tSubmitted by {{$ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLog.SubmissionLogActor}}\n\t\t\t\t\t\tat {{$ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLog.SubmissionLogDateISO | datetimeformat:\'detailed\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="submission-logs_detail" ng-if="$ctrl.submissionLogEntries.length === 0">\n\t\t\t\t\t<h5 class="submission-logs_heading">All submission errors dismissed</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="submission-logs_control" ng-if="$ctrl.submissionLogEntries.length > 1">\n\t\t\t\t\t<carousel-input current-index="$ctrl.logIndex" max-index="$ctrl.submissionLogEntries.length" on-index-change="$ctrl.onLogIndexChange($ctrl)" show-detail="false" theme="\'is-primary\'"></carousel-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="submission-logs_content" ng-if="$ctrl.submissionLogEntries.length > 0">\n\t\t\t\t<h6 class="submission-logs_subheading">{{$ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLog.SubmissionLogType | submissionLogTypeLabel}}</h6>\n\t\t\t\t<p class="submission-logs_paragraph">\n\t\t\t\t\t{{$ctrl.submissionLogEntries[$ctrl.logIndex].SubmissionLogEntryMessageText}}\n\t\t\t\t</p>\n\n\t\t\t\t<copilot-button ng-if="$ctrl.submissionLogEntries[$ctrl.logIndex].copilotState !== $ctrl.COPILOT_REQUEST_STATES.completed && $ctrl.isCopilotTranslationEnabled " is-loading="$ctrl.submissionLogEntries[$ctrl.logIndex].copilotState === $ctrl.COPILOT_REQUEST_STATES.loading" button-text="\'Translate this error into readable format\'" on-button-click="$ctrl.getCopilotErrorTranslation($ctrl.submissionLogEntries[$ctrl.logIndex])">\n\t\t\t\t</copilot-button>\n\n\t\t\t<copilot-response-card copilot-feature-context="{{$ctrl.COPILOT_FEATURES.payrollErrorTranslation}}" ng-if="$ctrl.submissionLogEntries[$ctrl.logIndex].copilotState === $ctrl.COPILOT_REQUEST_STATES.completed && !$ctrl.isCopilotError" on-feedback-click="$ctrl.handleErrorTranslationFeedback(copilotFeature, feedbackType, onSubmitComplete, $ctrl.submissionLogEntries[$ctrl.logIndex])" response="$ctrl.submissionLogEntries[$ctrl.logIndex].translationResponse" title="Translation" is-feedback-required="$ctrl.submissionLogEntries[$ctrl.logIndex].feedbackNotRequired">\n\t\t\t\t\t<cp-content>\n\t\t\t\t\t\t<article>\n\t\t\t\t\t\t\t<div ng-repeat="section in $ctrl.submissionLogEntries[$ctrl.logIndex].translationResponse.Sections">\n\t\t\t\t\t\t\t\t<h6 ng-if="section.title && (section.show === true || section.show === undefined)">{{section.title}}</h6>\n\t\t\t\t\t\t\t\t<p class="is-small" ng-if="section.content && (section.show === true || section.show === undefined)">{{section.content}}</p>\n\t\t\t\t\t\t\t\t<bullet-list ng-if="section.items && section.items.length > 0" bl-items="section.items" bl-theme="is-small is-indifferent"></bullet-list>\n\t\t\t\t\t\t\t\t<bullet-list ng-if="section.steps && section.steps.length > 0" bl-items="section.steps" bl-theme="is-small is-indifferent"></bullet-list>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="copilot-response-card_footer is-small" ng-if="$ctrl.response.Footer">{{$ctrl.response.Footer}}</p>\n\t\t\t\t\t\t</article>\n\t\t\t\t\t</cp-content>\n\t\t\t\t</copilot-response-card>\n\n\t\t\t<copilot-response-card copilot-feature-context="{{$ctrl.COPILOT_FEATURES.payrollErrorTranslation}}" is-error="true" ng-if="$ctrl.submissionLogEntries[$ctrl.logIndex].copilotState === $ctrl.COPILOT_REQUEST_STATES.completed && $ctrl.isCopilotError" on-reload-click="$ctrl.getCopilotErrorTranslation($ctrl.submissionLogEntries[$ctrl.logIndex])" title="Translation"></copilot-response-card>\n\t\t\t</div>\n\n\t\t\t<div class="submission-logs_content" ng-if="$ctrl.submissionLogEntries.length === 0">\n\t\t\t\t<p class="submission-logs_paragraph primary-light align-center" ng-transclude="submissionLogsDismissedCopy"></p>\n\t\t\t</div>\n\n\t\t\t<div class="submission-logs_footer">\n\t\t\t\t<div ng-switch="$ctrl.submissionLogEntries[$ctrl.logIndex].dismissState">\n\n\t\t\t\t\t<a class="submission-logs_action primary-light fadeIn" href="" ng-click="$ctrl.setCurrentLogEntryDismissState($ctrl, $ctrl.SUBMISSION_DISMISS_STATES.confirm)" ng-if="$ctrl.submissionLogEntries.length > 0" ng-switch-default>\n\t\t\t\t\t\t<i class="icon-trash n"></i> Dismiss error\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<div class="submission-logs_confirm fadeIn" pc-switch-when="$ctrl.SUBMISSION_DISMISS_STATES.confirm">\n\t\t\t\t\t\t<p class="submission-logs_confirm-copy dropIn">\n\t\t\t\t\t\t\t<i class="icon-trash n primary"></i> Are you sure?&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.updateSubmissionLogEntryDismissed($ctrl)">Yes</a>&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.setCurrentLogEntryDismissState($ctrl, null)">No</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.SUBMISSION_DISMISS_STATES.loading">\n\t\t\t\t\t\t<circle-loader size="\'s\'"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<submit-button button-theme="\'primary\'" display-text="\'Reset payroll\'" icon-position="left" icon="icon-loading" ng-if="$ctrl.onResetPeriod" state="$ctrl.resetState"></submit-button>\n\t\t\t</div>\n\t\t</form>\n\n\t\t<!-- Reports -->\n\t\t<div class="submission-logs_files">\n\t\t\t<div class="submission-logs_files-header">\n\t\t\t\t<h6><ng-pluralize count="$ctrl.submissionFiles.length" when="{\'1\': \'Submission file\', \'other\': \'Submission files\'}"></ng-pluralize></h6>\n\t\t\t</div>\n\n\t\t\t<div class="report-download-card_wrapper rows has-small-gap" ng-if="$ctrl.submissionFiles.length > 0">\n\t\t\t\t<report-download-card agency-profile-id="$ctrl.agencyProfileId" ng-repeat="report in $ctrl.submissionFiles | orderBy: [\'-CanDownload\', \'DisplayName\'] " pay-period="$ctrl.payPeriod" report="report" supplementary-payment-id="$ctrl.supplementaryPaymentId"></report-download-card>\n\t\t\t</div>\n\n\t\t\t<div ng-if="$ctrl.submissionFiles.length <= 0">\n\t\t\t\t<note note-icon="icon-warning" note-theme="is-tertiary" note-title="Reports unavailable">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tOne or more submission files aren\'t available for download, so you may need to check\n\t\t\t\t\t\t\tthat they\'ve been included in the report packs used with {{::$root.currentCompany.Name}}.\n\t\t\t\t\t\t\tSubmission files can be useful in helping you diagnose any submission errors.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Error -->\n\t<div pc-switch-when="$ctrl.COMPONENT_STATES.error">\n\t\t<error-block></error-block>\n\t</div>\n</div>\n');
$templateCache.put('components/submit-button/submitButton.html','<button data-cy="{{buttonId}}" data-page-state="{{pageState}}" id="{{buttonId}}" ng-class="{\n\t\t\'success\': state === \'saved\',\n\t\t[buttonTheme]: state !== \'saved\',\n\t\t\'primary-action\': isPrimaryAction\n\t}" ng-disabled="disableButton || state === \'saving\'" type="submit">\n\t<span ng-show="state !== \'saving\' && state !== \'saved\'"><i ng-class="icon" ng-if="icon && iconPosition === \'left\'"></i> {{displayText}} <i ng-class="icon" ng-if="icon && iconPosition === \'right\'"></i></span>\n\t<span ng-show="state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t<span ng-show="state === \'saved\'"><i class="icon-tick"></i></span>\n</button>\n');
$templateCache.put('components/summary-action-card/summary-action-card.component.html','<div class="summary-action-card {{$ctrl.adjustment.adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}}">\n\n\t<!-- Icon -->\n\t<div class="badge is-primary is-small summary-action-card_badge">\n\t\t<i class="icon-clock"></i>\n\t</div>\n\n\t<!-- Info -->\n\t<div class="summary-action-card_info">\n\t\t<p class="summary-action-card_title">{{$ctrl.summaryCardTitle}}</p>\n\t\t<p class="summary-action-card_description">{{$ctrl.summaryCardDescription}}</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="summary-action-card_actions" ng-if="$ctrl.canEdit">\n\t\t<a href="" class="summary-action-card_action" ng-click="$ctrl.onEdit()" aria-label="Edit"><i class="icon-edit"></i></a>\n\t</div>\n</div>\n');
$templateCache.put('components/supplementary-payment-card/supplementary-payment-card.component.html','<div class="supplementary-payment-card" ng-class="[$ctrl.payment.theme]" ng-mouseleave="$ctrl.hideMenus($ctrl.payment)" ng-switch="$ctrl.payment.SupplementaryPaymentState">\n\n\t<div class="supplementary-payment-card_details">\n\n\t\t<div class="supplementary-payment-card_header">\n\t\t\t<div class="supplementary-payment-card_badge">\n\t\t\t\t<icon-dot icon="icon-clock" theme="{{$ctrl.payment.theme}}"></icon-dot>\n\t\t\t</div>\n\t\t\t<a class="supplementary-payment-card_heading" ui-sref="payroll.supplementary-pay-run.reports({\n\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId,\n\t\t\t\t\tpayPeriodId: $ctrl.payment.AgencyPayPeriodID,\n\t\t\t\t\tsupplementaryPaymentId: $ctrl.payment.SupplementaryPaymentID\n\t\t\t\t})">\n\t\t\t\t<truncate text="$ctrl.payment.SupplementaryPaymentTitle" truncate-amount="90"></truncate>\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="supplementary-payment-card_state">\n\t\t\t<p class="supplementary-payment-card_meta" pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t\tSubmitted by {{$ctrl.payment.SupplementaryPaymentActionerName}} at {{$ctrl.payment.SupplementaryPaymentLastUpdatedDateISO | datetimeformat:\'detailed\'}}\n\t\t\t</p>\n\t\t\t<p class="supplementary-payment-card_meta" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\t\t\t\tSubmission failed\n\t\t\t</p>\n\t\t\t<p class="supplementary-payment-card_meta" ng-switch-default>\n\t\t\t\tCurrently in progress...\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<div class="supplementary-payment-card_info">\n\t\t<div class="supplementary-payment-card_info-item" ng-if="$ctrl.payment.SupplementaryPaymentIsExcludedFromRTI">\n\t\t\t<span class="tag secondary inverse">Omitted from RTI</span>\n\t\t</div>\n\n\t\t<div class="supplementary-payment-card_info-item">\n\t\t\t<span class="supplementary-payment-card_count">\n\t\t\t\t<i class="icon-team-alt l"></i>\n\t\t\t\t{{$ctrl.payment.SupplementaryPaymentCount}}\n\t\t\t</span>\n\t\t</div>\n\n\t\t<div class="supplementary-payment-card_info-item">\n\t\t\t<p class="supplementary-payment-card_value">\n\t\t\t\t{{$ctrl.payment.SupplementaryPaymentPayDateISO | dateformat}}\n\t\t\t</p>\n\t\t\t<p class="supplementary-payment-card_label">\n\t\t\t\tPayment date\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<dropdown-menu class="supplementary-payment-card_action-menu" data-cy="supplementary-payment-card_action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="$ctrl.payment.showMenu" menu-size="xl" menu-theme="{{$ctrl.payment.theme}}" ng-if="!$root.userHasRole([\n\t\t\t\'companyadministratorlite\',\n\t\t\t\'groupadminlite\'\n\t\t])">\n\t\t<!-- Edit -->\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" data-cy="supplementary-payment-card-action-cog-history-supplementary-pay-run-continue" ng-click="$ctrl.editSupplementaryPayment($ctrl.payment)" ng-if="$ctrl.payment.canEdit && $root.currentUser.Permissions.Payroll.canRunPayroll">\n\t\t\t\tContinue\n\t\t\t</a>\n\t\t\t<a ui-sref="payroll.supplementary-pay-run.reports({\n\t\t\t\t\tagencyProfileId: $ctrl.agencyProfileId,\n\t\t\t\t\tpayPeriodId: $ctrl.payment.AgencyPayPeriodID,\n\t\t\t\t\tsupplementaryPaymentId: $ctrl.payment.SupplementaryPaymentID\n\t\t\t\t})">\n\t\t\t\tView pay run\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Reports -->\n\t\t<div class="dropdown-group" ng-if="$ctrl.payment.SupplementaryPaymentState === $ctrl.SUBMISSION_STATES.submitted">\n\t\t\t<a href="" ng-click="$ctrl.editSupplementaryPayment($ctrl.payment, true)">\n\t\t\t\tDownload reports\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Delete -->\n\t\t<div class="dropdown-group" ng-if="$ctrl.payment.CanDelete && $root.currentUser.Permissions.Payroll.canRunPayroll">\n\t\t\t<a class="is-assertive" href="" data-cy="supplementary-payment-card-action-cog-history-supplementary-pay-run-delete" ng-click="$ctrl.openDeleteSupplementaryPaymentForm($ctrl.payment)" ng-switch="$ctrl.payment.deleteState">\n\t\t\t\tDelete\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n\n</div>\n');
$templateCache.put('components/support-article/support-article.component.html','<article class="support-article" ng-class="{\n\t\t\'is-inline\' : $ctrl.isInline\n\t}">\n\t<!-- Header -->\n\t<div class="support-article_header">\n\t\t<div class="support-article_header-title">\n\t\t\t<h2 class="support-article_header-name" ng-bind-html="$ctrl.articleTitle">\n\t\t\t</h2>\n\t\t\t<!-- External link -->\n\t\t\t<a aria-label="Open full page" class="support-article_header-external-link" href="" ng-click="$ctrl.openFullPage($ctrl)" ng-if="$ctrl.isInline && $ctrl.showLinkToFullPage">\n\t\t\t\t<i class="icon-external-link primary m"></i>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="support-article_header-meta-tags">\n\t\t\t<meta-tags meta-tags="$ctrl.metaTags"></meta-tags>\n\t\t</div>\n\t</div>\n\n\t<!-- Video -->\n\t<div class="support-article_video-container" ng-if="$ctrl.articleHasVideo">\n\t\t<iframe allowfullscreen class="support-article_video" frameborder="0" src="{{$ctrl.articleVideoSrc}}"></iframe>\n\t</div>\n\n\t<!-- Article -->\n\t<div class="support-article_main">\n\t\t<support-article-content article-content="$ctrl.articleContent" article-key="$ctrl.articleKey"></support-article-content>\n\t</div>\n\n</article>\n');
$templateCache.put('components/support-article-card/support-article-card.component.html','<a class="support-article-card {{$ctrl.viewMode}}" href="" ng-click="$ctrl.onClick($ctrl)">\n\t<div class="support-article-card_image-container" ng-class="{\n\t\t\t\'is-video-thumbnail\' : $ctrl.hasVideo\n\t\t}">\n\t\t<img alt="" class="support-article-card_image" ng-src="{{$ctrl.supportArticle.supportArticleThumbnailUrl}}">\n\t</div>\n\t<div class="support-article-card_summary">\n\t\t<div class="support-article-card_title">\n\t\t\t<span ng-bind-html="$ctrl.supportArticle.title"></span>\n\t\t</div>\n\t\t<div class="support-article-card_excerpt" ng-bind-html="$ctrl.supportArticle.content"></div>\n\t\t<meta-tags meta-tags="$ctrl.metaTags" show-if-empty="true"></meta-tags>\n\t</div>\n</a>\n');
$templateCache.put('components/support-article-content/support-article-content.component.html','<article ng-transclude></article>\n');
$templateCache.put('components/support-article-image/support-article-image.component.html','<div class="support-article-image">\n\t<img alt="" class="support-article-image_image" ng-mouseout="$ctrl.onImageMouseOut($ctrl)" ng-mouseover="$ctrl.onImageMouseOver($ctrl)" src="{{$ctrl.articleImageSrc}}">\n\t<button class="is-clear support-article-image_focus-image" ng-class="{ \'fadeIn is-visible\': $ctrl.showImageFocusButton }" ng-click="$ctrl.showImageFocus($ctrl)" ng-mouseover="$ctrl.onImageMouseOver($ctrl)">\n\t\t<i class="icon-full-screen m"></i>\n\t</button>\n\t<!-- Image caption needed removing for some unknown reason. Keeping this here because it\'s a good thing and might be reinstated at some point -->\n\t<!-- <div class="support-article-image_caption" ng-if="$ctrl.articleImageAlt">{{$ctrl.articleImageAlt}}</div> -->\n</div>\n');
$templateCache.put('components/support-article-link/support-article-link.component.html','<a class="{{$ctrl.theme}}" href="" ng-class="{\n\t\t\'underline\': $ctrl.underline\n\t}" ng-click="$ctrl.openSupportArticle($ctrl.articleKey)" ng-transclude></a>');
$templateCache.put('components/support-categories/support-categories.component.html','<div class="support-categories">\n\n\t<!-- Breadcrumb. Only applicable when there\'s more than one item; i.e. don\'t show at the top Help and Support level -->\n\t<div class="support-categories_breadcrumb" ng-if="$ctrl.breadcrumb.length > 1">\n\t\t<div class="support-categories_breadcrumb-item" ng-repeat="category in $ctrl.breadcrumb">\n\t\t\t<a class="underline" href="" ng-click="$ctrl.changeCategory(category.id, $ctrl)" ng-if="!$last">\n\t\t\t\t{{category.name}}\n\t\t\t</a>\n\t\t\t<span ng-if="$last">{{category.name}}</span>\n\t\t\t<div class="support-categories_breadcrumb-separator" ng-if="!$last">\n\t\t\t\t<icon class="icon-chevron-right"></icon>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Help and support categories -->\n\t<div class="support-category-cards" ng-if="$ctrl.filteredCategories.length > 0">\n\t\t<support-category-card categories="$ctrl.categories" category="category" layout="$ctrl.layout" ng-repeat="category in $ctrl.filteredCategories" on-category-click="$ctrl.onCategoryClick($ctrl, category)"></support-category-card>\n\t</div>\n\t<!-- Latest articles (when at top category level) or articles for current category (when category selected -->\n\t<loading-block ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.articlesLoading"></loading-block>\n\t<div ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.ready">\n\t\t<div ng-if="$ctrl.supportArticles.length > 0">\n\t\t\t<div class="support-categories_heading" ng-if="$ctrl.categoryId === 0">\n\t\t\t\tLatest support articles\n\t\t\t</div>\n\t\t\t<div class="support-categories_heading" ng-if="$ctrl.categoryId !== 0">\n\t\t\t\t{{$ctrl.currentCategoryName}} articles\n\t\t\t</div>\n\t\t\t<div class="support-article-cards">\n\t\t\t\t<support-article-card ng-repeat="supportArticle in $ctrl.supportArticles" on-click="$ctrl.onArticleClick($ctrl, supportArticle)" support-article="supportArticle"></support-article-card>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- No articles or categories -->\n\t\t<empty-search ng-if="\n\t\t\t\t$ctrl.supportArticles.length === 0 &&\n\t\t\t\t$ctrl.filteredCategories.length === 0\n\t\t\t">\n\t\t\t<a class="action fadeIn" href="" ng-click="$ctrl.goHome($ctrl)">\n\t\t\t\tBack to Help and Support\n\t\t\t</a>\n\t\t</empty-search>\n\t</div>\n\n</div>');
$templateCache.put('components/support-category-card/support-category-card.component.html','<a class="support-category-card is-primary fadeIn" href="" ng-class="{ \'is-headline\' : $ctrl.isHeadline }" ng-click="$ctrl.onClick($ctrl, $ctrl.category)">\n\t<!-- Show image for headline categories -->\n\t<div class="support-category-card_headline-image" ng-if="$ctrl.isHeadline">\n\t\t<img alt="" src="{{$ctrl.headlineImageSrc}}">\n\t</div>\n\n\t<!-- Show icon for categories that aren\'t headline -->\n\t<div class="badge support-category-card_icon" ng-class="$ctrl.category.theme" ng-if="!$ctrl.isHeadline">\n\t\t<i class="l" ng-class="$ctrl.category.icon"></i>\n\t</div>\n\n\t<h5 class="support-category-card_title" ng-bind-html="$ctrl.category.name"></h5>\n\t<div class="support-category-card_description" ng-bind-html="$ctrl.category.description"></div>\n\t<div class="support-category-card_article-count">\n\t\t<i class="icon-right primary m"></i>\n\t\t<span class="primary m stronger" ng-if="$ctrl.category.articleCount !== 0">\n\t\t\t&nbsp;{{$ctrl.category.articleCount}}&nbsp;{{$ctrl.itemDescription}}\n\t\t</span>\n\t</div>\n</a>\n');
$templateCache.put('components/support-guide-card/support-guide-card.component.html','<div class="support-guide-card" ng-click="$ctrl.onClick($ctrl)">\n\t<div class="support-guide-card_summary">\n\n\t\t<div class="support-guide-card_header">\n\t\t\t<span class="badge support-guide-card_header-badge" ng-class="$ctrl.supportGuide.theme">\n\t\t\t\t<i class="l" ng-class="$ctrl.supportGuide.icon"></i>\n\t\t\t</span>\n\t\t\t<span class="support-guide-card_header-title" ng-bind-html="$ctrl.supportGuide.title"></span>\n\t\t</div>\n\n\t\t<div class="support-guide-card_sections">\n\t\t\t<div class="support-guide-card_section" ng-repeat="supportGuideSection in $ctrl.supportGuide.supportGuideSections">\n\t\t\t\t<div class="support-guide-card_section-number">{{$index + 1}}</div>\n\t\t\t\t<div class="support-guide-card_section-title">{{supportGuideSection.title}}</div>\n\t\t\t\t<div class="support-guide-card_section-status">\n\t\t\t\t\t<i class="m icon-tick"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="support-guide-card_tags">\n\t\t\t<meta-tags meta-tags="$ctrl.metaTags" show-if-empty="true"></meta-tags>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('components/switch-account-card/switch-account-card.component.html','<div class="account-card" ng-class="{\'is-clickable\': $ctrl.isClickable}">\n\t<a class="account-card_clickable-overlay" href="" ng-click="$ctrl.onClickInternal()" ng-if="$ctrl.isClickable">\n\t</a>\n\n\t<div class="account-card_main">\n\t\t<div class="account-card_info">\n\t\t\t<p class="is-strong is-font-primary-400">\n\t\t\t\t{{$ctrl.account.AccountDetails.Name}}\n\t\t\t</p>\n\t\t\t<p class="is-small">\n\t\t\t\t{{$ctrl.account.AccountDetails.AgencyProfileName}}\n\t\t\t</p>\n\t\t</div>\n\t\n\t\t<span class="tag l quarternary">{{$ctrl.account.AccountDetails.RoleType | roleTypeMeta:\'name\'}}</span>\n\n\t</div>\n\t<div class="account-card_action-icon" ng-if="$ctrl.isClickable">\n\t\t<i class="icon-right is-large is-primary"></i>\n\t</div>\n</div>\n');
$templateCache.put('components/switch-account-item/switch-account-item.component.html','<div class="switch-account-item">\n\t<div class="switch-account-item_info">\n\t\t<p class="is-small is-strong is-font-primary-400">{{$ctrl.account.AccountDetails.Name}}</p>\n\t\t<p class="is-small is-font-greyscale-300">\t\t\t\t\n\t\t\t<truncate id="agency-profile-name" text="$ctrl.account.AccountDetails.AgencyProfileName" truncate-amount="30">\n\t\t\t</truncate>\n\t\t</p>\n\t</div>\n\t<span class="tag l quarternary">{{$ctrl.account.AccountDetails.RoleType | roleTypeMeta:\'name\'}}</span>\n</div>');
$templateCache.put('components/tab-bar/tab-bar.component.html','<nav class="tab-bar" id="{{$ctrl.tabBarDef.id}}" ng-class="{\'is-centered\' : $ctrl.isCentered, \'is-open\' : $ctrl.isOpen}" tabindex="-1">\n\t<div class="tab-bar_container">\n\t\t<!-- This is the selected tab (mobile mode only, the tab is repeated in the tab list for selection, this one is to show the selected,\n\t\t\tand is clickable to open the list, so it behaves like a real select box, and also doesn\'t disrupt the list of options for\n\t\t\taccessibility purposes. Previously the selected tab was positioned absolutely at the top and thus effectively removed from the\n\t\t\tlist, spagging up tab order). -->\n\t\t<a class="tab-bar_tab is-current-tab" href="" id="tab-bar-mobile-current-tab" ng-click="$ctrl.isOpen = !$ctrl.isOpen" ng-if="$ctrl.mobileView">\n\t\t\t{{$ctrl.currentTab.label}}\n\t\t</a>\n\n\t\t<!-- This tab has an sref. It\'s not a simple case of using something like attr-ui-sref="{{ tab.sref || undefined }}" to avoid repetition here,\n\t\t\t since that causes an error in the console. Apparently a known bug https://github.com/angular-ui/ui-router/issues/2090.\n\t\t\t Note that the ng-style here is necessary (as opposed to a more conventional, conditional ng-class) as the margin forms\n\t\t\t part of the layout calculation and needs to be set in js code. -->\n\t\t<a class="tab-bar_tab" data-cy="{{tab.id}}" id="{{tab.id}}" ng-click="$ctrl.tabSelected($ctrl, tab)" ng-if="tab.sref" ng-repeat="tab in $ctrl.visibleTabs" ng-style="{\n\t\t\t\t\'margin-left\': ($first || $ctrl.mobileView) ? 0 : $ctrl.TAB_MARGIN + \'px\'\n\t\t\t}" ui-sref-active="active" ui-sref="{{ tab.sref }}">\n\t\t\t{{tab.label}}\n\t\t\t<tab-bar-counter count="$ctrl.tabBarCounts[tab.id].count" is-current="$ctrl.currentTab.id === tab.id" ng-if="tab.hasCount" theme="$ctrl.tabBarCounts[tab.id].theme"></tab-bar-counter>\n\t\t</a>\n\t\t<!-- This tab doesn\'t have an sref. It\'ll probably invoke a function in the parent controller based on onTabSelected attribute. Its active state\n\t\t\t is determined by the current tab as set in the controller.\n\t\t\t Note that the ng-style here is necessary (as opposed to a more conventional, conditional ng-class) as the margin forms\n\t\t\t part of the layout calculation and needs to be set in js code. -->\n\t\t<a class="tab-bar_tab" data-cy="{{tab.id}}" href="" id="{{tab.id}}" ng-class="{\n\t\t\t\t\'active\': $ctrl.currentTab.id === tab.id\n\t\t\t}" ng-click="$ctrl.tabSelected($ctrl, tab)" ng-if="!tab.sref" ng-repeat="tab in $ctrl.visibleTabs" ng-style="{\n\t\t\t\t\'margin-left\': ($first || $ctrl.mobileView) ? 0 : $ctrl.TAB_MARGIN + \'px\'\n\t\t\t}">\n\t\t\t{{tab.label}}\n\t\t\t<tab-bar-counter count="$ctrl.tabBarCounts[tab.id].count" is-current="$ctrl.currentTab.id === tab.id" ng-if="tab.hasCount" theme="$ctrl.tabBarCounts[tab.id].theme"></tab-bar-counter>\n\t\t</a>\n\t\t<a aria-label="Toggle overflow" class="tab-bar_overflow-toggle" href="" ng-click="$ctrl.toggleOverflow($ctrl)" ng-if="$ctrl.hasOverflow">\n\t\t\t<i class="icon-ellipses m"></i>\n\t\t</a>\n\t\t<div class="tab-bar_overflow fadeIn" click-anywhere-but-here="$ctrl.hideOverflow($ctrl)" ng-class="{\'is-visible\': $ctrl.showOverflow }">\n\t\t\t<div class="tab-bar_overflow-content">\n\t\t\t\t<!-- Same again for overflow tabs, see comments above -->\n\t\t\t\t<a class="tab-bar_overflow-tab" data-cy="{{tab.id}}" id="{{tab.id}}" ng-click="$ctrl.overflowTabSelected($ctrl, tab)" ng-if="tab.sref" ng-repeat="tab in $ctrl.overflowTabs" ui-sref-active="active" ui-sref="{{tab.sref}}">\n\t\t\t\t\t{{tab.label}}\n\t\t\t\t\t<tab-bar-counter count="$ctrl.tabBarCounts[tab.id].count" is-current="$ctrl.currentTab.id === tab.id" ng-if="tab.hasCount" theme="$ctrl.tabBarCounts[tab.id].theme"></tab-bar-counter>\n\t\t\t\t</a>\n\t\t\t\t<a class="tab-bar_overflow-tab" data-cy="{{tab.id}}" href="" id="{{tab.id}}" ng-class="{ \'active\': $ctrl.currentTab.id === tab.id }" ng-click="$ctrl.overflowTabSelected($ctrl, tab)" ng-if="!tab.sref" ng-repeat="tab in $ctrl.overflowTabs">\n\t\t\t\t\t{{tab.label}}\n\t\t\t\t\t<tab-bar-counter count="$ctrl.tabBarCounts[tab.id].count" is-current="$ctrl.currentTab.id === tab.id" ng-if="tab.hasCount" theme="$ctrl.tabBarCounts[tab.id].theme"></tab-bar-counter>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</nav>\n');
$templateCache.put('components/task-card/task-card.component.html','<div class="task-card" data-cy="{{::$ctrl.taskId}}" ng-class="$ctrl.taskTheme">\n\t<div class="task-card_layout">\n\t\t<div class="task-card_icon" ng-if="$ctrl.hasIcon">\n\t\t\t<i class="icon-{{$ctrl.taskIcon}}"></i>\n\t\t</div>\n\n\t\t<div class="task-card_content">\n\t\t\t<h6 class="task-card_title" ng-transclude="title"></h6>\n\t\t\t<p class="task-card_description" ng-transclude="description"></p>\n\t\t</div>\n\n\t\t<div class="task-card_actions">\n\t\t\t<div ng-transclude="action"></div>\n\t\t</div>\n\t</div>\n\n\t<div class="task-card_footer" ng-transclude="footer" ng-if="$ctrl.hasFooter"></div>\n</div>\n');
$templateCache.put('components/task-item/taskItemComponent.html','<div class="task-item">\n\t<div class="task-item__check" ng-class="{\'task-item__check--complete\' : tiIsComplete}">\n\t\t<i class="icon-check" ng-if="tiIsComplete"></i>\n\t</div>\n\t<div class="task-item__content" ng-class="{\'task-item__content--required\' : tiRequired}">\n\t\t<p>\n\t\t\t{{tiText}}<span class="asterix" ng-if="tiRequired">*</span>\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/tax-info-form-fields/tax-info-form-fields.component.html','<div class="tax-info-form-fields">\n\t<!-- Tax Code Number / Letter -->\n\t<div class="form-field">\n\t\t<label ng-class="{ \'required\' : $ctrl.required }" for="taxcodenumber">Tax Code:</label>\n\t\t<div class="field">\n\t\t\t<div class="tax-code">\n\t\t\t\t<input id="taxcodenumber" maxlength="{{$root.CONFIG.taxCodeNumberMaxLength}}" name="taxcodenumber" ng-change="$ctrl.updateTaxCode($ctrl.taxInfo)" ng-disabled="$ctrl.TAX_CODES_FIXED.indexOf($ctrl.taxInfo.taxCodeLetter) > -1 || $ctrl.isDisabled" ng-model-options="{ debounce: 300 }" ng-model="$ctrl.taxInfo.taxCodeNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="$ctrl.required && $ctrl.TAX_CODES_FIXED.indexOf($ctrl.taxInfo.taxCodeLetter) === -1" placeholder="{{$root.CONFIG.personalAllowanceNumber}}" type="text">&nbsp;&nbsp;\n\t\t\t\t<select id="taxcodeletter" name="taxcodeletter" ng-change="$ctrl.updateTaxCode($ctrl.taxInfo)" ng-disabled="$ctrl.isDisabled" ng-model="$ctrl.taxInfo.taxCodeLetter" ng-options="TAX_CODE as TAX_CODE for TAX_CODE in $ctrl.TAX_CODES | filter: taxCodeFilter" ng-required="$ctrl.required"></select>\n\t\t\t</div>\n\t\t\t<span class="field-info fadeIn">{{$ctrl.taxInfo.TaxCode}}&nbsp;{{$ctrl.taxInfo.TaxCodeM1W1 ? $root.CONFIG.w1m1Label : \'\'}}</span>\n\t\t</div>\n\t\t<div class="form-errors fadeIn" ng-messages="$ctrl.form.taxcodenumber.$error" ng-show="$ctrl.form.taxcodenumber.$touched" role="alert">\n\t\t\t<p ng-message="required">Please enter a Tax Code</p>\n\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Scottish Tax Code (disabled for NT tax code, or if moving payrolls) -->\n\t<div class="form-field">\n\t\t<div class="field">\n\t\t\t<input id="scottishTaxCode" label-text="\'Scottish tax code\'" name="scottishTaxCode" ng-change="$ctrl.updateTaxCode($ctrl.taxInfo)" ng-disabled="$ctrl.taxInfo.taxCodeLetter === \'NT\' || $ctrl.taxInfo.isTaxCodeWelsh  || $ctrl.isDisabled" ng-model="$ctrl.taxInfo.isTaxCodeScottish" type="checkbox" checkbox>\n\t\t</div>\n\t\t<p class="form-message">People that live in Scotland pay the Scottish rate of Income Tax. <a href="{{$root.URLS.gov.scottishIncomeTax}}" target="_blank">Read more</a></p>\n\t</div>\n\n\t<!-- Welsh Tax Code (disabled for NT tax code, or if moving payrolls) -->\n\t<div class="form-field">\n\t\t<div class="field">\n\t\t\t<input id="welshTaxCode" label-text="\'Welsh tax code\'" name="welshTaxCode" ng-change="$ctrl.updateTaxCode($ctrl.taxInfo)" ng-disabled="$ctrl.taxInfo.taxCodeLetter === \'NT\' || $ctrl.taxInfo.isTaxCodeScottish || $ctrl.isDisabled" ng-model="$ctrl.taxInfo.isTaxCodeWelsh" type="checkbox" checkbox>\n\t\t</div>\n\t\t<p class="form-message">People that live in Wales pay the Welsh rate of Income Tax. <a href="{{$root.URLS.gov.welshIncomeTax}}" target="_blank">Read more</a></p>\n\t</div>\n\n\t<!-- W1M1 (disabled if moving payrolls) -->\n\t<div class="form-field">\n\t\t<div class="field">\n\t\t\t<input id="w1m1" label-text="\'Week 1, Month 1\'" name="w1m1" ng-model="$ctrl.taxInfo.TaxCodeM1W1" ng-disabled="$ctrl.isDisabled" type="checkbox" checkbox>\n\t\t</div>\n\t\t<p class="form-message">Week 1, Month 1 means any previous payments in the tax year will not be taken into consideration.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.whatIsW1M1">Read more</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<!-- NI Category (edit when allowNiCategoryEdit set) -->\n\t<div class="form-field" ng-if="$ctrl.allowNiCategoryEdit && $ctrl.showNiCategory">\n\t\t<label for="niCategory" ng-class="{ \'required\' : $ctrl.required }">National Insurance category</label>\n\t\t<div class="field">\n\t\t\t<select class="m" id="niCategory" name="niCategory" ng-disabled="$ctrl.isDisabled" ng-model="$ctrl.taxInfo.NICode" ng-options="niCategoryLetter as niCategoryLetter for niCategoryLetter in $ctrl.niCategoryLetters" ng-required="$ctrl.required"></select>\n\t\t</div>\n\t</div>\n\n\t<!-- NI Category (view when allowNiCategoryEdit not set)-->\n\t<div class="form-field" ng-if="!$ctrl.allowNiCategoryEdit && $ctrl.showNiCategory">\n\t\t<note note-theme="primary">\n\t\t\t<note-content>\n\t\t\t\t<h6>Current NI category</h6>\n\t\t\t\t<p class="primary">\n\t\t\t\t\t<span class="primary-dark l stronger">{{$ctrl.taxInfo.NICode}}</span>\n\t\t\t\t\t<span ng-if="$ctrl.taxInfo.NICodeEffectiveDateISO">&nbsp;(effective {{$ctrl.taxInfo.NICodeEffectiveDateISO | dateformat}})</span>\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n</div>\n');
$templateCache.put('components/tax-info-update-card/tax-info-update-card.component.html','<div class="tax-info-update-card">\n\n\t<div class="tax-info-update-card_main">\n\n\t\t<div class="tax-info-update-card_header">\n\t\t\t<div class="tax-info-update-card_icon">\n\t\t\t\t<icon-dot icon="{{$ctrl.taxUpdate.icon}}" icon-size="is-medium" theme="is-larger {{$ctrl.taxUpdate.iconTheme}}"></icon-dot>\n\t\t\t</div>\n\n\t\t\t<div class="tax-info-update-card_header-title">\n\t\t\t\t<h6 class="tax-info-update-card_title">{{::$ctrl.taxUpdate.title}}</h6>\n\t\t\t\t<p class="tax-info-update-card_label" data-cy="tax-info-update-card-{{::$ctrl.index}}_label">\n\t\t\t\t\t{{::$ctrl.taxUpdate.label}}\n\t\t\t\t</p>\n\t\t\t</div>\t\n\t\t</div>\n\n\t\t<div class="tax-info-update-card_tax-sections">\n\t\t\t<div class="tax-info-update-card_tax-section is-tax-code">\n\t\t\t\t<div class="tax-info-update-card_tax-section-value is-strong" data-cy="tax-info-update-card-{{::$ctrl.index}}_tax-code">\n\t\t\t\t\t{{::$ctrl.taxUpdate.taxCode}}\n\t\t\t\t</div>\n\t\t\t\t<div class="tax-info-update-card_tax-section-name">Tax code</div>\n\t\t\t</div>\n\t\t\t<div class="tax-info-update-card_tax-section">\n\t\t\t\t<div class="tax-info-update-card_tax-section-value is-strong" data-cy="tax-info-update-card-{{::$ctrl.index}}_ni-category">\n\t\t\t\t\t{{::$ctrl.taxUpdate.niCode}}\n\t\t\t\t</div>\n\t\t\t\t<div class="tax-info-update-card_tax-section-name">NI category</div>\n\t\t\t</div>\n\t\t\t<div class="tax-info-update-card_tax-section is-student-loan" ng-class="{ \'is-invisible\': $ctrl.taxUpdate.IsOffPayrollWorker }">\n\t\t\t\t<div class="tax-info-update-card_tax-section-value is-strong" data-cy="tax-info-update-card-{{::$ctrl.index}}_student-loan">\n\t\t\t\t\t{{::$ctrl.taxUpdate.StudentLoan}}\n\t\t\t\t</div>\n\t\t\t\t<div class="tax-info-update-card_tax-section-name">Student loan</div>\n\t\t\t</div>\n\t\t\t<div class="tax-info-update-card_tax-section is-postgraduate-loan" ng-class="{ \'is-invisible\': $ctrl.taxUpdate.IsOffPayrollWorker }">\n\t\t\t\t<div class="tax-info-update-card_tax-section-value is-strong" data-cy="tax-info-update-card-{{::$ctrl.index}}_postgraduate-loan">\n\t\t\t\t\t{{::$ctrl.taxUpdate.PostGraduateLoan}}\n\t\t\t\t</div>\n\t\t\t\t<div class="tax-info-update-card_tax-section-name">Postgraduate loan</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="tax-info-update-card_menu">\n\t\t\t<dropdown-menu menu-id="tax-info-update-card-{{::$ctrl.index}}_cog-menu" menu-icon="icon-setup" menu-size="l" menu-show-chevron="false" menu-theme="{{::$ctrl.theme}}" ng-if="$ctrl.taxUpdate.CanDelete && $root.currentUser.Permissions.Team.canEditTaxStatus">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a data-cy="tax-info-update-card-{{::$ctrl.index}}_edit" ng-click="$ctrl.openEditTaxUpdateForm($ctrl.taxUpdate)" ng-if="$ctrl.taxUpdate.CanUpdateTaxCode || $ctrl.taxUpdate.CanUpdateNICategory || $ctrl.taxUpdate.CanUpdateStudentLoan || $ctrl.taxUpdate.CanUpdatePostGraduateLoan" title="Edit">\n\t\t\t\t\t\tEdit\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="assertive" data-cy="tax-info-update-card-{{::$ctrl.index}}_delete" ng-click="$ctrl.openDeleteTaxUpdateForm($ctrl.taxUpdate)" title="Delete">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<div class="tax-info-update-card_footer" ng-if="$ctrl.taxUpdate.ActionDateISO">\n\t\t{{::$ctrl.taxUpdate.footerText}}\n\t</div>\n</div>\n');
$templateCache.put('components/tax-treatment-list/tax-treatment-list.component.html','<ul class="tax-treatment-list">\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsTaxable }">\n\t\t<div class="tax-treatment-list_item-text">Taxable</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsTaxable ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsNIable }">\n\t\t<div class="tax-treatment-list_item-text">National Insurance</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsNIable ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsNotional }">\n\t\t<div class="tax-treatment-list_item-text">Notional Payment</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsNotional ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsBIK }">\n\t\t<div class="tax-treatment-list_item-text">Benefit in kind</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsBIK ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsSalarySacrifice }">\n\t\t<div class="tax-treatment-list_item-text">Salary sacrifice</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsSalarySacrifice ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.IsPensionable }">\n\t\t<div class="tax-treatment-list_item-text">Pensionable</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.IsPensionable ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.NMWState }">\n\t\t<div class="tax-treatment-list_item-text">National Minimum/Living Wage checks</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.NMWState ? \'YES\' : \'NO\'}}</div>\n\t</li>\n\t<li class="tax-treatment-list_item" ng-class="{ \'tax-treatment-list_item-positive\': $ctrl.adjustmentGroupEntry.NetPayState }">\n\t\t<div class="tax-treatment-list_item-text">Net pay calculation</div>\n\t\t<div class="tax-treatment-list_item-indicator">{{$ctrl.adjustmentGroupEntry.NetPayState ? \'YES\' : \'NO\'}}</div>\n\t</li>\n</ul>');
$templateCache.put('components/tax-update-card/tax-update-card.component.html','<div class="tax-update-card" ng-class="[\n\t\t$ctrl.taxUpdateLogEntry.theme,\n\t\t$ctrl.theme\n\t]">\n\t<div class="tax-update-card_header">\n\t\t<avatar avatar-initial="{{$ctrl.taxUpdateLogEntry.TargetActor[0]}}" avatar-size="is-small" class="tax-update-card_avatar"></avatar>\n\t\t<h6 class="tax-update-card_name">\n\t\t\t{{$ctrl.taxUpdateLogEntry.TargetActor}}\n\t\t</h6>\n\t</div>\n\t<div class="tax-update-card_details" ng-switch="$ctrl.taxUpdateLogEntry.isAutomaticUpdate">\n\t\t<p class="is-small" ng-bind-html="$ctrl.taxUpdateLogEntry.titleHTML"></p>\n\t\t<p class="is-small tax-update-card_updated" ng-switch-when="true">\n\t\t\t<i class="m icon-loading tax-update_icon"></i>\n\t\t\tReceived automatically at {{ $ctrl.taxUpdateLogEntry.LogDateISO | dateformat: \'timeDate\' }}\n\t\t</p>\n\t\t<p class="is-small tax-update-card_updated" ng-switch-when="false">\n\t\t\tUpdated by {{$ctrl.taxUpdateLogEntry.ActionActor}} at {{$ctrl.taxUpdateLogEntry.LogDateISO | dateformat:\'timeDate\'}}\n\t\t</p>\n\t</div>\n</div>\n\n');
$templateCache.put('components/tax-update-confirmation-card/tax-update-confirmation-card.component.html','<div class="tax-update-confirmation-card {{ $ctrl.teamMemberTax.isAccepted ? \'is-secondary\' : \'is-assertive\' }}">\n\n\t<div class="tax-update-confirmation-card_toggle">\n\t\t<toggle-input class="is-secondary" field-label="{{ $ctrl.teamMemberTax.isAccepted ? \'Accept\' : \'Reject\' }}" field-model="$ctrl.teamMemberTax.isAccepted" field-name="rejectToggle{{$ctrl.index}}" field-name="taxUpdateAccept" field-on-change="$ctrl.updateRejectedState($ctrl.teamMemberTax)" field-theme-inactive="is-assertive" field-theme-active="is-secondary" field-label-stay-active="true"></toggle-input>\n\t</div>\n\n\t<div class="tax-update-confirmation-card_info">\n\t\t<div class="tax-update-confirmation-card_user">\n\t\t\t<avatar class="admin-card__avatar" avatar-initial="{{$ctrl.teamMemberTax.FullName[0]}}" avatar-size="is-small"></avatar>\n\t\t\t<p class="strong">&nbsp;&nbsp;{{$ctrl.teamMemberTax.FullName}}</p>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-line">\n\t\t\t<div class="tax-update-confirmation-card_info-line-name">Current:</div>\n\t\t\t<div class="tax-update-confirmation-card_info-line-value">{{$ctrl.teamMemberTax.TaxDetailsFrom}}</div>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-line">\n\t\t\t<div class="tax-update-confirmation-card_info-line-name">New:</div>\n\t\t\t<div class="tax-update-confirmation-card_info-line-value">{{$ctrl.teamMemberTax.TaxDetailsTo}}</div>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-line" ng-if="$ctrl.teamMemberTax.TotalPayPreviousEmploymentTo > -1">\n\t\t\t<div class="tax-update-confirmation-card_info-line-name">Total pay in previous employment - {{$ctrl.teamMemberTax.TotalPayPreviousEmploymentTo | monetise}}</div>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-line" ng-if="$ctrl.teamMemberTax.TotalTaxPreviousEmploymentTo > -1">\n\t\t\t<div class="tax-update-confirmation-card_info-line-name">Total tax paid in previous employment - {{$ctrl.teamMemberTax.TotalTaxPreviousEmploymentTo | monetise}}</div>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-line">\n\t\t\t<div class="tax-update-confirmation-card_info-line-name">Effective Date:</div>\n\t\t\t<div class="tax-update-confirmation-card_info-line-value">{{$ctrl.teamMemberTax.EffectiveDateISO | dateformat:\'numeric\' }}</div>\n\t\t</div>\n\t\t<div class="tax-update-confirmation-card_info-received" ng-if="$ctrl.teamMemberTax.CreatedDateISO"><i class="m icon-loading"></i>&nbsp;Received automatically at {{ $ctrl.teamMemberTax.CreatedDateISO | dateformat: \'timeDate\' }}</div>\n\t\t<div class="form-field tax-update-confirmation-card_rejection-reason" ng-if="!$ctrl.teamMemberTax.isAccepted">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="rejectionReason{{$ctrl.index}}" class="required">Reason for rejection</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="rejectionReason{{$ctrl.index}}" name="rejectionReason{{$ctrl.index}}" ng-model="$ctrl.teamMemberTax.RejectReason" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t<option value="We\'ve been advised by HMRC">We\'ve been advised by HMRC</option>\n\t\t\t\t\t<option value="There is an HMRC misalignment">There is an HMRC misalignment</option>\n\t\t\t\t\t<option value="Other">Other</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="form[\'rejectionReason\' + index].$error" ng-if="form[\'rejectionReason\' + index].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a reason for rejection</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/team-card/teamCard.html','<div class="team-card fadeIn" id="team-card-{{index}}" ng-class="{\'is-selected\' : teamMember.isSelected}">\n\t<header class="team-card_header has-checkbox">\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="checkbox-input primary-alt team-card_checkbox">\n\t\t\t<input aria-label="Select {{::teamMember.Forename}}" class="checkbox-input-field" data-cy="select-team-member-{{index}}-checkbox" id="{{::teamMember.UserID}}" ng-change="onCheckboxToggle()" ng-model="teamMember.isSelected" type="checkbox">\n\t\t\t<label class="checkbox-input-label" for="{{::teamMember.UserID}}"></label>\n\t\t</div>\n\n\t\t<!-- Non-admin -->\n\t\t<a class="team-card_persona" data-cy="team-card-persona" ng-if="::!teamMember.IsAdmin || !teamMember.ExcludeFromPayroll" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">\n\t\t\t<avatar avatar-initial="{{teamMember.isCompany ? teamMember.BusinessDetails.TradingName[0] : teamMember.Forename[0] }}" avatar-size="is-large" avatar-user-id="{{teamMember.UserID}}" class="team-card_avatar"></avatar>\n\t\t\t<name class="team-card_name" company-name="{{teamMember.BusinessDetails.TradingName}}" forename="{{teamMember.Forename}}" name-type="{{teamMember.isCompany ? \'company\' : \'person\'}}" surname="{{teamMember.Surname}}"></name>\n\t\t</a>\n\n\t</header>\n\n\t<main class="team-card_main">\n\n\t\t<!-- Admin Only -->\n\t\t<section class="team-card_section team-card_section-info" ng-if="::teamMember.IsAdmin && teamMember.ExcludeFromPayroll">\n\t\t\t<p>Admin access only, not on payroll.</p>\n\t\t</section>\n\n\t\t<!-- Everyone else -->\n\t\t<section class="team-card_section team-card_section-info" ng-if="::!teamMember.IsAdmin || !teamMember.ExcludeFromPayroll">\n\t\t\t<!-- Complete -->\n\t\t\t<div ng-if="::teamMember.IsComplete">\n\n\t\t\t\t<!-- Payroll setup mode -->\n\t\t\t\t<p ng-if="::teamMember.IsInSetupMode">{{teamMember.Forename}} has all the information needed for payroll.</p>\n\n\t\t\t\t<!-- In Payroll -->\n\t\t\t\t<div ng-if="!teamMember.IsInSetupMode">\n\n\t\t\t\t\t<!-- Non-CIS -->\n\t\t\t\t\t<div class="team-card_personal-info" ng-if="::!teamMember.IsCISSubcontractor && !teamMember.isCompany">\n\t\t\t\t\t\t<p>NI Number: <em>{{teamMember.NINumber | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t\t\t<p>Payroll ID: <em>{{teamMember.ID | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t\t\t<p>Tax Code: <em>{{teamMember.TaxCode | checkEmpty:\'Unknown\'}}<span title="Week 1 Month 1" ng-if="::teamMember.TaxCodeM1W1">&nbsp;{{$root.CONFIG.w1m1Label}}</span></em></p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- CIS Company -->\n\t\t\t\t\t<div class="team-card_personal-info" ng-if="::teamMember.IsCISSubcontractor || teamMember.isCompany">\n\t\t\t\t\t\t<p>UTR: <em>{{::teamMember.UTR | checkEmpty: \'Waiting\' }}</em></p>\n\t\t\t\t\t\t<p>Payroll ID: <em>{{teamMember.ID | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t\t\t<p>Deduction rate: <em>{{::teamMember.CISDetailsTaxTreatment | taxTreatment }}</em></p>\n\t\t\t\t\t\t<p>Type: <em>{{::teamMember.BusinessDetails.BusinessType | cisBusinessType}}</em></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Incomplete -->\n\t\t\t<div ng-if="::!teamMember.IsComplete">\n\n\t\t\t\t<!-- Payroll setup mode -->\n\t\t\t\t<p ng-if="::teamMember.IsInSetupMode">{{::teamMember.isCompany ? teamMember.BusinessDetails.TradingName : teamMember.Forename}} is missing important information needed for payroll.\n\t\t\t\t\t<a class="tertiary" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">Edit profile</a>\n\t\t\t\t</p>\n\n\t\t\t\t<!-- Setup complete -->\n\t\t\t\t<div ng-if="::!teamMember.IsInSetupMode && teamMember.IsInPensionSetupMode">\n\t\t\t\t\t<p>NI Number: <em>{{teamMember.NINumber | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t\t<p>Tax Code: <em>{{teamMember.TaxCode | checkEmpty:\'Unknown\'}}<span title="Week 1 Month 1" ng-if="::teamMember.TaxCodeM1W1">&nbsp;{{$root.CONFIG.w1m1Label}}</span></em></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</section>\n\n\t\t<!-- Team Member State -->\n\t\t<section class="team-card_section team-card_section-status">\n\t\t\t<team-member-state team-member="teamMember"></team-member-state>\n\t\t</section>\n\t</main>\n\n\t<dropdown-menu class="team-card_action-menu" id="team-card-{{index}}-action-menu" menu-icon="icon-setup" menu-show="vm.showActionMenu" menu-size="l" ng-if="::!teamMember.ExcludeFromPayroll || (teamMember.ExcludeFromPayroll && $root.currentUser.Permissions.CompanySettings.canAccessPermissions)">\n\t\t<div ng-if="::!teamMember.ExcludeFromPayroll && teamMember.IsComplete">\n\n\t\t\t<!-- This needs to be available for Agencies who do not use the import, so they can add team members into payroll -->\n\t\t\t<div class="dropdown-group" ng-if="::company.CompanyType === INTERFACE_TYPES.agency && $root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\t<a href="" ng-click="openAddAChangeForm()">Add a change</a>\n\t\t\t</div>\n\n\t\t\t<!-- Non leavers -->\n\t\t\t<div class="dropdown-group-parent" ng-if="::!teamMember.IsLeaver && !teamMember.IsCISSubcontractor">\n\t\t\t\t<!-- Payroll -->\n\t\t\t\t<div class="dropdown-group" ng-if="::!teamMember.IsOffPayrollWorker">\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-update-salary" ng-click="openPayInformationForm()" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Pay information</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-supplementary-pay-run" ng-click="openSupplementaryPayRunForm(teamMember)" ng-if="::teamMember.IsSupplementaryAvailable && teamMember.IsComplete && $root.currentUser.Permissions.Payroll.canRunPayroll">Supplementary pay run</a>\n\t\t\t\t\t<a data-cy="team-card-sick-pay" href="" id="team-card-{{index}}-action-sick-pay" ng-click="openSickPayForm()" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Sick pay</a>\n\t\t\t\t\t<a data-cy="team-card-maternity-pay" href="" id="team-card-{{index}}-action-maternity-pay" ng-click="openMaternityPayForm()" ng-if="::teamMember.CanAddMaternityPay && $root.currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Maternity Pay</a>\n\t\t\t\t\t<a data-cy="team-card-paternity-pay" href="" id="team-card-{{index}}-action-paternity-pay" ng-click="openPaternityPayForm()" ng-if="::teamMember.CanAddPaternityPay && $root.currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Paternity Pay</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-aoe" ng-click="openAttachmentOfEarningsForm()" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAOE">Attachment of Earnings</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-repayment-schedule" ng-click="openRepaymentScheduleForm()" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">Repayment schedule</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Other -->\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-mark-as-leaver" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving">Mark as leaver</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-cancel-rejoin-leaver" ng-click="openCancelRejoinLeaver()" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && teamMember.IsRestarter && teamMember.IsInSetupMode">Cancel rejoin leaver</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-unmark-as-leaver" ng-click="openUnmarkAsLeaverForm()" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving">Unmark as leaver</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-edit-leave-date" ng-click="openUpdateLeaverStatusForm(true)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving">Edit leaver information</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-eyu" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.EYU)" ng-if="::teamMember.CanSubmitEYU && $root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates && !teamMember.IsOffPayrollWorker">Earlier year update</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-ytd-fps" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.YTDFPS)" ng-if="::teamMember.CanSubmitYTDFPS && $root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates && !teamMember.IsOffPayrollWorker">Submit Earlier Year FPS</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-advance-future-periods" ng-click="openAdvanceFuturePeriodsForm(payPeriod)" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation && teamMember.CanAdvanceFuturePeriods">Advance future periods</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-advance-future-periods" ng-click="openUnmarkAsAdvancingForm()" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation && teamMember.IsAdvancingFuturePeriods">Unmark as \u2018Advancing\u2019</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-on-hold" ng-click="openOnHoldForm(teamMember)" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Mark as {{teamMember.IsOnHold ? "\u2018Active on payroll\u2019" : "\u2018On hold\u2019" }}</a>\n\t\t\t\t\t<a href="" id="team-card-{{index}}-action-remove-from-team" ng-click="openChangeAdminStateForm(true)" ng-if="::teamMember.IsInSetupMode && teamMember.IsAdmin && $root.currentUser.Permissions.CompanySettings.canAccessPermissions">Remove from team</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="dropdown-group" ng-if="::teamMember.IsInSetupMode && !teamMember.IsAdmin\n\t\t\t\t\t\t   && !teamMember.IsRestarter && $root.currentUser.Permissions.Team.canAddDeleteTeamMembers\n\t\t\t\t\t\t   && teamMember.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.InwardPending">\n\t\t\t\t\t<a class="assertive" href="" id="team-card-{{index}}-action-delete-team-member" ng-click="openDeleteTeamMemberForm()">Delete team member</a>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Non leavers (CIS) -->\n\t\t\t<div class="dropdown-group" ng-if="::!teamMember.IsLeaver && teamMember.IsCISSubcontractor && teamMember.IsComplete">\n\t\t\t\t<a href="" id="team-card-{{index}}-action-mark-as-leaver" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving">Mark as leaver</a>\n\t\t\t</div>\n\n\t\t\t<!-- Account -->\n\t\t\t<div class="dropdown-group" ng-if="!teamMember.IsInSetupMode && teamMember.IsComplete">\n\t\t\t\t<a href="" id="team-card-{{index}}-action-invite" ng-click="openInviteToRegisterForm()" ng-if="::!teamMember.IsRegistered && $root.currentUser.Permissions.Team.canInviteTeamMembersToRegister">Invite to register</a>\n\t\t\t\t<a id="team-card-{{index}}-action-view-profile" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId: teamMember.UserID})">View profile</a>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div ng-if="::teamMember.IsAdmin && teamMember.ExcludeFromPayroll && $root.currentUser.Permissions.CompanySettings.canAccessPermissions && teamMember.IsComplete">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a href="" id="team-card-{{index}}-action-add-to-payroll" ng-click="openChangeAdminStateForm(false)">Add to payroll</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Incomplete -->\n\t\t<div class="dropdown-group" ng-if="!teamMember.IsComplete">\n\t\t\t<a data-cy="team-member_action-menu_pay-information" href="" ng-click="openPayInformationForm()" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Pay information</a>\n\t\t\t<a data-cy="team-member_action-menu_mark-as-leaver" href="" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::($root.currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving)">Mark as leaver</a>\n\t\t\t<a data-cy="team-member_action-menu_unmark-as-leaver" href="" ng-click="openUnmarkAsLeaverForm()" ng-if="::($root.currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving)">Unmark as leaver</a>\n\t\t\t<a data-cy="team-card-{{index}}-edit-leave-date" href="" ng-click="openUpdateLeaverStatusForm(true)" ng-if="::($root.currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving)">Edit leaver information</a>\n\t\t\t<a data-cy="team-member_action-menu_invite-to-register" href="" ng-click="openInviteToRegisterForm()" ng-if="!teamMember.IsRegistered && $root.currentUser.Permissions.Team.canInviteTeamMembersToRegister">Invite to register</a>\n\t\t\t<a data-cy="team-member_action-menu_unregister" href="" ng-click="openUnregisterUserForm()" ng-if="teamMember.IsRegistered && $root.currentUser.Permissions.Team.canInviteTeamMembersToRegister">Unregister</a>\n\t\t\t<a data-cy="team-card-{{index}}-action-view-profile" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId: teamMember.UserID})">View profile</a>\n\t\t</div>\n\n\t\t<div class="dropdown-group" ng-if="::teamMember.IsInSetupMode && !teamMember.IsAdmin && !teamMember.IsComplete\n\t\t\t\t&& !teamMember.IsRestarter && $root.currentUser.Permissions.Team.canAddDeleteTeamMembers\n\t\t\t\t&& teamMember.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.InwardPending">\n\t\t\t<a class="assertive" href="" id="team-card-{{index}}-action-delete-team-member" ng-click="openDeleteTeamMemberForm()">Delete team member</a>\n\t\t</div>\n\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/team-card-basic/team-card-basic.component.html','<div class="team-card-basic" ng-class="[\n\t\t$ctrl.theme,\n\t\t{\n\t\t\t\'is-selected\': $ctrl.isSelected || $ctrl.ngModel,\n\t\t\t\'is-email-hidden\': !$ctrl.showEmail\n\t\t}\n\t]">\n\t<div class="team-card-basic_checkbox" ng-if="$ctrl.hasCheckbox">\n\t\t<input class="pc-checkbox" id="{{$ctrl.teamMember.UserID}}" name="{{$ctrl.teamMember.UserID}}" ng-click="$ctrl.onChange()" ng-model="$ctrl.ngModel" type="checkbox">\n\t</div>\n\t<label class="team-card-basic_persona" for="{{$ctrl.teamMember.UserID}}">\n\t\t<div class="team-card-basic_avatar">\n\t\t\t<avatar avatar-initial="{{ $ctrl.teamMember.Forename ? $ctrl.teamMember.Forename[0] : $ctrl.teamMember.Name[0] }}" avatar-size="is-small" avatar-user-id="{{$ctrl.teamMember.UserID}}"></avatar>\n\t\t</div>\n\t\t<div>\n\t\t\t<span ng-if="!$ctrl.isNameClickable">\n\t\t\t\t<h5 class="team-card-basic_title" ng-if="::!$ctrl.teamMember.isCurrentUser && $ctrl.teamMember.Forename">\n\t\t\t\t\t<truncate text="$ctrl.teamMember.Forename + \' \' + $ctrl.teamMember.Surname" truncate-amount="50">\n\t\t\t\t\t</truncate>\n\t\t\t\t</h5>\n\t\t\t\t<h5 class="team-card-basic_title" ng-if="::!$ctrl.teamMember.isCurrentUser && !$ctrl.teamMember.Forename && $ctrl.teamMember.Name">\n\t\t\t\t\t<truncate text="$ctrl.teamMember.Name" truncate-amount="50">\n\t\t\t\t\t</truncate>\n\t\t\t\t</h5>\n\t\t\t\t<h5 class="team-card-basic_title" ng-if="::$ctrl.teamMember.isCurrentUser">You</h5>\n\t\t\t</span>\n\t\t\t<span ng-if="$ctrl.isNameClickable">\n\t\t\t\t<h5 class="team-card-basic_title">\n\t\t\t\t\t<a href="" ng-click="$ctrl.onChange()">\n\t\t\t\t\t\t<truncate text="$ctrl.teamMember.Forename + \' \' + $ctrl.teamMember.Surname" truncate-amount="50">\n\t\t\t\t\t\t</truncate>\n\t\t\t\t\t</a>\n\t\t\t\t</h5>\n\t\t\t</span>\n\t\t\t<h6 class="team-card-basic_subtitle" ng-if="!$ctrl.hasContent && $ctrl.showEmail">\n\t\t\t\t{{$ctrl.teamMember.EmailAddress | checkEmpty:\'No email\'}}\n\t\t\t</h6>\n\t\t\t<div class="team-card-basic_content" ng-if="$ctrl.hasContent" ng-transclude="content"></div>\n\t\t</div>\n\t</label>\n\t<div class="team-card-basic_icon" ng-if="$ctrl.showIcon" ng-transclude="icon"></div>\n\t<div class="team-card-basic_actions" ng-if="$ctrl.hasActions" ng-transclude="actions"></div>\n\t<div class="team-card-basic_footer fadeIn" ng-if="$ctrl.hasFooter && $ctrl.showFooter" ng-transclude="footer"></div>\n</div>\n');
$templateCache.put('components/team-card-history/teamCardHistory.html','<div class="team-card team-card-history fadeIn" ng-class="{\'is-active\': menuShow}">\n\n\t<header class="team-card-history-header">\n\t\t<a href ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})" class="team-card-history-persona" ng-if="!teamMember.IsAdmin || !teamMember.ExcludeFromPayroll">\n\t\t\t<avatar class="team-card-history-avatar is-link" avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t<name class="team-card-history-name" forename="{{teamMember.Forename}}" surname="{{teamMember.Surname}}"></name>\n\t\t</a>\n\t</header>\n\n\t<div class="team-card-history-stat">\n\t\t<span class="team-card-history-stat-label">Net pay</span>\n\t\t<span class="team-card-history-stat-value" ng-class="{\'highlighted tertiary\' : teamMember.HasSalaryChange}">{{teamMember.NetPayment | monetise}}</span>\n\t</div>\n\n\t<div class="team-card-history-tags">\n\n\t\t<!-- Leaver -->\n\t\t<a href class="tag quarternary team-card-history-tag" tooltip tooltip-text="Leave date: {{teamMember.LeaveDateISO | dateformat:\'simple\'}}" ng-if="teamMember.LeaveDateISO">LEAVER</a>\n\n\t\t<!-- Starter -->\n\t\t<a href class="tag positive team-card-history-tag" tooltip tooltip-text="Start date: {{teamMember.StartDateISO | dateformat:\'simple\'}}" ng-if="teamMember.StartDateISO && !teamMember.LeaveDateISO">STARTER</a>\n\n\t\t<!-- Salary Change -->\n\t\t<a href class="tag tertiary team-card-history-tag" tooltip tooltip-text="{{teamMember.Forename}} had a salary change in this period" ng-if="teamMember.HasSalaryChange">SALARY CHANGE</a>\n\n\t\t<!-- Manual Payment -->\n\t\t<a href class="tag primary team-card-history-tag" tooltip tooltip-text="{{teamMember.Forename}} isn\u2019t included in your BACS file and should be paid manually" ng-if="!teamMember.HasBankDetails">MANUAL</a>\n\t</div>\n\n\t<dropdown-menu class="team-card-history-action-menu" menu-size="l" menu-icon="icon-setup" menu-show="menuShow">\n\n\t\t<div class="dropdown-group">\n\t\t\t<!-- Not live -->\n\t\t\t<!-- <a href="" ng-click="openAdditionalPayRunForm()">Additional pay run</a> -->\n\t\t\t<a href="" ng-click="openViewPayStatementForm(teamMember.UserID)">View pay statement</a>\n\t\t</div>\n\n\t\t<div class="dropdown-group">\n\t\t\t<a ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">View profile</a>\n\t\t</div>\n\n\t</dropdown-menu>\n\n</div>\n');
$templateCache.put('components/team-card-leaver/team-card-leaver.component.html','<div class="team-card fadeIn" data-cy="team-leaver-{{:: $ctrl.index}}" id="team-card-{{$ctrl.index}}" ng-class="{\'is-selected\' : $ctrl.teamMember.isSelected}">\n\t<header class="team-card_header">\n\t\t<a class="team-card_persona" ng-href="{{$ctrl.profileUrl}}">\n\t\t\t<avatar avatar-initial="{{$ctrl.teamMember.Forename[0]}}" avatar-size="is-large" avatar-user-id="{{$ctrl.teamMember.UserID}}" class="team-card_avatar"></avatar>\n\t\t\t<name class="team-card_name" company-name="{{$ctrl.teamMember.BusinessDetails.TradingName}}" forename="{{$ctrl.teamMember.Forename}}" name-type="{{$ctrl.teamMember.isCompany ? \'company\' : \'person\'}}" surname="{{$ctrl.teamMember.Surname}}"></name>\n\t\t</a>\n\t</header>\n\n\t<main class="team-card_main">\n\n\t<section class="team-card_section team-card_section-info">\n\t\t\t<div class="team-card_personal-info">\n\t\t\t\t<p>NI Number: <em>{{$ctrl.teamMember.NINumber | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t<p>Tax Code: <em>{{$ctrl.teamMember.TaxCode | checkEmpty:\'Unknown\'}}<span title="Week 1 Month 1" ng-if="::$ctrl.teamMember.TaxCodeM1W1">&nbsp;{{$root.CONFIG.w1m1Label}}</span></em></p>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="team-card_section team-card_section-state">\n\t\t\t<div class="team-member-state">\n\t\t\t\t<p><span class="tag quarternary">Leaver</span><span class="team-card_section-state-meta" ng-if="$ctrl.teamMember.LeaveDateISO">&nbsp;&nbsp;on {{$ctrl.teamMember.LeaveDateISO | dateformat}}</span></p>\n\t\t\t</div>\n\t\t</section>\n\t</main>\n\n\t<dropdown-menu class="team-card_action-menu" id="team-card-{{$ctrl.index}}-action-menu" menu-id="team-leaver-menu" menu-icon="icon-setup" menu-size="l" ng-if="!$ctrl.teamMember.isArchivedLeaver">\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" data-cy="team-leaver-menu-unmark-as-leaver" id="team-card-{{$ctrl.index}}-action-unmark-as-leaver" ng-click="$ctrl.openUnmarkAsLeaverForm($ctrl)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && !$ctrl.payPeriod.IsRollback && $ctrl.teamMember.IsLeaverManuallySet && !$ctrl.teamMember.IsCISSubcontractor">Unmark as leaver</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-edit-leave-date" id="team-card-{{$ctrl.index}}-action-edit-leave-date" ng-click="$ctrl.openUpdateLeaverStatusForm($ctrl, true)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers">Edit leaver information</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-payment-after-leaving" id="team-card-{{$ctrl.index}}-action-payment-after-leaving" ng-click="$ctrl.openPaymentAfterLeavingForm($ctrl)" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments && !$ctrl.teamMember.IsCISSubcontractor">Payment after leaving</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-generate-p45" id="team-card-{{$ctrl.index}}-action-generate-p45" ng-click="$ctrl.openGenerateP45Form($ctrl)" ng-if="::!$ctrl.teamMember.IsP45Generated">Generate P45</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-eyu" id="team-card-{{index}}-action-eyu" ng-click="$ctrl.openCorrectionalSubmissionForm($ctrl, $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU)" ng-if="::$ctrl.teamMember.CanSubmitEYU && $root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Earlier year update</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-ytd-fps" id="team-card-{{index}}-action-ytd-fps" ng-click="$ctrl.openCorrectionalSubmissionForm($ctrl, $ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS)" ng-if="::$ctrl.teamMember.CanSubmitYTDFPS && $root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Submit Earlier Year FPS</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-rejoin-leaver" id="team-card-{{$ctrl.index}}-action-rejoin-leaver" ng-click="$ctrl.openRejoinLeaverForm($ctrl)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && !$ctrl.payPeriod.IsRollback">Rejoin leaver</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-leaver-made-in-error" id="team-card-{{index}}-action-leaver-made-in-error" ng-click="$ctrl.openLeaverMadeInErrorForm($ctrl)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers">Leaver made in error</a>\n\t\t\t<a href="" data-cy="team-leaver-menu-download-p45" id="team-card-{{$ctrl.index}}-action-download-p45" ng-click="$ctrl.downloadFile($ctrl.teamMember.DownloadP45URL)" ng-if="::$ctrl.teamMember.DownloadP45URL !== \'\' && !$ctrl.teamMember.IsCISSubcontractor">Download P45</a>\n\t\t</div>\n\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.Team.canAddDeleteTeamMembers">\n\t\t\t<a class="assertive" data-cy="team-leaver-menu-delete-team-member" href="" id="team-card-{{$ctrl.index}}-action-delete-team-member" ng-click="$ctrl.openDeleteTeamMemberForm($ctrl)">Delete team member</a>\n\t\t</div>\n\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/team-card-moved-payrolls/team-card-moved-payrolls.component.html','<div id="team-card-{{index}}" class="team-card fadeIn" ng-class="{\'is-selected\' : teamMember.isSelected}">\n\n\t<header class="team-card_header">\n\t\t<a ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId: teamMember.UserID})" class="team-card_persona">\n\t\t\t<avatar class="team-card_avatar" avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-large" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t<name class="team-card_name" forename="{{teamMember.Forename}}" surname="{{teamMember.Surname}}"></name>\n\t\t</a>\n\t</header>\n\n\t<main class="team-card_main">\n\n\t\t<section class="team-card_section team-card_section-info">\n\t\t\t<div class="team-card_personal-info">\n\t\t\t\t<p>NI Number: <em>{{teamMember.NINumber | checkEmpty:\'Waiting\'}}</em></p>\n\t\t\t\t<p>Tax Code: <em>{{teamMember.TaxCode | checkEmpty:\'Unknown\'}}<span title="Week 1 Month 1" ng-if="::teamMember.TaxCodeM1W1">&nbsp;{{$root.CONFIG.w1m1Label}}</span></em></p>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="team-card_section team-card_section-state">\n\t\t\t<div class="team-member-state">\n\t\t\t\t<p><span class="tag greyscale">MOVED PAYROLLS</span><span class="team-card_section-state-meta" ng-if="teamMember.PayrollMoveDateISO">&nbsp;&nbsp;on {{teamMember.PayrollMoveDateISO | dateformat}}</span></p>\n\t\t\t</div>\n\t\t</section>\n\t</main>\n\n\t<dropdown-menu id="team-card-{{index}}-action-menu" class="team-card_action-menu" menu-size="l" menu-icon="icon-setup">\n\t\t<div class="dropdown-group">\n\t\t\t<a href="" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId: teamMember.UserID})" id="team-card-{{index}}-action-view-profile" ng-click="viewProfile(userId)">View profile</a>\n\t\t</div>\n\t</dropdown-menu>\n\n</div>\n');
$templateCache.put('components/team-card-payroll/teamCardPayroll.html','<div id="team-card-payroll-{{index}}" data-cy="team-card-payroll-{{index}}" class="team-card-payroll fadeIn" ng-class="{\'team-card-payroll-selected\': teamMember.isSelected}">\n\t<header class="team-card-payroll-header">\n\n\t\t<!-- Bulk Actions -->\n\t\t<div class="checkbox-field checkbox">\n\t\t\t<input aria-label="Select {{::teamMember.PersonalDetails.Forename}}" ng-change="onCheckboxToggle()" ng-model="teamMember.isSelected" type="checkbox" id="{{teamMember.PersonalDetails.UserID}}">\n\t\t\t<label class="checkbox-field-tickbox" for="{{teamMember.PersonalDetails.UserID}}">\n\t\t\t</label>\n\t\t</div>\n\n\t\t<a class="team-card-payroll-persona" data-cy="team-card-payroll-open-profile" ng-if="!teamMember.IsAdmin || !teamMember.ExcludeFromPayroll" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.PersonalDetails.UserID})">\n\t\t\t<avatar avatar-initial="{{teamMember.PersonalDetails.Forename[0]}}" avatar-user-id="{{teamMember.PersonalDetails.UserID}}" avatar-size="is-medium" class="team-card-payroll-avatar">\n\t\t\t</avatar>\n\t\t\t<name class="team-card-payroll-name" company-name="{{::teamMember.PersonalDetails.BusinessDetails.TradingName}}" forename="{{::teamMember.PersonalDetails.Forename}}" name-type="{{::teamMember.isCompany ? \'company\' : \'person\'}}" surname="{{::teamMember.PersonalDetails.Surname}}">\n\t\t\t</name>\n\t\t</a>\n\t\t<p class="s team-card-payroll-meta">\n\t\t\tPayroll ID: {{::teamMember.PersonalDetails.PayrollID}}\n\n\t\t\t<!-- Tax Refund -->\n\t\t\t<a class="team-card-payroll-icon" href="" ng-click="openApplyTaxRefundForm()" ng-if="teamMember.IsTaxRefund" tooltip tooltip-icon-theme="secondary" tooltip-icon="icon-tax-code-change" tooltip-size="l" tooltip-text="Tax refund applied">\n\t\t\t\t<icon-dot icon="icon-tax-code-change" is-light="true" theme="is-secondary is-small has-hover"></icon-dot>\n\t\t\t</a>\n\n\t\t\t<!-- Payslip Note -->\n\t\t\t<a class="team-card-payroll-icon" href="" ng-click="openEditPayslipNotesForm()" ng-if="teamMember.HasPayslipNote" tooltip tooltip-icon-theme="indifferent" tooltip-icon="icon-document-1" tooltip-size="l" tooltip-text="{{teamMember.PayslipNoteTextMerged | emojify}}">\n\t\t\t\t<icon-dot icon="icon-document-1" theme="is-indifferent is-small has-hover" is-light="true"></icon-dot>\n\t\t\t</a>\n\n\t\t\t<!-- Paid Hourly -->\n\t\t\t<a class="team-card-payroll-icon" href="" ng-if="::teamMember.PersonalDetails.SalaryType === PAYMENT_TYPES.hourly" tooltip tooltip-icon-theme="primary" tooltip-icon="icon-clock" tooltip-text="{{::teamMember.PersonalDetails.Forename}} is paid hourly">\n\t\t\t\t<icon-dot icon="icon-clock" theme="is-primary is-small has-hover" is-light="true"></icon-dot>\n\t\t\t</a>\n\t\t</p>\n\t</header>\n\n\t<main class="team-card-payroll-main">\n\n\t\t<!-- Gross pay -->\n\t\t<section class="team-card-payroll-section">\n\t\t\t<h6 class="team-card-payroll-section-heading" id="team-card-payroll-{{index}}-gross-pay">\n\t\t\t\t{{teamMember.GrossPay | monetise}}\n\t\t\t</h6>\n\t\t\t<p>Gross pay</p>\n\t\t\t<div class="team-card-payroll-tag team-member-state">\n\t\t\t\t<team-member-state team-member="teamMember" on-state-click="openFormForState(teamMember)">\n\t\t\t\t</team-member-state>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Pension -->\n\t\t<section class="team-card-payroll-section" ng-if="company.HasPension && !teamMember.PersonalDetails.IsOffPayrollWorker">\n\t\t\t<!-- Keep parent container if CIS to make sure values align in UI -->\n\t\t\t<div ng-if="!teamMember.PersonalDetails.IsCISSubcontractor">\n\t\t\t\t<h6 class="team-card-payroll-section-heading" id="team-card-payroll-{{index}}-pension">\n\t\t\t\t\t{{teamMember.PensionAmount | monetise}}\n\t\t\t\t</h6>\n\t\t\t\t<p>AE Pension</p>\n\t\t\t\t<div class="team-card-payroll-tag team-member-state" ng-if="teamMember.PensionState !== \'\'">\n\t\t\t\t\t<pension-team-state is-clickable="true" pension-state="teamMember.PensionState"></pension-team-state>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\t</main>\n\n\t<footer class="team-card-payroll-footer" ng-class="{\'no-changes\': !teamMember.Adjustments.length && teamMember.loadingState !== \'loading\'}">\n\n\t\t<div class="align-center circle-loader-container" ng-if="teamMember.loadingState === \'loading\'">\n\t\t\t<div class="circle-loader-container-inner">\n\t\t\t\t<circle-loader></circle-loader>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Number of changes -->\n\t\t<p class="team-card-payroll-footer-count">\n\t\t\t<ng-pluralize count="teamMember.Adjustments.length" when="{\'0\': \'No changes\', \'1\': \'1 change\', \'other\': \'{} changes\'}">\n\t\t\t</ng-pluralize></p>\n\n\t\t<!-- View changes action -->\n\t\t<a class="team-card-payroll-footer-action" href="" ng-click="openViewChangesForm()" ng-if="teamMember.Adjustments.length > 0">\n\t\t\t<ng-pluralize count="teamMember.Adjustments.length" when="{\'0\': \'No change\', \'1\': \'View change\', \'other\': \'View changes\'}">\n\t\t\t</ng-pluralize>\n\t\t</a>\n\n\t\t<!-- Add change action -->\n\t\t<a class="team-card-payroll-footer-action" href="" ng-click="openAddAChangeForm()" ng-if="teamMember.Adjustments.length === 0 && $root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\tAdd a change\n\t\t</a>\n\n\t\t<!-- Adjustments list -->\n\t\t<adjustments-list adjustment-detail-summary="teamMember" agency-profile-id="{{agencyProfileId}}" callback="updateUser" can-update="$root.currentUser.Permissions.Payroll.canUpdateAdjustments && payPeriod.ApprovalDateISO === \'\'" class="team-card-payroll-adjustments" pay-period="payPeriod" user-id="{{teamMember.PersonalDetails.UserID}}"></adjustments-list>\n\t</footer>\n\n\t<span class="team-card-payroll-demo" ng-if="teamMember.showDemo" tooltip-demo td-id="{{$root.DEMO_TASKS.payroll.addBonus}},{{$root.DEMO_TASKS.payroll.addExpense}},{{$root.DEMO_TASKS.payroll.addPayslipNote}}" td-active="!menuShow">\n\t</span>\n\n\t<dropdown-menu id="team-card-payroll-{{index}}-action-menu" class="team-card-payroll-action-menu" menu-icon="icon-setup" menu-id="team-card-payroll-action-menu" menu-show="menuShow" menu-size="l">\n\t\t<div class="dropdown-group">\n\t\t\t<a data-cy="team-card-payroll-action-menu-edit-deemed-payment" href="" id="team-card-payroll-{{index}}-action-edit-deemed-payment" ng-click="openEditDeemedPaymentForm()" ng-if="::teamMember.PersonalDetails.IsOffPayrollWorker">\n\t\t\t\tEdit deemed payment\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-add-change" href="" id="team-card-payroll-{{index}}-action-add-change" ng-click="openAddAChangeForm()" ng-if="::!teamMember.PersonalDetails.IsOffPayrollWorker && $root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\tAdd a change\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-view-changes" href="" id="team-card-payroll-{{index}}-action-view-changes" ng-click="openViewChangesForm()" ng-if="::!teamMember.PersonalDetails.IsOffPayrollWorker && teamMember.Adjustments.length">\n\t\t\t\tView changes\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-update-gross-pay" href="" id="team-card-payroll-{{index}}-action-update-gross-pay" ng-click="openUpdateGrossPayForm(teamMember)" ng-if="::!teamMember.PersonalDetails.IsCISSubcontractor && !teamMember.PersonalDetails.IsOffPayrollWorker && $root.currentUser.Permissions.Team.canEditPayInformation">\n\t\t\t\tUpdate {{teamMember.PersonalDetails.SalaryType === SALARY_TYPES.netPay ? \'net pay\' : \'salary\'}} for period\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-update-leaver" href="" id="team-card-payroll-{{index}}-action-update-leaver" ng-click="openUpdateLeaverStatusForm(false)" ng-if="!teamMember.IsLeaver && !teamMember.PersonalDetails.IsCISSubcontractor && $root.currentUser.Permissions.Team.canManageLeavers">\n\t\t\t\tMark as leaver\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-{{teamMember.HasPayslipNote ? \'edit\' : \'add\'}}-payslip-note" href="" id="team-card-payroll-{{index}}-action-add-payslip-note" ng-click="openEditPayslipNotesForm()" ng-if="::$root.currentUser.Permissions.Payroll.canUpdatePayslipNotes">\n\t\t\t\t<span data-cy="team-card-payroll-action-menu-edit-payslip-note-link" ng-if="teamMember.HasPayslipNote">\n\t\t\t\t\tEdit payslip note\n\t\t\t\t</span>\n\t\t\t\t<span data-cy="team-card-payroll-action-menu-add-payslip-note-link" ng-if="!teamMember.HasPayslipNote">Add payslip note\n\t\t\t\t</span>\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-remove-payslip-note" href="" id="team-card-payroll-{{index}}-action-remove-payslip-note" ng-click="openRemovePayslipNotesForm()" ng-if="::teamMember.HasPayslipNote && $root.currentUser.Permissions.Payroll.canUpdatePayslipNotes">\n\t\t\t\tRemove payslip note\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-pay-statement" href="" id="team-card-payroll-{{index}}-action-pay-statement" ng-click="openPayStatementForm()">\n\t\t\t\tPreview pay statement\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-manage-pensions" href="" id="team-card-payroll-{{index}}-action-manage-pensions" ng-click="openPensionTeamManagePensionsForm()" ng-if="(!teamMember.PersonalDetails.IsCISSubcontractor && !teamMember.PersonalDetails.IsOffPayrollWorker) && (company.IsPensionActive && company.HasPension) && $root.currentUser.Permissions.Team.canUpdateTeamPensionSettings">\n\t\t\t\tManage pensions\n\t\t\t</a>\n\t\t\t<a data-cy="team-card-payroll-action-menu-view-work-pattern" href="" id="team-card-payroll-{{index}}-action-view-work-pattern" ng-if="::!teamMember.PersonalDetails.IsOffPayrollWorker && teamMember.PersonalDetails.SalaryType !== SALARY_TYPES.payPolicy && !teamMember.PersonalDetails.IsCISSubcontractor" ng-click="openViewWorkPatternForm(teamMember.PersonalDetails.UserID)">\n\t\t\t\tView work pattern\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a data-cy="team-card-payroll-action-menu-view-profile" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.PersonalDetails.UserID})">\n\t\t\t\tView profile\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n\n</div>\n');
$templateCache.put('components/team-card-pension/teamCardPension.html','<div class="team-card fadeIn" data-cy="pension-team-{{:: index }}">\n\n\t<!-- Header (avatar, name) -->\n\t<header class="team-card_header">\n\t\t<a class="team-card_persona" ui-sref="team.profile.overview({\n\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\tuserId:teamMember.UserID\n\t\t\t})">\n\t\t\t<avatar avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-large" avatar-user-id="{{teamMember.UserID}}" class="team-card_avatar"></avatar>\n\t\t\t<name class="team-card_name" forename="{{teamMember.Forename}}" surname="{{teamMember.Surname}}"></name>\n\t\t</a>\n\t</header>\n\n\t<!-- Complete, not ghost pension -->\n\t<main class="team-card_main" ng-if="::(\n\t\t\tteamMember.IsComplete &&\n\t\t\t!isGhostPension\n\t\t)">\n\t\t<!-- Pension Contributions -->\n\t\t<section class="team-card_section team-card_section-list">\n\t\t\t<ul>\n\t\t\t\t<li class="team-card_section-list-item">\n\t\t\t\t\t<span class="team-card_section-list-item-name ellipsis" title="{{teamMember.Forename}} ({{teamMember.Pension.HasFixedEmployeeContribution ? \'fixed\' : teamMember.Pension.PensionEmployeePercent + \'%\'}})">\n\t\t\t\t\t\t{{teamMember.Forename}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span>&nbsp;({{teamMember.Pension.HasFixedEmployeeContribution ? \'fixed\' : teamMember.Pension.PensionEmployeePercent + \'%\'}}</span>)\n\t\t\t\t\t<span class="team-card_section-list-item-value">{{teamMember.Pension.EmployeeContributionAmount | monetise}}</span>\n\t\t\t\t</li>\n\t\t\t\t<li class="team-card_section-list-item">\n\t\t\t\t\t<span class="team-card_section-list-item-name ellipsis" title="{{$root.currentCompany.Name}} ({{teamMember.Pension.HasFixedEmployerContribution ? \'fixed\' : teamMember.Pension.PensionEmployerPercent + \'%\'}})">\n\t\t\t\t\t\t{{$root.currentCompany.Name}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span>&nbsp;({{teamMember.Pension.HasFixedEmployerContribution ? \'fixed\' : teamMember.Pension.PensionEmployerPercent + \'%\'}}</span>)\n\t\t\t\t\t<span class="team-card_section-list-item-value">{{teamMember.Pension.EmployerContributionAmount | monetise}}</span>\n\t\t\t\t</li>\n\t\t\t\t<li class="team-card_section-list-item">\n\t\t\t\t\t<span class="team-card_section-list-item-name">Total</span>\n\t\t\t\t\t<span class="team-card_section-list-item-value">\n\t\t\t\t\t\t{{teamMember.Pension.EmployeeContributionAmount + teamMember.Pension.EmployerContributionAmount | monetise}}\n\t\t\t\t\t</span>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</section>\n\n\t\t<!-- Pension Status -->\n\t\t<section class="team-card_section team-card_section-status" ng-if="teamMember.Pension.PensionState !== \'\'">\n\t\t\t<span class="tag tertiary inverse" ng-if="::!teamMember.IsComplete">\n\t\t\t\tIncomplete\n\t\t\t</span>\n\t\t\t<pension-team-state is-clickable="true" pension-state="teamMember.Pension.PensionState"></pension-team-state>\n\t\t\t<span class="is-small italic" ng-if="pensionStateDate">\n\t\t\t\t&nbsp;{{teamMember.Pension.PensionState === \'postponed\' ? \'until\' : \'on\'}}&nbsp;{{pensionStateDate | dateformat:\'medium\'}}\n\t\t\t</span>\n\t\t</section>\n\n\t\t<!-- Additional post icon -->\n\t\t<div class="team-card_icon" ng-if="teamMember.Pension.IsAdditionalPost">\n\t\t\t<icon-dot icon="icon-setup-user" is-light="true" theme="is-primary has-hover" tooltip-position="left" tooltip-text="{{teamMember.Pension.SalaryPolicyPostTitle}}"></icon-dot>\n\t\t</div>\n\n\t</main>\n\n\t<!-- Not complete, not ghost pension -->\n\t<main class="team-card_main" ng-if="::(\n\t\t\t!teamMember.IsComplete &&\n\t\t\t!isGhostPension\n\t\t)">\n\t\t<!-- Pension Contributions -->\n\t\t<section class="team-card_section">\n\n\t\t\t<!-- Payroll Setup -->\n\t\t\t<p class="s" ng-if="::teamMember.IsInSetupMode">\n\t\t\t\t{{teamMember.Forename}} is missing important information needed for payroll.\n\t\t\t\t<a class="tertiary" data-cy="pension-team-edit-profile" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">\n\t\t\t\t\tEdit profile\n\t\t\t\t</a>\n\t\t\t</p>\n\n\t\t\t<!-- Pension Setup -->\n\t\t\t<p class="s" ng-if="::!teamMember.IsInSetupMode && teamMember.IsInPensionSetupMode">\n\t\t\t\tAdd status, group and contribution information for {{teamMember.Forename}}.\n\t\t\t\t<a class="tertiary" data-cy="pension-team-edit-pension-settings" href="" ng-click="openEditTeamMemberPensionWizard()">\n\t\t\t\t\tEdit pension settings\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</section>\n\n\t\t<!-- Additional post icon -->\n\t\t<div class="team-card_icon" ng-if="teamMember.Pension.IsAdditionalPost">\n\t\t\t<icon-dot icon="icon-setup-user" is-light="true" theme="is-primary has-hover" tooltip-position="left" tooltip-text="{{teamMember.Pension.SalaryPolicyPostTitle}}"></icon-dot>\n\t\t</div>\n\n\t\t<!-- Pension Status -->\n\t\t<section class="team-card_section team-card_section-status">\n\t\t\t<span class="tag tertiary inverse">Incomplete</span>\n\t\t</section>\n\t</main>\n\n\t<!-- Ghost pension -->\n\t<main class="team-card_main" ng-if="isGhostPension">\n\t\t<div class="team-card_section" ng-if="teamMember.Pension.PensionState !== \'eligible\'">\n\t\t\t<p class="s greyscale-darkened">\n\t\t\t\tYou\u2019ll be notified if {{teamMember.Forename}} becomes eligible for a workplace pension.\n\t\t\t\tYou can then update your Ghost Pension settings and select a pension provider.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="team-card_section" ng-if="teamMember.Pension.PensionState === \'eligible\'">\n\t\t\t<p class="s">\n\t\t\t\t{{teamMember.Forename}} is eligible for a workplace pension. Select a pension provider in your\n\t\t\t\t<a class="tertiary stronger" data-cy="pension-team-scheme-ghost-pension-settings" href="" ui-sref="pensions.scheme.settings({agencyProfileId: agencyProfileId, agencyEmployerPensionID: agencyEmployerPensionId})">\n\t\t\t\t\tGhost Pension settings\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Additional post icon -->\n\t\t<div class="team-card_icon" ng-if="teamMember.Pension.IsAdditionalPost">\n\t\t\t<icon-dot icon="icon-setup-user" is-light="true" theme="is-primary has-hover" tooltip-position="left" tooltip-text="{{teamMember.Pension.SalaryPolicyPostTitle}}"></icon-dot>\n\t\t</div>\n\n\t\t<!-- Pension Status -->\n\t\t<section class="team-card_section team-card_section-status" ng-if="teamMember.Pension.PensionState !== \'\'">\n\t\t\t<pension-team-state pension-state="teamMember.Pension.PensionState"></pension-team-state>\n\t\t</section>\n\n\t</main>\n\n\t<span class="team-card_demo" ng-if="teamMember.showDemo" td-active="!menuShow" td-id="{{$root.DEMO_TASKS.workplacePension.updateEmployeePensionContributions}},{{$root.DEMO_TASKS.workplacePension.updateEmployeesPensionState}}" tooltip-demo></span>\n\n\t<dropdown-menu class="team-card_action-menu" menu-id="pension-team-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-show="menuShow" menu-size="l">\n\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.Team.canUpdateTeamPensionSettings">\n\t\t\t<a data-cy="pension-team-menu-pension-status" href="" ng-click="openSlideInForm(\'pension-team-status\', true)" ng-if="teamMember.CanUpdatePensionStatus || teamMember.CanUpdatePensionStatusFull">\n\t\t\t\tPension status\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-pension-band" href="" ng-click="openSlideInForm(\'pension-team-bands\')" ng-if="teamMember.CanUpdatePensionBand">\n\t\t\t\tPension band\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-pension-group" href="" ng-click="openSlideInForm(\'pension-team-groups\')" ng-if="teamMember.CanUpdatePensionGroup">\n\t\t\t\tPension group\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-pension-contributions-non-ae" href="" ng-click="openSlideInForm(\'pension-team-contributions-non-ae\')" ng-if="teamMember.CanUpdatePensionSetup">\n\t\t\t\tPension contributions\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-pension-contributions-ae" href="" ng-click="openSlideInForm(\'pension-team-contributions-ae\')" ng-if="teamMember.CanUpdatePensionContributions">\n\t\t\t\tPension contributions\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-pension-postponement" href="" ng-click="openSlideInForm(\'pension-team-postponement\')" ng-if="teamMember.CanUpdatePensionPostponement">\n\t\t\t\tPension postponement\n\t\t\t</a>\n\t\t\t<a data-cy="pension-team-menu-view-profile" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">\n\t\t\t\tView profile\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="dropdown-group">\n\t\t\t<a class="assertive" data-cy="pension-team-menu-remove-from-pension" href="" ng-click="openSlideInForm(\'pension-team-remove\', true)" ng-if="teamMember.CanRemoveFromPension">\n\t\t\t\tRemove from pension\n\t\t\t</a>\n\t\t</div>\n\t</dropdown-menu>\n</div>\n');
$templateCache.put('components/team-card-reversed-tax-codes/team-card-reversed-tax-codes.component.html','<div class="team-card-reversed-tax-codes fadeIn">\n\t<!-- Header (avatar, name) -->\n\t<header class="team-card-reversed-tax-codes_header">\n\t\t<div class="team-card-reversed-tax-codes_persona">\n\t\t\t<avatar class="team-card-reversed-tax-codes_avatar" avatar-initial="{{ $ctrl.teamMember.Forename ? $ctrl.teamMember.Forename[0] : $ctrl.teamMember.Name[0] }}" avatar-size="is-small" avatar-user-id="{{$ctrl.teamMember.UserID}}"></avatar>\n\t\t\t<truncate class="team-card-reversed-tax-codes_title" text="$ctrl.teamMember.Forename + \' \' + $ctrl.teamMember.Surname" truncate-amount="50">\n\t\t\t</truncate>\n\t\t</div>\n\t</header>\n\t<!-- Main card content -->\n\t<main class="team-card-reversed-tax-codes_main">\n\t\t<!-- Tax components list -->\n\t\t<bullet-list bl-theme="is-tertiary is-small is-linked-bullets">\n\t\t\t<bl-items>\n\t\t\t\t<li class="bullet-list_item" ng-repeat="taxCode in $ctrl.taxCodeListItems track by $index">\n\t\t\t\t\t<p class="is-small is-font-greyscale-300" ng-class="{\'is-strong is-font-greyscale-500\': $index === 0 }">\n\t\t\t\t\t\t{{taxCode}}\n\t\t\t\t\t</p>\n\t\t\t\t</li>\n\t\t\t</bl-items>\n\t\t</bullet-list>\n\n\t\t<!-- Effective dates list -->\n\t\t<ul class="team-card-reversed-tax-codes_list">\n\t\t\t<li class="team-card-reversed-tax-codes_list-item" ng-repeat="effectiveDate in $ctrl.effectiveDatesListItems">\n\t\t\t\t<p class="is-small is-font-greyscale-300" ng-class="{\'is-strong is-font-greyscale-500\': $index === 0 }">\n\t\t\t\t\t{{ effectiveDate }}\n\t\t\t\t</p>\n\t\t\t</li>\n\t\t</ul>\n\t</main>\n\n\t<div class="team-card-reversed-tax-codes_actions">\n\t\t<a class="team-card-reversed-tax-codes_action is-primary" href="" ui-sref="team.profile.tax-status({agencyProfileId: $ctrl.teamMember.AgencyProfileID, userId: $ctrl.teamMember.UserID})">\n\t\t\t<i class="icon-right has-margin-right"></i> Go to profile\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/team-member-card/team-member-card.component.html','<div class="team-member-card is-primary">\n\t<avatar avatar-initial="{{$ctrl.teamMember.Forename[0]}}" avatar-size="is-small" avatar-theme="is-primary"></avatar>\n\t<div class="team-member-card_main">\n\t\t<div class="team-member-card_name">{{$ctrl.teamMember.Forename}}&nbsp;{{$ctrl.teamMember.Surname}}</div>\n\t\t<div class="team-member-card_info" ng-if="$ctrl.info" title="{{$ctrl.info}}">{{$ctrl.info}}</div>\n\t</div>\n\t<div class="team-member-card_goto-profile fadeIn"><a href="" ng-click="$ctrl.goToProfile($ctrl.teamMember, $ctrl)">Profile&nbsp;<i class="icon-chevron-right"></i></a></div>\n</div>');
$templateCache.put('components/team-member-carousel/teamMemberCarouselComponent.html','<div class="team-carousel">\n\t<div class="team-carousel__controls">\n\t\t<a class="team-carousel__previous" data-cy="team-carousel-previous-button" href="" ng-click="goToPreviousTeamMember(activeTeamMemberIndex)" ng-show="activeTeamMemberIndex > 0" aria-label="Go to previous team member">\n\t\t\t<i class="icon-back m"></i>\n\t\t</a>\n\t</div>\n\t<div class="team-carousel__item" ng-class="{\'fadeInRight\': carouselState === \'next\', \'fadeOutLeft\': carouselState === \'closeNext\', \'fadeOutRight\': carouselState === \'closePrevious\', \'fadeInLeft\': carouselState === \'previous\', \'fadeIn\': !carouselState}" ng-repeat="teamMember in teamMembers" ng-show="$index === activeTeamMemberIndex">\n\t\t<avatar class="team-carousel__avatar" avatar-initial="{{teamMember.PersonalDetails.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.PersonalDetails.UserID}}">\n\t\t</avatar>\n\t\t<p class="team-carousel__name" data-cy="team-carousel-name">\n\t\t\t{{teamMember.PersonalDetails.Forename}} {{teamMember.PersonalDetails.Surname}}\n\t\t</p>\n\t</div>\n\t<div class="team-carousel__controls">\n\t\t<a class="team-carousel__next" data-cy="team-carousel-next-button" href="" ng-click="goToNextTeamMember(activeTeamMemberIndex)" ng-show="activeTeamMemberIndex < numberOfTeamMembers" aria-label="Go to next team member">\n\t\t\t<i class="icon-right m"></i>\n\t\t</a>\n\t</div>\n</div>\n');
$templateCache.put('components/team-member-state/teamMemberState.html','<div class="team-member-state tag-priority-order" data-cy="team-member-state-tag-priority-order">\n\t<span class="tag greyscale" ng-if="::teamMember.IsArchived">Archived</span>\n\t<span class="tag quarternary" ng-if="::teamMember.IsLeaver">Leaver</span>\n\t<span class="tag quarternary" ng-if="::teamMember.IsLeaving">Is leaving</span>\n\t<span class="tag greyscale" ng-if="::teamMember.IsCISInactive">CIS Inactive</span>\n\t<span class="tag assertive" ng-if="::teamMember.IsOnHold">On Hold</span>\n\t<span class="tag assertive" ng-if="::(teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.Outward)">Excluded</span>\n\t<span class="tag greyscale" ng-if="::(teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.Outward)">Moved Payrolls</span>\n\t<span class="tag assertive" ng-if="::teamMember.IsFurloughed">Furloughed</span>\n\t<span class="tag tertiary inverse" ng-if="::!teamMember.IsComplete">Incomplete</span>\n\t<span class="tag primary highlight-on-hover" ng-if="::teamMember.IsAdvancingFuturePeriods" tooltip tooltip-position="top" tooltip-text="{{teamMember.StateTooltipText}}" tooltip-theme="is-text-aligned-center">\n\t\tAdvancing\n\t</span>\n\t<span class="tag primary highlight-on-hover" ng-if="::teamMember.HasAdvancedFuturePeriods" tooltip tooltip-position="top" tooltip-text="{{teamMember.StateTooltipText}}" tooltip-theme="is-text-aligned-center">\n\t\tAdvanced\n\t</span>\n\t<span class="tag tertiary" ng-if="::teamMember.IsOffPayrollWorker">Off payroll</span>\n\t<span class="tag positive" ng-if="::teamMember.IsInSetupMode">Ready for payroll</span>\n\t<span class="tag tertiary" ng-if="::teamMember.IsCISSubcontractor">CIS</span>\n\t<span class="tag positive" ng-if="::teamMember.IsStarter">New Starter</span>\n\t<span class="tag positive" ng-if="::teamMember.IsRejoiner">Rejoiner</span>\n\t<a href ng-click="stateClick(\'salary-change\')" class="tag tertiary" ng-if="::teamMember.HasSalaryChange" tooltip tooltip-text="Effective date: {{teamMember.SalaryChangeEffectiveDateISO | dateformat}}">Salary Change</a>\n\t<span class="tag plain" ng-if="::teamMember.IsExcludedFromRTI">Omitted from RTI</span>\n\t<span class="tag indifferent-lighter" ng-if="::!teamMember.IsRegistered">Not Registered</span>\n\t<span class="tag primary" ng-if="::teamMember.IsAdmin">Admin</span>\n\t<span class="tag plain" ng-if="::!teamMember.IsInSetupMode">Active on payroll</span>\n</div>\n');
$templateCache.put('components/team-payment-info/team-payment-info.component.html','<overlay-form on-close="onClose()">\n\t<overlay-form-header>\n\t\t<h2><i class="icon-wallet primary gradient overlay-form_header-icon"></i>Pay and tax info for your team</h2>\n\t\t<p>{{\'\' | loremIpsum}}</p>\n\t</overlay-form-header>\n\t<overlay-form-main>\n\n\t\t<!-- Loading -->\n\t\t<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n\t\t<!-- Ready -->\n\t\t<div class="fadeIn" ng-if="$ctrl.componentState === \'ready\'">\n\t\t\t\n\t\t\t<!-- Team Members -->\n\t\t\t<nav class="overlay-form-nav">\n\t\t\t\t<a href="" ng-repeat="teamMember in $ctrl.teamMembers" ng-click="$ctrl.selectActiveTeamMember($ctrl, $index)" class="overlay-form-nav-item">{{teamMember.Forename}} {{teamMember.Surname}}</a>\n\t\t\t</nav>\n\t\t\t\n\t\t\t<div class="overlay-form-main has-nav">\n\n\t\t\t\t<section class="team-info-capture-form slide-in-form">\n\t\t\t\t\t{{$ctrl.activeTeamMember.Forename}} {{$ctrl.activeTeamMember.Surname}}\n\n\t\t\t\t\t<payments-to-date-form ng-if="$ctrl.formOptions.formKey === \'payments-to-date\'" form-options="$ctrl.formOptions"></payments-to-date-form>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</div>\n\t</overlay-form-main>\n</overlay-form>');
$templateCache.put('components/team-pension-info/team-pension-info.component.html','<overlay-form on-close="$ctrl.onClose()">\n\t<overlay-form-header>\n\t\t<h2>Pension info for your team</h2>\n\t\t<p>Set your team members status, group and contribution levels</p>\n\t</overlay-form-header>\n\t<overlay-form-main>\n\n\t\t<!-- Loading -->\n\t\t<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n\t\t<!-- Ready -->\n\t\t<div class="fadeIn" ng-if="$ctrl.componentState === \'ready\'">\n\n\t\t\t<!-- Team Members -->\n\t\t\t<nav class="overlay-form-nav">\n\t\t\t\t<a href="" ng-repeat="teamMember in $ctrl.teamMembers" ng-click="$ctrl.selectActiveTeamMember($ctrl, $index)" class="overlay-form-nav-item">{{teamMember.Forename}} {{teamMember.Surname}}</a>\n\t\t\t</nav>\n\n\t\t\t<div class="overlay-form-main has-nav">\n\t\t\t\t\n\t\t\t\t<!-- Form -->\n\t\t\t\t<section class="team-info-capture-form">\n\t\t\t\t\t{{$ctrl.activeTeamMember.Forename}} {{$ctrl.activeTeamMember.Surname}}\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</div>\n\t</overlay-form-main>\n</overlay-form>');
$templateCache.put('components/team-summary-row/team-summary-row.component.html','<div class="team-summary-row" data-cy="team-member-summary-{{:: $index }}" ng-class="$ctrl.theme">\n\n\t<!-- Main area -->\n\t<div class="team-summary-row_content" ng-if="$ctrl.showContent">\n\n\t\t<!-- Avatar -->\n\t\t<div class="team-summary-row_avatar">\n\t\t\t<avatar avatar-initial="{{ $ctrl.teamMember.Forename ? $ctrl.teamMember.Forename[0] : $ctrl.teamMember.Name[0] }}" avatar-size="is-small" avatar-user-id="{{ $ctrl.teamMember.UserID }}" avatar-theme="{{ $ctrl.theme }}"></avatar>\n\t\t</div>\n\n\t\t<!-- Name -->\n\t\t<div class="team-summary-row_title">\n\t\t\t<h5>{{ $ctrl.teamMember.Forename }} {{ $ctrl.teamMember.Surname }}</h5>\n\t\t</div>\n\n\t\t<!-- Actions -->\n\t\t<div class="team-summary-row_actions" ng-if="$ctrl.hasActions" ng-transclude="actions"></div>\n\t</div>\n\n\t<!-- Footer -->\n\t<div class="team-summary-row_footer fadeIn" ng-if="$ctrl.hasFooter && $ctrl.showFooter" ng-transclude="footer"></div>\n\n</div>\n');
$templateCache.put('components/tooltip-card/tooltip-card.component.html','<div class="tooltip-card is-senary-darker fadeIn" ng-class="$ctrl.tooltip.size" ng-if="$ctrl.tooltip">\n\n\t<a aria-label="Close tooltip" class="tooltip-card_close is-white" data-cy="tooltip-card-close" href="" id="tooltip_{{$ctrl.tooltip.id}}" ng-click="$ctrl.closeTooltipCard($ctrl)">\n\t\t<i class="icon-cross"></i>\n\t</a>\n\n\t<h6 class="tooltip-card_title" data-cy="tooltip-card-title">\n\t\t{{$ctrl.tooltip.description}}\n\t</h6>\n\n\t<div class="tooltip-card_main" data-cy="tooltip-card-main" ng-bind-html="$ctrl.tooltip.tooltipHtml"></div>\n</div>\n');
$templateCache.put('components/tooltip-demo/tooltipDemoComponent.html','<div class="tooltip tooltip--demo {{tooltip.position}} active" ng-if="showTooltip && tdActive && $root.demoTaskComplete.demoShortId !== tooltipId">\n\t<h6 class="tooltip__heading">{{tooltip.heading}}</h6>\n\t<p class="tooltip__text">{{tooltip.copy}}</p>\n\t<button class="tooltip__button tertiary" ng-click="hideTooltip()">Got it</button>\n</div>\n<ng-transclude>\n</ng-transclude>');
$templateCache.put('components/tooltip-plus/tooltipPlusComponent.html','<div class="tooltip tooltip--plus {{tpOptions.position}} active" ng-if="showTooltip">\n\t<a href class="tooltip__close" ng-click="hideTooltip()" aria-label="Close tooltip"><i class="icon-cross"></i></a>\n\t<h6 class="tooltip__heading" ng-if="tpOptions.heading">{{tpOptions.heading}}</h6>\n\t<p class="tooltip__text" ng-if="tpOptions.copy">{{tpOptions.copy}}</p>\n\t<div class="tooltip__footer">\n\t\t<button class="tooltip__button tertiary" ng-click="buttonClick($event)" ng-if="tpOptions.buttonText">{{tpOptions.buttonText}}</button>\n\t\t<span class="tooltip__footnote" ng-if="tpOptions.footnote">{{tpOptions.footnote}}</span>\n\t</div>\n</div>\n');
$templateCache.put('components/truncate/truncate.component.html','<span data-cy="{{$ctrl.id}}" ng-bind-html="$ctrl.truncatedText" title="{{$ctrl.text}}">\n</span>\n');
$templateCache.put('components/user-card/userCardComponent.html','<div class="user-card">\n\t<avatar class="user-card-avatar" avatar-initial="{{user.Forename[0]}}" avatar-size="is-large" avatar-user-id="{{user.UserID}}"></avatar>\n\t<h6 class="user-card-name">{{user.Forename}} {{user.Surname}}</h6>\n\t<p class="user-card-email" ng-if="user.EmailAddress !== undefined">{{user.EmailAddress | checkEmpty:\'No email address\'}}</p>\n\t<p class="user-card-email" ng-if="user.Email !== undefined">{{user.Email | checkEmpty:\'No email address\'}}</p>\n</div>\n\n');
$templateCache.put('components/user-document-card/user-document-card.component.html','<div class="user-document-card fadeIn" data-cy="user-document-{{::$ctrl.documentIndex}}" ng-class="$ctrl.document.theme" ng-mouseleave="$ctrl.hideMenu($ctrl)">\n\n\t<div class="user-document-card_header">\n\t\t<div class="user-document-card_heading">\n\t\t\t<h6 class="user-document-card_type" data-cy="user-document-type">{{$ctrl.document.UserDocumentTypeDescription}}</h6>\n\t\t\t<p class="user-document-card_info" data-cy="user-document-data" ng-if="!$ctrl.document.IsEditable">\n\t\t\t\t{{$ctrl.document.UserDocumentData}}\n\t\t\t</p>\n\t\t\t<p class="user-document-card_info" data-cy="user-document-label" ng-if="$ctrl.document.IsEditable">\n\t\t\t\t{{$ctrl.document.UserDocumentLabel}}\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="user-document-card_actions">\n\n\t\t\t<icon-dot class="user-document-card_action" icon="icon-user" ng-if="$ctrl.document.UserDocumentState === $ctrl.USER_DOCUMENT_STATES.visibleInUserPortal" theme="{{$ctrl.document.theme}} is-alt-2 has-hover" tooltip-text="Available in the employee portal" tooltip-theme="is-text-aligned-center"></icon-dot>\n\n\t\t\t<dropdown-menu class="user-document-card_action user-document-card_menu" menu-icon-size="l" menu-icon="icon-setup" menu-id="user-document-menu" menu-show-chevron="false" menu-show="$ctrl.menuShow" menu-size="l" menu-theme="{{$ctrl.document.UserDocumentTypeID | userDocumentTypeTheme}}">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a href="" data-cy="user-document-menu-download" ng-click="$ctrl.downloadFile($ctrl.document.UserDocumentURL, $ctrl.document.UserDocumentName)">\n\t\t\t\t\t\tDownload\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" data-cy="user-document-menu-settings" ng-click="$ctrl.openUploadDocumentsForm($ctrl, $ctrl.UPLOADS_DOCUMENTS_FORMS.editFile)" ng-if="::$ctrl.document.IsEditable">\n\t\t\t\t\t\tSettings\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="dropdown-group" ng-if="::$ctrl.document.IsEditable">\n\t\t\t\t\t<a class="assertive" data-cy="user-document-menu-delete" href="" ng-click="$ctrl.openUploadDocumentsForm($ctrl, $ctrl.UPLOADS_DOCUMENTS_FORMS.deleteFile)">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\n\t<div class="user-document-card_footer">\n\n\t\t<div class="user-document-card_meta" data-cy="user-document-meta">\n\t\t\t<p class="user-document-card_paragraph is-small" ng-if="!$ctrl.document.IsRegenerated && $ctrl.document.UserDocumentManualDateISO">\n\t\t\t\tUploaded on {{::$ctrl.document.UserDocumentManualDateISO | dateformat}}\n\t\t\t</p>\n\t\t\t<p class="user-document-card_paragraph is-small" ng-if="!$ctrl.document.IsRegenerated && !$ctrl.document.UserDocumentManualDateISO">\n\t\t\t\tCreated on {{::$ctrl.document.UserDocumentCreatedDate}}\n\t\t\t</p>\n\t\t\t<p class="user-document-card_paragraph is-small" ng-if="$ctrl.document.IsRegenerated">\n\t\t\t\tRegenerated on {{::$ctrl.document.RegeneratedDateISO | dateformat}}\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="user-document-card_tag tag highlight-on-hover {{$ctrl.document.UserDocumentTypeID | userDocumentTypeTheme}}" data-cy="user-document-is-regenerated" ng-if="$ctrl.document.IsRegenerated" tooltip tooltip-text="{{$ctrl.document.Creator}} at {{$ctrl.document.RegeneratedDateISO | dateformat: \'timeDate24\'}}">\n\t\t\tREGENERATED\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/user-guide-card/userGuideCardComponent.html','<div class="user-guide-card {{userGuide.theme}}">\n\t<h5 class="user-guide-title">{{userGuide.title}}</h5>\n\t<p class="s user-guide-read-time"><i class="icon-clock"></i> {{userGuide.readTime}}</p>\n\t<a href="" class="user-guide-link" ng-href="{{userGuide.url}}" target="_blank"></a>\n</div>\n');
$templateCache.put('components/user-importer-status-block/userImporterStatusBlockComponent.html','<div>\n\n\n\t<!-- Importer is locked (deleting or importing) -->\n\t<section ng-if="importLocked">\n\n\t\t<!-- Deleting Import -->\n\t\t<section ng-if="payPeriod.DataDeletionState === SUBMISSION_STATES.submitting">\n\t\t\t<action-block ab-show-loading="true">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>We\'re just undoing your import...</h4>\n\t\t\t\t</ab-main>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Importing Data -->\n\t\t<section ng-if="payPeriod.DataImportState === SUBMISSION_STATES.submitting">\n\t\t\t<action-block ab-show-loading="true">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>We\'re importing to your payroll...</h4>\n\t\t\t\t</ab-main>\n\t\t\t</action-block>\n\t\t</section>\n\t</section>\n\n\t<!-- Importer Steps -->\n\t<section ng-switch="payPeriod.WorkerImportState" ng-if="!importLocked">\n\n\t\t<!-- Unsubmitted -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.unsubmitted">\n\t\t\t<action-block>\n\t\t\t\t<ab-main>\n\t\t\t\t\t<div ng-if="showPeriodInfo">\n\t\t\t\t\t\t<p class="action-block_label">Current period</p>\n\t\t\t\t\t\t<h3 class="action-block_period-display">{{payPeriod.PayPeriodDisplay}}</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h4>Import your worker data file for this period</h4>\n\t\t\t\t\t<p>Use the Paycircle Importer to upload, verify and import your worker data for this period.</p>\n\t\t\t\t</ab-main>\n\t\t\t\t<ab-actions>\n\t\t\t\t\t<a ui-sref="user-importer({agencyProfileId: agencyProfileId, from: returnState})" class="button l primary">Import now</a>\n\t\t\t\t</ab-actions>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Failed -->\n\t\t<section pc-switch-when="[SUBMISSION_STATES.failed, SUBMISSION_STATES.haserrors1]">\n\t\t\t<action-block>\n\t\t\t\t<ab-main>\n\t\t\t\t\t<div ng-if="showPeriodInfo">\n\t\t\t\t\t\t<p class="action-block_label">Current period</p>\n\t\t\t\t\t\t<h3 class="action-block_period-display">{{payPeriod.PayPeriodDisplay}}</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h4><i class="counter b primary" ng-class="{\'l\': numberOfIssues > 9}">{{numberOfIssues}}</i>&nbsp;&nbsp;<ng-pluralize count="numberOfIssues" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;to verify with your import</h4>\n\t\t\t\t\t<p>Resume your import so you can review these issues and continue to add your worker data for this period. <a href="" class="underline" ng-click="openCancelImportForm()">Cancel import</a></p>\n\t\t\t\t</ab-main>\n\t\t\t\t<ab-actions>\n\t\t\t\t\t<a ui-sref="user-importer({agencyProfileId: agencyProfileId, from: returnState})" class="button l primary">Review issues</a>\n\t\t\t\t</ab-actions>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Verified -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.verified">\n\t\t\t<action-block>\n\t\t\t\t<ab-main>\n\t\t\t\t\t<div ng-if="showPeriodInfo">\n\t\t\t\t\t\t<p class="action-block_label">Current period</p>\n\t\t\t\t\t\t<h3 class="action-block_period-display">{{payPeriod.PayPeriodDisplay}}</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h4>Your file is now ready to import</h4>\n\t\t\t\t\t<p>Before you start adding your changes, please resume your import to start building payroll. <a href="" class="underline" ng-click="openCancelImportForm()">Cancel import</a></p>\n\t\t\t\t</ab-main>\n\t\t\t\t<ab-actions>\n\t\t\t\t\t<a ui-sref="user-importer({agencyProfileId: agencyProfileId, from: returnState})" class="button l primary">Resume import</a>\n\t\t\t\t</ab-actions>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Uploading File / Processing -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.processing1">\n\t\t\t<action-block ab-show-loading="true">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>Uploading your file...</h4>\n\t\t\t\t\t<p>This should only take a moment and we\'ll let you know if anything needs cleaning up.</p>\n\t\t\t\t</ab-main>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Has serious errors -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.haserrors2">\n\t\t\t<action-block ab-theme="assertive">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4><i class="counter b assertive" ng-class="{\'l\': numberOfIssues > 9}">{{numberOfIssues}}</i>&nbsp;&nbsp;serious&nbsp;<ng-pluralize count="numberOfIssues" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;found with your import</h4>\n\t\t\t\t\t<p>This could cause serious problems with your payroll. Click <em>&lsquo;View import&rsquo;</em> so you can review the&nbsp;<ng-pluralize count="numberOfIssues" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;and contact support.</p>\n\t\t\t\t</ab-main>\n\t\t\t\t<ab-actions>\n\t\t\t\t\t<a ui-sref="user-importer({agencyProfileId: agencyProfileId, from: returnState})" class="button l assertive">View import</a>\n\t\t\t\t</ab-actions>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Importing Worker Data / Processing -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.processing2">\n\t\t\t<action-block ab-show-loading="true">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>Importing worker information...</h4>\n\t\t\t\t\t<p>We\'re importing worker details and setting up any new workers.</p>\n\t\t\t\t</ab-main>\n\t\t\t</action-block>\n\t\t</section>\n\n\t\t<!-- Worker Import Complete, Importing Data -->\n\t\t<section pc-switch-when="SUBMISSION_STATES.finished">\n\n\t\t\t<!-- Importing Shift Information -->\n\t\t\t<action-block ab-show-loading="true" ng-if="payPeriod.DataImportState === SUBMISSION_STATES.submitting">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>Importing shift information...</h4>\n\t\t\t\t\t<p>We\'re importing the workers shifts and setting up payroll.</p>\n\t\t\t\t</ab-main>\n\t\t\t</action-block>\n\n\t\t\t<!-- Data Import Complete -->\n\t\t\t<action-block ng-if="payPeriod.DataImportState === SUBMISSION_STATES.submitted">\n\t\t\t\t<ab-main>\n\t\t\t\t\t<h4>That\'s it, your import is complete!</h4>\n\t\t\t\t\t<p>You\'re all set to start adding changes to payroll</p>\n\t\t\t\t</ab-main>\n\t\t\t\t<ab-actions>\n\t\t\t\t\t<a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId, from: returnState})" class="button l primary">Go to payroll</a>\n\t\t\t\t</ab-actions>\n\t\t\t</action-block>\n\t\t</section>\n\t</section>\n</div>\n');
$templateCache.put('components/validated-input-form-field/validated-input-form-field.component.html','<div class="validated-input-form-field">\n\n\t<div class="validated-input-form-field_container" ng-switch="$ctrl.validationType">\n\t\t<!-- validationType == username -->\n\t\t<input disable-autocomplete="{{$ctrl.disableAutocomplete}}" id="{{$ctrl.inputName}}" name="{{$ctrl.inputName}}" ng-change="$ctrl.checkInput()" ng-model="$ctrl.input" ng-model-options="{ debounce : 300 }" pc-switch-when="$ctrl.INPUT_VALIDATION_TYPES.username" required type="{{$ctrl.inputType}}" username-check username-check-type="$ctrl.usernameCheckType">\n\n\t\t<!-- validationType == password -->\n\t\t<password-input allow-show-password="true" disable-autocomplete="$ctrl.disableAutocomplete" input-id="{{$ctrl.inputName}}" input-name="{{$ctrl.inputName}}" ng-change="$ctrl.checkInput()" ng-model="$ctrl.input" pc-switch-when="$ctrl.INPUT_VALIDATION_TYPES.password"></password-input>\n\n\t\t<!-- Transcluded Standard validation errors. -->\n\t\t<ng-transclude ng-if="$ctrl.hasStandardErrors" ng-transclude-slot="viErrors"></ng-transclude>\n\n\t\t<!-- Input rules validation -->\n\t\t<div class="validated-input-form-field_validation fadeIn" ng-if="$ctrl.inputCheck.results.length">\n\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t{{$ctrl.fieldPrompt}}:\n\t\t\t</p>\n\t\t\t<ul class="validated-input-form-field_check-results">\n\t\t\t\t<li class="validated-input-form-field_check-result" ng-class="{\n\t\t\t\t\t\t\'validated-input-form-field_check-result-passed\': result.passed && !result.init,\n\t\t\t\t\t\t\'validated-input-form-field_check-result-failed\': !result.passed && !result.init,\n\t\t\t\t\t\t\'validated-input-form-field_check-result-init\': result.init\n\t\t\t\t\t}" ng-repeat="result in $ctrl.inputCheck.results">\n\t\t\t\t\t{{result.description}}\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<p class="is-small is-greyscale" ng-if="$ctrl.fieldFootnote">\n\t\t\t\t{{$ctrl.fieldFootnote}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n</div>\n');
$templateCache.put('components/value-card/value-card.component.html','<div class="value-card {{$ctrl.theme}}">\n\t<p class="value-card_title">{{$ctrl.title}}</p>\n\t<p class="value-card_value" ng-if="$ctrl.value !== 0">{{$ctrl.value}}</p>\n\t<p class="value-card_value italic" ng-if="$ctrl.value === 0 && $ctrl.zeroValueText">{{$ctrl.zeroValueText}}</p>\n\t<p class="value-card_value" ng-if="$ctrl.value === 0 && !$ctrl.zeroValueText">0</p>\n</div>\n');
$templateCache.put('components/weekly-calendar/weekly-calendar.component.html','<div class="weekly-calendar">\n\n\t<div class="weekly-calendar_intro" ng-if="vm.isPreview">\n\t\t<p class="s"><span class="strong tertiary">Please note:</span> this is an indicative preview. When you assign this pattern to a team member, and give it an effective date, it may appear slightly differently.</p>\n\t</div>\n\n\t<header class="weekly-calendar_header">\n\t\t<h4 class="weekly-calendar_description">{{vm.calendar.month.description}}</h4>\n\t\t<div class="weekly-calendar_controls">\n\t\t\t<div class="weekly-calendar_controls-toggle">\n\t\t\t\t<a href="" ng-click="vm.decrementMonth(vm.payPeriod, vm.calendar)" aria-label="Go to previous month"><i class="icon-chevron-left"></i></a>\n\t\t\t\t<a href="" ng-click="vm.incrementMonth(vm.payPeriod, vm.calendar)" aria-label="Go to next month"><i class="icon-chevron-right"></i></a>\n\t\t\t</div>\n\t\t</div>\n\t</header>\n\n\t<div class="weekly-calendar_days-container">\n\t\t<div class="weekly-calendar_day {{day.monthNumber === vm.calendar.month.activeMonthNumber ? \'is-active\' : \'is-inactive\'}}" ng-repeat="day in vm.calendar.days">\n\t\t\t<header class="weekly-calendar_day-header" ng-class="{\'is-highlighted\': day.isHighlighted}">\n\t\t\t\t<span class="weekly-calendar_day-header-primary">{{day.dayName}}</span>\n\t\t\t\t<span class="weekly-calendar_day-header-secondary">{{day.dayOfMonth}}</span>\n\t\t\t</header>\n\t\t\t<div class="weekly-calendar_day-main">\n\t\t\t\t<span class="weekly-calendar_day-entry {{entry.theme}}" ng-class="{\'is-active\': entry.isActive}" ng-repeat="entry in day.entries">{{entry.value}}</span>\n\t\t\t\t<span class="weekly-calendar_day-label {{label.theme}}" ng-repeat="label in day.labels">{{label.value}}</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/work-pattern-builder/work-pattern-builder.component.html','<div class="work-pattern-builder" ng-switch="vm.workPattern.Group">\n\n\t<!-- Salaried -->\n\t<section pc-switch-when="WORK_PATTERN_GROUPS.standard">\n\t\t<div class="work-pattern-builder_group dropIn" ng-repeat="week in vm.workPattern.weeks track by $index">\n\t\t\t<div class="work-pattern-builder_cards">\n\t\t\t\t<label class="work-pattern-builder_card is-weekly {{vm.workPattern.theme}}" for="{{\'week-\' + $parent.$index + \'-day-\' + $index}}" ng-class="{\'is-disabled\': day.DayType === WORK_PATTERN_DAY_TYPES.nonWorking}" ng-repeat="day in week track by $index">\n\t\t\t\t\t<header class="work-pattern-builder_card-header">\n\t\t\t\t\t\t<p class="work-pattern-builder_card-label">{{$index | dayByIndex}}</p>\n\t\t\t\t\t\t<p class="work-pattern-builder_card-checkbox">\n\t\t\t\t\t\t\t<input type="checkbox" data-cy="work-pattern-builder-{{\'week-\' + $parent.$index + \'-day-\' + $index}}" name="{{\'week-\' + $parent.$index + \'-day-\' + $index}}" id="{{\'week-\' + $parent.$index + \'-day-\' + $index}}" ng-change="updateDays(vm)" ng-model="day.DayType" ng-false-value="1" ng-true-value="0" checkbox-input checkbox-input-theme="quarternary">\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</header>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n\n\t<!-- Flexi -->\n\t<section pc-switch-when="WORK_PATTERN_GROUPS.nonStandard" ng-switch="vm.workPattern.Basis">\n\n\t\t<!-- Weekly -->\n\t\t<div class="work-pattern-builder" pc-switch-when="WORK_PATTERN_BASIS.weekly">\n\t\t\t<div class="work-pattern-builder_group dropIn" ng-repeat="week in vm.workPattern.weeks track by $index">\n\t\t\t\t<header class="work-pattern-builder_group-header">\n\t\t\t\t\t<p class="work-pattern-builder_group-header-label">Week {{$index + 1}}</p>\n\t\t\t\t\t<a data-cy="work-pattern-builder-delete-week-{{$index}}" href="" class="greyscale work-pattern-builder_header-action" ng-click="deleteWorkPatternWeek(vm, $index)" ng-if="$index > 0"><i class="icon-trash"></i> Delete</a>\n\t\t\t\t</header>\n\t\t\t\t<div class="work-pattern-builder_cards">\n\t\t\t\t\t<div class="work-pattern-builder_card is-weekly has-controls {{vm.workPattern.theme}} popIn" ng-class="{\'is-disabled\': day.Hours === 0, \'is-assertive\': vm.form[\'week-day_\' + dayIndex].$invalid}" ng-repeat="(dayIndex, day) in week track by $index">\n\t\t\t\t\t\t<header class="work-pattern-builder_card-header">\n\t\t\t\t\t\t\t<p class="work-pattern-builder_card-label">{{dayIndex | dayByIndex}}</p>\n\t\t\t\t\t\t\t<input type="number" data-cy="work-pattern-builder-week-day-{{dayIndex}}" name="week-day_{{dayIndex}}" ng-change="updateDays(vm)" ng-model="day.Hours" ng-max="MAX_WORK_PATTERN_HOURS" ng-min="0" class="work-pattern-builder_card-input is-transparent is-spin-button-disabled" ng-required="true">\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="work-pattern-builder_card-controls">\n\t\t\t\t\t\t\t<a data-cy="work-pattern-builder-week-day-{{dayIndex}}-decrement" href="" class="{{day.Hours === 0 ? \'greyscale\' : vm.form[\'week-day_\' + dayIndex].$invalid ? \'assertive\' : vm.workPattern.theme}}" ng-click="decrementValue(day, vm)" aria-label="Decrease value"><i class="icon-minus-alt"></i></a>\n\t\t\t\t\t\t\t<a data-cy="work-pattern-builder-week-day-{{dayIndex}}-increment" href="" class="{{day.Hours === 0 ? \'greyscale\' : vm.form[\'week-day_\' + dayIndex].$invalid ? \'assertive\' : vm.workPattern.theme}}" ng-click="incrementValue(day, vm)" aria-label="Increase label"><i class="icon-plus"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<a data-cy="work-pattern-builder-add-week" href="" ng-click="addWorkPatternWeek(vm)" ng-if="vm.workPattern.weeks.length < MAX_WORK_PATTERN_WEEKS" class="button m white work-pattern-builder_action"><i class="icon-add m"></i> Add a week</a>\n\t\t</div>\n\n\t\t<!-- Daily -->\n\t\t<div class="work-pattern-builder" pc-switch-when="WORK_PATTERN_BASIS.daily">\n\t\t\t<div class="work-pattern-builder_cards">\n\t\t\t\t<div class="work-pattern-builder_card is-daily has-controls {{vm.workPattern.theme}} popIn" ng-class="{\'is-disabled\': day.Hours === 0, \'is-assertive\': vm.form[\'week-day_\' + dayIndex].$invalid}" ng-repeat="(dayIndex, day) in vm.workPattern.Days track by $index">\n\t\t\t\t\t<header class="work-pattern-builder_card-header">\n\t\t\t\t\t\t<p class="work-pattern-builder_card-label">Day {{dayIndex + 1}}</p>\n\t\t\t\t\t\t<a data-cy="work-pattern-builder-delete-day-{{dayIndex}}" href="" class="{{day.Hours === 0 ? \'greyscale\' : vm.form[\'week-day_\' + dayIndex].$invalid ? \'assertive\' : vm.workPattern.theme}} work-pattern-builder_card-action" ng-click="deleteWorkPatternDay(vm, $index)" ng-if="$index > 0"><i class="icon-trash"></i></a>\n\t\t\t\t\t\t<input type="number" data-cy="work-pattern-builder-week-day-{{dayIndex}}" name="week-day_{{dayIndex}}" ng-change="updateDays(vm)" ng-model="day.Hours" ng-max="MAX_WORK_PATTERN_HOURS" ng-min="0" class="work-pattern-builder_card-input is-transparent is-spin-button-disabled" ng-required="true">\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="work-pattern-builder_card-controls">\n\t\t\t\t\t\t<a data-cy="work-pattern-builder-week-day-{{dayIndex}}-decrement" href="" class="{{day.Hours === 0 ? \'greyscale\' : vm.form[\'week-day_\' + dayIndex].$invalid ? \'assertive\' : vm.workPattern.theme}}" ng-click="decrementValue(day, vm)" aria-label="Decrease value"><i class="icon-minus-alt"></i></a>\n\t\t\t\t\t\t<a data-cy="work-pattern-builder-week-day-{{dayIndex}}-increment" href="" class="{{day.Hours === 0 ? \'greyscale\' : vm.form[\'week-day_\' + dayIndex].$invalid ? \'assertive\' : vm.workPattern.theme}}" ng-click="incrementValue(day, vm)" aria-label="Increase label"><i class="icon-plus"></i></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div><!--\n\t\t\t--><a href="" data-cy="work-pattern-builder-add-day" class="work-pattern-builder_card is-daily is-action-card" ng-click="addWorkPatternDay(vm)" ng-if="vm.workPattern.Days.length < MAX_WORK_PATTERN_DAYS">\n\t\t\t\t\t<i class="icon-add m"></i>\n\t\t\t\t\t<span>Add day</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t\t<p class="error" ng-show="!hasValidHours(vm)">Working day hours cannot be empty or a negative value.</p>\n\t</section>\n</div>\n');
$templateCache.put('components/work-pattern-card/work-pattern-card.component.html','<div class="work-pattern-card" ng-class="vm.workPattern.theme">\n\t\n\t<header class="work-pattern-card-header">\n\t\t<h5 class="work-pattern-card-title">{{vm.workPattern.Description}}</h5>\n\t\t<dropdown-menu class="work-pattern-card-menu" menu-size="l" menu-show-chevron="false" menu-icon="icon-setup" menu-theme="{{vm.workPattern.theme}}">\n\t\t\t<div class="dropdown-group">\n\t\t\t\t<a href="" ng-click="openWorkPatternForm(vm.workPattern)">Edit</a>\n\t\t\t\t<a href="" ng-click="openWorkPatternTeamMembersForm(vm.workPattern)">View team members</a>\n\t\t\t</div>\n\t\t\t<div class="dropdown-group" ng-if="vm.workPattern.TeamMemberCount === 0 && vm.canDelete">\n\t\t\t\t<a href="" ng-click="openWorkPatternDeleteForm(vm.workPattern)" class="assertive">Delete</a>\n\t\t\t</div>\n\t\t</dropdown-menu>\n\t</header>\n\n\t<div class="work-pattern-card-main">\n\n\t\t<!-- Stats -->\n\t\t<div class="work-pattern-card-stats">\n\n\t\t\t<!-- Working Hours -->\n\t\t\t<div class="work-pattern-card-stat">\n\t\t\t\t<i class="icon-clock m {{vm.workPattern.theme}}"></i>\n\t\t\t\t<span class="work-pattern-card-stat-value">{{vm.workPattern.TotalHours | decimalise}}</span>\n\t\t\t\t<p class="work-pattern-card-stat-label">{{vm.workPattern.Group === WORK_PATTERN_GROUPS.standard ? \'Total work hours per week\' : \'Working hours\'}}</p>\n\t\t\t</div>\n\n\t\t\t<!-- Working Days -->\n\t\t\t<div class="work-pattern-card-stat">\n\t\t\t\t<i class="icon-calendar m {{vm.workPattern.theme}}"></i>\n\t\t\t\t<span class="work-pattern-card-stat-value">{{vm.workPattern.WorkingDays}}</span>\n\t\t\t\t<p class="work-pattern-card-stat-label">Working days</p>\n\t\t\t</div>\n\n\t\t\t<!-- Non-working days -->\n\t\t\t<div class="work-pattern-card-stat">\n\t\t\t\t<i class="icon-menu-close m {{vm.workPattern.theme}}"></i>\n\t\t\t\t<span class="work-pattern-card-stat-value">{{vm.workPattern.NonWorkingDays}}</span>\n\t\t\t\t<p class="work-pattern-card-stat-label">Non-working days</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Schedule -->\n\t\t<aside class="work-pattern-card-aside" ng-switch="vm.workPattern.Group">\n\n\t\t\t<!-- Weeks -->\n\t\t\t<div class="work-pattern-schedule {{vm.workPattern.theme}}">\n\n\t\t\t\t<div class="work-pattern-schedule-items" ng-if="vm.workPattern.Basis !== WORK_PATTERN_BASIS.daily">\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">&nbsp;</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">M</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">T</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">W</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">T</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">F</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">S</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">S</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Working Days -->\n\t\t\t\t<div class="work-pattern-schedule-items" pc-switch-when="WORK_PATTERN_GROUPS.standard">\n\t\t\t\t\t<div class="work-pattern-schedule-item-label">&nbsp;</div>\n\t\t\t\t\t<div class="work-pattern-schedule-item" ng-class="{\'is-disabled\': day.DayType === WORK_PATTERN_DAY_TYPES.nonWorking}" ng-repeat="day in vm.workPattern.Days track by $index">{{day.DayType | workPatternDayType}}</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Hours -->\n\t\t\t\t<div class="work-pattern-schedule-items" ng-repeat="week in vm.workPattern.weeks" pc-switch-when="WORK_PATTERN_GROUPS.nonStandard">\n\t\t\t\t\t<div class="work-pattern-schedule-item-label"><span ng-if="vm.workPattern.Basis !== WORK_PATTERN_BASIS.daily">Wk {{$index + 1}}</span><span ng-if="vm.workPattern.Basis === WORK_PATTERN_BASIS.daily">&nbsp;</span></div>\n\t\t\t\t\t<div class="work-pattern-schedule-item" ng-class="{\'is-disabled\': day.Hours === 0}" ng-repeat="day in week track by $index">{{day.Hours | decimalise}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</aside>\n\t</div>\n\n\t<!-- Used by -->\n\t<div class="work-pattern-card-associates">\n\t\t<p class="s"><i class="icon-team-alt l {{vm.workPattern.theme}}"></i>&nbsp;&nbsp;Used by <a href="" class="underline {{vm.workPattern.theme}}" ng-click="openWorkPatternTeamMembersForm(vm.workPattern)" ng-if="vm.workPattern.TeamMemberCount > 0"><ng-pluralize count="vm.workPattern.TeamMemberCount" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></a><span ng-if="vm.workPattern.TeamMemberCount === 0"><ng-pluralize count="vm.workPattern.TeamMemberCount" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></span></p>\n\t</div>\n</div>\n');
$templateCache.put('components/work-pattern-overview/work-pattern-overview.component.html','<div class="work-pattern-overview {{$ctrl.workPattern.theme}}">\n\t<div class="work-pattern-overview_details">\n\t\t<h6>{{$ctrl.index === 0 ? \'Current work pattern:\' : \'Work pattern change:\'}}</h6>\n\t\t<p class="work-pattern-overview_description"><strong>{{$ctrl.workPattern.IsCustomWorkPattern ? \'Custom\' : $ctrl.workPattern.Description}}</strong><span ng-if="$ctrl.workPattern.EffectiveDateISO !== \'\'">&nbsp;(effective {{$ctrl.workPattern.EffectiveDateISO | dateformat}})</span></p>\n\t\t<div class="work-pattern-overview_details-actions" ng-transclude="actions" ng-if="$ctrl.hasActions"></div>\n\t</div>\n\n\t<div class="work-pattern-overview_stats">\n\n\t\t<!-- Working Hours -->\n\t\t<div class="work-pattern-overview_stat">\n\t\t\t<i class="icon-clock l {{$ctrl.workPattern.theme}}"></i>\n\t\t\t<span class="work-pattern-overview_stat-value">{{$ctrl.workPattern.TotalHours | decimalise}}</span>\n\t\t\t<p class="work-pattern-overview_stat-label">{{$ctrl.workPattern.Group === $ctrl.WORK_PATTERN_GROUPS.standard ? \'Total work hours per week\' : \'Working hours\'}}</p>\n\t\t</div>\n\n\t\t<!-- Working Days -->\n\t\t<div class="work-pattern-overview_stat">\n\t\t\t<i class="icon-calendar l {{$ctrl.workPattern.theme}}"></i>\n\t\t\t<span class="work-pattern-overview_stat-value">{{$ctrl.workPattern.WorkingDays}}</span>\n\t\t\t<p class="work-pattern-overview_stat-label">Working days</p>\n\t\t</div>\n\n\t\t<!-- Non-working days -->\n\t\t<div class="work-pattern-overview_stat">\n\t\t\t<i class="icon-menu-close l {{$ctrl.workPattern.theme}}"></i>\n\t\t\t<span class="work-pattern-overview_stat-value">{{$ctrl.workPattern.NonWorkingDays}}</span>\n\t\t\t<p class="work-pattern-overview_stat-label">Non-working days</p>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('components/worker-mail/workerMailComponent.html','<span class="worker-mail-component">\n\n\t<!-- No mails -->\n\t<em ng-if="mailObject.length === 0">{{noMailsText}}</em>\n\n\t<!-- One mail -->\n\t<a target="_blank" ui-sref="sent-mail({agencyProfileId: agencyProfileId, maillogkey: mailObject[0].MailLogKey})" ng-if="mailObject.length === 1">\n\t\t<i ng-class="{\'icon-tick positive\': !mailObject[0].Bounced, \'icon-cross assertive\': mailObject[0].MailBounced}"></i>\n\t\t{{mailObject[0].MailSentDateISO | date:\'dd/MM/yyyy\'}}\n\t\t<em ng-if="mailObject[0].MailBounced">&nbsp;Bounced</em>\n\t</a>\n\n\t<!-- More than one mail -->\n\t<div class="dropdown-menu right" ng-if="mailObject.length > 1">\n\n\t\t<a href="" target="_blank" ng-click="toggleDropdown();" ng-if="mailObject.length > 1">\n\t\t\t{{mailObject.length}} mails sent <i class="icon-chevron-down"></i>\n\t\t</a>\n\n\t\t<div class="dropdown-menu_wrapper" ng-show="showDropdown">\n\t\t\t<div class="dropdown">\n\t\t\t\t<a target="_blank" ui-sref="sent-mail({agencyProfileId: agencyProfileId, maillogkey: mail.MailLogKey})" ng-repeat="mail in mailObject">\n\t\t\t\t\t<i ng-class="{\'icon-tick positive\': !mail.MailBounced, \'icon-cross assertive\': mail.MailBounced}"></i>\n\t\t\t\t\t{{mail.MailSentDateISO | date:\'dd/MM/yyyy\'}}\n\t\t\t\t\t<!--<em ng-if="mail.Bounced">&nbsp;Bounced</em>-->\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</span>\n');
$templateCache.put('components/workflow-activity-log/workflowActivityLogComponent.html','<!-- Outer div is required to ensure scope variables are available in the nested ng-repeat -->\n<div>\n\t<div class="workflow-activity-log" ng-repeat="logEntry in logList.filtered = (logList.all | filter : searchBarOptions.search.string)" wide-view="true">\n\t\t<div class="workflow-activity-log_date-group">\n\t\t\t<div class="workflow-activity-log_date-group-header" ng-if="logEntry.newGroup">\n\t\t\t\t<div class="workflow-activity-log_divider"></div>\n\t\t\t\t<div class="workflow-activity-log_date-header tag primary">{{logEntry.LogDateISO | dateformat: \'long\'}}</div>\n\t\t\t\t<div class="workflow-activity-log_divider"></div>\n\t\t\t</div>\n\t\t\t<div class="workflow-activity-log_entry" ng-class="{ \'workflow-activity-log_entry-last-of-group\' : logEntry.lastOfGroup }">\n\t\t\t\t<p class="primary strong m"><a ui-sref="payroll.current-period.team({agencyProfileId: logEntry.TargetID})">{{logEntry.CompanyName}}</a></p>\n\t\t\t\t<div ng-class="{ \'workflow-activity-log_wide\': wideView }">\n\t\t\t\t\t<div class="workflow-activity-log_info">\n\t\t\t\t\t\t<icon-dot size="m" theme="{{logEntry.logMetadata.theme}}" icon="icon-{{logEntry.logMetadata.icon}}" is-light="true"></icon-dot>&nbsp;&nbsp;\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t<span ng-bind-html="logEntry.ValueFrom | highlight:workflowActions:\'strong\'"></span>\n\t\t\t\t\t\t\t<span ng-if="logEntry.ValueFrom && logEntry.ValueTo">&nbsp;<i class="icon-arrow-right m primary"></i>&nbsp;</span>\n\t\t\t\t\t\t\t<span ng-bind-html="logEntry.ValueTo | highlight:workflowActions:\'strong\'"></span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="workflow-activity-log_actioner-info">{{logEntry.ActionActor}} at {{logEntry.LogDateISO | datetimeformat: \'readable\'}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('components/workflow-deadline-entry/workflow-deadline-entry.component.html','<div class="workflow-deadline-entry">\n\t<div class="form-field">\n\n\t\t<div class="workflow-deadline-entry_header">\n\t\t\t<label for="step{{$ctrl.entryIndex}}" class="workflow-deadline-entry_heading">\n\t\t\t\t<i class="icon-clock is-primary"></i>\n\t\t\t\t<span class="is-primary">Step {{$ctrl.entry.Number}}:</span>&nbsp;{{$ctrl.entry.Title}}\n\t\t\t</label>\n\n\t\t\t<div class="workflow-deadline-entry_warning" ng-class="{\n\t\t\t\t\t\'is-assertive\': !$ctrl.entry.isValid\n\t\t\t\t}" ng-if="$ctrl.entryIndex > 0">\n\t\t\t\t<i ng-class="{\n\t\t\t\t\t\t\'icon-information\': $ctrl.entry.isValid,\n\t\t\t\t\t\t\'icon-warning\': !$ctrl.entry.isValid\n\t\t\t\t\t}" class="workflow-deadline-entry_icon"></i>&nbsp;\n\t\t\t\tMust be after step {{$ctrl.entryIndex}}\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-main workflow-deadline-entry_fields">\n\t\t\t<label for="step{{$ctrl.entryIndex}}" class="form-field-label is-inline required">\n\t\t\t\tDue at:\n\t\t\t</label>\n\n\t\t\t<!-- Time -->\n\t\t\t<div class="workflow-deadline-entry_field">\n\t\t\t\t<select class="inline" ng-change="$ctrl.onDueDateChange()" ng-model="$ctrl.entry.DueTimeHour" ng-options="option.hour as option.hourDisplay for option in $ctrl.hours"></select>\n\t\t\t\t&nbsp;&nbsp;:&nbsp;&nbsp;\n\t\t\t\t<select class="inline" ng-change="$ctrl.onDueDateChange()" ng-model="$ctrl.entry.DueTimeMinutes" ng-options="option.minute as option.minuteDisplay for option in $ctrl.minutes"></select>\n\t\t\t</div>\n\n\t\t\t<!-- Date -->\n\t\t\t<div class="workflow-deadline-entry_field">\n\t\t\t\t<number-selector-field field-name="step{{$ctrl.entryIndex}}" min="0" ng-model-options="{ debounce:400 }" ng-model="$ctrl.entry.DueDaysConstant" nsf-on-change="$ctrl.onDueDateChange()" step="1"></number-selector-field>\n\t\t\t\t&nbsp;&nbsp;\n\t\t\t\tdays\n\t\t\t</div>\n\n\t\t\t<!-- Offset Type -->\n\t\t\t<div class="workflow-deadline-entry_field">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isAfterPayDateFalse{{$ctrl.entryIndex}}" name="isAfterPayDate{{$ctrl.entryIndex}}" ng-change="$ctrl.onOffsetTypeChange()" ng-disabled="$ctrl.isOffsetTypeDisabled()" ng-model="$ctrl.entry.IsAfterPayDay" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isAfterPayDateFalse{{$ctrl.entryIndex}}">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">before pay date</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isAfterPayDateTrue{{$ctrl.entryIndex}}" name="isAfterPayDate{{$ctrl.entryIndex}}" ng-change="$ctrl.onOffsetTypeChange()" ng-disabled="$ctrl.isOffsetTypeDisabled()" ng-model="$ctrl.entry.IsAfterPayDay" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isAfterPayDateTrue{{$ctrl.entryIndex}}">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">after pay date</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Block form if invalid -->\n\t\t<div ng-if="!$ctrl.entry.isValid">\n\t\t\t<input id="notAllowed{{$ctrl.entryIndex}}" name="notAllowed{{$ctrl.entryIndex}}" ng-model="$ctrl.entry.doesNotExist" required type="hidden" value="">\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/workflow-status-block/workflow-status-block.component.html','<div class="workflow-status-block">\n\t\n\t<notification-block icon="workflow-alt" icon-theme="{{$ctrl.theme}}">\n\t\t<nb-details>\n\t\t\t<h6>\n\t\t\t\tWorkflow: {{$ctrl.templateEntryCurrent.Title}}\n\t\t\t</h6>\n\t\t\t<p class="is-small">\n\t\t\t\tAssigned to: {{$ctrl.templateEntryCurrent.Actioner}}\n\t\t\t</p>\n\t\t</nb-details>\n\t\t<nb-actions>\n\t\t\t<div class="tag is-large" ng-class="$ctrl.theme">\n\t\t\t\t<i class="icon-{{::$ctrl.icon}}"></i>\n\t\t\t\t{{::$ctrl.tagLabel}}:&nbsp;{{$ctrl.templateEntryCurrent.DueDateISO | dateformat:\'dateTimeAlt\'}}\n\t\t\t</div>\n\t\t</nb-actions>\n\t</notification-block>\n</div>\n');
$templateCache.put('components/workflow-task-card/workflow-task-card.component.html','<div id="workflow-task-card-{{$ctrl.index}}" class="workflow-task-card fadeIn" ng-class="$ctrl.cardTheme" ng-mouseleave="$ctrl.hideMenu()">\n\t<div class="workflow-task-card_header">\n\t\t<div class="checkbox-field workflow-task-card_checkbox">\n\t\t\t<input aria-label="Mark task as complete" type="checkbox" id="{{$ctrl.task.WorkflowTemplateEntryID}}" ng-model="$ctrl.task.isSelected" ng-change="$ctrl.selectionChanged()" ng-disabled="$ctrl.taskIsComplete($ctrl.task)">\n\t\t\t<label class="checkbox-field-tickbox" for="{{$ctrl.task.WorkflowTemplateEntryID}}"></label>\n\t\t</div>\n\t\t<div class="workflow-task-card_company"><a ui-sref="payroll.current-period.team({agencyProfileId: $ctrl.task.AgencyProfileID})">{{$ctrl.task.CompanyName}}</a></div>\n\t\t<div class="workflow-task-card_period">{{$ctrl.task.CurrentPeriod}}</div>\n\t\t<div class="workflow-task-card_menu">\n\t\t\t<dropdown-menu id="workflow-task-card-{{$ctrl.index}}-action-menu" menu-icon="workflow-task-card_cog icon-setup" menu-show-chevron="false" menu-show="$ctrl.options.showMenu">\n\t\t\t\t<div class="dropdown-group" ng-if="!$ctrl.task.IsComplete">\n\t\t\t\t\t<a href="" id="workflow-task-card-{{$ctrl.index}}-action-reassign" ng-click="$ctrl.openReassignWorkflowTaskForm($ctrl.task)">Re-assign</a>\n\t\t\t\t\t<a id="workflow-task-card-{{$ctrl.index}}-action-goto-company" ui-sref="company-dashboard({agencyProfileId: $ctrl.task.AgencyProfileID})" title="Go to company">Go to company</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</div>\n\t<div class="workflow-task-card_footer">\n\t\t<i class="workflow-task-card_icon icon-workflow-alt"></i>\n\t\t<div class="workflow-task-card_title">&nbsp;&nbsp;{{$ctrl.task.Title}}&nbsp;</div>\n\t\t<span class="tag is-indifferent" ng-if="$ctrl.task.IsPayrollQueried">QUERIED</span>\n\t\t<span class="tag is-assertive inverse" ng-if="$ctrl.task.IsPayrollFailed">FAILED</span>\n\t\t<div class="tag workflow-task-card_status" ng-class="$ctrl.cardTheme">\n\t\t\t<div ng-if="!$ctrl.taskIsComplete($ctrl.task)"><i class="icon-clock s"></i>&nbsp;<span class="strong">{{$ctrl.task.IsOverdue ? \'OVERDUE\' : \'DUE\'}}:</span>\n\t\t\t\t&nbsp;{{$ctrl.task.DueDateISO | dateformat:\'dateTimeAlt\'}}</div>\n\t\t\t<span class="strong" ng-if="$ctrl.taskIsComplete($ctrl.task)">COMPLETE</span>\n\t\t</div>\n\t\t<div class="workflow-task-card_team-member" ng-if="$ctrl.showTeamMember">\n\t\t\t<div class="workflow-task-card_actioner"><div class="workflow-task-card_actioner-name">{{$ctrl.task.Actioner}}&nbsp;&nbsp;</div><avatar class="workflow-tasks-list__avatar" avatar-size="is-tiny" avatar-initial="{{$ctrl.task.Actioner[0]}}">{{$ctrl.task.Actioner}}</avatar></div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/workflow-task-summary-card/workflow-task-summary-card.component.html','<div class="workflow-task-summary-card" ng-class="[\n\t\tcardStyle,\n\t\t{\n\t\t\t\'inverse\': totalCount === 0,\n\t\t\t\'is-disabled\': totalCount === 0,\n\t\t\t\'is-compact\': isCompact\n\t\t}\n\t]">\n\t<a class="workflow-task-summary-card__overlay" ui-sref="{{targetState}}({ applyFilter: filterKey })" ng-if="targetState && totalCount > 0"></a>\n\t<div class="workflow-task-summary-card__header">\n\t\t<div class="workflow-task-summary-card__total-count"><i ng-class="{ \'icon-clock\' : !icon, \'{{icon}}\' : icon }"></i><span ng-class="{ \'workflow-task-summary-card__total-count-nonzero\': totalCount > 0 }">&nbsp;{{totalCount}}</span></div>\n\t\t<div class="workflow-task-summary-card__chevron" ng-if="totalCount > 0"><i class="icon-chevron-right"></i></div>\n\t</div>\n\t<div class="workflow-task-summary-card__status">{{status}}</div>\n\t<div class="workflow-task-summary-card__counts" ng-if="showCounts()">\n\t\t<div class="workflow-task-summary-card__count" ng-class="{ \'is-disabled\': teamCount === 0 }">\n\t\t\t<a class="workflow-task-summary-card__overlay" ui-sref="{{targetState}}({ applyFilter: \'{{filterKey}},{{teamMemberKeyList}}\' })" ng-if="targetState && teamCount > 0"></a>\n\t\t\t{{teamCount}} with team\n\t\t</div>\n\t\t<div class="workflow-task-summary-card__count" ng-class="{ \'is-disabled\': clientCount === 0 }">\n\t\t\t<a class="workflow-task-summary-card__overlay" ui-sref="{{targetState}}({ applyFilter: \'{{filterKey}},workflow-tasks-team-member-client\' })" ng-if="targetState && clientCount > 0"></a>\n\t\t\t{{clientCount}} with client\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/workflow-tasks-list/workflow-tasks-list.component.html','\n<div class="workflow-tasks-list__task" ng-repeat="task in workflowTasks">\n\t<div class="workflow-tasks-list__task-left">\n\t\t<p class="primary strong m"><a ui-sref="payroll.current-period.team({agencyProfileId: task.AgencyProfileID})">{{task.CompanyName}}</a></p>\n\t\t<p class="workflow-tasks-list__current-period">{{task.CurrentPeriod}}</p>\n\t\t<p class="workflow-tasks-list__step"><i class="primary icon-workflow-alt"></i>&nbsp;&nbsp;{{task.Title}}</p>\n\t</div>\n\t<div class="workflow-tasks-list__task-right">\n\t\t<div class="workflow-tasks-list__actioner"><div class="workflow-tasks-list__actioner-name">{{task.Actioner}}&nbsp;&nbsp;</div><avatar class="workflow-tasks-list__avatar" avatar-size="is-small" avatar-initial="{{task.Actioner[0]}}">{{task.Actioner}}</avatar></div>\n\t\t<div class="workflow-tasks-list__status">\n\t\t\t<div class="tag" ng-class="{ \'is-assertive\': task.IsOverdue, \'is-secondary\': !task.IsOverdue }">\n\t\t\t\t<i class="icon-clock s"></i>&nbsp;<span class="strong">{{task.IsOverdue ? \'OVERDUE\' : \'DUE\'}}:</span>&nbsp;{{task.DueDateISO | dateformat:\'dateTimeAlt\'}}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('components/workflow-timeline/workflow-timeline.component.html','<div class="workflow-timeline">\n\n\t<div class="workflow-timeline_layout">\n\n\t\t<div class="workflow-timeline_steps">\n\n\t\t\t<workflow-timeline-entry entry="templateEntry" ng-repeat="templateEntry in $ctrl.entries.beforePayDate" on-update="$ctrl.onUpdate" workflow-template="$ctrl.workflowTemplate"></workflow-timeline-entry>\n\n\t\t\t<div class="workflow-timeline_label" ng-if="$ctrl.payPeriod.PayDateISO">\n\n\t\t\t\t<span class="workflow-timeline_badge">\n\t\t\t\t\t<icon-dot icon="icon-calendar" theme="is-secondary"></icon-dot>\n\t\t\t\t</span>\n\n\t\t\t\t<p class="workflow-timeline_label-title">Next pay date - {{$ctrl.payPeriod.PayDateISO | dateformat}}</p>\n\t\t\t</div>\n\n\t\t\t<workflow-timeline-entry entry="templateEntry" ng-repeat="templateEntry in $ctrl.entries.afterPayDate" on-update="$ctrl.onUpdate" workflow-template="$ctrl.workflowTemplate"></workflow-timeline-entry>\n\n\t\t</div>\n\n\t</div>\n\n\t<div class="workflow-timeline_footer" ng-if="$ctrl.workflowTemplate.OffsetType !== $ctrl.WORKFLOW_OFFSET_TYPES.none" ng-switch="$ctrl.workflowTemplate.OffsetType">\n\t\t<p class="is-small">\n\t\t\t<i class="icon-clock n is-primary"></i>&nbsp;&nbsp;&nbsp;\n\n\t\t\t<span pc-switch-when="$ctrl.WORKFLOW_OFFSET_TYPES.lastWorkingDay">When due dates fall on a weekend or bank holiday they will be moved to the last working prior. </span>\n\t\t\t<span pc-switch-when="$ctrl.WORKFLOW_OFFSET_TYPES.nextWorkingDay">When due dates fall on a weekend or bank holiday they will be moved to the next working day. </span>\n\n\t\t\t<a href="" class="underline" ng-click="$ctrl.openWorkflowDeadlinesForm($ctrl.workflowTemplate)">Change</a>\n\t\t</p>\n\t</div>\n</div>\n');
$templateCache.put('components/workflow-timeline-entry/workflow-timeline-entry.component.html','<div class="workflow-timeline-entry" ng-class="$ctrl.entry.theme">\n\n\t<div class="workflow-timeline-entry_arrow"></div>\n\n\t<span class="workflow-timeline_badge">\n\t\t<icon-dot icon="{{$ctrl.entry.icon}}" theme="{{$ctrl.entry.theme}}"></icon-dot>\n\t</span>\n\n\t<header class="workflow-timeline-entry_header">\n\t\t<h5 class="workflow-timeline-entry_title">{{$ctrl.entry.Title}}</h5>\n\t</header>\n\n\t<!-- Description -->\n\t<div class="workflow-timeline-entry_description" ng-if="!$ctrl.entry.hasActioner && !$ctrl.entry.HasNote">\n\t\t<p>{{$ctrl.entry.Description}}</p>\n\t</div>\n\n\t<!-- Welcome note -->\n\t<div class="workflow-timeline-entry_note" ng-if="$ctrl.entry.HasNote">\n\t\t<p class="workflow-timeline-entry_note-subtitle" ng-class="[\n\t\t\t\t$ctrl.entry.theme,\n\t\t\t\t\'has-note\'\n\t\t\t]">\n\t\t\t<i class="icon-chat"></i>&nbsp;&nbsp;\n\t\t\tWelcome note:\n\t\t</p>\n\t\t<p class="workflow-timeline-entry_note-detail">\n\t\t\t{{$ctrl.entry.Note | emojify | limitTo:$ctrl.NOTE_LENGTH_LIMIT}}{{$ctrl.NOTE_LENGTH_LIMIT && $ctrl.entry.Note.length > $ctrl.NOTE_LENGTH_LIMIT ? \'...\' : \'\'}}&nbsp;\n\t\t\t<a href="" class="primary-light" ng-click="$ctrl.extendNoteLengthLimit()" ng-if="$ctrl.NOTE_LENGTH_LIMIT && $ctrl.entry.Note.length > $ctrl.NOTE_LENGTH_LIMIT">\n\t\t\t\tview more\n\t\t\t</a>\n\t\t</p>\n\t</div>\n\n\t<!-- Welcome note not added (first step only) -->\n\t<div class="workflow-timeline-entry_note" ng-if="!$ctrl.entry.HasNote && $ctrl.entryIndex === 0">\n\t\t<p class="workflow-timeline-entry_note-subtitle" ng-class="[\n\t\t\t\t$ctrl.entry.theme,\n\t\t\t\t\'is-italicised\'\n\t\t\t]">\n\t\t\t<i class="icon-chat"></i>&nbsp;&nbsp;Welcome note not added\n\t\t</p>\n\t</div>\n\n\t<footer class="workflow-timeline-entry_footer">\n\n\t\t<div class="workflow-timeline-entry_footer-actions">\n\n\t\t\t<!-- Collaborator -->\n\t\t\t<div class="workflow-timeline-entry_footer-action">\n\t\t\t\t<i class="icon-user workflow-timeline-entry_footer-action-icon"></i>\n\n\t\t\t\t<a href="" ng-click="$ctrl.openWorkflowCollaboratorForm()" class="s underline workflow-timeline-entry_footer-action-link">\n\t\t\t\t\t<span ng-if="$ctrl.entry.hasActioner">Collaborator: <name full-name="$ctrl.entry.Actioner" name-type="full-name"></name></span>\n\t\t\t\t\t<span ng-if="!$ctrl.entry.hasActioner">Edit collaborator</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- Deadline -->\n\t\t\t<div class="workflow-timeline-entry_footer-action">\n\t\t\t\t<i class="icon-clock workflow-timeline-entry_footer-action-icon"></i>\n\t\t\t\t<a href="" ng-click="$ctrl.openWorkflowDeadlinesForm()" class="s underline workflow-timeline-entry_footer-action-link">\n\t\t\t\t\t<span ng-if="$ctrl.entry.dueDateValid && $ctrl.entry.DueDaysConstant > 0 && $ctrl.workflowTemplate.CalendarType === $ctrl.WORKFLOW_CALENDAR_TYPES.workingDays">\n\t\t\t\t\t\tDue:&nbsp;<ng-pluralize count="$ctrl.entry.DueDaysConstant" when="{\'1\': \'1 working day\', \'other\': \'{} working days\'}"></ng-pluralize>&nbsp;{{$ctrl.entry.IsAfterPayDay ? \'after\' : \'before\' }} pay date at {{$ctrl.entry.DueTimeHour}}:{{$ctrl.entry.DueTimeMinutes | fixedLength:2}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="$ctrl.entry.dueDateValid && $ctrl.entry.DueDaysConstant > 0 && $ctrl.workflowTemplate.CalendarType !== $ctrl.WORKFLOW_CALENDAR_TYPES.workingDays">\n\t\t\t\t\t\tDue:&nbsp;<ng-pluralize count="$ctrl.entry.DueDaysConstant" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>&nbsp;{{$ctrl.entry.IsAfterPayDay ? \'after\' : \'before\' }} pay date at {{$ctrl.entry.DueTimeHour}}:{{$ctrl.entry.DueTimeMinutes | fixedLength:2}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="$ctrl.entry.dueDateValid && $ctrl.entry.DueDaysConstant === 0">Due: On pay day at {{$ctrl.entry.DueTimeHour}}:{{$ctrl.entry.DueTimeMinutes | fixedLength:2}}</span>\n\t\t\t\t\t<span ng-if="!$ctrl.entry.dueDateValid">Edit deadline</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t</footer>\n</div>\n');
$templateCache.put('modals/_template-modal/template.modal.html','\n<!-- Optional form wrapper if using submit button functionality -->\n<form name="modalForm" ng-submit="$ctrl.updateFunction($ctrl, modalForm)">\n\t<modal modal-options="$ctrl.modalOptions">\n\t\t<modal-body>\n\n\t\t\t<p>Modal body goes here...</p>\n\n\t\t</modal-body>\n\t\t<modal-footer ng-if="$ctrl.modalState !== \'success\'">\n\t\t\t<button class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button disable-button="!modalForm.$valid" display-text="\'Update\'" ng-if="$ctrl.modalState === \'ready\'" state="modalForm.state"></submit-button>\n\n\t\t</modal-footer>\n\t</modal>\n</form>\n');
$templateCache.put('form-fields/mention-input/mention-input.html','<div ng-if="canMention" class="mention-input" click-anywhere-but-here="removeUnusedMentionElement(vm)" is-active="vm.showPopout">\n\n\t<!-- Editable area -->\n\t<div role="textbox" aria-labelledby="mentionInputLabel" aria-multiline="true" class="mention-input_area" ng-keyup="onKeyUp(vm, $event)" ng-keydown="onKeyDown(vm, $event)" ng-click="onClick(vm)" ng-blur="updateNgModel()" ng-paste="updateNgModel()" tabindex="0" ng-attr-contenteditable="{{!$ctrl.disabled}}" id="mention-input" ng-class="{ \'disabled\' : $ctrl.disabled }">{{::message}}</div>\n\n\t<!-- Input (For Validation) -->\n\t<textarea ng-model="ngModel" name="{{::name}}" id="{{::name}}-mention-input-area" class="mention-input_input" ng-required="::$ctrl.required" ng-disabled="$ctrl.disabled" aria-hidden="true"></textarea>\n\n\t<!-- Popout -->\n\t<div class="popout fadeIn" ng-if="vm.showPopout && vm.hasAdmins">\n\t\t<div class="mention-input_header">\n\t\t\t<h6 class="mention-input_header-title fadeIn">Type here to mention a person\u2026</h6>\n\t\t</div>\n\n\t\t<div class="popout_content" ng-mouseenter="onMouseOver(vm)" ng-mouseleave="onMouseLeave(vm)">\n\n\t\t\t<div class="mention-input_group" ng-if="adminGroup.teamMembers.length > 0" ng-hide="adminGroup.filteredAdmins.length === 0" ng-repeat="adminGroup in vm.adminGroups">\n\t\t\t\t<div class="mention-input_group-header">\n\t\t\t\t\t<h5 class="mention-input_group-title">{{adminGroup.title}}</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="mention-input_group-list">\n\n\t\t\t\t\t<a href="" class="mention-input_item fadeIn" id="{{MENTION_OPTIONS.selectionIdPrefix}}-{{admin.UserID}}" ng-class="{ \'is-selected\': admin.index === vm.selectedAdminIndex }" ng-mouseover="setSearchIndex(vm, admin.index)" ng-click="selectAdmin(vm, admin.index)" ng-repeat="admin in adminGroup.filteredAdmins = (adminGroup.teamMembers | filter : {fullName : vm.searchTerm})">\n\t\t\t\t\t\t<div class="mention-input_item-avatar">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{::admin.Forename[0]}}" avatar-size="is-small"></avatar>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="mention-input_item-detail">\n\t\t\t\t\t\t\t<h3 class="mention-input_item-title">{{::admin.Forename}} {{::admin.Surname}}</h3>\n\t\t\t\t\t\t\t<h4 class="mention-input_item-subtitle">{{::admin.EmailAddress | checkEmpty:\'Not registered\'}}</h4>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</a>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Fallback input -->\n<textarea ng-if="!canMention" name="note" id="{{::name}}-note" rows="8" ng-model="ngModel"></textarea>\n');
$templateCache.put('components/settings-breadcrumb/settings-breadcrumb.component.html','<div class="settings-breadcrumb">\n\t<a data-cy="back-to-settings-overview-link" ng-href="{{$ctrl.ngHref}}" class="link-with-icon greyscale"><i class="icon-back"></i>Back to settings overview</a>\n</div>\n');
$templateCache.put('components/image-badge/image-badge.component.html','<div class="image-badge" ng-class="[$ctrl.imageSize, $ctrl.imageClass]">\n\t<img alt="{{$ctrl.imageAlt}}" class="image-badge_image" ng-src="{{$ctrl.imageUrl}}">\n</div>\n');
$templateCache.put('features/app/_template-feature/template-feature.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Optional Action Bar -->\n\t\t<header class="page-template-a-action-bar">\n\t\t\t<a class="link-with-icon greyscale" ui-sref="anywhere({agencyProfileId: agencyProfileId})"><i class="icon-back"></i>Back to wherever</a>\n\t\t</header>\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Feature title">\n\n\t\t\t<!-- Optional Secondary Menu -->\n\t\t\t<pt-secondary>\n\t\t\t\t<a class="button primary" href="" ng-click="openAForm()">Do something</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t\t<search-bar count="filteredResults.length" options="searchBarOptions"></search-bar>\n\n\t\t\t<!-- Data set -->\n\t\t\t<section class="result-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<!-- Data items -->\n\t\t\t\t<result-card current-page="searchBarOptions.currentPageNumber" company="company" dir-paginate="result in filteredResults = (results |\n\t\t\t\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" result="result"></result-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="filteredResults.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- Optional placeholder for no results -->\n\t<placeholder ng-if="!results.length" placeholder-graphic="team">\n\t\t<placeholder-title>You don\'t have any data to show yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you add data it will appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-secondary-actions>\n\t\t\t<a href="" ng-click="do-something()">Secondary action</a>\n\t\t</placeholder-secondary-actions>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="do-something()" class="button primary">Primary action</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/account-settings/account-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<div class="page-template-a-action-bar">\n\t\t\t<a class="link-with-icon greyscale" href="" ng-click="goBack()">\n\t\t\t\t<i class="icon-back"></i>Back\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Account settings"></page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<div class="detail-blocks">\n\n\t\t\t\t<!-- Avatar\n\t\t\t\t<detail-block db-details="vm.avatarDetails"></detail-block>-->\n\n\t\t\t\t<!-- Login -->\n\t\t\t\t<detail-block db-details="vm.accountDetails"></detail-block>\n\t\t\t</div>\n\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/activate-account/activateAccountView.html','<split-pane sp-template="{{vm.IsWhitelabel ? \'customisation\' : \'paycircle\'}}">\n\t<sp-left>\n\n\t\t<div class="split-pane-form">\n\n\t\t\t<div class="slide-in-form" ng-switch="pageState">\n\n\t\t\t\t<!-- Invalid URL -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="invalid-url">\n\t\t\t\t\t<p>There was a problem with the url provided...</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Generic error -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="error">\n\t\t\t\t\t<error-block></error-block>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Validate activation code -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="checking-activation">\n\n\t\t\t\t\t<form name="validateActivationCodeForm" ng-submit="onboardCompany(vm, validateActivationCodeForm)" novalidate>\n\n\t\t\t\t\t\t<fieldset ng-switch="activationState">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">Account activation</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">Checking your activation code</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<!-- Company Name -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<code-field code="vm.ActivationCode" title="Activation code" theme="is-plain"></code-field>\n\t\t\t\t\t\t\t\t\t<loading-block ng-if="activationState === \'loading\'"></loading-block>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.companyName.$error" ng-if="onboardingFreeTrialForm.companyName.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter your validation code</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Invalid Code -->\n\t\t\t\t\t\t\t<div class="form-content-block dropIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.invalidCode">\n\t\t\t\t\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t\t\t\t\t<p>The activation code does not match your email. <a href="" ng-click="sendInvitationMail(vm)" class="tertiary underline">Request a new activation code</a></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Timed out -->\n\t\t\t\t\t\t\t<div class="form-content-block dropIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.timedOut">\n\t\t\t\t\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t\t\t\t\t<p>This activation code has expired.<br><a href="" ng-click="updateOnboardingActivationCode(vm)" class="tertiary underline">Send a new activation code</a></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Company deleted -->\n\t\t\t\t\t\t\t<div class="form-content-block dropIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.companyDeleted">\n\t\t\t\t\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t\t\t\t\t<p>This activation code has expired.<br><a ui-sref="trial-signup({\'companyKey\': vm.BureauKey, emailAddress: vm.Email})" class="tertiary underline">Request a new activation code</a></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Company already created -->\n\t\t\t\t\t\t\t<div class="form-content-block dropIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.companyAlreadyCreated">\n\t\t\t\t\t\t\t\t<div class="info-block positive">\n\t\t\t\t\t\t\t\t\t<p>This account has already been activated.<br><a ui-sref="login({username: vm.Email})" class="underline">Sign in to your account here</a>.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Invitation Resent -->\n\t\t\t\t\t\t\t<div class="form-content-block dropIn" ng-switch-when="invitation-resent">\n\t\t\t\t\t\t\t\t<div class="info-block positive">\n\t\t\t\t\t\t\t\t\t<p>A new activation code is on its way to you now. Please check your email.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Code timed out -->\n\t\t\t\t<div class="fadeIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.timedOut">\n\n\t\t\t\t\t<div ng-switch="errorState">\n\t\t\t\t\t\t<div pc-switch-when="">\n\t\t\t\t\t\t\t<p>There was a problem with the url provided...</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Invalid code -->\n\t\t\t\t<div class="fadeIn" pc-switch-when="ACTIVATION_CODE_RESPONSES.invalidCode">\n\n\t\t\t\t\t<div ng-switch="errorState">\n\t\t\t\t\t\t<div pc-switch-when="">\n\t\t\t\t\t\t\t<p>There was a problem with the url provided...</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Onboarding (Free Trial) -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="registration">\n\n\t\t\t\t\t<form name="onboardingFreeTrialForm" ng-submit="onboardCompany(vm, onboardingFreeTrialForm)" ng-switch="vm.onboardingStep" novalidate>\n\n\t\t\t\t\t\t<!-- Email already in use -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="-2">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">{{vm.title}}</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t\t\t\t\t<p>It seems that the email <strong>{{vm.Email}}</strong> is already in use. This may be because you have previously signed up for your free trial or registered for an account. If that\'s the case you can <a ui-sref="login({username: vm.Email})" class="underline">sign in to your account here</a>.</p>\n\t\t\t\t\t\t\t\t\t<p>If you think there may be a problem, please contact support and we\u2019ll look into it for you.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Service error -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="-1">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">{{vm.title}}</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t\t\t\t\t<p>There was a problem registering your details. Please contact support and we\u2019ll look into it for you.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Building company / Loading -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="0">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">{{vm.Demonstration ? \'We are building your demo company\' : \'We are setting up your account\'}}</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<loading-block></loading-block>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Page 1 - Name / Company -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="1">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title" ng-if="::vm.Demonstration">Thanks for activating your free trial</h3>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title" ng-if="::!vm.Demonstration">Thanks for activating your account</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<p ng-if="::vm.Demonstration">Quickly tell us about you and your company so we can personalise your free trial. It only takes a minute!</p>\n\t\t\t\t\t\t\t\t<p ng-if="::!vm.Demonstration">Quickly tell us about you and your company then choose a password and that\'s it!</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Name -->\n\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t<!-- First Name -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="vm.Forename" ng-pattern="$root.REGEX.name" minlength="2" required>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.forename.$error" ng-if="onboardingFreeTrialForm.forename.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Surname -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input type="text" id="surname" name="surname" ng-model="vm.Surname" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.surname.$error" ng-if="onboardingFreeTrialForm.surname.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Company Name -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="companyName" class="required">Company name:</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="companyName" name="companyName" type="text" ng-model="vm.CompanyName" ng-pattern="$root.REGEX.companyName" required>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.companyName.$error" ng-if="onboardingFreeTrialForm.companyName.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message fadeIn">We\'ll use this for your demo company so it feels like home :)</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- New company? -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t<input type="checkbox" id="isNewCompany" name="isNewCompany" ng-model="vm.IsNewCompany" label-text="\'We are a brand new company\'" checkbox>\n\t\t\t\t\t\t\t\t\t<a class="checkbox-field-info" href="" ng-click="toggleModalIsOpen(modalOptions.newCompanyInfo)" aria-label="Open modal"><i class="icon-information m"></i></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Number of Employees -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="numberOfEmployees" class="required">How many employees do you have?</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<select class="l-alt" name="numberOfEmployees" id="numberOfEmployees" ng-model="vm.EmployeeCount" ng-options="option.value as option.name for option in NUMBER_OF_EMPLOYEE_OPTIONS" required>\n\t\t\t\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.numberOfEmployees.$error" ng-if="onboardingFreeTrialForm.numberOfEmployees.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!-- <p class="form-message fadeIn">Looking to onboard more than 20 team members? <a href="" ng-click="openSupportTab()" class="underline">Get in touch for onboarding support</a></p> -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Page 2 - Pay / Pension -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="2">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">Your payroll and pension</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<!-- Pay Frequency -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="numberOfEmployees" class="required">How frequently do you pay your team?</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<select name="payPeriodType" id="payPeriodType" ng-model="vm.PayrollFrequency" ng-options="option.id as option.name for option in PAY_PERIOD_TYPES_OPTIONS" required></select>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingFreeTrialForm.payPeriodType.$error" ng-if="onboardingFreeTrialForm.payPeriodType.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Workplace Pension -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="hasWorkplacePensionTrue">Do you have a Workplace Pension?</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="hasWorkplacePension" id="hasWorkplacePensionTrue" class="radio-card-input" ng-value="true" ng-change="reviewWorkplacePension(vm)" ng-model="vm.HasWorkplacePension" required>\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="hasWorkplacePensionTrue">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">Yes</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="hasWorkplacePension" id="hasWorkplacePensionFalse" class="radio-card-input" ng-value="false" ng-change="reviewWorkplacePension(vm)" ng-model="vm.HasWorkplacePension" required>\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="hasWorkplacePensionFalse">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">No</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<p class="form-message">If you don\u2019t have a workplace pension and you need to set one up, you will need to do so before onboarding.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Page 3 - Modules -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="3">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">Choose your modules to trial</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="checkbox-cards">\n\t\t\t\t\t\t\t\t\t<div class="checkbox-card quarternary">\n\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="hasPayroll" name="hasPayroll" class="checkbox-card-input" ng-model="vm.IsPayrollActive">\n\t\t\t\t\t\t\t\t\t\t<label class="checkbox-card-label" for="hasPayroll">\n\t\t\t\t\t\t\t\t\t\t\t<header class="checkbox-card-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-clock checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Payroll</h5>\n\t\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t\t<p class="checkbox-card-text">Manage payroll for your team - simple, cloud-based and collaborative, no previous payroll experience required!</p>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="checkbox-card secondary">\n\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="hasWorkplacePension" name="hasWorkplacePension" class="checkbox-card-input" ng-model="vm.IsPensionActive">\n\t\t\t\t\t\t\t\t\t\t<label class="checkbox-card-label" for="hasWorkplacePension">\n\t\t\t\t\t\t\t\t\t\t\t<header class="checkbox-card-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-money checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Workplace pension</h5>\n\t\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t\t<p class="checkbox-card-text">Connect your workplace pension to payroll or manage your workplace pension on its own - with no payroll connected</p>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Page 4 - Template -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="4">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">Customise your team names</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<p>Choose a theme to use for team member names in your demo company</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Company Template -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="radio-cards-images">\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateOlympicStars" class="radio-card-input" ng-value="COMPANY_TEMPLATES.olympicStars" ng-model="vm.Customisation">\n\t\t\t\t\t\t\t\t\t\t\t<label for="companyTemplateOlympicStars" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card-image-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img alt="" class="radio-card-image" src="images/graphics/demo-company-olympic-stars.png">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-title">Olympic stars</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateMovieStars" class="radio-card-input" ng-value="COMPANY_TEMPLATES.movieStars" ng-model="vm.Customisation">\n\t\t\t\t\t\t\t\t\t\t\t<label for="companyTemplateMovieStars" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card-image-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img alt="" class="radio-card-image" src="images/graphics/demo-company-movie-stars.png">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-title">Movie stars</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateHistoricalFigures" class="radio-card-input" ng-value="COMPANY_TEMPLATES.historicalFigures" ng-model="vm.Customisation">\n\t\t\t\t\t\t\t\t\t\t\t<label for="companyTemplateHistoricalFigures" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card-image-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img alt="" class="radio-card-image" src="images/graphics/demo-company-historical-figures.png">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-title">Historical figures</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateMusicalArtists" class="radio-card-input" ng-value="COMPANY_TEMPLATES.musicalArtists" ng-model="vm.Customisation">\n\t\t\t\t\t\t\t\t\t\t\t<label for="companyTemplateMusicalArtists" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card-image-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img alt="" class="radio-card-image" src="images/graphics/demo-company-musical-artists.png">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-title">Musical artists</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Page 5 - Credentials -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="5">\n\n\t\t\t\t\t\t\t<header class="split-pane-form-header">\n\t\t\t\t\t\t\t\t<p class="split-pane-form-pretitle">{{vm.pretitle}}</p>\n\t\t\t\t\t\t\t\t<h3 class="split-pane-form-title">Choose a password</h3>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t\t\t\t\t\t<p class="s">Choose a password to sign in with the email:</p>\n\t\t\t\t\t\t\t\t\t<p class="s"><span class="primary">{{vm.Email}}</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- New password -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="password">\n\t\t\t\t\t\t\t\t\t\tChoose a password\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<password-input allow-show-password="true" blacklisted-terms="[\n\t\t\t\t\t\t\t\t\t\t\tvm.Email\n\t\t\t\t\t\t\t\t\t\t]" input-id="password" input-name="password" ng-model="vm.Value"></password-input>\n\n\t\t\t\t\t\t\t\t\t<validated-input-form-field allow-show-password="true" blacklisted-terms="[\n\t\t\t\t\t\t\t\t\t\t\tvm.Email\n\t\t\t\t\t\t\t\t\t\t]" disable-autocomplete="true" field-name="Password" field-prompt="Your password must contain" input-name="password" ng-model="vm.Value" validation-type="{{INPUT_VALIDATION_TYPES.password}}">\n\t\t\t\t\t\t\t\t\t\t<vi-errors>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="validateActivationCodeForm.password.$invalid && validateActivationCodeForm.password.$touched" ng-messages="validateActivationCodeForm.password.$error">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\t\t\t\t\tPlease enter a new password\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</vi-errors>\n\t\t\t\t\t\t\t\t\t</validated-input-form-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Confirm new password -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="passwordConfirm">\n\t\t\t\t\t\t\t\t\t\tConfirm new password\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<password-input allow-show-password="true" compare-password="vm.Value" disable-autocomplete="true" input-id="passwordConfirm" input-name="passwordConfirm" ng-model="vm.ValueConfirm"></password-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="onboardingFreeTrialForm.passwordConfirm.$invalid && onboardingFreeTrialForm.passwordConfirm.$touched" ng-messages="onboardingFreeTrialForm.passwordConfirm.$error">\n\t\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\t\t\tPlease confirm your new password\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="comparison">\n\t\t\t\t\t\t\t\t\t\tPlease make sure your passwords match\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- New company? -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t<input type="checkbox" id="acceptTsAndCs" name="acceptTsAndCs" ng-model="vm.AcceptTsAndCs" label-text="\'I agree to the <a href=\\\'\' + $root.URLS.paycircle.website.terms + \'\\\' target=\\\'blank\\\'>Terms of use</a> and <a href=\\\'\' + $root.URLS.paycircle.website.privacy + \'\\\' target=\\\'blank\\\'>Privacy Policy</a> and to receive emails during my free demo and onboarding.\'" checkbox required>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<fieldset class="form-actions-block" ng-switch-when="1|2|3|4|5" ng-switch-when-separator="|">\n\n\t\t\t\t\t\t\t<a href="" class="button l secondary-action" ng-click="goToPreviousOnboardingStep(vm)" ng-if="vm.onboardingStep > 1">Back</a>\n\t\t\t\t\t\t\t<a href="" class="button l tertiary primary-action" ng-class="{\'disabled\': !onboardingFreeTrialForm.$valid || (!vm.IsPensionActive && !vm.IsPayrollActive)}" ng-click="goToNextOnboardingStep(vm)" ng-if="vm.onboardingStep !== 5">Next</a>\n\n\t\t\t\t\t\t\t<submit-button class="l" display-text="\'Next\'" state="onboardingFreeTrialForm.state" disable-button="!onboardingFreeTrialForm.$valid" ng-if="vm.onboardingStep === 5"></submit-button>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Progress steps -->\n\t\t\t\t\t\t<fieldset class="split-pane-form-progress-steps" ng-if="vm.onboardingStep >= 0">\n\n\t\t\t\t\t\t\t<progress-steps theme="primary" step-count="vm.TotalOnboardingSteps" active-step="vm.onboardingProgressStep"></progress-steps>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Powered by Paycircle -->\n\t\t\t<footer class="split-pane-form-footer" ng-if="::vm.IsWhitelabel">\n\t\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t\t</footer>\n\t\t</div>\n\t</sp-left>\n</split-pane>\n\n<modal modal-options="modalOptions.newCompanyInfo" ng-if="modalOptions.newCompanyInfo.isOpen">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block">\n\t\t\t<p>Please check this box if you are a brand new company, who has not run a payroll before and looking to run your first payroll and set up a new workplace pension for your company.</p>\n\t\t</div>\n\t\t<div class="modal_body-action-block align-center">\n\t\t\t<p><a href="" class="button m tertiary" ng-click="toggleModalIsOpen(modalOptions.newCompanyInfo)">Got it</a></p>\n\t\t</div>\n\t</modal-body>\n</modal>\n');
$templateCache.put('features/app/agency-dashboard/agency-dashboard.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Period in Rollback -->\n\t\t<div class="page-template-a-action-bar" ng-if="$root.currentPeriod.IsRollback">\n\t\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t\t</div>\n\n\t\t<!-- Header -->\n\t\t<page-template-a-header icon="dashboard" page-title="Dashboard" secondary-content-type="info"></page-template-a-header>\n\n\t\t<!-- Auto run -->\n\t\t<div class="page-template-a-section" ng-if="company.Company.IsAutoRun && $root.currentUser.canSeeAutoRun">\n\t\t\t<notification-block icon="loading" icon-theme="is-quarternary">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tPayroll is set to Auto run on {{company.PayPeriod.ProcessDateISO | dateformat}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou will be notified when payroll has been successfully submitted\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<button class="is-primary" type="button">\n\t\t\t\t\t\tRun payroll now\n\t\t\t\t\t</button>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- PAYE Scheme closed -->\n\t\t<div class="page-template-a-section" ng-if="$root.currentCompany.CeasePAYESchemeComplete">\n\t\t\t<notification-block icon="cross" icon-theme="is-assertive">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tThis PAYE scheme has closed\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThe PAYE scheme with the reference {{$root.currentCompany.PAYERef}} was closed on {{$root.currentCompany.PAYECeaseDateISO | dateformat}}.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.closingPayeScheme" theme="is-assertive is-underline">\n\t\t\t\t\t\t\tRead more about closing a PAYE scheme\n\t\t\t\t\t\t</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<a class="button is-primary" ng-if="$root.currentCompany.HasPension" ui-sref="pensions.summary({\n\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tDisconnect your pension\n\t\t\t\t\t</a>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Archived -->\n\t\t<div class="page-template-a-section" ng-if="$root.currentCompany.IsArchived">\n\t\t\t<notification-block icon="archive" icon-theme="is-greyscale">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tThis company was archived on {{::company.Company.ArchiveDateISO | dateformat}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tReason for archiving: {{::company.Company.ArchiveReason}}\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Compulsory submission -->\n\t\t<div class="page-template-a-section" ng-if="company.PayPeriod.IsCompulsorySubmission">\n\t\t\t<notification-block icon="warning" icon-theme="is-assertive">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tPayroll will be automatically submitted in {{company.PayPeriod.CompulsorySubmissionDaysAway}}\n\t\t\t\t\t\t<ng-pluralize count="company.PayPeriod.CompulsorySubmissionDaysAway" when="{\n\t\t\t\t\t\t\t\t\'1\': \'day\',\n\t\t\t\t\t\t\t\t\'other\': \'days\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tTo make sure your pension stays compliant, your payroll will be automatically submitted on {{company.PayPeriod.CompulsorySubmissionDateISO | dateformat:\'dayMonth\'}}.\n\t\t\t\t\t\t<a class="is-assertive is-underline" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tDisconnect pension\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<a ui-sref="payroll.run-payroll({\n\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t})" id="calculate-payroll-c" class="button is-primary">\n\t\t\t\t\t\tRun payroll now\n\t\t\t\t\t</a>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Workflow -->\n\t\t<div class="page-template-a-section" ng-if="company.Company.IsWorkflowEnabled">\n\t\t\t<workflow-status-block template-entry-current="workflowTemplateEntryCurrent"></workflow-status-block>\n\t\t</div>\n\n\t\t<!-- Main -->\n\t\t<div class="page-template-a-main">\n\n\t\t\t<!-- Company Overview -->\n\t\t\t<section class="page-template-a-section">\n\n\t\t\t\t<user-importer-status-block agency-profile-id="agencyProfileId" pay-period="company.PayPeriod" show-period-info="true"></user-importer-status-block>\n\t\t\t</section>\n\n\t\t\t<!-- Activity -->\n\t\t\t<section class="page-template-a-section">\n\n\t\t\t\t<activity-block agency-profile-id="agencyProfileId" date-from="company.PayPeriod.StartDateISO"></activity-block>\n\n\t\t\t</section>\n\t\t</div>\n\t</div>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/app-integrations/appIntegrationsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- URL does not have necessary parameters -->\n<error-block has-gutter="true" ng-if="pageState === \'incorrect-url\'"></error-block>\n');
$templateCache.put('features/app/authorise-app/authoriseAppView.html','<div class="authorise-connection {{pageState === \'connected\' ? \'is-complete\' : \'\'}}">\n\n\t<div class="authorise-connection_logos" ng-switch="appKey">\n\t\t<i class="icon-connection authorise-connection_connector xxxl"></i>\n\n\t\t<!-- Smart Pension -->\n\t\t<span class="authorise-connection_badge" ng-switch-when="smart">\n\t\t\t<image-badge image-alt="Smart Pension" image-key="smart-pension" image-type="integrations"></image-badge>\n\t\t</span>\n\n\t\t<!-- Peoples Pension -->\n\t\t<span class="authorise-connection_badge" ng-switch-when="peoples">\n\t\t\t<image-badge image-alt="The Peoples Pension" image-key="the-peoples-pension" image-type="integrations"></image-badge>\n\t\t</span>\n\n\t\t<!-- Xero -->\n\t\t<span class="authorise-connection_badge" ng-switch-when="xero">\n\t\t\t<image-badge image-alt="Xero" image-key="xero" image-type="integrations"></image-badge>\n\t\t</span>\n\n\t\t<!-- Paycircle -->\n\t\t<image-badge class="authorise-connection_badge is-paycircle" image-alt="Paycircle" image-key="paycircle"></image-badge>\n\t</div>\n\n\t<!-- Connecting -->\n\t<div class="authorise-connection_copy fadeIn" ng-switch="appKey" ng-if="pageState === \'connecting\'">\n\t\t<div class="authorise-connection_icon popIn">\n\t\t\t<circle-loader></circle-loader>\n\t\t</div>\n\t\t<h4 class="authorise-connection_title">Connecting</h4>\n\t\t\n\t\t<!-- Smart Pension -->\n\t\t<p class="s" ng-switch-when="smart">Your Smart Pension is being connected to your Paycircle account</p>\n\t\t\n\t\t<!-- Peoples Pension -->\n\t\t<p class="s" ng-switch-when="peoples">Your People\'s Pension is being connected to your Paycircle account so we can authorise your pension</p>\n\t\t\n\t\t<!-- Xero -->\n\t\t<p class="s" ng-switch-when="xero">Your Xero account is being connected to your Paycircle account</p>\n\t</div>\n\n\t<!-- Connected -->\n\t<div class="authorise-connection_copy fadeIn" ng-switch="appKey" ng-if="pageState === \'connected\'">\n\t\t<div class="authorise-connection_icon">\n\t\t\t<i class="icon-tick is-positive xxxl popIn"></i>\n\t\t</div>\n\t\t<h4 class="authorise-connection_title">Successfully connected!</h4>\n\n\t\t<!-- Smart Pension -->\n\t\t<p class="s" ng-switch-when="smart">Your Smart Pension is now connected to Paycircle. Close this tab to complete your authorisation.</p>\n\n\t\t<!-- Peoples Pension -->\n\t\t<p class="s" ng-switch-when="peoples">Your People\'s Pension is now connected to Paycircle. Close this tab to complete your authorisation.</p>\n\n\t\t<!-- Xero -->\n\t\t<p class="s" ng-switch-when="xero">Your Xero account is now connected to Paycircle. <a href="" ng-click="closeWindow()">Close this tab</a> to complete your authentication.</p>\n\t</div>\n\n\t<!-- Xero > Select Tenant (Multiple tenants only) -->\n\t<div class="authorise-connection_block fadeIn" ng-if="pageState === \'select-tenant\'">\n\t\t<div class="authorise-connection_section">\n\t\t\t<div class="authorise-connection_copy align-center" ng-switch="appKey">\t\t\t\t\n\t\t\t\t<h4 class="authorise-connection_title">Confirm the organisation you wish to connect to</h4>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="authorise-connection_section">\n\n\t\t\t<search-bar count="xeroTenantData.tenantsFiltered.length" options="searchBarOptions"></search-bar>\n\n\t\t\t<section class="tenant-cards">\n\n\t\t\t\t<div class="tenant-card" dir-paginate="tenant in xeroTenantData.tenantsFiltered = (\n\t\t\t\t\t\t\txeroTenantData.tenants |\n\t\t\t\t\t\t\tfilter : searchBarOptions.search.string\n\t\t\t\t\t\t) |\n\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t" ng-click="updateAgencyProfileXeroCredentialTenantId(agencyProfileId, tenant)">\n\t\t\t\t\t<span class="tenant-card_label">{{tenant.tenantName}}</span>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="xeroTenantData.tenantsFiltered.length === 0">\n\t\t\t\t\t<p class="is-small">No search results found</p>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</div>\n\t</div>\n\n\t<!-- Xero > Failed authorisation -->\n\t<div class="authorise-connection_copy fadeIn" ng-switch="appKey" ng-if="pageState === \'xero-reauthorise\'">\n\t\t\n\t\t<h4 class="authorise-connection_title">Unable to authorise Xero connection</h4>\n\n\t\t<p class="s"><a href="" ng-click="closeWindow()">Close this tab</a> and return to your company settings to try again.</p>\n\n\t</div>\n\n\t<!-- Error -->\n\t<div class="authorise-connection_copy fadeIn" ng-switch="appKey" ng-if="pageState === \'error\'">\n\t\t<div class="authorise-connection_icon">\n\t\t\t<i class="icon-cross is-assertive xxxl popIn"></i>\n\t\t</div>\n\t\t<h4 class="authorise-connection_title">Connection failed</h4>\n\n\t\t<!-- Xero -->\n\t\t<p class="s" ng-switch-when="xero">We were unable to connect to Xero.</p>\n\n\t\t<!-- Pension (generic) -->\n\t\t<p class="s" ng-switch-default>It looks like the credentials you\'ve entered don\'t have access to this pension. Please check the pension scheme reference and your credentials have been entered correctly.</p>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/bureau-dashboard/bureau-dashboard.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="bureau-dashboard page-template-a fadeIn" data-cy="bureau-dashboard" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header class="bureau-dashboard-header" icon="dashboard" page-title="Hello {{session.user.UserResponseFirstName}}">\n\t\t\t<pt-sub-heading>\n\t\t\t\t<h4 class="bureau-dashboard-sub-heading">Here\'s what\'s happening with your companies</h4>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-secondary class="bureau-dashboard-header-secondary-container">\n\t\t\t\t<h4 class="bureau-dashboard-header-primary-text">Tax week {{dashboard.CurrentTaxWeek}} / Tax month {{dashboard.CurrentTaxMonth}}</h4>\n\t\t\t\t<p class="bureau-dashboard-header-secondary-text">{{thisMonth | dateformat:\'monthYear\'}}</p>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<section class="bureau-dashboard-main page-template-a-main">\n\n\t\t\t<!-- Stat Blocks -->\n\t\t\t<header class="bureau-dashboard-tile-headers">\n\t\t\t\t<div class="bureau-dashboard-hero-tile">\n\t\t\t\t\t<div class="bureau-dashboard-hero-tile-content">\n\t\t\t\t\t\t<h3 class="bureau-dashboard-hero-tile-heading"><i class="icon-company"></i>Companies</h3>\n\t\t\t\t\t\t<p class="bureau-dashboard-hero-tile-count-primary">\n\t\t\t\t\t\t\t{{dashboard.CompanyCount | number}}\n\t\t\t\t\t\t\t<span class="accessible">Companies. Increased by </span>\n\t\t\t\t\t\t\t<span class="increased-by" tooltip tooltip-text="Compared to {{previousMonth | dateformat:\'monthYear\'}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\'decreased\': dashboard.CompanyCountIncrease < 0\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t<i ng-class="dashboard.CompanyCountIncrease < 0 ? \'icon-chevron-down\' : \'icon-chevron-up\'"></i>\n\t\t\t\t\t\t\t\t{{dashboard.CompanyCountIncrease | number}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<ul class="bureau-dashboard-hero-tile-key">\n\t\t\t\t\t\t\t<li class="is-font-secondary-300">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">\n\t\t\t\t\t\t\t\t\t\t{{dashboard.CompanyCountLive | number}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\tLive\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="is-font-tertiary-300">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">\n\t\t\t\t\t\t\t\t\t\t{{dashboard.CompanyCountTest | number}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\tTest Mode\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="is-font-quaternary-300" ng-if="currentUser.canSeeAutoRun">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">\n\t\t\t\t\t\t\t\t\t\t{{dashboard.CompanyCountAutoRun | number}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\tAuto run\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-hero-tile-chart">\n\t\t\t\t\t\t<arc-de-chart total="dashboard.CompanyCount" value="dashboard.CompanyCountLive" bar-color="#009f78" stack="1" ng-if="dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t\t<arc-de-chart total="dashboard.CompanyCount" value="dashboard.CompanyCountTest" bar-color="#e00075" stack="2" ng-if="dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t\t<arc-de-chart total="dashboard.CompanyCount" value="dashboard.CompanyCountAutoRun" bar-color="#8e3bb6" stack="3" ng-if="currentUser.canSeeAutoRun && dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="bureau-dashboard-hero-tile">\n\t\t\t\t\t<div class="bureau-dashboard-hero-tile-content">\n\t\t\t\t\t\t<h3 class="bureau-dashboard-hero-tile-heading"><i class="icon-team-alt"></i>Employees</h3>\n\t\t\t\t\t\t<p class="bureau-dashboard-hero-tile-count-primary">\n\t\t\t\t\t\t\t{{dashboard.UserCountActive | number}}\n\t\t\t\t\t\t\t<span class="accessible">Employees. Increased by </span>\n\t\t\t\t\t\t\t<span class="increased-by" tooltip tooltip-text="Compared to {{previousMonth | dateformat:\'monthYear\'}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\'decreased\': dashboard.UserCountIncrease < 0\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t<i ng-class="dashboard.UserCountIncrease < 0 ? \'icon-chevron-down\' : \'icon-chevron-up\'"></i>\n\t\t\t\t\t\t\t\t{{dashboard.UserCountIncrease | number}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<ul class="bureau-dashboard-hero-tile-key">\n\t\t\t\t\t\t\t<li class="is-font-secondary-300">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">{{dashboard.UserCountActive | number}}</span>\n\t\t\t\t\t\t\t\t\tActive on payroll\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="is-font-indifferent-300">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">{{dashboard.UserCountIncomplete | number}}</span>\n\t\t\t\t\t\t\t\t\tIncomplete\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="is-font-primary-300">\n\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text">\n\t\t\t\t\t\t\t\t\t<span class="bureau-dashboard-hero-tile-key-text-count">{{dashboard.UserCountCIS | number}}</span>\n\t\t\t\t\t\t\t\t\tCIS\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-hero-tile-chart">\n\t\t\t\t\t\t<arc-de-chart total="dashboard.UserCountActive" value="dashboard.UserCountActive" bar-color="#009f78" stack="1" ng-if="dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t\t<arc-de-chart total="dashboard.UserCountActive" value="dashboard.UserCountIncomplete" bar-color="#fee964" stack="2" ng-if="dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t\t<arc-de-chart total="dashboard.UserCountActive" value="dashboard.UserCountCIS" bar-color="#00819d" stack="3" ng-if="dashboard.CompanyCount"></arc-de-chart>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</header>\n\n\t\t\t<!-- Tiles -->\n\t\t\t<ul class="bureau-dashboard-tiles" ng-class="{closed: holdTheScroll}">\n\n\t\t\t\t<!-- Payrolls due this week -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'CompanyListToRun7Days\' && !tileClosing, incoming: incomingDashTile === \'CompanyListToRun7Days\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button quarternary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'CompanyListToRun7Days\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.CompanyListToRun7Days.lengtb < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'CompanyListToRun7Days\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PayrollCountToRun | number}}</div>\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-clock"></i>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.CompanyListToRun7Days.length" when="{\'1\': \'Payroll due this week\', \'other\': \'Payrolls due this week\'}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action quarternary" aria-label="Show payrolls due this week" href="" ng-click="toggleActiveDashTile(\'CompanyListToRun7Days\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content quarternary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'CompanyListToRun7Days\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListToRun7Days" info="CurrentPeriod" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 payroll due this week\',\n\t\t\t\t\t\t\t\t\'other\': \'{} payrolls due this week\'\n\t\t\t\t\t\t\t}" items-count="dashboard.CompanyListToRun7Days.length" preset-filter-key="PRESET_FILTER_KEYS.company.livePayrollsDueThisWeek" tag-type="isApproved" theme="quarternary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Payrolls overdue -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'PayrollCountOverdue\' && !tileClosing, incoming: incomingDashTile === \'PayrollCountOverdue\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button assertive" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'PayrollCountOverdue\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.PayrollCountOverdue < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'PayrollCountOverdue\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-clock"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PayrollCountOverdue | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.PayrollCountOverdue" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Payroll overdue\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Payrolls overdue\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action assertive" aria-label="Show payrolls overdue" href="" ng-click="toggleActiveDashTile(\'PayrollCountOverdue\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content assertive" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'PayrollCountOverdue\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListOverdue" info="CurrentPeriod" item-description="{\'1\': \'1 payroll overdue\', \'other\': \'{} payrolls overdue\'}" preset-filter-key="PRESET_FILTER_KEYS.company.livePayrollsOverdue" theme="assertive"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Payrolls failed -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'PayrollCountFailed\' && !tileClosing, incoming: incomingDashTile === \'PayrollCountFailed\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button tertiary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'PayrollCountFailed\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.PayrollCountFailed < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'PayrollCountFailed\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-clock"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PayrollCountFailed | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title"><ng-pluralize count="dashboard.PayrollCountFailed" when="{\'1\': \'Payroll failed\', \'other\': \'Payrolls failed\'}"></ng-pluralize></p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action tertiary" aria-label="Show payrolls failed" href="" ng-click="toggleActiveDashTile(\'PayrollCountFailed\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content tertiary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'PayrollCountFailed\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListFailed" info="CurrentPeriod" item-description="{\'1\': \'1 payroll failed\', \'other\': \'{} payrolls failed\'}" preset-filter-key="PRESET_FILTER_KEYS.company.livePayrollsFailed" theme="tertiary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- HMRC connection failed -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'0\' && !tileClosing, incoming: incomingDashTile === \'0\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button tertiary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'0\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.CompanyCountDPSFail < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'0\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-company"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.CompanyCountDPSFail | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title tertiary">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.CompanyCountDPSFail" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'HMRC connection failed\',\n\t\t\t\t\t\t\t\t\t\'other\': \'HMRC connections failed\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action tertiary" aria-label="Show failed HMRC connections" href="" ng-click="toggleActiveDashTile(\'0\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content tertiary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'0\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListDPSFail" info-label="PAYE Ref:" info="PAYEReference" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 failed connection with HMRC\',\n\t\t\t\t\t\t\t\t\'other\': \'{} failed connections with HMRC\'\n\t\t\t\t\t\t\t}" theme="tertiary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Pension submissions failed -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'PensionCountFailed\' && !tileClosing, incoming: incomingDashTile === \'PensionCountFailed\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button tertiary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'PensionCountFailed\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.PensionCountFailed < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'PensionCountFailed\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-money"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PensionCountFailed | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title tertiary">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.PensionCountFailed" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Pension submission failed\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Pension submissions failed\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action tertiary" aria-label="Show failed pension submissions" href="" ng-click="toggleActiveDashTile(\'PensionCountFailed\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content tertiary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'PensionCountFailed\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListPensionFailed" info="PensionProvider" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 pension submission failed\',\n\t\t\t\t\t\t\t\t\'other\': \'{} pension submissions failed\'\n\t\t\t\t\t\t\t}" theme="tertiary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Pensions unauthorised -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'PensionCountUnauthorised\' && !tileClosing, incoming: incomingDashTile === \'PensionCountUnauthorised\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button assertive" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'PensionCountUnauthorised\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.PensionCountUnauthorised < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'PensionCountUnauthorised\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-money"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PensionCountUnauthorised | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.PensionCountUnauthorised" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Pension unauthorised\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Pensions unauthorised\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action assertive" aria-label="Show unauthorised pensions" href="" ng-click="toggleActiveDashTile(\'PensionCountUnauthorised\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content assertive" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'PensionCountUnauthorised\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListPensionUnauthorised" info="PensionProvider" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 pension unauthorised\',\n\t\t\t\t\t\t\t\t\'other\': \'{} pensions unauthorised\'\n\t\t\t\t\t\t\t}" theme="assertive"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Pension re-enrolment -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'PensionCountReenrol\' && !tileClosing, incoming: incomingDashTile === \'PensionCountReenrol\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button secondary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'PensionCountReenrol\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.PensionCountReenrol < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'PensionCountReenrol\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-money"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.PensionCountReenrol | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.PensionCountReenrol" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Pension re-enrolment\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Pension re-enrolments\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action secondary" aria-label="Show pensions due for re-enrolment" href="" ng-click="toggleActiveDashTile(\'PensionCountReenrol\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content secondary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'PensionCountReenrol\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.CompanyListPensionReenrolment" info="PensionProvider" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 due for pension re-enrolment\',\n\t\t\t\t\t\t\t\t\'other\': \'{} due for pension re-enrolment\'\n\t\t\t\t\t\t\t}" theme="secondary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t\t<!-- Incomplete employees -->\n\t\t\t\t<li class="bureau-dashboard-tile" ng-class="{active: activeDashTile === \'UserCountIncomplete\' && !tileClosing, incoming: incomingDashTile === \'UserCountIncomplete\'}">\n\t\t\t\t\t<div class="bureau-dashboard-tile-button primary" ng-class="{\n\t\t\t\t\t\t\tactive: activeDashTile === \'UserCountIncomplete\' && !tileClosing,\n\t\t\t\t\t\t\tempty: dashboard.UserCountIncomplete < 1,\n\t\t\t\t\t\t\tincoming: incomingDashTile === \'UserCountIncomplete\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<i class="bureau-dashboard-tile-icon icon-team-alt"></i>\n\t\t\t\t\t\t<div class="bureau-dashboard-tile-number">{{dashboard.UserCountIncomplete | number}}</div>\n\t\t\t\t\t\t<p class="bureau-dashboard-tile-title">\n\t\t\t\t\t\t\t<ng-pluralize count="dashboard.UserCountIncomplete" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Incomplete employee\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Incomplete employees\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="bureau-dashboard-tile-overlay-action primary" aria-label="Show incomplete team members" href="" ng-click="toggleActiveDashTile(\'UserCountIncomplete\')"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="bureau-dashboard-tile-content primary" ng-class="{closed: tileClosing}" ng-if="activeDashTile === \'UserCountIncomplete\'">\n\t\t\t\t\t\t<dashboard-carousel company-list="dashboard.TeamMemberListIncomplete" is-team-member-list="true" item-description="{\n\t\t\t\t\t\t\t\t\'1\': \'1 incomplete employee\',\n\t\t\t\t\t\t\t\t\'other\': \'{} incomplete employees\'\n\t\t\t\t\t\t\t}" preset-filter-key="PRESET_FILTER_KEYS.livePayrollsDueThisWeek" theme="primary"></dashboard-carousel>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</section>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/bureau-onboarding/bureauOnboardingView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Title -->\n\t\t<page-template-a-header icon="rocket" page-title="Onboarding">\n\t\t\t<pt-secondary>\n\t\t\t\t<menu-button menu-button-text="New company" menu-button-theme="primary">\n\t\t\t\t\t<a href="" ng-click="openBureauNewCompanyForm(false)">Onboarding</a>\n\t\t\t\t\t<a href="" ng-click="openBureauNewCompanyForm(true)">Demo</a>\n\t\t\t\t</menu-button>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Companies -->\n\t\t<main class="page-template-a-main" ng-if="companies.all.length">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="companies"></search-bar>\n\n\t\t\t<!-- Company Cards -->\n\t\t\t<div class="company-onboarding-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<company-onboarding-card agency-profile-parent-id="{{agencyProfileParentId}}" company="company" reload-companies="reloadCompanies()" dir-paginate="company in companies.filtered = (companies.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></company-onboarding-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="companies.filtered.length === 0"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No companies -->\n\t\t<placeholder placeholder-graphic="no-companies" ng-if="!companies.all.length">\n\t\t\t<placeholder-title>You don\'t have any companies onboarding</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As companies start to onboard they will appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<menu-button menu-button-text="New company" menu-button-theme="primary">\n\t\t\t\t\t<a href="" ng-click="openBureauNewCompanyForm(false)">Onboarding</a>\n\t\t\t\t\t<a href="" ng-click="openBureauNewCompanyForm(true)">Demo</a>\n\t\t\t\t</menu-button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n');
$templateCache.put('features/app/bureaus/bureausView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="franchisees" page-title="Bureaus">\n\t\t\t<pt-secondary>\n\t\t\t\t<a href="" ng-click="openAddNewBureauForm()" class="button primary">\n\t\t\t\t\t<i class="icon-plus"></i>&nbsp;New bureau\n\t\t\t\t</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Bureaus -->\n\t\t<main class="page-template-a-main" ng-if="bureaus.all.length">\n\n\t\t\t<!-- Search / Filter -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="bureaus"></search-bar>\n\n\t\t\t<!-- Bureau Cards -->\n\t\t\t<div class="bureau-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<bureau-card bureau="bureau" refresh-bureaus="refreshBureaus" bulk-items="bureaus" callback="incrementBureauCount" dir-paginate="bureau in bureaus.filtered = (bureaus.all | filter : {Company: {Name: searchBarOptions.search.string}} ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></bureau-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="!bureaus.filtered.length"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No Bureaus -->\n\t\t<placeholder placeholder-graphic="no-bureaus" ng-if="!bureaus.all.length">\n\t\t\t<placeholder-title>You don\'t have any bureaus</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As bureaus are added they will start to appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ng-click="openAddNewBureauForm()" class="button primary">\n\t\t\t\t\t<i class="icon-plus"></i>&nbsp;New bureau\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/bureaus-archived/bureausArchivedView.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === PAGE_STATES.ready">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Title -->\n\t\t<page-template-a-header icon="archive" page-title="Archived Bureaus"></page-template-a-header>\n\n\t\t<!-- Archived bureaus -->\n\t\t<div class="page-template-a-main" ng-if="vm.archivedBureaus.length">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar count="filteredBureaus.length" options="searchBarOptions"></search-bar>\n\n\t\t\t<!-- Bureau cards -->\n\t\t\t<div class="bureau-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<bureau-card bulk-items="vm.archivedBureaus" bureau="bureau" current-page="searchBarOptions.currentPageNumber" dir-paginate="\n\t\t\t\t\t\tbureau in filteredBureaus = (\n\t\t\t\t\t\t\tvm.archivedBureaus |\n\t\t\t\t\t\t\tfilter : {Company: {Name: searchBarOptions.search.string}} |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter) |\n\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\t" refresh-bureaus="refreshArchivedBureaus"></bureau-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="filteredBureaus.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</div>\n\n\t\t<!-- No companies -->\n\t\t<placeholder ng-if="!vm.archivedBureaus.length" placeholder-graphic="no-archived-companies">\n\t\t\t<placeholder-title>You don\'t have any archived bureaus</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>When you archive bureaus they will appear here</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === PAGE_STATES.error"></error-block>\n');
$templateCache.put('features/app/companies/companiesView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Title -->\n\t\t<page-template-a-header icon="company" ng-if="!$root.userHasRole(\'groupadminlite\')" page-title="Companies" show-secondary-content="currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t<pt-secondary>\n\t\t\t\t<menu-button menu-button-id="create-company-menu-a" menu-button-text="New company" menu-button-theme="primary">\n\t\t\t\t\t<p class="dropdown-subtitle">In {{currentCompany.Name}}</p>\n\t\t\t\t\t<a href="" id="create-company-a" ng-click="openAddCompanyWizard()">Create company</a>\n\t\t\t\t\t<a href="" id="auto-create-company-a" ng-click="openAutoCreateCompanyForm()" ng-if="currentCompany.AgencyProfileDummy">Auto-create company</a>\n\t\t\t\t</menu-button>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- GAL Title -->\n\t\t<page-template-a-header icon="company" theme="is-greyscale has-border" ng-if="$root.userHasRole(\'groupadminlite\')" page-title="Hello {{currentUser.UserResponseFirstName}}">\n\t\t\t<pt-sub-heading>\n\t\t\t\t<h4 class="page-template-a-subheading">You have access to the following companies</h4>\n\t\t\t</pt-sub-heading>\n\t\t</page-template-a-header>\n\n\t\t<!-- Companies -->\n\t\t<main class="page-template-a-main" ng-if="companies.all.length">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar apply-filter-keys="applyFilter" filter-bar-options="filterBarOptions" ng-if="!$root.userHasRole(\'groupadminlite\')" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar bulk-actions-active="!$root.userHasRole(\'groupadminlite\')" bulk-items="companies" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a href="" ng-click="openAddCompaniesToCompanyGroupForm(companies.filtered)" ng-if="::currentUser.Permissions.Admin.canManageCompanyGroups">\n\t\t\t\t\t\tAdd to group\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="" ng-click="openRunBulkPayrollsForm(companies.filtered)" ng-if="::currentUser.Permissions.Payroll.canRunPayroll">\n\t\t\t\t\t\tRun payroll\n\t\t\t\t\t</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t</search-bar>\n\n\t\t\t<!-- Company Cards -->\n\t\t\t<div id="company-cards" class="company-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<company-card agency-profile-parent-id="agencyProfileParentId" bulk-items="companies" company="company" is-basic-view="company.Company.IsPayslipManagerActive || $root.userHasRole(\'groupadminlite\')" current-page="searchBarOptions.currentPageNumber" dir-paginate="company in companies.filtered = (\n\t\t\t\t\t\t\tcompanies.all |\n\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string : searchBarOptions.search.isExactMatch |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage" reload-companies="reloadCompanies()" reload-company="reloadCompany(company)"></company-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="companies.filtered.length === 0"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No companies -->\n\t\t<placeholder placeholder-graphic="no-companies" ng-if="!companies.all.length">\n\t\t\t<placeholder-title>You don\'t have any companies</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As companies are added they will start to appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions ng-if="::currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t\t<menu-button menu-button-id="create-company-menu-b" menu-button-text="New company" menu-button-theme="primary">\n\t\t\t\t\t<p class="dropdown-subtitle">In {{currentCompany.Name}}</p>\n\t\t\t\t\t<a href="" id="create-company-b" ng-click="openAddCompanyWizard()">Create company</a>\n\t\t\t\t\t<a href="" id="auto-create-company-b" ng-click="openAutoCreateCompanyForm()" ng-if="currentCompany.AgencyProfileDummy">Auto-create company</a>\n\t\t\t\t</menu-button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/companies-archived/companiesArchivedView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Title -->\n\t\t<page-template-a-header icon="archive" page-title="Archived Companies"></page-template-a-header>\n\n\t\t<!-- Companies -->\n\t\t<main class="page-template-a-main" ng-if="vm.archivedCompanies.length">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar options="searchBarOptions" count="filteredCompanies.length"></search-bar>\n\n\t\t\t<!-- Company Cards -->\n\t\t\t<div class="company-archived-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<company-archived-card company="company" on-update="refreshCompanies" dir-paginate="company in filteredCompanies = (vm.archivedCompanies | filter : {Company: {Name: searchBarOptions.search.string}} | filter : filterBarOptions.appliedFilter) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></company-archived-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredCompanies.length === 0"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No companies -->\n\t\t<placeholder placeholder-graphic="no-archived-companies" ng-if="!vm.archivedCompanies.length">\n\t\t\t<placeholder-title>You don\'t have any archived companies</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>When you archive companies they will appear here</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/companies-cloned/companies-cloned.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Title -->\n\t\t<page-template-a-header icon="duplicate" page-title="Cloned companies"></page-template-a-header>\n\n\t\t<!-- Companies -->\n\t\t<main class="page-template-a-main" ng-if="vm.clonedCompanies.length">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar options="searchBarOptions" count="filteredCompanies.length"></search-bar>\n\n\t\t\t<!-- Company Cards -->\n\t\t\t<div class="company-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<company-card company="company" current-page="searchBarOptions.currentPageNumber" dir-paginate="company in filteredCompanies = (\n\t\t\t\t\t\t\tvm.clonedCompanies |\n\t\t\t\t\t\t\tfilter : {\n\t\t\t\t\t\t\t\tCompany: {\n\t\t\t\t\t\t\t\t\tName: searchBarOptions.search.string\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage" is-clone="true" reload-companies="reloadCompanies()"></company-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredCompanies.length === 0"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No companies -->\n\t\t<placeholder placeholder-graphic="no-companies" ng-if="!vm.clonedCompanies.length">\n\t\t\t<placeholder-title>No payrolls cloned</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Once you start cloning payrolls they will appear here</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/company-dashboard/company-dashboard.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Period in Rollback -->\n\t\t<div class="page-template-a-action-bar" ng-if="$root.currentPeriod.IsRollback">\n\t\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t\t</div>\n\n\t\t<!-- Header -->\n\t\t<page-template-a-header icon="dashboard" page-title="Dashboard" secondary-content-type="info">\n\t\t\t<pt-secondary>\n\t\t\t\t<a data-cy="company-dashboard-go-to-payroll" href="" ng-if="::$root.currentUser.Permissions.isPayrollVisible" ng-href="{{$root.currentCompany.ngHref.payroll}}">\n\t\t\t\t\tGo to payroll <i class="icon-arrow-right"></i>\n\t\t\t\t</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Auto run -->\n\t\t<div class="page-template-a-section has-border-top" ng-if="company.Company.IsAutoRun && $root.currentUser.canSeeAutoRun">\n\t\t\t<notification-block icon="loading" icon-theme="is-quarternary">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tPayroll is set to Auto run on {{company.PayPeriod.ProcessDateISO | dateformat}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou will be notified when payroll has been successfully submitted\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<a class="button is-primary" href="" ui-sref="payroll.run-payroll({\n\t\t\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tRun payroll now\n\t\t\t\t\t</a>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- PAYE Scheme closed -->\n\t\t<div class="page-template-a-section has-border-top" ng-if="$root.currentCompany.CeasePAYESchemeComplete">\n\t\t\t<notification-block icon="cross" icon-theme="is-assertive">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tThis PAYE scheme has closed\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThe PAYE scheme with the reference {{$root.currentCompany.PAYERef}} was closed on {{$root.currentCompany.PAYECeaseDateISO | dateformat}}.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.closingPayeScheme" theme="is-assertive is-underline">\n\t\t\t\t\t\t\tRead more about closing a PAYE scheme\n\t\t\t\t\t\t</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<a class="button is-primary" ng-if="$root.currentCompany.HasPension" ui-sref="pensions.summary({\n\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tDisconnect your pension\n\t\t\t\t\t</a>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Archived -->\n\t\t<div class="page-template-a-section has-border-top" ng-if="$root.currentCompany.IsArchived">\n\t\t\t<notification-block icon="archive" icon-theme="is-greyscale">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tThis company was archived on {{::company.Company.ArchiveDateISO | dateformat}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tReason for archiving: {{::company.Company.ArchiveReason}}\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Compulsory submission -->\n\t\t<div class="page-template-a-section has-border-top" ng-if="company.PayPeriod.IsCompulsorySubmission">\n\t\t\t<notification-block icon="warning" icon-theme="is-assertive">\n\t\t\t\t<nb-details>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\tPayroll will be automatically submitted in {{company.PayPeriod.CompulsorySubmissionDaysAway}}\n\t\t\t\t\t\t<ng-pluralize count="company.PayPeriod.CompulsorySubmissionDaysAway" when="{\n\t\t\t\t\t\t\t\t\'1\': \'day\',\n\t\t\t\t\t\t\t\t\'other\': \'days\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tTo make sure your pension stays compliant, your payroll will be automatically submitted on {{company.PayPeriod.CompulsorySubmissionDateISO | dateformat:\'dayMonth\'}}.\n\t\t\t\t\t\t<a class="is-assertive is-underline" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tDisconnect pension\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</nb-details>\n\t\t\t\t<nb-actions>\n\t\t\t\t\t<a class="button is-primary" id="calculate-payroll-c" ui-sref="payroll.run-payroll({\n\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tRun payroll now\n\t\t\t\t\t</a>\n\t\t\t\t</nb-actions>\n\t\t\t</notification-block>\n\t\t</div>\n\n\t\t<!-- Workflow -->\n\t\t<div class="page-template-a-section has-border-top fadeIn" ng-if="company.Company.IsWorkflowEnabled && workflowState === \'ready\'">\n\t\t\t<workflow-status-block template-entry-current="workflowTemplateEntryCurrent"></workflow-status-block>\n\t\t</div>\n\n\t\t<!-- Main -->\n\t\t<div class="page-template-a-main">\n\n\t\t\t<!-- Company Overview -->\n\t\t\t<section class="page-template-a-section">\n\n\t\t\t\t<div class="overview-card-grid">\n\t\t\t\t\t<overview-card details="{\n\t\t\t\t\t\t\theader: {\n\t\t\t\t\t\t\t\ticon: payPeriod.icon,\n\t\t\t\t\t\t\t\ticonTheme: payPeriod.iconTheme,\n\t\t\t\t\t\t\t\tlayout: \'bar\',\n\t\t\t\t\t\t\t\tsubtitle: \'Pay day\',\n\t\t\t\t\t\t\t\ttag: payPeriod.dayCountDescription,\n\t\t\t\t\t\t\t\ttitle: payPeriod.payDateDescription\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\tmain: {\n\t\t\t\t\t\t\t\tbarPercentage: payPeriod.percentageComplete\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\tstats: [\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\tvalue: payPeriod.processDateDescription,\n\t\t\t\t\t\t\t\t\tdescription: \'Processing day\'\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\tvalue: payPeriod.payNotificationDateDescription,\n\t\t\t\t\t\t\t\t\tdescription: \'Pay notifications sent\'\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t]\n\t\t\t\t\t\t}">\n\t\t\t\t\t</overview-card>\n\t\t\t\t\t<overview-card details="{\n\t\t\t\t\t\t\theader: {\n\t\t\t\t\t\t\t\tchartData: {\n\t\t\t\t\t\t\t\t\tlabels: [\n\t\t\t\t\t\t\t\t\t\t\'Complete\',\n\t\t\t\t\t\t\t\t\t\t\'Incomplete\'\n\t\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t\t\tdatasets: [\n\t\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\t\tbackgroundColor: [\n\t\t\t\t\t\t\t\t\t\t\t\t\'#00819d\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'#bde1f0\'\n\t\t\t\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t\t\t\t\tborderAlign: \'inner\',\n\t\t\t\t\t\t\t\t\t\t\tborderColor: [\n\t\t\t\t\t\t\t\t\t\t\t\t\'#00819d\',\n\t\t\t\t\t\t\t\t\t\t\t\t\'#bde1f0\'\n\t\t\t\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t\t\t\t\tborderJoinStyle: \'miter\',\n\t\t\t\t\t\t\t\t\t\t\thoverBorderJoinStyle: \'miter\',\n\t\t\t\t\t\t\t\t\t\t\tdata: [\n\t\t\t\t\t\t\t\t\t\t\t\tcounts.NumberOfCompleteTeamMembers,\n\t\t\t\t\t\t\t\t\t\t\t\tcounts.NumberOfIncompleteTeamMembers\n\t\t\t\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t\t\t\t\thoverOffset: 5,\n\t\t\t\t\t\t\t\t\t\t\toffset: 0,\n\t\t\t\t\t\t\t\t\t\t\tborderWidth: 0,\n\t\t\t\t\t\t\t\t\t\t\tspacing: 0\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t]\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\ticon: \'team-alt\',\n\t\t\t\t\t\t\t\ticonTheme: \'is-primary is-light\',\n\t\t\t\t\t\t\t\tlayout: \'doughnut\',\n\t\t\t\t\t\t\t\tsubtitle: counts.NumberOfTeamMembers === 1 ? \'Team member\' : \'Team members\',\n\t\t\t\t\t\t\t\ttag: counts.NumberOfIncompleteTeamMembers + \' incomplete\',\n\t\t\t\t\t\t\t\ttitle: counts.NumberOfTeamMembers\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\tstats: [\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\tvalue: counts.NumberOfStarters,\n\t\t\t\t\t\t\t\t\tdescription: counts.NumberOfStarters === 1 ? \'New starter\' : \'New starters\',\n\t\t\t\t\t\t\t\t\ttype: \'number\'\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\tvalue: counts.NumberOfLeavers,\n\t\t\t\t\t\t\t\t\tdescription: counts.NumberOfLeavers === 1 ? \'Leaver\' : \'Leavers\',\n\t\t\t\t\t\t\t\t\ttype: \'number\'\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t]\n\t\t\t\t\t\t}" theme="is-style-b">\n\t\t\t\t\t\t<oc-footer-actions>\n\t\t\t\t\t\t\t<a class="is-small" href="" ui-sref="team.members({\n\t\t\t\t\t\t\t\t\tagencyProfileId\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tGo to team <i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</oc-footer-actions>\n\t\t\t\t\t</overview-card>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Activity -->\n\t\t\t<section class="page-template-a-section">\n\n\t\t\t\t<activity-block agency-profile-id="agencyProfileId" date-from="payPeriod.StartDateISO"></activity-block>\n\n\t\t\t</section>\n\t\t</div>\n\t</div>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/company-groups/companyGroupsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="company-groups" page-title="Company groups">\n\t\t\t<pt-secondary ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroups">\n\t\t\t\t<a href="" ng-click="openAddNewCompanyGroupForm()" class="button primary">\n\t\t\t\t\t<i class="icon-plus"></i>&nbsp;New company group\n\t\t\t\t</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Company Groups -->\n\t\t<main class="page-template-a-main" ng-if="companyGroups.all.length">\n\n\t\t\t<!-- Search / Filter -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="companyGroups"></search-bar>\n\n\t\t\t<!-- Company Group Cards -->\n\t\t\t<div class="company-group-cards {{searchBarOptions.layout}}">\n\n\t\t\t\t<company-group-card agency-profile-parent-id="agencyProfileParentId" company-group="companyGroup" company-groups="companyGroups" callback="refreshCompanyGroups()" dir-paginate="companyGroup in companyGroups.filtered = (companyGroups.all | filter : searchBarOptions.search.string ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></company-group-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="!companyGroups.filtered.length"></empty-search>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No Company Groups -->\n\t\t<placeholder placeholder-graphic="no-company-groups" ng-if="!companyGroups.all.length">\n\t\t\t<placeholder-title>You don\'t have any company groups</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As company groups are added they will start to appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ng-click="openAddNewCompanyGroupForm()" class="button primary">\n\t\t\t\t\t<i class="icon-plus"></i><span class="hidden-phone">&nbsp;New company group</span>\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/customisation/customisationView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="customiser fadeIn" ng-if="pageState === \'ready\'">\n\n\t<a href="" class="slide-in-form-tab primary" aria-label="Customise feature" ng-click="openCustomisationForm(featureKey)">\n\t\t<i class="icon-menu-alt slide-in-form-tab-icon"></i>\n\t</a>\n\n\t<div class="customiser-container">\n\n\t\t<header class="customiser-header">\n\t\t\t<p class="customiser-title">{{company.Name}} - Preview - {{customisationFeature.title}}</p>\n\t\t\t<a href="" ng-href="{{getHrefForCompanyType($root.currentCompany)}}" class="customiser-action"><i class="icon-cross"></i> Exit</a>\n\t\t</header>\n\n\t\t<section class="customiser-body" ng-switch="featureKey">\n\n\t\t\t<div class="customiser-feature-wrapper">\n\n\t\t\t\t<!-- Login -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="login">\n\t\t\t\t\t<img alt="" src="/images/graphics/customisation-features/0-large.png" class="customiser-feature-graphic">\n\t\t\t\t\t<div class="customiser-feature-background-colour" ng-style="{\'background-color\': customisation.Login.BackgroundColour}"></div>\n\t\t\t\t\t<div class="customiser-feature-company-details {{customisation.Login.TextShade}}">\n\t\t\t\t\t\t<div class="customiser-feature-logo" ng-if="customisation.Login.LogoURL !== \'\'">\n\t\t\t\t\t\t\t<img alt="" ng-src="{{customisation.Login.LogoURL}}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="fadeIn" ng-if="customisation.Login.IsAddressVisible">\n\t\t\t\t\t\t\t<h5 class="customiser-feature-company-name">{{customisation.AgencyProfileName}}</h5>\n\t\t\t\t\t\t\t<print-address class="customiser-feature-company-address" address="customisation.Login.Address"></print-address>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a href="tel:{{customisation.Login.Phone}}" class="underline customiser-feature-phone fadeIn" ng-if="customisation.Login.IsPhoneVisible">{{customisation.Contact.Phone}}</a>\n\t\t\t\t\t\t<a href="mailto:{{customisation.Login.EmailAddress}}" class="underline customiser-feature-email-address fadeIn" ng-if="customisation.Login.IsEmailAddressVisible">{{customisation.Contact.EmailAddress}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- App Header -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="app-header">\n\t\t\t\t\t<img alt="" src="/images/graphics/customisation-features/1-large.png" class="customiser-feature-graphic">\n\t\t\t\t\t<gradient-bar class="customiser-feature-decorator-bar" height="4" colour1="customisation.Branding.Colour1" colour2="customisation.Branding.Colour2"></gradient-bar>\n\t\t\t\t\t<img alt="" class="customiser-feature-icon" ng-if="customisation.LogoUrls.Icon !== \'\'" ng-src="{{customisation.LogoUrls.Icon}}">\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Email Footer -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="system-emails">\n\t\t\t\t\t<img alt="" src="/images/graphics/customisation-features/2-large.png" class="customiser-feature-graphic">\n\t\t\t\t\t<div class="customiser-feature-email-content">\n\t\t\t\t\t\t<img alt="" class="customiser-feature-email-logo" ng-src="{{customisation.Emails.LogoURL}}">\n\t\t\t\t\t\t<div class="fadeIn" ng-if="customisation.Login.IsAddressVisible">\n\t\t\t\t\t\t\t<p class="customiser-feature-email-text">{{customisation.AgencyProfileName}}, <print-address class="customiser-feature-email-address address inline small" address="customisation.Login.Address"></print-address></p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<p class="customiser-feature-email-text">Please do not reply to this message as it was sent from an unmonitored email address. <span ng-if="customisation.Emails.EmailAddress !== \'\'">For help, please contact <a href="mailto:{{customisation.Emails.EmailAddress}}">{{customisation.Emails.EmailAddress}}</a>.</span></p>\n\t\t\t\t\t\t<p class="customiser-feature-email-text" ng-if="customisation.Emails.EmailAccount !== \'\'">Please add <a href="mailto:{{customisation.Emails.EmailAccount}}">{{customisation.Emails.EmailAccount}}</a> to your contact list.</p>\n\t\t\t\t\t\t<powered-by-paycircle theme="less-padding"></powered-by-paycircle>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Online Payslips -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="online-payslips">\n\t\t\t\t\t<img alt="" class="customiser-feature-graphic" src="/images/graphics/customisation-features/3-large.png">\n\t\t\t\t\t<img alt="" class="customiser-feature-logo" ng-if="customisation.Payslips.LogoURL !== \'\'" ng-src="{{customisation.Payslips.LogoURL}}">\n\t\t\t\t\t<div class="customiser-feature-custom-container">\n\t\t\t\t\t\t<p class="customiser-feature-custom-message" ng-if="customisation.Payslips.CustomMessage !== \'\'">{{customisation.Payslips.CustomMessage}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="customiser-feature-contact" ng-if="customisation.Payslips.IsContactVisible && customisation.Contact.Forename !== \'\'">\n\t\t\t\t\t\t<h6>Contact</h6>\n\t\t\t\t\t\t<p>{{customisation.Contact.Forename}} {{customisation.Contact.Surname}}</p>\n\t\t\t\t\t\t<a href="mailto:{{customisation.Contact.EmailAddress}}">{{customisation.Contact.EmailAddress}}</a>\n\t\t\t\t\t\t<p>{{customisation.Contact.Phone}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Intercom -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="intercom" ng-if="company.CompanyType === INTERFACE_TYPES.bureau">\n\t\t\t\t\t<img alt="" class="customiser-feature-graphic" src="/images/graphics/customisation-features/4-large.png">\n\t\t\t\t\t<intercom-form customisation="customisation"></intercom-form>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employee Payroll customisation -->\n\t\t\t\t<div class="customiser-feature customiser-feature-{{featureKey}}" ng-switch-when="employee-portal">\n\t\t\t\t\t<img alt="" src="/images/graphics/customisation-features/5-large.png" class="customiser-feature-graphic">\n\t\t\t\t\t<img alt="" class="customiser-feature-employee-portal-logo" ng-src="{{customisation.SideBar.LogoURL}}">\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</section>\n\t</div>\n</section>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/data-importer.view.html','<ui-view></ui-view>');
$templateCache.put('features/app/document-preview/documentPreviewView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" show-logo="false">\n\t\t<action-bar-left>\n\t\t\t<a href="" class="button small" ng-click="goBack()">Close</a>\n\t\t</action-bar-left>\n\t\t<action-bar-right>\n\t\t\t<button class="is-small action-bar_action" ng-click="$root.print()" type="button">\n\t\t\t\tSave or Print\n\t\t\t</button>\t\t\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<div class="document b fadeIn">\n\n\t\t<!-- Postponement Notice -->\n\t\t<section class="page" ng-if="mailTypeId === MAIL_TYPES.postponementNotice">\n\n\t\t\t<header>\n\t\t\t\t<i class="icon-company xl"></i>\n\t\t\t\t<h6>{{::$root.currentCompany.Name}}</h6>\n\t\t\t\t<p class="s">Workplace Pension start date: <strong>{{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}</strong></p>\n\t\t\t\t<img alt="" class="logo" height="34" src="/images/paycircle-logo.png">\n\t\t\t</header>\n\t\t\t<article>\n\t\t\t\t<p>Hello,</p>\n\t\t\t\t<h4>Please read this carefully as it affects your pay</h4>\n\t\t\t\t<h5>Introducing \u2018Pension Auto Enrolment\u2019 for {{::$root.currentCompany.Name}}</h5>\n\t\t\t\t<p>You may have seen the adverts on TV \u2013 the Government and The Pensions Regulator have introduced a new scheme whereby all companies now have to offer a pension to their employees. The Government are trying to make sure that people start saving for their retirement earlier \u2013 so they have decided to implement a compulsory pension for working people in the UK.</p>\n\t\t\t\t<p>The date that {{::$root.currentCompany.Name}} have to set up their workplace pension by is {{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}, however your assessment has been deferred until {{deferraldate}}</p>\n\t\t\t\t<p>The new rules mean that people who meet certain criteria when they are assessed will be automatically enrolled into a workplace pension. People who do not meet the criteria will be invited to join and can opt in if they want to.</p>\n\t\t\t\t<h5>{{::$root.currentCompany.Name}} have opted to postpone the assessment of the team until {{ ::vm.pensionStaging.PostponementDateISO | dateformat:\'monthYear\' }}. However, should you wish to \u2018opt in\u2019 and start making contributions sooner, you can.</h5>\n\t\t\t\t<p>Anyone who is enrolled or who chooses to opt in to the workplace pension will make contributions from their pay each {{payperiod}} and, in most cases, {{company}} will contribute too.</p>\n\t\t\t\t<p>Please be aware, if you choose to \u2018opt in\u2019 to the workplace pension and you earn less than {{config.lowerEarningsLimit | monetise}} per year (that\u2019s {{config.lowerEarningsLimitMonthly | monetise}} per month or {{config.lowerEarningsLimitWeekly | monetise}} per week), you will not be entitled to contributions from your employer.</p>\n\t\t\t\t<!--<p>{{::$root.currentCompany.Name}} have chosen {{pensionprovider}} as their workplace pension provider.</p>-->\n\t\t\t\t<p>Read our full guidance notes for information</p>\n\t\t\t\t<p>It\u2019s important that you understand your rights as an employee, so please read our Guide to Workplace Pensions carefully to make sure you know what\u2019s going on and how you might be affected.</p>\n\t\t\t\t<p>Look out for our next email regarding the new pension and what it means to you</p>\n\t\t\t\t<p>{{::$root.currentCompany.Name}} works with Paycircle to help manage pay day for their team \u2013 this will now include managing the pension arrangements each {{payperiod}}. On behalf of {{company}}, we will be assessing everyone to see who needs to be automatically enrolled and who can opt in when the new pension comes into effect. Once you\u2019ve been assessed, we\u2019ll let you know your personal situation with regards to the new pension and make sure that you know how you can opt in or opt out.</p>\n\t\t\t\t<p>In the meantime, you will find lots more information in your Paycircle portal, including instructions for opting in. So, if you haven\u2019t already, make sure you register today.</p>\n\t\t\t\t<p>Best wishes,<br>The Paycircle Team</p>\n\t\t\t</article>\n\t\t\t<footer>\n\t\t\t\t<p class="s">&copy; Paycircle 2017. All rights reserved. www.paycircle.co.uk</p>\n\t\t\t</footer>\n\t\t</section>\n\n\t\t<!-- Pension Introduction -->\n\t\t<section class="page" ng-if="mailTypeId === MAIL_TYPES.pensionIntroduction">\n\n\t\t\t<header>\n\t\t\t\t<i class="icon-company xl"></i>\n\t\t\t\t<h6>{{::$root.currentCompany.Name}}</h6>\n\t\t\t\t<p class="s">Workplace Pension start date: <strong>{{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}</strong></p>\n\t\t\t\t<img alt="" class="logo" height="34" src="/images/paycircle-logo.png">\n\t\t\t</header>\n\t\t\t<article>\n\t\t\t\t<p>Hello,</p>\n\t\t\t\t<h4>Please read this carefully as it affects your pay</h4>\n\t\t\t\t<h5>Introducing \u2018Pension Auto Enrolment\u2019 for {{::$root.currentCompany.Name}}</h5>\n\t\t\t\t<p>You may have seen the adverts on TV \u2013 the Government and The Pensions Regulator have introduced a new scheme whereby all companies now have to offer a pension to their employees. The Government are trying to make sure that people start saving for their retirement earlier \u2013 so they have decided to implement a compulsory pension for working people in the UK.</p>\n\t\t\t\t<h5>The date that {{::$root.currentCompany.Name}} must have their pension set up by is {{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}</h5>\n\t\t\t\t<p>The new rules mean that people who meet certain criteria will be automatically enrolled into a workplace pension. People who do not meet the criteria will be invited to join and can opt in if they want to.</p>\n\t\t\t\t<p>Anyone enrolled in a workplace pension will make contributions from their pay each pay day and, in most cases, {{::$root.currentCompany.Name}} will contribute too.</p>\n\t\t\t\t<h5>Read our full guidance notes for information</h5>\n\t\t\t\t<p>It\u2019s important that you understand your rights as an employee, so please read our guidance notes carefully to make sure you know what\u2019s going on and how you might be affected.</p>\n\t\t\t\t<p>Look out for our next email regarding the new pension and what it means to you</p>\n\t\t\t\t<p>{{::$root.currentCompany.Name}} works with Paycircle to help manage pay day for their team \u2013 this will now include managing the pension arrangements each pay day. On behalf of {{::$root.currentCompany.Name}}, we will be assessing everyone to see who needs to be automatically enrolled and who can opt in when the new pension comes into effect. Once you\u2019ve been assessed, we\u2019ll let you know your personal situation with regards to the new pension and make sure that you know how you can opt in or opt out.</p>\n\t\t\t\t<p>In the meantime, you will find lots more information in your Paycircle portal. So, if you haven\u2019t already, make sure you register today.</p>\n\t\t\t\t<p>Best wishes,<br>The Paycircle Team</p>\n\t\t\t</article>\n\n\t\t\t<footer>\n\t\t\t\t<p class="s">&copy; Paycircle 2017. All rights reserved. www.paycircle.co.uk</p>\n\t\t\t</footer>\n\t\t</section>\n\n\t\t<!-- Assessment Status -->\n\t\t<section class="page" ng-if="mailTypeId === MAIL_TYPES.assessmentStatus">\n\n\t\t\t<header>\n\t\t\t\t<i class="icon-company xl"></i>\n\t\t\t\t<h6>{{::$root.currentCompany.Name}}</h6>\n\t\t\t\t<p class="s">Workplace Pension start date: <strong>{{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}</strong></p>\n\t\t\t\t<img alt="" class="logo" height="34" src="/images/paycircle-logo.png">\n\t\t\t</header>\n\n\t\t\t<article>\n\t\t\t\t<p>Hello,</p>\n\t\t\t\t<p>You have been assessed for automatic enrolment into {{::$root.currentCompany.Name}}\'s workplace pension scheme.</p>\n\t\t\t\t<p>As you met the criteria for automatic enrolment you have been enrolled and you will now be contributing a percentage of your pay each pay day into a pension and {{::$root.currentCompany.Name}} will be contributing too!</p>\n\t\t\t\t<p>If you do not want to participate in a company pension, you can opt out.</p>\n\t\t\t\t<p>If you want to know more about your contributions, please read this article and if you want to track your contributions, simply head to your Paycircle portal for more details.</p>\n\t\t\t\t<p>Best wishes,<br>The Paycircle Team</p>\n\t\t\t</article>\n\n\t\t\t<footer>\n\t\t\t\t<p class="s">&copy; Paycircle 2017. All rights reserved. www.paycircle.co.uk</p>\n\t\t\t</footer>\n\t\t</section>\n\n\t\t<!-- Compliance Follow-up -->\n\t\t<section class="page" ng-if="mailTypeId === MAIL_TYPES.complianceFollowUp">\n\n\t\t\t<header>\n\t\t\t\t<i class="icon-company xl"></i>\n\t\t\t\t<h6>{{::$root.currentCompany.Name}}</h6>\n\t\t\t\t<p class="s">Workplace Pension start date: <strong>{{ ::vm.pensionStaging.StagingDateISO | dateformat:\'monthYear\' }}</strong></p>\n\t\t\t\t<img alt="" class="logo" height="34" src="/images/paycircle-logo.png">\n\t\t\t</header>\n\n\t\t\t<article>\n\t\t\t\t<p>Hello,</p>\n\t\t\t\t<p>Over the last couple of weeks you will have received a few emails from Paycircle regarding the {{::$root.currentCompany.Name}} workplace pension.</p>\n\t\t\t\t<p>Whatever your status, it\u2019s important that you know your rights and options as an employee. To help you, we have produced a detailed guide that you can refer to anytime. We\u2019ve attached a copy to this email in PDF format and you will also find a copy in your Paycircle portal.</p>\n\t\t\t\t<p>Please take a little bit of time to read it and if you have any questions you can contact our support team anytime.</p>\n\t\t\t\t<p>You will also find lots more information in your portal. This is also where we will post status updates and provide you with everything you need to manage your workplace pension \u2013 including instructions for opting in or opting out of the scheme.</p>\n\t\t\t\t<p>So, if you haven\u2019t already, make sure you register today!</p>\n\t\t\t\t<p>Best wishes,<br>The Paycircle Team</p>\n\t\t\t</article>\n\n\t\t\t<footer>\n\t\t\t\t<p class="s">&copy; Paycircle 2017. All rights reserved. www.paycircle.co.uk</p>\n\t\t\t</footer>\n\t\t</section>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/email-preview/emailPreviewView.html','<loading-block ng-if="isLoading"></loading-block>\n\n<action-bar class="dropIn" ng-if="!isLoading" subtitle="Email Preview">\n\t<action-bar-right>\n\n\t\t<!-- Print -->\n\t\t<button class="button hidden-phone" ng-click="print()">\n\t\t\tPrint\n\t\t</button>\n\n\t\t<!-- Tablet+ -->\n\t\t<button class="button hidden-phone" ng-click="goBack()">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Mobile -->\n\t\t<a aria-label="Go back" class="action-bar-close visible-phone" href ng-click="goBack()">\n\t\t\t<i class="icon-cross tertiary"></i>\n\t\t</a>\n\t</action-bar-right>\n</action-bar>\n\n<div class="email-preview fadeIn" ng-if="!isLoading">\n\t<main class="email-preview-main" ng-class="{ \'is-full-screen\' : previewType === EMAIL_PREVIEW_TYPES.notificationSettingsPreview }">\n\t\t<div class="email-preview-header" ng-if="previewType === EMAIL_PREVIEW_TYPES.notificationSettingsPreview">\n\t\t\t<div class="email-preview-header-entry">\n\t\t\t\t<div class="email-preview-header-entry-title">\n\t\t\t\t\tSubject:\n\t\t\t\t</div>\n\t\t\t\t<div class="email-preview-header-entry-value">\n\t\t\t\t\t{{mailTemplate.MailTemplateSubject}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<iframe class="email-template-iframe" id="email-html" height="2000" width="600">\n\t\t</iframe>\n\t</main>\n\n\t<aside class="email-preview-aside" ng-class="{opened: openConfirmation}" ng-if="previewType === EMAIL_PREVIEW_TYPES.standard">\n\t\t<article>\n\t\t\t<span class="xs strong upcase">\n\t\t\t\tEmail\n\t\t\t</span>\n\t\t\t<h4 class="strong first">\n\t\t\t\t{{mailTemplate.MailTemplateName}}\n\t\t\t</h4>\n\t\t\t<div class="spacer s"></div>\n\n\t\t\t<!-- Send to team -->\n\t\t\t<section ng-if="teamMembers.length > 1">\n\t\t\t\t<p>\n\t\t\t\t\tThis email will be sent to <strong>{{teamMembers.length}} team members</strong>.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<!-- Send to individual -->\n\t\t\t<section ng-if="teamMembers.length === 1">\n\t\t\t\t<p>\n\t\t\t\t\tThis email will be sent to <strong>{{teamMembers[0].Forename}} {{teamMembers[0].Surname}}</strong>.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<p>Please note: all items in brackets will be replaced.</p>\n\n\t\t\t<!-- Automatic Sending Only -->\n\t\t\t<p ng-if="mailTemplate.MailTemplateAutomatic && !mailTemplate.MailTemplateSendManually">\n\t\t\t\tPaycircle will automatically send this email to your team members on your behalf when applicable.\n\t\t\t</p>\n\t\t</article>\n\n\t\t<div class="spacer m hidden-phone hidden-tablet"></div>\n\n\t\t<section class="hidden-tablet hidden-phone" ng-if="mailTemplate.MailTemplateSendManually && sendingState !== \'sent\'">\n\t\t\t<button class="button tertiary l" ng-click="toggleModal(\'sendEmail\')">\n\t\t\t\tSend email\n\t\t\t</button>\n\t\t</section>\n\n\t\t<!-- Success Message -->\n\t\t<section class="fadeIn" ng-if="sendingState === \'sent\'">\n\t\t\t<div class="info-block positive">\n\t\t\t\t<p class="strong s" ng-if="teamMembers.length > 1">\n\t\t\t\t\t<i class="icon-tick"></i>&nbsp;This email has been sent to {{teamMembers.length}} team members\n\t\t\t\t</p>\n\t\t\t\t<p class="strong s" ng-if="teamMembers.length === 1">\n\t\t\t\t\t<i class="icon-tick"></i>&nbsp;This email has been sent to {{teamMembers[0].Forename}} {{teamMembers[0].Surname}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="spacer m"></div>\n\t\t\t<p class="s strong">\n\t\t\t\t<a href="" ng-click="goBack()">\n\t\t\t\t\t<i class="icon-left"></i>Ok, go back to communications\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</section>\n\t</aside>\n\n\t<footer class="email-preview-footer hidden-desktop">\n\t\t<a class="float-right tertiary strong" href ng-click="showConfirmation()" ng-if="!openConfirmation">\n\t\t\tNext&nbsp;&nbsp;&nbsp;<i class="icon-right m"></i>\n\t\t</a>\n\t\t<a class="float-left tertiary strong" href ng-click="showConfirmation()" ng-if="openConfirmation">\n\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;&nbsp;Back\n\t\t</a>\n\t\t<section ng-if="mailTemplate.MailTemplateSendManually && sendingState !== \'sent\' && openConfirmation">\n\t\t\t<button class="button tertiary float-right" ng-click="toggleModal(\'sendEmail\')">\n\t\t\t\tSend email\n\t\t\t</button>\n\t\t</section>\n\t</footer>\n\n</div>\n\n<!-- Modal: Download -->\n<div class="modal primary m fadeIn" ng-if="modal.download">\n\t<div class="modal_overlay"></div>\n\t<div class="modal_window">\n\t\t<div class="modal_header">\n\t\t\t<h4 class="modal_title">\n\t\t\t\tDownload report\n\t\t\t</h4>\n\t\t\t<a aria-label="Toggle modal" class="modal_close" href ng-click="toggleModal(\'download\')">\n\t\t\t\t<i class="close icon-cross is-large"></i>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="modal_body">\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<p>\n\t\t\t\t\tTo download your report you can save this page as a PDF.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tTo save this page as a PDF:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<ul class="todo-list">\n\t\t\t\t\t<li class="todo-list-item complete">\n\t\t\t\t\t\t<i class="icon-tick"></i> Click the &ldquo;Print&rdquo; button below\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="todo-list-item complete">\n\t\t\t\t\t\t<i class="icon-tick"></i> Change printer destination to  &ldquo;Save as PDF&rdquo;\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="todo-list-item complete">\n\t\t\t\t\t\t<i class="icon-tick"></i> Click  &ldquo;Save&rdquo; and give your report a name\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal_footer">\n\t\t\t<button class="button is-small" ng-click="toggleModal(\'download\')">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="button is-small is-tertiary" ng-click="$root.print()">\n\t\t\t\tPrint\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Modal: Send Email -->\n<div class="modal primary m fadeIn" ng-if="modal.sendEmail">\n\t<div class="modal_overlay"></div>\n\t<div class="modal_window">\n\t\t<div class="modal_header">\n\t\t\t<h4 class="modal_title">\n\t\t\t\tAre you sure?\n\t\t\t</h4>\n\t\t\t<a aria-label="Toggle modal" class="modal_close" href ng-click="toggleModal(\'sendEmail\')">\n\t\t\t\t<i class="close icon-cross is-large"></i>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="modal_body">\n\t\t\t<p ng-if="context === \'company\'">\n\t\t\t\tAre you sure you want to send this email to your team? Once sent it is not possible to cancel.\n\t\t\t</p>\n\t\t\t<p ng-if="context === \'individual\'">\n\t\t\t\tAre you sure you want to send this email to {{teamMembers[0].Forename}} {{teamMembers[0].Surname}}? Once sent it is not possible to cancel.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="modal_footer">\n\t\t\t<button class="button" ng-click="toggleModal(\'sendEmail\')">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<button class="is-tertiary" ng-class="{\'success\': sendingState === \'sent\'}" ng-click="sendMail(teamMembers)" ng-disabled="sendingState === \'sending\'">\n\t\t\t\t<span ng-if="sendingState === \'\'">Send</span>\n\t\t\t\t<span ng-if="sendingState === \'sending\'"><i class="icon-loading spin"></i></span>\n\t\t\t\t<span ng-if="sendingState === \'sent\'"><i class="icon-tick"></i></span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('features/app/eps-importer/epsImporterView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="user-importer fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="EPS Importer">\n\t\t<action-bar-right>\n\t\t\t<a ui-sref="company-dashboard({agencyProfileId: agencyProfileId})" class="button">{{currentPayPeriod.WorkerImportState > SUBMISSION_STATES.unsubmitted ? \'Close\' : \'Cancel import\'}}</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- EPS Import States -->\n\t<div class="user-importer-body" ng-switch="currentPayPeriod.WorkerImportState" nv-file-drop nv-file-over uploader="uploader">\n\n\t\t<!-- Progress bar -->\n\t\t<section class="progress-step-bar">\n\t\t\t<status-directive step-name="Upload" step="1" active="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.unsubmitted" finished="currentPayPeriod.WorkerImportState > SUBMISSION_STATES.unsubmitted"></status-directive>\n\t\t\t<status-directive step-name="Importing" step="2" active="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.submitting" finished="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.verified"></status-directive>\n\t\t\t<status-directive step-name="Complete" step="3" active="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.finished" finished="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.finished"></status-directive>\n\t\t</section>\n\n\t\t<!-- Invalid File Format -->\n\t\t<main class="user-importer-state" ng-switch-when="-1">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/error-doc.png">\n\n\t\t\t<h3 class="user-importer-state-title">Invalid file type</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>The type of file you\'ve tried to upload doesn\'t appear to be a valid XML file.</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<a href="" ng-click="resetImporter(currentPayPeriod)" class="underline">Go back and try again</a>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Unsubmitted -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.unsubmitted">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/start-doc.png">\n\n\t\t\t<h3>Drag and drop an EPS file here to upload</h3>\n\n\t\t\t<div class="spacer xs"></div>\n\n\t\t\t<div class="user-importer-file-uploader">\n\t\t\t\t<label>\n\t\t\t\t\t<input id="fileUpload" type="file" accept="text/xml" nv-file-select uploader="uploader">\n\t\t\t\t\t<p>or <span class="primary"> click here to select a file from your computer</span></p>\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class="spacer m"></div>\n\n\t\t\t<p class="s"><span class="tag tertiary inverse">Important</span>&nbsp;&nbsp;This must be the most recent EPS to prevent the import from failing and prevent data mis-alignment</p>\n\n\t\t\t<div class="drop-zone-overlay user-importer-drop-zone"></div>\n\t\t</main>\n\n\t\t<!-- Submitting -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.submitting">\n\n\t\t\t<progress-ring pr-icon="icon-upload" pr-percentage="uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\n\t\t\t<p class="user-importer-filename" ng-if="uploadFilename">{{uploadFilename}}</p>\n\n\t\t\t<h3 class="user-importer-state-title">Paycircle is uploading your file</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>This should only take a moment and we\'ll let you know once the data has been imported.</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<p class="strong"><span class="tertiary">Important:</span> please don\'t close your browser until the upload is complete!</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Verified -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.verified">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" src="../../images/graphics/finish-doc.png" height="70">\n\n\t\t\t<h3 class="user-importer-state-title">Your file is ready to import</h3>\n\t\t\t<button class="round tertiary l" ng-click="importData(currentPayPeriod)">Import</button>\n\t\t</main>\n\n\t\t<!-- Processing / Importing Workers into Paycircle -->\n\t\t<main class="user-importer-state" pc-switch-when="[SUBMISSION_STATES.processing1, SUBMISSION_STATES.processing2]">\n\n\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t<h3 class="user-importer-state-title">Importing EPS information</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>Your import may take a little while. In the meantime you\'re safe to <a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="underline">close the importer</a>.</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Finished -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.finished">\n\n\t\t\t<h2 class="user-importer-state-title">That\'s it, your import is complete!</h2>\n\t\t\t<div>\n\t\t\t\t<a ui-sref="company-dashboard({agencyProfileId: agencyProfileId})" class="button tertiary l">Go to dashboard</a>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Failed -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t<img alt="" class="user-importer-state-graphic" src="../../images/graphics/error-doc.png" height="70">\n\t\t\t<h3 class="user-importer-state-title">There was a problem verifying your file</h3>\n\t\t\t<p>We could not import this EPS, please ensure it\'s for the pay period before the first one set up in Paycircle.</p>\n\t\t\t<div class="spacer s"></div>\n\t\t\t<p>You can reset your import and try again. If you continue to have problems please contact Paycircle Support</p>\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<a href="" ng-click="resetEPSImportStatus(currentPayPeriod)" class="button tertiary l">Reset import</a>\n\t\t</main>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/fps-importer/fpsImporterView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="user-importer fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="FPS Importer">\n\t\t<action-bar-right>\n\t\t\t<a href="" ng-click="resetWorkerImportStatus(currentPayPeriod)" class="button">Reset import</a>\n\t\t\t<a href="" ng-click="closeImporter()" class="button">{{currentPayPeriod.WorkerImportState > SUBMISSION_STATES.unsubmitted ? \'Close\' : \'Cancel import\'}}</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- FPS Import States -->\n\t<div class="user-importer-body" ng-switch="currentPayPeriod.WorkerImportState" nv-file-drop nv-file-over uploader="uploader">\n\n\t\t<!-- Progress bar -->\n\t\t<section class="progress-step-bar">\n\t\t\t<status-directive step-name="Upload" step="1" active="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.unsubmitted" finished="currentPayPeriod.WorkerImportState > SUBMISSION_STATES.unsubmitted"></status-directive>\n\t\t\t<status-directive step-name="Importing" step="2" active="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.submitting" finished="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.verified"></status-directive>\n\t\t\t<status-directive step-name="Complete" step="3" active="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.finished" finished="currentPayPeriod.WorkerImportState >= SUBMISSION_STATES.finished"></status-directive>\n\t\t</section>\n\n\t\t<!-- Invalid File Format -->\n\t\t<main class="user-importer-state" ng-switch-when="-1">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/error-doc.png">\n\n\t\t\t<h3 class="user-importer-state-title">Invalid file type</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>The type of file you\'ve tried to upload doesn\'t appear to be a valid XML file.</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<a href="" ng-click="resetImporter(currentPayPeriod)" class="underline">Go back and try again</a>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Unsubmitted -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.unsubmitted">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/start-doc.png">\n\n\t\t\t<h3>Drag and drop an FPS file here to upload</h3>\n\n\t\t\t<div class="spacer xs"></div>\n\n\t\t\t<div class="user-importer-file-uploader">\n\t\t\t\t<label>\n\t\t\t\t\t<input id="fileUpload" type="file" accept="text/xml" nv-file-select uploader="uploader">\n\t\t\t\t\t<p>or <span class="primary"> click here to select a file from your computer</span></p>\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class="spacer m"></div>\n\n\t\t\t<p class="s"><span class="tag tertiary inverse">Important</span>&nbsp;&nbsp;This must be the most recent FPS to prevent the import from failing and prevent data mis-alignment</p>\n\n\t\t\t<div class="drop-zone-overlay user-importer-drop-zone"></div>\n\t\t</main>\n\n\t\t<!-- Submitting -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.submitting">\n\n\t\t\t<progress-ring pr-icon="icon-upload" pr-percentage="uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\n\t\t\t<p class="user-importer-filename" ng-if="uploadFilename">{{uploadFilename}}</p>\n\n\t\t\t<h3 class="user-importer-state-title">Paycircle is uploading your file</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>This should only take a moment and we\'ll let you know once the data has been imported.</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<p class="strong"><span class="tertiary">Important:</span> please don\'t close your browser until the upload is complete!</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Verified -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.verified">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/finish-doc.png">\n\n\t\t\t<h3 class="user-importer-state-title">Your file is ready to import</h3>\n\t\t\t<p>We\'ll import the following data to payroll:</p>\n\t\t\t<div class="spacer s"></div>\n\n\t\t\t<!-- Number of workers being imported -->\n\t\t\t<h5 ng-if="numberOfWorkers > 0"><span class="tertiary">{{numberOfWorkers}}</span>&nbsp;<ng-pluralize count="numberOfWorkers" when="{\'1\': \'update\', \'other\': \'updates\'}"></ng-pluralize>&nbsp;will be made</h5>\n\n\t\t\t<!-- Number of workers being imported -->\n\t\t\t<h5 ng-if="numberOfNewStarters > 0"><span class="tertiary">{{numberOfNewStarters}}</span>&nbsp;<ng-pluralize count="numberOfNewStarters" when="{\'1\': \'new starter\', \'other\': \'new starters\'}"></ng-pluralize>&nbsp;will be added</h5>\n\n\t\t\t<!-- Number of skipped results -->\n\t\t\t<h5 ng-if="numberOfSkippedResults > 0"><span class="tertiary">{{numberOfSkippedResults}}</span>&nbsp;<ng-pluralize count="numberOfSkippedResults" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;were skipped</h5>\n\n\t\t\t<div class="spacer s"></div>\n\t\t\t<p>Once imported, you can start adding your changes</p>\n\t\t\t<div class="spacer xl"></div>\n\n\t\t\t<div class="user-importer-state-action">\n\t\t\t\t<div class="confirmation-block tertiary-light has-font-weight-normal">\n\t\t\t\t\t<h6>Do you wish to use HMRC Submission IDs as Payroll IDs?</h6>\n\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t<p class="is-small is-greyscale-darkened">\n\t\t\t\t\t\tThe HMRC Submission IDs in your FPS file will be used as Payroll IDs in Paycircle unless you uncheck the box below. Paycircle will then auto-generate Payroll IDs for you instead.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t<input checkbox class="s" id="setInternalId" label-text="\'Yes, use HMRC Submission IDs as Payroll IDs\'" name="setInternalId" ng-model="currentPayPeriod.setInternalId" required type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<button class="round tertiary l" ng-click="importData(currentPayPeriod)">Import</button>\n\t\t</main>\n\n\t\t<!-- Processing / Importing Workers into Paycircle -->\n\t\t<main class="user-importer-state" pc-switch-when="[SUBMISSION_STATES.processing1, SUBMISSION_STATES.processing2]">\n\n\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t<h3 class="user-importer-state-title">Importing worker information</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>Your import may take a little while and we\'ll email you when it\'s done. In the meantime you\'re safe to <a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="underline">close the importer</a>.</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Critical Errors -->\n\t\t<main class="user-importer-state" ng-switch="currentPayPeriod.WorkerImportState" pc-switch-when="SUBMISSION_STATES.haserrors2">\n\n\t\t\t<h4 class="user-importer-state-title">We\'ve found <strong>{{validationResults.length}}</strong> serious&nbsp;<ng-pluralize count="validationResults.length" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;with your import</h4>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p class="s">This could cause serious problems with your payroll so please contact Paycircle Support and we can help you to fix them.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Validator -->\n\t\t\t<div class="user-importer-validator assertive">\n\n\t\t\t\t<!-- Previous -->\n\t\t\t\t<a href="" class="user-importer-validator-previous" ng-class="{\'disabled\': currentIndex === 0}" ng-click="goToPrevious(validationResults, validationForm)" ng-if="validationResults.length > 1">&angrt;</a>\n\n\t\t\t\t<!-- Worker -->\n\t\t\t\t<div class="user-importer-validator-mask">\n\n\t\t\t\t\t<div class="user-importer-validator-result {{animationStep}}">\n\n\t\t\t\t\t\t<!-- Header -->\n\t\t\t\t\t\t<header class="user-importer-validator-header">\n\t\t\t\t\t\t\t<h5 class="user-importer-validator-worker-name">{{validationResult.worker.UserImportForename}} {{validationResult.worker.UserImportSurname}}</h5>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<!-- Main -->\n\t\t\t\t\t\t<main class="user-importer-validator-main">\n\n\t\t\t\t\t\t\t<form name="validationForm" ng-submit="updateUserInImport(validationResult, validationResults, currentPayPeriod, validationForm)" ng-switch="validationResult.ValidationType.ValidationTypeID">\n\n\t\t\t\t\t\t\t\t<!-- Everything else -->\n\t\t\t\t\t\t\t\t<section class="user-importer-validator-field">\n\n\t\t\t\t\t\t\t\t\t<!-- Title -->\n\t\t\t\t\t\t\t\t\t<h5 class="user-importer-validator-field-title">{{validationResult.isUpdated ? \'This entry has been updated\' : validationResult.ValidationType.validationTitle}}</h5>\n\n\t\t\t\t\t\t\t\t\t<!-- Value (read-only) -->\n\t\t\t\t\t\t\t\t\t<span class="user-importer-validator-field-read-only">{{validationResult.worker[validationResult.validationPropertyKey] || \'No value provided\' }}</span>\n\n\t\t\t\t\t\t\t\t\t<!-- Important! -->\n\t\t\t\t\t\t\t\t\t<p class="user-importer-validator-field-description">This issue could cause serious problems with your payroll</p>\n\t\t\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t\t\t<!-- Serious Errors (Contact Support) -->\n\t\t\t\t\t\t\t\t<footer class="user-importer-validator-actions align-center">\n\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Next -->\n\t\t\t\t<a href="" class="user-importer-validator-next" ng-class="{\'disabled\': currentResultNumber === validationResults.length}" ng-if="validationResults.length > 1" ng-click="goToNext(validationResults, currentPayPeriod, validationForm)">&angrt;</a>\n\t\t\t</div>\n\n\t\t\t<h5>{{currentResultNumber}}&nbsp;<span class="light">of</span>&nbsp;{{validationResults.length}}</h5>\n\t\t</main>\n\n\t\t<!-- Finished -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.finished">\n\n\t\t\t<h2 class="user-importer-state-title">That\'s it, your import is complete!</h2>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>You\'re all set to start getting your team ready for payroll</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<a ui-sref="team.members({agencyProfileId: agencyProfileId})" class="button tertiary l">Go to team</a>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Failed -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/error-doc.png">\n\t\t\t<h3 class="user-importer-state-title">There was a problem verifying your file</h3>\n\t\t\t<p>We could not import this FPS, please ensure it\'s for the pay period before the first one set up in Paycircle.</p>\n\t\t\t<div class="spacer s"></div>\n\t\t\t<p>You can reset your import and try again. If you continue to have problems please contact Paycircle Support</p>\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<a data-cy="fps-importer-failed-reset-import" href="" ng-click="resetWorkerImportStatus(currentPayPeriod)" class="button tertiary l">Reset import</a>\n\t\t</main>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/hr/hrView.html','<ui-view></ui-view>\n');
$templateCache.put('features/app/identity/identity.view.html','<loading-block></loading-block>');
$templateCache.put('features/app/manage-linked-accounts/manage-linked-accounts.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<div class="page-template-a-action-bar">\n\t\t\t<a class="link-with-icon greyscale" href="" ng-click="vm.goBack()">\n\t\t\t\t<i class="icon-back"></i>Back\n\t\t\t</a>\n\t\t</div>\n\n\t\t<br>\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="split" page-title="Linked accounts">\n\t\t\t<!-- Optional Secondary Menu -->\n\t\t\t<pt-secondary>\n\t\t\t\t<a class="button primary" href="" ng-click="vm.linkAccount()">\n\t\t\t\t<i class="icon-add"></i>&nbsp;Add linked account</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<div class="empty-state" ng-if="vm.linkedAccounts.length === 0">\n\t\t\t\t<placeholder placeholder-graphic="no-companies">\n\t\t\t\t\t<placeholder-title>You don\'t have any linked accounts</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIf you use multiple accounts to access the Payroll Portal and Pay Portal, you can link\n\t\t\t\t\t\t\tthem to the account you\'re currently signed into so you only need to use one account.\n\t\t\t\t\t\t\tYou\'ll be able to switch to any of your linked accounts at any time.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t<a class="button primary" href="" ng-click="vm.linkAccount()">\n\t\t\t\t\t\t\t<i class="icon-add"></i>&nbsp;Add linked account\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\n\t\t\t<div class="detail-blocks" ng-if="vm.linkedAccounts.length > 0">\n\t\t\t\t\t<detail-block db-details="vm.payrollAccountDetails" db-edit-text="\'Unlink\'" ng-if="vm.payrollAccountDetails.detailGroups.length > 0">\n\t\t\t\t\t</detail-block>\n\t\t\t\t\t<detail-block db-edit-text="\'Unlink\'" db-details="vm.payPortalAccountDetails" ng-if="vm.payPortalAccountDetails.detailGroups.length > 0">\n\t\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/my-tasks/myTasksPayrollView.html','<loading-block ng-if="vm.pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main" ng-if="vm.pageState === \'ready\'">\n\n\t<div ng-if="vm.payrollTasks.tasks.all.length">\n\n\t\t<filter-bar filter-bar-options="filterBarOptions" apply-filter-keys="applyFilter"></filter-bar>\n\n\t\t<search-bar options="searchBarOptions" count="vm.payrollTasks.tasks.filtered.length">\n\t\t\t<sb-actions>\n\t\t\t\t<div>\n\t\t\t\t\t<toggle-input field-label="Show complete" field-model="vm.payrollTasks.showComplete" field-name="showComplete"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</sb-actions>\n\t\t</search-bar>\n\n\t\t<div class="period-task-card_wrapper">\n\t\t\t<period-task-card task="task" show-task-company="vm.payrollTasks.showTaskCompany" update-tasks-count="vm.updatePayrollTasksCount(vm.payrollTasks)" refresh-tasks="vm.refreshTasks()" ng-repeat="task in vm.payrollTasks.tasks.filtered = ( vm.payrollTasks.tasks.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter | tasksOrder: vm.payrollTasks.showComplete)"></period-task-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.payrollTasks.tasks.filtered.length === 0 && searchBarOptions.search.string !== \'\'"></empty-search>\n\n\t\t<!-- All tasks completed -->\n\t\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="!vm.payrollTasks.showComplete && vm.payrollTasks.tasks.filtered.length === 0">\n\t\t\t<placeholder-title>All tasks have been completed</placeholder-title>\n\t\t</placeholder>\n\n\t</div>\n\n\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="vm.pageState === \'ready\' && !vm.payrollTasks.tasks.all.length">\n\t\t<placeholder-title>Your payroll task list is empty</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As tasks are assigned to you in company payrolls they will appear here</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</main>\n');
$templateCache.put('features/app/my-tasks/myTasksView.html','<div class="page-template-a fadeIn">\n\n\t<div class="page-template-a-wrapper" ng-switch="activeTab">\n\n\t\t<page-template-a-header icon="tick-square" page-title="My tasks"></page-template-a-header>\n\n\t\t<!-- Tabs -->\n\t\t<section class="page-template-a-navigation">\n\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t<a class="tabs-item has-counter" ui-sref="my-tasks.workflow" ui-sref-active="active">\n\t\t\t\t\tWorkflow\n\t\t\t\t\t<span class="tabs-item-counter tag primary" ng-class="{\'assertive\': vm.workflowTasks.hasOverdueTasks, \'inverse\': vm.isStateActive(\'my-tasks.workflow\'), \'tada\': vm.pageState === \'ready\'}">\n\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="vm.pageState === \'loading\'"></i>\n\t\t\t\t\t\t<span ng-if="vm.pageState === \'ready\'">{{vm.workflowTasks.taskCount | nineMax}}</span>\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\t\t\t\t<a class="tabs-item has-counter" ui-sref="my-tasks.payroll" ui-sref-active="active">\n\t\t\t\t\tPayroll\n\t\t\t\t\t<span class="tabs-item-counter tag primary" ng-class="{\'assertive\': vm.payrollTasks.hasOverdueTasks, \'inverse\': vm.isStateActive(\'my-tasks.payroll\'), \'tada\': vm.pageState === \'ready\'}">\n\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="vm.pageState === \'loading\'"></i>\n\t\t\t\t\t\t<span ng-if="vm.pageState === \'ready\'">{{vm.payrollTasks.incompleteTaskCount | nineMax}}</span>\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\t\t\t</nav>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="vm.pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/my-tasks/myTasksWorkflowView.html','<loading-block ng-if="vm.pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main" ng-if="vm.pageState === \'ready\'">\n\n\t<div ng-if="vm.workflowTasks.tasks.all.length">\n\n\t\t<filter-bar filter-bar-options="filterBarOptions" apply-filter-keys="applyFilter"></filter-bar>\n\n\t\t<search-bar options="searchBarOptions" bulk-items="vm.workflowTasks.tasks">\n\t\t\t<sb-bulk-actions>\n\t\t\t\t<a href="" ng-click="openReassignWorkflowTaskForm(vm.workflowTasks.tasks.filtered)">Re-assign</a>\n\t\t\t</sb-bulk-actions>\n\t\t</search-bar>\n\n\t\t<div class="workflow-task-card_wrapper">\n\t\t\t<workflow-task-card task="task" index="$index" refresh-tasks="vm.refreshTasks()" omit-current-user="true" bulk-items="vm.workflowTasks.tasks" ng-repeat="task in vm.workflowTasks.tasks.filtered = ( vm.workflowTasks.tasks.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse )"></workflow-task-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.workflowTasks.tasks.filtered.length === 0"></empty-search>\n\t</div>\n\n\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="vm.pageState === \'ready\' && !vm.workflowTasks.tasks.all.length">\n\t\t<placeholder-title>Your workflow task list is empty</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As workflow tasks are assigned to you they will appear here</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</main>\n');
$templateCache.put('features/app/onboarding-dashboard/onboarding-dashboard.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'" ng-switch="company.Company.State">\n\n\t<!-- Demo -->\n\t<div class="page-template-b page-template-b--white" pc-switch-when="COMPANY_STATES.demo">\n\t\t<div class="page-template-b-wrapper">\n\t\t\t<div class="page-template-b-header align-center">\n\t\t\t\t<h2 class="page-template-b-title"><i class="icon-dashboard tertiary"></i>&nbsp; Hi {{currentUser.UserResponseFirstName}}</h2>\n\t\t\t\t<h4 class="page-template-b-subtitle tertiary">Welcome to your demo dashboard</h4>\n\t\t\t</div>\n\n\t\t\t<div class="progress-block progress-block--tricolumn page-template-b-dashboard" ng-class="{\'secondary\' : onboardingDashboard.IsDemoComplete, \'quarternary\' : !onboardingDashboard.IsDemoComplete}">\n\t\t\t\t<div class="progress-block__graphic">\n\t\t\t\t\t<img alt="" ng-if="!onboardingDashboard.IsDemoComplete" src="/images/graphics/onboarding/demo-wizard-1.png" width="220">\n\t\t\t\t\t<img alt="" ng-if="onboardingDashboard.IsDemoComplete" src="/images/graphics/onboarding/demo-wizard-2.png" width="220">\n\t\t\t\t</div>\n\t\t\t\t<div class="progress-block__background">\n\t\t\t\t\t<div class="progress-block__layout">\n\t\t\t\t\t\t<div class="progress-block__copy" ng-if="!onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t\t<p class="stronger">\n\t\t\t\t\t\t\t\tComplete the tasks for each group below to unlock the Approve payroll button!\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__copy" ng-if="onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t\t<h5>Hurrah, great job!</h5>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tYou\u2019ve completed all tasks and approved your first payroll\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__progress" ng-if="!onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t\t{{onboardingDashboard.DemoPercentComplete}}%&nbsp;<progress-bar pb-percentage="onboardingDashboard.DemoPercentComplete" pb-theme="is-white"></progress-bar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__progress" ng-if="onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t\t100%&nbsp;<progress-bar pb-percentage="100" pb-theme="is-white"></progress-bar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__next" ng-if="onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t\t<h6 class="progress-block__next-copy">\n\t\t\t\t\t\t\t\tYou\u2019re ready to start onboarding your company\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t<button class="progress-block__next-button" ng-click="openMoveToOnboardingModal(modalOptions.moveToOnboarding, $root.currentCompany)">Start onboarding now <i class="icon-chevron-right"></i></button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<question-block-demo agency-profile-id="company.Company.AgencyProfileID" pensions="pension.Pensions" qb-group="group" qb-on-update="refreshOnboardingDashboard" ng-repeat="group in onboardingDashboard.Questions.QuestionGroups"></question-block-demo>\n\n\t\t\t<div class="question-block-demo approve-payroll" ng-class="{\'locked\': !onboardingDashboard.demoTasksComplete}">\n\t\t\t\t<div class="question-block-demo__card">\n\t\t\t\t\t<div class="question-block-demo__icon">\n\t\t\t\t\t\t<i class="gradient" ng-if="!onboardingDashboard.IsDemoComplete" ng-class="{\'icon-padlock primary\': !onboardingDashboard.demoTasksComplete, \'icon-clock white\' : onboardingDashboard.demoTasksComplete }"></i>\n\t\t\t\t\t\t<i class="icon-check white" ng-if="onboardingDashboard.IsDemoComplete"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="question-block-demo__details">\n\t\t\t\t\t\t<h4 class="question-block-demo__name">Approve payroll</h4>\n\t\t\t\t\t\t<p class="question-block-demo__copy">\n\t\t\t\t\t\t\tComplete all tasks to unlock the \u2018Approve payroll\u2019 button!\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="question-block-demo__action" ng-if="!onboardingDashboard.IsDemoComplete">\n\t\t\t\t\t\t<button class="primary m question-block-demo__button" ng-click="approvePayroll()"><i class="icon-padlock" ng-if="!onboardingDashboard.demoTasksComplete"></i>Approve payroll</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Cancel trial -->\n\t\t\t<section class="page-template-b-footer align-center">\n\t\t\t\t<p class="s">\uD83D\uDE22 Want to cancel your free trial? <a href="" ng-click="openCancelTrialForm()" class="underline">Click here</a></p>\n\n\t\t\t\t<!--\n\t\t\t\t<p class="s" ng-if="userHasRole(\'paycircle\')">\n\t\t\t\t\t<br>\n\t\t\t\t\t<span class="stronger">Paycircle internal demo testing tools</span> <br>\n\t\t\t\t\t<a href class="secondary" ng-click="completeDemoForMe(onboardingDashboard, true, false)">Complete demo for me</a> <br>\n\t\t\t\t\t<a href class="assertive" ng-click="completeDemoForMe(onboardingDashboard, true, true)">Complete demo for me (ignore approve payroll)</a> <br>\n\t\t\t\t\t<a href class="assertive" ng-click="completeDemoForMe(onboardingDashboard, false, false)">Clear demo for me</a> <br>\n\t\t\t\t\t<i>(refresh page after click)</i> <br><br>\n\t\t\t\t\t<a href class="assertive" ng-click="openMoveToOnboardingModal(modalOptions.moveToOnboarding, company)">Open onboarding modal</a>\n\t\t\t\t</p>\n\t\t\t\t-->\n\t\t\t</section>\n\n\t\t</div>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- Onboarding -->\n\t<div class="page-template-b" pc-switch-when="COMPANY_STATES.onboarding">\n\t\t<div class="page-template-b-wrapper m">\n\n\t\t\t<!-- Paycircle -->\n\t\t\t<div class="page-template-b-action-bar" ng-if="userHasRole([\'paycircle\'])">\n\t\t\t\t<a ui-sref="bureau-onboarding({agencyProfileId:CONFIG.paycircleOnboardingId})" class="link-with-icon greyscale"><i class="icon-back"></i>Back to Onboarding</a>\n\t\t\t</div>\n\n\t\t\t<!-- Bureaus -->\n\t\t\t<div class="page-template-b-action-bar" ng-if="userHasRole([\'bureau\', \'bureaumanager\'])">\n\t\t\t\t<a ui-sref="bureau-onboarding({agencyProfileId:currentUser.AgencyProfileID})" class="link-with-icon greyscale"><i class="icon-back"></i>Back to Onboarding</a>\n\t\t\t</div>\n\n\t\t\t<div class="page-template-b-header">\n\t\t\t\t<h2 class="page-template-b-title"><i class="icon-rocket tertiary"></i>&nbsp; Hi {{currentUser.UserResponseFirstName}}</h2>\n\t\t\t\t<h4 class="page-template-b-subtitle tertiary">Welcome to onboarding for {{currentCompany.Name}}</h4>\n\t\t\t</div>\n\n\t\t\t<div class="progress-block page-template-b-dashboard" ng-class="{\'secondary\' : onboardingDashboard.IsOnboardingComplete}">\n\t\t\t\t<div class="progress-block__graphic" ng-class="{\'progress-block__graphic--bring-forward\' : onboardingDashboard.IsOnboardingComplete}">\n\t\t\t\t\t<img alt="" ng-if="!onboardingDashboard.IsOnboardingComplete" src="images/graphics/onboarding/monster-shadow.png">\n\t\t\t\t\t<img alt="" ng-if="onboardingDashboard.IsOnboardingComplete" src="images/graphics/onboarding/monster-celebrate.png">\n\t\t\t\t</div>\n\t\t\t\t<div class="progress-block__background">\n\t\t\t\t\t<div class="progress-block__layout">\n\t\t\t\t\t\t<div class="prorgress-block__copy" ng-if="!onboardingDashboard.IsOnboardingComplete">\n\t\t\t\t\t\t\t<h3 class="progress-block__title">Overall progress</h3>\n\t\t\t\t\t\t    <h4 class="progress-block__subtitle">Add your module settings and essential information for your team</h4>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="prorgress-block__copy" ng-if="onboardingDashboard.IsOnboardingComplete">\n\t\t\t\t\t\t\t<h3 class="progress-block__title">Nice, you\u2019ve answered all questions!</h3>\n\t\t\t\t\t\t    <h4 class="progress-block__subtitle">You\u2019re one step closer to running your first pay period</h4>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__steps" ng-class="{\'progress-block__steps--completed\' : onboardingDashboard.IsOnboardingComplete }">\n\t\t\t\t\t\t\t<!-- Team -->\n\t\t\t\t\t\t\t<div class="progress-block__steps-item" ng-class="{\'progress-block__steps-item--completed\' : onboardingDashboard.IsTeamComplete}">\n\t\t\t\t\t\t\t\t<div class="progress-block__steps-check">\n\t\t\t\t\t\t\t\t\t<i class="icon-check"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\tTeam members\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="progress-block__steps-item" ng-class="{\'progress-block__steps-item--completed\' : onboardingQuestionGroup.isComplete}" ng-repeat="onboardingQuestionGroup in onboardingDashboard.Questions.QuestionGroups">\n\t\t\t\t\t\t\t\t<div class="progress-block__steps-check">\n\t\t\t\t\t\t\t\t\t<i class="icon-check"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t{{onboardingQuestionGroup.GroupName}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-block__next" ng-if="onboardingDashboard.IsOnboardingComplete">\n\t\t\t\t\t\t\t<h6 class="progress-block__next-copy">\n\t\t\t\t\t\t\t\tIt\u2019s time to start getting ready for your first pay period\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t<button class="progress-block__next-button" ng-if="!onboardingDashboard.CanRequestCallback" ng-click="changeCompanyState(currentCompany)">\n\t\t\t\t\t\t\t\t\tGo to your first pay period\n\t\t\t\t\t\t\t\t <i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<button class="progress-block__next-button" ng-if="onboardingDashboard.CanRequestCallback" ng-click="openRequestCallbackModal(modalOptions.moveToOnboarding)">\n\t\t\t\t\t\t\t\tRequest a callback <i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<main class="page-template-b-main">\n\n\t\t\t\t<!-- Setup -->\n\t\t\t\t<section class="page-template-b-section">\n\n\t\t\t\t\t<div class="onboarding-card primary onboarding-card-team{{onboardingDashboard.IsTeamComplete ? \' is-complete\' : \'\'}}">\n\t\t\t\t\t\t<div class="onboarding-card__card">\n\t\t\t\t\t\t\t<div class="onboarding-card__layout-row">\n\t\t\t\t\t\t\t\t<header class="onboarding-card__header-team">\n\t\t\t\t\t\t\t\t\t<div class="onboarding-card__header-title-bar">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-team-alt gradient primary onboarding-card__header-title-bar-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<h4>Team Members</h4>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>Import or add personal information for each of your team members</p>\n\t\t\t\t\t\t\t\t\t<a href="" class="onboarding-card__header-action" ng-click="toggleShowAddTeamMembers(vm)">{{onboardingDashboard.IsTeamComplete ? \'Review\' : \'Continue\'}} <i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<footer class="onboarding-card__footer">\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="onboarding-card__footer-confirm" id="confirmTeamMembersComplete" name="confirmTeamMembersComplete" ng-model="onboardingDashboard.IsTeamComplete" ng-change="toggleTeamCompleteState(onboardingDashboard)" ng-disabled="!areTeamMembersComplete" label-text="\'I\\\'ve added all my team members\'" checkbox>\n\t\t\t\t\t\t\t\t\t\t<a class="checkbox-field-info" href="" ng-click="toggleModalIsOpen(modalOptions.addingTeamMembers)" aria-label="Toggle modal"><i class="icon-information m"></i></a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="onboarding-card__footer-progress">\n\t\t\t\t\t\t\t\t\t\t<p class="onboarding-card__footer-progress-label">{{teamStats.teamMembersComplete}} of {{teamStats.numberOfTeamMembers}} complete</p>\n\t\t\t\t\t\t\t\t\t\t<progress-bar class="onboarding-card__footer-progress-bar" pb-percentage="teamStats.totalPercentageComplete"></progress-bar>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="onboarding-card__background"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<question-block-onboarding agency-profile-id="company.Company.AgencyProfileID" onboarding-dashboard="onboardingDashboard" on-update="refreshOnboardingDashboard" onboarding-actions="vm" onboarding-question-groups="questionGroupPair" ng-repeat="questionGroupPair in onboardingDashboard.questionGroupPairs"></question-block-onboarding>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Cancel trial -->\n\t\t\t\t<section class="page-template-b-footer align-center">\n\t\t\t\t\t<p class="s">\uD83D\uDE22 Want to cancel your onboarding? <a href="" ng-click="openCancelTrialForm()" class="underline">Click here</a></p>\n\t\t\t\t</section>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- Add team members -->\n\t<add-team-members agency-profile-id="currentCompany.AgencyProfileID" ng-if="vm.showAddTeamMembers" on-close="onCloseAddTeamMembers(vm)" onboarding-dashboard="onboardingDashboard"></add-team-members>\n\n\t<!-- Company summary -->\n\t<company-onboarding-summary agency-profile-id="currentCompany.AgencyProfileID" ng-if="vm.showCompanyOnboardingSummary" on-close="toggleShowCompanyOnboardingSummary(vm)"></company-onboarding-summary>\n\n\t<!-- Team payment info -->\n\t<team-payment-info agency-profile-id="currentCompany.AgencyProfileID" ng-if="vm.showTeamPaymentInfo" on-close="toggleShowTeamPaymentInfo(vm)"></team-payment-info>\n</div>\n\n<!-- Ready to go live -->\n<modal modal-options="modalOptions.moveToLive" ng-if="modalOptions.moveToLive.isOpen">\n\t<modal-body>\n\t\t<div class="modal_body-block">\n\t\t\t<p>Hi {{currentUser.Forename}}, now you\u2019ve moved on to the final part of onboarding, you\u2019ll see your account looks very different. That\u2019s because this is your live account and it\u2019s time to get ready for your first pay period.</p>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<p>You\u2019ll see the final tasks you need to take care of and also any questions you\u2019ve marked for later. Once these are complete, you can start adding any payroll changes for your first pay period.</p>\n\t\t</div>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<a href="" class="button tertiary" ng-click="toggleModalIsOpen(modalOptions.moveToLive)">Let\'s do it</a>\n\t\t</div>\n\t</modal-body>\n</modal>\n\n<!-- Switch to live mode -->\n<modal modal-options="modalOptions.switchToLiveMode" ng-if="modalOptions.switchToLiveMode.isOpen">\n\t<modal-body>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<img alt="" src="images/graphics/test-to-live@2x.png" width="389">\n\t\t</div>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<h5>Are you sure you want to switch to live mode?</h5>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec sed odio dui. Etiam porta sem malesuada magna mollis euismod. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a href="" class="button" ng-click="toggleModalIsOpen(modalOptions.switchToLiveMode)">Cancel</a>\n\t</modal-secondary-actions>\n\t<modal-primary-actions>\n\t\t<a href="" class="button tertiary" ng-click="switchCompanyToLiveMode(modalOptions.switchToLiveMode, company)">Switch to live</a>\n\t</modal-primary-actions>\n</modal>\n\n<!-- Video - A guide to adding pension info -->\n<modal modal-options="modalOptions.guideToAddingPensionInfo" ng-if="modalOptions.guideToAddingPensionInfo.isOpen">\n\t<modal-body>\n\t\t<iframe width="540" height="304" src="https://www.youtube.com/embed/bGKx_Du_sUI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n\t</modal-body>\n</modal>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/p11db-report/p11db-report.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\t<action-bar class="dropIn" subtitle="Report preview">\n\t\t<action-bar-right>\n\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button class="is-small action-bar_action" ng-click="openBrowserPrintDialog()" type="button">\n\t\t\t\t\tSave or Print\n\t\t\t\t</button>\n\n\t\t\t\t<a class="is-tertiary link-with-icon action-bar_action" href="" ng-click="goBack()" type="button">\n\t\t\t\t\t<i class="icon-cross is-medium has-margin-right"></i>Close\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- P11D(b) Submission view -->\n\t<div class="printable-form fadeIn p11db-report">\n\n\t\t<!-- Header -->\n\t\t<div class="printable-form_header">\n\t\t\t<h3 class="printable-form_header-title">\n\t\t\t\tP11D(b) Report\n\t\t\t</h3>\n\t\t\t<h4>\n\t\t\t\t{{::p11DbSubmission.P11DbSubmissionCompanyName}} - {{::p11DbSubmission.TaxYearDisplay}}\n\t\t\t</h4>\n\t\t</div>\n\n\t\t<!-- Breakdown -->\n\t\t<div class="printable-form_section">\n\t\t\t<div class="printable-form_breakdown">\n\t\t\t\t<div class="printable-form_breakdown-item" ng-repeat="breakdownItem in breakdownItems">\n\t\t\t\t\t<div class="printable-form_breakdown-item-label">\n\t\t\t\t\t\t{{breakdownItem.label}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-form_breakdown-item-value">\n\t\t\t\t\t\t{{breakdownItem.value}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/paycircle-dashboard/paycircle-dashboard.view.html','<div class="page-template-a fadeIn">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Paycircle Dashboard"></page-template-a-header>\n\n\t\t<!-- Tabs -->\n\t\t<section class="page-template-a-navigation">\n\n\t\t\t<!-- Navigation - not on Payroll -->\n\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t<a ui-sref="paycircle-dashboard.onboarding-stats" ui-sref-active="active">Onboarding stats</a>\n\t\t\t\t<a ui-sref="paycircle-dashboard.api-references" ui-sref-active="active">API references</a>\n\t\t\t</nav>\n\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>');
$templateCache.put('features/app/payroll/payroll.view.html','<ui-view></ui-view>');
$templateCache.put('features/app/payslip-manager/payslip-manager.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="payslip" page-title="Payslip manager">\n\t\t\t<pt-secondary>\n\t\t\t\t<a href="" ng-click="openPayrollSettingsForm()" class="link-with-icon"><i class="icon-setup"></i> Manage schedule</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="stat-block f is-large" ng-class="{\'is-inactive\' : !vm.dashboardData.IsPayslipManagerSetupComplete }">\n\t\t\t\t<div class="stat-block__item is-secondary" ng-class="{\'has-white-background\': vm.dashboardData.UserCount === 0 }">\n\t\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t\t<h2 class="stat-block__stat">{{vm.dashboardData.UserCount}}</h2>\n\t\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="stat-block__description">Team members</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item is-secondary" ng-class="{\'has-white-background\': vm.dashboardData.UserCountRegistered === 0 }">\n\t\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t\t<h2 class="stat-block__stat">{{vm.dashboardData.UserCountRegistered}}</h2>\n\t\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="stat-block__description">Registered</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item is-indifferent" ng-class="{\'has-white-background\': vm.dashboardData.UserCountUnregistered === 0 }">\n\t\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t\t<h2 class="stat-block__stat">{{vm.dashboardData.UserCountUnregistered}}</h2>\n\t\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="stat-block__description">Unregistered</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- PM Setup Mode -->\n\t\t<main class="page-template-a-main fadeIn" ng-if="!vm.dashboardData.IsPayslipManagerSetupComplete">\n\t\t\t<div class="dashboard-block primary align-graphic-middle fadeIn">\n\n\t\t\t\t<main class="dashboard-block-main">\n\n\t\t\t\t\t<img alt="" class="dashboard-block-graphic fadeIn" ng-src="images/graphics/placeholders/import.2x.png" width="280">\n\n\t\t\t\t\t<section class="dashboard-block-section fadeIn slow">\n\t\t\t\t\t\t<h3 class="dashboard-block-title">Bulk Import pay data </h3>\n\t\t\t\t\t\t<p class="dashboard-block-subtitle">Import a bulk file containing multiple pay periods  to generate the online payslips. </p>\n\t\t\t\t\t\t<a href="" class="button primary" ng-click="openPayslipManagerForm(\'bulk-import-confirm\')">Bulk import</a>\n\t\t\t\t\t\t<a href="" ng-click="openPayslipManagerForm(\'bulk-import-skip\')" class="button clear"><strong>Skip this step</strong></a>\n\t\t\t\t\t</section>\n\n\t\t\t\t</main>\n\n\t\t\t\t<footer class="dashboard-block-footer centered-contents align-center">\n\t\t\t\t\t<div><p class="primary-light"><i class="icon-warning m tertiary"></i>&nbsp;&nbsp;Bulk imports can only be made once and cannot be undone</p></div>\n\t\t\t\t</footer>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- PM Setup Complete -->\n\t\t<main class="page-template-a-main fadeIn" ng-if="vm.dashboardData.IsPayslipManagerSetupComplete">\n\n\t\t\t<search-bar options="searchBarOptions" count="vm.payPeriods.filtered.length"></search-bar>\n\n\t\t\t<div class="pay-period-card_wrapper fadeIn">\n\n\t\t\t<pay-period-card pay-period="payPeriod" agency-profile-id="agencyProfileId" refresh-periods="init()" dir-paginate="payPeriod in vm.payPeriods.filtered =\n\t\t\t\t\t\t( vm.payPeriods.all\n\t\t\t\t\t\t\t| filter : { PayPeriodDisplay: searchBarOptions.search.string }\n\t\t\t\t\t\t)\n\t\t\t\t\t\t| orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t\t| itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></pay-period-card>\n\n\t\t\t</div>\n\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.payPeriods.filtered.length === 0"></empty-search>\n\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/pensions.view.html','<ui-view></ui-view>\n');
$templateCache.put('features/app/reporting/reporting.view.html','<div class="page-template-a fadeIn">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="stats" page-title="Reporting" ng-if="showReportingHeader"></page-template-a-header>\n\n\t\t<ui-view></ui-view>\n\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-connection.view.html','<ui-view></ui-view>\n');
$templateCache.put('features/app/sent-mail/sentMailView.html','<loading-block ng-if="isLoading"></loading-block>\n\n<action-bar class="dropIn" ng-if="!isLoading" subtitle="Email History">\n\t<action-bar-right>\n\n\t<!-- Tablet+ -->\n\t\t<a href="" ng-click="goBack()" class="button hidden-phone">Cancel</a>\n\t\t<a href="" ng-click="$root.print()" class="button hidden-phone small">Print</a>\n\n\t\t<!-- Mobile -->\n\t\t<a href="" ng-click="goBack()" class="action-bar-close visible-phone" aria-label="Go back"><i class="icon-cross tertiary"></i></a>\n\t</action-bar-right>\n</action-bar>\n\n<div class="email-preview fadeIn" ng-if="!isLoading">\n\n\t<main class="email-preview-main">\n\t\t<iframe id="email-html" class="email-template-iframe is-flexible" width="600" height="2000"></iframe>\n\t</main>\n\n\t<aside class="email-preview-aside" ng-class="{opened: openMoreInfo}">\n\t\t<article ng-if="email">\n\t\t\t<span class="xs strong upcase">Email</span>\n\t\t\t<h4 class="strong first">{{email.MailSubject}}</h4>\n\t\t\t<div class="spacer s"></div>\n\t\t\t<p>This email was sent on <strong>{{email.MailSentDateISO | datetimeformat}}</strong></p>\n\t\t</article>\n\n\t\t<article ng-if="!email">\n\t\t\t<span class="xs strong upcase">No Email</span>\n\t\t\t<h4 class="strong first">Nothing to show</h4>\n\t\t\t<p>We were unable to load that sent mail. Please go back and try again.</p>\n\t\t</article>\n\n\t\t<hr class="xl b">\n\t</aside>\n\n\t<footer class="email-preview-footer hidden-desktop">\n\t\t<a href="" ng-if="!openMoreInfo" class="float-right tertiary strong" ng-click="showConfirmation()">More info&nbsp;&nbsp;&nbsp;<i class="icon-right m"></i></a>\n\t\t<a href="" ng-if="openMoreInfo" class="float-left tertiary strong" ng-click="showConfirmation()" aria-label="Go back"><i class="icon-back m"></i>&nbsp;&nbsp;&nbsp;Back</a>\n\t</footer>\n\n</div>\n');
$templateCache.put('features/app/settings/settings-entity.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<ui-view ng-if="pageState === \'ready\'"></ui-view>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Overview -->\n\t<div class="page-template-a fadeIn" ng-if="$state.current.name.indexOf(\'overview\') > -1">\n\n\t\t<div class="page-template-a-wrapper">\n\n\t\t\t<!-- Page Title / Header -->\n\t\t\t<page-template-a-header icon="settings" page-title="Settings overview"></page-template-a-header>\n\n\t\t\t<!-- Active -->\n\t\t\t<main class="page-template-a-main">\n\t\t\t\t<!-- Information -->\n\t\t\t\t<div class="fadeIn">\n\n\t\t\t\t\t<!-- Demo task completed -->\n\t\t\t\t\t<demo-completed ng-if="$root.demoTaskComplete" dc-for="changePayrollProcessingDate,switchToAutoRun,uploadCompanyPayslipLogo"></demo-completed>\n\n\t\t\t\t\t<!-- Breadcrumb Goes Here -->\n\t\t\t\t\t<div class="settings-overview-cards">\n\t\t\t\t\t\t<settings-overview-card settings-overview-group="settingsOverviewGroup" ng-repeat="settingsOverviewGroup in settingsOverviewGroups"></settings-overview-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\n\t\t\t<!-- Powered by Paycircle -->\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</div>\n\t</div>\n\n\t<!-- Sub Pages -->\n\t<div ng-if="$state.current.name.indexOf(\'overview\') === -1">\n\n\t\t<settings-breadcrumb state-name="$state.current.name" agency-profile-id="agencyProfileId"></settings-breadcrumb>\n\n\t\t<ui-view></ui-view>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/sox-report/sox-report.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Report preview">\n\t\t<action-bar-right>\n\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button class="is-small action-bar_action" ng-click="openBrowserPrintDialog(vm)" type="button">\n\t\t\t\t\tSave or Print\n\t\t\t\t</button>\n\n\t\t\t\t<a class="is-tertiary link-with-icon action-bar_action" href="" ng-click="goBack()" type="button">\n\t\t\t\t\t<i class="icon-cross is-medium has-margin-right"></i>Close\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Online payslip view -->\n\t<div class="printable-form fadeIn" ng-show="!vm.viewPrintablePayslip">\n\n\t\t<!-- Header -->\n\t\t<div class="printable-form_header">\n\t\t\t<h3 class="printable-form_header-title">SOX Compliant Sign-Off Report</h3>\n\t\t\t<h4>{{::$root.currentCompany.Name}}</h4>\n\t\t\t<h4>{{::$root.currentPeriod.PayPeriodDisplay}}</h4>\n\t\t</div>\n\n\t\t<!-- Breakdown -->\n\t\t<div class="printable-form_section">\n\t\t\t<div class="printable-form_breakdown">\n\t\t\t\t<div class="printable-form_breakdown-item" ng-repeat="breakdownItem in breakdownItems">\n\t\t\t\t\t<div class="printable-form_breakdown-item-label">\n\t\t\t\t\t\t{{breakdownItem.label}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="printable-form_breakdown-item-value">\n\t\t\t\t\t\t{{breakdownItem.value | monetise}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- RTI -->\n\t\t<div class="printable-form_section">\n\t\t\t<h5>RTI</h5>\n\t\t\t<p>\n\t\t\t\tBy returning this document we consent to the Payroll figures for the period {{::soxReport.AgencyPayPeriodDateFromISO | dateformat}} to\n\t\t\t\t{{::soxReport.AgencyPayPeriodDateToISO | dateformat}} paying {{::soxReport.AgencyPayPeriodPayDateISO | dateformat}} being sent to HMRC in the format of a Full Payment Submission.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Signature -->\n\t\t<div class="printable-form_section">\n\t\t\t<div class="printable-signature-block">\n\t\t\t\t<div class="printable-signature-block_item is-signed">\n\t\t\t\t\t<span>Signed</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="printable-signature-block_item is-date">\n\t\t\t\t\t<span>Date</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- BACS -->\n\t\t<div class="printable-form_section">\n\t\t\t<h5>BACS (if applicable)</h5>\n\t\t\t<p>By returning this document we consent to the transmission of BACS payments as detailed above.</p>\n\t\t</div>\n\n\t\t<!-- Signature -->\n\t\t<div class="printable-form_section">\n\t\t\t<div class="printable-signature-block">\n\t\t\t\t<div class="printable-signature-block_item is-signed">\n\t\t\t\t\t<span>Signed</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="printable-signature-block_item is-date">\n\t\t\t\t\t<span>Date</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/switch-account/switch-account.view.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div class="page-template-a fadeIn account-switch" ng-if="pageState === PAGE_STATES.ready">\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="team-alt" page-title="Choose an account to view">\n\t\t</page-template-a-header>\n\n\t\t<div class="page-template-a-main">\n\n\t\t\t<div class="page-template-a-section account-cards">\n\t\t\t\t<!-- The current logged in account will have one to many AccountEmployment records. -->\n\t\t\t\t<h6 class="is-strong">Main account</h6>\n\t\t\t\t<switch-account-card ng-repeat="account in accountsList | filter : { IsSignedIn : true }" account="account" on-click="onAccountCardClick(account.UserID)">\n\t\t\t\t</switch-account-card>\n\t\t\t</div>\n\n\t\t\t<div class="page-template-a-section account-cards">\n\t\t\t\t<h6 class="is-strong">Linked accounts</h6>\n\t\t\t\t<switch-account-card ng-repeat="account in accountsList | filter : { IsSignedIn : false }" account="account" on-click="onAccountCardClick(account.UserID)">\n\t\t\t\t</switch-account-card>\n\t\t\t</div>\n\n\t\t<div class="page-template-a_footer">\n\t\t\t<a href="" ng-click="goLinkAccounts()">\n\t\t\t\tManage linked accounts\n\t\t\t</a>\n\t\t</div>\n\t</div>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === PAGE_STATES.error"></error-block>');
$templateCache.put('features/app/team/teamView.html','<ui-view></ui-view>');
$templateCache.put('features/app/trial-signup/trial-signup.view.html','<split-pane sp-template="{{isWhitelabel ? \'customisation\' : \'paycircle\'}}">\n\t<sp-left>\n\n\t\t<!-- Request a free trial -->\n\t\t<div class="split-pane-form">\n\n\t\t\t<header class="split-pane-form-header">\n\t\t\t\t<p class="split-pane-form-pretitle">{{::vm.pretitle}}</p>\n\t\t\t\t<h2 class="split-pane-form-title" ng-switch="requestState">\n\t\t\t\t\t<span ng-switch-when="request-sending">Requesting activation code</span>\n\t\t\t\t\t<span ng-switch-when="request-sent">Activation code sent</span>\n\t\t\t\t\t<span ng-switch-default>Request an activation code</span>\n\t\t\t\t</h2>\n\t\t\t</header>\n\n\t\t\t<div class="slide-in-form fadeIn" ng-if="pageState === \'ready\'" ng-switch="requestState">\n\n\t\t\t\t<!-- Request -->\n\t\t\t\t<form class="split-pane-form fadeIn" name="requestActivationCodeForm" ng-submit="requestActivationCode(vm)" ng-switch-when="request" novalidate>\n\n\t\t\t\t\t<!-- Request activation code -->\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t\t<p>Enter your email address and click &lsquo;Get started&rsquo; to receive your free trial activation code.</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Email -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<label class="required" for="email">Email address</label>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<input id="email" name="email" ng-model="vm.emailAddress" required type="email">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="requestActivationCodeForm.email.$error" ng-show="requestActivationCodeForm.email.$touched && requestActivationCodeForm.email.$invalid" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t\t\t\t\t<p ng-message="email">Please make sure the email address is valid</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions-block l">\n\t\t\t\t\t\t<submit-button class="l fixed" disable-button="!requestActivationCodeForm.$valid" display-text="\'Get started\'" is-primary-action="false" state="vm.savingState"></submit-button>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</form>\n\n\t\t\t\t<!-- Request sending -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="request-sending">\n\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t<p>We\'re sending a 6-digit activation code to:<br><span class="primary">{{vm.emailAddress}}</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t<loading-block></loading-block>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Request sent -->\n\t\t\t\t<div class="fadeIn" ng-switch-when="request-sent">\n\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t<p>We\'ve sent a 6-digit activation code to:<br><span class="primary">{{vm.emailAddress}}</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t<p>Please click on the link in the email to complete your activation.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-footer-block" ng-switch-when="request|request-sent" ng-switch-when-separator="|">\n\t\t\t\t\t<p ng-switch-when="request-sent">\n\t\t\t\t\t\tDidn\'t receive your activation code? <a href="" ng-click="setRequestState(\'request\')" class="underline">Resend it</a>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-switch-when="request">\n\t\t\t\t\t\tAlready signed up for your free trial? <a ui-sref="login({username: vm.emailAddress})" class="underline">Login here</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Invalid URL -->\n\t\t\t<div class="fadeIn" ng-if="pageState === \'invalid-url\'">\n\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t<p>It seems that the url you\'ve ended up at is invalid. You can <a ui-sref="login" class="underline">sign in to your account here</a>.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Email already in use -->\n\t\t\t<div class="fadeIn" ng-if="pageState === \'error\'">\n\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t<p>There was a problem sending your invitation. Please contact support and we\u2019ll look into it for you.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Error -->\n\t\t\t<div class="fadeIn" ng-if="pageState === \'email-in-use\'">\n\t\t\t\t<div class="info-block tertiary">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIt seems that the email <strong>{{vm.emailAddress}}</strong> is already in use. This may be because you have previously signed up for your free trial or registered for an\n\t\t\t\t\t\taccount. If that\'s the case you can <a ui-sref="login({username: vm.emailAddress})" class="underline">sign in to your account here</a>.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIf you think there may be a problem, please contact support and we\u2019ll look into it for you.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<br>\n\t\t\t\t<a class="button tertiary" href="" ng-click="resetPage()">Back</a>\n\t\t\t</div>\n\n\t\t\t<!-- Invitation sent -->\n\t\t\t<div ng-if="pageState === \'invitation-sent\'">\n\t\t\t\t<p>An invitation has been sent to {{vm.emailAddress}}.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Powered by Paycircle -->\n\t\t\t<footer class="split-pane-form-footer" ng-if="::isWhitelabel">\n\t\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t\t</footer>\n\t\t</div>\n\t</sp-left>\n</split-pane>\n');
$templateCache.put('features/app/user-importer/userImporterView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="user-importer fadeIn" ng-if="pageState === \'ready\'" ng-class="{\'is-worker-visible\': options.isWorkerInfoVisible}">\n\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a href="" ng-click="openCancelImportForm()" class="button" ng-if="canCancelImport">Cancel import</a>\n\t\t\t<a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="button {{currentPayPeriod.WorkerImportState > 0 ? \'tertiary\' : \'\'}}" ng-if="canCloseImport">{{currentPayPeriod.WorkerImportState > 0 ? \'Save & close\' : \'Close\'}}</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Worker Import States -->\n\t<div class="user-importer-body" ng-switch="currentPayPeriod.WorkerImportState" nv-file-drop="" nv-file-over="" uploader="uploader">\n\n\t\t<!-- Progress bar -->\n\t\t<section class="progress-step-bar">\n\t\t\t<status-directive step-name="Upload" step="1" active="progress === 1" finished="progress > 1"></status-directive>\n\t\t\t<status-directive step-name="Verify" step="2" active="progress === 2" finished="progress > 2"></status-directive>\n\t\t\t<status-directive step-name="Import" step="3" active="progress === 3" finished="progress === 4"></status-directive>\n\t\t</section>\n\n\t\t<!-- Invalid File Format -->\n\t\t<main class="user-importer-state" ng-switch-when="-1">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/error-doc.png">\n\n\t\t\t<h3 class="user-importer-state-title">Invalid file type</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>The type of file you\'ve tried to upload doesn\'t appear to be a CSV file.</p>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<a href="" ng-click="resetImporter(currentPayPeriod)" class="underline">Go back and try again</a>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Unsubmitted / Start -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.unsubmitted">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/start-doc.png">\n\n\t\t\t<h3>Drag and drop your file here to upload</h3>\n\n\t\t\t<div class="spacer xs"></div>\n\n\t\t\t<div class="user-importer-file-uploader">\n\t\t\t\t<label>\n\t\t\t\t\t<input id="fileUpload" type="file" accept=".csv" nv-file-select uploader="uploader">\n\t\t\t\t\t<p>or <span class="primary"> click here to select a file from your computer</span></p>\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class="spacer s"></div>\n\n\t\t\t<h4>{{invalidFileErrorMessage}}</h4>\n\n\t\t\t<div ng-if="invalidFileErrorMessage" class="spacer m"></div>\n\n\t\t\t<p>Paycircle will check that your data is in order</p>\n\n\t\t\t<div class="drop-zone-overlay user-importer-drop-zone"></div>\n\n\t\t\t<div ng-show="progressVisible">\n\t\t\t\t<div class="percent">{{progress}}%</div>\n\t\t\t\t<div class="progress-bar">\n\t\t\t\t\t<div class="uploaded" ng-style="{\'width\': progress+\'%\'}"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Submitting / Uploading File   -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.submitting">\n\n\t\t\t<progress-ring pr-icon="icon-upload" pr-percentage="uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\n\t\t\t<p class="user-importer-filename" ng-if="uploadFilename">{{uploadFilename}}</p>\n\n\t\t\t<h3 class="user-importer-state-title">Paycircle is uploading your file</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>This should only take a moment and we\'ll let you know if anything needs cleaning up.</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<p class="strong"><span class="tertiary">Important:</span> please don\'t close your browser until the upload is complete!</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Submitted / File uploaded -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.submitted">\n\n\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t<h3 class="user-importer-state-title">Paycircle is reviewing your file</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>This should only take a moment and we\'ll let you know if anything needs cleaning up.</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Processing / Reviewing File -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.processing1">\n\n\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t<h3 class="user-importer-state-title">Paycircle is reviewing your file</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>This should only take a moment and we\'ll let you know if anything needs cleaning up.</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Errors / 2 error levels - Basic & Urgent (contact support) -->\n\t\t<main class="user-importer-state" ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors1 || currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2">\n\n\t\t\t<!-- Issues -->\n\t\t\t<div ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors1">\n\t\t\t\t<h4 class="user-importer-state-title">We\'ve found <strong>{{numberOfValidationResults}}</strong> worker entries that need cleaning up!</h4>\n\t\t\t\t<div class="user-importer-state-description">\n\t\t\t\t\t<p>These are normally just simple formatting issues that need correcting quickly. Please work through each of the items below before moving on.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Critical Issues -->\n\t\t\t<div ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2">\n\t\t\t\t<h4 class="user-importer-state-title">We\'ve found <strong>{{numberOfValidationResults}}</strong> serious&nbsp;<ng-pluralize count="numberOfValidationResults" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;with your import</h4>\n\t\t\t\t<div class="user-importer-state-description">\n\t\t\t\t\t<p class="s">This could cause serious problems with your payroll so please contact Paycircle Support and we will fix these for you asap.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Validator -->\n\t\t\t<div class="user-importer-validator" ng-class="{assertive: currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2}">\n\n\t\t\t\t<!-- Previous -->\n\t\t\t\t<a href="" class="user-importer-validator-previous" ng-class="{\'disabled\': currentIndex === 0}" ng-click="goToPrevious(validationResults, validationForm)" ng-if="numberOfValidationResults > 1">&angrt;</a>\n\n\t\t\t\t<!-- Worker -->\n\t\t\t\t<div class="user-importer-validator-mask">\n\n\t\t\t\t\t<div class="user-importer-validator-result {{animationStep}}">\n\n\t\t\t\t\t\t<!-- Header -->\n\t\t\t\t\t\t<header class="user-importer-validator-header">\n\t\t\t\t\t\t\t<h5 class="user-importer-validator-worker-name">{{validationResult.worker.UserImportForename}} {{validationResult.worker.UserImportSurname}}</h5>\n\t\t\t\t\t\t\t<a href="" ng-click="changeShowWorkerInfo()" class="user-importer-validator-header-action" aria-label="Change worker information"><i class="l" ng-class="{\'icon-menu-left\': !options.isWorkerInfoVisible, \'icon-menu-right\': options.isWorkerInfoVisible}"></i></a>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<!-- Main -->\n\t\t\t\t\t\t<main class="user-importer-validator-main">\n\n\t\t\t\t\t\t\t<form name="validationForm" ng-submit="updateUserInImport(validationResult, validationResults, currentPayPeriod, validationForm)" ng-switch="validationResult.ValidationType.ValidationTypeID">\n\n\t\t\t\t\t\t\t\t<!-- Address -->\n\t\t\t\t\t\t\t\t<fieldset class="fadeIn" ng-if="validationResult.addressLookupVisible">\n\t\t\t\t\t\t\t\t\t<section class="user-importer-validator-field is-address-lookup">\n\n\t\t\t\t\t\t\t\t\t\t<section class="user-importer-validator-field_section">\n\t\t\t\t\t\t\t\t\t\t\t<div class="search-dropdown" ng-mouseleave="options.showAddressResult = false">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="align-left" ng-change="lookupAddress(validationResult, options.addressSearchString)" ng-focus="options.showAddressResult = true" ng-keypress="showAgencySearch = true" ng-model-options="{ debounce:700 }" ng-model="options.addressSearchString" ng-mousedown="showAgencySearch = true" placeholder="Start typing the address" type="text">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="loadingAddresses" class="search-dropdown-results">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-dropdown-result">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-dropdown-results" ng-show="options.showAddressResult && addresses.length > 0">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="!loadingAddresses">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-repeat="address in addresses" class="search-dropdown-result" ng-click="selectAddress(validationResult, address)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{address.suggestion}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-if="addresses.length === 0">No addresses could be found</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-dropdown-results" ng-show="noAddressesFound && addresses.length === 0">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="search-dropdown-result">No results found, please check the address is correct</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t\t\t\t\t<section class="user-importer-validator-field_section">\n\n\t\t\t\t\t\t\t\t\t\t\t<note note-theme="{{addressLookupFailed ? \'assertive\' : \'primary\'}}">\n\t\t\t\t\t\t\t\t\t\t\t\t<note-columns>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-if="!selectedAddress && !addressLookupFailed">Look in the full worker record on the right to find the address to use above</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-if="!selectedAddress && addressLookupFailed">We\'re unable to load any addresses at this time. Please try entering an address again or come back in a few minutes to try. You\'re safe to <strong>Save and exit</strong> the importer.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<address class="address c" ng-if="selectedAddress">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>{{selectedAddress.line_1}}<span ng-if="selectedAddress.line_2 !== \'\'">,&nbsp;{{selectedAddress.line_2}}</span><span ng-if="selectedAddress.line_3 !== \'\'">&nbsp;, {{selectedAddress.line_3}}</span></p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>{{selectedAddress.post_town}},&nbsp;{{selectedAddress.postcode}}</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</address>\n\t\t\t\t\t\t\t\t\t\t\t\t</note-columns>\n\t\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t\t</section>\n\t\t\t\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t\t\t\t<footer class="user-importer-validator-actions">\n\t\t\t\t\t\t\t\t\t\t<a href="" class="secondary-action" ng-click="toggleAddressLookup(validationResult, validationForm)">Cancel address lookup</a>\n\t\t\t\t\t\t\t\t\t\t<button type="submit" ng-click="useSelectedAddress(validationResult, selectedAddress)" ng-disabled="!selectedAddress" class="primary primary-action">Use this address <i ng-if="updating" class="icon-loading spin"></i></button>\n\t\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t\t<!-- Everything else -->\n\t\t\t\t\t\t\t\t<fieldset ng-switch-default ng-if="!validationResult.addressLookupVisible">\n\t\t\t\t\t\t\t\t\t<section class="user-importer-validator-field">\n\n\t\t\t\t\t\t\t\t\t\t<!-- Title -->\n\t\t\t\t\t\t\t\t\t\t<h5 class="user-importer-validator-field-title">{{validationResult.isUpdated ? \'This entry has been updated\' : validationResult.ValidationType.validationTitle}}</h5>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Value (editable) -->\n\t\t\t\t\t\t\t\t\t\t<input class="user-importer-validator-field-input" type="text" name="validationValue" ng-model="validationResult.worker[validationResult.validationPropertyKey]" ng-if="currentPayPeriod.WorkerImportState !== SUBMISSION_STATES.haserrors2" placeholder="{{currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2 ? \'No value provided\' : \'\'}}">\n\n\t\t\t\t\t\t\t\t\t\t<!-- Value (read-only) -->\n\t\t\t\t\t\t\t\t\t\t<span class="user-importer-validator-field-read-only" ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2">{{validationResult.worker[validationResult.validationPropertyKey] || \'No value provided\' }}</span>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Description -->\n\t\t\t\t\t\t\t\t\t\t<p class="user-importer-validator-field-description" ng-if="validationResult.ValidationType.validationDescription && currentPayPeriod.WorkerImportState !== SUBMISSION_STATES.haserrors2">{{validationResult.ValidationType.validationDescription}}</p>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Postcode Lookup -->\n\t\t\t\t\t\t\t\t\t\t<p class="user-importer-validator-field-description" ng-if="validationResult.ValidationType.ValidationTypeID === VALIDATION_FIELD_TYPES.address"><a href="" ng-click="toggleAddressLookup(validationResult, validationForm)">Use address lookup</a> to search for the correct address.</p>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Important! -->\n\t\t\t\t\t\t\t\t\t\t<p class="user-importer-validator-field-description" ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2">This issue could cause serious problems with your payroll</p>\n\t\t\t\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t\t\t\t<!-- Validation Errors (Fix or skip) -->\n\t\t\t\t\t\t\t\t\t<footer class="user-importer-validator-actions" ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors1">\n\n\t\t\t\t\t\t\t\t\t\t<!-- Skip / Revert skip -->\n\t\t\t\t\t\t\t\t\t\t<a href="" class="secondary-action" ng-click="skipEntry(validationResult, validationResults, currentPayPeriod, validationForm, options)" ng-if="validationResult.ValidationType.ValidationTypeLevel > 1">{{validationResult.ValidationResultIgnore ? \'Don\\\'t skip this entry\' : \'Skip this entry\'}}</a>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Update / Finish -->\n\t\t\t\t\t\t\t\t\t\t<button type="submit" class="{{currentResultNumber === numberOfValidationResults ? \'tertiary\' : \'primary\'}} primary-action" ng-class="{\'positive\': validationResult.state === \'saved\'}" ng-disabled="validationForm.$pristine || validationResult.state === \'saving\'" ng-switch="validationResult.state">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-when="saved"><i class="icon-tick"></i></span>\n\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-when="saving"><i class="icon-loading spin"></i></span>\n\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-default>{{currentResultNumber === numberOfValidationResults ? \'Finish\' : \'Update\'}}</span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t\t\t\t<!-- Serious Errors (Contact Support) -->\n\t\t\t\t\t\t\t\t\t<footer class="user-importer-validator-actions align-center" ng-if="currentPayPeriod.WorkerImportState === SUBMISSION_STATES.haserrors2">\n\t\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Next -->\n\t\t\t\t<a href="" class="user-importer-validator-next" ng-class="{\'disabled\': currentResultNumber === numberOfValidationResults}" ng-if="numberOfValidationResults > 1" ng-click="goToNext(validationResults, currentPayPeriod, validationForm)">&angrt;</a>\n\t\t\t</div>\n\n\t\t\t<h5>{{currentResultNumber}}&nbsp;<span class="light">of</span>&nbsp;{{numberOfValidationResults}}</h5>\n\t\t</main>\n\n\t\t<!-- Verified -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.verified">\n\n\t\t\t<img alt="" class="user-importer-state-graphic" height="70" src="../../images/graphics/finish-doc.png">\n\n\t\t\t<h3 class="user-importer-state-title">Your file is ready to import</h3>\n\t\t\t<p>We\'ll import the following data to payroll:</p>\n\t\t\t<div class="spacer s"></div>\n\n\t\t\t<!-- Number of workers being imported -->\n\t\t\t<h5 ng-if="numberOfWorkers > 0"><span class="tertiary">{{numberOfWorkers}}</span>&nbsp;<ng-pluralize count="numberOfWorkers" when="{\'1\': \'update\', \'other\': \'updates\'}"></ng-pluralize>&nbsp;will be made</h5>\n\n\t\t\t<!-- Number of workers being imported -->\n\t\t\t<h5 ng-if="numberOfNewStarters > 0"><span class="tertiary">{{numberOfNewStarters}}</span>&nbsp;<ng-pluralize count="numberOfNewStarters" when="{\'1\': \'new starter\', \'other\': \'new starters\'}"></ng-pluralize>&nbsp;will be added</h5>\n\n\t\t\t<!-- Number of skipped results -->\n\t\t\t<h5 ng-if="numberOfSkippedResults > 0"><span class="tertiary">{{numberOfSkippedResults}}</span>&nbsp;<ng-pluralize count="numberOfSkippedResults" when="{\'1\': \'issue\', \'other\': \'issues\'}"></ng-pluralize>&nbsp;were skipped</h5>\n\n\t\t\t<div class="spacer s"></div>\n\t\t\t<p>Once imported, you can start adding your changes</p>\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<button class="round tertiary l" ng-click="importData(currentPayPeriod)">Import</button>\n\t\t</main>\n\n\t\t<!-- Processing / Importing Workers into Paycircle -->\n\t\t<main class="user-importer-state" pc-switch-when="SUBMISSION_STATES.processing2">\n\n\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t<h3 class="user-importer-state-title">Importing worker information</h3>\n\t\t\t<div class="user-importer-state-description">\n\t\t\t\t<p>Your import may take a little while and we\'ll email you when it\'s done. In the meantime you\'re safe to <a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="underline">close the importer</a>.</p>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Worker Import Complete / Import payroll data -->\n\t\t<main pc-switch-when="SUBMISSION_STATES.finished">\n\n\t\t\t<!-- Submitting -->\n\t\t\t<div class="user-importer-state" ng-if="currentPayPeriod.DataImportState === SUBMISSION_STATES.submitting">\n\n\t\t\t\t<circle-loader class="l user-importer-state-loader"></circle-loader>\n\n\t\t\t\t<h3 class="user-importer-state-title">Importing shift information</h3>\n\t\t\t\t<div class="user-importer-state-description">\n\t\t\t\t\t<p>We\'re importing the workers shifts and setting up payroll. Your import may take a little while and we\'ll email you when it\'s done.</p>\n\t\t\t\t\t<p>In the meantime you\'re safe to <a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="underline">close the importer</a>.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Finished -->\n\t\t\t<div class="user-importer-state" ng-if="currentPayPeriod.DataImportState === SUBMISSION_STATES.submitted">\n\n\t\t\t\t<h2 class="user-importer-state-title">That\'s it, your import is complete!</h2>\n\t\t\t\t<div class="user-importer-state-description">\n\t\t\t\t\t<p>You\'re all set to start adding changes to payroll</p>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<a ui-sref="payroll.current-period.changes({agencyProfileId: agencyProfileId})" class="button tertiary l">Go to payroll</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</main>\n\t</div>\n\n\t<!-- Worker Info -->\n\t<aside class="user-importer-worker" ng-class="{\'is-worker-visible\': options.isWorkerInfoVisible}" id="workerRecordContainer">\n\n\t\t<header class="user-importer-worker-header">\n\t\t\t<h6>Full worker record</h6>\n\t\t\t<a href="" ng-click="changeShowWorkerInfo(false)" aria-label="Close worker information"><i class="icon-menu-right m"></i></a>\n\t\t</header>\n\n\t\t<main class="user-importer-worker-main">\n\n\t\t\t<nav class="user-importer-worker-nav">\n\t\t\t\t<a href="" ng-click="changeWorkerPriorityFilter(\'all\')" ng-class="{\'active underline\': workerPriorityFilter === \'all\'}">All</a>\n\t\t\t\t<a href="" ng-click="changeWorkerPriorityFilter(\'basic\')" ng-class="{\'active underline\': workerPriorityFilter === \'basic\'}">Basic</a>\n\t\t\t</nav>\n\n\t\t\t<form name="updateFullWorkerForm" ng-submit="updateUserInImport(validationResult, validationResults, currentPayPeriod, updateFullWorkerForm)">\n\n\t\t\t\t<fieldset class="user-importer-worker-fields {{workerPriorityFilter}}">\n\t\t\t\t\t<button type="button" class="is-clear user-importer-worker-field {{propertyName | validationResultFieldPriority}}" ng-repeat="propertyName in validationResultsPropertyNames track by $index" ng-click="userHasRole(\'paycircle\') ? toggleEditMode(validationResult, propertyName) : \'\'" ng-class="{\'editable\': validationResult.editMode === propertyName, \'can-edit\': $root.userHasRole(\'paycircle\')}">\n\t\t\t\t\t\t<label class="user-importer-worker-field-label" for="{{propertyName}}">{{propertyName | validationResultFieldTitle}}</label>\n\t\t\t\t\t\t<input type="text" id="{{propertyName}}" class="user-importer-worker-field-input" ng-model="validationResult.worker[propertyName]" ng-blur="disableEditMode(col)">\n\t\t\t\t\t\t<label class="user-importer-worker-field-value" for="{{propertyName}}" ng-click="userHasRole(\'paycircle\') ? toggleEditMode(validationResult, propertyName) : \'\'">{{validationResult.worker[propertyName]}}</label>\n\t\t\t\t\t</button>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<fieldset class="user-importer-worker-actions" ng-if="$root.userHasRole(\'paycircle\')">\n\t\t\t\t\t<button type="submit" class="block primary" ng-class="{\'positive\': validationResult.state === \'saved\'}" ng-disabled="validationResult.state === \'saving\'" ng-switch="validationResult.state">\n\t\t\t\t\t\t<span ng-switch-when="saved"><i class="icon-tick"></i></span>\n\t\t\t\t\t\t<span ng-switch-when="saving"><i class="icon-loading spin"></i></span>\n\t\t\t\t\t\t<span ng-switch-default>Update</span>\n\t\t\t\t\t</button>\n\t\t\t\t</fieldset>\n\t\t\t</form>\n\t\t</main>\n\t</aside>\n</div>\n\n<div class="modal primary m fadeIn" ng-if="modal.skipWorker">\n\t<div class="modal_overlay"></div>\n\t<div class="modal_window">\n\t\t<div class="modal_header">\n\t\t\t<h4 class="modal_title">Skip entry for {{validationResult.worker.UserImportForename}} {{validationResult.worker.UserImportSurname}}</h4>\n\t\t</div>\n\n\t\t<div class="modal_body align-center">\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<p>Only this entry will be skipped and the rest of {{validationResult.worker.UserImportForename}}\'s data will be imported. You can always edit their profile later.</p>\n\t\t\t</div>\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<h4>Skip this entry?</h4>\n\t\t\t</div>\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<a href="" class="s strong" ng-click="toggleModal(\'skipWorker\')">Cancel</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n\t\t\t\t<a href="" class="button tertiary" ng-click="updateValidationResultIgnore(validationResult, validationResults, currentPayPeriod, validationForm)">Yes</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="modal_footer grey">\n\t\t\t<input type="checkbox" id="doNotAskAgain" name="doNotAskAgain" ng-model="options.doNotAskAgain" label-text="\'Don\\\'t ask me again\'" checkbox>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('features/app/workflow/workflow.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-switch="activeTab">\n\n\t\t<page-template-a-header icon="workflow-alt" page-title="Workflow"></page-template-a-header>\n\n\t\t<!-- Tabs -->\n\t\t<section class="page-template-a-navigation">\n\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t<a class="tabs-item" ui-sref="workflow.overview({agencyProfileId: vm.agencyProfileId})" ui-sref-active="active">Overview</a>\n\t\t\t\t<a class="tabs-item" ui-sref="workflow.companies({agencyProfileId: vm.agencyProfileId})" ui-sref-active="active">Companies</a>\n\t\t\t\t<a class="tabs-item" ui-sref="workflow.activity({agencyProfileId: vm.agencyProfileId})" ui-sref-active="active">Activity</a>\n\t\t\t</nav>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n');
$templateCache.put('features/shared/auth/authenticationView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-f fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-f_wrapper">\n\n\t\t<header class="page-template-f_header">\n\t\t\t<h1 ng-if="!vm.isInSetupMode">Authentication required</h1>\n\t\t\t<div ng-if="vm.isInSetupMode" ng-switch="vm.activeStep">\n\t\t\t\t<h1 class="fadeIn" ng-switch-default>Set up two-factor authentication</h1>\n\t\t\t\t<h1 class="fadeIn" pc-switch-when="AUTH_STAGES.code">Authentication required</h1>\n\t\t\t\t<h1 class="fadeIn" pc-switch-when="AUTH_STAGES.authenticated">Authentication complete</h1>\n\t\t\t</div>\n\n\t\t\t<div ng-if="vm.isInSetupMode" class="page-template-f_section centered-contents is-single-item">\n\t\t\t\t<progress-steps has-spacers="true" theme="is-secondary is-large" step-count="vm.totalSteps" active-step="vm.activeStepIndex"></progress-steps>\n\t\t\t</div>\n\t\t</header>\n\n\t\t<main class="page-template-f_main riseIn" ng-switch="vm.activeStep">\n\n\t\t\t<!-- Code input -->\n\t\t\t<section pc-switch-when="AUTH_STAGES.code" class="fadeIn">\n\t\t\t\t<form name="vm.TOTPForm" ng-submit="validate2FA(vm)" novalidate>\n\t\t\t\t\t<div class="page-template-f_content">\n\n\t\t\t\t\t\t<div class="page-template-f_content-header">\n\t\t\t\t\t\t\t<h3 ng-if="!vm.isInSetupMode">Enter the 6 digit verification code</h3>\n\t\t\t\t\t\t\t<h3 ng-if="vm.isInSetupMode">Finally, enter the 6 digit verification code</h3>\n\t\t\t\t\t\t\t<p>Enter the verification code from the authenticator app in the field below</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="page-template-f_section align-left">\n\t\t\t\t\t\t\t<code-field code="vm.totp" theme="{{vm.codeState === CODE_STATES.ready ? \'is-primary\' : vm.codeState === CODE_STATES.success ? \'is-positive\' : \'is-assertive\'}}" show-footer="vm.showCodeFooter" field-disabled="vm.codeState === CODE_STATES.lockedOut" on-code-change="validate2FA(vm)">\n\t\t\t\t\t\t\t\t<cf-footer>\n\t\t\t\t\t\t\t\t\t<div ng-switch="vm.codeState">\n\t\t\t\t\t\t\t\t\t\t<div pc-switch-when="CODE_STATES.success">\n\t\t\t\t\t\t\t\t\t\t\t<h6><i class="icon-tick is-positive is-medium"></i>&nbsp;&nbsp;Success</h6>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div pc-switch-when="CODE_STATES.incorrect">\n\t\t\t\t\t\t\t\t\t\t\t<h6><i class="icon-cross is-assertive is-medium"></i>&nbsp;&nbsp;Incorrect code</h6>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">\n\t\t\t\t\t\t\t\t\t\t\t\tYou have {{vm.maxVerifcationAttempts - vm.tfaResponse.AttemptCount}} more attempts before you will be locked out of your account\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div pc-switch-when="CODE_STATES.lockedOut">\n\t\t\t\t\t\t\t\t\t\t\t<h6><i class="icon-cross is-assertive is-medium"></i>&nbsp;&nbsp;Too many wrong attempts</h6>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">\n\t\t\t\t\t\t\t\t\t\t\t\tYou have been locked out of your account for<ng-pluralize count="vm.tfaResponse.AttemptLockoutMinutes" when="{\'1\': \' 1 minute and\', \'other\': \' {} minutes and\'}" ng-if="vm.tfaResponse.AttemptLockoutMinutes > 0"></ng-pluralize><ng-pluralize count="vm.tfaResponse.AttemptLockoutSeconds" when="{\'1\': \' 1 second\', \'other\': \' {} seconds\'}"></ng-pluralize>.\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</cf-footer>\n\t\t\t\t\t\t\t</code-field>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="page-template-f_section">\n\t\t\t\t\t\t\t<p class="is-greyscale is-small">Lost access to your authentication app? Contact your system administrator to reset your access.</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_actions">\n\t\t\t\t\t\t<a href="" ng-click="getQRCode(vm)" class="button" ng-class="{\'disabled\': vm.TOTPForm.state === \'saving\'}" ng-if="vm.isInSetupMode && vm.TOTPForm.state !== \'failed\'">Back</a>\n\t\t\t\t\t\t<a href="" ng-click="redirectToLogin(vm)" class="button" ng-class="{\'disabled\': vm.TOTPForm.state === \'saving\'}" ng-if="!vm.isInSetupMode && vm.TOTPForm.state !== \'failed\'">Back</a>\n\t\t\t\t\t\t<a href="" ng-click="redirectToLogin(vm)" class="button" ng-if="vm.TOTPForm.state === \'failed\' && vm.codeState === CODE_STATES.lockedOut">Back</a>\n\t\t\t\t\t\t<a href="" ng-click="resetTOTP(vm)" class="button" ng-if="vm.TOTPForm.state === \'failed\' && vm.codeState === CODE_STATES.incorrect">Try again</a>\n\t\t\t\t\t\t<submit-button display-text="\'Continue\'" state="vm.TOTPForm.state" disable-button="vm.TOTPForm.$invalid || vm.TOTPForm.state  === \'saved\' || vm.TOTPForm.state === \'failed\'"></submit-button>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</section>\n\n\t\t\t<!-- App download -->\n\t\t\t<section pc-switch-when="AUTH_STAGES.app" class="fadeIn">\n\t\t\t\t<div class="page-template-f_content">\n\t\t\t\t\t<div class="page-template-f_content-header">\n\t\t\t\t\t\t<h3>Download an authenticator app</h3>\n\t\t\t\t\t\t<p>Visit the Android or iOS app store and download an authenticator app for your smart phone or desktop, such as Microsoft Authenticator, Authy or Google Authenticator.</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section">\n\t\t\t\t\t\t<img src="../images/graphics/microsoft-authenticator.png" alt="Microsoft Authenticator">\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section">\n\t\t\t\t\t\t<h6 class="greyscale-darkened">Microsoft Authenticator</h6>\n\t\t\t\t\t\t<p class="is-small greyscale-darkened">Developer: Microsoft Corporation</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section">\n\t\t\t\t\t\t<a target="_blank" href="https://play.google.com/store/apps/details?id=com.azure.authenticator" style="display:inline-block;overflow:hidden;background:url(https://play.google.com/intl/en_gb/badges/static/images/badges/en_badge_web_generic.png) no-repeat;width:135px;height:40px;background-size: 155px auto;background-position: -10px -10px;"></a>&nbsp;\n\t\t\t\t\t\t<a target="_blank" href="https://apps.apple.com/gb/app/microsoft-authenticator/id983156458" style="display:inline-block;overflow:hidden;background:url(https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg) no-repeat;width:120px;height:40px;"></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="page-template-f_actions" ng-class="{\'is-justified-center\' : vm.sharedSecret }">\n\t\t\t\t\t<button ng-click="redirectToLogin(vm)" ng-if="!vm.sharedSecret" class="greyscale">Back</button>\n\t\t\t\t\t<button ng-click="getQRCode(vm)" class="tertiary">I\'ve downloaded an app</button>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- QR code -->\n\t\t\t<section pc-switch-when="AUTH_STAGES.qrCode" class="fadeIn">\n\t\t\t\t<div class="page-template-f_content">\n\t\t\t\t\t<div class="page-template-f_content-header">\n\t\t\t\t\t\t<h3>Scan the QR code below </h3>\n\t\t\t\t\t\t<p>Open your authenticator app and add a new account using the QR code below.</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section fadeIn" ng-if="vm.qrCodeString !== \'\'">\n\t\t\t\t\t\t<div class="qr-code">\n\t\t\t\t\t\t\t<div class="qr-code_content">\n\t\t\t\t\t\t\t\t<qrcode data="{{vm.qrCodeString}}" error-correction-level="M" size="130" version="7"></qrcode>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section fadeIn" ng-if="vm.qrCodeString === \'\'">\n\t\t\t\t\t\t<loading-block></loading-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section fadeIn" ng-if="vm.sharedSecret !== \'\'">\n\t\t\t\t\t\t<a href="" ng-click="toggleTroubleshooting(vm)" class="is-small underline">I can&apos;t scan the QR code</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-f_section fadeIn" ng-if="vm.showTroubleshooting">\n\t\t\t\t\t\t<p class="is-small">Manually enter the code and label below into your authenticator app. You may need to remove the \'=\' from the end of the code.</p>\n\n\t\t\t\t\t\t<div class="page-template-f_section">\n\t\t\t\t\t\t\t<label>Code:&nbsp;&nbsp;</label> <input readonly="readonly" type="text" name="sharedSecret" ng-model="vm.sharedSecret" class="primary-flat"> <br><br>\n\t\t\t\t\t\t\t<label>Label:&nbsp;&nbsp;</label> <input readonly="readonly" type="text" name="sharedSecret" ng-model="$root.CONFIG.appTitle" class="primary-flat">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="page-template-f_actions">\n\t\t\t\t\t<button ng-click="setAuthStage(AUTH_STAGES.app, vm)" class="greyscale">Back</button>\n\t\t\t\t\t<button ng-click="setAuthStage(AUTH_STAGES.code, vm)" class="tertiary">Continue</button>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Authenticated -->\n\t\t\t<section pc-switch-when="AUTH_STAGES.authenticated" class="fadeIn">\n\t\t\t\t<div class="page-template-f_content">\n\t\t\t\t\t<div class="page-template-f_content-header">\n\t\t\t\t\t\t<h3>That&apos;s it, all done!</h3>\n\t\t\t\t\t\t<p>You will now be redirected to your account</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="page-template-f_actions is-justified-center">\n\t\t\t\t\t<a href="" ng-click="setNewSession()" class="button tertiary m-l">Go to account</a>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</main>\n\n\t\t<footer class="page-template-f_footer">\n\t\t\t<powered-by-paycircle class="fast-search-powered-by-paycircle"></powered-by-paycircle>\n\n\t\t\t<div class="page-template-f_section">\n\t\t\t\t<p class="is-small align-center">\n\t\t\t\t\t&copy; {{$root.CONFIG.companyName}}.&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t<a href="" target="_blank" class="greyscale-darkened" ng-href="{{$root.URLS.paycircle.website.terms}}">Terms</a>&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t<a href="" target="_blank" class="greyscale-darkened" ng-href="{{$root.URLS.paycircle.website.privacy}}">Privacy</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</footer>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/shared/change-password/change-password.view.html','<split-pane sp-template="{{customisation.IsDefault ? \'paycircle\' : \'customisation\'}}">\n\t<sp-left>\n\n\t\t<!-- Change password -->\n\t\t<form class="form-style-a fadeIn" method="post" name="changePasswordForm" ng-if="pageState === \'ready\'" ng-submit="changePassword(credentials, changePasswordForm)" novalidate>\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="Reset password">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tChoose and confirm a new password before using it to log back into your account.\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\n\t\t\t<fieldset class="form-fieldset">\n\n\t\t\t\t<!-- Username -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t<label class="required" for="username">\n\t\t\t\t\t\t\tUsername\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t<input id="username" name="username" ng-model="credentials.username" placeholder="Username" type="text" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="\n\t\t\t\t\t\t\tchangePasswordForm.username.$touched &&\n\t\t\t\t\t\t\tchangePasswordForm.username.$invalid\n\t\t\t\t\t\t" ng-messages="changePasswordForm.username.$error">\n\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\tPlease enter your username\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- New password -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t<label class="required" for="password">\n\t\t\t\t\t\t\tChoose a password\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t<validated-input-form-field allow-show-password="true" disable-autocomplete="true" field-name="Password" field-prompt="Your password must contain" input-name="new-password" ng-model="credentials.password" validation-type="{{INPUT_VALIDATION_TYPES.password}}">\n\t\t\t\t\t\t\t<vi-errors>\n\t\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="changePasswordForm[\'new-password\'].$invalid && changePasswordForm[\'new-password\'].$touched" ng-messages="changePasswordForm[\'new-password\'].$error">\n\t\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\t\t\tPlease enter a new password\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</vi-errors>\n\t\t\t\t\t\t</validated-input-form-field>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- New password confirmation -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t<label class="required" for="passwordRepeated">\n\t\t\t\t\t\t\tConfirm password\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t<password-input allow-show-password="true" compare-password="credentials.password" disable-autocomplete="true" input-id="passwordRepeated" input-name="passwordRepeated" ng-model="credentials.passwordRepeated"></password-input>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="changePasswordForm.passwordRepeated.$invalid && changePasswordForm.passwordRepeated.$touched" ng-messages="changePasswordForm.passwordRepeated.$error">\n\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\tPlease confirm your new password\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="form-field_error" ng-message="comparison">\n\t\t\t\t\t\t\tPlease make sure your passwords match\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Username not matched -->\n\t\t\t<fieldset class="form-fieldset" ng-if="credentials.isInvalidUsername">\n\n\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Username not found">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tWe couldn\'t find an account with this username. Please check you have entered it correctly.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Password invalid -->\n\t\t\t<fieldset class="form-fieldset" ng-if="credentials.isInvalidPassword">\n\n\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Invalid password">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tThe password entered doesn\'t meet the criteria required\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Generic error -->\n\t\t\t<fieldset class="form-fieldset" ng-if="credentials.isGenericError">\n\n\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Unable to change password">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tThere was a problem changing your password. Please try again in a few minutes. If this continues, please contact your system admin\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t<submit-button disable-button="changePasswordForm.$invalid" display-text="\'Save new password\'" state="changePasswordForm.state"></submit-button>\n\n\t\t\t</fieldset>\n\n\t\t\t<div class="split-pane-left_additional-info">\n\t\t\t\t<p>\n\t\t\t\t\tRemembered it?\n\t\t\t\t\t<a class="is-primary" tabindex="-1" ui-sref="login">\n\t\t\t\t\t\tGo and sign in\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</form>\n\n\t\t<!-- No token -->\n\t\t<div class="form-style-a fadeIn" ng-if="pageState === \'no-token\'">\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="Change your password">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTo change your password you need to follow the link in your reset password email. Not received it?\n\t\t\t\t\t\t<a class="secondary" ui-sref="forgotten-password">\n\t\t\t\t\t\t\tTry sending it again\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\t\t</div>\n\n\t\t<!-- Success -->\n\t\t<div class="form-style-a fadeIn" ng-if="pageState === \'success\'">\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="Your password has been reset" theme="is-borderless">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tYou can now sign in to your payroll portal with your new password.\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\n\t\t\t<a class="button is-medium is-tertiary" href="" ui-sref="login">\n\t\t\t\tGo to sign in\n\t\t\t</a>\n\t\t</div>\n\t</sp-left>\n\n</split-pane>');
$templateCache.put('features/shared/help-and-support/helpAndSupportView.html','<help-and-support-panel display-mode="HELP_AND_SUPPORT_DISPLAY_OPTIONS.fullPage" help-and-support-options="helpAndSupportOptions"></help-and-support-panel>\n');
$templateCache.put('features/shared/intercom/intercomView.html','<div class="integration-connection fadeIn">\n\n\t<h1>{{code}}</h1>\n\t<h1>{{state}}</h1>\n</div>\n');
$templateCache.put('features/shared/login/login.view.html','<split-pane ng-if="pageState === \'ready\'" sp-left-theme="is-centered" sp-template="{{customisation.IsDefault ? \'paycircle\' : \'customisation\'}}">\n\t<sp-left>\n\t\t<div class="split-pane-form">\n\t\t\t<header class="split-pane-form-header">\n\t\t\t\t<h2 class="split-pane-form-title" ng-switch="credentials.loginType">\n\t\t\t\t\t<span pc-switch-when="LOGIN_TYPES.accessIdentityMigrate">{{getIdentityMigrateSignInTitleText()}}</span>\n\t\t\t\t\t<span pc-switch-when="LOGIN_TYPES.confirmEmail">Confirm your email address</span>\n\t\t\t\t\t<span pc-switch-when="LOGIN_TYPES.accessIdentityVerify">Check your inbox</span>\n\t\t\t\t\t<span pc-switch-when="LOGIN_TYPES.created">\n\t\t\t\t\t\tEmail address\n\t\t\t\t\t\t<confetti confetti-id="login-ran-confetti-for-verified" use-element-location="true">\n\t\t\t\t\t\t</confetti>\n\t\t\t\t\t\tverified\n\t\t\t\t\t</span>\n\t\t\t\t\t<span pc-switch-when="LOGIN_TYPES.workspaceMigrate">Welcome to Access Evo</span>\n\t\t\t\t\t<span ng-switch-default>Sign in to payroll</span>\n\t\t\t\t</h2>\n\t\t\t</header>\n\n\t\t\t<form class="form-style-a" method="post" name="loginForm" ng-submit="login(credentials, customisation)" novalidate autocomplete="on">\n\n\t\t\t\t<!-- UI for start (username/email only) -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.start">\n\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- Username or EmailAddress -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field_header has-anchor">\n\t\t\t\t\t\t\t\t<label for="loginUsernameOrEmail" class="form-field_label required">\n\t\t\t\t\t\t\t\tUsername\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<a class="is-small" tabindex="-1" ng-click="setPageState(\'reset-username\')">\n\t\t\t\t\t\t\t\tForgotten username?\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t\t<input autocomplete="username" id="loginUsernameOrEmail" name="usernameoremail" ng-model="credentials.loginUsernameOrEmail" placeholder="Username" required type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="loginForm.usernameoremail.$touched && loginForm.usernameoremail.$invalid" ng-messages="loginForm.usernameoremail.$error">\n\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter your Username\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<button class="is-tertiary is-fixed" ng-class="{\n\t\t\t\t\t\t\t\t\'is-positive\': credentials.loginUsernameOrEmailState === \'processing\'\n\t\t\t\t\t\t\t}" ng-disabled="credentials.loginUsernameOrEmailState === \'processing\'" type="submit">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginUsernameOrEmailState === \'\'">\n\t\t\t\t\t\t\t\tNext\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginUsernameOrEmailState === \'processing\'">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<section class="split-pane-form-feedback">\n\n\t\t\t\t\t\t<!-- Unexpected error -->\n\n\t\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="unexpectedError">\n\t\t\t\t\t\t\t\t<note note-title="There was a problem when trying to sign you in" note-theme="assertive" note-icon="icon-warning">\n\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t\tPlease try again. If the issue persists, please contact support.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<message-bar class="dropIn" theme="assertive" ng-if="credentials.loginUsernameOrEmailFailed">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tWe were unable to make this request. Please check your details and try again\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Change to SSO login -->\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="hr">OR</div>\n\t\t\t\t\t\t<a class="is-primary" href="" ng-click="credentials.loginType = LOGIN_TYPES.sso">\n\t\t\t\t\t\t\t<p class="is-strong is-small">\n\t\t\t\t\t\t\t\tUse single sign-on&nbsp;<i class="icon-chevron-right m"></i>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- accessIdentityMigrate and continue button is not clicked -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.accessIdentityMigrate && credentials.migratingUser.isCredentialsVerified && !credentials.newLoginContinueClicked">\n\t\t\t\t\t<img alt="Access" class="access-card_logo" src="/images/access-logo.png">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tWe\'ve changed the way you need to sign in to Paycircle and you\'ll now need to do so using the Access Identity platform.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIf you already use another Access product such as PeopleHR, you may have an existing Access account that you can also use to sign in to Paycircle. If Paycircle is the first Access product you\'ve used then you will need to set up a new Access account. Once you click \'Continue\' you\'ll be able to choose what you want to do in the next step. \n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIf you\'re unsure, we recommend quickly reading the below articles from our knowledge base before you continue.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<access-info-links show-overview-link="true"></access-info-links>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<button class="is-tertiary" type="button" ng-click="credentials.newLoginContinueClicked = true">\n\t\t\t\t\t\t\tContinue\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- accessIdentityMigrate and continue button is clicked-->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.accessIdentityMigrate && credentials.migratingUser.isCredentialsVerified && credentials.newLoginContinueClicked">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIf you already use another Access product, you may have an existing Access account. If Paycircle is the first Access product you\'ve used then you will need to set up a new Access account.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<h6>\n\t\t\t\t\t\t\tDo you need to set up a new Access account?\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</fieldset>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t<div class="form-field_input">\n\t\t\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t\t\t<input class="b" id="hasAccessAccountYes" name="hasAccessAccount" ng-disabled="credentials.loginSetupSigninIsLoading" ng-model="credentials.hasAccessAccount" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="hasAccessAccountYes">Yes</label>\n\t\t\t\t\t\t\t\t\t<input class="b" id="hasAccessAccountNo" name="hasAccessAccount" ng-disabled="credentials.loginSetupSigninIsLoading" ng-model="credentials.hasAccessAccount" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="hasAccessAccountNo">No</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<button class="is-tertiary" ng-disabled="credentials.loginSetupSigninIsLoading">\n\t\t\t\t\t\t\t<span ng-if="!credentials.hasAccessAccount">Set up a new Access account</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.hasAccessAccount">Sign in to your existing Access account</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<access-info-links></access-info-links>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- confirm email -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.confirmEmail && credentials.migratingUser.isCredentialsVerified">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p class="is-font-greyscale-300">\n\t\t\t\t\t\t\tWe\'re updating the login process for Paycircle which will require you to sign in with a unique\n\t\t\t\t\t\t\temail address in the future. Please confirm the email address you\'d like to use to continue.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="is-font-greyscale-300 split-pane-form-subtitle">\n\t\t\t\t\t\t\t<span class="is-font-greyscale-500">You\'re signed in as:</span>\n\t\t\t\t\t\t\t{{credentials.username}}\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="hr"></div>\n\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- EmailAddress -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field_header has-anchor">\n\t\t\t\t\t\t\t\t<label for="loginConfirmEmail" class="form-field_label required">\n\t\t\t\t\t\t\t\tEmail address\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t\t<input id="loginConfirmEmail" name="confirmEmail" ng-model="credentials.confirmEmail" ng-pattern="$root.REGEX.email" placeholder="Enter email address" required type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="loginForm.confirmEmail.$touched && loginForm.confirmEmail.$invalid">\n\t\t\t\t\t\t\t\t<p class="form-field_error">\n\t\t\t\t\t\t\t\t\tPlease enter a valid email address\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="credentials.loginDuplicateEmail && !credentials.accountAlreadyExists">\n\t\t\t\t\t\t\t\t<note note-title="Your email address must be unique" note-theme="assertive" note-icon="icon-warning">\n\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t\tThe email address you\'ve entered is already in use.\n\t\t\t\t\t\t\t\t\t\t\tPlease enter a unique email address and click \'Confirm\' to try again.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="credentials.loginDuplicateEmail && credentials.accountAlreadyExists">\n\t\t\t\t\t\t\t\t<note note-title="An Access account already exists" note-theme="assertive" note-icon="icon-warning">\n\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t\tThe email address you\'ve entered is already in use.\n\t\t\t\t\t\t\t\t\t\t\tPlease click \u2018Back\u2019 and sign in with your existing Access account.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<button class="is-fixed" ng-click="credentials.loginType = LOGIN_TYPES.accessIdentityMigrate" type="button">\n\t\t\t\t\t\t\t<span>Back</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="is-tertiary is-fixed" type="submit" ng-disabled="loginForm.confirmEmail.$invalid">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginConfirmEmailIsLoading === false">Confirm</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginConfirmEmailIsLoading === true">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<a class="is-primary" data-cy="login-link-what-is-a-unique-email" href="{{externalUrls.accessIdentityUrls.migrateAccount2}}" target="_blank" title="FAQ: What is a unique email?">\n\t\t\t\t\t\t\t<i class="icon-external-link"></i>\n\t\t\t\t\t\t\t<span>FAQ: What is a unique email?</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\t\t\t\t<!-- Verification code -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.accessIdentityVerify && credentials.migratingUser.isCredentialsVerified">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p class="is-font-greyscale-300">\n\t\t\t\t\t\t\tA verification code has been sent to your inbox.\n\t\t\t\t\t\t\tEnter the code below to continue. Please check your spam folder if\n\t\t\t\t\t\t\tyou don\u2019t see the email in your inbox in a moment.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="hr"></div>\n\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- EmailAddress -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field_header has-anchor">\n\t\t\t\t\t\t\t\t<label for="loginVerificationCode" class="form-field_label required">\n\t\t\t\t\t\t\t\t\tVerification code\n\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t\t<input id="loginVerificationCode" name="verificationCode" ng-model="credentials.verificationCode" ng-pattern="$root.REGEX.verificationCode" placeholder="Enter verification code" required type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="loginForm.verificationCode.$touched && loginForm.verificationCode.$invalid">\n\t\t\t\t\t\t\t\t<p class="form-field_error">\n\t\t\t\t\t\t\t\t\t6 characters, letters and numbers only\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-field_message" ng-if="loginForm.verificationCode.$untouched || !loginForm.verificationCode.$invalid">6 characters, letters and numbers only</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="credentials.loginVerificationInvalidOrExpired">\n\t\t\t\t\t\t<note note-title="There was a problem with your code" note-theme="assertive" note-icon="icon-warning">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tThis may be because it has expired or you have entered it incorrectly.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</fieldset>\n\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="credentials.resendVerificationCodeNotificationWarning">\n\t\t\t\t\t\t<note note-title="Verification code not resent" note-theme="assertive" note-icon="icon-warning">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tPlease wait for 1 minute before trying to resend your verification code again.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</fieldset>\n\t\t\t\t\t<fieldset class="form-field_errors has-margin-large" ng-if="credentials.resendVerificationCodeNotificationSuccess">\n\t\t\t\t\t\t<note note-title="Verification code resent" note-theme="secondary" note-icon="icon-tick">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tPlease check your spam folder if you don\'t see the email in your inbox in a moment.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<button class="is-fixed" ng-click="credentials.loginType = LOGIN_TYPES.confirmEmail" type="button">\n\t\t\t\t\t\t\tBack\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="is-tertiary is-fixed" type="submit" ng-disabled="loginForm.verificationCode.$invalid || credentials.verificationCode === \'\' || credentials.loginVerificationIsLoading === true">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginVerificationIsLoading === false">Confirm</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginVerificationIsLoading === true">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions is-left-column-alignment">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tDon\'t have a valid verification code?\n\t\t\t\t\t\t\t<button class="is-clear remove-space is-medium" type="button" ng-click="resendCode(credentials)" ng-disabled="credentials.loginVerificationRequestNewIsLoading">\n\t\t\t\t\t\t\t\t<span ng-if="credentials.loginVerificationRequestNewIsLoading === false">Resend code</span>\n\t\t\t\t\t\t\t\t<span ng-if="credentials.loginVerificationRequestNewIsLoading === true">\n\t\t\t\t\t\t\t\t\tResend code <i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tEntered the wrong email?\n\t\t\t\t\t\t\t<button class="is-clear remove-space is-medium" type="button" ng-click="credentials.loginType = LOGIN_TYPES.confirmEmail">\n\t\t\t\t\t\t\t\tUse a different email\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Verification code -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.created && credentials.migratingUser.isCredentialsVerified">\n\t\t\t\t\t<!-- Show the confetti as the code was verified -->\n\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p class="is-font-greyscale-300">\n\t\t\t\t\t\t\tOnce you click \'Continue\', you\'ll be redirected to Access to create a new password.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\t\t\t\t\t\t<access-card></access-card>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\t\t\t\t\t\t<button class="is-tertiary is-fixed" type="submit">\n\t\t\t\t\t\t\tContinue\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- accessEvoMigration  -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.workspaceMigrate">\n\t\t\t\t\t<img alt="Access" class="access-card_logo" src="/images/access-evo.png">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tYou\'re about to migrate your account to Access Evo, our cloud-based platform that brings all your Access products into one central hub.\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tOnce your account is migrated, a new Evo button will appear in the top left of the Paycircle header. This button allows you to navigate between your Access products using a single account.\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tClick \u2018Continue\u2019 and we\'ll guide you through the very quick migration process.\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIf you\'re unsure, we recommend quickly reading the below articles from our knowledge base before you continue.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</fieldset>\n\t\t\t\n\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\n\t\t\t\t\t<a class="is-primary" href="{{externalUrls.accessIdentityUrls.migrateAccount2}}" target="_blank" title="How do I migrate my account to Access Evo?">\n\t\t\t\t\t\t<i class="icon-external-link"></i>\n\t\t\t\t\t\t<span>How do I migrate my account to Access Evo?</span>\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<a class="is-primary" href="{{externalUrls.accessEvoUrls.whatIsEvo}}" target="_blank" title="What is Access Evo?">\n\t\t\t\t\t\t<i class="icon-external-link"></i>\n\t\t\t\t\t\t<span>What is Access Evo?</span>\n\t\t\t\t\t</a>\n\t\t\t\n\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<button class="is-tertiary" type="button" ng-click="migrateUserToWorkspace(credentials)">\n\t\t\t\t\t\t\t\tContinue\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="hr"></div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- UI for normal login -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.paycircle || (credentials.migratingUser.isMigrating && !credentials.migratingUser.isCredentialsVerified)">\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- Username -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field_header has-anchor">\n\t\t\t\t\t\t\t\t<label for="loginUsername" class="form-field_label required">\n\t\t\t\t\t\t\t\t\tUsername\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<a class="is-small" tabindex="-1" ng-click="setPageState(\'reset-username\')">\n\t\t\t\t\t\t\t\t\tForgotten username?\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t\t<input class="is-primary-200-flat" autocomplete="username" id="loginUsername" name="username" ng-model="credentials.username" placeholder="Username" readonly="readonly" required type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="\n\t\t\t\t\t\t\t\t\tloginForm.username.$touched &&\n\t\t\t\t\t\t\t\t\tloginForm.username.$invalid\n\t\t\t\t\t\t\t\t" ng-messages="loginForm.username.$error">\n\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter your username\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Password -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field_header has-anchor">\n\t\t\t\t\t\t\t\t<label class="form-field_label required" for="loginPassword">\n\t\t\t\t\t\t\t\t\tPassword\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<a class="is-small" tabindex="-1" ui-sref="reset-password">\n\t\t\t\t\t\t\t\t\tForgotten password?\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t\t<input autocomplete="current-password" id="loginPassword" name="password" ng-model="credentials.password" placeholder="Password" required type="password">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="\n\t\t\t\t\t\t\t\t\tloginForm.password.$touched &&\n\t\t\t\t\t\t\t\t\tloginForm.password.$invalid\n\t\t\t\t\t\t\t\t" ng-messages="loginForm.password.$error">\n\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter your password\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<button class="is-tertiary is-fixed" ng-class="{\n\t\t\t\t\t\t\t\t\'is-positive\': credentials.loginState === \'logged-in\'\n\t\t\t\t\t\t\t}" ng-disabled="credentials.loginDisabled" type="submit">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'\'">\n\t\t\t\t\t\t\t\tSign in\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'logging-in\' || credentials.loginState === \'logged-in\'">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<a class="is-small" tabindex="-1" ng-click="reset()">\n\t\t\t\t\t\t\tSign in with a different account\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<section class="split-pane-form-feedback">\n\n\t\t\t\t\t\t<!-- Slack Integration -->\n\t\t\t\t\t\t<message-bar class="dropIn" ng-if="credentials.connectionType && credentials.connectionType === \'slack\'" theme="indifferent">\n\t\t\t\t\t\t\t<p>Sign in to complete your Slack integration.</p>\n\t\t\t\t\t\t</message-bar>\n\n\t\t\t\t\t\t<!-- Attempts Remaining -->\n\t\t\t\t\t\t<message-bar class="dropIn" ng-if="loginAttempts >= 3 && loginAttempts < 5" theme="assertive">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tYou have&nbsp;\n\t\t\t\t\t\t\t\t<ng-pluralize count="loginAttemptsLeft" when="{\n\t\t\t\t\t\t\t\t\t\t\'0\': \'no attempts\',\n\t\t\t\t\t\t\t\t\t\t\'1\': \'1 attempt\',\n\t\t\t\t\t\t\t\t\t\t\'other\': \'{} attempts\'\n\t\t\t\t\t\t\t\t\t}"></ng-pluralize>&nbsp;\n\t\t\t\t\t\t\t\tleft. If you\'ve forgotten your password you can\n\t\t\t\t\t\t\t\t<a class="s" tabindex="-1" ui-sref="reset-password">\n\t\t\t\t\t\t\t\t\treset it here\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-bar>\n\n\t\t\t\t\t\t<!-- Locked Account -->\n\t\t\t\t\t\t<message-bar class="dropIn" ng-if="loginAttempts >= 5" theme="assertive">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tYour account has been locked.\n\t\t\t\t\t\t\t\t<a ui-sref="reset-password" tabindex="-1" class="s">\n\t\t\t\t\t\t\t\t\tReset your password\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\tto unlock your account.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-bar>\n\n\t\t\t\t\t\t<!-- Wrong Credentials -->\n\t\t\t\t\t\t<message-bar class="dropIn" theme="assertive" ng-if="loginAttempts < 3 && credentials.loginFailed">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tWe were unable to sign you in. Please check your details and try again\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-bar>\n\n\t\t\t\t\t\t<!-- Not payroll admin -->\n\t\t\t\t\t\t<message-bar class="dropIn" ng-if="!credentials.canAccess" theme="assertive">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tYou don\'t appear to have permission to sign into payroll. Could you be looking for the\n\t\t\t\t\t\t\t\t<a href="" ng-href="{{URLS.paycircle.userPortal}}">\n\t\t\t\t\t\t\t\t\tuser portal\n\t\t\t\t\t\t\t\t</a>?\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t</section>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- UI address for SSO login -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="credentials.loginType === LOGIN_TYPES.sso">\n\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- Email address -->\n\t\t\t\t\t\t<div class="split-pane-form-field">\n\t\t\t\t\t\t\t<label for="ssoLoginEmailAddress" class="split-pane-form-field-label required">\n\t\t\t\t\t\t\t\tEmail address\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<input autocomplete="email" id="ssoLoginEmailAddress" name="email" ng-model="credentials.email" placeholder="Email" required type="text">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<section class="split-pane-form-feedback">\n\t\t\t\t\t\t\t<!-- SSO not enabled for this user -->\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="getSSOMessageState(credentials) === \'userNotFound\'" theme="assertive">\n\t\t\t\t\t\t\t\t<p>SSO is not enabled for this email address.</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="getSSOMessageState(credentials) === \'identityMigratedUser\'" theme="assertive">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tPlease note that single sign-on (SSO) is no longer available in Paycircle. Click \'Go back\' and enter your Paycircle username to sign in using Access Identity.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="getSSOMessageState(credentials) === \'identityMigrationRequired\'" theme="assertive">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tPlease note that single sign-on (SSO) is no longer available in Paycircle. Click \'Go back\' and sign in with your Paycircle username and password to complete your migration to Access Identity.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="getSSOMessageState(credentials) === \'identityMigrationAndRegistrationRequired\'" theme="assertive">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tPlease note that single sign-on (SSO) is no longer available in Paycircle. Click \u2018Continue\u2019 and we\u2019ll walk you through what you need to do next.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t\t<!--Post redirect error state-->\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="credentials.ssoError" theme="assertive">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tIt looks like the credentials you\u2019ve entered don\u2019t have access to this application. Check you\u2019re using the correct credentials and try again.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t\t<message-bar class="dropIn" ng-if="getSSOMessageState(credentials) == \'unexpectedError\'" theme="assertive">\n\t\t\t\t\t\t\t\t<p>We\'re having trouble logging you in. Please try again.</p>\n\t\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t<button ng-if="getSSOMessageState(credentials) !== \'identityMigrationAndRegistrationRequired\'" class="tertiary split-pane-form-action-button" ng-class="{\n\t\t\t\t\t\t\t\t\'success\': credentials.loginState === \'logged-in\'\n\t\t\t\t\t\t\t}" ng-disabled="credentials.loginState === \'logging-in\'" type="submit">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'\'">\n\t\t\t\t\t\t\t\tSingle sign-on\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'logging-in\' || credentials.loginState === \'logged-in\'">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button ng-if="getSSOMessageState(credentials) === \'identityMigrationAndRegistrationRequired\'" class="tertiary split-pane-form-action-button" ng-class="{\n\t\t\t\t\t\t\t\t\'success\': credentials.loginState === \'logged-in\'\n\t\t\t\t\t\t\t}" ng-disabled="credentials.loginState === \'logging-in\'" ng-click="continueSSOForRegistration(credentials)">\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'\'">\n\t\t\t\t\t\t\t\tContinue\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span ng-if="credentials.loginState === \'logging-in\' || credentials.loginState === \'logged-in\'">\n\t\t\t\t\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<!-- Change to normal login -->\n\t\t\t\t\t<fieldset class="form-actions">\n\t\t\t\t\t\t<a class="is-primary" href="" ng-click="reset()">\n\t\t\t\t\t\t\t<p class="is-strong is-small">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-left m"></i>&nbsp;Go back\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\t\t\t</form>\n\n\t\t\t<footer class="split-pane-form-footer">\n\t\t\t\t<p class="xs">\n\t\t\t\t\t{{$root.CONFIG.dataProtectionStatement}}\n\t\t\t\t</p>\n\t\t\t\t<img alt="Powered by Paycircle" class="split-pane-form-powered-by" height="18" src="/images/powered-by-paycircle.svg">\n\t\t\t</footer>\n\t\t</div>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'reset-username\'">\n\t<sp-left>\n\t\t<div class="split-pane-left-container is-centered">\n\t\t\t<header>\n\t\t\t\t<h2 class="split-pane-left_title">Forgotten username</h2>\n\t\t\t\t<p>\n\t\t\t\t\tPlease contact your system admin so they can confirm your username for you.\n\t\t\t\t</p>\n\t\t\t</header>\n\t\t\t<div class="split-pane-left_additional-info">\n\t\t\t\t<p>\n\t\t\t\t\tRemembered it?\n\t\t\t\t\t<a class="is-primary" href="" ng-click="reset()">\n\t\t\t\t\t\tGo back to sign in\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'access-denied\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>IP address is not recognised</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Please contact your IT department or manager to arrange remote access to your account.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" ng-click="setPageState(\'ready\')">\n\t\t\t\t\tReturn to sign in\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'impersonation\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>Impersonation</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Paycircle does not support impersonation via your Access account.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" ng-click="gotoImpersonationLogin()">\n\t\t\t\t\tReturn to sign in\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'activeSession\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>Active Access Identity session detected</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p ng-if="activeSessionEmail">You\'re currently signed in to Access Identity as <strong style="user-select: none;">{{activeSessionEmail}}</strong></p>\n\t\t\t\t<p ng-if="!activeSessionEmail">An active Access Identity session was detected but the session details could not be retrieved.</p>\n\t\t\t\t<p>Please sign out of that Access Identity session before signing in with a different account to avoid losing unsaved work.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" data-cy="login-active-session-return-btn" ng-click="resetAfterActiveSession()">\n\t\t\t\t\tReturn to Sign In\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'migrationError\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>Please set up a new Access account</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Please note that the Access account you\u2019re trying to sign in to is already associated with an existing Payroll Portal account. To set up an alternative Access account click \u2018Return to sign in\u2019 and select \u2018No\u2019 when you\u2019re asked if you already have an Access account.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" ng-click="resetMigrationErrorWithDefaultNoAccessAccount()">\n\t\t\t\t\tReturn to sign in\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n\n<split-pane ng-if="pageState === \'migrationRequired\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>A new way to sign in</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>To continue signing in to your Payroll Portal using an Access account click \'Continue\'.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" ng-click="resetAfterMigrationRequiredError()">\n\t\t\t\t\tContinue\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<div class="spacer m"></div>\n\t\t<access-card></access-card>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n\n\n<split-pane ng-if="pageState === \'error\'">\n\t<sp-left>\n\t\t<placeholder placeholder-graphic="access-denied">\n\t\t\t<placeholder-title>{{signInErrorTitle}}</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>{{signInErrorMessage}}</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="primary" ng-click="resetAfterSignInError(credentials)">\n\t\t\t\t\tReturn to Sign in\n\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t\t<footer>\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</footer>\n\t</sp-left>\n</split-pane>\n');
$templateCache.put('features/shared/logout/logoutView.html','');
$templateCache.put('features/shared/password-expired/password-expired.view.html','<split-pane sp-template="{{customisation.IsDefault ? \'paycircle\' : \'customisation\'}}">\n\t<sp-left>\n\n\t\t<!-- Change password -->\n\t\t<form class="form-style-a fadeIn" method="post" name="changePasswordForm" ng-if="pageState === \'ready\'" ng-submit="changePassword(credentials, changePasswordForm)" novalidate>\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="It\'s time to reset your password">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIn order to keep your account secure we require you to reset your password once every 90 days. You won\'t be able to access your account until you have done so.\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\n\t\t\t<fieldset class="form-fieldset">\n\n\t\t\t\t<!-- New password -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t<label class="required" for="new-password">\n\t\t\t\t\t\t\tChoose a password\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t<validated-input-form-field allow-show-password="true" disable-autocomplete="true" field-name="Password" field-prompt="It must not be the same as your previous 12 passwords and should contain" input-name="new-password" ng-model="credentials.password" validation-type="{{INPUT_VALIDATION_TYPES.password}}">\n\t\t\t\t\t\t\t<vi-errors>\n\t\t\t\t\t\t\t\t<form-field-errors error-types="[\n\t\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\t\tkey: \'required\',\n\t\t\t\t\t\t\t\t\t\t\tmessage: \'Please enter a new password\'\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t]" input-name="new-password"></form-field-errors>\n\n\t\t\t\t\t\t\t\t<!-- Password invalid -->\n\t\t\t\t\t\t\t\t<div class="form-field_errors has-margin-large" ng-if="credentials.responseCode" ng-switch="credentials.responseCode">\n\n\t\t\t\t\t\t\t\t\t<!-- User does not exist -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="RESPONSE_CODES.userDoesNotExist">\n\t\t\t\t\t\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Unable to change password">\n\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere was a problem with your account. Please try again. If this continues, please contact your system admin.\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Existing password is incorrect -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="RESPONSE_CODES.incorrectExistingPassword">\n\t\t\t\t\t\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Existing password not matched">\n\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\t\t\tThe existing password doesn\'t match. If this continues, please contact your system admin.\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- New password does not comply -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="RESPONSE_CODES.passwordDoesNotSatisfyComplexityPolicy">\n\t\t\t\t\t\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Password is not valid">\n\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\t\t\tThe password does not satisfy the password policy. Please try again.\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Password has been changed in last 24 hours -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="RESPONSE_CODES.passwordChangedInPast24Hours">\n\t\t\t\t\t\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Password reset in last 24 hours">\n\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\t\t\tPlease note that you can only reset your password once in a 24 hour period.\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Password same as one of last 12 passwords used -->\n\t\t\t\t\t\t\t\t\t<div pc-switch-when="RESPONSE_CODES.passwordInHistory">\n\t\t\t\t\t\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Password used previously">\n\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\t\t\tIt must not be the same as your previous 12 passwords.\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</vi-errors>\n\t\t\t\t\t\t</validated-input-form-field>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- New password confirmation -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t<label class="required" for="new-password-confirm">\n\t\t\t\t\t\t\tConfirm password\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t<password-input allow-show-password="true" compare-password="credentials.password" disable-autocomplete="true" input-id="new-password-confirm" input-name="new-password-confirm" ng-model="credentials.passwordRepeated"></password-input>\n\t\t\t\t\t</div>\n\t\t\t\t\t<form-field-errors error-types="[\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tkey: \'required\',\n\t\t\t\t\t\t\t\tmessage: \'Please confirm your new password\'\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tkey: \'comparison\',\n\t\t\t\t\t\t\t\tmessage: \'Please make sure your passwords match\'\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t]" input-name="new-password-confirm"></form-field-errors>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Generic error -->\n\t\t\t<fieldset class="form-fieldset" ng-if="credentials.responseCode === RESPONSE_CODES.genericError">\n\n\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Unable to change password">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tThere was a problem changing your password. Please try again in a few minutes. If this continues, please contact your system admin\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t<submit-button disable-button="changePasswordForm.$invalid" display-text="\'Save new password\'" state="changePasswordForm.state"></submit-button>\n\n\t\t\t</fieldset>\n\t\t</form>\n\n\t\t<!-- No original password -->\n\t\t<div class="form-style-a fadeIn" ng-if="pageState === \'no-original-password\'">\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="Change your password">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTo change your password you need to first login.\n\t\t\t\t\t\t<a class="is-primary underline" ui-sref="login">\n\t\t\t\t\t\t\tGo to sign in\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\t\t</div>\n\n\t\t<!-- Success -->\n\t\t<div class="form-style-a fadeIn" ng-if="pageState === \'success\'">\n\n\t\t\t<form-header fh-show-title="false" fh-subtitle="Your password has been reset" theme="is-borderless">\n\t\t\t\t<form-header-intro>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tYou can now sign in to your payroll portal with your new password.\n\t\t\t\t\t</p>\n\t\t\t\t</form-header-intro>\n\t\t\t</form-header>\n\n\t\t\t<button class="is-medium is-tertiary" ui-sref="login" type="button">\n\t\t\t\tGo to sign in\n\t\t\t</button>\n\t\t</div>\n\t</sp-left>\n\n</split-pane>');
$templateCache.put('features/shared/reset-password/reset-password.view.html','<split-pane sp-left-theme="is-centered" sp-template="{{customisation.IsDefault ? \'paycircle\' : \'customisation\'}}">\n\t<sp-left>\n\t\t<div class="split-pane-form" ng-switch="pageState">\n\n\t\t\t<!-- Reset password -->\n\t\t\t<form class="form-style-a" name="resetPasswordForm" ng-submit="createPasswordRequest(user, resetPasswordForm)" pc-switch-when="PAGE_STATES.resetPassword" novalidate>\n\n\t\t\t\t<div class="split-pane-form-header">\n\t\t\t\t\t<h2 class="split-pane-form-title">\n\t\t\t\t\t\tForgotten password\n\t\t\t\t\t</h2>\n\t\t\t\t\t<p class="split-pane-form-subtitle">\n\t\t\t\t\t\tEnter your username and we\u2019ll send a password reset link to the recovery email address for this account.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset class="form-fieldset">\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field_header">\n\t\t\t\t\t\t\t<label class="form-field_label required" for="username">\n\t\t\t\t\t\t\t\tUsername\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field_main">\n\t\t\t\t\t\t\t<input id="username" name="username" ng-model="user.username" placeholder="Username" type="text" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field_errors fadeIn" ng-if="\n\t\t\t\t\t\t\t\tresetPasswordForm.username.$touched &&\n\t\t\t\t\t\t\t\tresetPasswordForm.username.$invalid\n\t\t\t\t\t\t\t" ng-messages="resetPasswordForm.username.$error">\n\t\t\t\t\t\t\t<p class="form-field_error" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter your username\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Unable to find username -->\n\t\t\t\t<fieldset class="form-fieldset" ng-if="user.isInvalidUsername">\n\n\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive">\n\t\t\t\t\t\t<note-header>\n\t\t\t\t\t\t\tUsername not found\n\t\t\t\t\t\t</note-header>\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tWe couldn\'t find an account with this username. Please check you have entered it correctly.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t\t<submit-button button-theme="\'is-tertiary is-fixed fixed-l\'" disable-button="resetPasswordForm.$invalid" display-text="\'Send password reset link\'" state="resetPasswordForm.state"></submit-button>\n\n\t\t\t\t</fieldset>\n\t\t\t</form>\n\n\t\t\t<!-- Reset password - Confirmed -->\n\t\t\t<div pc-switch-when="PAGE_STATES.resetPasswordConfirmation">\n\n\t\t\t\t<div class="split-pane-form-header">\n\t\t\t\t\t<h2 class="split-pane-form-title">\n\t\t\t\t\t\tPassword reset link sent\n\t\t\t\t\t</h2>\n\t\t\t\t\t<p class="split-pane-form-subtitle">\n\t\t\t\t\t\tA password reset link has been sent to the recovery email address for this account. Please check your spam folder if you don\u2019t see the email in your inbox in a moment.\n\t\t\t\t\t\tIf you don\u2019t receive your email, please contact your system admin.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Generic error -->\n\t\t\t<div pc-switch-when="PAGE_STATES.genericError">\n\n\t\t\t\t<div class="split-pane-form-header">\n\t\t\t\t\t<h2 class="split-pane-form-title">\n\t\t\t\t\t\tWe were unable to send a password link\n\t\t\t\t\t</h2>\n\t\t\t\t\t<p class="split-pane-form-subtitle">\n\t\t\t\t\t\tThere was a problem when sending your password link. Please contact support\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Remembered password? -->\n\t\t\t<div class="split-pane-form-footer">\n\t\t\t\t<p class="split-pane-form-footer-action">\n\t\t\t\t\tRemembered your password?\n\t\t\t\t\t<a class="underline" ui-sref="login">\n\t\t\t\t\t\tGo and sign in\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t\t<p class="xs">{{$root.CONFIG.dataProtectionStatement}}</p>\n\t\t\t\t<img alt="Powered by Paycircle" class="split-pane-form-powered-by" height="18" src="/images/powered-by-paycircle.svg">\n\t\t\t</div>\n\t\t</div>\n\t</sp-left>\n</split-pane>\n');
$templateCache.put('forms/admin/add-new-admin/add-new-admin.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Add new admin -->\n\t<form class="fadeIn" name="addNewAdminForm" ng-submit="addNewAdminSubmit(newAdmin, addNewAdminForm)" novalidate>\n\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">Enter details for the new admin and click &lsquo;Send invite&rsquo;. Unless you\u2019ve enabled single sign-on, they will be sent an invitation to register with Paycircle.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Name -->\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- First Name -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input id="forename" minlength="2" name="forename" ng-model="newAdmin.Forename" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewAdminForm.forename.$touched" ng-messages="addNewAdminForm.forename.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t\t<p ng-message="pattern">Name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Last Name -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input id="surname" name="surname" ng-model="newAdmin.Surname" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewAdminForm.surname.$touched" ng-messages="addNewAdminForm.surname.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t\t<p ng-message="pattern">Name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Name -->\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Email -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="email" class="required">Company email address:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input id="emailAddress" name="emailAddress" ng-model="newAdmin.EmailAddress" required type="email">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewAdminForm.emailAddress.$touched" ng-messages="addNewAdminForm.emailAddress.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Telephone number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="phone">Telephone number:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input id="phone" name="phone" ng-model="newAdmin.Telephone" ng-pattern="$root.REGEX.telephone" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewAdminForm.phone.$touched" ng-messages="addNewAdminForm.phone.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a telephone number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid phone number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- SSO ID (for SSO-enabled bureaus)-->\n\t\t\t<div class="form-field" ng-if="ssoEnabled">\n\t\t\t\t<label class="required" for="ssoId">Authentication ID:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="ssoId" name="ssoId" ng-model="newAdmin.SSOID" ng-model-options="{ debounce: 500 }" type="text" required ssoid-exists ssoid-exists-agency-profile-id="agencyProfileId" ssoid-exists-original="newAdmin.SSOID">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewAdminForm.ssoId.$touched" ng-messages="addNewAdminForm.ssoId.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a unique Authentication ID</p>\n\t\t\t\t\t<p ng-message="ssoid-exists">This Authentication ID is already in use</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Role / Permissions -->\n\t\t<fieldset class="form-fieldset-divider-top">\n\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="scheme">Choose a role:</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\n\t\t\t\t\t<!-- Bureau > Super user / Team member -->\n\t\t\t\t\t<div class="radio-rows-list" ng-if="formOptions.company.CompanyType === INTERFACE_TYPES.bureau">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleSuperUser" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.superUser" required type="radio">\n\t\t\t\t\t\t\t<label for="roleSuperUser" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.superUser | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleTeamMember" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.teamMember" required type="radio">\n\t\t\t\t\t\t\t<label for="roleTeamMember" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.teamMember | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Group > Group admin / Group admin lite-->\n\t\t\t\t\t<div class="radio-rows-list" ng-if="formOptions.company.CompanyType === INTERFACE_TYPES.group">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleGroupAdmin" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.groupAdmin" required type="radio">\n\t\t\t\t\t\t\t<label for="roleGroupAdmin" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.groupAdmin | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleGroupAdminLite" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.groupAdminLite" required type="radio">\n\t\t\t\t\t\t\t<label for="roleGroupAdminLite" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.groupAdminLite | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Company > Company admin / Company admin lite / Department admin -->\n\t\t\t\t\t<div class="radio-rows-list" ng-if="![INTERFACE_TYPES.bureau, INTERFACE_TYPES.group].includes(formOptions.company.CompanyType)">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleCompanyAdmin" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.companyAdmin" required type="radio">\n\t\t\t\t\t\t\t<label for="roleCompanyAdmin" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.companyAdmin | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleCompanyAdminLite" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.companyadministratorlite" required type="radio">\n\t\t\t\t\t\t\t<label for="roleCompanyAdminLite" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.companyadministratorlite | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="roleDepartmentAdmin" name="roleType" ng-change="updatePermissionsForRoleType(newAdmin)" ng-model="newAdmin.RoleType" ng-value="USER_ROLE_IDS.departmentadmin" required type="radio">\n\t\t\t\t\t\t\t<label for="roleDepartmentAdmin" class="radio-row-label">\n\t\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{USER_ROLE_IDS.departmentadmin | userRoleDescription}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</main>\n\n\t\t\t\t<footer class="form-field-footer fadeIn">\n\t\t\t\t\t<p class="s"><a href="" ng-click="toggleIsDefaultPermissions(newAdmin)" class="underline">Customise permissions</a></p>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Permissions -->\n\t\t\t<div class="form-field fadeIn" ng-if="!newAdmin.RoleDetail.IsDefault">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="scheme">Permissions:</label>\n\t\t\t\t\t<p class="s" ng-if="formOptions.company.CompanyType === INTERFACE_TYPES.bureau">If you adjust any permissions, they will only apply to this admin.</p>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<permissions-selector is-valid="newAdmin.isPermissionsValid" permissions-updated="newAdmin.hasPermissionsUpdated" role-detail="newAdmin.RoleDetail"></permissions-selector>\n\t\t\t\t</main>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions" ng-if="formOptions.formContext !== FORM_CONTEXTS.resendInvite">\n\n\t\t\t<!-- Close -->\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button disable-button="(newAdmin.RoleDetail.IsDefault && addNewAdminForm.$invalid) || (addNewAdminForm.$invalid || (!newAdmin.RoleDetail.IsDefault && !newAdmin.isPermissionsValid))" display-text="\'Send invite\'" state="addNewAdminForm.state"></submit-button>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions" ng-if="formOptions.formContext === FORM_CONTEXTS.resendInvite">\n\n\t\t\t<!-- Close -->\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t\t<button class="tertiary primary-action" ng-click="resendInvite(newAdmin, addNewAdminForm)" ng-disabled="addNewAdminForm.state === \'saving\' || newAdmin.state === \'saving\' || !addNewAdminForm.$valid" type="button">\n\t\t\t\t<span ng-show="newAdmin.state !== \'saving\'">Resend invite</span>\n\t\t\t\t<span ng-show="newAdmin.state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t\t</button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- Email exists -->\n<form-state form-options="formOptions" fs-show-close="false" fs-title="This email address is already in use" ng-if="pageState === \'email-exists\'">\n\t<fs-main>\n\t\t<section class="form-section">\n\t\t\t<p class="s">\n\t\t\t\tThe email address <strong>{{teamMember.EmailAddress}}</strong> is already being used by another user. If you recognise the name below, click &lsquo;Give admin access&rsquo; to\n\t\t\t\tcontinue. {{teamMember.Forename}} will be given admin access and sent a notification to let {{teamMember.Gender | personalise:\'him\'}} know.\n\t\t\t</p>\n\t\t</section>\n\n\t\t<!-- Existing User -->\n\t\t<section class="form-section">\n\t\t\t<user-card user="teamMember"></user-card>\n\t\t</section>\n\n\t\t<p class="s"><strong>Don\'t recognise the name?</strong> Contact support</p>\n\n\t\t<div class="form-actions">\n\n\t\t\t<!-- Cancel -->\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t\t<!-- Add new admin -->\n\t\t\t<button class="primary-action tertiary" ng-click="sendAdminInviteToTeamMember(teamMember)" ng-disabled="teamMember.state === \'saving\'" type="button">\n\t\t\t\t<span ng-show="teamMember.state !== \'supdateExistingAdminaving\'">Give admin access</span>\n\t\t\t\t<span ng-show="teamMember.state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t\t</button>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Invite Sent (external) -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{newAdmin.Fullname + \' has been invited\'}}" ng-if="pageState === FORM_STATES.inviteSentExternal">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\t{{newAdmin.Forename}} has been invited to become an admin of {{formOptions.company.Name}}.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Code -->\n\t\t<div class="form-state-section" ng-if="\n\t\t\t\t!ssoEnabled &&\n\t\t\t\tinvitation.InvitationStatus === REGISTRATION_INVITATION_STATUSES.ok &&\n\t\t\t\tinvitation.InvitationVerificationCode">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou now need to make sure you share {{newAdmin.Forename}}\'s unique verification code with them as they won\'t be able to register without it.\n\t\t\t\t\tTheir registration link and verification code will expire after 24 hours.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<note note-icon="icon-reference-number" note-title="Share this verification code" note-theme="is-primary is-emphasised primary">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tShare the below code with {{newAdmin.Forename}} using a secure method of your choosing.\n\t\t\t\t\t\t\tPlease don\'t share it with anyone else as they may get access to sensitive data.\n\t\t\t\t\t\t\tYou can view the code at any time by clicking on the action menu next to {{newAdmin.Forename}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-state-section has-padding-small">\n\t\t\t\t\t\t<admin-validation-code code="{{invitation.InvitationVerificationCode}}"></admin-validation-code>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a class="is-font-primary-400 link-with-icon strong is-small" href="" ng-click="copyVerificationCodeToClipboard(invitation.InvitationVerificationCode)">\n\t\t\t\t\t\t\t<i class="icon-duplicate"></i>\n\t\t\t\t\t\t\tCopy to clipboard\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fs-main>\n</form-state>\n\n<!-- Invite Sent (internal) -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{teamMember.Forename + \' is now an admin\'}}" ng-if="pageState === FORM_STATES.inviteSentInternal">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.Forename}} has been added as an admin for {{formOptions.company.Name}}.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Admin detials updated -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{newAdmin.Fullname + \' has been updated\'}}" ng-if="pageState === FORM_STATES.adminDetailsUpdated">\n\t<fs-main>\n\t\t<p class="s">{{newAdmin.Fullname}}\'s details have been updated.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Invite Sent -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{newAdmin.Forename + \' has been invited\'}}" ng-if="pageState === FORM_STATES.inviteResent">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\t{{newAdmin.Forename}} has been invited to become an admin of {{formOptions.company.Name}}.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Code -->\n\t\t<div class="form-state-section" ng-if="\n\t\t\t\t!ssoEnabled &&\n\t\t\t\tinvitation.InvitationStatus === REGISTRATION_INVITATION_STATUSES.ok &&\n\t\t\t\tinvitation.InvitationVerificationCode">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou now need to make sure you share {{newAdmin.Forename}}\'s unique verification code with them as they won\'t be able to register without it.\n\t\t\t\t\tTheir registration link and verification code will expire after 24 hours.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<note note-icon="icon-reference-number" note-title="Share this verification code" note-theme="is-primary has-border">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tShare the below code with {{newAdmin.Forename}} using a secure method of your choosing.\n\t\t\t\t\t\t\tPlease don\'t share it with anyone else as they may get access to sensitive data.\n\t\t\t\t\t\t\tYou can view the code at any time by clicking on the action menu next to {{newAdmin.Forename}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-state-section has-padding-small">\n\t\t\t\t\t\t<admin-validation-code code="{{invitation.InvitationVerificationCode}}"></admin-validation-code>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a class="is-font-primary-400 link-with-icon strong is-small" href="" ng-click="copyVerificationCodeToClipboard(invitation.InvitationVerificationCode)">\n\t\t\t\t\t\t\t<i class="icon-duplicate"></i>\n\t\t\t\t\t\t\tCopy to clipboard\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/addNewBureau/addNewBureauForm.html','<form name="addNewBureauForm" ng-submit="addNewBureau(bureau, addNewBureauForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Add a new bureau by providing the name of the new Bureau. Once created it will appear in your list of Bureaus.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Bureau name -->\n\t\t<div class="form-field">\n\t\t\t<label for="bureauname" class="required">Bureau name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="bureauname" name="bureauname" type="text" ng-model="bureau.bureauName" ng-pattern="$root.REGEX.lettersNumbersAndSymbols" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addNewBureauForm.bureauname.$error" ng-show="addNewBureauForm.bureauname.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Bureau names can only contain letters, numbers and basic symbols</p>\n\t\t\t\t<p ng-message="required">Please enter a bureau name</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="addNewBureauForm.state" ng-if="addNewBureauForm.state === \'saved\'">\n\t\t\t<p>{{bureau.bureauName}} has been set up and connected to your account.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNewBureauForm.state" disable-button="!addNewBureauForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="All done!" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">The new bureau, <strong>{{bureau.bureauName}}</strong>, has been created.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/adjustment-group/adjustment-group.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="adjustmentGroupForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateAdjustmentGroup(adjustmentGroupForm)" ng-switch="$ctrl.adjustmentGroupUpdateType" novalidate>\n\n\t<div pc-switch-when="$ctrl.ADJUSTMENT_GROUP_UPDATE_TYPES.newGroup" class="form-intro">\n\t\t<p class="is-small">Add a name and description and click \'Save\' before choosing which core elements will be included in this pack. You\'ll then be able to assign this pack to clients in your Companies page later.</p>\n\t</div>\n\n\t<div pc-switch-when="$ctrl.ADJUSTMENT_GROUP_UPDATE_TYPES.updateGroup" class="form-intro">\n\t\t<p class="is-small">Update the details below and click \'Save\' when you\'re done.</p>\n\t</div>\n\n\t<div pc-switch-when="$ctrl.ADJUSTMENT_GROUP_UPDATE_TYPES.duplicateGroup" class="form-section">\n\t\t<message-block theme="primary is-inline">\n\t\t\t<p><i class="icon-duplicate is-medium is-primary has-margin-right"></i>You\'re duplicating&nbsp;<strong>{{$ctrl.adjustmentGroup.agencyAdjustmentGroupNameOriginal}}</strong>&nbsp;which includes&nbsp;<ng-pluralize count="$ctrl.adjustmentGroup.NumberOfElementsVisible" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize>.</p>\n\t\t</message-block>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="name" class="required">Name</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="name" name="name" type="text" ng-model="$ctrl.adjustmentGroup.AgencyAdjustmentGroupName" ng-pattern="$root.REGEX.name" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="adjustmentGroupForm.name.$error" ng-if="adjustmentGroupForm.name.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a name</p>\n\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Description -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="description" class="required">Description</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<textarea name="description" id="description" maxlength="400" rows="4" ng-model="$ctrl.adjustmentGroup.AgencyAdjustmentGroupDescription" required></textarea>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="adjustmentGroupForm.description.$error" ng-if="adjustmentGroupForm.description.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a description</p>\n\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="adjustmentGroupForm.state" disable-button="!adjustmentGroupForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form class="fadeIn" name="setDefaultGroupForm" ng-if="$ctrl.pageState === \'set-default\'" ng-submit="$ctrl.updateAdjustmentGroup(setDefaultGroupForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to make this the default pay element pack?">\n\t\t<fs-preheader>\n\t\t\t<info-block ib-icon-dot="icon-adjustment" ib-theme="primary has-border has-large-title" ib-title="{{$ctrl.adjustmentGroup.AgencyAdjustmentGroupName}}">\n\t\t\t\t<ib-main>\n\t\t\t\t\t<span class="primary-light is-small"><ng-pluralize count="$ctrl.adjustmentGroup.NumberOfElementsVisible" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize></span>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</fs-preheader>\n\t\t<fs-main>\n\t\t\t<p class="is-small">The default pay element pack is automatically assigned to companies when you create them in your bureau. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="setDefaultGroupForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/addNewCompanyGroup/addNewCompanyGroupForm.html','<form name="addNewCompanyGroupForm" ng-submit="addNewCompanyGroup(companyGroup, addNewCompanyGroupForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\t\t<!-- Company Group name -->\n\t\t<div class="form-field">\n\t\t\t<label for="companygroupname" class="required">Group name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="companygroupname" name="companygroupname" type="text" ng-model="companyGroup.companyGroupName" ng-pattern="$root.REGEX.companyName" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyGroupForm.companygroupname.$error" ng-show="addNewCompanyGroupForm.companygroupname.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Only letters, numbers and ampersands are allowed in a company name</p>\n\t\t\t\t<p ng-message="required">Please enter a group name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Evo features radio cards -->\n\t\t<div class="form-field" ng-if="IsGroupCreationFeatureEnabled">\n\t\t\t<label class="required">Do you wish to enable Evo features for this group?</label>\n\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t<div class="radio-card">\n\t\t\t\t\t<input class="b radio-card-input" id="enableEvoFeaturesNo" name="enableEvoFeatures" ng-model="companyGroup.enableEvoFeatures" ng-value="false" required type="radio" ng-init="companyGroup.enableEvoFeatures = false">\n\t\t\t\t\t<label class="radio-card-label" for="enableEvoFeaturesNo">\n\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="radio-card">\n\t\t\t\t\t<input class="b radio-card-input" id="enableEvoFeaturesYes" name="enableEvoFeatures" ng-model="companyGroup.enableEvoFeatures" ng-value="true" required type="radio">\n\t\t\t\t\t<label class="radio-card-label" for="enableEvoFeaturesYes">\n\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field" ng-if="IsGroupCreationFeatureEnabled && companyGroup.enableEvoFeatures">\n\t\t\t<p class="is-small">\n\t\t\t\tSelect the Access Evo organisation you wish to link below. This will enable Evo features for admins of this company group.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-field" ng-if="IsGroupCreationFeatureEnabled && companyGroup.enableEvoFeatures">\n\t\t\t<p class="is-small">\n\t\t\t\tPlease ensure that you want all companies in this group to share the same customer code. If you don\'t, then do not connect this group to an Access Evo organisation. Once you click \'Save\', companies will be automatically added to this group based on the organisation you select below.\n\t\t\t</p>\n\t\t</div>\n\t\t<!-- Organization Selection -->\n\t\t<div class="form-field" ng-if="IsGroupCreationFeatureEnabled && companyGroup.enableEvoFeatures">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="workspaceOrganizations" class="required">Access Evo Organisation:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<select name="workspaceOrganizations" id="workspaceOrganizations" class="l" ng-model="selectedOrganization" ng-options="option.OrganisationID as option.OrganisationName for option in organizations" ng-change="setupSelectedOrganization(selectedOrganization)" required>\n\t\t\t\t\t<option value="">Select an Access Evo Organisation</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyGroupForm.workspaceOrganizations.$error" ng-show="addNewCompanyGroupForm.workspaceOrganizations.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an Access Evo Organisation</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Organization Warning note -->\n\t\t<div class="form-field" ng-if="IsGroupCreationFeatureEnabled && companyGroup.enableEvoFeatures && selectedOrganization">\t\t\t\n\t\t\t<note note-theme="tertiary" note-icon="icon-warning">\t\t\t\t\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="s">You\'re about to connect this company group to \'{{getSelectedOrganizationName(selectedOrganization)}}\' Access Evo organisation. If you select the wrong organisation and click \'Save\', then you will need to contact Support if you wish to change it.</p>\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<input checkbox id="confirmCorrectOrganization" label-text="\'I confirm this is the correct Access Evo organisation\'" ng-model="companyGroup.confirmCorrectOrganization" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="addNewCompanyGroupForm.state" ng-if="addNewCompanyGroupForm.state === \'saved\'">\n\t\t\t<p>{{companyGroup.companyGroupName}} has been set up and connected to your account.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNewCompanyGroupForm.state" disable-button="!addNewCompanyGroupForm.$valid || (IsGroupCreationFeatureEnabled && companyGroup.enableEvoFeatures && (!selectedOrganization || !companyGroup.confirmCorrectOrganization))"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="New group created" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{companyGroup.companyGroupName}} is now available in your list of company groups so you can start allocating companies to it when you need to.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/align-team-member-mappings-integration/align-team-member-mappings-integration.form.html','<form name="alignTeamMemberMappingsIntegrationForm" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.confirm($ctrl)" novalidate>\n\t<!-- View: actions -->\n\t<div ng-if="$ctrl.currentView === $ctrl.view.actions">\n\n\t\t<p class="is-small is-tertiary is-strong">\n\t\t\tOnce you\'re happy you\'ve completed all the steps listed on the settings page, \n\t\t\t<span class="has-underline">follow the below steps exactly as listed</span>.\n\t\t</p>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<h4>Reports to use</h4>\n\n\t\t<p class="is-small is-font-greyscale-300">\n\t\t\tYou can run these reports at any time during this data alignment process to give you an understanding of the current mapping of employees between products and incoming employee records.\n\t\t</p>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<note note-theme="basic">\n\t\t\t<note-content>\n\t\t\t\t<a class="is-primary is-strong" ng-click="$ctrl.clickAction.employeeMappingReport()">\n\t\t\t\t\t<i class="icon-right bureau-card-icon"></i> Existing employee mappings (CSV)\n\t\t\t\t</a>\n\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\tThis CSV report will show you who is and isn\'t mapped between the 2 products.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<note note-theme="basic">\n\t\t\t<note-content>\n\t\t\t\t<a class="is-primary is-strong" ng-click="$ctrl.clickAction.incomingEmployeesReport()">\n\t\t\t\t\t<i class="icon-right bureau-card-icon"></i> Employee creation events in limbo (CSV)\n\t\t\t\t</a>\n\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\tThis CSV report will show you the employee creation events sent over by the \'Bulk export\' in\n\t\t\t\t\tPeopleHR and are currently in limbo.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<div class="slide-in-form form-sub-heading"></div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<h4>Starting point</h4>\n\n\t\t<p class="is-small is-tertiary is-strong">\n\t\t\t<span class="has-underline">You must follow these 2 steps</span> to start the process of aligning the data between the 2 products.\n\t\t</p>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 1 - Clear existing events and mapping">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick this button to delete all integration events and clear all employee mapping links so you can run the next steps from a clean starting point.\n\t\t\t\t</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<button class="is-primary" type="button" ng-click="$ctrl.clickAction.clearAllEventsAndDeleteInternalMapping()">Clear events</button>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<note note-theme="is-tertiary" note-title="Step 2 - Run the \'Bulk export\' in the PeopleHR Super Admin Tool">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis will send over all the events from PeopleHR to Paycircle. After this is done, you can run the\n\t\t\t\t\t\'Employee creation events in limbo\' report to check that the events are there.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<div class="slide-in-form form-sub-heading"></div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<h4>Data aligning</h4>\n\n\t\t<p class="is-small is-tertiary is-strong">\n\t\t\tThese next steps are to align the data between PeopleHR and Paycircle. Depending on the outcome of steps 3, 4,\n\t\t\tand 5, you may need to start again from step 1 above. For example, if you have had to make any adjustments in\n\t\t\tPeopleHR you may need to start from step 1 again. \n\t\t</p>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 3 - Map employees automatically">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick this button to automatically map employees from the events sent over via the bulk export,\n\t\t\t\t\tand assign them their PeopleHR Employee ID in Paycircle. \n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tCheck CSV for any missing data, the frequent reasons behind missing data are the following:\n\t\t\t\t</p>\n\n\t\t\t\t<div class="spacer s"></div>\n\n\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\'Missing company ID from the team member in PeopleHR\',\n\t\t\t\t\t\t\'Team member doesn\u2019t exist in PeopleHR or Paycircle\',\n\t\t\t\t\t\t\'Missing company ID from the team member in PeopleHR\'\n\t\t\t\t\t\t]" bl-theme="is-primary is-small"></bullet-list>\n\n\t\t\t\t<div class="spacer s"></div>\n\n\t\t\t\t<p class="is-small is-strong">\n\t\t\t\t\tAt this point run the reporting tool \'Existing employee mappings (CSV)\' to check the current mapping for team members.\n\t\t\t\t</p>\n\n\t\t\t\t<div class="spacer s"></div>\n\n\t\t\t\t<button class="is-primary" type="button" ng-click="$ctrl.clickAction.autoMapIncomingEmployees()">Auto-map employees</button>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 4 - Export employee mapping">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis CSV report will contain employees in Paycircle including their PeopleHR Employee ID. You\'ll be able to see which team members didn\'t get picked\n\t\t\t\t\tup in the auto-mapping in step 4 and will need their PeopleHR Employee ID adding to the CSV file.\n\t\t\t\t</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<button class="is-primary" type="button" ng-click="$ctrl.clickAction.employeeMappingExport()">Download CSV</button>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 5 - Import updated employee mapping CSV">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tUpload the updated CSV file from step 4 to populate the PeopleHR Employee IDs for employees.\n\t\t\t\t</p>\n\n\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t<file-uploader-queued fu-queue="$ctrl.documents" fu-on-queue-update="$ctrl.updateFiles($ctrl)" fu-max-file-size="2097152" ng-if="$ctrl.documents.length === 0"></file-uploader-queued>\n\n\t\t\t\t<div ng-if="$ctrl.documents.length === 1">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t{{$ctrl.documents[0].DocumentName}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<a class="is-small stronger" ng-click="$ctrl.clickAction.clearDocuments()">Choose another file</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t<button class="is-primary" ng-disabled="$ctrl.documents.length === 0" type="button" ng-click="$ctrl.clickAction.employeeMappingImport()">Import</button>\n\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tAt this point you can run the \'Existing employee mappings\' report to check the current mapping for team members.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<div class="slide-in-form form-sub-heading"></div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<h4>Finalise</h4>\n\n\t\t<p class="is-small is-tertiary is-strong has-underline">\n\t\t\tOnly run these steps when all existing team members have a valid PeopleHR Employee ID added in Paycircle.\n\t\t</p>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 6 - Generate internal mapping">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick this button to update the mapping between employees and the EmployeeCreated events\n\t\t\t\t\twhich in turn will update the internal mapping required.\n\t\t\t\t</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<button class="is-primary" type="button" ng-click="$ctrl.clickAction.generateInternalMapping()">Generate</button>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<note note-theme="is-primary" note-title="Step 7 - Clean up processed events">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick this button to delete all processed events for employees who are already mapped. This will ensure\n\t\t\t\t\tthat only genuine new employee events remain in Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t<button class="is-primary" type="button" ng-click="$ctrl.clickAction.mappedEmployeeBulkExportMappingEventsCleanUp()">Clear events</button>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<p class="is-small is-tertiary is-strong">\n\t\t\tOnce all steps are complete, turn ON the Integration in Paycircle.\n\t\t</p>\n\n\t</div>\n\n\t<!-- View: confirm -->\n\t<div ng-if="$ctrl.currentView === $ctrl.view.confirm">\n\n\t\t<div class="form-intro">\n\t\t\t<h3 class="form-header_subtitle">\n\t\t\t\t<i class="icon-question-mark is-primary xl"></i> Are you sure?\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<div class="form-header_intro">\n\t\t\tThis action may update team member data. Ensure you are happy for this action to be processed.\n\t\t\t<div class="spacer m"></div>\n\t\t\tClick \'Confirm\' If you are happy to continue.\n\t\t</div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<a class="is-small stronger" ng-click="$ctrl.backToActionsView()">\n\t\t\tBack to Align Team Member mappings\n\t\t</a>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" ng-click="$ctrl.closeAndReload()" type="button">Cancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'"></submit-button>\n\t\t</fieldset>\n\n\t</div>\n\n\t<!-- View: processing -->\n\t<div ng-if="$ctrl.currentView === $ctrl.view.processing">\n\n\t\t<loading-block></loading-block>\n\n\t\t<div class="centered">\n\t\t\t<h2>Processing...</h2>\n\n\t\t\t<article>\n\t\t\t\t<p>\n\t\t\t\t\tProcessing updates, please do not close this page or click the back button in your browser until completed.\n\t\t\t\t</p>\n\t\t\t</article>\n\n\t\t</div>\n\n\t</div>\n\n\t<!-- View: complete -->\n\t<div ng-if="$ctrl.currentView === $ctrl.view.complete">\n\n\t\t<div class="form-intro">\n\t\t\t<h3 class="form-header_subtitle">\n\t\t\t\t<i class="icon-tick is-secondary xl"></i> Process has finished\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<div class="form-header_intro">\n\t\t\tThis action has now been completed, you are safe to close this page or click \'Back to mapping tasks\'.\n\t\t</div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<a class="is-small stronger" ng-click="$ctrl.backToActionsView()">\n\t\t\tBack to Align Team Member mappings\n\t\t</a>\n\n\t</div>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.closeAndReload()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/archive-bureau/archive-bureau.form.html','<form name="archiveBureauForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.archiveBureau" ng-submit="$ctrl.updateBureauArchiveStatus($ctrl.formOptions.bureauCompany, archiveBureauForm, true)">\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Would you like to archive this bureau?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tOnce you click \u2018Confirm\u2019, {{$ctrl.formOptions.bureauCompany.Name}} will be moved to your archived bureaus page.\n\t\t\t\tYou can undo this action at any time and {{$ctrl.formOptions.bureauCompany.Name}} will then be restored.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="archiveBureauForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<form name="archiveBureauForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.undoArchiveBureau" ng-submit="$ctrl.updateBureauArchiveStatus($ctrl.formOptions.bureauCompany, archiveBureauForm, false)">\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to restore this bureau?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tOnce you click \u2018Confirm\u2019, {{$ctrl.formOptions.bureauCompany.Name}} will be moved to your bureaus page.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="archiveBureauForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/archiveCompany/archiveCompanyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Archive -->\n<form name="archiveCompanyForm" ng-submit="setPageState(\'confirm\')" class="fadeIn" ng-if="pageState === \'archive\'" novalidate>\n\n\t<!-- Non-payslip Manager  -->\n\t<div class="form-intro" ng-if="!formOptions.company.IsPayslipManagerActive">\n\t\t<p class="s">Archiving {{formOptions.company.Name}} means all automated connections with HMRC, workplace pensions and any other integrations will stop working and they will be removed from any company groups. All company data will be read-only and some company views will be limited.<!--<a href="" ng-click="$root.openSupportTab()" class="underline">Read more about archiving companies</a>--></p>\n\t\t<p class="s">No emails will be sent for this company as of the point it is archived. If you would like any emails to be sent for this company, such as pay notifications for a period you have just finalised, please return to this page and archive the company after the emails have been sent.</p>\n\t</div>\n\n\t<!-- Payslip Manager -->\n\t<div class="form-intro" ng-if="formOptions.company.IsPayslipManagerActive">\n\t\t<p class="is-small">Archiving {{formOptions.company.Name}} means all company data will be read-only and some company views will be limited. It will also be removed from any company groups.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reason -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="reasonForArchive" class="required">Select a reason for archiving:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="reasonForArchive" id="reasonForArchive" ng-model="vm.archiveReason" ng-options="option.name as option.name for option in ARCHIVE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="archiveCompanyForm.reasonForArchive.$error" ng-if="archiveCompanyForm.reasonForArchive.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a reason</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="admins.length">\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Admins</h5>\n\t\t\t<p class="s">Please note that the following admins currently have access to {{formOptions.company.Name}}. You can manage admin acess from the archived companies page as usual.</p>\n\t\t</div>\n\n\t\t<div ng-repeat="admin in admins">\n\t\t\t{{admin.Forename}}\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Next\'" state="archiveCompanyForm.state" disable-button="!archiveCompanyForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm -->\n<form name="archiveCompanyConfirmationForm" ng-submit="archiveCompany(vm, archiveCompanyConfirmationForm)" class="fadeIn" ng-if="pageState === \'confirm\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to archive?">\n\t\t<fs-main>\n\t\t\t<p class="s">Once you click &lsquo;Archive&rsquo;, {{formOptions.company.Name}} will be moved to your archived companies page and all data will become read-only. You can undo this action at any time. {{formOptions.company.Name}} will then be restored along with all its data - as of the day it was archived.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" ng-click="setPageState(\'ready\')" class="button secondary-action">Cancel</a>\n\t\t\t<submit-button display-text="\'Archive\'" state="archiveCompanyConfirmationForm.state" disable-button="!archiveCompanyConfirmationForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Undo archive -->\n<form name="undoArchiveCompanyConfirmationForm" ng-submit="undoArchiveCompany(vm, undoArchiveCompanyConfirmationForm)" class="fadeIn" ng-if="pageState === \'undo-archive\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to restore this company?">\n\t\t<fs-main>\n\t\t\t<p class="s">Once you click &lsquo;Undo archive&rsquo;, {{formOptions.company.Name}} will be restored to its state as of the moment it was archived. Some data may now be out of date and you will need to update it if anything has changed. <!--<a href="">Read more about undoing archived companies</a>--></p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" ng-click="setPageState(\'ready\')" class="button secondary-action">Cancel</a>\n\t\t\t<submit-button display-text="\'Undo archive\'" state="undoArchiveCompanyConfirmationForm.state" disable-button="!undoArchiveCompanyConfirmationForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/autoCreateCompany/autoCreateCompanyForm.html','<form name="autoCreateCompanyForm" ng-submit="addNewTestCompany(testCompany.companyName, autoCreateCompanyForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">To auto-create a company simply add a name below and a new, pre-populated company will be added to your playground.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<label for="companyname" class="required">Company name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="companyname" name="companyname" type="text" ng-model="testCompany.companyName" ng-pattern="$root.REGEX.companyName" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="autoCreateCompanyForm.companyname.$error" ng-show="autoCreateCompanyForm.companyname.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="autoCreateCompanyForm.state" ng-if="autoCreateCompanyForm.state === \'saved\'">\n\t\t\t<p>{{testCompany.companyName}} has been set up and connected to your account.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="autoCreateCompanyForm.state" disable-button="!autoCreateCompanyForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="New company created" ng-if="pageState === \'created\'">\n\t<fs-main>\n\t\t<p class="s"><strong>{{testCompany.companyName}}</strong> has been created and pre-populated with payroll history, a workplace pension and three team members.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/average-holiday-pay-options/average-holiday-pay-options.form.html','<!-- Edit -->\n<form class="fadeIn" name="averageHolidayPayOptionsForm" ng-if="$ctrl.pageState === \'edit\'" ng-submit="$ctrl.onPrimaryAction(averageHolidayPayOptionsForm)" novalidate>\n\n\t<div class="form-content-block">\n\t\t<p class="s" data-cy="average-holiday-pay-options-selected-count">\n\t\t\tYou\'re managing 52-week average holiday pay settings for <strong>{{$ctrl.selectedCount}}</strong>\n\t\t\tpay element{{$ctrl.selectedCount === 1 ? \'\' : \'s\'}}.\n\t\t\tSelect if you wish to turn it on or off, then set the rate type and click \'Save\' to update.\n\t\t</p>\n\t</div>\n\n\t<!-- 52-week average holiday pay toggle -->\n\t<fieldset>\n\t\t<legend hidden>52-week average holiday pay</legend>\n\t\t<div class="settings-rows">\n\t\t\t<settings-row data-cy="average-holiday-pay-options-include-toggle" ng-model="$ctrl.form.includeIn52WeekAverage" sr-field-name="includeIn52WeekAverage" sr-icon="holiday" sr-theme="quarternary">\n\t\t\t\t<sr-label>52-week average holiday pay</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-if="!$ctrl.form.includeIn52WeekAverage">Switch to &lsquo;ON&rsquo; if you wish to include these payments in the 52-week average holiday pay calculations.</span>\n\t\t\t\t\t<span ng-if="$ctrl.form.includeIn52WeekAverage">Switch to &lsquo;OFF&rsquo; if you wish to exclude these payments from the 52-week average holiday pay calculations.</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Always included / excluded note -->\n\t<fieldset>\n\t\t<legend hidden>What is always included or excluded</legend>\n\t\t<note note-icon="icon-support" note-theme="indifferent">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Salary is always included in the 52-week average holiday pay calculation.</p>\n\t\t\t\t<p class="s">Statutory payments and payrolled benefits are excluded.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- Rate type -->\n\t<fieldset>\n\t\t<legend hidden>Rate type</legend>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="averageHolidayPayOptionsRateTypeDaily">Rate type</label>\n\t\t\t\t<p class="s" data-cy="average-holiday-pay-options-rate-type-description">\n\t\t\t\t\tSelect how these payments should be treated for the 52-week average holiday pay calculation. Note that the option selected will apply to all historic periods.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list">\n\n\t\t\t\t\t<!-- Daily -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="average-holiday-pay-options-rate-type-daily" id="averageHolidayPayOptionsRateTypeDaily" name="averageHolidayPayOptionsRateType" ng-model="$ctrl.form.rateType" ng-value="$ctrl.AVERAGE_HOLIDAY_PAY_RATE_TYPES.daily" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="averageHolidayPayOptionsRateTypeDaily">\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title"><strong>Daily</strong></p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">Payments will be treated as Daily rates for the 52-week calculation.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Hourly -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="average-holiday-pay-options-rate-type-hourly" id="averageHolidayPayOptionsRateTypeHourly" name="averageHolidayPayOptionsRateType" ng-model="$ctrl.form.rateType" ng-value="$ctrl.AVERAGE_HOLIDAY_PAY_RATE_TYPES.hourly" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="averageHolidayPayOptionsRateTypeHourly">\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title"><strong>Hourly</strong></p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">Payments will be treated as Hourly rates for the 52-week calculation.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Other -->\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="average-holiday-pay-options-rate-type-other" id="averageHolidayPayOptionsRateTypeOther" name="averageHolidayPayOptionsRateType" ng-model="$ctrl.form.rateType" ng-value="$ctrl.AVERAGE_HOLIDAY_PAY_RATE_TYPES.other" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="averageHolidayPayOptionsRateTypeOther">\n\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t<p class="radio-card-title"><strong>Other</strong></p>\n\t\t\t\t\t\t\t\t<p class="radio-card-description">Payments will be treated as a period payment for the 52-week calculation.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" data-cy="average-holiday-pay-options-cancel" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button button-id="average-holiday-pay-options-submit" disable-button="!averageHolidayPayOptionsForm.$valid" display-text="$ctrl.primaryButtonText" state="averageHolidayPayOptionsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Detecting divergent companies -->\n<loading-block ng-if="$ctrl.pageState === \'detecting\'"></loading-block>\n\n<!-- Push settings to companies -->\n<form class="slide-in-form-content fadeIn" name="pushSettingsToCompaniesForm" ng-if="$ctrl.pageState === \'select-companies\'" ng-submit="$ctrl.pushDown(pushSettingsToCompaniesForm)" novalidate>\n\n\t<!-- Some companies won\'t inherit this automatically -->\n\t<fieldset ng-if="$ctrl.companies.all.length > 0">\n\t\t<legend hidden>Companies affected</legend>\n\t\t<note data-cy="average-holiday-pay-push-warning" note-icon="icon-warning" note-theme="tertiary" note-title="Some companies have overridden these pay elements">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe companies below have their own version of one or more of the selected pay elements and won\'t automatically inherit this bureau-level setting.\n\t\t\t\t\tSelect the companies you wish to push the new settings to, or leave them for manual review at company level.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- No companies need updating -->\n\t<fieldset ng-if="$ctrl.companies.all.length === 0">\n\t\t<legend hidden>No companies need updating</legend>\n\t\t<note data-cy="average-holiday-pay-push-empty" note-icon="icon-information" note-theme="indifferent" note-title="No further company updates are required">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Every company already inherits these pay elements from the bureau, so there\'s nothing to push down.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<div ng-if="$ctrl.companies.all.length > 0">\n\n\t\t<!-- Filters -->\n\t\t<fieldset>\n\t\t\t<legend hidden>Filter by pay element</legend>\n\t\t\t<filter-bar data-cy="average-holiday-pay-push-filter-bar" filter-bar-options="$ctrl.filterBarOptions"></filter-bar>\n\t\t</fieldset>\n\n\t\t<!-- Select all + search -->\n\t\t<fieldset>\n\t\t\t<legend hidden>Search</legend>\n\t\t\t<div class="average-holiday-pay-push-toolbar">\n\t\t\t\t<div class="average-holiday-pay-push-toolbar_select-all">\n\t\t\t\t\t<div class="average-holiday-pay-push-toolbar_select-all-row">\n\t\t\t\t\t\t<a aria-label="Select all companies" class="multiple-select-checkbox" data-cy="average-holiday-pay-push-select-all" href="" ng-class="{\n\t\t\t\t\t\t\t\t\'checked\': $ctrl.companies.totalSelected > 0 && $ctrl.companies.totalSelected === $ctrl.companies.total,\n\t\t\t\t\t\t\t\t\'indeterminate\': $ctrl.companies.totalSelected > 0 && $ctrl.companies.totalSelected < $ctrl.companies.total\n\t\t\t\t\t\t\t}" ng-click="$ctrl.onSelectAllToggle()"></a>\n\t\t\t\t\t\t<span class="s">Select all</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<span class="average-holiday-pay-push-toolbar_count s" data-cy="average-holiday-pay-push-company-count">\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.companies.filtered.length" when="{\n\t\t\t\t\t\t\t\t\'0\': $ctrl.searchBarOptions.search.terms.noResults,\n\t\t\t\t\t\t\t\t\'1\': $ctrl.searchBarOptions.search.terms.singular,\n\t\t\t\t\t\t\t\t\'other\': $ctrl.searchBarOptions.search.terms.plural\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<search-bar bulk-items="$ctrl.companies" data-cy="average-holiday-pay-push-search-bar" options="$ctrl.searchBarOptions"></search-bar>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Company cards -->\n\t\t<fieldset class="form-content-block">\n\t\t\t<legend hidden>Companies</legend>\n\t\t\t<div class="average-holiday-pay-element-row_wrapper rows">\n\t\t\t\t<div class="average-holiday-pay-element-row fadeIn" data-cy="average-holiday-pay-push-company-card" dir-paginate="company in $ctrl.companies.filtered = (\n\t\t\t\t\t\t\t$ctrl.companies.all |\n\t\t\t\t\t\t\tfilter : $ctrl.matchesSearch |\n\t\t\t\t\t\t\tfilter : $ctrl.filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\ttrack by company.CompanyAgencyProfileID\n\t\t\t\t\t" ng-class="{ \'is-selected\': company.isSelected }" pagination-id="\'push-companies\'">\n\t\t\t\t\t<div class="average-holiday-pay-element-row_layout">\n\t\t\t\t\t\t<div class="average-holiday-pay-element-row_action">\n\t\t\t\t\t\t\t<input checkbox aria-label="Select {{company.CompanyName}}" data-cy="average-holiday-pay-push-company-checkbox" id="{{::company.CompanyAgencyProfileID}}" ng-change="$ctrl.onCheckboxToggle()" ng-model="company.isSelected" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="average-holiday-pay-element-row_content">\n\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_details">\n\t\t\t\t\t\t\t\t<h5 class="average-holiday-pay-element-row_heading" data-cy="average-holiday-pay-push-company-name">\n\t\t\t\t\t\t\t\t\t<i class="icon-company"></i>\n\t\t\t\t\t\t\t\t\t{{company.CompanyName}}\n\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t<span class="average-holiday-pay-element-row_meta average-holiday-pay-push-elements-summary" data-cy="average-holiday-pay-push-company-elements">\n\t\t\t\t\t\t\t\t\tOverridden element{{company.elementNames.length === 1 ? \'\' : \'s\'}}: {{company.inlineElementNames.join(\', \')}}<span ng-if="company.hasMoreElementNames">, </span>\n\t\t\t\t\t\t\t\t\t<a data-cy="average-holiday-pay-push-company-see-more" href="" ng-click="$ctrl.viewElements(company)" ng-if="company.hasMoreElementNames">&hellip; see more</a>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_tags">\n\t\t\t\t\t\t\t\t<span class="tag primary inverse" data-cy="average-holiday-pay-push-company-status-selected" ng-if="company.isSelected">\n\t\t\t\t\t\t\t\t\tWill be pushed\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class="tag tertiary inverse" data-cy="average-holiday-pay-push-company-status-manual" ng-if="!company.isSelected">\n\t\t\t\t\t\t\t\t\tManual review\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="$ctrl.companies.filtered.length === 0" search-bar-options="$ctrl.searchBarOptions"></empty-search>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="$ctrl.searchBarOptions.onPageChange(newPageNumber)" pagination-id="\'push-companies\'"></dir-pagination-controls>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" data-cy="average-holiday-pay-push-back" href="" ng-click="$ctrl.backToEdit()">Back</a>\n\t\t<submit-button button-id="average-holiday-pay-push-submit" display-text="\'Save\'" state="pushSettingsToCompaniesForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- A company\'s full overridden element list -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'company-elements\'">\n\t<div class="form-content-block">\n\t\t<a class="link-with-icon greyscale" data-cy="average-holiday-pay-push-elements-back" href="" ng-click="$ctrl.backToCompanyList()">\n\t\t\t<i class="icon-back"></i>Back to companies\n\t\t</a>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<h6 data-cy="average-holiday-pay-push-elements-company-name">{{$ctrl.viewingCompany.CompanyName}}</h6>\n\t\t<p class="s">\n\t\t\tOverridden element{{$ctrl.viewingCompany.elementNames.length === 1 ? \'\' : \'s\'}} ({{$ctrl.viewingCompany.elementNames.length}})\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<bullet-list bl-items="$ctrl.viewingCompany.elementNames" bl-theme="is-primary" data-cy="average-holiday-pay-push-elements-list"></bullet-list>\n\t</div>\n</div>\n\n<!-- Success -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="Pay element settings updated" ng-if="$ctrl.pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s" data-cy="average-holiday-pay-options-success-message">\n\t\t\tSettings have been updated for {{$ctrl.selectedCount}} pay element{{$ctrl.selectedCount === 1 ? \'\' : \'s\'}}.\n\t\t</p>\n\t\t<p class="s" data-cy="average-holiday-pay-push-success-message" ng-if="$ctrl.pushedCompanyCount > 0">\n\t\t\t{{$ctrl.pushedElementCount}} pay element version{{$ctrl.pushedElementCount === 1 ? \'\' : \'s\'}} also pushed to {{$ctrl.pushedCompanyCount}} compan{{$ctrl.pushedCompanyCount === 1 ? \'y\' : \'ies\'}}.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/changeAdminState/changeAdminStateForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Remove from team?" ng-if="formOptions.isExcluding && pageState === \'ready\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}} {{formOptions.context.Surname}} will be removed from your team but will still be an admin for {{formOptions.company.Name}}. If you need to add {{formOptions.context.Gender | personalise:\'him\'}} to payroll later you can do so from from your <a ui-sref="settings.company.admins({agencyProfileId: formOptions.company.AgencyProfileID})">Admins page</a> in Company Settings.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-click="changeAdminState()">Save</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Add to payroll?" ng-if="!formOptions.isExcluding && pageState === \'ready\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}} will be added to your team and you will need to complete all of {{formOptions.context.Gender | personalise:\'his\'}} profile information so {{formOptions.context.Gender | personalise:\'he\'}}\'s ready for payroll.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-click="changeAdminState()">Save</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Removed from team" ng-if="formOptions.isExcluding && pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}} {{formOptions.context.Surname}} has been removed from your team.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Added to team" ng-if="!formOptions.isExcluding && pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}} {{formOptions.context.Surname}} has been added to your team.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/clone-payroll/clone-payroll.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="clonePayrollForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.clonePayroll($ctrl, clonePayrollForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to clone this payroll?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis will make a copy of the payroll and save it to your Clones area. Some functionality will be disabled for the clone including:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\'Data submitted to or received from any third party including RTI, DPS, direct pension providers, CIS submissions, and CIS verification\',\n\t\t\t\t\t\t\'All system emails including invitations to register and workflow notifications\',\n\t\t\t\t\t\t\'Any changes to roles or permissions\',\n\t\t\t\t\t\t\'NI Numbers and email addresses for team members and admins\',\n\t\t\t\t\t\t\'Managing company groups\',\n\t\t\t\t\t\t\'Employee portal\',\n\t\t\t\t\t\t\'Autorun and auto sending of payroll reports\'\n\t\t\t\t\t]" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t\t</div>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that this won\'t have any effect on the original payroll which will remain in its current state and can be processed as normal. Click &lsquo;Confirm&rsquo; if you&apos;re\n\t\t\t\t\thappy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!clonePayrollForm.$valid" display-text="\'Confirm\'" state="clonePayrollForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Cloning -->\n<section class="form-summary fadeIn" ng-if="$ctrl.componentState === \'cloning\'">\n\t<section class="form-summary-section align-center">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section">\n\t\t<article class="align-center">\n\t\t\t<h5>Cloning payroll</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tYour payroll is currently being copied and will appear in your Clones area when it\u2019s finished. This can take up to around two minutes and you\u2019re safe to close this window while it\u2019s\n\t\t\t\thappening.\n\t\t\t</p>\n\t\t</article>\n\t</section>\n</section>\n\n<!-- Successfully cloned -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Payroll successfully cloned" ng-if="$ctrl.componentState === \'clone-success\'">\n\t<fs-main>\n\t\t<section class="form-summary-section">\n\t\t\t<p class="is-small">\n\t\t\t\tYour payroll has been cloned and will be available in your Clones area.\n\t\t\t</p>\n\t\t</section>\n\t\t<section class="form-summary-section">\n\t\t\t<p class="is-small">\n\t\t\t\t<a href="" ui-sref="companies-cloned({agencyProfileId: $root.currentCompany.AgencyProfileID})" class="is-strong">Go there now <i class="icon-chevron-right"></i></a>\n\t\t\t</p>\n\t\t</section>\n\t</fs-main>\n</form-state>\n\n<!-- Confirm Overwrite -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to overwrite the existing clone?" ng-if="$ctrl.componentState === \'confirm-overwrite\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tA new copy of this payroll will be made and will overwrite the existing clone. Click &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" ng-click="$ctrl.formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t<a href="" ng-click="$ctrl.clonePayroll($ctrl)" class="button is-tertiary primary-action">Confirm</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Delete Clone -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this clone?" ng-if="$ctrl.componentState === \'confirm-delete\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tOnce deleted this can\u2019t be undone and you\u2019ll need to make a new clone for this payroll. Click &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" ng-click="$ctrl.formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t<a href="" ng-click="$ctrl.deleteClone($ctrl)" class="button is-tertiary primary-action">Confirm</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Deleting -->\n<section class="form-summary fadeIn" ng-if="$ctrl.componentState === \'deleting\'">\n\t<section class="form-summary-section align-center">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section">\n\t\t<article class="align-center">\n\t\t\t<h5>Deleting clone</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tYour payroll is currently being deleted and will be removed from your Clones area when it\u2019s finished.\n\t\t\t</p>\n\t\t</article>\n\t</section>\n</section>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/delete-team-member/delete-team-member.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Individual -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you want to delete this team member?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tDeleting this team member will remove all of their information and this cannot be undone. If you wish to add them to your team again you can do so from your team page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="tertiary primary-action" ng-click="deleteTeamMember(userId)" type="button">\n\t\t\tDelete team member\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Bulk -->\n<form class="fadeIn" name="bulkDeleteForm" ng-if="pageState === \'ready-bulk\'" ng-submit="deleteTeamMembers(formOptions.userIds, bulkDeleteForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYou have chosen to delete&nbsp;\n\t\t\t\t<strong>\n\t\t\t\t\t<ng-pluralize count="formOptions.userIds.length" when="{\n\t\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</strong>\n\t\t\t</p>\n\t\t\t<p class="is-small">\n\t\t\t\tThis will remove all of their information and this cannot be undone. If you wish to add them to your team again you can do so from your team page.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button disable-button="!bulkDeleteForm.$valid" display-text="\'Delete\'" state="bulkDeleteForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n\n<!-- Deleting -->\n<div class="fadeIn" ng-if="pageState === \'deleting\'">\n\t<loading-block>\n\t\t<lb-description>\n\t\t\t<h6>\n\t\t\t\tCurrently deleting&nbsp;\n\t\t\t\t<ng-pluralize count="formOptions.userIds.length" when="{\n\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t}"></ng-pluralize>\n\t\t\t</h6>\n\t\t</lb-description>\n\t</loading-block>\n</div>\n\n<!-- Deleted (single)-->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Team member deleted" ng-if="pageState === \'deleted\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe team member has been deleted. If you wish to add them to your team again you can do so from your team page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Deleted (bulk) -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Team members have been deleted" ng-if="pageState === \'deleted-bulk\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThose team members have been deleted. If you wish to add them to your team again you can do so from your team page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Deletion error -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This team member can\'t be deleted" ng-if="pageState === \'delete-error\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease note that team members with payment history cannot be deleted.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Deletion error due to draft payslips -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This team member can\'t be deleted" ng-if="pageState === \'delete-error-draft-payslips\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou cannot delete this team member or change their status because they have a draft payslip pending.\n\t\t\tPlease recall draft payslips from Smart View first, then return here to make employee changes.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Not in setup mode -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to delete this team member" ng-if="pageState === \'not-in-setup-mode\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tTeam members can only be deleted before they have been paid for the first time. If a team member is leaving, you\'ll need to mark them as a leaver in their profile and this will take\n\t\t\teffect when the next payroll is run.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Logged in user -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You can\'t delete yourself" ng-if="pageState === \'logged-in-user\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease contact support if you need any help.\n\t\t</p>\n\t\t<p>\n\t\t\t<a href="" ng-click="formOptions.closeForm()" class="link-with-icon">\n\t\t\t\tOk, close this window\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/deleteAdjustmentGroup/deleteAdjustmentGroupForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Confirmation -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this pack?" ng-if="pageState === \'confirmation\'">\n\t<fs-preheader>\n\t\t<info-block ib-icon-dot="icon-adjustment" ib-theme="primary has-border has-large-title" ib-title="{{adjustmentGroup.AgencyAdjustmentGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="primary-light is-small"><ng-pluralize count="adjustmentGroup.NumberOfElementsVisible" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize></span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="is-small">Deleting this pay element pack cannot be undone and it will no longer be available to assign to companies. Click \u2018confirm\u2019 if you\u2019re happy to continue.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<button class="primary-action tertiary" ng-class="{\'success\': adjustmentGroup.state === \'saved\'}" ng-click="deleteAdjustmentGroup(adjustmentGroup)">\n\t\t\t<span ng-show="adjustmentGroup.state !== \'saving\' && adjustmentGroup.state !== \'saved\'">Confirm</span>\n\t\t\t<span ng-show="adjustmentGroup.state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t\t<span ng-show="adjustmentGroup.state === \'saved\'"><i class="icon-tick"></i></span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- In Use -->\n<form-state form-options="formOptions" fs-theme="tertiary" fs-icon="warning" fs-title="This pack is in use" ng-if="pageState === \'adjustment-group-in-use\'">\\\n\t<fs-preheader>\n\t\t<info-block ib-icon-dot="icon-adjustment" ib-theme="primary has-border has-large-title" ib-title="{{adjustmentGroup.AgencyAdjustmentGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="primary-light is-small"><ng-pluralize count="adjustmentGroup.NumberOfElementsVisible" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize></span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThis pay element pack is currently being used by <ng-pluralize count="adjustmentGroup.CompaniesUsedBy" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize>. Before it can be deleted, please unassign it from all companies using the \'Manage pay elements\' link in the action menu for each company in your Companies page.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Is default -->\n<form-state form-options="formOptions" fs-theme="tertiary" fs-icon="warning" fs-title="This pack can\u2019t be deleted" ng-if="pageState === \'adjustment-group-is-default\'">\n\t<fs-preheader>\n\t\t<info-block ib-icon-dot="icon-adjustment" ib-theme="primary has-border has-large-title" ib-title="{{adjustmentGroup.AgencyAdjustmentGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="primary-light is-small"><ng-pluralize count="adjustmentGroup.NumberOfElementsVisible" when="{\'1\': \'1 pay element\', \'other\': \'{} pay elements\'}"></ng-pluralize></span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThis pay element pack can\u2019t be deleted as it\u2019s currently set as the default. Set a different pack as the default by clicking \u2018Set as default pack\u2019 in the action menu for the pack. You\u2019ll then be able to delete this pack if it\u2019s not currently in use by any of your companies.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/deleteBureau/deleteBureauForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Delete {{formOptions.company.Name}}?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">Deleting {{formOptions.company.Name}} cannot be undone.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-click="deleteBureau(formOptions.company)" ng-disabled="formOptions.company.state === \'saving\'">\n\t\t\t<span ng-if="!formOptions.company.state">Delete bureau</span>\n\t\t\t<span ng-if="formOptions.company.state"><i class="icon-loading spin"></i></span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Cannot delete -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to delete {{formOptions.company.Name}}?" ng-if="pageState === \'cannot-delete\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.company.Name}} cannot be deleted. You can only delete a bureau where no companies have been allocated to it.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="{{formOptions.company.Name}} has been deleted" ng-if="pageState === \'success\'"></form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/deleteCompanyGroup/deleteCompanyGroupForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteCompanyGroupForm" ng-submit="deleteCompanyGroup(vm, deleteCompanyGroupForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Are you sure you want to delete this group?">\n\t\t<fs-main ng-if="formOptions.company.CompanyCount === 0">\n\t\t\t<p class="s">Once you click \u2018Delete\u2019 this group will be removed from your Company groups page.</p>\n\t\t</fs-main>\n\t\t<fs-main ng-if="formOptions.company.CompanyCount > 0">\n\t\t\t<p class="s">\n\t\t\t\tThere&nbsp;<ng-pluralize count="formOptions.company.CompanyCount" when="{\'1\': \'is 1 company\', \'other\': \'are {} companies\'}"></ng-pluralize>&nbsp;currently in this group.\n\t\t\t\t<span ng-if="vm.companyGroups.length === 0">Once deleted these companies will remain ungrouped and will be listed in your Companies page.</span>\n\t\t\t\t<span ng-if="vm.companyGroups.length > 0">Once deleted, these companies can either remain ungrouped, and simply be listed in your Companies page, or you can add them all to another group now.</span>\n\t\t\t\tClick &lsquo;Delete&rsquo; once you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset ng-if="formOptions.company.CompanyCount > 0 && vm.companyGroups.length > 0">\n\n\t\t<!-- Radio Cards -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="ungrouped" class="required">What do you want to do with these companies?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\n\t\t\t\t\t<input type="radio" name="companyOption" id="ungrouped" class="b" ng-value="false" ng-model="vm.moveCompaniesToADifferentGroup" required>\n\t\t\t\t\t<label class="radio-card-label" for="ungrouped">Leave them ungrouped</label>\n\n\t\t\t\t\t<input type="radio" name="companyOption" id="newgroup" class="b" ng-value="true" ng-model="vm.moveCompaniesToADifferentGroup" required>\n\t\t\t\t\t<label class="radio-card-label" for="newgroup">Add them to another group</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Select company group  -->\n\t\t<div class="form-field fadeIn" ng-if="vm.moveCompaniesToADifferentGroup">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="companyGroup" class="required">Select a company group:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="block" name="companyGroup" id="companyGroup" ng-model="vm.newAgencyProfileParentId" ng-options="companyGroup.Company.AgencyProfileID as companyGroup.Company.Name for companyGroup in vm.companyGroups" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="deleteCompanyGroupForm.companyGroup.$error" ng-if="deleteCompanyGroupForm.companyGroup.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a company group</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<!-- Note -->\n \t\t<div class="form-field">\n\t\t\t<note note-title="Group admins" note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-dismiss-key="delete-group-admin-access">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">Please note that any users who were invited with either the &lsquo;Group admin&lsquo; or &lsquo;Group admin lite&lsquo; role will have their admin access to this group revoked.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Delete\'" state="deleteCompanyGroupForm.state" disable-button="!deleteCompanyGroupForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Group deleted" ng-if="pageState === \'success\'">\n\t<fs-main ng-if="::formOptions.company.CompanyCount === 0">\n\t\t<p class="s">This group has been deleted.</p>\n\t</fs-main>\n\t<fs-main ng-if="::formOptions.company.CompanyCount > 0">\n\t\t<p class="s" ng-if="!vm.moveCompaniesToADifferentGroup">This group has been deleted, the companies have been ungrouped and they can be found in your Companies page should you wish to add them to other groups.</p>\n\t\t<p class="s" ng-if="vm.moveCompaniesToADifferentGroup">This group has been deleted, the companies have been ungrouped and they can be found in your Companies page should you wish to add them to other groups.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/deletePayElement/deletePayElementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this pay element?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">&lsquo;{{payElement.AgencyAdjustmentGroupEntryText}}&rsquo; will no longer be available to use when you add changes to your clients\' payroll and you will need to recreate it if you decide you need to use it again.</p>\n\t\t<p class="s"><strong>Please note:</strong> all previous changes that have used this pay element will not be affected and will still appear correctly on payslips and in payroll history.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<button class="tertiary primary-action" ng-click="deletePayElement(payElement, payElement)" ng-disabled="payElement.state === \'saving\'" data-cy="delete-pay-element-form-delete-button--{{::payElementType.AgencyAdjustmentGroupEntryText | slugify}}">Delete</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/duplicatePayElement/duplicatePayElementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="duplicatePayElementForm" ng-if="pageState === \'ready\'" ng-submit="updateAgencyAdjustmentGroupEntry(payElement, duplicatePayElementForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<div class="message-bar inline align-left {{::formOptions.payElementObj.IsDeduction ? \'assertive\' : \'positive\'}}">\n\t\t\t<p>\n\t\t\t\t<i class="icon-{{::formOptions.payElementObj.IsDeduction ? \'minus\' : \'add\'}} m {{::formOptions.payElementObj.IsDeduction ? \'assertive\' : \'positive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\tYou are duplicating the <span class="strong {{::formOptions.payElementObj.IsDeduction ? \'assertive\' : \'positive\'}}">{{formOptions.payElementObj.originalName}}</span>\n\t\t\t\t{{formOptions.payElementObj.payElementDescription | lowercase}}&nbsp;pay element\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<fieldset>\n\t\t<legend hidden>Pay Element</legend>\n\t\t<!-- Pay Element Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="payElementName" class="required">Name</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input data-cy="duplicate-pay-element-form-pay-element-name-input" id="payElementName" name="payElementName" ng-model="payElement.AgencyAdjustmentGroupEntryText" ng-pattern="$root.REGEX.description" placeholder="Type here..." required type="text">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="duplicatePayElementForm.payElementName.$error" ng-if="duplicatePayElementForm.payElementName.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter basic characters only</p>\n\t\t\t\t<p ng-message="required">Please enter a name for the new pay element</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<legend hidden>Pensionable</legend>\n\t\t<div class="settings-rows">\n\n\t\t\t<!-- Pensionable -->\n\t\t\t<settings-row ng-if="::company.IsPensionActive" ng-model="payElement.AgencyAdjustmentGroupEntryPensionState" on-update="reviewPayElementPension(payElement)" sr-disabled="::isPayElementPensionableReadOnly" sr-field-name="agencyAdjustmentGroupEntryPensionState" sr-icon="money" sr-theme="quarternary" data-cy="duplicate-pay-element-form-settings-row-pensionable">\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-pensionable">Pensionable</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-pensionable">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntryPensionBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-pensionable-on-locked">\n\t\t\t\t\t\t\tThis pay element is included in pay when calculating pension contributions. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-pensionable-off-locked">\n\t\t\t\t\t\t\tThis pay element is not included in pay when calculating pension contributions. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-pensionable-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\u2019t want this pay element to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-pensionable-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-content ng-if="\n\t\t\t\t\t\tpayElement.IsSalarySacrifice &&\n\t\t\t\t\t\tpayElement.AgencyAdjustmentGroupEntryPensionState\n\t\t\t\t\t" data-cy="duplicate-pay-element-form-content-pension-salary-sacrifice">\n\n\t\t\t \t\t<!-- Pension Salary Sacrifice Behaviour -->\n\t\t\t \t\t<div class="form-field" data-cy="duplicate-pay-element-form-form-field-pension-salary-sacrifice">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label ng-class="{ \'is-greyscale\': isPayElementPensionableReadOnly }" for="paymentScheduleTypePensionBehaviourBoth">Include when calculating contributions for:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline is-quarternary">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" data-cy="duplicate-pay-element-form-radio-both" id="paymentScheduleTypePensionBehaviourBoth" name="paymentScheduleTypePensionBehaviour" ng-disabled="::isPayElementPensionableReadOnly" ng-model="payElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.both" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Both</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" data-cy="duplicate-pay-element-form-radio-employee" id="paymentScheduleTypePensionBehaviourEmployee" name="paymentScheduleTypePensionBehaviour" ng-disabled="::isPayElementPensionableReadOnly" ng-model="payElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployee" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employee only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" data-cy="duplicate-pay-element-form-radio-employer" id="paymentScheduleTypePensionBehaviourEmployer" name="paymentScheduleTypePensionBehaviour" ng-disabled="::isPayElementPensionableReadOnly" ng-model="payElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployer" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employer only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Net pay -->\n\t\t\t<settings-row data-cy="duplicate-pay-element-form-settings-row-net-pay" ng-model="payElement.AgencyAdjustmentGroupEntryNetPayState" on-update="reviewPayElementNetPay(payElement)" sr-disabled="isPayElementNetPayReadOnly(payElement)" sr-field-name="agencyAdjustmentGroupEntryNetPayState" sr-icon="wallet" sr-theme="quarternary">\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-net-pay">Net Pay calculations</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-net-pay">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntryNetPayBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-net-pay-on-locked">\n\t\t\t\t\t\t\tThis pay element will be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-net-pay-off-locked">\n\t\t\t\t\t\t\tThis pay element will not be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-net-pay-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don&apos;t want this pay element to be included in pay calculations for team members set to &lsquo;Net Pay&rsquo; for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-net-pay-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be included in pay calculations for team members set to &lsquo;Net Pay&rsquo; for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Salary sacrifice calculations -->\n\t\t\t<settings-row data-cy="duplicate-pay-element-form-settings-row-salary-sacrifice" ng-model="payElement.AgencyAdjustmentGroupEntrySalarySacrificeState" ng-if="payElement.SalarySacrificeState !== ADJUSTMENT_DETAIL_STATES.hidden" on-update="reviewPayElementSalarySacrifice(payElement)" sr-disabled="isPayElementSalarySacrificeReadOnly(payElement)" sr-field-name="agencyAdjustmentGroupEntrySalarySacrificeState" sr-icon="salary-change" sr-theme="quarternary">\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-salary-sacrifice">Salary sacrifice calculations</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-salary-sacrifice">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntrySalarySacrificeBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-salary-sacrifice-on-locked">\n\t\t\t\t\t\t\tThis pay element will be included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-salary-sacrifice-off-locked">\n\t\t\t\t\t\t\tThis pay element will not be included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-salary-sacrifice-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you do not wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-salary-sacrifice-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Payroll BIK -->\n\t\t\t<settings-row data-cy="duplicate-pay-element-form-settings-row-payroll-bik" ng-model="payElement.AgencyAdjustmentGroupEntryPayrollBIKState" on-update="reviewPayElementPayrollBIK(payElement)" sr-disabled="isPayElementPayrollBIKReadOnly(payElement)" sr-field-name="agencyAdjustmentGroupEntryPayrollBIKState" sr-icon="clock" sr-theme="quarternary">\n\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-payroll-bik">Payroll benefit</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-payroll-bik">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntryPayrollBIKBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-payroll-bik-on-locked">\n\t\t\t\t\t\t\tThis benefit in kind pay element will not be payrolled. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-payroll-bik-off-locked">\n\t\t\t\t\t\t\tThis benefit in kind pay element will not be payrolled. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-payroll-bik-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you do not want to payroll this benefit each time you run payroll for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-payroll-bik-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want to payroll this benefit each time you run payroll for {{formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Holiday Pay -->\n\t\t\t<settings-row data-cy="duplicate-pay-element-form-settings-row-holiday-payable" ng-model="payElement.AgencyAdjustmentGroupEntryHolidayState" on-update="reviewPayElementHoliday(payElement)" sr-disabled="isPayElementHolidayReadOnly(payElement)" sr-field-name="AgencyAdjustmentGroupEntryHolidayState" sr-icon="holiday" sr-theme="quarternary">\n\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-holiday-payable">Holiday Pay</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-holiday-payable">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntryHolidayBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-holiday-payable-on-locked">\n\t\t\t\t\t\t\tThis pay element will always be included in rolled up holiday pay calculations. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-holiday-payable-off-locked">\n\t\t\t\t\t\t\tThis pay element cannot be included in rolled up holiday pay calculations. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-holiday-payable-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t wish to include these payments in rolled up holiday pay calculations.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-holiday-payable-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you wish to include these payments in rolled up holiday pay calculations.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Prorate -->\n\t\t\t<settings-row data-cy="duplicate-pay-element-form-settings-row-prorate" ng-model="payElement.AgencyAdjustmentGroupEntryProrateState" on-update="reviewPayElementProrate(payElement)" sr-disabled="isPayElementProrateReadOnly(payElement)" sr-field-name="AgencyAdjustmentGroupEntryProrateState" sr-icon="calendar" sr-theme="quarternary">\n\t\t\t\t<sr-label data-cy="duplicate-pay-element-form-label-prorate">Prorate</sr-label>\n\t\t\t\t<sr-description data-cy="duplicate-pay-element-form-description-prorate">\n\t\t\t\t\t<span ng-switch="payElement.AgencyAdjustmentGroupEntryProrateBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked" data-cy="duplicate-pay-element-form-prorate-on-locked">\n\t\t\t\t\t\t\tThis pay element will always be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked" data-cy="duplicate-pay-element-form-prorate-off-locked">\n\t\t\t\t\t\t\tThis pay element cannot be prorated. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on" data-cy="duplicate-pay-element-form-prorate-on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t want this pay element to be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off" data-cy="duplicate-pay-element-form-prorate-off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<div class="form-content-block" ng-if="$root.currentCompany.CompanyType === INTERFACE_TYPES.bureau && payElement.PensionState !== ADJUSTMENT_DETAIL_STATES.hidden && !isPayElementReadOnly(payElement)">\n\t\t<div class="spec-list">\n\n\t\t\t<!-- Pensionable -->\n\t\t\t<div class="spec-list-item indifferent">\n\t\t\t\t<span class="spec-list-item-icon"><i class="icon-money"></i></span>\n\t\t\t\t<p class="spec-list-item-name">Workplace pension calculations</p>\n\t\t\t\t<p class="spec-list-item-description">This pay element can be included or excluded from pension calculations on a per company basis.</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Alternative currency -->\n\t<fieldset ng-if="currencies && currencies.length > 0">\n\t\t<legend hidden>Alternative currency</legend>\n\t\t<div class="form-field">\n\t\t\t<extended-toggle-input field-label="Use an alternative default currency" field-model="payElement.isPayElementUsingAlternativeCurrency" field-name="payElement.isPayElementUsingAlternativeCurrency" field-theme-light="true">\n\t\t\t\t<field-description>Toggle on to use an alternative default currency whenever this pay element is used. It can be overridden when the change is added to payroll.</field-description>\n\t\t\t\t<field-content>\n\n\t\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="currencyId" class="required">Select currency:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t<select class="l" id="currencyId" name="currencyId" ng-model="payElement.CurrencyID" ng-options="currency.CurrencyID as currency.CurrencyLabel for currency in currencies" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="duplicatePayElementForm.currencyId.$error" ng-if="duplicatePayElementForm.currencyId.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</field-content>\n\t\t\t</extended-toggle-input>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<legend hidden>Pay element notes</legend>\n\t\t<note note-title="Allocating new pay elements to journal codes" note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-dismiss-key="duplicate-element-nominal-codes">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">To use a new pay element in journals, you will need to allocate it to a nominal code in the journal settings area where you wish to use it.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t\t<note ng-if="isAverageHolidayPayEnabled" note-title="52-week average holiday pay settings" note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-dismiss-key="duplicate-element-52-week-average-holiday-pay">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Settings for the 52-week average holiday pay calculation are inherited from the original pay element. To amend them, use the Average Holiday Pay configuration in the Reports &amp; Journals settings area.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="duplicatePayElementForm.state" disable-button="!duplicatePayElementForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-accounting-integration/edit-accounting-integration.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="editAccountingIntegrationForm" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate ng-submit="$ctrl.openConnectionForm()">\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Select accounting software:</label>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="accounting-integration-type-cards">\n\t\t\t\t\t<div class="accounting-integration-type-card-radio" ng-repeat="accountIntegrationType in $ctrl.accountIntegrationTypes">\n\t\t\t\t\t\t<input class="accounting-integration-type-card-radio-input" id="accountIntegrationType-{{$index}}" name="accountIntegrationType" ng-class="{\'is-faded\': editAccountingIntegrationForm.accountIntegrationType.$valid}" ng-model="$ctrl.selectedIntegration" ng-required="true" ng-value="accountIntegrationType.AccountingIntegrationType" type="radio">\n\t\t\t\t\t\t<label class="accounting-integration-type-card-radio-label" for="accountIntegrationType-{{$index}}">\n\t\t\t\t\t\t\t<img alt="{{accountIntegrationType.AccountingIntegrationName}}" class="accounting-integration-type-card-logo-{{accountIntegrationType.AccountingIntegrationName | slugify}}" ng-src="{{accountIntegrationType.AccountingIntegrationImageUrl}}">\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<submit-button display-text="\'Next\'" disable-button="editAccountingIntegrationForm.$invalid" state="editAccountingIntegrationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-bureau-bun/edit-bureau-bun.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="editBureauBunForm" ng-submit="$ctrl.updateAgencyEmployerBUN($ctrl, editBureauBunForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Enter your Bureau User Number (BUN) so it\u2019s included in BACS file formats that use it. Otherwise, the respective SUN will be used.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- BUN -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="agencyEmployerBun">BUN:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="agencyEmployerBun" class="l" name="agencyEmployerBun" ng-model="$ctrl.agencyEmployerBun" ng-pattern="$root.REGEX.bacsBun" placeholder="Enter number.." type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="editBureauBunForm.agencyEmployerBun.$error" ng-if="editBureauBunForm.agencyEmployerBun.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid BUN</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="editBureauBunForm.state" disable-button="!editBureauBunForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-edp-integration/edit-edp-integration.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" data-cy="edit-edp-integration-form" name="editEdpIntegrationForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.submitEditEdpIntegrationForm($ctrl, editEdpIntegrationForm)" novalidate>\n\t<fieldset>\n\t\t<p class="is-small">\n\t\t\tControl the Event-Driven Processing integration for this company. When connected, incoming events are processed based on the topic settings below.\n\t\t</p>\n\t</fieldset>\n\n\t<!-- Connection toggle -->\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\t\t\t\t<settings-row data-cy="edp-integration-toggle" ng-model="$ctrl.formOptions.integrationData.isEdpIntegrationEnabled" sr-field-name="isEdpIntegrationEnabled" sr-icon="connection" sr-label="EDP Integration">\n\t\t\t\t\t<sr-description ng-if="$ctrl.formOptions.integrationData.isEdpIntegrationEnabled">\n\t\t\t\t\t\tTurning this off will stop all event processing for this company. Topic preferences will be preserved.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="!$ctrl.formOptions.integrationData.isEdpIntegrationEnabled">\n\t\t\t\t\t\tTurning this on will enable event processing. All topics will be enabled by default on first connection.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Topic toggles (only visible when connected) -->\n\t<fieldset ng-if="$ctrl.formOptions.integrationData.isEdpIntegrationEnabled && $ctrl.topics.length > 0">\n\t\t<h4>Event topics</h4>\n\t</fieldset>\n\n\t<fieldset ng-if="$ctrl.formOptions.integrationData.isEdpIntegrationEnabled && $ctrl.topics.length > 0">\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\t\t\t\t<settings-row data-cy="edp-topic-toggle-{{topic.EdpIntegrationTopicKey}}" ng-model="topic.EdpIntegrationTopicIsEnabled" ng-repeat="topic in $ctrl.topics track by topic.EdpIntegrationTopicKey" sr-field-name="{{topic.EdpIntegrationTopicKey}}" sr-icon="connection" sr-label="{{topic.DisplayName}}">\n\t\t\t\t\t<sr-description ng-if="topic.EdpIntegrationTopicIsEnabled">\n\t\t\t\t\t\tEvents for {{topic.DisplayName}} are being processed.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="!topic.EdpIntegrationTopicIsEnabled">\n\t\t\t\t\t\tEvents for {{topic.DisplayName}} will be skipped.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="$ctrl.formOptions.integrationData.isEdpIntegrationEnabled && $ctrl.topics.length === 0">\n\t\t<p class="is-small is-tertiary">\n\t\t\tNo event topics are configured for this company. Topics will be available once the EDP integration has received its first event.\n\t\t</p>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="edp-integration-cancel-btn" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<submit-button data-cy="edp-integration-save-btn" disable-button="!$ctrl.hasChanges()" display-text="\'Save\'" state="editEdpIntegrationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block data-cy="edp-integration-error-block" ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-pay-experian-integration/edit-pay-experian-integration.form.html','<form name="editPayExperianIntegrationForm" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate ng-submit="$ctrl.submitEditPayExperianIntegrationForm($ctrl, editPayExperianIntegrationForm)">\n\n\t<fieldset>\n\t\t<p class="is-small">\n\t\t\tDigital Employment Verification enables employees to securely, and only at their discretion, share required payslip data to expedite application processes.\n\t\t\tThis will help them secure exciting, life-changing services or purchases, and remove the admin burden on you and your team of having to provide physical documents to them.\n\t\t</p>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<h4>How is employee data shared?</h4>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<bullet-list bl-theme="is-small is-primary">\n\t\t\t<bl-items>\n\t\t\t\t<li class="bullet-list_item">\n\t\t\t\t\tData is only accessed with the explicit consent of the employee\n\t\t\t\t</li>\n\t\t\t\t<li class="bullet-list_item">\n\t\t\t\t\tData is only shared with the specified businesses (e.g., mortgage lender) as agreed by the employee and only for the specific use case they consent for\n\t\t\t\t</li>\n\t\t\t\t<li class="bullet-list_item">\n\t\t\t\t\tVerification requests only the bare minimum data required\n\t\t\t\t</li>\n\t\t\t\t<li class="bullet-list_item">\n\t\t\t\t\tData is encrypted and transferred securely\n\t\t\t\t</li>\n\t\t\t</bl-items>\n\t\t</bullet-list>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\t\t\t\t<settings-row ng-model="$ctrl.formOptions.integrationData.isPayExperianIntegrationEnabled" sr-field-name="isPayExperianIntegrationEnabled" sr-icon="fixed-value" sr-label="Digital Employment Verification">\n\t\t\t\t\t<sr-description ng-if="$ctrl.formOptions.integrationData.isPayExperianIntegrationEnabled">\n\t\t\t\t\t\tTurning this off means that employees won\'t be able to securely share required payslip data to expedite application processes.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="!$ctrl.formOptions.integrationData.isPayExperianIntegrationEnabled">\n\t\t\t\t\t\tTurning this on means that employees will be able to securely share required payslip data to expedite application processes.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<submit-button disable-button="$ctrl.isPayExperianIntegrationEnabledOnLoad === $ctrl.formOptions.integrationData.isPayExperianIntegrationEnabled" display-text="\'Save\'" state="editPayExperianIntegrationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-people-hr-integration/edit-people-hr-integration.form.html','<form name="editPeopleHrIntegrationForm" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate ng-submit="$ctrl.submitEditPeopleHrIntegrationForm($ctrl, editPeopleHrIntegrationForm)">\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\t\t\t\t<settings-row ng-model="$ctrl.formOptions.integrationData.isPeopleHRIntegrationEnabled" sr-field-name="isPeopleHRIntegrationEnabled" sr-icon="team" sr-label="PeopleHR Integration">\n\t\t\t\t\t<sr-description ng-if="!$ctrl.formOptions.integrationData.isPeopleHRIntegrationEnabled">\n\t\t\t\t\t\tTurning this on means you\'ll be able to receive and review team and payroll updates if you\'re an existing user of PeopleHR.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="$ctrl.formOptions.integrationData.isPeopleHRIntegrationEnabled">\n\t\t\t\t\t\tTurning this off means you won\'t be able to receive and review team and payroll updates if you\'re an existing user of PeopleHR.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<submit-button disable-button="$ctrl.isPeopleHRIntegrationEnabledOnLoad === $ctrl.formOptions.integrationData.isPeopleHRIntegrationEnabled" display-text="\'Save\'" state="editPeopleHrIntegrationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-rotaready-entity-mapping/edit-rotaready-entity-mapping.form.html','<!-- Loading -->\n<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.loading"></loading-block>\n\n<form class="fadeIn" name="editRotareadyEntityMappingForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.ready" novalidate>\n\n\t<!-- Intro -->\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tRotaready entities must be mapped to business categories in Paycircle. This is so updates\n\t\t\tsent from Rotaready to Paycircle get applied to the correct business category.\n\t\t</p>\n\t</div>\n\n\t<!-- Tabs -->\n\t<nav class="tabs">\n\t\t<a data-cy="entity-mapping-tab-unmapped" href="" ng-class="{\n\t\t\t\t\'active\': $ctrl.activeTab === $ctrl.TAB.unmapped\n\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl.TAB.unmapped)">\n\t\t\tUnmapped ({{$ctrl.entitiesUnmapped.length}})\n\t\t</a>\n\t\t<a data-cy="entity-mapping-tab-mapped" href="" ng-class="{\n\t\t\t\t\'active\': $ctrl.activeTab === $ctrl.TAB.mapped\n\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl.TAB.mapped)">\n\t\t\tMapped ({{$ctrl.entitiesMapped.length}})\n\t\t</a>\n\t</nav>\n\n\t<!-- Unmapped -->\n\t<div class="rotaready-team-mapping-cards fadeIn" ng-if="$ctrl.activeTab === $ctrl.TAB.unmapped">\n\t\t<div class="rotaready-team-mapping-card" data-cy="entity-mapping-unmapped-card-{{$index}}" ng-class="{\'is-matched\': false}" ng-repeat="entity in $ctrl.entitiesUnmapped">\n\n\t\t\t<div class="rotaready-team-mapping-card_source">\n\t\t\t\t<div class="rotaready-team-mapping-card_source_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{entity.EntityName}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="entity-mapping-unmapped-start-date-{{$index}}" ng-if="entity.PayrollCalendarStartDateISO">Start Date: {{entity.PayrollCalendarStartDateISO | dateformat}}</p>\n\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="entity-mapping-unmapped-group-{{$index}}" ng-if="entity.EntityGroupName">Group: {{entity.EntityGroupName}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<span class="tag is-assertive">\n\t\t\t\t\t\tUnmapped\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-team-mapping-card_target" ng-class="{\'is-matched\': false}">\n\t\t\t\t<div class="rotaready-team-mapping-card_target_middle">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<select class="rotaready-team-mapping-card_target_middle_top" data-cy="entity-mapping-select-{{$index}}" id="entityMapping-{{$index}}" name="entityMapping-{{$index}}" ng-change="$ctrl.mapEntity(entity)" ng-model="entity.selectedBusinessCodeID" ng-options="code.BusinessCodeID as code.BusinessCodeNarrative group by $ctrl.getCategoryTypeDescription(code.BusinessCategoryType) for code in $ctrl.businessCodes | orderBy: \'BusinessCodeNarrative\'">\n\t\t\t\t\t\t\t<option value="">Please select</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No results -->\n\t\t<placeholder ng-if="$ctrl.entitiesUnmapped.length === 0" placeholder-graphic="no-companies" placeholder-graphic-size="l">\n\t\t\t<placeholder-title>No unmapped Rotaready entities</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>There are no unmapped Rotaready entities at the moment.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Mapped -->\n\t<div class="rotaready-team-mapping-cards fadeIn" ng-if="$ctrl.activeTab === $ctrl.TAB.mapped">\n\t\t<div class="rotaready-team-mapping-card" data-cy="entity-mapping-mapped-card-{{$index}}" ng-class="{\'is-matched\': true}" ng-repeat="entity in $ctrl.entitiesMapped">\n\t\t\t<div class="rotaready-team-mapping-card_source">\n\t\t\t\t<div class="rotaready-team-mapping-card_source_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{entity.EntityName}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="entity-mapping-mapped-start-date-{{$index}}" ng-if="entity.PayrollCalendarStartDateISO">Start Date: {{entity.PayrollCalendarStartDateISO | dateformat}}</p>\n\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="entity-mapping-mapped-group-{{$index}}" ng-if="entity.EntityGroupName">Group: {{entity.EntityGroupName}}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div>\n\t\t\t\t\t<span class="tag is-positive">Mapped</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-team-mapping-card_target" ng-class="{\'is-matched\': true}">\n\t\t\t\t<div class="rotaready-team-mapping-card_target_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{entity.businessCodeNarrative}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p ng-if="entity.businessCategoryTypeDescription">\n\t\t\t\t\t\t{{entity.businessCategoryTypeDescription}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="entity-mapping-mapped-nominal-code-{{$index}}" ng-if="entity.businessCodeValue">Journal Code: {{entity.businessCodeValue}}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_target_middle_button" data-cy="entity-mapping-unmatch-{{$index}}" ng-click="$ctrl.unmapEntity(entity)">Undo</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No results -->\n\t\t<placeholder ng-if="$ctrl.entitiesMapped.length === 0" placeholder-graphic="no-companies" placeholder-graphic-size="l">\n\t\t\t<placeholder-title>No mapped entities</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>There are no mapped entities. Check the &lsquo;Unmapped&rsquo; tab for entities that need mapping.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="entity-mapping-close" ng-click="$ctrl.closeForm()" type="button">Close</button>\n\t\t<button class="is-tertiary primary-action" data-cy="entity-mapping-save" ng-click="$ctrl.setPageState($ctrl.PAGE_STATE.confirm)" type="button">Save</button>\n\t</fieldset>\n</form>\n\n<!-- Confirm -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Save changes?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.confirm">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t{{$ctrl.getChangedMappingsCount()}} entity mapping{{$ctrl.getChangedMappingsCount() === 1 ? \'\' : \'s\'}} will be updated.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tClick &lsquo;Confirm&rsquo; if you\'re happy to save changes,\n\t\t\tor click &lsquo;Back&rsquo; to return to the previous page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" data-cy="entity-mapping-confirm-back" href="" ng-click="$ctrl.setPageState($ctrl.PAGE_STATE.ready)">Back</a>\n\t\t<button class="is-tertiary primary-action" data-cy="entity-mapping-confirm-save" ng-click="$ctrl.saveChanges()">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.error" secondary-action="$ctrl.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/edit-rotaready-integration/edit-rotaready-integration.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.loading"></loading-block>\n\n<!-- Credentials Input -->\n<form class="fadeIn" name="credentialsInputForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.credentialsInput" ng-submit="$ctrl.connect()" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tEnter the Access Rotaready API credentials for the site or sites you wish to give Paycircle access to.\n\t\t\tThese are provided upon request by Access Rotaready. When you\'re ready, click &lsquo;Connect&rsquo; to continue.\n\t\t</p>\n\t</div>\n\n\t<div class="form-field" ng-if="$ctrl.connectionFailed">\n\n\t\t<note note-icon="icon-warning" note-theme="assertive" note-title="Failed to Connect">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">Failed to connect using the API credentials you entered. Please try again</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="realmInput">Realm:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="realmInput" name="realmInput" ng-model="$ctrl.formObject.realmInput" ng-pattern="$root.REGEX.lettersAndNumbers" placeholder="Type here..." required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="credentialsInputForm.realmInput.$touched" ng-messages="credentialsInputForm.realmInput.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Only letters and numbers are allowed</p>\n\t\t\t\t<p ng-message="required">Please enter a realm</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="keyInput">Key:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="keyInput" name="keyInput" ng-model="$ctrl.formObject.keyInput" ng-pattern="$root.REGEX.lettersNumbersAndSymbols" placeholder="Type here..." required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="credentialsInputForm.keyInput.$touched" ng-messages="credentialsInputForm.keyInput.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Only letters, numbers, and the plus (+), minus (-) and ampersand (&) symbols are allowed</p>\n\t\t\t\t<p ng-message="required">Please enter a key</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="secretInput">Secret:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="secretInput" name="secretInput" ng-model="$ctrl.formObject.secretInput" ng-pattern="$root.REGEX.lettersNumbersAndSymbols" placeholder="Type here..." required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="credentialsInputForm.secretInput.$touched" ng-messages="credentialsInputForm.secretInput.$error" role="alert">\n\t\t\t<p ng-message="pattern">Only letters, numbers, and the plus (+), minus (-) and ampersand (&) symbols are allowed</p>\n\t\t\t<p ng-message="required">Please enter a secret</p>\n\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.closeForm()" type="button">Cancel</button>\n\t\t<submit-button disable-button="!credentialsInputForm.$valid" display-text="\'Connect\'"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Connecting -->\n<section class="form-summary fadeIn" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connecting">\n\t<section class="form-summary-section align-center">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<h3>Connecting to Rotaready</h3>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a moment. Please don\'t close this window or click the back button on your browser.</p>\n\t</section>\n</section>\n\n<!-- Select Entity -->\n<form class="fadeIn" name="entitySelectionForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.entitySelection && !$ctrl.isManagingLinkedSites" ng-submit="$ctrl.updateEntities()" novalidate>\n\t<div class="form-field">\n\t\t<message-block icon="tick" theme="is-alternative is-inline is-positive">\n\t\t\t<p>You\'re now connected to Rotaready</p>\n\t\t</message-block>\n\t</div>\n\n\t\t<div class="spacer s"></div>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tSelect at least 1 Rotaready site you wish to connect {{$ctrl.formOptions.company.Name}} to.\n\t\t\tOn the next step you\'ll be able to create business categories from your sites.\n\t\t\tClick &lsquo;Next&rsquo; to continue.\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<section class="form-field" ng-if="$ctrl.rotareadyEntities.length !== 0">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="checkbox-list-header">\n\t\t\t\t\t<h6 class="checkbox-list-header_title">{{$ctrl.getSelectedRotareadyEntities().length}} selected</h6>\n\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t<a href ng-click="$ctrl.toggleAllEntities(true)">\n\t\t\t\t\t\t\tSelect all\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href ng-click="$ctrl.toggleAllEntities(false)">\n\t\t\t\t\t\t\tUnselect all\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="spacer m"></div>\n\n\t\t\t<div class="checkbox-rows-list">\n\t\t\t\t<div class="checkbox-row" ng-repeat="entity in $ctrl.rotareadyEntities">\n\t\t\t\t\t<label class="checkbox-row_label" for="{{entity.EntityID}}_{{entity.PayrollCalendarID}}" ng-class="{\'is-disabled\': entity.isMappedToOtherCompany}">\n\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" id="{{entity.EntityID}}_{{entity.PayrollCalendarID}}" name="{{entity.EntityID}}_{{entity.PayrollCalendarID}}" ng-model="entity.isSelected" ng-disabled="entity.isMappedToOtherCompany" type="checkbox">\n\t\t\t\t\t\t<span class="tenant-card_label">{{entity.EntityName}}</span>\n\t\t\t\t\t\t<span class="form-note is-small greyscale-midtone checkbox-row_note" ng-if="entity.isMappedToOtherCompany">Mapped to {{entity.mappedCompanyName}}</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="tenant-cards_placeholder">\n\t\t\t<placeholder ng-if="$ctrl.rotareadyEntities.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-companies">\n\t\t\t\t<placeholder-title>No sites found</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>Check that you\'re using the correct Realm before disconnecting and trying again.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t</placeholder>\n\t\t</div>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.goBackToCredentialsInput()" type="button">Back</button>\n\t\t<submit-button disable-button="!$ctrl.getSelectedRotareadyEntities().length > 0" display-text="\'Next\'"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Manage Linked Sites -->\n<form class="fadeIn" name="linkedSitesForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.entitySelection && $ctrl.isManagingLinkedSites" ng-submit="$ctrl.moveToConfirmLinkedSites()" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tChoose which Rotaready sites/departments are linked to {{$ctrl.formOptions.company.Name}}, then click &lsquo;Save&rsquo;.\n\t\t</p>\n\t</div>\n\n\t<!-- Tabs -->\n\t<div class="form-section">\n\t\t<nav class="tabs">\n\t\t\t<a class="tabs-item has-counter" data-cy="linked-sites-tab-linked" href="" ng-class="{\n\t\t\t\t\t\'active\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.linked\n\t\t\t\t}" ng-click="$ctrl.setEntitySelectionTab($ctrl.ENTITY_SELECTION_TABS.linked)">\n\t\t\t\tLinked\n\t\t\t\t<span class="tabs-item-counter tag primary" data-cy="linked-sites-tab-linked-count" ng-class="{\n\t\t\t\t\t\t\'inverse\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.linked\n\t\t\t\t\t}">{{$ctrl.linkedRotareadyEntities.length | nineMax}}</span>\n\t\t\t</a>\n\t\t\t<a class="tabs-item has-counter" data-cy="linked-sites-tab-new" href="" ng-class="{\n\t\t\t\t\t\'active\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.newSites\n\t\t\t\t}" ng-click="$ctrl.setEntitySelectionTab($ctrl.ENTITY_SELECTION_TABS.newSites)">\n\t\t\t\tNot Linked\n\t\t\t\t<span class="tabs-item-counter tag" data-cy="linked-sites-tab-new-count" ng-class="{\n\t\t\t\t\t\t\'inverse\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.newSites,\n\t\t\t\t\t\t\'positive\': $ctrl.hasNewNotLinkedSites,\n\t\t\t\t\t\t\'primary\': !$ctrl.hasNewNotLinkedSites\n\t\t\t\t\t}">{{$ctrl.newRotareadyEntities.length | nineMax}}</span>\n\t\t\t</a>\n\t\t\t<a class="tabs-item has-counter" data-cy="linked-sites-tab-removed" href="" ng-class="{\n\t\t\t\t\t\'active\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.removed\n\t\t\t\t}" ng-click="$ctrl.setEntitySelectionTab($ctrl.ENTITY_SELECTION_TABS.removed)">\n\t\t\t\tRemoved\n\t\t\t\t<span class="tabs-item-counter tag" data-cy="linked-sites-tab-removed-count" ng-class="{\n\t\t\t\t\t\t\'assertive\': $ctrl.removedRotareadyEntities.length > 0,\n\t\t\t\t\t\t\'inverse\': $ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.removed,\n\t\t\t\t\t\t\'primary\': $ctrl.removedRotareadyEntities.length === 0\n\t\t\t\t\t}">{{$ctrl.removedRotareadyEntities.length | nineMax}}</span>\n\t\t\t</a>\n\t\t</nav>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<!-- Linked -->\n\t\t<section class="form-field" ng-if="$ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.linked">\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="s">Rotaready sites that are already linked to this Paycircle company.</p>\n\t\t\t</div>\n\t\t\t<search-bar count="$ctrl.getFilteredEntities($ctrl.linkedRotareadyEntities, $ctrl.linkedSitesSearchBarOptions).length" data-cy="linked-sites-search-bar" ng-if="$ctrl.linkedRotareadyEntities.length !== 0" options="$ctrl.linkedSitesSearchBarOptions"></search-bar>\n\t\t\t<div class="checkbox-rows-list" ng-if="$ctrl.linkedRotareadyEntities.length !== 0">\n\t\t\t\t<div class="checkbox-row" ng-repeat="entity in $ctrl.getFilteredEntities($ctrl.linkedRotareadyEntities, $ctrl.linkedSitesSearchBarOptions) track by entity.RotareadyEntityID">\n\t\t\t\t\t<label class="checkbox-row_label has-warning" for="linked_{{entity.RotareadyEntityID}}">\n\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" data-cy="linked-site-checkbox-{{$index}}" id="linked_{{entity.RotareadyEntityID}}" name="linked_{{entity.RotareadyEntityID}}" ng-model="entity.isSelected" type="checkbox">\n\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t<span class="tenant-card_label">{{entity.EntityName}}</span>\n\t\t\t\t\t\t\t<info-block class="checkbox-row_warning" data-cy="linked-site-warning-{{$index}}" ib-theme="assertive has-icon has-border has-plain-type" ng-if="entity.isRenamed || (!entity.isSelected && entity.employeeCount !== null)">\n\t\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" ng-if="entity.isRenamed">Renamed in Rotaready: {{entity.rotareadyEntityName}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" ng-if="!entity.isSelected && entity.employeeCount > 0">{{entity.employeeCount}} employee{{entity.employeeCount === 1 ? \'\' : \'s\'}} currently linked to this site. Unlinking removes the site and its business category mapping.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" ng-if="!entity.isSelected && entity.employeeCount === 0">Unlinking removes this site and its business category mapping.</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t\t</info-block>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="is-small greyscale-midtone" ng-if="$ctrl.linkedRotareadyEntities.length === 0">No sites are currently linked.</p>\n\t\t</section>\n\n\t\t<!-- Not Linked -->\n\t\t<section class="form-field" ng-if="$ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.newSites">\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="s">Rotaready sites that exist but are not linked to this Paycircle company.</p>\n\t\t\t</div>\n\t\t\t<search-bar count="$ctrl.getFilteredEntities($ctrl.newRotareadyEntities, $ctrl.newSitesSearchBarOptions).length" data-cy="new-sites-search-bar" ng-if="$ctrl.newRotareadyEntities.length !== 0" options="$ctrl.newSitesSearchBarOptions"></search-bar>\n\t\t\t<div class="checkbox-rows-list" ng-if="$ctrl.newRotareadyEntities.length !== 0">\n\t\t\t\t<div class="checkbox-row" ng-repeat="entity in $ctrl.getFilteredEntities($ctrl.newRotareadyEntities, $ctrl.newSitesSearchBarOptions) track by entity.EntityID + \'_\' + entity.PayrollCalendarID">\n\t\t\t\t\t<label class="checkbox-row_label has-warning" for="new_{{entity.EntityID}}_{{entity.PayrollCalendarID}}" ng-class="{\'is-disabled\': entity.isMappedToOtherCompany}">\n\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" data-cy="new-site-checkbox-{{$index}}" id="new_{{entity.EntityID}}_{{entity.PayrollCalendarID}}" name="new_{{entity.EntityID}}_{{entity.PayrollCalendarID}}" ng-disabled="entity.isMappedToOtherCompany" ng-model="entity.isSelected" type="checkbox">\n\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t<div class="checkbox-row_header">\n\t\t\t\t\t\t\t\t<span class="tenant-card_label">{{entity.EntityName}}</span>\n\t\t\t\t\t\t\t\t<span class="tag positive" data-cy="new-site-tag-{{$index}}" ng-if="entity.isNew">New</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<info-block class="checkbox-row_warning" data-cy="new-site-warning-{{$index}}" ib-theme="assertive has-icon has-border has-plain-type" ng-if="entity.isMappedToOtherCompany">\n\t\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">Mapped to {{entity.mappedCompanyName}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t\t</info-block>\n\t\t\t\t\t\t\t<info-block class="checkbox-row_warning" data-cy="new-site-frequency-warning-{{$index}}" ib-theme="assertive has-icon has-border has-plain-type" ng-if="entity.isSelected && entity.frequencyWarning">\n\t\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">{{entity.frequencyWarning}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t\t</info-block>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="is-small greyscale-midtone" ng-if="$ctrl.newRotareadyEntities.length === 0">No new sites found in Rotaready.</p>\n\t\t</section>\n\n\t\t<!-- Removed -->\n\t\t<section class="form-field" ng-if="$ctrl.entitySelectionTab === $ctrl.ENTITY_SELECTION_TABS.removed">\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="s">Sites linked to this Paycircle company that no longer exist in Rotaready.</p>\n\t\t\t</div>\n\t\t\t<search-bar count="$ctrl.getFilteredEntities($ctrl.removedRotareadyEntities, $ctrl.removedSitesSearchBarOptions).length" data-cy="removed-sites-search-bar" ng-if="$ctrl.removedRotareadyEntities.length !== 0" options="$ctrl.removedSitesSearchBarOptions"></search-bar>\n\t\t\t<div class="checkbox-rows-list" ng-if="$ctrl.removedRotareadyEntities.length !== 0">\n\t\t\t\t<div class="checkbox-row" ng-repeat="entity in $ctrl.getFilteredEntities($ctrl.removedRotareadyEntities, $ctrl.removedSitesSearchBarOptions) track by entity.RotareadyEntityID">\n\t\t\t\t\t<div class="checkbox-row_label has-warning">\n\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t<div class="checkbox-row_header">\n\t\t\t\t\t\t\t\t<span class="tenant-card_label">{{entity.EntityName}}</span>\n\t\t\t\t\t\t\t\t<a class="checkbox-row_note" data-cy="unlink-removed-site-{{$index}}" href="" ng-click="$ctrl.toggleRemovedEntity(entity)">{{entity.isRemoved ? \'Cancel unlink\' : \'Unlink\'}}</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<info-block class="checkbox-row_warning" data-cy="removed-site-warning-{{$index}}" ib-theme="assertive has-icon has-border has-plain-type">\n\t\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">No longer in Rotaready</p>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small" ng-if="entity.isRemoved">Will be unlinked when you save</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t\t</info-block>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="is-small greyscale-midtone" ng-if="$ctrl.removedRotareadyEntities.length === 0">No sites have been removed in Rotaready.</p>\n\t\t</section>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="linked-sites-back" ng-click="$ctrl.goBackFromLinkedSites()" type="button">Back</button>\n\t\t<submit-button data-cy="linked-sites-save" disable-button="!$ctrl.hasLinkedSiteSelection()" display-text="\'Save\'"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm Linked Sites -->\n<form class="fadeIn" name="confirmLinkedSitesForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmLinkedSites" ng-submit="$ctrl.updateLinkedSiteSelection()" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to save these site changes?">\n\t\t<fs-main>\n\t\t\t<p class="s" ng-if="$ctrl.linkedSiteChanges.length !== 0">The following changes will be made to the Rotaready sites linked to {{$ctrl.formOptions.company.Name}}:</p>\n\t\t\t<div class="form-content-block" data-cy="linked-sites-changes-list" ng-if="$ctrl.linkedSiteChanges.length !== 0">\n\t\t\t\t<bullet-list bl-theme="is-small is-primary is-spaced-out">\n\t\t\t\t\t<bl-items>\n\t\t\t\t\t\t<li class="bullet-list_item" ng-repeat="change in $ctrl.linkedSiteChanges track by $index">\n\t\t\t\t\t\t\t<span>{{change}}</span>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</bl-items>\n\t\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t\t<p class="s" ng-if="$ctrl.linkedSiteChanges.length === 0">There are no changes to the linked sites.</p>\n\t\t\t<p class="s">Click &lsquo;Confirm&rsquo; if you\'re happy to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="confirm-linked-sites-cancel" ng-click="$ctrl.goBackToLinkedSites()" type="button">Cancel</button>\n\t\t<submit-button data-cy="confirm-linked-sites-confirm" display-text="\'Confirm\'" state="confirmLinkedSitesForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Connection Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Connected to Rotaready" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connectionSuccess">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou\'ve successfully connected to Rotaready. Before data can start flowing into Paycircle you also\n\t\t\t\tneed to map the team members. Click the link below to do this now, or come back to it later by clicking \'Edit\'\n\t\t\t\tin company settings > Integrations > Time and Attendance.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<info-block ib-theme="secondary has-icon has-plain-type">\n\t\t\t<ib-header>\n\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t<i class="icon-settings secondary info-block-icon"></i>\n\t\t\t\t\t<h6 class="stronger">Manage Rotaready Data Mapping</h6>\n\t\t\t\t</div>\n\t\t\t</ib-header>\n\t\t\t<ib-main>\n\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\tManage the mapping of team members and sites/departments from Rotaready with team members and business categories in Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\tTo manage these mappings,\n\t\t\t\t\t<a data-cy="open-rotaready-page-link" href="" ng-click="$ctrl.openRotareadyPage()">\n\t\t\t\t\t\tgo to mapping.\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" data-cy="close-form-link" href="" ng-click="$ctrl.closeForm()">Close</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Connected -->\n<form name="editRotareadyIntegrationForm" class="fadeIn" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connected" novalidate>\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\t\t\t\t<settings-row ng-model="$ctrl.isRotareadyIntegrationEnabled" sr-field-name="isRotareadyIntegrationEnabled" sr-icon="team" sr-label="Rotaready Integration">\n\t\t\t\t\t<sr-description ng-if="!$ctrl.isRotareadyIntegrationEnabled">\n\t\t\t\t\t\tTurning this on means you\'ll be able to receive and review team and payroll updates from Rotaready.\n\t\t\t\t\t</sr-description>\n\n\t\t\t\t\t<sr-description ng-if="$ctrl.isRotareadyIntegrationEnabled">\n\t\t\t\t\t\tTurning this off means you won\'t be able to receive and review team and payroll updates from Rotaready.\n\t\t\t\t\t</sr-description>\n\n\t\t\t\t\t<sr-content ng-if="$ctrl.isRotareadyIntegrationEnabled">\n\t\t\t\t\t\t<fieldset ng-if="$ctrl.isRealmSegmentationEnabled">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Manage Linked Sites/Departments</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\tChoose which Rotaready sites/departments are linked to this company.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<a class="link-with-icon strong" data-cy="manage-linked-sites" href="" ng-click="$ctrl.openLinkedSites()">\n\t\t\t\t\t\t\t\t\t<i class="icon-right"></i>\n\t\t\t\t\t\t\t\t\tManage linked sites/departments\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">Manage Rotaready Data Mapping</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\tManage the mapping of team members and sites/departments from Rotaready with team members and business categories in Paycircle.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openRotareadyPage()" class="link-with-icon strong">\n\t\t\t\t\t\t\t\t\t<i class="icon-right"></i>\n\t\t\t\t\t\t\t\t\tGo to mapping\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<fieldset ng-if="$ctrl.isMonthlyPayroll">\n\t\t\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<h6 class="stronger">Rotaready reference periods</h6>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t\tConfigure how Rotaready schedules align with your pay periods.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Setup periods" field-model="$ctrl.isReferencePeriodsEnabled" field-name="isReferencePeriodsEnabled" field-on-change="$ctrl.onToggleReferencePeriods()"></toggle-input>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<fieldset ng-if="$ctrl.isReferencePeriodsEnabled">\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\t\t\t\t\t\tYour current pay period ({{ $ctrl.formOptions.currentPayPeriod.PayPeriodDisplay }}):\n\t\t\t\t\t\t\t\t\t\t</p><div class="spacer s"></div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t<bullet-list bl-items="$ctrl.currentPayPeriodList" bl-theme="is-small is-spaced-out is-primary"></bullet-list>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="referencePeriodsPattern" class="required">Reference period pattern:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="reference-periods-pattern-445" default id="referencePeriodsPattern445" name="referencePeriodsPattern" ng-change="$ctrl.onChangeReferencePeriodsPattern($ctrl.referencePeriodConfig.PatternStartDateISO)" ng-model="$ctrl.referencePeriodConfig.Pattern" ng-value="$ctrl.REFERENCE_PERIODS_PATTERNS.fourFourFive" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="referencePeriodsPattern445">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">{{ $ctrl.REFERENCE_PERIODS_PATTERNS_DISPLAY[$ctrl.REFERENCE_PERIODS_PATTERNS.fourFourFive] }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="reference-periods-pattern-454" id="referencePeriodsPattern454" name="referencePeriodsPattern" ng-change="$ctrl.onChangeReferencePeriodsPattern($ctrl.referencePeriodConfig.PatternStartDateISO)" ng-model="$ctrl.referencePeriodConfig.Pattern" ng-value="$ctrl.REFERENCE_PERIODS_PATTERNS.fourFiveFour" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="referencePeriodsPattern454">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">{{ $ctrl.REFERENCE_PERIODS_PATTERNS_DISPLAY[$ctrl.REFERENCE_PERIODS_PATTERNS.fourFiveFour] }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="reference-periods-pattern-544" id="referencePeriodsPattern544" name="referencePeriodsPattern" ng-change="$ctrl.onChangeReferencePeriodsPattern($ctrl.referencePeriodConfig.PatternStartDateISO)" ng-model="$ctrl.referencePeriodConfig.Pattern" ng-value="$ctrl.REFERENCE_PERIODS_PATTERNS.fiveFourFour" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="referencePeriodsPattern544">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">{{ $ctrl.REFERENCE_PERIODS_PATTERNS_DISPLAY[$ctrl.REFERENCE_PERIODS_PATTERNS.fiveFourFour] }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="reference-periods-pattern-offset" id="referencePeriodsPatternOffset" name="referencePeriodsPattern" ng-change="$ctrl.onChangeReferencePeriodsPattern($ctrl.referencePeriodConfig.PatternStartDateISO)" ng-model="$ctrl.referencePeriodConfig.Pattern" ng-value="$ctrl.REFERENCE_PERIODS_PATTERNS.offset" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="referencePeriodsPatternOffset">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">{{ $ctrl.REFERENCE_PERIODS_PATTERNS_DISPLAY[$ctrl.REFERENCE_PERIODS_PATTERNS.offset] }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.referencePeriodConfig.Pattern === $ctrl.REFERENCE_PERIODS_PATTERNS.offset">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="referencePeriodsOffsetAnchor" class="required">Pay period date:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t\t<p class="s">This is the pay period date that your reference period moves in relation to. E.g. select \'Pay date\' if your reference period is always x days before your pay date.</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select class="l" data-cy="reference-periods-offset-anchor" id="referencePeriodsOffsetAnchor" name="referencePeriodsOffsetAnchor" ng-change="$ctrl.refreshReferencePeriodCalendar()" ng-model="$ctrl.referencePeriodConfig.OffsetAnchor" ng-options="option.id as option.description for option in $ctrl.REFERENCE_PERIOD_OFFSET_ANCHOR_OPTIONS" required>\n\t\t\t\t\t\t\t\t\t\t\t<option value="">Select date...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editRotareadyIntegrationForm.referencePeriodsOffsetAnchor.$touched" ng-messages="editRotareadyIntegrationForm.referencePeriodsOffsetAnchor.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select pay period date</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.referencePeriodConfig.Pattern === $ctrl.REFERENCE_PERIODS_PATTERNS.offset">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="referencePeriodsOffsetTarget" class="required">Reference period date:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t\t<p class="s">This is the reference period date that moves relative to your selected pay period date. E.g. select \'End date\' if your reference period end date is always x days before your pay date.</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select class="l" data-cy="reference-periods-offset-target" id="referencePeriodsOffsetTarget" name="referencePeriodsOffsetTarget" ng-change="$ctrl.refreshReferencePeriodCalendar()" ng-model="$ctrl.referencePeriodConfig.OffsetTarget" ng-options="option.id as option.description for option in $ctrl.REFERENCE_PERIOD_OFFSET_TARGET_OPTIONS" required>\n\t\t\t\t\t\t\t\t\t\t\t<option value="">Select date...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editRotareadyIntegrationForm.referencePeriodsOffsetTarget.$touched" ng-messages="editRotareadyIntegrationForm.referencePeriodsOffsetTarget.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select reference period date</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.referencePeriodConfig.Pattern === $ctrl.REFERENCE_PERIODS_PATTERNS.offset">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="offsetDays" class="required">Offset days:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t\t\t\t\t\t<p class="s">This is the number of days between your selected pay period date and selected reference period date. E.g. enter -5 if your reference period end date is always 5 days before your pay date.</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<number-selector-field data-cy="reference-periods-offset-days" field-name="offsetDays" max="0" min="-31" ng-model="$ctrl.referencePeriodConfig.OffsetDays" ng-regex-key="integersOnly" ng-required="true" nsf-on-change="$ctrl.refreshReferencePeriodCalendar()" step="1"></number-selector-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editRotareadyIntegrationForm.offsetDays.$touched" ng-messages="editRotareadyIntegrationForm.offsetDays.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of offset days</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of -31 days</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 0 days</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.referencePeriodConfig.Pattern !== $ctrl.REFERENCE_PERIODS_PATTERNS.offset">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="startDate">Start date of current reference period:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-on-change="$ctrl.refreshReferencePeriodCalendar" field-value-iso="$ctrl.referencePeriodConfig.PatternStartDateISO" field-max-date-iso="$ctrl.referencePeriodDateMax" field-min-date-iso="$ctrl.referencePeriodDateMin"></date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editRotareadyIntegrationForm.startDate.$touched" ng-messages="editRotareadyIntegrationForm.startDate.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the start date of reference period</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">The start date can be no later than {{$ctrl.referencePeriodDateMax | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">The start date can be no earlier than {{$ctrl.referencePeriodDateMin | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<a data-cy="reference-periods-calendar-toggle" href="" ng-click="$ctrl.toggleReferencePeriodCalendar()" class="link-with-icon strong" ng-class="{\'is-disabled\': !$ctrl.isEditFormValid(editRotareadyIntegrationForm)}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-{{$ctrl.isCalendarOpen ? \'right\' : \'back\'}}"></i>\n\t\t\t\t\t\t\t\t\t\t{{$ctrl.isCalendarOpen ? \'Close\' : \'Open\'}} reference period calendar\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="NMW compliance">\n\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">Reference periods affect how working time is calculated for National Minimum Wage purposes. Ensure your chosen pattern aligns with your operational requirements and compliance obligations.</p>\n\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</sr-content>\n\t\t\t\t</settings-row>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.closeForm()" type="button">Cancel</button>\n\t\t<submit-button disable-button="!$ctrl.isEditFormValid(editRotareadyIntegrationForm)" display-text="\'Save\'" ng-click="$ctrl.submitEditRotareadyIntegrationForm(editRotareadyIntegrationForm)" state="editRotareadyIntegrationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="$ctrl.isCalendarOpen">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Reference period calendar</h5>\n\t\t<a aria-label="Close calendar" data-cy="reference-periods-calendar-close" class="slide-in-form-aside-header-action" href="" ng-click="$ctrl.toggleReferencePeriodCalendar()">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\n\t<!-- Loading -->\n\t<div class="slide-in-form-aside-main align-center fadeIn" ng-if="$ctrl.isCalendarLoading">\n\t\t<loading-block position="after">\n\t\t\t<lb-description>\n\t\t\t\t<h5>Generating preview</h5>\n\t\t\t</lb-description>\n\t\t</loading-block>\n\t</div>\n\n\t<div class="slide-in-form-aside-main fadeIn" ng-if="!$ctrl.isCalendarLoading">\n\t\t<div ng-repeat="(periodIndex, period) in $ctrl.periodDetails.referencePeriods" ng-if="periodIndex === $ctrl.periodDetails.periodIndex">\n\t\t\t<div class="slide-in-form-aside-subheader">\n\t\t\t\t<p>Period {{periodIndex + 1}}</p>\n\n\t\t\t\t<div class="next-previous-controls slide-in-form-aside-subheader-actions">\n\t\t\t\t\t<a aria-label="Go to previous reference period" data-cy="reference-periods-calendar-previous" href="" ng-click="$ctrl.decrementPeriodIndex($ctrl.periodDetails)" ng-class="{\'disabled\': $ctrl.periodDetails.periodIndex === $ctrl.periodDetails.periodIndexMin}">\n\t\t\t\t\t\t<i class="icon-chevron-left"></i>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a aria-label="Go to next reference period" data-cy="reference-periods-calendar-next" href="" ng-click="$ctrl.incrementPeriodIndex($ctrl.periodDetails)" ng-class="{\'disabled\': $ctrl.periodDetails.periodIndex === $ctrl.periodDetails.periodIndexMax}">\n\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Reference Periods -->\n\t\t\t<div class="data-grid is-primary">\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div data-cy="reference-periods-calendar-pay-period" class="data-grid_cell is-primary">Pay period</div>\n\t\t\t\t\t<div data-cy="reference-periods-calendar-pay-period-value" class="data-grid_cell">{{period.PayPeriodDisplay}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div data-cy="reference-periods-calendar-pay-date" class="data-grid_cell is-primary">Pay date</div>\n\t\t\t\t\t<div data-cy="reference-periods-calendar-pay-date-value" class="data-grid_cell">{{period.PayPeriodPayDateISO | dateformat}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div data-cy="reference-periods-calendar-start-date" class="data-grid_cell is-primary">Reference period start date</div>\n\t\t\t\t\t<div data-cy="reference-periods-calendar-start-date-value" class="data-grid_cell">{{period.PeriodStartDateISO | dateformat}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div data-cy="reference-periods-calendar-end-date" class="data-grid_cell is-primary">Reference period end date</div>\n\t\t\t\t\t<div data-cy="reference-periods-calendar-end-date-value" class="data-grid_cell">{{period.PeriodEndDateISO | dateformat}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div data-cy="reference-periods-calendar-weeks" class="data-grid_cell is-primary">No. Weeks</div>\n\t\t\t\t\t<div data-cy="reference-periods-calendar-weeks-value" class="data-grid_cell">{{period.NoWeeks}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</aside>\n\n<!-- Error when saving reference periods -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to update reference periods" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.referencePeriodsValidationError">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe start date selected means that in one or more of your periods, the end date is on or after your pay date. Try using an earlier start date in your reference period settings.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.goBack()">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Confirm disconnect -->\n<form class="fadeIn" name="disconnectForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect" ng-submit="$ctrl.disconnect()" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to disconnect from Rotaready?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tOnce disconnected you\'ll no longer receive team and payroll data from Rotaready.\n\t\t\t\tPlease note that this won\'t affect any other companies you may have connected to Rotaready.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\'re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!disconnectForm.$valid" display-text="\'Confirm\'" state="disconnectForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Disconnected -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Disconnected from Rotaready" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.disconnected">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou can connect to Rotaready again at any time from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong">\n\t\t\t\t<a data-cy="slide-in-form-close-link" href="" ng-click="$ctrl.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Reference Periods Updated -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Reference Periods Updated" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.referencePeriodsUpdated">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe reference periods have been successfully updated.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong">\n\t\t\t\t<a data-cy="slide-in-form-close-link" href="" ng-click="$ctrl.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Entity validation error -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to save site/department mapping" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.entityValidationError">\n\t<fs-main>\n\t\t<p class="is-small">One or more of the selected sites/departments could not be saved:</p>\n\t\t<div class="spacer s"></div>\n\t\t<bullet-list bl-items="$ctrl.entityValidationErrors" bl-theme="is-small is-spaced-out is-assertive"></bullet-list>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.goBack()">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error && !$ctrl.isRotareadyIntegrationEnabled" secondary-action="$ctrl.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n<error-block data-cy="rotaready-error-disconnect-button" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error && $ctrl.isRotareadyIntegrationEnabled" secondary-action="$ctrl.moveToConfirmDisconnect()" secondary-action-text="Try to disconnect"></error-block>\n');
$templateCache.put('forms/admin/edit-rotaready-team-mapping/edit-rotaready-team-mapping.form.html','<!-- Loading -->\n<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.loading"></loading-block>\n\n<form class="fadeIn" name="editRotareadyTeamMappingForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.ready" novalidate>\n\n\t<!-- Intro -->\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tTeam members in Paycircle must be mapped to team members in Rotaready. This is so updates\n\t\t\tsent from Rotaready to Paycircle get appplied to the correct team member.\n\t\t</p>\n\t</div>\n\n\t<!-- Tabs -->\n\t<nav class="tabs">\n\t\t<a href="" ng-class="{\n\t\t\t\t\'active\': $ctrl.activeTab === $ctrl.TAB.unmatchedRotaready\n\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl.TAB.unmatchedRotaready)">\n\t\t\tUnmatched Rotready ({{$ctrl.teamMembersUnmatchedRotaready.length}})\n\t\t</a>\n\t\t<a href="" ng-class="{\n\t\t\t\t\'active\': $ctrl.activeTab === $ctrl.TAB.unmatchedPaycircle\n\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl.TAB.unmatchedPaycircle)">\n\t\t\tUnmatched Paycircle ({{$ctrl.teamMembersUnmatchedPaycircle.length}})\n\t\t</a>\n\t\t<a href="" ng-class="{\n\t\t\t\t\'active\': $ctrl.activeTab === $ctrl.TAB.matched\n\t\t\t}" ng-click="$ctrl.setActiveTab($ctrl.TAB.matched)">\n\t\t\tMatched ({{$ctrl.teamMembersMatched.length}})\n\t\t</a>\n\t</nav>\n\n\t<!-- Unmatched Rotaready -->\n\t<div class="rotaready-team-mapping-cards fadeIn" ng-if="$ctrl.activeTab === $ctrl.TAB.unmatchedRotaready">\n\t\t<div class="rotaready-team-mapping-card" ng-class="{\'is-matched\': false}" ng-repeat="teamMember in $ctrl.teamMembersUnmatchedRotaready">\n\n\t\t\t<div class="rotaready-team-mapping-card_source">\n<!--\t\t\t\t<div class="rotaready-team-mapping-card_source_left">-->\n<!--\t\t\t\t\t<h5>Rotaready: </h5>-->\n<!--\t\t\t\t</div>-->\n\t\t\t\t<div class="rotaready-team-mapping-card_source_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top" ng-if="teamMember.Rotaready">\n\t\t\t\t\t\t{{teamMember.Rotaready.FullName}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDate of birth: {{teamMember.Rotaready.DateOfBirthIso | dateformat:\'dayMonthYear\'}}<br>\n\t\t\t\t\t\tGender: {{teamMember.Rotaready.Gender}}<br>\n\t\t\t\t\t\tNINO: {{teamMember.Rotaready.Nino}}<br>\n\t\t\t\t\t\tEmail: {{teamMember.Rotaready.Email}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<span class="tag is-assertive" ng-if="!teamMember.Paycircle && !teamMember.create">\n\t\t\t\t\t\tUnmatched\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="rotaready-team-mapping-card_target" ng-class="{\'is-matched\': false}">\n<!--\t\t\t\t<div class="rotaready-team-mapping-card_target_left">-->\n<!--\t\t\t\t\t<h5>Paycircle: </h5>-->\n<!--\t\t\t\t</div>-->\n\t\t\t\t<div class="rotaready-team-mapping-card_target_middle">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<select class="rotaready-team-mapping-card_target_middle_top" id="teamMember-{{$index}}" name="teamMember-{{$index}}" ng-change="$ctrl.matchTeamMembers(teamMember)" ng-model="teamMember.Paycircle" ng-options="tm.Paycircle as tm.Paycircle.FullName for tm in $ctrl.teamMembersUnmatchedPaycircle | orderBy: \'Paycircle.FullName\'">\n\t\t\t\t\t\t\t<option value="">Please select</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_target_middle_button" ng-click="$ctrl.createPaycircleTeamMember(teamMember)">\n\t\t\t\t\tCreate\n\t\t\t\t</button>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No results -->\n\t\t<placeholder ng-if="$ctrl.teamMembersUnmatchedRotaready.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-companies">\n\t\t\t<placeholder-title>No unmatched Rotaready team members</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>There are no unmatched Rotaready team members at the moment.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Matched -->\n\t<div class="rotaready-team-mapping-cards fadeIn" ng-if="$ctrl.activeTab === $ctrl.TAB.matched">\n\t\t<div class="rotaready-team-mapping-card" ng-class="{\'is-matched\': true}" ng-repeat="teamMember in $ctrl.teamMembersMatched">\n\t\t\t<div class="rotaready-team-mapping-card_source">\n\t\t\t\t<div class="rotaready-team-mapping-card_source_left">\n\t\t\t\t\t<h5>Rotaready: </h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="rotaready-team-mapping-card_source_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{teamMember.Rotaready ? teamMember.Rotaready.FullName : \'Create\'}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p ng-if="teamMember.Rotaready">\n\t\t\t\t\t\tDate of birth: {{teamMember.Rotaready.DateOfBirthIso | dateformat:\'dayMonthYear\'}}<br>\n\t\t\t\t\t\tGender: {{teamMember.Rotaready.Gender}}<br>\n\t\t\t\t\t\tNINO: {{teamMember.Rotaready.Nino}}<br>\n\t\t\t\t\t\tEmail: {{teamMember.Rotaready.Email}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div>\n\t\t\t\t\t<span class="tag is-positive">Matched</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-team-mapping-card_target" ng-class="{\'is-matched\': true}">\n\t\t\t\t<div class="rotaready-team-mapping-card_target_left">\n\t\t\t\t\t<h5>Paycircle: </h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="rotaready-team-mapping-card_target_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{teamMember.Paycircle ? teamMember.Paycircle.FullName : \'Create\'}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p ng-if="teamMember.Paycircle">\n\t\t\t\t\t\tDate of birth: {{teamMember.Paycircle.DateOfBirthIso | dateformat:\'dayMonthYear\'}}<br>\n\t\t\t\t\t\tGender: {{teamMember.Paycircle.Gender}}<br>\n\t\t\t\t\t\tNINO: {{teamMember.Paycircle.Nino}}<br>\n\t\t\t\t\t\tEmail: {{teamMember.Paycircle.Email}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_target_middle_button" ng-click="$ctrl.unmatchTeamMembers(teamMember)" ng-if="teamMember.Paycircle && teamMember.Rotaready">Undo Match</button>\n\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_target_middle_button" ng-click="$ctrl.undoCreateRotareadyTeamMember(teamMember)" ng-if="!teamMember.Rotaready">Undo Create</button>\n\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_target_middle_button" ng-click="$ctrl.undoCreatePaycircleTeamMember(teamMember)" ng-if="!teamMember.Paycircle">Undo Create</button>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No results -->\n\t\t<placeholder ng-if="$ctrl.teamMembersMatched.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-companies">\n\t\t\t<placeholder-title>No matched team members</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>There are no matched team members. Check the &lsquo;Unmatched&rsquo; tab for team members that need matching.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Unmatched Paycircle -->\n\t<div class="rotaready-team-mapping-cards fadeIn" ng-if="$ctrl.activeTab === $ctrl.TAB.unmatchedPaycircle">\n\n\t\t<div class="rotaready-team-mapping-card" ng-class="{\'is-matched\': false}" ng-repeat="teamMember in $ctrl.teamMembersUnmatchedPaycircle">\n\n\t\t\t<div class="rotaready-team-mapping-card_source">\n\t\t\t\t<div class="rotaready-team-mapping-card_source_left">\n\t\t\t\t\t<h5>Paycircle: </h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="rotaready-team-mapping-card_source_middle">\n\t\t\t\t\t<h5 class="rotaready-team-mapping-card_source_middle_top">\n\t\t\t\t\t\t{{teamMember.Paycircle.FullName}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDate of birth: {{teamMember.Paycircle.DateOfBirthIso | dateformat:\'dayMonthYear\'}}<br>\n\t\t\t\t\t\tGender: {{teamMember.Paycircle.Gender}}<br>\n\t\t\t\t\t\tNINO: {{teamMember.Paycircle.Nino}}<br>\n\t\t\t\t\t\tEmail: {{teamMember.Paycircle.Email}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<button class="is-small rotaready-team-mapping-card_source_middle_button" ng-click="$ctrl.createRotareadyTeamMember(teamMember)">Create</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No results -->\n\t\t<placeholder ng-if="$ctrl.teamMembersUnmatchedPaycircle.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-companies">\n\t\t\t<placeholder-title>No unmatched Paycircle team members</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>There are no unmatched Paycircle team members at the moment.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.closeForm()" type="button"> Close</button>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.setPageState($ctrl.PAGE_STATE.confirm)" type="button">Save</button>\n\t</fieldset>\n</form>\n\n<!-- Confirm -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Save changes?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.confirm">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t- {{$ctrl.teamMemberMappingsUpdated.length}} team members\' mappings will be updated<br>\n\t\t\t- {{$ctrl.createInPaycircle.length}} new team members will be created in Paycircle<br>\n\t\t\t- {{$ctrl.createInRotaready.length}} new team members will be created in Rotaready\n\t\t</p>\n\t\t<p class="s">\n\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to save changes,\n\t\t\tor click &lsquo;Back&rsquo; to return to the previous page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.setPageState($ctrl.PAGE_STATE.ready)">Back</a>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.saveChanges()">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATE.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/editAdmin/editAdminForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="editAdminForm" ng-if="pageState === \'ready\'" ng-submit="updateAdmin(vm, editAdminForm)" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="forename" minlength="2" name="forename" ng-model="vm.admin.Forename" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="editAdminForm.forename.$touched" ng-messages="editAdminForm.forename.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p ng-message="pattern">Name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Last Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="surname" name="surname" ng-model="vm.admin.Surname" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="editAdminForm.surname.$touched" ng-messages="editAdminForm.surname.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t<p ng-message="pattern">Name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Email / Telephone -->\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Email -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="email" class="required">Email address:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="emailAddress" name="emailAddress" ng-model="vm.admin.Email" required type="email">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="editAdminForm.emailAddress.$touched" ng-messages="editAdminForm.emailAddress.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Telephone number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="phone">Telephone number:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="phone" name="phone" ng-model="vm.admin.PhoneNumberPrimary" ng-pattern="$root.REGEX.telephone" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="editAdminForm.phone.$error" ng-if="editAdminForm.phone.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a telephone number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid phone number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- SSO ID (for SSO-enabled bureaus)-->\n\t\t<div class="form-field" ng-if="vm.ssoEnabled">\n\t\t\t<label class="required" for="ssoId">Authentication ID:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="ssoId" name="ssoId" ng-model="vm.admin.SSOID" ng-model-options="{ debounce: 500 }" type="text" required ssoid-exists ssoid-exists-agency-profile-id="agencyProfileId" ssoid-exists-user-id="userId" ssoid-exists-original="vm.admin.SSOID">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="editAdminForm.ssoId.$touched" ng-messages="editAdminForm.ssoId.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a unique Authentication ID</p>\n\t\t\t\t<p ng-message="ssoid-exists">This Authentication ID is already in use</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Role Selection -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="roleOption1">Choose a role:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main" ng-switch="formOptions.company.CompanyType">\n\n\t\t\t\t<!-- Bureau > Super User or Team Member-->\n\t\t\t\t<div class="radio-rows-list" pc-switch-when="INTERFACE_TYPES.bureau">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption1" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.superUser" required type="radio">\n\t\t\t\t\t\t<label for="roleOption1" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.superUser | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption2" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.teamMember" required type="radio">\n\t\t\t\t\t\t<label for="roleOption2" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.teamMember | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Group > Group Admin or Group Admin Lite -->\n\t\t\t\t<div class="radio-rows-list" pc-switch-when="INTERFACE_TYPES.group">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption1" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.groupAdmin" required type="radio">\n\t\t\t\t\t\t<label for="roleOption1" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.groupAdmin | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption2" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.groupAdminLite" required type="radio">\n\t\t\t\t\t\t<label for="roleOption2" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.groupAdminLite | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company > Company Admin, Company Admin Lite or Department Admin -->\n\t\t\t\t<div class="radio-rows-list" ng-switch-default>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption1" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.companyAdmin" required type="radio">\n\t\t\t\t\t\t<label for="roleOption1" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.companyAdmin | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption2" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.companyadministratorlite" required type="radio">\n\t\t\t\t\t\t<label for="roleOption2" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.companyadministratorlite | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="roleOption3" name="roleType" ng-change="updatePermissionsForRoleType(vm)" ng-model="vm.roleDetail.RoleType" ng-value="PERMISSION_ROLE_IDS.departmentadmin" required type="radio">\n\t\t\t\t\t\t<label for="roleOption3" class="radio-row-label">\n\t\t\t\t\t\t\t<span class="tag l quarternary radio-row-label-tag"><i class="icon-roles"></i>&nbsp;&nbsp;{{PERMISSION_ROLE_IDS.departmentadmin | permissionRole}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Permissions -->\n\t<fieldset class="fadeIn">\n\n\t\t<!-- Has custom -->\n\t\t<div class="form-field" ng-if="vm.roleDetail.Groups.length">\n\t\t\t<div class="field">\n\t\t\t\t<input checkbox id="checkboxField" label-text="\'Has custom permissions\'" name="checkboxField" ng-false-value="true" ng-model="vm.roleDetail.IsDefault" ng-true-value="false" type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Custom permissions -->\n\t\t<div class="form-field fadeIn" ng-if="!vm.roleDetail.IsDefault && vm.roleDetail.Groups.length">\n\t\t\t<div class="field">\n\t\t\t\t<permissions-selector class="has-border-top" is-valid="vm.isPermissionsValid" permissions-updated="vm.hasPermissionsUpdated" role-detail="vm.roleDetail"></permissions-selector>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No permissions -->\n\t\t<div class="form-content-block fadeIn" ng-if="!vm.roleDetail.Groups.length">\n\t\t\t<div class="message-bar assertive inline">\n\t\t\t\t<p class="s">{{formOptions.context.Forename}} doesn\'t have any permissions assigned. Please contact support</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="(vm.roleDetail.IsDefault && editAdminForm.$invalid) || (editAdminForm.$invalid || (!vm.roleDetail.IsDefault && !vm.isPermissionsValid))" display-text="\'Save\'" state="editAdminForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/editCompanyGroup/editCompanyGroupForm.html','<form name="editCompanyGroupForm" ng-submit="updateCompanyGroup(editCompanyGroupForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\t\t<!-- Workspace Organization -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="workspaceOrganizations" class="required">Workspace Organization:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<select name="workspaceOrganizations" id="workspaceOrganizations" class="l" ng-model="selectedOrganization" ng-options="option.OrganisationID as option.OrganisationName for option in organizations" ng-change="setupSelectedOrganization(selectedOrganization)">\n\t\t\t\t\t{{selectedOrganization.OrganisationName}}\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Workspace Organization Warning -->\n\t<fieldset ng-if="true">\n\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="warning" note-title="Workspace Organization Selection Unavailable">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">When a group has companies from multiple workspace organizations or a mixture of companies in and outside of a workspace organization, you cannot select a workspace organization to link the group to.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="editCompanyGroupForm.state" ng-if="editCompanyGroupForm.state === \'saved\'">\n\t\t\t<p>Workspace Organization has been updated.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="editCompanyGroupForm.state" disable-button="!editCompanyGroupForm.$valid || !selectedOrganization"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Workspace Organization updated" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Workspace Organization has been successfully updated.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>');
$templateCache.put('forms/admin/invite-to-register/invite-sso-admin-to-fully-register.form.html','<loading-block ng-if="componentState === COMPONENT_STATES.loading"></loading-block>\n\n<!-- Individual invite -->\n<form class="fadeIn" name="inviteSSOAdminToFullyRegisterForm" ng-if="componentState === COMPONENT_STATES.individualInvite" ng-submit="sendRegistrationEmailForSsoAdmin(inviteSSOAdminToFullyRegisterForm)" novalidate>\n\t<div class="form-section">\n\t\t<div class="info-block primary">\n\t\t\t<p>The invitation will be sent to the email saved in {{formOptions.adminObj.Forename}}\'s profile:</p>\n\t\t\t<p class="strong"><em>{{::formOptions.adminObj.EmailAddress}}</em></p>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Send invite\'" state="inviteSSOAdminToFullyRegisterForm.state" disable-button="!inviteSSOAdminToFullyRegisterForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n<!-- Individual success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{formOptions.adminObj.Forename}} has been invited" ng-if="componentState === COMPONENT_STATES.individualSuccess">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAn invitation has been sent to <em>{{::formOptions.adminObj.EmailAddress}}</em> for {{formOptions.adminObj.Forename}} to register their account.\n\t\t</p>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tYou now need to make sure you share {{formOptions.adminObj.Forename}}\'s unique verification code with them as they won\'t be able to register without it.\n\t\t\t\tTheir registration link and verification code will expire after 24 hours.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<note note-icon="icon-reference-number" note-title="Share this verification code" note-theme="is-primary is-emphasised primary">\n\t\t\t<note-content>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tShare the below code with {{formOptions.adminObj.Forename}} using a secure method of your choosing.\n\t\t\t\t\t\tPlease don\'t share it with anyone else as they may get access to sensitive data.\n\t\t\t\t\t\tYou can view the code at any time by clicking on the action menu next to {{formOptions.adminObj.Forename}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-state-section has-padding-small">\n\t\t\t\t\t<admin-validation-code code="{{invitation.InvitationVerificationCode}}"></admin-validation-code>\n\t\t\t\t</div>\n\n\t\t\t\t<div>\n\t\t\t\t\t<a class="is-font-primary-400 link-with-icon strong is-small" href="" ng-click="copyVerificationCodeToClipboard(invitation.InvitationVerificationCode)">\n\t\t\t\t\t\t<i class="icon-duplicate"></i>\n\t\t\t\t\t\tCopy to clipboard\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t</note-content>\n\t\t</note>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="componentState === \'COMPONENT_STATES.error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/invite-to-register/invite-to-register.form.html','<loading-block ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.loading"></loading-block>\n\n<!-- Individual invite -->\n<form class="fadeIn" name="inviteToRegisterIndividualForm" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.individualInvite" ng-submit="$ctrl.sendInvitationMailInternal($ctrl, inviteToRegisterIndividualForm)" novalidate>\n\n\t<!-- Has email -->\n\t<div class="form-section" ng-if="::$ctrl.hasEmailAddress">\n\t\t<div class="info-block primary is-compact">\n\t\t\t<p>The invitation will be sent to the email saved in {{$ctrl.teamMember.Personal.Forename}}\'s profile:</p>\n\t\t\t<p class="strong"><em>{{::$ctrl.formOptions.context.EmailAddress}}</em></p>\n\t\t</div>\n\t</div>\n\n\t<!-- No email -->\n\t<div class="form-section" ng-if="::!$ctrl.hasEmailAddress">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\t{{$ctrl.teamMember.Personal.Forename}} doesn\'t have an email address saved in their profile. Enter a valid email address below to\n\t\t\t\tinvite them to register. If you wish to save the email address, you\'ll need to\n\t\t\t\t<a ui-sref="team.profile.overview({agencyProfileId: $ctrl.formOptions.agencyProfileId, userId:$ctrl.teamMember.Personal.UserID})">edit {{$ctrl.teamMember.Personal.Forename}}\'s profile</a>.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<div class="form-intro" ng-if="::$ctrl.hasEmailAddress">\n\t\t<p class="s">\n\t\t\tWant to send it to an alternative email address?\n\t\t\t<a href="" ng-click="$ctrl.toggleAddAlternativeEmail($ctrl)" class="underline">{{$ctrl.addAlternativeEmail ? \'Hide alternative email\' : \'Add an alternative email\'}}</a>\n\t\t</p>\n\t</div>\n\n\t<fieldset class="fadeIn" ng-if="$ctrl.addAlternativeEmail">\n\n\t\t<!-- Email Address -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="email" class="required">{{::$ctrl.hasEmailAddress ? \'Alternative email address\' : \'Email address\'}}</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="email" name="email" ng-model="$ctrl.alternativeEmailAddress" ng-pattern="$root.REGEX.email" placeholder="{{$ctrl.PLACEHOLDERS.email}}" required type="email">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="inviteToRegisterIndividualForm.email.$error" ng-if="inviteToRegisterIndividualForm.email.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid email address</p>\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">This will not overwrite the email in {{$ctrl.teamMember.Personal.Forename}}\'s profile.</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Send invite\'" state="inviteToRegisterIndividualForm.state" disable-button="!inviteToRegisterIndividualForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Bulk invite -->\n<form class="fadeIn" name="inviteToRegisterBulkForm" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.bulkInvite" ng-submit="$ctrl.sendInvitationMailInternalBulk($ctrl, inviteToRegisterBulkForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to send invites?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYou\u2019re about to send registration invitations to <ng-pluralize count="$ctrl.formOptions.userIds.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Confirm\'" state="inviteToRegisterBulkForm.state" disable-button="!inviteToRegisterBulkForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Individual success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{$ctrl.teamMember.Personal.Forename}} has been invited" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.individualSuccess">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAn invitation has been sent to <em>{{$ctrl.sentAddress}}</em> for {{$ctrl.teamMember.Personal.Forename}} to register their account.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Bulk success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="Invites sent" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.bulkSuccess">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tRegistration invitations have been sent to <ng-pluralize count="$ctrl.formOptions.userIds.length" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>.\n\t\t\tOnce they\u2019ve registered for their employee portals, they will be marked as &lsquo;Registered&rsquo;.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/link-element/link-element.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="linkElementForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateLinkElement($ctrl, linkElementForm)" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="linkElementName">Link element name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="linkElementName" name="linkElementName" ng-model="$ctrl.linkElement.LinkElementName" ng-pattern="$root.REGEX.description" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkElementForm.linkElementName.$touched" ng-messages="linkElementForm.linkElementName.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter basic characters only</p>\n\t\t\t\t<p ng-message="required">Please enter a link element name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Change type -->\n\t\t<div class="form-field">\n\t\t\t<change-creator vm="$ctrl.changeCreatorVm"></change-creator>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="$ctrl.changeCreatorVm.newAdjustment.adjustmentType">\n\n\t\t<!-- Toggle -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-disabled="$ctrl.linkElement.isGlobalRateDisabled" field-label="Add global rate" field-model="$ctrl.linkElement.hasGlobalRate" field-name="toggleField" field-on-change="$ctrl.reviewGlobalRate($ctrl)"></toggle-input>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn" ng-if="!$ctrl.linkElement.hasGlobalRate">\t\n\t\t\t\tAdd a global rate so it&apos;s available to all team members. It can be overridden with a different rate when adding link rates for them.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Set global rate (Coming later with Education sector) ->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label\n\t\t\t\t\tclass="required"\n\t\t\t\t\tfor="globalRateOption"\n\t\t\t\t>Set global rate:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select\n\t\t\t\t\tid="globalRateOption"\n\t\t\t\t\tname="globalRateOption"\n\t\t\t\t\tng-model="$ctrl.globalRateOption"\n\t\t\t\t\tng-options="option.id as option.description for option in $ctrl.globalRateOptions"\n\t\t\t\t\trequired\n\t\t\t\t></select>\n\t\t\t</div>\n\t\t\t<div\n\t\t\t\tclass="form-errors fadeIn"\n\t\t\t\tng-if="linkElementForm.selectField.$touched"\n\t\t\t\tng-messages="linkElementForm.selectField.$error"\n\t\t\t\trole="alert"\n\t\t\t>\n\t\t\t\t<p ng-message="required">Please select a type of rate</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">The rate can be overridden with a different rate when adding link rates for a them.</p>\n\t\t</div>\n\n\t\t<!-- Rate -->\n\t\t<div class="form-field" ng-if="$ctrl.linkElement.hasGlobalRate">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="rate">Rate:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="xl monetise" id="rate" name="rate" ng-max="$root.CONFIG.number7Digits4Decimal" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.linkElement.LinkElementRate" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" placeholder="0.00" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkElementForm.rate.$touched" ng-messages="linkElementForm.rate.$error" role="alert">\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits4Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="pattern">Numbers can only have up to 4 decimal places</p>\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Multiplier -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="multiplier" class="required">Multiplier:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<number-selector-field field-name="multiplier" ng-model-options="{\n\t\t\t\t\t\tdebounce:400\n\t\t\t\t\t}" ng-model="$ctrl.linkElement.LinkElementMultiplier" theme="{{$ctrl.changeCreatorVm.newAdjustment.adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}"></number-selector-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkElementForm.multiplier.$touched" ng-messages="linkElementForm.multiplier.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid number</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!linkElementForm.$valid || !$ctrl.changeCreatorVm.newAdjustment.adjustmentType" display-text="$ctrl.formOptions.primaryButtonText" state="linkElementForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Delete -->\n<form class="fadeIn" name="deleteLinkElementForm" ng-if="$ctrl.componentState === \'confirm-delete\'" ng-submit="$ctrl.deleteLinkElement($ctrl, deleteLinkElementForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this link element?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYou&apos;re about to delete the &lsquo;{{$ctrl.linkElement.LinkElementName}}&rsquo; link element and it will no longer be available for &lsquo;Hourly paid&rsquo; team members.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you&apos;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!deleteLinkElementForm.$valid" display-text="\'Delete\'" state="deleteLinkElementForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Adjustment type mismatch -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Unable to edit linked element" ng-if="$ctrl.componentState === \'adjustment-type-mismatch\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThis may be because the pay element used for this linked element needs to be added back into one of the pay element packs assigned to {{$ctrl.formOptions.company.Name}}. Once you\u2019ve done that you\u2019ll be\n\t\t\table to continue editing.\n\t\t</p>\n\t\t<p class="is-small">\n\t\t\tIf the pay element used has been deleted, however, you\u2019ll need to create a new linked element that uses a new pay element, and add new link rates for any affected team members.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/manage-mentions-access/manage-mentions-access.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="manageMentionsAccessForm" ng-submit="$ctrl.updateTeamMemberAdminMentions($ctrl, manageMentionsAccessForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tSelect which admins mentions {{::$ctrl.formOptions.context.Forename}} can access, so they also receive notifications when those other admins are mentioned. If one of these selected admins is mentioned in a company {{::$ctrl.formOptions.context.Forename}} doesn\u2019t have access to, they will not receive a notification.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t\n\t\t<div class="form-field">\n\t\t\t<div class="checkbox-list-header">\n\t\t\t\t<h4 class="checkbox-list-header_title">Bureau Admins</h4>\n\t\t\t\t<div class="inline-links" ng-if="$ctrl.admins.length > 0">\n\t\t\t\t\t<a href ng-click="$ctrl.toggleAllAdmins($ctrl, true)">Select all</a>\n\t\t\t\t\t<a href ng-click="$ctrl.toggleAllAdmins($ctrl, false)">Unselect all</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field team-card-basic_wrapper" ng-if="$ctrl.admins.length > 0">\n\n\t\t\t<team-card-basic team-member="admin" has-checkbox="true" ng-model="admin.HasMentionsAccess" theme="align-actions-right" ng-repeat="admin in $ctrl.admins" on-change="$ctrl.updateIsSelectedForDuplicates($ctrl, admin)">\n\t\t\t\t<tc-actions>\n\t\t\t\t\t<button type="button" class="is-clear" ng-click="admin.HasMentionsAccess = !admin.HasMentionsAccess">\n\t\t\t\t\t\t<icon-dot icon="icon-chat" theme="is-light is-large {{admin.HasMentionsAccess ? \'is-secondary\' : \'is-tertiary\'}}"></icon-dot>\n\t\t\t\t\t</button>\n\t\t\t\t</tc-actions>\n\t\t\t</team-card-basic>\n\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="!$ctrl.admins.length > 0">\n\t\t\t<p class="s"><em>{{$ctrl.formOptions.company.Name}} doesn\'t currently have any bureau team members.</em></p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="manageMentionsAccessForm.state" disable-button="!manageMentionsAccessForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/manage-pay-elements/manage-pay-elements.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- No pay element packs -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'no-pay-element-packs\'">\n\n\t<div class="form-intro">\n\t\t<p class="caption">\n\t\t\t{{$ctrl.formOptions.company.Name}} hasn\'t been assigned any pay element packs. Please contact support to get them set up.\n\t\t</p>\n\t</div>\n</div>\n\n<!-- Pay element packs -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'pay-element-packs\'">\n\n\t<div class="form-intro">\n\t\t<p class="s">{{$ctrl.formOptions.company.Name}} has been assigned the following pay element packs:</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-cards">\n\n\t\t\t<!-- Assigned pay element packs -->\n\t\t\t<div class="pack-item-card primary is-clickable" ng-click="$ctrl.setActivePayElementPackById(payElementPack)" ng-repeat="payElementPack in $ctrl.payElementPacks" ng-switch="$ctrl.payElementState">\n\t\t\t\t<p class="pack-item-card-name">{{payElementPack.AgencyAdjustmentGroupName}}</p>\n\t\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t\t<i class="icon-adjustment m"></i>\n\t\t\t\t\t\t<ng-pluralize count="payElementPack.NumberOfElements" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 element\',\n\t\t\t\t\t\t\t\t\'other\': \'{} elements\'\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t\t<i class="icon-visible m"></i>{{payElementPack.NumberOfElementsVisible}} visible\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\n\t\t\t<!-- Add new pay element pack -->\n\t\t\t<div ng-if="$ctrl.payElementPacksAssignable.length" ng-switch="$ctrl.addPackState">\n\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<button class="is-medium-large is-white is-block fadeIn" type="button" ng-click="$ctrl.setAddPackState(\'adding-pack\')" ng-switch-when="add-pack">\n\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Assign another pack\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<form class="pack-item-card-add-form fadeIn" name="assignPackForm" ng-submit="$ctrl.assignNewPack($ctrl.newPack, assignPackForm)" ng-switch-when="adding-pack" novalidate>\n\t\t\t\t\t<select title="adjustmentGroup" class="pack-item-card-add-select" id="newPackObj" name="newPackObj" ng-model="$ctrl.newPack" ng-options="adjustmentGroup as adjustmentGroup.AgencyAdjustmentGroupName for adjustmentGroup in $ctrl.payElementPacksAssignable track by adjustmentGroup.AgencyAdjustmentGroupID" required>\n\t\t\t\t\t\t<option value="">Select a pack to add...</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<div class="pack-item-card-add-actions">\n\t\t\t\t\t\t<submit-button button-theme="\'is-primary is-fixed\'" disable-button="!assignPackForm.$valid" display-text="\'Assign pack\'" state="assignPackForm.state"></submit-button>\n\t\t\t\t\t\t<a class="button" href="" ng-click="$ctrl.setAddPackState(\'add-pack\')">Cancel</a>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- No assignable pay element packs -->\n\t<div class="form-content-block" ng-if="!$ctrl.payElementPacksAssignable.length">\n\t\t<div class="message-bar inline indifferent">\n\t\t\t<p>There are no additional pay element packs available to assign</p>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Pay element pack -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'pay-element-pack\'">\n\n\t<div class="form-content-block">\n\t\t<a class="link-with-icon greyscale" href="" ng-click="$ctrl.closePayElementPack()">\n\t\t\t<i class="icon-back"></i>Back to packs\n\t\t</a>\n\t</div>\n\n\t<!-- Pay element pack overview -->\n\t<div class="form-content-block">\n\t\t<div class="pack-item-card primary active">\n\t\t\t<h6>{{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}</h6>\n\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-adjustment m"></i>{{$ctrl.activePayElementPack.NumberOfElements}} elements\n\t\t\t\t</li>\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-visible m"></i>{{$ctrl.activePayElementPack.NumberOfElementsVisible}} visible\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<a class="pack-item-card-action" href="" ng-click="$ctrl.setPageState(\'confirm-unassign\')" ng-if="$ctrl.payElementPacks.length > 1">Unassign pack</a>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="is-small">Click on the edit icon to edit element visibility and settings. Your changes will only apply to {{$ctrl.formOptions.company.Name}}.</p>\n\t</div>\n\n\t<div class="form-content-block" ng-if="$ctrl.activePayElementPack.GroupEntries.length > 0">\n\n\t\t<search-bar count="$ctrl.countFilteredPayElements($ctrl.activePayElementPack)" options="$ctrl.searchBarOptions"></search-bar>\n\n\t\t<!-- Pay Element Categories -->\n\t\t<div class="pay-element-type-rows {{payElementPack.theme}}" ng-repeat="payElementPack in $ctrl.activePayElementPack.GroupEntries |\n\t\t\t\torderBy : [\n\t\t\t\t\t\'order\',\n\t\t\t\t\t\'Category\'\n\t\t\t\t]\n\t\t\t" ng-show="payElementPack.payElementsFiltered.length > 0">\n\t\t\t<p class="pay-element-type-row-category">\n\t\t\t\t{{payElementPack.CategoryName}} ({{payElementPack.payElementsFiltered.length}})\n\t\t\t</p>\n\t\t\t<div class="pay-element-type-row-category-group fadeIn">\n\n\t\t\t\t<!-- Pay elements -->\n\t\t\t\t<pay-element-type-row ng-repeat="payElement in payElementPack.payElementsFiltered = (payElementPack.GroupEntries |\n\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\tAgencyAdjustmentGroupEntryText: $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t" on-edit-pay-element="$ctrl.viewPayElement" pay-element-type-group="$ctrl.activePayElementPack" pay-element-type-index="$index" pay-element-type="payElement"></pay-element-type-row>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- No pay elements -->\n\t<placeholder ng-if="$ctrl.activePayElementPack.GroupEntries.length === 0" placeholder-graphic="no-pay-elements">\n\t\t<placeholder-title>There are no pay elements in this pack</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As pay elements are added, they will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Pay element -->\n<form class="fadeIn" name="updatePayElementForm" ng-if="$ctrl.pageState === \'pay-element-type\'" ng-submit="$ctrl.updatePayElement($ctrl.activePayElement, $ctrl.activePayElementPack, updatePayElementForm)" novalidate>\n\n\t<div class="form-content-block">\n\t\t<a class="link-with-icon greyscale" href="" ng-click="$ctrl.closePayElement()">\n\t\t\t<i class="icon-back"></i>Back to pack\n\t\t</a>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="s">\n\t\t\tAny changes you make to the below settings will only apply to {{$ctrl.formOptions.company.Name}} and won\'t affect the &lsquo;{{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}&rsquo;\n\t\t\telement pack.\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<pay-element-type-card class="l" pay-element-type="$ctrl.activePayElement"></pay-element-type-card>\n\t</div>\n\n\t<fieldset>\n\t\t<legend hidden>Pensionable</legend>\n\t\t<div class="settings-rows">\n\n\t\t\t<!-- Pensionable -->\n\t\t\t<settings-row ng-if="::$ctrl.agencyProfileCompanyDetails.IsPensionActive" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionState" on-update="$ctrl.reviewPayElementPension($ctrl.activePayElement)" sr-disabled="::isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.agencyProfileCompanyDetails)" sr-field-name="agencyAdjustmentGroupEntryPensionState" sr-icon="money" sr-theme="quarternary">\n\t\t\t\t<sr-label>Pensionable</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element is included in pay when calculating pension contributions. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element is not included in pay when calculating pension contributions. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t want this pay element to be included when calculating pension contributions for team members.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be included when calculating pension contributions for team members.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\n\t\t\t\t<sr-content ng-if="\n\t\t\t\t\t\t$ctrl.activePayElement.IsSalarySacrifice &&\n\t\t\t\t\t\t$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionState\n\t\t\t\t\t">\n\n\t\t\t \t\t<!-- Pension Salary Sacrifice Behaviour -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth" ng-class="{\n\t\t\t\t\t\t\t\t\t\'is-greyscale\': isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.agencyProfileCompanyDetails)\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tInclude when calculating contributions for:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline is-quarternary">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourBoth" name="paymentScheduleTypePensionBehaviour" ng-disabled="::isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.agencyProfileCompanyDetails)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.both" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourBoth">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Both</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourEmployee" name="paymentScheduleTypePensionBehaviour" ng-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.agencyProfileCompanyDetails)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.employee" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourEmployee">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employee only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourEmployer" name="paymentScheduleTypePensionBehaviour" ng-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.agencyProfileCompanyDetails)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.employer" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourEmployer">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employer only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Net pay -->\n\t\t\t<settings-row ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryNetPayState" on-update="$ctrl.reviewPayElementNetPay($ctrl.activePayElement)" sr-disabled="$ctrl.isPayElementNetPayReadOnly($ctrl.activePayElement)" sr-field-name="agencyAdjustmentGroupEntryNetPayState" sr-icon="wallet" sr-theme="quarternary">\n\t\t\t\t<sr-label>Net Pay calculations</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryNetPayBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element will be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element will not be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don&apos;t want this pay element to be included in pay calculations for team members set to &lsquo;Net Pay&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be included in pay calculations for team members set to &lsquo;Net Pay&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Salary sacrifice -->\n\t\t\t<settings-row ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntrySalarySacrificeState" on-update="$ctrl.reviewPayElementSalarySacrifice($ctrl.activePayElement)" sr-disabled="$ctrl.isPayElementSalarySacrificeReadOnly($ctrl.activePayElement)" sr-field-name="agencyAdjustmentGroupEntrySalarySacrificeState" sr-icon="salary-change" sr-theme="quarternary">\n\t\t\t\t<sr-label>Salary sacrifice calculations</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntrySalarySacrificeBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element is included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element is not included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you do not wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Payroll BIK -->\n\t\t\t<settings-row ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPayrollBIKState" on-update="$ctrl.reviewPayElementPayrollBIK($ctrl.activePayElement)" sr-disabled="$ctrl.isPayElementPayrollBIKReadOnly($ctrl.activePayElement)" sr-field-name="agencyAdjustmentGroupEntryPayrollBIKState" sr-icon="clock" sr-theme="quarternary">\n\t\t\t\t<sr-label>Payroll benefit</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPayrollBIKBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis benefit in kind pay element will not be payrolled. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis benefit in kind pay element will not be payrolled. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you do not want to payroll this benefit each time you run payroll for {{$ctrl.formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want to payroll this benefit each time you run payroll for {{$ctrl.formOptions.company.Name}}.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Holiday Pay -->\n\t\t\t<settings-row ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayState" on-update="$ctrl.reviewPayElementHoliday($ctrl.activePayElement)" sr-disabled="$ctrl.isPayElementHolidayReadOnly($ctrl.activePayElement)" sr-field-name="agencyAdjustmentGroupEntryHolidayState" sr-icon="holiday" sr-theme="quarternary">\n\n\t\t\t\t<sr-label>Holiday Pay</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element will always be included in rolled up holiday pay calculations. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element cannot be included in rolled up holiday pay calculations. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t wish to include these payments in rolled up holiday pay calculations.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you wish to include these payments in rolled up holiday pay calculations.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\n\t\t\t<!-- Prorate -->\n\t\t\t<settings-row ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryProrateState" on-update="$ctrl.reviewPayElementProrate($ctrl.activePayElement)" sr-disabled="$ctrl.isPayElementProrateReadOnly($ctrl.activePayElement)" sr-field-name="agencyAdjustmentGroupEntryProrateState" sr-icon="calendar" sr-theme="quarternary">\n\t\t\t\t<sr-label>Prorate</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryProrateBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element will always be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period. It can\'t be switched OFF.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element cannot be prorated. It can\'t be switched ON.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t want this pay element to be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be prorated for mid-period starters, leavers or when the recurring pay element ends mid-period.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<legend hidden>Visibility</legend>\n\t\t<!-- Holiday Accrued\n\t\t<div class="form-field" ng-if="$ctrl.activePayElement.HolidayState !== $ctrl.ADJUSTMENT_DETAIL_STATES.hidden">\n\t\t\t<div class="field">\n\t\t\t\t<settings-row\n\t\t\t\t\tng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayState"\n\t\t\t\t\tsr-disabled="$ctrl.activePayElement.HolidayState === $ctrl.ADJUSTMENT_DETAIL_STATES.readonly"\n\t\t\t\t\tsr-field-name="agencyAdjustmentGroupEntryHolidayState"\n\t\t\t\t\tsr-icon="holiday"\n\t\t\t\t\tsr-theme="indifferent"\n\t\t\t\t>\n\t\t\t\t\t<sr-label>{{$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayState ? \'Accrues holiday pay\' : \'Doesn\\\'t accrue holiday pay\'}}</sr-label>\n\t\t\t\t\t<sr-description ng-if="$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayState">\n\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t want this pay element to be included when calculating accrued holiday pay for {{$ctrl.formOptions.company.Name}}.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="!$ctrl.activePayElement.AgencyAdjustmentGroupEntryHolidayState">\n\t\t\t\t\t\tSwitch to &lsquo;ON\'&rsquo;if you want this pay element to be included when calculating accrued holiday pay for {{$ctrl.formOptions.company.Name}}.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</div>-->\n\n\t\t<!-- Visibility -->\n\t\t<legend hidden>Visibility</legend>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="payElementVisible">\n\t\t\t\t\tVisibility\n\t\t\t\t</label>\n\t\t\t\t<p class="s">\n\t\t\t\t\tTo quickly hide &lsquo;{{$ctrl.activePayElement.AgencyAdjustmentGroupEntryText}}&rsquo; from {{$ctrl.formOptions.company.Name}}, without removing it from the\n\t\t\t\t\t&lsquo;{{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}&rsquo; element pack, set it to &lsquo;Hidden&rsquo;. You can easily make it visible again later.\n\t\t\t\t</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="payElementVisible" name="schemeType" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryVisible" ng-value="true" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="payElementVisible">\n\t\t\t\t\t\t\t<i class="icon-visible radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Visible</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="payElementNotVisible" name="schemeType" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryVisible" ng-value="false" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="payElementNotVisible">\n\t\t\t\t\t\t\t<i class="icon-hidden radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Hidden</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="!$ctrl.journalFramework.IsReadOnly">\n\t\t<legend hidden>Allocating new pay elements note</legend>\n\t\t<note note-dismiss-key="manage-element-nominal-codes" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Allocating new pay elements to journal codes">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">To use a new pay element in journals, you will need to allocate it to a nominal code in the journal settings area where you wish to use it.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<fieldset ng-if="$ctrl.isAverageHolidayPayEnabled">\n\t\t<legend hidden>52-week average holiday pay note</legend>\n\t\t<note note-dismiss-key="manage-element-52-week-average-holiday-pay" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="52-week average holiday pay settings">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Settings for the 52-week average holiday pay calculation are inherited from the original pay element. To amend them, use the Average Holiday Pay configuration in the Reports &amp; Journals settings area.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.setPageState(\'pay-element-pack\')">Cancel</a>\n\t\t<submit-button disable-button="!updatePayElementForm.$valid" display-text="Save" state="updatePayElementForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm unassign pack -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to unassign this pack?" ng-if="$ctrl.pageState === \'confirm-unassign\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll admins for {{$ctrl.formOptions.company.Name}} will no longer be able to use the pay elements in the {{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}} when adding changes\n\t\t\tto payroll. If you change your mind at a later date you can simply re-assign this pack to {{$ctrl.formOptions.company.Name}}.\n\t\t</p>\n\t\t<p class="s">\n\t\t\t<strong>Please note:</strong> all previous payroll changes for {{$ctrl.formOptions.company.Name}} that used pay elements from the {{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}\n\t\t\twill not be affected and will still appear correctly on payslips and in payroll history.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.setPageState(\'pay-element-pack\')">Back</a>\n\t\t<button class="tertiary primary-action" ng-class="{\n\t\t\t\t\'success\': $ctrl.activePayElementPack.state === \'saved\'\n\t\t\t}" ng-click="$ctrl.unassignAdjustmentGroup($ctrl.activePayElementPack)" ng-disabled="$ctrl.activePayElementPack.state === \'saving\'" ng-switch="$ctrl.activePayElementPack.state">\n\t\t\t<span ng-switch-when="saving"><i class="icon-loading spin"></i></span>\n\t\t\t<span ng-switch-when="saved"><i class="icon-tick"></i></span>\n\t\t\t<span ng-switch-default>Unassign pack</span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/manage-pay-elements-pension/manage-pay-elements-pension.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<!-- No Pay Element Packs -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.formState === \'no-pay-element-packs\'">\n\n\t<div class="form-intro">\n\t\t<p class="caption">\n\t\t\t{{$ctrl.formOptions.company.Name}} hasn\'t been assigned any pay element packs. Please contact support to get them set up.\n\t\t</p>\n\t</div>\n</div>\n\n<!-- Pay Element Packs -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.formState === \'pay-element-packs\'">\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-cards">\n\t\t\t<div class="pack-item-card primary is-clickable" ng-click="$ctrl.setActivePayElementPackById(payElementPack)" ng-repeat="payElementPack in $ctrl.payElementPacks">\n\t\t\t\t<p class="pack-item-card-name">{{payElementPack.AgencyAdjustmentGroupName}}</p>\n\t\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t\t<i class="icon-adjustment m"></i>\n\t\t\t\t\t\t<ng-pluralize count="payElementPack.NumberOfElements" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 element\',\n\t\t\t\t\t\t\t\t\'other\': \'{} elements\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t\t<i class="icon-money m"></i>\n\t\t\t\t\t\t{{payElementPack.NumberOfElementsPensionable}} pensionable\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Pay Element Pack -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.formState === \'pay-element-pack\'">\n\n\t<div class="form-content-block">\n\t\t<a class="link-with-icon greyscale" href="" ng-click="$ctrl.closePayElementPack($ctrl)">\n\t\t\t<i class="icon-back"></i>\n\t\t\t{{$ctrl.formOptions.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment ? \'Back to groups\' : \'Back to bands\'}}\n\t\t</a>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-card primary active">\n\t\t\t<p class="pack-item-card-name">{{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}</p>\n\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-adjustment m"></i>\n\t\t\t\t\t{{$ctrl.activePayElementPack.NumberOfElements}} elements\n\t\t\t\t</li>\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-money m"></i>\n\t\t\t\t\t{{$ctrl.activePayElementPack.NumberOfElementsPensionable}} pensionable\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="caption">\n\t\t\tClick on the edit icon to edit the element\'s pensionable settings. Your changes will only apply to this\n\t\t\t{{$ctrl.formOptions.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment ? \'group\' : \'band\'}}.\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block">\n\n\t\t<search-bar count="$ctrl.countFilteredPayElements($ctrl.activePayElementPack)" options="$ctrl.searchBarOptions"></search-bar>\n\n\t\t<!-- Pay Element Categories -->\n\t\t<div class="pay-element-type-rows {{payElementPack.theme}}" ng-repeat="payElementPack in $ctrl.activePayElementPack.GroupEntries |\n\t\t\t\torderBy : [\n\t\t\t\t\t\'order\',\n\t\t\t\t\t\'Category\'\n\t\t\t\t]\n\t\t\t" ng-show="payElementPack.payElementsFiltered.length > 0">\n\t\t\t<p class="pay-element-type-row-category">\n\t\t\t\t{{payElementPack.CategoryName}} ({{payElementPack.payElementsFiltered.length}})\n\t\t\t</p>\n\t\t\t<div class="pay-element-type-row-category-group fadeIn">\n\t\t\t\t<pay-element-type-row is-pension-only="true" ng-repeat="payElement in payElementPack.payElementsFiltered = (\n\t\t\t\t\t\tpayElementPack.GroupEntries |\n\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\tAgencyAdjustmentGroupEntryText: $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t} |\n\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\')\n\t\t\t\t\t" on-edit-pay-element="$ctrl.viewPayElement" pay-element-type-group="payElementPack" pay-element-type-index="$index" pay-element-type="payElement"></pay-element-type-row>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Pay Element -->\n<form class="fadeIn" name="updatePayElementForm" ng-if="$ctrl.formState === \'pay-element\'" ng-submit="$ctrl.updatePayElement($ctrl, $ctrl.activePayElementPack,  updatePayElementForm)" novalidate>\n\n\t<div class="form-content-block">\n\t\t<a class="link-with-icon greyscale" href="" ng-click="$ctrl.closePayElement()">\n\t\t\t<i class="icon-back"></i>Back to groups\n\t\t</a>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-card primary active">\n\t\t\t<p class="pack-item-card-name">{{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}</p>\n\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-adjustment m"></i>\n\t\t\t\t\t{{$ctrl.activePayElementPack.NumberOfElements}} elements\n\t\t\t\t</li>\n\t\t\t\t<li class="pack-item-card-meta-item">\n\t\t\t\t\t<i class="icon-money m"></i>\n\t\t\t\t\t{{$ctrl.activePayElementPack.NumberOfElementsPensionable}} pensionable\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="is-small">\n\t\t\tAny changes you make to the below settings will only apply to this {{::$ctrl.formOptions.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment ? \'group\' : \'band\'}} and won\'t affect\n\t\t\tthe settings for other {{::$ctrl.formOptions.pension.PensionType === $ctrl.PENSION_TYPES.autoEnrolment ? \'groups\' : \'bands\'}}.\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<pay-element-type-card class="l" pay-element-type="$ctrl.activePayElement"></pay-element-type-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="settings-rows">\n\n\t\t\t<!-- Pensionable -->\n\t\t\t<settings-row ng-if="::$ctrl.formOptions.company.IsPensionActive" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionState" on-update="$ctrl.reviewPayElementPension($ctrl.activePayElement)" sr-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.formOptions.company)" sr-field-name="agencyAdjustmentGroupEntryPensionState" sr-icon="money" sr-theme="quarternary">\n\t\t\t\t<sr-label>Pensionable</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\tThis pay element is included in pay when calculating pension contributions. It can\'t be switched &lsquo;OFF&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\tThis pay element is not included in pay when calculating pension contributions. It can\'t be switched &lsquo;ON&rsquo;.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on">\n\t\t\t\t\t\t\tSwitch to &lsquo;OFF&rsquo; if you don\'t want this pay element to be included when calculating pension contributions for team members.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off">\n\t\t\t\t\t\t\tSwitch to &lsquo;ON&rsquo; if you want this pay element to be included when calculating pension contributions for team members.\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-content ng-if="\n\t\t\t\t\t\t$ctrl.activePayElement.IsSalarySacrifice &&\n\t\t\t\t\t\t$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionState\n\t\t\t\t\t">\n\n\t\t\t \t\t<!-- Pension Salary Sacrifice Behaviour -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth" ng-class="{\n\t\t\t\t\t\t\t\t\t\'is-greyscale\': $ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.formOptions.company)\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tInclude when calculating contributions for:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline is-quarternary">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourBoth" name="paymentScheduleTypePensionBehaviour" ng-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.formOptions.company)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.both" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourBoth">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Both</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourEmployee" name="paymentScheduleTypePensionBehaviour" ng-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.formOptions.company)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.employee" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourEmployee">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employee only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input is-quarternary" id="paymentScheduleTypePensionBehaviourEmployer" name="paymentScheduleTypePensionBehaviour" ng-disabled="::$ctrl.isPayElementPensionableReadOnly($ctrl.activePayElement, $ctrl.formOptions.company)" ng-model="$ctrl.activePayElement.AgencyAdjustmentGroupEntryPensionBehaviourAttributes" ng-value="$ctrl.PAYMENT_SCHEDULE_PENSION_OPTIONS.employer" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="paymentScheduleTypePensionBehaviourEmployer">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Employer only</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!updatePayElementForm.$valid" display-text="Save" state="updatePayElementForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm unassign pack -->\n<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to unassign this pack?" ng-if="$ctrl.formState === \'confirm-unassign\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPayroll admins for {{$ctrl.formOptions.company.Name}} will no longer be able to use the pay elements in the {{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}} when adding changes to\n\t\t\tpayroll. If you change your mind at a later date you can simply re-assign this pack to {{$ctrl.formOptions.company.Name}}.\n\t\t</p>\n\t\t<p class="is-small">\n\t\t\t<strong>Please note:</strong> all previous payroll changes for {{$ctrl.formOptions.company.Name}} that used pay elements from the {{$ctrl.activePayElementPack.AgencyAdjustmentGroupName}}\n\t\t\twill not be affected and will still appear correctly on payslips and in payroll history.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setComponentState(\'pay-element-pack\')">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-class="{\n\t\t\t\t\'success\': $ctrl.activePayElementPack.state === \'saved\'\n\t\t\t}" ng-click="unassignAdjustmentGroup($ctrl.activePayElementPack)" ng-disabled="$ctrl.activePayElementPack.state === \'saving\'">\n\t\t\t<span ng-show="$ctrl.activePayElementPack.state !== \'saving\' && $ctrl.activePayElementPack.state !== \'saved\'">\n\t\t\t\tUnassign pack\n\t\t\t</span>\n\t\t\t<span ng-show="$ctrl.activePayElementPack.state === \'saving\'">\n\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t</span>\n\t\t\t<span ng-show="$ctrl.activePayElementPack.state === \'saved\'">\n\t\t\t\t<i class="icon-tick"></i>\n\t\t\t</span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/manageAdmins/manageAdminsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="form-content-block" ng-if="pageState === \'ready\'">\n\n\t<div class="form-intro align-right" ng-switch="permissionReportDownloadState">\n\t\t<a ng-switch-default href="" ng-click="downloadPermissionsReport()" class="link-with-icon fadeIn primary">\n\t\t\t<i class="icon-download"></i>&nbsp;Permissions report\n\t\t</a>\n\n\t\t<circle-loader ng-switch-when="loading" class="fadeIn" size="s"></circle-loader>\n\t</div>\n\n\t<section class="form-section" ng-switch="formOptions.company.CompanyType">\n\n\t\t<!-- Bureau admins -->\n\t\t<div class="admin-card-group fadeIn" pc-switch-when="INTERFACE_TYPES.bureau" ng-if="::$root.currentUser.Permissions.Admin.canManageBureauAdmins">\n\t\t\t<h5 class="admin-card-group-subtitle">Bureau team</h5>\n\n\t\t\t<!-- Admins -->\n\t\t\t<div class="admin-cards" ng-if="adminGroups.BureauAdmins.length">\n\t\t\t\t<admin-card admin="admin" agency-profile-id="agencyProfileId" callback="refreshAdmins" can-add-to-team="false" can-edit-admin="canEditAdmin" can-manage-mentions-access="true" form-options="formOptions" ng-repeat="admin in adminGroups.BureauAdmins" sso-enabled="ssoEnabled"></admin-card>\n\t\t\t</div>\n\n\t\t\t<!-- No admins -->\n\t\t\t<div class="info-block primary has-plain-type fadeIn" ng-if="!adminGroups.BureauAdmins.length">\n\t\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any bureau team members.</em></p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Group admins -->\n\t\t<div class="admin-card-group fadeIn" pc-switch-when="INTERFACE_TYPES.group" ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroupAdmins">\n\t\t\t<h5 class="admin-card-group-subtitle">Group admins</h5>\n\n\t\t\t<!-- Admins -->\n\t\t\t<div class="admin-cards" ng-if="adminGroups.GroupAdmins.length">\n\t\t\t\t<admin-card admin="admin" agency-profile-id="agencyProfileId" callback="refreshAdmins" can-add-to-team="false" can-edit-admin="canEditAdmin" form-options="formOptions" ng-repeat="admin in adminGroups.GroupAdmins"></admin-card>\n\t\t\t</div>\n\n\t\t\t<!-- No admins -->\n\t\t\t<div class="info-block primary has-plain-type fadeIn" ng-if="!adminGroups.GroupAdmins.length">\n\t\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any group admins.</em></p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company admins -->\n\t\t<div class="admin-card-group fadeIn" ng-switch-default>\n\t\t\t<h5 class="admin-card-group-subtitle">Company admins</h5>\n\n\t\t\t<!-- Admins -->\n\t\t\t<div class="admin-cards" ng-if="adminGroups.CompanyAdmins.length">\n\t\t\t\t<admin-card admin="admin" agency-profile-id="agencyProfileId" callback="refreshAdmins" can-edit-admin="canEditAdmin" can-add-to-team="formOptions.company.CompanyType !== INTERFACE_TYPES.bureau && formOptions.company.CompanyType !== INTERFACE_TYPES.group" form-options="formOptions" ng-repeat="admin in adminGroups.CompanyAdmins"></admin-card>\n\t\t\t</div>\n\n\t\t\t<!-- No admins -->\n\t\t\t<div class="info-block primary has-plain-type fadeIn" ng-if="!adminGroups.CompanyAdmins.length">\n\t\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any company admins.</em></p>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n\n\t<div class="form-actions">\n\t\t<a href="" class="button primary primary-action" ng-click="openAddNewAdminForm()">Add new admin</a>\n\t</div>\n\n</section>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/managePermissions/managePermissionsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="managePermissionsForm" ng-submit="saveForm(vm, managePermissionsForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">{{formOptions.context.Forename}} has the <span class="strong quarternary">{{vm.roleDetail.RoleType | roleTypeMeta:\'name\'}}</span> role and will have those permissions for all companies they have access to. If you need to adjust any permissions, you can do so below and they only apply to {{formOptions.context.Forename}}. To change {{formOptions.context.Forename}}\'s role <a href="" ng-click="openEditAdminForm(vm.roleDetail)" class="underline">edit their details</a>.</p>\n\t</div>\n\n\t<!-- Has role set up -->\n\t<div class="form-content-block" ng-if="vm.roleDetail.Groups.length">\n\t\t<permissions-selector is-valid="vm.isPermissionsValid" permissions-updated="vm.permissionsUpdated" role-detail="vm.roleDetail"></permissions-selector>\n\t</div>\n\n\t<!-- No role set up -->\n\t<div class="form-content-block" ng-if="!vm.roleDetail.Groups.length">\n\t\t<div class="message-bar assertive inline">\n\t\t\t<p class="s">{{formOptions.context.Forename}} doesn\'t have any permissions assigned. Please contact support</p>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a data-cy="secondary-action" href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="managePermissionsForm.state" disable-button="!vm.permissionsUpdated || !vm.isPermissionsValid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/manageVisibility/manageVisibilityForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="manageVisibilityForm" ng-submit="updateUserProfileAgencyProfileVisibleList(vm, manageVisibilityForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">If you wish to hide {{formOptions.company.Name}} from certain admins when they sign in, uncheck them below. This won\'t affect their visibility of any other companies.</p>\n\t</div>\n\n\t<!-- Bureau admins -->\n\t<fieldset ng-if="::$root.currentUser.Permissions.Admin.canManageBureauAdmins" data-cy="bureau-admins-fieldset">\n\t\t\n\t\t<div class="form-field">\n\t\t\t<div class="checkbox-list-header">\n\t\t\t\t<h4 class="checkbox-list-header_title">Bureau Admins</h4>\n\t\t\t\t<div class="inline-links" ng-if="vm.adminGroups.BureauAdmins.length > 0">\n\t\t\t\t\t<a href ng-click="toggleAdminGroup(vm.adminGroups.BureauAdmins, true)">Select all</a>\n\t\t\t\t\t<a href ng-click="toggleAdminGroup(vm.adminGroups.BureauAdmins, false)">Unselect all</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field team-card-basic_wrapper" ng-if="vm.adminGroups.BureauAdmins.length > 0">\n\n\t\t\t<team-card-basic team-member="admin" has-checkbox="true" ng-model="admin.IsCompanyVisible" data-cy="admin-card-visibility-form" theme="align-actions-right" ng-repeat="admin in vm.adminGroups.BureauAdmins" on-change="updateIsSelectedForDuplicates(vm, admin)">\n\t\t\t\t<tc-actions>\n\t\t\t\t\t<button type="button" class="is-clear" ng-click="admin.IsCompanyVisible = !admin.IsCompanyVisible">\n\t\t\t\t\t\t<icon-dot icon="{{admin.IsCompanyVisible ? \'icon-visible\' : \'icon-hidden\'}}" theme="is-light is-large {{admin.IsCompanyVisible ? \'is-secondary\' : \'is-tertiary\'}}"></icon-dot>\n\t\t\t\t\t</button>\n\t\t\t\t</tc-actions>\n\t\t\t</team-card-basic>\n\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="!vm.adminGroups.BureauAdmins.length > 0">\n\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any bureau team members.</em></p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Group admins -->\n\t<fieldset ng-if="::$root.currentUser.Permissions.Admin.canManageCompanyGroupAdmins" data-cy="group-admins-fieldset">\n\n\t\t<div class="form-field">\n\t\t\t<div class="checkbox-list-header">\n\t\t\t\t<h4 class="checkbox-list-header_title">Group Admins</h4>\n\t\t\t\t<div class="inline-links" ng-if="vm.adminGroups.GroupAdmins.length > 0">\n\t\t\t\t\t<a href ng-click="toggleAdminGroup(vm.adminGroups.GroupAdmins, true)">Select all</a>\n\t\t\t\t\t<a href ng-click="toggleAdminGroup(vm.adminGroups.GroupAdmins, false)">Unselect all</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field team-card-basic_wrapper" ng-if="vm.adminGroups.GroupAdmins.length > 0">\n\n\t\t\t<team-card-basic team-member="admin" has-checkbox="true" ng-model="admin.IsCompanyVisible" theme="align-actions-right" ng-repeat="admin in vm.adminGroups.GroupAdmins" on-change="updateIsSelectedForDuplicates(vm, admin)">\n\t\t\t\t<tc-actions>\n\t\t\t\t\t<button type="button" class="is-clear" ng-click="admin.IsCompanyVisible = !admin.IsCompanyVisible">\n\t\t\t\t\t\t<icon-dot icon="{{admin.IsCompanyVisible ? \'icon-visible\' : \'icon-hidden\'}}" theme="is-light is-large {{admin.IsCompanyVisible ? \'is-secondary\' : \'is-tertiary\'}}"></icon-dot>\n\t\t\t\t\t</button>\n\t\t\t\t</tc-actions>\n\t\t\t</team-card-basic>\n\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="!vm.adminGroups.GroupAdmins.length > 0">\n\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any group admins.</em></p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="manageVisibilityForm.state" disable-button="!manageVisibilityForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Visibility settings updated" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">Your visiblity settings for {{formOptions.context.Name}} have been updated.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/removeAdminAccess/removeAdminAccessForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you want to remove {{formOptions.context.Forename}}\'s admin access?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tRemoving admin access for {{formOptions.context.Forename}} will either remove their association to the company or restrict their access to manage payroll,\n\t\t\tif they are an employee. You can always make them an admin again in the future.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action is-tertiary" ng-click="revokeAdminAccess()" ng-disabled="loadingState === \'deleting\'">\n\t\t\tRemove admin access\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/unlinkAccessAccount/unlinkAccessAccountForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to unlink this Access account?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThis will unlink {{formOptions.context.Forename}}\'s Access account from their Paycircle account and the next time they sign in to Paycircle they will need to go through the Access Identity account migration journey again.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action is-tertiary" ng-click="unlinkAccessAccount()" ng-disabled="loadingState === \'deleting\'">\n\t\t\tRemove Access Link\n\t\t</button>\n\t</fs-actions>\n</form-state>\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/resetAuthAccess/resetAuthAccessForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="resetAuthAccessForm" ng-submit="resetAuth(vm, resetAuthAccessForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-title="You are about to reset access for {{fullName}}" fs-show-close="false">\n\t\t<fs-main>\n\t\t\t<div class="form-field">\n\t\t\t\t<main class="form-field-main extended-radio_wrapper">\n\t\t\t\t\t<extended-radio name="resetType" value="RESET_TYPES.tfa" ng-model="vm.resetType">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6 class="is-greyscale-dark">Reset two-factor authentication</h6>\n\t\t\t\t\t\t\t<p class="is-small">This action will allow the admin to rescan the QR code and create a new authenticator account.</p>\n\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t</extended-radio>\n\n\t\t\t\t\t<extended-radio name="resetType" value="RESET_TYPES.lockout" ng-model="vm.resetType">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6 class="is-greyscale-dark">Reset lockout period</h6>\n\t\t\t\t\t\t\t<p class="is-small">This action will reset the lockout period on the account allowing the admin to retry immediately.</p>\n\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</main>\n\t\t\t</div>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Reset access\'" state="resetAuthAccessForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/view-role/view-role.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="viewRoleForm" ng-submit="$ctrl.onSave($ctrl, viewRoleForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-switch="$ctrl.formContext">\n\t\t<h5 pc-switch-when="$ctrl.FORM_CONTEXT.user"><i class="icon-binoculars is-primary l"></i>&nbsp;&nbsp;&nbsp;Viewing as user</h5>\n\t\t<h5 pc-switch-when="$ctrl.FORM_CONTEXT.role"><i class="icon-binoculars is-primary l"></i>&nbsp;&nbsp;&nbsp;Viewing as a {{::$ctrl.permissionRoleDetail.RoleType | permissionRole | lowercase}}</h5>\n\t\t<p class="is-small">View Paycircle exactly as this user does. Your account will temporarily gain the current role and permission set, and you can exit from this at any time. </p>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<ul class="list e">\n\t\t\t<li><i class="icon-roles m is-primary"></i>&nbsp;&nbsp;Your account will temporarily gain the <span class="stronger primary">{{::$ctrl.permissionRoleDetail.RoleType | permissionRole}} role</span></li>\n\t\t\t<li ng-if="::!$ctrl.permissionRoleDetail.IsDefault"><i class="icon-settings m is-primary"></i>&nbsp;&nbsp;Your account will temporarily gain a <span class="stronger primary">custom permission set</span></li>\n\t\t</ul>\n\n\t</div>\n\n\t<div class="form-section">\n\t\t<message-block theme="tertiary is-inline" has-drop-in="false">\n\t\t\t<p ng-switch="$ctrl.formContext">\n\t\t\t\t<i class="icon-warning is-medium is-tertiary has-margin-right"></i>\n\t\t\t\t<span pc-switch-when="$ctrl.FORM_CONTEXT.user">Any changes you make while viewing as this user will be permanent.</span>\n\t\t\t\t<span pc-switch-when="$ctrl.FORM_CONTEXT.role">Any changes you make while viewing as this role will be permanent.</span>\n\t\t\t</p>\n\t\t</message-block>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Continue\'" state="viewRoleForm.state" disable-button="!viewRoleForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-theme="tertiary" fs-icon="warning" fs-title="You can\'t view this users role" ng-if="$ctrl.componentState === \'do-not-have-permission\'">\n\t<fs-main>\n\t\t<p class="is-small">You can only view a role for a user with a permission set lower than yours.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/cis/business-type/cisBusinessTypeForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- CIS - Business -->\n<form name="cisBusinessTypeForm" ng-submit="updateTeamMemberCISBusiness(cisDetails, cisBusinessTypeForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Business Type\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">What type of business does {{formOptions.context.Forename}} run?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="businessType" id="businessTypeSoleTrader" class="radio-card-input" ng-value="BUSINESS_TYPES.soletrader" ng-model="cisDetails.BusinessDetails.BusinessType" required />\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypeSoleTrader">\n\t\t\t\t\t\t\t<i class="icon-user radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Sole trader</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="businessType" id="businessTypePartnership" class="radio-card-input" ng-value="BUSINESS_TYPES.partnership" ng-model="cisDetails.BusinessDetails.BusinessType" required />\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypePartnership">\n\t\t\t\t\t\t\t<i class="icon-team-alt radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Partnership</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t\t-->\n\n\t\t<!-- Trading Name -->\n\t\t<div class="form-field">\n\t\t\t<label for="tradingName" ng-class="{required: cisDetails.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership}">Trading name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="tradingName" name="tradingName" ng-model="cisDetails.BusinessDetails.TradingName" ng-pattern="$root.REGEX.companyName" ng-required="cisDetails.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisBusinessTypeForm.tradingName.$error" ng-if="cisBusinessTypeForm.tradingName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a Trading name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Partnership UTR -->\n\t\t<div class="form-field fadeIn" ng-if="cisDetails.BusinessDetails.BusinessType === BUSINESS_TYPES.partnership">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="partnershipUTR" class="required">Unique Taxpayer reference (UTR) for partnership:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="text" class="m" id="partnershipUTR" name="partnershipUTR" ng-model="cisDetails.BusinessDetails.PartnershipUTR" ng-pattern="$root.REGEX.utr" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisBusinessTypeForm.partnershipUTR.$error" ng-if="cisBusinessTypeForm.partnershipUTR.$touched || cisBusinessTypeForm.$submitted" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a Unique Tax reference number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid Unique Tax reference number</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeWizard()">Close</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="cisBusinessTypeForm.state" disable-button="cisBusinessTypeForm.$invalid"></submit-button>\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/cis/company-contact/cisCompanyContactForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companyContactForm" ng-submit="updateCisCompanyContact(contact, companyContactForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Contact at {{cisCompany.BusinessDetails.TradingName}}</h4>\n\t\t<p class="s">Add details for the main contact at {{cisCompany.BusinessDetails.TradingName}}</p>\n\t</div>\n\n\t<!-- Personal -->\n\t<fieldset>\n\n\t\t<!-- Title -->\n\t\t<div class="form-field">\n\t\t\t<label class="required" for="title">Title:</label>\n\t\t\t<div class="field">\n\t\t\t\t<select id="title" name="title" class="l" ng-model="contact.Title" ng-options="salutation for salutation in SALUTATIONS" required>\n\t\t\t\t\t<option value="">Select title...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyContactForm.title.$error" ng-if="companyContactForm.title.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a title</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Name -->\n\t\t<section class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="contact.Forename" ng-pattern="$root.REGEX.name" minlength="2" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companyContactForm.forename.$error" ng-if="companyContactForm.forename.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Middle name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="middlenames">Middle names:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="middlenames" name="middlenames" ng-model="contact.Middlenames" ng-pattern="$root.REGEX.name">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companyContactForm.middlenames.$error" ng-if="companyContactForm.middlenames.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Middle names can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Last name -->\n\t\t<div class="form-field">\n\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="surname" name="surname" ng-model="contact.Surname" ng-pattern="$root.REGEX.name" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyContactForm.surname.$error" ng-if="companyContactForm.surname.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t<p ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Email -->\n\t\t<div class="form-field">\n\t\t\t<label for="email" ng-class="{\'required\': !contact.DummyEmail, \'disabled\': contact.DummyEmail}">Email address:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="emailPrimary" name="emailPrimary" ng-model="contact.Email" ng-model-options="{ debounce: 500 }" ng-disabled="contact.DummyEmail" ng-required="!contact.DummyEmail">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyContactForm.emailPrimary.$error" ng-show="companyContactForm.emailPrimary.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No Email -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="dummyEmail" name="dummyEmail" ng-model="contact.DummyEmail" ng-change="usingDummyEmail(contact, companyContactForm)" label-text="\'I don\\\'t have an email address at the moment\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companyContactForm.state" disable-button="companyContactForm.$invalid"></submit-button>\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/cis/company-details/cisCompanyDetailsForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- CIS Company Details -->\n<form name="cisCompanyDetailsForm" ng-submit="updateCISCompanyContact(cisCompany, cisCompanyDetailsForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4 class="strong">{{cisCompany.BusinessDetails.BusinessType === BUSINESS_TYPES.company ? \'Limited company details\' : \'Trust details\'}}</h4>\n\t\t<p class="s">Add company details for {{cisCompany.BusinessDetails.TradingName}}</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="cisCompanyName">Company name:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="cisCompanyName" name="cisCompanyName" type="text" ng-model="cisCompany.BusinessDetails.TradingName" placeholder="Type here..." ng-pattern="$root.REGEX.companyName">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisCompanyDetailsForm.cisCompanyName.$error" ng-if="cisCompanyDetailsForm.cisCompanyName.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Only basic characters allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company UTR -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="utr" ng-class="{\'required\': !cisCompany.UTRPending, \'disabled\': cisCompany.UTRPending || formOptions.company.AgencyProfileDummy}">Company Unique Taxpayer reference (UTR):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="text" class="m" id="utr" name="utr" ng-model="cisCompany.UTR" ng-pattern="$root.REGEX.utr" ng-disabled="cisCompany.UTRPending || formOptions.company.AgencyProfileDummy" ng-required="!cisCompany.UTRPending">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisCompanyDetailsForm.utr.$error" ng-if="cisCompanyDetailsForm.utr.$touched || cisCompanyDetailsForm.$submitted" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a Unique Taxpayer reference number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid Unique Taxpayer reference number. It should consist of 10 digits. E.g. 0123456789</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company UTR Pending -->\n\t\t<div class="form-field" ng-if="teamMember.CIS.BusinessDetails.BusinessType !== BUSINESS_TYPES.soletrader">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="utrpending" ng-model="cisCompany.UTRPending" ng-disabled="formOptions.company.AgencyProfileDummy" label-text="\'Waiting for a Company UTR\'" checkbox>\n\t\t\t</div>\n\t\t\t<p class="form-message"><strong>Please note:</strong> if you\'re waiting for the Company UTR, you can come back here to add it later. Company set up won\'t be complete until you\'ve done so.</p>\n\t\t</div>\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field" ng-if="formOptions.company.AgencyProfileDummy">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> UTR numbers are pre-populated for playground companies.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- VAT Registration Number -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="vatRegistrationNumber">VAT registration number:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="text" class="m" id="vatRegistrationNumber" name="vatRegistrationNumber" placeholder="{{$root.PLACEHOLDERS.vatNumber}}" ng-model="cisCompany.VATRegistrationNumber" ng-pattern="$root.REGEX.vat">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisCompanyDetailsForm.vatRegistrationNumber.$error" ng-if="cisCompanyDetailsForm.vatRegistrationNumber.$touched || cisCompanyDetailsForm.$submitted" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a VAT Registration number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid VAT Registration number, E.g. {{::$root.PLACEHOLDERS.vatNumber}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company address -->\n\t\t<div class="form-field">\n\t\t\t<address-lookup address="cisCompany.AddressDetails" is-disabled="cisCompany.addressDetailsPending" is-required="!cisCompany.addressDetailsPending" is-uk-only="true"></address-lookup>\n\t\t</div>\n\n\t\t<!-- Has address -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="hasAddressToggle" name="hasAddressToggle" ng-model="cisCompany.addressDetailsPending" label-text="\'I don\\\'t have the company address at the moment\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeWizard()">Close</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="cisCompanyDetailsForm.state" disable-button="cisCompanyDetailsForm.$invalid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/cis/vat/cisVATForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- CIS - VAT -->\n<form name="cisVATForm" ng-submit="updateTeamMemberCISVAT(cisDetails, cisVATForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Registered for VAT? -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">Is {{formOptions.context.Forename}} registered for VAT?</label>\n\t\t\t\t<p class="s">You\'ll be able to add VAT payments for {{formOptions.context.Forename}} each period</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="isVATRegistered" id="isVATRegisteredTrue" class="radio-card-input" ng-value="true" ng-model="cisDetails.isVATRegistered" required>\n\t\t\t\t\t\t<label class="radio-card-label positive" for="isVATRegisteredTrue">\n\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Yes</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="isVATRegistered" id="isVATRegisteredFalse" class="radio-card-input" ng-value="false" ng-model="cisDetails.isVATRegistered" required>\n\t\t\t\t\t\t<label class="radio-card-label assertive" for="isVATRegisteredFalse">\n\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">No</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- VAT Registration Number -->\n\t\t<div class="form-field fadeIn" ng-if="cisDetails.isVATRegistered">\n\t\t\t<label for="vatRegistrationNumber" class="required">VAT Registration number:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" class="m" id="vatRegistrationNumber" name="vatRegistrationNumber" placeholder="{{$root.PLACEHOLDERS.vatNumber}}" ng-model="cisDetails.VATRegistrationNumber" ng-pattern="$root.REGEX.vat" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisVATForm.vatRegistrationNumber.$error" ng-if="cisVATForm.vatRegistrationNumber.$touched || cisVATForm.$submitted" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a VAT Registration number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid VAT Registration number, E.g. {{::$root.PLACEHOLDERS.vatNumber}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="cisVATForm.state" disable-button="cisVATForm.$invalid"></submit-button>\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/cis/verification/cisVerificationForm.html','\n<loading-block ng-if="pageState === FORM_STATES.loading"></loading-block>\n\n<!-- Verify -->\n<form name="cisVerificationForm" ng-submit="updateTeamMemberCISVerification(vm, cisVerificationForm)" class="fadeIn" ng-if="pageState === FORM_STATES.ready" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Last contracted -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">When did you last contract {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}}?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input type="radio" name="lastContracted" id="lastContracted2Plus" class="b" ng-value="LAST_CONTACTED_OPTIONS.lessThanTwoYears" ng-model="vm.lastContracted">\n\t\t\t\t\t\t<label for="lastContracted2Plus">Less than two years ago</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input type="radio" name="lastContracted" id="lastContracted2Minus" class="b" ng-value="LAST_CONTACTED_OPTIONS.moreThanTwoYears" ng-model="vm.lastContracted">\n\t\t\t\t\t\t<label for="lastContracted2Minus">More than two years ago</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input type="radio" name="lastContracted" id="lastContractedFirst" class="b" ng-value="LAST_CONTACTED_OPTIONS.firstTime" ng-model="vm.lastContracted">\n\t\t\t\t\t\t<label for="lastContractedFirst">This is the first time</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-switch="vm.lastContracted">\n\t\t<h4>Verification</h4>\n\t\t<p class="s" pc-switch-when="LAST_CONTACTED_OPTIONS.lessThanTwoYears">As you\'ve paid {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} within the last two years, you won\'t need to verify them again. You should have existing verification details that you can enter below.</p>\n\t\t<p class="s" ng-switch-default>As it\'s been more than two years since you last contracted {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}}, they will need to be verified. Click \'Verify\' and we\'ll verify {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} using the Tax Office Reference, business type and address you\'ve supplied.</p>\n\t</fieldset>\n\n\t<!-- Contracted less than 2 years ago -->\n\t<fieldset ng-if="vm.lastContracted === LAST_CONTACTED_OPTIONS.lessThanTwoYears">\n\n\t\t<!-- Verification Number -->\n\t\t<div class="form-field">\n\t\t\t<label for="verificationNumber" class="required">Verification number:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" class="m" id="verificationNumber" name="verificationNumber" ng-model="vm.cisDetails.VerificationReference" ng-pattern="$root.REGEX.cisVerification" placeholder="V1234567890" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisVerificationForm.verificationNumber.$error" ng-if="cisVerificationForm.verificationNumber.$touched || cisVerificationForm.$submitted" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a Verification number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid Verification number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Date of last verification -->\n\t\t<div class="form-field">\n\t\t\t<label class="required" for="lastVerificationDate">Date of last verification:</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field field-id="lastVerificationDate" field-min-date-iso="vm.dateVerifiedISOMin" field-max-date-iso="vm.dateVerifiedISOMax" field-value-iso="vm.cisDetails.DateVerifiedISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisVerificationForm.lastVerificationDate.$error" ng-if="cisVerificationForm.lastVerificationDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter the last verification date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="min">Please enter a date within the last 2 years</p>\n\t\t\t\t<p ng-message="max">Please enter a date earlier than today</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Deduction rate -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="deductionRate" class="required">Deduction rate:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="deductionRate" id="deductionRate" ng-model="vm.cisDetails.TaxTreatment" ng-options="option.id as option.name for option in TAX_TREATMENT_OPTIONS" required></select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="cisVerificationForm.deductionRate.$error" ng-if="cisVerificationForm.deductionRate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a day</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-content-block">\n\t\t\t<p class="s">Can\'t find {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}}\'s verification details? Contact support</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- First time or contracted over 2 years ago -->\n\t<fieldset ng-if="vm.lastContracted !== LAST_CONTACTED_OPTIONS.lessThanTwoYears">\n\t\t<div class="form-field">\n\t\t\t<a href="" class="button" ng-click="payrollVerifySubcontractors(vm)" ng-disabled="">Verify</a>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="cisVerificationForm.state" disable-button="cisVerificationForm.$invalid || cisVerificationForm.state === \'saving\' || (vm.lastContracted !== LAST_CONTACTED_OPTIONS.lessThanTwoYears && !vm.cisDetails.IsVerified)"></submit-button>\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<!-- Re-verify -->\n<form-state form-options="formOptions" ng-if="pageState === FORM_STATES.reverify" fs-show-close="false">\n\t<fs-main>\n\n\t\t<div class="form-section">\n\t\t\t<h4 class="form-section-subheading">Re-verification</h4>\n\t\t\t<p class="is-small">Click \u2018Re-verify\' and we\'ll verify {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} using the Tax Office Reference, business type and address you\'ve supplied.</p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<button class="button is-tertiary" ng-click="payrollVerifySubcontractors(vm)">Re-verify</button>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Verifying -->\n<div ng-if="pageState === FORM_STATES.verifying">\n\t<loading-block position="after">\n\t\t<lb-description>We\'re verifying {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}}\'s details.<br>This can take up to 30 seconds to complete</lb-description>\n\t</loading-block>\n</div>\n\n<!-- Verified -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="{{formOptions.context.Forename}}{{ formOptions.isReverify ? \' has been re-verified\' : \' has been verified\'}}" ng-if="pageState === FORM_STATES.verified">\n\t<fs-main>\n\t\t<p class="s">We have verified that {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} is registered for CIS and their details have been updated.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Unable to verify -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="We were unable to {{ formOptions.isReverify ? \'re-verify\' : \'verify\'}} {{formOptions.context.Forename}}" ng-if="pageState === FORM_STATES.verifyFailed">\n\t<fs-main>\n\t\t<p class="s" ng-if="!formOptions.isReverify">We were unable to verify that {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} is registered for CIS. Please check their details and try-again.</p>\n\t\t<p class="s" ng-if="formOptions.isReverify">We were unable to verify that {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} is registered for CIS. Please check their details are correct before coming back to re-verify again.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action" ng-click="setPageState(\'ready\')">Verify again</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Unable to verify -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="We were unable to verify {{formOptions.context.Forename}}" ng-if="pageState === FORM_STATES.notReady">\n\t<fs-main>\n\t\t<p class="s">We were unable to verify that {{::vm.isCompany ? vm.cisDetails.BusinessDetails.TradingName : formOptions.context.Forename}} is registered for CIS. Please add Address and business details before verifying.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === FORM_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/bacs-penny-test/bacs-penny-test.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- BACS penny test -->\n<form name="bacsPennyTestForm" ng-submit="$ctrl.generateTestPaymentFile($ctrl, bacsPennyTestForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Company account</h5>\n\t\t<p class="s">Add details for the bank account where you will upload the BACS file</p>\n\t</div>\n\n\t<!-- Payment File Type -->\n\t<fieldset>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bankBranchName" class="required">Select your bank:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select id="bankBranchName" name="bankBranchName" ng-change="$ctrl.selectBankFileUpdate($ctrl)" ng-model="$ctrl.selectedBankFile" ng-options="bank as bank.BankName for bank in $ctrl.bankFiles track by bank.BankID" required>\n\t\t\t\t\t\t <option value="">Select a bank\u2026</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.bankBranchName.$error" ng-if="bacsPennyTestForm.bankBranchName.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select your bank</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field is-logo-field">\n\t\t\t\t<img src="{{$ctrl.selectedBankFile | bankLogoUrl}}" alt="{{$ctrl.companyBank.BankName | capitalise}}" class="form-field-logo fadeIn" ng-if="$ctrl.selectedBankFile">\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Account Details -->\n\t<fieldset class="fadeIn" ng-if="$ctrl.companyBank.BankFileID !== $root.CONFIG.guidEmpty">\n\n\t\t<!-- Global ACH (Automated Clearing House)  -->\n\t\t<fieldset ng-if="$ctrl.companyBank.IsGdffAvailable">\n\n\t\t\t<!--\n\t\t\t\tClient identifier (also known as GDFF Client Identifier.\n\t\t\t\tWhat is one?: https://tipalti.com/ach-vs-wire/#:~:text=An%20ACH%20transfer%20(a.k.a.%20direct,network%20to%20a%20recipient\'s%20bank.)\n\t\t\t-->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="gdffClientIdentifier" class="required">Client identifier:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="gdffClientIdentifier" maxlength="10" minlength="10" name="gdffClientIdentifier" ng-model="$ctrl.companyBank.GdffClientIdentifier" ng-pattern="$root.REGEX.lettersAndNumbers" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.gdffClientIdentifier.$error" ng-if="bacsPennyTestForm.gdffClientIdentifier.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter only letters and numbers.</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 10 characters</p>\n\t\t\t\t\t<p ng-message="required">Please enter a client identifier.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Customer account number (also know as GDFF Originators Account Number) -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="gdffOriginatorsAccountNumber" class="required">Customer account number:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="gdffOriginatorsAccountNumber" maxlength="10" minlength="10" name="gdffOriginatorsAccountNumber" ng-model="$ctrl.companyBank.GdffOriginatorsAccountNumber" ng-pattern="$root.REGEX.lettersAndNumbers" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.gdffOriginatorsAccountNumber.$error" ng-if="bacsPennyTestForm.gdffOriginatorsAccountNumber.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter an alphanumeric account number.</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 10 characters</p>\n\t\t\t\t\t<p ng-message="required">Please enter an originators account number.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Account Details -->\n\t\t<fieldset ng-if="!$ctrl.companyBank.IsGdffAvailable">\n\n\t\t\t<!-- Account name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bankAccountName" class="required">Account name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="bankAccountName" name="bankAccountName" type="text" ng-model="$ctrl.companyBank.BankAccountName" ng-pattern="$root.REGEX.lettersAndNumbers" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.bankAccountName.$error" ng-if="bacsPennyTestForm.bankAccountName.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a bank account name.</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers and letters only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Account Number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="bankAccountNumber" class="required">Account number:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="m" id="bankAccountNumber" maxlength="8" name="bankAccountNumber" ng-maxlength="8" ng-minlength="8" ng-model="$ctrl.companyBank.BankAccountNumber" ng-pattern="$root.REGEX.numbersOnly" placeholder="12345678" required type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.bankAccountNumber.$error" ng-if="bacsPennyTestForm.bankAccountNumber.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a bank account number</p>\n\t\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 8 digits</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">8 digits, no symbols</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Sort code -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="sortCode" class="required">Sort code:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<sort-code sort-code-name="companyBankSortCode" sort-code="$ctrl.companyBank.SortCode"></sort-code>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="bacsPennyTestForm.companyBankSortCode.$touched" ng-messages="bacsPennyTestForm.companyBankSortCode.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- SUN Number -->\n\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.isSunNumberApplicable($ctrl)">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sunNumber" ng-class="{\'required\': $ctrl.isSunNumberRequired($ctrl)}">SUN Number:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="m" id="sunNumber" maxlength="6" name="sunNumber" ng-maxlength="8" ng-minlength="6" ng-model="$ctrl.companyBank.BACSSUNNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="$ctrl.isSunNumberRequired($ctrl)" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.sunNumber.$error" ng-if="bacsPennyTestForm.sunNumber.$touched" role="alert">\n\t\t\t\t\t<p ng-message="minlength || maxlength">SUN number should be 6 digits</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t<p ng-message="required">Please enter a SUN number</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t</div>\n\n\t\t\t<!-- Bank payment file type -->\n\t \t\t<div class="form-field fadeIn" ng-if="$ctrl.companyBank.IsBACSAvailable && $ctrl.companyBank.IsFPSAvailable">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required">Bank payment file type:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card" ng-if="$ctrl.companyBank.IsBACSAvailable">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="bankPaymentTypeBACS" name="bankPaymentTypeBACS" ng-model="$ctrl.companyBank.BACSFileFormat" ng-value="$ctrl.BANK_FILE_FORMATS.bacs" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="bankPaymentTypeBACS">\n\t\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">BACS</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card" ng-if="$ctrl.companyBank.IsFPSAvailable">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="bankPaymentTypeFPS" name="bankPaymentTypeFPS" ng-model="$ctrl.companyBank.BACSFileFormat" ng-value="$ctrl.BANK_FILE_FORMATS.fps" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="bankPaymentTypeFPS">\n\t\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">FPS</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Using FPS means payments can be made immediately after payroll has been approved whereas BACS requires a 3 day turn around.</p>\n\t\t\t</div>\n\n\t\t\t<!-- IBAN -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="companyBankIBAN">\n\t\t\t\t\t\tIBAN:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="companyBankIBAN" maxlength="50" name="companyBankIBAN" ng-model="$ctrl.companyBank.BankIBAN" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- BIC -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="companyBankBIC">\n\t\t\t\t\t\tBIC:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l" id="companyBankBIC" name="companyBankBIC" ng-model="$ctrl.companyBank.BankBIC" ng-pattern="$root.REGEX.bic" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="bacsPennyTestForm.companyBankBIC.$touched" ng-messages="bacsPennyTestForm.companyBankBIC.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid BIC</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Payment Reference -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bacsPaymentReference" class="required">Payment reference:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="text" id="bacsPaymentReference" name="bacsPaymentReference" ng-model="$ctrl.companyBank.BACSPaymentReference" ng-pattern="$root.REGEX.lettersAndNumbers" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.bacsPaymentReference.$error" ng-if="bacsPennyTestForm.bacsPaymentReference.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a payment reference</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter letters or numbers only</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">This will be used as the reference for all payments included in the BACS file</p>\n\t\t\t</div>\n\n\t\t\t<!-- Bank Template Reference -->\n\t\t\t<div class="form-field" ng-if="$ctrl.selectedBankFile.ShowTemplateReference">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bacsTemplateReference" class="required">Template reference:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="text" id="bacsTemplateReference" name="bacsTemplateReference" ng-model="$ctrl.companyBank.BankTemplateReference" ng-pattern="$root.REGEX.lettersAndNumbers" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.bacsTemplateReference.$error" ng-if="bacsPennyTestForm.bacsTemplateReference.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a template reference</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter letters or numbers only</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">This is the Template Reference or Bulk List from which to make payments</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Payee Account -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Payee account</h5>\n\t\t\t<p class="is-small">Add details for the bank account the penny payment should be made to and the date it should be made</p>\n\t\t</div>\n\n\t\t<!-- Account name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="payeeAccountName" class="required">Account name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="payeeAccountName" name="payeeAccountName" type="text" ng-model="$ctrl.payeeBank.BankAccountName" ng-pattern="$root.REGEX.lettersAndNumbers" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.payeeAccountName.$error" ng-if="bacsPennyTestForm.payeeAccountName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an account name.</p>\n\t\t\t\t<p ng-message="pattern">Please enter numbers and letters only</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Account Number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="payeeAccountNumber" class="required">Account number:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="m" id="payeeAccountNumber" maxlength="8" name="payeeAccountNumber" ng-maxlength="8" ng-minlength="8" ng-model="$ctrl.payeeBank.BankAccountNumber" ng-pattern="$root.REGEX.numbersOnly" placeholder="12345678" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.payeeAccountNumber.$error" ng-if="bacsPennyTestForm.payeeAccountNumber.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an account number</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 8 digits</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">8 digits, no symbols</p>\n\t\t\t</div>\n\n\t\t\t<!-- Sort code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="payee-sortcodea" class="required">Sort code:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<sort-code sort-code-name="payeeSortCode" sort-code="$ctrl.payeeBank.SortCode"></sort-code>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="bacsPennyTestForm.payeeSortCode.$touched" ng-messages="bacsPennyTestForm.payeeSortCode.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- IBAN -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="bankIBAN">\n\t\t\t\t\tIBAN:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="payeeBankIBAN" maxlength="50" name="bankIBAN" ng-model="$ctrl.payeeBank.BankIBAN" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- BIC -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="payeeBankBIC">\n\t\t\t\t\tBIC:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="payeeBankBIC" name="payeeBankBIC" ng-model="$ctrl.payeeBank.BankBIC" ng-pattern="$root.REGEX.bic" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="bacsPennyTestForm.payeeBankBIC.$touched" ng-messages="bacsPennyTestForm.payeeBankBIC.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid BIC</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Payment date -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="paymentDate" class="required">Payment date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="paymentDate" field-style="m" field-value-iso="$ctrl.payeeBank.bacsPaymentDateIso">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bacsPennyTestForm.paymentDate.$error" ng-if="bacsPennyTestForm.paymentDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a payment date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Next\'" state="bacsPennyTestForm.state" disable-button="bacsPennyTestForm.$invalid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Generated -->\n<div ng-if="$ctrl.pageState === \'generated\'">\n\n\t<div class="spacer xxl"></div>\n\n\t<download-link-card text="Download BACS file" url="$ctrl.bacsDownloadUrl"></download-link-card>\n\n\t<div class="spacer l"></div>\n\n\t<bank-summary-card bank="$ctrl.companyBank" bank-title="Company account" on-edit="$ctrl.setPageState(\'ready\')">\n\t</bank-summary-card>\n\n\t<div class="spacer s"></div>\n\n\t<bank-summary-card bank="$ctrl.payeeBank" bank-title="Payee account" on-edit="$ctrl.setPageState(\'ready\')">\n\t</bank-summary-card>\n\n</div>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/addPayslipLabel/addPayslipLabelForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addPayslipLabelForm" ng-submit="createNewAdjustmentLabel(newAdjustmentLabel.adjustmentLabel, addPayslipLabelForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Payslip labels are always associated with a payroll change type. Choose a type of change before giving your label a name.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="pill-input-field primary" ng-class="{\'assertive\': newAdjustmentLabel.adjustmentType && newAdjustmentLabel.adjustmentType.Category === \'Deductions\', \'positive\': newAdjustmentLabel.adjustmentType && newAdjustmentLabel.adjustmentType.Category !== \'Deductions\', \'active\': newAdjustmentLabel.searchTermAdjustmentTypesFocused}">\n\t\t\t<label for="searchTermAdjustmentTypes" class="pill-input-field-label"><i class="icon-adjustment"></i> Type of change</label>\n\t\t\t<input class="pill-input-field-input fadeIn" name="searchTermAdjustmentTypes" id="searchTermAdjustmentTypes" type="text" ng-focus="toggleSearchTermFocus(newAdjustmentLabel, true)" ng-blur="toggleSearchTermFocus(newAdjustmentLabel, false)" placeholder="Search for a change" ng-model="newAdjustmentLabel.searchTermAdjustmentTypes" ng-if="!newAdjustmentLabel.adjustmentType">\n\t\t\t<div class="pill-input-field-item fadeIn" ng-if="newAdjustmentLabel.adjustmentType">\n\t\t\t\t<span>{{newAdjustmentLabel.adjustmentType.AgencyAdjustmentGroupEntryText}}</span>\n\t\t\t\t<a href="" ng-click="resetActiveAdjustmentType(newAdjustmentLabel)" class="pill-input-field-item-delete" aria-label="Reset selected change type"><i class="icon-plus"></i></a>\n\t\t\t</div>\n\n\t\t\t<div class="pill-input-search-results dropIn" ng-show="newAdjustmentLabel.searchTermAdjustmentTypes.length > 3">\n\n\t\t\t\t<!-- Changes -->\n\t\t\t\t<div class="pill-input-search-results-group primary">\n\t\t\t\t\t<p class="pill-input-search-results-subheading">Changes</p>\n\t\t\t\t\t<button type="button" class="is-clear pill-input-search-result {{adjustmentType.Category === \'Deductions\' ? \'assertive\' : \'positive\'}} clickable" ng-click="setActiveAdjustmentType(adjustmentType)" ng-repeat="adjustmentType in filteredAdjustmentTypes = ( adjustmentTypes | filter: newAdjustmentLabel.searchTermAdjustmentTypes ) | orderBy: \'AgencyAdjustmentGroupEntryText\' ">\n\t\t\t\t\t\t<span class="pill-input-search-result-icon"><i class="icon-{{adjustmentType.Category === \'Deductions\' ? \'minus\' : \'add\'}}"></i></span>\n\t\t\t\t\t\t<p class="pill-input-search-result-description">{{adjustmentType.AgencyAdjustmentGroupEntryText}}</p>\n\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t</button>\n\t\t\t\t\t<p ng-if="!filteredAdjustmentTypes.length">\uD83D\uDE23 <span class="caption">No changes found</span></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="!newAdjustmentLabel.adjustmentType">\n\n\t\t<section class="form-section">\n\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t<a href="" ng-click="changeTab(\'additions\')" ng-class="{\'active\': activeTab === \'additions\'}">Additions</a>\n\t\t\t\t<a href="" ng-click="changeTab(\'deductions\')" ng-class="{\'active\': activeTab === \'deductions\'}">Deductions</a>\n\t\t\t</nav>\n\t\t</section>\n\n\t\t<section class="form-section">\n\t\t\t<div class="pay-element-type-cards split">\n\t\t\t\t<pay-element-type-card class="clickable basic fadeIn" pay-element-type="adjustmentType" ng-click="setActiveAdjustmentType(adjustmentType)" ng-repeat="adjustmentType in adjustmentTypes | filter : deductionFilter | orderBy: \'AgencyAdjustmentGroupEntryText\' | limitTo: newAdjustmentLabel.searchResultsLimit"></pay-element-type-card>\n\t\t\t</div>\n\t\t</section>\n\t\t\n\t\t<section class="form-section align-center" ng-if="newAdjustmentLabel.searchResultsLimit">\n\t\t\t<a href="" class="button white" ng-click="showAllResults(newAdjustmentLabel)"><i class="icon-add m"></i>&nbsp;&nbsp;Show all</a>\n\t\t</section>\n\t</fieldset>\n\n\t<fieldset class="form-section" ng-if="newAdjustmentLabel.adjustmentType">\n\n\t\t<div class="pill-input-field {{newAdjustmentLabel.adjustmentType.Category === \'Deductions\' ? \'assertive\' : \'positive\'}} {{newAdjustmentLabel.adjustmentLabelInputActive ? \'active\' : \'\'}}">\n\t\t\t<label for="newAdjustmentLabel" class="pill-input-field-label"><i class="icon-label"></i> Label name</label>\n\t\t\t<input class="pill-input-field-input" name="newAdjustmentLabel" id="newAdjustmentLabel" type="text" placeholder="Enter a label name" maxlength="40" ng-model="newAdjustmentLabel.adjustmentLabel.AgencyAdjustmentLabelText" ng-focus="toggleLabelInputFocus(newAdjustmentLabel, true)" ng-blur="toggleLabelInputFocus(newAdjustmentLabel, false)" ng-pattern="$root.REGEX.description">\n\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="addPayslipLabelForm.newAdjustmentLabel.$error" ng-if="addPayslipLabelForm.newAdjustmentLabel.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addPayslipLabelForm.state" disable-button="!addPayslipLabelForm.$valid" ng-if="newAdjustmentLabel.adjustmentType"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/billing-enabled/billingEnabledForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="billingEnabledForm" ng-submit="updateIsBillingEnabled(formOptions.company.IsBillingEnabled, billingEnabledForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Radio Cards -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="">Is Billing enabled?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="billingEnabled" id="billingEnabledTrue" class="radio-card-input" ng-value="true" ng-model="formOptions.company.IsBillingEnabled" required>\n\t\t\t\t\t\t<label class="radio-card-label positive" for="billingEnabledTrue">\n\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Yes</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="billingEnabled" id="billingEnabledFalse" class="radio-card-input" ng-value="false" ng-model="formOptions.company.IsBillingEnabled" required>\n\t\t\t\t\t\t<label class="radio-card-label assertive" for="billingEnabledFalse">\n\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">No</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Bureau\'s -->\n \t\t<div class="form-field" ng-if="formOptions.company.CompanyType === INTERFACE_TYPES.bureau">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="strong"><i class="icon-money indifferent m"></i>&nbsp;&nbsp;Enabling Billing for Bureaus</h6>\n\t\t\t\t<p>If you enable/disable billing for a bureau then all companies within that bureau will inherit the same billing settings, unless specifically set for a company.</p>\n\t\t\t</div>\n \t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="billingEnabledForm.state" disable-button="!billingEnabledForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/bulkAddToCompanyGroup/bulkAddToCompanyGroupForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section ng-if="pageState === \'ready\'">\n\n\t<!-- Company Context -->\n\t<section class="form-context fadeIn">\n\t\t<i class="icon-company form-context-icon"></i>\n\t\t<p class="form-context-name"><ng-pluralize count="agencyProfileIdList.length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize></p>\n\t</section>\n\n\t<form name="addCompaniesToCompanyGroupForm" ng-submit="addCompaniesToCompanyGroup(model.companyGroup, addCompaniesToCompanyGroupForm)" class="fadeIn" novalidate>\n\n\t\t<!-- Add to Company Group -->\n\t\t<fieldset ng-if="availableGroups.length">\n\n\t\t\t<!-- Company groups -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="companyGroup" class="required">Add to a group:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select id="companyGroup" name="companyGroup" ng-model="model.companyGroup" ng-options="availableGroup as availableGroup.Company.Name for availableGroup in availableGroups" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="addCompaniesToCompanyGroupForm.companyGroup.$error" ng-if="addCompaniesToCompanyGroupForm.companyGroup.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a group</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Close -->\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t\t<!-- Make existing user admin -->\n\t\t\t<button class="tertiary primary-action" ng-disabled="!addCompaniesToCompanyGroupForm.$valid || addCompaniesToCompanyGroupForm.state" ng-if="availableGroups.length">\n\t\t\t\t<span ng-show="!addCompaniesToCompanyGroupForm.state">Add to group</span>\n\t\t\t\t<span ng-show="addCompaniesToCompanyGroupForm.state"><i class="icon-loading spin"></i></span>\n\t\t\t</button>\n\t\t</fieldset>\n\t</form>\n</section>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Added to group" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p><ng-pluralize count="agencyProfileIdList.length" when="{\'1\': \'1 company has\', \'other\': \'{} companies have\'}"></ng-pluralize>&nbsp;been added to <a ui-sref="companies({agencyProfileParentId: model.companyGroup.Company.AgencyProfileID})" class="strong">{{model.companyGroup.Company.Name}}</a>.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Partial success state because not all companies were successfully linked to the org -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Couldn\'t add all companies" ng-if="pageState === \'partial-success\'">\n\t<fs-main>\n\t\t<!-- Successful companies -->\n\t\t<div ng-if="successfulCompanies.length > 0">\n\t\t\t<div ng-repeat="company in successfulCompanies">\n\t\t\t\t<p class="s">\'{{company.name}}\' have been successfully added to this group.</p>\n\t\t\t</div>\n\t\t\t<br>\n\t\t</div>\n\t\t<!-- Failed companies -->\n\t\t<div ng-if="failedCompanies.length > 0">\n\t\t\t<p class="s">The following companies couldn\'t be added to this group:</p>\n\t\t\t<br>\n\t\t\t<bullet-list bl-theme="is-small is-tertiary">\n\t\t\t\t<bl-items>\n\t\t\t\t\t<li class="bullet-list_item" ng-repeat="company in failedCompanies">\n\t\t\t\t\t\t<span ng-if="company.reason === \'missing\'">{{company.name}} - Missing a customer code</span>\n\t\t\t\t\t\t<span ng-if="company.reason === \'mismatch\'">{{company.name}} - Customer code {{company.customerCode}} doesn\'t match the customer code for this group {{organisationCustomerCode}}</span>\n\t\t\t\t\t</li>\n\t\t\t\t</bl-items>\n\t\t\t</bullet-list>\n\t\t\t<br>\n\t\t\t<p class="s">Go to the \'Customer codes\' area in your bureau settings to ensure a company has the right code before trying again.</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/business-code/business-code.form.html','<loading-block ng-if="pageState === BUSINESS_CODE_FORM_STATES.loading"></loading-block>\n\n<!-- Add / edit business code (category) -->\n<form class="fadeIn" name="businessCodeCreateForm" ng-if="pageState === BUSINESS_CODE_FORM_STATES.create" ng-submit="updateBusinessCategory(vm, businessCodeCreateForm)" novalidate>\n\n\t<div class="form-intro" ng-switch="formOptions.formState">\n\t\t<p class="s">You can add team members from your Business categories area or in the company details area for team members.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Business Code / Category name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="businessCodeNarrative" class="required">{{vm.businessCategory.businessCategoryNameCapitalised}} name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="businessCodeNarrative" maxlength="30" name="businessCodeNarrative" ng-change="validateBusinessCodeNarrative(vm)" ng-model="vm.businessCode.BusinessCodeNarrative" placeholder="E.g. Accounts, HR etc" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="businessCodeCreateForm.businessCodeNarrative.$invalid && businessCodeCreateForm.businessCodeNarrative.$touched" ng-messages="businessCodeCreateForm.businessCodeNarrative.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a {{vm.businessCategory.businessCategoryNameCapitalised}} name</p>\n\t\t\t\t<p ng-message="maxlength">{{vm.businessCategory.businessCategoryNameCapitalised}} names can be no longer than 30 characters</p>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="!vm.businessCode.isValid" role="alert">\n\t\t\t\t<p>There\'s already a business category with that name, please choose another</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">Maximum of 30 characters</p>\n\t\t</div>\n\n\t\t<!-- Journal code -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="journalCode">Journal code:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="journalCode" name="journalCode" ng-model="vm.businessCode.BusinessCodeValue" type="text">\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="businessCodeCreateForm.state" disable-button="businessCodeCreateForm.$invalid || !vm.businessCode.isValid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm delete  -->\n<form class="fadeIn" name="deleteForm" ng-if="pageState === BUSINESS_CODE_FORM_STATES.delete" ng-submit="updateBusinessCategory(vm, deleteForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to delete this category?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that deleting &lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; may affect any business category overrides for hourly rates and payroll changes you have saved for team members. Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue. \n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Confirm\'" state="saving"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Manage team members -->\n<form class="fadeIn" name="manageTeamMembersForm" ng-if="pageState === BUSINESS_CODE_FORM_STATES.manageTeamMembers" ng-submit="updateBusinessCodeMembers(vm, manageTeamMembersForm)" novalidate>\n\n\t<section class="form-section">\n\t\t<business-code-card business-category="vm.businessCategory" business-code="vm.businessCode"></business-code-card>\n\t</section>\n\n\t<section class="form-section" ng-if="vm.businessCode.UserAgencyProfileBusinessCodeCount > 0">\n\t\t<div class="form-intro">\n\t\t\t<p>\n\t\t\t\t<ng-pluralize count="vm.businessCode.UserAgencyProfileBusinessCodeCount" when="{\'1\': \'1 team member is\', \'other\': \'{} team members are\'}"></ng-pluralize>&nbsp;currently allocated to\n\t\t\t\t&lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo;. Click on &lsquo;Move&rsquo; if you wish to move them to a different {{vm.businessCategory.businessCategoryNameLowercase}},\n\t\t\t\tthen click &lsquo;Save&rsquo; to confirm.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<section class="form-section team-card-basic_wrapper rows">\n\n\t\t\t\t<team-card-basic ng-repeat="teamMember in vm.teamMembers | orderBy: [\'Forename\', \'Surname\', \'isAdditionalPost\']" show-footer="teamMember.isEditing" show-icon="teamMember.isAdditionalPost" team-member="teamMember" is-name-clickable="false">\n\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t<a class="team-card-basic_action link-with-icon strong is-font-primary-400" href="" ng-click="toggleIsEditing(vm, teamMember)" ng-if="!teamMember.HasCostSplit">\n\t\t\t\t\t\t\t<span class="fadeIn" ng-if="!teamMember.isEditing">\n\t\t\t\t\t\t\t\t<i class="icon-switch is-smedium"></i>Move\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="fadeIn" ng-if="teamMember.isEditing">\n\t\t\t\t\t\t\t\t<i class="icon-cross is-smedium"></i>Cancel\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<div class="team-member-has-cost-split tag" ng-if="teamMember.HasCostSplit" tooltip tooltip-position="left" tooltip-text="Team members can&apos;t be moved while they\'re using a category for a cost split">\n\t\t\t\t\t\t\t<i class="icon-padlock"></i>\n\t\t\t\t\t\t\tCOST SPLIT\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</tc-actions>\n\n\t\t\t\t\t<tc-icon>\n\t\t\t\t\t\t<icon-dot icon="icon-setup-user" theme="is-primary is-light has-hover" tooltip-position="left" tooltip-text="{{teamMember.PostTitle}}"></icon-dot>\n\t\t\t\t\t</tc-icon>\n\n\t\t\t\t\t<tc-footer>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="{{\'business-code\' + $index}}" class="required">Move to:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<select id="{{\'business-code-\' + $index}}" name="{{\'business-code-\' + $index}}" ng-change="updateTeamMemberBusinessCode(vm, teamMember)" ng-model="teamMember.moveToBusinessCode" ng-options="businessCode.BusinessCodeID as businessCode.BusinessCodeNarrative for businessCode in vm.businessCategory.BusinessCodes\n\t\t\t\t\t\t\t\t\t\t| filter: { BusinessCodeID : \'!\' + vm.businessCode.BusinessCodeID }\n\t\t\t\t\t\t\t\t\t\t| orderBy: [\'-IsUnallocatedBusinessCode\', \'BusinessCodeNarrative\']\n\t\t\t\t\t\t\t\t\t" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="manageTeamMembersForm[\'business-code-\' + $index].$error" ng-if="manageTeamMembersForm[\'business-code-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select a {{vm.businessCategory.businessCategoryNameLowercase}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</tc-footer>\n\t\t\t\t</team-card-basic>\n\n\t\t\t</section>\n\t\t</fieldset>\n\n\t</section>\n\n\t<section class="form-section" ng-if="vm.businessCode.UserAgencyProfileBusinessCodeCount === 0">\n\n\t\t<placeholder placeholder-graphic="team" ng-if="vm.businessCode.IsUnallocatedBusinessCode">\n\t\t\t<placeholder-title>All team members have been allocated to a {{vm.businessCategory.businessCategoryNameLowercase}}</placeholder-title>\n\t\t</placeholder>\n\n\t\t<placeholder placeholder-graphic="team" ng-if="!vm.businessCode.IsUnallocatedBusinessCode">\n\t\t\t<placeholder-title>There are no team members in {{vm.businessCode.BusinessCodeNarrative}}</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>You can add a team member to this category by moving them from another category or by going to the &lsquo;Information&rsquo; area in their profile and updating their company details.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t</section>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!vm.hasChangeBeenMade" display-text="formOptions.primaryButtonText" state="manageTeamMembersForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Manage visibility -->\n<form class="fadeIn" name="manageVisibilityForm" ng-if="pageState === BUSINESS_CODE_FORM_STATES.manageVisibility" ng-submit="updateAgencyDepartmentVisible(vm, manageVisibilityForm)" novalidate>\n\n\t<section class="form-section">\n\t\t<business-code-card business-category="vm.businessCategory" business-code="vm.businessCode"></business-code-card>\n\t</section>\n\n\t<section class="form-section" ng-if="vm.departmentAdmins.length > 0">\n\n\t\t<div class="form-intro">\n\t\t\t<p>The below department admins can see &lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo;. Uncheck any admins you wish to hide it from and the respective team members won\u2019t be visible to them when they sign in.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Department admin -->\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="checkbox-list-header">\n\t\t\t\t\t<h6 class="checkbox-list-header_title">Department admins</h6>\n\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t<a href ng-click="toggleDepartmentVisibility(vm, true)">Select all</a>\n\t\t\t\t\t\t<a href ng-click="toggleDepartmentVisibility(vm, false)">Unselect all</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="form-field team-card-basic_wrapper">\n\n\t\t\t\t\t<team-card-basic has-checkbox="true" ng-model="admin.IsVisible" ng-repeat="admin in vm.departmentAdmins" on-change="updateHasChangeBeenMade(vm)" team-member="admin" theme="align-actions-right">\n\t\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t\t<button type="button" class="is-icon-only is-clear" ng-click="admin.IsVisible = !admin.IsVisible">\n\t\t\t\t\t\t\t\t<icon-dot icon="{{admin.IsVisible ? \'icon-visible\' : \'icon-hidden\'}}" theme="is-light is-large {{admin.IsVisible ? \'is-secondary\' : \'is-tertiary\'}}"></icon-dot>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</tc-actions>\n\t\t\t\t\t</team-card-basic>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field-main" ng-if="!vm.departmentAdmins.length > 0">\n\t\t\t\t\t<p class="s"><em>{{formOptions.company.Name}} doesn\'t currently have any department admins.</em></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\t</section>\n\n\t<div class="form-section" ng-if="vm.departmentAdmins.length === 0">\n\t\t<placeholder placeholder-graphic="no-admins">\n\t\t\t<placeholder-title>No department admins</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\tOnce you\'ve set up department admins for {{formOptions.company.Name}}, you\'ll be able to manage visibility of this department.\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions ng-if="$root.currentUser.Permissions.CompanySettings.canAccessPermissions">\n\t\t\t\t<a ui-sref="settings.company.admins({agencyProfileId: formOptions.agencyProfileId})">\n\t\t\t\t\tGo to Admins<i class="icon-chevron-right has-margin-left"></i>\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="manageVisibilityForm.state" disable-button="manageVisibilityForm.$invalid || !vm.hasChangeBeenMade"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Created -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Category created" ng-if="pageState === BUSINESS_CODE_FORM_STATES.created">\n\t<fs-main>\n\t\t<p class="s">The &lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; category has been created.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Deleted -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Category deleted" ng-if="pageState === BUSINESS_CODE_FORM_STATES.deleted">\n\t<fs-main>\n\t\t<p class="s">The &lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; category has been deleted.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Team updated -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Category updated" ng-if="pageState === BUSINESS_CODE_FORM_STATES.teamUpdated">\n\t<fs-main>\n\t\t<p class="s">&lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; has been updated with your team member changes.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Visibility updated -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Category updated" ng-if="pageState === BUSINESS_CODE_FORM_STATES.visibilityUpdated">\n\t<fs-main>\n\t\t<p class="s">&lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; has been updated.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot delete -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This category is in use" ng-if="pageState === BUSINESS_CODE_FORM_STATES.cannotDelete">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t&lsquo;{{vm.businessCode.BusinessCodeNarrative}}&rsquo; can\'t be deleted as it\'s currently being used by team members as their home category or for a cost split. Those team members will need to be removed from this category before it can be deleted.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === BUSINESS_CODE_FORM_STATES.error"></error-block>\n');
$templateCache.put('forms/company/companyBankDetails/companyBankDetailsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="directDebitForm" ng-submit="updateCompanyDirectDebitMandateBank(directDebit, directDebitForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Updating your Direct Debit bank details will require authorisation, which can take a couple of days. Once authorised, the new details will take effect when your next payment is made.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Account name -->\n\t\t<div class="form-field">\n\t\t\t<label for="accountName" class="required">Account name</label>\n\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="accountName" name="accountName" ng-model="directDebit.Bank.BankAccountName" ng-pattern="$root.REGEX.name" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.accountName.$error" ng-show="directDebitForm.accountName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an account name</p>\n\t\t\t\t<p ng-message="pattern">Please enter simple characters only</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Account number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="accountNumber" class="required">Account number</label>\n\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="accountNumber" class="m" name="accountNumber" ng-model="directDebit.Bank.BankAccountNumber" maxlength="8" ng-minlength="8" ng-maxlength="8" placeholder="12345678" ng-pattern="$root.REGEX.numbersOnly" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.accountNumber.$error" ng-show="directDebitForm.accountNumber.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an account number</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">The account number should be 8 digits long</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Sort code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sortcodeA" class="required">Sort code</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<sort-code sort-code-name="sortCode" sort-code="directDebit.Bank.SortCode"></sort-code>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="directDebitForm.sortCode.$touched" ng-messages="directDebitForm.sortCode.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- The legal bit -->\n\t<fieldset class="form-fieldset-divider-top">\n\t\t<div class="direct-debit-legalities">\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">{{$root.CONFIG.companyName}}</p>\n\t\t\t\t<p class="s">{{$root.CONFIG.companyAddress}}</p>\n\t\t\t\t<p class="s"><a href="tel:{{$root.CONFIG.companyPhoneNumber}}">{{$root.CONFIG.companyPhoneNumber}}</a>, <a href="mailto:{{$root.CONFIG.companyEmail}}">{{$root.CONFIG.companyEmail}}</a></p>\n\t\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" class="direct-debit-legalities-logo" target="_blank">\n\t\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">Your payments are protected by the <a href="" ng-click="setPageState(\'direct-debit-guarantee\')">Direct Debit Guarantee</a></p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Confirmation -->\n\t<div class="form-section">\n\t\t<div class="confirmation-block indifferent">\n\t\t\t<input type="checkbox" id="confirmInformation" class="s" name="confirmInformation" ng-model="directDebit.IsConfirmed" label-text="\'I confirm that I am the account holder and am authorised to set up Direct Debit payments on this account.\'" checkbox required>\n\t\t</div>\n\t</div>\n\n\t<!-- Powered by GoCardless -->\n\t<div class="form-section">\n\t\t<div class="direct-debit-legalities">\n\t\t\t<p class="s">Read the GoCardless <a href="" ng-href="{{$root.URLS.goCardless.privacyNotice}}" target="_blank">privacy notice</a>.</p>\n\t\t\t<a href="" ng-href="{{$root.URLS.goCardless.website}}" target="_blank"><img src="images/graphics/powered-by-gocardless.png" alt="Powered by GoCardless" width="150" class="pricing-plan-summary-card-powered-by"></a>\n\t\t</div>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="directDebitForm.state" disable-button="!directDebitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-show-close="false" ng-if="pageState === \'direct-debit-guarantee\'">\n\t<fs-main>\n\t\t<div class="form-section">\n\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" target="_blank">\n\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<h4 class="strong">Direct Debit Guarantee</h4>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<p class="s">The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</p>\n\t\t\t<p class="s">If there are any changes to the amount, date or frequency of your Direct Debit Hamilton Enterpris will notify you (normally 3 working days) in advance of your account being debited or as otherwise agreed. If you request Hamilton Enterpris to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</p>\n\t\t\t<p class="s">If an error is made in the payment of your Direct Debit, by Hamilton Enterpris or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society.</p>\n\t\t\t<p class="s">If you receive a refund you are not entitled to, you must pay it back when Hamilton Enterpris asks you to.</p>\n\t\t\t<p class="s">You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify Hamilton Enterpris.</p>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Done</button>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="tick" fs-theme="positive" fs-title="This Direct Debit has been set up" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Your Direct Debit details have been updated successfully.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/companyBillingDetails/companyBillingDetailsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="directDebitForm" ng-submit="updateGoCardlessDirectDebit(directDebit, directDebitForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">To set up your variable Direct Debit with Paycircle, enter your billing details below. Your first payment date will be 3 days after you next run payroll.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="directDebit.PrimaryContact.Forename" ng-pattern="$root.REGEX.name" minlength="2" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.forename.$error" ng-if="directDebitForm.forename.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Last name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="surname" name="surname" ng-model="directDebit.PrimaryContact.Surname" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.surname.$error" ng-if="directDebitForm.surname.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t<p ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Email -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="email" class="required">Email address</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="emailAddress" name="emailAddress" ng-model="directDebit.PrimaryContact.EmailAddress" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.emailAddress.$error" ng-show="directDebitForm.emailAddress.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Address -->\n\t\t<div class="form-field">\n\t\t\t<address-lookup address="directDebit.BillingAddress" is-required="true"></address-lookup>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- The legal bit -->\n\t<fieldset class="form-fieldset-divider-top">\n\t\t<div class="direct-debit-legalities">\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">{{$root.CONFIG.companyName}}</p>\n\t\t\t\t<p class="s">{{$root.CONFIG.companyAddress}}</p>\n\t\t\t\t<p class="s"><a href="tel:{{$root.CONFIG.companyPhoneNumber}}">{{$root.CONFIG.companyPhoneNumber}}</a>, <a href="mailto:{{$root.CONFIG.companyEmail}}">{{$root.CONFIG.companyEmail}}</a></p>\n\t\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" class="direct-debit-legalities-logo" target="_blank">\n\t\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">Your payments are protected by the <a href="" ng-click="setPageState(\'direct-debit-guarantee\')">Direct Debit Guarantee</a></p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Confirmation -->\n\t<div class="form-section">\n\t\t<div class="confirmation-block indifferent">\n\t\t\t<input type="checkbox" id="confirmInformation" class="s" name="confirmInformation" ng-model="directDebit.IsConfirmed" label-text="\'I confirm that I am the account holder and am authorised to set up Direct Debit payments on this account.\'" checkbox required>\n\t\t</div>\n\t</div>\n\n\t<!-- Powered by GoCardless -->\n\t<div class="form-section">\n\t\t<div class="direct-debit-legalities">\n\t\t\t<p class="s">Read the GoCardless <a href="" ng-href="{{$root.URLS.goCardless.privacyNotice}}" target="_blank">privacy notice</a>.</p>\n\t\t\t<a href="" ng-href="{{$root.URLS.goCardless.website}}" target="_blank"><img src="images/graphics/powered-by-gocardless.png" alt="Powered by GoCardless" width="150" class="pricing-plan-summary-card-powered-by"></a>\n\t\t</div>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="directDebitForm.state" disable-button="!directDebitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-show-close="false" ng-if="pageState === \'direct-debit-guarantee\'">\n\t<fs-main>\n\t\t<div class="form-section">\n\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" target="_blank">\n\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<h4 class="strong">Direct Debit Guarantee</h4>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<p class="s">The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</p>\n\t\t\t<p class="s">If there are any changes to the amount, date or frequency of your Direct Debit Hamilton Enterpris will notify you (normally 3 working days) in advance of your account being debited or as otherwise agreed. If you request Hamilton Enterpris to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</p>\n\t\t\t<p class="s">If an error is made in the payment of your Direct Debit, by Hamilton Enterpris or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society.</p>\n\t\t\t<p class="s">If you receive a refund you are not entitled to, you must pay it back when Hamilton Enterpris asks you to.</p>\n\t\t\t<p class="s">You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify Hamilton Enterpris.</p>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Done</button>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="tick" fs-theme="positive" fs-title="Direct Debit details have been updated" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Your Direct Debit request has been submitted and we\'re just waiting for your company and bank details to be confirmed. This should only take around 24 hours but don\'t worry, we\'ll email you when your Direct Debit is good to go!</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/companyBillingName/companyBillingNameForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="billingNameForm" ng-submit="updateGoCardlessBillingName(directDebit, billingNameForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">If you\'d like a different name to be used on your invoices, edit the billing name below. This won\'t affect the billing information you\'ve used to set up your Direct Debit.</p>\n\t</div>\n\n\t<!-- Basic Inputs -->\n\t<fieldset>\n\n\t\t<!-- Billing Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="billingName" class="required">Billing Name</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="billingName" name="billingName" type="text" ng-model="directDebit.CompanyName" ng-pattern="$root.REGEX.name" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="billingNameForm.billingName.$error" ng-if="billingNameForm.billingName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a billing name</p>\n\t\t\t\t<p ng-message="pattern">Billing name can only contain letters, apostrophes and hyphens</p>\n\t\t\t</div>\n\t\t</div>\n    </fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="billingNameForm.state" disable-button="!billingNameForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/companyModules/companyModulesForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companyModulesForm" ng-submit="updateCompanyModules(companyModules, companyModulesForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Modules</h4>\n\t\t<p class="s">Choose which modules you would like to turn on for {{formOptions.company.Name}}.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<section class="settings-rows">\n\n\t\t\t\t<!-- Payroll -->\n\t\t\t\t<settings-row ng-model="companyModules.IsPayrollActive" on-update="validateModuleSelection(companyModules)" sr-disabled="!companyModules.CanEditPayrollActive" sr-field-name="isPayrollActive" sr-label="Payroll">\n\t\t\t\t\t<sr-description>Payroll will be run through Paycircle and sent to HMRC each period.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Workplace Pension -->\n\t\t\t\t<settings-row ng-model="companyModules.IsPensionActive" on-update="validateModuleSelection(companyModules)" sr-disabled="!companyModules.CanEditPensionActive" sr-field-name="isPensionActive" sr-label="Pension">\n\t\t\t\t\t<sr-description>Pension contributions will be calculated and submitted each period.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- CIS -->\n\t\t\t\t<settings-row ng-model="companyModules.IsCISActive" on-update="validateModuleSelection(companyModules)" sr-disabled="!companyModules.CanEditCISActive" sr-field-name="isCISActive" sr-label="CIS (Construction Industry Scheme)">\n\t\t\t\t\t<sr-description>CIS contribution information will be collected, calculated and submitted each period.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Off payroll workers -->\n\t\t\t\t<settings-row ng-model="companyModules.IsOffPayrollActive" on-update="validateModuleSelection(companyModules)" sr-disabled="!companyModules.CanEditOffPayrollActive" sr-field-name="isOffPayrollActive" sr-label="Off-payroll workers">\n\t\t\t\t\t<sr-description>Deemed payments can be added so tax and NI can be calculated and submitted each period.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- HR -->\n\t\t\t\t<settings-row ng-model="companyModules.IsHRActive" on-update="validateModuleSelection(companyModules)" sr-disabled="!companyModules.CanEditHRActive" sr-field-name="isHRActive" sr-label="HR">\n\t\t\t\t\t<sr-description>Set up company policies, job grades and manage and track your team\u2019s holidays and sick days.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Expats -->\n\t\t\t\t<settings-row ng-if="companyModules.CanEditExpatActive" ng-model="companyModules.IsExpatActive" on-update="validateModuleSelection(companyModules)" sr-field-name="isExpatActive" sr-label="Expats">\n\t\t\t\t\t<sr-description>Manage tax equalisation and foreign tax credits for team members and pay them using alternative currencies.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t</section>\n\t\t</div>\n\n\t\t<!-- Show when: Payroll module is not on -->\n\t\t<div class="form-content-block fadeIn" ng-if="!companyModules.IsPayrollActive">\n\t\t\t<note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="Looking to turn on Payroll...">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tIf you turn the payroll module on, you will need to ensure that any tax and year to date information is up to date before submitting the next pay period.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Show when: HR module can\'t be turned off -->\n\t\t<div class="form-content-block fadeIn" ng-if="companyModules.IsHRActive && !companyModules.CanEditHRActive">\n\t\t\t<note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="Turning off the HR module">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tPlease note that if any policies exist in your HR area, the HR module can\'t be turned off.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Show when: CIS module is not on -->\n\t\t<div class="form-content-block fadeIn" ng-if="!companyModules.IsCISActive">\n\t\t\t<note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="Looking to set up a CIS scheme?">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThis requires additional information. You will need to confirm your CIS deductions suffered for this tax year and your UTR to activate your CIS scheme.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Show when: Company is CIS only -->\n\t\t<div class="form-content-block fadeIn" ng-if="formOptions.company.CISOnly">\n\t\t\t<note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="CIS only company?">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tIf you only operate a CIS scheme with no PAYE employees, please select the CIS module only and switch both payroll and pension modules to off.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="!companyModules.isModuleSelectionValid">\n\t\t\t<note note-theme="assertive-darkened">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div ng-switch="companyModules.moduleValidState">\n\n\t\t\t\t\t\t<!-- Show when: no modules are on -->\n\t\t\t\t\t\t<p class="s" ng-switch-when="no-modules-selected">\n\t\t\t\t\t\t\tAt least one of the modules above should be turned on to create a company\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t <p class="s" ng-switch-when="no-hr-without-payroll">\n\t\t\t\t\t\t\tPlease turn on the <span class="strong">Payroll</span> module if the <span class="strong">HR</span> module is turned on\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Show when: CIS and Pension module are both on but not payroll -->\n\t\t\t\t\t\t<p class="s" ng-switch-when="no-pension-and-cis-without-payroll">\n\t\t\t\t\t\t\tPlease turn off the <span class="strong">Pension</span> module to run a CIS scheme\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<p class="s" ng-switch-when="no-off-payroll-without-payroll">\n\t\t\t\t\t\t\tPlease turn on the <span class="strong">Payroll</span> module if the <span class="strong">Off-payroll workers</span> module is turned on\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="companyModulesForm.state" disable-button="!companyModulesForm.$valid || !companyModules.isModuleSelectionValid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/companyOverview/companyOverviewForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companyOverviewForm" ng-submit="saveForm(form, companyOverviewForm)" class="company-overview fadeIn" ng-if="pageState === \'ready\'" ng-switch="activePeriodType" novalidate>\n\n\t<header class="company-overview_header">\n\t\t<div class="company-overview_company-name">\n\t\t\t<i class="icon-company is-large is-primary company-overview_icon"></i>\n\t\t\t<h5>{{formOptions.company.Name}}</h5>\n\t\t</div>\n\t\t<div>\n\t\t\t<dropdown-menu id="company-overview-action-menu" class="company-overview_action-menu" menu-id="company-overview-menu" menu-size="l" menu-icon="icon-setup">\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a ui-sref="company-dashboard({agencyProfileId: company.Company.AgencyProfileID})">Go to company</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="dropdown-group" ng-if="company.Company.PAYECeaseDateISO === \'\'">\n\t\t\t\t\t<a data-cy="company-overview-menu-add-a-change" href="" ng-click="openAddAChangeForm(company)" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments">Add a change</a>\n\t\t\t\t\t<a data-cy="company-overview-menu-run-period" href="" ng-click="openRunPayrollForm(company)" ng-if="::$root.currentUser.Permissions.Payroll.canRunPayroll">{{company.Company.PensionOnly ? \'Run period\' : \'Run payroll\'}}</a>\n\t\t\t\t\t<a data-cy="company-overview-menu-manage-admins" href="" ng-click="openManageAdminsForm(company)" ng-if="::$root.currentUser.Permissions.CompanySettings.canAccessPermissions">Manage admins</a>\n\t\t\t\t\t<a data-cy="company-overview-menu-manage-visibility" href="" ng-click="openManageVisibilityForm()" ng-if="::$root.currentUser.Permissions.Admin.canManageBureauAdmins || $root.currentUser.Permissions.Admin.canManageCompanyGroupAdmins">Manage visibility</a>\n\t\t\t\t\t<a data-cy="company-overview-menu-generate-reports" href="" ng-click="generateReports(company.PayPeriod)" ng-if="$root.userHasRole([\'paycircle\']) && !company.PayPeriod.IsPayrollLocked">Re-calculate payroll</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Super Users -->\n\t\t\t\t<div class="dropdown-group" ng-if="company.PayPeriod.PayrollState !== SUBMISSION_STATES.submitting && company.Company.CanBeDeleted && $root.currentUser.Permissions.Admin.canManageCompanies">\n\t\t\t\t\t<a data-cy="company-overview-menu=delete-company" href="" id="company-overview_delete-company" class="assertive" ng-click="confirmDeleteCompany()">Delete company</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</header>\n\n\t<section class="company-overview-section">\n\n\t\t<div class="meta-data-block">\n\t\t\t<div class="meta-data">\n\t\t\t\t<p class="meta-data-title">PAYE Ref.</p>\n\t\t\t\t<p class="meta-data-value">{{company.Company.PAYERef}}</p>\n\t\t\t</div>\n\t\t\t<div class="meta-data">\n\t\t\t\t<p class="meta-data-title">Accounts Office No.</p>\n\t\t\t\t<p class="meta-data-value">{{company.Company.AccountsOfficeReference}}</p>\n\t\t\t</div>\n\t\t\t<div class="meta-data" ng-if="company.Company.HasPension">\n\t\t\t\t<p class="meta-data-title">Pension Provider</p>\n\t\t\t\t<p class="meta-data-value">{{company.Pension.ProviderName}}</p>\n\t\t\t</div>\n\t\t\t<div class="meta-data" ng-if="company.Company.HasPension && company.Pension.EmployerReference">\n\t\t\t\t<p class="meta-data-title">Pension Ref.</p>\n\t\t\t\t<p class="meta-data-value">{{company.Pension.EmployerReference}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n\n\t<section class="company-overview-section company-overview-divider">\n\t\t<div class="company-overview-people">\n\t\t\t<p><i class="icon-team-alt"></i><ng-pluralize count="company.Company.TeamMemberCount" when="{\'1\': \'1 employee\', \'other\': \'{} employees\'}"></ng-pluralize></p>\n\t\t</div>\n\t</section>\n\n\t<!-- PAYE open -->\n\t<div ng-if="company.Company.PAYECeaseDateISO === \'\'">\n\n\t\t<section class="company-overview-section company-overview-actions">\n\t\t\t<div class="toggle-links" ng-if="company.PreviousPayPeriod">\n\t\t\t\t<a data-cy="company-overview-previous-period" href="" ng-click="setActivePeriodType(\'previous\')" class="toggle-link" ng-class="{\'active\': activePeriodType === \'previous\'}"><i class="icon-chevron-left"></i>Previous period</a>\n\t\t\t\t<a data-cy="company-overview-current-period" href="" ng-click="setActivePeriodType(\'current\')" class="toggle-link" ng-class="{\'active\': activePeriodType === \'current\'}">Current period<i class="icon-chevron-right"></i></a>\n\t\t\t</div>\n\t\t\t<div class="company-overview-payroll-actions fadeIn" ng-switch-when="current">\n\t\t\t\t<a data-cy="company-overview-add-a-change" href="" ng-click="openAddAChangeForm(company)" class="button s clear hidden-phone" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments">Add a change</a>\n\t\t\t\t<a data-cy="company-overview-run-period" href="" ng-click="openRunPayrollForm(company)" class="button s primary" ng-if="::$root.currentUser.Permissions.Payroll.canRunPayroll">{{company.Company.PensionOnly ? \'Run period\' : \'Run payroll\'}}</a>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Current Period -->\n\t\t<section ng-switch-when="current">\n\t\t\t<div class="company-overview-section align-center">\n\t\t\t\t<h2><i class="is-greyscale {{company.PayPeriod.PayrollState === SUBMISSION_STATES.submitted ? \'icon-history\' : \'icon-clock\'}}"></i>&nbsp;{{company.PayPeriod.PayPeriodDisplay}}&nbsp;&nbsp;<payroll-state cease-paye-scheme-complete="company.Company.CeasePAYESchemeComplete" pay-period="company.PayPeriod" ceased-date="company.Company.PAYECeaseDateISO"></payroll-state></h2>\n\t\t\t\t<p class="is-small align-center"><strong>Pay day:</strong> {{company.PayPeriod.PayDateISO | dateformat}} ({{company.PayPeriod.TaxPeriod | taxPeriodDescription:company.PayPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t</div>\n\t\t\t<pay-period-tabs agency-profile-id="formOptions.company.AgencyProfileID" company="formOptions.company" form-options="formOptions" on-pay-period-change="refreshCompanyData" pay-period="company.PayPeriod" reports="reports"></pay-period-tabs>\n\t\t</section>\n\n\t\t<!-- Previous Period -->\n\t\t<section ng-switch-when="previous">\n\t\t\t<div class="company-overview-section align-center">\n\t\t\t\t<h2><i class="is-greyscale {{company.PreviousPayPeriod.PayrollState === SUBMISSION_STATES.submitted ? \'icon-history\' : \'icon-clock\'}}">&nbsp;</i>{{company.PreviousPayPeriod.PayPeriodDisplay}}&nbsp;&nbsp;<payroll-state cease-paye-scheme-complete="company.Company.CeasePAYESchemeComplete" pay-period="company.PreviousPayPeriod" ceased-date="company.Company.PAYECeaseDateISO"></payroll-state></h2>\n\t\t\t\t<p class="is-small align-center"><strong>Pay day:</strong> {{company.PreviousPayPeriod.PayDateISO | dateformat}} ({{company.PreviousPayPeriod.TaxPeriod | taxPeriodDescription:company.PreviousPayPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t</div>\n\t\t\t<pay-period-tabs agency-profile-id="formOptions.company.AgencyProfileID" company="formOptions.company" form-options="formOptions" ng-if="::company.PreviousPayPeriod" on-pay-period-change="refreshCompanyData" pay-period="company.PreviousPayPeriod" reports="reports"></pay-period-tabs>\n\t\t</section>\n\n\t\t<!-- No Previous Period -->\n\t\t<section ng-if="::!company.PreviousPayPeriod">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s">No periods have been processed yet. As soon as they do they will appear here.</p>\n\t\t\t</div>\n\t\t</section>\n\t</div>\n\n\t<!-- PAYE closed -->\n\t<div class="dashboard-block assertive fadeIn" ng-if="company.Company.CeasePAYESchemeComplete">\n\n\t\t<main class="dashboard-block-main">\n\t\t\t<section class="dashboard-block-section fadeIn slow">\n\t\t\t\t<p class="dashboard-block-period">\n\t\t\t\t\t<span class="dashboard-block-period-label">Last period</span>\n\t\t\t\t\t<span class="dashboard-block-period-value">{{company.PreviousPayPeriod.PayPeriodDisplay}}</span>\n\t\t\t\t</p>\n\t\t\t\t<h3 class="dashboard-block-title">This PAYE scheme has been closed</h3>\n\t\t\t\t<p class="dashboard-block-subtitle">The PAYE scheme with the reference {{company.Company.PAYERef}} was closed on {{company.Company.PAYECeaseDateISO | dateformat}}.<br>\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.closingPayeScheme" theme="assertive">Read more about closing a PAYE scheme</support-article-link></p>\n\t\t\t\t<a ui-sref="pensions.summary({agencyProfileId: currentCompany.AgencyProfileID})" class="button assertive" ng-if="company.Company.HasPension">Disconnect your pension</a>\n\t\t\t</section>\n\t\t</main>\n\t\t<div class="tag-label assertive dashboard-block-tag-label"><i class="icon-cross tag-label-icon"></i>Closed</div>\n\t</div>\n</form>\n\n<!-- Cannot run payroll - Report generation failed -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Payroll could not be calculated" ng-if="pageState === \'report-generation-failed\'">\n\t<fs-main>\n\t\t<p class="s">There was a problem calculating your payroll. Please contact support for more information.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Confirm delete -->\n<form class="fadeIn" name="confirmDeleteForm" ng-if="pageState === \'confirm-delete-company\'" ng-submit="deleteCompany(company)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this company?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThis cannot be undone and you will need to re-create the company and team members if you change your mind later.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\n\t\t\t<!-- Cancel -->\n\t\t\t<button href="" class="button secondary-action" ng-click="cancelConfirmDeleteCompany()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button disable-button="!confirmDeleteForm.$valid" display-text="\'Delete\'" state="confirmDeleteForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Deleting -->\n<div class="fadeIn" ng-if="pageState === \'deleting-company\'">\n\t<loading-block>\n\t\t<lb-description>\n\t\t\t<h6>\n\t\t\t\tCurrently deleting {{formOptions.company.Name}}\n\t\t\t</h6>\n\t\t</lb-description>\n\t</loading-block>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/crossPeriodReport/crossPeriodReportForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="crossPeriodReportForm" ng-submit="generateReport(selectedPayPeriods, fileFormat)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Select a start and end period and click \'Generate\' to start creating your costings report. It may take a few moments to generate your report.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="slide-in-form_item form-fields-from-to">\n\n\t\t\t<!-- Start period -->\n\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label class="required">Start period</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<select id="payPeriodStart" name="payPeriodStart" ng-model="selectedPayPeriods.payPeriodStart" ng-options="payPeriod as payPeriod.PayPeriodDisplay for payPeriod in startPayPeriods" ng-change="refreshEndPayPeriods(selectedPayPeriods.payPeriodStart)" required>\n\t\t\t\t\t\t\t<option value="">Choose a start period...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="crossPeriodReportForm.payPeriodStart.$error" ng-show="crossPeriodReportForm.payPeriodStart.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please choose a start period</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- End period -->\n\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label class="required">End period</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<select id="payPeriodEnd" name="payPeriodEnd" ng-model="selectedPayPeriods.payPeriodEnd" ng-options="payPeriod as payPeriod.PayPeriodDisplay for payPeriod in endPayPeriods" required>\n\t\t\t\t\t\t\t<option value="">Choose an end period...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="crossPeriodReportForm.payPeriodEnd.$error" ng-show="crossPeriodReportForm.payPeriodEnd.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please choose an end period</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Report type -->\n\t\t<div class="slide-in-form_item form-field">\n\t\t\t<label for="fileFormatExcel" class="required">File format:</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input type="radio" name="fileFormat" id="fileFormatExcel" class="b" ng-value="\'excel\'" ng-model="fileFormat">\n\t\t\t\t\t<label for="fileFormatExcel">Excel</label>\n\n\t\t\t\t\t<input type="radio" name="fileFormat" id="fileFormatCsv" class="b" ng-value="\'csv\'" ng-model="fileFormat">\n\t\t\t\t\t<label for="fileFormatCsv">CSV</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="fadeIn align-center" ng-if="crossPeriodReportForm.state === \'saving\' && false">\n\t\t<circle-loader></circle-loader>\n\t\t<h5>Generating report</h5>\n\t\t<p><em>This may take a few moments before your download begins</em></p>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="\'Generate\'" state="crossPeriodReportForm.state" disable-button="!crossPeriodReportForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No pay periods or only a single pay period -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="More payroll history needed" ng-if="pageState === \'not-available\'">\n\t<fs-main>\n\t\t<p class="s">Cross period reports will become available when at least two payroll periods have been run for {{formOptions.company.Name}}.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/customisation/customisationForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section ng-if="pageState === \'ready\'" ng-switch="customisationTab">\n\n\t<feature-carousel fc-active-key="customisationTab" fc-directory="customisation-features" fc-items="carouselItems" fc-on-active-key-change="formOptions.onFeatureSwitch"></feature-carousel>\n\n\t<!-- Login Page -->\n\t<form class="fadeIn" name="customiseLoginForm" ng-submit="updateCompanyCustomisationLogin(customisation.Login, customiseLoginForm)" ng-switch-when="login" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s strong"><span class="tertiary">This is a preview</span> - please make sure you click &lsquo;Save&rsquo; to save your customisation changes.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Logo -->\n\t\t\t<form-group fg-title="Logo">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="agencyProfileId" fu-customisation-type="CUSTOMISATION_TYPES.login" fu-max-file-size="750" fu-model="customisation.Login.LogoURL" fu-on-update="refreshImages(\'Login\', \'LogoURL\')" fu-template="stacked"></customisation-image-uploader>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message">Upload an alternative to your standard company logo. Choose a PNG or JPEG image no larger than 750kb.</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Background Colour -->\n\t\t\t<form-group fg-title="Background colour">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<colour-picker colour="customisation.Login.BackgroundColour" cp-id="backgroundColour" cp-on-change="liveUpdate(customisation.Login.BackgroundColour, \'Login\', \'BackgroundColour\')" show-message="true"></colour-picker>\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseLoginForm.backgroundColour.$error" ng-if="customiseLoginForm.backgroundColour.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid hex value, including the hashtag. E.g. \'#ffffff\'</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">Click on the colour swatch or enter a # value</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Text Shade -->\n\t\t\t<form-group fg-title="Text shade">\n\t\t\t\t<shade-picker sp-model="customisation.Login.TextShade" sp-on-change="liveUpdate(customisation.Login.TextShade, \'Login\', \'TextShade\')"></shade-picker>\n\t\t\t</form-group>\n\n\t\t\t<!-- Address -->\n\t\t\t<form-group fg-title="Address">\n\n\t\t\t\t<!-- Company Has Address -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Login.Address.AddressPostcode !== \'\'">\n\t\t\t\t\t<div class="form-field-label">\n\t\t\t\t\t\t<p class="caption">Saved in {{formOptions.company.CompanyType | companyTypeDescription}} settings:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<div class="info-block is-compact">\n\t\t\t\t\t\t\t<h6>{{formOptions.company.Name}}</h6>\n\t\t\t\t\t\t\t<print-address class="address small" address="customisation.Login.Address"></print-address>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No Company Address -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Login.Address.AddressPostcode === \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<p class="form-message"><em>Please add an address in {{formOptions.company.CompanyType | companyTypeDescription}} settings first. <a ui-sref="settings.bureau.information({agencyProfileId: agencyProfileId, openForm:\'basic\'})" class="underline">Go to {{formOptions.company.CompanyType | companyTypeDescription}} settings</a></em></p>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is address visible -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Login.Address.AddressPostcode !== \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<input id="isAddressVisible" label-text="\'Show address\'" name="isAddressVisible" ng-change="liveUpdate(customisation.Login.IsAddressVisible, \'Login\', \'IsAddressVisible\')" ng-model="customisation.Login.IsAddressVisible" type="checkbox" checkbox>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Email address -->\n\t\t\t<form-group fg-title="Email address">\n\n\t\t\t\t<!-- Company has support email -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.EmailAddress !== \'\'">\n\t\t\t\t\t<div class="form-field-label">\n\t\t\t\t\t\t<p class="caption">Saved in {{formOptions.company.CompanyType | companyTypeDescription}} settings:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="info-block is-compact">\n\t\t\t\t\t\t\t<p class="s">{{customisation.Contact.EmailAddress}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company has no support email -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.EmailAddress === \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<p class="form-message"><em>Please add an email address in {{formOptions.company.CompanyType | companyTypeDescription}} settings first. <a ui-sref="settings.bureau.information({agencyProfileId: agencyProfileId, openForm:\'basic\'})" class="underline">Go to {{formOptions.company.CompanyType | companyTypeDescription}} settings</a></em></p>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is email visible -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.EmailAddress !== \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<input id="isEmailAddressVisible" label-text="\'Show email address\'" name="isEmailAddressVisible" ng-change="liveUpdate(customisation.Login.IsEmailAddressVisible, \'Login\', \'IsEmailAddressVisible\')" ng-model="customisation.Login.IsEmailAddressVisible" type="checkbox" checkbox>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Telephone -->\n\t\t\t<form-group fg-title="Telephone">\n\n\t\t\t\t<!-- Company has phone -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.Phone !== \'\'">\n\t\t\t\t\t<div class="form-field-label">\n\t\t\t\t\t\t<p class="caption">Saved in {{formOptions.company.CompanyType | companyTypeDescription}} settings:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<div class="info-block is-compact">\n\t\t\t\t\t\t\t<p class="s">{{customisation.Contact.Phone}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company has no phone -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.Phone === \'\'">\n\t\t\t\t\t<p class="form-message"><em>Please add a telephone number in {{formOptions.company.CompanyType | companyTypeDescription}} settings first. <a ui-sref="settings.bureau.information({agencyProfileId: agencyProfileId, openForm:\'basic\'})" class="underline">Go to {{formOptions.company.CompanyType | companyTypeDescription}} settings</a></em></p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is phone visible -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Contact.Phone !== \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<input id="isPhoneVisible" label-text="\'Show telephone number\'" name="isPhoneVisible" ng-change="liveUpdate(customisation.Login.IsPhoneVisible, \'Login\', \'IsPhoneVisible\')" ng-model="customisation.Login.IsPhoneVisible" type="checkbox" checkbox>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Feedback -->\n\t\t\t<form-feedback state="customiseLoginForm.state" ng-if="customiseLoginForm.state === \'saved\'">\n\t\t\t\t<p>The customisation details for the sign in page have been saved</p>\n\t\t\t</form-feedback>\n\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="customiseLoginForm.state" disable-button="!customiseLoginForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Branding -->\n\t<form class="fadeIn" name="customiseBrandingForm" ng-submit="updateCompanyCustomisationBranding(customisation.Branding, customiseBrandingForm)" ng-switch-when="app-header" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s strong"><span class="tertiary">This is a preview</span> - please make sure you click &lsquo;Save&rsquo; to save your customisation changes.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- App Icon -->\n\t\t\t<form-group fg-title="App icon">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="agencyProfileId" fu-customisation-type="CUSTOMISATION_TYPES.icon" fu-max-file-size="750" fu-model="customisation.LogoUrls.Icon" fu-on-delete="refreshImages(\'LogoUrls\', \'Icon\')" fu-on-update="refreshImages(\'LogoUrls\', \'Icon\')"></customisation-image-uploader>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message">The image will be cropped to 60px square so we recommend uploading a square image. Choose a PNG or JPEG image no larger than 750kb.</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Brand Colours -->\n\t\t\t<form-group fg-title="Brand colours">\n\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<p class="s">Display a single colour strip or add two colours to use a gradient</p>\n\t\t\t\t</section>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="name">Colour 1</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<colour-picker colour="customisation.Branding.Colour1" cp-id="brandColour1" cp-on-change="liveUpdate(customisation.Branding.Colour1, \'Branding\', \'Colour1\')"></colour-picker>\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseLoginForm.brandColour1.$error" ng-if="customiseLoginForm.brandColour1.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid hex value, including the hashtag. E.g. \'#ffffff\'</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">Click on the colour swatch or enter a # value</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="name">Colour 2</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<colour-picker colour="customisation.Branding.Colour2" cp-id="brandColour2" cp-on-change="liveUpdate(customisation.Branding.Colour2, \'Branding\', \'Colour2\')"></colour-picker>\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseLoginForm.brandColour2.$error" ng-if="customiseLoginForm.brandColour2.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid hex value, including the hashtag. E.g. \'#ffffff\'</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<gradient-bar colour1="customisation.Branding.Colour1" colour2="customisation.Branding.Colour2" height="8" template="inline"></gradient-bar>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Spacer required to allow room for colour picker -->\n\t\t\t<div class="spacer xxxxxl"></div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Feedback -->\n\t\t\t<form-feedback state="customiseBrandingForm.state" ng-if="customiseBrandingForm.state === \'saved\'">\n\t\t\t\t<p>The customisation details for the app header have been saved</p>\n\t\t\t</form-feedback>\n\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="customiseBrandingForm.state" disable-button="!customiseBrandingForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Email -->\n\t<form class="fadeIn" name="customiseEmailForm" ng-submit="updateCompanyCustomisationEmail(customisation.Emails, customiseEmailForm)" ng-switch-when="system-emails" novalidate>\n\t\t<fieldset>\n\n\t\t\t<!-- Logo -->\n\t\t\t<form-group fg-title="Logo">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="agencyProfileId" fu-customisation-type="CUSTOMISATION_TYPES.email" fu-max-file-size="750" fu-model="customisation.Emails.LogoURL" fu-on-delete="refreshImages(\'Emails\', \'LogoURL\')" fu-on-update="refreshImages(\'Emails\', \'LogoURL\')" fu-template="stacked"></customisation-image-uploader>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message">To use an alternative to your standard company logo, upload it here. Choose a PNG or JPEG image no larger than 750kb.</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Email address -->\n\t\t\t<form-group fg-title="Email address">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<p class="s">To show a different email address in email footers, enter it below:</p>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<input id="email" name="email" type="text" ng-model="customisation.Emails.EmailAddress" placeholder="{{$root.PLACEHOLDERS.email}}" ng-change="liveUpdate(customisation.Emails.EmailAddress, \'Emails\', \'EmailAddress\')" ng-pattern="$root.REGEX.email">\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseEmailForm.email.$error" ng-if="customiseEmailForm.email.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid email address</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Address -->\n\t\t\t<form-group fg-title="Address">\n\n\t\t\t\t<!-- Company Has Address -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Login.Address.AddressPostcode !== \'\'">\n\t\t\t\t\t<div class="form-field-label">\n\t\t\t\t\t\t<p class="caption">Saved in {{formOptions.company.CompanyType | companyTypeDescription}} settings:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<div class="info-block is-compact">\n\t\t\t\t\t\t\t<h6>{{formOptions.company.Name}}</h6>\n\t\t\t\t\t\t\t<print-address class="address small" address="customisation.Login.Address"></print-address>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No Company Address -->\n\t\t\t\t<div class="form-field" ng-if="::customisation.Login.Address.AddressPostcode === \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<p class="form-message"><em>Please add an address in {{formOptions.company.CompanyType | companyTypeDescription}} settings first. <a ui-sref="settings.bureau.information({agencyProfileId: agencyProfileId, openForm:\'basic\'})" class="underline">Go to {{formOptions.company.CompanyType | companyTypeDescription}} settings</a></em></p>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Publish live switch -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<p class="s">To make your settings live turn on the switch below and click \u2018Save\u2019. You can turn them off at any time.</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-label="Publish to live" field-model="customisation.Emails.IsCustomisationLive" field-name="isCustomisationLive"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Feedback -->\n\t\t\t<form-feedback state="customiseEmailForm.state" ng-if="customiseEmailForm.state === \'saved\'">\n\t\t\t\t<p>The customisation details for emails have been saved</p>\n\t\t\t</form-feedback>\n\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="customiseEmailForm.state" disable-button="!customiseEmailForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Online Payslips -->\n\t<form class="fadeIn" name="customiseOnlinePayslipsForm" ng-submit="updateCompanyCustomisationPayslip(customisation.Payslips, customisation.Contact, customiseOnlinePayslipsForm)" ng-switch-when="online-payslips" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s strong"><span class="tertiary">This is a preview</span> - please make sure you click &lsquo;Save&rsquo; to save your customisation changes.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Logo -->\n\t\t\t<form-group fg-title="Logo">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="agencyProfileId" fu-customisation-type="CUSTOMISATION_TYPES.payslip" fu-max-file-size="750" fu-model="customisation.Payslips.LogoURL" fu-on-delete="refreshImages(\'LogoUrls\', \'Icon\')" fu-on-update="refreshImages(\'Payslips\', \'LogoURL\')" fu-template="stacked"></customisation-image-uploader>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message">The image will be cropped to 60px square so we recommend uploading a square image. Choose a PNG or JPEG image no larger than 750kb.</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Support Contact -->\n\t\t\t<form-group fg-title="Payroll support contact">\n\n\t\t\t\t<!-- Company has contact -->\n\t\t\t\t<div class="form-field" ng-if="customisation.Contact.Forename !== \'\'">\n\t\t\t\t\t<div class="form-field-label">\n\t\t\t\t\t\t<p class="caption">Saved in {{formOptions.company.CompanyType | companyTypeDescription}} settings:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="info-block is-compact">\n\t\t\t\t\t\t\t<p class="s">{{customisation.Contact.Forename}} {{customisation.Contact.Surname}}</p>\n\t\t\t\t\t\t\t<p class="s">{{customisation.Contact.EmailAddress}}</p>\n\t\t\t\t\t\t\t<p class="s">{{customisation.Contact.Phone}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Company has no contact -->\n\t\t\t\t<div class="form-field" ng-if="customisation.Contact.Forename === \'\'">\n\t\t\t\t\t<p class="form-message"><em>Please add a Payroll support contact in {{formOptions.company.CompanyType | companyTypeDescription}} settings first. <a ui-sref="settings.bureau.information({agencyProfileId: agencyProfileId, openForm:\'basic\'})" class="underline">Go to {{formOptions.company.CompanyType | companyTypeDescription}} settings</a></em></p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is contact visible -->\n\t\t\t\t<div class="form-field" ng-if="customisation.Contact.Forename !== \'\'">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<input id="isPayrollContactVisible" label-text="\'Show payroll contact\'" name="isPayrollContactVisible" ng-change="liveUpdate(customisation.Payslips.IsContactVisible, \'Payslips\', \'IsContactVisible\')" ng-model="customisation.Payslips.IsContactVisible" type="checkbox" checkbox>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\n\t\t\t<!-- Custom Message -->\n\t\t\t<form-group fg-title="Custom message">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<p class="s">Include a message to further personalise your payslips:</p>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<textarea maxlength="150" ng-change="liveUpdate(customisation.Payslips.CustomMessage, \'Payslips\', \'CustomMessage\')" ng-model="customisation.Payslips.CustomMessage" rows="4"></textarea>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message fadeIn">Max. 150 characters</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Feedback -->\n\t\t\t<form-feedback state="customiseOnlinePayslipsForm.state" ng-if="customiseOnlinePayslipsForm.state === \'saved\'">\n\t\t\t\t<p>The customisation details for online payslips have been saved</p>\n\t\t\t</form-feedback>\n\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="customiseOnlinePayslipsForm.state" disable-button="!customiseOnlinePayslipsForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Intercom -->\n\t<form class="fadeIn" name="customiseIntercomForm" ng-submit="updateCompanyCustomisationIntercom(customisation.Intercom, customiseIntercomForm)" ng-switch-when="intercom" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s">Enter your Intercom details below and click \'Test connection\' to see if Paycircle can connect to your account.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- App ID -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="intercomappid" class="required">App ID</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<input id="intercomappid" class="s" name="intercomappid" type="text" ng-model="customisation.Intercom.AppID" required>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseIntercomForm.intercomappid.$error" ng-if="customiseIntercomForm.intercomappid.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid Intercom App ID</p>\n\t\t\t\t\t<p ng-message="required">Please enter an Intercom App ID</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">8 characters, letters and numbers only</p>\n\t\t\t</div>\n\n\t\t\t<!-- Identity Verification Secret -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="intercomsecret" class="required">Identity verification Secret</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<input id="intercomsecret" name="intercomsecret" type="text" ng-model="customisation.Intercom.VerificationSecret" required>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="customiseIntercomForm.intercomsecret.$error" ng-if="customiseIntercomForm.intercomsecret.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the Identity verification Secret</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Test connection -->\n\t\t\t<div class="form-field">\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<button class="button primary fixed-l" ng-click="testIntercomConnection(customisation)" ng-disabled="!customiseIntercomForm.$valid || customisation.testConnectionState" ng-switch="customisation.testConnectionState" type="button">\n\t\t\t\t\t\t<span ng-switch-when="loading"><i class="icon-loading spin"></i></span>\n\t\t\t\t\t\t<span ng-switch-default>Test connection</span>\n\t\t\t\t\t</button>\n\t\t\t\t</main>\n\t\t\t</div>\n\n\t\t\t<div class="form-cta">\n\t\t\t\t<p class="s strong">Need an Intercom account? <a ng-href="{{$root.URLS.intercom.website}}" class="link" target="_blank">Get one here</a></p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Feedback -->\n\t\t\t<form-feedback state="customiseIntercomForm.state" ng-if="customiseIntercomForm.state === \'saved\'">\n\t\t\t\t<p>The customisation details for Intercom have been saved</p>\n\t\t\t</form-feedback>\n\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="customiseIntercomForm.state" disable-button="!customiseIntercomForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Employee portal -->\n\t<form class="fadeIn" name="customiseEmployeePortalForm" ng-submit="updateCompanyCustomisationEmployeePortal(customisation.SideBar, customiseEmployeePortalForm)" ng-switch-when="employee-portal" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s">Edit and review all sections then click \u2018Preview\u2019 to preview your settings. You can then save them to make them live.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<!-- Logo -->\n\t\t\t<form-group fg-title="Logo">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<customisation-image-uploader agency-profile-id="agencyProfileId" fu-customisation-type="CUSTOMISATION_TYPES.sidebar" fu-max-file-size="750" fu-model="customisation.SideBar.LogoURL" fu-on-update="refreshImages(\'SideBar\', \'LogoURL\')" fu-template="stacked"></customisation-image-uploader>\n\t\t\t\t\t</main>\n\t\t\t\t\t<p class="form-message">Upload an alternative to your standard company logo. Choose a PNG or JPEG image no larger than 750kb.</p>\n\t\t\t\t</div>\n\t\t\t</form-group>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" ng-href="{{exitNgHref}}" class="button secondary-action" ng-click="formOptions.closeForm()">Exit</a>\n\t\t</fieldset>\n\t</form>\n\n\n</section>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/deletePayslipLabel/deletePayslipLabelForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this label?">\n\t<fs-main>\n\t\t<p class="s">\'{{formOptions.adjustmentLabelObj.AgencyAdjustmentLabelText}}\' will no longer be available to use when you add changes to payroll and you will need to re-create it if you decide you need it again.</p>\n\t\t<p class="s"><strong>Please note:</strong> all previous changes where \'{{formOptions.adjustmentLabelObj.AgencyAdjustmentLabelText}}\' has been used as the payslip label will not be affected and will still appear correctly on payslips and in payroll history.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Back</a>\n\t\t<submit-button display-text="\'Delete\'" state="formOptions.adjustmentLabelDeletionState" ng-click="deletePayslipLabel(formOptions.adjustmentLabelObj, formOptions.adjustmentLabelDeletionState)"></submit-button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/directDebit/directDebitForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="directDebitForm" ng-submit="setPageState(\'review\')" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">To set up your variable Direct Debit with Paycircle, enter your billing details below. Your first payment date will be 3 days after you next run payroll.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Individual details -->\n\t\t<div class="form-field-group" ng-if="!directDebit.useCompanyName">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="directDebit.PrimaryContact.Forename" ng-pattern="$root.REGEX.name" minlength="2" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.forename.$error" ng-if="directDebitForm.forename.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message"><a href="" ng-click="toggleUseCompanyName(directDebit)">or use a company name</a></p>\n\t\t\t</div>\n\n\t\t\t<!-- Last name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="surname" name="surname" ng-model="directDebit.PrimaryContact.Surname" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.surname.$error" ng-if="directDebitForm.surname.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t<p ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field" ng-if="directDebit.useCompanyName">\n\t\t\t<label for="companyName" class="required">Company name</label>\n\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="companyName" name="companyName" ng-model="directDebit.CompanyName" ng-pattern="$root.REGEX.companyName" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.companyName.$error" ng-show="directDebitForm.companyName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t<p ng-message="pattern">Please enter basic characters only</p>\n\t\t\t</div>\n\t\t\t<p class="form-message"><a href="" ng-click="toggleUseCompanyName(directDebit)">or use a persons name</a></p>\n\t\t</div>\n\n\t\t<!-- Email -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="email" class="required">Email address</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="emailAddress" name="emailAddress" ng-model="directDebit.PrimaryContact.EmailAddress" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.emailAddress.$error" ng-show="directDebitForm.emailAddress.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Account name -->\n\t\t<div class="form-field">\n\t\t\t<label for="accountName" class="required">Account name</label>\n\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="accountName" name="accountName" ng-model="directDebit.Bank.BankAccountName" ng-pattern="$root.REGEX.name" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.accountName.$error" ng-show="directDebitForm.accountName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an account name</p>\n\t\t\t\t<p ng-message="pattern">Please enter basic characters only</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Account number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="accountNumber" class="required">Account number</label>\n\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="accountNumber" class="m" name="accountNumber" ng-model="directDebit.Bank.BankAccountNumber" maxlength="8" ng-minlength="8" ng-maxlength="8" placeholder="12345678" ng-pattern="$root.REGEX.numbersOnly" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="directDebitForm.accountNumber.$error" ng-show="directDebitForm.accountNumber.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an account number</p>\n\t\t\t\t\t<p ng-message="minlength || maxlength">The account number should be 8 digits long</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Sort code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sortcodeA" class="required">Sort code</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<sort-code sort-code="directDebit.Bank.SortCode" sort-code-name="sortCode"></sort-code>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="directDebitForm.sortCode.$touched" ng-messages="directDebitForm.sortCode.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Address -->\n\t\t<div class="form-field">\n\t\t\t<address-lookup address="directDebit.BillingAddress" is-required="true" show-label="true" is-uk-only="true"></address-lookup>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- The legal bit -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="direct-debit-legalities">\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">{{$root.CONFIG.companyName}}</p>\n\t\t\t\t<p class="s">{{$root.CONFIG.companyAddress}}</p>\n\t\t\t\t<p class="s"><a href="tel:{{$root.CONFIG.companyPhoneNumber}}">{{$root.CONFIG.companyPhoneNumber}}</a>, <a href="mailto:{{$root.CONFIG.companyEmail}}">{{$root.CONFIG.companyEmail}}</a></p>\n\t\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" class="direct-debit-legalities-logo">\n\t\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">Your payments are protected by the <a href="" ng-click="setPageState(\'direct-debit-guarantee\')">Direct Debit Guarantee</a></p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Confirmation -->\n\t<div class="form-section">\n\t\t<div class="confirmation-block indifferent">\n\t\t\t<input type="checkbox" id="confirmInformation" class="s" name="confirmInformation" ng-model="directDebit.IsConfirmed" label-text="\'I confirm that I am the account holder and am authorised to set up Direct Debit payments on this account.\'" checkbox required>\n\t\t</div>\n\t</div>\n\n\t<!-- Powered by GoCardless -->\n\t<div class="form-section">\n\t\t<div class="direct-debit-legalities">\n\t\t\t<a href="" ng-href="{{$root.URLS.goCardless.website}}" target="_blank"><img src="images/graphics/powered-by-gocardless.png" alt="Powered by GoCardless" width="150" class="pricing-plan-summary-card-powered-by"></a>\n\t\t\t<p class="s">Read the GoCardless <a href="" ng-href="{{$root.URLS.goCardless.privacyNotice}}" target="_blank">privacy notice</a>.</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Next\'" state="directDebitForm.state" disable-button="!directDebitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form name="directDebitReviewForm" ng-submit="createGoCardlessDirectDebit(directDebit, directDebitReviewForm)" class="fadeIn" ng-if="pageState === \'review\' || pageState === \'success\'" novalidate>\n\n\t<div class="form-intro" ng-if="pageState === \'review\'">\n\t\t<p class="s">Please review the details you have entered before clicking \'Set up Direct Debit\'. Click \'Back\' if you need to edit anything.</p>\n\t</div>\n\t<div class="form-intro fadeIn" ng-if="pageState === \'success\'">\n\t\t<h3 class="strong">Direct Debit set up - complete</h3>\n\t\t<p class="s">You should receive an email within three business days confirming that your Direct Debit has been set up. The name that will appear on your bank statements for payments is {{$root.CONFIG.companyName}}.</p>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<!-- Personal Info. -->\n\t\t<div class="review-card primary">\n\t\t\t<p class="review-card-title">Personal Information</p>\n\t\t\t<div class="review-card-items">\n\t\t\t\t<div class="review-card-item" ng-if="!directDebit.useCompanyName">\n\t\t\t\t\t<span class="review-card-label">Name:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.PrimaryContact.Forename}} {{directDebit.PrimaryContact.Surname}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="review-card-item" ng-if="directDebit.useCompanyName">\n\t\t\t\t\t<span class="review-card-label">Company name:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.CompanyName}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="review-card-item">\n\t\t\t\t\t<span class="review-card-label">Email address:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.PrimaryContact.EmailAddress}}</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Account Info. -->\n\t\t<div class="review-card primary">\n\t\t\t<p class="review-card-title">Account Information</p>\n\t\t\t<div class="review-card-items">\n\t\t\t\t<div class="review-card-item">\n\t\t\t\t\t<span class="review-card-label">Account name:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.Bank.BankAccountName}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="review-card-item">\n\t\t\t\t\t<span class="review-card-label">Account number:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.Bank.BankAccountNumber}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="review-card-item">\n\t\t\t\t\t<span class="review-card-label">Sort code:</span>\n\t\t\t\t\t<span class="review-card-value">{{directDebit.Bank.SortCode}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="review-card-item">\n\t\t\t\t\t<span class="review-card-label">Payment method:</span>\n\t\t\t\t\t<span class="review-card-value">Direct Debit</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Billing Address -->\n\t\t<div class="review-card primary">\n\t\t\t<p class="review-card-title">Billing Address</p>\n\t\t\t<div class="review-card-main">\n\t\t\t\t<print-address class="address c small" address="directDebit.BillingAddress"></print-address>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-section" ng-if="pageState === \'success\'">\n\t\t<p class="s strong"><a href="" ng-click="closeForm()">Ok, close this window</a></p>\n\t</div>\n\n\t<!-- The legal bit -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="direct-debit-legalities">\n\n\t\t\t<!-- Trading details -->\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">{{$root.CONFIG.companyName}}</p>\n\t\t\t\t<p class="s">{{$root.CONFIG.companyAddress}}</p>\n\t\t\t\t<p class="s"><a href="tel:{{$root.CONFIG.companyPhoneNumber}}">{{$root.CONFIG.companyPhoneNumber}}</a>, <a href="mailto:{{$root.CONFIG.companyEmail}}">{{$root.CONFIG.companyEmail}}</a></p>\n\t\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" class="direct-debit-legalities-logo">\n\t\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- DD Guarantee -->\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="s">Your payments are protected by the <a href="" ng-click="setPageState(\'direct-debit-guarantee\')">Direct Debit Guarantee</a></p>\n\t\t\t</div>\n\n\t\t\t<!-- Powered by GoCardless -->\n\t\t\t<div class="form-section">\n\t\t\t\t<a href="" ng-href="{{$root.URLS.goCardless.website}}" target="_blank"><img src="images/graphics/powered-by-gocardless.png" alt="Powered by GoCardless" width="150" class="pricing-plan-summary-card-powered-by"></a>\n\t\t\t\t<p class="s">Read the GoCardless <a href="" ng-href="{{$root.URLS.goCardless.privacyNotice}}" target="_blank">privacy notice</a>.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="pageState === \'review\'">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="directDebitReviewForm.state" disable-button="!directDebitReviewForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-show-close="false" ng-if="pageState === \'direct-debit-guarantee\'">\n\t<fs-main>\n\t\t<div class="form-section">\n\t\t\t<a href="" ng-href="{{$root.URLS.directDebit.website}}" target="_blank">\n\t\t\t\t<img src="images/graphics/direct-debit@2x.png" alt="Direct Debit Guarantee" width="82" class="pricing-plan-summary-card-powered-by">\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<h4 class="strong">Direct Debit Guarantee</h4>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<p class="s">The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</p>\n\t\t\t<p class="s">If there are any changes to the amount, date or frequency of your Direct Debit Hamilton Enterpris will notify you (normally 3 working days) in advance of your account being debited or as otherwise agreed. If you request Hamilton Enterpris to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</p>\n\t\t\t<p class="s">If an error is made in the payment of your Direct Debit, by Hamilton Enterpris or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society.</p>\n\t\t\t<p class="s">If you receive a refund you are not entitled to, you must pay it back when Hamilton Enterpris asks you to.</p>\n\t\t\t<p class="s">You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify Hamilton Enterpris.</p>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<button class="secondary-action" ng-click="setPageState(previousPageState)">Done</button>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/financials/financialsForm.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Confirm connect -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to connect to Access Financials?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmConnect">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tWe\u2019ll connect to Access Financials and you\u2019ll then be able to select an organisation to give Paycircle access to.\n\t\t\tClick &lsquo;Connect&rsquo; if you\u2019re happy to continue.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.connect()">Connect</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Connected -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Connected to Access Financials" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connected">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou\u2019ve successfully connected to Access Financials. To import the Chart of Accounts click on the\n\t\t\t\t\u2018Import\u2019 button in the nominal codes area, and select the Access Financials option in the importer.\n\t\t\t\tYou can disconnect from Access Financials at any time from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong">\n\t\t\t\t<a data-cy="slide-in-form-close-link" href="" ng-click="$ctrl.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Instance Selection -->\n<form ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.instanceSelection" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tSelect an organisation to give Paycircle access to:\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="authorise-connection_section">\n\n\t\t\t<search-bar bulk-items="$ctrl.accessFinancialsTenants" count="$ctrl.accessFinancialsTenants.filtered.length" options="$ctrl.searchBarOptions"></search-bar>\n\n\t\t\t<section class="tenant-cards" ng-if="$ctrl.accessFinancialsTenants.all.length !== 0">\n\t\t\t\t<div class="tenant-card" dir-paginate="tenant in $ctrl.accessFinancialsTenants.filtered = (\n\t\t\t\t\t\t\t$ctrl.accessFinancialsTenants.all |\n\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" ng-click="$ctrl.updateAccessFinancialsInstance(tenant)">\n\t\t\t\t\t<span class="tenant-card_label">{{tenant.Name}}</span>\n\n\t\t\t\t\t<a href="" class="tenant-card_overlay-action link-with-icon primary">\n\t\t\t\t\t\tSelect&nbsp;&nbsp;<i class="icon-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="$ctrl.accessFinancialsTenants.filtered.length === 0" search-bar-options="$ctrl.searchBarOptions"></empty-search>\n\t\t\t</section>\n\n\t\t\t<!-- \'No organisations found\' placeholder -->\n\t\t\t<div class="tenant-cards_placeholder">\n\t\t\t\t<placeholder ng-if="$ctrl.accessFinancialsTenants.all.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-companies">\n\t\t\t\t\t<placeholder-title>No organisations found</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>Check that you\'re using the same email address you use for your Access Financials account before trying again.</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t</fieldset>\n</form>\n\n<!-- Confirm disconnect -->\n<form class="fadeIn" name="disconnectForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect" ng-submit="$ctrl.disconnect($ctrl, disconnectForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to disconnect from Access Financials?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tOnce disconnected you\'ll no longer be able to import your Chart of Accounts or post journals to Access Financials. \n\t\t\t\tPlease note that this won\'t affect any other companies you may have connected to the same organisation in Access Financials. \n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\'re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!disconnectForm.$valid" display-text="\'Confirm\'" state="disconnectForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Disconnected -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Disconnected from Access Financials" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.disconnected">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou can connect to Access Financials again at any time from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong">\n\t\t\t\t<a data-cy="slide-in-form-close-link" href="" ng-click="$ctrl.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/historicTaxPeriod/historicTaxPeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="saveHistoricTaxPeriodForm" ng-submit="saveHistoricTaxPeriod(saveHistoricTaxPeriodForm, agencyPayment)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="formEditState === FORM_EDIT_STATES.createNew">\n\t\t<p class="s">\n\t\t\tSelect an earlier tax month from the current tax year, enter the figures from the respective P32, and we\'ll suggest what would have been due to HMRC based on those figures.\n\t\t</p>\n\t</div>\n\n\t<!-- You can\'t change the period date when in view/edit mode -->\n\t<fieldset>\n\t\t<div class="form-field-highlight primary">\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="taxPeriod" class="required" ng-class="{ \'is-greyscale\': formEditState === FORM_EDIT_STATES.viewOrEdit }">Tax period:</label>\n\t\t\t\t<select ng-if="formEditState === FORM_EDIT_STATES.createNew" id="taxPeriod" name="taxPeriod" ng-options="payPeriod as payPeriod.TaxPeriodName for payPeriod in agencyPayment.payPeriods" ng-model="agencyPayment.selectedPayPeriod" ng-change="selectedPayPeriodChange(agencyPayment, agencyPayment.selectedPayPeriod)" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t\t<!-- When editing, show the pay period display in the disabled select dropdown -->\n\t\t\t\t<select ng-if="formEditState === FORM_EDIT_STATES.viewOrEdit" id="taxPeriod" name="taxPeriod" ng-disabled="true" ng-options="payPeriod as payPeriod.TaxPeriodName for payPeriod in agencyPayment.payPeriods" ng-model="agencyPayment.selectedPayPeriod">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="tax" class="required">Tax:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="tax" name="tax" class="monetise" ng-model="agencyPayment.AgencyPaymentTax" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="employeeNic" class="required">Employee NIC:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="employeeNic" name="employeeNic" class="monetise" ng-model="agencyPayment.AgencyPaymentEENI" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="employerNic" class="required">Employer NIC:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="employerNic" name="employerNic" class="monetise" ng-model="agencyPayment.AgencyPaymentERNI" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="studentLoan" class="required">Student Loan:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="studentLoan" name="studentLoan" class="monetise" ng-model="agencyPayment.AgencyPaymentSL" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="postGraduateLoan" class="required">Postgraduate loan:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="postGraduateLoan" name="postGraduateLoan" class="monetise" ng-model="agencyPayment.AgencyPaymentPGL" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="employmentAllowanceClaimed" class="required">Employment allowance claimed:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="employmentAllowanceClaimed" name="employmentAllowanceClaimed" class="monetise" ng-model="agencyPayment.AgencyPaymentEmployerAllowance" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="smpRecovered" class="required">SMP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="smpRecovered" name="smpRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentSMPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="sppRecovered" class="required">SPP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="sppRecovered" name="sppRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentSPPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="sapRecovered" class="required">SAP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="sapRecovered" name="sapRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentSAPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="shppRecovered" class="required">ShPP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="shppRecovered" name="shppRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentShPPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="spbpRecovered" class="required">SPBP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="spbpRecovered" name="spbpRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentSPBPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="sncpRecovered" class="required">SNCP recovered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="sncpRecovered" name="sncpRecovered" class="monetise" ng-model="agencyPayment.AgencyPaymentSNCPRecovered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="advanceFundingReceived" class="required">Advance funding received:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="advanceFundingReceived" name="advanceFundingReceived" class="monetise" ng-model="agencyPayment.AgencyPaymentAdvanceFundingReclaimed" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="cisDeductions" class="required">CIS deductions:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="cisDeductions" name="cisDeductions" class="monetise" ng-model="agencyPayment.AgencyPaymentCISDeduction" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="cisDeductionsSuffered" class="required">CIS deductions suffered:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="cisDeductionsSuffered" name="cisDeductionsSuffered" class="monetise" ng-model="agencyPayment.AgencyPaymentCISDeductionSuffered" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="apprenticeshipLevyAmountDue" class="required">Apprenticeship Levy amount due:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="number" id="apprenticeshipLevyAmountDue" name="apprenticeshipLevyAmountDue" class="monetise" ng-model="agencyPayment.AgencyPaymentLevyAmount" ng-change="recalculateHMRCDueAmount(agencyPayment)" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\t<fieldset>\n\t\t<calculation-card title="Total due to HMRC:" amount="agencyPayment.totalDue" busy="false"></calculation-card>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Cancel -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<!-- Save -->\n\t\t<submit-button display-text="\'Save\'" state="saveHistoricTaxPeriodForm.state" disable-button="!saveHistoricTaxPeriodForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Historic tax period {{formEditState === FORM_EDIT_STATES.createNew ? \'saved\' : \'updated\'}}" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s" ng-if="formEditState === FORM_EDIT_STATES.createNew">\'{{agencyPayment.selectedPayPeriod.TaxPeriodName}}\' has been saved and is now listed in your pay period history.</p>\n\t\t<p class="s" ng-if="formEditState === FORM_EDIT_STATES.viewOrEdit">\'{{agencyPayment.selectedPayPeriod.TaxPeriodName}}\' has been updated.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="No historic tax periods available" ng-if="pageState === \'no-historic-periods\'">\n\t<fs-main>\n\t\t<p class="s">This is because you are currently in the first tax month of the current tax year and historic tax periods can only be added for the current tax year.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/journal-code-format/journal-code-format.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="journalCodeFormatForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateJournalCodeFormat($ctrl, journalCodeFormatForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tMake sure you\u2019ve selected the &lsquo;Full journal code&rsquo; header to be included in your custom journal report template.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<message-bar theme="indifferent">\n\t\t\t\t<h6 class="indifferent">Full journal code format</h6>\n\t\t\t\t<h3 class="journal-code-preview_segments">\n\t\t\t\t\t<span class="journal-code-preview_segment" ng-class="{\n\t\t\t\t\t\t\t\'is-indifferent\': journalCode.preview === \'xxx\'\n\t\t\t\t\t\t}" ng-repeat="journalCode in $ctrl.journalCodesActive" title="journalCode.name">\n\t\t\t\t\t\t{{!$first ? $ctrl.journalCodeFormat.delimiterChar : \'\'}}{{journalCode.preview}}\n\t\t\t\t\t</span>\n\t\t\t\t</h3>\n\t\t\t</message-bar>\n\t\t</div>\n\n\t\t<!-- Delimiter toggle -->\n\t\t<div class="form-field">\n\t\t\t{{$ctrl.journalCode.JournalCodeFormatDelimiter}}\n\t\t\t<toggle-input field-label="Use delimiter" field-model="$ctrl.journalCodeFormat.isDelimited" field-name="isDelimited" field-on-change="$ctrl.reviewDelimiter($ctrl)"></toggle-input>\n\t\t</div>\n\n\t\t<!-- Delimiter dropdown -->\n\t\t<div class="form-field" ng-if="$ctrl.journalCodeFormat.isDelimited">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="selectField">Select delimiter</label>\n\t\t\t</div>\n\t\t\t<div class="journal-code-format_delimiter-dropdown">\n\t\t\t\t<select class="xl-alt" id="selectField" name="selectField" ng-model="$ctrl.journalCodeFormat.JournalCodeFormatDelimiter" ng-change="$ctrl.reviewDelimiter($ctrl)" ng-options="option.value as option.description for option in $ctrl.DELIMITER_SELECT_OPTIONS" required></select>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<hr class="xl">\n\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Sub-code order</h4>\n\t\t\t<p>Select which codes are included, and in what order they should appear in your full journal codes:</p>\n\t\t</div>\n\n\t\t<div>\n\n\t\t\t<!-- Active -->\n\t\t\t<div class="journal-code-preview_card" ng-repeat="(journalCodeIndex, journalCode) in $ctrl.journalCodesActive">\n\n\t\t\t\t<div class="journal-code-preview_details">\n\t\t\t\t\t<input checkbox id="activeCheckboxField_{{journalCode.originalIndex}}" label-text="journalCode.name" label-text-class="journal-code-preview_details-strong" name="activeCheckboxField_{{journalCode.originalIndex}}" ng-change="$ctrl.hideJournalCode($ctrl, journalCode.originalIndex)" ng-disabled="$ctrl.journalCodesActive.length <= 1" ng-model="journalCode.isActive" type="checkbox">\n\t\t\t\t</div>\n\n\t\t\t\t<span class="journal-code-preview_card-abbr strong">{{journalCode.abbr}}</span>\n\t\t\t\t\n\t\t\t\t<div class="journal-code-preview_card-actions">\n\t\t\t\t\t<a aria-label="Increase code position" class="badge is-primary-lighter is-extra-small has-hover-state" href="" ng-click="$ctrl.incrementCodePosition($ctrl, journalCodeIndex)" ng-if="$ctrl.journalCodesActive.length > 1">\n\t\t\t\t\t\t<i class="icon-chevron-up"></i>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a aria-label="Decrease code position" class="badge is-primary-lighter is-extra-small has-hover-state" href="" ng-click="$ctrl.decrementCodePosition($ctrl, journalCodeIndex)" ng-if="$ctrl.journalCodesActive.length > 1">\n\t\t\t\t\t\t<i class="icon-chevron-down"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Hidden -->\n\t\t\t<div class="journal-code-preview_card is-hidden" ng-repeat="(hiddenJournalCodeIndex, hiddenJournalCode) in $ctrl.journalCodesHidden">\n\t\t\t\t<div class="journal-code-preview_details">\n\t\t\t\t\t<input checkbox id="hiddenCheckboxField_{{hiddenJournalCode.originalIndex}}" label-text="hiddenJournalCode.name" label-text-class="journal-code-preview_details-strong" name="hiddenCheckboxField_{{hiddenJournalCode.originalIndex}}" ng-change="$ctrl.unhideJournalCode($ctrl, hiddenJournalCode.originalIndex)" ng-model="hiddenJournalCode.isActive" type="checkbox">\n\t\t\t\t</div>\t\n\n\t\t\t\t<span class="journal-code-preview_card-abbr strong">{{hiddenJournalCode.abbr}}</span>\n\n\t\t\t\t<div class="journal-code-preview_card-actions">\n\t\t\t\t\t<i class="icon-hidden is-medium" ng-class="{\'is-greyscale-lightened\': !hiddenJournalCode.isActive}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="journalCodeFormatForm.state" ng-if="journalCodeFormatForm.state === \'saved\'">\n\t\t\t<p>Feedback option 1: A bit of feedback to say the form has been saved successfully inline and the form is still open</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!journalCodeFormatForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="journalCodeFormatForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a href="" ng-if="$ctrl.formOptions.canSkip" class="button tertiary-action" ng-click="$ctrl.formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Feedback option 2" ng-if="$ctrl.formState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A new state for the form to navigate to</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setFormState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/journal-code-financials/journal-code-financials.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn journal-code-financials-form" name="journalCodeFinancialsForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateFinancialsCategoryMappings($ctrl, journalCodeFinancialsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tWe\u2019ve found the following journal code format in Access Financials, and mapped the \'Nominal code\'\n\t\t\tin Paycircle to \'Nominal details\'. Map any remaining business categories in Paycircle to your\n\t\t\tAccess Financials nominal categories. Switch on the toggle against a category to add a control\n\t\t\taccount code.\n\t\t</p>\n\t</div>\n\n\t<!-- Journal code preview -->\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<message-bar theme="indifferent">\n\t\t\t\t<!-- Financials -->\n\t\t\t\t<h6 class="indifferent">Access Financials code format</h6>\n\t\t\t\t<h3 class="journal-code-preview_segments">\n\t\t\t\t\t<span class="journal-code-preview_segment" data-cy="journal-code-preview-financials">\n\t\t\t\t\t\t{{$ctrl.financialsJournalCode}}\n\t\t\t\t\t</span>\n\t\t\t\t</h3>\n\n\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t<hr class="journal-code-preview_segments_spacer">\n\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\n\t\t\t\t<!-- Paycircle -->\n\t\t\t\t<h6 class="indifferent">Paycircle code format</h6>\n\t\t\t\t<h3 class="journal-code-preview_segments">\n\t\t\t\t\t<span class="journal-code-preview_segment" data-cy="journal-code-preview-paycircle">\n\t\t\t\t\t\t{{$ctrl.journalCodePreview}}\n\t\t\t\t\t</span>\n\t\t\t\t</h3>\n\t\t\t</message-bar>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Category mapping -->\n\t<fieldset>\n\t\t\t\n\t\t\t<div class="financials-category_card" data-cy="financials-category-card-{{$index}}" ng-repeat="accessFinancialsCategory in $ctrl.accessFinancialsCategories">\n\n\t\t\t\t<div class="financials-category_card-selects">\n\n\t\t\t\t\t<!-- Financials category -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="selectField">Access Financials:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input data-cy="financials-category-input" id="inputField" name="inputField" ng-model="accessFinancialsCategory.Name" type="text" value="{{accessFinancialsCategory.Name}}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="financials-category_card-selects-arrow">\n\t\t\t\t\t\t<i class="primary icon-arrow-right"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Paycircle category -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="selectField-{{accessFinancialsCategory.ID}}">Paycircle:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input data-cy="paycircle-nominal-category-input" id="inputField" name="inputField" ng-if="accessFinancialsCategory.IsNominalDetailCategory" ng-value="\'Nominal code\'" type="text">\n\t\t\t\t\t\t\t<select class="l-alt" data-cy="paycircle-category-select" id="selectField-{{accessFinancialsCategory.ID}}" name="selectField-{{accessFinancialsCategory.ID}}" ng-change="$ctrl.selectPaycircleCategory(journalCodeFinancialsForm, accessFinancialsCategory)" ng-if="!accessFinancialsCategory.IsNominalDetailCategory" ng-model="accessFinancialsCategory.paycircleCategory" ng-options="paycircleCategory as paycircleCategory.BusinessCategoryName for paycircleCategory in $ctrl.paycircleCategories | orderBy: \'BusinessCategoryName\'" required value="{{accessFinancialsCategory.paycircleCategory.BusinessCategoryName}}"></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="journalCodeFinancialsForm[\'selectField-\' + accessFinancialsCategory.ID].$touched" ng-messages="journalCodeFinancialsForm[\'selectField-\' + accessFinancialsCategory.ID].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Control account code -->\n\t\t\t\t<div class="financials-category_card-toggle" ng-if="!accessFinancialsCategory.IsNominalDetailCategory && accessFinancialsCategory.paycircleCategory">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<toggle-input data-cy="control-account-toggle" field-label="Add control account code" field-model="accessFinancialsCategory.paycircleCategory.hasControlAccountCode" field-name="useControlAccountCode-{{$index}}" value="{{accessFinancialsCategory.paycircleCategory.hasControlAccountCode}}"></toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field" ng-if="accessFinancialsCategory.paycircleCategory.hasControlAccountCode">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="textField-{{$index}}">Control account code:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input data-cy="control-account-code" id="textField-{{$index}}" name="textField-{{$index}}" ng-maxlength="128" ng-model="accessFinancialsCategory.paycircleCategory.BusinessCategoryDefaultCodeValue" ng-pattern="$root.REGEX.lettersAndNumbers" placeholder="Type here..." required type="text" value="{{accessFinancialsCategory.paycircleCategory.BusinessCategoryDefaultCodeValue}}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="journalCodeFinancialsForm[\'textField-\' + $index].$touched" ng-messages="journalCodeFinancialsForm[\'textField-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="maxlength">Enter a maximum of 128 characters</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Enter letters or numbers only</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!journalCodeFinancialsForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="journalCodeFinancialsForm.state"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/journal-post-temporal-data/journal-post-temporal-data.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="journalPostTemporalDataForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateJournalPostSettings($ctrl.formOptions.postGroup, journalPostTemporalDataForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Your new post can use the journals settings at the time payroll was run or the latest settings. Once you\u2019ve added your new post you\u2019ll able to preview the data before posting.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">Which journal settings do you wish to use?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="overrideTemporalDataPayroll" name="overrideTemporalData" ng-model="$ctrl.formOptions.postGroup.journalPostOverrideTemporalDataEnum" ng-value="$ctrl.TEMPORAL_DATA_ENUM.payroll" type="radio">\n\t\t\t\t\t\t<label for="overrideTemporalDataPayroll" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">When payroll was run</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="overrideTemporalDataLatest" name="overrideTemporalData" ng-model="$ctrl.formOptions.postGroup.journalPostOverrideTemporalDataEnum" ng-value="$ctrl.TEMPORAL_DATA_ENUM.latest" type="radio">\n\t\t\t\t\t\t<label for="overrideTemporalDataLatest" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Latest</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!journalPostTemporalDataForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="journalPostTemporalDataForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Post outstanding" ng-if="$ctrl.formState === \'post-outstanding\'">\n\t<fs-main>\n\t\t<p class="is-small">Please note that you can\u2019t have more than one outstanding post. You can adjust the journal settings as required, and preview the data of your outstanding post before posting it.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/manageCompanyGroups/manageCompanyGroupsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addToCompanyGroupForm" ng-submit="addToCompanyGroup(model.companyGroup, addToCompanyGroupForm)" ng-if="pageState === \'ready\'" class="fadeIn" novalidate>\n\n\t<!-- Has Groups -->\n\t<section class="form-section company-group-cards rows" ng-if="companyGroups.length">\n\t\t<p class="s" ng-if="availableGroups.length">{{formOptions.company.Name}} has been allocated to {{companyGroups.length}}&nbsp;<ng-pluralize count="companyGroups.length" when="{\'1\': \'group\', \'other\': \'groups\'}"></ng-pluralize>:</p>\n\t\t<p class="s" ng-if="!availableGroups.length">{{formOptions.company.Name}} has been allocated to all groups:</p>\n\t\t<div class="spacer m"></div>\n\t\t<company-group-card-basic company-group="companyGroup" remove-company-group="removeCompanyGroup(companyGroup, addToCompanyGroupForm)" ng-repeat="companyGroup in companyGroups"></company-group-card-basic>\n\t</section>\n\n\t<!-- No Groups -->\n\t<section class="form-section" ng-if="!companyGroups.length">\n\t\t<p class="s">{{formOptions.company.Name}} hasn\'t been allocated to any groups yet.&nbsp;<span ng-if="availableGroups.length">Select an existing group or create a new group below.</span></p>\n\t</section>\n\n\n\t<!-- Add to Company Group -->\n\t<fieldset ng-if="availableGroups.length">\n\n\t\t<!-- Company groups -->\n\t\t<div class="form-field">\n\t\t\t<label for="companyGroup" class="required">Add to a group:</label>\n\t\t\t<div class="field">\n\t\t\t\t<select id="companyGroup" name="companyGroup" ng-model="model.companyGroup" ng-options="availableGroup as availableGroup.Company.Name for availableGroup in availableGroups" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addToCompanyGroupForm.companyGroup.$error" ng-if="addToCompanyGroupForm.companyGroup.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a group</p>\n\t\t\t</div>\n\t\t</div>\n\t\t\n\t\t<!-- Warning note when customer codes don\'t match -->\n\t\t<fieldset class="form-fieldset" ng-if="isGroupCreationFeatureEnabled && isGroupLinkedToOrganisation && !isGroupChecking && model.companyGroup && !customerCodesMatch && !companyCustomerCodeMissing">\n\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Couldn\'t be added to group">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThe customer code for {{formOptions.company.Name}} ({{companyCustomerCode}}) is different to the customer code for this group ({{organisationCustomerCode}}). As this group has Access Evo features enabled, they must match. Go to the \'Customer codes\' area in your bureau settings to ensure a company has the right code before trying again.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\t\t\n\t\t<!-- Warning note when company customer code is missing -->\n\t\t<fieldset class="form-fieldset" ng-if="isGroupCreationFeatureEnabled && isGroupLinkedToOrganisation && !isGroupChecking && model.companyGroup && !customerCodesMatch && companyCustomerCodeMissing">\n\t\t\t<note note-animation="fadeIn" note-dismiss="false" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Couldn\'t be added to group">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t{{formOptions.company.Name}} don\'t have a customer code and, as this group has Access Evo features enabled, they need one that matches the customer code for this group ({{organisationCustomerCode}}). Go to the \'Customer codes\' area in your bureau settings to ensure a company has the right code before trying again.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!--\n\t<section class="form-section">\n\t\t<p class="s"><a href="" ng-click="openCreateNewCompanyGroupForm()" class="link-with-icon"><i class="icon-right"></i>Create a new group</a></p>\n\t</section>\n\t-->\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Make existing user admin -->\n\t\t<button class="tertiary primary-action" ng-disabled="!addToCompanyGroupForm.$valid || addToCompanyGroupForm.state || \n\t\t\t\t(isGroupCreationFeatureEnabled && isGroupLinkedToOrganisation && !customerCodesMatch)" ng-if="availableGroups.length">\n\t\t\t<span ng-show="!addToCompanyGroupForm.state">Add to group</span>\n\t\t\t<span ng-show="addToCompanyGroupForm.state"><i class="icon-loading spin"></i></span>\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Confirm remove group -->\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Remove from {{selectedCompanyGroup.Name}}?" ng-if="pageState === \'confirm-remove-from-group\'">\n\t<fs-main>\n\t\t<p class="s">If you remove {{formOptions.company.Name}} from {{selectedCompanyGroup.Name}}, some people with access to the group will no longer be able to see the company. You can easily add {{formOptions.company.Name}} back into the group from the Companies page.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Cancel</a>\n\t\t<a href="" class="button tertiary primary-action" ng-click="removeFromCompanyGroup(selectedCompanyGroup)">Remove from group</a>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/payslip-manager/payslip-manager.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Bulk import -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Bulk import of pay data" fs-theme="tertiary" ng-if="$ctrl.pageState === \'bulk-import-confirm\' ">\n\t<fs-main>\n\t\t<p class="is-small">Please note that the pay periods in your import file must match the pay periods you have set up for your company. If the pay periods cannot be matched by the importer then your data will fail to import correctly. Click &lsquo;Confirm&rsquo; if you\'re happy to continue.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="tertiary primary-action" ng-click="$ctrl.goToBulkImporter($ctrl)">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Skip this step -->\n<form name="bulkImportSkipForm" ng-submit="$ctrl.updateAgencyProfileIsPayslipManagerSetupComplete($ctrl, bulkImportSkipForm)" class="fadeIn" ng-if="$ctrl.pageState === \'bulk-import-skip\' " novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to skip bulk import?" fs-theme="tertiary">\n\t\t<fs-main>\n\t\t\t<p class="is-small">Please note that once you skip bulk import you will only be able to import data per individual pay period. Click &lsquo;Confirm&rsquo; if you\'re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Confirm\'" state="bulkImportSkipForm.state" disable-button="!bulkImportSkipForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Main run already imported -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="You\u2019ve already imported a main pay run" fs-theme="tertiary" ng-if="$ctrl.pageState === \'main-run-imported-previously\' ">\n\t<fs-main>\n\t\t<p class="is-small">Please note that if you import a full pay run again it will overwrite existing data. Click &lsquo;Confirm&rsquo; if you\'re happy to continue.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="tertiary primary-action" ng-click="$ctrl.goToBulkImporter($ctrl)">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Main run not imported -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Your main pay run hasn\'t been imported yet" fs-theme="tertiary" ng-if="$ctrl.pageState === \'main-run-not-imported\' ">\n\t<fs-main>\n\t\t<p class="is-small">Once you\'ve imported your main pay run you\'ll be able to import any supplementary pay runs for the period.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/payroll-overview/companyPayrollOverviewForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="form-intro">\n\t\t<p class="s">Review the questions you\'ve answered and any you\'ve marked for later. Click on the edit icon to jump back and edit anything you need to change.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\n\t\t<overview-data overview-groups="taskListGroups" on-edit="openEditCompanyPayrollWizard"></overview-data>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button primary-action tertiary" ng-click="formOptions.closeForm()">Close</a>\n\t\t</fieldset>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/pension-connector/companyPensionConnectorForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<section ng-if="pageState === PAGE_STATES.ready" ng-switch="vm.activeStep">\n\n\t<!-- Pension Type -->\n\t<form class="fadeIn" name="pensionTypeForm" ng-submit="loadStep(vm, false, pensionTypeForm)" pc-switch-when="CONNECTOR_FORMS.pensionType" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>Choose a type of pension</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tTeam members can only be in one AE pension scheme but can be in any number of non-AE pension schemes.\n\t\t\t\tNon-AE pension schemes don\u2019t include any of the automation options used for AE pensions and just require contribution levels to be setup for team members.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Pension type selector -->\n\t \t\t<div class="form-field">\n\t \t\t\t<div class="form-field-header">\n\t \t\t\t\t<label for="autoEnrolment" class="required">\n\t\t\t\t\t\tWhich type of pension do you wish to add?:\n\t\t\t\t\t</label>\n\t \t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="autoEnrolment" name="autoEnrolment" ng-change="onPensionTypeChange(vm.pension)" ng-disabled="!vm.pensionDetails.CanAddAEPension" ng-model="vm.pension.PensionType" ng-value="PENSION_TYPES.autoEnrolment" type="radio" required>\n\t\t\t\t\t\t\t<label class="radio-card-label" for="autoEnrolment">\n\t\t\t\t\t\t\t\t<i class="icon-money radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">AE Pension</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="nonAutoEnrolment" name="nonAutoEnrolment" ng-change="onPensionTypeChange(vm.pension)" ng-model="vm.pension.PensionType" ng-value="PENSION_TYPES.nonAutoEnrolment" type="radio" required>\n\t\t\t\t\t\t\t<label class="radio-card-label" for="nonAutoEnrolment">\n\t\t\t\t\t\t\t\t<i class="icon-money radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Non-AE Pension</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field" ng-if="!vm.pensionDetails.CanAddAEPension">\n\t\t\t\t<note note-dismiss-key="pension-types" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Looking to add an new AE pension?">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note: you can only add non-AE pensions at the moment. As you\u2019re running a Ghost pension,\n\t\t\t\t\t\t\tif you need to add a new AE pension, all you need to do is\n\t\t\t\t\t\t\t<a class="indifferent underline" href="" ng-click="goToGhostPensionSettings(vm.pensionDetails, formOptions.agencyProfileId)">\n\t\t\t\t\t\t\t\tgo to the pension settings page\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t, click the \u2018Edit\u2019 link in the pension provider section, then follow the steps to finish set up.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionTypeForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionTypeForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension Ghost -->\n\t<form class="fadeIn" name="pensionGhostForm" ng-submit="loadStep(vm, false, pensionGhostForm)" pc-switch-when="CONNECTOR_FORMS.pensionGhost" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>Just need to assess your team for now?</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tIf you don\u2019t wish to set up a pension just yet, but you\u2019d like team members to be assessed for auto-enrolment,\n\t\t\t\tyou can create a \u2018Ghost Pension\u2019 which doesn\'t require any pension scheme settings.\n\t\t\t\tThe system will then notifiy you when a team member becomes eligible and you can change your Ghost Pension settings to a real pension provider.\n\t\t\t\t<a class="underline" href="" ng-href="{{$root.URLS.paycircle.support.pensionGhost}}" ng-if="$root.URLS.paycircle.support.pensionGhost" target="_blank">\n\t\t\t\t\tRead more about Ghost pensions\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Is Ghost Pension -->\n\t \t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="ghostPensionOption1" name="ghostPension" ng-model="vm.pension.IsGhostPension" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="ghostPensionOption1">\n\t\t\t\t\t\t\t\t<i class="icon-rosette radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Choose a provider</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="ghostPensionOption2" name="ghostPension" ng-model="vm.pension.IsGhostPension" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="ghostPensionOption2">\n\t\t\t\t\t\t\t\t<i class="icon-clock radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">\n\t\t\t\t\t\t\t\t\tUse a Ghost Pension\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionGhostForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionGhostForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension Provider -->\n\t<form class="fadeIn" name="pensionProviderForm" ng-submit="loadStep(vm, false, pensionProviderForm)" novalidate pc-switch-when="CONNECTOR_FORMS.pensionProvider">\n\t\t<div class="form-intro">\n\t\t\t<h4>Choose your pension provider</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tYou should have already chosen your workplace pension provider and have a compliant scheme in place for your team.\n\t\t\t\tTell us if this is a new scheme or not then choose your provider from the options below.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset class="form-fieldset-divider">\n\n\t\t\t<!-- Is this a new pension scheme? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="scheme" class="required">\n\t\t\t\t\t\tIs this a new pension scheme?\n\t\t\t\t\t</label>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\ti.e. no contributions have been made into it yet\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t<input class="b" data-cy="is-pension-scheme-true" id="isPensionSchemeTrue" name="isPensionScheme" ng-model="vm.pension.IsNewScheme" ng-value="true" type="radio">\n\t\t\t\t\t<label for="isPensionSchemeTrue">Yes</label>\n\t\t\t\t\t<input class="b" data-cy="is-pension-scheme-false" id="isPensionSchemeFalse" name="isPensionScheme" ng-model="vm.pension.IsNewScheme" ng-value="false" type="radio">\n\t\t\t\t\t<label for="isPensionSchemeFalse">No</label>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Direct connect providers -->\n\t\t<fieldset ng-if="vm.directConnectionProviders.length > 0">\n\n\t\t\t<!-- Direct providers -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="pensionProvider0" class="{{vm.manuallyEnterPension ? \'disabled\' : \'required\'}}">\n\t\t\t\t\t\tDirect connection providers\n\t\t\t\t\t</label>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPaycircle can connect to these providers directly to send and receive data.\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t<div class="pension-provider-cards cards is-fixed">\n\t\t\t\t\t\t<div class="pension-provider-card-radio" ng-repeat="pensionProvider in vm.directConnectionProviders">\n\t\t\t\t\t\t\t<input class="pension-provider-card-radio-input" data-cy="pension-provider-direct-{{::$index}}" id="pensionProvider{{$index}}" name="pensionProviders" ng-change="onPensionProviderSelect(vm, pensionProvider)" ng-class="{\'is-faded\': pensionProviderForm.pensionProviders.$valid}" ng-disabled="vm.manuallyEnterPension" ng-model="vm.pension.PensionProviderID" ng-required="!vm.manuallyEnterPension" ng-value="pensionProvider.PensionProviderID" type="radio">\n\t\t\t\t\t\t\t<label class="pension-provider-card-radio-label" for="pensionProvider{{$index}}">\n\t\t\t\t\t\t\t\t<img alt="{{pensionProvider.PensionProviderName}}" class="pension-provider-card-logo" ng-src="{{pensionProvider.PensionProviderImageUrl}}">\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Manual providers -->\n\t\t<fieldset class="form-fieldset-divider">\n\n\t\t\t<!-- Manual providers -->\n\t \t\t<div class="form-field" ng-if="vm.manualProviders.length > 0">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="manualPensionProvider0" class="{{vm.manuallyEnterPension ? \'disabled\' : \'required\'}}">Manual providers</label>\n\t\t\t\t\t<p class="is-small">You will need to upload your pension file to these providers each time you run payroll and manage your teams&apos; opt in and opt out requests manually.</p>\n\t\t\t\t</header>\n\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split">\n\t\t\t\t\t\t<div class="radio-card" ng-repeat="pensionProvider in vm.manualProviders">\n\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="pension-provider-manual-{{::$index}}" id="manualPensionProvider{{$index}}" name="pensionProviders" ng-change="onPensionProviderSelect(vm, pensionProvider)" ng-disabled="vm.manuallyEnterPension" ng-model="vm.pension.PensionProviderID" ng-required="!vm.manuallyEnterPension" ng-value="pensionProvider.PensionProviderID" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="manualPensionProvider{{$index}}">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">{{pensionProvider.PensionProviderName}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t \t\t</div>\n\t \t</fieldset>\n\n\t \t<fieldset>\n\n\t\t\t<!-- Pension provider not shown -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="field">\n\t\t\t\t\t<label for="manuallyEnterPension" class="hidden">Manually Enter Pension</label>\n\t\t\t\t\t<input checkbox id="manuallyEnterPension" label-text="\'My provider isn&#8217;t shown above\'" name="manuallyEnterPension" ng-change="onManualPensionInputChange(vm)" ng-model="vm.manuallyEnterPension" type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pension provider name -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.manuallyEnterPension">\n\t\t\t\t<label class="required" for="manualPensionName">\n\t\t\t\t\tEnter your provider name\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="manualPensionName" name="manualPensionName" ng-model="vm.pension.PensionProviderName" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionProviderForm.manualPensionName.$touched" ng-messages="pensionProviderForm.manualPensionName.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter pension provider name\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionProviderForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionProviderForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension Automation -->\n\t<form class="fadeIn" name="pensionAutomationForm" ng-submit="loadStep(vm, false, pensionAutomationForm)" novalidate pc-switch-when="CONNECTOR_FORMS.pensionAutomation">\n\t \t<div class="form-intro">\n\t\t\t<h4>Automation options</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tPaycircle can automate many of your workplace pension management tasks. Use the toggle options below to manage your workplace pension automation settings.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Note: Direct connections -->\n\t\t<div class="form-field" ng-if="vm.selectedPensionProvider.PensionProviderHasAPI">\n\t\t\t<note note-dismiss-key="pension-automation-form-1" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Looking to connect directly to {{vm.selectedPensionProvider.PensionProviderName}}?">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tIf you\u2019d like to connect directly to {{vm.selectedPensionProvider.PensionProviderName}}, and this isn\u2019t a brand new pension,\n\t\t\t\t\t\tit\u2019s critical you check that the information in your {{vm.selectedPensionProvider.PensionProviderName}} portal is up to date. This should ensure that your pension submissions don\'t fail. We recommend you check the following:\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'All enrolments that have occurred before your current pay period are up to date\',\n\t\t\t\t\t\t\t\t\'All contributions that have been paid before your current pay period are up to date\',\n\t\t\t\t\t\t\t\t\'All team members who have opted out or ceased membership before your current period are up to date\',\n\t\t\t\t\t\t\t\t\'Your pension period dates are the same as those in your provider portal\'\n\t\t\t\t\t\t\t]" bl-theme="is-indifferent is-small is-spaced-out"></bullet-list>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tFor more information, read our\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionSubmissionTroubleshooting" theme="indifferent" underline="true">\n\t\t\t\t\t\t\ttroubleshooting guide to pension submissions\n\t\t\t\t\t\t</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="settings-rows">\n\n\t\t\t\t\t<!-- Team Assessment -->\n\t\t\t\t\t<settings-row ng-model="vm.pension.AssessTeam" on-update="onAssessTeamChange(vm.pension)" sr-field-name="assessTeam" sr-theme="secondary">\n\t\t\t\t\t\t<sr-label>Team assessment</sr-label>\n\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\tAutomatic team assessment comes as standard. Paycircle will assess your team each time you run payroll\n\t\t\t\t\t\t\tand automatically enrol anyone who becomes eligible.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Connect directly -->\n\t\t\t\t\t<settings-row ng-if="vm.selectedPensionProvider.PensionProviderHasAPI && !vm.pension.IsGhostPension" ng-model="vm.pension.ConnectToProvider" on-update="onConnectToProviderChange(vm.pension)" sr-disabled="!vm.pension.AssessTeam || vm.pension.UsePensionPolicy" sr-field-name="connectToProvider" sr-theme="secondary">\n\t\t\t\t\t\t<sr-label>Connect directly to {{vm.selectedPensionProvider.PensionProviderName}}</sr-label>\n\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\tPaycircle will send your pension data directly to your pension provider and receive updates,\n\t\t\t\t\t\t\tsuch as opt in and opt out notices and information regarding pension group changes.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Send pension comms -->\n\t\t\t\t\t<settings-row ng-model="vm.pension.SendCommunications" sr-field-name="sendCommunications" sr-theme="secondary">\n\t\t\t\t\t\t<sr-label>Send pension status communications</sr-label>\n\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\tPaycircle will automatically send pension related communications to all of your team members via email and store\n\t\t\t\t\t\t\tthem in your communications centre - keeping you compliant at all times.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Manual tasks -->\n\t\t<fieldset class="fadeIn" ng-if="!vm.pension.ConnectToProvider || !vm.pension.SendCommunications">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6 class="stronger">Manual pension tasks</h6>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tTurning off automation options means that you will need to manage those tasks manually.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="task-overview-blocks">\n\n\t\t\t\t\t<div class="task-overview-block secondary" ng-if="!vm.pension.AssessTeam">\n\t\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t\t<h6 class="task-overview-block-title">Team assessment - OFF</h6>\n\t\t\t\t\t\t\t<p class="task-overview-block-subtitle">\n\t\t\t\t\t\t\t\tManage the statuses of your team members manually\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="task-overview-block-action" href="" ng-click="toggleShowOverviewDetailsTeam(vm)">\n\t\t\t\t\t\t\t\t<i class="icon-clipboard"></i>&nbsp;4 tasks <i class="icon-chevron-{{vm.showOverviewDetailsTeam ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="vm.showOverviewDetailsTeam">\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Team members will not be assessed for auto-enrolment and re-enrolment so you will need to keep their pension statuses up-to-date in the respective pension or in the pension area in their profile.\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-secondary"></bullet-list>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="task-overview-block secondary" ng-if="!vm.pension.ConnectToProvider">\n\t\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t\t<h6 class="task-overview-block-title">Connect directly to {{vm.selectedPensionProvider.PensionProviderName}} - OFF</h6>\n\t\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage the synchronisation of your payroll and pension manually</p>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleShowOverviewDetailsConnect(vm)" class="task-overview-block-action">\n\t\t\t\t\t\t\t\t<i class="icon-clipboard"></i>&nbsp;4 tasks <i class="icon-chevron-{{vm.showOverviewDetailsConnect ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<section class="task-overview-block-main dropIn fast" ng-if="vm.showOverviewDetailsConnect">\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Download pension files from Paycircle and upload them to your pension provider\\\'s portal each pay period\',\n\t\t\t\t\t\t\t\t\t\'Update Paycircle when someone chooses to opt in, opt out or cease membership\',\n\t\t\t\t\t\t\t\t\t\'Update Paycircle if your company or a team member changes their pension contribution percentages or amounts\',\n\t\t\t\t\t\t\t\t\t\'Update Paycircle when you set up a new workplace pension group or move team member between groups\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="task-overview-block secondary" ng-if="!vm.pension.SendCommunications">\n\t\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t\t<h6 class="task-overview-block-title">Send pension status communications - OFF</h6>\n\t\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage workplace pension communications to your team manually</p>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleShowOverviewDetailsComms(vm)" class="task-overview-block-action">\n\t\t\t\t\t\t\t\t<i class="icon-clipboard"></i>&nbsp;7 tasks <i class="icon-chevron-{{vm.showOverviewDetailsComms ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<section class="task-overview-block-main dropIn fast" ng-if="vm.showOverviewDetailsComms">\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Send pension assessment notices to new team members to tell them when they are going to be assessed\',\n\t\t\t\t\t\t\t\t\t\'Send postponement notices to new team members when they join the company - if you are using postponement for new team members\',\n\t\t\t\t\t\t\t\t\t\'Send change in status notices to team members each time their enrolment status changes\',\n\t\t\t\t\t\t\t\t\t\'Send postponement notices to team members when their enrolment status changes - if you are using postponement for team member threshold changes\',\n\t\t\t\t\t\t\t\t\t\'Send enrolment notices when a team member gets enrolled into a workplace pension\',\n\t\t\t\t\t\t\t\t\t\'Send re-enrolment assessment notices to team members when your company goes through its cyclical 3 year re-enrolment process\',\n\t\t\t\t\t\t\t\t\t\'Send re-enrolment notices to team members who are re-enrolled when your company goes through its cyclical 3 year re-enrolment process\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionAutomationForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionAutomationForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension staging/start date/DoC -->\n\t<form class="fadeIn" name="pensionStagingDateForm" ng-submit="loadStep(vm, false, pensionStagingDateForm)" pc-switch-when="CONNECTOR_FORMS.pensionStagingDate" novalidate>\n\t\t<!-- Staging/start date -->\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Pension staging/start date</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tTell us the company\'s staging/start date and whether they chose to postpone, and the next re-enrolment date.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Start date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="stagingDate">\n\t\t\t\t\tStart Date:\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<date-input-field field-id="stagingDate" field-max-date-iso="vm.stagingDateBoundaries.stagingDateISOMax" field-value-iso="vm.pension.StagingDateISO" field-on-change-fn="onStagingDateChange(vm)">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionStagingDateForm.stagingDate.$touched" ng-messages="pensionStagingDateForm.stagingDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter start date</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t<p ng-message="max">Please enter a date before {{vm.stagingDateBoundaries.stagingDateISOMax | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Start date postponed -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="stagingPostponed">\n\t\t\t\t\t\tAre you postponing your start date?\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t<!-- Yes -->\n\t\t\t\t\t<input class="b" id="stagingPostponedTrue" name="stagingPostponed" ng-model="vm.pension.IsStagingPostponed" ng-value="true" type="radio">\n\t\t\t\t\t<label for="stagingPostponedTrue">Yes</label>\n\t\t\t\t\t<!-- No -->\n\t\t\t\t\t<input class="b" id="stagingPostponedFalse" name="stagingPostponed" ng-model="vm.pension.IsStagingPostponed" ng-value="false" type="radio">\n\t\t\t\t\t<label for="stagingPostponedFalse">No</label>\n\t\t\t\t</section>\n\t\t\t</div>\n\n\t\t\t<!-- Staging postponement date -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.pension.IsStagingPostponed">\n\t\t\t\t<label class="required" for="stagingPostponementDate">\n\t\t\t\t\tPostponement date:\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<date-input-field field-id="stagingPostponementDate" field-min-date-iso="vm.postponementDateBoundaries.postponedDateMinISO" field-max-date-iso="vm.postponementDateBoundaries.postponedDateMaxISO" field-value-iso="vm.pension.PostponementDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionStagingDateForm.stagingPostponementDate.$touched" ng-messages="pensionStagingDateForm.stagingPostponementDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter staging postponement date</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t<p ng-message="min || max">\n\t\t\t\t\t\tThis date needs to be between {{vm.postponementDateBoundaries.postponedDateMinISO | dateformat:\'long\'}} -\n\t\t\t\t\t\t{{vm.postponementDateBoundaries.postponedDateMaxISO | dateformat:\'long\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Note: Calculating contributions -->\n\t\t\t<div class="form-field">\n\t\t\t\t<note note-dismiss-key="pension-staging-date-1" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Calculating contributions">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPaycircle cannot calculate past or missed contributions, only contributions from when the pension is set up on Paycircle.\n\t\t\t\t\t\t\tAny missed contributions or fines need to be dealt with directly with The Pensions Regulator.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Re-enrolment info -->\n\t\t\t<div class="form-field">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t<span class="fadeIn" ng-if="!vm.validationResults.CompanyIsInReenrolmentWindow">\n\t\t\t\t\t\tYour re-enrolment date is the third anniversary of your start date. You can adjust this to a date within a 6 month window however.\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class="fadeIn" ng-if="vm.validationResults.CompanyIsInReenrolmentWindow">\n\t\t\t\t\t\tBased on the start date entered, you\u2019re currently in your 6 month re-enrolment window\n\t\t\t\t\t\t({{vm.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'dayMonth\'}} -\n\t\t\t\t\t\t{{vm.validationResults.ReenrolmentWindowEndDateISO | dateformat:\'dayMonthYear\'}}) and you may have completed re-enrolment.\n\t\t\t\t\t</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Staging date in Re-enrolment window (3 years before current period start date) -->\n\t\t\t<fieldset class="fadeIn" ng-if="vm.validationResults.CompanyIsInReenrolmentWindow">\n\n\t\t\t\t<!-- Completed re-enrolment -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="reenrolmentCompleted">\n\t\t\t\t\t\t\tHave you already completed re-enrolment?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t\t<input type="radio" name="reenrolmentCompleted" id="reenrolmentCompletedTrue" class="b" ng-value="true" ng-model="vm.pension.ReenrolmentAlreadyCompleted" ng-change="validateReenrolmentDate(vm)">\n\t\t\t\t\t\t<label for="reenrolmentCompletedTrue">Yes</label>\n\t\t\t\t\t\t<input type="radio" name="reenrolmentCompleted" id="reenrolmentCompletedFalse" class="b" ng-value="false" ng-model="vm.pension.ReenrolmentAlreadyCompleted" ng-change="validateReenrolmentDate(vm)">\n\t\t\t\t\t\t<label for="reenrolmentCompletedFalse">No</label>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Re-enrolment completion date -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="reenrolmentCompletionDate">\n\t\t\t\t\t\t\tCompletion date:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="reenrolmentCompletionDate" field-min-date-iso="vm.validationResults.ReenrolmentWindowStartDateISO" field-max-date-iso="vm.validationResults.ReenrolmentWindowEndDateISO" field-on-change-fn="validateReenrolmentDate(vm)" field-value-iso="vm.pension.ReenrolmentCompletionDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionStagingDateForm.reenrolmentCompletionDate.$touched" ng-messages="pensionStagingDateForm.reenrolmentCompletionDate.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter a completion date</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t<p ng-message="min || max">\n\t\t\t\t\t\t\tThis date needs to be between {{vm.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'long\'}} -\n\t\t\t\t\t\t\t{{vm.validationResults.ReenrolmentWindowEndDateISO  | dateformat:\'long\'}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Re-enrolment date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="!vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t\t\tRe-enrolment date:\n\t\t\t\t\t</label>\n\t\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t\t\tNext re-enrolment date:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="reenrolmentDate" field-value-iso="vm.pension.ReenrolmentDateISO" field-on-change-fn="validateReenrolmentDate(vm)">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionStagingDateForm.reenrolmentDate.$touched" ng-messages="pensionStagingDateForm.reenrolmentDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a re-enrolment date</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Note: Check re-enrolment date -->\n\t\t\t<div class="form-field fadeIn" ng-if="!vm.validationResults.IsValid && vm.validationResults.ReenrolmentDateISO">\n\t\t\t\t<note note-dismiss-key="pension-staging-date-2" note-dismiss="true" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Check your re-enrolment date">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tYour re-enrolment date should be between {{vm.validationResults.ReenrolmentDateMinISO | dateformat}} - {{vm.validationResults.ReenrolmentDateMaxISO | dateformat}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Include opted out team members -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<label for="reenrolRecentOptOuts" class="hidden">Include opted out team members</label>\n\t\t\t\t\t<input type="checkbox" id="reenrolRecentOptOuts" name="reenrolRecentOptOuts" ng-model="vm.pension.ReenrolRecentOptOuts" label-text="\'Include team members who opt out in the 12 months prior to re-assessment for re-enrolment\'" checkbox>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Note: Connecting multiple pensions -->\n\t\t\t<div class="form-field">\n\t\t\t\t<note note-dismiss-key="pension-staging-date-3" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Connecting multiple pensions">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tYour re-enrolment date is for your company rather than this particular workplace pension.\n\t\t\t\t\t\t\tAs this is the first pension you\u2019re connecting, you won\u2019t need to add your re-enrolment date again later if you decide to connect another pension later.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- DoC -->\n\t\t<fieldset class="form-fieldset-divider-top">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Declaration of Compliance</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tA Declaration of Compliance must be submitted to The Pensions Regulator within 5 months of your pension duties start date and then every 3 years,\n\t\t\t\t\twhen your team are assessed for re-enrolment.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- TPR letter code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="tprLetterCode">\n\t\t\t\t\t<abbr class="underline" tooltip tooltip-position="right" tooltip-text="The Pensions Regulator">\n\t\t\t\t\t\tTPR\n\t\t\t\t\t</abbr>\n\t\t\t\t\tletter code:\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="m" id="tprLetterCode" name="tprLetterCode" ng-maxlength="10" ng-model="vm.pension.PensionLetterCode" ng-pattern="$root.REGEX.tprLetterCode" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionStagingDateForm.tprLetterCode.$touched" role="alert" ng-messages="pensionStagingDateForm.tprLetterCode.$error">\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid TPR letter code (10 digits, starting with a "1")</p>\n\t\t\t\t\t<p ng-message="maxlength">Please enter only 10 digits</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Note: TPR letter code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<note note-icon="icon-support" note-theme="indifferent is-form-field">\n\t\t\t\t\t<note-header>\n\t\t\t\t\t\tDon\u2019t know your\n\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-position="right" tooltip-text="The Pensions Regulator">\n\t\t\t\t\t\t\tTPR\n\t\t\t\t\t\t</abbr>\n\t\t\t\t\t\tletter code?\n\t\t\t\t\t</note-header>\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tYou can find it out on the\n\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="The Pensions Regulator" tooltip-position="right">\n\t\t\t\t\t\t\t\tTPR\n\t\t\t\t\t\t\t</abbr>\n\t\t\t\t\t\t\twebsite using your references:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class="stat-list basic plain-text">\n\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t<span class="stat-list__key">Accounts office reference:</span>\n\t\t\t\t\t\t\t\t<span class="stat-list__value">{{formOptions.company.AccountsOfficeReference}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t<span class="stat-list__key">PAYE reference:</span>\n\t\t\t\t\t\t\t\t<span class="stat-list__value">{{formOptions.company.PAYERef}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a href="" ng-href="{{$root.URLS.tpr.letterCode}}" class="is-small indifferent-darkened underline" target="_blank">\n\t\t\t\t\t\t\tFind out your TPR letter code now\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Has the Declaration of Compliance (DoC) been submitted? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required">Has the Declaration of Compliance (DoC) been submitted?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedTrue" class="b" ng-value="true" ng-model="vm.pension.DOCSubmitted">\n\t\t\t\t\t\t<label for="docSubmittedTrue">Yes</label>\n\t\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedFalse" class="b" ng-value="false" ng-model="vm.pension.DOCSubmitted">\n\t\t\t\t\t\t<label for="docSubmittedFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionStagingDateForm.$valid || !vm.validationResults.IsValid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionStagingDateForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension Settings -->\n\t<form class="fadeIn" name="pensionSettingsForm" ng-submit="loadStep(vm, false, pensionSettingsForm)" pc-switch-when="CONNECTOR_FORMS.pensionSettings" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>Pension settings</h4>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Pension provider name -->\n\t\t\t<div class="form-field" ng-if="vm.pension.PensionType === PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t<label class="required" for="pensionProviderName">\n\t\t\t\t\tPension provider:\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="pensionProviderName" name="pensionProviderName" ng-model="vm.pension.PensionProviderName" placeholder="Enter pension provider name\u2026" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSettingsForm.pensionProviderName.$touched" ng-messages="pensionSettingsForm.pensionProviderName.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter pension provider name</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Scheme reference (AE pensions only, disabled if connected to provider) -->\n\t\t\t<div class="form-section" ng-class="{\n\t\t\t\t\t\'is-disabled\' : vm.pension.ConnectToProvider\n\t\t\t\t}" ng-if="vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="hasSchemeReference">Do you wish to add a scheme reference number?</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceTrue" name="hasSchemeReference" ng-model="vm.pension.HasSchemeReference" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceFalse" name="hasSchemeReference" ng-model="vm.pension.HasSchemeReference" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn">\n\t\t\t\t<!-- Scheme reference format - if AE pension and has scheme reference set. Disabled when connect to provider is set -->\n\t\t\t\t<div class="form-section" ng-class="{\n\t\t\t\t\t\t\'is-disabled\' : vm.pension.ConnectToProvider\n\t\t\t\t\t}" ng-if="vm.pension.HasSchemeReference && vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="schemeReferenceFormat">\n\t\t\t\t\t\t\t\tScheme reference format:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select id="schemeReferenceFormat" name="schemeReferenceFormat" ng-model="vm.pension.SchemeReferenceDisplayType" ng-options="schemeReferenceDisplayType.id as schemeReferenceDisplayType.description for schemeReferenceDisplayType in PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS" required></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Education employer number fields (when display type is education employer number)-->\n\t\t\t\t<fieldset ng-if="\n\t\t\t\t\t\tvm.pension.SchemeReferenceDisplayType === PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber &&\n\t\t\t\t\t\tvm.pension.HasSchemeReference">\n\t\t\t\t\t<!-- Local authority number -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="localAuthorityNumber">\n\t\t\t\t\t\t\t\tLocal authority number:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="l-alt" id="localAuthorityNumber" name="localAuthorityNumber" ng-model="vm.pension.LocalAuthorityNumber" type="text" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSettingsForm.localAuthorityNumber.$touched" ng-messages="pensionSettingsForm.localAuthorityNumber.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter local authority number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Establishment number -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="establishmentNumber">\n\t\t\t\t\t\t\t\tEstablishment number:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="l-alt" id="establishmentNumber" name="establishmentNumber" ng-model="vm.pension.EstablishmentNumber" type="text" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSettingsForm.establishmentNumber.$touched" ng-messages="pensionSettingsForm.establishmentNumber.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter establishment number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Employer Pension Scheme Reference (when display type is employerReference) -->\n\t\t\t\t<fieldset ng-if="\n\t\t\t\t\tvm.pension.SchemeReferenceDisplayType === PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference &&\n\t\t\t\t\tvm.pension.HasSchemeReference\n\t\t\t\t">\n\t\t\t\t\t<pension-scheme-employer-reference-field connect-to-provider="vm.pension.ConnectToProvider" employer-reference="vm.pension.EmployerReference" pension-provider-id="vm.selectedPensionProvider.PensionProviderID" pension-type="vm.pension.PensionType"></pension-scheme-employer-reference-field>\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Pension description -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="pensionDescription">Description:</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<input id="pensionDescription" maxlength="128" name="pensionDescription" ng-model="vm.pension.PensionDescription" placeholder="Enter a description" type="text">\n\t\t\t\t</main>\n\t\t\t\t<p class="form-message fadeIn">\n\t\t\t\t\tThis is optional and can be useful if you&apos;re connecting more than one pension from the same provider.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<!-- Tax relief type -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="taxReliefType">Tax relief type:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select class="l-alt" id="taxReliefType" name="taxReliefType" ng-model="vm.pension.TaxReliefType" ng-options="taxReliefType.id as taxReliefType.description for taxReliefType in TAX_RELIEF_TYPES" required></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset ng-if="vm.pensionDetails.Pensions.length === 0">\n\t\t\t<!-- Pension period alignment -->\n\t\t\t<div class="form-content-block no-margin top">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<p class="is-small">The alignment settings you select below will apply to all pension periods. If you&apos;re unsure what to select we suggest leaving it as &apos;Same as pay periods&apos; for now. This can be edited later from your &apos;Pensions&apos; page.</p>\n\t\t\t\t\t<br>\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\t\tPension period alignment:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentSame" name="periodAlignment" ng-model="vm.pension.HasPensionDateOffset" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t<label for="periodAlignmentSame" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Same as pay periods</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentDifferent" name="periodAlignment" ng-model="vm.pension.HasPensionDateOffset" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t<label for="periodAlignmentDifferent" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Different to pay periods</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\n\t\t\t\t<div class="form-field" ng-if="vm.pension.HasPensionDateOffset">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\t\tOffset to:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b" id="afterPayDate" name="beforePayDate" ng-change="onOffsetTypeChange(vm)" ng-model="vm.isBeforePeriodDate" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label for="afterPayDate">\n\t\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="afterPayDateOffset" max="21" min="0" ng-model="vm.pensionDateAfterOffset" ng-required="!vm.isBeforePeriodDate" ng-readonly="vm.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<span ng-if="vm.pensionDateAfterOffset">\n\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionDateAfterOffset" when="{\'1\': \'day later than pay periods\',\n\t\t\t\t\t\t\t\t\t\t\t\t   \'other\': \'days later than pay periods\'}">\n\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionDateAfterOffset">days later than pay periods</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSettingsForm.afterPayDateOffset.$touched" ng-messages="pensionSettingsForm.afterPayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b" id="beforePayDate" name="afterPayDate" ng-change="onOffsetTypeChange(vm)" ng-model="vm.isBeforePeriodDate" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label for="beforePayDate">\n\t\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="beforePayDateOffset" max="21" min="0" ng-model="vm.pensionDateBeforeOffset" ng-required="vm.isBeforePeriodDate" ng-readonly="!vm.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<span ng-if="vm.pensionDateBeforeOffset">\n\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionDateBeforeOffset" when="{\'1\': \'day earlier than pay periods\',\n\t\t\t\t\t\t\t\t\t\t\t\t   \'other\': \'days earlier than pay periods\'}">\n\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionDateBeforeOffset">days earlier than pay periods</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSettingsForm.beforePayDateOffset.$touched" ng-messages="pensionSettingsForm.beforePayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message primary">Max. offset is 21 days.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<button class="button secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="button secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionSettingsForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionSettingsForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Team postponement -->\n\t<form class="fadeIn" name="pensionTeamForm" ng-submit="loadStep(vm, false, pensionTeamForm)" pc-switch-when="CONNECTOR_FORMS.pensionTeam" novalidate>\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Team postponement</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPostponement can be applied to new employees who join the team or those employees who pass through the relevant age and earnings thresholds up to a maximum of three months.\n\t\t\t\t\tThese can also be set later in the Pension page for this company.\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionStartDate" underline="true">\n\t\t\t\t\t\tRead more about pension staging/start\n\t\t\t\t\t</support-article-link>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- New team member postponement -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="newStarterPostponement">New team member postponement:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<select class="l-alt" id="newStarterPostponement" name="newStarterPostponement" ng-model="vm.pension.NewStarterPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in vm.postponementOptions">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Threshold change postponement -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="eligiblePostponement">Threshold change postponement:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<select class="l-alt" id="eligiblePostponement" name="eligiblePostponement" ng-model="vm.pension.EligibleWorkerPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in vm.postponementOptions">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionTeamForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionTeamForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pension Groups -->\n\t<form class="fadeIn" name="pensionGroupsForm" ng-submit="loadStep(vm, false, pensionGroupsForm)" pc-switch-when="CONNECTOR_FORMS.pensionGroups" novalidate>\n\t\t<!-- Contribution rates type, applicable if HR module is on, pension is AE and their are pension policies defined and pension is not connected directly to the provider -->\n\t\t<fieldset class="fadeIn" ng-if="\n\t\t\t\tvm.company.IsHRActive &&\n\t\t\t\tvm.pension.PensionType === PENSION_TYPES.autoEnrolment &&\n\t\t\t\tvm.pensionPolicies.length !== 0 &&\n\t\t\t\t!vm.pension.IsGhostPension &&\n\t\t\t\t!vm.pension.ConnectToProvider\n\t\t\t">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="contributionRatesTypeUsePensionPolicyFalse">How do you wish to define contribution rates?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="contributionRatesTypeUsePensionPolicyFalse" name="contributionRatesType" ng-change="onUsePensionPolicyChange(vm.pension)" ng-model="vm.pension.UsePensionPolicy" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="contributionRatesTypeUsePensionPolicyFalse">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Add pension groups manually</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="contributionRatesTypeUsePensionPolicyTrue" name="contributionRatesType" ng-change="onUsePensionPolicyChange(vm.pension)" ng-model="vm.pension.UsePensionPolicy" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="contributionRatesTypeUsePensionPolicyTrue">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Use a pension policy</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Use pension policy -->\n\t\t<fieldset ng-if="vm.pension.UsePensionPolicy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Pension Policy</h4>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="pensionPolicy">\n\t\t\t\t\t\tSelect a pension policy:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="pensionPolicy" name="pensionPolicy" ng-model="vm.pension.policy" ng-change="onPensionPolicyChange(vm.pension)" ng-options="pensionPolicy as pensionPolicy.PolicyName for pensionPolicy in vm.pensionPolicies | orderBy: \'PolicyName\'" required>\n\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-note" ng-switch="vm.pension.policy.PolicyBandCalculation">\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod">\n\t\t\t\t\t\tContribution bands will be determined for team members based on their annualised pensionable pay in your current period.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod">\n\t\t\t\t\t\tContribution bands will be determined for team members based on their pensionable pay in your current period.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\t\t\tYou\u2019ll be able to enter a full-time equivalent salary for team members as you add them to a pension scheme using this policy.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t\t\t\tYou can select a contribution band for team members when you add them to this pension scheme.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionGroupsForm.pensionPolicy.$touched" ng-messages="pensionGroupsForm.pensionPolicy.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a pension policy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="vm.pension.policy">\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<h5>\n\t\t\t\t\t\t<pc-pluralise count="vm.pension.policy.bandsCount" single="{{vm.pension.policy.policyBandDescription}}" multiple="{{vm.pension.policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="pension-policy-band-cards">\n\t\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.pension.policy.PolicyBands" policy="vm.pension.policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<!-- Set contribution bands manually (this is by default is HR is not active)-->\n\t\t<fieldset ng-if="!vm.pension.UsePensionPolicy">\n\t\t\t<div class="form-intro" ng-if="vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t<h4>Pension Groups</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease enter the group name that has been set up on the pension provider website and set the group\'s contribution percentages.\n\t\t\t\t\tClick &lsquo;Add another group&rsquo; to add additional groups.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-intro" ng-if="vm.pension.PensionType === PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t<h4>Contribution bands</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tAdd contribution bands so you can easily assign them to team members without having to add their contribution settings individually.\n\t\t\t\t\tSet a default band and that will be used when you add a team member to this pension. You can always add custom contribution percentages for team members.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-content-block" ng-if="vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t<note note-dismiss-key="pension-groups" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Minimum contributions for workplace pension compliance">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Set your contributions to match what you have set up with your pension provider.\n\t\t\t\t\t\t\tPlease make sure that you do not go below the minimum contribution requirements set by The Pensions Regulator to ensure workplace pension compliance.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Groups/Contribution bands -->\n\t\t\t<fieldset class="pension-scheme-group_wrapper">\n\t\t\t\t<pension-scheme-group group="group" index="$index" ng-repeat="group in vm.pension.PensionGroups" on-group-delete="deletePensionGroup(vm.pension.PensionGroups, $index)" on-group-is-default-change="onGroupIsDefaultChange(vm, $index)" pension-groups="vm.pension.PensionGroups" pension-type="vm.pension.PensionType"></pension-scheme-group>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Add group -->\n\t\t\t<div class="form-content-block">\n\t\t\t\t<button class="is-medium-large is-white is-block" data-cy="pensions-connector-add-group" ng-click="addNewPensionGroup(vm)" type="button">\n\t\t\t\t\t<span ng-if="vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t\t<i class="icon-add button_icon-pre"></i>Add another group\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="vm.pension.PensionType === PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\t\t<i class="icon-add button_icon-pre"></i>Add contribution band\n\t\t\t\t\t</span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="loadStep(vm, true)" ng-if="vm.isBackButtonDisplayed" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!pensionGroupsForm.$valid" display-text="vm.isFinalFormStep ? \'Create pension\' : \'Next\'" state="pensionGroupsForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</section>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/company/people-hr-updates-data/people-hr-updates-data.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.FORM_STATE.loading"></loading-block>\n\n<form class="fadeIn" name="peopleHrUpdatesDataForm" ng-if="!$ctrl.isEdp && $ctrl.pageContext === $ctrl.FORM_CONTEXT.default && $ctrl.pageState === $ctrl.FORM_STATE.ready" ng-submit="$ctrl.confirmRetry()">\n\t<div class="form-intro" ng-if="$ctrl.data.Status === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.failed">\n\t\t<p class="s">\n\t\t\t<span class="is-font-greyscale-300">\n\t\t\t\tYou may need to adjust your data in PeopleHR to address the issue below.\n\t\t\t\tIf you adjusted your data in Paycircle, you can click retry and we\'ll try to apply your update again.\n\t\t\t</span>\n\t\t</p>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<people-hr-updates-card hide-action="true" hide-footer="$ctrl.data.Status === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.complete" hide-warning-icon="true" remove-hover-effect="true" event-data="$ctrl.data" show-employee-id="true"></people-hr-updates-card>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<note ng-if="$ctrl.data.Status === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.complete && $ctrl.data.ErrorMessage.length >= 1" note-icon="icon-warning" note-theme="is-tertiary" note-title="Update warnings">\n\t\t\t<note-content>\n\t\t\t\t<bullet-list bl-theme="is-tertiary" bl-items="$ctrl.errorMessageList"></bullet-list>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<h6>Data received from PeopleHR</h6>\n\n\t<p class="is-small italic is-font-greyscale-300">\n\t\tReceived at {{ $ctrl.data.ReceivedTimeISO | dateformat: \'timeDayDate\'}}\n\t</p>\n\n\t<hr class="l">\n\t\t\n\t<table class="f fadeIn">\n\t\t<tbody>\n\t\t\t<tr ng-repeat="item in $ctrl.processedBodyData">\n\t\t\t\t<td>{{$ctrl.processBodyKeyText(item.key)}}</td>\n\t\t\t\t<td>{{item.value}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n\t<fieldset class="form-actions" ng-if="$ctrl.data.Status === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.failed">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<button class="is-tertiary primary-action" type="submit">Retry</button>\n\t</fieldset>\n</form>\n\n<!-- EDP single event view -->\n<div class="fadeIn" ng-if="$ctrl.isEdp && !$ctrl.isBulk && $ctrl.pageContext === $ctrl.FORM_CONTEXT.default && $ctrl.pageState === $ctrl.FORM_STATE.ready">\n\t<div class="form-intro" ng-if="$ctrl.data.EdpEventStatus === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.failed">\n\t\t<p class="s">\n\t\t\t<span class="is-font-greyscale-300">\n\t\t\t\tYou may need to adjust your data to address the issue below.\n\t\t\t\tOnce resolved, click retry and we\'ll queue your update for reprocessing.\n\t\t\t</span>\n\t\t</p>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<people-hr-updates-card event-data="$ctrl.data" hide-action="true" hide-footer="$ctrl.data.EdpEventStatus === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.complete" hide-warning-icon="true" remove-hover-effect="true" show-employee-id="true"></people-hr-updates-card>\n\t</div>\n\n\t<div class="form-intro" ng-if="$ctrl.data.EdpEventStatus === $ctrl.PEOPLE_HR_UPDATES_EVENT_STATUS.complete && $ctrl.edpErrorMessageList.length">\n\t\t<note note-icon="icon-warning" note-theme="is-tertiary" note-title="Update warnings">\n\t\t\t<note-content>\n\t\t\t\t<bullet-list bl-theme="is-tertiary" bl-items="$ctrl.edpErrorMessageList"></bullet-list>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div data-cy="people-hr-updates-data-payload" ng-if="$ctrl.parsedPayload.length">\n\t\t<h6>Event data</h6>\n\n\t\t<p class="is-small italic is-font-greyscale-300">\n\t\t\tReceived at {{ $ctrl.data.EdpEventReceivedTime | dateformat: \'timeDayDate\'}}\n\t\t</p>\n\n\t\t<hr class="l">\n\n\t\t<table class="f fadeIn" data-cy="people-hr-updates-data-payload-table">\n\t\t\t<tbody>\n\t\t\t\t<tr data-cy="people-hr-updates-data-payload-row-{{$index}}" ng-repeat="item in $ctrl.parsedPayload track by $index">\n\t\t\t\t\t<td>{{item.heading}}</td>\n\t\t\t\t\t<td>{{item.value}}</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n\t<fieldset class="form-actions" ng-if="$ctrl.canRetry">\n\t\t<button class="secondary-action" data-cy="people-hr-updates-data-cancel-btn" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t<button class="is-quinary primary-action" data-cy="people-hr-updates-data-retry-btn" ng-click="$ctrl.confirmRetry()" type="button">Retry</button>\n\t</fieldset>\n</div>\n\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="question-mark" fs-theme="positive" fs-title="Are you sure you wish to retry?" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.confirmRetry">\n\t<fs-main>\n\t\t<p class="s is-font-greyscale-300" ng-if="!$ctrl.isEdp && !$ctrl.isMixed">\n\t\t\t<span ng-if="$ctrl.isBulk">You\'re about to retry <ng-pluralize count="$ctrl.formOptions.messageId.length" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>. </span>\n\t\t\tOnce you click \'Confirm\' we\'ll change the status of your updates to pending.\n\t\t\tYou\'ll then need to click the \'Refresh\' button at the top of your updates list to see if they have been successful or failed again.\n\t\t</p>\n\t\t<p class="s is-font-greyscale-300" ng-if="$ctrl.isMixed">\n\t\t\t<span>You\'re about to retry <ng-pluralize count="$ctrl.bulkRetryCount" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>. </span>\n\t\t\tOnce you click \'Confirm\' we\'ll queue your updates for reprocessing.\n\t\t\tYou\'ll then need to click the \'Refresh\' button at the top of your updates list to see if they have been successful or failed again.\n\t\t</p>\n\t\t<p class="s is-font-greyscale-300" ng-if="$ctrl.isEdp">\n\t\t\t<span ng-if="$ctrl.isBulk">You\'re about to retry <ng-pluralize count="$ctrl.formOptions.eventId.length" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>. </span>\n\t\t\tOnce you click \'Confirm\' we\'ll queue your updates for reprocessing.\n\t\t\tYou\'ll then need to click the \'Refresh\' button at the top of your updates list to see if they have been successful or failed again.\n\t\t</p>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button type="button" ng-click="$ctrl.onCancelClick()">Cancel</button>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.performRetry()" type="submit">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.retry">\n\t<fs-main>\n\t\t<div class="align-center">\n\t\t\t<h4>Retrying update</h4>\n\t\t\t<p class="s is-font-greyscale-300">\n\t\t\t\tWe\'re retrying your update and this should only take a few moments.<br>\n\t\t\t\tPlease don\'t click back or close this window.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.retryResults">\n\t<fs-main>\n\t\t<div class="form-intro">\n\t\t\t<p class="s is-font-greyscale-300">\n\t\t\t\t{{$ctrl.countOfSuccessfulEvents}} out of {{$ctrl.countOfEvents}} selected \n\t\t\t\t<ng-pluralize count="$ctrl.countOfEvents" when="{\'1\': \'event\', \'other\': \'events\'}"></ng-pluralize> \n\t\t\t\thave been submitted successfully, while {{$ctrl.countOfFailedEvents}} \n\t\t\t\t<ng-pluralize count="$ctrl.countOfFailedEvents" when="{\'1\': \'event\', \'other\': \'events\'}"></ng-pluralize> \n\t\t\t\tfailed to retry.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<section class="people-hr-updates-card_wrapper rows">\n\t\t\t<people-hr-updates-card agency-profile-id="agencyProfileId" event-data="event" hide-action="true" ng-repeat="event in $ctrl.integrationEvents" remove-hover-effect="true" show-employee-id="true"></people-hr-updates-card>\n\t\t</section>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.onCancelClick()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/post-to-xero/post-to-xero.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="postToXeroForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.postToXero($ctrl, postToXeroForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Choose if you wish to post your journal to draft or final then click &lsquo;Continue&rsquo;. We\u2019ll let you know if there are problems with your post.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">Where do you wish to post your journal to?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="submitTypeDraft" name="submitType" ng-model="$ctrl.formOptions.postObj.submitAsFinalEnum" ng-value="$ctrl.XERO_POST_STATES.draft" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="submitTypeDraft">\n\t\t\t\t\t\t\t<p class="radio-row-title">Draft</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="submitTypeFinal" name="submitType" ng-model="$ctrl.formOptions.postObj.submitAsFinalEnum" ng-value="$ctrl.XERO_POST_STATES.final" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="submitTypeFinal">\n\t\t\t\t\t\t\t<p class="radio-row-title">Final</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!postToXeroForm.$valid" display-text="\'Continue\'" state="postToXeroForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Posting -->\n<section class="form-summary fadeIn" ng-if="$ctrl.formState === \'posting\'">\n\n\t<section class="form-summary-section align-center">\n\t\t<image-badge image-alt="Xero" image-class="is-inline-block" image-key="xero" image-type="integrations"></image-badge>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<h3>Posting to Xero</h3>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a moment. Please don\u2019t close this window or click the back button on your browser.</p>\n\t</section>\n</section>\n\n<!-- Warnings / Errors -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Your journal couldn\'t be posted to Xero" fs-theme="tertiary" ng-if="$ctrl.formState === \'failed-to-post\'">\n\t<fs-main>\n\n\t\t<!-- Errors -->\n\t\t<div class="form-state-section" ng-if="$ctrl.postJournalResponse.ErrorMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following errors occurred and need to be fixed before trying to post to Xero again:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="errorMessage in $ctrl.postJournalResponse.ErrorMessages track by $index">\n\t\t\t\t<message-block theme="tertiary is-inline">\n\t\t\t\t\t<p><i class="icon-warning is-medium is-tertiary has-margin-right"></i>{{errorMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Warnings -->\n\t\t<div class="for-state-section" ng-if="$ctrl.postJournalResponse.WarningMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following warnings are just for your information:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="warningMessage in $ctrl.postJournalResponse.WarningMessages track by $index">\n\t\t\t\t<message-block theme="indifferent is-inline">\n\t\t\t\t\t<p><i class="icon-information is-medium is-indifferent has-margin-right"></i>{{warningMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-state-section"></div>\n\t\t\t<p class="is-strong">\n\t\t\t\t<a href="" ng-click="$ctrl.formOptions.closeForm()" class="link-with-icon">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t\n\t</fs-main>\n</form-state>\n\n<!-- Unable to connect -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="We couldn\u2019t connect to Xero" fs-theme="tertiary" ng-if="$ctrl.formState === \'failed-to-connect\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tThis may be because Paycircle has been disconnected in your Xero account or there\u2019s currently a problem with Xero. Try connecting your Xero account from your Xero settings or you may wish\n\t\t\t\tto check the <a href="https://status.xero.com/" class="underline" target="_blank">Xero status page</a>.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\t<a href="" ui-sref="settings.company.journals.xero({agencyProfileId: $ctrl.formOptions.agencyProfileId})">Go to Xero settings</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Posted -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Your journal has been posted to Xero" fs-theme="positive" ng-if="$ctrl.formState === \'posted\'">\n\t<fs-main>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">Your journal for {{$ctrl.formOptions.company.Name}} has been successfully posted and is now available to process in your accounting software.</p>\n\t\t</div>\n\n\t\t<!-- Warnings -->\n\t\t<div class="form-state-section" ng-if="$ctrl.postJournalResponse.WarningMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following warnings are just for your information:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="warningMessage in $ctrl.postJournalResponse.WarningMessages track by $index">\n\t\t\t\t<message-block icon="information" theme="indifferent is-inline">\n\t\t\t\t\t<p class="is-small">{{warningMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/post-to-financials/post-to-financials.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<!-- Confirmation -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to post to Access Financials?" ng-if="$ctrl.formState === \'ready\'" novalidate>\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tYour journal will be posted to Access Financials as a draft. \n\t\t\tWe\u2019ll let you know if there are problems with your post.\n\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.postToFinancials($ctrl)">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Posting -->\n<section class="form-summary fadeIn" ng-if="$ctrl.formState === \'posting\'">\n\n\t<section class="form-summary-section align-center">\n\t\t<img src="../images/logo/integrations/access-financials.2x.png" style="width: 300px;">\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<h3>Posting to Financials</h3>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a moment. Please don\u2019t close this window or click the back button on your browser.</p>\n\t</section>\n</section>\n\n<!-- Warnings / Errors -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Your journal couldn\'t be posted to Access Financials" fs-theme="tertiary" ng-if="$ctrl.formState === \'failed-to-post\'">\n\t<fs-main>\n\n\t\t<!-- Errors -->\n\t\t<div class="form-state-section" ng-if="$ctrl.postJournalResponse.ErrorMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following errors occurred and need to be fixed before trying to post to Access Financials again:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="errorMessage in $ctrl.postJournalResponse.ErrorMessages track by $index">\n\t\t\t\t<message-block theme="tertiary is-inline">\n\t\t\t\t\t<p><i class="icon-warning is-medium is-tertiary has-margin-right"></i>{{errorMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Warnings -->\n\t\t<div class="for-state-section" ng-if="$ctrl.postJournalResponse.WarningMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following warnings are just for your information:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="warningMessage in $ctrl.postJournalResponse.WarningMessages track by $index">\n\t\t\t\t<message-block theme="indifferent is-inline">\n\t\t\t\t\t<p><i class="icon-information is-medium is-indifferent has-margin-right"></i>{{warningMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-strong">\n\t\t\t\t<a class="link-with-icon strong" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Unable to connect -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="We couldn\u2019t connect to Access Financials" fs-theme="tertiary" ng-if="$ctrl.formState === \'failed-to-connect\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tThis may be because Paycircle has been disconnected in your Access Financials account or there\u2019s currently a problem with Access Financials.\n\t\t\t\tTry connecting your Access Financials account from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\t<a href="" ui-sref="settings.company.integration({agencyProfileId: $ctrl.formOptions.agencyProfileId})">Go to integration settings</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Posted -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Your journal has been posted to Access Financials" fs-theme="positive" ng-if="$ctrl.formState === \'posted\'">\n\t<fs-main>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">Your journal for {{$ctrl.formOptions.company.Name}} has been successfully posted and is now available to process in your accounting software.</p>\n\t\t</div>\n\n\t\t<!-- Warnings -->\n\t\t<div class="form-state-section" ng-if="$ctrl.postJournalResponse.WarningMessages.length">\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">The following warnings are just for your information:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section has-padding-small" ng-repeat="warningMessage in $ctrl.postJournalResponse.WarningMessages track by $index">\n\t\t\t\t<message-block icon="information" theme="indifferent is-inline">\n\t\t\t\t\t<p class="is-small">{{warningMessage}}</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/resolve-pay-period-dates/resolve-pay-period-dates.form.html','<!-- Loading -->\n<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Invalid periods -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'invalid-periods\'">\n\t<div class="form-intro">\n\t\t<p class="s">Pay period dates can\'t be worked out because {{$ctrl.invalidPeriods.length === 1 ? \'one of the periods\' : \'some of the periods\'}} provided couldn\'t be understood.</p>\n\t</div>\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" data-cy="resolve-pay-period-dates-cancel" href="" ng-click="$ctrl.formOptions.closeForm()">Close</a>\n\t</fieldset>\n</div>\n\n<!-- No periods -->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.pageState === \'no-periods\'">\n\t<div class="form-intro">\n\t\t<p class="s">There are no pay period numbers or tax years to work out dates for.</p>\n\t</div>\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" data-cy="resolve-pay-period-dates-cancel" href="" ng-click="$ctrl.formOptions.closeForm()">Close</a>\n\t</fieldset>\n</div>\n\n<!-- Ready -->\n<form class="fadeIn" name="resolvePayPeriodDatesForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.confirmDates(resolvePayPeriodDatesForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Enter the start date for {{$ctrl.anchorPeriodLabel}} and we\'ll work out the start and end dates for all {{$ctrl.periods.length}} {{$ctrl.periods.length === 1 ? \'period\' : \'periods\'}}.</p>\n\t</div>\n\n\t<!-- Start date -->\n\t<fieldset>\n\t\t<legend hidden>Start date</legend>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="resolvePayPeriodDatesStartDate">Start date for {{$ctrl.anchorPeriodLabel}}:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="resolvePayPeriodDatesStartDate" field-on-change-fn="$ctrl.onStartDateChange($ctrl.startDateISO)" field-required="true" field-value-iso="$ctrl.startDateISO"></date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="resolvePayPeriodDatesForm.resolvePayPeriodDatesStartDate.$touched" ng-messages="resolvePayPeriodDatesForm.resolvePayPeriodDatesStartDate.$error" role="alert">\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t<p ng-message="required">Please enter a start date</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Resolving -->\n\t<div class="form-content-block fadeIn" ng-if="$ctrl.resolutionState === \'resolving\'">\n\t\t<loading-block position="after">\n\t\t\t<lb-description>\n\t\t\t\t<h5>Generating preview</h5>\n\t\t\t</lb-description>\n\t\t</loading-block>\n\t</div>\n\n\t<!-- Resolution error -->\n\t<fieldset class="fadeIn" ng-if="$ctrl.resolutionState === \'error\'">\n\t\t<legend hidden>Resolution error</legend>\n\t\t<note note-icon="icon-warning" note-theme="tertiary">\n\t\t\t<note-content>\n\t\t\t\t<p class="s" data-cy="resolve-pay-period-dates-error-message">{{$ctrl.resolutionMessage}}</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- Resolved periods -->\n\t<fieldset class="fadeIn" ng-if="$ctrl.resolutionState === \'resolved\'">\n\t\t<legend hidden>Resolved pay period dates</legend>\n\n\t\t<div class="form-content-block">\n\t\t\t<p class="s" data-cy="resolve-pay-period-dates-resolved-summary">Dates have been resolved for {{$ctrl.resolution.resolvedPeriods.length}} {{$ctrl.resolution.resolvedPeriods.length === 1 ? \'period\' : \'periods\'}}. Please check them and click &lsquo;Confirm&rsquo; to continue.</p>\n\t\t</div>\n\n\t\t<div class="data-grid is-primary">\n\t\t\t<div class="data-grid_row" data-cy="resolve-pay-period-dates-period-row" dir-paginate="resolvedPeriod in $ctrl.resolution.resolvedPeriods | itemsPerPage : $ctrl.itemsPerPage" current-page="$ctrl.currentPageNumber" pagination-id="\'resolved-periods\'">\n\t\t\t\t<div class="data-grid_cell is-primary">\n\t\t\t\t\t<p class="s strong" data-cy="resolve-pay-period-dates-period-label">Period {{resolvedPeriod.PeriodNumber}} of {{resolvedPeriod.PeriodYear}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_cell">\n\t\t\t\t\t<p class="s" data-cy="resolve-pay-period-dates-period-dates">{{resolvedPeriod.StartDateISO | dateformat}} &ndash; {{resolvedPeriod.EndDateISO | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" pagination-id="\'resolved-periods\'"></dir-pagination-controls>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Actions</legend>\n\t\t<a class="button secondary-action" data-cy="resolve-pay-period-dates-cancel" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="$ctrl.resolutionState !== \'resolved\'" button-id="resolve-pay-period-dates-submit" display-text="\'Confirm\'" state="resolvePayPeriodDatesForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/rotaready-updates-data/rotaready-updates-data.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.FORM_STATE.loading"></loading-block>\n\n<form class="fadeIn" name="rotareadyUpdatesDataForm" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.default && $ctrl.pageState === $ctrl.FORM_STATE.ready" ng-submit="$ctrl.confirmRetry()" data-cy="rotaready-updates-data-form">\n\t<div class="form-intro" ng-if="$ctrl.data.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed">\n\t\t<p class="s">\n\t\t\t<span class="is-font-greyscale-300">\n\t\t\t\tYou may need to adjust your data in Rotaready to address the issue below.\n\t\t\t\tIf you adjusted your data in Paycircle, you can click retry and we\'ll try to apply your update again.\n\t\t\t</span>\n\t\t</p>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<rotaready-updates-card hide-action="true" hide-warning-icon="true" remove-hover-effect="true" event-data="$ctrl.data"></rotaready-updates-card>\n\t</div>\n\n\t<!-- Critical Messages Block -->\n\t<div class="form-intro">\n\t\t<note ng-if="$ctrl.errorMessageList.critical.length >= 1" note-icon="icon-warning" note-theme="assertive" note-title="Critical">\n\t\t\t<note-content>\n\t\t\t\t<ul class="bullet-list is-assertive-lightened" data-cy="rotaready-updates-data-critical-list">\n\t\t\t\t\t<li class="bullet-list_item" ng-repeat="message in $ctrl.errorMessageList.critical" data-cy="rotaready-updates-data-critical-message-{{$index}}">\n\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t{{message.MessageText}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<a data-cy="rotaready-updates-data-critical-message-dismiss-{{$index}}" href="" class="is-assertive" ng-click="$ctrl.dismissMessage(message)" ng-if="!$ctrl.getIsDismissed(message) && !message.isDismissing" role="button">\n\t\t\t\t\t\t\tDismiss\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<span ng-if="!$ctrl.getIsDismissed(message) && message.isDismissing">Dismissing...</span>\n\t\t\t\t\t\t<span class="xs is-light" ng-if="$ctrl.getIsDismissed(message)" data-cy="rotaready-updates-data-critical-message-dismissed-info-{{$index}}">\n\t\t\t\t\t\t\t<br>Dismissed by {{message.DismissedByUsername}} at {{message.DismissedAtTime}} on {{message.DismissedAtDate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<div class="rotaready-updates-data-form_dismiss-all-action" ng-if="$ctrl.getHasMultipleNonDismissedCriticalMessages()">\n\t\t\t\t\t<a data-cy="rotaready-updates-data-critical-dismiss-all" href="" class="link-with-icon is-assertive" ng-click="$ctrl.dismissAllMessages()" ng-if="!$ctrl.isDismissingAll" role="button">\n\t\t\t\t\t\t<i class="icon-cross"></i>\n\t\t\t\t\t\tDismiss all\n\t\t\t\t\t</a>\n\t\t\t\t\t<span ng-if="$ctrl.isDismissingAll" class="is-small">\n\t\t\t\t\t\tDismissing...\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Warning Messages Block -->\n\t<div class="form-intro">\n\t\t<note ng-if="$ctrl.errorMessageList.warning.length >= 1" note-icon="icon-warning" note-theme="is-tertiary" note-title="Warnings">\n\t\t\t<note-content>\n\t\t\t\t<div class="rotaready-updates-data-form_warning-scroll-container" data-cy="rotaready-updates-data-warning-scroll-container">\n\t\t\t\t\t<bullet-list bl-items="$ctrl.errorMessageList.warning" bl-theme="is-small is-tertiary is-spaced-out"></bullet-list>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Info Messages Block -->\n\t<div class="form-intro">\n\t\t<note ng-if="$ctrl.errorMessageList.info.length >= 1" note-icon="icon-support" note-theme="indifferent" note-title="Information">\n\t\t\t<note-content>\n\t\t\t\t<div class="rotaready-updates-data-form_info-scroll-container" data-cy="rotaready-updates-data-info-scroll-container">\n\t\t\t\t\t<bullet-list bl-items="$ctrl.errorMessageList.info" bl-theme="is-small is-indifferent is-spaced-out"></bullet-list>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<h6>Data received from Rotaready</h6>\n\n\t<p class="is-small italic is-font-greyscale-300">\n\t\tReceived at {{ $ctrl.data.ReceivedTimeISO | dateformat: \'timeDayDate\'}}\n\t</p>\n\n\t<hr class="l">\n\t\t\n\t<table class="f fadeIn">\n\t\t<tbody>\n\t\t\t<tr ng-repeat="item in $ctrl.processedBodyData" data-cy="rotaready-update-data-section-{{$index}}">\n\t\t\t\t<td data-cy="rotaready-update-data-section-{{$index}}-label">{{item.heading}}</td>\n\t\t\t\t<td data-cy="rotaready-update-data-section-{{$index}}-value">{{item.value}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n\t<fieldset class="form-actions" ng-if="$ctrl.data.Status === $ctrl.ROTAREADY_UPDATES_EVENT_STATUS.failed">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button" data-cy="rotaready-update-cancel-button">Cancel</button>\n\t\t<button class="is-tertiary primary-action" type="submit" data-cy="rotaready-update-retry-button">Retry</button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="question-mark" fs-theme="positive" fs-title="Are you sure you wish to retry?" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.confirmRetry">\n\t<fs-main>\n\t\t<p class="s is-font-greyscale-300">\n\t\t\t<span ng-if="$ctrl.isBulk">You\'re about to retry <ng-pluralize count="$ctrl.formOptions.eventId.length" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>. </span>\n\t\t\tOnce you click \'Confirm\' we\'ll change the status of your updates to pending.\n\t\t\tYou\'ll then need to click the \'Refresh\' button at the top of your updates list to see if they have been successful or failed again.\n\t\t</p>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button type="button" ng-click="$ctrl.onCancelClick()" data-cy="rotaready-update-confirm-cancel-button">Back</button>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.performRetry()" type="submit" data-cy="rotaready-update-confirm-button">Confirm</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Too many updates selected" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.retryLimitExceeded">\n\t<fs-main>\n\t\t<p class="s is-font-greyscale-300" data-cy="rotaready-update-retry-limit-exceeded-message">\n\t\t\tYou\'ve selected <ng-pluralize count="$ctrl.formOptions.eventId.length" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>, but you can only retry up to <ng-pluralize count="$ctrl.ROTAREADY_UPDATES_MAX_RETRY_COUNT" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize> at a time.\n\t\t\tPlease deselect some updates and try again.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.retry">\n\t<fs-main>\n\t\t<div class="align-center">\n\t\t\t<h4>Retrying update</h4>\n\t\t\t<p class="s is-font-greyscale-300">\n\t\t\t\tWe\'re retrying your update and this should only take a few moments.<br>\n\t\t\t\tPlease don\'t click back or close this window.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageContext === $ctrl.FORM_CONTEXT.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/switchToLive/switchToLiveForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Switch to Live Mode -->\n<form name="switchToLiveForm" ng-submit="switchToLive(switchToLiveForm)" ng-if="pageState === \'switch-to-live\'">\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Switch {{formOptions.company.Name}} to Live Mode?">\n\t\t<fs-main>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">{{formOptions.currentPayPeriod.PayPeriodDisplay}} will be the first live period for {{formOptions.company.Name}}.\n\t\t\t\t\tOnce you switch to Live Mode, if you have enabled electronic updates they will begin to be applied as they become available.</p>\n\t\t\t</section>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">If you decide you don\'t want to run {{formOptions.currentPayPeriod.PayPeriodDisplay}} as a live period you can switch back to Test Mode at any time from your Companies page or the company dashboard.</p>\n\t\t\t</section>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Switch to Live Mode\'" state="switchToLiveForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Switched to Live Mode -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Switched to Live Mode" ng-if="pageState === \'switched-to-live\'">\n\t<fs-main>\n\t\t<section class="form-section">\n\t\t\t<div class="live-mode-bar">\n\t\t\t\t<p><strong>{{formOptions.company.Name}}</strong> is now running in Live Mode</p>\n\t\t\t\t<span class="marker s positive live-mode-bar-marker"></span>\n\t\t\t</div>\n\t\t</section>\n\t\t<section class="form-section">\n\t\t\t<p class="s">{{formOptions.currentPayPeriod.PayPeriodDisplay}} will be the first live period for {{formOptions.company.Name}}.\n\t\t\t\tOnce you switch to Live Mode, if you have enabled electronic updates they will begin to be applied as they become available.</p>\n\t\t</section>\n\t\t<section class="form-section">\n\t\t\t<p class="s">If you decide you don\'t want to run {{formOptions.currentPayPeriod.PayPeriodDisplay}} as a live period you can switch back to Test Mode at any time from your Companies page or the company dashboard.</p>\n\t\t</section>\n\t</fs-main>\n</form-state>\n\n<!-- Switch to Test Mode -->\n<form name="switchToTestForm" ng-submit="switchToTest(switchToTestForm)" ng-if="pageState === \'switch-to-test\'">\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Switch {{formOptions.company.Name}} to Test Mode?">\n\t\t<fs-main>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">Once you switch to Test Mode, if you have enabled electronic updates they will no longer be applied.</p>\n\t\t\t</section>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">You can switch to Live Mode at the click of a button from your Companies page or the company dashboard whenever you\u2019re ready to go.</p>\n\t\t\t</section>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Switch to Test Mode\'" state="switchToTestForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Switched to Test Mode -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="{{formOptions.company.Name}} has been switched to Test Mode" ng-if="pageState === \'switched-to-test\'">\n\t<fs-main>\n\t\t<section class="form-section">\n\t\t\t<div class="test-mode-bar">\n\t\t\t\t<p><strong>{{formOptions.company.Name}}</strong> is set to run in Test Mode</p>\n\t\t\t\t<span class="marker s tertiary test-mode-bar-marker"></span>\n\t\t\t</div>\n\t\t</section>\n\t\t<section class="form-section">\n\t\t\t<p class="s">Payroll can now run in Test Mode to make sure the information is correct while migrating across from your existing payroll provider.</p>\n\t\t</section>\n\t\t<div class="note">\n\t\t\t<p>When you\'re ready to run as a live period, you can switch to Live Mode at any time from the company action menu.</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot be switched to Test Mode -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="{{formOptions.company.Name}} cannot be switched to Test Mode" ng-if="pageState === \'live-payroll-ran\'">\n\t<fs-main>\n\t\t<p class="s">As a live payroll has already ran for {{formOptions.company.Name}}, it cannot be switched to Test Mode. If you have any questions or concerns with your payroll please contact our support team.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/rotaready-updates-dismiss-all/rotaready-updates-dismiss-all.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="rotareadyUpdatesDismissAllForm" ng-submit="$ctrl.confirmDismissAll()" data-cy="rotaready-updates-dismiss-all-form" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Dismiss critical messages" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t<ng-pluralize count="$ctrl.totalCriticalMessages" when="{\n\t\t\t\t\t\t\'1\': \'1 critical message will be dismissed.\',\n\t\t\t\t\t\t\'other\': \'{} critical messages will be dismissed.\'\n\t\t\t\t\t}"></ng-pluralize>\n\t\t\t</p>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<info-block ib-theme="assertive has-icon has-border has-plain-type">\n\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t\t<h6 class="stronger">Ensure critical issues have been corrected</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-header>\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tCritical messages highlight issues in mapping between the information coming from Rotaready and data in Paycircle. Please ensure you are happy that all issues have been addressed before continuing.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- Confirmation -->\n\t\t\t<div class="form-section">\n\t\t\t\t<div class="confirmation-block tertiary-light">\n\t\t\t\t\t<input id="confirmInformation" label-text="\'I want to dismiss all critical messages for Rotaready updates\'" name="confirmInformation" ng-model="$ctrl.isConfirmed" type="checkbox" checkbox required>\n\t\t\t\t\t<p class="p s"> By ticking this box you are confirming that you have addressed the issues that these messages\n\t\t\t\t\t\trelate to.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<button data-cy="rotaready-updates-critical-dismiss-all-cancel" ng-click="$ctrl.cancel()" type="button">Cancel</button>\n\t\t\t<submit-button data-cy="rotaready-updates-critical-dismiss-all-confirm" display-text="\'Confirm\'" disable-button="!$ctrl.isConfirmed"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="true" fs-title="Critical messages dismissed" ng-if="$ctrl.pageState === \'complete\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tCritical messages have been dismissed successfully.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/work-pattern/workPatternForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workPatternForm" ng-submit="updateWorkPattern(vm, workPatternForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Pattern details -->\n\t<fieldset>\n\n\t\t<!-- Pattern Type -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">Pattern type:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="patternType" id="patternGroupStandard" class="radio-card-input" ng-value="WORK_PATTERN_GROUPS.standard" ng-model="vm.workPattern.Group" ng-change="reviewWorkPattern(vm)" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="patternGroupStandard">\n\t\t\t\t\t\t\t<i class="icon-calendar radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Standard</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="patternType" id="patternGroupNonStandard" class="radio-card-input" ng-value="WORK_PATTERN_GROUPS.nonStandard" ng-model="vm.workPattern.Group" ng-change="reviewWorkPattern(vm)" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="patternGroupNonStandard">\n\t\t\t\t\t\t\t<i class="icon-part-time radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Non-standard</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="description" class="required">Name:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input type="text" name="description" id="description" ng-model="vm.workPattern.Description" placeholder="Enter pattern name..." ng-pattern="$root.REGEX.description" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="workPatternForm.description.$error" ng-if="workPatternForm.description.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a name</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Standard -->\n\t\t<div class="form-field" ng-if="vm.workPattern.Group === WORK_PATTERN_GROUPS.standard">\n\t\t\t<p class="s">Select the working days you wish to include in the work pattern. You can set an effective date for the pattern when you assign it to a team member. <!--<a href="" class="underline">Read more about work patterns</a>--></p>\n\t\t</div>\n\n\t\t<!-- Basis (Weekly/Daily, Non-standard only) -->\n\t\t<div class="form-field" ng-if="vm.workPattern.Group === WORK_PATTERN_GROUPS.nonStandard">\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="toggle-block {{vm.workPattern.Group === WORK_PATTERN_GROUPS.standard ? \'quarternary\': \'secondary\'}}">\n\t\t\t\t\t<span class="toggle-block-label left" ng-class="{\'active\': vm.workPattern.Basis === WORK_PATTERN_BASIS.weekly}">Mon-Sun weeks</span>\n\t\t\t\t\t<a href="" ng-click="togglePatternBasis(vm)" class="toggle-block-toggle">\n\t\t\t\t\t\t<span class="toggle-c {{vm.workPattern.Group === WORK_PATTERN_GROUPS.standard ? \'quarternary\': \'secondary\'}}" ng-class="{active: vm.workPattern.Basis === WORK_PATTERN_BASIS.daily}"></span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<span class="toggle-block-label right" ng-class="{\'active\': vm.workPattern.Basis === WORK_PATTERN_BASIS.daily}">Individual days</span>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="vm.workPattern.Group === WORK_PATTERN_GROUPS.nonStandard">\n\t\t\t<p class="s">You can add up to five weeks to the pattern. Adjust the hours on each day or leave as \'0\' for non-working days. You can set an effective date when you assign the work pattern to a team member.</p>\n\t\t</div>\n\t</fieldset>\n\t\n\t<fieldset>\n\n\t\t<!-- Work Pattern -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<work-pattern-builder on-update="reloadCalendar(vm)" work-pattern="vm.workPattern"></work-pattern-builder>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Total Work Hours Per Week -->\n\t\t<div class="form-field fadeIn" ng-if="vm.workPattern.Group === WORK_PATTERN_GROUPS.standard">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="totalHours" class="required">Total work hours per week:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<number-selector-field ng-model="vm.workPattern.TotalHours" field-name="totalHours" nsf-on-change="roundTotalHours(vm)"></number-selector-field>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Preview Pattern -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<p class="s"><a href="" ng-click="toggleIsCalendarVisible(vm)"><i class="icon-back m"></i>&nbsp;&nbsp;Preview pattern in pay period calendar</a></p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Team Members -->\n\t<fieldset class="form-fieldset-divider-top" ng-if="!vm.isNewWorkPattern">\n\t\t<p class="s"><i class="icon-team-alt m primary"></i> This pattern is used by <a href="" ng-click="openWorkPatternTeamMembersForm(vm.workPattern)" class="underline"><ng-pluralize count="vm.workPattern.TeamMemberCount" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize></a></p>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="caption" ng-if="vm.workPattern.UpdatedDateISO">Last updated by {{vm.workPattern.UpdatedBy}} at {{vm.workPattern.UpdatedDateISO | dateformat:\'time\'}} on {{vm.workPattern.UpdatedDateISO | dateformat}}. <!--<a href="" class="greyscale underline">Archive pattern</a>--></p>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="workPatternForm.state" disable-button="!workPatternForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isCalendarVisible">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay Period Calendar</h5>\n\t\t<a href="" class="slide-in-form-aside-header-action" ng-click="closeIsCalendarVisible(vm)" aria-label="Close calendar"><i class="icon-right l"></i></a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main" ng-switch="vm.calendarState">\n\n\t\t<div class="fadeIn" ng-switch-when="ready">\n\t\t\t<weekly-calendar pay-period="vm.payPeriod" work-patterns="[vm.workPattern]"></weekly-calendar>\n\t\t</div>\n\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\t</div>\n</aside>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/work-pattern-delete/workPatternDeleteForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workPatternDeleteForm" ng-submit="deleteWorkPattern(vm, workPatternDeleteForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="s">This cannot be undone and you will need to re-create the work pattern if you change your mind later.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Delete\'" state="workPatternDeleteForm.state" disable-button="!workPatternDeleteForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to delete" ng-if="pageState === \'in-use\'">\n\t<fs-main>\n\t\t<p class="s">The {{vm.workPattern.Description}} work pattern is currently being used by&nbsp;<ng-pluralize count="vm.workPattern.TeamMemberCount" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize> and cannot be deleted.</p>\n\t</fs-main>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/work-pattern-team-members/workPatternTeamMembersForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workPatternTeamMembersForm" ng-submit="saveForm(form, workPatternTeamMembersForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<description-card icon="pay-periods" theme="{{vm.workPattern.Group === WORK_PATTERN_GROUPS.standard ? \'quarternary\' : \'secondary\'}}">{{vm.workPattern.Description}}</description-card>\n\t</div>\n\n\t<!-- Team Members -->\n\t<fieldset ng-if="vm.teamMembers.length">\n\n\t\t<div class="form-section">\n\t\t\t<p class="s">The below team members use this work pattern. You can assign it to other team members by editing their pay information. You can assign this work pattern to team members in their profiles. <a ui-sref="team.members({agencyProfileId: formOptions.agencyProfileId})" class="underline">Go to team</a></p>\n\t\t</div>\n\n\t\t<div class="team-card-basic_wrapper">\n\t\t\t<team-card-basic ng-repeat="teamMember in vm.teamMembers" show-email="false" team-member="teamMember">\n\t\t\t\t<tc-actions>\n\t\t\t\t\t<a class="team-card-basic_action" ui-sref="team.profile.information({agencyProfileId: formOptions.agencyProfileId, userId: teamMember.UserID})">Profile <i class="icon-chevron-right"></i></a>\n\t\t\t\t</tc-actions>\n\t\t\t</team-card-basic>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- No Team Members -->\n\t<div class="form-section" ng-if="!vm.teamMembers.length">\n\t\t<p class="s">There are no team members using the {{vm.workPattern.Description}} work pattern. <a ui-sref="team.members({agencyProfileId: formOptions.agencyProfileId})" class="underline">Go to team</a></p>\n\t</div>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/workflow-collaborator/workflowCollaboratorForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workflowCollaboratorForm" ng-submit="updateWorkflowTemplateEntry(vm, workflowCollaboratorForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<info-block ib-theme="primary has-icon has-border">\n\t\t\t<ib-header>\n\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t<i class="icon-workflow-alt primary info-block-icon"></i>\n\t\t\t\t\t<h6 class="stronger">{{vm.workflowTemplateEntry.Title}}</h6>\n\t\t\t\t</div>\n\t\t\t</ib-header>\n\t\t\t<ib-main>\n\t\t\t\t<p class="s">{{vm.workflowTemplateEntry.Description}}</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="s">Select someone from the collaborators who have access to this payroll.</p>\n\t</div>\n\n\t<!-- Select a collaborator -->\n\t<fieldset ng-if="!vm.activeAdmin">\n\n\t\t<div class="form-field" ng-if="vm.adminGroups.BureauAdmins.length > 0 && $root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureau, USER_ROLES.bureaumanager])">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Bureau admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.BureauAdmins">\n\t\t\t\t\t\t<action ng-if="!admin.isActive">\n\t\t\t\t\t\t\t<a href="" ng-click="selectAdmin(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="vm.adminGroups.GroupAdmins.length > 0 && $root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureau, USER_ROLES.bureaumanager, USER_ROLES.groupuser])">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Group admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.GroupAdmins">\n\t\t\t\t\t\t<action ng-if="!admin.isActive">\n\t\t\t\t\t\t\t<a href="" ng-click="selectAdmin(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="vm.adminGroups.CompanyAdmins.length > 0">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Company admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.CompanyAdmins">\n\t\t\t\t\t\t<action ng-if="!admin.isActive">\n\t\t\t\t\t\t\t<a href="" ng-click="selectAdmin(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Select a collaborator -->\n\t<fieldset ng-if="vm.activeAdmin">\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">Select a collaborator:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="vm.activeAdmin">\n\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t<a href="" ng-click="deselectAdmin(vm)" class="s">Change</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<fieldset ng-if="vm.workflowTemplateEntry.Number === 1">\n\n\t\t\t<!-- Has note -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="checkbox" id="hasNote" name="hasNote" ng-model="vm.workflowTemplateEntry.HasNote" ng-change="updateHasNote(vm)" label-text="\'Add an automatic welcome note for \' + vm.activeAdmin.Forename" checkbox>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Each time a new workflow cycle begins, your welcome note will appear at the top of the Notes stream so you can let {{vm.activeAdmin.Forename}} know what data you\u2019d like them to share with you</p>\n\t\t\t</div>\n\n\t\t\t<!-- Note -->\n\t\t\t<div class="form-field fadeIn">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="welcomeNote" ng-class="{\'disabled\': !vm.workflowTemplateEntry.HasNote, \'required\': vm.workflowTemplateEntry.HasNote}">Note:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<textarea name="welcomeNote" id="welcomeNote" maxlength="1000" rows="10" ng-model="vm.workflowTemplateEntry.Note" placeholder="{{vm.workflowTemplateEntry.HasNote ? \'\' : vm.workflowTemplateEntry.notePlaceholder}}" ng-required="vm.workflowTemplateEntry.HasNote" ng-disabled="!vm.workflowTemplateEntry.HasNote"></textarea>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="workflowCollaboratorForm.welcomeNote.$error" ng-if="workflowCollaboratorForm.welcomeNote.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a note</p>\n\t\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="workflowCollaboratorForm.state" disable-button="!workflowCollaboratorForm.$valid || !vm.activeAdmin"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/company/xero/xero.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- 2FA warning -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-title="Turn on Two Factor Authentication" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.twoFaWarning">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPlease contact your system admin as Two Factor Authentication must be been turned on for {{$ctrl.formOptions.company.Name}} before you can connect to Xero.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Identity Confirm 2FA policy -->\n<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="true" fs-title="Are you sure you wish to connect to Xero?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.identityConfirm2faPolicy">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tBefore connecting, you need to confirm that you\'ve enabled two-factor authentication for {{$ctrl.formOptions.company.Name}} in your Access account. You\u2019ll then be taken to the Xero login screen and, after logging in, you\u2019ll be able to select an organisation to give Paycircle access to.\n\t\t</p>\n\t\t<div class="spacer m"></div>\n\t\t<note class="fadeIn" note-theme="tertiary is-form-field">\n\t\t\t<note-content>\n\t\t\t\t<p>Before continuing you need to confirm that you have enabled two-factor authentication using your Access account.</p>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<input id="checkboxField" label-text="\'I confirm that I have enabled two-factor authentication.\'" label-text-class="is-small" name="checkboxField" ng-model="$ctrl.IdentityConfirmTwoFAPolicyState" type="checkbox" checkbox>\n\t\t\t</note-content>\n\t\t</note>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="is-tertiary primary-action" ng-disabled="!$ctrl.IdentityConfirmTwoFAPolicyState" ng-click="$ctrl.confirmIdentityTwoFAPolicyState($ctrl)">Connect</button>\n\t</fs-actions>\n</form-state>\n\n\n<!-- Confirm connect -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to connect to Xero?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmConnect">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tYou\u2019ll be taken to the Xero login screen and, after logging in, you\u2019ll be able to select an organisation to allow Paycircle access to.\n\t\t\tClick &lsquo;Connect&rsquo; if you\u2019re happy to continue.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.connectToXero($ctrl)">Connect</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Awaiting authorisation -->\n<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Awaiting authentication" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.pollingAuthorisation">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tOnce you\u2019ve successfully allowed access to this organisation in Xero we\u2019ll confirm that Paycircle has been successfully connected. Please leave this window open in the meantime.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Connected -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Connected to Xero" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connected">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou\u2019ve successfully connected to Xero. To import the Chart of Accounts click on the \u2018Import\u2019 button\n\t\t\t\tin the nominal codes area, and select the Xero option in the importer. You can disconnect from Xero\n\t\t\t\tat any time from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong"><a href="" ng-click="$ctrl.closeForm()">Ok, close this window</a></p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Confirm disconnect -->\n<form class="fadeIn" name="disconnectXeroForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect" ng-submit="$ctrl.disconnectXero($ctrl, disconnectXeroForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to disconnect from Xero?" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.confirmDisconnect">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tOnce disconnected you\'ll no longer be able to import your Chart of Accounts or post journals to Xero. Please note that this won\'t affect any other companies you may have connected to the same organisation in Xero. Click &lsquo;Confirm&rsquo; if you\'re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<button class="is-tertiary primary-action" ng-click="$ctrl.disconnectXero($ctrl)">Confirm</button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!disconnectXeroForm.$valid" display-text="\'Confirm\'" state="disconnectXeroForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Disconnected -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="Disconnected from Xero" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.disconnected">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou can connect to Xero again at any time from your integration settings.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s strong"><a href="" ng-click="$ctrl.closeForm()">Ok, close this window</a></p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Connect error -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to establish Xero connection" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connectError">\n\t<fs-main>\n\t\t<p class="s">We\'re unable to establish a connection to Xero at this time. Please try again in a few moments. If the problem persists please contact support.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/company/workflow-deadlines/workflowDeadlinesForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workflowDeadlinesForm" ng-submit="updateWorkflowTemplateEntries(vm, workflowDeadlinesForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tSet deadlines for each step of the payroll process relative to your pay date:\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-secondary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="icon-calendar" theme="is-secondary is-medium has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<div class="slide-in-form-info-card_title">Next pay date: {{::$root.currentPeriod.PayDateISO | dateformat:\'dayMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<div class="workflow-deadline-entry_wrapper">\n\t\t\t<workflow-deadline-entry ng-repeat="(templateEntryIndex, templateEntry) in vm.workflowTemplate.TemplateEntries" entry="templateEntry" entry-index="templateEntryIndex" entries="vm.workflowTemplate.TemplateEntries" on-entry-update="onDeadlineEntryChange()"></workflow-deadline-entry>\n\n\t\t</div>\n\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<!-- Calendar type -->\n\t\t<div class="form-field form-field-highlight is-primary">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="calendarType" class="required">Calculate deadlines using:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main has-suffix">\n\t\t\t\t<select data-cy="calendar-type-select" id="calendarType" name="calendarType" ng-model="vm.workflowTemplate.CalendarType" ng-options="calendarType.value as calendarType.description for calendarType in vm.calendarTypeOptions" required>\n\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t</select>\n\t\t\t\t<i class="form-field-main_suffix icon-information is-primary" ng-if="vm.workflowTemplate.CalendarType === WORKFLOW_CALENDAR_TYPES.calendarDays" tooltip tooltip-text="Deadlines will be calculated regardless of weekends and Bank Holidays."></i>\n\t\t\t\t<i class="form-field-main_suffix icon-information is-primary" ng-if="vm.workflowTemplate.CalendarType === WORKFLOW_CALENDAR_TYPES.workingDays" tooltip tooltip-text="Deadlines will be calculated excluding weekends and Bank Holidays."></i>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Offset type -->\n\t\t<div class="form-field form-field-highlight is-primary">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="offsetType" class="required">When deadlines fall on a weekend or Bank Holiday:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select data-cy="offset-type-select" id="offsetType" name="offsetType" ng-model="vm.workflowTemplate.OffsetType" ng-options="offsetType.value as offsetType.description for offsetType in vm.offsetTypeOptions" required>\n\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t</div>\n\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="workflowDeadlinesForm.state" disable-button="!workflowDeadlinesForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/employment/add-tax-update/add-tax-update.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addTaxUpdateForm" ng-if="$ctrl.formState === \'ready\' || $ctrl.formState === \'saved\'" ng-submit="$ctrl.addTaxUpdate($ctrl.teamMember, $ctrl.taxUpdate, addTaxUpdateForm, $ctrl.formOptions.isEditMode)" novalidate>\n\t<div ng-if="$ctrl.formState === \'ready\'">\n\n\t\t<section class="form-section" ng-if="$ctrl.formOptions.isEditMode">\n\t\t\t<div class="spacer m"></div>\n\t\t\t<div>\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Some values can\'t be edited">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tTo edit the effective date of a manual update you will need to delete it and add a new one.\n\t\t\t\t\t\t\tWhere an update has been sent from HMRC, both the effective date and the value being updated can\'t be edited.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="form-section">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p>\n\t\t\t\t\tThis update will include all of the values below.\n\t\t\t\t\tDepending on when you want it to become effective, you may wish to compare it to any other scheduled updates for {{$ctrl.formOptions.context.Forename}}.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="form-section">\n\n\t\t\t<!--Edit tax code-->\n\t\t\t<form-accordion-alternative cancel-id="add-tax-update-cancel-edit-tax-code" edit-id="add-tax-update-edit-tax-code" is-read-only="$ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateTaxCode" on-cancel="$ctrl.resetTaxCode($ctrl.taxUpdate, $ctrl.taxUpdateCopy)" on-edit="$ctrl.updateEditBlockCount(1)">\n\t\t\t\t<faa-title-closed>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\t<i class="icon-tax-code-change is-medium is-primary" data-cy="add-tax-update-prepopulated-tax-code" ng-class="{ \'is-tertiary\': $ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateTaxCode }"></i>&nbsp;\n\t\t\t\t\t\tTax code: {{::$ctrl.taxUpdate.taxCode}}\n\t\t\t\t\t</h6>\n\t\t\t\t</faa-title-closed>\n\n\t\t\t\t<faa-title-open>\n\t\t\t\t\t<h5>Edit tax code</h5>\n\t\t\t\t</faa-title-open>\n\n\t\t\t\t<faa-content>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<tax-info-form-fields allow-ni-category-edit="false" ni-category-letters="$ctrl.niCategoryLetters" required="true" show-ni-category="false" tax-info="$ctrl.taxUpdate"></tax-info-form-fields>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</faa-content>\n\t\t\t</form-accordion-alternative>\n\n\t\t\t<!--Edit national insurance category-->\n\t\t\t<form-accordion-alternative cancel-id="add-tax-update-cancel-edit-ni-category" edit-id="add-tax-update-edit-ni-category" is-read-only="$ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateNICategory" on-cancel="$ctrl.resetNICode($ctrl.taxUpdate, $ctrl.taxUpdateCopy)" on-edit="$ctrl.updateEditBlockCount(1)">\n\t\t\t\t<faa-title-closed>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\t<i class="icon-national-insurance is-medium is-primary" data-cy="add-tax-update-prepopulated-ni-category" ng-class="{ \'is-tertiary\': $ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateNICategory }"></i>&nbsp;\n\t\t\t\t\t\tNational Insurance category: {{::$ctrl.taxUpdate.NICode}}\n\t\t\t\t\t</h6>\n\t\t\t\t</faa-title-closed>\n\n\t\t\t\t<faa-title-open>\n\t\t\t\t\t<h5>Edit National Insurance category</h5>\n\t\t\t\t</faa-title-open>\n\n\t\t\t\t<faa-subtitle data-cy="add-tax-update-prepopulated-civilian-employment-start-date" ng-if="$ctrl.taxUpdate.NICode === $ctrl.NI_CATEGORY_LETTER.v && $ctrl.taxUpdate.CivilianStartDateISO">\n\t\t\t\t\tStart date of first civilian employment: {{::$ctrl.taxUpdate.CivilianStartDateISO | dateformat}}\n\t\t\t\t</faa-subtitle>\n\n\t\t\t\t<faa-content>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="niCode">\n\t\t\t\t\t\t\t\t\t\tNI Category:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<select class="m" id="niCode" name="niCode" ng-change="$ctrl.niCodeOnChange($ctrl.taxUpdate.NICodeChange, $ctrl.teamMember.Tax.NICodeChangeEffectiveDateISO)" ng-model="$ctrl.taxUpdate.NICodeChange" ng-options="niCategory as niCategory for niCategory in $ctrl.niCategoryLetters" ng-required="true">\n\t\t\t\t\t\t\t\t\t\t\t<option value="">Select...</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addTaxUpdateForm.niCode.$error" ng-show="addTaxUpdateForm.niCode.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please choose a new NI category</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Veterans -->\n\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.taxUpdate.NICodeChange === $ctrl.NI_CATEGORY_LETTER.v">\n\t\t\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tEnter the start date of {{::$ctrl.formOptions.context.Forename}}\u2019s first civilian employment if you want Employer NICs relief to be automatically stopped after their qualifying period ends.\n\t\t\t\t\t\t\t\t\t\tOtherwise, you\u2019ll need to manually change their National Insurance category.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- First civilian employment -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="civilianStartDateIso">\n\t\t\t\t\t\t\t\t\t\t\tStart date of {{::$ctrl.formOptions.context.Forename}}\u2019s first civilian employment:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="civilianStartDateIso" field-required="false" field-style="l" field-value-iso="$ctrl.taxUpdate.CivilianStartDateISO"></date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addTaxUpdateForm.civilianStartDateIso.$touched" ng-messages="addTaxUpdateForm.civilianStartDateIso.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<fieldset ng-if="$ctrl.canEditBackdatedNI">\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input checkbox id="hasBackdateNi" label-text="\'Backdate category change\'" name="hasBackdatedNi" ng-model="$ctrl.teamMember.Tax.HasBackdatedNI" type="checkbox"></div>\n\t\t\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t\t\t\t<p class="s">Check this box if you wish to backdate the category change and calculate backdated employee National Insurance.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.teamMember.Tax.HasBackdatedNI">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="niEffectiveFromDate" ng-class="{ \'required\' : $ctrl.teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\t\t\tEffective from date:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="niEffectiveFromDate" field-max-date-iso="::$ctrl.teamMember.Tax.NICodeChangeEffectiveDateMaxISO" field-min-date-iso="::$ctrl.teamMember.Tax.NICodeChangeEffectiveDateMinISO" field-on-change-fn="$ctrl.niEffectiveFromDateOnChange($ctrl.taxUpdate.NICodeChange, $ctrl.teamMember.Tax.NICodeChangeEffectiveDateISO)" field-required="$ctrl.teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="$ctrl.teamMember.Tax.NICodeChangeEffectiveDateISO"></date-input-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addTaxUpdateForm.niEffectiveFromDate.$error" ng-show="addTaxUpdateForm.niEffectiveFromDate.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please choose an effective from date</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please choose a date on or after the start of the current tax year ({{$ctrl.teamMember.Tax.NICodeChangeEffectiveDateMinISO | dateformat}})</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Please choose a date earlier than or on the previous pay date ({{$ctrl.teamMember.Tax.NICodeChangeEffectiveDateMaxISO | dateformat}})</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-message">Must be earlier than or on the previous pay date ({{::$ctrl.teamMember.Tax.NICodeChangeEffectiveDateMaxISO | dateformat}})</div>\n\t\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.teamMember.Tax.HasBackdatedNI && addTaxUpdateForm.niEffectiveFromDate.$valid">\n\t\t\t\t\t\t\t\t\t\t\t<div class="divider primary"></div>\n\t\t\t\t\t\t\t\t\t\t\t<p class="s">Based on the effective date you\'ve entered, we\'ve calculated the following backdated employee NI change:</p>\n\t\t\t\t\t\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t\t\t\t\t\t<calculation-card amount="$ctrl.teamMember.Tax.BackdatedNIEEAmount ? $ctrl.teamMember.Tax.BackdatedNIEEAmount : 0" busy="$ctrl.teamMember.Tax.calculatingBackdatedNI" title="Backdated employee National Insurance"></calculation-card>\n\t\t\t\t\t\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t\t\t\t\t\t<p class="s">The above change will be added to your current period for {{$ctrl.teamMember.Personal.Forename}}.</p>\n\t\t\t\t\t\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t\t\t\t\t\t<p class="form-message normal primary" ng-if="$ctrl.teamMember.Tax.calculatingBackdatedNI">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="spin icon-loading m"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t\tCalculating backdated NI\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p class="form-message normal primary" ng-if="!$ctrl.teamMember.Tax.calculatingBackdatedNI">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-back m is-primary"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" href="" ng-click="$ctrl.toggleShowBackdatedNICalculations($ctrl.teamMember)">\n\t\t\t\t\t\t\t\t\t\t\t\t\tPreview backdated NI calculations\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Has {{$ctrl.formOptions.context.Forename}}\'s date of birth changed?">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s date of birth can affect their NI calculations.\n\t\t\t\t\t\t\t\t\t\tYou may wish to double check that {{$ctrl.formOptions.context.Forename}}\'s date of birth is correct.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- Note: Workplace postcode -->\n\t\t\t\t\t\t<div class="form-field" ng-if="$ctrl.teamMember.CanRequireWorkplacePostcode">\n\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Freeport and investment zone NI categories">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\tYou may need to add a workplace postcode for {{$ctrl.formOptions.context.Forename}} if they have been on a freeport or investment zone NI category this tax year.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</faa-content>\n\n\t\t\t</form-accordion-alternative>\n\n\t\t\t<!--Edit student loan-->\n\t\t\t<form-accordion-alternative cancel-id="add-tax-update-cancel-edit-student-loan" edit-id="add-tax-update-edit-student-loan" is-read-only="$ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateStudentLoan" ng-if="::$ctrl.taxUpdate.canShowStudentLoan && !$ctrl.teamMember.Company.IsOffPayrollWorker" on-cancel="$ctrl.resetStudentLoan($ctrl.taxUpdate, $ctrl.taxUpdateCopy)" on-edit="$ctrl.updateEditBlockCount(1)">\n\t\t\t\t<faa-title-closed>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\t<i class="icon-student-loan is-medium is-primary" data-cy="add-tax-update-prepopulated-student-loan" ng-class="{ \'is-tertiary\': $ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdateStudentLoan }"></i>&nbsp;\n\t\t\t\t\t\tStudent loan: {{::$ctrl.taxUpdate.StudentLoan}}\n\t\t\t\t\t</h6>\n\t\t\t\t</faa-title-closed>\n\n\t\t\t\t<faa-title-open>\n\t\t\t\t\t<h5>Edit student loan</h5>\n\t\t\t\t</faa-title-open>\n\n\t\t\t\t<faa-content>\n\t\t\t\t\t<!-- Student loan -->\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="form-field-label required" for="studentLoanTrue">\n\t\t\t\t\t\t\t\t\tDoes {{$ctrl.formOptions.context.Forename}} have a student loan?\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanTrue" name="studentLoan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.HasStudentLoan" ng-required="true" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanTrue">\n\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanFalse" name="studentLoan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.HasStudentLoan" ng-required="true" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanFalse">\n\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Student loan plan -->\n\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.taxUpdate.HasStudentLoan">\n\t\t\t\t\t\t\t<label class="strong required" for="studentLoanPlan1">\n\t\t\t\t\t\t\t\tStudent loan plan:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t\t\t<span ng-if="::$ctrl.taxUpdate.canShowStudentLoanPlan1">\n\t\t\t\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1" name="studentLoanPlan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.studentLoanPlanOption" ng-required="true" ng-value="$ctrl.STUDENT_LOAN_PLANS.plan1" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="studentLoanPlan1">Plan 1</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="::$ctrl.taxUpdate.canShowStudentLoanPlan2">\n\t\t\t\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan2" name="studentLoanPlan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.studentLoanPlanOption" ng-required="true" ng-value="$ctrl.STUDENT_LOAN_PLANS.plan2" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="studentLoanPlan2">Plan 2</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="::$ctrl.taxUpdate.canShowStudentLoanPlan1and2">\n\t\t\t\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1and2" name="studentLoanPlan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.studentLoanPlanOption" ng-required="true" ng-value="$ctrl.STUDENT_LOAN_PLANS.plan1and2" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="studentLoanPlan1and2">Plan 1 and 2</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="::$ctrl.taxUpdate.canShowStudentLoanPlan4">\n\t\t\t\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan4" name="studentLoanPlan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.studentLoanPlanOption" ng-required="true" ng-value="$ctrl.STUDENT_LOAN_PLANS.plan4" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="studentLoanPlan4">Plan 4</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="::$ctrl.taxUpdate.canShowStudentLoanPlan5">\n\t\t\t\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan5" name="studentLoanPlan" ng-change="$ctrl.updateStudentLoan($ctrl.taxUpdate)" ng-model="$ctrl.taxUpdate.studentLoanPlanOption" ng-required="true" ng-value="$ctrl.STUDENT_LOAN_PLANS.plan5" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="studentLoanPlan5">Plan 5</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addTaxUpdateForm.studentLoanPlan.$error" ng-show="addTaxUpdateForm.studentLoanPlan.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please choose a student loan plan</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</faa-content>\n\n\t\t\t</form-accordion-alternative>\n\n\t\t\t<!--Edit postgraduate loan-->\n\t\t\t<form-accordion-alternative cancel-id="add-tax-update-cancel-edit-postgraduate-loan" edit-id="add-tax-update-edit-postgraduate-loan" is-read-only="$ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdatePostGraduateLoan" ng-if="::$ctrl.taxUpdate.canShowPostgraduateLoan && !$ctrl.teamMember.Company.IsOffPayrollWorker" on-cancel="$ctrl.resetPostgraduateLoan($ctrl.taxUpdate, $ctrl.taxUpdateCopy)" on-edit="$ctrl.updateEditBlockCount(1)">\n\t\t\t\t<faa-title-closed>\n\t\t\t\t\t<h6>\n\t\t\t\t\t\t<i class="icon-student-loan is-medium is-primary" data-cy="add-tax-update-prepopulated-postgraduate-loan" ng-class="{ \'is-tertiary\': $ctrl.formOptions.isEditMode && !$ctrl.taxUpdate.CanUpdatePostGraduateLoan }"></i>&nbsp;\n\t\t\t\t\t\tPostgraduate loan: {{::$ctrl.taxUpdate.PostGraduateLoan}}\n\t\t\t\t\t</h6>\n\t\t\t\t</faa-title-closed>\n\n\t\t\t\t<faa-title-open>\n\t\t\t\t\t<h5>Edit postgraduate loan</h5>\n\t\t\t\t</faa-title-open>\n\n\t\t\t\t<faa-content>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="form-field-label required" for="postgraduateLoanTrue">\n\t\t\t\t\t\t\t\t\tDoes {{$ctrl.formOptions.context.Forename}} have a postgraduate loan?\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanTrue" name="postgraduateLoan" ng-model="$ctrl.taxUpdate.HasPostGraduateLoan" ng-required="true" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanTrue">\n\t\t\t\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanFalse" name="postgraduateLoan" ng-model="$ctrl.taxUpdate.HasPostGraduateLoan" ng-required="true" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanFalse">\n\t\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</faa-content>\n\t\t\t</form-accordion-alternative>\n\n\t\t\t<section class="form-section">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPlease note that the effective date will be relative to the pay date for the period in which it falls.\n\t\t\t\t\t\tYou\'re currently in the {{$ctrl.formOptions.currentPayPeriod.PayPeriodDisplay}} pay period and the pay date is the {{$ctrl.formOptions.currentPayPeriod.PayDateISO | dateformat : \'custom\' : \'Do MMMM\'}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Tax update effective date -->\n\t\t\t<fieldset class="fadeIn">\n\t\t\t\t<!-- Tax change effective date -->\n\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="EffectiveDateISO">\n\t\t\t\t\t\t\tEffective date:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main row no-margin">\n\t\t\t\t\t\t<date-input-field class="col six" field-disabled="$ctrl.formOptions.isEditMode" field-id="EffectiveDateISO" field-max-date-iso="$ctrl.effectiveDateMaxISO" field-min-date-iso="$ctrl.effectiveDateMinISO" field-required="true" field-value-iso="$ctrl.taxUpdate.EffectiveDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addTaxUpdateForm.EffectiveDateISO.$touched" ng-messages="addTaxUpdateForm.EffectiveDateISO.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t<p ng-message="min,max">Please enter a date between {{$ctrl.effectiveDateMinISO | dateformat}} - {{$ctrl.effectiveDateMaxISO | dateformat}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the tax update effective date</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="fadeIn form-message" ng-if="!$ctrl.formOptions.isEditMode">\n\t\t\t\t\t\tMust be between {{$ctrl.effectiveDateMinISO | dateformat}} - {{$ctrl.effectiveDateMaxISO | dateformat}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</section>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<!-- Close -->\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeWithoutCallback()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button disable-button="addTaxUpdateForm.$invalid || $ctrl.editBlocksOpen === 0" state="addTaxUpdateForm.state"></submit-button>\n\t\t</fieldset>\n\t</div>\n\n\t<div ng-if="$ctrl.formState === \'saved\'">\n\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Tax update saved">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s tax update has been saved. You can delete it up until payroll is run for the period in which it becomes effective.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="primary" fs-title="Future update already saved" ng-if="$ctrl.formState === \'cant-add-update\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease note that if there\'s an update already saved that will become effective on your next pay date ({{ $ctrl.formOptions.currentPayPeriod.PayDateISO | dateformat:\'full\' }}) or one that will become effective in a future pay period, you will need to delete it before adding a new update.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action tertiary" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="$ctrl.formState ===\'ready\' && $ctrl.teamMember.Tax.showBackdatedNICalculations">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Backdated NI calculations</h5>\n\t\t<a aria-label="Hide backdated NI calculations" class="slide-in-form-aside-header-action" href="" ng-click="$ctrl.toggleShowBackdatedNICalculations($ctrl.teamMember)">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\t<backdated-ni-calculation-view backdated-ni="$ctrl.teamMember.Tax.backdatedNI" busy="$ctrl.teamMember.Tax.calculatingBackdatedNI"></backdated-ni-calculation-view>\n</aside>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/add-to-business-category/add-to-business-category.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addToBusinessCategoryForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateBusinessCodeMembersForBusinessCategory(addToBusinessCategoryForm)" novalidate>\n\n\t<fieldset ng-if="$ctrl.businessCategories.length">\n\n\t\t<section class="form-section">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p>\n\t\t\t\t\tYou\u2019re adding\n\t\t\t\t\t<ng-pluralize count="$ctrl.formOptions.userIds.length" when="{\n\t\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\tto business categories. If a team member is already allocated to a category it will be overwritten by the category you select below.\n\t\t\t\t\tPlease note this won\u2019t affect any of their historical data.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="form-section">\n\n\t\t\t<fieldset class="form-field-highlight is-clear fadeIn" ng-repeat="businessCategoryChange in $ctrl.businessCategoryChanges">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\n\t\t\t\t\t\t<h5 class="form-section-subheading has-smaller-margin">Add to business category</h5>\n\n\t\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t\t<a class="form-field-header-action primary" href="" ng-click="$ctrl.onBusinessCategoryChangeDelete($index)" ng-if="$ctrl.businessCategoryChanges.length > 1 && !$ctrl.isSelectedCostSplitBusinessCategory(businessCategoryChange)">\n\t\t\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<label class="required" for="business-category-$index">\n\t\t\t\t\t\t\tType:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="l-alt" id="business-category-$index" name="business-category-$index" ng-disabled="businessCategoryChange.BusinessCategory && $ctrl.isSelectedCostSplitBusinessCategory(businessCategoryChange)" ng-model="businessCategoryChange.BusinessCategory" ng-options="businessCategory as businessCategory.BusinessCategoryName for businessCategory in $ctrl.businessCategories | addToBusinessCategoryRemoveUsedCategories : $ctrl.businessCategoryChanges : businessCategoryChange.BusinessCategory.BusinessCategoryID" required>\n\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\tPlease select a type...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addToBusinessCategoryForm[\'business-category-\' + $index].$touched" ng-messages="addToBusinessCategoryForm[\'business-category-\' + $index].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please select a type</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="business-code-$index">\n\t\t\t\t\t\t\tCategory:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="l-alt" id="business-code-$index" name="business-code-$index" ng-change="$ctrl.onBusinessCategoryChange(businessCategoryChange.BusinessCategory)" ng-disabled="!businessCategoryChange.BusinessCategory || $ctrl.isSelectedCostSplitBusinessCategory(businessCategoryChange)" ng-model="businessCategoryChange.BusinessCategory.selectedBusinessCode" ng-options="::businessCode as businessCode.BusinessCodeNarrative for businessCode in businessCategoryChange.BusinessCategory.BusinessCodes" required>\n\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\tPlease select a category...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addToBusinessCategoryForm[\'business-code-\' + $index].$touched" ng-messages="addToBusinessCategoryForm[\'business-code-\' + $index].$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please select a category</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t</section>\n\n\t\t<section class="form-section fadeIn" ng-if="$ctrl.businessCategoryChanges.length < $ctrl.businessCategories.length">\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.onAddAnother()" type="button">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add business category\n\t\t\t</button>\n\t\t</section>\n\n\t\t<section class="form-section with-separator" ng-if="$ctrl.businessCodeSelected()">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p>\n\t\t\t\t\tGross costs for journals will be allocated to the business categories selected above. Add a cost split below to split them across other categories. This will overwrite any cost splits already saved for the selected team members.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.businessCodes.BusinessCodeCostSplit !== null && $ctrl.businessCodes.BusinessCodeCostSplit.BusinessCategoryID !== $root.CONFIG.guidEmpty">\n\n\t\t\t\t<cost-split-form-field business-categories="$ctrl.businessCategoriesForCostSplit" empty-user-agency-profile-business-code="$ctrl.emptyUserAgencyProfileBusinessCode" user="{ userId: $ctrl.formOptions.userIds[0] }" user-business-codes="$ctrl.businessCodes">\n\t\t\t\t</cost-split-form-field>\n\t\t\t</div>\n\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.businessCodes.BusinessCodeCostSplit.BusinessCategoryID === $root.CONFIG.guidEmpty">\n\t\t\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.onAddCostSplitClick()" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add cost split\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</section>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button disable-button="!addToBusinessCategoryForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="addToBusinessCategoryForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Team members updated" ng-if="$ctrl.formState === \'success\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYour selected team members have been updated an you can review their changes in the Company Details area in their profile.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/additionalPost/additionalPostForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="additionalPostForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="updateAdditionalPost(vm, vm.additionalPost, vm.teamMember.salary, additionalPostForm)" novalidate>\n\n\t<fieldset ng-if="formOptions.activeStep === PAGE_STEPS.companyDetails">\n\n\t\t<!-- Start date (if additional post has not yet been paid) -->\n\t\t<div class="form-field" ng-if="!vm.additionalPost.IsLocked">\n\t\t\t<div class="fadeIn" ng-if="vm.teamMember.salary.SalaryYearly">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="startDate">\n\t\t\t\t\t\tPost start date:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="startDate" field-min-date-iso="vm.teamMember.salary.StartDateISO" field-on-change-fn="onStartDateChange(vm)" field-style="primary" field-value-iso="vm.additionalPost.StartDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="additionalPostForm.startDate.$touched" ng-messages="additionalPostForm.startDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the post start date</p>\n\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.teamMember.salary.StartDateISO | dateformat}}</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Job Title -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="jobTitle">\n\t\t\t\t\tJob title:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="jobTitle" name="jobTitle" ng-model="vm.additionalPost.SalaryPolicyPostTitle" ng-pattern="$root.REGEX.genericCharacter" type="text" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="additionalPostForm.jobTitle.$error" ng-show="additionalPostForm.jobTitle.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Job titles can only contain letters, numbers and basic symbols</p>\n\t\t\t\t<p ng-message="required">Please enter a job title</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Job grade -->\n\t\t<div class="form-field" ng-if="vm.company.IsHRActive && vm.policyGrades.length !== 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="jobGrade">Job grade:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="jobGrade" name="jobGrade" ng-model="vm.additionalPost.JobGradeID" ng-options="policyGrade.PolicyGradeID as policyGrade.PolicyGradeName for policyGrade in vm.policyGrades | orderBy: \'PolicyGradeName\'">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Business codes -->\n\t\t<fieldset ng-if="vm.businessCategories.length">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Business categories</h5>\n\t\t\t\t<p class="form-field-sub is-small">Select home categories for {{::formOptions.context.Forename}} to allocate their gross costs for journals. Click \u2018Add cost split\u2019 to split them across other categories.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-repeat="businessCategory in vm.businessCategories">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="businessCategory_{{$index}}">\n\t\t\t\t\t\t{{businessCategory.BusinessCategoryName}}\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="businessCategory_{{$index}}" name="businessCategory_{{$index}}" ng-change="onBusinessCategoryChange()" ng-disabled="businessCategory.BusinessCategoryID === vm.userAgencyProfileBusinessCodes.BusinessCodeCostSplit.BusinessCategoryID" ng-model="businessCategory.selectedBusinessCode" ng-options="businessCode as businessCode.BusinessCodeNarrative for businessCode in businessCategory.BusinessCodes | orderBy: \'BusinessCodeNarrative\'">\n\t\t\t\t\t\t<option value="">-- None --</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="vm.userAgencyProfileBusinessCodes.BusinessCodeCostSplit.BusinessCategoryID !== $root.CONFIG.guidEmpty">\n\t\t\t\t<cost-split-form-field business-categories="vm.businessCategories" empty-user-agency-profile-business-code="vm.emptyUserAgencyProfileBusinessCode" user="{ userId: formOptions.userId, forename: formOptions.context.Forename }" user-business-codes="vm.userAgencyProfileBusinessCodes">\n\t\t\t\t</cost-split-form-field>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="vm.userAgencyProfileBusinessCodes.BusinessCodeCostSplit.BusinessCategoryID === $root.CONFIG.guidEmpty && showCostSplitButton()">\n\t\t\t\t<button class="is-medium-large is-white is-block" ng-click="onAddCostSplitClick(vm.userAgencyProfileBusinessCodes)" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add cost split\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Pay Policy -->\n\t\t<fieldset ng-if="vm.teamMember.salary.SalaryType === SALARY_TYPES.payPolicy">\n\n\t\t\t<!-- Post Identifier -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="salaryPolicyPostReference">\n\t\t\t\t\t\tPost Identifier:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="salaryPolicyPostReference" name="salaryPolicyPostReference" ng-model-options="{ debounce: 250 }" ng-model="vm.additionalPost.SalaryPolicyPostReference" post-identifier-unique post-identifier-unique-agency-profile-id="formOptions.agencyProfileId" post-identifier-unique-user-id="formOptions.userId" post-identifier-unique-original="vm.additionalPost.SalaryPolicyPostReference" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="additionalPostForm.salaryPolicyPostReference.$touched" ng-messages="additionalPostForm.salaryPolicyPostReference.$error" role="alert">\n\t\t\t\t\t<p ng-message="{{POST_IDENTIFIER_UNIQUE}}">\n\t\t\t\t\t\tThis identifier is being used by another post\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">\n\t\t\t\t\tUse this identifier to import payroll changes for team members with multiple posts. It can also be used as a post identifier to submit information to your pension provider.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<!-- Additional post only for pay policy paid team members -->\n\t<fieldset ng-if="formOptions.activeStep === PAGE_STEPS.payPolicyInformation">\n\n\t\t<div class="form-section">\n\t\t\t<h5 class="form-section-subheading">Pay</h5>\n\t\t\t<div class="form-section">\n\n\t\t\t\t<!-- Update pending message for annual salary policy when applicable -->\n\t\t\t\t<div class="form-section smaller-margin" ng-if="vm.additionalPost.SalaryPolicy.showPolicyUpdateInfo">\n\t\t\t\t\t<note note-icon="icon-information" note-theme="tertiary" note-title="Policy update">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\tA policy update has been added for the \'{{vm.additionalPost.SalaryPolicy.PolicyName}}\'\n\t\t\t\t\t\t\t\tpay policy and {{formOptions.context.Forename}}\'s pay has been updated.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Annual salary policy -->\n\t\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="false" allow-edit-effective-date="false" backdated-salary-derived-elements-enabled="vm.backdatedSalaryDerivedElementsEnabled" company="vm.company" current-pay-period="vm.currentPayPeriod" get-backdated-salary-derived-element-value-for-display="getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj)" id="additionalPostAnnualSalaryPolicy" mode="vm.additionalPost.IsLocked ? SALARY_POLICY_FORM_FIELD_MODES.view : SALARY_POLICY_FORM_FIELD_MODES.edit" on-add-change="addAnnualSalaryPolicyChange(vm.additionalPost.SalaryPolicy)" on-error="onError" pay-policies="vm.payPolicies" salary-policy="vm.additionalPost.SalaryPolicy" salary="vm.teamMember.salary" show-add-change="vm.additionalPost.IsLocked  && !vm.additionalPost.SalaryPolicy.SiblingPolicy" show-effective-date="!vm.teamMember.personal.IsInSetupMode" team-member="vm.teamMember">\n\t\t\t\t</salary-policy-form-field>\n\n\t\t\t\t<!-- Annual salary policy - additional form field when adding a change. -->\n\t\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="true" allow-edit-effective-date="!vm.additionalPost.SalaryPolicy.SiblingPolicy.IsPolicyUpdatePending" backdated-salary-derived-elements-enabled="vm.backdatedSalaryDerivedElementsEnabled" company="vm.company" current-pay-period="vm.currentPayPeriod" get-backdated-salary-derived-element-value-for-display="getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj)" id="additionalPostAnnualSalaryPolicyUpdate_{{$index}}" mode="SALARY_POLICY_FORM_FIELD_MODES.addChange" ng-if="vm.additionalPost.SalaryPolicy.SiblingPolicy" on-delete="deleteAnnualSalaryPolicyChange(vm, vm.additionalPost.SalaryPolicy)" on-error="onError" pay-policies="vm.payPolicies" salary-policy="vm.additionalPost.SalaryPolicy.SiblingPolicy" salary="vm.teamMember.salary" team-member="vm.teamMember">\n\t\t\t\t</salary-policy-form-field>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Annual allowance pay policies for additional post (zero or more)-->\n\t\t<div class="form-section with-separator" ng-repeat="annualAllowancePolicy in vm.additionalPost.SalaryPolicy.AllowancePolicies | filter: { IsSalaryPolicyDelete : false }">\n\t\t\t<div class="form-section_header">\n\t\t\t\t<div class="form-section_header-title">Annual allowance</div>\n\t\t\t\t<div class="form-section_header-action">\n\t\t\t\t\t<div class="fadeIn" ng-if="!annualAllowancePolicy.confirmDelete">\n\t\t\t\t\t\t<a class="greyscale s strong" href="" ng-click="toggleConfirmDeleteAnnualAllowancePolicy(annualAllowancePolicy)">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="fadeIn" ng-if="annualAllowancePolicy.confirmDelete">\n\t\t\t\t\t\t<p class="s strong">\n\t\t\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t\t\t<a href="" ng-click="deleteAnnualAllowancePolicy(vm.additionalPost, annualAllowancePolicy)">Yes</a>\n\t\t\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleConfirmDeleteAnnualAllowancePolicy(annualAllowancePolicy)">No</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Update pending message for annual allowance policy when applicable -->\n\t\t\t<div class="form-section smaller-margin" ng-if="annualAllowancePolicy.showPolicyUpdateInfo">\n\t\t\t\t<note note-icon="icon-information" note-theme="tertiary" note-title="Policy update">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tA policy update has been added for the \'{{annualAllowancePolicy.PolicyName}}\'\n\t\t\t\t\t\t\tpay policy and {{formOptions.context.Forename}}\'s pay has been updated.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Annual allowance policy -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="false" allow-edit-effective-date="vm.additionalPost.IsLocked" company="vm.company" current-pay-period="vm.currentPayPeriod" id="additionalPostAnnualAllowancePolicy_{{$index}}" mode="annualAllowancePolicy.HasBeenPaid ? SALARY_POLICY_FORM_FIELD_MODES.view : SALARY_POLICY_FORM_FIELD_MODES.edit" on-add-change="addAnnualAllowanceChange(annualAllowancePolicy)" on-error="onError" pay-policies="vm.payPolicies" parent-annual-salary-policy="vm.additionalPost.SalaryPolicy" salary-policy="annualAllowancePolicy" salary="vm.teamMember.salary" show-add-change="annualAllowancePolicy.HasBeenPaid && !annualAllowancePolicy.policyChange" show-effective-date="!vm.teamMember.personal.IsInSetupMode" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\n\t\t\t<!-- Annual allowance policy - additional form field when adding a change. -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="true" allow-edit-effective-date="!annualAllowancePolicy.policyChange.IsPolicyUpdatePending" company="vm.company" current-pay-period="vm.currentPayPeriod" id="additionalPostAnnualAllowancePolicyUpdate_{{$index}}" mode="SALARY_POLICY_FORM_FIELD_MODES.addChange" ng-if="annualAllowancePolicy.policyChange" on-delete="deleteAnnualAllowancePolicyChange(annualAllowancePolicy)" on-error="onError" pay-policies="vm.payPolicies" parent-annual-salary-policy="vm.additionalPost.SalaryPolicy" salary-policy="annualAllowancePolicy.policyChange" salary="vm.teamMember.salary" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\t\t</div>\n\n\t\t<!-- Add an annual allowance. One only. Available only there are annual allowance policies and one hasn\'t already been added-->\n\t\t<div class="form-section with-separator" ng-if="!vm.hasAnnualAllowancePolicy && vm.annualAllowancePoliciesCount !== 0">\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="addAnnualAllowancePolicy(vm)" type="button">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add annual allowance\n\t\t\t</button>\n\t\t</div>\n\n\t\t<!-- Day rate calculations -->\n\t\t<div class="form-section with-separator">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Day rate calculations</h5>\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe default calculation method saved in your company settings will be used\n\t\t\t\t\tbut that can overridden for {{formOptions.context.Forename}} below.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payPeriodProRationDayRate">\n\t\t\t\t\t\t\tPay period pro-ration day rate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="block" id="periodProRatingMethod" name="periodProRatingMethod" ng-model="vm.teamMember.salary.periodProRatingMethod" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | orderBy: \'description\'" required>\n\t\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">\n\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<p class="form-note is-primary-light">Used for starting, leaving, salary changes, and statutory payments</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payElementDayRate">Pay element day rate:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="block" id="elementProRatingMethod" name="elementProRatingMethod" ng-model="vm.teamMember.salary.elementProRatingMethod" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | orderBy: \'description\'" required>\n\t\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">\n\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<p class="form-note is-primary-light">\n\t\t\t\t\t\t\tUsed for day rate changes such as Unpaid Leave, Unpaid Sickness, and KIT Days\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="goToPageStep(vm, PAGE_STEPS.companyDetails)" ng-if="\n\t\t\t\tformOptions.activeStep === PAGE_STEPS.payPolicyInformation &&\n\t\t\t\tvm.showFormAsWizard\n\t\t\t">Back</a>\n\t\t<a class="button secondary-action" href="" ng-click="goToPageStep(vm, PAGE_STEPS.companyDetails)" ng-if="\n\t\t\t\tformOptions.activeStep === PAGE_STEPS.payInformation &&\n\t\t\t\tvm.showFormAsWizard\n\t\t\t">Skip</a>\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<!-- Submit (wizard context, \'Next\' or \'Finish\')-->\n\t\t<submit-button disable-button="additionalPostForm.$invalid" display-text="formOptions.activeStep === PAGE_STEPS.companyDetails ? \'Next\' : \'Finish\'" ng-if="vm.showFormAsWizard" state="additionalPostForm.state"></submit-button>\n\t\t<!-- Submit (non-wizard context, \'Save\')-->\n\t\t<submit-button disable-button="additionalPostForm.$invalid" display-text="\'Save\'" ng-if="!vm.showFormAsWizard" state="additionalPostForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<!-- Success message -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="positive" fs-title="Employment information saved" ng-if="pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}\u2019s employment information for this post has been saved and can be edited from their profile page at any time.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/additionalPost/cancelLeavingAdditionalPostForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="cancelLeavingAdditionalPostForm" ng-if="pageState === \'ready\'" ng-submit="cancelLeavingAdditionalPost(cancelLeavingAdditionalPostForm, vm)">\n\n\t<!-- Cancel leaving confirmation -->\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to cancel leaving?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">The leave date will be removed and {{formOptions.context.Forename}} will continue working in this post as normal.\n\t\t\t\tClick \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">Cancel</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="cancelLeavingAdditionalPostForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cancel leaving confirmation -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="secondary" fs-title="Leaving cancelled" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}} is no longer leaving their additional post.</p>\n\t</fs-main>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/additionalPost/deleteAdditionalPostForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteAdditionalPostForm" ng-if="pageState === \'ready\'" ng-submit="deleteAdditionalPost(deleteAdditionalPostForm)">\n\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to delete this post?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">Please note that if you\u2019ve added any changes to payroll for this post they will also be deleted. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Confirm\'" state="deleteAdditionalPostForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="primary" fs-title="Post deleted" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">This post has been deleted and {{formOptions.context.Forename}}\u2019s profile has been updated.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/additionalPost/leaveAdditionalPostForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="leaveAdditionalPostForm" ng-if="pageState === \'ready\'" ng-submit="leaveAdditionalPost(leaveAdditionalPostForm, vm)">\n\t<div class="form-intro">\n\t\t<p class="s">Enter {{formOptions.context.Forename}}\u2019s leaving date for \u2018{{vm.additionalPost.SalaryPolicy.SalaryPolicyPostTitle}}\u2019 and their pay will be adjusted in your current period as required.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="leaveDate">\n\t\t\t\t\tPost end date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="leaveDate" field-max-date-iso="vm.leaveDateMax" field-min-date-iso="vm.leaveDateMin" field-style="primary" field-on-change-fn="onLeaveDateChange(vm)" field-value-iso="vm.leaveDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="leaveAdditionalPostForm.leaveDate.$error" ng-if="leaveAdditionalPostForm.leaveDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a post end date</p>\n\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.leaveDateMin | dateformat}}</p>\n\t\t\t\t<p ng-message="max">Please enter a date on or before {{vm.leaveDateMax | dateformat}}</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t\t<div class="form-note">Please note: The post end date cannot be before the start date for this post ({{vm.leaveDateMin | dateformat}}) and\n\t\t\t\tmust be on or before the last day of your current pay period ({{vm.leaveDateMax | dateformat}}).\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Leave date in the past message -->\n\t<div class="form-content-block fadeIn" ng-if="vm.isLeaveDateInPast">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Updating Year to date figures">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">As you\'ve added a leave date in the past for {{formOptions.context.Forename}}, you may wish\n\t\t\t\t\tto review {{teamMember.Personal.Gender | personalise:\'her\'}} Year to date figures for the current tax\n\t\t\t\t\tyear and update them as required.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Leave date before last pay date -->\n\t<div class="form-content-block fadeIn" ng-if="vm.isLeaveDateBeforeLastPayDate">\n\t\t<note note-dismiss="false" note-has-confirmation="true" note-id="tax-correction-confirmation" note-theme="tertiary is-form-field" note-title="I confirm I\'ve corrected {{formOptions.context.Forename}}\'s tax position">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">You\'ve entered a leave date earlier than the last time {{formOptions.context.Forename}} was paid.\n\t\t\t\t\tThis payment may have needed to be a \'Payment After Leaving\' which would impact their tax position. Please\n\t\t\t\t\tcheck the box above to confirm you have taken the necessary steps to identify and correct any issues which\n\t\t\t\t\tmay arise from using the leave date entered before clicking \'Save\'.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!leaveAdditionalPostForm.$valid" display-text="\'Save\'" state="leaveAdditionalPostForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="secondary" fs-title="Marked as leaving post" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">You can cancel this from {{formOptions.context.Forename}}\u2019s profile area any time up until you next run payroll.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/backdated-salary/backdated-salary-calculation-view.form.html','<div>\n\n\t<!-- Loading -->\n\t<div class="slide-in-form-aside-main" ng-if="$ctrl.busy">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="slide-in-form-aside-main" ng-if="!$ctrl.busy">\n\n\t\t<!-- Has calculation -->\n\t\t<div ng-if="$ctrl.backdatedSalary.BackdatedSalary.length" ng-repeat="backdatedSalaryPeriod in $ctrl.backdatedSalary.BackdatedSalary">\n\t\t\t<h6 class="payments-summary-table-title">\n\t\t\t\t<i class="icon-calendar is-medium is-primary"></i>&nbsp;&nbsp;{{backdatedSalaryPeriod.PayPeriodDisplay}}\n\t\t\t</h6>\n\t\t\t<table class="primary payments-summary-table">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class="is-title-column">PAYMENT</th>\n\t\t\t\t\t\t<th>ORIGINAL</th>\n\t\t\t\t\t\t<th>NEW</th>\n\t\t\t\t\t\t<th>DIFFERENCE</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Gross Pay</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.Gross | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.GrossCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.GrossDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Tax</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.Tax | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.TaxCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.TaxDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Employee\'s NI</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NIEE | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NIEECorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.NIEEDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Employer\'s NI</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NIER | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NIERCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.NIERDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Employee\'s workplace pension</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.EmployeePension | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.EmployeePensionCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.EmployeePensionDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Employer\'s workplace pension</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.EmployerPension | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.EmployerPensionCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.EmployerPensionDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Student loan</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.StudentLoan | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.StudentLoanCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.StudentLoanDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Postgraduate loan</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.PostgraduateLoan | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.PostgraduateLoanCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.PostgraduateLoanDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Net pay</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NetPay | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedSalaryPeriod.NetPayCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedSalaryPeriod.NetPayDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<!-- Error in calculation -->\n\t\t<div ng-if="!$ctrl.backdatedSalary.BackdatedSalary.length">\n\t\t\t<error-block></error-block>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('forms/employment/backdated-salary/backdated-salary-view.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<div class="spacer m"></div>\n\t<p class="s">If you need to edit the salary change that\'s been saved, <a class="underline" href="" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId: userId})">go to {{formOptions.context.Forename}}\'s profile</a> to edit {{formOptions.context.Gender | personalise:\'his\'}} pay information.</p>\n\n\t<form>\n\n\t\t<!-- Starter -->\n\t\t<fieldset ng-if="isNewStarterStartDateInPast">\n\n\t\t\t<div class="form-field-highlight is-primary">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<p class="is-small" ng-switch="backdatedSalary.Salary.StarterCalculationMethod">\n\t\t\t\t\t\t\tThe start date set for {{::formOptions.context.Forename}} is in the past and you have chosen to apply the NI, student loan, and postgraduate loan calculations\n\t\t\t\t\t\t\t<span pc-switch-when="BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod">to your current pay period.</span>\n\t\t\t\t\t\t\t<span ng-switch-default>across all affected pay periods.</span>\n\t\t\t\t\t\t</p>\n\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<h6>Salary</h6>\n\t\t\t\t\t\t<p class="primary"><span class="primary-dark l stronger">{{backdatedSalary.Salary.SalaryYearly | monetise}}</span><span class="strong-light s">&nbsp;(effective {{teamMemberCompany.StartDateISO | dateformat}})</span></p>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="divider primary"></div>\n\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tBased on their start date, and NI, student loan, and postgraduate loan calculation selected, the following backdated salary has been calculated for {{::formOptions.context.Forename}} and will be added to your current period:\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<calculation-card title="Salary - Backdated" amount="backdatedSalary.BackdatedSalaryAmount ? backdatedSalary.BackdatedSalaryAmount : 0"></calculation-card>\n\n\t\t\t\t\t\t<!-- Calculation method description -->\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t{{backdatedSalary.BackdatedSalaryCalculationMethod | backdatedSalaryCalculationDescription : isNewStarterStartDateInPast : formOptions.context.Forename}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset ng-if="!isNewStarterStartDateInPast">\n\t\t\t<div class="form-field">\n\t\t\t\t<note note-theme="primary">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<h6>Current salary</h6>\n\t\t\t\t\t\t<p class="primary"><span class="primary-dark l stronger">{{backdatedSalary.Salary.SalaryYearly | monetise}}</span><span class="strong-light s" ng-if="backdatedSalary.Salary.SalaryEffectiveDateISO">&nbsp;(effective {{backdatedSalary.Salary.SalaryEffectiveDateISO | dateformat}})</span></p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<fieldset ng-if="salaryChange">\n\t\t\t\t<div class="form-field-highlight primary fadeIn">\n\t\t\t\t\t<div class="form-field" ng-switch="salaryChange.CalculationMethod">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<h5>Salary change</h5>\n\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tThe effective date set for {{::formOptions.context.Forename}}\'s new annual salary is in the past and you have chosen to apply the revised tax, NI, student loan, and postgraduate loan calculations\n\t\t\t\t\t\t\t\t<span pc-switch-when="BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod">to your current pay period.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation">across all affected pay periods.</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t\t<h6>New salary:</h6>\n\t\t\t\t\t\t\t<p class="primary"><span class="primary-dark l stronger">{{salaryChange.SalaryYearly | monetise}}</span><span class="strong-light s" ng-if="salaryChange.SalaryEffectiveDateISO">&nbsp;(effective {{backdatedSalary.Salary.SalaryFutureChanges[0].SalaryEffectiveDateISO | dateformat}})</span></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="divider primary"></div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<p class="s">Based on the effective date, and tax, NI, student loan, and postgraduate loan calculation selected, the following backdated salary has been calculated for {{formOptions.context.Forename}} and will be added to your current period:</p>\n\t\t\t\t\t\t\t<calculation-card title="Salary - Backdated" amount="backdatedSalary.BackdatedSalaryAmount ? backdatedSalary.BackdatedSalaryAmount : 0"></calculation-card>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t{{backdatedSalary.BackdatedSalaryCalculationMethod | backdatedSalaryCalculationDescription : isNewStarterStartDateInPast : formOptions.context.Forename}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div pc-switch-when="BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation">\n\t\t\t\t\t\t\t\t<p class="form-message normal primary"><i class="icon-back m is-primary"></i>&nbsp;&nbsp;<a class="underline" data-cy="backdated-salary-show-calculations" ng-click="toggleShowBackdatedSalaryCalculations()" href="">View backdated calculations</a></p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Pension contributions shortfall" ng-if="!teamMemberCompany.IsStarter">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t{{::formOptions.context.Forename}}\'s earlier pension contributions may have been too low. If you chose to backdate tax, NI, student loan, and postgraduate loan calculations, we recommend adding a \'Pension\' deduction for the shortfall.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\n\t\t\t<div class="spacer m" ng-if="!teamMemberCompany.IsStarter"></div>\n\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Rolled Up Holiday Pay">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s" ng-if="!teamMemberCompany.IsStarter">\n\t\t\t\t\t\tRolled Up Holiday Pay will only be calculated on {{::formOptions.context.Forename}}\'s backdated salary if\n\t\t\t\t\t\tyou chose to apply calculations for tax, NI, student loan, and postgraduate\n\t\t\t\t\t\tloan contributions to the current period. If you chose to backdate the\n\t\t\t\t\t\tcalculations, any changes to their Rolled Up Holiday Pay will need to be made\n\t\t\t\t\t\tmanually using the preview pay statement override.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="s" ng-if="teamMemberCompany.IsStarter">\n\t\t\t\t\t\tIf you chose to apply calculations for NI, student loan, and postgraduate loan contributions to\n\t\t\t\t\t\tall affected periods, these will only apply to {{::formOptions.context.Forename}}\'s backdated salary.\n\t\t\t\t\t\tAny Rolled Up Holiday Pay due on their backdated salary for each affected period will be excluded\n\t\t\t\t\t\tfrom the calculations.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t\t</fieldset>\n\t</form>\n\n\t<aside class="slide-in-form-aside slideInRight" ng-if="pageState ===\'ready\' && showBackdatedSalaryCalculations">\n\t\t<header class="slide-in-form-aside-header">\n\t\t\t<h5>Backdated calculations</h5>\n\t\t\t<a aria-label="Toggle backdated calculations" class="slide-in-form-aside-header-action" data-cy="backdated-salary-hide-calculations" href="" ng-click="toggleShowBackdatedSalaryCalculations()"><i class="icon-right l"></i></a>\n\t\t</header>\n\t\t<backdated-salary-calculation-view backdated-salary="backdatedSalary"></backdated-salary-calculation-view>\n\t</aside>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/backdatedNI/backdatedNICalculationView.html','<div>\n\t<div class="slide-in-form-aside-main" ng-if="$ctrl.busy">\n\t\t<loading-block></loading-block>\n\t</div>\n\t<div class="slide-in-form-aside-main" ng-if="!$ctrl.busy">\n\t\t<div ng-repeat="backdatedNIPeriod in $ctrl.backdatedNi">\n\t\t\t<h6 class="payments-summary-table-title"><i class="icon-calendar m primary"></i>&nbsp;&nbsp;{{backdatedNIPeriod.PayPeriodDisplay}}</h6>\n\t\t\t<table class="primary payments-summary-table">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th>NET PAY</th>\n\t\t\t\t\t\t<th>EMPLOYER NI</th>\n\t\t\t\t\t\t<th>EMPLOYEE NI</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Original</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NetPay | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NIER | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NIEE | monetise}}</div></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">New</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NetPayCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NIERCorrected | monetise}}</div></td>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell">{{backdatedNIPeriod.NIEECorrected | monetise}}</div></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading">Difference</div></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedNIPeriod.NetPayDifference"></signed-amount-tag></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedNIPeriod.NIERDifference"></signed-amount-tag></td>\n\t\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="backdatedNIPeriod.NIEEDifference"></signed-amount-tag></td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t\t<table class="primary payments-summary-table-totals">\n\t\t\t<tbody>\n\t\t\t\t<tr>\n\t\t\t\t\t<td><div class="payments-summary-table-cell payments-summary-table-column-heading"><h6>Totals</h6></div></td>\n\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="$ctrl.backdatedNi.TotalNetPay"></signed-amount-tag></td>\n\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="$ctrl.backdatedNi.TotalNIER"></signed-amount-tag></td>\n\t\t\t\t\t<td><signed-amount-tag class="payments-summary-table-cell" amount="$ctrl.backdatedNi.TotalNIEE"></signed-amount-tag></td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>\n');
$templateCache.put('forms/employment/backdatedNI/backdatedNIViewForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<div class="spacer m"></div>\n\t<p class="s">If you need to edit the NI category change that\'s been saved, <a class="underline" href="" ui-sref="team.profile.information({agencyProfileId: agencyProfileId, userId: userId})">go to {{teamMember.Forename}}\'s profile</a> to edit {{formOptions.context.Gender | personalise:\'his\'}} Tax status.</p>\n\n\t<form>\n\t\t<div class="form-field">\n\t\t\t<note note-theme="primary">\n\t\t\t\t<note-content>\n\t\t\t\t\t<h6>Current NI category</h6>\n\t\t\t\t\t<p class="primary"><span class="primary-dark l stronger">{{backdatedNI.Tax.NICode}}</span><span class="strong-light s" ng-if="backdatedNI.Tax.NICodeEffectiveDateISO">&nbsp;(effective {{backdatedNI.Tax.NICodeEffectiveDateISO | dateformat}})</span></p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight primary fadeIn">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<h5>NI category change</h5>\n\t\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t\t<h6>New NI category:</h6>\n\t\t\t\t\t\t<p class="primary"><span class="primary-dark l stronger">{{backdatedNI.Tax.NICodeChange}}</span><span class="strong-light s" ng-if="backdatedNI.Tax.NICodeChangeEffectiveDateISO">&nbsp;(effective {{backdatedNI.Tax.NICodeChangeEffectiveDateISO | dateformat}})</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="divider primary"></div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<p class="s">Based on the effective date, we\'ve calculated the following backdated employee NI change:</p>\n\t\t\t\t\t\t<calculation-card title="Backdated employee National Insurance" amount="backdatedNI.BackdatedNIAmount ? backdatedNI.BackdatedNIAmount : 0"></calculation-card>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message normal primary"><i class="icon-back m"></i>&nbsp;&nbsp;<a class="underline" ng-click="toggleShowBackdatedNICalculations()" href="">Preview backdated NI calculations</a></p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-section">\n\t\t\t\t<note note-title="Has {{teamMember.Forename}}\'s date of birth changed?" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s date of birth can affect their NI calculations. You may wish to double check that {{formOptions.context.Forename}}\'s date of birth is correct.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\t</form>\n\n\t<aside class="slide-in-form-aside slideInRight" ng-if="pageState ===\'ready\' && showBackdatedNICalculations">\n\t\t<header class="slide-in-form-aside-header">\n\t\t\t<h5>Backdated NI calculations</h5>\n\t\t\t<a href="" class="slide-in-form-aside-header-action" ng-click="toggleShowBackdatedNICalculations()" aria-label="Hide backdated NI calculations"><i class="icon-right l"></i></a>\n\t\t</header>\n\t\t<backdated-ni-calculation-view backdated-ni="backdatedNI.BackdatedNI"></backdated-ni-calculation-view>\n\t</aside>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/company-vehicle/company-vehicle.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<div ng-if="$ctrl.componentState === \'ready\'" ng-switch="$ctrl.formOptions.activeStep">\n\n\t<!-- Step 1 -->\n\t<form name="companyVehicleStep1Form" ng-submit="$ctrl.goToNextStep($ctrl, companyVehicleStep1Form)" class="fadeIn" ng-switch-when="1" novalidate>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Vehicle type -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitVan" ng-model="$ctrl.carBenefit.CarBenefitVan"></form-field>\n\t\t</fieldset>\n\n\t\t<!-- Car details -->\n\t\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="!$ctrl.carBenefit.CarBenefitVan">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Car details</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Make of car -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitMake" ng-model="$ctrl.carBenefit.CarBenefitMake"></form-field>\n\n\t\t\t<!-- Registration -->\n\t\t\t<div class="form-field-group slide-in-form_item">\n\n\t\t\t\t<!-- Date first registered -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitRegisteredDateISO" ng-model="$ctrl.carBenefit.CarBenefitRegisteredDateISO"></form-field>\n\t\t\t\t\n\t\t\t\t<!-- Registration number -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitRegNo" ng-model="$ctrl.carBenefit.CarBenefitRegNo"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Car specs -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\n\t\t\t\t<!-- Fuel type -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitFuelType" ng-model="$ctrl.carBenefit.CarBenefitFuelType"></form-field>\n\n\t\t\t\t<!-- Engine capacity -->\n\t\t\t\t<form-field class="form-field-group_item fadeIn" form-field-options="$ctrl.formFields.carBenefitEngineSize" ng-if="$ctrl.carBenefit.CarBenefitFuelType !== $ctrl.FUEL_TYPES.electric" ng-model="$ctrl.carBenefit.CarBenefitEngineSize"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Emissions -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item fadeIn" ng-if="$ctrl.carBenefit.isRegistrationDateAfterThreshold">\n\n\t\t\t\t<!-- CO2 emissions -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitCO2" ng-model="$ctrl.carBenefit.CarBenefitCO2"></form-field>\n\t\t\t\t\n\t\t\t\t<!-- Zero emissions mileage -->\n\t\t\t\t<form-field class="form-field-group_item fadeIn" form-field-options="$ctrl.formFields.carBenefitZeroEmissionsMileage" ng-if="$ctrl.carBenefit.CarBenefitFuelType !== $ctrl.FUEL_TYPES.electric" ng-model="$ctrl.carBenefit.CarBenefitZeroEmissionsMileage"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Don\'t know emissions -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitCO2Unknown" ng-if="$ctrl.carBenefit.isRegistrationDateAfterThreshold" ng-model="$ctrl.carBenefit.carBenefitCO2Unknown"></form-field>\n\n\t\t\t<!-- List price -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitPrice" ng-model="$ctrl.carBenefit.CarBenefitPrice"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Availability -->\n\t\t\t<div class="form-fields-from-to slide-in-form_item">\n\n\t\t\t\t<!-- Car available from -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitAvailableFromISO" ng-model="$ctrl.carBenefit.CarBenefitAvailableFromISO"></form-field>\n\n\t\t\t\t<!-- Car available to -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitAvailableToISO" ng-model="$ctrl.carBenefit.CarBenefitAvailableToISO"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Days unavailable -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitDaysUnavailable" ng-model="$ctrl.carBenefit.CarBenefitDaysUnavailable"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Free fuel -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitFuelProvided" ng-model="$ctrl.carBenefit.CarBenefitFuelProvided"></form-field>\n\n\t\t\t<!-- Free fuel provided... -->\n\t\t\t<div class="form-fields-from-to slide-in-form_item fadeIn" ng-if="$ctrl.carBenefit.CarBenefitFuelProvided">\n\n\t\t\t\t<!-- Car available from -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitFuelDateProvidedISO" ng-model="$ctrl.carBenefit.CarBenefitFuelDateProvidedISO"></form-field>\n\n\t\t\t\t<!-- Car available to -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitFuelDateWithdrawnISO" ng-model="$ctrl.carBenefit.CarBenefitFuelDateWithdrawnISO"></form-field>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Van details -->\n\t\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="$ctrl.carBenefit.CarBenefitVan">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Van details</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Zero Co2? -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitVanZeroCO2" ng-model="$ctrl.carBenefit.carBenefitHasZeroCO2"></form-field>\n\n\t\t\t<!-- Availability -->\n\t\t\t<div class="form-fields-from-to slide-in-form_item">\n\n\t\t\t\t<!-- Car available from -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitVanAvailableFromISO" ng-model="$ctrl.carBenefit.CarBenefitAvailableFromISO"></form-field>\n\n\t\t\t\t<!-- Car available to -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitVanAvailableToISO" ng-model="$ctrl.carBenefit.CarBenefitAvailableToISO"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Availability -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\n\t\t\t\t<!-- Days unavailable -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitDaysUnavailable" ng-model="$ctrl.carBenefit.CarBenefitDaysUnavailable"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Free fuel -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitFuelProvided" ng-model="$ctrl.carBenefit.CarBenefitFuelProvided"></form-field>\n\n\t\t\t<!-- Free fuel provided... -->\n\t\t\t<div class="form-fields-from-to slide-in-form_item fadeIn" ng-if="$ctrl.carBenefit.CarBenefitFuelProvided">\n\n\t\t\t\t<!-- Car available from -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitFuelDateProvidedISO" ng-model="$ctrl.carBenefit.CarBenefitFuelDateProvidedISO"></form-field>\n\n\t\t\t\t<!-- Car available to -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.carBenefitFuelDateWithdrawnISO" ng-model="$ctrl.carBenefit.CarBenefitFuelDateWithdrawnISO"></form-field>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Next\'" state="companyVehicleStep1Form.state" disable-button="!companyVehicleStep1Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 2 -->\n\t<form name="companyVehicleStep2Form" ng-submit="$ctrl.updateCarBenefit($ctrl, companyVehicleStep2Form)" class="fadeIn" ng-switch-when="2" novalidate>\n\t\t\n\t\t<div class="form-intro">\n\t\t\t<h4>Payments and costs</h4>\n\t\t</div>\n\n\t\t<!-- Car -->\n\t\t<div ng-if="!$ctrl.carBenefit.CarBenefitVan">\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- OpRA -->\n\t\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitOpRA" ng-model="$ctrl.carBenefit.CarBenefitOpRA"></form-field>\n\t\t\t\n\t\t\t</fieldset>\n\n\t\t\t<fieldset class="fadeIn" ng-if="$ctrl.carBenefit.CarBenefitOpRA">\n\n\t\t\t\t<!-- Amount foregone -->\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitAmountForegone" ng-model="$ctrl.carBenefit.CarBenefitAmountForegone"></form-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Payment towards private use (pa) -->\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item" ng-if="$ctrl.carBenefit.CarBenefitFuelProvided">\n\t\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitFuelAmountForegone" ng-model="$ctrl.carBenefit.CarBenefitFuelAmountForegone"></form-field>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- Capital contribution -->\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitCapitalContribution" ng-model="$ctrl.carBenefit.CarBenefitCapitalContribution"></form-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Payment towards private use (pa) -->\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitPrivateUse" ng-model="$ctrl.carBenefit.CarBenefitPrivateUse"></form-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Taxable accessories -->\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitAccessories" ng-model="$ctrl.carBenefit.CarBenefitAccessories"></form-field>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\t\t</div>\n\n\t\t<!-- Van -->\n\t\t<div ng-if="$ctrl.carBenefit.CarBenefitVan">\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- Private use contribution? -->\n\t\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitVanContributionPrivateUse" ng-model="$ctrl.carBenefit.carBenefitHasContributionPrivateUse"></form-field>\n\n\t\t\t\t<div class="form-field-group is-two-column slide-in-form_item" ng-if="$ctrl.carBenefit.carBenefitHasContributionPrivateUse">\n\n\t\t\t\t\t<!-- Contribution Amount -->\n\t\t\t\t\t<div class="form-field-group_item">\n\t\t\t\t\t\t<form-field class="slide-in-form_item fadeIn" form-field-options="$ctrl.formFields.carBenefitVanCapitalContribution" ng-model="$ctrl.carBenefit.CarBenefitPrivateUse"></form-field>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Share -->\n\t\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitVanShare" ng-model="$ctrl.carBenefit.CarBenefitVanShare"></form-field>\n\n\t\t\t\t<!-- Usage -->\n\t\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.carBenefitVanShareAvailablePercent" ng-if="$ctrl.carBenefit.CarBenefitVanShare" ng-model="$ctrl.carBenefit.CarBenefitVanShareAvailablePercent"></form-field>\n\n\t\t\t</fieldset>\t\t\t\n\t\t</div>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.goToPreviousStep($ctrl)">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Next\'" state="companyVehicleStep2Form.state" disable-button="!companyVehicleStep2Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 3 -->\n\t<form name="companyVehicleStep3Form" ng-submit="$ctrl.reviewCalculatePaymentScheduleGroup($ctrl, companyVehicleStep3Form)" class="fadeIn" ng-switch-when="3" novalidate>\n\n\t\t<fieldset>\n\n\t\t\t<div class="form-field-group slide-in-form_item">\n\n\t\t\t\t<!-- Taxable car benefit -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitCashEquivalent" ng-model="$ctrl.carBenefit.CarBenefitCashEquivalent"></form-field>\n\n\t\t\t\t<!-- Car benefit paid YTD -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitPaidYTD" ng-model="$ctrl.carBenefit.CarBenefitPaidYTD"></form-field>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group slide-in-form_item" ng-if="$ctrl.carBenefit.CarBenefitFuelProvided">\n\n\t\t\t\t<!-- Taxable fuel benefit -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitFuelCashEquivalent" ng-model="$ctrl.carBenefit.CarBenefitFuelCashEquivalent"></form-field>\n\n\t\t\t\t<!-- Fuel benefit paid YTD -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.carBenefitFuelPaidYTD" ng-model="$ctrl.carBenefit.CarBenefitFuelPaidYTD"></form-field>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Payslip Label -->\n\t\t\t<pill-input-field class="slide-in-form_item" field-options="$ctrl.labelOptions" ng-model="$ctrl.paymentScheduleGroup.PayslipLabel" ng-model-save="$ctrl.paymentScheduleGroup.payslipLabelSave"></pill-input-field>\n\n\t\t\t<!-- Payroll Benefit -->\n\t\t\t<settings-row class="slide-in-form_item" sr-field-name="bikBehaviour" sr-icon="clock" sr-theme="quarternary" ng-model="$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">\n\t\t\t\t<sr-label>Payroll benefit</sr-label>\n\t\t\t\t<sr-description ng-if="$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">Switch to \'OFF\' if you don\'t want to payroll this benefit each time you run payroll for {{::$ctrl.formOptions.company.Name}}</sr-description>\n\t\t\t\t<sr-description ng-if="!$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">Switch to \'ON\' if you want to payroll this benefit each time you run payroll for {{::$ctrl.formOptions.company.Name}}</sr-description>\n\t\t\t</settings-row>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.goToPreviousStep($ctrl)">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Next\'" state="companyVehicleStep3Form.state" disable-button="!companyVehicleStep3Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 4 > Benefit Summary -->\n\t<form name="companyVehicleStep4Form" ng-submit="$ctrl.updatePaymentScheduleGroup($ctrl, companyVehicleStep4Form)" class="fadeIn" ng-switch-when="4" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Benefit summary</h4>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Car benefit" rc-view-type="benefit" can-edit="true" on-edit="$ctrl.goToStep($ctrl, 1)"></repayment-card>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<table class="primary payments-table">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t\t<th>Amount</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat="payment in $ctrl.paymentScheduleGroup.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag positive" data-cy="isPaid" ng-if="payment.IsPaid && !payment.IsPaused">Paid</span>\n\t\t\t\t\t\t\t<span class="tag tertiary" data-cy="isPaused" ng-if="payment.IsPaused">Paused</span>\n\t\t\t\t\t\t\t<span class="tag assertive" ng-if="payment.IsCancelled">Stopped</span>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<strong class="payments-table-amount">{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.goToPreviousStep($ctrl)">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="companyVehicleStep4Form.state" disable-button="!companyVehicleStep4Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-title="Invalid schedule settings" ng-if="$ctrl.componentState === \'company-vehicle-invalid\'">\n\t<fs-main>\n\t\t<p>You have entered an invalid combination of settings for this company vehicle. Please double check the vehicle settings, including fuel type, engine capacity, and CO2 emissions, before trying to add the schedule again.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/company-vehicle-view/company-vehicle-view.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<!-- Benefit Summary -->\n<form name="benefitSummaryForm" ng-submit="$ctrl.deletePaymentScheduleGroup($ctrl, benefitSummaryForm)" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Car benefit" rc-view-type="benefit" can-edit="$root.currentUser.Permissions.Payroll.canUpdateRepaymentSchedules" on-edit="$ctrl.openCompanyVehicleForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<!-- Schedule -->\n\t<div class="form-section" ng-if="!$ctrl.isDeleteConfirmed">\n\t\t<table class="primary payments-table">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t<th>Amount</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat="payment in $ctrl.paymentScheduleGroup.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span class="tag positive" data-cy="isPaid" ng-if="payment.IsPaid && !payment.IsPaused">Paid</span>\n\t\t\t\t\t\t<span class="tag tertiary" data-cy="isPaused" ng-if="payment.IsPaused">Paused</span>\n\t\t\t\t\t\t<span class="tag assertive" data-cy="isCancelled" ng-if="payment.IsCancelled">Stopped</span>\n\t\t\t\t\t\t<strong class="payments-table-amount">{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n\t<div class="form-section fadeIn" ng-if="$ctrl.isDeleteConfirmed">\n\t\t\n\t\t<!-- Confirm deletion -->\n\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to {{$ctrl.paymentScheduleGroup.canDelete ? \'delete\' : \'stop\'}} this benefit?">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">Once you click \'Confirm\' this cannot be undone.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="$ctrl.paymentScheduleGroup.CanCancel && $root.currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">\n\n\t\t<!-- No payment made -->\n\t\t<div ng-if="$ctrl.paymentScheduleGroup.canDelete">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.cancelDelete($ctrl)" ng-if="$ctrl.isDeleteConfirmed">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.isDeleteConfirmed ? \'Confirm\' : \'Delete\'" state="benefitSummaryForm.state" disable-button="!benefitSummaryForm.$valid"></submit-button>\n\t\t</div>\n\t\t\n\t\t<!-- Payment made -->\n\t\t<div ng-if="!$ctrl.paymentScheduleGroup.canDelete">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.cancelDelete($ctrl)" ng-if="$ctrl.isDeleteConfirmed">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.isDeleteConfirmed ? \'Confirm\' : \'Stop benefit\'" state="benefitSummaryForm.state" disable-button="!benefitSummaryForm.$valid"></submit-button>\n\t\t\t<a href="" class="button tertiary tertiary-action" ng-click="$ctrl.setComponentState(\'pause\')" ng-if="!$ctrl.paymentScheduleGroup.IsPaused && !$ctrl.isDeleteConfirmed" data-cy="pauseBenefit">Pause benefit</a>\n\t\t\t<a href="" class="button tertiary tertiary-action" ng-click="$ctrl.setComponentState(\'resume\')" ng-if="$ctrl.paymentScheduleGroup.IsPaused" data-cy="resumeBenefit">Resume benefit</a>\n\t\t</div>\n\t</fieldset>\n</form>\n\n<!-- Pause -->\n<form name="pauseBenefitForm" ng-submit="$ctrl.pausePaymentScheduleGroup($ctrl, pauseBenefitForm)" ng-if="$ctrl.componentState === \'pause\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Car benefit" rc-view-type="benefit" can-edit="true" on-edit="$ctrl.openCompanyVehicleForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Confirm pause -->\n\t\t<div class="form-section fadeIn">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="How long do you wish to pause this benefit for?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Select the number of pay periods to pause this benefit for and deductions won\u2019t be taken from Bruce\u2019s pay.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\t\t\t\n\t\t</div>\n\n\t\t<!-- Pause length -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pauseCount" class="required">Select the number of pay periods to pause:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="pauseCount" id="pauseCount" ng-model="$ctrl.pauseCount" ng-options="option.value as option.description for option in $ctrl.PAUSE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pauseBenefitForm.pauseCount.$error" ng-if="pauseBenefitForm.pauseCount.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="pauseBenefitForm.state" disable-button="!pauseBenefitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Resume -->\n<form name="resumeBenefitForm" ng-submit="$ctrl.resumePaymentScheduleGroup($ctrl, resumeBenefitForm)" ng-if="$ctrl.componentState === \'resume\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Car benefit" rc-view-type="benefit" can-edit="$ctrl.paymentScheduleGroup.CanCancel" on-edit="$ctrl.openCompanyVehicleForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Confirm pause -->\n\t\t<div class="form-section fadeIn">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to resume this benefit?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Deductions will continue be taken from {{$ctrl.formOptions.context.Forename}}\'s pay the next time you run payroll. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="resumeBenefitForm.state" disable-button="!resumeBenefitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/companyDetails/companyDetailsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companyDetailsForm" class="fadeIn" ng-submit="updateTeamMemberCompany(teamMember, businessCategories, companyDetailsForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Moved payrolls warning -->\n\t\t<div class="form-section" ng-if="teamMember.Company.isMovingPayrollsInwardPending">\n\t\t\t<note note-theme="tertiary" note-icon="icon-warning" note-title="{{formOptions.context.Forename}}\'s company details" note-dismiss="false">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">{{formOptions.context.Forename}} has recently moved payrolls and their company details information represents that held with HMRC.\n\t\t\t\t\t\tEditing this information means it will be updated with HMRC when you next run payroll.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- New Starter -->\n \t\t<div class="form-field" ng-if="::teamMember.Company.isNewStarterQuestionVisible">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="isStarterTrue" ng-class="{ \'disabled\': teamMember.Company.isMovingPayrollsInwardPending, \'required\': teamMember.isTeamMemberSetupFieldsRequired }">Is {{::formOptions.context.Forename}} a new starter?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isStarterTrue" name="isStarter" ng-change="reviewHasExistingSubmissionId(teamMember, currentPayPeriod)" ng-disabled="::(!teamMember.Company.CanUpdateStarterStatus && teamMember.Company.IsStarter) || teamMember.Company.isMovingPayrollsInwardPending" ng-model="teamMember.Company.IsStarter" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="isStarterTrue" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isStarterFalse" name="isStarter" ng-change="reviewHasExistingSubmissionId(teamMember, currentPayPeriod)" ng-disabled="::(!teamMember.Company.CanUpdateStarterStatus && teamMember.Company.IsStarter) || teamMember.Company.isMovingPayrollsInwardPending" ng-model="teamMember.Company.IsStarter" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="isStarterFalse" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t\t<!-- Start date (required if new starter) -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="startDate" ng-class="{\'required\': teamMember.Company.IsStarter && teamMember.isTeamMemberSetupFieldsRequired, \'disabled\': teamMember.Company.isMovingPayrollsInwardPending}">Start date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="startDate" field-style="l-alt" field-on-change-fn="onStartDateChange(teamMember, currentPayPeriod)" field-disabled="teamMember.Company.isMovingPayrollsInwardPending" field-required="teamMember.Company.IsStarter && teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="teamMember.Company.StartDateISO" field-min-date-iso="teamMember.Company.startDateMinISO" field-max-date-iso="teamMember.Company.startDateMaxISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.startDate.$error" ng-show="companyDetailsForm.startDate.$touched" role="alert">\n\t\t\t\t<p data-cy="company-details-start-date-validation-max-min-message" ng-message="max || min">\n\t\t\t\t\tPlease enter a start date between {{teamMember.Company.startDateMinISO | dateformat}} and {{teamMember.Company.startDateMaxISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t\t<p data-cy="company-details-start-date-validation-required-message" ng-message="required">\n\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s start date\n\t\t\t\t</p>\n\t\t\t\t<p data-cy="company-details-start-date-validation-date-message" ng-message="date">\n\t\t\t\t\tPlease enter a valid start date\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Changing start date info block -->\n\t\t<div class="form-content-block" ng-if="!teamMember.IsInSetupMode">\n\t\t\t<note note-title="Changing start dates" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t{{formOptions.context.Forename}}\'s start date was previously submitted to HMRC when they were first included in the payroll. Changing\n\t\t\t\t\t\ttheir start date now won\'t affect any future submissions but means your records will be up to date.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Backdated salary for new starters -->\n\t\t<div class="form-field fadeIn" ng-if="teamMember.Company.isNewStarterStartDateInPast">\n\t\t\t<note note-theme="indifferent is-form-field" note-title="Backdated salary for new starters" note-icon="icon-support" note-dismiss="true" note-dismiss-key="company-details-backdated-salary">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tBackdated salary for new starters with a start date in the past will be automatically calculated if they have an annual salary in their pay information. You can then decide if you wish to include the backdated salary in your main pay run or supplementary pay run, if you wish to submit them sooner.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Previously submitted new starters -->\n\t\t<div class="form-field" ng-if="::!teamMember.Company.CanUpdateStarterStatus && teamMember.Company.IsStarter && currentPayPeriod.IsRollback">\n\t\t\t<note note-theme="indifferent is-form-field" note-title="Previously submitted new starters" note-icon="icon-support">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">As {{::formOptions.context.Forename}} has previously been submitted as a new starter they can\'t be changed to a non-new starter for a rolled back pay period.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Job Title -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="jobTitle">Job title:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="text" id="jobTitle" name="jobTitle" ng-pattern="$root.REGEX.genericCharacter" ng-model="teamMember.Company.JobTitle">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.jobTitle.$error" ng-show="companyDetailsForm.jobTitle.$touched" role="alert">\n\t\t\t\t<p data-cy="company-details-job-title-validation-pattern-message" ng-message="pattern">\n\t\t\t\t\tJob titles can only contain letters, numbers and basic symbols\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Job grade -->\n\t\t<div class="form-field" ng-if="company.IsHRActive && policyGrades.length !== 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="jobGrade">Job grade:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="jobGrade" name="jobGrade" ng-model="teamMember.Company.PolicyGradeID" ng-options="policyGrade.PolicyGradeID as policyGrade.PolicyGradeName for policyGrade in policyGrades | orderBy: \'PolicyGradeName\'">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Occupational sick policy code -->\n\t\t<div class="form-field" ng-if="company.IsHRActive && !teamMember.Company.IsOffPayrollWorker && sicknessPolicies.length !== 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="occupationalSicknessPolicyCode">Occupational sick policy code:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="occupationalSicknessPolicyCode" name="occupationalSicknessPolicyCode" ng-model="teamMember.Company.OccupationalSicknessPolicyCode" ng-options="policy.PolicyCode as policy.name for policy in sicknessPolicies | orderBy: \'name\'">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Journals -->\n\t\t<fieldset ng-if="businessCategories.length">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Business categories</h5>\n\t\t\t\t<p class="form-field-sub is-small">Select home categories for {{::formOptions.context.Forename}} to allocate their gross costs for journals. Click \u2018Add cost split\u2019 to split them across other categories.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field" ng-repeat="businessCategory in businessCategories" ng-if="businessCategory.BusinessCodes.length > 0">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="businessCategory_{{$index}}">\n\t\t\t\t\t\t{{businessCategory.BusinessCategoryName}}\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select data-cy="company-details-form-select-business-category_{{$index}}" id="businessCategory_{{$index}}" name="businessCategory_{{$index}}" ng-change="onBusinessCategoryChange()" ng-disabled="businessCategory.BusinessCategoryID === teamMember.Company.BusinessCodes.BusinessCodeCostSplit.BusinessCategoryID" ng-model="businessCategory.selectedBusinessCode" ng-options="businessCode as businessCode.BusinessCodeNarrative for businessCode in businessCategory.BusinessCodes | orderBy: \'BusinessCodeNarrative\'">\n\t\t\t\t\t\t<option value="">-- None --</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Company.BusinessCodes.BusinessCodeCostSplit !== null && teamMember.Company.BusinessCodes.BusinessCodeCostSplit.BusinessCategoryID !== $root.CONFIG.guidEmpty">\n\t\t\t\t<cost-split-form-field business-categories="businessCategories" empty-user-agency-profile-business-code="emptyUserAgencyProfileBusinessCode" user="{ userId: formOptions.userId, forename: formOptions.context.Forename }" user-business-codes="teamMember.Company.BusinessCodes">\n\t\t\t\t</cost-split-form-field>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Company.BusinessCodes.BusinessCodeCostSplit.BusinessCategoryID === $root.CONFIG.guidEmpty && showCostSplitButton()">\n\t\t\t\t<button class="is-medium-large is-white is-block" data-cy="company-details-form-button-add-cost-split" ng-click="onAddCostSplitClick(teamMember.Company.BusinessCodes)" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add cost split\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Pay Policy -->\n\t\t<fieldset ng-if="teamMember.Salary.SalaryType === SALARY_TYPES.payPolicy">\n\n\t\t\t<!-- Post Identifier -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="primarySalaryPolicyPostReference">\n\t\t\t\t\t\tPost Identifier:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="primarySalaryPolicyPostReference" name="primarySalaryPolicyPostReference" ng-model-options="{ debounce: 250 }" ng-model="teamMember.Company.PrimarySalaryPolicyPostReference" post-identifier-unique post-identifier-unique-agency-profile-id="formOptions.agencyProfileId" post-identifier-unique-original="teamMember.Company.PrimarySalaryPolicyPostReference" post-identifier-unique-user-id="formOptions.userId" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="companyDetailsForm.primarySalaryPolicyPostReference.$touched" ng-messages="companyDetailsForm.primarySalaryPolicyPostReference.$error" role="alert">\n\t\t\t\t\t<p data-cy="company-details-primary-policy-post-reference-validation-message" ng-message="{{POST_IDENTIFIER_UNIQUE}}">\n\t\t\t\t\t\tThis identifier is being used by another post\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">\n\t\t\t\t\tUse this identifier to import payroll changes for team members with multiple posts. It can also be used as a post identifier to submit information to your pension provider.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Payroll ID / Short ID in the platform -->\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="staffNumber" ng-class="{ \'disabled\': teamMember.Company.isMovingPayrollsInwardPending, \'required\': teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\tPayroll ID:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="staffNumber" name="staffNumber" ng-change="reviewHasExistingSubmissionId(teamMember, currentPayPeriod)" ng-disabled="teamMember.Company.isMovingPayrollsInwardPending || teamMember.Company.IsShortIDLockedByIntegration" ng-model="teamMember.Company.StaffNumber" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-field less-margin" ng-if="teamMember.Company.IsShortIDLockedByIntegration">\n\t\t\t\t<message-block data-cy="payroll-id-locked-message" has-drop-in="false" theme="tertiary is-inline">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<i class="icon-padlock is-medium is-tertiary has-margin-right"></i>\n\t\t\t\t\t\t<span>This field is managed by your integration. To make changes, update the Payroll ID in your connected system.</span>\n\t\t\t\t\t</p>\n\t\t\t\t</message-block>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.staffNumber.$error" ng-show="companyDetailsForm.staffNumber.$touched" role="alert">\n\t\t\t\t<p data-cy="company-details-staff-number-validation-required-message" ng-message="required">\n\t\t\t\t\tPlease enter a Payroll ID\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<p class="form-message" ng-if="!teamMember.Company.IsShortIDLockedByIntegration">\n\t\t\t\tA unique payroll ID has been automatically generated for {{teamMember.Personal.Forename}} to identify {{teamMember.Personal.Gender | personalise:\'him\'}} within {{formOptions.company.Name}} in Paycircle. This can be edited but should be unique to {{teamMember.Personal.Forename}}.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- HMRC Submissions / Payroll ID in the platform -->\n\t\t<fieldset class="fadeIn" ng-if="teamMember.IsInSetupMode && !teamMember.Company.IsStarter && !formOptions.company.PensionOnly">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>HMRC submissions</h5>\n\t\t\t\t<p class="s form-field-sub">\n\t\t\t\t\tIf you want to use an existing HMRC Submission ID to continue making submissions to HMRC, please enter it in the box below. You may be able to find it in your previous payroll software or in your latest FPS file if it\u2019s available.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payroll Number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label ng-class="{\'required\' : !teamMember.Company.HasNoExistingSubmissionID && teamMember.isTeamMemberSetupFieldsRequired, \'disabled\': !teamMember.IsInSetupMode || teamMember.Company.HasNoExistingSubmissionID || teamMember.Company.isMovingPayrollsInwardPending }" for="payrollNumber">Existing HMRC Submission ID:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="m" id="payrollNumber" name="payrollNumber" ng-disabled="!teamMember.IsInSetupMode || teamMember.Company.HasNoExistingSubmissionID || teamMember.Company.isMovingPayrollsInwardPending" ng-model="teamMember.Company.PayrollNumber" ng-required="!teamMember.Company.HasNoExistingSubmissionID && teamMember.isTeamMemberSetupFieldsRequired" placeholder="Enter ID" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.payrollNumber.$error" ng-show="companyDetailsForm.payrollNumber.$touched" role="alert">\n\t\t\t\t\t<p data-cy="company-details-payroll-number-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter an HMRC Submission ID\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Has an additional HMRC Submission ID -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input type="checkbox" id="hasNoExistingSubmissionID" name="hasNoExistingSubmissionID" ng-change="reviewHasExistingSubmissionId(teamMember, currentPayPeriod)" ng-model="teamMember.Company.HasNoExistingSubmissionID" ng-disabled="teamMember.Company.isMovingPayrollsInwardPending" label-text="\'I don\u2019t have an existing HMRC Submission ID\'" checkbox>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-class="{ \'disabled\': teamMember.Company.isMovingPayrollsInwardPending }">Check this box if you don\u2019t have an existing HMRC Submission ID and one will be automatically generated.</p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Omit from RTI -->\n\t\t<div class="form-field" ng-if="teamMember.IsInSetupMode && !teamMember.Company.IsOffPayrollWorker && !teamMember.IsInRetrospectivePayrollSetupMode">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="isExcludedFromRTI" label-text="\'Omit from RTI submissions\'" name="isExcludedFromRTI" ng-model="teamMember.Company.IsExcludedFromRTI" type="checkbox">\n\t\t\t</div>\n\t\t\t<p class="form-message">This will omit {{::formOptions.context.Forename}} from RTI submissions but still generate payslips when you run payroll. Once your first live period has been run, you can use the \u2018Include in RTI submissions\u2019 action that will appear in {{::formOptions.context.Forename}}\u2019s profile to add them as a new starter.</p>\n\t\t</div>\n\n\t\t<!-- Directors -->\n\t\t<fieldset>\n\n\t\t\t<!-- Is Director? -->\n\t \t\t<div class="form-field" ng-if="!teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="isDirectorInTaxYearTrue">\n\t\t\t\t\t\tHas {{::formOptions.context.Forename}} been a director this tax year?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isDirectorInTaxYearTrue" name="isDirectorInTaxYear" ng-model="teamMember.Company.IsDirectorInTaxYear" ng-value="true" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t<label for="isDirectorInTaxYearTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isDirectorInTaxYearFalse" name="isDirectorInTaxYear" ng-model="teamMember.Company.IsDirectorInTaxYear" ng-value="false" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t<label for="isDirectorInTaxYearFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\n\t\t\t<!-- Note: Correcting NI contributions -->\n\t\t\t<div class="form-field fadeIn" ng-if="!teamMember.IsInSetupMode && teamMember.Company.IsDirectorInTaxYear !== teamMember.Company.isDirectorInTaxYearOriginal">\n\t\t\t\t<note note-title="Correcting NI contributions" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tIf {{::formOptions.context.Forename}} was added as a director by mistake and run through payroll, you may need to correct any NI contributions manually for the affected periods.\n\t\t\t\t\t\t\tOnce you click \u2018Save\u2019, {{::formOptions.context.Forename}} will be unmarked as a director and their director Year to Dates will be removed.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Company director -->\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.Company.IsDirectorInTaxYear">\n\n\t\t\t\t<!-- Appointment start date -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="directorStartDateISO">Date appointed:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="directorStartDateISO" field-required="false" field-value-iso="teamMember.Company.DirectorStartDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.directorStartDateISO.$error" ng-if="companyDetailsForm.directorStartDateISO.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="company-details-director-start-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message" data-cy="company-details-director-start-date-message" ng-if="teamMember.IsInSetupMode">\n\t\t\t\t\t\tPlease note that if no appointment date is added, {{formOptions.context.Forename}}\u2019s start date will be used as a basis for annual earnings calculations\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Note: Annual earnings calculations -->\n\t\t\t\t<div class="form-field" ng-if="!teamMember.IsInSetupMode">\n\t\t\t\t\t<note note-title="Annual earnings calculations" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="s">Please note that by changing the appointment date, {{formOptions.context.Forename}}\u2019s annual earnings will be calculated using the new date. </p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- National Insurance Payment Method -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="directorsNiMethodStandard">Which method is used to pay their National Insurance?</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="directorsNiMethodStandard" name="directorsNiMethod" ng-model="teamMember.Company.DirectorNIStandard" ng-value="true" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="directorsNiMethodStandard">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Standard (cumulative)</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="directorsNiMethodAlternative" name="directorsNiMethod" ng-model="teamMember.Company.DirectorNIStandard" ng-value="false" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="directorsNiMethodAlternative">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Alternative (non-cumulative)</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message" data-cy="company-details-director-ni-standard-message" ng-if="teamMember.Company.DirectorNIStandard">\n\t\t\t\t\t\tThis \'Standard (cumulative)\' method is common for directors who are paid irregularly.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="form-message" data-cy="company-details-director-ni-standard-message" ng-if="!teamMember.Company.DirectorNIStandard">\n\t\t\t\t\t\tThis \'Alternative (non-cumulative)\' method is common for directors who are paid regularly.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Directorship ending this year? -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="hasDirectorEndDateInTaxYearTrue">\n\t\t\t\t\t\t\tIs the directorship ending this tax year?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasDirectorEndDateInTaxYearTrue" name="hasDirectorEndDateInTaxYear" ng-model="teamMember.Company.HasDirectorEndDateInTaxYear" ng-value="true" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t\t<label for="hasDirectorEndDateInTaxYearTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasDirectorEndDateInTaxYearFalse" name="hasDirectorEndDateInTaxYear" ng-model="teamMember.Company.HasDirectorEndDateInTaxYear" ng-value="false" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t\t\t<label for="hasDirectorEndDateInTaxYearFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\n\t\t\t\t<fieldset class="fadeIn" ng-if="teamMember.Company.HasDirectorEndDateInTaxYear">\n\n\t\t\t\t\t<!-- Appointment end date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="directorEndDateISO">\n\t\t\t\t\t\t\t\tAppointment end date:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="directorEndDateISO" field-max-date-iso="teamMember.Company.DirectorEndDateMaxISO" field-min-date-iso="teamMember.Company.DirectorEndDateMinISO" field-required="true" field-value-iso="teamMember.Company.DirectorEndDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.directorEndDateISO.$error" ng-if="companyDetailsForm.directorEndDateISO.$touched" role="alert">\n\t\t\t\t\t\t\t<p data-cy="company-details-director-end-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="company-details-director-end-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\t\tPlease enter an end date on or before {{teamMember.Company.DirectorEndDateMaxISO | dateformat}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="company-details-director-end-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\tPlease enter an end date on or after {{teamMember.Company.DirectorEndDateMinISO | dateformat}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="company-details-director-end-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter the appointment end date\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p data-cy="company-details-director-end-date-message" class="form-message">\n\t\t\t\t\t\t\tMust be on or after {{teamMember.Company.DirectorEndDateMinISO | dateformat}}, and on or before {{teamMember.Company.DirectorEndDateMaxISO | dateformat}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Previously submitted new starters -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<note note-theme="indifferent is-form-field" note-title="Adding a directorship cease date" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">If {{::formOptions.context.Forename}} stops being a director, their National Insurance contributions will continue to be calculated as a director for the remainder of the tax year. From the start of a new tax year, their National Insurance contributions will be calculated as a normal employee again.</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Note: NI refunds -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="!teamMember.IsInSetupMode && teamMember.Company.directorNIStandardOriginal !== teamMember.Company.DirectorNIStandard">\n\t\t\t\t\t<note note-title="National Insurance refunds for directors" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">If you switch the method used for calculating National Insurance, and a refund is due, it will be added to your current period.</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<!-- Is Apprentice? -->\n\t\t<div class="form-field" ng-if="!teamMember.Company.IsDirectorInTaxYear && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="isApprenticeTrue">Is {{::formOptions.context.Forename}} an apprentice?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isApprenticeTrue" name="isApprentice" ng-model="teamMember.Company.IsApprentice" ng-value="true" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="isApprenticeTrue" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isApprenticeFalse" name="isApprentice" ng-model="teamMember.Company.IsApprentice" ng-value="false" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="isApprenticeFalse" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t\t<!-- Is irregular worker? -->\n\t\t<div class="form-field" ng-if="!teamMember.Company.IsOffPayrollWorker">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="isIrregularWorkerTrue">Is {{::formOptions.context.Forename}} an irregular worker?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isIrregularWorkerTrue" name="isIrregularWorker" ng-model="teamMember.Company.IsIrregularWorker" ng-value="true" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="isIrregularWorkerTrue" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isIrregularWorkerFalse" name="isIrregularWorker" ng-model="teamMember.Company.IsIrregularWorker" ng-value="false" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="isIrregularWorkerFalse" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t\t<!-- PeopleHR Employee ID in the platform -->\n\t\t<div class="form-field" ng-if="company.IsPeopleHRIntegrationEnabled">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="phrEmployeeID" ng-class="{ \'required\': teamMember.isTeamMemberSetupFieldsRequired }">PeopleHR Employee ID:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="phrEmployeeID" maxlength="15" name="phrEmployeeID" ng-model="teamMember.Company.PhrEmployeeID" ng-required="teamMember.isTeamMemberSetupFieldsRequired" placeholder="Enter ID" type="text">\n\t\t\t</div>\n\t\t\t<p class="form-message">\n\t\t\t\tPlease ensure this matches the \'Employee ID\' in PeopleHR exactly. 15 characters max.\n\t\t\t</p>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companyDetailsForm.phrEmployeeID.$error" ng-show="companyDetailsForm.phrEmployeeID.$touched" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter a PeopleHR Employee ID\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="maxlength">\n\t\t\t\t\tPlease enter only 15 characters\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n \t\t<!-- Expats -->\n \t\t<fieldset ng-if="formOptions.company.IsExpatActive && !teamMember.Company.IsOffPayrollWorker">\n\n\t\t\t<!-- Is expat? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="isExpatriateTrue">\n\t\t\t\t\t\tIs {{::formOptions.context.Forename}} an expat?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isExpatriateTrue" name="isExpatriate" ng-change="reviewIsExpatriate(teamMember)" ng-model="teamMember.Company.IsExpatriate" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="isExpatriateTrue">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isExpatriateFalse" name="isExpatriate" ng-change="reviewIsExpatriate(teamMember)" ng-model="teamMember.Company.IsExpatriate" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="isExpatriateFalse">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\n\t\t\t<!-- Seconded to work in the UK? -->\n\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Company.IsExpatriate">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="isSecondedToWorkInUkTrue">\n\t\t\t\t\t\tHas {{::formOptions.context.Forename}} been seconded to work in the UK?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isSecondedToWorkInUkTrue" name="isSecondedToWorkInUk" ng-change="reviewIsSeconded(teamMember)" ng-model="teamMember.Company.IsSeconded" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="isSecondedToWorkInUkTrue">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="isSecondedToWorkInUkFalse" name="isSecondedToWorkInUk" ng-change="reviewIsSeconded(teamMember)" ng-model="teamMember.Company.IsSeconded" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="isSecondedToWorkInUkFalse">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\n\t \t\t<!-- Only applicable for seconded expatriates -->\n\t \t\t<fieldset class="fadeIn" ng-if="teamMember.Company.IsSeconded">\n\n\t \t\t\t<!-- Is an EEA citizen? -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="isEaaCitizenTrue">\n\t\t\t\t\t\t\tIs {{::formOptions.context.Forename}} an <abbr class="underline" tooltip tooltip-text="European Economic Area" tooltip-position="right">EEA</abbr> citizen?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isEaaCitizenTrue" name="isEaaCitizen" ng-model="teamMember.Company.IsEEACitizen" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isEaaCitizenTrue">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isEaaCitizenFalse" name="isEaaCitizen" ng-model="teamMember.Company.IsEEACitizen" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isEaaCitizenFalse">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t \t\t</div>\n\n\t \t\t\t<!-- Is under EPM6 scheme? -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="isUnderEpm6SchemeTrue">\n\t\t\t\t\t\t\tIs {{::formOptions.context.Forename}} under an EPM6 (Modified) Scheme?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isUnderEpm6SchemeTrue" name="isUnderEpm6Scheme" ng-model="teamMember.Company.IsEPM6" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isUnderEpm6SchemeTrue">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isUnderEpm6SchemeFalse" name="isUnderEpm6Scheme" ng-model="teamMember.Company.IsEPM6" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isUnderEpm6SchemeFalse">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t \t\t</div>\n\n\t \t\t</fieldset>\n\n\t \t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<button ng-if="!formOptions.canGoBack" data-cy="secondary-action-cancel" class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companyDetailsForm.state" disable-button="companyDetailsForm.$invalid"></submit-button>\n\n\t\t<button class="tertiary-action" data-cy="tertiary-action" ng-click="formOptions.skip()" ng-if="formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Payroll ID already exists -->\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="This Payroll ID is already in use" ng-if="pageState === \'payroll-id-exists-in-scheme\'">\n\t<fs-main>\n\t\t<p class="s">The Payroll ID entered is already being used by another team member. Please click &lsquo;Back&rsquo; and double check it is correct. The Payroll ID should be unique to each team member in the PAYE scheme, which can be used for more than one company. If you\'re absolutely sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, please contact support and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button data-cy="secondary-action" class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- HMRC Submission ID already exists -->\n<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="This HMRC Submission ID is already in use" ng-if="pageState === \'hmrc-submission-id-exists-in-scheme\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe HMRC Submission ID entered is already being used by another team member. Please click &lsquo;Back&rsquo; and double check it is correct. The HMRC Submission ID should be unique to each team member in the PAYE scheme, which can be used for more than one company. If you\'re absolutely sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, contact support and we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button data-cy="secondary-action" class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/continuous-employment/continuous-employment.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="continuousEmploymentForm" ng-submit="updateTeamMemberCompanyContinuousEmployment(vm, continuousEmploymentForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h6>{{formOptions.context.Forename}}\u2019s continuous employment</h6>\n\t\t<p class="s">If {{formOptions.context.Forename}} was transferred to this payroll from another related company, their continuous employment details can be stored by adding their original start date.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Employer Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="continuousEmploymentEmployerName">Previous employer:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="continuousEmploymentEmployerName" name="continuousEmploymentEmployerName" type="text" ng-model="vm.continuousEmployment.ContinuousEmploymentEmployerName" ng-pattern="$root.REGEX.companyName">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="continuousEmploymentForm.continuousEmploymentEmployerName.$error" ng-if="continuousEmploymentForm.continuousEmploymentEmployerName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Start Date -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="continuousEmploymentStartDateIso">Start date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="continuousEmploymentStartDateIso" field-required="true" field-value-iso="vm.continuousEmployment.ContinuousEmploymentStartDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="continuousEmploymentForm.continuousEmploymentStartDateIso.$error" ng-if="continuousEmploymentForm.continuousEmploymentStartDateIso.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a start date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid start date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">The date {{formOptions.context.Forename}} started work with this employer</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="vm.showDelete">\n\t\t<p class="s strong">\n\t\t\t<a data-cy="continuous-employment-delete-continuous-employment" class="greyscale" ng-click="deletePreviousEmployment()"><i class="icon-trash m"></i> Delete continuous employment</a>\n\t\t</p>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="continuousEmploymentForm.state" disable-button="!continuousEmploymentForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- Delete continuous employment -->\n<form name="deletePreviousEmploymentForm" ng-submit="updateTeamMemberCompanyContinuousEmployment(vm, deletePreviousEmploymentForm)" class="fadeIn" ng-if="pageState === \'delete-employment\'" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure you wish to delete this?" fs-show-close="false">\n\t\t<fs-main>\n\t\t\t<p class="is-small">You can add continuous employment information to {{formOptions.context.Forename}}\'s profile later if you need to.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Delete\'" state="deletePreviousEmploymentForm.state" disable-button="!deletePreviousEmploymentForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/delete-tax-update/delete-tax-update.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="deleteTaxUpdateForm" ng-submit="$ctrl.deleteTaxUpdate(deleteTaxUpdateForm)">\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to delete this update?" ng-if="$ctrl.formState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tOnce you delete this update for {{$ctrl.formOptions.context.Forename}} it cannot be undone. Click &lsquo;Confirm&rsquo; if you\'re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<!-- Close -->\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeWithoutCallback()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button display-text="\'Confirm\'" state="deleteTaxUpdateForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<!-- Success -->\n\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Update deleted" ng-if="$ctrl.formState === \'success\'">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s tax update has been deleted.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Cannot delete -->\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Unable to delete update" ng-if="$ctrl.formState === \'cannot-delete\'">\n\t\t<fs-main>\n\t\t\t<p class="s">Update cannot be deleted. You can only delete pending updates.</p>\n\t\t</fs-main>\n\t</form-state>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/healthcare/healthcare.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<div ng-if="$ctrl.componentState === \'ready\'" ng-switch="$ctrl.formOptions.activeStep">\n\n\t<!-- Step 1 -->\n\t<form name="healthcareStep1Form" ng-submit="$ctrl.updateHealthBenefit($ctrl, healthcareStep1Form)" class="fadeIn" ng-switch-when="1" novalidate>\n\n\t\t<!-- Payments & Costs -->\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Payments & Costs</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Cost to Employer -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.healthBenefitCost" ng-model="$ctrl.healthBenefit.HealthBenefitCost"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Contribute? -->\n\t\t\t<form-field class="slide-in-form_item" form-field-options="$ctrl.formFields.healthBenefitContributes" ng-model="$ctrl.healthBenefit.healthBenefitContributes"></form-field>\n\n\t\t\t<!-- Contribution amount -->\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item fadeIn" ng-if="$ctrl.healthBenefit.healthBenefitContributes">\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.healthBenefitContribution" ng-model="$ctrl.healthBenefit.HealthBenefitContribution"></form-field>\n\t\t\t</div>\n\n\t\t\t<!-- Policy length -->\n\t\t\t<div class="form-fields-from-to slide-in-form_item">\n\n\t\t\t\t<!-- Policy Start Date -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.healthBenefitPolicyStartDateISO" ng-model="$ctrl.healthBenefit.HealthBenefitPolicyStartDateISO"></form-field>\n\t\t\t\t\n\t\t\t\t<!-- Policy End Date -->\n\t\t\t\t<form-field class="form-fields-from-to_item" form-field-options="$ctrl.formFields.healthBenefitPolicyEndDateISO" ng-model="$ctrl.healthBenefit.HealthBenefitPolicyEndDateISO"></form-field>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Next\'" state="healthcareStep1Form.state" disable-button="!healthcareStep1Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 2 -->\n\t<form name="healthcareStep2Form" ng-submit="$ctrl.reviewCalculatePaymentScheduleGroup($ctrl, healthcareStep2Form)" class="fadeIn" ng-switch-when="2" novalidate>\n\t\t\n\t\t<div class="form-intro">\n\t\t\t<h4>Benefit in Kind</h4>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<div class="form-field-group is-two-column slide-in-form_item">\n\t\t\t\t\n\t\t\t\t<!-- Taxable Benefit -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.healthBenefitCashEquivalent" ng-model="$ctrl.healthBenefit.HealthBenefitCashEquivalent"></form-field>\n\t\t\t\t\n\t\t\t\t<!-- Benefit Paid YTD -->\n\t\t\t\t<form-field class="form-field-group_item" form-field-options="$ctrl.formFields.healthBenefitPaidYTD" ng-model="$ctrl.healthBenefit.HealthBenefitPaidYTD"></form-field>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Payslip Label -->\n\t\t\t<pill-input-field class="slide-in-form_item" field-options="$ctrl.labelOptions" ng-model="$ctrl.paymentScheduleGroup.PayslipLabel" ng-model-save="$ctrl.paymentScheduleGroup.payslipLabelSave"></pill-input-field>\n\n\t\t\t<!-- Payroll Benefit -->\n\t\t\t<settings-row class="slide-in-form_item" sr-field-name="bikBehaviour" sr-icon="clock" sr-theme="quarternary" ng-model="$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">\n\t\t\t\t<sr-label>Payroll benefit</sr-label>\n\t\t\t\t<sr-description ng-if="$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">Switch to \'OFF\' if you don\'t want to payroll this benefit each time you run payroll for {{::$ctrl.formOptions.company.Name}}</sr-description>\n\t\t\t\t<sr-description ng-if="!$ctrl.paymentScheduleGroup.PaymentScheduleGroupPayrollBIKState">Switch to \'ON\' if you want to payroll this benefit each time you run payroll for {{::$ctrl.formOptions.company.Name}}</sr-description>\n\t\t\t</settings-row>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.goToPreviousStep($ctrl)">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Next\'" state="healthcareStep2Form.state" disable-button="!healthcareStep2Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 3 > Benefit Summary -->\n\t<form name="healthcareStep3Form" ng-submit="$ctrl.updatePaymentScheduleGroup($ctrl, healthcareStep3Form)" class="fadeIn" ng-switch-when="3" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Benefit summary</h4>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Healthcare benefit" rc-view-type="benefit" can-edit="true" on-edit="$ctrl.goToStep($ctrl, 1)"></repayment-card>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<table class="primary payments-table">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t\t<th>Amount</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat="payment in $ctrl.paymentScheduleGroup.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag positive" ng-if="payment.IsPaid">Paid</span>\n\t\t\t\t\t\t\t<strong class="payments-table-amount">{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.goToPreviousStep($ctrl)">Back</a>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="healthcareStep3Form.state" disable-button="!healthcareStep3Form.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/healthcare-view/healthcare-view.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<!-- Benefit Summary -->\n<form name="benefitSummaryForm" ng-submit="$ctrl.deletePaymentScheduleGroup($ctrl, benefitSummaryForm)" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Healthcare benefit" rc-view-type="benefit" can-edit="$root.currentUser.Permissions.Payroll.canUpdateRepaymentSchedules" on-edit="$ctrl.openHealthcareForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<!-- Schedule -->\n\t<div class="form-section" ng-if="!$ctrl.isDeleteConfirmed">\n\t\t<table class="primary payments-table">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t<th>Amount</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat="payment in $ctrl.paymentScheduleGroup.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span class="tag positive" data-cy="isPaid" ng-if="payment.IsPaid && !payment.IsPaused">Paid</span>\n\t\t\t\t\t\t<span class="tag tertiary" data-cy="isPaused" ng-if="payment.IsPaused">Paused</span>\n\t\t\t\t\t\t<span class="tag assertive" data-cy="isCancelled" ng-if="payment.IsCancelled">Stopped</span>\n\t\t\t\t\t\t<strong class="payments-table-amount">{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n\t<!-- Confirm deletion -->\n\t<div class="form-section fadeIn" ng-if="$ctrl.isDeleteConfirmed">\n\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to {{$ctrl.paymentScheduleGroup.canDelete ? \'delete\' : \'stop\'}} this benefit?">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">Once you click \'Confirm\' this cannot be undone.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="$ctrl.paymentScheduleGroup.CanCancel && $root.currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">\n\n\t\t<!-- No payment made -->\n\t\t<div ng-if="$ctrl.paymentScheduleGroup.canDelete">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.cancelDelete($ctrl)" ng-if="$ctrl.isDeleteConfirmed">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.isDeleteConfirmed ? \'Confirm\' : \'Delete\'" state="benefitSummaryForm.state" disable-button="!benefitSummaryForm.$valid"></submit-button>\n\t\t</div>\n\n\t\t<!-- Payment made -->\n\t\t<div ng-if="!$ctrl.paymentScheduleGroup.canDelete">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.cancelDelete($ctrl)" ng-if="$ctrl.isDeleteConfirmed">Cancel</a>\n\t\t\t<submit-button display-text="$ctrl.isDeleteConfirmed ? \'Confirm\' : \'Stop benefit\'" state="benefitSummaryForm.state" disable-button="!benefitSummaryForm.$valid"></submit-button>\n\t\t\t<a href="" class="button tertiary tertiary-action" ng-click="$ctrl.setComponentState(\'pause\')" ng-if="!$ctrl.paymentScheduleGroup.IsPaused && !$ctrl.isDeleteConfirmed" data-cy="pauseBenefit">Pause benefit</a>\n\t\t\t<a href="" class="button tertiary tertiary-action" ng-click="$ctrl.setComponentState(\'resume\')" ng-if="$ctrl.paymentScheduleGroup.IsPaused && !$ctrl.isDeleteConfirmed" data-cy="resumeBenefit">Resume benefit</a>\n\t\t</div>\n\t</fieldset>\n</form>\n\n<!-- Pause -->\n<form name="pauseBenefitForm" ng-submit="$ctrl.pausePaymentScheduleGroup($ctrl, pauseBenefitForm)" ng-if="$ctrl.componentState === \'pause\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Healthcare benefit" rc-view-type="benefit" can-edit="true" on-edit="$ctrl.openCompanyVehicleForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Confirm pause -->\n\t\t<div class="form-section fadeIn">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="How long do you wish to pause this benefit for?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Select the number of pay periods to pause this benefit for and deductions won\u2019t be taken from {{$ctrl.formOptions.context.Forename}}\'s pay.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\t\t\t\n\t\t</div>\n\n\t\t<!-- Pause length -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pauseCount" class="required">Select the number of pay periods to pause:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="pauseCount" id="pauseCount" ng-model="$ctrl.pauseCount" ng-options="option.value as option.description for option in $ctrl.PAUSE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="templateForm.pauseCount.$error" ng-if="templateForm.pauseCount.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="pauseBenefitForm.state" disable-button="!pauseBenefitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Resume -->\n<form name="resumeBenefitForm" ng-submit="$ctrl.resumePaymentScheduleGroup($ctrl, resumeBenefitForm)" ng-if="$ctrl.componentState === \'resume\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Benefit summary</h5>\n\t</div>\n\n\t<div class="form-section">\n\t\t<repayment-card repayment="$ctrl.paymentScheduleGroup" rc-label="Healthcare benefit" rc-view-type="benefit" can-edit="true" on-edit="$ctrl.openCompanyVehicleForm($ctrl)"></repayment-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Confirm pause -->\n\t\t<div class="form-section fadeIn">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to resume this benefit?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Deductions will continue be taken from {{$ctrl.formOptions.context.Forename}}\'s pay the next time you run payroll. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="resumeBenefitForm.state" disable-button="!resumeBenefitForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/link-rate/link-rate.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="linkRateForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateUserPayElements($ctrl, linkRateForm)" novalidate>\n\n\t<fieldset>\n\n\t\t<div class="form-intro" ng-if="$ctrl.isBulk">\n\t\t\t<p class="is-small">\n\t\t\t\tYou&apos;re adding a link rate for\n\t\t\t\t<ng-pluralize count="$ctrl.formOptions.userIds.length" when="{\n\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t}"></ng-pluralize>.\n\t\t\t\tPlease note that if the selected link element has already been added for one\n\t\t\t\tof your selected team members, this will overwrite the existing link rate.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Link Element -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="linkElement" ng-class="{\n\t\t\t\t\t\t\'disabled\': $ctrl.isEditing\n\t\t\t\t\t}">\n\t\t\t\t\tLink element:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select id="linkElement" name="linkElement" ng-change="$ctrl.reviewLinkElement($ctrl)" ng-disabled="$ctrl.isEditing" ng-model="$ctrl.selectedLinkElement" ng-options="option as option.LinkElementName for option in $ctrl.linkElementDetails.LinkElements |\n\t\t\t\t\t\torderBy: \'LinkElementName\' track by option.LinkElementID" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkRateForm.linkElement.$touched" ng-messages="linkRateForm.linkElement.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select a link element</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Rate -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="rateType">\n\t\t\t\t\tRate type:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\n\t\t\t\t<!-- Rate (individual) -->\n\t\t\t\t<select id="rateType" name="rateType" ng-change="$ctrl.reviewUserPayElement($ctrl)" ng-if="!$ctrl.isBulk" ng-model="$ctrl.selectedRate" ng-options="option as option.SalaryRateDisplay for option in $ctrl.salary.SalaryRatesWithCalculated track by option.SalaryRateID" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\n\t\t\t\t<!-- Rate (bulk) -->\n\t\t\t\t<select id="rateType" name="rateType" ng-change="$ctrl.reviewUserPayElement($ctrl)" ng-if="$ctrl.isBulk" ng-model="$ctrl.selectedRate" ng-options="option as option.SalaryRateDisplay for option in $ctrl.rates track by option.SalaryRateID" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkRateForm.rateType.$touched" ng-messages="linkRateForm.rateType.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select a rate</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="$ctrl.selectedLinkElement && $ctrl.selectedRate">\n\t\t<!-- Rate -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.selectedRate.SalaryRateID === \'custom\'">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="rate">\n\t\t\t\t\tRate:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="xl monetise" id="rate" maxlength="20" min="0.01" name="rate" ng-model="$ctrl.userPayElement.UnitValue" ng-pattern="::$ctrl.regexService.salaryRatesRegEx" placeholder="0.00" type="number" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkRateForm.rate.$touched" ng-messages="linkRateForm.rate.$error" role="alert">\n\t\t\t\t<p ng-message="maxlength">Maximum of 20 digits</p>\n\t\t\t\t<p ng-message="min">Amount should be 1p or greater</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="pattern">Numbers can only have up to 4 decimal places</p>\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Add standard units -->\n\t\t<div class="form-field" ng-if="$ctrl.selectedLinkElement.LinkElementAdjustmentValueType === $ctrl.ADJUSTMENT_VALUE_TYPES.unit">\n\t\t\t<main class="form-field-main">\n\t\t\t\t<toggle-input field-label="Add standard units" field-model="$ctrl.userPayElement.AddStandardUnits" field-name="addStandardUnits" field-on-change="$ctrl.reviewStandardUnits($ctrl)"></toggle-input>\n\t\t\t</main>\n\t\t\t<p class="form-message fadeIn">\n\t\t\t\tYou can add units each pay period or add recurring standard units. The units can be updated each pay period.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Standard units -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.userPayElement.AddStandardUnits">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="standardUnits">\n\t\t\t\t\tStandard units:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<number-selector-field field-name="standardUnits" ng-model-options="{ debounce:400 }" ng-model="$ctrl.userPayElement.Units" theme="{{$ctrl.selectedLinkElement.IsDeduction ? \'assertive\' : \'positive\'}}"></number-selector-field>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="linkRateForm.standardUnits.$touched" ng-messages="linkRateForm.standardUnits.$error" role="alert">\n\t\t\t\t<p ng-message="max">Maximum of 1000 units</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid number</p>\n\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Summary -->\n\t\t<div class="form-field">\n\t\t\t<div class="link-rate-summary {{$ctrl.selectedLinkElement.IsDeduction ? \'is-assertive\' : \'is-positive\'}}">\n\t\t\t\t<p class="link-rate-summary_intro" ng-if="\n\t\t\t\t\t\t!$ctrl.userPayElement.AddStandardUnits &&\n\t\t\t\t\t\t$ctrl.selectedLinkElement.LinkElementAdjustmentValueType === $ctrl.ADJUSTMENT_VALUE_TYPES.unit\n\t\t\t\t\t">\n\t\t\t\t\tUnits for the following link rate can be updated each pay period:\n\t\t\t\t</p>\n\t\t\t\t<div class="link-rate-summary_main">\n\t\t\t\t\t<h6 class="link-rate-summary_main-item">{{$ctrl.selectedLinkElement.LinkElementName}}</h6>\n\t\t\t\t\t<h6 class="link-rate-summary_main-item">\n\t\t\t\t\t\t<span ng-if="$ctrl.userPayElement.Units">{{$ctrl.userPayElement.Units}} x</span>\n\t\t\t\t\t\t{{$ctrl.userPayElement.UnitValue * $ctrl.selectedLinkElement.LinkElementMultiplier | monetise:$root.CONFIG.precision.salaryRates}}\n\t\t\t\t\t</h6>\n\t\t\t\t</div>\n\t\t\t\t<p class="link-rate-summary_footer">\n\t\t\t\t\tThe {{$ctrl.selectedLinkElement.LinkElementName}} link element has a x {{$ctrl.selectedLinkElement.LinkElementMultiplier}} multiplier set\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!linkRateForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="linkRateForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Delete -->\n<form class="fadeIn" name="deleteLinkRateForm" ng-if="$ctrl.componentState === \'confirm-delete\'" ng-submit="$ctrl.deleteUserPayElement($ctrl, deleteLinkRateForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this link rate?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYou&apos;re about to delete the &lsquo;{{$ctrl.selectedLinkElement.LinkElementName}}&rsquo; link rate and it will no longer be available for\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}. Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!deleteLinkRateForm.$valid" display-text="\'Delete\'" state="deleteLinkRateForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No link elements -->\n<placeholder ng-if="$ctrl.componentState === \'no-link-elements\'" placeholder-graphic="no-link-elements">\n\t<placeholder-title>No link elements</placeholder-title>\n\t<placeholder-copy>\n\t\t<p>\n\t\t\tOnce you&apos;ve added link elements in your company settings they will be available here to set link rates up for {{$ctrl.formOptions.context.Forename}}.\n\t\t</p>\n\t</placeholder-copy>\n\t<placeholder-primary-actions>\n\t\t<a href="" ui-sref="settings.company.pay-elements.link-elements({agencyProfileId: $ctrl.formOptions.agencyProfileId})">\n\t\t\tGo to pay elements <i class="icon-chevron-right"></i>\n\t\t</a>\n\t</placeholder-primary-actions>\n</placeholder>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/movedPayrollsWarning/movedPayrollsWarningForm.html','<form name="movedPayrollsWarningForm" class="fadeIn" ng-submit="dismissWarning()" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="s">{{formOptions.context.Forename}} has recently moved payrolls. {{formOptions.context.Forename}}\'s employment information has been automatically transferred\n\t\t\t\tfrom {{formOptions.fromCompanyName}} and some of it can\u2019t be changed. Employment information includes company details, pay information, payments to\n\t\t\t\tdate and tax information for the current tax year and represents the information held by HMRC. If you edit any of these details {{formOptions.context.Forename}}\'s\n\t\t\t\tinformation will be updated with HMRC when you run payroll.</p>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<button class="tertiary primary-action">Continue</button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n');
$templateCache.put('forms/employment/new-starter-information/new-starter-information.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="newStarterInformationForm" ng-if="pageState === \'ready\'" ng-submit="updateNewStarterInformation(teamMember, newStarterInformationForm)" novalidate>\n\n\t<!-- New Starters (Non-seconded) -->\n\t<fieldset class="fadeIn" ng-if="!teamMember.Company.IsSeconded">\n\n\t\t<!-- Starter document type -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="form-field-label l" for="newStarterDocument">\n\t\t\t\t\tDoes {{formOptions.context.Forename}} have a new starter document?\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="documentTypeDeclaration" name="newStarterDocument" ng-change="onStarterDocumentChange(teamMember)" ng-model="teamMember.newStarterDocumentType" ng-value="NEW_STARTER_DOCUMENT_TYPES.declaration" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="documentTypeDeclaration">\n\t\t\t\t\t\t\t<i class="icon-clipboard radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Declaration</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="documentTypeP45" name="newStarterDocument" ng-change="onStarterDocumentChange(teamMember)" ng-model="teamMember.newStarterDocumentType" ng-value="NEW_STARTER_DOCUMENT_TYPES.p45" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="documentTypeP45">\n\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">P45</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="documentTypeP6" name="newStarterDocument" ng-change="onStarterDocumentChange(teamMember)" ng-model="teamMember.newStarterDocumentType" ng-value="NEW_STARTER_DOCUMENT_TYPES.p6" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="documentTypeP6">\n\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">P6</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Warning displayed when document type has changed -->\n\t\t<fieldset ng-if="teamMember.showDocumentTypeChangeWarning">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Updating the new starter document">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPlease note that updating from P45 to P6 will delete the leave date previously entered and updating from either\n\t\t\t\t\t\tP45 or P6 to starter declaration will delete all previously entered data.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\n\t\t<!-- New Starter Declaration -->\n\t\t<fieldset class="fadeIn" ng-if="teamMember.newStarterDocumentType === NEW_STARTER_DOCUMENT_TYPES.declaration">\n\n\t\t\t<!-- New Starter Declaration -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label required l" for="starterDeclarationA">\n\t\t\t\t\t\tWhat is their employment status?\n\t\t\t\t\t</label>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tAs {{formOptions.context.Forename}} doesn\u2019t have a P45 or P6 select one of the declaration options below. Please note that this can be updated after you\u2019ve run your first\n\t\t\t\t\t\tpay period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationA" name="starterDeclaration" ng-model="teamMember.Tax.StarterDeclaration" ng-value="\'A\'" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationA">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">A</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tThis is {{formOptions.context.Forename}}&rsquo;s first job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\tsince start of tax year and <span class="strong">they have not</span> been receiving taxable Jobseeker&rsquo;s Allowance,\n\t\t\t\t\t\t\t\t\t\tEmployment and Support Allowance, taxable Incapacity Benefit, State or Occupational pension.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationB" name="starterDeclaration" ng-model="teamMember.Tax.StarterDeclaration" ng-value="\'B\'" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationB">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">B</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tThis is now {{formOptions.context.Forename}}&rsquo;s only job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>but</em> since start of tax year <span class="strong">they have</span> had another job, or received taxable\n\t\t\t\t\t\t\t\t\t\tJobseeker&rsquo;s Allowance, Employment and Support Allowance or taxable Incapacity Benefit.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationC" name="starterDeclaration" ng-model="teamMember.Tax.StarterDeclaration" ng-value="\'C\'" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationC">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">C</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tAs well as this new job, {{formOptions.context.Forename}} has another job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>or</em> receives State or Occupational Pension.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationD" name="starterDeclaration" ng-model="teamMember.Tax.StarterDeclaration" ng-value="\'D\'" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationD">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">D</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} has not completed a starter declaration\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>so</em> they will be assigned a 0T W1/M1 tax code in order to calculate\n\t\t\t\t\t\t\t\t\t\ttheir tax.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.starterDeclaration.$error" ng-show="newStarterInformationForm.starterDeclaration.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease choose an option that describes {{formOptions.context.Forename}}&rsquo;s employment status\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- P45 -->\n\t\t<fieldset class="fadeIn" ng-if="teamMember.newStarterDocumentType === NEW_STARTER_DOCUMENT_TYPES.p45">\n\n\t\t\t<!-- Leaving Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="previousEmploymentLeaveDate">\n\t\t\t\t\t\tLeaving date on P45:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="previousEmploymentLeaveDate" field-min-date-iso="teamMember.YTD.YTDLeaveDatePreviousEmploymentISOMin" field-value-iso="teamMember.YTD.YTDLeaveDatePreviousEmploymentISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="newStarterInformationForm.previousEmploymentLeaveDate.$touched" ng-messages="newStarterInformationForm.previousEmploymentLeaveDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter a leave date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\tPlease enter a valid leave date, like this: dd/mm/yyyy\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\tIt looks like {{formOptions.context.Forename}}\'s P45 is no longer valid as the leave date is in the previous tax year.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tShown next to box 4 on the P45\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Total Pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="totalPayInPreviousEmployment">\n\t\t\t\t\t\tTotal pay in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdGrossPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" name="ytdGrossPreviousEmployment" ng-model="teamMember.YTD.YTDGrossPreviousEmployment" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.ytdGrossPreviousEmployment.$error" ng-show="newStarterInformationForm.ytdGrossPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tShown next to box 7 on the P45\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Total Tax -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="totalTaxInPreviousEmployment">\n\t\t\t\t\t\tTotal tax paid in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdTaxPreviousEmployment" name="ytdTaxPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="teamMember.YTD.YTDTaxPreviousEmployment" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.ytdTaxPreviousEmployment.$error" ng-show="newStarterInformationForm.ytdTaxPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tShown next to box 7 on the P45\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- P6 -->\n\t\t<fieldset class="fadeIn" ng-if="teamMember.newStarterDocumentType === NEW_STARTER_DOCUMENT_TYPES.p6">\n\n\t\t\t<!-- Total Pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="totalPayInPreviousEmployment">\n\t\t\t\t\t\tTotal pay in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdGrossPreviousEmployment" name="ytdGrossPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="teamMember.YTD.YTDGrossPreviousEmployment" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.ytdGrossPreviousEmployment.$error" ng-show="newStarterInformationForm.ytdGrossPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Total Tax -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="totalTaxInPreviousEmployment">\n\t\t\t\t\t\tTotal tax paid in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdTaxPreviousEmployment" name="ytdTaxPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="teamMember.YTD.YTDTaxPreviousEmployment" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.ytdTaxPreviousEmployment.$error" ng-show="newStarterInformationForm.ytdTaxPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Automated tax codes note -->\n\t\t<fieldset>\n\t\t\t<div class="form-field" ng-if="!formOptions.company.DPSImport">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Turn on automated tax codes">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small" ng-if="teamMember.newStarterDocumentType === NEW_STARTER_DOCUMENT_TYPES.declaration">\n\t\t\t\t\t\t\tPlease note that updating {{formOptions.context.Forename}}\'s starter declaration won\'t update their tax code as they have already been run through payroll.\n\t\t\t\t\t\t\tYou can update {{formOptions.context.Forename}}\'s tax status manually in the Information area of their profile.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="is-small" ng-if="teamMember.newStarterDocumentType !== NEW_STARTER_DOCUMENT_TYPES.declaration">\n\t\t\t\t\t\t\tPaycircle can automatically update tax code and student loan notices and remove the need to perform these tasks manually.&nbsp;\n\t\t\t\t\t\t\t<a class="indifferent underline" href="" ng-href="{{$root.URLS.paycircle.support.automaticTaxCodeUpdates}}" target="_blank">\n\t\t\t\t\t\t\t\tRead more\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- New Starters (Seconded expatriate) -->\n\t<fieldset class="fadeIn" ng-if="teamMember.Company.IsSeconded">\n\n\t\t<!-- Employment status -->\n\t\t<fieldset>\n\n\t\t\t<!-- New Starter Declaration -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label required" for="starterDeclarationA" ng-class="{\n\t\t\t\t\t\t\t\'disabled\': !teamMember.IsInSetupMode\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tWhat is {{formOptions.context.Forename}}\'s employment status?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateA" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.stay183DaysOrMore" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateA">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">A</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} intends to live in the UK for 183 days or more\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateB" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.stayLessThan183Days" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateB">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">B</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} intends to live in the UK for less than 183 days\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateC" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.inOutUk" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateC">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">C</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} will be working for {{formOptions.company.Name}} both inside and outside the UK but will be living abroad\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- JE: Might be re-introduced later on\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\tclass="radio-card-input"\n\t\t\t\t\t\t\t\tid="secondedStateD"\n\t\t\t\t\t\t\t\tname="secondedState"\n\t\t\t\t\t\t\t\tng-disabled="!teamMember.IsInSetupMode"\n\t\t\t\t\t\t\t\tng-model="teamMember.Tax.SecondedState"\n\t\t\t\t\t\t\t\tng-value="SECONDED_STATES.notEnoughInformation"\n\t\t\t\t\t\t\t\trequired\n\t\t\t\t\t\t\t\ttype="radio"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<label\n\t\t\t\t\t\t\t\tclass="radio-card-label"\n\t\t\t\t\t\t\t\tfor="secondedStateD"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">D</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} has not provided enough information\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\tso they will be assigned a 0T tax code, in order to calculate their tax, and they will be assessed to determine their National Insurance category.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t-->\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="newStarterInformationForm.secondedState.$error" ng-show="newStarterInformationForm.secondedState.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease choose an option that describes {{formOptions.context.Forename}}&apos;s employment status\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button disable-button="newStarterInformationForm.$invalid" display-text="\'Save\'" ng-if="!teamMember.Company.IsSeconded" state="newStarterInformationForm.state"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/payInformation/payInformationForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="payInformationForm" ng-if="pageState === \'ready\'" ng-submit="updateTeamMemberSalary(vm, payInformationForm)" novalidate>\n\t<!-- Employment Type -->\n\t<fieldset>\n\n\t\t<!-- Standard / Non-standard / Net Pay / Paid Hourly / Pay policy* (*if HR active for company)-->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="l" for="paymentTypeFullTime" ng-class="{\n\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t}">\n\t\t\t\t\tHow is {{formOptions.context.Forename}} employed?\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="paymentType" name="paymentType" ng-change="selectEmploymentType(vm)" ng-model="vm.teamMember.salary.EmploymentType" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired">\n\t\t\t\t\t<option ng-repeat="(index, employmentType) in vm.employmentTypes" ng-value="{{index}}">{{employmentType}}</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Changing Employment Type warning if applicable -->\n\t\t<div class="form-field fadeIn" ng-if="!formOptions.context.IsInSetupMode && vm.teamMember.salary.showEmploymentTypeChangedWarningMessage">\n\t\t\t<info-block ib-theme="indifferent has-icon has-plain-type">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-support indifferent-darkened info-block-icon"></i>\n\t\t\t\t\t\t<h6>Changing employment types</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">{{vm.teamMember.salary.employmentTypeChangedWarningMessage}}</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Currency (Expats && Net Pay || Standard Pattern) -->\n\t<fieldset ng-if="\n\t\t\tvm.teamMember.company.IsExpatriate &&\n\t\t\t[EMPLOYMENT_TYPES.netPay, EMPLOYMENT_TYPES.standard].includes(vm.teamMember.salary.EmploymentType)\n\t\t">\n\t\t<pay-information-currencies-fieldset agency-profile-id="formOptions.agencyProfileId" is-required="vm.teamMember.isTeamMemberSetupFieldsRequired" team-member="vm.teamMember"></pay-information-currencies-fieldset>\n\t</fieldset>\n\n\t<!-- Work Pattern (Regular / Flexi) -->\n\t<fieldset class="fadeIn" ng-if="\n\t\t\tvm.isWorkPatternsApplicable &&\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.standard ||\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.nonStandard\n\t\t">\n\t\t<!-- No company work patterns -->\n\t\t<div class="info-block tertiary" ng-if="!vm.companyWorkPatternsFiltered.length">\n\t\t\t<p class="s">\n\t\t\t\t{{formOptions.company.Name}} doesn\'t have any Work Patterns for this employment type set up.\n\t\t\t\t<a class="underline tertiary" ui-sref="settings.company.work-patterns({agencyProfileId: formOptions.agencyProfileId})">\n\t\t\t\t\tSet one up now\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t\t<input id="notAllowed" name="notAllowed" ng-model="vm.doesNotExist" required type="hidden" value="">\n\t\t</div>\n\n\t\t<!-- Has work patterns -->\n\t\t<div ng-if="vm.companyWorkPatternsFiltered.length">\n\t\t\t<div class="fadeIn" ng-class="{\n\t\t\t\t\t\'form-field-options-box\': workPattern.isEditing\n\t\t\t\t}" ng-repeat="(workPatternIndex, workPattern) in vm.teamMember.workPatterns">\n\t\t\t\t<!-- View -->\n\t\t\t\t<work-pattern-overview index="$index" ng-if="!workPattern.isEditing" work-pattern="workPattern">\n\t\t\t\t\t<wpo-actions ng-if="(workPatternIndex + 1) === vm.teamMember.workPatterns.length">\n\t\t\t\t\t\t<a class="s underline" data-cy="pay-information-edit-work-pattern-{{workPatternIndex}}" href="" ng-class="workPattern.theme" ng-click="toggleWorkPatternIsEditing(vm, workPatternIndex)">\n\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</wpo-actions>\n\t\t\t\t</work-pattern-overview>\n\n\t\t\t\t<!-- Edit -->\n\t\t\t\t<div ng-if="workPattern.isEditing">\n\n\t\t\t\t\t<div class="form-intro has-action">\n\t\t\t\t\t\t<h5>Work pattern{{workPatternIndex > 0 ? \' change\' : \'\'}}</h5>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tSelect one of the Salary patterns saved in your company settings or add a custom work pattern for {{formOptions.context.Forename}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a aria-label="Delete work pattern" data-cy="pay-information-delete-work-pattern-{{workPatternIndex}}" class="greyscale form-intro_action" href="" ng-click="deleteWorkPattern(vm, workPatternIndex)" ng-if="workPatternIndex > 0">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Active sick pay warning -->\n\t\t\t\t\t<div class="form-field" ng-if="vm.teamMember.hasWorkPatternsChanged && vm.teamMember.isOnSickLeave">\n\t\t\t\t\t\t<info-block ib-theme="tertiary has-icon has-plain-type">\n\t\t\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t\t\t\t<i class="icon-warning tertiary info-block-icon"></i>\n\t\t\t\t\t\t\t\t\t<h6 class="stronger">{{formOptions.context.Forename}} has an active sick pay schedule</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</ib-header>\n\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\t\t\t\t\tPlease note that changing the work pattern may impact the sick pay calculation. To ensure accuracy, go to the \'Schedules\' tab in {{formOptions.context.Forename}}\'s profile and update the schedule as required.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t</info-block>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Checkbox field -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input checkbox id="isCustom{{workPatternIndex}}" label-text="\'Use a custom work pattern\'" name="isCustom{{workPatternIndex}}" ng-change="toggleWorkPatternIsCustom(vm, workPatternIndex)" ng-model="workPattern.IsCustomWorkPattern" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Work Pattern Type -->\n\t\t\t\t\t<div class="form-field" ng-if="!workPattern.IsCustomWorkPattern">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select id="workPattern{{workPatternIndex}}" name="workPattern{{workPatternIndex}}" ng-change="selectWorkPattern(vm, workPattern)" ng-model="workPattern.companyWorkPattern" ng-options="companyWorkPattern as companyWorkPattern.Description for companyWorkPattern in vm.companyWorkPatternsFiltered track by companyWorkPattern.WorkPatternID" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired"></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.workPattern.$touched" ng-messages="payInformationForm.workPattern.$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}" ng-message="required">\n\t\t\t\t\t\t\t\tPlease select a work pattern\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Custom Work Pattern -->\n\t\t\t\t\t<fieldset ng-if="workPattern.IsCustomWorkPattern">\n\n\t\t\t\t\t\t<!-- Standard -->\n\t\t\t\t\t\t<div class="form-field" ng-if="vm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.standard">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\tSelect the working days you wish to include in {{formOptions.context.Forename}}\'s work pattern:\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<fieldset ng-if="vm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.nonStandard">\n\n\t\t\t\t\t\t\t<!-- Pattern Type -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="toggle-block {{workPattern.theme | uncemify}}">\n\t\t\t\t\t\t\t\t\t\t<span class="toggle-block-label left" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'active\': workPattern.Basis === WORK_PATTERN_BASIS.weekly\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\tMon-Sun weeks\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<a class="toggle-block-toggle" data-cy="pay-information-work-pattern-{{workPatternIndex}}-toggle-pattern-basis" href="" ng-click="togglePatternBasis(vm, workPattern)">\n\t\t\t\t\t\t\t\t\t\t\t<span class="toggle-c {{workPattern.theme | uncemify}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'active\': workPattern.Basis === WORK_PATTERN_BASIS.daily\n\t\t\t\t\t\t\t\t\t\t\t\t}"></span>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t<span class="toggle-block-label right" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'active\': workPattern.Basis === WORK_PATTERN_BASIS.daily\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\tIndividual days\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Non-Standard -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<p class="s fadeIn" ng-if="workPattern.Basis === WORK_PATTERN_BASIS.weekly">\n\t\t\t\t\t\t\t\t\tAdjust the hours on each day or leave as \'0\' for non-working days. You can add up to eight weeks to the pattern.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="s fadeIn" ng-if="workPattern.Basis === WORK_PATTERN_BASIS.daily">\n\t\t\t\t\t\t\t\t\tAdd the number of days in the work pattern and the hours worked on each day. Leave the hours as \'0\' for non-working days.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<work-pattern-builder on-update="onWorkPatternChange(vm)" required="vm.teamMember.isTeamMemberSetupFieldsRequired" work-pattern="workPattern"></work-pattern-builder>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field" ng-if="vm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.standard">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="totalHours-{{workPatternIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tTotal work hours per week:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<number-selector-field field-name="totalHours-{{workPatternIndex}}" max="$root.CONFIG.maxHoursPerWeek" ng-model="workPattern.TotalHours" nsf-on-change="onWorkPatternChange(vm)"></number-selector-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'totalHours-\' + workPatternIndex].$touched" ng-messages="payInformationForm[\'totalHours-\' + workPatternIndex].$error" role="alert">\n\t\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-total-hours-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\t\t\tMaximum of {{$root.CONFIG.maxHoursPerWeek}} hours per week\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-total-hours-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\t\tPlease enter a positive value\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-total-hours-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter the total work hours per week\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<!-- Effective date -->\n\t\t\t\t\t<div class="form-field fadeIn" ng-if="\n\t\t\t\t\t\t\t!vm.teamMember.personal.IsInSetupMode ||\n\t\t\t\t\t\t\t(vm.teamMember.workPatterns.length > 1 && workPatternIndex > 0) ||\n\t\t\t\t\t\t\tvm.teamMember.salary.EmploymentType !== vm.teamMember.salary.employmentTypeOriginal\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="effective-date-{{workPatternIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tEffective date:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="{{\'effective-date-\' + workPatternIndex}}" field-max-date-iso="workPattern.effectiveDateISOMax" field-min-date-iso="workPattern.effectiveDateISOMin" field-on-change-fn="onWorkPatternChange(vm)" field-required="vm.teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="workPattern.EffectiveDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'effective-date-\' + workPatternIndex].$touched" ng-messages="payInformationForm[\'effective-date-\' + workPatternIndex].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\t\tPlease enter a date on or before {{workPattern.effectiveDateISOMax | dateformat}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\tPlease enter a date from {{workPattern.effectiveDateISOMin | dateformat}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter a date this work pattern will take effect\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message" data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-message">\n\t\t\t\t\t\t\tNeeds to be between {{workPattern.effectiveDateISOMin | dateformat}} and {{workPattern.effectiveDateISOMax | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="form-message" data-cy="pay-information-work-pattern-{{workPatternIndex}}-effective-date-start-date" ng-if="vm.teamMember.company.StartDateISO !== \'\'">\n\t\t\t\t\t\t\t{{formOptions.context.Forename}}\'s start date is set to {{vm.teamMember.company.StartDateISO | dateformat}} in their company details\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-content-block" ng-if="vm.teamMember.workPatterns.length < MAX_WORK_PATTERNS">\n\t\t\t\t<button class="is-medium-large is-white is-block" data-cy="pay-information-add-work-pattern-change" ng-click="addWorkPatternChange(vm)" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i> Add a work pattern change\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t\t<!-- Preview Pattern -->\n\t\t\t<div class="form-content-block no-margin bottom">\n\t\t\t\t<p class="s">\n\t\t\t\t\t<a data-cy="pay-information-preview-pattern" href="" ng-click="showIsCalendarVisible(vm)">\n\t\t\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;Preview pattern in pay period calendar\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Flexi Pattern > Rate -->\n\t<fieldset class="fadeIn" ng-if="vm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.nonStandard">\n\n\t\t<!-- Payment type > annual / rate -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="scheme" ng-class="{\n\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t}">\n\t\t\t\t\tHow is {{formOptions.context.Forename}} paid?\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input class="b" id="employmentPaymentTypeSalary" name="employmentPaymentType" ng-change="selectPaymentType(vm)" ng-model="vm.teamMember.salary.PaymentType" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" ng-value="EMPLOYMENT_PAYMENT_TYPES.annualSalary" type="radio">\n\t\t\t\t<label for="employmentPaymentTypeSalary">Annual salary</label>\n\n\t\t\t\t<input class="b" id="employmentPaymentTypeRate" name="employmentPaymentType" ng-change="selectPaymentType(vm)" ng-model="vm.teamMember.salary.PaymentType" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" ng-value="EMPLOYMENT_PAYMENT_TYPES.rate" type="radio">\n\t\t\t\t<label for="employmentPaymentTypeRate">Rate</label>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Rate -->\n\t\t<fieldset ng-if="vm.teamMember.salary.PaymentType === EMPLOYMENT_PAYMENT_TYPES.rate">\n\n\t\t\t<!-- Edit -->\n\t\t\t<div class="form-field-options-box primary">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="salaryRate" ng-class="{\n\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tRate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t<!-- Daily Rate -->\n\t\t\t\t\t\t<input class="l monetise" id="salaryRate" name="salaryRate" ng-if="vm.teamMember.salary.RateType === EMPLOYMENT_RATE_TYPES.daily" ng-max="$root.CONFIG.number7Digits4Decimal" ng-maxlength="$root.CONFIG.salaryRateMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="vm.teamMember.salary.SalaryDailyRatePartTime" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\n\t\t\t\t\t\t<!-- Hourly Rate -->\n\t\t\t\t\t\t<input class="l monetise" id="salaryRate" name="salaryRate" ng-if="vm.teamMember.salary.RateType === EMPLOYMENT_RATE_TYPES.hourly" ng-max="$root.CONFIG.number7Digits4Decimal" ng-maxlength="$root.CONFIG.salaryRateMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="vm.teamMember.salary.SalaryHourlyRatePartTime" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\n\t\t\t\t\t\t&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t\t<div class="toggle-control primary">\n\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\'active greyscale\': vm.teamMember.salary.RateType === EMPLOYMENT_RATE_TYPES.hourly\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tPer hour\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<a class="toggle-a s toggle-control-toggle primary" data-cy="pay-information-toggle-rate-type" href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\'active\': vm.teamMember.salary.RateType === EMPLOYMENT_RATE_TYPES.daily\n\t\t\t\t\t\t\t\t}" ng-click="toggleRateType(vm.teamMember.salary)"></a>\n\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\'active greyscale\': vm.teamMember.salary.RateType === EMPLOYMENT_RATE_TYPES.daily\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tPer day\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tEnter a rate for {{formOptions.context.Forename}} and we\'ll calculate an annual salary that can be used to calculate things like sick pay.\n\t\t\t\t\t\tPlease note that to use a daily rate, the hours on working days in {{formOptions.context.Forename}}\'s work pattern should be the same.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.salaryRate.$error" ng-show="payInformationForm.salaryRate.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\tMaximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}99\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-validation-maxlength-message" ng-message="maxlength">\n\t\t\t\t\t\t\tOnly {{$root.CONFIG.salaryRateMaxLength}} characters are allowed\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tMinimum of {{$root.CONFIG.numberMin | monetise}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter a rate\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Add rate change -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.teamMember.salary.SalaryFutureChanges.length < MAX_RATE_CHANGES">\n\t\t\t\t<button class="is-medium-large is-white is-block" data-cy="pay-information-add-rate-change" ng-click="addSalaryChange(vm, SALARY_FUTURE_CHANGE_TYPES.rate)" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i> Add a rate change\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t\t<!-- Rate change -->\n\t\t\t<div class="form-field" ng-if="vm.teamMember.salary.SalaryFutureChanges.length">\n\t\t\t\t<div class="form-field-options-box primary" ng-repeat="salaryFutureChange in vm.teamMember.salary.SalaryFutureChanges">\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<header class="form-intro-header">\n\t\t\t\t\t\t\t<h6>Rate change</h6>\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\tEnter a rate for {{formOptions.context.Forename}} and we\'ll calculate an annual salary that can be used to calculate things like sick pay.\n\t\t\t\t\t\t\t\tPlease note that to use a daily rate, the hours on working days in {{formOptions.context.Forename}}\'s work pattern should be the same.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a aria-label="Delete salary change" class="form-intro-action primary-light" data-cy="pay-information-delete-salary-change-{{$index}}" href="" ng-click="deleteSalaryChange(vm.teamMember.salary.SalaryFutureChanges, $index)">\n\t\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Rate -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="salaryRate" ng-class="{\n\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tRate:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t<!-- Daily Rate -->\n\t\t\t\t\t\t\t<input class="l monetise" id="salaryRate-{{$index}}" name="salaryRate-{{$index}}" ng-if="salaryFutureChange.RateType === EMPLOYMENT_RATE_TYPES.daily" ng-max="$root.CONFIG.number7Digits4Decimal" ng-maxlength="$root.CONFIG.salaryRateMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="salaryFutureChange.SalaryDailyRatePartTime" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\n\t\t\t\t\t\t\t<!-- Hourly Rate -->\n\t\t\t\t\t\t\t<input class="l monetise" id="salaryRate-{{$index}}" name="salaryRate-{{$index}}" ng-if="salaryFutureChange.RateType === EMPLOYMENT_RATE_TYPES.hourly" ng-max="$root.CONFIG.number7Digits4Decimal" ng-maxlength="$root.CONFIG.salaryRateMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="salaryFutureChange.SalaryHourlyRatePartTime" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\n\t\t\t\t\t\t\t&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t\t\t<div class="toggle-control primary">\n\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active greyscale\': salaryFutureChange.RateType === EMPLOYMENT_RATE_TYPES.hourly\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tHourly\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<a class="toggle-a s toggle-control-toggle primary" data-cy="pay-information-toggle-rate-type-{{$index}}" href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active\': salaryFutureChange.RateType === EMPLOYMENT_RATE_TYPES.daily\n\t\t\t\t\t\t\t\t\t}" ng-click="toggleRateType(salaryFutureChange)"></a>\n\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active greyscale\': salaryFutureChange.RateType === EMPLOYMENT_RATE_TYPES.daily\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tDaily\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.salaryRate.$error" ng-show="payInformationForm.salaryRate.$touched" role="alert">\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-{{$index}}-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\t\tMaximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}99\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-{{$index}}-validation-maxlength-message" ng-message="maxlength">\n\t\t\t\t\t\t\t\tOnly {{$root.CONFIG.salaryRateMaxLength}} characters are allowed\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-{{$index}}-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\tMinimum of {{$root.CONFIG.numberMin | monetise}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-rate-{{$index}}-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter a rate\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Effective Date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="salaryRateEffectiveDate" ng-class="{\n\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tEffective from date:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<date-input-field field-id="salaryRateEffectiveDate" field-min-date-iso="salaryFutureChange.SalaryChangeEffectiveDateMinISO" field-required="vm.teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="salaryFutureChange.SalaryEffectiveDateISO"></date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.salaryRateEffectiveDate.$error" ng-show="payInformationForm.salaryRateEffectiveDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-effective-date-{{$index}}-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\tPlease enter a date from {{salaryFutureChange.SalaryChangeEffectiveDateMinISO | dateformat}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="pay-information-salary-effective-date-{{$index}}-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease choose an effective date\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message fadeIn">{{salaryFutureChange.SalaryEffectiveDateISO | dateformat:\'long\'}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Salary (Regular or Non-regular with salary) -->\n\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.standard ||\n\t\t\t(\n\t\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.nonStandard &&\n\t\t\t\tvm.teamMember.salary.PaymentType === EMPLOYMENT_PAYMENT_TYPES.annualSalary\n\t\t\t)\n\t\t">\n\n\t\t<!-- Salary Amount -->\n\t\t<div class="form-field form-field-options-box primary form-field-options" ng-if="!vm.teamMember.salary.forceSalaryChange">\n\t\t\t<!-- Annual / Effective date -->\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Annual -->\n\t\t\t\t<div class="form-field" ng-if="formOptions.context.IsInSetupMode">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="yearlySalary" ng-class="{\n\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tAnnual salary:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<span class="form-field-header-info fadeIn" ng-if="vm.teamMember.salary.SalaryYearly > 1000">\n\t\t\t\t\t\t\t{{vm.teamMember.salary.SalaryYearly | abbrNum}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="field-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="yearlySalary" name="yearlySalary" ng-change="onAnnualSalaryChange(vm, vm.teamMember.salary)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{debounce:500}" ng-model="vm.teamMember.salary.SalaryYearly" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.yearlySalary.$error" ng-show="payInformationForm.yearlySalary.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="pay-information-yearly-salary-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\tMaximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-yearly-salary-validation-maxlength-message" ng-message="maxlength">\n\t\t\t\t\t\t\tOnly {{$root.CONFIG.salaryMaxLength}} characters are allowed\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-yearly-salary-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tMinimum of {{$root.CONFIG.numberMin | monetise}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="pay-information-yearly-salary-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter a salary or calculate it by entering an alternative salary\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Start date (new starter) -->\n\t\t\t\t<div class="form-field" ng-if="vm.isNewStarterStartDateInPast">\n\t\t\t\t\t<div class="fadeIn" ng-if="vm.teamMember.salary.SalaryYearly">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="startDate">Start date:</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-read-only="true" field-style="primary" field-value-iso="vm.teamMember.company.StartDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Current salary -->\n\t\t\t\t<div class="form-field" ng-if="!formOptions.context.IsInSetupMode">\n\t\t\t\t\t<h6>Current salary:</h6>\n\t\t\t\t\t<p class="is-font-primary-400">\n\t\t\t\t\t\t<span class="stronger">\n\t\t\t\t\t\t\t{{vm.teamMember.salary.SalaryYearly | monetise : null : null : { HIDE_CURRENCY_LABEL: true } }}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="vm.teamMember.salary.SalaryEffectiveDateISO">\n\t\t\t\t\t\t\t(effective {{vm.teamMember.salary.SalaryEffectiveDateISO | dateformat}})\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Effective Date (select) -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="\n\t\t\t\t\t\t!vm.isNewStarterStartDateInPast && hasSalaryChanged(vm) &&\n\t\t\t\t\t\tformOptions.company.State !== COMPANY_STATES.onboarding && !formOptions.context.IsInSetupMode\n\t\t\t\t\t">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="effectivedate" ng-class="{\n\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tEffective from date:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<select id="effectivedate" name="effectivedate" ng-model="vm.teamMember.salary.SalaryEffectiveDateISO" ng-options="date.dateISO as date.description group by date.month for date in vm.effectiveDateOptions" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired"></select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.effectivedate.$error" ng-show="payInformationForm.effectivedate.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="pay-information-" ng-message="required">\n\t\t\t\t\t\t\tPlease choose an effective date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message fadeIn">{{vm.teamMember.salary.SalaryEffectiveDateISO | dateformat:\'long\'}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Salary Breakdown -->\n\t\t\t<fieldset class="fadeIn" ng-show="vm.teamMember.salary.isSalaryBreakdownVisible">\n\t\t\t\t<salary-breakdown disabled="vm.teamMember.hasSalary || !formOptions.context.IsInSetupMode" form="payInformationForm" salary="vm.teamMember.salary" sb-id="salary" update-salary="updateBreakdownFromValue"></salary-breakdown>\n\t\t\t</fieldset>\n\n\t\t\t<div class="form-field-options-box-detail" ng-if="\n\t\t\t\t\t(vm.teamMember.hasSalary &&\tvm.teamMember.salary.isSalaryBreakdownVisible) ||\n\t\t\t\t\t!vm.teamMember.hasSalary &&\n\t\t\t\t\tvm.teamMember.salary.EmploymentType !== EMPLOYMENT_TYPES.nonStandard\n\t\t\t\t">\n\t\t\t\t<p class="s" ng-show="!vm.teamMember.hasSalary && !vm.teamMember.salary.isSalaryBreakdownVisible">\n\t\t\t\t\tMonthly, weekly, daily and hourly salaries will be calculated automatically.\n\t\t\t\t</p>\n\t\t\t\t<p class="s" ng-show="vm.teamMember.salary.isSalaryBreakdownVisible">\n\t\t\t\t\t<span ng-if="!vm.teamMember.hasSalary">Adjust a salary to see the change reflected in all other values.</span>\n\t\t\t\t\tSalaries are calculated based on {{formOptions.context.Forename}}\'s work pattern and day rate\n\t\t\t\t\tcalculation method ({{vm.teamMember.salary.ProRatingType | calculationMethodDescription}}).\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<a class="form-field-options-box-action" data-cy="pay-information-toggle-salary-breakdown" href="" ng-click="vm.teamMember.salary.isSalaryBreakdownVisible = !vm.teamMember.salary.isSalaryBreakdownVisible" ng-if="vm.teamMember.salary.EmploymentType !== EMPLOYMENT_TYPES.nonStandard">\n\t\t\t\t{{vm.teamMember.salary.isSalaryBreakdownVisible ? \'View less\' : \'View more\'}}\n\t\t\t\t<i class="icon-chevron-{{vm.teamMember.salary.isSalaryBreakdownVisible ? \'up\' : \'down\'}}"></i>\n\t\t\t</a>\n\n\t\t\t<!-- Backdated pay information -->\n\t\t\t<fieldset class="fadeIn" ng-if="\n\t\t\t\t\tvm.isNewStarterStartDateInPast &&\n\t\t\t\t\tvm.teamMember.salary.backdatedSalaryAmount > 0\n\t\t\t\t">\n\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-padding">\n\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tBased on the start date, and NI, student loan, and postgraduate loan calculation selected, the following backdated salary has been calculated for {{::formOptions.context.Forename}} and will be added to your current period:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<calculation-card amount="vm.teamMember.salary.backdatedSalaryAmount" busy="vm.teamMember.salary.backdatedSalaryState === \'loading\'" data-cy="pay-information-new-starter-backdated-calculation-card" title="Backdated salary"></calculation-card>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t\t<!-- Calculation method description -->\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t{{vm.teamMember.salary.StarterCalculationMethod | backdatedSalaryCalculationDescription : vm.isNewStarterStartDateInPast : formOptions.context.Forename}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<h6>How do you wish to calculate NI, student loan, and postgraduate loan?</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" data-cy="pay-information-new-starter-calculation-method-current-period" id="newStarterCalculationTypeCurrentOnly" name="newStarterCalculationType" ng-change="onNiCalculationUpdate(vm, vm.teamMember.salary)" ng-model="vm.teamMember.salary.StarterCalculationMethod" ng-value="BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="s" for="newStarterCalculationTypeCurrentOnly">\n\t\t\t\t\t\t\t\t\t\tApply to the current period only\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" data-cy="pay-information-new-starter-calculation-method-all-periods" id="newStarterCalculationTypeAllAffected" name="newStarterCalculationType" ng-change="onNiCalculationUpdate(vm, vm.teamMember.salary)" ng-model="vm.teamMember.salary.StarterCalculationMethod" ng-value="BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="s" for="newStarterCalculationTypeAllAffected">\n\t\t\t\t\t\t\t\t\t\tBackdate for all affected periods\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-padding">\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input checkbox data-cy="pay-information-new-starter-include-in-pay-run" id="starterCalculationInclude" label-text="\'Include in next pay run\'" name="starterCalculationInclude" ng-model="vm.teamMember.salary.StarterCalculationInclude" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tChecking this box means the payment can be included in your main pay run or a supplementary pay run if you wish to submit them sooner.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Rolled Up Holiday Pay">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tIf you chose to apply calculations for NI, student loan, and postgraduate loan contributions to\n\t\t\t\t\t\t\tall affected periods, these will only apply to {{formOptions.context.Forename}}\'s backdated salary.\n\t\t\t\t\t\t\tAny Rolled Up Holiday Pay due on their backdated salary for each affected period will be excluded\n\t\t\t\t\t\t\tfrom the calculations.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\n\t\t\t</fieldset>\n\t\t</div>\n\n\t\t<!-- Add Salary Change -->\n\t\t<div class="form-field fadeIn" ng-if="\n\t\t\t\tvm.teamMember.salary.SalaryFutureChanges.length < MAX_SALARY_CHANGES &&\n\t\t\t\t!vm.teamMember.salary.forceSalaryChange\n\t\t\t">\n\t\t\t<button class="is-medium-large is-white is-block" data-cy="pay-information-add-a-salary-change" ng-click="addSalaryChange(vm, SALARY_FUTURE_CHANGE_TYPES.salary)" type="button">\n\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add a salary change\n\t\t\t</button>\n\t\t</div>\n\n\t\t<!-- Salary Change -->\n\t\t<div class="form-field fadeIn" ng-if="vm.teamMember.salary.SalaryFutureChanges.length">\n\t\t\t<!-- Salary Changes -->\n\t\t\t<div class="form-field-highlight primary" ng-repeat="(salaryFutureChangeIndex, salaryFutureChange) in vm.teamMember.salary.SalaryFutureChanges">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<header class="form-intro-header">\n\t\t\t\t\t\t<h5>Salary change</h5>\n\t\t\t\t\t\t<p class="s" ng-if="!salaryFutureChange.isRequired">\n\t\t\t\t\t\t\tAdd a new annual salary and choose an effective date and the change will be automatically applied in the respective pay period.\n\t\t\t\t\t\t\t<a ng-href="{{$root.URLS.paycircle.support.salaryChangeChange}}" ng-if="$root.URLS.paycircle.support.salaryChangeChange" target="_blank">\n\t\t\t\t\t\t\t\tRead more here\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" ng-if="salaryFutureChange.isRequired">\n\t\t\t\t\t\t\tAdd a new annual salary. This will be applied in the current pay period ({{vm.currentPayPeriod.StartDateISO | dateformat}}).\n\t\t\t\t\t\t\t<a ng-href="{{$root.URLS.paycircle.support.salaryChangeChange}}" ng-if="$root.URLS.paycircle.support.salaryChangeChange" target="_blank">\n\t\t\t\t\t\t\t\tRead more here\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a aria-label="Delete salary change" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-delete" class="form-intro-action primary-light" href="" ng-click="deleteSalaryChange(vm.teamMember.salary.SalaryFutureChanges, $index)" ng-if="!vm.teamMember.salary.forceSalaryChange">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t<div class="form-field" ng-if="salaryFutureChange.isNewSalaryChange">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-list is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" id="salaryChangeType-fixedValue" name="salaryChangeType" ng-model="salaryFutureChange.salaryChangeType" ng-value="SALARY_CHANGE_TYPES.fixedValue" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="salaryChangeType-fixedValue">Fixed value</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b" id="salaryChangeType-percentage" name="salaryChangeType" ng-model="salaryFutureChange.salaryChangeType" ng-value="SALARY_CHANGE_TYPES.percentage" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="salaryChangeType-percentage">Percentage</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Annual / Effective date -->\n\t\t\t\t\t<div ng-switch="salaryFutureChange.salaryChangeType" ng-class="{\n\t\t\t\t\t\t\t\'form-field-group\': salaryFutureChange.salaryChangeType === SALARY_CHANGE_TYPES.fixedValue,\n\t\t\t\t\t\t\t\'form-field\': salaryFutureChange.salaryChangeType === SALARY_CHANGE_TYPES.percentage\n\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t<!-- Fixed Value-->\n\t\t\t\t\t\t<div class="form-field fadeIn" pc-switch-when="SALARY_CHANGE_TYPES.fixedValue">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="futureYearlySalary" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tAnnual salary:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<span class="form-field-header-info fadeIn" ng-if="salaryFutureChange.SalaryYearly > 1000">\n\t\t\t\t\t\t\t\t\t{{salaryFutureChange.SalaryYearly | abbrNum}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="futureYearlySalary" name="futureYearlySalary" ng-change="onAnnualSalaryChange(vm, salaryFutureChange)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model-options="{debounce: 500}" ng-model="salaryFutureChange.SalaryYearly" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.futureYearlySalary.$error" ng-show="payInformationForm.futureYearlySalary.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a salary or calculate it by entering an alternative salary</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- %age -->\n\t\t\t\t\t\t<div class="form-field fadeIn" pc-switch-when="SALARY_CHANGE_TYPES.percentage">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="salaryChangePercentage">Salary change (%):</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="percentage s" id="salaryChangePercentage" max="9999" min="0" name="salaryChangePercentage" ng-change="onSalaryChangePercentageChange(vm, salaryFutureChange)" ng-model="salaryFutureChange.salaryChangePercentage" ng-model-options="{\n\t\t\t\t\t\t\t\t\t\tdebounce: 500\n\t\t\t\t\t\t\t\t\t}" ng-pattern="$root.REGEX.decimalFourPlaces" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\n\t\t\t\t\t\t\t\t<!-- Pattern Type -->\n\t\t\t\t\t\t\t\t<div class="toggle-control primary is-inline is-inline-block no-wrap">\n\t\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'active greyscale\': salaryFutureChange.isSalaryChangePercentageIncrease\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\tIncrease\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<a class="toggle-a s toggle-control-toggle primary" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-toggle-percentage-multiplier" href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'active\': !salaryFutureChange.isSalaryChangePercentageIncrease\n\t\t\t\t\t\t\t\t\t\t}" ng-click="toggleSalaryChangePercentageMultiplier(vm, salaryFutureChange)"></a>\n\t\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'active greyscale\': !salaryFutureChange.isSalaryChangePercentageIncrease\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\tDecrease\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.salaryChangePercentage.$error" ng-show="payInformationForm.salaryChangePercentage.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Percentage change should be no more than 9999</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Percentage change should be no less than 0</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid percentage with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a percentage</p>\n\t\t\t\t\t\t\t\t<p ng-message="step">Please enter a percentage up to 2 decimal places</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Percentage Salary Change-->\n\t\t\t\t\t\t<fieldset class="form-field-highlight is-primary-lightest is-small is-compact fadeIn" ng-if="\n\t\t\t\t\t\t\t\tsalaryFutureChange.salaryChangeType === SALARY_CHANGE_TYPES.percentage &&\n\t\t\t\t\t\t\t\tsalaryFutureChange.salaryChangePercentage\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<h6 class="float-left primary-dark">New salary:</h6>\n\t\t\t\t\t\t\t<span class="float-right primary-dark stronger">{{salaryFutureChange.SalaryYearly | monetise}}</span>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Effective Date -->\n\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="!salaryFutureChange.isRequired">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="futureEffectiveDate" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\tEffective from date:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<date-input-field field-disabled="salaryFutureChange.isRequired" field-id="futureEffectiveDate" field-min-date-iso="salaryFutureChange.effectiveDateMinISO" field-on-change-fn="reviewBackdatedSalaryCalculation(vm)" field-required="vm.teamMember.isTeamMemberSetupFieldsRequired" field-style="{{salaryFutureChange.salaryChangeType === SALARY_CHANGE_TYPES.percentage ? \'l\' : \'\' }}" field-value-iso="salaryFutureChange.SalaryEffectiveDateISO"></date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.futureEffectiveDate.$error" ng-show="payInformationForm.futureEffectiveDate.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date from {{salaryFutureChange.effectiveDateMinISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please choose an effective date</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message fadeIn">{{salaryFutureChange.SalaryEffectiveDateISO | dateformat:\'long\'}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Salary Breakdown -->\n\t\t\t\t\t<fieldset class="fadeIn" ng-show="salaryFutureChange.isSalaryBreakdownVisible">\n\t\t\t\t\t\t<salary-breakdown form="payInformationForm" salary="salaryFutureChange" sb-id="{{\'future_change_\' + salaryFutureChangeIndex}}" update-salary="updateBreakdownFromValue"></salary-breakdown>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="form-field-options-box-detail">\n\t\t\t\t\t\t<p class="s" ng-show="!salaryFutureChange.isSalaryBreakdownVisible">\n\t\t\t\t\t\t\tMonthly, weekly, daily and hourly salaries will be calculated automatically.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" ng-show="salaryFutureChange.isSalaryBreakdownVisible">\n\t\t\t\t\t\t\tAdjust a salary to see the change reflected in all other values. Salaries are calculated based on {{formOptions.company.Name}}\'s work hours\n\t\t\t\t\t\t\tper week ({{formOptions.company.WorkHoursPerWeek}}hrs) and {{formOptions.context.Forename}}\'s day rate calculation\n\t\t\t\t\t\t\tmethod ({{vm.teamMember.salary.ProRatingType | calculationMethodDescription}}).\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<a class="s" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-toggle-salary-breakdown" href="" ng-click="toggleIsSalaryBreakdownVisible(salaryFutureChange)">\n\t\t\t\t\t\t{{salaryFutureChange.isSalaryBreakdownVisible ? \'View less\' : \'View more\'}}\n\t\t\t\t\t\t<i class="icon-chevron-{{salaryFutureChange.isSalaryBreakdownVisible ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- Backdated pay information -->\n\t\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-padding fadeIn" ng-if="salaryFutureChange.isBackdatedSalary">\n\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tBased on the effective date, and tax, NI, student loan, and postgraduate loan calculation selected, the following backdated salary has been calculated for {{formOptions.context.Forename}} and will be\n\t\t\t\t\t\t\t\tadded to your current period:\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<calculation-card amount="salaryFutureChange.backdatedSalary.BackdatedSalaryAmount" busy="salaryFutureChange.backdatedSalaryState === \'loading\'" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-backdated-calculation-card" title="Backdated salary"></calculation-card>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<settings-row data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-backdated-salary-derived-elements-toggle" ng-if="salaryFutureChange.CalculationMethod === BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod && vm.backdatedSalaryDerivedElementsEnabled" ng-model="salaryFutureChange.BackdateSalaryDerivedElements" on-update="reviewBackdatedSalaryCalculation(vm, salaryFutureChange)" sr-field-name="backdateSalaryDerivedElements" sr-label="Backdated salary derived elements">\n\t\t\t\t\t\t\t<sr-description>Select whether to proceed with any identified backdated salary derived elements for this salary change. These additional changes can be updated or removed afterwards if necessary</sr-description>\n\t\t\t\t\t\t</settings-row>\n\t\t\t\t\t\t<div class="form-field" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-backdated-salary-derived-elements" ng-if="getShowBackdatedSalaryDerivedElements(vm, salaryFutureChange) && salaryFutureChange.BackdateSalaryDerivedElements">\n\t\t\t\t\t\t\t<div ng-repeat="(backdatedElementIndex, backdatedElement) in salaryFutureChange.backdatedSalary.BackdatedElements">\n\t\t\t\t\t\t\t\t<calculation-card data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-backdated-element-{{backdatedElementIndex}}" amount="getBackdatedSalaryDerivedElementValueForDisplay(backdatedElement)" busy="salaryFutureChange.backdatedSalaryState === \'loading\'" title="{{backdatedElement.Label}}"></calculation-card>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t\t\t<!-- Calculation method description -->\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t{{salaryFutureChange.CalculationMethod | backdatedSalaryCalculationDescription : vm.isNewStarterStartDateInPast : formOptions.context.Forename}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<h6>How do you wish to calculate tax, NI, student loan, and postgraduate loan?</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-calculation-method-current-period" id="calculationTypeCurrentOnly" name="calculationType" ng-change="reviewBackdatedSalaryCalculation(vm, salaryFutureChange)" ng-model="salaryFutureChange.CalculationMethod" ng-value="BACKDATED_SALARY_CALCULATION_METHODS.applyToCurrentPeriod" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="s" for="calculationTypeCurrentOnly">\n\t\t\t\t\t\t\t\t\t\t\tApply to the current period only\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input class="b" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-calculation-method-all-periods" id="calculationTypeAllAffected" name="calculationType" ng-change="reviewBackdatedSalaryCalculation(vm, salaryFutureChange)" ng-model="salaryFutureChange.CalculationMethod" ng-value="BACKDATED_SALARY_CALCULATION_METHODS.applyAsBackdatedCalculation" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="s" for="calculationTypeAllAffected">\n\t\t\t\t\t\t\t\t\t\t\tBackdate for all affected periods\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<p class="form-message normal primary" ng-switch="salaryFutureChange.backdatedSalaryState">\n\t\t\t\t\t\t\t\t<span ng-switch-when="loading">\n\t\t\t\t\t\t\t\t\t<i class="spin icon-loading m"></i>&nbsp;&nbsp;Calculating backdated calculations\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-switch-when="ready">\n\t\t\t\t\t\t\t\t\t<i class="icon-back m is-primary"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<a class="underline" data-cy="pay-information-salary-change-{{salaryFutureChangeIndex}}-show-backdated-calculations" href="" ng-click="showBackdatedSalaryCalculations(salaryFutureChange)">\n\t\t\t\t\t\t\t\t\t\tPreview backdated calculations\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<div class="form-field fadeIn" ng-if="salaryFutureChange.isBackdatedSalary">\n\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Pension contributions shortfall">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}}\'s earlier pension contributions may have been too low. If you chose to backdate tax, NI, student loan, and postgraduate loan calculations,\n\t\t\t\t\t\t\t\t\twe recommend adding a \'Pension\' deduction for the shortfall.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Rolled Up Holiday Pay">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tRolled Up Holiday Pay will only be calculated on {{formOptions.context.Forename}}\'s backdated salary if\n\t\t\t\t\t\t\t\t\tyou chose to apply calculations for tax, NI, student loan, and postgraduate\n\t\t\t\t\t\t\t\t\tloan contributions to the current period. If you chose to backdate the\n\t\t\t\t\t\t\t\t\tcalculations, any changes to their Rolled Up Holiday Pay will need to be made\n\t\t\t\t\t\t\t\t\tmanually using the preview pay statement override.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Backdated salary for new starters -->\n\t\t<div class="form-field fadeIn" ng-if="\n\t\t\t\tvm.teamMember.company.IsStarter &&\n\t\t\t\t!vm.teamMember.company.StartDateISO\n\t\t\t">\n\t\t\t<note note-dismiss-key="pay-information-backdated-salary" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Backdated salary for new starters">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tBackdated salary for new starters with a start date in the past will be automatically calculated if they have an annual salary in their pay information.\n\t\t\t\t\t\tYou can then decide if you wish to include the backdated salary in your main pay run or supplementary pay run, if you wish to submit them sooner.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Calculation method -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="dayRateCalculation" ng-class="{\n\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t}">\n\t\t\t\t\tDay rate calculation method:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="block" id="dayRateCalculation" name="dayRateCalculation" ng-change="onDayRateCalculationUpdate(vm)" ng-model="vm.teamMember.salary.ProRatingType" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | orderBy:\'description\'" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired">\n\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="vm.teamMember.salary.ProRatingType === 16">\n\t\t\t<info-block ib-theme="indifferent has-icon has-plain-type">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-support indifferent-darkened info-block-icon"></i>\n\t\t\t\t\t\t<h6>Annualised days calculation</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">The calculation will be based on {{formOptions.context.Forename}}\'s work pattern.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Net Pay -->\n\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.netPay\n\t\t">\n\t\t<!-- Net pay per period -->\n\t\t<div class="form-field-highlight primary">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="netPay" ng-class="{\n\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tNet pay per {{vm.currentPayPeriod.PeriodType | payPeriodTypeDescription:\'month\'}}\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input autocomplete="off" class="monetise" id="netPay" name="yearlySalary" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="vm.teamMember.salary.SalaryYearly" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm.yearlySalary.$error" ng-show="payInformationForm.yearlySalary.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="maxlength">Only {{$root.CONFIG.salaryMaxLength}} characters are allowed</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter a net payment amount</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.netToGross" underline="true">\n\t\t\t\t\t\tRead more about adding salaries as Net pay.\n\t\t\t\t\t</support-article-link>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Rates -->\n\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="\n\t\t\t![EMPLOYMENT_TYPES.paidHourly, EMPLOYMENT_TYPES.payPolicy].includes(vm.teamMember.salary.EmploymentType)\n\t\t">\n\t\t<!-- Overtime Rates -->\n\t\t<div class="form-field form-field-options-box primary form-field-options">\n\n\t\t\t<div class="form-intro has-action">\n\t\t\t\t<h5>Overtime rates</h5>\n\t\t\t\t<p class="s">\n\t\t\t\t\tAdd hourly and daily overtime rates to use for calculating things like back pay, unpaid leave, notice pay, holiday pay and overtime.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Hourly rate -->\n\t\t\t\t<div class="form-field" ng-if="!vm.teamMember.salary.hasSalaryHourlyRateOvertime">\n\t\t\t\t\t<button class="is-medium-large is-white is-primary-100 is-block" data-cy="pay-information-add-a-hourly-rate" ng-click="toggleHasOvertimeRateHourly(vm)" type="button">\n\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add a hourly rate\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field fadeIn" ng-if="vm.teamMember.salary.hasSalaryHourlyRateOvertime">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="hourlyRate" ng-class="{\n\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tHourly rate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<a aria-label="Reset overtime hourly rate" class="form-field-header-action primary-light" data-cy="pay-information-reset-overtime-hourly-rate" href ng-click="toggleHasOvertimeRateHourly(vm)">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise" id="hourlyRate" name="hourlyRate" ng-max="$root.CONFIG.number7Digits4Decimal" ng-min="$root.CONFIG.numberMin" ng-model="vm.teamMember.salary.SalaryHourlyRateOvertime" ng-pattern="$root.REGEX.number7Digits4Decimal" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" placeholder="0.00" type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.hourlyRate.$touched" ng-messages="payInformationForm.hourlyRate.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}99</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Daily rate -->\n\t\t\t\t<div class="form-field" ng-if="!vm.teamMember.salary.hasSalaryDailyRateOvertime">\n\t\t\t\t\t<button class="is-medium-large is-white is-primary-100 is-block" data-cy="pay-information-add-a-daily-rate" ng-click="toggleHasOvertimeRateDaily(vm)" type="button" ng-if="!vm.teamMember.salary.hasSalaryDailyRateOvertime">\n\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add a daily rate\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field fadeIn" ng-if="vm.teamMember.salary.hasSalaryDailyRateOvertime">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="dailyRate" ng-class="{\n\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\tDaily rate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<a aria-label="Reset overtime daily rate" class="form-field-header-action primary-light" data-cy="pay-information-reset-overtime-daily-rate" href ng-click="toggleHasOvertimeRateDaily(vm)">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise" id="dailyRate" name="dailyRate" ng-max="$root.CONFIG.number7Digits4Decimal" ng-min="$root.CONFIG.numberMin" ng-model="vm.teamMember.salary.SalaryDailyRateOvertime" ng-pattern="$root.REGEX.number7Digits4Decimal" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" placeholder="0.00" type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.dailyRate.$touched" ng-messages="payInformationForm.dailyRate.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}99</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Additional Rates -->\n\t\t<div class="form-field form-field-options-box primary form-field-options">\n\n\t\t\t<div class="form-intro has-action">\n\t\t\t\t<h5>Additional rates</h5>\n\t\t\t\t<p class="s">\n\t\t\t\t\tAdd additional hourly and daily rates so they\'re available when adding changes to payroll.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="rate-generator">\n\n\t\t\t\t<!-- Rates -->\n\t\t\t\t<section class="rate-generator_section" ng-if="vm.teamMember.salary.SalaryRates.length">\n\t\t\t\t\t<div class="rate-generator_items">\n\n\t\t\t\t\t\t<div class="rate-generator_item has-delete-action dropIn fast" ng-repeat="rate in vm.teamMember.salary.SalaryRates">\n\t\t\t\t\t\t\t<!-- Description -->\n\t\t\t\t\t\t\t<div class="rate-generator_item-field is-first is-extra-large">\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="salaryRateDescription-{{$index}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\tRate name\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input id="salaryRateDescription-{{$index}}" name="salaryRateDescription-{{$index}}" ng-model="rate.SalaryRateDescription" ng-pattern="$root.REGEX.description" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" placeholder="Enter a rate name" type="text">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="payInformationForm[\'salaryRateDescription-\' + $index].$error" ng-if="payInformationForm[\'salaryRateDescription-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">No special characters</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t\t<div class="rate-generator_item-field">\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="salaryRate-{{$index}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\tRate\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<div class="input-warning-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t<input class="l monetise" id="salaryRate-{{$index}}" name="salaryRate-{{$index}}" ng-max="$root.CONFIG.number7Digits4Decimal" ng-min="$root.CONFIG.numberMin" ng-model="rate.SalaryRateValue" ng-pattern="$root.REGEX.number7Digits4Decimal" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'salaryRate-\' + $index].$touched" ng-messages="payInformationForm[\'salaryRate-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits2Decimal | monetise}}99</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Delete -->\n\t\t\t\t\t\t\t<div class="rate-generator_item-delete">\n\t\t\t\t\t\t\t\t<a aira-label="Delete additional rate" href="" data-cy="pay-information-additional-rate-{{$index}}-delete-rate" ng-click="deleteSalaryRate(vm.teamMember.salary.SalaryRates, rate.SalaryRateID)">\n\t\t\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Add an additional rate -->\n\t\t\t\t<section class="rate-generator_section is-borderless">\n\t\t\t\t\t<button class="is-medium-large is-white is-primary-100 is-block" data-cy="pay-information-add-an-additional-rate" ng-click="addSalaryRate(vm.teamMember.salary.SalaryRates)" type="button">\n\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add an additional rate\n\t\t\t\t\t</button>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Hourly -->\n\t<fieldset class="fadeIn" ng-if="vm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.paidHourly">\n\t\t<div class="form-section">\n\t\t\t<p class="is-small">\n\t\t\t\tHours worked can always be adjusted each period and the rate name will appear on {{formOptions.context.Forename}}&rsquo;s payslip.\n\t\t\t\tTo allocate the costs for a rate to a different set of business categories toggle the override on.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<div class="form-field-options-box primary">\n\n\t\t\t\t<div class="rate-generator">\n\n\t\t\t\t\t<!-- Default Rate -->\n\t\t\t\t\t<section class="rate-generator_section">\n\n\t\t\t\t\t\t<header class="rate-generator_header">\n\t\t\t\t\t\t\t<div class="rate-generator_header-content">\n\t\t\t\t\t\t\t\t<h5>Standard hourly rate</h5>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tThis will be used for calculating things like back pay and unpaid leave.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<main class="rate-generator_main">\n\n\t\t\t\t\t\t\t<div class="rate-generator_items" ng-repeat="rate in vm.teamMember.salary.SalaryRates | filter: { SalaryRateDefault: true }">\n\t\t\t\t\t\t\t\t<div class="rate-generator_item">\n\t\t\t\t\t\t\t\t\t<!-- Rate name -->\n\t\t\t\t\t\t\t\t\t<div class="rate-generator_item-field is-first is-large">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRateDescriptionDefault" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\tName:\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t\t<input id="salaryRateDescriptionDefault" name="salaryRateDescriptionDefault" ng-model="rate.SalaryRateDescription" ng-pattern="$root.REGEX.description" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" placeholder="Standard rate" type="text">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.salaryRateDescriptionDefault.$touched" ng-messages="payInformationForm.salaryRateDescriptionDefault.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">No special characters</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Hourly Rate -->\n\t\t\t\t\t\t\t\t\t<div class="rate-generator_item-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRateDefault" class="required">\n\t\t\t\t\t\t\t\t\t\t\t\t\tRate:\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-main" tooltip tooltip-position="top" tooltip-text="{{vm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tnmwWarning:vm.teamMember.salary.SalaryMinimumWageDetails.SalaryNationalMinimumWage}}" tooltip-visible="{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t!vm.teamMember.company.IsDirectorInTaxYear &&\n\t\t\t\t\t\t\t\t\t\t\t\t\trate.isBelowNMW &&\n\t\t\t\t\t\t\t\t\t\t\t\t\tvm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType !== NMW_CATEGORIES.notApplicable ? \'true\' : \'false\'\n\t\t\t\t\t\t\t\t\t\t\t\t}}">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="input-warning-wrapper" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'tertiary\': rate.isBelowNMW && !vm.teamMember.company.IsDirectorInTaxYear &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType === NMW_CATEGORIES.over22,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'indifferent\': rate.isBelowNMW && !vm.teamMember.company.IsDirectorInTaxYear &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType !== NMW_CATEGORIES.over22\n\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="l monetise" id="salaryRateDefault" name="salaryRateDefault" ng-change="checkNMWHourlyRate(rate, vm.teamMember.salary)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="$root.CONFIG.hourlyRateMin" ng-model="rate.SalaryRateValue" ng-pattern="::regexService.salaryRatesRegEx" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.salaryRateDefault.$touched" ng-messages="payInformationForm.salaryRateDefault.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.hourlyRateMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Standard Hours -->\n\t\t\t\t\t\t\t\t\t<div class="rate-generator_item-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRateHoursDefault" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\tHours:\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t\t<number-selector-field field-name="salaryRateHoursDefault" field-required="vm.teamMember.isTeamMemberSetupFieldsRequired" max="$root.CONFIG.number7Digits4Decimal" ng-model="rate.SalaryRateHours" ng-regex-key="decimalFourPlaces" theme="is-block"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm.salaryRateHoursDefault.$touched" ng-messages="payInformationForm.salaryRateHoursDefault.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits4Decimal}}</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.numberMin}}</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="rate-generator_footer">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<toggle-input field-label="Override business categories" field-model="rate.overrideBusinessCategories" field-name="salaryRateOverrideBusinessCategories" field-on-change="onBusinessCategoriesOverrideChange(rate)" field-style="has-active-label" field-theme-active="is-primary" field-theme-inactive="is-primary-200">\n\t\t\t\t\t\t\t\t\t\t\t</toggle-input>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="rate.overrideBusinessCategories">\n\t\t\t\t\t\t\t\t\t\t<business-categories-override business-categories="rate.businessCategories" user-forename="formOptions.context.Forename">\n\t\t\t\t\t\t\t\t\t\t</business-categories-override>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</main>\n\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Additional Rates -->\n\t\t<div class="form-section fadeIn" ng-if="vm.teamMember.salary.SalaryRates.length > 1">\n\n\t\t\t<div class="form-field-options-box primary" ng-repeat="rate in vm.teamMember.salary.SalaryRates | filter: { SalaryRateDefault: false } ">\n\n\t\t\t\t<div class="rate-generator">\n\n\t\t\t\t\t<section class="rate-generator_section">\n\n\t\t\t\t\t\t<header class="rate-generator_header">\n\n\t\t\t\t\t\t\t<div class="rate-generator_header-content">\n\t\t\t\t\t\t\t\t<h5>Additional rate</h5>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="rate-generator_header-action">\n\n\t\t\t\t\t\t\t\t<div class="fadeIn">\n\t\t\t\t\t\t\t\t\t<div ng-if="!rate.confirmDelete">\n\t\t\t\t\t\t\t\t\t\t<a aria-label="Delete additional hourly rate" class="s primary" href="" ng-click="toggleConfirmDeleteAdditionalHourlyRate(rate)">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div ng-if="rate.confirmDelete">\n\t\t\t\t\t\t\t\t\t\t<p class="s strong">\n\t\t\t\t\t\t\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="deleteSalaryRate(vm.teamMember.salary.SalaryRates, rate.SalaryRateID)">\n\t\t\t\t\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="toggleConfirmDeleteAdditionalHourlyRate(rate)">\n\t\t\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<main class="rate-generator_main">\n\n\t\t\t\t\t\t\t<div class="rate-generator_item">\n\n\t\t\t\t\t\t\t\t<!-- Description -->\n\t\t\t\t\t\t\t\t<div class="rate-generator_item-field is-first is-large">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRateDescription-{{$index}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\tName:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<input id="salaryRateDescription-{{$index}}" name="salaryRateDescription-{{$index}}" ng-model="rate.SalaryRateDescription" ng-pattern="$root.REGEX.description" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" placeholder="Enter a rate name" type="text">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'salaryRateDescription-\' + $index].$touched" ng-messages="payInformationForm[\'salaryRateDescription-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">No special characters</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Rate -->\n\t\t\t\t\t\t\t\t<div class="rate-generator_item-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRate-{{$index}}" ng-class="{ \'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\t\t\t\tRate:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main" tooltip tooltip-position="top" tooltip-text="{{vm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType | nmwWarning:vm.teamMember.salary.SalaryMinimumWageDetails.SalaryNationalMinimumWage}}" tooltip-visible="{{!vm.teamMember.company.IsDirectorInTaxYear && rate.isBelowNMW && vm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType !== NMW_CATEGORIES.notApplicable ? \'true\' : \'false\'}}">\n\t\t\t\t\t\t\t\t\t\t\t<div class="input-warning-wrapper" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'tertiary\': rate.isBelowNMW && !vm.teamMember.company.IsDirectorInTaxYear && vm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType === NMW_CATEGORIES.over22,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'indifferent\': rate.isBelowNMW && !vm.teamMember.company.IsDirectorInTaxYear && vm.teamMember.salary.SalaryMinimumWageDetails.SalaryMinimumWageAgeType !== NMW_CATEGORIES.over22\n\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="l monetise" id="salaryRate-{{$index}}" name="salaryRate-{{$index}}" ng-change="checkNMWHourlyRate(rate, vm.teamMember.salary)" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="$root.CONFIG.hourlyRateMin" ng-model="rate.SalaryRateValue" ng-pattern="::regexService.salaryRatesRegEx" ng-required="vm.teamMember.isTeamMemberSetupFieldsRequired" type="number">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'salaryRate-\' + $index].$touched" ng-messages="payInformationForm[\'salaryRate-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.hourlyRateMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Hours -->\n\t\t\t\t\t\t\t\t<div class="rate-generator_item-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="salaryRateHours-{{$index}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'required\' : vm.teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\tHours:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<number-selector-field field-name="salaryRateHours-{{$index}}" field-required="vm.teamMember.isTeamMemberSetupFieldsRequired" max="$root.CONFIG.number7Digits4Decimal" ng-model="rate.SalaryRateHours" ng-regex-key="decimalFourPlaces" theme="is-block"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="payInformationForm[\'salaryRateHours-\' + $index].$touched" ng-messages="payInformationForm[\'salaryRateHours-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits4Decimal}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.numberMin}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\n\t\t\t\t\t\t<div class="rate-generator_footer">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<toggle-input field-label="Override business categories" field-model="rate.overrideBusinessCategories" field-name="salaryRateOverrideBusinessCategories-{{$index}}" field-on-change="onBusinessCategoriesOverrideChange(rate)" field-style="has-active-label" field-theme-active="is-primary" field-theme-inactive="is-primary-200">\n\t\t\t\t\t\t\t\t\t</toggle-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field fadeIn" data-cy="pay-information-hourly-rate-{{$index}}-delete-rate" ng-if="rate.overrideBusinessCategories">\n\t\t\t\t\t\t\t\t<business-categories-override business-categories="rate.businessCategories" user-forename="formOptions.context.Forename">\n\t\t\t\t\t\t\t\t</business-categories-override>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Add an additional rate -->\n\t\t<div class="form-section">\n\t\t\t<button class="is-medium-large is-white is-block" data-cy="pay-information-add-an-additional-rate-2" ng-click="addSalaryRate(vm.teamMember.salary.SalaryRates, true)" type="button">\n\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add additional rate\n\t\t\t</button>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Tax and NI settings (Expats && Net Pay || Standard Pattern) -->\n\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="\n\t\t\tvm.teamMember.company.IsExpatriate &&\n\t\t\t[EMPLOYMENT_TYPES.netPay, EMPLOYMENT_TYPES.standard].includes(vm.teamMember.salary.EmploymentType)\n\t\t">\n\t\t<pay-information-tax-ni-fieldset is-required="vm.teamMember.isTeamMemberSetupFieldsRequired" team-member="vm.teamMember"></pay-information-tax-ni-fieldset>\n\t</fieldset>\n\n\t<!-- Calculation settings (All employment types but pay policy) -->\n\t<fieldset class="form-fieldset-divider-top" ng-if="vm.teamMember.salary.EmploymentType !== EMPLOYMENT_TYPES.payPolicy">\n\t\t<pay-information-calculations-fieldset agency-profile-id="formOptions.agencyProfileId" team-member="vm.teamMember"></pay-information-calculations-fieldset>\n\t</fieldset>\n\n\t<!-- Pay policy - no annual salary policies available -->\n\t<fieldset class="fadeIn" ng-if="\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy &&\n\t\t\tvm.annualSalaryPoliciesCount === 0\n\t\t">\n\t\t<placeholder placeholder-graphic="no-pay-policies" placeholder-graphic-size="l">\n\t\t\t<placeholder-title>No annual salary policies available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\tOnce you\u2019ve added your pay policies they will be available here so you can continue setting pay information for {{::formOptions.context.Forename}}.\n\t\t\t\t\tYou\'ll need at least one annual salary pay policy to continue.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<p class="stronger s">\n\t\t\t\t\t<a class="is-primary bold" href="" ui-sref="hr.policies.pay({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\t\tGo to pay policies&nbsp;<i class="icon-chevron-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</fieldset>\n\n\t<!-- Pay policy - annual salary policies -->\n\t<fieldset class="fadeIn" ng-if="\n\t\t\tvm.teamMember.salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy &&\n\t\t\tvm.annualSalaryPoliciesCount !== 0\n\t\t">\n\t\t<h5 class="form-section-subheading">Pay</h5>\n\t\t<div class="form-section">\n\n\t\t\t<!-- Update pending message for annual salary policy when applicable -->\n\t\t\t<div class="form-section smaller-margin" ng-if="vm.teamMember.salary.annualSalaryPolicy.IsPolicyUpdatePending">\n\t\t\t\t<note note-icon="icon-information" note-theme="tertiary" note-title="Policy update">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">A policy update has been added for the \'{{vm.teamMember.salary.annualSalaryPolicy.PolicyName}}\'\n\t\t\t\t\t\t\tpay policy and {{formOptions.context.Forename}}\'s pay has been updated.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Annual salary policy\n\t\t\t\t (effective date not editable, but displayed for a new starter. In the case of non-new starters in setup mode, the\n\t\t\t\t  effective date is blank, which the platform interprets as being the start of the current period (or ignores) -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="false" allow-edit-effective-date="false" backdated-salary-derived-elements-enabled="vm.backdatedSalaryDerivedElementsEnabled" company="vm.company" current-pay-period="vm.currentPayPeriod" get-backdated-salary-derived-element-value-for-display="getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj)" id="payPolicyAnnualSalary_{{$index}}" mode="vm.teamMember.salary.annualSalaryPolicy.HasBeenPaid ? SALARY_POLICY_FORM_FIELD_MODES.view : SALARY_POLICY_FORM_FIELD_MODES.edit" on-add-change="addSalaryChange(vm, SALARY_FUTURE_CHANGE_TYPES.policy)" on-error="onError" pay-policies="vm.payPolicies" salary-policy="vm.teamMember.salary.annualSalaryPolicy" salary="vm.teamMember.salary" show-add-change="vm.teamMember.salary.annualSalaryPolicy.HasBeenPaid && vm.teamMember.salary.SalaryFutureChanges.length === 0" show-effective-date="!vm.teamMember.personal.IsInSetupMode" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\n\t\t\t<!-- Annual salary policy - additional form field when adding a change.\n\t\t\t     (effective date editable and displayed unless this represent a policy update; deleteable only\n\t\t\t\t if it doesn\'t represent an automatic pay policy update) -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="!salaryFutureChange.Policy.IsPolicyUpdatePending" allow-edit-effective-date="!salaryFutureChange.Policy.IsPolicyUpdatePending" backdated-salary-derived-elements-enabled="vm.backdatedSalaryDerivedElementsEnabled" company="vm.company" current-pay-period="vm.currentPayPeriod" get-backdated-salary-derived-element-value-for-display="getBackdatedSalaryDerivedElementValueForDisplay(backdatedElementObj)" id="payPolicyAnnualSalaryPayChange_{{$index}}" mode="SALARY_POLICY_FORM_FIELD_MODES.addChange" ng-repeat="(salaryFutureChangeIndex, salaryFutureChange) in vm.teamMember.salary.SalaryFutureChanges" on-delete="deletePayPolicyChange(vm.teamMember.salary)" on-error="onError" pay-policies="vm.payPolicies" salary-future-change="salaryFutureChange" salary-policy="salaryFutureChange.Policy" salary="vm.teamMember.salary" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\t\t</div>\n\n\t\t<!-- Annual allowance pay policies (zero or more)-->\n\t\t<div class="form-section with-separator" ng-repeat="annualAllowancePolicy in vm.teamMember.salary.AllowancePolicies | filter: { IsSalaryPolicyDelete : false }">\n\t\t\t<div class="form-section_header">\n\t\t\t\t<div class="form-section_header-title">Annual allowance</div>\n\t\t\t\t<div class="form-section_header-action">\n\t\t\t\t\t<div class="fadeIn" ng-if="!annualAllowancePolicy.confirmDelete">\n\t\t\t\t\t\t<a class="greyscale s strong" data-cy="pay-information-annual-allowance-{{$index}}-delete-allowance" href="" ng-click="toggleConfirmDeleteAnnualAllowancePolicy(annualAllowancePolicy)"><i class="icon-trash"></i>&nbsp;&nbsp;Delete</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="fadeIn" ng-if="annualAllowancePolicy.confirmDelete">\n\t\t\t\t\t\t<p class="s strong">\n\t\t\t\t\t\t\tAre you sure?&nbsp;\n\t\t\t\t\t\t\t<a data-cy="pay-information-annual-allowance-{{$index}}-delete-confirm" href="" ng-click="deleteAnnualAllowancePolicy(vm.teamMember.salary, annualAllowancePolicy)">Yes</a>\n\t\t\t\t\t\t\t<span class="greyscale">&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t<a data-cy="pay-information-annual-allowance-{{$index}}-delete-cancel" href="" ng-click="toggleConfirmDeleteAnnualAllowancePolicy(annualAllowancePolicy)">No</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Update pending message for annual allowance policy when applicable -->\n\t\t\t<div class="form-section smaller-margin" ng-if="annualAllowancePolicy.IsPolicyUpdatePending">\n\t\t\t\t<note note-icon="icon-information" note-theme="tertiary" note-title="Policy update">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">A policy update has been added for the \'{{annualAllowancePolicy.PolicyName}}\'\n\t\t\t\t\t\t\tpay policy and {{formOptions.context.Forename}}\'s pay has been updated.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Annual allowance policy -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="false" allow-edit-effective-date="!vm.teamMember.personal.IsInSetupMode && !annualAllowancePolicy.IsPolicyUpdatePending" company="vm.company" current-pay-period="vm.currentPayPeriod" id="payPolicyAnnualAllowance_{{$index}}" mode="annualAllowancePolicy.HasBeenPaid ? SALARY_POLICY_FORM_FIELD_MODES.view : SALARY_POLICY_FORM_FIELD_MODES.edit" on-add-change="addAnnualAllowanceChange(annualAllowancePolicy)" on-error="onError" parent-annual-salary-policy="vm.teamMember.salary.annualSalaryPolicy" pay-policies="vm.payPolicies" salary-policy="annualAllowancePolicy" salary="vm.teamMember.salary" show-add-change="annualAllowancePolicy.HasBeenPaid && !annualAllowancePolicy.policyChange" show-effective-date="!vm.teamMember.personal.IsInSetupMode" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\n\t\t\t<!-- Annual allowance policy - additional form field when adding a change to current allowance policy. -->\n\t\t\t<salary-policy-form-field agency-profile-id="vm.agencyProfileId" allow-delete="true" allow-edit-effective-date="!annualAllowancePolicy.IsPolicyUpdatePending" company="vm.company" current-pay-period="vm.currentPayPeriod" id="payPolicyAnnualAllowancePayChange_{{$index}}" mode="SALARY_POLICY_FORM_FIELD_MODES.addChange" ng-if="annualAllowancePolicy.policyChange" on-delete="deleteAnnualAllowanceChange(annualAllowancePolicy, annualAllowancePolicy.policyChange)" on-error="onError" parent-annual-salary-policy="vm.teamMember.salary.annualSalaryPolicy" pay-policies="vm.payPolicies" salary-policy="annualAllowancePolicy.policyChange" salary="vm.teamMember.salary" team-member="vm.teamMember">\n\t\t\t</salary-policy-form-field>\n\t\t</div>\n\n\t\t<!-- Add an annual allowance. Available only when there are annual allowance policies to choose from -->\n\t\t<div class="form-section with-separator" ng-if="vm.annualAllowancePoliciesCount !== 0">\n\t\t\t<button class="is-medium-large is-white is-block" data-cy="pay-information-add-annual-allowance" ng-click="addAnnualAllowancePolicy(vm.teamMember, vm.teamMember.salary)" type="button">\n\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add annual allowance\n\t\t\t</button>\n\t\t</div>\n\n\t\t<!-- Day rate calculations -->\n\t\t<div class="form-section with-separator">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Day rate calculations</h5>\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe default calculation method saved in your company settings will be used\n\t\t\t\t\tbut that can overridden for {{formOptions.context.Forename}} below.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payPeriodProRationDayRate">Pay period pro-ration day rate:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="block" id="periodProRatingMethod" name="periodProRatingMethod" ng-model="vm.teamMember.salary.periodProRatingMethod" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | orderBy: \'description\'" required>\n\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<p class="form-note is-primary-light">Used for starting, leaving, salary changes, and statutory payments</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payElementDayRate">\n\t\t\t\t\t\t\tPay element day rate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="block" id="elementProRatingMethod" name="elementProRatingMethod" ng-model="vm.teamMember.salary.elementProRatingMethod" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | orderBy: \'description\'" required>\n\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<p class="form-note is-primary-light">\n\t\t\t\t\t\t\tUsed for day rate changes such as Unpaid Leave, Unpaid Sickness, and KIT Days\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- On maternity leave -->\n\t<fieldset ng-if="vm.teamMember.company.isOnMaternityLeave">\n\t\t<div class="note tertiary">\n\t\t\t<h6><i class="icon-maternity tertiary m"></i>&nbsp;&nbsp;Currently on maternity pay</h6>\n\t\t\t<p>\n\t\t\t\t{{formOptions.context.Forename}} is currently on maternity pay and changing their pay information means you may need to update their\n\t\t\t\tschedule of payments so she is paid the correct amount. After saving {{formOptions.context.Forename}}\'s new pay information,\n\t\t\t\tyou can update their maternity schedule from the overview page in their profile.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Rolled up holiday settings -->\n\t<div class="form-fieldset-divider-top" ng-if="vm.teamMember.company.IsRollUpHolidayVisible">\n\t\t<pay-information-rolled-up-fieldset agency-profile-id="formOptions.agencyProfileId" is-required="vm.teamMember.isTeamMemberSetupFieldsRequired" paye-details="formOptions.payeDetails" team-member="vm.teamMember"></pay-information-rolled-up-fieldset>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="pay-information-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" data-cy="pay-information-cancel" ng-click="formOptions.closeForm()" ng-if="!formOptions.canGoBack" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="payInformationForm.$invalid || isSubmitButtonDisabled(vm)" display-text="formOptions.primaryButtonText" state="payInformationForm.state"></submit-button>\n\t\t<button class="tertiary-action" data-cy="pay-information-skip" ng-click="formOptions.skip()" ng-if="formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isCalendarVisible">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay period calendar</h5>\n\t\t<a aria-label="Toggle pay period calendar" class="slide-in-form-aside-header-action" data-cy="pay-information-toggle-calendar" href="" ng-click="toggleIsCalendarVisible(vm)">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main" ng-switch="vm.calendarState">\n\t\t<div class="fadeIn" ng-switch-when="ready">\n\t\t\t<weekly-calendar is-preview="true" pay-period="vm.currentPayPeriod" work-patterns="vm.teamMember.workPatterns"></weekly-calendar>\n\t\t</div>\n\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t<loading-block></loading-block>\n\t\t</div>\n\t</div>\n</aside>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="\n\t\tpageState === \'ready\' &&\n\t\tvm.teamMember.salary.SalaryFutureChanges.length &&\n\t\tvm.teamMember.salary.SalaryFutureChanges[0].showBackdatedSalaryCalculations\n\t">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Backdated calculations</h5>\n\t\t<a aria-label="Toggle backdated calculations" class="slide-in-form-aside-header-action" data-cy="pay-information-toggle-backdates-calculations" href="" ng-click="toggleShowBackdatedCalculations(vm.teamMember.salary.SalaryFutureChanges[0])">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\t<backdated-salary-calculation-view backdated-salary="vm.teamMember.salary.SalaryFutureChanges[0].backdatedSalary" busy="vm.teamMember.salary.SalaryFutureChanges[0].calculatingBackdatedSalary"></backdated-salary-calculation-view>\n</aside>\n\n<!-- Furloughed -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="{{formOptions.context.Forename}} has been furloughed" ng-if="pageState === \'team-member-furloughed\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease note that {{formOptions.context.Forename}} has been furloughed and you can\u2019t edit their pay information until their furlough period has ended.\n\t\t\tYou can review {{formOptions.context.Forename}}\u2019s furlough information in the Overview area in {{formOptions.context.Gender | personalise:\'his\'}} profile.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/paymentsToDate/paymentsToDateForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="paymentsToDateForm" ng-if="pageState === \'ready\'" ng-submit="updateTeamMemberYTD(teamMember, paymentsToDateForm)" ng-switch="activeTab" novalidate>\n\n\t<!-- Team member has Pre-RTI YTDs -->\n\t<div class="form-section" ng-if="teamMember.HasYTDnonRTI">\n\t\t<nav class="tabs">\n\t\t\t<a href="" ng-class="{\n\t\t\t\t\t\'active\': activeTab === TABS.postRTIInclusion\n\t\t\t\t}" ng-click="setActiveTab(TABS.postRTIInclusion)">\n\t\t\t\tPost-RTI Inclusion\n\t\t\t</a>\n\t\t\t<a href="" ng-class="{\n\t\t\t\t\t\'active\': activeTab === TABS.preRTIInclusion\n\t\t\t\t}" ng-click="setActiveTab(TABS.preRTIInclusion)">\n\t\t\t\tPre-RTI Inclusion\n\t\t\t</a>\n\t\t</nav>\n\t</div>\n\n\t<!-- Post-RTI Inclusion -->\n\t<div class="form-section fadeIn" pc-switch-when="TABS.postRTIInclusion">\n\t\t<!-- Current employment -->\n\t\t<fieldset class="form-fieldset-divider">\n\n\t\t\t<!-- Moved payrolls warning -->\n\t\t\t<div class="form-section" ng-if="teamMember.Company.isMovingPayrollsInwardPending">\n\t\t\t\t<note note-dismiss="false" note-icon="icon-warning" note-theme="tertiary" note-title="{{formOptions.context.Forename}}\'s payments to date information">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}} has recently moved payrolls and their payments to date information represents that held with HMRC.\n\t\t\t\t\t\t\tEditing this information means it will be updated with HMRC when you next run payroll.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Payments to date for {{formOptions.company.Name}}</h4>\n\t\t\t\t<p class="s">We need to know certain pay and tax payments that have been made since {{startOfTaxYear | simple}}.\n\t\t\t\t\tYou\'ll need {{formOptions.context.Forename}}\'s latest payslip where you can find the below numbers.</p>\n\t\t\t\t<p class="form-note">This is important to make sure {{formOptions.context.Forename}}\'s tax is calculated correctly.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Gross Pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdGrossCurrentEmploymentTotal" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total YTD gross pay:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdGrossCurrentEmploymentTotal" name="ytdGrossCurrentEmploymentTotal" ng-model="teamMember.YTD.YTDGrossCurrentEmploymentTotal" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdGrossCurrentEmploymentTotal.$touched" ng-messages="paymentsToDateForm.ytdGrossCurrentEmploymentTotal.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter the total amount of pay {{formOptions.context.Forename}} received (before any deductions)</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tThis is {{formOptions.context.Forename}}\'s total gross pay for this tax year\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Gross Pay for Tax -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdGrossCurrentEmploymentforTax" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total YTD gross pay for Tax:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdGrossCurrentEmploymentforTax" name="ytdGrossCurrentEmploymentforTax" ng-model="teamMember.YTD.YTDGrossCurrentEmploymentforTax" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdGrossCurrentEmploymentforTax.$touched" ng-messages="paymentsToDateForm.ytdGrossCurrentEmploymentforTax.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter the total amount of pay {{formOptions.context.Forename}} received (before any deductions)</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tThis is {{formOptions.context.Forename}}\'s total taxable pay for this tax year\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Gross Pay for NIC -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdGrossCurrentEmploymentforNIC" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total YTD gross pay for NIC:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdGrossCurrentEmploymentforNIC" name="ytdGrossCurrentEmploymentforNIC" ng-model="teamMember.YTD.YTDGrossCurrentEmploymentforNIC" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdGrossCurrentEmploymentforNIC.$touched" ng-messages="paymentsToDateForm.ytdGrossCurrentEmploymentforNIC.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter the total amount of pay {{formOptions.context.Forename}} received (before any deductions)</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-if="!teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tThis is {{formOptions.context.Forename}}\'s total pay for National Insurance this tax year\n\t\t\t\t</p>\n\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tThis is {{formOptions.context.Forename}}\'s total pay for National Insurance this tax year and should be inclusive of the value relating to a directorship that you enter below.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Gross Pay for NIC as a director -->\n\t\t\t<div class="form-field" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdGrossCurrentEmploymentForDirectorNIC" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\tYTD gross pay for NIC as a director:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdGrossCurrentEmploymentForDirectorNIC" name="ytdGrossCurrentEmploymentForDirectorNIC" ng-model="teamMember.YTD.YTDGrossCurrentEmploymentForDirectorNIC" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdGrossCurrentEmploymentForDirectorNIC.$touched" ng-messages="paymentsToDateForm.ytdGrossCurrentEmploymentForDirectorNIC.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Net pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdNetCurrentEmployment">Total net pay:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdNetCurrentEmployment" name="ytdNetCurrentEmployment" ng-model="teamMember.YTD.YTDNetCurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNetCurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdNetCurrentEmployment.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Tax -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdTotalTaxPaid" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total tax paid:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdTotalTaxPaid" name="ytdTotalTaxPaid" ng-model="teamMember.YTD.YTDTaxCurrentEmployment" ng-pattern="$root.REGEX.number9Digits2DecimalAllowNegative" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdTotalTaxPaid.$touched" ng-messages="paymentsToDateForm.ytdTotalTaxPaid.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum allowed range +/- {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter the total amount of tax {{formOptions.context.Forename}} paid</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Expats -->\n\t\t\t\t<p class="form-message" ng-if="::teamMember.Company.IsExpatriate">\n\t\t\t\t\tThis is {{::formOptions.context.Forename}}\u2019s total tax paid and should be inclusive of both UK tax and any foreign tax offset.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Employees NI -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdEENICurrentEmployment" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\tTotal YTD National Insurance paid by {{formOptions.context.Forename}}:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdEENICurrentEmployment" name="ytdEENICurrentEmployment" ng-model="teamMember.YTD.YTDEENICurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdEENICurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdEENICurrentEmployment.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s total National Insurance contribution amount</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-if="!teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tOften referred to as \'Employee\'s NI\'\n\t\t\t\t</p>\n\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tOften referred to as \'Employee\'s NI\' and should be inclusive of the value relating to a directorship that you enter below.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Employees NI as a director -->\n\t\t\t<div class="form-field" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdDirectorEENICurrentEmployment" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\tYTD National Insurance paid by {{formOptions.context.Forename}} as a director:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdDirectorEENICurrentEmployment" name="ytdDirectorEENICurrentEmployment" ng-model="teamMember.YTD.YTDDirectorEENICurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorEENICurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdDirectorEENICurrentEmployment.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Employers NI -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdERNICurrentEmployment" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\tTotal YTD National Insurance paid by {{formOptions.company.Name}}:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdERNICurrentEmployment" name="ytdERNICurrentEmployment" ng-model="teamMember.YTD.YTDERNICurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdERNICurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdERNICurrentEmployment.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.company.Name}}\'s total National Insurance contribution amount</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" ng-if="!teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tOften referred to as \'Employer\'s NI\'\n\t\t\t\t</p>\n\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\tOften referred to as \'Employer\'s NI\' and should be inclusive of the value relating to a directorship that you enter below.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Employers NI as a director -->\n\t\t\t<div class="form-field" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="ytdDirectorERNICurrentEmployment" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\tYTD National Insurance paid by {{formOptions.company.Name}} as a director:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdDirectorERNICurrentEmployment" name="ytdDirectorERNICurrentEmployment" ng-model="teamMember.YTD.YTDDirectorERNICurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorERNICurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdDirectorERNICurrentEmployment.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Add NI earnings thresholds -->\n\t\t\t<div class="form-field" ng-if="formOptions.company.CompanyType !== INTERFACE_TYPES.agency">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-label="Add National Insurance earnings thresholds" field-model="teamMember.YTD.hasYTDNILELs" field-name="hasYTDNILELs"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Enter manually -->\n\t\t\t<fieldset ng-if="formOptions.company.CompanyType !== INTERFACE_TYPES.agency && teamMember.YTD.hasYTDNILELs">\n\n\t\t\t\t<!-- Total earnings -->\n\t\t\t\t<div class="form-field fadeIn">\n\n\t\t\t\t\t<h5 class="lel-block__title" ng-if="teamMember.YTD.HasDirectorYTD">Total earnings</h5>\n\n\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t<!-- NI at LEL-->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdNIatLEL" class="required">\n\t\t\t\t\t\t\t\tEarnings at the\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr>:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIatLEL" name="ytdNIatLEL" ng-model="teamMember.YTD.YTDNIatLEL" ng-pattern="$root.REGEX.number4Digits" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIatLEL.$touched" ng-messages="paymentsToDateForm.ytdNIatLEL.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings at the LEL</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t<!-- NI from LEL to PT -->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdNILELtoPT" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\tEarnings above\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr> and up to\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNILELtoPT" name="ytdNILELtoPT" ng-model="teamMember.YTD.YTDNILELtoPT" ng-pattern="$root.REGEX.number4Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNILELtoPT.$touched" ng-messages="paymentsToDateForm.ytdNILELtoPT.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above LEL and up to PT</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t\t<!-- NI from PT to UEL -->\n\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t<label for="ytdNIPTtoUEL" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tEarnings above\n\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>, up to and including the\n\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIPTtoUEL" name="ytdNIPTtoUEL" ng-model="teamMember.YTD.YTDNIPTtoUEL" ng-pattern="$root.REGEX.number5Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIPTtoUEL.$touched" ng-messages="paymentsToDateForm.ytdNIPTtoUEL.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above PT, up to and including the UEL</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- NI above UEL -->\n\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t<label for="ytdNIaboveUEL" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tEarnings above the\n\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIaboveUEL" name="ytdNIaboveUEL" ng-model="teamMember.YTD.YTDNIAboveUEL" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIaboveUEL.$touched" ng-messages="paymentsToDateForm.ytdNIaboveUEL.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above the UEL</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\tTotal earnings should be inclusive of the values relating to a directorship that you enter below.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t<!-- Total earnings as a director -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="teamMember.YTD.HasDirectorYTD">\n\n\t\t\t\t\t<h5 class="lel-block__title">Earnings as a director</h5>\n\n\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t<!-- NI at LEL-->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdDirectorNIatLEL" class="required">Earnings at the\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr>:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIatLEL" name="ytdDirectorNIatLEL" ng-model="teamMember.YTD.YTDDirectorNIatLEL" ng-pattern="$root.REGEX.number4Digits" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIatLEL.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIatLEL.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings at the LEL</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- NI from LEL to PT -->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdDirectorNILELtoPT" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr> and up to\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNILELtoPT" name="ytdDirectorNILELtoPT" ng-model="teamMember.YTD.YTDDirectorNILELtoPT" ng-pattern="$root.REGEX.number4Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNILELtoPT.$touched" ng-messages="paymentsToDateForm.ytdDirectorNILELtoPT.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above LEL and up to PT</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t<!-- NI from PT to UEL -->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdDirectorNIPTtoUEL" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>, up to and including the\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIPTtoUEL" name="ytdDirectorNIPTtoUEL" ng-model="teamMember.YTD.YTDDirectorNIPTtoUEL" ng-pattern="$root.REGEX.number5Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIPTtoUEL.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIPTtoUEL.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above PT, up to and including the UEL</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- NI above UEL -->\n\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t<label for="ytdDirectorNIAboveUEL" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above the\n\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIAboveUEL" name="ytdDirectorNIAboveUEL" ng-model="teamMember.YTD.YTDDirectorNIAboveUEL" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIAboveUEL.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIAboveUEL.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above the UEL</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p>If {{formOptions.context.Forename}} was on a different letter code earlier in the tax year, to the one they\'re on now,\n\t\t\t\t\t\tyou can add payments and earnings thresholds below.</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Add previous NIC letter code -->\n\t\t\t\t<div class="fadeIn" ng-if="!teamMember.YTD.hasSecondNICLetterCode">\n\t\t\t\t\t<button class="is-medium-large is-white is-block" ng-click="toggleSecondNICLetterCode(teamMember)" type="button">\n\t\t\t\t\t\t<i class="icon-add button_icon-pre"></i>Add previous NIC letter code\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- LELS -->\n\t\t\t\t<div class="lel-block fadeIn" ng-if="teamMember.YTD.hasSecondNICLetterCode">\n\n\t\t\t\t\t<!-- NIC letter code -->\n\t\t\t\t\t<div class="lel-block__header">\n\t\t\t\t\t\t<label for="ytdNICode2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">NIC letter code:</label>\n\t\t\t\t\t\t<div class="form-field lel-block__letter-code">\n\t\t\t\t\t\t\t<select class="inline" id="ytdNICode2" name="ytdNICode2" ng-model="teamMember.YTD.YTDNICode2" ng-options="niCategoryLetter as niCategoryLetter for niCategoryLetter in niCategoryLetters" ng-required="teamMember.isTeamMemberSetupFieldsRequired">\n\t\t\t\t\t\t\t\t<option value="">Select</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="lel-block__delete">\n\t\t\t\t\t\t<a class="link-with-icon greyscale-darkened" href="" ng-click="toggleSecondNICLetterCode(teamMember)">\n\t\t\t\t\t\t\t<i class="icon-trash"></i> Delete\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="lel-block__content">\n\n\t\t\t\t\t\t<div class="form-field" ng-if="paymentsToDateForm.ytdNICode2.$touched && paymentsToDateForm.ytdNICode2.$invalid">\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdNICode2.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select an NIC letter code</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Note: Workplace postcode -->\n\t\t\t\t\t\t<div class="form-field" ng-if="teamMember.CanRequireWorkplacePostcode">\n\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Freeport and investment zone NI categories">\n\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\tYou may need to add a workplace postcode for {{::formOptions.context.Forename}} if they have been on a freeport or investment zone NI category this tax year.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Employees NI -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="ytdEENICurrentEmployment2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tTotal YTD National Insurance paid by {{formOptions.context.Forename}}:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdEENICurrentEmployment2" name="ytdEENICurrentEmployment2" ng-model="teamMember.YTD.YTDEENICurrentEmployment2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdEENICurrentEmployment2.$touched" ng-messages="paymentsToDateForm.ytdEENICurrentEmployment2.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s total National Insurance contribution amount</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message" ng-if="!teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t\tOften referred to as \'Employee\'s NI\'\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t\tOften referred to as \'Employee\'s NI\' and should be inclusive of the value relating to a directorship that you enter below.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Employees NI as a director -->\n\t\t\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="ytdDirectorEENICurrentEmployment2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tYTD National Insurance paid by {{formOptions.context.Forename}} as a director:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdDirectorEENICurrentEmployment2" name="ytdDirectorEENICurrentEmployment2" ng-model="teamMember.YTD.YTDDirectorEENICurrentEmployment2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorEENICurrentEmployment2.$touched" ng-messages="paymentsToDateForm.ytdDirectorEENICurrentEmployment2.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Employers NI -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="ytdERNICurrentEmployment2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tTotal YTD National Insurance paid by {{formOptions.company.Name}}:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdERNICurrentEmployment2" name="ytdERNICurrentEmployment2" ng-model="teamMember.YTD.YTDERNICurrentEmployment2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdERNICurrentEmployment2.$touched" ng-messages="paymentsToDateForm.ytdERNICurrentEmployment2.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.company.Name}}\'s total National Insurance contribution amount</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message" ng-if="!teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t\tOften referred to as \'Employer\'s NI\'\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="form-message" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t\tOften referred to as \'Employer\'s NI\' and should be inclusive of the value relating to a directorship that you enter below.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Employers NI as a director-->\n\t\t\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="ytdDirectorERNICurrentEmployment2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\t\t\t\t\tYTD National Insurance paid by {{formOptions.company.Name}} as a director:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdDirectorERNICurrentEmployment2" name="ytdDirectorERNICurrentEmployment2" ng-model="teamMember.YTD.YTDDirectorERNICurrentEmployment2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorERNICurrentEmployment2.$touched" ng-messages="paymentsToDateForm.ytdDirectorERNICurrentEmployment2.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Add NI earnings thresholds -->\n\t\t\t\t\t\t<div class="form-field" ng-if="formOptions.company.CompanyType !== INTERFACE_TYPES.agency">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<toggle-input field-label="Add National Insurance earnings thresholds" field-model="teamMember.YTD.hasYTDNILELs2" field-name="hasYTDNILELs2"></toggle-input>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Enter manually -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-if="formOptions.company.CompanyType !== INTERFACE_TYPES.agency && teamMember.YTD.hasYTDNILELs2">\n\n\t\t\t\t\t\t\t<!-- Total earnings -->\n\t\t\t\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t\t\t\t<h5 class="lel-block__title" ng-if="teamMember.YTD.HasDirectorYTD">\n\t\t\t\t\t\t\t\t\tTotal earnings\n\t\t\t\t\t\t\t\t</h5>\n\n\t\t\t\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t\t\t\t<!-- NI at LEL-->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdNIatLEL2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings at the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIatLEL2" name="ytdNIatLEL2" ng-model="teamMember.YTD.YTDNIatLEL2" ng-pattern="$root.REGEX.number4Digits" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIatLEL2.$touched" ng-messages="paymentsToDateForm.ytdNIatLEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings at the LEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- NI from LEL to PT -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdNILELtoPT2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr> and up to\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNILELtoPT2" name="ytdNILELtoPT2" ng-model="teamMember.YTD.YTDNILELtoPT2" ng-pattern="$root.REGEX.number4Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNILELtoPT2.$touched" ng-messages="paymentsToDateForm.ytdNILELtoPT2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above LEL and up to PT</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t\t\t\t<!-- NI from PT to UEL -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdNIPTtoUEL2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>, up to and including the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIPTtoUEL2" name="ytdNIPTtoUEL2" ng-model="teamMember.YTD.YTDNIPTtoUEL2" ng-pattern="$root.REGEX.number5Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIPTtoUEL2.$touched" ng-messages="paymentsToDateForm.ytdNIPTtoUEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above PT, up to and including the UEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- NI above UEL -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdNIaboveUEL2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdNIaboveUEL2" name="ytdNIaboveUEL2" ng-model="teamMember.YTD.YTDNIAboveUEL2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdNIaboveUEL2.$touched" ng-messages="paymentsToDateForm.ytdNIaboveUEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above the UEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Total earnings as a director -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="teamMember.YTD.HasDirectorYTD">\n\n\t\t\t\t\t\t\t\t<h5 class="lel-block__title">Earnings as a director</h5>\n\n\t\t\t\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t\t\t\t<!-- NI at LEL-->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdDirectorNIatLEL2" class="required">Earnings at the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIatLEL2" name="ytdDirectorNIatLEL2" ng-model="teamMember.YTD.YTDDirectorNIatLEL2" ng-pattern="$root.REGEX.number4Digits" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIatLEL2.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIatLEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings at the LEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- NI from LEL to PT -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdDirectorNILELtoPT2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Lower Earnings Limit">LEL</abbr> and up to\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNILELtoPT2" name="ytdDirectorNILELtoPT2" ng-model="teamMember.YTD.YTDDirectorNILELtoPT2" ng-pattern="$root.REGEX.number4Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNILELtoPT2.$touched" ng-messages="paymentsToDateForm.ytdDirectorNILELtoPT2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number4Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above LEL and up to PT</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="lel-block__group">\n\t\t\t\t\t\t\t\t\t<!-- NI from PT to UEL -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdDirectorNIPTtoUEL2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Primary Threshold">PT</abbr>, up to and including the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIPTtoUEL2" name="ytdDirectorNIPTtoUEL2" ng-model="teamMember.YTD.YTDDirectorNIPTtoUEL2" ng-pattern="$root.REGEX.number5Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIPTtoUEL2.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIPTtoUEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above PT, up to and including the UEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- NI above UEL -->\n\t\t\t\t\t\t\t\t\t<div class="lel-block__label">\n\t\t\t\t\t\t\t\t\t\t<label for="ytdDirectorNIAboveUEL2" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Earnings above the\n\t\t\t\t\t\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="Upper Earnings Limit">UEL</abbr>:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdDirectorNIAboveUEL2" name="ytdDirectorNIAboveUEL2" ng-model="teamMember.YTD.YTDDirectorNIAboveUEL2" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdDirectorNIAboveUEL2.$touched" ng-messages="paymentsToDateForm.ytdDirectorNIAboveUEL2.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s earnings above the UEL</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Has additional payments -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="hasAdditionalPaymentsTrue">Does {{formOptions.context.Forename}} have any additional payments?</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="b" id="hasAdditionalPaymentsTrue" name="hasAdditionalPayments" ng-model="teamMember.YTD.hasAdditionalPayments" ng-value="true" type="radio">\n\t\t\t\t\t<label for="hasAdditionalPaymentsTrue">Yes</label>\n\t\t\t\t\t<input class="b" id="hasAdditionalPaymentsFalse" name="hasAdditionalPayments" ng-model="teamMember.YTD.hasAdditionalPayments" ng-value="false" type="radio">\n\t\t\t\t\t<label for="hasAdditionalPaymentsFalse">No</label>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Including {{teamMember.YTD.additionalPaymentsCopy}}.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Additional payments? -->\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasAdditionalPayments">\n\n\t\t\t\t<!-- Student loan -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdStudentLoanCurrentEmployment">Total Student Loan paid:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdStudentLoanCurrentEmployment" name="ytdStudentLoanCurrentEmployment" ng-model="teamMember.YTD.YTDStudentLoanCurrentEmployment" ng-pattern="$root.REGEX.number5Digits" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdStudentLoanCurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdStudentLoanCurrentEmployment.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the student loan for current employment</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Postgraduate loan -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdPostgraduateLoanCurrentEmployment">Total Postgraduate Loan paid:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPostgraduateLoanCurrentEmployment" name="ytdPostgraduateLoanCurrentEmployment" ng-model="teamMember.YTD.YTDPostGraduateLoanCurrentEmployment" ng-pattern="$root.REGEX.number5Digits" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPostgraduateLoanCurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdPostgraduateLoanCurrentEmployment.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number5Digits | monetise:\'down\'}}. No decimal places</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Sick pay -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSSPCurrentEmployment">Total Sick Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSSPCurrentEmployment" name="ytdSSPCurrentEmployment" ng-model="teamMember.YTD.YTDSSPCurrentEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdSSPCurrentEmployment.$touched" ng-messages="paymentsToDateForm.ytdSSPCurrentEmployment.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory maternity pay -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveSMP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSMPCurrentEmployment">Total Maternity Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSMPCurrentEmployment" name="ytdSMPCurrentEmployment" ng-model="teamMember.YTD.YTDSMPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdSMPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdSMPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory paternity payments -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveSPP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSPPCurrentEmployment">Total Paternity Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSPPCurrentEmployment" name="ytdSPPCurrentEmployment" ng-model="teamMember.YTD.YTDSPPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdSPPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdSPPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory adoption pay -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveSAP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSAPCurrentEmployment">Total Adoption Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSAPCurrentEmployment" name="ytdSAPCurrentEmployment" ng-model="teamMember.YTD.YTDSAPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdSAPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdSAPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory shared parental payments -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveShPP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdShPPCurrentEmployment">Total Shared Parental Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdShPPCurrentEmployment" name="ytdShPPCurrentEmployment" ng-model="teamMember.YTD.YTDShPPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdShPPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdShPPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory parental bereavement payments -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveSPBP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSPBPCurrentEmployment">Total Parental Bereavement Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSPBPCurrentEmployment" name="ytdSPBPCurrentEmployment" ng-model="teamMember.YTD.YTDSPBPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdSPBPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdSPBPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Statutory neonatal care payments -->\n\t\t\t\t<div class="form-field" ng-if="teamMember.YTD.canHaveSNCP">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdSNCPCurrentEmployment">Total Neonatal Care Pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdSNCPCurrentEmployment" name="ytdSNCPCurrentEmployment" ng-model="teamMember.YTD.YTDSNCPCurrentEmployment" ng-pattern="$root.REGEX.number6Digits2Decimal" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.ytdSNCPCurrentEmployment.$error" ng-show="paymentsToDateForm.ytdSNCPCurrentEmployment.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number6Digits2Decimal | monetise}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Has pension year to dates -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="hasPensionYTDsTrue">Does {{formOptions.context.Forename}} have any Pension year to dates?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="b" id="hasPensionYTDsTrue" name="hasPensionYTDs" ng-model="teamMember.YTD.hasPensionContributions" ng-value="true" type="radio">\n\t\t\t\t\t<label for="hasPensionYTDsTrue">Yes</label>\n\t\t\t\t\t<input class="b" id="hasPensionYTDsFalse" name="hasPensionYTDs" ng-model="teamMember.YTD.hasPensionContributions" ng-value="false" type="radio">\n\t\t\t\t\t<label for="hasPensionYTDsFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pension year to dates -->\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasPensionContributions">\n\n\t\t\t\t<!-- Employee AE pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionEmployee" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employee AE pension contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionEmployee" name="ytdPensionContributionEmployee" ng-model="teamMember.YTD.YTDPensionContributionEmployee" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionEmployee.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionEmployee.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employee AE pension contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employer AE pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionEmployer" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employer AE pension contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionEmployer" name="ytdPensionContributionEmployer" ng-model="teamMember.YTD.YTDPensionContributionEmployer" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionEmployer.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionEmployer.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employer AE pension contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employee AE additional pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionVoluntary" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employee AE additional voluntary contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionVoluntary" name="ytdPensionContributionVoluntary" ng-model="teamMember.YTD.YTDPensionContributionVoluntary" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionVoluntary.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionVoluntary.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employee AE additional voluntary contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employee non-AE pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionEmployeeNonAE" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employee non-AE pension contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionEmployeeNonAE" name="ytdPensionContributionEmployeeNonAE" ng-model="teamMember.YTD.YTDPensionContributionEmployeeNonAE" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionEmployeeNonAE.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionEmployeeNonAE.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employee non-AE pension contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employer non-AE pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionEmployerNonAE" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employer non-AE pension contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionEmployerNonAE" name="ytdPensionContributionEmployerNonAE" ng-model="teamMember.YTD.YTDPensionContributionEmployerNonAE" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionEmployerNonAE.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionEmployerNonAE.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employer non-AE pension contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employee non-AE additional pension contributions -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="ytdPensionContributionVoluntaryNonAE" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Employee non-AE additional voluntary contributions to date:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPensionContributionVoluntaryNonAE" name="ytdPensionContributionVoluntaryNonAE" ng-model="teamMember.YTD.YTDPensionContributionVoluntaryNonAE" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPensionContributionVoluntaryNonAE.$touched" ng-messages="paymentsToDateForm.ytdPensionContributionVoluntaryNonAE.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the employee non-AE additional voluntary contributions to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Has BIK year to dates -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="hasBIKYTDsTrue">Does {{formOptions.context.Forename}} have a Payrolled Benefits in Kind year to date?</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="b" id="hasBIKYTDsTrue" name="hasBIKYTDs" ng-model="teamMember.YTD.hasBIKYTDs" ng-value="true" type="radio">\n\t\t\t\t\t<label for="hasBIKYTDsTrue">Yes</label>\n\t\t\t\t\t<input class="b" id="hasBIKYTDsFalse" name="hasBIKYTDs" ng-model="teamMember.YTD.hasBIKYTDs" ng-value="false" type="radio">\n\t\t\t\t\t<label for="hasBIKYTDsFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- BIK year to dates -->\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasBIKYTDs">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="ytdPayrollBIK" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Payrolled Benefits in Kind to date:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdPayrollBIK" name="ytdPayrollBIK" ng-model="teamMember.YTD.YTDPayrollBIK" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdPayrollBIK.$touched" ng-messages="paymentsToDateForm.ytdPayrollBIK.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the Payrolled Benefits in Kind to date</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t\t<!-- Expats -->\n\t\t\t<fieldset ng-if="::teamMember.Company.IsExpatriate">\n\n\t\t\t\t<!-- Tax excempt YTDs -->\n\t\t\t\t<fieldset>\n\n\t\t\t\t\t<!-- Has tax excempt year to dates -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="hasTaxExcemptYtdsTrue">Does {{formOptions.context.Forename}} have any tax exemption year to dates?</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="b" id="hasTaxExcemptYtdsTrue" name="hasTaxExcemptYtds" ng-model="teamMember.YTD.hasTaxExcemptYtds" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="hasTaxExcemptYtdsTrue">Yes</label>\n\t\t\t\t\t\t\t<input class="b" id="hasTaxExcemptYtdsFalse" name="hasTaxExcemptYtds" ng-model="teamMember.YTD.hasTaxExcemptYtds" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="hasTaxExcemptYtdsFalse">No</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- BIK year to dates -->\n\t\t\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasTaxExcemptYtds">\n\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="ytdTaxExemptIncome">Exempt income year to date:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdTaxExemptIncome" name="ytdTaxExemptIncome" ng-model="teamMember.YTD.YTDTaxExemptIncome" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdTaxExemptIncome.$touched" ng-messages="paymentsToDateForm.ytdTaxExemptIncome.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Exempt income year to date</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="ytdTaxExemptGrossUp">Exempt gross up year to date:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdTaxExemptGrossUp" name="ytdTaxExemptGrossUp" ng-model="teamMember.YTD.YTDTaxExemptGrossUp" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdTaxExemptGrossUp.$touched" ng-messages="paymentsToDateForm.ytdTaxExemptGrossUp.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Exempt gross up year to date</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Foreigh tax credits-->\n\t\t\t\t<fieldset>\n\n\t\t\t\t\t<!-- Has foreign tax credits -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="hasForeignTaxCreditsTrue">Does {{formOptions.context.Forename}} have any foreign tax credit year to dates?</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="b" id="hasForeignTaxCreditsTrue" name="hasForeignTaxCredits" ng-model="teamMember.YTD.hasForeignTaxCredits" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="hasForeignTaxCreditsTrue">Yes</label>\n\t\t\t\t\t\t\t<input class="b" id="hasForeignTaxCreditsFalse" name="hasForeignTaxCredits" ng-model="teamMember.YTD.hasForeignTaxCredits" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="hasForeignTaxCreditsFalse">No</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- BIK year to dates -->\n\t\t\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasForeignTaxCredits">\n\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="ytdForeignTaxCredit">Foreign tax credit year to date:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdForeignTaxCredit" name="ytdForeignTaxCredit" ng-model="teamMember.YTD.YTDForeignTaxCredit" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdForeignTaxCredit.$touched" ng-messages="paymentsToDateForm.ytdForeignTaxCredit.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Foreign tax credit year to date</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="ytdForeignTaxOffset">Foreign tax offset year to date:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise" id="ytdForeignTaxOffset" name="ytdForeignTaxOffset" ng-model="teamMember.YTD.YTDForeignTaxOffset" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdForeignTaxOffset.$touched" ng-messages="paymentsToDateForm.ytdForeignTaxOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Foreign tax offset year to date</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Taxable earnings in UK & abroad -->\n\t\t\t\t<fieldset>\n\t\t\t\t\t<!-- Has taxable earnings in UK & abroad -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="hasEarningsTaxableUKAndAbroadTrue">\n\t\t\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have any earnings taxable in the UK and abroad year to date?\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="b" id="hasEarningsTaxableUKAndAbroadTrue" name="hasEarningsTaxableUKAndAbroad" ng-model="teamMember.YTD.hasEarningsTaxableUKAndAbroad" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="hasEarningsTaxableUKAndAbroadTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<input class="b" id="hasEarningsTaxableUKAndAbroadFalse" name="hasEarningsTaxableUKAndAbroad" ng-model="teamMember.YTD.hasEarningsTaxableUKAndAbroad" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="hasEarningsTaxableUKAndAbroadFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Earnings taxable in UK & abroad -->\n\t\t\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasEarningsTaxableUKAndAbroad">\n\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<!-- Earnings taxable in both the UK and abroad -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="is-required" for="ytdEarningsTaxableInUKandAbroad">\n\t\t\t\t\t\t\t\t\t\tEarnings taxable in both the UK and abroad:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdEarningsTaxableInUKandAbroad" name="ytdEarningsTaxableInUKandAbroad" ng-model="teamMember.YTD.YTDEarningsTaxableInUKandAbroad" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdEarningsTaxableInUKandAbroad.$touched" ng-messages="paymentsToDateForm.ytdEarningsTaxableInUKandAbroad.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Earnings taxable in both the UK and abroad year to date</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message fadeIn">\n\t\t\t\t\t\t\t\t\tThis value isn&apos;t calculated by Paycircle and should be entered manually or imported\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Foreign tax paid YTD -->\n\t\t\t\t<fieldset>\n\t\t\t\t\t<!-- Has taxable earnings in UK & abroad -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="hasTotalForeignTaxPaidYTDTrue">\n\t\t\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have a total foreign tax paid year to date?\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="b" id="hasTotalForeignTaxPaidYTDTrue" name="hasTotalForeignTaxPaidYTD" ng-model="teamMember.YTD.hasTotalForeignTaxPaidYTD" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="hasTotalForeignTaxPaidYTDTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<input class="b" id="hasTotalForeignTaxPaidYTDFalse" name="hasTotalForeignTaxPaidYTD" ng-model="teamMember.YTD.hasTotalForeignTaxPaidYTD" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="hasTotalForeignTaxPaidYTDFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Expats YTD\'s -->\n\t\t\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasTotalForeignTaxPaidYTD">\n\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<!-- Total foreign tax paid -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="is-required" for="ytdForeignTaxPaid">\n\t\t\t\t\t\t\t\t\t\tTotal foreign tax paid:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="ytdForeignTaxPaid" name="ytdForeignTaxPaid" ng-model="teamMember.YTD.YTDForeignTaxPaid" ng-pattern="$root.REGEX.number9Digits2Decimal" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paymentsToDateForm.ytdForeignTaxPaid.$touched" ng-messages="paymentsToDateForm.ytdForeignTaxPaid.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the Total foreign tax paid</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message fadeIn">\n\t\t\t\t\t\t\t\t\tThis value isn&apos;t calculated by Paycircle and should be entered manually or imported\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<!-- Previous employers -->\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Did {{formOptions.context.Forename}} work for anyone else in this tax year?</h4>\n\t\t\t\t<p class="s">If {{formOptions.context.Forename}} has worked for any other employers since {{startOfTaxYear | simple}}, before joining {{formOptions.company.Name}},\n\t\t\t\t\tenter the total amount of gross pay and the total amount of tax paid for all those employers. This is so their\n\t\t\t\t\ttax can be calculated correctly.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Has previous employers -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="b" id="hasPreviousEmploymentTrue" name="hasPreviousEmployment" ng-model="teamMember.YTD.hasPreviousEmploymentPay" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t<label for="hasPreviousEmploymentTrue">Yes</label>\n\t\t\t\t\t<input class="b" id="hasPreviousEmploymentFalse" name="hasPreviousEmployment" ng-model="teamMember.YTD.hasPreviousEmploymentPay" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t<label for="hasPreviousEmploymentFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.YTD.hasPreviousEmploymentPay">\n\n\t\t\t\t<!-- Total gross -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="payInPreviousEmploymentUpToDate" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total gross pay:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="payInPreviousEmploymentUpToDate" name="payInPreviousEmploymentUpToDate" ng-model="teamMember.YTD.YTDGrossPreviousEmployment" ng-pattern="$root.REGEX.number9Digits2Decimal" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.payInPreviousEmploymentUpToDate.$error" ng-show="paymentsToDateForm.payInPreviousEmploymentUpToDate.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the total gross pay from any previous companies</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Total tax -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="taxInPreviousEmploymentUpToDate" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Total tax paid:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input autocomplete="off" class="l monetise" id="taxInPreviousEmploymentUpToDate" name="taxInPreviousEmploymentUpToDate" ng-model="teamMember.YTD.YTDTaxPreviousEmployment" ng-pattern="$root.REGEX.number9Digits2DecimalAllowNegative" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paymentsToDateForm.taxInPreviousEmploymentUpToDate.$error" ng-show="paymentsToDateForm.taxInPreviousEmploymentUpToDate.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum allowed range +/- {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter the total tax paid for any previous companies</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Pre-RTI Inclusion -->\n\t<div class="form-section fadeIn" pc-switch-when="TABS.preRTIInclusion">\n\n\t\t<div class="form-intro">\n\t\t\t<p>\n\t\t\t\tBelow is a read-only record of {{::formOptions.context.Forename}}\u2019s payments to date for {{::formOptions.company.Name}} before they were included in RTI submissions:\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="payment-table">\n\n\t\t\t\t\t<div class="payment-table__header payment-table__cell">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\tTax year {{::teamMember.preRtiTaxYearDisplay}}\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="payment-table__layout fadeIn">\n\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class="fadeIn" ng-repeat="payment in teamMember.filteredPayments =\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\tteamMember.nonRTIPayments |\n\t\t\t\t\t\t\t\t\t\t\tpaymentsToDatePreRTIShowAdditionalPayments : teamMember.hidePreRTIAdditionalPayments\n\t\t\t\t\t\t\t\t\t\t)">\n\n\t\t\t\t\t\t\t\t\t<!-- Label -->\n\t\t\t\t\t\t\t\t\t<td class="payment-table__cell payment-table__cell--label">\n\t\t\t\t\t\t\t\t\t\t<label for="preRtiPayment-{{$index}}" class="strong">\n\t\t\t\t\t\t\t\t\t\t\t{{payment.paymentLabel}}:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t\t\t\t\t<td class="payment-table__cell payment-table__cell--field">\n\t\t\t\t\t\t\t\t\t\t<input class="is-primary-lighter-flat is-strong" id="preRtiPayment-{{$index}}" name="preRtiPayment-{{$index}}" ng-model="payment.paymentAmount" readonly="readonly" tabindex="-1" type="text">\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t<!-- Toggle Additional Payments -->\n\t\t\t\t\t\t\t<tfoot>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="payment-table__cell payment-table__cell--footer" colspan="2">\n\t\t\t\t\t\t\t\t\t\t<a class="primary strong" href="#" ng-click="togglePreRTIAdditionalPayments(teamMember)">\n\t\t\t\t\t\t\t\t\t\t\t<i class="" ng-class="teamMember.hidePreRTIAdditionalPayments ? \'icon-chevron-down\' : \'icon-chevron-up\'"></i>&nbsp;{{$ctrl.hideAdditionalPayments ? "Show" : "Hide"}} additional payments\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tfoot>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<form-feedback ng-if="paymentsToDateForm.state === \'saved\'" state="paymentsToDateForm.state">\n\t\t\t<p>{{formOptions.context.Forename}}\'s payment to date information has been saved.</p>\n\t\t</form-feedback>\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">Back</a>\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()" ng-if="!formOptions.totalSteps">Cancel</a>\n\n\t\t<submit-button disable-button="paymentsToDateForm.$invalid" display-text="formOptions.primaryButtonText" state="paymentsToDateForm.state"></submit-button>\n\n\t\t<a class="button tertiary-action" href="" ng-click="formOptions.skip()" ng-if="formOptions.canSkip">Skip</a>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?" ng-if="pageState === \'confirm-edit\'">\n\t<fs-main>\n\t\t<p class="s">This form contains the pay and tax Year to Date information, for the current tax year, for {{formOptions.context.Forename}}.\n\t\t\tThese figures represent the information that HMRC holds on their records for this team member.\n\t\t\tIf you edit any of the figures in this form, this team member\u2019s information will be updated with HMRC when you run payroll.\n\t\t</p>\n\n\t\t<p class="s">\n\t\t\tMaking changes to a team member\u2019s Year to Date figures will create log entries in the payroll audit report, the team member\u2019s profile history and on the Company dashboard.\n\t\t</p>\n\n\t\t<br>\n\n\t\t<!-- Confirmation -->\n\t\t<div class="form-section">\n\t\t\t<div class="confirmation-block tertiary-light">\n\t\t\t\t<input id="confirmInformation" label-text="\'I want to make changes to the Year to Date figures for \' + formOptions.context.Forename" name="confirmInformation" ng-click="toggleIsConfirmed(teamMember)" ng-model="teamMember.isConfirmed" type="checkbox" checkbox required>\n\t\t\t\t<p class="p s"> By ticking this box you are confirming that you understand that making changes to a team member\u2019s Year to Date\n\t\t\t\t\tinformation will change the data that HMRC holds on their records for this team member next time you run payroll.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<button class="tertiary primary-action" ng-click="setPageState(\'ready\')" ng-disabled="!teamMember.isConfirmed" state="pageState">Continue</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/rti-submission/rti-submission.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.losding"></loading-block>\n\n<!-- Include - Confirm -->\n<form class="fadeIn" name="rtiSubmissionForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.confirmInclude" ng-submit="$ctrl.updateTeamMemberIncludeInRTI($ctrl, rtiSubmissionForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to include {{$ctrl.formOptions.context.Forename}} in RTI submissions?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}} will be marked as a new starter and you\u2019ll need to add a new start date for them.\n\t\t\t\tTheir tax code will also be overwritten. You\u2019ll need to complete setting up their profile before they can be included in payroll.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!rtiSubmissionForm.$valid" display-text="\'Confirm\'" state="rtiSubmissionForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Include - Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="{{$ctrl.formOptions.context.Forename}} will now be included in RTI submissions" ng-if="$ctrl.formState === $ctrl.FORM_STATES.includeSuccess">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou can omit {{$ctrl.formOptions.context.Forename}} again any time before you next run payroll by clicking \u2018Omit from RTI submissions\u2019 in the actions menu in their profile.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Exclude - Confirm -->\n<form class="fadeIn" name="rtiSubmissionForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.confirmExclude" ng-submit="$ctrl.updateTeamMemberIncludeInRTI($ctrl, rtiSubmissionForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to omit {{$ctrl.formOptions.context.Forename}} from RTI submissions?">\n\t\t<fs-main>\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tAny changes you\u2019ve made to {{$ctrl.formOptions.context.Forename}}\u2019s information while they were set to be included in RTI submission will be removed,\n\t\t\t\t\tand their profile will be restored to it\u2019s previous state. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<note note-title="Changes to team member information" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tIf you\'ve made any changes to {{$ctrl.formOptions.context.Forename}}\'s company details or tax status while they\'ve been included in RTI submissions,\n\t\t\t\t\t\t\tyou may need to edit them in their profile after they\'ve been omitted again.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</section>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.setFormState(\'ready\')" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\n\t\t\t<submit-button disable-button="!rtiSubmissionForm.$valid" display-text="\'Confirm\'" state="rtiSubmissionForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Exclude - Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="{{$ctrl.formOptions.context.Forename}} has been omitted from RTI submissions" ng-if="$ctrl.formState === $ctrl.FORM_STATES.excludeSuccess">\n\t<fs-main>\n\t\t<p class="is-small">{{$ctrl.formOptions.context.Forename}} is now omitted from RTI submissions and their profile has been restored to it\u2019s previous state.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/starter-information/starter-information.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="starterInformationForm" ng-if="pageState === \'ready\'" ng-submit="updateTeamMemberTax(teamMember, starterInformationForm)" novalidate>\n\t<!-- New Starters (Non-seconded) -->\n\t<fieldset class="fadeIn" ng-if="!teamMember.Company.IsSeconded">\n\n\t\t<!-- Has P45 -->\n\t\t<div class="form-field" ng-if="teamMember.IsInSetupMode">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="form-field-label" for="p45AvailableTrue" ng-class="{\n\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t}">\n\t\t\t\t\tDo they have a P45?\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="p45AvailableTrue" name="p45Available" ng-model="teamMember.Tax.IsP45Available" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="p45AvailableTrue">\n\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="p45AvailableFalse" name="p45Available" ng-model="teamMember.Tax.IsP45Available" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="p45AvailableFalse">\n\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No P45 - New Starter Declaration -->\n\t\t<fieldset class="fadeIn" ng-if="!teamMember.Tax.IsP45Available">\n\n\t\t\t<!-- New Starter Declaration -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label is-large" for="starterDeclarationA" ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tWhat is their employment status?\n\t\t\t\t\t</label>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tAs {{formOptions.context.Forename}} doesn\u2019t have a P45 select one of the declaration options below.\n\t\t\t\t\t\tPlease note that this can be updated after you\u2019ve run your first pay period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationA" name="starterDeclaration" ng-change="onStarterDeclarationChange(teamMember.Tax)" ng-model="teamMember.Tax.StarterDeclaration" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="\'A\'" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationA">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">A</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tThis is {{formOptions.context.Forename}}&rsquo;s first job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\tsince start of tax year and <span class="strong">they have not</span>\n\t\t\t\t\t\t\t\t\t\tbeen receiving taxable Jobseeker&rsquo;s Allowance, Employment and Support Allowance, taxable Incapacity Benefit, State or Occupational pension.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationB" name="starterDeclaration" ng-change="onStarterDeclarationChange(teamMember.Tax)" ng-model="teamMember.Tax.StarterDeclaration" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="\'B\'" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationB">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">B</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tThis is now {{formOptions.context.Forename}}&rsquo;s only job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>but</em> since start of tax year <span class="strong">they have</span>\n\t\t\t\t\t\t\t\t\t\thad another job, or received taxable Jobseeker&rsquo;s Allowance, Employment and Support Allowance or taxable Incapacity Benefit.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationC" name="starterDeclaration" ng-change="onStarterDeclarationChange(teamMember.Tax)" ng-model="teamMember.Tax.StarterDeclaration" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="\'C\'" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationC">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">C</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\tAs well as this new job, {{formOptions.context.Forename}} has another job\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>or</em> receives State or Occupational Pension.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="starterDeclarationD" name="starterDeclaration" ng-change="onStarterDeclarationChange(teamMember.Tax)" ng-model="teamMember.Tax.StarterDeclaration" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="\'D\'" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label has-even-padding" for="starterDeclarationD">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text radio-card-option-text-align-self-start">D</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-title">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} has not completed a starter declaration\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\t<em>so</em> they will be assigned a 0T W1/M1 tax code in order to calculate their tax,\n\t\t\t\t\t\t\t\t\t\tand they will be assessed to determine their National Insurance category.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<div class="form-field radio-card-label-additional-content-toggle">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<toggle-input field-disabled="teamMember.Tax.StarterDeclaration !== \'D\'" field-label="Override tax code and NI category" field-model="teamMember.Tax.IsStarterDefaultOverridden" field-name="isStarterDefaultOverridden"></toggle-input>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-card-label-additional-content" ng-if="teamMember.Tax.IsStarterDefaultOverridden">\n\t\t\t\t\t\t\t\t\t\t<tax-info-form-fields allow-ni-category-edit="teamMember.IsInSetupMode" is-disabled="teamMember.Tax.StarterDeclaration !== \'D\'" ni-category-letters="niCategoryLetters" tax-info="teamMember.Tax">\n\t\t\t\t\t\t\t\t\t\t</tax-info-form-fields>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Note: Workplace postcode -->\n\t\t\t\t\t\t\t\t\t\t<div class="form-field" ng-if="teamMember.CanRequireWorkplacePostcode">\n\t\t\t\t\t\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Freeport and investment zone NI categories">\n\t\t\t\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou may need to add a workplace postcode for {{::formOptions.context.Forename}} if they have been on a freeport or investment zone NI category this tax year.\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.apprenticeshipLevy.$error" ng-show="starterInformationForm.starterDeclaration.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease choose an option that describes {{formOptions.context.Forename}}&rsquo;s employment status\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Veterans -->\n\t\t\t<fieldset class="fadeIn" ng-if="teamMember.Tax.NICode === NI_CATEGORY_LETTER.v">\n\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEnter the start date of {{::formOptions.context.Forename}}\u2019s first civilian employment if you want Employer NICs relief to be automatically stopped after their qualifying period ends.\n\t\t\t\t\t\tOtherwise, you\u2019ll need to manually change their National Insurance category.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- First civilian employment -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="civilianStartDateIso">\n\t\t\t\t\t\t\tStart date of {{::formOptions.context.Forename}}\u2019s first civilian employment:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="civilianStartDateIso" field-required="false" field-style="l" field-value-iso="teamMember.Tax.CivilianStartDateISO"></date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="taxStatusForm.civilianStartDateIso.$touched" ng-messages="taxStatusForm.civilianStartDateIso.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t\t<!-- Has Student Loan -->\n\t\t\t<div class="form-field" ng-if="::teamMember.Tax.canShowStudentLoan && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="studentLoanTrue">\n\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have a student loan?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanTrue" name="studentLoan" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanFalse" name="studentLoan" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Student loan plan -->\n\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Tax.StudentLoan">\n\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="strong" for="studentLoanPlan1" ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tStudent loan plan:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan1" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan1">Plan 1</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan2">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan2" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan2" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan2">Plan 2</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1and2">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1and2" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan1and2" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan1and2">Plan 1 and Plan 2</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan4">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan4" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan4" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan4">Plan 4</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan5">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan5" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan5" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan5">Plan 5</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="taxStatusForm.studentLoanPlan.$error" ng-show="taxStatusForm.studentLoanPlan.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please choose a student loan plan</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Postgraduate loan -->\n\t\t\t<div class="form-field" ng-if="::teamMember.Tax.canShowPostgraduateLoan && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label" for="postgraduateLoanTrue" ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have a postgraduate loan?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanTrue" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanFalse" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Has P45 - Pay / Tax to date -->\n\t\t<fieldset class="fadeIn" ng-if="teamMember.Tax.IsP45Available">\n\n\t\t\t<!-- Leaving Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}" for="previousEmploymentLeaveDate">\n\t\t\t\t\t\tLeaving date on P45:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="previousEmploymentLeaveDate" field-min-date-iso="teamMember.YTD.YTDLeaveDatePreviousEmploymentISOMin" field-required="teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="teamMember.YTD.YTDLeaveDatePreviousEmploymentISO"></date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="starterInformationForm.previousEmploymentLeaveDate.$touched" ng-messages="starterInformationForm.previousEmploymentLeaveDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter a leave date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\tPlease enter a valid leave date, like this: dd/mm/yyyy\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\tIt looks like {{formOptions.context.Forename}}\'s P45 is no longer valid as the leave date is in the previous tax year.\n\t\t\t\t\t\t<a class="underline assertive" href="" ng-click="$root.openModalDialog({\n\t\t\t\t\t\t\t\tmodalKey: \'leave-date-expired\',\n\t\t\t\t\t\t\t\tmodalData: {\n\t\t\t\t\t\t\t\t\tteamMember\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\tWhat to do now?\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Shown next to box 4 on the P45</p>\n\t\t\t</div>\n\n\t\t\t<!-- Total Pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="totalPayInPreviousEmployment">\n\t\t\t\t\t\tTotal pay in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdGrossPreviousEmployment" min="0" name="ytdGrossPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="teamMember.YTD.YTDGrossPreviousEmployment" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="starterInformationForm.ytdGrossPreviousEmployment.$error" ng-show="starterInformationForm.ytdGrossPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Shown next to box 7 on the P45</p>\n\t\t\t</div>\n\n\t\t\t<!-- Total Tax -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="totalTaxInPreviousEmployment">\n\t\t\t\t\t\tTotal tax paid in previous employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l monetise" id="ytdTaxPreviousEmployment" name="ytdTaxPreviousEmployment" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="teamMember.YTD.YTDTaxPreviousEmployment" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="starterInformationForm.ytdTaxPreviousEmployment.$error" ng-show="starterInformationForm.ytdTaxPreviousEmployment.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Shown next to box 7 on the P45</p>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- New Starters (Seconded expatriate) -->\n\t<fieldset class="fadeIn" ng-if="teamMember.Company.IsSeconded">\n\n\t\t<!-- Employment status -->\n\t\t<fieldset>\n\n\t\t\t<!-- New Starter Declaration -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label required" for="starterDeclarationA" ng-class="{\n\t\t\t\t\t\t\t\'disabled\': !teamMember.IsInSetupMode\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tWhat is {{formOptions.context.Forename}}\'s employment status?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateA" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.stay183DaysOrMore" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateA">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">A</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} intends to live in the UK for 183 days or more\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateB" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.stayLessThan183Days" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateB">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">B</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} intends to live in the UK for less than 183 days\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="secondedStateC" name="secondedState" ng-disabled="!teamMember.IsInSetupMode" ng-model="teamMember.Tax.SecondedState" ng-value="SECONDED_STATES.inOutUk" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="secondedStateC">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">C</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} will be working for {{formOptions.company.Name}} both inside and outside the UK but will be living abroad\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- JE: Might be re-introduced later on\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\tclass="radio-card-input"\n\t\t\t\t\t\t\t\tid="secondedStateD"\n\t\t\t\t\t\t\t\tname="secondedState"\n\t\t\t\t\t\t\t\tng-disabled="!teamMember.IsInSetupMode"\n\t\t\t\t\t\t\t\tng-model="teamMember.Tax.SecondedState"\n\t\t\t\t\t\t\t\tng-value="SECONDED_STATES.notEnoughInformation"\n\t\t\t\t\t\t\t\trequired\n\t\t\t\t\t\t\t\ttype="radio"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<label\n\t\t\t\t\t\t\t\tclass="radio-card-label"\n\t\t\t\t\t\t\t\tfor="secondedStateD"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">D</span>\n\t\t\t\t\t\t\t\t<div class="radio-card-option-info">\n\t\t\t\t\t\t\t\t\t<p class="radio-card-subtitle">\n\t\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} has not provided enough information\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-description">\n\t\t\t\t\t\t\t\t\t\tso they will be assigned a 0T tax code, in order to calculate their tax, and they will be assessed to determine their National Insurance category.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t-->\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="starterInformationForm.secondedState.$error" ng-show="starterInformationForm.secondedState.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease choose an option that describes {{formOptions.context.Forename}}&apos;s employment status\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Student / Postgraduate Loan -->\n\t\t<fieldset ng-if="teamMember.IsInSetupMode">\n\n\t\t\t<!-- Has Student Loan -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label" for="studentLoanTrue">\n\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have a student loan?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input b" id="studentLoanTrue" name="studentLoan" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input b" id="studentLoanFalse" name="studentLoan" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Student loan plan -->\n\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Tax.StudentLoan">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="strong" for="studentLoanPlan1" ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tStudent loan plan:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan1" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan1">Plan 1</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan2">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan2" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan2" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan2">Plan 2</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1and2">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1and2" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan1and2" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan1and2">Plan 1 and Plan 2</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan4">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan4" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan4" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan4">Plan 4</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan5">\n\t\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan5" name="studentLoanPlan" ng-model="teamMember.Tax.studentLoanPlanOption" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="STUDENT_LOAN_PLANS.plan5" type="radio">\n\t\t\t\t\t\t\t<label for="studentLoanPlan5">Plan 5</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="starterInformationForm.studentLoanPlan.$error" ng-show="starterInformationForm.studentLoanPlan.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please choose a student loan plan</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Postgraduate loan -->\n\t\t\t<div class="form-field" ng-if="::teamMember.Tax.canShowPostgraduateLoan && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field-label" for="postgraduateLoanTrue" ng-class="{\n\t\t\t\t\t\t\t\'required\' : teamMember.isTeamMemberSetupFieldsRequired\n\t\t\t\t\t\t}">\n\t\t\t\t\t\tDoes {{formOptions.context.Forename}} have a postgraduate loan?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input b" id="postgraduateLoanTrue" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanTrue">\n\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input b" id="postgraduateLoanFalse" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanFalse">\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="starterInformationForm.state === \'saved\'" state="starterInformationForm.state">\n\t\t\t<p>{{formOptions.context.Forename}}&rsquo;s P45 details have been saved.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()" ng-if="!formOptions.totalSteps">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="starterInformationForm.$invalid" display-text="formOptions.primaryButtonText" state="starterInformationForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a class="button tertiary-action" href="" ng-click="formOptions.skip()" ng-if="formOptions.canSkip">\n\t\t\tSkip\n\t\t</a>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/employment/taxStatus/taxStatusForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="taxStatusForm" class="fadeIn" ng-submit="updateTeamMemberTax(teamMember, taxStatusForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="!teamMember.TeamMemberSetupComplete">\n\t\t<h4>Tell us some basic tax details</h4>\n\t</div>\n\n\t<!-- Moved payrolls warning -->\n\t<div class="form-section" ng-if="teamMember.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending">\n\t\t<note note-theme="tertiary" note-icon="icon-warning" note-title="{{formOptions.context.Forename}}\'s tax status" note-dismiss="false">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">{{formOptions.context.Forename}} has recently moved payrolls and their tax status information represents that held with HMRC.\n\t\t\t\t\tEditing this information means it will be updated with HMRC when you next run payroll.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\n\t\t<fieldset>\n\t\t\t<tax-info-form-fields allow-ni-category-edit="teamMember.IsInSetupMode" ni-category-letters="niCategoryLetters" required="teamMember.isTeamMemberSetupFieldsRequired" tax-info="teamMember.Tax"></tax-info-form-fields>\n\t\t</fieldset>\n\n\t\t<!-- Veterans -->\n\t\t<fieldset class="fadeIn" ng-if="\n\t\t\t\tteamMember.Tax.NICode === NI_CATEGORY_LETTER.v ||\n\t\t\t\tteamMember.Tax.HasNICodeChange && teamMember.Tax.NICodeChange === NI_CATEGORY_LETTER.v\n\t\t\t">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<p>\n\t\t\t\t\tEnter the start date of {{::formOptions.context.Forename}}\u2019s first civilian employment if you want Employer NICs relief to be automatically stopped after their qualifying period ends.\n\t\t\t\t\tOtherwise, you\u2019ll need to manually change their National Insurance category.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- First civilian employment -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="civilianStartDateIso">\n\t\t\t\t\t\tStart date of {{::formOptions.context.Forename}}\u2019s first civilian employment:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="civilianStartDateIso" field-required="false" field-style="l" field-value-iso="teamMember.Tax.CivilianStartDateISO"></date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="taxStatusForm.civilianStartDateIso.$touched" ng-messages="taxStatusForm.civilianStartDateIso.$error" role="alert">\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Note: Workplace postcode -->\n\t\t<fieldset ng-if="teamMember.CanRequireWorkplacePostcode">\n\t\t\t<div class="form-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Freeport and investment zone NI categories">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tYou may need to add a workplace postcode for {{::formOptions.context.Forename}} if they have been on a freeport or investment zone NI category this tax year.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Student loan -->\n\t\t<div class="form-field" ng-if="::teamMember.Tax.canShowStudentLoan && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="form-field-label" for="studentLoanTrue" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\tDoes {{formOptions.context.Forename}} have a student loan?\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanTrue" name="studentLoan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanTrue">\n\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="studentLoanFalse" name="studentLoan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.StudentLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="studentLoanFalse">\n\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t</div>\n\n\t\t<!-- Student loan plan -->\n\t\t<div class="form-field fadeIn" ng-if="teamMember.Tax.StudentLoan">\n\t\t\t<label class="strong" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }" for="studentLoanPlan1">Student loan plan:</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1">\n\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1" name="studentLoanPlan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.studentLoanPlanOption" ng-value="STUDENT_LOAN_PLANS.plan1" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="studentLoanPlan1">Plan 1</label>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan2">\n\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan2" name="studentLoanPlan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.studentLoanPlanOption" ng-value="STUDENT_LOAN_PLANS.plan2" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="studentLoanPlan2">Plan 2</label>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan1and2">\n\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan1and2" name="studentLoanPlan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.studentLoanPlanOption" ng-value="STUDENT_LOAN_PLANS.plan1and2" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="studentLoanPlan1and2">Plan 1 and Plan 2</label>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan4">\n\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan4" name="studentLoanPlan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.studentLoanPlanOption" ng-value="STUDENT_LOAN_PLANS.plan4" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="studentLoanPlan4">Plan 4</label>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="::teamMember.Tax.canShowStudentLoanPlan5">\n\t\t\t\t\t\t<input class="b is-narrow" id="studentLoanPlan5" name="studentLoanPlan" ng-change="updateStudentLoan(teamMember)" ng-model="teamMember.Tax.studentLoanPlanOption" ng-value="STUDENT_LOAN_PLANS.plan5" ng-required="teamMember.isTeamMemberSetupFieldsRequired" type="radio">\n\t\t\t\t\t\t<label for="studentLoanPlan5">Plan 5</label>\n\t\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="taxStatusForm.studentLoanPlan.$error" ng-show="taxStatusForm.studentLoanPlan.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a student loan plan</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Postgraduate loan -->\n\t\t<div class="form-field" ng-if="::teamMember.Tax.canShowPostgraduateLoan && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="form-field-label" for="postgraduateLoanTrue" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">\n\t\t\t\t\tDoes {{formOptions.context.Forename}} have a postgraduate loan?\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanTrue" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanTrue">\n\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="postgraduateLoanFalse" name="postgraduateLoan" ng-model="teamMember.Tax.PostGraduateLoan" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="postgraduateLoanFalse">\n\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<p class="form-message fadeIn">Please select &lsquo;No&rsquo; if you\'re unsure.</p>\n\t\t</div>\n\n\t\t<!-- Tax change effective date -->\n\t\t<fieldset class="fadeIn" ng-if="showTaxChangeDate && teamMember.Tax.CanAddTaxChangeEffectiveDate">\n\t\t\t<note note-theme="primary has-border is-form-field">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<!-- Has tax change effective date -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="hasTaxChangeEffectiveDate" class="is-small" ng-class="{ \'required\' : teamMember.isTeamMemberSetupFieldsRequired }">Add an effective date within the current pay period for these tax status updates:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="radio-list is-inline">\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input class="b" id="hasTaxChangeEffectiveDate-yes" name="hasTaxChangeEffectiveDate" ng-model="teamMember.Tax.HasTaxChangeEffectiveDate" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="hasTaxChangeEffectiveDate-yes" class="s">Yes</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input class="b" id="hasTaxChangeEffectiveDate-no" name="hasTaxChangeEffectiveDate" ng-model="teamMember.Tax.HasTaxChangeEffectiveDate" ng-required="teamMember.isTeamMemberSetupFieldsRequired" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label for="hasTaxChangeEffectiveDate-no" class="s">No</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Tax change effective date -->\n\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="teamMember.Tax.HasTaxChangeEffectiveDate">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="taxChangeEffectiveDateISO" field-min-date-iso="teamMember.Tax.TaxChangeEffectiveDateMinISO" field-max-date-iso="formOptions.currentPayPeriod.PayDateISO" field-required="teamMember.isTeamMemberSetupFieldsRequired" field-value-iso="teamMember.Tax.TaxChangeEffectiveDateISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="taxStatusForm.taxChangeEffectiveDateISO.$error" ng-if="taxStatusForm.taxChangeEffectiveDateISO.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the tax code effecitve date</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter an effective date on or after {{teamMember.Tax.TaxChangeEffectiveDateMinISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter an effective date on or before {{formOptions.currentPayPeriod.PayPeriodDisplay}}\'s pay date ({{formOptions.currentPayPeriod.PayDateISO | dateformat}})</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="fadeIn italic primary-light is-small">If you need to add a tax status update with an effective date later than your current pay period, please wait until you are in the respective pay period.</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\n\t\t<!-- Note: Automated Tax Codes -->\n\t\t<div class="form-field" ng-if="!formOptions.company.DPSImport">\n\t\t\t<note note-theme="indifferent is-form-field" note-title="Turn on automated tax updates" note-icon="icon-support" note-dismiss="true" note-dismiss-key="tax-status-automated-tax-code">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">We can automatically update tax code and student loan notices and remove the need to perform these tasks manually.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.automaticTaxCodeUpdates" theme="indifferent" underline="true">Read more</support-article-link></p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="taxStatusForm.state" ng-if="taxStatusForm.state === \'saved\'">\n\t\t\t<p>Tax details have been saved.</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a data-cy="tax-status-back-action" href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<!-- Close -->\n\t\t<a data-cy="tax-status-cancel-action" href="" ng-if="!formOptions.totalSteps" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="taxStatusForm.state" disable-button="taxStatusForm.$invalid"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a data-cy="tax-status-skip-action" href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="pageState ===\'ready\' && teamMember.Tax.showBackdatedNICalculations">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Backdated NI calculations</h5>\n\t\t<a data-cy="tax-status- hide-backdated-ni-calculations-action" href="" aria-label="Hide backdated NI calculations" class="slide-in-form-aside-header-action" ng-click="toggleShowBackdatedNICalculations(teamMember)"><i class="icon-right l"></i></a>\n\t</header>\n\t<backdated-ni-calculation-view backdated-ni="teamMember.Tax.backdatedNI" busy="teamMember.Tax.calculatingBackdatedNI"></backdated-ni-calculation-view>\n</aside>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/employment/viewWorkPattern/viewWorkPatternForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="form-content-block">\n\t\t<p class="s">\n\t\t\t{{formOptions.context.Forename}} uses the below work pattern. If you need to make changes to {{formOptions.context.Forename}}\'s work pattern or hourly rate,\n\t\t\t<span ng-if="!formOptions.hideProfileLink"><a ui-sref="team.profile.information({agencyProfileId: formOptions.company.AgencyProfileID, userId: formOptions.context.UserID})" class="underline">go to their profile</a>.</span>\n\t\t\t<span ng-if="formOptions.hideProfileLink">go to their profile.</span>\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block" ng-repeat="workPattern in vm.workPatterns">\n\n\t\t<div class="form-content-block" ng-if="!$first">\n\t\t\t<p class="s">\n\t\t\t\t{{formOptions.context.Forename}} is set to change to the &lsquo;{{workPattern.Description}}&rsquo; work pattern on {{workPattern.EffectiveDateISO | dateformat}}. You can cancel this change by editing {{formOptions.context.Forename}}\'s pay information in {{formOptions.context.Gender | personalise:\'his\'}}\n\t\t\t\t<span ng-if="!formOptions.hideProfileLink"><a ui-sref="team.profile.information({agencyProfileId: formOptions.company.AgencyProfileID, userId: formOptions.context.UserID})" class="underline">profile</a>.</span>\n\t\t\t\t<span ng-if="formOptions.hideProfileLink">profile.</span>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<work-pattern-overview index="$index" work-pattern="workPattern"></work-pattern-overview>\n\t</div>\n\n\t<!-- Preview Pattern -->\n\t<div class="form-content-block">\n\t\t<p class="s"><a href="" ng-click="showIsCalendarVisible(vm)"><i class="icon-back m"></i>&nbsp;&nbsp;View pattern in pay period calendar</a></p>\n\t</div>\n</div>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isCalendarVisible">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay period calendar</h5>\n\t\t<a aria-label="Toggle pay period calendar" href="" class="slide-in-form-aside-header-action" ng-click="toggleIsCalendarVisible(vm)"><i class="icon-right l"></i></a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main">\n\t\t<weekly-calendar work-patterns="vm.workPatterns" pay-period="vm.currentPayPeriod"></weekly-calendar>\n\t</div>\n</aside>\n\n<!-- CIS -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="No work pattern to view" ng-if="pageState === \'is-cis\'">\n\t<fs-main>\n\t\t<p class="s">As {{formOptions.context.Forename}} is a CIS subcontractor, work patterns do not apply. As {{formOptions.context.Forename}} is a CIS subcontractor, they don\'t have a work pattern assigned to them.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Not applicable -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Work Patterns aren\'t available" ng-if="pageState === \'not-applicable\'">\n\t<fs-main>\n\t\t<p class="s">Work patterns aren\'t available for companies with a quarterly, bi-annual or annual pay frequency.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/employment/workplace-information/workplace-information.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="workplaceInformationForm" ng-submit="updateTeamMemberCompanyWorkplaceInformation(vm, workplaceInformationForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h6>{{formOptions.context.Forename}}\'s workplace information</h6>\n\t\t<p class="s">You may need to add a workplace postcode for {{formOptions.context.Forename}} if they have been on a freeport or investment zone NI category this tax year.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Workplace Postcode -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="workplaceInformationWorkplacePostcode">Workplace postcode:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="workplaceInformationWorkplacePostcode" name="workplaceInformationWorkplacePostcode" ng-model="vm.workplaceInformation.WorkplacePostcode" ng-pattern="vm.workplaceInformation.WorkplacePostcodeRegex" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="workplaceInformationForm.workplaceInformationWorkplacePostcode.$error" ng-if="workplaceInformationForm.workplaceInformationWorkplacePostcode.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid UK postcode</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="vm.showDelete">\n\t\t<p class="s strong">\n\t\t\t<a data-cy="workplace-information-delete-workplace-information" class="greyscale" ng-click="deleteWorkplaceInformation()"><i class="icon-trash m"></i> Delete workplace information</a>\n\t\t</p>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="workplaceInformationForm.state" disable-button="!workplaceInformationForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- Delete workplace information -->\n<form name="deleteWorkplaceInformationForm" ng-submit="updateTeamMemberCompanyWorkplaceInformation(vm, deleteWorkplaceInformationForm)" class="fadeIn" ng-if="pageState === \'delete-information\'" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure you wish to delete this?" fs-show-close="false">\n\t\t<fs-main>\n\t\t\t<p class="is-small">You can add workplace information to {{formOptions.context.Forename}}\'s profile later if you need to.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Delete\'" state="deleteWorkplaceInformationForm.state" disable-button="!deleteWorkplaceInformationForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/hr/addPayPolicyUpdateForm/addPayPolicyUpdateForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<!-- Show policy summary when viewing or confirming duplication or edit -->\n<form ng-if="pageState === PAGE_STATES.ready" name="addPayPolicyUpdateForm" ng-submit="addPayPolicyUpdate(vm.payPolicyUpdate, addPayPolicyUpdateForm)" novalidate>\n\n\t<!-- Confirm update or update not permitted. Only the confirm step allow progression -->\n\t<div class="form-section fadeIn" ng-if="[UPDATE_STEPS.confirmUpdate, UPDATE_STEPS.updateNotPermitted].includes(updateStep)">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="{{vm.payPolicyCurrent.policyIcon}}" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.payPolicyCurrent.PolicyName}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn">\n\n\t\t\t<!-- Update not permitted -->\n\t\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy can\'t be updated" ng-if="updateStep === UPDATE_STEPS.updateNotPermitted">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThis policy can\u2019t be updated as one or more team members using this policy already has a pay change set up in their pay information.\n\t\t\t\t\t\tYou\u2019ll need to remove these changes before adding your policy update.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t\t<fs-actions>\n\t\t\t\t\t<a href="" ng-click="formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t\t\t</fs-actions>\n\t\t\t</form-state>\n\n\t\t\t<!-- Confirm update -->\n\t\t\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to add a policy update?" ng-if="updateStep === UPDATE_STEPS.confirmUpdate">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThe &lsquo;{{vm.payPolicyCurrent.PolicyName}}&rsquo; policy is being used by the below team members. Once you save your updates,\n\t\t\t\t\t\tpay changes will be added for team members and then applied when you run payroll for {{vm.currentPayPeriod.PayPeriodDisplay}}.\n\t\t\t\t\t\tYou can delete your updates any time before then.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t\t<fs-actions>\n\t\t\t\t\t<a href="" ng-click="formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t\t\t\t<a href="" ng-click="moveToNextUpdateStep(updateStep)" class="button is-tertiary primary-action">Confirm</a>\n\t\t\t\t</fs-actions>\n\t\t\t</form-state>\n\n\t\t\t<!-- Team members shown for confirm update -->\n\t\t\t<div ng-if="updateStep === UPDATE_STEPS.confirmUpdate">\n\t\t\t\t<!-- Search bar -->\n\t\t\t\t<search-bar options="vm.policyTeamMembersSearchOptions" bulk-items="vm.policyTeamMembers"></search-bar>\n\t\t\t\t<div class="team-member-cards" ng-if="vm.policyTeamMembers.all.length !== 0">\n\t\t\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" ng-repeat="teamMember in vm.policyTeamMembers.filtered = ( vm.policyTeamMembers.all | filter : vm.policyTeamMembersSearchOptions.search.string ) | orderBy : vm.policyTeamMembersSearchOptions.orderBy : vm.policyTeamMembersSearchOptions.results.reverse" team-member="teamMember"></team-member-card>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-if="vm.jobGradeTeamMembers.filtered.length === 0 && vm.jobGradeTeamMembers.all.length !== 0" search-bar-options="vm.searchBarOptions">\n\t\t\t\t</empty-search>\n\t\t\t</div>\n\t\t</fieldset>\n\t</div>\n\n\t<div class="form-section fadeIn" ng-if="updateStep === UPDATE_STEPS.policySettings">\n\t\t<div class="form-intro">\n\t\t\t<h5>Policy settings</h5>\n\t\t\t<p class="s">Make any working time changes and set an effective for this policy update then click \u2018Next\u2019 to move on and\n\t\t\t\tupdate your pay points.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Contracted working time only applicable to annualSalary-type pay policies, when these have been set -->\n\t\t<fieldset ng-if="vm.payPolicyUpdate.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<fieldset>\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">Set contracted working time to apply to all team members using this policy.\n\t\t\t\t\t\t\tThe time can be overridden when you set up their pay information.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="workHoursPerWeek">Contracted hours per week:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<number-selector-field field-name="workHoursPerWeek" ng-model="vm.payPolicyUpdate.PolicyHoursPerWeek" max="config.workTimeLimits.hoursPerWeek.max" min="config.workTimeLimits.hoursPerWeek.min" step="config.workTimeLimits.hoursPerWeek.step"></number-selector-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addPayPolicyUpdateForm.workHoursPerWeek.$touched" ng-messages="addPayPolicyUpdateForm.workHoursPerWeek.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.hoursPerWeek.max}} hours</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="config.workTimeLimits.hoursPerWeek.min" when="{\'1\': \'1 hour\', \'other\': \'{} hours\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="workWeeksPerYear">Contracted weeks per year:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<number-selector-field field-name="workWeeksPerYear" ng-model="vm.payPolicyUpdate.PolicyWeeksPerYear" max="config.workTimeLimits.weeksPerYear.max" min="config.workTimeLimits.weeksPerYear.min" step="config.workTimeLimits.weeksPerYear.step"></number-selector-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addPayPolicyUpdateForm.workWeeksPerYear.$touched" ng-messages="addPayPolicyUpdateForm.workWeeksPerYear.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.weeksPerYear.max}} weeks</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="config.workTimeLimits.weeksPerYear.min" when="{\'1\': \'1 week\', \'other\': \'{} weeks\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-note no-bottom-margin">\n\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\tThis assumes a 5 day week and the same daily working hours.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Effective date -->\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<fieldset>\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">Set an effective date that will apply to all team members using this policy.\n\t\t\t\t\t\t\tThe date must be on or before the end of your current pay period.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="effectiveDate">Effective date:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="effectiveDate" field-max-date-iso="vm.currentPayPeriod.EndDateISO" field-value-iso="vm.payPolicyUpdate.PolicyEffectiveDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addPayPolicyUpdateForm.effectiveDate.$error" ng-if="addPayPolicyUpdateForm.effectiveDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the effective date</p>\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{vm.currentPayPeriod.EndDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-note">\n\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\tAn effective date in the past will automatically calculate any backdated payments for team members.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Update policy bands -->\n\t<div class="form-section fadeIn" ng-if="updateStep === UPDATE_STEPS.policyBands">\n\t\t<fieldset class="fadeIn">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>{{utilities.toSentenceCase(vm.payPolicyUpdate.policyBandDescription)}}s</h5>\n\t\t\t\t<p class="s">\n\t\t\t\t\tUpdate {{vm.payPolicyUpdate.policyBandDescription}}s for the \'{{vm.payPolicyUpdate.PolicyName}}\' policy.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Percentage uplift -->\n\t\t\t<fieldset ng-if="vm.percentageUpliftEnabled">\n\t\t\t\t<div class="form-field-highlight primary" data-cy="pay-policy-update-percentage-uplift">\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t<p class="s">Apply a percentage uplift to all {{vm.payPolicyUpdate.policyBandDescription}}s. This will update the annual salary and hourly rate for each {{vm.payPolicyUpdate.policyBandDescription}}.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t\t<div class="form-field" data-cy="pay-policy-update-percentage-uplift-value-input">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="upliftPercentage">Percentage uplift (%):</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-with-action_container">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main with-action">\n\t\t\t\t\t\t\t\t\t\t<input type="number" id="upliftPercentage" name="upliftPercentage" class="pill-input-detail-item_input percentage" ng-model="vm.upliftPercentage" ng-change="clearUpliftPreview(vm)" ng-pattern="$root.REGEX.decimal" min="0" max="100" step="0.010" placeholder="e.g. 2.5">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-action" data-cy="pay-policy-update-percentage-uplift-apply-button">\n\t\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="applyUplift(vm)" ng-class="{\'disabled\': !vm.upliftPercentage || vm.upliftPercentage < 0 || vm.upliftPercentage > 100 || vm.isApplyingUplift}">\n\t\t\t\t\t\t\t\t\t\t\t{{vm.isApplyingUplift ? \'Applying...\' : \'Apply\'}}\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" data-cy="pay-policy-update-percentage-uplift-errors" ng-if="addPayPolicyUpdateForm.upliftPercentage.$touched" ng-messages="addPayPolicyUpdateForm.upliftPercentage.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 0%</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 100%</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid percentage</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid percentage with no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Uplift preview note -->\n\t\t\t<fieldset ng-if="vm.upliftPreview">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Percentage uplift preview">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tReview the uplifted values below. These values will be applied to the {{vm.payPolicyUpdate.policyBandDescription}}s when you save.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\n\t\t\t<!-- The policy band form fields -->\n\t\t\t<fieldset>\n\t\t\t\t<!-- Filter out those marked for deletion. Disable name edit -->\n\t\t\t\t<policy-band-form-field allow-name-edit="policyBand.allowNameEdit" index="$index" ng-repeat="policyBand in policyBandsFiltered = vm.payPolicyUpdate.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" on-view-team-members="viewTeamMembers(policyBand.TeamMembers, vm)" policy="vm.payPolicyUpdate" policy-band="policyBand" previous-policy-band="$index !== 0 ? policyBandsFiltered[$index - 1] : undefined" show-actions="$index !== 0" uplift-preview="vm.upliftPreview"></policy-band-form-field>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Add band -->\n\t\t\t<a class="add-card s stronger fadeIn" href ng-click="addPayPolicyBand(vm.payPolicyUpdate)">\n\t\t\t\t<i class="icon-add m"></i>&nbsp;&nbsp;Add {{vm.payPolicyUpdate.policyBandDescription}}\n\t\t\t</a>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Post-save summary -->\n\t<div class="form-section fadeIn" ng-if="updateStep === UPDATE_STEPS.summary">\n\t\t<div class="form-content-block fadeIn">\n\t\t\t<note note-cheese="Pending" note-dismiss="false" note-emphasise="true" note-icon="icon-loading" note-icon-size="l" note-theme="tertiary" note-title="Update: {{vm.payPolicyUpdate.UpdateEffectiveDateISO | dateformat}}">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Once you run payroll for {{vm.currentPayPeriod.PayPeriodDisplay}} your updates will replace the current settings\n\t\t\t\t\t\tfor this pay policy. You can delete your update below.</p>\n\t\t\t\t\t<div class="form-note">Added by {{vm.payPolicyUpdate.CreatedBy}} on {{vm.payPolicyUpdate.CreatedDateISO | dateformat}}</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn">\n\t\t\t<!-- Tabs for current policy and update -->\n\t\t\t<fieldset>\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<navigation-tabs>\n\t\t\t\t\t   <a ng-class="{\'active\': vm.summaryActiveTab === SUMMARY_TABS.current}" ng-click="changeSummaryTab(SUMMARY_TABS.current, vm)">Current</a>\n\t\t\t\t\t   <a ng-class="{\'active\': vm.summaryActiveTab === SUMMARY_TABS.update}" ng-click="changeSummaryTab(SUMMARY_TABS.update, vm)">Update</a>\n\t\t\t\t\t</navigation-tabs>\n\t\t\t\t</section>\n\t\t\t</fieldset>\n\t\t\t<div class="form-tab-content">\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<icon-dot icon="{{vm.summaryActivePolicy.policyIcon}}" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.summaryActivePolicy.PolicyName}}</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a class="is-primary-light" href="" ng-click="setUpdateStep(UPDATE_STEPS.policySettings)" ng-if="!vm.summaryActivePolicy.IsPolicyRestricted && $root.currentUser.Permissions.HR.canManagePolicies"><i class="icon-edit m"></i></a>\n\t\t\t\t\t\t\t\t<icon-dot icon="icon-padlock" ng-if="vm.summaryActivePolicy.IsPolicyRestricted" theme="is-tertiary has-box-shadow"></icon-dot>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- Summary footer - contracted work hours, pensionable; where applicable -->\n\t\t\t\t\t\t<div class="slide-in-form-info-card_footer">\n\t\t\t\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.summaryActivePolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t\t\t\t<p>Contracted hours per week</p>\n\t\t\t\t\t\t\t\t<p>{{vm.summaryActivePolicy.PolicyHoursPerWeek.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.summaryActivePolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t\t\t\t<p>Contracted weeks per year</p>\n\t\t\t\t\t\t\t\t<p>{{vm.summaryActivePolicy.PolicyWeeksPerYear.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.summaryActivePolicy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<i class="icon-money is-primary"></i>&nbsp;&nbsp;{{vm.summaryActivePolicy.PolicyPensionState === POLICY_PENSION_STATES.inactive ? \'Non-p\' : \'P\'}}ensionable\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- View team members - when there are entries in TeamMembers. Use the current pay policy for this list,\n\t\t\t\t     regardless of active tab, since for the update these have been cleared out. -->\n\t\t\t\t<div class="form-section" ng-if="vm.payPolicy.TeamMembers.length !== 0">\n\t\t\t\t\t<a href="" ng-click="viewTeamMembers(vm.payPolicyCurrent.TeamMembers, vm)" ng-if="vm.payPolicyCurrent.TeamMembers.length !== 0">\n\t\t\t\t\t\t<p class="s strong is-primary">\n\t\t\t\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\tView&nbsp;<ng-pluralize count="vm.payPolicyCurrent.TeamMembers.length" when="{\'1\': \'team member\', \'other\': \'{} team members\'}"></ng-pluralize>&nbsp;using policy\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Policy bands -->\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<h5>\n\t\t\t\t\t\t<pc-pluralise count="vm.summaryActivePolicy.bandsCount" single="{{vm.summaryActivePolicy.policyBandDescription}}" multiple="{{vm.summaryActivePolicy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t<!-- Hide deleted bands in view mode, in case this is the summary view after creating or editing a policy -->\n\t\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.summaryActivePolicy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" policy="vm.summaryActivePolicy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Delete orphan warning -->\n\t<div class="form-section fadeIn" ng-if="updateStep === UPDATE_STEPS.deleteOrphanWarning">\n\t\t<fieldset class="fadeIn">\n\t\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Policy update deleted">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">The policy update has been deleted, but the following team members couldn\'t be automatically re-assigned to a matching band:</p>\n\t\t\t\t\t<ul class="s">\n\t\t\t\t\t\t<li ng-repeat="message in vm.deletionFailureMessages">{{message}}</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="updateStep > 0">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t{{[UPDATE_STEPS.summary, UPDATE_STEPS.deleteOrphanWarning].includes(updateStep) ? \'Close\' : \'Cancel\'}}\n\t\t</a>\n\t\t<a class="button secondary-action" href="" ng-click="moveToPreviousUpdateStep(updateStep)" ng-if="updateStep > UPDATE_STEPS.policySettings && updateStep < UPDATE_STEPS.summary">\n\t\t\tBack\n\t\t</a>\n\t\t<a class="button is-tertiary primary-action" ng-click="moveToNextUpdateStep(updateStep, vm.payPolicyUpdate)" ng-class="{ \'disabled\': addPayPolicyUpdateForm.$invalid }" ng-if="updateStep < UPDATE_STEPS.policyBands">\n\t\t\t{{updateStep === UPDATE_STEPS.confirmUpdate ? \'Confirm\' : \'Next\'}}\n\t\t</a>\n\t\t<a class="button is-tertiary primary-action" ng-click="deletePayPolicyUpdate(addPayPolicyUpdateForm, vm.payPolicyUpdate, formOptions)" ng-if="updateStep === UPDATE_STEPS.summary">\n\t\t\t<span ng-if="addPayPolicyUpdateForm.state !== \'saving\'">\n\t\t\t\tDelete update\n\t\t\t</span>\n\t\t\t<span ng-if="addPayPolicyUpdateForm.state === \'saving\'">\n\t\t\t\t<i class="icon-loading spin"></i>\n\t\t\t</span>\n\t\t</a>\n\t\t<submit-button disable-button="addPayPolicyUpdateForm.$invalid" display-text="\'Save\'" ng-if="updateStep === UPDATE_STEPS.policyBands" state="addPayPolicyUpdateForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- View team members -->\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isTeamMembersViewActive">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>View team members</h5>\n\t\t<a href="" class="slide-in-form-aside-header-action" ng-click="toggleIsTeamMemberViewActive(vm)"><i class="icon-right l"></i></a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main">\n\t\t<search-bar options="vm.policyTeamMembersSearchOptions" bulk-items="vm.policyTeamMembers"></search-bar>\n\t\t<div class="team-member-cards" ng-if="vm.policyTeamMembers.all.length !== 0">\n\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" info="teamMember.PolicyBandName" ng-repeat="teamMember in vm.policyTeamMembers.filtered = ( vm.policyTeamMembers.all | filter : vm.policyTeamMembersSearchOptions.search.string ) | orderBy : vm.policyTeamMembersSearchOptions.orderBy : vm.policyTeamMembersSearchOptions.results.reverse" team-member="teamMember"></team-member-card>\n\t\t</div>\n\t</div>\n</aside>\n\n<!-- Error -->\n<div ng-if="pageState === PAGE_STATES.error">\n\t<error-block></error-block>\n</div>\n');
$templateCache.put('forms/hr/deleteJobGradeForm/deleteJobGradeForm.html','<div ng-if="pageState === PAGE_STATES.ready">\n\t<form name="deleteJobGradeForm" ng-submit="deleteJobGrade(vm.jobGrade, deleteJobGradeForm)" class="fadeIn" novalidate>\n\t\t<div class="form-section">\n\t\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<icon-dot icon="icon-threshold-change" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.jobGrade.PolicyGradeName}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<form-state form-options="formOptions" fs-show-close="false" fs-icon="question-mark" fs-title="Are you sure you wish to delete this job grade?">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s" ng-if="!vm.isJobGradeInUse">\n\t\t\t\t\tDeleting this job grade won\u2019t affect any historical payroll data where it has been used. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t\t<p class="s" ng-if="vm.isJobGradeInUse">\n\t\t\t\t\tThe below team members will no longer have a job grade assigned to them. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- Team members if job grade is in use -->\n\t\t<div ng-if="vm.isJobGradeInUse">\n\t\t\t<search-bar count="vm.jobGradeTeamMembers.filtered.length" ng-if="vm.jobGradeTeamMembers.all.length !== 0" options="vm.searchBarOptions"></search-bar>\n\t\t\t<div class="team-member-cards" ng-if="vm.jobGradeTeamMembers.all.length !== 0">\n\t\t\t\t<team-member-card ng-repeat="jobGradeTeamMember in vm.jobGradeTeamMembers.filtered = ( vm.jobGradeTeamMembers.all | filter : vm.searchBarOptions.search.string ) |\n\t\t\t\t\t\t\t   orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse" team-member="jobGradeTeamMember" agency-profile-id="vm.agencyProfileId">\n\t\t\t\t</team-member-card>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Confirm\'" state="deleteJobGradeForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/hr/deletePolicyForm/deletePolicyForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div ng-if="pageState === PAGE_STATES.ready">\n\t<form class="fadeIn" name="deletePolicyForm" ng-submit="deletePolicy(vm.policy, deletePolicyForm)" novalidate>\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="icon-document" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.policy.PolicyName}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="icon-padlock" ng-if="vm.policy.IsPolicyRestricted" theme="is-tertiary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_section" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<!-- This is currently fixed to a single option -->\n\t\t\t\t<p class="is-primary-light s">Bandings: Full-time equivalent salary</p>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_section" ng-if="[POLICY_CATEGORIES.sickness, POLICY_CATEGORIES.parental].includes(vm.policy.policyCategory)">\n\t\t\t\t<p class="is-primary-light s">Pay rate: {{POLICY_PAY_BASES_DESCRIPTIONS[vm.policy.PolicyPayBasis]}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Policy not locked and not in use - can be deleted -->\n\t\t<form-state form-options="formOptions" fs-icon="information" fs-show-close="false" fs-title="Are you sure you wish to delete this policy?" ng-if="!vm.policy.IsPolicyRestricted && !vm.policy.policyInUse">\n\t\t\t<fs-main>\n\t\t\t\t<!-- Pay policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t\tDeleting this pay policy won\u2019t affect any historical payroll data where it has been used.\n\t\t\t\t\tClick \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t\t<!-- Pension policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t\tOnce this policy is deleted it cannot be undone and will no longer be available to set contributions bands for pension schemes.\n\t\t\t\t\tClick \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t\t<!-- Parental policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.parental">\n\t\t\t\t\tOnce this policy is deleted it cannot be undone. Please note that previously created occupational maternity pay schedules\n\t\t\t\t\twon\u2019t be affected. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t\t<!-- Sickness policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\t\tOnce this policy is deleted it cannot be undone. Please note that previously created occupational sick pay schedules\n\t\t\t\t\twon\u2019t be affected. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- Policy locked - can\'t be deleted -->\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy is locked" ng-if="vm.policy.IsPolicyRestricted">\n\t\t\t<fs-main>\n\t\t\t\t<!-- Pay policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t\tThis pay policy can\u2019t be deleted as it\u2019s currently being used by the\n\t\t\t\t\t<ng-pluralize count="vm.policy.TeamMembers.length" when="{\'1\': \'team member\', \'other\': \'{} team members\'}"></ng-pluralize> below.\n\t\t\t\t\tAdd a policy update with an effective date and any pay rate or working time changes will be automatically added as pay changes for team members.\n\t\t\t\t</p>\n\t\t\t\t<!-- Pension policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t\tThis pension policy can\u2019t be deleted as it\u2019s currently being used by the\n\t\t\t\t\t<ng-pluralize count="vm.policy.PensionSchemes.length" when="{\'1\': \'pension scheme\', \'other\': \'{} pension schemes\'}"></ng-pluralize> below.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- Policy not locked but in use - can\'t be deleted -->\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy is in use" ng-if="!vm.policy.IsPolicyRestricted && vm.policy.policyInUse">\n\t\t\t<fs-main>\n\t\t\t\t<!-- Pay policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t\tThis pay policy can\u2019t be deleted as it\u2019s currently being used by the\n\t\t\t\t\t<ng-pluralize count="vm.policy.TeamMembers.length" when="{\'1\': \'team member\', \'other\': \'{} team members\'}"></ng-pluralize> below.\n\t\t\t\t\tYou need to assign them a new pay policy before deleting this one.\n\t\t\t\t</p>\n\t\t\t\t<!-- Pension policy -->\n\t\t\t\t<p class="s" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t\tThis pension policy can\u2019t be deleted as it\u2019s currently being used by the\n\t\t\t\t\t<ng-pluralize count="vm.policy.PensionSchemes.length" when="{\'1\': \'pension scheme\', \'other\': \'{} pension schemes\'}"></ng-pluralize> below.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- List of team members for locked pay policy and / or policy currently in use -->\n\t\t<div class="team-member-cards" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pay && (vm.policy.IsPolicyRestricted || vm.policy.policyInUse)">\n\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" info="teamMember.PolicyBandName" ng-repeat="teamMember in vm.policy.TeamMembers" team-member="teamMember"></team-member-card>\n\t\t</div>\n\n\t\t<!-- List of pension schemes for locked pension policy and / or policy currently in use -->\n\t\t<div class="policy-pension-scheme-cards" ng-if="vm.policy.policyCategory === POLICY_CATEGORIES.pension && (vm.policy.IsPolicyRestricted || vm.policy.policyInUse)">\n\t\t\t<policy-pension-scheme-card agency-profile-id="vm.agencyProfileId" info="pensionScheme.policyBandName" ng-repeat="pensionScheme in vm.policy.PensionSchemes" pension-scheme="pensionScheme"></policy-pension-scheme-card>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<!-- Submit available if policy not locked and not in use -->\n\t\t\t<submit-button display-text="\'Confirm\'" ng-if="!vm.policy.IsPolicyRestricted && !vm.policy.policyInUse" state="deletePolicyForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>');
$templateCache.put('forms/hr/jobGradeTeamMembersForm/jobGradeTeamMembersForm.html','<form>\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="icon-threshold-change" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.jobGrade.PolicyGradeName}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Search bar -->\n\t<search-bar options="vm.searchBarOptions" count="vm.jobGradeTeamMembers.filtered.length" ng-if="vm.jobGradeTeamMembers.all.length !== 0"></search-bar>\n\n\t<div class="team-member-cards" ng-if="vm.jobGradeTeamMembers.all.length !== 0">\n\t\t<team-member-card agency-profile-id="vm.agencyProfileId" ng-repeat="jobGradeTeamMember in vm.jobGradeTeamMembers.filtered = ( vm.jobGradeTeamMembers.all | filter : vm.searchBarOptions.search.string ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse" team-member="jobGradeTeamMember"></team-member-card>\n\t</div>\n\n\t<!-- No search results -->\n\t<empty-search ng-if="vm.jobGradeTeamMembers.filtered.length === 0 && vm.jobGradeTeamMembers.all.length !== 0" search-bar-options="vm.searchBarOptions">\n\t</empty-search>\n\n\t<!-- \'No job grades\' placeholder -->\n\t<placeholder placeholder-graphic="no-job-grades" placeholder-graphic-size="l" ng-if="vm.jobGradeTeamMembers.all.length === 0">\n\t\t<placeholder-title>Job grade not in use</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Team members using this job grade will appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="goToTeam(vm.agencyProfileId)" class="s strong is-primary">Go to team&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</form>\n');
$templateCache.put('forms/hr/payPolicyHistoryForm/payPolicyHistoryForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form>\n\n\t<!-- Back to history when viewing specific policy -->\n\t<div class="form-section" ng-if="pageState === PAGE_STATES.viewPolicy">\n\t\t<a class="is-greyscale is-small" href="" ng-click="setPageState(PAGE_STATES.viewHistory)">\n\t\t\t<i class="icon-back m"></i>\n\t\t\t<span class="s strong">&nbsp;Back to history</span>\n\t\t</a>\n\t</div>\n\n\t<!-- Reproduce specific history card contents here -->\n\t<div class="form-section" ng-if="pageState === PAGE_STATES.viewPolicy">\n\t\t<pay-policy-history-card pay-policy="vm.historicPayPolicy" show-actions="false"></pay-policy-history-card>\n\t</div>\n\n\t<!-- Policy header, always present -->\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="{{formOptions.payPolicy.policyIcon}}" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<p class="m strong">{{formOptions.payPolicy.PolicyName}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Summary footer - contracted work hours, pensionable; where applicable -->\n\t\t\t<div class="slide-in-form-info-card_footer">\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="formOptions.payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t<p>Contracted hours per week</p>\n\t\t\t\t\t<p>{{formOptions.payPolicy.PolicyHoursPerWeek.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="formOptions.payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t<p>Contracted weeks per year</p>\n\t\t\t\t\t<p>{{formOptions.payPolicy.PolicyWeeksPerYear.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="formOptions.payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<i class="icon-money is-primary-dark"></i>&nbsp;&nbsp;{{formOptions.payPolicy.PolicyPensionState === POLICY_PENSION_STATES.inactive ? \'Non-p\' : \'P\'}}ensionable\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- History -->\n\t<fieldset class="fadeIn" ng-if="pageState === PAGE_STATES.viewHistory">\n\t\t<div class="form-section">\n\t\t\t<div class="pay-policy-history-cards">\n\t\t\t\t<pay-policy-history-card ng-repeat="payPolicy in vm.policyGroup" on-view-settings="onViewSettings(vm, payPolicy)" pay-policy="payPolicy">\n\t\t\t\t</pay-policy-history-card>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Specific policy view -->\n\t<fieldset class="fadeIn" ng-if="pageState === PAGE_STATES.viewPolicy">\n\t\t<div class="form-section">\n\t\t\t<div class="form-section-heading">\n\t\t\t\t<h6>\n\t\t\t\t\t<ng-pluralize count="vm.historicPayPolicy.PolicyBands.length" when="{\n\t\t\t\t\t\t\t\'1\': \'1 pay point\',\n\t\t\t\t\t\t\t\'other\': \'{} pay points\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</h6>\n\t\t\t</div>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<!-- Hide deleted bands in view mode, in case this is the summary view after creating or editing a policy -->\n\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.historicPayPolicy.PolicyBands" policy="vm.historicPayPolicy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/hr/updateJobGradeForm/updateJobGradeForm.html','<div ng-if="pageState === PAGE_STATES.ready">\n\t<form name="updateJobGradeForm" ng-submit="updateJobGrade(vm.jobGrade, updateJobGradeForm)" class="fadeIn" novalidate>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="jobGradeName" class="required">Name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input data-cy="job-grade-name-input" type="text" name="jobGradeName" ng-model="vm.jobGrade.PolicyGradeName" ng-change="checkJobGradeName(vm.jobGrade, vm.jobGrades, updateJobGradeForm.jobGradeName)" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors" ng-messages="updateJobGradeForm.jobGradeName.$error" ng-if="updateJobGradeForm.jobGradeName.$touched" role="alert">\n\t\t\t\t\t<p data-cy="job-grade-name-required-message" ng-message="required">Please enter a name for the job grade</p>\n\t\t\t\t\t<p data-cy="job-grade-name-unique-message" ng-message="{{JOB_GRADE_NAME_NOT_UNIQUE}}">Please ensure the job grade name is unique</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="updateJobGradeForm.state" disable-button="!updateJobGradeForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/hr/updatePayPolicyForm/updatePayPolicyForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<!-- ------------------------------------- Edit ------------------------------------- -->\n<div ng-if="pageState === PAGE_STATES.edit">\n\n\t<form name="updatePayPolicyForm" ng-submit="updatePayPolicy(vm.payPolicy, updatePayPolicyForm)" class="fadeIn" novalidate>\n\n\t\t<!-- Confirm duplication (if duplicating an existing pay policy)-->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.confirmDuplication">\n\t\t\t<form-state form-options="formOptions" fs-show-close="false" fs-icon="information" fs-title="Are you sure you wish to duplicate this policy?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">Duplicating the \u2018{{vm.payPolicy.originalPolicyName}}\u2019 policy will duplicate the settings and the pay points won\u2019t be in use\n\t\t\t\t\t\tby any team members until you set up their pay information. Click \u2018Next\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</fieldset>\n\n\t\t<!-- Pay policy type -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.selectPolicyType">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Which type of pay policy do you wish to add?</h5>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="policyTypeAnnualSalary" name="radioCards" ng-model="vm.payPolicy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.annualSalary" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyTypeAnnualSalary">\n\t\t\t\t\t\t\t\t<i class="icon-wallet radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualSalary]}}</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="policyTypeAnnualAllowance" name="radioCards" ng-model="vm.payPolicy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.annualAllowance" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyTypeAnnualAllowance">\n\t\t\t\t\t\t\t\t<i class="icon-calendar radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualAllowance]}}</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Pay policy - main attributes; name and basis -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.policySettings">\n\t\t\t<div class="form-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Locking pay policies">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">Please note that once a team member using this policy has been run through payroll the policy will be locked\n\t\t\t\t\t\t\tand will no longer be editable. You can add policy updates with an effective date if you need to make changes to it in the future.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Policy settings</h5>\n\t\t\t\t<p class="s">Add settings for this pay policy then click \u2018Next\u2019 to move on and add policy bands.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="payPolicyName" class="required">Policy name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input name="payPolicyName" ng-change="checkPayPolicyName(vm.payPolicy, vm.payPolicies, updatePayPolicyForm.payPolicyName)" ng-model="vm.payPolicy.PolicyName" type="text" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors" ng-if="updatePayPolicyForm.payPolicyName.$touched" ng-messages="updatePayPolicyForm.payPolicyName.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a name for the pay policy</p>\n\t\t\t\t\t<p ng-message="{{PAY_POLICY_NAME_NOT_UNIQUE}}">Please ensure the pay policy name is unique</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Is allowance pensionable? Applicable to annualAllowance-type pay policies -->\n\t\t\t<fieldset ng-if="vm.payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="isAllowancePensionable">Is this allowance pensionable?</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isAllowancePensionableTrue" name="isAllowancePensionable" ng-model="vm.payPolicy.PolicyPensionActive" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="isAllowancePensionableTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isAllowancePensionableFalse" name="isAllowancePensionable" ng-model="vm.payPolicy.PolicyPensionActive" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="isAllowancePensionableFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t </div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Contracted working time only applicable to annualSalary-type pay policies -->\n\t\t\t<fieldset ng-if="vm.payPolicy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<p class="s">Set contracted working time to apply to all team members using this policy.\n\t\t\t\t\t\t\t\tThe time can be overridden when you set up their pay information.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<toggle-input field-label="Set contracted working time" field-model="vm.payPolicy.hasContractedWorkingTime" field-name="hasContractedWorkingTime"></toggle-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<fieldset ng-if="vm.payPolicy.hasContractedWorkingTime">\n\t\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="workHoursPerWeek">Contracted hours per week:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="workHoursPerWeek" ng-model="vm.payPolicy.PolicyHoursPerWeek" max="hourOptions.maxHours" min="hourOptions.minHours" step="hourOptions.stepCount"></number-selector-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePayPolicyForm.workHoursPerWeek.$touched" ng-messages="updatePayPolicyForm.workHoursPerWeek.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{hourOptions.maxHours}} hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{hourOptions.minHours}} hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="workWeeksPerYear">Contracted weeks per year:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="workWeeksPerYear" ng-model="vm.payPolicy.PolicyWeeksPerYear" max="weekOptions.maxWeeks" min="weekOptions.minWeeks" step="weekOptions.stepCount"></number-selector-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePayPolicyForm.workWeeksPerYear.$touched" ng-messages="updatePayPolicyForm.workWeeksPerYear.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{weekOptions.maxWeels}} weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{weekOptions.minWeeks}} weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-note">\n\t\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\t\tThis assumes a 5 day week and the same daily working hours.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<p class="s">Set an effective date that will apply to all team members using this policy.\n\t\t\t\t\t\t\t\tYou can override the date when you set up their pay information.\n\t\t\t\t\t\t\t\tThe date must be on or before the end of your current pay period.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<toggle-input field-label="Set an effective date" field-model="vm.payPolicy.hasEffectiveDate" field-name="hasEffectiveDate"></toggle-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<fieldset ng-if="vm.payPolicy.hasEffectiveDate">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="effectiveDate">Effective date:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="effectiveDate" field-value-iso="vm.payPolicy.PolicyEffectiveDateISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-note">\n\t\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\t\tAn effective date in the past will automatically calculate any backdated payments for team members.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<!-- Pay points for this policy -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.policyPayPoints">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Pay points</h5>\n\t\t\t\t<p class="s">Add pay points for the \u2018{{vm.payPolicy.PolicyName}}\u2019 policy.</p>\n\t\t\t</div>\n\t\t\t<fieldset>\n\t\t\t\t<pay-policy-band-form-field index="$index" ng-repeat="policyBand in vm.payPolicy.PolicyBands" on-view-team-members="viewTeamMembers(policyBand.TeamMembers, vm)" pay-policy="vm.payPolicy" policy-band="policyBand" show-actions="$index !== 0"></pay-policy-band-form-field>\n\t\t\t</fieldset>\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="addPolicyBand(vm.payPolicy, vm.emptyPolicyBand)" type="button">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add pay point\n\t\t\t</button>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<a class="button is-tertiary primary-action" href="" ng-click="moveToNextStep(editStep)" ng-class="{ \'disabled\': updatePayPolicyForm.$invalid }" ng-if="editStep !== EDIT_STEPS.EDIT_STEPS_COUNT">\n\t\t\t\tNext\n\t\t\t</a>\n\t\t\t<submit-button disable-button="updatePayPolicyForm.$invalid" display-text="\'Save\'" ng-if="editStep === EDIT_STEPS.EDIT_STEPS_COUNT" state="updatePayPolicyForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<!-- ------------------------------------- View ------------------------------------- -->\n<div ng-if="pageState === PAGE_STATES.view">\n\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="icon-document" theme="is-primary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<p class="m strong">{{vm.payPolicy.PolicyName}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<a aria-label="Edit policy" href="" ng-click="editPayPolicy(formOptions)" ng-if="!vm.payPolicy.PolicyLocked && $root.currentUser.Permissions.HR.canManagePolicies"><i class="icon-edit m"></i></a>\n\t\t\t\t\t<icon-dot icon="icon-padlock" ng-if="vm.payPolicy.PolicyLocked" theme="is-tertiary"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_section">\n\t\t\t\t<p class="is-primary-light s" ng-if="vm.payPolicy.hasEffectiveDate">\n\t\t\t\t\tEffective: {{vm.payPolicy.PolicyEffectiveDateISO | dateformat}}</p>\n\t\t\t\t<p class="is-primary-light italic s" ng-if="!vm.payPolicy.hasEffectiveDate">\n\t\t\t\t\tEffective date not set\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_footer">\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.payPolicy.hasContractedWorkingTime">\n\t\t\t\t\t<p>Contracted hours per week</p>\n\t\t\t\t\t<p>{{vm.payPolicy.PolicyHoursPerWeek.toFixed(salaryRatesPrecision)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.payPolicy.PolicyPensionActive">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<i class="icon-money is-primary"></i>&nbsp;&nbsp;Pensionable\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.payPolicy.hasContractedWorkingTime">\n\t\t\t\t\t<p>Contracted weeks per year</p>\n\t\t\t\t\t<p>{{vm.payPolicy.PolicyWeeksPerYear.toFixed(salaryRatesPrecision)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="!vm.payPolicy.hasContractedWorkingTime">\n\t\t\t\t\t<p class="italic is-primary-light">Contracted working time not set</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tClose\n\t\t\t</a>\n\t\t</fieldset>\n\t</div>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy is locked" ng-if="vm.showPolicyLockedWarning">\n\t\t<fs-main>\n\t\t<p class="s">This pay policy can\u2019t be edited as it\u2019s currently being used by\n\t\t\t<ng-pluralize count="vm.payPolicy.TeamMembers.length" when="{\'1\': \'team member\', \'other\': \'{} team members\'}"></ng-pluralize>.\n\t\t\tAdd a policy update with an effective date and any pay rate or working time changes will be automatically added as pay changes for team members.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<div class="form-section" ng-if="vm.payPolicy.TeamMembers.length !== 0">\n\t\t<a href="" ng-click="viewTeamMembers(vm.payPolicy.TeamMembers, vm)" ng-if="vm.payPolicy.TeamMembers.length !== 0">\n\t\t\t<p class="s strong is-primary">\n\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;\n\t\t\t\t\tView&nbsp;<ng-pluralize count="vm.payPolicy.TeamMembers.length" when="{\'1\': \'team member\', \'other\': \'{} team members\'}"></ng-pluralize>&nbsp;using policy\n\t\t\t</p>\n\t\t</a>\n\t</div>\n\n\t<div class="form-note" ng-if="vm.payPolicy.TeamMembers.length === 0">\n\t\tThis pay policy isn\'t being used by any team members\n\t</div>\n\n\t<div class="form-section">\n\t\t<h5><ng-pluralize count="vm.payPolicy.PolicyBands.length" when="{ \'1\': \'1 pay point\', \'other\': \'{} pay points\'}"></ng-pluralize></h5>\n\t</div>\n\n\t<div class="pay-policy-band-cards">\n\t\t<policy-band-card ng-repeat="policyBand in vm.payPolicy.PolicyBands" policy="vm.payPolicy" policy-band="policyBand"></policy-band-card>\n\t</div>\n\n</div>\n\n<!-- Error -->\n<div ng-if="pageState === PAGE_STATES.error">\n\t<error-block></error-block>\n</div>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isTeamMemberViewActive">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>View team members</h5>\n\t\t<a href="" class="slide-in-form-aside-header-action" ng-click="toggleIsTeamMemberViewActive(vm)" aria-label="Hide team members"><i class="icon-right l"></i></a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main">\n\t\t<search-bar options="vm.policyTeamMembersSearchOptions" bulk-items="vm.policyTeamMembers"></search-bar>\n\t\t<div class="team-member-cards" ng-if="vm.policyTeamMembers.all.length !== 0">\n\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" info="teamMember.PolicyBandName" ng-repeat="teamMember in vm.policyTeamMembers.filtered = ( vm.policyTeamMembers.all | filter : vm.policyTeamMembersSearchOptions.search.string ) | orderBy : vm.policyTeamMembersSearchOptions.orderBy : vm.policyTeamMembersSearchOptions.results.reverse" team-member="teamMember"></team-member-card>\n\t\t</div>\n\t</div>\n</aside>\n');
$templateCache.put('forms/hr/updatePolicyForm/updatePolicyForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<!-- Show policy summary when viewing or confirming duplication or edit.\n\t In view mode, hide for duplication (update pending) warning -->\n<form ng-if="\n\t(\n\t\tpageState === PAGE_STATES.view &&\n\t\t!vm.showPolicyUpdatePendingWarning\n\t) ||\n\t(\n\t\tpageState === PAGE_STATES.edit &&\n\t\t(\n\t\t\teditStep === EDIT_STEPS.confirmDuplication ||\n\t\t\teditStep === EDIT_STEPS.confirmEdit\n\t\t)\n\t)">\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="{{vm.policy.policyIcon}}" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<div class="slide-in-form-info-card_title">{{editStep === EDIT_STEPS.confirmDuplication ? vm.policy.originalPolicyName : vm.policy.PolicyName}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if="![EDIT_STEPS.confirmEdit, EDIT_STEPS.confirmDuplication].includes(editStep)">\n\t\t\t\t\t<!-- Don\'t allow edit for newly created policy. Going back to edit at this point will cause a new policy to be created -->\n\t\t\t\t\t<a aria-label="Edit policy" class="is-primary-light" href="" ng-click="editPolicy(vm, formOptions)" ng-if="!vm.policy.IsPolicyRestricted && $root.currentUser.Permissions.HR.canManagePolicies && ![UPDATE_POLICY_MODES.create, UPDATE_POLICY_MODES.duplicate].includes(vm.updatePolicyMode)"><i class="icon-edit m"></i></a>\n\t\t\t\t\t<icon-dot icon="icon-padlock" ng-if="vm.policy.IsPolicyRestricted" theme="is-tertiary has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_section">\n\t\t\t\t<p class="is-primary-light is-small" ng-switch="vm.policyCategory">\n\t\t\t\t\t<!-- Parental / Sickness -->\n\t\t\t\t\t<span pc-switch-when="[POLICY_CATEGORIES.parental, POLICY_CATEGORIES.sickness]">Pay rate: {{POLICY_PAY_BASES_DESCRIPTIONS[vm.policy.PolicyPayBasis]}}</span>\n\t\t\t\t\t<!-- Bandings (pension only) -->\n\t\t\t\t\t<span pc-switch-when="POLICY_CATEGORIES.pension">Bandings: {{POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS[vm.policy.PolicyBandCalculation]}}</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<!-- Summary footer - pay policy only. Contracted work hours, pensionable; where applicable -->\n\t\t\t<div class="slide-in-form-info-card_footer" ng-if="vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.policy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t<p>Contracted hours per week</p>\n\t\t\t\t\t<p>{{vm.policy.PolicyHoursPerWeek.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.policy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t\t<p>Contracted weeks per year</p>\n\t\t\t\t\t<p>{{vm.policy.PolicyWeeksPerYear.toFixed(config.precision.salaryRates)}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_item" ng-if="vm.policy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<i class="icon-money is-primary-dark"></i>&nbsp;&nbsp;{{vm.policy.PolicyPensionState === POLICY_PENSION_STATES.inactive ? \'Non-p\' : \'P\'}}ensionable\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</form>\n\n<!-- ---------------------- Edit mode ---------------------- -->\n<div ng-if="pageState === PAGE_STATES.edit">\n\n\t<form class="fadeIn" name="updatePolicyForm" ng-submit="updatePolicy(vm.policy, updatePolicyForm)" novalidate>\n\t\t<!-- Confirm edit (if editing an exising policy)-->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.confirmEdit">\n\t\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Are you sure you wish to edit this policy?">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPlease note that making changes to this policy won\u2019t automatically update any {{POLICY_TYPE_NAMES[vm.policy.PolicyType].toLowerCase()}}\n\t\t\t\t\t\tschedules that have already been created. Those schedules will need to be deleted and created again.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</fieldset>\n\n\t\t<!-- Confirm duplication (if duplicating an existing policy)-->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.confirmDuplication">\n\t\t\t<form-state form-options="formOptions" fs-icon="information" fs-show-close="false" fs-title="Are you sure you wish to duplicate this policy?">\n\t\t\t\t<fs-main ng-switch="vm.policyCategory">\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_CATEGORIES.pay">\n\t\t\t\t\t\tDuplicating the \u2018{{vm.policy.originalPolicyName}}\u2019 policy will duplicate the settings and the pay points won\u2019t be in use\n\t\t\t\t\t\tby any team members until you set up their pay information. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_CATEGORIES.parental">\n\t\t\t\t\t\tDuplicating the \u2018{{vm.policy.originalPolicyName}}\u2019 policy will duplicate the settings and policy bands\n\t\t\t\t\t\tbut it won\u2019t be used until you select it when adding occupational maternity pay for a team member. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_CATEGORIES.pension">\n\t\t\t\t\t\tDuplicating the \u2018{{vm.policy.originalPolicyName}}\u2019 policy will duplicate the settings and the contribution bands won\u2019t be in used by\n\t\t\t\t\t\tany team members until you add them to a pension scheme that uses it. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_CATEGORIES.sickness">\n\t\t\t\t\t\tDuplicating the \u2018{{vm.policy.originalPolicyName}}\u2019 policy will duplicate the settings and policy bands\n\t\t\t\t\t\tbut it won\u2019t be used until you select it when adding occupational sick pay for a team member. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t\t</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</fieldset>\n\n\t\t<!-- ---- Pay policy basis (pay policies only ) ---- -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.selectPolicyPayBasis">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Which type of {{vm.policyCategory}} policy do you wish to add?</h5>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="policyTypeAnnualSalary" name="radioCards" ng-model="vm.policy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.annualSalary" type="radio" required>\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyTypeAnnualSalary">\n\t\t\t\t\t\t\t\t<i class="icon-wallet radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualSalary]}}</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="policyTypeAnnualAllowance" name="radioCards" ng-model="vm.policy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.annualAllowance" type="radio" required>\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyTypeAnnualAllowance">\n\t\t\t\t\t\t\t\t<i class="icon-calendar radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualAllowance]}}</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- ------------- Edit policy settings ------------- -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.policySettings">\n\t\t\t<!-- Locked warning - pay policies -->\n\t\t\t<div class="form-section" ng-if="vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Locking pay policies">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note that once a team member using this policy has been run through payroll the policy will be locked\n\t\t\t\t\t\t\tand will no longer be editable. You can add policy updates with an effective date if you need to make changes to it in the future.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>Policy settings</h5>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tAdd settings for this {{vm.policyCategory}} policy then click \u2018Next\u2019 to move on and\n\t\t\t\t\t{{vm.updatePayPolicyMode === UPDATE_POLICY_MODES.import ? \'import\' : \'add\'}}\n\t\t\t\t\t{{vm.policy.policyBandDescription}}s.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Policy type (where required) -->\n\t\t\t<div class="form-field" ng-if="vm.policy.showPolicyType">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="policyType">\n\t\t\t\t\t\tPolicy type:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="policyType" name="policyType" ng-change="updatePolicyForm.policyName.$validate()" ng-model="vm.policy.PolicyType" ng-options="policyType.policyType as policyType.description for policyType in vm.policyTypes" required>\n\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Policy name (applicable to all) -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="policyName">\n\t\t\t\t\t\tPolicy name:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input data-cy="{{vm.policyCategory}}-policy-name-input" name="policyName" ng-model-options="{ debounce: 250 }" ng-model="vm.policy.PolicyName" policy-name-exists policy-name-exists-agency-profile-id="vm.agencyProfileId" policy-name-exists-original="vm.policy.PolicyName" policy-name-exists-policy-id="vm.policy.PolicyID" policy-name-exists-policy-type="vm.policy.PolicyType" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors" ng-if="updatePolicyForm.policyName.$touched" ng-messages="updatePolicyForm.policyName.$error" role="alert">\n\t\t\t\t\t<p data-cy="policy-name-require-message" ng-message="required">\n\t\t\t\t\t\tPlease enter a name for the {{vm.policyCategory}} policy\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="policy-name-type-required-message" ng-message="{{POLICY_NAME_TYPE_REQUIRED}}">\n\t\t\t\t\t\tPlease select a policy type to check name uniqueness\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="policy-name-unique-message" ng-message="{{POLICY_NAME_EXISTS}}">\n\t\t\t\t\t\tPlease ensure the {{vm.policyCategory}} policy name is unique\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Policy code (applicable to sickness policies only) -->\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="policyCode">\n\t\t\t\t\t\tPolicy code:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input data-cy="{{vm.policyCategory}}-policy-code-input" maxlength="50" name="policyCode" ng-model-options="{ debounce: 250 }" ng-model="vm.policy.PolicyCode" ng-pattern="$root.REGEX.lettersNumbersAndSymbols" policy-code-exists policy-code-exists-agency-profile-id="vm.agencyProfileId" policy-code-exists-original="vm.policy.PolicyCode" policy-code-exists-policy-id="vm.policy.PolicyID" policy-code-exists-policy-type="vm.policy.PolicyType" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors" ng-if="updatePolicyForm.policyCode.$touched" ng-messages="updatePolicyForm.policyCode.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Only letters, numbers, and the plus (+), minus (-) and ampersand (&) symbols are allowed</p>\n\t\t\t\t\t<p ng-message="maxlength">Only 50 characters are allowed</p>\n\t\t\t\t\t<p data-cy="policy-code-unique-message" ng-message="{{POLICY_CODE_EXISTS}}">\n\t\t\t\t\t\tPlease ensure the {{vm.policyCategory}} policy code is unique\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Is allowance pensionable? Applicable to annualAllowance-type pay policies only -->\n\t\t\t<fieldset ng-if="vm.policyCategory === POLICY_CATEGORIES.pay && vm.policy.PolicyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="isAllowancePensionableActive">Is this allowance pensionable?</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isAllowancePensionableActive" name="isAllowancePensionableActive" ng-model="vm.policy.PolicyPensionState" ng-value="POLICY_PENSION_STATES.active" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isAllowancePensionableActive">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="isAllowancePensionableInactive" name="isAllowancePensionableInactive" ng-model="vm.policy.PolicyPensionState" ng-value="POLICY_PENSION_STATES.inactive" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="isAllowancePensionableInactive">\n\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t </div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Contracted working time only applicable to annualSalary-type pay policies -->\n\t\t\t<fieldset ng-if="vm.policyCategory === POLICY_CATEGORIES.pay && vm.policy.PolicyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tSet contracted working time to apply to all team members using this policy.\n\t\t\t\t\t\t\tThe time can be overridden when you set up their pay information.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="workHoursPerWeek">\n\t\t\t\t\t\t\t\t\t\tContracted hours per week:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="workHoursPerWeek" max="config.workTimeLimits.hoursPerWeek.max" min="config.workTimeLimits.hoursPerWeek.min" ng-model="vm.policy.PolicyHoursPerWeek" ng-regex-key="contractedWorkingTimesRegEx" step="config.workTimeLimits.hoursPerWeek.step"></number-selector-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePolicyForm.workHoursPerWeek.$touched" ng-messages="updatePolicyForm.workHoursPerWeek.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.hoursPerWeek.max}} hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="config.workTimeLimits.hoursPerWeek.min" when="{\'1\': \'1 hour\', \'other\': \'{} hours\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="workWeeksPerYear">\n\t\t\t\t\t\t\t\t\t\tContracted weeks per year:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t<number-selector-field field-name="workWeeksPerYear" max="config.workTimeLimits.weeksPerYear.max" min="config.workTimeLimits.weeksPerYear.min" ng-model="vm.policy.PolicyWeeksPerYear" ng-regex-key="contractedWorkingTimesRegEx" step="config.workTimeLimits.weeksPerYear.step"></number-selector-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePolicyForm.workWeeksPerYear.$touched" ng-messages="updatePolicyForm.workWeeksPerYear.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.weeksPerYear.max}} weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of\n\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="config.workTimeLimits.weeksPerYear.min" when="{\'1\': \'1 week\', \'other\': \'{} weeks\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-note no-bottom-margin">\n\t\t\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\t\t\tThis assumes a 5 day week and the same daily working hours.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Sickness year (sickness policies only ... obviously)-->\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="policyType">\n\t\t\t\t\t\tSickness year:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="policyType" name="policyType" ng-model="vm.policy.PolicyYearBasis" ng-options="policyYearBasisType.policyYearBasis as policyYearBasisType.description for policyYearBasisType in vm.policyYearBasesTypes" required>\n\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\t<div class="form-field-subheading">\n\t\t\t\t\t<p class="s">When setting up a sickness policy, you can choose the calculation method\n\t\t\t\t\t\tto use either the number of working days the employee is absent or the number\n\t\t\t\t\t\tof calendar days they are absent\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<label class="required" for="calculationBasisSicknessPolicyCalendarDays">\n\t\t\t\t\tCalculate based on:\n\t\t\t\t</label>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="calculationBasisSicknessPolicyCalendarDays" name="calculationBasis" ng-model="vm.policy.PolicyDailyRateCalculationMethod" ng-value="0" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="calculationBasisSicknessPolicyCalendarDays">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Calendar Days</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="calculationBasisSicknessPolicyPayPeriod" name="calculationBasis" ng-model="vm.policy.PolicyDailyRateCalculationMethod" ng-value="1" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="calculationBasisSicknessPolicyPayPeriod">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Working Days</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</main>\n\t\t\t</div>\n\n\t\t\t<!-- Entitlement bands basis (sickness policies only)-->\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<extended-toggle-input field-label="Base entitlement bands on length of service" field-model="vm.policy.baseBandsOnLengthOfService" field-name="baseBandsOnLengthOfService" field-on-change="onBaseBandsOnLengthOfServiceChange(vm.policy)">\n\t\t\t\t\t\t<field-description>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tTurn this on if you want entitlement bands to be automatically selected for team member\u2019s based on their start or\n\t\t\t\t\t\t\t\tcontinuous employment date, instead of selecting them manually.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</field-description>\n\t\t\t\t\t\t<field-content>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="lengthOfServiceStartDate">Calculate length of service from:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<!-- Length of service options -->\n\t\t\t\t\t\t\t\t\t<div class="radio-list--inline has-uniform-spacing">\n\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t<input class="b" id="lengthOfServiceStartDate" name="lengthOfServiceType" ng-model="vm.policy.PolicyServiceEntitlement" ng-value="POLICY_SERVICE_ENTITLEMENTS.serviceFromStartDate" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label for="lengthOfServiceStartDate">Start date</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t\t<input class="b" id="lengthOfServiceContinuousEmployment" name="lengthOfServiceType" ng-model="vm.policy.PolicyServiceEntitlement" ng-value="POLICY_SERVICE_ENTITLEMENTS.serviceContinuous" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label for="lengthOfServiceContinuousEmployment">Continuous employment date</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-note no-bottom-margin">\n\t\t\t\t\t\t\t\t\t\tPlease note that where a team member doesn\u2019t have a continuous employment date saved, their start date will be used.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</field-content>\n\t\t\t\t\t</extended-toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Rates of pay type (parental and sickness policies)-->\n\t\t\t<div class="form-field" ng-if="[POLICY_CATEGORIES.parental, POLICY_CATEGORIES.sickness].includes(vm.policyCategory)">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="policyBandRate">Set rates of pay using:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="policyPayBasisAverageWeeklyPercent" name="policyPayBasis" ng-model="vm.policy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.averageWeeklyPercent" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-row-label" for="policyPayBasisAverageWeeklyPercent">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.averageWeeklyPercent]}}</p>\n\t\t\t\t\t\t\t\t<p class="radio-row-info">Payments will be based on the average weekly earnings calculated in the eight week qualifying period.</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="policyPayBasisAnnualSalaryPercent" name="policyPayBasis" ng-model="vm.policy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.annualSalaryPercent" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-row-label" for="policyPayBasisAnnualSalaryPercent">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualSalaryPercent]}}</p>\n\t\t\t\t\t\t\t\t<p class="radio-row-info">\n\t\t\t\t\t\t\t\t\tPayments will be based on the team members annual salary at the time their\n\t\t\t\t\t\t\t\t\t<span ng-if="vm.policyCategory === POLICY_CATEGORIES.parental">maternity schedule is created.</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">sickness begins.</span>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="policyPayBasisFixedAmount" name="policyPayBasis" ng-model="vm.policy.PolicyPayBasis" ng-value="POLICY_PAY_BASES.fixedAmount" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-row-label" for="policyPayBasisFixedAmount">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.fixedAmount]}}</p>\n\t\t\t\t\t\t\t\t<p class="radio-row-info">Enter payments as fixed amounts.</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Define contribution rates (pension policies) -->\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="policyBandRate">Define contribution rates as:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="policyBandRatePercentage" name="policyBandRate" ng-change="onPolicyBandRateChange(vm.policy, vm.policy.PolicyBandRateTypeEmployer)" ng-model="vm.policy.PolicyBandRateTypeEmployer" ng-value="POLICY_BAND_RATE_TYPES.percentage" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyBandRatePercentage">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Percentage (%)</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="policyBandRateFixedValue" name="policyBandRate" ng-change="onPolicyBandRateChange(vm.policy, vm.policy.PolicyBandRateTypeEmployer)" ng-model="vm.policy.PolicyBandRateTypeEmployer" ng-value="POLICY_BAND_RATE_TYPES.fixedValue" ` required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="policyBandRateFixedValue">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Fixed value (\xA3)</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Assign contribution bands (pension policies) -->\n\t\t\t<div class="form-field" ng-if="vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="policyBandRateType">\n\t\t\t\t\t\tAssign contribution bands\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="policyBandRateType" name="policyBandRateType" ng-model="vm.policy.PolicyBandCalculation" ng-options="policyBandCalculationType.policyBandCalculation as policyBandCalculationType.description for policyBandCalculationType in vm.policyBandCalculationTypes" required>\n\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-note" ng-switch="vm.policy.PolicyBandCalculation">\n\t\t\t\t\t<p class="is-small" pc-switch-when="[POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod, POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod]">\n\t\t\t\t\t\tContribution bands for team members will be based on payroll changes for them in your current period.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\t\t\tYou\u2019ll be able to enter a full-time equivalent salary for team members as you add them to a pension scheme using this policy.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" pc-switch-when="POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t\t\t\tYou\u2019ll be able to select a contribution band for team members as you add them to a pension scheme using this policy.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- ----------------- Edit bands ----------------- -->\n\t\t<fieldset class="fadeIn" ng-if="editStep === EDIT_STEPS.policyBands" ng-switch="vm.policyCategory">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h5>{{utilities.toSentenceCase(vm.policy.policyBandDescription)}}s</h5>\n\t\t\t\t<p class="is-small" pc-switch-when="POLICY_CATEGORIES.pay">\n\t\t\t\t\tAdd {{vm.policy.policyBandDescription}}s for the \u2018{{vm.policy.PolicyName}}\u2019 policy.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" pc-switch-when="[POLICY_CATEGORIES.parental, POLICY_CATEGORIES.sickness]">\n\t\t\t\t\tPay rates for {{vm.policy.policyBandDescription}}s are set to \'{{POLICY_PAY_BASES_DESCRIPTIONS[vm.policy.PolicyPayBasis]}}\'.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" ng-switch="vm.policy.PolicyBandCalculation" pc-switch-when="POLICY_CATEGORIES.pension">\n\t\t\t\t\t{{utilities.toSentenceCase(vm.policy.policyBandDescription)}}s\n\t\t\t\t\t<span pc-switch-when="POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod">\n\t\t\t\t\t\twill be based on the team member\'s pensionable pay for the period.\n\t\t\t\t\t</span>\n\t\t\t\t\t<span pc-switch-when="POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod">\n\t\t\t\t\t\twill be based on the team member\'s annualised pensionable pay for the period.\n\t\t\t\t\t</span>\n\t\t\t\t\t<span pc-switch-when="POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t\t\t\twill need to be assigned manually to team members as you add them to a pension scheme using this policy.\n\t\t\t\t\t</span>\n\t\t\t\t\t<span pc-switch-when="POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\t\t\twill be based on a full-time equivalent salary entered for team members as you add them to a pension scheme using this policy.\n\t\t\t\t\t</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- \'and above\' note for pension and sickness policies -->\n\t\t\t<div class="form-section" ng-if="vm.policyCategory === POLICY_CATEGORIES.pension ||\n\t\t\t\t\t\t(vm.policyCategory === POLICY_CATEGORIES.sickness && vm.policy.PolicyServiceEntitlement !== POLICY_SERVICE_ENTITLEMENTS.none)">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Using the \'and above\' toggle for the final policy band">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Toggle on the \'and above\' switch for the final band in your policy so there\'s no upper limit (e.g. \xA360,000.00 and above).</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Option to set same employer rate for all bands (pensions)-->\n\t\t\t<fieldset ng-if="vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<extended-toggle-input field-label="Use the same employer contribution rate for all bands" field-model="vm.policy.useSameEmployerContributionRateForAllBands" field-name="useSameEmployerContributionRateForAllBands">\n\t\t\t\t\t<field-content>\n\t\t\t\t\t\t<div class="form-field" ng-if="vm.policy.PolicyBandRateTypeEmployer === POLICY_BAND_RATE_TYPES.percentage" ~>\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="fixedEmployerContribution">\n\t\t\t\t\t\t\t\t\tEmployer contribution (%):\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<number-selector-field field-name="fixedEmployerContribution" ng-model="vm.policy.fixedEmployerContribution" ng-regex-key="decimalFourPlaces"></number-selector-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePolicyForm.fixedEmployerContribution.$touched" ng-messages="updatePolicyForm.fixedEmployerContribution.$error" ng-required="true" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the fixed employer contribution</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field" ng-if="vm.policy.PolicyBandRateTypeEmployer === POLICY_BAND_RATE_TYPES.fixedValue">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="fixedEmployerContribution">\n\t\t\t\t\t\t\t\t\tEmployer contribution (\xA3):\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input id="fixedEmployerContribution" name="fixedEmployerContribution" ng-max="config.occupationalPoliciesMaxSalary" ng-model="vm.policy.fixedEmployerContribution" ng-pattern="::regexService.salaryRatesRegEx" required type="number">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updatePolicyForm.fixedEmployerContribution.$touched" ng-messages="updatePolicyForm.fixedEmployerContribution.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">The maximum value is {{config.occupationalPoliciesMaxSalary}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a number with no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the fixed employer contribution</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\t\t\t</fieldset>\n\n\t\t\t<!-- The policy band form fields -->\n\t\t\t<fieldset>\n\t\t\t\t<!-- Filter out those marked for deletion -->\n\t\t\t\t<policy-band-form-field index="$index" ng-repeat="policyBand in policyBandsFiltered = vm.policy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" on-view-team-members="showTeamMembersView(vm, policyBand.TeamMembers)" policy="vm.policy" policy-band="policyBand" previous-policy-band="$index !== 0 ? policyBandsFiltered[$index - 1] : undefined" show-actions="$index !== 0"></policy-band-form-field>\n\t\t\t</fieldset>\n\t\t\t<!-- Add band, hidden when last band has infinite upper range (where applicable) - i.e. \'and above\' is selected -->\n\t\t\t<button class="is-medium-large is-white is-block" data-cy="add-{{vm.policyCategory}}-band-button" ng-click="policyService.createPolicyBand(vm.policy)" ng-if="!vm.policy.lastBand.isUpperRangeInfinite" type="button">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add {{vm.policy.policyBandDescription}}\n\t\t\t</button>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="policies-close-form" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<a class="button secondary-action" data-cy="policies-move-to-previous-step" href="" ng-click="moveToPreviousStep(editStep)" ng-if="editStep > EDIT_STEPS.policySettings">\n\t\t\t\tBack\n\t\t\t</a>\n\t\t\t<a class="button is-tertiary primary-action" data-cy="policies-move-to-next-step" href="" ng-click="moveToNextStep(editStep, vm.policy)" ng-class="{ \'disabled\': updatePolicyForm.$invalid || updatePolicyForm.$pending }" ng-if="editStep !== EDIT_STEPS.EDIT_STEPS_COUNT">\n\t\t\t\t{{editStep === EDIT_STEPS.confirmDuplication ? \'Confirm\' : \'Next\'}}\n\t\t\t</a>\n\t\t\t<submit-button disable-button="updatePolicyForm.$invalid" display-text="\'Save\'" ng-if="editStep === EDIT_STEPS.EDIT_STEPS_COUNT" state="updatePolicyForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- ---------------------- View mode ---------------------- -->\n<div ng-if="pageState === PAGE_STATES.view">\n\n\t<form>\n\t\t<!-- Locked message. Only really applicable to pension and pay policies, but here for all just in case.-->\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy is locked" ng-if="vm.showPolicyLockedWarning">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThis {{vm.policyCategory}} policy can\u2019t be edited as it\u2019s currently being used by the\n\t\t\t\t\t\t<!-- Extend message for pay policies, as there will be additional information about assigned pension schemes -->\n\t\t\t\t\t\t<span ng-if="vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t\t\t\t<ng-pluralize count="vm.policy.TeamMembers.length" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<!-- Extend message for pension policies, as there will be additional information about assigned pension schemes -->\n\t\t\t\t\t\t<span ng-if="vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t\t\t\t<ng-pluralize count="vm.policy.PensionSchemes.length" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'1 pension scheme\',\n\t\t\t\t\t\t\t\t\t\'other\': \'{} pension schemes\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\tbelow.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="team-member-cards">\n\t\t\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" info="teamMember.PolicyBandName" ng-repeat="teamMember in vm.policyTeamMembers.filtered = (\n\t\t\t\t\t\t\t\tvm.policyTeamMembers.all |\n\t\t\t\t\t\t\t\tfilter : vm.policyTeamMembersSearchOptions.search.string\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy : vm.policyTeamMembersSearchOptions.orderBy : vm.policyTeamMembersSearchOptions.results.reverse" team-member="teamMember"></team-member-card>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- Can\'t duplicate message, when a policy update is pending -->\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="This policy can\'t be duplicated" ng-if="vm.showPolicyUpdatePendingWarning">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note that this policy can\u2019t be duplicated at the moment as there\u2019s an update pending.\n\t\t\t\t\tOnce the update is applied when you next run payroll you\u2019ll be able to duplicate as normal.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- Don\'t show any summary information when warnings being shown -->\n\t\t<div ng-if="\n\t\t\t!vm.showPolicyUpdatePendingWarning &&\n\t\t\t!vm.showPolicyLockedWarning\n\t\t">\n\t\t\t<!-- View team members - when there are entries in TeamMembers. Show only for pay policies -->\n\t\t\t<div class="form-section" ng-if="vm.payPolicy.TeamMembers.length !== 0 && vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t<a href="" ng-click="showTeamMembersView(vm, vm.policy.TeamMembers)" ng-if="vm.policy.TeamMembers.length !== 0 && !vm.isTeamMembersViewActive">\n\t\t\t\t\t<p class="s strong is-primary" ng-if="!vm.isTeamMembersViewActive">\n\t\t\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;\n\t\t\t\t\t\tView\n\t\t\t\t\t\t<ng-pluralize count="vm.policy.TeamMembers.length" when="{\n\t\t\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\tusing policy\n\t\t\t\t\t</p>\n\t\t\t\t</a>\n\t\t\t\t<a href="" ng-click="hideTeamMembersView(vm)" ng-if="vm.policy.TeamMembers.length !== 0 && vm.isTeamMembersViewActive">\n\t\t\t\t\t<p class="s strong is-primary fadeIn" ng-if="vm.isTeamMembersViewActive">\n\t\t\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Close team members list\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="s strong is-primary" ng-if="!vm.isTeamMembersViewActive">\n\t\t\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;\n\t\t\t\t\t\tView\n\t\t\t\t\t\t<ng-pluralize count="vm.policy.TeamMembers.length" when="{\n\t\t\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\tusing policy\n\t\t\t\t\t</p>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- No associated team members note, pay policies only -->\n\t\t\t<div class="form-section" ng-if="vm.policy.TeamMembers.length === 0 && vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\t<div class="form-note">\n\t\t\t\t\tThis pay policy isn\'t being used by any team members\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- View pension schemes - when there are entries in PensionSchemes. Show only for pension policies. -->\n\t\t\t<div class="form-section" ng-if="vm.policy.PensionSchemes.length !== 0 && vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<a href="" ng-click="showPensionSchemesView(vm, vm.policy.PensionSchemes)" ng-if="!vm.isPensionSchemeViewActive">\n\t\t\t\t\t<p class="s strong is-primary fadeIn" ng-if="!vm.isPensionSchemeViewActive">\n\t\t\t\t\t\t<i class="icon-back m"></i>&nbsp;&nbsp;\n\t\t\t\t\t\tView\n\t\t\t\t\t\t<ng-pluralize count="vm.policy.PensionSchemes.length" when="{\n\t\t\t\t\t\t\t\t\'1\': \'pension scheme\',\n\t\t\t\t\t\t\t\t\'other\': \'{} pension schemes\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\tusing this policy\n\t\t\t\t\t</p>\n\t\t\t\t</a>\n\t\t\t\t<a href="" ng-click="hidePensionSchemesView(vm)" ng-if="vm.isPensionSchemeViewActive">\n\t\t\t\t\t<p class="s strong is-primary" ng-if="vm.isPensionSchemeViewActive">\n\t\t\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Close pension schemes list\n\t\t\t\t\t</p>\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- No associated pension schemes note, pension policies only -->\n\t\t\t<div class="form-section" ng-if="vm.policy.PensionSchemes.length === 0 && vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\t<div class="form-note">\n\t\t\t\t\tThis pension policy isn\'t being used by any pension schemes\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<pc-pluralise count="vm.policy.bandsCount" multiple="{{vm.policy.policyBandDescription}}s" single="{{vm.policy.policyBandDescription}}"></pc-pluralise>\n\t\t\t\t</h5>\n\t\t\t</div>\n\n\t\t\t<!-- Hide pay points for duplication (pending update) warning -->\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<!-- Hide deleted bands in view mode, in case this is the summary view after creating or editing a policy -->\n\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.policy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" policy="vm.policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tClose\n\t\t\t</a>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- View team members -->\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isTeamMembersViewActive">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>View team members</h5>\n\t\t\t<a aria-label="Close team member list" class="slide-in-form-aside-header-action" href="" ng-click="hideTeamMembersView(vm)">\n\t\t\t\t<i class="icon-right l"></i>\n\t\t\t</a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main">\n\t\t<search-bar bulk-items="vm.policyTeamMembers" options="vm.policyTeamMembersSearchOptions"></search-bar>\n\t\t<div class="team-member-cards" ng-if="vm.policyTeamMembers.all.length !== 0">\n\t\t\t<team-member-card agency-profile-id="vm.agencyProfileId" info="teamMember.PolicyBandName" ng-repeat="teamMember in vm.policyTeamMembers.filtered = (\n\t\t\t\t\t\tvm.policyTeamMembers.all |\n\t\t\t\t\t\tfilter : vm.policyTeamMembersSearchOptions.search.string\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : vm.policyTeamMembersSearchOptions.orderBy : vm.policyTeamMembersSearchOptions.results.reverse" team-member="teamMember"></team-member-card>\n\t\t</div>\n\t</div>\n</aside>\n\n<!-- View pension schemes -->\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isPensionSchemeViewActive">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>View pension schemes</h5>\n\t\t<a aria-label="Close pensions list" class="slide-in-form-aside-header-action" href="" ng-click="hidePensionSchemesView(vm)">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main">\n\t\t<search-bar bulk-items="vm.policyPensionSchemes" options="vm.policyPensionSchemesSearchOptions"></search-bar>\n\t\t<div class="policy-pension-scheme-cards" ng-if="vm.policyPensionSchemes.all.length !== 0">\n\t\t\t<policy-pension-scheme-card agency-profile-id="vm.agencyProfileId" ng-repeat="pensionScheme in vm.policyPensionSchemes.filtered = (\n\t\t\t\t\t\tvm.policyPensionSchemes.all |\n\t\t\t\t\t\tfilter : vm.policyPensionSchemesSearchOptions.search.string\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : vm.policyPensionSchemesSearchOptions.orderBy : vm.policyPensionSchemesSearchOptions.results.reverse" pension-scheme="pensionScheme"></policy-pension-scheme-card>\n\t\t</div>\n\t</div>\n</aside>\n\n<!-- Error -->\n<div ng-if="pageState === PAGE_STATES.error">\n\t<error-block></error-block>\n</div>\n\n<!-- Policy saved successfully -->\n<div ng-if="pageState === PAGE_STATES.saved">\n\t<div class="form-section">\n\t\t<div class="slide-in-form-success">\n\t\t\t<div class="slide-in-form-success_icon">\n\t\t\t\t<i class="icon-tick"></i>\n\t\t\t</div>\n\t\t\t<h2 class="slide-in-form-success_title">Policy updated</h2>\n\t\t\t<p class="slide-in-form-success_message">\n\t\t\t\t{{vm.savedPolicyName}} has been updated successfully.\n\t\t\t</p>\n\t\t\t<p class="slide-in-form-success_link">\n\t\t\t\t<a href="" ng-click="formOptions.closeForm()">Ok, close this window</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('forms/hr/viewPensionPolicyForm/viewPensionPolicyForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form ng-if="pageState === PAGE_STATES.ready">\n\t<div class="form-intro" ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t<p class="s">To make changes to this pension policy you\'ll need to edit it in your\n\t\t\t<a class="is-primary underline" href="" ui-sref="hr.policies.pension({agencyProfileId: vm.agencyProfileId})">Pension Policies</a> area.\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="slide-in-form-info-card is-primary">\n\t\t\t<div class="slide-in-form-info-card_header">\n\t\t\t\t<div>\n\t\t\t\t\t<icon-dot icon="{{vm.policy.policyIcon}}" theme="is-primary is-extra-large has-box-shadow"></icon-dot>\n\t\t\t\t</div>\n\t\t\t\t<div class="slide-in-form-info-card_expanded-section">\n\t\t\t\t\t<p class="s is-primary-light">Policy name</p>\n\t\t\t\t\t<div class="slide-in-form-info-card_title">{{vm.policy.PolicyName}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="slide-in-form-info-card_section">\n\t\t\t\t<p class="is-primary-light s">\n\t\t\t\t\tBandings: {{POLICY_BAND_CALCULATION_TYPE_DESCRIPTIONS[vm.policy.PolicyBandCalculation]}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-section">\n\t\t<h5>\n\t\t\t<ng-pluralize count="vm.policy.bandsCount" when="{\'1\': \'1 contribution band\', \'other\': \'{} contribution bands\'}"></ng-pluralize>\n\t\t</h5>\n\t</div>\n\n\t<div class="pension-policy-band-cards">\n\t\t<!-- Hide deleted bands in view mode, in case this is the summary view after creating or editing a policy -->\n\t\t<policy-band-card ng-repeat="policyBand in vm.policy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" policy="vm.policy" policy-band="policyBand"></policy-band-card>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tClose\n\t\t</a>\n\t</fieldset>\n</form>\n\n<!-- Error -->\n<div ng-if="pageState === PAGE_STATES.error">\n\t<error-block></error-block>\n</div>\n');
$templateCache.put('forms/imports/cancel-user-import/cancelUserImportForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to cancel this import?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">Cancelling this import will delete any updated information and nothing will be imported.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<button class="tertiary primary-action" ng-disabled="currentPayPeriod.state === \'saving\'" ng-click="cancelImport(currentPayPeriod)">\n\t\t\t<span ng-show="currentPayPeriod.state !== \'saving\'">Cancel import</span>\n\t\t\t<span ng-show="currentPayPeriod.state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="The import has been cancelled" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">It might take a few moments to clean up the information that had been imported.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/imports/delete-import-mapping/deleteImportMappingForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteImportMappingForm" ng-submit="deleteImportMapping(importMappingTemplate, deleteImportMappingForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Summary -->\n\t\t<div class="form-field">\n\t\t\t<meta-data-card meta-title="importMappingTemplate.Name" meta-items="metaItems" icon="icon-upload"></meta-data-card>\n\t\t</div>\n\n\t</fieldset>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this import mapping?">\n\t\t<fs-main>\n\n\t\t\t<!-- Company -->\n\t\t\t<p class="s" ng-if="::$root.currentCompany.isPayrollCompany">&lsquo;{{formOptions.importMappingTemplate.Name}}&rsquo; will no longer be available to use for imports, and you will need to re-create it if you decide you need it again. Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue.</p>\n\t\t\t\n\t\t\t<!-- Bureau -->\n\t\t\t<p class="s" ng-if="::!$root.currentCompany.isPayrollCompany">Once this the mapping template has been deleted it will no longer be available to any companies in your bureau. Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="deleteImportMappingForm.state" disable-button="!deleteImportMappingForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state ng-if="pageState === \'success\'" form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="The import mapping has been deleted">\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/edit-import-layout/editImportLayoutForm.html','<div ng-if="pageState === \'ready\'">\n\t<form name="editImportLayoutForm" ng-submit="vm.updateImportLayout(vm, editImportLayoutForm)" ng-if="pageState === \'ready\'">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">Select the label layout to use when importing changes to your current period.</p>\n\t\t</div>\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="importHorizontal" class="required">Data layout:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<extended-radio always-show-content="true" name="importHorizontal" value="false" ng-model="vm.vertical" required>\n\t\t\t\t\t\t<radio-label>Horizontal</radio-label>\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<div class="inline-half">\n\t\t\t\t\t\t\t\t<div class="inline-half_item">\n\t\t\t\t\t\t\t\t\t<p class="s">The pay element data flows across in rows and there\'s a row for every element for every team member</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="inline-half_item">\n\t\t\t\t\t\t\t\t\t<img alt="" src="images/graphics/horizontal-elements.png">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<extended-radio always-show-content="true" name="importVertical" value="true" ng-model="vm.vertical" required>\n\t\t\t\t\t\t<radio-label>Vertical</radio-label>\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<div class="inline-half">\n\t\t\t\t\t\t\t\t<div class="inline-half_item">\n\t\t\t\t\t\t\t\t\t<p class="s">The pay element data flows down in columns and there\'s (normally) a single row for each team member</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="inline-half_item">\n\t\t\t\t\t\t\t\t\t<img alt="" src="images/graphics/vertical-elements.png">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="editImportLayoutForm.state" disable-button="!editImportLayoutForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/edit-team-imports/edit-team-imports.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form name="editTeamImportsForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateTeamImports($ctrl, editTeamImportsForm)">\n\n\t<fieldset>\n\t\t<settings-row ng-model="$ctrl.isImportAutoComplete" sr-field-name="is-import-auto-complete" sr-icon="payslip">\n\t\t\t<sr-label>Auto-set casual workers</sr-label>\n\t\t\t<sr-description ng-if="$ctrl.isImportAutoComplete">\n\t\t\t\tTurning this off means that team members won\u2019t be automatically set as casual workers when they\u2019re imported.\n\t\t\t</sr-description>\n\t\t\t<sr-description ng-if="!$ctrl.isImportAutoComplete">\n\t\t\t\tTurning this on means that team members will be automatically set as casual workers when they\u2019re imported, and only appear on payroll when changes are imported for them.\n\t\t\t</sr-description>\n\t\t</settings-row>\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="$ctrl.isImportAutoComplete">\n\n\t\t<!-- A note that can be dismissed -->\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Importing and auto-setting casual workers">\n\t\t\t<note-content>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tAs well as setting every team member as a casual worker, the following information will be added for them:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'Their start date will be set to the start date of your current period\',\n\t\t\t\t\t\t\t\'Their starter declaration will be set to &lsquo;D&rsquo;\',\n\t\t\t\t\t\t\t\'A zero salary will be added in their pay information\'\n\t\t\t\t\t\t]" bl-theme="is-small is-spaced-out is-indifferent is-italicised"></bullet-list>\n\t\t\t\t</div>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThis and any other information can be updated in their profile as normal once they\u2019re imported. Team members will only appear in your current period when changes are imported for\n\t\t\t\t\t\tthem.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!editTeamImportsForm.$valid" display-text="\'Save\'" state="editTeamImportsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/imports/import-history/import-history.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="importHistoryForm" ng-submit="$ctrl.saveForm($ctrl, importHistoryForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-section">\n\t\t<info-block ib-theme="align-center secondary has-border">\n\t\t\t<ib-main>\n\t\t\t\t<p>Pay day: {{$ctrl.formOptions.payPeriod.PayDateISO | dateformat:\'long\'}}</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<h4 class="strong">{{$ctrl.formOptions.payPeriod.PayPeriodDisplay}}</h4>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<h5><ng-pluralize count="$ctrl.mainRunGroups.length" when="{\'1\': \'1 Main pay run\', \'other\': \'{} Main pay runs\'}"></ng-pluralize></h5>\n\t\t<p class="is-small">Undoing this import will also undo the supplementary pay runs for this period.</p>\n\t</div>\n\n\t<section class="form-section">\n\n\t\t<!-- Import history -->\n\t\t<div class="import-history-item_wrapper" ng-if="$ctrl.mainRunGroups.length > 0">\n\t\t\t<import-history-item form-options="$ctrl.formOptions" import="import" ng-repeat="import in $ctrl.mainRunGroups" on-undo="$ctrl.onImportGroupUndo($ctrl, import)"></import-history-item>\n\t\t</div>\n\n\t\t<!-- No history -->\n\t\t<div ng-if="$ctrl.mainRunGroups.length === 0">\n\t\t\t<placeholder placeholder-graphic="no-imports">\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>There are no Main run imports</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t</placeholder>\n\t\t</div>\n\n\t</section>\n\n</form>\n\n<!-- Confirm delete -->\n<form name="undoImportForm" ng-submit="$ctrl.deleteUserPayElementImportGroup($ctrl, undoImportForm)" class="fadeIn" ng-if="$ctrl.componentState === \'confirm-undo\'" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Are you sure you wish to undo this import? ">\n\t\t<fs-main>\n\t\t\t<p class="is-small">All payslip data that was imported from the file \u2018{{$ctrl.groupToBeDeleted.ImportedFileName}}\u2019 and  and any additional supplementary pay run imports will be deleted from the May pay period. This can\u2019t be undone and they will need to be imported again if you later decide that you still need to use them.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Back</a>\n\t\t\t<submit-button display-text="\'Undo import\'" state="undoImportForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Import undone -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Import undone" ng-if="$ctrl.componentState === \'import-undone\'">\n\t<fs-main>\n\t\t<p class="is-small">Your import had been undone and all payslip data deleted.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/mapping-template/mapping-template.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="fileMappingForm" ng-submit="$ctrl.reviewSaveMappingTemplate($ctrl, fileMappingForm)" class="fadeIn" ng-switch="$ctrl.formOptions.actionType" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\n\t\t<!-- Companies -->\n\t\t<p class="s" ng-if="::$root.currentCompany.isPayrollCompany">The mapping template will remember the column number you dropped your headers onto and will drop them in the same place each time you use it for importing.</p>\n\t\t\n\t\t<!-- Bureaus -->\n\t\t<p class="s" ng-if="::!$root.currentCompany.isPayrollCompany">Your new mapping template will be available to all companies in your bureau.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Summary -->\n\t\t<div class="form-field">\n\t\t\t<meta-data-card meta-title="$ctrl.importMappingTemplate.Name" meta-items="$ctrl.metaItems" icon="icon-upload"></meta-data-card>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Create -->\n\t<fieldset ng-switch-when="create|duplicate" ng-switch-when-separator="|">\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="mappingTemplateName" class="required">Mapping template name:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="mappingTemplateName" name="mappingTemplateName" type="text" ng-model="$ctrl.importMappingTemplate.Name" ng-pattern="$root.REGEX.description" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="fileMappingForm.mappingTemplateName.$error" ng-if="fileMappingForm.mappingTemplateName.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter letters, numbers and basic symbols only</p>\n\t\t\t\t<p ng-message="required">Please enter a mapping template name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Default (only applicable to companies) -->\n\t\t<div class="form-field" ng-if="$root.currentCompany.isPayrollCompany">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="isDefault" name="isDefault" ng-model="$ctrl.importMappingTemplate.IsDefault" label-text="\'Set as default template when importing \' + $ctrl.importMappingTemplate.mappingTypeDescription + \' for \' + $ctrl.formOptions.company.Name" checkbox>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Update -->\n\t<fieldset ng-switch-when="update">\n\n\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to update this mapping?">\n\t\t\t<fs-main>\n\n\t\t\t\t<!-- Bureau Template -->\n\t\t\t\t<p class="is-small" ng-if="$ctrl.importMappingTemplate.IsGlobalTemplate">This will update the mapping template for all companies in your bureau. Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue.</p>\n\n\t\t\t\t<!-- Company Template -->\n\t\t\t\t<p class="is-small" ng-if="!$ctrl.importMappingTemplate.IsGlobalTemplate">Click &lsquo;Confirm&rsquo; if you&apos;re happy to continue.</p>\t\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.actionType === \'update\' ? \'Confirm\' : $ctrl.formOptions.primaryButtonText" state="fileMappingForm.state" disable-button="!fileMappingForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/imports/match-change-type/match-change-type.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="matchChangeTypeForm" ng-if="pageState === \'ready\'" ng-submit="saveForm(vm)" novalidate>\n\n\t<!-- Change Type -->\n\t<fieldset>\n\n\t\t<!-- Search -->\n\t\t<div class="pill-input-field primary" ng-class="{\n\t\t\t\t\'active\': vm.adjustmentTypesSearchIsFocused,\n\t\t\t\t\'assertive\': vm.adjustmentTypeSelected && vm.adjustmentTypeSelected.IsDeduction,\n\t\t\t\t\'positive\': vm.adjustmentTypeSelected && !vm.adjustmentTypeSelected.IsDeduction\n\t\t\t}">\n\t\t\t\n\t\t\t<!-- Search input -->\n\t\t\t<label for="adjustmentTypesSearchTerm" class="pill-input-field-label">\n\t\t\t\t<i class="icon-adjustment"></i> Match to change type\n\t\t\t</label>\n\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" id="adjustmentTypesSearchTerm" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-if="!vm.adjustmentTypeSelected && !vm.adjustmentLabelSelected" ng-model="vm.adjustmentTypesSearchTerm" placeholder="Search for a change or payslip label" type="text">\n\n\t\t\t<!-- Selected Change -->\n\t\t\t<div class="pill-input-field-items">\n\t\t\t\t<div class="pill-input-field-item {{vm.adjustmentTypeSelected.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn {{isEditAdjustment ? \'not-deleteable\' : \'\'}}" data-cy="add-change-type-selected-adjustment" ng-if="vm.adjustmentTypeSelected">\n\t\t\t\t\t<span>{{vm.adjustmentTypeSelected.AgencyAdjustmentLabelText ? vm.adjustmentTypeSelected.AgencyAdjustmentLabelText : vm.adjustmentTypeSelected.AgencyAdjustmentGroupEntryText}}</span>\n\t\t\t\t\t<a aria-label="Reset change type" class="pill-input-field-item-delete" href="" ng-click="deselectAdjustmentType(vm)" ng-if="!isEditAdjustment">\n\t\t\t\t\t\t<i class="icon-plus"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Search results -->\n\t\t\t<div class="pill-input-search-results dropIn" click-anywhere-but-here="resetAdjustmentTypeSearchTerm()" is-active="vm.adjustmentTypesSearchTerm.length >= SEARCH_TERM_MIN_COUNT" ng-show="vm.adjustmentTypesSearchTerm.length >= SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t<div class="pill-input-search-results-group primary" ng-if="vm.adjustmentLabels.length">\n\t\t\t\t\t<p class="pill-input-search-results-subheading">Payslip labels</p>\n\t\t\t\t\t<div class="pill-input-search-result secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel(vm, adjustmentLabel)" ng-repeat="adjustmentLabel in vm.adjustmentLabelsFiltered = (\n\t\t\t\t\t\t\t\tvm.adjustmentLabels |\n\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypesSearchTerm\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy:[\n\t\t\t\t\t\t\t\t\'IsDeduction\',\n\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t] |\n\t\t\t\t\t\t\tlimitTo: SEARCH_RESULTS_LIMIT\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t<i class="icon-label"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<p class="pill-input-search-result-description">\n\t\t\t\t\t\t\t{{adjustmentLabel.AgencyAdjustmentLabelText}}\n\t\t\t\t\t\t\t<span>{{adjustmentLabel.AdjustmentText}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="pill-input-search-result-action" href="">\n\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p ng-if="!vm.adjustmentLabelsFiltered.length">\n\t\t\t\t\t\t<span class="caption">No payslip labels found</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Changes -->\n\t\t\t\t<div class="pill-input-search-results-group primary">\n\t\t\t\t\t<p class="pill-input-search-results-subheading">Changes</p>\n\t\t\t\t\t<div class="pill-input-search-result fadeIn {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-click="selectAdjustmentType(vm, adjustmentType)" ng-repeat="adjustmentType in filteredAdjustmentTypes = (\n\t\t\t\t\t\t\t\tvm.adjustmentTypes |\n\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypeSearchFilter |\n\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntryText\': vm.adjustmentTypesSearchTerm\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy:\'AgencyAdjustmentGroupEntryText\' |\n\t\t\t\t\t\t\tlimitTo: SEARCH_RESULTS_LIMIT\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t<i class="icon-{{adjustmentType.IsDeduction ? \'minus\' : \'add\'}}"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<p class="pill-input-search-result-description">\n\t\t\t\t\t\t\t{{adjustmentType.AgencyAdjustmentGroupEntryText}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<a class="pill-input-search-result-action" href="">\n\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p ng-if="!filteredAdjustmentTypes.length">\n\t\t\t\t\t\t<span class="caption">No changes found</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Manually select -->\n\t\t<fieldset class="fadeIn" ng-if="!vm.adjustmentTypeSelected">\n\t\t\t<div class="form-content-block tight">\n\t\t\t\t<p class="is-small">Or select from below:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="vm.adjustmentTypesCount.totalAdditions > 0 && vm.adjustmentTypesCount.totalDeductions > 0">\n\t\t\t\t<nav class="tabs" ng-class="{\n\t\t\t\t\t\t\'open\': isOpen\n\t\t\t\t\t}" ng-click="isOpen = !isOpen">\n\t\t\t\t\t<a data-cy="add-change-type-tab-additions" href="" ng-class="{\n\t\t\t\t\t\t\t\'active\': vm.adjustmentTypesFilterKey === ADJUSTMENT_TYPE_FILTER_KEYS.additions\n\t\t\t\t\t\t}" ng-click="changeAdjustmentTypeFilter(vm, ADJUSTMENT_TYPE_FILTER_KEYS.additions)" ng-if="::vm.adjustmentTypesCount.totalAdditions > 0">\n\t\t\t\t\t\tAdditions\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="add-change-type-tab-deductions" href="" ng-class="{\n\t\t\t\t\t\t\t\'active\': vm.adjustmentTypesFilterKey === ADJUSTMENT_TYPE_FILTER_KEYS.deductions\n\t\t\t\t\t\t}" ng-click="changeAdjustmentTypeFilter(vm, ADJUSTMENT_TYPE_FILTER_KEYS.deductions)" ng-if="::vm.adjustmentTypesCount.totalDeductions > 0">\n\t\t\t\t\t\tDeductions\n\t\t\t\t\t</a>\n\t\t\t\t</nav>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="vm.adjustmentTypes.length">\n\t\t\t\t<div class="adjustment-type-cards">\n\n\t\t\t\t\t<!-- Change Types -->\n\t\t\t\t\t<div class="adjustment-type-card {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} clickable" id="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-repeat="adjustmentType in vm.adjustmentTypesFiltered = (\n\t\t\t\t\t\t\t\tvm.adjustmentTypes |\n\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypesFilter |\n\t\t\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\tlimitTo: vm.searchResultsLimitAdjustmentTypes\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<div class="adjustment-type-card_main" data-cy="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-click="selectAdjustmentType(vm, adjustmentType)">\n\t\t\t\t\t\t\t<span class="adjustment-type-card_action">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="adjustment-type-card_description">\n\t\t\t\t\t\t\t\t{{adjustmentType.AgencyAdjustmentGroupEntryText}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a aria-label="Show information tooltip" class="adjustment-type-card_info-action" href ng-click="$root.$broadcast(\'toggle-tooltip-card\', adjustmentType.tooltip)">\n\t\t\t\t\t\t\t<i class="icon-information is-medium {{adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}} adjustment-type-card_info-action-icon"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="adjustment-type-card {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} clickable" id="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-repeat="adjustmentType in filteredAdjustmentTypes = (\n\t\t\t\t\t\t\t\tadjustmentTypes |\n\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypeFilter |\n\t\t\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\tlimitTo: vm.searchResultsLimitAdjustmentTypes">\n\t\t\t\t\t\t<div class="adjustment-type-card_main" data-cy="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-click="selectAdjustmentType(vm, adjustmentType)">\n\t\t\t\t\t\t\t<span class="adjustment-type-card_action">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="adjustment-type-card_description">{{adjustmentType.AgencyAdjustmentGroupEntryText}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a aria-label="Show information tooltip" class="adjustment-type-card_info-action" href ng-click="$root.$broadcast(\'toggle-tooltip-card\', adjustmentType.tooltip)">\n\t\t\t\t\t\t\t<i class="icon-information is-medium {{adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}} adjustment-type-card_info-action-icon"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Load more -->\n\t\t\t\t<div class="item-selection-cards-load-more" ng-if="vm.searchResultsLimitAdjustmentTypes < filteredAdjustmentTypes.length">\n\t\t\t\t\t<a class="button white" data-cy="add-change-type-load-more" href="" ng-click="incrementSearchResultsAdjustmentTypes(vm)">\n\t\t\t\t\t\t<i class="icon-add m"></i>&nbsp;Show more\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="!vm.adjustmentTypes.length">\n\t\t\t\t<div class="info-block primary">\n\t\t\t\t\t<p class="is-small">There are no pay elements available</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Payslip Label -->\n\t<fieldset class="fadeIn" ng-if="vm.adjustmentTypeSelected">\n\n\t\t<!-- Payslip Label -->\n\t\t<div class="form-field">\n\t\t\t<div class="pill-input-field {{vm.adjustmentTypeSelected.IsDeduction ? \'assertive\' : \'positive\'}}" ng-class="{\n\t\t\t\t\t\'active\': vm.searchTermAdjustmentLabelsFocused\n\t\t\t\t}">\n\t\t\t\t\n\t\t\t\t<!-- Label -->\n\t\t\t\t<label class="pill-input-field-label" for="newAdjustmentLabel">\n\t\t\t\t\t<i class="icon-label"></i> Label for payslip <span>optional</span>\n\t\t\t\t</label>\n\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" id="newAdjustmentLabel" maxlength="40" minlength="3" name="newAdjustmentLabel" ng-blur="toggleSearchTermLabelsFocus(vm, false)" ng-focus="toggleSearchTermLabelsFocus(vm, true); toggleShowPayslipLabelResults(vm, true);" ng-if="!vm.adjustmentLabelSelected" ng-model="vm.adjustmentLabelSearchTerm" ng-pattern="$root.REGEX.description" ng-required="vm.saveLabel" placeholder="Add a custom label for this change" type="text">\n\t\t\t\t\n\t\t\t\t<!-- Errors -->\n\t\t\t\t<div class="pill-input-field-errors" ng-if="!matchChangeTypeForm.newAdjustmentLabel.$valid && matchChangeTypeForm.newAdjustmentLabel.$touched" ng-messages="matchChangeTypeForm.newAdjustmentLabel.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t\t\t<p ng-message="required">Please enter a label</p>\n\t\t\t\t\t<p ng-message="minlength">Please enter a label with at least 3 characters</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Selected Label -->\n\t\t\t\t<div class="pill-input-field-items" ng-if="vm.adjustmentLabelSelected">\n\t\t\t\t\t<div class="pill-input-field-item {{vm.adjustmentTypeSelected.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn">\n\t\t\t\t\t\t<span>{{vm.adjustmentLabelSelected}}</span>\n\t\t\t\t\t\t<a aria-label="Reset label" class="pill-input-field-item-delete" href="" ng-click="resetAdjustmentLabel(vm)">\n\t\t\t\t\t\t\t<i class="icon-plus"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Search results -->\n\t\t\t\t<div class="pill-input-search-results dropIn" click-anywhere-but-here="toggleShowPayslipLabelResults(vm, false)" is-active="vm.adjustmentLabelSearchTerm.length >= SEARCH_TERM_MIN_COUNT && !vm.adjustmentLabelSelected" ng-if="vm.adjustmentLabels.length" ng-show="vm.adjustmentLabelSearchTerm.length >= SEARCH_TERM_MIN_COUNT && !vm.adjustmentLabelSelected && vm.showPayslipLabelResults">\n\n\t\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t\t<div class="pill-input-search-results-group primary">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Payslip labels</p>\n\t\t\t\t\t\t<div class="pill-input-search-result secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel(vm, adjustmentLabel, false)" ng-repeat="adjustmentLabel in vm.adjustmentLabelsFiltered = (\n\t\t\t\t\t\t\t\t\tvm.adjustmentLabels |\n\t\t\t\t\t\t\t\t\tfilter: vm.adjustmentLabelSearchTerm |\n\t\t\t\t\t\t\t\t\tfilter: vm.newAdjustment.Label\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy:[\n\t\t\t\t\t\t\t\t\t\'IsDeduction\',\n\t\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t\t]\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t<i class="icon-label"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description">\n\t\t\t\t\t\t\t\t{{adjustmentLabel.AgencyAdjustmentLabelText}} <span>{{adjustmentLabel.AdjustmentText}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="pill-input-search-result-action" href="">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p ng-if="!vm.adjustmentLabelsFiltered.length">\n\t\t\t\t\t\t\t<span class="caption">No &lsquo;{{vm.adjustmentTypeSelected.AgencyAdjustmentGroupEntryText}}&rsquo; payslip labels found</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.adjustmentTypeSelected.AgencyAdjustmentNetToGross">\n\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSelect whether you wish to import this element as net or gross and click &lsquo;Save&rsquo; to finish mapping the header.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Net / Gross -->\n\t \t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="importAsGross">Import element as:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="importAsGross" name="importAs" ng-model="vm.isNetImport" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="importAsGross">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Gross</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="importAsNet" name="importAs" ng-model="vm.isNetImport" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="importAsNet">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Net</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.showPayElementRateType">\n\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tWhere a team member doesn\'t have the rate type you select below saved in their profile, they will be ignored from your import.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Rate Type -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="payElementRateType">Select a rate to import with:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t\t<extended-radio ng-repeat="(key, rateType) in IMPORT_RATE_TYPES" ng-if="rateType !== IMPORT_RATE_TYPES.none" always-show-content="true" has-click-anywhere="true" name="payElementRateType" ng-model="vm.payElementRateType" theme="is-primary has-hover is-tight" value="rateType">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{ rateType | importPayElementRateType }}</h6>\n\t\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\t\t{{ rateType | importPayElementRateType:\'description\' }}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!matchChangeTypeForm.$valid || !vm.adjustmentTypeSelected" display-text="formOptions.primaryButtonText" state="matchChangeTypeForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n\n');
$templateCache.put('forms/imports/match-link-element/match-link-element.form.html','<form name="matchLinkElementForm" ng-submit="$ctrl.matchLinkElement($ctrl)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Select -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="linkElement" class="required">Select a link element:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main" ng-switch="$ctrl.formOptions.layoutType">\n\n\t\t\t\t<!-- Vertical > Select from mapping headers -->\n\t\t\t\t<select class="l-alt" id="linkElement" name="linkElement" ng-model="$ctrl.linkElement" ng-options="option as option.ImportMappingColumnText for option in $ctrl.formOptions.mappingHeaders | filter: {\'isInUse\': false} | orderBy : \'ImportMappingColumnText\'" ng-switch-when="vertical" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\n\t\t\t\t<!-- Horizontal > Select from link elements -->\n\t\t\t\t<select class="l-alt" id="linkElement" name="linkElement" ng-model="$ctrl.linkElement" ng-options="option as option.LinkElementName for option in $ctrl.formOptions.linkElements | orderBy : \'LinkElementName\'" ng-switch-when="horizontal" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="matchLinkElementForm.linkElement.$error" ng-if="matchLinkElementForm.linkElement.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<p class="is-small">Can&apos;t find a link element? <a href="" ng-click="$ctrl.openLinkElementForm()">Create a new Link Element</a></p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="matchLinkElementForm.state" disable-button="!matchLinkElementForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No link elements -->\n<placeholder placeholder-graphic="no-link-elements" ng-if="$ctrl.componentState === \'no-link-elements\'">\n\t<placeholder-title>No unit link elements</placeholder-title>\n\t<placeholder-copy>\n\t\t<p>Once you&apos;ve added unit link elements in your company settings they will be available here to use when importing.</p>\n\t</placeholder-copy>\n\t<placeholder-primary-actions>\n\t\t<div class="spaced-links is-inline">\n\t\t\t<a href="" ng-click="$ctrl.openLinkElementForm()" class="spaced-links__item">Create a new Link Element</a>\n\t\t\t<a href="" ui-sref="settings.company.pay-elements.link-elements({agencyProfileId: $ctrl.formOptions.agencyProfileId})" class="spaced-links__item">Go to pay elements <i class="icon-chevron-right"></i></a>\n\t\t</div>\n\t</placeholder-primary-actions>\n</placeholder>\n');
$templateCache.put('forms/imports/match-payslip-label/matchPayslipLabelForm.html','<form name="matchPayslipLabelForm" ng-submit="matchPayslipLabel(vm)" class="fadeIn" novalidate>\n\n\t<fieldset>\n\t\t<pay-element-type-card-basic description="Pay element" is-deduction="formOptions.fileColumn.mappingHeader.AgencyAdjustmentIsDeduction" label="formOptions.fileColumn.mappingHeader.ImportMappingColumnText"></pay-element-type-card-basic>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<p class="s">Select a label for the header you\u2019ve just dropped:</p>\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<!-- Payslip Label -->\n\t\t<div class="form-field">\n\n\t\t\t<div class="pill-input-field {{formOptions.fileColumn.mappingHeader.AgencyAdjustmentIsDeduction ? \'assertive\' : \'positive\'}}">\n\t\t\t\t<label for="newAdjustmentLabel" class="pill-input-field-label is-secondary"><i class="icon-label"></i> Label for payslip <span>(optional)</span></label>\n\t\t\t\t<input class="pill-input-field-input fadeIn" type="text" id="newAdjustmentLabel" name="newAdjustmentLabel" ng-model="vm.adjustmentLabel" maxlength="40" minlength="3" ng-pattern="$root.REGEX.description" autocomplete="off">\n\t\t\t\t<div class="pill-input-field-errors" ng-messages="matchPayslipLabelForm.newAdjustmentLabel.$error" ng-if="!matchPayslipLabelForm.newAdjustmentLabel.$valid && matchPayslipLabelForm.newAdjustmentLabel.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t\t\t<p ng-message="required">Please enter a label</p>\n\t\t\t\t\t<p ng-message="minlength">Please enter a label with at least 3 characters</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="matchPayslipLabelForm.state" disable-button="!matchPayslipLabelForm.$valid"></submit-button>\n\t</fieldset>\n</form>');
$templateCache.put('forms/imports/match-policy-details/match-policy-details.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Policy cannot be updated - pending update or future salary changes -->\n<div class="fadeIn" data-cy="match-policy-details-skip" ng-if="pageState === \'ready\' && vm.isExistingPolicy && !vm.canUpdate">\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>{{vm.policyName}}</h5>\n\t\t</div>\n\t</fieldset>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This policy can\'t be updated">\n\t\t<fs-main>\n\t\t\t<p class="s" ng-if="vm.hasPendingUpdate">\n\t\t\t\tThis policy already has a pending update. You\'ll need to remove the existing update before importing a new one.\n\t\t\t</p>\n\t\t\t<p class="s" ng-if="vm.hasFutureChanges">\n\t\t\t\tThis policy can\'t be updated as one or more team members using this policy already has a pay change set up in their pay information.\n\t\t\t\tYou\'ll need to remove these changes before adding your policy update.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button" data-cy="match-policy-details-close" href="" ng-click="closeForm()">Ok, got it</a>\n\t\t</fs-actions>\n\t</form-state>\n</div>\n\n<form class="fadeIn" data-cy="match-policy-details-form" name="matchPolicyDetailsForm" ng-if="pageState === \'ready\' && vm.canUpdate" ng-submit="saveForm(vm)" novalidate>\n\n\t<!-- Policy Name Header -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>{{vm.policyName}}</h5>\n\t\t\t<p class="is-small">Enter the policy details for this policy name.</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Existing policy info note -->\n\t<fieldset ng-if="vm.isExistingPolicy">\n\t\t<note note-icon="icon-warning" note-theme="warning">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">An existing policy has been found and will be updated.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</fieldset>\n\n\t<!-- Policy Type (locked for existing policies \u2014 type is immutable once created) -->\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Which type of pay policy?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" data-cy="match-policy-details-type-salary" id="policyPayBasisAnnualSalary" name="policyPayBasis" ng-disabled="vm.isExistingPolicy" ng-model="vm.policyPayBasis" ng-value="POLICY_PAY_BASES.annualSalary" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="policyPayBasisAnnualSalary">\n\t\t\t\t\t\t\t<i class="icon-wallet radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualSalary]}}</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" data-cy="match-policy-details-type-allowance" id="policyPayBasisAnnualAllowance" name="policyPayBasis" ng-disabled="vm.isExistingPolicy" ng-model="vm.policyPayBasis" ng-value="POLICY_PAY_BASES.annualAllowance" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="policyPayBasisAnnualAllowance">\n\t\t\t\t\t\t\t<i class="icon-calendar radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">{{POLICY_PAY_BASES_DESCRIPTIONS[POLICY_PAY_BASES.annualAllowance]}}</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Effective Date -->\n\t<fieldset class="fadeIn" ng-if="vm.policyPayBasis">\n\t\t<div class="form-field-highlight primary">\n\t\t\t<div class="form-fieldset-header">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSet an effective date for this policy. Effective date is ignored for new policies.\n\t\t\t\t\tFor updates to paid policies, it is required and must be current period or earlier.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="effectiveDate" ng-class="{\'required\': vm.isLocked}">Effective date:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field data-cy="match-policy-details-effective-date" field-id="effectiveDate" field-max-date-iso="vm.currentPayPeriod.EndDateISO" field-required="vm.isLocked" field-value-iso="vm.effectiveDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="matchPolicyDetailsForm.effectiveDate.$touched" ng-messages="matchPolicyDetailsForm.effectiveDate.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{vm.currentPayPeriod.EndDateISO | dateformat}}</p>\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Is allowance pensionable? Applicable to annualAllowance-type pay policies only -->\n\t<fieldset class="fadeIn" ng-if="vm.policyPayBasis === POLICY_PAY_BASES.annualAllowance">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="isAllowancePensionableActive">Is this allowance pensionable?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="match-policy-details-pensionable-yes" id="isAllowancePensionableActive" name="pensionState" ng-model="vm.pensionState" ng-value="POLICY_PENSION_STATES.active" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isAllowancePensionableActive">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" data-cy="match-policy-details-pensionable-no" id="isAllowancePensionableInactive" name="pensionState" ng-model="vm.pensionState" ng-value="POLICY_PENSION_STATES.inactive" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isAllowancePensionableInactive">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Contracted Working Time (only for Annual Salary) -->\n\t<fieldset class="fadeIn" ng-if="vm.policyPayBasis === POLICY_PAY_BASES.annualSalary">\n\t\t<div class="form-field-highlight primary">\n\t\t\t<div class="form-fieldset-header">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSet contracted working time to apply to all team members using this policy.\n\t\t\t\t\tThe time can be overriden when you set up their pay information.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="workHoursPerWeek">\n\t\t\t\t\t\t\t\tContracted hours per week:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field field-name="workHoursPerWeek" max="config.workTimeLimits.hoursPerWeek.max" min="config.workTimeLimits.hoursPerWeek.min" ng-model="vm.hoursPerWeek" step="config.workTimeLimits.hoursPerWeek.step"></number-selector-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="matchPolicyDetailsForm.workHoursPerWeek.$touched" ng-messages="matchPolicyDetailsForm.workHoursPerWeek.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.hoursPerWeek.max}} hours</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{config.workTimeLimits.hoursPerWeek.min}} hours</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of hours</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="workWeeksPerYear">\n\t\t\t\t\t\t\t\tContracted weeks per year:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field field-name="workWeeksPerYear" max="config.workTimeLimits.weeksPerYear.max" min="config.workTimeLimits.weeksPerYear.min" ng-model="vm.weeksPerYear" step="config.workTimeLimits.weeksPerYear.step"></number-selector-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="matchPolicyDetailsForm.workWeeksPerYear.$touched" ng-messages="matchPolicyDetailsForm.workWeeksPerYear.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.weeksPerYear.max}} weeks</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{config.workTimeLimits.weeksPerYear.min}} weeks</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of weeks</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-note">\n\t\t\t\t\t<p class="s is-primary-light">\n\t\t\t\t\t\tThis assumes a 5 day week and the same daily working hours.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="match-policy-details-cancel" href="" ng-click="closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button data-cy="match-policy-details-submit" disable-button="matchPolicyDetailsForm.$invalid" display-text="\'Save\'" state="matchPolicyDetailsForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/pay-element-matching-form/pay-element-matching-form.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="payElementMatchingForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.submitForm($ctrl.vm)" novalidate>\n\t<!-- Header info -->\n\t<div class="form-field">\n\t\t<p class="strong">Resolve pay element match</p>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<p class="s" ng-if="$ctrl.vm.isMultipleMatches">\n\t\t\tMultiple existing pay elements match the imported value. \n\t\t\tPlease select which element to update or create a new one.\n\t\t</p>\n\t\t<p class="s" ng-if="$ctrl.vm.isSingleMatch">\n\t\t\tAn existing pay element matches the imported value.\n\t\t\tYou can update the existing element or create a new one.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<!-- Multiple matches - card selection -->\n\t\t<div class="form-field" ng-if="$ctrl.vm.isMultipleMatches">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="payElementSelect">Select pay element to update:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="item-selection-cards">\n\t\t\t\t\t<div class="item-selection-card clickable" data-cy="pay-element-matching-form-option-{{$index}}" ng-class="{\'selected\': $ctrl.vm.selectedPayElement === payElement, \'is-clear\': $ctrl.vm.selectedPayElement !== payElement, \'primary\': $ctrl.vm.selectedPayElement === payElement}" ng-click="$ctrl.selectPayElement($ctrl.vm, payElement)" ng-repeat="payElement in $ctrl.vm.matchedPayElements">\n\t\t\t\t\t\t<div class="item-selection-card_main">\n\t\t\t\t\t\t\t<div class="item-selection-card_content">\n\n\t\t\t\t\t\t\t\t<p class="strong">{{payElement.Label || payElement.Description}}\n\t\t\t\t\t\t\t\t\t<span class="item-selection-card_action">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-tick" ng-if="$ctrl.vm.selectedPayElement === payElement"></i>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="s" ng-if="payElement.Value">Total Value: {{payElement.Value | currency:\'\':2}}</p>\n\t\t\t\t\t\t\t\t<p class="s" ng-if="payElement.Units">Units: {{payElement.Units}}</p>\n\t\t\t\t\t\t\t\t<p class="s" ng-if="payElement.UnitValue">Unit Value: {{payElement.UnitValue | currency:\'\':2}}</p>\n\t\t\t\t\t\t\t\t<p class="s" ng-if="payElement.RecurringPeriodCount > 0">\n\t\t\t\t\t\t\t\t\tRecurring: {{payElement.RecurringPeriodCount}} period(s)\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="s" ng-if="payElement.RecurringPeriodCount < 1">\n\t\t\t\t\t\t\t\t\tRecurring: Indefinitely\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Single match - show match details -->\n\t\t<div class="form-field" ng-if="$ctrl.vm.isSingleMatch && $ctrl.vm.matchedPayElements.length > 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>Matched pay element:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="info-block primary">\n\t\t\t\t\t<p class="strong">{{$ctrl.vm.matchedPayElements[0].Label || $ctrl.vm.matchedPayElements[0].Description}}</p>\n\t\t\t\t\t<p class="s" ng-if="$ctrl.vm.matchedPayElements[0].Value">\n\t\t\t\t\t\tTotal Value: {{$ctrl.vm.matchedPayElements[0].Value | currency:\'\':2}}\n\t\t\t\t\t\t<span ng-if="$ctrl.vm.matchedPayElements[0].Units"> | Units: {{$ctrl.vm.matchedPayElements[0].Units}}</span>\n\t\t\t\t\t\t<span ng-if="$ctrl.vm.matchedPayElements[0].UnitValue"> | Unit Value: {{$ctrl.vm.matchedPayElements[0].UnitValue | currency:\'\':2}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="s" ng-if="$ctrl.vm.matchedPayElements[0].RecurringPeriodCount > 0">\n\t\t\t\t\t\tRecurring: {{$ctrl.vm.matchedPayElements[0].RecurringPeriodCount}} period(s)\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Action selection for single match -->\n\t\t<div class="form-field" ng-if="$ctrl.vm.isSingleMatch">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">What would you like to do?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="pay-element-matching-form-update-existing" id="updateExisting" name="matchAction" ng-change="$ctrl.selectToUpdated($ctrl.vm, $ctrl.vm.matchedPayElements[0])" ng-model="$ctrl.vm.createAsNew" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="updateExisting">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Update</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="pay-element-matching-form-create-new" id="createNew" name="matchAction" ng-change="$ctrl.setCreateAsNew($ctrl.vm)" ng-model="$ctrl.vm.createAsNew" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="createNew">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Create</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<div class="info-block note">\n\t\t\t\t\t<span ng-if="!$ctrl.vm.createAsNew" class="radio-card-option-description fadeIn">The imported values will update the matched pay element</span>\n\t\t\t\t\t<span ng-if="$ctrl.vm.createAsNew" class="radio-card-option-description fadeIn">A new pay element will be created instead of updating the existing one</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Create as new option for multiple matches -->\n\t\t<div class="form-field" ng-if="$ctrl.vm.isMultipleMatches">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="checkbox-rows-list">\n\t\t\t\t\t<div class="checkbox-row" data-cy="pay-element-matching-form-create-new-checkbox-row">\n\t\t\t\t\t\t<label class="checkbox-row_label" for="createAsNewCheckbox"> \n\t\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" data-cy="pay-element-matching-form-create-new-checkbox" id="createAsNewCheckbox" ng-change="$ctrl.vm.selectedPayElement = null" ng-model="$ctrl.vm.createAsNew" type="checkbox">\n\t\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t\t<h6>\n\t\t\t\t\t\t\t\t\t<label class="radio-row-label" for="createAsNewCheckbox">\n\t\t\t\t\t\t\t\t\t\t<p class="radio-row-title" data-cy="pay-element-matching-form-create-new-checkbox-label">Create as new pay element instead</p>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="pay-element-matching-form-cancel-button" href="" ng-click="$ctrl.closeForm()">Cancel</a>\n\t\t<a class="button tertiary-action" data-cy="pay-element-matching-form-skip-button" href="" ng-click="$ctrl.skipRow()">Skip row</a>\n\t\t<submit-button data-cy="pay-element-matching-form-submit-button" disable-button="!$ctrl.isFormValid($ctrl.vm)" display-text="\'Confirm\'" state="payElementMatchingForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>');
$templateCache.put('forms/imports/pay-element-net-to-gross/pay-element-net-to-gross.form.html','<form class="fadeIn" name="updatNetToGrossForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateNetToGrossEnabled()" novalidate>\n\n\t<fieldset>\n\t\t<pay-element-type-card-basic description="Pay element" is-deduction="$ctrl.formOptions.fileColumn.mappingHeader.AgencyAdjustmentIsDeduction" label="$ctrl.formOptions.fileColumn.mappingHeader.ImportMappingColumnText"></pay-element-type-card-basic>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<p class="is-small">\n\t\t\tSelect whether you wish to import this element as net or gross and click &lsquo;Save&rsquo; to finish mapping the header.\n\t\t</p>\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<!-- Net / Gross -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="importAsGross">Import element as:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="importAsGross" name="importAs" ng-model="$ctrl.isNetImport" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="importAsGross">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Gross</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="importAsNet" name="importAs" ng-model="$ctrl.isNetImport" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="importAsNet">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Net</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!updatNetToGrossForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="updatNetToGrossForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/pay-element-rate-type/pay-element-rate-type.form.html','<form class="fadeIn" name="payElementRateTypeForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updatePayElementRateType(payElementRateTypeForm)" novalidate>\n\n\t<fieldset>\n\t\t<pay-element-type-card-basic is-deduction="$ctrl.formOptions.fileColumn.mappingHeader.AgencyAdjustmentIsDeduction" label="$ctrl.formOptions.fileColumn.mappingHeader.ImportMappingColumnText" theme="is-text-greyscale l"></pay-element-type-card-basic>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<p class="is-small">\n\t\t\tWhere a team member doesn\'t have the rate type you select below saved in their profile, they will be ignored from your import.\n\t\t</p>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- Rate Type -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="payElementRateType">Select a rate to import with:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t<extended-radio ng-repeat="(key, rateType) in $ctrl.IMPORT_RATE_TYPES" ng-if="rateType !== $ctrl.IMPORT_RATE_TYPES.none" always-show-content="true" has-click-anywhere="true" name="payElementRateType" ng-model="$ctrl.payElementRateType" theme="is-primary has-hover is-tight" value="rateType">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{:: rateType | importPayElementRateType }}</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\t{{:: rateType | importPayElementRateType:\'description\' }}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" data-cy="pay-element-rate-type-form-cancel" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button button-id="pay-element-rate-type-form-submit" display-text="$ctrl.formOptions.primaryButtonText" state="payElementRateTypeForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/undo-import/undoImportForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to undo this import?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p>Undoing this import will delete everything you recently imported so you can start again.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="tertiary primary-action" ng-disabled="currentPayPeriod.state === \'saving\'" ng-click="undoImport(currentPayPeriod)">\n\t\t\t<span ng-show="currentPayPeriod.state !== \'saving\'">Undo import</span>\n\t\t\t<span ng-show="currentPayPeriod.state === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="The import has been undone" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p>Your import has now been reset and is now ready to re-import.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/imports/undo-import-company-data/undo-import-company-data.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="undoImportCompanyDataForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.deleteUserImportGroup($ctrl.formOptions.userImportGroupObj, undoImportCompanyDataForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you want to undo this import?" ng-if="$ctrl.componentState === \'ready\'">\n\t\t<fs-main ng-switch="$ctrl.formOptions.userImportGroupObj.ImportType">\n\t\t\t<p class="is-small" pc-switch-when="[\n\t\t\t\t\t$ctrl.IMPORT_MAPPING_TYPES.businessCategories,\n\t\t\t\t\t$ctrl.IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories\n\t\t\t\t]">\n\t\t\t\tAll data that was imported using the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will be deleted and this can\'t be undone.\n\t\t\t\tThis may affect any business category overrides for hourly rates and payroll changes you have saved for team members.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\'re happy to continue.\n\t\t\t</p>\n\t\t\t<p class="is-small" ng-switch-default>\n\t\t\t\tAll data that was imported using the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will be deleted and this can\'t be undone.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you&apos;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">Cancel</button>\n\t\t\t<submit-button disable-button="!undoImportCompanyDataForm.$valid" display-text="\'Confirm\'" state="undoImportCompanyDataForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cannot undo business code import -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-title="Import contains categories in use" ng-if="$ctrl.componentState === \'cannot-undo-business-code-import\'">\n\t<fs-main>\n\t\t<section class="form-section">\n\t\t\t<p class="s">\n\t\t\t\tThis import can\'t be undone as it includes categories that team members are currently using as their home category or for a cost split.\n\t\t\t\tThose team members will need to be removed from the respective categories in their profile before this import can be undone.\n\t\t\t</p>\n\t\t</section>\n\t</fs-main>\n</form-state>\n\n<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window" ng-if="$ctrl.componentState === \'error\'"></error-block>\n\n');
$templateCache.put('forms/imports/undo-import-pay-element/undo-import-pay-element.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="undoImportPayElementForm" ng-submit="$ctrl.deleteUserPayElementImportGroup($ctrl.formOptions.userImportGroupObj, undoImportPayElementForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you want to undo this import?" ng-if="$ctrl.componentState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tThe data that was imported using the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will be deleted and cannot be undone.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tPlease note that if you imported a salary change or work pattern update for a team member with this file, and those changes have since been processed through payroll, the salary change will not be deleted and will need to be reverted manually.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tClick &lsquo;Undo import&lsquo; if you&lsquo;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Undo import\'" state="undoImportPayElementForm.state" disable-button="!undoImportPayElementForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window" ng-if="$ctrl.componentState === \'error\'"></error-block>\n\n');
$templateCache.put('forms/imports/undo-import-pay-policy/undo-import-pay-policy.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<!-- Can undo all policies -->\n<form class="fadeIn" name="undoImportPayPolicyForm" ng-if="$ctrl.componentState === \'ready\' && $ctrl.canUndoAll" ng-submit="$ctrl.resetPayPolicyImportGroup($ctrl.formOptions.userImportGroupObj, undoImportPayPolicyForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you want to undo this import?">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tThe data that was imported using the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will be reversed.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tThe following {{$ctrl.previewDetails.length}} {{$ctrl.previewDetails.length === 1 ? \'policy\' : \'policies\'}} will be affected:\n\t\t\t</p>\n\t\t\t<div class="form-content-block">\n\t\t\t\t<bullet-list bl-theme="is-small is-tertiary is-spaced-out">\n\t\t\t\t\t<bl-items>\n\t\t\t\t\t\t<li class="bullet-list_item" ng-repeat="detail in $ctrl.previewDetails">\n\t\t\t\t\t\t\t<span>{{detail.PolicyName}} - {{$ctrl.getImportActionDescription(detail.ImportAction)}}</span>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</bl-items>\n\t\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t\t<p class="s">\n\t\t\t\tClick &lsquo;Undo import&rsquo; if you&rsquo;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" data-cy="undo-import-pay-policy-cancel" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button data-cy="undo-import-pay-policy-submit" disable-button="!undoImportPayPolicyForm.$valid" display-text="\'Undo import\'" state="undoImportPayPolicyForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cannot undo \u2014 blocked policies -->\n<div class="fadeIn" ng-if="$ctrl.componentState === \'ready\' && !$ctrl.canUndoAll">\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="This import cannot be undone">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tOne or more policies from the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; cannot be reversed. All policies in the import must be reversible before the undo can proceed.\n\t\t\t</p>\n\t\t\t<div class="form-content-block">\n\t\t\t\t<bullet-list bl-theme="is-small is-tertiary is-spaced-out">\n\t\t\t\t\t<bl-items>\n\t\t\t\t\t\t<li class="bullet-list_item" ng-repeat="detail in $ctrl.previewDetails">\n\t\t\t\t\t\t\t<span ng-if="detail.CannotUndoReason">{{detail.PolicyName}} - {{detail.CannotUndoReason}}</span>\n\t\t\t\t\t\t\t<span ng-if="!detail.CannotUndoReason">{{detail.PolicyName}} - Can be undone</span>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</bl-items>\n\t\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" data-cy="undo-import-pay-policy-close" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tClose\n\t\t\t</button>\n\t\t</fs-actions>\n\t</form-state>\n</div>\n\n<!-- Undoing -->\n<section class="form-summary fadeIn" ng-if="$ctrl.componentState === \'undoing\'">\n\t<loading-block size="m">\n\t\t<lb-description>Undoing import...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a few moments.</p>\n\t\t<p class="s">Please don&rsquo;t close your browser or hit the &lsquo;Back&rsquo; button!</p>\n\t</section>\n</section>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/imports/undo-import-posts-pay-policies/undo-import-posts-pay-policies.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="undoImportPostsPayPoliciesForm" ng-submit="$ctrl.resetUserImportGroup($ctrl.formOptions.userImportGroupObj, undoImportPostsPayPoliciesForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you want to undo this import?">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tUndoing the import &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will remove the posts, pay policies and allowances that were <strong>added</strong> by this file.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tPosts that were <strong>updated</strong> rather than added will not be reverted &mdash; the previous values are not held and cannot be restored. Any changes that have since been processed through payroll will also be left in place and must be reverted manually.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tClick &lsquo;Undo import&rsquo; if you&rsquo;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" data-cy="undo-import-posts-pay-policies-cancel-btn" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Undo import\'" state="undoImportPostsPayPoliciesForm.state" disable-button="!undoImportPostsPayPoliciesForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Undoing -->\n<section class="form-summary fadeIn" ng-if="$ctrl.componentState === \'undoing\'">\n\t<loading-block size="m">\n\t\t<lb-description>Undoing import...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a few moments.</p>\n\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t</section>\n</section>\n\n<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window" ng-if="$ctrl.componentState === \'error\'"></error-block>\n');
$templateCache.put('forms/imports/undo-import-team/undo-import-team.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="undoImportTeamForm" ng-submit="$ctrl.resetUserImportGroup($ctrl.formOptions.userImportGroupObj, undoImportTeamForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you want to undo this import?">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tThe data that was imported using the file &lsquo;{{$ctrl.formOptions.userImportGroupObj.ImportedFileName}}&rsquo; will be deleted and cannot be undone.\n\t\t\t</p>\n\t\t\t<div ng-switch="$ctrl.formOptions.userImportGroupObj.ImportType">\n\t\t\t\t<p class="s" pc-switch-when="$ctrl.IMPORT_MAPPING_TYPES.sickness">\n\t\t\t\t\tPlease note that if you imported a sick pay schedule for a team member with this file that has since been processed through payroll, the sick pay schedule won&rsquo;t be deleted and will need to be cancelled manually.\n\t\t\t\t</p>\n\t\t\t\t<p class="s" ng-switch-default>\n\t\t\t\t\tPlease note that if you imported a salary change or work pattern update for a team member with this file, and those changes have since been processed through payroll, the salary change will not be deleted and will need to be reverted manually.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<p class="s">\n\t\t\t\tClick &lsquo;Undo import&rsquo; if you&rsquo;re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Undo import\'" state="undoImportTeamForm.state" disable-button="!undoImportTeamForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Undoing -->\n<section class="form-summary fadeIn" ng-if="$ctrl.componentState === \'undoing\'">\n\t<loading-block size="m">\n\t\t<lb-description>Undoing import...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This should only take a few moments.</p>\n\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t</section>\n</section>\n\n<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window" ng-if="$ctrl.componentState === \'error\'"></error-block>\n\n');
$templateCache.put('forms/imports/update-payelement-validation-result/update-payelement-validation-result.form.html','<form class="fadeIn" name="updatePayelementValidationResultForm" ng-submit="updatePayElementValidationResultValue(formOptions)" novalidate>\n\t<div class="form-field">\n\t\t<p class="strong"><span ng-bind="formOptions.validationResult.ValidationType.ValidationTypeText"></span></p>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<p class="s">Update the value below to fix the validation issue.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<!-- Validation result -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="payElementValidationResult">Value:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input data-cy="update-payelement-validation-result-form-value-input" id="payElementValidationResult" name="payElementValidationResult" ng-model="formOptions.validationResult.ValidationResultImportValue" required type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="update-payelement-validation-result-form-cancel-button" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button data-cy="update-payelement-validation-result-form-submit-button" disable-button="!updatePayelementValidationResultForm.$valid" display-text="formOptions.primaryButtonText" state="updatePayelementValidationResultForm.state"></submit-button>\n\t</fieldset>\n</form>\n');
$templateCache.put('forms/imports/update-validation-result/update-validation-result.form.html','<form name="updateValidationResultForm" ng-submit="updateValidationResultValue(formOptions)" class="fadeIn" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Nominal codes with the same code must have a unique narrative. Update the narrative below to fix the issue.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Validation result -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="validationResult" class="required">Narrative:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="validationResult" name="validationResult" ng-model="formOptions.validationResult.ValidationResultImportValue" required type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!updateValidationResultForm.$valid" display-text="formOptions.primaryButtonText" state="updateValidationResultForm.state"></submit-button>\n\t</fieldset>\n</form>');
$templateCache.put('forms/imports/upload-to-importer/uploadToImporterForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="messageDocumentTransferForm" ng-submit="messageDocumentTransfer(formOptions.file, messageDocumentTransferForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" fs-show-close="false" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<fieldset>\n\t\t\t\t<p class="s">\n\t\t\t\t\tYou\u2019re about to upload a copy of &lsquo;{{formOptions.file.DocumentName}}&rsquo; to the importer which can then be checked and used to import data into your Current period. The file attached to your note will still be the original version.\n\t\t\t\t</p>\n\t\t\t</fieldset>\n\t\t\t<!--\n\t\t\t<fieldset class="form-fieldset-divider-top">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input type="checkbox" id="dontShowWarning" name="dontShowWarning" ng-model="formObject.checkboxField" label-text="\'Don\u2019t show me this warning again\'" checkbox />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t<p class="form-note">\n\t\t\t\t\t\t\tPlease note: This will only turn off this warning for you and not everyone with access to notes\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t\t-->\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Continue\'" state="messageDocumentTransferForm.state" disable-button="!messageDocumentTransferForm.$valid"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Payroll has been calculated" ng-if="pageState === \'unable-to-import\'">\n\t<fs-main>\n\t\t<p class="s">If you\u2019d like to import changes to this pay period, close this window then click the \u2018Go back\u2019 button. This will ensure your draft reports have been calculated with the latest payroll data.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Cancel</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/imports/validate-data/validateDataForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Unable to match user -->\n\t<form class="fadeIn" name="matchTeamMemberForm" ng-submit="matchTeamMember(vm)" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Match to an existing team member</h4>\n\t\t\t<p class="s">\n\t\t\t\tSelect one of your existing team members so we know who to match this row with.\n\t\t\t\tPlease check all the information in the row to ensure you have matched it with the correct team member.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Team members -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required" for="selectedTeamMember">\n\t\t\t\t\tMatch this to a team member:\n\t\t\t\t</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select id="selectedTeamMember" name="selectedTeamMember" ng-model="vm.selectedTeamMember" ng-options="teamMember as teamMember.Forename + \' \' + teamMember.Surname\n\t\t\t\t\t\t\tfor teamMember in vm.teamMembers\n\t\t\t\t\t\t\t| orderBy: \'Forename\'\n\t\t\t\t\t\t\ttrack by teamMember.UserID" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="matchTeamMemberForm.selectedTeamMember.$touched" ng-messages="matchTeamMemberForm.selectedTeamMember.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a team member</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button disable-button="!matchTeamMemberForm.$valid" display-text="formOptions.primaryButtonText" state="matchTeamMemberForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="{{vm.errorTitle}}" ng-if="pageState === \'unknown-validation-type\'">\n\t<fs-main>\n\t\t<p>{{vm.errorDescription}}</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="HMRC Submission ID already in use" ng-if="pageState === \'submission-id-in-use\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe HMRC Submission ID entered is already in use by another team member across the PAYE scheme\n\t\t\t\tand to avoid any potential problems with duplicated data, it will be ignored from this import.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tAlternatively, if you are able to resolve the issue you can restart the import.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="HMRC Submission ID cannot be changed" ng-if="pageState === \'submission-id-locked\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThis team member has already been processed on payroll, so their HMRC Submission ID can no longer be changed.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tRemove the HMRC Submission ID for this team member from your file and try the import again,\n\t\t\t\tor ignore this row to import the rest of your file.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="Payroll ID already in use" ng-if="pageState === \'payroll-id-in-use\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe Payroll ID entered is already in use by another team member across the PAYE scheme.\n\t\t\t\tTo continue with your import, either update the value or delete it so you can add it manually in the team member\'s profile later.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tAlternatively, if you are able to resolve the issue you can restart the import.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="NI Number already in use" ng-if="pageState === \'ni-number-in-use-paycircle\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe NI Number in your file is already in use by another system user and to avoid any potential problems with duplicated data,\n\t\t\t\tit will be ignored from this import. We\'ll display an alert for this team member, to remind you before you run payroll,\n\t\t\t\tand you\'ll be able to edit the NI Number in this team members profile. Please note that all other data in this row will be imported as normal.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tAlternatively, if you can fix the issue in your CSV file beforehand, you can try your import again.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="NI Number already in use" ng-if="pageState === \'ni-number-in-use\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe NI Number in your file is already in use by another team member and to avoid any potential problems with duplicated data,\n\t\t\t\tit will be ignored from this import. We\'ll display an alert for this team member, to remind you before you run payroll,\n\t\t\t\tand you\'ll be able to edit the NI Number in this team members profile. Please note that all other data in this row will be imported as normal.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\tAlternatively, if you are able to resolve the issue you can restart the import.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="assertive" fs-title="NI Number already in use on PAYE scheme" ng-if="pageState === \'ni-number-in-use-on-paye-scheme\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tThe NI Number in your file is already in use by another team member on this PAYE scheme. Please note that the NI number will still be imported, \n\t\t\t\tso you may want to check that the information on your file is correct before continuing.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- No team members -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You don\'t have any team members set up yet" ng-if="pageState === \'no-team-members\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tYou can add new team members in\n\t\t\t<a ui-sref="team.members({agencyProfileId: formOptions.company.AgencyProfileID})">\n\t\t\t\tyour Team area\n\t\t\t</a>.\n\t\t\tTo get them ready for payroll, you may want to have things like their Date of Birth, NI Number, Address, Bank details and tax code to hand.\n\t\t\tYou can then import payroll changes and get the latest tax updates for your team members.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/onboarding/askMyAdvisor/askMyAdvisorForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="askMyAdvisorForm" ng-submit="openEmailClient(vm, askMyAdvisorForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Get help from your advisor or accountant</h5>\n\t\t<p class="s">We\u2019ll build you an SOS email so you can request their help!</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<label class="required" for="name">Full name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="name" name="name" ng-model="vm.name" ng-pattern="$root.REGEX.name" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="askMyAdvisorForm.name.$error" ng-if="askMyAdvisorForm.name.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a name</p>\n\t\t\t\t<p ng-message="pattern">Names can only contain letters, apostrophes and hyphens</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Email -->\n\t\t<div class="form-field">\n\t\t\t<label for="email" class="required">Email address</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="emailAddress" name="emailAddress" ng-model="vm.email" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="askMyAdvisorForm.emailAddress.$error" ng-show="askMyAdvisorForm.emailAddress.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Relationship to you -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="relationship" class="required">Relationship to you:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="relationship" id="relationship" ng-model="vm.relationshipType" ng-options="option.value as option.name for option in RELATIONSHIP_TYPES" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="askMyAdvisorForm.relationship.$error" ng-if="askMyAdvisorForm.relationship.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Message -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="message" class="required">Message:</label>\n\t\t\t\t<p class="s form-field-sub">All questions you\u2019ve marked for later are included in your message below. You can delete any of them if you don\u2019t need to ask for them any more.</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<textarea id="message" name="message" ng-model="vm.message" rows="20" required></textarea>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="askMyAdvisorForm.message.$error" ng-if="askMyAdvisorForm.message.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a message</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Create email\'" state="askMyAdvisorForm.state" disable-button="!askMyAdvisorForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/bureauEditFirstPeriod/bureauEditFirstPeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="bureauEditFirstPeriodForm" ng-submit="saveForm(form, bureauEditFirstPeriodForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="stronger"><i class="icon-support indifferent m"></i> Editing first pay period date</h6>\n\t\t\t\t<p class="s">\n\t\t\t\t\tEditing the first pay period for {{company.Name}} may mean that any team pay and tax info. and employer payment data that\u2019s been added will be out of date and will be deleted. This includes undoing any data imported from FPS or EPS files. Team pension states may also need reviewing to ensure they still match the data held in the providers portal. <a href="" target="_blank" class="indifferent">Read more here</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Date of birth -->\n\t\t<div class="form-field">\n\t\t\t<label for="goLiveDate" class="required">First pay period:</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field field-id="goLiveDate" field-min-date-iso="company.goLiveDateMinIso" field-value-iso="company.GoLiveDateISO" field-required="true">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bureauEditFirstPeriodForm.goLiveDate.$error" ng-if="bureauEditFirstPeriodForm.goLiveDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a first pay period date</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="min">New first pay period cannot be before {{company.goLiveDateMinIso | dateformat}}.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="bureauEditFirstPeriodForm.state" disable-button="!bureauEditFirstPeriodForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Go live date updated" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">The first pay period for {{company.Name}}. has been updated to {{company.GoLiveDateISO | dateformat}} and a notification email has been sent to <span class="stronger">{{company.AdminEmail}}</span>.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/onboarding/bureauExtendTrial/bureauExtendTrialForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" ng-if="pageState === \'ready\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{company.Name}} will have access to their free trial for another {{$root.CONFIG.demoCompanyTrialLength}} days. We\u2019ll send an email to <span class="stronger">{{company.AdminEmail}}</span> to let them know that their free trial has been extended.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="extendFreeTrial()">Extend free trial</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Free trial extended" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tAn email was sent to <span class="stronger">{{company.AdminEmail}}</span> to let them know that their free trial demo has been extended by a further 30 days.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/onboarding/bureauMoveToLive/bureauMoveToLiveForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" ng-if="pageState === \'ready\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">This will move {{company.Name}} from Onboarding to your Companies page and the next time they sign in, they will see changes to their account so they can get ready for their first period. </p>\n\t\t<p class="s">By default they will be in \u2018Test mode\u2019, similar to running in parallel, and you will need to switch them to \u2018Live mode\u2019 so their first period is run as live. More info on test and live modes</p>\n\t\t<p class="s">Please note that you won\u2019t be able to move them back to Onboarding once moved.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="moveCompanyLive()">Move to live</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{company.Name}} has moved" ng-if="pageState === \'moved\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t{{company.Name}} can now be found in your Companies page where they are set to run in \u2018Test mode\u2019. Remember to switch them to \u2018Live mode\u2019 if you wish to run their first period as live.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/bureauNewCompany/bureauNewCompanyForm.html','<form name="bureauNewCompanyForm" ng-submit="reviewCompany(company, bureauNewCompanyForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="companyName" class="required">Company name:</label>\n\t\t\t</div>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="companyName" name="companyName" ng-model="company.Name" ng-pattern="$root.REGEX.companyName" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bureauNewCompanyForm.companyName.$error" ng-if="bureauNewCompanyForm.companyName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Invite to register -->\n\t\t<div class="form-field" ng-if="!company.Demonstration">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="delaySend" name="delaySend" ng-model="company.DelaySend" ng-true-value="false" ng-false-value="true" label-text="\'Send an invitation to register\'" checkbox>\n\t\t\t</div>\n\t\t\t<p class="form-message normal">\n\t\t\t\tWe\u2019ll email them a link to register for a Paycircle account so they can view and edit their onboarding dashboard.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="!company.DelaySend">\n\n\t\t<!-- Name -->\n\t\t<section class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="company.AdminForename" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bureauNewCompanyForm.forename.$error" ng-if="bureauNewCompanyForm.forename.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Last name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="surname">Surname:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="surname" name="surname" ng-model="company.AdminSurname" ng-pattern="$root.REGEX.name" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="bureauNewCompanyForm.surname.$error" ng-if="bureauNewCompanyForm.surname.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a last name</p>\n\t\t\t\t\t<p ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Personal Email -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="email">Email address</label>\n\t\t\t</div>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="email" name="email" required ng-model="company.AdminEmail" ng-model-options="{ debounce: 500 }">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bureauNewCompanyForm.email.$error" ng-show="bureauNewCompanyForm.email.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Telephone number -->\n\t\t<div class="form-field">\n\t\t\t<label for="phone">Telephone number:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="phone" name="phone" ng-model="company.AdminTelephone" ng-pattern="$root.REGEX.telephone">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="bureauNewCompanyForm.phone.$error" ng-if="bureauNewCompanyForm.phone.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a telephone number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid phone number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Demo company message -->\n\t\t<div class="form-field" ng-if="company.Demonstration">\n\t\t\t<div class="info-block primary">\n\t\t\t\t<div class="info-block-main">\n\t\t\t\t\t<p class="s">We\u2019ll email them an activation code to confirm their email address and set up their demo account. The free demo will last for {{$root.CONFIG.demoCompanyTrialLength}} days after which it can be extended for another {{$root.CONFIG.demoCompanyTrialLength}} days.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="bureauNewCompanyForm.state" disable-button="!bureauNewCompanyForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="New company saved" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\n\t\t<!-- Invitation sent -->\n\t\t<div ng-if="!company.DelaySend">\n\t\t\t<p class="s" ng-if="!company.Demonstration">An invitation to register has been emailed to&nbsp;<span class="stronger">{{company.AdminEmail}}</span>&nbsp;and you can now monitor the progress of&nbsp;<span class="stronger">{{company.Name}}</span>&nbsp;on your Onboarding page.</p>\n\t\t\t<p class="s" ng-if="company.Demonstration">A free trial demo activation code has been emailed to&nbsp;<span class="stronger">{{company.AdminEmail}}</span>&nbsp;and you can now monitor the onboarding progress of&nbsp;<span class="stronger">{{company.Name}}</span>&nbsp;on your Onboarding page.</p>\n\t\t</div>\n\n\t\t<!-- Invitation not sent -->\n\t\t<div ng-if="company.DelaySend">\n\t\t\t<p class="s">You can monitor the progress of&nbsp;<span class="stronger">{{company.Name}}</span>&nbsp;on your Onboarding page. You can invite someone to register at a later date.</p>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/onboarding/bureauOnboardingChecklist/bureauOnboardingChecklistForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="bureauOnboardingChecklistForm" ng-submit="saveForm(form, bureauOnboardingChecklistForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-action" ng-if="formOptions.company.AdminInviteState === ADMIN_INVITE_STATES.registered">\n\t\t<p class="s">\n\t\t\tHere\u2019s an overview of the questions answered so far. Click on \u2018Go to company\u2019 to edit the questions.\n\t\t</p>\n\t\t<div class="form-action__button">\n\t\t\t<a ui-sref="company-dashboard({agencyProfileId: formOptions.company.AgencyProfileID})" class="button primary">Go to Company&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t</div>\n\t</div>\n\n\t<fieldset>\n\t\t<question-block-bureau ng-repeat="group in company.questions" qb-group="group" qp-theme="primary"></question-block-bureau>\n\t</fieldset>\n\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/cancelTrial/cancelTrialForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">Once you click \u2018Confirm\u2019, your account, and any of your data held by Paycircle, will be deleted and you will be logged out.</p>\n\n\t\t<p class="s"><span class="stronger">Please note:</span> once your account has been deleted it cannot be undone and the data cannot be recovered.</p>\n\n\t\t<p class="s">An email will be sent to <span class="stronger">{{company.CancellationEmail}}</span> to confirm that your data has been deleted in line with GDPR regulations.</p>\n\n\t\t<p class="s">\n\t\t\t<a href="{{$root.URLS.paycircle.website.privacy}}" target="_blank" class="underline">More info on how we manage data in Paycircle</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button ng-click="deleteCompany(company, vm)" display-text="\'Confirm\'" state="vm.state"></submit-button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/moveToOnboarding/moveToOnboardingForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">Once you\u2019ve moved {{formOptions.company.Name}} to Onboarding, any company admins will now see their Onboarding dashboard the next time they sign in.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button ng-click="moveCompanyToOnboarding(vm)" display-text="\'Move to onboarding\'" state="vm.state"></submit-button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{company.Name}} has moved" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.company.Name}} can now be found in your Companies page where they are set to run in \u2018Test mode\u2019. Remember to switch them to \u2018Live mode\u2019 if you wish to run their first period as live.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/onboardingWizardCompany/onboardingWizardCompanyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'" ng-switch="formOptions.activeStep">\n\t<!-- Step 1 -->\n\t<form class="fadeIn" name="onboardingWizardCompanyFormStep1" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardCompanyFormStep1)" ng-switch-when="1" novalidate>\n\t\t<fieldset>\n\n\t\t\t<!-- What type of company are you? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="paymentDateFirstPeriod" class="required">What type of company are you?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="xl" id="paymentDateFirstPeriod" name="paymentDateFirstPeriod" ng-model="vm.companyType" ng-options="option.value as option.name for option in COMPANY_TYPE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep1.paymentDateFirstPeriod.$touched" ng-messages="onboardingWizardCompanyFormStep1.paymentDateFirstPeriod.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.companyType.indexOf(\'LLP\') === -1">\n\t\t\t<!-- Company Number-->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="numberField">Company number</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="l" id="companyNumber" maxlength="10" name="companyNumber" ng-model="vm.companyNumber" ng-pattern="$root.REGEX.companyNumber" type="text" capitalise>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep1.companyNumber.$touched" ng-messages="onboardingWizardCompanyFormStep1.companyNumber.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a company number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid company number. They are usually between 7-8 digits, often starting with 2 letters.</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">The registration number provided by Companies House</p>\n\t\t\t</div>\n\n\t\t\t<!-- Number of Directors -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="numberOfDirectors">Number of directors</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="m" id="numberOfDirectors" maxlength="10" name="numberOfDirectors" ng-model="vm.numberOfDirectors" ng-pattern="$root.REGEX.number" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep1.numberOfDirectors.$touched" ng-messages="onboardingWizardCompanyFormStep1.numberOfDirectors.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid number</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t\t<submit-button disable-button="!onboardingWizardCompanyFormStep1.$valid" display-text="formOptions.primaryButtonText" icon-position="right" icon="icon-chevron-right" state="onboardingWizardCompanyFormStep1.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 2 -->\n\t<form class="fadeIn" name="onboardingWizardCompanyFormStep2" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardCompanyFormStep2)" ng-switch-when="2" novalidate>\n\t\t<fieldset>\n\n\t\t\t<!-- How are your team employed? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="employmentType" class="required">How are your team employed?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="xl" id="employmentType" name="employmentType" ng-model="vm.employmentTypes" ng-options="option.value as option.name for option in EMPLOYMENT_TYPE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep2.employmentType.$touched" ng-messages="onboardingWizardCompanyFormStep2.employmentType.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- How are the team paid? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="salaryType" class="required">How are they paid?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="xl" id="salaryType" name="salaryType" ng-model="vm.salaryTypes" ng-options="option.value as option.name for option in SALARY_TYPE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep2.salaryType.$touched" ng-messages="onboardingWizardCompanyFormStep2.salaryType.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" ng-click="goToPreviousStep()" class="button secondary-action">\n\t\t\t\t<i class="icon-chevron-left"></i>Back\n\t\t\t</a>\n\t\t\t<submit-button disable-button="!onboardingWizardCompanyFormStep2.$valid" display-text="formOptions.primaryButtonText" icon-position="right" icon="icon-chevron-right" state="onboardingWizardCompanyFormStep2.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 3 -->\n\t<form class="fadeIn" name="onboardingWizardCompanyFormStep3" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardCompanyFormStep3)" ng-switch-when="3" novalidate>\n\t\t<fieldset>\n\n\t\t\t<!-- Accounts office reference -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="accountsOfficeReference" class="l {{vm.accountsOfficeReferenceSkip ? \'disabled\' : \'required\'}}">Accounts office reference number</label>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tAn Accounts Office Reference number is needed when you make\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.payeReferenceNumber">PAYE</support-article-link>\n\t\t\t\t\t\tpayments to HMRC and should follow the format 123PA12345678.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.accountsOfficeReference" underline="true">How to find it</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="accountsOfficeReference" max-length="13" min-length="13" name="accountsOfficeReference" ng-disabled="vm.accountsOfficeReferenceSkip" ng-model="vm.accountsOfficeReference" ng-pattern="!vm.accountsOfficeReferenceSkip ? $root.REGEX.accountsOfficeRef : \'\'" ng-required="!vm.accountsOfficeReferenceSkip" placeholder="123PA12345678" type="text" capitalise>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep3.accountsOfficeReference.$touched" ng-messages="onboardingWizardCompanyFormStep3.accountsOfficeReference.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t<p ng-message="pattern">This should be 13 characters and follow the format 123PA12345678</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Skip -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-skip">\n\t\t\t\t\t<input class="form-field-skip-checkbox" id="accountsOfficeReferenceSkip" label-text="\'Skip this for now\'" name="accountsOfficeReferenceSkip" ng-model="vm.accountsOfficeReferenceSkip" type="checkbox" checkbox>\n\t\t\t\t\t<p class="s">This is needed in order to run your first pay period so we\'ll add it to your list of skipped questions on your onboarding dashboard.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-fieldset-divider-top">\n\n\t\t\t<!-- PAYE reference number-->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payeReference1" class="l {{vm.payeReferenceSkip ? \'disabled\' : \'required\'}}">PAYE reference number</label>\n\t\t\t\t\t<p class="s">If you are a company and you employ people to work with you and pay them as employees then you would normally register for Pay As You Earn (PAYE) with HMRC.\n\t\t\t\t\t\tThis should follow the format 123/A246.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.payeReferenceNumber" underline="true">How to find it</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="s" id="payeReference1" name="payeReference1" ng-change="constructPayeReference(vm)" ng-disabled="vm.payeReferenceSkip" ng-model="vm.payeReference1" ng-pattern="!vm.payeReferenceSkip ? $root.REGEX.payeRefA : \'\'" ng-required="!vm.payeReferenceSkip" placeholder="123" type="text" capitalise>\n\t\t\t\t\t<span>&nbsp;/&nbsp;</span>\n\t\t\t\t\t<input class="s" id="payeReference2" name="payeReference2" ng-change="constructPayeReference(vm)" ng-disabled="vm.payeReferenceSkip" ng-model="vm.payeReference2" ng-pattern="!vm.payeReferenceSkip ? $root.REGEX.payeRefB : \'\'" ng-required="!vm.payeReferenceSkip" placeholder="A246" type="text" capitalise>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep3.payeReference1.$touched && onboardingWizardCompanyFormStep3.payeReference2.$touched" ng-messages="onboardingWizardCompanyFormStep3.payeReference1.$error || onboardingWizardCompanyFormStep3.payeReference2.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a PAYE reference number</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a valid PAYE reference number. E.g. 123/A246</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Skip -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-skip">\n\t\t\t\t\t<input class="form-field-skip-checkbox" id="payeReferenceSkip" label-text="\'Skip this for now\'" name="payeReferenceSkip" ng-model="vm.payeReferenceSkip" type="checkbox" checkbox>\n\t\t\t\t\t<p class="s">This is needed in order to run your first pay period so we\'ll add it to your list of skipped questions on your onboarding dashboard.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()">\n\t\t\t\t<i class="icon-chevron-left"></i>Back\n\t\t\t</a>\n\t\t\t<submit-button disable-button="!onboardingWizardCompanyFormStep3.$valid" display-text="formOptions.primaryButtonText" icon-position="right" icon="icon-chevron-right" state="onboardingWizardCompanyFormStep3.state">\n\t\t\t</submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 4 -->\n\t<form class="fadeIn" name="onboardingWizardCompanyFormStep4" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardCompanyFormStep4)" ng-switch-when="4" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>Electronic updates</h4>\n\t\t\t<p class="s">\n\t\t\t\tWe suggest enabling electronic updates from HMRC to automatically keep tax codes and student loan notices up to date.\n\t\t\t\tYour credentials will be validated when you click \u2018Save\u2019.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Electronic updates enabled? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="electronicUpdatesTrue" class="{{vm.hmrcCredentialsSkip ? \'disabled\' : \'required\'}}">Enable electronic updates:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input class="b" id="electronicUpdatesTrue" name="hmrcCredentials" ng-disabled="vm.hmrcCredentialsSkip" ng-model="vm.electronicUpdates" ng-required="!vm.hmrcCredentialsSkip" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="electronicUpdatesTrue">Yes</label>\n\t\t\t\t\t\t<input class="b" id="electronicUpdatesFalse" name="hmrcCredentials" ng-disabled="vm.hmrcCredentialsSkip" ng-model="vm.electronicUpdates" ng-required="!vm.hmrcCredentialsSkip" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="electronicUpdatesFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">You\'ll need to make sure electronic updates, also known as Electronic Data Interchange (EDI), is enabled in your HMRC account.\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Find out how</support-article-link>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- HMRC User ID -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="hmrcUserId" ng-class="{required: vm.electronicUpdates && !vm.hmrcCredentialsSkip, disabled: vm.hmrcCredentialsSkip}">HMRC User ID:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcUserId" maxlength="{{$root.CONFIG.hmrcUsernameMaxLength}}" name="hmrcUserId" ng-disabled="vm.hmrcCredentialsSkip" ng-model="vm.hmrcUsername" ng-required="vm.electronicUpdates && !vm.hmrcCredentialsSkip" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep4.hmrcUserId.$touched" ng-messages="onboardingWizardCompanyFormStep4.hmrcUserId.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the HMRC User ID</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- HMRC Password -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="hmrcPassword" ng-class="{required: vm.electronicUpdates && !vm.hmrcCredentialsSkip, disabled: vm.hmrcCredentialsSkip}">HMRC Password:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcPassword" name="hmrcPassword" ng-disabled="vm.hmrcCredentialsSkip" ng-model="vm.hmrcPassword" ng-required="vm.electronicUpdates && !vm.hmrcCredentialsSkip" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="onboardingWizardCompanyFormStep4.hmrcPassword.$touched" ng-messages="onboardingWizardCompanyFormStep4.hmrcPassword.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the HMRC Password</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Skip -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-skip">\n\t\t\t\t\t<input class="form-field-skip-checkbox" id="hmrcCredentialsSkip" label-text="\'Skip this for now\'" name="hmrcCredentialsSkip" ng-change="resethmrcCredentials(vm)" ng-model="vm.hmrcCredentialsSkip" type="checkbox" checkbox>\n\t\t\t\t\t<p class="s">This is needed in order to run your first pay period so we\'ll add it to your list of skipped questions on your onboarding dashboard.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()">\n\t\t\t\t<i class="icon-chevron-left"></i>Back\n\t\t\t</a>\n\t\t\t<submit-button disable-button="!onboardingWizardCompanyFormStep4.$valid" display-text="formOptions.primaryButtonText" icon-position="right" icon="icon-chevron-right" state="onboardingWizardCompanyFormStep4.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Summary -->\n\t<div class="form-content-block" ng-switch-when="5">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tReview the questions you\u2019ve answered and any you\u2019ve skipped for now. Click on the edit icon to jump back and edit anything you need to change.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="task-list has-margin">\n\t\t\t<div class="task-list-item" ng-class="{\'is-complete\': question.Complete, \'is-skipped\': question.Skipped, \'required\': question.Mandatory}" ng-repeat="question in vm.companyQuestions">\n\t\t\t\t<p class="task-list-item-label">{{question.QuestionName}}<span class="tertiary" ng-if="question.Mandatory">*</span></p>\n\t\t\t\t<div ng-switch="question.valueType">\n\t\t\t\t\t<div class="question-list-item-value" ng-switch-when="address">\n\t\t\t\t\t\t<print-address address="question.value"></print-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="boolean">\n\t\t\t\t\t\t{{question.Value ? \'Yes\' : \'No\'}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="date">\n\t\t\t\t\t\t{{question.Value | dateformat}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="task-list-item-value {{question.Value === \'\' ? \'is-empty\' : \'\'}}" ng-switch-when="hmrc-credentials">\n\t\t\t\t\t\t<span ng-if="question.Skipped">Skipped</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && (question.Value && question.Value !== \'\')">{{question.Value}}</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && (!question.Value || question.Value === \'\')">Not provided</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="salary-type">\n\t\t\t\t\t\t{{question.Value | paymentTypeDescription}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="task-list-item-value {{question.Value === \'\' ? \'is-empty\' : \'\'}}" ng-switch-default>\n\t\t\t\t\t\t<span ng-if="question.Skipped">Skipped</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && (question.Value && question.Value !== \'\')">{{question.Value}}</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && (!question.Value || question.Value === \'\')">Not answered</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<a class="task-list-item-edit" href="" ng-click="setActiveStep(question.formStep)">\n\t\t\t\t\t<i class="icon-edit"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="goToPreviousStep()">\n\t\t\t\t<i class="icon-chevron-left"></i>Back\n\t\t\t</a>\n\t\t\t<a class="button primary-action tertiary" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tFinish\n\t\t\t</a>\n\t\t</fieldset>\n\t</div>\n</div>\n\n<!-- Testing HMRC credentials -->\n<section class="form-summary fadeIn" ng-if="pageState === \'testing-hmrc-credentials\'">\n\t<loading-block size="m">\n\t\t<lb-description>Validating HMRC credentials...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">We\'re quickly testing the connection to HMRC. This shouldn\'t take too long.</p>\n\t</section>\n</section>\n\n<!-- HMRC credentials invalid -->\n<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to validate HMRC credentials" ng-if="pageState === \'hmrc-credentials-invalid\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to validate the HMRC credentials entered.</p>\n\t\t<p class="s">\n\t\t\t<a href="" ng-click="setPageState(\'ready\')" class="underline">\n\t\t\t\tGo back and try again\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- HMRC credentials valid but Electronic updates are not switched on -->\n<form-state class="fadeIn" form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Electronic updates not enabled" ng-if="pageState === \'automatic-updates-not-enabled\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tWe were able to connect to HMRC successfully although it appears as though your electronic HMRC notices are not enabled.\n\t\t\tYou\'ll need to turn these on to enable electronic notices. Follow\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">\n\t\t\t\tthese simple steps\n\t\t\t</support-article-link>\n\t\t\tto switch electronic notices on.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/onboarding/onboardingWizardProfile/onboardingWizardProfileForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'" ng-switch="formOptions.activeStep">\n\n\t<!-- Step 1 -->\n\t<form name="onboardingWizardProfileFormStep1" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardProfileFormStep1)" class="fadeIn" novalidate ng-switch-when="1">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Get started</h4>\n\t\t\t<p class="s">Answer these simple Profile questions to get your Onboarding underway!</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- What type of company are you? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="relationshipToCompany" class="required">What is your relationship to {{formOptions.company.Name}}?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="l-alt" name="relationshipToCompany" id="relationshipToCompany" ng-model="vm.relationshipToCompany" ng-options="option.value as option.name for option in RELATIONSHIP_TYPE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep1.relationshipToCompany.$error" ng-if="onboardingWizardProfileFormStep1.relationshipToCompany.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- What is your Payroll experience? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payrollExperience" class="required">What is your payroll experience?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="l-alt" name="payrollExperience" id="payrollExperience" ng-model="vm.payrollExperience" ng-options="option.value as option.name for option in PAYROLL_EXPERIENCE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep1.payrollExperience.$error" ng-if="onboardingWizardProfileFormStep1.payrollExperience.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()" ng-if="formOptions.canCloseForm">Cancel</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="onboardingWizardProfileFormStep1.state" disable-button="!onboardingWizardProfileFormStep1.$valid" icon="icon-chevron-right" icon-position="right"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 2 -->\n\t<form name="onboardingWizardProfileFormStep2" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardProfileFormStep2)" class="fadeIn" novalidate ng-switch-when="2">\n\t\t<fieldset>\n\n\t\t\t<!-- Who will be involved? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payrollInvolvement" class="required">Who will be involved with running this payroll?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select name="payrollInvolvement" id="payrollInvolvement" ng-model="vm.payrollInvolvement" ng-options="option.value as option.name for option in INVOLVEMENT_TYPE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep2.payrollInvolvement.$error" ng-if="onboardingWizardProfileFormStep2.payrollInvolvement.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()"><i class="icon-chevron-left"></i>Back</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="onboardingWizardProfileFormStep2.state" disable-button="!onboardingWizardProfileFormStep2.$valid" icon="icon-chevron-right" icon-position="right"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 3 -->\n\t<form name="onboardingWizardProfileFormStep3" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardProfileFormStep3)" class="fadeIn" novalidate ng-switch-when="3">\n\n\t\t<fieldset>\n\n\t\t\t<!-- Software -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="existingPayrollSoftware" class="required">What software do you currently use to run payroll?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select name="existingPayrollSoftware" id="existingPayrollSoftware" ng-model="vm.existingPayrollSoftware" ng-options="option.value as option.name for option in SOFTWARE_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep3.existingPayrollSoftware.$error" ng-if="onboardingWizardProfileFormStep3.existingPayrollSoftware.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Payroll complexity -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="payrollComplexityRating" class="required">How complex is your payroll?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select name="payrollComplexityRating" id="payrollComplexityRating" ng-model="vm.payrollComplexityRating" ng-options="option.value as option.name for option in PAYROLL_COMPLEXITY_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep3.payrollComplexityRating.$error" ng-if="onboardingWizardProfileFormStep3.payrollComplexityRating.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()"><i class="icon-chevron-left"></i>Back</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="onboardingWizardProfileFormStep3.state" disable-button="!onboardingWizardProfileFormStep3.$valid" icon="icon-chevron-right" icon-position="right"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Step 4 -->\n\t<form name="onboardingWizardProfileFormStep4" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardProfileFormStep4)" class="fadeIn" novalidate ng-switch-when="4">\n\n\t\t<fieldset>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="isPayrollActive" class="required">Which modules will you be using?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="checkbox-cards">\n\t\t\t\t\t\t<div class="checkbox-card quarternary">\n\t\t\t\t\t\t\t<input type="checkbox" id="isPayrollActive" name="isPayrollActive" class="checkbox-card-input" ng-model="vm.isPayrollActive">\n\t\t\t\t\t\t\t<label class="checkbox-card-label" for="isPayrollActive">\n\t\t\t\t\t\t\t\t<header class="checkbox-card-header">\n\t\t\t\t\t\t\t\t\t<i class="icon-clock checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Payroll</h5>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<p class="checkbox-card-text">Manage payroll for your team - simple, cloud-based and collaborative, no previous payroll experience required!</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="checkbox-card secondary">\n\t\t\t\t\t\t\t<input type="checkbox" id="isWorkplacePensionActie" name="isWorkplacePensionActie" class="checkbox-card-input" ng-model="vm.isWorkplacePensionActive">\n\t\t\t\t\t\t\t<label class="checkbox-card-label" for="isWorkplacePensionActie">\n\t\t\t\t\t\t\t\t<header class="checkbox-card-header">\n\t\t\t\t\t\t\t\t\t<i class="icon-money checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">Workplace pension</h5>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<p class="checkbox-card-text">Connect your workplace pension to payroll or manage your workplace pension on its own - with no payroll connected</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!--\n\t\t\t\t\t\t<div class="checkbox-card primary">\n\t\t\t\t\t\t\t<input type="checkbox" id="isCisActive" name="isCisActive" class="checkbox-card-input" ng-model="vm.isCISActive" />\n\t\t\t\t\t\t\t<label class="checkbox-card-label" for="isCisActive">\n\t\t\t\t\t\t\t\t<header class="checkbox-card-header">\n\t\t\t\t\t\t\t\t\t<i class="icon-cis checkbox-card-icon m"></i>\n\t\t\t\t\t\t\t\t\t<h5 class="checkbox-card-title">CIS</h5>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<p class="checkbox-card-text">Manage payroll for your CIS workers</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t-->\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()"><i class="icon-chevron-left"></i>Back</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="onboardingWizardProfileFormStep4.state" disable-button="!onboardingWizardProfileFormStep4.$valid" icon="icon-chevron-right" icon-position="right"></submit-button>\n\t\t</fieldset>\n\t</form>\t\t\n\n\t<!-- Step 5 -->\n\t<form name="onboardingWizardProfileFormStep5" ng-submit="saveCompanyOnboarding(vm, formOptions, onboardingWizardProfileFormStep5)" class="fadeIn" novalidate ng-switch-when="5">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Your payroll advisor</h4>\n\t\t\t<p class="s">You may be able to ask your existing payroll advisor to help with giving you awkward pieces of information etc.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- External advisor -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="hasExternalAdvisor" class="required">Do you have an accountant or other external advisor?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select name="hasExternalAdvisor" id="hasExternalAdvisor" class="l" ng-model="vm.hasExternalAdvisor" ng-change="updateExternalAdvisorInvolvement(vm)" ng-options="option.value as option.name for option in YES_NO_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep5.hasExternalAdvisor.$error" ng-if="onboardingWizardProfileFormStep5.hasExternalAdvisor.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- External advisor involvement -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.hasExternalAdvisor === \'Yes\'">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="externalAdvisorInvolvement" class="required">Do you think they will help with onboarding?</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select name="externalAdvisorInvolvement" id="externalAdvisorInvolvement" class="l" ng-model="vm.externalAdvisorInvolvement" ng-options="option.value as option.name for option in YES_NO_OPTIONS" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="onboardingWizardProfileFormStep5.externalAdvisorInvolvement.$error" ng-if="onboardingWizardProfileFormStep5.externalAdvisorInvolvement.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">We\'ll work with them to get all the information required to get your account ready to go live.</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()"><i class="icon-chevron-left"></i>Back</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="onboardingWizardProfileFormStep5.state" disable-button="!onboardingWizardProfileFormStep5.$valid" icon="icon-chevron-right" icon-position="right"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Summary -->\n\t<div class="form-content-block" ng-switch-when="6">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tReview the questions you\u2019ve answered and any you\u2019ve skipped for now. Click on the edit icon to jump back and edit anything you need to change.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="task-list">\n\t\t\t<div class="task-list-item" ng-class="{\'is-complete\': question.Complete, \'is-skipped\': question.Skipped, \'required\': question.Mandatory}" ng-repeat="question in vm.profileQuestions | orderBy:\'order\'" ng-if="question.showBlock">\n\t\t\t\t<p class="task-list-item-label">{{question.QuestionName}}<span class="tertiary" ng-if="question.Mandatory">*</span></p>\n\t\t\t\t<div ng-switch="question.valueType">\n\t\t\t\t\t<div class="question-list-item-value" ng-switch-when="address">\n\t\t\t\t\t\t<print-address address="question.value"></print-address>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="boolean">{{question.Value ? \'Yes\' : \'No\'}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="date">{{question.Value | dateformat}}</p>\n\t\t\t\t\t<p class="task-list-item-value" ng-switch-when="salary-type">{{question.Value | paymentTypeDescription}}</p>\n\t\t\t\t\t<p class="task-list-item-value {{question.Value === \'\' ? \'is-empty\' : \'\'}}" ng-switch-default>\n\t\t\t\t\t\t<span ng-if="question.Skipped">Skipped</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && question.Value !== \'\'">{{question.Value}}</span>\n\t\t\t\t\t\t<span ng-if="!question.Skipped && question.Value === \'\'">Not answered</span>\n\t\t\t\t\t</p>\n\n\t\t\t\t</div>\n\t\t\t\t<a href="" ng-click="setActiveStep(question.formStep)" class="task-list-item-edit"><i class="icon-edit"></i></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="goToPreviousStep()"><i class="icon-chevron-left"></i>Back</a>\n\t\t\t<a href="" class="button primary-action tertiary" ng-click="formOptions.closeForm()">Finish</a>\n\t\t</fieldset>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/onboarding/unlockApprovePayroll/unlockApprovePayrollForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="unlockApprovePayrollForm" ng-submit="saveForm(form, unlockApprovePayrollForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Check your data is up to date</h5>\n\t\t<p class="s">The end date of your first pay period ({{currentPayPeriod.PayPeriodDisplay}}) has passed and you haven\u2019t run payroll yet. We\u2019ve temporarily locked the approve payroll button so we can understand why you\u2019re delayed. <a href="" class="underline">Why do we check this with you?</a></p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Company Template -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">Tell us why you\'re delayed</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row primary">\n\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateOlympicStars" class="b radio-row-input" ng-value="COMPANY_TEMPLATES.olympicStars" ng-model="vm.Customisation">\n\t\t\t\t\t\t<label for="companyTemplateOlympicStars" class="radio-row-label">I\'m just running a little bit behind</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row tertiary">\n\t\t\t\t\t\t<input type="radio" name="companyTemplate" id="companyTemplateMovieStars" class="b radio-row-input" ng-value="COMPANY_TEMPLATES.movieStars" ng-model="vm.Customisation">\n\t\t\t\t\t\t<label for="companyTemplateMovieStars" class="radio-row-label">I\'ve run the pay period ({{currentPayPeriod.PayPeriodDisplay}}) in {{\'NameOfPreviousPayrollProvider\'}}</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<p class="form-message">We didn\u2019t mean to cause a panic and we only check this with you for your first pay period. If your data is right now it will be right going forwards! \uD83E\uDD17</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="unlockApprovePayrollForm.state" disable-button="!unlockApprovePayrollForm.$valid"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Form state title" ng-if="pageState === \'form-state\'">\n\t<fs-main>\n\t\t<p>A message that lives within the form state</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/addAChange/addAChangeForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="tight fadeIn" name="addAChangeForm" ng-if="pageState === \'ready\'" ng-submit="addChange(vm, addAChangeForm)" novalidate>\n\n\t<!-- Tax refund -->\n\t<div class="form-content-block no-margin top fadeIn" ng-if="vm.selectedTeamMembers.length && vm.selectedTeamMembers[0].HasTaxRefund">\n\t\t<div class="note indifferent">\n\t\t\t<h6 class="stronger"><i class="icon-support indifferent m"></i> Team members with tax refunds</h6>\n\t\t\t<p class="s">{{vm.selectedTeamMembers[0].Forename}} is set to receive a tax refund this period because {{vm.selectedTeamMembers[0].Gender | personalise:\'he\'}} is on zero pay. Adding a change will remove the tax refund. <a href="" ng-href="{{$root.URLS.paycircle.support.applyingTaxRefund}}" target="_blank" class="indifferent underline">Read more about tax refunds</a></p>\n\t\t</div>\n\t</div>\n\n\t<!-- Find team member -->\n\t<fieldset ng-if="!isEditTeamMember">\n\n\t\t<div class="form-field">\n\t\t\t<div class="pill-input-field primary" ng-class="{\'active\': vm.searchTermTeamMembersFocused}" ng-click="toggleSearchTermTeamMembersFocus(vm, true)">\n\t\t\t\t<label for="searchTermTeamMembers" class="pill-input-field-label"><i class="icon-user"></i> Add change for</label>\n\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" id="searchTermTeamMembers" ng-blur="toggleSearchTermTeamMembersFocus(vm, false)" ng-focus="toggleSearchTermTeamMembersFocus(vm, true)" ng-if="!vm.selectedTeamMembers.length" ng-model="vm.searchTermTeamMembers" placeholder="Search for a team member or department" type="text">\n\n\t\t\t\t<div class="pill-input-field-items" ng-if="vm.selectedTeamMembers.length">\n\t\t\t\t\t<div class="pill-input-field-item fadeIn" ng-repeat="selectedTeamMember in vm.selectedTeamMembers">\n\t\t\t\t\t\t<span>{{selectedTeamMember.Forename}} {{selectedTeamMember.Surname}}</span>\n\t\t\t\t\t\t<a href="" ng-click="deselectTeamMember(vm, $index)" class="pill-input-field-item-delete" aria-label="Deselect team menber"><i class="icon-plus"></i></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="pill-input-search-results dropIn" click-anywhere-but-here="resetTeamMemberSearchTerm()" is-active="vm.searchTermTeamMembers.length >= SEARCH_TERM_MIN_COUNT" ng-show="vm.searchTermTeamMembers.length >= SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t\t<!-- Team Members -->\n\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Team members</p>\n\t\t\t\t\t\t<button class="pill-input-search-result is-clear is-primary" ng-click="selectTeamMember(teamMember, \'searchTermAdjustmentTypes\')" ng-if="filteredTeamMembers.length" ng-repeat="teamMember in filteredTeamMembers = (teamMembers | filter: vm.searchTermTeamMembers) | limitTo:SEARCH_RESULTS_LIMIT" type="button">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-avatar">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-tiny" avatar-theme="is-primary" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{teamMember.Forename}} {{teamMember.Surname}}</p>\n\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action" aria-label="Select team member"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p ng-if="!filteredTeamMembers.length"><span class="caption">No team members found</span></p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Departments -->\n\t\t\t\t\t<div class="pill-input-search-results-group" ng-if="CAN_ADD_DEPARTMENT_CHANGES">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Departments</p>\n\t\t\t\t\t\t<button class="pill-input-search-result is-clear is-quarternary clickable" ng-click="selectTeamMembersByDepartment(teamMembers, department.AgencyDepartmentID)" ng-if="filteredTeamMembers.length" ng-repeat="department in filteredDepartments = (departments | filter: vm.searchTermTeamMembers) | limitTo:SEARCH_RESULTS_LIMIT" type="button">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t<icon-dot icon="icon-team-alt" is-light="true" theme="is-medium is-quaternary"></icon-dot>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{department.AgencyDepartmentName}}</p>\n\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action" aria-label="Select department"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p ng-if="!filteredDepartments.length"><span class="caption">No departments found</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Or select team member from list... -->\n\t\t<fieldset class="fadeIn" ng-if="!vm.selectedTeamMembers.length">\n\n\t\t\t<div class="form-content-block tight">\n\t\t\t\t<p class="s">Or select from below:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<div class="item-selection-cards" data-cy="add-a-change-form-item-selection-cards">\n\n\t\t\t\t\t<!-- Team Members -->\n\t\t\t\t\t<button class="item-selection-card is-clear primary clickable {{teamMember.isCompany ? \'is-company\' : \'\'}}" data-cy="add-a-change-form-add-change-team-member-button-{{$index}}" id="add-change-team-member-{{$index}}" ng-click="selectTeamMember(teamMember, \'searchTermAdjustmentTypes\')" ng-repeat="teamMember in teamMembers | limitTo:vm.searchResultsLimitTeam" type="button">\n\t\t\t\t\t\t<div class="item-selection-card-avatar" data-cy="add-a-change-form-add-change-team-member-avatar-{{::teamMember.UserID | slugify}}">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-small" avatar-theme="is-primary" avatar-user-id="{{teamMember.UserID}}" data-cy="add-a-change-form--add-change-team-member-avatar-component-{{::teamMember.UserID | slugify}}"></avatar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="item-selection-card-forename" data-cy="add-a-change-form-team-member-forename-{{::teamMember.Forename | slugify}}">{{teamMember.Forename}}</p>\n\t\t\t\t\t\t<p class="item-selection-card-surname" data-cy="add-a-change-form-team-member-surname-{{::teamMember.Surname | slugify}}">{{teamMember.Surname}}</p>\n\t\t\t\t\t\t<a href="" class="item-selection-card-action" data-cy="add-a-change-form-team-member-action-{{$index}}"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<!-- Departments -->\n\t\t\t\t\t<button class="item-selection-card quarternary clickable" ng-click="selectTeamMembersByDepartment(teamMembers, department.AgencyDepartmentID)" ng-if="CAN_ADD_DEPARTMENT_CHANGES" ng-repeat="department in departments | limitTo:SEARCH_RESULTS_LIMIT" type="button">\n\t\t\t\t\t\t<i class="icon-team-alt item-selection-card-icon"></i>\n\t\t\t\t\t\t<p class="item-selection-card-description">{{department.AgencyDepartmentName}}</p>\n\t\t\t\t\t\t<a href="" class="item-selection-card-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Load more -->\n\t\t\t\t<div class="item-selection-cards-load-more" ng-if="vm.searchResultsLimitTeam < teamMembers.length">\n\t\t\t\t\t<a href="" class="button white" ng-click="incrementSearchResultsTeam(vm)"><i class="icon-add m"></i>&nbsp;Show more</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Note: Leavers on NT tax codes -->\n\t<div class="form-content-block fadeIn" ng-if="vm.selectedTeamMembers.length && vm.selectedTeamMembers[0].IsLeaver && vm.taxCode.TaxCode === \'NT\'">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Leavers on NT tax codes">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that {{vm.selectedTeamMembers[0].Forename}} is a leaver on an NT tax code.\n\t\t\t\t\tUnless you\'re adding a payment after leaving for share-based earnings, you need to change their tax code to 0T W1/M1 in their \'Tax status\' area so that their tax is calculated correctly.\n\t\t\t\t\tYou can do this once you\'ve saved {{vm.selectedTeamMembers[0].Forename}}\'s payment.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Type of change -->\n\t<fieldset class="fadeIn" ng-if="vm.selectedTeamMembers.length">\n\n\t\t<div class="form-field" data-cy="add-a-change-form-form-field">\n\t\t\t<div class="pill-input-field primary" data-cy="add-a-change-form-pill-input-field" ng-class="{\n\t\t\t\t\t\'assertive\': vm.selectedAdjustmentType && vm.selectedAdjustmentType.IsDeduction,\n\t\t\t\t\t\'positive\': vm.selectedAdjustmentType && !vm.selectedAdjustmentType.IsDeduction,\n\t\t\t\t\t\'active\': vm.searchTermAdjustmentTypesFocused\n\t\t\t\t}">\n\t\t\t\t<label for="searchTermAdjustmentTypes" class="pill-input-field-label" data-cy="add-a-change-form-pill-input-field-label-{{::searchTermAdjustmentTypes}}"><i class="icon-adjustment"></i> Type of change</label>\n\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" data-cy="add-a-change-form-searchTermAdjustmentTypes" id="searchTermAdjustmentTypes" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-if="!vm.selectedAdjustmentType && !vm.selectedAdjustmentLabel" ng-model="vm.searchTermAdjustmentTypes" placeholder="Search for a change or payslip label" type="text">\n\n\t\t\t\t<!-- Selected Change -->\n\t\t\t\t<div class="pill-input-field-items" data-cy="add-a-change-form-pill-input-field-items">\n\t\t\t\t\t<div class="pill-input-field-item {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn {{isEditAdjustment ? \'not-deleteable\' : \'\'}}" data-cy="add-a-change-form-pill-input-field-item" ng-if="vm.selectedAdjustmentType">\n\t\t\t\t\t\t<span data-cy="add-a-change-form-vm.selectedAdjustmentType">{{vm.selectedAdjustmentType.AgencyAdjustmentLabelText ? vm.selectedAdjustmentType.AgencyAdjustmentLabelText : vm.selectedAdjustmentType.AgencyAdjustmentGroupEntryText}}</span>\n\t\t\t\t\t\t<a href="" ng-click="deselectAdjustmentType(vm)" class="pill-input-field-item-delete" ng-if="!isEditAdjustment" aria-label="Deselect change type"><i class="icon-plus"></i></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Search results -->\n\t\t\t\t<div class="pill-input-search-results dropIn" click-anywhere-but-here="resetAdjustmentTypeSearchTerm()" data-cy="add-a-change-form-pill-input-search-results" is-active="vm.searchTermAdjustmentTypes.length >= SEARCH_TERM_MIN_COUNT" ng-show="vm.searchTermAdjustmentTypes.length >= SEARCH_TERM_MIN_COUNT">\n\n\t\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t\t<div class="pill-input-search-results-group" data-cy="add-a-change-form-payslip-labels-group" ng-if="adjustmentLabels.length">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading" data-cy="add-a-change-form-payslip-labels-subheading">Payslip labels</p>\n\t\t\t\t\t\t<button class="pill-input-search-result is-clear secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" data-cy="add-a-change-form-payslip-label-button-{{$index}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel(vm, adjustmentLabel)" ng-repeat="\n\t\t\t\t\t\t\t\tadjustmentLabel in filteredAdjustmentLabels = (\n\t\t\t\t\t\t\t\t\tadjustmentLabels |\n\t\t\t\t\t\t\t\t\tfilter:  {\'AgencyAdjustmentLabelText\' : vm.searchTermAdjustmentTypes }\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy:[\n\t\t\t\t\t\t\t\t\t\'IsDeduction\',\n\t\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t\t] |\n\t\t\t\t\t\t\t\tlimitTo:SEARCH_RESULTS_LIMIT\n\t\t\t\t\t\t\t" type="button">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-icon" data-cy="add-a-change-form-payslip-label-icon-{{$index}}">\n\t\t\t\t\t\t\t\t<icon-dot icon="icon-label" is-light="true" theme="is-medium {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}"></icon-dot>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description" data-cy="add-a-change-form-payslip-label-description-{{$index}}">{{adjustmentLabel.AgencyAdjustmentLabelText}} <span>{{adjustmentLabel.AdjustmentText}}</span></p>\n\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action" data-cy="add-a-change-form-payslip-label-action-{{$index}}"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p ng-if="!filteredAdjustmentLabels.length" data-cy="add-a-change-form-no-payslip-labels-found"><span class="caption">No payslip labels found</span></p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Changes -->\n\t\t\t\t\t<div class="pill-input-search-results-group" data-cy="add-a-change-form-changes-group">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading" data-cy="add-a-change-form-changes-subheading">Changes</p>\n\t\t\t\t\t\t<button class="pill-input-search-result is-clear fadeIn {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" data-cy="add-a-change-form-change-button-{{$index}}" ng-click="selectAdjustmentType(vm, adjustmentType)" ng-repeat="\n\t\t\t\t\t\t\t\tadjustmentType in filteredAdjustmentTypes = (\n\t\t\t\t\t\t\t\t\tadjustmentTypes |\n\t\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypeSearchFilter |\n\t\t\t\t\t\t\t\t\tfilter: {\'AgencyAdjustmentGroupEntryText\' : vm.searchTermAdjustmentTypes }\n\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\' |\n\t\t\t\t\t\t\t\tlimitTo:SEARCH_RESULTS_LIMIT\n\t\t\t\t\t\t\t" type="button">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-icon" data-cy="add-a-change-form-change-icon-{{::AgencyAdjustmentGroupEntryText | slugify}}">\n\t\t\t\t\t\t\t\t<icon-dot icon="icon-{{adjustmentType.IsDeduction ? \'minus\' : \'add\'}}" is-light="true" theme="is-medium {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}"></icon-dot>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description" data-cy="add-a-change-form-change-description-{{::AgencyAdjustmentGroupEntryText | slugify}}">{{adjustmentType.AgencyAdjustmentGroupEntryText}}</p>\n\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action" data-cy="add-a-change-form-change-action-{{::AgencyAdjustmentGroupEntryText | slugify}}"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p ng-if="!filteredAdjustmentTypes.length" data-cy="add-a-change-form-no-changes-found"><span class="caption">No changes found</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Change type details -->\n\t\t\t\t<div ng-if="vm.selectedAdjustmentType" ng-switch="vm.selectedAdjustmentType.AgencyAdjustmentValueType">\n\n\t\t\t\t\t<div class="pill-input-details" ng-class="{ \'has-currency-action\' : vm.currencies && vm.currencies.length > 0 }">\n\n\t\t\t\t\t\t<!-- Absolute -->\n\t\t\t\t\t\t<div class="pill-input-detail-items" pc-switch-when="ADJUSTMENT_VALUE_TYPES.absolute" ng-switch="vm.selectedAdjustmentType.AgencyAdjustmentSpecialType">\n\n\t\t\t\t\t\t\t<!-- Accrued Holiday -->\n\t\t\t\t\t\t\t<div pc-switch-when="ADJUSTMENT_SPECIAL_TYPES.accruedHoliday" ng-switch="holidayAccrualState">\n\n\t\t\t\t\t\t\t\t<div ng-switch-when="loading">\n\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div ng-switch-when="ready">\n\n\t\t\t\t\t\t\t\t\t<!-- Has holiday accrued -->\n\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-items fadeIn">\n\n\t\t\t\t\t\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-field is-inline">\n\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentTotalValue" class="pill-input-detail-item_label required">Amount:</label>\n\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input monetise {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentTotalValue" maxlength="10" name="adjustmentTotalValue" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="resetNetToGrossEnabled(vm)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model="vm.newAdjustment.Value" ng-pattern="$root.REGEX.decimal" placeholder="Enter amount..." required type="number">\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentTotalValue.$dirty && addAChangeForm.adjustmentTotalValue.$invalid" ng-messages="addAChangeForm.adjustmentTotalValue.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">{{vm.selectedTeamMembers[0].HolidayAccrual | monetise}} is the maximum payable</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Accrual -->\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-field is-inline pill-input-detail-field-copy">\n\t\t\t\t\t\t\t\t\t\t\t<p class="is-small">of <a href ng-click="setAdjustmentValueToAccruedHolidayTotal(vm)" class="positive underline" tooltip tooltip-text="{{vm.selectedTeamMembers[0].Forename}} has accrued {{vm.selectedTeamMembers[0].HolidayAccrual | monetise}} in holiday pay" tooltip-position="top-left" tooltip-size="m">{{vm.selectedTeamMembers[0].HolidayAccrual | monetise}}</a> accrued</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- General fixed adjustment -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-items" ng-switch-default data-cy="add-a-change-form-pill-input-detail-items">\n\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-inline" data-cy="add-a-change-form-pill-input-detail-item">\n\t\t\t\t\t\t\t\t\t<label for="adjustmentTotalValue" class="pill-input-detail-item_label required" data-cy="add-a-change-form-adjustment-total-value-label">Amount<span ng-if="vm.newAdjustment.IsPeriodOverride">&nbsp;for {{::vm.currentPayPeriod.PayPeriodDisplay}}</span>:</label>\n\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input is-inline {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" data-cy="add-a-change-form-adjustment-total-value-input" id="adjustmentTotalValue" name="adjustmentTotalValue" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="reviewNetToGross(vm, vm.newAdjustment.NetToGross, true)" ng-class="{ \'monetise\' : !vm.newAdjustment.isPaymentInCurrency }" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="vm.newAdjustment.Value" ng-pattern="$root.REGEX.decimal" placeholder="Enter amount..." required type="number">\n\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" data-cy="add-a-change-form-pill-input-field-errors" ng-if="addAChangeForm.adjustmentTotalValue.$touched && !addAChangeForm.adjustmentTotalValue.$valid" ng-messages="addAChangeForm.adjustmentTotalValue.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max" data-cy="add-a-change-form-error-max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min" data-cy="add-a-change-form-error-min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number" data-cy="add-a-change-form-error-number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern" data-cy="add-a-change-form-error-pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required" data-cy="add-a-change-form-error-required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Units -->\n\t\t\t\t\t\t<div class="pill-input-detail-items is-inline" pc-switch-when="ADJUSTMENT_VALUE_TYPES.unit">\n\n\t\t\t\t\t\t\t<!-- Units -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-item">\n\t\t\t\t\t\t\t\t<label for="adjustmentUnits" class="pill-input-detail-item_label required">{{vm.selectedAdjustmentType.AgencyAdjustmentUnitLabel}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnits" maxlength="10" name="adjustmentUnits" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="calculateAdjustmentValue(vm.newAdjustment)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="vm.newAdjustment.Units" ng-pattern="$root.REGEX.decimalFourPlaces" placeholder="Enter {{vm.selectedAdjustmentType.AgencyAdjustmentUnitLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentUnits.$touched && !addAChangeForm.adjustmentUnits.$valid" ng-messages="addAChangeForm.adjustmentUnits.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-item">\n\t\t\t\t\t\t\t\t<label for="adjustmentUnitValue" class="pill-input-detail-item_label required">{{vm.selectedAdjustmentType.AgencyAdjustmentValueLabel}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="calculateAdjustmentValue(vm.newAdjustment)" ng-class="{ \'monetise\' : !vm.newAdjustment.isPaymentInCurrency }" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="vm.newAdjustment.UnitValue" ng-pattern="::regexService.salaryRatesRegEx" placeholder="Enter {{vm.selectedAdjustmentType.AgencyAdjustmentValueLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentUnitValue.$touched && !addAChangeForm.adjustmentUnitValue.$valid" ng-messages="addAChangeForm.adjustmentUnitValue.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Percentage (only available when 1 team member is selected) -->\n\t\t\t\t\t\t<div class="pill-input-detail-items" pc-switch-when="ADJUSTMENT_VALUE_TYPES.percentage">\n\n\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input percentage {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnits" maxlength="10" name="adjustmentUnits" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="calculatePercentageValue(vm)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="vm.newAdjustment.Units" ng-pattern="vm.selectedAdjustmentType.IsEmployeePension || vm.selectedAdjustmentType.IsEmployerPension ? $root.REGEX.decimalFourPlaces : $root.REGEX.decimal" required type="number">\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentUnits.$touched && !addAChangeForm.adjustmentUnits.$valid" ng-messages="addAChangeForm.adjustmentUnits.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a percentage</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{vm.selectedAdjustmentType.IsEmployeePension || vm.selectedAdjustmentType.IsEmployerPension ? \'4\' : \'2\'}} decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<span class="pill-input-detail-field-divider">of</span>\n\n\t\t\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t\t\t<div class="pill-input-detail-field">\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="pill-input-detail-item_input {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="calculatePercentageValue(vm)" ng-class="{ \'monetise\' : !vm.newAdjustment.isPaymentInCurrency }" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="vm.newAdjustment.UnitValue" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<a class="pill-input-detail-field-action {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" href="" ng-click="setPercentageCalculationToSalary(vm)" ng-if="vm.selectedTeamMembers[0].SalaryType === PAYMENT_TYPES.salary">Set to salary</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentUnitValue.$touched && !addAChangeForm.adjustmentUnitValue.$valid" ng-messages="addAChangeForm.adjustmentUnitValue.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Linked -->\n\t\t\t\t\t\t<div ng-switch="vm.selectedTeamMembers[0].Salary.PaymentType" pc-switch-when="ADJUSTMENT_VALUE_TYPES.linked">\n\n\t\t\t\t\t\t\t<circle-loader class="s" ng-if="vm.selectedTeamMembers[0].salaryState === \'loading\'"></circle-loader>\n\n\t\t\t\t\t\t\t<div ng-if="vm.selectedTeamMembers[0].salaryState === \'ready\'">\n\n\t\t\t\t\t\t\t\t<!-- Has rates defined -->\n\t\t\t\t\t\t\t\t<div ng-if="vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated.length">\n\n\t\t\t\t\t\t\t\t\t<select id="salaryRate" name="salaryRate" ng-change="selectSalaryRate(vm)" ng-model="vm.newAdjustment.selectedRate" ng-options="rate as rate.SalaryRateDisplay for rate in vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated" required>\n\t\t\t\t\t\t\t\t\t\t<option value="">Select a rate...</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.salaryRate.$touched && !addAChangeForm.salaryRate.$valid" ng-messages="addAChangeForm.salaryRate.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a rate</p>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.newAdjustment.selectedRate">\n\n\t\t\t\t\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-items is-inline fadeIn">\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentUnits" class="required pill-input-detail-item_label">Units:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<number-selector-field field-name="adjustmentUnits" ng-model-options="{ debounce:400 }" ng-model="vm.newAdjustment.Units" nsf-on-change="calculateAdjustmentValue(vm.newAdjustment)" size="is-block" theme="{{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked fadeIn" ng-if="vm.newAdjustment.selectedRate.SalaryRateID === \'custom\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentUnitValue" class="required pill-input-detail-item_label">Rate:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise pill-input-detail-item_input {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="adjustmentUnitValue" maxlength="10" name="adjustmentUnitValue" ng-blur="toggleSearchTermTypesFocus(vm, false)" ng-change="calculateAdjustmentValue(vm.newAdjustment)" ng-focus="toggleSearchTermTypesFocus(vm, true)" ng-min="0" ng-model-options="{ debounce:200 }" ng-model="vm.newAdjustment.UnitValue" ng-pattern="::regexService.salaryRatesRegEx" placeholder="Enter {{vm.selectedAdjustmentType.AgencyAdjustmentValueLabel}}..." required type="number">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-if="addAChangeForm.adjustmentUnitValue.$touched && !addAChangeForm.adjustmentUnitValue.$valid" ng-messages="addAChangeForm.adjustmentUnitValue.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.salaryRates}} decimal places</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="pill-input-detail-item is-stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="adjustmentMultiplyRate" class="required pill-input-detail-item_label">Multiply rate by:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<number-selector-field field-name="adjustmentMultiplyRate" ng-model-options="{ debounce:400 }" ng-model="vm.newAdjustment.UnitValueMultiplier" nsf-on-change="calculateAdjustmentValue(vm.newAdjustment)" size="is-block" theme="{{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}"></number-selector-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="spacer xs"></div>\n\n\t\t\t\t\t\t\t\t\t\t<p class="caption">Note: the rates available are based on the pay information in {{vm.selectedTeamMembers[0].Forename}}\'s profile</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- No rates defined -->\n\t\t\t\t\t\t\t\t<div ng-if="!vm.selectedTeamMembers[0].Salary.SalaryRatesWithCalculated.length">\n\t\t\t\t\t\t\t\t\t<p class="caption">There are no rates set up for {{vm.selectedTeamMembers[0].Forename}}</p>\n\t\t\t\t\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowedNoRatesDefined" ng-model="vm.doesNotExist" value="" required>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Net to Gross -->\n\t\t\t\t\t\t<div class="pill-input-detail-toggle fadeIn" ng-if="vm.selectedAdjustmentType.AgencyAdjustmentNetToGross && !vm.newAdjustment.IsPeriodOverride" pc-switch-when="[\n\t\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.absolute,\n\t\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.unit\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t<div class="toggle-tab positive">\n\t\t\t\t\t\t\t\t<a href="" ng-click="reviewNetToGross(vm, false)" class="toggle-tab-option" ng-class="{\'active\' : !vm.newAdjustment.NetToGross}">Gross</a>\n\t\t\t\t\t\t\t\t<a href="" ng-click="reviewNetToGross(vm, true)" class="toggle-tab-option" ng-class="{\'active\' : vm.newAdjustment.NetToGross}">Net</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Use currency -->\n\t\t\t\t\t\t<div class="pill-input-detail-toggle is-checkbox" ng-class="{\n\t\t\t\t\t\t\t\t\'has-less-margin\' : vm.selectedAdjustmentType.AgencyAdjustmentValueType === ADJUSTMENT_VALUE_TYPES.percentage\n\t\t\t\t\t\t\t}" pc-switch-when="[\n\t\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.percentage,\n\t\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.absolute,\n\t\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.unit\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t<input checkbox title="isPaymentInCurrency" id="isPaymentInCurrency" label-text-class="is-small" label-text="\'Use currency\'" name="isPaymentInCurrency" ng-if="vm.currencies && vm.currencies.length > 0" ng-model="vm.newAdjustment.isPaymentInCurrency" ng-change="onIsPaymentInCurrencyChange(vm)" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Period Override -->\n\t\t\t\t\t<div class="fadeIn" pc-switch-when="[\n\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.absolute,\n\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.unit,\n\t\t\t\t\t\t\tADJUSTMENT_VALUE_TYPES.percentage\n\t\t\t\t\t\t]" ng-if="isEditAdjustment && vm.newAdjustment.Recurring">\n\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t<toggle-input field-label="Override amount this period only" field-model="vm.newAdjustment.IsPeriodOverride" field-name="isPeriodOverride" field-on-change="reviewPeriodOverride(vm)"></toggle-input>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Currency -->\n\t\t\t\t\t<div class="pill-input-detail-field has-margin fadeIn" ng-if="vm.newAdjustment.isPaymentInCurrency && vm.currencies.length > 0">\n\t\t\t\t\t\t<label for="adjustmentTotalValue" class="pill-input-detail-item_label required">Currency:</label>\n\t\t\t\t\t\t<select class="pill-input-detail-item_input" id="currencyId" name="currencyId" ng-model="vm.newAdjustment.selectedCurrency" ng-options="currency as currency.CurrencyLabel for currency in vm.currencies" required>\n\t\t\t\t\t\t   \t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<div class="pill-input-field-errors fadeIn" ng-messages="addAChangeForm.currencyId.$error" ng-if="addAChangeForm.currencyId.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an option</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message fadeIn" ng-if="vm.newAdjustment.selectedCurrency">\xA3 to {{vm.newAdjustment.selectedCurrency.CurrencyLabel}} exchange rate: {{vm.newAdjustment.selectedCurrency.CurrencyValue}}</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn" ng-if="!vm.selectedAdjustmentType">\n\t\t\t<div class="form-content-block tight">\n\t\t\t\t<p class="s">Or select from below:</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="adjustmentTypesCount.totalAdditions > 0 && adjustmentTypesCount.totalDeductions > 0">\n\t\t\t\t<nav class="tabs" data-cy="add-a-change-form-tabs">\n\t\t\t\t\t<a data-cy="add-a-change-form-tab-additions" href="" ng-class="{\'active\': vm.adjustmentTypeFilterKey === \'additions\'}" ng-click="changeAdjustmentTypeFilter(\'additions\')" ng-if="::adjustmentTypesCount.totalAdditions > 0">Additions</a>\n\t\t\t\t\t<a data-cy="add-a-change-form-tab-deductions" href="" ng-class="{\'active\': vm.adjustmentTypeFilterKey === \'deductions\'}" ng-click="changeAdjustmentTypeFilter(\'deductions\')" ng-if="::adjustmentTypesCount.totalDeductions > 0">Deductions</a>\n\t\t\t\t</nav>\n\t\t\t</div>\n\n\t\t\t<!-- Adjustment types -->\n\t\t\t<div class="form-section" data-cy="add-a-change-form-form-section" ng-if="adjustmentTypes.length">\n\t\t\t\t<div class="adjustment-type-cards" data-cy="add-a-change-form-adjustment-type-cards">\n\n\t\t\t\t\t<div class="adjustment-type-card is-clear {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} clickable" data-cy="add-a-change-form-adjustment-type-card-{{::adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" id="add-change-type-{{adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" ng-repeat="adjustmentType in filteredAdjustmentTypes = (\n\t\t\t\t\t\t\t\tadjustmentTypes |\n\t\t\t\t\t\t\t\tfilter: vm.adjustmentTypeFilter |\n\t\t\t\t\t\t\t\torderBy: \'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\tlimitTo: vm.searchResultsLimitAdjustmentTypes">\n\t\t\t\t\t\t<a role="button" class="adjustment-type-card_main" data-cy="add-a-change-form-adjustment-type-card-main-{{::adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}" href="" ng-click="selectAdjustmentType(vm, adjustmentType)">\n\t\t\t\t\t\t\t<span class="adjustment-type-card_action" data-cy="add-a-change-form-adjustment-type-card-action-{{::adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}"><i class="icon-chevron-right"></i></span>\n\t\t\t\t\t\t\t<p class="adjustment-type-card_description" data-cy="add-a-change-form-adjustment-type-card-description-{{::adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}">\n\t\t\t\t\t\t\t\t<truncate text="adjustmentType.AgencyAdjustmentGroupEntryText" truncate-amount="20"></truncate>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a aria-label="Show information tooltip" href ng-click="$root.$broadcast(\'toggle-tooltip-card\', adjustmentType.tooltip)" class="adjustment-type-card_info-action" data-cy="add-a-change-form-adjustment-type-card-info-action-{{::adjustmentType.AgencyAdjustmentGroupEntryText | desymbolise | slugify}}">\n\t\t\t\t\t\t\t<i class="icon-information is-medium {{adjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}} adjustment-type-card_info-action-icon"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Load more -->\n\t\t\t\t<div class="adjustment-type-cards-load-more" ng-if="vm.searchResultsLimitAdjustmentTypes < filteredAdjustmentTypes.length" data-cy="add-a-change-form-adjustment-type-cards-load-more">\n\t\t\t\t\t<a href="" class="button white" ng-click="incrementSearchResultsAdjustmentTypes(vm)" data-cy="add-a-change-form-show-more-button"><i class="icon-add m" data-cy="add-a-change-form-show-more-icon"></i>&nbsp;Show more</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="!adjustmentTypes.length">\n\t\t\t\t<div class="info-block primary">\n\t\t\t\t\t<p class="s">There are no pay elements available</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Payslip Label / Recurring / Preview / Tax Treatment -->\n\t<fieldset class="fadeIn" ng-if="vm.selectedAdjustmentType">\n\n\t\t<!-- Apply to additional post (where applicable - when there are additional posts and the\n\t\t\t adjustment isn\'t pension related. Pension selection itself is effectively the additional\n\t\t\t post) -->\n\t\t<div class="form-field" ng-if="\n\t\t\t\tvm.selectedTeamMembers[0].AdditionalPosts.length !== 0 &&\n\t\t\t\t!vm.selectedAdjustmentType.IsEmployeePension &&\n\t\t\t\t!vm.selectedAdjustmentType.IsEmployerPension\n\t\t\t">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<extended-toggle-input field-label="Apply to additional post" field-model="vm.newAdjustment.applyToAdditionalPost" field-name="applyToAdditionalPost" field-on-change="onApplyToAdditionalPostChange(vm, vm.newAdjustment)">\n\t\t\t\t\t<field-content>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<select id="additionalPost" name="additionalPost" ng-change="onAdditionalPostChange(vm, vm.newAdjustment)" ng-model="vm.newAdjustment.additionalPost" ng-options="additionalPost as additionalPost.JobTitle for additionalPost in vm.selectedTeamMembers[0].AdditionalPosts | orderBy: \'JobTitle\'" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addAChangeForm.additionalPost.$invalid" role="alert" ng-messages="addAChangeForm.additionalPost.$error">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select an additional post</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Stat payments - Gross Pay -->\n\t\t<div class="form-field" ng-if="vm.selectedAdjustmentType.AgencyAdjustmentCategory === ADJUSTMENT_CATEGORY_TYPES.statutoryPayment">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Original gross pay will be overridden">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tPlease note when applying a statutory pay element to an employee, the original gross pay will be overridden. If you would like to update the gross pay, you will need to\n\t\t\t\t\t\tadd further pay elements.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Stat payments - EPS and P32 -->\n\t\t<div class="form-field" ng-if="vm.selectedAdjustmentType.IsStatutoryParentalPay  && vm.selectedAdjustmentType.AgencyAdjustmentCategory !== ADJUSTMENT_CATEGORY_TYPES.occupational">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Statutory elements linked to EPS and P32">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tStatutory pay elements will be reported on the EPS and will also be displayed on the P32 report.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Tax treatment: Redundancy payments -->\n\t\t<div class="form-field" ng-if="vm.selectedAdjustmentType.IsRedundancyPay">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Tax treatment on redundancy payments">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tOnly amounts over \xA330,000.00 will be subject to tax and Employer\'s Class 1A NICs.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Tax treatment: Testimonial payments -->\n\t\t<div class="form-field" ng-if="vm.selectedAdjustmentType.IsTestimonialPay">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Tax treatment on testimonial payments">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tOnly amounts over \xA3100,000.00 will be subject to tax and Employer\'s Class 1A NICs.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Payslip Label -->\n\t\t<div class="form-field" data-cy="add-a-change-form-form-field">\n\t\t\t<div class="pill-input-field {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" ng-class="{\'active\': vm.searchTermAdjustmentLabelsFocused}" data-cy="add-a-change-form-pill-input-field">\n\t\t\t\t<label for="newAdjustmentLabel" class="pill-input-field-label"><i class="icon-label"></i> Label for payslip <span>optional</span></label>\n\t\t\t\t<input autocomplete="off" class="pill-input-field-input fadeIn" data-cy="add-a-change-form-new-adjustment-label-input" id="newAdjustmentLabel" maxlength="40" minlength="3" name="newAdjustmentLabel" ng-blur="toggleSearchTermLabelsFocus(vm, false)" ng-focus="toggleSearchTermLabelsFocus(vm, true); toggleShowPayslipLabelResults(vm, true);" ng-if="!vm.selectedAdjustmentLabel" ng-model="vm.newAdjustment.Label" ng-pattern="$root.REGEX.description" ng-required="vm.saveLabel" placeholder="Add a custom label for this change" type="text">\n\t\t\t\t<div class="pill-input-field-errors" data-cy="add-a-change-form-pill-input-field-errors" ng-if="!addAChangeForm.newAdjustmentLabel.$valid && addAChangeForm.newAdjustmentLabel.$touched" ng-messages="addAChangeForm.newAdjustmentLabel.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern" data-cy="add-a-change-form-error-pattern">Only basic characters are allowed</p>\n\t\t\t\t\t<p ng-message="required" data-cy="add-a-change-form-error-required">Please enter a label</p>\n\t\t\t\t\t<p ng-message="minlength" data-cy="add-a-change-form-error-minlength">Please enter a label with at least 3 characters</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Selected Label -->\n\t\t\t\t<div class="pill-input-field-items" ng-if="vm.selectedAdjustmentLabel" data-cy="add-a-change-form-pill-input-field-items">\n\t\t\t\t\t<div class="pill-input-field-item {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} fadeIn" data-cy="add-a-change-form-pill-input-field-item">\n\t\t\t\t\t\t<span data-cy="add-a-change-form-selected-adjustment-label">{{vm.selectedAdjustmentLabel}}</span>\n\t\t\t\t\t\t<a href="" ng-click="resetPayslipLabel(vm)" class="pill-input-field-item-delete" aria-label="Reset payslip label" data-cy="add-a-change-form-reset-payslip-label"><i class="icon-plus"></i></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Save for future use -->\n\t\t\t\t<div class="pill-input-details fadeIn" ng-show="addAChangeForm.newAdjustmentLabel.$valid && vm.newAdjustment.Label.length > SEARCH_TERM_MIN_COUNT && !vm.selectedAdjustmentLabel">\n\t\t\t\t\t<input checkbox class="{{!vm.selectedAdjustmentType ? \'secondary\' : vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}" id="saveLabel" label-text="\'Save for future use\'" name="saveLabel" ng-model="vm.saveLabel" type="checkbox">\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Search results -->\n\t\t\t\t<div class="pill-input-search-results has-action dropIn" click-anywhere-but-here="toggleShowPayslipLabelResults(vm, false)" is-active="vm.newAdjustment.Label.length >= SEARCH_TERM_MIN_COUNT && !vm.selectedAdjustmentLabel" ng-if="adjustmentLabels.length" ng-show="vm.newAdjustment.Label.length >= SEARCH_TERM_MIN_COUNT && !vm.selectedAdjustmentLabel && vm.showPayslipLabelResults">\n\n\t\t\t\t\t<!-- Payslip labels -->\n\t\t\t\t\t<div class="pill-input-search-results-group">\n\t\t\t\t\t\t<p class="pill-input-search-results-subheading">Payslip labels</p>\n\t\t\t\t\t\t<button class="pill-input-search-result is-clear secondary fadeIn {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}" ng-click="selectAdjustmentTypeFromAdjustmentLabel(vm, adjustmentLabel, false)" ng-repeat="\n\t\t\t\t\t\t\t\tadjustmentLabel in filteredAdjustmentLabels = (\n\t\t\t\t\t\t\t\t\tadjustmentLabels |\n\t\t\t\t\t\t\t\t\tfilter: vm.labelFilter |\n\t\t\t\t\t\t\t\t\tfilter: vm.newAdjustment.Label\n\t\t\t\t\t\t\t\t) | orderBy:[\n\t\t\t\t\t\t\t\t\t\'IsDeduction\',\n\t\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t\t]\n\t\t\t\t\t\t\t" type="button">\n\t\t\t\t\t\t\t<span class="pill-input-search-result-icon">\n\t\t\t\t\t\t\t\t<icon-dot icon="icon-label" is-light="true" theme="is-medium {{adjustmentLabel.Addition ? \'positive\' : \'assertive\'}}"></icon-dot>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p class="pill-input-search-result-description">{{adjustmentLabel.AgencyAdjustmentLabelText}} <span>{{adjustmentLabel.AdjustmentText}}</span></p>\n\t\t\t\t\t\t\t<a href="" class="pill-input-search-result-action"><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p ng-if="!filteredAdjustmentLabels.length">\n\t\t\t\t\t\t\t<span class="caption">No &lsquo;{{vm.selectedAdjustmentType.AgencyAdjustmentGroupEntryText}}&rsquo; payslip labels found</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pension -->\n\t\t<fieldset class="fadeIn" ng-if="vm.selectedAdjustmentType.IsEmployeePension || vm.selectedAdjustmentType.IsEmployerPension">\n\n\t\t\t<!-- Select pension for adjustment -->\n\t\t\t<div class="form-field fadeIn" ng-if="!pensionState || (pensionState && vm.selectedTeamMembers[0].pensions.length > 0)">\n\t\t\t\t<div class="pill-input-field {{vm.selectedAdjustmentType.IsDeduction ? \'assertive\' : \'positive\'}}">\n\t\t\t\t\t<label for="agencyEmployerPensionId" class="pill-input-field-label"><i class="icon-money"></i> Pension scheme</label>\n\n\t\t\t\t\t<div ng-switch="pensionState">\n\n\t\t\t\t\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="fadeIn" ng-switch-when="ready">\n\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<select id="agencyEmployerPensionId" name="agencyEmployerPensionId" ng-change="onPensionChange(vm, vm.selectedTeamMembers[0].pensions)" ng-model="vm.newAdjustment.WorkplacePensionID" ng-disabled="vm.selectedTeamMembers[0].pensions.length === 1" ng-options="pension.WorkplacePensionID as pension.pensionLabel for pension in vm.selectedTeamMembers[0].pensions" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Select a pension scheme</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addAChangeForm.agencyEmployerPensionId.$error" ng-if="addAChangeForm.agencyEmployerPensionId.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select a pension</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Team member isn\'t in a pension -->\n\t\t\t<div class="form-field fadeIn" ng-if="pensionState && vm.selectedTeamMembers[0].pensions.length === 0">\n\t\t\t\t<note note-title="Pension scheme" note-icon="icon-warning" note-theme="tertiary is-form-field">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Please note that {{vm.selectedTeamMembers[0].Forename}} isn\u2019t a member of a pension scheme so the selected type of change can\u2019t be used.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Recurring -->\n\t\t<div class="form-field" data-cy="add-a-change-form-form-field-recurring">\n\t\t\t<div class="form-field-main" data-cy="add-a-change-form-form-field-main-recurring">\n\t\t\t\t<extended-toggle-input data-cy="add-a-change-form-extended-toggle-input-recurring" field-disabled="vm.newAdjustment.IsPeriodOverride" field-label="Make this change recurring" field-model="vm.newAdjustment.Recurring" field-name="isRecurring" field-on-change="vm.onRecurringChange(vm)">\n\t\t\t\t\t<field-content data-cy="add-a-change-form-field-content-recurring">\n\n\t\t\t\t\t\t<input class="b" data-cy="add-a-change-form-recur-for-x-pay-periods-false" id="recurForXPayPeriodsFalse" name="recurForXPayPeriods" ng-click="setRecurringPeriodCount(vm)" ng-disabled="vm.newAdjustment.IsPeriodOverride" ng-model="vm.recurForXPayPeriods" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="recurForXPayPeriodsFalse" data-cy="add-a-change-form-label-recur-for-x-pay-periods-false">Every pay period</label>\n\n\t\t\t\t\t\t<input class="b" data-cy="add-a-change-form-recur-for-x-pay-periods-true" id="recurForXPayPeriodsTrue" name="recurForXPayPeriods" ng-disabled="vm.newAdjustment.IsPeriodOverride" ng-model="vm.recurForXPayPeriods" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="recurForXPayPeriodsTrue" data-cy="add-a-change-form-label-recur-for-x-pay-periods-true">For</label>\n\n\t\t\t\t\t\t<input class="s-alt" type="number" name="recurringPeriodCount" id="recurringPeriodCount" required min="1" ng-model="vm.newAdjustment.RecurringPeriodCount" ng-disabled="!vm.recurForXPayPeriods || vm.newAdjustment.IsPeriodOverride" ng-blur="getPayPeriodForPeriodCount(vm)" ng-max="vm.newAdjustment.RecurringPeriodCountMax" data-cy="add-a-change-form-recurring-period-count">\n\n\t\t\t\t\t\t<label class="is-inline is-medium" ng-class="{\'is-disabled\': vm.newAdjustment.IsPeriodOverride}" for="recurForXPayPeriodsTrue" data-cy="add-a-change-form-label-recurring-period-count">\n\t\t\t\t\t\t\t&nbsp;&nbsp;&nbsp;<ng-pluralize count="vm.newAdjustment.RecurringPeriodCount" when="{\'1\': \'pay period\', \'other\': \'pay periods\'}" data-cy="add-a-change-form-ng-pluralize-recurring-period-count"></ng-pluralize>\n\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t<div class="form-field-footer fadeIn" ng-if="vm.recurForXPayPeriods" data-cy="add-a-change-form-form-field-footer-recurring">\n\t\t\t\t\t\t\t<div class="spacer xs" data-cy="add-a-change-form-spacer-recurring"></div>\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.recurringPayPeriodDisplay" data-cy="add-a-change-form-recurring-pay-period-display">\n\t\t\t\t\t\t\t\t<p class="is-small" data-cy="add-a-change-form-final-change-message">The final change will be added to payroll in the {{vm.recurringPayPeriodDisplay}} period</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!vm.recurringPayPeriodDisplay" data-cy="add-a-change-form-no-recurring-pay-period-display">\n\t\t\t\t\t\t\t\t<p class="form-message fadeIn" ng-if="addAChangeForm.recurringPeriodCount.$valid" data-cy="add-a-change-form-valid-recurring-period-count-message">\n\t\t\t\t\t\t\t\t\tYour change can recur for a maximum of {{vm.newAdjustment.RecurringPeriodCountMax}} pay periods\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addAChangeForm.recurringPeriodCount.$error" ng-if="addAChangeForm.recurringPeriodCount.$invalid" role="alert" data-cy="add-a-change-form-form-errors-recurring-period-count">\n\t\t\t\t\t\t\t\t\t<p ng-message="required" data-cy="add-a-change-form-error-required-recurring-period-count">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min" data-cy="add-a-change-form-error-min-recurring-period-count">Amount should be no less than 1</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="max" data-cy="add-a-change-form-error-max-recurring-period-count">This change can recur for a maximum of {{vm.newAdjustment.RecurringPeriodCountMax}} pay periods</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number" data-cy="add-a-change-form-error-number-recurring-period-count">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\n\t\t\t\t<!-- Recurring end date (imported) -->\n\t\t\t\t<div class="fadeIn" data-cy="add-a-change-form-recurring-end-date" ng-if="vm.newAdjustment.Recurring && vm.newAdjustment.RecurringEndDateISO && vm.newAdjustment.Prorate">\n\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t<note data-cy="add-a-change-form-recurring-end-date-note" note-icon="icon-calendar" note-theme="indifferent is-form-field">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small" data-cy="add-a-change-form-recurring-end-date-value">Recurring end date: <strong>{{vm.newAdjustment.RecurringEndDateISO | dateformat}}</strong></p>\n\t\t\t\t\t\t\t<p class="is-small" data-cy="add-a-change-form-recurring-end-date-prorate-note" ng-if="vm.newAdjustment.Prorate">This date is used for proration calculations when the recurring element ends in the current period.</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Override business categories -->\n\t\t<div class="form-field" data-cy="add-a-change-form-form-field-override-business-categories">\n\t\t\t<div class="form-field-main" data-cy="add-a-change-form-form-field-main-override-business-categories">\n\t\t\t\t<extended-toggle-input data-cy="add-a-change-form-extended-toggle-input-override-business-categories" field-label="Override business categories" field-model="vm.newAdjustment.overrideBusinessCategories" field-on-change="onBusinessCategoriesOverrideChange(vm)" field-name="overrideBusinessCategories">\n\t\t\t\t\t<field-content>\n\t\t\t\t\t\t<business-categories-override business-categories="vm.newAdjustment.businessCategories" data-cy="add-a-change-form-business-categories-override" user-forename="vm.selectedTeamMembers[0].Forename">\n\t\t\t\t\t\t</business-categories-override>\n\t\t\t\t\t</field-content>\n\t\t\t\t</extended-toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Payment type -->\n\t\t<fieldset ng-if="vm.selectedTeamMembers[0].IsLeaver">\n\t\t\t<div class="form-field-highlight is-compact is-clear">\n\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\t\tAs {{:: vm.selectedTeamMembers[0].Forename}} is a submitted leaver this will be added as a regular payment after leaving by default.\n\t\t\t\t\t\tRead more below if you\'re unsure what type of payment this is.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="newAdjustmentPaymentTypeOptionRegular">Type of payment:</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="newAdjustmentPaymentTypeOptionRegular" name="newAdjustmentPaymentType" ng-model="vm.newAdjustment.PaymentType" ng-value="ADJUSTMENT_PAYMENT_TYPES.regular" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="newAdjustmentPaymentTypeOptionRegular">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Regular</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="newAdjustmentPaymentTypeOptionIrregular" name="newAdjustmentPaymentType" ng-model="vm.newAdjustment.PaymentType" ng-value="ADJUSTMENT_PAYMENT_TYPES.irregular" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="newAdjustmentPaymentTypeOptionIrregular">\n\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Irregular</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<button class="is-clear no-margin remove-space" ng-click="togglePaymentTypeInformation()" type="button">\n\t\t\t\t\t\t<i class="icon-up button-icon_pre n" ng-class="{\n\t\t\t\t\t\t\t\t\'flip\': !vm.showPaymentTypeInformation\n\t\t\t\t\t\t\t}"></i>&nbsp;\n\t\t\t\t\t\t{{ vm.showPaymentTypeInformation ? \'Less\' : \'More\'}}&nbsp;info on payment type\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-section form-summary no-margin fadeIn" ng-if="vm.showPaymentTypeInformation">\n\t\t\t\t\t<h6>Regular payments</h6>\n\t\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\t\tExamples include salary or wages, a regular bonus, holiday pay, overtime paid in arrears, or a redundancy payment.\n\t\t\t\t\t\tNational Insurance contributions and student and postgraduate loan deductions will be calculated on each payment separately using the usual earnings period.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h6>Irregular payments</h6>\n\t\t\t\t\t<p class="is-small is-font-greyscale-300">\n\t\t\t\t\t\tExamples include arrears of pay following a pay award, accrued holiday pay, shares or other securities, or some other form of one-off payment.\n\t\t\t\t\t\tNational Insurance contributions and student and postgraduate loan deductions will be calculated on the total payment using a weekly earnings period.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small is-font-greyscale-300 no-margin bottom">\n\t\t\t\t\t\tWhere there\'s a mix of payment types, National Insurance contributions and student and postgraduate loan deductions will be calculated on the total payment using the usual earnings period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Preview -->\n\t\t<div class="form-field fadeIn" ng-if="vm.newAdjustment.Value" data-cy="add-a-change-form-form-field-preview">\n\t\t\t<div class="adjustment-card {{vm.selectedAdjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}}" data-cy="add-a-change-form-adjustment-card">\n\n\t\t\t\t<!-- Adjustment Summary -->\n\t\t\t\t<div class="adjustment-card_section is-flex" data-cy="add-a-change-form-adjustment-summary">\n\n\t\t\t\t\t<!-- Description / Label -->\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<h6 class="adjustment-card_description" data-cy="add-a-change-form-adjustment-description-{{::AgencyAdjustmentGroupEntryText | slugify}}">{{vm.selectedAdjustmentType.AgencyAdjustmentGroupEntryText}}<span ng-if="vm.newAdjustment.NetToGross || vm.selectedAdjustmentType.AgencyAdjustmentNetToGrossOnly">&nbsp;(Net)</span><span class="adjustment-card_description-meta" ng-if="vm.newAdjustment.Recurring"><i class="icon-loading adjustment-card_recurring fadeIn"></i><span ng-if="vm.recurForXPayPeriods"><ng-pluralize count="vm.newAdjustment.RecurringPeriodCount" when="{\'1\': \'1 period\', \'other\': \'{} periods\'}"></ng-pluralize></span><span ng-if="!vm.recurForXPayPeriods">Every period</span></span></h6>\n\t\t\t\t\t\t<p class="adjustment-card_label" data-cy="add-a-change-form-adjustment-label-{{::vm.newAdjustment.Label === \'\' ? \'No payslip label\' : vm.newAdjustment.Label  | slugify}}">{{vm.newAdjustment.Label === \'\' ? \'No payslip label\' : vm.newAdjustment.Label}}</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Value / Calculation -->\n\t\t\t\t\t<div class="adjustment-card_values" ng-switch="vm.selectedAdjustmentType.AgencyAdjustmentValueType" data-cy="add-a-change-form-adjustment-values">\n\n\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t<h6 class="adjustment-card_value" data-cy="add-a-change-form-adjustment-card-value" ng-class="{\n\t\t\t\t\t\t\t\t\'has-line-through\': vm.newAdjustment.IsPeriodOverride\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t{{\n\t\t\t\t\t\t\t\tvm.newAdjustment |\n\t\t\t\t\t\t\t\tadjustmentValue :\n\t\t\t\t\t\t\t\tnull : {\n\t\t\t\t\t\t\t\t\tCURRENCY_VALUE: vm.newAdjustment.selectedCurrency.CurrencyValue,\n\t\t\t\t\t\t\t\t\tHIDE_CURRENCY_LABEL: true\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t</h6>\n\n\t\t\t\t\t\t<!-- Absolute (net to gross) -->\n\t\t\t\t\t\t<p class="adjustment-card_meta fadeIn" pc-switch-when="ADJUSTMENT_VALUE_TYPES.absolute" ng-switch="netToGrossLoadingState" ng-if="vm.newAdjustment.NetToGross || vm.selectedAdjustmentType.AgencyAdjustmentNetToGrossOnly" data-cy="add-a-change-form-net-to-gross">\n\t\t\t\t\t\t\t<span class="fadeIn" ng-switch-when="loading"><circle-loader class="m"></circle-loader></span>\n\t\t\t\t\t\t\t<span class="fadeIn" ng-switch-default>({{vm.newAdjustment.grossAmount | monetise : null : null : { CURRENCY_VALUE: vm.newAdjustment.selectedCurrency.CurrencyValue, HIDE_CURRENCY_LABEL: true } }} Gross)</span>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Absolute (accrued holiday) -->\n\t\t\t\t\t\t<p class="adjustment-card_meta fadeIn" pc-switch-when="ADJUSTMENT_VALUE_TYPES.absolute" ng-if="vm.selectedTeamMembers[0].HolidayAccrual > 0" data-cy="add-a-change-form-accrued-holiday">(of <span class="underline" tooltip tooltip-text="{{vm.selectedTeamMembers[0].Forename}} has accrued {{vm.selectedTeamMembers[0].HolidayAccrual | monetise  : null : null : { CURRENCY_VALUE: vm.newAdjustment.selectedCurrency.CurrencyValue, HIDE_CURRENCY_LABEL: true } }} in holiday pay" tooltip-position="top-left" tooltip-size="m">{{vm.selectedTeamMembers[0].HolidayAccrual | monetise : null : null : { CURRENCY_VALUE: vm.newAdjustment.selectedCurrency.CurrencyValue, HIDE_CURRENCY_LABEL: true } }}</span> accrued)</p>\n\n\t\t\t\t\t\t<!-- Linked | Percentage | Units -->\n\t\t\t\t\t\t<p class="adjustment-card_meta fadeIn" pc-switch-when="[ADJUSTMENT_VALUE_TYPES.linked, ADJUSTMENT_VALUE_TYPES.percentage, ADJUSTMENT_VALUE_TYPES.unit]" data-cy="add-a-change-form-linked-percentage-units">{{vm.newAdjustment | adjustmentValueTypeCalculation : null : { CURRENCY_VALUE: vm.newAdjustment.selectedCurrency.CurrencyValue, HIDE_CURRENCY_LABEL: true } }}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Period Override -->\n\t\t\t\t<div class="adjustment-card_section is-flex fadeIn" ng-if="vm.newAdjustment.IsPeriodOverride" data-cy="add-a-change-form-period-override">\n\n\t\t\t\t\t<!-- Pay period -->\n\t\t\t\t\t<div class="adjustment-card_section is-flex">\n\t\t\t\t\t\t<icon-dot class="adjustment-card_section-icon" icon="icon-clock" theme="is-large {{vm.selectedAdjustmentType.IsDeduction ? \'is-assertive\' : \'is-positive\'}}"></icon-dot>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<h6 data-cy="add-a-change-form-current-pay-period">{{vm.currentPayPeriod.PayPeriodDisplay}}</h6>\n\t\t\t\t\t\t\t<p class="adjustment-card_label">This will revert to the original value once payroll has been run</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="adjustment-card_values">\n\t\t\t\t\t\t<h6 class="adjustment-card_value" data-cy="add-a-change-form-override-value">{{vm.newAdjustment | adjustmentValue: { IS_OVERRIDE_APPLICABLE: false } }}</h6>\n\t\t\t\t\t\t<p class="adjustment-card_meta" data-cy="add-a-change-form-override-meta">{{vm.newAdjustment | adjustmentValueTypeCalculation: { IS_OVERRIDE_APPLICABLE: false } }}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Future Adjustments -->\n\t\t\t\t<div class="adjustment-card_section" ng-if="formOptions.isFutureAdjustment" data-cy="add-a-change-form-future-adjustments">\n\t\t\t\t\t<label for="selectedPayPeriod" class="required adjustment-card_select-label">Add to future pay period:</label>\n\t\t\t\t\t<select class="is-small inline adjustment-card_select" data-cy="add-a-change-form-future-pay-period-select" id="selectedPayPeriod" name="selectedPayPeriod" ng-model="vm.selectedPayPeriodId" ng-options="payPeriod.PayPeriodID as payPeriod.PayPeriodDisplay for payPeriod in payPeriods" required></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<hr class="xl">\n\n\t\t<div class="form-field">\n\n\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t<button class="detail-blocks-toggle is-clear clickable" type="button" ng-class="{\'active\' : vm.showTaxTreatment}" ng-click="vm.showTaxTreatment = !vm.showTaxTreatment">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-chevron-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t{{vm.showTaxTreatment ? \'Hide\' : \'Show\'}} tax treatment\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : vm.showTaxTreatment}" data-cy="add-a-change-form-detail-blocks-hidden">\n\n\t\t\t\t\t<adjustment-type-tax-treatment adjustment-type="vm.selectedAdjustmentType" data-cy="add-a-change-form-adjustment-type-tax-treatment"></adjustment-type-tax-treatment>\n\n\t\t\t\t\t<div class="detail-blocks-hidden_footer" data-cy="add-a-change-form-detail-blocks-hidden-footer">\n\t\t\t\t\t\t<em class="is-small" data-cy="add-a-change-form-pension-treatment-info">You can review pension treatment for pay elements by clicking the &lsquo;Manage pay elements&rsquo; action in your pension schemes.</em>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions fadeIn">\n\t\t<a href="" ng-if="!formOptions.totalSteps" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addAChangeForm.state" disable-button="addAChangeForm.$invalid || !vm.selectedAdjustmentType || calculationState === \'not-allowed\' || isBusinessCategoriesInvalid(vm)"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No team members -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You have no team members available to add changes to" ng-if="pageState === \'no-team-members\'">\n\t<fs-main>\n\t\t<p class="s">This may be because their profile is incomplete, they\'re excluded from payroll, or they\'re marked as \'On hold\', \'Off payroll\', or \'Advancing\'.</p>\n\t</fs-main>\n</form-state>\n\n<!-- No pay element packs -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You don\'t have any pay element packs" ng-if="pageState === \'no-adjustment-types\'">\n\t<fs-main>\n\t\t<p class="s">There are no pay element packs assigned to {{formOptions.company.Name}}. If you need help setting up your pay element packs, please contact support.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Period Not Unsubmitted -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You\'re unable to make changes at this time" ng-if="pageState === \'not-submitted\'">\n\t<fs-main>\n\t\t<p class="s">The {{vm.currentPayPeriod.PayPeriodDisplay}} period may still be processing. This can take a few minutes to complete so try again shortly.</p>\n\t</fs-main>\n</form-state>\n\n<!-- No access to pay element -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You don\'t have permission" ng-if="pageState === \'no-access-to-adjustment-type\'">\n\t<fs-main>\n\t\t<p class="s">You don\'t have permission to update this Pay Element. If you need any help, please contact support.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/addLeave/addLeaveForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addLeaveForm" ng-submit="addNewLeave(newLeave, addLeaveForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tLeave days are counted and stored for each team member, for tracking purposes only. Don\u2019t forget to add leave related adjustments to payroll, where appropriate.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">Read more about tracking holidays and sick days.</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Type of leave -->\n\t\t<div class="form-field" ng-if="newLeave.selectedLeaveType.id !== LEAVE_TYPE_DESCRIPTIONS.sickLeave">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="leaveType" class="required">Choose a type of leave:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<select class="l-alt" name="leaveType" id="leaveType" ng-model="newLeave.selectedLeaveType" ng-options="option as option.name for option in LEAVE_TYPES" required>\n\t\t\t\t\t<option value="" hidden disabled="disabled" selected="selected">Select a type of leave</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addLeaveForm.leaveType.$error" ng-if="addLeaveForm.leaveType.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a type of leave</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Start date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="startDate">Start date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<date-input-field field-id="startDate" field-value-iso="newLeave.startDateIso" field-required="true">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="addLeaveForm.startDate.$error" ng-if="addLeaveForm.startDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a start date for the leave</p>\n\t\t\t\t\t<p ng-message="max">The start date should be the same as or sooner than the end date</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayFrom" name="holidayHalfDayFrom" ng-model="newLeave.halfDayFrom" ng-change="addHalfDayFrom(newLeave)" ng-disabled="!newLeave.startDateIso || (newLeave.leaveDays === 0.5 && newLeave.halfDayTo)">\n\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayFrom">{{newLeave.leaveDays > 1 ? "Half day PM" : "Half day AM"}}</label>\n\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayFrom"></label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="leave-card__form-icon" ng-class="{\'invisible\' : !newLeave.startDateIso}">\n\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t</div>\n\n\t\t\t<!-- End date -->\n\t\t\t<div class="form-field" ng-class="{\'invisible\' : !newLeave.startDateIso}">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="endDateIso">End date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<date-input-field field-id="endDate" field-required="true" field-value-iso="newLeave.endDateIso">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="addLeaveForm.endDateIso.$error" ng-if="addLeaveForm.endDateIso.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a end date for the leave</p>\n\t\t\t\t\t<p ng-message="min">The end date should be the same as or later than the start date</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayTo" name="holidayHalfDayTo" ng-model="newLeave.halfDayTo" ng-change="addHalfDayTo(newLeave)" ng-disabled="newLeave.leaveDays === 0.5 && newLeave.halfDayFrom">\n\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayTo">{{newLeave.leaveDays > 1 ? "Half day AM" : "Half day PM"}}</label>\n\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayTo"></label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="newLeave.startDateIso && newLeave.endDateIso && newLeave.selectedLeaveType">\n\t\t<div class="leave-card {{newLeave.selectedLeaveType.id | leaveThemes}}">\n\t\t\t<p class="s align-left" ng-if="newLeave.leaveDays > 1">{{formOptions.context.Forename}} will be on {{newLeave.selectedLeaveType.name | lowercase}} from <span class="stronger {{newLeave.selectedLeaveType.id | leaveThemes:true}}">{{newLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> to <span class="stronger {{newLeave.selectedLeaveType.id | leaveThemes:true}}">{{newLeave.endDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{newLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="newLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t\t<p class="s align-left" ng-if="newLeave.leaveDays <= 1">{{formOptions.context.Forename}} will be on {{newLeave.selectedLeaveType.name | lowercase}} on <span class="stronger {{newLeave.selectedLeaveType.id | leaveThemes:true}}">{{newLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{newLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="newLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addLeaveForm.state" disable-button="!addLeaveForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/addPeriodNote/addPeriodNoteForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addPeriodNoteForm" ng-if="pageState === \'ready\'" ng-submit="checkForMentions(vm, addPeriodNoteForm)" novalidate>\n\t<fieldset>\n\t\t<legend hidden>Note Details</legend>\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss-key="period-note-mention" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Password protected files">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPassword protected files are frequently used for virus or malware attacks so all uploads are scanned to keep your data safe and secure.\n\t\t\t\t\t\tProtected files will always be rejected whether you have chosen to add a password to them or not.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\n\t\t</div>\n\n\t\t<!-- Note -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="note" id="mentionInputLabel">\n\t\t\t\t\tNote:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<mention-input agency-profile-id="formOptions.agencyProfileId" mention-list="vm.note.MentionList" name="note" ng-model="vm.note.Text" required="true" rows="8"></mention-input>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addPeriodNoteForm.note.$error" ng-messages="addPeriodNoteForm.note.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a note.</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">Type \'@\' to view and select from a list of everyone with access to this payroll.</p>\n\t\t</div>\n\n\t\t<!-- Attachments -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<file-uploader fu-agency-profile-id="formOptions.agencyProfileId" fu-allow-multiple="true" fu-file-list="vm.note.DocumentList" fu-name="periodNoteUploader" fu-on-error="onError" fu-on-upload-complete="onUploadComplete" fu-on-upload-start="onUploadStart" fu-params="vm.fileUploaderParams"></file-uploader>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Note Options</legend>\n\t\t<a class="button secondary-action" href="" ng-class="{\n\t\t\t\t\'is-disabled\': formOptions.isCloseFormDisabled\n\t\t\t}" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button disable-button="!addPeriodNoteForm.$valid" display-text="formOptions.primaryButtonText" state="addPeriodNoteForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You don\'t have any team members set up yet" ng-if="pageState === \'no-team-members\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou can add new team members in\n\t\t\t<a ui-sref="team.members({agencyProfileId: agencyProfileId})">your Team area</a>.\n\t\t\tTo get them ready for payroll, you may want to have things like their Date of Birth, NI Number, Address, Bank details and tax code to hand.\n\t\t\tYou can then import payroll changes and get the latest tax updates for your team members.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Do you wish to mention someone?" fs-show-close="false" ng-if="pageState === \'no-mention\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tMentioning the person your note is intended for means they will also receive a notification and may see it sooner. To mention someone in your note click \'Go Back, \' type the \'@\' symbol and select a person from the list that appears.\n\t\t</p>\n\t\t<p class="is-small">\n\t\t\tClick \'Continue\' if you\'re happy to add your note without mentioning someone.\n\t\t</p>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="goBack()" type="button">\n\t\t\tGo back\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="createMessage(vm)" type="button">\n\t\t\tContinue\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/addPeriodTask/addPeriodTaskForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addPeriodTaskForm" ng-if="pageState === \'ready\'" ng-submit="saveForm(vm, addPeriodTaskForm)" novalidate>\n\t<div class="form-field">\n\t\t<note note-dismiss-key="period-task-mention" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Password protected files">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPassword protected files are frequently used for virus or malware attacks so all uploads are scanned to keep your data safe and secure.\n\t\t\t\t\tProtected files will always be rejected whether you have chosen to add a password to them or not.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tAdd your task, select an assignee and add an optional due date.\n\t\t\tThe payroll processing date for {{formOptions.company.Name}} is {{::$root.currentPeriod.PayDateISO | dateformat:\'dayMonthYear\'}}.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<legend hidden>Task Details</legend>\n\t\t<!-- Task -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="textField">\n\t\t\t\t\tTask:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<custom-textarea name="task" placeholder="Enter a task" required="true" rows="5" text="vm.task.Text">\n\t\t\t\t</custom-textarea>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addPeriodTaskForm.task.$touched" ng-messages="addPeriodTaskForm.task.$error" role="alert">\n\t\t\t\t<p ng-message="maxlength">Maximum length of task description is 2048 characters.</p>\n\t\t\t\t<p ng-message="required">Please enter a task.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Attachments -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<file-uploader fu-agency-profile-id="formOptions.agencyProfileId" fu-allow-multiple="true" fu-file-list="vm.task.DocumentList" fu-name="periodTaskUploader" fu-on-error="onError" fu-on-upload-complete="onUploadComplete" fu-on-upload-start="onUploadStart" fu-params="vm.fileUploaderParams"></file-uploader>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Assignee -->\n\t\t<div class="form-field" ng-if="vm.admins.length">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="textField">\n\t\t\t\t\tAssign task:\n\t\t\t\t</label>\n\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSelect one of your team as the assignee for this task\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-main team-card-basic_wrapper">\n\t\t\t\t<team-card-basic class="fadeIn" ng-if="!vm.selectedAdmin" ng-repeat="admin in vm.admins" team-member="admin">\n\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t<a class="team-card-basic_action is-primary" data-cy="add-period-task-assign-admin-{{$index}}" href="" ng-click="assignTaskToAdmin(vm, admin)">\n\t\t\t\t\t\t\tAssign\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</tc-actions>\n\t\t\t\t</team-card-basic>\n\n\t\t\t\t<team-card-basic class="fadeIn" ng-if="vm.selectedAdmin" team-member="vm.selectedAdmin">\n\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t<a class="team-card-basic_action is-primary" href="" ng-click="reassignTask(vm)">\n\t\t\t\t\t\t\tChange\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</tc-actions>\n\t\t\t\t</team-card-basic>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Task details-->\n\t<fieldset class="fadeIn" ng-if="vm.selectedAdmin">\n\t<legend hidden>Task Details</legend>\n\t\t<div class="form-field-group fadeIn">\n\n\t\t\t<!-- Due date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="payPeriodType">\n\t\t\t\t\t\tDue date:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<date-input-field field-id="taskDueDate" field-required="true" field-value-iso="vm.task.DateDueISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Due at -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="paymentDateFirstPeriod">\n\t\t\t\t\t\tTime:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<time-input-field field-name="periodTaskTime" field-value-iso="vm.task.DateDueISO"></time-input-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<p class="form-note">Tasks are prioritised by due date</p>\n\t\t</div>\n\n\t\t<!-- Repeat task -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input title="Create this task every pay period" checkbox id="taskIsRecurring" label-text="\'Create this task every pay period\'" name="taskIsRecurring" ng-model="vm.task.IsRecurring" type="checkbox">\n\t\t\t</div>\n\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou can edit this task at any time to stop creating it every pay period\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Task Options</legend>\n\t\t<a class="button secondary-action" href="" ng-class="{\n\t\t\t\t\'is-disabled\': formOptions.isCloseFormDisabled\n\t\t\t}" ng-click="onCancelClick()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button disable-button="addPeriodTaskForm.$invalid || !vm.selectedAdmin" display-text="formOptions.primaryButtonText" state="addPeriodTaskForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="You don\'t have any team members set up yet" ng-if="pageState === \'no-team-members\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou can add new team members in\n\t\t\t<a ui-sref="team.members({agencyProfileId: agencyProfileId})">your Team area</a>.\n\t\t\tTo get them ready for payroll, you may want to have things like their Date of Birth, NI Number, Address,\n\t\t\tBank details and tax code to hand. You can then import payroll changes and get the latest tax updates for\n\t\t\tyour team members.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/advance-future-periods/advance-future-periods.form.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="advanceFuturePeriodsForm" ng-if="pageState === \'ready\'" ng-submit="advanceFuturePeriods(vm.advanceFuturePeriodsContext, advanceFuturePeriodsForm)" novalidate>\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tSelect a number of periods to advance for {{vm.advanceFuturePeriodsContext.text}} when you run payroll for\n\t\t\t{{vm.currentPayPeriod.PayPeriodDisplay}}. This can be cancelled any time before you run payroll.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-section">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="periodsToAdvance" class="required">Periods to advance:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<number-selector-field field-name="periodsToAdvance" max="vm.advanceFuturePeriodsContext.periodsToAdvanceMax" min="vm.advanceFuturePeriodsContext.periodsToAdvanceMin" ng-model-options="{ debounce: 300 }" ng-model="vm.advanceFuturePeriodsContext.periodsToAdvance" ng-regex-key="numbersPositiveWhole" nsf-on-change="onPeriodsToAdvanceChange(vm)" step="1"></number-selector-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="advanceFuturePeriodsForm.periodsToAdvance.$touched" ng-messages="advanceFuturePeriodsForm.periodsToAdvance.$error" role="alert">\n\t\t\t\t\t<p ng-message="max">Please enter or select a maximum of\n\t\t\t\t\t\t<ng-pluralize count="vm.advanceFuturePeriodsContext.periodsToAdvanceMax" when="{\'1\': \'1 pay period\', \'other\': \'{} pay periods\'}"></ng-pluralize>.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="min">Please enter or select a minimum of\n\t\t\t\t\t\t<ng-pluralize count="vm.advanceFuturePeriodsContext.periodsToAdvanceMin" when="{\'1\': \'1 pay period\', \'other\': \'{} pay periods\'}"></ng-pluralize>.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter a whole number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<section class="fadeIn form-section" ng-show="advanceFuturePeriodsForm.periodsToAdvance.$valid">\n\t\t\t<div class="form-field-highlight is-primary">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tThe following periods will be advanced for {{vm.advanceFuturePeriodsContext.text}}\n\t\t\t\t\t\twhen you run payroll for {{vm.currentPayPeriod.PayPeriodDisplay}}:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-list">\n\t\t\t\t\t<div class="form-list_item is-primary fadeIn" ng-repeat="advanceFuturePeriod in vm.advanceFuturePeriods" ng-show="$index < vm.advanceFuturePeriodsContext.periodsToAdvance">\n\t\t\t\t\t\t<p><i class="icon-calendar m is-primary"></i>&nbsp;&nbsp;&nbsp;<span class="is-strong">{{advanceFuturePeriod.PayPeriodDisplay}}</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="form-section">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Turn on threshold postponement for AE pensions">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tYou may wish to turn on threshold postponement for your AE pensions if you\'re advancing periods for team members\n\t\t\t\t\t\tso they\'re not incorrectly assessed when they receive additional pay for those periods.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</section>\n\n\t\t<section class="form-section">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Pay statement overrides">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s" ng-if="!vm.advanceFuturePeriodsContext.isBulk">\n\t\t\t\t\t\tPlease note that you won\'t be able to override any payments in the pay statement preview for any of these team\n\t\t\t\t\t\tmembers in your current period and any overrides that you\'ve already added will be deleted once you click \'Save\'.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="s" ng-if="vm.advanceFuturePeriodsContext.isBulk">\n\t\t\t\t\t\tPlease note that you won\'t be able to override any payments in {{vm.advanceFuturePeriodsContext.text}}\'s pay statement\n\t\t\t\t\t\tpreview in your current period and any overrides that you\'ve already added will be deleted once you click \'Save\'.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</section>\n\n\t</fieldset>\n\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="!advanceFuturePeriodsForm.$valid" display-text="\'Save\'" state="advanceFuturePeriodsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No future pay periods available to advance (possibly not a valid scenario, but you never know)-->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="No periods to advance" ng-if="pageState === PAGE_STATES.noFuturePeriods">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThere are no future pay periods available to advance.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Have you added all your changes for {{vm.advanceFuturePeriodsContext.applicableTo}}?" ng-if="pageState === PAGE_STATES.confirmation">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tPlease ensure that you have made any of the below changes required for {{vm.advanceFuturePeriodsContext.applicableTo}}\n\t\t\t\tbefore setting them to advance, as they may affect tax and NI calculations for the future periods you\u2019re advancing:\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<bullet-list bl-theme="is-primary is-small">\n\t\t\t\t<bl-items>\n\t\t\t\t\t<li class="bullet-list_item">Payroll changes</li>\n\t\t\t\t\t<li class="bullet-list_item">Changes to personal details or tax status</li>\n\t\t\t\t\t<li class="bullet-list_item">Changes to pension information</li>\n\t\t\t\t\t<li class="bullet-list_item">Updates to parental, sick, or repayment schedules</li>\n\t\t\t\t\t<li class="bullet-list_item">Updates to Attachment of Earnings orders or childcare vouchers</li>\n\t\t\t\t</bl-items>\n\t\t\t</bullet-list>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tIf you realise that you\u2019ve forgotten to add any of these changes you will need to unmark {{vm.advanceFuturePeriodsContext.applicableTo}}\n\t\t\t\tas \u2018Advancing\u2019, make your changes, then set them to advance again. This will ensure your tax and NI calculations are up to date.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToAdvanceFuturePeriodsForTeamMembers" underline="true">Read our guide to advancing future periods for team members</support-article-link>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<div class="confirmation-block tertiary-light has-font-weight-normal">\n\t\t\t\t<input checkbox class="s" id="confirmInformation" label-text="\'I confirm that I have already added all payroll changes for the periods I wish to advance\'" name="confirmInformation" ng-model="vm.confirmInformation" required type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Cancel</button>\n\t\t<button class="tertiary primary-action" ng-disabled="!vm.confirmInformation" ng-click="setPageState(PAGE_STATES.ready)">Continue</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="secondary" fs-title="Marked as \'Advancing\'" ng-if="pageState === PAGE_STATES.complete">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t{{utilities.toSentenceCase(vm.advanceFuturePeriodsContext.text)}} {{vm.advanceFuturePeriodsContext.isBulk ? \'have\' : \'has\'}} been marked as \u2018Advancing\u2019\n\t\t\tand after you run payroll for {{vm.currentPayPeriod.PayPeriodDisplay}} they won\u2019t appear on payroll again until after the\n\t\t\t{{vm.advanceFuturePeriodsContext.lastAdvancePeriodDisplay}} period is finalised. You can cancel this by clicking the\n\t\t\t\u2018Unmark as advancing\u2019 action in their profile before you run payroll.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/applyTaxRefund/applyTaxRefundForm.html','<section class="form-summary fadeIn" ng-if="pageState === \'loading\'">\n\t<loading-block size="m">\n\t\t<lb-description>Calculating tax refund\u2026</lb-description>\n\t</loading-block>\n</section>\n\n<form name="applyTaxRefundForm" ng-submit="updateTaxRefund(teamMember, applyTaxRefundForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Based on {{formOptions.context.Forename}}\u2019s pay and tax code information for this tax year, our system has calculated that {{formOptions.context.Forename}} is due a refund.</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="tax-refund">\n\t\t\t<div class="tax-refund__header">\n\t\t\t\t<h6 class="tax-refund__title">Tax refund</h6>\n\t\t\t\t<h6 class="tax-refund__amount">{{teamMember.TaxPayable | positive | monetise}}</h6>\n\t\t\t</div>\n\t\t\t<div class="tax-refund__content" ng-if="!teamMember.IsTaxRefund">\n\t\t\t\t<p class="s greyscale-darkened">\n\t\t\t\t\tClick \u2018apply\u2019 to confirm you would like to apply {{formOptions.context.Forename}}\u2019s refund to the current period.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="tax-refund__content" ng-if="teamMember.IsTaxRefund">\n\t\t\t\t<p class="s greyscale-darkened">\n\t\t\t\t\tClick \u2018delete\u2019 to confirm you would like to remove {{formOptions.context.Forename}}\u2019s refund from the current period.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="teamMember.IsTaxRefund ? \'Delete\' : \'Apply\'" state="applyTaxRefundForm.state" disable-button="!applyTaxRefundForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="No tax refund due" ng-if="pageState === \'no-refund-due\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tBased on {{formOptions.context.Forename}}\u2019s pay and tax code information for this tax year, our system has calculated that there\u2019s no refund due.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This feature isn\'t available in Test mode" ng-if="pageState === \'test-mode\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tIf you wish to apply a tax refund, you can do so once you switch to live mode. Please note that if you decide to switch back to test mode, before your first live period is run, and tax refunds you\'ve added will be deleted.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{teamMember.IsTaxRefund ? \'Tax refund removed\' : \'Tax refund applied\'}}" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s" ng-if="!teamMember.IsTaxRefund">{{formOptions.context.Forename}}\u2019s tax refund will be applied in the {{formOptions.currentPayPeriod.PayPeriodDisplay}} period. You can decide not to apply {{formOptions.context.Forename}}\u2019s tax refund up to the point you run payroll. <a href ui-sref="payroll.current-period.changes({agencyProfileId: formOptions.agencyProfileId})" class="underline">Go to current period</a></p>\n\t\t<p class="s" ng-if="teamMember.IsTaxRefund">{{formOptions.context.Forename}}\u2019s tax refund will be removed from the {{formOptions.currentPayPeriod.PayPeriodDisplay}} period. <a href ui-sref="payroll.current-period.changes({agencyProfileId: formOptions.agencyProfileId})" class="underline">Go to current period</a></p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/attachment-of-earnings/attachment-of-earnings-view.form.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- View AOE -->\n<form class="fadeIn" name="viewAoeForm" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Paid -->\n\t<div class="form-content-block" ng-if="::aoe.OrderState === AOE_ORDER_STATES.complete && finalPayment">\n\t\t<div class="note positive">\n\t\t\t<p><span class="strong positive">Complete</span>&nbsp;on {{finalPayment.PayPeriod.PayDateISO | dateformat}}</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Cancelled -->\n\t<div class="form-content-block" ng-if="::aoe.OrderState === AOE_ORDER_STATES.cancelled">\n\t\t<div class="note tertiary">\n\t\t\t<p><span class="strong tertiary">Cancelled</span>&nbsp;- {{aoe.CancelledReason.ReasonText}}</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Paused -->\n\t<div class="form-content-block" ng-if="::aoe.IsPaused">\n\t\t<div class="note assertive">\n\t\t\t<p><span class="strong assertive">Deductions paused</span> on {{aoe.PauseDateISO | dateformat}}</p>\n\t\t</div>\n\t</div>\n\n\t<nav class="tabs" ng-class="{\n\t\t\t\'open\': isOpen\n\t\t}" ng-click="isOpen = !isOpen">\n\t\t<a href="" ng-class="{\n\t\t\t\t\'active\': activeTab === \'details\'\n\t\t\t}" ng-click="changeTab(\'details\')">\n\t\t\tDetails\n\t\t</a>\n\t\t<a href="" ng-class="{\n\t\t\t\t\'active\': activeTab === \'payment-history\'\n\t\t\t}" ng-click="changeTab(\'payment-history\')">\n\t\t\tPayment history\n\t\t</a>\n\t</nav>\n\n\t<!-- Details -->\n\t<div class="form-content-block" ng-if="activeTab === \'details\'">\n\t\t<h4>Attachment of Earnings Order - {{aoe.AttachmentOrderType.Description}}</h4>\n\n\t\t<div class="form-data-summary">\n\t\t\t<div class="form-data-summary-items">\n\t\t\t\t<div class="form-data-summary-item">\n\t\t\t\t\t<h6>Reference number:</h6>\n\t\t\t\t\t<p>{{aoe.PaymentReference}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item">\n\t\t\t\t\t<h6>Date of order:</h6>\n\t\t\t\t\t<p>{{aoe.OrderDateISO | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.TotalAmount > 0">\n\t\t\t\t\t<h6>Total amount to be recovered:</h6>\n\t\t\t\t\t<p ng-if="aoe.TotalAmount !== \'\'">{{aoe.TotalAmount | monetise}}</p>\n\t\t\t\t\t<p class="greyscale" ng-if="aoe.TotalAmount === \'\'">\n\t\t\t\t\t\t<em>Not shown on order</em>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.AttachmentOrderType.AttachmentOrderRateID === AOE_ORDER_TYPES.cmaScotland">\n\t\t\t\t\t<h6>Daily maintenance rate:</h6>\n\t\t\t\t\t<p>{{aoe.DailyRateValue | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.ProtectedEarningsValue > 0">\n\t\t\t\t\t<h6>Protected earnings:</h6>\n\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t<p ng-if="aoe.ProtectedEarningsUnits === 1">{{aoe.ProtectedEarningsValue}}%</p>\n\t\t\t\t\t<!-- Amount -->\n\t\t\t\t\t<p ng-if="aoe.ProtectedEarningsUnits === 2">{{aoe.ProtectedEarningsValue | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.FixedAmountValue > 0">\n\t\t\t\t\t<h6>Fixed {{::$root.currentPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} amount:</h6>\n\t\t\t\t\t<p>{{aoe.FixedAmountValue | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.OrderEndDateISO !== \'\'">\n\t\t\t\t\t<h6>End date:</h6>\n\t\t\t\t\t<p>{{aoe.OrderEndDateISO | dateformat}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-summary-item" ng-if="aoe.IsPriority">\n\t\t\t\t\t<span class="hmrc-label">Priority</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Has admin charge -->\n\t\t\t<div class="message-bar indifferent template-1" ng-if="aoe.HasAdminCharge">\n\t\t\t\t<i class="icon-fixed-value indifferent message-bar-icon"></i>\n\t\t\t\t<p class="message-bar-message">{{aoe.AdminChargeValue | monetise}} admin charge applied to each deduction</p>\n\t\t\t\t<a class="indifferent underline message-bar-action" href="" ng-click="openViewAttachmentOfEarningsForm(aoe, 6)">\n\t\t\t\t\tTurn off\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- No admin charge -->\n\t\t\t<div class="message-bar indifferent template-1" ng-if="!aoe.HasAdminCharge">\n\t\t\t\t<i class="icon-fixed-value indifferent message-bar-icon"></i>\n\t\t\t\t<p class="message-bar-message">No admin charge has been applied</p>\n\t\t\t\t<a class="indifferent underline message-bar-action" href="" ng-click="openViewAttachmentOfEarningsForm(aoe, 6)">\n\t\t\t\t\tTurn on\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n        <div ng-if="!aoe.DisbursementDetail.BankInfo.ManualPayment">\n\t\t\t<div class="stat-list primary plain-text">\n\t\t\t\t<div ng-if="aoe.hasBankDetails">\n\t\t\t\t\t<div class="stat-list__info-text">Payments will be made into the following account:</div>\n\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t<span class="stat-list__key">Account name:</span>\n\t\t\t\t\t\t<span class="stat-list__value">{{aoe.DisbursementDetail.BankInfo.BankAccountName}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t<span class="stat-list__key">Sort code:</span>\n\t\t\t\t\t\t<span class="stat-list__value">{{aoe.DisbursementDetail.BankInfo.SortCode}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t<span class="stat-list__key">Account number:</span>\n\t\t\t\t\t\t<span class="stat-list__value">{{aoe.DisbursementDetail.BankInfo.BankAccountNumber}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if="!aoe.hasBankDetails">\n\t\t\t\t\t<div class="stat-list__info-text italic">Bank details not added</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t<span class="stat-list__key">Payment reference:</span>\n\t\t\t\t\t<span class="stat-list__value">{{aoe.DisbursementDetail.BankInfo.BACSPaymentReference}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="stat-list__footer" ng-if="isAoeBacsEnabled">\n\t\t\t\t\t{{aoe.bacsPaymentInfoText}}.\n\t\t\t\t</div>\n\t\t\t</div>\n        </div>\n\n        <div class="message-bar primary template-1" ng-if="aoe.DisbursementDetail.BankInfo.ManualPayment">\n            <i class="icon-information primary message-bar-icon"></i>\n            <p class="message-bar-message">This order is set to be paid manually</p>\n        </div>\n\t</div>\n\n\t<!-- Payment History -->\n\t<div class="form-content-block" ng-if="activeTab === \'payment-history\'">\n\n\t\t<div class="form-content-block">\n\t\t\t<div class="form-data-meta">\n\t\t\t\t<div class="form-data-meta-item">\n\t\t\t\t\t<p class="form-data-meta-item-title">Total amount to recover</p>\n\t\t\t\t\t<p class="form-data-meta-item-value">{{aoe.TotalAmount | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-meta-item">\n\t\t\t\t\t<p class="form-data-meta-item-title">Amount paid to date</p>\n\t\t\t\t\t<p class="form-data-meta-item-value">{{aoe.AmountPaid | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-data-meta-item">\n\t\t\t\t\t<p class="form-data-meta-item-title">Still to pay</p>\n\t\t\t\t\t<p class="form-data-meta-item-value">{{aoe.AmountRemaining | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-content-block">\n\t\t\t<table class="primary">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t\t<th>Amount</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody ng-if="::aoePayments.length">\n\t\t\t\t\t<tr ng-repeat="payment in aoePayments" ng-class="{\n\t\t\t\t\t\t\t\'payments-table-paid\': payment.HasBeenPaid\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<strong>{{payment.PayPeriod.PayPeriodDisplay}}</strong>&nbsp;\n\t\t\t\t\t\t\t<em><ng-pluralize count="payment.DaysInPeriod" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></em>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<strong class="payments-table-amount">{{payment.PaymentAmount | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t\t<tbody ng-if="::(!aoePayments.length && !aoe.isManualPayment)">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="align-center" colspan="2">\n\t\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t\t<p class="caption">\n\t\t\t\t\t\t\t\tPayments will start to appear here when the first instalment is be taken from {{formOptions.context.Forename}}\'s pay.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div ng-if="aoe.IsEditable">\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou can edit this order up until the point payroll is run and the first payment is taken from {{formOptions.context.Forename}}\'s pay.\n\t\t\t\t\t<a class="underline" href="" ng-click="openViewAttachmentOfEarningsForm(aoe)">\n\t\t\t\t\t\tEdit this order now\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- Edible -->\n\t\t<p class="caption" ng-if="aoe.IsEditable">\n\t\t\tThis order was added for {{formOptions.context.Forename}} on {{aoe.OrderDateAddedISO | dateformat}} and the first instalment will be taken from {{formOptions.context.Forename}}\'s pay when\n\t\t\tyou approve payroll for <strong>{{::$root.currentPeriod.PayPeriodDisplay}}</strong>. Until then you can delete this order.\n\t\t</p>\n\t\t<!-- Not editable -->\n\t\t<p class="caption" ng-if="!aoe.IsEditable">\n\t\t\tThis order was added for {{formOptions.context.Forename}} on {{aoe.OrderDateAddedISO | dateformat}}.\n\t\t</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="::aoe.OrderState === AOE_ORDER_STATES.active">\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\n\t\t<!-- Cancel order -->\n\t\t<button class="is-tertiary primary-action" data-cy="attachment-of-earnings-view-button-cancel-this-order" ng-click="aoe.IsEditable ? setPageState(\'cancel-inactive-order\') : setPageState(\'cancel-active-order\')" type="button">\n\t\t\tCancel this order\n\t\t</button>\n\n\t\t<!-- Pause deductions -->\n\t\t<button class="is-tertiary tertiary-action" data-cy="attachment-of-earnings-view-button-pause-deductions" ng-click="setPageState(\'pause-deductions\')" ng-if="!aoe.IsPaused" type="button">\n\t\t\tPause deductions\n\t\t</button>\n\n\t\t<!-- Resume deductions -->\n\t\t<button class="is-tertiary tertiary-action" ng-click="setPageState(\'resume-deductions\')" ng-if="aoe.IsPaused" type="button">\n\t\t\tResume deductions\n\t\t</button>\n\n\t</fieldset>\n</form>\n\n<!-- Cancel Order -->\n<form class="fadeIn" name="cancelAoeForm" ng-if="pageState === \'cancel-inactive-order\'" ng-submit="cancelAoe(aoe, cancelAoeForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to cancel this order?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tAs well as cancelling the order in Paycircle, you should also contact the issuing council to confirm that you wish to cancel the order. Instructions on how to cancel the order should\n\t\t\t\tbe provided with the original documents. Usually this requires an email to be sent to the respective council. We\'ve pre-written an email you can send if you wish.\n\t\t\t\t<a class="underline" href="mailto:?subject=REF: *place reference here*&body=Hello,%0A%0AWe have received an Attachment Order requesting deductions to be made on behalf of\n\t\t\t\t\t\t{{formOptions.context.Forename}} {{formOptions.context.Surname}}. Unfortunately, we cannot make the requested deductions as this individual hasn\'t worked for us for at least 3\n\t\t\t\t\t\tmonths and there\'s no likelihood of them working for us again any time soon.%0A%0ACan you please confirm receipt of this email for our records.%0A%0AMany thanks,%0A*place name\n\t\t\t\t\t\there*">\n\t\t\t\t\tClick here to open it in your email client\n\t\t\t\t</a>.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="cancelAoeForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cancel Order -->\n<form name="cancelAoeForm" ng-if="pageState === \'cancel-active-order\'" ng-submit="cancelAoe(aoe, cancelAoeForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to cancel this order?">\n\t\t<fs-main>\n\t\t\t<div class="form-content-block">\n\t\t\t\t<div class="note indifferent">\n\t\t\t\t\t<p>This order still has an outstanding balance of {{aoe.AmountRemaining | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-content-block">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou should have received a letter from the issuer to confirm they have either cancelled or withdrawn the order or the balance has been fully paid. Alternatively,\n\t\t\t\t\t{{formOptions.context.Forename}} may have left the company. Please select a reason before confirming that you wish to cancel this order.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- Reason for cancelling -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="reasonForCancelling">\n\t\t\t\t\t\t\tReason for cancelling:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select id="reasonForCancelling" name="reasonForCancelling" ng-model="aoe.CancelledReason.ReasonState" ng-options="cancellationReason.ReasonState as cancellationReason.ReasonText for cancellationReason in cancellationReasons" required>\n\t\t\t\t\t\t\t<option value="">Please select a reason...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="!templateForm.$valid.$touched" ng-messages="cancelAoeForm.reasonForCancelling.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please select a reason</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<submit-button disable-button="" display-text="\'Confirm\'" state="cancelAoeForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cancelled -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="The order has been cancelled" ng-if="pageState === \'cancelled\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tNo further deductions will be made for {{formOptions.context.Forename}}.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Pause Deductions -->\n<form name="confirmPauseDeductions" ng-if="pageState === \'pause-deductions\'" ng-submit="updateAttachmentOrderPaused(aoe, true, confirmPauseDeductions)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to pause deductions?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{formOptions.context.Forename}}\'s deductions will be paused with immediate effect and will no longer be taken when you run payroll. You can come back at any time to resume deductions.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<submit-button disable-button="" display-text="\'Confirm\'" state="confirmPauseDeductions.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Resume Deductions -->\n<form name="confirmResumeDeductions" ng-if="pageState === \'resume-deductions\'" ng-submit="updateAttachmentOrderPaused(aoe, false, confirmResumeDeductions)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to resume deductions?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{formOptions.context.Forename}}\'s deductions will be resumed with immediate effect and the next one will be taken when you next run payroll. Click &lsquo;Confirm&rsquo; if you\u2019re\n\t\t\t\thappy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\t\t\t<submit-button disable-button="" display-text="\'Confirm\'" state="confirmResumeDeductions.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/attachment-of-earnings/attachment-of-earnings.form.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'" ng-switch="activeStep">\n\n\t<!-- Step 0 - New / Existing order? -->\n\t<section class="fadeIn" ng-switch-when="0">\n\t\t<form name="attachmentOfEarningsStep2" ng-submit="validateAoeEligibility(aoe)" novalidate>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou may have received a new Attachment of Earnings order for {{formOptions.context.Forename}} or you may wish to add an existing order that has been partially paid and still has\n\t\t\t\t\tan outstanding balance.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- New / Existing -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="form-field-label l" for="aoeNewExistingTrue">\n\t\t\t\t\t\t\tIs this a new or existing order?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="radio-card-input" id="aoeNewExistingTrue" name="aoeNewExisting" ng-model="aoe.isNewOrder" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="aoeNewExistingTrue">\n\t\t\t\t\t\t\t\t\t<i class="icon-add radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-text">New</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="radio-card-input" id="aoeNewExistingFalse" name="aoeNewExisting" ng-model="aoe.isNewOrder" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label" for="aoeNewExistingFalse">\n\t\t\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-text">Existing</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions fadeIn">\n\t\t\t\t<button class="tertiary primary-action">Next</button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 1 - Checking worker information -->\n\t<section class="fadeIn" ng-switch-when="1">\n\n\t\t<div class="spacer l"></div>\n\n\t\t<p class="is-small">\n\t\t\tWe\'re checking to see if {{formOptions.context.Forename}} has been paid by {{formOptions.company.Name}} in the last 3 months. If not, we recommend cancelling the order.\n\t\t</p>\n\n\t\t<loading-block></loading-block>\n\t</section>\n\n\t<!-- Step 2 - Validate Eligiblility -->\n\t<section class="fadeIn" ng-switch-when="2">\n\t\t<form name="attachmentOfEarningsStep1" ng-submit="goToNextStep()" novalidate>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tWe were unable to verify whether {{formOptions.context.Forename}} has been paid in the last 3 months. If not we suggest you select &lsquo;No&rsquo; and follow the advice that\n\t\t\t\t\twe\'ll show you.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="form-field-label l" for="isAoeEligibleFalse">\n\t\t\t\t\t\t\tHas {{formOptions.context.Forename}} been paid in the last 3 months?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="radio-card-input" id="isAoeEligibleTrue" name="isAoeEligible" ng-model="aoeDetails.IsEligible" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label positive" for="isAoeEligibleTrue">\n\t\t\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-text">Yes</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t<input class="radio-card-input" id="isAoeEligibleFalse" name="isAoeEligible" ng-model="aoeDetails.IsEligible" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label class="radio-card-label assertive" for="isAoeEligibleFalse">\n\t\t\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="radio-card-text">No</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Yes -->\n\t\t\t\t<div class="form-content-block fadeIn" ng-if="aoeDetails.IsEligible">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tOk, hit &lsquo;Next&rsquo; to move on and tell us about the order!\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No (specific false check as null by default) -->\n\t\t\t\t<div class="form-content-block fadeIn" ng-if="aoeDetails.IsEligible === false">\n\t\t\t\t\t<div class="note">\n\t\t\t\t\t\t<h6>Cancel the order</h6>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tAs {{formOptions.context.Forename}} has not been paid by <em>{{formOptions.company.Name}}</em> in the last three months we suggest you make arrangements to cancel these\n\t\t\t\t\t\t\tdeductions with immediate effect.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tInstructions on how to cancel the order should be provided with the original documents. Usually this requires an email to be sent to the respective council.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tWe\'ve pre-written an email you can send if you wish.\n\t\t\t\t\t\t\t<a href="mailto:?subject=REF: *place reference here*&body=Hello,%0A%0AWe have received an Attachment Order requesting deductions to be made on behalf of\n\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} {{formOptions.context.Surname}}. Unfortunately, we cannot make the requested deductions as this individual hasn\'t worked for us\n\t\t\t\t\t\t\t\t\tfor at least 3 months and there\'s no likelihood of them working for us again any time soon.%0A%0ACan you please confirm receipt of this email for our records.\n\t\t\t\t\t\t\t\t\t%0A%0AMany thanks,%0A*place name here*">\n\t\t\t\t\t\t\t\tClick here to open it in your email client\n\t\t\t\t\t\t\t</a>.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<a class="link-with-icon" href="" ng-click="formOptions.closeForm()">\n\t\t\t\t\t\t\tOk, close this window\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions fadeIn" ng-if="aoeDetails.IsEligible">\n\t\t\t\t<button class="tertiary primary-action">Next</button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 3 - Order details -->\n\t<section class="fadeIn" ng-switch-when="3">\n\t\t<form name="attachmentOfEarningsStep2" ng-submit="reviewAoeDetailsStep(aoe, currentPayPeriod)" novalidate>\n\n\t\t\t<!-- Eligibility Unknown -->\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou should have received an Attachment of Earnings order for {{formOptions.context.Forename}} which specifies an amount owed and how it should be paid. The order will look\n\t\t\t\t\tsomething like\n\t\t\t\t\t<a class="underline" href="{{$root.URLS.paycircle.images.attachentOfEarningsExample}}" target="_blank">\n\t\t\t\t\t\tthese samples\n\t\t\t\t\t</a>.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Tell us about the order</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Order type -->\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="orderType">\n\t\t\t\t\t\t\tWhat type of order is it?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select id="orderType" name="orderType" ng-change="resetOrderType(aoe, orderType)" ng-model="aoe.AttachmentOrderType" ng-options="orderType as orderType.Description for orderType in orderTypes track by orderType.AttachmentOrderRateID" required>\n\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\tSelect a type of order\u2026\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tThis will be written near the top of the order\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Order details -->\n\t\t\t<fieldset class="fadeIn" ng-if="aoe.AttachmentOrderType.AttachmentOrderRateID">\n\n\t\t\t\t<!-- Payment Reference -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="paymentreference">\n\t\t\t\t\t\t\tPayment Reference:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l" id="paymentreference" name="paymentreference" ng-model-options="{\n\t\t\t\t\t\t\t\tupdateOn: \'blur\'\n\t\t\t\t\t\t\t}" ng-model="aoe.PaymentReference" ng-pattern="$root.REGEX.description" required type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep2.paymentreference.$error" ng-show="attachmentOfEarningsStep2.paymentreference.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease enter a payment reference\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\t\tPayment reference should only contain letters, numbers and basic symbols\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message" ng-if="aoe.AttachmentOrderType.Description !== \'AEO\'">\n\t\t\t\t\t\tThis is usually their NI Number\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Date of the order -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="date">\n\t\t\t\t\t\t\tDate of the order:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="date" field-max-date-iso="aoe.orderDateISOMax" field-value-iso="aoe.OrderDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep2.date.$error" ng-show="attachmentOfEarningsStep2.date.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease enter the date of the order\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="date">\n\t\t\t\t\t\t\tPlease enter a valid date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="max">\n\t\t\t\t\t\t\tThe date of the order can be no later than {{aoe.orderDateISOMax | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Amount -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="{{aoe.hasTotalAmount ? \'required\' : \'disabled\'}}" for="totalamount">\n\t\t\t\t\t\t\tTotal amount to be recovered:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="m monetise" id="totalamount" min="0.01" name="totalamount" ng-disabled="!aoe.hasTotalAmount" ng-model="aoe.TotalAmount" ng-required="aoe.hasTotalAmount" type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep2.totalamount.$error" ng-show="attachmentOfEarningsStep2.totalamount.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="number">\n\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease enter the total amount to be recovered\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\t\tThe minimum amount is 1p\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Daily maintenance rate (CMA Scotland only) -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="aoe.AttachmentOrderType.AttachmentOrderRateID === AOE_ORDER_TYPES.cmaScotland">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="dailyMaintenanceAmount">\n\t\t\t\t\t\t\tDaily maintenance rate:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="m monetise" id="dailyMaintenanceAmount" min="0.01" name="dailyMaintenanceAmount" ng-model="aoe.DailyRateValue" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep2.dailyMaintenanceAmount.$error" ng-show="attachmentOfEarningsStep2.dailyMaintenanceAmount.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="number">\n\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease enter a daily maintenance rate amount\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\t\tThe minimum amount is 1p\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Has total amount (DEO only) -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="aoe.AttachmentOrderType.AttachmentOrderRateID === AOE_ORDER_TYPES.deo">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input checkbox id="hasTotalAmount" label-text="\'A total amount isn\\\'t shown\'" name="hasTotalAmount" ng-change="resetTotalAmount(aoe)" ng-false-value="true" ng-model="aoe.hasTotalAmount" ng-true-value="false" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tIn this case the order may show when payments should start and end, which you can set in the next step, or it may be that payments should continue indefinitely and\n\t\t\t\t\t\tuntil such time as you are instructed by the issuer to cancel the order.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Amount paid -->\n\t\t\t\t<div class="form-field" ng-if="!aoe.isNewOrder || aoe.originalAmountPaid > 0">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="amountPaid">\n\t\t\t\t\t\t\tAmount paid so far:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="m monetise" id="amountPaid" min="0" name="amountPaid" ng-max="aoe.TotalAmount" ng-model="aoe.AmountPaid" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep2.amountPaid.$error" ng-show="attachmentOfEarningsStep2.amountPaid.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\tPlease enter the total amount paid so far\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="number">\n\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\t\tPlease enter numbers only\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\t\tPlease enter an amount that is 0 or greater\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-message="max">\n\t\t\t\t\t\t\tThis amount cannot be more than the total amount to be recovered\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Priority -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="aoe.AttachmentOrderType.CanBePriority">\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input checkbox id="priority" label-text="\'The order is marked as \\\'priority\\\'\'" name="priority" ng-model="aoe.IsPriority" type="checkbox">\n\t\t\t\t\t\t\t&nbsp;&nbsp;<span class="hmrc-label fadeIn" ng-if="aoe.IsPriority">\n\t\t\t\t\t\t\t\tPriority\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- AOE order priority -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="AOE priority order">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\tAttachment of Earnings payments are automatically taken in a certain order depending on their type and issue date but checking the box above means that this order\n\t\t\t\t\t\t\t\t\twill take priority over other orders of the same type.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\t\t\t\t<button class="secondary-action" ng-click="goToStep(0)" type="button">\n\t\t\t\t\tStart again\n\t\t\t\t</button>\n\t\t\t\t<button class="is-tertiary primary-action" ng-disabled="attachmentOfEarningsStep2.$invalid" type="submit">\n\t\t\t\t\tNext\n\t\t\t\t</button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 4 - Additional Order Info. -->\n\t<section class="fadeIn" ng-switch-when="4">\n\t\t<form name="attachmentOfEarningsStep3" ng-submit="goToNextStep()" novalidate>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Payment conditions</h4>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf these aren&#39;t specified on the order, simply hit &lsquo;Next&rsquo; and move on.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="option-list">\n\n\t\t\t\t\t\t<!-- Protected Earnings -->\n\t\t\t\t\t\t<div class="option-list-item">\n\t\t\t\t\t\t\t<div class="option-list-item-header">\n\t\t\t\t\t\t\t\t<input checkbox id="protectedEarnings" label-text="\'A &lsquo;protected earnings&rsquo; amount is shown\'" name="protectedEarnings" ng-model="aoe.HasProtectedEarnings" type="checkbox">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="option-list-item-main indent fadeIn" ng-if="aoe.HasProtectedEarnings">\n\t\t\t\t\t\t\t\t<p class="is-small option-list-item-description">\n\t\t\t\t\t\t\t\t\tThis will be specified as a fixed amount or a percentage and these are the earnings that need to remain after applying the deduction. This tends to be 60% but\n\t\t\t\t\t\t\t\t\tplease change the below value and units if you need to.\n\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="protectedEarningsValue" class="required">\n\t\t\t\t\t\t\t\t\t\t\t\tValue:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<input class="s" id="protectedEarningsValue" name="protectedEarningsValue" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'monetise\': aoe.ProtectedEarningsUnits === UNIT_TYPE_IDS.absolute\n\t\t\t\t\t\t\t\t\t\t\t\t}" ng-model="aoe.ProtectedEarningsValue" ng-pattern="$root.REGEX.numbersOnly" required type="text">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep3.protectedEarningsValue.$error" ng-show="attachmentOfEarningsStep3.protectedEarningsValue.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\t\t\t\tPlease enter the protected earnings amount\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\t\t\t\t\t\t\tPlease enter numbers only\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Units -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="protectedEarningsUnits">\n\t\t\t\t\t\t\t\t\t\t\t\tUnits:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<select class="m" id="protectedEarningsUnits" name="protectedEarningsUnits" ng-model="aoe.ProtectedEarningsUnits" ng-options="unitType.id as unitType.description for unitType in UNIT_TYPES" required></select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Fixed Amount -->\n\t\t\t\t\t\t<div class="option-list-item">\n\t\t\t\t\t\t\t<div class="option-list-item-header">\n\t\t\t\t\t\t\t\t<input checkbox id="hasFixedValue" label-text="\'A &lsquo;fixed amount&rsquo; is shown\'" name="hasFixedValue" ng-disabled="aoe.isFixedAmountRequired" ng-model="aoe.HasFixedValue" type="checkbox">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="option-list-item-main indent fadeIn" ng-if="aoe.HasFixedValue">\n\t\t\t\t\t\t\t\t<p class="is-small option-list-item-description">\n\t\t\t\t\t\t\t\t\tThe order may show a number of values but as your pay periods are {{currentPayPeriod.PayPeriodType | payPeriodTypeDescription:\'monthly\'}}, make sure you enter the\n\t\t\t\t\t\t\t\t\t{{currentPayPeriod.PayPeriodType | payPeriodTypeDescription:\'monthly\'}} amount below.\n\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t<!-- Value -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="fixedAmountValue" class="required">\n\t\t\t\t\t\t\t\t\t\t\tValue:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input class="s monetise" id="fixedAmountValue" name="fixedAmountValue" ng-model="aoe.FixedAmountValue" required type="number">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep3.fixedAmountValue.$error" ng-show="attachmentOfEarningsStep3.fixedAmountValue.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">\n\t\t\t\t\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\t\t\t\t\t\t\tPlease enter numbers only\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\t\t\tPlease enter the fixed amount\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- End date -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="fixedAmountEndDate">End date:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="fixedAmountEndDate" field-required="false" field-value-iso="aoe.OrderEndDateISO" field-min-date-iso="aoe.orderEndDateISOMin">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="attachmentOfEarningsStep3.fixedAmountEndDate.$error" ng-show="attachmentOfEarningsStep3.fixedAmountEndDate.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">\n\t\t\t\t\t\t\t\t\t\t\tPlease enter a valid date\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">\n\t\t\t\t\t\t\t\t\t\t\tThe end date can be no earlier than {{aoe.orderEndDateISOMin | dateformat}}\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\t\t\t\t\tAn end date is optional and may be shown on the order as &lsquo;Last payment due date&rsquo;. If no end date is shown, payments will continue indefinitely and\n\t\t\t\t\t\t\t\t\t\tuntil such time as you are instructed by the issuer to cancel the order. The end date cannot be before {{aoe.orderEndDateISOMin | dateformat}}.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\t\t\t\t<button class="secondary-action" ng-click="goToPreviousStep()" type="button">\n\t\t\t\t\tBack\n\t\t\t\t</button>\n\t\t\t\t<button class="is-tertiary primary-action" ng-disabled="attachmentOfEarningsStep3.$invalid" type="submit">\n\t\t\t\t\tNext\n\t\t\t\t</button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 5 - Bank details -->\n\t<section class="fadeIn" ng-switch-when="5">\n\t\t<form name="attachmentOfEarningsStep4" ng-submit="goToNextStep()" novalidate>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Add bank details for the issuer</h4>\n\t\t\t\t<p ng-if="isAoeBacsEnabled">\n\t\t\t\t\tAttachment of Earnings Orders are set to be paid by BACS in your company settings so you\u2019ll need to add bank details to include them.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\t\t\t\t<bacs-disbursement agency-profile-id="formOptions.agencyProfileId" bacs-enabled="isAoeBacsEnabled" disabled="aoe.DisbursementDetail.ManualPayment" disbursement="aoe.DisbursementDetail" form="attachmentOfEarningsStep4" is-aoe-payment="true" pay-period="currentPayPeriod" show-bacs-title="true"></bacs-disbursement>\n\t\t\t</fieldset>\n\n\t\t\t<fieldset class="form-fieldset-divider-top" ng-if="isAoeBacsEnabled && [\n\t\t\t\t\t\tPAY_PERIOD_TYPES.monthly,\n\t\t\t\t\t\tPAY_PERIOD_TYPES.weekly,\n\t\t\t\t\t\tPAY_PERIOD_TYPES.fortnightly,\n\t\t\t\t\t\tPAY_PERIOD_TYPES.fourweekly\n\t\t\t\t\t].includes(currentPayPeriod.PeriodType)\n\t\t\t\t">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input checkbox id="isManualPayment" label-text="\'Make a manual payment\'" name="isManualPayment" ng-model="aoe.DisbursementDetail.ManualPayment" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tCheck this box if you don\u2019t wish to add bank details and to ignore these payments from BACS files. Instead they will be added to your Manual payment report.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="BACS payment dates">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPlease note that if you set BACS payment dates to a day of the month and select the 29th, 30th or 31st, February will default to the last day of the month, as will\n\t\t\t\t\t\t\t\tmonths with 30 days if you select the 31st.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t<button class="button secondary-action" ng-click="goToPreviousStep()" type="button">\n\t\t\t\t\tBack\n\t\t\t\t</button>\n\n\t\t\t\t<submit-button disable-button="!attachmentOfEarningsStep4.$valid" state="attachmentOfEarningsStep4.state"></submit-button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 6 - Admin charge -->\n\t<section class="fadeIn" ng-switch-when="6">\n\t\t<form name="attachmentOfEarningsStep5" ng-submit="createAttachmentOfEarnings(aoe, attachmentOfEarningsStep5)" novalidate>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Admin charge</h4>\n\t\t\t\t<p>\n\t\t\t\t\tYou are entitled to deduct a {{aoe.AdminChargeValue | monetisedown}} administration charge for each deduction made for this order. If you decide to apply the charge, it will\n\t\t\t\t\tappear on payslips as &lsquo;{{aoe.AttachmentOrderType.Description}} - Admin charge&rsquo;. You can turn this off later if you wish to.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- Apply admin charge -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input checkbox id="hasAdminCharge" label-text="aoe.adminChargeText" name="hasAdminCharge" ng-model="aoe.HasAdminCharge" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Actions -->\n\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t<button class="secondary-action" ng-click="goToPreviousStep()" ng-if="aoe.IsEditable" type="button">\n\t\t\t\t\tBack\n\t\t\t\t</button>\n\n\t\t\t\t<submit-button disable-button="!attachmentOfEarningsStep5.$valid" state="attachmentOfEarningsStep5.state"></submit-button>\n\t\t\t</fieldset>\n\t\t</form>\n\t</section>\n\n\t<!-- Step 7 - Saved -->\n\t<section class="fadeIn" ng-switch-when="7">\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Saved!">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe first payment will be made when you approve payroll for <strong>{{currentPayPeriod.PayPeriodDisplay}}</strong>.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf for some reason you wish to cancel this order, you can do so from {{formOptions.context.Forename}}\'s profile, but you must do this before you approve payroll for\n\t\t\t\t\t<strong>{{currentPayPeriod.PayPeriodDisplay}}</strong>.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</section>\n</div>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/calculate-payroll/calculate-payroll.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<!-- Calculate payroll (previously labelled \'locking\' of payroll, hence some older references to \'Locked\') -->\n<form class="fadeIn" name="calculatePayrollForm" ng-if="$ctrl.pageState === $ctrl.FORM_STATES.calculatePayroll" ng-submit="$ctrl.calculatePayroll($ctrl, calculatePayrollForm)" novalidate>\n\n\t<section class="form-section">\n\t\t<info-block ib-theme="primary has-larger-title align-center" ib-title="{{$ctrl.payPeriod.PayPeriodDisplay}}"></info-block>\n\t</section>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-show-close="false" fs-title="You\u2019re about to calculate payroll">\n\t\t<fs-main>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tOnce payroll has been calculated, tax code, student loan, and postgraduate loan notices will no longer be automatically applied to the current period. They will be postponed\n\t\t\t\t\tuntil the next period unless you choose to edit payroll, and review them by clicking on &lsquo;Get tax updates&rsquo;.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that while payroll is in a calculated state, any updates to settings or team members will still be applied to the calculated period and may affect your draft reports.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Switching a manual AE pension scheme to direct connection">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tIf you\u2019re operating a manual AE pension scheme, and you choose to switch it to connect directly to the provider while your payroll is in a calculated state, we\n\t\t\t\t\t\t\trecommend you check that the scheme and group settings in Paycircle match those held by them. Turning on the direct connection may automatically update your scheme and\n\t\t\t\t\t\t\taffect your draft reports.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section form-fieldset-divider-top no-margin-top">\n\n\t\t\t\t<!-- CIS Deductions? -->\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<input checkbox id="hasCISDeductionsToReport" label-text="\'Report CIS deductions for this period\'" name="hasCISDeductionsToReport" ng-model="$ctrl.cisDeductions.HasCISDeductionsToReport" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Has CIS deductions -->\n\t\t\t\t<section class="form-section fadeIn" ng-if="$ctrl.cisDeductions.HasCISDeductionsToReport">\n\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tEnter any deductions suffered this period, optionally add any subcontractor deductions and confirm you\'re happy with the information you\u2019ve added.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<!-- CIS deductions suffered -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="cisDeductionsSuffered">\n\t\t\t\t\t\t\t\t\tDeductions suffered this period:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input class="l monetise" id="cisDeductionsSuffered" name="cisDeductionsSuffered" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.cisDeductions.CISDeductionsSuffered" ng-pattern="$root.REGEX.decimal" placeholder="0.00" required type="number">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="calculatePayrollForm.cisDeductionsSuffered.$touched" ng-messages="calculatePayrollForm.cisDeductionsSuffered.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the deductions suffered</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\t\t\tCIS deductions can be offset against your monthly or quarterly payments to HMRC. You can reduce your tax, National Insurance contributions or CIS payments by the\n\t\t\t\t\t\t\t\tamount of deductions.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Has CIS subcontractor deductions? -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<toggle-input field-label="Add additional CIS subcontractor deductions" field-model="$ctrl.cisDeductions.HasCISSubcontractorDeductions" field-name="hasCISSubcontractorDeductions"></toggle-input>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tAdd a subcontractor deduction amount in addition to those that have already been automatically deducted for team members in your current period.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-if="$ctrl.cisDeductions.HasCISSubcontractorDeductions">\n\n\t\t\t\t\t\t\t<!-- CIS deductions suffered -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="cisSubcontractorDeductions">\n\t\t\t\t\t\t\t\t\t\tAdditional subcontractor deductions:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input class="l monetise" id="cisSubcontractorDeductions" name="cisSubcontractorDeductions" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.cisDeductions.CISSubcontractorDeductions" ng-pattern="$root.REGEX.decimal" placeholder="0.00" required type="number">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="calculatePayrollForm.cisSubcontractorDeductions.$touched" ng-messages="calculatePayrollForm.cisSubcontractorDeductions.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the deductions suffered</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Confirmation information -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<info-block ib-theme="indifferent">\n\t\t\t\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t\t\t\t<div class="checkbox-fields">\n\t\t\t\t\t\t\t\t\t\t<input checkbox id="confirmInformation" label-text="\'I confirm that the information given in this period is correct to the best of my knowledge\'" name="confirmInformation" ng-model="$ctrl.cisDeductions.confirmInformation" required type="checkbox">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</ib-main>\n\t\t\t\t\t\t\t</info-block>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!calculatePayrollForm.$valid" display-text="\'Continue\'" state="calculatePayrollForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<!-- Undo payroll calculation -> Reports haven\'t been generated -->\n<form class="fadeIn" name="uncalculatePayrollForm" ng-if="$ctrl.pageState === $ctrl.FORM_STATES.uncalculatePayroll" ng-submit="$ctrl.uncalculatePayroll(uncalculatePayrollForm)" novalidate>\n\n\t<section class="form-section">\n\t\t<info-block ib-theme="primary has-larger-title align-center" ib-title="{{$ctrl.payPeriod.PayPeriodDisplay}}"></info-block>\n\t</section>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to undo your calculation?">\n\t\t<fs-main>\n\n\t\t\t<p class="is-small">\n\t\t\t\tOnce you click &lsquo;Confirm&rsquo; you\u2019ll be able to add further changes to payroll and review any tax code, student loan, and postgraduate loan notices received while your\n\t\t\t\tpayroll has been in a calculated state.\n\t\t\t</p>\n\n\t\t\t<!-- Draft Payslips Warning -->\n\t\t\t<info-block ib-theme="assertive has-icon has-border has-plain-type" ng-if="$ctrl.draftPayslipsState.State !== $ctrl.DRAFT_PAYSLIP_TASK_STATES.none">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Draft payslips have been sent</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou have draft payslips that have been sent to employees.\n\t\t\t\t\t\tThese will <span class="stronger">NOT</span> be automatically updated or recalled when you undo the calculation.\n\t\t\t\t\t\tIf you make changes to payroll data, you will need to manually recall and resend draft payslips to reflect those changes.\n\t\t\t\t\t</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!uncalculatePayrollForm.$valid" display-text="\'Confirm\'" state="uncalculatePayrollForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.FORM_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n\n');
$templateCache.put('forms/payroll/cancel-move-payrolls/cancelMovePayrollsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="cancelMovePayrollsForm" ng-submit="cancelMovePayrolls(teamMember, agencyProfileId, cancelMovePayrollsForm)" class="fadeIn" ng-if="pageState === CANCEL_MOVE_PAYROLL_PAGE_STATES.confirmCancel" novalidate>\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="s">You\'re about to cancel {{formOptions.context.Forename}}\u2019s recent payroll move. This means {{formOptions.context.Gender | personalise: \'his\'}} profile\n\t\t\t\tfor {{formOptions.company.Name}} will be removed and {{formOptions.context.Gender | personalise: \'his\'}} profile for {{teamMember.Company.PayrollMoveCompanyName}} will be restored, including any personal or\n\t\t\t\taccount data you\u2019ve edited since {{formOptions.context.Gender | personalise: \'he\'}} moved. Click \u2018Confirm\u2019 if you\u2019re happy to proceed.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="cancelMovePayrollsForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Cancel operation invalid -->\n<form-state form-options="formOptions" fs-theme="primary" fs-icon="information" fs-show-close="true" fs-title="{{formOptions.context.Forename}}\'s payroll move cannot be cancelled" ng-if="pageState === CANCEL_MOVE_PAYROLL_PAGE_STATES.cancelInvalid">\n\t<fs-main ng-switch="invalidCancelReason">\n\t\t<!-- Some of these errors are irrelevant in this specific context. Nevertheless, the API can return any one of these codes, so they\'re all represented -->\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsPayrollsOnDifferentPAYESchemes">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are on a different PAYE scheme.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsPayrollsInDifferentTaxMonths">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as their payroll isn\'t in the same tax month.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsSamePayroll">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are already a team member of the company.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasPaymentScheduleInProgress">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they have a repayment schedule in progress. Review the \'Schedules\' area in their profile for more information.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsLeaver">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are marked as a leaver.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsCIS">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are a member of the CIS scheme. CIS team members can\'t be moved between payrolls.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIncomplete">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled until their profile is complete.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasNoNINumber">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled until a National Insurance Number is added for them.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidIsAlreadyPendingMover">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they have already been moved there.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsExcluded">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are marked as excluded from payroll.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasAOEInProgress">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they have an Attachment of Earnings Order in progress. Review the \'Schedules\' area in their profile for more information.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserAlreadyExistsOnTargetPayroll">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they are already a team member of the company.</p>\n\t\t<p class="s" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserNeverPaidOnOriginalPayroll">{{formOptions.context.Forename}}\'s payroll move to {{teamMember.Company.PayrollMoveCompanyName}} can\'t be cancelled as they were never previously a member of the company.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" ng-if="pageState === \'success\'" fs-show-close="false" fs-title="{{formOptions.context.Forename}}\'s payroll move has been cancelled">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.Personal.Forename}}\u2019s profile for {{teamMember.Company.PayrollMoveCompanyName}} has been removed and {{formOptions.context.Gender | personalise: \'his\'}} original\n\t\t\tprofile for {{formOptions.company.Name}} has been restored.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action tertiary" ng-click="closeForm()">Close\n\t</button></fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/cancelRejoinLeaver/cancelRejoinLeaverForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="cancelRejoinLeaverForm" ng-submit="cancelUserAgencyProfileRestart(cancelRejoinLeaverForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Cancel rejoining {{formOptions.context.Forename}} onto payroll?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThis will remove {{formOptions.context.Forename}}\'s new starter profile, and restore their full profile information in your Leavers area. Click \'Confirm\' if you\'re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="cancelRejoinLeaverForm.state" disable-button="!cancelRejoinLeaverForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success feedback - mark as leaving -->\n<form-state form-options="formOptions" fs-icon="tick" ng-if="pageState === \'success\'" fs-title="Marked as leaver">\n\t<fs-main>\n\t\t<p class="is-small">{{formOptions.context.Forename}} has been marked as a leaver and moved to your Leavers page.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/change-employee-payroll-type/changeEmployeePayrollTypeForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES.loading"></loading-block>\n\n<form name="changeEmployeePayrollTypeForm" class="fadeIn" ng-submit="changeEmployeePayrollType(changeEmployeePayrollTypeForm)" ng-if="pageState === CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES.ready" novalidate>\n\n\t<!-- Changing to PAYE employee -->\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to change {{formOptions.context.Forename}} to an employee?" ng-if="formOptions.employeePayrollType === EMPLOYMENT_PAYROLL_TYPES.paye">\n\t\t<fs-main>\n\t\t\t<p class="s">{{formOptions.context.Forename}}&rsquo;s profile will change to a setup state and they won\u2019t appear in your current period again until all the information\n\t\t\t\trequired to get them ready for payroll is completed. Their history will be available again after you next run payroll. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Reverting to off-payroll worker -->\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to revert {{formOptions.context.Forename}} to an off-payroll worker?" ng-if="formOptions.employeePayrollType === EMPLOYMENT_PAYROLL_TYPES.offPayroll">\n\t\t<fs-main>\n\t\t\t<p class="s">{{formOptions.context.Forename}} will marked as \u2018Off-payroll\u2019, their pay information will be deleted, and they will be excluded from any pension schemes\n\t\t\t\tyou may have added them to. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p><br>\n\n\t\t\t\t<note note-title="Reverting team members to off-payroll workers" note-icon="icon-support" note-theme="indifferent" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">Please note that any of the following payments you may have set up for {{formOptions.context.Forename}} since you changed them to an employee will be deleted:</p>\n\t\t\t\t\t\t<ul class="note-list">\n\t\t\t\t\t\t\t<li class="note-list_item">Sick pay</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Maternity pay</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Paternity pay</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Repayment schedules (cycle to work, company loan, season ticket loan)</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Attachment of Earnings Orders</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Benefits in Kind (company vehicle, healthcare)</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Childcare vouchers</li>\n\t\t\t\t\t\t\t<li class="note-list_item">Future changes</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" icon-position="right" state="changeEmployeePayrollTypeForm.state" disable-button="!changeEmployeePayrollTypeForm.$valid"></submit-button>\n\t</fieldset>\n\n</form>\n\n<!-- Error -->\n<error-block ng-if="pageState === CHANGE_EMPLOYEE_PAYROLL_TYPE_PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/childcareVouchers/childcareVouchersForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="childcareVouchersSetupForm" ng-submit="saveChildcareVoucher(vm, childcareVouchersSetupForm)" class="fadeIn" ng-if="pageState === \'setup\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">To make childcare voucher payments for {{formOptions.context.Forename}}, select the period you want them to begin, the amount to pay each period then click \u2018Save\u2019.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- First payment -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="firstPaymentDate" class="required">Make the first payment in:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" name="firstPaymentDate" id="firstPaymentDate" ng-model="vm.selectedPayPeriod" ng-options="payPeriod as payPeriod.PayPeriodDisplay for payPeriod in vm.payPeriods track by payPeriod.PayPeriodID" ng-change="updateSelectedPayPeriod(vm)" required></select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="childcareVouchersSetupForm.firstPaymentDate.$error" ng-if="childcareVouchersSetupForm.firstPaymentDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select a period</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Amount to pay -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="amountToPay" class="required">Amount to pay each period:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="amountToPay" class="l-alt monetise" name="amountToPay" type="text" ng-model="vm.paymentScheduleGroup.FixedRepaymentAmount" placeholder="Type an amount here\u2026" ng-pattern="$root.REGEX.decimal" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="childcareVouchersSetupForm.amountToPay.$error" ng-if="childcareVouchersSetupForm.amountToPay.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid amount</p>\n\t\t\t</div>\n\t\t\t<p class="form-message"><span class="stronger normal">Please note:</span> payments will continue to be made until such time as you cancel them</p>\n\t\t</div>\n\n\t\t<!-- Payslip Label -->\n\t\t<div class="form-field">\n\t\t\t<div class="pill-input-field primary" ng-class="{\'active\': vm.payslipLabelFocused}">\n\t\t\t\t<label for="payslipLabel" class="pill-input-field-label"><i class="icon-label"></i> Label for payslip <span>optional</span></label>\n\t\t\t\t<input class="pill-input-field-input fadeIn" type="text" id="payslipLabel" name="payslipLabel" ng-model="vm.paymentScheduleGroup.PayslipLabel" ng-focus="togglePayslipLabelFocused(vm, true)" placeholder="Add a custom label for this change" ng-required="vm.saveLabel" maxlength="40" minlength="3" ng-pattern="$root.REGEX.description" autocomplete="off" ng-if="!vm.selectedAdjustmentLabel">\n\t\t\t\t<div class="pill-input-field-errors" ng-messages="childcareVouchersSetupForm.payslipLabel.$error" ng-if="!childcareVouchersSetupForm.payslipLabel.$valid && childcareVouchersSetupForm.payslipLabel.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t\t\t<p ng-message="required">Please enter a label</p>\n\t\t\t\t\t<p ng-message="minlength">Please enter a label with at least 3 characters</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<!-- Pensionable -->\n\t\t<settings-row sr-field-name="paymentScheduleGroupPensionState" sr-icon="money" ng-model="vm.paymentScheduleGroup.PaymentScheduleGroupPensionState" sr-theme="quarternary" sr-disabled="::vm.isChildcareVoucherPensionDisabled" on-update="reviewChildcareVoucherPension(vm.paymentScheduleGroup)" ng-if="$root.currentCompany.IsPensionActive">\n\t\t\t<sr-label>Pensionable</sr-label>\n\t\t\t<sr-description>\n\t\t\t\t<span ng-switch="vm.paymentScheduleGroup.PaymentScheduleGroupPensionBehaviour">\n\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked">This will be included in pay when calculating pension contributions. It can\'t be switched &lsquo;OFF&rsquo;.</span>\n\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked">This will not be included in pay when calculating pension contributions. It can\'t be switched &lsquo;ON&rsquo;.</span>\n\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on">Switch to &lsquo;OFF&rsquo; if you don\u2019t want these payments to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.</span>\n\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off">Switch to &lsquo;ON&rsquo; if you want these payments to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.</span>\n\t\t\t\t</span>\n\t\t\t</sr-description>\n\n\t\t\t<sr-content ng-if="vm.paymentScheduleGroup.PaymentScheduleGroupPensionState && vm.paymentScheduleGroup.PaymentScheduleGroupPension.length > 0">\n\n\t\t\t\t<fieldset>\n\t\t\t\t\t<h6>Include when calculating contributions for:</h6>\n\t\t\t\t</fieldset>\n\n\t\t \t\t<!-- Pension Salary Sacrifice Behaviour -->\n\t\t \t\t<div class="form-field less-margin color-card is-white" ng-repeat="pension in vm.paymentScheduleGroup.PaymentScheduleGroupPension">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth" ng-class="{ \'is-greyscale\': vm.isChildcareVoucherPensionDisabled }">\n\t\t\t\t\t\t\t{{::pension.PensionProviderName}}\n\t\t\t\t\t\t\t<span class="float-right is-quarternary is-light">Ref: {{::pension.EmployerReference}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list is-inline" ng-class="{ \'is-disabled\' : vm.isChildcareVoucherPensionDisabled }">\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourEmployer-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::vm.isChildcareVoucherPensionDisabled" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer" type="radio">\n\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployer-{{::pension.AgencyEmployerPensionID}}">Employer only</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourEmployee-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::vm.isChildcareVoucherPensionDisabled" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee" type="radio">\n\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployee-{{::pension.AgencyEmployerPensionID}}">Employee only</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourBoth-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::vm.isChildcareVoucherPensionDisabled" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.both" type="radio">\n\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth-{{::pension.AgencyEmployerPensionID}}">Both</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t \t\t</div>\n\n\t\t\t</sr-content>\n\t\t</settings-row>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro" ng-class="{\'disabled\' : vm.paymentScheduleGroup.DisbursementDetail.ManualPayment }" ng-if="vm.isBacsChildcareVouchersEnabled">\n\t\t\t<h4>BACS</h4>\n\t\t\t<p class="s">Childcare vouchers are set to be paid by BACS in your company settings so you\u2019ll need to add bank details to include them.</p>\n\t\t</div>\n\n\t\t<bacs-disbursement pay-period="vm.payPeriod" disbursement="vm.paymentScheduleGroup.DisbursementDetail" agency-profile-id="formOptions.agencyProfileId" form="childcareVouchersSetupForm" disabled="vm.paymentScheduleGroup.DisbursementDetail.ManualPayment" bacs-enabled="vm.isBacsChildcareVouchersEnabled"></bacs-disbursement>\n\n\t</fieldset>\n\n\t<fieldset class="form-section with-separator no-bottom-margin" ng-if="vm.isBacsChildcareVouchersEnabled">\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="manualPayment" name="manualPayment" ng-model="vm.paymentScheduleGroup.DisbursementDetail.ManualPayment" label-text="\'Make these payments manually\'" checkbox>\n\t\t\t</div>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="form-message">Check this box if you don\u2019t wish to add bank details and to ignore these payments from BACS files. Instead they will be added to your Manual payment report.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="[PAY_PERIOD_TYPES.monthly, PAY_PERIOD_TYPES.weekly, PAY_PERIOD_TYPES.fortnightly, PAY_PERIOD_TYPES.fourweekly].includes(vm.payPeriod.PeriodType)">\n\t\t\t<note note-title="BACS payment dates" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that if you set BACS payment dates to a day of the month and select the 29th, 30th or 31st, February will default to the last day of the month, as will months with 30 days if you select the 31st. </p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="childcareVouchersSetupForm.state" disable-button="!childcareVouchersSetupForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form name="childcareVouchersViewForm" ng-submit="stopChildcareVoucherPayments(vm, childcareVouchersViewForm)" class="fadeIn" ng-if="pageState === \'view\'" novalidate ng-switch="vm.formView">\n\n\t<div class="form-section fadeIn" ng-if="vm.paymentScheduleGroup.CancelledDateISO">\n\t\t<notification-card theme="is-tertiary is-borderless">\n\t\t\t<nc-description>\n\t\t\t\t<span>Payments stopped</span> on {{vm.paymentScheduleGroup.CancelledDateISO | dateformat}}\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<div class="form-section">\n\t\t<navigation-tabs>\n\t\t   <a href="" data-cy="childcare-vouchers-form-button-tab-details" ng-class="{\'active\': vm.formView === \'details\'}" ng-click="vm.formView = \'details\'">Details</a>\n\t\t   <a href="" data-cy="childcare-vouchers-form-button-tab-payments" ng-class="{\'active\': vm.formView === \'payments\'}" ng-click="vm.formView = \'payments\'">Payment history</a>\n\t\t</navigation-tabs>\n\t</div>\n\n\t<div class="form-section fadeIn" ng-switch-when="details">\n\n\t\t<h4>Childcare voucher payments</h4>\n\n\t\t<div class="spacer l"></div>\n\n\t\t<repayment-card repayment="vm.paymentScheduleGroup" rc-theme="is-quarternary" rc-view-type="payment"></repayment-card>\n\n\t\t<div class="spacer l"></div>\n\n\t\t<p class="s">A fixed payment will be made each pay period of {{vm.paymentScheduleGroup.FixedRepaymentAmount | monetise}}, starting in {{vm.paymentScheduleGroup.FirstPayPeriodDisplay}}. If you need to change anything, go back and <a href ng-click="setPageState(\'setup\')" class="underline">edit the settings</a>.</p>\n\n\t\t<hr class="xxl">\n\n\t\t<div class="stat-list primary plain-text" ng-if="vm.hasBankDetails">\n\t\t\t<div class="stat-list__info-text">Payments will be made into the following account:</div>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Account name:</span> <span class="stat-list__value">{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.BankAccountName}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Sort code:</span> <span class="stat-list__value">{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.SortCode}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row">\n\t\t\t\t<span class="stat-list__key">Account number:</span> <span class="stat-list__value">{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.BankAccountNumber}}</span>\n\t\t\t</div>\n\t\t\t<div class="stat-list__row" ng-if="vm.isBacsChildcareVouchersEnabled">\n\t\t\t\t<span class="stat-list__key">Payment reference:</span> <span class="stat-list__value">{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.BACSPaymentReference}}</span>\n\t\t\t</div>\n\t\t\t<!--\n\t\t\t<div class="stat-list__image">\n\t\t\t\t<img src="{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.BankBranchName}}" alt="{{vm.paymentScheduleGroup.DisbursementDetail.BankInfo.BankBranchName | capitalise}}" style="max-height: 65px" />\n\t\t\t</div>\n\t\t\t-->\n\t\t\t<div class="stat-list__footer" ng-if="vm.isBacsChildcareVouchersEnabled">{{vm.paymentScheduleGroup.bacsPaymentInfoText}}.</div>\n\t\t</div>\n\n\t\t<div class="note primary" ng-if="!vm.hasBankDetails">\n\t\t\t<p class="s italic">Bank details not added</p>\n\t\t</div>\n\n\t</div>\n\n\t<div class="form-section fadeIn" ng-switch-when="payments">\n\n\t\t<p>\n\t\t\t<span class="s greyscale">Recurring payment</span><br>\n\t\t\t{{vm.paymentScheduleGroup.FixedRepaymentAmount | monetise}}\n\t\t</p>\n\n\t\t<div class="spacer l"></div>\n\n\t\t<table class="primary payments-table">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t<th>Deduction</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody ng-if="::vm.paymentScheduleGroup.ScheduleEntries.length">\n\t\t\t\t<tr class="payments-table-repaid" ng-repeat="payment in vm.paymentScheduleGroup.ScheduleEntries">\n\t\t\t\t\t<td><span class="stronger">{{payment.PayPeriodDisplay}}</span></td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong class="payments-table-amount is-deduction">-{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t\t<tbody ng-if="::!vm.paymentScheduleGroup.ScheduleEntries.length">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan="2" class="align-center">\n\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t<p class="caption">Payments will start to appear here when the first payment is be taken from {{formOptions.context.Forename}}\'s pay.</p>\n\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n\t<fieldset ng-show="vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension.length > 0">\n\n\t\t<div class="form-field">\n\n\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t<button type="button" class="is-clear detail-blocks-toggle clickable is-secondary no-padding-bottom" ng-class="{\'active\' : vm.showPensionSchemes}" ng-click="vm.showPensionSchemes = !vm.showPensionSchemes">\n\t\t\t\t\t<div class="detail-block-toggle-dot">\n\t\t\t\t\t\t<icon-dot icon="icon-money" theme="is-secondary"></icon-dot>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tPensionable for <ng-pluralize count="vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension.length" when="{\'1\': \'1 scheme\', \'other\': \'{} schemes\'}"></ng-pluralize>\n\t\t\t\t\t</h5>\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-chevron-up is-secondary"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : vm.showPensionSchemes}">\n\n\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t<tr ng-repeat="scheme in vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension = ( vm.paymentScheduleGroup.PaymentScheduleGroupPension | filter: { PaymentScheduleGroupPensionState: true } )">\n\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t<span class="is-greyscale-dark is-small">{{::scheme.PensionProviderName}}</span>\n\t\t\t\t\t\t\t\t<span class="is-greyscale is-small">({{::scheme.EmployerReference}})</span>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<td class="float-right" ng-switch="scheme.PaymentScheduleGroupPensionBehaviourAttributes">\n\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.both">Employee and Employer</span>\n\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee">Employee only</span>\n\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer">Employer only</span>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</table>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t</fieldset>\n\n\t<div class="form-section with-separator">\n\t\t<p class="form-note">These childcare voucher payments were created by {{vm.paymentScheduleGroup.CreatedBy}} on {{vm.paymentScheduleGroup.CreatedDateISO | dateformat:\'dateTime\'}}</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<submit-button display-text="\'Stop payments\'" state="childcareVouchersViewForm.state" disable-button="!vm.paymentScheduleGroup.CanCancel"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/cis-suffered/cis-suffered.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<section ng-if="$ctrl.pageState === \'ready\'">\n\t<!-- Unsubmitted -->\n\t\t<form class="fadeIn" name="cisSufferedForm" ng-submit="$ctrl.updateCISDeductions(cisSufferedForm)" novalidate>\n\n\t\t\t<section class="form-section">\n\t\t\t\t<info-block ib-align="center" ib-theme="primary">\n\t\t\t\t\t<ib-header>\n\t\t\t\t\t\t<p>For the period</p>\n\t\t\t\t\t\t<h4 class="strong">{{$ctrl.payPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t\t</ib-header>\n\t\t\t\t</info-block>\n\t\t\t</section>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe CIS deduction amounts below can be edited and re-submitted at any time up until {{::$ctrl.cisDeductionsObj.CISSubmissionDeadlineISO | dateformat}}.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- CIS deductions suffered -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="cisDeductionsSuffered">\n\t\t\t\t\t\t\tDeductions suffered this period:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l monetise" id="cisDeductionsSuffered" name="cisDeductionsSuffered" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.cisDeductions.CISDeductionsSuffered" ng-pattern="$root.REGEX.number9Digits2Decimal" placeholder="0.00" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="cisSufferedForm.cisDeductionsSuffered.$touched" ng-messages="cisSufferedForm.cisDeductionsSuffered.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tCIS deductions suffered can be offset against your monthly or quarterly payments to HMRC.\n\t\t\t\t\t\tYou can reduce your tax, National Insurance contributions or CIS payments by the amount of deductions.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- CIS deductions suffered -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="cisSubcontractorDeductions">\n\t\t\t\t\t\t\tSubcontractor deductions this period:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l monetise" id="cisSubcontractorDeductions" name="cisSubcontractorDeductions" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.cisDeductions.CISSubcontractorDeductions" ng-pattern="$root.REGEX.number9Digits2Decimal" placeholder="0.00" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="cisSufferedForm.cisSubcontractorDeductions.$touched" ng-messages="cisSufferedForm.cisSubcontractorDeductions.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tPlease note that this is the total of subcontractor deductions that were automatically calculated for team members, and any additional subcontractor deductions you need to submit for this period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\n\t\t\t\t<submit-button disable-button="!cisSufferedForm.$valid" display-text="\'Submit\'" state="cisSufferedForm.state"></submit-button>\n\t\t\t</fieldset>\n\t\t</form>\n</section>\n\n<section ng-if="$ctrl.pageState === \'submitted\'" ng-switch="$ctrl.payPeriod.EPSState">\n\t\t<!-- Submitting -->\n\t\t<section class="form-summary fadeIn" pc-switch-when="$ctrl.SUBMISSION_STATES.submitting">\n\n\t\t\t<loading-block size="l"></loading-block>\n\n\t\t\t<section class="form-summary-section align-center">\n\t\t\t\t<h4>Re-submitting CIS suffered</h4>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou don\'t have to wait for this to finish running. It will update as soon as it\'s complete.\n\t\t\t\t</p>\n\t\t\t</section>\n\t\t</section>\n\n\t\t<!-- Unsubmitted & RTI Off -->\n\t\t<section class="form-summary fadeIn" pc-switch-when="$ctrl.SUBMISSION_STATES.unsubmitted" ng-if="$root.currentCompany.IsRTISubmissionDisabled">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="CIS suffered has been submitted">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">CIS deductions suffered have been saved.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</section>\n\n\t\t<!-- Submitted -->\n\t\t<section pc-switch-when="$ctrl.SUBMISSION_STATES.submitted">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="CIS suffered has been submitted">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="is-small">CIS deductions suffered have been saved and submitted to HMRC.</p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</section>\n\n\t\t<!-- Failed -->\n\t\t<section class="form-summary fadeIn" pc-switch-when="$ctrl.SUBMISSION_STATES.failed">\n\n\t\t\t<form class="fadeIn" name="cisSufferedFailedForm" ng-submit="$ctrl.updateCISDeductions(cisSufferedFailedForm)" novalidate>\n\t\t\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="CIS suffered could not be submitted">\n\t\t\t\t\t<fs-main>\n\n\t\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tThere was a problem submitting your CIS deductions suffered to HMRC. Review and fix any errors before clicking \'Retry\'.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t\t<submission-logs agency-profile-id="$ctrl.formOptions.agencyProfileId" pay-period-id="$ctrl.formOptions.payPeriodId" submission-log-entries="$ctrl.submissionLogEntries" submission-log-type="$ctrl.submissionLogType">\n\t\t\t\t\t\t\t\t<submission-logs-dismissed-copy>\n\t\t\t\t\t\t\t\t\tAll submission errors have been dismissed.\n\t\t\t\t\t\t\t\t</submission-logs-dismissed-copy>\n\t\t\t\t\t\t\t</submission-logs>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fs-main>\n\t\t\t\t</form-state>\n\n\t\t\t\t<fieldset class="form-actions">\n\n\t\t\t\t\t<button class="secondary-action" data-cy="cis-suffered-failed-back" ng-click="$ctrl.onSubmissionFailedBack()" type="button">\n\t\t\t\t\t\tBack\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<button class="secondary-action" data-cy="cis-suffered-failed-cancel" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\t\t\tCancel\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<submit-button display-text="\'Retry\'" state="cisSufferedFailedForm.state"></submit-button>\n\n\t\t\t\t</fieldset>\n\t\t\t</form>\n\t\t</section>\n</section>\n\n<!-- Deadline Passed -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="CIS suffered can no longer be submitted" ng-if="$ctrl.pageState === \'deadline-passed\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe deadline for submitting CIS deductions suffered was {{$ctrl.cisDeductionsObj.CISSubmissionDeadlineISO | dateformat}}.\n\t\t\tAny further deductions for the period {{$ctrl.payPeriod.$ctrl.payPeriodDisplay}} will have to be added in the following pay period.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Year End CIS deductions EA Alert -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Employment Allowance may be affected" fs-show-close="false" ng-if="$ctrl.pageState === \'alert\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe pay period you\'re about to add submit CIS deductions for relates to a different tax year to the current period.\n\t\t</p>\n\t\t<p class="is-small">\n\t\t\tIf the Employment Allowance settings for {{$root.currentCompany.Name}} have changed between the {{$ctrl.payPeriod.TaxYearDisplay}} tax year and the current period, for example because \'Auto-reclaim\' wasn\'t turned on, it could impact both your EPS and P32 reports.\n\t\t\tYou may need to adjust your \'Employer status\' settings before running.\n\t\t</p>\n\t\t<p class="is-small">\n\t\t\tClick \'Continue\' if you\'re happy that you\'ve added the correct Employment Allowance settings for the {{$ctrl.payPeriod.TaxYearDisplay}} tax year for {{$root.currentCompany.Name}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="$ctrl.setPageState(\'ready\')" type="button">\n\t\t\tContinue\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n\n');
$templateCache.put('forms/payroll/correctional-submission/correctional-submission.form.html','<div ng-switch="$ctrl.formState">\n\n\t<!-- Loading -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Select Tax Year -->\n\t<form class="fadeIn" name="correctionalSubmissionStep1" ng-submit="$ctrl.getTeamMemberPaymentsForTaxYear()" novalidate pc-switch-when="$ctrl.FORM_STATES.selectTaxYear">\n\t\t<div class="form-intro">\n\t\t\t<p class="is-small">\n\t\t\t\tChoose your tax year before entering your year to date updates. Then click \'Next\' to review your updates before confirming.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<header class="info-block-sub-heading" ng-if="$ctrl.isBulkUpdate" ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re adding an earlier year update for <b>{{::$ctrl.formOptions.userIds.length}} team members</b>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re submitting a Earlier Year FPS for <b>{{::$ctrl.formOptions.userIds.length}} team members</b>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="taxYear" class="required">Choose the tax year:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<select autofocus name="taxYear" id="taxYear" ng-model="$ctrl.taxYear" ng-options="taxYear as taxYear.TaxYearDisplay for taxYear in $ctrl.taxYears" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset class="form-actions">\n\n\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button button-id="primary-action" display-text="\'Next\'" state="correctionalSubmissionStep1.state" disable-button="!correctionalSubmissionStep1.$valid"></submit-button>\n\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Show payments -->\n\t<form class="fadeIn" name="correctionalSubmissionStep2" ng-submit="$ctrl.goToSummary()" novalidate pc-switch-when="$ctrl.FORM_STATES.showPayments">\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<header class="info-block-sub-heading" ng-if="$ctrl.isBulkUpdate" ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re adding an earlier year update for <b>{{::$ctrl.formOptions.userIds.length}} team members</b>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re submitting a Earlier Year FPS for <b>{{::$ctrl.formOptions.userIds.length}} team members</b>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{::$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- Controls -->\n\t\t\t<div class="form-field" ng-if="$ctrl.isBulkUpdate">\n\t\t\t\t<div class="navigation-arrows">\n\t\t\t\t\t<button aria-label="Go to previous team member" class="navigation-arrows__arrow is-white" data-cy="previous-team-member" ng-click="$ctrl.onChangeTeamMember()" ng-disabled="$ctrl.teamMemberIndex == 0" title="Previous team member" type="button">\n\t\t\t\t\t\t<i class="icon-chevron-left"></i>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<div class="navigation-arrows__page">\n\t\t\t\t\t\t{{$ctrl.teamMemberIndex+1}} of {{::$ctrl.team.length}}\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<button aria-label="Go to next team member" class="navigation-arrows__arrow is-white" data-cy="next-team-member" ng-click="$ctrl.onChangeTeamMember(true)" ng-disabled="!$ctrl.teamMember.isValid || $ctrl.teamMemberIndex == $ctrl.team.length-1" title="Next team member" type="button">\n\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="submission-table is-tight-layout" ng-class="{\n\t\t\t\t\t\t\'has-left-aligned-headers\': !$ctrl.isDifferenceColumnVisible,\n\t\t\t\t\t\t\'is-disabled\': $ctrl.teamMember.isSkipped,\n\t\t\t\t\t\t\'is-tertiary\': $ctrl.teamMember.IsIgnored\n\t\t\t\t\t}">\n\t\t\t\t\t<div class="submission-table_header" ng-if="$ctrl.isBulkUpdate">\n\t\t\t\t\t\t<avatar class="submission-table_avatar" avatar-initial="{{$ctrl.teamMember.Forename[0]}}" avatar-theme="{{ $ctrl.teamMember.IsIgnored ? \'is-tertiary\' : \'is-primary\' }}" avatar-size="is-medium" avatar-user-id="{{$ctrl.teamMember.UserID}}"></avatar>\n\n\t\t\t\t\t\t<div class="submission-table_name">\n\t\t\t\t\t\t\t<h5>{{$ctrl.teamMember.Forename}} <br>{{$ctrl.teamMember.Surname}}</h5>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="submission-table_skip fadeIn" ng-if="!$ctrl.teamMember.IsIgnored">\n\t\t\t\t\t\t\t<span class="toggle-d primary" ng-class="{\'active\' : $ctrl.teamMember.isSkipped}" ng-click="$ctrl.onSkipTeamMember()"></span>\n\n\t\t\t\t\t\t\t<span class="skip" ng-class="{\'skipped\' : $ctrl.teamMember.isSkipped}">Skip</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Note: Workplace postcode -->\n\t\t\t\t\t<div class="form-field" ng-if="$ctrl.teamMember.CanRequireWorkplacePostcode">\n\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Freeport and investment zone NI categories">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tYou may need to add a workplace postcode for {{$ctrl.teamMember.Forename}} if they have been on a freeport or investment zone NI category this tax year.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="submission-table_layout fadeIn">\n\n\t\t\t\t\t\t<!-- Not ignored -->\n\t\t\t\t\t\t<table ng-if="!$ctrl.teamMember.IsIgnored">\n\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th class="submission-table_cell is-label hidden-phone"></th>\n\n\t\t\t\t\t\t\t\t\t<th class="submission-table_cell is-header">\n\t\t\t\t\t\t\t\t\t\t{{::$ctrl.taxYear.TaxYearDisplay}}\n\t\t\t\t\t\t\t\t\t</th>\n\n\t\t\t\t\t\t\t\t\t<th class="submission-table_cell is-header">\n\t\t\t\t\t\t\t\t\t\tNew value\n\t\t\t\t\t\t\t\t\t</th>\n\n\t\t\t\t\t\t\t\t\t<th class="submission-table_cell is-header" ng-if="::$ctrl.isDifferenceColumnVisible">\n\t\t\t\t\t\t\t\t\t\tDifference\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t<!-- Main payments -->\n\t\t\t\t\t\t\t<tbody class="submission-table_section" ng-if="$ctrl.teamMember.payments">\n\t\t\t\t\t\t\t\t<tr class="fadeIn" correctional-submission-fieldset fieldset-id="main-payments" form="correctionalSubmissionStep2" is-difference-column-visible="$ctrl.isDifferenceColumnVisible" ng-repeat="payment in $ctrl.teamMember.payments" on-payment-change="$ctrl.onPaymentChange()" payment="payment" tax-year="$ctrl.taxYear" team-member="$ctrl.teamMember">\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t<!-- NI Payments -->\n\t\t\t\t\t\t\t<tbody class="submission-table_section" ng-if="$ctrl.teamMember.NICurrentEmployment" ng-repeat="(categoryIndex, category) in $ctrl.teamMember.NICurrentEmployment">\n\n\t\t\t\t\t\t\t\t<tr class="submission-table_full-row fadeIn">\n\n\t\t\t\t\t\t\t\t\t<td class="submission-table_cell is-label" colspan="{{$ctrl.isDifferenceColumnVisible ? 4 : 3}}">\n\t\t\t\t\t\t\t\t\t\t<div class="submission-table_sub-header">\n\n\t\t\t\t\t\t\t\t\t\t\t<div class="submission-table_sub-header-title">\n\t\t\t\t\t\t\t\t\t\t\t\t<h6 class="strong" ng-if="category.isNewCategory">Add NI category</h6>\n\t\t\t\t\t\t\t\t\t\t\t\t<h6 class="strong" ng-if="!category.isNewCategory">NI category: {{:: category.NICode}}</h6>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<!-- Delete NI letter -->\n\t\t\t\t\t\t\t\t\t\t\t<div class="submission-table_sub-header-action" ng-if="category.CanBeDeleted && $ctrl.teamMember.NICurrentEmployment.length > 1">\n\t\t\t\t\t\t\t\t\t\t\t\t<a aria-label="Delete NI category" class="strong" data-cy="delete-ni-category-{{categoryIndex}}" href ng-click="$ctrl.onDeleteNICategory(categoryIndex)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-trash m"></i> Delete\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t<!-- Only new categories can change NI Letter -->\n\t\t\t\t\t\t\t\t<tr class="fadeIn" ng-if="category.CanBeDeleted">\n\t\t\t\t\t\t\t\t\t<td class="submission-table_cell is-label">\n\t\t\t\t\t\t\t\t\t\t<label for="ni-category-{{categoryIndex}}-NICode" class="strong required">\n\t\t\t\t\t\t\t\t\t\t\tNI category:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t<td class="submission-table_cell is-field" colspan="2" data-fieldname="New category">\n\t\t\t\t\t\t\t\t\t\t<select id="ni-category-{{categoryIndex}}-NICode" name="ni-category-{{categoryIndex}}-NICode" ng-model="category.NICode" ng-options="niLetter as niLetter for niLetter in $ctrl.niCategoryLetters |\n\t\t\t\t\t\t\t\t\t\t\t\tremoveUsedItemsById :\n\t\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.teamMember.NICurrentEmployment :\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'NICode\' :\n\t\t\t\t\t\t\t\t\t\t\t\t\tcategory.NICode" required>\n\t\t\t\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t<!-- Payments -->\n\t\t\t\t\t\t\t\t<tr class="fadeIn" correctional-submission-fieldset form="correctionalSubmissionStep2" fieldset-id="ni-category-{{categoryIndex}}-{{$index}}" is-difference-column-visible="$ctrl.isDifferenceColumnVisible" ng-repeat="payment in category.payments" on-payment-change="$ctrl.onPaymentChange()" payment="payment" tax-year="$ctrl.taxYear" team-member="$ctrl.teamMember">\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t<!-- Add NI category -->\n\t\t\t\t\t\t\t<tbody class="submission-table_section fadeIn" ng-if="$ctrl.teamMember.NICurrentEmployment.length < $root.CONFIG.maxCountOfNILetterCodeCorrectionalUpdates">\n\t\t\t\t\t\t\t\t<tr class="submission-table_full-row">\n\t\t\t\t\t\t\t\t\t<td class="submission-table_cell" colspan="{{$ctrl.isDifferenceColumnVisible ? 4 : 3}}">\n\t\t\t\t\t\t\t\t\t\t<button class="is-medium-large is-white is-primary-100 is-block" data-cy="add-ni-category" ng-click="$ctrl.onAddNICategory()" type="button">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Add NI category\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t<!-- Additional payments -->\n\t\t\t\t\t\t\t<tbody class="submission-table_section" ng-if="$ctrl.teamMember.additionalPayments">\n\t\t\t\t\t\t\t\t<tr class="fadeIn" correctional-submission-fieldset form="correctionalSubmissionStep2" fieldset-id="additional-payments" is-difference-column-visible="$ctrl.isDifferenceColumnVisible" ng-repeat="payment in $ctrl.teamMember.additionalPayments" on-payment-change="$ctrl.onPaymentChange()" payment="payment" tax-year="$ctrl.taxYear" team-member="$ctrl.teamMember">\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t</table>\n\n\t\t\t\t\t\t<!-- Ignored -->\n\t\t\t\t\t\t<div class="submission-table_warning fadeIn" ng-if="$ctrl.teamMember.IsIgnored">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<h5>{{$ctrl.teamMember.Forename}} will be ignored in this update</h5>\n\t\t\t\t\t\t\t\t<p class="is-small">{{$ctrl.teamMember.ignoredMessage.detailed}}</p>\n\t\t\t\t\t\t\t\t<p class="is-small" ng-if="$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.earlierYearUpdate">Read more on earlier year updates</support-article-link>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.selectTaxYear)" type="button">\n\t\t\t\tGo back\n\t\t\t</button>\n\n\t\t\t<submit-button button-id="primary-action" disable-button="!$ctrl.formValid || !correctionalSubmissionStep2.$valid" display-text="\'Next\'" state="correctionalSubmissionStep2.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Summary of changes -->\n\t<form class="fadeIn" name="correctionalSubmissionStep3" ng-submit="$ctrl.onConfirmSubmission(correctionalSubmissionStep3)" novalidate pc-switch-when="$ctrl.FORM_STATES.summary">\n\t\t<div class="form-section">\n\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="is-tertiary is-form-field" note-title="Submitting information to HMRC">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t\t\t<p pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t\tBy clicking \'Confirm update\', you are agreeing to update {{$ctrl.teamSummary.updated.length > 1 ? $ctrl.teamSummary.updated.length + \' team members\\\'\' : $ctrl.teamSummary.updated[0].Forename + \'\\\'s\'}} records with HMRC.\n\t\t\t\t\t\t\tYou are also agreeing to refund any overpaid National Insurance contributions that may be due as a result of this update.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\t\t\tBy clicking \'Confirm submission\', you are agreeing to changing {{$ctrl.teamSummary.updated.length > 1 ? $ctrl.teamSummary.updated.length + \' team members\\\'\' : $ctrl.teamSummary.updated[0].Forename + \'\\\'s\'}} history with HMRC.\n\t\t\t\t\t\t\tYou are also agreeing to refund any overpaid National Insurance contributions that may be due as a result of this update.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t<ib-main>\n\t\t\t\t\t<header class="info-block-sub-heading" ng-if="$ctrl.isBulkUpdate" ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re adding an earlier year update for <b>{{$ctrl.teamSummary.updated.length}} team members</b>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\t\t\t<i class="icon-team-alt is-primary is-large has-margin-right"></i> You\'re submitting a Earlier Year FPS for <b>{{$ctrl.teamSummary.updated.length}} team members</b>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</header>\n\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</h6>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\tIf you\'re happy with everything, click \'Confirm update\' to submit your earlier year update to HMRC.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\tIf you\'re happy with everything, click \'Confirm submission\' to submit your Earlier Year FPS to HMRC.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-section" ng-if="$ctrl.isBulkUpdate">\n\t\t\t<navigation-tabs class="pay-statement-tabs">\n\t\t\t\t<a href="" data-cy="tab-updated" ng-class="{\'active\': $ctrl.summaryView == $ctrl.SUMMARY_VIEWS.updated }" ng-click="$ctrl.setSummaryView($ctrl.SUMMARY_VIEWS.updated)"><ng-pluralize count="$ctrl.teamSummary.updated.length" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize> to submit</a>\n\t\t\t\t<a href="" data-cy="tab-ignored" ng-class="{\'active\': $ctrl.summaryView == $ctrl.SUMMARY_VIEWS.ignored }" ng-click="$ctrl.setSummaryView($ctrl.SUMMARY_VIEWS.ignored)">{{$ctrl.teamSummary.ignored.length}} ignored</a>\n\t\t\t\t<a href="" data-cy="tab-skipped" ng-class="{\'active\': $ctrl.summaryView == $ctrl.SUMMARY_VIEWS.skipped }" ng-click="$ctrl.setSummaryView($ctrl.SUMMARY_VIEWS.skipped)">{{$ctrl.teamSummary.skipped.length}} skipped</a>\n\t\t\t</navigation-tabs>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch="$ctrl.summaryView">\n\n\t\t\t<!-- Updated -->\n\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.SUMMARY_VIEWS.updated">\n\t\t\t\t<div class="team-summary-row_wrapper">\n\n\t\t\t\t\t<team-summary-row index="teamMemberIndex" ng-repeat="(teamMemberIndex, teamMember) in $ctrl.teamSummary.updated" show-footer="teamMember.isDetailsVisible" show-content="$ctrl.isBulkUpdate" team-member="teamMember" theme="is-primary">\n\t\t\t\t\t\t<tsr-actions ng-if="$ctrl.teamSummary.updated.length > 1">\n\t\t\t\t\t\t\t<button class="is-white" data-cy="toggle-details-{{teamMemberIndex}}" ng-click="$ctrl.onTeamMemberDetailsToggle(teamMember)" type="button">\n\t\t\t\t\t\t\t\t{{teamMember.isDetailsVisible ? \'Hide\' : \'Show\'}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</tsr-actions>\n\n\t\t\t\t\t\t<tsr-footer>\n\n\t\t\t\t\t\t\t<div class="pay-statement">\n\n\t\t\t\t\t\t\t\t<div class="pay-statement-section has-no-border-for-only-child" ng-repeat="(paymentGroupIndex, paymentGroup) in teamMember.updatedPaymentGroups" data-cy="team-member-{{::teamMemberIndex}}-group-{{::paymentGroupIndex}}">\n\t\t\t\t\t\t\t\t\t<div class="pay-statement-section-title" ng-if="paymentGroup.title">\n\t\t\t\t\t\t\t\t\t\t<h6>{{::paymentGroup.title}}</h6>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="pay-statement-item" ng-repeat="(paymentIndex, payment) in paymentGroup.payments">\n\t\t\t\t\t\t\t\t\t\t<span class="pay-statement-label" data-cy="team-member-{{::teamMemberIndex}}-group-{{::paymentGroupIndex}}-payment-{{::paymentIndex}}-label">{{payment.paymentLabel}}</span>\n\n\t\t\t\t\t\t\t\t\t\t<span class="pay-statement-value" ng-if="!$ctrl.isDifferenceColumnVisible">{{:: payment.paymentNewAmountInteger | number: 2}}</span>\n\n\t\t\t\t\t\t\t\t\t\t<span class="pay-statement-value" ng-if="$ctrl.isDifferenceColumnVisible">\n\t\t\t\t\t\t\t\t\t\t\t<span data-cy="team-member-{{::teamMemberIndex}}-group-{{::paymentGroupIndex}}-payment-{{::paymentIndex}}-difference-value" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-font-secondary-300\': payment.paymentIsIncrease,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-font-quinary-300\': payment.paymentIsDecrease\n\t\t\t\t\t\t\t\t\t\t\t\t}">{{::payment.paymentDifferenceLabel}}</span>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</tsr-footer>\n\t\t\t\t\t</team-summary-row>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Ignored -->\n\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.SUMMARY_VIEWS.ignored">\n\t\t\t\t<p class="caption" ng-if="$ctrl.teamSummary.ignored.length === 0">\n\t\t\t\t\tNo team members have been ignored in this update.\n\t\t\t\t</p>\n\n\t\t\t\t<div class="team-summary-row_wrapper" ng-if="$ctrl.teamSummary.ignored.length > 0">\n\n\t\t\t\t\t<team-summary-row index="teamMemberIndex" ng-repeat="(teamMemberIndex, teamMember) in $ctrl.teamSummary.ignored" team-member="teamMember" theme="is-tertiary">\n\t\t\t\t\t\t<tsr-actions>\n\t\t\t\t\t\t\t<span class="is-small">{{teamMember.ignoredMessage.summary}}</span>\n\t\t\t\t\t\t</tsr-actions>\n\t\t\t\t\t</team-summary-row>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Skipped -->\n\t\t\t<div class="fadeIn" pc-switch-when="$ctrl.SUMMARY_VIEWS.skipped">\n\n\t\t\t\t<p class="caption" ng-if="$ctrl.teamSummary.skipped.length === 0">\n\t\t\t\t\tNo team members have been skipped in this update.\n\t\t\t\t</p>\n\n\t\t\t\t<div class="team-summary-row_wrapper" ng-if="$ctrl.teamSummary.skipped.length > 0">\n\n\t\t\t\t\t<team-summary-row index="teamMemberIndex" ng-repeat="(teamMemberIndex, teamMember) in $ctrl.teamSummary.skipped" team-member="teamMember" theme="is-primary">\n\t\t\t\t\t\t<tsr-actions>\n\t\t\t\t\t\t\t<span class="is-small">Skipped</span>\n\t\t\t\t\t\t</tsr-actions>\n\t\t\t\t\t</team-summary-row>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.showPayments)" type="button">\n\t\t\t\tGo back\n\t\t\t</button>\n\n\t\t\t<submit-button button-id="primary-action" disable-button="!correctionalSubmissionStep3.$valid" display-text="$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU ? \'Confirm update\' : \'Confirm submission\'" state="correctionalSubmissionStep3.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Submitting -->\n\t<section class="form-summary fadeIn" pc-switch-when="$ctrl.FORM_STATES.submitting">\n\t\t<loading-block size="m">\n\t\t\t<lb-description>\n\t\t\t\t{{$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU ? \'Submitting earlier year update...\' : \'Submitting Earlier Year FPS...\'}}\n\t\t\t</lb-description>\n\t\t</loading-block>\n\t\t<section class="form-summary-section align-center">\n\t\t\t<p class="is-small">\n\t\t\t\tPlease don\'t close this window while your update is submitting.\n\t\t\t\tThis can take a few moments, and will update as soon as it\'s complete.\n\t\t\t</p>\n\t\t</section>\n\t</section>\n\n\t<!-- Submitted - EYU -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.submittedEYU">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Earlier year update submitted">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.teamSummary.updated.length > 1">\n\t\t\t\t\tYour earlier year update has been submitted for {{$ctrl.teamSummary.updated.length}} team members and their history with HMRC has been changed.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.teamSummary.updated.length === 1">\n\t\t\t\t\tYour earlier year update has been submitted and {{$ctrl.teamSummary.updated[0].Forename}}\'s history with HMRC has been changed.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Submitted - YTD FPS -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.submittedYTDFPS">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Earlier Year FPS submitted">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.isBulkUpdate">\n\t\t\t\t\tYour Earlier Year FPS for {{:: $ctrl.teamSummary.updated.length}} team members has been submitted to HMRC and your Earlier Year FPS report for\n\t\t\t\t\t<a href="" class="primary underline" ui-sref="payroll.pay-period({agencyProfileId: $ctrl.formOptions.agencyProfileId, payPeriodId: $ctrl.taxYear.PayPeriodID})">{{:: $ctrl.taxYear.PayPeriodDisplay}}</a> is available in your payroll history.\n\t\t\t\t</p>\n\n\t\t\t\t<p class="is-small" ng-if="!$ctrl.isBulkUpdate">\n\t\t\t\t\tYour Earlier Year FPS for {{:: $ctrl.teamSummary.updated[0].Forename}} has been submitted to HMRC and your Earlier Year FPS report for\n\t\t\t\t\t<a href="" class="primary underline" ui-sref="payroll.pay-period({agencyProfileId: $ctrl.formOptions.agencyProfileId, payPeriodId: $ctrl.taxYear.PayPeriodID})">{{:: $ctrl.taxYear.PayPeriodDisplay}}</a> is available in your payroll history.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Not enough history for EYU -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.notEnoughHistoryEYU">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Cannot submit earlier year update">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that your earlier year update cannot be submitted due to one of the following reasons:\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'Earlier year updates cannot be submitted after the 2019-2020 tax year. Please try to submit a Earlier Year FPS instead.\',\n\t\t\t\t\t\t\t\'A team member must have at least one full tax year\\\'s history saved in Paycircle.\'\n\t\t\t\t\t\t]" bl-theme="is-small"></bullet-list>\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Employment allowance warning -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.previousTaxYear">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Employment Allowance may be affected">\n\t\t\t<fs-main ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\tYou\'re about to submit an Earlier Year Update to correct a previous tax year.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\tYou\'re about to submit an Earlier Year FPS to correct a previous tax year.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf the Employment Allowance settings for {{$ctrl.formOptions.company.Name}} have changed between the tax year you wish to correct and the current period, for example because \'Auto-reclaim\' wasn\'t turned on, it could impact both your EPS and P32 reports. You may need to adjust your \'Employer status\' settings before running.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Continue\' if you\'re happy that you\'ve added the correct Employment Allowance settings for the tax year you\'re correcting for {{$ctrl.formOptions.company.Name}}.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\n\t\t\t\t<button class="primary-action is-tertiary" data-cy="primary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.selectTaxYear)" type="button">\n\t\t\t\t\tContinue\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Not enough history for YTD FPS -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.notEnoughHistoryYTDFPS">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Cannot submit Earlier Year FPS">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that your Earlier Year FPS cannot be submitted due to one of the following reasons:\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'Earlier Year FPS\\\' cannot be submitted before the 2018-2019 tax year. Please try to submit an earlier year update instead.\',\n\t\t\t\t\t\t\t\'A team member must have at least one full tax year\\\'s history saved in Paycircle.\'\n\t\t\t\t\t\t]" bl-theme="is-small"></bullet-list>\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- All team members ignored -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.allIgnored">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="primary less-margin" fs-title="All team members have been ignored">\n\t\t\t<fs-preheader>\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</fs-preheader>\n\n\t\t\t<fs-main>\n\t\t\t\t<div ng-switch="$ctrl.formOptions.correctionalSubmissionType">\n\t\t\t\t\t<div pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t\t<p class="is-small">All team members will be ignored from this earlier year update due to one of the following reasons:</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Earlier year updates cannot be submitted after the \' + $ctrl.taxYear.TaxYearDisplay + \' tax year. Please try to submit a Earlier Year FPS instead.\',\n\t\t\t\t\t\t\t\t\t\'A team member must have at least one full tax year\\\'s history saved in Paycircle.\',\n\t\t\t\t\t\t\t\t\t\'The selected team member\\\'s profile is incomplete.\',\n\t\t\t\t\t\t\t\t\t\'The selected team member is a subcontractor under the Construction Industry Scheme (CIS).\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-small"></bullet-list>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.earlierYearUpdate">Read more about earlier year updates</support-article-link>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div pc-switch-when="$ctrl.CORRECTIONAL_SUBMISSION_TYPES.YTDFPS">\n\t\t\t\t\t\t<p class="is-small">All team members will be ignored from this submission due to one of the following reasons:</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Earlier Year FPS\\\' cannot be submitted before the \' + $ctrl.taxYear.TaxYearDisplay + \' tax year. Please try to submit an earlier year update instead.\',\n\t\t\t\t\t\t\t\t\t\'A team member must have at least one full tax year\\\'s history saved in Paycircle.\',\n\t\t\t\t\t\t\t\t\t\'The selected  team member\\\'s profile is incomplete.\',\n\t\t\t\t\t\t\t\t\t\'The selected team member is a subcontractor under the Construction Industry Scheme (CIS).\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-small"></bullet-list>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- All team members skipped -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.allSkipped">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary less-margin" fs-title="All team members have been skipped">\n\t\t\t<fs-preheader>\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</fs-preheader>\n\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou\'ve chosen to skip all selected team members which means there\'s nothing to submit to HMRC.\n\t\t\t\t\t<support-article-link ng-if="$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU" article-key="$root.URLS.paycircle.support.earlierYearUpdate">Read more about earlier year updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.showPayments)" type="button">\n\t\t\t\t\tGo back\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- All team members skipped & ignored -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.allSkippedAndIgnored">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary less-margin" fs-title="No team members to submit">\n\t\t\t<fs-preheader>\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</fs-preheader>\n\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tAll team members in this update have either been skipped or will be ignored which means there\'s nothing to submit to HMRC.\n\t\t\t\t\t<support-article-link ng-if="$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU" article-key="$root.URLS.paycircle.support.earlierYearUpdate">Read more about earlier year updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.showPayments)" type="button">\n\t\t\t\t\tGo back\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Cant update team member -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.cantUpdateTeamMember">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="primary less-margin" fs-title="{{$ctrl.teamMember.Forename}} can\'t be updated for the selected tax year">\n\t\t\t<fs-preheader ng-if="$ctrl.teamMember.IsLeaver || $ctrl.teamMember.IsStarter">\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</fs-preheader>\n\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">{{$ctrl.teamMember.ignoredMessage.detailed}}</p>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.formOptions.correctionalSubmissionType === $ctrl.CORRECTIONAL_SUBMISSION_TYPES.EYU">\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.earlierYearUpdate">Read more on earlier year updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Submission failed -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.submissionFailed">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary less-margin" fs-title="There seems to be a problem with your update">\n\t\t\t<fs-preheader>\n\t\t\t\t<info-block ib-theme="is-white has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary is-large has-margin-right"></i> Tax year {{$ctrl.taxYear.TaxYearDisplay}}\n\n\t\t\t\t\t\t\t<a aria-label="Go to select tax year" class="float-right" data-cy="select-tax-year" href ng-click="$ctrl.onTaxYearEdit()">\n\t\t\t\t\t\t\t\t<i class="icon-edit m"></i> Edit\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</fs-preheader>\n\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis may be because we\'re unable to match a team member at HMRC or there\'s a general problem with HMRC\'s systems. Click \'Go back\' and try again in a few moments.\n\t\t\t\t\tIf you continue to experience the same problem please contact support.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t<b>Please note:</b> the figures you\'ve entered for your team members have been saved so if you need to come back later, to try making the update again, you won\'t have to re-enter them.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="$ctrl.getTeamMemberPaymentsForTaxYear()" type="button">\n\t\t\t\t\tGo back\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Error -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FORM_STATES.error">\n\t\t<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\t</div>\n</div>\n');
$templateCache.put('forms/payroll/delete-supplementary-pay-run/delete-supplementary-pay-run.form.html','<form class="fadeIn" name="deleteSupplementaryPayRunForm" ng-submit="$ctrl.deleteSupplementaryPayRun($ctrl, deleteSupplementaryPayRunForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this pay run?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThis will remove the run from your Supplementary pay runs page and delete your draft reports. Click &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!deleteSupplementaryPayRunForm.$valid" display-text="\'Confirm\'" state="deleteSupplementaryPayRunForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/deleteChange/deleteChangeForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this change?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">This will delete the {{formOptions.adjustmentObj.Description}} ({{formOptions.adjustmentObj.Value | monetise}}) change for {{formOptions.context.Forename}}. This can\'t be undone and you will have to add it again if you decide you need it later.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" ng-click="formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t<button class="tertiary primary-action" ng-click="deleteAdjustment(formOptions.adjustmentObj)">Delete</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Change deleted" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}\'s change has been deleted.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/bureauDeleteCompany/bureauDeleteCompanyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">This will delete <span class="stronger">{{company.Name}}</span> from your Onboarding page and remove all their data from the system. We\u2019ll also send an email to <span class="stronger">{{company.AdminEmail}}</span> to confirm that we no longer hold any of their data in line with GDPR regulations. <a href="{{$root.URLS.paycircle.website.privacy}}" target="_blank" class="underline">More info on how we manage data in Paycircle</a>.</p>\n\t\t<p class="s"><b>Please note:</b> once you delete {{company.Name}}, it cannot be undone and they will need to created again and their data added from scratch.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button ng-click="deleteCompany(company, vm)" display-text="\'Delete company\'" state="vm.state"></submit-button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="{{company.Name}} has been deleted" ng-if="pageState === \'deleted\'">\n\t<fs-main>\n\t\t<p class="s">An email was sent to <span class="stronger">{{company.AdminEmail}}</span> to let them know that their company has been deleted from Paycircle and longer no hold any of their data in line with GDPR regulations.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/onboarding/bureauChangeCompanyState/bureauChangeCompanyStateForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-switch="formOptions.newCompanyState">\n\n\n\t<!-- Demo -> Onboarding -->\n\t<div pc-switch-when="COMPANY_STATES.onboarding">\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\tOnce you\u2019ve moved {{formOptions.company.Name}} to \u2018onboarding\u2019, they can then start adding onboarding data and monitoring their progress on their <a ui-sref="company-dashboard({agencyProfileId: formOptions.company.AgencyProfileID})">onboarding dashboard</a>. You can also view their <a href ng-click="openOnboardingChecklistForm()">onboarding checklist</a> for a quick overview of how they\u2019re getting on.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tAny company admins will now see their onboarding dashboard the next time they sign in.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t\t<button class="primary-action tertiary" ng-click="updateCompanyState(formOptions.company)">Move to onboarding</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Moved to onboarding" ng-if="pageState === \'saved\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\t{{formOptions.company.Name}} has been moved to \u2018onboarding\u2019.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Onboarding -> First period -->\n\t<div pc-switch-when="COMPANY_STATES.firstPeriod">\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Not ready to move to first pay period" ng-if="pageState === \'disabled\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\t{{formOptions.company.Name}} cannot be moved to the first pay period yet. There are still onboarding actions to complete prior to {{formOptions.company.Name}} running the first pay period. To see what information is outstanding,  <a href="" ng-click="openOnboardingChecklistForm(formOptions.company)">view their onboarding checklist here</a>.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tTo add information on behalf of {{formOptions.company.Name}}, you can head to their <a ui-sref="company-dashboard({agencyProfileId: formOptions.company.AgencyProfileID})">onboarding dashboard</a>.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Are you sure?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\tOnce you\u2019ve moved {{formOptions.company.Name}} to their first pay period, their final onboarding tasks can be completed. Any company admins will now see their first pay period dashboard the next time they sign in.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" type="button" ng-click="formOptions.closeForm()">Cancel</button>\n\t\t\t\t<button class="primary-action tertiary" ng-click="updateCompanyState(formOptions.company)">Move to first pay period</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Moved to first pay period" ng-if="pageState === \'saved\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\t{{formOptions.company.Name}} has been moved to their first pay period.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- First period -> Ready to run -->\n\t<div pc-switch-when="COMPANY_STATES.readyToRun">\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Can\u2019t mark \u2018Ready to run\u2019 yet" ng-if="pageState === \'disabled\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\t{{formOptions.company.Name}} can\u2019t be marked as \u2018Ready to run\u2019 yet. There are still onboarding actions to complete prior to {{formOptions.company.Name}} running the first pay period. If you want to see which information is outstanding you can head to their first pay period dashboard.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tTo see what still needs to be completed, you can <a ui-sref="company-dashboard({agencyProfileId: formOptions.company.AgencyProfileID})">head to their first pay period dashboard</a>.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-title="Mark as \u2018Ready to run\u2019?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIt isn\u2019t necessary to mark {{formOptions.company.Name}}  as \u2018Ready to run\u2019 but you may wish to confirm, for your own peace of mind, that they\u2019re ready to run their first pay period. Their first pay period can be run regardless and this won\u2019t affect what any company admins see when they sign in.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" type="button" ng-click="formOptions.closeForm()">Cancel</button>\n\t\t\t\t<button class="primary-action tertiary" ng-click="updateCompanyState(formOptions.company)">Mark as \u2018Ready to run\u2019?</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Marked as \u2018Ready to run\u2019" ng-if="pageState === \'saved\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">\n\t\t\t\t\t{{formOptions.company.Name}} has been marked as \u2018Ready to run\u2019.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/deletePayrollAlert/deletePayrollAlertForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure you want to dismiss this alert?" fs-show-close="false" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">Once this alert has been dismissed, you won\u2019t be able to view it in the alerts tab again. It will still be included in the alert report download.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="deletePayrollAlert()">Dismiss</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/deletePeriodNote/deletePeriodNoteForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" fs-show-close="false" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">Once this note is deleted, you won\u2019t be able to retrieve it and it will need to be added again. If you\u2019re happy that it hasn\u2019t already been actioned, click \u2018Delete\u2019 below.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="deletePeriodNote()">Delete</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/deletePeriodTask/deletePeriodTaskForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" fs-show-close="false" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="s">Once this task is deleted, you won\u2019t be able to retrieve it and it will need to be added again. It will also be removed from the assignee\u2019s personal task list.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="deletePeriodTask()">Delete</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/editHolidayPolicy/editHolidayPolicyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="editHolidayPolicyForm" ng-submit="saveForm(form, editHolidayPolicyForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tAdjust {{formOptions.context.Forename}}\u2019s holiday policy settings below and any changes you make will only be saved for {{formOptions.context.Gender | personalise:\'him\'}}.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">Read more about holiday and sickness policies.</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Holiday -->\n\t\t<section class="form-section">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Holiday policy</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Total holiday days and rollover days -->\n\t\t\t<div class="form-field-group">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="policyDescription" class="required">Total holiday:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<number-picker ng-model="holidaySickness.HolidayDays" field-name="policyToda" heading="days" figure-type="\'\'" step="1" min="1" max="100"></number-picker>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="policyDescription" class="required">Rollover days:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<number-picker ng-model="holidaySickness.RolloverDays" heading="days" figure-type="\'\'" step="1" min="0" max="100"></number-picker>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Includes bank holidays -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="checkbox" id="policyBankHolidays" name="policyBankHolidays" ng-model="holidaySickness.IncludeBankHolidays" label-text="\'This includes bank holidays\'" checkbox>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t</fieldset>\n\n\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="editHolidayPolicyForm.state" disable-button="!editHolidayPolicyForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{formOptions.context.Forename}}\u2019s holiday policy has been updated" ng-if="pageState === \'saved-policy\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">To find out more about tracking holiday and sickness, read our\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">guide to holiday and sickness policies</support-article-link>.</p>\n\t\t<p class="s strong"><br><a href="" class="strong" ng-click="closeForm()">Ok, close this window</a></p>\n\t</fs-main>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/editPayNotificationDate/editPayNotificationDateForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="editPayNotificationDateForm" ng-if="pageState === \'ready\'" ng-submit="updatePayNotificationDate(editPayNotificationDateForm, vm.payPeriod, vm)" novalidate>\n\t<!-- Choose a day or notify immediately -->\n\t<fieldset>\n\t\t<toggle-buttons id="chooseDate" true-label="\'Choose a day\'" label="\'When would you like to let employees know they\\\'ve been paid?\'" false-label="\'Notify immediately\'" ng-model="vm.chooseDate"></toggle-buttons>\n\t</fieldset>\n\n\t<!-- Select a date (applicable when \'Choose a day\' option is selected)-->\n\t<fieldset ng-if="vm.chooseDate">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="payslipNotificationDate">Pay notification date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="payslipNotificationDate" field-max-date-iso="vm.payPeriod.payslipDateMaximumISO" field-min-date-iso="vm.payPeriod.payslipDateMinimumISO" field-value-iso="vm.payPeriod.PayslipDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="editPayNotificationDateForm.payslipNotificationDate.$touched" ng-messages="editPayNotificationDateForm.payslipNotificationDate.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a pay notification date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="max">Please enter a date up to {{vm.payPeriod.payslipDateMaximumISO | dateformat}}</p>\n\t\t\t\t<p ng-message="min">Please enter a date from {{vm.payPeriod.payslipDateMinimumISO | dateformat}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" disable-button="!editPayNotificationDateForm.$valid" state="editPayNotificationDateForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/editRepaymentScheduleFixedForPeriod/editRepaymentScheduleFixedForPeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Save Schedule -->\n<form name="editRepaymentScheduleFixedForPeriodForm" class="fadeIn" ng-submit="updatePaymentScheduleValue(vm, editRepaymentScheduleFixedForPeriodForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">This deduction is part of a repayment schedule for {{formOptions.context.Forename}}:</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-section">\n\t\t\t<repayment-card repayment="vm.paymentScheduleGroup" rc-theme="is-quarternary" rc-view-type="payment"></repayment-card>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Scheduled Deduction -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="scheduledDeduction" class="not-clickable">Scheduled deduction</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="text-display assertive">-{{::vm.paymentScheduleGroup.ValueForCurrentPeriod | monetise}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- New Deduction -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="newDeductionAmount" class="required">New deduction:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input id="newDeductionAmount" name="newDeductionAmount" type="number" class="monetise" ng-model="vm.paymentScheduleGroup.ValueForCurrentPeriod" ng-min="0" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="editRepaymentScheduleFixedForPeriodForm.newDeductionAmount.$error" ng-if="editRepaymentScheduleFixedForPeriodForm.newDeductionAmount.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a positive amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<p class="s">To stop these payments altogether, go to {{formOptions.context.Forename}}&apos;s profile and open {{formOptions.context.Gender | personalise:\'his\'}} childcare schedule. You can then click \'Stop payments\'.</p>\n\t\t</div>\n\n\t\t<div class="form-section" ng-show="vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension.length > 0">\n\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t\t<button type="button" class="is-clear detail-blocks-toggle clickable is-secondary no-padding-bottom" ng-class="{\'active\' : vm.showPensionSchemes}" ng-click="vm.showPensionSchemes = !vm.showPensionSchemes">\n\t\t\t\t\t\t<div class="detail-block-toggle-dot">\n\t\t\t\t\t\t\t<icon-dot icon="icon-money" theme="is-secondary"></icon-dot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t\tPensionable for <ng-pluralize count="vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension.length" when="{\'1\': \'1 scheme\', \'other\': \'{} schemes\'}"></ng-pluralize>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t\t<i class="icon-chevron-up is-secondary"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : vm.showPensionSchemes}">\n\n\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t<tr ng-repeat="scheme in vm.paymentScheduleGroup.filteredPaymentScheduleGroupPension = ( vm.paymentScheduleGroup.PaymentScheduleGroupPension | filter: { PaymentScheduleGroupPensionState: true } )">\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale-dark is-small">{{::scheme.PensionProviderName}}</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small">({{::scheme.EmployerReference}})</span>\n\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t<td class="float-right" ng-switch="scheme.PaymentScheduleGroupPensionBehaviourAttributes">\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.both">Employee and Employer</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee">Employee only</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer">Employer only</span>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" disable-button="!editRepaymentScheduleFixedForPeriodForm.$valid" state="editRepaymentScheduleFixedForPeriodForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/editRepaymentScheduleForPeriod/editRepaymentScheduleForPeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Save Schedule -->\n<form name="recalculateRepaymentScheduleForm" class="fadeIn" ng-submit="saveRecalculatedRepaymentSchedule(paymentSchedule, recalculateRepaymentScheduleForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">This deduction is part of a repayment schedule for {{formOptions.context.Forename}}:</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-section">\n\t\t\t<repayment-card repayment="paymentSchedule"></repayment-card>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<p class="s">If you wish to update it for this pay period, add a new deduction amount and click \'Recalculate\' to see how it will affect the repayment schedule. You can then save the new repayment schedule.</p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<div class="form-field-group">\n\n\t\t\t\t<!-- Scheduled Deduction -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="scheduledDeduction" class="not-clickable">Scheduled deduction</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="text-display assertive">-{{::paymentSchedule.nextPayment.ScheduleValue | monetise}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- New Deduction -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="newDeductionAmount" class="required">New deduction:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input id="newDeductionAmount" name="newDeductionAmount" type="number" class="monetise" ng-model="paymentSchedule.newDeductionAmount" ng-max="paymentSchedule.TotalAmountRemaining" ng-min="0" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="recalculateRepaymentScheduleForm.newDeductionAmount.$error" ng-if="recalculateRepaymentScheduleForm.newDeductionAmount.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="max">This exceeds the amount still to pay</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a positive amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Re-calculate -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header hidden-phone">\n\t\t\t\t\t\t<label class="not-clickable">&nbsp;</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<a href="" ng-click="recalculateRepaymentSchedule(paymentSchedule, recalculateRepaymentScheduleForm)" class="button primary block" ng-class="{\'disabled\': !recalculateRepaymentScheduleForm.$valid || paymentSchedule.recalculationState === \'recalculating\'}"><i class="icon-loading m" ng-class="{\'spin\': paymentSchedule.recalculationState === \'recalculating\'}"></i>&nbsp;&nbsp;Recalculate</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch="paymentSchedule.deductionType" ng-if="!paymentSchedule.recalculationState && paymentSchedule.newDeductionAmount === \'\'">\n\t\t\t<p class="s" pc-switch-when="LOAN_DEDUCTION_TYPES.FIXED">This is based on a fixed deduction each pay period of {{paymentSchedule.FixedRepaymentAmount | monetise}}, starting in {{paymentSchedule.FirstPayPeriodDisplay}}.</p>\n\t\t\t<p class="s" pc-switch-when="LOAN_DEDUCTION_TYPES.SPLIT">This is based on a split deduction over&nbsp;<ng-pluralize count="paymentSchedule.PeriodRepaymentCount" when="{\'1\': \'1 pay period\', \'other\': \'{} pay periods\'}"></ng-pluralize>, starting in {{paymentSchedule.FirstPayPeriodDisplay}}.</p>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch="paymentSchedule.recalculationState">\n\t\t\t<div class="fadeIn" ng-switch-when="recalculating">\n\t\t\t\t<loading-block></loading-block>\n\t\t\t</div>\n\t\t\t<table class="primary payments-table fadeIn" ng-switch-default>\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t\t<th>Deduction</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr class="payments-table-repaid" ng-if="paymentSchedule.TotalBroughtForward > 0">\n\t\t\t\t\t\t<td>Previous</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag assertive">Paid</span>\n\t\t\t\t\t\t\t<strong class="payments-table-amount is-deduction">{{paymentSchedule.TotalBroughtForward | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr ng-repeat="payment in paymentSchedule.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag assertive" ng-if="payment.IsPaid">Paid</span>\n\t\t\t\t\t\t\t<strong class="payments-table-amount is-deduction">-{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class="form-section" ng-show="paymentSchedule.filteredPaymentScheduleGroupPension.length > 0">\n\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t\t<button type="button" class="is-clear detail-blocks-toggle clickable is-secondary no-padding-bottom" ng-class="{\'active\' : showPensionSchemes}" ng-click="showPensionSchemes = !showPensionSchemes">\n\t\t\t\t\t\t<div class="detail-block-toggle-dot">\n\t\t\t\t\t\t\t<icon-dot icon="icon-money" theme="is-secondary"></icon-dot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t\tPensionable for <ng-pluralize count="paymentSchedule.filteredPaymentScheduleGroupPension.length" when="{\'1\': \'1 scheme\', \'other\': \'{} schemes\'}"></ng-pluralize>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t\t<i class="icon-chevron-up is-secondary"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : showPensionSchemes}">\n\n\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t<tr ng-repeat="scheme in paymentSchedule.filteredPaymentScheduleGroupPension = ( paymentSchedule.PaymentScheduleGroupPension | filter: { PaymentScheduleGroupPensionState: true } )">\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale-dark is-small">{{::scheme.PensionProviderName}}</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small">({{::scheme.EmployerReference}})</span>\n\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t<td class="float-right" ng-switch="scheme.PaymentScheduleGroupPensionBehaviourAttributes">\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.both">Employee and Employer</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee">Employee only</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer">Employer only</span>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" disable-button="!recalculateRepaymentScheduleForm.$valid || !paymentSchedule.recalculationState" state="recalculateRepaymentScheduleForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Repayment schedule saved" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}&apos;s &lsquo;{{paymentSchedule.PaymentScheduleTypeDescription}}&rsquo; repayment schedule has now been saved and the first repayment will be taken in the pay period {{paymentSchedule.FirstPayPeriodDisplay}}.</p>\n\t\t<p class="s"><strong>Please note:</strong> You can edit or delete the schedule before it begins and, once the schedule has started, you can also edit a payment each pay period if, for example, {{formOptions.context.Forename}} wished to pay the loan off early.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.repaymentSchedules" underline="true">Read more about repayment schedules here</support-article-link>.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Invalid schedule -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="A repayment schedule can\'t exceed one year" ng-if="pageState === \'invalid-schedule\'">\n    <fs-main>\n        <p class="s">You&apos;ve entered a loan amount of {{paymentSchedule.TotalAmount | monetise}} and chosen to recover it with fixed deductions of {{paymentSchedule.FixedRepaymentAmount | monetise}} each pay period. This means the schedule will exceed the limit of one year. Click &lsquo;back&rsquo; to change the values you&apos;ve entered.</p>\n    </fs-main>\n    <fs-actions>\n        <a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n    </fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/editSicknessPolicy/editSicknessPolicyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="editSicknessPolicyForm" ng-submit="saveForm(form, editSicknessPolicyForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tAdjust {{formOptions.context.Forename}}\u2019s sickness policy settings below and any changes you make will only be saved for {{formOptions.context.Gender | personalise:\'him\'}}.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">Read more about holiday and sickness policies</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Sickness -->\n\t\t<section class="form-section">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Sickness policy</h4>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required">Sickness pattern:</label>\n\t\t\t\t</header>\n\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: holidaySickness.SicknessType === SICKNESS_TYPES.payAllSickness}" ng-click="holidaySickness.SicknessType = SICKNESS_TYPES.payAllSickness">Pay all sickness</a>\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: holidaySickness.SicknessType === SICKNESS_TYPES.statutory}" ng-click="holidaySickness.SicknessType = SICKNESS_TYPES.statutory">Statutory sick pay</a>\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: holidaySickness.SicknessType === SICKNESS_TYPES.custom}" ng-click="holidaySickness.SicknessType = SICKNESS_TYPES.custom">Custom</a>\n\t\t\t\t</ul>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="holidaySickness.SicknessType === SICKNESS_TYPES.custom">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="policyDays" class="required">Custom pattern:</label>\n\t\t\t\t\t<p class="s">Add the number of days you wish to pay for and all subsequent sick days will be based on Statutory sick pay.</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<number-picker ng-model="holidaySickness.SicknessDays" field-name="policyDays" heading="days" figure-type="\'\'" step="1" min="1" max="100"></number-picker>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</section>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="editSicknessPolicyForm.state" disable-button="!editSicknessPolicyForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{formOptions.context.Forename}}\u2019s sickness policy has been updated" ng-if="pageState === \'saved-policy\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">To find out more about tracking holiday and sickness, read our\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">guide to holiday and sickness policies</support-article-link>.</p>\n\t\t<p class="s strong"><br><a href="" class="strong" ng-click="closeForm()">Ok, close this window</a></p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/excludeFromPayroll/excludeFromPayrollForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="excludeFromPayrollForm" ng-submit="saveExcludeFromPayroll(teamMember, excludeFromPayrollForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Exclude from Payroll -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="form-field-label required l" for="excludeFromPayrollTrue">Do you want to exclude {{formOptions.context.Forename}} from payroll?</label>\n\t\t\t\t<p class="s">This will remove {{formOptions.context.Forename}} from all future pay periods until {{formOptions.context.Gender | personalise}} is included again.</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="excludeFromPayroll" id="excludeFromPayrollTrue" class="radio-card-input" ng-value="true" ng-model="teamMember.Company.ExcludeFromPayroll">\n\t\t\t\t\t\t<label class="radio-card-label positive" for="excludeFromPayrollTrue">\n\t\t\t\t\t\t\t<i class="icon-tick radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Yes</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="excludeFromPayroll" id="excludeFromPayrollFalse" class="radio-card-input" ng-value="false" ng-model="teamMember.Company.ExcludeFromPayroll">\n\t\t\t\t\t\t<label class="radio-card-label assertive" for="excludeFromPayrollFalse">\n\t\t\t\t\t\t\t<i class="icon-cross radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">No</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="excludeFromPayrollForm.state" ng-if="excludeFromPayrollForm.state === \'saved\'">\n\t\t\t<p>{{formOptions.context.Forename}}\'s payroll preferences have been saved successfully</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="excludeFromPayrollForm.state" disable-button="!excludeFromPayrollForm.$valid"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a href="" ng-if="formOptions.canSkip" class="button tertiary-action" ng-click="formOptions.skip()">Skip</a>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/furlough/furloughForm.html','<div ng-switch="pageState">\n\n\t<!-- Loading -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Ready (create new furlough) -->\n\t<form class="fadeIn" pc-switch-when="PAGE_STATES.ready" name="furloughForm" ng-submit="saveUpdateFurloughForm(vm, furloughForm)" novalidate ng-switch="vm.teamMemberSalary.SalaryType">\n\n\t\t<fieldset>\n\n\t\t\t<!-- Furlough period dates -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t<!-- Start date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="startDate">Start date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-value-iso="vm.furloughDetail.StartDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.startDate.$error" ng-if="furloughForm.startDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the start date</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field-group_divider"><i class="icon-arrow-right is-medium is-primary"></i></div>\n\n\t\t\t\t\t<!-- End date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="endDate">End date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="endDate" field-max-date-iso="$root.CONFIG.furlough.maxDate" field-min-date-iso="vm.furloughDetail.StartDateISO" field-value-iso="vm.furloughDetail.EndDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.endDate.$error" ng-if="furloughForm.endDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{$root.CONFIG.furlough.maxDate | dateformat}}</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.furloughDetail.StartDateISO | dateformat}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tEnd date must be on or before {{$root.CONFIG.furlough.maxDate | dateformat}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Single team member -->\n\t\t<div ng-if="!IS_BULK_FURLOUGH">\n\n\t\t\t<!-- Gross Pay -->\n\t\t\t<div class="form-content-block" pc-switch-when="SALARY_TYPES.grossPay">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t{{formOptions.context.Forename}} has an annual salary of {{vm.teamMemberSalary.SalaryYearly | monetise}} saved in their pay information and you can see what their {{vm.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} furlough pay will be when the reclaimable monthly cap of {{vm.teamMemberSalary.periodCap | monetise}} is applied.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Hourly pay / Net pay / Casual / Variable -->\n\t\t\t<fieldset ng-switch-default>\n\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tAs {{formOptions.context.Forename}} doesn\u2019t have an annual salary saved in their pay information please enter a {{vm.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} gross pay amount and we\u2019ll calculate the equivalent.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Gross Pay -->\n\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="grossPay" class="required">{{vm.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\' | capitalise}} gross pay:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input ng-model-options="{ debounce:500 }" name="grossPay" type="number" id="grossPay" class="monetise m" ng-model="vm.teamMemberSalary.grossPayAmount" placeholder="0.00" required ng-change="getFurloughPayForNonGrossPaySalary(vm)">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.grossPay.$error" ng-if="furloughForm.grossPay.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<p class="is-small fadeIn" ng-if="vm.teamMemberSalary.showFurloughSalaryPay">\n\t\t\t\t\t\tBased on the amount entered you can see what {{formOptions.context.Forename}}\u2019s {{vm.payPeriod.PeriodType | payPeriodTypeDescription:\'monthly\'}} furlough pay will be when the reclaimable monthly cap of {{vm.teamMemberSalary.periodCap | monetise}} is applied.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t</div>\n\n\t\t<!-- Bulk update -->\n\t\t<div ng-if="IS_BULK_FURLOUGH" class="form-content-block">\n\t\t\t<p class="is-small">\n\t\t\t\tIf {{$root.CONFIG.furlough.monthlyPayCapPercent}}% of the saved annual salary for any of the selected team members exceeds {{$root.CONFIG.furlough.annualPayCap | monetise}}, they will be paid the {{vm.periodCap | monetise}} monthly cap for reclaiming furlough pay. You can address any shortfall with a pay top-up.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.teamMemberSalary.showFurloughSalaryPay">\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="stat-block e no-footer is-primary is-small">\n\t\t\t\t\t<div class="stat-block__stats">\n\n\t\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t\t<h2 class="stat-block__title">{{vm.teamMemberSalary.totalPay | monetise}}</h2>\n\t\t\t\t\t\t\t<p class="stat-block__desc">100% pay</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn" ng-if="!vm.showSalaryOverride">{{vm.teamMemberSalary.percentagePay | monetise}}</h2>\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn primary-light" ng-if="vm.showSalaryOverride && !vm.furloughDetail.SalaryForPeriod">Unknown</h2>\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn" ng-if="vm.showSalaryOverride && vm.furloughDetail.SalaryForPeriod">{{vm.furloughDetail.SalaryForPeriod | monetise}}</h2>\n\t\t\t\t\t\t\t<p class="stat-block__desc">{{$root.CONFIG.furlough.monthlyPayCapPercent}}% pay</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn" ng-if="!vm.showSalaryOverride">{{vm.teamMemberSalary.furloughPay | monetise}}</h2>\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn primary-light" ng-if="vm.showSalaryOverride && !vm.furloughDetail.SalaryForPeriod">Unknown</h2>\n\t\t\t\t\t\t\t<h2 class="stat-block__title fadeIn" ng-if="vm.showSalaryOverride && vm.furloughDetail.SalaryForPeriod">{{vm.furloughDetail.SalaryForPeriod | monetise}}</h2>\n\t\t\t\t\t\t\t<p class="stat-block__desc">Furlough pay</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message">The furlough pay can be reclaimed through the Coronavirus Job Retention Scheme</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Override salary -->\n\t\t<fieldset pc-switch-when="SALARY_TYPES.grossPay" ng-if="!IS_BULK_FURLOUGH">\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-name="showSalaryOverride" field-model="vm.showSalaryOverride" field-label="Override {{$root.CONFIG.furlough.monthlyPayCapPercent}}% pay amount"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="vm.showSalaryOverride">\n\t\t\t\t<div class="form-content-block no-margin top">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tInstead of paying the {{$root.CONFIG.furlough.monthlyPayCapPercent}}% calculated enter a fixed pay amount below\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay amount -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="salaryForPeriod" class="required">Pay amount:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input ng-model-options="{ debounce:500 }" name="salaryForPeriod" type="number" id="salaryForPeriod" class="monetise m" ng-model="vm.furloughDetail.SalaryForPeriod" placeholder="Enter amount" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.salaryForPeriod.$error" ng-if="furloughForm.salaryForPeriod.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<!-- Add top up -->\n\t\t<fieldset class="fadeIn" ng-if="vm.teamMemberSalary.showFurloughSalaryPay && !vm.showPartTimeFurloughPay">\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-name="showAddTopUp" field-model="vm.showAddTopUp" field-label="Add pay top-up"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="vm.showAddTopUp">\n\t\t\t\t<div class="form-content-block no-margin top">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tOnce you click \u2018Save\u2019 these payments will be created for each pay period affected. If you later need to edit any of them you should do so in the future changes page in your company settings area.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Top up amount -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="topUpAmount" class="required">Top-up amount:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input name="topUpAmount" type="number" id="topUpAmount" class="monetise m" ng-model="vm.furloughDetail.TopupAmount" placeholder="Enter amount" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.topUpAmount.$error" ng-if="furloughForm.topUpAmount.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="!IS_BULK_FURLOUGH">\n\t\t\t<!-- Switch to part-time furlough pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<p class="is-small">If {{formOptions.context.Forename}} is returning to work part-time, you can change their furlough status from full-time to part-time below.\n\t\t\t\t\t\tPlease note that you can\u2019t add a pay top-up for team members furloughed part-time.\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-name="showPartTimeFurloughPay" field-on-change="showPartTimeFurloughPayChanged(vm)" field-model="vm.showPartTimeFurloughPay" field-label="Switch to part-time furlough pay"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.showPartTimeFurloughPay">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="partTimeFurloughStartDate">Select a period to start part-time furlough:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select class="l" name="partTimeFurloughStartPayPeriod" id="partTimeFurloughStartPayPeriod" ng-model="vm.furloughDetail.PartTimeDateISO" ng-options="payPeriodDetail.PeriodStartISO as payPeriodDetail.PayPeriodDisplay for payPeriodDetail in vm.payPeriodDetails" required></select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message">Please note: Any hours that fall outside of your selected period at the start\n\t\t\t\t\t\tof the calendar month should be added to your reclaim report before submitting your reclaim.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="is-small">{{formOptions.context.Forename}}\u2019s current salary will be used to pay contracted hours and their furlough salary\n\t\t\t\t\t\tfor furlough hours and the payments will be added as two separate pay elements in your current period.\n\t\t\t\t\t\tYou can update these hours up until the time you run payroll for the respective pay period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="furlough-part-time-form-field-list">\n\t\t\t\t\t<furlough-part-time-form-field ng-repeat="payPeriodDetail in vm.payPeriodDetails | filter: payPeriodDetailFilter" pay-period-detail="payPeriodDetail" index="$index"></furlough-part-time-form-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="furloughForm.state" disable-button="!furloughForm.$valid"></submit-button>\n\n\t\t</fieldset>\n\t</form>\n\n\t<!-- View -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.view">\n\t\t<form-state form-options="formOptions" fs-show-close="false" fs-theme="less-margin">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<h4>Furlough pay</h4>\n\t\t\t\t\t<p>Please note that if you\u2019ve added a pay top-up for {{formOptions.context.Forename}} you can override any payments in the future changes page in your company settings area. </p>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset>\n\n\t\t\t\t\t<div class="repayment-card is-primary is-date-range">\n\t\t\t\t\t\t<div class="repayment-card_main">\n\t\t\t\t\t\t\t<div class="repayment-card_icon">\n\t\t\t\t\t\t\t\t<i class="icon-wallet xl"></i>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="repayment-card_details">\n\t\t\t\t\t\t\t\t<div class="repayment-card_meta">\n\t\t\t\t\t\t\t\t\t<h5 class="repayment-card_label">Start date</h5>\n\t\t\t\t\t\t\t\t\t<h6 class="repayment-card_amount">{{vm.furloughDetail.StartDateISO | dateformat}}</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="repayment-card_chevron">\n\t\t\t\t\t\t\t\t\t<i class="icon-chevron-right is-primary m"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="repayment-card_meta">\n\t\t\t\t\t\t\t\t\t<h5 class="repayment-card_label">End date</h5>\n\t\t\t\t\t\t\t\t\t<h6 class="repayment-card_amount">{{vm.furloughDetail.EndDateISO | dateformat}}</h6>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="repayment-card_footer">\n\t\t\t\t\t\t\t<div class="repayment-card_meta">\n\t\t\t\t\t\t\t\t<h5 class="repayment-card_label">Furlough status</h5>\n\t\t\t\t\t\t\t\t<h6 class="repayment-card_amount">{{vm.furloughDetail.isPartTime ? \'Part-time\' : \'Full-time\'}}</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="repayment-card_meta" ng-if="vm.furloughDetail.isPartTime">\n\t\t\t\t\t\t\t\t<h5 class="repayment-card_label">Part-time start date</h5>\n\t\t\t\t\t\t\t\t<h6 class="repayment-card_amount">{{vm.furloughDetail.PartTimeDateISO | dateformat}}</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="repayment-card_meta">\n\t\t\t\t\t\t\t\t<h5 class="repayment-card_label">Monthly furlough pay</h5>\n\t\t\t\t\t\t\t\t<h6 class="repayment-card_amount">{{vm.furloughDetail.SalaryForPeriod | monetise}}</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t\t<p class="is-small">If you need to update {{formOptions.context.Forename}}\u2019s furlough dates or change their furlough status,\n\t\t\t\t\t\t\t<a href="" ng-click="setPageState(PAGE_STATES.editDates)" class="underline primary">click here to edit {{formOptions.context.Forename}}\u2019s furlough settings.</a>\n\t\t\t\t\t\t\tIf you no longer wish to furlough them, click the \u2018Unfurlough\u2019 button below.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t\t<button class="primary-action tertiary" ng-click="setPageState(PAGE_STATES.unfurloughConfirm)">Unfurlough</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Edit dates -->\n\t<form class="fadeIn" pc-switch-when="PAGE_STATES.editDates" name="furloughForm" ng-submit="updateTeamMemberSalaryFurloughedInProgress(vm, furloughForm)" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Edit furlough dates</h4>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Furlough period dates -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t<!-- Start date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="startDate">Start date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-read-only="vm.furloughDetail.startDateReadonly" field-value-iso="vm.furloughDetail.StartDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.startDate.$error" ng-if="furloughForm.startDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the start date</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field-group_divider"><i class="icon-arrow-right is-medium is-primary"></i></div>\n\n\t\t\t\t\t<!-- End date -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="endDate">End date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="endDate" field-max-date-iso="$root.CONFIG.furlough.maxDate" field-min-date-iso="vm.furloughDetail.StartDateISO" field-value-iso="vm.furloughDetail.EndDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="furloughForm.endDate.$error" ng-if="furloughForm.endDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the start for the first period</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{$root.CONFIG.furlough.maxDate | dateformat}}</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.furloughDetail.StartDateISO | dateformat}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\tEnd date must be on or before {{$root.CONFIG.furlough.maxDate | dateformat}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn">\n\t\t\t<!-- Switch to part-time furlough pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<p class="is-small">If {{formOptions.context.Forename}} is returning to work part-time, you can change their furlough status from full-time to part-time below.</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-name="showPartTimeFurloughPay" field-on-change="showPartTimeFurloughPayChanged(vm)" field-model="vm.showPartTimeFurloughPay" field-label="Switch to part-time furlough pay"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.showPartTimeFurloughPay">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="partTimeFurloughStartDate">Select a period to start part-time furlough:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select class="l" name="partTimeFurloughStartPayPeriod" id="partTimeFurloughStartPayPeriod" ng-model="vm.furloughDetail.PartTimeDateISO" ng-options="payPeriodDetail.PeriodStartISO as payPeriodDetail.PayPeriodDisplay for payPeriodDetail in vm.payPeriodDetails" required></select>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message">Please note: Any hours that fall outside of your selected period at the start\n\t\t\t\t\t\tof the calendar month should be added to your reclaim report before submitting your reclaim.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="is-small">{{formOptions.context.Forename}}\u2019s current salary will be used to pay contracted hours and their furlough salary\n\t\t\t\t\t\tfor furlough hours and the payments will be added as two separate pay elements in your current period.\n\t\t\t\t\t\tYou can update these hours up until the time you run payroll for the respective pay period.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="furlough-part-time-form-field-list">\n\t\t\t\t\t<furlough-part-time-form-field ng-repeat="payPeriodDetail in vm.payPeriodDetails | filter: payPeriodDetailFilter" pay-period-detail="payPeriodDetail" is-paid="payPeriodDetail.PeriodComplete && !user.IsInSetupMode" index="$index"></furlough-part-time-form-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\n\t\t\t<a href="" class="button secondary-action" ng-click="setPageState(PAGE_STATES.view)">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="furloughForm.state" disable-button="!furloughForm.$valid"></submit-button>\n\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Individual saved -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.individualSaved">\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Furlough information saved">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf you need to review or edit {{formOptions.context.Forename}}\u2019s furlough information you can do so in the Overview area in their profile.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Confirm Unfurlough -->\n\t<form class="fadeIn" pc-switch-when="PAGE_STATES.unfurloughConfirm" name="unfurloughConfirmForm" ng-submit="updateTeamMemberSalaryFurloughedCancel(vm, unfurloughConfirmForm)" novalidate>\n\t\t<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure you wish to unfurlough {{formOptions.context.Forename}}?" fs-show-close="false">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">This will delete {{formOptions.context.Forename}}\u2019s furlough pay settings and they will continue being paid based on the pay information saved in their profile. If {{formOptions.context.Forename}} was receiving a pay top-up, all future payments will also be deleted. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="setPageState(PAGE_STATES.view)" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t\t<submit-button display-text="\'Confirm\'" state="unfurloughConfirmForm.state" disable-button="!unfurloughConfirmForm.$valid"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Unfurloughed -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.unfurloughed">\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-title="{{formOptions.context.Forename}} has been unfurloughed">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">{{formOptions.context.Forename}} will continue being paid based on the pay information saved in their profile.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Marked as leaver -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.markedAsLeaving">\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="{{formOptions.context.Forename}} is marked as leaving">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">{{formOptions.context.Forename}} can\u2019t be furloughed while they have also been marked as leaving. Unmark {{formOptions.context.Forename}} as leaving in their profile before trying again.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Bulk saved -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.bulkSaved">\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Team members furloughed">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe selected team members have now been furloughed. If you need to review or edit the furlough information for a team member you can do so in the Overview area in their profile.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Error -->\n\t<div class="fadeIn" pc-switch-when="PAGE_STATES.error">\n\t\t<error-block secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\t</div>\n</div>\n');
$templateCache.put('forms/payroll/generate-p45/generate-p45.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Confirmation -->\n<form class="fadeIn" name="generateP45Form" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.payrollRegenerateP45($ctrl, generateP45Form)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to generate a P45?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tAs {{::$ctrl.formOptions.context.Forename}} has already left you may wish to review their Year to date figures for the current tax year and update them as required. The P45 will be\n\t\t\t\tmade available in their Pay Portal and the Documents area in their profile. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Confirm\'" state="saving"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<!-- Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="secondary" fs-title="P45 generated" ng-if="$ctrl.pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{::$ctrl.formOptions.context.Forename}}\u2019s P45 is now available in their Pay Portal and the Documents area in their profile.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<form-state data-cy="p45-no-leave-date-warning" form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to generate P45" ng-if="$ctrl.pageState === \'no-leave-date\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou cannot generate a P45 for {{::$ctrl.formOptions.context.Forename}} {{::$ctrl.formOptions.context.Surname}} as they do not have a leave date. Edit their leaver information and add a leave date before trying again.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/holidaySickness/holidaySicknessForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="holidaySicknessForm" ng-submit="addNewLeave(HS, holidaySicknessForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t   <a data-cy="holiday-sickness-form-tab-overview" href="" ng-class="{\'active\': HS.formView === \'overview\'}" ng-click="HS.formView = \'overview\'; HS.showAddLeave = false">Overview</a>\n\t\t\t   <a data-cy="holiday-sickness-form-tab-holiday" href="" ng-class="{\'active\': HS.formView === \'holiday\'}" ng-click="HS.formView = \'holiday\'; HS.showAddLeave = false">Holiday</a>\n\t\t\t   <a data-cy="holiday-sickness-form-tab-sickness" href="" ng-class="{\'active\': HS.formView === \'sickness\'}" ng-click="HS.formView = \'sickness\'; HS.showAddLeave = false">Sickness</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content" ng-switch="HS.formView">\n\n\t\t<!-- Overview -->\n\t\t<fieldset class="fadeIn" ng-switch-when="overview">\n\n\t\t\t<section class="form-section larger-margin">\n\t\t\t\t<div class="spaced-links spaced-links--large">\n\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t<div class="stat-block d">\n\t\t\t\t\t\t\t<div class="stat-block__item secondary">\n\t\t\t\t\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-holiday stat-block__icon"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<figure class="stat-block__figure" data-cy="holiday-sickness-form-total-holiday">\n\t\t\t\t\t\t\t\t\t\t{{HS.holiday.Holidays.TotalHoliday}}\n\t\t\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<span class="stat-block__label">Days total holiday</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="stat-block__item stat-block__item--graph secondary">\n\t\t\t\t\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t\t\t\t\t<progress-ring pr-percentage="HS.holiday.daysTakenPercent" pr-size="small" pr-theme-complete="secondary" pr-theme-incomplete="greyscale"></progress-ring>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t\t\t\t\t<figure class="stat-block__figure" data-cy="holiday-sickness-form-days-taken">\n\t\t\t\t\t\t\t\t\t\t{{HS.holiday.daysTaken}}\n\t\t\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t\t\t<span class="stat-block__label">Days taken</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="spaced-links__spacer"></div>\n\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t<div class="stat-block d">\n\t\t\t\t\t\t\t<div class="stat-block__item assertive">\n\t\t\t\t\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-sick stat-block__icon"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<figure class="stat-block__figure" data-cy="holiday-sickness-form-total-sickness">\n\t\t\t\t\t\t\t\t\t\t{{HS.sickness.Sickness.TotalSickness}}\n\t\t\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<span class="stat-block__label">Days sick leave</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<section class="form-section">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<div class="form-intro form-intro--with-link">\n\t\t\t\t\t\t\t<h6 class="medium">Upcoming leave <span class="greyscale" data-cy="holiday-sickness-form-upcoming-holiday-leave">({{HS.holiday.upcoming.length}})</span></h6>\n\t\t\t\t\t\t\t<a data-cy="holiday-sickness-form-all-holiday" href ng-click="HS.formView = \'holiday\'" class="s strong">All holiday <i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main" data-cy="holiday-sickness-form-overview-holiday">\n\t\t\t\t\t\t<leave-card callback="onLeaveDelete()" index="$index" leave-type="holiday" is-integration-locked="leave.IsFromIntegration" leave="leave" ng-repeat="leave in HS.holiday.upcoming"></leave-card>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<section class="form-section with-separator">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<div class="form-intro form-intro--with-link">\n\t\t\t\t\t\t\t<h6 class="medium">Last sickness leave <span class="greyscale" data-cy="holiday-sickness-form-last-sick-leave">({{HS.sickness.all.length}})</span></h6>\n\t\t\t\t\t\t\t<a data-cy="holiday-sickness-form-all-sickness" href ng-click="HS.formView = \'sickness\'" class="s strong primary">All sickness <i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main" data-cy="holiday-sickness-form-overview-sickness">\n\t\t\t\t\t\t<leave-card callback="onLeaveDelete()" index="$index" leave-type="sickness" is-integration-locked="leave.IsFromIntegration" leave="leave" ng-repeat="leave in HS.sickness.all"></leave-card>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</fieldset>\n\n\t\t<!-- Holiday -->\n\t\t<fieldset class="fadeIn" ng-switch-when="holiday">\n\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-intro form-intro--with-link">\n\t\t\t\t\t<h5 class="stronger">Holiday year: <span>{{HS.holiday.HolidayYearFromISO | dateformat:\'dayMonthYear\'}}&nbsp;-&nbsp;{{HS.holiday.HolidayYearToISO | dateformat:\'dayMonthYear\'}}</span></h5>\n\t\t\t\t\t<a data-cy="holiday-sickness-form-holiday-edit-policy" href ng-click="openEditHolidayPolicyForm()" class="s strong"><i class="icon-edit"></i> Edit policy</a>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<section>\n\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t<h6 class="medium">\n\t\t\t\t\t\t\t\tUpcoming <span class="greyscale">({{HS.holiday.upcoming.length}})</span>\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="form-field-main" data-cy="holiday-sickness-form-holiday-upcoming">\n\n\t\t\t\t\t\t<leave-card callback="onLeaveDelete()" index="$index" leave-type="holiday" is-integration-locked="leave.IsFromIntegration" leave="leave" ng-repeat="leave in HS.holiday.upcoming"></leave-card>\n\n\t\t\t\t\t\t<a data-cy="holiday-sickness-form-holiday-add-holiday-leave" class="leave-card leave-card--add-leave fadeIn" href ng-if="!HS.showAddLeave" ng-click="openAddLeave(HS)">\n\t\t\t\t\t\t\t<i class="icon-add"></i>&nbsp;&nbsp;Add holiday leave\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<div class="leave-card leave-card--form fadeIn" ng-if="HS.showAddLeave">\n\n\t\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t\t<h6 class="stronger">\n\t\t\t\t\t\t\t\t\tAdd leave\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tLeave days are counted and stored for each team member, for tracking purposes only. Don\u2019t forget to add leave related adjustments to payroll, where appropriate.\n\t\t\t\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">Read more about tracking holidays and sick days.</support-article-link>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="leave-card__form-layout">\n\n\t\t\t\t\t\t\t\t<!-- Type of leave -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="leaveType" class="required">Type of leave:</label>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<select class="block" name="leaveType" id="leaveType" ng-model="HS.addLeave.selectedLeaveType" ng-options="option as option.name for option in LEAVE_TYPES.holiday" required>\n\t\t\t\t\t\t\t\t\t\t\t<option value="" hidden disabled="disabled" selected="selected">Select a type of leave</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="holidaySicknessForm.leaveType.$error" ng-if="holidaySicknessForm.leaveType.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please choose a type of leave</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t\t<!-- Start date -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="startDate">Start date:</label>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-value-iso="HS.addLeave.startDateIso" field-required="true">\n\t\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="holidaySicknessForm.startDate.$error" ng-if="holidaySicknessForm.startDate.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a start date for the leave</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">The start date should be the same as or sooner than the end date</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayFrom" name="holidayHalfDayFrom" ng-model="HS.addLeave.halfDayFrom" ng-change="addHalfDayFrom(HS.addLeave)" ng-disabled="!HS.addLeave.startDateIso || (HS.addLeave.leaveDays === 0.5 && HS.addLeave.halfDayTo)">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayFrom">{{HS.addLeave.leaveDays > 1 ? "Half day PM" : "Half day AM"}}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayFrom"></label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="leave-card__form-icon" ng-class="{\'invisible\' : !HS.addLeave.startDateIso}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- End date -->\n\t\t\t\t\t\t\t\t\t<div class="form-field" ng-class="{\'invisible\' : !HS.addLeave.startDateIso}">\n\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="endDateIso">End date:</label>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="endDate" field-required="true" field-value-iso="HS.addLeave.endDateIso">\n\t\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="holidaySicknessForm.endDateIso.$error" ng-if="holidaySicknessForm.endDateIso.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a end date for the leave</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">The end date should be the same as or later than the start date</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayTo" name="holidayHalfDayTo" ng-model="HS.addLeave.halfDayTo" ng-change="addHalfDayTo(HS.addLeave)" ng-disabled="HS.addLeave.leaveDays === 0.5 && HS.addLeave.halfDayFrom">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayTo">{{HS.addLeave.leaveDays > 1 ? "Half day AM" : "Half day PM"}}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayTo"></label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="leave-card__section fadeIn" ng-if="HS.addLeave.startDateIso && HS.addLeave.endDateIso && HS.addLeave.selectedLeaveType">\n\t\t\t\t\t\t\t\t<div class="leave-card {{HS.addLeave.selectedLeaveType.id | leaveThemes}}">\n\t\t\t\t\t\t\t\t\t<p class="s align-left" ng-if="HS.addLeave.leaveDays > 1">{{formOptions.context.Forename}} will be on {{HS.addLeave.selectedLeaveType.name | lowercase}} from <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> to <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.endDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="HS.addLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t\t\t\t\t\t\t\t<p class="s align-left" ng-if="HS.addLeave.leaveDays <= 1">{{formOptions.context.Forename}} will be on {{HS.addLeave.selectedLeaveType.name | lowercase}} on <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="HS.addLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<footer class="leave-card__section">\n\t\t\t\t\t\t\t\t<submit-button button-id="holiday-sickness-form-holiday-add-leave" display-text="\'Add leave\'" state="holidaySicknessForm.state" disable-button="!holidaySicknessForm.$valid" button-theme="\'primary\'"></submit-button>\n\t\t\t\t\t\t\t\t<a href class="button" ng-click="resetNewLeave(HS)">\n\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<section class="form-section with-separator">\n\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t<h6 class="medium">Taken <span class="greyscale">({{HS.holiday.taken.length}})</span></h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="form-field-main" data-cy="holiday-sickness-form-holiday-taken">\n\n\t\t\t\t\t\t<leave-card callback="onLeaveDelete()" index="$index" leave-type="holiday" is-integration-locked="leave.IsFromIntegration" leave="leave" ng-repeat="leave in HS.holiday.taken"></leave-card>\n\n\t\t\t\t\t</main>\n\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</fieldset>\n\n\t\t<!-- Sickness -->\n\t\t<fieldset class="fadeIn" ng-switch-when="sickness">\n\n\t\t\t<section>\n\t\t\t\t<div class="form-intro form-intro--with-link">\n\t\t\t\t\t<h5 class="stronger">Sickness year: <span>{{HS.sickness.SicknessYearFromISO | dateformat:\'dayMonthYear\'}}&nbsp;-&nbsp;{{HS.sickness.SicknessYearToISO | dateformat:\'dayMonthYear\'}}</span></h5>\n\t\t\t\t\t<a data-cy="holiday-sickness-form-sickness-edit-policy" href ng-click="openEditSicknessPolicyForm()" class="s strong"><i class="icon-edit"></i> Edit policy</a>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<section>\n\t\t\t\t<div class="form-field">\n\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t<h6 class="medium">\n\t\t\t\t\t\t\t\tSickness leave <span class="greyscale">({{HS.sickness.all.length}})</span>\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="form-field-main" data-cy="holiday-sickness-form-sickness-all">\n\n\t\t\t\t\t\t<leave-card callback="onLeaveDelete()" index="$index" leave-type="sickness" is-integration-locked="leave.IsFromIntegration" leave="leave" ng-repeat="leave in HS.sickness.all"></leave-card>\n\n\t\t\t\t\t\t<a class="leave-card leave-card--add-leave fadeIn" data-cy="holiday-sickness-form-sickness-add-sickness-leave" href ng-click="openAddLeave(HS)" ng-if="!HS.showAddLeave">\n\t\t\t\t\t\t\t<i class="icon-add"></i>&nbsp;&nbsp;Add sickness leave\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<div class="leave-card leave-card--form fadeIn" ng-if="HS.showAddLeave">\n\n\t\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t\t<h6 class="stronger">\n\t\t\t\t\t\t\t\t\tAdd leave\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tLeave days are counted and stored for each team member, for tracking purposes only. Don\u2019t forget to add leave related adjustments to payroll, where appropriate.\n\t\t\t\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">Read more about tracking holidays and sick days.</support-article-link>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="leave-card__form-layout">\n\n\t\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t\t<!-- Start date -->\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="startDate">Start date:</label>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="startDate" field-value-iso="HS.addLeave.startDateIso" field-required="true">\n\t\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="holidaySicknessForm.startDate.$error" ng-if="holidaySicknessForm.startDate.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a start date for the leave</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="max">The start date should be the same as or sooner than the end date</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayFrom" name="holidayHalfDayFrom" ng-model="HS.addLeave.halfDayFrom" ng-change="addHalfDayFrom(HS.addLeave)" ng-disabled="!HS.addLeave.startDateIso || (HS.addLeave.leaveDays === 0.5 && HS.addLeave.halfDayTo)">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayFrom">{{HS.addLeave.leaveDays > 1 ? "Half day PM" : "Half day AM"}}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayFrom"></label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="leave-card__form-icon" ng-class="{\'invisible\' : !HS.addLeave.startDateIso}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- End date -->\n\t\t\t\t\t\t\t\t\t<div class="form-field" ng-class="{\'invisible\' : !HS.addLeave.startDateIso}">\n\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="endDateIso">End date:</label>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="endDate" field-required="true" field-value-iso="HS.addLeave.endDateIso">\n\t\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="holidaySicknessForm.endDateIso.$error" ng-if="holidaySicknessForm.endDateIso.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a end date for the leave</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">The end date should be the same as or later than the start date</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="holidayHalfDayTo" name="holidayHalfDayTo" ng-model="HS.addLeave.halfDayTo" ng-change="addHalfDayTo(HS.addLeave)" ng-disabled="HS.addLeave.leaveDays === 0.5 && HS.addLeave.halfDayFrom">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-label" for="holidayHalfDayTo">{{HS.addLeave.leaveDays > 1 ? "Half day AM" : "Half day PM"}}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox-field-tickbox" for="holidayHalfDayTo"></label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="leave-card__section fadeIn" ng-if="HS.addLeave.startDateIso && HS.addLeave.endDateIso && HS.addLeave.selectedLeaveType">\n\t\t\t\t\t\t\t\t<div class="leave-card {{HS.addLeave.selectedLeaveType.id | leaveThemes}}">\n\t\t\t\t\t\t\t\t\t<p class="s align-left" ng-if="HS.addLeave.leaveDays > 1">{{formOptions.context.Forename}} will be on {{HS.addLeave.selectedLeaveType.name | lowercase}} from <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> to <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.endDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="HS.addLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t\t\t\t\t\t\t\t<p class="s align-left" ng-if="HS.addLeave.leaveDays <= 1">{{formOptions.context.Forename}} will be on {{HS.addLeave.selectedLeaveType.name | lowercase}} on <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}">{{HS.addLeave.startDateIso | dateformat:\'custom\':\'Do MMM\'}}</span> for a total of <span class="stronger {{HS.addLeave.selectedLeaveType.id | leaveThemes:true}}"><ng-pluralize count="HS.addLeave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<footer class="leave-card__section">\n\t\t\t\t\t\t\t\t<submit-button button-id="holiday-sickness-form-sickness-add-leave" button-theme="\'primary\'" disable-button="!holidaySicknessForm.$valid" display-text="\'Add leave\'" state="holidaySicknessForm.state"></submit-button>\n\t\t\t\t\t\t\t\t<button data-cy="holiday-sickness-form-sickness-cancel-leave" ng-click="resetNewLeave(HS)" type="button">\n\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</fieldset>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Close</a>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/hourlyTotals/hourlyTotalsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="hourlyTotalsForm" ng-submit="updateSalaryRates(teamMembers, hourlyTotalsForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Hourly totals</h4>\n\t\t<p class="s">Adjust standard hours and add hours for additional rates for your hourly paid team members. To edit hourly rates, go to the respective team member\'s profile.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<search-bar options="searchBarOptions" count="filteredTeamMembers.length"></search-bar>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="hourly-totals-card primary fadeIn" dir-paginate="teamMember in filteredTeamMembers = ( teamMembers | filter : searchBarOptions.search.string ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber">\n\n\t\t\t<header class="hourly-totals-card_header">\n\t\t\t\t<div class="hourly-totals-card_avatar">\n\t\t\t\t\t<avatar avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-small" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="hourly-totals-card_title">\n\t\t\t\t\t<h6 class="hourly-totals-card_name">{{teamMember.Forename}} {{teamMember.Surname}}</h6>\n\t\t\t\t\t<p class="is-primary s">Payroll ID: {{teamMember.PayrollID}}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="hourly-totals-card_meta fadeIn">\n\t\t\t\t\t<span class="hourly-totals-card_meta-item">{{teamMember.totalGross | monetise}}</span>\n\t\t\t\t\t<span class="hourly-totals-card_meta-item">{{teamMember.totalHours}} hrs</span>\n\t\t\t\t</div>\n\t\t\t</header>\n\n\t\t\t<div class="hourly-totals-card_rates form-field">\n\t\t\t\t<div class="hourly-totals-card_rate" ng-repeat="salaryRate in teamMember.SalaryRates | orderBy: \'SalaryRateDefault\':true" ng-class="{\'is-default\': salaryRate.SalaryRateDefault}">\n\n\t\t\t\t\t<!-- Description -->\n\t\t\t\t\t<p class="hourly-totals-card_rate-description">{{salaryRate.SalaryRateDescription}} - {{salaryRate.SalaryRateValue | monetise:config.precision.salaryRates}}/hr</p>\n\n\t\t\t\t\t<!-- Hours -->\n\t\t\t\t\t<div class="hourly-totals-card_rate-field">\n\t\t\t\t\t\t<number-selector-field class="s has-dirty-styling hourly-totals-card_hours" ng-model="salaryRate.SalaryRateHoursForPeriod" field-name="salaryRate-{{teamMember.UserID}}-{{$index}}" max="$root.CONFIG.number7Digits4Decimal" min="$root.CONFIG.numberMin" ng-regex-key="decimalFourPlaces"></number-selector-field>\n\n\t\t\t\t\t\t<div class="form-errors hourly-totals-card_rate-errors fadeIn" ng-if="hourlyTotalsForm[\'salaryRate-\' + teamMember.UserID + \'-\' + $index].$touched" ng-messages="hourlyTotalsForm[\'salaryRate-\' + teamMember.UserID + \'-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Max: {{$root.CONFIG.number7Digits4Decimal}}</p>\n\t\t\t\t\t\t\t<p ng-message="min">Min: {{$root.CONFIG.numberMin}}</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredTeamMembers.length === 0"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</fieldset>\n\n\t<div class="form-content-block">\n\t\t<h6>Can\'t find an hourly rate?</h6>\n\t\t<p class="s">Make sure you\'ve set it up in the team member\'s profile. If you think there\'s a problem, please contact support.</p>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="hourlyTotalsForm.state" disable-button="!hourlyTotalsForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No hourly paid team members -->\n<placeholder placeholder-graphic="supplementary-payments" ng-if="pageState === \'no-hourly-paid-team-members\'">\n\t<placeholder-title>No hourly paid team members</placeholder-title>\n\t<placeholder-copy>\n\t\t<p>Team members set to \u2018Paid hourly\u2019 in their pay information will appear here. </p>\n\t</placeholder-copy>\n\t<placeholder-secondary-actions>\n\t\t<a href="" ui-sref="team.members({agencyProfileId: formOptions.agencyProfileId})" ng-if="$root.currentUser.Permissions.isTeamVisible">Go to your Team area&nbsp;&nbsp;<i class="icon-chevron-right"></i></a>\n\t</placeholder-secondary-actions>\n</placeholder>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/leaverMadeInError/leaver-made-in-error.form.html','<loading-block ng-if="$ctrl.componentState === COMPONENT_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="leaverMadeInErrorForm" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.confirm" ng-submit="$ctrl.leaverMadeInError(leaverMadeInErrorForm, $ctrl.teamMember)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure {{$ctrl.formOptions.context.Forename}} was made a leaver in error?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}} will be moved back to your Team area, will appear on payroll again, and their leave date and P45 will be deleted.\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\u2019s P45 will also be removed from their Pay Portal. {{$ctrl.formOptions.context.Forename}} will need to be marked as\n\t\t\t\t\ta previously submitted leaver if you later realise you\u2019ve added them back to the team in error. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<note note-title="Leavers made in error and their P45" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tPlease note that once a P45 is deleted, after you confirm that a team member was made a leaver in error, this cannot be undone.\n\t\t\t\t\t\t\tYou may wish to download a copy of it before you continue.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<!-- Note: Automated pensions -->\n\t\t\t<div class="form-state-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Leaver made in error and automated pensions">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tPlease note that if {{::$ctrl.formOptions.context.Forename}} is in an automated pension, they will have been submitted to the provider as a leaver.\n\t\t\t\t\t\t\tIf you wish to maintain their original pension status, they will need to be rejoined to the scheme with the provider.\n\t\t\t\t\t\t\tAlternatively, you can leave their pension status blank, and Paycircle will assess them in the current period.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!leaverMadeInErrorForm.$valid" display-text="\'Confirm\'" state="leaverMadeInErrorForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="is-secondary" fs-show-close="true" fs-title="{{$ctrl.formOptions.context.Forename}} has been added to your team" ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.complete">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}} is now marked as \u2018Active on payroll\u2019 again and their P45 has been deleted.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === $ctrl.COMPONENT_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/link-rates/link-rates.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="linkRatesForm" ng-submit="$ctrl.updateLinkRates($ctrl, linkRatesForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Link rates</h4>\n\t\t<p class="is-small">Adjust the units for your team members\u2019 link rates. To edit link rates, go to the respective team member\u2019s profile.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<search-bar options="$ctrl.searchBarOptions" count="$ctrl.filteredTeamMembers.length"></search-bar>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="hourly-totals-card primary fadeIn" dir-paginate="(teamMemberIndex, teamMember) in $ctrl.filteredTeamMembers = ( $ctrl.teamMembers | filter : $ctrl.searchBarOptions.search.string ) | orderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse | itemsPerPage : $ctrl.searchBarOptions.results.itemsPerPage" current-page="$ctrl.searchBarOptions.currentPageNumber">\n\n\t\t\t<header class="hourly-totals-card_header">\n\t\t\t\t<div class="hourly-totals-card_avatar">\n\t\t\t\t\t<avatar avatar-initial="{{teamMember.UserForename[0]}}" avatar-size="is-small" avatar-user-id="{{teamMember.UserID}}"></avatar>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="hourly-totals-card_title">\n\t\t\t\t\t<h6 class="hourly-totals-card_name">{{teamMember.UserForename}} {{teamMember.UserSurname}}</h6>\n\t\t\t\t</div>\n\t\t\t</header>\n\n\t\t\t<div class="hourly-totals-card_rates">\n\t\t\t\t<div class="hourly-totals-card_rate" ng-repeat="(payElementIndex, payElement) in teamMember.PayElements">\n\n\t\t\t\t\t<!-- Description -->\n\t\t\t\t\t<p class="hourly-totals-card_rate-description">{{payElement.Label}} - {{payElement.UnitValue | monetise:$root.CONFIG.precision.salaryRates}} (x{{payElement.UnitValueMultiplier}})</p>\n\n\t\t\t\t\t<!-- Hours -->\n\t\t\t\t\t<number-selector-field class="s has-dirty-styling hourly-totals-card_hours" ng-model="payElement.Units" nsf-on-change="$ctrl.calculateTotal(payElement)" field-name="payElement-{{teamMemberIndex}}-{{payElementIndex}}"></number-selector-field>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="$ctrl.searchBarOptions" ng-show="$ctrl.filteredTeamMembers.length === 0"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="$ctrl.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="linkRatesForm.state" disable-button="!linkRatesForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No link rates -->\n<placeholder placeholder-graphic="no-link-elements" ng-if="$ctrl.pageState === \'no-link-rates\'">\n\t<placeholder-title>No link rates</placeholder-title>\n\t<placeholder-copy>\n\t\t<p>Once you&apos;ve added link rates to any team members they will appear here so you can add changes each pay period.</p>\n\t</placeholder-copy>\n</placeholder>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/manage-rolled-up-holiday/manage-rolled-up-holiday.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="manageRolledUpHolidayForm" ng-submit="saveForm(manageRolledUpHolidayForm)" class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<fieldset>\n\t\t<section class="form-section">\n\t\t\t<div class="form-intro" data-cy="manage-rolled-up-holiday-form-intro-text">\n\t\t\t\t<p class="s primary">\n\t\t\t\t\tYou\'re managing rolled up holiday for\n\t\t\t\t\t<ng-pluralize count="formOptions.userIds.length" when="{\n\t\t\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t\t\t}">\n\t\t\t\t\t</ng-pluralize>.\n\t\t\t\t\tSelect if you wish to turn it on or off and click \'Save\' to update their pay information.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div data-cy="manage-rolled-up-holiday-form-note">\n\t\t\t\t<note note-theme="primary">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<label class="is-large">Rolled up holiday</label>\n\n\t\t\t\t\t\t<div class="spacer xs"></div>\n\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tThis will calculate {{formOptions.payeDetails.PAYERolledUpHolidayPayRate}}% of gross salary, plus any pay elements with \'Holiday Pay\' toggled on, and add a \'Rolled Up Holiday Pay\' amount to each pay period. Salary can be excluded from the calculation if required.\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<label class="required">Calculate and pay every period?</label>\n\n\t\t\t\t\t\t<div class="spacer s"></div>\n\n\t\t\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<!-- No -->\n\t\t\t\t\t\t\t\t\t<input class="b" data-cy="manage-rolled-up-holiday-form-input-false" id="isRolledUpHolidayFalse" name="isRolledUpHoliday" ng-disabled="manageRolledUpHolidayForm.state === \'saving\'" ng-model="formOptions.isRolledUpHoliday" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="isRolledUpHolidayFalse">No</label>\n\t\t\t\n\t\t\t\t\t\t\t\t\t<!-- Yes -->\n\t\t\t\t\t\t\t\t\t<input class="b" data-cy="manage-rolled-up-holiday-form-input-true" id="isRolledUpHolidayTrue" name="isRolledUpHoliday" ng-disabled="manageRolledUpHolidayForm.state === \'saving\'" ng-model="formOptions.isRolledUpHoliday" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="isRolledUpHolidayTrue">Yes</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="fadeIn" ng-if="formOptions.isRolledUpHoliday">\n\t\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t\t<toggle-input data-cy="manage-rolled-up-holiday-form-exclude-salary-toggle" field-label="Exclude salary" field-model="formOptions.excludeSalaryFromRolledUpHoliday" field-name="excludeSalary"></toggle-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</section>\n\t</fieldset>\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" data-cy="manage-rolled-up-holiday-form-button-close" ng-click="closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="save" state="manageRolledUpHolidayForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Rolled up holiday updated" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tRolled up holiday has been updated in the pay information for\n\t\t\t<ng-pluralize count="formOptions.userIds.length" when="{\n\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t}">\n\t\t\t</ng-pluralize>. \n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/maternityPay/maternityPayForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Maternity Pay -->\n<section class="fadeIn" ng-if="pageState === \'ready\'" ng-switch="maternityPay.step">\n\t<!-- Start Date -->\n\t<form class="fadeIn" name="maternityPayFormStepCalculate" ng-submit="getMaternitySalaryPayments(maternityPay, maternityPayFormStepCalculate)" pc-switch-when="MATERNITY_PAY_STEPS.calculate" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s">You should have received a Maternity Certificate (MAT B1 Form) from {{formOptions.context.Forename}} and it may be useful to have it to hand before you begin.</p>\n\t\t</div>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>When should maternity pay begin?</h4>\n\t\t\t<p class="s">Tell us the due date and hit &lsquo;Calculate&rsquo; to find out the earliest possible start date</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Due Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="duedate" ng-class="{\'disabled\': maternityPay.hasStartDateBeenCalculated}">Due date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-disabled="maternityPay.hasStartDateBeenCalculated" field-id="duedate" field-max-date-iso="maternityPay.dueDateISOMax" field-read-only="maternityPay.IsFromIntegration" field-style="l" field-value-iso="maternityPay.DueDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t\t&nbsp;\n\t\t\t\t\t<a class="button" data-cy="maternity-due-date-boundaries-calculcate-button" href="" ng-class="{\'disabled\': maternityPayFormStepCalculate.duedate.$invalid}" ng-click="getMaternityDateBoundaries(maternityPay)" ng-if="!maternityPay.hasStartDateBeenCalculated && !maternityPay.IsFromIntegration">Calculate</a>\n\t\t\t\t\t<a class="button" data-cy="maternity-due-date-boundaries-recalculcate-button" href="" ng-class="{\'disabled\': maternityPayFormStepCalculate.duedate.$invalid}" ng-click="resetDueDate(maternityPay)" ng-if="maternityPay.hasStartDateBeenCalculated && !maternityPay.IsFromIntegration">Recalculate</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="maternityPayFormStepCalculate.duedate.$error" ng-show="maternityPayFormStepCalculate.duedate.$touched" role="alert">\n\t\t\t\t\t<p data-cy="maternity-due-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s due date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="maternity-due-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\tPlease enter a valid due date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="maternity-due-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\tMaternity pay can only be added up to {{$root.CONFIG.parentalDueDateMaxWeeksInFuture}} weeks\n\t\t\t\t\t\tof the due date, before {{maternityPay.dueDateISOMax | dateformat:\'long\'}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" ng-if="maternityPay.TeamMemberMaternityStatus === 1">Please enter a due date</p>\n\t\t\t\t<p class="form-message fadeIn" data-cy="maternity-due-date-message" ng-if="maternityPayFormStepCalculate.duedate.$valid">\n\t\t\t\t\t{{maternityPay.DueDateISO | dateformat:\'long\'}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Start Date -->\n\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.hasStartDateBeenCalculated">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="startdate" ng-class="{\'disabled\': maternityPay.WasBabyBornEarly}">Maternity leave start date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="startdate" field-min-date-iso="maternityPay.StartDateMinISO" field-style="l" field-disabled="maternityPay.WasBabyBornEarly" field-read-only="maternityPay.IsFromIntegration" field-value-iso="maternityPay.StartDateISO" field-on-change-fn="onMaternityPayStartDateChange(maternityPay)">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="maternityPayFormStepCalculate.startdate.$error" ng-show="maternityPayFormStepCalculate.startdate.$touched" role="alert">\n\t\t\t\t\t<p data-cy="maternity-start-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\tPlease enter a start date after {{maternityPay.StartDateMinISO | dateformat}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="maternity-start-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s maternity leave start date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="maternity-start-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\tPlease enter a valid start date\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" data-cy="maternity-start-date-min-message" ng-if="maternityPayFormStepCalculate.duedate.$valid">\n\t\t\t\t\tThis date must be on or after {{maternityPay.StartDateMinISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- End Date -->\n\t\t\t<fieldset class="fadeIn" ng-if="maternityPay.isEndDateEditable">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="enddate">Maternity leave end date:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="enddate" field-min-date-iso="maternityPay.EndDateMinISO" field-max-date-iso="maternityPay.EndDateMaxISO" field-on-change-fn="onMaternityPayEndDateChange(maternityPay)" field-on-focus-fn="setIsEndDateCommsVisible(maternityPay, true)" field-read-only="maternityPay.IsFromIntegration" field-style="l" field-value-iso="maternityPay.EndDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="maternityPayFormStepCalculate.enddate.$error" ng-show="maternityPayFormStepCalculate.enddate.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="maternity-end-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tPlease enter an end date from {{maternityPay.EndDateMinISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-end-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\tPlease enter an end date up to {{maternityPay.EndDateMaxISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-end-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s maternity leave end date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-end-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\tPlease enter a valid end date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message fadeIn" data-cy="maternity-end-date-min-message" ng-if="maternityPayFormStepCalculate.duedate.$valid">\n\t\t\t\t\t\tThis can\'t be earlier than {{maternityPay.EndDateMinISO | dateformat}} or later than {{maternityPay.EndDateMaxISO | dateformat}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- End date comms -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.isEndDateCommsVisible">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-on-dismiss="setIsEndDateCommsVisible(maternityPay, false, true)" note-theme="indifferent" note-title="Statutory maternity pay calculated in full weeks">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPlease note that statutory maternity pay will be calculated in full weeks based on the start date.\n\t\t\t\t\t\t\t\tIf the end date you\u2019ve entered falls in a part week, that week will be ignored when calculating statutory maternity payments.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<!-- Born early -->\n\t\t<fieldset class="fadeIn" ng-if="maternityPay.StartDateISO">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input checkbox id="wasBabyBornEarly" label-text="\'The baby was born early\'" name="wasBabyBornEarly" ng-disabled="maternityPay.IsFromIntegration" ng-model="maternityPay.WasBabyBornEarly" type="checkbox">\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message" data-cy="maternity-born-early-message">\n\t\t\t\t\tCheck this box if the birth date is earlier than the due date on the MAT B1\n\t\t\t\t\tform due to the baby being born early, a pregnancy related illness, or a stillbirth.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="maternityPay.WasBabyBornEarly">\n\n\t\t\t\t<!-- Birth Date -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="birthDate">Birth date:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="birthDate" field-min-date-iso="maternityPay.BirthDateMinISO" field-read-only="maternityPay.IsFromIntegration" field-style="l" field-value-iso="maternityPay.BirthDateISO"></date-input-field>\n\t\t\t\t\t\t&nbsp;\n\t\t\t\t\t\t<a class="button" data-cy="maternity-birth-date-recalculcate-button" href="" ng-class="{\'disabled\': maternityPayFormStepCalculate.birthDate.$invalid}" ng-click="onMaternityPayBirthDateChange(maternityPay)" ng-if="!maternityPay.IsFromIntegration">Recalculate</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="maternityPayFormStepCalculate.birthDate.$error" ng-show="maternityPayFormStepCalculate.birthDate.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="maternity-birth-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tPlease enter a birth date after {{maternityPay.BirthDateMinISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-birth-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter a birth date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-birth-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\tPlease enter a valid birth date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message fadeIn" data-cy="maternity-birth-date-message">\n\t\t\t\t\t\tThis date must be after {{maternityPay.BirthDateMinISO | dateformat}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Early start Date -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.EarlyStartDateISO">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="earlyStartDateIso">Maternity leave start date:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="earlyStartDateIso" field-style="l primary-flat" field-read-only="true" field-value-iso="maternityPay.EarlyStartDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message fadeIn" data-cy="maternity-early-start-date-message">\n\t\t\t\t\t\t{{maternityPay.EarlyStartDateISO | dateformat:\'long\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="maternityPay.maternityDatesState === \'ready\' && maternityPayFormStepCalculate.startdate.$valid">\n\t\t\t<!-- Paid in full? -->\n\t\t\t<fieldset class="fadeIn" ng-if="maternityPay.IsHistoricSchedule">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="paidInFullTrue" class="required">Has the schedule already been paid in full?</label>\n\t\t\t\t\t\t<p class="is-small">As the leave end date is before the start of your current period, choose whether you wish to add an outstanding payment to payroll.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullTrue" ng-model="maternityPay.IsPaidInFull" theme="is-tight" value="true">\n\t\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t\t<h6>Yes</h6>\n\t\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t\t<p class="is-small">You\u2019ll need to enter the payments already made for this schedule.</p>\n\t\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t\t</extended-radio>\n\t\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullFalse" ng-model="maternityPay.IsPaidInFull" theme="is-tight" value="false">\n\t\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t\t<h6>No</h6>\n\t\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The schedule will be calculated and the outstanding payment will be added to your current period and included in payroll.</p>\n\t\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t\t</extended-radio>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- In progress schedule? -->\n\t\t\t<fieldset class="fadeIn" ng-if="!maternityPay.IsHistoricSchedule && maternityPay.IsInProgressSchedule">\n\t\t\t\t<!-- Existing schedule? -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<p class="s">If this is an existing maternity pay schedule, where some payments have already been made, toggle the switch below.\n\t\t\t\t\t\t\tThe remainder of the schedule will then be calculated.</p>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<toggle-input field-label="Add payments already made" field-model="maternityPay.HasAmountBroughtForward" field-name="hasAmountBroughtForward"></toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Payments already made -->\n\t\t\t<fieldset ng-if="maternityPay.IsHistoricSchedule || maternityPay.HasAmountBroughtForward" ng-switch="maternityPay.AmountBroughtForwardMethod">\n\t\t\t\t<div class="form-summary no-margin" ng-if="maternityPay.IsHistoricSchedule">\n\t\t\t\t\t<p class="is-small">Enter the payments that were made for this schedule:</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Amount brought forward option -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodTotalAmount" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(maternityPay)" ng-model="maternityPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount" type="radio">\n\t\t\t\t\t\t<label for="amountBroughtForwardMethodTotalAmount" class="s">as a total amount</label>\n\t\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodPerPeriod" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(maternityPay)" ng-model="maternityPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit" type="radio">\n\t\t\t\t\t\t<label for="amountBroughtForwardMethodPerPeriod" class="s">as payments per pay period</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Total payments made so far -->\n\t\t\t\t<div class="form-field fadeIn" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="totalBroughtForward" class="required">Total payments made so far:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise xl" id="totalBroughtForward" maxlength="10" name="totalBroughtForward" ng-min="0" ng-model="maternityPay.TotalBroughtForward" ng-pattern="$root.REGEX.decimal" type="number" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="maternityPayFormStepCalculate.totalBroughtForward.$touched" ng-messages="maternityPayFormStepCalculate.totalBroughtForward.$error" role="alert">\n\t\t\t\t\t\t<p data-cy="maternity-total-brought-forward-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter a number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-total-brought-forward-min-message" ng-message="min">\n\t\t\t\t\t\t\tAmount should be 1p or greater\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="maternity-total-brought-forward-number-message" ng-message="number">\n\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay Period amounts -->\n\t\t\t\t<fieldset ng-switch="maternityPay.paymentsBroughtForwardState" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit">\n\n\t\t\t\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t<circle-loader class="m fadeIn"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Ready -->\n\t\t\t\t\t<div class="form-input-list fadeIn" ng-switch-when="ready">\n\t\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in maternityPay.PaymentsBroughtForward">\n\t\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PayPeriodDisplay}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="brought-forward-payment-{{$index}}" min="0" name="brought-forward-payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="maternityPayFormStepCalculate[\'payment-\' + $index].$touched" ng-messages="maternityPayFormStepCalculate[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t<p data-cy="maternity-payment-amount-required-message" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter an amount\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="maternity-payment-amount-number-message" ng-message="number">\n\t\t\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="maternity-payment-amount-min-message" ng-message="min">\n\t\t\t\t\t\t\t\t\tPlease enter a positive number\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Empty -->\n\t\t\t\t\t<div class="info-block indifferent fadeIn" ng-switch-when="empty">\n\t\t\t\t\t\t<p class="s">Unable to generate brought forward dates</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Advance funding -->\n\t\t\t<fieldset>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input id="advancedFunding" label-text="\'I\\\'ve applied for advance funding for \' + formOptions.context.Forename + \'\\\'s maternity payments\'" name="advancedFunding" ng-change="getTeamMemberMaternityDetailsForAdvanceFunding(maternityPay)" ng-model="maternityPay.HasAdvanceFunding" type="checkbox" checkbox>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">Check this box if you\'ve only applied at this stage or if you\'ve applied and already received the advance funding.</p>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset class="fadeIn" ng-if="maternityPay.AdvanceFunding.length">\n\t\t\t\t\t<div class="form-field" ng-if="maternityPay.AdvanceFunding.length > 1">\n\t\t\t\t\t\t<p class="s">As {{formOptions.context.Forename}}\'s maternity leave will be split across this and next tax year, the amount of advance\n\t\t\t\t\t\t\tfunding you receive may change. You\'ll receive a notification of the new amount from HMRC near the end of this tax year.\n\t\t\t\t\t\t\tIf you already know both amounts enter them below or update {{formOptions.context.Forename}}\'s profile later.</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Advance funding amounts -->\n\t\t\t\t\t<div class="form-field" ng-repeat="(advanceFundingIndex, advanceFunding) in maternityPay.AdvanceFunding">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="advanceFundingCurrent{{advanceFundingIndex}}" ng-class="{\'required\':advanceFundingIndex === 0}">Advance funding amount ({{advanceFunding.TaxYearDisplay}}):</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input class="monetise xl" id="advanceFundingCurrent{{advanceFundingIndex}}" maxlength="10" name="advanceFundingCurrent{{advanceFundingIndex}}" ng-model="advanceFunding.PaymentAmount" ng-pattern="$root.REGEX.decimal" ng-required="advanceFundingIndex === 0" placeholder="0.00" type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="maternityPayFormStepCalculate[\'advanceFundingCurrent\' + advanceFundingIndex].$touched" ng-messages="maternityPayFormStepCalculate[\'advanceFundingCurrent\' + advanceFundingIndex].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="maternity-advance-payment-amount-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter a number\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="maternity-advance-payment-amount-pattern-message" ng-message="pattern">\n\t\t\t\t\t\t\t\tAmount should be 1p or greater\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="maternity-advance-payment-amount-maxlength-message" ng-message="maxlength">\n\t\t\t\t\t\t\t\tMaximum of 10 digits\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="maternity-advance-payment-amount-number-message" ng-message="number">\n\t\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Pro-ration -->\n\t\t\t<fieldset class="fadeIn" ng-if="!maternityPay.IsHistoricSchedule && !maternityPay.IsPaidInFull">\n\n\t\t\t\t<!-- Pro-ration method -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationCompanySetting" name="proRationCompanySetting" ng-model="maternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.companySetting" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\u2019ve worked in a pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationPeriod" name="proRationPeriod" ng-model="maternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.period" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in a pay period\n\t\t\t\t\t\t\t\t\t\tbased on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationManual" name="proRationManual" ng-model="maternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.manual" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\u2019t cover a whole pay period (e.g. the first and last payments of an extended period of leave) pro-ration can be\n\t\t\t\t\t\t\t\t\t\tturned off and any adjustments can be made manually to {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Turn off pro-ration -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Remember to make changes manually">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s normal\n\t\t\t\t\t\t\t\tpay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Salary Sacrifice -->\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<settings-row ng-model="maternityPay.SalarySacrificeState" on-update="reviewStatPaymentSalarySacrifice(maternityPay)" sr-disabled="::getIsStatPaymentSalarySacrificeReadOnly(maternityPay)" sr-field-name="salarySacrificeState" sr-icon="salary-change" sr-theme="secondary">\n\t\t\t\t\t\t<sr-label>Salary sacrifice warnings</sr-label>\n\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\t<span ng-switch="maternityPay.SalarySacrificeBehaviour">\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked">This pay element is included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;OFF&rsquo;.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked">This pay element is not included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;ON&rsquo;.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on">Switch to OFF if you do not wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off">Switch to ON if you wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button disable-button="maternityPayFormStepCalculate.$invalid || maternityPay.maternityDatesState !== \'ready\'" display-text="\'Next\'" state="maternityPayFormStepCalculate.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pay Information -->\n\t<form class="fadeIn" name="maternityPayFormStepEnterPaymentDetails" ng-submit="reviewMaternitySchedulePayments(maternityPay, maternityPayFormStepEnterPaymentDetails)" pc-switch-when="MATERNITY_PAY_STEPS.enterPaymentDetails" novalidate>\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Please give us some pay information</h4>\n\t\t\t\t<p class="s">Please enter the gross amount {{formOptions.context.Forename}} was paid for each of the dates below</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in maternityPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="payment-{{$index}}" min="0" name="payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="maternityPayFormStepEnterPaymentDetails[\'payment-\' + $index].$touched" ng-messages="maternityPayFormStepEnterPaymentDetails[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-fieldset-divider-top" ng-if="!maternityPay.IsHistoricSchedule && !maternityPay.IsPaidInFull">\n\n\t\t\t<!-- Calculation Method -->\n\t \t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="smpScheduleCalculationMethodPeriod" class="required">How do you wish to calculate the SMP schedule?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="smpScheduleCalculationMethodPeriod" name="smpScheduleCalculationMethod" ng-model="maternityPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.periodDates" type="radio">\n\t\t\t\t\t\t\t<label for="smpScheduleCalculationMethodPeriod" class="radio-row-label">On a pay period basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="smpScheduleCalculationMethodWeekly" name="smpScheduleCalculationMethod" ng-model="maternityPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.weekly" type="radio">\n\t\t\t\t\t\t\t<label for="smpScheduleCalculationMethodWeekly" class="radio-row-label">On a weekly basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="updateMaternityDates(maternityPay)">Back</a>\n\t\t\t<submit-button disable-button="!maternityPayFormStepEnterPaymentDetails.$valid" display-text="\'Next\'" state="maternityPayFormStepEnterPaymentDetails.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Occupational Maternity Pay -->\n\t<form class="fadeIn" name="maternityPayFormStepAddSupplementaryOccupationalMaternityPay" ng-submit="goToNextStep(maternityPay)" pc-switch-when="MATERNITY_PAY_STEPS.addSupplementaryOccupationalMaternityPay" novalidate>\n\t\t<fieldset class="fadeIn">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Occupational maternity pay</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Use occupational policy? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="addSupplementaryOccupationalMaternityPayTrue">Do you wish to add supplementary occupational maternity pay?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalMaternityPayTrue" name="addSupplementaryOccupationalMaternityPay" ng-change="onUsePolicyChange(vm, maternityPay)" ng-init="onUsePolicyInit(vm, maternityPay, teamMember)" ng-model="maternityPay.UsePolicy" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalMaternityPayTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalMaternityPayFalse" name="addSupplementaryOccupationalMaternityPay" ng-change="onUsePolicyChange(vm, maternityPay)" ng-model="maternityPay.UsePolicy" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalMaternityPayFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Loading state -->\n\t\t\t<div class="form-section" ng-if="maternityPay.UsePolicy && vm.loadingStatePolicies === \'loading\'">\n\n\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t<loading-block></loading-block>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="maternityPay.UsePolicy && vm.loadingStatePolicies === \'ready\'">\n\n\t\t\t<!-- Select a policy -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="maternityPolicy" class="required">Select a policy:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="maternityPolicy" name="maternityPolicy" ng-change="onSelectMaternityPolicy(maternityPay, teamMember)" ng-model="maternityPay.Policy" ng-options="maternityPolicy as maternityPolicy.PolicyName for maternityPolicy in vm.maternityPolicies | orderBy: \'PolicyName\' track by maternityPolicy.PolicyID" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Policy details -->\n\t\t\t<fieldset class="fadeIn" ng-if="maternityPay.Policy">\n\n\t\t\t\t<!-- Valid maternity policy selection - show policy -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.Policy.isValid" ng-switch="maternityPay.TeamMemberMaternityStatus">\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<p class="caption">\n\t\t\t\t\t\t\tPayment bands are set to &lsquo;{{utilities.toUnsentenceCase(POLICY_PAY_BASES_DESCRIPTIONS[maternityPay.Policy.PolicyPayBasis])}}&rsquo;.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Unable to use average weekly earnings policy -->\n\t\t\t\t\t<div class="form-section fadeIn" ng-if="maternityPay.Policy.PolicyPayBasis === POLICY_PAY_BASES.averageWeeklyPercent" pc-switch-when="STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient">\n\n\t\t\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t\t\t<!-- Feedback note -->\n\t\t\t\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="An average weekly earnings policy can\u2019t be used">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tBased on {{formOptions.context.Forename}}\u2019s employment dates, an average weekly earnings figure can\u2019t be calculated, so a maternity policy with pay rates set to\n\t\t\t\t\t\t\t\t\t&lsquo;Percentage of average weekly earnings&rsquo; can\u2019t be selected.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t<pc-pluralise count="maternityPay.Policy.PolicyBands.length" multiple="{{maternityPay.Policy.policyBandDescription}}s" single="{{maternityPay.Policy.policyBandDescription}}"></pc-pluralise>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Payment bands -->\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in maternityPay.Policy.PolicyBands" policy="maternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Invalid maternity policy selection > % of annual salary policy but no annual salary -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="!maternityPay.Policy.isValid">\n\n\t\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t\t<!-- No valid annual salary -->\n\t\t\t\t\t<note ng-if="maternityPay.Policy.noAnnualSalarySaved" note-icon="icon-warning" note-theme="tertiary" note-title="No annual salary saved">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tEntitlement bands for the selected policy are set to &lsquo;{{POLICY_PAY_BASES_DESCRIPTIONS[maternityPay.Policy.PolicyPayBasis]}}&rsquo; but\n\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} doesn\u2019t have an annual salary saved in their pay information.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="goToPreviousStep(maternityPay)">Back</a>\n\t\t\t<submit-button disable-button="!maternityPayFormStepAddSupplementaryOccupationalMaternityPay.$valid" display-text="\'Next\'" state="maternityPayFormStepAddSupplementaryOccupationalMaternityPay.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Preview -->\n\t<form class="fadeIn" name="maternityPayFormStepReviewSchedule" ng-init="getMaternitySchedulePayments(maternityPay)" ng-submit="updateTeamMemberMaternitySchedulePayments(maternityPay, maternityPayFormStepReviewSchedule)" ng-switch="maternityPay.loadingStateSchedulePayments" pc-switch-when="MATERNITY_PAY_STEPS.reviewSchedule" novalidate>\n\n\t\t<!-- Loading summary -->\n\t\t<fieldset ng-switch-when="loading">\n\t\t\t<loading-block></loading-block>\n\t\t</fieldset>\n\n\t\t<!-- Schedule summary -->\n\t\t<fieldset class="fadeIn" ng-switch-when="ready">\n\n\t\t\t<!-- Historic schedule -->\n\t\t\t<div class="form-section fadeIn" ng-if="maternityPay.IsPaidInFull">\n\t\t\t\t<notification-card theme="is-secondary">\n\t\t\t\t\t<nc-description>\n\t\t\t\t\t\t<span class="strong">Complete</span> on {{maternityPay.PaidInFullPayDateISO | dateformat}}\n\t\t\t\t\t</nc-description>\n\t\t\t\t</notification-card>\n\t\t\t</div>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<header class="form-intro-header">\n\t\t\t\t\t<a class="link-with-icon form-intro-action" href="" ng-click="$root.print()"><i class="icon-print"></i>Print</a>\n\t\t\t\t\t<h4>{{formOptions.context.Forename}}\'s maternity payment schedule</h4>\n\t\t\t\t</header>\n\t\t\t\t<p class="s">The below maternity payments will be automatically added to payroll for the respective pay periods.</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<stat-payment-summary-card on-edit="updateMaternityDates(maternityPay)" stat-payment="maternityPay" stat-payment-type="maternity">\n\t\t\t\t</stat-payment-summary-card>\n\t\t\t</div>\n\n\t\t\t<!-- Pro-ration -->\n\t\t\t<div class="form-section" ng-if="!maternityPay.IsHistoricSchedule && !maternityPay.IsPaidInFull">\n\t\t\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<div ng-switch="maternityPay.ProRatingMethod">\n\n\t\t\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t\t\t<p class="s" data-cy="maternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.companySetting">\n\t\t\t\t\t\t\t\tStandard pro-ration is being used where the schedule doesn\u2019t cover whole pay\n\t\t\t\t\t\t\t\tperiods. <a href="" class="indifferent underline" data-cy="maternity-pro-ration-setting-change-action" ng-click="updateMaternityDates(maternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t\t\t<p class="s" data-cy="maternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\t\tPeriod pro-ration is being used where the schedule doesn\'t cover whole pay\n\t\t\t\t\t\t\t\tperiods. <a href="" class="indifferent underline" data-cy="maternity-pro-ration-setting-change-action" ng-click="updateMaternityDates(maternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t\t\t<p class="s" data-cy="maternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.manual">\n\t\t\t\t\t\t\t\tPro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustments to {{formOptions.context.Forename}}\'s pay will need to be\n\t\t\t\t\t\t\t\tmade manually. <a href="" class="indifferent underline" data-cy="maternity-pro-ration-setting-change-action" ng-click="updateMaternityDates(maternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- Tabs for payments and policy if using a policy -->\n\t\t\t<fieldset class="no-print" ng-if="maternityPay.UsePolicy">\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<navigation-tabs>\n\t\t\t\t\t   <a href="" data-cy="maternity-policy-payments" ng-class="{\'active\': maternityPay.reviewScheduleView === \'payments\'}" ng-click="maternityPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t\t   <a href="" data-cy="maternity-policy-policy" ng-class="{\'active\': maternityPay.reviewScheduleView === \'policy\'}" ng-click="maternityPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t\t\t</navigation-tabs>\n\t\t\t\t</section>\n\t\t\t</fieldset>\n\n\t\t\t<div class="form-tab-content no-print" ng-switch="maternityPay.reviewScheduleView">\n\t\t\t\t<div class="form-section" ng-switch-when="payments" ng-if="maternityPay.SchedulePayments.length > 0">\n\t\t\t\t\t<payment-schedule can-edit-occupational-payment-values="true" occupational-payment-label="OMP" schedule-payments="maternityPay.SchedulePayments" schedule-payment-label="SMP" show-occupational-policy-payment-values="maternityPay.UsePolicy" statutory-pay-calculation-method="maternityPay.CalculationMethod"></payment-schedule>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tThe below entitlement bands are from &lsquo;{{maternityPay.Policy.PolicyName}}&rsquo; and used to calculate\n\t\t\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t<pc-pluralise count="maternityPay.Policy.PolicyBands.length" single="{{maternityPay.Policy.policyBandDescription}}" multiple="{{maternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in maternityPay.Policy.PolicyBands" policy="maternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- For printing only - payments and policy info (as applicable)-->\n\t\t\t<div class="print-only">\n\t\t\t\t<h5>Payments</h5>\n\t\t\t\t<div class="form-section" ng-if="maternityPay.SchedulePayments.length > 0">\n\t\t\t\t\t<payment-schedule occupational-payment-label="OMP" schedule-payments="maternityPay.SchedulePayments" schedule-payment-label="SMP" show-occupational-policy-payment-values="maternityPay.UsePolicy" statutory-pay-calculation-method="maternityPay.CalculationMethod"></payment-schedule>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section print-only-page-break" ng-if="maternityPay.UsePolicy">\n\t\t\t\t\t<h5>Maternity policy</h5>\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tThe below entitlement bands are from &lsquo;{{maternityPay.Policy.PolicyName}}&rsquo; and used to calculate\n\t\t\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t<pc-pluralise count="maternityPay.Policy.PolicyBands.length" single="{{maternityPay.Policy.policyBandDescription}}" multiple="{{maternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in maternityPay.Policy.PolicyBands" policy="maternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="maternityPay.HasAdvanceFunding">\n\t\t\t\t<p class="s">You\'ve received <strong>{{maternityPay.advanceFundingTotalAmount | monetise}}</strong> in advance funding for {{formOptions.context.Forename}}\'s Maternity\n\t\t\t\t\tpayments and each time you approve your payroll, HMRC will automatically use what\'s left to reduce what you owe on your\n\t\t\t\t\tadvance payment. <a href="" class="underline tertiary" data-cy="maternity-edit-amounts" ng-click="updateMaternityDates(maternityPay)">Edit amount</a></p>\n\t\t\t</div>\n\n\t\t\t<fieldset class="form-actions">\n\t\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="goToPreviousStep(maternityPay)">Back</a>\n\t\t\t\t<submit-button disable-button="!maternityPayFormStepReviewSchedule.$valid" display-text="\'Save &amp; finish\'" state="maternityPayFormStepReviewSchedule.state"></submit-button>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t</form>\n</section>\n\n<!-- Dates incorrect -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="{{formOptions.context.Forename}}\'s maternity dates are incomplete" ng-if="pageState === \'date-details-missing\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided don\'t allow us to calculate the correct statutory maternity pay for {{formOptions.context.Forename}}.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\tthem eligible to receive statutory maternity pay, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Not Eligible (Employment details insufficient, earnings too low or continuous employment criteria not met) -->\n<form class="fadeIn" name="notEligibleForSMPForm" ng-if="pageState === \'not-eligible\'" ng-submit="createNilSchedule(maternityPay, notEligibleForSMPForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="{{formOptions.context.Forename}} doesn\'t qualify for Statutory Maternity Pay">\n\t\t<fs-main>\n\t\t\t<statutory-parental-pay-not-eligible eligibility-date-min-iso="maternityPay.maternityPayEligibilityDateMinIso" forename="{{formOptions.context.Forename}}" is-leaver="teamMember.Company.IsLeaver" is-policies-applicable="maternityPay.isPoliciesApplicable" leave-date-iso="teamMember.Company.LeaveDateISO" parental-type="maternity" pay-errors="maternityPay.TeamMemberMaternityErrors" pay-status="maternityPay.TeamMemberMaternityStatus" salary-payments="maternityPay.SalaryPayments" today-iso="TODAY_ISO"></statutory-parental-pay-not-eligible>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Next\'" state="notEligibleForSMPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- PAYE information missing -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="The maternity dates fall into a new tax year" ng-if="pageState === \'paye-details-missing\'">\n\t<fs-main>\n\t\t<p class="s">We are missing the latest PAYE tax and National Insurance figures for some of the tax years that the maternity pay dates fall in.</p>\n\t\t<p class="s">Please&nbsp;contact support&nbsp; and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Duplicate payment schedule -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="A payment schedule already exists" ng-if="pageState === \'duplicate-payment-schedule\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided overlap with an existing statutory payment schedule for {{formOptions.context.Forename}}.\n\t\t\tYou can either delete the existing schedule or click \'Back\' to change the dates you have provided.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Payroll has already been run -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pay periods have already been run" ng-if="pageState === \'payroll-has-run\'">\n\t<fs-main>\n\t\t<p class="s">The dates you have provided overlap with pay periods that have already been run.</p>\n\t\t<p class="s">If you believe this to be incorrect, please&nbsp;contact support&nbsp; and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Saved!" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s" data-cy="maternity-success-messsage">{{formOptions.context.Forename}}\'s maternity will begin on <span data-cy="maternity-success-messsage-date">{{maternityPay.StartDateISO | dateformat}}</span>.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/maternityPay/maternityPayViewForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- View Maternity Pay -->\n<form name="viewMaternityPayViewForm" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Complete -->\n\t<div class="form-section fadeIn" ng-if="maternityPay.IsPaidInFull">\n\t\t<notification-card theme="is-secondary">\n\t\t\t<nc-description>\n\t\t\t\t<p><span class="strong">Complete</span> on {{maternityPay.PaidInFullPayDateISO | dateformat}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<!-- Managed by integration -->\n\t<div class="form-section fadeIn" data-cy="integration-banner" ng-if="maternityPay.IsFromIntegration">\n\t\t<notification-card data-cy="maternity-pay-integration-banner" theme="is-indifferent">\n\t\t\t<nc-description>\n\t\t\t\t<p><i class="icon-information m is-indifferent"></i>&nbsp;&nbsp;&nbsp;{{edpTopicMessage}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<div class="form-intro" ng-if="!maternityPay.updateReason">\n\t\t<header class="form-intro-header">\n\t\t\t<a href="" ng-click="$root.print()" class="link-with-icon form-intro-action"><i class="icon-print m"></i>Print</a>\n\t\t\t<h4>{{formOptions.context.Forename}}\'s maternity payment schedule</h4>\n\t\t</header>\n\t\t<p class="s">The below maternity payments will be automatically added to payroll for the respective pay periods.</p>\n\t</div>\n\n\t<div class="form-intro" ng-if="maternityPay.updateReason">\n\t\t<h4>{{formOptions.context.Forename}}\'s {{maternityPay.updateReason ? \'re-calculated\' : \'\'}} maternity schedule</h4>\n\t\t<p class="s">\n\t\t\t{{formOptions.context.Forename}}\'s maternity payments have been re-calculated with and will continue to be automatically added to payroll for the respective pay periods. If you\'re happy\n\t\t\twith your changes click &lsquo;Save schedule&rsquo;.\n\t\t</p>\n\t</div>\n\n\t<!-- Payment Summary -->\n\t<div class="form-section">\n\n\t\t<stat-payment-summary-card can-edit="maternityPay.CanBeUpdated" on-edit="setPageState(\'update\')" stat-payment="maternityPay" stat-payment-type="maternity">\n\t\t</stat-payment-summary-card>\n\n\t</div>\n\n\t<!-- Pro-ration -->\n\t<div class="form-content-block" ng-if="!maternityPay.IsHistoricSchedule">\n\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t<ib-main>\n\t\t\t\t<div ng-switch="maternityPay.ProRatingMethod">\n\n\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t<!-- Pro-ration is a payroll-only setting, not EDP-sourced data, so it stays editable regardless of maternityPay.IsFromIntegration -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.companySetting">Standard pro-ration is being used where the schedule doesn\u2019t cover whole pay periods. <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\n\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.period">Period pro-ration is being used where the schedule doesn\'t cover whole pay periods. <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\n\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.manual">Pro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustments to {{formOptions.context.Forename}}\'s pay will need to be made manually. <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\t\t\t\t</div>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<!-- Tabs for payments and policy if using a policy -->\n\t<fieldset class="no-print" ng-if="maternityPay.UsePolicy">\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a href="" ng-class="{\'active\': maternityPay.reviewScheduleView === \'payments\'}" ng-click="maternityPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t<a href="" ng-class="{\'active\': maternityPay.reviewScheduleView === \'policy\'}" ng-click="maternityPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content no-print" ng-switch="maternityPay.reviewScheduleView">\n\t\t<div class="form-section" ng-switch-when="payments" ng-if="maternityPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule can-edit-occupational-payment-values="false" occupational-payment-label="OMP" schedule-payments="maternityPay.SchedulePayments" schedule-payment-label="SMP" show-occupational-policy-payment-values="maternityPay.UsePolicy" statutory-pay-calculation-method="maternityPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe below payments bands are based on a {{::POLICY_PAY_BASES_DESCRIPTIONS[maternityPay.Policy.PolicyPayBasis] | lowercase }}\n\t\t\t\t\tand were used to calculate occupational payments:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<pc-pluralise count="maternityPay.Policy.PolicyBands.length" single="{{maternityPay.Policy.policyBandDescription}}" multiple="{{maternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in maternityPay.Policy.PolicyBands" policy="maternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- For printing only - payments and policy info (as applicable)-->\n\t<div class="print-only">\n\t\t<h5>Payments</h5>\n\t\t<div class="form-section" ng-if="maternityPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule occupational-payment-label="OMP" schedule-payments="maternityPay.SchedulePayments" schedule-payment-label="SMP" show-occupational-policy-payment-values="maternityPay.UsePolicy" statutory-pay-calculation-method="maternityPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\t\t<div class="form-section print-only-page-break" ng-if="maternityPay.UsePolicy">\n\t\t\t<h5>Maternity policy</h5>\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe below entitlement bands are from \u2018{{maternityPay.Policy.PolicyName}}\u2019 and used to calculate\n\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<pc-pluralise count="maternityPay.Policy.PolicyBands.length" single="{{maternityPay.Policy.policyBandDescription}}" multiple="{{maternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in maternityPay.Policy.PolicyBands" policy="maternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Advance funding -->\n\t<!-- Advance funding is HMRC financial data, not EDP-sourced, so it stays editable regardless of maternityPay.IsFromIntegration -->\n\t<div class="form-section" ng-if="maternityPay.HasAdvanceFunding">\n\t\t<p class="s">You\'ve received <strong>{{maternityPay.advanceFundingTotalAmount | monetise}}</strong> in advance funding for {{formOptions.context.Forename}}\'s Maternity payments and each time you approve your payroll, HMRC will automatically use what\'s left to reduce what you owe on your advance payment. <a class="underline tertiary" href="" ng-click="openAdvanceMaternityFundingForm(maternityPay.PaymentScheduleGroupID)">Edit amount</a></p>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="canUndoUpdateInProgressOriginal">\n\t\t<div class="note tertiary">\n\t\t\t<p class="s">\n\t\t\t\t{{formOptions.context.Forename}}\'s maternity payment schedule has been updated. If you wish to revert to the original payment schedule, click \'Undo schedule update\' below.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="isUpdatedOriginal && maternityPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s maternity schedule was updated by {{maternityPay.UpdatedBy}} on {{maternityPay.UpdatedDateISO | dateformat}} at {{maternityPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Extended -->\n\t<div class="form-section" ng-if="isExtendedOriginal && maternityPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s maternity schedule was extended by {{maternityPay.UpdatedBy}} on {{maternityPay.UpdatedDateISO | dateformat}} at {{maternityPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Prior to payroll being run -->\n\t<!-- Reachable for an integration-owned record: \'Update schedule\' opens the same edit wizard as the edit pencil, which already keeps EDP-sourced dates read-only -->\n\t<fieldset class="form-actions" ng-if="canBeDeletedOriginal">\n\n\t\t<button class="secondary-action" data-cy="maternity-update-schedule" ng-click="setPageState(\'update\')" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-delete-schedule" ng-click="setPageState(\'delete\')" ng-if="!maternityPay.IsFromIntegration" type="button">\n\t\t\tDelete schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Update schedule -->\n\t<!-- Reachable for an integration-owned record: MATERNITY_UPDATE_OPTIONS is already filtered to payroll-only reasons for those records -->\n\t<fieldset class="form-actions" ng-if="canUpdateInProgressOriginal && !maternityPay.updateReason">\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-update-in-progress-schedule" ng-click="onUpdateScheduleClick(maternityPay)" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Cancel extension -->\n\t<fieldset class="form-actions" ng-if="canCancelExtensionOriginal && !maternityPay.IsFromIntegration">\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-cancel-extension" ng-click="setPageState(\'confirm-cancel-extension\')" type="button">\n\t\t\tCancel extension\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Update \'in-progress\' schedule -->\n\t<fieldset class="form-actions" ng-if="canUpdateInProgressOriginal && maternityPay.updateReason">\n\n\t\t<button class="secondary-action" data-cy="maternity-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-save-and-finish" ng-click="updateTeamMemberMaternitySchedulePayments(maternityPay, viewMaternityPayViewForm)" type="button">\n\t\t\tSave &amp; finish\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Undo \'in-progress\' schedule update -->\n\t<fieldset class="form-actions" ng-if="canUndoUpdateInProgressOriginal">\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-undo-schedule-update" ng-click="setPageState(\'undo-schedule-update\')" type="button">\n\t\t\tUndo schedule update\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Extend schedule -->\n\t<fieldset class="form-actions" ng-if="canBeExtendedOriginal && !canBeDeletedOriginal && !maternityPay.IsFromIntegration">\n\n\t\t<button class="tertiary primary-action" data-cy="maternity-extend-schedule" ng-click="onExtendScheduleClick(maternityPay)" type="button">\n\t\t\tExtend schedule\n\t\t</button>\n\n\t</fieldset>\n\n</form>\n\n<!-- Change pro-ration -->\n<form name="changeProRationForm" ng-submit="updateTeamMemberSchedulePaymentsProRatingMethod(maternityPay, changeProRationForm)" class="fadeIn" ng-if="pageState === \'change-pro-ration\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Change pro-ration method</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationCompanySetting" id="proRationCompanySetting" class="b radio-row-input" ng-value="PRO_RATION_METHODS.companySetting" ng-model="maternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\u2019ve worked in a pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationPeriod" id="proRationPeriod" class="b radio-row-input" ng-value="PRO_RATION_METHODS.period" ng-model="maternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in a pay period based on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationManual" id="proRationManual" class="b radio-row-input" ng-value="PRO_RATION_METHODS.manual" ng-model="maternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\u2019t cover a whole pay period (e.g. the first and last payments of an extended period of leave) pro-ration can be turned off and any adjustments can be made manually to {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Turn off pro-ration -->\n\t\t<div class="form-field fadeIn" ng-if="maternityPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t<note note-theme="indifferent" note-title="Remember to make changes manually" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s normal pay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="changeProRationForm.state" disable-button="!changeProRationForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Update \'not-started\' schedule -->\n<form name="editMaternityPayForm" ng-submit="openEditMaternityPayForm(maternityPay)" class="fadeIn" ng-if="pageState === \'update\'" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to update this schedule?</h4>\n\t\t</header>\n\t\t<p class="s">If you proceed, the existing schedule will be replaced with the new one for {{formOptions.context.Forename}}\'s maternity leave.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="editMaternityPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Update \'in-progress\' schedule -->\n<form class="fadeIn" name="updateMaternityPayForm" ng-if="pageState === \'update-in-progress-schedule\'" ng-submit="updateTeamMemberMaternityScheduleInProgress(maternityPay, updateMaternityPayForm)" ng-switch="maternityPay.updateReason" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Update {{formOptions.context.Forename}}\'s maternity payment schedule</h4>\n\t\t<p class="s">Choose the reason why you wish to update {{formOptions.context.Forename}}\'s maternity schedule.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.updatingMaternitySchedule" underline="true">Read more about ending maternity schedules early</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reason -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="startdate">Why are you updating the schedule?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="maternityReason" name="maternityReason" ng-model="maternityPay.updateReason" ng-options="option.value as option.label for option in MATERNITY_UPDATE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select\u2026</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateMaternityPayForm.maternityReason.$error" ng-if="updateMaternityPayForm.maternityReason.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a reason for the update</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-switch="maternityPay.updateReason">\n\n\t\t<!-- Leaving / Redundancy -->\n\t\t<div class="form-field fadeIn" pc-switch-when="[SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.Redundancy]">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">When do you want the last payment to be made?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select name="lastPaymentPeriodId" id="lastPaymentPeriodId" ng-model="maternityPay.lastPaymentPeriodId" ng-options="payment.AgencyPayPeriodID as payment.PayPeriodDisplay for payment in maternityPay.pendingPayments" required>\n\t\t\t\t\t<option value="">Choose a pay period...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!--- Returning to work early / sharing parental leave with partner / Employee is deceased -->\n\t\t<fieldset pc-switch-when="[\n\t\t\t\tSCHEDULE_UPDATE_REASONS.EmployeeIsDeceased,\n\t\t\t\tSCHEDULE_UPDATE_REASONS.ReturnToWork,\n\t\t\t\tSCHEDULE_UPDATE_REASONS.SharedParentalLeave\n\t\t\t]">\n\t\t\t<div class="form-field fadeIn">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required">What is their last payment date?</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="returnDate" field-min-date-iso="maternityPay.EndDateMinISO" field-max-date-iso="maternityPay.EndDateMaxISO" field-on-focus-fn="setIsEndDateCommsVisible(maternityPay, true)" field-value-iso="maternityPay.EndDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="updateMaternityPayForm.returnDate.$error" ng-if="updateMaternityPayForm.returnDate.$invalid && updateMaternityPayForm.returnDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="min">The date must be from {{maternityPay.EndDateMinISO | dateformat}}</p>\n\t\t\t\t\t<p ng-message="max">The date must be no later than {{maternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">This date must be from {{maternityPay.EndDateMinISO | dateformat}}</p>\n\t\t\t</div>\n\n\t\t\t<!-- End date comms -->\n\t\t\t<div class="form-field fadeIn" ng-if="maternityPay.isEndDateCommsVisible">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-on-dismiss="setIsEndDateCommsVisible(maternityPay, false, true)" note-theme="indifferent" note-title="Statutory maternity pay calculated in full weeks">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note that statutory maternity pay will be calculated in full weeks based on the start date.\n\t\t\t\t\t\t\tIf the end date you\u2019ve entered falls in a part week, that week will be ignored when calculating statutory maternity payments.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Updating maternity leave start date -->\n\t\t<div class="form-field fadeIn" pc-switch-when="SCHEDULE_UPDATE_REASONS.CorrectStartDate">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="startdate">Enter a new maternity leave start date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="startdate" field-min-date-iso="maternityPay.StartDateMinISO" field-value-iso="maternityPay.StartDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateMaternityPayForm.startdate.$error" ng-show="updateMaternityPayForm.startdate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">Please enter a start date after {{maternityPay.StartDateMinISO | dateformat}}</p>\n\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s maternity leave start date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid start date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn" ng-if="updateMaternityPayForm.duedate.$valid">This date must be on or after {{maternityPay.StartDateMinISO | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- Re-enter gross payments -->\n\t\t<fieldset class="fadeIn" pc-switch-when="[SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.CorrectEndDate, SCHEDULE_UPDATE_REASONS.CorrectStartDate, SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased, SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.Redundancy, SCHEDULE_UPDATE_REASONS.ReturnToWork, SCHEDULE_UPDATE_REASONS.SalaryUpdate, SCHEDULE_UPDATE_REASONS.SharedParentalLeave]">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in maternityPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="updateMaternityPayForm[\'payment-\' + $index].$error" ng-if="updateMaternityPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Update maternity pay\'" state="updateMaternityPayForm.state" disable-button="!updateMaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Extend schedule -->\n<form class="fadeIn" name="updateMaternityPayForm" ng-if="pageState === \'extend-schedule\'" ng-submit="updateTeamMemberMaternityScheduleInProgress(maternityPay, updateMaternityPayForm, \'extend-schedule\')" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s maternity payment schedule</h4>\n\t\t<p class="s">Enter a new end date for the schedule, click &lsquo;Re-calculate&rsquo;, and any additional payments will be calculated.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Original end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Original end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="originalEndDate" field-read-only="true" field-style="is-primary-light" field-value-iso="maternityPay.endDateIsoOriginal">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<p class="form-message">{{maternityPay.EndDateMinISO | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- New end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">New end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="newEndDate" field-max-date-iso="maternityPay.EndDateMaxISO" field-min-date-iso="maternityPay.endDateIsoOriginal" field-value-iso="maternityPay.EndDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateMaternityPayForm.newEndDate.$error" ng-if="updateMaternityPayForm.newEndDate.$invalid && updateMaternityPayForm.newEndDate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">The date must be from {{maternityPay.endDateIsoOriginal | dateformat}}</p>\n\t\t\t\t<p ng-message="max">The date must be no later than {{maternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">This date must be from {{maternityPay.endDateIsoOriginal | dateformat}} and no later than {{maternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Re-enter gross payments -->\n\t<fieldset class="fadeIn">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Payments List -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-input-list">\n\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in maternityPay.SalaryPayments">\n\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="updateMaternityPayForm[\'payment-\' + $index].$error" ng-if="updateMaternityPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Re-calculate\'" state="updateMaternityPayForm.state" disable-button="!updateMaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm extend schedule -->\n<form class="fadeIn" name="extendMaternityPayForm" ng-if="pageState === \'confirm-extend-schedule\'" ng-submit="updateTeamMemberMaternitySchedulePayments(maternityPay, extendMaternityPayForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s maternity payment schedule</h4>\n\t\t<p class="s">{{formOptions.context.Forename}}\'s maternity payments have been re-calculated. Click &lsquo;Confirm&rsquo; to apply the changes.</p>\n\t</div>\n\n\t<!-- Payment Summary -->\n\t<fieldset>\n\n\t\t<div class="form-section">\n\n\t\t\t<stat-payment-summary-card can-edit="maternityPay.CanBeUpdated && !maternityPay.IsFromIntegration" on-edit="setPageState(\'extend-schedule\')" stat-payment="maternityPay" stat-payment-type="maternity">\n\t\t\t</stat-payment-summary-card>\n\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<div class="form-section" ng-if="maternityPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule can-edit-occupational-payment-values="false" occupational-payment-label="OMP" schedule-payments="maternityPay.SchedulePayments" schedule-payment-label="SMP" show-occupational-policy-payment-values="maternityPay.UsePolicy" statutory-pay-calculation-method="maternityPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="extendMaternityPayForm.state" disable-button="!extendMaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm cancel extend schedule -->\n<form class="fadeIn" name="cancelExtendMaternityForm" ng-if="pageState === \'confirm-cancel-extension\'" ng-submit="updateTeamMemberMaternityScheduleInProgressReset(maternityPay, cancelExtendMaternityForm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tCancelling {{formOptions.context.Forename}}\'s maternity payment schedule will reset the schedule and delete any additional payments.\n\t\t\t\tClick &lsquo;Confirm&rsquo; to apply the changes.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button disable-button="!cancelExtendMaternityForm.$valid" display-text="\'Confirm\'" state="cancelExtendMaternityForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Undo \'in-progress\' schedule > confirmation -->\n<form class="fadeIn" name="undoInProgressScheduleUpdateConfirmationForm" ng-if="pageState === \'undo-schedule-update\'" ng-submit="updateTeamMemberMaternityScheduleInProgressReset(maternityPay, undoInProgressScheduleUpdateConfirmationForm)" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to undo this update?</h4>\n\t\t</header>\n\t\t<p class="s">Once you undo this payment schedule update, it will be deleted and the original payment schedule will be restored. If you later realise you\'ve made a mistake, you will need to create this update again. If you\'re happy to proceed, click \'Confirm\' and you\'ll then see the original payment schedule again.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="undoInProgressScheduleUpdateConfirmationForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Delete Schedule confirmation -->\n<form name="deleteMaternityPayForm" ng-submit="deleteTeamMemberStatutoryPay(maternityPay, deleteMaternityPayForm)" class="fadeIn" ng-if="pageState === \'delete\'" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to delete this schedule?</h4>\n\t\t</header>\n\t\t<p class="s">The payment schedule will be removed from {{formOptions.context.Forename}}\'s profile.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="deleteMaternityPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Deleted -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="The payment schedule has been deleted" ng-if="pageState === \'deleted\'">\n\t<fs-main>\n\t\t<p class="s">No payments will be made for {{formOptions.context.Forename}}\'s maternity.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('forms/payroll/move-payrolls/move-payrolls.form.html','<!-- Loading -->\n<loading-block ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="movePayrollsForm" ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.selectCompany" ng-submit="moveToNextStep(pageState, vm, movePayrollsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tOnce you move {{formOptions.context.Forename}} to another payroll, their profile will be moved to your &lsquo;Moved payrolls&rsquo; area for this payroll where you will still be able to\n\t\t\taccess their history and documents. A new profile will be created in the new payroll using the same Year to Date figures, tax and company information.\n\t\t</p>\n\t</div>\n\n\t<div class="form-field">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Moving team members between payrolls">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that any of the following payments you may have previously saved for {{formOptions.context.Forename}} will be deleted, so we recommend making a note of them in case\n\t\t\t\t\tyou wish to add them again later:\n\t\t\t\t</p>\n\t\t\t\t<ul class="note-list">\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tSick pay\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tMaternity pay\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tPaternity pay\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tRepayment schedules (cycle to work, company loan, season ticket loan)\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tAttachment of Earnings Orders\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tBenefits in Kind (company vehicle, healthcare)\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tChildcare vouchers\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class="note-list_item">\n\t\t\t\t\t\tFuture changes\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<h6 class="is-small">\n\t\t\t\t\t\tNational Insurance contributions\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tIf you\u2019re moving {{formOptions.context.Forename}} to a company with a longer pay interval, please review and amend their National Insurance contributions accordingly. We will not\n\t\t\t\t\t\tautomatically aggregate earnings for previous pay periods.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<h6 class="is-small">\n\t\t\t\t\t\tWorkplace pension groups\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tIf you have a workplace pension set up, and the same one is operated by the new company, you will need to confirm which pension group you wish to add\n\t\t\t\t\t\t{{formOptions.context.Forename}} to.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe following companies are on the same PAYE scheme. Select a company then click &lsquo;Next&rsquo;, before confirming you wish to proceed:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t<extended-radio name="companyRadioGroup" ng-model="vm.selectedCompany" ng-repeat="company in companies" required="true" value="company">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<div class="extended-radio_horizontal">\n\t\t\t\t\t\t\t<i class="icon-company l primary">&nbsp;&nbsp;&nbsp;</i>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<p class="m">{{company.CompanyName}}</p>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">{{company.PayrollFrequency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</radio-label>\n\t\t\t\t</extended-radio>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!movePayrollsForm.$valid" display-text="\'Next\'" icon-position="right" icon="icon-chevron-right" state="movePayrollsForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<!-- Confirm payroll move -->\n<form class="fadeIn" name="movePayrollsConfirmationForm" ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.confirmMove" ng-submit="moveToNextStep(pageState, vm, movePayrollsConfirmationForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to move {{formOptions.context.Forename}}?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{formOptions.context.Forename}} is about to be moved from {{formOptions.company.Name}} to {{vm.selectedCompany.CompanyName}}. If you later realise you\u2019ve moved\n\t\t\t\t{{formOptions.context.Forename}} by mistake, you can move {{formOptions.context.Gender | personalise:\'him\'}} between payrolls again. Click \u2018Confirm\u2019 if you\u2019re happy to proceed.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" ng-disabled="movePayrollsConfirmationForm.state === \'saving\'" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Confirm\'" state="movePayrollsConfirmationForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- No companies on same PAYE scheme -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="true" fs-theme="assertive" fs-title="{{formOptions.context.Forename}}\'s payroll cannot be moved" ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.noCompaniesWithSamePAYEScheme">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThere are no companies that have the same PAYE scheme as {{formOptions.company.Name}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Move operation invalid -->\n<form-state form-options="formOptions" fs-icon="information" fs-show-close="true" fs-theme="primary" fs-title="{{formOptions.context.Forename}} can\'t be moved" ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.moveInvalid">\n\t<fs-main ng-switch="vm.invalidMoveReason">\n\t\t<!-- Some of these errors are irrelevant in this specific context. Nevertheless, the API can return any one of these codes, so they\'re all represented -->\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsPayrollsOnDifferentPAYESchemes">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they are on a different PAYE scheme.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsPayrollsInDifferentTaxMonths">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as their payroll isn\'t in the same tax month.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsSamePayroll">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{formOptions.company.Name}} as they are already a team member of the company.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasPaymentScheduleInProgress">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they have a repayment schedule in progress. Review the \'Schedules\' area in their profile for more information.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsLeaver">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they are marked as a leaver.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsCIS">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they are a member of the CIS scheme. CIS team members can\'t be moved between payrolls.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIncomplete">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} until their profile is complete.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasNoNINumber">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} until a National Insurance Number is added for them.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidIsAlreadyPendingMover">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they have already been moved there.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserIsExcluded">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they are marked as excluded from payroll.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserHasAOEInProgress">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they have an Attachment of Earnings Order in progress. Review the \'Schedules\' area in their profile for more information.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserAlreadyExistsOnTargetPayroll">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they are already a team member of the company.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="PAYROLL_MOVE_VALID_STATUSES.InvalidAsUserNeverPaidOnOriginalPayroll">\n\t\t\t{{formOptions.context.Forename}} can\'t be moved to {{vm.selectedCompany.CompanyName}} as they were never previously a member of the company.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="button secondary-action" ng-click="setPageState(MOVE_PAYROLL_PAGE_STATES.selectCompany)" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="formOptions.closeForm()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="false" fs-theme="positive" fs-title="{{formOptions.context.Forename}} has moved payrolls" ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou can now find {{formOptions.context.Forename}}\u2019s profile for {{formOptions.company.Name}} in your \u2018Moved payrolls\u2019 area if you need to view any of their historical data.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action tertiary" ng-click="closeForm()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === MOVE_PAYROLL_PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/niCategoryUpdates/ni-category-updates.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="niCategoryUpdatesForm" ng-submit="$ctrl.updateTeamMembersNICodes($ctrl, niCategoryUpdatesForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tThere&nbsp;<ng-pluralize count="$ctrl.teamMembers.length" when="{\'1\': \'is 1 National Insurance category update\', \'other\': \'are {} National Insurance category updates\'}"></ng-pluralize>&nbsp;available. Select which updates you wish to apply for this pay period. Any that aren\'t applied will be available again next pay period.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<span class="is-small is-greyscale-dark is-strong">\n\t\t\t\t\t<ng-pluralize count="$ctrl.niUpdatesCount" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>&nbsp;will be applied\n\t\t\t\t</span>\n\t\t\t</header>\n\n\t\t\t<div class="form-field-main team-card-basic_wrapper">\n\n\t\t\t\t<team-card-basic team-member="teamMember" has-checkbox="true" ng-model="teamMember.UpdateAccepted" theme="align-actions-right" ng-repeat="teamMember in $ctrl.teamMembers" on-change="$ctrl.updateNiUpdatesCount($ctrl)">\n\t\t\t\t\t<tc-content>\n\t\t\t\t\t\t<span class="is-greyscale is-medium">{{::teamMember.OldNICode}}&nbsp;<i class="icon-chevron-right primary"></i>&nbsp;{{::teamMember.NewNICode}}</span>\n\t\t\t\t\t</tc-content>\n\t\t\t\t</team-card-basic>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="niCategoryUpdatesForm.state" disable-button="niCategoryUpdatesForm.$invalid || $ctrl.niUpdatesCount === 0"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Team {{$ctrl.niUpdatesCount > 1 ? \'members\' : \'member\' }} updated" ng-if="$ctrl.componentState === \'saved\'">\n\t<fs-main>\n\t\t<p>Your selected National Insurance updates have been saved and&nbsp;<ng-pluralize count="$ctrl.niUpdatesCount" when="{\'1\': \'1 team member has\', \'other\': \'{} team members have\'}"></ng-pluralize>&nbsp;been updated.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/onHold/onHoldForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="onHoldForm" ng-submit="updateOnHoldStatus(vm, onHoldForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\t\n\t<section class="form-summary" ng-if="vm.context === CONTEXTS.individualOnHold">\n\t\t<div class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl is-primary"></i>\n\t\t\t<h4>Are you sure you wish to mark {{formOptions.context.Forename}} as \u2018Active on payroll\u2019?</h4>\n\t\t</div>\n\t</section>\n\n\t<div class="form-intro" data-cy="on-hold-form-intro-text">\n\n\t\t<p class="s" ng-switch="vm.context">\n\t\t\t<span pc-switch-when="[CONTEXTS.individualActive, CONTEXTS.bulkActive]">Team members marked as &lsquo;On hold&rsquo; will no longer be included in submissions to HMRC when you approve payroll\n\t\t\t\teach period and they also won\u2019t appear in your current period page. You can mark them as &lsquo;Active on payroll&rsquo; again later from their profile page.\n\t\t\t\t&nbsp;<support-article-link article-key="markAsOnHold" underline="true">Read more about marking employees as &lsquo;On hold&rsquo; for payroll</support-article-link>\n\t\t\t</span>\n\t\t\t<span pc-switch-when="CONTEXTS.individualOnHold">{{formOptions.context.Forename}} will be included in submissions to HMRC when you approve payroll each period\n\t\t\t\tand they will appear in your current period page. You can mark them as\n\t\t\t\t&lsquo;On hold&lsquo; again later from their profile page.</span>\n\t\t\t<span pc-switch-when="CONTEXTS.bulkOnHold">You\u2019re about to mark {{vm.userIds.length}} team members as &lsquo;Active on payroll&rsquo;. They will be included in submissions to HMRC\n\t\t\t\twhen you approve payroll each period and will appear in your current period page. You can mark them as &lsquo;On hold&rsquo; again later from their profile page.</span>\n\t\t</p>\n\t</div>\n\n\t<!-- Marking as on hold -->\n\t<fieldset ng-if="[CONTEXTS.individualActive, CONTEXTS.bulkActive].includes(vm.context)">\n\n\t\t<!-- On hold length type -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header" ng-switch="vm.context">\n\t\t\t\t<label for="onHoldTypeIndefinite" pc-switch-when="CONTEXTS.bulkActive">How long should these team members be marked on hold for?</label>\n\t\t\t\t<label for="onHoldTypeIndefinite" pc-switch-when="CONTEXTS.individualActive">How long should {{::formOptions.context.Forename}} be marked on hold for?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\n\t\t\t\t<extended-radio name="onHoldTypeIndefinite" value="ON_HOLD_TYPES.indefinite" ng-model="vm.onHoldType">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Indefinitely</h6>\n\t\t\t\t\t</radio-label>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio name="onHoldTypePeriodCount" value="ON_HOLD_TYPES.periodCount" ng-model="vm.onHoldType" on-change="focusOnPeriodCount()">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">For a number of pay periods</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-field>\n\t\t\t\t\t\t<input type="number" id="onHoldPeriodCount" name="onHoldPeriodCount" class="s" autocomplete="off" data-cy="on-hold-form-on-hold-period-count" ng-model="vm.onHoldPeriodCount" ng-min="vm.onHoldType === ON_HOLD_TYPES.periodCount ? 1 : 0" ng-disabled="vm.onHoldType !== ON_HOLD_TYPES.periodCount" ng-required="vm.onHoldType === ON_HOLD_TYPES.periodCount">\n\t\t\t\t\t</radio-field>\n\t\t\t\t</extended-radio>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Marking as On hold -->\n\t\t<div class="form-field">\n\t\t\t<note note-title="Marking as \u2018On hold\u2018" note-theme="indifferent is-form-field" note-icon="icon-support" class="fadeIn">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="s">Please note that any of the following payments you may have previously set up for team members will be deleted once you mark them as \'On hold\', so we recommend making a note of them in case you wish to add them again later:</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Sick pay\',\n\t\t\t\t\t\t\t\t\'Maternity pay \',\n\t\t\t\t\t\t\t\t\'Paternity pay \',\n\t\t\t\t\t\t\t\t\'Repayment schedules (cycle to work, company loan, season ticket loan)\',\n\t\t\t\t\t\t\t\t\'Childcare vouchers\',\n\t\t\t\t\t\t\t\t\'Future changes\'\n\t\t\t\t\t\t\t]" bl-theme="is-indifferent is-small is-italicised is-spaced-out"></bullet-list>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="s">If you have a workplace pension set up, it\u2019s also critical you check that any changes in a team members status is also reflected in your pension provider portal. This should ensure that your pension submissions don\'t fail in the future.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="s">Check the box below and click &lsquo;Mark as &lsquo;On hold&rsquo;&rsquo; if you\'re happy to continue.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<input type="checkbox" id="isConfirmed" name="isConfirmed" ng-model="vm.isConfirmed" label-text="\'I understand and would like to continue\'" checkbox>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.isOnHold ? \'Mark as \u2018Active on payroll\u2019\' : \'Mark as \u2018On hold\u2019\'" state="onHoldForm.state" disable-button="!onHoldForm.$valid || !vm.isConfirmed"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Marked as {{formOptions.isOnHold ?\'\u2018Active on payroll\u2019\' : \'\u2018On hold\u2019\'}}" ng-if="pageState === \'success\'">\n\t<fs-main>\n\n\t\t<p class="s" ng-switch="vm.context">\n\t\t\t<span ng-switch-when="individual-active">{{formOptions.context.Forename}} has been marked as &lsquo;On hold&rsquo; and will no longer appear in your current period page or submissions to HMRC when you approve payroll each period.</span>\n\t\t\t<span ng-switch-when="individual-on-hold">{{formOptions.context.Forename}} has been marked as &lsquo;Active on payroll&rsquo; and now appears in your current period page or submissions to HMRC when you approve payroll each period.</span>\n\t\t\t<span ng-switch-when="bulk-active">{{vm.userIds.length}} team members have been marked as &lsquo;On hold&rsquo; and will no longer appear in your current period page or submissions to HMRC when you approve payroll each period.</span>\n\t\t\t<span ng-switch-when="bulk-on-hold">{{vm.userIds.length}} team members have been marked as &lsquo;Active on payroll&rsquo; and will appear in your current period page or submissions to HMRC when you approve payroll each period.</span>\n\t\t</p>\n\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/paternityPay/paternityPayForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Schedule -->\n<div class="fadeIn" ng-if="pageState === \'ready\'" ng-switch="paternityPay.step">\n\t<!-- Start Date -->\n\t<form class="fadeIn" name="paternityPayFormStep1" ng-submit="getPaternitySalaryPayments(paternityPay, paternityPayFormStep1)" pc-switch-when="PATERNITY_PAY_STEPS.calculate" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>When should paternity pay begin?</h4>\n\t\t\t<p class="s">Let us know the due date, the birth date and when the payments will start</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Due Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="duedate">Due date:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="duedate" field-max-date-iso="paternityPay.dueDateISOMax" field-read-only="paternityPay.IsFromIntegration" field-style="l" field-value-iso="paternityPay.DueDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="paternityPayFormStep1.duedate.$error" ng-show="paternityPayFormStep1.duedate.$touched" role="alert">\n\t\t\t\t\t<p data-cy="paternity-due-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter the baby\'s due date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="paternity-due-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\tPlease enter a valid due date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="paternity-due-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\tPaternity pay can only be added up to {{$root.CONFIG.parentalDueDateMaxWeeksInFuture}} weeks of the due date,\n\t\t\t\t\t\tbefore {{paternityPay.dueDateISOMax | dateformat:\'long\'}}.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Birth Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="birthdate">Birth date:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="birthdate" field-on-change-fn="onChangePaternityPayBirthDate(paternityPay)" field-read-only="paternityPay.IsFromIntegration" field-style="l" field-value-iso="paternityPay.BirthDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t\t&nbsp;\n\t\t\t\t\t<a class="button" data-cy="paternity-birth-date-calculate-button" href="" ng-class="{disabled: paternityPayFormStep1.duedate.$invalid || paternityPayFormStep1.birthdate.$invalid}" ng-click="getPaternityDateBoundaries(paternityPay)" ng-if="!paternityPay.IsFromIntegration">\n\t\t\t\t\t\t{{!paternityPay.isStartDateEditable ? \'Calculate\' : \'Recalculate\'}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="paternityPayFormStep1.birthdate.$error" ng-show="paternityPayFormStep1.birthdate.$touched" role="alert">\n\t\t\t\t\t<p data-cy="paternity-birth-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter the baby\'s birth date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="paternity-birth-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\tPlease enter a valid birth date\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" data-cy="paternity-birth-date-message" ng-if="paternityPay.TeamMemberPaternityStatus === 1">\n\t\t\t\t\tPlease enter the due date as well as the birth date\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Start Date -->\n\t\t\t<div class="form-field fadeIn" ng-if="paternityPay.isStartDateEditable">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="startdate">Paternity leave start date:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="startdate" field-min-date-iso="paternityPay.StartDateMinISO" field-on-change-fn="onChangePaternityPayStartDate(paternityPay)" field-read-only="paternityPay.IsFromIntegration" field-style="l" field-value-iso="paternityPay.StartDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="paternityPayFormStep1.startdate.$error" ng-show="paternityPayFormStep1.startdate.$touched" role="alert">\n\t\t\t\t\t<p data-cy="paternity-start-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\tPlease enter a start date from {{paternityPay.StartDateMinISO | dateformat}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="paternity-start-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s paternity leave start date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p data-cy="paternity-start-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\tPlease enter a valid start date\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" data-cy="paternity-start-date-message" ng-if="paternityPayFormStep1.duedate.$valid && paternityPayFormStep1.birthdate.$valid">\n\t\t\t\t\tThis date must be after {{paternityPay.StartDateMinISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- End Date -->\n\t\t\t<fieldset ng-if="paternityPay.isEndDateEditable">\n\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="enddate">Paternity leave end date:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="enddate" field-min-date-iso="paternityPay.EndDateMinISO" field-max-date-iso="paternityPay.EndDateMaxISO" field-on-change-fn="onChangePaternityPayEndDate(paternityPay)" field-on-focus-fn="setIsEndDateCommsVisible(paternityPay, true)" field-read-only="paternityPay.IsFromIntegration" field-style="l" field-value-iso="paternityPay.EndDateISO">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="paternityPayFormStep1.enddate.$error" ng-show="paternityPayFormStep1.enddate.$touched" role="alert">\n\t\t\t\t\t\t<p data-cy="paternity-end-date-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tPlease enter an end date from {{paternityPay.EndDateMinISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="paternity-end-date-validation-max-message" ng-message="max">\n\t\t\t\t\t\t\tPlease enter an end date on or before {{paternityPay.EndDateMaxISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="paternity-end-date-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter {{formOptions.context.Forename}}\'s paternity leave end date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="paternity-end-date-validation-date-message" ng-message="date">\n\t\t\t\t\t\t\tPlease enter a valid end date\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p data-cy="paternity-end-date-message" class="form-message fadeIn" ng-if="paternityPayFormStep1.duedate.$valid">This date must be after {{paternityPay.EndDateMinISO | dateformat}} and no later than {{paternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- End date comms -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="paternityPay.isEndDateCommsVisible">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-on-dismiss="setIsEndDateCommsVisible(paternityPay, false, true)" note-theme="indifferent" note-title="Statutory paternity pay calculated in full weeks">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPlease note that statutory paternity pay will be calculated in full weeks based on the start date.\n\t\t\t\t\t\t\t\tIf the end date you\u2019ve entered falls in a part week, that week will be ignored when calculating statutory paternity payments.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="paternityPay.paternityDatesState === \'ready\' && paternityPayFormStep1.startdate.$valid">\n\t\t\t<!-- Paid in full? -->\n\t\t\t<fieldset ng-if="paternityPay.IsHistoricSchedule">\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="paidInFullTrue" class="required">Has the schedule already been paid in full?</label>\n\t\t\t\t\t\t<p class="is-small">As the leave end date is before the start of your current period, choose whether you wish to add an outstanding payment to payroll.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullTrue" ng-model="paternityPay.IsPaidInFull" theme="is-tight" value="true">\n\t\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t\t<h6>Yes</h6>\n\t\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t\t<p class="is-small">You\u2019ll need to enter the payments already made for this schedule.</p>\n\t\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t\t</extended-radio>\n\t\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullFalse" ng-model="paternityPay.IsPaidInFull" theme="is-tight" value="false">\n\t\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t\t<h6>No</h6>\n\t\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t\t<p class="is-small">The schedule will be calculated and the outstanding payment will be added to your current period and included in payroll.</p>\n\t\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t\t</extended-radio>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Payments already made -->\n\t\t\t<fieldset ng-if="!paternityPay.IsHistoricSchedule && paternityPay.IsInProgressSchedule">\n\n\t\t\t\t<!-- Existing schedule? -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<p class="s">If this is an existing paternity pay schedule, where some payments have already been made, toggle the switch below.\n\t\t\t\t\t\t\tThe remainder of the schedule will then be calculated.</p>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<toggle-input field-label="Add payments already made" field-model="paternityPay.HasAmountBroughtForward" field-name="hasAmountBroughtForward"></toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Payments made so far -->\n\t\t\t<fieldset ng-if="paternityPay.IsHistoricSchedule || paternityPay.HasAmountBroughtForward" ng-switch="paternityPay.AmountBroughtForwardMethod">\n\t\t\t\t<div class="form-summary no-margin" ng-if="paternityPay.IsHistoricSchedule">\n\t\t\t\t\t<p class="is-small">Enter the payments that were made for this schedule:</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Amount brought forward option -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodTotalAmount" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(paternityPay)" ng-model="paternityPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount" type="radio">\n\t\t\t\t\t\t<label for="amountBroughtForwardMethodTotalAmount" class="s">as a total amount</label>\n\t\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodPerPeriod" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(paternityPay)" ng-model="paternityPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit" type="radio">\n\t\t\t\t\t\t<label for="amountBroughtForwardMethodPerPeriod" class="s">as payments per pay period</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Total payments made so far -->\n\t\t\t\t<div class="form-field fadeIn" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="totalBroughtForward" class="required">Total payments made so far:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise xl" id="totalBroughtForward" maxlength="10" name="totalBroughtForward" ng-min="0" ng-model="paternityPay.TotalBroughtForward" ng-pattern="$root.REGEX.decimal" type="number" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="paternityPayFormStep1.totalBroughtForward.$touched" ng-messages="paternityPayFormStep1.totalBroughtForward.$error" role="alert">\n\t\t\t\t\t\t<p data-cy="paternity-total-brought-forward-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\tPlease enter a number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="paternity-total-brought-forward-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\tAmount should be 1p or greater\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p data-cy="paternity-total-brought-forward-validation-number-message" ng-message="number">\n\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pay Period amounts -->\n\t\t\t\t<fieldset ng-switch="paternityPay.paymentsBroughtForwardState" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit">\n\t\t\t\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t<circle-loader class="m fadeIn"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Ready -->\n\t\t\t\t\t<div class="form-input-list fadeIn" ng-switch-when="ready">\n\t\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in paternityPay.PaymentsBroughtForward">\n\t\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PayPeriodDisplay}}:</label>\n\t\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="brought-forward-payment-{{$index}}" min="0" name="brought-forward-payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="paternityPayFormStep1[\'payment-\' + $index].$touched" ng-messages="paternityPayFormStep1[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-bought-forward-amount-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter an amount\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-bought-forward-amount-validation-number-message" ng-message="number">\n\t\t\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-bought-forward-amount-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\t\tPlease enter a positive number\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Empty -->\n\t\t\t\t\t<div class="info-block indifferent fadeIn" ng-switch-when="empty">\n\t\t\t\t\t\t<p class="s">Unable to generate brought forward dates</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button disable-button="!paternityPayFormStep1.$valid || paternityPay.paternityDatesState !== \'ready\'" display-text="\'Next\'" state="paternityPayFormStep1.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pay Information -->\n\t<form class="fadeIn" name="paternityPayFormStep2" ng-submit="reviewPaternitySchedulePayments(paternityPay, paternityPayFormStep2)" pc-switch-when="PATERNITY_PAY_STEPS.enterPaymentDetails" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<h4>Please give us some pay information</h4>\n\t\t\t<p class="s">Please enter the gross amount {{formOptions.context.Forename}} was paid for each of the dates below</p>\n\t\t</div>\n\n\t\t<fieldset>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in paternityPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="payment-{{$index}}" min="0" name="payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="paternityPayFormStep2[\'payment-\' + $index].$touched" ng-messages="paternityPayFormStep2[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-payment-amount-validation-required-message" ng-message="required">\n\t\t\t\t\t\t\t\tPlease enter an amount\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-payment-amount-validation-number-message" ng-message="number">\n\t\t\t\t\t\t\t\tPlease enter a valid number\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p data-cy="paternity-payment-{{$index}}-payment-amount-validation-min-message" ng-message="min">\n\t\t\t\t\t\t\t\tPlease enter a positive number\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pro-ration -->\n\t\t\t<div class="form-field" ng-if="!paternityPay.IsHistoricSchedule">\n\t\t\t\t<!-- Pro-ration method -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationCompanySetting" name="proRationCompanySetting" ng-model="paternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.companySetting" type="radio">\n\t\t\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\u2019ve worked in\n\t\t\t\t\t\t\t\t\t\ta pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationPeriod" name="proRationPeriod" ng-model="paternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.period" type="radio">\n\t\t\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in\n\t\t\t\t\t\t\t\t\t\ta pay period based on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationManual" name="proRationManual" ng-model="paternityPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.manual" type="radio">\n\t\t\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\u2019t cover a whole pay period (e.g. the first and last payments of an\n\t\t\t\t\t\t\t\t\t\textended period of leave) pro-ration can be turned off and any adjustments can be made manually\n\t\t\t\t\t\t\t\t\t\tto {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Turn off pro-ration -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="paternityPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Remember to make changes manually">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s\n\t\t\t\t\t\t\t\tnormal pay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Salary Sacrifice -->\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<settings-row ng-model="paternityPay.SalarySacrificeState" on-update="reviewStatPaymentSalarySacrifice(paternityPay)" sr-disabled="::getIsStatPaymentSalarySacrificeReadOnly(paternityPay)" sr-field-name="salarySacrificeState" sr-icon="salary-change" sr-theme="secondary">\n\t\t\t\t\t\t<sr-label>Salary sacrifice warnings</sr-label>\n\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\t<span ng-switch="paternityPay.SalarySacrificeBehaviour">\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked">This pay element is included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;OFF&rsquo;.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked">This pay element is not included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;ON&rsquo;.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on">Switch to OFF if you do not wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.</span>\n\t\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off">Switch to ON if you wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<!-- Schedule Calculation Method -->\n\t\t<fieldset class="form-fieldset-divider-top" ng-if="!paternityPay.IsHistoricSchedule && !paternityPay.IsPaidInFull">\n\t \t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sppScheduleCalculationMethodPeriod" class="required">How do you wish to calculate the SPP schedule?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="sppScheduleCalculationMethodPeriod" name="sppScheduleCalculationMethod" ng-model="paternityPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.periodDates" type="radio">\n\t\t\t\t\t\t\t<label for="sppScheduleCalculationMethodPeriod" class="radio-row-label">On a pay period basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="sppScheduleCalculationMethodWeekly" name="sppScheduleCalculationMethod" ng-model="paternityPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.weekly" type="radio">\n\t\t\t\t\t\t\t<label for="sppScheduleCalculationMethodWeekly" class="radio-row-label">On a weekly basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="goToPreviousStep(paternityPay)">Back</a>\n\t\t\t<submit-button disable-button="!paternityPayFormStep2.$valid" display-text="\'Next\'" state="paternityPayFormStep2.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Occupational Paternity Pay -->\n\t<form class="fadeIn" name="paternityPayFormStepAddSupplementaryOccupationalPaternityPay" ng-submit="goToNextStep(paternityPay)" pc-switch-when="PATERNITY_PAY_STEPS.addSupplementaryOccupationalPaternityPay" novalidate>\n\t\t<fieldset class="fadeIn">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Occupational paternity pay</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Use occupational policy? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="addSupplementaryOccupationalPaternityPayTrue">Do you wish to add supplementary occupational paternity pay?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalPaternityPayTrue" name="addSupplementaryOccupationalPaternityPay" ng-change="onUsePolicyChange(vm, paternityPay)" ng-init="onUsePolicyInit(vm, paternityPay, teamMember)" ng-model="paternityPay.UsePolicy" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalPaternityPayTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalPaternityPayFalse" name="addSupplementaryOccupationalPaternityPay" ng-change="onUsePolicyChange(vm, paternityPay)" ng-model="paternityPay.UsePolicy" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalPaternityPayFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Loading state -->\n\t\t\t<div class="form-section" ng-if="paternityPay.UsePolicy && vm.loadingStatePolicies === \'loading\'">\n\n\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowedPoliciesLoading" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t<loading-block></loading-block>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="paternityPay.UsePolicy && vm.loadingStatePolicies === \'ready\'">\n\n\t\t\t<!-- Select a policy -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="paternityPolicy" class="required">Select a policy:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="paternityPolicy" name="paternityPolicy" ng-change="onSelectPaternityPolicy(paternityPay, teamMember)" ng-model="paternityPay.Policy" ng-options="paternityPolicy as paternityPolicy.PolicyName for paternityPolicy in vm.paternityPolicies | orderBy: \'PolicyName\' track by paternityPolicy.PolicyID" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Policy details -->\n\t\t\t<fieldset class="fadeIn" ng-if="paternityPay.Policy">\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="caption">\n\t\t\t\t\t\tPayment bands are set to &lsquo;{{utilities.toUnsentenceCase(POLICY_PAY_BASES_DESCRIPTIONS[paternityPay.Policy.PolicyPayBasis])}}&rsquo;.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Valid paternity policy selection - show bands -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="paternityPay.Policy.isValid" ng-switch="paternityPay.TeamMemberPaternityStatus">\n\n\t\t\t\t\t<!-- Unable to use average weekly earnings policy -->\n\t\t\t\t\t<div class="form-section fadeIn" ng-if="paternityPay.Policy.PolicyPayBasis === POLICY_PAY_BASES.averageWeeklyPercent" pc-switch-when="STAT_PAYMENT_SCHEDULE_STATES.employmentDetailsInsufficient">\n\n\t\t\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowedAverageWeeklyPercent" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t\t\t<!-- Feedback note -->\n\t\t\t\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="An average weekly earnings policy can\u2019t be used">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tBased on {{formOptions.context.Forename}}\u2019s employment dates, an average weekly earnings figure can\u2019t be calculated, so a paternity policy with pay rates set to\n\t\t\t\t\t\t\t\t\t&lsquo;Percentage of average weekly earnings&rsquo; can\u2019t be selected.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t<pc-pluralise count="paternityPay.Policy.bandsCount" single="{{paternityPay.Policy.policyBandDescription}}" multiple="{{paternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Payment bands -->\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in paternityPay.Policy.PolicyBands" policy="paternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Invalid paternity policy selection > % of annual salary policy but no annual salary -->\n\t\t\t\t<div class="form-field fadeIn" ng-if="!paternityPay.Policy.isValid">\n\n\t\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowedNoAnnualSalary" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t\t<!-- No valid annual salary -->\n\t\t\t\t\t<note ng-if="paternityPay.Policy.noAnnualSalarySaved" note-icon="icon-warning" note-theme="tertiary" note-title="No annual salary saved">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tEntitlement bands for the selected policy are set to &lsquo;{{POLICY_PAY_BASES_DESCRIPTIONS[paternityPay.Policy.PolicyPayBasis]}}&rsquo; but\n\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} doesn\u2019t have an annual salary saved in their pay information.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="goToPreviousStep(paternityPay)">Back</a>\n\t\t\t<submit-button disable-button="!paternityPayFormStepAddSupplementaryOccupationalPaternityPay.$valid" display-text="\'Next\'" state="paternityPayFormStepAddSupplementaryOccupationalPaternityPay.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Schedule summary -->\n\t<form class="fadeIn" name="paternityPayFormStep3" ng-init="getPaternitySchedulePayments(paternityPay)" ng-submit="updateTeamMemberPaternitySchedulePayments(paternityPay, paternityPayFormStep3)" ng-switch="paternityPay.loadingStateSchedulePayments" pc-switch-when="PATERNITY_PAY_STEPS.reviewSchedule" novalidate>\n\n\t\t<!-- Loading summary -->\n\t\t<fieldset ng-switch-when="loading">\n\t\t\t<loading-block></loading-block>\n\t\t</fieldset>\n\n\t\t<!-- Schedule summary -->\n\t\t<fieldset class="fadeIn" ng-switch-when="ready">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>{{formOptions.context.Forename}}\'s paternity payment schedule</h4>\n\t\t\t\t<p class="s">The below paternity payments will be automatically added to payroll for the respective pay periods.</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section">\n\n\t\t\t\t<stat-payment-summary-card on-edit="goToStep(paternityPay, PATERNITY_PAY_STEPS.calculate)" stat-payment="paternityPay" stat-payment-type="paternity">\n\t\t\t\t</stat-payment-summary-card>\n\n\t\t\t</div>\n\n\t\t\t<!-- Pro-ration -->\n\t\t\t<div class="form-section" ng-if="!paternityPay.IsHistoricSchedule && !paternityPay.IsPaidInFull">\n\t\t\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<div ng-switch="paternityPay.ProRatingMethod">\n\n\t\t\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t\t\t<p class="s" data-cy="paternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.companySetting">\n\t\t\t\t\t\t\t\tStandard pro-ration is being used where the schedule doesn\u2019t cover\n\t\t\t\t\t\t\t\twhole pay periods. <a href="" class="indifferent underline" ng-click="updatePaternityDates(paternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t\t\t<p class="s" data-cy="paternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\t\tPeriod pro-ration is being used where the schedule doesn\'t cover\n\t\t\t\t\t\t\t\twhole pay periods. <a href="" class="indifferent underline" ng-click="updatePaternityDates(paternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t\t\t<p class="s" data-cy="paternity-pro-ration-message" pc-switch-when="PRO_RATION_METHODS.manual">\n\t\t\t\t\t\t\t\tPro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustmentsto {{formOptions.context.Forename}}\'s pay\n\t\t\t\t\t\t\t\twill need to be made manually. <a href="" class="indifferent underline" ng-click="updatePaternityDates(paternityPay)">Change this</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</div>\n\n\t\t\t<!-- Tabs for payments and policy if using a policy -->\n\t\t\t<fieldset ng-if="paternityPay.UsePolicy">\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<navigation-tabs>\n\t\t\t\t\t   <a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'payments\'}" ng-click="paternityPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t\t   <a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'policy\'}" ng-click="paternityPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t\t\t</navigation-tabs>\n\t\t\t\t</section>\n\t\t\t</fieldset>\n\n\t\t\t<div class="form-tab-content" ng-switch="paternityPay.reviewScheduleView">\n\t\t\t\t<div class="form-section" ng-switch-when="payments" ng-if="paternityPay.SchedulePayments.length > 0">\n\t\t\t\t\t<payment-schedule can-edit-occupational-payment-values="true" occupational-payment-label="OPP" schedule-payments="paternityPay.SchedulePayments" schedule-payment-label="SPP" show-occupational-policy-payment-values="paternityPay.UsePolicy" statutory-pay-calculation-method="paternityPay.CalculationMethod"></payment-schedule>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">The below entitlement bands are from \u2018{{paternityPay.Policy.PolicyName}}\u2019 and used to calculate\n\t\t\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t<pc-pluralise count="paternityPay.Policy.PolicyBands.length" single="{{paternityPay.Policy.policyBandDescription}}" multiple="{{paternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in paternityPay.Policy.PolicyBands" policy="paternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="form-actions">\n\t\t\t\t<a class="button secondary-action" data-cy="secondary-action" href="" ng-click="goToPreviousStep(paternityPay)">Back</a>\n\t\t\t\t<submit-button disable-button="!paternityPayFormStep3.$valid" display-text="\'Save &amp; finish\'" state="paternityPayFormStep3.state"></submit-button>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- Dates incorrect -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="{{formOptions.context.Forename}}\'s paternity dates are incomplete" ng-if="pageState === \'date-details-missing\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided don\'t allow us to calculate the correct statutory paternity pay for {{formOptions.context.Forename}}.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\tthem eligible to receive statutory paternity pay, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="goToPreviousStep(paternityPay)">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- PAYE information missing -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="The paternity dates fall into a new tax year" ng-if="pageState === \'paye-details-missing\'">\n\t<fs-main>\n\t\t<p class="s">We are missing the latest PAYE tax and National Insurance figures for some of the tax years that the paternity pay dates fall in.</p>\n\t\t<p class="s">Please contact support and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="goToPreviousStep(paternityPay)">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Not Eligible (Employment details insufficient, earnings too low or continuous employment criteria not met) -->\n<form class="fadeIn" name="notEligibleForSPPForm" ng-if="pageState === \'not-eligible\'" ng-submit="createNilSchedule(paternityPay, notEligibleForSPPForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="{{formOptions.context.Forename}} doesn\'t qualify for Statutory Paternity Pay">\n\t\t<fs-main>\n\t\t\t<statutory-parental-pay-not-eligible eligibility-date-min-iso="paternityPay.paternityPayEligibilityDateMinIso" forename="{{formOptions.context.Forename}}" is-leaver="teamMember.Company.IsLeaver" is-policies-applicable="paternityPay.isPoliciesApplicable" leave-date-iso="teamMember.Company.LeaveDateISO" parental-type="paternity" pay-errors="paternityPay.TeamMemberPaternityErrors" pay-status="paternityPay.TeamMemberPaternityStatus" salary-payments="paternityPay.SalaryPayments" today-iso="TODAY_ISO"></statutory-parental-pay-not-eligible>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Next\'" state="notEligibleForSPPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Duplicate payment schedule -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="A payment schedule already exists" ng-if="pageState === \'duplicate-payment-schedule\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided overlap with an existing statutory payment schedule for {{formOptions.context.Forename}}. You can either delete the existing schedule\n\t\t\tor click \'Back\' to change the dates you have provided.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="goToPreviousStep(paternityPay)">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Payroll has already been run -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pay periods have already been run" ng-if="pageState === \'payroll-has-run\'">\n\t<fs-main>\n\t\t<p class="s">The dates you have provided overlap with pay periods that have already been run.</p>\n\t\t<p class="s">If you believe this to be incorrect, please contact support and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="goToPreviousStep(paternityPay)">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Calculating -->\n<section class="form-summary fadeIn" ng-if="pageState === \'calculating\'">\n\t<loading-block class="m"></loading-block>\n\t<p class="align-center">Checking {{formOptions.context.Forename}}\'s pay info...</p>\n</section>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Saved!" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<div data-cy="paternity-success-messsage">\n\t\t\t<p class="s">{{formOptions.context.Forename}}\'s paternity will begin on {{paternityPay.StartDateISO | dateformat}} and the first paternity payment will be made when you\n\t\t\t\tapprove payroll for <strong>{{paternityPay.StartPayPeriodDisplay}}</strong>.</p>\n\t\t\t<p class="s">If for some reason you wish to delete these paternity payments, you can do so from {{formOptions.context.Forename}}\'s profile, but you must do it before you\n\t\t\t\tapprove payroll for <strong>{{paternityPay.StartPayPeriodDisplay}}</strong>.</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/paternityPay/paternityPayViewForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- View Paternity Pay -->\n<form name="viewPaternityPayForm" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Complete -->\n\t<div class="form-section fadeIn" ng-if="paternityPay.IsPaidInFull">\n\t\t<notification-card theme="is-secondary">\n\t\t\t<nc-description>\n\t\t\t\t<p><span class="strong">Complete</span> on {{paternityPay.PaidInFullPayDateISO | dateformat}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<!-- Managed by integration -->\n\t<div class="form-section fadeIn" data-cy="integration-banner" ng-if="paternityPay.IsFromIntegration">\n\t\t<notification-card data-cy="paternity-pay-integration-banner" theme="is-indifferent">\n\t\t\t<nc-description>\n\t\t\t\t<p><i class="icon-information m is-indifferent"></i>&nbsp;&nbsp;&nbsp;{{edpTopicMessage}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<h4>{{formOptions.context.Forename}}\'s paternity payment schedule</h4>\n\t\t<p class="s">The below paternity payments will be automatically added to payroll for the respective pay periods.</p>\n\t</div>\n\n\t<!-- Schedule summary -->\n\t<div class="form-section">\n\n\t\t<stat-payment-summary-card can-edit="paternityPay.CanBeUpdated" on-edit="setPageState(\'update\')" stat-payment="paternityPay" stat-payment-type="paternity">\n\t\t</stat-payment-summary-card>\n\n\t</div>\n\n\t<!-- Pro-ration -->\n\t<div class="form-section" ng-if="!paternityPay.IsHistoricSchedule">\n\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t<ib-main>\n\t\t\t\t<div ng-switch="paternityPay.ProRatingMethod">\n\n\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.companySetting">\n\t\t\t\t\t\tStandard pro-ration is being used where the schedule doesn\u2019t cover whole pay periods.\n\t\t\t\t\t\t<a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a>\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.period">\n\t\t\t\t\t\tPeriod pro-ration is being used where the schedule doesn\'t cover whole pay periods.\n\t\t\t\t\t\t<a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a>\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.manual">\n\t\t\t\t\t\tPro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustments to {{formOptions.context.Forename}}\'s pay will need to be made manually.\n\t\t\t\t\t\t<a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<!-- Tabs for payments and policy if using a policy -->\n\t<fieldset class="no-print" ng-if="paternityPay.UsePolicy">\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'payments\'}" ng-click="paternityPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t<a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'policy\'}" ng-click="paternityPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content no-print" ng-switch="paternityPay.reviewScheduleView">\n\n\t\t<!-- Payment schedule -->\n\t\t<div class="form-section" ng-switch-when="payments" ng-if="paternityPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule brought-forward-payments="paternityPay.PaymentsBroughtForward" occupational-payment-label="OPP" schedule-payments="paternityPay.SchedulePayments" schedule-payment-label="SPP" show-occupational-policy-payment-values="paternityPay.UsePolicy" statutory-pay-calculation-method="paternityPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe below payments bands are based on a {{::POLICY_PAY_BASES_DESCRIPTIONS[paternityPay.Policy.PolicyPayBasis] | lowercase }}\n\t\t\t\t\tand were used to calculate occupational payments:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<pc-pluralise count="paternityPay.Policy.PolicyBands.length" single="{{paternityPay.Policy.policyBandDescription}}" multiple="{{paternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in paternityPay.Policy.PolicyBands" policy="paternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="canUndoUpdateInProgressOriginal">\n\t\t<div class="note tertiary">\n\t\t\t<p class="s">\n\t\t\t\t{{formOptions.context.Forename}}\'s paternity payment schedule has been updated. If you wish to revert to the original payment schedule, click \'Undo schedule update\' below.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="isUpdatedOriginal && paternityPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s paternity schedule was updated by {{paternityPay.UpdatedBy}} on {{paternityPay.UpdatedDateISO | dateformat}} at {{paternityPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Extended -->\n\t<div class="form-section" ng-if="isExtendedOriginal && paternityPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s paternity schedule was extended by {{paternityPay.UpdatedBy}} on {{paternityPay.UpdatedDateISO | dateformat}} at {{paternityPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Prior to payroll being run -->\n\t<!-- Reachable for an integration-owned record: \'Update schedule\' opens the same edit wizard as the edit pencil, which already keeps EDP-sourced dates read-only -->\n\t<fieldset class="form-actions" ng-if="canBeDeletedOriginal">\n\n\t\t<button class="secondary-action" data-cy="paternity-update-schedule" ng-click="setPageState(\'update\')" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-delete-schedule" ng-click="setPageState(\'delete\')" ng-if="!paternityPay.IsFromIntegration" type="button">\n\t\t\tDelete schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Update schedule -->\n\t<!-- Reachable for an integration-owned record: PATERNITY_UPDATE_OPTIONS is already filtered to payroll-only reasons for those records -->\n\t<fieldset class="form-actions" ng-if="canUpdateInProgressOriginal && !paternityPay.updateReason">\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-update-schedule" ng-click="onUpdateScheduleClick(paternityPay)" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Cancel extension -->\n\t<fieldset class="form-actions" ng-if="canCancelExtensionOriginal && !paternityPay.IsFromIntegration">\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-cancel-extension" ng-click="setPageState(\'confirm-cancel-extension\')" type="button">\n\t\t\tCancel extension\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Update \'in-progress\' schedule -->\n\t<fieldset class="form-actions" ng-if="canUpdateInProgressOriginal && paternityPay.updateReason">\n\n\t\t<button class="secondary-action" data-cy="paternity-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-save-and-finish" ng-click="updateTeamMemberPaternitySchedulePayments(paternityPay, viewPaternityPayForm)" type="button">\n\t\t\tSave &amp; finish\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Undo \'in-progress\' schedule update -->\n\t<fieldset class="form-actions" ng-if="canUndoUpdateInProgressOriginal">\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-undo-schedule-update" ng-click="setPageState(\'undo-schedule-update\')" type="button">\n\t\t\tUndo schedule update\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Extend schedule -->\n\t<fieldset class="form-actions" ng-if="canBeExtendedOriginal && !canBeDeletedOriginal && !paternityPay.IsFromIntegration">\n\n\t\t<button class="tertiary primary-action" data-cy="paternity-extend-schedule" ng-click="onExtendScheduleClick(paternityPay)" type="button">\n\t\t\tExtend schedule\n\t\t</button>\n\n\t</fieldset>\n</form>\n\n<!-- Update \'not started\' schedule -->\n<form class="fadeIn" name="updatePaternityPayForm" ng-if="pageState === \'update\'" ng-submit="updatePaternityPay(paternityPay)" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to update this schedule?">\n\t\t<fs-main>\n\t\t\t<p class="s">If you proceed, the existing schedule will be replaced with the new one for {{formOptions.context.Forename}}\'s paternity leave.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="updatePaternityPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Update \'in-progress\' schedule -->\n<form class="fadeIn" name="updatePaternityPayForm" ng-if="pageState === \'update-in-progress-schedule\'" ng-submit="updateTeamMemberPaternityScheduleInProgress(paternityPay, updatePaternityPayForm)" ng-switch="paternityPay.updateReason" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Update {{formOptions.context.Forename}}\'s paternity payment schedule</h4>\n\t\t<p class="s">Choose the reason why you wish to update {{formOptions.context.Forename}}\'s paternity schedule. <a ng-href="{{$root.URLS.paycircle.support.updatingMaternitySchedule}}" target="_blank" class="underline">Read more about ending paternity schedules early</a></p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reason -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="startdate">Why are you updating the schedule?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="paternityReason" name="paternityReason" ng-model="paternityPay.updateReason" ng-options="option.value as option.label for option in PATERNITY_UPDATE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select\u2026</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updatePaternityPayForm.paternityReason.$error" ng-if="updatePaternityPayForm.paternityReason.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a reason for the update</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-switch="paternityPay.updateReason">\n\n\t\t<!-- Leaving / Redundancy -->\n\t\t<div class="form-field fadeIn" pc-switch-when="[SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.Redundancy]">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">When do you want the last payment to be made?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select name="lastPaymentPeriodId" id="lastPaymentPeriodId" ng-model="paternityPay.lastPaymentPeriodId" ng-options="payment.AgencyPayPeriodID as payment.PayPeriodDisplay for payment in paternityPay.pendingPayments" required>\n\t\t\t\t\t<option value="">Choose a pay period...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Returning to work early / sharing parental leave with partner / Employee is deceased -->\n\t\t<fieldset class="fadeIn" pc-switch-when="[\n\t\t\t\tSCHEDULE_UPDATE_REASONS.EmployeeIsDeceased,\n\t\t\t\tSCHEDULE_UPDATE_REASONS.ReturnToWork,\n\t\t\t\tSCHEDULE_UPDATE_REASONS.SharedParentalLeave\n\t\t\t]">\n\t\t\t<div class="form-field fadeIn">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required">What is their last payment date?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="returnDate" field-min-date-iso="paternityPay.EndDateMinISO" field-max-date-iso="paternityPay.EndDateMaxISO" field-on-focus-fn="setIsEndDateCommsVisible(paternityPay, true)" field-value-iso="paternityPay.EndDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="updatePaternityPayForm.returnDate.$error" ng-if="updatePaternityPayForm.returnDate.$invalid && updatePaternityPayForm.returnDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="min">The date must be from {{paternityPay.EndDateMinISO | dateformat}}</p>\n\t\t\t\t\t<p ng-message="max">The date must be no later than {{paternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">This date must be from {{paternityPay.EndDateMinISO | dateformat}}</p>\n\t\t\t</div>\n\n\t\t\t<!-- End date comms -->\n\t\t\t<div class="form-field fadeIn" ng-if="paternityPay.isEndDateCommsVisible">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-on-dismiss="setIsEndDateCommsVisible(paternityPay, false, true)" note-theme="indifferent" note-title="Statutory paternity pay calculated in full weeks">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note that statutory paternity pay will be calculated in full weeks based on the start date.\n\t\t\t\t\t\t\tIf the end date you\u2019ve entered falls in a part week, that week will be ignored when calculating statutory paternity payments.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Updating paternity leave start date -->\n\t\t<div class="form-field fadeIn" pc-switch-when="SCHEDULE_UPDATE_REASONS.CorrectStartDate">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="startdate">Enter a new paternity leave start date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="startdate" field-min-date-iso="paternityPay.StartDateMinISO" field-value-iso="paternityPay.StartDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updatePaternityPayForm.startdate.$error" ng-show="updatePaternityPayForm.startdate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">Please enter a start date after {{paternityPay.StartDateMinISO | dateformat}}</p>\n\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s paternity leave start date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid start date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn" ng-if="updatePaternityPayForm.duedate.$valid">This date must be on or after {{paternityPay.StartDateMinISO | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- Re-enter gross payments -->\n\t\t<fieldset class="fadeIn" pc-switch-when="[SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.CorrectEndDate, SCHEDULE_UPDATE_REASONS.CorrectStartDate, SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased, SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.Redundancy, SCHEDULE_UPDATE_REASONS.ReturnToWork, SCHEDULE_UPDATE_REASONS.SalaryUpdate, SCHEDULE_UPDATE_REASONS.SharedParentalLeave]">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in paternityPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="updatePaternityPayForm[\'payment-\' + $index].$error" ng-if="updatePaternityPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Update paternity pay\'" state="updatePaternityPayForm.state" disable-button="!updatePaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Undo update \'in-progress\' schedule > confirmation -->\n<form class="fadeIn" name="undoInProgressScheduleUpdateConfirmationForm" ng-if="pageState === \'undo-schedule-update\'" ng-submit="updateTeamMemberPaternityScheduleInProgressReset(paternityPay, undoInProgressScheduleUpdateConfirmationForm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to undo this update?">\n\t\t<fs-main>\n\t\t\t<p class="s">Once you undo this payment schedule update, it will be deleted and the original payment schedule will be restored. If you later realise you\'ve made a mistake, you will need to create this update again. If you\'re happy to proceed, click \'Confirm\' and you\'ll then see the original payment schedule again.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t\t<submit-button display-text="\'Confirm\'" state="undoInProgressScheduleUpdateConfirmationForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Change pro-ration -->\n<form class="fadeIn" name="changeProRationForm" ng-if="pageState === \'change-pro-ration\'" ng-submit="updateTeamMemberSchedulePaymentsProRatingMethod(paternityPay, changeProRationForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Change pro-ration method</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationCompanySetting" id="proRationCompanySetting" class="b radio-row-input" ng-value="PRO_RATION_METHODS.companySetting" ng-model="paternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\u2019ve worked in a pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationPeriod" id="proRationPeriod" class="b radio-row-input" ng-value="PRO_RATION_METHODS.period" ng-model="paternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in a pay period based on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationManual" id="proRationManual" class="b radio-row-input" ng-value="PRO_RATION_METHODS.manual" ng-model="paternityPay.ProRatingMethod">\n\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\u2019t cover a whole pay period (e.g. the first and last payments of an extended period of leave) pro-ration can be turned off and any adjustments can be made manually to {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Turn off pro-ration -->\n\t\t<div class="form-field fadeIn" ng-if="paternityPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t<note note-theme="indifferent" note-title="Remember to make changes manually" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s normal pay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="changeProRationForm.state" disable-button="!changeProRationForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Extend schedule -->\n<form class="fadeIn" name="extendPaternityPayForm" ng-if="pageState === \'extend-schedule\'" ng-submit="updateTeamMemberPaternityScheduleInProgress(paternityPay, extendPaternityPayForm, \'extend-schedule\')" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s paternity payment schedule</h4>\n\t\t<p class="s">Enter a new end date for the schedule, click &lsquo;Re-calculate&rsquo;, and any additional payments will be calculated.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Original end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Original end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="originalEndDate" field-read-only="true" field-style="is-primary-light" field-value-iso="paternityPay.endDateIsoOriginal">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<p class="form-message">{{paternityPay.EndDateMinISO | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- New end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">New end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="newEndDate" field-max-date-iso="paternityPay.EndDateMaxISO" field-min-date-iso="paternityPay.endDateIsoOriginal" field-value-iso="paternityPay.EndDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="extendPaternityPayForm.newEndDate.$error" ng-if="extendPaternityPayForm.newEndDate.$invalid && extendPaternityPayForm.newEndDate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">The date must be from {{paternityPay.endDateIsoOriginal | dateformat}}</p>\n\t\t\t\t<p ng-message="max">The date must be no later than {{paternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">This date must be from {{paternityPay.endDateIsoOriginal | dateformat}} and no later than {{paternityPay.EndDateMaxISO | dateformat}}</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Re-enter gross payments -->\n\t<fieldset class="fadeIn">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Payments List -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-input-list">\n\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in paternityPay.SalaryPayments">\n\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="extendPaternityPayForm[\'payment-\' + $index].$error" ng-if="extendPaternityPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Re-calculate\'" state="extendPaternityPayForm.state" disable-button="!extendPaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm extend schedule -->\n<form class="fadeIn" name="confirmExtendPaternityPayForm" ng-if="pageState === \'confirm-extend-schedule\'" ng-submit="updateTeamMemberPaternitySchedulePayments(paternityPay, confirmExtendPaternityPayForm, \'confirm-extend-schedule\')" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s paternity payment schedule</h4>\n\t\t<p class="s">{{formOptions.context.Forename}}\'s paternity payments have been re-calculated. Click &lsquo;Confirm&rsquo; to apply the changes.</p>\n\t</div>\n\n\t<!-- Schedule summary -->\n\t<div class="form-section">\n\n\t\t<stat-payment-summary-card can-edit="paternityPay.CanBeUpdated && !paternityPay.IsFromIntegration" on-edit="setPageState(\'extend-schedule\')" stat-payment="paternityPay" stat-payment-type="paternity">\n\t\t</stat-payment-summary-card>\n\n\t</div>\n\n\t<!-- Tabs for payments and policy if using a policy -->\n\t<fieldset ng-if="paternityPay.UsePolicy">\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'payments\'}" ng-click="paternityPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t<a href="" ng-class="{\'active\': paternityPay.reviewScheduleView === \'policy\'}" ng-click="paternityPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content" ng-switch="paternityPay.reviewScheduleView">\n\t\t<div class="form-section" ng-switch-when="payments" ng-if="paternityPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule can-edit-occupational-payment-values="false" occupational-payment-label="OPP" schedule-payments="paternityPay.SchedulePayments" schedule-payment-label="SPP" show-occupational-policy-payment-values="paternityPay.UsePolicy" statutory-pay-calculation-method="paternityPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">The below entitlement bands are from \u2018{{paternityPay.Policy.PolicyName}}\u2019 and used to calculate\n\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<h5><pc-pluralise count="paternityPay.Policy.PolicyBands.length" single="{{paternityPay.Policy.policyBandDescription}}" multiple="{{paternityPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t</h5>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in paternityPay.Policy.PolicyBands" policy="paternityPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="confirmExtendPaternityPayForm.state" disable-button="!confirmExtendPaternityPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm cancel extend schedule -->\n<form class="fadeIn" name="cancelExtendPaternityForm" ng-if="pageState === \'confirm-cancel-extension\'" ng-submit="updateTeamMemberPaternityScheduleInProgressReset(paternityPay, cancelExtendPaternityForm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tCancelling {{formOptions.context.Forename}}\'s paternity payment schedule will reset the schedule and delete any additional payments.\n\t\t\t\tClick &lsquo;Confirm&rsquo; to apply the changes.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init()">Back</a>\n\t\t<submit-button disable-button="!cancelExtendPaternityForm.$valid" display-text="\'Confirm\'" state="cancelExtendPaternityForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n\n<!-- Delete Schedule -->\n<form class="fadeIn" name="deletePaternityPayForm" ng-if="pageState === \'delete\'" ng-submit="deletePaternityPay(paternityPay, deletePaternityPayForm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this schedule?">\n\t\t<fs-main>\n\t\t\t<p class="s">The payment schedule will be removed from {{formOptions.context.Forename}}\'s profile.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="deletePaternityPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Deleted -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="The payment schedule has been deleted" ng-if="pageState === \'deleted\'">\n\t<fs-main>\n\t\t<p class="s">No payments will be made for {{formOptions.context.Forename}}\'s paternity.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('forms/payroll/payStatement/payStatementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="payStatementForm" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-context" ng-if="formState === \'preview\' || formState === \'history\'" ng-class="{\'no-preview\' : formState === \'history\'}">\n\t\t<team-member-carousel active-team-member-user-id="{{formOptions.userId}}" team-members="teamMembers" on-team-member-change="setMember"></team-member-carousel>\n\t</div>\n\n\t<div class="form-content-block" ng-if="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods">\n\t\t<note note-theme="indifferent" note-icon="icon-support" note-title="Overriding calculated figures" note-dismiss="true" note-dismiss-key="edit-payment-figures">\n\t\t\t<note-content>\n\t\t\t\t<p>Calculated figures with the edit icon next to them can always be edited for team members. To restore the original value, delete the edited value and hit return or click on the tick icon.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div class="form-content-block" ng-if="!canEditFigures && canEditPensionFigures && !payment.Personal.IsAdvancingFuturePeriods">\n\t\t<note note-theme="indifferent" note-icon="icon-support" note-title="Overriding Workplace Pension figures" note-dismiss="true" note-dismiss-key="edit-pension-figures">\n\t\t\t<note-content>\n\t\t\t\t<p>You can always edit Workplace Pension figures for team members each pay period, to ensure they always match those submitted to your provider.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Overriding net to gross figures -->\n\t<div class="form-content-block" ng-if="canEditFigures">\n\t\t<note note-dismiss-key="overriding-net-to-gross-figures" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Overriding net to gross figures">\n\t\t\t<note-content>\n\t\t\t\t<p>\n\t\t\t\t\tPlease note if you override the Tax and NI for anyone on net pay or in receipt of a net to gross payment,\n\t\t\t\t\tyou may not see the net figures you are expecting due to the way Paycircle calculates gross up elements.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<loading-block ng-if="payStatementState === \'loading\'" size="m"></loading-block>\n\n\t<div class="pay-statement fadeInFast" ng-if="payStatementState === \'ready\'">\n\n\t \t<div class="form-content-block" ng-if="formState === \'preview\'">\n\t\t\t<p class="s strong"><span class="tertiary">This is a pay statement preview</span> - please approve payroll before using it to pay {{payment.Personal.Forename}}</p>\n\t \t</div>\n\n\t\t<header class="pay-statement-header">\n\t\t\t<div class="info-block primary align-center">\n\t\t\t\t<h4>{{payment.PayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t</div>\n\t\t</header>\n\n\t\t<main class="pay-statement-main">\n\n\t\t\t<!-- Pay -->\n\t\t\t<div class="pay-statement-section" ng-class="{\n\t\t\t\t\t\'can-edit\' : canEditFigures && !payment.Personal.IsAdvancingFuturePeriods\n\t\t\t\t}">\n\n\t\t\t\t<!-- Gross Pay -->\n\t\t\t\t<div class="pay-statement-item">\n\t\t\t\t\t<span class="pay-statement-label">{{::payment.PayPeriod.IsPartnership ? \'Gross Profit share\' : \'Gross Pay\'}}</span>\n\t\t\t\t\t<span class="pay-statement-value" data-cy="pay-statement-gross-pay">\n\t\t\t\t\t\t{{payment.GrossPay | monetise}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Tax -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-affects-net-pay="true" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-tax-paid" payment-label="payment.PayPeriod.IsPartnership ? \'Tax reserve\' : \'Tax\'" payment-original="payment.TaxPaid" payment-override="payment.Override.Tax" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- UK Tax (Expat only) -->\n\t\t\t\t<div class="form-field less-margin" ng-if="::payment.Personal.IsExpatriate">\n\t\t\t\t\t<pay-statement-field payment-can-edit="false" payment-id="pay-statement-uk-tax-paid" payment-label="\'UK Tax\'" payment-original="payment.UKTaxPaid" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Foreign Tax Offset(Expat only) -->\n\t\t\t\t<div class="form-field less-margin" ng-if="::payment.Personal.IsExpatriate">\n\t\t\t\t\t<pay-statement-field payment-can-edit="false" payment-id="pay-statement-foreign-tax-offset" payment-label="\'Foreign Tax Offset\'" payment-original="payment.ForeignTaxOffset" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employees NI -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-affects-net-pay="true" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-employees-ni" payment-label="payment.PayPeriod.IsPartnership ? \'Employee\\\'s National Insurance reserve\' : \'Employee\\\'s National Insurance\'" payment-original="payment.NI" payment-override="payment.Override.NI" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employers NI -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-employers-ni" payment-label="payment.PayPeriod.IsPartnership ? \'Employer\\\'s National Insurance reserve\' : \'Employer\\\'s National Insurance\'" payment-original="payment.NIER" payment-override="payment.Override.NIEmployer" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Workplace Pension -->\n\t\t\t<div class="pay-statement-section" ng-class="{\n\t\t\t\t\t\'can-edit\' : canEditPensionFigures &&\n\t\t\t\t\t\t\t\t(!pension.IsEmployeePensionRefund || !pension.IsEmployerPensionRefund) &&\n\t\t\t\t\t\t\t\t!payment.Personal.IsOffPayrollWorker &&\n\t\t\t\t\t\t\t\t!payment.Personal.IsAdvancingFuturePeriods\n\t\t\t\t}" ng-if="!payment.Personal.IsOffPayrollWorker" ng-repeat="pension in pensions = (payment.Pensions | orderBy : \'PensionType\') track by $index">\n\n\t\t\t\t<h6 class="pay-statement-section-title">{{::pension.title}}</h6>\n\n\t\t\t\t<!-- Employee Contribution -->\n\t\t\t\t<div class="form-field no-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-affects-net-pay="true" payment-can-edit="canEditPensionFigures && !pension.IsEmployeePensionRefund && !payment.Personal.IsOffPayrollWorker && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-pension-{{$index}}-employees-pension-payment" payment-label="pension.IsEmployeePensionRefund ? \'Employee\\\'s Workplace Pension refund\' : pension.PensionType === PENSION_TYPES.nonAutoEnrolment ? \'Employee\\\'s Contribution\' : \'Employee\\\'s Workplace Pension\'" payment-min="0" payment-original="pension.EmployeesPensionPayment" payment-override="payment.Override.Pensions[$index].Pension" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employer Contribution -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-can-edit="canEditPensionFigures && !pension.IsEmployerPensionRefund && !payment.Personal.IsOffPayrollWorker && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-pension-{{$index}}-employers-pension-payment" payment-label="pension.IsEmployerPensionRefund ? \'Employer\\\'s Workplace Pension refund\' : pension.PensionType === PENSION_TYPES.nonAutoEnrolment ? \'Employer\\\'s Contribution\' : \'Employer\\\'s Workplace Pension\'" payment-min="0" payment-original="pension.EmployersPensionPayment" payment-override="payment.Override.Pensions[$index].PensionEmployer" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employers NI Savings -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" ng-if="pension.HasPensionPaymentEmployersNISaving" payment-can-edit="false" payment-id="pay-statement-pension-{{$index}}-pension-payment-employers-ni-saving" payment-label="\'Employer\\\'s NI savings (\' + pension.PensionPaymentEmployersNISavingPercent + \'%)\'" payment-min="0" payment-original="pension.PensionPaymentEmployersNISaving" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Student Loans -->\n\t\t\t<div class="pay-statement-section" ng-if="payment.Tax.StudentLoan || payment.Tax.PostGraduateLoan" ng-class="{\n\t\t\t\t\t\'can-edit\' : canEditFigures && !payment.Personal.IsAdvancingFuturePeriods\n\t\t\t\t}">\n\n\t\t\t\t<!-- Student Loan -->\n\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-affects-net-pay="true" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-student-loan-paid" payment-label="payment.PayPeriod.IsPartnership ? \'Student Loan reserve\' : \'Student Loan\'" payment-original="payment.StudentLoanPaid" payment-override="payment.Override.StudentLoan" payment="payment"></pay-statement-field>\n\n\t\t\t\t<!-- Postgraduate Loan -->\n\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-affects-net-pay="true" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-postgraduate-loan-paid" payment-label="payment.PayPeriod.IsPartnership ? \'Postgraduate Loan reserve\' : \'Postgraduate Loan\'" payment-original="payment.PostGraduateLoanPaid" payment-override="payment.Override.PostgraduateLoan" payment="payment"></pay-statement-field>\n\n\t\t\t</div>\n\n\t\t\t<!-- Rollup Holiday Pay -->\n\t\t\t<div class="pay-statement-section" ng-class="{\n\t\t\t\t\t\'can-edit\' : canEditFigures && !payment.Personal.IsAdvancingFuturePeriods\n\t\t\t\t}" ng-if="payment.IsRollUpHolidayPayVisible">\n\t\t\t\t<!-- Rollup Holiday Pay -->\n\t\t\t\t<div class="form-field less-margin">\n\t\t\t\t\t<pay-statement-field callback="onUpdatePayStatement(payment)" payment-can-edit="canEditFigures && !payment.Personal.IsAdvancingFuturePeriods" payment-id="pay-statement-rollup-holiday" payment-label="\'Rolled Up Holiday Pay\'" payment-original="payment.RollUpHoliday" payment-override="payment.Override.RollUpHoliday" payment="payment"></pay-statement-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Changes -->\n\t\t\t<div class="pay-statement-section">\n\t\t\t\t<div class="pay-statement-item">\n\t\t\t\t\t<adjustments-list adjustment-detail-summary="payment" agency-profile-id="{{agencyProfileId}}" can-update="false" form-options="formOptions" ng-if="payment.Adjustments.length" user-id="{{payment.Personal.UserID}}"></adjustments-list>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Total Pay -->\n\t\t\t<div class="pay-statement-section">\n\t\t\t\t<div class="pay-statement-item pay-statement-summary">\n\t\t\t\t\t<h5 class="pay-statement-label">{{::payment.PayPeriod.IsPartnership ? \'Net Drawings\' : \'Net Pay\'}}</h5>\n\t\t\t\t\t<h5 class="pay-statement-value" data-cy="pay-statement-net-pay">\n\t\t\t\t\t\t{{payment.NetPay | monetise}}\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<footer class="pay-statement-footer">\n\n\t\t\t<div class="pay-statement-meta">\n\t\t\t\t<span class="pay-statement-meta-item" data-cy="pay-statement-tax-code" ng-if="::!payment.Personal.IsCISSubcontractor">\n\t\t\t\t\tTax code: {{payment.Tax.TaxCode}}&nbsp;{{payment.Tax.TaxCodeM1W1 ? $root.CONFIG.w1m1Label : \'\'}}\n\t\t\t\t</span>\n\t\t\t\t<span class="pay-statement-meta-item" data-cy="pay-statement-ni-category" ng-if="::!payment.Personal.IsCISSubcontractor">\n\t\t\t\t\tNI category: {{payment.Tax.NICode}}\n\t\t\t\t</span>\n\t\t\t\t<span class="pay-statement-meta-item" data-cy="pay-statment-tax-treatment" ng-if="::payment.Personal.IsCISSubcontractor">\n\t\t\t\t\tCIS deduction rate: {{payment.CIS.TaxTreatment | taxTreatment}}\n\t\t\t\t</span>\n\t\t\t\t<span class="pay-statement-meta-item" data-cy="pay-statement-salary-yearly" ng-if="::payment.Salary.SalaryType === PAYMENT_TYPES.salary && payment.Salary.SalaryYearly > 0">\n\t\t\t\t\tSalary: {{payment.Salary.SalaryYearly | monetise}}\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<div class="pay-statement-downloads" ng-if="::formState !== \'preview\' && PayslipPDFURL !== \'\'">\n\t\t\t\t<div class="pay-statement-download" ng-if="payment.CanDownload">\n\t\t\t\t\t<h6 class="pay-statement-download-title">{{::formOptions.company.CISOnly ? \'PDF pay statement\' : \'PDF payslip\'}}</h6>\n\t\t\t\t\t<p class="pay-statement-download-info">Created on {{payment.PayPeriod.PayDateISO | dateformat}}</p>\n\t\t\t\t\t<i class="icon-download pay-statement-download-icon"></i>\n\t\t\t\t\t<a href="" ng-click="downloadFile(payment.PayslipPDFURL)" class="pay-statement-download-link"></a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="pay-statement-download" ng-if="::formState !== \'preview\'">\n\t\t\t\t\t<h6 class="pay-statement-download-title">{{::formOptions.company.CISOnly ? \'Online pay statement\' : \'Online payslip\'}}</h6>\n\t\t\t\t\t<p class="pay-statement-download-info">Created on {{payment.PayPeriod.PayDateISO | dateformat}}</p>\n\t\t\t\t\t<i class="icon-external-link pay-statement-download-icon"></i>\n\t\t\t\t\t<a ui-sref="payslip({\n\t\t\t\t\t\t\t\'agencyProfileId\': agencyProfileId,\n\t\t\t\t\t\t\t\'userId\': userId,\n\t\t\t\t\t\t\t\'payPeriodId\': agencyPayPeriodId,\n\t\t\t\t\t\t\t\'userPaymentId\': teamMemberPayment.UserPaymentID,\n\t\t\t\t\t\t\t\'supplementaryPaymentId\': teamMemberPayment.SupplementaryPaymentID,\n\t\t\t\t\t\t\t\'userDocumentTypeId\': teamMemberPayment.UserDocumentTypeID\n\t\t\t\t\t\t})" class="pay-statement-download-link"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</footer>\n\t</div>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/recall-draft-payslips/recall-draft-payslips.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" name="recallDraftPayslipsForm" ng-submit="$ctrl.recallDraftPayslips($ctrl, recallDraftPayslipsForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to recall draft payslips?">\n\n\t\t<fs-main>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tTeam members will no longer be able to view a draft copy of their payslip in their Pay Portal.\n\t\t\t\t\tIf you need to resend them, you can do so from your Smart View.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' if you\'re happy to continue.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button disable-button="!recallDraftPayslipsForm.$valid" display-text="\'Confirm\'" state="recallDraftPayslipsForm.state"></submit-button>\n\t\t\t\n\t\t</fs-actions>\n\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/refreshSelectedChanges/refreshSelectedChangesForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="refreshSelectedChangesForm" ng-if="pageState === \'ready\'" ng-submit="refreshChanges()" novalidate>\n\t<fieldset>\n\t\t<legend hidden>Refresh Changes Details</legend>\n\t\t<div class="form-intro">\n\t\t\t<p class="is-small">Updates could have been made to a team member\'s pay for the current period, which might require you to refresh the team\'s changes to view the latest values for some system-calculated elements. Simply select the options you wish to update to see the latest calculations.</p>\n\t\t</div>\n\n\t\t<!-- Changes -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="changes">\n\t\t\t\t\tWhich changes do you wish to refresh?\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="checkbox-rows-list">\n\t\t\t\t\t<div class="checkbox-row" data-cy="refresh-selected-changes-form-checkbox-row-{{checkboxRow.Value  | slugify}}-{{checkboxRowIndex}}" ng-repeat="(checkboxRowIndex, checkboxRow) in refreshChangesData">\n\t\t\t\t\t\t<label class="checkbox-row_label" for="checkbox-row_{{checkboxRowIndex}}">\n\t\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" data-cy="refresh-selected-changes-form-checkbox-row-input-{{checkboxRow.Value | slugify}}-{{checkboxRowIndex}}" id="checkbox-row_{{checkboxRowIndex}}" name="checkbox-row_{{checkboxRowIndex}}" ng-model="checkboxRow.IsChecked" type="checkbox">\n\t\t\t\t\t\t\t<div class="checkbox-row_context">\n\t\t\t\t\t\t\t\t<h6>\n\t\t\t\t\t\t\t\t\t<label class="radio-row-label" for="checkbox-row_{{checkboxRowIndex}}">\n\t\t\t\t\t\t\t\t\t\t<p class="radio-row-title" data-cy="refresh-selected-changes-form-checkbox-row-title-{{checkboxRow.Value | slugify}}-{{checkboxRowIndex}}">{{checkboxRow.Value}}</p>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>Refresh Changes Options</legend>\n\t\t<a class="button secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button disable-button="!isChecked()" display-text="formOptions.primaryButtonText" state="refreshSelectedChangesForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/regenerateBacsFile/regenerateBacsFileForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="regenerateBacsForm" ng-submit="regenerateBacs(company, payPeriod, regenerateBacsForm)" ng-if="pageState === \'ready\'">\n\t<form-state form-options="formOptions" fs-show-close="true" fs-icon="question-mark" fs-title="Are you sure you wish to regenerate your BACS files?">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tYou\'re about to regenerate your BACS files for {{payPeriod.PayPeriodDisplay}} for {{company.Name}}.\n\t\t\t\tRegenerated files will also replace the original on your \'BACS downloads\' page in your bureau settings,\n\t\t\t\tso you can use the most recent version for making payments. If you\'ve already made payments for this pay period,\n\t\t\t\tyou may wish to mark it as \'processed\' on your \'BACS downloads\' page.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Regenerate\'" state="regenerateBacsForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/regenerateDocuments/regenerateDocumentsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="regenerateDocumentsForm" class="fadeIn" ng-submit="vm.regenerateDocuments(vm.regenerateDocumentsOptions, regenerateDocumentsForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<h5>Choose documents to regenerate</h5>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="extended-checkbox_wrapper">\n\t\t\t\t\t<extended-checkbox name="payslips" always-show-content="true" ng-model="vm.regenerateDocumentsOptions.documentTypes.payslips" on-change="vm.documentTypeSelectionChanged(vm.regenerateDocumentsOptions)" required="!vm.selectionsAreValid" ng-if="vm.regenerationDetails.CanRegeneratePayslips && vm.regenerationDetails.PayslipPeriods.length">\n\t\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark extended-checkbox_title">Payslips</h6>\n\t\t\t\t\t\t\t<p class="is-small is-greyscale-darkened light">Select the pay period range you wish to regenerate payslips for:</p>\n\t\t\t\t\t\t</checkbox-label>\n\n\t\t\t\t\t\t<checkbox-content>\n\n\t\t\t\t\t\t\t<div class="form-fields-from-to is-primary">\n\n\t\t\t\t\t\t\t\t<!-- Date from -->\n\t\t\t\t\t\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="regeneratePayslipsFrom" class="required" ng-class="{\'disabled\' : !vm.regenerateDocumentsOptions.documentTypes.payslips }">First pay period:</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<select ng-change="vm.refreshPayPeriods(vm)" name="regeneratePayslipsFrom" id="regeneratePayslipsFrom" ng-disabled="!vm.regenerateDocumentsOptions.documentTypes.payslips" ng-model="vm.regenerateDocumentsOptions.periodFromId" ng-options="payPeriod.PayPeriodID as payPeriod.PayPeriodDisplay for payPeriod in vm.regenerationDetails.periodsFrom | orderBy: \'startDateUnix\'" ng-required="vm.regenerateDocumentsOptions.documentTypes.payslips">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Date to -->\n\t\t\t\t\t\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label for="regeneratePayslipsTo" class="required" ng-class="{\'disabled\' : !vm.regenerateDocumentsOptions.documentTypes.payslips }">Last pay period:</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<select ng-change="vm.refreshPayPeriods(vm)" name="regeneratePayslipsTo" id="regeneratePayslipsTo" ng-disabled="!vm.regenerateDocumentsOptions.documentTypes.payslips" ng-model="vm.regenerateDocumentsOptions.periodToId" ng-options="payPeriod.PayPeriodID as payPeriod.PayPeriodDisplay for payPeriod in vm.regenerationDetails.periodsTo | orderBy: \'startDateUnix\'" ng-required="vm.regenerateDocumentsOptions.documentTypes.payslips">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="regenerateDocumentsForm.$error" ng-if="true" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="pay-period-range">Please select a valid range</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</checkbox-content>\n\t\t\t\t\t</extended-checkbox>\n\n\t\t\t\t\t<extended-checkbox name="p60" ng-model="vm.regenerateDocumentsOptions.documentTypes.p60" on-change="vm.documentTypeSelectionChanged(vm.regenerateDocumentsOptions)" required="!vm.selectionsAreValid" ng-if="vm.regenerationDetails.CanRegenerateP60">\n\t\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark extended-checkbox_title">P60</h6>\n\t\t\t\t\t\t</checkbox-label>\n\t\t\t\t\t</extended-checkbox>\n\n\t\t\t\t\t<extended-checkbox name="p45" ng-model="vm.regenerateDocumentsOptions.documentTypes.p45" on-change="vm.documentTypeSelectionChanged(vm.regenerateDocumentsOptions)" required="!vm.selectionsAreValid" ng-if="vm.regenerationDetails.CanRegenerateP45">\n\t\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark extended-checkbox_title">P45</h6>\n\t\t\t\t\t\t</checkbox-label>\n\t\t\t\t\t</extended-checkbox>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="regenerateDocumentsForm.documentType.$error" ng-if="vm.selectionsChanged" role="alert">\n\t\t\t\t<p ng-message="required">Please select at least one document type</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Regenerate\'" disable-button="!regenerateDocumentsForm.$valid" state="regenerateDocumentsForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-title="Documents regenerated" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}\'s documents have been regenerated and are now available in the Documents area in {{formOptions.context.Gender | personalise:\'her\'}} profile.</p>\n\t</fs-main>\n</form-state>\n\n<!-- HMRC credentials valid but Electronic updates are not switched on -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="true" fs-title="No documents to regenerate" ng-if="pageState === \'no-documents-to-regenerate\'">\n\t<fs-main>\n\t\t<p class="s">There are no documents available to regenerate for {{formOptions.context.Forename}}. Please note that only Payslips, P45s and P60s can be regenerated.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/rejoinLeaver/rejoinLeaverForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Rejoin {{formOptions.context.Forename}} onto payroll?" ng-if="pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="is-small">This will add a new starter profile for {{formOptions.context.Forename}} in your Team members area. A read-only copy of their company details, Year to Dates, documents, and history information will remain in your Leavers area. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" ng-click="formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\t\t<a href="" ng-click="rejoinLeaver()" class="button tertiary primary-action">Confirm</a>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Rejoined {{formOptions.context.Forename}} onto payroll" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="is-small">{{formOptions.context.Forename}} has been rejoined onto payroll, and their previous start and leaves dates have been reset, allowing you can enter up to date information for them. A read-only copy of their profile has been added to your Leavers area.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/removePayslipNotes/removePayslipNotesForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="removePayslipNoteForm" ng-submit="removePayslipNotes(form, removePayslipNoteForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to remove these payslip notes?" ng-if="bulkRemoval">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">This cannot be undone and you will need to add the payslip note for {{teamMembers.length}} team members again if you change your mind later. </p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to remove this payslip note?" ng-if="!bulkRemoval">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<p class="s">This cannot be undone and you will need to add the payslip note for {{teamMember.PersonalDetails.Forename}} again if you change your mind later. </p>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Remove payslip notes\'" state="removePayslipNoteForm.state" disable-button="!removePayslipNoteForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Payslip note removed" ng-if="pageState === \'saved\' && !bulkRemoval">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.PersonalDetails.Forename}}\'s payslip note has been removed.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Payslip notes removed" ng-if="pageState === \'saved\' && bulkRemoval">\n\t<fs-main>\n\t\t<p class="s">{{teamMembers.length}} team member\'s payslip notes have been removed.</p>\n\t</fs-main>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/repaymentSchedules/repaymentSchedulesForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n<!-- Calculate Repayment Schedule -->\n<form name="calculateRepaymentScheduleForm" class="fadeIn" ng-submit="calculateRepaymentSchedule(paymentSchedule, payPeriods, paymentScheduleTypes, calculateRepaymentScheduleForm)" ng-if="pageState === \'calculate-schedule\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Schedule settings</h4>\n\t\t<p class="s">Add your settings then click &lsquo;Calculate schedule&rsquo; so you can review the schedule of deductions before saving.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.repaymentSchedules" underline="true">More about repayment schedules</support-article-link></p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Loan type -->\n\t\t<div class="form-field">\n\t\t\t<label class="required" for="loanTypeCompany">Which type of loan is this for?</label>\n\t\t\t<div class="radio-cards s radio-cards-phone-block">\n\t\t\t\t<div class="radio-card" ng-repeat="paymentScheduleType in paymentScheduleTypes">\n\t\t\t\t\t<input type="radio" name="loanType{{$index}}" id="loanType{{$index}}" class="radio-card-input" required ng-change="setupSelectedScheduleType(paymentSchedule, $root.currentCompany, calculateRepaymentScheduleForm)" ng-value="paymentScheduleType" ng-model="paymentSchedule.paymentScheduleType">\n\t\t\t\t\t<label class="radio-card-label" for="loanType{{$index}}">\n\t\t\t\t\t\t<i class="icon-{{paymentScheduleType.PaymentScheduleTypeID | paymentScheduleTypeIcon}} radio-card-icon"></i>\n\t\t\t\t\t\t<p class="radio-card-text">{{paymentScheduleType.PaymentScheduleTypeDescription}}</p>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Loan amount / First payment date -->\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Loan amount -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="loanAmount" class="required">Total loan amount:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="number" id="loanAmount" name="loanAmount" class="monetise" required autocomplete="off" ng-model="paymentSchedule.TotalAmount" ng-min="1" ng-max="200000" ng-maxlength="10" ng-blur="getRepaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="calculateRepaymentScheduleForm.loanAmount.$error" ng-show="calculateRepaymentScheduleForm.loanAmount.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a loan amount</p>\n\t\t\t\t\t<p ng-message="min">Please enter a positive amount</p>\n\t\t\t\t\t<p ng-message="max">Maximum of {{200000 | monetise}}</p>\n\t\t\t\t\t<p ng-message="maxlength">Only 10 digits are allowed</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Amount paid so far -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="totalBoughtForward" class="required">Amount paid so far:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="number" id="totalBoughtForward" name="totalBoughtForward" class="monetise" required autocomplete="off" ng-model="paymentSchedule.TotalBroughtForward" ng-min="0" max="{{paymentSchedule.TotalAmount}}" ng-maxlength="10" ng-blur="getRepaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="calculateRepaymentScheduleForm.totalBoughtForward.$error" ng-show="calculateRepaymentScheduleForm.totalBoughtForward.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a loan amount</p>\n\t\t\t\t\t<p ng-message="min">Please enter a positive amount</p>\n\t\t\t\t\t<p ng-message="max">This cannot be more than the loan amount</p>\n\t\t\t\t\t<p ng-message="maxlength">Only 10 digits are allowed</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- First Deduction Period -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="payPeriodStartDate" class="required" ng-class="{\'disabled\': isEditMode}">Take the first deduction in:</label>\n\t\t\t</div>\n\t\t\t<div class="field">\n\t\t\t\t<select class="l-alt" name="payPeriodStartDate" id="payPeriodStartDate" required ng-model="paymentSchedule.firstPayPeriod" ng-change="setupSelectedPayPeriod(paymentSchedule, calculateRepaymentScheduleForm)" ng-options="payPeriod as payPeriod.PayPeriodDisplay for payPeriod in payPeriods" ng-if="!isEditMode"></select>\n\n\t\t\t\t<input class="l-alt" id="payPeriodStartDate" name="payPeriodStartDate" type="text" disabled="disabled" required ng-model="paymentSchedule.FirstPayPeriodDisplay" ng-if="isEditMode" ng-blur="getRepaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="calculateRepaymentScheduleForm.payPeriodStartDate.$error" ng-if="calculateRepaymentScheduleForm.payPeriodStartDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select the pay period type</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Deduction method -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="deductionTypeFixed">How do you wish to take deductions?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\n\t\t\t\t<extended-radio name="deductionTypeFixed" value="LOAN_DEDUCTION_TYPES.FIXED" ng-model="paymentSchedule.deductionType" show-content-when-checked="(calculateRepaymentScheduleForm.fixedDeductionAmount.$valid && paymentSchedule.LastPayPeriodDisplay) || (calculateRepaymentScheduleForm.fixedDeductionAmount.$touched && calculateRepaymentScheduleForm.fixedDeductionAmount.$invalid)" on-change="setPaymentScheduleRepaymentDefaults(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Take a fixed deduction each pay period of</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-field>\n\t\t\t\t\t\t<input type="number" id="fixedDeductionAmount" name="fixedDeductionAmount" class="monetise m" autocomplete="off" ng-model="paymentSchedule.FixedRepaymentAmount" ng-min="paymentSchedule.deductionType === LOAN_DEDUCTION_TYPES.FIXED ? 1 : 0" ng-max="paymentSchedule.TotalAmount" ng-maxlength="10" ng-disabled="paymentSchedule.deductionType !== LOAN_DEDUCTION_TYPES.FIXED" ng-required="paymentSchedule.deductionType === LOAN_DEDUCTION_TYPES.FIXED" ng-change="resetPaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)" ng-blur="getRepaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t\t</radio-field>\n\n\t\t\t\t\t<radio-content>\n\n\t\t\t\t\t\t<div class="form-errors" ng-messages="calculateRepaymentScheduleForm.fixedDeductionAmount.$error" ng-if="calculateRepaymentScheduleForm.fixedDeductionAmount.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">This value can&apos;t exceed the total loan amount</p>\n\t\t\t\t\t\t\t<p ng-message="maxlength">Only 10 digits are allowed</p>\n\t\t\t\t\t\t\t<p ng-message="min">This value needs to be a positive amount</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t\t\t\t<p ng-message="overLimit">Maximum number of {{::paymentSchedule.PeriodRepaymentCountMax}} pay periods exceeded</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="fadeIn" ng-if="calculateRepaymentScheduleForm.fixedDeductionAmount.$valid && paymentSchedule.LastPayPeriodDisplay">\n\t\t\t\t\t\t\t<p class="is-small">The last deduction will be taken in the {{paymentSchedule.LastPayPeriodDisplay}} period</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\n\t\t\t\t<extended-radio name="deductionType" value="LOAN_DEDUCTION_TYPES.SPLIT" ng-model="paymentSchedule.deductionType" show-content-when-checked="(calculateRepaymentScheduleForm.splitDeductionPeriodCount.$valid && paymentSchedule.LastPayPeriodDisplay) || (calculateRepaymentScheduleForm.splitDeductionPeriodCount.$touched && calculateRepaymentScheduleForm.splitDeductionPeriodCount.$invalid)" on-change="setPaymentScheduleRepaymentDefaults(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Split deductions evenly over a number of pay periods</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-field>\n\t\t\t\t\t\t<input type="number" id="splitDeductionPeriodCount" name="splitDeductionPeriodCount" class="s-alt" autocomplete="off" ng-model="paymentSchedule.PeriodRepaymentCount" ng-min="paymentSchedule.deductionType === LOAN_DEDUCTION_TYPES.SPLIT ? 1 : 0" ng-max="paymentSchedule.PeriodRepaymentCountMax" ng-disabled="paymentSchedule.deductionType !== LOAN_DEDUCTION_TYPES.SPLIT" ng-required="paymentSchedule.deductionType === LOAN_DEDUCTION_TYPES.SPLIT" ng-change="resetPaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)" ng-blur="getRepaymentAmountValidation(paymentSchedule, calculateRepaymentScheduleForm)">\n\t\t\t\t\t</radio-field>\n\n\t\t\t\t\t<radio-content>\n\n\t\t\t\t\t\t<div class="form-errors" ng-messages="calculateRepaymentScheduleForm.splitDeductionPeriodCount.$error" ng-if="calculateRepaymentScheduleForm.splitDeductionPeriodCount" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">This value can&apos;t exceed {{::paymentSchedule.PeriodRepaymentCountMax}} periods</p>\n\t\t\t\t\t\t\t<p ng-message="min">This value needs to be a positive amount</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="fadeIn" ng-if="calculateRepaymentScheduleForm.splitDeductionPeriodCount.$valid && paymentSchedule.LastPayPeriodDisplay">\n\t\t\t\t\t\t\t<p class="is-small">The last deduction will be taken in the {{paymentSchedule.LastPayPeriodDisplay}} period</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">The schedule can be split over a maximum of {{::paymentSchedule.PeriodRepaymentCountMax}} pay periods</p>\n\t\t</div>\n\n\t\t<!-- Payslip Label -->\n\t\t<div class="form-field">\n\t\t\t<div class="pill-input-field primary" ng-class="{\'active\': paymentSchedule.adjustmentLabelFocus}">\n\t\t\t\t<label for="adjustmentLabel" class="pill-input-field-label"><i class="icon-label"></i> Label for payslip <span>optional</span></label>\n\t\t\t\t<input class="pill-input-field-input fadeIn" type="text" id="adjustmentLabel" name="adjustmentLabel" ng-model="paymentSchedule.PayslipLabel" ng-focus="toggleAdjustmentLabelFocus(paymentSchedule, true)" ng-blur="toggleAdjustmentLabelFocus(paymentSchedule, false)" placeholder="Add a custom label for this schedule" maxlength="40" minlength="3" ng-pattern="$root.REGEX.description">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pensionable -->\n\t\t<fieldset>\n\t\t\t<settings-row sr-field-name="paymentScheduleGroupPensionState" sr-icon="money" ng-model="paymentSchedule.PaymentScheduleGroupPensionState" sr-theme="quarternary" sr-disabled="!paymentSchedule.pensionableStatusEditable" on-update="updateRepaymentSchedulePensionable(paymentSchedule)" ng-if="$root.currentCompany.IsPensionActive">\n\t\t\t\t<sr-label>Pensionable</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-switch="paymentSchedule.PaymentScheduleGroupPensionBehaviour">\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked">This will be included in pay when calculating pension contributions. It can\'t be switched &lsquo;OFF&rsquo;.</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked">This will not be included in pay when calculating pension contributions. It can\'t be switched &lsquo;ON&rsquo;.</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on">Switch to &lsquo;OFF&rsquo; if you don\u2019t want these payments to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.</span>\n\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off">Switch to &lsquo;ON&rsquo; if you want these payments to be included in pay when calculating pension contributions for {{formOptions.company.Name}}.</span>\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-content ng-if="paymentSchedule.PaymentScheduleGroupPensionState && paymentSchedule.PaymentScheduleGroupPension.length > 0">\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<h6>Include when calculating contributions for:</h6>\n\t\t\t\t\t</fieldset>\n\n\t\t\t \t\t<!-- Pension Salary Sacrifice Behaviour -->\n\t\t\t \t\t<div class="form-field less-margin color-card is-white" ng-repeat="pension in paymentSchedule.PaymentScheduleGroupPension">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth" ng-class="{ \'is-greyscale\': !paymentSchedule.pensionableStatusEditable }">\n\t\t\t\t\t\t\t\t{{::pension.PensionProviderName}}\n\t\t\t\t\t\t\t\t<span class="float-right is-quarternary is-light">Ref: {{::pension.EmployerReference}}</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-list is-inline" ng-class="{ \'is-disabled\' : !paymentSchedule.pensionableStatusEditable }">\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourEmployer-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::!paymentSchedule.pensionableStatusEditable" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployer-{{::pension.AgencyEmployerPensionID}}">Employer only</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourEmployee-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::!paymentSchedule.pensionableStatusEditable" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourEmployee-{{::pension.AgencyEmployerPensionID}}">Employee only</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input class="b is-quarternary" id="paymentScheduleTypePensionBehaviourBoth-{{::pension.AgencyEmployerPensionID}}" name="paymentScheduleTypePensionBehaviour-{{::pension.AgencyEmployerPensionID}}" ng-disabled="::!paymentSchedule.pensionableStatusEditable" ng-model="pension.PaymentScheduleGroupPensionBehaviourAttributes" ng-value="PAYMENT_SCHEDULE_PENSION_OPTIONS.both" type="radio">\n\t\t\t\t\t\t\t\t\t<label for="paymentScheduleTypePensionBehaviourBoth-{{::pension.AgencyEmployerPensionID}}">Both</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t \t\t</div>\n\n\t\t\t\t</sr-content>\n\n\t\t\t</settings-row>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Calculate schedule\'" disable-button="calculateRepaymentScheduleForm.$invalid || !paymentSchedule.LastPayPeriodDisplay" state="calculateRepaymentScheduleForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Save Schedule -->\n<form name="saveRepaymentScheduleForm" class="fadeIn" ng-submit="saveRepaymentSchedule(paymentSchedule, saveRepaymentScheduleForm)" ng-if="pageState === \'save-schedule\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Repayment schedule</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-section">\n\t\t\t<repayment-card repayment="paymentSchedule"></repayment-card>\n\t\t</div>\n\n\t\t<div class="form-section" ng-switch="paymentSchedule.deductionType">\n\t\t\t<p class="s" pc-switch-when="LOAN_DEDUCTION_TYPES.FIXED">This is based on a fixed deduction each pay period of {{paymentSchedule.FixedRepaymentAmount | monetise}}, starting in {{paymentSchedule.FirstPayPeriodDisplay}}. <span ng-if="canEditPaymentSchedule">If you need to change anything, go back and <a href="" class="underline" ng-click="editSchedule(paymentSchedule)">edit the schedule settings</a>.</span></p>\n\t\t\t<p class="s" pc-switch-when="LOAN_DEDUCTION_TYPES.SPLIT">This is based on a split deduction over&nbsp;<ng-pluralize count="paymentSchedule.PeriodRepaymentCount" when="{\'1\': \'1 pay period\', \'other\': \'{} pay periods\'}"></ng-pluralize>, starting in {{paymentSchedule.FirstPayPeriodDisplay}}. <span ng-if="canEditPaymentSchedule">If you need to change anything, go back and <a href="" class="underline" ng-click="editSchedule(paymentSchedule)">edit the schedule settings</a>.</span></p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<table class="primary payments-table">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Pay Period</th>\n\t\t\t\t\t\t<th>Deduction</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr class="payments-table-repaid" ng-if="paymentSchedule.TotalBroughtForward > 0">\n\t\t\t\t\t\t<td>Previous</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag assertive">Paid</span>\n\t\t\t\t\t\t\t<strong class="payments-table-amount is-deduction">{{paymentSchedule.TotalBroughtForward | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr ng-repeat="payment in paymentSchedule.ScheduleEntries" ng-class="{\'payments-table-paid\': payment.IsPaid}">\n\t\t\t\t\t\t<td><strong>{{payment.PayPeriodDisplay}}</strong></td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class="tag assertive" ng-if="payment.IsPaid">Paid</span>\n\t\t\t\t\t\t\t<strong class="payments-table-amount is-deduction">{{payment.ScheduleValue | monetise}}</strong>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class="form-section" ng-show="paymentSchedule.filteredPaymentScheduleGroupPension.length > 0">\n\n\t\t\t<div class="form-field">\n\n\t\t\t\t<div class="detail-blocks accordion s">\n\n\t\t\t\t\t<button type="button" class="is-clear detail-blocks-toggle clickable is-secondary no-padding-bottom" ng-class="{\'active\' : showPensionSchemes}" ng-click="showPensionSchemes = !showPensionSchemes">\n\t\t\t\t\t\t<div class="detail-block-toggle-dot">\n\t\t\t\t\t\t\t<icon-dot icon="icon-money" theme="is-secondary"></icon-dot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\t\tPensionable for <ng-pluralize count="paymentSchedule.filteredPaymentScheduleGroupPension.length" when="{\'1\': \'1 scheme\', \'other\': \'{} schemes\'}"></ng-pluralize>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t\t<i class="icon-chevron-up is-secondary"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<div class="detail-blocks-hidden" ng-class="{\'active\' : showPensionSchemes}">\n\n\t\t\t\t\t\t<table width="100%">\n\t\t\t\t\t\t\t<tr ng-repeat="scheme in paymentSchedule.filteredPaymentScheduleGroupPension = ( paymentSchedule.PaymentScheduleGroupPension | filter: { PaymentScheduleGroupPensionState: true } )">\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale-dark is-small">{{::scheme.PensionProviderName}}</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small">({{::scheme.EmployerReference}})</span>\n\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t<td class="float-right" ng-switch="scheme.PaymentScheduleGroupPensionBehaviourAttributes">\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.both">Employee and Employer</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employee">Employee only</span>\n\t\t\t\t\t\t\t\t\t<span class="is-greyscale is-small" pc-switch-when="PAYMENT_SCHEDULE_PENSION_OPTIONS.employer">Employer only</span>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top no-margin-top" ng-if="::!isEditMode">\n\t\t<p class="is-small">Click &lsquo;Save schedule&rsquo; and {{formOptions.context.Forename}}&apos;s deductions will begin in the pay period {{paymentSchedule.FirstPayPeriodDisplay}}. You can edit or delete the schedule before it begins.</p>\n\t</fieldset>\n\n\t<!-- Delete / Cancel -->\n\t<fieldset class="form-fieldset-divider-top no-margin-top" ng-if="paymentSchedule.state === \'viewing\'">\n\t\t<p class="caption">Added by {{paymentSchedule.CreatedBy}} on {{paymentSchedule.CreatedDateISO | dateformat:\'numeric\'}} at {{paymentSchedule.CreatedDateISO | dateformat:\'time\'}}.</p>\n\t\t<p class="caption" ng-if="paymentSchedule.CancelledDateISO !== \'\'">Cancelled by {{paymentSchedule.CancelledBy}} on {{paymentSchedule.CancelledDateISO | dateformat:\'numeric\'}} at {{paymentSchedule.CancelledDateISO | dateformat:\'time\'}}.</p>\n\t\t<a href="" data-cy="slide-in-form-delete-link" ng-click="setPageState(canEditPaymentSchedule ? \'confirm-delete\' : \'confirm-cancel\')" class="greyscale form-meta-delete-action" ng-if="paymentSchedule.CanCancel && paymentSchedule.CancelledDateISO === \'\'"><i class="icon-trash m"></i>{{canEditPaymentSchedule ? \'Delete\' : \'Cancel\'}} schedule</a>\n\t</fieldset>\n\n\t<fieldset class="form-actions" ng-if="paymentSchedule.state === \'calculated\'">\n\t\t<a href="" class="button secondary-action" ng-click="editSchedule(paymentSchedule)">Back</a>\n\t\t<submit-button display-text="\'Save schedule\'" disable-button="!saveRepaymentScheduleForm.$valid" state="saveRepaymentScheduleForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Repayment schedule saved" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}&apos;s &lsquo;{{paymentSchedule.PaymentScheduleTypeDescription}}&rsquo; repayment schedule has now been saved and the first repayment will be taken in the pay period {{paymentSchedule.FirstPayPeriodDisplay}}.</p>\n\t\t<p class="s"><strong>Please note:</strong> You can edit or delete the schedule before it begins and, once the schedule has started, you can also edit a payment each pay period if, for example, {{formOptions.context.Forename}} wished to pay the loan off early.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.repaymentSchedules" underline="true">Read more about repayment schedules here</support-article-link>.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Confirm Cancel -->\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to cancel this schedule?" ng-if="pageState === \'confirm-cancel\'">\n\t<fs-main>\n\t\t<p class="s">This will cancel the &lsquo;{{paymentSchedule.PaymentScheduleTypeDescription}}&rsquo; ({{paymentSchedule.TotalAmount | monetise}}) repayment schedule for {{formOptions.context.Forename}}. Any paid payments will remain for historic purposes but all future payments will be deleted. This can\'t be undone and you will have to create it again if you decide you need it later.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'save-schedule\')">Cancel</a>\n\t\t<button id="button-primary" class="tertiary primary-action" ng-click="deletePaymentScheduleGroup(paymentSchedule, \'successfully-cancelled\')">Cancel schedule</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Confirm Delete -->\n<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this schedule?" ng-if="pageState === \'confirm-delete\'">\n\t<fs-main>\n\t\t<p class="s">This will delete the &lsquo;{{paymentSchedule.PaymentScheduleTypeDescription}}&rsquo; ({{paymentSchedule.TotalAmount | monetise}}) repayment schedule for {{formOptions.context.Forename}}. This can\'t be undone and you will have to create it again if you decide you need it later.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'save-schedule\')">Cancel</a>\n\t\t<button id="button-primary" class="tertiary primary-action" ng-click="deletePaymentScheduleGroup(paymentSchedule, \'successfully-deleted\')">Delete schedule</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Successfully cancelled -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Schedule cancelled" ng-if="pageState === \'successfully-cancelled\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}&apos;s repayment schedule has been cancelled.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Successfully deleted -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Schedule deleted" ng-if="pageState === \'successfully-deleted\'">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.Forename}}&apos;s repayment schedule has been deleted.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Invalid schedule -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="A repayment schedule can\'t exceed one year" ng-if="pageState === \'invalid-schedule\'">\n    <fs-main>\n        <p class="s">You&apos;ve entered a loan amount of {{paymentSchedule.TotalAmount | monetise}} and chosen to recover it with fixed deductions of {{paymentSchedule.FixedRepaymentAmount | monetise}} each pay period. This means the schedule will exceed the limit of one year. Click &lsquo;back&rsquo; to change the values you&apos;ve entered.</p>\n    </fs-main>\n    <fs-actions>\n        <a href="" class="button secondary-action" ng-click="setPageState(\'calculate-schedule\')">Back</a>\n    </fs-actions>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/reversedHmrcTaxUpdates/reversed-hmrc-tax-updates.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="reversedHmrcTaxUpdatesForm" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small is-font-greyscale-300">\n\t\t\tThe below team members have pending tax updates that may cause an unintended reversal in their tax status. Click \'Go to profile\' to make adjustments to their pending tax updates.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<span class="is-small is-greyscale-dark is-strong">\n\t\t\t\t\t<ng-pluralize count="$ctrl.distinctTeamMemberCount" when="{ \'1\': \'1 team member\', \'other\': \'{} team members\'}">\n\t\t\t\t\t</ng-pluralize>\n\t\t\t\t</span>\n\t\t\t</header>\n\t\t\t<div class="form-field-main team-card-reversed-tax-codes_wrapper">\n\t\t\t\t<team-card-reversed-tax-codes ng-repeat="teamMember in $ctrl.teamMembers" team-member="teamMember">\n\t\t\t\t</team-card-reversed-tax-codes>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<submit-button display-text="\'Close\'" ng-click="$ctrl.formOptions.closeForm()"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/rollback-period/rollback-period.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="rollbackPeriodForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.ready" ng-submit="$ctrl.rollbackPeriod(rollbackPeriodForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to rollback?">\n\n\t\t<fs-main>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tRolling back will re-open the period <strong>{{$ctrl.payPeriod.PayPeriodDisplay}}</strong>\n\t\t\t\t\tand you won\'t be able to access <strong>{{::$root.currentPeriod.PayPeriodDisplay}}</strong>.\n\t\t\t\t\tDon\'t worry if you\'ve already started making changes in {{::$root.currentPeriod.PayPeriodDisplay}},\n\t\t\t\t\tthey will still be there once you\'ve re-run payroll for {{$ctrl.payPeriod.PayPeriodDisplay}}.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that unless you are within the delayed submission period, automated pension submissions cannot be corrected by performing a rollback.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<!-- Manual tacks -->\n\t\t\t<section class="form-state-section">\n\t\t\t\t<note note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Manual tasks after rolling back a pay period">\n\t\t\t\t\t<note-content>\n\n\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tBefore continuing, please note a number of manual tasks that you will need to action for rolled back periods:\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\'Pension status and contribution changes you\u2019ve made for team members  won\u2019t be automatically reverted so this will need to be done manually\',\n\t\t\t\t\t\t\t\t\t\'Team members who were submitted as leavers in this period won\u2019t have their P45s regenerated and you\u2019ll need to do this manually from the Documents tab in their profiles after you\u2019ve re-run\',\n\t\t\t\t\t\t\t\t\t\'Team members who have been marked as submitted leavers will need to be unmarked as leavers in your Leavers area\',\n\t\t\t\t\t\t\t\t\t\'A rejoiner cannot be cancelled once they have been processed through payroll after rejoining. If you have rejoined a leaver, you should not rollback to a period before they were rejoined\',\n\t\t\t\t\t\t\t\t\t\'Automatic or manual tax code updates that have been applied for team members won\u2019t be automatically reverted, or re-applied when you re-run, so this will need to be done manually\',\n\t\t\t\t\t\t\t\t\t\'If workflow is active, it will be reverted to the same step that your current period is on, step deadlines will become out of date, and step completion notifications won\u2019t be sent until you bring payroll back up to date\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-small is-italicised is-indifferent is-spaced-out"></bullet-list>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t<span class="strong indifferent upcase">Important:</span>\n\t\t\t\t\t\t\t\tRollbacks are not recommended and should always be actioned with caution.\n\t\t\t\t\t\t\t\tThe recommendation is to always encourage changes to be made within the next period where possible.\n\t\t\t\t\t\t\t\tBy choosing to rollback a pay period you are taking full responsibility for any potential payroll misalignments\n\t\t\t\t\t\t\t\tthat occur as a result.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<input id="confirmRollback" label-text="\'I understand the risks and take responsibility\'" name="confirmRollback" ng-model="$ctrl.confirm" type="checkbox" checkbox required>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</section>\n\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button disable-button="!rollbackPeriodForm.$valid" display-text="\'Roll back period\'" state="rollbackPeriodForm.state"></submit-button>\n\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{::$ctrl.payPeriod.PayPeriodDisplay}} has been re-opened" ng-if="$ctrl.formState === $ctrl.FORM_STATES.success">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou can now add any changes you may have forgotten to {{::$ctrl.payPeriod.PayPeriodDisplay}} before re-running payroll.\n\t\t\tIf you have any questions or need any help with anything please\n\t\t\t\tcontact support.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Unable to Rollback -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This period can\'t be rolled back" ng-if="$ctrl.formState === $ctrl.FORM_STATES.notAllowed">\n\t<fs-main>\n\t\t<div ng-switch="$ctrl.canRollbackState">\n\n\t\t\t<!-- Already rolled back -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noAlreadyRolledBack">\n\t\t\t\tYou can only roll back a pay period once and the {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period has previously been\n\t\t\t\trolled back and re-run.\n\t\t\t</p>\n\n\t\t\t<!-- No double roll back -->\n\t\t\t<p class="is-small" pc-switch-when="[\n\t\t\t\t\t$ctrl.ROLLBACK_STATES.noDoubleRollback,\n\t\t\t\t\t$ctrl.ROLLBACK_STATES.noNotLastSubmittedPeriod\n\t\t\t\t]">\n\t\t\t\tYou can\'t roll back multiple pay periods and you have already rolled back {{::$root.currentPeriod.PayPeriodDisplay}}.\n\t\t\t</p>\n\n\t\t\t<!-- No unsubmitted period -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noUnsubmittedPeriod">\n\t\t\t\tThe {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period can\'t be rolled back at this time as it hasn\'t been run yet.\n\t\t\t\tIf the problem persists please\n\t\t\t\t\tcontact support.\n\t\t\t</p>\n\n\t\t\t<!-- No partially submitted current period -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noHasPartiallySubmittedCurrentPeriod">\n\t\t\t\tThe {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period can\'t be rolled back at this time as your current period was only partially submitted.\n\t\t\t\tIf the problem persists please\n\t\t\t\t\tcontact support.\n\t\t\t</p>\n\n\t\t\t<!-- Is an agency -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noIsAnAgency">\n\t\t\t\tYou can\'t roll back pay periods for an agency payroll. If you have any questions or need any help with anything please\n\t\t\t\t\tcontact support.\n\t\t\t</p>\n\n\t\t\t<!-- Sup. pay run been made -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noHasSupplementaryPayment">\n\t\t\t\tAs a supplementary pay run has been made since payroll was finalised, you can no longer\n\t\t\t\troll back the {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period.\n\t\t\t</p>\n\n\t\t\t<!-- Period contained advancing team members -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noHasAdvancingTeamMembers">\n\t\t\t\tPlease note that this period included team members with future periods advanced so it can\u2019t be rolled back.\n\t\t\t\tAny corrections for those team members will need to be made manually once they return to payroll.\n\t\t\t</p>\n\n\t\t\t<!-- Cloned company -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noIsClone">\n\t\t\t\tYou can\'t roll back pay periods for a cloned payroll. If you have any questions or need any help with anything please\n\t\t\t\t\tcontact support.\n\t\t\t</p>\n\n\t\t\t<!-- Pay policy active -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noIsPayPolicyActive">\n\t\t\t\tThe {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period can\u2019t be rolled back as a team member was paid using a pay policy.\n\t\t\t</p>\n\n\t\t\t<!-- Pay policy updated -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noPayPolicyWasUpdated">\n\t\t\t\tThe {{::$ctrl.payPeriod.PayPeriodDisplay}} pay period can\'t be rolled back as a pay policy has been updated.\n\t\t\t</p>\n\n\t\t\t<!-- Rejoiners included -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noHasRejoiners">\n\t\t\t\t{{::$ctrl.payPeriod.PayPeriodDisplay}} can\u2019t be rolled back as it included a leaver who was rejoined.\n\t\t\t\tYou need to cancel them as a rejoiner before trying to roll back again.\n\t\t\t</p>\n\n\t\t\t<!-- Has draft payslips -->\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.ROLLBACK_STATES.noHasDraftPayslips">\n\t\t\t\tYou cannot rollback to a previous period because you have draft payslips pending in the current period. \n\t\t\t\tPlease recall your draft payslips from Smart View first, then return here to rollback.\n\t\t\t</p>\n\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Year End Rollback EA Alert -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Employment Allowance may be affected" fs-show-close="false" ng-if="$ctrl.formState === $ctrl.FORM_STATES.alert">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe pay period you\'re about to rollback relates to a different tax year to the current period.\n\t\t</p>\n\n\t\t<p class="is-small">\n\t\t\tIf the Employment Allowance settings for {{$root.currentCompany.Name}} have changed between the {{$ctrl.payPeriod.TaxYearDisplay}} tax year and the current period, for example because \'Auto-reclaim\' wasn\'t turned on, it could impact both your EPS and P32 reports. \n\t\t\tYou may need to adjust your \'Employer status\' settings before running.\n\t\t</p>\n\n\t\t<p class="is-small">\n\t\t\tClick \'Continue\' if you\'re happy that you\'ve added the correct Employment Allowance settings for the {{$ctrl.payPeriod.TaxYearDisplay}} tax year for {{$root.currentCompany.Name}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="primary-action tertiary" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.ready)" type="button">\n\t\t\tContinue\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/runPayroll/runPayrollForm.html','<loading-block ng-if="pageState === FORM_STATES.loading"></loading-block>\n\n<section class="fadeIn" ng-if="pageState === FORM_STATES.ready" ng-switch="currentPayPeriod.PayrollState">\n\t<!-- Unsubmitted -->\n\t<form name="runPayrollForm" ng-submit="reviewPayroll(currentPayPeriod, companyBankDetails, runPayrollForm)" pc-switch-when="SUBMISSION_STATES.unsubmitted" novalidate>\n\t\t<!-- Pay Period Description -->\n\t\t<section class="form-section">\n\t\t\t<div class="info-block align-center" ng-class="{\n\t\t\t\t\t\'is-primary\': currentPayPeriod.PayDayDaysOverdue === 0,\n\t\t\t\t\t\'is-assertive\': currentPayPeriod.PayDayDaysOverdue > 0\n\t\t\t\t}" ng-if="!currentPayPeriod.IsOutsideTimePeriod">\n\t\t\t\t<p>You\'re about to approve payroll for the period</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<h4 class="strong" data-cy="run-payroll-current-pay-period">\n\t\t\t\t\t{{currentPayPeriod.PayPeriodDisplay}}\n\t\t\t\t</h4>\n\t\t\t</div>\n\n\t\t\t<div class="info-block align-center tertiary" ng-if="currentPayPeriod.IsOutsideTimePeriod">\n\t\t\t\t<p class="tertiary-light">You\'re about to approve payroll for the period</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<h4 class="strong" data-cy="run-payroll-current-pay-period">\n\t\t\t\t\t{{currentPayPeriod.PayPeriodDisplay}}\n\t\t\t\t</h4>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<p class="s tertiary stronger" data-cy="close-succession-outside-period-message">\n\t\t\t\t\t<i class="icon-warning m is-icon-tertiary-300"></i>&nbsp;Running in close succession\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Total cost -->\n\t\t<section class="form-section" ng-if="currentPayPeriod.runPayrollStep !== RUN_PAYROLL_STEPS.advancePayrollsConfirmation">\n\t\t\t<payment-info-card card-icon="money" card-layout="row" card-theme="indifferent" card-title="Total cost" card-value="currentPayPeriod.TotalCost">\n\t\t\t\t<p>\n\t\t\t\t\tPay day {{currentPayPeriod.PayDateISO | dateformat}}\n\t\t\t\t</p>\n\t\t\t</payment-info-card>\n\t\t</section>\n\n\t\t<!-- Payroll -->\n\t\t<fieldset ng-if="currentPayPeriod.runPayrollStep === RUN_PAYROLL_STEPS.payrollSummary">\n\n\t\t\t<!-- Alerts -->\n\t\t\t<section class="form-section payroll-alert-card_wrapper has-larger-gap" ng-if="currentPayPeriod.runPayrollStep === RUN_PAYROLL_STEPS.payrollSummary">\n\t\t\t\t<!-- Delayed Pension Submission - Already submitted -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-money" ng-if="::currentPayPeriod.DelayPensionSubmission && currentPayPeriod.CanDelayPensionSubmission" theme="is-secondary">\n\t\t\t\t\t<pacb-title>Automated pension submission delayed</pacb-title>\n\t\t\t\t\t<pacb-detail>Scheduled to submit on {{::currentPayPeriod.PensionSubmissionScheduledDateISO | datetimeformat:\'long-alt\'}}</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Delayed Pension Submission - Already submitted -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-money" ng-if="::currentPayPeriod.DelayPensionSubmission && !currentPayPeriod.CanDelayPensionSubmission" theme="is-tertiary">\n\t\t\t\t\t<pacb-title>Automated pensions already submitted</pacb-title>\n\t\t\t\t\t<pacb-detail>Corrections to pension calculations will need to be made manually in the next pay period</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Alerts -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-warning" ng-if="::messsageStatusCounts.WarningCount > 0" theme="is-tertiary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payrollAlertCounts.WarningCount" when="{\'1\': \'1 warning\', \'other\': \'{} warnings\'}"></ng-pluralize>&nbsp;will be ignored\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail>\n\t\t\t\t\t\t<a ui-sref="payroll.run-payroll({agencyProfileId: formOptions.company.AgencyProfileID, activeTab: \'alerts\'})" class="is-tertiary is-underline">\n\t\t\t\t\t\t\tClick here\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tto review {{payrollAlertCounts.WarningCount === 1 ? \'it\' : \'them\'}}.\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Tasks -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-tick-square" ng-if="::messsageStatusCounts.TaskCount > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="messsageStatusCounts.TaskCount" when="{\'1\': \'1 task\', \'other\': \'{} tasks\'}"></ng-pluralize>&nbsp;outstanding\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail ng-if="::formOptions.company.IsWorkflowActive">\n\t\t\t\t\t\t<a class="is-primary is-underline" ui-sref="payroll.run-payroll({agencyProfileId: formOptions.company.AgencyProfileID, activeTab: \'periodTasks\'})">\n\t\t\t\t\t\t\tClick here\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tto review them.\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t\t<pacb-detail ng-if="::!formOptions.company.IsWorkflowActive">\n\t\t\t\t\t\t<a class="is-primary is-underline" ui-sref="payroll.current-period.tasks({agencyProfileId: formOptions.company.AgencyProfileID})">\n\t\t\t\t\t\t\tClick here\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tto review them.\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- RTI submission disabled -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-tax-code-change" ng-if="::formOptions.company.IsRTISubmissionDisabled" theme="is-secondary">\n\t\t\t\t\t<pacb-title>RTI submission is turned off</pacb-title>\n\t\t\t\t\t<pacb-detail>Your FPS and EPS will not be submitted to HMRC</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- EPS disabled -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-tax-code-change" ng-if="::formOptions.company.AgencyEmployerEPSDisabled" theme="is-secondary">\n\t\t\t\t\t<pacb-title>Auto EPS submission is turned off</pacb-title>\n\t\t\t\t\t<pacb-detail>You can submit your EPS manually from your history area</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Omitted from RTI -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-tax-code-change" ng-if="::payPeriodCounts.NumberOfTeamMembersExcludedFromRTI > 0" theme="is-secondary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersExcludedFromRTI" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize> <span class="is-medium is-greyscale-darkened">omitted from RTI submissions</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail><a href="" class="is-secondary is-underline" ui-sref="team.members({agencyProfileId: formOptions.company.AgencyProfileID, presetfilterkey: PRESET_FILTER_KEYS.team.isExcludedFromRti})">Click here</a> to review them</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- New Starters / Leavers -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-team" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfStarters" when="{\'0\': \'No new starters\', \'1\': \'1 new starter\', \'other\': \'{} new starters\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">and</span>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfLeavers" when="{\'0\': \'no leavers\', \'1\': \'1 leaver\', \'other\': \'{} leavers\'}"></ng-pluralize>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- CIS deductions -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-cis" ng-if="::(formOptions.company.IsCISActive && formOptions.company.IsPayrollActive) || cisDeductions.CISDeductionsSuffered > 0" theme="is-secondary">\n\t\t\t\t\t<pacb-title ng-if="::cisDeductions.CISDeductionsSuffered === 0">\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">Suffered</span> no CIS deductions\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-title ng-if="::cisDeductions.CISDeductionsSuffered > 0">\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">Suffered CIS deductions of</span>&nbsp;{{::cisDeductions.CISDeductionsSuffered | monetise}}\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- CIS subcontractor deductions -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-cis" ng-if="::(formOptions.company.IsCISActive && formOptions.company.IsPayrollActive) || cisDeductions.CISSubcontractorDeductions > 0" theme="is-secondary">\n\t\t\t\t\t<pacb-title ng-if="::cisDeductions.CISSubcontractorDeductions === 0">\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">Suffered</span> no additional CIS subcontractor deductions\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-title ng-if="::cisDeductions.CISSubcontractorDeductions > 0">\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">Additional CIS subcontractor deductions of</span>&nbsp;{{::cisDeductions.CISSubcontractorDeductions | monetise}}\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Adoption Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSAP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSAP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving adoption pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Maternity Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSMP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSMP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving maternity pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Paternity Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSPP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSPP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving paternity pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Shared Parental Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnShPP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnShPP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving shared parental pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Parental Bereavement Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSPBP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSPBP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving parental bereavement pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Neonatal Care Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-maternity" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSNCP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSNCP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving neonatal care pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Sick Pay -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-sick" ng-if="::payPeriodCounts.NumberOfTeamMembersOnSSP > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersOnSSP" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">receiving sick pay</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- HMRC Tax Reversal -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-tax-code-change" ng-if="::reversedHmrcTaxUpdatesCount > 0" theme="is-tertiary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="reversedHmrcTaxUpdatesCount" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">\n\t\t\t\t\t\t\t<ng-pluralize count="reversedHmrcTaxUpdatesCount" when="{\'1\': \'has\', \'other\': \'have\'}"></ng-pluralize>\n\t\t\t\t\t\t\tpending updates that may cause an unintended tax status reversal</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail>\n\t\t\t\t\t\t<a class="underline" href="" ng-click="viewReversedHmrcTaxUpdates()">\n\t\t\t\t\t\t\tReview updates\n\t\t\t\t\t\t</a>&nbsp;to make adjustments before running payroll\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- National Minimum Wage -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-wallet" ng-if="::payPeriodCounts.NumberOfTeamMembersBelowNMW > 0" theme="is-tertiary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersBelowNMW" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">below the National Minimum Wage and National Living Wage.</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Team members advancing payrolls -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-add-user" ng-if="::payPeriodCounts.NumberOfTeamMembersAdvancingPeriods > 0" theme="is-tertiary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersAdvancingPeriods" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened"> will be advanced.</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail>\n\t\t\t\t\t\t<a class="is-tertiary is-underline" ui-sref="team.members({agencyProfileId: formOptions.company.AgencyProfileID, \'applyfilter\': \'is-advancing-future-periods\'})">\n\t\t\t\t\t\t\tClick here\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tto review them.\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Incomplete Team Members -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-setup-user" ng-if="::payPeriodCounts.NumberOfIncompleteTeamMembers > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfIncompleteTeamMembers" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">{{::payPeriodCounts.NumberOfIncompleteTeamMembers === 1 ? \'is\' : \'are\'}} incomplete</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail ng-if="::$root.currentUser.Permissions.isTeamVisible">\n\t\t\t\t\t\t<a class="is-primary is-underline" href="" ui-sref="team.members({agencyProfileId: formOptions.company.AgencyProfileID, presetfilterkey: PRESET_FILTER_KEYS.team.incompleteProfiles})">\n\t\t\t\t\t\t\tComplete their\n\t\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfIncompleteTeamMembers" when="{\'1\': \'profile\', \'other\': \'profiles\'}"></ng-pluralize>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tif you wish to include them in payroll\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Team Members without emails -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-email" ng-if="::payPeriodCounts.NumberOfTeamMembersWithoutEmails > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title ng-if="::payPeriodCounts.NumberOfTeamMembersWithoutEmails > 1">\n\t\t\t\t\t\t{{payPeriodCounts.NumberOfTeamMembersWithoutEmails}} team members\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">don\'t have email addresses</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-title ng-if="::payPeriodCounts.NumberOfTeamMembersWithoutEmails === 1">\n\t\t\t\t\t\t1 team member\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">doesn\'t have an email address</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail>Payslips will be available when the period is approved, should you wish to send any by post.</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Team Members missing bank details -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-bank" ng-if="::payPeriodCounts.NumberOfTeamMembersMissingBankDetails > 0" theme="is-primary">\n\t\t\t\t\t<pacb-title>\n\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersMissingBankDetails" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\t\t<span class="is-medium is-greyscale-darkened">{{::payPeriodCounts.NumberOfTeamMembersMissingBankDetails === 1 ? \'is\' : \'are\'}} missing bank details</span>\n\t\t\t\t\t</pacb-title>\n\t\t\t\t\t<pacb-detail>\n\t\t\t\t\t\t<a class="underline is-primary" href="" ng-click="openBacsSettingsForm()">\n\t\t\t\t\t\t\tAdd bank details for\n\t\t\t\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersMissingBankDetails" when="{\'1\': \'this team member\', \'other\': \'these team members\'}"></ng-pluralize>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\tto include them in your BACS file, or make manual payments.\n\t\t\t\t\t</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t\t<!-- Workflow -->\n\t\t\t\t<payroll-alert-card-basic icon="icon-workflow-alt" ng-if="::formOptions.company.IsWorkflowActive" theme="is-primary">\n\t\t\t\t\t<pacb-title>The current workflow cycle will be completed</pacb-title>\n\t\t\t\t\t<pacb-detail>Once payroll has been run successfully, the first collaborator for the next workflow cycle will be notified</pacb-detail>\n\t\t\t\t</payroll-alert-card-basic>\n\n\t\t\t</section>\n\n\t\t\t<!-- Has team members -->\n\t\t\t<fieldset ng-if="payPeriodCounts.NumberOfCompleteTeamMembers > 0">\n\n\t\t\t\t<!-- Non-rollback period -->\n\t\t\t\t<fieldset ng-if="!currentPayPeriod.IsRollback">\n\n\t\t\t\t\t<!-- PayslipDateISO - Date to send payslips. Not relevant if PayDashboard is enabled -->\n\t\t\t\t\t<section class="form-section with-separator fadeIn" ng-if="!company.IsPayDashboardEnabled" ng-switch="currentPayPeriod.payslipDateOption">\n\t\t\t\t\t\t<h6 class="form-section-subheading">When would you like to let employees know they\'ve been paid?</h6>\n\n\t\t\t\t\t\t<div ng-if="currentPayPeriod.CanSchedulePayslips">\n\t\t\t\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payslipDateOption === PAYSLIP_DATE_OPTIONS.notificationDate}" ng-click="changePayslipDate(currentPayPeriod, PAYSLIP_DATE_OPTIONS.notificationDate)">\n\t\t\t\t\t\t\t\t\t{{currentPayPeriod.PayslipDisplayDateISO | dateformat}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payslipDateOption === PAYSLIP_DATE_OPTIONS.now}" ng-click="changePayslipDate(currentPayPeriod, PAYSLIP_DATE_OPTIONS.now)">\n\t\t\t\t\t\t\t\t\tRight away\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payslipDateOption === PAYSLIP_DATE_OPTIONS.custom}" ng-click="changePayslipDate(currentPayPeriod, PAYSLIP_DATE_OPTIONS.custom)">\n\t\t\t\t\t\t\t\t\tChoose a day\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<p class="s fadeIn">\n\t\t\t\t\t\t\t<!-- Notification date -->\n\t\t\t\t\t\t\t<span ng-switch-when="notification-date">\n\t\t\t\t\t\t\t\t<span ng-if="currentPayPeriod.PayslipDateISO < currentDate">Employees will be notified immediately.</span>\n\t\t\t\t\t\t\t\t<span ng-if="currentPayPeriod.PayslipDateISO >= currentDate">Employees will be notified on {{currentPayPeriod.PayslipDisplayDateISO | dateformat:\'long\'}} at {{$root.CONFIG.scheduledTimePayslips}}.</span>\n\t\t\t\t\t\t\t\t<span ng-if="!currentPayPeriod.CanSchedulePayslips">&nbsp;The payslip date cannot be changed as the Payday has passed.</span>\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<!-- Right away -->\n\t\t\t\t\t\t\t<span ng-switch-when="now">Employees will be notified as soon as payroll is complete.</span>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Custom -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-switch-when="custom">\n\n\t\t\t\t\t\t\t<!-- Choose a date -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<label class="required" for="payslipSendDate">Choose a date:</label>\n\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t<date-input-field field-style="l-alt" field-id="payslipSendDate" field-min-date-iso="currentPayPeriod.payslipDateISOMin" field-value-iso="currentPayPeriod.PayslipDateISO">\n\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="runPayrollForm.payslipSendDate.$touched" ng-messages="runPayrollForm.payslipSendDate.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a date to send employees email notifications</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date after {{currentPayPeriod.payslipDateISOMin | dateformat}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">Payslips will be sent at {{$root.CONFIG.scheduledTimePayslips}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- BACS Date - Date to make payments -->\n\t\t\t\t\t<section class="form-section with-separator fadeIn" ng-if="companyBankDetails.BACSEnabled" ng-switch="currentPayPeriod.bacsDateOption">\n\t\t\t\t\t\t<h6 class="form-section-subheading">When would you like payments to be made to team members?</h6>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.option1}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.option1)">\n\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[BACS_DATE_OPTIONS.option1] | dateformat}}\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.option2}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.option2)">\n\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[BACS_DATE_OPTIONS.option2] | dateformat}}\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.custom}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.custom)">\n\t\t\t\t\t\t\t\t\t\tChoose a day\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message">Once you\u2019ve approved payroll, you can download your BACS file and upload to your bank account to pay your team members.</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Custom date -->\n\t\t\t\t\t\t<div class="form-field fadeIn" pc-switch-when="BACS_DATE_OPTIONS.custom">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="bacsDate">\n\t\t\t\t\t\t\t\t\tChoose a date:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-style="l-alt" field-id="bacsDate" field-min-date-iso="currentPayPeriod.bacsDateISOMin" field-value-iso="currentPayPeriod.BACSDateISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="runPayrollForm.bacsDate.$touched" ng-messages="runPayrollForm.bacsDate.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a you would like payments to be made to team members</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">This can be no earlier than today</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- FPS late reasons -->\n\t\t\t\t\t<section class="form-section with-separator fadeIn" ng-if="lateReasons">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="fpsLateReason">Select a reason for submitting your FPS late</label>\n\t\t\t\t\t\t\t\t<p>As pay day has passed your FPS will be submitted with the late reason selected below</p>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<select class="block" id="fpsLateReason" name="fpsLateReason" ng-model="currentPayPeriod.lateReasonCode" ng-options="lateReason.Code as (lateReason.Code + \' - \' + lateReason.Description) for lateReason in lateReasons">\n\t\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\t\tPlease select...\n\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</section>\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Rollback period -->\n\t\t\t\t<section class="form-section with-separator" ng-if="currentPayPeriod.IsRollback">\n\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tEdit the \u2018Pay date\u2019 to change the pay date on your FPS.\n\t\t\t\t\t\t\t<span ng-if="companyBankDetails.BACSEnabled">If you wish to change the payment date in your BACS file edit \u2018Payments to team\u2019. </span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- PayDateISO -->\n\t\t\t\t\t<section class="form-section">\n\t\t\t\t\t\t<form-accordion icon="icon-calendar" on-toggle="onPayDateContentToggle(currentPayPeriod)" show-content="currentPayPeriod.showPayDateOptions">\n\t\t\t\t\t\t\t<fa-title>\n\t\t\t\t\t\t\t\t<h6 class="fadeIn is-medium" ng-if="!currentPayPeriod.showPayDateOptions">\n\t\t\t\t\t\t\t\t\t<span class="stronger">Pay date:</span> {{currentPayPeriod.PayDateISO | dateformat:\'custom\':\'dddd D MMM[,] YYYY [at] h:mma\'}}\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<h6 class="fadeIn" ng-if="currentPayPeriod.showPayDateOptions">\n\t\t\t\t\t\t\t\t\tChange pay date\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</fa-title>\n\n\t\t\t\t\t\t\t<fa-content>\n\t\t\t\t\t\t\t\t<h6 class="form-section-subheading">What would you like the new pay date to be?</h6>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payDateOption === PAY_DATE_OPTIONS.option1}" ng-click="changePayDateOption(currentPayPeriod, PAY_DATE_OPTIONS.option1)">\n\t\t\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[PAY_DATE_OPTIONS.option1] | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payDateOption === PAY_DATE_OPTIONS.option2}" ng-click="changePayDateOption(currentPayPeriod, PAY_DATE_OPTIONS.option2)">\n\t\t\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[PAY_DATE_OPTIONS.option2] | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.payDateOption === PAY_DATE_OPTIONS.custom}" ng-click="changePayDateOption(currentPayPeriod, PAY_DATE_OPTIONS.custom)">\n\t\t\t\t\t\t\t\t\t\t\t\tChoose a day\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Custom -->\n\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="currentPayPeriod.payDateOption === PAY_DATE_OPTIONS.custom">\n\t\t\t\t\t\t\t\t\t<label class="required" for="payDate">\n\t\t\t\t\t\t\t\t\t\tPay date:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-style="l-alt" field-id="payDate" field-min-date-iso="currentPayPeriod.TaxPeriodStartDateISO" field-max-date-iso="currentPayPeriod.TaxPeriodEndDateISO" field-value-iso="currentPayPeriod.PayDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="runPayrollForm.payDate.$error" ng-messages="runPayrollForm.payDate.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a new pay date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{::currentPayPeriod.TaxPeriodStartDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{::currentPayPeriod.TaxPeriodEndDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-message">The pay date should be on or before {{::currentPayPeriod.TaxPeriodEndDateISO | dateformat:\'dayMonthYear\'}}</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fa-content>\n\t\t\t\t\t\t</form-accordion>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- BACS Date - Date to make payments -->\n\t\t\t\t\t<section class="form-section with-separator" ng-switch="currentPayPeriod.bacsDateOption">\n\t\t\t\t\t\t<form-accordion icon="icon-calendar" ng-if="companyBankDetails.BACSEnabled" on-toggle="onBacsDateContentToggle(currentPayPeriod)" show-content="currentPayPeriod.showBacsDateOptions">\n\t\t\t\t\t\t\t<fa-title>\n\t\t\t\t\t\t\t\t<h6 ng-if="!currentPayPeriod.showBacsDateOptions" class="fadeIn is-medium">\n\t\t\t\t\t\t\t\t\t<span class="stronger">Payments to team: </span> {{currentPayPeriod.BACSDateISO | dateformat:\'custom\':\'dddd D MMM[,] YYYY [at] h:mma\'}}\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t\t<h6 ng-if="currentPayPeriod.showBacsDateOptions" class="fadeIn">\n\t\t\t\t\t\t\t\t\tChange pay date\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</fa-title>\n\n\t\t\t\t\t\t\t<fa-content>\n\t\t\t\t\t\t\t\t<h6 class="form-section-subheading">When would you like payments to be made to team members?</h6>\n\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.option1}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.option1)">\n\t\t\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[BACS_DATE_OPTIONS.option1] | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.option2}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.option2)">\n\t\t\t\t\t\t\t\t\t\t\t\t{{currentPayPeriod[BACS_DATE_OPTIONS.option2] | dateformat}}\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a class="option-tab" href="" ng-class="{active: currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.custom}" ng-click="changeBacsDateOption(currentPayPeriod, BACS_DATE_OPTIONS.custom)">\n\t\t\t\t\t\t\t\t\t\t\t\tChoose a day\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-message">Once you\u2019ve approved payroll, you can download your BACS file and upload to your bank account to pay your team members.</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Custom date -->\n\t\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="currentPayPeriod.bacsDateOption === BACS_DATE_OPTIONS.custom">\n\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="bacsDate">\n\t\t\t\t\t\t\t\t\t\t\tChoose a date:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-style="l-alt" field-id="bacsDate" field-min-date-iso="currentPayPeriod.bacsDateISOMin" field-value-iso="currentPayPeriod.BACSDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="runPayrollForm.bacsDate.$touched" ng-messages="runPayrollForm.bacsDate.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a you would like payments to be made to team members</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">This can be no earlier than today</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</fa-content>\n\t\t\t\t\t\t</form-accordion>\n\t\t\t\t\t</section>\n\t\t\t\t</section>\n\n\t\t\t</fieldset>\n\n\t\t\t<!-- No team members -->\n\t\t\t<section ng-if="payPeriodCounts.NumberOfCompleteTeamMembers === 0">\n\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tWhen you run a &lsquo;nil&rsquo; payroll, Paycircle sends a submission to HMRC to let them know that\n\t\t\t\t\t\tyour scheme is still active but that you have no team members to pay this period.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.runningNilPayroll" underline="true"></support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Back -->\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\n\t\t\t<!-- Run payroll -->\n\t\t\t<span tooltip-demo td-id="{{$root.DEMO_TASKS.approvePayroll.checkPayroll}}" class="primary-action">\n\t\t\t\t<submit-button disable-button="(currentPayPeriod.runPayrollStep === RUN_PAYROLL_STEPS.advancePayrollsConfirmation && !currentPayPeriod.confirmAdvancingPeriods)\n\t\t\t\t\t\t|| !runPayrollForm.$valid" display-text="currentPayPeriod.hasAdvancingTeamMembers && currentPayPeriod.runPayrollStep !== RUN_PAYROLL_STEPS.advancePayrollsConfirmation\n\t\t\t\t\t\t\t? \'Next\' : formOptions.company.PensionOnly ? \'Run period\' : \'Run payroll\'" state="runPayrollForm.state"></submit-button>\n\t\t\t</span>\n\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Running -->\n\t<section class="form-summary fadeIn" pc-switch-when="[SUBMISSION_STATES.submitting, SUBMISSION_STATES.requesting]">\n\t\t<loading-block size="m">\n\t\t\t<lb-description>Running {{formOptions.company.PensionOnly ? \'period\' : \'payroll\'}}...</lb-description>\n\t\t</loading-block>\n\t\t<section class="form-summary-section align-center">\n\t\t\t<p class="s">You don\'t have to wait for this to finish running. It will update as soon as it\'s complete.</p>\n\t\t\t<p>\n\t\t\t\t<a class="link-with-icon" href="" ng-click="formOptions.closeForm()">\n\t\t\t\t\tOk, close this window\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</section>\n\t</section>\n\n\t<!-- Success -->\n\t<section class="form-summary fadeIn" pc-switch-when="SUBMISSION_STATES.submitted">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-tick xxl positive"></i>\n\t\t\t<h4>All done</h4>\n\t\t</header>\n\t\t<p class="s">This period has run successfully.</p>\n\t\t<p>\n\t\t\t<a class="link-with-icon" href="" ng-click="formOptions.closeForm()">\n\t\t\t\tOk, close this window\n\t\t\t</a>\n\t\t</p>\n\t</section>\n\n\t<!-- Failed -->\n\t<section class="form-summary fadeIn" pc-switch-when="SUBMISSION_STATES.failed">\n\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Payroll submission failed">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">Your payroll submission has failed. Close this window to review any issues and click the \u2018Reset payroll\u2019 button to try again. </p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t</section>\n</section>\n\n<!-- Payroll run in close succession -->\n<form-state class="no-margin" form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure?" ng-if="pageState === FORM_STATES.outsideTimePeriod">\n\t<fs-preheader>\n\t\t<section class="form-section">\n\t\t\t<div class="spacer l"></div>\n\t\t\t<div class="info-block align-center tertiary">\n\t\t\t\t<p class="tertiary-light">You\'re about to approve payroll for the period</p>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<h4 class="strong">{{currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<p class="s tertiary" data-cy="close-succession-message">\n\t\t\t\t\t<i class="icon-warning m"></i>&nbsp;Running in close succession\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</section>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="s">You have recently approved a payroll, are you sure you want to approve another period so soon?</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<a class="button tertiary primary-action" data-page-state="outside-time-period" href="" id="button-primary" ng-click="pollForPayrollState(currentPayPeriod)">\n\t\t\tContinue\n\t\t</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Advance team members confirmation -->\n<form-state class="no-margin" form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="is-tertiary" fs-title="Are you sure you wish to advance team members?" ng-if="currentPayPeriod.runPayrollStep === RUN_PAYROLL_STEPS.advancePayrollsConfirmation">\n\t<fs-main>\n\t\t<div class="form-section">\n\t\t\t<p class="s">\n\t\t\t\t<ng-pluralize count="payPeriodCounts.NumberOfTeamMembersAdvancingPeriods" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\twill be advanced and they won\'t appear on payroll again until those advanced periods have been run.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<note note-dismiss="false" note-icon="icon-warning" note-theme="tertiary" note-title="Making corrections">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\tOnce you\u2019ve run payroll this cannot be undone and pay periods that contain advanced team members cannot be rolled back.\n\t\t\t\t\t\t\t\tAny corrections will need to be made manually once the team member returns to payroll.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input checkbox id="confirmAdvancingPeriods" label-text="\'I understand\'" label-text-class="s" name="confirmAdvancingPeriods" ng-model="currentPayPeriod.confirmAdvancingPeriods" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t\t<div class="form-section">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Turn on threshold postponement for AE pensions">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tYou may wish to turn on threshold postponement for your AE pensions if you\'re advancing periods for team members so they\'re not\n\t\t\t\t\t\tincorrectly assessed when they receive additional pay for those periods.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Unauthorised pension scheme -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unauthorised pension scheme" ng-if="pageState === FORM_STATES.pensionUnauthorized">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as one or more pension schemes are unauthorised. You will need to authorise the schemes or switch the pensions to manual in order to run payroll.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Failed pension submission -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Failed pension submission" ng-if="pageState === FORM_STATES.pensionSubmissionFailure">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as one or more pension submissions have failed to submit to the providers. You will need to resolve the failures or mark the pensions as manually submitted in order to run payroll.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Future PAYE scheme cease date -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Future PAYE scheme cease date" ng-if="pageState === FORM_STATES.payeCessationDateInFuture">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as the PAYE scheme for {{formOptions.company.Name}} is set to cease in the future. You will be able to run payroll on or after the cease date. Alternatively, you may want to update the PAYE scheme cease date or cancel the closure.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Pending pension submission -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pending pension submission" ng-if="pageState === FORM_STATES.pensionSubmissionPending">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as one or more pension submissions are still pending. You will be able to run payroll once the submissions have finalised.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Pension scheme not active -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pension scheme not active" ng-if="pageState === FORM_STATES.pensionNotActive">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as one or more pension schemes are not active with the provider. You will need to make the schemes active, connect to schemes that are active, or switch the pensions to manual in order to run payroll.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Missing pension information -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Missing pension information" ng-if="pageState === FORM_STATES.retrospectivePensionIncomplete">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run as one or more team members are missing pension information. You will need to complete the team member profiles in order to run payroll.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Generic form 1 -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to run payroll" ng-if="pageState === FORM_STATES.unableToRunPayroll">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run at this time.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Generic form 2 (catch-all default) -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to run payroll" ng-if="pageState === FORM_STATES.unableToRunPayrollDefault">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can\'t be run at this time. If the problem persists, please contact support.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Outside date range -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pay period is outside date range" ng-if="pageState === FORM_STATES.outsideDateRange">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll can only be ran within a certain time period of your payment date. Please\n\t\t\t\tcontact support\n\t\t\tfor more information.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - Report generation failed -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Payroll could not be calculated" ng-if="pageState === FORM_STATES.reportGenerationFailed">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThere was a problem calculating your payroll. Please\n\t\t\t\tcontact support\n\t\t\tfor more information.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - PAYE scheme closed -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to run payroll" ng-if="pageState === FORM_STATES.payeSchemeClosed">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll cannot be run currently as the PAYE scheme for {{formOptions.company.Name}} has been closed. If this appears incorrect, please\n\t\t\t\tcontact support\n\t\t\tfor more information.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Cannot run payroll - PAYE cessation date in past -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This PAYE scheme is set to cease" ng-if="pageState === FORM_STATES.payeCessationDateInPast">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayoll can\u2019t be run as the PAYE scheme for {{formOptions.company.Name}} has been set to cease as of\n\t\t\t{{formOptions.company.PAYECeaseDateISO | dateformat}}.\n\t\t\tPlease note that the cessation date will be automatically submitted to HMRC by the system.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Cannot run payroll - Demo incomplete (tasks outstanding) -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="You haven\u2019t completed your tasks" ng-if="pageState === FORM_STATES.demoIncomplete">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t<a class="underline" ui-sref="company-dashboard({agencyProfileId})">\n\t\t\t\tGo to your dashboard\n\t\t\t</a>\n\t\t\tto review your progress and continue with your tasks.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Cannot run payroll - User is unauthorised -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="You don\'t have permission to run payroll" ng-if="pageState === FORM_STATES.userUnauthorised">\n\t<fs-main>\n\t\t<p class="is-small">If you need to run payroll, please contact your payroll administrator.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary" fs-title="Before your first live pay run" ng-if="pageState === FORM_STATES.firstPayRun">\n\t<fs-main>\n\t\t<section class="form-state-section">\n\t\t\t<note note-theme="tertiary is-form-field">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tYou\'re about to run your first live payroll in Paycircle. Before proceeding, there are a number of manual tasks that you need to action. Please ensure that:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Your pay period dates align with your last Full Payment Submission (FPS) sent to HMRC, or are as you would expect if you have decided to change your pay periods\',\n\t\t\t\t\t\t\t\t\'Your employee RTI IDs (e.g. NI numbers, HMRC Submission ID) have been entered correctly and match those previously submitted to HMRC\',\n\t\t\t\t\t\t\t\t\'Your HMRC PAYE and Accounts Office references have been entered correctly\'\n\t\t\t\t\t\t\t]" bl-theme="is-small is-italicised is-tertiary is-spaced-out"></bullet-list>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t<span class="note-warning">Important:</span>\n\t\t\t\t\t\t\tMistakes here could cause duplicate records or submission errors with HMRC.\n\t\t\t\t\t\t\tTake a moment to review these settings before finalising your payroll.\n\t\t\t\t\t\t\tYou will not be able to correct pay periods in a rollback.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<input id="confirmFirstPayRun" label-text="\'I understand the risks and take responsibility\'" name="confirmFirstPayRun" ng-model="formOptions.confirmFirstPayRun" type="checkbox" checkbox required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</section>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="primary-action tertiary" type="button" ng-disabled="!formOptions.confirmFirstPayRun" ng-click="continueFirstPayRun()">\n\t\t\tRun payroll\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Cannot run payroll - Has Payroll Errors -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="{{payrollAlertCounts.ErrorCount}} {{payrollAlertCounts.ErrorCount > 1 ? \'errors need\' : \'error needs\'}} fixing" ng-if="pageState === FORM_STATES.hasPayrollErrors">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou can\u2019t run payroll for {{formOptions.company.Name}} until the outstanding\n\t\t\t\t<ng-pluralize count="payrollAlertCounts.ErrorCount" when="{\'1\': \'error has\', \'other\': \'errors have\'}"></ng-pluralize>\n\t\t\t\tbeen fixed. Click \u2018Cancel\u2019 to go back and review\n\t\t\t\t<ng-pluralize count="payrollAlertCounts.ErrorCount" when="{\'1\': \'it\', \'other\': \'them\'}"></ng-pluralize>\n\t\t\t\tin your Alerts.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-state-section" ng-if="formOptions.company.HasAutoPension">\n\t\t\t<h6>Need to get payroll approved now?</h6>\n\t\t\t<p class="s">\n\t\t\t\tIf you\'re in a hurry to get your payroll approved, you may choose to submit your pension file manually while you wait for your scheme to become &lsquo;Active&rsquo;.\n\t\t\t\tYou can do this by disconnecting your automated pension submissions in your &lsquo;Pension settings&rsquo;.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\t<a class="underline" ui-sref="pensions.summary({agencyProfileId: agencyProfileId})">\n\t\t\t\t\tView pensions\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Cannot run payroll - Rotaready Critical Errors -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Critical Rotaready alerts need dismissing" ng-if="pageState === FORM_STATES.rotareadyCriticalErrors">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">\n\t\t\t\tYou can\'t run payroll for {{formOptions.company.Name}} because there are critical alerts that need to be dismissed in your \'Rotaready updates\' area.\n\t\t\t</p>\n\t\t\t<p class="s">\n\t\t\t\t<a class="underline" ui-sref="team.rotaready-updates({agencyProfileId})">\n\t\t\t\t\tGo to Rotaready updates\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<form-state fs-show-close="false" ng-if="[\n\t\tFORM_STATES.payslipsGenerating,\n\t\tFORM_STATES.reportsGenerating\n\t].includes(pageState)\n\t">\n\t<fs-main>\n\t\t<loading-block size="m"></loading-block>\n\t\t<div class="form-summary align-center">\n\t\t\t<div class="form-summary-section">\n\t\t\t\t<h4>Generating {{pageState === FORM_STATES.payslipsGenerating ? \'payslips\' : \'reports\'}}</h4>\n\t\t\t</div>\n\t\t\t<section class="form-summary-section">\n\t\t\t\t<p class="s">\n\t\t\t\t\tOnce your {{pageState === FORM_STATES.payslipsGenerating ? \'payslips\' : \'reports\'}} have finished generating you\u2019ll be able to run payroll.\n\t\t\t\t\tClick \u2018Cancel\u2019 to close this window and try again shortly.\n\t\t\t\t</p>\n\t\t\t</section>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === FORM_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/runPayrollBulk/runPayrollBulkForm.html','<!-- Loading -->\n<form-state form-options="formOptions" fs-show-close="false" ng-if="pageState === \'loading\'">\n\n\t<fs-preheader>\n\t\t<loading-block size="m"></loading-block>\n\t</fs-preheader>\n\n\t<fs-main>\n\t\t<section class="form-state-section">\n\t\t\t<p class="s align-center">We\u2019re calculating payroll and checking for payroll alerts. Depending on the size of the companies you\u2019ve selected, this may take a few minutes. Please don\u2019t close your browser until this has finished.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.bulkPayrollRun" underline="true">Read more about bulk running payroll</support-article-link></p>\n\t\t</section>\n\n\t\t<section class="form-state-section">\n\t\t\t<p class="s stronger align-center greyscale-dark">\n\t\t\t\tChecking {{vm.companiesChecked+1}} of {{formOptions.agencyProfilesIdArray.length}} companies\n\t\t\t</p>\n\t\t</section>\n\n\t\t<section class="form-state-section">\n\t\t\t<progress-bar pb-percentage="(vm.companiesChecked/formOptions.agencyProfilesIdArray.length) * 100" pb-theme="is-primary is-base-greyscale-lighter"></progress-bar>\n\t\t</section>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="cancelBulkPayrollSetup(vm)">Cancel</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Unsubmitted -->\n<form name="confirmBulkRunPayrollForm" class="fadeIn" ng-submit="setPageState(\'confirm\')" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="info-block primary bulk-processing-list" ng-if="vm.companiesThatCanRun.length > 0">\n\t\t<p class="bulk-processing-list-leading-text">You\u2019re about to process <br><strong>{{vm.companiesThatCanRun.length}}&nbsp;<ng-pluralize count="vm.companiesThatCanRun.length" when="{\'1\': \'company\', \'other\': \'companies\'}"></ng-pluralize></strong></p>\n\n\t\t<ul>\n\t\t\t<li ng-repeat="company in vm.companiesThatCanRun | limitTo: vm.companyListLimit" class="bulk-processing-list-item primary">\n\t\t\t\t<i class="icon-company bulk-processing-list-item-icon"></i>\n\t\t\t\t<div class="bulk-processing-list-item-name">{{company.Company.Name}}</div>\n\t\t\t\t<div class="bulk-processing-list-item-period">{{company.PayPeriod.PayPeriodDisplay}}</div>\n\t\t\t\t<span class="bulk-processing-list-item-tag tag primary inverse" ng-if="company.Company.TeamMemberCount === 0">Nil</span>\n\t\t\t</li>\n\n\t\t\t<button type="button" class="button clear bulk-processing-show-more" ng-click="toggleShowMore(vm)" ng-if="vm.companiesThatCanRun.length > 5"><i class="icon-chevron-down" ng-if="vm.companyListLimit === 5"></i><i class="icon-chevron-up" ng-if="vm.companyListLimit !== 5"></i> Show {{vm.companyListLimit === 5 ? \'all\' : \'less\'}} companies</button>\n\t\t</ul>\n\t</div>\n\n\t<div class="info-block tertiary bulk-processing-list" ng-if="vm.companiesWithErrors.length > 0">\n\t\t<p class="bulk-processing-list-accordion-header">\n\t\t\t<strong>{{vm.companiesWithErrors.length}}&nbsp;<ng-pluralize count="vm.companiesWithErrors.length" when="{\'1\': \'company\', \'other\': \'companies\'}"></ng-pluralize></strong> can\'t be run and will be ignored\n\n\t\t\t<a href="" ng-click="toggleErrors(vm)" class="assertive bulk-processing-list-accordion-control">{{vm.showCompanyErrors ? \'Less\' : \'More\'}} info <i ng-class="{\'icon-chevron-down\': !vm.showCompanyErrors, \'icon-chevron-up\': vm.showCompanyErrors}"></i></a>\n\t\t</p>\n\n\t\t<ul ng-if="vm.showCompanyErrors">\n\t\t\t<li ng-repeat="company in vm.companiesWithErrors" class="bulk-processing-list-item tertiary">\n\t\t\t\t<i class="bulk-processing-list-item-icon icon-warning"></i>\n\n\t\t\t\t<div class="bulk-processing-list-item-name">{{company.Company.Name}}</div>\n\n\t\t\t\t<div class="bulk-processing-list-item-error tertiary" ng-if="!company.Company.IsPayslipManagerActive">\n\t\t\t\t\t<ng-pluralize count="company.errorCount" when="{\'1\': \'1 error alert\', \'other\': \'{} error alerts\'}"></ng-pluralize>&nbsp;need fixing before running payroll. <a href="" ng-click="goToCurrentPeriodAlertsForCompany(company)" class="tertiary underline">Go to company</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="bulk-processing-list-item-error tertiary" ng-if="company.Company.IsPayslipManagerActive">\n\t\t\t\t\tCompany is a payslip-only company\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="\'Continue\'" state="confirmBulkRunPayrollForm.state" disable-button="vm.companiesThatCanRun.length < 1"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- Confirm -->\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" ng-if="pageState === \'confirm\'" fs-show-close="false">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">You\u2019re about to process&nbsp;<ng-pluralize count="vm.companiesThatCanRun.length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize>. Click \u2018Run\u2019 if you\u2019re happy to continue.</p>\n\t\t\t<p class="s">Processing these companies will:</p>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<ul class="check-list primary">\n\t\t\t\t<li class="check-list-item s">Submit files to HMRC for all PAYE schemes</li>\n\t\t\t\t<li class="check-list-item s">Submit files to HMRC for all CIS schemes</li>\n\t\t\t\t<li class="check-list-item s">Submit files to pension providers for all connected workplace pension schemes</li>\n\t\t\t</ul>\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">Pay notifications for PAYE and CIS scheme team members will be sent on the dates specified by each company in their respective Company settings</p>\n\t\t\t<p class="s">This will run payroll for <strong><ng-pluralize count="vm.companiesThatCanRun.length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize></strong>. Are you sure you want to continue?</p>\n\t\t</div>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<a href="" class="button primary-action tertiary" ng-click="bulkRunPayroll(vm)">Run</a>\n\t</fs-actions>\n</form-state>\n\n<!-- Running -->\n<loading-block ng-if="pageState === \'running\'"></loading-block>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="clock" fs-title="Payroll has started" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Payroll is underway for <strong><ng-pluralize count="vm.companiesThatCanRun.length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize></strong>. Each company\'s payroll can take a few minutes to run depending on the size of the company. You can keep track of them back on the Companies page.</p>\n\t</fs-main>\n\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/salary-change/salary-change.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" ng-if="$ctrl.pageState === \'ready\'">\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tIf you need to edit the salary change that\u2019s been saved,\n\t\t\t<span ng-if="$ctrl.formOptions.hideProfileLink">\n\t\t\t\tgo to {{$ctrl.formOptions.context.Forename}}\u2019s profile\n\t\t\t</span>\n\t\t\t<span ng-if="!$ctrl.formOptions.hideProfileLink">\n\t\t\t\t<a class="underline" ui-sref="team.profile.overview({\n\t\t\t\t\t\tagencyProfileId: $ctrl.formOptions.agencyProfileId,\n\t\t\t\t\t\tuserId: $ctrl.formOptions.context.UserID\n\t\t\t\t\t})">\n\t\t\t\t\tgo to {{$ctrl.formOptions.context.Forename}}\u2019s profile\n\t\t\t\t</a>\n\t\t\t</span>\n\t\t\tto edit {{$ctrl.formOptions.context.Gender | personalise:\'his\'}} pay information.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Current salary -->\n\t\t<div class="form-field-highlight primary">\n\t\t\t<h6>Current salary:</h6>\n\t\t\t<p>\n\t\t\t\t<span class="primary-dark stronger">{{$ctrl.currentSalary.SalaryYearly | monetise : null : null : { HIDE_CURRENCY_LABEL: true } }}</span>\n\t\t\t\t<span class="primary-light s" ng-if="$ctrl.currentSalary.SalaryEffectiveDateISO">\n\t\t\t\t\t(effective {{$ctrl.currentSalary.SalaryEffectiveDateISO | dateformat}})\n\t\t\t\ts</span>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="spacer l"></div>\n\n\t\t<!-- Future salary -->\n\t\t<div class="form-field-highlight tertiary">\n\t\t\t<h5>Salary change:</h5>\n\n\t\t\t<div class="spacer xs"></div>\n\t\t\t<p class="is-small">\n\t\t\t\tThe effective date set for the new annual salary below means the salary change will be applied in the {{$ctrl.futureSalary.SalaryEffectiveDateISO | dateformat:\'monthYear\'}} pay period.\n\t\t\t</p>\n\t\t\t<div class="spacer xs"></div>\n\n\t\t\t<h6>New salary:</h6>\n\t\t\t<p>\n\t\t\t\t<span class="tertiary-dark stronger">{{$ctrl.futureSalary.SalaryYearly | monetise : null : null : { HIDE_CURRENCY_LABEL: true } }}</span>\n\t\t\t\t<span class="tertiary-light s">(effective {{$ctrl.futureSalary.SalaryEffectiveDateISO | dateformat}})</span>\n\t\t\t</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button primary-action" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tClose\n\t\t</a>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/payroll/send-draft-payslips/send-draft-payslips.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="sendDraftPayslipsForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.sendDraftPayslips($ctrl, sendDraftPayslipsForm)" novalidate>\n\t\n   \t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-theme="primary" fs-title="Are you sure you wish to send draft payslips?">\n\n\t\t<fs-main>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis will send team members a draft copy of their payslip to review in their Pay Portal before payroll is finalised.\n\t\t\t\t\tIf you need to recall them, you can do so from your Smart View.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t\t<section class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' if you\'re happy to continue.\n\t\t\t\t</p>\n\t\t\t</section>\n\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button disable-button="!sendDraftPayslipsForm.$valid" display-text="\'Confirm\'" state="sendDraftPayslipsForm.state"></submit-button>\n\t\t\t\n\t\t</fs-actions>\n\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/sendNotifications/send-notifications.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<div ng-if="$ctrl.componentState === \'ready\'" ng-switch="$ctrl.formOptions.payPeriod.PayslipManagerState">\n\n\t<!-- Notifications not sent -->\n\t<form pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.notificationsNotSent" name="sendNotificationsForm" ng-submit="$ctrl.payrollMailPayslips($ctrl, sendNotificationsForm)" class="fadeIn" novalidate>\n\n\t\t<div class="form-section">\n\t\t\t<note note-title="Notifying your team" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">Please note that you can only send notifications once per period.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-section larger-margin">\n\t\t\t<section class="form-section">\n\t\t\t\t<div class="info-block align-center indifferent">\n\t\t\t\t\t<p>Notifications will be sent for</p>\n\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t<h4 class="strong">{{$ctrl.formOptions.payPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<section class="form-section">\n\t\t\t<div class="payroll-alert-card is-primary is-basic">\n\t\t\t\t<div class="payroll-alert-card_layout">\n\t\t\t\t\t<div class="payroll-alert-card_icon"><icon-dot icon="icon-payslip"></icon-dot></div>\n\t\t\t\t\t<div class="payroll-alert-card_content">\n\t\t\t\t\t\t<h6 class="payroll-alert-card_title"><ng-pluralize count="$ctrl.formOptions.payPeriod.PayslipManagerCount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize></h6>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Send\'" state="sendNotificationsForm.state" disable-button="!sendNotificationsForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Notifications already sent -->\n\t<div pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.notificationsSent">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Notifications have already been sent for {{$ctrl.formOptions.payPeriod.PayPeriodDisplay}}">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">You can only send notifications once per period.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Awaiting Upload -->\n\t<div pc-switch-when="$ctrl.PAYSLIP_MANAGER_STATE.awaitingUpload">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Notifications can\u2019t be sent for {{$ctrl.formOptions.payPeriod.PayPeriodDisplay}}">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">You haven\'t imported your data for this period yet</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n</div>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/sickPay/sickPayForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === PAGE_STATES.ready" ng-switch="vm.sicknessPay.step">\n\t<!-- Calculate -->\n\t<form class="fadeIn" name="sickPayFormStepCalculate" ng-submit="getSicknessSalaryPayments(vm, vm.sicknessPay, sickPayFormStepCalculate)" pc-switch-when="SICKNESS_PAY_STEPS.calculate" novalidate>\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tDepending on your company policy for sick pay, you may have received a sick note, signed by a doctor,\n\t\t\t\tfrom {{formOptions.context.Forename}} and it may be useful to have it to hand before you begin.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Radios -->\n\t\t<fieldset>\n\n\t\t\t<!-- Sickness Type -->\n\t \t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sicknessTypeStandard" class="required">Which type of sick pay do you wish to add?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="sicknessTypeStandard" name="radioCards" ng-change="getTeamMemberSicknessDates(vm.sicknessPay)" ng-model="vm.sicknessPay.SicknessType" ng-value="SICK_PAY_TYPES.standard" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="sicknessTypeStandard">\n\t\t\t\t\t\t\t\t<i class="icon-sick radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Standard</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="sicknessTypeCovid" name="radioCards" ng-change="getTeamMemberSicknessDates(vm.sicknessPay)" ng-model="vm.sicknessPay.SicknessType" ng-value="SICK_PAY_TYPES.covid19" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="sicknessTypeCovid">\n\t\t\t\t\t\t\t\t<i class="icon-virus radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Covid 19</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t<p class="form-message is-greyscale">\n\t\t\t\t\t\tPlease note: those who have COVID-19 or are advised to self-isolate may have obtained an &ldquo;isolation note&rdquo; after visiting NHS 111 online and\n\t\t\t\t\t\tcompleting the online form.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Covid cessation note -->\n\t \t\t<div class="form-field fadeIn" ng-if="vm.sicknessPay.SicknessType === SICK_PAY_TYPES.covid19">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Covid-19 sick pay scheme cessation">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tHMRC ended the Covid-19 sick pay scheme as of 25 March 2022 for England, Scotland and Wales. All sickness after this date should follow standard SSP rules with the\n\t\t\t\t\t\t\texception of employees resident in Northern Ireland.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.sicknessPay.disableSicknessDates && !vm.sicknessPay.IsFromIntegration">\n\t\t\t<loading-block></loading-block>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="!vm.sicknessPay.disableSicknessDates || vm.sicknessPay.IsFromIntegration">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h6>How long will {{formOptions.context.Forename}} be on sick pay for?</h6>\n\t\t\t\t<p class="s">\n\t\t\t\t\tNormally the first day they were sick to the day they had\n\t\t\t\t\tbeen signed off until. Normal salary will apply the next working day after the end date.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-fields-from-to">\n\n\t\t\t\t<!-- Start Date -->\n\t\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="sickdate">Start date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="sickdate" field-read-only="vm.sicknessPay.IsFromIntegration" field-value-iso="vm.sicknessPay.SickDateISO" field-on-change-fn="getEndDateMaxDateIso(vm.sicknessPay)" field-on-change="sickPayStartDateChanged(vm.sicknessPay)">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="sickPayFormStepCalculate.sickdate.$error" ng-show="sickPayFormStepCalculate.sickdate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a start date</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- End Date -->\n\t\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="enddate">End date:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-id="enddate" field-read-only="vm.sicknessPay.IsFromIntegration" field-on-change-fn="sickPayEndDateChanged(vm.sicknessPay)" field-max-date-iso="vm.sicknessPay.maxEndDateIso" field-value-iso="vm.sicknessPay.EndDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="sickPayFormStepCalculate.enddate.$error" ng-show="sickPayFormStepCalculate.enddate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an end date</p>\n\t\t\t\t\t\t\t<p ng-message="max">Please enter a date on or before {{vm.sicknessPay.maxEndDateIso | dateformat}}</p>\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Disable form while checking dates -->\n\t\t\t<input id="notAllowed" name="notAllowed" ng-if="vm.sicknessPay.loadingState === \'loading\'" ng-model="vm.sicknessPay.doesNotExist" type="hidden" value="" required>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<p class="is-small">Set the working days to use when calculating {{formOptions.context.Forename}}\'s\n\t\t\t\t\t\t\tsick pay by toggling the switch below. This will\n\t\t\t\t\t\t\toverride their work pattern if they have one saved in their profile.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<toggle-input field-label="Override working days" field-model="vm.sicknessPay.UseWorkDayOverride" field-disabled="vm.disableWorkDayOverrideToggle" field-name="overrideWorkingDays"></toggle-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\t<fieldset ng-if="vm.sicknessPay.UseWorkDayOverride">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<simple-work-pattern on-update="onUpdateWorkPattern" work-pattern="vm.workPattern">\n\t\t\t\t\t\t\t\t\t</simple-work-pattern>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Updating work pattern overrides">\n\t\t\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\t\t\tOnce the first payment has been made, you won\'t be able to update this\n\t\t\t\t\t\t\t\t\t\t\toverride unless you end the schedule and add a new one.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t\t\t</note>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="!vm.sicknessPay.disableSicknessDates && vm.sicknessPay.IsHistoricSchedule">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="paidInFullTrue" class="required">Has the schedule already been paid in full?</label>\n\t\t\t\t\t<p class="is-small">As the leave end date is before the start of your current period, choose whether you wish to add an outstanding payment to payroll.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullTrue" ng-model="vm.sicknessPay.IsPaidInFull" theme="is-tight" value="true">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6>Yes</h6>\n\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<p class="is-small">You\u2019ll need to enter the payments already made for this schedule.</p>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t\t<extended-radio always-show-content="true" name="paidInFullFalse" ng-model="vm.sicknessPay.IsPaidInFull" theme="is-tight" value="false">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6>No</h6>\n\t\t\t\t\t\t</radio-label>\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<p class="is-small">The schedule will be calculated and the outstanding payment will be added to your current period and included in payroll.</p>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button disable-button="!sickPayFormStepCalculate.$valid || vm.sicknessPay.loadingState !== \'ready\'" display-text="\'Next\'" state="sickPayFormStepCalculate.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Pay Information -->\n\t<form class="fadeIn" name="sickPayFormStepEnterPaymentDetails" ng-submit="getSicknessSchedulePayments(vm, vm.sicknessPay, sickPayFormStepEnterPaymentDetails)" pc-switch-when="SICKNESS_PAY_STEPS.enterPaymentDetails" novalidate>\n\t\t<!-- Gross payments -->\n\t\t<fieldset ng-if="!vm.sicknessPay.IsHistoricSchedule || !vm.sicknessPay.IsPaidInFull">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Add gross pay amounts</h4>\n\t\t\t\t<p class="s" ng-if="!formOptions.context.IsInSetupMode">Please enter the gross amount {{formOptions.context.Forename}} was paid for each of the dates below.</p>\n\t\t\t\t<p class="s" ng-if="formOptions.context.IsInSetupMode">Please enter the gross amount {{formOptions.context.Forename}} would have been paid for each of the dates below, had they not been on Statutory Sick Pay.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in vm.sicknessPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="payment-{{$index}}" min="0" name="payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="sickPayFormStepEnterPaymentDetails[\'payment-\' + $index].$touched" ng-messages="sickPayFormStepEnterPaymentDetails[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Calculation Method -->\n\t\t<fieldset class="form-fieldset-divider-top" ng-if="!vm.sicknessPay.IsHistoricSchedule && !vm.sicknessPay.IsPaidInFull">\n\t \t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="sspScheduleCalculationMethodPeriod" class="required">Calculate the SSP schedule:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="sspScheduleCalculationMethodPeriod" name="sspScheduleCalculationMethod" ng-model="vm.sicknessPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.periodDates" type="radio">\n\t\t\t\t\t\t\t<label for="sspScheduleCalculationMethodPeriod" class="radio-row-label">On a pay period basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="sspScheduleCalculationMethodWeekly" name="sspScheduleCalculationMethod" ng-model="vm.sicknessPay.CalculationMethod" ng-value="STATUTORY_PAY_CALCULATION_METHODS.weekly" type="radio">\n\t\t\t\t\t\t\t<label for="sspScheduleCalculationMethodWeekly" class="radio-row-label">On a weekly basis</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t \t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Waiting days -->\n\t\t<fieldset ng-if="vm.sicknessPay.CanAddWaitingDays">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tIf you know how many waiting days have been used prior to this schedule, toggle the switch below.\n\t\t\t\t\t\tThis will help us calculate the correct payments for {{formOptions.context.Forename}}.\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-label="Add waiting days used" field-model="vm.sicknessPay.HasWaitingDaysBroughtForward" field-name="hasWaitingDaysBroughtForward"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="vm.sicknessPay.HasWaitingDaysBroughtForward">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<number-selector-field class="s" ng-model="vm.sicknessPay.WaitingDaysBroughtForward" step="1" min="1" max="vm.sicknessPay.WaitingDaysMax" field-name="waitingDaysBroughtForward"></number-selector-field>&nbsp;&nbsp;<ng-pluralize count="vm.sicknessPay.WaitingDaysBroughtForward" when="{\'1\': \'day\', \'other\': \'days\'}"></ng-pluralize>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Maximum of&nbsp;<ng-pluralize count="vm.sicknessPay.WaitingDaysMax" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize></p>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- In progress schedule? -->\n\t\t<fieldset class="fadeIn" ng-if="!vm.sicknessPay.IsHistoricSchedule && vm.sicknessPay.IsInProgressSchedule">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tIf this is an existing sick pay schedule, where some payments have already been made, toggle the switch below.\n\t\t\t\t\t\tThe remainder of the schedule will then be calculated.\n\t\t\t\t\t</p>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-label="Add payments already made" field-model="vm.sicknessPay.HasAmountBroughtForward" field-name="hasAmountBroughtForward"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Payments already made -->\n\t\t<fieldset ng-if="vm.sicknessPay.IsHistoricSchedule || vm.sicknessPay.HasAmountBroughtForward" ng-switch="vm.sicknessPay.AmountBroughtForwardMethod">\n\n\t\t\t<div class="form-summary no-margin" ng-if="vm.sicknessPay.IsHistoricSchedule">\n\t\t\t\t<p class="is-small">Enter the payments that were made for this schedule:</p>\n\t\t\t</div>\n\n\t\t\t<!-- Amount brought forward option -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodTotalAmount" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(vm.sicknessPay)" ng-model="vm.sicknessPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount" type="radio">\n\t\t\t\t\t<label for="amountBroughtForwardMethodTotalAmount" class="s">as a total amount</label>\n\t\t\t\t\t<input class="b" id="amountBroughtForwardMethodPerPeriod" name="amountBroughtForwardMethod" ng-change="reviewBroughtForwardMethod(vm.sicknessPay)" ng-model="vm.sicknessPay.AmountBroughtForwardMethod" ng-value="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit" type="radio">\n\t\t\t\t\t<label for="amountBroughtForwardMethodPerPeriod" class="s">as payments per pay period</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Total payments made so far -->\n\t\t\t<div class="form-field fadeIn" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.totalAmount">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="totalBroughtForward" class="required">Total payments made so far:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise xl" id="totalBroughtForward" maxlength="10" name="totalBroughtForward" ng-min="0" ng-model="vm.sicknessPay.TotalBroughtForward" ng-pattern="$root.REGEX.decimal" type="number" required>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="sickPayFormStepEnterPaymentDetails.totalBroughtForward.$touched" ng-messages="sickPayFormStepEnterPaymentDetails.totalBroughtForward.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t<p ng-message="min">Amount should be 1p or greater</p>\n\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pay Period amounts -->\n\t\t\t<fieldset ng-switch="vm.sicknessPay.paymentsBroughtForwardState" pc-switch-when="STATUTORY_PAY_AMOUNT_BROUGHT_FORWARD_METHODS.periodSplit">\n\t\t\t\t<div class="fadeIn" ng-switch-when="loading">\n\t\t\t\t\t<circle-loader class="m fadeIn"></circle-loader>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Ready -->\n\t\t\t\t<div class="form-input-list fadeIn" ng-switch-when="ready">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in vm.sicknessPay.PaymentsBroughtForward">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PayPeriodDisplay}}:</label>\n\t\t\t\t\t\t\t<input autocomplete="off" class="monetise form-input-list_input" id="brought-forward-payment-{{$index}}" min="0" name="brought-forward-payment-{{$index}}" ng-model="payment.PaymentAmount" placeholder="0.00" type="number" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-if="sickPayFormStepEnterPaymentDetails[\'payment-\' + $index].$touched" ng-messages="sickPayFormStepEnterPaymentDetails[\'payment-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Empty -->\n\t\t\t\t<div class="info-block indifferent fadeIn" ng-switch-when="empty">\n\t\t\t\t\t<p class="s">Unable to generate brought forward dates</p>\n\t\t\t\t</div>\n\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<!-- Pro-ration -->\n\t\t<fieldset ng-if="!vm.sicknessPay.IsHistoricSchedule && !vm.sicknessPay.IsPaidInFull">\n\n\t\t\t<!-- Pro-ration method -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationCompanySetting" name="proRationCompanySetting" ng-change="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction = false" ng-model="vm.sicknessPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.companySetting" type="radio">\n\t\t\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\u2019ve worked in a pay period and\n\t\t\t\t\t\t\t\t\tthe statutory payment added on top.</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationPeriod" name="proRationPeriod" ng-model="vm.sicknessPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.period" type="radio">\n\t\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in a pay period based\n\t\t\t\t\t\t\t\t\ton the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.sicknessPay.ProRatingMethod === PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\t\t\t<div class="spacer s"></div> \n\t\t\t\t\t\t\t\t\t<toggle-input field-label="Display leave days as a separate deduction on payslips" field-model="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction" field-name="displayLeaveDaysAsSeparateDeduction"></toggle-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input class="b radio-row-input" id="proRationManual" name="proRationManual" ng-change="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction = false" ng-model="vm.sicknessPay.ProRatingMethod" ng-value="PRO_RATION_METHODS.manual" type="radio">\n\t\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\u2019t cover a whole pay period (e.g. the first and last payments of an extended period of leave)\n\t\t\t\t\t\t\t\t\tpro-ration can be turned off and any adjustments can be made manually to {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</main>\n\t\t\t</div>\n\n\t\t\t<!-- Turn off pro-ration -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.sicknessPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t\t<note note-theme="indifferent" note-title="Remember to make changes manually" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s normal pay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Salary Sacrifice -->\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<settings-row ng-model="vm.sicknessPay.SalarySacrificeState" on-update="reviewStatPaymentSalarySacrifice(vm.sicknessPay)" sr-disabled="::getIsStatPaymentSalarySacrificeReadOnly(vm.sicknessPay)" sr-field-name="salarySacrificeState" sr-icon="salary-change" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Salary sacrifice warnings</sr-label>\n\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t<span ng-switch="vm.sicknessPay.SalarySacrificeBehaviour">\n\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.onLocked">This pay element is included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;OFF&rsquo;.</span>\n\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.offLocked">This pay element is not included in salary sacrifice calculations when payroll is calculated. It can\'t be switched &lsquo;ON&rsquo;.</span>\n\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.on">Switch to OFF if you do not wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions.</span>\n\t\t\t\t\t\t\t<span pc-switch-when="ADJUSTMENT_BEHAVIOUR_STATES.off">Switch to ON if you wish to treat this as basic pay when assessing if salary sacrifice deductions exceed basic pay. Where they do exceed basic pay, they will still be taken, and you will receive an alert in the current period once payroll has been calculated, and may need to make manual adjustments to the team member\'s salary sacrifice deductions</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="goToPreviousStep(vm.sicknessPay)">Back</a>\n\t\t\t<submit-button disable-button="!sickPayFormStepEnterPaymentDetails.$valid" display-text="\'Next\'" state="sickPayFormStepEnterPaymentDetails.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Add supplementary occupational sick pay (applicable when HR is active and sickness policies are available)-->\n\t<form class="fadeIn" name="sickPayFormStepAddSupplementaryOccupationalSickPay" ng-submit="getSicknessSchedulePayments(vm, vm.sicknessPay, sickPayFormStepAddSupplementaryOccupationalSickPay, true)" pc-switch-when="SICKNESS_PAY_STEPS.addSupplementaryOccupationalSickPay" novalidate>\n\t\t<fieldset class="fadeIn">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Occupational sick pay</h4>\n\t\t\t</div>\n\n\t\t\t<!-- Use occupational policy? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="addSupplementaryOccupationalSickPayTrue">Do you wish to add supplementary occupational sick pay?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalSickPayTrue" name="addSupplementaryOccupationalSickPay" ng-init="onSelectSickPayPolicy(vm.sicknessPay, vm.teamMember, true)" ng-model="vm.sicknessPay.UsePolicy" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalSickPayTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="addSupplementaryOccupationalSickPayFalse" name="addSupplementaryOccupationalSickPay" ng-model="vm.sicknessPay.UsePolicy" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="addSupplementaryOccupationalSickPayFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="fadeIn" ng-if="vm.sicknessPay.UsePolicy">\n\n\t\t\t<!-- Select a policy -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="sicknessPolicy" class="required">Select a policy:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select id="sicknessPolicy" name="sicknessPolicy" ng-model="vm.sicknessPay.Policy" ng-change="onSelectSickPayPolicy(vm.sicknessPay, vm.teamMember, false)" ng-options="sicknessPolicy as sicknessPolicy.PolicyName for sicknessPolicy in vm.sicknessPolicies | filter: vm.sicknessPoliciesFilter | orderBy: \'PolicyName\' track by sicknessPolicy.PolicyID" required>\n\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="vm.sicknessPay.Policy">\n\t\t\t\t<div class="form-section" ng-if="vm.sicknessPay.Policy.isValid">\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<p class="form-note">\n\t\t\t\t\t\t\tThis policy uses a {{utilities.toUnsentenceCase(POLICY_YEAR_BASES_DESCRIPTIONS[vm.sicknessPay.Policy.PolicyYearBasis])}} and\n\t\t\t\t\t\t\tentitlement bands are set to &lsquo;{{utilities.toUnsentenceCase(POLICY_PAY_BASES_DESCRIPTIONS[vm.sicknessPay.Policy.PolicyPayBasis])}}&rsquo;.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Entitlement used -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="entitlementUsedDays" class="required">Entitlement used in current sickness year:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field class="m" field-name="entitlementUsedDays" min="0" ng-model="vm.sicknessPay.OccupationalEntitlementUsed" ng-required="true" step="1">\n\t\t\t\t\t\t\t</number-selector-field>&nbsp;&nbsp;<ng-pluralize count="vm.sicknessPay.entitlementUsedDays" when="{ \'1\': \'day\', \'other\': \'days\' }"></ng-pluralize>\n\t\t\t\t\t\t\t<span ng-if="vm.sicknessPay.EntitlementCalculationResult" class="form-note-inline">\n\t\t\t\t\t\t\t\t(Calculated from {{vm.sicknessPay.EntitlementCalculationResult.PolicyYearStartDateISO | dateformat:\'dayMonthYear\'}} to {{vm.sicknessPay.EntitlementCalculationResult.PolicyYearEndDateISO | dateformat:\'dayMonthYear\'}})\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Warning: Later schedules exist -->\n\t\t\t\t\t<div class="form-field fadeIn" ng-if="vm.sicknessPay.EntitlementCalculationResult.HasLaterSchedules">\n\t\t\t\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="tertiary" note-title="Later sickness schedules exist">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\tYou are adding a sickness schedule that may affect how entitlements are applied for this policy year. \n\t\t\t\t\t\t\t\t\tAfter saving, please review sickness schedules dated after this one to ensure entitlements are correct.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Band selection for non-length-of-service policies -->\n\t\t\t\t\t<div class="form-field" ng-if="vm.sicknessPay.Policy.PolicyServiceEntitlement === POLICY_SERVICE_ENTITLEMENTS.none">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="sicknessPolicy" class="required">Select an entitlement band:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<select id="sicknessPolicyBand" name="sicknessPolicyBand" ng-model="vm.sicknessPay.PolicyBand" ng-options="sicknessPolicyBand as sicknessPolicyBand.PolicyBandName for sicknessPolicyBand in vm.sicknessPay.Policy.PolicyBands | orderBy: \'PolicyBandName\' track by sicknessPolicyBand.PolicyBandID" required>\n\t\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t\t<h5>\n\t\t\t\t\t\t\t\t<pc-pluralise count="vm.sicknessPay.Policy.PolicyBands.length" single="{{vm.sicknessPay.Policy.policyBandDescription}}" multiple="{{vm.sicknessPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.sicknessPay.Policy.PolicyBands" policy="vm.sicknessPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Invalid sickness policy selection -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="!vm.sicknessPay.Policy.isValid">\n\n\t\t\t\t\t<!-- Hidden input to disable form -->\n\t\t\t\t\t<input type="hidden" name="notAllowed" id="notAllowed" ng-model="vm.doesNotExist" value="" required>\n\n\t\t\t\t\t<!-- % of annual salary policy but no annual salary-->\n\t\t\t\t\t<div class="form-section" ng-if="vm.sicknessPay.Policy.noAnnualSalarySaved">\n\t\t\t\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="No annual salary saved">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\tEntitlement bands for the selected policy are set to \u2018{{POLICY_PAY_BASES_DESCRIPTIONS[vm.sicknessPay.Policy.PolicyPayBasis]}}\u2019 but\n\t\t\t\t\t\t\t\t\t{{formOptions.context.Forename}} doesn\u2019t have an annual salary saved in their pay information.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No start date or continuous employment date saved for policy based on length of service -->\n\t\t\t\t\t<div class="form-section" ng-if="vm.sicknessPay.Policy.noStartOrContinuousEmploymentDateSaved">\n\t\t\t\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="No start or continuous employment date saved">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\tEntitlement bands for the selected policy are based on length of service but {{formOptions.context.Forename}} doesn\u2019t have a start\n\t\t\t\t\t\t\t\t\tor continuous employment date saved in their company details.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="goToPreviousStep(vm.sicknessPay)">Back</a>\n\t\t\t<submit-button disable-button="!sickPayFormStepAddSupplementaryOccupationalSickPay.$valid" display-text="\'Next\'" state="sickPayFormStepAddSupplementaryOccupationalSickPay.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Review -->\n\t<form class="fadeIn" name="sickPayFormStepReviewSchedule" ng-submit="saveSicknessPay(vm.sicknessPay, sickPayFormStepReviewSchedule)" pc-switch-when="SICKNESS_PAY_STEPS.reviewSchedule" novalidate>\n\t\t<!-- Historic schedule -->\n\t\t<div class="form-section fadeIn" ng-if="vm.sicknessPay.IsPaidInFull">\n\t\t\t<notification-card theme="is-secondary">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<span class="strong">Complete</span> on {{vm.sicknessPay.PaidInFullPayDateISO | dateformat}}\n\t\t\t\t</nc-description>\n\t\t\t</notification-card>\n\t\t</div>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>{{formOptions.context.Forename}}\'s sick payment schedule</h4>\n\t\t\t<p class="s">The below sick payments will be automatically added to payroll for the respective pay periods.</p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\n\t\t\t<stat-payment-summary-card on-edit="goToStep(vm.sicknessPay, SICKNESS_PAY_STEPS.calculate)" stat-payment="vm.sicknessPay" stat-payment-type="sickness">\n\t\t\t</stat-payment-summary-card>\n\n\t\t</div>\n\t\t<div class="form-section" ng-if="vm.sicknessPay.UseWorkDayOverride">\n\t\t\t<div class="form-field-highlight clear">\n\t\t\t\t<div class="form-fieldset-header no-margin bottom">\n\t\t\t\t\t<i class="primary" ng-class="\'icon-loading\'">\n\t\t\t\t\t</i>&nbsp;\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tWorking days have been overridden for this schedule:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<simple-work-pattern-summary work-pattern="vm.workPattern">\n\t\t\t\t</simple-work-pattern-summary>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-section" ng-if="!vm.sicknessPay.IsHistoricSchedule && !vm.sicknessPay.IsPaidInFull">\n\t\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t\t<ib-main>\n\t\t\t\t\t<div ng-switch="vm.sicknessPay.ProRatingMethod">\n\n\t\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.companySetting">\n\t\t\t\t\t\t\tStandard pro-ration is being used where the schedule doesn\u2019t cover whole pay\n\t\t\t\t\t\t\tperiods. <a href="" class="indifferent underline" ng-click="goToStep(vm.sicknessPay, SICKNESS_PAY_STEPS.enterPaymentDetails)">Change this</a>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\tPeriod pro-ration is being used where the schedule doesn\u2019t cover whole pay periods.<span ng-if="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction"> Leave days will be displayed as a separate deduction on payslips.</span>\n\t\t\t\t\t\t\t<a href="" class="indifferent underline" ng-click="goToStep(vm.sicknessPay, SICKNESS_PAY_STEPS.enterPaymentDetails)">Change this</a>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.manual">\n\t\t\t\t\t\t\tPro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustments to {{formOptions.context.Forename}}\'s pay will\n\t\t\t\t\t\t\tneed to be made manually. <a href="" class="indifferent underline" ng-click="goToStep(vm.sicknessPay, SICKNESS_PAY_STEPS.enterPaymentDetails)">Change this</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t\t<!-- Tabs for payments and policy if using a policy -->\n\t\t<fieldset ng-if="vm.sicknessPay.UsePolicy">\n\t\t\t<section class="form-section">\n\t\t\t\t<navigation-tabs>\n\t\t\t\t   <a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'payments\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t   <a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'policy\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t\t</navigation-tabs>\n\t\t\t</section>\n\t\t</fieldset>\n\n\t\t<div class="form-tab-content" ng-switch="vm.sicknessPay.reviewScheduleView">\n\t\t\t<div class="form-section" ng-switch-when="payments" ng-if="vm.sicknessPay.SchedulePayments.length > 0">\n\t\t\t\t<payment-schedule can-edit-occupational-payment-values="true" occupational-payment-label="OSP" schedule-payments="vm.sicknessPay.SchedulePayments" schedule-payment-label="SSP" show-occupational-policy-payment-values="vm.sicknessPay.UsePolicy" statutory-pay-calculation-method="vm.sicknessPay.CalculationMethod"></payment-schedule>\n\t\t\t</div>\n\t\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p class="s">The below entitlement bands are from &lsquo;{{vm.sicknessPay.Policy.PolicyName}}&rsquo; and used to calculate\n\t\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<h5>\n\t\t\t\t\t\t<pc-pluralise count="vm.sicknessPay.Policy.PolicyBands.length" single="{{vm.sicknessPay.Policy.policyBandDescription}}" multiple="{{vm.sicknessPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-band-cards">\n\t\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.sicknessPay.Policy.PolicyBands" policy="vm.sicknessPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="goToPreviousStep(vm.sicknessPay)">Back</a>\n\t\t\t<submit-button disable-button="!sickPayFormStepReviewSchedule.$valid" display-text="\'Save &amp; finish\'" state="sickPayFormStepReviewSchedule.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- Dates incorrect -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="{{formOptions.context.Forename}}\'s sick dates are incomplete" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.dateDetailsMissing">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided don\'t allow us to calculate the correct statutory sick pay for {{formOptions.context.Forename}}.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\tthem eligible to receive statutory sick pay, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Less than four days sickness -->\n<form class="fadeIn" name="notEligibleForSSPForm" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.scheduleLengthError" ng-submit="createNilSchedule(vm, vm.sicknessPay, notEligibleForSSPForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Sickness period less than four days">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note that the period of sickness should be at least four days and the dates you\u2019ve entered mean we can\u2019t calculate\n\t\t\t\t\tstatutory sick pay for {{formOptions.context.Forename}}. You can still add a nil schedule by clicking \u2018Next\u2019.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\t\t\tthem eligible to receive statutory sick pay, please\n\t\t\t\t\t\tcontact support\n\t\t\t\t\tand we\'ll look into it for you.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-state-section has-border-top" ng-if="vm.sicknessPay.isPolicyApplicable">\n\t\t\t\t<div class="form-state-section-textblock">\n\t\t\t\t\t<h5>Need to add occupational sickness pay?</h5>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tYou can select a sickness policy to use in the next step if you still wish to make occupational payments to {{formOptions.context.Forename}} even\n\t\t\t\t\t\tthough they won\u2019t receive any statutory payments.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<!-- pbtodo - bypass next step -->\n\t\t<submit-button display-text="\'Next\'" state="notEligibleForSSPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Less than four days sickness (partial eligibility) -->\n<form class="fadeIn" name="partialNotEligibleForSSPForm" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.partialScheduleLengthError" ng-submit="createNilSchedule(vm, vm.sicknessPay, partialNotEligibleForSSPForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Sickness period less than four days">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note that the period of sickness is less than four days and the dates you\'ve entered mean we may only be able to calculate\n\t\t\t\t\tstatutory sick pay for part of {{formOptions.context.Forename}}\'s sickness period. You can still add a schedule showing reduced entitlement by clicking \'Next\'.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\t\t\tthem eligible to receive statutory sick pay in full, please\n\t\t\t\t\t\tcontact support\n\t\t\t\t\tand we\'ll look into it for you.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Next\'" state="partialNotEligibleForSSPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- PAYE information missing -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="The sick leave dates fall into a new tax year" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.payeDetailsMissing">\n\t<fs-main>\n\t\t<p class="s">We are missing the latest PAYE tax and National Insurance figures for some of the tax years that the sick pay dates fall in.</p>\n\t\t<p class="s">Please contact support and we\'ll look into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<form class="fadeIn" name="notEligibleForSSPForm" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.earningsInsufficient" ng-submit="createNilSchedule(vm, vm.sicknessPay, notEligibleForSSPForm)" novalidate>\n\n\t<!-- Earnings too low -->\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Insufficient earnings">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe earnings for {{formOptions.context.Forename}} don\'t meet the weekly Lower Earnings Limit of {{vm.sicknessPay.TeamMemberSicknessErrors.AverageWeeklyEarningsMin | monetise}} and as a\n\t\t\t\t\tresult, {{formOptions.context.Forename}} is not eligible to receive statutory sick pay. You can still add a nil schedule by clicking \u2018Next\u2019.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\t\t\tthem eligible to receive statutory sick pay, please\n\t\t\t\t\t\tcontact support\n\t\t\t\t\tand we\'ll look into it for you.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-state-section has-border-top" ng-if="vm.sicknessPay.isPolicyApplicable">\n\t\t\t\t<div class="form-state-section-textblock">\n\t\t\t\t\t<h5>Need to add occupational sickness pay?</h5>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tYou can select a sickness policy to use in the next steps if you still wish to make occupational payments to {{formOptions.context.Forename}} even\n\t\t\t\t\t\tthough they won\u2019t receive any statutory payments.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Next\'" state="notEligibleForSSPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form class="fadeIn" name="partiallyNotEligibleForSSPForm" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.earningsPartiallyInsufficient" ng-submit="createNilSchedule(vm, vm.sicknessPay, partiallyNotEligibleForSSPForm)" novalidate>\n\n\t<!-- Earnings partially too low -->\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Insufficient earnings for part of the sickness period">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="s">\n\t\t\t\t\tThe earnings for {{formOptions.context.Forename}} are below the weekly Lower Earnings Limit of {{vm.sicknessPay.TeamMemberSicknessErrors.AverageWeeklyEarningsMin | monetise}} applicable to part of the\n\t\t\t\t\tsickness period. As a result, {{formOptions.context.Forename}} may not be eligible to receive statutory sick pay for part of the schedule. You can still add a schedule showing reduced entitlement by clicking \'Next\'.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, and should make\n\t\t\t\t\tthem eligible to receive statutory sick pay in full, please\n\t\t\t\t\t\tcontact support\n\t\t\t\t\tand we\'ll look into it for you.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Next\'" state="partiallyNotEligibleForSSPForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Duplicate payment schedule -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="A payment schedule already exists" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.duplicatePaymentSchedule">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tThe dates you have provided overlap with an existing statutory payment schedule for {{formOptions.context.Forename}}. You can either\n\t\t\tdelete the existing schedule or click \'Back\' to change the dates you have provided.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf you\'re sure that the information you\'ve entered for {{formOptions.context.Forename}} is correct, please\n\t\t\t\tcontact support\n\t\t\tand we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Payroll has already been run -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Pay periods have already been run" ng-if="pageState === STAT_PAYMENT_SCHEDULE_STATES.payrollHasRun">\n\t<fs-main>\n\t\t<p class="s">The dates you have provided overlap with pay periods that have already been run.</p>\n\t\t<p class="s">If you believe this to be incorrect, please contact support and we\'ll\n\t\t\tlook into it for you.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Saved!" ng-if="pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t{{formOptions.context.Forename}}\'s sick pay schedule has been saved.\n\t\t</p>\n\t\t<p class="s">\n\t\t\tIf for some reason you wish to delete these payments, you can do so from {{formOptions.context.Forename}}\'s profile.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/sickPay/sickPayViewForm.html','<!-- Loading -->\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- View Sickness Pay -->\n<form name="viewSickPayForm" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Complete -->\n\t<div class="form-section fadeIn" ng-if="vm.sicknessPay.IsPaidInFull">\n\t\t<notification-card theme="is-secondary">\n\t\t\t<nc-description>\n\t\t\t\t<p><span class="strong">Complete</span> on {{vm.sicknessPay.PaidInFullPayDateISO | dateformat}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<!-- Managed by integration -->\n\t<div class="form-section fadeIn" data-cy="integration-banner" ng-if="vm.isEdpSicknessSchedule">\n\t\t<notification-card data-cy="sick-pay-integration-banner" theme="is-indifferent">\n\t\t\t<nc-description>\n\t\t\t\t<p><i class="icon-information m is-indifferent"></i>&nbsp;&nbsp;&nbsp;{{vm.edpTopicMessage}}</p>\n\t\t\t</nc-description>\n\t\t</notification-card>\n\t</div>\n\n\t<div class="form-intro">\n\t\t<h4>{{formOptions.context.Forename}}\'s sickness payment schedule</h4>\n\t\t<p class="s">The below sickness payments will be automatically added to payroll for the respective pay periods.</p>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<stat-payment-summary-card can-edit="vm.sicknessPay.CanBeUpdated" on-edit="setPageState(\'update\')" stat-payment="vm.sicknessPay" stat-payment-type="sickness">\n\t\t</stat-payment-summary-card>\n\n\t</div>\n\n\t<div class="form-section" ng-if="vm.sicknessPay.UseWorkDayOverride">\n\t\t<div class="form-field-highlight clear">\n\t\t\t<div class="form-fieldset-header no-margin bottom">\n\t\t\t\t<i class="primary" ng-class="\'icon-loading\'">\n\t\t\t\t</i>&nbsp;\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tWorking days have been overridden for this schedule:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<simple-work-pattern-summary work-pattern="vm.workPattern">\n\t\t\t</simple-work-pattern-summary>\n\t\t</div>\n\t</div>\n\n\n\t<!-- Pro-ration -->\n\t<div class="form-content-block" ng-if="!vm.sicknessPay.IsHistoricSchedule">\n\t\t<info-block ib-theme="indifferent has-plain-type">\n\t\t\t<ib-main>\n\t\t\t\t<div ng-switch="vm.sicknessPay.ProRatingMethod">\n\n\t\t\t\t\t<!-- Company setting -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.companySetting">Standard pro-ration is being used where the schedule doesn\u2019t cover whole pay periods. <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\n\t\t\t\t\t<!-- Period -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.period">Period pro-ration is being used where the schedule doesn\u2019t cover whole pay periods.<span ng-if="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction"> Leave days will be displayed as a separate deduction on payslips</span> <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\n\t\t\t\t\t<!-- Manual -->\n\t\t\t\t\t<p class="s" pc-switch-when="PRO_RATION_METHODS.manual">Pro-ration has been turned off where the schedule doesn\u2019t cover whole pay periods and any adjustments to {{formOptions.context.Forename}}\'s pay will need to be made manually. <a class="indifferent underline" href="" ng-click="setPageState(\'change-pro-ration\')">Change this</a></p>\n\t\t\t\t</div>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<!-- Tabs for payments and policy if using a policy -->\n\t<fieldset ng-if="vm.sicknessPay.UsePolicy">\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'payments\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t<a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'policy\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content" ng-switch="vm.sicknessPay.reviewScheduleView">\n\t\t<div class="form-section" ng-switch-when="payments" ng-if="vm.sicknessPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule can-edit-occupational-payment-values="false" occupational-payment-label="OSP" schedule-payments="vm.sicknessPay.SchedulePayments" schedule-payment-label="SSP" show-occupational-policy-payment-values="vm.sicknessPay.UsePolicy" statutory-pay-calculation-method="vm.sicknessPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThe below payments bands are based on a {{::POLICY_PAY_BASES_DESCRIPTIONS[vm.sicknessPay.Policy.PolicyPayBasis] | lowercase }}\n\t\t\t\t\tand were used to calculate occupational payments:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<pc-pluralise count="vm.sicknessPay.Policy.PolicyBands.length" single="{{vm.sicknessPay.Policy.policyBandDescription}}" multiple="{{vm.sicknessPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.sicknessPay.Policy.PolicyBands" policy="vm.sicknessPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="vm.canUndoUpdateInProgressOriginal">\n\t\t<div class="note tertiary">\n\t\t\t<p class="s" ng-switch="vm.sicknessPay.UpdateReason">\n\n\t\t\t\t<!-- Leaving -->\n\t\t\t\t<span pc-switch-when="SCHEDULE_UPDATE_REASONS.IsLeaving">{{formOptions.context.Forename}} is leaving on {{vm.sicknessPay.EndDateISO | dateformat}}. If you wish to revert to the original payment schedule or you need to change {{formOptions.context.Forename}}\u2019s return date, click \u2018Undo schedule update\u2019 below.</span>\n\n\t\t\t\t<!-- Returning to work early -->\n\t\t\t\t<span pc-switch-when="SCHEDULE_UPDATE_REASONS.ReturnToWork">{{formOptions.context.Forename}} is returning to work early on {{vm.sicknessPay.EndDateISO | dateformat}}. If you wish to revert to the original payment schedule or you need to change {{formOptions.context.Forename}}\u2019s return date, click \u2018Undo schedule update\u2019 below.</span>\n\n\t\t\t\t<!-- Gross pay corrected -->\n\t\t\t\t<span pc-switch-when="SCHEDULE_UPDATE_REASONS.CorrectGrossPay">{{formOptions.context.Forename}}\'s gross payments have been updated. If you wish to revert to the original payment schedule, click \'Undo schedule update\' below.</span>\n\n\t\t\t\t<!-- Sick leave extended -->\n\t\t\t\t<span pc-switch-when="SCHEDULE_UPDATE_REASONS.CorrectEndDate">{{formOptions.context.Forename}}\'s sick leave was extended. If you wish to revert to the original payment schedule, click \'Undo schedule update\' below.</span>\n\n\t\t\t\t<!-- Updated -->\n\t\t\t\t<span ng-switch-default>{{formOptions.context.Forename}}\'s sickness payment schedule has been updated. If you wish to revert to the original payment schedule, click \'Undo schedule update\' below.</span>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Updated -->\n\t<div class="form-section" ng-if="vm.isUpdatedOriginal && vm.sicknessPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s sickness schedule was updated by {{vm.sicknessPay.UpdatedBy}} on {{vm.sicknessPay.UpdatedDateISO | dateformat}} at {{vm.sicknessPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Extended -->\n\t<div class="form-section" ng-if="vm.isExtendedOriginal && vm.sicknessPay.UpdatedBy">\n\t\t<p class="caption">\n\t\t\t{{formOptions.context.Forename}}\'s sickness schedule was extended by {{vm.sicknessPay.UpdatedBy}} on {{vm.sicknessPay.UpdatedDateISO | dateformat}} at {{vm.sicknessPay.UpdatedDateISO | dateformat:\'time\'}}\n\t\t</p>\n\t</div>\n\n\t<!-- Prior to payroll being run -->\n\t<fieldset class="form-actions" ng-if="vm.canBeDeletedOriginal">\n\n\t\t<button class="secondary-action" data-cy="sick-update-schedule" ng-click="setPageState(\'update\')" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="sick-delete-schedule" ng-click="setPageState(\'delete\')" ng-if="!vm.isEdpSicknessSchedule" type="button">\n\t\t\tDelete schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Update schedule -->\n\t<fieldset class="form-actions" ng-if="vm.canUpdateInProgressOriginal && !vm.updateReason">\n\n\t\t<button class="tertiary primary-action" data-cy="sick-update-schedule" ng-click="onUpdateScheduleClick(vm)" type="button">\n\t\t\tUpdate schedule\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Cancel extension -->\n\t<fieldset class="form-actions" ng-if="vm.canCancelExtensionOriginal && !vm.isEdpSicknessSchedule">\n\n\t\t<button class="tertiary primary-action" data-cy="sick-cancel-extension" ng-click="setPageState(\'confirm-cancel-extension\')" type="button">\n\t\t\tCancel extension\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Updating in-progress schedule -->\n\t<fieldset class="form-actions" ng-if="vm.canUpdateInProgressOriginal && vm.updateReason">\n\n\t\t<button class="secondary-action" data-cy="sick-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="tertiary primary-action" data-cy="sick-save-and-finish" ng-click="updateTeamMemberSicknessSchedulePayments(vm)" type="button">\n\t\t\tSave &amp; finish\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Undo \'in-progress\' schedule update -->\n\t<fieldset class="form-actions" ng-if="vm.canUndoUpdateInProgressOriginal">\n\n\t\t<button class="tertiary primary-action" data-cy="sick-undo-schedule-update" ng-click="setPageState(\'undo-schedule-update\')" type="button">\n\t\t\tUndo schedule update\n\t\t</button>\n\n\t</fieldset>\n\n\t<!-- Extend schedule -->\n\t<fieldset class="form-actions" ng-if="vm.canBeExtendedOriginal && !vm.canBeDeletedOriginal && !vm.isEdpSicknessSchedule">\n\n\t\t<button class="tertiary primary-action" data-cy="sick-extend-schedule" ng-click="onExtendScheduleClick(vm)" type="button">\n\t\t\tExtend schedule\n\t\t</button>\n\n\t</fieldset>\n</form>\n\n<!-- Undo in progress schedule update confirmation -->\n<form name="undoInProgressScheduleUpdateConfirmationForm" ng-submit="updateTeamMemberSicknessScheduleInProgressReset(vm, undoInProgressScheduleUpdateConfirmationForm)" class="fadeIn" ng-if="pageState === \'undo-schedule-update\'" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to undo this update?</h4>\n\t\t</header>\n\t\t<p class="s">Once you undo this payment schedule update, it will be deleted and the original payment schedule will be restored. If you later realise you\'ve made a mistake, you will need to create this update again. If you\'re happy to proceed, click \'Confirm\' and you\'ll then see the original payment schedule again.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="undoInProgressScheduleUpdateConfirmationForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Change pro-ration -->\n<form name="changeProRationForm" ng-submit="updateTeamMemberSchedulePaymentsProRatingMethod(vm.sicknessPay, changeProRationForm)" class="fadeIn" ng-if="pageState === \'change-pro-ration\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Change pro-ration method</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="proRationCompanySetting" class="required">Pro-ration method:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationCompanySetting" id="proRationCompanySetting" class="b radio-row-input" ng-value="PRO_RATION_METHODS.companySetting" ng-model="vm.sicknessPay.ProRatingMethod" ng-change="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction = false">\n\t\t\t\t\t\t<label for="proRationCompanySetting" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be pro-rated for the days they\'ve worked in a pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t\t<input type="radio" name="proRationPeriod" id="proRationPeriod" class="b radio-row-input" ng-value="PRO_RATION_METHODS.period" ng-model="vm.sicknessPay.ProRatingMethod">\n\t\t\t\t\t\t\t<label for="proRationPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t\t<p class="s">{{formOptions.context.Forename}}\'s normal pay will be reduced by the number of leave days in a pay period based on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.sicknessPay.ProRatingMethod === PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t\t\t\t<toggle-input field-label="Display leave days as a separate deduction on payslips" field-model="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction" field-name="displayLeaveDaysAsSeparateDeduction"></toggle-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="proRationManual" id="proRationManual" class="b radio-row-input" ng-value="PRO_RATION_METHODS.manual" ng-model="vm.sicknessPay.ProRatingMethod" ng-change="vm.sicknessPay.DisplayLeaveDaysAsSeparateDeduction = false">\n\t\t\t\t\t\t<label for="proRationManual" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\'t cover a whole pay period (e.g. the first and last payments of an extended period of leave) pro-ration can be turned off and any adjustments can be made manually to {{formOptions.context.Forename}}\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Turn off pro-ration -->\n\t\t<div class="form-field fadeIn" ng-if="vm.sicknessPay.ProRatingMethod === PRO_RATION_METHODS.manual">\n\t\t\t<note note-theme="indifferent" note-title="Remember to make changes manually" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that if you turn off pro-ration, statutory payments will be added on top of {{formOptions.context.Forename}}\'s normal pay and any adjustments will need to be made manually for those pay periods affected.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="changeProRationForm.state" disable-button="!changeProRationForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm update schedule -->\n<form name="confirmUpdateSickPayForm" ng-submit="updateSicknessPay(vm.sicknessPay)" class="fadeIn" ng-if="pageState === \'update\'" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to update this schedule?</h4>\n\t\t</header>\n\t\t<p class="s">If you proceed, the existing schedule will be replaced with the new one for {{formOptions.context.Forename}}\'s sick leave.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="confirmUpdateSickPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Update schedule -->\n<form name="updateSickPayForm" ng-submit="updateTeamMemberSicknessScheduleInProgress(vm, updateSickPayForm)" class="fadeIn" ng-if="pageState === \'update-in-progress-schedule\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Update {{formOptions.context.Forename}}\u2019s sick pay schedule</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reason -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="updateReason">Why are you updating the schedule?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="updateReason" name="updateReason" ng-model="vm.updateReason" ng-change="onUpdateReasonChange(vm.sicknessPay)" ng-options="option.value as option.label for option in SICKNESS_UPDATE_OPTIONS" required>\n\t\t\t\t\t<option value="">Please select\u2026</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateSickPayForm.updateReason.$error" ng-if="updateSickPayForm.updateReason.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please choose a reason for the update</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset>\n\t\t<p class="is-small">Current period of sickness:</p>\n\n\t\t<div class="spacer s"></div>\n\n\t\t<div class="from-to-date">\n\t\t\t<span class="from-date"><i class="icon-calendar"></i>&nbsp;<strong>Start date:</strong>&nbsp;<span class="date">{{vm.sicknessPay.StartDateISO | dateformat}}</span></span>\n\t\t\t<span class="to-date"><i class="icon-calendar"></i>&nbsp;<strong>End date:</strong>&nbsp;<span class="date">{{vm.sicknessPay.endDateIsoOriginal | dateformat}}</span></span>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-switch="vm.updateReason">\n\n\t\t<!-- Extend sick leave (date must be after current end date) -->\n\t\t<div pc-switch-when="SCHEDULE_UPDATE_REASONS.CorrectEndDate" class="form-field fadeIn">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="endDate">New end date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="endDate" field-min-date-iso="vm.sicknessPay.endDateMinIso" field-value-iso="vm.sicknessPay.EndDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateSickPayForm.endDate.$error" ng-show="updateSickPayForm.endDate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">Please enter an end date from {{vm.sicknessPay.endDateMinIso | dateformat}}</p>\n\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s new end date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">This date must be from {{vm.sicknessPay.endDateMinIso | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- Return to work early / Mark as leaving (end date to be before existing end date) / Employee is deceased -->\n\t\t<div pc-switch-when="[SCHEDULE_UPDATE_REASONS.ReturnToWork, SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased]" class="form-field fadeIn">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="endDate">New end date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="endDate" field-min-date-iso="vm.sicknessPay.EndDateMinISO" field-max-date-iso="vm.sicknessPay.endDateMaxIso" field-value-iso="vm.sicknessPay.EndDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateSickPayForm.endDate.$error" ng-show="updateSickPayForm.endDate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">Please enter an end date from {{vm.sicknessPay.EndDateMinISO | dateformat}}</p>\n\t\t\t\t<p ng-message="max">Please enter an end date before {{vm.sicknessPay.endDateIsoOriginal | dateformat}}</p>\n\t\t\t\t<p ng-message="required">Please enter {{formOptions.context.Forename}}\'s new end date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">This date must be between {{vm.sicknessPay.EndDateMinISO | dateformat}} - {{vm.sicknessPay.endDateIsoOriginal | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- Re-enter gross payments -->\n\t\t<fieldset pc-switch-when="[SCHEDULE_UPDATE_REASONS.CorrectGrossPay, SCHEDULE_UPDATE_REASONS.CorrectEndDate, SCHEDULE_UPDATE_REASONS.CorrectStartDate, SCHEDULE_UPDATE_REASONS.EmployeeIsDeceased, SCHEDULE_UPDATE_REASONS.IsLeaving, SCHEDULE_UPDATE_REASONS.Redundancy, SCHEDULE_UPDATE_REASONS.ReturnToWork, SCHEDULE_UPDATE_REASONS.SalaryUpdate, SCHEDULE_UPDATE_REASONS.SharedParentalLeave]" class="fadeIn">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Payments List -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-input-list">\n\t\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in vm.sicknessPay.SalaryPayments">\n\t\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="updateSickPayForm[\'payment-\' + $index].$error" ng-if="updateSickPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="onUpdateScheduleCancelClick(vm.sicknessPay)">Cancel</a>\n\t\t<submit-button display-text="\'Next\'" state="updateSickPayForm.state" disable-button="!updateSickPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Extend schedule -->\n<form class="fadeIn" name="updateSickPayForm" ng-if="pageState === \'extend-schedule\'" ng-submit="updateTeamMemberSicknessScheduleInProgress(vm, updateSickPayForm, \'extend-schedule\')" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s sick payment schedule</h4>\n\t\t<p class="s">Enter a new end date for the schedule, click &lsquo;Re-calculate&rsquo;, and any additional payments will be calculated.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Original end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Original end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="originalEndDate" field-read-only="true" field-style="is-primary-light" field-value-iso="vm.sicknessPay.endDateIsoOriginal">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<p class="form-message">{{vm.sicknessPay.EndDateMinISO | dateformat}}</p>\n\t\t</div>\n\n\t\t<!-- New end date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">New end date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="newEndDate" field-max-date-iso="vm.sicknessPay.EndDateMaxISO" field-min-date-iso="vm.sicknessPay.endDateIsoOriginal" field-value-iso="vm.sicknessPay.EndDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="updateSickPayForm.newEndDate.$error" ng-if="updateSickPayForm.newEndDate.$invalid && updateSickPayForm.newEndDate.$touched" role="alert">\n\t\t\t\t<p ng-message="min">The date must be from {{vm.sicknessPay.endDateIsoOriginal | dateformat}}</p>\n\t\t\t\t<p ng-message="max">The date must be no later than {{vm.sicknessPay.EndDateMaxISO | dateformat}}</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">This date must be from {{vm.sicknessPay.endDateIsoOriginal | dateformat}}<span ng-if="vm.sicknessPay.EndDateMaxISO !== \'\'"> and no later than {{vm.sicknessPay.EndDateMaxISO | dateformat}}</span></p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Re-enter gross payments -->\n\t<fieldset class="fadeIn">\n\t\t<div class="form-intro">\n\t\t\t<p class="s">\n\t\t\t\tPlease re-enter the gross amounts {{formOptions.context.Forename}} would have been paid for each of the dates below and we\'ll recalculate {{formOptions.context.Forename}}\'s payment schedule.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Payments List -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-input-list">\n\t\t\t\t<div class="form-input-list_block" ng-repeat="payment in vm.sicknessPay.SalaryPayments">\n\t\t\t\t\t<div class="form-input-list_field">\n\t\t\t\t\t\t<label class="form-input-list_label required" for="payment-{{$index}}">{{payment.PaymentDateISO | dateformat}}:</label>\n\t\t\t\t\t\t<input type="number" id="payment-{{$index}}" class="monetise form-input-list_input" name="payment-{{$index}}" ng-model="payment.PaymentAmount" min="0" placeholder="0.00" required autocomplete="off">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-input-list_errors fadeIn" ng-messages="updateSickPayForm[\'payment-\' + $index].$error" ng-if="updateSickPayForm[\'payment-\' + $index].$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init(formOptions.scheduleID)">Back</a>\n\t\t<submit-button display-text="\'Re-calculate\'" state="updateSickPayForm.state" disable-button="!updateSickPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm extend schedule -->\n<form class="fadeIn" name="extendSickPayForm" ng-if="pageState === \'confirm-extend-schedule\'" ng-submit="updateTeamMemberSicknessSchedulePayments(vm, extendSickPayForm, \'confirm-extend-schedule\')" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Extend {{formOptions.context.Forename}}\'s sick payment schedule</h4>\n\t\t<p class="s">{{formOptions.context.Forename}}\'s sick payments have been re-calculated. Click &lsquo;Confirm&rsquo; to apply the changes.</p>\n\t</div>\n\n\t<div class="form-section">\n\n\t\t<stat-payment-summary-card can-edit="vm.sicknessPay.CanBeUpdated" on-edit="setPageState(\'extend-schedule\')" stat-payment="vm.sicknessPay" stat-payment-type="sickness">\n\t\t</stat-payment-summary-card>\n\n\t</div>\n\n\t<!-- Tabs for payments and policy if using a policy -->\n\t<fieldset ng-if="vm.sicknessPay.UsePolicy">\n\t\t<section class="form-section">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'payments\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'payments\'">Payments</a>\n\t\t\t\t<a href="" ng-class="{\'active\': vm.sicknessPay.reviewScheduleView === \'policy\'}" ng-click="vm.sicknessPay.reviewScheduleView = \'policy\'">Policy</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\t</fieldset>\n\n\t<div class="form-tab-content" ng-switch="vm.sicknessPay.reviewScheduleView">\n\t\t<div class="form-section" ng-switch-when="payments" ng-if="vm.sicknessPay.SchedulePayments.length > 0">\n\t\t\t<payment-schedule can-edit-occupational-payment-values="false" occupational-payment-label="OSP" schedule-payments="vm.sicknessPay.SchedulePayments" schedule-payment-label="SSP" show-occupational-policy-payment-values="vm.sicknessPay.UsePolicy" statutory-pay-calculation-method="vm.sicknessPay.CalculationMethod"></payment-schedule>\n\t\t</div>\n\t\t<div class="form-section" ng-switch-when="policy">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="s">The below entitlement bands are from \u2018{{vm.sicknessPay.Policy.PolicyName}}\u2019 and used to calculate\n\t\t\t\t\tsupplementary occupational payments for this schedule:\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<h5><pc-pluralise count="vm.sicknessPay.Policy.PolicyBands.length" single="{{vm.sicknessPay.Policy.policyBandDescription}}" multiple="{{vm.sicknessPay.Policy.policyBandDescription}}s"></pc-pluralise>\n\t\t\t</h5>\n\t\t\t<div class="policy-band-cards">\n\t\t\t\t<policy-band-card ng-repeat="policyBand in vm.sicknessPay.Policy.PolicyBands" policy="vm.sicknessPay.Policy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init(formOptions.scheduleID)">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="extendSickPayForm.state" disable-button="!extendSickPayForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm cancel extend schedule -->\n<form class="fadeIn" name="cancelExtendSickPayForm" ng-if="pageState === \'confirm-cancel-extension\'" ng-submit="updateTeamMemberSicknessScheduleInProgressReset(vm, cancelExtendSickPayForm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tCancelling {{formOptions.context.Forename}}\'s sick payment schedule will reset the schedule and delete any additional payments.\n\t\t\t\tClick &lsquo;Confirm&rsquo; to apply the changes.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="init(formOptions.scheduleID)">Back</a>\n\t\t<submit-button disable-button="!cancelExtendSickPayForm.$valid" display-text="\'Confirm\'" state="cancelExtendSickPayForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm delete schedule -->\n<form name="deleteSickPayForm" ng-submit="deleteSicknessPay(vm, deleteSickPayForm)" class="fadeIn" ng-if="pageState === \'delete\'" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to delete this schedule?</h4>\n\t\t</header>\n\t\t<p class="s">The payment schedule will be removed from {{formOptions.context.Forename}}\'s profile.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'ready\')">Back</a>\n\t\t<submit-button display-text="\'Confirm\'" state="deleteSickPayForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Deleted -->\n<section class="form-summary fadeIn" ng-if="pageState === \'deleted\'">\n\t<header class="form-summary-header">\n\t\t<i class="icon-tick xxl positive"></i>\n\t\t<h4>The payment schedule has been deleted</h4>\n\t</header>\n\t<p class="s">No payments will be made for {{formOptions.context.Forename}}\'s sick leave.</p>\n\t<p><a href="" id="slide-in-form-close-link" ng-click="formOptions.closeForm()" class="link-with-icon">Ok, close this window</a></p>\n</section>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('forms/payroll/submitChangesTable/submitChangesTableForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="submitChangesTableForm" ng-if="pageState === \'ready\'" ng-submit="submitChangesTable(submitChangesTableForm)">\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you\u2019ve added all your changes?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">Once the changes table is submitted for review you won\u2019t be able to add any further changes.\n\t\t\t\tIf you realise you\u2019ve forgotten something leave a note so it can be actioned. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button type="button" class="secondary-action" ng-click="formOptions.closeForm()">Cancel</button>\n\t\t\t<submit-button display-text="\'Confirm\'" state="submitChangeTablesForm.state">Confirm</submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/submitEps/submitEpsForm.html','<loading-block ng-if="pageState === \'loading\' || pageState === \'cancelling\'">\n\t<lb-description ng-if="pageState === \'cancelling\'">Cancelling...</lb-description>\n</loading-block>\n\n<section class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<form name="submitEpsForm" ng-submit="onFormSubmit(manualEps, agencyProfileId, payPeriodId)" novalidate>\n\t\t<div class="form-content-block">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Submitting EPS corrections">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that this is just for correcting previous submissions to HMRC.\n\t\t\t\t\t\tReports will not be updated to include these corrections and they won\u2019t be included in any disbursements and P32 reminder emails.\n\t\t\t\t\t\tThe exception to this is \u2018CIS deductions suffered\u2019 which will be included in any disbursements and P32 reminder emails.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-content-block" ng-if="manualEps.EPSDetail.EmploymentAllowanceEligible">\n\t\t\t<p class="s">{{formOptions.company.Name}} are eligible for Employment Allowance and their business sector\n\t\t\t\tis \'{{manualEps.EPSDetail.EmploymentAllowanceSector | businessSectorDescription}}\'.</p>\n\t\t</div>\n\n\t\t<div class="form-content-block" ng-if="otherCompanies.length > 0">\n\t\t\t<p class="s">{{formOptions.company.Name}} are linked to the following other companies under the same PAYE scheme which may affect the current values displayed below:</p>\n\t\t\t<div class="form-content-block">\n\t\t\t\t<bullet-list bl-theme="is-primary is-small is-bold">\n\t\t\t\t\t<bl-items>\n\t\t\t\t\t\t<li class="bullet-list_item" ng-repeat="name in otherCompanies">{{name}}</li>\n\t\t\t\t\t</bl-items>\n\t\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<eps-form-fieldset eps="manualEps"></eps-form-fieldset>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="cancelSubmitEps(manualEps)">Cancel</a>\n\t\t\t<submit-button disable-button="!submitEpsForm.$valid || (!manualEps.hasChanges && !manualEps.canBeSubmittedWithoutChanges)" display-text="\'Submit\'" state="submitEpsForm.state"></submit-button>\n\t\t</fieldset>\n\n\t</form>\n\n</section>\n\n<section class="fadeIn" ng-if="pageState === \'submitted\'" ng-switch="manualEps.ManualEPSSubmissionState">\n\t<!-- EPS Submitting -->\n\t<section class="form-summary" pc-switch-when="[SUBMISSION_STATES.unsubmitted, SUBMISSION_STATES.submitting]">\n\t\t<loading-block size="m">\n\t\t\t<lb-description><h4>Submitting to HMRC...</h4></lb-description>\n\t\t</loading-block>\n\t\t<section class="form-summary-section align-center">\n\t\t\t<p class="s">Your EPS is being submitted to HMRC and should only take a few moments.<br>\n\t\t\t\tPlease don\u2019t click back or close your browser window.</p>\n\t\t</section>\n\t</section>\n\n\t<!-- EPS Submitted -->\n\t<div pc-switch-when="SUBMISSION_STATES.submitted">\n\n\t\t<!-- Default -->\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Your EPS has been successfully sent to HMRC" ng-if="!manualEps.showManualEPSEAWarning">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">Your EPS has been successfully sent to HMRC.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<!-- AE only manual EPS -->\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Year to date updated" ng-if="manualEps.showManualEPSEAWarning">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour Employment Allowance year to date figure has been updated.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- EPS Submission Failed -->\n\t<div pc-switch-when="SUBMISSION_STATES.failed">\n\t\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="There seems to be a problem submitting this EPS">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">Unfortunately your EPS submission to HMRC failed.</p>\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="What to do if the problem persists">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="s">If you\'ve tried to fix the issues mentioned and you\'re still having problems submitting your EPS\n\t\t\t\t\t\t\t\tthen please get in touch and we\'ll help you fix the problem pronto!</p>\n\t\t\t\t\t\t\t<p class="s">Talk to the Paycircle team</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<a class="button secondary-action" href="" ng-click="cancelSubmitEps(manualEps)">Cancel</a>\n\t\t\t\t<button class="primary-action tertiary inverse" ng-click="resetSubmissionState(manualEps)">Try again</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n</section>\n\n<!-- EPS won\'t be submitted (EA-only difference) -->\n<form name="epsWontBeSubmittedForm" ng-submit="submitEps(manualEps, agencyProfileId, payPeriodId)" ng-if="pageState === \'eps-wont-be-submitted\'">\n\t<form-state form-options="formOptions" fs-icon="information" fs-show-close="false" fs-title="An EPS won\u2019t be submitted">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that as you\u2019ve only entered a different figure for Employment Allowance, an EPS won\u2019t be submitted when you click \u2018Continue\u2019.\n\t\t\t\tThe year to date figure will be updated as normal, however.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tClose\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Continue\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Year End EA Submit EPS Alert -->\n<form name="epsAlert" ng-if="pageState === \'alert\'">\n\t<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Employment Allowance may be affected" fs-show-close="false">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThe pay period you\'re about to submit an EPS for relates to a different tax year to the current period.\n\t\t\t</p>\n\t\t\t<p class="is-small">\n\t\t\t\tIf the Employment Allowance settings for {{$root.currentCompany.Name}} have changed between the {{manualEps.ManualEPSTaxYearDisplay}} tax year and the current period, for example because \'Auto-reclaim\' wasn\'t turned on, it could impact both your EPS and P32 reports. \n\t\t\t\tYou may need to adjust your \'Employer status\' settings before running.\n\t\t\t</p>\n\t\t\t<p class="is-small">\n\t\t\t\tClick \'Continue\' if you\'re happy that you\'ve added the correct Employment Allowance settings for the {{manualEps.ManualEPSTaxYearDisplay}} tax year for {{$root.currentCompany.Name}}.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<button class="primary-action tertiary" ng-click="setPageState(\'ready\')" type="button">\n\t\t\t\tContinue\n\t\t\t</button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/supplementary-pay-run/supplementary-pay-run.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- RTI submission disabled warning -->\n<form class="fadeIn" name="supplementaryPayRunRTISubmissionDisabledForm" ng-if="pageState === \'rti-submission-disabled\'" ng-submit="onRTISubmissionContinue(vm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary" fs-title="RTI submission is turned off" ng-if="pageState === \'rti-submission-disabled\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that RTI submission is turned off in your payroll settings so this supplementary pay run will be saved but not submitted. It will be saved to your Supplementary pay runs\n\t\t\t\tarea and Year to Dates for team members will be updated as normal.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunRTISubmissionDisabledForm.$valid" display-text="\'Continue\'" state="supplementaryPayRunRTISubmissionDisabledForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Previous Tax Year -->\n<form class="fadeIn" name="supplementaryPayRunPreviousTaxYearForm" ng-if="pageState === \'previous-tax-year\'" ng-submit="onPreviousTaxYearContinue(vm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Employment Allowance may be affected">\n\t\t<fs-main>\n\n\t\t\t<p class="is-small">\n\t\t\t\tThe pay period you\'re about to add a supplementary pay run for relates to a different tax year to the current period.\n\t\t\t</p>\n\n\t\t\t<p class="is-small">\n\t\t\t\tIf the Employment Allowance settings for {{formOptions.company.Name}} have changed between the {{vm.payPeriodPrevious.TaxYearDisplay}} tax year and the current period, for example because \'Auto-reclaim\' wasn\'t turned on, it could impact both your EPS and P32 reports. You may need to adjust your \'Employer status\' settings before running.\n\t\t\t</p>\n\n\t\t\t<p class="is-small">\n\t\t\t\tClick \'Continue\' if you\'re happy that you\'ve added the correct Employment Allowance settings for the {{vm.payPeriodPrevious.TaxYearDisplay}} tax year for {{formOptions.company.Name}}.\n\t\t\t</p>\n\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunPreviousTaxYearForm.$valid" display-text="\'Continue\'" state="supplementaryPayRunPreviousTaxYearForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Pension Submitted Warning -->\n<form class="fadeIn" name="supplementaryPayRunPensionSubmittedForm" ng-if="pageState === \'pension-submitted\'" ng-submit="reviewInit(vm)" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Your pension has been submitted">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYour pension file for {{vm.payPeriodPrevious.PayPeriodDisplay}} has already been submitted. If you\u2019re operating an automated pension scheme and you\u2019ve turned on pension calculations\n\t\t\t\tthey will be automatically removed from this supplementary pay run. You can manually add pension-related changes to replace them, however, and you\u2019ll need to upload them to your\n\t\t\t\tpension portal manually.\n\t\t\t</p>\n\t\t\t<p class="is-small">\n\t\t\t\tFor manual pension schemes, if you previously added pension-related changes you\u2019ll need to upload them to your pension portal manually.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunPensionSubmittedForm.$valid" display-text="\'Continue\'" state="supplementaryPayRunPensionSubmittedForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Review leavers -->\n<form class="fadeIn" name="supplementaryPayRunReviewLeaversForm" ng-if="pageState === \'review-leavers\'" ng-submit="setupLeaversToSubmitForSupplementaryPayment(vm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Select leavers to submit in this pay run</h5>\n\t\t<p class="is-small">\n\t\t\tOne or more of the team members you\u2019ve selected are marked as leavers. To submit them as leavers in this run select them below before clicking \u2018Next\u2019. Otherwise, you can submit changes\n\t\t\tfor them as normal and they will be submitted as a leaver later.\n\t\t</p>\n\t</div>\n\n\t<!-- Leavers -->\n\t<fieldset>\n\n\t\t<div class="checkbox-rows-list">\n\t\t\t<div class="checkbox-row" ng-repeat="(leaverIndex, leaver) in vm.leavers">\n\t\t\t\t<label class="checkbox-row_label" for="checkbox-row_{{leaverIndex}}">\n\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" id="checkbox-row_{{leaverIndex}}" name="checkbox-row_{{leaverIndex}}" ng-model="leaver.isChecked" type="checkbox">\n\t\t\t\t\t<avatar avatar-initial="{{leaver.Forename[0]}}" avatar-size="is-small" class="checkbox-row_avatar"></avatar>\n\t\t\t\t\t<span class="checkbox-row_context">\n\t\t\t\t\t\t<h6>\n\t\t\t\t\t\t\t<name forename="{{leaver.Forename}}" surname="{{leaver.Surname}}"></name>\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\tLeave date: {{leaver.LeaveDateISO | dateformat}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</span>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunReviewLeaversForm.$valid" display-text="\'Next\'" state="supplementaryPayRunReviewLeaversForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Adjustments overview -->\n<form class="fadeIn" name="supplementaryPayRunForm1" ng-if="pageState === \'adjustments-overview\'" ng-submit="setupAdjustmentsForSupplementaryPayment(vm)" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Description -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="paymentDescription">\n\t\t\t\t\tDescription:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input data-cy="supplementary-run-description-field" id="paymentDescription" name="paymentDescription" ng-model="vm.supplementaryPayment.SupplementaryPaymentTitle" ng-pattern="$root.REGEX.description" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="supplementaryPayRunForm1.paymentDescription.$touched" ng-messages="supplementaryPayRunForm1.paymentDescription.$error" role="alert">\n\t\t\t\t<p data-cy="supplementary-run-description-required-message" ng-message="required">\n\t\t\t\t\tPlease enter a description\n\t\t\t\t</p>\n\t\t\t\t<p data-cy="supplementary-run-description-match-message" ng-message="pattern">\n\t\t\t\t\tOnly basic characters are allowed\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset>\n\n\t\t<!-- Changes -->\n\t\t<collapsible-list is-active="true" label="getAdjustmentCountLabel(vm)">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-cards">\n\t\t\t\t\t<div class="adjustment-list-card has-action" ng-repeat="(teamMemberIndex, teamMember) in vm.teamMembers">\n\n\t\t\t\t\t\t<!-- Team member -->\n\t\t\t\t\t\t<p class="adjustment-list-card_header">\n\t\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t\t<span class="adjustment-list-card_header-label">\n\t\t\t\t\t\t\t\t{{teamMember.Forename}} {{teamMember.Surname}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="adjustment-list-card_adjustment" ng-if="teamMember.adjustments.length > 0" ng-repeat="(adjustmentIndex, adjustment) in teamMember.adjustments">\n\n\t\t\t\t\t\t\t<!-- Payslip Label -->\n\t\t\t\t\t\t\t<div class="adjustment-list-card_adjustment-label">\n\n\t\t\t\t\t\t\t\t<!-- w/o Tooltip -->\n\t\t\t\t\t\t\t\t<span ng-if="!adjustment.Tooltip">{{getAdjustmentDescription(adjustment)}} {{adjustment | adjustmentValueTypeCalculation}}</span>\n\n\t\t\t\t\t\t\t\t<!-- w/ Tooltip -->\n\t\t\t\t\t\t\t\t<span class="underline" ng-if="adjustment.Tooltip" tooltip tooltip-text="{{adjustment.Tooltip}}">\n\t\t\t\t\t\t\t\t\t{{getAdjustmentDescription(adjustment)}} {{adjustment | adjustmentValueTypeCalculation}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Adjustment details -->\n\t\t\t\t\t\t\t<p class="is-small {{getAdjustmentValueDisplayClass(adjustment)}} adjustment-list-card_adjustment-value" ng-show="!adjustment.confirmDelete">\n\t\t\t\t\t\t\t\t{{adjustment | adjustmentValue}}\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Actions -->\n\t\t\t\t\t\t\t<div class="adjustment-list-card_adjustment-actions" ng-show="!adjustment.confirmDelete">\n\t\t\t\t\t\t\t\t<a aria-label="Edit change" class="adjustment-list-card_adjustment-action" href="" ng-click="editAdjustment(vm, teamMemberIndex, adjustmentIndex)" ng-if="adjustment.canEdit">\n\t\t\t\t\t\t\t\t\t<i class="icon-edit is-smedium"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<a aria-label="Delete change" class="adjustment-list-card_adjustment-action" href="" ng-click="toggleAdjustmentConfirmDelete(adjustment)" ng-if="adjustment.canDelete">\n\t\t\t\t\t\t\t\t\t<i class="icon-trash is-smedium"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Confirm delete -->\n\t\t\t\t\t\t\t<div class="adjustment-list-card_adjustment-confirm-delete fadeIn" ng-show="adjustment.confirmDelete">\n\t\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t\tDelete this change?&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<a href="" ng-click="deleteAdjustment(vm, teamMemberIndex, adjustmentIndex)">\n\t\t\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;|&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t<a href="" ng-click="toggleAdjustmentConfirmDelete(adjustment)">\n\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="adjustment-list-card_placeholder" ng-if="teamMember.adjustments.length === 0">\n\t\t\t\t\t\t\t<p class="is-caption">No changes added</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<button class="button is-white is-tiny adjustment-list-card_action" data-cy="supplementary-run-add-change-button" ng-click="addPayElementForTeamMember(vm, teamMemberIndex)" type="button">\n\t\t\t\t\t\t\tAdd change\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\n\t\t<!-- Starters -->\n\t\t<collapsible-list can-open="vm.starters.length > 0" is-active="vm.starters.length > 0" ng-if="vm.starters.length > 0" label="getLabel(vm, \'starters\')">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-card" ng-repeat="starter in vm.starters">\n\t\t\t\t\t<div class="adjustment-list-card_header">\n\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-label">{{starter.Forename}} {{starter.Surname}}</span>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-meta">Start date: {{starter.StartDateISO | dateformat}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\n\t\t<!-- Leavers -->\n\t\t<collapsible-list can-open="vm.leavers.length > 0" is-active="vm.leavers.length > 0" ng-if="vm.leavers.length > 0" label="getLabel(vm, \'leavers\')">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-card" ng-repeat="leaver in vm.leavers">\n\t\t\t\t\t<div class="adjustment-list-card_header">\n\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-label">{{leaver.Forename}} {{leaver.Surname}}</span>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-meta">\n\t\t\t\t\t\t\tLeave date: {{leaver.LeaveDateISO | dateformat}}\n\t\t\t\t\t\t\t<a aria-label="Edit selected leavers" class="is-greyscale adjustment-list-card_header-action" href="" ng-click="editSelectedLeavers(vm)" ng-if="vm.leaversOriginal.length">\n\t\t\t\t\t\t\t\t<i class="icon-edit is-smedium"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunForm1.$valid || (vm.totalAdjustmentCount === 0 && vm.leavers.length === 0)" display-text="\'Next\'" state="supplementaryPayRunForm1.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Adjustment builder -->\n<form class="fadeIn" name="supplementaryPayRunFormAlt" ng-if="pageState === \'adjustment-builder\'" ng-submit="addActiveAdjustmentToSupplementaryPayments(vm)" novalidate>\n\n\t<fieldset>\n\t\t<change-creator agency-profile-id="vm.agencyProfileId" vm="vm.activeAdjustment"></change-creator>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(\'adjustments-overview\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunFormAlt.$valid || !vm.activeAdjustment.newAdjustment.adjustmentType || !vm.activeAdjustment.isValid || isBusinessCategoriesInvalid(vm)" display-text="vm.activeAdjustment.isEditing ? \'Update\' : \'Add\'" state="supplementaryPayRunFormAlt.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Report options -->\n<form class="fadeIn" name="supplementaryPayRunForm2" ng-if="pageState === \'report-options\'" ng-submit="updateSupplementaryPayment(vm)" novalidate>\n\n\t<div class="form-content-block">\n\t\t<summary-action-card can-edit="true" on-edit="goToAdjustmentsOverview()" summary-card-description="getSupplementaryPayDescription(vm)" summary-card-title="vm.supplementaryPayment.SupplementaryPaymentTitle"></summary-action-card>\n\t</div>\n\n\t<div class="form-content-block" ng-if="!vm.isBulkOperation && !vm.teamMembers[0].IsInSetupMode">\n\t\t<p class="is-small">\n\t\t\t{{vm.teamMembers[0].Forename}}&apos;s supplementary payslip can either include just the changes you\'ve added or combine them with all the information from their previous payslip for\n\t\t\t{{vm.payPeriodPrevious.PayPeriodDisplay}}.<span ng-if="formOptions.company.IsBACSEnabled">&nbsp;A supplementary BACS file will also be created.</span>\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block" ng-if="vm.isBulkOperation">\n\t\t<p class="is-small">\n\t\t\tSupplementary payslips can either include just the changes you\'ve added or combine the new changes with all the information from previous payslips for\n\t\t\t{{vm.payPeriodPrevious.PayPeriodDisplay}}.<span ng-if="formOptions.company.IsBACSEnabled">&nbsp;A supplementary BACS file will also be created.</span>\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Payslip Option -->\n \t\t<div class="form-field" ng-if="!vm.teamMembers[0].IsInSetupMode">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Supplementary payslips to generate:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="payslipOption1" name="payslipOption" ng-model="vm.supplementaryPayment.SupplementaryPaymentPayslipType" ng-value="vm.SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES.justSupplementaryChanges" required type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="payslipOption1">\n\t\t\t\t\t\t\t<p class="radio-row-title">\n\t\t\t\t\t\t\t\tOne payslip with just the new changes\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="payslipOption2" name="payslipOption" ng-model="vm.supplementaryPayment.SupplementaryPaymentPayslipType" ng-value="vm.SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES.combineWithPreviousPayslip" required type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="payslipOption2">\n\t\t\t\t\t\t\t<p class="radio-row-title">\n\t\t\t\t\t\t\t\tOne payslip combined with the previous payslip\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="payslipOption3" name="payslipOption" ng-model="vm.supplementaryPayment.SupplementaryPaymentPayslipType" ng-value="vm.SUPPLEMENTARY_PAYMENT_PAYSLIP_TYPES.createBothTypesOfPayslip" required type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="payslipOption3">\n\t\t\t\t\t\t\t<p class="radio-row-title">\n\t\t\t\t\t\t\t\tTwo separate payslips for the new and combined changes\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="form-message" ng-if="!vm.isBulkOperation">\n\t\t\t\tThis won\'t affect {{vm.teamMembers[0].Forename}}&apos;s original payslips for {{vm.payPeriodPrevious.PayPeriodDisplay}} and they will still be available in the Payments area in their\n\t\t\t\tprofile.\n\t\t\t</p>\n\t\t\t<p class="form-message" ng-if="vm.isBulkOperation">\n\t\t\t\tThis won\'t affect any original payslips for {{vm.payPeriodPrevious.PayPeriodDisplay}} and they will still be available in the Payments area in their profile.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Payment date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="paymentDate">\n\t\t\t\t\tPayment date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="paymentDate" field-value-iso="vm.supplementaryPayment.SupplementaryPaymentPayDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="supplementaryPayRunForm2.paymentDate.$touched" ng-messages="supplementaryPayRunForm2.paymentDate.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter a payment date\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="date">\n\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">\n\t\t\t\tThis will be used to label supplementary pay runs in your History area and will also be used as the payment date if you use BACS.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(\'adjustments-overview\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunForm2.$valid" display-text="\'Next\'" state="supplementaryPayRunForm2.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- BACS Files -->\n<form class="fadeIn" name="supplementaryPayRunForm5" ng-if="pageState === \'bacs-files-options\'" ng-submit="updateSupplementaryPaymentDisbursements(vm)" novalidate>\n\t<div class="form-content-block">\n\t\t<summary-action-card can-edit="true" on-edit="goToAdjustmentsOverview()" summary-card-description="getSupplementaryPayDescription(vm)" summary-card-title="vm.supplementaryPayment.SupplementaryPaymentTitle"></summary-action-card>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<h4>BACS files</h4>\n\t\t<p class="is-small">\n\t\t\tPayments to team members are automatically included in a main BACS file which uses the payment date set in the previous step and is shown below.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>\n\t\t\t\t\tMain BACS payment date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="inline-half">\n\t\t\t\t\t<message-block class="inline-half_item" theme="is-primary is-inline">\n\t\t\t\t\t\t<span class="is-primary">{{::vm.supplementaryPayment.SupplementaryPaymentPayDateISO | dateformat: \'numeric\'}}</span>\n\t\t\t\t\t</message-block>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-content-block" ng-if="vm.supplementaryPaymentDisbursements.length > 0">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tSelect other disbursements you wish to make BACS payments for and choose whether you wish to include them in the main file or create a separate file.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<extended-checkbox name="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}" ng-model="supplementaryPaymentDisbursement.IsEnabled" ng-repeat="supplementaryPaymentDisbursement in vm.supplementaryPaymentDisbursements">\n\t\t\t\t\t<checkbox-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{::supplementaryPaymentDisbursement.Name}}</h6>\n\t\t\t\t\t</checkbox-label>\n\n\t\t\t\t\t<checkbox-content>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header form-intro">\n\t\t\t\t\t\t\t\t<label class="required" for="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Options">\n\t\t\t\t\t\t\t\t\tBACS payment:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline" id="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Options">\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Included" name="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Included" ng-model="supplementaryPaymentDisbursement.IsSeparate" ng-value="false" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Included">\n\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Include in main file</span>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Separate" name="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Separate" ng-model="supplementaryPaymentDisbursement.IsSeparate" ng-value="true" type="radio">\n\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="supplementaryPaymentDisbursement{{supplementaryPaymentDisbursement.Name}}Separate">\n\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Create a separate file</span>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spacer s" ng-if="supplementaryPaymentDisbursement.IsSeparate"></div>\n\t\t\t\t\t\t<div ng-if="supplementaryPaymentDisbursement.IsSeparate">\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required" for="{{supplementaryPaymentDisbursement.Name}}PaymentDateISO">\n\t\t\t\t\t\t\t\t\t\tPayment date:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<date-input-field field-id="{{supplementaryPaymentDisbursement.Name}}PaymentDateISO" field-value-iso="supplementaryPaymentDisbursement.PaymentDateISO">\n\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="supplementaryPayRunForm5[supplementaryPaymentDisbursement.Name + \'PaymentDate\'].$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\t\tPlease enter a payment date\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="date">\n\t\t\t\t\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</checkbox-content>\n\t\t\t\t</extended-checkbox>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(\'report-options\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="setPageState(\'confirm-delete\')" ng-if="vm.supplementaryPayment.CanDelete" type="button">\n\t\t\tDelete run\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunForm5.$valid" display-text="\'Next\'" state="supplementaryPayRunForm5.state">\n\t\t</submit-button>\n\t\t<button class="primary-action tertiary" ng-disabled="!supplementaryPayRunForm5.$valid" ng-click="saveForLater(vm)" type="button">\n\t\t\tSave for later\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Generating Reports -->\n<section class="form-summary fadeIn" ng-if="pageState === \'generating-documents\'">\n\t<loading-block position="after" size="m">\n\t\t<lb-description>\n\t\t\t<h5>Draft reports are being generated</h5>\n\t\t</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="is-small">\n\t\t\tYour supplementary pay run documents are being generated and this should only take a few moments. Please don\'t click back or close your browser window.\n\t\t</p>\n\t</section>\n</section>\n\n<!-- Review Reports -->\n<form class="fadeIn" name="supplementaryPayRunForm3" ng-if="pageState === \'review-reports\'" ng-submit="setPageState(\'submission-summary\')" novalidate>\n\n\t<div class="form-content-block">\n\t\t<summary-action-card can-edit="true" on-edit="goToAdjustmentsOverview()" summary-card-description="getSupplementaryPayDescription(vm)" summary-card-title="vm.supplementaryPayment.SupplementaryPaymentTitle"></summary-action-card>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="is-small">\n\t\t\tYour supplementary pay run reports have been generated and are available to preview. They can also be downloaded later from the &lsquo;Supplementary pay runs&rsquo; page in your History area.\n\t\t</p>\n\n\t</div>\n\n\t<div class="form-content-block" ng-if="formOptions.company.IsBACSEnabled">\n\t\t<p class="is-small">\n\t\t\tA supplementary BACS file has also been generated for {{formOptions.company.Name}} and can also be downloaded later from the &lsquo;Supplementary pay runs&rsquo; page in your History\n\t\t\tarea.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reports -->\n\t\t<div class="report-download-card_wrapper rows">\n\t\t\t<report-download-card agency-profile-id="formOptions.company.AgencyProfileID" can-regenerate-bacs="false" form-options="formOptions" ng-repeat="report in vm.reports" pay-period="vm.payPeriodPrevious" report="report" show-created-date="true" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(getPreviousPageState())" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="setPageState(\'confirm-delete\')" ng-if="vm.supplementaryPayment.CanDelete" type="button">\n\t\t\tDelete run\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunForm3.$valid" display-text="\'Next\'" state="supplementaryPayRunForm3.state"></submit-button>\n\t\t<button class="primary-action tertiary" ng-click="saveForLater()" type="button">\n\t\t\tSave for later\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Submission summary -->\n<form class="fadeIn" name="supplementaryPayRunForm4" ng-if="pageState === \'submission-summary\'" ng-submit="payrollSubmitSupplementaryPayment(vm, supplementaryPayRunForm4)" novalidate>\n\n\t<div class="form-intro" ng-if="!vm.isSavePayRunOnly">\n\t\t<h5>Submission summary</h5>\n\t\t<p class="is-small">\n\t\t\tHere\'s a summary of what will be updated. If you\'re happy everything looks correct, click &lsquo;Submit pay run&rsquo; and your submission will begin.\n\t\t</p>\n\t</div>\n\n\t<!-- RTI Submission Disabled -->\n\t<div class="form-intro" ng-if="vm.isSavePayRunOnly">\n\t\t<h5>Summary</h5>\n\t\t<p class="is-small">\n\t\t\tHere\u2019s a summary of what will be saved in your supplementary pay run. If you\u2019re happy everything looks correct, click \u2019Save pay run\u2019.\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block fadeIn">\n\t\t<summary-action-card summary-card-description="getSupplementaryPayDescription(vm)" summary-card-title="vm.supplementaryPayment.SupplementaryPaymentTitle"></summary-action-card>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Changes -->\n\t\t<collapsible-list can-open="vm.supplementaryPayment.SupplementaryPaymentElements.length > 0" is-active="vm.supplementaryPayment.SupplementaryPaymentElements.length > 0" label="getAdjustmentCountLabel(vm)">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-cards">\n\t\t\t\t\t<div class="adjustment-list-card" ng-if="teamMember.adjustments.length > 0" ng-repeat="(teamMemberIndex, teamMember) in vm.teamMembers">\n\t\t\t\t\t\t<!-- Team member -->\n\t\t\t\t\t\t<p class="adjustment-list-card_header">\n\t\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t\t<span class="adjustment-list-card_header-label">\n\t\t\t\t\t\t\t\t{{teamMember.Forename}} {{teamMember.Surname}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="adjustment-list-card_adjustment" ng-repeat="(adjustmentIndex, adjustment) in teamMember.adjustments">\n\n\t\t\t\t\t\t\t<!-- Payslip Label -->\n\t\t\t\t\t\t\t<div class="adjustment-list-card_adjustment-label">\n\n\t\t\t\t\t\t\t\t<!-- w/o Tooltip -->\n\t\t\t\t\t\t\t\t<span ng-if="!adjustment.Tooltip">{{getAdjustmentDescription(adjustment)}} {{adjustment | adjustmentValueTypeCalculation}}</span>\n\n\t\t\t\t\t\t\t\t<!-- w/ Tooltip -->\n\t\t\t\t\t\t\t\t<span ng-if="adjustment.Tooltip" class="underline" tooltip tooltip-text="{{adjustment.Tooltip}}">\n\t\t\t\t\t\t\t\t\t{{getAdjustmentDescription(adjustment)}} {{adjustment | adjustmentValueTypeCalculation}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Adjustment details -->\n\t\t\t\t\t\t\t<p class="is-small {{getAdjustmentValueDisplayClass(adjustment)}} adjustment-list-card_adjustment-value">\n\t\t\t\t\t\t\t\t{{adjustment | adjustmentValue}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\n\t\t<!-- Starters -->\n\t\t<collapsible-list can-open="vm.starters.length > 0" is-active="vm.starters.length > 0" label="getLabel(vm, \'starters\')" ng-if="vm.starters.length > 0">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-card" ng-repeat="starter in vm.starters">\n\t\t\t\t\t<div class="adjustment-list-card_header">\n\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-label">{{starter.Forename}} {{starter.Surname}}</span>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-meta">Start date: {{starter.StartDateISO | dateformat}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\n\t\t<!-- Leavers -->\n\t\t<collapsible-list can-open="vm.leavers.length > 0" is-active="vm.leavers.length > 0" label="getLabel(vm, \'leavers\')" ng-if="vm.leavers.length > 0">\n\t\t\t<collapsible-list-content>\n\t\t\t\t<div class="adjustment-list-card" ng-repeat="leaver in vm.leavers">\n\t\t\t\t\t<div class="adjustment-list-card_header">\n\t\t\t\t\t\t<i class="icon-user is-smedium is-primary adjustment-list-card_header-icon"></i>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-label">{{leaver.Forename}} {{leaver.Surname}}</span>\n\t\t\t\t\t\t<span class="adjustment-list-card_header-meta">Leave date: {{leaver.LeaveDateISO | dateformat}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</collapsible-list-content>\n\t\t</collapsible-list>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(\'review-reports\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="deleteSupplementaryPayment(vm, supplementaryPayRunForm4)" ng-if="vm.supplementaryPayment.CanDelete" type="button">\n\t\t\tDelete run\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunForm4.$valid" display-text="vm.isSavePayRunOnly ? \'Save pay run\' : \'Submit pay run\'" state="supplementaryPayRunForm4.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Save for later confirmation -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-title="Pay run saved" ng-if="pageState === \'saved-for-later\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tThis supplementary pay run has been saved<span ng-if="vm.showLinkToSupplementaryPayRuns"> and can be found in the Supplementary Pay Runs section of {{formOptions.company.Name}}\'s Payroll</span>.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section" ng-if="vm.showLinkToSupplementaryPayRuns">\n\t\t\t<a class="is-small strong" ui-sref="payroll.history.supplementary-pay-runs({\n\t\t\t\t\tagencyProfileId: vm.agencyProfileId\n\t\t\t\t})">\n\t\t\t\tGo to Supplementary Pay Runs\n\t\t\t</a>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Submitting -->\n<div ng-if="pageState === \'submitting\'">\n\t<loading-block position="after" size="m">\n\t\t<lb-description>\n\t\t\t<h5>Finalising pay run</h5>\n\t\t</lb-description>\n\t</loading-block>\n\t<section class="form-content-block align-center">\n\t\t<p class="is-small">\n\t\t\tYour supplementary pay run is being finalised and should only take a few moments. Please don\'t click back or close your browser window.\n\t\t</p>\n\t</section>\n</div>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Pay run finalised" ng-if="pageState === \'success\'">\n\t<fs-main>\n\n\t\t<div class="form-state-section">\n\n\t\t\t<!-- Single -->\n\t\t\t<p class="is-small" ng-if="!vm.isBulkOperation">\n\t\t\t\t{{vm.teamMembers[0].Forename}}&apos;s information has been successfully updated and {{vm.teamMembers[0].Gender | personalise:\'he\'}} has been notified that\n\t\t\t\t{{vm.teamMembers[0].Gender | personalise:\'his\'}} supplementary payslip is now available in {{vm.teamMembers[0].Gender | personalise:\'his\'}} user portal. A supplementary pay run has\n\t\t\t\tbeen added to the supplementary pay runs page in your history area where you can also find your supplementary FPS file, submission receipt and BACS file, if you\'re using one.\n\t\t\t</p>\n\n\t\t\t<!-- Bulk -->\n\t\t\t<p class="is-small" ng-if="vm.isBulkOperation">\n\t\t\t\tTeam members have been notified that their supplementary payslip is now available in their Pay Portal. Your supplementary pay run reports can also be downloaded later from the &lsquo;Supplementary pay runs&rsquo; page in your History area.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<hr class="xl">\n\n\t\t<div class="form-content-block">\n\t\t\t<p class="is-small">\n\t\t\t\tQuickly download your new documents:\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Reports -->\n\t\t<div class="form-state-section report-download-card_wrapper rows">\n\n\t\t\t<!-- Classic -->\n\t\t\t<report-download-card agency-profile-id="formOptions.company.AgencyProfileID" can-regenerate-bacs="false" form-options="formOptions" ng-repeat="report in vm.classicReports" pay-period="vm.reportPeriod" report="report" show-created-date="true" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<h5>Combined reports</h5>\n\t\t</div>\n\n\t\t<div class="form-state-section report-download-card_wrapper rows">\n\n\t\t\t<!-- Custom -->\n\t\t\t<report-download-card agency-profile-id="formOptions.company.AgencyProfileID" can-regenerate-bacs="false" form-options="formOptions" ng-repeat="report in vm.combinedReports" pay-period="vm.reportPeriod" report="report" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\n\t\t</div>\n\n\t</fs-main>\n</form-state>\n\n<!-- Reports -->\n<form-state form-options="formOptions" fs-show-close="false" ng-if="pageState === \'report-downloads\'">\n\t<fs-main>\n\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tReports, including a supplementary FPS, and BACS file, if you\u2019re using one, have been generated for the supplementary pay run, and can be downloaded below.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Reports -->\n\t\t<div class="form-state-section report-download-card_wrapper rows">\n\n\t\t\t<!-- Classic -->\n\t\t\t<report-download-card agency-profile-id="formOptions.company.AgencyProfileID" can-regenerate-bacs="false" form-options="formOptions" ng-repeat="report in vm.classicReports" pay-period="vm.reportPeriod" report="report" show-created-date="true" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\n\t\t</div>\n\n\t\t<div class="form-state-section">\n\t\t\t<h5>Combined reports</h5>\n\t\t</div>\n\n\t\t<div class="form-state-section report-download-card_wrapper rows">\n\n\t\t\t<!-- Custom -->\n\t\t\t<report-download-card agency-profile-id="formOptions.company.AgencyProfileID" can-regenerate-bacs="false" form-options="formOptions" ng-repeat="report in vm.combinedReports" pay-period="vm.reportPeriod" report="report" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\n\t\t</div>\n\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Error submitting -->\n<form class="fadeIn" name="supplementaryPayRunRetryForm" ng-if="pageState === \'error-submitting\'" ng-submit="payrollSubmitSupplementaryPayment(vm, supplementaryPayRunRetryForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="There seems to be a problem submitting your pay run">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour pay run could not be submitted to HMRC for the below reasons. Review and fix any errors before clicking &lsquo;Try again&rsquo; to re-submit your pay run. Alternatively, you may wish to delete this one and start again with a new pay run.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section" ng-if="vm.supplementaryPayment.SupplementaryPaymentState === SUBMISSION_STATES.failed">\n\n\t\t\t\t<!-- FPS -->\n\t\t\t\t<div ng-switch="vm.supplementaryPayment.SupplementaryPaymentFPSState">\n\n\t\t\t\t\t<!-- Failed -->\n\t\t\t\t\t<div pc-switch-when="SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<message-block theme="positive-alt is-inline">\n\t\t\t\t\t\t\t<p><i class="icon-tick is-medium is-positive has-margin-right"></i>FPS file submitted successfully</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Submitted -->\n\t\t\t\t\t<div pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<message-block theme="assertive-alt is-inline">\n\t\t\t\t\t\t\t<p><i class="icon-cross is-medium is-assertive has-margin-right"></i>FPS file failed</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="spacer s"></div>\n\n\t\t\t\t<!-- EPS -->\n\t\t\t\t<div ng-switch="vm.supplementaryPayment.SupplementaryPaymentEPSState">\n\n\t\t\t\t\t<!-- Failed -->\n\t\t\t\t\t<div pc-switch-when="SUBMISSION_STATES.submitted">\n\t\t\t\t\t\t<message-block theme="positive-alt is-inline">\n\t\t\t\t\t\t\t<p><i class="icon-tick is-medium is-positive has-margin-right"></i>EPS file submitted successfully</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Submitted -->\n\t\t\t\t\t<div pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t\t\t\t<message-block theme="assertive-alt is-inline">\n\t\t\t\t\t\t\t<p><i class="icon-cross is-medium is-assertive has-margin-right"></i>EPS file failed</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<submission-logs agency-profile-id="vm.supplementaryPayment.AgencyProfileID" pay-period-id="vm.supplementaryPayment.AgencyPayPeriodID" submission-log-type="submissionLogType" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID">\n\t\t\t\t\t<submission-logs-dismissed-copy>\n\t\t\t\t\t\tAll submission errors have been dismissed. <br>If you\'re happy you\'ve fixed everything, click \'Try again\'.\n\t\t\t\t\t</submission-logs-dismissed-copy>\n\t\t\t\t</submission-logs>\n\t\t\t</div>\n\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\n\t\t<!-- Delete run - Available when EPS hasn\'t been submitted -->\n\t\t<button class="secondary-action" ng-click="setPageState(\'confirm-delete\')" ng-if="![SUBMISSION_STATES.submitted, SUBMISSION_STATES.failed].includes(vm.supplementaryPayment.SupplementaryPaymentEPSState)" type="button">\n\t\t\tDelete run\n\t\t</button>\n\n\t\t<!-- Go back - Available when EPS hasn\'t been submitted -->\n\t\t<button class="secondary-action" ng-click="setPageState(\'submission-summary\')" ng-if="![SUBMISSION_STATES.submitted, SUBMISSION_STATES.failed].includes(vm.supplementaryPayment.SupplementaryPaymentEPSState)" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<submit-button disable-button="!supplementaryPayRunRetryForm.$valid" display-text="\'Try again\'" state="supplementaryPayRunRetryForm.state"></submit-button>\n\t\t<button class="primary-action tertiary" ng-click="saveForLater()">\n\t\t\tSave for later\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Confirm Delete -->\n<form class="fadeIn" name="supplementaryPayRunConfirmDeleteForm" ng-if="pageState === \'confirm-delete\'" ng-submit="deleteSupplementaryPayment(vm, supplementaryPayRunConfirmDeleteForm)" novalidate>\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Are you sure you wish to delete this pay run?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis will delete the &lsquo;{{vm.supplementaryPayment.SupplementaryPaymentTitle}}&rsquo; pay run. This can\'t be undone and you will have to create it again if you decide you need\n\t\t\t\t\tit later.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="setPageState(\'review-reports\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<submit-button disable-button="!supplementaryPayRunConfirmDeleteForm.$valid" display-text="\'Confirm\'" state="supplementaryPayRunConfirmDeleteForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Already in progress -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="There is already a pending supplementary payment" ng-if="pageState === \'already-in-progress\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">\n\t\t\t\tA supplementary pay run has already been started. Only 1 supplementary pay run can be actioned at any one time. You can delete pending payments in the Supplementary Pay Runs area.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state-section" ng-if="vm.showLinkToSupplementaryPayRuns">\n\t\t\t<a class="is-small strong" ui-sref="payroll.history.supplementary-pay-runs({\n\t\t\t\t\tagencyProfileId: vm.agencyProfileId\n\t\t\t\t})">\n\t\t\t\tGo to Supplementary Pay Runs\n\t\t\t</a>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- No team members selected -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="No team members have been selected" ng-if="pageState === \'no-team-members-selected\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThere are no team members selected\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Team members omitted from RTI -->\n<form-state form-options="formOptions" fs-icon="information" fs-show-close="false" fs-title="{{ vm.excludedFromRti.length === 1 ? vm.teamMembers[0].Forename + \' is omitted from RTI submissions\' : \'The selected team members are omitted from RTI submissions\' }}" ng-if="pageState === \'excluded-from-rti\'">\n\t<fs-main>\n\n\t\t<!-- Single team member -->\n\t\t<p class="is-small" ng-if="vm.excludedFromRti.length === 1">\n\t\t\tPlease note that {{vm.teamMembers[0].Forename}} is omitted from RTI submissions so this supplementary pay run will be saved but not submitted.\n\t\t\tIt will be saved to your Supplementary pay runs area and {{vm.teamMembers[0].Forename}}\u2019s Year to Dates will be updated as normal.\n\t\t</p>\n\n\n\t\t<!-- Bulk update -->\n\t\t<p class="is-small" ng-if="vm.excludedFromRti.length > 1">\n\t\t\tPlease note that the team members you\u2019ve selected are omitted from RTI submissions so this supplementary pay run will be saved but not submitted.\n\t\t\tIt will be saved to your Supplementary pay runs area and their Year to Dates will be updated as normal.\n\t\t</p>\n\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="onTeamMemberOmittedContinue(vm)" type="button">\n\t\t\tContinue\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window" error-message="{{vm.errorMessage}}"></error-block>\n');
$templateCache.put('forms/payroll/tax-updates/tax-updates-confirmation.form.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form name="taxUpdatesForm" ng-if="pageState === PAGE_STATES.ready">\n\t<div class="form-intro">\n\t\t<p class="is-small strong">\n\t\t\tThere&nbsp;<ng-pluralize count="taxUpdates.LogEntries.length" when="{\'1\': \'is 1 update\', \'other\': \'are {} updates\'}"></ng-pluralize>.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="tax-update-cards">\n\t\t\t<tax-update-card ng-repeat="logEntry in taxUpdates.LogEntries" tax-update-log-entry="logEntry"></tax-update-card>\n\t\t</div>\n\t</fieldset>\n</form>\n\n<form class="fadeIn" name="taxUpdatesForm" ng-if="pageState === PAGE_STATES.readyForManualAccept" ng-submit="updateTeamMemberTaxList(taxUpdatesForm, teamMemberTaxList)" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tThere&nbsp;<ng-pluralize count="::teamMemberTaxList.length" when="{\'1\': \'is 1 update\', \'other\': \'are {} updates\'}"></ng-pluralize>&nbsp;available from HMRC.\n\t\t\tSwitch off any you don\u2019t wish to accept and give a reason for rejecting them. Click &lsquo;Accept updates&rsquo; once you\u2019re happy to continue.\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<p class="s strong"><ng-pluralize count="getAcceptedCount(teamMemberTaxList)" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>&nbsp;will be accepted.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="tax-update-confirmation-cards">\n\t\t\t<tax-update-confirmation-card enable-confirmation="true" index="$index" ng-repeat="teamMemberTax in teamMemberTaxList" team-member-tax="teamMemberTax"></tax-update-confirmation-card>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!taxUpdatesForm.$valid" display-text="\'Accept updates\'" state="taxUpdatesForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Querying payroll -->\n<loading-block ng-if="pageState === PAGE_STATES.queryingPayroll" position="after">\n\t<lb-description>\n\t\t<p class="is-small">\n\t\t\tChecking for tax updates\n\t\t</p>\n\t</lb-description>\n</loading-block>\n\n<!-- Problem with tax updates -->\n<form class="fadeIn" name="taxUpdatesFailedForm" ng-if="pageState === PAGE_STATES.queryPayrollFailed" ng-submit="checkForTaxUpdates()" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="{{failureInfoObj.title}}">\n\t\t<fs-main>\n\t\t\t<p class="is-small">{{failureInfoObj.message}}</p>\n\t\t\t<p class="is-small">\n\t\t\t\tFor more guidance\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.taxCodeUpdates" theme="is-tertiary is-strong" underline="true">read our troubleshooting guide to tax updates</support-article-link>\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Try again\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Update success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="primary" fs-title="Tax updates saved" ng-if="pageState === PAGE_STATES.taxUpdatesSaved">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYour tax updates have been saved and team members have been updated.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- No changes -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-theme="primary" fs-title="You\'re up to date" ng-if="pageState === PAGE_STATES.noTaxUpdates">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tIt looks like you already have the latest tax updates!\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Electronic updates not enabled -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="true" fs-theme="primary" fs-title="Enable electronic updates" ng-if="pageState === PAGE_STATES.electronicUpdatesNotEnabled">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tWe suggest enabling electronic updates from HMRC to automatically keep tax codes and student loan notices up to date.\n\t\t\tYou\u2019ll then be able to check for updates in here at any time.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Here\u2019s how to enable updates</support-article-link>\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Electronic updates enabled but company in test mode -->\n<form-state form-options="formOptions" fs-show-close="true" fs-theme="primary" fs-title="Tax updates aren\'t available in Test Mode" ng-if="pageState === PAGE_STATES.electronicUpdatesNotAvailableInTestMode">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tTax updates will not be applied while {{formOptions.company.Name}} are running in Test Mode.\n\t\t\tOnce they are switched to Live Mode then updates will be applied as they become available.\n\t\t\tIf you haven\u2019t already done so, you may wish to enable electronic updates from HMRC in your company settings\n\t\t\tto automatically keep tax codes and student loan notices up to date.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Here\u2019s how to enable updates</support-article-link>\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Electronic updates not available in pension only -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="This feature isn\'t currently available" ng-if="pageState === PAGE_STATES.electronicUpdatesNotAvailableInPensionOnly">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease note that you can\'t receive tax updates as the Payroll module isn\'t turned on in your company settings.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/tax-updates/tax-updates.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="taxUpdatesForm" ng-submit="checkForTaxUpates()" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-section" ng-if="vm.taxUpdateFailed">\n\t\t<info-block ib-theme="tertiary has-icon has-plain-type">\n\t\t\t<ib-header>\n\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t<i class="icon-warning tertiary info-block-icon"></i>\n\t\t\t\t\t<h6 class="stronger">There\u2019s a problem with tax updates</h6>\n\t\t\t\t</div>\n\t\t\t</ib-header>\n\t\t\t<ib-main>\n\t\t\t\t<p class="s greyscale-darkened">\n\t\t\t\t\tTax updates aren\u2019t currently being received by Paycircle so your data may not be up to date. To fix the problem,\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.taxCodeUpdates" underline="true" position="left">read our troubleshooting guide to tax updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<div class="form-section" ng-if="!vm.company.Employer.DPSImport">\n\t\t<info-block ib-theme="indifferent has-icon has-plain-type">\n\t\t\t<ib-header>\n\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t<i class="icon-support indifferent-darkened info-block-icon"></i>\n\t\t\t\t\t<h6 class="stronger">Enable electronic updates</h6>\n\t\t\t\t</div>\n\t\t\t</ib-header>\n\t\t\t<ib-main>\n\t\t\t\t<p class="s greyscale-darkened">\n\t\t\t\t\tWe suggest enabling electronic updates from HMRC to automatically keep tax codes and student loan notices up to date. You\u2019ll also be able to click the \u2018Check tax updates\u2019 button below to check for updates at any time.\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Here\u2019s how to enable updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<div class="form-intro-split">\n\t\t<div class="form-intro-split__content">\n\t\t\t<h4>{{vm.payPeriod.PayPeriodDisplay}}</h4>\n\t\t\t<p>\n\t\t\t\t<ng-pluralize count="vm.taxUpdates.NumberOfTaxChanges" when="{\'1\': \'1 update\', \'other\': \'{} updates\'}"></ng-pluralize>&nbsp;for this period <br>\n\t\t\t\t<em class="greyscale" ng-if="vm.taxUpdates.LastUpdateDateISO">Last updated at {{vm.taxUpdates.LastUpdateDateISO | dateformat:\'timeDate\'}}</em>\n\t\t\t\t<em class="greyscale" ng-if="!vm.taxUpdates.LastUpdateDateISO">No updates yet</em>\n\t\t\t</p>\n\t\t</div>\n\t\t<div>\n\t\t\t<submit-button display-text="\'Check tax updates\'" button-theme="\'primary form-intro-split__button\'" state="taxUpdatesForm.state" is-primary-action="false" disable-button="!vm.company.Employer.DPSImport"></submit-button>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-section">\n\t\t<div class="tax-update-cards">\n\t\t\t<tax-update-card ng-repeat="logEntry in vm.taxUpdates.LogEntries" tax-update-log-entry="logEntry" theme="$last ? \'is-last\' : \'\'"></tax-update-card>\n\t\t</div>\n\t</fieldset>\n\n</form>\n\n<!-- Submitting -->\n<section class="form-summary fadeIn" ng-if="pageState === \'checking\'">\n\t<loading-block size="l"></loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p>Checking for tax updates\u2026</p>\n\t</section>\n</section>\n\n<!-- Failed -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-show-close="false" fs-title="Tax updates couldn\u2019t be retrieved" ng-if="pageState === \'failed\'">\n\t<fs-main>\n\t\t<p class="s">There\u2019s seems to be a problem retrieving tax updates so your data couldn\u2019t be updated. We suggest waiting a few minutes and coming back to try again. If the problem persists,\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.taxCodeUpdates" theme="tertiary" underline="true">read our troubleshooting guide to tax updates</support-article-link>.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="primary-action tertiary" ng-click="checkForTaxUpates()">Try again</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/unmark-as-advancing/unmark-as-advancing.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="unmarkAsAdvancingForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="unmarkAsAdvancing(vm.unmarkAsAdvancingContext, unmarkAsAdvancingForm)" novalidate>\n\t<form-state class="fadeIn" form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you want to unmark {{vm.unmarkAsAdvancingContext.text}} as \u2018Advancing\u2019?">\n\t\t<fs-main>\n\t\t\t<p class="s">This will remove any additional payments that have been added to your current period for {{vm.unmarkAsAdvancingContext.text}}\n\t\t\t\tand they will be run through payroll as normal. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="unmarkAsAdvancingForm.$invalid" display-text="\'Confirm\'" state="unmarkAsAdvancingForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Complete -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="true" fs-title="Unmarked as \u2018Advancing\u2019" ng-if="pageState === PAGE_STATES.complete">\n\t<fs-main>\n\t\t<p class="s">{{utilities.toTitleCase(vm.unmarkAsAdvancingContext.text)}} {{vm.unmarkAsAdvancingContext.isBulk ? \'have\' : \'has\'}}\n\t\t\tbeen unmarked as &lsquo;Advancing&rsquo; and they can be run through payroll as normal.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/unmarkAsLeaver/unmarkAsLeaverForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="unmarkAsLeaverForm" ng-submit="payrollUpdateLeaveDateAndRegenerateP45(teamMember, unmarkAsLeaverForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="!teamMember.Company.IsLeaverManuallySet">\n\t\t<h4>Are you sure you want to unmark {{teamMember.Personal.Forename}} as a leaver?</h4>\n\t\t<p class="s">All details around leaving will be deleted and {{teamMember.Personal.Forename}} will be included in the next payoll.</p>\n\t</div>\n\n\t<form-state class="fadeIn" form-options="formOptions" fs-show-close="false" fs-icon="question-mark" fs-title="Are you sure?" ng-if="teamMember.Company.IsLeaverManuallySet">\n\t\t<fs-main>\n\t\t\t<p class="s">Once {{teamMember.Personal.Forename}} has been unmarked as a leaver, they will be added to your team members page. Click \'Unmark\' if you\'re happy to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Leave date in the past message -->\n\t<div class="form-content-block fadeIn" ng-if="!teamMember.Company.IsLeaverManuallySet">\n\t\t<note note-title="Updating Year to date figures" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">If you unmark {{teamMember.Personal.Forename}} as a leaver, you may wish to review their Year to date figures for the current tax year if you previously updated them after marking them as a leaver.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<!-- Close -->\n\t\t<a href="" ng-if="!formOptions.totalSteps" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="unmarkAsLeaverForm.state" disable-button="unmarkAsLeaverForm.$invalid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success feedback -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Unmarked as leaver" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="is-small">{{teamMember.Personal.Forename}} has been unmarked as a leaver<span ng-if="teamMember.Company.IsLeaverManuallySet">&nbsp;and moved to your Team members page</span>.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Company in rollback -->\n<form-state form-options="formOptions" fs-icon="warning" ng-if="pageState === \'company-in-rollback\'" fs-title="Payroll is currently in rollback">\n\t<fs-main>\n\t\t<p class="is-small">The payroll for {{formOptions.company.Name}} is currently in rollback and as {{teamMember.Personal.Forename}} has already been submitted as a leaver to HMRC when you ran the payroll, they will need to be submitted as a leaver when you run the payroll for this period again.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/updateGrossPay/update-gross-pay.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="updateGrossPayForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.ready" ng-submit="$ctrl.updateGrossPay($ctrl, updateGrossPayForm)" novalidate>\n\n\t<div class="form-field-highlight primary">\n\n\t\t<fieldset>\n\n\t\t\t<!-- Gross pay -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="grossPay" class="required">{{::$ctrl.teamMember.Salary.SalaryType === $ctrl.SALARY_TYPES.netPay ? \'Net pay\' : \'Salary\' }}:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="m" id="grossPay" name="grossPay" ng-class="{\n\t\t\t\t\t\t\t\'monetise\' : $ctrl.teamMember.Salary.CurrencyLabel === \'\'\n\t\t\t\t\t\t}" ng-max="$root.CONFIG.number7Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.grossPay" required type="number">\n\t\t\t\t\t<input class="xs-alt is-strong primary-light-flat" id="currencyLabel" name="currencyLabel" type="text" ng-if="$ctrl.formOptions.company.IsExpatActive && $ctrl.teamMember.Salary.CurrencyLabel !== \'\'" ng-model="$ctrl.teamMember.Salary.CurrencyLabel" readonly="readonly">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="updateGrossPayForm.grossPay.$error" ng-show="updateGrossPayForm.grossPay.$touched" role="alert">\n\t\t\t\t\t<p ng-message="min">Please enter a minimum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="max">Please enter a maximum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="required">Please enter a salary</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Numbers only, no symbols except a decimal point</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-gap">\n\n\t\t\t<!-- Apply to all pay periods -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input checkbox id="isSalaryOnlyForPeriod" label-text="\'Apply to all pay periods\'" name="isSalaryOnlyForPeriod" ng-false-value="true" ng-model="$ctrl.isSalaryOnlyForPeriod" ng-true-value="false" type="checkbox">\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">\n\t\t\t\t\tThis will update {{::$ctrl.formOptions.context.Forename}}\u2019s net pay for this period and will also save it as the new value in the pay information in their profile.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\n\t</div>\n\n\t<!-- If new starter and start date is after 1st day of current period pro rata calculation will apply -->\n\t<div class="form-section" ng-if="$ctrl.isProRatedApplicable">\n\t\t<div class="note">\n\t\t\t<p class="is-small">\n\t\t\t\tNote: if you\'re trying to update {{$ctrl.formOptions.context.Forename}}\'s salary because it looks incorrect, it may be because their start date is set to <strong>{{$ctrl.teamMember.Company.StartDateISO | dateformat}}</strong> and their pay is being pro-rated. Try setting their start date to the start of the current period in their profile. <a ui-sref="team.profile.overview({agencyProfileId: $ctrl.formOptions.agencyProfileId, userId: $ctrl.formOptions.context.UserID})">Go to their profile</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="!updateGrossPayForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="updateGrossPayForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Period Not Unsubmitted -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="You\'re unable to make changes at this time" ng-if="$ctrl.formState === $ctrl.FORM_STATES.notUnsubmitted">\n\t<fs-main>\n\t\t<p class="is-small">The {{::$ctrl.currentPayPeriod.PayPeriodDisplay}} period may still be processing. This can take a few minutes to complete so try again shortly.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Paid Hourly -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="{{::$ctrl.formOptions.context.Forename}} is on hourly pay" ng-if="$ctrl.formState === $ctrl.FORM_STATES.paidHourly">\n\t<fs-main>\n\t\t<p class="is-small">As {{::$ctrl.formOptions.context.Forename}} is on hourly pay, their salary cannot be updated. This is so the hours worked appear on their payslip correctly. Add an \'Hourly rate\' change for {{::$ctrl.formOptions.context.Forename}} by clicking \'Add a change\'.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Not available -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Unable to update salary for period" ng-if="$ctrl.formState === $ctrl.FORM_STATES.notAvailable">\n\t<fs-main>\n\t\t<p class="is-small">As {{::$ctrl.formOptions.context.Forename}} isn\'t paid using a salary, their salary cannot be updated. You will need to change {{::$ctrl.formOptions.context.Forename}}\'s Pay Information to be able to update their salary.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/updateLeaverStatus/updateLeaverStatusForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="updateLeaverStatusForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="updateLeaverInformation(teamMember, updateLeaverStatusForm)" novalidate>\n\t<!-- Previously submitted as leaver? -->\n\t<fieldset ng-if="teamMember.submitLeaverFormOptions.showPreviouslySubmittedAsLeaver">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="alreadySubmittedAsLeaver" ng-class="{ \'disabled\' : teamMember.Company.StartDateISO === \'\' }">Has {{teamMember.Personal.Forename}} previously been submitted as a leaver?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="alreadySubmittedAsLeaverTrue" name="alreadySubmittedAsLeaver" ng-change="onLeaverManuallySetChange(teamMember)" ng-disabled="teamMember.Company.StartDateISO === \'\'" ng-model="teamMember.Company.IsLeaverManuallySet" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="alreadySubmittedAsLeaverTrue" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="alreadySubmittedAsLeaverFalse" name="alreadySubmittedAsLeaver" ng-change="onLeaverManuallySetChange(teamMember)" ng-disabled="teamMember.Company.StartDateISO === \'\'" ng-model="teamMember.Company.IsLeaverManuallySet" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="alreadySubmittedAsLeaverFalse" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Leaver information -->\n\t<fieldset ng-if="teamMember.submitLeaverFormOptions.showLeaveInformation">\n\t\t<div class="form-field">\n\t\t\t<p class="is-small" ng-if="!teamMember.submitLeaverFormOptions.showP45Generation">Select a reason for leaving and enter a leave date.</p>\n\t\t\t<p class="is-small" ng-if="teamMember.submitLeaverFormOptions.showP45Generation">Select a reason for leaving and enter a leave\n\t\t\t\tdate, and decide if you wish to {{isP45OptionToRegenerate ? \'re\' : \'\'}}generate their P45, which will also be made available in their portal,\n\t\t\t\twhen you next run payroll.</p>\n\t\t</div>\n\n\t\t<!-- Leave reason -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="leavingReason" ng-class="{\'required\': !teamMember.Company.IsLeaverManuallySet}">Reason for leaving:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<select class="l-alt" id="leavingReason" name="leavingReason" ng-model="teamMember.Company.LeaveReason" ng-options="reason.id as reason.prompt for reason in LEAVING_REASONS" ng-required="!teamMember.Company.IsLeaverManuallySet">\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="updateLeaverStatusForm.leavingReason.$touched" ng-messages="updateLeaverStatusForm.leavingReason.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select a reason for leaving</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Notes -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="leavingNotes">Additional notes:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<textarea id="leavingNotes" maxlength="150" name="leavingNotes" ng-model="teamMember.Company.LeaveNote" placeholder="Enter a note..." rows="3" type="textarea"></textarea>\n\t\t\t</main>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="form-message">150 characters max</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Leave Date -->\n\t<fieldset ng-if="teamMember.submitLeaverFormOptions.showLeaveDate">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="leavedate" ng-class="{\'required\': !teamMember.Company.IsLeaverManuallySet}">Leave date:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<date-input-field field-value-iso="teamMember.Company.LeaveDateISO" field-max-date-iso="teamMember.Company.leaveDateISOMax" field-min-date-iso="teamMember.Company.leaveDateISOMin" field-id="leavedate" field-on-change="checkLeaveDate(teamMember, payPeriod)" field-required="!teamMember.Company.IsLeaverManuallySet">\n\t\t\t\t</date-input-field>\n\t\t\t</main>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="form-message" ng-if="!teamMember.Company.IsCISSubcontractor">\n\t\t\t\t\tPlease note: The leave date<span ng-if="teamMember.Company.leaveDateISOMin">&nbsp;cannot be before the start date ({{teamMember.Company.leaveDateISOMin | dateformat}})\n\t\t\t\t\tand</span>&nbsp;can be up to 3 months after the pay date ({{teamMember.Company.leaveDateISOMax | dateformat}}) for your current pay period.\n\t\t\t\t</p>\n\t\t\t\t<p class="form-message" ng-if="teamMember.Company.IsCISSubcontractor">\n\t\t\t\t\tPlease note: The leave can be up to 3 months after the pay date ({{teamMember.Company.leaveDateISOMax | dateformat}}) for your current pay period.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="updateLeaverStatusForm.leavedate.$touched" ng-messages="updateLeaverStatusForm.leavedate.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a leave date</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid leave date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="date">Please enter a valid leave date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="min">{{teamMember.Personal.Forename}}\'s leave date can\'t be before their start date ({{teamMember.Company.leaveDateISOMin | dateformat}})</p>\n\t\t\t\t<p ng-message="max">{{teamMember.Personal.Forename}}\'s leave date can\'t be later than {{teamMember.Company.leaveDateISOMax | dateformat}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- P45 [re]generation -->\n\t<!--\n\t\tHidden for:\n\t\t- All team members of LLPs\n\t\t- All team members of pension-only companies\n\t\t- All team members of CIS-only companies\n\t\t- CIS team members in mixed CIS and PAYE companies\n\t -->\n\n\t<fieldset class="fadeIn" ng-if="\n\t\tteamMember.submitLeaverFormOptions.showP45Generation &&\n\t\t(\n\t\t\t!teamMember.Company.IsLeaverManuallySet &&\n\t\t\t!(\n\t\t\t\t$root.currentCompany.IsLLP ||\n\t\t\t\t$root.currentCompany.PensionOnly ||\n\t\t\t\tteamMember.Company.IsCISSubcontractor\n\t\t\t)\n\t\t)\n\t">\n \t\t<!-- Generate P45? -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<!-- \'regenerate\' if this is an edit leave information operation, \'generate\' if this is a first-time submit as leaver operation -->\n\t\t\t\t<label for="noP45GenerationFalse">Do you wish to {{isP45OptionToRegenerate ? \'re\' : \'\'}}generate their P45?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="noP45GenerationFalse" name="noP45Generation" ng-model="teamMember.Company.noP45Generation" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="noP45GenerationFalse" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="noP45GenerationTrue" name="noP45Generation" ng-model="teamMember.Company.noP45Generation" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="noP45GenerationTrue" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t</fieldset>\n\n\t<fieldset ng-if="!teamMember.Company.IsLeaver">\n\t\t<div class="form-field fadeIn" ng-if="!teamMember.Company.IsLeaverManuallySet && teamMember.Company.isLeaveDateAfterEndDate">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">Submit {{::formOptions.context.Forename}} as a leaver?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="leaveSubmitLeaveDatePeriod" name="leaveSubmit" ng-model="teamMember.Company.LeaveSubmit" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="leaveSubmitLeaveDatePeriod" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">In the pay period the leave date falls in</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="leaveSubmitNextRunPeriod" name="leaveSubmit" ng-model="teamMember.Company.LeaveSubmit" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="leaveSubmitNextRunPeriod" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">The next time I run payroll</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Leave date in the past message -->\n\t\t<div class="form-content-block fadeIn" ng-if="teamMember.Company.isLeaveDateInPast">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Updating Year to date figures">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">As you\'ve added a leave date in the past for {{teamMember.Personal.Forename}}, you may wish to review {{teamMember.Personal.Gender | personalise:\'her\'}} Year\n\t\t\t\t\t\tto date figures for the current tax year and update them as required.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Leave date > last pay date -->\n\t\t<div class="form-content-block fadeIn" ng-if="teamMember.Company.isLeaveDateBeforeLastPayDate">\n\t\t\t<note note-dismiss="false" note-has-confirmation="true" note-id="tax-correction-confirmation" note-theme="tertiary is-form-field" note-title="I confirm I\'ve corrected {{teamMember.Personal.Forename}}\'s tax position">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">You\'ve entered a leave date earlier than the last time {{teamMember.Personal.Forename}} was paid. This payment may have needed to be a \'Payment After Leaving\'\n\t\t\t\t\t\twhich would impact their tax position. Please check the box above to confirm you have taken the necessary steps to identify and correct any issues which may arise\n\t\t\t\t\t\tfrom using the leave date entered before clicking \'Save\'.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Attachment of Earnings -->\n\t\t<div class="form-content-block fadeIn" ng-if="::aoe.totalAoeAmountRemaining > 0">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<p><strong>Please note:</strong> {{teamMember.Personal.Forename}} has Attachment of Earnings with an outstanding balance of {{aoe.totalAoeAmountRemaining | monetise}}.\n\t\t\t\t\tThe last payment will be taken when you run payroll for the period {{teamMember.Personal.Forename}} is leaving in and any orders will be cancelled.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-content-block" ng-if="teamMember.Company.HasFutureSMP">\n\t\t\t<div class="note tertiary">\n\t\t\t\t<h6 class="strong"><i class="icon-maternity tertiary"></i> Currently on maternity pay</h6>\n\t\t\t\t<p class="s">{{teamMember.Personal.Forename}} is currently on maternity pay and, if {{teamMember.Personal.Gender | personalise:\'he\'}} is leaving the company,\n\t\t\t\t\tyou may wish to end {{teamMember.Personal.Gender | personalise:\'his\'}} maternity payment schedule early. Otherwise the schedule will continue as normal\n\t\t\t\t\tafter {{teamMember.Personal.Gender | personalise:\'he\'}} has left and until it is paid in full.\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.updatingMaternitySchedule" theme="tertiary">Read more about updating a statutory maternity pay schedule</support-article-link>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">Back</a>\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()" ng-if="!formOptions.totalSteps">Cancel</a>\n\n\t\t<submit-button disable-button="updateLeaverStatusForm.$invalid" display-text="formOptions.primaryButtonText" state="updateLeaverStatusForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- No start date -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="{{teamMember.Personal.Forename}} doesn\u2019t have a start date" ng-if="pageState === PAGE_STATES.noStartDate">\n\t<fs-main>\n\t\t<p class="is-small">If {{teamMember.Personal.Forename}} hasn\u2019t previously been submitted as a leaver, you\u2019ll need to add a start date to\n\t\t\ttheir <a href="" class="primary underline" ng-click="openCompanyDetailsForm(teamMember)">company details</a> before marking them as a leaver. If {{teamMember.Personal.Forename}} has\n\t\t\tpreviously been submitted as a leaver click \u2018Continue\u2019 to add their leaver information.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">Cancel</button>\n\t\t<button class="primary-action tertiary" ng-click="setPageState(PAGE_STATES.ready)">Continue</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Already left -->\n<form-state form-options="formOptions" fs-icon="padlock" fs-title="{{teamMember.Personal.Forename}} has already left" ng-if="pageState === PAGE_STATES.alreadyLeft">\n\t<fs-main>\n\t\t<p class="is-small">When a person has already left the team {{teamMember.Personal.Gender | personalise:\'his\'}} leave status can\'t be changed.\n\t\t\t{{teamMember.Personal.Gender | personalise:\'he\' | capitalise}} will need to go through the rejoin process.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Company in rollback -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Payroll is currently in rollback" ng-if="pageState === PAGE_STATES.companyInRollback">\n\t<fs-main>\n\t\t<p class="is-small">The payroll for {{formOptions.company.Name}} is currently in rollback and as {{teamMember.Personal.Forename}} has already been submitted as\n\t\t\ta leaver to HMRC when you ran the payroll, they will need to be submitted as a leaver when you run the payroll for this period again.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Leave date invalid - Before last payment date -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Leave date is before last payment" ng-if="pageState === PAGE_STATES.leaveDateInvalid">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.Personal.Forename}}\'s leave date needs to be after the date {{teamMember.Personal.Gender | personalise:\'he\'}} was last\n\t\t\tpaid ({{payPeriod.LastPaySubmissionDateISO | dateformat}}).</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(PAGE_STATES.ready)">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Success feedback  - leave date updated -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Leaver information updated" ng-if="formOptions.forUpdate && pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.Personal.Forename}}\'s leaver information has been updated.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Success feedback - mark as leaving -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Marked as leaver" ng-if="!formOptions.forUpdate && pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s" ng-if="!teamMember.Company.IsLeaverManuallySet">\n\t\t\t{{teamMember.Personal.Forename}} has been marked as a leaver.\n\t\t\t<span ng-if="!teamMember.Company.IsCISSubcontractor">You may wish to review {{teamMember.Personal.Forename}}\'s year to date figures for the current tax year and update them as required.</span>\n\t\t</p>\n\t\t<p class="s" ng-if="teamMember.Company.IsLeaverManuallySet">\n\t\t\t{{teamMember.Personal.Forename}} has been marked as a leaver and moved to your Leavers page.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/view-changes/view-changes.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="form-content-block fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="form-content-block" ng-if="!formOptions.userId">\n\t\t<div class="info-block primary align-center">\n\t\t\t<h4>{{::currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t</div>\n\t</div>\n\n\t<!-- Adjustments List -->\n\t<div class="team-adjustments-list" ng-if="teamMembers.length && teamMember.Adjustments.length" ng-repeat="teamMember in teamMembers | orderBy:\'UserForename\'">\n\n\t\t<h6 class="team-member-name" ng-if="showTeamMemberNames">\n\t\t\t{{teamMember.UserForename}} {{teamMember.UserSurname}}\n\t\t</h6>\n\n \t\t<!-- Team Member Adjustments -->\n\t\t<adjustments-list adjustment-detail-summary="teamMember" agency-profile-id="{{agencyProfileId}}" callback="refreshTeamMembers" can-update="$root.currentUser.Permissions.Payroll.canUpdateAdjustments && currentPayPeriod.ApprovalDateISO === \'\'" form-options="formOptions" pay-period="currentPayPeriod" theme="is-block" user-id="{{teamMember.UserID}}"></adjustments-list>\n\t</div>\n\n\t<!-- No Adjustments -->\n\t<placeholder ng-if="!teamMembers.length" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t<!-- Company -->\n\t\t<placeholder-title ng-if="!formOptions.userId">\n\t\t\tNo changes have been made for {{formOptions.company.Name}}\n\t\t</placeholder-title>\n\n\t\t<!-- Team member -->\n\t\t<placeholder-title ng-if="formOptions.userId">\n\t\t\tNo changes have been made for {{::currentPayPeriod.PayPeriodDisplay}}\n\t\t</placeholder-title>\n\n\t\t<placeholder-copy>\n\t\t\t<p>Start adding changes and they will start to appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\t<!-- Actions -->\n\t<div class="form-actions" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t<button class="is-primary primary-action" ng-click="openAddAChangeFormOptions()" type="button">\n\t\t\tAdd change\n\t\t</button>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/personal/address/address.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addressForm" ng-if="pageState === \'ready\'" ng-submit="updateTeamMemberAddresses(teamMember, addressForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4 ng-if="!teamMember.AddressSetupComplete">\n\t\t\tAdd an address for {{formOptions.context.Forename}}\n\t\t</h4>\n\t\t<h4 ng-if="teamMember.AddressSetupComplete">\n\t\t\tUpdate {{formOptions.context.Forename}}\'s address\n\t\t</h4>\n\t</div>\n\n\t<!-- Skip address - Only applicable to CIS Subcontractors -->\n\t<fieldset ng-if="teamMember.Company.IsCISSubcontractor">\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="hasAddressToggle" label-text="\'I don\\\'t have an address for \' + formOptions.context.Forename + \' at the moment\'" name="hasAddressToggle" ng-change="onUpdateIsAddressSkipped(teamMember)" ng-model="teamMember.isAddressSkipped" type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-class="fadeIn" ng-if="!teamMember.isAddressSkipped">\n\n\t\t<fieldset>\n\n\t\t\t<!-- UK / Non UK -->\n\t\t\t<div class="form-field">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPaycircle supports UK and non-UK addresses, but if you operate a workplace pension all enrolled team members will need a UK address for correspondence.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="radio-cards-list-split">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isUKAddressTrue" name="addressType" ng-change="onUpdateIsUkAddress(teamMember)" ng-model="teamMember.isUKAddress" ng-value="true" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isUKAddressTrue">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\t\tUK address\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div><!-- Eliminate whitespace between inline elements.\n\t\t\t\t --><div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="isUKAddressFalse" name="addressType" ng-change="onUpdateIsUkAddress(teamMember)" ng-model="teamMember.isUKAddress" ng-value="false" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="isUKAddressFalse">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\t\tNon-UK address\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Address lookups - one for UK address, another for foreign address input -->\n\t\t\t<div class="form-field">\n\t\t\t\t<address-lookup address="teamMember.Address" id="ukAddressLookup" is-required="true" is-uk-only="true" ng-if="teamMember.isUKAddress">\n\t\t\t\t</address-lookup>\n\t\t\t\t<address-lookup address="teamMember.ForeignAddress" id="foreignAddressLookup" is-required="true" manual-entry-only="true" ng-if="!teamMember.isUKAddress">\n\t\t\t\t</address-lookup>\n\t\t\t</div>\n\t\t</fieldset>\n\n\n\t\t<!-- UK Correspondance address -->\n\t\t<fieldset class="form-fieldset-divider-top fadeIn" ng-if="!teamMember.isUKAddress">\n\n\t\t\t<fieldset ng-if="!teamMember.isUKAddress && !teamMember.HasUKAddress">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<h6>\n\t\t\t\t\t\t<i class="icon-information primary m"></i>&nbsp;&nbsp;A UK correspondence address may be required\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThis can be added now or at a later date, but is required for all enrolled team members in order to run Payroll.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<button class="is-medium-large is-white is-block" data-cy="address-add-a-uk-address" ng-click="addUKAddress(teamMember)" type="button">\n\t\t\t\t\t\t<i class="icon-add button_icon-pre"></i>Add a UK address\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- UK correspondence address lookup. -->\n\t\t\t<fieldset ng-if="teamMember.HasUKAddress">\n\t\t\t\t<div class="form-intro form-intro--with-link">\n\t\t\t\t\t<h4>UK correspondence address</h4>\n\t\t\t\t\t<a class="s greyscale" data-cy="address-remove-uk-address" href="" ng-click="removeUKAddress(teamMember)">\n\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;Delete\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<address-lookup address="teamMember.Address" id="ukCorrespondenceAddress" is-uk-only="true"></address-lookup>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="addressForm.state === \'saved\'" state="addressForm.state">\n\t\t\t<p>{{formOptions.context.Forename}}\'s address has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" ng-if="!formOptions.totalSteps" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="addressForm.$invalid" display-text="formOptions.primaryButtonText" state="addressForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<button class="tertiary-action" data-cy="tertiary-action" ng-click="formOptions.skip()" ng-if="formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/personal/email/emailForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="emailAddressForm" class="fadeIn" ng-submit="updateUserContactEmail(teamMember, emailAddressForm)" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Personal Email -->\n\t\t<div class="form-field">\n\t\t\t<label for="email" ng-class="{\'required\': !teamMember.Personal.DummyEmail, \'disabled\': teamMember.Personal.DummyEmail}">Primary email address</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="email" id="emailPrimary" name="emailPrimary" ng-model="teamMember.Personal.Email" ng-model-options="{ debounce: 500 }" ng-disabled="teamMember.Personal.DummyEmail" ng-required="!teamMember.Personal.DummyEmail">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="emailAddressForm.emailPrimary.$error" ng-show="emailAddressForm.emailPrimary.$touched" role="alert">\n\t\t\t\t<p data-cy="email-email-validation-message-required" ng-message="required">Please enter an email address</p>\n\t\t\t\t<p data-cy="email-email-validation-message-email" ng-message="email">Please make sure the email is valid</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No Email -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="dummyEmail" name="dummyEmail" ng-model="teamMember.Personal.DummyEmail" ng-change="usingDummyEmail(emailAddressForm)" label-text="formOptions.context.Forename + \' doesn\\\'t have an email address\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Printable Payslips -->\n\t\t<div class="form-content-block">\n\t\t\t<div class="note fadeIn" ng-if="teamMember.Personal.DummyEmail">\n\t\t\t\t<h6>Printable payslips</h6>\n\t\t\t\t<p>Any team members that do not have an email address will need their payslips printed and given to them by hand. We\'ve made this simple by providing a download for all those team members without emails, available once you\'ve approved payroll.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" ng-if="!formOptions.canGoBack" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="emailAddressForm.state" disable-button="!emailAddressForm.$valid"></submit-button>\n\n\t\t<button class="tertiary-action" data-cy="tertiary-action" ng-click="onFormSkip()" ng-if="formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/personal/finished/addTeamMemberFinishedForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Personal -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Personal information saved" ng-if="formView === \'personal\'" fs-show-close="false">\n\t<fs-main>\n\t\t<feature-sentiment customer-name="formOptions.company.Name" data-cy="feature-sentiment-new-employee" feature="adding a new team member" ng-if="formOptions.wizardKey === FORM_WIZARD_KEYS.teamMemberAdd" product="Paycircle" user-id="$root.currentUser.UserResponseContactEmail">\n\t\t</feature-sentiment>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">{{teamMember.Forename}}\u2019s personal information has been saved and you can add and edit information from {{teamMember.Forename}}\u2019s profile page whenever you need to. <span ng-if="hasPension && formOptions.company.State !== COMPANY_STATES.onboarding">Click the link below to move on and start adding Employment information for {{teamMember.Forename}}.</span></p>\n\t\t</div>\n\t\t<div class="form-state-section" ng-if="formOptions.company.State !== COMPANY_STATES.onboarding">\n\t\t\t<a href="" class="link-card quarternary" ng-click="openNewFormWizard(FORM_WIZARD_KEYS.teamMemberEditEmployment)" data-cy="add-employment-information">\n\t\t\t\t<span class="link-card__icon">\n\t\t\t\t\t<i class="icon-company"></i>\n\t\t\t\t</span>\n\t\t\t\t<span class="link-card__title">\n\t\t\t\t\t<h6>Add employment information</h6>\n\t\t\t\t</span>\n\t\t\t\t<span class="link-card__arrow">\n\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t</span>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<hr class="l">\n\t\t\t<p class="stronger s">Want to continue adding team members?</p>\n\t\t\t<p class="stronger s">\n\t\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Employment -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Employment information saved" ng-if="formView === \'employment\'" fs-show-close="false">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="s">{{teamMember.Forename}}\u2019s employment information has been saved and you can add and edit information from {{teamMember.Forename}}\u2019s profile page whenever you need to. <span ng-if="hasPension && formOptions.company.State !== COMPANY_STATES.onboarding">Click the link below to move on and start adding Workplace Pension information for {{teamMember.Forename}}.</span></p>\n\t\t</div>\n\t\t<div class="form-state-section" ng-if="hasPension && formOptions.company.State !== COMPANY_STATES.onboarding && !teamMember.IsOffPayrollWorker">\n\t\t\t<a href="" class="link-card secondary" data-cy="add-pension-information" ng-click="openNewFormWizard(FORM_WIZARD_KEYS.teamMemberEditAEPension)">\n\t\t\t\t<div class="link-card__icon">\n\t\t\t\t\t<i class="icon-money"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="link-card__title">\n\t\t\t\t\t<h6>Add workplace pension information</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="link-card__arrow">\n\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t</div>\n\t\t\t</a>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<hr class="l">\n\t\t\t<p class="stronger s">Want to continue adding team members?</p>\n\t\t\t<p class="stronger s">\n\t\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- AE Pension -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Workplace pension information saved" ng-if="formView === \'ae-pension\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{teamMember.Forename}}\'s workplace pension information has been saved and you can add and edit information from {{teamMember.Forename}}\'s profile page whenever you need to.</p>\n\t\t<div class="spacer l"></div>\n\t\t<hr>\n\t\t<div class="spacer l"></div>\n\t\t<p class="stronger s">\n\t\t\tWant to continue adding team members?\n\t\t</p>\n\t\t<p class="stronger s">\n\t\t\t</p><p class="stronger s">\n\t\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t<p></p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Non-AE Pension -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Pension information saved" ng-if="formView === \'non-ae-pension\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="is-small">{{teamMember.Forename}}\'s pension information has been saved and you can add and edit information from {{teamMember.Forename}}\'s profile page whenever you need to.</p>\n\t\t<div class="spacer l"></div>\n\t\t<hr>\n\t\t<div class="spacer l"></div>\n\t\t<p class="stronger s">\n\t\t\tWant to continue adding team members?\n\t\t</p>\n\t\t<p class="stronger s">\n\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- CIS Personal -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Personal information saved" ng-if="formView === \'personal-cis\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename + \' \' + formOptions.context.Surname}}\u2019s personal information has been saved and you can add and edit information from {{formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename + \' \' + formOptions.context.Surname}}\u2019s profile page whenever you need to. Click the link below to move on and start adding CIS information for {{teamMember.Forename}}.</p>\n\t\t<div class="spacer l"></div>\n\t\t<a href="" class="link-card quarternary" ng-click="openNewFormWizard(FORM_WIZARD_KEYS.cisSubcontractor)" data-cy="add-cis-information">\n\t\t\t<div class="link-card__icon">\n\t\t\t\t<i class="icon-company"></i>\n\t\t\t</div>\n\t\t\t<div class="link-card__title">\n\t\t\t\t<h6>Add CIS information</h6>\n\t\t\t</div>\n\t\t\t<div class="link-card__arrow">\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</div>\n\t\t</a>\n\t\t<div class="spacer l"></div>\n\t\t<hr>\n\t\t<div class="spacer l"></div>\n\t\t<p class="stronger s">\n\t\t\tWant to continue adding team members?\n\t\t</p>\n\t\t<p class="stronger s">\n\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- CIS Company -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Company information saved" ng-if="formView === \'cis-company\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename + \' \' + formOptions.context.Surname}}\u2019s company information has been saved and you can add and edit information from {{formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename + \' \' + formOptions.context.Surname}}\u2019s profile page whenever you need to.</p>\n\t\t<div class="spacer l"></div>\n\t\t<a href="" class="link-card quarternary" ng-click="openCISVerificationForm()" data-cy="add-cis-information">\n\t\t\t<div class="link-card__icon">\n\t\t\t\t<i class="icon-company"></i>\n\t\t\t</div>\n\t\t\t<div class="link-card__title">\n\t\t\t\t<h6>Add CIS information</h6>\n\t\t\t</div>\n\t\t\t<div class="link-card__arrow">\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</div>\n\t\t</a>\n\t\t<div class="spacer l"></div>\n\t\t<hr>\n\t\t<div class="spacer l"></div>\n\t\t<p class="stronger s">\n\t\t\tWant to continue adding team members?\n\t\t</p>\n\t\t<p class="stronger s">\n\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- CIS Subcontractor -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="CIS information saved" ng-if="formView === \'cis-subcontractor\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">{{formOptions.context.isCompany ? formOptions.context.BusinessDetails.TradingName : formOptions.context.Forename}}\'s CIS information has been saved and you can view and edit it in their profile whenever you need to.</p>\n\t\t<div class="spacer l"></div>\n\t\t<hr>\n\t\t<div class="spacer l"></div>\n\t\t<p class="stronger s">\n\t\t\tWant to continue adding team members?\n\t\t</p>\n\t\t<p class="stronger s">\n\t\t\t<a data-cy="add-another-team-member" href="" ng-click="openAddTeamMemberWizard()">\n\t\t\t\t<i class="icon-right m"></i>&nbsp;&nbsp;Add another team member\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeWizard()">\n\t\t\tClose\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeWizard()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/personal/passport/passport.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="passportForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateTeamMemberPassportInformation(passportForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tYou may have passport details for {{$ctrl.formOptions.context.Forename}} if, for example,\n\t\t\tyou&apos;ve carried out right to work checks for them. Add and save them below so you can reference them later.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Passport number -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="passportNumber">Passport Number:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="passportNumber" maxlength="9" minlength="9" name="passportNumber" ng-model="$ctrl.teamMember.Personal.PassportNumber" ng-pattern="$root.REGEX.passport" placeholder="123456789" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="passportForm.passportNumber.$touched" ng-messages="passportForm.passportNumber.$error" role="alert">\n\t\t\t\t<p ng-message="minlength || maxlength">Please enter a valid 9 digit number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid passport number</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">Enter a 9 digit number (E.g. 123456789)</p>\n\t\t</div>\n\n\t\t<!-- Passport expiry date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="passportExpiry">Passport expiry date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="passportExpiry" field-required="false" field-style="l" field-value-iso="$ctrl.teamMember.Personal.PassportExpiryDateISO"></date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="passportForm.passportExpiry.$touched" ng-messages="passportForm.passportExpiry.$error" role="alert">\n\t\t\t\t<p ng-message="date">Please enter a valid passport expiry date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Is EU Citizen -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="euCitizen" name="euCitizen" ng-model="$ctrl.teamMember.Personal.EUCitizen" label-text="$ctrl.formOptions.context.Forename + \' is an EU Citizen\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Nationality -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="nationality">Nationality:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="l" id="nationality" name="nationality" ng-model="$ctrl.teamMember.Personal.Nationality" ng-options="nationality for nationality in $ctrl.NATIONALITIES">\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Visa Number -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="visaNumber">Visa Number:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="visaNumber" name="visaNumber" ng-model="$ctrl.teamMember.Personal.VisaNumber" ng-pattern="$root.REGEX.lettersAndNumbers" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="passportForm.visaNumber.$touched" ng-messages="passportForm.visaNumber.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Visa number must only include letters and numbers</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Visa expiry date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="visaExpiryDateISO">Visa expiry date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="visaExpiryDateISO" field-required="false" field-style="l" field-value-iso="$ctrl.teamMember.Personal.VisaExpiryDateISO"></date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="passportForm.visaExpiryDateISO.$touched" ng-messages="passportForm.visaExpiryDateISO.$error" role="alert">\n\t\t\t\t<p ng-message="date">Please enter a valid expiry expiry date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Arrival in the UK -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="ukArrivalDateISO">Arrival in UK date:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="ukArrivalDateISO" field-required="false" field-style="l" field-value-iso="$ctrl.teamMember.Personal.UKArrivalDateISO"></date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="passportForm.ukArrivalDateISO.$touched" ng-messages="passportForm.ukArrivalDateISO.$error" role="alert">\n\t\t\t\t<p ng-message="date">Please enter a valid UK arrival date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="passportForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="passportForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Delete -->\n<form class="fadeIn" name="deletePassportInformationForm" ng-if="$ctrl.formState === \'delete-information\'" ng-submit="$ctrl.onDeletePassportInformation(deletePassportInformationForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you want to delete this?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYou can add Passport and Visa details to {{$ctrl.formOptions.context.Forename}}\'s profile later if you need to.\n\t\t\t</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Delete\'" state="deletePassportInformationForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()">\n</error-block>\n');
$templateCache.put('forms/personal/payment-details/payment-details.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="bankForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateTeamMemberBank($ctrl, bankForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Add payment details to pay {{$ctrl.teamMember.nameToUse}}</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- No bank details? -->\n\t\t<div class="form-field">\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="noAccountDetails" label-text="$ctrl.teamMember.nameToUse + \' doesn\\\'t have any account details\'" ng-change="$ctrl.updateBankDetails($ctrl.teamMember)" ng-model="$ctrl.teamMember.Bank.noAccountDetails" type="checkbox" checkbox>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Account Type -->\n\t\t<div class="form-field">\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="bankTypeBank" name="bankType" ng-disabled="$ctrl.teamMember.Bank.noAccountDetails" ng-model="$ctrl.teamMember.Bank.bankType" ng-value="\'bank\'" type="radio" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="bankTypeBank">\n\t\t\t\t\t\t\t<i class="icon-bank radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Bank</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="bankTypeBuildingSociety" name="bankType" ng-disabled="$ctrl.teamMember.Bank.noAccountDetails" ng-model="$ctrl.teamMember.Bank.bankType" ng-value="\'building-society\'" type="radio" required>\n\t\t\t\t\t\t\t<label class="radio-card-label" for="bankTypeBuildingSociety">\n\t\t\t\t\t\t\t<i class="icon-building-society radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Building Society</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Has bank details -->\n\t<fieldset class="fadeIn" ng-if="!$ctrl.teamMember.Bank.noAccountDetails">\n\n\t\t<!-- Building Society -->\n\t\t<div class="form-field" ng-if="$ctrl.teamMember.Bank.bankType === \'building-society\'">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="buildingsocietyref" class="required" ng-class="{\'required\': !$ctrl.teamMember.Bank.noAccountDetails, \'disabled\': $ctrl.teamMember.Bank.noAccountDetails}">\n\t\t\t\t\tReference Number\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="xl" id="buildingsocietyref" maxlength="30" name="buildingsocietyref" ng-disabled="$ctrl.teamMember.Bank.noAccountDetails" ng-model="$ctrl.teamMember.Bank.BuildingSocietyReference" ng-pattern="$root.REGEX.lettersAndNumbers" ng-required="!$ctrl.teamMember.Bank.noAccountDetails" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors" ng-if="bankForm.buildingsocietyref.$touched" role="alert" ng-messages="bankForm.buildingsocietyref.$error">\n\t\t\t\t<p data-cy="payment-details-building-society-reference-validation-required-message" ng-message="required">\n\t\t\t\t</p><p data-cy="payment-buildingsocietyref-validation-message-required" ng-message="required">Please enter a building society reference</p>\n\t\t\t\t<p data-cy="payment-buildingsocietyref-validation-message-pattern" ng-message="pattern">Please enter numbers and letters only</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Account Number -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bankaccountnumber" ng-class="{\'required\': !$ctrl.teamMember.Bank.noAccountDetails, \'disabled\': $ctrl.teamMember.Bank.noAccountDetails}">\n\t\t\t\t\t\tAccount number:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l-alt" id="bankaccountnumber" maxlength="8" name="bankaccountnumber" ng-disabled="$ctrl.teamMember.Bank.noAccountDetails" ng-maxlength="8" ng-minlength="8" ng-model="$ctrl.teamMember.Bank.BankAccountNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="!$ctrl.teamMember.Bank.noAccountDetails" placeholder="12345678" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="bankForm.bankaccountnumber.$touched" ng-messages="bankForm.bankaccountnumber.$error" role="alert">\n\t\t\t\t\t<p data-cy="payment-bankaccountnumber-validation-message-required" ng-message="required">Please enter a bank account number</p>\n\t\t\t\t\t<p data-cy="payment-bankaccountnumber-validation-message-length" ng-message="minlength || maxlength">Account number should be 8 digits</p>\n\t\t\t\t\t<p data-cy="payment-bankaccountnumber-validation-message-pattern" ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Sort code -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="bankSortCode" ng-class="{\'required\': !$ctrl.teamMember.Bank.noAccountDetails, \'disabled\': $ctrl.teamMember.Bank.noAccountDetails}">Sort code:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<sort-code sort-code-disabled="$ctrl.teamMember.Bank.noAccountDetails" sort-code-name="sortCode" sort-code-required="!$ctrl.teamMember.Bank.noAccountDetails" sort-code="$ctrl.teamMember.Bank.SortCode"></sort-code>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="bankForm.sortCode.$touched" ng-messages="bankForm.sortCode.$error" role="alert">\n\t\t\t\t\t<p data-cy="payment-sortcode-validation-message-required" ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t<p data-cy="payment-sortcode-validation-message-sortcode" ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Account holder name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="bankAccountName">Account holder name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="bankAccountName" name="bankAccountName" ng-disabled="$ctrl.teamMember.Bank.noAccountDetails" ng-model="$ctrl.teamMember.Bank.BankAccountName" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- IBAN -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="bankIBAN" ng-class="{\n\t\t\t\t\t\t\'required\': $ctrl.teamMember.Bank.isPaymentInCurrency\n\t\t\t\t\t}">\n\t\t\t\t\tIBAN:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="block" id="bankIBAN" maxlength="50" name="bankIBAN" ng-model="$ctrl.teamMember.Bank.BankIBAN" ng-required="$ctrl.teamMember.Bank.isPaymentInCurrency" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="bankForm.bankIBAN.$touched" ng-messages="bankForm.bankIBAN.$error" role="alert">\n\t\t\t\t<p data-cy="payment-iban-validation-message-required" ng-message="required">Please enter an IBAN</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- BIC -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="bankBIC">\n\t\t\t\t\tBIC:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="bankBIC" name="bankBIC" ng-model="$ctrl.teamMember.Bank.BankBIC" ng-pattern="$root.REGEX.bic" type="text">\n\t\t\t\t<input checkbox class="form-field-main_inline-field" id="isPaymentInCurrency" label-text="\'Pay in currency\'" name="isPaymentInCurrency" ng-if="$ctrl.currencies && $ctrl.currencies.length > 0" ng-model="$ctrl.teamMember.Bank.isPaymentInCurrency" type="checkbox">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="bankForm.bankBIC.$touched" ng-messages="bankForm.bankBIC.$error" role="alert">\n\t\t\t\t<p data-cy="payment-bankbic-validation-message-pattern" ng-message="pattern">Please enter a valid BIC</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Currency -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.teamMember.Bank.isPaymentInCurrency && $ctrl.currencies.length > 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="currencyId">\n\t\t\t\t\tCurrency:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="l" id="currencyId" name="currencyId" ng-model="$ctrl.teamMember.Bank.selectedCurrency" ng-options="currency as currency.CurrencyLabel for currency in $ctrl.currencies" required>\n\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\tPlease select...\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="bankForm.currencyId.$touched" ng-messages="bankForm.currencyId.$error" role="alert">\n\t\t\t\t<p data-cy="payment-currency-validation-message-required" ng-message="required">Please select an option</p>\n\t\t\t</div>\n\t\t\t<p data-cy="payment-details-currency-id-message" class="form-message fadeIn" ng-if="$ctrl.teamMember.Bank.selectedCurrency">\xA3 to {{$ctrl.teamMember.Bank.selectedCurrency.CurrencyLabel}} exchange rate: {{$ctrl.teamMember.Bank.selectedCurrency.CurrencyValue}}</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<form-feedback ng-if="bankForm.state === \'saved\'" state="bankForm.state">\n\t\t\t<p>{{$ctrl.teamMember.nameToUse}}\'s bank details have been saved.</p>\n\t\t</form-feedback>\n\n\t\t<button data-cy="secondary-action-back" type="button" class="secondary-action" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack">\n\t\t\tBack\n\t\t</button>\n\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="$ctrl.formOptions.closeForm()" ng-if="!$ctrl.formOptions.totalSteps" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="bankForm.state" disable-button="bankForm.$invalid"></submit-button>\n\n\t\t<button class="tertiary-action" data-cy="tertiary-action" ng-click="$ctrl.formOptions.skip()" ng-if="$ctrl.formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/personal/personal/personal.form.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Select scheme (when IsCISActive (&& !CISOnly)) or IsOffPayrollActive, or both -->\n<form class="fadeIn" name="personalSetupForm" ng-if="pageState === \'select-scheme\'" ng-submit="reviewTeamMember(teamMember, personalSetupForm)" novalidate>\n\n\t<fieldset>\n\n\t\t<!--\n\t\t\tScheme Type. For CIS active (and not CIS-only), or Off-payroll active companies. CIS option is shown for IsCISActive companies, Off-payroll option\n\t\t\tis shown for IsOffPayrollActive companies. One or other or both will be available depending on these settings\n\t\t-->\n\t\t<div class="form-field" ng-if="(\n\t\t\t\t\tformOptions.company.IsCISActive &&\n\t\t\t\t\t!formOptions.company.CISOnly\n\t\t\t\t) ||\n\t\t\t\tformOptions.company.IsOffPayrollActive\n\t\t\t">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="schemePAYE">Which scheme would you like to add them to?</label>\n\t\t\t\t<p class="s">Team members can only be paid through one type of employment scheme</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="schemePAYE" name="schemeType" ng-change="updateTeamMemberScheme(SCHEME_TYPES.paye, teamMember)" ng-disabled="teamMember.userContext === \'existing-user\'" ng-model="teamMember.Company.schemeType" ng-value="SCHEME_TYPES.paye" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="schemePAYE">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">PAYE</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Only show the CIS option if IsCISActive is set -->\n\t\t\t\t\t<div class="radio-row" ng-if="formOptions.company.IsCISActive">\n\t\t\t\t\t\t<input class="b radio-row-input" id="schemeCIS" name="schemeType" ng-change="updateTeamMemberScheme(SCHEME_TYPES.cis, teamMember)" ng-disabled="teamMember.userContext === \'existing-user\'" ng-model="teamMember.Company.schemeType" ng-value="SCHEME_TYPES.cis" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="schemeCIS">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">CIS</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Off-payroll -->\n\t\t\t\t\t<div class="radio-row" ng-if="formOptions.company.IsOffPayrollActive">\n\t\t\t\t\t\t<input class="b radio-row-input" id="schemeOffPayroll" name="schemeType" ng-change="updateTeamMemberScheme(SCHEME_TYPES.offPayroll, teamMember)" ng-disabled="teamMember.userContext === \'existing-user\'" ng-model="teamMember.Company.schemeType" ng-value="SCHEME_TYPES.offPayroll" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="schemeOffPayroll">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Off-payroll</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Business Type -->\n\t\t<div class="form-field fadeIn" ng-if="teamMember.Company.IsCISSubcontractor">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">What type of business do they run?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="businessTypeSoleTrader" name="businessType" ng-model="teamMember.CIS.BusinessDetails.BusinessType" ng-value="BUSINESS_TYPES.soletrader" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypeSoleTrader">\n\t\t\t\t\t\t\t<i class="icon-user radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Sole trader</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="businessTypePartnership" name="businessType" ng-model="teamMember.CIS.BusinessDetails.BusinessType" ng-value="BUSINESS_TYPES.partnership" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypePartnership">\n\t\t\t\t\t\t\t<i class="icon-team-alt radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Partnership</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="businessTypeLimited" name="businessType" ng-model="teamMember.CIS.BusinessDetails.BusinessType" ng-value="BUSINESS_TYPES.company" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypeLimited">\n\t\t\t\t\t\t\t<i class="icon-company radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Limited company</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="businessTypeTrust" name="businessType" ng-model="teamMember.CIS.BusinessDetails.BusinessType" ng-value="BUSINESS_TYPES.trust" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="businessTypeTrust">\n\t\t\t\t\t\t\t<i class="icon-rosette radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Trust</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<button data-cy="secondary-action" class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Review user -->\n\t\t<button data-cy="primary-action" class="tertiary primary-action" ng-disabled="personalSetupForm.$invalid" type="submit">\n\t\t\tNext\n\t\t</button>\n\t</fieldset>\n</form>\n\n<!-- Personal details -->\n<form class="fadeIn" name="personalForm" ng-if="pageState === \'personal\'" ng-submit="reviewTeamMember(teamMember, personalForm)" novalidate>\n\n\t<!-- Personal -->\n\t<fieldset>\n\n\t\t<!-- Title -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="title">Title:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="l" id="title" name="title" ng-change="reviewTitleSelection(teamMember)" ng-model="teamMember.Personal.Title" ng-options="salutation for salutation in SALUTATIONS" required>\n\t\t\t\t\t<option value="">Select title...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.title.$touched" ng-messages="personalForm.title.$error" role="alert">\n\t\t\t\t<p data-cy="personal-title-validation-message-required" ng-message="required">Please choose a title</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Name -->\n\t\t<section class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="forename">First name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="forename" minlength="2" name="forename" ng-model="teamMember.Personal.Forename" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.forename.$touched" ng-messages="personalForm.forename.$error" role="alert">\n\t\t\t\t\t<p data-cy="personal-forename-validation-message-required" ng-message="required">Please enter a first name</p>\n\t\t\t\t\t<p data-cy="personal-forename-validation-message-pattern" ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p data-cy="personal-forename-validation-message-minlength" ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Middle name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="middlenames">Middle names:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="middlenames" name="middlenames" ng-model="teamMember.Personal.Middlenames" ng-pattern="$root.REGEX.name" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.middlenames.$touched" ng-messages="personalForm.middlenames.$error" role="alert">\n\t\t\t\t\t<p data-cy="personal-middlename-validation-message-pattern" ng-message="pattern">Middle names can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Last name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="surname">Last name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="surname" name="surname" ng-model="teamMember.Personal.Surname" ng-pattern="$root.REGEX.name" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.surname.$touched" ng-messages="personalForm.surname.$error" role="alert">\n\t\t\t\t<p data-cy="personal-surname-validation-message-required" ng-message="required">Please enter a last name</p>\n\t\t\t\t<p data-cy="personal-surname-validation-message-pattern" ng-message="pattern">Last name can only contain letters, apostrophes and hyphens</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Gender -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">Gender:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="genderFemale" name="genderFemale" ng-model="teamMember.Personal.Gender" ng-value="\'Female\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="genderFemale">\n\t\t\t\t\t\t\t<i class="icon-female radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Female</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="radio-card-input" id="genderMale" name="genderMale" ng-model="teamMember.Personal.Gender" ng-value="\'Male\'" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="genderMale">\n\t\t\t\t\t\t\t<i class="icon-male radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Male</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Date of birth -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="dob" ng-class="{\n\t\t\t\t\t\t\'required\': teamMember.isDOBRequired\n\t\t\t\t\t}">Date of birth:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="dob" field-max-date-iso="teamMember.Personal.DOBISOMax" field-min-date-iso="teamMember.Personal.DOBISOMin" field-on-change-fn="onDateOfBirthChange(teamMember)" field-required="teamMember.isDOBRequired" field-value-iso="teamMember.Personal.DOBISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.dob.$touched" ng-messages="personalForm.dob.$error" role="alert">\n\t\t\t\t<p data-cy="personal-dob-validation-message-required" ng-message="required">Please enter a date of birth</p>\n\t\t\t\t<p data-cy="personal-dob-validation-message-pattern" ng-message="pattern">Please enter a valid date of birth, like this: dd/mm/yyyy</p>\n\t\t\t\t<p data-cy="personal-dob-validation-message-min" ng-message="min">New team members cannot be older than {{$root.CONFIG.userMaxAge}} years old.</p>\n\t\t\t\t<p data-cy="personal-dob-validation-message-max" ng-message="max">The date of birth cannot be in the future.</p>\n\t\t\t</div>\n\t\t\t<p id="form-message-dob" class="form-message fadeIn" ng-if="personalForm.dob.$touched && personalForm.forename.$touched && (teamMember.Personal.DOBISO && personalForm.dob.$valid) && personalForm.forename.$valid">\n\t\t\t\t<span ng-if="personalForm.forename.$valid">{{teamMember.Personal.Forename}} will be</span>\n\t\t\t\t{{teamMember.Personal.DOBISO | agenextbirthday}} on {{teamMember.Personal.DOBISO | nextBirthday | dateformat:\'long\'}}.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Date of birth warning -->\n\t<fieldset>\n\t\t<div class="fadeIn" ng-if="(formOptions.ageValidation && personalForm.forename.$touched && teamMember.Personal.Forename) || teamMember.userContext === \'existing-user\'" ng-switch="formOptions.ageValidation">\n            <div pc-switch-when="AGE_VALIDATION.under13">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="tertiary" note-title="Team member under 13 years old">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tBased on the next pay date and the date of birth you\'ve entered, {{teamMember.Personal.Forename}} will be under 13 years old on payday.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n            <div pc-switch-when="AGE_VALIDATION.between13And15">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="tertiary" note-title="Team member under 16 years old">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tBased on the next pay date and the date of birth you\'ve entered, {{teamMember.Personal.Forename}} will be under 16 years old on payday.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n           \t<div pc-switch-when="AGE_VALIDATION.overPension">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="tertiary" note-title="Team member over state pension age">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tBased on the next pay date and the date of birth you\'ve entered, {{teamMember.Personal.Forename}} will be over the state pension age on payday. Depending on the provider,\n\t\t\t\t\t\t\t {{teamMember.Personal.Forename}} may no longer be able to make pension contributions.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n            </div>\n        </div>\n\t</fieldset>\n\n\t<!-- NI Number (not applicable in Playground) -->\n\t<fieldset>\n\n\t\t<!-- NI Number Note -->\n\t\t<div class="form-field" ng-if="vm.isNiNoteVisible">\n\n\t\t\t<note note-dismiss="true" note-dismiss-param="vm.isNiNoteVisible" note-icon="icon-support" note-theme="indifferent" note-title="Entering false or temporary NI Numbers">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tIf you don\'t know a team member\'s NI Number, please check the &lsquo;Waiting for a National Insurance number&rsquo; box. Entering false or temporary NI numbers will result in\n\t\t\t\t\t\ta restricted system experience and may cause HMRC submission failures.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- NI Number -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="niNumber" ng-class="{\n\t\t\t\t\t\t\'disabled\': formOptions.company.AgencyProfileDummy || teamMember.Personal.NINumberPending,\n\t\t\t\t\t\t\'required\': !teamMember.Personal.NINumberPending && teamMember.isNIRequired\n\t\t\t\t\t}\n\t\t\t\t">\n\t\t\t\t\tNational Insurance number:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<ni-number ni-number-disabled="teamMember.Personal.NINumberPending" ni-number-name="niNumber" ni-number-required="!teamMember.Personal.NINumberPending && teamMember.isNIRequired" ni-number="teamMember.Personal.NINumber"></ni-number>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.niNumber.$touched" ng-messages="personalForm.niNumber.$error" role="alert">\n\t\t\t\t<p data-cy="personal-ninumber-validation-message" ng-message="required || pattern || minlength">Please enter a valid National Insurance number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- NI Number Pending? -->\n\t\t<div class="form-field">\n\t\t\t<input checkbox id="ninumberpending" label-text="\'Waiting for a National Insurance number\'" ng-change="onNiNumberPendingChange(teamMember)" ng-disabled="formOptions.company.AgencyProfileDummy" ng-model="teamMember.Personal.NINumberPending" type="checkbox">\n\t\t</div>\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field" ng-if="formOptions.company.AgencyProfileDummy">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> National Insurance numbers are not enabled for playground companies.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- NI Number change & Pension submissions -->\n\t\t<div class="form-field fadeIn" ng-if="formOptions.company.HasPension && teamMember.Personal.NINumberOriginal !== \'\' && (teamMember.Personal.NINumber !== teamMember.Personal.NINumberOriginal)">\n\t\t\t<note note-icon="icon-support" note-theme="indifferent" note-title="Pension submissions">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tPlease note that if you update {{teamMember.Personal.Forename}}\'s National Insurance Number, you may wish to double check that it matches the number that may be held with\n\t\t\t\t\t\tyour pension provider, to avoid any submission problems.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\n\t</fieldset>\n\n\t<!-- UTR (not applicable in Playground, only required for CIS Subcontractors) -->\n\t<fieldset ng-if="teamMember.Company.IsCISSubcontractor">\n\n\t\t<!-- UTR -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="utr" ng-class="{\n\t\t\t\t\t\t\'required\': teamMember.isUtrRequired,\n\t\t\t\t\t\t\'disabled\': !teamMember.isUtrRequired\n\t\t\t\t\t}">Unique Taxpayer reference (UTR):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="utr" name="utr" ng-disabled="!teamMember.isUtrRequired" ng-model="teamMember.Personal.UTR" ng-pattern="$root.REGEX.utr" ng-required="teamMember.isUtrRequired" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="personalForm.utr.$touched || personalForm.$submitted" ng-messages="personalForm.utr.$error" role="alert">\n\t\t\t\t<p data-cy="personal-utr-validation-message-required" ng-message="required">Please enter a Unique Taxpayer reference number</p>\n\t\t\t\t<p data-cy="personal-utr-validation-message-pattern" ng-message="pattern">Please enter a valid Unique Taxpayer reference number. It should consist of 10 digits. E.g. 0123456789</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- UTR Number Pending -->\n\t\t<div class="form-field" ng-if="teamMember.CIS.BusinessDetails.BusinessType !== BUSINESS_TYPES.soletrader">\n\t\t\t<input checkbox id="utrpending" label-text="\'Waiting for a UTR\'" ng-change="setIsUtrRequired(teamMember)" ng-disabled="formOptions.company.AgencyProfileDummy" ng-model="teamMember.Personal.UTRPending" type="checkbox">\n\t\t</div>\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field" ng-if="formOptions.company.AgencyProfileDummy">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> UTR numbers are pre-populated for playground companies.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions" ng-if="!formOptions.company.IsCISActive">\n\n\t\t<!-- Cancel -->\n\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" ng-if="formOptions.isWizard && !teamMember.PersonalSetupComplete" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<button class="secondary-action" data-cy="secondary-action-close" ng-click="formOptions.closeForm()" ng-if="formOptions.isWizard && teamMember.PersonalSetupComplete" type="button">\n\t\t\tClose\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!personalForm.$valid" display-text="teamMember.userContext === \'new-user\' ? \'Create\' : formOptions.primaryButtonText" state="personalForm.state"></submit-button>\n\t</fieldset>\n\n\t<fieldset class="form-actions" ng-if="formOptions.company.IsCISActive">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="reOpenSetupForm(teamMember)" ng-if="!teamMember.PersonalSetupComplete" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Cancel -->\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" ng-if="formOptions.isWizard && !teamMember.PersonalSetupComplete" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" data-cy="secondary-action-close" ng-click="formOptions.closeForm()" ng-if="formOptions.isWizard && teamMember.PersonalSetupComplete" type="button">\n\t\t\tClose\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!personalForm.$valid" display-text="teamMember.userContext === \'new-user\' ? \'Create\' : formOptions.primaryButtonText" state="personalForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- CIS Company Details -->\n<form class="fadeIn" name="cisCompanyDetailsForm" ng-if="pageState === \'cis-company\'" ng-submit="reviewTeamMember(teamMember, cisCompanyDetailsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4 class="strong">{{teamMember.CIS.BusinessDetails.BusinessType === BUSINESS_TYPES.company ? \'Limited company details\' : \'Trust details\'}}</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="cisCompanyName">Company name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="cisCompanyName" name="cisCompanyName" ng-model="teamMember.CIS.BusinessDetails.TradingName" ng-pattern="$root.REGEX.companyName" placeholder="Type here..." required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="cisCompanyDetailsForm.cisCompanyName.$touched" ng-messages="cisCompanyDetailsForm.cisCompanyName.$error" role="alert">\n\t\t\t\t<p data-cy="personal-ciscompanyname-validation-message-pattern" ng-message="pattern">Only basic characters allowed</p>\n\t\t\t\t<p data-cy="personal-ciscompanyname-validation-message-required" ng-message="required">Please enter a company name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company UTR -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="utr" ng-class="{\n\t\t\t\t\t\t\'required\': !teamMember.Personal.UTRPending,\n\t\t\t\t\t\t\'disabled\': teamMember.Personal.UTRPending || formOptions.company.AgencyProfileDummy\n\t\t\t\t\t}">Company Unique Taxpayer reference (UTR):</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="utr" name="utr" ng-disabled="teamMember.Personal.UTRPending || formOptions.company.AgencyProfileDummy" ng-model="teamMember.Personal.UTR" ng-pattern="$root.REGEX.utr" ng-required="!teamMember.Personal.UTRPending" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="cisCompanyDetailsForm.utr.$touched || cisCompanyDetailsForm.$submitted" ng-messages="cisCompanyDetailsForm.utr.$error" role="alert">\n\t\t\t\t<p data-cy="personal-companyutr-validation-message-required" ng-message="required">Please enter a Unique Taxpayer reference number</p>\n\t\t\t\t<p data-cy="personal-companyutr-validation-message-pattern" ng-message="pattern">Please enter a valid Unique Taxpayer reference number. It should consist of 10 digits. E.g. 0123456789</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- UTR Number Pending -->\n\t\t<div class="form-field" ng-if="teamMember.CIS.BusinessDetails.BusinessType !== BUSINESS_TYPES.soletrader">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="utrpending" label-text="\'Waiting for a Company UTR\'" ng-disabled="formOptions.company.AgencyProfileDummy" ng-model="teamMember.Personal.UTRPending" type="checkbox">\n\t\t\t</div>\n\t\t\t<p class="form-message">\n\t\t\t\t<strong>Please note:</strong> if you\'re waiting for the Company UTR, you can come back here to add it later. Company set up won\'t be complete until you\'ve done so.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field" ng-if="formOptions.company.AgencyProfileDummy">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> UTR numbers are pre-populated for playground companies.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- VAT Registration Number -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="vatRegistrationNumber">VAT registration number:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="vatRegistrationNumber" name="vatRegistrationNumber" ng-model="teamMember.CIS.VATRegistrationNumber" ng-pattern="$root.REGEX.vat" placeholder="{{$root.PLACEHOLDERS.vatNumber}}" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="cisCompanyDetailsForm.vatRegistrationNumber.$touched || cisCompanyDetailsForm.$submitted" ng-messages="cisCompanyDetailsForm.vatRegistrationNumber.$error" role="alert">\n\t\t\t\t<p data-cy="personal-vatregistrationnumber-validation-message-required" ng-message="required">Please enter a VAT Registration number</p>\n\t\t\t\t<p data-cy="personal-vatregistrationnumber-validation-message-pattern" ng-message="pattern">Please enter a valid VAT Registration number, E.g. {{::$root.PLACEHOLDERS.vatNumber}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company address -->\n\t\t<div class="form-field">\n\t\t\t<address-lookup address="teamMember.CISCompanyAddress" is-disabled="teamMember.CISCompanyAddressPending" is-required="!teamMember.CISCompanyAddressPending" is-uk-only="true"></address-lookup>\n\t\t</div>\n\n\t\t<!-- Option to not provide address (CIS only) -->\n\t\t<div class="form-field">\n\t\t\t<input checkbox id="hasAddressToggle" label-text="\'I don\\\'t have the company address at the moment\'" name="hasAddressToggle" ng-model="teamMember.CISCompanyAddressPending" type="checkbox">\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="setPageState(\'select-scheme\'); setTeamMemberFormStep(teamMember, 1)" type="button">\n\t\t\tBack\n\t\t</button>\n\n        <!-- Close -->\n        <button class="secondary-action" data-cy="secondary-action-close" ng-click="formOptions.closeForm()" type="button">\n            Cancel\n        </button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="cisCompanyDetailsForm.$invalid" display-text="teamMember.userContext === \'new-user\' ? \'Create\' : formOptions.primaryButtonText" state="cisCompanyDetailsForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- User exists in company -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="It looks like you have already added this user" ng-if="pageState === \'user-exists-for-company\'">\n\t<fs-main>\n\t\t<section class="form-section">\n\t\t\t<p class="is-small">The NI Number entered matches one of {{formOptions.company.Name}}\'s existing team members.</p>\n\t\t</section>\n\t\t<section class="form-section">\n\n\t\t\t<!-- Existing User -->\n\t\t\t<user-card user="existingUser"></user-card>\n\t\t</section>\n\t\t<section class="form-section">\n\t\t\t<p class="is-small">\n\t\t\t\tIf you\'re unsure whether this is the right person, contact support and we\'ll quickly check for you. This will\n\t\t\t\thelp avoid duplicating their details, which could cause payroll problems later.\n\t\t\t</p>\n\t\t</section>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'personal\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- User exists in Paycircle (mismatch) -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="This NI Number is already in use" ng-if="pageState === \'user-mismatch\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe NI Number you\'ve entered is already in use by another user. Please click \'Back\' and double check that the NI Number and other information you\'ve entered is correct. If you\'re\n\t\t\tabsolutely sure that the information you\'ve entered for {{teamMember.Personal.Forename}} is correct, please\n\t\t\tcontact support and we\'ll look into it for you.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'personal\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- User is leaver -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="This team member is already a leaver" ng-if="pageState === \'user-is-leaver\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThe team member you\'re trying to add was previously a leaver of {{formOptions.company.Name}}. Instead of adding them as a new team member, go to your Leavers page and click the\n\t\t\t&lsquo;Rejoin leaver&rsquo; link in the action menu for the respective leaver.\n\t\t</p>\n\t\t<p>\n\t\t\t<a class="link-with-icon" ui-sref="team.leavers({\n\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t})"><i class="icon-right"></i>Go to Leavers page</a></p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'personal\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- User exists in Paycircle and added to team (exact match) -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{existingUser.Personal.Forename}} has been added to the team" ng-if="pageState === \'user-exists-in-paycircle\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{existingUser.Personal.Forename}} has been added to {{formOptions.company.Name}}\'s team. View {{existingUser.Personal.Forename}}\'s profile to complete\n\t\t\t{{existingUser.Personal.Gender | personalise:\'his\'}} information so {{existingUser.Personal.Gender | personalise:\'he\'}} is ready for the next period.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tClose\n\t\t</button>\n\t\t<button class="tertiary primary-action" data-cy="primary-action" ui-sref="team.profile.overview({\n\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\tuserId: existingUser.Personal.UserID\n\t\t\t})" type="button">\n\t\t\tView profile\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Confirm invitation -->\n<form class="fadeIn" name="inviteToRegisterForm" ng-if="pageState === \'confirm-invite\'" ng-submit="inviteToRegister(existingUser.Personal.UserID, inviteToRegisterForm)" novalidate>\n\n\t<div class="form-summary">\n\t\t<header class="form-summary-header">\n\t\t\t<i class="icon-question-mark xxl primary"></i>\n\t\t\t<h4>Are you sure you wish to invite {{existingUser.Personal.Forename}}?</h4>\n\t\t</header>\n\t\t<p class="is-small">An invitation will be sent straight away to {{existingUser.Personal.Forename}} by email.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<div class="form-actions">\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'personal\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<submit-button display-text="\'Confirm\'" state="inviteToRegisterForm.state"></submit-button>\n\t</div>\n</form>\n\n<!-- Invite sent -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{existingUser.Personal.Forename}} has been invited to join your team!" ng-if="pageState === \'invite-sent\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAn invitation has been sent to {{existingUser.Personal.Forename}}. If {{existingUser.Personal.Forename}} doesn\'t open the email and register within the next 7 days, they will need to\n\t\t\tbe re-invited.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action" ng-click="setPageState(\'personal\')" type="button">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/personal/personal-overview/personalOverviewForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="form-intro">\n\t\t<p class="s">Review the questions you\'ve answered and any you\'ve marked for later. Click on the edit icon to jump back and edit anything you need to change.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\n\t\t<overview-data overview-groups="taskListGroups" on-edit="openEditTeamMemberWizard"></overview-data>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button primary-action tertiary" ng-click="formOptions.closeForm()">Close</a>\n\t\t</fieldset>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/personal/telephone/telephoneForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="telephoneForm" ng-submit="saveTelephoneDetails(teamMemberObj, telephoneForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Main phone number -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="mainNumber">Main contact number</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="mainNumber" name="mainNumber" type="text" ng-pattern="$root.REGEX.telephone" ng-model="teamMemberObj.Personal.PhoneNumberPrimary" placeholder="Enter your main contact number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="telephoneForm.mainNumber.$error" ng-if="telephoneForm.mainNumber.$invalid && telephoneForm.mainNumber.$touched" role="alert">\n\t\t\t\t<p data-cy="telephone-phonenumberprimary-validation-message-pattern" ng-message="pattern">Please enter a valid phone number</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Alternative phone number -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="otherNumber">Other contact number</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="otherNumber" name="otherNumber" type="text" ng-pattern="$root.REGEX.telephone" ng-model="teamMemberObj.Personal.PhoneNumberSecondary" placeholder="Enter an alternative contact number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="telephoneForm.otherNumber.$error" ng-if="telephoneForm.otherNumber.$invalid && telephoneForm.otherNumber.$touched" role="alert">\n\t\t\t\t<p data-cy="telephone-phonenumbersecondary-validation-message-pattern" ng-message="pattern">Please enter a valid phone number</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="telephoneForm.state" ng-if="telephoneForm.state === \'saved\'">\n\t\t\t<p>{{formOptions.context.Forename}}\'s contact details have been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" ng-if="!formOptions.totalSteps" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="telephoneForm.$invalid" display-text="formOptions.primaryButtonText" state="telephoneForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<button class="tertiary-action" data-cy="tertiary-action" ng-click="formOptions.skip()" ng-if="formOptions.canSkip" type="button">\n\t\t\tSkip\n\t\t</button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/personal/unregister-user/unregister-user.form.html','<form class="fadeIn" name="unregisterUserForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.unregisterUser(unregisterUserForm)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to unregister this team member?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tOnce {{::$ctrl.formOptions.context.Forename}} has been unregistered, they will no longer be able to access their Pay Portal\n\t\t\t\t\tfor {{::$ctrl.formOptions.company.Name}} and the &lsquo;Account&rsquo; area will be removed from their profile until they register again.\n\t\t\t\t\tClick on the &lsquo;Invite to register&rsquo; link in their profile if you wish to send them another invitiation.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<div class="confirmation-block tertiary-light has-font-weight-normal">\n\t\t\t\t\t<input checkbox class="s" id="confirmInformation" label-text-class="is-small" label-text="\'I confirm that I have received confirmation that \' + $ctrl.formOptions.context.Forename + \' wishes to unregister their account and I understand that they won\u2019t be able to sign in to their Pay Portal  once I click \u2018Confirm\u2019.\'" name="confirmInformation" ng-model="$ctrl.confirmInformation" required type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fs-main>\n\t\t<fs-actions>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button display-text="\'Confirm\'" disable-button="unregisterUserForm.$invalid" state="unregisterUserForm.state"></submit-button>\n\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{$ctrl.formOptions.context.Forename}} has been unregistered" ng-if="$ctrl.pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{::$ctrl.formOptions.context.Forename}} has been unregistered and can no longer access their Pay Portal for {{::$ctrl.formOptions.company.Name}}.\n\t\t\tClick on the &lsquo;Invite to register&rsquo; link in their profile if you wish to send them another invitiation.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n\n');
$templateCache.put('forms/personal/user-documents/user-documents.form.html','<div class="fadeIn" ng-switch="$ctrl.formOptions.formState">\n\n\t<div class="slide-in-form-content" pc-switch-when="[$ctrl.UPLOADS_DOCUMENTS_FORMS.deleteFile, $ctrl.UPLOADS_DOCUMENTS_FORMS.editFile]">\n\t\t<file-card agency-profile-id="$ctrl.formOptions.agencyProfileId" file="$ctrl.formOptions.document" file-size="is-large" file-theme="{{$ctrl.formOptions.document.DocumentTypeID | userDocumentTypeTheme}} has-background"></file-card>\n\t</div>\n\n\t<!-- Upload -->\n\t<form pc-switch-when="$ctrl.UPLOADS_DOCUMENTS_FORMS.uploadFile" name="userDocumentsUploadForm" ng-submit="$ctrl.uploadDocuments($ctrl, userDocumentsUploadForm)" class="fadeIn" novalidate>\n\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss-key="user-documents-mention" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Password protected files">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPassword protected files are frequently used for virus or malware attacks so all uploads are scanned to keep your data safe and secure. \n\t\t\t\t\t\tProtected files will always be rejected whether you have chosen to add a password to them or not.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="fileType" class="required">File type</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-list is-inline">\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="fileType" id="fileType-different" class="b" ng-value="$ctrl.FILE_TYPE_GLOBAL_OPTIONS.differentForEachFile" ng-model="$ctrl.globalFileTypeOption">\n\t\t\t\t\t\t\t\t<label for="fileType-different">Different for each file</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t<input type="radio" name="fileType" id="fileType-same" ng-change="$ctrl.setDocumentsFileTypeToGlobal($ctrl)" class="b" ng-value="$ctrl.FILE_TYPE_GLOBAL_OPTIONS.sameForAllFiles" ng-model="$ctrl.globalFileTypeOption">\n\t\t\t\t\t\t\t\t<label for="fileType-same">Same for all files</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset class="form-fieldset-divider-top smaller-padding is-primary-lighter">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="fileType" class="required" ng-class="{ \'disabled\' : $ctrl.globalFileTypeOption === $ctrl.FILE_TYPE_GLOBAL_OPTIONS.differentForEachFile }">File type:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t<select class="l-alt" id="fileType" name="fileType" ng-change="$ctrl.setDocumentsFileTypeToGlobal($ctrl)" ng-disabled="$ctrl.globalFileTypeOption === $ctrl.FILE_TYPE_GLOBAL_OPTIONS.differentForEachFile" ng-model="$ctrl.globalFileType" ng-options="option.key as option.label for option in $ctrl.FILE_TYPE_OPTIONS" required>\n\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="file-card_wrapper fadeIn" ng-if="$ctrl.documents.length > 0">\n\t\t\t<file-card agency-profile-id="$ctrl.formOptions.agencyProfileId" file-size="is-large" file-theme="is-primary" file="document" ng-repeat="document in $ctrl.documents" on-delete="document.remove()">\n\t\t\t\t<fc-footer>\n\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t<!-- File type -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="{{$index}}-fileType" class="required" ng-class="{ \'disabled\' : $ctrl.globalFileTypeOption === $ctrl.FILE_TYPE_GLOBAL_OPTIONS.sameForAllFiles}">File type:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<select id="{{$index}}-fileType" name="{{$index}}-fileType" ng-disabled="$ctrl.globalFileTypeOption === $ctrl.FILE_TYPE_GLOBAL_OPTIONS.sameForAllFiles" ng-model="document.params.filetype" ng-options="option.key as option.label for option in $ctrl.FILE_TYPE_OPTIONS" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Single Date -->\n\t\t\t\t\t\t<div ng-if="![$ctrl.USER_DOCUMENT_IDS.p60, $ctrl.USER_DOCUMENT_IDS.p11d].includes(document.params.filetype)" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label ng-class="{ \'required\' : document.params.filetype !== $ctrl.USER_DOCUMENT_IDS.other }" for="{{$index}}-fileDate">Date:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="{{$index}}-fileDate" field-required="document.params.filetype !== $ctrl.USER_DOCUMENT_IDS.other" field-value-iso="document.params.date">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="userDocumentsUploadForm[$index + \'-fileDate\'].$error" ng-if="userDocumentsUploadForm[$index + \'-fileDate\'].$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Tax year select -->\n\t\t\t\t\t\t<div ng-if="[$ctrl.USER_DOCUMENT_IDS.p60, $ctrl.USER_DOCUMENT_IDS.p11d].includes(document.params.filetype)" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="{{$index}}-taxYearStart" class="required">Date:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t<div class="date-range">\n\t\t\t\t\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t\t\t\t\t<input class="s" id="{{$index}}-taxYearStart" maxlength="4" min="1970" name="{{$index}}-taxYearStart" ng-change="$ctrl.onTaxYearStartDateChange(document)" ng-model="document.taxYearDate.startDate" required type="number">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="date-range__icon">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t\t\t\t\t<input class="s" id="{{$index}}-taxYearEnd" maxlength="4" readonly="readonly" name="{{$index}}-taxYearEnd" ng-model="document.taxYearDate.endDate" type="number">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="userDocumentsUploadForm[$index + \'-taxYearStart\'].$error" ng-if="userDocumentsUploadForm[$index + \'-taxYearStart\'].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Label -->\n\t\t\t\t\t<div ng-if="document.params.filetype === $ctrl.USER_DOCUMENT_IDS.other" class="form-field fadeIn">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="{{$index}}-fileName" class="required">File name:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t<input id="{{$index}}-fileName" name="{{$index}}-fileName" ng-model="document.params.label" required type="text">\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Available in pay portal -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input type="checkbox" id="{{$index}}-available" class="xs" name="{{$index}}-available" ng-model="document.params.available" label-text="\'Make this file available in \'+ $ctrl.formOptions.context.Forename + \'\\\'s portal\'" checkbox>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fc-footer>\n\t\t\t</file-card>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<file-uploader-queued fu-allowed-file-types-key="all" fu-queue="$ctrl.documents" fu-on-queue-update="$ctrl.updateFiles($ctrl)" fu-message="Select files to upload" fu-max-file-size="2097152"></file-uploader-queued>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-footer">\n\t\t\t\t\t<p class="form-note">2Mb max. file size</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Upload\'" state="userDocumentsUploadForm.state" disable-button="$ctrl.documents.length === 0 || userDocumentsUploadForm.$invalid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Edit -->\n\t<form pc-switch-when="$ctrl.UPLOADS_DOCUMENTS_FORMS.editFile" name="userDocumentsEditForm" ng-submit="$ctrl.updateUserDocument($ctrl, userDocumentsEditForm)" class="fadeIn" novalidate>\n\n\t\t<fieldset>\n\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<h5>\n\t\t\t\t\t\tLabels\n\t\t\t\t\t</h5>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tChoose how you wish to label this document, and add a date to display on the document.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<fieldset>\n\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t<!-- File type -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="documentFileType" class="required">File type:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<select id="documentFileType" name="documentFileType" ng-model="$ctrl.formOptions.document.UserDocumentTypeID" ng-change="$ctrl.onDocumentTypeChange($ctrl.formOptions.document)" ng-options="option.key as option.label for option in $ctrl.FILE_TYPE_OPTIONS" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Single Date -->\n\t\t\t\t\t\t<div ng-if="![$ctrl.USER_DOCUMENT_IDS.p60, $ctrl.USER_DOCUMENT_IDS.p11d].includes($ctrl.formOptions.document.UserDocumentTypeID)" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label ng-class="{ \'required\' : $ctrl.formOptions.document.UserDocumentTypeID !== $ctrl.USER_DOCUMENT_IDS.other }" for="manualDateIso">Date:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="manualDateIso" field-required="$ctrl.formOptions.document.UserDocumentTypeID !== $ctrl.USER_DOCUMENT_IDS.other" field-value-iso="$ctrl.formOptions.document.UserDocumentManualDateISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="userDocumentsEditForm.manualDateIso.$error" ng-if="userDocumentsEditForm.manualDateIso.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Tax year select -->\n\t\t\t\t\t\t<div ng-if="[$ctrl.USER_DOCUMENT_IDS.p60, $ctrl.USER_DOCUMENT_IDS.p11d].includes($ctrl.formOptions.document.UserDocumentTypeID)" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="taxYearStart" class="required">Date:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t<div class="date-range">\n\t\t\t\t\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t\t\t\t\t<input class="s" id="taxYearStart" maxlength="4" min="1970" name="taxYearStart" ng-change="$ctrl.onTaxYearStartDateChange($ctrl.formOptions.document)" ng-model="$ctrl.formOptions.document.taxYearDate.startDate" required type="number">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="date-range__icon">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t\t\t\t\t<input class="s" id="taxYearEnd" maxlength="4" readonly="readonly" min="1970" name="taxYearEnd" ng-model="$ctrl.formOptions.document.taxYearDate.endDate" type="number">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="userDocumentsEditForm.taxYearStart.$error" ng-if="userDocumentsEditForm.taxYearStart.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a number</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Label -->\n\t\t\t\t\t<div ng-if="$ctrl.formOptions.document.UserDocumentTypeID === $ctrl.USER_DOCUMENT_IDS.other" class="form-field fadeIn">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="documentLabel" class="required">File name:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t<input id="documentLabel" name="documentLabel" ng-model="$ctrl.formOptions.document.UserDocumentLabel" required type="text">\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Available in pay portal -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input type="checkbox" id="available" class="xs" name="available" ng-model="$ctrl.formOptions.document.available" label-text="\'Make this file available in \'+ $ctrl.formOptions.context.Forename + \'\\\'s portal\'" checkbox>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="userDocumentsEditForm.state" disable-button="userDocumentsEditForm.$invalid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Delete -->\n\t<form pc-switch-when="$ctrl.UPLOADS_DOCUMENTS_FORMS.deleteFile" name="userDocumentsDeleteForm" ng-submit="$ctrl.deleteUserDocument($ctrl, userDocumentsDeleteForm)" class="fadeIn" novalidate>\n\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this document?">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">The document will be deleted from {{::$ctrl.formOptions.context.Forename}}\'s profile and also from the document storage area in their portal. Click \'Confirm\' if you\'re happy to continue.</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t\t<submit-button display-text="\'Confirm\'" state="userDocumentsDeleteForm.state"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Error -->\n\t<div class="fadeIn" ng-switch-when="error">\n\t\t<error-block secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\t</div>\n</div>\n');
$templateCache.put('forms/personal/user-download-documents/user-download-documents.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="userDownloadsDocumentForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.downloadFile()" novalidate>\n\t<div class="form-intro">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Manually updated documents">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note that manually uploaded documents can\'t be included in a bulk document download for a team member and will need to be downloaded individually.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t\t<p class="is-small" data-cy="user-download-documents-form-intro">\n\t\t\tSelect the document type and pay period range you wish to use for your download before clicking \'Download\'. You may wish to password protect your ZIP file for security.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="downloadFileType">\n\t\t\t\t\tDocument type:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="is-extra-large" data-cy="user-download-documents-form-file-type-select" id="downloadFileType" name="downloadFileType" ng-change="$ctrl.onFileTypeChange()" ng-model="$ctrl.globalFileType" ng-options="option.key as option.label for option in $ctrl.FILE_TYPE_OPTIONS" ng-required="true">\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="slide-in-form_item form-fields-from-to">\n\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" data-cy="user-download-documents-form-first-period-label" for="firstPeriodField">\n\t\t\t\t\t\t\tFirst period:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select data-cy="user-download-documents-form-first-period-select" id="firstPeriodField" name="firstPeriodField" ng-change="$ctrl.refreshPayPeriods()" ng-model="$ctrl.periodFromId" ng-options="payPeriod.PayPeriodID as payPeriod.PayPeriodDisplay for payPeriod in $ctrl.periodsFrom | orderBy: \'startDateUnix\'" ng-required="true">\n\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message fadeIn" data-cy="user-download-documents-form-max-periods-message">\n\t\t\t\t\t12 months max.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-fields-from-to_item">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label class="required" data-cy="user-download-documents-form-last-period-label" for="lastPeriodField">\n\t\t\t\t\t\t\tLast period:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select data-cy="user-download-documents-form-last-period-select" id="lastPeriodField" name="lastPeriodField" ng-change="$ctrl.refreshPayPeriods()" ng-model="$ctrl.periodToId" ng-options="payPeriod.PayPeriodID as payPeriod.PayPeriodDisplay for payPeriod in $ctrl.periodsTo | orderBy: \'startDateUnix\'" ng-required="true">\n\t\t\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="Password protect the ZIP file" field-model="$ctrl.passwordProtectionEnabled" field-name="passwordProtectionEnabled" field-theme-active="is-primary" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- PW protection ON -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.passwordProtectionEnabled">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="zipPassword" class="required">Password:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="password-toggle">\n\t\t\t\t\t\t<input autocomplete="off" class="is-extra-large" data-cy="user-download-documents-form-password-input" id="zipPassword" name="zipPassword" ng-model="$ctrl.password" required type="{{$ctrl.showPassword ? \'text\' : \'password\'}}">\n\n\t\t\t\t\t\t<a class="password-toggle-action" href ng-click="$ctrl.togglePasswordVisibility()">\n\t\t\t\t\t\t\t<i class="icon-{{$ctrl.showPassword ? \'hide\' : \'visible\'}} m"></i>&nbsp;&nbsp;{{$ctrl.showPassword ? \'Hide\' : \'Show\'}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t<p class="form-message fadeIn" data-cy="user-download-documents-form-important-message">\n\t\t\t\tImportant: if you intend to forward the downloaded ZIP file to another party, you will need to share the password by another means of your choosing.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="user-download-documents-form-cancel-button" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="userDownloadsDocumentForm.$invalid" display-text="\'Download\'"></submit-button>\n\t</fieldset>\n</form>\n\n<section class="form-summary fadeIn" ng-if="$ctrl.pageState === \'zip-documents\'">\n\t<loading-block size="is-medium"></loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<article class="align-center">\n\t\t\t<h4>Zipping your documents</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tWe\'re just zipping up your documents and this should only take a few moments.<br>\n\t\t\t\tPlease don\'t click back or close this window.\n\t\t\t</p>\n\t\t</article>\n\t</section>\n</section>\n\n<!-- No Documents -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="Only manually uploaded documents exist" ng-if="$ctrl.pageState === \'no-documents\'">\n\t<fs-main>\n\t\t<p class="s" data-cy="user-download-documents-form-no-documents-message">Please note that manually uploaded documents can\'t be included in a bulk document download for a team member and will need to be downloaded individually.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/reporting/bacs-download-confirmation/bacs-download-confirmation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Payroll hasn\'t been finalised" ng-if="$ctrl.pageState === \'ready\'">\n\t<fs-main>\n\t\t<p class="is-small">You\'re about to download a BACS file before payroll has been finalised. Please be aware that this file may become out of date if you or another admin make changes to the payroll or team after it\'s been downloaded.</p>\n\t\t<p class="is-small">The activity log for {{$ctrl.formOptions.company.Name}} will be updated to show that you downloaded this file before payroll was finalised. Click \'Continue\' if you still wish to download this BACS file.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-click="$ctrl.exportBacs($ctrl.formOptions.reportObj)">\n\t\t\tContinue\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window">\n</error-block>\n\n');
$templateCache.put('forms/reporting/delete-report-template/delete-report-template.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="deleteReportTemplateForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.deleteReportTemplate(deleteReportTemplateForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to delete this template?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">You\u2019re about to delete the \u2018{{$ctrl.formOptions.reportTemplate.ReportTemplateName}}\u2019 report template. Once deleted, it will be removed from any report packs it\u2019s been added to and will no longer be available to company groups or companies. If you later realise you\u2019ve made a mistake, you will need to recreate the report template again. Click \u2018Delete\u2019 if you wish to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button button-id="delete-report-template-confirm" display-text="\'Delete\'" state="deleteReportTemplateForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Template deleted" ng-if="$ctrl.pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">Your report template has been deleted and can no longer be added to report packs.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/reporting/download-reports/downloadReportsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="reportsExportForm" ng-submit="exportReports(vm, reportsExportForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="vm.payPeriod.PayrollState !== SUBMISSION_STATES.submitted">\n\t\t<p class="s"><span class="tertiary">WARNING:</span> Any reports you include in your download are in a DRAFT format. Please do not pay your team or HMRC using the data in these reports.</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="info-block quarternary align-center" ng-class="{indifferent: vm.payPeriod.PayrollState !== SUBMISSION_STATES.submitted}">\n\t\t\t<p>Download reports for the period</p>\n\t\t\t<div class="spacer xs"></div>\n\t\t\t<h4 class="strong">{{vm.payPeriod.PayPeriodDisplay}}</h4>\n\t\t\t<div ng-if="vm.payPeriod.PayrollState !== SUBMISSION_STATES.submitted">\n\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t<p class="s"><i class="icon-warning m"></i>&nbsp;This period hasn\'t been approved yet</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-section">\n\t\t<p class="s">Select the file formats you wish to include in your download and they will be bundled into a single ZIP file which you can also password protect if you wish. Your selections will be saved in this view for future downloads.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Reports -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<h5>Reports</h5>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\n\t\t\t\t<report-downloads agency-profile-id="formOptions.agencyProfileId" report-collection="vm.reportCollection" pay-period="vm.payPeriod"></report-downloads>\n\n\t\t\t</main>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<!-- Password Protect -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-name="isPasswordProtected" field-model="vm.isPasswordProtected" field-label="Password protect the ZIP file" field-theme-active="is-primary" field-theme-light="true"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Choose Password -->\n\t\t<div class="form-field fadeIn" ng-if="vm.isPasswordProtected">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="password" class="required">Choose a password</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="{{vm.showPassword ? \'text\' : \'password\'}}" id="password" class="l password-input" name="password" ng-model="vm.reportCollection.ReportTemplateCollectionPassword" required>\n\t\t\t\t<a href="" class="password-input-toggle" ng-click="toggleShowPassword(vm)"><i class="icon-{{vm.showPassword ? \'hidden\' : \'visible\'}} m"></i> {{vm.showPassword ? \'Hide\' : \'Show\'}}</a>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="reportsExportForm.password.$error" ng-if="reportsExportForm.password.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a password or switch password protection off</p>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn"><strong>Important:</strong> if you intend to forward the downloaded ZIP file to another party, you will need to share the password by another means of your choosing.</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Download\'" state="reportsExportForm.state" disable-button="!reportsExportForm.$valid || vm.reportCollection.ReportTemplateCollectionEntries.length === 0"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Generating reports -->\n<section class="form-summary fadeIn" ng-if="pageState === \'generating\'">\n\t<loading-block size="m">\n\t\t<lb-description>We\'re generating your reports...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">This shouldn\'t take too long.</p>\n\t</section>\n</section>\n\n<!-- Generating payslips -->\n<section class="form-summary fadeIn" ng-if="pageState === \'generating-payslips\'">\n\t<section class="form-summary-section">\n\t\t<loading-block size="m"></loading-block>\n\t</section>\n\t<section class="form-summary-section align-center">\n\t\t<h5>Generating payslips</h5>\n\t\t<div class="spacer xs"></div>\n\t\t<p class="s">Once your payslips have finished generating you\u2019ll be able to download your reports. Please don\u2019t click back or close your browser window.</p>\n\t</section>\n</section>\n\n<!-- Generating payslips failed -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="There was a problem generating payslips" ng-if="pageState === \'generating-payslips-failed\'">\n\t<fs-main>\n\t\t<div class="form-state-section">\n\t\t\t<p class="is-small">Click &lsquo;Try again&rsquo; to try generating your reports again. If the problem persists please contact support. Otherwise, click \u2018Continue\u2019 to download your reports as normal.</p>\n\t\t</div>\n\t\t<div class="form-state-section">\n\t\t\t<a class="button is-primary" href="" ng-click="createPayslips(vm)">Try again</a>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</button>\n\t</fs-actions>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/reporting/manage-report-packs/manageReportPacksForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- No Report Groups -->\n<div class="slide-in-form-content fadeIn" ng-if="pageState === \'no-report-groups\'">\n\n\t<div class="form-intro">\n\t\t<p class="caption">{{formOptions.company.Name}} hasn\'t been assigned any report packs. Please contact support to get them set up.</p>\n\t</div>\n</div>\n\n<!-- Report Groups -->\n<div class="slide-in-form-content fadeIn" ng-if="pageState === \'report-groups\'">\n\n\t<div class="form-intro">\n\t\t<h6>Template packs</h6>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-cards">\n\t\t\t<a href="" class="pack-item-card primary is-clickable" ng-click="setActiveReportGroupById(vm, reportGroup)" ng-repeat="reportGroup in vm.companyReportPacks">\n\t\t\t\t<p class="pack-item-card-name">{{reportGroup.ReportTemplateGroupName}}</p>\n\t\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t\t<li class="pack-item-card-meta-item"><i class="icon-stats m"></i><ng-pluralize count="reportGroup.NumberOfReports" when="{\'1\': \'1 report\', \'other\': \'{} reports\'}"></ng-pluralize></li>\n\t\t\t\t\t<li class="pack-item-card-meta-item"><i class="icon-visible m"></i>{{reportGroup.NumberOfVisibleReports}} visible</li>\n\t\t\t\t</ul>\n\t\t\t</a>\n\n\t\t\t<div ng-switch="vm.addGroupState" ng-if="vm.assignableReportPacks.length">\n\n\t\t\t\t<!-- Add pack -- -->\n\t\t\t\t<div class="form-content-block">\n\t\t\t\t\t<button class="is-medium-large is-white is-block fadeIn" type="button" ng-click="setAddGroupState(\'adding-pack\')" ng-switch-when="add-pack">\n\t\t\t\t\t\t<i class="icon-add is-medium button_icon-pre"></i>Assign another pack\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<form name="assignPackForm" ng-submit="assignNewPack(newPack, assignPackForm)" novalidate class="pack-item-card-add-form fadeIn" ng-switch-when="adding-pack">\n\t\t\t\t\t<select name="newPackObj" id="newPackObj" class="pack-item-card-add-select" ng-model="newPack" ng-options="reportGroup as reportGroup.ReportTemplateGroupName for reportGroup in vm.assignableReportPacks track by reportGroup.ReportTemplateGroupID" required>\n\t\t\t\t\t\t<option value="" selected="selected" disabled="disabled" hidden>Select a pack to add...</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<div class="pack-item-card-add-actions">\n\t\t\t\t\t\t<submit-button button-theme="\'primary\'" display-text="\'Assign pack\'" state="assignPackForm.state" disable-button="!assignPackForm.$valid"></submit-button>\n\t\t\t\t\t\t<a href="" ng-click="setAddGroupState(\'add-pack\')" class="button">Cancel</a>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block" ng-if="!vm.assignableReportPacks.length">\n\t\t<div class="message-bar inline indifferent">\n\t\t\t<p>There are no additional report packs available to assign</p>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Report Group -->\n<div class="slide-in-form-content fadeIn" ng-if="pageState === \'report-group\'">\n\n\t<div class="form-content-block">\n\t\t<a href="" ng-click="closeReportPack(vm)" class="link-with-icon greyscale"><i class="icon-back"></i>Back to packs</a>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="pack-item-card primary active">\n\t\t\t<p class="pack-item-card-name">{{vm.activeReportGroup.ReportTemplateGroupName}}</p>\n\t\t\t<ul class="pack-item-card-meta">\n\t\t\t\t<li class="pack-item-card-meta-item"><i class="icon-stats m"></i>{{vm.activeReportGroup.NumberOfReports}} reports</li>\n\t\t\t\t<li class="pack-item-card-meta-item"><i class="icon-visible m"></i>{{vm.activeReportGroup.NumberOfVisibleReports}} visible</li>\n\t\t\t</ul>\n\t\t\t<a href="" class="pack-item-card-action" ng-click="setPageState(\'confirm-unassign\')">Unassign pack</a>\n\t\t</div>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<p class="caption">Click on the edit icon to edit report template visibility and settings. Your changes will only apply to {{formOptions.company.Name}}.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="report-pack-row_wrapper rows">\n\t\t\t<report-pack-row report-template="reportTemplate" on-template-edit="viewReportTemplate(vm, reportTemplate)" ng-repeat="reportTemplate in vm.activeReportGroup.ReportTemplates | orderBy:\'ReportTemplateName\'"></report-pack-row>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Pay Element Type -->\n<form name="updateReportTemplateForm" ng-submit="updateReportTemplateVisibilityDetailsForPack(vm, updateReportTemplateForm)" class="fadeIn" ng-if="pageState === \'report-template\'" novalidate>\n\n\t<div class="form-content-block">\n\t\t<p class="s">Any changes you make to the below settings will only apply to {{formOptions.company.Name}} and won\'t affect the \'{{vm.activeReportGroup.ReportTemplateGroupName}}\' element pack.</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<div class="form-field-highlight" ng-class="vm.activeReportTemplate.theme">\n\t\t\t<h5><i class="m" ng-class="[vm.activeReportTemplate.theme, vm.activeReportTemplate.icon]"></i>&nbsp;&nbsp;{{vm.activeReportTemplate.ReportTemplateName}}</h5>\n\t\t</div>\n\t</div>\n\n\t<!-- Options -->\n\t<fieldset class="form-fieldset-divider-top" ng-if="!vm.activeReportTemplate.IsClassicReport">\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="reportTemplateVisible">Payroll reporting</label>\n\t\t\t\t<p class="s">Use this report for payroll as well as displaying it in the general reporting area</p>\n\t\t\t</header>\n\t\t</div>\n\n\t\t<!-- Display as draft -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-name="displayDraft" field-model="vm.activeReportTemplate.accessibilityIsDraft" field-label="Display in DRAFT reports after payroll has been calculated"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Display as final -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-name="displayFinal" field-model="vm.activeReportTemplate.accessibilityIsFinal" field-label="Display in FINAL reports after payroll has been submitted"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<!-- Visibility -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="reportTemplateVisible">Visibility</label>\n\t\t\t\t<p class="s">To quickly hide \'{{vm.activeReportTemplate.ReportTemplateName}}\' from {{formOptions.company.Name}}, without removing it from the \'{{vm.activeReportGroup.ReportTemplateGroupName}}\' report pack, set it to \'Hidden\'. You can easily make it visible again later.</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="schemeType" id="reportTemplateVisible" class="radio-card-input" ng-value="true" ng-model="vm.activeReportTemplate.IsVisible" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="reportTemplateVisible">\n\t\t\t\t\t\t\t<i class="icon-visible radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Visible</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="schemeType" id="reportTemplateNotVisible" class="radio-card-input" ng-value="false" ng-model="vm.activeReportTemplate.IsVisible" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="reportTemplateNotVisible">\n\t\t\t\t\t\t\t<i class="icon-hidden radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">Hidden</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t</fieldset>\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'report-group\')">Cancel</a>\n\t\t<submit-button display-text="Save" state="updateReportTemplateForm.state" disable-button="!updateReportTemplateForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm unassign pack -->\n<form-state class="fadeIn" form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to unassign this pack?" ng-if="pageState === \'confirm-unassign\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tPayroll admins for {{formOptions.company.Name}} will no longer be able to see the templates in {{vm.activeReportGroup.ReportTemplateGroupName}}. If you change your mind at a later date you can simply re-assign this pack to {{formOptions.company.Name}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(\'report-group\')">Back</a>\n\t\t<button class="tertiary primary-action" ng-click="unassignReportGroup(vm)" ng-disabled="vm.saveState === \'saving\'" ng-class="{\'success\': vm.activeReportGroup.state === \'saved\'}">\n\t\t\t<span ng-show="vm.saveState !== \'saving\' && vm.saveState !== \'saved\'">Unassign pack</span>\n\t\t\t<span ng-show="vm.saveState === \'saving\'"><i class="icon-loading spin"></i></span>\n\t\t\t<span ng-show="vm.saveState === \'saved\'"><i class="icon-tick"></i></span>\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/reporting/report-template-group/report-template-group.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<!-- Process group actions-->\n<form class="fadeIn" name="reportTemplateGroupForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.processGroupActions" ng-submit="$ctrl.onFormSubmit(reportTemplateGroupForm)" novalidate>\n\n\t<div class="form-intro" ng-switch="$ctrl.formOptions.reportTemplateGroupFormView">\n\n\t\t<!-- Duplicate -->\n\t\t<div class="form-section" pc-switch-when="$ctrl.REPORT_TEMPLATE_GROUP_FORM_STATES.duplicate">\n\t\t\t<div class="message-bar inline primary align-left">\n\t\t\t\t<p>\n\t\t\t\t\tYou\'re duplicating&nbsp;<span class="stronger primary">{{$ctrl.reportTemplateGroup.reportTemplateGroupNameOriginal}}</span>&nbsp;which includes&nbsp;\n\t\t\t\t\t<ng-pluralize count="$ctrl.reportTemplateGroup.NumberOfReports" when="{\n\t\t\t\t\t\t\t\'1\': \'1 report template\',\n\t\t\t\t\t\t\t\'other\': \'{} report templates\'\n\t\t\t\t\t\t}"></ng-pluralize>.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- New/Duplicate -->\n\t\t<p class="is-small" pc-switch-when="[\n\t\t\t\t$ctrl.REPORT_TEMPLATE_GROUP_FORM_STATES.new,\n\t\t\t\t$ctrl.REPORT_TEMPLATE_GROUP_FORM_STATES.duplicate\n\t\t\t]">\n\t\t\tAdd a name and description and click \u2018Save\u2019 before choosing which reports will be included in this pack.\n\t\t\tYou\u2019ll then be able to assign this pack to clients in your company groups and companies page later.\n\t\t</p>\n\n\t\t<!-- Update -->\n\t\t<p class="is-small" pc-switch-when="$ctrl.REPORT_TEMPLATE_GROUP_FORM_STATES.update">\n\t\t\tUpdate the details below and click \'Save\' when you\'re done.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="reportTemplateGroupName">\n\t\t\t\t\tName\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="reportTemplateGroupName" name="reportTemplateGroupName" ng-model="$ctrl.reportTemplateGroup.ReportTemplateGroupName" ng-pattern="$root.REGEX.companyName" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="reportTemplateGroupForm.reportTemplateGroupName.$touched" ng-messages="reportTemplateGroupForm.reportTemplateGroupName.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a pack name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Description -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="reportTemplateGroupDescription">\n\t\t\t\t\tDescription\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<textarea id="reportTemplateGroupDescription" maxlength="400" name="reportTemplateGroupDescription" ng-model="$ctrl.reportTemplateGroup.ReportTemplateGroupDescription" required rows="4"></textarea>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="reportTemplateGroupForm.reportTemplateGroupDescription.$touched" ng-messages="reportTemplateGroupForm.reportTemplateGroupDescription.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a description</p>\n\t\t\t\t<p ng-message="pattern">Only basic characters are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Default -->\n\t\t<div class="form-field" ng-if="::!$ctrl.reportTemplateGroup.ReportTemplateGroupDefault">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="reportTemplateGroupDefault" label-text="\'Set this as the default report pack\'" name="reportTemplateGroupDefault" ng-model="$ctrl.reportTemplateGroup.ReportTemplateGroupDefault" type="checkbox">\n\t\t\t</div>\n\t\t\t<p class="form-message">\n\t\t\t\tThe default report pack will be automatically assigned to new company groups and companies when you add them to your bureau as they must have at least 1 pack assigned.\n\t\t\t\tChanging your default pack doesn\u2019t affect any existing companies or the packs already assigned to them.\n\t\t\t</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button disable-button="!reportTemplateGroupForm.$valid" display-text="\'Save\'" state="reportTemplateGroupForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- View inheritors-->\n<div class="slide-in-form-content fadeIn" ng-if="$ctrl.formState === $ctrl.FORM_STATES.viewGroupInheritors">\n\n\t<div class="form-section">\n\t\t<info-block ib-icon-dot="icon-stats" ib-theme="primary has-border has-large-title" ib-title="{{::$ctrl.reportTemplateGroupInheritors.ReportTemplateGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="primary-light is-small">\n\t\t\t\t\t<ng-pluralize count="$ctrl.reportTemplateGroupInheritors.ReportCount" when="{\n\t\t\t\t\t\t\t\'1\': \'1 report template\',\n\t\t\t\t\t\t\t\'other\': \'{} report templates\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<div class="form-section">\n\t\t<div class="form-intro">\n\t\t\t<p>This report pack is being used by the below {{::$ctrl.reportTemplateGroupFormView === $ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies ? \'companies\' : \'company groups\'}}:</p>\n\t\t</div>\n\t</div>\n\n\t<div class="form-section">\n\t\t<search-bar count="$ctrl.reportTemplateGroupFormView === $ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies ? $ctrl.reportTemplateGroupInheritors.Companies.length : $ctrl.reportTemplateGroupInheritors.filteredCompanyGroups.length" options="$ctrl.searchBarOptions"></search-bar>\n\t</div>\n\n\t<div class="form-section" ng-switch="$ctrl.reportTemplateGroupFormView">\n\n\t\t<!-- Companies -->\n\t\t<div class="icon-card-basic_wrapper" pc-switch-when="$ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies">\n\t\t\t<icon-card-basic contents="{{company.AgencyProfileName}}" icon="icon-company" ng-repeat="\n\t\t\t\t\tcompany in $ctrl.reportTemplateGroupInheritors.filteredCompanies =\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\t$ctrl.reportTemplateGroupInheritors.Companies |\n\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse\n\t\t\t\t"></icon-card-basic>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="$ctrl.reportTemplateGroupInheritors.filteredCompanies.length === 0" search-bar-options="$ctrl.searchBarOptions"></empty-search>\n\n\t\t</div>\n\n\t\t<!-- Company Groups -->\n\t\t<div class="icon-card-basic_wrapper" pc-switch-when="$ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups">\n\t\t\t<icon-card-basic contents="{{companyGroup.AgencyProfileName}}" icon="icon-company-groups" ng-repeat="\n\t\t\t\t\tcompanyGroup in $ctrl.reportTemplateGroupInheritors.filteredCompanyGroups =\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\t$ctrl.reportTemplateGroupInheritors.CompanyGroups |\n\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.search.string\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : $ctrl.searchBarOptions.orderBy : $ctrl.searchBarOptions.results.reverse\n\t\t\t\t"></icon-card-basic>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="$ctrl.reportTemplateGroupInheritors.filteredCompanyGroups.length === 0" search-bar-options="$ctrl.searchBarOptions"></empty-search>\n\n\t\t</div>\n\n\t</div>\n\n</div>\n\n<!-- Group not in use -->\n<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-title="Pack not in use" ng-if="$ctrl.formState === $ctrl.FORM_STATES.groupNotInUse">\n\t<fs-preheader>\n\t\t<info-block ib-icon-dot="icon-stats" ib-theme="primary has-border has-large-title" ib-title="{{::$ctrl.reportTemplateGroupInheritors.ReportTemplateGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="is-primary-light is-small">\n\t\t\t\t\t<ng-pluralize count="$ctrl.reportTemplateGroupInheritors.ReportCount" when="{\n\t\t\t\t\t\t\t\'1\': \'1 report template\',\n\t\t\t\t\t\t\t\'other\': \'{} report templates\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThis report pack isn\u2019t being used by any {{::$ctrl.reportTemplateGroupFormView === $ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies ? \'companies\' : \'company groups\'}}.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Group in use -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="This pack is in use" ng-if="$ctrl.formState === $ctrl.FORM_STATES.groupInUse">\n\t<fs-preheader>\n\t\t<info-block ib-icon-dot="icon-stats" ib-theme="primary has-border has-large-title" ib-title="{{::$ctrl.reportTemplateGroupInheritors.ReportTemplateGroupName}}">\n\t\t\t<ib-main>\n\t\t\t\t<span class="primary-light is-small">\n\t\t\t\t\t<ng-pluralize count="$ctrl.reportTemplateGroupInheritors.ReportCount" when="{\n\t\t\t\t\t\t\t\'1\': \'1 report template\',\n\t\t\t\t\t\t\t\'other\': \'{} report templates\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</span>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</fs-preheader>\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPlease note that this report pack is currently in use. Before it can be deleted, please unassign it from all company groups and companies using the \u2018Manage reports\u2019 link in the action menu for each of them. Click on the links below to see who\u2019s using this pack.\n\t\t</p>\n\t\t<p class="is-small" ng-if="$ctrl.reportTemplateGroupInheritors.Companies.length > 0">\n\t\t\t<a href="" class="is-primary is-strong" ng-click="$ctrl.onViewInheritors($ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies)">\n\t\t\t\t<i class="icon-chevron-right"></i> View <ng-pluralize count="$ctrl.reportTemplateGroupInheritors.Companies.length" when="{\'1\': \'1 company\', \'other\': \'{} companies\'}"></ng-pluralize>\n\t\t\t</a>\n\t\t</p>\n\t\t<p class="is-small" ng-if="$ctrl.reportTemplateGroupInheritors.CompanyGroups.length > 0">\n\t\t\t<a href="" class="is-primary is-strong" ng-click="$ctrl.onViewInheritors($ctrl.REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups)">\n\t\t\t\t<i class="icon-chevron-right"></i> View <ng-pluralize count="$ctrl.reportTemplateGroupInheritors.CompanyGroups.length" when="{\'1\': \'1 company group\', \'other\': \'{} company groups\'}"></ng-pluralize>\n\t\t\t</a>\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Confirmation -->\n<form name="deleteReportTemplateGroupForm" ng-submit="$ctrl.onFormSubmit(deleteReportTemplateGroupForm)" ng-if="$ctrl.formState === $ctrl.FORM_STATES.confirmDelete">\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete this pack?">\n\t\t<fs-main>\n\n\t\t\t<p class="is-small">\n\t\t\t\tThis will delete the &lsquo;{{$ctrl.formOptions.reportTemplateGroup.ReportTemplateGroupName}}&rsquo; report template pack and cannot be undone.\n\t\t\t</p>\n\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button display-text="\'Delete pack\'" state="deleteReportTemplateGroupForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n\n');
$templateCache.put('forms/workflow/complete-step/completeStepForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Complete step -->\n<form name="completeStepForm" ng-submit="completeStep(vm, completeStepForm)" class="fadeIn" ng-if="pageState === \'complete-step\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you\'ve done everything?">\n\t\t<fs-main>\n\t\t\t<p class="s">If you\'ve completed everything you need to for this step, click \'Complete\' and the collaborator for the next step will be notified. If you realise that you\'ve forgotten to do something however, and you need to let the next collaborator know, you can continue adding notes.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Complete\'" state="completeStepForm.state" disable-button="!completeStepForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Not the collaborator -->\n<form name="completeStepOnBehalfForm" ng-submit="completeStepOnBehalf(vm, completeStepOnBehalfForm)" class="fadeIn" ng-if="pageState === \'complete-step-on-behalf\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="You\'re not the collaborator for this step">\n\t\t<fs-main>\n\t\t\t<p class="s">{{vm.workflowTemplateEntry.Actioner}} is the collaborator for this step. Add a reason for completing below and click &lsquo;Complete&rsquo; so {{vm.workflowTemplateEntry.Actioner}} can see why you\'ve completed it on their behalf. The next collaborator will be notified and {{vm.workflowTemplateEntry.Actioner}} will no longer be able to complete the step.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="completionReason" class="required">Reason for completing:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<mention-input name="completionReason" agency-profile-id="formOptions.agencyProfileId" ng-model="vm.newMessage.Text" rows="6" mention-list="vm.newMessage.MentionList" required="true"></mention-input>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="completeStepOnBehalfForm.completionReason.$error" ng-if="completeStepOnBehalfForm.completionReason.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please add a reason for completing</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Complete\'" state="completeStepOnBehalfForm.state" disable-button="!completeStepOnBehalfForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Step completed -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="The next collaborator has been notified" ng-if="pageState === \'step-completed\'">\n\t<fs-main>\n\t\t<p class="s">The next collaborator has been notified that you\'ve completed this step. If you realise that you\'ve forgotten to do something however, and you need to let the next collaborator know, you can continue adding notes.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Query reports -->\n<form name="queryReportsForm" ng-submit="updateWorkflowTemplateQueried(vm, queryReportsForm)" class="fadeIn" ng-if="pageState === \'query-reports\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Why do you wish to query your reports?">\n\t\t<fs-main>\n\t\t\t<p class="s">Enter a query note below to tell us why you wish to query your reports. Once you click &lsquo;Send query&rsquo; you\'ll no longer be able to see the &lsquo;Approve reports&rsquo; and &lsquo;Query reports&rsquo; buttons until a revised set of draft reports have been created. Your query note will appear in the Notes tab.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="queryNote" class="required">Query note:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<mention-input name="queryNote" agency-profile-id="formOptions.agencyProfileId" ng-model="vm.newMessage.Text" required="true" rows="6" mention-list="vm.newMessage.MentionList"></mention-input>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="queryReportsForm.queryNote.$error" ng-if="queryReportsForm.queryNote.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please add a query note</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Send query\'" state="queryReportsForm.state" disable-button="!queryReportsForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Query sent -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Your query has been sent" ng-if="pageState === \'query-sent\'">\n\t<fs-main>\n\t\t<p class="s">Your query has been sent and has been added to the Notes tab. A revised set of draft reports will now be created and you\'ll be notified when they\'re ready for you to review.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Go back -->\n<form name="goBackForm" ng-submit="goBack(goBackForm)" class="fadeIn" ng-if="pageState === \'go-back\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to go back to the previous step?">\n\t\t<fs-main>\n\t\t\t<p class="s">Please note that going back a step won\u2019t affect any information that has already been added such as changes, notes and tasks. Earlier steps will still have their original deadline and may now be overdue. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Confirm\'" state="goBackForm.state" disable-button="!goBackForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/workflow/reassign-workflow-task/reassignWorkflowTaskForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="reassignWorkflowTaskForm" ng-submit="updateActioner(workflowTasks, vm.selectedActioner)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="workflowTasks.length === 1">\n\t\t<note note-theme="primary">\n\t\t\t<note-header>\n\t\t\t\t<h6><i class="icon-workflow-alt l strong"></i>&nbsp;&nbsp;{{workflowTasks[0].Title}}</h6>\n\t\t\t</note-header>\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">{{workflowTasks[0].Description}}</p>\n\t\t\t</note-content>\n\t\t</note>\n\t\t<div class="spacer s"></div>\n\t\t<p class="is-small">\n\t\t\tAssign a collaborator for this stage in the payroll process. A collaborator can be anyone who has access to this company\'s payroll.\n\t\t</p>\n\t</div>\n\n\t<div class="form-intro" ng-if="workflowTasks.length > 1">\n\t\t<p class="is-small">\n\t\t\tYou\'re about to reassign&#32;<ng-pluralize count="workflowTasks.length" when="{\'1\': \'1 workflow step\', \'other\': \'{} workflow steps\'}"></ng-pluralize>&#32;to\n\t\t\tanother actioner. This will update the workflow settings for the respective company and you can re-assign this step back to the same\n\t\t\tactioner at any time. Once you click \'Re-assign\', these workflow steps will appear in the selected actioners tasks area.\n\t\t</p>\n\t</div>\n\n\t<fieldset class="fadeIn" ng-if="vm.selectedActioner">\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Select a collaborator:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="vm.selectedActioner">\n\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleActionerIsSelected(vm, vm.selectedActioner)" class="s">Change</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="!vm.selectedActioner">\n\t\t<div class="form-field" ng-if="vm.adminGroups.BureauAdmins.length > 0 && $root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureau, USER_ROLES.bureaumanager])">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Bureau admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.BureauAdmins">\n\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleActionerIsSelected(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="vm.adminGroups.GroupAdmins.length > 0 && $root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureau, USER_ROLES.bureaumanager, USER_ROLES.groupuser, USER_ROLES.groupadminlite])">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Group admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.GroupAdmins">\n\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleActionerIsSelected(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="vm.adminGroups.CompanyAdmins.length > 0">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Company admins</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="admin-cards-workflow">\n\t\t\t\t\t<admin-card-workflow admin="admin" ng-repeat="admin in vm.adminGroups.CompanyAdmins">\n\t\t\t\t\t\t<action>\n\t\t\t\t\t\t\t<a href="" ng-click="toggleActionerIsSelected(vm, admin)" class="s">Select</a>\n\t\t\t\t\t\t</action>\n\t\t\t\t\t</admin-card-workflow>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Re-assign\'" state="reassignWorkflowTaskForm.state" disable-button="!vm.selectedActioner"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="{{ workflowTasks.length > 1 ? \'Steps\' : \'Step\' }} re-assigned" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">The selected workflow&#32;<ng-pluralize count="workflowTasks.length" when="{\'1\': \'step has\', \'other\': \'steps have\'}"></ng-pluralize>&#32;been re-assigned to {{vm.selectedActioner.Forename}} and will now appear in {{teamMember.Gender | personalise: \'his\'}} tasks area.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="No assignees available" ng-if="pageState === \'no-company-admins\'">\n\t<fs-main>\n\t\t<p class="s">You can\'t reassign&#32;\n\t\t\t<ng-pluralize count="workflowTasks.length" when="{\'1\': \'this\', \'other\': \'these\'}">\n\t\t\t</ng-pluralize>&#32;workflow&#32;<ng-pluralize count="workflowTasks.length" when="{\'1\': \'step\', \'other\': \'steps\'}"></ng-pluralize> at this time as there are no other admins available.\n\t\t\t\tThis may be because they either haven\'t been set up yet, or they don\'t have access to all the companies you\'ve selected.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/payroll/deleteHistoricTaxPeriod/deleteHistoricPayPeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteHistoricPayPeriodForm" ng-submit="deleteHistoricPayPeriod(deleteHistoricPayPeriodForm, payPeriod)">\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this pay period?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">Once you delete &lsquo;{{payPeriod.TaxMonth}}&rsquo;, it can\'t be undone and you will need to add your P32 figures again.\n\t\t\t\tPlease note that this won\'t affect any other pay periods in your history. Click \'Delete\' if you\'re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Delete\'" state="deleteHistoricPayPeriodForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<!-- Success -->\n\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Historic pay period deleted" ng-if="pageState === \'success\'">\n\t\t<fs-main>\n\t\t\t<p class="s">\'{{payPeriod.TaxMonth}}\' has been deleted and is no longer listed in your pay period history.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('modals/app/browser-compatibility-warning/app-browser-compatibility-warning.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block align-center">\n\t\t\t<h3>It\'s time to move on to a modern browser</h3>\n\t\t\t<div class="spacer m"></div>\n\t\t\t<p class="s">\n\t\t\t\tPaycircle has some exciting features and in order to get the very best experience,\n\t\t\t\tplease download or update your browser to one of the following:\n\t\t\t</p>\n\t\t\t<div class="spacer m"></div>\n\t\t\t<p class="s"><a href="https://www.whatismybrowser.com" target="_blank">\uD83E\uDD14 Click here to find out which browser you\'re using<i class="icon-chevron-right m"></i></a></p>\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<div class="button-cards">\n\t\t\t\t<button-card banner-text="{{browser.recommended ? \'RECOMMENDED\' : \'\'}}" button-link="{{browser.homePageUrl}}" img-src="images/browser-logos/{{browser.id}}.png" ng-repeat="browser in $ctrl.BROWSER_COMPATIBILITY_LIST | orderBy : \'recommended\'" subtitle="Version {{browser.minVersion}}+" title="{{browser.name}}"></button-card>\n\t\t\t</div>\n\t\t\t<div class="spacer xl"></div>\n\t\t\t<p class="s">\n\t\t\t\t<a href="" ng-click="$ctrl.modalOptions.closeModal()">\n\t\t\t\t\t\uD83D\uDE41 Continue with your current browser<i class="icon-chevron-right m"></i>\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t\t<p class="caption s">Only recommended if you\'re happy that some features may not work correctly!</p>\n\t\t</div>\n\t</modal-body>\n</modal>');
$templateCache.put('modals/employment/leave-date-expired/leave-date-expired.modal.html','\n<!-- Optional form wrapper if using submit button functionality -->\n<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<div class="modal_body-block">\n\n\t\t\t<!-- In setup mode -->\n\t\t\t<p class="is-small" ng-if="$ctrl.modalOptions.modalData.teamMember.IsInSetupMode">\n\t\t\t\tAs the leave date you have entered is in a previous tax year, the details on the P45 are no longer relevant for this tax year.\n\t\t\t\tYou will either need to request a more recent P45 from this team member or cancel this form and add a Starter Declaration for this team member.\n\t\t\t</p>\n\n\t\t\t<!-- Not in setup mode -->\n\t\t\t<p class="is-small" ng-if="!$ctrl.modalOptions.modalData.teamMember.IsInSetupMode">\n\t\t\t\tAs the leave date you have entered is in a previous tax year, the details on the P45 are no longer relevant for this tax year.\n\t\t\t\tYou will need to request a more recent P45 from this team member or await an update from HMRC. If you have electronic updates switched on, this will happen automatically.\n\t\t\t\tIf you do not have electronic updates enabled, HMRC will send a P6 form.\n\t\t\t</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a class="button is-small is-tertiary" href="" ng-click="$ctrl.modalOptions.closeModal()">\n\t\t\tGot it\n\t\t</a>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/generic/information/information.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<div class="modal_body-section" ng-repeat="informationItem in $ctrl.modalOptions.information">\n\t\t\t<p ng-if="informationItem.type === \'text\'">{{informationItem.content}}</p>\n\t\t\t<bullet-list ng-if="informationItem.type === \'list\'" bl-items="informationItem.content"></bullet-list>\n\t\t</div>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a class="button is-small" ng-click="$ctrl.modalOptions.closeModal()" href>\n\t\t\t{{$ctrl.modalOptions.closeButtonLabel || \'Close\'}}\n\t\t</a>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/imports/duplicate-mapping-headers/imports-duplicate-mapping-headers.modal.html','\n<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\n\t\t<article>\t\t\n\t\t\t<h4>\n\t\t\t\tThere\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.fileColumns.length" when="{\n\t\t\t\t\t\t\'1\': \'is {} duplicate header\',\n\t\t\t\t\t\t\'other\': \'are {} duplicate headers\'\n\t\t\t\t\t}"></ng-pluralize> in your file\n\t\t\t</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tAs you\u2019ve chosen to automatically map our headers you may wish to check that they have been mapped correctly and make any necessary adjustments. The following headers are duplicated\n\t\t\t\tin your file:\n\t\t\t</p>\n\t\t\t<bullet-list bl-items="$ctrl.modalOptions.modalData.fileColumnsDisplay" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t</article>\n\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a class="button is-small is-tertiary" href ng-click="$ctrl.modalOptions.closeModal()">Got it</a>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/imports/leavers/imports-leavers.modal.html','\n<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\n\t\t<article>\n\t\t\t<h4>\n\t\t\t\tThere\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.leavers.length" when="{\n\t\t\t\t\t\t\'1\': \'is {} leaver\',\n\t\t\t\t\t\t\'other\': \'are {} leavers\'\n\t\t\t\t\t}"></ng-pluralize> in your file\n\t\t\t</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tChanges are imported for leavers as a payment after leaving and set as a \'Regular\' payment by default. Unless you\'re adding a payment after leaving for share-based earnings, you need to change any leavers on an NT tax code to an 0T W1/M1 tax code.\n\t\t\t\tIf you don\'t wish to import changes for leavers you can ignore them from your import. If you need to make a team member a rejoiner, you can do so from their leaver profile in your \'Leavers\' area. The following team members in your file are leavers:\n\t\t\t</p>\n\t\t\t<bullet-list bl-items="$ctrl.modalOptions.modalData.leavers" bl-theme="is-small is-primary is-spaced-out"></bullet-list>\n\t\t</article>\n\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<button class="is-small is-tertiary" ng-click="$ctrl.modalOptions.closeModal()" type="button">\n\t\t\tGot it\n\t\t</button>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/imports/nothing-to-import/imports-nothing-to-import.modal.html','\n<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\n\t\t<article>\t\t\n\t\t\t<h5>Please review the data in your file</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tIt doesn\'t look like there\'s new or updated data to be imported from your file. Alternatively, you might have chosen to ignore all rows. Click &lsquo;Cancel&rsquo; before reviewing\n\t\t\t\tyour data and trying to import again.\n\t\t\t</p>\n\t\t</article>\n\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a class="button is-small" href ng-click="$ctrl.modalOptions.closeModal()">Cancel</a>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/payroll/reset-period/payroll-reset-period.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block company-card-modal-confirmation_header">\n\t\t\t<h4 class="company-card-modal-confirmation_header-title">Are you sure you wish to reset payroll?</h4>\n\t\t\t<p class="s">Your payroll submission has failed for the following reason:</p>\n\t\t</div>\n\n\t\t<submission-logs agency-profile-id="$ctrl.modalOptions.modalData.company.Company.AgencyProfileID" on-reset-period="$ctrl.modalOptions.callback()" pay-period-id="$ctrl.modalOptions.modalData.company.PayPeriod.PayPeriodID" submission-log-type="$ctrl.submissionLogType">\n\t\t\t<submission-logs-dismissed-copy>\n\t\t\t\tAll submission errors have been dismissed. <br>Reset payroll and try running it again.\n\t\t\t</submission-logs-dismissed-copy>\n\t\t</submission-logs>\n\n\t</modal-body>\n</modal>\n');
$templateCache.put('modals/session/timed-out/session-timed-out.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block align-center">\n\t\t\t<img src="images/graphics/placeholders/access-denied.2x.png" alt="Access denied" width="300">\n\t\t</div>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<h5>You have been signed out</h5>\n\t\t</div>\n\t</modal-body>\n\t<modal-primary-actions class="center-actions">\n\t\t<button class="is-tertiary" ng-click="$ctrl.clickSignIn()" type="button">\n\t\t\tSign in\n\t</button>\n\t</modal-primary-actions>\n</modal>');
$templateCache.put('modals/session/timeout-warning/session-timeout-warning.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block align-center">\n\t\t\t<progress-ring pr-percentage="$ctrl.percentageRemaining" pr-size="extraLarge" pr-theme-complete="tertiary">\n\t\t\t\t<pr-content>\n\t\t\t\t\t<span>{{$ctrl.countdown}}</span><br>Seconds\n\t\t\t\t</pr-content>\n\t\t\t</progress-ring>\n\t\t</div>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<h5 class="modal_body-block-heading">Your session is about to expire</h5>\n\t\t\t<p class="modal_body-block-heading">You will be signed out due to inactivity</p>\n\t\t</div>\n\t\t<div class="modal_body-block align-center">\n\t\t\t<a class="button m" href="" ng-click="$ctrl.modalOptions.callback()">\n\t\t\t\tSign out\n\t\t\t</a>\n\t\t\t<a class="button m tertiary" href="" ng-click="$ctrl.onExtendSession()">\n\t\t\t\tExtend session\n\t\t\t</a>\n\t\t</div>\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</modal-body>\n</modal>');
$templateCache.put('modals/settings/journal-code-preview-info/settings-journal-code-preview-info.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<div class="modal_body-block">\n\t\t\t<img alt="" src="images/graphics/journal-code-preview.png" style="width: 100%;">\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<h5>What is the full journal code format?</h5>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<p class="s">\n\t\t\t\tThe full journal code format shows you how your full journal code will be formatted based on how you\n\t\t\t\tcustomise it. For indicative purposes it simply shows a key for each of sub-codes you choose to include.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<p class="s">\n\t\t\t\tWhen you add team members to the business categories in their profiles their pay information, and pay\n\t\t\t\telements added for them, will be allocated to the respective journal code when you produce your journal\n\t\t\t\treport each pay period.\n\t\t\t</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a class="button is-small is-tertiary inverse" href="" ng-click="$ctrl.modalOptions.closeModal()">\n\t\t\tGot it\n\t\t</a>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/settings/journal-nominal-codes-allocation-report/settings-journal-nominal-codes-allocation-report.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<div class="nominal-code-preview-modal page-template-a">\n\t\t\t<div class="nominal-code-preview-modal_header-wrapper">\n\t\t\t\t<page-template-a-header icon="excel" page-title="Nominal codes"></page-template-a-header>\n\t\t\t\t<div>\n\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.modalOptions.callback()">\n\t\t\t\t\t\tExport CSV\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="s strong greyscale">\n\t\t\t\t{{$ctrl.modalOptions.modalData.nominalCodes.entries.allocated.length}} of {{$ctrl.modalOptions.modalData.nominalCodes.entries.all.length}} pay elements allocated\n\t\t\t</p>\n\t\t\t<div class="nominal-code-preview-modal_main">\n\t\t\t\t<nominal-code-preview nominal-codes-list="$ctrl.modalOptions.modalData.nominalCodes.all"></nominal-code-preview>\n\t\t\t</div>\n\t\t</div>\n\t</modal-body>\n</modal>');
$templateCache.put('modals/settings/pay-element-type/settings-pay-element-type.modal.html','<modal modal-options="$ctrl.modalOptions">\n\n\t<modal-body>\n\t\t<div class="modal_body-block">\n\t\t\t<pay-element-type-card class="l" pay-element-type="$ctrl.modalOptions.modalData.activePayElementType"></pay-element-type-card>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<div class="tag-list" data-cy="pay-element-tag-list">\n\n\t\t\t\t<div class="tag-list_item" ng-class="{\'is-active\' : setting.isActive}" ng-repeat="setting in $ctrl.modalOptions.modalData.activePayElementType.settings | filter: isVisible" data-cy="pay-element-tag-list-item">\n\t\t\t\t\t<h6 class="tag-list_item-title" data-cy="pay-element-tag-list-item-title-{{::setting.label | slugify}}">{{::setting.label}}</h6>\n\t\t\t\t\t<div class="tag-list_tag" data-cy="pay-element-tag-list-tag-{{::setting.label | slugify}}">\n\t\t\t\t\t\t<div class="tag l" ng-class="{\'indifferent\' : setting.isActive}" data-cy="pay-element-tag-list-tag-status">\n\t\t\t\t\t\t\t{{::!setting.isApplicable ? \'N/A\' : setting.isActive ? \'Yes\' : \'No\'}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="modal_body-block">\n\t\t\t<div class="spec-list" ng-switch="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentValueType">\n\t\t\t\t<div ng-if="$ctrl.modalOptions.modalData.currentCompany.CompanyType === $ctrl.INTERFACE_TYPES.bureau">\n\n\t\t\t\t\t<!-- Pensionable -->\n\t\t\t\t\t<div class="spec-list-item quarternary" ng-if="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntryPensionState">\n\t\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t\t<i class="icon-money"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<p class="spec-list-item-name">Workplace pension calculations</p>\n\t\t\t\t\t\t<p class="spec-list-item-description" ng-switch="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntryPensionBehaviour">\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\t\tThis pay element is included in pay when calculating pension contributions.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\t\tThis pay element is not included in pay when calculating pension contributions.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="[\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on,\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\tThis pay element can be included or excluded from pension calculations if it\'s duplicated or\n\t\t\t\t\t\t\t\ton a per company basis.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Net Pay -->\n\t\t\t\t\t<div class="spec-list-item quarternary" ng-if="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntryNetPayState">\n\t\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t\t<i class="icon-wallet"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<p class="spec-list-item-name">Net Pay calculations</p>\n\t\t\t\t\t\t<p class="spec-list-item-description" ng-switch="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntryNetPayBehaviour">\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\t\tThis pay element will be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\t\tThis pay element will not be included in any pay calculations for team members set to &lsquo;Net Pay&rsquo;.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="[\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on,\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\tThis pay element can be included or excluded in pay calculations for team members set to &lsquo;Net Pay&rsquo;\n\t\t\t\t\t\t\t\tif it\'s duplicated or on a per company basis.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Salary Sacrifice -->\n\t\t\t\t\t<div class="spec-list-item quarternary" ng-if="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntrySalarySacrificeState">\n\t\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t\t<i class="icon-salary-change"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<p class="spec-list-item-name">Salary sacrifice calculations</p>\n\t\t\t\t\t\t<p class="spec-list-item-description" ng-switch="$ctrl.modalOptions.modalData.activePayElementType.AgencyAdjustmentGroupEntrySalarySacrificeBehaviour">\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.onLocked">\n\t\t\t\t\t\t\t\tThis pay element will be included or excluded in salary sacrifice calculations for team members.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.offLocked">\n\t\t\t\t\t\t\t\tThis pay element will not be included or excluded in salary sacrifice calculations for team members.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span pc-switch-when="[\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.on,\n\t\t\t\t\t\t\t\t$ctrl.ADJUSTMENT_BEHAVIOUR_STATES.off\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\tThis pay element can be included or excluded from basic pay, for assessing if salary sacrifice deductions exceed basic pay, if it\u2019s duplicated or on a per company basis.\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Value Type -->\n\t\t\t\t<div class="spec-list-item primary" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.absolute">\n\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t<i class="icon-fixed-value"></i>\n\t\t\t\t\t</span>\n\t\t\t\t\t<p class="spec-list-item-name">Fixed value</p>\n\t\t\t\t\t<p class="spec-list-item-description">\n\t\t\t\t\t\tThis type of {{$ctrl.modalOptions.modalData.activePayElementType.IsDeduction ? \'deduction\' : \'addition\'}} can be added\n\t\t\t\t\t\tas a fixed value when applying it to a team member on payroll.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="spec-list-item primary" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.unit">\n\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t<i class="icon-fixed-value"></i>\n\t\t\t\t\t</span>\n\t\t\t\t\t<p class="spec-list-item-name">Unit value</p>\n\t\t\t\t\t<p class="spec-list-item-description">\n\t\t\t\t\t\tThis type of {{$ctrl.modalOptions.modalData.activePayElementType.IsDeduction ? \'deduction\' : \'addition\'}} can be added\n\t\t\t\t\t\twith units when applying it to a team member on payroll.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="spec-list-item primary" pc-switch-when="$ctrl.ADJUSTMENT_VALUE_TYPES.percentage">\n\t\t\t\t\t<span class="spec-list-item-icon">\n\t\t\t\t\t\t<i class="icon-percentage-value"></i>\n\t\t\t\t\t</span>\n\t\t\t\t\t<p class="spec-list-item-name">Percentage value</p>\n\t\t\t\t\t<p class="spec-list-item-description">\n\t\t\t\t\t\tThis type of {{$ctrl.modalOptions.modalData.activePayElementType.IsDeduction ? \'deduction\' : \'addition\'}} can be added\n\t\t\t\t\t\tas a percentage value when applying it to a team member on payroll.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<p class="caption" ng-if="$ctrl.modalOptions.modalData.currentCompany.CompanyType !== $ctrl.INTERFACE_TYPES.bureau">\n\t\t\t\tIf you wish to change these settings, please\n\t\t\t\t\tcontact support.\n\t\t\t</p>\n\t\t\t<p class="caption" ng-if="$ctrl.modalOptions.modalData.currentCompany.CompanyType === $ctrl.INTERFACE_TYPES.bureau">\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.payElementsCustomisation" underline="true">\n\t\t\t\t\tRead more about customising pay elements for holiday and pension calculations\n\t\t\t\t</support-article-link>.\n\t\t\t</p>\n\t\t</div>\n\t</modal-body>\n</modal>\n');
$templateCache.put('modals/team/advance-pay-periods/team-advance-pay-periods.modal.html','<form name="teamAdvancePayPeriodsModelForm" ng-submit="$ctrl.onContinue()">\n\t<modal modal-options="$ctrl.modalOptions">\n\t\t<modal-body>\n\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t\t<p class="s">Please note that {{$ctrl.modalOptions.modalData.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.counts.total}}&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.original" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>&nbsp;you\'ve selected can\'t be advanced future periods for the reasons below:</p>\n\t\t\t</article>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed === 0">\n\t\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t\t<p class="s">None of the team members you\'ve selected can be advanced future periods for the reasons below:</p>\n\t\t\t</article>\n\t\t\t<div class="modal-body-block">\n\t\t\t\t<div class="tag-list-alt">\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.leaverOrLeaving !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.leaverOrLeaving}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Leaver&rsquo; or &lsquo;Is leaving&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.onHold !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.onHold}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;On hold&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.incomplete !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.incomplete}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Incomplete profile</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.advancingOrAdvanced !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.advancingOrAdvanced}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Advancing&rsquo; or &lsquo;Has advanced&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.other !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.other}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Other</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed !== 0">\n\t\t\t\t<p class="s">If you\'re happy to proceed with the remaining&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.totalAllowed" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>, click &lsquo;Continue&rsquo;</p>\n\t\t\t</div>\n\n\t\t</modal-body>\n\t\t<modal-secondary-actions>\n\t\t\t<button type="button" class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal($ctrl)">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t</modal-secondary-actions>\n\n\t\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t<submit-button disable-button="!teamAdvancePayPeriodsModelForm.$valid" display-text="\'Continue\'" state="teamAdvancePayPeriodsModelForm.state"></submit-button>\n\t\t</modal-primary-actions>\n\t</modal>\n</form>\n');
$templateCache.put('modals/team/bulk-delete-summary/bulk-delete-summary.modal.html','\n<modal modal-options="$ctrl.modalOptions">\n\t\n\t<modal-body>\n\n\t\t<div class="modal_body-block">\n\n\t\t\t<!-- Some team members will be ignored -->\n\t\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted.length > 0">\n\t\t\t\t<h5 class="is-first">Some team members will be ignored</h5>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that {{$ctrl.modalOptions.modalData.teamMemberCounts.cannotBeDeleted.length}} of {{$ctrl.modalOptions.modalData.teamMemberCounts.total}}&nbsp;\n\t\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.teamMemberCounts.total" when="{\n\t\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t\t}"></ng-pluralize>&nbsp;you\'ve selected can\'t be deleted because they have either been included in a pay run or they have rejoined the team.\n\t\t\t\t</p>\n\t\t\t</article>\n\n\t\t\t<!-- Noone selected can be deleted -->\n\t\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted.length === 0">\n\t\t\t\t<h5 class="is-first">Please check the selected team members</h5>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tNone of the team members you\'ve selected can be deleted because have either been included in a pay run or they have rejoined the team.\n\t\t\t\t</p>\n\t\t\t</article>\n\t\t</div>\n\n\t</modal-body>\n\n\t<modal-secondary-actions ng-if="$ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted.length > 0">\n\t\t<button class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t</modal-secondary-actions>\n\n\t<modal-primary-actions>\n\n\t\t<button class="is-small is-tertiary" ng-click="$ctrl.openDeleteTeamMembersForm()" ng-if="$ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted.length > 0" type="button">\n\t\t\tContinue\n\t\t</button>\n\n\t\t<button class="is-small is-tertiary" ng-click="$ctrl.modalOptions.closeModal()" ng-if="$ctrl.modalOptions.modalData.teamMemberCounts.canBeDeleted.length === 0" type="button">\n\t\t\tGot it\n\t\t</button>\n\t</modal-primary-actions>\n\n</modal>\n');
$templateCache.put('modals/team/correctional-submission/team-correctional-submission.modal.html','<form name="teamEarlierYearUpdateForm" ng-submit="$ctrl.onContinue()">\n\t<modal modal-options="$ctrl.modalOptions">\n\t\t<modal-body>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t\t<p class="s">Please note that {{$ctrl.modalOptions.modalData.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.counts.total}}&nbsp;\n\t\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.counts.total" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>&nbsp;\n\t\t\t\t\tyou\'ve selected can\'t be included in {{$ctrl.modalOptions.modalData.eyuType === EYU_TYPES.YTDFPS ? \'a Earlier Year FPS\' : \'an earlier year update\'}} for the following reasons:</p>\n\t\t\t</article>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed === 0">\n\t\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t\t<p class="s">None of the team members you\'ve selected can be included in this {{$ctrl.modalOptions.modalData.eyuType === EYU_TYPES.YTDFPS ? \'Earlier Year FPS\' : \'Earlier year update\'}} because they\'re marked as &lsquo;Advancing&rsquo; or &lsquo;Has advanced&rsquo;.</p>\n\t\t\t</article>\n\t\t\t<div class="modal-body-block">\n\t\t\t\t<div class="tag-list-alt">\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.advancedOrAdvancing > 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.advancedOrAdvancing}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Advanced&rsquo; or &lsquo;Has advanced&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<p class="s">If you\'re happy to proceed with the remaining&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.totalAllowed" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>, click &lsquo;Continue&rsquo;</p>\n\t\t\t</div>\n\t\t</modal-body>\n\t\t<modal-secondary-actions>\n\t\t\t<button type="button" class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal($ctrl)">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t</modal-secondary-actions>\n\n\t\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t<submit-button disable-button="!teamEarlierYearUpdateForm.$valid" display-text="\'Continue\'" state="teamEarlierYearUpdateForm.state"></submit-button>\n\t\t</modal-primary-actions>\n\t</modal>\n</form>\n');
$templateCache.put('modals/team/excluded-from-rti/team-excluded-from-rti.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<article class="modal-body-block">\n\t\t\t<h5 class="first">Please review the team members you\u2019ve selected</h5>\n\t\t\t<p class="s no-margin bottom">\n\t\t\t\t{{$ctrl.modalOptions.modalData.counts.excludedFromRti}} of {{$ctrl.modalOptions.modalData.counts.original}} the team members you\u2019ve selected are omitted from RTI submissions.\n\t\t\t\tYou can process a supplementary pay run just for team members omitted from RTI submissions or just for team members active on payroll but not a combination of the two.\n\t\t\t\tFirst filter your team members by \u2019Status\u2019 before making your selection and trying again.\n\t\t\t</p>\n\t\t</article>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<button type="button" ng-click="$ctrl.modalOptions.closeModal($ctrl)">\n\t\t\tCancel\n\t\t</button>\n\t</modal-secondary-actions>\n</modal>\n');
$templateCache.put('modals/team/furlough/team-furlough.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<article class="modal_body-block">\n\t\t\t<h5 class="first">Some team members may be ignored</h5>\n\t\t\t<p class="s no-margin bottom">\n\t\t\t\tTeam members will be ignored if they are already furloughed, are currently marked as leaving or don\u2019t have a saved annual salary. Team members who are paid hourly will need to be\n\t\t\t\tfurloughed individually as a gross pay figure needs to be entered.\n\t\t\t</p>\n\t\t</article>\n\t</modal-body>\n\t<modal-primary-actions>\n\t\t<a class="button tertiary" href="" ng-click="$ctrl.modalOptions.callback()">Continue</a>\n\t</modal-primary-actions>\n\t<modal-secondary-actions>\n\t\t<a class="button" href="" ng-click="$ctrl.modalOptions.closeModal()">Cancel</a>\n\t</modal-secondary-actions>\n</modal>');
$templateCache.put('modals/team/invite-to-register/team-invite-to-register.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.totalAllowed > 0">\n\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that {{$ctrl.modalOptions.modalData.inviteToRegister.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.inviteToRegister.counts.original}}&nbsp;\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.inviteToRegister.counts.original" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>&nbsp;you\u2019ve selected won\u2019t be invited to register for the reasons below:\n\t\t\t</p>\n\t\t</article>\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.totalAllowed === 0">\n\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t<p class="is-small">None of the team members you\'ve selected can be invited to register for the reasons below:</p>\n\t\t</article>\n\t\t<div class="modal_body-block">\n\t\t\t<div class="tag-list-alt">\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.missingEmails > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.inviteToRegister.counts.missingEmails}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">No email address</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.alreadyRegistered > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.inviteToRegister.counts.alreadyRegistered}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Already registered</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.totalAllowed > 0">\n\t\t\t<p class="is-small">Click &lsquo;Continue&rsquo; if you\u2019re happy to proceed with the remaining team members selected.</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.inviteToRegister.counts.totalAllowed > 0">\n\t\t<a class="button tertiary" href="" ng-click="$ctrl.modalOptions.callback()">Continue</a>\n\t</modal-primary-actions>\n\t<modal-secondary-actions>\n\t\t<a class="button" href="" ng-click="$ctrl.modalOptions.closeModal()">Cancel</a>\n\t</modal-secondary-actions>\n</modal>');
$templateCache.put('modals/team/manage-rolled-up-holiday/team-manage-rolled-up-holiday.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.data.counts.totalAllowed > 0">\n\t\t\t<h5 class="first" data-cy="team-manage-rolled-up-holiday-modal-title-ignored">\n\t\t\t\tSome team members will be ignored\n\t\t\t</h5>\n\t\t\t<p class="s" data-cy="team-manage-rolled-up-holiday-modal-note-total-counts">\n\t\t\t\tPlease note that {{$ctrl.modalOptions.modalData.data.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.data.counts.total}}\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.data.counts.total" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\tyou\'ve selected can\'t be included because they are paid through the CIS scheme or marked as \'Off-payroll\'.\n\t\t\t</p>\n\t\t</article>\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.data.counts.totalAllowed === 0">\n\t\t\t<h5 class="first" data-cy="team-manage-rolled-up-holiday-modal-title-check">\n\t\t\t\tPlease check the selected team members\n\t\t\t</h5>\n\t\t\t<p class="is-small" data-cy="team-manage-rolled-up-holiday-modal-note-cant-be-included">\n\t\t\t\tPlease note that the\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.data.counts.total" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\tyou\'ve selected can\'t be included because they are paid through the CIS scheme or marked as \'Off-payroll\'.\n\t\t\t</p>\n\t\t</article>\n\t\t<div class="modal_body-block">\n\t\t\t<div class="tag-list-alt">\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.data.counts.cis > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag" data-cy="team-manage-rolled-up-holiday-modal-tag-cis">{{$ctrl.modalOptions.modalData.data.counts.cis}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label" data-cy="team-manage-rolled-up-holiday-modal-label-cis">Paid through CIS scheme</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.data.counts.offPayroll > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag" data-cy="team-manage-rolled-up-holiday-modal-tag-off-payroll">{{$ctrl.modalOptions.modalData.data.counts.offPayroll}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label" data-cy="team-manage-rolled-up-holiday-modal-label-off-payroll">Marked as \'Off-payroll\'</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.data.counts.totalAllowed > 0">\n\t\t\t<p class="s" data-cy="team-manage-rolled-up-holiday-modal-text-proceed-with">\n\t\t\t\tIf you\'re happy to proceed with the remaining\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.data.counts.totalAllowed" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>, click \'Continue\'\n\t\t\t</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.data.counts.totalAllowed > 0">\n\t\t<a class="button tertiary" data-cy="team-manage-rolled-up-holiday-modal-btn-continue" href="" ng-click="$ctrl.modalOptions.callback()">Continue</a>\n\t</modal-primary-actions>\n\t<modal-secondary-actions>\n\t\t<a class="button" data-cy="team-manage-rolled-up-holiday-modal-btn-cancel" href="" ng-click="$ctrl.modalOptions.closeModal()">Cancel</a>\n\t</modal-secondary-actions>\n</modal>');
$templateCache.put('modals/team/mark-as-on-hold-or-active/team-mark-as-on-hold-or-active.modal.html','<form name="teamMarkAsOnHoldOrActiveForm" ng-submit="$ctrl.onContinue()">\n\t<modal modal-options="$ctrl.modalOptions">\n\t\t<modal-body>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t\t<p class="s">Please note that {{$ctrl.modalOptions.modalData.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.counts.total}}&nbsp;\n\t\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.counts.total" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>&nbsp;\n\t\t\t\t\tyou\'ve selected can\'t be {{$ctrl.modalOptions.modalData.markAsOnHold ? \'marked as \u2018On hold\u2019\' : \'marked as \u2018Active on payroll\u2019\'}} for the following reasons:</p>\n\t\t\t</article>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed === 0">\n\t\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t\t<p class="s">None of the team members you\'ve selected can be {{$ctrl.modalOptions.modalData.markAsOnHold ? \'marked as \u2018On hold\u2019\' : \'marked as \u2018Active on payroll\u2019\'}} for the following reasons:</p>\n\t\t\t</article>\n\t\t\t<div class="modal-body-block">\n\t\t\t\t<div class="tag-list-alt">\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.advancedOrAdvancing !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.advancedOrAdvancing}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Advanced&rsquo; or &lsquo;Has advanced&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.alreadyOnHold !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.alreadyOnHold}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Already marked as &lsquo;On hold&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.alreadyActive !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.alreadyActive}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Already marked as &lsquo;Active on payroll&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<p class="s">If you\'re happy to proceed with the remaining&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.totalAllowed" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>, click &lsquo;Continue&rsquo;</p>\n\t\t\t</div>\n\t\t</modal-body>\n\t\t<modal-secondary-actions>\n\t\t\t<button type="button" class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal($ctrl)">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t</modal-secondary-actions>\n\n\t\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t<submit-button disable-button="!teamMarkAsOnHoldOrActiveForm.$valid" display-text="\'Continue\'" state="teamMarkAsOnHoldOrActiveForm.state"></submit-button>\n\t\t</modal-primary-actions>\n\t</modal>\n</form>\n');
$templateCache.put('modals/team/supplementary-pay-run/team-supplementary-pay-run.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body class="fadeIn">\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.totalAllowed > 0">\n\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t<p class="s">\n\t\t\t\tPlease note that {{$ctrl.modalOptions.modalData.supplementaryRun.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.supplementaryRun.counts.original}}&nbsp;\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.supplementaryRun.counts.original" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>&nbsp;you\'ve selected can\'t be included in this supplementary pay run because they are paid through the CIS scheme or have already had a supplementary payment made\n\t\t\t\tfor the most recent pay period.\n\t\t\t</p>\n\t\t</article>\n\t\t<article class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.totalAllowed === 0">\n\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t<p class="is-small">\n\t\t\t\tNone of the team members you\'ve selected can be included in this supplementary pay run because they\'re incomplete, are marked as &lsquo;Advanced&rsquo; or\n\t\t\t\t&lsquo;Has advanced&rsquo;, are paid through the CIS scheme or have already had a supplementary payment made for the most recent pay period.\n\t\t\t</p>\n\t\t</article>\n\t\t<div class="modal_body-block">\n\t\t\t<div class="tag-list-alt">\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.incomplete > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.incomplete}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">\n\t\t\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.supplementaryRun.counts.incomplete" when="{\n\t\t\t\t\t\t\t\t\'1\': \'Incomplete team member\',\n\t\t\t\t\t\t\t\t\'other\': \'Incomplete team members\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.leavers > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.leavers}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Leaver&rsquo;</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.cis > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.cis}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Paid through CIS scheme</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.offPayroll > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.offPayroll}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Off-payroll worker</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.advancedOrAdvancing > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.advancedOrAdvancing}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Marked as &lsquo;Advanced&rsquo; or &lsquo;Has advanced&rsquo;</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.other > 0">\n\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.supplementaryRun.counts.other}}</span>\n\t\t\t\t\t<p class="tag-list-alt_label">Supplementary payment already made</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal_body-block" ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.totalAllowed > 0">\n\t\t\t<p class="s">\n\t\t\t\tIf you\'re happy to proceed with the remaining&nbsp;\n\t\t\t\t<ng-pluralize count="$ctrl.modalOptions.modalData.supplementaryRun.counts.totalAllowed" when="{\n\t\t\t\t\t\t\'1\': \'team member\',\n\t\t\t\t\t\t\'other\': \'team members\'\n\t\t\t\t\t}"></ng-pluralize>, click &lsquo;Continue&rsquo;\n\t\t\t</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.supplementaryRun.counts.totalAllowed > 0">\n\t\t<a class="button tertiary" href="" ng-click="$ctrl.modalOptions.callback()">Continue</a>\n\t</modal-primary-actions>\n\t<modal-secondary-actions>\n\t\t<a class="button" href="" ng-click="$ctrl.modalOptions.closeModal()">Cancel</a>\n\t</modal-secondary-actions>\n</modal>');
$templateCache.put('modals/team/unmark-as-advancing/team-unmark-as-advancing.modal.html','<form name="unmarkAsAdvancingModalForm" ng-submit="$ctrl.onContinue()">\n\t<modal modal-options="$ctrl.modalOptions">\n\t\t<modal-body>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t\t<h5 class="first">Some team members will be ignored</h5>\n\t\t\t\t<p class="s">Please note that {{$ctrl.modalOptions.modalData.counts.totalNotAllowed}} of {{$ctrl.modalOptions.modalData.counts.total}}&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.original" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>&nbsp;you\'ve selected can\'t be advanced future periods for the reasons below:</p>\n\t\t\t</article>\n\t\t\t<article class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed === 0">\n\t\t\t\t<h5 class="first">Please check the selected team members</h5>\n\t\t\t\t<p class="s">None of the team members you\'ve selected can be unmarked as &lsquo;Advancing&rsquo; for the reasons below:</p>\n\t\t\t</article>\n\t\t\t<div class="modal-body-block">\n\t\t\t\t<div class="tag-list-alt">\n\t\t\t\t\t<div class="tag-list-alt_item" ng-if="$ctrl.modalOptions.modalData.counts.leaverOrLeaving !== 0">\n\t\t\t\t\t\t<span class="tag assertive inverse tag-list-alt_tag">{{$ctrl.modalOptions.modalData.counts.notAdvancing}}</span>\n\t\t\t\t\t\t<p class="tag-list-alt_label">Not marked as &lsquo;Advancing&rsquo;</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="modal-body-block" ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed !== 0">\n\t\t\t\t<p class="s">If you\'re happy to proceed with the remaining&nbsp;<ng-pluralize count="$ctrl.modalOptions.modalData.counts.totalAllowed" when="{\'1\': \'team member\', \'other\': \'team members\'}"></ng-pluralize>, click &lsquo;Continue&rsquo;</p>\n\t\t\t</div>\n\t\t</modal-body>\n\t\t<modal-secondary-actions>\n\t\t\t<button type="button" class="is-greyscale" ng-click="$ctrl.modalOptions.closeModal($ctrl)">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t</modal-secondary-actions>\n\n\t\t<modal-primary-actions ng-if="$ctrl.modalOptions.modalData.counts.totalAllowed > 0">\n\t\t\t<submit-button disable-button="!unmarkAsAdvancingModalForm.$valid" display-text="\'Continue\'" state="unmarkAsAdvancingModalForm.state"></submit-button>\n\t\t</modal-primary-actions>\n\t</modal>\n</form>\n');
$templateCache.put('modals/workflow/draft-reports/workflow-draft-reports.modal.html','<modal-dialog modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<article>\n\t\t\t\t<h4 class="is-first">Your draft reports are ready</h4>\n\t\t\t\t<p class="is-small">Payroll has been calculated and your draft reports are ready for you to review.</p>\n\t\t\t</article>\n\t\t</div>\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<div class="info-block positive has-border">\n\t\t\t\t<h6 class="is-positive"><i class="icon-clock is-large has-margin-right"></i> Due: {{$ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.DueDateISO | dateformat:\'long\'}}</h6>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-dialog_section">\n\t\t\t<h4>What you need to do next</h4>\n\t\t</div>\n\t\t<div class="modal-dialog_section">\n\t\t\t<div class="row has-gutter has-margin is-large">\n\t\t\t\t<div class="col six">\n\t\t\t\t\t<graphic-card graphic-key="query-reports" layout="is-stacked" theme="is-indifferent">\n\t\t\t\t\t\t<copy>\n\t\t\t\t\t\t\t<h5 class="is-first">I need to make further changes</h5>\n\t\t\t\t\t\t\t<p class="is-small is-last">\n\t\t\t\t\t\t\t\tIf you spot something wrong, or if you\u2019ve forgotten to tell us about something, click on the &lsquo;Query reports&rsquo; button.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</copy>\n\t\t\t\t\t</graphic-card>\n\t\t\t\t</div>\n\t\t\t\t<div class="col six">\n\t\t\t\t\t<graphic-card graphic-key="approve-reports" layout="is-stacked" theme="is-positive">\n\t\t\t\t\t\t<copy>\n\t\t\t\t\t\t\t<h5 class="is-first">I\'m happy the reports are correct</h5>\n\t\t\t\t\t\t\t<p class="is-small is-last">\n\t\t\t\t\t\t\t\tClick on the &lsquo;Approve reports&rsquo; button at the top of the page and we will be notified that payroll is ready to run.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</copy>\n\t\t\t\t\t</graphic-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-dialog_body-action-block align-center">\n\t\t\t<a href class="button is-tertiary is-medium" ng-click="$ctrl.updateWorkflowTemplateEntrySplashState($ctrl)">Review Draft Reports</a>\n\t\t</div>\n\n\t</modal-body>\n</modal-dialog>\n');
$templateCache.put('modals/workflow/payroll-information/workflow-payroll-information.modal.html','<modal-dialog modal-options="$ctrl.modalOptions">\n\n\t<!-- Not Overdue -->\n\t<modal-body ng-if="!$ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.IsOverdue">\n\t\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<article>\n\t\t\t\t<h4 class="is-first">We need your payroll information</h4>\n\t\t\t\t<p>Your new pay period is open and we\'re ready for you to start sharing your information with us.</p>\n\t\t\t</article>\n\t\t</div>\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<div class="info-block positive has-border">\n\t\t\t\t<h6 class="is-positive"><i class="icon-clock is-large has-margin-right"></i> Due: {{$ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.DueDateISO | dateformat:\'long\'}}</h6>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-dialog_section">\n\n\t\t\t<graphic-card graphic-key="add-your-data">\n\t\t\t\t<copy>\n\t\t\t\t\t<h4 class="is-first">What you need to do next</h4>\n\t\t\t\t\t<p class="is-small">Click the &lsquo;Add&rsquo; button to add notes and files telling us about your payroll changes. You can sign in anytime to do this.</p>\n\t\t\t\t</copy>\n\t\t\t</graphic-card>\n\n\t\t</div>\n\t\t<div class="modal-dialog_body-action-block align-center">\n\t\t\t<a href class="button is-tertiary is-medium" ng-click="$ctrl.updateWorkflowTemplateEntrySplashState($ctrl)">Get started</a>\n\t\t</div>\n\t</modal-body>\n\n\t<!-- Overdue -->\n\t<modal-body ng-if="$ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.IsOverdue">\n\t\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<article>\n\t\t\t\t<h4 class="is-first">Your payroll information is overdue</h4>\n\t\t\t\t<p class="is-small">Your payroll information was due by the deadline shown.</p>\n\t\t\t</article>\n\t\t</div>\n\t\t<div class="modal-dialog_section has-margin-large">\n\t\t\t<div class="info-block assertive has-border">\n\t\t\t\t<h6 class="is-assertive"><i class="icon-clock is-large has-margin-right"></i> Due: {{$ctrl.modalOptions.modalData.workflowTemplate.TemplateEntryCurrent.DueDateISO | dateformat:\'long\'}}</h6>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-dialog_section">\n\n\t\t\t<graphic-card graphic-key="overdue-confirmation" theme="is-assertive">\n\t\t\t\t<copy>\n\t\t\t\t\t<h4 class="is-first">What you need to do next</h4>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tIf you\u2019ve added everything or there are no changes to make, just click the &lsquo;I\u2019ve added everything&rsquo; button to confirm everything is ready.\n\t\t\t\t\t\tOr you can leave a note if you have any queries.\n\t\t\t\t\t</p>\n\t\t\t\t</copy>\n\t\t\t</graphic-card>\n\n\t\t</div>\n\t\t<div class="modal-dialog_body-action-block align-center">\n\t\t\t<a href class="button is-tertiary is-medium" ng-click="$ctrl.updateWorkflowTemplateEntrySplashState($ctrl)">Get started</a>\n\t\t</div>\n\n\t</modal-body>\n</modal-dialog>\n');
$templateCache.put('modals/app/smart-view-feedback/smart-view-feedback.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<div class="smart-view-feedback-modal" ng-class="{\'is-success\': $ctrl.modalState === \'success\'}">\n\t\t\t\n\t\t\t<div class="smart-view-feedback-modal_content">\n\t\t\t\t<div class="smart-view-feedback-modal_form" ng-if="$ctrl.modalState === \'ready\'">\n\t\t\t\t\t<p class="smart-view-feedback-modal_greeting">\n\t\t\t\t\t\tThanks, {{$ctrl.userName}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="smart-view-feedback-modal_subtitle">\n\t\t\t\t\t\tPlease take a moment to share some additional feedback.\n\t\t\t\t\t</p>\n\t\t\t\t\t<textarea class="smart-view-feedback-modal_textarea" ng-model="$ctrl.feedback.text" ng-change="$ctrl.updateCharacterCount()" maxlength="200" ng-trim="false" placeholder="Enter your feedback" rows="4"></textarea>\n\t\t\t\t\t\n\t\t\t\t\t<div class="smart-view-feedback-modal_counter">\n\t\t\t\t\t\t{{$ctrl.characterCount}}/{{$ctrl.maxCharacters}} characters\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div ng-if="$ctrl.modalState === \'success\'" class="smart-view-feedback-success">\n\t\t\t\t\t<div class="smart-view-feedback-success_content">\n\t\t\t\t\t\t<div class="smart-view-feedback-success_icon">\n\t\t\t\t\t\t\t<i class="icon-tick xxxl positive"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h3 class="smart-view-feedback-success_title">Thanks!</h3>\n\t\t\t\t\t\t<p class="smart-view-feedback-success_subtitle">We really appreciate the feedback.</p>\n\t\t\t\t\t\t<a href ng-click="$ctrl.modalOptions.closeModal()">\n\t\t\t\t\t\t\tClose this window\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t\n\t\t\t\t\t<confetti confetti-id="feedback-confetti" ng-if="$ctrl.showConfetti" x="0.5" y="0.5"></confetti>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div ng-if="$ctrl.modalState === \'error\'">\n\t\t\t\t\t<p>Sorry, there was an error submitting your feedback. Please try again.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</modal-body>\n\t\n\t<modal-secondary-actions>\n\t\t<button class="button is-greyscale" ng-click="$ctrl.modalOptions.closeModal()" ng-if="$ctrl.modalState === \'ready\'" type="button">\n\t\t\tNo thanks\n\t\t</button>\n\t</modal-secondary-actions>\n\t\n\t<modal-primary-actions>\n\t\t<button class="button tertiary" ng-click="$ctrl.submitFeedback()" ng-disabled="!$ctrl.feedback.text.trim()" ng-if="$ctrl.modalState === \'ready\'" type="button">\n\t\t\tSend\n\t\t</button>\n\t</modal-primary-actions>\n</modal>');
$templateCache.put('modals/app/cookie-preferences/cookie-preferences.modal.html','<modal modal-options="$ctrl.modalOptions">\n\t<modal-body>\n\t\t<!-- Initial Consent Step -->\n\t\t<div ng-if="$ctrl.showInitialConsent">\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<h5>Cookie Preferences Required</h5>\n\t\t\t</div>\n\t\t\n\t\t<div class="modal_body-block">\n\t\t\t\t\t<p class="is-small">We use cookies to enhance your experience on our website. Please make your choice to continue using our platform.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal_body-block">\n\t\t\t\t\t<a class="link-with-icon" data-cy="view-cookie-policy-link" ng-href="{{$ctrl.cookiePolicyUrl}}" rel="noopener noreferrer" target="_blank">\n\t\t\t\t\t\t<i class="icon-right"></i>\n\t\t\t\t\t\tView our Cookie Policy \n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\n\t\t<!-- Detailed Preferences Step -->\n\t\t<div ng-if="!$ctrl.showInitialConsent">\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<h5>Customise your preferences</h5>\n\t\t\t</div>\n\t\t\t<div class="modal_body-block">\n\t\t\t\t\t<p class="is-small">We use cookies to enhance your experience on our website. You can choose which categories of cookies to allow.</p>\n\t\t\t\t</div>\n\t\t\t\n\t\t\t\t<form class="form modal_body-block" name="cookiePreferencesForm">\n\t\t\t\t<fieldset class="fieldset">\n\t\t\t\t\t<div class="settings-rows">\n\t\t\t\t\t\t<settings-row ng-repeat="category in $ctrl.cookieCategories" ng-model="$ctrl.preferences[category.key]" sr-disabled="category.required" sr-field-name="{{category.key}}" sr-icon="cookie" sr-theme="primary" sr-content-collapsed="$ctrl.expandedCategories[category.key]">\n\t\t\t\t\t\t\t<sr-label>\n\t\t\t\t\t\t\t\t<span>{{category.name}}</span>\n\t\t\t\t\t\t\t\t<span class="tag is-inverse is-primary float-right" ng-if="category.required">\n\t\t\t\t\t\t\t\t\tEssential\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</sr-label>\n\t\t\t\t\t\t\t<sr-description>\n\t\t\t\t\t\t\t\t<p class="is-small">{{category.shortDescription}}</p>\n\t\t\t\t\t\t\t\t<a class="is-underline" ng-click="$ctrl.toggleCategory(category.key)">\n\t\t\t\t\t\t\t\t\t{{$ctrl.expandedCategories[category.key] ? \'Show less\' : \'Show more\'}} info\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t\t\t<sr-content ng-if="$ctrl.expandedCategories[category.key]">\n\t\t\t\t\t\t\t\t<div class="fadeIn">\n\t\t\t\t\t\t\t\t\t<p class="is-small">{{category.description}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</sr-content>\n\t\t\t\t\t\t</settings-row>\n\t\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t\t</form>\n\t\t\t<div class="modal_body-block">\n\t\t\t\t<a class="link-with-icon" data-cy="view-cookie-policy-link" ng-href="{{$ctrl.cookiePolicyUrl}}" rel="noopener noreferrer" target="_blank">\n\t\t\t\t\t<i class="icon-right"></i>\n\t\t\t\t\tView our Cookie Policy \n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</modal-body>\n\t<!--First step actions-->\n\t<modal-secondary-actions ng-if="$ctrl.showInitialConsent">\n\t\t<button class="button" ng-click="$ctrl.showManagePreferences()" type="button">\n\t\t\tManage preferences\n\t\t</button>\n\t</modal-secondary-actions>\n\n\t<modal-primary-actions ng-if="$ctrl.showInitialConsent">\n\t\t<button class="button is-tertiary" ng-click="$ctrl.requiredOnly()" type="button">\n\t\t\tRequired only\n\t\t</button>\n\t\t<button class="button is-tertiary" ng-click="$ctrl.acceptAllFromInitial()" type="button">\n\t\t\tAccept all\n\t\t</button>\n\t</modal-primary-actions>\n\t<!--Manage preferences step actions-->\n\t<modal-secondary-actions ng-if="!$ctrl.showInitialConsent">\n\t\t<button class="button" ng-click="$ctrl.rejectAll()" type="button">\n\t\t\tRequired only\n\t\t</button>\n\t</modal-secondary-actions>\n\t<modal-primary-actions ng-if="!$ctrl.showInitialConsent">\n\t\t<button class="button is-tertiary" ng-click="$ctrl.savePreferences()" type="button">\n\t\t\tSave preferences\n\t\t</button>\n\t\t<button class="button is-tertiary" ng-click="$ctrl.acceptAll()" type="button">\n\t\t\tAccept all\n\t\t</button>\n\t</modal-primary-actions>\n</modal>\n');
$templateCache.put('scripts/directives/templates/info-tooltip.html','<div class="info-tooltip {{position}}" ng-switch="tooltipInfoType">\n\t<div class="info-tooltip_wrapper" ng-switch-when="adjustment">\n\t\t<ul class="info-tooltip_list">\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.IsTaxable }">\n\t\t\t\t<div class="info-tooltip_listitem-text">Taxable</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.IsTaxable | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.IsNIable }">\n\t\t\t\t<div class="info-tooltip_listitem-text">National Insurance</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.IsNIable | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.IsNotional }">\n\t\t\t\t<div class="info-tooltip_listitem-text">Notional Payment</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.IsNotional | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.IsBIK }">\n\t\t\t\t<div class="info-tooltip_listitem-text">Benefit in kind</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.IsBIK | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.IsSalarySacrifice }">\n\t\t\t\t<div class="info-tooltip_listitem-text">Salary sacrifice</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.IsSalarySacrifice | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.NMWState }">\n\t\t\t\t<div class="info-tooltip_listitem-text">National Minimum/Living Wage checks</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.NMWState | yesNo}}</div>\n\t\t\t</li>\n\t\t\t<li class="info-tooltip_listitem" ng-class="{ \'info-tooltip_listitem-positive\': tooltipInfoSource.NetPayState }">\n\t\t\t\t<div class="info-tooltip_listitem-text">Net pay calculation</div>\n\t\t\t\t<div class="info-tooltip_listitem-indicator">{{tooltipInfoSource.NetPayState | yesNo}}</div>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>\n<span ng-transclude>\n</span>');
$templateCache.put('scripts/directives/templates/tooltip.html','<div ng-if="showTooltip" role="tooltip" class="tooltip {{position}} {{tooltipTheme}}" ng-class="{\'tooltip--has-icon\' : tooltipIcon}">\n\t<span class="tooltip__icon" ng-if="tooltipIcon">\n\t\t<i class="{{tooltipIcon}}" ng-class="tooltipIconTheme"></i>\n\t</span>\n\t<p class="tooltip__text" data-cy="tooltip-text">{{tooltipText}}</p>\n</div>\n<span ng-transclude>\n</span>');
$templateCache.put('features/app/data-importer/import-data/data-importer-import-data.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\t<action-bar class="dropIn" subtitle="{{::IS_BUREAU_MAPPING ? \'Mapping template builder\' : \'Importer\'}}">\n\t\t<action-bar-right>\n\t\t\t<a class="link-with-icon tertiary" ng-href="{{backNgHref}}">\n\t\t\t\t<i class="icon-cross"></i>Close\n\t\t\t</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<div class="data-importer_mapping" ng-switch="vm.state">\n\t\t<!-- Xero loading -->\n\t\t<div class="data-importer_state align-center fadeIn" pc-switch-when="\'xero-loading\'">\n\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<h4 class="data-importer_state-title">We\u2019re just getting your Chart of Accounts</h4>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<progress-ring pr-badge="xero" pr-percentage="vm.xeroLoadingPercentage" pr-size="medium" pr-theme-complete="primary"></progress-ring>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Access Financials loading -->\n\t\t<div class="data-importer_state align-center fadeIn" pc-switch-when="\'financials-loading\'">\n\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<h4 class="data-importer_state-title" ng-if="vm.importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts">We\u2019re just getting your Chart of Accounts</h4>\n\t\t\t\t<h4 class="data-importer_state-title" ng-if="vm.importMappingType === IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories">We\u2019re just getting your Nominal Categories</h4>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<progress-ring pr-percentage="vm.financialsLoadingPercentage" pr-size="medium" pr-theme-complete="primary">\n\t\t\t\t\t<pr-content class="data-importer_state-section_access-logo">\n\t\t\t\t\t\t<img src="/images/logo/integrations/access-logo.2x.png" alt="access-logo">\n\t\t\t\t\t</pr-content>\n\t\t\t\t</progress-ring>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Document details (Bureau) -->\n\t\t<div class="data-importer_pre-header" ng-if="::!$root.currentCompany.isPayrollCompany && vm.importMappingTemplate.isTemplate" pc-switch-when="\'mapping\'">\n\n\t\t\t<!-- Template info -->\n\t\t\t<div class="data-importer_template-info">\n\t\t\t\t<div class="data-importer_template-info-icon is-primary">\n\t\t\t\t\t<i class="icon-upload"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-importer_template-info-details" ng-switch="vm.stateKey">\n\t\t\t\t\t<h6 class="data-importer_template-info-name">{{::vm.importMappingTemplate.Name}}</h6>\n\t\t\t\t\t<p class="is-small" ng-switch-when="data-importer.import-data">\n\t\t\t\t\t\t{{::vm.importMappingType | importMappingTypeDescription}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Document details (Company) -->\n\t\t<div class="data-importer_pre-header" ng-if="::$root.currentCompany.isPayrollCompany && vm.state !== \'xero-loading\' && vm.state !== \'financials-loading\'">\n\n\t\t\t<!-- File info -->\n\t\t\t<div class="data-importer_file-info">\n\t\t\t\t<div class="data-importer_file-info-icon is-primary">\n\t\t\t\t\t<i class="icon-csv"></i>\n\t\t\t\t</div>\n\t\t\t\t<span class="data-importer_file-info-name is-primary">{{::vm.document.DocumentName}}</span>\n\t\t\t\t<span class="data-importer_file-info-context" ng-switch="vm.stateKey">\n\t\t\t\t\t<span ng-switch-when="data-importer.import-data">{{::vm.importMappingTypeDisplay | importMappingTypeDescription}}</span>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<!-- Mapping template -->\n\t\t\t<div class="data-importer_template" ng-if="vm.importMappingTemplate.isTemplate" pc-switch-when="\'mapping\'">\n\t\t\t\t<span class="data-importer_template-status" ng-if="vm.importMappingTemplate.IsGlobalTemplate" tooltip tooltip-position="left" tooltip-size="s" tooltip-text="Bureau-managed mapping">\n\t\t\t\t\t<icon-dot icon="icon-company-groups" theme="is-large is-tertiary"></icon-dot>\n\t\t\t\t</span>\n\t\t\t\t<p class="s">\n\t\t\t\t\t<span>{{vm.importMappingTemplate.Name}}</span>\n\t\t\t\t\t<a class="is-underlined" href="" ng-click="restartImport(true)">\n\t\t\t\t\t\tchange\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Mapping Templates -->\n\t\t<div class="data-importer_state m fadeIn align-left" pc-switch-when="\'mapping-templates\'">\n\t\t\t<header class="data-importer_intro">\n\t\t\t\t<h4>Use a mapping template</h4>\n\t\t\t\t<p class="s">If you always use the same mapping template to validate files, you can set your selection as the default and we won\u2019t ask you to pick one every time.</p>\n\t\t\t</header>\n\n\t\t\t<!-- Select template -->\n\t\t\t<div class="data-importer_field">\n\t\t\t\t<header class="data-importer_field-header">\n\t\t\t\t\t<label class="data-importer_field-label required" for="selectTemplate">\n\t\t\t\t\t\tSelect template:\n\t\t\t\t\t</label>\n\t\t\t\t\t<a class="is-small greyscale data-importer_field-header-action" ui-sref="settings.company.imports.mappings({\n\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tManage templates\n\t\t\t\t\t</a>\n\t\t\t\t</header>\n\t\t\t\t<main class="data-importer_field-main">\n\t\t\t\t\t<select class="block" id="selectTemplate" name="selectTemplate" ng-model="vm.importMappingTemplate" ng-options="template as template.IsDefault ? template.Name + \' (default)\' : template.Name for template in vm.mappingTemplates track by template.ImportMappingID" required></select>\n\t\t\t\t</main>\n\t\t\t\t<div class="data-importer_field-errors fadeIn" ng-if="templateForm.selectTemplate.$touched" ng-messages="templateForm.selectTemplate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a template</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Set as default -->\n\t\t\t<div class="data-importer_field fadeIn">\n\t\t\t\t<div class="data-importer_field-main">\n\t\t\t\t\t<input checkbox id="setAsDefault" label-text="\'Set as default template when importing \' + vm.importMappingTypeDescription + \' for \' + currentCompany.Name" name="setAsDefault" ng-model="vm.importMappingTemplate.IsDefault" type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validation results (team) -->\n\t\t<div class="data-importer_section fadeIn" pc-switch-when="\'validation-results-team\'">\n\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t<header class="data-importer_intro">\n\t\t\t\t\t<h4>\n\t\t\t\t\t\t<i class="icon-warning tertiary"></i>&nbsp;\n\t\t\t\t\t\t<ng-pluralize count="vm.validationResults.length" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 team member needs action\',\n\t\t\t\t\t\t\t\t\'other\': \'{} team members need action\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t</h4>\n\t\t\t\t\t<p class="s">Click on a highlighted team member for more information</p>\n\t\t\t\t</header>\n\n\t\t\t\t<!-- File Data -->\n\t\t\t\t<div class="table-shadow has-scrollbar import-data-mapping-table">\n\t\t\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t\t\t<table class="c">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th>Ignore</th>\n\t\t\t\t\t\t\t\t\t<th class="column-header is-primary" ng-repeat="column in vm.fileData.Columns | filter:vm.showHiddenColumnsFilter">\n\t\t\t\t\t\t\t\t\t\t{{::column.ImportMappingColumnText}}\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr dir-paginate="row in rows = ( vm.fileData.Rows | itemsPerPage: 10 )" ng-class="{\'tertiary\': row.isInvalid, \'disabled\': row.isDisabled || row.Ignore}">\n\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t<input class="pc-checkbox import-data-mapping-checkbox" id="row-{{row.originalIndex}}" ng-change="reValidateAll(vm)" ng-model="row.Ignore" type="checkbox">\n\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t<td ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'has-cell-action\': cell.validationResult\n\t\t\t\t\t\t\t\t\t\t}" ng-if="vm.hiddenColumnsArr.indexOf(cellIndex) === -1" ng-repeat="(cellIndex, cell) in row.cells">\n\t\t\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t\t\t\t<a aria-label="Open map user" class="cell-action" href="" ng-click="openMapUserForm($parent.$parent.$index, row, $index, cell)" ng-if="cell.validationResult && !row.Ignore" title="{{cell.validationResult.ValidationTypeText}}"><i class="icon-warning tertiary"></i></a>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7">\n\t\t\t\t</dir-pagination-controls>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validation results (PayElements)-->\n\t\t<div class="data-importer_section fadeIn" pc-switch-when="\'validation-results-recurring-payelements\'">\n\t\t\t<validation-results file-data="vm.fileData" active-validation-result-filter="vm.activeValidationResultFilter" allow-actions-on-updates="true" validation-result-filters="vm.validationResultFilters" is-ignore-all-rows-enabled="vm.isIgnoreAllRowsEnabled" show-hidden-columns-filter="vm.showHiddenColumnsFilter" show-hidden-columns="SHOW_HIDDEN_COLUMNS" hidden-columns-array="vm.hiddenColumnsArr" on-toggle-ignore-row="reValidateAll(vm)" on-toggle-ignore-all-rows="toggleIsIgnoreAllRowsEnabled(vm, filteredRows, isIgnoreAllRowsEnabled)" validation-results-title="Your Recurring Pay Elements will be imported as follows" validation-results-message="Review any warnings before clicking \'Import\'" on-update-filter="setActiveValidationResultFilter(vm, validationResultFilter)" on-validation-result-action="openUpdateValidationResultForm(vm, row, validationResult)" on-pay-element-validation-action="openPayElementMatchingForm(vm, row, validationResult)">\n\t\t\t</validation-results>\n\t\t</div>\n\n\t\t<!-- Validation results (nominal codes)-->\n\t\t<div class="data-importer_section fadeIn" pc-switch-when="\'validation-results\'">\n\t\t\t<validation-results file-data="vm.fileData" active-validation-result-filter="vm.activeValidationResultFilter" validation-result-filters="vm.validationResultFilters" is-ignore-all-rows-enabled="vm.isIgnoreAllRowsEnabled" show-hidden-columns-filter="vm.showHiddenColumnsFilter" show-hidden-columns="SHOW_HIDDEN_COLUMNS" hidden-columns-array="vm.hiddenColumnsArr" on-toggle-ignore-row="reValidateAll(vm)" on-toggle-ignore-all-rows="toggleIsIgnoreAllRowsEnabled(vm, filteredRows, isIgnoreAllRowsEnabled)" validation-results-title="Your nominal codes will be imported as follows" validation-results-message="Review any warnings before clicking \'Import\'" on-update-filter="setActiveValidationResultFilter(vm, validationResultFilter)" on-validation-result-action="openUpdateValidationResultForm(vm, row, validationResult)">\n\t\t\t</validation-results>\n\t\t</div>\n\n\t\t<!-- Validating -->\n\t\t<div class="data-importer_state fadeIn" pc-switch-when="\'validating\'">\n\t\t\t<div class="data-importer_state-graphic">\n\t\t\t\t<progress-ring pr-icon="icon-upload" pr-percentage="vm.uploadingProgress" pr-theme-complete="tertiary" pr-size="medium">\n\t\t\t\t</progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">We\'re just checking your file...</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the &lsquo;Back&rsquo; button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validated -->\n\t\t<div class="data-importer_state s fadeIn" pc-switch-when="\'validated\'">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary xl"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">That\'s it, your file has been checked!</h5>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<p>This file is now ready to start importing data.</p>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<p>\n\t\t\t\t\t<a class="tertiary underline" data-cy="data-importer-import-data-view-validated-go-to-files" ui-sref="data-importer.my-files({\n\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t\t\t\t})">Go to files</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Data mapping -->\n\t\t<div class="data-importer_content" id="data-importer-content" pc-switch-when="\'mapping\'">\n\n\t\t\t<!-- Auto Mapped -->\n\t\t\t<div class="data-importer_title" ng-if="::vm.IS_AUTO_MAPPED">\n\t\t\t\t<div class="data-importer_title-bar">\n\t\t\t\t\t<h4>Link elements have been automatically matched to your headers</h4>\n\t\t\t\t</div>\n\t\t\t\t<p class="s">Click &lsquo;Match link element&rsquo; to select a link rate for any unmatched columns</p>\n\t\t\t</div>\n\n\t\t\t<!-- Manually Mapped -->\n\t\t\t<div class="data-importer_title" ng-if="::!vm.IS_AUTO_MAPPED">\n\t\t\t\t<div class="data-importer_title-bar">\n\t\t\t\t\t<h4>Match our headers to your columns</h4>\n\n\t\t\t\t\t<!-- Mapping Templates -->\n\t\t\t\t\t<div class="data-importer_title-bar-actions">\n\n\t\t\t\t\t\t<div class="button-container">\n\t\t\t\t\t\t\t<button class="white" ng-click="onToggleFullScreen()" type="button">\n\t\t\t\t\t\t\t\t<i class="icon-full-screen"></i>\n\t\t\t\t\t\t\t\tFull screen\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Unable to update Bureau level template at company level -->\n\t\t\t\t\t\t<div class="button-container fadeIn" ng-if="vm.isMappingValid && vm.hasTemplateMappingChanged && !isFullScreenActive()">\n\t\t\t\t\t\t\t<a class="button is-tertiary" href="" ng-click="openMappingTemplateForm(vm, \'create\')">\n\t\t\t\t\t\t\t\tSave new mapping\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="button" href="" ng-click="openMappingTemplateForm(vm, \'update\')" ng-if="vm.importMappingTemplate.isTemplate && !(vm.importMappingTemplate.IsGlobalTemplate && $root.currentCompany.isPayrollCompany)">\n\t\t\t\t\t\t\t\tUpdate mapping\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="button-container">\n\t\t\t\t\t\t\t<a class="button" data-cy="automap-button" href="" ng-click="autoMapColumnsByName(vm)">\n\t\t\t\t\t\t\t\t<i class="icon-loading has-margin-right"></i>Auto-map\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="s">Select the header you wish to map, then click on &lsquo;Map header&rsquo; for the column you wish to map it to</p>\n\t\t\t</div>\n\n\t\t\t<div class="data-importer_section">\n\t\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t\t<!-- Mapping Headers -->\n\t\t\t\t\t<div class="import-data-mapping-section" ng-if="::!vm.IS_AUTO_MAPPED">\n\t\t\t\t\t\t<!-- Filter -->\n\t\t\t\t\t\t<div class="import-data-mapping-section" ng-if="vm.mappingColumns.length > vm.DEFAULT_MAPPING_COLUMNS_VISIBLE && vm.filterBarOptionsMappingColumns.filters.length > 0">\n\t\t\t\t\t\t\t<filter-bar-basic filter-bar-options="vm.filterBarOptionsMappingColumns"></filter-bar-basic>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Headers to map -->\n\t\t\t\t\t\t<div class="import-data-mapping-section">\n\t\t\t\t\t\t\t<div class="mapping-headers" ng-class="[\n\t\t\t\t\t\t\t\t\tvm.filterBarOptionsMappingColumns.displayOption.key,\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\t\'has-active-radio\': isMappingHeaderIndexSet(vm)\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\t<div class="mapping-header_card-wrapper fadeInFast" ng-repeat="mappingColumn in vm.mappingColumnsFiltered = (\n\t\t\t\t\t\t\t\t\t\tvm.mappingColumns |\n\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\'isIgnored\': false\n\t\t\t\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\t\t\t\tfilter: vm.filterBarOptionsMappingColumns.filterExp |\n\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\'ImportMappingColumnText\': vm.filterBarOptionsMappingColumns.searchString\n\t\t\t\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\t\t\t\tfilter: filterRecurringElementOptions |\n\t\t\t\t\t\t\t\t\t\tlimitTo: vm.mappingColumnsVisible\n\t\t\t\t\t\t\t\t\t)">\n\n\t\t\t\t\t\t\t\t\t<!-- Radio (Important: Needs to sit next to input - sibling selector) -->\n\t\t\t\t\t\t\t\t\t<input class="mapping-header_card-radio" id="mapping-header_{{::mappingColumn.originalIndex}}" name="mapping-header_{{::mappingColumn.originalIndex}}" ng-click="reviewActiveMappingColumn(vm, mappingColumn)" ng-disabled="!mappingColumn.isReusable && mappingColumn.isInUse" ng-model="vm.activeMappingHeaderIndex" ng-value="mappingColumn.originalIndex" type="radio">\n\n\t\t\t\t\t\t\t\t\t<!-- Card -->\n\t\t\t\t\t\t\t\t\t<label class="mapping-header_card-label" data-cy="mapping-header-card-{{::mappingColumn.ImportMappingColumnText | slugify}}" data-cy-validation-value="{{::mappingColumn.ImportMappingColumnValidationValue}}" for="mapping-header_{{::mappingColumn.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'has-hover-state\': mappingColumn.isReusable || !mappingColumn.isInUse,\n\t\t\t\t\t\t\t\t\t\t\t\'has-tooltip\': mappingColumn.hasTooltip,\n\t\t\t\t\t\t\t\t\t\t\t\'is-disabled\': !mappingColumn.isReusable && mappingColumn.isInUse\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t{{mappingColumn.ImportMappingColumnText}}\n\t\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t\t\t<!-- Tooltip -->\n\t\t\t\t\t\t\t\t\t<a aria-label="Show information tooltip" class="mapping-header_card-tooltip-link" data-cy="mapping-header-card-tooltip-{{::mappingColumn.ImportMappingColumnText | slugify}}" href="" ng-click="$root.$broadcast(\'toggle-tooltip-card\', mappingColumn.tooltip)" ng-if="mappingColumn.hasTooltip">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-information"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p ng-if="vm.mappingColumnsFiltered.length === 0">\n\t\t\t\t\t\t\t\t\tNo mapping header results\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Show more -->\n\t\t\t\t\t\t<div class="import-data-mapping-section" ng-if="\n\t\t\t\t\t\t\t\tvm.filterBarOptionsMappingColumns.displayOption.key === \'is-layout-grid\' &&\n\t\t\t\t\t\t\t\tvm.mappingColumnsVisible <= vm.mappingColumnsFiltered.length\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<a class="s" href="" ng-click="showMoreMappingColumns(vm)"><i class="icon-chevron-down"></i>&nbsp;More</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- File Data -->\n\t\t\t\t\t<div class="import-data-mapping-section">\n\t\t\t\t\t\t<div class="import-data-mapping-tables">\n\n\t\t\t\t\t\t\t<div class="import-data-mapping_header">\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-details">\n\n\t\t\t\t\t\t\t\t\t<!-- Show context -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="vm.importContext === IMPORT_CONTEXT_TYPES.employeeData && !IS_BUREAU_MAPPING">\n\t\t\t\t\t\t\t\t\t\t<a aria-label="Toggle content" class="is-greyscale" href="" ng-click="toggleShowContext(vm)">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-chevron-left is-small fadeIn" ng-if="vm.isContextVisible"></i><i class="icon-left-pane"></i><i class="icon-chevron-right is-small fadeIn" ng-if="!vm.isContextVisible"></i>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Row/Column count -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item">\n\t\t\t\t\t\t\t\t\t\t<span class="is-greyscale-darkened is-small">\n\t\t\t\t\t\t\t\t\t\t\t{{vm.fileData.columnsFiltered.length}} columns, {{vm.fileData.rowsFiltered.length}} rows\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Ignore All Rows -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="!IS_BUREAU_MAPPING">\n\t\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t<input checkbox class="xs" id="isIgnoreAllRowsEnabled" label-text-class="is-small" label-text="\'Ignore all rows\'" name="isIgnoreAllRowsEnabled" ng-change="toggleIsIgnoreAllRowsEnabled(vm)" ng-model="vm.isIgnoreAllRowsEnabled" type="checkbox">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Policy matching summary -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="vm.uniquePolicyNamesCollected && importMappingType === IMPORT_MAPPING_TYPES.policyImport">\n\t\t\t\t\t\t\t\t\t\t<span class="is-small" data-cy="policy-matching-summary" ng-class="{\'assertive\': !vm.allPoliciesMatched, \'positive\': vm.allPoliciesMatched}">\n\t\t\t\t\t\t\t\t\t\t\t{{vm.policyMatchedCount}} of {{vm.policyTotalCount}} policies matched\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-display">\n\n\t\t\t\t\t\t\t\t\t<!-- Column Visibility -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-actions">\n\t\t\t\t\t\t\t\t\t\t<span class="is-greyscale-darkened is-small">Columns:</span>\n\t\t\t\t\t\t\t\t\t\t<a class="import-data-mapping_header-actions-action is-small" href="" ng-click="hideEmptyColumns(vm)">Hide empty</a>\n\t\t\t\t\t\t\t\t\t\t<a class="import-data-mapping_header-actions-action is-small" href="" ng-click="showEmptyColumns(vm)">Show all</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Data -->\n\t\t\t\t\t\t\t<div class="import-data-mapping-tables_body">\n\n\t\t\t\t\t\t\t\t<!-- File data -->\n\t\t\t\t\t\t\t\t<div class="import-data-mapping-table" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'has-overlay\': vm.isContextVisible && vm.importContext === IMPORT_CONTEXT_TYPES.employeeData && !IS_BUREAU_MAPPING,\n\t\t\t\t\t\t\t\t\t\t\'is-small\': !vm.isChangeTypeMapped && !vm.isLinkElementMapped,\n\t\t\t\t\t\t\t\t\t\t\'is-medium\': (vm.isChangeTypeMapped || vm.isLinkElementMapped) && !vm.isRatedElementMapped,\n\t\t\t\t\t\t\t\t\t\t\'is-large\': vm.isChangeTypeMapped && vm.isRatedElementMapped\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t<div class="table-shadow" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'has-scrollbar\' : hasScrollWidth (\'table-wrapper-id\'),\n\t\t\t\t\t\t\t\t\t\t\t\'hide-right-shadow\' : !hasScrollWidth (\'table-wrapper-id\')\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t<div class="table-wrapper" id="table-wrapper-id" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'has-scrollbar\' : hasScrollWidth (\'table-wrapper-id\'),\n\t\t\t\t\t\t\t\t\t\t\t\t\'hide-x-scroll\' : !hasScrollWidth (\'table-wrapper-id\')\n\t\t\t\t\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t\t\t\t\t<table class="c has-drop-zones">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Drop zones -->\n\t\t\t\t\t\t\t\t\t\t\t\t<thead class="drop-zone-cards" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-hover-states-enabled\': vm.activeMappingHeaderIndex || vm.activeMappingHeaderIndex === 0\n\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="column-header is-fluid" ng-if="vm.importContext === IMPORT_CONTEXT_TYPES.companyData">&nbsp;</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th ng-if="vm.uniquePolicyNamesCollected && importMappingType === IMPORT_MAPPING_TYPES.policyImport">&nbsp;</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper" data-cy="mapping-header-card-{{::column.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active positive\': column.state === \'valid\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active assertive\': column.state === \'invalid\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-repeat="column in vm.fileData.Columns | filter: vm.showHiddenColumnsFilter" ng-switch="column.state">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Matched -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card is-active is-positive fadeIn" ng-click="reviewActiveMappingColumn(vm, column.mappingHeader)" ng-switch-when="valid">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Not linked -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!column.isLinked">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{column.mappingHeader.ImportMappingColumnText}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.isPayElementNetable || column.mappingHeader.isPayElementNetable">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(<a class="drop-zone-card_link" href="" ng-click="openEditPayElementNetToGrossForm(vm, column.originalIndex)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{column.AgencyAdjustmentNetToGross ? \'Net\' : \'Gross\'}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Rate type -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.mappingHeader.isPayElementRateTypeEditable && column.AgencyAdjustmentRateType && column.AgencyAdjustmentRateType !== IMPORT_RATE_TYPES.none">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(<a class="drop-zone-card_link" href="" ng-click="openEditPayElementRateTypeForm(vm, column.originalIndex)">{{ column.AgencyAdjustmentRateType | importPayElementRateType }}</a>)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Linked -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.isLinked">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{column.mappingHeader.ImportMappingColumnText}}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Rate / Unit label -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-show="column.adjustmentType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t({{column.mappingHeader.ImportMappingColumnType | importMappingColumnTypeDescription}})\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Net / Gross -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.isPayElementNetable || column.mappingHeader.isPayElementNetable">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t({{column.AgencyAdjustmentNetToGross ? \'Net\' : \'Gross\'}})\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Rate type -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.mappingHeader.isPayElementRateTypeEditable && column.AgencyAdjustmentRateType && column.AgencyAdjustmentRateType !== IMPORT_RATE_TYPES.none">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(x<a class="drop-zone-card_link" href="" ng-click="openEditPayElementRateTypeForm(vm, column.originalIndex)">{{ column.AgencyAdjustmentRateType | importPayElementRateType }}</a>)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card_cancel" href="" ng-click="deleteColumnMapping(vm, column.originalIndex, column.mappingHeader.originalIndex)"></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Invalid -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card is-active is-assertive fadeIn" ng-click="reviewActiveMappingColumn(vm, column.mappingHeader)" ng-switch-when="invalid">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{column.mappingHeader.ImportMappingColumnText}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.isLinked">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-show="column.adjustmentType">({{column.mappingHeader.ImportMappingColumnType | importMappingColumnTypeDescription}})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card_cancel" href="" ng-click="deleteColumnMapping(vm, column.originalIndex, column.mappingHeader.originalIndex)"></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Drop header -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card is-placeholder has-hover-state fadeIn" href="" ng-click="mapColumn(vm, column)" ng-if="::!vm.IS_AUTO_MAPPED" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="block align-center" ng-if="column.loadingState === \'loading\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.loadingState !== \'loading\'">Map header</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card is-placeholder has-hover-state fadeIn" href="" ng-click="openMatchLinkElementFormVertical(vm, column.originalIndex)" ng-if="::vm.IS_AUTO_MAPPED" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-plus"></i> Match link element\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Adjustment labels -->\n\t\t\t\t\t\t\t\t\t\t\t\t<tbody ng-if="vm.isPayElementImportMappingTypeWithElementLabel && !IS_BUREAU_MAPPING">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-repeat="column in vm.fileData.columnsFiltered = (vm.fileData.Columns | filter: vm.showHiddenColumnsFilter)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="s" href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-disabled\': !column.isInUse\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-click="openMatchPayslipLabelForm(vm, column.originalIndex)" ng-if="!column.mappingHeader.disableLabelAssignment">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{column.AgencyAdjustmentLabel !== \'\' ? column.AgencyAdjustmentLabel : \'Add payslip label\'}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Data headers -->\n\t\t\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="column-header is-fluid" ng-if="vm.importContext === IMPORT_CONTEXT_TYPES.companyData">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tIgnore\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" data-cy="policy-details-column-header" ng-if="vm.uniquePolicyNamesCollected && importMappingType === IMPORT_MAPPING_TYPES.policyImport">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPolicy Details\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="column-header has-action" data-cy="mapping-header-column-{{::column.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active positive\': column.state === \'valid\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active assertive\': column.state === \'invalid\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-repeat="column in vm.fileData.columnsFiltered = ( vm.fileData.Columns | filter: vm.showHiddenColumnsFilter )">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>{{::column.ImportMappingColumnText}} ({{column.cellCountNotEmpty}})</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a aria-label="Toggle hidden column" class="is-greyscale-lightened column-header_action" href="" ng-click="toggleShowColumn(vm, column)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-hidden"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Data -->\n\t\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr dir-paginate="row in vm.fileData.rowsFiltered = ( vm.fileData.Rows | itemsPerPage: 10 )" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'disabled\': row.Ignore\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Ignore -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="is-fluid align-center" ng-if="::vm.importContext === IMPORT_CONTEXT_TYPES.companyData">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="pc-checkbox is-small import-data-mapping-checkbox" id="row-{{row.originalIndex}}" ng-change="reValidateAll(vm)" ng-model="row.Ignore" type="checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Policy Details -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fadeIn" data-cy="policy-details-cell" ng-if="vm.uniquePolicyNamesCollected && importMappingType === IMPORT_MAPPING_TYPES.policyImport">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" data-cy="policy-details-matched" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchPolicyDetailsForm(vm, getPolicyNameForRow(vm, row))" ng-if="vm.policyMatches[getPolicyNameForRow(vm, row)] && vm.policyMatches[getPolicyNameForRow(vm, row)].matched && !vm.policyMatches[getPolicyNameForRow(vm, row)].skipped && vm.policyMatches[getPolicyNameForRow(vm, row)].data.policyPayBasis === 1">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAnnual Salary | {{vm.policyMatches[getPolicyNameForRow(vm, row)].data.hoursPerWeek}} hrs | {{vm.policyMatches[getPolicyNameForRow(vm, row)].data.weeksPerYear}} wks\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" data-cy="policy-details-matched" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchPolicyDetailsForm(vm, getPolicyNameForRow(vm, row))" ng-if="vm.policyMatches[getPolicyNameForRow(vm, row)] && vm.policyMatches[getPolicyNameForRow(vm, row)].matched && !vm.policyMatches[getPolicyNameForRow(vm, row)].skipped && vm.policyMatches[getPolicyNameForRow(vm, row)].data.policyPayBasis === 2">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAnnual Allowance | Pensionable: {{vm.policyMatches[getPolicyNameForRow(vm, row)].data.isPensionable ? \'Yes\' : \'No\'}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline greyscale" data-cy="policy-details-skipped" href="" ng-click="openMatchPolicyDetailsForm(vm, getPolicyNameForRow(vm, row))" ng-if="vm.policyMatches[getPolicyNameForRow(vm, row)] && vm.policyMatches[getPolicyNameForRow(vm, row)].skipped">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSkipped\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline assertive" data-cy="policy-details-click-to-match" href="" ng-class="{\'greyscale\': row.Ignore, \'is-disabled\': !getPolicyNameForRow(vm, row)}" ng-click="openMatchPolicyDetailsForm(vm, getPolicyNameForRow(vm, row))" ng-if="!vm.policyMatches[getPolicyNameForRow(vm, row)] || !vm.policyMatches[getPolicyNameForRow(vm, row)].matched">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tClick to match\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Data -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td data-cy="table-data-{{::row.originalIndex}}-{{::cell.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'assertive is-invalid\': !cell.isValid,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-editing\': cell.state === \'editing\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-repeat="cell in row.cells | filter: vm.showHiddenColumnsFilterForCells">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-editing\': cell.state === \'editing\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-invalid\': !cell.isValid && cell.state !== \'editing\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-switch="cell.state">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Editing -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="table-inline-edit-cell_input" id="cell-{{::row.originalIndex}}-{{::cell.originalIndex}}" ng-blur="validateCellData(vm, cell)" ng-model="cell.value" ng-style="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twidth: cell.width + \'px\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-switch-when="editing" pc-keypress pc-keypress-action="validateCellData(vm, cell)" pc-keypress-key="enter" type="text">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Display -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell_value" ng-click="editCell(cell, row.originalIndex, $event)" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- States -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell_states" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-if="!row.Ignore && cell.state !== \'editing\' && cell.state !== \'loading\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-cross table-inline-edit-cell_state hide-on-hover" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-if="!cell.isValid"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-edit table-inline-edit-cell_state show-on-hover" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Context pane -->\n\t\t\t\t\t\t\t\t<div class="table-overlay import-data-mapping-table-overlay" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'is-small\': !vm.isChangeTypeMapped && !vm.isLinkElementMapped,\n\t\t\t\t\t\t\t\t\t\t\'is-medium\': (vm.isChangeTypeMapped || vm.isLinkElementMapped) && !vm.isRatedElementMapped,\n\t\t\t\t\t\t\t\t\t\t\'is-large\': vm.isChangeTypeMapped && vm.isRatedElementMapped\n\t\t\t\t\t\t\t\t\t}" ng-if="vm.isContextVisible && vm.importContext === IMPORT_CONTEXT_TYPES.employeeData && !IS_BUREAU_MAPPING">\n\n\t\t\t\t\t\t\t\t\t<table class="c" style="width:100%">\n\t\t\t\t\t\t\t\t\t\t<thead class="drop-zone-cards">\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card-placeholder"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card-placeholder">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<select class="block" ng-model="vm.teamMemberViewType" ng-options="viewType as viewType.description for viewType in vm.teamMemberViewTypes track by viewType.key"></select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper fadeIn" ng-if="vm.isChangeTypeMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card-placeholder"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper fadeIn" ng-if="vm.isLinkElementMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card-placeholder"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody ng-if="vm.isPayElementImportMappingTypeWithElementLabel">\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="align-center">Ignore</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th>{{vm.teamMemberViewType.description}}</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="fadeIn" ng-if="vm.isChangeTypeMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\tMatch change type\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="fadeIn" ng-if="vm.isLinkElementMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\tMatch link element\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr dir-paginate="row in rows = ( vm.fileData.Rows | itemsPerPage: 10 )" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'assertive\': row.isInvalid,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\'disabled\': row.Ignore\n\t\t\t\t\t\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Ignore -->\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="align-center">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="pc-checkbox is-small import-data-mapping-checkbox" id="row-{{row.originalIndex}}" ng-change="reValidateAll(vm)" ng-disabled="!row.isTeamMemberValid" ng-model="row.Ignore" type="checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<td ng-switch="vm.teamMemberViewType.key">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Full Name -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-user-field" ng-switch-when="full-name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'greyscale\': row.Ignore\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-click="openValidateDataForm(row)" ng-if="row.isTeamMemberValid">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="getFullNameDescriptionForRow(row, true)" title="{{getFullNameDescriptionForRow(row)}}"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!row.isTeamMemberValid">Team member removed</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- NI Number -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-user-field" ng-switch-when="ni-number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{getNIDescriptionForRow(row)}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Adjustment Type -->\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="fadeIn" ng-if="vm.isChangeTypeMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchChangeTypeFormHorizontal(vm, row.originalIndex)" ng-if="row.adjustmentType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{row.adjustmentLabel !== \'\' ? row.adjustmentLabel : row.adjustmentType.AgencyAdjustmentGroupEntryText}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="row.adjustmentType.AgencyAdjustmentNetToGross">({{row.adjustmentType.NetToGross ? \'Net\' : \'Gross\'}})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="row.AgencyAdjustmentRateType && row.AgencyAdjustmentRateType !== IMPORT_RATE_TYPES.none">({{ row.AgencyAdjustmentRateType | importPayElementRateType }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline assertive" data-cy="open-match-change-type-link-{{::row.originalIndex}}" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchChangeTypeFormHorizontal(vm, row.originalIndex)" ng-if="!row.adjustmentType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tClick to match\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Link elements -->\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="fadeIn" ng-if="vm.isLinkElementMapped">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchLinkElementFormHorizontal(vm, row.originalIndex)" ng-if="row.adjustmentType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{row.adjustmentType.LinkElementName}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline assertive" data-cy="open-match-change-type-link-{{::row.originalIndex}}" href="" ng-class="{\'greyscale\': row.Ignore}" ng-click="openMatchLinkElementFormHorizontal(vm, row.originalIndex)" ng-if="!row.adjustmentType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tClick to match\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7">\n\t\t\t\t\t\t\t</dir-pagination-controls>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="data-importer_state fadeIn" pc-switch-when="\'import-blocked\'" role="alert">\n\t\t\t<div class="icon-badge assertive l data-importer_state-graphic"><i class="icon-warning icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">The import could not be completed</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s" ng-repeat="error in vm.importErrors">{{error}}</p>\n\t\t\t\t<a class="s strong underline" data-cy="blocked-import-go-back" ng-href="{{backNgHref}}">Return to imports</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="data-importer_state fadeIn" pc-switch-when="\'calculated-pay-history-import-locked\'" role="alert">\n\t\t\t<div class="icon-badge assertive l data-importer_state-graphic"><i class="icon-padlock icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Calculated pay history cannot be imported</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">Payroll is currently calculated. Unlock payroll before importing historic pay data.</p>\n\t\t\t\t<a class="s strong underline" data-cy="calculated-pay-history-import-locked-go-to-team" ui-sref="team.imports({agencyProfileId: vm.agencyProfileId})">Return to team imports</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Importing changes -->\n\t\t<div class="data-importer_state fadeIn" pc-switch-when="\'importing\'">\n\t\t\t<div class="data-importer_state-graphic">\n\t\t\t\t<progress-ring pr-icon="icon-csv" pr-percentage="vm.importingPercentComplete" pr-size="medium" pr-theme-complete="primary"></progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">Your changes are being imported...</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the &lsquo;Back&rsquo; button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Imported -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'imported\'">\n\t\t\t<div class="icon-badge primary l data-importer_state-graphic"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Your import has finished</h5>\n\t\t\t<div class="data-importer_state-section" ng-switch="vm.importContext">\n\n\t\t\t\t<!-- Company data -->\n\t\t\t\t<div class="data-importer_state-copy" pc-switch-when="IMPORT_CONTEXT_TYPES.companyData">\n\t\t\t\t\t<div ng-switch="vm.importMappingType">\n\t\t\t\t\t\t<p class="s" pc-switch-when="[\n\t\t\t\t\t\t\t\tIMPORT_MAPPING_TYPES.businessCategories,\n\t\t\t\t\t\t\t\tIMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories\n\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\tYour import has been recorded in the Imports tab in your business categories area\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" pc-switch-when="IMPORT_MAPPING_TYPES.policyImport">\n\t\t\t\t\t\t\tYour pay policy import has finished\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" ng-switch-default>\n\t\t\t\t\t\t\tYour import has been recorded in the Imports tab in your journal settings area\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employee data -->\n\t\t\t\t<div class="data-importer_state-copy" ng-switch-default>\t\t\t\t\t\n\t\t\t\t\t<div ng-switch="vm.importMappingType">\n\t\t\t\t\t\t<p class="s" pc-switch-when="IMPORT_MAPPING_TYPES.sickness">\n\t\t\t\t\t\t\tYour sick pay schedule import has finished\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="s" ng-switch-default>\n\t\t\t\t\t\t\tYour import has been recorded in the Imports tab in your Current period\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section fadeIn" ng-if="vm.hasImportSummaryToDisplay">\n\n\t\t\t\t<div class="data-importer_summary-block">\n\t\t\t\t\t<import-summary import-summary="vm.importSummary" is-pay-element-import="vm.isAdjustmentImportMappingType"></import-summary>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="data-importer_state-section fadeIn" ng-if="!vm.hasImportSummaryToDisplay && vm.importMappingType === IMPORT_MAPPING_TYPES.policyImport">\n\t\t\t\t<p class="s greyscale">No changes were made. The imported file matches your existing data.</p>\n\t\t\t</div>\n\n\t\t\t<div class="data-importer_state-section" ng-switch="vm.agencyDocumentType">\n\n\t\t\t\t<div ng-switch="vm.importMappingType" pc-switch-when="DOCUMENT_TYPES.periodImport">\n\t\t\t\t\t<!-- Current Period > Team -->\n\t\t\t\t\t<a class="s strong underline" data-cy="go-to-current-period-link" pc-switch-when="[IMPORT_MAPPING_TYPES.linkedElements, IMPORT_MAPPING_TYPES.linkRateUnits]" ui-sref="payroll.current-period.team({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\t\tGo to your current period\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<!-- Current Period > Current Period -->\n\t\t\t\t\t<a class="s strong underline" data-cy="go-to-current-period-link" ng-switch-default ng-href="{{$root.currentCompany.ngHref.payroll}}">\n\t\t\t\t\t\tGo to your current period\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\n\t\t\t\t<a class="s strong underline" data-cy="go-to-business-categories-link" pc-switch-when="[\n\t\t\t\t\t\tDOCUMENT_TYPES.businessCategories,\n\t\t\t\t\t\tDOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport,\n\t\t\t\t\t]" ui-sref="settings.company.business-categories.category({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\tGo to business categories settings\n\t\t\t\t</a>\n\t\t\t\t<a class="s strong underline" data-cy="go-to-journal-settings-link" pc-switch-when="[\n\t\t\t\t\t\tDOCUMENT_TYPES.nominalCodes,\n\t\t\t\t\t\tDOCUMENT_TYPES.accessFinancialsNominalAccountsImport,\n\t\t\t\t\t\tDOCUMENT_TYPES.xeroNominalCodes\n\t\t\t\t\t]" ui-sref="settings.company.journals.nominal-codes({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\tGo to journal settings\n\t\t\t\t</a>\n\t\t\t\t<a class="s strong underline" data-cy="go-to-team-link" pc-switch-when="DOCUMENT_TYPES.teamImport" ui-sref="team.members({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\tGo to your team\n\t\t\t\t</a>\n\t\t\t\t<a class="s strong underline" data-cy="go-to-pay-policies-link" pc-switch-when="DOCUMENT_TYPES.policyImport" ui-sref="hr.policies.pay({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\tGo to pay policies\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section align-left" ng-if="!vm.hasSavedFileMapping && !vm.hasUsedTemplate">\n\t\t\t\t<note note-theme="indifferent" note-title="Save a mapping template" note-icon="icon-support">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tWe notice you didn\u2019t use or save a mapping template during your import. Saving a template means you can reuse it without having to match the headers every time you import.\n\t\t\t\t\t\t\t<a class="underline is-indifferent" href="" ng-click="openMappingTemplateForm(vm, \'create\')">\n\t\t\t\t\t\t\t\tSave mapping template now\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Mapping Templates -->\n<full-page-controls ng-if="vm.state === \'mapping-templates\'">\n\n\t<fpc-primary>\n\t\t<button class="tertiary" data-cy="data-importer-import-data-view-mapping-templates-next" ng-click="initMapping(vm)" type="button">\n\t\t\tNext\n\t\t</button>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Validation results (team) -->\n<full-page-controls ng-if="vm.state === \'validation-results-team\'">\n\n\t<fpc-primary>\n\t\t<button class="tertiary" data-cy="data-importer-import-data-view-validation-results-next" ng-click="updateImportMappingFile(vm)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" type="button">\n\t\t\tNext\n\t\t</button>\n\t</fpc-primary>\n\n\t<fpc-secondary>\n\t\t<a data-cy="data-importer-import-data-view-validation-results-cancel-import" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<!-- Validation results (other) -->\n<full-page-controls ng-if="vm.state === \'validation-results\'">\n\t<fpc-primary>\n\t\t<button class="tertiary" data-cy="data-importer-import-data-view-validation-results-import" ng-click="updateImportMappingFile(vm)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" type="button">\n\t\t\tImport\n\t\t</button>\n\t</fpc-primary>\n</full-page-controls>\n\n<full-page-controls ng-if="vm.state === \'validation-results-recurring-payelements\'">\n\t<fpc-primary>\n\t\t<button class="tertiary" data-cy="data-importer-import-data-view-validation-results-recurring-payelements-import" ng-click="vm.activeValidationResultFilter.hasActions ? validatePayElementImportFile(vm, false, true) : generateUserImport(vm, true)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" type="button">\n\t\t\tImport Data\n\t\t</button>\n\t</fpc-primary>\n\n\t<fpc-secondary>\n\t\t<a data-cy="data-importer-import-data-view-validation-results-cancel-import" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\n</full-page-controls>\n\n<!-- Importing (Bureaus can only save mappings) -->\n<full-page-controls ng-if="vm.state === \'mapping\'">\n\n\t<!-- Bureaus -->\n\t<fpc-secondary ng-if="::IS_BUREAU_MAPPING">\n\t\t<a data-cy="data-importer-import-data-view-mapping-bureau-cancel-import" href="" ng-href="{{backNgHref}}">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<!-- Companies -->\n\t<fpc-secondary ng-if="::!IS_BUREAU_MAPPING">\n\t\t<div ng-switch="importMappingType">\n\t\t\t<a data-cy="data-importer-import-data-view-mapping-business-categories-cancel-import" pc-switch-when="[\n\t\t\t\t\tIMPORT_MAPPING_TYPES.businessCategories,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories\n\t\t\t\t]" ui-sref="settings.company.business-categories.category({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\tCancel import\n\t\t\t</a>\n\n\t\t\t<a data-cy="data-importer-import-data-view-mapping-nominal-codes-cancel-import" pc-switch-when="[\n\t\t\t\t\tIMPORT_MAPPING_TYPES.nominalCodes,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.xeroNominalCodes,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts\n\t\t\t\t]" ui-sref="settings.company.journals.nominal-codes({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\tCancel import\n\t\t\t</a>\n\n\t\t\t<a data-cy="data-importer-import-data-view-mapping-default-cancel-import" ng-switch-default ui-sref="data-importer.my-files({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.agencyDocumentType})">\n\t\t\t\tCancel import\n\t\t\t</a>\n\t\t</div>\n\t</fpc-secondary>\n\n\t<fpc-primary ng-if="::!IS_BUREAU_MAPPING">\n\t\t<div ng-switch="importMappingType">\n\n\t\t\t<button class="tertiary" data-cy="data-importer-import-data-view-mapping-nominal-codes-import" ng-click="updateImportMappingFile(vm, true)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" pc-switch-when="[\n\t\t\t\t\tIMPORT_MAPPING_TYPES.nominalCodes,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.businessCategories,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.xeroNominalCodes,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts\n\t\t\t\t]">\n\t\t\t\tImport\n\t\t\t</button>\n\t\t\t<button class="tertiary" data-cy="data-importer-import-data-view-mapping-nominal-codes-import" ng-click="validatePayElementImportFile(vm, true, false)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" pc-switch-when="[\n\t\t\t\t\tIMPORT_MAPPING_TYPES.payElementsRecurring,\n\t\t\t\t\tIMPORT_MAPPING_TYPES.payElementsFixedRecurring\n\t\t\t\t]">\n\t\t\t\tImport\n\t\t\t</button>\n\t\t\t<button class="tertiary" data-cy="data-importer-import-data-view-mapping-default-import" ng-click="generateUserImport(vm, true)" ng-disabled="!vm.isRowDataValid || !vm.isMappingValid" ng-switch-default>\n\t\t\t\tImport\n\t\t\t</button>\n\t\t</div>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Imported -->\n<full-page-controls ng-if="vm.importContext === IMPORT_CONTEXT_TYPES.employeeData && vm.state === \'imported\'">\n\n\t<fpc-secondary>\n\t\t<a data-cy="data-importer-import-data-view-imported-go-to-files" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tGo to files\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary>\n\t\t<a class="button tertiary" data-cy="data-importer-import-data-view-imported-import-with-same-file" ui-sref="data-importer.select-import-type({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\tpayPeriodId: vm.payPeriodId,\n\t\t\t\timportMappingType: importMappingType\n\t\t\t})">\n\t\t\tImport with same file\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'">\n\t<div ng-switch="errorState" ng-if="$root.isDevelopment">\n\t\t<p pc-switch-when="ERROR_STATES.adjustmentTypeColumnNotDefined">Unable to locate the Adjustment Type mapping column</p>\n\t</div>\n</error-block>\n');
$templateCache.put('features/app/data-importer/my-files/data-importer-my-files.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Intro -->\n\t<placeholder placeholder-graphic="import" ng-if="!vm.agencyDocumentsValidated.length && !vm.agencyDocumentsNotValidated.length">\n\t\t<placeholder-title>Getting started</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>To start importing, first upload your CSV file and then check it to ensure the data is in order. We won\'t bother you with this message again once you\'ve uploaded your first file! \uD83D\uDE01</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a class="button tertiary l" data-cy="data-importer-my-files-upload-file" ui-sref="data-importer.upload-file({\n\t\t\t\t\tagencyDocumentType: agencyDocumentType,\n\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t})">Get started</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n\t<div class="data-importer_main-wrapper" ng-if="vm.agencyDocumentsValidated.length || vm.agencyDocumentsNotValidated.length">\n\n\t\t<div class="data-importer_main-secondary-actions" ng-if="agencyDocumentType === DOCUMENT_TYPES.teamImport">\n\t\t\t<a class="data-importer_main-secondary-action" ui-sref="data-importer.select-import-file-type({\n\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\tagencyDocumentType: agencyDocumentType\n\t\t\t\t})">\n\t\t\t\t<i class="icon-arrow-right flip l"></i><br>Use a new file\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Files -->\n\t\t<div class="data-importer_header">\n\t\t\t<h2>Select an existing file to import</h2>\n\t\t</div>\n\n\t\t<div class="document-uploads" ng-if="vm.agencyDocumentsValidated.length">\n\n\t\t\t<header class="document-uploads_header">\n\t\t\t\t<h5>Ready for import</h5>\n\t\t\t</header>\n\n\t\t\t<div class="grid is-flex" ng-class="{\'is-centered\': vm.agencyDocumentsValidated.length <= 2}">\n\t\t\t\t<document-upload-card class="grid_item" document="document" document-index="documentIndex" ng-repeat="(documentIndex, document) in vm.agencyDocumentsValidated | orderBy:createdDateISOUnix" on-delete="onDeleteDocument(vm.agencyDocumentsValidated, document, documentIndex)">\n\t\t\t\t\t<actions>\n\t\t\t\t\t\t<a class="button white is-primary" data-cy="data-importer-my-files-import-file-{{::documentIndex}}" ui-sref="data-importer.select-import-type({\n\t\t\t\t\t\t\t\tagencyDocumentId: document.AgencyDocumentID,\n\t\t\t\t\t\t\t\tagencyDocumentType: agencyDocumentType,\n\t\t\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\t\t\tpayPeriodId: vm.currentPayPeriod.PayPeriodID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-upload"></i>&nbsp;Import\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</actions>\n\t\t\t\t</document-upload-card>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="document-uploads">\n\n\t\t\t<header class="document-uploads_header">\n\t\t\t\t<h5>Validation required</h5>\n\t\t\t</header>\n\n\t\t\t<div class="grid is-flex" ng-class="{\'is-centered\': vm.agencyDocumentsValidated.length <= 2}">\n\t\t\t\t<document-upload-card class="grid_item" document="document" document-index="documentIndex" ng-if="vm.agencyDocumentsNotValidated.length" ng-repeat="(documentIndex, document) in vm.agencyDocumentsNotValidated | orderBy:createdDateISOUnix" on-delete="onDeleteDocument(vm.agencyDocumentsNotValidated, document, documentIndex)">\n\t\t\t\t\t<actions>\n\t\t\t\t\t\t<a class="button white is-tertiary" data-cy="data-importer-my-files-validate-file-{{::documentIndex}}" ui-sref="data-importer.validate-file({\n\t\t\t\t\t\t\t\tagencyDocumentId: document.AgencyDocumentID,\n\t\t\t\t\t\t\t\tagencyDocumentType: agencyDocumentType,\n\t\t\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\t\t\timportMappingType: document.mappingType,\n\t\t\t\t\t\t\t\tpayPeriodId: vm.currentPayPeriod.PayPeriodID\n\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t<i class="icon-upload"></i>&nbsp;Validate\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</actions>\n\t\t\t\t</document-upload-card>\n\t\t\t</div>\n\n\t\t\t<div class="align-center" ng-if="!vm.agencyDocumentsNotValidated.length">\n\t\t\t\t<em class="greyscale">Files that require validation before being ready for importing will appear here</em>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<full-page-controls ng-if="pageState === \'ready\' && vm.agencyDocuments.length">\n\t<fpc-primary>\n\t\t<a class="button tertiary" data-cy="data-importer-my-files-view-upload-a-new-file" ui-sref="data-importer.upload-file({\n\t\t\t\tagencyDocumentType: agencyDocumentType,\n\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t})">\n\t\t\tUpload a new file\n\t\t</a>\n\t</fpc-primary>\n</full-page-controls>\n\n<!-- No team members -->\n<div class="data-importer fadeIn" ng-if="pageState === \'no-team-members\'">\n\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- No team members -->\n\t<placeholder placeholder-graphic="team" placeholder-graphic-size="l">\n\t\t<placeholder-title>You don\'t have any team members set up yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>You can add new team members in your Team area. Once they\'re ready for payroll, you can then import payroll changes and get the latest tax updates for your team members.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a ui-sref="team.members({agencyProfileId: agencyProfileId})" class="underline">Go to team <i class="icon-chevron-right"></i></a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/select-import-file-type/data-importer-select-import-file-type.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{vm.backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Files -->\n\t<div class="data-importer_mapping">\n\n\t\t<div class="data-importer_main" ng-switch="vm.agencyDocumentType">\n\n\t\t\t<header class="data-importer_header">\n\t\t\t\t<h2>Select a new file to import</h2>\n\t\t\t\t<p>Import using an FPS or CSV file or download our pre-formatted CSV template.</p>\n\t\t\t</header>\n\n\t\t\t<!-- Team Import -->\n\t\t\t<section class="data-importer_section" pc-switch-when="vm.DOCUMENT_TYPES.teamImport">\n\n\t\t\t\t<!-- Import Types -->\n\t\t\t\t<section class="data-importer_section">\n\t\t\t\t\t<div class="data-import-types">\n\n\t\t\t\t\t\t<!-- FPS -->\n\t\t\t\t\t\t<div class="data-import-type">\n\t\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<i class="icon-document l"></i>\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="FPS file">FPS file</h6>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Upload an FPS file for the current tax year">Upload an FPS file for the current tax year</p>\n\t\t\t\t\t\t\t<a ui-sref="fps-importer({agencyProfileId: vm.agencyProfileId})" class="data-import-type_action" data-cy="upload-fps"></a>\n\t\t\t\t\t\t</div><!--\n\n\t\t\t\t\t\tCSV \n\t\t\t\t\t\t--><div class="data-import-type">\n\t\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<i class="icon-csv l"></i>\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="CSV file">CSV file</h6>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to those in your CSV file before importing">Map our column headers to those in your CSV file before importing</p>\n\t\t\t\t\t\t\t<a ui-sref="data-importer.upload-file({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.agencyDocumentType, from: \'select-import-file-type\'})" class="data-import-type_action" data-cy="upload-csv"></a>\n\t\t\t\t\t\t</div><!--\n\n\t\t\t\t\t\tExisting file\n\t\t\t\t\t\t--><div class="data-import-type">\n\t\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="Use an existing file">Use an existing file</h6>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Use a file that\'s already been uploaded">Select from the files you\'ve already uploaded</p>\n\t\t\t\t\t\t\t<a ui-sref="data-importer.my-files({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.agencyDocumentType})" class="data-import-type_action" data-cy="upload-existing-file"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Preformatted CSV -->\n\t\t\t\t<section class="data-importer_section is-small">\n\n\t\t\t\t\t<div class="file-download-card is-quarternary">\n\n\t\t\t\t\t\t<div class="badge is-medium is-quarternary file-download-card_badge">\n\t\t\t\t\t\t\t<i class="icon-download l"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<h6 class="file-download-card_label">Download pre-formatted CSV</h6>\n\t\t\t\t\t\t<p class="file-download-card_description">Populate our template in your spreadsheet software and import in CSV format later</p>\n\n\t\t\t\t\t\t<a href="" ng-click="downloadImportTemplate()" class="file-download-card_action"></a>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t</section>\n\n\t\t\t<!-- Default -->\n\t\t\t<section class="data-importer_section" ng-switch-default>\n\t\t\t\t<message-block theme="tertiary">\n\t\t\t\t\t<p>There are no import types available for this type of file.</p>\n\t\t\t\t</message-block>\n\t\t\t</section>\n\n\t\t</div>\n\t</div>\n</div>\n\n<full-page-controls>\n\n\t<fpc-secondary>\n\t\t<a href="" ui-sref="team.members({agencyProfileId: vm.agencyProfileId})">\n\t\t\tBack to team\n\t\t</a>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/select-import-file-type-bcat/data-importer-select-import-file-type-bcat.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a class="link-with-icon tertiary" ng-href="{{vm.backNgHref}}">\n\t\t\t\t<i class="icon-cross"></i>Close\n\t\t\t</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Files -->\n\t<div class="data-importer_mapping">\n\n\t\t<div class="data-importer_main">\n\n\t\t\t<div class="data-importer_header">\n\t\t\t\t<h2>Import business categories</h2>\n\t\t\t\t<p>Import business categories from your accounting software or use a CSV file</p>\n\t\t\t</div>\n\n\t\t\t<!-- Team Import -->\n\t\t\t<section class="data-importer_section">\n\n\t\t\t\t<!-- Import Types -->\n\t\t\t\t<section class="data-importer_section">\n\t\t\t\t\t<div class="data-import-types align-center">\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!-- Access Financials -->\n\t\t\t\t\t\t<div class="data-import-type" ng-if="vm.accountingIntegrationConnection.IsConnected &&\n\t\t\t\t\t\t\t\tvm.accountingIntegrationConnection.IntegrationType === vm.ACCOUNTING_INTEGRATION_TYPES.accessFinancials">\n\t\t\t\t\t\t\t<div class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<img class="data-import-type_icon_access" src="../images/logo/integrations/access-logo.2x.png">\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="Financials">\n\t\t\t\t\t\t\t\t\tAccess Financials\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to your Nominal Categories in Financials">\n\t\t\t\t\t\t\t\tMap our column headers to your Nominal Categories in Financials\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="data-import-type_action" ui-sref="data-importer.import-data({\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tpayPeriodId: vm.payPeriodId,\n\t\t\t\t\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport,\n\t\t\t\t\t\t\t\t\timportMappingType: vm.IMPORT_MAPPING_TYPES.accessFinancialsBusinessCategories\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!--CSV-->\n\t\t\t\t\t\t<div class="data-import-type">\n\t\t\t\t\t\t\t<div class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<i class="icon-csv l"></i>\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="CSV file">\n\t\t\t\t\t\t\t\t\tCSV file\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to those in your CSV file before importing">\n\t\t\t\t\t\t\t\tMap our column headers to those in your CSV file before importing\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="data-import-type_action" data-cy="upload-csv" ui-sref="data-importer.upload-file({\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport,\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tfrom: \'business-categories\',\n\t\t\t\t\t\t\t\t\tpayPeriodId: $root.currentPeriod.PayPeriodID\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t</section>\n\n\t\t</div>\n\t</div>\n</div>\n\n<full-page-controls>\n\n\t<fpc-secondary>\n\t\t<a href="" ui-sref="settings.company.business-categories.category({agencyProfileId: vm.agencyProfileId})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/select-import-file-type-xero/data-importer-select-import-file-type-xero.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a class="link-with-icon tertiary" ng-href="{{vm.backNgHref}}">\n\t\t\t\t<i class="icon-cross"></i>Close\n\t\t\t</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Files -->\n\t<div class="data-importer_mapping">\n\n\t\t<div class="data-importer_main">\n\n\t\t\t<div class="data-importer_header">\n\t\t\t\t<h2>Import nominal codes</h2>\n\t\t\t\t<p>Import your Chart of Accounts from your accounting software or use a CSV file</p>\n\t\t\t</div>\n\n\t\t\t<!-- Team Import -->\n\t\t\t<section class="data-importer_section">\n\n\t\t\t\t<!-- Import Types -->\n\t\t\t\t<section class="data-importer_section">\n\t\t\t\t\t<div class="data-import-types align-center">\n\n\t\t\t\t\t\t<!-- Xero -->\n\t\t\t\t\t\t<div class="data-import-type" data-cy="xero-accounts-import" ng-if="vm.accountingIntegrationConnection.IsConnected &&\n\t\t\t\t\t\t\t\tvm.accountingIntegrationConnection.IsTwoFactorAuthenticationEnabled &&\n\t\t\t\t\t\t\t\tvm.accountingIntegrationConnection.IntegrationType === vm.ACCOUNTING_INTEGRATION_TYPES.xero">\n\t\t\t\t\t\t\t<div class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<image-badge class="data-import-type_badge" image-alt="Xero" image-key="xero" image-size="is-extra-small" image-type="integrations"></image-badge>\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="Xero">\n\t\t\t\t\t\t\t\t\tXero\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to your Chart of Accounts in Xero">\n\t\t\t\t\t\t\t\tMap our column headers to your Chart of Accounts in Xero\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="data-import-type_action" ui-sref="data-importer.import-data({\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tpayPeriodId: vm.payPeriodId,\n\t\t\t\t\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.xeroNominalCodes,\n\t\t\t\t\t\t\t\t\timportMappingType: vm.IMPORT_MAPPING_TYPES.xeroNominalCodes\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!-- Access Financials -->\n\t\t\t\t\t\t<div class="data-import-type" data-cy="financials-accounts-import" ng-if="vm.accountingIntegrationConnection.IsConnected &&\n\t\t\t\t\t\t\t\tvm.accountingIntegrationConnection.IntegrationType === vm.ACCOUNTING_INTEGRATION_TYPES.accessFinancials">\n\t\t\t\t\t\t\t<div class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<img class="data-import-type_icon_access" src="../images/logo/integrations/access-logo.2x.png">\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="Financials">\n\t\t\t\t\t\t\t\t\tAccess Financials\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to your Chart of Accounts in Financials">\n\t\t\t\t\t\t\t\tMap our column headers to your Chart of Accounts in Financials\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="data-import-type_action" ui-sref="data-importer.import-data({\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tpayPeriodId: vm.payPeriodId,\n\t\t\t\t\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.accessFinancialsNominalAccountsImport,\n\t\t\t\t\t\t\t\t\timportMappingType: vm.IMPORT_MAPPING_TYPES.accessFinancialsNominalAccounts\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!--CSV-->\n\t\t\t\t\t\t<div class="data-import-type" data-cy="csv-accounts-import">\n\t\t\t\t\t\t\t<div class="data-import-type_header">\n\t\t\t\t\t\t\t\t<div class="data-import-type_icon">\n\t\t\t\t\t\t\t\t\t<i class="icon-csv l"></i>\n\t\t\t\t\t\t\t\t\t<div class="data-import-type_icon-arrow">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="CSV file">\n\t\t\t\t\t\t\t\t\tCSV file\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="s data-import-type_description" title="Map our column headers to those in your CSV file before importing">\n\t\t\t\t\t\t\t\tMap our column headers to those in your CSV file before importing\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<a class="data-import-type_action" data-cy="upload-csv" ui-sref="data-importer.upload-file({\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.nominalCodes,\n\t\t\t\t\t\t\t\t\tfrom: \'select-import-file-type-xero\',\n\t\t\t\t\t\t\t\t\tpayPeriodId: $root.currentPeriod.PayPeriodID\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t</section>\n\n\t\t</div>\n\t</div>\n</div>\n\n<full-page-controls>\n\n\t<fpc-secondary>\n\t\t<a href="" ui-sref="settings.company.journals.nominal-codes({agencyProfileId: vm.agencyProfileId})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/select-import-type/data-importer-select-import-type.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="{{::IS_BUREAU_MAPPING ? \'Mapping template builder\' : \'Importer\'}}">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Files -->\n\t<div class="data-importer_mapping">\n\n\t\t<div class="data-importer_pre-header">\n\t\t\t<div class="data-importer_file-info">\n\t\t\t\t<div class="data-importer_file-info-icon is-primary">\n\t\t\t\t\t<i class="icon-tick"></i>\n\t\t\t\t</div>\n\t\t\t\t<span class="data-importer_file-info-name is-primary">{{vm.document.DocumentName}}</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="data-importer_main">\n\n\t\t\t<!-- Companies -->\n\t\t\t<header class="data-importer_header" ng-if="::!IS_BUREAU_MAPPING">\n\t\t\t\t<h2>Select the type of data you wish to import</h2>\n\t\t\t\t<p>You can then match our headers to the columns in your file</p>\n\t\t\t</header>\n\n\t\t\t<!-- Bureaus (mapping templates only) -->\n\t\t\t<header class="data-importer_header is-large" ng-if="::IS_BUREAU_MAPPING">\n\t\t\t\t<h3>Select the type of data you wish to import with this mapping</h3>\n\t\t\t</header>\n\n\t\t\t<section class="data-importer_section">\n\t\t\t\t<div class="data-import-types">\n\t\t\t\t\t<div class="data-import-type" ng-class="{\'is-disabled\': dataImportType.isUnavailable}" ng-repeat="dataImportType in vm.dataImportTypes">\n\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t<i class="icon-{{dataImportType.icon}} l data-import-type_icon"></i>\n\t\t\t\t\t\t\t<div class="marker m has-no-border primary data-import-type_marker"><i class="icon-arrow-right"></i></div>\n\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="{{dataImportType.name}}">{{dataImportType.name}}</h6>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<p class="s data-import-type_description" title="{{dataImportType.description}}">{{dataImportType.description}}</p>\n\t\t\t\t\t\t<p class="s assertive data-import-type_description" ng-if="dataImportType.isUnavailable">{{dataImportType.unavailableDescription}}</p>\n\t\t\t\t\t\t<a aria-label="Import {{dataImportType.name}}" class="data-import-type_action" data-cy="data-importer-select-import-type-{{dataImportType.name | slugify}}" ng-if="!dataImportType.isUnavailable" ui-sref="data-importer.import-data({\n\t\t\t\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\timportMappingType: dataImportType.id,\n\t\t\t\t\t\t\t\tlayoutType: vm.layoutType,\n\t\t\t\t\t\t\t\tpayPeriodId: vm.payPeriodId\n\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- All -->\n\t\t\t<section class="data-importer_section" ng-if="vm.agencyDocumentType === DOCUMENT_TYPES.teamImport">\n\t\t\t\t<div class="data-import-types is-two-columns align-center">\n\t\t\t\t\t<div class="data-import-type has-no-icon">\n\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t<h6 class="data-import-type_name">Import all data</h6>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<p class="s data-import-type_description">Map headers and import information for all the above data groups, excluding calculated pay history, sick pay schedules and posts &amp; pay policies, at the same time</p>\n\t\t\t\t\t\t<a class="data-import-type_action" data-cy="data-importer-select-import-type-import-all-data" ui-sref="data-importer.import-data({\n\t\t\t\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\timportMappingType: IMPORT_MAPPING_TYPES.all,\n\t\t\t\t\t\t\t\tpayPeriodId: vm.payPeriodId\n\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</div>\n\t</div>\n</div>\n\n<full-page-controls>\n\n\t<!-- Bureaus -->\n\t<fpc-secondary ng-if="IS_BUREAU_MAPPING">\n\t\t<a href="" ng-href="{{backNgHref}}">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<!-- Companies -->\n\t<fpc-secondary ng-if="!IS_BUREAU_MAPPING">\n\t\t<a href="" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/select-mapping-type/data-importer-select-mapping-type.view.html','<div class="data-importer fadeIn">\n\n\t<action-bar class="dropIn" subtitle="Mapping template builder">\n\t\t<action-bar-right>\n\t\t\t<a ui-sref="settings.bureau.imports.mappings({agencyProfileId})" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Files -->\n\t<div class="data-importer_mapping">\n\n\t\t<div class="data-importer_main">\n\n\t\t\t<header class="data-importer_header">\n\t\t\t\t<h2>What do you wish to use this mapping for?</h2>\n\t\t\t</header>\n\n\t\t\t<section class="data-importer_section is-small">\n\n\t\t\t\t<!-- Mapping Types -->\n\t\t\t\t<div class="data-import-types is-one-column">\n\t\t\t\t\t<div class="data-import-type" ng-repeat="mappingType in mappingTypes | orderBy: \'name\'">\n\t\t\t\t\t\t<header class="data-import-type_header">\n\t\t\t\t\t\t\t<i class="icon-{{::mappingType.icon}} l data-import-type_icon"></i>\n\t\t\t\t\t\t\t<div class="marker m has-no-border primary data-import-type_marker"><i class="icon-arrow-right"></i></div>\n\t\t\t\t\t\t\t<h6 class="data-import-type_name" title="{{::mappingType.name}}">{{::mappingType.name}}</h6>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<p class="s data-import-type_description" title="{{::mappingType.description}}">{{::mappingType.description}}</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!-- Imports -->\n\t\t\t\t\t\t<a class="data-import-type_action" ng-if="!mappingType.isValidation" ui-sref="data-importer.select-import-type({\n\t\t\t\t\t\t\t\tagencyDocumentId,\n\t\t\t\t\t\t\t\tagencyDocumentType: mappingType.id,\n\t\t\t\t\t\t\t\tagencyProfileId,\n\t\t\t\t\t\t\t\tbackState: \'settings.bureau.imports.mappings\',\n\t\t\t\t\t\t\t\tlayoutType: mappingType.layoutType,\n\t\t\t\t\t\t\t\tpayPeriodId: $root.CONFIG.guidEmpty\n\t\t\t\t\t\t\t})"></a>\n\n\t\t\t\t\t\t<!-- Validation -->\n\t\t\t\t\t\t<a class="data-import-type_action" ng-if="mappingType.isValidation" ui-sref="data-importer.validate-file({\n\t\t\t\t\t\t\t\tagencyDocumentId,\n\t\t\t\t\t\t\t\tagencyDocumentType: mappingType.id,\n\t\t\t\t\t\t\t\tagencyProfileId,\n\t\t\t\t\t\t\t\tbackState: \'settings.bureau.imports.mappings\',\n\t\t\t\t\t\t\t\timportMappingType: mappingType.importMappingType,\n\t\t\t\t\t\t\t\tlayoutType: mappingType.layoutType,\n\t\t\t\t\t\t\t\tpayPeriodId: $root.CONFIG.guidEmpty\n\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t</div>\n\t</div>\n</div>\n');
$templateCache.put('features/app/data-importer/upload-file/data-importer-upload-file.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="{{::$root.currentCompany.CompanyType === INTERFACE_TYPES.bureau ? \'Mapping template builder\' : \'Importer\'}}">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Import States -->\n\t<div class="data-importer_body" ng-switch="currentPayPeriod.dataImportState">\n\n\t\t<!-- CSV file has misaligned columns -->\n\t\t<div class="data-importer_state m fadeIn" ng-switch-when="-2">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary l"><i class="icon-warning icon-badge-icon xl"></i></div>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<h5 class="data-importer_state-title">CSV format is invalid</h5>\n\t\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t\t<p class="s">Please fix the following errors in your CSV file before trying to upload it again</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section table-wrapper has-scrollbar">\n\t\t\t\t<table class="c is-block">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th class="align-center">Row</th>\n\t\t\t\t\t\t\t<th class="align-center">Column</th>\n\t\t\t\t\t\t\t<th class="align-center">Description</th>\n\t\t\t\t\t\t\t<th class="align-center">Data</th>\n\t\t\t\t\t\t\t<th class="align-center">&nbsp;</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr ng-repeat="error in currentPayPeriod.errors | limitTo:10">\n\t\t\t\t\t\t\t<td class="align-center">{{error.row}}</td>\n\t\t\t\t\t\t\t<td class="align-center">{{error.column || \'-\'}}</td>\n\t\t\t\t\t\t\t<td class="align-center">{{error.message}}</td>\n\t\t\t\t\t\t\t<td class="align-center">{{error.data || \'-\'}}</td>\n\t\t\t\t\t\t\t<td class="align-center"><i class="icon-warning is-medium is-tertiary has-margin-right"></i></td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-action">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t<a data-cy="data-importer-upload-file-reset" href="" ng-click="resetImporter(currentPayPeriod)" class="tertiary underline">Reset import and try again</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Invalid File Format -->\n\t\t<div class="data-importer_state s fadeIn" ng-switch-when="-1">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary l"><i class="icon-warning icon-badge-icon xl"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Invalid file type</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">The type of file you\'ve tried to upload doesn\'t appear to be a valid {{::agencyDocumentType | documentTypeLabel}} file.</p>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-action">\n\t\t\t\t<a data-cy="data-importer-upload-file-reset" href="" ng-click="resetImporter(currentPayPeriod)" class="tertiary underline">Reset import and try again</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Unsubmitted / Submitting -->\n\t\t<div class="data-importer_state l fadeIn" ng-if="currentPayPeriod.dataImportState === SUBMISSION_STATES.unsubmitted || currentPayPeriod.dataImportState === SUBMISSION_STATES.submitting">\n\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<h2 class="data-importer_state-title">Upload your {{::agencyDocumentType | documentTypeLabel}} file</h2>\n\t\t\t\t<p ng-if="::$root.currentCompany.CompanyType !== INTERFACE_TYPES.bureau && ![DOCUMENT_TYPES.payslipManagerFullRun, DOCUMENT_TYPES.payslipManagerSupplementaryRun].includes(agencyDocumentType)">Once your file is uploaded you can then check the data is in order</p>\n\t\t\t</div>\n\n\t\t\t<!-- Unsubmitted -->\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<div class="drop-zone" nv-file-drop nv-file-over uploader="uploader">\n\t\t\t\t\t<div class="data-importer_dropzone-progress">\n\t\t\t\t\t\t<progress-ring pr-icon="icon-upload" pr-percentage="uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="data-importer_dropzone-filename fadeIn" ng-if="uploadFilename">{{uploadFilename}}</p>\n\t\t\t\t\t<h5 class="data-importer_dropzone-subtitle">{{currentPayPeriod.dataImportState === SUBMISSION_STATES.unsubmitted ? \'Drag and drop your \' + (agencyDocumentType | documentTypeLabel) + \' file here\' : \'We\\\'re uploading your \' + (agencyDocumentType | documentTypeLabel) + \' file\'}}</h5>\n\t\t\t\t\t<input id="fileUpload" class="data-importer_file-input" type="file" accept="{{fileTypeAcceptOption}}" nv-file-select uploader="uploader" data-cy="file-upload">\n\t\t\t\t\t<p class="data-importer_dropzone-copy" ng-if="currentPayPeriod.dataImportState === SUBMISSION_STATES.unsubmitted">or <label class="data-importer_dropzone-link" for="fileUpload">select it from your computer</label></p>\n\t\t\t\t\t<p class="data-importer_dropzone-copy" ng-if="currentPayPeriod.dataImportState === SUBMISSION_STATES.submitting">This should only take a moment...</p>\n\t\t\t\t\t<div class="drop-zone-overlay data-importer_dropzone-overlay"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="data-importer_note" ng-if="![DOCUMENT_TYPES.payslipManagerFullRun, DOCUMENT_TYPES.payslipManagerSupplementaryRun].includes(agencyDocumentType)">\n\t\t\t\t<note note-theme="tertiary" note-title="Apostrophes and commas in column headings" note-icon="icon-warning">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="s">Please note that if you have any apostrophes or commas in your column headings such as \u2018Emp\u2019ee\u2019 and \u2018Emp\u2019er\u2019,\n\t\t\t\t\t\t\t\t\t these should be removed before uploading your file as they will corrupt your data import.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Finished -->\n\t\t<div class="data-importer_state s fadeIn" pc-switch-when="SUBMISSION_STATES.finished">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary xl"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">That\'s it, your file has been imported!</h5>\n\t\t\t<p>This file has now been uploaded and will be available in your files.</p>\n\t\t\t<p>\n\t\t\t\t<a class="tertiary underline" data-cy="data-importer-upload-file-go-to-files" ui-sref="data-importer.my-files({agencyProfileId: agencyProfileId, agencyDocumentType: agencyDocumentType})">\n\t\t\t\tGo to files\n\t\t\t</a>\n\t\t</p>\n\t\t</div>\n\n\t\t<!-- Failed -->\n\t\t<div class="data-importer_state s fadeIn" pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary xl"><i class="icon-cross icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Your file is invalid</h5>\n\t\t\t<p>The file you\'re trying to upload is invalid. Reset your import to try again.</p>\n\t\t\t<p>\n\t\t\t\t<a class="tertiary underline" data-cy="data-importer-upload-file-reset" href="" ng-click="resetImporter(currentPayPeriod)">\n\t\t\t\t\tReset import\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Cancel -->\n<full-page-controls ng-if="currentPayPeriod.dataImportState !== SUBMISSION_STATES.submitting">\n\n\t<fpc-secondary>\n\t\t<div ng-switch="$root.currentCompany.CompanyType">\n\t\t\t<!-- Bureaus -->\n\t\t\t<div pc-switch-when="INTERFACE_TYPES.bureau">\n\t\t\t\t<a href="" ng-href="{{backNgHref}}">\n\t\t\t\t\tCancel import\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<!-- Companies -->\n\t\t\t<div ng-switch-default ng-switch="from">\n\t\t\t\t<a href="" ng-switch-when="business-categories" ui-sref="settings.company.business-categories.category({\n\t\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t\t})">\n\t\t\t\t\tCancel upload\n\t\t\t\t</a>\n\n\t\t\t\t<a href="" ng-switch-when="select-import-file-type" ui-sref="data-importer.select-import-file-type({\n\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\tagencyDocumentType: agencyDocumentType\n\t\t\t\t\t})">\n\t\t\t\t\tCancel upload\n\t\t\t\t</a>\n\n\t\t\t\t<a href="" ng-switch-when="payslip-manager" ui-sref="payslip-manager({\n\t\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t\t})">\n\t\t\t\t\tCancel upload\n\t\t\t\t</a>\n\n\t\t\t\t<a href="" ui-sref="data-importer.my-files({\n\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\tagencyDocumentType: agencyDocumentType\n\t\t\t\t\t})" ng-switch-default>\n\t\t\t\t\tCancel upload\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</fpc-secondary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/validate-file/data-importer-validate-file.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="{{::IS_BUREAU_MAPPING ? \'Mapping template builder\' : \'Importer\'}}">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Mapping -->\n\t<div class="data-importer_mapping" ng-switch="vm.state">\n\n\t\t<!-- Document details (Bureau) -->\n\t\t<div class="data-importer_pre-header" pc-switch-when="\'mapping\'" ng-if="::!$root.currentCompany.isPayrollCompany && vm.importMappingTemplate.isTemplate">\n\n\t\t\t<!-- Template info -->\n\t\t\t<div class="data-importer_template-info">\n\t\t\t\t<div class="data-importer_template-info-icon is-primary">\n\t\t\t\t\t<i class="icon-upload"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-importer_template-info-details" ng-switch="vm.stateKey">\n\t\t\t\t\t<h6 class="data-importer_template-info-name">{{::vm.importMappingTemplate.Name}}</h6>\n\t\t\t\t\t<p class="is-small" ng-switch-when="data-importer.validate-file">Validation</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Document Details -->\n\t\t<div class="data-importer_pre-header" ng-if="::$root.currentCompany.isPayrollCompany">\n\n\t\t\t<!-- File info -->\n\t\t\t<div class="data-importer_file-info">\n\t\t\t\t<div class="data-importer_file-info-icon" ng-class="{\n\t\t\t\t\t\t\'is-tertiary\': [\n\t\t\t\t\t\t\t\'mapping\',\n\t\t\t\t\t\t\t\'validating\',\n\t\t\t\t\t\t\t\'validation-results-team\'\n\t\t\t\t\t\t].includes(vm.state),\n\t\t\t\t\t\t\'is-primary\': ![\n\t\t\t\t\t\t\t\'mapping\',\n\t\t\t\t\t\t\t\'validating\',\n\t\t\t\t\t\t\t\'validation-results-team\'\n\t\t\t\t\t\t].includes(vm.state)}">\n\t\t\t\t\t<i ng-class="{\'icon-csv\': vm.state !== \'imported\', \'icon-tick\': vm.state === \'imported\'}"></i>\n\t\t\t\t</div>\n\t\t\t\t<span class="data-importer_file-info-name" ng-class="{\n\t\t\t\t\t\t\'tertiary\': [\n\t\t\t\t\t\t\t\'mapping\',\n\t\t\t\t\t\t\t\'validating\',\n\t\t\t\t\t\t\t\'validation-results-team\'\n\t\t\t\t\t\t].includes(vm.state),\n\t\t\t\t\t\t\'primary\': ![\n\t\t\t\t\t\t\t\'mapping\',\n\t\t\t\t\t\t\t\'validating\',\n\t\t\t\t\t\t\t\'validation-results-team\'\n\t\t\t\t\t\t].includes(vm.state)\n\t\t\t\t\t}">\n\t\t\t\t\t{{vm.document.DocumentName}}\n\t\t\t\t</span>\n\t\t\t\t<span class="data-importer_file-info-context" ng-switch="vm.stateKey">\n\t\t\t\t\t<span ng-switch-when="data-importer.validate-file">Validate</span>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<!-- Mapping template -->\n\t\t\t<div class="data-importer_template" ng-if="vm.importMappingTemplate.isTemplate" pc-switch-when="\'mapping\'">\n\t\t\t\t<span class="data-importer_template-status" ng-if="vm.importMappingTemplate.IsGlobalTemplate" tooltip tooltip-position="left" tooltip-size="s" tooltip-text="Bureau-managed mapping">\n\t\t\t\t\t<icon-dot icon="icon-company-groups" theme="is-large is-tertiary"></icon-dot>\n\t\t\t\t</span>\n\t\t\t\t<p class="s">\n\t\t\t\t\t<span>{{vm.importMappingTemplate.Name}}</span>&nbsp;\n\t\t\t\t\t<a href="" ng-click="restartImport(true)">Change</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Mapping Templates -->\n\t\t<div class="data-importer_state m fadeIn align-left" pc-switch-when="\'mapping-templates\'">\n\n\t\t\t<header class="data-importer_intro">\n\t\t\t\t<h4>Use a mapping template</h4>\n\t\t\t\t<p class="s">If you always use the same mapping template to validate files, you can set your selection as the default and we won\u2019t ask you to pick one every time.</p>\n\t\t\t</header>\n\n\t\t\t<!-- Select template -->\n\t\t\t<div class="data-importer_field">\n\t\t\t\t<header class="data-importer_field-header">\n\t\t\t\t\t<label for="selectTemplate" class="data-importer_field-label required">Select template:</label>\n\t\t\t\t\t<a class="is-small greyscale data-importer_field-header-action" ui-sref="settings.company.imports.mappings({\n\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId\n\t\t\t\t\t\t})">Manage templates</a>\n\t\t\t\t</header>\n\t\t\t\t<main class="data-importer_field-main">\n\t\t\t\t\t<select class="block" id="selectTemplate" name="selectTemplate" ng-model="vm.importMappingTemplate" ng-options="template as template.Name for template in vm.mappingTemplates track by template.ImportMappingID" required></select>\n\t\t\t\t</main>\n\t\t\t\t<div class="data-importer_field-errors fadeIn" ng-messages="templateForm.selectTemplate.$error" ng-if="templateForm.selectTemplate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a template</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Set as default -->\n\t\t\t<div class="data-importer_field fadeIn">\n\t\t\t\t<div class="data-importer_field-main">\n\t\t\t\t\t<input checkbox id="setAsDefault" label-text="\'Set as default template when validating \' + vm.importMappingTypeDescription + \' for \' + currentCompany.Name" name="setAsDefault" ng-model="vm.importMappingTemplate.IsDefault" type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Header / Footer Rows > Not currently active (due: v3) -->\n\t\t<div pc-switch-when="\'row-settings\'">\n\n\t\t\t<header class="data-importer_intro">\n\t\t\t\t<h4>Confirm header and footer rows in your file</h4>\n\t\t\t\t<p class="s">We\u2019ll only ask this once for this file and we\u2019ll ignore all but the last header and all footer rows</p>\n\t\t\t</header>\n\n\t\t\t<!-- Inputs -->\n\t\t\t<div class="data-importer_section">\n\t\t\t\t<div class="data-importer_input-fields">\n\t\t\t\t\t<div class="data-importer_input-field">\n\t\t\t\t\t\t<label for="TitleRows" class="data-importer_input-field-label required">Header rows in file:</label>\n\t\t\t\t\t\t<input class="xs is-spin-button-disabled" id="TitleRows" name="TitleRows" ng-model="vm.fileData.TitleRows" required type="number">\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="data-importer_input-field">\n\t\t\t\t\t\t<label for="FooterRows" class="data-importer_input-field-label required">Footer rows in file:</label>\n\t\t\t\t\t\t<input class="xs is-spin-button-disabled" id="FooterRows" name="FooterRows" ng-model="vm.fileData.FooterRows" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- File Overview -->\n\t\t\t<div class="data-importer_section">\n\t\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t\t<!-- File Data -->\n\t\t\t\t\t<div class="table-shadow has-scrollbar">\n\t\t\t\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t\t\t\t<table class="c import-data-mapping-table">\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<td class="column-header" ng-repeat="column in vm.fileData.Columns | filter: vm.showHiddenColumnsFilter" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-th\': rowIndex + 1 <= vm.fileData.TitleRows\n\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t{{::column.ImportMappingColumnText}}\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr dir-paginate="\n\t\t\t\t\t\t\t\t\t\t\t(rowIndex, row) in vm.fileData.rowsFiltered = (\n\t\t\t\t\t\t\t\t\t\t\t\tvm.fileData.Rows |\n\t\t\t\t\t\t\t\t\t\t\t\tfilter : vm.filterBarOptions.appliedFilter\n\t\t\t\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\t\t\t\titemsPerPage : 10\n\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t<td ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'is-th\': rowIndex + 2 <= vm.fileData.TitleRows || rowIndex + 1 > (vm.fileData.Rows.length - vm.fileData.FooterRows)\n\t\t\t\t\t\t\t\t\t\t\t}" ng-if="vm.hiddenColumnsArr.indexOf(cellIndex) === -1 || SHOW_HIDDEN_COLUMNS" ng-repeat="(cellIndex, cell) in row.cells">\n\t\t\t\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Mapping -->\n\t\t<div class="data-importer_content" id="data-importer-content" pc-switch-when="\'mapping\'">\n\n\t\t\t<!-- Title Bar -->\n\t\t\t<div class="data-importer_title">\n\t\t\t\t<div class="data-importer_title-bar">\n\t\t\t\t\t<h4>Map our headers to your columns</h4>\n\t\t\t\t\t<div class="data-importer_title-bar-actions">\n\n\t\t\t\t\t\t<div class="button-container">\n\t\t\t\t\t\t\t<button ng-click="onToggleFullScreen()" class="white" type="button">\n\t\t\t\t\t\t\t\t<i class="icon-full-screen"></i>\n\t\t\t\t\t\t\t\tFull screen\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Unable to update Bureau level template at company level -->\n\t\t\t\t\t\t<div class="button-container fadeIn" ng-if="vm.isMappingValid && vm.hasTemplateMappingChanged && !isFullScreenActive()">\n\n\t\t\t\t\t\t\t<!-- Unable to update Bureau level template at company level -->\n\t\t\t\t\t\t\t<a class="button is-tertiary" href="" ng-click="openMappingTemplateForm(vm, \'create\')">\n\t\t\t\t\t\t\t\tSave new mapping\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="button" href="" ng-click="openMappingTemplateForm(vm, \'update\')" ng-if="vm.importMappingTemplate.isTemplate && !(vm.importMappingTemplate.IsGlobalTemplate && $root.currentCompany.isPayrollCompany)">\n\t\t\t\t\t\t\t\tUpdate mapping\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Auto map > Automatically compares column headers with mapping headers and drops if matched -->\n\t\t\t\t\t\t<div class="button-container">\n\t\t\t\t\t\t\t<a href="" ng-click="autoMapColumnsByName(vm)" class="button"><i class="icon-loading has-margin-right"></i>Auto-map</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="s">Select the header you wish to map, then click on &lsquo;Map header&rsquo; for the column you wish to map it to</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\t<span class="strong tertiary">Please note:</span>&nbsp;files can only have a single header row so you may need to remove any additional header rows in your file before uploading.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="data-importer_section">\n\t\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t\t<!-- Mapping headers -->\n\t\t\t\t\t<div class="data-importer_section">\n\n\t\t\t\t\t\t<!-- Filter -->\n\t\t\t\t\t\t<div class="import-data-mapping-section" ng-if="vm.mappingColumns.length > vm.DEFAULT_MAPPING_COLUMNS_VISIBLE && vm.filterBarOptionsMappingColumns.filters.length > 0">\n\t\t\t\t\t\t\t<filter-bar-basic filter-bar-options="vm.filterBarOptionsMappingColumns"></filter-bar-basic>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Mapping Headers -->\n\t\t\t\t\t\t<div class="import-data-mapping-section">\n\t\t\t\t\t\t\t<div class="mapping-headers" ng-class="[\n\t\t\t\t\t\t\t\t\tvm.filterBarOptionsMappingColumns.displayOption.key,\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\t\'has-active-radio\': isMappingHeaderIndexSet(vm)\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t]">\n\t\t\t\t\t\t\t\t<div class="mapping-header_card-wrapper" ng-repeat="mappingColumn in vm.mappingColumnsFiltered = (\n\t\t\t\t\t\t\t\t\t\tvm.mappingColumns |\n\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\'isIgnored\': false\n\t\t\t\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\t\t\t\tfilter: vm.filterBarOptionsMappingColumns.filterExp |\n\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\'ImportMappingColumnText\': vm.filterBarOptionsMappingColumns.searchString\n\t\t\t\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\t\t\t\tlimitTo: vm.mappingColumnsVisible\n\t\t\t\t\t\t\t\t\t)">\n\n\t\t\t\t\t\t\t\t\t<!-- Radio (Important: Needs to sit next to input - sibling selector) -->\n\t\t\t\t\t\t\t\t\t<input class="mapping-header_card-radio" id="mapping-header_{{::mappingColumn.originalIndex}}" name="mapping-header_{{::mappingColumn.originalIndex}}" ng-click="reviewActiveMappingColumn(vm, mappingColumn)" ng-disabled="!mappingColumn.isReusable && mappingColumn.isInUse" ng-model="vm.activeMappingHeaderIndex" ng-value="mappingColumn.originalIndex" type="radio">\n\n\t\t\t\t\t\t\t\t\t<!-- Card -->\n\t\t\t\t\t\t\t\t\t<label class="mapping-header_card-label" data-cy-validation-value="{{::mappingColumn.ImportMappingColumnValidationValue}}" for="mapping-header_{{::mappingColumn.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'has-hover-state\': mappingColumn.isReusable || !mappingColumn.isInUse,\n\t\t\t\t\t\t\t\t\t\t\t\'has-tooltip\': mappingColumn.hasTooltip,\n\t\t\t\t\t\t\t\t\t\t\t\'is-disabled\': !mappingColumn.isReusable && mappingColumn.isInUse\n\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t{{mappingColumn.ImportMappingColumnText}}\n\t\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t\t\t<!-- Tooltip -->\n\t\t\t\t\t\t\t\t\t<a aria-label="Show information tooltip" class="mapping-header_card-tooltip-link" href="" ng-click="$root.$broadcast(\'toggle-tooltip-card\', mappingColumn.tooltip)" ng-if="mappingColumn.hasTooltip">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-information"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Show more -->\n\t\t\t\t\t\t<div class="import-data-mapping-section" ng-if="\n\t\t\t\t\t\t\t\tvm.filterBarOptionsMappingColumns.displayOption.key === \'is-layout-grid\' &&\n\t\t\t\t\t\t\t\tvm.mappingColumnsVisible <= vm.mappingColumnsFiltered.length\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<a href="" ng-click="showMoreMappingColumns(vm)" class="s"><i class="icon-chevron-down"></i>&nbsp;More</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Invalid tabs -->\n\t\t\t\t\t<div class="data-importer_section fadeIn" ng-if="vm.fileData.invalidRowCount > 0">\n\n\t\t\t\t\t\t<div class="data-importer_summary_tags">\n\n\t\t\t\t\t\t\t<!-- Invalid -->\n\t\t\t\t\t\t\t<div class="data-importer_summary_tag">\n\t\t\t\t\t\t\t\t<span class="tag assertive inverse tabs-item-counter-before" title="{{vm.fileData.invalidRowCount}}">{{vm.fileData.invalidRowCount}}</span>\n\t\t\t\t\t\t\t\t<span class="data-importer_summary_tag-label">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.fileData.invalidRowCount" when="{\n\t\t\t\t\t\t\t\t\t\t\t\'1\': \'Invalid row\',\n\t\t\t\t\t\t\t\t\t\t\t\'other\': \'Invalid rows\'\n\t\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Valid -->\n\t\t\t\t\t\t\t<div class="data-importer_summary_tag">\n\t\t\t\t\t\t\t\t<span class="tag primary inverse tabs-item-counter-before" title="{{vm.fileData.validRowCount}}">{{vm.fileData.validRowCount}}</span>\n\t\t\t\t\t\t\t\t<span class="data-importer_summary_tag-label">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.fileData.invalidRowCount" when="{\n\t\t\t\t\t\t\t\t\t\t\t\'1\': \'Valid row\',\n\t\t\t\t\t\t\t\t\t\t\t\'other\': \'Valid rows\'\n\t\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Toggle -->\n\t\t\t\t\t\t\t<div class="toggle-control data-importer_summary_toggle fadeIn" ng-if="vm.fileData.invalidRowCount > 0">\n\t\t\t\t\t\t\t\t<a class="toggle-a s toggle-control-toggle {{vm.activeMappingFilterKey === FILTER_KEYS.dataImporterValidate.validationState.invalid ? \'active primary\': \'\'}}" href="" ng-click="toggleMappingFilter(vm)"></a>\n\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active primary\': vm.activeMappingFilterKey === FILTER_KEYS.dataImporterValidate.validationState.invalid\n\t\t\t\t\t\t\t\t\t}">Hide valid</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- File Data -->\n\t\t\t\t\t<div class="import-data-mapping-section">\n\t\t\t\t\t\t<div class="import-data-mapping-tables">\n\n\t\t\t\t\t\t\t<div class="import-data-mapping_header">\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-details">\n\n\t\t\t\t\t\t\t\t\t<!-- Row/Column count -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item">\n\t\t\t\t\t\t\t\t\t\t<span class="is-greyscale-darkened is-small">\n\t\t\t\t\t\t\t\t\t\t\t{{vm.fileData.columnsFiltered.length}} columns, {{vm.fileData.rowsFiltered.length}} rows\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-display">\n\n\t\t\t\t\t\t\t\t\t<!-- Column Visibility -->\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-actions">\n\t\t\t\t\t\t\t\t\t\t<span class="is-greyscale-darkened is-small">Columns:</span>\n\t\t\t\t\t\t\t\t\t\t<a class="import-data-mapping_header-actions-action is-small" href="" ng-click="hideEmptyColumns(vm)">Hide empty</a>\n\t\t\t\t\t\t\t\t\t\t<a class="import-data-mapping_header-actions-action is-small" href="" ng-click="showEmptyColumns(vm)">Show all</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Data -->\n\t\t\t\t\t\t\t<div class="import-data-mapping-tables_body">\n\n\t\t\t\t\t\t\t\t<!-- File data -->\n\t\t\t\t\t\t\t\t<div class="import-data-mapping-table">\n\n\t\t\t\t\t\t\t\t\t<div class="table-shadow has-scrollbar">\n\t\t\t\t\t\t\t\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t\t\t\t\t\t\t\t<table class="c import-data-mapping-table has-drop-zones">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Drop zones -->\n\t\t\t\t\t\t\t\t\t\t\t\t<thead class="drop-zone-cards" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-hover-states-enabled\': vm.activeMappingHeaderIndex || vm.activeMappingHeaderIndex === 0\n\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="drop-zone-card_wrapper" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active positive\': column.state === \'valid\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active assertive\': column.state === \'invalid\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-repeat="column in vm.fileData.columnsFiltered = ( vm.fileData.Columns | filter: vm.showHiddenColumnsFilter )" ng-switch="column.state">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Matched -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card is-active is-positive fadeIn" ng-switch-when="valid">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{column.mappingHeader.ImportMappingColumnText}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card_cancel" href="" ng-click="deleteColumnMapping(vm, column.originalIndex, column.mappingHeader.originalIndex)"></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Invalid -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="drop-zone-card is-active is-assertive fadeIn" ng-switch-when="invalid">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{column.mappingHeader.ImportMappingColumnText}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card_cancel" href="" ng-click="deleteColumnMapping(vm, column.originalIndex, column.mappingHeader.originalIndex)"></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Drop header -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="drop-zone-card is-placeholder has-hover-state fadeIn" href="" ng-click="mapColumn(vm, column)" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="block align-center" ng-if="column.loadingState === \'loading\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="column.loadingState !== \'loading\'">Map header</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- File headers -->\n\t\t\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="column-header has-action" id="column-header-{{::column.originalIndex}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active positive\': column.state === \'valid\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'active assertive\': column.state === \'invalid\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-repeat="column in vm.fileData.Columns | filter: vm.showHiddenColumnsFilter">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>{{::column.ImportMappingColumnText}} ({{column.cellCountNotEmpty}})</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a aria-label="Toggle hidden column" class="is-greyscale-lightened column-header_action" href="" ng-click="toggleShowColumn(vm, column)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-hidden"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- File data -->\n\t\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr dir-paginate="\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(rowIndex, row) in vm.fileData.rowsFiltered = (\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.fileData.Rows |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfilter : vm.filterBarOptions.appliedFilter\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\titemsPerPage : 10\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-repeat="cell in row.cells | filter: vm.showHiddenColumnsFilterForCells" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'assertive is-invalid\': !cell.isValid,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-editing\': cell.state === \'editing\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-editing\': cell.state === \'editing\',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-invalid\': !cell.isValid && cell.state !== \'editing\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-switch="cell.state">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Loading -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-when="loading">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<circle-loader class="s"></circle-loader>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Edit -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="table-inline-edit-cell_input" id="cell-{{::rowIndex}}-{{::cell.originalIndex}}" ng-blur="validateCellData(vm, cell)" ng-model="cell.value" ng-style="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twidth: cell.width + \'px\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-switch-when="editing" pc-keypress pc-keypress-action="validateCellData(vm, cell)" pc-keypress-key="enter" type="text">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- View -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell_value" ng-click="editCell(cell, row.originalIndex, $event)" ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{::cell.value}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- States -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-inline-edit-cell_states" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-if="!row.Ignore && cell.state !== \'editing\' && cell.state !== \'loading\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-cross table-inline-edit-cell_state hide-on-hover" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}" ng-if="!cell.isValid"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-edit table-inline-edit-cell_state show-on-hover" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\'is-assertive\': !cell.isValid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validating -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'validating\'">\n\t\t\t<div class="data-importer_state-progress">\n\t\t\t\t<progress-ring pr-icon="icon-csv" pr-percentage="vm.uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">We\'re just checking your file...</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validate -->\n\t\t<div class="data-importer_section fadeIn" pc-switch-when="\'validation-results-team\'">\n\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t<div class="data-importer_title">\n\t\t\t\t\t<div class="data-importer_title-bar">\n\t\t\t\t\t\t<h4>Match rows to existing team members</h4>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="data-importer_section" ng-if="importMappingType === IMPORT_MAPPING_TYPES.team">\n\t\t\t\t\t<nav class="tabs primary has-border-bottom">\n\t\t\t\t\t\t<a class="tabs-item has-counter-before" href="" ng-class="{\n\t\t\t\t\t\t\t\t\'active\': validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey\n\t\t\t\t\t\t\t}" ng-click="setActiveValidationResultFilter(vm, validationResultFilter)" ng-if="::validationResultFilter.total > 0 || (validationResultFilter.total === 0 && !validationResultFilter.isHiddenWhenEmpty)" ng-repeat="validationResultFilter in vm.validationResultFilters">\n\t\t\t\t\t\t\t<span class="tag {{validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey ? validationResultFilter.themeActive : validationResultFilter.theme}} tabs-item-counter-before {{validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey ? \'inverse\' : \'\'}}" title="{{::validationResultFilter.total}}">{{::validationResultFilter.total | nineMax}}</span>\n\t\t\t\t\t\t\t{{::validationResultFilter.title}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Has results -->\n\t\t\t\t<div class="data-importer_section fadeIn" ng-show="vm.fileData.rowsFiltered.length > 0">\n\n\t\t\t\t\t<!-- File Data -->\n\t\t\t\t\t<div class="import-data-mapping-tables">\n\n\t\t\t\t\t\t<div class="import-data-mapping_header">\n\n\t\t\t\t\t\t\t<div class="import-data-mapping_header-details">\n\n\t\t\t\t\t\t\t\t<!-- Ignore All Rows -->\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item">\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-checkbox">\n\t\t\t\t\t\t\t\t\t\t<input checkbox class="xs" id="isIgnoreAllRowsEnabled" label-text-class="is-small" label-text="\'Ignore all rows\'" name="isIgnoreAllRowsEnabled" ng-change="toggleIsIgnoreAllRowsEnabled(vm)" ng-model="vm.isIgnoreAllRowsEnabled" type="checkbox">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="vm.activeValidationResultFilter.filterKey === VALIDATION_TYPE_LEVELS.warning">\n\t\t\t\t\t\t\t\t\t<p class="s">Click on the warning link for more information</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="table-shadow has-scrollbar">\n\t\t\t\t\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t\t\t\t\t<table class="c import-data-mapping-table">\n\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header align-center" ng-if="vm.activeValidationResultFilter.canIgnore">Ignore</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-if="vm.activeValidationResultFilter.hasActions">Warning</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-if="vm.activeValidationResultFilter.isTeamMemberMatched">Team member</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-repeat="column in vm.fileData.Columns | filter: vm.showHiddenColumnsFilter">{{::column.ImportMappingColumnText}}</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr dir-paginate="\n\t\t\t\t\t\t\t\t\t\t\t\t(rowIndex, row) in vm.fileData.rowsFiltered = (\n\t\t\t\t\t\t\t\t\t\t\t\t\tvm.fileData.Rows |\n\t\t\t\t\t\t\t\t\t\t\t\t\tfilter: vm.activeValidationResultFilter.filter |\n\t\t\t\t\t\t\t\t\t\t\t\t\titemsPerPage : 10\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'disabled\': row.isDisabled || row.Ignore\n\t\t\t\t\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t\t\t\t\t<td class="align-center" ng-if="vm.activeValidationResultFilter.canIgnore">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="pc-checkbox import-data-mapping-checkbox" id="row-{{row.originalIndex}}" ng-change="reValidateAll(vm)" ng-model="row.Ignore" type="checkbox">\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-if="vm.activeValidationResultFilter.hasActions">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-repeat="\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalidationResult in row.validationResults |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValidationType: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValidationTypeLevel: VALIDATION_TYPE_LEVELS.warning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t" ng-switch="validationResult.ValidationType.ValidationTypeID">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Select team member -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p pc-switch-when="VALIDATION_TYPES.userDoesNotExist">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!row.TeamMember">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-warning m {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}" href="" ng-click="openValidateDataForm(row, validationResult)">{{validationResult.actionMessage}}</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="row.TeamMember"><i class="icon-check m {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="openValidateDataForm(row, validationResult)" class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}">{{row.TeamMember.Forename}} {{row.TeamMember.Surname}}</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Warning -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-switch-default>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-warning m {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}" href="" ng-click="openValidateDataForm(row, validationResult)">{{validationResult.actionMessage}}</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-if="vm.activeValidationResultFilter.isTeamMemberMatched">\n\t\t\t\t\t\t\t\t\t\t\t\t{{row.teamMember.name}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-class="{\'greyscale\': cell.isIgnored}" ng-if="vm.hiddenColumnsArr.indexOf(cellIndex) === -1 || SHOW_HIDDEN_COLUMNS" ng-repeat="(cellIndex, cell) in row.cells">\n\t\t\t\t\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="data-importer_section fadeIn" ng-if="!vm.fileData.rowsFiltered.length">\n\t\t\t\t\t<placeholder placeholder-graphic="generic-rows" placeholder-graphic-size="l">\n\t\t\t\t\t\t<placeholder-title>No rows found</placeholder-title>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Finished -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'validated\'">\n\t\t\t<div class="icon-badge data-importer_state-graphic tertiary l"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Your file check is complete!</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This file is now ready for importing data and we won\'t need to check your team members again if you wish to use it for multiple imports</p>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-action">\n\t\t\t\t<a class="strong s underline" data-cy="data-importer-validate-file-view-validated-go-to-files" ui-sref="data-importer.my-files({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.agencyDocumentType})">\n\t\t\t\t\tGo to files\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Importing -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'importing\'">\n\t\t\t<div class="data-importer_state-progress">\n\t\t\t\t<progress-ring pr-icon="icon-team-alt" pr-percentage="vm.importingPercentComplete" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">Your team is being updated</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Imported -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'imported\'">\n\t\t\t<div class="icon-badge data-importer_state-graphic primary l"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Your team import has finished</h5>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t\t<p class="s">Your import has been recorded in the Imports page in your Team area and you can now see the data you\'ve imported in your Team members page</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section fadeIn" ng-if="vm.hasImportSummaryToDisplay">\n\n\t\t\t\t<div class="data-importer_summary-block">\n\t\t\t\t\t<import-summary import-summary="vm.importSummary"></import-summary>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t\t<div class="data-importer_state-section">\n\t\t\t\t<div class="data-importer_state-action">\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t<a class="underline" data-cy="data-importer-validate-file-view-imported-go-to-your-team-area" ui-sref="team.members({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\t\t\tGo to your team area\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Mapping Templates -->\n<full-page-controls ng-if="vm.state === \'mapping-templates\'">\n\n\t<fpc-primary>\n\t\t<button class="tertiary" data-cy="data-importer-validate-file-view-mapping-templates-next" ng-click="initMapping(vm)" type="button">\n\t\t\tNext\n\t\t</button>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Row Settings > Not currently active (due: v3) -->\n<full-page-controls ng-if="vm.state === \'row-settings\'">\n\n\t<fpc-primary>\n\t\t<button class="tertiary" ng-click="updateRowSettings(vm)" type="button">\n\t\t\tNext\n\t\t</button>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Mapping controls -->\n<full-page-controls ng-if="vm.state === \'mapping\'">\n\t<!-- Bureaus -->\n\t<fpc-secondary ng-if="::IS_BUREAU_MAPPING">\n\t\t<a data-cy="data-importer-validate-file-view-mapping-bureau-cancel-import" href="" ng-href="{{backNgHref}}">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<!-- Companies -->\n\t<fpc-secondary ng-if="::!IS_BUREAU_MAPPING">\n\t\t<a data-cy="data-importer-validate-file-view-mapping-other-cancel-import" href="" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary ng-if="::!IS_BUREAU_MAPPING">\n\t\t<button class="tertiary" data-cy="data-importer-validate-file-view-mapping-next" ng-click="updateImportMappingFile(vm, true)" ng-disabled="!vm.isMappingValid" type="button">\n\t\t\tNext\n\t\t</button>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Validation results (team) -->\n<full-page-controls ng-if="vm.state === \'validation-results-team\'">\n\t<fpc-secondary>\n\t\t<a data-cy="data-importer-validate-file-view-validation-results-cancel-import" href="" ui-sref="data-importer.my-files({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary>\n\t\t<div ng-switch="importMappingType">\n\n\t\t\t<!-- Team > Imports team -->\n\t\t\t<button class="tertiary" data-cy="data-importer-validate-file-view-validation-results-import" ng-click="generateUserImport(vm, true)" ng-disabled="!vm.isMappingValid || !vm.isRowDataValid" pc-switch-when="[IMPORT_MAPPING_TYPES.team]" type="button">\n\t\t\t\tImport\n\t\t\t</button>\n\n\t\t\t<button class="tertiary" data-cy="data-importer-validate-file-view-validation-results-next" ng-click="updateImportMappingFile(vm, true)" ng-disabled="!vm.isMappingValid || !vm.isRowDataValid" ng-switch-default type="button">\n\t\t\t\tNext\n\t\t\t</button>\n\t\t</div>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Validated controls -->\n<full-page-controls ng-if="vm.state === \'validated\'">\n\n\t<fpc-primary>\n\t\t<div ng-switch="importMappingType">\n\n\t\t\t<!-- Team -->\n\t\t\t<a class="button tertiary" data-cy="data-importer-validate-file-view-validated-team-import-with-this-file" pc-switch-when="IMPORT_MAPPING_TYPES.team" ui-sref="data-importer.select-import-type({\n\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\t\tpayPeriodId: vm.payPeriodId, importMappingType: importMappingType\n\t\t\t\t})">\n\t\t\t\tImport with this file\n\t\t\t</a>\n\n\t\t\t<!-- Everything else -->\n\t\t\t<a class="button tertiary" data-cy="data-importer-validate-file-view-validated-other-import-with-this-file" ng-switch-default ui-sref="data-importer.select-import-type({\n\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\t\tpayPeriodId: vm.payPeriodId\n\t\t\t\t})">\n\t\t\t\tImport with this file\n\t\t\t</a>\n\n\t\t</div>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Imported controls -->\n<full-page-controls ng-if="vm.state === \'imported\'">\n\n\t<fpc-secondary>\n\t\t<a data-cy="data-importer-validate-file-view-imported-upload-a-new-file" href="" ui-sref="data-importer.upload-file({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType\n\t\t\t})">\n\t\t\tUpload a new file\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary>\n\t\t<a class="button tertiary" data-cy="data-importer-validate-file-view-imported-import-with-same-file" ui-sref="data-importer.select-import-type({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentId: vm.agencyDocumentId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\tpayPeriodId: vm.payPeriodId,\n\t\t\t\timportMappingType: importMappingType\n\t\t\t})">\n\t\t\tImport with same file\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/validate-xml-file/data-importer-validate-xml-file.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="data-importer has-full-page-controls fadeIn" ng-if="pageState === \'ready\'">\n\n\t<action-bar class="dropIn" subtitle="Importer">\n\t\t<action-bar-right>\n\t\t\t<a ng-href="{{backNgHref}}" class="link-with-icon tertiary"><i class="icon-cross"></i>Close</a>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Mapping -->\n\t<div class="data-importer_mapping" ng-switch="vm.state">\n\n\t\t<!-- Document Details -->\n\t\t<div class="data-importer_pre-header">\n\n\t\t\t<!-- File info -->\n\t\t\t<div class="data-importer_file-info">\n\t\t\t\t<div class="data-importer_file-info-icon is-primary">\n\t\t\t\t\t<i class="icon-tick"></i>\n\t\t\t\t</div>\n\t\t\t\t<span class="data-importer_file-info-name primary">{{vm.document.DocumentName}}</span>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Validating -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'validating\'">\n\t\t\t<div class="data-importer_state-progress">\n\t\t\t\t<progress-ring pr-icon="icon-csv" pr-percentage="vm.uploadingProgress" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">We\'re just checking your file...</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Validate -->\n\t\t<div class="data-importer_section fadeIn" pc-switch-when="\'validate\'">\n\t\t\t<div class="import-data-mapping">\n\n\t\t\t\t<header class="data-importer_intro">\n\t\t\t\t\t<h4>The following payslip data will be imported</h4>\n\t\t\t\t\t<p class="s">New team members and pay information will be created from the below users  </p>\n\t\t\t\t</header>\n\n\t\t\t\t<div class="data-importer_section">\n\t\t\t\t\t<nav class="tabs primary has-border-bottom">\n\t\t\t\t\t\t<a href="" ng-click="setActiveValidationResultFilter(vm, validationResultFilter)" class="tabs-item has-counter-before" ng-class="{\'active\': validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey}" ng-repeat="validationResultFilter in vm.validationResultFilters" ng-if="::validationResultFilter.total > 0 || (validationResultFilter.total === 0 && !validationResultFilter.isHiddenWhenEmpty)">\n\t\t\t\t\t\t\t<span class="tag {{validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey ? validationResultFilter.themeActive : validationResultFilter.theme}} tabs-item-counter-before {{validationResultFilter.filterKey === vm.activeValidationResultFilter.filterKey ? \'inverse\' : \'\'}}" title="{{::validationResultFilter.total}}">{{::validationResultFilter.total | nineMax}}</span>\n\t\t\t\t\t\t\t{{::validationResultFilter.title}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nav>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Has results -->\n\t\t\t\t<div class="data-importer_section fadeIn" ng-show="vm.fileData.rowsFiltered.length > 0">\n\n\t\t\t\t\t<div class="data-importer_section" ng-if="vm.activeValidationResultFilter.filterKey === VALIDATION_TYPE_LEVELS.warning">\n\t\t\t\t\t\t<p class="s">Click on the warning link for more information</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- File Data -->\n\t\t\t\t\t<div class="import-data-mapping-tables">\n\n\t\t\t\t\t\t<div class="import-data-mapping_header">\n\n\t\t\t\t\t\t\t<div class="import-data-mapping_header-details">\n\n\t\t\t\t\t\t\t\t<!-- Ignore All Rows -->\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="vm.activeValidationResultFilter.filterKey !== VALIDATION_TYPE_LEVELS.unchanged">\n\t\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-checkbox">\n\t\t\t\t\t\t\t\t\t\t<input checkbox class="xs" id="isIgnoreAllRowsEnabled" label-text-class="is-small" label-text="\'Ignore all rows\'" name="isIgnoreAllRowsEnabled" ng-change="toggleIsIgnoreAllRowsEnabled(vm, vm.fileData.rowsFiltered)" ng-model="vm.isIgnoreAllRowsEnabled" type="checkbox">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="import-data-mapping_header-item" ng-if="vm.activeValidationResultFilter.filterKey === VALIDATION_TYPE_LEVELS.warning">\n\t\t\t\t\t\t\t\t\t<p class="s">Click on the warning link for more information</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="table-shadow has-scrollbar">\n\t\t\t\t\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t\t\t\t\t<table class="c import-data-mapping-table">\n\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header align-center" ng-if="vm.activeValidationResultFilter.canIgnore">Ignore</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-if="vm.activeValidationResultFilter.hasActions">Warning</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-if="vm.activeValidationResultFilter.isTeamMemberMatched">Team member</th>\n\t\t\t\t\t\t\t\t\t\t\t<th class="column-header" ng-repeat="column in vm.fileData.Columns | filter: vm.showHiddenColumnsFilter">{{::column.ImportMappingColumnText}}</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr dir-paginate="(rowIndex, row) in vm.fileData.rowsFiltered = ( vm.fileData.Rows | filter: vm.activeValidationResultFilter.filter | itemsPerPage : 10 )" ng-class="{\'disabled\': row.isDisabled || row.Ignore}">\n\n\t\t\t\t\t\t\t\t\t\t\t<td class="align-center" ng-if="vm.activeValidationResultFilter.canIgnore">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" id="row-{{row.originalIndex}}" ng-model="row.Ignore" ng-change="reValidateAll(vm)" class="pc-checkbox import-data-mapping-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-if="vm.activeValidationResultFilter.hasActions">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-repeat="\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalidationResult in row.validationResults |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValidationType: {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValidationTypeLevel: VALIDATION_TYPE_LEVELS.warning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t" ng-switch="validationResult.ValidationType.ValidationTypeID">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Select team member -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p pc-switch-when="VALIDATION_TYPES.userDoesNotExist">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!row.TeamMember"><i class="icon-warning m {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}"></i>&nbsp;&nbsp;<a href="" ng-click="openValidateDataForm(row)" class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}">{{row.actionMessage}}</a></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="row.TeamMember"><i class="icon-check m {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}"></i>&nbsp;&nbsp;<a href="" ng-click="openValidateDataForm(row)" class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}">{{row.TeamMember.Forename}} {{row.TeamMember.Surname}}</a></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Warning -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-switch-default><i class="icon-warning m {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}"></i>&nbsp;&nbsp;<a href="" ng-click="openValidateDataForm(row)" class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}">{{row.actionMessage}}</a></p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-if="vm.activeValidationResultFilter.isTeamMemberMatched">\n\t\t\t\t\t\t\t\t\t\t\t\t{{row.teamMember.name}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t\t<td ng-repeat="(cellIndex, cell) in row.cells" ng-class="{\'greyscale\': cell.isIgnored}" ng-if="vm.hiddenColumnsArr.indexOf(cellIndex) === -1 || SHOW_HIDDEN_COLUMNS">\n\t\t\t\t\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="data-importer_section fadeIn" ng-if="!vm.fileData.rowsFiltered.length">\n\t\t\t\t\t<placeholder placeholder-graphic="generic-rows" placeholder-graphic-size="l">\n\t\t\t\t\t\t<placeholder-title>No rows found</placeholder-title>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Importing -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'importing\'">\n\t\t\t<div class="data-importer_state-progress">\n\t\t\t\t<progress-ring pr-icon="icon-team-alt" pr-percentage="vm.importingPercentComplete" pr-theme-complete="tertiary" pr-size="medium"></progress-ring>\n\t\t\t</div>\n\t\t\t<h5 class="data-importer_state-title">Your team is being updated</h5>\n\t\t\t<div class="data-importer_state-copy">\n\t\t\t\t<p class="s">This should only take a few moments.</p>\n\t\t\t\t<p class="s">Please don\'t close your browser or hit the \'Back\' button!</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Imported -->\n\t\t<div class="data-importer_state m fadeIn" pc-switch-when="\'imported\'">\n\t\t\t<div class="icon-badge data-importer_state-graphic primary l"><i class="icon-check icon-badge-icon"></i></div>\n\t\t\t<h5 class="data-importer_state-title">Online payslips are now available</h5>\n\t\t\t<!-- 171123 - Hidden for now, this import (payslip manager) isn\'t used and we need to fix the stats here -->\n\t\t\t<!-- <div class="data-importer_state-section">\n\t\t\t\t<div class="data-importer_summary-block">\n\t\t\t\t\t<div class="data-importer_summary-block-item">\n\t\t\t\t\t\t<div class="tag is-secondary inverse">{{vm.importSummary.m_Item1}}</div>&nbsp;&nbsp;\n\t\t\t\t\t\t<ng-pluralize count="vm.importSummary.m_Item1" when="{\'1\': \'Team member was created\', \'other\': \'Team members were created\'}"></ng-pluralize>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="data-importer_summary-block-item">\n\t\t\t\t\t\t<div class="tag is-secondary inverse">{{vm.importSummary.m_Item2}}</div>&nbsp;&nbsp;\n\t\t\t\t\t\t<ng-pluralize count="vm.importSummary.m_Item2" when="{\'1\': \'Payslips was generated \', \'other\': \'Payslips were generated\'}"></ng-pluralize>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="data-importer_summary-block-item">\n\t\t\t\t\t\t<div class="tag is-greyscale inverse">{{vm.importSummary.m_Item3}}</div>&nbsp;&nbsp;\n\t\t\t\t\t\t<ng-pluralize count="vm.importSummary.m_Item3" when="{\'1\': \'Team member was ignored\', \'other\': \'Team members were ignored\'}"></ng-pluralize>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div> -->\n\t\t</div>\n\t</div>\n</div>\n\n<!-- Validate controls -->\n<full-page-controls ng-if="vm.state === \'validate\'">\n\n\t<fpc-secondary>\n\t\t<a href="" ng-href="{{backNgHref}}">\n\t\t\tCancel import\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary>\n\t\t<button class="tertiary" ng-click="generateUserImport(vm, true)" ng-disabled="!vm.isRowDataValid" type="button">\n\t\t\tImport\n\t\t</button>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Imported controls -->\n<full-page-controls ng-if="vm.state === \'imported\'">\n\n\t<fpc-secondary>\n\t\t<a href="" ui-sref="data-importer.upload-file({\n\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\tagencyDocumentType: vm.agencyDocumentType,\n\t\t\t\tpayPeriodId: vm.payPeriodId\n\t\t\t})">\n\t\t\tUpload another file\n\t\t</a>\n\t</fpc-secondary>\n\n\t<fpc-primary>\n\t\t<a href="" ng-href="{{backNgHref}}" class="button tertiary">\n\t\t\tFinish\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/data-importer/validation-results/validation-results.component.html','<!-- Validation results-->\n<div class="import-data-mapping">\n\t<validation-results-title validation-results-title="{{$ctrl.validationResultsTitle}}" validation-results-message="{{$ctrl.validationResultsMessage}}"></validation-results-title>\n\n\t<validation-results-filter validation-result-filters="$ctrl.validationResultFilters" active-validation-result-filter="$ctrl.activeValidationResultFilter" on-update-filter="$ctrl.onUpdateFilter({validationResultFilter: validationResultFilter})"></validation-results-filter>\n\n\t<!-- Has results -->\n\t<validation-results-file-data active-validation-result-filter="$ctrl.activeValidationResultFilter" allow-actions-on-updates="$ctrl.allowActionsOnUpdates" file-data="$ctrl.fileData" hidden-columns-array="$ctrl.hiddenColumnsArray" is-ignore-all-rows-enabled="$ctrl.isIgnoreAllRowsEnabled" on-toggle-ignore-all-rows="$ctrl.onToggleIgnoreAllRows({filteredRows: filteredRows, isIgnoreAllRowsEnabled: isIgnoreAllRowsEnabled})" on-toggle-ignore-row="$ctrl.onToggleIgnoreRow()" on-validation-result-action="$ctrl.onValidationResultAction({row: row, validationResult: validationResult})" on-pay-element-validation-action="$ctrl.onPayElementValidationAction({row: row, validationResult: validationResult})" show-hidden-columns="$ctrl.showHiddenColumns" show-hidden-columns-filter="$ctrl.showHiddenColumnsFilter"></validation-results-file-data>\n\n\t<!-- No results -->\n\t<div class="data-importer_section fadeIn" ng-if="!$ctrl.fileData.filteredRows || !$ctrl.fileData.filteredRows.length">\n\t\t<placeholder placeholder-graphic="generic-rows" placeholder-graphic-size="l">\n\t\t\t<placeholder-title>No rows found</placeholder-title>\n\t\t</placeholder>\n\t</div>\n</div>\n');
$templateCache.put('features/app/hr/holiday-sickness/holidaySicknessView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Demo task completed -->\n\t\t<demo-completed dc-for="addHoliday,addSickness,editHoliday" ng-if="$root.demoTaskComplete"></demo-completed>\n\n\t\t<page-template-a-header icon="calendar" page-title="Holiday and sickness"></page-template-a-header>\n\n\t\t<main class="page-template-a-main">\n\n\t\t\t<div class="policy-summary" ng-if="HS.teamMembers.length">\n\t\t\t\t<div class="policy-summary__row">\n\t\t\t\t\t<div class="policy-summary__card secondary">\n\t\t\t\t\t\t<header class="policy-summary__header">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-holiday policy-summary__icon"></i>Annual leave days\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="policy-summary__body">\n\t\t\t\t\t\t\t<div class="policy-summary__stat">\n\t\t\t\t\t\t\t\t<h4 class="policy-summary__number">{{HS.summary.holiday.AnnualLeaveDays}}</h4>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__difference" ng-if="HS.summary.holiday.holidayDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<i ng-class="HS.summary.holiday.holidayDiff ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i>&nbsp;{{HS.summary.holiday.holidayDiffDisplay}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t\t<div class="policy-summary__footer" ng-if="HS.summary.holiday.holidayDiffDisplay">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLast year: {{HS.summary.holiday.AnnualLeaveDaysPreviousYear}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-summary__card assertive">\n\t\t\t\t\t\t<header class="policy-summary__header">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-sick policy-summary__icon"></i>Sick leave days\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="policy-summary__body">\n\t\t\t\t\t\t\t<div class="policy-summary__stat">\n\t\t\t\t\t\t\t\t<h4 class="policy-summary__number">{{HS.summary.sickness.SickLeaveDays}}</h4>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__difference" ng-if="HS.summary.sickness.sicknessDaysDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<i ng-class="HS.summary.sickness.sicknessDaysDiff ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i>&nbsp;{{HS.summary.sickness.sicknessDaysDiffDisplay}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t\t<footer class="policy-summary__footer" ng-if="HS.summary.sickness.sicknessDaysDiffDisplay">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLast year: {{HS.summary.sickness.SickLeaveDaysPreviousYear}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-summary__card primary">\n\t\t\t\t\t\t<header class="policy-summary__header">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-stats policy-summary__icon"></i>Absence rate\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="policy-summary__body">\n\t\t\t\t\t\t\t<div class="policy-summary__stat">\n\t\t\t\t\t\t\t\t<h4 class="policy-summary__number">{{HS.summary.sickness.AbsenceRate}}%</h4>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__difference" ng-if="HS.summary.sickness.absenceDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<i ng-class="HS.summary.sickness.absenceDiff ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i>&nbsp;{{HS.summary.sickness.absenceDiffDisplay}}%\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t\t<footer class="policy-summary__footer" ng-if="HS.summary.sickness.absenceDiffDisplay">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLast year: {{HS.summary.sickness.AbsenceRatePreviousYear}}%\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="policy-summary__row" ng-if="HS.summary.sickness.MostAbsent || HS.summary.sickness.LeastAbsent">\n\t\t\t\t\t<div class="policy-summary__card compact primary" ng-if="HS.summary.sickness.MostAbsent">\n\t\t\t\t\t\t<div class="policy-summary__avatar">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{HS.summary.sickness.MostAbsent[0]}}" avatar-size="is-medium"></avatar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<header class="policy-summary__header">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tMost absent <br>\n\t\t\t\t\t\t\t\t<span>{{HS.summary.sickness.MostAbsent}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="policy-summary__body">\n\t\t\t\t\t\t\t<div class="policy-summary__stat">\n\t\t\t\t\t\t\t\t<h4 class="policy-summary__number">{{HS.summary.sickness.MostAbsentDays}}</h4>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__difference" ng-if="HS.summary.sickness.mostAbsenceDaysDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<i ng-class="HS.summary.sickness.mostAbsenceDaysDiff ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i>&nbsp;{{HS.summary.sickness.mostAbsenceDaysDiffDisplay}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__footer" ng-if="HS.summary.sickness.mostAbsenceDaysDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tLast year: {{HS.summary.sickness.MostAbsentDaysPreviousYear}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="policy-summary__card compact primary" ng-if="HS.summary.sickness.LeastAbsent">\n\t\t\t\t\t\t<div class="policy-summary__avatar">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{HS.summary.sickness.LeastAbsent[0]}}" avatar-size="is-medium"></avatar>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<header class="policy-summary__header">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLeast absent <br>\n\t\t\t\t\t\t\t\t<span>{{HS.summary.sickness.LeastAbsent}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<main class="policy-summary__body">\n\t\t\t\t\t\t\t<div class="policy-summary__stat">\n\t\t\t\t\t\t\t\t<h4 class="policy-summary__number">{{HS.summary.sickness.LeastAbsentDays}}</h4>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__difference" ng-if="HS.summary.sickness.leastAbsenceDaysDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<i ng-class="HS.summary.sickness.leastAbsenceDaysDiff ? \'icon-chevron-up\' : \'icon-chevron-down\'"></i>&nbsp;{{HS.summary.sickness.leastAbsenceDaysDiffDisplay}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="policy-summary__footer" ng-if="HS.summary.sickness.leastAbsenceDaysDiffDisplay">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tLast year: {{HS.summary.sickness.LeastAbsentDaysPreviousYear}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</main>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="leave-calendar" hs="HS" ng-if="HS.teamMembers.length" style="--daysInMonth: {{HS.calendar.month.days.length}}; --dayWidth: {{HS.calendar.dayWidth}}px; --teamMembers: {{filteredTeamMembers.length}};" leave-calendar>\n\t\t\t\t<div class="leave-calendar__sidebar">\n\t\t\t\t\t<div class="leave-calendar__header is-sidebar">\n\t\t\t\t\t\t<h4 class="leave-calendar__title">Team</h4>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="leave-calendar__team">\n\t\t\t\t\t\t<input class="small calendar__search" id="search-input" name="search-input" ng-model="HS.searchTerm" placeholder="Search team..." results="5" type="search">\n\t\t\t\t\t\t<a class="leave-calendar__member" data-cy="holiday-sickness-team-member-{{$index}}-open-form" dir-paginate="teamMember in filteredTeamMembers = ( HS.teamMembers | filter : HS.searchTerm) | itemsPerPage : 50" href="" ng-click="openHolidaySicknessForm(teamMember.UserID)">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Name[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.UserID}}" class="leave-calendar__avatar"></avatar>\n\t\t\t\t\t\t\t<span>{{teamMember.Name}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="leave-calendar__body">\n\t\t\t\t\t<div class="leave-calendar__header">\n\t\t\t\t\t\t<h4 class="leave-calendar__title">{{HS.calendar.currentMonth.monthDisplay}} <span>{{HS.calendar.currentMonth.yearDisplay}}</span></h4>\n\t\t\t\t\t\t<div class="leave-calendar__controls">\n\t\t\t\t\t\t\t<a aria-label="Go to previous month" class="leave-calendar__control leave-calendar__control--left" href="" ng-click="changeDate(-1)">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-left"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="leave-calendar__control leave-calendar__control--today" href="" ng-click="changeDate(0)">Today</a>\n\t\t\t\t\t\t\t<a aria-label="Go to next month" class="leave-calendar__control leave-calendar__control--right" href="" ng-click="changeDate(1)">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<span class="leave-calendar__demo" td-id="{{$root.DEMO_TASKS.holidayAndSickness.addHoliday}},{{$root.DEMO_TASKS.holidayAndSickness.addSickness}}" tooltip-demo></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="leave-calendar__layout">\n\t\t\t\t\t\t<div class="leave-calendar__content" ng-class="{\'leave-calendar__content--small\' : filteredTeamMembers.length < 5, \'leave-calendar__content--medium\' : filteredTeamMembers.length === 5 }">\n\t\t\t\t\t\t\t<div class="leave-calendar__month" ng-repeat="month in HS.calendar.months" style="--daysInMonth: {{month.days.length}}; --dayWidth: {{HS.calendar.dayWidth}}px;">\n\t\t\t\t\t\t\t\t<div class="leave-calendar__row">\n\t\t\t\t\t\t\t\t\t<div class="leave-calendar__day leave-calendar__day--header" ng-repeat="day in month.days">\n\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__name">{{day.nameDisplay}}</span> <span class="leave-calendar__date">{{day.date}}</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="leave-calendar__row" ng-init="memberIndex = $index" ng-repeat="teamMember in filteredTeamMembers track by $index">\n\t\t\t\t\t\t\t\t\t<div class="leave-calendar__day" ng-class="{\'leave-calendar__day--has-leave\' : teamMember.leaveDetails[day.id].length > 0 || !userCanManageTeamHR}" ng-click="createNewLeave(teamMember, day)" ng-init="dayIndex = $index" ng-repeat="day in month.days track by $index" role="button">\n\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__leave {{leave.theme.layoutClass}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'leave-calendar__leave--on-the-move \': leave.showMenu && leave.theme.display,\n\t\t\t\t\t\t\t\t\t\t\t\t\'leave-calendar__leave--halfDayFrom\': (leave.halfDayFrom && leave.leaveDays !== HS.calendar.halfDay) || (leave.halfDayTo && leave.leaveDays === HS.calendar.halfDay),\n\t\t\t\t\t\t\t\t\t\t\t\t\'leave-calendar__leave--halfDayTo\': leave.halfDayTo && leave.leaveDays !== HS.calendar.halfDay\n\t\t\t\t\t\t\t\t\t\t\t}" ng-if="teamMember.leaveDetails[day.id].length > 0" ng-repeat="leave in teamMember.leaveDetails[day.id]" id="{{leave.day}}" role="button" style="--leaveLength: {{leave.sublength ? leave.sublength : leave.leaveDays}}">\n\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__leave-tooltip" ng-if="leave.theme.id === 0 && leave.theme.count == 1" td-id="{{$root.DEMO_TASKS.holidayAndSickness.editHoliday}}" tooltip-demo></span>\n\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__leave-card {{leave.theme.class}}" hs="HS" is-readonly="leave.isIntegrationLocked" leave="leave" ng-class="{\'leave-calendar__leave-card--resize \': leave.showMenu && leave.theme.display && userCanManageTeamHR && !leave.isIntegrationLocked}" ng-click="toggleMenu(leave, teamMember)" ng-if="userCanManageTeamHR || (!userCanManageTeamHR && leave.theme.type !== \'add\')" role="button" team-member="teamMember" title="{{leave.theme.display + \' (\' + leave.leaveDays + \' \' + (leave.leaveDays == 1 ? \'day\' : \'days\') + \')\'}}" leave-calendar-card>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="leave.theme.display">{{leave.theme.display}} (<ng-pluralize count="leave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>)</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t<aside class="leave-calendar__menu {{leave.theme.class}}" click-anywhere-but-here="toggleMenu(leave, teamMember)" is-active="leave.showMenu" ng-class="{\'leave-calendar__menu--bottom\' : memberIndex < 3}" ng-if="leave.showMenu">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-layout" ng-if="leave.theme.display">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-type">{{leave.theme.display}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-information leave-calendar__menu-info" data-cy="leave-calendar-integration-info" ng-if="leave.isIntegrationLocked" tooltip tooltip-position="left" tooltip-text="{{leave.integrationMessage}}"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="leave-calendar__menu-delete" ng-click="deleteLeave(leave, teamMember)" ng-if="userCanManageTeamHR && !leave.isIntegrationLocked"><i class="icon-trash"></i></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-section leave-calendar__menu-split">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{leave.startDateIso | dateformat:\'dayMonth\'}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-arrow">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{leave.endDateIso | dateformat:\'dayMonth\'}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-section leave-calendar__menu-split" ng-if="userCanManageTeamHR">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input id="leaveHalfDayFrom" label-text="leave.leaveDays <= 1 ? \'Half day AM\' : \'Half day PM\'" name="leaveHalfDayFrom" ng-change="addHalfDayFrom(leave, teamMember)" ng-disabled="(leave.leaveDays <= 1 && leave.halfDayTo) || leave.isIntegrationLocked" ng-model="leave.halfDayFrom" type="checkbox" checkbox>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input id="leaveHalfDayTo" label-text="leave.leaveDays <= 1 ? \'Half day PM\' : \'Half day AM\'" name="leaveHalfDayTo" ng-change="addHalfDayTo(leave, teamMember)" ng-disabled="(leave.leaveDays <= 1 && leave.halfDayFrom) || leave.isIntegrationLocked" ng-model="leave.halfDayTo" type="checkbox" checkbox>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="leave-calendar__menu-length">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTotal:&nbsp;<ng-pluralize count="leave.leaveDays" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-layout fadeIn" ng-if="!leave.theme.display">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="leave-calendar__menu-header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tChoose a leave type:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row leave-calendar__menu-row--types" ng-click="setLeaveTypeForNewLeaveItem(teamMember, leave, 0)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-type secondary">Annual leave</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row leave-calendar__menu-row--types" ng-click="setLeaveTypeForNewLeaveItem(teamMember, leave, 1)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-type quarternary">Special leave</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row leave-calendar__menu-row--types" ng-click="setLeaveTypeForNewLeaveItem(teamMember, leave, 2)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-type assertive">Sick leave</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="leave-calendar__menu-row leave-calendar__menu-row--types" ng-click="setLeaveTypeForNewLeaveItem(teamMember, leave, 3)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="leave-calendar__menu-type greyscale">Unpaid leave</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</aside>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- No team members -->\n\t\t\t<placeholder ng-if="!HS.teamMembers.length" placeholder-graphic="team">\n\t\t\t\t<placeholder-title>You don\'t have any team members set up yet</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>As you add team members in the Team section, they will appear here, so you can start tracking their holidays, sick days and other leave days.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t</placeholder>\n\n\t\t</main>\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/hr/job-grades/jobGradesView.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === PAGE_STATES.ready">\n\t<div class="page-template-a-wrapper">\n\n\t\t<div class="page-template-a-header-wrapper">\n\t\t\t<page-template-a-header icon="threshold-change" page-title="Job Grades"></page-template-a-header>\n\t\t</div>\n\n\t\t<!-- Search bar -->\n\t\t<search-bar action-selected="searchBarActionSelected" count="vm.jobGrades.filtered.length" ng-if="vm.jobGrades.all.length !== 0" options="vm.searchBarOptions" show-actions="vm.jobGrades.all.length !== 0"></search-bar>\n\n\t\t<!-- Job grade cards -->\n\t\t<div class="job-grade-card_wrapper" ng-if="vm.jobGrades.all.length !== 0">\n\t\t\t<job-grade-card agency-profile-id="agencyProfileId" job-grade="jobGrade" job-grades="vm.jobGrades.all" ng-repeat="jobGrade in vm.jobGrades.filtered = ( vm.jobGrades.all | filter : vm.searchBarOptions.search.string ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse" on-update="refresh()"></job-grade-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-if="vm.jobGrades.filtered.length === 0 && vm.jobGrades.all.length !== 0" search-bar-options="vm.searchBarOptions">\n\t\t</empty-search>\n\n\t\t<!-- \'No job grades\' placeholder -->\n\t\t<placeholder ng-if="vm.jobGrades.all.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-job-grades">\n\t\t\t<placeholder-title>{{::$root.currentUser.Permissions.HR.canManageJobGrades ? \'Start adding job grades\' : \'No job grades to display\'}}</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Job grades can be assigned to team members and used with company policies to calculate rates of pay.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions ng-if="::$root.currentUser.Permissions.HR.canManageJobGrades">\n\t\t\t\t<button class="is-primary" data-cy="add-job-grade" ng-click="addJobGrade()">\n\t\t\t\t\t<i class="icon-plus"></i>&nbsp;Add job grade\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === PAGE_STATES.error"></error-block>\n');
$templateCache.put('features/app/hr/policies/policiesView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-switch="activeTab">\n\n\t\t<div class="page-template-a-header-wrapper">\n\t\t\t<page-template-a-header icon="billing" page-title="Policies"></page-template-a-header>\n\t\t</div>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t<a data-cy="hr-policies-sickness-tab" ui-sref-active="active" ui-sref="hr.policies.sickness({agencyProfileId: vm.agencyProfileId})">Sickness</a>\n\t\t\t\t<a data-cy="hr-policies-parental-tab" ui-sref-active="active" ui-sref="hr.policies.parental({agencyProfileId: vm.agencyProfileId})">Parental</a>\n\t\t\t\t<a data-cy="hr-policies-pension-tab" ui-sref-active="active" ui-sref="hr.policies.pension({agencyProfileId: vm.agencyProfileId})">Pension</a>\n\t\t\t\t<!-- Pay policies visible only to Paycircle users for the time being -->\n\t\t\t\t<a data-cy="hr-policies-pay-tab" ui-sref-active="active" ui-sref="hr.policies.pay({agencyProfileId: vm.agencyProfileId})">Pay</a>\n\t\t\t\t<a data-cy="hr-policies-holiday-tab" ui-sref-active="active" ui-sref="hr.policies.holiday({agencyProfileId: vm.agencyProfileId})">Holiday</a>\n\t\t\t</nav>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/hr/imports/hrImportsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.importGroups.length">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="upload" page-title="Pay policy imports"></page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Search bar -->\n\t\t\t<search-bar count="vm.importGroupsFiltered.length" data-cy="hr-imports-search-bar" options="vm.searchBarOptions"></search-bar>\n\n\t\t\t<!-- Import Cards -->\n\t\t\t<div class="import-history-item_wrapper">\n\t\t\t\t<import-history-item agency-profile-id="agencyProfileId" current-page="vm.searchBarOptions.currentPageNumber" data-cy="hr-imports-history-item" dir-paginate="import in vm.importGroupsFiltered = ( vm.importGroups | filter : vm.searchBarOptions.search.string ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse | itemsPerPage : vm.searchBarOptions.results.itemsPerPage" import="import" on-update="refreshPage()" pay-period="vm.payPeriod"></import-history-item>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" data-cy="hr-imports-pagination" direction-links="true" max-size="7"></dir-pagination-controls>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="vm.importGroupsFiltered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- No imports -->\n\t<placeholder ng-if="!vm.importGroups.length" placeholder-graphic="import">\n\t\t<placeholder-title>You don\'t have any pay policy imports to show yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you import pay policy data it will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/payroll-current-period.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section ng-if="pageState === \'ready\'">\n\n\t<!-- Workflow -->\n\t<pay-period-workflow agency-profile-id="currentCompany.AgencyProfileID" logged-in-user="currentUser" on-update="updateWorkflow()" pay-period="vm.payPeriod" workflow-template="vm.workflowTemplate" ng-if="vm.isWorkflowActive"></pay-period-workflow>\n\n\t<!-- PAYE Open -->\n\t<div class="page-template-c" ng-if="::!currentCompany.CeasePAYESchemeComplete">\n\n\t\t<!-- Demo task completed -->\n\t\t<demo-completed ng-if="$root.demoTaskComplete" dc-for="addBonus,addExpense,addPayslipNote"></demo-completed>\n\n\t\t<div class="page-template-c-wrapper fadeIn" ng-switch="vm.viewType">\n\n\t\t\t<!-- Action Bar -->\n\t\t\t<div class="page-template-c-action-bar">\n\n\t\t\t\t<!-- Period in Rollback -->\n\t\t\t\t<div ng-if="$root.currentPeriod.IsRollback">\n\t\t\t\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Will only show the message of highest importance (top to bottom) -->\n\t\t\t\t<div class="message-bar-priority-group">\n\n\t\t\t\t\t<!-- Compulsory submission -->\n\t\t\t\t\t<message-bar class="align-center" tag-label="Warning" tag-label-icon="warning" theme="assertive" ng-if="::vm.payPeriod.IsCompulsorySubmission">\n\t\t\t\t\t\t<p><span class="stronger">Payroll will be automatically be submitted in <span class="highlight">{{vm.payPeriod.CompulsorySubmissionDaysAway}}&nbsp;<ng-pluralize count="vm.payPeriod.CompulsorySubmissionDaysAway" when="{\'1\': \'day\', \'other\': \'days\'}"></ng-pluralize></span>.</span></p>\n\t\t\t\t\t</message-bar>\n\n\t\t\t\t\t<!-- Autorun -->\n\t\t\t\t\t<message-bar class="align-center" tag-label="Auto run" tag-label-icon="clock" theme="quarternary" ng-if="::currentCompany.IsAutoRun && currentUser.canSeeAutoRun">\n\t\t\t\t\t\t<p><span class="stronger">Payroll is set to <span class="highlight">Auto run on {{vm.payPeriod.ProcessDateISO | dateformat}}</span></span>. Want to change this? <a ui-sref="settings.company.payroll-settings({agencyProfileId: agencyProfileId})">Go to company settings</a></p>\n\t\t\t\t\t</message-bar>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Header -->\n\t\t\t<page-template-c-header icon="clock" page-title="{{vm.payPeriod.PayPeriodDisplay}}">\n\t\t\t\t<pt-tertiary ng-if="vm.previousPayPeriod.PayPeriodDisplay">\n\t\t\t\t\t<a ui-sref="payroll.previous-period({agencyProfileId: agencyProfileId})"><i class="icon-back m"></i>&nbsp;&nbsp;{{vm.previousPayPeriod.PayPeriodDisplay}}</a>\n\t\t\t\t</pt-tertiary>\n\t\t\t\t<pt-sub-heading>\n\t\t\t\t\t<p class="is-small"><strong>Pay day:</strong> {{vm.payPeriod.PayDateISO | dateformat}} ({{vm.payPeriod.TaxPeriod | taxPeriodDescription:vm.payPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t\t</pt-sub-heading>\n\t\t\t\t<pt-action-menu>\n\t\t\t\t\t<div class="page-template-c-action-item page-template-c-action-button" ng-if="currentCompany.IsExpatActive">\n\t\t\t\t\t\t<button class="is-white" ng-click="openCompanySettingsCurrencyForm(vm.payPeriod)" type="button">\n\t\t\t\t\t\t\t<i class="icon-fixed-value button_icon-pre"></i> Currencies\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="page-template-c-action-item page-template-c-action-button" ng-if="currentUser.Permissions.Payroll.canUpdateTaxUpdates">\n\t\t\t\t\t\t<button class="is-white" ng-click="openTaxUpdatesForm(vm)" type="button">\n\t\t\t\t\t\t\t<i class="icon-tax-code-change button_icon-pre"></i> Get tax updates\n\n\t\t\t\t\t\t\t<div class="button-counter is-assertive" ng-if="vm.payPeriod.DPSState === DPS_STATES.hmrcFault">\n\t\t\t\t\t\t\t\t<span><i class="button-counter_icon icon-warning s"></i></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="button-counter tertiary" ng-class="{\'tada\': true}" ng-if="vm.payPeriodCounts.NumberOfTaxChangesPending && vm.payPeriod.DPSState !== DPS_STATES.hmrcFault">\n\t\t\t\t\t\t\t\t<div tooltip tooltip-text="HMRC Updates for review">\n\t\t\t\t\t\t\t\t\t<i class="icon-loading xs spin" ng-if="false"></i>\n\t\t\t\t\t\t\t\t\t<span>{{vm.payPeriodCounts.NumberOfTaxChangesPending | nineMax}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<menu-button class="page-template-c-action-button" menu-button-align="left" menu-button-has-chevron="false" menu-button-text="Add" menu-button-type="fluid" menu-button-id="payroll-current-period-add">\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-change" href="" ng-click="openAddAChangeForm(vm.payPeriod, undefined, true)" ng-if="vm.permissions.isAddChangeVisible">\n\t\t\t\t\t\t\t<i class="icon-adjustment"></i>\n\t\t\t\t\t\t\t<span>Change</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-changes-table" href="" ng-click="openChangesTable(vm.payPeriod)" ng-if="vm.isChangesTableEditable">\n\t\t\t\t\t\t\t<i class="icon-excel"></i>\n\t\t\t\t\t\t\t<span>Changes table</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-hourly-totals" href="" ng-click="openAddHourlyTotalsForm(vm.payPeriod)" ng-if="::vm.permissions.isHourlyTotalsVisible">\n\t\t\t\t\t\t\t<i class="icon-clock"></i>\n\t\t\t\t\t\t\t<span>Hourly totals</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-link-rates" href="" ng-click="openAddLinkRatesForm(vm.payPeriod)" ng-if="::vm.permissions.isLinkRatesVisible">\n\t\t\t\t\t\t\t<i class="icon-link"></i>\n\t\t\t\t\t\t\t<span>Link rates</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-import" ui-sref="data-importer.my-files({agencyProfileId: agencyProfileId, agencyDocumentType: DOCUMENT_TYPES.periodImport})" ng-if="vm.permissions.isImportsVisible">\n\t\t\t\t\t\t\t<i class="icon-upload"></i>\n\t\t\t\t\t\t\t<span>Import</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-note" href="" ng-click="openAddPeriodNoteForm()" ng-if="::vm.permissions.isNotesVisible">\n\t\t\t\t\t\t\t<i class="icon-chat"></i>\n\t\t\t\t\t\t\t<span>Note</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="payroll-current-period-add-task" href="" ng-click="openAddPeriodTaskForm()" ng-if="::vm.permissions.isTasksVisible">\n\t\t\t\t\t\t\t<i class="icon-tick-square"></i>\n\t\t\t\t\t\t\t<span>Task</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</menu-button>\n\n\t\t\t\t\t<div class="page-template-c-action-item page-template-c-action-button" ng-if="vm.permissions.isCalculateVisible">\n\t\t\t\t\t\t<span class="page-template-c-action-demo" tooltip-demo td-id="{{$root.DEMO_TASKS.approvePayroll.calculatePayroll}}"></span>\n\t\t\t\t\t\t<button class="is-tertiary" id="calculate-payroll-a" ng-click="openCalculatePayrollForm(vm)" ng-if="\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\tvm.isWorkflowActive &&\n\t\t\t\t\t\t\t\t\tvm.workflowTemplate.showWorkflowActions &&\n\t\t\t\t\t\t\t\t\tvm.workflowTemplate.IsCalculateAvailable\n\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t!vm.isWorkflowActive &&\n\t\t\t\t\t\t\t\t\tcurrentUser.Permissions.Payroll.canCalculatePayroll\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t" type="button">\n\t\t\t\t\t\t\t<i class="button_icon-pre icon-chevron-right"></i> Calculate\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</pt-action-menu>\n\t\t\t</page-template-c-header>\n\n\t\t\t<!-- Info -->\n\t\t\t<div class="page-template-c-section align-center" ng-if="vm.permissions.isFinishPeriodStateVisible">\n\t\t\t\t<p class="s">Click &lsquo;Finish&rsquo; when you\'ve finished adding your data</p>\n\t\t\t</div>\n\n\t\t\t<!-- Import Incomplete -->\n\t\t\t<section pc-switch-when="VIEW_TYPES.import">\n\t\t\t\t<user-importer-status-block agency-profile-id="agencyProfileId" pay-period="vm.payPeriod"></user-importer-status-block>\n\t\t\t</section>\n\n\t\t\t<!-- Changes table imports. Visible when the changes haven\'t been marked as \'complete\' -->\n\t\t\t<section class="page-template-c-section fadeIn" ng-if="vm.userImportGroup && vm.userPayElements && vm.isChangesTableEditable">\n\t\t\t\t<changes-imported agency-profile-id="agencyProfileId" is-workflow-active="vm.isWorkflowActive" on-import="refreshPayroll()" pay-period="vm.payPeriod" user-pay-elements="vm.userPayElements"></changes-imported>\n\t\t\t</section>\n\n\t\t\t<!-- Import Complete or Normal payroll -->\n\t\t\t<section pc-switch-when="VIEW_TYPES.payroll">\n\n\t\t\t\t<!-- At least one tab is visible to the user -->\n\t\t\t\t<div ng-if="vm.currentPeriodTabBarDef.tabs.length">\n\n\t\t\t\t\t<section class="page-template-c-navigation">\n\t\t\t\t\t\t<tab-bar tab-bar-def="vm.currentPeriodTabBarDef" tab-bar-counts="vm.currentPeriodTabBarCounts" is-centered="true"></tab-bar>\n\t\t\t\t\t</section>\n\n\t\t\t\t\t<!-- Team members -->\n\t\t\t\t\t<main class="page-template-c-main" ui-view></main>\n\n\t\t\t\t\t<!-- Undo Import -->\n\t\t\t\t\t<section class="page-template-c-section" ng-if="currentCompany.IsDataImportEnabled">\n\t\t\t\t\t\t<message-bar class="align-center">\n\t\t\t\t\t\t\t<p>Want to re-import your workers and start again? <a href="" ng-click="openUndoImportForm()">Undo this import</a></p>\n\t\t\t\t\t\t</message-bar>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No tabs are visible to the user -->\n\t\t\t\t<placeholder ng-if="!vm.currentPeriodTabBarDef.tabs.length" placeholder-graphic="access-denied" placeholder-graphic-size="l">\n\t\t\t\t\t<placeholder-title>You don\'t have permission to view this pay period</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>Contact your administrator if you think you should have access.</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- PAYE Closed -->\n\t<div class="page-template-c" ng-if="::currentCompany.CeasePAYESchemeComplete">\n\n\t\t<div class="dashboard-block assertive fadeIn">\n\n\t\t\t<main class="dashboard-block-main">\n\t\t\t\t<img alt="" class="dashboard-block-graphic" src="images/graphics/placeholders/paye-scheme-closed.2x.png" width="280">\n\n\t\t\t\t<section class="dashboard-block-section">\n\t\t\t\t\t<p class="dashboard-block-period">\n\t\t\t\t\t\t<span class="dashboard-block-period-label">Last period</span>\n\t\t\t\t\t\t<span class="dashboard-block-period-value">{{vm.previousPayPeriod.PayPeriodDisplay}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3 class="dashboard-block-title">This PAYE scheme has been closed</h3>\n\t\t\t\t\t<p class="dashboard-block-subtitle">The PAYE scheme with the reference {{currentCompany.PAYERef}} was closed on {{currentCompany.PAYECeaseDateISO | dateformat}}.<br>\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.closingPayeScheme" theme="assertive">Read more about closing a PAYE scheme</support-article-link></p>\n\t\t\t\t\t<a ui-sref="pensions.scheme.settings({agencyProfileId: currentCompany.AgencyProfileID})" class="button assertive" ng-if="company.Company.HasPension">Disconnect your pension</a>\n\t\t\t\t</section>\n\t\t\t</main>\n\t\t\t<div class="tag-label assertive dashboard-block-tag-label"><i class="icon-cross tag-label-icon"></i>Closed</div>\n\t\t</div>\n\t</div>\n\n</section>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/future-changes/payroll-future-changes.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Information -->\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div ng-if="futureChanges.length">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="calendar" page-title="Future changes">\n\t\t\t<pt-secondary ng-if="$root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\t<a href="" ng-click="openAddAChangeForm()" class="button primary">\n\t\t\t\t\tAdd future change\n\t\t\t\t</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Team members -->\n\t\t<div class="page-template-a-wrapper">\n\n\t\t\t<!-- Team -->\n\t\t\t<main class="page-template-a-main">\n\n\t\t\t\t<!-- Filter -->\n\t\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t\t<!-- Search -->\n\t\t\t\t<search-bar options="searchBarOptions" count="filteredFutureChanges.length"></search-bar>\n\n\t\t\t\t<!-- Team Cards -->\n\t\t\t\t<section class="future-change-cards">\n\n\t\t\t\t\t<div class="future-change-card" dir-paginate="futureChange in filteredFutureChanges =\n\t\t\t\t\t\t\t( futureChanges |\n\t\t\t\t\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage" ng-switch="futureChange.paymentType">\n\n\t\t\t\t\t\t<div class="future-change-card-main">\n\t\t\t\t\t\t\t<a class="future-change-card-persona" ui-sref="team.profile.overview({agencyProfileId: agencyProfileId, userId:futureChange.UserID})">\n\t\t\t\t\t\t\t\t<avatar avatar-initial="{{futureChange.UserForename ? futureChange.UserForename[0] : futureChange.Forename[0]}}" avatar-size="is-medium" avatar-user-id="{{futureChange.UserID}}" class="future-change-card-avatar is-link"></avatar>\n\t\t\t\t\t\t\t\t<name class="future-change-card-name" forename="{{futureChange.UserForename ? futureChange.UserForename : futureChange.Forename}}" surname="{{futureChange.UserSurname ? futureChange.UserSurname : futureChange.Surname}}"></name>\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<div class="future-change-card-info-outer">\n\t\t\t\t\t\t\t\t<div class="future-change-card-info">\n\t\t\t\t\t\t\t\t\t<div class="future-change-card-info-item">\n\t\t\t\t\t\t\t\t\t\t{{futureChange.Period ? futureChange.Period : futureChange.PayPeriodDisplay}}\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="future-change-card-info-item future-change-card-recurring" ng-if="futureChange.PaymentScheduleTypeID !== REPAYMENT_SCHEDULE_TYPES.childcareVouchers && futureChange.RemainingPayments > 0" tooltip tooltip-size="m" tooltip-text="{{futureChange.RemainingPayments > 1 ? \'Will recur for \' + futureChange.RemainingPayments + \' pay periods\' : \'Will recur for 1 pay period\'}}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-loading"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="future-change-card-info-item" pc-switch-when="SCHEDULED_PAYMENT_TYPES.salaryChange">\n\t\t\t\t\t\t\t\t\t\t<span class="tag tertiary highlight-on-hover align-with-text has-margin-left future-change-card-tooltip" tooltip tooltip-text="Effective date: {{futureChange.SalaryEffectiveDateChangeISO | dateformat}}">\n\t\t\t\t\t\t\t\t\t\t\tSalary Change\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div ng-if="futureChange.SalaryPolicyPostTitle" class="future-change-card-info-item">\n\t\t\t\t\t\t\t\t\t\t<icon-dot ng-if="futureChange.SalaryPolicyPostTitle" icon="icon-setup-user" theme="is-primary is-light has-hover" tooltip-position="left" tooltip-text="{{futureChange.SalaryPolicyPostTitle}}"></icon-dot>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- General changes -->\n\t\t\t\t\t\t\t<div ng-if="futureChange.paymentType === SCHEDULED_PAYMENT_TYPES.change">\n\t\t\t\t\t\t\t\t<div class="future-change-card-adjustment">\n\t\t\t\t\t\t\t\t\t<!-- Editable -->\n\t\t\t\t\t\t\t\t\t<a class="future-change-card-adjustment-label" href="" ng-click="openEditChangeForm(futureChange)" ng-if="futureChange.canEdit" tooltip tooltip-size="m" tooltip-text="{{futureChange.Tooltip ? futureChange.Tooltip : futureChange.Description}}">\n\t\t\t\t\t\t\t\t\t\t{{futureChange.Label !== \'\' ? futureChange.Label : futureChange.Description}}\n\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t<!-- Not Editable -->\n\t\t\t\t\t\t\t\t\t<span class="future-change-card-adjustment-label is-not-editable" ng-if="!futureChange.canEdit">\n\t\t\t\t\t\t\t\t\t\t{{futureChange.Label !== \'\' ? futureChange.Label : futureChange.Description}}\n\t\t\t\t\t\t\t\t\t\t<i class="icon-information" data-cy="future-change-integration-info" ng-if="futureChange.IsFromIntegration" tooltip tooltip-position="right" tooltip-size="m" tooltip-text="This adjustment is managed by a source system and cannot be edited here."></i>\n\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t<span class="future-change-card-adjustment-amount {{futureChange.Deduction ? \'assertive\' : \'positive\'}}">{{futureChange.Deduction ? \'-\' : \'+\'}}{{futureChange.Value | monetise}}</span>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<dropdown-menu class="future-change-card-action-menu" menu-icon="icon-setup" menu-show-chevron="false" menu-size="l" ng-if="futureChange.canEdit">\n\t\t\t\t\t\t\t\t\t<div class="dropdown-group" ng-if="futureChange.canEdit">\n\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="openEditChangeForm(futureChange)">Edit change</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="dropdown-group" ng-if="futureChange.canDelete">\n\t\t\t\t\t\t\t\t\t\t<a class="assertive" href="" ng-click="openDeleteChangeForm(futureChange)">Delete change</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Stat / Scheduled payments -->\n\t\t\t\t\t\t\t<div ng-if="![SCHEDULED_PAYMENT_TYPES.change, SCHEDULED_PAYMENT_TYPES.salaryChange].includes(futureChange.paymentType)">\n\t\t\t\t\t\t\t\t<div class="future-change-card-adjustment">\n\t\t\t\t\t\t\t\t\t<a class="future-change-card-adjustment-label" href="" ng-click="openFutureAdjustmentViewForm(futureChange)" ng-if="::futureChange.Label !== \'\'">\n\t\t\t\t\t\t\t\t\t\t{{futureChange.Label}}\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<span class="future-change-card-adjustment-amount assertive">-{{futureChange.ValueForPeriod | monetise}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<a aria-label="View change" class="future-change-card-action" href="" ng-click="openFutureAdjustmentViewForm(futureChange)">\n\t\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Future Salary Change-->\n\t\t\t\t\t\t\t<div ng-if="futureChange.paymentType === SCHEDULED_PAYMENT_TYPES.salaryChange">\n\t\t\t\t\t\t\t\t<div class="future-change-card-salary">\n\t\t\t\t\t\t\t\t\t<p class="greyscale-dark is-small stronger">\n\t\t\t\t\t\t\t\t\t\t{{futureChange.SalaryYearlyCurrent | monetise}} <i class="icon-arrow-right tertiary"></i> {{futureChange.SalaryYearlyChange | monetise}}\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<a aria-label="View change" class="future-change-card-action" href="" ng-click="openFutureAdjustmentViewForm(futureChange)">\n\t\t\t\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Scheduled payments -->\n\t\t\t\t\t\t<footer class="future-change-card-footer" pc-switch-when="SCHEDULED_PAYMENT_TYPES.scheduledPayment">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t<i class="icon-{{futureChange.PaymentScheduleTypeID | paymentScheduleTypeIcon}} future-change-card-footer-icon primary"></i>\n\t\t\t\t\t\t\t\t{{futureChange.PaymentScheduleTypeDescription}} -\n\t\t\t\t\t\t\t\t<span>{{futureChange.AmountOutstanding | monetise}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t<!-- Maternity Pay -->\n\t\t\t\t\t\t<footer class="future-change-card-footer" pc-switch-when="SCHEDULED_PAYMENT_TYPES.maternityPay">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t<i class="icon-maternity future-change-card-footer-icon tertiary"></i>\n\t\t\t\t\t\t\t\tMaternity leave -\n\t\t\t\t\t\t\t\t<span>{{futureChange.StartDateISO | dateformat}} - {{futureChange.EndDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t<!-- Paternity Pay -->\n\t\t\t\t\t\t<footer class="future-change-card-footer" pc-switch-when="SCHEDULED_PAYMENT_TYPES.paternityPay">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t<i class="icon-maternity future-change-card-footer-icon tertiary"></i>\n\t\t\t\t\t\t\t\tPaternity leave -\n\t\t\t\t\t\t\t\t<span>{{futureChange.StartDateISO | dateformat}} - {{futureChange.EndDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\n\t\t\t\t\t\t<!-- Sick Pay -->\n\t\t\t\t\t\t<footer class="future-change-card-footer" pc-switch-when="SCHEDULED_PAYMENT_TYPES.sicknessPay">\n\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t<i class="icon-sick future-change-card-footer-icon positive"></i>\n\t\t\t\t\t\t\t\tSick pay -\n\t\t\t\t\t\t\t\t<span>{{futureChange.StartDateISO | dateformat}} - {{futureChange.EndDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</footer>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search ng-show="filteredFutureChanges.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Pagination -->\n\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t\t\t</main>\n\n\t\t\t<!-- Powered by Paycircle -->\n\t\t\t<powered-by-paycircle></powered-by-paycircle>\n\t\t</div>\n\t</div>\n\n\t<!-- No future changes -->\n\t<placeholder placeholder-graphic="changes" ng-if="!futureChanges.length">\n\t\t<placeholder-title>Start creating your future changes</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>If you have any adjustments that will apply in future pay periods you can add them here and Paycircle will automatically apply them in the period you specify. For more information regarding how to set up future adjustments,\n\t\t\t\t<support-article-link article-key="URLS.paycircle.support.futureChanges" underline="true">check out our help guide</support-article-link>.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="openAddAChangeForm()" class="button primary">\n\t\t\t\tAdd future change\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/pay-period/pay-period.view.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-c fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Page -->\n\t<div class="page-template-c-wrapper" ng-if="::vm.payPeriod">\n\n\t\t<div class="page-template-c-section pay-period-back-row">\n\t\t\t<a ui-sref="payroll.history.pay-periods({agencyProfileId: agencyProfileId})" class="link-with-icon greyscale"><i class="icon-back"></i>Back to history</a>\n\t\t\t<feature-sentiment customer-name="currentCompany.Name" data-cy="feature-sentiment-post-payroll" feature="your pay run" ng-if="vm.payPeriod.PayrollState === SUBMISSION_STATES.submitted" product="Paycircle" user-id="$root.currentUser.UserResponseContactEmail">\n\t\t\t</feature-sentiment>\n\t\t</div>\n\n\t\t<!-- Header -->\n\t\t<page-template-c-header icon="history" page-title="{{::vm.payPeriod.PayPeriodDisplay}}" secondary-content-type="info" show-secondary-content="true">\n\t\t\t<pt-total-cost>\n\t\t\t\t{{::vm.payPeriod.TotalCost | monetise}}\n\t\t\t</pt-total-cost>\n\t\t\t<pt-sub-heading>\n\t\t\t\t<p class="is-small"><strong>Pay day:</strong> {{vm.payPeriod.PayDateISO | dateformat}} ({{vm.payPeriod.TaxPeriod | taxPeriodDescription:vm.payPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-action-menu>\n\t\t\t\t<menu-button class="page-template-c-action-button" data-cy="pay-period-payslips" menu-button-align="left" menu-button-has-chevron="false" menu-button-icon="icon-download" menu-button-size="l" menu-button-text="Payslips" menu-button-type="fluid" ng-if="\n\t\t\t\t\t\t(vm.reports | reportCategories:\'payslip\').length > 0\n\t\t\t\t\t\t&& $root.currentUser.Permissions.isReportingVisible\n\t\t\t\t\t">\n\t\t\t\t\t<report-export-item id="download-payslips-link-{[$index}}" report="report" ng-repeat="report in vm.reports | reportCategories:\'payslip\'"></report-export-item>\n\t\t\t\t</menu-button>\n\t\t\t\t<a class="button primary page-template-c-action-button" data-cy="pay-period-reports" href="" ng-click="openReportsExportForm()" ng-if="$root.currentUser.Permissions.isReportingVisible"><i class="icon-download"></i> Reports</a>\n\t\t\t\t<div class="page-template-c-message" ng-class="{ \'has-action\': !vm.payPeriod.PayMailSent }">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<i class="icon-payslip is-medium is-indifferent has-margin-right"></i>\n\t\t\t\t\t\t<span class="strong">Pay notifications {{vm.payPeriod.PayMailSent ? \'sent\' : \'scheduled\'}}:</span>&nbsp;\n\t\t\t\t\t\t<span class="italic is-indifferent">{{vm.payPeriod.PayslipDateISO | dateformat: \'longWithShortMonth\'}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<a href="" class="page-template-c-message-action is-indifferent" ng-if="!vm.payPeriod.PayMailSent" ng-click="editPayNotificationDate(vm.payPeriod)">Edit date<i class="icon-chevron-right is-medium is-indifferent"></i></a>\n\t\t\t\t</div>\n\t\t\t</pt-action-menu>\n\t\t</page-template-c-header>\n\n\t\t<main class="page-template-c-main">\n\n\t\t\t<!-- Pay Period Info -->\n\t\t\t<pay-period-tabs allow-changes-in-restricted-view="true" company="currentCompany" is-restricted-view="$root.userHasRole([\'groupadminlite\', \'companyadministratorlite\'])" on-pay-period-change="init" pay-period="vm.payPeriod" reports="vm.reports" supplementary-pay-runs="vm.supplementaryPayments"></pay-period-tabs>\n\n\t\t</main>\n\t</div>\n\n\t<!-- No payroll history -->\n\t<placeholder placeholder-graphic="no-pay-periods" ng-if="::!vm.payPeriod">\n\t\t<placeholder-title>You don\'t have any history yet.</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As soon as you approve your first period, your history will be shown here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/paycircle-dashboard/tabs/api-references.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<section class="sub-page-template-a-section">\n\n\t\t\t<header class="sub-page-template-a-header">\n\t\t\t\t<p class="s strong">Notes:</p>\n\t\t\t\t<ul class="bullet-list primary s">\n\t\t\t\t\t<li class="bullet-list-item s">This table list all API references across projects <strong>Payroll</strong>, <strong>UserPortal</strong> and <strong>Registration</strong>.</li>\n\t\t\t\t\t<li class="bullet-list-item s">This table has a composite primary key of <strong>API + PROJECT</strong>.</li>\n\t\t\t\t\t<li class="bullet-list-item s">A small number of library functions don\'t correspond to an API call (e.g. <strong>getUserId</strong> in <strong>UserPortal</strong>).</li>\n\t\t\t\t\t<li class="bullet-list-item s">Library names are sometimes different across projects (e.g. <strong>agency</strong> in <strong>UserPortal</strong> is analogous to <strong>companyData</strong> in <strong>Payroll</strong>).</li>\n\t\t\t\t</ul>\n\t\t\t</header>\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t\t<search-bar options="vm.searchBarOptions" count="vm.filteredApiReferences.length"></search-bar>\n\n\t\t\t<!-- Data set -->\n\t\t\t<section>\n\n\t\t\t\t<table class="is-primary">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>API</th>\n\t\t\t\t\t\t\t<th>Project</th>\n\t\t\t\t\t\t\t<th>UI library</th>\n\t\t\t\t\t\t\t<th>Reference count</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr ng-repeat="apiReference in vm.filteredApiReferences = ( vm.apiReferences | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse">\n\t\t\t\t\t\t\t<td>{{apiReference.name}}</td>\n\t\t\t\t\t\t\t<td>{{apiReference.project}}</td>\n\t\t\t\t\t\t\t<td>{{apiReference.library}}</td>\n\t\t\t\t\t\t\t<td style="width: 50%;">\n\t\t\t\t\t\t\t\t<a href="" ng-click="toggleShowReferences(apiReference)">&nbsp;<ng-pluralize count="apiReference.referenceCount" when="{\'1\': \'1 reference\', \'other\': \'{} references\'}"></ng-pluralize><i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t\t<table class="is-primary compact" ng-if="apiReference.showReferences">\n\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th>Source file</th>\n\t\t\t\t\t\t\t\t\t\t\t<th>Line</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="reference in apiReference.references">\n\t\t\t\t\t\t\t\t\t\t\t<td>{{reference.filename}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>{{reference.line}}</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\n\t\t\t</section>\n\t\t</section>\n\t</div>\n\n</div>\n\n<!-- Error block. Assume this happens when scansource data isn\'t available. This probably isn\'t worthy of a gremlin -->\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'error\'">\n\n\t<div class="page-template-a-wrapper">\n\t\t<!-- Page Title / Header -->\n\t\t<section class="sub-page-template-a-section">\n\t\t\t<placeholder placeholder-graphic="generic-files" placeholder-graphic-size="l">\n\t\t\t\t<placeholder-title>API reference data not found</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>API reference data isn\'t available in this environment.</p>\n\t\t\t\t\t<p>If you were expecting to see it, talk to someone in the UI team.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t</placeholder>\n\t\t</section>\n\t</div>\n</div>');
$templateCache.put('features/app/paycircle-dashboard/tabs/onboarding-stats.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<section class="sub-page-template-a-section">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t\t<search-bar options="searchBarOptions" count="filteredCompanies.length"></search-bar>\n\n\t\t\t<!-- Data set -->\n\t\t\t<section>\n\n\t\t\t\t<table class="is-primary">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>Bureau</th>\n\t\t\t\t\t\t\t<th>Jan</th>\n\t\t\t\t\t\t\t<th>Feb</th>\n\t\t\t\t\t\t\t<th>Mar</th>\n\t\t\t\t\t\t\t<th>Apr</th>\n\t\t\t\t\t\t\t<th>May</th>\n\t\t\t\t\t\t\t<th>Jun</th>\n\t\t\t\t\t\t\t<th>Jul</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr dir-paginate="company in filteredCompanies = ( onboardingStats.Companies | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : 50">\n\t\t\t\t\t\t\t<td>{{company.Bureau}}</td>\n\t\t\t\t\t\t\t<td>{{company.Jan}}</td>\n\t\t\t\t\t\t\t<td>{{company.Feb}}</td>\n\t\t\t\t\t\t\t<td>{{company.Mar}}</td>\n\t\t\t\t\t\t\t<td>{{company.Apr}}</td>\n\t\t\t\t\t\t\t<td>{{company.May}}</td>\n\t\t\t\t\t\t\t<td>{{company.Jun}}</td>\n\t\t\t\t\t\t\t<td>{{company.Jul}}</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-if="filteredCompanies.length === 0">\n\t\t\t\t\t<a href="" class="button action fadeIn" ng-click="searchBarOptions.search.string = \'\'" ng-if="searchBarOptions.search.string !== \'\'">Clear search</a>\n\t\t\t\t</empty-search>\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</section>\n\t</div>\n\n\t<!-- Optional placeholder for no results -->\n\t<placeholder placeholder-graphic="team" ng-if="!onboardingStats.Companies.length">\n\t\t<placeholder-title>You don\'t have any data to show yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you add data it will appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-secondary-actions>\n\t\t\t<a href="" ng-click="do-something()">Secondary action</a>\n\t\t</placeholder-secondary-actions>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="do-something()" class="button primary">Primary action</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/history/payroll-history.view.html','<div class="page-template-c fadeIn">\n\n\t<div class="page-template-c-wrapper">\n\n\t\t<!-- Header -->\n\t\t<page-template-c-header icon="calendar" page-title="History"></page-template-c-header>\n\n\t\t<section class="page-template-c-navigation">\n\t\t\t<tab-bar is-centered="true" tab-bar-def="vm.payrollHistoryTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<main class="page-template-c-main" ui-view></main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>');
$templateCache.put('features/app/payroll/previous-period/payroll-previous-period.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-c fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-c-wrapper" ng-if="::currentCompany.HasRunPayroll">\n\n\t\t<!-- Header -->\n\t\t<page-template-c-header icon="clock" page-title="{{vm.payPeriod.PayPeriodDisplay}}">\n\t\t\t<pt-secondary>\n\t\t\t\t<a ng-href="{{::currentUser.ngHrefFunctions.currentPeriod(currentCompany.AgencyProfileID)}}">{{vm.payPeriodCurrent.PayPeriodDisplay}}&nbsp;&nbsp;<i class="icon-right m"></i></a>\n\t\t\t</pt-secondary>\n\t\t\t<pt-sub-heading>\n\t\t\t\t<p class="is-small"><strong>Pay day:</strong> {{vm.payPeriod.PayDateISO | dateformat}} ({{vm.payPeriod.TaxPeriod | taxPeriodDescription:vm.payPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-action-menu>\n\t\t\t\t<menu-button class="page-template-c-action-button" menu-button-align="left" menu-button-icon="icon-download" menu-button-size="l" menu-button-type="fluid" menu-button-text="Payslips" menu-button-has-chevron="false" ng-if="::(vm.reports | reportCategories:\'payslip\').length > 0">\n\t\t\t\t\t<report-export-item id="download-payslips-link-{[$index}}" report="payslip" ng-repeat="payslip in vm.reports | reportCategories:\'payslip\'"></report-export-item>\n\t\t\t\t</menu-button>\n\t\t\t</pt-action-menu>\n\t\t</page-template-c-header>\n\n\t\t<section class="page-template-c-section pay-period-tabs-overview fadeIn" ng-if="vm.showPaymentSummary">\n\t\t\t<payroll-payment-summary is-cis-only="vm.company.CISOnly" pay-period="vm.payPeriod" show-pension-info="vm.company.IsPensionActive">\n\t\t\t</payroll-payment-summary>\n\t\t</section>\n\n\t\t<navigation-tabs class="page-template-c-navigation">\n\t\t\t<a href="" ng-click="setActiveTab(vm, vm.TABS.reports)" class="tabs-item" ng-class="{active: vm.activeTab === vm.TABS.reports}">Reports</a>\n\t\t\t<a href="" ng-click="setActiveTab(vm, vm.TABS.notes)" class="tabs-item" ng-class="{active: vm.activeTab === vm.TABS.notes}">Notes</a>\n\t\t</navigation-tabs>\n\n\t\t<main class="page-template-c-main fadeIn" ng-switch="vm.activeTab" ng-if="vm.hasReportsPermissions">\n\n\t\t\t<!-- Reports -->\n\t\t\t<div pc-switch-when="vm.TABS.reports">\n\n\t\t\t\t<!-- Reports -->\n\t\t\t\t<section class="page-template-c-section">\n\n\t\t\t\t\t<!-- Supplementary Pay Runs -->\n\t\t\t\t\t<div class="supplementary-pay-run-cards" ng-if="vm.supplementaryPayRuns.length > 0 && $root.currentUser.Permissions.isHistoryVisible">\n\t\t\t\t\t\t<div class="supplementary-pay-run-card" ng-class="supplementaryPayRun.theme" ng-repeat="supplementaryPayRun in vm.supplementaryPayRuns">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<p class="supplementary-pay-run-card_label">\n\t\t\t\t\t\t\t\t\tSupplementary pay run - {{supplementaryPayRun.SupplementaryPaymentState | supplementaryPaymentStateLabel}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="supplementary-pay-run-card_title">\n\t\t\t\t\t\t\t\t\t{{supplementaryPayRun.SupplementaryPaymentTitle}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<span class="supplementary-pay-run-card_action">\n\t\t\t\t\t\t\t\tView pay run<i class="icon-chevron-right"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<a class="supplementary-pay-run-card_overlay" ui-sref="payroll.supplementary-pay-run.changes({\n\t\t\t\t\t\t\t\t\tpayPeriodId: supplementaryPayRun.AgencyPayPeriodID,\n\t\t\t\t\t\t\t\t\tsupplementaryPaymentId: supplementaryPayRun.SupplementaryPaymentID\n\t\t\t\t\t\t\t\t})"></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Reports -->\n\t\t\t\t\t<div class="report-download-card_wrapper" ng-if="vm.reports.length > 0">\n\t\t\t\t\t\t<report-download-card agency-profile-id="currentCompany.AgencyProfileID" ng-repeat="report in vm.reports | orderBy: [\'-CanDownload\', \'DisplayName\'] " on-update="init()" pay-period="vm.payPeriod" report="report">\n\t\t\t\t\t\t</report-download-card>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No Reports -->\n\t\t\t\t\t<div class="sub-page-template-a-section" ng-if="vm.reports.length === 0">\n\t\t\t\t\t\t<placeholder placeholder-graphic="generic-files">\n\t\t\t\t\t\t\t<placeholder-title>No reports available</placeholder-title>\n\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t<p>No reports are available as they haven\u2019t been assigned to or added for {{currentCompany.Name}} yet.</p>\n\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t\t\t<a href="" ui-sref="settings.company.reports.custom({agencyProfileId: company.AgencyProfileID })" class="link-with-icon primary" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports">Go to report templates<i class="icon-chevron-right n"></i></a>\n\t\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t</div>\n\n\t\t\t\t</section>\n\t\t\t</div>\n\n\t\t\t<!-- Notes -->\n\t\t\t<div pc-switch-when="vm.TABS.notes">\n\n\t\t\t\t<!-- Has notes -->\n\t\t\t\t<div ng-if="vm.notes.length">\n\n\t\t\t\t\t<search-bar options="vm.searchBarOptions" count="vm.notes.length"></search-bar>\n\n\t\t\t\t\t<div class="pay-period-note_wrapper rows">\n\t\t\t\t\t\t<pay-period-note note="note" refresh-notes="refreshNotes" agency-pay-period-id="vm.payPeriod.PayPeriodID" agency-profile-id="agencyProfileId" ng-repeat="note in filtered = ( vm.notes | filter : vm.searchBarOptions.search.string ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse"></pay-period-note>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="filtered.length === 0"></empty-search>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No notes -->\n\t\t\t\t<placeholder placeholder-graphic="notes" placeholder-graphic-size="l" ng-if="!vm.notes.length">\n\t\t\t\t\t<placeholder-title>There are no notes for this period</placeholder-title>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- Optional placeholder for no results -->\n\t<placeholder placeholder-graphic="team" ng-if="::!currentCompany.HasRunPayroll">\n\t\t<placeholder-title>{{currentCompany.Name}} hasn\'t run payroll yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As soon as their first period has been run, it will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/run-payroll/payroll-run-payroll.view.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Workflow -->\n\t<pay-period-workflow agency-profile-id="currentCompany.AgencyProfileID" logged-in-user="currentUser" on-update="refresh(vm)" on-run-payroll="runPayrollCallback" pay-period="vm.payPeriod" workflow-template="vm.workflowTemplate" ng-if="vm.isWorkflowActive && vm.payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted"></pay-period-workflow>\n\n\t<div id="run-payroll-page" class="page-template-c" ng-switch="vm.payPeriod.PayrollState">\n\n\t\t<!-- Demo task completed -->\n\t\t<demo-completed ng-if="demoTaskComplete" dc-for="checkPayroll"></demo-completed>\n\n\t\t<!-- Header -->\n\t\t<page-template-c-header icon="clock" page-title="{{vm.payPeriod.PayPeriodDisplay}}">\n\t\t\t<pt-tertiary ng-if="vm.previousPayPeriod.PayPeriodDisplay">\n\t\t\t\t<a ui-sref="payroll.previous-period({agencyProfileId: currentCompany.AgencyProfileID})"><i class="icon-back m"></i>&nbsp;&nbsp;{{vm.previousPayPeriod.PayPeriodDisplay}}</a>\n\t\t\t</pt-tertiary>\n\t\t\t<pt-total-cost>\n\t\t\t\t{{vm.payPeriod.TotalCost | monetise}}\n\t\t\t</pt-total-cost>\n\t\t\t<pt-sub-heading>\n\t\t\t\t<p class="is-small"><strong>Pay day:</strong> {{vm.payPeriod.PayDateISO | dateformat}} ({{vm.payPeriod.TaxPeriod | taxPeriodDescription:vm.payPeriod.PayPeriodType | capitalise}})</p>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-action-menu ng-if="vm.payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted || vm.payPeriod.PayrollState === SUBMISSION_STATES.submitted">\n\t\t\t\t<a data-cy="run-payroll-undo-calculation" href="" ng-click="openUncalculatePayrollForm(vm, vm.workflowTemplate)" class="button white page-template-c-action-button" ng-if="vm.permissions.isUnlockPayrollVisible && vm.payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted"><i class="icon-chevron-left"></i>Undo calculation</a>\n\t\t\t\t<menu-button class="page-template-c-action-button" menu-button-align="left" menu-button-has-chevron="false" menu-button-id="run-payroll-add" menu-button-text="Add" menu-button-type="fluid" ng-if="vm.payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted">\n\t\t\t\t\t<a data-cy="payroll-run-payroll-note-link" href="" ng-click="openAddPeriodNoteForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateNotes">\n\t\t\t\t\t\t<i class="icon-chat"></i>\n\t\t\t\t\t\t<span>Note</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="payroll-run-payroll-task-link" href="" ng-click="openAddPeriodTaskForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateTasks">\n\t\t\t\t\t\t<i class="icon-tick-square"></i>\n\t\t\t\t\t\t<span>Task</span>\n\t\t\t\t\t</a>\n\t\t\t\t</menu-button>\n\n\t\t\t\t<!-- Payslips -->\n\t\t\t\t<div class="menu-button is-left-aligned is-fluid l page-template-c-action-button" click-anywhere-but-here="vm.isPayslipButtonOpen = false" is-active="vm.isPayslipButtonOpen" ng-class="{\n\t\t\t\t\t\t\'is-open\' : vm.isPayslipButtonOpen\n\t\t\t\t\t}" ng-if="\n\t\t\t\t\t\t(vm.payPeriod.CanCreatePayslipReports || vm.payPeriod.CanCreateCISPayStatementReports)\n\t\t\t\t\t\t&& $root.currentUser.Permissions.isReportingVisible\n\t\t\t\t\t">\n\n\t\t\t\t\t<a class="button menu-button_primary-action is-primary" data-cy="generate-payslips-button" href="" id="generate-payslips-button" ng-click="reviewPayslipState(vm)">\n\t\t\t\t\t\t<i class="has-margin-right" ng-class="{\n\t\t\t\t\t\t\t\t\'icon-loading spin\': vm.payPeriod.PayslipState === SUBMISSION_STATES.submitting,\n\t\t\t\t\t\t\t\t\'icon-download\': vm.payPeriod.PayslipState !== SUBMISSION_STATES.submitting\n\t\t\t\t\t\t\t}"></i>Payslips\n\t\t\t\t\t</a>\n\n\t\t\t\t\t<div class="dropdown menu-button_dropdown fadeInFast" ng-if="vm.isPayslipButtonOpen" ng-switch="vm.payPeriod.PayslipState">\n\n\t\t\t\t\t\t<!-- Creating -->\n\t\t\t\t\t\t<div class="menu-button_dropdown-state fadeIn" pc-switch-when="SUBMISSION_STATES.submitting">\n\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t<p class="is-small">Generating payslips</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Created -->\n\t\t\t\t\t\t<div pc-switch-when="SUBMISSION_STATES.submitted">\n\n\t\t\t\t\t\t\t<!-- Has payslips -->\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.payslipReports.length > 0" ng-repeat="payslip in vm.payslipReports">\n\t\t\t\t\t\t\t\t<report-export-item id="download-payslips-link-{[$index}}" report="payslip"></report-export-item>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- No payslips -->\n\t\t\t\t\t\t\t<div class="menu-button_dropdown-state has-less-padding fadeIn" ng-if="vm.payslipReports.length === 0">\n\t\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t\t<i class="icon-information is-large is-primary"></i>\n\t\t\t\t\t\t\t\t\t<p class="is-small">There are no payslips available for the period</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t\t<a class="strong" href="" ng-click="reviewPayslipState(vm)">Close</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Failed -->\n\t\t\t\t\t\t<div class="menu-button_dropdown-state has-less-padding fadeIn" pc-switch-when="SUBMISSION_STATES.failed">\n\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t<i class="icon-warning is-large is-tertiary"></i>\n\t\t\t\t\t\t\t\t<p class="is-small">There was a problem generating payslips</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="menu-button_dropdown-state-section">\n\t\t\t\t\t\t\t\t<a class="strong" href="" ng-click="createPayslips(vm)">Try again</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<a class="button primary page-template-c-action-button" data-cy="run-payroll-reports" href="" ng-click="openReportsExportForm(vm)" ng-if="$root.currentUser.Permissions.isReportingVisible"><i class="icon-download has-margin-right"></i>Reports</a>\n\t\t\t\t<div class="page-template-c-action-item page-template-c-action-button" ng-if="vm.permissions.isRunPayrollVisible && vm.payPeriod.PayrollState === SUBMISSION_STATES.unsubmitted">\n\t\t\t\t\t<span class="page-template-c-action-demo" tooltip-demo td-id="{{DEMO_TASKS.approvePayroll.runPayroll}}"></span>\n\t\t\t\t\t<a href="" ng-click="openRunPayrollForm()" data-cy="open-run-payroll-form" class="button tertiary page-template-c-action-button"><i class="icon-chevron-right"></i> Run payroll</a>\n\t\t\t\t</div>\n\t\t\t</pt-action-menu>\n\t\t\t<pt-secondary>\n\t\t\t\t<feature-sentiment customer-name="currentCompany.Name" data-cy="feature-sentiment-run-payroll" feature="your pay run" ng-if="vm.payPeriod.PayrollState === SUBMISSION_STATES.submitted" product="Paycircle" user-id="$root.currentUser.UserResponseContactEmail">\n\t\t\t\t</feature-sentiment>\n\t\t\t</pt-secondary>\n\t\t\t<pt-secondary-action ng-if="vm.nextPayPeriod">\n\t\t\t\t<a href="">{{vm.nextPayPeriod.PayPeriodDisplay}} <i class="icon-next m"></i></a>\n\t\t\t</pt-secondary-action>\n\t\t</page-template-c-header>\n\n\t\t<!-- Unsubmitted -->\n\t\t<div class="page-template-c-wrapper fadeIn" pc-switch-when="SUBMISSION_STATES.unsubmitted" ng-switch="currentCompany.State">\n\n\t\t\t<!-- Onboarding > Demo -->\n\t\t\t<section class="page-template-c-section" pc-switch-when="COMPANY_STATES.demo" ng-if="!vm.canRunPayroll.CanRunPayroll">\n\t\t\t\t<message-bar class="align-center" theme="primary">\n\t\t\t\t\t<p><i class="icon-padlock m primary"></i>&nbsp;&nbsp;\u2018Run payroll\u2019 is locked until you <a ui-sref="company-dashboard({agencyProfileId: currentCompany.AgencyProfileID})" class="underline">complete all your dashboard tasks</a></p>\n\t\t\t\t</message-bar>\n\t\t\t</section>\n\n\t\t\t<!-- Everything else -->\n\t\t\t<section class="page-template-c-section" ng-switch-default>\n\n\t\t\t\t<!-- Compulsory Submission -->\n\t\t\t\t<message-bar class="align-center" theme="assertive" type="action" tag-label="Warning" tag-label-icon="warning" ng-if="vm.payPeriod.IsCompulsorySubmission">\n\t\t\t\t\t<p><span class="stronger">Payroll will be automatically submitted in <span class="highlight">{{vm.payPeriod.CompulsorySubmissionDaysAway}}&nbsp;<ng-pluralize count="vm.payPeriod.CompulsorySubmissionDaysAway" when="{\'1\': \'day\', \'other\': \'days\'}"></ng-pluralize></span>.</span>&nbsp;<button tooltip-demo td-id="{{DEMO_TASKS.approvePayroll.runPayroll}}" class="assertive" ng-click="openRunPayrollForm()">Run payroll now</button></p>\n\t\t\t\t</message-bar>\n\n\t\t\t\t<!-- Autorun -->\n\t\t\t\t<message-bar class="align-center" theme="quarternary" type="action" tag-label="Auto run" tag-label-icon="clock" ng-if="currentCompany.IsAutoRun && !vm.payPeriod.IsCompulsorySubmission && currentUser.canSeeAutoRun">\n\t\t\t\t\t<p><span class="stronger">Payroll is set to <span class="highlight">Auto run on {{vm.payPeriod.ProcessDateISO | dateformat}}</span></span>&nbsp;<button tooltip-demo td-id="{{DEMO_TASKS.approvePayroll.runPayroll}}" class="quarternary" ng-click="openRunPayrollForm()" ng-if="::currentUser.Permissions.Payroll.canRunPayroll">Run payroll now</button></p>\n\t\t\t\t</message-bar>\n\t\t\t</section>\n\n\t\t\t<main class="page-template-a-main">\n\t\t\t\t<pay-period-tabs active-tab="vm.activeTab" company="currentCompany" is-restricted-view="vm.isRestrictedView" on-pay-period-change="refresh" pay-period="vm.payPeriod" reports="vm.reports"></pay-period-tabs>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Submitting -->\n\t\t<div class="page-template-c-wrapper fadeIn" pc-switch-when="[SUBMISSION_STATES.submitting, SUBMISSION_STATES.requesting]">\n\n\t\t\t<main class="payroll-status-box">\n\n\t\t\t\t<div class="payroll-status-details">\n\n\t\t\t\t\t<h5>Running payroll...</h5>\n\n\t\t\t\t\t<circle-loader class="payroll-status-circle-loader"></circle-loader>\n\n\t\t\t\t\t<div ng-switch="currentCompany.State">\n\t\t\t\t\t\t<p pc-switch-when="COMPANY_STATES.demo">This can take a few minutes depending on the number of people in your company. In your live account you\'ll be safe to get on with your day at this point as we\'ll email you to let you know when processing is complete. However, these emails are disabled in your demo account.</p>\n\t\t\t\t\t\t<p ng-switch-default>This can take a few minutes depending on the number of people in your company. You\'re safe to get on with your day now and we\'ll email you to let you know when processing is complete.</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="payroll-status-process-list">\n\n\t\t\t\t\t\t<!-- Test run -->\n\t\t\t\t\t\t<ul class="todo-list" ng-if="currentCompany.IsInTestMode">\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 0}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 0, \'icon-loading spin\': payPeriodSubState === 0}"></i> Calculating and finalising payroll\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 1}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 1, \'icon-loading spin\': payPeriodSubState === 1}"></i> Setting up the next period\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-loading spin\': payPeriodSubState > 1}"></i> Finalising payroll\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t<!-- Approve Payroll -->\n\t\t\t\t\t\t<ul class="todo-list" ng-if="!currentCompany.IsInTestMode">\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 0}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 0, \'icon-loading spin\': payPeriodSubState === 0}"></i> Calculating and finalising payroll\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 1}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 1, \'icon-loading spin\': payPeriodSubState === 1}"></i> Sending the data to HMRC\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 2}" ng-if="!payPeriod.scheduleNotifications">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 2, \'icon-loading spin\': payPeriodSubState === 2}"></i> Preparing payslips and sending payday emails\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 2}" ng-if="payPeriod.scheduleNotifications">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 2, \'icon-loading spin\': payPeriodSubState === 2}"></i> Preparing payslips and scheduling payday emails\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 3}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 3, \'icon-loading spin\': payPeriodSubState === 3}"></i> Setting up the next period\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class="todo-list-item" ng-class="{\'complete\': payPeriodSubState > 4}">\n\t\t\t\t\t\t\t\t<i ng-class="{\'icon-tick tada\': payPeriodSubState > 4, \'icon-loading spin\': payPeriodSubState === 4}"></i> Finalising payroll\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<!-- Submitted -->\n\t\t<div class="page-template-c-wrapper fadeIn" pc-switch-when="SUBMISSION_STATES.submitted">\n\n\t\t\t<section class="page-template-c-section">\n\n\t\t\t\t<!-- Autorun off -->\n\t\t\t\t<div class="message-bar-success" ng-class="{\'fadeIn\': vm.payrollSuccessState === ANIMATION_STATES.animateIn, \'fadeOut\': vm.payrollSuccessState === ANIMATION_STATES.animateOut}" ng-if="vm.payrollSuccessState !== ANIMATION_STATES.hidden">\n\t\t\t\t\t<a href class="message-bar-success-action" ng-click="toggleShowPayrollSuccess(vm)" aria-label="Toggle message"><i class="icon-cross m"></i></a>\n\t\t\t\t\t<div class="message-bar-success-container">\n\n\t\t\t\t\t\t<!-- Icon -->\n\t\t\t\t\t\t<a href ng-click="fireConfetti(vm)" class="message-bar-success-icon tada" aria-label="Fire confetti">\n\t\t\t\t\t\t\t<i class="icon-check xxxl"></i>\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<div class="message-bar-success-main">\n\n\t\t\t\t\t\t\t<h4 class="message-bar-success-title">Payroll has been run successfully!</h4>\n\t\t\t\t\t\t\t<p class="message-bar-success-subtitle" ng-if="!$root.userHasRole([USER_ROLES.paycircle, USER_ROLES.bureau, USER_ROLES.bureaumanager])"><span class="l">\uD83D\uDC49</span>&nbsp;&nbsp;You now need to make the payments below</p>\n\n\t\t\t\t\t\t\t<!-- Not Autorun -->\n\t\t\t\t\t\t\t<p class="s message-bar-success-follow-up" ng-if="::!currentCompany.IsAutoRun || !currentUser.canSeeAutoRun">{{vm.nextPayPeriod.PayPeriodDisplay}} is now open. <a ng-href="{{vm.companyPayrollNgRef}}" class="underline">Go there now</a></p>\n\n\t\t\t\t\t\t\t<!-- Autorun -->\n\t\t\t\t\t\t\t<p class="s message-bar-success-follow-up" ng-if="::currentCompany.IsAutoRun && currentUser.canSeeAutoRun">{{vm.nextPayPeriod.PayPeriodDisplay}} is now open and set to <span class="highlight">Auto run on {{vm.nextPayPeriod.ProcessDateISO | dateformat}}</span></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="message-bar-success-footer" ng-if="vm.accountingIntegrationConnection.IsConnected && $root.currentUser.Permissions.CompanySettings.canAccessReports">\n\t\t\t\t\t\t<!-- Post Journal -->\n\t\t\t\t\t\t<a href ng-click="openPostJournalForm(vm)">\n\t\t\t\t\t\t\t<i class="icon-right is-smedium"></i>\n\t\t\t\t\t\t\tPost your journal to {{vm.accountingIntegrationConnection.accountingIntegrationName}} now\n\t\t\t\t\t\t</a>\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<a href class="message-bar-success-action" ng-click="toggleShowPayrollSuccess(vm)" aria-label="Toggle message"><i class="icon-cross m"></i></a>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<main class="page-template-c-main">\n\n\t\t\t\t<!-- Pay Period Info -->\n\t\t\t\t<pay-period-tabs active-tab="vm.activeTab" company="currentCompany" is-restricted-view="vm.isRestrictedView" on-pay-period-change="refresh" pay-period="vm.payPeriod" reports="vm.reports"></pay-period-tabs>\n\t\t\t</main>\n\n\t\t\t<confetti confetti-id="payroll-ran-confetti" ng-if="vm.showConfetti"></confetti>\n\t\t</div>\n\n\t\t<!-- Failed -->\n\t\t<div class="page-template-c-wrapper fadeIn" pc-switch-when="SUBMISSION_STATES.failed">\n\n\t\t\t<div class="page-template-c-align-middle">\n\t\t\t\t<div class="page-template-c-section">\n\t\t\t\t\t<h4 class="assertive align-center"><i class="icon-warning xl assertive"></i>There seems to be a problem approving payroll</h4>\n\t\t\t\t</div>\n\n\t\t\t\t<section class="page-template-c-section">\n\t\t\t\t\t<p class="is-small align-center">\n\t\t\t\t\t\tYour payroll submission has failed for the reason below. Once you\u2019ve reviewed the issue, click the \u2018Reset payroll\u2019 button and you\u2019ll be taken back to your calculated payroll view where you can run payroll again.\n\t\t\t\t\t</p>\n\t\t\t\t</section>\n\n\t\t\t\t<div class="page-template-c-section">\n\t\t\t\t\t<submission-logs agency-profile-id="AGENCY_PROFILE_ID" on-reset-period="resetPeriod(vm.payPeriod)" pay-period-id="vm.payPeriod.PayPeriodID" submission-log-type="submissionLogType">\n\t\t\t\t\t\t<submission-logs-dismissed-copy>\n\t\t\t\t\t\t\tAll submission errors have been dismissed. <br>Reset payroll and try running it again.\n\t\t\t\t\t\t</submission-logs-dismissed-copy>\n\t\t\t\t\t</submission-logs>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/supplementary-pay-run/supplementary-pay-run.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-c fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-c-wrapper" ng-if="::currentCompany.HasRunPayroll">\n\n\t\t<div class="page-template-c-section">\n\t\t\t<a class="is-greyscale link-with-icon" ui-sref="payroll.history.supplementary-pay-runs({\n\t\t\t\t\tagencyProfileId\n\t\t\t\t})">\n\t\t\t\t<i class="icon-back is-medium has-margin-right"></i>Back to history\n\t\t\t</a>\n\t\t</div>\n\n\t\t<!-- Header -->\n\t\t<page-template-c-header icon="clock" page-title="{{vm.supplementaryPayment.SupplementaryPaymentTitle}}">\n\t\t\t<pt-sub-heading>\n\t\t\t\t<span class="tag has-margin-right" ng-class="{\n\t\t\t\t\t\t\'is-assertive inverse\': vm.supplementaryPayment.SupplementaryPaymentState === SUBMISSION_STATES.failed,\n\t\t\t\t\t\t\'is-indifferent\': vm.supplementaryPayment.SupplementaryPaymentState !== SUBMISSION_STATES.failed\n\t\t\t\t\t}">\n\t\t\t\t\t{{vm.supplementaryPayment.SupplementaryPaymentState | supplementaryPaymentStateLabel}}\n\t\t\t\t</span>\n\t\t\t\t<span class="is-small">\n\t\t\t\t\t<strong>Payment date:</strong>\n\t\t\t\t\t{{vm.supplementaryPayment.SupplementaryPaymentPayDateISO | dateformat}}\n\t\t\t\t</span>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-total-cost>\n\t\t\t\t{{vm.payPeriod.TotalCost | monetise}}\n\t\t\t</pt-total-cost>\n\t\t\t<pt-action-menu>\n\n\t\t\t\t<!-- Delete -->\n\t\t\t\t<button class="is-white page-template-c-action-button" ng-click="vm.openDeleteSupplementaryRunForm(vm)" ng-if="vm.supplementaryPayment.CanDelete && $root.currentUser.Permissions.Payroll.canRunPayroll" type="button">\n\t\t\t\t\t<i class="icon-trash has-margin-right"></i>Delete\n\t\t\t\t</button>\n\n\t\t\t\t<!-- Payslips -->\n\t\t\t\t<menu-button class="page-template-c-action-button" menu-button-align="left" menu-button-has-chevron="false" menu-button-icon="icon-download" menu-button-size="l" menu-button-text="Payslips" menu-button-type="fluid" ng-if="::vm.payslipReports.length > 0 && vm.permissions.isReportsVisible">\n\t\t\t\t\t<report-export-item id="download-payslips-link-{[$index}}" report="payslip" ng-repeat="payslip in vm.payslipReports"></report-export-item>\n\t\t\t\t</menu-button>\n\n\t\t\t\t<!-- Continue -->\n\t\t\t\t<button class="is-tertiary page-template-c-action-button" ng-click="vm.openEditSupplementaryPaymentForm(vm)" ng-if="vm.supplementaryPayment.canEdit && $root.currentUser.Permissions.Payroll.canRunPayroll" type="button">\n\t\t\t\t\t<i class="icon-chevron-right has-margin-right"></i>Continue\n\t\t\t\t</button>\n\t\t\t</pt-action-menu>\n\t\t</page-template-c-header>\n\n\t\t<div ng-if="vm.supplementaryPayRunTabBarDef.tabs.length">\n\t\t\t<section class="page-template-c-navigation">\n\t\t\t\t<tab-bar is-centered="true" tab-bar-def="vm.supplementaryPayRunTabBarDef"></tab-bar>\n\t\t\t</section>\n\n\t\t\t<main class="page-template-c-main" ui-view></main>\n\t\t</div>\n\n\t\t<placeholder ng-if="!vm.supplementaryPayRunTabBarDef.tabs.length" placeholder-graphic="access-denied" placeholder-graphic-size="l">\n\t\t\t<placeholder-title>You don\'t have permission to view this pay period</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Contact your administrator if you think you should have access.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- Optional placeholder for no results -->\n\t<placeholder ng-if="::!currentCompany.HasRunPayroll" placeholder-graphic="team">\n\t\t<placeholder-title>\n\t\t\t{{currentCompany.Name}} hasn\'t run payroll yet\n\t\t</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As soon as their first period has been run, it will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/summary/pensions-summary.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Period in Rollback -->\n\t<div class="page-template-a-action-bar" ng-if="$root.currentPeriod.IsRollback">\n\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t</div>\n\n\t<div class="page-template-a-wrapper" ng-if="!currentCompany.HasPension">\n\t\t<section class="page-template-a-section">\n\t\t\t<setup-block sb-graphic="images/graphics/placeholders/setup-pension.2x.png" sb-theme="is-secondary">\n\t\t\t\t<sb-header>\n\t\t\t\t\t<h1 class="setup-block_heading">\n\t\t\t\t\t\tSet up your company pension\n\t\t\t\t\t</h1>\n\t\t\t\t\t<p class="stronger setup-block_subheading">\n\t\t\t\t\t\tWhether you just have a single workplace pension or a number of active pensions running for this company, you can set everything up here.\n\t\t\t\t\t</p>\n\t\t\t\t</sb-header>\n\t\t\t\t<sb-content>\n\t\t\t\t\t<p class="stronger setup-block_content-header">There are a few things to note before you begin:</p>\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tclass: \'highlighted\',\n\t\t\t\t\t\t\t\ttext: \'Please make sure that you set up your company\\\'s workplace pension first.\'\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\'If you do not have a workplace pension, please set up a \\\'ghost pension\\\' in the background.\',\n\t\t\t\t\t\t\t\'Setting up a company workplace pension or \\\'ghost pension\\\' ensures that the system can perform the correct background pension assessments for your team each pay period - to make sure you stay compliant.\',\n\t\t\t\t\t\t\t\'Once you have set up your workplace pension or ghost pension, you can then set up any number of other company pensions.\',\n\t\t\t\t\t\t\t\'You can also set up more than one workplace pension for your company.\'\n\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t<div class="setup-block_actions">\n\t\t\t\t\t\t<button class="is-secondary is-medium setup-block_actions-button" data-cy="pensions-setup-pension" ng-click="openCompanyPensionConnectorForm()" type="button">\n\t\t\t\t\t\t\tStart setting up my pension\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p class="is-secondary">\n\t\t\t\t\t\t\tSet up normally takes around 5 minutes\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</sb-content>\n\t\t\t</setup-block>\n\t\t</section>\n\n\t\t<hr class="greyscale-lighter xxl">\n\n\t\t<section class="page-template-a-section">\n\t\t\t<p class="align-center">\n\t\t\t\tYou can connect directly to the following pension providers to send and receive data:\n\t\t\t</p>\n\n\t\t\t<div class="spacer l"></div>\n\n\t\t\t<div class="pension-provider-carousel">\n\t\t\t\t<a class="pension-provider-card" href="" ng-href="{{pensionProvider.PensionProviderUrl}}" ng-repeat="pensionProvider in vm.pensionProviders" target="_blank">\n\t\t\t\t\t<img alt="{{pensionProvider.PensionProviderName}}" class="pension-provider-card-logo" ng-src="{{pensionProvider.PensionProviderImageUrl}}">\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="spacer m"></div>\n\n\t\t\t<div class="terms-cards">\n\n\t\t\t\t<!-- Connecting directly -->\n\t\t\t\t<div class="terms-card">\n\t\t\t\t\t<div class="terms-card_header">\n\t\t\t\t\t\t<h6 class="terms-card_title">\n\t\t\t\t\t\t\t<i class="icon-information is-secondary is-large has-margin-right"></i>Connecting directly to your pension provider\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="terms-card_description">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'You can connect directly to some pension providers to automatically send and receive data each time you run payroll.\',\n\t\t\t\t\t\t\t\t\'Some workplace pension providers offer more automation than others.\',\n\t\t\t\t\t\t\t\t\'During the set up process, we will let you know your automation options, based upon the pension provider you have chosen.\',\n\t\t\t\t\t\t\t\t\'If your provider is not listed, you will need to upload your pension file to your provider each time you run payroll and manage your team\\\'s opt in and opt out requests manually.\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Automation options -->\n\t\t\t\t<div class="terms-card is-secondary">\n\t\t\t\t\t<div class="terms-card_header">\n\t\t\t\t\t\t<h6 class="terms-card_title">\n\t\t\t\t\t\t\t<i class="icon-loading is-secondary xl has-margin-right"></i>Automation options include:\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="terms-card_items">\n\t\t\t\t\t\t<div class="terms-card_item">\n\t\t\t\t\t\t\t<h6 class="terms-card_item-header">\n\t\t\t\t\t\t\t\t<i class="icon-team-alt is-large terms-card_item-icon"></i> Team assessment\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPaycircle will automatically assess your team members each pay period and enrol anyone who becomes eligible\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="terms-card_item">\n\t\t\t\t\t\t\t<h6 class="terms-card_item-header">\n\t\t\t\t\t\t\t\t<i class="icon-email is-large terms-card_item-icon"></i> Sending of compliant pension communications\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPaycircle can automatically email pension communications to any team members regarding postponement and status changes\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="terms-card_item">\n\t\t\t\t\t\t\t<h6 class="terms-card_item-header">\n\t\t\t\t\t\t\t\t<i class="icon-submitted is-large terms-card_item-icon"></i> Communication with pension providers\n\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tPaycircle will automatically submit pension files each pay period and receive opt in and opt out updates directly from the pension provider (only available with certain providers)\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t</div>\n\n\t<div class="page-template-a-wrapper" ng-if="currentCompany.HasPension">\n\n\t\t<page-template-a-header icon="money" page-title="Pensions">\n\t\t\t<pt-secondary>\n\t\t\t\t<button class="primary" data-cy="pensions-summary-add-pension" ng-click="openCompanyPensionConnectorForm()" type="button">\n\t\t\t\t\t<i class="icon-plus"></i>&nbsp;Add pension\n\t\t\t\t</button>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<div class="page-template-a-action-bar" ng-if="vm.pensionSummary.TotalNotAllocated || vm.pensionSummary.TotalEligible || $root.currentPeriod.IsRollback">\n\n\t\t\t<notification-card icon="warning" ng-if="vm.pensionSummary.TotalNotAllocated" theme="is-tertiary">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<ng-pluralize count="vm.pensionSummary.TotalNotAllocated" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 team member needs\',\n\t\t\t\t\t\t\t\t\'other\': \'{} team members need\'\n\t\t\t\t\t\t\t}"></ng-pluralize>&nbsp;to be added to a pension.\n\t\t\t\t\t</p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a data-cy="pensions-summary-view-incomplete-team-members" ui-sref="team.members({\n\t\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\t\tapplyfilter: \'team-status-incomplete\'\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tView team members\n\t\t\t\t\t</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\n\t\t\t<notification-card icon="warning" ng-if="vm.pensionSummary.TotalEligible" theme="is-tertiary">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<ng-pluralize count="vm.pensionSummary.TotalEligible" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 team member is\',\n\t\t\t\t\t\t\t\t\'other\': \'{} team members are\'\n\t\t\t\t\t\t\t}"></ng-pluralize>&nbsp; eligible for a workplace pension.\n\t\t\t\t\t\t<a href="" data-cy="pensions-summary-edit-ghost-pension-settings" ng-click="goToGhostPensionSettings(vm.pensionSummary, agencyProfileId)" class="tertiary underline">\n\t\t\t\t\t\t\tEdit your Ghost Pension settings\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a data-cy="pensions-summary-view-team-members" ui-sref="team.members({\n\t\t\t\t\t\t\tagencyProfileId: agencyProfileId\n\t\t\t\t\t\t})">\n\t\t\t\t\t\tView team members\n\t\t\t\t\t</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="stat-block e">\n\t\t\t\t<div class="stat-block__stats">\n\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t<h2 class="stat-block__title">\n\t\t\t\t\t\t\t<i class="icon-joiners stat-block__icon stat-block__icon--large"></i> {{vm.pensionSummary.TotalInPension}}\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<p class="stat-block__desc">\n\t\t\t\t\t\t\tAre in AE pensions\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t<h2 class="stat-block__title">\n\t\t\t\t\t\t\t<i class="icon-leavers stat-block__icon stat-block__icon--large"></i> {{vm.pensionSummary.TotalExcluded}}\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<p class="stat-block__desc">\n\t\t\t\t\t\t\tAre excluded from AE pensions\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="stat-block__stat">\n\t\t\t\t\t\t<h2 class="stat-block__title">\n\t\t\t\t\t\t\t<i class="icon-joiners stat-block__icon stat-block__icon--large"></i> {{vm.pensionSummary.TotalContribution | monetise}}\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<p class="stat-block__desc">\n\t\t\t\t\t\t\tTotal contributions for all AE pensions\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="stat-block__footer">\n\t\t\t\t\t<div class="stat-block__statsfooter">\n\t\t\t\t\t\t<div class="stat-block__statfooter">\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\tNext re-enrolment:\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\t<span>{{vm.pensionSummary.ReenrolmentDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t&nbsp;\n\t\t\t\t\t\t\t\t<a data-cy="pensions-summary-edit-reenrolment-settings" href="" ng-click="openCompanyPensionStagingForm()">\n\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="stat-block__statfooter">\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\tPension period:\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\t<span>{{vm.pensionSummary.PensionStartDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t<i class="icon-arrow-right primary s"></i>\n\t\t\t\t\t\t\t\t<span>{{vm.pensionSummary.PensionEndDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t&nbsp;\n\t\t\t\t\t\t\t\t<a href="" ng-click="openCompanyPensionPeriodForm()" ng-if="vm.pensionSummary.CanUpdatePensionPeriods">\n\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="stat-block__statfooter">\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\tPension period alignment:\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="stat-block__date">\n\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionSummary.HasPensionDateOffset">\n\t\t\t\t\t\t\t\t\tSame as pay periods\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="vm.pensionSummary.IsPensionDateOffsetBeforePeriodDate && vm.pensionSummary.HasPensionDateOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionSummary.PensionDateOffset" when="{\'1\': \'{} day earlier than pay periods\',\n\t\t\t\t\t\t\t\t\t\t\t   \'other\': \'{} days earlier than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionSummary.IsPensionDateOffsetBeforePeriodDate && vm.pensionSummary.HasPensionDateOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionSummary.PensionDateOffset" when="{\'1\': \'{} day later than pay periods\',\n\t\t\t\t\t\t\t\t\t\t\t   \'other\': \'{} days later than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>&nbsp;\n\t\t\t\t\t\t\t\t<a href="" ng-click="openCompanyPensionAlignmentForm()">\n\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Support notification -->\n\t\t\t\t\t<div class="pension-support-notification" style="margin-top: 20px;" ng-if="hasFailedPensions()">\n\t\t\t\t\t\t<notification-card theme="is-tertiary">\n\t\t\t\t\t\t\t<nc-description>\n\t\t\t\t\t\t\t\tHaving trouble updating your pension period dates? Read our troubleshooting guide for assistance\n\t\t\t\t\t\t\t</nc-description>\n\t\t\t\t\t\t\t<nc-action>\n\t\t\t\t\t\t\t\t<a ng-href="{{ $root.URLS.paycircle.help.pensionGroupDatesMismatch }}" target="_blank">\n\t\t\t\t\t\t\t\t\tRead now\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</nc-action>\n\t\t\t\t\t\t</notification-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Data set -->\n\t\t\t<section class="pension-scheme-card_wrapper cards">\n\n\t\t\t\t<pension-scheme-card agency-profile-id="agencyProfileId" callback="init()" index="$index" ng-repeat="pension in vm.pensionSummary.Pensions" pension="pension" total-not-allocated="vm.pensionSummary.TotalNotAllocated"></pension-scheme-card>\n\n\t\t\t</section>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/scheme/pensions-scheme.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Demo task completed -->\n\t<demo-completed ng-if="$root.demoTaskComplete" dc-for="updateEmployeePensionContributions,updateTeamPostponementSettings,updateEmployeesPensionState"></demo-completed>\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<header class="page-template-a-action-bar">\n\t\t\t<a data-cy="pensions-scheme-back-to-pensions" ui-sref="pensions.summary({agencyProfileId: agencyProfileId})" class="link-with-icon greyscale"><i class="icon-back"></i>Back to Pensions</a>\n\t\t</header>\n\n\t\t<div class="page-template-a-action-bar" ng-if="pension.TotalIncomplete || pension.TotalEligible">\n\t\t\t<notification-card theme="is-tertiary" icon="warning" ng-if="pension.TotalIncomplete">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p><ng-pluralize count="pension.TotalIncomplete" when="{\'1\': \'1 team member is\', \'other\': \'{} team members are\'}"></ng-pluralize>&nbsp;missing important pension information.</p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a ui-sref="pensions.scheme.team({agencyProfileId: agencyProfileId, applyfilter: \'team-status-incomplete\'})">View team members</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\n\t\t\t<notification-card theme="is-tertiary" icon="warning" ng-if="pension.TotalEligible">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p><ng-pluralize count="pension.TotalEligible" when="{\'1\': \'1 team member is\', \'other\': \'{} team members are\'}"></ng-pluralize>&nbsp; eligible for a workplace pension. <a data-cy="pensions-scheme-edit-ghost-pension-settings" href="" ui-sref="pensions.scheme.settings({agencyProfileId: agencyProfileId, agencyEmployerPensionId: pension.AgencyEmployerPensionID})" class="tertiary underline">Edit your Ghost Pension settings</a></p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a ui-sref="pensions.scheme.team({agencyProfileId: agencyProfileId, agencyEmployerPensionId: pension.AgencyEmployerPensionID})">View team members</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\t\t</div>\n\n\t\t<!-- Pension Info -->\n\t\t<section class="page-template-a-section">\n\t\t\t<pension-scheme-header agency-profile-id="agencyProfileId" callback="refreshPension()" pension="pension"></pension-scheme-header>\n\t\t</section>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<navigation-tabs>\n\t\t\t\t<a ui-sref-active="active" data-cy="pensions-scheme-status" ui-sref="pensions.scheme.status">Status</a>\n\t\t\t\t<a ui-sref-active="active" data-cy="pensions-scheme-history" ui-sref="pensions.scheme.history">History</a>\n\t\t\t\t<a ui-sref-active="active" data-cy="pensions-scheme-communications" ui-sref="pensions.scheme.communications" ng-if="::pension.PensionType !== PENSION_TYPES.nonAutoEnrolment">Communications</a>\n\t\t\t\t<a ui-sref-active="active" data-cy="pensions-scheme-team" ui-sref="pensions.scheme.team">Team</a>\n\t\t\t\t<a ui-sref-active="active" data-cy="pensions-scheme-settings" ui-sref="pensions.scheme.settings">Settings</a>\n\t\t\t</navigation-tabs>\n\t\t</section>\n\n\t\t<main class="page-template-a-main" ui-view></main>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/reporting/report/reporting-report.view.html','<div class="sub-page-template-a fadeIn">\n\n\t<section class="sub-page-template-a-header reporting-back-row">\n\t\t<a href="" ng-click="onGoBack()" class="link-with-icon greyscale"><i class="icon-back"></i>\n\t\t\t<span ng-if="!reportOptions.returnTo">Back to reports</span>\n\t\t\t<span ng-if="reportOptions.returnTo">Go back</span>\n\t\t</a>\n\t\t<feature-sentiment customer-name="currentCompany.Name" data-cy="feature-sentiment-reporting" feature="reporting" product="Paycircle" user-id="$root.currentUser.UserResponseContactEmail">\n\t\t</feature-sentiment>\n\t</section>\n\n\t<section class="sub-page-template-a-section">\n\n\t\t<report report-options="reportOptions"></report>\n\n\t</section>\n</div>\n');
$templateCache.put('features/app/reporting/saved-settings/reporting-saved-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<main class="sub-page-template-a-main">\n\n\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t<search-bar options="searchBarOptions" count="vm.savedSettings.length"></search-bar>\n\n\t\t<section class="report-settings-card_wrapper rows">\n\t\t\t<report-settings-card agency-profile-id="agencyProfileId" report="reportSettingObj" ng-repeat="reportSettingObj in filtered = (vm.savedSettings | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse"></report-settings-card>\n\t\t</section>\n\t</main>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/reporting/summary/reporting-summary.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<main class="sub-page-template-a-main" ng-if="vm.reports.length > 0">\n\n\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t<search-bar options="vm.searchBarOptions" count="vm.reportsFiltered.length"></search-bar>\n\n\t\t<div class="report-card_wrapper cards fadeIn">\n\t\t\t<report-card agency-profile-id="currentCompany.AgencyProfileID" report="report" ng-repeat="report in vm.reportsFiltered = (vm.reports | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter)"></report-card>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="!vm.reportsFiltered.length"></empty-search>\n\t\t</div>\n\t</main>\n\n\t<!-- No Reports -->\n\t<div class="sub-page-template-a-section" ng-if="vm.reports.length === 0">\n\t\t<placeholder placeholder-graphic="generic-files">\n\t\t\t<placeholder-title>No reports available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>No reports are available as they haven\u2019t been assigned to or added for {{currentCompany.Name}} yet.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ui-sref="settings.company.reports.custom({agencyProfileId: currentCompany.AgencyProfileID })" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports" class="link-with-icon primary">Go to report templates<i class="icon-chevron-right n"></i></a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-employees-only-paycircle/rotaready-employees-only-paycircle.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button class="is-tertiary" data-cy="rotaready-connection-paycircle-only-send-to-rotaready" ng-click="onSendToRotaready()" type="button">\n\t\t\t\t\tSend to Rotaready\n\t\t\t\t</button>\n\t\t\t\t<button data-cy="rotaready-connection-paycircle-only-cancel" ng-click="cancel()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<div class="rotaready-connection fadeIn">\n\t\t<div class="rotaready-connection_wrapper">\n\t\t\t<!-- Section header -->\n\t\t\t<div class="rotaready-connection_section-header">\n\t\t\t\t<div class="rotaready-connection_section-header_title">\n\t\t\t\t\t<i class="icon-team-alt m is-primary"></i>\n\t\t\t\t\t<h3>Employees only in Paycircle\n\t\t\t\t\t\t<span class="tag l tertiary inverse">\n\t\t\t\t\t\t\t{{teamMembersUnmatchedPaycircle.length}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t\t<p class="rotaready-connection_section-header_description">Select the employees you wish to create in Rotaready and click \'Send to Rotaready\'. Leave anyone you\'d like to exclude from the integration or wish to send later.</p>\n\t\t\t</div>\n\t\t\t<!-- Employees section -->\n\t\t\t<div class="rotaready-connection_section team-card-basic_wrapper">\n\t\t\t\t<div class="checkbox-list-header">\n\t\t\t\t\t<h6 class="checkbox-list-header_title">{{createInRotaready.length}} selected</h6>\n\t\t\t\t\t<div class="inline-links">\n\t\t\t\t\t\t<a data-cy="rotaready-connection-paycircle-only-select-all" href ng-click="toggleAllTeamMembers(true)">\n\t\t\t\t\t\t\tSelect all\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="rotaready-connection-paycircle-only-unselect-all" href ng-click="toggleAllTeamMembers(false)">\n\t\t\t\t\t\t\tUnselect all\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="checkbox-rows-list">\n\t\t\t\t\t<div class="checkbox-row" dir-paginate="(teamMemberIndex, teamMember) in teamMembersUnmatchedPaycircle | itemsPerPage: 10">\n\t\t\t\t\t\t<label class="checkbox-row_label" for="{{teamMember.Paycircle.Id}}">\n\t\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" data-cy="rotaready-connection-paycircle-only-checkbox-{{teamMemberIndex}}" id="{{teamMember.Paycircle.Id}}" name="{{teamMember.Paycircle.Id}}" ng-change="updateSelectedTeamMembers()" ng-model="teamMember.Paycircle.isSelected" type="checkbox">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Paycircle.Forename[0]}}" avatar-size="is-small" class="checkbox-row_avatar"></avatar>\n\t\t\t\t\t\t\t<span class="checkbox-row_context">\n\t\t\t\t\t\t\t\t<name class="strong" forename="{{teamMember.Paycircle.Forename}}" surname="{{teamMember.Paycircle.Surname}}"></name>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\t\t\tNI Number:\n\t\t\t\t\t\t\t\t\t<span class="is-small is-greyscale" data-cy="rotaready-connection-paycircle-only-ni-number-{{teamMemberIndex}}" ng-if="teamMember.Paycircle.Nino">\n\t\t\t\t\t\t\t\t\t\t{{::teamMember.Paycircle.Nino}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span class="is-small is-greyscale italic" data-cy="rotaready-connection-paycircle-only-ni-number-unknown-{{teamMemberIndex}}" ng-if="!teamMember.Paycircle.Nino">\n\t\t\t\t\t                    {{$root.config.defaultEmptyText}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t| DOB:\n\t\t\t\t\t\t\t\t\t<span class="is-small is-greyscale" data-cy="rotaready-connection-paycircle-only-dob-{{teamMemberIndex}}">\n\t\t\t\t\t\t\t\t\t\t{{::teamMember.Paycircle.DateOfBirthIso | dateformat}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7">\n\t\t\t\t</dir-pagination-controls>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n</div>');
$templateCache.put('features/app/rotaready-connection/rotaready-entity-matched/rotaready-entity-matched.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button data-cy="rotaready-connection-cancel-entity-matches" ng-click="cancel()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Page content -->\n\t<div class="rotaready-connection-match-now">\n\t\t<div class="rotaready-connection-match-now_wrapper">\n\t\t\t<!-- Section header -->\n\t\t\t<div class="rotaready-connection-match-now_header">\n\t\t\t\t<div class="rotaready-connection-match-now_header_title">\n\t\t\t\t\t<h3 data-cy="rotaready-connection-mapped-entities">Mapped sites/departments\n\t\t\t\t\t\t<span class="tag l primary inverse">\n\t\t\t\t\t\t\t{{entitiesMapped.all.length}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t\t<p class="rotaready-connection-match-now_header_description">This page shows sites/departments that have been successfully matched between Rotaready and Paycircle. You can unmap a site/department if needed by clicking the &lsquo;Unmap&rsquo; button.</p>\n\t\t\t</div>\n\n\t\t\t<search-bar bulk-items="entitiesMapped" options="searchBarOptions"></search-bar>\n\n\t\t\t<div class="rotaready-connection-match-now_column-headers" ng-if="entitiesMapped.all.length > 0">\t\n\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t<h6>From Rotaready</h6>\n\t\t\t\t</div>\t\n\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t<h6>In Paycircle</h6>\n\t\t\t\t</div>\t\n\t\t\t</div>\t\n\n\t\t\t<div class="rotaready-employee-cards" current-page="searchBarOptions.currentPageNumber" dir-paginate="entity in entitiesMapped.filtered = (\n\t\t\t\t\t\tentitiesMapped.all |\n\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t) |\n\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t">\n\t\t\t\t<!-- Entity card (From Rotaready) -->\n\t\t\t\t<div class="rotaready-employee-card">\n\t\t\t\t\t<div class="rotaready-employee-card_wrapper">\n\t\t\t\t\t\t<h6 data-cy="rotaready-entity-matched-name-{{$index}}">{{entity.EntityName}}</h6>\n\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-matched-start-date-{{$index}}" ng-if="entity.PayrollCalendarStartDateISO">Start Date: {{entity.PayrollCalendarStartDateISO | dateformat}}</p>\n\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-matched-group-{{$index}}" ng-if="entity.EntityGroupName">Group: {{entity.EntityGroupName}}</p>\n\t\t\t\t\t\t<div ng-if="entity.MissingInSourceUTC">\n\t\t\t\t\t\t\t<span class="tag is-indifferent" data-cy="rotaready-entity-matched-missing-{{$index}}">No longer in Rotaready</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t\t\t<!-- Mapped business category card (To Paycircle) -->\n\t\t\t\t<div class="rotaready-team-member-search-card">\n\t\t\t\t\t<p class="is-small is-greyscale">Is matched to:</p>\n\t\t\t\t\t<div class="rotaready-team-card-basic rotaready-team-card-basic_fill">\n\t\t\t\t\t\t<div class="rotaready-team-card-basic_main">\n\t\t\t\t\t\t\t<avatar avatar-initial="{{entity.businessCodeNarrative[0]}}" avatar-size="is-small" avatar-theme="is-primary"></avatar>\n\t\t\t\t\t\t\t<div class="rotaready-employee-card_inf">\n\t\t\t\t\t\t\t\t<h6 data-cy="rotaready-entity-pending-code-{{$index}}">{{entity.businessCodeNarrative}}</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" ng-if="entity.businessCategoryTypeDescription">{{entity.businessCategoryTypeDescription}}</p>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-pending-nominal-code-{{$index}}" ng-if="entity.businessCodeValue">Journal Code: {{entity.businessCodeValue}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="rotaready-team-card-basic_action">\n\t\t\t\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-entity-unmap-{{$index}}" ng-click="unmapEntity(entity)" type="button">\n\t\t\t\t\t\t\t\tUnmap\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-if="entitiesMapped.all.length > 0" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t\t\t<!-- No mapped entities placeholder -->\n\t\t\t<placeholder ng-if="entitiesMapped.all.length === 0" placeholder-graphic="no-companies" placeholder-graphic-size="l">\n\t\t\t\t<placeholder-title>No Mapped Sites/Departments Found</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>Once Rotaready sites/departments are mapped to business categories in Paycircle, they will appear here.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t<a class="s strong is-primary" data-cy="rotaready-entity-matched-go-to-map-now" href="" ng-click="goToMapNow()">Map sites/departments now&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t\t\t</placeholder-primary-actions>\n\t\t\t</placeholder>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-if="entitiesMapped.filtered.length === 0 && entitiesMapped.all.length > 0" search-bar-options="searchBarOptions">\n\t\t\t</empty-search>\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-match-now/rotaready-match-now.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button class="is-tertiary" data-cy="rotaready-connection-save-matches" ng-click="onSaveMappings()" ng-disabled="teamMemberMappingsUpdated.length === 0" type="button">\n\t\t\t\t\tSave matches\n\t\t\t\t</button>\n\t\t\t\t<button data-cy="rotaready-connection-cancel-matches" ng-click="cancel()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Page content -->\n\t<div class="rotaready-connection-match-now">\n\t\t<div class="rotaready-connection-match-now_wrapper">\n\t\t\t<!-- Section header -->\n\t\t\t<div class="rotaready-connection-match-now_header">\n\t\t\t\t<div class="rotaready-connection-match-now_header_title">\n\t\t\t\t\t<h3 data-cy="rotaready-connection-unmatched-employees">Unmatched employees\n\t\t\t\t\t\t<span class="tag l tertiary inverse">\n\t\t\t\t\t\t\t{{teamMembersUnmatchedRotaready.length}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t\t<p class="rotaready-connection-match-now_header_description">Choose a Paycircle employee and click \'Match\' to move them to \'Pending\'. Pending employees won\'t be matched until you click \'Save matches\'. Possible matches are shown where at least 3 pieces of data match the incoming employee.</p>\n\t\t\t</div>\n\n\t\t\t<section class="rotaready-connection-match-now_navigation">\n\t\t\t\t<navigation-tabs>\n\t\t\t\t\t<a data-cy="tab-bar-settings-rotaready-available-to-match" href="" ng-class="{\'active\': activeTab === TABS.AVAILABLE}" ng-click="setActiveTab(TABS.AVAILABLE)">\n\t\t\t\t\t\tAvailable to match <span class="tag primary" ng-class="{\'inverse\': activeTab === TABS.AVAILABLE}">{{teamMembersUnmatchedRotaready.length}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="tab-bar-settings-rotaready-pending" href="" ng-class="{\'active\': activeTab === TABS.PENDING}" ng-click="setActiveTab(TABS.PENDING)">\n\t\t\t\t\t\tPending <span class="tag primary" ng-class="{\'inverse\': activeTab === TABS.PENDING}">{{teamMemberMappingsUpdated.length}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</navigation-tabs>\n\t\t\t</section>\n\t\t\t<div class="rotaready-connection_section" ng-if="activeTab === TABS.AVAILABLE">\n\t\t\t\t<rotaready-match-employees is-pending-tab="false" is-payroll-locked="isPayrollLocked" rotaready-team-members="teamMembersUnmatchedRotaready" paycircle-team-members="teamMembersUnmatchedPaycircle" bulk-items="teamMembersUnmatchedRotareadyBulkItems" update-team-member-state="updateTeamMemberState(teamMember, action)">\n\t\t\t</div>\n\t\t\t<div class="rotaready-connection_section" ng-if="activeTab === TABS.PENDING">\n\t\t\t\t<rotaready-match-employees is-pending-tab="true" team-members-mapped="teamMemberMappingsUpdated" bulk-items="teamMemberMappingsUpdatedBulkItems" create-in-paycircle="createInPaycircle" update-team-member-state="updateTeamMemberState(teamMember, action)">\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-entity-match-now/rotaready-entity-match-now.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button class="is-tertiary" data-cy="rotaready-connection-save-entity-mappings" ng-click="onSaveMappings()" ng-disabled="entityMappingsPending.length === 0" type="button">\n\t\t\t\t\tSave mappings\n\t\t\t\t</button>\n\t\t\t\t<button data-cy="rotaready-connection-cancel-entity-mapping" ng-click="cancel()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Page content -->\n\t<div class="rotaready-connection-match-now">\n\t\t<div class="rotaready-connection-match-now_wrapper">\n\t\t\t<!-- No business categories configured -->\n\t\t\t<message-block data-cy="rotaready-entity-no-business-codes-message" icon="warning" ng-if="businessCodes.length === 0" theme="is-tertiary">\n\t\t\t\t<p>Business categories have not been configured. You can create these via business category settings or by using the create options here.</p>\n\t\t\t</message-block>\n\n\t\t\t<!-- Section header -->\n\t\t\t<div class="rotaready-connection-match-now_header">\n\t\t\t\t<div class="rotaready-connection-match-now_header_title">\n\t\t\t\t\t<h3 data-cy="rotaready-connection-unmapped-entities">Unmapped sites/departments\n\t\t\t\t\t\t<span class="tag l tertiary inverse">\n\t\t\t\t\t\t\t{{entitiesUnmapped.all.length}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t\t<p class="rotaready-connection-match-now_header_description">Select a Paycircle business category and click \'Match\' to move them to &lsquo;Pending&rsquo;. Pending business categories won\'t be matched until you click &lsquo;Save mappings&rsquo;.</p>\n\t\t\t</div>\n\n\t\t\t<section class="rotaready-connection-match-now_navigation">\n\t\t\t\t<navigation-tabs>\n\t\t\t\t\t<a data-cy="tab-bar-entity-available" href="" ng-class="{\'active\': activeTab === TABS.AVAILABLE}" ng-click="setActiveTab(TABS.AVAILABLE)">\n\t\t\t\t\t\tAvailable to map <span class="tag primary" ng-class="{\'inverse\': activeTab === TABS.AVAILABLE}">{{entitiesUnmapped.all.length}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="tab-bar-entity-pending" href="" ng-class="{\'active\': activeTab === TABS.PENDING}" ng-click="setActiveTab(TABS.PENDING)">\n\t\t\t\t\t\tPending <span class="tag primary" ng-class="{\'inverse\': activeTab === TABS.PENDING}">{{entityMappingsPending.length}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</navigation-tabs>\n\t\t\t</section>\n\n\t\t\t<div class="rotaready-match-employees">\n\n\t\t\t\t<search-bar bulk-items="entitiesUnmapped" options="searchBarOptions"></search-bar>\n\n\t\t\t\t<div class="rotaready-match-employees_header" ng-if="activeTab === TABS.AVAILABLE && entitiesUnmapped.all.length > 0 || activeTab === TABS.PENDING && entityMappingsPending.length > 0">\n\t\t\t\t\t<div class="rotaready-match-employees_header-title" ng-class="{\'available-match\': activeTab === TABS.AVAILABLE, \'pending-match\': activeTab === TABS.PENDING}">\n\t\t\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t\t\t<h6>From Rotaready</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t\t\t<h6>In Paycircle</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<button class="rotaready-match-employees_header-button is-primary" data-cy="rotaready-entity-create-all-business-codes" ng-click="createAllBusinessCodes()" ng-if="!readOnlyFramework && activeTab === TABS.AVAILABLE && entitiesUnmapped.all.length > 0" type="button">\n\t\t\t\t\t\tCreate all as new\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class="rotaready-match-employees_header-button is-primary" data-cy="rotaready-entity-undo-all" ng-click="unmapAllPendingEntities()" ng-if="activeTab === TABS.PENDING && entityMappingsPending.length > 0" type="button">\n\t\t\t\t\t\tUndo all\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Available tab -->\n\t\t\t\t<div class="rotaready-connection_section" ng-if="activeTab === TABS.AVAILABLE">\n\t\t\t\t\t<div class="rotaready-employee-cards" current-page="searchBarOptions.currentPageNumber" dir-paginate="entity in entitiesUnmapped.filtered = (\n\t\t\t\t\t\t\t\tentitiesUnmapped.all |\n\t\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\t">\n\t\t\t\t\t\t<!-- Entity card (From Rotaready) -->\n\t\t\t\t\t\t<div class="rotaready-employee-card">\n\t\t\t\t\t\t\t<div class="rotaready-employee-card_wrapper">\n\t\t\t\t\t\t\t\t<h6 data-cy="rotaready-entity-unmapped-name-{{$index}}">{{entity.EntityName}}</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-unmapped-start-date-{{$index}}" ng-if="entity.PayrollCalendarStartDateISO">Start Date: {{entity.PayrollCalendarStartDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-unmapped-group-{{$index}}" ng-if="entity.EntityGroupName">Group: {{entity.EntityGroupName}}</p>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<span class="tag is-assertive">Unmapped</span>\n\t\t\t\t\t\t\t\t\t<span class="tag is-indifferent" data-cy="rotaready-entity-unmapped-missing-{{$index}}" ng-if="entity.MissingInSourceUTC">No longer in Rotaready</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t\t\t\t\t<!-- Business category selection card (To Paycircle) -->\n\t\t\t\t\t\t<div class="rotaready-team-member-search-card">\n\t\t\t\t\t\t\t<search-select data-cy="rotaready-entity-mapping-select-{{$index}}" id="entityMapping-{{$index}}" is-disabled="entity.selectedBusinessCode" item-name="code" items="businessCodesFiltered" search-property="BusinessCodeNarrative" value-property="BusinessCodeID" label-singular="business category" label-plural="business categories" name="entityMapping-{{$index}}" ng-model="entity.selectedBusinessCodeID" on-select="mapEntitySelect(entity)">\n\t\t\t\t\t\t\t\t<item-template ng-non-bindable>\n\t\t\t\t\t\t\t\t\t<div class="search-select-result_item-with-icon">\n\t\t\t\t\t\t\t\t\t\t<span class="search-select-result_avatar">\n\t\t\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{code.BusinessCodeNarrative[0]}}" avatar-size="is-small" avatar-theme="is-primary"></avatar>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<div class="search-select-result_detail">\n\t\t\t\t\t\t\t\t\t\t\t<h3 class="search-select-result_title">{{code.BusinessCodeNarrative}} <span ng-if="code.isNewBusinessCode" class="tag is-inverse is-tertiary">NEW</span></h3>\n\t\t\t\t\t\t\t\t\t\t\t<h4 class="search-select-result_subtitle">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>{{code.businessCategoryTypeDescription}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="code.BusinessCodeValue"> | Journal Code: {{code.BusinessCodeValue}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<span class="search-select-result_action">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</item-template>\n\t\t\t\t\t\t\t</search-select>\n\t\t\t\t\t\t\t<div class="rotaready-team-member-search-card_search-footer" ng-if="!entity.selectedBusinessCode">\n\t\t\t\t\t\t\t\t<div class="rotaready-team-member-search-card_search-footer_left-content" ng-if="entity.possibleMatchesFiltered.length > 0">\n\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-possible-match-text-{{$index}}">Possible match:</p>\n\t\t\t\t\t\t\t\t\t<ul class="rotaready-entity-match-now_possible-matches_list">\n\t\t\t\t\t\t\t\t\t\t<li ng-repeat="match in entity.possibleMatchesFiltered">\n\t\t\t\t\t\t\t\t\t\t\t<a class="is-small is-inline" data-cy="rotaready-entity-possible-match-name-{{$parent.$index}}-{{$index}}" href="" ng-click="mapEntityFromSuggestion(entity, match)">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-add is-primary s"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="strong">{{match.BusinessCodeNarrative}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="is-font-greyscale-300">({{match.businessCategoryTypeDescription}})</span>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="rotaready-team-member-search-card_search-footer_right-content is-white is-primary" data-cy="rotaready-entity-create-business-code-{{$index}}" ng-click="createBusinessCode(entity)" ng-if="!readOnlyFramework" type="button">\n\t\t\t\t\t\t\t\t\tCreate as new\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="rotaready-team-card-basic rotaready-team-card-basic_fill" ng-if="entity.selectedBusinessCode">\n\t\t\t\t\t\t\t\t<div class="rotaready-team-card-basic_main">\n\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{entity.selectedBusinessCode.BusinessCodeNarrative[0]}}" avatar-size="is-small" avatar-theme="is-primary"></avatar>\n\t\t\t\t\t\t\t\t\t<div class="rotaready-employee-card_inf">\n\t\t\t\t\t\t\t\t\t\t<h6 data-cy="rotaready-entity-pending-code-{{$index}}">{{entity.selectedBusinessCode.BusinessCodeNarrative}} <span ng-if="entity.selectedBusinessCode.isNewBusinessCode" class="tag is-inverse is-tertiary">NEW</span></h6>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" ng-if="entity.selectedBusinessCode.businessCategoryTypeDescription">{{entity.selectedBusinessCode.businessCategoryTypeDescription}}</p>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-pending-nominal-code-{{$index}}" ng-if="entity.selectedBusinessCode.BusinessCodeValue">Journal Code: {{entity.selectedBusinessCode.BusinessCodeValue}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="rotaready-team-card-basic_action">\n\t\t\t\t\t\t\t\t\t<button class="is-white primary" data-cy="rotaready-entity-business-code-match-{{$index}}" ng-click="mapEntity(entity)" type="button">\n\t\t\t\t\t\t\t\t\t\tMatch\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t<button class="is-white primary" data-cy="rotaready-entity-business-code-clear-{{$index}}" ng-click="mapEntityDeselect(entity)" type="button">\n\t\t\t\t\t\t\t\t\t\tClear\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Pagination -->\n\t\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-if="entitiesUnmapped.all.length > 0" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t\t\t\t\t<!-- No unmapped entities placeholder -->\n\t\t\t\t\t<placeholder ng-if="entitiesUnmapped.all.length === 0" placeholder-graphic="no-companies" placeholder-graphic-size="l">\n\t\t\t\t\t\t<placeholder-title>No Unmapped Sites/Departments Found</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>All Rotaready sites/departments have been mapped to business categories in Paycircle.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t\t<a class="s strong is-primary" data-cy="rotaready-entity-match-now-go-to-mapped" href="" ng-click="goToEntityMatched()">Review mappings&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t</placeholder>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search ng-if="entitiesUnmapped.filtered.length === 0 && entitiesUnmapped.all.length > 0" search-bar-options="searchBarOptions">\n\t\t\t\t\t</empty-search>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pending tab -->\n\t\t\t\t<div class="rotaready-connection_section" ng-if="activeTab === TABS.PENDING">\n\t\t\t\t\t<div class="rotaready-employee-cards" ng-repeat="entity in entityMappingsPending | orderBy: \'EntityName\'">\n\t\t\t\t\t\t<!-- Entity card (From Rotaready) -->\n\t\t\t\t\t\t<div class="rotaready-employee-card is-active">\n\t\t\t\t\t\t\t<div class="rotaready-employee-card_wrapper">\n\t\t\t\t\t\t\t\t<h6 data-cy="rotaready-entity-pending-name-{{$index}}">{{entity.EntityName}}</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-pending-start-date-{{$index}}" ng-if="entity.PayrollCalendarStartDateISO">Start Date: {{entity.PayrollCalendarStartDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-pending-group-{{$index}}" ng-if="entity.EntityGroupName">Group: {{entity.EntityGroupName}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t\t\t\t\t<!-- Pending matched business categorycategorycategorycategorycategorycategorycategorycategorycategorycategorycategorycategory card (To Paycircle) -->\n\t\t\t\t\t\t<div class="rotaready-team-member-search-card">\n\t\t\t\t\t\t\t<p class="is-small is-greyscale">Will be matched:</p>\n\t\t\t\t\t\t\t<div class="rotaready-team-card-basic rotaready-team-card-basic_fill">\n\t\t\t\t\t\t\t\t<div class="rotaready-team-card-basic_main">\n\t\t\t\t\t\t\t\t\t<avatar avatar-initial="{{entity.businessCodeNarrative[0]}}" avatar-size="is-small" avatar-theme="is-primary"></avatar>\n\t\t\t\t\t\t\t\t\t<div class="rotaready-employee-card_inf">\n\t\t\t\t\t\t\t\t\t\t<h6 data-cy="rotaready-entity-pending-code-{{$index}}">{{entity.businessCodeNarrative}} <span ng-if="entity.isNewBusinessCode" class="tag is-inverse is-tertiary">NEW</span></h6>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" ng-if="entity.businessCategoryTypeDescription">{{entity.businessCategoryTypeDescription}}</p>\n\t\t\t\t\t\t\t\t\t\t<p class="is-small is-greyscale-300" data-cy="rotaready-entity-pending-nominal-code-{{$index}}" ng-if="entity.businessCodeValue">Journal Code: {{entity.businessCodeValue}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="rotaready-team-card-basic_action">\n\t\t\t\t\t\t\t\t\t<button class="is-white is-primary" data-cy="rotaready-entity-undo-match-{{$index}}" ng-click="unmapPendingEntity(entity)" type="button">\n\t\t\t\t\t\t\t\t\t\tUndo\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No pending entities placeholder -->\n\t\t\t\t\t<placeholder ng-if="entityMappingsPending.length === 0" placeholder-graphic="no-companies" placeholder-graphic-size="l">\n\t\t\t\t\t\t<placeholder-title>No pending changes yet</placeholder-title>\n\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t<p>Pending site/department mappings will appear here.</p>\n\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t</placeholder>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-summary/rotaready-summary.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<a class="is-tertiary link-with-icon action-bar_action" href="" ng-click="goBack()" type="button">\n\t\t\t\t\t<i class="icon-cross is-medium has-margin-right"></i>Close\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Page content -->\n\t<div class="rotaready-connection fadeIn">\n\t\t<div class="rotaready-connection_wrapper">\n\t\t\t<!-- Logo -->\n\t\t\t<div class="rotaready-connection_logo">\n\t\t\t\t<img alt="Rotaready" ng-src="images/logo/integrations/access-rotaready.2x.png">\n\t\t\t\t<hr class="m">\n\t\t\t</div>\n\t\t\t\t<!-- Mapping row: Employees and Entity Mapping side by side -->\n\t\t\t<div class="rotaready-connection_mapping-row">\n\n\t\t\t\t<!-- Employees column -->\n\t\t\t\t<div class="rotaready-connection_mapping-column">\n\t\t\t\t\t<!-- Section header -->\n\t\t\t\t\t<div class="rotaready-connection_section-header">\n\t\t\t\t\t\t<div class="rotaready-connection_section-header_title">\n\t\t\t\t\t\t\t<i class="icon-team-alt m is-primary"></i>\n\t\t\t\t\t\t\t<h3>Employees</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="rotaready-connection_employee-count">\n\t\t\t\t\t\t\t<span class="tag tertiary inverse" data-cy="rotaready-teammembers-received-from-rotaready">\n\t\t\t\t\t\t\t\t{{teamMembersReceivedFromRotaready}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p> <ng-pluralize count="teamMembersReceivedFromRotaready" when="{\'1\': \'Employee\', \'other\': \'Employees\'}"></ng-pluralize> received from Rotaready</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="rotaready-connection_section-header_description">Please note that it\'s optional to fix any errors you may have below. You can return here at any time to review and update your data.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Employees section -->\n\t\t\t\t\t<div class="rotaready-connection_inline-section">\n\t\t\t\t\t\t<!--Unmatched employees card-->\n\t\t\t\t\t\t<stat-card-actions is-positive="false" card-title="unmatchedRotareadyStatTitle" card-description="unmatchedRotareadyStatDescription" cytext="\'rotaready-stat-card-unmatched-employees\'" actions="[{\n\t\t\t\t\t\t\t\tlabel: \'Match now\',\n\t\t\t\t\t\t\t\tonClick: goToMatchNow,\n\t\t\t\t\t\t\t\tisPrimary: true,\n\t\t\t\t\t\t\t\tisDisabled: teamMembersUnmatchedRotaready.length === 0\n\t\t\t\t\t\t\t}]">\n\t\t\t\t\t\t</stat-card-actions>\n\t\t\t\t\t\t<!--Matched employees card-->\n\t\t\t\t\t\t<stat-card-actions is-positive="true" card-title="matchedStatTitle" card-description="matchedStatDescription" cytext="\'rotaready-stat-card-matched-employees\'" actions="[{\n\t\t\t\t\t\t\t\tlabel: \'Review matches\',\n\t\t\t\t\t\t\t\tonClick: goToMatched,\n\t\t\t\t\t\t\t\tisPrimary: false,\n\t\t\t\t\t\t\t\tisDisabled: teamMembersMatched.length === 0\n\t\t\t\t\t\t\t}]">\n\t\t\t\t\t\t</stat-card-actions>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="rotaready-connection_section" ng-if="false">\n\t\t\t\t\t\t<!--Only in Paycircle card (hidden/not implemented for integration V1)-->\n\t\t\t\t\t\t<stat-card-actions is-positive="false" is-inline="true" card-title="unmatchedPaycircleStatTitle" card-description="unmatchedPaycircleStatDescription" cytext="\'rotaready-stat-card-paycircle-only-employees\'" actions="[{\n\t\t\t\t\t\t\t\tlabel: \'Choose\',\n\t\t\t\t\t\t\t\tonClick: goToOnlyPaycircle,\n\t\t\t\t\t\t\t\tisPrimary: true,\n\t\t\t\t\t\t\t\tisDisabled: teamMembersUnmatchedPaycircle.length === 0\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\tlabel: \'Send all\',\n\t\t\t\t\t\t\t\t\tisPrimary: false,\n\t\t\t\t\t\t\t\t\tisDisabled: teamMembersUnmatchedPaycircle.length === 0\n\t\t\t\t\t\t\t\t}]">\n\t\t\t\t\t\t</stat-card-actions>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Entity Mapping column -->\n\t\t\t\t<div class="rotaready-connection_mapping-column">\n\t\t\t\t\t<div class="rotaready-connection_section-header">\n\t\t\t\t\t\t<div class="rotaready-connection_section-header_title">\n\t\t\t\t\t\t\t<i class="icon-group m is-primary"></i>\n\t\t\t\t\t\t\t<h3>Site/Department Mapping</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="rotaready-connection_employee-count">\n\t\t\t\t\t\t\t<span class="tag tertiary inverse" data-cy="rotaready-entities-linked-from-rotaready">\n\t\t\t\t\t\t\t\t{{entitiesLinkedFromRotaready}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<p> <ng-pluralize count="entitiesLinkedFromRotaready" when="{\'1\': \'Site/Department\', \'other\': \'Sites/Departments\'}"></ng-pluralize> linked from Rotaready</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="rotaready-connection_section-header_description">Rotaready sites/departments need to be mapped to business categories in Paycircle. You can return here at any time to review and update your data.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="rotaready-connection_inline-section">\n\t\t\t\t\t\t<!--Unmapped entities card-->\n\t\t\t\t\t\t<stat-card-actions is-positive="false" card-title="unmappedEntityStatTitle" card-description="unmappedEntityStatDescription" cytext="\'rotaready-stat-card-unmapped-entities\'" actions="[{\n\t\t\t\t\t\t\t\tlabel: \'Map now\',\n\t\t\t\t\t\t\t\tonClick: goToEntityMatchNow,\n\t\t\t\t\t\t\t\tisPrimary: true,\n\t\t\t\t\t\t\t\tisDisabled: entityMappingUnmatched === 0\n\t\t\t\t\t\t\t}]">\n\t\t\t\t\t\t</stat-card-actions>\n\t\t\t\t\t\t<!--Mapped entities card-->\n\t\t\t\t\t\t<stat-card-actions is-positive="true" card-title="mappedEntityStatTitle" card-description="mappedEntityStatDescription" cytext="\'rotaready-stat-card-mapped-entities\'" actions="[{\n\t\t\t\t\t\t\t\tlabel: \'Review mappings\',\n\t\t\t\t\t\t\t\tonClick: goToEntityMatched,\n\t\t\t\t\t\t\t\tisPrimary: false,\n\t\t\t\t\t\t\t\tisDisabled: entityMappingMatched === 0\n\t\t\t\t\t\t\t}]">\n\t\t\t\t\t\t</stat-card-actions>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Pay elements section (below, centered) -->\n\t\t\t<div class="rotaready-connection_pay-elements-section">\n\t\t\t\t<div class="rotaready-connection_section-header">\n\t\t\t\t\t<div class="rotaready-connection_section-header_title">\n\t\t\t\t\t\t<i class="icon-adjustment m is-primary"></i>\n\t\t\t\t\t\t<h3>Pay elements</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="rotaready-connection_section-header_description" ng-if="unmatchedPayElements.length > 0">\n\t\t\t\t\t\tPlease note that it\'s optional to fix any errors you may have below. You can return here at any time to review and update your data.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="rotaready-connection_section-header_description" ng-if="unmatchedPayElements.length === 0">\n\t\t\t\t\t\tAll pay elements in Rotaready have a matching pay element in Paycircle. You can return here at any time to review your data.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="rotaready-connection_section" ng-if="unmatchedPayElements.length > 0">\n\t\t\t\t\t<bullet-list bl-items="unmatchedPayElements" bl-theme="is-small is-primary is-bold"></bullet-list>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="rotaready-connection_footer" ng-if="unmatchedPayElements.length > 0">\n\t\t\t\t\t<p>These will need creating in the \'Pay elements\' area in your company settings. You can then return here to review your refreshed matching results.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/rotaready-connection/rotaready-matched/rotaready-matched.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Action bar -->\n\t<action-bar class="dropIn" subtitle="Rotaready Data Sync">\n\t\t<action-bar-right>\n\t\t\t<div class="action-bar_actions">\n\t\t\t\t<button data-cy="rotaready-connection-cancel-matches" ng-click="cancel()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</action-bar-right>\n\t</action-bar>\n\n\t<!-- Page content -->\n\t<div class="rotaready-connection-match-now">\n\t\t<div class="rotaready-connection-match-now_wrapper">\n\t\t\t<!-- Section header -->\n\t\t\t<div class="rotaready-connection-match-now_header">\n\t\t\t\t<div class="rotaready-connection-match-now_header_title">\n\t\t\t\t\t<h3 data-cy="rotaready-connection-unmatched-employees">Matched employees\n\t\t\t\t\t\t<span class="tag l primary inverse">\n\t\t\t\t\t\t\t{{teamMembersMatched.all.length}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t\t<p class="rotaready-connection-match-now_header_description">This page shows employees that have been successfully matched between Rotaready and Paycircle. You can unmatch an employee if needed by clicking the \'Unmatch\' button. Matched employees will have their data synchronized between both systems.</p>\n\t\t\t</div>\n\n\t\t\t<div class="rotaready-connection-match-now_column-headers" ng-if="teamMembersMatched.all.length > 0">\n\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t<h6>From Rotaready</h6>\n\t\t\t\t</div>\n\t\t\t\t<div class="rotaready-connection-match-now_column-header">\n\t\t\t\t\t<h6>In Paycircle</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<search-bar bulk-items="teamMembersMatched" options="searchBarOptions"></search-bar>\n\n\t\t\t<div class="rotaready-employee-cards" current-page="searchBarOptions.currentPageNumber" dir-paginate="(index, teamMember) in teamMembersMatched.filtered = (\n\t\t\t\t\t\tteamMembersMatched.all |\n\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t) |\n\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t">\n\t\t\t\t<!-- Employee Card -->\n\t\t\t\t<rotaready-employees-card employee="teamMember.Rotaready"></rotaready-employees-card>\n\n\t\t\t\t<i class="icon-chevron-right rotaready-match-employees_chevron"></i>\n\n\t\t\t\t<!-- Matched card -->\n\t\t\t\t<rotaready-team-member-matched-card index="index" is-matched-view="true" on-unmatch-click="unmatchTeamMembers(teamMember)" team-member="teamMember">\n\t\t\t\t</rotaready-team-member-matched-card>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-if="teamMembersMatched.all.length > 0" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t\t\t<!-- No matched employees placeholder -->\n\t\t\t<placeholder placeholder-graphic="no-job-grades" placeholder-graphic-size="l" ng-if="teamMembersMatched.all.length === 0">\n\t\t\t\t<placeholder-title>No Matched Employees Found</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>Once employees from Rotaready are matched to employees in Paycircle, they will appear here.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t<a href="" ng-click="goTo()" class="s strong is-primary">Match employees now&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t\t\t</placeholder-primary-actions>\n\t\t\t</placeholder>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-if="teamMembersMatched.filtered.length === 0 && teamMembersMatched.all.length > 0" search-bar-options="searchBarOptions">\n\t\t\t</empty-search>\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/access/settings-access.view.html','<div class="page-template-a fadeIn">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="padlock" page-title="Access"></page-template-a-header>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<tab-bar tab-bar-def="settingsAccessTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/settings/admins/settings-admins.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Team members -->\n\t<div class="page-template-a-wrapper" ng-if="vm.admins.all.length">\n\n\t\t<page-template-a-header icon="admins" page-title="Admins">\n\t\t\t<pt-secondary>\n\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t<div class="spaced-links__item" ng-switch="vm.permissionReportDownloadState">\n\t\t\t\t\t\t<a ng-switch-default href="" ng-click="downloadPermissionsReport(vm)" class="link-with-icon primary fadeIn">\n\t\t\t\t\t\t\t<i class="icon-download"></i>&nbsp;Permissions report\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<circle-loader ng-switch-when="loading" class="fadeIn" size="s"></circle-loader>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t<a href="" ng-click="openNewAdminForm(vm)" class="button primary">\n\t\t\t\t\t\t\t<i class="icon-plus"></i>&nbsp;New admin\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Team -->\n\t\t<main>\n\n\t\t\t<!-- Filter -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="vm.admins"></search-bar>\n\n\t\t\t<!-- Team Cards -->\n\t\t\t<section class="admin-cards rows">\n\t\t\t\t<admin-card admin="admin" agency-profile-id="vm.agencyProfileId" callback="refreshAdmins" can-add-to-team="$root.currentCompany.isPayrollCompany" can-edit-admin="vm.canEditAdmin" can-manage-mentions-access="$root.currentCompany.CompanyType === INTERFACE_TYPES.bureau" dir-paginate="admin in vm.admins.filtered = ( vm.admins.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber" sso-enabled="vm.ssoEnabled"></admin-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.admins.filtered.length === 0"></empty-search>\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder placeholder-graphic="no-admins" ng-if="!vm.admins.all.length">\n\t\t<placeholder-title>You don\'t have any admins set up yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As admins are added they will appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" class="button primary" ng-click="openNewAdminForm(vm)"><i class="icon-plus"></i>&nbsp;New admin</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/average-holiday-pay/settings-average-holiday-pay.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\t\t<page-template-a-header icon="csv" page-title="Average Holiday Pay">\n\t\t\t<pt-sub-heading>\n\t\t\t\t<p class="is-small" data-cy="average-holiday-pay-description">\n\t\t\t\t\tConfigure which pay elements are included in the 52-week average holiday pay calculation.\n\t\t\t\t</p>\n\t\t\t</pt-sub-heading>\n\t\t</page-template-a-header>\n\n\t\t<main class="page-template-a-main" ng-if="vm.payElements.all.length > 0">\n\n\t\t\t<!-- Filters -->\n\t\t\t<filter-bar data-cy="average-holiday-pay-filter-bar" filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar bulk-items="vm.payElements" data-cy="average-holiday-pay-search-bar" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a data-cy="average-holiday-pay-manage-options" href="" ng-class="{ \'is-disabled\': !vm.payElements.totalSelected }" ng-click="vm.payElements.totalSelected && manageOptions()">\n\t\t\t\t\t\tManage options\n\t\t\t\t\t</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t</search-bar>\n\n\t\t\t<!-- Pay Elements List -->\n\t\t\t<section class="page-template-a-section">\n\t\t\t\t<div class="average-holiday-pay-element-row_wrapper rows">\n\t\t\t\t\t<div class="average-holiday-pay-element-row fadeIn" data-cy="average-holiday-pay-element-row" dir-paginate="payElement in vm.payElements.filtered = (\n\t\t\t\t\t\t\t\tvm.payElements.all |\n\t\t\t\t\t\t\t\tfilter : { Name: searchBarOptions.search.string } |\n\t\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\t\ttrack by payElement.AgencyAdjustmentGroupEntryID\n\t\t\t\t\t\t" ng-class="{ \'is-selected\': payElement.isSelected }">\n\t\t\t\t\t\t<div class="average-holiday-pay-element-row_layout" data-cy="average-holiday-pay-element-row-layout">\n\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_action">\n\t\t\t\t\t\t\t\t<input checkbox aria-label="Select {{payElement.Name}}" data-cy="average-holiday-pay-element-checkbox" id="{{::payElement.AgencyAdjustmentGroupEntryID}}" ng-change="onCheckboxToggle()" ng-model="payElement.isSelected" type="checkbox">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_content">\n\t\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_details">\n\t\t\t\t\t\t\t\t\t<h5 class="average-holiday-pay-element-row_heading" data-cy="average-holiday-pay-element-name">\n\t\t\t\t\t\t\t\t\t\t{{payElement.Name}}\n\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t<span class="average-holiday-pay-element-row_meta" data-cy="average-holiday-pay-element-category">\n\t\t\t\t\t\t\t\t\t\t{{payElement.Category | splitPascalCase}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="average-holiday-pay-element-row_tags">\n\t\t\t\t\t\t\t\t\t<span class="tag inverse" data-cy="average-holiday-pay-element-rate-type" ng-class="payElement.RateType === rateTypes.other ? \'tertiary\' : \'primary\'">\n\t\t\t\t\t\t\t\t\t\t{{payElement.RateType === rateTypes.hourly ? \'Hourly\' : payElement.RateType === rateTypes.daily ? \'Daily\' : \'Other\'}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span class="tag inverse" data-cy="average-holiday-pay-element-inclusion" ng-class="payElement.IncludeIn52WeekAverage ? \'primary\' : \'tertiary\'">\n\t\t\t\t\t\t\t\t\t\t{{payElement.IncludeIn52WeekAverage ? \'Included\' : \'Not included\'}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search ng-show="vm.payElements.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- No pay elements -->\n\t\t<placeholder ng-if="!vm.payElements.all.length" placeholder-graphic="no-job-grades">\n\t\t\t<placeholder-title>No pay elements</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\tThere are no pay elements configured for this company.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/bacs-downloads/settings-bacs-downloads.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="download" page-title="BACS downloads">\n\t\t\t<pt-secondary>\n\t\t\t\t<info-block ib-theme="secondary is-compact has-border">\n\t\t\t\t\t<ib-main>\n\t\t\t\t\t\t<strong>BUN</strong>:\n\t\t\t\t\t\t<a data-cy="bacs-downloads-edit-bureau-bun" href="" class="secondary" ng-click="openEditBureauBunForm(vm)">\n\t\t\t\t\t\t\t<span class="underline">{{vm.agencyEmployerBun | checkEmpty:\'Add number\'}}</span>\n\t\t\t\t\t\t\t<i class="icon-edit"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</ib-main>\n\t\t\t\t</info-block>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<section class="page-template-a-navigation" ng-if="vm.bacsDownloads.all.length">\n\t\t\t<tab-bar tab-bar-def="vm.bacsDownloadsTabBarDef" on-tab-selected="onTabSelected"></tab-bar>\n\t\t</section>\n\n\t\t<main class="page-template-a-main" ng-if="vm.bacsDownloads.all.length">\n\n\t\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t\t<search-bar options="vm.searchBarOptions" bulk-items="vm.bacsDownloads">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a href="" ng-click="createBACSDownloadFile(vm.bacsDownloads.filtered, true)">Download</a>\n\t\t\t\t\t<a href="" ng-if="activeState !== DOCUMENT_STATES.available" ng-click="updateBacsDocumentState(vm.bacsDownloads.filtered, DOCUMENT_STATES.available, true)">Move to \u2018Available\u2019</a>\n\t\t\t\t\t<a href="" ng-if="activeState !== DOCUMENT_STATES.pending" ng-click="updateBacsDocumentState(vm.bacsDownloads.filtered, DOCUMENT_STATES.pending, true)">Move to \u2018Pending\u2019</a>\n\t\t\t\t\t<a href="" ng-if="activeState !== DOCUMENT_STATES.processed" ng-click="updateBacsDocumentState(vm.bacsDownloads.filtered, DOCUMENT_STATES.processed, true)">Move to \u2018Processed\u2019</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t</search-bar>\n\n\t\t\t<section class="bacs-card_wrapper rows">\n\n\t\t\t\t<bacs-card bacs-file="bacsFile" on-state-change="updateBacsDocumentState" on-download="createBACSDownloadFile" bulk-items="vm.bacsDownloads" dir-paginate="bacsFile in vm.bacsDownloads.filtered = ( vm.bacsDownloads.all | filter: {State: activeState} | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse | itemsPerPage : vm.searchBarOptions.results.itemsPerPage"></bacs-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.bacsDownloads.filtered.length === 0"></empty-search>\n\t\t\t</section>\n\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<placeholder ng-if="!vm.bacsDownloads.all.length" placeholder-graphic="files">\n\t\t\t<placeholder-title>No BACS files to download</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p class="s">As new BACS files become available, for companies using BACS, they will appear here for bulk download.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/billing/settings-billing.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="billing" page-title="Billing and payments">\n\t\t\t<pt-secondary>\n\t\t\t\t<a href="" class="button primary" ng-click="openDirectDebitForm()" ng-if="directDebitMandate.MandateDetails.MandateState === MANDATE_STATES.unsubmitted">Set up Direct Debit</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Direct Debit connected -->\n\t\t<section class="page-template-a-section" ng-switch="directDebitMandate.MandateDetails.MandateState">\n\n\t\t\t<!-- No Direct Debit set up -->\n\t\t\t<div class="fadeIn" pc-switch-when="MANDATE_STATES.unsubmitted">\n\t\t\t\t<div class="pricing-plan-summary-card">\n\n\t\t\t\t\t<div class="pricing-plan-summary-card-sections">\n\n\t\t\t\t\t\t<!-- Pricing Plan -->\n\t\t\t\t\t\t<section class="pricing-plan-summary-card-section">\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-plan">\n\t\t\t\t\t\t\t\t<img alt="" class="pricing-plan-summary-card-graphic" height="200" src="images/graphics/placeholders/sme-billing-plan.2x.png">\n\t\t\t\t\t\t\t\t<h1 class="pricing-plan-summary-card-title">Pricing Plan</h1>\n\t\t\t\t\t\t\t\t<h1 class="pricing-plan-summary-card-price">{{1 | monetise}}<span>/payslip</span></h1>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-label">excl. VAT</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<!-- Included in plan -->\n\t\t\t\t\t\t<section class="pricing-plan-summary-card-section">\n\t\t\t\t\t\t\t<header class="pricing-plan-summary-card-section-header">\n\t\t\t\t\t\t\t\t<h5 class="pricing-plan-summary-card-section-title">Included in your plan</h5>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-section-subtitle">Based on your current team -&nbsp;<ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 person\', \'other\': \'{} people\'}"></ng-pluralize>&nbsp;active on payroll</p>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-features">\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description"><ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize></p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsPayrollActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-pay-periods pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">Payroll</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsPensionActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-money pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">Pension</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsCISActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-cis pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">CIS</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature">\n\t\t\t\t\t\t\t\t\t<i class="icon-mobile pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">User Portal</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-total">\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-total-description">Charge per payroll run <span>(excl. VAT)</span></p>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-total-amount">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<footer class="pricing-plan-summary-card-footer">\n\t\t\t\t\t\t<div class="pricing-plan-summary-card-footer-actions">\n\t\t\t\t\t\t\t<span>Want&nbsp;<ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize>&nbsp;for {{nextPayment.Amount | monetise}}?</span>\n\t\t\t\t\t\t\t<a href="" class="button primary" ng-click="openDirectDebitForm()">Set up Direct Debit</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<img alt="Powered by GoCardless" class="pricing-plan-summary-card-powered-by" src="images/graphics/powered-by-gocardless-blue@2x.png" width="150">\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Redirect flow not completed -->\n\t\t\t<div class="state-block secondary fadeIn" pc-switch-when="MANDATE_STATES.redirectFlowNotCompleted">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/direct-debit-requested.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit request submitted...</h2>\n\t\t\t\t<p class="state-block-description">Your Direct Debit request has been submitted and we\'re just waiting for your company and bank details to be confirmed. This should only take around 24 hours but don\'t worry, we\'ll email you when your Direct Debit is good to go!</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<img alt="Powered by GoCardless" src="images/graphics/powered-by-gocardless.png" width="150">\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Pending customer approval -->\n\t\t\t<div class="state-block indifferent fadeIn" pc-switch-when="MANDATE_STATES.pendingCustomerApproval">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/direct-debit-requested.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit request approval required...</h2>\n\t\t\t\t<p class="state-block-description">Your Direct Debit request has been submitted and is awaiting for you to confirm your details. Once confirmed, return back here and refresh for further information.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<img alt="Powered by GoCardless" src="images/graphics/powered-by-gocardless.png" width="150">\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Pending submission -->\n\t\t\t<div class="state-block positive fadeIn" pc-switch-when="MANDATE_STATES.pendingSubmission">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/direct-debit-requested.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit set up in progress...</h2>\n\t\t\t\t<p class="state-block-description">This can take up to three days, please check back or refresh this page for updates. Once complete you will have access to your billing and payment information.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<img alt="Powered by GoCardless" src="images/graphics/powered-by-gocardless.png" width="150">\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Submitted -->\n\t\t\t<div class="state-block positive fadeIn" pc-switch-when="MANDATE_STATES.submitted">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/direct-debit-requested.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit request successfully submitted...</h2>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<img alt="Powered by GoCardless" src="images/graphics/powered-by-gocardless.png" width="150">\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Failed -->\n\t\t\t<div class="state-block assertive fadeIn" pc-switch-when="MANDATE_STATES.failed">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/billing-problem.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit request failed...</h2>\n\t\t\t\t<p class="state-block-subtitle">Please update your details as soon as possible</p>\n\t\t\t\t<p class="state-block-description">Your Direct Debit has failed. Please <a href="" ng-click="openCompanyBankDetailsForm()" class="underline">check the bank account details</a> you used to set up this Direct Debit. If you need further help, please contact our support team.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Cancelled -->\n\t\t\t<div class="state-block assertive fadeIn" pc-switch-when="MANDATE_STATES.cancelled">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/billing-problem.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit request cancelled...</h2>\n\t\t\t\t<p class="state-block-subtitle">Please update your details as soon as possible</p>\n\t\t\t\t<p class="state-block-description">Your Direct Debit mandate has been cancelled. You will need to <a href="" class="underline" ng-click="openCompanyBankDetailsForm()">set up a new Direct Debit mandate</a> to keep your account active. If you need further help, please contact our support team.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<a href="" class="button l assertive" ng-click="openCompanyBankDetailsForm()">Set up Direct Debit</a>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Expired -->\n\t\t\t<div class="state-block assertive fadeIn" pc-switch-when="MANDATE_STATES.expired">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/billing-problem.2x.png">\n\t\t\t\t<h2 class="state-block-title">Direct Debit mandate expired...</h2>\n\t\t\t\t<p class="state-block-subtitle">Please update your details as soon as possible</p>\n\t\t\t\t<p class="state-block-description">Your Direct Debit mandate has expired. You will need to <a href="" class="underline" ng-click="openCompanyBankDetailsForm()">set up a new Direct Debit mandate</a> to keep your account active. If you need further help, please contact our support team.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<a href="" class="button l assertive" ng-click="openCompanyBankDetailsForm()">Set up Direct Debit</a>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Invalid bank details -->\n\t\t\t<div class="state-block assertive fadeIn" pc-switch-when="MANDATE_STATES.invalidBankDetails">\n\t\t\t\t<img alt="" class="state-block-graphic" src="images/graphics/placeholders/billing-problem.2x.png">\n\t\t\t\t<h2 class="state-block-title">Your bank details are invalid...</h2>\n\t\t\t\t<p class="state-block-subtitle">Please update them as soon as possible</p>\n\t\t\t\t<p class="state-block-description">Your Direct Debit has failed. Please <a href="" ng-click="openCompanyBankDetailsForm()" class="underline">check the bank account details</a> you used to set up this Direct Debit. If you need further help, please contact our support team.</p>\n\t\t\t\t<footer class="state-block-footer">\n\t\t\t\t\t<a href="" class="button l assertive" ng-click="openCompanyBankDetailsForm()">Update Bank Details</a>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Active -->\n\t\t\t<div class="fadeIn" pc-switch-when="MANDATE_STATES.active">\n\n\t\t\t\t<section class="page-template-a-section">\n\t\t\t\t\t<div class="billing-cards" ng-switch="nextPayment.PaymentStatus">\n\n\t\t\t\t\t\t<!-- Overview -->\n\t\t\t\t\t\t<div class="billing-card billing-overview {{nextPayment.PaymentStatus | paymentState:\'theme\'}}" ng-switch="nextPayment.PaymentStatus">\n\n\t\t\t\t\t\t\t<header class="billing-card-info-header">\n\t\t\t\t\t\t\t\t<h5 class="billing-card-info-title">Payment</h5>\n\t\t\t\t\t\t\t\t<div class="billing-card-status">\n\t\t\t\t\t\t\t\t\t<span class="billing-card-emoji">{{nextPayment.PaymentStatus | paymentState:\'emoji\'}}</span>\n\t\t\t\t\t\t\t\t\t<span class="tag {{nextPayment.PaymentStatus | paymentState:\'theme\'}} inverse">{{nextPayment.PaymentStatus | paymentState}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t<section pc-switch-when="PAYMENT_STATES.failed">\n\t\t\t\t\t\t\t\t<div class="billing-card-info-group">\n\t\t\t\t\t\t\t\t\t<div class="billing-card-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-label">Billing date</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-value">{{nextPayment.ChargeDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="billing-card-info-warning">\n\t\t\t\t\t\t\t\t\t<p class="billing-card-info-message">Your payment has failed. Make a manual payment to keep your account active.</p>\n\t\t\t\t\t\t\t\t\t<p class="billing-card-info-owed"><span class="billing-card-info-owed-label">Amount owed</span>{{nextPayment.TotalAmount | monetise}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t\t<section ng-switch-default>\n\t\t\t\t\t\t\t\t<div class="billing-card-info-group">\n\t\t\t\t\t\t\t\t\t<div class="billing-card-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-label">Billing date</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-value">{{nextPayment.ChargeDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="billing-card-info-group">\n\t\t\t\t\t\t\t\t\t<div class="billing-card-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-label">Subtotal</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-value">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="billing-card-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-label">UK VAT @ 20%</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-value">{{nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="billing-card-info-group">\n\t\t\t\t\t\t\t\t\t<div class="billing-card-info-item l">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-label">Total monthly charge</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-card-info-item-value">{{nextPayment.TotalAmount | monetise}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</section>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Summary -->\n\t\t\t\t\t\t<div class="billing-card billing-summary primary">\n\t\t\t\t\t\t\t<img alt="" class="billing-card-graphic" height="130" src="images/graphics/placeholders/sme-billing-plan.2x.png">\n\t\t\t\t\t\t\t<p class="billing-card-title">Pricing plan</p>\n\t\t\t\t\t\t\t<div class="billing-card-meta">\n\t\t\t\t\t\t\t\t<span class="billing-card-meta-item"><ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t\t<span class="billing-card-meta-item"><ng-pluralize count="company.numberOfModules" when="{\'1\': \'1 module\', \'other\': \'{} modules\'}"></ng-pluralize></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- <p class="billing-card-date">Plan renewal date: {{PLAN_RENEWAL_DATE}}</p> -->\n\t\t\t\t\t\t\t<a ui-sref="settings.company.upgrade({agencyProfileId: agencyProfileId})" class="billing-card-action">Review my plan</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Details -->\n\t\t\t\t\t\t<div class="billing-card billing-detail secondary">\n\t\t\t\t\t\t\t<div class="billing-detail-group">\n\t\t\t\t\t\t\t\t<header class="billing-detail-group-header">\n\t\t\t\t\t\t\t\t\t<h6 class="billing-detail-group-title">Billing name</h6>\n\t\t\t\t\t\t\t\t\t<a href="" ng-click="openCompanyBillingNameForm()" class="billing-card-action billing-detail-action">Update</a>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<div class="billing-detail-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-label">{{directDebitMandate.CompanyName}}</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-value"></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="billing-detail-group">\n\t\t\t\t\t\t\t\t<header class="billing-detail-group-header">\n\t\t\t\t\t\t\t\t\t<h6 class="billing-detail-group-title">Account information</h6>\n\t\t\t\t\t\t\t\t\t<a href="" class="billing-card-action billing-detail-action" ng-click="openCompanyBankDetailsForm()">Update</a>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<div class="billing-detail-info-items">\n\t\t\t\t\t\t\t\t\t<div class="billing-detail-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-label">Account number</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-value">{{directDebitMandate.Bank.BankAccountNumber}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="billing-detail-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-label">Sort code</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-value">{{directDebitMandate.Bank.SortCode}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="billing-detail-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-label">Payment method</p>\n\t\t\t\t\t\t\t\t\t\t<p class="billing-detail-info-item-value">Direct Debit</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="billing-detail-group">\n\t\t\t\t\t\t\t\t<header class="billing-detail-group-header">\n\t\t\t\t\t\t\t\t\t<h6 class="billing-detail-group-title">Billing address</h6>\n\t\t\t\t\t\t\t\t\t<a href="" class="billing-card-action billing-detail-action" ng-click="openCompanyBillingDetailsForm()">Update</a>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<div class="billing-detail-info-items">\n\t\t\t\t\t\t\t\t\t<print-address class="address inline billing-detail-info-address" address="directDebitMandate.BillingAddress"></print-address>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Has payments -->\n\t\t\t\t<section ng-if="payments.length">\n\n\t\t\t\t\t<!-- Filter Bar -->\n\t\t\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t\t\t<!-- Search Bar -->\n\t\t\t\t\t<search-bar options="searchBarOptions" count="filteredPayments.length"></search-bar>\n\n\t\t\t\t\t<div class="billing-rows">\n\t\t\t\t\t\t<div class="billing-row" dir-paginate="payment in filteredPayments = ( payments | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy | itemsPerPage : searchBarOptions.results.itemsPerPage">\n\t\t\t\t\t\t\t<div class="billing-row-period">{{payment.PayPeriod.PayPeriodDisplay}}</div>\n\t\t\t\t\t\t\t<div class="billing-row-description">{{payment.Description}}</div>\n\t\t\t\t\t\t\t<div class="billing-row-status">\n\t\t\t\t\t\t\t\t<span class="tag {{payment.PaymentStatus | paymentState:\'theme\'}} xs">{{payment.PaymentStatus | paymentState}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="billing-row-amount">{{payment.TotalAmount | monetise}}</div>\n\t\t\t\t\t\t\t<div class="billing-row-date">{{payment.ChargeDateISO | dateformat}}</div>\n\t\t\t\t\t\t\t<a href="" ng-click="downloadFile(payment.PaymentInvoiceURL)" class="greyscale billing-row-action"><i class="icon-download"></i></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No search results -->\n\t\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredPayments.length === 0"></empty-search>\n\n\t\t\t\t\t<section class="page-template-a-section">\n\t\t\t\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t\t\t\t</section>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- No payments -->\n\t\t\t\t<section class="page-template-a-section" ng-if="!payments.length">\n\t\t\t\t\t<div class="placeholder theme-2 align-center">\n\t\t\t\t\t\t<p class="s">Your Direct Debit has been set up and your first payment will be taken after you\'ve processed your next payroll. You will be able to see your billing and payment history here and Paycircle will also email you in advance of payment each month.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- Cancel account -->\n\t\t\t\t<section class="page-template-a-section">\n\t\t\t\t\t<p class="s align-center">\uD83D\uDE22 Want to cancel your account? Please contact our support team</p>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</section>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/bureau-payroll-settings/bureau-payroll-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Payroll settings">\n\t\t</page-template-a-header>\n\n\t\t<div class="detail-blocks">\n\t\t\t<!-- Payroll settings -->\n\t\t\t<detail-block db-details="basicDetails" db-edit-text="\'Edit\'" db-feedback-position="top" db-show-feedback="true">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small normal">\n\t\t\t\t\t\tSchedule when you wish to send notifications to team members and make their P60s available in their Pay Portal.\n\t\t\t\t\t\tThis will be applied to all companies in your bureau but can be overridden at company level in their respective settings area.\n\t\t\t\t\t</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\t\t</div>\n\n\t\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'">\n</error-block>\n');
$templateCache.put('features/app/settings/business-categories/settings-business-categories.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<page-template-a-header icon="group" page-title="Business categories">\n\t\t<pt-sub-heading>\n\t\t\t<p class="is-small">Please note that the Standard Payroll Summary Report will be broken down by department</p>\n\t\t</pt-sub-heading>\n\t\t<pt-secondary>\n\t\t\t<a class="button is-primary" data-cy="import-business-categories" ui-sref="data-importer.select-import-file-type-bcat({\n\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.accessFinancialsBusinessCategoriesImport\n\t\t\t\t})">\n\t\t\t\t<i class="icon-upload has-margin-right"></i>Import categories\n\t\t\t</a>\n\t\t</pt-secondary>\n\t</page-template-a-header>\n\n\t<section class="page-template-a-navigation">\n\t\t<tab-bar tab-bar-def="vm.businessCategoriesTabBarDef"></tab-bar>\n\t</section>\n\n\t<ui-view></ui-view>\n\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>');
$templateCache.put('features/app/settings/customisation/settings-customisation.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="paintpot" page-title="Customisation"></page-template-a-header>\n\n\t\t<section class="page-template-a-section">\n\n\t\t\t<section class="page-template-a-navigation">\n\t\t\t\t<tab-bar tab-bar-def="vm.customisationTabBarDef" on-tab-selected="onTabSelected"></tab-bar>\n\t\t\t</section>\n\n\t\t\t<main class="page-template-a-main" ng-if="vm.currentTab === TAB_KEYS.settings.customisation.tabs.system">\n\t\t\t\t<div class="detail-blocks">\n\n\t\t\t\t\t<!-- Login page -->\n\t\t\t\t\t<detail-block db-details="vm.loginPage" db-edit-text="\'Edit and preview\'"></detail-block>\n\n\t\t\t\t\t<!-- App header -->\n\t\t\t\t\t<detail-block db-details="vm.appHeader" db-edit-text="\'Edit and preview\'"></detail-block>\n\n\t\t\t\t\t<!-- System emails -->\n\t\t\t\t\t<detail-block db-details="vm.systemEmails" db-edit-text="\'Edit and preview\'" db-show-feedback="true" db-feedback-position="bottom">\n\t\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t\tPlease note: the \u2018Powered by Paycircle\u2019 logo will always be shown in the footer of emails\n\t\t\t\t\t\t</db-feedback>\n\t\t\t\t\t</detail-block>\n\n\t\t\t\t\t<!-- Online payslips -->\n\t\t\t\t\t<detail-block db-details="vm.onlinePayslips" db-edit-text="\'Edit and preview\'" db-show-feedback="true" db-feedback-position="bottom">\n\t\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t\tPlease note: the \u2018Powered by Paycircle\u2019 logo will always be shown in the footer of online payslips\n\t\t\t\t\t\t</db-feedback>\n\t\t\t\t\t</detail-block>\n\n\t\t\t\t\t<!-- Intercom live chat -->\n\t\t\t\t\t<detail-block db-details="vm.intercomChat" db-show-feedback="true" ng-if="::company.CompanyType === INTERFACE_TYPES.bureau">\n\t\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t\t<img src="../images/logo/intercom.svg" alt="Intercom" height="40">\n\t\t\t\t\t\t</db-feedback>\n\t\t\t\t\t\t<db-html>\n\t\t\t\t\t\t\t<p class="is-small is-greyscale-darkened">Need an Intercom account? <a ng-href="{{$root.URLS.intercom.website}}" target="_blank" class="is-primary">Get one here</a></p>\n\t\t\t\t\t\t</db-html>\n\t\t\t\t\t</detail-block>\n\t\t\t\t</div>\n\t\t\t</main>\n\n\t\t\t<main class="page-template-a-main" ng-if="vm.currentTab === TAB_KEYS.settings.customisation.tabs.employeePortal">\n\t\t\t\t<div class="detail-blocks">\n\t\t\t\t\t<!-- Employee portal -->\n\t\t\t\t\t<detail-block db-details="vm.employeePortal" db-edit-text="\'Edit and preview\'"></detail-block>\n\t\t\t\t</div>\n\t\t\t</main>\n\n\t\t</section>\n\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/email-notifications/settings-email-notifications.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Information -->\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="email" page-title="Email notifications"></page-template-a-header>\n\n\t\t<section class="page-template-a-section">\n\t\t\t<div ng-if="frameworkIsInherited" class="email-settings_header">\n\t\t\t\t<icon-dot icon="icon-company-groups" theme="tertiary"></icon-dot>\n\t\t\t\t<p class="m">&nbsp;&nbsp;{{company.Name}} are using the email notification settings for \'{{companyEmailFramework.FrameworkOwnerAgencyProfileName}}\'.\n\t\t\t\t\tTo use custom notification settings, <a href="" ng-click="openEmailNotificationSettingsForm()">click here</a>.</p>\n\t\t\t</div>\n\t\t\t<div ng-if="!frameworkIsInherited" class="email-settings_header">\n\t\t\t\t<p class="m">Choose which emails you would like us to automatically send for you.</p>\n\t\t\t</div>\n\t\t\t<note note-theme="indifferent" ng-if="companyEmailFramework.CompanyHasPayDashboardEnabled">\n\t\t\t\t<note-content>\n\t\t\t\t\t<i class="indifferent m icon-information inline"></i><span class="s">&nbsp;&nbsp;PayDashboard file creation is turned on in your\n\t\t\t\t\t\t<a class="indifferent underline" ui-sref="settings.company.payroll-settings({agencyProfileId: agencyProfileId})">company settings</a> so all emails to team members have been disabled.</span>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t\t<div class="email-card-group" ng-repeat="emailGroup in emailGroups">\n\t\t\t\t<div class="email-card-group_header"><h4>{{emailGroup.groupName}}</h4>\n\t\t\t\t\t<div class="email-card-group_controls" ng-if="!emailGroup.isSystem && !companyEmailFramework.IsReadOnly">\n\t\t\t\t\t\t<div class="email-card-group_control-link"><a href="" ng-click="setAllActive(emailGroup, true)">Turn all on</a></div>\n\t\t\t\t\t\t<div class="email-card-group_control-link"><a href="" ng-click="setAllActive(emailGroup, false)">Turn all off</a></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="s" ng-if="emailGroup.isSystem">These emails are just for preview and will always be sent when automatically or manually triggered</p>\n\t\t\t\t<div class="email-subgroup" ng-class="{ \'is-first\' : $first }" ng-repeat="emailSubgroup in emailGroup.emailSubgroups">\n\t\t\t\t\t<div class="email-subgroup_header"><a href="" class="email-subgroup-header_expand-link {{emailSubgroup.groupTheme}}" ng-click="toggleExpand(emailSubgroup)"><i class="icon-chevron-down m" ng-if="emailSubgroup.isExpanded"></i><i class="icon-chevron-up m" ng-if="!emailSubgroup.isExpanded"></i>&nbsp;&nbsp;{{emailSubgroup.subgroupName.toUpperCase()}} ({{emailSubgroup.activeCount}} ON)</a></div>\n\t\t\t\t\t<div class="email-cards" ng-if="emailSubgroup.isExpanded">\n\t\t\t\t\t\t<email-card ng-repeat="email in emailSubgroup.emailList" agency-profile-id="agencyProfileId" email="email" preview-type="EMAIL_PREVIEW_TYPES.notificationSettingsPreview" on-email-active-change="onEmailActiveChange(email)"></email-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\t</div>\n</div>');
$templateCache.put('features/app/settings/employee-portal/settings-employee-portal-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="user" page-title="Employee Portal settings"></page-template-a-header>\n\n\t\t<!-- Settings blocks for employee portal settings -->\n\t\t<div class="detail-blocks">\n\n\t\t\t<detail-block db-can-edit="angular.isDefined(employeePortalSettingsDetailBlock.editAction)" db-details="employeePortalSettingsDetailBlock" ng-repeat="employeePortalSettingsDetailBlock in vm.employeePortalSettingsDetailBlocks" db-show-feedback="employeePortalSettingsDetailBlock.feedback" db-feedback-position="bottom">\n\t\t\t\t<db-feedback ng-if="employeePortalSettingsDetailBlock.feedback">\n\t\t\t\t\t<p>{{employeePortalSettingsDetailBlock.feedback}}</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\t\t</div>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/file-uploads/settings-file-uploads.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Information -->\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="document" page-title="File uploads">\n\n\t\t\t<pt-secondary ng-if="vm.documents.all.length > 0">\n\t\t\t\t<button class="is-primary" ng-click="openFileUploadsForm(FILE_UPLOAD_FORMS.uploadFile)" type="button">\n\t\t\t\t\t<i class="icon-upload has-margin-right"></i>Upload files\n\t\t\t\t</button>\n\t\t\t</pt-secondary>\n\n\t\t</page-template-a-header>\n\n\t\t<main class="page-template-a-main" ng-if="vm.documents.all.length > 0">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar apply-filter-keys="applyfilter" filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar bulk-items="vm.documents" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a class="is-assertive" href="" ng-click="openFileUploadsForm(FILE_UPLOAD_FORMS.deleteFile, vm.documents.filtered)">\n\t\t\t\t\t\tDelete\n\t\t\t\t\t</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t</search-bar>\n\n\t\t\t<!-- Documents -->\n\t\t\t<section class="page-template-a-section">\n\n\t\t\t\t<div class="document-upload-row_wrapper">\n\t\t\t\t\t<document-upload-row agency-profile-id="agencyProfileId" bulk-items="vm.documents" current-page="searchBarOptions.currentPageNumber" dir-paginate="document in vm.documents.filtered = (\n\t\t\t\t\t\t\t\tvm.documents.all |\n\t\t\t\t\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t\t) |\n\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\t" document="document" refresh-page="refreshPage()"></document-upload-row>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-if="vm.documents.filtered.length === 0">\n\t\t\t\t\t<button class="action fadeIn" ng-click="searchBarOptions.search.string = \'\'" ng-if="searchBarOptions.search.string !== \'\'" type="button">\n\t\t\t\t\t\tClear search\n\t\t\t\t\t</button>\n\t\t\t\t</empty-search>\n\n\t\t\t\t<!-- Pagination -->\n\t\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t\t</section>\n\t\t</main>\n\n\t\t<!-- No documents -->\n\t\t<placeholder ng-if="vm.documents.all.length === 0" placeholder-graphic="no-imports">\n\t\t\t<placeholder-title>Start uploading files </placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Upload CSV and FPS files which you can later use for importing team and payroll data along with any other files you may wish to store for your records.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="is-primary" ng-click="openFileUploadsForm(FILE_UPLOAD_FORMS.uploadFile)" type="button">\n\t\t\t\t\t<i class="icon-upload has-margin-right"></i>Upload files\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/gender-pay-gap/settings-gender-pay-gap.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\t\t<page-template-a-header icon="setup-user" page-title="Gender pay gap"></page-template-a-header>\n\n\t\t<!-- Reports -->\n\t\t<div ng-if="vm.genderPayGapReports.all.length">\n\t\t\t<main>\n\t\t\t\t<!-- Search Bar -->\n\t\t\t\t<search-bar bulk-items="vm.genderPayGapReports" options="searchBarOptions">\n\t\t\t\t\t<sb-right-actions>\n\t\t\t\t\t\t<div class="spaced-links is-centered-bottom">\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<button class="is-primary" data-cy="gpg-new-report" ng-click="openGenderPayGapWizard()">\n\t\t\t\t\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t\t\t\t\t&nbsp;&nbsp;New report\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</sb-right-actions>\n\t\t\t\t</search-bar>\n\n\t\t\t\t<section class="gender-pay-gap-report-card_wrapper rows">\n\t\t\t\t\t<gender-pay-gap-report-card agency-profile-id="agencyProfileId" current-page="searchBarOptions.currentPageNumber" dir-paginate="genderPayGapReport in vm.genderPayGapReports.filtered = (\n\t\t\t\t\t\t\t\tvm.genderPayGapReports.all |\n\t\t\t\t\t\t\t\tfilter : searchBarOptions.search.string ) |\n\t\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage" gender-pay-gap-report="genderPayGapReport" index="$index" on-update="refresh()"></gender-pay-gap-report-card>\n\t\t\t\t</section>\n\t\t\t</main>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.genderPayGapReports.filtered.length === 0"></empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</div>\n\n\t\t<!-- No reports -->\n\t\t<placeholder placeholder-graphic="no-job-grades" ng-if="!vm.genderPayGapReports.all.length">\n\t\t\t<placeholder-title>No reports saved</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\tOnce you start adding your gender pay gap reports they will appear here.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="is-primary" data-cy="gpg-new-report-no-reports" ng-click="openGenderPayGapWizard()" type="button">\n\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t&nbsp;&nbsp;New report\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/imports/settings-imports.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-switch="activeTab">\n\n\t\t<div class="page-template-a-header-wrapper">\n\t\t\t<page-template-a-header icon="upload" page-title="{{$root.currentCompany.CompanyType === INTERFACE_TYPES.bureau ? \'Mapping templates\' : \'Imports\'}}"></page-template-a-header>\n\t\t</div>\n\n\t\t<!-- Navigation > Only applicable to Companies -->\n\t\t<section class="page-template-a-navigation" ng-if="$root.currentCompany.CompanyType !== INTERFACE_TYPES.bureau">\n\t\t\t<tab-bar tab-bar-def="settingsImportsTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/information/settings-information.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Information"></page-template-a-header>\n\n\t\t<!-- Company -->\n\t\t<div class="detail-blocks">\n\n\t\t\t<!-- Basic Details -->\n\t\t\t<detail-block db-details="basicDetails"></detail-block>\n\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/integrations/settings-integrations.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<div class="page-template-a-header-wrapper">\n\t\t\t<page-template-a-header icon="connection" page-title="Integrations"></page-template-a-header>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="detail-blocks">\n\t\t\t\t<detail-block db-can-edit="canEditPeopleHRIntegrationEnabled" db-details="peopleHrIntegration" db-show-feedback="true">\n\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t<p class="normal">\n\t\t\t\t\t\t\tExisting users of PeopleHR can receive and review team and payroll updates.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</db-feedback>\n\t\t\t\t\t<db-html>\n\t\t\t\t\t\t<p class="normal is-tertiary is-strong">\n\t\t\t\t\t\t\tUse these utilities for clients using the PeopleHR integration who already have data live in Paycircle. Before you begin, make sure:\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'The integration is turned OFF in Paycircle\',\n\t\t\t\t\t\t\t\t\'Confirm ALL employee data is ready in PHR\',\n\t\t\t\t\t\t\t\t\'Do NOT add any more data in PeopleHR until this process is completed\',\n\t\t\t\t\t\t\t\t\'The integration is turned ON in PeopleHR\'\n\t\t\t\t\t\t\t\t]" bl-theme="is-primary normal"></bullet-list>\n\n\t\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t\t<button class="is-white" ng-click="openAlignTeamMemberMappingsIntegrationForm()">\n\t\t\t\t\t\t\tAlign team member mappings\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</db-html>\n\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="detail-blocks">\n\t\t\t\t<detail-block db-details="accountingIntegration" db-edit-text="isAccountingIntegrationEnabled ? \'Disconnect\' : \'Connect\'" db-feedback-position="top" db-show-feedback="true">\n\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t<p class="normal">\n\t\t\t\t\t\t\tImport nominal accounts and post journals to your accounting software.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</db-feedback>\n\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="page-template-a-section" ng-if="isAccessRotareadyFeatureEnabled">\n\t\t\t<div class="detail-blocks">\n\t\t\t\t<detail-block db-details="timeAndAttendanceIntegration" db-edit-text="isAccessRotareadyIntegrationEnabled ? \'Edit\' : \'Connect\'" db-feedback-position="top" db-show-feedback="true">\n\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t<p class="normal">\n\t\t\t\t\t\t\tExisting users of Rotaready can receive and review team and payroll updates.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</db-feedback>\n\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="detail-blocks">\n\t\t\t\t<detail-block db-details="edpIntegration" db-edit-text="isEdpIntegrationEnabled ? \'Manage\' : \'Connect\'" db-feedback-position="top" db-show-feedback="isEdpIntegrationEnabled">\n\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t<p class="normal">\n\t\t\t\t\t\t\tControl which event types are processed by the EDP integration.\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\tDisable topics to skip incoming events of that type.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</db-feedback>\n\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\t\t\t<div class="detail-blocks">\n\t\t\t\t<detail-block db-can-edit="canEditPayExperianIntegrationEnabled" db-details="payExperianIntegration" db-feedback-position="top" db-show-feedback="true">\n\t\t\t\t\t<db-feedback>\n\t\t\t\t\t\t<p class="normal">\n\t\t\t\t\t\t\tEnable employees to securely share payslip data to expedite application processes.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</db-feedback>\n\t\t\t\t</detail-block>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n</div>');
$templateCache.put('features/app/settings/journals/settings-journals.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-switch="activeTab">\n\n\t\t<!-- Page header -->\n\t\t<div class="page-template-a-header-wrapper">\n\n\t\t\t<!-- Page title -->\n\t\t\t<page-template-a-header icon="excel" page-title="Journals">\n\t\t\t\t<pt-sub-heading>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tSet up your nominal codes, add any sub-code overrides for business categories,\n\t\t\t\t\t\tand configure your journal code format for submissions to your accounting software.\n\t\t\t\t\t</p>\n\t\t\t\t</pt-sub-heading>\n\t\t\t</page-template-a-header>\n\n\t\t\t<!-- Journal format overview -->\n\t\t\t<journal-code-preview agency-profile-id="vm.agencyProfileId" is-financials-integrated="vm.isFinancialsIntegrated" journal-code-format="vm.journalCodeFormat" journal-codes-active="vm.journalCodesActive" on-update="vm.refresh()"></journal-code-preview>\n\t\t</div>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<tab-bar tab-bar-def="vm.settingsJournalsTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/modules/settings-modules.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<div class="page-template-a-header-wrapper">\n\t\t\t<page-template-a-header icon="toggle-on" page-title="Modules"></page-template-a-header>\n\t\t</div>\n\n\t\t<div class="page-template-a-section">\n\n\t\t\t<!-- Company -->\n\t\t\t<div class="detail-blocks">\n\n\t\t\t\t<!-- Modules -->\n\t\t\t\t<detail-block db-details="moduleDetails" ng-if="::moduleDetails.detailGroups.length"></detail-block>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block></div>');
$templateCache.put('features/app/settings/overview/settings-overview_blocks.view.html','<section class="page-template-a-section" ng-if="pageState === \'ready\'">\n\n\t<!-- Company -->\n\t<div class="detail-blocks">\n\n\t\t<!-- Basic Details -->\n\t\t<detail-block db-details="basicDetails"></detail-block>\n\n\t\t<!-- Modules -->\n\t\t<detail-block db-details="moduleDetails" ng-if="::moduleDetails.detailGroups.length"></detail-block>\n\n\t\t<!-- References and updates -->\n\t\t<detail-block db-details="referencesDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t<!-- Payroll settings -->\n\t\t<detail-block db-details="payPeriodDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t<!-- P32 payment-->\n\t\t<detail-block db-details="p32PaymentDetails" ng-if="::isPayrollCompany && !company.PensionOnly"></detail-block>\n\n\t\t<!-- Employer status -->\n\t\t<detail-block db-details="employerDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t<!-- Work Patterns -->\n\t\t<detail-block db-details="workPatternDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t<!-- Payslips -->\n\t\t<detail-block db-details="payslipDetails" ng-if="::isPayrollCompany">\n\t\t\t<db-content>\n\t\t\t\t<p class="detail-block-upload-description">\n\t\t\t\t\tThe Paycircle logo is shown on payslips by default. <br>Upload your own logo to override it.\n\t\t\t\t</p>\n\t\t\t\t<p class="detail-block-upload-note">\n\t\t\t\t\tChoose a PNG or JPEG, 750Kb max. We recommend the image has a transparent background.\n\t\t\t\t</p>\n\t\t\t\t<div class="detail-block-links">\n\t\t\t\t\t<a href ng-click="openPayslipPreviewForm(\'Online\')" class="detail-block-links-item primary">\n\t\t\t\t\t\t<i class="icon-external-link"></i>&nbsp;&nbsp;Online preview\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href ng-click="openPayslipPreviewForm(\'PDF\')" class="detail-block-links-item primary">\n\t\t\t\t\t\t<i class="icon-external-link"></i>&nbsp;&nbsp;PDF preview\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</db-content>\n\t\t</detail-block>\n\n\t</div>\n</section>\n');
$templateCache.put('features/app/settings/p11db-submissions/settings-p11db-submissions.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="P11D(b) submissions">\n\t\t\t<pt-secondary>\n\t\t\t\t<button class="is-primary" data-cy="new-p11db-submission" ng-click="vm.openP11DbSubmissionForm()" ng-if="vm.p11DbSubmissions.length !== 0">\n\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t&nbsp;&nbsp;New submission\n\t\t\t\t</button>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- No P11D(b) Submissions -->\n\t\t<placeholder placeholder-graphic="changes" ng-if="vm.p11DbSubmissions.length === 0">\n\t\t\t<placeholder-title>No submissions made</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\tClick \'New submission\' to begin. You\'ll be able to save a draft PDF of your data if it needs approval before being submitted.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="is-primary" ng-click="vm.openP11DbSubmissionForm()" type="button">\n\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t&nbsp;&nbsp;New submission\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- P11D(b) Submissions -->\n\t\t<main>\n\t\t\t<!-- P11D(b) Submissions Cards -->\n\t\t\t<section class="p11db-submissions-card_wrapper rows" ng-if="vm.p11DbSubmissions.length > 0">\n\n\t\t\t\t<p11db-submissions-card agency-profile-id="vm.agencyProfileId" ng-repeat="p11dbSubmission in vm.p11DbSubmissions" p11db-submission="p11dbSubmission" refresh-submissions="vm.refreshSubmissions"></p11db-submissions-card>\n\n\t\t\t</section>\n\t\t</main>\n\t</div>\n</div>\n');
$templateCache.put('features/app/settings/pay-elements/settings-pay-elements.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="adjustment" page-title="Pay elements"></page-template-a-header>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<tab-bar tab-bar-def="payElementsTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<placeholder placeholder-graphic="no-pay-elements" ng-if="!adjustmentGroup.GroupEntries.length">\n\t\t<placeholder-title>You don\'t have any pay elements to show yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you add pay elements, they will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/payslips/settings-payslips.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="payslip" page-title="Payslips"></page-template-a-header>\n\n\t\t<div class="detail-blocks">\n\n\t\t\t<!-- Display -->\n\t\t\t<detail-block db-details="vm.payslipDisplay">\n\t\t\t\t<db-content>\n\t\t\t\t\t<p class="detail-block-upload-description">\n\t\t\t\t\t\tThe Paycircle logo is shown on payslips by default. <br>Upload your own logo to override it.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="detail-block-upload-note">\n\t\t\t\t\t\tChoose a PNG or JPEG, 750Kb max. We recommend the image has a transparent background.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="detail-block-links">\n\t\t\t\t\t\t<a class="detail-block-links-item primary" href="" ng-click="openPayslipPreviewForm(\'Online\')">\n\t\t\t\t\t\t\t<i class="icon-external-link"></i>&nbsp;&nbsp;Online preview\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="detail-block-links-item primary" href="" ng-click="openPayslipPreviewForm(\'PDF\')">\n\t\t\t\t\t\t\t<i class="icon-external-link"></i>&nbsp;&nbsp;PDF preview\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</db-content>\n\t\t\t</detail-block>\n\n\t\t\t<!-- Downloads -->\n\t\t\t<detail-block db-details="vm.payslipDownloads" db-feedback-position="top" db-show-feedback="true">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tCustomise the sort order of team members for payslip downloads from the Payroll area.\n\t\t\t\t\t</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/payroll-settings/settings-payroll-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Payroll Settings"></page-template-a-header>\n\n\t\t<!-- Company -->\n\t\t<div class="detail-blocks">\n\n\t\t\t<!-- Payroll settings -->\n\t\t\t<detail-block db-details="payPeriodDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t\t<!-- References and updates -->\n\t\t\t<detail-block db-details="referencesDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t\t<!-- P32 payment-->\n\t\t\t<detail-block db-details="p32PaymentDetails" ng-if="::isPayrollCompany && !company.PensionOnly"></detail-block>\n\n\t\t\t<!-- Employer status -->\n\t\t\t<detail-block db-details="employerDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t\t<!-- Work Patterns -->\n\t\t\t<detail-block db-details="workPatternDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t\t<!-- Sickness settings -->\n\t\t\t<detail-block db-details="sicknessSettingsDetails" ng-if="::isPayrollCompany"></detail-block>\n\n\t\t\t<!-- Calculations Settings -->\n\t\t\t<detail-block db-details="calculationSettings" ng-if="::calculationSettings && isPayrollCompany"></detail-block>\n\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/pension-settings/settings-pension-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="settings" page-title="Pension Settings"></page-template-a-header>\n\n\t\t<!-- Pension settings -->\n\t\t<div class="detail-blocks">\n\n\t\t\t<!-- Communications -->\n\t\t\t<detail-block db-details="communications" db-show-feedback="true" db-feedback-position="bottom">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small">Pension communications can be sent to an email address of your choosing for team members who don\u2019t have an email address saved in their contact details.</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\n\t\t\t<!-- Submissions -->\n\t\t\t<detail-block db-details="submissions"></detail-block>\n\n\t\t\t<!-- Sup. Runs -->\n\t\t\t<detail-block db-details="supplementaryPayRuns"></detail-block>\n\n\t\t</div>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/reports/settings-reports.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="stats" page-title="Report templates"></page-template-a-header>\n\n\t\t<section class="page-template-a-navigation">\n\t\t\t<tab-bar tab-bar-def="settingsReportsTabBarDef"></tab-bar>\n\t\t</section>\n\n\t\t<ui-view></ui-view>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/settings/roles/settings-roles.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="roles" page-title="Roles">\n\t\t\t<section class="page-template-a-main-action">\n\t\t\t\t<p>Can\'t find a pay element? Contact support</p>\n\t\t\t</section>\n\t\t</page-template-a-header>\n\n\t\t<div class="side-bar-menu_wrapper">\n\n\t\t\t<!-- Roles -->\n\t\t\t<div class="side-bar-menu_menu">\n\t\t\t\t<header class="side-bar-menu_menu-header">{{vm.roles.length}} roles</header>\n\n\t\t\t\t<div class="side-bar-item_wrapper">\n\n\t\t\t\t\t<side-bar-item heading="role.roleName" id="{{ role.roleName | slugify }}" is-active="role === vm.activeRole" ng-repeat="role in vm.roles | orderBy:\'roleOrder\'" on-click="selectRole(vm, role)" theme="is-primary">\n\t\t\t\t\t\t<side-bar-item-description>\n\n\t\t\t\t\t\t\t<ng-pluralize count="role.roleActiveActionsCount" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'1 action\',\n\t\t\t\t\t\t\t\t\t\'other\': \'{} actions\'\n\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\n\t\t\t\t\t\t</side-bar-item-description>\n\t\t\t\t\t</side-bar-item>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Selected Role -->\n\t\t\t<div class="side-bar-menu_main" ng-if="vm.activeRole">\n\t\t\t\t<header class="side-bar-menu_main-header">\n\t\t\t\t\t<h3 class="side-bar-menu_main-heading"><i class="icon-roles quarternary"></i> {{vm.activeRole.roleName}}</h3>\n\t\t\t\t\t<p class="side-bar-menu_menu-main-subheading">{{vm.activeRole.roleDescription}}</p>\n\t\t\t\t\t<a class="side-bar-menu_menu-header-action button is-primary" href="#" ng-if="vm.activeRole.showViewRoleButton && !$root.currentUser.hasTempPermissions" ng-click="openViewRoleForm(vm.activeRole)"><i class="icon-visible"></i> View role</a>\n\t\t\t\t</header>\n\n\t\t\t\t<permissions-selector role-detail="vm.activeRole" changes-count="vm.changesCount" is-valid="vm.isValid"></permissions-selector>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<full-page-controls theme="{{vm.saveState === \'saved\' ? \'is-primary\' : \'\'}}" ng-if="vm.changesCount && vm.isValid">\n\n\t<fpc-secondary ng-if="vm.saveState !== \'saved\'">\n\t\t<span class="tag primary inverse align-with-text">\n\t\t\t{{vm.changesCount}}\n\t\t</span> &nbsp;\n\t\t<span class="is-white is-small">\n\t\t\t<ng-pluralize count="vm.changesCount" when="{\n\t\t\t\t\t\'1\': \'Action changes\',\n\t\t\t\t\t\'other\': \'Actions changed\'\n\t\t\t\t}"></ng-pluralize>\n\t\t</span>\n\t</fpc-secondary>\n\n\t<fpc-tertiary ng-if="vm.saveState !== \'saved\'">\n\t\t<button class="tertiary" ng-class="{\n\t\t\t\t\'success\': vm.saveState === \'saved\'\n\t\t\t}" ng-click="openUpdateRoleModal(vm)" type="button">\n\t\t\t<i class="icon-loading {{vm.saveState === \'saving\' ? \'spin\' : \'\'}}"></i>&nbsp;Update role\n\t\t</button>\n\t</fpc-tertiary>\n\n\t<fpc-tertiary ng-if="vm.saveState === \'saved\'">\n\t\t<icon-dot class="is-inline-block" icon="icon-check" theme="is-primary is-white"></icon-dot>\n\n\t\t<span class="is-white is-small">\n\t\t\t&nbsp;&nbsp;Roles updated!\n\t\t</span>\n\t</fpc-tertiary>\n\n\t<fpc-primary ng-if="vm.saveState !== \'saved\'">\n\t\t<a href="" ng-click="clearAllChanges(vm)">\n\t\t\tClear all changes\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<!-- Modal: Update role -->\n<modal modal-options="vm.updateRoleModalOptions" ng-if="vm.updateRoleModalOptions.isOpen">\n\t<modal-body>\n\t\t<div class="modal_body-block">\n\t\t\t<h5 class="align-center">Are you sure you wish to update this role?</h5>\n\t\t</div>\n\t\t<div class="modal_body-block">\n\t\t\t<p class="align-center s">Your permission updates will be applied to all users who have been assigned this role. If you\u2019ve previously chosen to customise permissions for a user however, they won\u2019t be affected by this update.</p>\n\t\t</div>\n\t</modal-body>\n\t<modal-secondary-actions>\n\t\t<a href="" class="button" ng-click="vm.updateRoleModalOptions.isOpen = false;">Cancel</a>\n\t</modal-secondary-actions>\n\t<modal-primary-actions>\n\t\t<form name="updateRoleForm" ng-submit="updateRole(vm)" novalidate>\n\t\t\t<submit-button display-text="\'Continue\'" state="updateRoleForm.state"></submit-button>\n\t\t</form>\n\t</modal-primary-actions>\n</modal>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/currencies/settings-currencies.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="settings" page-title="Currencies"></page-template-a-header>\n\n\t\t<div class="detail-blocks">\n\n\t\t\t<detail-block db-details="vm.exchangeRates" db-show-feedback="vm.exchangeRates.feedback" db-feedback-position="top">\n\t\t\t\t<db-feedback ng-if="vm.exchangeRates.feedback">\n\t\t\t\t\t<p>{{vm.exchangeRates.feedback}}</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\t\t</div>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/customer-codes/settings-customer-codes.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="page-template-a-wrapper">\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="reference-number" page-title="Customer codes">\n\t\t\t<pt-secondary>\n\t\t\t\t<h6>\n\t\t\t\t\t{{vm.bureauCustomerCode.CompanyName}}\n\t\t\t\t</h6>\n\t\t\t\t<p class="is-small italic is-font-greyscale-300 inline" ng-if="!vm.bureauCustomerCode.CustomerCode">\n\t\t\t\t\tNo code added\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small is-font-greyscale-300 inline" ng-if="vm.bureauCustomerCode.CustomerCode">\n\t\t\t\t\t{{vm.bureauCustomerCode.CustomerCode}}\n\t\t\t\t</p>\n\t\t\t\t<a class="underline is-small inline" href="" ng-click="vm.editBureauCustomerCode(vm.bureauCustomerCode)">\n\t\t\t\t\tEdit\n\t\t\t\t</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- No Companies -->\n\t\t<placeholder placeholder-graphic="no-companies" ng-if="vm.customerCodes.all.length === 0">\n\t\t\t<placeholder-title>\n\t\t\t\tYou don\'t have any companies\n\t\t\t</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\tAs companies are added they will start to appear here.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a class="strong" href="" id="customer-codes-go-to-companies" ui-sref="companies({agencyProfileId: vm.agencyProfileId})">\n\t\t\t\t\t<i class="icon-right"></i> Go to Companies page\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<main class="page-template-a-main" ng-if="vm.customerCodes.all.length">\n\t\t\t<!-- Filter -->\n\t\t\t<filter-bar filter-bar-options="vm.filterBarOptions">\n\t\t\t</filter-bar>\n\n\t\t\t<!-- Search bar-->\n\t\t\t<search-bar action-selected="vm.searchBarActionSelected" bulk-items="vm.customerCodes" options="vm.searchBarOptions">\n\t\t\t</search-bar>\n\n\t\t\t<div class="customer-codes-cards">\n\t\t\t\t<customer-codes-card agency-profile-id="vm.agencyProfileId" customer-code="customerCode" dir-paginate="customerCode in vm.customerCodes.filtered = (\n\t\t\t\t\t\t\t\t\tvm.customerCodes.all |\n\t\t\t\t\t\t\t\t\tfilter : vm.searchBarOptions.search.string\n\t\t\t\t\t\t\t\t| \tfilter : vm.filterBarOptions.appliedFilter)\n\t\t\t\t\t\t\t\t| orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse\n\t\t\t\t\t\t\t\t| itemsPerPage : vm.searchBarOptions.results.itemsPerPage" refresh="vm.refresh">\n\t\t\t\t</customer-codes-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="!vm.customerCodes.filtered.length" search-bar-options="vm.searchBarOptions">\n\t\t\t\t</empty-search>\n\t\t\t</div>\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)">\n\t\t\t</dir-pagination-controls>\n\t\t</main>\n\t</div>\n</div>\n');
$templateCache.put('features/app/settings/upgrade/settings-upgrade.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header emoji="\uD83D\uDE80" page-title="Pay as you grow">\n\t\t\t<pt-sub-heading>\n\t\t\t\t<p>Your Paycircle subscription will scale up or down with your company - update your team or update your modules and only pay for what you use.</p>\n\t\t\t</pt-sub-heading>\n\t\t\t<pt-secondary ng-if="directDebitMandate.MandateDetails.MandateState === MANDATE_STATES.unsubmitted">\n\t\t\t\t<a href="" class="button primary" ng-click="openDirectDebitForm()">Set up Direct Debit</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<main>\n\n\t\t\t<!-- Summary -->\n\t\t\t<section class="page-template-a-section">\n\t\t\t\t<div class="pricing-plan-summary-card">\n\n\t\t\t\t\t<div class="pricing-plan-summary-card-sections">\n\n\t\t\t\t\t\t<!-- Pricing Plan -->\n\t\t\t\t\t\t<section class="pricing-plan-summary-card-section">\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-plan">\n\t\t\t\t\t\t\t\t<img alt="" class="pricing-plan-summary-card-graphic" height="220" src="images/graphics/placeholders/sme-billing-plan.2x.png">\n\t\t\t\t\t\t\t\t<h1 class="pricing-plan-summary-card-title">Pricing Plan</h1>\n\t\t\t\t\t\t\t\t<h1 class="pricing-plan-summary-card-price">{{1 | monetise}}<span>/payslip</span></h1>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-label">excl. VAT</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<!-- Included in plan -->\n\t\t\t\t\t\t<section class="pricing-plan-summary-card-section">\n\t\t\t\t\t\t\t<header class="pricing-plan-summary-card-section-header">\n\t\t\t\t\t\t\t\t<h5 class="pricing-plan-summary-card-section-title">Included in your plan</h5>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-section-subtitle" ng-if="currentCompany.TeamMemberCount > 0">Based on your current team -&nbsp;<ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 person\', \'other\': \'{} people\'}"></ng-pluralize>&nbsp;active on payroll</p>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-section-subtitle" ng-if="currentCompany.TeamMemberCount === 0">Based on your current team - 0 people active on payroll</p>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-features">\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="currentCompany.TeamMemberCount > 0">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description"><ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize></p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Nil payroll submission -->\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="currentCompany.TeamMemberCount === 0">\n\t\t\t\t\t\t\t\t\t<i class="icon-payslip pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">Minimum processing fee</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsPayrollActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-pay-periods pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">Payroll</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsPensionActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-money pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">Pension</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsCISActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-cis pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">CIS</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature" ng-if="company.Employer.IsHRActive">\n\t\t\t\t\t\t\t\t\t<i class="icon-team-alt pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">HR</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-feature">\n\t\t\t\t\t\t\t\t\t<i class="icon-mobile pricing-plan-summary-card-feature-icon"></i>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-description">User Portal</p>\n\t\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-feature-amount"><span class="tag primary inverse">Included</span></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="pricing-plan-summary-card-total">\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-total-description">Charge per payroll run <span>(excl. VAT)</span></p>\n\t\t\t\t\t\t\t\t<p class="pricing-plan-summary-card-total-amount">{{nextPayment.TotalAmount - nextPayment.VAT | monetise}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</section>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<footer class="pricing-plan-summary-card-footer">\n\t\t\t\t\t\t<div class="pricing-plan-summary-card-footer-actions" ng-if="directDebitMandate.MandateDetails.MandateState === MANDATE_STATES.unsubmitted">\n\t\t\t\t\t\t\t<span>Want&nbsp;<ng-pluralize count="nextPayment.Amount" when="{\'1\': \'1 payslip\', \'other\': \'{} payslips\'}"></ng-pluralize>&nbsp;for {{nextPayment.Amount | monetise}}?</span>\n\t\t\t\t\t\t\t<a href="" class="button primary" ng-click="openDirectDebitForm()">Set up Direct Debit</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<img alt="Powered by GoCardless" class="pricing-plan-summary-card-powered-by" src="images/graphics/powered-by-gocardless-blue@2x.png" width="150">\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\n\t\t\t</section>\n\n\t\t\t<!-- Modules -->\n\t\t\t<section class="page-template-a-section">\n\t\t\t\t<h5 class="strong">Hand picked modules for your company</h5>\n\t\t\t\t<p>Add and remove modules as you need them. Look out for new modules coming soon!</p>\n\t\t\t</section>\n\n\t\t\t<!-- Modules -->\n\t\t\t<section class="page-template-a-section">\n\t\t\t\t<div class="module-cards">\n\n\t\t\t\t\t<!-- Payroll -->\n\t\t\t\t\t<div class="module-card {{module.Theme}}" ng-class="{\'active\': module.IncludedInPlan}" ng-repeat="module in modules">\n\t\t\t\t\t\t<div class="module-card-decorator"></div>\n\t\t\t\t\t\t<i class="icon-{{module.Icon}} module-card-icon"></i>\n\t\t\t\t\t\t<p class="module-card-free" ng-if="!module.IncludedInPlan && module.IsFree">Free</p>\n\t\t\t\t\t\t<h5 class="module-card-title">{{module.Title}}</h5>\n\t\t\t\t\t\t<p class="module-card-description">{{module.Description}}</p>\n\t\t\t\t\t\t<footer class="module-card-footer" ng-switch="module.Key">\n\t\t\t\t\t\t\t<p class="module-card-state" ng-if="module.IncludedInPlan">Included in plan</p>\n\n\t\t\t\t\t\t\t<!-- Pension -->\n\t\t\t\t\t\t\t<a href="" ng-click="openModulesForm()" class="button s {{module.Theme}} module-card-action" ng-if="!module.IncludedInPlan" ng-switch-when="pension">Add to plan</a>\n\n\t\t\t\t\t\t\t<!-- CIS -->\n\t\t\t\t\t\t\t<a href="" ng-click="openModulesForm()" class="button s {{module.Theme}} module-card-action" ng-if="!module.IncludedInPlan" ng-switch-when="cis">Add to plan</a>\n\n\t\t\t\t\t\t\t<!-- Default -->\n\t\t\t\t\t\t\t<a href="" ui-sref="settings.company.modules({agencyProfileId: agencyProfileId})" class="button s {{module.Theme}} module-card-action" ng-if="!module.IncludedInPlan" ng-switch-default>Add to plan</a>\n\t\t\t\t\t\t</footer>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</main>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/workflow/settings-workflow.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Team members -->\n\t<div class="page-template-a-wrapper" ng-if="currentCompany.IsWorkflowEnabled">\n\n\t\t<page-template-a-header icon="workflow-alt" page-title="Workflow"></page-template-a-header>\n\n\t\t<section class="page-template-a-section" ng-switch="vm.workflowTemplate.State">\n\n\t\t\t<!-- Incomplete/Inactive/Complete -->\n\t\t\t<div class="workflow-summary-bar" pc-switch-when="[WORKFLOW_TEMPLATE_STATES.incomplete, WORKFLOW_TEMPLATE_STATES.inactive, WORKFLOW_TEMPLATE_STATES.complete]">\n\t\t\t\t<p class="workflow-summary-bar_status">\n\t\t\t\t\t<span class="tag tertiary workflow-summary-bar_tag">Draft</span>\n\t\t\t\t\t<strong class="workflow-summary-bar_tagline">Workflow is not active</strong>\n\t\t\t\t</p>\n\t\t\t\t<p class="s">Assign collaborators and set deadlines for sign off of each of the four stages.</p>\n\t\t\t\t<button class="button tertiary workflow-summary-bar_action" ng-class="{disabled: (vm.workflowTemplate.State !== WORKFLOW_TEMPLATE_STATES.complete && vm.workflowTemplate.State !== WORKFLOW_TEMPLATE_STATES.inactive) || !vm.dueDateSetupComplete}" ng-click="openStartWorkflowForm(vm.workflowTemplate)" tooltip tooltip-position="left" tooltip-text="Set up is complete. Click the \'Start\' button when you are ready to start collaborating!" tooltip-visible="vm.workflowTemplate.State === WORKFLOW_TEMPLATE_STATES.complete" type="button">\n\t\t\t\t\t\t<i class="icon-tick"></i>&nbsp;&nbsp;Start workflow\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t\t<!-- Active -->\n\t\t\t<div class="workflow-summary-bar" pc-switch-when="WORKFLOW_TEMPLATE_STATES.active">\n\t\t\t\t<p class="workflow-summary-bar_status">\n\t\t\t\t\t<span class="tag tertiary inverse workflow-summary-bar_tag">Live</span>\n\t\t\t\t\t<strong class="workflow-summary-bar_tagline">Workflow is active</strong>\n\t\t\t\t</p>\n\t\t\t\t<p class="s">To stop using workflow, click the &lsquo;Stop workflow&rsquo; button</p>\n\t\t\t\t<a href="" ng-click="openStopWorkflowForm(vm.workflowTemplate)" class="button tertiary workflow-summary-bar_action"><i class="icon-cross"></i>&nbsp;&nbsp;Stop workflow</a>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Workflow -->\n\t\t<section class="page-template-a-section">\n\n\t\t\t<workflow-timeline agency-profile-id="currentCompany.AgencyProfileID" on-update="refreshPage" workflow-template="vm.workflowTemplate" pay-period="vm.payPeriod"></workflow-timeline>\n\n\t\t</section>\n\n\t\t<section class="page-template-a-section" ng-if="vm.workflowTemplate.State !== WORKFLOW_TEMPLATE_STATES.active">\n\t\t\t<a href="" ng-click="openDisableWorkflowForm(vm.workflowTemplate)" class="greyscale underline s"><em>Disable workflow</em></a>\n\t\t</section>\n\t</div>\n\n\t<!-- Enable workflow -->\n\t<placeholder placeholder-graphic="workflow" ng-if="!currentCompany.IsWorkflowEnabled">\n\t\t<placeholder-title>Enable Workflow</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Work with collaborators to manage the process of running payroll. Assign responsibilities to team members and deadlines for each stage of the payroll process and activate notifications and reminders for each task assigned.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" class="button primary" ng-click="openEnableWorkflowForm(vm.workflowTemplate)">Go to set up</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/work-patterns/settings-work-patterns.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="pay-periods" page-title="Work patterns">\n\n\t\t\t<!-- Optional Secondary Menu -->\n\t\t\t<pt-secondary ng-if="featureState === \'active\'">\n\t\t\t\t<a href="" ng-click="openWorkPatternForm()" class="button primary">+ New pattern</a>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Active -->\n\t\t<main class="page-template-a-main" ng-if="featureState === \'active\'">\n\n\t\t\t<div class="work-patterns">\n\n\t\t\t\t<!-- Standard patterns -->\n\t\t\t\t<div class="work-pattern-group" ng-if="vm.workPatternsStandard.length">\n\n\t\t\t\t\t<header class="work-pattern-group-header">\n\t\t\t\t\t\t<h4>Standard patterns</h4>\n\t\t\t\t\t\t<p>These patterns can be assigned to team members set to \'Standard pattern\' in their pay information</p>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<work-pattern-card class="work-pattern-group-card" can-delete="vm.canDeleteWorkPatternsStandard" agency-profile-id="agencyProfileId" work-pattern="workPattern" on-update="init" ng-repeat="workPattern in vm.workPatternsStandard"></work-pattern-card>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Non-standard patterns -->\n\t\t\t\t<div class="work-pattern-group" ng-if="vm.workPatternsNonStandard.length">\n\n\t\t\t\t\t<header class="work-pattern-group-header">\n\t\t\t\t\t\t<h4>Non-standard patterns</h4>\n\t\t\t\t\t\t<p>These patterns can be assigned to team members set to \'Non-standard pattern\' in their pay information</p>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<work-pattern-card class="work-pattern-group-card" can-delete="vm.canDeleteWorkPatternsNonStandard" agency-profile-id="agencyProfileId" work-pattern="workPattern" on-update="init" ng-repeat="workPattern in vm.workPatternsNonStandard"></work-pattern-card>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</main>\n\n\t\t<!-- Not active -->\n\t\t<placeholder placeholder-graphic="work-patterns" ng-if="featureState === \'not-active\'">\n\t\t\t<placeholder-title>Work Patterns are not available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Work Patterns are not currently available in Live mode.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Not applicable -->\n\t\t<placeholder placeholder-graphic="work-patterns" ng-if="featureState === \'not-applicable\'">\n\t\t\t<placeholder-title>Work Patterns aren\'t available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Work patterns aren\'t available for companies with a quarterly, bi-annual or annual pay frequency.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/leavers/teamLeaversView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.leavers.all.length">\n\n\t\t<page-template-a-header icon="leavers" page-title="Leavers"></page-template-a-header>\n\n\t\t<!-- Leavers -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="vm.leavers"></search-bar>\n\n\t\t\t<!-- Team Cards -->\n\t\t\t<section class="team-cards {{searchBarOptions.layout}}">\n\t\t\t\t<team-card-leaver agency-profile-id="agencyProfileId" index="$index" team-member="leaver" on-update="refreshLeavers" pay-period="vm.currentPayPeriod" dir-paginate="leaver in vm.leavers.filtered = ( vm.leavers.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage"></team-card-leaver>\n\t\t\t</section>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.leavers.filtered.length === 0"></empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder placeholder-graphic="leavers" ng-if="!vm.leavers.all.length">\n\t\t<placeholder-title>You don\'t have any leavers yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As people leave your company they will appear here, so you can access their profiles at any time.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/members/teamView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Period in Rollback -->\n\t<div class="page-template-a-action-bar" ng-if="$root.currentPeriod.IsRollback">\n\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t</div>\n\n\t<!-- Team members -->\n\t<div class="page-template-a-wrapper" ng-if="teamMembers.all.length">\n\n\t\t<page-template-a-header icon="team-alt" ng-if="currentCompany.PAYECeaseDateISO === \'\'" page-title="Team">\n\t\t\t<pt-secondary>\n\t\t\t\t<a class="button is-primary" data-cy="import-team-members-a" ng-if="currentUser.Permissions.Team.canImportTeamData" ui-sref="data-importer.select-import-file-type({\n\t\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\t\tagencyDocumentType: DOCUMENT_TYPES.teamImport\n\t\t\t\t\t})">Import</a>\n\t\t\t\t<button class="is-primary" data-cy="add-team-member-manually" ng-click="openAddTeamMemberWizard()" ng-if="currentUser.Permissions.Team.canAddDeleteTeamMembers">\n\t\t\t\t\tAdd team member\n\t\t\t\t</button>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Team -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar apply-filter-keys="applyfilter" filter-bar-options="filterBarOptions" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar bulk-items="teamMembers" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a data-cy="bulk-earlier-year-update-action" href="" ng-click="reviewCorrectionalSubmissionTeamMembers(CORRECTIONAL_SUBMISSION_TYPES.EYU, teamMembers.filtered)" ng-if="$root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Earlier year update</a>\n\t\t\t\t\t<a data-cy="bulk-submit-earlier-fps-action" href="" ng-click="reviewCorrectionalSubmissionTeamMembers(CORRECTIONAL_SUBMISSION_TYPES.YTDFPS, teamMembers.filtered)" ng-if="$root.currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Submit Earlier Year FPS</a>\n\t\t\t\t\t<a data-cy="bulk-supplementary-run-action" href="" ng-click="reviewSupplementaryTeamMembers(teamMembers.filtered)" ng-if="$root.currentUser.Permissions.Payroll.canRunPayroll">Supplementary pay run</a>\n\t\t\t\t\t<a data-cy="bulk-mark-on-hold-action" href="" ng-click="reviewOnHoldTeamMembers(teamMembers.filtered, true)" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Mark as \u2018On hold\u2019</a>\n\t\t\t\t\t<a data-cy="bulk-advance-future-periods-action" href="" ng-click="reviewAdvanceFuturePeriodTeamMembers(teamMembers.filtered, currentPayPeriod)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly">Advance future periods</a>\n\t\t\t\t\t<a data-cy="bulk-unmark-advancing-action" href="" ng-click="reviewUnmarkAsAdvancingTeamMembers(teamMembers.filtered)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly">Unmark as \u2018Advancing\u2019</a>\n\t\t\t\t\t<a data-cy="bulk-mark-active-period-action" href="" ng-click="reviewOnHoldTeamMembers(teamMembers.filtered, false)" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Mark as \u2018Active on payroll\u2019</a>\n\t\t\t\t\t<a data-cy="bulk-manage-rolled-up-holiday-action" href="" ng-click="reviewManageRolledUpHoliday(teamMembers.filtered)" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation && $root.currentCompany.CompanyType != INTERFACE_TYPES.agency && $root.currentCompany.CompanyHolidayPolicy === COMPANY_HOLIDAY_POLICY_TYPES.none">Manage rolled up holiday</a>\n\t\t\t\t\t<a data-cy="bulk-furlough-action" href="" ng-click="openFurloughModal()">Furlough</a>\n\t\t\t\t\t<a data-cy="bulk-add-link-rate-action" href="" ng-click="openAddLinkRateForm(teamMembers.filtered)">Add link rate</a>\n\t\t\t\t\t<a data-cy="bulk-add-business-category-action" href="" ng-click="openAddToBusinessCategoryForm(teamMembers.filtered)" ng-if="::$root.currentUser.Permissions.Team.canEditCompanyDetails && hasSetupBusinessCategories">Add to business category</a>\n\t\t\t\t\t<a data-cy="bulk-invite-to-register-action" href="" ng-click="reviewTeamMembersAccountForRegistration(teamMembers.filtered)" ng-if="$root.currentUser.Permissions.Team.canInviteTeamMembersToRegister">Invite to register</a>\n\t\t\t\t\t<a data-cy="bulk-delete-team-members-action" href="" ng-click="reviewDeleteTeamMembers(teamMembers.filtered)" class="assertive" ng-if="$root.currentUser.isPaycircleAdmin">Delete team members</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t</search-bar>\n\n\t\t\t<!-- Team Cards -->\n\t\t\t<section class="team-cards" ng-class="searchBarOptions.layout" ng-if="searchBarOptions">\n\n\t\t\t\t<team-card agency-profile-id="{{agencyProfileId}}" bulk-items="teamMembers" company="company" current-page="searchBarOptions.currentPageNumber" dir-paginate="teamMember in teamMembers.filtered = (\n\t\t\t\t\t\t\tteamMembers.all |\n\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string : searchBarOptions.search.isExactMatch |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" index="$index" on-update="refreshTeam" paye-details="payeDetails" pay-period="currentPayPeriod" team-member="teamMember"></team-card>\n\t\t\t</section>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="teamMembers.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder ng-if="!teamMembers.all.length" placeholder-graphic="team">\n\t\t<placeholder-title>You don\'t have any team members set up yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>\n\t\t\t\tAs you add team members they will appear here, so you can access their profiles at any time. To add new team members, and get them ready for payroll, you may want to have things like\n\t\t\t\ttheir Date of Birth, NI Number, Address, Bank details and tax code to hand.\n\t\t\t</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions ng-if="currentCompany.PAYECeaseDateISO === \'\'">\n\t\t\t<a class="button is-primary" data-cy="import-team-members-a" ng-if="currentUser.Permissions.Team.canImportTeamData" ui-sref="data-importer.select-import-file-type({\n\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\tagencyDocumentType: DOCUMENT_TYPES.teamImport\n\t\t\t\t})">Import</a>\n\t\t\t<a class="button is-primary" data-cy="add-team-member-manually" href="" ng-click="openAddTeamMemberWizard()" ng-if="currentUser.Permissions.Team.canAddDeleteTeamMembers">Add team member</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/manager/teamManagerView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<page-template-a-header icon="team-alt" page-title="Team manager"></page-template-a-header>\n\n\t\t<main class="page-template-a-main" ng-if="vm.teamMembers.all.length">\n\n\t\t\t<search-bar options="vm.searchBarOptions" bulk-items="vm.teamMembers"></search-bar>\n\n\t\t\t<section class="team-card-basic_wrapper">\n\t\t\t\t<team-card-basic class="clickable" dir-paginate="teamMember in vm.teamMembers.filtered =\n\t\t\t\t\t\t( vm.teamMembers.all\n\t\t\t\t\t\t\t| filter : vm.searchBarOptions.search.string\n\t\t\t\t\t\t)\n\t\t\t\t\t\t| orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse\n\t\t\t\t\t\t| itemsPerPage : vm.searchBarOptions.results.itemsPerPage" is-name-clickable="true" show-email="false" team-member="teamMember" ui-sref="team.profile.information({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">\n\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t<team-member-state team-member="teamMember"></team-member-state>\n\t\t\t\t\t\t<a aria-label="Go to team member" href="" class="team-card-basic_edit" ui-sref="team.profile.information({agencyProfileId: agencyProfileId, userId:teamMember.UserID})">\n\t\t\t\t\t\t\t<i class="icon-chevron-right l greyscale"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</tc-actions>\n\t\t\t\t\t</team-card-basic>\n\t\t\t</section>\n\n\t\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.teamMembers.filtered.length === 0"></empty-search>\n\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<main class="page-template-a-main" ng-if="!vm.teamMembers.all.length">\n\n\t\t\t<placeholder placeholder-graphic="team">\n\t\t\t\t<placeholder-title>You don\'t have any team members set up yet</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>As you add team members they will appear here, so you can access their profiles at any time.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t</placeholder>\n\n\t\t</main>\n\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/moved-payrolls/teamMovedPayrollsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.teamMembers.all.length">\n\n\t\t<page-template-a-header icon="archive" page-title="Moved payrolls"></page-template-a-header>\n\n\t\t<!-- Leavers -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar options="vm.searchBarOptions" bulk-items="vm.teamMembers"></search-bar>\n\n\t\t\t<!-- Team Cards -->\n\t\t\t<section class="team-cards {{vm.searchBarOptions.layout}}">\n\t\t\t\t<team-card-archived agency-profile-id="{{vm.agencyProfileId}}" index="$index" bulk-items="vm.teamMembers" team-member="leaver" company="currentCompany" on-update="init" pay-period="vm.currentPayPeriod" dir-paginate="leaver in vm.teamMembers.filtered = ( vm.teamMembers.all | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse | itemsPerPage : vm.searchBarOptions.results.itemsPerPage"></team-card-archived>\n\t\t\t</section>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-if="vm.teamMembers.filtered.length === 0">\n\t\t\t\t<a href="" class="button action fadeIn" ng-click="vm.searchBarOptions.search.string = \'\'" ng-if="vm.searchBarOptions.search.string !== \'\'">Clear search</a>\n\t\t\t</empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder placeholder-graphic="leavers" ng-if="!vm.teamMembers.all.length">\n\t\t<placeholder-title>You don\'t have any archived team members yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>When team members are archived they will become visible here, so you can access their profiles at any time.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/people-hr-updates/team-people-hr-updates.view.html','<loading-block ng-if="pageState === \'loading\' || pageState === \'refreshing\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-show="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="remote-access" page-title="PeopleHR updates">\n\t\t\t<pt-secondary>\n\t\t\t\t<span class="tag" ng-class="{\n\t\t\t\t\t\t\'positive\': integrationStatusData.Status === PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS.active,\n\t\t\t\t\t\t\'primary inverse\': integrationStatusData.Status === PEOPLE_HR_UPDATES_EVENT_SERVICE_STATUS.paused\n\t\t\t\t\t}" ng-if="hasPeopleHr">{{integrationServiceStatusText}}</span>\n\t\t\t\t<span class="tag negative" data-cy="people-hr-updates-failed-count" ng-if="statusCounts.FailedCount">{{statusCounts.FailedCount}} failed</span>\n\t\t\t\t<span class="tag warning" data-cy="people-hr-updates-new-count" ng-if="statusCounts.NewCount">{{statusCounts.NewCount}} new</span>\n\t\t\t\t<span class="tag primary inverse" data-cy="people-hr-updates-processing-count" ng-if="statusCounts.ProcessingCount">{{statusCounts.ProcessingCount}} processing</span>\n\t\t\t\t<span class="tag" data-cy="people-hr-updates-total-count">{{statusCounts.TotalCount || 0}} total</span>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar - always shown so the date range can be widened when nothing was received in it -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t\t<!-- The search bar decorates searchBarOptions with its paging defaults on the scope it is\n\t\t\t\tcompiled in, so it and the paginated list below are hidden rather than removed, keeping\n\t\t\t\tthem on the same scope -->\n\t\t\t<search-bar bulk-items="integrationEvents" ng-show="integrationEvents.all.length" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions>\n\t\t\t\t\t<a data-cy="bulk-people-hr-updates-retry" href="" ng-click="retryUpdates()">Retry</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t\t<sb-right-actions>\n\t\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t<dropdown-menu menu-icon="icon-download" menu-id="export-people-hr-updates" menu-text="Export">\n\t\t\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t\t\t<a data-cy="export-people-hr-updates-csv" href="" ng-click="!isExporting && exportUpdates(\'csv\')">Export to CSV</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="export-people-hr-updates-excel" href="" ng-click="!isExporting && exportUpdates(\'xlsx\')">Export to Excel</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t<button class="is-white is-primary is-small" data-cy="refresh-people-hr-updates" ng-click="refreshUpdates()">\n\t\t\t\t\t\t\t\t<i class="icon-loading"></i>\n\t\t\t\t\t\t\t\tRefresh updates\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</sb-right-actions>\n\t\t\t</search-bar>\n\t\t\t<section class="people-hr-updates-card_wrapper rows" ng-show="integrationEvents.all.length">\n\n\t\t\t\t<!-- Data items -->\n\t\t\t\t<people-hr-updates-card agency-profile-id="agencyProfileId" bulk-items="integrationEvents" current-page="searchBarOptions.currentPageNumber" dir-paginate="result in integrationEvents.filtered = (\n\t\t\t\t\t\t\tintegrationEvents.all |\n\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" event-data="result" index="$index" reload-people-hr-updates-page="refreshUpdates()"></people-hr-updates-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="integrationEvents.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-show="integrationEvents.all.length" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Optional placeholder for no results -->\n\t\t<placeholder ng-if="!integrationEvents.all.length" placeholder-graphic="people-hr-updates">\n\t\t\t<placeholder-title>No updates to display</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As updates are received from PeopleHR, they will appear here. You can then review the data that was sent and retry any failed updates.</p>\n\t\t\t\t<p ng-if="hasDateRange">No updates were received in the selected date range. Change the date filter to look further back.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="is-primary" data-cy="refresh-people-hr-updates-empty" ng-click="refreshUpdates()">\n\t\t\t\t\t<i class="icon-loading"></i>\n\t\t\t\t\tRefresh updates\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Error block if there are any issues when loading data -->\n\t\t<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/team/profile/profileView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Demo task completed -->\n\t<demo-completed dc-for="editSalary,makeLeaver,editTaxCode" ng-if="$root.demoTaskComplete"></demo-completed>\n\n\t<!-- Period in Rollback -->\n\t<div class="page-template-a-action-bar" ng-if="$root.currentPeriod.IsRollback">\n\t\t<rollback-status-block pay-period="$root.currentPeriod"></rollback-status-block>\n\t</div>\n\n\t<!-- Action Bar -->\n\t<section class="page-template-a-action-bar">\n\t\t<a class="link-with-icon greyscale" ng-if="!teamMember.Company.IsLeaver && !$root.currentCompany.IsPayslipManagerActive && !(teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.Outward)" ui-sref="team.members({agencyProfileId: agencyProfileId})"><i class="icon-back"></i>Back to team</a>\n\t\t<a class="link-with-icon greyscale" ng-if="(teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.Outward)" ui-sref="team.moved-payrolls({agencyProfileId: agencyProfileId})"><i class="icon-back"></i>Back to moved payrolls</a>\n\t\t<a class="link-with-icon greyscale" ng-if="teamMember.Company.IsLeaver && !$root.currentCompany.IsPayslipManagerActive" ui-sref="team.leavers({agencyProfileId: agencyProfileId})"><i class="icon-back"></i>Back to leavers</a>\n\t\t<a class="link-with-icon greyscale" ng-if="$root.currentCompany.IsPayslipManagerActive" ui-sref="team.manager({agencyProfileId: agencyProfileId})"><i class="icon-back"></i>Back to team manager</a>\n\t</section>\n\n\t<!-- Option to cancel payroll move -->\n\t<section class="page-template-a-section" ng-if="teamMember.Company.PayrollMoveStatus === PAYROLL_MOVE_STATUSES.InwardPending">\n\t\t<notification-card theme="is-tertiary">\n\t\t\t<nc-description>\n\t\t\t\t<p class="strong is-tertiary-dark"><i class="icon-information m is-tertiary"></i>&nbsp;&nbsp;&nbsp;{{teamMember.Personal.Forename}} was moved\n\t\t\t\t\tfrom the {{teamMember.Company.PayrollMoveCompanyName}} payroll at {{teamMember.Company.PayrollMoveDateISO | dateformat:\'timeDate24\'}}</p>\n\t\t\t</nc-description>\n\t\t\t<nc-action>\n\t\t\t\t<a href="" ng-click="openCancelMovePayrollsForm(teamMember)">Cancel move</a>\n\t\t\t</nc-action>\n\t\t</notification-card>\n\t</section>\n\n\t<!-- Team Member -->\n\t<section class="page-template-a-context-block">\n\t\t<div class="team-member-overview">\n\n\t\t\t<!-- Avatar -->\n\t\t\t<avatar avatar-initial="{{teamMember.Personal.Forename[0] || teamMember.CIS.BusinessDetails.TradingName[0]}}" avatar-size="is-giant" avatar-user-id="{{teamMember.Personal.UserID}}" class="team-member-overview-avatar">\n\t\t\t</avatar>\n\n\t\t\t<!-- Name -->\n\t\t\t<h2 class="team-member-overview-name">\n\t\t\t\t<truncate text="teamMember.isCompany ? teamMember.CIS.BusinessDetails.TradingName : teamMember.Personal.Forename + \' \' + teamMember.Personal.Surname" truncate-amount="50"></truncate>\n\t\t\t</h2>\n\n\t\t\t<!-- State -->\n\t\t\t<team-member-state class="team-member-overview-state" team-member="teamMember"></team-member-state>\n\n\t\t\t<!-- Incomplete / Progress -->\n\t\t\t<div class="team-member-overview-progress" ng-if="!teamMember.TeamMemberSetupComplete && !teamMember.ExcludeFromPayroll && teamMember.IsInSetupMode">\n\t\t\t\t<span class="team-member-overview-progress-label">progress</span>\n\t\t\t\t<progress-bar pb-percentage="percentCompleted" pb-theme="is-tertiary"></progress-bar>\n\t\t\t</div>\n\n\t\t\t<!-- Actions -->\n\t\t\t<dropdown-menu class="team-member-overview-action-menu" menu-demo-id="{{$root.DEMO_TASKS.team.makeLeaver}}" menu-icon="icon-setup" menu-on-open="hasLinkedUserProfile()" menu-size="l" menu-text="Actions" ng-if="!teamMember.isArchivedEmployment && (teamMember.TeamMemberSetupComplete || teamMember.IsInSetupMode) && teamMember.Company.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.Outward">\n\n\t\t\t\t<!-- Non-PM companies only -->\n\t\t\t\t<div ng-if="!$root.currentCompany.IsPayslipManagerActive">\n\n\t\t\t\t\t<!-- PAYE -->\n\t\t\t\t\t<div class="dropdown-group" ng-if="::teamMember.TeamMemberSetupComplete && !teamMember.IsLeaver && !teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_pay-information" href="" ng-click="openPayInformationForm()" ng-if="::currentUser.Permissions.Team.canEditPayInformation">Pay information</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_supplementary-pay-run" href="" ng-click="openSupplementaryPayRunForm(teamMember)" ng-if="::teamMember.IsSupplementaryAvailable && currentUser.Permissions.Payroll.canRunPayroll">Supplementary pay run</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_sick-pay" href="" ng-click="openSickPayForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Sick pay</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_maternity-pay" href="" ng-click="openMaternityPayForm()" ng-if="::teamMember.CanAddMaternityPay && currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Maternity Pay</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_paternity-pay" href="" ng-click="openPaternityPayForm()" ng-if="::teamMember.CanAddPaternityPay && currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Paternity Pay</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_aoe" href="" ng-click="openAttachmentOfEarningsForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateStatutoryPayments">Attachment of Earnings</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_repayment-schedule" href="" ng-click="openRepaymentScheduleForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">Repayment schedule</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_company-vehicle" href="" ng-click="openCompanyVehicleForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">Company vehicle</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_healthcare" href="" ng-click="openHealthcareForm()" ng-if="::currentUser.Permissions.Payroll.canUpdateRepaymentSchedules">Healthcare</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_childcare-vouchers" href="" ng-click="openChildcareVouchersForm()" ng-if="::currentUser.Permissions.Team.canEditPayInformation">Childcare vouchers</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_mark-as-leaver" href="" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::(currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving) && !teamMember.IsInSetupMode">Mark as leaver</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_unmark-as-leaver" href="" ng-click="openUnmarkAsLeaverForm()" ng-if="::(currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving) && !teamMember.IsInSetupMode">Unmark as leaver</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_edit-leaver-information" href="" ng-click="openUpdateLeaverStatusForm(true)" ng-if="::(currentUser.Permissions.Team.canManageLeavers && teamMember.IsLeaving) && !teamMember.IsInSetupMode">Edit leaver information</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_revert-to-off-payroll" href="" ng-click="changeEmployeePayrollType(EMPLOYMENT_PAYROLL_TYPES.offPayroll, \'Revert to off-payroll worker\')" ng-if="::currentUser.Permissions.Team.canEditPayInformation && teamMember.CanSwitchToOffPayroll && $root.currentCompany.IsOffPayrollActive  && !teamMember.IsInSetupMode">Revert to off-payroll worker</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_earlier-year-update" href="" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.EYU)" ng-if="::teamMember.CanSubmitEYU && currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Earlier year update</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_submit-ytd-fps" href="" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.YTDFPS)" ng-if="::teamMember.CanSubmitYTDFPS && currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Submit Earlier Year FPS</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_change-hold-status" href="" ng-click="openOnHoldForm(teamMember)" ng-if="::currentUser.Permissions.Team.canEditPayInformation">Mark as {{teamMember.Company.IsOnHold ? "\u2018Active on payroll\u2019" : "\u2018On hold\u2019" }}</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_furlough" href="" ng-click="openFurloughForm(teamMember)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && !teamMember.Company.IsFurloughed">Furlough</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_tax-refund" href="" ng-click="openApplyTaxRefundForm(teamMember, currentPayPeriod)" ng-if="::currentUser.Permissions.Team.canEditPayInformation">{{teamMember.Tax.HasTaxRefund ? \'Delete\' : \'Apply\'}}&nbsp;tax refund</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_add_post" href="" ng-click="openAdditionalPostForm(currentPayPeriod)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && teamMember.Salary.EmploymentType === EMPLOYMENT_TYPES.payPolicy">Add post</a>\n\t\t\t\t\t\t<a href="" ng-click="openAdvanceFuturePeriodsForm(currentPayPeriod)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly && teamMember.CanAdvanceFuturePeriods" data-cy="team-member_action-advance-future-periods">Advance future periods</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-advance-future-periods" href="" ng-click="openUnmarkAsAdvancingForm()" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly && teamMember.IsAdvancingFuturePeriods">Unmark as &lsquo;Advancing&rsquo;</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- CIS -->\n\t\t\t\t\t<div class="dropdown-group" ng-if="::teamMember.TeamMemberSetupComplete && !teamMember.IsLeaver && teamMember.Company.IsCISSubcontractor">\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_mark-as-leaver" href="" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::(currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving)">Mark as leaver</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_reverify" href="" ng-click="openCISVerificationForm(true)">Re-verify</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Leavers -->\n\t\t\t\t\t<div class="dropdown-group" ng-if="::!teamMember.IsInSetupMode && teamMember.IsLeaver">\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_unmark-as-leaver" href="" ng-click="openUnmarkAsLeaverForm()" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers && teamMember.Company.IsLeaverManuallySet && !teamMember.Company.IsCISSubcontractor">Unmark as Leaver</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_edit-leave-date" href="" ng-click="openUpdateLeaverStatusForm(true)" ng-if="::$root.currentUser.Permissions.Team.canManageLeavers">Edit leaver information</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_payment-after-leaving" href="" ng-click="openPaymentAfterLeavingForm(currentPayPeriod)" ng-if="::currentUser.Permissions.Payroll.canUpdateAdjustments && !teamMember.IsCISSubcontractor">Payment after leaving</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_generate-p45" href="" ng-click="openGenerateP45Form()" ng-if="::!teamMember.Tax.IsP45Generated">Generate P45</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_earlier-year-update" href="" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.EYU)" ng-if="teamMember.CanSubmitEYU && currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Earlier year update</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_submit-ytd-fps" href="" ng-click="openCorrectionalSubmissionForm(CORRECTIONAL_SUBMISSION_TYPES.YTDFPS)" ng-if="::teamMember.CanSubmitYTDFPS && currentUser.Permissions.Payroll.canMakePreviousYearUpdates">Submit Earlier Year FPS</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_rejoin-leaver" href="" ng-click="openRejoinLeaverForm()" ng-if="::currentUser.Permissions.Team.canManageLeavers && !currentPayPeriod.IsRunRollback && (!teamMember.Company.IsLeaverManuallySet || teamMember.Company.IsCISSubcontractor)">Rejoin leaver</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_leaver-made-in-error" href="" ng-click="openLeaverMadeInErrorForm()" ng-if="::currentUser.Permissions.Team.canManageLeavers && !teamMember.CanUpdateLeaveStatus">Leaver made in error</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Not in setup mode -->\n\t\t\t\t\t<div class="dropdown-group" ng-if="::!teamMember.IsInSetupMode">\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_rti-submission" href="" ng-click="openRtiSubmissionForm(teamMember)" ng-if="teamMember.Company.IsExcludedFromRTI">\n\t\t\t\t\t\t\tInclude in RTI submissions\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_revert-to-off-payroll" href="" ng-click="changeEmployeePayrollType(EMPLOYMENT_PAYROLL_TYPES.offPayroll, \'Revert to off-payroll worker\')" ng-if="::currentUser.Permissions.Team.canEditPayInformation && teamMember.CanSwitchToOffPayroll && $root.currentCompany.IsOffPayrollActive">Revert to off-payroll worker</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_unlink-access-account" href="" ng-click="openUnlinkAccessAccountForm()" ng-if="canManageAccounts && linkedUserProfile">Unlink Access account</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_invite-to-register" href="" ng-click="openInviteToRegisterForm()" ng-if="::!teamMember.Company.IsRegistered && currentUser.Permissions.Team.canInviteTeamMembersToRegister">Invite to register</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_unregister" href="" ng-click="openUnregisterUserForm()" ng-if="::teamMember.Company.IsRegistered && currentUser.Permissions.Team.canInviteTeamMembersToRegister">Unregister</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-remove-admin-access" href="" ng-click="openRemoveAdminAccessForm()" ng-if="::teamMember.Company.IsAdmin && teamMember.Company.IsRegistered && currentUser.Permissions.CompanySettings.canAccessPermissions">Remove admin access</a>\n\t\t\t\t\t\t<a data-cy="team-member_action-menu_move-payrolls" href="" ng-click="openMovePayrollsForm()" ng-if="::currentUser.Permissions.Team.canAddDeleteTeamMembers">Move payrolls</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is Off Payroll and 100% complete -->\n\t\t\t\t<div class="dropdown-group" ng-if="::teamMember.Company.IsOffPayrollWorker && teamMember.TeamMemberSetupComplete">\n\t\t\t\t\t<a data-cy="team-member_action-menu_change-hold-status" href="" ng-click="openOnHoldForm(teamMember)" ng-if="::currentUser.Permissions.Team.canEditPayInformation">Mark as {{teamMember.Company.IsOnHold ? "\u2018Active on payroll\u2019" : "\u2018On hold\u2019" }}</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_mark-as-leaver" href="" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::(currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving)">Mark as leaver</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_change-to-employee" href="" ng-click="changeEmployeePayrollType(EMPLOYMENT_PAYROLL_TYPES.paye, \'Change to employee\')" ng-if="::currentUser.Permissions.Team.canEditPayInformation">Change to employee</a>\n\t\t\t\t\t<a href="" ng-click="openAdvanceFuturePeriodsForm(currentPayPeriod)" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly && teamMember.CanAdvanceFuturePeriods" data-cy="team-member_action-advance-future-periods">Advance future periods</a>\n\t\t\t\t\t<a data-cy="team-member_action-advance-future-periods" href="" ng-click="openUnmarkAsAdvancingForm()" ng-if="::currentUser.Permissions.Team.canEditPayInformation && currentPayPeriod.PayPeriodType === PAY_PERIOD_TYPES.weekly && teamMember.IsAdvancingFuturePeriods">Unmark as &lsquo;Advancing&rsquo;</a>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- In setup mode -->\n\t\t\t\t<div class="dropdown-group" ng-if="::teamMember.IsInSetupMode || $root.currentCompany.IsPayslipManagerActive">\n\t\t\t\t\t<a data-cy="team-member_action-menu_cancel-rejoin-leaver" href="" ng-click="openCancelRejoinLeaver()" ng-if="::currentUser.Permissions.Team.canManageLeavers && teamMember.Company.IsRestarter">Cancel rejoin leaver</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_rti-submission" href="" ng-click="openRtiSubmissionForm(teamMember)" ng-if="teamMember.CanSwitchToOmitFromRTI && teamMember.IsInRetrospectivePayrollSetupMode">\n\t\t\t\t\t\tOmit from RTI submissions\n\t\t\t\t\t</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_revert-to-off-payroll" href="" ng-click="changeEmployeePayrollType(EMPLOYMENT_PAYROLL_TYPES.offPayroll, \'Revert to off-payroll worker\')" ng-if="::currentUser.Permissions.Team.canEditPayInformation && teamMember.CanSwitchToOffPayroll && $root.currentCompany.IsOffPayrollActive">Revert to off-payroll worker</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_unlink-access-account" href="" ng-click="openUnlinkAccessAccountForm()" ng-if="canManageAccounts && linkedUserProfile">Unlink Access account</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_invite-to-register" href="" ng-click="openInviteToRegisterForm()" ng-if="::!teamMember.Company.IsRegistered && currentUser.Permissions.Team.canInviteTeamMembersToRegister">Invite to register</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_unregister" href="" ng-click="openUnregisterUserForm()" ng-if="::teamMember.Company.IsRegistered && currentUser.Permissions.Team.canInviteTeamMembersToRegister">Unregister</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_mark-as-leaver" href="" ng-click="openUpdateLeaverStatusForm(false)" ng-if="::currentUser.Permissions.Team.canManageLeavers && !teamMember.IsLeaving && !teamMember.IsLeaver && !$root.currentCompany.IsPayslipManagerActive && !teamMember.Company.IsOffPayrollWorker && !teamMember.Company.IsCISSubcontractor">Mark as leaver</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_unmark-as-leaver" href="" ng-click="openUnmarkAsLeaverForm()" ng-if="::currentUser.Permissions.Team.canManageLeavers && (teamMember.IsLeaving || teamMember.IsLeaver) && !$root.currentCompany.IsPayslipManagerActive">Unmark as Leaver</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_edit-leaver-information" href="" ng-click="openUpdateLeaverStatusForm(true)" ng-if="::currentUser.Permissions.Team.canManageLeavers && (teamMember.IsLeaving || teamMember.IsLeaver) && !$root.currentCompany.IsPayslipManagerActive">Edit leaver information</a>\n\t\t\t\t\t<a data-cy="team-member_action-menu_remove-from-team" href="" ng-click="openChangeAdminStateForm(true)" ng-if="::teamMember.Company.IsAdmin && currentUser.Permissions.CompanySettings.canAccessPermissions && !$root.currentCompany.IsPayslipManagerActive">Remove from team</a>\n\t\t\t\t\t<a class="assertive" data-cy="team-member_action-menu_delete-team-member" href="" ng-click="openDeleteTeamMemberForm()" ng-if="::!teamMember.Company.IsAdmin && !teamMember.Company.IsRestarter && !teamMember.Company.isMovingPayrollsInwardPending && currentUser.Permissions.Team.canAddDeleteTeamMembers && !$root.currentCompany.IsPayslipManagerActive">Delete team member</a>\n\t\t\t\t\t<a class="assertive" data-cy="team-member_action-menu_delete-team-member" href="" ng-click="openDeleteTeamMemberForm(true)" ng-if="::currentUser.Permissions.Team.canAddDeleteTeamMembers && $root.currentCompany.IsPayslipManagerActive">Delete team member</a>\n\t\t\t\t</div>\n\n\t\t\t</dropdown-menu>\n\t\t</div>\n\t</section>\n\n\t<!-- Tabs -->\n\t<section class="page-template-a-navigation">\n\t\t<tab-bar tab-bar-def="teamProfileTabBarDef"></tab-bar>\n\t</section>\n\n\t<main class="page-template-a-main" ui-view></main>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/rotaready-updates/team-rotaready-updates.view.html','<loading-block ng-if="pageState === \'loading\' || pageState === \'refreshing\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-show="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="remote-access" page-title="Rotaready updates">\n\t\t\t<pt-secondary>\n\t\t\t\t<span class="tag" ng-class="{\n\t\t\t\t\t\t\'positive\': integrationStatusData.Status === ROTAREADY_UPDATES_EVENT_SERVICE_STATUS.active,\n\t\t\t\t\t\t\'primary inverse\': integrationStatusData.Status === ROTAREADY_UPDATES_EVENT_SERVICE_STATUS.paused\n\t\t\t\t\t}">{{integrationServiceStatusText}}</span>\n\t\t\t\t<span>Rotaready updates {{integrationServiceStatusText}}</span>\n\t\t\t</pt-secondary>\n\t\t</page-template-a-header>\n\n\t\t<!-- Critical events banner -->\n\t\t<div class="page-template-a-action-bar" ng-if="criticalEventsCount > 0 && updatesViewMode !== \'grouped\'">\n\t\t\t<notification-card icon="warning" theme="is-assertive">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<ng-pluralize count="criticalEventsCount" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 critical alert needs\',\n\t\t\t\t\t\t\t\t\'other\': \'{} critical alerts need\'\n\t\t\t\t\t\t\t}"></ng-pluralize>&nbsp;to be dismissed before you can run payroll\n\t\t\t\t\t</p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a data-cy="rotaready-updates-view-critical-events" href="" ng-click="applyCriticalFilter()">\n\t\t\t\t\t\tView alerts\n\t\t\t\t\t</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\t\t</div>\n\n\t\t<!-- Grouped events banner -->\n\t\t<div class="page-template-a-action-bar" ng-if="isGroupedUpdatesEnabled && isGroupedUpdatesAvailable">\n\t\t\t<notification-card icon="information">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p ng-if="updatesViewMode !== \'grouped\'">\n\t\t\t\t\t\t{{filteredGroupedEventsCount}} of {{filteredEventsCount}} updates contain {{filteredUniqueGroupsCount}} unique issues\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-if="updatesViewMode === \'grouped\'">\n\t\t\t\t\t\tShowing {{filteredUniqueGroupsCount}} unique issues across {{filteredGroupedEventsCount}} of {{filteredEventsCount}} updates\n\t\t\t\t\t</p>\n\t\t\t\t</nc-description>\n\t\t\t\t<nc-action>\n\t\t\t\t\t<a data-cy="toggle-rotaready-updates-view" href="" ng-click="toggleUpdatesViewMode()">\n\t\t\t\t\t\t{{updatesViewMode === \'grouped\' ? \'View all updates\' : \'View unique issues\'}}\n\t\t\t\t\t</a>\n\t\t\t\t</nc-action>\n\t\t\t</notification-card>\n\t\t</div>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar - always shown so the date range can be widened when nothing was received in it -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t\t<!-- The search bar decorates searchBarOptions with its paging defaults on the scope it is\n\t\t\t\tcompiled in, so it and the paginated list below are hidden rather than removed, keeping\n\t\t\t\tthem on the same scope -->\n\t\t\t<search-bar bulk-items="integrationEvents" ng-show="integrationEvents.all.length" options="searchBarOptions">\n\t\t\t\t<sb-bulk-actions ng-if="updatesViewMode !== \'grouped\'">\n\t\t\t\t\t<a data-cy="bulk-rotaready-updates-retry" href="" ng-click="retryUpdates()">Retry</a>\n\t\t\t\t\t<a data-cy="bulk-rotaready-updates-dismiss" href="" ng-click="dismissUpdates()" ng-if="hasOnlyCriticalEventsSelected()">Dismiss</a>\n\t\t\t\t</sb-bulk-actions>\n\t\t\t\t<sb-right-actions>\n\t\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t<dropdown-menu menu-icon="icon-download" menu-id="export-rotaready-updates" menu-text="Export">\n\t\t\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t\t\t<a data-cy="export-rotaready-updates-csv" href="" ng-click="!isExporting && exportUpdates(\'csv\')">Export to CSV</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="export-rotaready-updates-excel" href="" ng-click="!isExporting && exportUpdates(\'xlsx\')">Export to Excel</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t<button class="is-white is-primary is-small" data-cy="refresh-rotaready-updates" ng-click="refreshUpdates()">\n\t\t\t\t\t\t\t\t<i class="icon-loading"></i>\n\t\t\t\t\t\t\t\tRefresh updates\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</sb-right-actions>\n\t\t\t</search-bar>\n\t\t\t<section class="rotaready-updates-card_wrapper rows" ng-if="integrationEvents.all.length && updatesViewMode !== \'grouped\'">\n\n\t\t\t\t<!-- Data items -->\n\t\t\t\t<rotaready-updates-card agency-profile-id="agencyProfileId" current-page="searchBarOptions.currentPageNumber" data-cy="rotaready-updates-card-{{$index}}" dir-paginate="result in integrationEvents.filtered = (\n\t\t\t\t\t\t\tintegrationEvents.all |\n\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" event-data="result" index="$index" on-checkbox-toggle="onCheckboxToggle()" reload-rotaready-updates-page="refreshUpdates()"></rotaready-updates-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="integrationEvents.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t\t\t</section>\n\n\t\t\t<section class="rotaready-updates-card_wrapper rows" ng-if="integrationEvents.all.length && updatesViewMode === \'grouped\'">\n\n\t\t\t\t<!-- Grouped data items -->\n\t\t\t\t<rotaready-updates-grouped-card agency-profile-id="agencyProfileId" current-page="searchBarOptions.currentPageNumber" data-cy="rotaready-updates-grouped-card-{{$index}}" dir-paginate="result in integrationEvents.filtered = (\n\t\t\t\t\t\t\tintegrationEvents.all |\n\t\t\t\t\t\t\tfilterBy : searchBarOptions.search.filterOption.filterKeys : searchBarOptions.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\ttrack by $index\n\t\t\t\t\t" event-data="result" index="$index"></rotaready-updates-grouped-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="integrationEvents.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" ng-show="integrationEvents.all.length" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\n\t\t<!-- Placeholder for no results -->\n\t\t<placeholder ng-if="!integrationEvents.all.length" placeholder-graphic="people-hr-updates">\n\t\t\t<placeholder-title>No updates to display</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As updates are received from Rotaready, they will appear here. You can then review the data that was sent and retry any failed updates.</p>\n\t\t\t\t<p ng-if="hasDateRange">No updates were received in the selected date range. Change the date filter to look further back.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<button class="is-primary" data-cy="refresh-rotaready-updates-empty" ng-click="refreshUpdates()">\n\t\t\t\t\t<i class="icon-loading"></i>\n\t\t\t\t\tRefresh updates\n\t\t\t\t</button>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<!-- Error block if there are any issues when loading data -->\n\t\t<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/team/imports/teamImportsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.importGroups.length">\n\n\t\t<!-- Page Title / Header -->\n\t\t<page-template-a-header icon="upload" page-title="Imports"></page-template-a-header>\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search bar -->\n\t\t\t<search-bar options="vm.searchBarOptions" count="vm.importGroupsFiltered.length"></search-bar>\n\n\t\t\t<!-- Import Cards -->\n\t\t\t<div class="import-history-item_wrapper">\n\t\t\t\t<import-history-item agency-profile-id="agencyProfileId" import="import" on-update="refreshPage()" pay-period="vm.payPeriod" dir-paginate="import in vm.importGroupsFiltered = ( vm.importGroups | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse | itemsPerPage : vm.searchBarOptions.results.itemsPerPage" current-page="vm.searchBarOptions.currentPageNumber"></import-history-item>\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.importGroupsFiltered.length === 0"></empty-search>\n\t\t</main>\n\n\t\t<!-- Powered by Paycircle -->\n\t\t<powered-by-paycircle></powered-by-paycircle>\n\t</div>\n\n\t<!-- No imports -->\n\t<placeholder placeholder-graphic="import" ng-if="!vm.importGroups.length">\n\t\t<placeholder-title>You don\'t have any imports to show yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you import data it will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/workflow/companies/workflow-companies.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main">\n\n\t<div ng-if="vm.workflowTasks.all.length">\n\n\t\t<filter-bar filter-bar-options="filterBarOptions" apply-filter-keys="applyFilter"></filter-bar>\n\n\t\t<search-bar options="searchBarOptions" bulk-items="vm.workflowTasks">\n\t\t\t<sb-bulk-actions>\n\t\t\t\t<a href="" ng-click="openReassignWorkflowTaskForm(vm.workflowTasks.filtered)">Re-assign</a>\n\t\t\t</sb-bulk-actions>\n\t\t</search-bar>\n\n\t\t<div class="workflow-task-card_wrapper">\n\t\t\t<workflow-task-card task="workflowTask" show-team-member="true" index="$index" refresh-tasks="refreshView()" bulk-items="vm.workflowTasks" ng-repeat="workflowTask in vm.workflowTasks.filtered = ( vm.workflowTasks.all | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse )"></workflow-task-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.workflowTasks.filtered.length === 0"></empty-search>\n\t</div>\n\n\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="pageState === \'ready\' && !vm.workflowTasks.all.length">\n\t\t<placeholder-title>No companies to show</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As workflow tasks are created, for companies with it enabled, they will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</main>\n');
$templateCache.put('features/app/workflow/overview/workflow-overview.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="workflow-overview" ng-if="pageState === \'ready\'">\n\n\t<div class="workflow-overview-task-summary-card-block">\n\t\t<div class="workflow-overview-task-summary-cards">\n\t\t\t<workflow-task-summary-card total-count="vm.workflowOverview.OverdueCount" team-count="vm.workflowOverview.OverdueWithTeamCount" client-count="vm.workflowOverview.OverdueWithClientCount" status="Overdue" card-style="assertive" target-state="workflow.companies" filter-key="workflow-tasks-status-overdue" team-member-count="vm.teamMemberAdminCount"></workflow-task-summary-card>\n\t\t\t<workflow-task-summary-card total-count="vm.workflowOverview.TodayCount" team-count="vm.workflowOverview.TodayWithTeamCount" client-count="vm.workflowOverview.TodayWithClientCount" status="Due today" card-style="secondary" target-state="workflow.companies" filter-key="workflow-tasks-status-due-today" team-member-count="vm.teamMemberAdminCount"></workflow-task-summary-card>\n\t\t\t<workflow-task-summary-card total-count="vm.workflowOverview.NextTwoDaysCount" team-count="vm.workflowOverview.NextTwoDaysWithTeamCount" client-count="vm.workflowOverview.NextTwoDaysWithClientCount" status="Due in next 2 days" card-style="secondary" target-state="workflow.companies" filter-key="workflow-tasks-status-due-within-two-days" team-member-count="vm.teamMemberAdminCount"></workflow-task-summary-card>\n\t\t\t<workflow-task-summary-card class="is-indifferent" icon="icon-undo" total-count="vm.workflowOverview.QueryCount" status="Queried" target-state="workflow.companies" filter-key="workflow-tasks-status-queried"></workflow-task-summary-card>\n\t\t</div>\n\t</div>\n\n\t<div class="task-blocks">\n\n\t\t<!-- Due Next -->\n\t\t<div class="task-block">\n\t\t\t<header class="task-block-header">\n\t\t\t\t<h5>Due next</h5>\n\t\t\t\t<a ui-sref="workflow.companies({agencyProfileId: vm.agencyProfileId})" class="task-block-header-action">View all</a>\n\t\t\t</header>\n\t\t\t<main class="task-block-main is-scrollable">\n\t\t\t\t<workflow-tasks-list workflow-tasks="vm.workflowOverview.DueList" ng-if="vm.workflowOverview.DueList.length"></workflow-tasks-list>\n\t\t\t\t<div class="workflow-overview_empty-message" ng-if="!vm.workflowOverview.DueList.length">\n\t\t\t\t\t<i class="icon-information primary xl"></i>\n\t\t\t\t\t<h6 class="workflow-overview_empty-message-header">No workflows due</h6>\n\t\t\t\t\t<p class="s">Once you start workflow for the companies with it enabled, you\'ll see the active step for each of them here.</p>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t\t<!-- Recent activity -->\n\t\t<div class="task-block">\n\t\t\t<header class="task-block-header">\n\t\t\t\t<h5>Recent activity</h5>\n\t\t\t\t<a ui-sref="workflow.activity({agencyProfileId: vm.agencyProfileId})" class="task-block-header-action">View all</a>\n\t\t\t</header>\n\t\t\t<main class="task-block-main is-scrollable">\n\t\t\t\t<workflow-activity-log log-list="vm.workflowOverview.LogList" ng-if="vm.workflowOverview.LogList.length"></workflow-activity-log>\n\t\t\t\t<div class="workflow-overview_empty-message" ng-if="!vm.workflowOverview.LogList.length">\n\t\t\t\t\t<i class="icon-information primary xl"></i>\n\t\t\t\t\t<h6 class="workflow-overview_empty-message-header">No activity to show</h6>\n\t\t\t\t\t<p class="s">Once you start enabling workflow for companies, you will start to see activity appear here.</p>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t</div>\n\n</div>');
$templateCache.put('features/app/workflow/activity/workflow-activity.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main" ng-if="pageState === \'ready\'">\n\n\t<div ng-if="vm.workflowActivityLogEntries.all.length">\n\t\t<search-bar options="searchBarOptions" bulk-items="vm.workflowActivityLogEntries"></search-bar>\n\t\t<workflow-activity-log search-bar-options="searchBarOptions" log-list="vm.workflowActivityLogEntries" wide-view="true"></workflow-activity-log>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.workflowActivityLogEntries.filtered.length === 0"></empty-search>\n\t</div>\n\n\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="pageState === \'ready\' && !vm.workflowActivityLogEntries.all.length">\n\t\t<placeholder-title>No activity to show</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As workflow activity begins, for companies with it enabled, it will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</main>');
$templateCache.put('features/app/workplace-pension/tabs/workplacePensionSupportView.html','<div class="sub-page-template-a fadeIn">\n\n\t<header class="sub-page-template-a-header">\n\t\t<h4>Useful links and articles</h4>\n\t\t<p>Here are some helpful guides and articles to support you in the set up and management of your workplace pension.</p>\n\t</header>\n\n\t<main class="sub-page-template-a-main">\n\n\t\t<ul class="faqs">\n\t\t\t<li class="faq"><support-article-link article-key="$root.URLS.paycircle.support.whoIsEligibleForAe"><i class="icon-right"></i> Who is eligible for auto enrolment?</support-article-link></li>\n\t\t\t<li class="faq"><support-article-link article-key="$root.URLS.paycircle.support.whatAreTheContributions"><i class="icon-right"></i> Auto enrolment \u2013 what are the contributions?</support-article-link></li>\n\t\t\t<li class="faq"><support-article-link article-key="$root.URLS.paycircle.support.howDoIPostpone"><i class="icon-right"></i> How do I postpone my Start Date?</support-article-link></li>\n\t\t\t<li class="faq"><support-article-link article-key="$root.URLS.paycircle.support.whatToSendAndWhen"><i class="icon-right"></i> Pension communications \u2013 what to send and when to send them</support-article-link></li>\n\t\t\t<li class="faq"><support-article-link article-key="$root.URLS.paycircle.support.whatIsADOC"><i class="icon-right"></i> What is a Declaration of Compliance?</support-article-link></li>\n\t\t</ul>\n\n\t\t<div class="spacer xl"></div>\n\n\t\t<h4>User Guides</h4>\n\t\t<div class="spacer m"></div>\n\t\t<div class="user-guides pairs cf">\n\t\t\t<user-guide-card guide-id="setupPensionInformation"></user-guide-card>\n\t\t\t<user-guide-card guide-id="employerResponsibilities"></user-guide-card>\n\t\t\t<user-guide-card guide-id="ensuringCompliancy"></user-guide-card>\n\t\t\t<user-guide-card guide-id="tenStepsToSetupPension"></user-guide-card>\n\t\t</div>\n\t</main>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n');
$templateCache.put('features/shared/auth/SSO/sso-register-user.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n<split-pane ng-if="pageState === \'ready\'" sp-left-theme="is-centered" sp-template="{{customisation.IsDefault ? \'paycircle\' : \'customisation\'}}">\n\t<sp-left>\n\t\t<div class="split-pane-left-container">\n\t\t\t<header ng-if="contentState === \'request-registration\' || contentState === \'confirm-signout\'" class="split-pane-left_header">\n\t\t\t\t<h2 ng-if="contentState === \'request-registration\'" class="split-pane-left_title">SSO is no longer available in Paycircle</h2>\n\t\t\t\t<h2 ng-if="contentState === \'confirm-signout\'" class="split-pane-left_title">Your request to register has been processed</h2>\n\t\t\t</header>\n\n\t\t\t<div class="split-pane-left_additional-info">\n\t\t\t\t<div ng-if="contentState === \'request-registration\'">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSingle sign-on (SSO) is no longer available in Paycircle, as we\'ve changed the way you need to sign in.\n\t\t\t\t\t\t<br>You\'ll now need to do so using the Access Identity platform.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTo migrate your account to Access Identity, we first need you to fully register for Paycircle.\n\t\t\t\t\t\t<br>Once registered, you will then be able to use SSO with Access Identity.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tClick \u2018Register for Paycircle\u2019 and we\u2019ll send a registration link to your inbox.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIf you\u2019re unsure about anything, we recommend reviewing the articles below in our knowledge base before proceeding.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class="spacer l"></div>\n\n\t\t\t\t\t<access-info-links show-overview-link="true" for-sso="true"></access-info-links>\n\n\t\t\t\t\t<div class="spacer m"></div>\n\n\t\t\t\t\t<button class="is-tertiary" type="button" ng-click="requestRegistration()">Register For Paycircle</button>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="contentState === \'confirm-signout\'">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAn email has been sent to your inbox with a link to register for Paycircle and complete your migration to Access identity.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t<p class="is-font-greyscale-500">\n\t\t\t\t\t\tYour verification code is:\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\t<strong class="is-large">{{registrationCode}}</strong>\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPlease save this code, as you will need it to complete registration.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tClick \u2018Confirm\u2019 to sign out of Paycircle then click the registration link in your inbox to continue. Check your spam folder if you can\u2019t see the email.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t<button class="is-tertiary" type="button" ng-click="confirmSignout()">Confirm</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<error-block ng-if="contentState === \'error\'"></error-block>\n\t</sp-left>\n</split-pane>\n\n');
$templateCache.put('features/shared/help-and-support/article/helpAndSupportArticleView.html','<loading-block size="xl" ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Main -->\n<main class="page-template-e_main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Breadcrumb -->\n\t<div class="page-template-e_section">\n\t\t<p class="s"><a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})">Help and Support</a> > {{::vm.category.name}}</p>\n\t</div>\n\n\t<!-- Article -->\n\t<div class="page-template-e_section">\n\t\t<support-article article="vm.article"></support-article>\n\t</div>\n\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/shared/help-and-support/category/helpAndSupportCategoryView.html','<loading-block size="xl" ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Main -->\n<main class="page-template-e_main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Breadcrumb -->\n\t<div class="page-template-e_section">\n\t\t<p class="s"><a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})">Help and Support</a> > {{::vm.category.name}}</p>\n\t</div>\n\n\t<!-- Title -->\n\t<div class="page-template-e_section">\n\t\t<h3>{{::vm.category.name}} <small>({{vm.totalArticleCount}}&nbsp;<ng-pluralize count="vm.totalArticleCount" when="{\'1\': \'article\', \'other\': \'articles\'}"></ng-pluralize>)</small></h3>\n\t</div>\n\n\t<!-- Categories -->\n\t<div class="page-template-e_section">\n\n\t\t<div class="support-categories" ng-show="vm.categoriesFiltered.length > 0">\n\t\t\t<div class="support-category-card is-primary" ng-repeat="category in vm.categoriesFiltered = (vm.categories | filter: {parent: vm.categoryId})">\n\n\t\t\t\t<div class="support-category-card_header">\n\t\t\t\t\t<span class="badge support-category-card_header-badge" ng-class="category.acf.category_theme"><i ng-class="category.acf.category_icon"></i></span>\n\t\t\t\t\t<h5 class="support-category-card_header-name" ng-bind-html="category.name">{{category.name | truncate:30}}</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="support-category-card_main">\n\n\t\t\t\t\t<!-- Sub Categories -->\n\t\t\t\t\t<div class="support-category-card_sub-categories" ng-show="category.subCategories.length > 0">\n\t\t\t\t\t\t<p class="support-category-card_sub-category" ng-repeat="subCategory in category.subCategories = (vm.categories | filter: {parent: category.id})">\n\t\t\t\t\t\t\t<a ui-sref="help-and-support.category-list({categoryId: subCategory.id})" class="support-category-card_sub-category-action">\n\t\t\t\t\t\t\t\t<i class="icon-right support-category-card_sub-category-icon"></i>\n\t\t\t\t\t\t\t\t<span class="support-category-card_sub-category-name">{{subCategory.name}}</span>\n\t\t\t\t\t\t\t\t<em class="support-category-card_sub-category-meta">({{subCategory.count}}&nbsp;<ng-pluralize count="subCategory.count" when="{\'1\': \'article\', \'other\': \'articles\'}"></ng-pluralize>)</em>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Articles -->\n\t\t\t\t\t<div class="support-category-card_articles" ng-show="category.subCategories.length === 0">\n\t\t\t\t\t\t<p class="s support-category-card_article-description">{{category.description}}</p>\n\t\t\t\t\t\t<div class="support-category-card_article-action">\n\t\t\t\t\t\t\t<a ui-sref="help-and-support.category-list({categoryId: category.id})"><i class="icon-right"></i>&nbsp;&nbsp;{{category.count}}&nbsp;<ng-pluralize count="category.count" when="{\'1\': \'article\', \'other\': \'articles\'}"></ng-pluralize></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No categories -->\n\t\t<empty-search ng-show="vm.categoriesFiltered.length === 0">\n\t\t\t<a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})" class="action fadeIn">Back to Help and Support</a>\n\t\t</empty-search>\n\t</div>\n\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/shared/help-and-support/category-list/helpAndSupportCategoryListView.html','<loading-block size="xl" ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Main -->\n<main class="page-template-e_main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Breadcrumb -->\n\t<div class="page-template-e_section">\n\t\t<p class="s"><a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})">Help and Support</a> > {{::vm.category.name}}</p>\n\t</div>\n\n\t<!-- Title -->\n\t<div class="page-template-e_section">\n\t\t<h3>{{::vm.category.name}} <small>({{vm.category.count}}&nbsp;<ng-pluralize count="vm.category.count" when="{\'1\': \'article\', \'other\': \'articles\'}"></ng-pluralize>)</small></h3>\n\t</div>\n\n\t<!-- Articles -->\n\t<div class="page-template-e_section">\n\t\t<div class="support-articles">\n\t\t\t<support-article-card agency-profile-id="vm.agencyProfileId" article="article" ng-repeat="article in vm.articles"></support-article-card>\n\t\t</div>\n\t</div>\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/shared/help-and-support/search-results/helpAndSupportSearchResultsView.html','<loading-block size="xl" ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Main -->\n<main class="page-template-e_main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Breadcrumb -->\n\t<div class="page-template-e_section">\n\t\t<p class="s"><a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})" class="icon-link"><i class="icon-back"></i>Help and Support</a></p>\n\t</div>\n\n\t<!-- Title -->\n\t<div class="page-template-e_section">\n\t\t<h3><ng-pluralize count="vm.articles.length" when="{\'1\': \'1 result\', \'other\': \'{} results\'}"></ng-pluralize> found for &lsquo;{{::vm.searchTerm}}&rsquo;</h3>\n\t</div>\n\n\t<!-- Articles -->\n\t<div class="page-template-e_section">\n\n\t\t<!-- Articles -->\n\t\t<div class="support-articles" ng-if="vm.articles.length">\n\t\t\t<support-article-card agency-profile-id="vm.agencyProfileId" article="article" ng-repeat="article in vm.articles"></support-article-card>\n\t\t</div>\n\n\t\t<!-- No articles -->\n\t\t<empty-search ng-if="vm.articles.length === 0">\n\t\t\t<a ui-sref="help-and-support.home({agencyProfileId: vm.agencyProfileId})" class="action fadeIn">Back to Help and Support</a>\n\t\t</empty-search>\n\n\t</div>\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/shared/help-and-support/home/helpAndSupportHomeView.html','<loading-block size="xl" ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-e_main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Categories -->\n\t<div class="page-template-e_section has-divider-bottom">\n\t\t<support-categories categories="vm.categoriesAll"></support-categories>\n\t</div>\n\n\t<!-- Popular -->\n\t<div class="page-template-e_section">\n\t\t<header class="page-template-e_section-header">\n\t\t\t<h5>Popular articles</h5>\n\t\t</header>\n\t\t<div class="support-articles">\n\t\t\t<support-article-card agency-profile-id="vm.agencyProfileId" article="article" ng-repeat="article in vm.popularArticles"></support-article-card>\n\t\t</div>\n\t</div>\n\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/additional-info/addNewCompanyAdditionalInfoForm.html','\n<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addNewCompanyAdditionalInfoForm" ng-submit="saveCompanyAdditionalInfoForm(company, addNewCompanyAdditionalInfoForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro" ng-if="!company.CISOnly">\n\t\t<h4>Additional Information</h4>\n\t</div>\n\n\t<fieldset ng-if="company.IsPayrollActive || company.IsPensionActive">\n\n\t\t<!-- Small Employer -->\n\t\t<fieldset>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Small Employer</h4>\n\t\t\t\t<p class="is-small">If {{company.CompanyName}} had a National Insurance liability below the threshold in the previous tax year, it is entitled to Small Employer\'s relief.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Small Employer -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="smallCompanyTrue" class="required">Is {{company.CompanyName}} a small employer?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input type="radio" name="smallCompany" id="smallCompanyTrue" class="b" ng-value="true" ng-model="company.EmployerDetails.SmallEmployer">\n\t\t\t\t\t\t<label for="smallCompanyTrue">Yes</label>\n\n\t\t\t\t\t\t<input type="radio" name="smallCompany" id="smallCompanyFalse" class="b" ng-value="false" ng-model="company.EmployerDetails.SmallEmployer">\n\t\t\t\t\t\t<label for="smallCompanyFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Employment Allowance -->\n\t\t<fieldset class="form-fieldset-divider-top">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Employment Allowance</h4>\n\t\t\t\t<p class="is-small">Most employers are entitled to an Employment Allowance each tax year to offset against Class 1 National Insurance.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Employment Allowance entitled -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="allowanceEligibleTrue" class="required">Is {{company.CompanyName}} entitled to Employment Allowance?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input type="radio" name="allowanceEligible" id="allowanceEligibleTrue" class="b" ng-value="true" ng-model="company.EmployerDetails.EmployersAllowanceEligible">\n\t\t\t\t\t\t<label for="allowanceEligibleTrue">Yes</label>\n\n\t\t\t\t\t\t<input type="radio" name="allowanceEligible" id="allowanceEligibleFalse" class="b" ng-value="false" ng-model="company.EmployerDetails.EmployersAllowanceEligible">\n\t\t\t\t\t\t<label for="allowanceEligibleFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<fieldset class="fadeIn" ng-if="company.EmployerDetails.EmployersAllowanceEligible">\n\n\t\t\t\t<!-- Employment Allowance used -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="allowanceUsed" class="required">Employment Allowance claimed to date</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise m-alt" id="allowanceUsed" name="allowanceUsed" ng-max="company.EmployerDetails.EmployersAllowanceMax" ng-min="$root.CONFIG.numberMin" ng-model="company.EmployerDetails.EmployersAllowanceUsed" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.allowanceUsed.$error" ng-if="addNewCompanyAdditionalInfoForm.allowanceUsed.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{company.EmployerDetails.EmployersAllowanceMax | monetise:\'down\'}} for the tax year.</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t<p class="form-message">If nothing has been claimed leave as {{0 | monetise}}.</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Employers NI eligible -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label for="employersNIForEmployersAllowance" class="required">Employer\'s National Insurance eligible for Employment Allowance to date</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise m-alt" id="employersNIForEmployersAllowance" name="employersNIForEmployersAllowance" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.EmployerDetails.EmployersNIForEmployersAllowance" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.employersNIForEmployersAllowance.$error" ng-if="addNewCompanyAdditionalInfoForm.employersNIForEmployersAllowance.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Business sector -->\n\t\t\t\t<div class="form-field" ng-if="company.EmployerDetails.CanHaveEmployersAllowanceSector">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="businessSector" class="required">Business sector:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t<select class="block" name="businessSector" id="businessSector" ng-model="company.EmployerDetails.EmployersAllowanceSector" ng-options="option.value as option.description for option in BUSINESS_SECTOR_OPTIONS" ng-required="company.EmployerDetails.CanHaveEmployersAllowanceSector"></select>\n\t\t\t\t\t</main>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.businessSector.$error" ng-if="addNewCompanyAdditionalInfoForm.businessSector.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please select a business sector</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Auto-reclaim -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<settings-row sr-field-name="employersAllowanceAutoReclaim" sr-icon="loading" ng-model="company.EmployerDetails.EmployersAllowanceAutoReclaim">\n\t\t\t\t\t\t<sr-label>Auto-reclaim</sr-label>\n\t\t\t\t\t\t<sr-description ng-if="!company.EmployerDetails.EmployersAllowanceAutoReclaim">Turning this on means the indicator that you wish to reclaim Employment Allowance will always be sent to HMRC in the first EPS submission of the tax year.</sr-description>\n\t\t\t\t\t\t<sr-description ng-if="company.EmployerDetails.EmployersAllowanceAutoReclaim">Turning this off means the indicator that you wish to reclaim Employment Allowance will not be sent to HMRC in the first EPS submission of the tax year.</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t</fieldset>\n\n\t\t<!-- Apprenticeship Levy -->\n\t\t<fieldset class="form-fieldset-divider-top">\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Apprenticeship Levy</h4>\n\t\t\t\t<p class="s">If you\'re an employer who pays over {{$root.CONFIG.apprenticeshipLevyThreshold}} annually, you are required to pay the Apprenticeship Levy. This is automatically calculated each time payroll is run and will appear on your P32 if applicable. If you have any partner companies, you can split the allowance {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}} between them.</p>\n\t\t\t\t<p class="s">If your payroll does not meet the threshold for the Apprenticeship Levy, select {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}} unless advised otherwise. Selecting \xA30 will result in the levy being calculated without any allowance applied, leading to an unexpected charge for this payroll company.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Apprenticeship Levy Allocation -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label class="required">How much of the allowance would you like to allocate to {{company.CompanyName}}?</label>\n\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.EmployerDetails.apprenticeshipLevyOption === \'full\'}" ng-click="changeApprenticeshipLevyOption(company.EmployerDetails, \'full\')">\xA315,000</a>\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.EmployerDetails.apprenticeshipLevyOption === \'none\'}" ng-click="changeApprenticeshipLevyOption(company.EmployerDetails, \'none\')">\xA30</a>\n\t\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.EmployerDetails.apprenticeshipLevyOption === \'custom\'}" ng-click="changeApprenticeshipLevyOption(company.EmployerDetails, \'custom\')">Another amount</a>\n\t\t\t\t</ul>\n\t\t\t</div>\n\n\t\t\t<!-- Apprenticeship Levy Amount -->\n\t\t\t<div class="form-field fadeIn" ng-if="company.EmployerDetails.apprenticeshipLevyOption === \'custom\'">\n\t\t\t\t<label for="apprenticeshipLevy" class="required">Amount:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="monetise m-alt" id="apprenticeshipLevy" name="apprenticeshipLevy" ng-max="$root.CONFIG.apprenticeshipLevy" ng-min="$root.CONFIG.numberMin" ng-model="company.EmployerDetails.ApprenticeshipLevyAmount" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.apprenticeshipLevy.$error" ng-if="addNewCompanyAdditionalInfoForm.apprenticeshipLevy.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.apprenticeshipLevy | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Maximum of {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}}</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="company.EmployerDetails.apprenticeshipLevyOption !== \'custom\' || addNewCompanyAdditionalInfoForm.apprenticeshipLevy.$valid">\n\t\t\t\t<div class="info-block indifferent is-compact has-plain-type">\n\t\t\t\t\t<p ng-if="!company.EmployerDetails.HasApprenticeshipAllowanceSplit">The full Apprenticeship Levy of {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}} will be allocated to {{company.CompanyName}}.</p>\n\t\t\t\t\t<p ng-if="company.EmployerDetails.HasApprenticeshipAllowanceSplit">{{company.EmployerDetails.ApprenticeshipLevyAmount | monetise}} of the Apprenticeship Levy will be assigned to {{company.CompanyName}}.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Apprenticeship levy YTD-->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<toggle-input field-name="toggleField" field-model="company.apprenticeshipLevyYTDActive" field-label="Add app levy Year to Date"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field-group fadeIn" ng-if="company.apprenticeshipLevyYTDActive">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="apprenticeshipLevyPayBillToDate" class="required">Pay bill to date:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise" id="apprenticeshipLevyPayBillToDate" name="apprenticeshipLevyPayBillToDate" ng-max="$root.CONFIG.number10Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.EmployerDetails.PayPeriodGroupPayBillYTD" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.apprenticeshipLevyPayBillToDate.$error" ng-if="addNewCompanyAdditionalInfoForm.apprenticeshipLevyPayBillToDate.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number10Digits2Decimal | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t<label for="apprenticeshipLevyPaidToDate" class="required">Levy paid to date:</label>\n\t\t\t\t\t</header>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="monetise" id="apprenticeshipLevyPaidToDate" name="apprenticeshipLevyPaidToDate" ng-max="$root.CONFIG.apprenticeshipLevyPaidToDateMax" ng-min="$root.CONFIG.apprenticeshipLevyPaidToDateMin" ng-model="company.EmployerDetails.PayPeriodGroupAppLevyYTD" ng-pattern="$root.REGEX.integersOnly" type="number" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">Enter value in whole pounds</p>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.apprenticeshipLevyPaidToDate.$error" ng-if="addNewCompanyAdditionalInfoForm.apprenticeshipLevyPaidToDate.$touched" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of \xA3999,999,999</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.apprenticeshipLevyPaidToDateMin}}</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Onboarding PAYE credit -->\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Onboarding PAYE credit</h4>\n\t\t\t\t<p class="is-small">If you\u2019ve overpaid to HMRC you can reduce your balance on your next P32 payment by adding your onboarding credit amount.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Currently in credit with HMRC? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="inCreditWithHMRCTrue" class="required">Does {{company.CompanyName}} have onboarding PAYE credit with HMRC?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input type="radio" name="inCreditWithHMRC" id="inCreditWithHMRCTrue" class="b" ng-value="true" ng-model="company.EmployerDetails.HasOnboardingPAYECredit">\n\t\t\t\t\t\t<label for="inCreditWithHMRCTrue">Yes</label>\n\n\t\t\t\t\t\t<input type="radio" name="inCreditWithHMRC" id="inCreditWithHMRCFalse" class="b" ng-value="false" ng-model="company.EmployerDetails.HasOnboardingPAYECredit">\n\t\t\t\t\t\t<label for="inCreditWithHMRCFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Credit amount -->\n\t\t\t<div class="form-field fadeIn" ng-if="company.EmployerDetails.HasOnboardingPAYECredit">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="onboardingPAYECredit" class="required">Credit amount:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="monetise m-alt" id="onboardingPAYECredit" min="0" name="onboardingPAYECredit" ng-model="company.EmployerDetails.OnboardingPAYECredit" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyAdditionalInfoForm.onboardingPAYECredit.$touched" ng-messages="addNewCompanyAdditionalInfoForm.onboardingPAYECredit.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- CIS -->\n\t<fieldset ng-class="{\n\t\t\t\'form-fieldset-divider-top\': !company.CISOnly\n\t\t}">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>CIS (Construction Industry Scheme)</h4>\n\t\t\t<p class="s">CIS deductions can be offset against your monthly or quarterly payments to HMRC. You can reduce your tax, National Insurance contributions or CIS payments by the amount of deductions.</p>\n\t\t</div>\n\n\t\t<!-- Deductions suffered -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<label for="deductionsSuffered" class="required">Deductions suffered this tax year to date:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input class="monetise m-alt" id="deductionsSuffered" name="deductionsSuffered" ng-max="$root.CONFIG.number10Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.EmployerDetails.CISDeductionsSuffered" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="addNewCompanyAdditionalInfoForm.deductionsSuffered.$error" ng-if="addNewCompanyAdditionalInfoForm.deductionsSuffered.$touched" role="alert">\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number10Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="number">Please enter a valid amount</p>\n\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t<p ng-message="required">Please enter the deductions suffered</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="addNewCompanyAdditionalInfoForm.state" ng-if="addNewCompanyAdditionalInfoForm.state === \'saved\'">\n\t\t\t<p>Company additional info has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a href="" class="button secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNewCompanyAdditionalInfoForm.state" disable-button="!addNewCompanyAdditionalInfoForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/finished/addNewCompanyFinishedForm.html','<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{company.CompanyName}} has been created">\n\t<fs-main>\n\t\t<div ng-if="company.isInPlayground">\n\t\t\t<p class="s"><strong>{{company.CompanyName}}</strong> has been added to your playground and will appear on your Companies page</p>\n\t\t</div>\n\t\t<div ng-if="!company.isInPlayground">\n\t\t\t<section class="form-section">\n\t\t\t\t<div class="test-mode-bar">\n\t\t\t\t\t<p><strong>{{company.CompanyName}}</strong> are running in Test Mode</p>\n\t\t\t\t\t<span class="marker s tertiary test-mode-bar-marker"></span>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">When you run payroll, submissions won\u2019t be made and payslips won\u2019t be sent to the team.\n\t\t\t\t\tPlease note that if you enable electronic updates they will not be applied for companies running in Test Mode.\n\t\t\t\t\tOnce a company is switched to Live Mode then updates will be applied as they become available.\n\t\t\t\t\tYou can always access your reports as you would normally with live payroll.</p>\n\t\t\t</section>\n\t\t\t<section class="form-section">\n\t\t\t\t<p class="s">You can switch to Live Mode at the click of a button from your Companies page or the company dashboard whenever you\u2019re ready to go.</p>\n\t\t\t</section>\n\n\t\t\t<!-- Group and Organization Linking Warnings -->\n\t\t\t<div ng-if="company.isGroupCreationFeatureEnabled && company.isGroupLinkedToOrganisation">\n\t\t\t\t<!-- Success message when customer codes match -->\n\t\t\t\t<section class="form-section" ng-if="company.customerCodesMatch">\n\t\t\t\t\t<div class="notification primary">\n\t\t\t\t\t\t<p class="s"><strong>{{company.CompanyName}}</strong> has been successfully linked to the organization.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t\t\n\t\t\t\t<!-- Warning note when customer codes don\'t match -->\n\t\t\t\t<fieldset class="form-fieldset" ng-if="!company.companyCustomerCodeMissing && !company.customerCodesMatch">\n\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="true" note-icon="icon-warning" note-theme="tertiary is-form-field" note-title="Couldn\'t be linked to organization">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tThe customer code for {{company.CompanyName}} ({{company.companyCustomerCode}}) is different to the customer code for this group ({{company.organisationCustomerCode}}). As this group has Access Evo features enabled, they must match. Go to the \'Customer codes\' area in your bureau settings to ensure a company has the right code before trying again.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</fieldset>\n\t\t\t\t\n\t\t\t\t<!-- Warning note when company customer code is missing -->\n\t\t\t\t<fieldset class="form-fieldset" ng-if="company.companyCustomerCodeMissing">\n\t\t\t\t\t<note note-animation="fadeIn" note-dismiss="true" note-icon="icon-warning" note-theme="tertiary is-form-field" note-title="Couldn\'t be linked to organization">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t{{company.CompanyName}} doesn\'t have a customer code and, as this group has Access Evo features enabled, it needs one that matches the customer code for this group ({{company.organisationCustomerCode}}). Go to the \'Customer codes\' area in your bureau settings to ensure a company has the right code before trying again.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</fieldset>\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n</form-state>\n');
$templateCache.put('forms/admin/addNewCompany/modules/addNewCompanyModulesForm.html','<form name="addNewCompanyModulesForm" ng-submit="saveNewCompanyModules(company, addNewCompanyModulesForm)" class="fadeIn" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Modules</h4>\n\t\t<p class="s">Choose which modules you would like to turn on for {{company.CompanyName}}.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<section class="form-section">\n\t\t\t<div class="form-field">\n\t\t\t\t<section class="settings-rows">\n\n\t\t\t\t\t<!-- Payroll -->\n\t\t\t\t\t<settings-row ng-model="company.IsPayrollActive" on-update="validateModuleSelection(company)" sr-disabled="company.IsPayslipManagerActive" sr-field-name="payroll" sr-label="Payroll">\n\t\t\t\t\t\t<sr-description>Manage payroll for your team and make submissions to HMRC each pay period.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Pension -->\n\t\t\t\t\t<settings-row ng-model="company.IsPensionActive" on-update="validateModuleSelection(company)" sr-disabled="company.IsPayslipManagerActive" sr-field-name="workplacePension" sr-label="Pension">\n\t\t\t\t\t\t<sr-description>Connect your workplace pension to payroll or manage your workplace pension on its own.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- CIS -->\n\t\t\t\t\t<settings-row ng-model="company.IsCISActive" on-update="validateModuleSelection(company)" sr-disabled="company.IsPayslipManagerActive" sr-field-name="cis" sr-label="CIS (Construction Industry Scheme)">\n\t\t\t\t\t\t<sr-description>Construction Industry Scheme for contractors - manage payments to subcontractors.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- HR -->\n\t\t\t\t\t<settings-row ng-model="company.IsHRActive" on-update="validateModuleSelection(company)" sr-disabled="company.IsPayslipManagerActive" sr-field-name="hr" sr-label="HR">\n\t\t\t\t\t\t<sr-description>Set up company policies, job grades and manage and track your team\u2019s holidays and sick days.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Off-payroll -->\n\t\t\t\t\t<settings-row sr-disabled="company.IsPayslipManagerActive" sr-field-name="offPayroll" sr-label="Off-payroll workers" ng-model="company.IsOffPayrollActive" on-update="validateModuleSelection(company)">\n\t\t\t\t\t\t<sr-description>Deemed payments can be added so tax and NI can be calculated and submitted each period.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Payslip Manager -->\n\t\t\t\t\t<settings-row ng-if="company.IsPayslipManagerInUse" ng-model="company.IsPayslipManagerActive" on-update="validateModuleSelection(company)" sr-field-name="payslipOnly" sr-label="Payslip manager">\n\t\t\t\t\t\t<sr-description>Deliver your employees their payslips and documents.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<!-- Expats -->\n\t\t\t\t\t<settings-row ng-model="company.IsExpatActive" on-update="validateModuleSelection(company)" sr-disabled="company.IsPayslipManagerActive" sr-field-name="expats" sr-label="Expats">\n\t\t\t\t\t\t<sr-description>Manage tax equalisation and foreign tax credits for team members and pay them using alternative currencies.</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class="form-section with-separator">\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Integrations</h4>\n\t\t\t\t<p class="is-small">Choose which integrations you would like to turn on for {{company.CompanyName}}.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<section class="settings-rows">\n\n\t\t\t\t\t<!-- Pay Experian -->\n\t\t\t\t\t<settings-row ng-model="company.IsPayExperianIntegrationEnabled" on-update="validateModuleSelection(company)" sr-field-name="payexperian" sr-label="Digital Employment Verification">\n\t\t\t\t\t\t<sr-description>Enable employees to securely share required payslip data to expedite application processes.</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="form-field" ng-if="!company.isModuleSelectionValid" ng-switch="company.moduleValidState">\n\t\t\t<div class="message-bar indifferent fadeIn" ng-switch-when="no-modules-selected">\n\t\t\t\t<p class="s">At least one of the modules above should be turned on to create a company</p>\n\t\t\t</div>\n\t\t\t<div class="message-bar indifferent fadeIn" ng-switch-when="no-pension-and-cis-without-payroll">\n\t\t\t\t<p class="s">Please turn off the <span class="strong">Workplace Pension</span> module to run a CIS scheme</p>\n\t\t\t</div>\n\t\t\t<div class="message-bar indifferent fadeIn" ng-switch-when="no-hr-without-payroll">\n\t\t\t\t<p class="s">Please turn on the <span class="strong">Payroll</span> module if the <span class="strong">HR</span> module is turned on</p>\n\t\t\t</div>\n\t\t\t<div class="message-bar indifferent fadeIn" ng-switch-when="no-off-payroll-without-payroll">\n\t\t\t\t<p class="s">Please turn on the <span class="strong">Payroll</span> module if the <span class="strong">Off-payroll workers</span> module is turned on</p>\n\t\t\t</div>\n\t\t\t<div class="message-bar indifferent fadeIn" ng-switch-when="no-expats-without-payroll">\n\t\t\t\t<p class="s">Please turn on the <span class="strong">Payroll</span> module if the <span class="strong">Expats</span> module is turned on</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-content-block fadeIn" ng-if="company.IsCISActive">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="strong"><i class="icon-cis indifferent m"></i>&nbsp;&nbsp;CIS only company?</h6>\n\t\t\t\t<p>If you only operate a CIS scheme with no PAYE employees, please select the <span class="strong">CIS</span> module only and switch\n\t\t\t\t\tboth <span class="strong">Payroll</span> and <span class="strong">Workplace Pension</span> modules to \u2018off\u2019.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNewCompanyModulesForm.state" disable-button="!addNewCompanyModulesForm.$valid || !company.isModuleSelectionValid"></submit-button>\n\t</fieldset>\n</form>\n');
$templateCache.put('forms/admin/addNewCompany/basic/addNewCompanyBasicForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyBasicForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyBasic(company, addNewCompanyBasicForm)" novalidate>\n\t<!-- Test Mode -->\n\t<section class="form-section" ng-if="!company.isInPlayground">\n\t\t<p class="s">New companies will run in Test Mode by default so you can run payroll alongside your existing system for comparison.\n\t\t\tYou can switch over to live at the click of a button, from your Companies page, whenever you\'re ready to go.</p>\n\t</section>\n\n\t<div class="form-intro">\n\t\t<h4>Basic information</h4>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="companyName" class="required">Company name:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input data-cy="company-name-input" id="companyName" name="companyName" ng-model="company.CompanyName" ng-pattern="$root.REGEX.companyName" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyBasicForm.companyName.$touched" ng-messages="addNewCompanyBasicForm.companyName.$error" role="alert">\n\t\t\t\t<p data-cy="company-name-required-message" ng-message="required">Please enter a company name</p>\n\t\t\t\t<p data-cy="company-name-pattern-message" ng-message="pattern">Only letters, full-stops, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Display pay frequency -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox data-cy="display-pay-frequency" id="displayPayFrequency" label-text="\'Add pay frequency to company display name\'" name="displayPayFrequency" ng-model="company.DisplayPayFrequency" type="checkbox">\n\t\t\t</div>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="s">A pay frequency label will be added to end of the company name (e.g. ACME Company - Monthly) for display purposes\n\t\t\t\t\tin the system. This won&rsquo;t appear on any documents such as Payslips and P45\u2019s however.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company number -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="companyNumber">Company number:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input capitalise data-cy="company-number-input" class="l" id="companyNumber" maxlength="10" name="companyNumber" ng-model="company.EmployerDetails.CompanyNumber" ng-pattern="$root.REGEX.companyNumber" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors" ng-if="addNewCompanyBasicForm.companyNumber.$touched" ng-messages="addNewCompanyBasicForm.companyNumber.$error" role="alert">\n\t\t\t\t<p data-cy="company-number-required-message" ng-message="required">Please enter a company number</p>\n\t\t\t\t<p data-cy="company-number-pattern-message" ng-message="pattern">Please enter a valid company number. They are usually between 7-8 digits, often starting with 2 letters.</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">The registration number provided by Companies House</p>\n\t\t</div>\n\n\t\t<!-- Industry sectors -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="industrySectors">Primary industry sector:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select data-cy="industry-sectors-dropdown" id="industrySectors" name="industrySectors" ng-change="formatIndustrySectorDescription(company.IndustrySectorID)" ng-model="company.IndustrySectorID" ng-options="sector.IndustrySectorID as sector.CategoryName for sector in company.industrySectors">\n\t\t\t\t\t<option value="">Select an industry sector\u2026</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-field-footer" data-cy="industry-sector-description">\n\t\t\t<bullet-list bl-theme="is-small is-primary" ng-if="company.IndustrySectorID">\n\t\t\t\t<bl-items>\n\t\t\t\t\t<li class="bullet-list_item" ng-repeat="description in industrySectorDescription track by $index">\n\t\t\t\t\t\t<p class="is-small is-font-greyscale-300" data-cy="industry-sector-description">\n\t\t\t\t\t\t\t{{description}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</li>\n\t\t\t\t</bl-items>\n\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Client reference -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="clientReference">Client reference:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" data-cy="client-reference-input" id="clientReference" name="clientReference" ng-model="company.EmployerDetails.ClientReference" type="text">\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top" ng-if="company.isCustomerCodeEnabled">\n\t\t<!-- Access Evo -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Access Evo</label>\n\t\t\t</header>\n\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="s" data-cy="customer-code-required-message">\n\t\t\t\t\tEnter a customer code so we can verify it with Access Dimensions. If the organisation doesn\'t look correct,\n\t\t\t\t\tyou may need to enter a different code. Once a code has been saved you\'ll need to contact support if you wish to change it.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Customer code -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="customerCode">Customer code:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" data-cy="customer-code-input" id="customerCode" name="customerCode" ng-change="resetVerificationState()" ng-disabled="verificationState === \'verifying\'" ng-maxlength="15" ng-model="company.CustomerCode" ng-pattern="$root.REGEX.customerCode" type="text">\n\t\t\t\t<button class="button-compact" data-cy="customer-code-verify-button" ng-click="verifyCustomerCode(company)" ng-disabled="!company.CustomerCode || verificationState === \'verifying\'" ng-hide="true" type="button">\n\t\t\t\t\tVerify\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<p class="form-message" data-cy="customer-code-max-char-number">\n\t\t\t\tMax. 15 characters.\n\t\t\t</p>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyBasicForm.customerCode.$touched" ng-messages="addNewCompanyBasicForm.customerCode.$error" role="alert">\n\t\t\t\t<p data-cy="customer-code-max-length-message" ng-message="maxlength">Enter a maximum of 15 characters</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="verificationState === \'verifying\'">\n\t\t\t<circle-loader></circle-loader>\n\t\t\t<span class="s ml-1">Verifying customer code...</span>\n\t\t</div>\n\t\t<div class="form-field" ng-if="verificationState === \'invalid\' || verificationState === \'error\'">\n\t\t\t<message-block theme="assertive is-inline" has-drop-in="false">\n\t\t\t\t<p>\n\t\t\t\t\t<i class="icon-warning is-medium is-assertive has-margin-right"></i>\n\t\t\t\t\t<span>Valid code not found. Please check you\'ve entered it correctly.</span>\n\t\t\t\t</p>\n\t\t\t</message-block>\n\t\t</div>\n\t\t<div class="form-field" ng-if="verificationState === \'valid\'">\n\t\t\t<message-block theme="secondary is-inline" has-drop-in="false">\n\t\t\t\t<p>\n\t\t\t\t\t<i class="icon-tick is-medium is-secondary has-margin-right"></i>\n\t\t\t\t\t<span>Valid code found: {{company.customerCodeCompanyName}}</span>\n\t\t\t\t</p>\n\t\t\t</message-block>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="secondary-action-back" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button data-cy="company-setup-step-one-submit" disable-button="!addNewCompanyBasicForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyBasicForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pay-periods/addNewCompanyPayPeriodsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addNewCompanyPayPeriodsForm" ng-submit="saveNewCompanyPayPeriods(newCompany, addNewCompanyPayPeriodsForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Pay Periods</h4>\n\t\t<p>Add your pay period settings and preview your future pay periods.</p>\n\t</div>\n\n\t<pay-period-dates period-details="newCompany.PeriodDetails2" on-preview="generateTimeline" form="addNewCompanyPayPeriodsForm" is-cis-active="newCompany.IsCISActive"></pay-period-dates>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNewCompanyPayPeriodsForm.state" disable-button="!addNewCompanyPayPeriodsForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="newCompany.PeriodDetails2.isTimelineVisible">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay period calendar</h5>\n\t\t<a aria-label="Hide pay period calendar" href="" class="slide-in-form-aside-header-action" ng-click="toggleIsTimelineVisible(newCompany.PeriodDetails2)"><i class="icon-right l"></i></a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main align-center fadeIn" ng-if="newCompany.PeriodDetails2.payPeriodsLoadingState === \'loading\'">\n\t\t<circle-loader></circle-loader>\n\t</div>\n\n\t<div class="slide-in-form-aside-main fadeIn" ng-if="newCompany.PeriodDetails2.payPeriodsLoadingState === \'ready\'">\n\n\t\t<div ng-repeat="(payPeriodIndex, payPeriod) in newCompany.PeriodDetails2.payPeriods" ng-show="payPeriodIndex === newCompany.PeriodDetails2.payPeriodIndex">\n\n\t\t\t<div class="slide-in-form-aside-subheader">\n\t\t\t\t<p>{{payPeriod.PayPeriodDisplay}}&nbsp;&nbsp;<span class="tag is-tertiary">{{payPeriod.TaxPeriod | taxPeriodDescription:payPeriod.PeriodType}}</span></p>\n\t\t\t\t<div class="next-previous-controls slide-in-form-aside-subheader-actions">\n\t\t\t\t\t<a aria-label="Go to previous month" href="" ng-click="decrementPayPeriodIndex(newCompany.PeriodDetails2)" ng-class="{\'disabled\': newCompany.PeriodDetails2.payPeriodIndex === newCompany.PeriodDetails2.payPeriodIndexMin}"><i class="icon-chevron-left"></i></a>\n\t\t\t\t\t<a aria-label="Go to next month" href="" ng-click="incrementPayPeriodIndex(newCompany.PeriodDetails2)" ng-class="{\'disabled\': newCompany.PeriodDetails2.payPeriodIndex === newCompany.PeriodDetails2.payPeriodIndexMax}"><i class="icon-chevron-right"></i></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pay Periods -->\n\t\t\t<div class="data-grid is-primary">\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Start date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.StartDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">End date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.EndDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Payroll processing date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.ProcessDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Pay day</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.PayDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Pay day notifications sent</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.PayslipDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<error-block ng-if="newCompany.PeriodDetails2.payPeriodsLoadingState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n</aside>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/addNewCompany/payroll/addNewCompanyPayrollForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyPayrollForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyPayroll(company, addNewCompanyPayrollForm)" novalidate>\n\t<div class="form-intro">\n\t\t<h4>References and updates</h4>\n\t\t<p class="s" ng-if="!company.isInPlayground">\n\t\t\tLet\'s add some details about your payroll so we can set things up for you.\n\t\t</p>\n\t\t<p class="s" ng-if="company.isInPlayground">\n\t\t\tAs you\u2019re creating a company in your playground, any references are automatically configured. These details will be used:\n\t\t</p>\n\t</div>\n\n\t<!-- In Playground -->\n\t<div ng-if="company.isInPlayground">\n\n\t\t<section class="form-section">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s" ng-if="!company.isPensionOnly">\n\t\t\t\t\t<strong>Accounts Office reference:</strong> {{company.EmployerDetails.AccountsOffice}}\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\t<strong>Tax Office reference number:</strong> {{company.EmployerDetails.TaxOffice}}/{{company.EmployerDetails.TaxOfficeReference}}\n\t\t\t\t</p>\n\t\t\t\t<p class="s" ng-if="company.IsCISActive">\n\t\t\t\t\t<strong>Unique Tax Reference number:</strong> {{company.EmployerDetails.UTR}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</section>\n\t\t<p class="s">Click <em>\'Next\'</em> to continue.</p>\n\t</div>\n\n\t<!-- HMRC Credentials -->\n\t<fieldset ng-if="!company.isInPlayground">\n\n\t\t<!-- Accounts Office Reference Number -->\n\t\t<div class="form-field" ng-if="!company.isPensionOnly">\n\t\t\t<label for="accountsOfficeReferenceNumber">Accounts Office reference number:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input class="l" id="accountsOfficeReferenceNumber" max-length="13" min-length="13" name="accountsOfficeReferenceNumber" ng-model="company.EmployerDetails.AccountsOffice" ng-pattern="$root.REGEX.accountsOfficeRef" placeholder="123PA12345678" type="text" capitalise>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPayrollForm.accountsOfficeReferenceNumber.$touched" ng-messages="addNewCompanyPayrollForm.accountsOfficeReferenceNumber.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">This has to be 13 characters and in this format 123PA12345678</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Tax Office Reference Number -->\n\t\t<div class="form-field">\n\t\t\t<label for="taxOffice">Tax Office reference number:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input class="s" id="taxOffice" name="taxOffice" ng-model="company.EmployerDetails.TaxOffice" ng-pattern="$root.REGEX.payeRefA" ng-required="company.EmployerDetails.TaxOfficeReference" placeholder="123" type="text" capitalise>\n\t\t\t\t<span>&nbsp;/&nbsp;</span>\n\t\t\t\t<input class="s" id="taxOfficeRef" name="taxOfficeRef" ng-model="company.EmployerDetails.TaxOfficeReference" ng-pattern="$root.REGEX.payeRefB" ng-required="company.EmployerDetails.TaxOffice" placeholder="A246" type="text" capitalise>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPayrollForm.taxOfficeRef.$touched && addNewCompanyPayrollForm.taxOffice.$touched" ng-messages="addNewCompanyPayrollForm.taxOffice.$error || addNewCompanyPayrollForm.taxOfficeRef.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid Tax Office reference number. E.g. 123/A246</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- PensionOnly - TOR number-->\n\t\t<div class="form-content-block fadeIn" ng-if="company.isPensionOnly">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Tax Office reference number">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">This can be added at a later date but is required in order to run payroll.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Note for AOR and TOR numbers -->\n\t\t<div class="form-content-block fadeIn" ng-if="!company.isPensionOnly && (!company.EmployerDetails.AccountsOffice || !company.EmployerDetails.TaxOffice || !company.EmployerDetails.TaxOfficeReference)">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Accounts Office &amp; Tax Office reference numbers">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Can be added at a later date but are required in order to run payroll</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Unique Taxpayer Reference (UTR) -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="utr" ng-class="{\n\t\t\t\t\t\t\'required\': company.IsCISActive\n\t\t\t\t\t}">\n\t\t\t\t\tUnique Taxpayer Reference (UTR):\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="utr" name="utr" ng-model="company.EmployerDetails.UTR" ng-pattern="$root.REGEX.utr" ng-required="company.IsCISActive" placeholder="1234567890" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPayrollForm.utr.$touched" ng-messages="addNewCompanyPayrollForm.utr.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a Unique Taxpayer Reference number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid Unique Taxpayer Reference number. It should consist of 10 digits. E.g. 0123456789</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- New company? -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="isNewCompany" label-text="\'This is a new company\'" name="isNewCompany" ng-model="company.EmployerDetails.IsNewCompany" type="checkbox" checkbox>\n\t\t\t</div>\n\t\t\t<p class="form-message">For companies with new PAYE schemes</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Electronic Updates -->\n\t<fieldset class="form-fieldset-divider-top" ng-if="!company.isInPlayground && !company.isPensionOnly">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Electronic updates</h4>\n\t\t\t<p class="s">\n\t\t\t\tWe suggest enabling electronic updates from HMRC to automatically keep tax codes and student loan notices up to date.\n\t\t\t\tYour credentials will be validated when you click \u2018Save\u2019.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Electronic updates enabled? -->\n\t\t<div class="form-field">\n\t\t\t<label for="IsElectronicUpdatesEnabledTrue" class="required">Enable electronic updates:</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input class="b" id="IsElectronicUpdatesEnabledTrue" name="electronicUpdatesEnabled" ng-model="company.EmployerDetails.IsElectronicUpdatesEnabled" ng-value="true" type="radio">\n\t\t\t\t\t<label for="IsElectronicUpdatesEnabledTrue">Yes</label>\n\t\t\t\t\t<input class="b" id="IsElectronicUpdatesEnabledFalse" name="electronicUpdatesEnabled" ng-model="company.EmployerDetails.IsElectronicUpdatesEnabled" ng-value="false" type="radio">\n\t\t\t\t\t<label for="IsElectronicUpdatesEnabledFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="form-message">You\'ll need to make sure electronic updates, also known as Electronic Data Interchange (EDI), is enabled in your HMRC account.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Find out how</support-article-link>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- HMRC Credentials -->\n\t\t<fieldset>\n\n\t\t\t<!-- HMRC User ID -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="hmrcUserId" ng-class="{\'required\' : company.EmployerDetails.IsElectronicUpdatesEnabled }">HMRC User ID:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcUserId" maxlength="{{$root.CONFIG.hmrcUsernameMaxLength}}" name="hmrcUserId" ng-model="company.EmployerDetails.HMRCUserName" ng-required="company.EmployerDetails.IsElectronicUpdatesEnabled" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPayrollForm.hmrcUserId.$touched" ng-messages="addNewCompanyPayrollForm.hmrcUserId.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the HMRC User ID</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- HMRC Password -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="hmrcPassword" ng-class="{\'required\' : company.EmployerDetails.IsElectronicUpdatesEnabled }">HMRC Password:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcPassword" name="hmrcPassword" ng-model="company.EmployerDetails.HMRCPassword" ng-required="company.EmployerDetails.IsElectronicUpdatesEnabled" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPayrollForm.hmrcPassword.$touched" ng-messages="addNewCompanyPayrollForm.hmrcPassword.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the HMRC Password</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Electronic updates warning -->\n\t\t<fieldset>\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Electronic updates in Test Mode">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that if you enable electronic updates they will not be applied for companies running in Test Mode.\n\t\t\t\t\t\tOnce a company is switched to Live Mode then updates will be applied as they become available.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" data-cy="secondary-action-back" href="" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!addNewCompanyPayrollForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPayrollForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Testing HMRC credentials -->\n<section class="form-summary fadeIn" ng-if="pageState === \'testing-hmrc-credentials\'">\n\t<loading-block size="m">\n\t\t<lb-description>Validating HMRC credentials...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">We\'re quickly testing the connection to HMRC. This shouldn\'t take too long.</p>\n\t</section>\n</section>\n\n<!-- HMRC credentials invalid -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to validate HMRC credentials" ng-if="pageState === \'hmrc-credentials-invalid\'">\n\t<fs-main>\n\t\t<p>We were unable to validate the credentials provided for HMRC. Please <a href="" ng-click="setPageState(\'ready\')" class="underline">go back</a> and try again.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- HMRC credentials valid but Electronic updates are not switched on -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Electronic updates not enabled" ng-if="pageState === \'automatic-updates-not-enabled\'">\n\t<fs-main>\n\t\t<p>We were able to connect to HMRC successfully although it appears as though your electronic HMRC notices are not enabled.\n\t\t\tYou\'ll need to turn these on to enable electronic notices. Follow\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">\n\t\t\t\tthese simple steps\n\t\t\t</support-article-link>\n\t\t\tto switch electronic notices on.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-automation/addNewCompanyPensionAutomationForm.html','\n<!-- Pension Groups -->\n<form class="fadeIn" name="addNewCompanyPensionAutomationForm" ng-submit="saveNewCompanyPensionAutomation(pension, addNewCompanyPensionAutomationForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Automation options</h4>\n\t\t<p class="is-small">\n\t\t\tPaycircle can automate many of your workplace pension management tasks. Use the toggle options below to manage your workplace pension automation settings.\n\t\t</p>\n\t</div>\n\n\t<div class="form-field" ng-if="pension.selectedPensionProviderObj.PensionProviderHasAPI">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Looking to connect directly to {{pension.selectedPensionProviderObj.PensionProviderName}}?">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf you\u2019d like to connect directly to {{pension.selectedPensionProviderObj.PensionProviderName}}, and this isn\u2019t a brand new pension, it\u2019s critical you check that the information in\n\t\t\t\t\tyour {{pension.selectedPensionProviderObj.PensionProviderName}} portal is up to date. This should ensure that your pension submissions don\'t fail. We recommend you check the following:\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'All enrolments that have occurred before your current pay period are up to date\',\n\t\t\t\t\t\t\t\'All contributions that have been paid before your current pay period are up to date\',\n\t\t\t\t\t\t\t\'All team members who have opted out or ceased membership before your current period are up to date\',\n\t\t\t\t\t\t\t\'Your pension period dates are the same as those in your provider portal\'\n\t\t\t\t\t\t]" bl-theme="is-small is-indifferent"></bullet-list>\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tFor more information, read our\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionSubmissionTroubleshooting" theme="indifferent" underline="true">\n\t\t\t\t\t\ttroubleshooting guide to pension submissions\n\t\t\t\t\t</support-article-link>\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\n\t\t\t<div class="settings-rows">\n\n\t\t\t\t<!-- Team Assessment -->\n\t\t\t\t<settings-row ng-model="pension.AssessTeam" on-update="onAssessTeamChange(pension)" sr-field-name="assessTeam" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Team assessment</sr-label>\n\t\t\t\t\t<sr-description>\n\t\t\t\t\t\tAutomatic team assessment comes as standard. Paycircle will assess your team each time you run payroll and automatically enrol anyone who becomes eligible.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Connect directly -->\n\t\t\t\t<settings-row ng-if="pension.selectedPensionProviderObj.PensionProviderHasAPI && !pension.IsGhostPension" ng-model="pension.ConnectToProvider" sr-disabled="!pension.AssessTeam" sr-field-name="connectToProvider" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Connect directly to {{pension.selectedPensionProviderObj.PensionProviderName}}</sr-label>\n\t\t\t\t\t<sr-description>\n\t\t\t\t\t\tPaycircle will send your pension data directly to your pension provider and receive updates, such as opt in and opt out notices and information regarding pension group changes.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Send pension comms -->\n\t\t\t\t<settings-row ng-model="pension.SendCommunications" sr-field-name="sendCommunications" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Send pension status communications</sr-label>\n\t\t\t\t\t<sr-description>\n\t\t\t\t\t\tPaycircle will automatically send pension related communications to all of your team members via email and store them in your communications centre - keeping you compliant at\n\t\t\t\t\t\tall times.\n\t\t\t\t\t</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Manual tasks -->\n\t<fieldset class="fadeIn" ng-if="!pension.ConnectToProvider || !pension.SendCommunications">\n\n\t\t<div class="form-intro">\n\t\t\t<h6 class="stronger">Manual pension tasks</h6>\n\t\t\t<p class="is-small">\n\t\t\t\tTurning off automation options means that you will need to manage those tasks manually.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="task-overview-blocks">\n\t\t\t\t<div class="task-overview-block secondary" ng-if="!pension.AssessTeam">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Team assessment - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage the statuses of your team members manually</p>\n\t\t\t\t\t\t<a class="task-overview-block-action" href="" ng-click="toggleShowOverviewDetailsTeam(pension)">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 4 tasks <i class="icon-chevron-{{pension.showOverviewDetailsTeam ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="pension.showOverviewDetailsTeam">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Team members will not be assessed for auto-enrolment and re-enrolment so you will need to keep their pension statuses up-to-date in the respective pension or in the pension area in their profile.\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t\t<div class="task-overview-block secondary" ng-if="!pension.ConnectToProvider">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Connect directly to {{pension.selectedPensionProviderObj.PensionProviderName}} - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage the synchronisation of your payroll and pension manually</p>\n\t\t\t\t\t\t<a class="task-overview-block-action" href="" ng-click="toggleShowOverviewDetailsConnect(pension)">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 4 tasks <i class="icon-chevron-{{pension.showOverviewDetailsConnect ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="pension.showOverviewDetailsConnect">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Download pension files from Paycircle and upload them to your pension provider\\\'s portal each pay period\',\n\t\t\t\t\t\t\t\t\'Update Paycircle when someone chooses to opt in, opt out or cease membership\',\n\t\t\t\t\t\t\t\t\'Update Paycircle if your company or a team member changes their pension contribution percentages or amounts\',\n\t\t\t\t\t\t\t\t\'Update Paycircle when you set up a new workplace pension group or move team member between groups\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t\t<div class="task-overview-block secondary" ng-if="!pension.SendCommunications">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Send pension status communications - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage workplace pension communications to your team manually</p>\n\t\t\t\t\t\t<a class="task-overview-block-action" href="" ng-click="toggleShowOverviewDetailsComms(pension)">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 7 tasks <i class="icon-chevron-{{pension.showOverviewDetailsComms ? \'up\' : \'down\'}}"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="pension.showOverviewDetailsComms">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Send pension assessment notices to new team members to tell them when they are going to be assessed\',\n\t\t\t\t\t\t\t\t\'Send postponement notices to new team members when they join the company - if you are using postponement for new team members\',\n\t\t\t\t\t\t\t\t\'Send change in status notices to team members each time their enrolment status changes\',\n\t\t\t\t\t\t\t\t\'Send postponement notices to team members when their enrolment status changes - if you are using postponement for team member threshold changes\',\n\t\t\t\t\t\t\t\t\'Send enrolment notices when a team member gets enrolled into a workplace pension\',\n\t\t\t\t\t\t\t\t\'Send re-enrolment assessment notices to team members when your company goes through its cyclical 3 year re-enrolment process\',\n\t\t\t\t\t\t\t\t\'Send re-enrolment notices to team members who are re-enrolled when your company goes through its cyclical 3 year re-enrolment process\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" href="" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!addNewCompanyPensionAutomationForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionAutomationForm.state"></submit-button>\n\t</fieldset>\n</form>\n');
$templateCache.put('forms/admin/addNewCompany/pension-ghost/addNewCompanyPensionGhostForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyPensionGhostForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyPensionSettings(pension, addNewCompanyPensionGhostForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Pension scheme</h4>\n\t</div>\n\n\t<div class="form-section" ng-class="{\n\t\t\t\'is-disabled\': company.isPensionSchemeSetupDeferred\n\t\t}">\n\t\t<div class="form-intro">\n\t\t\t<h6>Just need to assess your team for now?</h6>\n\t\t\t<p class="is-small">\n\t\t\t\tIf you don\u2019t wish to set up a pension just yet, but you\u2019d like team members to be assessed for auto-enrolment, you can create a &lsquo;Ghost Pension&rsquo; which doesn\'t require any\n\t\t\t\tpension scheme settings. The system will then notifiy you when a team member becomes eligible and you can change your Ghost Pension settings to a real pension provider.\n\t\t\t\t<a class="underline" href="" ng-href="{{$root.URLS.paycircle.support.pensionGhost}}" ng-if="$root.URLS.paycircle.support.pensionGhost" target="_blank">\n\t\t\t\t\tRead more about Ghost pensions\n\t\t\t\t</a>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Is Ghost Pension -->\n\t\t\t <div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="ghostPensionOption1" name="ghostPension" ng-model="pension.IsGhostPension" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="ghostPensionOption1">\n\t\t\t\t\t\t\t\t<i class="icon-rosette radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Choose a provider</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="radio-card-input" id="ghostPensionOption2" name="ghostPension" ng-model="pension.IsGhostPension" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-card-label" for="ghostPensionOption2">\n\t\t\t\t\t\t\t\t<i class="icon-clock radio-card-icon"></i>\n\t\t\t\t\t\t\t\t<p class="radio-card-text">Use a Ghost Pension</p>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n\n\t<div class="form-field-group has-divider" ng-if="company.IsHRActive">\n\n\t\t<note note-theme="primary">\n\t\t\t<note-content>\n\t\t\t\t<h6><i class="icon-menu-alt m is-primary"></i>&nbsp;Looking to set up a banded pension scheme?</h6>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou\u2019ll first need to create a pension policy in the HR area for {{company.CompanyName}} once you\u2019ve finished adding them.\n\t\t\t\t\t\tCheck the box below to set your pension schemes up later, or you can continue with choosing a standard auto-enrolment provider above.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<input checkbox id="isPensionSchemeSetupDeferred" label-text="\'Set pension schemes up later\'" name="isPensionSchemeSetupDeferred" ng-model="company.isPensionSchemeSetupDeferred" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save / Next (if pensions aren\'t being skipped) -->\n\t\t<submit-button disable-button="!addNewCompanyPensionGhostForm.$valid" display-text="formOptions.primaryButtonText" ng-if="!company.isPensionSchemeSetupDeferred" state="addNewCompanyPensionGhostForm.state"></submit-button>\n\n\t\t<!-- Finish (if pensions are being skipped)-->\n\t\t<button class="button tertiary primary-action" ng-click="saveNewCompanyPensionDeferred(company, addNewCompanyPensionGhostForm)" ng-if="company.isPensionSchemeSetupDeferred" type="button">\n\t\t\tFinish\n\t\t</button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-groups/addNewCompanyPensionGroupsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyPensionGroupsForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyPensionGroups(vm, addNewCompanyPensionGroupsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Pension groups</h4>\n\t\t<p class="is-small">\n\t\t\tPlease enter the group name that has been set up on the pension provider website and set the group\'s contribution percentages. Click &lsquo;Add another group&rsquo; to add additional groups.\n\t\t</p>\n\t</div>\n\n\t<div class="form-content-block">\n\t\t<note note-dismiss-key="add-new-company-pension-groups" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Minimum contributions for workplace pension compliance">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSet your contributions to match what you have set up with your pension provider. Please make sure that you do not go below the minimum contribution requirements set by The\n\t\t\t\t\tPensions Regulator to ensure workplace pension compliance.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Groups-->\n\t<fieldset class="pension-scheme-group_wrapper">\n\t\t<pension-scheme-group group="group" index="$index" ng-repeat="group in vm.pension.PensionGroups" on-group-delete="deletePensionGroup(vm.pension.PensionGroups, $index)" pension-groups="vm.pension.PensionGroups" pension-type="vm.pension.PensionType"></pension-scheme-group>\n\t</fieldset>\n\n\t<!-- Add group -->\n\t<div class="form-content-block">\n\t\t<button class="is-medium-large is-white is-block" ng-click="addNewPensionGroup(vm)" type="button">\n\t\t\t<i class="icon-add m button_icon-pre"></i>Add another group\n\t\t</button>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!addNewCompanyPensionGroupsForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionGroupsForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-postponement/addNewCompanyPensionPostponementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyPensionPostponementForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyPensionPostponementForm(company, pension, addNewCompanyPensionPostponementForm)" novalidate>\n\n\t<!-- Team postponement -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Team postponement</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tPostponement can be applied to new employees who join the team or those employees who pass through the relevant age and earnings thresholds up to a maximum of three months. These can\n\t\t\t\talso be set later in the Pension page for this company.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionStartDate" underline="true">\n\t\t\t\t\tRead more about pension staging/start\n\t\t\t\t</support-article-link>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- New team member postponement -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="newStarterPostponement">\n\t\t\t\t\t\tNew team member postponement:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select class="l-alt" id="newStarterPostponement" name="newStarterPostponement" ng-model="pension.NewStarterPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in postponementOptions">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Threshold change postponement -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="eligiblePostponement">\n\t\t\t\t\t\tThreshold change postponement:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select class="l-alt" id="eligiblePostponement" name="eligiblePostponement" ng-model="pension.EligibleWorkerPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in postponementOptions">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!addNewCompanyPensionPostponementForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionPostponementForm.state"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-provider/addNewCompanyPensionProviderForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addNewCompanyPensionSettingsForm" ng-if="pageState === \'ready\'" ng-submit="saveNewCompanyPensionSettings(pension, pensionProviders, addNewCompanyPensionSettingsForm)" novalidate>\n\t<div class="form-intro">\n\t\t<h4>Choose your pension provider</h4>\n\t\t<p class="s">\n\t\t\tYou should have already chosen your workplace pension provider and have a compliant scheme in place for your team.\n\t\t\tTell us if this is a new scheme or not then choose your provider from the options below.\n\t\t</p>\n\t</div>\n\n\t<fieldset class="form-fieldset-divider">\n\n\t\t<!-- Is this a new pension scheme? -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">\n\t\t\t\t\tIs this a new pension scheme?\n\t\t\t\t</label>\n\t\t\t\t<p class="s">\n\t\t\t\t\ti.e. no contributions have been made into it yet\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<!-- Yes -->\n\t\t\t\t<input class="b" id="isNewPensionSchemeTrue" name="isNewPensionScheme" ng-model="pension.IsNewScheme" ng-value="true" type="radio">\n\t\t\t\t<label for="isNewPensionSchemeTrue">Yes</label>\n\t\t\t\t<!-- No -->\n\t\t\t\t<input class="b" id="isNewPensionSchemeFalse" name="isNewPensionScheme" ng-model="pension.IsNewScheme" ng-value="false" type="radio">\n\t\t\t\t<label for="isNewPensionSchemeFalse">No</label>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\n\t<!-- Direct connect providers -->\n\t<fieldset class="form-fieldset-divider" ng-if="directConnectionProviders.length > 0">\n\t\t<!-- Direct providers -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="{{pension.manuallyEnterPension ? \'disabled\' : \'required\'}}" for="pensionProvider0">\n\t\t\t\t\tDirect connection providers\n\t\t\t\t</label>\n\t\t\t\t<p class="s">\n\t\t\t\t\tPaycircle can connect to these providers directly to send and receive data.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="pension-provider-cards cards is-fixed">\n\t\t\t\t\t<div class="pension-provider-card-radio" ng-repeat="pensionProvider in directConnectionProviders">\n\t\t\t\t\t\t<input class="pension-provider-card-radio-input" data-cy="pension-provider-direct-{{::$index}}" id="pensionProvider{{$index}}" name="pensionProviders" ng-change="onPensionProviderSelect(pension, pensionProvider)" ng-class="{\'is-faded\': addNewCompanyPensionSettingsForm.pensionProviders.$valid}" ng-disabled="pension.manuallyEnterPension" ng-model="pension.PensionProviderID" ng-required="!pension.manuallyEnterPension" ng-value="pensionProvider.PensionProviderID" type="radio">\n\t\t\t\t\t\t<label class="pension-provider-card-radio-label" for="pensionProvider{{$index}}">\n\t\t\t\t\t\t\t<img alt="{{pensionProvider.PensionProviderName}}" class="pension-provider-card-logo" ng-src="{{pensionProvider.PensionProviderImageUrl}}">\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Manual providers -->\n\t<fieldset class="form-fieldset-divider">\n\n\t\t<!-- Manual providers -->\n \t\t<div class="form-field" ng-if="manualProviders.length > 0">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="{{pension.manuallyEnterPension ? \'disabled\' : \'required\'}}" for="manualPensionProvider0">\n\t\t\t\t\tManual providers\n\t\t\t\t</label>\n\t\t\t\t<p class="s">\n\t\t\t\t\tYou will need to upload your pension file to these providers each time you run payroll and manage your\n\t\t\t\t\tteams&apos; opt in and opt out requests manually.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split">\n\t\t\t\t\t<div class="radio-card" ng-repeat="pensionProvider in manualProviders">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="pension-provider-manual-{{::$index}}" id="manualPensionProvider{{$index}}" name="pensionProviders" ng-change="onPensionProviderSelect(pension, pensionProvider)" ng-disabled="pension.manuallyEnterPension" ng-model="pension.PensionProviderID" ng-required="!pension.manuallyEnterPension" ng-value="pensionProvider.PensionProviderID" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="manualPensionProvider{{$index}}">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">{{pensionProvider.PensionProviderName}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n \t</fieldset>\n\n \t<fieldset>\n\n\t\t<!-- Pension provider not shown -->\n\t\t<div class="form-field">\n\t\t\t<input checkbox id="manuallyEnterPension" label-text="\'My provider isn&#8217;t shown above\'" name="manuallyEnterPension" ng-change="toggleManuallyEnterPension(pension)" ng-model="pension.manuallyEnterPension" type="checkbox">\n\t\t</div>\n\n\t\t<!-- Pension provider name -->\n\t\t<div class="form-field fadeIn" ng-if="pension.manuallyEnterPension">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="manualPensionName">\n\t\t\t\t\tEnter your provider name\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="manualPensionName" name="manualPensionName" ng-model="pension.PensionProviderName" type="text" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionSettingsForm.manualPensionName.$touched" ng-messages="addNewCompanyPensionSettingsForm.manualPensionName.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter pension provider name</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="addNewCompanyPensionSettingsForm.state === \'saved\'" state="addNewCompanyPensionSettingsForm.state">\n\t\t\t<p>Company pay period info has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" data-cy="secondary-action-cancel" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!addNewCompanyPensionSettingsForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionSettingsForm.state"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-settings/addNewCompanyPensionSettingsForm.html','<form class="fadeIn" name="addNewCompanyPensionSettingsForm" ng-submit="saveNewCompanyPensionSettings(vm, addNewCompanyPensionSettingsForm)" novalidate>\n\t<div class="form-intro">\n\t\t<h4>Pension settings</h4>\n\t</div>\n\n\t<fieldset>\n\t\t<!-- Scheme reference (AE pensions only, disabled if connected to provider) -->\n\t\t<div class="form-section" ng-class="{\n\t\t\t\t\'is-disabled\' : vm.pension.ConnectToProvider\n\t\t\t}" ng-if="vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="hasSchemeReference">Do you wish to add a scheme reference number?</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceTrue" name="hasSchemeReference" ng-model="vm.pension.HasSchemeReference" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceFalse" name="hasSchemeReference" ng-model="vm.pension.HasSchemeReference" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn">\n\t\t\t<!-- Scheme reference format - if AE pension and has scheme reference set. Disabled when connect to provider is set -->\n\t\t\t<div class="form-section" ng-class="{\n\t\t\t\t\t\'is-disabled\' : vm.pension.ConnectToProvider\n\t\t\t\t}" ng-if="vm.pension.HasSchemeReference && vm.pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="schemeReferenceFormat">\n\t\t\t\t\t\t\tScheme reference format:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select id="schemeReferenceFormat" name="schemeReferenceFormat" ng-model="vm.pension.SchemeReferenceDisplayType" ng-options="schemeReferenceDisplayType.id as schemeReferenceDisplayType.description for schemeReferenceDisplayType in PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS" required></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Education employer number fields (when display type is education employer number)-->\n\t\t\t<fieldset ng-if="\n\t\t\t\t\tvm.pension.SchemeReferenceDisplayType === PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber &&\n\t\t\t\t\tvm.pension.HasSchemeReference">\n\t\t\t\t<!-- Local authority number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="localAuthorityNumber">\n\t\t\t\t\t\t\tLocal authority number:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l-alt" id="localAuthorityNumber" name="localAuthorityNumber" ng-model="vm.pension.LocalAuthorityNumber" type="text" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionSettingsForm.localAuthorityNumber.$touched" ng-messages="addNewCompanyPensionSettingsForm.localAuthorityNumber.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter local authority number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Establishment number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="establishmentNumber">\n\t\t\t\t\t\t\tEstablishment number:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l-alt" id="establishmentNumber" name="establishmentNumber" ng-model="vm.pension.EstablishmentNumber" type="text" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionSettingsForm.establishmentNumber.$touched" ng-messages="addNewCompanyPensionSettingsForm.establishmentNumber.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter establishment number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Employer Pension Scheme Reference (when display type is employerReference) -->\n\t\t\t<fieldset ng-if="\n\t\t\t\t\tvm.pension.SchemeReferenceDisplayType === PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference &&\n\t\t\t\t\tvm.pension.HasSchemeReference">\n\t\t\t\t<pension-scheme-employer-reference-field connect-to-provider="vm.pension.ConnectToProvider" employer-reference="vm.pension.EmployerReference" pension-provider-id="vm.pension.selectedPensionProviderObj.PensionProviderID" pension-type="vm.pension.PensionType"></pension-scheme-employer-reference-field>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t\t<!-- Pension description -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pensionDescription">Description:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="pensionDescription" maxlength="128" name="pensionDescription" ng-model="vm.pension.PensionDescription" placeholder="Enter a description" type="text">\n\t\t\t</main>\n\t\t\t<p class="form-message fadeIn">This is optional and can be useful if you&apos;re connecting more than one pension from the same provider.</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- Tax relief type -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="taxReliefType">Tax relief type:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select class="l-alt" id="taxReliefType" name="taxReliefType" ng-model="vm.pension.TaxReliefType" ng-options="taxReliefType.id as taxReliefType.description for taxReliefType in TAX_RELIEF_TYPES" required></select>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- Pension period alignment -->\n\t\t<div class="form-content-block no-margin top">\n\t\t\t<div class="form-field">\n\t\t\t\t<p class="is-small">The alignment settings you select below will apply to all pension periods. If you&apos;re unsure what to select we suggest leaving it as &apos;Same as pay periods&apos; for now. This can be edited later from your &apos;Pensions&apos; page.</p>\n\t\t\t\t<br>\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\tPension period alignment:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentSame" name="periodAlignment" ng-model="vm.pension.HasPensionDateOffset" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="periodAlignmentSame" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Same as pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentDifferent" name="periodAlignment" ng-model="vm.pension.HasPensionDateOffset" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="periodAlignmentDifferent" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Different to pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field" ng-if="vm.pension.HasPensionDateOffset">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\tOffset to:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="afterPayDate" name="beforePayDate" ng-change="onOffsetTypeChange(vm)" ng-model="vm.isBeforePeriodDate" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label for="afterPayDate">\n\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="afterPayDateOffset" max="21" min="0" ng-model="vm.pensionDateAfterOffset" ng-required="!vm.isBeforePeriodDate" ng-readonly="vm.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t<span ng-if="vm.pensionDateAfterOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionDateAfterOffset" when="{\'1\': \'day later than pay periods\',\n\t\t\t\t\t\t\t\t\t\t       \'other\': \'days later than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionDateAfterOffset">days later than pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionSettingsForm.afterPayDateOffset.$touched" ng-messages="addNewCompanyPensionSettingsForm.afterPayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="beforePayDate" name="afterPayDate" ng-change="onOffsetTypeChange(vm)" ng-model="vm.isBeforePeriodDate" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label for="beforePayDate">\n\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="beforePayDateOffset" max="21" min="0" ng-model="vm.pensionDateBeforeOffset" ng-required="vm.isBeforePeriodDate" ng-readonly="!vm.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t<span ng-if="vm.pensionDateBeforeOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.pensionDateBeforeOffset" when="{\'1\': \'day earlier than pay periods\',\n\t\t\t\t\t\t\t\t\t\t       \'other\': \'days earlier than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="!vm.pensionDateBeforeOffset">days earlier than pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionSettingsForm.beforePayDateOffset.$touched" ng-messages="addNewCompanyPensionSettingsForm.beforePayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message primary">Max. offset is 21 days.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button type="button" class="button secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">\n\t\t\tBack\n\t\t</button>\n\t\t<button type="button" class="button secondary-action" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!addNewCompanyPensionSettingsForm.$valid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionSettingsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/addNewCompany/pension-staging/addNewCompanyPensionStagingForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="addNewCompanyPensionStagingForm" ng-submit="saveNewCompanyPensionStaging(vm, addNewCompanyPensionStagingForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Staging/start date -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Pension staging/start date</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tTell us the company\'s staging/start date and whether they chose to postpone, and the next re-enrolment date.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Start date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="stagingDate">\n\t\t\t\t\tStart Date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="stagingDate" field-max-date-iso="vm.stagingDateBoundaries.stagingDateISOMax" field-value-iso="vm.pension.StagingDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionStagingForm.stagingDate.$touched" ng-messages="addNewCompanyPensionStagingForm.stagingDate.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter start date\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="date">\n\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="max">\n\t\t\t\t\tPlease enter a date before {{vm.stagingDateBoundaries.stagingDateISOMax | dateformat}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Start date postponed -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="stagingPostponed">\n\t\t\t\t\tAre you postponing your start date?\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\n\t\t\t\t<!-- Yes -->\n\t\t\t\t<input type="radio" name="stagingPostponed" id="stagingPostponedTrue" class="b" ng-value="true" ng-model="vm.pension.IsStagingPostponed">\n\t\t\t\t<label for="stagingPostponedTrue">\n\t\t\t\t\tYes\n\t\t\t\t</label>\n\n\t\t\t\t<!-- No -->\n\t\t\t\t<input type="radio" name="stagingPostponed" id="stagingPostponedFalse" class="b" ng-value="false" ng-model="vm.pension.IsStagingPostponed">\n\t\t\t\t<label for="stagingPostponedFalse">\n\t\t\t\t\tNo\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Staging postponement date -->\n\t\t<div class="form-field fadeIn" ng-if="vm.pension.IsStagingPostponed">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="stagingPostponementDate">\n\t\t\t\t\tPostponement date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="stagingPostponementDate" field-min-date-iso="vm.postponementDateBoundaries.postponedDateMinISO" field-max-date-iso="vm.postponementDateBoundaries.postponedDateMaxISO" field-value-iso="vm.pension.PostponementDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionStagingForm.stagingPostponementDate.$touched" ng-messages="addNewCompanyPensionStagingForm.stagingPostponementDate.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter staging postponement date\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="date">\n\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="min || max">\n\t\t\t\t\tThis date needs to be between {{vm.postponementDateBoundaries.postponedDateMinISO | dateformat:\'long\'}} - {{vm.postponementDateBoundaries.postponedDateMaxISO | dateformat:\'long\'}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: Calculating contributions -->\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Calculating contributions">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPaycircle cannot calculate past or missed contributions, only contributions from when the pension is set up on Paycircle. Any missed contributions or fines need to be dealt\n\t\t\t\t\t\twith directly with The Pensions Regulator.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Re-enrolment info -->\n\t\t<div class="form-field" ng-if="vm.validationResults">\n\t\t\t<p class="is-small">\n\t\t\t\t<span class="fadeIn" ng-if="!vm.validationResults.CompanyIsInReenrolmentWindow">\n\t\t\t\t\tYour re-enrolment date is the third anniversary of your start date. You can adjust this to a date within a 6 month window however.\n\t\t\t\t</span>\n\t\t\t\t<span class="fadeIn" ng-if="vm.validationResults.CompanyIsInReenrolmentWindow">\n\t\t\t\t\tBased on the start date entered, you\u2019re currently in your 6 month re-enrolment window ({{vm.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'dayMonth\'}} -\n\t\t\t\t\t{{vm.validationResults.ReenrolmentWindowEndDateISO | dateformat:\'dayMonthYear\'}}) and you may have completed re-enrolment.\n\t\t\t\t</span>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Staging date in Re-enrolment window (3 years before current period start date) -->\n\t\t<fieldset class="fadeIn" ng-if="vm.validationResults.CompanyIsInReenrolmentWindow">\n\n\t\t\t<!-- Completed re-enrolment -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="reenrolmentCompleted">\n\t\t\t\t\t\tHave you already completed re-enrolment?\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t<!-- Yes -->\n\t\t\t\t\t<input class="b" id="reenrolmentCompletedTrue" name="reenrolmentCompleted" ng-model="vm.pension.ReenrolmentAlreadyCompleted" ng-value="true" type="radio">\n\t\t\t\t\t<label for="reenrolmentCompletedTrue">\n\t\t\t\t\t\tYes\n\t\t\t\t\t</label>\n\n\t\t\t\t\t<!-- No -->\n\t\t\t\t\t<input class="b" id="reenrolmentCompletedFalse" name="reenrolmentCompleted" ng-model="vm.pension.ReenrolmentAlreadyCompleted" ng-value="false" type="radio">\n\t\t\t\t\t<label for="reenrolmentCompletedFalse">\n\t\t\t\t\t\tNo\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Re-enrolment completion date -->\n\t\t\t<div class="form-field fadeIn" ng-if="vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="reenrolmentCompletionDate">Completion date:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="reenrolmentCompletionDate" field-min-date-iso="vm.validationResults.ReenrolmentWindowStartDateISO" field-max-date-iso="vm.validationResults.ReenrolmentWindowEndDateISO" field-value-iso="vm.pension.ReenrolmentCompletionDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionStagingForm.reenrolmentCompletionDate.$touched" ng-messages="addNewCompanyPensionStagingForm.reenrolmentCompletionDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter a completion date\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="date">\n\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="min || max">\n\t\t\t\t\t\tThis date needs to be between {{vm.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'long\'}} - {{vm.validationResults.ReenrolmentWindowEndDateISO  | dateformat:\'long\'}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Re-enrolment date -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="!vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t\tRe-enrolment date:\n\t\t\t\t</label>\n\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="vm.pension.ReenrolmentAlreadyCompleted">\n\t\t\t\t\tNext re-enrolment date:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="reenrolmentDate" field-value-iso="vm.pension.ReenrolmentDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionStagingForm.reenrolmentDate.$touched" ng-messages="addNewCompanyPensionStagingForm.reenrolmentDate.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter a re-enrolment date\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="date">\n\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: Check re-enrolment date -->\n\t\t<div class="form-field fadeIn" ng-if="!vm.validationResults.IsValid && vm.validationResults.ReenrolmentDateISO">\n\t\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="assertive is-form-field" note-title="Check your re-enrolment date">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour re-enrolment date should be between {{vm.validationResults.ReenrolmentDateMinISO | dateformat}} - {{vm.validationResults.ReenrolmentDateMaxISO | dateformat}}.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Include opted out team members -->\n\t\t<div class="form-field">\n\t\t\t<input checkbox id="reenrolRecentOptOuts" label-text="\'Include team members who opt out in the 12 months prior to re-assessment for re-enrolment\'" name="reenrolRecentOptOuts" ng-model="vm.pension.ReenrolRecentOptOuts" type="checkbox">\n\t\t</div>\n\n\t\t<!-- Note: Connecting multiple pensions -->\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Connecting multiple pensions">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour re-enrolment date is for your company rather than this particular workplace pension. As this is the first pension you\u2019re connecting, you won\u2019t need to add your\n\t\t\t\t\t\tre-enrolment date again later if you decide to connect another pension later.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- DoC -->\n\t<fieldset class="form-fieldset-divider-top" ng-if="!vm.company.EmployerDetails.IsNewCompany">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Declaration of Compliance</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tA Declaration of Compliance must be submitted to The Pensions Regulator within 5 months of your pension duties start date and then every 3 years, when your team are assessed for re-enrolment.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- TPR letter code -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="tprLetterCode">\n\t\t\t\t\t<abbr class="underline" tooltip tooltip-text="The Pensions Regulator" tooltip-position="right">TPR</abbr> letter code:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="m" id="tprLetterCode" name="tprLetterCode" ng-maxlength="10" ng-model="vm.pension.PensionLetterCode" ng-pattern="$root.REGEX.tprLetterCode" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="addNewCompanyPensionStagingForm.tprLetterCode.$touched" ng-messages="addNewCompanyPensionStagingForm.tprLetterCode.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\tPlease enter a valid TPR letter code (10 digits, starting with a "1")\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="maxlength">\n\t\t\t\t\tPlease enter only 10 digits\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: TPR letter code -->\n\t\t<div class="form-field">\n\t\t\t<note note-icon="icon-support" note-theme="indifferent is-form-field">\n\t\t\t\t<note-header>\n\t\t\t\t\tDon\u2019t know your\n\t\t\t\t\t<abbr class="underline" tooltip tooltip-position="right" tooltip-text="The Pensions Regulator">\n\t\t\t\t\t\tTPR\n\t\t\t\t\t</abbr> letter code?\n\t\t\t\t</note-header>\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou can find it out on the\n\t\t\t\t\t\t<abbr class="underline" tooltip tooltip-position="right" tooltip-text="The Pensions Regulator">\n\t\t\t\t\t\t\tTPR\n\t\t\t\t\t\t</abbr> website using your references:\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class="stat-list basic plain-text">\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key">\n\t\t\t\t\t\t\t\tAccounts office reference:\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t\t\t\t{{vm.company.EmployerDetails.AccountsOffice}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key">\n\t\t\t\t\t\t\t\tPAYE reference:\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="stat-list__value">\n\t\t\t\t\t\t\t\t{{vm.company.EmployerDetails.TaxOffice}}/{{vm.company.EmployerDetails.TaxOfficeReference}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<a class="s indifferent-darkened underline" href="" ng-href="{{$root.URLS.tpr.letterCode}}" target="_blank">\n\t\t\t\t\t\tFind out your TPR letter code now\n\t\t\t\t\t</a>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Has the Declaration of Compliance (DoC) been submitted? -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required">\n\t\t\t\t\tHas the Declaration of Compliance (DoC) been submitted?\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-list">\n\n\t\t\t\t\t<!-- Yes -->\n\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedTrue" class="b" ng-value="true" ng-model="vm.pension.DOCSubmitted">\n\t\t\t\t\t<label for="docSubmittedTrue">\n\t\t\t\t\t\tYes\n\t\t\t\t\t</label>\n\n\t\t\t\t\t<!-- No -->\n\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedFalse" class="b" ng-value="false" ng-model="vm.pension.DOCSubmitted">\n\t\t\t\t\t<label for="docSubmittedFalse">\n\t\t\t\t\t\tNo\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<button class="secondary-action" data-cy="secondary-action-back" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!addNewCompanyPensionStagingForm.$valid || !vm.validationResults.IsValid" display-text="formOptions.primaryButtonText" state="addNewCompanyPensionStagingForm.state"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/access/companySettingsAddOfficeLocationsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<form name="addOfficeLocationsForm" ng-submit="updateOfficeLocations(addOfficeLocationsForm, ipAddresses)" class="fadeIn" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<p class="s">All admins will automatically be granted sign in access from these locations.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<note note-title="What is my IP address?" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">If you are unsure of your IP address visit <a class="indifferent" href="https://whatismyipaddress.com/">What is my IP address</a> from the location you want to access paycircle from.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<office-location-form-field show-delete="showAddLocation" ng-repeat="ipAddress in ipAddresses" ip-address="ipAddress" on-delete="deleteOfficeLocation(ipAddress, ipAddresses)" index="$index" name="officeLocation"></office-location-form-field>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="addOfficeLocationsForm.state" disable-button="!addOfficeLocationsForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\t<button class="is-medium-large is-white is-block" ng-click="addOfficeLocation(ipAddresses)" ng-if="showAddLocation" type="button">\n\t\t<i class="icon-add m button_icon-pre"></i> Add location\n\t</button>\n</div>\n\n<!-- Add success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Office locations saved" ng-if="pageState === \'save-success\'">\n\t<fs-main>\n\t\t<p class="s">Your new office locations have been saved and anyone working from those locations will have sign in access.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/access/companySettingsAuthenticationSessionForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsAuthenticationSessionForm" ng-submit="updateCompanyAuthenticationDetails(vm, companySettingsAuthenticationSessionForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-section">\n\t\t<note note-title="Session timeout while running payroll" note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-dismiss-key="authentication-session">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">If you are timed out while payroll is running it will not affect the payroll process, simply log back in.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="sessionDuration">Session duration:</label>\n\t\t\t\t\t<p>Set the session duration before people are signed out of their accounts after a period of inactivity.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<ul class="option-tabs">\n\t\t\t\t\t\t<a href="" class="option-tab" ng-class="{\'active\': vm.sessionTimeoutOption === SESSION_DURATION_OPTIONS.fifteen}" ng-click="onSessionTimeoutChange(vm, SESSION_DURATION_OPTIONS.fifteen)">15</a>\n\t\t\t\t\t\t<a href="" class="option-tab" ng-class="{\'active\': vm.sessionTimeoutOption === SESSION_DURATION_OPTIONS.thirty}" ng-click="onSessionTimeoutChange(vm, SESSION_DURATION_OPTIONS.thirty)">30</a>\n\t\t\t\t\t\t<a href="" class="option-tab" ng-class="{\'active\': vm.sessionTimeoutOption === SESSION_DURATION_OPTIONS.custom}" ng-click="onSessionTimeoutChange(vm, SESSION_DURATION_OPTIONS.custom)">Custom</a>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="vm.sessionTimeoutOption === SESSION_DURATION_OPTIONS.custom">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<duration-input field-model="vm.companyAuthentication.SessionTimeout" field-name="sessionTimeout" field-required="true" field-show-divisions="[\'minutes\', \'hours\']">\n\t\t\t\t\t</duration-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="timeoutWarning">Timeout warning:</label>\n\t\t\t\t<p>Set the time period the user receives a warning before being automatically logged out.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<duration-input field-model="vm.companyAuthentication.SessionTimeoutWarning" field-name="timeoutWarning" field-show-divisions="[\'minutes\']" field-validation="{\'minutes\': vm.companyAuthentication.SessionTimeout }">\n\t\t\t\t</duration-input>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<div class="form-section" ng-if="!vm.tfaIsEnabled && vm.originalTfaIsEnabled">\n\t\t<note note-title="Are you sure you wish to disable two-factor authentication?" note-theme="tertiary" note-icon="icon-warning">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour account is more secure when you need a password and a verification code to sign in. If you remove this extra layer of security, you will only be asked for a password when you sign in. It might be easier for someone to break into the system.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsAuthenticationSessionForm.state" disable-button="companySettingsAuthenticationSessionForm.$invalid || vm.companyAuthentication.SessionTimeout === 0"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/access/companySettingsAuthenticationSsoForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsAuthenticationSsoForm" ng-submit="updateCompanyAuthenticationSsoDetails(vm, companySettingsAuthenticationSsoForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\t<div class="form-section">\n\t\t<settings-row sr-disabled="vm.toggleDisabled" sr-field-name="oidcEnabled" sr-icon="login" ng-model="vm.companyAuthentication.OIDCEnabled">\n\t\t\t<sr-label>Single-sign on</sr-label>\n\t\t\t<sr-description>Turning on Single sign-on means your bureau team can authenticate themselves\n\t\t\t\tusing their SSO ID rather than using Paycircle credentials.\n\t\t\t</sr-description>\n\t\t\t<sr-content ng-if="vm.companyAuthentication.OIDCEnabled">\n\t\t\t\t<fieldset class="fadeIn">\n\n\t\t\t\t\t<!-- SSO Provider options -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="ssoProvider" class="required">Single sign-on provider:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards-50-50">\n\t\t\t\t\t\t\t\t<!-- Remove ng-if when all options are available. Remove this comment too, otherwise\n\t\t\t\t\t\t\t\t     it might just get confusing -->\n\t\t\t\t\t\t\t\t<div class="radio-card" ng-repeat="oidcOption in OIDC_OPTIONS" ng-if="oidcOption.isImplemented">\n\t\t\t\t\t\t\t\t\t<input class="radio-card-input" id="{{oidcOption.key}}" name="oidcOptions" ng-model="vm.companyAuthentication.OIDCSystem" ng-value="oidcOption.value" type="radio">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="{{oidcOption.key}}">\n\t\t\t\t\t\t\t\t\t\t<img alt="{{oidcOption.name}}" class="radio-card-image" src="{{oidcOption.logo}}">\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- Azure -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="vm.companyAuthentication.OIDCSystem === OIDC_SYSTEMS.azure">\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="ssoApplicationId" class="required">Application ID:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="ssoApplicationId" name="ssoApplicationId" type="text" ng-model="vm.companyAuthentication.OIDCClientID" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsAuthenticationSsoForm.ssoApplicationId.$error" ng-if="companySettingsAuthenticationSsoForm.ssoApplicationId.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the Application ID</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="ssoTenantId" class="required">Tenant ID:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="ssoTenantId" name="ssoTenantId" type="text" ng-model="vm.companyAuthentication.OIDCTenantID" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsAuthenticationSsoForm.ssoTenantId.$error" ng-if="companySettingsAuthenticationSsoForm.ssoTenantId.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the Tenant ID</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- okta -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="vm.companyAuthentication.OIDCSystem === OIDC_SYSTEMS.okta">\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="ssoClientId" class="required">Client ID:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="ssoClientId" name="ssoClientId" type="text" ng-model="vm.companyAuthentication.OIDCClientID" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsAuthenticationSsoForm.ssoClientId.$error" ng-if="companySettingsAuthenticationSsoForm.ssoClientId.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the client ID</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="ssoDomain" class="required">Domain:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="ssoDomain" name="ssoDomain" type="text" ng-model="vm.companyAuthentication.OIDCDomain" required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsAuthenticationSsoForm.ssoDomain.$error" ng-if="companySettingsAuthenticationSsoForm.ssoDomain.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter the domain</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<!-- xero -->\n\t\t\t\t<fieldset class="fadeIn" ng-if="vm.companyAuthentication.OIDCSystem === OIDC_SYSTEMS.xero">\n\t\t\t\t\t<!-- Put whatever xero wants here. -->\n\t\t\t\t</fieldset>\n\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\n\t<div class="form-section" ng-if="vm.noteTitle && vm.noteContent">\n\t\t<note note-theme="tertiary" note-title="{{vm.noteTitle}}" note-icon="icon-warning">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t{{vm.noteContent}}\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companySettingsAuthenticationSsoForm.$valid || vm.saveButtonDisabled" display-text="formOptions.primaryButtonText" state="companySettingsAuthenticationSsoForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/access/companySettingsAuthenticationTfaForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsAuthenticationTfaForm" ng-submit="updateCompanyAuthenticationDetails(vm, companySettingsAuthenticationTfaForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-section">\n\t\t<note ng-if="vm.logoutOnSave && !vm.originalTfaIsEnabled && !vm.isIdentityEnabled" note-title="Enabling two-factor authentication will log you out" note-theme="assertive" note-icon="icon-warning">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">If you are enabling two-factor authentication for the first time you will be automatically logged out of the system once you click \'Save\'. You will then be required to authenticate when you log back in again.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div class="form-section">\n\t\t<settings-row sr-field-name="tfaIsEnabled" sr-icon="mobile" ng-model="vm.tfaIsEnabled" sr-disabled="vm.isIdentityEnabled">\n\t\t\t<sr-label>Two-factor authentication</sr-label>\n\t\t\t<sr-description ng-if="!vm.tfaIsEnabled">Turning this on will require <span class="stronger">users of the payroll portal</span> to configure two-factor authentication the next time they sign in. <br></sr-description>\n\t\t\t<sr-description ng-if="vm.tfaIsEnabled">Disabling two-factor authentication will remove this extra layer of security, you will only be asked for a password when you sign in. <br></sr-description>\n\t\t\t<sr-content ng-if="vm.tfaIsEnabled">\n\t\t\t\t<fieldset class="fadeIn">\n\n\t\t\t\t\t<!-- Re-authentication period -->\n\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t<label for="reauthPeriodLogin">Re-authentication period:</label>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-cards">\n\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input type="radio" name="reauthPeriod" id="reauthPeriodLogin" class="radio-card-input" ng-value="TFA_STATES.login" ng-model="vm.companyAuthentication.TwoFAState" required ng-change="onPeriodTypeChange(vm)">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="reauthPeriodLogin">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-login radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">Every sign in</p>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t<input type="radio" name="reauthPeriod" id="reauthPeriodTime" class="radio-card-input" ng-value="TFA_STATES.timePeriod" ng-model="vm.companyAuthentication.TwoFAState" required ng-change="onPeriodTypeChange(vm)">\n\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="reauthPeriodTime">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-clock radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">Time period</p>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\n\t\t\t\t<fieldset class="fadeIn" ng-if="vm.companyAuthentication.TwoFAState === TFA_STATES.timePeriod">\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<h6>Re-authentication time period:</h6>\n\t\t\t\t\t\t<p class="is-small">Paycircle recommend re-authenticating every&nbsp;<ng-pluralize count="DEFAULT_TIME_PERIOD_DAYS" when="{\'1\': \'day\', \'other\': \'{} days\'}"></ng-pluralize></p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Time period -->\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<duration-input field-model="vm.companyAuthentication.TwoFATimePeriod" field-name="reauthTimePeriod"></duration-input>\n\t\t\t\t\t</div>\n\n\t\t\t\t</fieldset>\n\t\t\t</sr-content>\n\t\t\t<sr-content ng-if="!vm.tfaIsEnabled && vm.isIdentityEnabled">\n\t\t\t\t<div class="spacer m"></div>\n\t\t\t\t<note note-title="Two-factor authentication and your Access account" note-theme="tertiary" note-icon="icon-warning" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Please note that two-factor authentication is now disabled in Paycircle and should be enabled using your Access account.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\t<div class="form-section" ng-if="!vm.tfaIsEnabled && vm.originalTfaIsEnabled">\n\t\t<note note-title="Are you sure you wish to disable two-factor authentication?" note-theme="tertiary" note-icon="icon-warning">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Your account is more secure when you need a password and a verification code to sign in. If you remove this extra layer of security, you will only be asked for a password when you sign in. It might be easier for someone to break into the system.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsAuthenticationTfaForm.state" disable-button="!companySettingsAuthenticationTfaForm.$valid || vm.isIdentityEnabled"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/access/companySettingsEditRemoteLocationsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<form name="editRemoteLocations" ng-submit="updateRemoteLocations(editRemoteLocations, teamMemberAdmins)" class="fadeIn" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<p class="s">To give an admin remote access, add their remote IP address below.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<note note-title="What is my IP address?" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">If you are unsure of your IP address visit <a class="indifferent" href="https://whatismyipaddress.com/">What is my IP address</a> from the location you want to access paycircle from.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<remote-location-form-field ng-repeat="teamMemberAdmin in teamMemberAdmins" show-delete="showDelete" team-member-admin="teamMemberAdmin" index="$index" name="remoteLocation"></remote-location-form-field>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Save\'" state="editRemoteLocations.state" disable-button="!editRemoteLocations.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n</div>\n\n<!-- Add success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Remote locations saved" ng-if="pageState === \'save-success\'">\n\t<fs-main>\n\t\t<p class="s">Your new remote locations have been saved and admins working from those locations will have sign in access.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/access/deleteOfficeLocationForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteOfficeLocationForm" ng-submit="deleteOfficeLocation(deleteOfficeLocationForm, officeLocation)">\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this location?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">Once deleted, any admins logging in from &lsquo;{{officeLocation.Description}}&rsquo; will no longer be able to access the system.\n\t\t\t\tIf you\u2019re happy to continue, click &lsquo;Delete&rsquo;.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Delete\'" state="deleteOfficeLocationForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<!-- Success -->\n\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Office location deleted" ng-if="pageState === \'success\'">\n\t\t<fs-main>\n\t\t\t<p class="s">The &lsquo;{{officeLocation.Description}}&rsquo; office location has been deleted.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tClose\n\t\t\t</button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/access/deleteRemoteLocationForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteRemoteLocationForm" ng-submit="deleteRemoteLocation(deleteRemoteLocationForm, teamMemberAdmins)" ng-if="pageState !== \'loading\'">\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-icon="warning" fs-title="Are you sure you wish to delete this IP address?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">If you\u2019re happy to remove the IP address for {{teamMemberAdmin.Forename}} {{teamMemberAdmin.Surname}}, click &lsquo;Delete&rsquo;.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="\'Delete\'" state="deleteRemoteLocationForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<!-- Success -->\n\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Remote location deleted" ng-if="pageState === \'success\'">\n\t\t<fs-main>\n\t\t\t<p class="s">The IP address for {{teamMemberAdmin.Forename}} {{teamMemberAdmin.Surname}}\'s remote location has been deleted.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tClose\n\t\t\t</button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/bacs/companySettingsBacsForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<!-- BACS -->\n<form class="fadeIn" name="companySettingsBacsForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="reviewCompanyBACSDetails(vm, companySettingsBacsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tFirst turn on BACS file creation and add your settings before moving on to select which payments to include in your BACS file. We\u2019ll also let you know if any team members are missing bank details.\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<settings-row ng-model="vm.companyBankDetails.BACSEnabled" sr-field-name="bacsEnabled" sr-icon="billing">\n\t\t\t<sr-label>BACS file creation</sr-label>\n\t\t\t<sr-description>Turning this on means that a BACS file will be created each time you run payroll. You can then upload the file to your company bank account to make payments.</sr-description>\n\t\t\t<sr-content ng-if="vm.companyBankDetails.BACSEnabled">\n\t\t\t\t<fieldset class="fadeIn">\n\n\t\t\t\t\t<!-- Payment File Type -->\n\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="bankBranchName" class="required">Select your bank:</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<select id="bankBranchName" name="bankBranchName" ng-change="selectBankFileUpdate(vm)" ng-model="vm.selectedBankFile" ng-options="bank as bank.BankName for bank in vm.bankFiles track by bank.BankID" required>\n\t\t\t\t\t\t\t\t\t <option value="">Select a bank\u2026</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsBacsForm.bankBranchName.$error" ng-if="companySettingsBacsForm.bankBranchName.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select your bank</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="form-field is-logo-field">\n\t\t\t\t\t\t\t<img alt="{{vm.selectedBankFile.BankName | capitalise}}" class="form-field-logo fadeIn" ng-if="vm.selectedBankFile" src="{{vm.selectedBankFile | bankLogoUrl}}">\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<fieldset ng-if="vm.companyBankDetails.BankFileID !== $root.CONFIG.guidEmpty">\n\n\t\t\t\t\t\t<!-- Global ACH (Automated Clearing House)  -->\n\t\t\t\t\t\t<div class="fadeIn" ng-if="vm.companyBankDetails.IsGdffAvailable">\n\n\t\t\t\t\t\t\t<!-- Client identifier (also known as GDFF Client Identifier. What is one?: https://tipalti.com/ach-vs-wire/#:~:text=An%20ACH%20transfer%20(a.k.a.%20direct,network%20to%20a%20recipient\'s%20bank.) -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="gdffClientIdentifier" class="required">Client identifier:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="gdffClientIdentifier" maxlength="10" minlength="10" name="gdffClientIdentifier" ng-model="vm.companyBankDetails.GdffClientIdentifier" ng-pattern="$root.REGEX.lettersAndNumbers" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.gdffClientIdentifier.$touched" ng-messages="companySettingsBacsForm.gdffClientIdentifier.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter only letters and numbers.</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 10 characters</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a client identifier.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Customer account number (also know as GDFF Originators Account Number) -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="gdffOriginatorsAccountNumber" class="required">Customer account number:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="gdffOriginatorsAccountNumber" maxlength="10" minlength="10" name="gdffOriginatorsAccountNumber" ng-model="vm.companyBankDetails.GdffOriginatorsAccountNumber" ng-pattern="$root.REGEX.lettersAndNumbers" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsBacsForm.gdffOriginatorsAccountNumber.$error" ng-if="companySettingsBacsForm.gdffOriginatorsAccountNumber.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter an alphanumeric account number.</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 10 characters</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an originators account number.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Account Details -->\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-if="!vm.companyBankDetails.IsGdffAvailable">\n\n\t\t\t\t\t\t\t<!-- Account name -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="bankAccountName" ng-class="{ \'required\' : vm.selectedBankFile.accountNameRequired }">\n\t\t\t\t\t\t\t\t\t\tAccount name:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="bankAccountName" name="bankAccountName" ng-model="vm.companyBankDetails.BankAccountName" ng-pattern="$root.REGEX.lettersAndNumbers" ng-required="vm.selectedBankFile.accountNameRequired" type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.bankAccountName.$touched" ng-messages="companySettingsBacsForm.bankAccountName.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a bank account name.</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers and letters only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t<!-- Account Number -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="bankAccountNumber" ng-class="{ \'required\' : vm.selectedBankFile.accountNumberRequired }">\n\t\t\t\t\t\t\t\t\t\t\tAccount number:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input class="m" id="bankAccountNumber" maxlength="8" name="bankAccountNumber" ng-maxlength="8" ng-minlength="8" ng-model="vm.companyBankDetails.BankAccountNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="vm.selectedBankFile.accountNumberRequired" placeholder="12345678" type="text">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.bankAccountNumber.$touched" ng-messages="companySettingsBacsForm.bankAccountNumber.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a bank account number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="minlength || maxlength">Account number should be 8 digits</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-message">8 digits, no symbols</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Sort code -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label for="sortCode" ng-class="{ \'required\' : vm.selectedBankFile.sortCodeRequired }">\n\t\t\t\t\t\t\t\t\t\t\tSort code:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<sort-code sort-code-name="sortCode" sort-code-required="vm.selectedBankFile.sortCodeRequired" sort-code="vm.companyBankDetails.SortCode"></sort-code>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsBacsForm.sortCode.$error" ng-if="companySettingsBacsForm.sortCode.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a valid sort code</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern || minlength || maxlength">Sort code should consist of 6 numbers</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- SUN Number -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="isSunNumberApplicable(vm)">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="sunNumber" ng-class="{\'required\': isSunNumberRequired(vm)}">\n\t\t\t\t\t\t\t\t\t\tSUN Number:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input class="m" id="sunNumber" maxlength="6" name="sunNumber" ng-maxlength="8" ng-minlength="6" ng-model="vm.companyBankDetails.BACSSUNNumber" ng-pattern="$root.REGEX.numbersOnly" ng-required="isSunNumberRequired(vm)" type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.sunNumber.$touched" ng-messages="companySettingsBacsForm.sunNumber.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="minlength || maxlength">SUN number should be 6 digits</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">6 digits, no symbols</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Bank payment file type -->\n\t\t\t\t\t \t\t<div class="form-field fadeIn" ng-if="vm.companyBankDetails.IsBACSAvailable && vm.companyBankDetails.IsFPSAvailable">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label class="required">Bank payment file type:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="radio-cards">\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card" ng-if="vm.companyBankDetails.IsBACSAvailable">\n\t\t\t\t\t\t\t\t\t\t\t<input class="radio-card-input" id="bankPaymentTypeBACS" name="bankPaymentTypeBACS" ng-model="vm.companyBankDetails.BACSFileFormat" ng-value="BANK_FILE_FORMATS.bacs" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="bankPaymentTypeBACS">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">BACS</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card" ng-if="vm.companyBankDetails.IsFPSAvailable">\n\t\t\t\t\t\t\t\t\t\t\t<input class="radio-card-input" id="bankPaymentTypeFPS" name="bankPaymentTypeFPS" ng-model="vm.companyBankDetails.BACSFileFormat" ng-value="BANK_FILE_FORMATS.fps" required type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="bankPaymentTypeFPS">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-document radio-card-icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="radio-card-text">FPS</p>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">Using FPS means payments can be made immediately after payroll has been approved whereas BACS requires a 3 day turn around.</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- IBAN -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="bankIBAN">\n\t\t\t\t\t\t\t\t\t\tIBAN:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="bankIBAN" maxlength="50" name="bankIBAN" ng-model="vm.companyBankDetails.BankIBAN" type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- BIC -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="bankBIC">\n\t\t\t\t\t\t\t\t\t\tBIC:\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input class="l" id="bankBIC" name="bankBIC" ng-model="vm.companyBankDetails.BankBIC" ng-pattern="$root.REGEX.bic" type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.bankBIC.$touched" ng-messages="companySettingsBacsForm.bankBIC.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid BIC</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Payment Reference -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="bacsPaymentReference" class="required">Payment reference:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="bacsPaymentReference" name="bacsPaymentReference" ng-model="vm.companyBankDetails.BACSPaymentReference" ng-pattern="$root.REGEX.lettersAndNumbers" required type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.bacsPaymentReference.$touched" ng-messages="companySettingsBacsForm.bacsPaymentReference.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a payment reference</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter letters or numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">This will be used as the reference for all payments included in the BACS file</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<!-- Bank Template Reference -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="vm.selectedBankFile.ShowTemplateReference">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="bankTemplateReference" class="required">Template reference:</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="bankTemplateReference" name="bankTemplateReference" ng-model="vm.companyBankDetails.BankTemplateReference" ng-pattern="$root.REGEX.lettersAndNumbers" ng-required="vm.selectedBankFile.ShowTemplateReference" type="text">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBacsForm.bankTemplateReference.$touched" ng-messages="companySettingsBacsForm.bankTemplateReference.$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter a template reference</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter letters or numbers only</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">This is the Template Reference or Bulk List from which to make payments</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</fieldset>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\t<!-- Has active BACS disbursements -->\n\t<div class="form-field" ng-if="!vm.companyBankDetails.BACSEnabled && vm.disableSaving">\n\n\t\t<note note-icon="icon-warning" note-theme="tertiary is-form-field" note-title="You have active disbursements">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tYou have active disbursements set up in the pay elements in your company settings and they will need to be removed before you can turn off BACS file creation.\n\t\t\t\t\t<a ui-sref="settings.company.pay-elements.disbursements({agencyProfileId: AGENCY_PROFILE_ID})" class="tertiary underline">Go to disbursements</a>\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="companySettingsBacsForm.$invalid || !vm.companyBankDetails.BACSEnabled && vm.disableSaving" display-text="vm.companyBankDetails.BACSEnabled ? \'Next\' : \'Save\'" state="companySettingsBacsForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- Payments to include -->\n<form class="fadeIn" name="companySettingsBacsPaymentsForm" ng-if="pageState === PAGE_STATES.paymentsIncluded" ng-submit="updateCompanyBACSDetails(vm, companySettingsBacsPaymentsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Payments to include in the BACS file</h4>\n\t\t<p class="s">Select which payments you want to include in your BACS file. Any payments not included will need to be made manually. You can always come back to change these settings later.</p>\n\t</div>\n\n\t<section class="form-section">\n\t\t<div class="extended-checkbox_wrapper">\n\t\t\t<extended-checkbox name="includesAOE" ng-model="vm.companyBankDetails.includeAOE" on-change="setBacsIncludedPayments(vm)">\n\t\t\t\t<checkbox-label>\n\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Attachment of Earnings Orders</h6>\n\t\t\t\t\t<p class="is-small is-greyscale-darkened">Add bank and BACS details when you add an order for a team member</p>\n\t\t\t\t</checkbox-label>\n\t\t\t</extended-checkbox>\n\n\t\t\t<extended-checkbox name="includesChildcareVouchers" ng-model="vm.companyBankDetails.includeChildcareVouchers" on-change="setBacsIncludedPayments(vm)">\n\t\t\t\t<checkbox-label>\n\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Childcare Vouchers</h6>\n\t\t\t\t\t<p class="is-small is-greyscale-darkened">Add bank and BACS details when you add a recurring payment for a team member</p>\n\t\t\t\t</checkbox-label>\n\t\t\t</extended-checkbox>\n\n\t\t\t<extended-checkbox name="includePension{{$index+1}}" ng-if="vm.company.HasPension" ng-model="vm.companyBankDetails[\'includePension\' +($index+1)]" ng-repeat="pensionDisbursement in vm.company.PensionDisbursements" on-change="setBacsIncludedPayments(vm)">\n\t\t\t\t<checkbox-label>\n\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{pensionDisbursement.PensionName}} ({{pensionDisbursement.PensionReference}})</h6>\n\t\t\t\t\t<p class="is-small is-greyscale-darkened">Add bank and BACS details for your pension provider here</p>\n\t\t\t\t</checkbox-label>\n\n\t\t\t\t<checkbox-content>\n\t\t\t\t\t<bacs-disbursement agency-profile-id="AGENCY_PROFILE_ID" disbursement="pensionDisbursement" form="companySettingsBacsPaymentsForm" pay-period="vm.payPeriod"></bacs-disbursement>\n\t\t\t\t</checkbox-content>\n\t\t\t</extended-checkbox>\n\n\t\t\t<extended-checkbox name="includesHMRC" ng-if="vm.company.HMRCDisbursement" ng-model="vm.companyBankDetails.includeHMRC" on-change="setBacsIncludedPayments(vm)">\n\t\t\t\t<checkbox-label>\n\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">HMRC</h6>\n\t\t\t\t\t<p class="is-small is-greyscale-darkened">Use preset bank details and add BACS details for HMRC here</p>\n\t\t\t\t</checkbox-label>\n\n\t\t\t\t<checkbox-content>\n\t\t\t\t\t<bacs-disbursement agency-profile-id="AGENCY_PROFILE_ID" disbursement="vm.company.HMRCDisbursement" form="companySettingsBacsPaymentsForm" is-hmrc-payment="true" pay-period="vm.payPeriod" company-name="formOptions.company.Name"></bacs-disbursement>\n\t\t\t\t</checkbox-content>\n\t\t\t</extended-checkbox>\n\t\t</div>\n\t</section>\n\n\t<div class="form-field" ng-if="[\n\t\t\tPAY_PERIOD_TYPES.monthly,\n\t\t\tPAY_PERIOD_TYPES.weekly,\n\t\t\tPAY_PERIOD_TYPES.fortnightly,\n\t\t\tPAY_PERIOD_TYPES.fourweekly\n\t\t].includes(vm.payPeriod.PeriodType)">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="BACS payment dates">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Please note that if you set BACS payment dates to a day of the month and select the 29th, 30th or 31st, February will default to the last day of the month, as will months with 30 days if you select the 31st. </p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="setPageState(PAGE_STATES.ready)">Back</a>\n\t\t<submit-button disable-button="!companySettingsBacsPaymentsForm.$valid" display-text="\'Save\'" state="companySettingsBacsPaymentsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-show-close="!vm.companyBankDetails.BACSEnabled" fs-title="BACS settings saved" ng-if="pageState === PAGE_STATES.saved">\n\t<fs-main>\n\t\t<p class="s">Your BACS settings have been saved and your selected payments and all team members with bank details will be included in your BACS file each time you approve payroll.</p>\n\n\t\t<div ng-if="vm.teamMembers.length > 0">\n\t\t\t<hr class="xxl">\n\t\t\t<div ng-if="vm.incompleteTeamMembers.length > 0">\n\t\t\t\t<h6><ng-pluralize count="vm.incompleteTeamMembers.length" when="{\'1\': \'1 team member is\', \'other\': \'{} team members are\'}"></ng-pluralize>&nbsp;missing bank details</h6>\n\t\t\t\t<p class="s">They won\u2019t be included in your BACS file and will need to be paid manually. If you don\u2019t wish to add their bank details now you can do it from your company settings or their profile pages later. We\u2019ll also remind you when you approve payroll.</p>\n\t\t\t\t<div class="spacer xl"></div>\n\n\t\t\t\t<div class="team-card-basic_wrapper">\n\t\t\t\t\t<team-card-basic ng-repeat="teamMember in vm.incompleteTeamMembers" team-member="teamMember">\n\t\t\t\t\t\t<tc-actions>\n\t\t\t\t\t\t\t<team-member-state team-member="teamMember"></team-member-state>\n\t\t\t\t\t\t\t<a aria-label="Open payment details for team member" href="" class="team-card-basic_edit" ng-click="openPaymentDetailsForm(teamMember, PAGE_STATES.saved)">\n\t\t\t\t\t\t\t\t<i class="icon-edit l greyscale"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</tc-actions>\n\t\t\t\t\t</team-card-basic>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div ng-if="vm.incompleteTeamMembers.length === 0">\n\t\t\t\t<h6>All team members have bank details</h6>\n\t\t\t</div>\n\n\t\t\t<div class="spacer xs"></div>\n\n\t\t\t<p class="s">You can review all information for your team in your <a href="" ng-click="openEmployeeDetailsReportModal()">Employee details report</a>.</p>\n\t\t</div>\n\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Incomplete team members -->\n<form-state form-options="formOptions" fs-show-close="false" fs-theme="less-margin" ng-if="pageState === PAGE_STATES.incompleteTeamMembers">\n\t<fs-main>\n\t\t<h6><ng-pluralize count="vm.incompleteTeamMembers.length" when="{\'1\': \'1 team member is\', \'other\': \'{} team members are\'}"></ng-pluralize>&nbsp;missing bank details</h6>\n\t\t<p class="s">They won\u2019t be included in your BACS file and will need to be paid manually. If you don\u2019t wish to add their bank details now you can do it from your company settings or their profile pages later. We\u2019ll also remind you when you approve payroll.</p>\n\t\t<div class="spacer xl"></div>\n\n\t\t<div class="team-card-basic_wrapper">\n\t\t\t<team-card-basic ng-repeat="teamMember in vm.incompleteTeamMembers" team-member="teamMember">\n\t\t\t\t<tc-actions>\n\t\t\t\t\t<team-member-state team-member="teamMember"></team-member-state>\n\t\t\t\t\t<a aria-label="Open payment details for team member" href="" class="team-card-basic_edit" ng-click="openPaymentDetailsForm(teamMember, PAGE_STATES.incompleteTeamMembers)">\n\t\t\t\t\t\t<i class="icon-edit l greyscale"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</tc-actions>\n\t\t\t</team-card-basic>\n\t\t</div>\n\n\t\t<div class="spacer xs"></div>\n\n\t\t<p class="s">You can review all information for your team in your <a href="" ng-click="openEmployeeDetailsReportModal()">Employee details report</a>.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/bacs-disbursements/addBacsDisbursementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="addDisbursementForm" ng-if="pageState === \'ready\'" ng-submit="updateDisbursement(vm, addDisbursementForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">\n\t\t\tChoose a pay element then add bank details and decide if you want to include payments in your BACS files\n\t\t</p>\n\t</div>\n\n\t<!-- Basic Inputs -->\n\t<fieldset>\n\t\t<change-creator agency-profile-id="formOptions.agencyProfileId" vm="vm.changeCreatorVm"></change-creator>\n\t</fieldset>\n\n\t<fieldset class="fadeIn" ng-if="vm.changeCreatorVm.newAdjustment.adjustmentType">\n\t\t<div class="form-intro">\n\t\t\t<h4>Bank Details</h4>\n\t\t</div>\n\t\t<bacs-disbursement agency-profile-id="vm.agencyProfileId" disbursement="vm.disbursement" form="addDisbursementForm" pay-period="vm.payPeriod" show-bacs-title="true"></bacs-disbursement>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Cancel -->\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!addDisbursementForm.$valid || !vm.changeCreatorVm.newAdjustment.adjustmentType" display-text="Save" state="addDisbursementForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Disbursement saved" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYour new disbursement for the pay element {{ todo }} has been saved. If you wish to add further disbursements, click &lsquo;Add another&rsquo;.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="primary-action tertiary" ng-click="setPageState(\'ready\')" type="button">\n\t\t\tAdd another\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/bacs-disbursements/deleteBacsDisbursementForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="deleteDisbursementForm" ng-submit="deleteDisbursement(disbursement, deleteDisbursementForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Confirmation -->\n\t<form-state form-options="formOptions" fs-show-close="false" fs-theme="primary" fs-icon="question-mark" fs-title="Are you sure you wish to delete this disbursement?" ng-if="pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">You&apos;re about to delete the &lsquo;{{disbursement.Description}}&rsquo; disbursement. Once deleted, this cannot be undone. If you&apos;re happy to continue, click &lsquo;Delete&rsquo;</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Delete\'" state="saving"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-theme="positive" fs-icon="tick" fs-title="Disbursement deleted" ng-if="pageState === \'deleted\'">\n\t<fs-main>\n\t\t<p class="s">Your disbursement has been deleted.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/bik/companySettingsBikForm.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form name="companySettingsBikForm" ng-submit="updateCompanyBIKSettings(vm, companySettingsBikForm)" class="fadeIn" ng-if="pageState === PAGE_STATES.ready" novalidate>\n\n\t<div class="form-section">\n\t\t<settings-row sr-field-name="bikEnabled" ng-model="vm.agencyEmployerPayrollBIK" sr-icon="clock">\n\t\t\t<sr-label>Payroll Benefits in Kind</sr-label>\n\t\t\t<sr-description ng-if="vm.agencyEmployerPayrollBIK">Switch to \'OFF\' if you don\u2019t wish to payroll Benefits in Kind each time you run payroll for {{vm.company.Name}}.</sr-description>\n\t\t\t<sr-description ng-if="!vm.agencyEmployerPayrollBIK">Switch to \'ON\' if you wish to payroll Benefits in Kind each time you run payroll for {{vm.company.Name}}.</sr-description>\n\t\t\t<sr-content ng-if="vm.agencyEmployerPayrollBIK">\n\t\t\t\t<fieldset class="fadeIn">\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">For your records, enter the date you registered with HMRC to payroll Benefits in Kind.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="bikRegistrationDate">Registration date:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<date-input-field field-disabled="!vm.agencyEmployerPayrollBIK" field-id="bikRegistrationDate" field-required="false" field-value-iso="vm.agencyEmployerPayrollBIKRegistrationDateISO">\n\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsBikForm.bikRegistrationDate.$error" ng-if="companySettingsBikForm.bikRegistrationDate.$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</fieldset>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="companySettingsBikForm.state" disable-button="!companySettingsBikForm.$valid"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/calculation-method/companySettingsCalculationMethodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsCalculationMethodForm" ng-submit="saveCalculationMethod(formOptions.company, companySettingsCalculationMethodForm)" class="fadeIn" novalidate ng-if="pageState === \'ready\'">\n\n\t<div class="form-intro">\n\t\t<p class="s">The calculation method you select will be used by default. This can be overridden for each team member when you edit their pay information.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="calculationMethod">Select a default calculation method:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select data-cy="calculationMethod" id="calculationMethod" ng-options="calculationMethod.key as calculationMethod.description for calculationMethod in CALCULATION_METHODS | filter: { \'showForCompaniesOnly\': true } | orderBy: [\'-isCalculation\', \'description\']" ng-model="company.DayRateCalculationMethod">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="company.DayRateCalculationMethod === 16">\n\t\t\t<info-block ib-theme="indifferent has-icon has-plain-type">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-support indifferent-darkened info-block-icon"></i>\n\t\t\t\t\t\t<h6>Annualised days calculation</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="s">The actual calculation method will be determined automatically based on each team member\'s work pattern.</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-subheading">\n\t\t\t\t<p class="s">Where you use a team member\u2019s work pattern as the calculation method you can use their\n\t\t\t\t\tsalary and number of working days in the pay period or the calendar year.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<label for="calculationBasisPayPeriod">Calculate based on:</label>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="calculationBasis" id="calculationBasisPayPeriod" class="b radio-card-input" ng-value="false" ng-model="company.CalculatePatternOnYearlyBasis">\n\t\t\t\t\t\t<label for="calculationBasisPayPeriod" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Pay period</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="calculationBasis" id="calculationBasisCalendarYear" class="b radio-card-input" ng-value="true" ng-model="company.CalculatePatternOnYearlyBasis">\n\t\t\t\t\t\t<label for="calculationBasisCalendarYear" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Calendar year</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-subheading">\n\t\t\t\t<p class="s">Where you use 260, 261, or 253 working days per year as the calculation method you can\n\t\t\t\t\tset a maximum number of working days in a month to be used for mid-month salary change calculations.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<label for="maxWorkingDaysInMonth22Days">Maximum working days in month:</label>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="maxWorkingDaysInMonth" id="maxWorkingDaysInMonth22Days" class="b radio-card-input" ng-value="22" ng-model="company.MaximumWorkingDaysInMonth">\n\t\t\t\t\t\t<label for="maxWorkingDaysInMonth22Days" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">22 days</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="maxWorkingDaysInMonth" id="maxWorkingDaysInMonth23Days" class="b radio-card-input" ng-value="23" ng-model="company.MaximumWorkingDaysInMonth">\n\t\t\t\t\t\t<label for="maxWorkingDaysInMonth23Days" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">23 days</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsCalculationMethodForm.state" disable-button="!companySettingsCalculationMethodForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/calculation-settings/company-settings-calculation-settings.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsCalculationSettingsForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateAgencyEmployerNetPayCalculationDetails(companySettingsCalculationSettingsForm)" novalidate>\n\n\t<!-- Calculation order -->\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h4>Calculation order</h4>\n\t\t</div>\n\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="calculateGrossToNetElementsFirstYes">\n\t\t\t\t\tCalculate gross to net elements of pay before net to gross:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="calculateGrossToNetElementsFirstYes" name="calculateGrossToNetElementsFirst" ng-model="$ctrl.calculationDetail.CalculateGrossToNetElementsFirst" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="calculateGrossToNetElementsFirstYes" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="calculateGrossToNetElementsFirstNo" name="calculateGrossToNetElementsFirst" ng-model="$ctrl.calculationDetail.CalculateGrossToNetElementsFirst" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="calculateGrossToNetElementsFirstNo" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\t</fieldset>\n\n\t<!-- Net to gross calculations -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Net to gross calculations</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tSetting the below elements of pay to &lsquo;No&rsquo; means they won\u2019t be included in net to gross calculations.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.calculationDetail.HasNetToGrossEENIPaidByEmployer">\n\t\t   <div class="form-field-header">\n\t\t\t   <label for="netToGrossEENIPaidByEmployerTrue">\n\t\t\t\t\tGross up for Employee NI:\n\t\t\t   </label>\n\t\t   </div>\n\t\t   <div class="form-field-main">\n\t\t\t   <div class="radio-cards-list-split is-inline">\n\t\t\t\t   <div class="radio-card">\n\t\t\t\t\t   <input class="b radio-card-input" id="netToGrossEENIPaidByEmployerTrue" name="netToGrossEENIPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossEENIPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t   <label class="radio-card-label" for="netToGrossEENIPaidByEmployerTrue">\n\t\t\t\t\t\t   <span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t   </label>\n\t\t\t\t   </div>\n\t\t\t\t   <div class="radio-card">\n\t\t\t\t\t   <input class="b radio-card-input" id="netToGrossEENIPaidByEmployerFalse" name="netToGrossEENIPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossEENIPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t   <label class="radio-card-label" for="netToGrossEENIPaidByEmployerFalse">\n\t\t\t\t\t\t   <span class="radio-card-option-text">No</span>\n\t\t\t\t\t   </label>\n\t\t\t\t   </div>\n\t\t\t   </div>\n\t\t   </div>\n\t\t</div>\n\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="netToGrossPensionPaidByEmployerTrue">\n\t\t\t\t\tGross up for pension contributions:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPensionPaidByEmployerTrue" name="netToGrossPensionPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossPensionPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPensionPaidByEmployerTrue">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPensionPaidByEmployerFalse" name="netToGrossPensionPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossPensionPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPensionPaidByEmployerFalse">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="netToGrossSLPaidByEmployerTrue">\n\t\t\t\t\tGross up for student loans (Plan 1, 2, 4, and 5):\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossSLPaidByEmployerTrue" name="netToGrossSLPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossSLPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossSLPaidByEmployerTrue">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossSLPaidByEmployerFalse" name="netToGrossSLPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossSLPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossSLPaidByEmployerFalse">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="netToGrossPGLPaidByEmployerTrue">\n\t\t\t\t\tGross up for postgraduate loans:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPGLPaidByEmployerTrue" name="netToGrossPGLPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossPGLPaidByEmployer" ng-value="true" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPGLPaidByEmployerTrue">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" id="netToGrossPGLPaidByEmployerFalse" name="netToGrossPGLPaidByEmployer" ng-model="$ctrl.calculationDetail.NetToGrossPGLPaidByEmployer" ng-value="false" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="netToGrossPGLPaidByEmployerFalse">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button disable-button="companySettingsCalculationSettingsForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsCalculationSettingsForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/cease-paye/company-settings-cease-paye.form.html','<!-- Cease PAYE scheme -->\n<div ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.ready" ng-switch="$ctrl.activeStep">\n\n\t<div class="form-content-block fadeIn" ng-if="$ctrl.activeStep !== $ctrl.CEASE_STEPS.intro">\n\t\t<info-block ib-icon-dot="icon-document" ib-theme="is-primary has-border">\n\t\t\t<ib-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\t<span class="is-primary-light">PAYE scheme</span> <br>\n\t\t\t\t\t<span class="is-greyscale-dark">{{::$ctrl.formOptions.company.PAYERef}}</span>\n\t\t\t\t</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n\n\t<!-- Intro -->\n\t<form class="fadeIn" name="ceasePayeIntroForm" ng-submit="$ctrl.setActiveStep($ctrl.CEASE_STEPS.closeDate)" novalidate pc-switch-when="$ctrl.CEASE_STEPS.intro">\n\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-show-close="false" fs-theme="primary" fs-title="How to close your PAYE scheme">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tAfter you click &lsquo;Start&rsquo; you\u2019ll be able to set the date that you wish your PAYE scheme to be recorded as closed and\n\t\t\t\t\t\tPaycircle will automatically send the relevant communications to HMRC.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tDon&apos;t forget that if you have a workplace pension connected to Paycircle you will need to disconnect it.\n\t\t\t\t\t\tYou will also need to contact your pension provider and let them know that you have closed your PAYE scheme.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.closingPayeScheme" underline="true">\n\t\t\t\t\t\t\tRead more about closing a PAYE scheme\n\t\t\t\t\t\t</support-article-link>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t\t<submit-button display-text="\'Start\'"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Close date -->\n\t<form class="fadeIn" name="ceasePayeForm" ng-submit="$ctrl.setActiveStep($ctrl.CEASE_STEPS.confirm)" novalidate pc-switch-when="$ctrl.CEASE_STEPS.closeDate">\n\t\t<fieldset>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tEnter your scheme cessation date and we&apos;ll let you know if there&apos;s anything else you need to do.\n\t\t\t\t\tPlease note that if you enter a date in the past, this cannot be undone after you confirm you wish to proceed in the next step.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-section">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="calculationMethodA">\n\t\t\t\t\t\t\tWhen do you wish to close the scheme?\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<date-input-field field-id="ceasePayeDate" field-max-date-iso="$ctrl.ceasePayeDateMax" field-min-date-iso="$ctrl.ceasePayeDateMin" field-on-change-fn="$ctrl.onCeasePayeDateChange()" field-style="l" field-value-iso="$ctrl.ceasePayeDate"></date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="ceasePayeForm.ceasePayeDate.$touched" ng-messages="ceasePayeForm.ceasePayeDate.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="date">Please enter a valid date</p>\n\t\t\t\t\t\t<p ng-message="min">The cessation date cannot be any earlier than {{::$ctrl.ceasePayeDateMin | dateformat}}</p>\n\t\t\t\t\t\t<p ng-message="max">The cessation date cannot be any later than {{::$ctrl.ceasePayeDateMin | dateformat}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section fadeIn" ng-if="$ctrl.ceasePayeDate">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="What to do next">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<!-- Cease date is in current period or future -->\n\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in your current or a future pay period and you&apos;ll need to ensure you run payroll for that period to finish closing your scheme.\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<!-- Cease date is in the past -->\n\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="!$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in a previous pay period and once you&apos;ve confirmed you wish to close your scheme we will automatically finish closing it for you.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!ceasePayeForm.$valid" display-text="\'Next\'" state="ceasePayeForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Confirm -->\n\t<form class="fadeIn" name="ceasePayeConfirmForm" ng-submit="$ctrl.updateAgencyProfileCeasePAYEScheme(ceasePayeConfirmForm)" novalidate pc-switch-when="$ctrl.CEASE_STEPS.confirm">\n\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Are you sure you wish to close this PAYE scheme?">\n\t\t\t<fs-main>\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tClicking &lsquo;Confirm&rsquo; will set this scheme to close on the date you have chosen.\n\t\t\t\t\t\tWhen a PAYE scheme closes, we will send a communication to HMRC to notify them.\n\t\t\t\t\t\tYour team members will be marked as leavers and they will each be issued with a P45.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<note note-dismiss="true" note-title="What to do next" note-icon="icon-support" note-theme="indifferent">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<!-- Cease date is in current period or future -->\n\t\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in your current or a future pay period and you&apos;ll need to ensure you run payroll for that period to finish closing your scheme.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<!-- Cease date is in the past -->\n\t\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="!$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in a previous pay period and once you&apos;ve confirmed you wish to close your scheme we will automatically finish closing it for you.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="$ctrl.setActiveStep($ctrl.CEASE_STEPS.closeDate)" type="button">\n\t\t\t\t\tBack\n\t\t\t\t</button>\n\t\t\t\t<submit-button disable-button="!ceasePayeConfirmForm.$valid" display-text="\'Confirm\'" state="ceasePayeConfirmForm.state"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Ceased -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.CEASE_STEPS.ceased">\n\t\t<div class="form-section">\n\t\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="Your PAYE scheme is set to close">\n\t\t\t\t<fs-main>\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tYour team members have been marked as leaving your company and will each be issued with a P45.\n\t\t\t\t\t\t\tHMRC will be notified that your scheme has been closed.\n\t\t\t\t\t\t\tThe date that will appear on all of these records is {{$ctrl.ceasePayeDate | dateformat:\'full\'}}.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<note note-dismiss="true" note-title="What to do next" note-icon="icon-support" note-theme="indifferent">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<!-- Cease date is in current period or future -->\n\t\t\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in your current or a future pay period and you&apos;ll need to ensure you run payroll for that period to finish closing your scheme.\n\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t<!-- Cease date is in the past -->\n\t\t\t\t\t\t\t\t<p class="is-small fadeIn" ng-if="!$ctrl.isCeasePayeDateInCurrentPeriodOrFuture">\n\t\t\t\t\t\t\t\t\tThe cessation date you&apos;ve entered falls in a previous pay period and once you&apos;ve confirmed you wish to close your scheme we will automatically finish closing it for you.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</div>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t\t<div class="form-section with-separator">\n\t\t\t<p class="caption">\n\t\t\t\tDon&apos;t wish to close this PAYE scheme after all? <a href="" ng-click="$ctrl.cancelCeasePAYEScheme()">Cancel closing the scheme</a>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Loading -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.CEASE_STEPS.loading">\n\t\t<loading-block></loading-block>\n\t</div>\n\n\t<!-- Reopened -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.CEASE_STEPS.reOpened">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" fs-title="Your PAYE scheme is active">\n\t\t\t<fs-main>\n\n\t\t\t\t<div class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYou\u2019ve successfully cancelled closing your PAYE scheme and it is now active again.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-section" ng-if="$ctrl.formOptions.company.HasAutoPension">\n\t\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Need to reconnect your pension?">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tIf you have already disconnected your workplace pension from Paycircle you may need to reconnect it in order to continue running your payroll as usual.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="is-small" ng-if="$root.currentUser.Permissions.isPensionVisible">\n\t\t\t\t\t\t\t\t<a class="is-indifferent-darkened" ui-sref="pensions.summary({\n\t\t\t\t\t\t\t\t\t\tagencyProfileId: $ctrl.formOptions.agencyProfileId\n\t\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\t\tGo to your Pensions page\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n</div>\n\n<!-- Incorrect payroll type (Agency/Actual Only) -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to close this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.incorrectPayrollType">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{::$ctrl.formOptions.company.Name}} is not able to close their PAYE scheme directly.\n\t\t\tPlease contact support to discuss ceasing this scheme.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Incorrect payroll type (Pension only) -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to close this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.companyIsPensionOnly">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAs {{::$ctrl.formOptions.company.Name}} is only running a pension they cannot close a PAYE scheme.\n\t\t\tPlease contact support for more information.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Incorrect payroll type (CIS only) -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to close this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.companyIsCISOnly">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAs {{::$ctrl.formOptions.company.Name}} is only running a CIS scheme they cannot close a PAYE scheme.\n\t\t\tPlease contact support for more information.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Incorrect payroll type (LLP) -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to close this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.llpCompany">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tPartnership companies are not able to close their PAYE scheme directly.\n\t\t\tPlease contact support to discuss closing this scheme.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Multiple payroll company -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to close this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.multiplePayrollCompany">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tAs there are multiple payrolls attached to this scheme, you are not able to close their PAYE scheme directly.\n\t\t\tPlease contact support to discuss closing this scheme.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Already ceased -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to cancel the cessation of this PAYE scheme" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.alreadyCeased">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tWe were unable to cancel the cessation of this PAYE scheme as it has already been ceased.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/currencies/company-settings-currencies.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<!-- Edit Currencies -->\n<form class="fadeIn" name="companySettingsCurrenciesForm" ng-if="$ctrl.pageState === $ctrl.FORM_STATES.editCurrencies" ng-submit="$ctrl.updateCurrencies(companySettingsCurrenciesForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro" ng-if="!$ctrl.formOptions.isEditMode">\n\t\t\t<p>Add a name for each currency and the Sterling to currency exchange rate.</p>\n\t\t</div>\n\n\t\t<div class="form-intro" ng-if="$ctrl.formOptions.isEditMode">\n\t\t\t<p>\n\t\t\t\tEditing your exchange rates here will also update them in your company settings.\n\t\t\t\tYou can edit them at any time before you run payroll by clicking on the \u2018Currencies\u2019 button in your current period.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-section form-field-highlight is-primary fadeIn" ng-repeat="currency in $ctrl.currencies">\n\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t<!-- Currency Name -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="currencyLabel{{$index}}" ng-class="{\n\t\t\t\t\t\t\t\t\t\'required\' : !$ctrl.formOptions.isEditMode\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\tName:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="currencyLabel{{$index}}" name="currencyLabel{{$index}}" ng-blur="$ctrl.onCurrencyLabelChange(currency, companySettingsCurrenciesForm[\'currencyLabel\'+$index])" ng-class="{ \'primary\' : $ctrl.formOptions.isEditMode }" ng-model="currency.CurrencyLabel" ng-pattern="$root.REGEX.lettersOnly" ng-readonly="$ctrl.formOptions.isEditMode" placeholder="Enter name..." required type="text">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsCurrenciesForm[\'currencyLabel\'+$index].$error" ng-if="companySettingsCurrenciesForm[\'currencyLabel\'+$index].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="pattern">Currency name can only be letters</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a name</p>\n\t\t\t\t\t\t\t<p ng-message="nonUnique">Currency name needs to be unique</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Rate -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="exchangeRate{{$index}}" class="required">\n\t\t\t\t\t\t\t\tExchange rate:\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="exchangeRate{{$index}}" name="exchangeRate{{$index}}" ng-model="currency.CurrencyValue" ng-pattern="$root.REGEX.number" placeholder="Type here..." required step="0.0001" type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsCurrenciesForm[\'exchangeRate\'+$index].$error" ng-if="companySettingsCurrenciesForm[\'exchangeRate\'+$index].$touched" role="alert">\n\t\t\t\t\t\t\t<p ng-message="step">Please enter an Exchange rate up to 4 decimal places</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<a aria-label="Delete currency" class="form-field-group_action" href="" ng-click="$ctrl.onCurrencyDelete(companySettingsCurrenciesForm, $index, currency)" ng-if="!$ctrl.formOptions.isEditMode">\n\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t</a>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-section" ng-if="!$ctrl.formOptions.isEditMode">\n\t\t\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.onAddCurrency()" type="button">\n\t\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add currency\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n    \t\tCancel\n    \t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!companySettingsCurrenciesForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsCurrenciesForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<!-- Exchange Rates -->\n<form class="fadeIn" name="companySettingsCurrenciesForm" ng-if="$ctrl.pageState === $ctrl.FORM_STATES.exchangeRates" ng-submit="$ctrl.updateAgencyPayPeriodCurrencyCheck(companySettingsCurrenciesForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are your exchange rates up to date?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tIf you\u2019re happy that your exchange rates are up to date, check the box below and click \u2018Confirm\u2019.\n\t\t\t\t\tYou can edit them at any time before you run payroll by clicking on the \u2018Currencies\u2019 button in your current period.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<span class="greyscale strong is-small">\n\t\t\t\t\t<ng-pluralize count="$ctrl.currencies.length" when="{\n\t\t\t\t\t\t\t\'1\': \'1 exchange rate\',\n\t\t\t\t\t\t\t\'other\': \'{} exchange rates\'\n\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t</span>\n\n\t\t\t\t<span class="float-right">\n\t\t\t\t\t<a class="link-with-icon primary strong" href="" ng-click="$ctrl.setPageState($ctrl.FORM_STATES.editCurrencies)">\n\t\t\t\t\t\t<i class="icon-edit n"></i> Edit exchange rates\n\t\t\t\t\t</a>\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t <table class="primary payment-schedule-table">\n\t\t\t\t \t<thead>\n\t\t\t\t \t\t<tr>\n\t\t\t\t \t\t\t<th>Currency</th>\n\t\t\t\t \t\t\t<th>1.00 Sterling</th>\n\t\t\t\t \t\t</tr>\n\t\t\t\t \t</thead>\n\t\t\t\t \t<tbody>\n\t\t\t\t \t\t<tr ng-repeat="currency in $ctrl.currencies">\n\t\t\t\t \t\t\t<td class="strong">\n\t\t\t\t \t\t\t\t{{currency.CurrencyLabel}}\n\t\t\t\t \t\t\t</td>\n\t\t\t\t \t\t\t<td class="strong align-right">\n\t\t\t\t \t\t\t\t{{currency.CurrencyValue}}\n\t\t\t\t \t\t\t</td>\n\t\t\t\t \t\t</tr>\n\t\t\t\t \t</tbody>\n\t\t\t\t </table>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<div class="confirmation-block indifferent">\n\t\t\t\t\t<input checkbox class="s" id="confirmInformation" label-text="\'I confirm that exchange rates are up to date\'" name="confirmInformation" ng-model="directDebit.IsConfirmed" required type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="!companySettingsCurrenciesForm.$valid" display-text="\'Confirm\'" state="companySettingsCurrenciesForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<div ng-if="$ctrl.pageState === $ctrl.FORM_STATES.noCurrenciesSetup">\n\t<placeholder placeholder-graphic="monetary" ng-if="!vm.businessCode.IsUnallocatedBusinessCode">\n\t\t<placeholder-title>No currencies set up</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Once you\u2019ve set up currencies in your company settings area you\u2019ll be able to review and update exchange rates from your current period.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-secondary-actions>\n\t\t\t<a href="" ng-if="$root.currentUser.Permissions.isCompanySettingsVisible" ui-sref="settings.company.currencies({\n\t\t\t\t\tagencyProfileId: $ctrl.formOptions.agencyProfileId\n\t\t\t\t})">\n\t\t\t\tGo to company settings&nbsp;&nbsp;<i class="icon-chevron-right"></i>\n\t\t\t</a>\n\t\t</placeholder-secondary-actions>\n\t</placeholder>\n</div>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.FORM_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/customer-codes/company-settings-customer-codes.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.loading"></loading-block>\n\n\t<form class="fadeIn" name="editCustomerCodesForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.ready" ng-submit="$ctrl.onSubmit()">\n\t\t<div ng-if="$ctrl.contentType === $ctrl.CONTEXT_TYPE.single">\n\n\t\t\t<div class="form-intro" ng-if="!$ctrl.formOptions.isBureau">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tEdit the customer code for: {{$ctrl.customerCode.CompanyName}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<label for="CustomerCode">\n\t\t\t\t\t\t\tCustomer code:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l" id="CustomerCode" name="CustomerCode" ng-change="$ctrl.resetVerificationState($ctrl.customerCode)" ng-disabled="$ctrl.customerCode.verificationState === \'verifying\' || $ctrl.customerCode.isLocked" ng-pattern="$root.REGEX.customerCode" ng-model="$ctrl.customerCode.CustomerCode" placeholder="Enter value" type="text">\n\t\t\t\t\t\t<button class="button-compact" ng-click="$ctrl.verifyCustomerCode($ctrl.customerCode)" ng-disabled="!$ctrl.customerCode.CustomerCode || $ctrl.customerCode.verificationState === \'verifying\' || $ctrl.customerCode.isLocked" ng-hide="true" type="button">\n\t\t\t\t\t\t\tVerify\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message">Max. 15 characters.</p>\n\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editCustomerCodesForm.CustomerCode.$touched" ng-messages="editCustomerCodesForm.CustomerCode.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="pattern">Maximum of 15 characters</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field less-margin" ng-if="$ctrl.customerCode.verificationState === \'verifying\'">\n\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t\t<span class="s ml-1">Verifying customer code...</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field less-margin" ng-if="$ctrl.customerCode.verificationState === \'invalid\' || verificationState === \'error\'">\n\t\t\t\t\t<message-block theme="assertive is-inline" has-drop-in="false">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<i class="icon-warning is-medium is-assertive has-margin-right"></i>\n\t\t\t\t\t\t\t<span>Valid code not found. Please check you\'ve entered it correctly.</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</message-block>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field less-margin" ng-if="$ctrl.customerCode.verificationState === \'valid\'">\n\t\t\t\t\t<message-block theme="secondary is-inline" has-drop-in="false">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<i class="icon-tick is-medium is-secondary has-margin-right"></i>\n\t\t\t\t\t\t\t<span>Valid code found: {{$ctrl.customerCode.customerCodeCompanyName}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</message-block>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field less-margin" ng-if="!$ctrl.customerCode.verificationState && $ctrl.customerCode.isLocked">\n\t\t\t\t\t<message-block theme="tertiary is-inline" has-drop-in="false">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<i class="icon-padlock is-medium is-tertiary has-margin-right"></i>\n\t\t\t\t\t\t\t<span>Code verified: {{$ctrl.customerCode.CompanyName}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</message-block>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</div>\n\t\t<div ng-if="$ctrl.contentType === $ctrl.CONTEXT_TYPE.bulk">\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tNote: Customer codes can have a max. length of 15 characters.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<!-- Search bar-->\n\t\t\t<search-bar bulk-items="$ctrl.customerCodes" options="$ctrl.searchBarOptions">\n\t\t\t</search-bar>\n\t\t\t<fieldset>\n\t\t\t\t<div class="form-field no-margin" ng-repeat="code in $ctrl.customerCodes.filtered = (\n\t\t\t\t\t\t\t\t\t$ctrl.customerCodes.all |\n\t\t\t\t\t\t\t\t\tfilter : $ctrl.searchBarOptions.search.string)">\n\t\t\t\t\t<div class="form-field-inline">\n\t\t\t\t\t\t<div class="form-field-header no-bottom-margin">\n\t\t\t\t\t\t\t<label class="is-small no-margin" for="{{$ctrl.getLabel(code)}}">\n\t\t\t\t\t\t\t\t<truncate text="code.CompanyName" truncate-amount="30"></truncate>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<input class="l" id="{{$ctrl.getLabel(code)}}" name="{{$ctrl.getLabel(code)}}" ng-change="$ctrl.resetVerificationState(code)" ng-disabled="code.isLocked" ng-pattern="$root.REGEX.customerCode" ng-model="code.CustomerCode" placeholder="Enter value" type="text">\n\t\t\t\t\t\t\t\t<button class="button secondary-action" ng-click="$ctrl.verifyCustomerCode(code)" ng-disabled="!code.CustomerCode || code.verificationState === \'verifying\' || code.isLocked" ng-hide="true" type="button">\n\t\t\t\t\t\t\t\t\tVerify\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="editCustomerCodesForm[$ctrl.getLabel(code)].$touched" ng-messages="editCustomerCodesForm[$ctrl.getLabel(code)].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Enter a maximum of 15 characters</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field less-margin" ng-if="code.verificationState === \'verifying\'">\n\t\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t\t\t<span class="s ml-1">Verifying customer code...</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field less-margin" ng-if="code.verificationState === \'invalid\' || code.verificationState === \'error\'">\n\t\t\t\t\t\t<message-block theme="assertive is-inline" has-drop-in="false">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-warning is-medium is-assertive has-margin-right"></i>\n\t\t\t\t\t\t\t\t<span>Valid code not found. Please check you\'ve entered it correctly.</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field less-margin" ng-if="code.verificationState === \'valid\'">\n\t\t\t\t\t\t<message-block theme="secondary is-inline" has-drop-in="false">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-tick is-medium is-secondary has-margin-right"></i>\n\t\t\t\t\t\t\t\t<span>Valid code found: {{code.customerCodeCompanyName}}</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field less-margin" ng-if="!code.verificationState && code.isLocked">\n\t\t\t\t\t\t<message-block theme="tertiary is-inline" has-drop-in="false">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t<i class="icon-padlock is-medium is-tertiary has-margin-right"></i>\n\t\t\t\t\t\t\t\t<span>Code verified</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</message-block>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<hr class="m">\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="!$ctrl.customerCodes.filtered.length" search-bar-options="$ctrl.searchBarOptions">\n\t\t\t\t</empty-search>\n\t\t\t</fieldset>\n\t\t</div>\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="button secondary-action" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button button-id="customerCodes-submit" disable-button="editCustomerCodesForm.$invalid || $ctrl.isSubmitDisabled()" display-text="\'Save\'" state="editCustomerCodesForm.state">\n\t\t\t</submit-button>\n\t\t</fieldset>\n\t</form>\n\n<!-- Add success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Customer codes saved" ng-if="$ctrl.formState === $ctrl.FORM_STATES.saved">\n\t<fs-main>\n\t\t<p class="s">Your customer codes have been saved.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window">\n</error-block>\n');
$templateCache.put('forms/admin/companySettings/directors-ni/companySettingsDirectorsNIForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsDirectorsNIForm" ng-submit="updateAgencyEmployerDirectorNIStandard(vm, companySettingsDirectorsNIForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Directors NI calculation method</h4>\n\t\t<p class="s">Depending on the frequency of Directors pay, their National Insurance contributions may be calculated a certain way. <a href="{{$root.URLS.gov.directorsNi}}" target="_blank" rel="external">Read more about calculation methods</a></p>\n\t</div>\n\n\t<fieldset>\n\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="calculationMethod" id="directorsNiMethodStandard" class="b radio-row-input" ng-value="true" ng-model="vm.DirectorNIStandard" ng-disabled="vm.directorNIStandardSkip" ng-required="!vm.directorNIStandardSkip">\n\t\t\t\t\t\t<label class="radio-row-label" for="directorsNiMethodStandard">\n\t\t\t\t\t\t\t<p class="radio-row-title">Standard (cumulative)</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input type="radio" name="calculationMethod" id="directorsNiMethodAlternative" class="b radio-row-input" ng-value="false" ng-model="vm.DirectorNIStandard" ng-disabled="vm.directorNIStandardSkip" ng-required="!vm.directorNIStandardSkip">\n\t\t\t\t\t\t<label class="radio-row-label" for="directorsNiMethodAlternative">\n\t\t\t\t\t\t\t<p class="radio-row-title">Alternative (non-cumulative)</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsDirectorsNIForm.state" disable-button="!companySettingsDirectorsNIForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/email-notifications/companySettingsEmailNotificationsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsEmailNotificationsForm" ng-submit="saveEmailNotificationsSettings(companySettingsEmailNotificationsForm, selectedFrameworkOption)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Select one of the email notification settings options below. If you choose the \'Custom\' opton, you can edit notifications specifically for {{formOptions.company.Name}}</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row" ng-repeat="companyEmailFrameworkOption in companyEmailFrameworkOptions track by $index">\n\t\t\t\t\t\t<input type="radio" name="frameworkOption" id="frameworkOption-{{$index}}" ng-change="companyEmailFrameworkChanged(companyEmailFrameworkOption)" class="b radio-row-input" ng-model="selectedFrameworkOption" ng-value="companyEmailFrameworkOption" required>\n\t\t\t\t\t\t<label class="radio-row-label" for="frameworkOption-{{$index}}">\n\t\t\t\t\t\t\t<p class="radio-row-title">{{companyEmailFrameworkOption.label}}</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<p class="form-message">Please note: to make changes to email notifications settings for your bureau or a company group, go to the respective settings area.</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsEmailNotificationsForm.state" disable-button="!companySettingsEmailNotificationsForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Success -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Email notification settings updated" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s" ng-if="selectedFrameworkOption.isCustom">{{formOptions.company.Name}} are now set to use custom email notification settings and you can turn emails on or off specifically for them.</p>\n\t\t<p class="s" ng-if="!selectedFrameworkOption.isCustom">{{formOptions.company.Name}} are now set to use email notification settings from \'{{selectedFrameworkOption.label}}\'.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()">Close</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/employee-portal/companySettingsEmployeePortalForm.html','<form name="companySettingsEmployeePortalForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="updateEmployeePortalSettings(vm, companySettingsEmployeePortalForm)">\n\n\t<div class="form-content-block">\n\t\t<div class="form-intro">\n\t\t\t<h4>Set permission levels</h4>\n\t\t\t<p class="s" ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.profile">\n\t\t\t\tChoose whether employees profile information is read-only or editable.\n\t\t\t</p>\n\t\t\t<p class="s" ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.pensions">\n\t\t\t\tChoose whether employees can opt in/out of their pension and manage their contributions.\n\t\t\t</p>\n\t\t\t<p class="s" ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.holidayAndSickness">\n\t\t\t\tChoose whether the Holiday & Sickness area is visible or hidden.\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\n\t<!-- Profile permissions -->\n\t<fieldset ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.profile">\n\n\t\t<div class="form-field">\n\t\t\t<toggle-buttons false-label="\'Read-only\'" id="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation].id}}" info-text="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation].infoText" label="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation].label" ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.personalInformation].value" true-label="\'Editable\'">\n\t\t\t</toggle-buttons>\n\t\t</div>\n\n\t\t<!-- Gender visibility -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>Gender visibility</label>\n\t\t\t\t<p cass="is-small">Choose whether the employee\u2019s gender is displayed within their profile.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="toggle-control">\n\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\'active\': !vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender].value\n\t\t\t\t\t\t}"><i class="icon-visible toggle-control-icon"></i> Visible</span>\n\t\t\t\t\t<a class="toggle-a s toggle-control-toggle {{!vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender].value ? \'primary\' : \'active tertiary\'}}" href="" ng-click="toggleIsGenderVisible(vm)"></a>\n\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\'active tertiary\': vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.gender].value\n\t\t\t\t\t\t}"><i class="icon-hidden toggle-control-icon"></i> Hidden</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-fieldset-divider"></div>\n\n\t\t<toggle-buttons false-label="\'Read-only\'" id="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses].id}}" info-text="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses].infoText" label="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses].label" ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.addresses].value" true-label="\'Editable\'">\n\t\t</toggle-buttons>\n\n\t\t<div class="form-fieldset-divider"></div>\n\n\t\t<toggle-buttons false-label="\'Read-only\'" id="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails].id}}" info-text="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails].infoText" label="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails].label" ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.bankDetails].value" true-label="\'Editable\'">\n\t\t</toggle-buttons>\n\n\t</fieldset>\n\n\t<!-- Pensions permissions -->\n\t<fieldset ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.pensions">\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<section class="settings-rows">\n\t\t\t\t\t<settings-row ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.employeeOptInOut].value" sr-field-name="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.employeeOptInOut].id}}" sr-icon="threshold-change" sr-label="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.employeeOptInOut].label}}">\n\t\t\t\t\t\t<sr-description>Turning this on means that employees will be able to opt in/out of workplace pensions.</sr-description>\n\t\t\t\t\t</settings-row>\n\n\t\t\t\t\t<settings-row ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.manageContributions].value" sr-field-name="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.manageContributions].id}}" sr-icon="threshold-change" sr-label="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.manageContributions].label}}">\n\t\t\t\t\t\t<sr-description>Turning this on means that employees will be able to adjust their pension contributions.</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<!-- Holiday and Sickness permissions -->\n\t<fieldset ng-if="vm.permissionsGroup.groupId === EMPLOYEE_PORTAL_PERMISSIONS_GROUP_IDS.holidayAndSickness">\n\n\t\t<toggle-buttons false-label="\'Hidden\'" id="{{vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.holidayAndSickness].id}}" label="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.holidayAndSickness].label" ng-model="vm.permissionsDetailBlocks[EMPLOYEE_PORTAL_PERMISSIONS_FLAGS.holidayAndSickness].value" true-label="\'Visible\'">\n\t\t</toggle-buttons>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="companySettingsEmployeePortalForm.state" disable-button="!companySettingsEmployeePortalForm.$valid"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/employer/companySettingsEmployerForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsEmployerForm" ng-submit="updateAgencyEmployerStatusDetails(company.Employer, companySettingsEmployerForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<!-- Small Employer -->\n\t<fieldset>\n\n\t\t<div class="form-intro" ng-class="{\'disabled\': company.Employer.smallEmployerSkip}">\n\t\t\t<h4>Small Employer</h4>\n\t\t\t<p class="is-small">If {{company.Name}} had a National Insurance liability below the threshold in the previous tax year, it is entitled to Small Employer\'s relief.</p>\n\t\t</div>\n\n\t\t<!-- Small Employer -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" ng-class="{\'disabled\': company.Employer.smallEmployerSkip}">Is {{company.Name}} a small employer?</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input data-cy="small-employer-yes" type="radio" name="smallCompany" id="smallCompanyTrue" class="b" ng-value="true" ng-model="company.Employer.SmallEmployer" ng-disabled="company.Employer.smallEmployerSkip">\n\t\t\t\t\t<label for="smallCompanyTrue">Yes</label>\n\n\t\t\t\t\t<input data-cy="small-employer-no" type="radio" name="smallCompany" id="smallCompanyFalse" class="b" ng-value="false" ng-model="company.Employer.SmallEmployer" ng-disabled="company.Employer.smallEmployerSkip">\n\t\t\t\t\t<label for="smallCompanyFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Skip -->\n\t\t<div class="form-field" ng-if="::formOptions.company.State === COMPANY_STATES.onboarding">\n\t\t\t<div class="form-field-skip">\n\t\t\t\t<input type="checkbox" id="smallCompanySkip" class="form-field-skip-checkbox" name="smallCompanySkip" ng-model="company.Employer.smallEmployerSkip" ng-change="toggleSkipSmallEmployer(company.Employer)" checkbox label-text="\'Skip this for now\'">\n\t\t\t\t<p class="s">This is needed in order to run your first pay period so we\'ll add it to your list of skipped questions on your onboarding dashboard.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-fieldset fadeIn" ng-if="showSmallEmployerWarning">\n\t\t<div class="confirmation-block tertiary-light">\n\t\t\t<input type="checkbox" id="confirmSmallEmployerChange" name="confirmSmallEmployerChange" ng-model="company.Employer.smallEmploymentChangeIsConfirmed" label-text="\'I understand that this may mean that Paycircle won\\\'t match HMRC\'" checkbox required>\n\t\t\t<p class="p s">I understand that historic payroll reports within Paycircle may not match HMRC\u2019s portal for any periods I have already run this tax year.</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Employment Allowance -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Employment Allowance</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tMost employers are entitled to an Employment Allowance each tax year to offset against Class 1 National Insurance.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Entitled? -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" ng-class="{\'disabled\': company.Employer.employmentAllowanceSkip}">Is {{company.Name}} entitled to Employment Allowance?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input data-cy="employer-allowance-yes" type="radio" name="allowanceEligible" id="allowanceEligibleTrue" class="b" ng-value="true" ng-model="company.Employer.EmployersAllowanceEligible" ng-disabled="company.Employer.employmentAllowanceSkip">\n\t\t\t\t\t<label for="allowanceEligibleTrue">Yes</label>\n\n\t\t\t\t\t<input data-cy="employer-allowance-no" type="radio" name="allowanceEligible" id="allowanceEligibleFalse" class="b" ng-value="false" ng-model="company.Employer.EmployersAllowanceEligible" ng-disabled="company.Employer.employmentAllowanceSkip">\n\t\t\t\t\t<label for="allowanceEligibleFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn" ng-if="company.Employer.EmployersAllowanceEligible">\n\n\t\t\t<!-- Allowance used -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="allowanceUsed" class="required" ng-class="{\'disabled\': company.Employer.employmentAllowanceSkip}">Employment Allowance claimed to date</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise m-alt" data-cy="allowance-used-field" id="allowanceUsed" name="allowanceUsed" ng-disabled="company.Employer.employmentAllowanceSkip" ng-max="company.Employer.EmployersAllowanceMax" ng-min="$root.CONFIG.numberMin" ng-model="company.Employer.EmployersAllowanceUsed" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsEmployerForm.allowanceUsed.$error" ng-show="companySettingsEmployerForm.allowanceUsed.$touched" role="alert">\n\t\t\t\t\t<p data-cy="allowanceUsed-required-message" ng-message="required">Please enter an amount</p>\n\t\t\t\t\t<p data-cy="allowanceUsed-numbers-only-message" ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t<p data-cy="allowanceUsed-valid-message" ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t<p data-cy="allowanceUsed-max-message" ng-message="max">Maximum of {{company.Employer.EmployersAllowanceMax | monetise:\'down\'}} for the tax year.</p>\n\t\t\t\t\t<p data-cy="allowanceUsed-positive-message" ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">If nothing has been claimed leave as {{0 | monetise}}.</p>\n\t\t\t</div>\n\n\t\t\t<!-- Employers NI eligible -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="employersNIForEmployersAllowance" class="required" ng-class="{\'disabled\': company.Employer.employmentAllowanceSkip}">Employer\'s National Insurance eligible for Employment Allowance to date</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise m-alt" data-cy="employersNi-employer-allowance-field" id="employersNIForEmployersAllowance" name="employersNIForEmployersAllowance" ng-disabled="company.Employer.employmentAllowanceSkip" ng-max="$root.CONFIG.number9Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.Employer.EmployersNIForEmployersAllowance" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsEmployerForm.employersNIForEmployersAllowance.$error" ng-show="companySettingsEmployerForm.employersNIForEmployersAllowance.$touched" role="alert">\n\t\t\t\t\t<p data-cy="employersNi-employer-allowance-required-message" ng-message="required">Please enter an amount</p>\n\t\t\t\t\t<p data-cy="employersNi-employer-allowance-numbers-message" ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t\t<p data-cy="employersNi-employer-allowance-valid-message" ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t<p data-cy="employersNi-employer-allowance-max-message" ng-message="max">Maximum of {{$root.CONFIG.number9Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p data-cy="employersNi-employer-allowance-positive-message" ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Skip -->\n\t\t\t<div class="form-field" ng-if="::formOptions.company.State === COMPANY_STATES.onboarding">\n\t\t\t\t<div class="form-field-skip">\n\t\t\t\t\t<input type="checkbox" id="employmentAllowanceSkip" class="form-field-skip-checkbox" name="employmentAllowanceSkip" ng-model="company.Employer.employmentAllowanceSkip" ng-change="toggleSkipEmploymentAllowance(company.Employer)" checkbox label-text="\'Skip this for now\'">\n\t\t\t\t\t<p class="s">This is needed in order to run your first pay period so we\'ll add it to your list of skipped questions on your onboarding dashboard.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="showEmploymentAllowanceWarning">\n\t\t\t\t<div class="confirmation-block tertiary-light">\n\t\t\t\t\t<input type="checkbox" id="confirmEmploymentAllowanceChange" name="confirmEmploymentAllowanceChange" ng-model="company.Employer.employmentAllowanceChangeIsConfirmed" label-text="\'I understand that this may mean that Paycircle won\\\'t match HMRC\'" checkbox required>\n\t\t\t\t\t<p class="p s">I understand that historic payroll reports within Paycircle may not match HMRC\u2019s portal for any periods I have already run this tax year.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Business sector -->\n\t\t\t<div class="form-field" ng-if="company.Employer.CanHaveEmployersAllowanceSector">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="businessSector" class="required">Business sector:</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<select class="block" name="businessSector" id="businessSector" ng-model="company.Employer.EmployersAllowanceSector" ng-options="option.value as option.description for option in BUSINESS_SECTOR_OPTIONS" ng-required="company.Employer.CanHaveEmployersAllowanceSector"></select>\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsEmployerForm.businessSector.$error" ng-if="companySettingsEmployerForm.businessSector.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please select a business sector</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Auto-reclaim -->\n\t\t\t<div class="form-field">\n\t\t\t\t<settings-row sr-field-name="employersAllowanceAutoReclaim" ng-model="company.Employer.EmployersAllowanceAutoReclaim" sr-icon="loading">\n\t\t\t\t\t<sr-label>Auto-reclaim</sr-label>\n\t\t\t\t\t<sr-description ng-if="!company.Employer.EmployersAllowanceAutoReclaim">Turning this on means the indicator that you wish to reclaim Employment Allowance will always be sent to HMRC in the first EPS submission of the tax year.</sr-description>\n\t\t\t\t\t<sr-description ng-if="company.Employer.EmployersAllowanceAutoReclaim">Turning this off means the indicator that you wish to reclaim Employment Allowance will not be sent to HMRC in the first EPS submission of the tax year.</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Apprenticeship Levy -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Apprenticeship Levy</h4>\n\t\t\t<p class="s">If you\'re an employer who pays out over {{$root.CONFIG.apprenticeshipLevyThreshold}} each year, you are required to pay the Apprenticeship Levy. This is automatically calculated each time payroll is run and will appear on your P32 if applicable. If you have any partner companies you can split the allowance ({{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}}) between them.</p>\n\t\t</div>\n\n\t\t<!-- Apprenticeship Levy Allocation -->\n\t\t<div class="form-field">\n\t\t\t<label class="required">How much of the allowance would you like to allocate to {{company.Name}}?</label>\n\t\t\t<ul class="option-tabs">\n\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.Employer.apprenticeshipLevyOption === \'full\'}" ng-click="changeApprenticeshipLevyOption(company.Employer, \'full\')">\xA315,000</a>\n\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.Employer.apprenticeshipLevyOption === \'none\'}" ng-click="changeApprenticeshipLevyOption(company.Employer, \'none\')">\xA30</a>\n\t\t\t\t<a href="" class="option-tab" ng-class="{active: company.Employer.apprenticeshipLevyOption === \'custom\'}" ng-click="changeApprenticeshipLevyOption(company.Employer, \'custom\')">Another amount</a>\n\t\t\t</ul>\n\t\t</div>\n\n\t\t<!-- Apprenticeship Levy Amount -->\n\t\t<div class="form-field fadeIn" ng-if="company.Employer.apprenticeshipLevyOption === \'custom\'">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="apprenticeshipLevy" class="required">Amount:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="number" class="monetise m-alt" id="apprenticeshipLevy" name="apprenticeshipLevy" ng-model="company.Employer.ApprenticeshipLevyAmount" ng-pattern="$root.REGEX.numbersOnly" min="0" ng-max="$root.CONFIG.apprenticeshipLevy" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsEmployerForm.apprenticeshipLevy.$error" ng-if="companySettingsEmployerForm.apprenticeshipLevy.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t<p ng-message="max">This should be a maximum of {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}}</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">Maximum of {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}}</p>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="company.Employer.apprenticeshipLevyOption !== \'custom\' || companySettingsEmployerForm.apprenticeshipLevy.$valid">\n\t\t\t<div class="info-block indifferent is-compact has-plain-type">\n\t\t\t\t<p ng-if="!company.Employer.HasApprenticeshipAllowanceSplit">The full Apprenticeship Levy of {{$root.CONFIG.apprenticeshipLevy | monetise:\'down\'}} will be allocated to {{company.Name}}.</p>\n\t\t\t\t<p ng-if="company.Employer.HasApprenticeshipAllowanceSplit">{{company.Employer.ApprenticeshipLevyAmount | monetise}} of the Apprenticeship Levy will be assigned to {{company.Name}}.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Apprenticeship levy YTD-->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-name="toggleField" field-model="company.Employer.apprenticeshipLevyYTDActive" field-label="Add app levy Year to Date"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field-group fadeIn" ng-if="company.Employer.apprenticeshipLevyYTDActive">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="apprenticeshipLevyPayBillToDate" class="required">Pay bill to date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise m-alt" id="apprenticeshipLevyPayBillToDate" name="apprenticeshipLevyPayBillToDate" ng-max="$root.CONFIG.number10Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.Employer.PayPeriodGroupPayBillYTD" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsEmployerForm.apprenticeshipLevyPayBillToDate.$error" ng-if="companySettingsEmployerForm.apprenticeshipLevyPayBillToDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number10Digits2Decimal | monetise}}</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="apprenticeshipLevyPaidToDate" class="required">Levy paid to date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="monetise m-alt" id="apprenticeshipLevyPaidToDate" name="apprenticeshipLevyPaidToDate" ng-max="$root.CONFIG.apprenticeshipLevyPaidToDateMax" ng-min="$root.CONFIG.apprenticeshipLevyPaidToDateMin" ng-model="company.Employer.PayPeriodGroupAppLevyYTD" ng-pattern="$root.REGEX.integersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Enter value in whole pounds</p>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsEmployerForm.apprenticeshipLevyPaidToDate.$touched" ng-messages="companySettingsEmployerForm.apprenticeshipLevyPaidToDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="max">Maximum of \xA3999,999,999</p>\n\t\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.apprenticeshipLevyPaidToDateMin}}</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Onboarding PAYE credit - Freely editable if payroll hasn\'t been run, with caution if payroll has been run -->\n\t<fieldset>\n\t\t<div class="form-intro-split">\n\t\t\t<h4>Onboarding PAYE credit</h4>\n\t\t\t<!-- Override options if payroll has been run for this company -->\n\t\t\t<a class="is-greyscale is-small" href="" ng-click="toggleOverrideOnboardingPAYECredit(company.Employer)" ng-if="company.HasRunPayroll && !company.Employer.overrideOnboardingPAYECredit">\n\t\t\t\t<i class="icon-edit m"></i>&nbsp;&nbsp;Edit amount\n\t\t\t</a>\n\t\t\t<a class="is-greyscale is-small" href="" ng-click="toggleOverrideOnboardingPAYECredit(company.Employer)" ng-if="company.HasRunPayroll && company.Employer.overrideOnboardingPAYECredit">\n\t\t\t\t<i class="icon-cross m"></i>&nbsp;&nbsp;Cancel edit\n\t\t\t</a>\n\t\t</div>\n\n\t\t<value-card ng-if="company.HasRunPayroll && !company.Employer.overrideOnboardingPAYECredit" theme="is-primary" title="Credit amount:" value="company.Employer.OnboardingPAYECredit | monetise" zero-value-text="Not set">\n\t\t</value-card>\n\n\t\t<fieldset ng-if="!company.HasRunPayroll || company.Employer.overrideOnboardingPAYECredit">\n\n\t\t\t<!-- Currently in credit with HMRC? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="inCreditWithHMRCTrue" class="required">Does {{company.CompanyName}} have onboarding PAYE credit with HMRC?</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\n\t\t\t\t\t\t<input class="b" id="inCreditWithHMRCTrue" name="inCreditWithHMRC" ng-model="company.Employer.HasOnboardingPAYECredit" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="inCreditWithHMRCTrue">Yes</label>\n\n\t\t\t\t\t\t<input class="b" id="inCreditWithHMRCFalse" name="inCreditWithHMRC" ng-model="company.Employer.HasOnboardingPAYECredit" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="inCreditWithHMRCFalse">No</label>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Credit amount -->\n\t\t\t<div class="form-field fadeIn" ng-if="company.Employer.HasOnboardingPAYECredit">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="onboardingPAYECredit" class="required">Credit amount:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input class="monetise m-alt" id="onboardingPAYECredit" min="0" name="onboardingPAYECredit" ng-model="company.Employer.OnboardingPAYECredit" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsEmployerForm.onboardingPAYECredit.$touched" ng-messages="companySettingsEmployerForm.onboardingPAYECredit.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Confirmation if editing and payroll has been run -->\n\t\t\t<fieldset>\n\t\t\t\t<note ng-if="company.HasRunPayroll && company.Employer.overrideOnboardingPAYECredit" note-confirmation-field="confirmPAYECreditOverride" note-has-confirmation="true" note-id="confirm-paye-credit-override" note-theme="tertiary" note-title="I wish to update the onboarding PAYE credit amount">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">By ticking this box you are confirming that you understand that making changes to the\n\t\t\t\t\t\t\tonboarding PAYE credit amount will change the amounts due to HMRC for {{company.CompanyName}} next time you run payroll.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- CIS -->\n\t<fieldset class="form-fieldset-divider-top">\n\t\t<div class="form-intro">\n\t\t\t<h4>CIS (Construction Industry Scheme)</h4>\n\t\t\t<p class="s">CIS deductions can be offset against your monthly or quarterly payments to HMRC. You can reduce your tax, National Insurance contributions or CIS payments by the amount of deductions.</p>\n\t\t</div>\n\n\t\t<!-- Deductions suffered -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<label for="deductionsSuffered" class="required">Deductions suffered this tax year to date:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input class="monetise m-alt" id="deductionsSuffered" name="deductionsSuffered" ng-max="$root.CONFIG.number10Digits2Decimal" ng-min="$root.CONFIG.numberMin" ng-model="company.Employer.CISDeductionsSuffered" ng-pattern="$root.REGEX.numbersOnly" required type="number">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsEmployerForm.deductionsSuffered.$touched" ng-messages="companySettingsEmployerForm.deductionsSuffered.$error" role="alert">\n\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.number10Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="min">Minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="pattern">Please enter numbers only</p>\n\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Cancel -->\n\t\t<a href="" ng-click="formOptions.closeForm()" class="button secondary-action">Cancel</a>\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-click="formOptions.back()" class="button secondary-action" ng-if="formOptions.canGoBack">Back</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsEmployerForm.state" disable-button="!companySettingsEmployerForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/eps/companySettingsEPSForm.html','<form name="companySettingsEPSForm" ng-submit="updateAgencyEmployerEPSDisabled(agencyEmployerEPSEnabled, companySettingsEPSForm)" class="fadeIn" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Automatically submit EPS</h5>\n\t\t<p class="s">Your EPS file will be automatically submitted to HMRC each time you run payroll. This can be turned off and you can manually submit your EPS file from your History area at a time of your choosing.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<settings-row sr-field-name="agencyEmployerEPSEnabled" sr-icon="tax-code-change" sr-theme="secondary" ng-model="agencyEmployerEPSEnabled">\n\t\t\t\t<sr-label>Auto submit EPS</sr-label>\n\t\t\t\t<sr-description ng-if="agencyEmployerEPSEnabled">Turning off &lsquo;Auto send&rsquo; means that you will need to submit your EPS file to HMRC manually each time you run payroll.</sr-description>\n\t\t\t\t<sr-description ng-if="!agencyEmployerEPSEnabled">Turning on &lsquo;Auto send&rsquo; means that your EPS file will be automatically submitted to HMRC each time you run payroll.</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsEPSForm.state" disable-button="!companySettingsEPSForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/file-uploads/company-settings-file-uploads.form.html','<div class="fadeIn" ng-switch="$ctrl.formOptions.formState">\n\t<!-- Upload -->\n\t<form class="fadeIn" name="fileUploadsUploadForm" ng-submit="$ctrl.closeForm()" novalidate pc-switch-when="$ctrl.FILE_UPLOAD_FORMS.uploadFile">\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss-key="file-uploads-mention" note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Password protected files">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPassword protected files are frequently used for virus or malware attacks so all uploads are scanned to keep your data safe and secure. \n\t\t\t\t\t\tProtected files will always be rejected whether you have chosen to add a password to them or not.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<file-uploader fu-agency-profile-id="$ctrl.formOptions.agencyProfileId" fu-allow-multiple="true" fu-file-list="$ctrl.documents" fu-label="Drag and drop or click to select files for upload" fu-max-file-size="2097152" fu-name="companySettingsFileUploader" fu-on-error="$ctrl.onError" fu-on-upload-complete="$ctrl.onUploadComplete" fu-on-upload-start="$ctrl.onUploadStart" fu-params="$ctrl.fileUploaderParams"></file-uploader>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-class="{\n\t\t\t\t\t\'is-disabled\': $ctrl.formOptions.isCloseFormDisabled\n\t\t\t\t}" ng-click="$ctrl.onCancelUpload($ctrl, fileUploadsUploadForm, true)">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button disable-button="$ctrl.documents.length === 0" display-text="\'Upload\'" state="fileUploadsUploadForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Rename -->\n\t<form class="fadeIn" name="fileUploadsRenameForm" ng-submit="$ctrl.updateAgencyDocumentName($ctrl.formOptions.document, fileUploadsRenameForm)" novalidate pc-switch-when="$ctrl.FILE_UPLOAD_FORMS.renameFile">\n\t\t<fieldset>\n\n\t\t\t<!-- Text -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="documentName">\n\t\t\t\t\t\tFile label:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t<input id="documentName" name="documentName" ng-model="$ctrl.formOptions.document.DocumentName" required type="text">\n\t\t\t\t</main>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="fileUploadsRenameForm.documentName.$touched" ng-messages="fileUploadsRenameForm.documentName.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a document name</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button disable-button="fileUploadsRenameForm.$invalid" display-text="\'Save\'" state="fileUploadsRenameForm.state"></submit-button>\n\t\t</fieldset>\n\t</form>\n\n\t<!-- Delete -->\n\t<form class="fadeIn" name="fileUploadsDeleteForm" ng-submit="$ctrl.deleteAgencyDocuments($ctrl.documents, fileUploadsDeleteForm)" novalidate pc-switch-when="$ctrl.FILE_UPLOAD_FORMS.deleteFile">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="Are you sure you wish to delete {{$ctrl.documents.length > 1 ? \'these files\' : \'this file\'}}?">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.documents.length === 1">\n\t\t\t\t\tYou\u2019re about to delete the file \u2018{{$ctrl.formOptions.document.documentNameOriginal}}\u2019. This won\u2019t affect any\n\t\t\t\t\timports this file has previously been used for. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.documents.length > 1">\n\t\t\t\t\tYou\u2019re about to delete {{$ctrl.documents.length}} files. This won\u2019t affect any imports that these files have\n\t\t\t\t\tpreviously been used for. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\t\tCancel\n\t\t\t\t</a>\n\t\t\t\t<submit-button display-text="\'Confirm\'" state="fileUploadsDeleteForm.state"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Import -->\n\t<form class="fadeIn" name="fileUploadsImportForm" ng-submit="$ctrl.messageDocumentTransfer($ctrl, fileUploadsImportForm)" novalidate pc-switch-when="$ctrl.FILE_UPLOAD_FORMS.importFile">\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-show-close="false" fs-title="You\u2019re about to import an FPS file">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tOnce you click \u2018Continue\u2019 the importer will be opened and immediately begin validation of your data.\n\t\t\t\t\tOnce the validation has been completed successfully you\u2019ll then be able to import.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\t\tCancel\n\t\t\t\t</a>\n\t\t\t\t<submit-button display-text="\'Continue\'" state="fileUploadsImportForm.state"></submit-button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</form>\n\n\t<!-- Import History -->\n\t<div class="fadeIn" pc-switch-when="$ctrl.FILE_UPLOAD_FORMS.importHistory">\n\t\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-theme="less-margin">\n\t\t\t<fs-main>\n\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<document-upload-row agency-profile-id="$ctrl.formOptions.agencyProfileId" document="$ctrl.formOptions.document"></document-upload-row>\n\t\t\t\t</section>\n\n\t\t\t\t<section class="form-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThis file has been used for the below imports. If you need to undo one of them, head to the Imports page in your Team area.\n\t\t\t\t\t</p>\n\t\t\t\t</section>\n\n\t\t\t\t<section class="form-section centered-contents fadeIn" ng-if="!$ctrl.importHistory">\n\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t</section>\n\n\t\t\t\t<section class="form-section fadeIn" ng-if="$ctrl.importHistory">\n\t\t\t\t\t<!-- Import history -->\n\t\t\t\t\t<div class="import-history-item_wrapper" ng-if="$ctrl.importHistory.length > 0">\n\t\t\t\t\t\t<import-history-item import="import" ng-repeat="import in $ctrl.importHistory"></import-history-item>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- No history -->\n\t\t\t\t\t<div ng-if="$ctrl.importHistory.length === 0" ng-switch="$ctrl.formOptions.document.MIMEFormat">\n\n\t\t\t\t\t\t<!-- FPS / Validated CSV -->\n\t\t\t\t\t\t<div ng-if="\n\t\t\t\t\t\t\t\t$ctrl.formOptions.document.MIMEFormat === $ctrl.MIME_FORMATS.fps ||\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t$ctrl.formOptions.document.MIMEFormat === $ctrl.MIME_FORMATS.csv &&\n\t\t\t\t\t\t\t\t\t$ctrl.formOptions.document.DocumentState === $ctrl.DOCUMENT_STATES.checked\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<placeholder placeholder-graphic="no-imports">\n\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t<p>This file hasn\u2019t been used for any imports yet</p>\n\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t\t<placeholder-primary-actions ng-switch="$ctrl.formOptions.document.MIMEFormat">\n\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.setFormState($ctrl.FILE_UPLOAD_FORMS.importFile)" pc-switch-when="$ctrl.MIME_FORMATS.fps">\n\t\t\t\t\t\t\t\t\t\tImport now\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.formOptions.document, $ctrl.DOCUMENT_TYPES.teamImport, $ctrl.formOptions.agencyProfileId)" pc-switch-when="$ctrl.MIME_FORMATS.csv">\n\t\t\t\t\t\t\t\t\t\tImport team data\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.formOptions.document, $ctrl.DOCUMENT_TYPES.periodImport, $ctrl.formOptions.agencyProfileId)" pc-switch-when="$ctrl.MIME_FORMATS.csv">\n\t\t\t\t\t\t\t\t\t\tImport payroll data\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Unvalidated CSV -->\n\t\t\t\t\t\t<div ng-if="\n\t\t\t\t\t\t\t$ctrl.formOptions.document.MIMEFormat === $ctrl.MIME_FORMATS.csv &&\n\t\t\t\t\t\t\t$ctrl.formOptions.document.DocumentState === $ctrl.DOCUMENT_STATES.unchecked\n\t\t\t\t\t\t">\n\t\t\t\t\t\t\t<placeholder placeholder-graphic="no-imports">\n\t\t\t\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t\t\t\t<p>Validate this file before using it to import team or payroll data</p>\n\t\t\t\t\t\t\t\t</placeholder-copy>\n\t\t\t\t\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.formOptions.document, $ctrl.DOCUMENT_TYPES.teamImport, $ctrl.formOptions.agencyProfileId)">\n\t\t\t\t\t\t\t\t\t\tImport team data\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a class="button primary" href="" ng-click="$ctrl.goToDataImporterForDocumentType($ctrl.formOptions.document, $ctrl.DOCUMENT_TYPES.periodImport, $ctrl.formOptions.agencyProfileId)">\n\t\t\t\t\t\t\t\t\t\tImport payroll data\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</placeholder-primary-actions>\n\t\t\t\t\t\t\t</placeholder>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Error -->\n\t<div class="fadeIn" ng-switch-when="error">\n\t\t<error-block secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n\t</div>\n</div>\n');
$templateCache.put('forms/admin/companySettings/gender-pay-gap-delete/company-settings-gender-pay-gap-delete.form.html','<form class="fadeIn" name="companySettingsGenderPayGapDeleteForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.onFormSubmit(companySettingsGenderPayGapDeleteForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to delete this report?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">Once you delete \'{{:: $ctrl.formOptions.report.GenderPayGapReportName }}\' this cannot be undone. Click \'Confirm\' if you\'re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<button class="secondary-action" data-cy="cancel-gender-pay-gap-delete-form" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<!-- Save -->\n\t\t\t<submit-button button-id="submit-gender-pay-gap-delete-form" display-text="\'Confirm\'" state="companySettingsGenderPayGapDeleteForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="is-secondary" fs-title="Report deleted" ng-if="$ctrl.pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">Your gender pay gap report report has been deleted.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/gender-pay-gap-enabled/company-settings-gender-pay-gap-enabled.form.html','<form class="fadeIn" name="companySettingsGenderPayGapEnabledForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.onFormSubmit(companySettingsGenderPayGapEnabledForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<settings-row sr-field-name="isGenderPayGapEnabled" sr-icon="setup-user" sr-theme="is-primary" ng-model="$ctrl.isGenderPayGapEnabled">\n\t\t\t\t<sr-label>Gender pay gap reporting</sr-label>\n\t\t\t\t<sr-description ng-if="$ctrl.isGenderPayGapEnabled">Turning this off means that gender pay reporting cannot be accessed in the \'Report & Journals\' area of {{ $ctrl.formOptions.company.isPayrollCompany ? \'company\' : \'group\' }} settings for {{ $ctrl.formOptions.company.Name }}.</sr-description>\n\t\t\t\t<sr-description ng-if="!$ctrl.isGenderPayGapEnabled">Turning this on means that gender pay reporting can be accessed in the \'Report & Journals\' area of {{ $ctrl.formOptions.company.isPayrollCompany ? \'company\' : \'group\' }} settings for {{ $ctrl.formOptions.company.Name }}.</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="cancel-gender-pay-gap-enabled-form" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button button-id="submit-gender-pay-gap-enabled-form" disable-button="companySettingsGenderPayGapEnabledForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsGenderPayGapEnabledForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/hmrc/companySettingsHmrcForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsHmrcFormCtrl" ng-if="pageState === \'ready\'" ng-submit="saveCompanyReferences(company.Employer, companySettingsHmrcFormCtrl)" novalidate>\n\t<fieldset ng-if="::isInPlayground">\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> Company references are not editable in your playground.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset ng-class="{ \'form-fieldset-divider-top\' : isInPlayground }">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Electronic updates</h4>\n\t\t\t<p class="s">\n\t\t\t\tWe suggest enabling electronic updates from HMRC to automatically keep tax codes and student loan notices up to date.\n\t\t\t\tYour credentials will be validated when you click \u2018Save\u2019.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- HMRC Credentials - Not valid -->\n\t\t<fieldset class="fadeIn" ng-if="company.Employer.areHmrcCredentialsEditable">\n\n\t\t\t<!-- Electronic updates enabled? -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="electronicallyUpdateTrue" class="required">Enable electronic updates:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<input class="b" id="electronicallyUpdateTrue" name="electronicallyUpdate" ng-change="enableElectronicUpdatesChanged(company.Employer)" ng-disabled="::isInPlayground" ng-model="company.Employer.DPSImport" ng-value="true" type="radio">\n\t\t\t\t\t\t<label for="electronicallyUpdateTrue">Yes</label>\n\n\t\t\t\t\t\t<input class="b" id="electronicallyUpdateFalse" name="electronicallyUpdate" ng-change="enableElectronicUpdatesChanged(company.Employer)" ng-disabled="::isInPlayground" ng-model="company.Employer.DPSImport" ng-value="false" type="radio">\n\t\t\t\t\t\t<label for="electronicallyUpdateFalse">No</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">You\'ll need to make sure electronic updates, also known as Electronic Data Interchange (EDI), is enabled in your HMRC account.\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">Find out how</support-article-link>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<fieldset>\n\n\t\t\t\t<!-- HMRC User ID -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="hmrcUserId" ng-class="{ \'required\' : company.Employer.DPSImport }">HMRC User ID:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcUserId" maxlength="{{$root.CONFIG.hmrcUsernameMaxLength}}" name="hmrcUserId" ng-model="company.Employer.HMRCUserName" ng-readonly="::isInPlayground" ng-required="company.Employer.DPSImport" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsHmrcFormCtrl.hmrcUserId.$touched" ng-messages="companySettingsHmrcFormCtrl.hmrcUserId.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the HMRC User ID</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- HMRC Password -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<label for="hmrcPassword" ng-class="{ \'required\' : company.Employer.DPSImport }">HMRC Password:</label>\n\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t<input autocomplete="off" class="l" id="hmrcPassword" name="hmrcPassword" ng-model="company.Employer.HMRCPassword" ng-readonly="::isInPlayground" ng-required="company.Employer.DPSImport" type="text">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsHmrcFormCtrl.hmrcPassword.$touched" ng-messages="companySettingsHmrcFormCtrl.hmrcPassword.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter the HMRC Password</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Automatic updates -->\n\t\t\t\t<div class="form-field fadeIn">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<settings-row ng-if="company.Employer.DPSImport" ng-model="company.Employer.DPSAutoApply" on-update="validateModuleSelection(companyModules)" sr-disabled="isInPlayground" sr-field-name="dpsImport" sr-label="Automatically accept HMRC updates" sr-theme="secondary">\n\t\t\t\t\t\t\t<sr-description>Updates from HMRC will be automatically applied. This includes tax code changes, along with any Year to Date updates, and student loan notices.</sr-description>\n\t\t\t\t\t\t</settings-row>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message fadeIn" ng-if="company.Employer.DPSAutoApply">\n\t\t\t\t\t\tPlease note that any tax code updates received while payroll is in a calculated state may need to be manually accepted if you need to re-calculate payroll soon after undoing\n\t\t\t\t\t\tthe previous calculation.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\t\t<!-- HMRC Credentials - Valid -->\n\t\t<fieldset class="fadeIn" ng-if="!company.Employer.areHmrcCredentialsEditable">\n\t\t\t<div class="info-block positive">\n\t\t\t\t<p class="s">Electronic updates are currently enabled.\n\t\t\t\t\t<a class="underline" href="" ng-click="editHMRCCredentials(company.Employer)">Change settings</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<!-- Electronic updates warning -->\n\t\t<fieldset>\n\t\t\t<note ng-if="formOptions.company.IsInTestMode" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Electronic updates in Test Mode">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Please note that {{formOptions.company.Name}} are currently in Test Mode and electronic updates will not be applied.\n\t\t\t\t\t\tOnce you switch them to Live Mode then updates will be applied as they become available.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="companySettingsHmrcFormCtrl.state === \'saved\'" state="companySettingsHmrcFormCtrl.state">\n\t\t\t<p>This information has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!companySettingsHmrcFormCtrl.$valid" display-text="formOptions.primaryButtonText" state="companySettingsHmrcFormCtrl.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Testing HMRC credentials -->\n<section class="form-summary fadeIn" ng-if="pageState === \'testing-hmrc-credentials\'">\n\t<loading-block size="m">\n\t\t<lb-description>Validating HMRC credentials...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">We\'re quickly testing the connection to HMRC. This shouldn\'t take too long.</p>\n\t</section>\n</section>\n\n<!-- HMRC credentials invalid -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to validate HMRC credentials" ng-if="pageState === \'hmrc-credentials-invalid\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to validate the HMRC credentials entered.</p>\n\t\t<p class="s">\n\t\t\t<a href="" ng-click="setPageState(\'ready\')" class="underline">Go back and try again</a>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- HMRC credentials valid but Electronic updates are not switched on -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Electronic updates not enabled" ng-if="pageState === \'automatic-updates-not-enabled\'">\t<fs-main>\n\t\t<p class="s">We were able to connect to HMRC successfully although it appears as though your electronic HMRC notices are not enabled.\n\t\t\tYou\'ll need to turn these on to enable electronic notices. Follow\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">these simple steps</support-article-link> to switch electronic notices on.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()">\n</error-block>\n');
$templateCache.put('forms/admin/companySettings/holiday-policy/companySettingsHolidayPolicyForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsHolidayPolicyForm" ng-submit="saveForm(form, companySettingsHolidayPolicyForm, policy)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Policy Name -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="policyName" class="required">Policy name:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="policyName" name="policyName" type="text" placeholder="Standard holiday policy" ng-model="policy.HolidayPolicyName" required>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsHolidayPolicyForm.policyName.$error" ng-if="companySettingsHolidayPolicyForm.policyName.$touched" role="alert">\n\t\t\t\t<p ng-message="required || pattern">Please enter a Policy name</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Policy Description -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="policyDescription" class="required">Description:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<textarea id="policyDescription" name="policyDescription" placeholder="Holiday policy is 28 days including bank holidays - no days rolled over" ng-model="policy.HolidayPolicyDescription" required></textarea>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsHolidayPolicyForm.policyDescription.$error" ng-if="companySettingsHolidayPolicyForm.policyDescription.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a Policy description</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Holiday Year -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="policyDescription" class="required">Holiday year:</label>\n\t\t\t\t<p class="form-field-sub greyscale-darkened">\n\t\t\t\t\tAdd the dates you wish your holiday year to run between\n\t\t\t\t</p>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="date-range">\n\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t<date-input-field field-id="startDate" field-value-iso="policy.HolidayPolicyDateFromISO" field-required="true" field-ng-model-options="{ updateOn: \'blur\' }" field-on-change="addAYear">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="date-range__icon">\n\t\t\t\t\t\t<i class="icon-arrow-right"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="date-range__input">\n\t\t\t\t\t\t<date-input-field field-id="endDate" field-value-iso="policy.HolidayPolicyDateToISO" field-required="true" field-ng-model-options="{ updateOn: \'blur\' }" field-on-change="subtractAYear">\n\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsHolidayPolicyForm.startDate.$error" ng-if="companySettingsHolidayPolicyForm.startDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a start date for the holiday year</p>\n\t\t\t\t<p ng-message="min && max">Please enter a start date within this year</p>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsHolidayPolicyForm.endDate.$error" ng-if="companySettingsHolidayPolicyForm.endDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a end date for the holiday year</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-links">\n\t\t\t\t<p>Set as <a href ng-click="setYearTo(\'calendar\')">Calendar year</a> <span>|</span> <a href ng-click="setYearTo(\'tax\')">Tax year</a></p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Total holiday days and rollover days -->\n\t\t<div class="form-field-group">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="policyDescription" class="required">Total holiday:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<number-picker ng-model="policy.HolidayPolicyDays" field-name="policyToda" heading="days" figure-type="\'\'" step="1" min="1" max="100"></number-picker>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="policyDescription" class="required">Rollover days:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<number-picker ng-model="policy.HolidayPolicyRolloverDays" heading="days" figure-type="\'\'" step="1" min="0" max="100"></number-picker>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Includes bank holidays -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="policyBankHolidays" name="policyBankHolidays" ng-model="policy.HolidayPolicyBankHolidays" label-text="\'This includes bank holidays\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<a href="" ng-if="!formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsHolidayPolicyForm.state" disable-button="!companySettingsHolidayPolicyForm.$valid"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Your holiday policy has been updated" ng-if="pageState === \'saved-policy\'">\n\t<fs-main>\n\t\t<p class="s">If you wish to manage your team\'s holiday right away, <a ui-sref="hr.holiday-sickness({agencyProfileId: agencyProfileId})">head to the holiday and sickness tracker</a>.\n\t\t\tTo find out more about tracking holiday and sickness, read our\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.holidayAndSickness">guide to holiday and sickness policies</support-article-link>.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/inactive-period/companySettingsInactivePeriodForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsInactivePeriodForm" ng-submit="updateAgencyEmployerInactivity(vm, companySettingsInactivePeriodForm)" class="fadeIn" ng-if="pageState === \'setup\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">If you are not paying any team members for a while but you think that you might be paying them again in the future, you can report a Period of inactivity to HMRC rather than running \u2018nil\u2019 payrolls for that period of inactivity.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.periodOfInactivity" underline="true">Read more about reporting a Period of inactivity</support-article-link>\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<settings-row sr-field-name="hasPeriodOfInactivity" sr-icon="clock" ng-model="vm.inactivityDetails.HasPeriodOfInactivity" sr-disabled="vm.inactivityDetails.inactivePeriodExists">\n\t\t\t<sr-label>Period of inactivity</sr-label>\n\t\t\t<sr-description>Turning on a Period of inactivity will send a single submission to HMRC to inform them that there will be no payroll submissions for the period that you select.</sr-description>\n\t\t\t<sr-content ng-if="vm.inactivityDetails.HasPeriodOfInactivity && !vm.inactivityDetails.inactivePeriodExists">\n\t\t\t\t<fieldset class="fadeIn">\n\n\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tSelect the beginning of the period and end of the period for the Period of Inactivity submission.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<!-- First period -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="firstInactivePeriod">First submission:</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="firstInactivePeriod" class="primary" name="firstInactivePeriod" type="text" readonly="readonly" ng-model="vm.firstInactivePeriod.PayPeriodDisplay">\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Last period -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="lastInactivePeriod" class="required">Last submission:</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<select name="lastInactivePeriod" id="lastInactivePeriod" ng-model="vm.lastInactivePeriod" ng-options="payPeriod.PayPeriodDisplay for payPeriod in vm.inactivityDetails.UpcomingIncompletePeriods" required>\n\t\t\t\t\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">Please select a period...</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsInactivePeriodForm.lastInactivePeriod.$error" ng-if="companySettingsInactivePeriodForm.lastInactivePeriod.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a period</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset ng-if="vm.lastInactivePeriod">\n\t\t\t\t\t\t<p class="s fadeIn" ng-if="vm.firstInactivePeriod.PayPeriodID !== vm.lastInactivePeriod.PayPeriodID">A period of activity will be reported from <span class="primary stronger">{{vm.firstInactivePeriod.PayPeriodDisplay}}</span> to <span class="primary stronger">{{vm.lastInactivePeriod.PayPeriodDisplay}}</span>. Your reports will be available in your history as usual and include a \u2018EPS nil submission\u2019 report.</p>\n\t\t\t\t\t\t<p class="s fadeIn" ng-if="vm.firstInactivePeriod.PayPeriodID === vm.lastInactivePeriod.PayPeriodID">A period of activity will be reported in <span class="primary stronger">{{vm.firstInactivePeriod.PayPeriodDisplay}}</span>. Your reports will be available in your history as usual and include a \u2018EPS nil submission\u2019 report.</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t</fieldset>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\t<div class="form-section" ng-if="vm.inactivityDetails.inactivePeriodExists">\n\t\t<note note-theme="assertive-darkened">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note: you\u2019ve already submitted a number of periods of inactivity. Please re-open all inactive periods from <a href="" ui-sref="payroll.history.pay-periods({agencyProfileId: agencyProfileId})" class="assertive-darkened underline">your History page</a> before selecting a new range of periods of inactivity.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsInactivePeriodForm.state" disable-button="!(vm.inactivityDetails.HasPeriodOfInactivity && vm.lastInactivePeriod)"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Period of inactivity reported" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">If you later change your mind and wish to re-open one of your inactive periods, you can do so from <a href="" ui-sref="payroll.history.pay-periods({agencyProfileId: agencyProfileId})" class="primary underline">your History page</a>.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" ng-if="pageState === \'reopen\'" fs-show-close="false">\n\t<fs-main>\n\t\t<p class="s">Reopening the {{vm.payPeriod.PayPeriodDisplay}} period will also remove all later periods of inactivity.\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.periodOfInactivity" underline="true">Read more about reporting a period of inactivity</support-article-link>\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="tertiary primary-action" ng-click="reopenInactivePeriod(vm)">Reopen period</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Pay period reopened" ng-if="pageState === \'reopened\'">\n\t<fs-main>\n\t\t<p class="s">{{vm.payPeriod.PayPeriodDisplay}} has been reopened and all later periods of inactivity have been removed.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Can\'t reopen period" ng-if="pageState === \'cant-reopen\'">\n\t<fs-main>\n\t\t<p class="s">{{vm.payPeriod.PayPeriodDisplay}} cannot be reopened because there are completed, or partially submitted periods after it.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/journals/company-settings-delete-nominal-code.form.html','<form class="fadeIn" name="deleteNominalCodeForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.deleteNominalCode(deleteNominalCodeForm, $ctrl)" novalidate>\n\n\t<!-- Confirmation -->\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-title="Are you sure you wish to delete this nominal code?" ng-if="$ctrl.formState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<p class="s">\n\t\t\t\tAny pay elements you\u2019ve allocated to this code will need to be allocated to another code if you wish to include them in your journal. Click &lsquo;Confirm&rsquo; if you\u2019re happy\n\t\t\t\tto continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!deleteNominalCodeForm.$valid" display-text="\'Confirm\'" state="deleteNominalCodeForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<!-- Saved -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Business category deleted" ng-if="$ctrl.formState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Your business category has been deleted and your Journal Code Preview has been updated.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- In use -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to delete" ng-if="$ctrl.formState === \'in-use\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t&lsquo;{{$ctrl.formOptions.businessCategory.BusinessCategoryName}}&rsquo; has been assigned to team members and cannot be deleted. Re-assign them to a new business category before trying again.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/journals/companySettingsAddNominalCodesForm.html','<div ng-if="pageState === \'ready\'">\n\t<form class="fadeIn" name="addNominalCodesForm" ng-submit="updateNominalCodes(addNominalCodesForm, nominalCodes, isUpdate)" novalidate>\n\n\t\t<div class="form-intro">\n\t\t\t<p class="s">Add as many nominal codes and narratives as you need to below. Please note that if you later delete a code,\n\t\t\t\tit won\'t affect any journals that previously used it.</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<nominal-code-form-field agency-profile-id="agencyProfileId" class="fadeIn" index="$index" is-financials-integrated="formOptions.isFinancialsIntegrated" ng-if="!nominalCode.NominalCodeArchived" ng-repeat="nominalCode in nominalCodes" nominal-code-list="nominalCodes" nominal-code="nominalCode" show-actions="!$first"></nominal-code-form-field>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="addNominalCode(nominalCodes)" type="button">\n\t\t\t\t<i class="icon-add m button_icon-pre"></i>Add nominal code\n\t\t\t</button>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="addNominalCodesForm.state" disable-button="!addNominalCodesForm.$valid"></submit-button>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<!-- Create -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Nominal codes saved" ng-if="pageState === \'add-success\'">\n\t<fs-main>\n\t\t<p class="s">Your nominal codes have been saved and you can now start allocating pay elements to them.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Edit -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Nominal codes saved" ng-if="pageState === \'edit-success\'">\n\t<fs-main>\n\t\t<p class="s">Your nominal codes have been updated. Please note that if you deleted any codes, journals previously created with those will not be affected.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/journals/companySettingsDeleteBusinessCategoryForm.html','<div ng-if="pageState === \'ready\'">\n\t<form name="deleteBusinessCategoryForm" ng-submit="deleteBusinessCategory(deleteBusinessCategoryForm, businessCategory)" class="fadeIn" novalidate>\n\n\t\t<!-- Confirmation -->\n\t\t<form-state form-options="formOptions" fs-icon="tick" fs-title="Are you sure you wish to delete this category?" fs-show-close="false" ng-if="pageState === \'ready\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="s">You\'re about to delete the &lsquo;{{formOptions.businessCategory.BusinessCategoryName}}&rsquo; business category.\n\t\t\t\t\tTeam members who have already been added to this category in their profiles, will be removed from it.\n\t\t\t\t\tIf you\'re happy to continue, click &lsquo;Delete&rsquo;.\n\t\t\t\t</p>\n\t\t\t\t<p class="s">Please note that journals previously created using this category will not be affected.</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button display-text="formOptions.primaryButtonText" state="deleteBusinessCategoryForm.state" disable-button="!deleteBusinessCategoryForm.$valid"></submit-button>\n\t\t</fieldset>\n\n\t</form>\n</div>\n\n<!-- Saved -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Business category deleted" ng-if="pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Your business category has been deleted and your Journal Code Preview has been updated.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- In use -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to delete" ng-if="pageState === \'in-use\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\t&lsquo;{{formOptions.businessCategory.BusinessCategoryName}}&rsquo; has been assigned to team members and cannot be deleted. Re-assign them to a new business category before trying again.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/ni-updates/company-settings-ni-updates.form.html','<form class="fadeIn" name="companySettingsNiUpdatesForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateAgencyEmployerAutoApplyNICodeChanges(companySettingsNiUpdatesForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Auto-accept NI Category updates</h5>\n\t\t<p class="is-small">\n\t\t\tBy default, the system will automatically update NI Categories if, for example, a team member turns State Pension age.\n\t\t\tThis can be turned off, however, and updates can be accepted manually from your Current period page.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<settings-row ng-model="$ctrl.formOptions.company.AutoApplyNICode" sr-field-name="autoApplyNiCode" sr-icon="loading" sr-theme="primary">\n\n\t\t\t\t<sr-label>Auto-accept NI Category updates</sr-label>\n\n\t\t\t\t<sr-description ng-if="vm.AutoApplyNICode">\n\t\t\t\t\tTurning off &lsquo;Auto accept NI category updates&rsquo; means your employees\' national insurance category letters will need to be manually applied\n\t\t\t\t</sr-description>\n\n\t\t\t\t<sr-description ng-if="!vm.AutoApplyNICode">\n\t\t\t\t\tTurning on &lsquo;Auto accept NI category updates&rsquo; means your employees\' national insurance category letters will be automatically applied\n\t\t\t\t</sr-description>\n\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button disable-button="companySettingsNiUpdatesForm.$pristine" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsNiUpdatesForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/nmw-calculation/company-settings-nmw-calculation.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="companySettingsNmwCalculationForm" ng-submit="$ctrl.updateCompanyNMWCalculationMethod($ctrl, companySettingsNmwCalculationForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>How would you like national minimum wage calculated?</label>\n\t\t\t</header>\n\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\n\t\t\t\t\t<div class="radio-row" ng-repeat="method in $ctrl.nmwCalculationMethods">\n\t\t\t\t\t\t<input class="b radio-row-input" id="nmwCalculationMethod-{{method}}" name="nmwCalculationMethods" ng-model="$ctrl.company.NMWCalculationMethod" ng-value="method" type="radio">\n\n\t\t\t\t\t\t<label for="nmwCalculationMethod-{{method}}" class="radio-row-label">\n\t\t\t\t\t\t\t<p class="radio-row-title">{{::method | nmwCalculationMethod}}</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsNmwCalculationForm.state" disable-button="!companySettingsNmwCalculationForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/p11d-submission/company-settings-p11d-submission.form.html','<loading-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="p11dSubmissionForm" ng-submit="$ctrl.saveForm($ctrl, newP11dSubmission)" ng-if="$ctrl.formState !== $ctrl.FORM_STATES.confirmDelete && $ctrl.formState !== $ctrl.FORM_STATES.deleted" novalidate>\n\t<!-- Step 1 -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.step1">\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="payPeriodId">Choose the tax year</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select class="block" id="payPeriodId" name="payPeriodId" ng-model="$ctrl.payPeriodId" ng-options="option.PayPeriodID as option.TaxYearDisplay for option in $ctrl.taxYears" required>\n\t\t\t\t\t\t\t<option value="" selected="selected">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.payPeriodId.$touched" ng-messages="p11dSubmissionForm.payPeriodId.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please select an option</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<br>\n\n\t\t\t<div class="form-field-highlight tertiary">\n\t\t\t\t<p class="is-small greyscale-100">\n\t\t\t\t\tBefore continuing, we recommend you check that a P11D(b) hasn\'t already been submitted for another company on the same PAYE scheme for the selected tax year.\n\t\t\t\t\tIf it has, and these figures were intended to be included in that submission, then you may need to send any corrections via a paper P11D(b) now.\n\t\t\t\t</p>\n\t\t\t\t<br>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input checkbox id="hasCheckedPaye" label-text="\'I have checked other companies on this PAYE scheme\'" name="hasCheckedPaye" ng-model="$ctrl.hasCheckedPaye" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-actions">\n\n\t\t\t<!-- Close -->\n\t\t\t<button class="secondary-action" data-cy="open-form-ui-kit-close" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<!-- Next -->\n\t\t\t<button class="primary-action is-tertiary" ng-click="$ctrl.goToStep2()" ng-disabled="!$ctrl.hasCheckedPaye || !$ctrl.payPeriodId" type="button">\n\t\t\t\tNext\n\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Step 2 -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.step2">\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear is-strong">\n\t\t\t\tTax year {{$ctrl.p11dSubmission.TaxYearDisplay}}\n\t\t\t</div>\n\n\t\t\t<br>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Company info.</h4>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="P11DbSubmissionCompanyName">Company name:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="P11DbSubmissionCompanyName" name="P11DbSubmissionCompanyName" ng-model="$ctrl.p11dSubmission.P11DbSubmissionCompanyName" ng-pattern="$ctrl.p11dSubmission.P11DbSubmissionCompanyNameRegex" required type="text">\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Max. 35 characters.</p>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionCompanyName.$invalid" ng-messages="p11dSubmissionForm.P11DbSubmissionCompanyName.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t\t<p ng-message="pattern">Maximum of 35 characters</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="P11DbSubmissionAccountsOffice">\n\t\t\t\t\t\tAccounts Office reference number:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="is-primary-lighter-flat" id="P11DbSubmissionAccountsOffice" name="P11DbSubmissionAccountsOffice" ng-model="$ctrl.p11dSubmission.P11DbSubmissionAccountsOffice" readonly="readonly" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="P11DbSubmissionTaxOffice">\n\t\t\t\t\t\tTax Office reference number:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="m is-primary-lighter-flat" id="P11DbSubmissionTaxOffice" name="P11DbSubmissionTaxOffice" ng-model="$ctrl.p11dSubmission.P11DbSubmissionTaxOffice" readonly="readonly" type="text">\n\t\t\t\t\t&nbsp;\n\t\t\t\t\t<input class="m is-primary-lighter-flat" id="P11DbSubmissionTaxOfficeRef" name="P11DbSubmissionTaxOfficeRef" ng-model="$ctrl.p11dSubmission.P11DbSubmissionTaxOfficeRef" readonly="readonly" type="text">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<fieldset class="form-actions">\n\n\t\t\t<button class="secondary-action" ng-disabled="$ctrl.isStep1Disabled" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step1)" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<button class="primary-action is-tertiary" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step3)" ng-disabled="p11dSubmissionForm.$invalid" type="button">\n\t\t\t\tNext\n\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Step 3 -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.step3">\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear is-strong">\n\t\t\t\tTax year {{$ctrl.p11dSubmission.TaxYearDisplay}}\n\t\t\t</div>\n\n\t\t\t<br>\n\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Class 1A NICs due</h4>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="P11DbSubmissionNICRate">Class 1A NICs rate:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input class="l is-primary-lighter-flat" id="P11DbSubmissionNICRate" name="P11DbSubmissionNICRate" ng-min="0" ng-model="$ctrl.p11dSubmission.P11DbSubmissionNICRate" placeholder="Enter value" required readonly="readonly" type="number">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionNICRate.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionNICRate.$error" role="alert">\n\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="P11DbSubmissionBenefitsLiable">Total benefits liable to Class 1A NICs:</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input id="P11DbSubmissionBenefitsLiable" name="P11DbSubmissionBenefitsLiable" ng-min="0" ng-model="$ctrl.p11dSubmission.P11DbSubmissionBenefitsLiable" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t</div>\n\t\t\t\t<p class="form-message">Max. 2 decimal places.</p>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionBenefitsLiable.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionBenefitsLiable.$error" role="alert">\n\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<br>\n\n\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<input checkbox id="adjustAboveFigure" label-text="\'Adjust the above figure\'" name="adjustAboveFigure" ng-model="$ctrl.adjustAboveFigure" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tYou may need to adjust the total figure above if, for example, you\'ve incorrectly reported a cash equivalent figure,\n\t\t\t\t\t\t\t\tor included employees who aren\'t liable for National Insurance, on forms P11D.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="fadeIn" ng-if="$ctrl.adjustAboveFigure">\n\t\t\t\t\t<br>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="textField">Amounts not included in \u2018Total benefits\u2019 on which Class 1A NICs are due:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="P11DbSubmissionAdjustmentDueAmount" name="P11DbSubmissionAdjustmentDueAmount" ng-min="0" ng-model="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentDueAmount" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message">Max. 2 decimal places. If none, enter \'0\'</p>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionAdjustmentDueAmount.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionAdjustmentDueAmount.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="textField">Brief description:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<textarea id="P11DbSubmissionAdjustmentDueDescription" name="P11DbSubmissionAdjustmentDueDescription" ng-model="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentDueDescription" ng-pattern="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentDueDescriptionRegex" placeholder="Enter description" required>\n\t\t\t\t\t\t\t</textarea>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message">Max. 35 characters. If the figure above is \'0\', enter \'N/A\'</p>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionAdjustmentDueDescription.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionAdjustmentDueDescription.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a description</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of 35 characters</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<hr class="l">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="textField">Amounts included in \u2018Total benefits\u2019 on which Class 1A NICs are not due:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input id="P11DbSubmissionAdjustmentNotDueAmount" name="P11DbSubmissionAdjustmentNotDueAmount" ng-min="0" ng-model="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentNotDueAmount" ng-pattern="$root.REGEX.decimal" placeholder="Enter value" required type="number">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message">Max. 2 decimal places. If none, enter \'0\'</p>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionAdjustmentNotDueAmount.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionAdjustmentNotDueAmount.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="min">Amount should be no less than 0</p>\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a value</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label class="required" for="textField">Brief description:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<textarea id="P11DbSubmissionAdjustmentNotDueDescription" name="P11DbSubmissionAdjustmentNotDueDescription" ng-model="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentNotDueDescription" ng-pattern="$ctrl.p11dSubmission.P11DbSubmissionAdjustmentNotDueDescriptionRegex" placeholder="Enter description" required>\n\t\t\t\t\t\t\t</textarea>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message">Max. 35 characters. If the figure above is \'0\', enter \'N/A\'</p>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="p11dSubmissionForm.P11DbSubmissionAdjustmentNotDueDescription.$touched" ng-messages="p11dSubmissionForm.P11DbSubmissionAdjustmentNotDueDescription.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="required">Please enter a description</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Maximum of 35 characters</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.goToStep2()" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\n\t\t\t<submit-button button-id="p11dSubmissionForm-submit" disable-button="p11dSubmissionForm.$invalid" display-text="\'Next\'"></submit-button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Generating -->\n\t<section class="form-summary fadeIn" ng-if="$ctrl.formState === $ctrl.FORM_STATES.generating">\n\t\t<loading-block size="m" position="after">\n\t\t\t<lb-description><h4>Generating draft report</h4></lb-description>\n\t\t</loading-block>\n\t\t<section class="form-summary-section align-center">\n\t\t\t<p class="is-small">\n\t\t\t\tYour draft report is being generated and this should only take a few moments.\n\t\t\t\tPlease don\'t click back or close your browser window\n\t\t\t</p>\n\t\t</section>\n\t</section>\n\n\t<!-- Step 4 -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.step4">\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear is-strong">\n\t\t\t\tTax year {{$ctrl.p11dSubmission.TaxYearDisplay}}\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<h4>Draft report</h4>\n\t\t\t</div>\n\n\t\t\t<p class="is-greyscale is-small">\n\t\t\t\tClick \'Finish later\' to save the draft to your submissions page so you can continue with it later.\n\t\t\t\tYou can download the report from the action menu for the draft submission at any time.\n\t\t\t</p>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<report-card-clickable action="$ctrl.openReportPreview" icon="icon-download" subtitle="Created at {{$ctrl.p11dSubmission.P11DbSubmissionCreatedDateISO  | datetimeformat:\'detailed\'}}" title="P11D(b) Report">\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step3)" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.openDeleteConfirmationView()" type="button">\n\t\t\t\tDelete\n\t\t\t</button>\n\n\t\t\t<button class="tertiary-action is-tertiary" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step5)" type="button">\n\t\t\t\tNext\n\t\t\t</button>\n\n\t\t\t<button class="primary-action is-tertiary" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\tFinish later\n\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Step 5 -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.step5">\n\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight clear is-strong">\n\t\t\t\tTax year {{$ctrl.p11dSubmission.TaxYearDisplay}}\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<br>\n\t\t<fieldset>\n\t\t\t<p class="is-greyscale is-small">\n\t\t\t\tReview your data and confirm that you\'re happy to make your submission.\n\t\t\t</p>\n\t\t</fieldset>\n\t\t<br>\n\t\t<fieldset>\n\t\t\t<div class="form-field-highlight primary">\n\t\t\t\t<div class="form-fieldset-header">\n\t\t\t\t\t<i class="icon-company primary m has-margin-right">\n\t\t\t\t\t</i>\n\t\t\t\t\t&nbsp;<h5 class="m">{{$ctrl.p11dSubmission.P11DbSubmissionCompanyName}}</h5>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tA/C Office Ref: {{$ctrl.p11dSubmission.P11DbSubmissionAccountsOffice}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tTax Office Ref: {{$ctrl.p11dSubmission.P11DbSubmissionTaxOffice}}/{{$ctrl.p11dSubmission.P11DbSubmissionTaxOfficeRef}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="divider primary"></div>\n\t\t\t\t<div class="form-field-group">\n\t\t\t\t\t<p class="is-small">Class 1A NICs rate:</p>\n\t\t\t\t\t<p class="is-small">{{$ctrl.p11dSubmission.P11DbSubmissionNICRate | formatDecimal}}%</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-group no-margin top">\n\t\t\t\t\t<p class="is-small">Total benefits liable to Class 1A NICs:</p>\n\t\t\t\t\t<p class="is-small">{{$ctrl.p11dSubmission.P11DbSubmissionBenefitsLiable | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-group no-margin top">\n\t\t\t\t\t<p class="is-small">Amounts not included in \u2018Total benefits\u2019 on which Class 1A NICs are due:</p>\n\t\t\t\t\t<p class="is-small">{{$ctrl.p11dSubmission.P11DbSubmissionAdjustmentDueAmount | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-group no-margin top">\n\t\t\t\t\t<p class="is-small">Amounts included in \u2018Total benefits\u2019 on which Class 1A NICs are not due:</p>\n\t\t\t\t\t<p class="is-small">{{$ctrl.p11dSubmission.P11DbSubmissionAdjustmentNotDueAmount | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-group no-margin top">\n\t\t\t\t\t<p class="is-small">Total of benefits on which Class 1A NICs are due:</p>\n\t\t\t\t\t<p class="is-small">{{$ctrl.p11dSubmission.P11DbSubmissionBenefitsLiableTotal | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="divider primary"></div>\n\t\t\t\t<div class="form-field-group no-margin top">\n\t\t\t\t\t<p class="is-strong">Class 1A NICs payable:</p>\n\t\t\t\t\t<p class="is-strong">{{$ctrl.p11dSubmission.P11DbSubmissionNICPayable | monetise}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset>\n\t\t\t<div class="form-section">\n\t\t\t\t<div class="confirmation-block tertiary-light">\n\t\t\t\t\t<input checkbox id="hasConfirmedDeclaration" label-text="\'Confirm declaration\'" name="hasConfirmedDeclaration" ng-model="$ctrl.hasConfirmedDeclaration" type="checkbox">\n\t\t\t\t\t<p class="p is-small greyscale-100">\n\t\t\t\t\t\tI confirm that details of expenses payments and benefits that must be returned on forms P11D or taxed through payroll have been sent to HMRC.\n\t\t\t\t\t\tI declare that all the details on this form are fully and truly stated to the best of my knowledge and belief.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-actions">\n\t\t\t<button class="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step4)" type="button">\n\t\t\t\tBack\n\t\t\t</button>\n\n\t\t\t<button class="secondary-action" ng-click="$ctrl.openDeleteConfirmationView()" type="button">\n\t\t\t\tDelete\n\t\t\t</button>\n\n\t\t\t<button class="primary-action is-tertiary" ng-click="$ctrl.submitP11db()" ng-disabled="!$ctrl.hasConfirmedDeclaration" type="button">\n\t\t\t\tSubmit\n\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Submitting -->\n\t<section class="form-summary fadeIn" ng-if="$ctrl.formState === $ctrl.FORM_STATES.submitting">\n\t\t<loading-block size="m" position="after">\n\t\t\t<lb-description><h4>Submitting</h4></lb-description>\n\t\t</loading-block>\n\n\t\t<section class="form-summary-section align-center">\n\t\t\t<p class="is-small">\n\t\t\t\tYour data is being submitted to HMRC and this should only take a few moments.\n\t\t\t\tPlease don\'t click back or close your browser window.\n\t\t\t</p>\n\t\t</section>\n\t</section>\n\n\t<!-- Submitted -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.submitted">\n\t\t<form-state class="fadeIn" fs-icon="tick" fs-show-close="false" fs-title="Successfully submitted">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour P11D(b) for the {{$ctrl.p11dSubmission.TaxYearDisplay}} tax year has been successfully submitted to HMRC and your report is available for download.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<report-card-clickable action="$ctrl.openReportPreview" icon="icon-download" subtitle="Created at {{$ctrl.p11dSubmission.P11DbSubmissionCreatedDateISO  | dateformat:\'timeDate\'}}" title="P11D(b) Report">\n\t\t\t\t\t</report-card-clickable>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-strong">\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.onClose()" class="link-with-icon">\n\t\t\t\t\t\t\tOk, close this window\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</fs-main>\n\t</form-state></div>\n\n\t<!-- Submission Failed -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.failed">\n\t\t<form-state class="fadeIn" fs-show-close="false" fs-icon="warning" fs-theme="tertiary" fs-title="There seems to be a problem with your submission">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour data could not be submitted to HMRC for the below reasons. Review and fix any errors\n\t\t\t\t\t\tbefore trying again. Alternatively, you may wish to delete this one and start again with a new\n\t\t\t\t\t\tsubmission.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<submission-logs agency-profile-id="$ctrl.p11dSubmission.AgencyProfileID" pay-period-id="$ctrl.p11dSubmission.AgencyPayPeriodID" p11db-submission-id="$ctrl.p11dSubmission.P11DbSubmissionID" submission-log-type="$ctrl.submissionLogType">\n\t\t\t\t\t\t<submission-logs-dismissed-copy>\n\t\t\t\t\t\t\tClick \'Back\' to review your submission data or click \'Finish later\' to review your data later.\n\t\t\t\t\t\t</submission-logs-dismissed-copy>\n\t\t\t\t\t</submission-logs>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="secondary-action" ng-click="$ctrl.setFormState($ctrl.FORM_STATES.step5)" type="button">\n\t\t\t\t\tBack\n\t\t\t\t</button>\n\t\t\t\t<button class="secondary-action" ng-click="$ctrl.openDeleteConfirmationView()" type="button">\n\t\t\t\t\tDelete\n\t\t\t\t</button>\n\t\t\t\t<button class="primary-action tertiary" ng-click="$ctrl.onClose()" type="button">\n\t\t\t\t\tFinish later\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Validation Warnings-->\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-title="{{$ctrl.getErrorTitle()}}" ng-if="$ctrl.formState === $ctrl.FORM_STATES.validationWarning">\n\t\t<fs-main ng-init="taxYear = $ctrl.getSelectedTaxYear()" ng-switch="$ctrl.validationWarning">\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.existingDraftSubmission">\n\t\t\t\tThere\'s already a draft submission saved. Either continue with that one or delete it and start a new submission.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.missingAccountsOfficeReference">\n\t\t\t\tThe Accounts Office reference number is missing from your company settings. You need to\n\t\t\t\t<a href="" ng-click="$ctrl.openPayrollSettingsForm()" class="underline">update your references</a> before trying again.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.missingTaxOfficeReference">\n\t\t\t\tThe Tax Office reference number is missing from your company settings. You need to\n\t\t\t\t<a href="" ng-click="$ctrl.openPayrollSettingsForm()" class="underline">update your references</a> before trying again.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.noTaxYearsAvailable">\n\t\t\t\tPlease note that there are no tax years available to choose from for {{$ctrl.formOptions.company.Name}}. This may be because you haven\'t submitted the final period for a tax year or all available tax years have already been submitted.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.outsideSubmissionWindowForTaxYear">\n\t\t\t\tPlease note that the window to submit your P11D(b) data for the {{taxYear.TaxYearDisplay}} tax year is between 6th April and 5th April of the following tax year.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.p11DbAlreadyExistsForTaxYear ">\n\t\t\t\tPlease note that a submission has already been made for the {{taxYear.TaxYearDisplay}} tax year. If these figures were intended to be included in that submission, then you may need to send any corrections via a paper P11D(b) now.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.payrollModuleDisabled">\n\t\t\t\tPlease note that the payroll module is turned off in your company settings and your P11D(b) can\'t be submitted to HMRC. <a href="" ng-click="$ctrl.openCompanyModulesForm()" class="underline">Click here</a> to turn on the payroll module in your modules area.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.rtiSubmissionsDisabled">\n\t\t\t\tPlease note that RTI submissions are turned off in your company settings so your P11D(b) data can\'t be submitted to HMRC. <a href="" ng-click="$ctrl.openPayrollSettingsForm()" class="underline">Click here</a> to turn on RTI submissions in your payroll settings.\n\t\t\t</p>\n\t\t\t<p class="is-font-greyscale-300 is-small" pc-switch-when="$ctrl.VALIDATION_WARNINGS.submissionInProgress">\n\t\t\t\tA submission is currently in progress for this company. Please try again later.\n\t\t\t</p>\n\n\t\t\t<br>\n\n\t\t\t<footer class="form-state-footer">\n\t\t\t\t<p class="s strong">\n\t\t\t\t\t<a class="strong" href="" ng-click="$ctrl.onClose()">\n\t\t\t\t\t\tOk, close this window\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t</footer>\n\t\t</fs-main>\n\t</form-state>\n</form>\n\n<!-- Confirm Delete -->\n<form class="fadeIn" name="companySettingsP11dbSubmissionDeleteForm" ng-if="$ctrl.formState === $ctrl.FORM_STATES.confirmDelete || $ctrl.formState === $ctrl.FORM_STATES.deleted" ng-submit="$ctrl.deleteSubmission($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to delete this submission?" ng-if="$ctrl.formState === $ctrl.FORM_STATES.confirmDelete">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour submission for the tax year {{::$ctrl.p11dSubmission.TaxYearDisplay}} will be removed from your submissions page and you will need to start again. Click \'Confirm\' if you are happy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.cancelDelete()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button display-text="\'Confirm\'" ng-if="$ctrl.p11dSubmission.CanDelete"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Submission deleted" fs-show-close="true" ng-if="$ctrl.formState === $ctrl.FORM_STATES.deleted">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYour submission for tax year {{::$ctrl.p11dbSubmission.TaxYearDisplay}} has been removed.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n</form>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error" secondary-action="$ctrl.onClose()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/p32-payment/companySettingsP32PaymentForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="vm.companySettingsP32PaymentForm" ng-submit="updateCompanyP32Management(vm, vm.companySettingsP32PaymentForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-field">\n\t\t<note note-title="Pay HMRC using BACS" note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-dismiss-key="p32-payment-form">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">If you wish to set up automatic payments to HMRC, you can turn on BACS file creation in your payroll settings.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- HMRC payment account -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="textField" class="required">Which account do you make payment to?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="extended-checkbox_wrapper">\n\t\t\t\t\t<extended-radio name="hmrcAccount" value="hmrcAccount.id" ng-model="vm.company.HMRCPaymentAccount" ng-repeat="hmrcAccount in HMRC_PAYMENT_ACCOUNTS">\n\t\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{hmrcAccount.displayShort}}</h6>\n\t\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t\t<div class="stat-list primary plain-text">\n\t\t\t\t\t\t\t\t<p class="stat-list__header is-small">\n\t\t\t\t\t\t\t\t\tPayments to HMRC go to the following bank account:\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t\t<span class="stat-list__key">Account name:</span> <span class="stat-list__value">{{hmrcAccount.accountName}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t\t<span class="stat-list__key">Sort code:</span> <span class="stat-list__value">{{hmrcAccount.sortCode}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t\t\t<span class="stat-list__key">Account number:</span> <span class="stat-list__value">{{hmrcAccount.accountNumber}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</radio-content>\n\t\t\t\t\t</extended-radio>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<settings-row sr-field-name="isAutomatedEmailsEnabled" sr-icon="email" ng-model="vm.company.IsAutomatedEmailsEnabled">\n\t\t\t\t<sr-label>Auto email instruction</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-if="vm.company.IsAutomatedEmailsEnabled">Turning this off means you won\'t receive an automated email before your payment is due to HMRC.</span>\n\t\t\t\t\t<span ng-if="!vm.company.IsAutomatedEmailsEnabled">Turning this on means you\'ll receive an automated email before your payment is due to HMRC.</span>\n\t\t\t\t\t<br>\n\t\t\t\t\t<a class="link-with-icon" ui-sref="email-preview({agencyProfileId: formOptions.company.AgencyProfileID, mailtypeid: vm.company.MailTypeID, previewType: EMAIL_PREVIEW_TYPES.notificationSettingsPreview})"><i class="icon-external-link"></i> Preview email</a>\n\t\t\t</sr-description>\n\t\t\t\t<sr-content ng-if="vm.company.IsAutomatedEmailsEnabled">\n\n\t\t\t\t\t<!-- HMRC automated email frequency -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="automatedEmailFrequency" class="required">How frequently do you pay HMRC?</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="radio-list is-inline">\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input type="radio" name="automatedEmailFrequency" id="automatedEmailFrequency-monthly" class="b" ng-value="P32_EMAIL_FREQUENCIES.monthly" ng-change="onEmailFrequencyChange(vm)" ng-model="vm.company.AutomatedEmailFrequency">\n\t\t\t\t\t\t\t\t\t<label for="automatedEmailFrequency-monthly">Monthly</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input type="radio" name="automatedEmailFrequency" id="automatedEmailFrequency-quarterly" class="b" ng-value="P32_EMAIL_FREQUENCIES.quarterly" ng-change="onEmailFrequencyChange(vm)" ng-model="vm.company.AutomatedEmailFrequency">\n\t\t\t\t\t\t\t\t\t<label for="automatedEmailFrequency-quarterly">Quarterly</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t<input type="radio" name="automatedEmailFrequency" id="automatedEmailFrequency-annually" class="b" ng-value="P32_EMAIL_FREQUENCIES.annually" ng-change="onEmailFrequencyChange(vm)" ng-model="vm.company.AutomatedEmailFrequency">\n\t\t\t\t\t\t\t\t\t<label for="automatedEmailFrequency-annually">Annually</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- HMRC automated email send dates -->\n\t\t\t\t\t<fieldset ng-switch="vm.company.AutomatedEmailFrequency">\n\n\t\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t\t<p class="is-small">Payment to HMRC is due on the {{vm.payPeriod.HMRCPaymentDateISO | dateformat:\'ordinal\'}} of the month. Each instruction email will contain amounts due to HMRC on the {{vm.payPeriod.HMRCPaymentDateISO | dateformat:\'ordinal\'}} after the send date of the email.</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Monthly -->\n\t\t\t\t\t\t<div pc-switch-when="P32_EMAIL_FREQUENCIES.monthly" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label for="automatedEmailDayOfMonth" class="required">Date to send email:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<select name="automatedEmailDayOfMonth" id="automatedEmailDayOfMonth" class="xl" ng-model="vm.company.AutomatedEmailDayOfMonth" ng-options="option.id as option.name for option in vm.automatedEmailDayOfMonthOptions | orderBy: [\'order\', \'id\']" required>\n\t\t\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Select a date\u2026</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.automatedEmailDayOfMonth.$error" ng-if="vm.companySettingsP32PaymentForm.automatedEmailDayOfMonth.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select date to send the email</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Quarterly -->\n\t\t\t\t\t\t<div pc-switch-when="P32_EMAIL_FREQUENCIES.quarterly" class="fadeIn">\n\n\t\t\t\t\t\t\t<div class="form-intro">\n\t\t\t\t\t\t\t\t<p>Add the four dates on which you\u2019d like your instruction email to be sent. Each date should be later than the previous.</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t<!-- Send date 1 -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="sendDate1ISO">Send date 1:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="sendDate1ISO" field-min-date-iso="vm.payPeriod.sendDate1MinIso" field-on-change="updateSendDateValidation" field-value-iso="vm.company.AutomatedEmailQ1SendDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.sendDate1ISO.$error" ng-if="vm.companySettingsP32PaymentForm.sendDate1ISO.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the first email send date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.payPeriod.sendDate1MinIso | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Send date 2 -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header" for="sendDate2ISO">\n\t\t\t\t\t\t\t\t\t\t<label class="required">Send date 2:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="sendDate2ISO" field-max-date-iso="vm.sendDateValidation.date2.maxIso" field-min-date-iso="vm.sendDateValidation.date2.minIso" field-value-iso="vm.company.AutomatedEmailQ2SendDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.sendDate2ISO.$error" ng-if="vm.companySettingsP32PaymentForm.sendDate2ISO.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the second email send date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{vm.sendDateValidation.date2.minIso | dateformat}} and {{vm.sendDateValidation.date2.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t\t<!-- Send date 3 -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="sendDate3ISO">Send date 3:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="sendDate3ISO" field-max-date-iso="vm.sendDateValidation.date3.maxIso" field-min-date-iso="vm.sendDateValidation.date3.minIso" field-value-iso="vm.company.AutomatedEmailQ3SendDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.sendDate3ISO.$error" ng-if="vm.companySettingsP32PaymentForm.sendDate3ISO.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the third email send date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{vm.sendDateValidation.date3.minIso | dateformat}} and {{vm.sendDateValidation.date3.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Send date 4 -->\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="sendDate4ISO">Send date 4:</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<date-input-field field-id="sendDate4ISO" field-max-date-iso="vm.sendDateValidation.date4.maxIso" field-min-date-iso="vm.sendDateValidation.date4.minIso" field-value-iso="vm.company.AutomatedEmailQ4SendDateISO">\n\t\t\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.sendDate4ISO.$error" ng-if="vm.companySettingsP32PaymentForm.sendDate4ISO.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the forth email send date</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min || max">Please enter a date between {{vm.sendDateValidation.date4.minIso | dateformat}} and {{vm.sendDateValidation.date4.maxIso | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Annually -->\n\t\t\t\t\t\t<div pc-switch-when="P32_EMAIL_FREQUENCIES.annually" class="form-field fadeIn">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="automatedEmailAnnualSendDateIso">Date to send email:</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t<date-input-field field-id="automatedEmailAnnualSendDateIso" field-min-date-iso="vm.payPeriod.sendDate1MinIso" field-on-change="validateAnnualSendDate" field-value-iso="vm.company.AutomatedEmailAnnualSendDateISO">\n\t\t\t\t\t\t\t\t</date-input-field>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="vm.companySettingsP32PaymentForm.automatedEmailAnnualSendDateIso.$error" ng-if="vm.companySettingsP32PaymentForm.automatedEmailAnnualSendDateIso.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the start email send date</p>\n\t\t\t\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t\t\t<p ng-message="dayOfMonth">Please enter a date on or before the {{vm.annualSendDateMaxDisplay | dateformat:\'ordinal\'}} day of any month</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a date on or after {{vm.payPeriod.sendDate1MinIso | dateformat}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class="form-message fadeIn">This date must be from {{vm.payPeriod.sendDate1MinIso | dateformat}} to {{vm.payPeriod.annualSendDateMaxIso | dateformat:\'ordinal\'}} day of any month</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<!-- Personal data agreement -->\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<input type="checkbox" id="personalDataAgreement" name="personalDataAgreement" ng-model="vm.personalDataAgreement" label-text="\'I understand that the email sent includes company sensitive data\'" checkbox required>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<a class="link-with-icon" href="" ng-click="openAddressBookModal(vm)"><i class="icon-external-link"></i> View and manage recipients</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="vm.companySettingsP32PaymentForm.state" disable-button="!vm.companySettingsP32PaymentForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/p60-notifications/company-settings-p60-notifications.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsP60NotificationsForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.onFormSubmit(companySettingsP60NotificationsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<note ng-if="$ctrl.formOptions.company.CompanyType === $ctrl.INTERFACE_TYPES.bureau" note-dismiss-key="company-settings-p60-notifications" note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Saving P60 schedules in bureau settings">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">Please note that when you save the below P60 notification schedule it will be applied to all companies in your bureau but can be overridden at company level in their respective settings area.</p>\n\t\t\t</note-content>\n\t\t</note>\n\n\n\t\t<p class="is-small">\n\t\t\tP60s are always generated when the final payroll of the tax year is run but you can schedule when you wish to send notifications to team members and make them available in their Pay Portal.\n\t\t</p>\n\t</div>\n\n\t<!-- Scheduled -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Scheduled</h5>\n\t\t</div>\n\n\t\t<div class="p60-notification_wrapper" ng-if="$ctrl.scheduledNotifications.length > 0">\n\n\t\t\t<div class="p60-notification" ng-repeat="notification in $ctrl.scheduledNotifications">\n\n\t\t\t\t<!-- Edit mode -->\n\t\t\t\t<div class="p60-notification_card fadeIn is-in-edit-mode" ng-if="notification.isInEditMode">\n\n\t\t\t\t\t<div class="p60-notification_header">\n\t\t\t\t\t\t<h5 class="p60-notification_heading">\n\t\t\t\t\t\t\t{{::notification.isExistingNotification ? \'Edit\' : \'Add\'}} notification schedule\n\t\t\t\t\t\t</h5>\n\n\t\t\t\t\t\t<button class="p60-notification_action is-clear" ng-click="$ctrl.onNotificationCancel(notification, $index)" type="button">\n\t\t\t\t\t\t\t<i class="icon-cross"></i>&nbsp;&nbsp;Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<fieldset class="p60-notification_contents">\n\n\t\t\t\t\t\t<!-- Tax Year -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" ng-class="::{\n\t\t\t\t\t\t\t\t\t\t\'disabled\' : notification.taxYear.HasScheduledP60Notification\n\t\t\t\t\t\t\t\t\t}" for="taxYear-{{$index}}">\n\t\t\t\t\t\t\t\t\tSelect a tax year:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t<!-- Existing notification -->\n\t\t\t\t\t\t\t\t<input class="block" disabled="disabled" id="taxYear-{{$index}}" name="taxYear-{{$index}}" ng-if="::notification.taxYear.HasScheduledP60Notification" ng-model="notification.taxYear.TaxYearDisplayName" type="text">\n\n\t\t\t\t\t\t\t\t<!-- New notification -->\n\t\t\t\t\t\t\t\t<select class="block" id="taxYear-{{$index}}" name="taxYear-{{$index}}" ng-if="!notification.taxYear.HasScheduledP60Notification" ng-model="notification.taxYear" ng-options="taxYear as taxYear.TaxYearDisplayName for taxYear in\n\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.unscheduledTaxYears |\n\t\t\t\t\t\t\t\t\t\t\t\t\tcompanySettingsP60RemoveUsedTaxYears :\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.scheduledNotifications :\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tnotification.taxYear.TaxYear" required>\n\t\t\t\t\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\t\t\t\t\tPlease select a tax year...\n\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t</select>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsP60NotificationsForm[\'taxYear-\' + $index].$touched" ng-messages="companySettingsP60NotificationsForm[\'taxYear-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please select a tax year</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<fieldset class="fadeIn" ng-if="notification.taxYear">\n\n\t\t\t\t\t\t\t<!-- Frequency type -->\n\t\t\t\t\t \t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\tWhen would you like to let employees know their P60 is available?\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\n\t\t\t\t\t\t\t\t\t\t<!-- On final pay run -->\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card" ng-if="\n\t\t\t\t\t\t\t\t\t\t\t\t(notification.taxYear.HasScheduledP60Notification && !notification.taxYear.ScheduledP60Notification.CanManuallySendNow) ||\n\t\t\t\t\t\t\t\t\t\t\t\t!notification.taxYear.HasScheduledP60Notification\n\t\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="notificationType-{{$index}}-on-final-payroll-run" name="notificationType-{{$index}}" ng-model="notification.notificationType" ng-value="$ctrl.NOTIFICATION_TYPES.onFinalPayRun" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="notificationType-{{$index}}-on-final-payroll-run">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">When final payroll is run</span>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Right away -->\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card" ng-if="notification.taxYear.HasScheduledP60Notification && notification.taxYear.ScheduledP60Notification.CanManuallySendNow">\n\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="notificationType-{{$index}}-right-away" name="notificationType-{{$index}}" ng-model="notification.notificationType" ng-value="$ctrl.NOTIFICATION_TYPES.rightAway" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="notificationType-{{$index}}-right-away">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Right away</span>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<!-- Custom -->\n\t\t\t\t\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t\t\t\t\t<input class="b radio-card-input" id="notificationType-{{$index}}-custom" name="notificationType-{{$index}}" ng-model="notification.notificationType" ng-value="$ctrl.NOTIFICATION_TYPES.custom" type="radio">\n\t\t\t\t\t\t\t\t\t\t\t<label class="radio-card-label" for="notificationType-{{$index}}-custom">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Choose a day</span>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t \t\t</div>\n\n\t\t\t\t\t \t\t<fieldset class="fadeIn" ng-if="notification.notificationType === $ctrl.NOTIFICATION_TYPES.rightAway">\n\t\t\t\t\t \t\t\t<p class="is-small is-primary-light italic">\n\t\t\t\t\t \t\t\t\tNotifications will be sent to team members when you click \u2018Save\u2019.\n\t\t\t\t\t \t\t\t</p>\n\t\t\t\t\t \t\t</fieldset>\n\n\t\t\t\t\t \t\t<!-- Custom Date -->\n\t\t\t\t\t \t\t<fieldset class="fadeIn" ng-if="notification.notificationType === $ctrl.NOTIFICATION_TYPES.custom">\n\n\t\t\t\t\t \t\t\t<div class="form-intro">\n\t\t\t\t\t \t\t\t\t<p>Please note if you run payroll later than the date entered, P60 notifications will be automatically sent at the same time.</p>\n\t\t\t\t\t \t\t\t</div>\n\n\t\t\t\t\t\t \t\t<div class="form-field fadeIn" ng-if="notification.notificationType === $ctrl.NOTIFICATION_TYPES.custom">\n\t\t\t\t\t\t \t\t\t<div class="form-field-header">\n\t\t\t\t\t\t \t\t\t\t<label class="required" for="notificationDateIso-{{$index}}">\n\t\t\t\t\t\t \t\t\t\t\tChoose a date:\n\t\t\t\t\t\t \t\t\t\t</label>\n\t\t\t\t\t\t \t\t\t</div>\n\t\t\t\t\t\t \t\t\t<div class="form-field-main">\n\t\t\t\t\t\t \t\t\t\t<date-input-field field-id="notificationDateIso-{{$index}}" field-max-date-iso="notification.taxYear.LatestValidNotificationDateISO" field-min-date-iso="notification.taxYear.EarliestValidNotificationDateISO" field-required="true" field-style="l" field-value-iso="notification.notificationDateIso"></date-input-field>\n\t\t\t\t\t\t \t\t\t</div>\n\t\t\t\t\t\t \t\t\t<div class="form-errors fadeIn" ng-if="companySettingsP60NotificationsForm[\'notificationDateIso-\' + $index].$touched" ng-messages="companySettingsP60NotificationsForm[\'notificationDateIso-\' + $index].$error" role="alert">\n\t\t\t\t\t\t \t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t\t \t\t\t\t<p ng-message="max">Please enter a date on or before {{notification.taxYear.LatestValidNotificationDateISO | dateformat}}</p>\n\t\t\t\t\t\t \t\t\t\t<p ng-message="min">Please enter a date on or after {{notification.taxYear.EarliestValidNotificationDateISO | dateformat}}</p>\n\t\t\t\t\t\t \t\t\t\t<p ng-message="required">Please enter a date</p>\n\t\t\t\t\t\t \t\t\t</div>\n\n\t\t\t\t\t\t \t\t\t<p class="form-message primary">\n\t\t\t\t\t\t \t\t\t\tMust be on or before {{ notification.taxYear.LatestValidNotificationDateISO | dateformat }}.\n\t\t\t\t\t\t \t\t\t</p>\n\t\t\t\t\t\t \t\t</div>\n\t\t\t\t\t \t\t</fieldset>\n\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t</fieldset>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Display Mode -->\n\t\t\t\t<div class="p60-notification_card" ng-if="!notification.isInEditMode && !notification.isDeleted">\n\t\t\t\t\t<div class="p60-notification_header">\n\t\t\t\t\t\t<div class="p60-notification_icon">\n\t\t\t\t\t\t\t<i class="icon-calendar is-primary m"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<h6 class="p60-notification_heading">\n\t\t\t\t\t\t\t{{::notification.taxYear.TaxYearDisplayName}}\n\n\t\t\t\t\t\t\t<!-- Bureau Override -->\n\t\t\t\t\t\t\t<span class="tag is-tertiary highlight-on-hover" ng-if="!$ctrl.hideOverriddenNotificationElements(notification.isBureauInherited)" tooltip tooltip-text="Tax year saved in bureau settings, click \'Override\' to change for this company only">\n\t\t\t\t\t\t\t\tBUREAU\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<!-- P60s Created -->\n\t\t\t\t\t\t\t<span class="tag is-primary align-with-text" ng-if="::notification.taxYear.ScheduledP60Notification.P60sCreated">\n\t\t\t\t\t\t\t\tP60S Created\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<!-- P60s Sending -->\n\t\t\t\t\t\t\t<span class="tag is-tertiary align-with-text" ng-if="::notification.taxYear.ScheduledP60Notification.P60sSending">\n\t\t\t\t\t\t\t\tPending\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</h6>\n\n\t\t\t\t\t\t<div ng-if="$ctrl.hideOverriddenNotificationElements(notification.isBureauInherited)">\n\t\t\t\t\t\t\t<!-- Edit -->\n\t\t\t\t\t\t\t<button class="p60-notification_action is-clear is-primary" ng-click="$ctrl.onNotificationEdit(notification)" ng-if="notification.taxYear.ScheduledP60Notification.CanEdit" type="button">\n\t\t\t\t\t\t\t\t<i class="icon-edit"></i>&nbsp;&nbsp;Edit\n\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t<!-- Delete -->\n\t\t\t\t\t\t\t<button class="p60-notification_action is-clear" ng-click="$ctrl.onNotificationDelete(notification, $index)" ng-if="notification.taxYear.ScheduledP60Notification.CanDelete" type="button">\n\t\t\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Override -->\n\t\t\t\t\t\t<button class="p60-notification_action is-clear" ng-click="$ctrl.onNotificationOverride(notification)" ng-if="!$ctrl.hideOverriddenNotificationElements(notification.isBureauInherited)" type="button">\n\t\t\t\t\t\t\t<i class="icon-edit"></i>&nbsp;&nbsp;Override\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="p60-notification_contents">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tScheduled to send: {{::notification.taxYear.ScheduledP60Notification.NotificationDateDisplay}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="p60-notification_card is-deleted" ng-if="notification.isDeleted">\n\t\t\t\t\t<div class="p60-notification_header">\n\t\t\t\t\t\t<div class="p60-notification_icon">\n\t\t\t\t\t\t\t<i class="icon-trash is-assertive m"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<h6 class="p60-notification_heading">\n\t\t\t\t\t\t\t{{::notification.taxYear.TaxYearDisplayName}}\n\t\t\t\t\t\t</h6>\n\n\t\t\t\t\t\t<button class="p60-notification_action is-clear" ng-click="$ctrl.onNotificationCancelDelete(notification)" type="button">\n\t\t\t\t\t\t\t<i class="icon-cross"></i>&nbsp;&nbsp;Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="p60-notification_contents">\n\t\t\t\t\t\t<p class="is-small is-assertive-darkened">\n\t\t\t\t\t\t\tWill be deleted when you click \'Save\'\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.scheduledNotifications.length !== $ctrl.p60NotificationSettings.TaxYearSchedule.length">\n\t\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.onScheduleP60Notifications()" type="button">\n\t\t\t\t<i class="icon-add m button_icon-pre"></i>Schedule P60 notifications\n\t\t\t</button>\n\t\t</div>\n\n\t\t<div class="spacer m"></div>\n\n\t\t<div class="form-field-highlight indifferent fadeIn" ng-if="$ctrl.showDeleteOption()">\n\t\t\t<p class="is-small greyscale-100">\n\t\t\t\tIf any companies already have P60 notification settings configured for the above tax years,\n\t\t\t\tand you wish to overwrite them with these settings, please check the box below before clicking \'Save\'.\n\t\t\t</p>\n\n\t\t\t<div class="spacer m"></div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input checkbox id="doOverride" label-text="\'Delete existing company overrides\'" name="doOverride" ng-model="$ctrl.overwriteChildCompaniesSettings" type="checkbox">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Sent -->\n\t<fieldset class="form-fieldset-divider-top smaller-gap" ng-if="$ctrl.sentNotifications.length > 0">\n\n\t\t<div class="form-intro">\n\t\t\t<h5>Sent</h5>\n\t\t</div>\n\n\t\t<div class="p60-notification_wrapper">\n\n\t\t\t<div class="p60-notification" ng-repeat="notification in $ctrl.sentNotifications">\n\t\t\t\t<div class="p60-notification_card is-sent">\n\t\t\t\t\t<div class="p60-notification_header">\n\t\t\t\t\t\t<div class="p60-notification_icon">\n\t\t\t\t\t\t\t<i class="icon-tick is-secondary m"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<h6 class="p60-notification_heading">\n\t\t\t\t\t\t\t{{::notification.taxYear.TaxYearDisplayName}}\n\t\t\t\t\t\t</h6>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="p60-notification_contents">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tSent on: {{::notification.taxYear.ScheduledP60Notification.P60sSentDateDisplay}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" data-cy="p60-notifications-cancel" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button disable-button="companySettingsP60NotificationsForm.$invalid || !$ctrl.hasFormChanged" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsP60NotificationsForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="secondary" fs-title="P60 notification settings saved" ng-if="$ctrl.formState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tP60 notifications have been scheduled to be sent on the dates you\u2019ve entered. You can adjust these any time before they\u2019re due to be sent.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/paydashboard/companySettingsPayDashboardForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsPayDashboardForm" ng-submit="updateAgencyProfileIsPayDashboardEnabled(companySettingsPayDashboardForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<settings-row sr-field-name="isPayDashboardEnabled" sr-icon="billing" ng-model="agencyProfileCompanyInformation.IsPayDashboardEnabled">\n\t\t\t\t\t<sr-label>PayDashboard file creation</sr-label>\n\t\t\t\t\t<sr-description ng-if="!agencyProfileCompanyInformation.IsPayDashboardEnabled">Turning this on means that a PayDashboard XML file will be created each time you approve payroll. You can then upload it to your PayDashboard account.</sr-description>\n\t\t\t\t\t<sr-description ng-if="agencyProfileCompanyInformation.IsPayDashboardEnabled">Turning this off means that a PayDashboard XML file won\'t be created each time you approve payroll.</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="form-field" ng-if="agencyProfileCompanyInformation.IsPayDashboardEnabled">\n\t\t\t<note note-title="Emails to team members will be disabled" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Turning on PayDashboard file creation means that pay day emails, and all other system notifications, to team members will be disabled\n\t\t\t\t\t\tand they won\'t be able to access their user portal. If you wish to turn PayDashboard file creation off later, these emails will be re-enabled.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<!-- Cancel -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsPayDashboardForm.state" disable-button="!companySettingsPayDashboardForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/payroll-settings/company-settings-backdated-salary-elements.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsBackdatedSalaryElementsForm" ng-if="pageState === \'ready\'" ng-submit="saveForm(vm, companySettingsBackdatedSalaryElementsForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h4>Backdated salary derived elements</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tControl whether back pay is automatically generated for salary derived elements when a salary change is backdated.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="field">\n\t\t\t\t\t<settings-row ng-model="vm.company.BackdatedSalaryDerivedElementsEnabled" sr-field-name="BackdatedSalaryDerivedElementsEnabled" sr-icon="money" sr-theme="quarternary">\n\t\t\t\t\t\t<sr-label>Backdate salary derived elements</sr-label>\n\t\t\t\t\t\t<sr-description ng-if="vm.company.BackdatedSalaryDerivedElementsEnabled">\n\t\t\t\t\t\t\tWhen on, backdating a salary change will also backdate all salary derived pay elements in the period as well as the gross salary for the employee.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t\t<sr-description ng-if="!vm.company.BackdatedSalaryDerivedElementsEnabled">\n\t\t\t\t\t\t\tWhen off, backdating a salary change will only affect the gross salary. Salary derived pay elements will not be backdated.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!companySettingsBackdatedSalaryElementsForm.$valid" display-text="formOptions.primaryButtonText" state="companySettingsBackdatedSalaryElementsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/payroll-settings/company-settings-payroll-auto.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsPayrollAutoForm" ng-if="pageState === \'ready\'" ng-submit="saveForm(vm, companySettingsPayrollAutoForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h4>Automated payroll options</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tSet your payroll to Auto run and your payroll reports to Auto send and let Paycircle process your payroll automatically and send you password protected reports every pay period.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="field">\n\t\t\t\t\t<settings-row ng-model="vm.isAutoRun" sr-disabled="::!formOptions.company.CanUpdateAutoRun" sr-field-name="isAutoRun" sr-icon="clock" sr-theme="quarternary">\n\t\t\t\t\t\t<sr-label>Auto run payroll</sr-label>\n\t\t\t\t\t\t<sr-description ng-if="vm.isAutoRun">\n\t\t\t\t\t\t\tTurning off &lsquo;Auto run&rsquo; means you will need to submit your payroll manually each {{vm.currentPayPeriod.PayPeriodType | payPeriodTypeDescription:\'month\'}}.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t\t<sr-description ng-if="!vm.isAutoRun">\n\t\t\t\t\t\t\tTurning on &lsquo;Auto run&rsquo; means your payroll will be submitted on your chosen pay day each {{vm.currentPayPeriod.PayPeriodType | payPeriodTypeDescription:\'month\'}}.\n\t\t\t\t\t\t</sr-description>\n\t\t\t\t\t\t<sr-content ng-if="vm.isAutoRun">\n\n\t\t\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t\t\t<div class="form-intro-split">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="is-large is-quarternary"></icon-dot>\n\t\t\t\t\t\t\t\t\t<h5 class="form-intro-split__content">&nbsp;&nbsp;Auto run warnings</h5>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\t\t\t\t\tYou will receive an auto run warning in your notifications 2 days <span class="strong greyscale-dark">before</span> your payroll processing date if any of the\n\t\t\t\t\t\t\t\t\tfollowing warning alerts occur:\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\'A team member is missing bank details and BACS is enabled\',\n\t\t\t\t\t\t\t\t\t\t\'A team member has negative net pay\',\n\t\t\t\t\t\t\t\t\t\t\'A team member\\\'s tax code has been updated\',\n\t\t\t\t\t\t\t\t\t\t\'Pension re-enrolment is due in the pay period\',\n\t\t\t\t\t\t\t\t\t\t\'A team member is missing pension information\'\n\t\t\t\t\t\t\t\t\t]" bl-theme="is-small is-quarternary greyscale-darkened is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\t\t\t\t\tPlease note that these will just be warnings and payroll will still be auto run.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t\t<fieldset class="form-fieldset-divider-top is-quarternary-lighter">\n\t\t\t\t\t\t\t\t<div class="form-intro-split">\n\t\t\t\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="is-large is-assertive"></icon-dot>\n\t\t\t\t\t\t\t\t\t<h5 class="form-intro-split__content">&nbsp;&nbsp;Auto run failures</h5>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\t\t\t\t\tYou will receive an auto run warning in your notifications <span class="strong greyscale-dark">after</span> your payroll has been run and it fails:\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<div class="spacer l"></div>\n\t\t\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\t\t\'Payroll submission to HMRC has failed\'\n\t\t\t\t\t\t\t\t\t]" bl-theme="is-small is-assertive is-spaced-out"></bullet-list>\n\t\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t\t</sr-content>\n\t\t\t\t\t</settings-row>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field" ng-if="!formOptions.company.CanEnableAutoRun">\n\t\t\t\t<div class="note indifferent">\n\t\t\t\t\t<h6 class="strong">\n\t\t\t\t\t\t<i class="icon-support indifferent m"></i>&nbsp;&nbsp;Trying to turn on Auto run payroll?\n\t\t\t\t\t</h6>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour current pay period is {{vm.currentPayPeriod.PayPeriodDisplay}} and is {{vm.currentPayPeriod.ProcessDayDaysOverdue}} days overdue. You can\'t turn on Auto run until your\n\t\t\t\t\t\tpayroll is up to date. If you\'re having problems doing this, please contact our support team\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<fieldset class="form-fieldset-divider-top">\n\t\t\t<div class="form-field">\n\t\t\t\t<settings-row ng-model="vm.autoSendPayrollEmailsEnabled" on-update="onSendPayrollEmailsChange(vm)" sr-field-name="vm.autoSendPayrollEmailsEnabled" sr-icon="email">\n\t\t\t\t\t<sr-label>Auto send payroll reports</sr-label>\n\t\t\t\t\t<sr-description ng-if="vm.autoSendPayrollEmailsEnabled">\n\t\t\t\t\t\tTurning off &lsquo;Auto send&rsquo; means that payroll reports will not be emailed to all payroll admins each time payroll is approved.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-description ng-if="!vm.autoSendPayrollEmailsEnabled">\n\t\t\t\t\t\tTurning on &lsquo;Auto send&rsquo; means your payroll reports will be automatically emailed to all payroll admins each time payroll is approved.\n\t\t\t\t\t</sr-description>\n\t\t\t\t\t<sr-content ng-if="vm.autoSendPayrollEmailsEnabled">\n\n\t\t\t\t\t\t<!-- Reports to include -->\n\t\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label>Reports to include in the email:</label>\n\t\t\t\t\t\t\t\t\t<p class="is-small">Please note that payslips will be sent in a single PDF document</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\n\t\t\t\t\t\t\t\t\t<report-downloads agency-profile-id="formOptions.agencyProfileId" report-collection="vm.reportCollection"></report-downloads>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<!-- Password Protect -->\n\t\t\t\t\t\t<fieldset class="form-fieldset-divider-top is-primary-lighter smaller-padding">\n\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<toggle-input field-label="Password protect the reports" field-model="vm.passwordProtectionEnabled" field-name="passwordProtectionEnabled" field-theme-active="is-primary" field-theme-light="true"></toggle-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Has PW protection -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="vm.passwordProtectionEnabled">\n\t\t\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="autoreport-password">Choose a password</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="password-toggle">\n\t\t\t\t\t\t\t\t\t\t<input class="xl" id="autoreport-password" ng-model="vm.reportCollection.ReportTemplateCollectionPassword" required type="{{vm.showPassword ? \'text\' : \'password\'}}">\n\t\t\t\t\t\t\t\t\t\t<a class="password-toggle-action" href ng-click="togglePasswordVisibility(vm)">\n\t\t\t\t\t\t\t\t\t\t\t<i class="icon-{{vm.showPassword ? \'hide\' : \'visible\'}} m"></i>&nbsp;&nbsp;{{vm.showPassword ? \'Hide\' : \'Show\'}}\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\t\t\t\t<strong>Important:</strong>&nbsp;for security reasons, the password will not be sent with the reports. Share it with payroll admins by another means of your choosing.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- No PW protection -->\n\t\t\t\t\t\t\t<div class="form-field fadeIn" ng-if="!vm.passwordProtectionEnabled">\n\t\t\t\t\t\t\t\t<div class="confirmation-block clear s">\n\t\t\t\t\t\t\t\t\t<input checkbox class="is-small" id="confirmInformation" label-text="\'I understand that I am sending sensitive and/or personal data by email and give Paycircle permission to send files without password protection.\'" name="confirmInformation" ng-model="directDebit.IsConfirmed" required type="checkbox">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t\t<email-contacts agency-profile-id="formOptions.company.AgencyProfileID" contact-external-id="CONTACT_EXTERNAL_CATEGORIES.payrollEmailRecipient" form="companySettingsPayrollAutoForm" label="Reports will be automatically sent to" new-contacts="vm.email.contactsExternalNew" old-contacts="vm.email.contactsExternalOld"></email-contacts>\n\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</sr-content>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!companySettingsPayrollAutoForm.$valid || (vm.autoSendPayrollEmailsEnabled && vm.reportCollection.ReportTemplateCollectionEntries.length === 0)" display-text="formOptions.primaryButtonText" state="companySettingsPayrollAutoForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/payroll-settings/company-settings-payroll-settings.form.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="updatePayPeriodsForm" ng-if="pageState === \'ready\' || pageState === \'confirm-skip-tax-period\'" ng-submit="updatePayPeriodsSettings(vm.periodDetails, updatePayPeriodsForm, pageState === \'confirm-skip-tax-period\')" novalidate>\n\t<div ng-if="pageState === \'ready\'">\n\t\t<div class="form-intro">\n\t\t\t<h4>Pay Periods</h4>\n\t\t\t<p>\n\t\t\t\tSet the frequency that the company pays it\u2019s team members and add the key payroll dates.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.payPeriods" underline="true">\n\t\t\t\t\tRead more about pay periods\n\t\t\t\t</support-article-link>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<pay-period-dates agency-profile-id="formOptions.agencyProfileId" form="updatePayPeriodsForm" is-cis-active="formOptions.company.IsCISActive" on-preview="generateTimeline" period-details="vm.periodDetails"></pay-period-dates>\n\n\t\t<!-- Changing pay period -->\n\t\t<note class="fadeIn" ng-if="!$root.currentCompany.IsPayslipManagerActive && vm.periodDetails.showChangeWarning && !vm.periodDetails.hasAgreedTerms" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Changing pay period settings">\n\t\t\t<note-content ng-if="showOnlyReferencePeriodsWarning(vm)">\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tWhere applicable, ensure your Rotaready reference periods are aligned with your new pay period settings\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\n\t\t\t<note-content ng-if="!showOnlyReferencePeriodsWarning(vm)">\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPlease note that if you have previously set up any of the following for {{formOptions.company.Name}}, \n\t\t\t\t\t\tthey will be deleted when you save your new pay periods settings. We recommend making a note of them in case you wish to add them again later:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'Sick pay schedules\',\n\t\t\t\t\t\t\t\'Maternity pay schedules\',\n\t\t\t\t\t\t\t\'Paternity pay schedules\',\n\t\t\t\t\t\t\t\'Repayment schedules (cycle to work, company loan, season ticket loan)\',\n\t\t\t\t\t\t\t\'Benefit in Kind schedules (company vehicle, healthcare)\',\n\t\t\t\t\t\t\t\'Childcare voucher schedules\',\n\t\t\t\t\t\t\t\'Future changes\',\n\t\t\t\t\t\t\t\'Payroll notes and tasks\',\n\t\t\t\t\t\t\t\'Workflow\',\n\t\t\t\t\t\t\t\'Pension period alignment\',\n\t\t\t\t\t\t\t\'PAYE scheme cessation date\'\n\t\t\t\t\t\t]" bl-theme="is-small is-italicised is-indifferent is-spaced-out"></bullet-list>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Show additional warning if pay period dates have changed -->\n\t\t\t\t<div class="note-section" ng-if="vm.periodDetails.havePeriodDatesChanged">\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tIf you have a workplace pension set up, it\u2019s also critical you check that the information in your pension provider\n\t\t\t\t\t\t\tportal is updated to match your new settings. This should ensure that your pension submissions don\'t fail in the future. We recommend you do the following:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'If your pension is connected directly to your provider, first disconnect it in the automation options in your pension settings\',\n\t\t\t\t\t\t\t\t\'Update the pension period dates in your pension settings area\',\n\t\t\t\t\t\t\t\t\'Check your pension pay frequency is set to the same in your pension provider portal\',\n\t\t\t\t\t\t\t\t\'When everything matches between your pension settings here and those in your provider portal, you can reconnect your pension in the automation options in your pension settings\'\n\t\t\t\t\t\t\t]" bl-theme="is-indifferent is-small is-spaced-out"></bullet-list>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="is-small">For more information, read our\n\t\t\t\t\t\t\t<a class="indifferent underline" ng-href="{{$root.URLS.paycircle.support.pensionSubmissionTroubleshooting}}" target="_blank">\n\t\t\t\t\t\t\t\ttroubleshooting guide to pension submissions\n\t\t\t\t\t\t\t</a>.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tWhere applicable, ensure your Rotaready reference periods are aligned with your new pay period settings\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\n\t\t<div class="slide-in-form-alert">\n\t\t\t<note class="slide-in-form-alert_note fadeIn" ng-class="{\n\t\t\t\t\t\'is-visible\': !$root.currentCompany.IsPayslipManagerActive && vm.periodDetails.showChangeWarning\n\t\t\t\t}" note-theme="tertiary is-form-field">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div ng-if="showOnlyReferencePeriodsWarning(vm)">\n\t\t\t\t\t\t<input id="checkboxField" label-text="\'I understand that I may need to review my Rotaready reference periods.\'" label-text-class="is-small" name="checkboxField" ng-model="vm.periodDetails.hasAgreedTerms" type="checkbox" checkbox>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-if="!showOnlyReferencePeriodsWarning(vm)">\n\t\t\t\t\t\t<input id="checkboxField" label-text="\'I understand that saving my new pay period settings will delete certain data and I may need to review the information in my pension provider portal.\'" label-text-class="is-small" name="checkboxField" ng-model="vm.periodDetails.hasAgreedTerms" type="checkbox" checkbox>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</div>\n\n\t<!-- Confirmation Step (shown only after submit if agreedTerms is true) -->\n\t<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary" fs-title="You are about to skip a tax period" ng-if="pageState === \'confirm-skip-tax-period\'">\n\t\t<fs-main>\n\t\t\t<section class="form-state-section">\n\t\t\t\t<note note-theme="tertiary is-form-field">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\tOnce payroll has been run, these dates cannot be changed easily. Submitting a misaligned period can lead to duplicate records, RTI rejections, or incorrect employee tax data with HMRC. If you\'re unsure, please check your last FPS submission or speak to your payroll advisor before proceeding.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</section>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" data-cy="back-pay-periods-settings-button" ng-click="formOptions.back()" ng-if="formOptions.canGoBack" type="button">\n\t\t\tBack\n\t\t</button>\n\t\t<button class="secondary-action" data-cy="cancel-pay-periods-settings-button" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<button class="primary-action tertiary" data-cy="next-pay-periods-settings-button" ng-click="goToConfirmStep(updatePayPeriodsForm)" ng-disabled="!updatePayPeriodsForm.$valid || !canUpdatePeriods(vm.periodDetails)" ng-if="pageState !== \'ready\' && pageState !== \'confirm-skip-tax-period\'" type="button">\n\t\t\tNext\n\t\t</button>\n\t\t<submit-button data-cy="submit-pay-periods-settings-button" disable-button="!updatePayPeriodsForm.$valid || !canUpdatePeriods(vm.periodDetails)" display-text="formOptions.primaryButtonText" state="updatePayPeriodsForm.state" ng-if="pageState === \'ready\'|| pageState === \'confirm-skip-tax-period\'"></submit-button>\n\t</fieldset>\n</form>\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.periodDetails.isTimelineVisible" ng-switch="vm.periodDetails.payPeriodsLoadingState">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay period calendar</h5>\n\t\t<a aria-label="Close pay period calendar" class="slide-in-form-aside-header-action" href="" ng-click="toggleIsTimelineVisible(vm.periodDetails)">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\n\t<!-- Loading -->\n\t<div class="slide-in-form-aside-main align-center fadeIn" ng-switch-when="loading">\n\t\t<loading-block position="after">\n\t\t\t<lb-description>\n\t\t\t\t<h5>Generating preview</h5>\n\t\t\t</lb-description>\n\t\t</loading-block>\n\t</div>\n\n\t<!-- Ready -->\n\t<div class="slide-in-form-aside-main fadeIn" ng-switch-when="ready">\n\t\t<div ng-repeat="(payPeriodIndex, payPeriod) in vm.periodDetails.payPeriods" ng-show="payPeriodIndex === vm.periodDetails.payPeriodIndex">\n\t\t\t<div class="slide-in-form-aside-subheader">\n\t\t\t\t<p>{{payPeriod.PayPeriodDisplay}}&nbsp;&nbsp;<span class="tag is-tertiary">{{payPeriod.TaxPeriod | taxPeriodDescription:payPeriod.PeriodType}}</span></p>\n\t\t\t\t<div class="next-previous-controls slide-in-form-aside-subheader-actions">\n\t\t\t\t\t<a aria-label="Go to previous month" href="" ng-click="decrementPayPeriodIndex(vm.periodDetails)" ng-class="{\'disabled\': vm.periodDetails.payPeriodIndex === vm.periodDetails.payPeriodIndexMin}">\n\t\t\t\t\t\t<i class="icon-chevron-left"></i>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a aria-label="Go to next month" href="" ng-click="incrementPayPeriodIndex(vm.periodDetails)" ng-class="{\'disabled\': vm.periodDetails.payPeriodIndex === vm.periodDetails.payPeriodIndexMax}">\n\t\t\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Pay Periods -->\n\t\t\t<div class="data-grid is-primary">\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Start date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.StartDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">End date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.EndDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Payroll processing date</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.ProcessDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Pay day</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.PayDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="data-grid_row">\n\t\t\t\t\t<div class="data-grid_cell is-primary">Pay day notifications sent</div>\n\t\t\t\t\t<div class="data-grid_cell">{{payPeriod.PayslipDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Error > Same as \'validation-error\' below -->\n\t<div ng-switch-when="error">\n\t\t<note note-icon="icon-warning" note-theme="assertive" note-title="Unable to update payroll settings">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tThis is usually because the new pay date overlaps with a previously submitted tax period.\n\t\t\t\t\tThe new pay date cannot be before {{vm.periodDetails.PeriodPayDateISOMin | dateformat}}.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n</aside>\n\n<!-- Rollback/Submitting -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="{{vm.currentPayPeriod.IsRollback ? \'Payroll is currently in rollback\' : vm.currentPayPeriod.PayrollState === SUBMISSION_STATES.submitting ? \'Payroll is submitting\' : \'Payroll has failed\'}}" ng-if="pageState === \'cant-change-settings\'">\n\t<fs-main>\n\t\t<p class="is-small" ng-if="vm.currentPayPeriod.IsRollback">\n\t\t\tThe payroll for {{formOptions.company.Name}} is currently in rollback and payroll settings\n\t\t\tcan\'t be updated until you run the payroll for this period again.\n\t\t</p>\n\n\t\t<div ng-if="!vm.currentPayPeriod.IsRollback" ng-switch="vm.currentPayPeriod.PayrollState">\n\t\t\t<p class="is-small" pc-switch-when="SUBMISSION_STATES.submitting">\n\t\t\t\tThe payroll for {{formOptions.company.Name}} is currently submitting.\n\t\t\t\tPayroll settings can\'t be updated until this is complete.\n\t\t\t</p>\n\t\t\t<p class="is-small" ng-switch-default>\n\t\t\t\tThe payroll for {{formOptions.company.Name}} has failed and payroll settings can\'t be updated until\n\t\t\t\tyou run the payroll for this period again.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n</form-state>\n\n<!-- Validation Error -->\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to update payroll settings" ng-if="pageState === \'validation-error\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tThis is usually because the new pay date overlaps with a previously submitted tax period.\n\t\t\tThe new pay date cannot be before {{vm.periodDetails.PeriodPayDateISOMin | dateformat}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">\n\t\t\tBack\n\t\t</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Team members set as advancing/advanced -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Team members are marked as \'Advancing\' or \'Advanced\'" ng-if="pageState === \'team-members-advancing\'">\n    <fs-main>\n        <p class="is-small">\n        \tTeam members are currently marked as &lsquo;Advancing&rsquo; or &lsquo;Advanced&rsquo; and payroll settings can\u2019t be updated until they appear on payroll again.\n        </p>\n    </fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/payslip-additional-note/company-settings-payslip-additional-note.form.html','<form class="fadeIn" name="companySettingsPayslipAdditionalNoteForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateAgencyProfilePayslipAdditionalNoticeVisible(companySettingsPayslipAdditionalNoteForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<settings-row ng-model="$ctrl.isPayslipAdditionalNoteVisible" sr-field-name="isPayslipAdditionalNoteVisible" sr-icon="payslip">\n\t\t\t\t<sr-label>Display Healthcare Levy notice</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-if="$ctrl.isPayslipAdditionalNoteVisible">\n\t\t\t\t\t\tTurning this off means that for employees and directors, the Healthcare Levy notice won\u2019t be displayed on online and PDF payslips.\n\t\t\t\t\t</span>\n\t\t\t\t\t<span ng-if="!$ctrl.isPayslipAdditionalNoteVisible">\n\t\t\t\t\t\tTurning this on means that for employees, the Healthcare Levy notice will be displayed on online and PDF payslips where the pay day falls between 06/04/2022 - 05/11/2022.\n\t\t\t\t\t\tFor directors, an alternative message will be displayed for the whole of the 22/23 tax year.\n\t\t\t\t\t</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsPayslipAdditionalNoteForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/payslip-display-period/company-settings-payslip-display-period.form.html','<form class="fadeIn" name="companySettingsPayslipDisplayPeriodForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateAgencyProfilePayslipPeriodVisible(companySettingsPayslipDisplayPeriodForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<settings-row ng-model="$ctrl.isPayslipPeriodVisible" sr-field-name="isPayslipPeriodVisible" sr-icon="payslip">\n\t\t\t\t<sr-label>Display pay period</sr-label>\n\t\t\t\t<sr-description>\n\t\t\t\t\t<span ng-if="$ctrl.isPayslipPeriodVisible">Turning this off means that the pay period won\u2019t be displayed on online and PDF payslips.</span>\n\t\t\t\t\t<span ng-if="!$ctrl.isPayslipPeriodVisible">Turning this on means that the pay period will be displayed on online and PDF payslips.</span>\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" data-cy="open-form-ui-kit-close" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsPayslipDisplayPeriodForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/pdf-download-sorting/company-settings-pdf-download-sorting.form.html','<form class="fadeIn" name="pdfDownloadSortingForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateAgencyProfilePdfPayslipSorting(pdfDownloadSortingForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tSelect how you wish to sort team members in the &lsquo;Team payslips (PDF)&rsquo; and &lsquo;Payslip summary (PDF)&rsquo; downloads that are available when you calculate and run payroll.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Team member sort order -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">\n\t\t\t\t\tTeam member sort order:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row" ng-repeat="sortByOption in $ctrl.PAYSLIP_SORT_BY_OPTIONS">\n\t\t\t\t\t\t<input class="b radio-row-input" id="sortByOption_{{$index}}" name="sortByOption_{{$index}}" ng-model="$ctrl.companyDetails.PdfPayslipTeamMemberSorting" ng-value="sortByOption.id" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="sortByOption_{{$index}}">\n\t\t\t\t\t\t\t<p class="radio-row-title">\n\t\t\t\t\t\t\t\t{{sortByOption.name}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Awaiting release of Journals / Xero, so only avaialable to Xero Beta customers -->\n\t<fieldset>\n\n\t\t<!-- Business category sorting -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-label="Add business category sorting" field-model="$ctrl.isBusinessCategorySortingEnabled" field-name="isBusinessCategorySortingEnabled" field-on-change="$ctrl.onBusinessCategorySortingEnabledToggled()"></toggle-input>\n\t\t\t</div>\n\t\t\t<p class="form-message fadeIn">\n\t\t\t\tSelect a business category to sort by primarily, and team members will be sorted within categories using the sort order above.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-class="fadeIn" ng-if="$ctrl.isBusinessCategorySortingEnabled">\n\n\t\t<!-- Business category -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="scheme">\n\t\t\t\t\tBusiness category:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row" ng-repeat="sortByOption in $ctrl.BUSINESS_CATEGORY_SORT_BY_OPTIONS" ng-show="sortByOption.key !== \'none\'">\n\t\t\t\t\t\t<input class="b radio-row-input" id="businessCategory_{{$index}}" name="businessCategory_{{$index}}" ng-model="$ctrl.companyDetails.PdfPayslipBusinessCategorySorting" ng-value="sortByOption.id" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="businessCategory_{{$index}}">\n\t\t\t\t\t\t\t<p class="radio-row-title">\n\t\t\t\t\t\t\t\t{{sortByOption.name}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Department Note -->\n\t\t<div class="form-field fadeIn">\n\t\t\t<note note-dismiss="true" note-dismiss-key="business-category-sort-by" note-icon="icon-support" note-theme="indifferent" note-title="Team members who aren\'t in a {{$ctrl.companyDetails.PdfPayslipBusinessCategorySorting | businessCategorySortByDescription | lowercase}}">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tPlease note that team members who aren\'t in a {{$ctrl.companyDetails.PdfPayslipBusinessCategorySorting | businessCategorySortByDescription | lowercase}} will be included at\n\t\t\t\t\t\tthe end of the PDF and sorted using the team member sort order above.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" data-cy="open-form-ui-kit-close" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!pdfDownloadSortingForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="pdfDownloadSortingForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/pension-communications/company-settings-pension-communications.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="companySettingsPensionCommunicationsForm" ng-submit="$ctrl.updateAgencyProfilePensionCommunicationSettings($ctrl, companySettingsPensionCommunicationsForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Employer pension communications email</h4>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="settings-rows">\n\t\t\t<settings-row sr-field-name="useDefaultPensionRecipientEmail" sr-icon="email" sr-theme="secondary" ng-model="$ctrl.pensionSettings.Communications.UseDefaultPensionRecipientEmail">\n\t\t\t\t<sr-label>Default pension communications email</sr-label>\n\t\t\t\t<sr-description ng-if="$ctrl.pensionSettings.Communications.UseDefaultPensionRecipientEmail">Switching this off will stop all pension communications emails from being sent to the below email address for team members without an email address saved in their contact details.</sr-description>\n\t\t\t\t<sr-description ng-if="!$ctrl.pensionSettings.Communications.UseDefaultPensionRecipientEmail">Switching this on will allow you to choose an email address where all pension communications emails can be sent for team members who don\u2019t have an email address saved in their contact details.</sr-description>\n\t\t\t\t<sr-content ng-if="$ctrl.pensionSettings.Communications.UseDefaultPensionRecipientEmail">\n\t\t\t\t\t<fieldset>\n\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<label for="email" class="required">Email address</label>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<input type="email" id="defaultPensionRecipientEmail" required placeholder="{{$ctrl.PLACEHOLDERS.email}}" name="defaultPensionRecipientEmail" ng-model="$ctrl.pensionSettings.Communications.DefaultPensionRecipientEmail">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsPensionCommunicationsForm.defaultPensionRecipientEmail.$error" ng-show="companySettingsPensionCommunicationsForm.defaultPensionRecipientEmail.$touched" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an email address</p>\n\t\t\t\t\t\t\t\t<p ng-message="email">Please make sure the email is valid</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</fieldset>\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsPensionCommunicationsForm.state" disable-button="!companySettingsPensionCommunicationsForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/pension-submissions/company-settings-pension-submissions.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsPensionSubmissionsForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateAgencyProfilePensionSubmissionSettings($ctrl, companySettingsPensionSubmissionsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Delay submission for automated pensions</h5>\n\t\t<p class="s">\n\t\t\tDelay the submission of your pension files for automated pensions so they\u2019re not submitted at the same time you run payroll. Payroll corrections you need to make during the delay can then\n\t\t\tbe included in the submission.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Delay -->\n\t\t<div class="form-field">\n\t\t\t<settings-row ng-model="$ctrl.pensionSettings.Submissions.DelayPensionSubmission" sr-field-name="settings-row2" sr-icon="remote-access" sr-theme="secondary">\n\t\t\t\t<sr-label>Delay pension submission</sr-label>\n\t\t\t\t<sr-description ng-if="!$ctrl.pensionSettings.Submissions.DelayPensionSubmission">\n\t\t\t\t\tTurning on delayed pension submission means that you can schedule your pension file submission to occur later than when you run payroll.\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-description ng-if="$ctrl.pensionSettings.Submissions.DelayPensionSubmission">\n\t\t\t\t\tTurning off delayed pension submission means that your pension files for automated pensions will be submitted at the same time you run payroll.\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-content ng-if="$ctrl.pensionSettings.Submissions.DelayPensionSubmission">\n\t\t\t\t\t\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tSubmission will be scheduled for 10.00pm on the day you choose. This can be manually overridden in your payroll or pension area if you need to submit sooner.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t\t<label for="delayCount" class="required">Delay submission until:</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<number-selector-field class="s" field-name="delayCount" max="$ctrl.pensionSettings.Submissions.PensionSubmissionDelayCountMax" min="1" ng-model-options="{ debounce:400 }" ng-model="$ctrl.pensionSettings.Submissions.PensionSubmissionDelayCount" ng-regex-key="numbersPositiveWhole" step="1"></number-selector-field>\n\t\t\t\t\t\t\t<span>&nbsp;\n\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.pensionSettings.Submissions.PensionSubmissionDelayCount" when="{\n\t\t\t\t\t\t\t\t\t\t\'1\': \'day after payroll processing date\',\n\t\t\t\t\t\t\t\t\t\t\'other\': \'days after payroll processing date\'\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsPensionSubmissionsForm.delayCount.$touched" ng-messages="companySettingsPensionSubmissionsForm.delayCount.$error" role="alert">\n\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{::$ctrl.pensionSettings.Submissions.PensionSubmissionDelayCountMax}}</p>\n\t\t\t\t\t\t\t<p ng-message="min">Minium of 1</p>\n\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a whole number</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class="form-message">\n\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.pensionSettings.Submissions.PensionSubmissionDelayCountMax" when="{\n\t\t\t\t\t\t\t\t\t\'1\': \'Max 1 day\',\n\t\t\t\t\t\t\t\t\t\'other\': \'Max {} days\'\n\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t</sr-content>\n\t\t\t</settings-row>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Submission deadlines for pension providers">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">\n\t\t\t\t\t\tPlease ensure you have checked the submission deadline for each of the automated pension providers you may be using before you turn on submission delay. You should set the\n\t\t\t\t\t\tdelay to the earliest of the provider deadlines as scheduled submission will happen at the same time for all of your automated schemes.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companySettingsPensionSubmissionsForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsPensionSubmissionsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="A scheduled submission is outstanding" ng-if="$ctrl.componentState === \'outstanding-submission\'">\n\t<fs-main>\n\t\t<div class="form-state_section">\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that you\u2019re trying to set the submission delay to sooner than today\u2019s date. This can\u2019t be done while there\u2019s a scheduled submission outstanding. You can\n\t\t\t\tmanually override the scheduled submission in your current period or your pension area - to submit it right away - then you\u2019ll then be able to adjust your submission delay.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state_section">\n\t\t\t<a href="" ui-sref="payroll.current-period({\'agencyProfileId\': $ctrl.formOptions.agencyProfileId})">Go to current period</a>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/pension-sup-runs/company-settings-pension-sup-runs.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsPensionSupRunsForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateAgencyProfilePensionSupplementaryPaySettings($ctrl, companySettingsPensionSupRunsForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<h5>Pension calculations for supplementary pay runs</h5>\n\t\t<p class="s">\n\t\t\tCalculations on pensionable changes in supplementary pay runs can be included in your pension file. For automated pension schemes the supplementary pay run must be made before your\n\t\t\tsubmission date.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<settings-row ng-model="$ctrl.pensionSettings.SupplementaryPay.CalculatePensionsInSupplementaryRun" sr-field-name="settings-row2" sr-icon="remote-access" sr-theme="secondary">\n\t\t\t\t<sr-label>Pension calculations</sr-label>\n\t\t\t\t<sr-description ng-if="!$ctrl.pensionSettings.SupplementaryPay.CalculatePensionsInSupplementaryRun">\n\t\t\t\t\tTurning this on means that calculations on pensionable changes in supplementary pay runs will be added to your pension file.\n\t\t\t\t</sr-description>\n\t\t\t\t<sr-description ng-if="$ctrl.pensionSettings.SupplementaryPay.CalculatePensionsInSupplementaryRun">\n\t\t\t\t\tTurning this off means that calculations on pensionable changes in supplementary pay runs won\u2019t be added to your pension file.\n\t\t\t\t</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companySettingsPensionSupRunsForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsPensionSupRunsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="A scheduled submission is outstanding" ng-if="$ctrl.componentState === \'outstanding-submission\'">\n\t<fs-main>\n\t\t<div class="form-state_section">\n\t\t\t<p class="is-small">\n\t\t\t\tPlease note that you\u2019re trying to set the submission delay to sooner than today\u2019s date. This can\u2019t be done while there\u2019s a scheduled submission outstanding. You can\n\t\t\t\tmanually override the scheduled submission in your current period or your pension area - to submit it right away - then you\u2019ll then be able to adjust your submission delay.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-state_section">\n\t\t\t<a href="" ui-sref="payroll.current-period({\'agencyProfileId\': $ctrl.formOptions.agencyProfileId})">Go to current period</a>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/period-display-title/companySettingsPeriodDisplayTitleForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsPeriodDisplayTitleForm" ng-if="pageState === \'ready\'" ng-submit="updateCompanyMonthlyDisplayFormat(vm, companySettingsPeriodDisplayTitleForm)" novalidate>\n\t<div class="form-intro">\n\t\t<h4>Period display title</h4>\n\t\t<p class="is-small">\n\t\t\tYour first pay period will run from {{::vm.currentPeriod.StartDateISO | dateformat:\'dayMonthFull\'}} to {{::vm.currentPeriod.EndDateISO | dateformat:\'full\'}}.\n\t\t\tThe period title can be displayed in a month and year format or as a date range.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="periodDisplayOption0">How should the pay period title be displayed?</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\n\t\t\t\t\t<div class="radio-row" ng-repeat="periodDisplayOption in vm.periodDisplayOptions">\n\t\t\t\t\t\t<input class="b radio-row-input" id="{{\'periodDisplayOption\' + $index}}" name="periodDisplayOption" ng-change="onPeriodDisplayTitleChange(vm, periodDisplayOption)" ng-disabled="!periodDisplayOption.enabled" ng-model="vm.company.MonthlyDisplayFormat" ng-value="periodDisplayOption.value" required type="radio">\n\t\t\t\t\t\t\t<label class="radio-row-label" for="{{\'periodDisplayOption\' + $index}}">\n\t\t\t\t\t\t\t<p class="radio-row-title">{{::periodDisplayOption.description}}</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Changing pay period -->\n\t<div class="form-field fadeIn" ng-if="vm.company.HasRunPayroll && companySettingsPeriodDisplayTitleForm.$dirty">\n\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Changing period display title">\n\t\t\t<note-content>\n\t\t\t\t<div class="note-section">\n\t\t\t\t\t<p class="is-small">Please note that changing the period display title will update the display titles when viewing periods in your History area.\n\t\t\t\t\t\tHowever, period display titles for logs and documents relating to those periods will remain the same.</p>\n\t\t\t\t</div>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Preview -->\n\t<div class="form-field">\n\t\t<a aria-label="Toggle pay period calendar" class="link-with-icon" href="" ng-click="toggleIsTimelineVisible(vm)">\n\t\t\t<i class="icon-{{vm.isTimelineVisible ? \'right\' : \'back\'}}"></i>{{vm.isTimelineVisible ? \'Close pay period calendar\' : \'Open pay period calendar\'}}\n\t\t</a>\n\t</div>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companySettingsPeriodDisplayTitleForm.$valid" display-text="formOptions.primaryButtonText" state="companySettingsPeriodDisplayTitleForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n\n<aside class="slide-in-form-aside slideInRight" ng-if="vm.isTimelineVisible">\n\t<header class="slide-in-form-aside-header">\n\t\t<h5>Pay period calendar</h5>\n\t\t<a aria-label="Close pay period calendar" href="" class="slide-in-form-aside-header-action" ng-click="toggleIsTimelineVisible(vm)">\n\t\t\t<i class="icon-right l"></i>\n\t\t</a>\n\t</header>\n\n\t<div class="slide-in-form-aside-main fadeIn">\n\n\t\t<div class="slide-in-form-aside-subheader">\n\t\t\t<p>{{vm.payPeriodDisplay}}&nbsp;&nbsp;<span class="tag is-tertiary">{{::vm.currentPeriod.TaxPeriod | taxPeriodDescription:vm.currentPeriod.PeriodType}}</span></p>\n\t\t</div>\n\n\t\t<!-- Pay Periods -->\n\t\t<div class="data-grid is-primary">\n\t\t\t<div class="data-grid_row">\n\t\t\t\t<div class="data-grid_cell is-primary">Start date</div>\n\t\t\t\t<div class="data-grid_cell">{{vm.currentPeriod.StartDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t</div>\n\t\t\t<div class="data-grid_row">\n\t\t\t\t<div class="data-grid_cell is-primary">End date</div>\n\t\t\t\t<div class="data-grid_cell">{{vm.currentPeriod.EndDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t</div>\n\t\t\t<div class="data-grid_row">\n\t\t\t\t<div class="data-grid_cell is-primary">Payroll processing date</div>\n\t\t\t\t<div class="data-grid_cell">{{vm.currentPeriod.ProcessDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t</div>\n\t\t\t<div class="data-grid_row">\n\t\t\t\t<div class="data-grid_cell is-primary">Pay day</div>\n\t\t\t\t<div class="data-grid_cell">{{vm.currentPeriod.PayDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t</div>\n\t\t\t<div class="data-grid_row">\n\t\t\t\t<div class="data-grid_cell is-primary">Pay day notifications sent</div>\n\t\t\t\t<div class="data-grid_cell">{{vm.currentPeriod.PayslipDateISO | dateformat:\'dayFullMonth\'}}</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</aside>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/references/companySettingsReferencesForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsReferencesForm" ng-submit="saveCompanyReferences(company.Employer, companySettingsReferencesForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Playgound Note -->\n\t\t<div class="form-field" ng-if="::isInPlayground">\n\t\t\t<div class="info-block primary has-plain-type">\n\t\t\t\t<p class="s"><strong>Note:</strong> Company references are not editable in your playground.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Company number -->\n\t\t<div class="form-field">\n\t\t\t<label for="companyNumber" ng-class="{\n\t\t\t\t\t\'disabled\' : formOptions.company.CeasePAYESchemeComplete\n\t\t\t\t}">\n\t\t\t\tCompany number:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<input capitalise class="l" id="companyNumber" maxlength="10" name="companyNumber" ng-disabled="formOptions.company.CeasePAYESchemeComplete" ng-model="company.Employer.CompanyNumber" ng-pattern="$root.REGEX.companyNumber" ng-readonly="::isInPlayground" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors" ng-if="companySettingsReferencesForm.companyNumber.$touched" ng-messages="companySettingsReferencesForm.companyNumber.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a company number</p>\n\t\t\t\t<p ng-message="pattern">Please enter a valid company number. They are usually between 7-8 digits, often starting with 2 letters.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Client reference -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="clientReference">Client reference:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="clientReference" name="clientReference" ng-model="company.Employer.ClientReference" type="text">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Accounts Office Reference Number -->\n\t\t<div class="form-field" ng-if="!company.PensionOnly">\n            <label for="accountsOfficeReferenceNumber">Accounts Office reference number:</label>\n            <div class="field">\n                <input type="text" class="l" id="accountsOfficeReferenceNumber" name="accountsOfficeReferenceNumber" placeholder="123PA12345678" min-length="13" max-length="13" ng-model="company.Employer.AccountsOffice" ng-pattern="$root.REGEX.accountsOfficeRef" capitalise ng-readonly="::isInPlayground">\n            </div>\n            <div class="form-errors fadeIn" ng-messages="companySettingsReferencesForm.accountsOfficeReferenceNumber.$error" ng-if="companySettingsReferencesForm.accountsOfficeReferenceNumber.$touched" role="alert">\n                <p ng-message="pattern">This has to be 13 characters and in this format 123PA12345678</p>\n            </div>\n\t\t</div>\n\n\t\t<!-- Tax Office Reference Number -->\n\t\t<div class="form-field">\n            <label for="taxOffice">Tax Office reference number:</label>\n            <div class="field">\n                <input type="text" class="s" id="taxOffice" name="taxOffice" ng-model="company.Employer.TaxOffice" placeholder="123" capitalise ng-required="company.Employer.TaxOfficeReference" ng-pattern="$root.REGEX.payeRefA">\n                <span>&nbsp;/&nbsp;</span>\n                <input type="text" class="s" id="taxOfficeRef" name="taxOfficeRef" ng-model="company.Employer.TaxOfficeReference" placeholder="A246" capitalise ng-required="company.Employer.TaxOffice" ng-pattern="$root.REGEX.payeRefB">\n            </div>\n            <div class="form-errors fadeIn" ng-messages="companySettingsReferencesForm.taxOffice.$error || companySettingsReferencesForm.taxOfficeRef.$error" ng-if="companySettingsReferencesForm.taxOfficeRef.$touched && companySettingsReferencesForm.taxOffice.$touched" role="alert">\n                <p ng-message="pattern">Please enter a valid Tax Office reference number. E.g. 123/A246</p>\n            </div>\n\t\t</div>\n\n        <!-- Note for AOR and TOR numbers -->\n\t\t<div class="form-content-block fadeIn" ng-if="!company.PensionOnly && (!company.Employer.AccountsOffice || !company.Employer.TaxOffice || !company.Employer.TaxOfficeReference)">\n            <note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="Accounts Office &amp; Tax Office reference numbers">\n                <note-content>\n                    <p class="s">Can be added at a later date but are required in order to run payroll</p>\n                </note-content>\n            </note>\n        </div>\n\n        <!-- PensionOnly - TOR number-->\n\t\t<div class="form-content-block fadeIn" ng-if="company.PensionOnly">\n            <note note-theme="indifferent" note-icon="icon-support" note-dismiss="true" note-title="Tax Office reference number">\n                <note-content>\n                    <p class="is-small">This can be added at a later date but is required in order to run payroll.</p>\n                </note-content>\n            </note>\n        </div>\n\n\t\t<!-- Unique Taxpayer Reference (UTR) -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="utr" ng-class="{\n\t\t\t\t\t\t\'required\': company.Employer.IsCISActive\n\t\t\t\t\t}">\n\t\t\t\t\tUnique Taxpayer Reference (UTR):\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" id="utr" name="utr" ng-model="company.Employer.UTR" ng-pattern="$root.REGEX.utr" ng-required="company.Employer.IsCISActive" placeholder="1234567890" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsReferencesForm.utr.$touched" ng-messages="companySettingsReferencesForm.utr.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter a Unique Taxpayer Reference number\n\t\t\t\t</p>\n\t\t\t\t<p ng-message="pattern">\n\t\t\t\t\tPlease enter a valid Unique Taxpayer Reference number. It should consist of 10 digits. E.g. 0123456789\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- New company? -->\n\t\t<div class="form-field" ng-if="!company.HasRunPayroll">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="isNewCompany" name="isNewCompany" ng-model="company.Employer.IsNewCompany" label-text="\'This is a new company\'" checkbox>\n\t\t\t</div>\n\t\t\t<p class="form-message">For companies with new PAYE schemes</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="companySettingsReferencesForm.state" ng-if="companySettingsReferencesForm.state === \'saved\'">\n\t\t\t<p>This information has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsReferencesForm.state" disable-button="!companySettingsReferencesForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Testing HMRC credentials -->\n<section class="form-summary fadeIn" ng-if="pageState === \'testing-hmrc-credentials\'">\n\t<loading-block size="m">\n\t\t<lb-description>Validating HMRC credentials...</lb-description>\n\t</loading-block>\n\t<section class="form-summary-section align-center">\n\t\t<p class="s">We\'re quickly testing the connection to HMRC. This shouldn\'t take too long.</p>\n\t</section>\n</section>\n\n<!-- HMRC credentials invalid -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Unable to validate HMRC credentials" ng-if="pageState === \'hmrc-credentials-invalid\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to validate the HMRC credentials entered.</p>\n\t\t<p class="s"><a href="" ng-click="setPageState(\'ready\')" class="underline">Go back and try again</a></p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- HMRC credentials valid but Electronic updates are not switched on -->\n<form-state form-options="formOptions" fs-icon="warning" fs-show-close="false" fs-title="Electronic updates not enabled" ng-if="pageState === \'automatic-updates-not-enabled\'">\n\t<fs-main>\n\t\t<p class="s">We were able to connect to HMRC successfully although it appears as though your electronic HMRC notices are not enabled. You\'ll need to turn these on to enable electronic notices. Follow\n\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.howToEnableElectronicHMRCNotices" underline="true">these simple steps</support-article-link> to switch electronic notices on.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/rotaready-entity-create-all-business-codes/rotaready-entity-create-all-business-codes.form.html','<form class="fadeIn" data-cy="rotaready-entity-create-all-business-codes-form" name="createAllBusinessCodesForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.onSubmit(createAllBusinessCodesForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">Create business categories for all\n\t\t\t<ng-pluralize count="$ctrl.unmappedCount" when="{\'1\': \'1 unmapped site/department\', \'other\': \'{} unmapped sites/departments\'}"></ng-pluralize>.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Business category -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="businessCategoryId">Business category:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select data-cy="rotaready-entity-create-all-business-codes-category" id="businessCategoryId" name="businessCategoryId" ng-model="$ctrl.formObject.businessCategoryId" ng-options="category.BusinessCategoryID as category.BusinessCategoryName for category in $ctrl.businessCategories | orderBy: \'BusinessCategoryName\'" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="createAllBusinessCodesForm.businessCategoryId.$touched" ng-messages="createAllBusinessCodesForm.businessCategoryId.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select a business category</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Naming strategy -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>How should the business category names be generated?</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards-list">\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="rotaready-entity-create-all-naming-entity-name" id="namingStrategyEntityName" name="namingStrategy" ng-model="$ctrl.formObject.namingStrategy" ng-value="$ctrl.NAMING_STRATEGIES.ENTITY_NAME" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="namingStrategyEntityName">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<h6>Use site/department name</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">The business category name will be based on the Rotaready site/department name.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="rotaready-entity-create-all-naming-entity-name-and-calendar" id="namingStrategyEntityNameAndCalendar" name="namingStrategy" ng-model="$ctrl.formObject.namingStrategy" ng-value="$ctrl.NAMING_STRATEGIES.ENTITY_NAME_AND_CALENDAR" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="namingStrategyEntityNameAndCalendar">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<h6>Use site/department name and payroll calendar</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">The payroll calendar will be added in brackets after the site/department name, for example Site A (Monthly).</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="rotaready-entity-create-all-naming-prefix" id="namingStrategyPrefix" name="namingStrategy" ng-model="$ctrl.formObject.namingStrategy" ng-value="$ctrl.NAMING_STRATEGIES.PREFIX" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="namingStrategyPrefix">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<h6>Use a prefix, then site/department name</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">A prefix will be added before the site/department name.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input class="b radio-card-input" data-cy="rotaready-entity-create-all-naming-prefix-and-calendar" id="namingStrategyPrefixAndCalendar" name="namingStrategy" ng-model="$ctrl.formObject.namingStrategy" ng-value="$ctrl.NAMING_STRATEGIES.PREFIX_AND_CALENDAR" type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="namingStrategyPrefixAndCalendar">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<h6>Use a prefix, then site/department name and payroll calendar</h6>\n\t\t\t\t\t\t\t\t<p class="is-small is-greyscale">A prefix will be added before the site/department name, with the payroll calendar in brackets after it, for example ABC Site A (Monthly).</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Prefix input -->\n\t\t<div class="form-field" ng-if="$ctrl.isPrefixRequired()">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="prefix">Prefix:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input data-cy="rotaready-entity-create-all-prefix-input" id="prefix" name="prefix" ng-model="$ctrl.formObject.prefix" ng-required="$ctrl.isPrefixRequired()" placeholder="Enter prefix" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="createAllBusinessCodesForm.prefix.$touched" ng-messages="createAllBusinessCodesForm.prefix.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a prefix</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<info-block ib-theme="assertive has-icon has-border has-plain-type">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout-slim">\n\t\t\t\t\t\t<i class="icon-warning assertive info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">Preventing creation of duplicates</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThis will create new business categories by generating them with names as defined above.\n\t\t\t\t\t\tIf the name matches an existing category, we will use it rather than creating a duplicate.\n\t\t\t\t\t</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</div>\n\n\t</fieldset>\t\n\n\t<fieldset class="form-actions">\n\t\t<a href="" data-cy="rotaready-entity-create-all-business-codes-cancel" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\n\t\t<submit-button data-cy="rotaready-entity-create-all-business-codes-submit" display-text="\'Create all business categories\'"></submit-button>\n\t</fieldset>\n\n</form>\n');
$templateCache.put('forms/admin/companySettings/rotaready-entity-create-business-code/rotaready-entity-create-business-code.form.html','<form class="fadeIn" data-cy="rotaready-entity-create-business-code-form" name="createBusinessCodeForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.onSubmit(createBusinessCodeForm)" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="is-small">Select a business category and enter a name for the new business category.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Business category -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="businessCategoryId">Business category:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t\t<select data-cy="rotaready-entity-create-business-code-category" id="businessCategoryId" name="businessCategoryId" ng-change="$ctrl.checkForDuplicate(createBusinessCodeForm)" ng-model="$ctrl.formObject.businessCategoryId" ng-options="category.BusinessCategoryID as category.BusinessCategoryName for category in $ctrl.businessCategories | orderBy: \'BusinessCategoryName\'" required>\n\t\t\t\t\t<option value="">Please select...</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="createBusinessCodeForm.businessCategoryId.$touched" ng-messages="createBusinessCodeForm.businessCategoryId.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please select a business category</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Business category name -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="businessCodeNarrative">Name:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input data-cy="rotaready-entity-create-business-code-name" id="businessCodeNarrative" name="businessCodeNarrative" ng-change="$ctrl.checkForDuplicate(createBusinessCodeForm)" ng-model="$ctrl.formObject.businessCodeNarrative" placeholder="Enter name" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="createBusinessCodeForm.businessCodeNarrative.$touched" ng-messages="createBusinessCodeForm.businessCodeNarrative.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a name.</p>\n\t\t\t\t<p ng-message="nonUnique">A {{$ctrl.duplicateCategoryName}} with this name already exists. Please enter a different name.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" data-cy="rotaready-entity-create-business-code-cancel" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\n\t\t<submit-button data-cy="rotaready-entity-create-business-code-submit" display-text="\'Create business category\'"></submit-button>\n\t</fieldset>\n\n</form>\n');
$templateCache.put('forms/admin/companySettings/rotaready-entity-save-confirmation/rotaready-entity-save-confirmation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" data-cy="rotaready-entity-save-confirmation-form" name="companySettingsRotareadyEntitySaveForm" ng-submit="$ctrl.saveEntityMappings($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to save these site/department mappings?" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou\'re about to map\n\t\t\t\t\t<ng-pluralize count="$ctrl.mappingCount" when="{\'1\': \'1 site/department\',\'other\': \'{} sites/departments\'}"></ng-pluralize>\n\t\t\t\t\tfrom Rotaready to\n\t\t\t\t\t<ng-pluralize count="$ctrl.mappingCount" when="{\'1\': \'1 business category\',\'other\': \'{} business categories\'}"></ng-pluralize>\n\t\t\t\t\tin Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' if you\'re happy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" data-cy="rotaready-entity-save-confirmation-cancel" href="" ng-click="$ctrl.cancel()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button data-cy="rotaready-entity-save-confirmation-submit" display-text="\'Confirm\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state data-cy="rotaready-entity-save-confirmation-success" form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="true" fs-title="Site/department mappings have been saved" ng-if="$ctrl.pageState === \'saved\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{ $ctrl.getSuccessMessage() }}\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/rotaready-entity-unmatch-confirmation/rotaready-entity-unmatch-confirmation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" data-cy="rotaready-entity-unmatch-confirmation-form" name="companySettingsRotareadyEntityUnmatchForm" ng-submit="$ctrl.unmapEntity($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to unmap this site/department?" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou\'re about to unmap {{$ctrl.entity.EntityName}} in Rotaready from {{$ctrl.entity.businessCodeNarrative}} in Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' to proceed.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" data-cy="rotaready-entity-unmatch-confirmation-cancel" href="" ng-click="$ctrl.cancel()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button data-cy="rotaready-entity-unmatch-confirmation-submit" display-text="\'Confirm\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state data-cy="rotaready-entity-unmatch-confirmation-success" form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="true" fs-title="Site/department successfully unmapped" ng-if="$ctrl.pageState === \'saved\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThe site/department has been successfully unmapped.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/rotaready-save-confirmation/rotaready-save-confirmation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsRotareadySaveForm" ng-submit="$ctrl.saveTeamMembersChanges($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="{{$ctrl.getTitle()}}" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.matchCount > 0">\n\t\t\t\t\tYou\'re about to match\n\t\t\t\t\t<ng-pluralize count="$ctrl.matchCount" when="{\'1\': \'1 team member\',\'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\tfrom Rotaready to\n\t\t\t\t\t<ng-pluralize count="$ctrl.matchCount" when="{\'1\': \'1 team member\',\'other\': \'{} team members\'}"></ng-pluralize>\n\t\t\t\t\tin Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small" ng-if="$ctrl.creationCount > 0">\n\t\t\t\t\tYou\'re about to create <ng-pluralize count="$ctrl.creationCount" when="{\'1\': \'1 team member\',\'other\': \'{} team members\'}"></ng-pluralize> from Rotaready in Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' if you\'re happy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.cancel()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button display-text="\'Confirm\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Matches have been saved" fs-show-close="true" ng-if="$ctrl.pageState === \'saved\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\t{{ $ctrl.getSuccessMessage() }}\n\t\t\t</p>\n\n\t\t\t<div ng-if="$ctrl.usersWithWarnings && $ctrl.usersWithWarnings.length > 0">\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t<div class="form-intro">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tSome users were created successfully but with warnings. Please review the details below:\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-repeat="userWithWarning in $ctrl.usersWithWarnings">\n\t\t\t\t\t<note note-icon="icon-warning" note-theme="is-tertiary" note-title="{{userWithWarning.UserFullName}}">\n\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t<bullet-list bl-items="userWithWarning.Warnings" bl-theme="is-small is-tertiary is-spaced-out"></bullet-list>\n\t\t\t\t\t\t</note-content>\n\t\t\t\t\t</note>\n\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Failed to create users" fs-show-close="true" ng-if="$ctrl.pageState === \'saveError\'">\n\t\t<fs-main>\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tSome of the Rotaready users could not be created in Paycircle. Review the errors below and make any corrections before retrying.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Failed User Creations Block -->\n\t\t\t<div ng-repeat="failedUser in $ctrl.failedUsers">\n\t\t\t\t<note note-icon="icon-warning" note-theme="is-tertiary" note-title="{{failedUser.UserFullName}}">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<bullet-list bl-items="failedUser.Criticals" bl-theme="is-small is-tertiary is-spaced-out" data-cy="rotaready-save-confirmation-critical-list" ng-if="failedUser.Criticals && failedUser.Criticals.length > 0"></bullet-list>\n\t\t\t\t\t\t<bullet-list bl-items="failedUser.Errors" bl-theme="is-small is-tertiary is-spaced-out" data-cy="rotaready-save-confirmation-error-list" ng-if="failedUser.Errors && failedUser.Errors.length > 0"></bullet-list>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t\t<div class="spacer s"></div>\n\t\t\t</div>\n\t\t</fs-main>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/rotaready-unmatch-confirmation/rotaready-unmatch-confirmation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsRotareadyUnmatchForm" ng-submit="$ctrl.saveTeamMembersChanges($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to unmatch this team member?" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYou\'re about to unmatch {{$ctrl.teamMember.Rotaready.FullName }} in Rotaready from {{$ctrl.teamMember.Paycircle.FullName}} in Paycircle.\n\t\t\t\t</p>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tClick \'Confirm\' to proceed.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.cancel()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button display-text="\'Confirm\'"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Team member successfully unmatched" fs-show-close="true" ng-if="$ctrl.pageState === \'saved\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThe team member has been successfully unmatched.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/rti-submissions/company-settings-rti-submissions.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsRtiSubmissionsForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateAgencyEmployerDisableRTISubmissions($ctrl, companySettingsRtiSubmissionsForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<h5>RTI submissions to HMRC</h5>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<div class="form-field">\n\t\t\t\t<settings-row sr-field-name="isRtiSubmissionDisabled" sr-icon="tax-code-change" ng-model="$ctrl.isRTISubmissionDisabled" sr-theme="secondary">\n\t\t\t\t\t<sr-label>RTI submissions</sr-label>\n\t\t\t\t\t<sr-description ng-if="$ctrl.isRTISubmissionDisabled">Turning off RTI submissions means that each time you run payroll FPS and EPS submissions will never be made to HMRC.</sr-description>\n\t\t\t\t\t<sr-description ng-if="!$ctrl.isRTISubmissionDisabled">Turning on RTI submissions means that each time you run payroll FPS and EPS submissions will be made to HMRC.</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\n\t\t\t<div class="form-field fadeIn" ng-if="!$ctrl.isRTISubmissionDisabled">\n\t\t\t\t<note note-title="Turning off pension submissions" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Please note that if you\'ve connected a pension directly to your provider, you may wish to turn this off in the automation options for the scheme, so that submissions aren\'t automatically made when you run payroll.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fieldset>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="!companySettingsRtiSubmissionsForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsRtiSubmissionsForm.state"></submit-button>\n\t</fieldset>\n</form>\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/sick-pay-default-work-pattern/company-settings-sick-pay-default-work-pattern.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsSickPayDefaultWorkPatternForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateSickPayDefaultWorkDays($ctrl, companySettingsSickPayDefaultWorkPatternForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<p class="is-small" data-cy="company-settings-sick-pay-default-work-pattern-description">\n\t\t\t\tThe work pattern you configure below will be used by default when creating sick pay schedules for hourly paid team members. You will still be able to override the work pattern against a team member\'s schedule if required.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" data-cy="company-settings-sick-pay-default-work-pattern-header-label">Default work pattern for sick pay:</label>\n\t\t\t</header>\n\n\t\t\t<simple-work-pattern work-pattern="$ctrl.workPattern">\n\t\t\t</simple-work-pattern>\n\t\t</div>\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss="false" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Updating the default work pattern">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tUpdating this work pattern will only affect newly created sick pay schedules. Existing sick pay schedules will not be affected.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="!companySettingsSickPayDefaultWorkPatternForm.$valid || !$ctrl.isWorkPatternValid($ctrl.workPattern)" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsSickPayDefaultWorkPatternForm.state"></submit-button>\n\t</fieldset>\n</form>\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/sickness-pro-ration-method/company-settings-sickness-pro-ration-method.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsSicknessProRationMethodForm" ng-if="$ctrl.componentState === \'ready\'" ng-submit="$ctrl.updateSicknessProRationMethod($ctrl, companySettingsSicknessProRationMethodForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<p class="is-small" data-cy="company-settings-sickness-pro-ration-method-description">\n\t\t\t\tThe pro-ration method you configure below will be used by default when creating sick pay schedules. You will still be able to override the pro-ration method against a team member\'s schedule if required.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" data-cy="company-settings-sickness-pro-ration-method-header-label" for="proRationCompanySetting">Pro-ration method:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="proRationCompanySetting" name="proRationMethod" ng-change="$ctrl.displayLeaveDaysAsSeparateDeduction = false" ng-model="$ctrl.proRationMethod" ng-value="$ctrl.PRO_RATION_METHODS.companySetting" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="proRationCompanySetting">\n\t\t\t\t\t\t\t<p class="radio-row-title">Standard pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">The team member\'s normal pay will be pro-rated for the days they\'ve worked in a pay period and the statutory payment added on top.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="proRationPeriod" name="proRationMethod" ng-model="$ctrl.proRationMethod" ng-value="$ctrl.PRO_RATION_METHODS.period" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="proRationPeriod">\n\t\t\t\t\t\t\t<p class="radio-row-title">Period pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">The team member\'s normal pay will be reduced by the number of leave days in a pay period based on the day rate calculation method saved in their pay information.</p>\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.proRationMethod === $ctrl.PRO_RATION_METHODS.period">\n\t\t\t\t\t\t\t\t<div class="spacer s"></div>\n\t\t\t\t\t\t\t\t<toggle-input field-label="Display leave days as a separate deduction on payslips" field-model="$ctrl.displayLeaveDaysAsSeparateDeduction" field-name="displayLeaveDaysAsSeparateDeduction"></toggle-input>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-row">\n\t\t\t\t\t\t<input class="b radio-row-input" id="proRationManual" name="proRationMethod" ng-change="$ctrl.displayLeaveDaysAsSeparateDeduction = false" ng-model="$ctrl.proRationMethod" ng-value="$ctrl.PRO_RATION_METHODS.manual" type="radio">\n\t\t\t\t\t\t<label class="radio-row-label" for="proRationManual">\n\t\t\t\t\t\t\t<p class="radio-row-title">Manual pro-ration</p>\n\t\t\t\t\t\t\t<p class="s">Where the schedule doesn\'t cover a whole pay period (e.g. the first and last payments of an extended period of leave) pro-ration can be turned off and any adjustments can be made manually to the team member\'s pay for those pay periods affected.</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<note note-dismiss="false" note-icon="icon-support" note-theme="indifferent is-form-field" note-title="Updating the pro-ration method">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tUpdating this pro-ration method will only affect newly created sick pay schedules. Existing sick pay schedules will not be affected.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button disable-button="!companySettingsSicknessProRationMethodForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsSicknessProRationMethodForm.state"></submit-button>\n\t</fieldset>\n</form>\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/skip-pay-periods/companySettingsSkipPayPeriodsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsSkipPayPeriodsForm" ng-submit="updateAgencyEmployerSkipped(vm, companySettingsSkipPayPeriodsForm)" class="fadeIn" ng-if="pageState === \'setup\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tIf you don\u2019t want to make any submissions or the pay period has already been submitted outside of Paycircle, you can skip pay periods.\n\t\t</p>\n\t</div>\n\n\t<div class="form-section">\n\t\t<note note-title="Checking year to dates information" note-theme="indifferent is-form-field" note-icon="icon-support">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">If you skip pay periods on Paycircle, you will need to ensure that any year to date information has been updated before submitting the next pay period.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<div class="form-section">\n\t\t<settings-row sr-field-name="hasSkippedPeriods" sr-icon="clock" ng-model="vm.inactivityDetails.HasSkippedPeriods" sr-disabled="vm.inactivityDetails.inactivePeriodExists">\n\t\t\t<sr-label>Skip periods</sr-label>\n\t\t\t<sr-description>Turning on skip pay periods means no submissions will be made for the period that you select.</sr-description>\n\t\t\t<sr-content ng-if="vm.inactivityDetails.HasSkippedPeriods && !vm.inactivityDetails.inactivePeriodExists">\n\t\t\t\t<fieldset class="fadeIn">\n\n\t\t\t\t\t<div class="form-section">\n\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\tSelect the first and last pay periods to skip:\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<!-- First period -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="firstInactivePeriod">First period to skip:</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<input id="firstInactivePeriod" class="primary" name="firstInactivePeriod" type="text" readonly="readonly" ng-model="vm.firstInactivePeriod.PayPeriodDisplay">\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Last period -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t<label for="lastInactivePeriod" class="required">Last period to skip:</label>\n\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t<select name="lastInactivePeriod" id="lastInactivePeriod" ng-model="vm.lastInactivePeriod" ng-options="payPeriod.PayPeriodDisplay for payPeriod in vm.inactivityDetails.UpcomingIncompletePeriods" required>\n\t\t\t\t\t\t\t\t\t\t<option value="" disabled="disabled" hidden selected="selected">Please select a period...</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsSkipPayPeriodsForm.lastInactivePeriod.$error" ng-if="companySettingsSkipPayPeriodsForm.lastInactivePeriod.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Please select a period</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t<fieldset class="fadeIn" ng-if="vm.lastInactivePeriod">\n\t\t\t\t\t\t<p class="s fadeIn" ng-if="vm.firstInactivePeriod.PayPeriodID !== vm.lastInactivePeriod.PayPeriodID"><span class="primary stronger">{{vm.firstInactivePeriod.PayPeriodDisplay}}</span> to <span class="primary stronger">{{vm.lastInactivePeriod.PayPeriodDisplay}}</span> pay periods will be skipped.</p>\n\t\t\t\t\t\t<p class="s fadeIn" ng-if="vm.firstInactivePeriod.PayPeriodID === vm.lastInactivePeriod.PayPeriodID">The <span class="primary stronger">{{vm.firstInactivePeriod.PayPeriodDisplay}}</span> pay period will be skipped.</p>\n\t\t\t\t\t</fieldset>\n\n\t\t\t\t</fieldset>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</div>\n\n\t<div class="form-section" ng-if="vm.inactivityDetails.inactivePeriodExists">\n\t\t<note note-theme="tertiary">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tPlease note: you\'ve already skipped a number of pay periods. Please re-open all skipped periods from <a href="" ui-sref="payroll.history.pay-periods({agencyProfileId: agencyProfileId})" class="assertive-darkened underline">your History page</a> before selecting a new range of periods to skip.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset class="form-actions">\n\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsSkipPayPeriodsForm.state" disable-button="!(vm.inactivityDetails.HasSkippedPeriods && vm.lastInactivePeriod)"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Skipped periods saved" ng-if="pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="s">If you later change your mind and wish to re-open one of your skipped periods, you can do so from <a href="" ui-sref="payroll.history.pay-periods({agencyProfileId: agencyProfileId})" class="primary underline">your History page</a>.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="question-mark" fs-title="Are you sure?" ng-if="pageState === \'reopen\'" fs-show-close="false">\n\t<fs-main>\n\t\t<div class="form-section">\n\t\t\t<p class="s">Reopening the {{vm.payPeriod.PayPeriodDisplay}} period will also remove all later skipped periods.</p>\n\t\t</div>\n\n\t\t<div class="form-section">\n\t\t\t<note note-title="Checking year to dates information" note-theme="indifferent is-form-field" note-icon="icon-support">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">If you skip pay periods on Paycircle, you will need to ensure that any year to date information has been updated before submitting the next pay period.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" type="button" ng-click="formOptions.closeForm()">Cancel</button>\n\t\t<button class="tertiary primary-action" ng-click="reopenInactivePeriod(vm)">Reopen period</button>\n\t</fs-actions>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Pay period reopened" ng-if="pageState === \'reopened\'">\n\t<fs-main>\n\t\t<p class="s">{{vm.payPeriod.PayPeriodDisplay}} has been reopened and all later skipped periods have been removed.</p>\n\t</fs-main>\n</form-state>\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Can\'t reopen period" ng-if="pageState === \'cant-reopen\'">\n\t<fs-main>\n\t\t<p class="s">{{vm.payPeriod.PayPeriodDisplay}} cannot be reopened because there are completed, or partially submitted periods after it.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/support-contact/companySettingsSupportContactForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form name="companySettingsSupportContactForm" ng-submit="saveCompanyBasicDetails(company, companySettingsSupportContactForm)" class="fadeIn" ng-if="pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Payroll support contact</h4>\n\t\t<p class="s">We suggest adding details for the best person to contact for any payroll related queries.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Main Contact Name -->\n\t\t<section class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="forename" name="forename" ng-model="company.Contact.Forename" ng-pattern="$root.REGEX.name" minlength="2">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsSupportContactForm.forename.$error" ng-if="companySettingsSupportContactForm.forename.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Last name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="surname">Last name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input type="text" id="surname" name="surname" ng-model="company.Contact.Surname" ng-pattern="$root.REGEX.name">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsSupportContactForm.surname.$error" ng-if="companySettingsSupportContactForm.surname.$touched" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Last names can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</section>\n\n\t\t<!-- Email address -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="email">Email address:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="email" name="email" type="text" ng-model="company.Contact.EmailAddress" placeholder="{{$root.PLACEHOLDERS.email}}" ng-pattern="$root.REGEX.email">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsSupportContactForm.email.$error" ng-if="companySettingsSupportContactForm.email.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid email address</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback state="companySettingsSupportContactForm.state" ng-if="companySettingsSupportContactForm.state === \'saved\'">\n\t\t\t<p>This information has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="formOptions.canGoBack" class="button secondary-action" ng-click="formOptions.back()">Back</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsSupportContactForm.state" disable-button="!companySettingsSupportContactForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/work-durations/companySettingsWorkDurationsForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="workDurationsForm" ng-if="pageState === \'ready\'" ng-submit="saveWorkDurations(company, workDurationsForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<p class="s">Standard work hours per week will be used by default for team members using a standard work pattern. This can be overridden in their pay information, however.</p>\n\t\t</div>\n\n\t\t<!-- Standard work hours per week -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">Standard work hours per week:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<number-picker class="{{workDurationsForm.workHoursPerWeek.$invalid ? \'invalid\' : \'\'}} m" field-name="workHoursPerWeek" figure-type="number" heading="hours" is-editable="true" max="config.workTimeLimits.hoursPerWeek.max" min="config.workTimeLimits.hoursPerWeek.min" ng-model="company.WorkHoursPerWeek" np-on-change="onWorkDurationsChange(company)" ng-pattern="regexService.contractedWorkingTimesRegEx" step="config.workTimeLimits.hoursPerWeek.step"></number-picker>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="workDurationsForm.workHoursPerWeek.$error" role="alert">\n\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.hoursPerWeek.max}} hours</p>\n\t\t\t\t<p ng-message="min">Please enter a minimum of {{config.workTimeLimits.hoursPerWeek.min}} hours</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t<p ng-message="required">Please enter the number of hours per week</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Standard work weeks per year -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required">Standard work weeks per year:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<number-picker class="{{workDurationsForm.workWeeksPerYear.$invalid ? \'invalid\' : \'\'}} m" figure-type="number" heading="weeks" is-editable="true" field-name="workWeeksPerYear" max="config.workTimeLimits.weeksPerYear.max" min="config.workTimeLimits.weeksPerYear.min" ng-model="company.WorkWeeksPerYear" np-on-change="onWorkDurationsChange(company)" ng-pattern="regexService.contractedWorkingTimesRegEx" step="config.workTimeLimits.weeksPerYear.step"></number-picker>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="workDurationsForm.workWeeksPerYear.$error" role="alert">\n\t\t\t\t<p ng-message="max">Please enter a maximum of {{config.workTimeLimits.weeksPerYear.max}} weeks</p>\n\t\t\t\t<p ng-message="min">Please enter a minimum of {{config.workTimeLimits.weeksPerYear.min}} weeks</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number of weeks</p>\n\t\t\t\t<p ng-message="pattern">Please enter no more than {{config.precision.contractedWorkingTimes}} decimal places</p>\n\t\t\t\t<p ng-message="required">Please enter the number of weeks per year</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<div class="form-content-block fadeIn" ng-if="company.HasRunPayroll && company.workDurationsChanged">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<p><strong>Please note:</strong> this change to your work pattern will apply when you approve payroll for {{currentPayPeriod.PayPeriodDisplay}}.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">Cancel</a>\n\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.back()" ng-if="formOptions.canGoBack">Back</a>\n\n\t\t<submit-button disable-button="!workDurationsForm.$valid" display-text="formOptions.primaryButtonText" state="workDurationsForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/admin/companySettings/workflow/companySettingsWorkflowForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Enable Workflow -->\n<form name="enableWorkflowForm" ng-submit="enableWorkflow(vm, enableWorkflowForm)" class="fadeIn" ng-if="pageState === \'enable-workflow\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Ready to set up collaborators for your payroll process?">\n\t\t<fs-main>\n\t\t\t<p class="s">Assign a collaborator and set a deadline for each stage of the payroll process. Then decide when you wish to start working collaboratively. A workflow set up task will be created in your \u2018My tasks\u2019 page so you can easily come back and continue set up at any point until you start workflow.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Continue\'" state="enableWorkflowForm.state" disable-button="!enableWorkflowForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Disable Workflow -->\n<form name="disableWorkflowForm" ng-submit="disableWorkflow(vm, disableWorkflowForm)" class="fadeIn" ng-if="pageState === \'disable-workflow\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you sure you wish to disable workflow?">\n\t\t<fs-main>\n\t\t\t<p class="s">Your existing workflow settings will be removed and, if you decide to enable workflow for {{formOptions.company.Name}} again later, you will need to add them again. Click &lsquo;Disable&rsquo; to continue.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Disable\'" state="disableWorkflowForm.state" disable-button="!disableWorkflowForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Workflow disabled -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Workflow has been disabled" ng-if="pageState === \'workflow-disabled\'">\n\t<fs-main>\n\t\t<p class="s">You have successfully disabled workflow for {{formOptions.company.Name}}.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Stop Workflow -->\n<form name="disableWorkflowForm" ng-submit="stopWorkflow(vm, disableWorkflowForm)" class="fadeIn" ng-if="pageState === \'stop-workflow\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="You are about to stop workflow">\n\t\t<fs-main>\n\t\t\t<p class="s">Stopping workflow will turn off reminders and notifications and collaborators will no longer be able to sign off each stage of the payroll process. Collaborators will still have access to the {{formOptions.company.Name}} payroll as administrators but they will no longer receive automated notifications related to the payroll process.</p>\n\t\t\t<p class="s">If you are looking to delete this workflow completely, click the \'Disable workflow\' link in the Workflow settings page.</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Stop workflow\'" state="disableWorkflowForm.state" disable-button="!disableWorkflowForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Workflow stopped -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Workflow has stopped" ng-if="pageState === \'workflow-stopped\'">\n\t<fs-main>\n\t\t<p class="s">You have successfully stopped workflow for {{formOptions.company.Name}}.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Start workflow -->\n<form name="startWorkflowForm" ng-submit="startWorkflow(vm, startWorkflowForm)" class="fadeIn" ng-if="pageState === \'start-workflow\'" novalidate>\n\n\t<form-state form-options="formOptions" fs-show-close="false" fs-title="Are you ready to start collaborating?">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="s">When you start Workflow all of the stages and deadlines will become active and collaborators will start to receive reminders and notifications. Deadlines that have passed will be ignored and marked as complete and the workflow for this pay period will start today.</p>\n\t\t\t\t<p class="s" ng-if="vm.activeWorkflowTemplateEntry">Once you click &lsquo;Start workflow&rsquo; the first notification will be sent for the following step:</p>\n\t\t\t</div>\n\t\t\t<info-block ib-theme="primary has-icon has-border" ng-if="vm.activeWorkflowTemplateEntry">\n\t\t\t\t<ib-header>\n\t\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t\t<i class="icon-workflow-alt primary info-block-icon"></i>\n\t\t\t\t\t\t<h6 class="stronger">{{vm.activeWorkflowTemplateEntry.Title}}</h6>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t<profile-card name="vm.activeWorkflowTemplateEntry.Actioner" avatar-size="is-small" meta="vm.activeWorkflowTemplateEntry.CompanyName" theme="is-primary"></profile-card>\n\t\t\t\t</ib-header>\n\t\t\t\t<ib-main>\n\t\t\t\t\t<div class="spacer xs"></div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<i class="icon-clock"></i>&nbsp;&nbsp;\n\t\t\t\t\t\tDue:&nbsp;<ng-pluralize count="vm.activeWorkflowTemplateEntry.DueDaysConstant" when="{\'1\': \'1 day\', \'other\': \'{} days\'}"></ng-pluralize>&nbsp;{{vm.activeWorkflowTemplateEntry.IsAfterPayDay ? \'after\' : \'before\' }} pay date at {{vm.activeWorkflowTemplateEntry.DueTimeHour}}:{{vm.activeWorkflowTemplateEntry.DueTimeMinutes | fixedLength:2}}\n\t\t\t\t\t</p>\n\t\t\t\t</ib-main>\n\t\t\t</info-block>\n\t\t</fs-main>\n\t</form-state>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Start workflow\'" state="startWorkflowForm.state" disable-button="!startWorkflowForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Workflow started -->\n<form-state form-options="formOptions" fs-icon="tick" fs-title="Workflow has started" ng-if="pageState === \'workflow-started\'">\n\t<fs-main>\n\t\t<p class="s">You have successfully started workflow for {{formOptions.company.Name}}.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Due dates in the past-->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Please bring payroll up to date" ng-if="pageState === \'due-dates-in-past\'">\n\t<fs-main>\n\t\t<p class="is-small">Please note that at least one of the step deadlines needs to be in the future before you can start workflow. You need to bring payroll up to date before starting workflow.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/admin/companySettings/auto-apply-tax-refunds/companySettingsAutoApplyTaxRefundsForm.html','<form name="companySettingsAutoApplyTaxRefundsForm" ng-submit="updateUserAgencyProfileTaxRefund(autoApplyTaxRefund, companySettingsAutoApplyTaxRefundsForm)" class="fadeIn" novalidate>\n\n\t<fieldset>\n\t\t<div class="form-field">\n\t\t\t<settings-row sr-field-name="userAgencyProfileTaxRefund" sr-icon="tax-code-change" sr-theme="secondary" ng-model="autoApplyTaxRefund">\n\t\t\t\t<sr-label>Auto apply tax refunds</sr-label>\n\t\t\t\t<sr-description ng-if="autoApplyTaxRefund">Turning off \'Auto apply tax refunds\' means that when a team member has zero pay and they\'re due a tax refund, it won\'t be automatically applied to payroll.</sr-description>\n\t\t\t\t<sr-description ng-if="!autoApplyTaxRefund">Turning on \'Auto apply tax refunds\' means that when a team member has zero pay and they\'re due a tax refund, it will be automatically applied to payroll.</sr-description>\n\t\t\t</settings-row>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="companySettingsAutoApplyTaxRefundsForm.state" disable-button="!companySettingsAutoApplyTaxRefundsForm.$valid"></submit-button>\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/basic/company-settings-basic.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsBasicForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.saveCompanyBasicDetails($ctrl, companySettingsBasicForm)" novalidate>\n\t<fieldset ng-if="$ctrl.companyIsPayrollOrBureau">\n\n\t\t<!-- Company name -->\n\t\t<div class="form-field">\n\t\t\t<label for="companyName" class="required">Company name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="companyName" name="companyName" ng-model="$ctrl.company.CompanyName" ng-pattern="$root.REGEX.companyName" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.companyName.$touched" ng-messages="companySettingsBasicForm.companyName.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a company name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Display pay frequency -->\n\t\t<div class="form-field" ng-if="$ctrl.company.CompanyType !== $ctrl.INTERFACE_TYPES.bureau">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="displayPayFrequency" label-text="\'Add pay frequency to company display name\'" name="displayPayFrequency" ng-model="$ctrl.company.DisplayPayFrequency" type="checkbox">\n\t\t\t</div>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="s">\n\t\t\t\t\tA pay frequency label will be added to end of the company name (e.g. ACME Company - Monthly) for display purposes\n\t\t\t\t\tin the system. This won&rsquo;t appear on any documents such as Payslips and P45\u2019s however.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Industry sectors -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="industrySectors">Primary industry sector:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select data-cy="industry-sectors-dropdown" id="industrySectors" name="industrySectors" ng-change="$ctrl.formatIndustrySectorDescription($ctrl.company.IndustrySectorID)" ng-model="$ctrl.company.IndustrySectorID" ng-options="sector.IndustrySectorID as sector.CategoryName for sector in $ctrl.industrySectors">\n\t\t\t\t\t<option value="">Select an industry sector\u2026</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-field-footer" data-cy="industry-sector-description">\n\t\t\t\t<bullet-list bl-theme="is-small is-primary" ng-if="$ctrl.company.IndustrySectorID">\n\t\t\t\t\t<bl-items>\n\t\t\t\t\t\t<li class="bullet-list_item" ng-repeat="description in $ctrl.industrySectorDescription track by $index">\n\t\t\t\t\t\t\t<p class="is-small is-font-greyscale-300" data-cy="industry-sector-description">\n\t\t\t\t\t\t\t\t{{description}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</bl-items>\n\t\t\t\t</bullet-list>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Address Lookup -->\n\t\t<div class="form-field">\n\t\t\t<address-lookup address="$ctrl.company.Address" is-company-address="true"></address-lookup>\n\t\t</div>\n\n\t\t<!-- Telephone -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="phoneNumber">Telephone:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input class="l" id="phoneNumber" name="phoneNumber" ng-model="$ctrl.company.Contact.Phone" ng-pattern="$root.REGEX.numbersOnly" placeholder="01234567890" type="text">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.phoneNumber.$touched" ng-messages="companySettingsBasicForm.phoneNumber.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Only numbers are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Website -->\n\t\t<div class="form-field">\n\t\t\t<label for="website">Company website:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="website" name="website" ng-model="$ctrl.company.Website" type="text">\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset ng-if="!$ctrl.companyIsPayrollOrBureau">\n\n\t\t<!-- Group name -->\n\t\t<div class="form-field">\n\t\t\t<label for="companyName" class="required">Group name:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input id="companyName" name="companyName" ng-model="$ctrl.company.CompanyName" ng-pattern="$root.REGEX.companyName" required type="text">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.companyName.$touched" ng-messages="companySettingsBasicForm.companyName.$error" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a group name</p>\n\t\t\t\t<p ng-message="pattern">Only letters, numbers, ampersands, apostrophes &amp; hyphens are allowed</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Organisation already linked warning -->\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && $ctrl.isLinkedToOrganisation">\n\t\t\t<note note-icon="icon-tick" note-theme="success" note-title="Access Evo feature enabled">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">This group is currently connected to the \'{{$ctrl.linkedOrganisationName}}\' Access Evo organisation.<br>\n\t\t\t\t\tYou will need to contact Support if you wish to change this.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t\t<!-- Evo features radio cards-->\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation">\n\t\t\t<label class="required">Do you wish to enable Evo features for this group?</label>\n\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t<div class="radio-card">\n\t\t\t\t\t<input class="b radio-card-input" id="enableEvoFeaturesNo" name="enableEvoFeatures" ng-model="$ctrl.companyGroup.enableEvoFeatures" ng-value="false" required type="radio" ng-init="$ctrl.companyGroup.enableEvoFeatures = false">\n\t\t\t\t\t<label class="radio-card-label" for="enableEvoFeaturesNo">\n\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="radio-card">\n\t\t\t\t\t<input class="b radio-card-input" id="enableEvoFeaturesYes" name="enableEvoFeatures" ng-model="$ctrl.companyGroup.enableEvoFeatures" ng-value="true" required type="radio">\n\t\t\t\t\t<label class="radio-card-label" for="enableEvoFeaturesYes">\n\t\t\t\t\t\t<span class="radio-card-option-text">\n\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Different Customer Codes Warning -->\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && !$ctrl.haveCommonCustomerCode">\n\t\t\t<note note-icon="icon-warning" note-theme="warning" note-title="Unable to Link to Evo Organisation">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">This group cannot be linked to an Access Evo organisation because the companies within this group have different customer codes. All companies in a group must have the same customer code to be linked to an Evo organisation.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && $ctrl.haveCommonCustomerCode">\n\t\t\t<p class="is-small">\n\t\t\t\tSelect the Access Evo organisation you wish to link below. This will enable Evo features for admins of this company group.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && $ctrl.haveCommonCustomerCode">\n\t\t\t<p class="is-small">\n\t\t\t\tPlease ensure that you want all companies in this group to share the same customer code. If you don\'t, then do not connect this group to an Access Evo organisation. Once you click \'Save\', companies will be automatically added to this group based on the organisation you select below.\n\t\t\t</p>\n\t\t</div>\n\t\t<!-- Organization Selection -->\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && $ctrl.haveCommonCustomerCode">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="workspaceOrganizations" class="required">Access Evo Organisation:</label>\n\t\t\t</header>\n\t\t\t<div class="field">\n\t\t\t\t<select name="workspaceOrganizations" id="workspaceOrganizations" class="l" ng-model="$ctrl.selectedOrganization" ng-options="option.OrganisationID as option.OrganisationName for option in $ctrl.organizations" ng-change="$ctrl.setupSelectedOrganization($ctrl.selectedOrganization)" required>\n\t\t\t\t\t<option value="">Select an Access Evo Organisation</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="companySettingsBasicForm.workspaceOrganizations.$error" ng-show="companySettingsBasicForm.workspaceOrganizations.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please select an Access Evo Organisation</p>\n\t\t\t</div>\n\t\t\t<div class="form-field-footer" ng-if="$ctrl.organizations.length === 0">\n\t\t\t\t<p class="s">No Access Evo organisations with matching customer code are available. Only organisations with the same customer code as the companies in this group can be selected.</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- Organization Warning note -->\n\t\t<div class="form-field" ng-if="$ctrl.IsGroupCreationFeatureEnabled && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && $ctrl.haveCommonCustomerCode && $ctrl.selectedOrganization">\n\t\t\t<note note-theme="tertiary" note-icon="icon-warning">\n\t\t\t\t<note-content>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<p class="s">You\'re about to connect this company group to \'{{$ctrl.getSelectedOrganizationName($ctrl.selectedOrganization)}}\' Access Evo organisation. If you select the wrong organisation and click \'Save\', then you will need to contact Support if you wish to change it.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="note-section">\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<input checkbox id="confirmCorrectOrganization" label-text="\'I confirm this is the correct Access Evo organisation\'" ng-model="$ctrl.companyGroup.confirmCorrectOrganization" type="checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top" ng-if="$ctrl.companyIsPayrollOrBureau">\n\t\t<div class="form-intro">\n\t\t\t<h4>Payroll support contact</h4>\n\t\t\t<p class="s">We suggest adding details for the best person to contact for any payroll related queries.</p>\n\t\t</div>\n\n\t\t<!-- Main Contact Name -->\n\t\t<section class="form-field-group">\n\n\t\t\t<!-- First Name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="forename">First name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="forename" minlength="2" name="forename" ng-model="$ctrl.company.Contact.Forename" ng-pattern="$root.REGEX.name" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.forename.$touched" ng-messages="companySettingsBasicForm.forename.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">First name can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t\t<p ng-message="minlength">First name needs to contain more than 1 letter</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Last name -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="surname">Last name:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<input id="surname" name="surname" ng-model="$ctrl.company.Contact.Surname" ng-pattern="$root.REGEX.name" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.surname.$touched" ng-messages="companySettingsBasicForm.surname.$error" role="alert">\n\t\t\t\t\t<p ng-message="pattern">Last names can only contain letters, apostrophes and hyphens</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Email address -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="email">Email address:</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="email" name="email" ng-model="$ctrl.company.Contact.EmailAddress" ng-pattern="$root.REGEX.email" placeholder="{{$root.PLACEHOLDERS.email}}" type="text">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.email.$touched" ng-messages="companySettingsBasicForm.email.$error" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid email address</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top" ng-if="$ctrl.companyIsPayrollOrBureau && $ctrl.customerCodeEnabled">\n\n\t\t<!-- Access Evo -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Access Evo</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="s" data-cy="customer-code-required-message">\n\t\t\t\t\tEnter a customer code so we can verify it with Access Dimensions. If the organisation doesn\'t look correct,\n\t\t\t\t\tyou may need to enter a different code. Once a code has been saved you\'ll need to contact support if you wish to change it.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Customer code -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="customerCode">Customer code:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l" data-cy="customer-code-input" id="customerCode" name="customerCode" ng-change="$ctrl.resetVerificationState()" ng-disabled="$ctrl.isCustomerCodeLocked || $ctrl.verificationState === \'verifying\'" ng-maxlength="15" ng-model="$ctrl.company.CustomerCode" ng-pattern="$root.REGEX.customerCode" type="text">\n\t\t\t\t<button class="button-compact" data-cy="customer-code-verify-button" ng-click="$ctrl.verifyCustomerCode($ctrl.company)" ng-disabled="!$ctrl.company.CustomerCode || $ctrl.verificationState === \'verifying\' || $ctrl.isCustomerCodeLocked" ng-hide="true" type="button">\n\t\t\t\t\tVerify\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<p class="form-message" data-cy="customer-code-max-char-number">\n\t\t\t\t{{$ctrl.isCustomerCodeLocked ? \'Please contact support if you need to change your customer code.\' : \'Max. 15 characters.\'}}\n\t\t\t</p>\n\n\t\t\t<div class="form-errors fadeIn" ng-if="companySettingsBasicForm.customerCode.$touched" ng-messages="companySettingsBasicForm.customerCode.$error" role="alert">\n\t\t\t\t<p data-cy="customer-code-max-length-message" ng-message="maxlength">Enter a maximum of 15 characters</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.verificationState === \'verifying\'">\n\t\t\t<circle-loader></circle-loader>\n\t\t\t<span class="s ml-1">Verifying customer code...</span>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.verificationState === \'invalid\' || $ctrl.verificationState === \'error\'">\n\t\t\t<message-block theme="assertive is-inline" has-drop-in="false">\n\t\t\t\t<p>\n\t\t\t\t\t<i class="icon-warning is-medium is-assertive has-margin-right"></i>\n\t\t\t\t\t<span>Valid code not found. Please check you\'ve entered it correctly.</span>\n\t\t\t\t</p>\n\t\t\t</message-block>\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.verificationState === \'valid\'">\n\t\t\t<message-block theme="secondary is-inline" has-drop-in="false">\n\t\t\t\t<p>\n\t\t\t\t\t<i class="icon-tick is-medium is-secondary has-margin-right"></i>\n\t\t\t\t\t<span>Valid code found: {{$ctrl.company.customerCodeCompanyName}}</span>\n\t\t\t\t</p>\n\t\t\t</message-block>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="companySettingsBasicForm.state === \'saved\'" state="companySettingsBasicForm.state">\n\t\t\t<p>This information has been saved</p>\n\t\t</form-feedback>\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" data-cy="secondary-action-back" href="" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!companySettingsBasicForm.$valid ||\n\t\t\t($ctrl.IsGroupCreationFeatureEnabled && !$ctrl.companyIsPayrollOrBureau && !$ctrl.isLinkedToOrganisation && $ctrl.companyGroup.enableEvoFeatures && (!$ctrl.haveCommonCustomerCode || (!$ctrl.selectedOrganization || !$ctrl.companyGroup.confirmCorrectOrganization)))" display-text="$ctrl.formOptions.primaryButtonText" state="companySettingsBasicForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/payroll/maternityPay/advanceMaternityFunding/advanceMaternityFundingForm.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="advanceMaternityFundingForm" ng-if="pageState === \'ready\'" ng-submit="updateTeamMemberMaternityAdvanceFunding(maternityPay, advanceMaternityFundingForm)" novalidate>\n\n\t<div class="form-intro" ng-if="maternityPay.AdvanceFunding.length > 1">\n\t\t<p class="s" ng-if="maternityPay.AdvanceFunding.length > 1">As {{formOptions.context.Forename}}\'s maternity leave will be split across this and next tax year, the amount of advance funding you receive may change. You\'ll receive a notification of the new amount from HMRC near the end of this tax year. If you already know both amounts enter them below or update {{formOptions.context.Forename}}\'s profile later.</p>\n\t\t<p class="s" ng-if="maternityPay.AdvanceFunding.length === 1">Enter the Advance Funding amount below or you can update {{formOptions.context.Forename}}\'s profile later.</p>\n\t</div>\n\n\t<fieldset class="fadeIn" ng-if="maternityPay.AdvanceFunding.length">\n\n\t\t<!-- Advance funding amounts -->\n\t\t<div class="form-field" ng-repeat="(paymentIndex, payment) in maternityPay.AdvanceFunding">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="advanceFundingCurrent{{paymentIndex}}" ng-class="{\'required\':paymentIndex === 0}">Advance funding amount ({{payment.TaxYearDisplay}}):</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input name="advanceFundingCurrent{{paymentIndex}}" type="number" id="advanceFundingCurrent{{paymentIndex}}" maxlength="10" class="monetise xl" ng-model="payment.PaymentAmount" ng-pattern="$root.REGEX.decimal" placeholder="0.00" ng-required="paymentIndex === 0">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="advanceMaternityFundingForm[\'advanceFundingCurrent\' + paymentIndex].$error" ng-if="advanceMaternityFundingForm[\'advanceFundingCurrent\' + paymentIndex].$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t<p ng-message="pattern">Amount should be 1p or greater</p>\n\t\t\t\t<p ng-message="maxlength">Maximum of 10 digits</p>\n\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="formOptions.primaryButtonText" state="advanceMaternityFundingForm.state" disable-button="!advanceMaternityFundingForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n\n<form-state form-options="formOptions" fs-icon="warning" fs-title="Unable to add Advance funding" ng-if="pageState === \'unable-to-add\'">\n\t<fs-main>\n\t\t<p class="s">Advance funding can no longer be applied to this schedule.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setComponentState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="pageState === \'error\'" secondary-action="formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/pension/scheme/authorise-nest/pension-scheme-authorise-nest.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemeAuthoriseNestForm" ng-submit="$ctrl.authoriseNestPension($ctrl, pensionSchemeAuthoriseNestForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">Enter your NEST sign in details below and click \u2018Authorise\u2019. Make sure the details you enter exactly match those you use to sign in to the pension portal on the NEST website.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Username -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="nestUsername" class="required">Username</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="nestUsername" class="xl" name="nestUsername" type="text" ng-model="$ctrl.username" required autocomplete="authorise-nest-un">\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeAuthoriseNestForm.nestUsername.$error" ng-if="pensionSchemeAuthoriseNestForm.nestUsername.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a username</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Password -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="nestPassword" class="required">Password</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<div class="password-toggle">\n\t\t\t\t\t<input id="nestPassword" class="xl" name="nestPassword" type="{{$ctrl.passwordInputType ? $ctrl.passwordInputType : \'text\'}}" ng-model="$ctrl.password" required autocomplete="authorise-nest-pw">\n\t\t\t\t\t<a href="" ng-click="$ctrl.togglePasswordInputType($ctrl)" class="password-toggle-action">\n\t\t\t\t\t\t<i class="icon-{{$ctrl.passwordInputType === \'password\' ? \'hidden\' : \'visible\'}} m"></i>&nbsp;&nbsp;{{$ctrl.passwordInputType === \'password\' ? \'Show\' : \'Hide\'}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</main>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeAuthoriseNestForm.nestPassword.$error" ng-if="pensionSchemeAuthoriseNestForm.nestPassword.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a password</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Note: Locked Nest accounts -->\n\t<div class="form-content-block">\n\t\t<note note-title="Locked NEST accounts" note-theme="indifferent" note-icon="icon-support">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">For security reasons, your online NEST account is automatically locked when you enter incorrect sign in details more than three times.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Authorise\'" state="pensionSchemeAuthoriseNestForm.state" disable-button="!pensionSchemeAuthoriseNestForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Invalid credentials -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" class="fadeIn" fs-title="Your sign in details weren\'t recognised" ng-if="$ctrl.pageState === \'invalid-credentials\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to authorise your pension because your sign in details weren\u2019t recognised. Click &lsquo;back&rsquo; to try again and make sure the details you enter exactly match those you use to access your pension portal on the NEST website.</p>\n\n\t\t<!-- Note: Locked Nest accounts -->\n\t\t<div class="form-content-block">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="stronger"><i class="icon-support indifferent m"></i> Locked NEST accounts</h6>\n\t\t\t\t<p class="s">For security reasons, your online NEST account is automatically locked when you enter incorrect sign in details more than three times.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Invalid Employer Reference -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" class="fadeIn" fs-title="Your Employer Reference appears incorrect" ng-if="$ctrl.pageState === \'invalid-employer-reference\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to authorise your pension because your Employer Reference number appears incorrect. You\'ll need to go and check your Employer Reference number before being able to authorise the pension.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" class="fadeIn" fs-title="Your account has been authorised" ng-if="$ctrl.pageState === \'success\'">\n\t<fs-main>\n\t\t<p class="s">Your pension has now been authorised and Paycircle will update any information that may have changed while it was in an unauthorised state.</p>\n\t</fs-main>\n</form-state>\n\n<!-- No Access -->\n<form-state form-options="$ctrl.formOptions" fs-theme="tertiary" class="fadeIn" fs-title="Your account doesn\'t have access to this pension" ng-if="$ctrl.pageState === \'no-access\'">\n\t<fs-main>\n\t\t<p class="s">The account with the sign in details you\u2019ve entered doesn\u2019t have access to this pension. Click \u2018back\u2019 to try again and make sure the sign in details you enter exactly match those you use to access your pension portal on the NEST website.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Locked -->\n<form-state form-options="$ctrl.formOptions" fs-theme="tertiary" class="fadeIn" fs-title="Your NEST account is locked" ng-if="$ctrl.pageState === \'account-locked\'">\n\t<fs-main>\n\t\t<p class="s">We were unable to authorise your pension because your NEST account is locked. You can expect to receive an unlock account code from NEST within one hour, to your email address registered with NEST.</p>\n\t\t<p class="s">If you think you\u2019ve used the wrong sign in details, click &lsquo;back&rsquo; to try a different set.</p>\n\n\t\t<!-- Note: Locked Nest accounts -->\n\t\t<div class="form-content-block">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="stronger"><i class="icon-support indifferent m"></i> Locked NEST accounts</h6>\n\t\t\t\t<p class="s">For security reasons, your online NEST account is automatically locked when you enter incorrect sign in details more than three times.</p>\n\t\t\t</div>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<!-- General Error -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" class="fadeIn" fs-title="Unable to authorise at this time" ng-if="$ctrl.pageState === \'general-error\'">\n\t<fs-main>\n\t\t<p class="s">We are unable to authorise your pension at this time and suggest you try again in a few moments. If the problem persists or you have any questions please contact support</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/pension/scheme/authorise-peoples-pension/pension-scheme-authorise-peoples-pension.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.loading"></loading-block>\n\n<form name="pensionSchemeAuthorisePeoplesPensionForm" ng-submit="$ctrl.authorisePeoplesPension($ctrl, pensionSchemeAuthorisePeoplesPensionForm)" class="fadeIn" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.ready" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Connect to People\'s Pension</h4>\n\t\t<p class="s">By clicking &lsquo;Authorise&rsquo; you will be redirected to the People\'s Pension website where you will need to sign in to give Paycircle authorisation to connect to your pension.</p>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Authorise\'" state="pensionSchemeAuthorisePeoplesPensionForm.state" disable-button="!pensionSchemeAuthorisePeoplesPensionForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Authorising -->\n<form-state form-options="$ctrl.formOptions" fs-icon="clock" fs-show-close="false" class="fadeIn" fs-title="Awaiting authorisation" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.awaitingAuthorisation">\n\t<fs-main>\n\t\t<p class="s">Once Paycircle has been authorised to connect to your People\'s Pension click &lsquo;Finish&rsquo; and your pension details will be refreshed to complete your authorisation.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setPageState($ctrl.PAGE_STATES.ready)">Back</a>\n\t\t<button class="tertiary primary-action" ng-click="$ctrl.closeForm()">Finish</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Authorised -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" class="fadeIn" fs-title="Your account has been authorised" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s">Your pension has now been authorised and Paycircle will update any information that may have changed while it was in an unauthorised state.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Connect error -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to establish People\'s Pension connection" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connectError">\n\t<fs-main>\n\t\t<p class="s">We\'re unable to establish a connection to People\'s Pension at this time. Please try again in a few moments. If the problem persists please contact support.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/authorise-smart/pension-scheme-authorise-smart.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.loading"></loading-block>\n\n<form name="pensionSchemeAuthoriseSmartForm" ng-submit="$ctrl.authoriseSmartPension($ctrl, pensionSchemeAuthoriseSmartForm)" class="fadeIn" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.ready" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Connect to Smart Pension</h4>\n\t\t<p class="s">Tell us if you\'re an admin working at {{$ctrl.formOptions.company.Name}} or an advisor working on their behalf then click \'Next\'. We\'ll check your details and direct you to connect to Smart Pension.</p>\n\t</div>\n\n\t<!-- Smart Connection -->\n\t<fieldset>\n\n\t\t<!-- Radio Cards -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label>Who are you?</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<div class="radio-cards">\n\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="roleType" id="roleTypeEmployer" class="radio-card-input" ng-value="$ctrl.SMART_PENSION_ROLES.employer" ng-model="$ctrl.smartRoleType" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="roleTypeEmployer">\n\t\t\t\t\t\t\t<i class="icon-company radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">I\'m an employer</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t<input type="radio" name="roleType" id="roleTypeAdvisor" class="radio-card-input" ng-value="$ctrl.SMART_PENSION_ROLES.advisor" ng-model="$ctrl.smartRoleType" required>\n\t\t\t\t\t\t<label class="radio-card-label" for="roleTypeAdvisor">\n\t\t\t\t\t\t\t<i class="icon-user radio-card-icon"></i>\n\t\t\t\t\t\t\t<p class="radio-card-text">I\'m an advisor</p>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="note indifferent">\n\t\t\t\t<h6 class="stronger"><i class="icon-information indifferent m"></i>&nbsp;&nbsp;Authorising your Smart Pension</h6>\n\t\t\t\t<p class="s">By clicking \'Authorise\' you will be redirected to the Smart Pension website where you have to sign in to give Paycircle authorisation to connect to your pension.</p>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Authorise\'" state="pensionSchemeAuthoriseSmartForm.state" disable-button="!pensionSchemeAuthoriseSmartForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Authorising -->\n<form-state form-options="$ctrl.formOptions" fs-icon="clock" fs-show-close="false" class="fadeIn" fs-title="Awaiting authorisation" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.awaitingAuthorisation">\n\t<fs-main>\n\t\t<p class="s">Once Paycircle has been authorised to connect to your Smart Pension click \'Finish\' and your pension details will be refreshed to complete your authorisation.</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.setPageState($ctrl.PAGE_STATES.ready)">Back</a>\n\t\t<button class="tertiary primary-action" ng-click="$ctrl.formOptions.closeForm()">Finish</button>\n\t</fs-actions>\n</form-state>\n\n<!-- Authorised -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-theme="positive" class="fadeIn" fs-title="Your account has been authorised" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="s">Your pension has now been authorised and Paycircle will update any information that may have changed while it was in an unauthorised state.</p>\n\t</fs-main>\n</form-state>\n\n<!-- Connect error -->\n<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="Unable to establish Smart Pension connection" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.connectError">\n\t<fs-main>\n\t\t<p class="s">We\'re unable to establish a connection to Smart Pension at this time. Please try again in a few moments. If the problem persists please contact support.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/automation/pension-scheme-automation.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemeAutomationForm" class="fadeIn" ng-submit="$ctrl.reviewConfirmation($ctrl, pensionSchemeAutomationForm)" novalidate ng-if="$ctrl.pageState === \'ready\'">\n\n\t<div class="form-intro">\n\t\t<h4>Automation options</h4>\n\t\t<p class="s">Paycircle can automate many of your workplace pension management tasks. Use the toggle options below to manage your workplace pension automation settings.</p>\n\t</div>\n\n\t<div class="form-field" ng-if="$ctrl.pension.PensionAutomationDetails.PensionProviderHasAPI">\n\t\t<note note-title="Looking to connect directly to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}}?" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">\n\t\t\t\t\tIf you\u2019d like to connect directly to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}}, and this isn\u2019t a brand new pension, it\u2019s critical you check that the information in your {{$ctrl.pension.PensionProviderDetails.PensionProviderName}} portal is up to date. This should ensure that your pension submissions don\'t fail. We recommend you check the following:\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\'All enrolments that have occurred before your current pay period are up to date\',\n\t\t\t\t\t\t\t\'All contributions that have been paid before your current pay period are up to date\',\n\t\t\t\t\t\t\t\'All team members who have opted out or ceased membership before your current period are up to date\',\n\t\t\t\t\t\t\t\'Your pension period dates are the same as those in your provider portal\'\n\t\t\t\t\t\t]" bl-theme="is-indifferent greyscale-darkened is-spaced-out"></bullet-list>\n\t\t\t\t</p>\n\t\t\t\t<p class="s">\n\t\t\t\t\tFor more information, read our\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionSubmissionTroubleshooting" theme="indifferent" underline="true">troubleshooting guide to pension submissions</support-article-link>\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Note: Policy-based schemes -->\n\t<div class="form-field" ng-if="$ctrl.pension.PensionPolicyDetails.UsePensionPolicy">\n\t\t<note note-title="Direct connection for policy-based schemes" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true" note-dismiss-key="pension-automation-form-2">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">This scheme was set up to use a pension policy. If you wish to connect to your provider directly you will need to delete this scheme and set up a new one that uses pension groups instead of a pension policy.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\n\t\t\t<div class="settings-rows">\n\n\t\t\t\t<!-- Team Assessment -->\n\t\t\t\t<settings-row ng-model="$ctrl.pension.PensionAutomationDetails.AssessTeam" on-update="$ctrl.onAssessTeamChange($ctrl.pension)" sr-disabled="!$ctrl.pension.PensionAutomationDetails.CanUpdateTeamAssessment" sr-field-name="assessTeam" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Team assessment</sr-label>\n\t\t\t\t\t<sr-description>Automatic team assessment comes as standard. Paycircle will assess your team each time you run payroll and automatically enrol anyone who becomes eligible.</sr-description>\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Connect directly -->\n\t\t\t\t<settings-row ng-if="$ctrl.pension.PensionAutomationDetails.PensionProviderHasAPI" ng-model="$ctrl.pension.PensionAutomationDetails.ConnectToProvider" sr-disabled="!$ctrl.pension.PensionAutomationDetails.AssessTeam || !$ctrl.pension.PensionAutomationDetails.CanConnectToProvider" sr-field-name="connectToProvider" sr-theme="secondary" on-update="$ctrl.onConnectToProviderChange()">\n\t\t\t\t\t<sr-label>Connect directly to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}}</sr-label>\n\t\t\t\t\t<sr-description>Paycircle will send your pension data directly to your pension provider and receive updates, such as opt in and opt out notices and information regarding pension group changes.</sr-description>\n\n\t\t\t\t\t<!-- Employer Pension Scheme Reference -->\n\t\t\t\t\t<sr-content ng-if="($ctrl.pension.PensionAutomationDetails.ConnectToProvider && !$ctrl.connectToProviderOriginal) && !$ctrl.isReferenceValid">\n\t\t\t\t\t\t<p class="is-small">Your employer pension scheme reference is in the wrong format for {{$ctrl.pension.PensionProviderDetails.PensionProviderName}}. Please enter the correct format in order to enable the direct connection.</p>\t\t\t\t\t\n\t\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t\t<legend hidden>pension scheme employer reference field</legend>\n\t\t\t\t\t\t\t<pension-scheme-employer-reference-field connect-to-provider="$ctrl.pension.PensionAutomationDetails.ConnectToProvider" employer-reference="$ctrl.pension.PensionSettingDetails.EmployerReference" pension-provider-id="$ctrl.pension.PensionProviderDetails.PensionProviderID" pension-type="$ctrl.pension.PensionSettingDetails.PensionType"></pension-scheme-employer-reference-field>\n\t\t\t\t\t\t</fieldset>\n\t\t\t\t\t</sr-content>\t\t\t\t\n\t\t\t\t</settings-row>\n\n\t\t\t\t<!-- Send pension comms -->\n\t\t\t\t<settings-row ng-model="$ctrl.pension.PensionAutomationDetails.SendCommunications" sr-disabled="$ctrl.formOptions.company.IsClone" sr-field-name="sendCommunications" sr-theme="secondary">\n\t\t\t\t\t<sr-label>Send pension status communications</sr-label>\n\t\t\t\t\t<sr-description>Paycircle will automatically send pension related communications to all of your team members via email and store them in your communications centre - keeping you compliant at all times.</sr-description>\n\t\t\t\t</settings-row>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Manual tasks -->\n\t<fieldset class="fadeIn" ng-if="($ctrl.pension.PensionAutomationDetails.PensionProviderHasAPI && !$ctrl.pension.PensionAutomationDetails.ConnectToProvider) || !$ctrl.pension.PensionAutomationDetails.SendCommunications">\n\t\t<legend hidden>Manual tasks</legend>\n\t\t<div class="form-intro">\n\t\t\t<h6 class="stronger">Manual pension tasks</h6>\n\t\t\t<p class="s">Turning off automation options means that you will need to manage those tasks manually.</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="task-overview-blocks">\n\t\t\t\t<div class="task-overview-block secondary" ng-if="!$ctrl.pension.PensionAutomationDetails.AssessTeam">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Team assessment - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage the statuses of your team members manually</p>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleShowOverviewDetailsTeam($ctrl)" class="task-overview-block-action">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 4 tasks <i class="icon-chevron-{{$ctrl.showOverviewDetailsTeam ? \'up\' : \'down\'}}"></i></a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="$ctrl.showOverviewDetailsTeam">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Team members will not be assessed for auto-enrolment and re-enrolment so you will need to keep their pension statuses up-to-date in the respective pension or in the pension area in their profile.\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="task-overview-block secondary" ng-if="$ctrl.pension.PensionAutomationDetails.PensionProviderHasAPI && !$ctrl.pension.PensionAutomationDetails.ConnectToProvider">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Connect directly to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}} - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage the synchronisation of your payroll and pension manually</p>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleShowOverviewDetailsConnect($ctrl)" class="task-overview-block-action">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 4 tasks <i class="icon-chevron-{{$ctrl.showOverviewDetailsConnect ? \'up\' : \'down\'}}"></i></a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="$ctrl.showOverviewDetailsConnect">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Download pension files from Paycircle and upload them to your pension provider\\\'s portal each pay period\',\n\t\t\t\t\t\t\t\t\'Update Paycircle when someone chooses to opt in, opt out or cease membership\',\n\t\t\t\t\t\t\t\t\'Update Paycircle if your company or a team member changes their pension contribution percentages or amounts\',\n\t\t\t\t\t\t\t\t\'Update Paycircle when you set up a new workplace pension group or move team member between groups\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t\t<div class="task-overview-block secondary" ng-if="!$ctrl.pension.PensionAutomationDetails.SendCommunications">\n\t\t\t\t\t<header class="task-overview-block-header">\n\t\t\t\t\t\t<h6 class="task-overview-block-title">Send pension status communications - OFF</h6>\n\t\t\t\t\t\t<p class="task-overview-block-subtitle">Manage workplace pension communications to your team manually</p>\n\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleShowOverviewDetailsComms($ctrl)" class="task-overview-block-action">\n\t\t\t\t\t\t\t<i class="icon-clipboard"></i> 7 tasks <i class="icon-chevron-{{$ctrl.showOverviewDetailsComms ? \'up\' : \'down\'}}"></i></a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="task-overview-block-main dropIn" ng-if="$ctrl.showOverviewDetailsComms">\n\t\t\t\t\t\t<bullet-list bl-items="[\n\t\t\t\t\t\t\t\t\'Send pension assessment notices to new team members to tell them when they are going to be assessed\',\n\t\t\t\t\t\t\t\t\'Send postponement notices to new team members when they join the company - if you are using postponement for new team members\',\n\t\t\t\t\t\t\t\t\'Send change in status notices to team members each time their enrolment status changes\',\n\t\t\t\t\t\t\t\t\'Send postponement notices to team members when their enrolment status changes - if you are using postponement for team member threshold changes\',\n\t\t\t\t\t\t\t\t\'Send enrolment notices when a team member gets enrolled into a workplace pension\',\n\t\t\t\t\t\t\t\t\'Send re-enrolment assessment notices to team members when your company goes through its cyclical 3 year re-enrolment process\',\n\t\t\t\t\t\t\t\t\'Send re-enrolment notices to team members who are re-enrolled when your company goes through its cyclical 3 year re-enrolment process\'\n\t\t\t\t\t\t\t]" bl-theme="is-secondary is-spaced-out"></bullet-list>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>action buttons</legend>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="pensionSchemeAutomationForm.state" disable-button="!pensionSchemeAutomationForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm cancellation -->\n<form class="fadeIn" name="companyPensionAutomationConfirmationForm" ng-if="$ctrl.pageState === \'confirm-cancellation\'" ng-submit="$ctrl.updateCompanyPensionAutomation($ctrl, companyPensionAutomationConfirmationForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Your scheduled submission will be cancelled">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tBy turning off the direct connection to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}} the {{$ctrl.pensionSummary.PreviousPayPeriod.PayPeriodDisplay}} submission for this pension\n\t\t\t\tscheme, scheduled for {{$ctrl.pensionSummary.PensionSubmissionScheduledDateISO | datetimeformat:\'long-alt\'}}, will be cancelled and you will need to upload your pension file in your provider\n\t\t\t\tportal going forwards. This won\u2019t affect any other automated pensions schemes you may have connected. Click &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>action buttons</legend>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companyPensionAutomationConfirmationForm.$valid" display-text="\'Confirm\'" state="companyPensionAutomationConfirmationForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Confirm schedule -->\n<form class="fadeIn" name="companyPensionAutomationConfirmSchedulForm" ng-if="$ctrl.pageState === \'confirm-schedule\'" ng-submit="$ctrl.updateCompanyPensionAutomation($ctrl, companyPensionAutomationConfirmSchedulForm)" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="tertiary" fs-title="Your next submission will be automatically scheduled">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tBy turning on the direct connection to {{$ctrl.pension.PensionProviderDetails.PensionProviderName}} the {{$ctrl.pensionSummary.PreviousPayPeriod.PayPeriodDisplay}} submission for this pension\n\t\t\t\tscheme will be scheduled for {{$ctrl.pensionSummary.PensionSubmissionScheduledDateISO | datetimeformat:\'long-alt\'}}. If you\u2019ve already uploaded your pension file for\n\t\t\t\t{{$ctrl.pensionSummary.PreviousPayPeriod.PayPeriodDisplay}} in your provider portal you may wish to wait until any other automated pensions you\u2019ve connected have been submitted.\n\t\t\t\tClick &lsquo;Confirm&rsquo; if you\u2019re happy to continue.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<legend hidden>action buttons</legend>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!companyPensionAutomationConfirmSchedulForm.$valid" display-text="\'Confirm\'" state="companyPensionAutomationConfirmSchedulForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/delete/pension-scheme-delete.form.html','<!-- Delete pension -->\n<form name="pensionSchemeDeleteForm" ng-submit="$ctrl.deletePension($ctrl, pensionSchemeDeleteForm)" ng-if="$ctrl.pageState === \'ready\'">\n\t<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Are you sure you want to delete this pension?" fs-show-close="false">\n\t\t<fs-main>\n\t\t\t<div class="form-state-section">\n\t\t\t\t<p class="is-small">Any team members currently in this pension scheme will be removed if you choose to delete it, and may need to be added to another pension. Click \'Delete pension\' if you\'re happy to continue.</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Payroll changes for pension elements">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Please note that if you\'ve added payroll changes to your current period or an in-progress supplementary pay using pension-related elements, and selected this pension scheme, those changes will be deleted when you click \u2018Delete pension\u2019.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t\t<div class="form-state-section">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Sub-code overrides for journals">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">Please note that if you have any sub-code overrides in place for this pension scheme, the override code will be deleted when you click \'Delete pension\'. This won\'t affect any other pension schemes with override codes in place.</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button display-text="\'Delete pension\'" state="pensionSchemeDeleteForm.state" disable-button="!pensionSchemeDeleteForm.$valid">\n\t\t\t</submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<!-- Success -->\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Pension deleted" ng-if="$ctrl.pageState === \'success\'">\n\t<fs-main>\n\t\t<div ng-switch="$ctrl.formOptions.pension.PensionType">\n\t\t\t<p pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment" class="is-small">\n\t\t\t\tYour workplace pension has been deleted and any team members previously added to it need to be added to another pension.\n\t\t\t</p>\n\t\t\t<p pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment" class="is-small">\n\t\t\t\tYour pension scheme has been deleted and any team members previously added to it may need to be added to another pension.\n\t\t\t</p>\n\t\t</div>\n\t</fs-main>\n\t<fs-actions>\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tClose\n\t\t</a>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window">\n</error-block>\n');
$templateCache.put('forms/pension/scheme/groups/pension-scheme-groups.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemeGroupsForm" ng-submit="$ctrl.saveCompanyPensionGroups($ctrl, pensionSchemeGroupsForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate ng-switch="$ctrl.pension.PensionProviderDetails.PensionType">\n\n\t<div class="form-intro" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t<h4>Pension Groups</h4>\n\t\t<p class="is-small">Please enter the group name that has been set up on the pension provider website and set the group\'s contribution percentages. Click &lsquo;Add another group&rsquo; to add additional groups.</p>\n\t</div>\n\n\t<div class="form-intro" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t<h4>Contribution bands</h4>\n\t\t<p class="is-small">Add contribution bands so you can easily assign them to team members without having to add their contribution settings individually. Set a default band and that will be used when you add a team member to this pension. You can always add custom contribution percentages for team members.</p>\n\t</div>\n\n\t<div class="form-content-block" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t<note note-title="Minimum contributions for workplace pension compliance" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true" note-dismiss-key="company-pension-groups">\n\t\t\t<note-content>\n\t\t\t\t<p class="s">Set your contributions to match what you have set up with your pension provider. Please make sure that you do not go below the minimum contribution requirements set by The Pensions Regulator to ensure workplace pension compliance.</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Groups/Contribution bands -->\n\t<fieldset class="pension-scheme-group_wrapper">\n\t\t<pension-scheme-group pension-type="$ctrl.pension.PensionProviderDetails.PensionType" pension-groups="$ctrl.pension.PensionGroupDetails.PensionGroups" ng-repeat="group in $ctrl.pension.PensionGroupDetails.PensionGroups" index="$index" group="group" on-group-delete="$ctrl.deletePensionGroup($ctrl, $index)"></pension-scheme-group>\n\t</fieldset>\n\n\t<!-- Add group -->\n\t<div class="form-content-block" ng-if="$ctrl.pension.PensionGroupDetails.CanAddGroups">\n\t\t<button class="is-medium-large is-white is-block" ng-click="$ctrl.addNewPensionGroup($ctrl)" type="button">\n\t\t\t<span pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add another group\n\t\t\t</span>\n\t\t\t<span pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t<i class="icon-add button_icon-pre"></i>Add contribution band\n\t\t\t</span>\n\t\t</button>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="pensionSchemeGroupsForm.state" disable-button="!pensionSchemeGroupsForm.$valid"></submit-button>\n\t</fieldset>\n\n</form>\n\n<!-- Group can\'t be deleted -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-theme="tertiary" fs-title="This {{$ctrl.pension.PensionProviderDetails.PensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment ? \'contribution band\' : \'group\'}} is currently in use" ng-if="$ctrl.pageState === \'group-cant-be-deleted\'">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tYou have&nbsp;<ng-pluralize count="$ctrl.undeleteablePensionGroup.TotalInGroup" when="{\'1\': \'1 team member\', \'other\': \'{} team members\'}"></ng-pluralize>&nbsp;assigned to this {{$ctrl.pension.PensionProviderDetails.PensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment ? \'contribution band\' : \'group\'}}. Please review the Team area in your pension scheme and update the respective team members contribution settings before deleting this {{$ctrl.pension.PensionProviderDetails.PensionType === $ctrl.PENSION_TYPES.nonAutoEnrolment ? \'band\' : \'group\'}}.\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setPageState(\'ready\')">Back</button>\n\t</fs-actions>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/period/pension-scheme-period.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="pensionSchemePeriodForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updatePensionPeriod($ctrl, pensionSchemePeriodForm)" novalidate>\n\t<fieldset>\n\t\t<div class="form-content-block no-margin top">\n\t\t\t<p class="s">\n\t\t\tThe below pension period start and end dates are for the {{ $ctrl.pension.PayPeriodDisplay }} pay period.\n\t\t\tYou may need to adjust the dates below to match your pension provider and ensure your pension submissions can be made successfully.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Pension period dates -->\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Start Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="pensionPeriodStartDate">\n\t\t\t\t\t\tPension period start date:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<date-input-field field-id="pensionPeriodStartDate" field-value-iso="$ctrl.pension.PensionStartDateISO" field-on-change-fn="$ctrl.validatePensionDates($ctrl, pensionSchemePeriodForm.pensionPeriodEndDate)">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemePeriodForm.pensionPeriodStartDate.$touched" ng-messages="pensionSchemePeriodForm.pensionPeriodStartDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter the start date for the pension period\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="date">\n\t\t\t\t\t\tPlease enter a valid date, like this: dd/mm/yyyy\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field-group_divider"><i class="icon-arrow-right is-medium is-primary"></i></div>\n\t\t\t\n\t\t\t<!-- End Date -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="pensionPeriodEndDate">\n\t\t\t\t\t\tPension period end date:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<date-input-field field-id="pensionPeriodEndDate" field-read-only="!$ctrl.validationResults.IsEndDateEditable" field-on-change-fn="$ctrl.validatePensionDates($ctrl, pensionSchemePeriodForm.pensionPeriodEndDate)" field-value-iso="$ctrl.pension.PensionEndDateISO" field-min-date-iso="$ctrl.validationResults.IsEndDateEditable ? $ctrl.pension.PensionStartDateISO : $ctrl.pension.PensionEndDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemePeriodForm.pensionPeriodStartDate.$touched || pensionSchemePeriodForm.pensionPeriodStartDate.$error\n\t\t\t\t\t\t\t|| pensionSchemePeriodForm.pensionPeriodEndDate.$touched || pensionSchemePeriodForm.pensionPeriodEndDate.$error" ng-messages="pensionSchemePeriodForm.pensionPeriodEndDate.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the end date for the pension period</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\n\t\t\t\t\t<div ng-if="$ctrl.validationResults.IsEndDateEditable">\n\t\t\t\t\t\t<p ng-message="min">Please enter a date from {{$ctrl.pension.PensionStartDateISO | dateformat}}</p>\n\t\t\t\t\t\t<p ng-if="$ctrl.validationResults.IsEndDateExceeding" ng-message="isEndDateExceeding">Must be on or before {{ $ctrl.validationResults.EndDateMaxISO | dateformat }}.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Note: Check overlapping -->\n\t<div class="form-field fadeIn" ng-if="$ctrl.validationResults.IsPeriodOverlapping">\n\t\t<note note-dismiss="true" note-icon="icon-warning" note-theme="tertiary" note-title="Overlapping pension periods">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tPlease note that the dates you\'ve entered overlap with another pension period. If you are happy with this click \'Save\' to continue.\n\t\t\t\t</p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="(pensionSchemePeriodForm.$invalid && !$ctrl.pension.validationResults.IsValid) || $ctrl.validationResults.IsEndDateExceeding" display-text="\'Save\'" state="pensionSchemePeriodForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/scheme/period-alignment/pension-scheme-period-alignment.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="pensionSchemePeriodAlignmentForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updatePensionPeriodAlignment($ctrl, pensionSchemePeriodAlignmentForm)" novalidate>\n\t<div class="form-intro">\n\t\t<p class="is-small">The selected alignment will apply to all future pension periods once you click \'Save\'. This can be edited at any time.</p>\n\t</div>\n\n\t<fieldset>\n\t\t<div class="form-content-block no-margin top">\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\tPension period alignment:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentSame" name="periodAlignment" ng-model="$ctrl.hasPensionDateOffset" ng-value="false" type="radio">\n\t\t\t\t\t\t\t<label for="periodAlignmentSame" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Same as pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="periodAlignmentDifferent" name="periodAlignment" ng-model="$ctrl.hasPensionDateOffset" ng-value="true" type="radio">\n\t\t\t\t\t\t\t<label for="periodAlignmentDifferent" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Different to pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="form-field" ng-if="$ctrl.hasPensionDateOffset">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="periodAlignmentSame">\n\t\t\t\t\t\tOffset to:\n\t\t\t\t\t</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-list">\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="afterPayDate" name="beforePayDate" ng-change="$ctrl.onOffsetTypeChange()" ng-model="$ctrl.isBeforePeriodDate" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t<label for="afterPayDate">\n\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="afterPayDateOffset" max="21" min="0" ng-model="$ctrl.pensionDateAfterOffset" ng-required="!$ctrl.isBeforePeriodDate" ng-readonly="$ctrl.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t<span ng-if="$ctrl.pensionDateAfterOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.pensionDateAfterOffset" when="{\'1\': \'day later than pay periods\',\n\t\t\t\t\t\t\t\t\t\t       \'other\': \'days later than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="!$ctrl.pensionDateAfterOffset">days later than pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemePeriodAlignmentForm.afterPayDateOffset.$touched" ng-messages="pensionSchemePeriodAlignmentForm.afterPayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of hours</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t<input class="b" id="beforePayDate" name="afterPayDate" ng-change="$ctrl.onOffsetTypeChange()" ng-model="$ctrl.isBeforePeriodDate" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t<label for="beforePayDate">\n\t\t\t\t\t\t\t\t<number-selector-field class="xs" field-name="beforePayDateOffset" max="21" min="0" ng-model="$ctrl.pensionDateBeforeOffset" ng-required="$ctrl.isBeforePeriodDate" ng-readonly="!$ctrl.isBeforePeriodDate" ng-regex-key="integersOnly" step="1">\n\t\t\t\t\t\t\t\t</number-selector-field>\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t<span ng-if="$ctrl.pensionDateBeforeOffset">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="$ctrl.pensionDateBeforeOffset" when="{\'1\': \'day earlier than pay periods\',\n\t\t\t\t\t\t\t\t\t\t       \'other\': \'days earlier than pay periods\'}">\n\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if="!$ctrl.pensionDateBeforeOffset">days earlier than pay periods</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemePeriodAlignmentForm.beforePayDateOffset.$touched" ng-messages="pensionSchemePeriodAlignmentForm.beforePayDateOffset.$error" role="alert">\n\t\t\t\t\t\t\t\t<p ng-message="max">Please enter a maximum of 21 days</p>\n\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a minimum of 1 day</p>\n\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="required">Please enter the number of days</p>\n\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter whole numbers only</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="form-message primary">Max. offset is 21 days.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<button class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="pensionSchemePeriodAlignmentForm.$invalid" display-text="\'Save\'" state="pensionSchemePeriodAlignmentForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/scheme/postponement/pension-scheme-postponement.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemePostponementForm" ng-submit="$ctrl.updatePensionPostponementDetails($ctrl, pensionSchemePostponementForm)" class="fadeIn" novalidate ng-if="$ctrl.pageState === \'ready\'">\n\n\t<!-- Team postponement -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Team postponement</h4>\n\t\t\t<p class="s">Postponement can be applied to new employees who join the team or those employees who pass through the relevant age and earnings thresholds up to a maximum of three months. These can also be set later in the Pension page for this company.\n\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionStartDate" underline="true">Read more about pension staging/start</support-article-link>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- New team member postponement -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="newStarterPostponement">New team member postponement:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select class="l-alt" id="newStarterPostponement" name="newStarterPostponement" ng-model="$ctrl.pension.PensionPostponementDetails.NewStarterPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in $ctrl.postponementOptions">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Threshold change postponement -->\n\t\t\t<div class="form-field">\n\t\t\t\t<label for="eligiblePostponement">Threshold change postponement:</label>\n\t\t\t\t<div class="field">\n\t\t\t\t\t<select class="l-alt" id="eligiblePostponement" name="eligiblePostponement" ng-model="$ctrl.pension.PensionPostponementDetails.EligibleWorkerPostponementLength" ng-options="postponementOption.value as postponementOption.key for postponementOption in $ctrl.postponementOptions">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="pensionSchemePostponementForm.state" disable-button="!pensionSchemePostponementForm.$valid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/provider/pension-scheme-provider.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemeProviderForm" ng-submit="$ctrl.updateCompanyPensionProvider($ctrl, pensionSchemeProviderForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h4>Choose your pension provider</h4>\n\t\t<p class="s">You should have already chosen your workplace pension provider and have a compliant scheme in place for your team. Tell us if this is a new scheme or not then choose your provider from the options below.</p>\n\t</div>\n\n\t<!-- Note: Policy-based schemes -->\n\t<div class="form-field" ng-if="$ctrl.pension.PensionPolicyDetails.UsePensionPolicy">\n\t\t<note note-title="Changing provider for policy-based schemes" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t<note-content>\n\t\t\t\t<p class="is-small">This scheme was set up to use a pension policy. If you\'re changing provider because you wish to connect to one directly, or you wish to create pension groups instead of using a pension policy, you will need to delete this scheme and set up a new one. </p>\n\t\t\t</note-content>\n\t\t</note>\n\t</div>\n\n\t<!-- Direct connect providers -->\n\t<fieldset class="form-fieldset-divider" ng-if="$ctrl.directConnectionProviders.length > 0">\n\n\t\t<!-- Direct providers -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pensionProvider0" class="{{$ctrl.manuallyEnterPension ? \'disabled\' : \'required\'}}">Direct connection providers</label>\n\t\t\t\t<p class="s">Paycircle can connect to these providers directly to send and receive data.</p>\n\t\t\t</header>\n\n\t\t\t<section class="form-field-main">\n\t\t\t\t<div class="pension-provider-cards cards is-fixed">\n\t\t\t\t\t<div class="pension-provider-card-radio" ng-repeat="pensionProvider in $ctrl.directConnectionProviders">\n\t\t\t\t\t\t<input type="radio" name="pensionProviders" id="pensionProvider{{$index}}" class="pension-provider-card-radio-input" ng-class="{\'is-faded\': pensionSchemeProviderForm.pensionProviders.$valid}" ng-value="pensionProvider.PensionProviderID" ng-model="$ctrl.pension.PensionProviderDetails.PensionProviderID" ng-required="!$ctrl.manuallyEnterPension" ng-disabled="$ctrl.manuallyEnterPension">\n\n\t\t\t\t\t\t<label class="pension-provider-card-radio-label" for="pensionProvider{{$index}}">\n\t\t\t\t\t\t\t<img ng-src="{{pensionProvider.PensionProviderImageUrl}}" alt="{{pensionProvider.PensionProviderName}}" class="pension-provider-card-logo">\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Manual providers -->\n\t<fieldset class="form-fieldset-divider">\n\n\t\t<!-- Manual providers -->\n \t\t<div class="form-field" ng-if="$ctrl.manualProviders.length > 0">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="manualPensionProvider0" class="{{$ctrl.manuallyEnterPension ? \'disabled\' : \'required\'}}">Manual providers</label>\n\t\t\t\t<p class="s">You will need to upload your pension file to these providers each time you run payroll and manage your teams&apos; opt in and opt out requests manually.</p>\n\t\t\t</header>\n\t\t\t<section class="form-field-main">\n\t\t\t\t<div class="radio-cards-list-split">\n\t\t\t\t\t<div class="radio-card" ng-repeat="pensionProvider in $ctrl.manualProviders">\n\t\t\t\t\t\t<input type="radio" name="pensionProviders" id="manualPensionProvider{{$index}}" class="b radio-card-input" ng-value="pensionProvider.PensionProviderID" ng-model="$ctrl.pension.PensionProviderDetails.PensionProviderID" ng-required="!$ctrl.manuallyEnterPension" ng-disabled="$ctrl.manuallyEnterPension">\n\t\t\t\t\t\t<label for="manualPensionProvider{{$index}}" class="radio-card-label">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">{{pensionProvider.PensionProviderName}}</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</section>\n \t\t</div>\n \t</fieldset>\n\n \t<fieldset>\n\n\t\t<!-- Pension provider not shown -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="manuallyEnterPension" name="manuallyEnterPension" ng-model="$ctrl.manuallyEnterPension" ng-change="$ctrl.toggleManuallyEnterPension($ctrl)" label-text="\'My provider isn&#8217;t shown above\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pension provider name -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.manuallyEnterPension">\n\t\t\t<label for="manualPensionName" class="required">Enter your provider name</label>\n\t\t\t<div class="field">\n\t\t\t\t<input type="text" id="manualPensionName" name="manualPensionName" ng-model="$ctrl.pension.PensionProviderDetails.PensionProviderName" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeProviderForm.manualPensionName.$error" ng-if="pensionSchemeProviderForm.manualPensionName.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter pension provider name</p>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="pensionSchemeProviderForm.state" disable-button="!pensionSchemeProviderForm.$valid"></submit-button>\n\n\t</fieldset>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n\n');
$templateCache.put('forms/pension/scheme/settings/pension-scheme-settings.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="pensionSchemeSettingsForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updatePensionSettingDetails($ctrl, pensionSchemeSettingsForm)" novalidate>\n\t<div class="form-intro">\n\t\t<h4>Pension settings</h4>\n\t</div>\n\n\t<fieldset ng-disabled="!$ctrl.pension.PensionSettingDetails.CanUpdatePensionSettings" ng-switch="$ctrl.pension.PensionSettingDetails.PensionType">\n\t\t<!-- Pension provider name -->\n\t\t<div class="form-field" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="pensionProviderName">\n\t\t\t\t\tPension provider:\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="pensionProviderName" name="pensionProviderName" ng-model="$ctrl.pension.PensionSettingDetails.PensionProviderName" type="text" required>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemeSettingsForm.pensionProviderName.$touched" ng-messages="pensionSchemeSettingsForm.pensionProviderName.$error" role="alert">\n\t\t\t\t<p ng-message="required">\n\t\t\t\t\tPlease enter pension provider name\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Scheme reference (AE pensions only, disabled if connected to provider) -->\n\t\t<div class="form-section" ng-class="{\n\t\t\t\t\'is-disabled\' : $ctrl.pension.PensionAutomationDetails.ConnectToProvider || !$ctrl.pension.PensionSettingDetails.CanUpdateSchemeReferenceDisplay\n\t\t\t}" ng-if="$ctrl.pension.PensionSettingDetails.PensionType === $ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label for="hasSchemeReference">Do you wish to add a scheme reference number?</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="radio-cards-list-split is-inline">\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceTrue" name="hasSchemeReference" ng-change="$ctrl.onHasSchemeReferenceChange($ctrl.pension)" ng-model="$ctrl.pension.PensionSettingDetails.HasSchemeReference" ng-value="true" required type="radio">\n\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceTrue" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">Yes</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="radio-card">\n\t\t\t\t\t\t\t<input class="b radio-card-input" id="hasSchemeReferenceFalse" name="hasSchemeReference" ng-change="$ctrl.onHasSchemeReferenceChange($ctrl.pension)" ng-model="$ctrl.pension.PensionSettingDetails.HasSchemeReference" ng-value="false" required type="radio">\n\t\t\t\t\t\t\t\t<label for="hasSchemeReferenceFalse" class="radio-card-label">\n\t\t\t\t\t\t\t\t<span class="radio-card-option-text">No</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset class="fadeIn">\n\t\t\t<!-- Scheme reference format - if AE pension and has scheme reference set. Disabled when connect to provider is set -->\n\t\t\t<div class="form-section" ng-class="{\n\t\t\t\t\t\'is-disabled\' : $ctrl.pension.PensionAutomationDetails.ConnectToProvider || !$ctrl.pension.PensionSettingDetails.CanUpdateSchemeReferenceDisplay\n\t\t\t\t}" ng-if="$ctrl.pension.PensionSettingDetails.HasSchemeReference && $ctrl.pension.PensionSettingDetails.PensionType === $ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="schemeReferenceFormat">\n\t\t\t\t\t\t\tScheme reference format:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<select id="schemeReferenceFormat" name="schemeReferenceFormat" ng-model="$ctrl.pension.PensionSettingDetails.SchemeReferenceDisplayType" ng-options="schemeReferenceDisplayType.id as schemeReferenceDisplayType.description for schemeReferenceDisplayType in $ctrl.PENSION_SCHEME_REFERENCE_DISPLAY_TYPE_DESCRIPTIONS" required></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Education employer number fields (when display type is education employer number)-->\n\t\t\t<fieldset ng-if="\n\t\t\t\t$ctrl.pension.PensionSettingDetails.SchemeReferenceDisplayType === $ctrl.PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.educationEmployerNumber &&\n\t\t\t\t$ctrl.pension.PensionSettingDetails.HasSchemeReference">\n\t\t\t\t<!-- Local authority number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="localAuthorityNumber">\n\t\t\t\t\t\t\tLocal authority number:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l-alt" id="localAuthorityNumber" name="localAuthorityNumber" ng-model="$ctrl.pension.PensionSettingDetails.LocalAuthorityNumber" type="text" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemeSettingsForm.localAuthorityNumber.$touched" ng-messages="pensionSchemeSettingsForm.localAuthorityNumber.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter local authority number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Establishment number -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="establishmentNumber">\n\t\t\t\t\t\t\tEstablishment number:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<input class="l-alt" id="establishmentNumber" name="establishmentNumber" ng-model="$ctrl.pension.PensionSettingDetails.EstablishmentNumber" type="text" required>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionSchemeSettingsForm.establishmentNumber.$touched" ng-messages="pensionSchemeSettingsForm.establishmentNumber.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="required">Please enter establishment number</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\n\t\t\t<!-- Employer Pension Scheme Reference (when display type is employerReference) -->\n\t\t\t<fieldset ng-if="\n\t\t\t\t\t$ctrl.pension.PensionSettingDetails.SchemeReferenceDisplayType === $ctrl.PENSION_SCHEME_REFERENCE_DISPLAY_TYPES.employerReference &&\n\t\t\t\t\t$ctrl.pension.PensionSettingDetails.HasSchemeReference">\n\t\t\t\t<pension-scheme-employer-reference-field connect-to-provider="$ctrl.pension.PensionAutomationDetails.ConnectToProvider" employer-reference="$ctrl.pension.PensionSettingDetails.EmployerReference" pension-provider-id="$ctrl.pension.PensionProviderDetails.PensionProviderID" pension-type="$ctrl.pension.PensionSettingDetails.PensionType"></pension-scheme-employer-reference-field>\n\t\t\t</fieldset>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- Pension description -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pensionDescription">\n\t\t\t\t\tDescription:\n\t\t\t\t</label>\n\t\t\t</header>\n\t\t\t<main class="form-field-main">\n\t\t\t\t<input id="pensionDescription" maxlength="128" name="pensionDescription" ng-model="$ctrl.pension.PensionSettingDetails.PensionDescription" placeholder="Enter a description" type="text">\n\t\t\t</main>\n\t\t\t<p class="form-message fadeIn">\n\t\t\t\tThis is optional and can be useful if you\u2019re connecting more than one pension from the same provider.\n\t\t\t</p>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t<!-- Tax relief type -->\n\t\t<div class="form-field">\n\t\t\t<label for="taxReliefType" ng-class="{disabled: !$ctrl.pension.PensionSettingDetails.CanUpdatePensionSettings}">\n\t\t\t\tTax relief type:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<select class="l-alt" id="taxReliefType" name="taxReliefType" ng-disabled="!$ctrl.pension.PensionSettingDetails.CanUpdatePensionSettings" ng-model="$ctrl.pension.PensionSettingDetails.TaxReliefType" ng-options="taxReliefType.id as taxReliefType.description for taxReliefType in $ctrl.TAX_RELIEF_TYPES" required></select>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="pensionSchemeSettingsForm.$invalid && !$ctrl.pension.PensionSettingDetails.validationResults.IsValid" display-text="\'Save\'" state="pensionSchemeSettingsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/scheme/staging/pension-scheme-staging.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionSchemeStagingForm" ng-submit="$ctrl.updatePensionStagingDetails($ctrl, pensionSchemeStagingForm)" class="fadeIn" novalidate ng-if="$ctrl.pageState === \'ready\'">\n\n\t<!-- Staging/start date -->\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Pension staging/start date</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tTell us the company\'s staging/start date and whether they chose to postpone, and the next re-enrolment date.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Start date -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="stagingDate" ng-class="{\'disabled\': !$ctrl.pension.PensionStagingDetails.CanUpdateStagingDate}">Start Date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="stagingDate" field-max-date-iso="$ctrl.stagingDateBoundaries.stagingDateISOMax" field-value-iso="$ctrl.pension.PensionStagingDetails.StagingDateISO" field-disabled="!$ctrl.pension.PensionStagingDetails.CanUpdateStagingDate">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeStagingForm.stagingDate.$error" ng-if="pensionSchemeStagingForm.stagingDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter start date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="max">Please enter a date before {{$ctrl.stagingDateBoundaries.stagingDateISOMax | dateformat}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Start date postponed -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="stagingPostponed" class="required" ng-class="{\'disabled\' : !$ctrl.pension.PensionStagingDetails.CanUpdatePostponementDate }">Are you postponing your start date?</label>\n\t\t\t</header>\n\t\t\t<section class="form-field-main">\n\t\t\t\t<!-- Yes -->\n\t\t\t\t<input type="radio" name="stagingPostponed" id="stagingPostponedTrue" class="b" ng-value="true" ng-model="$ctrl.pension.PensionStagingDetails.IsStagingPostponed" ng-disabled="!$ctrl.pension.PensionStagingDetails.CanUpdatePostponementDate">\n\t\t\t\t<label for="stagingPostponedTrue">Yes</label>\n\t\t\t\t<!-- No -->\n\t\t\t\t<input type="radio" name="stagingPostponed" id="stagingPostponedFalse" class="b" ng-value="false" ng-model="$ctrl.pension.PensionStagingDetails.IsStagingPostponed" ng-disabled="!$ctrl.pension.PensionStagingDetails.CanUpdatePostponementDate">\n\t\t\t\t<label for="stagingPostponedFalse">No</label>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<!-- Staging postponement date -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.PensionStagingDetails.IsStagingPostponed">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="stagingPostponementDate">Postponement date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="stagingPostponementDate" field-min-date-iso="$ctrl.pension.PensionStagingDetails.PostponementDateMinISO" field-max-date-iso="$ctrl.pension.PensionStagingDetails.PostponementDateMaxISO" field-read-only="!$ctrl.pension.PensionStagingDetails.CanUpdatePostponementDate" field-value-iso="$ctrl.pension.PensionStagingDetails.PostponementDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeStagingForm.stagingPostponementDate.$error" ng-if="pensionSchemeStagingForm.stagingPostponementDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter staging postponement date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t<p ng-message="min || max">This date needs to be between {{$ctrl.pension.PensionStagingDetails.PostponementDateMinISO | dateformat:\'long\'}} - {{$ctrl.pension.PensionStagingDetails.PostponementDateMaxISO | dateformat:\'long\'}}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: Calculating contributions -->\n\t\t<div class="form-field">\n\t\t\t<note note-title="Calculating contributions" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Paycircle cannot calculate past or missed contributions, only contributions from when the pension is set up on Paycircle. Any missed contributions or fines need to be dealt with directly with The Pensions Regulator.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Re-enrolment info -->\n\t\t<div class="form-field" ng-if="$ctrl.validationResults">\n\t\t\t<p class="is-small">\n\t\t\t\t<span class="fadeIn" ng-if="!$ctrl.validationResults.CompanyIsInReenrolmentWindow">Your re-enrolment date is the third anniversary of your start date. You can adjust this to a date within a 6 month window however. </span>\n\t\t\t\t<span class="fadeIn" ng-if="$ctrl.validationResults.CompanyIsInReenrolmentWindow">Based on the start date entered, you\u2019re currently in your 6 month re-enrolment window ({{$ctrl.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'dayMonth\'}} - {{$ctrl.validationResults.ReenrolmentWindowEndDateISO | dateformat:\'dayMonthYear\'}}) and you may have completed re-enrolment. </span>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Staging date in Re-enrolment window (3 years before current period start date) -->\n\t\t<fieldset class="fadeIn" ng-if="$ctrl.validationResults.CompanyIsInReenrolmentWindow">\n\n\t\t\t<!-- Completed re-enrolment -->\n\t\t\t<div class="form-field">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label for="reenrolmentCompleted" class="required">Have you already completed re-enrolment?</label>\n\t\t\t\t</header>\n\t\t\t\t<section class="form-field-main">\n\t\t\t\t\t<!-- Yes -->\n\t\t\t\t\t<input type="radio" name="reenrolmentCompleted" id="reenrolmentCompletedTrue" class="b" ng-value="true" ng-model="$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted">\n\t\t\t\t\t<label for="reenrolmentCompletedTrue">Yes</label>\n\t\t\t\t\t<!-- No -->\n\t\t\t\t\t<input type="radio" name="reenrolmentCompleted" id="reenrolmentCompletedFalse" class="b" ng-value="false" ng-model="$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted">\n\t\t\t\t\t<label for="reenrolmentCompletedFalse">No</label>\n\t\t\t\t</section>\n\t\t\t</div>\n\n\t\t\t<!-- Re-enrolment completion date -->\n\t\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted">\n\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t<label class="required" for="reenrolmentCompletionDate">Completion date:</label>\n\t\t\t\t</header>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<date-input-field field-id="reenrolmentCompletionDate" field-min-date-iso="$ctrl.validationResults.ReenrolmentWindowStartDateISO" field-max-date-iso="$ctrl.validationResults.ReenrolmentWindowEndDateISO" field-value-iso="$ctrl.pension.PensionStagingDetails.ReenrolmentCompletionDateISO">\n\t\t\t\t\t</date-input-field>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeStagingForm.reenrolmentCompletionDate.$error" ng-if="pensionSchemeStagingForm.reenrolmentCompletionDate.$touched" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter a completion date</p>\n\t\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t\t\t<p ng-message="min || max">This date needs to be between {{$ctrl.validationResults.ReenrolmentWindowStartDateISO | dateformat:\'long\'}} - {{$ctrl.validationResults.ReenrolmentWindowEndDateISO  | dateformat:\'long\'}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Re-enrolment date -->\n\t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="!$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted">Re-enrolment date:</label>\n\t\t\t\t<label class="required" for="reenrolmentDate" ng-if="$ctrl.pension.PensionStagingDetails.ReenrolmentAlreadyCompleted">Next re-enrolment date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="reenrolmentDate" field-value-iso="$ctrl.pension.PensionStagingDetails.ReenrolmentDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeStagingForm.reenrolmentDate.$error" ng-if="pensionSchemeStagingForm.reenrolmentDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter a re-enrolment date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: Check re-enrolment date -->\n\t\t<div class="form-field fadeIn" ng-if="!$ctrl.validationResults.IsValid && $ctrl.validationResults.ReenrolmentDateISO">\n\t\t\t<note note-title="Check your re-enrolment date" note-theme="assertive is-form-field" note-icon="icon-warning" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour re-enrolment date should be between {{$ctrl.validationResults.ReenrolmentDateMinISO | dateformat}} - {{$ctrl.validationResults.ReenrolmentDateMaxISO | dateformat}}.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Include opted out team members -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="reenrolRecentOptOuts" name="reenrolRecentOptOuts" ng-model="$ctrl.pension.PensionStagingDetails.ReenrolRecentOptOuts" label-text="\'Include team members who opt out in the 12 months prior to re-assessment for re-enrolment\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: Connecting multiple pensions -->\n\t\t<div class="form-field">\n\t\t\t<note note-title="Connecting multiple pensions" note-theme="indifferent is-form-field" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">Your re-enrolment date is for your company rather than this particular workplace pension. As this is the first pension you\u2019re connecting, you won\u2019t need to add your re-enrolment date again later if you decide to connect another pension later.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- DOC -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Declaration of Compliance</h4>\n\t\t\t<p class="is-small">\n\t\t\t\tA Declaration of Compliance must be submitted to The Pensions Regulator within 5 months of your pension duties start date and then every 3 years, when your team are assessed for re-enrolment.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- TPR letter code -->\n\t\t<div class="form-field">\n\t\t\t<label for="tprLetterCode"><abbr class="underline" tooltip tooltip-text="The Pensions Regulator" tooltip-position="right">TPR</abbr> letter code:</label>\n\t\t\t<div class="field">\n\t\t\t\t<input class="m" type="text" id="tprLetterCode" name="tprLetterCode" ng-model="$ctrl.pension.PensionStagingDetails.PensionLetterCode" ng-pattern="$root.REGEX.tprLetterCode" ng-maxlength="10">\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionSchemeStagingForm.tprLetterCode.$error" ng-if="pensionSchemeStagingForm.tprLetterCode.$touched" role="alert">\n\t\t\t\t<p ng-message="pattern">Please enter a valid TPR letter code (10 digits, starting with a "1")</p>\n\t\t\t\t<p ng-message="maxlength">Please enter only 10 digits</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Note: TPR letter code -->\n\t\t<div class="form-field">\n\n\t\t\t<note note-title="Don\u2019t know your TPR letter code?" note-theme="indifferent" note-icon="icon-support">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="s">You can find it out on the <abbr class="underline" tooltip tooltip-text="The Pensions Regulator" tooltip-position="right">TPR</abbr> website using your references:</p>\n\t\t\t\t\t<div class="stat-list basic plain-text">\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key">Accounts office reference:</span> <span class="stat-list__value">{{$ctrl.formOptions.company.AccountsOfficeReference}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="stat-list__row">\n\t\t\t\t\t\t\t<span class="stat-list__key">PAYE reference:</span> <span class="stat-list__value">{{$ctrl.formOptions.company.PAYERef}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<a href="" ng-href="{{$root.URLS.tpr.letterCode}}" class="s indifferent-darkened underline" target="_blank">Find out your TPR letter code now</a>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t\t<!-- Has the Declaration of Compliance (DoC) been submitted? -->\n\t\t<div class="form-field">\n\t\t\t<label class="required">Has the Declaration of Compliance (DoC) been submitted?</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list">\n\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedTrue" class="b" ng-value="true" ng-model="$ctrl.pension.PensionStagingDetails.DOCSubmitted">\n\t\t\t\t\t<label for="docSubmittedTrue">Yes</label>\n\n\t\t\t\t\t<input type="radio" name="docSubmitted" id="docSubmittedFalse" class="b" ng-value="false" ng-model="$ctrl.pension.PensionStagingDetails.DOCSubmitted">\n\t\t\t\t\t<label for="docSubmittedFalse">No</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="\'Save\'" state="pensionSchemeStagingForm.state" disable-button="!pensionSchemeStagingForm.$valid || !$ctrl.validationResults.IsValid"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/team/pension-scheme-team.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="pensionSchemeTeamForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateTeamMembersInPension(pensionSchemeTeamForm)" novalidate>\n\t<div class="info-block indifferent" ng-if="!$ctrl.teamMembers.length">\n\t\t<p class="is-small">There are currently no team members waiting to be added to a pension.</p>\n\t</div>\n\n\t<div class="form-intro" ng-if="$ctrl.teamMembers.length">\n\t\t<p class="is-small">\n\t\t\tSelect team members to add to this pension scheme:\n\t\t</p>\n\t</div>\n\n\t<fieldset ng-if="$ctrl.teamMembers.length">\n\n\t\t<div class="form-field">\n\t\t\t<div class="checkbox-list-header">\n\t\t\t\t<h6 class="checkbox-list-header_title">{{$ctrl.selectedTeamMembers.length}} selected</h6>\n\t\t\t\t<div class="inline-links">\n\t\t\t\t\t<a href ng-click="$ctrl.toggleAllTeamMembers(true)">\n\t\t\t\t\t\tSelect all\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href ng-click="$ctrl.toggleAllTeamMembers(false)">\n\t\t\t\t\t\tUnselect all\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Team Members -->\n \t\t<div class="form-field">\n \t\t\t<div class="checkbox-rows-list">\n\t\t\t\t<div class="checkbox-row" ng-repeat="teamMember in $ctrl.teamMembers">\n\t\t\t\t\t<label class="checkbox-row_label" for="{{teamMember.UserID}}">\n\t\t\t\t\t\t<input class="pc-checkbox checkbox-row_input" id="{{teamMember.id}}" name="{{teamMember.id}}" ng-change="$ctrl.updateSelectedTeamMembers()" ng-model="teamMember.isSelected" type="checkbox">\n\t\t\t\t\t\t<avatar avatar-initial="{{teamMember.Forename[0]}}" avatar-size="is-small" class="checkbox-row_avatar"></avatar>\n\t\t\t\t\t\t<span class="checkbox-row_context">\n\t\t\t\t\t\t\t<name forename="{{teamMember.Forename}}" surname="{{teamMember.Surname}}"></name>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<div ng-if="teamMember.isAdditionalPost">\n\t\t\t\t\t\t\t<icon-dot icon="icon-setup-user" is-light="true" theme="is-primary has-hover" tooltip-position="left" tooltip-text="{{teamMember.SalaryPolicyPostTitle}}"></icon-dot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n \t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<submit-button disable-button="$ctrl.selectedTeamMembers.length === 0" display-text="\'Add to pension\'" state="pensionSchemeTeamForm.state"></submit-button>\n\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Team members added" ng-if="$ctrl.pageState === \'saved\'">\n\t<fs-main ng-switch="$ctrl.formOptions.pension.PensionType">\n\t\t<p class="is-small" pc-switch-when="$ctrl.PENSION_TYPES.nonAutoEnrolment">\n\t\t\t<ng-pluralize count="$ctrl.selectedTeamMembers.length" when="{\n\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t}"></ng-pluralize>\n\t\t\thave been added to this pension scheme and have been assigned the default contribution band.\n\t\t</p>\n\t\t<p class="is-small" pc-switch-when="$ctrl.PENSION_TYPES.autoEnrolment">\n\t\t\t<ng-pluralize count="$ctrl.selectedTeamMembers.length" when="{\n\t\t\t\t\t\'1\': \'1 team member\',\n\t\t\t\t\t\'other\': \'{} team members\'\n\t\t\t\t}"></ng-pluralize>\n\t\t\thave been added to this pension scheme.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/scheme/warnings/pension-scheme-failed-pension-manually-submit-warning.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Confirmation -->\n<form name="pensionSchemeFailedPensionManuallySubmitWarningForm" ng-submit="$ctrl.updatePensionManualSubmission($ctrl, pensionSchemeFailedPensionManuallySubmitWarningForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-theme="primary" fs-icon="question-mark" fs-title="Are you sure you wish to submit this pension manually?">\n\t\t<fs-main>\n\t\t\t<p class="s">By confirming this, we\'ll assume that you have successfully submitted your pension file for {{::$ctrl.pension.PayPeriodPreviousDisplay}} outside of the system and future submissions will continue as normal. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Confirm\'" state="saving"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/scheme/warnings/pension-scheme-queued-pension-cancel-warning.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Confirmation -->\n<form name="pensionSchemeQueuedPensionCancelWarningForm" ng-submit="$ctrl.updatePensionFailedSubmission($ctrl, pensionSchemeQueuedPensionCancelWarningForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<form-state form-options="$ctrl.formOptions" fs-show-close="false" fs-theme="primary" fs-icon="question-mark" fs-title="Are you sure you wish to cancel this queued pension?">\n\t\t<fs-main>\n\t\t\t<p class="s">By cancelling this queued pension, you will be marking the {{::$ctrl.pension.PayPeriodPreviousDisplay}} submission as failed and will then have the option to resubmit or submit your pension outside of the system. Click \u2018Confirm\u2019 if you\u2019re happy to continue.</p>\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t\t<submit-button class="primary-action tertiary" display-text="\'Confirm\'" state="saving"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/bands/pension-team-bands.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="pensionTeamBandsForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.ready" ng-submit="$ctrl.updateTeamMemberPensionContributions($ctrl, pensionTeamBandsForm)" novalidate>\n\t<fieldset>\n\n\t\t<div class="form-intro" ng-switch="$ctrl.pensionPolicy.PolicyBandCalculation">\n\t\t\t<h4 class="strong">Contribution band</h4>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution band will be determined by their pensionable pay\n\t\t\t\tafter payroll is calculated each period.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution band will be determined by their annualised pensionable\n\t\t\t\tpay after payroll is calculated each period.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\t<span ng-if="!$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual && !$ctrl.pension.PensionFullTimeEquivalentSalaryIsOverridden">\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution band is determined by their full-time equivalent\n\t\t\t\t\tsalary, which is calculated automatically from their pay record and kept in sync when their pay changes.\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="!$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual && $ctrl.pension.PensionFullTimeEquivalentSalaryIsOverridden">\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution band is determined by their full-time equivalent\n\t\t\t\t\tsalary, which is configured to be manually maintained against this pension instead of automatically calculated from their pay record.\n\t\t\t\t</span>\n\t\t\t\t<span ng-if="$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual">\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution band is determined by their full-time equivalent\n\t\t\t\t\tsalary. As their pay type has no full-time equivalent salary to calculate from, please enter and maintain this value.\n\t\t\t\t</span>\n\t\t\t</p>\n\t\t\t<!-- No prompt for manual - user needs to select band -->\n\t\t</div>\n\n\t\t<div class="form-field" ng-if="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="contributionBand">\n\t\t\t\t\tSelect a contribution band\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<select id="contributionBand" name="contributionBand" ng-model="$ctrl.pension.PolicyBandID" ng-options="policyBand.PolicyBandID as policyBand.PolicyBandName for policyBand in $ctrl.pensionPolicy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" required>\n\t\t\t\t\t<option disabled="disabled" hidden selected="selected" value="">\n\t\t\t\t\t\tPlease select...\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Calculated from the pay record, so read only unless the value is maintained manually against this pension -->\n\t\t<div class="form-field" ng-if="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary && !$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual && !$ctrl.pension.PensionFullTimeEquivalentSalaryIsOverridden">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label>\n\t\t\t\t\tFull-time equivalent salary\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<p data-cy="pension-fte-salary">{{$ctrl.pension.PensionFullTimeEquivalentSalaryCalculated | monetise}}</p>\n\t\t\t</div>\n\t\t\t<p class="form-message" data-cy="pension-fte-salary-calculated" ng-if="$ctrl.pension.PensionFullTimeEquivalentSalaryCalculated">This is calculated automatically from {{$ctrl.formOptions.context.Forename}}\'s latest pay record.</p>\n\t\t\t<p class="form-message" data-cy="pension-fte-salary-pending" ng-if="!$ctrl.pension.PensionFullTimeEquivalentSalaryCalculated">FTE will be calculated once a salary or post is assigned.</p>\n\t\t</div>\n\n\t\t<!-- Pay types with no full-time equivalent salary to calculate from, and pensions the value is maintained manually against -->\n\t\t<div class="form-field" ng-if="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary && ($ctrl.pension.PensionFullTimeEquivalentSalaryIsManual || $ctrl.pension.PensionFullTimeEquivalentSalaryIsOverridden)">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label class="required" for="fteSalary">\n\t\t\t\t\tFull-time equivalent salary\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l monetise" data-cy="pension-fte-salary-input" id="fteSalary" name="fteSalary" ng-max="$root.CONFIG.number7Digits2Decimal" ng-maxlength="$root.CONFIG.salaryMaxLength" ng-min="$root.CONFIG.numberMin" ng-model="$ctrl.pension.PensionFullTimeEquivalentSalary" ng-pattern="$root.REGEX.decimal" required type="number">\n\t\t\t</div>\n\t\t\t<p class="form-message" data-cy="pension-fte-salary-manual" ng-if="$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual">{{$ctrl.formOptions.context.Forename}}\'s pay type has no full-time equivalent salary to calculate from, please maintain this value to keep them in the right band.</p>\n\t\t\t<p class="form-message" data-cy="pension-fte-salary-overridden" ng-if="!$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual">This value is maintained by you rather than calculated from {{$ctrl.formOptions.context.Forename}}\'s pay record, so it will not change when their pay does.<span ng-if="$ctrl.pension.PensionFullTimeEquivalentSalaryCalculated"> Their pay record calculates {{$ctrl.pension.PensionFullTimeEquivalentSalaryCalculated | monetise}}.</span></p>\n\t\t\t<div class="form-errors" ng-messages="pensionTeamBandsForm.fteSalary.$error" ng-show="pensionTeamBandsForm.fteSalary.$touched">\n\t\t\t\t<p ng-message="max">Please enter a maximum of {{$root.CONFIG.number7Digits2Decimal | monetise}}</p>\n\t\t\t\t<p ng-message="maxlength">Please enter no more than {{$root.CONFIG.salaryMaxLength}} characters</p>\n\t\t\t\t<p ng-message="min">Please enter a minimum of {{$root.CONFIG.numberMin | monetise}}</p>\n\t\t\t\t<p ng-message="pattern">Please enter no more than 2 decimal places</p>\n\t\t\t\t<p ng-message="required">Please enter a full-time equivalent salary</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- A pay type that calculates an FTE salary can still have it maintained manually, for pensionable pay this payroll cannot see -->\n\t\t<div class="form-field" ng-if="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary && !$ctrl.pension.PensionFullTimeEquivalentSalaryIsManual">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox data-cy="pension-fte-salary-override" id="fteSalaryIsOverridden" label-text="\'Maintain \' + $ctrl.formOptions.context.Forename + \'&rsquo;s full-time equivalent salary manually\'" name="fteSalaryIsOverridden" ng-model="$ctrl.pension.PensionFullTimeEquivalentSalaryIsOverridden" type="checkbox">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<!-- Bands -->\n\t\t\t<div class="form-section">\n\t\t\t\t<h5>\n\t\t\t\t\t<ng-pluralize count="$ctrl.pensionPolicy.bandsCount" when="{\'1\': \'1 contribution band\', \'other\': \'{} contribution bands\'}"></ng-pluralize>\n\t\t\t\t</h5>\n\t\t\t</div>\n\n\t\t\t<div class="pension-policy-band-cards">\n\t\t\t\t<!-- Hide deleted bands in view mode, in case this is the summary view after creating or editing a policy.\n\t\t\t\t\t For manual policy pensions, the currently selected pension band is highlighted, all others are selectable. -->\n\t\t\t\t<policy-band-card is-highlighted="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.manual && policyBand.PolicyBandID === $ctrl.pension.PolicyBandID" is-selectable="$ctrl.pensionPolicy.PolicyBandCalculation === $ctrl.POLICY_BAND_CALCULATION_TYPES.manual && policyBand.PolicyBandID !== $ctrl.pension.PolicyBandID" ng-click="$ctrl.onPolicyBandCardClick($ctrl.pension, policyBand)" ng-repeat="policyBand in $ctrl.pensionPolicy.PolicyBands | filter: { \'PolicyBandDelete\' : \'false\' }" policy="$ctrl.pensionPolicy" policy-band="policyBand"></policy-band-card>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<!-- Back (wizard)-->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack">Back</a>\n\n\t\t<!-- Close (non-wizard)-->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()" ng-if="!$ctrl.formOptions.canGoBack">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="pensionTeamBandsForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamBandsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Excluded -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Excluded from workplace pension" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.excluded">\n\t<fs-main>\n\t\t<p class="is-small">{{$ctrl.formOptions.context.Forename}} has been excluded from the workplace pension.\n\t\t\tExcluded team members will still be assessed as normal, they just won\'t ever be enrolled or be entitled to ask to join the pension.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/team/contributions-ae/pension-team-contributions-ae.form.html','<loading-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="pensionTeamBandsForm" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.pensionPolicyBandSummary" ng-submit="$ctrl.closeForm($ctrl)" novalidate>\n\t<fieldset>\n\t\t<div class="form-intro" ng-switch="$ctrl.pensionPolicy.PolicyBandCalculation">\n\t\t\t<h4 class="strong">{{$ctrl.formOptions.context.Forename}}\'s contribution rates</h4>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayForPeriod">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\u2019s contribution band will be determined by their\n\t\t\t\tpensionable pay after payroll is calculated each period.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.pensionablePayAnnualisedForPeriod">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\u2019s contribution band will be determined by their annualised\n\t\t\t\tpensionable pay after payroll is calculated each period.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.fteSalary">\n\t\t\t\tBased on a full-time equivalent salary of {{$ctrl.pension.PensionFullTimeEquivalentSalary | monetise}},\n\t\t\t\t{{$ctrl.formOptions.context.Forename}} falls into {{$ctrl.pension.PensionGroupName}} and the\n\t\t\t\tcontribution rates for this band are {{$ctrl.pension.employeeAmount}} employee /\n\t\t\t\t{{$ctrl.pension.employerAmount}} employer.\n\t\t\t</p>\n\t\t\t<p class="is-small" pc-switch-when="$ctrl.POLICY_BAND_CALCULATION_TYPES.manual">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}} has been added to {{$ctrl.pension.PensionGroupName}} and the contribution\n\t\t\t\trates for this band are {{$ctrl.pension.employeeAmount}} employee / {{$ctrl.pension.employerAmount}} employer.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="form-note has-top-border">\n\t\t\tPlease note that contribution rates can\u2019t be customised for pension schemes that use a pension policy.\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<!-- Close. (This state will only ever be reached outside of a wizard) -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">Close</a>\n\t</fieldset>\n</form>\n\n<form class="fadeIn" name="pensionTeamContributionsAeForm" ng-class="{\'has-warning\': $ctrl.pensionWarningState}" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.ready" ng-submit="$ctrl.updateTeamMemberPensionContributions($ctrl, pensionTeamContributionsAeForm)" novalidate>\n\t<!-- Single Pension Group -->\n\t<div class="form-intro">\n\t\t<h6 class="strong">{{$ctrl.formOptions.context.Forename}}\'s contribution rates</h6>\n\t\t<p class="is-small">\n\t\t\t{{$ctrl.formOptions.context.Forename}} is a member of &lsquo;{{$ctrl.pensionGroup.PensionGroupName}}&rsquo; and the contribution rates\n\t\t\tfor this group are {{$ctrl.pensionGroup.EmployeePercent}}% employee / {{$ctrl.pensionGroup.EmployerPercent}}% employer.\n\t\t</p>\n\t</div>\n\n\t<!-- Custom Contribution Rates -->\n\t<fieldset class="form-fieldset-divider-top">\n\n\t\t<div class="form-field">\n\t\t\t<p class="is-small">\n\t\t\t\tIf for some reason you wish to use different contribution rates for {{$ctrl.formOptions.context.Forename}},\n\t\t\t\tyou can customise them below.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<input checkbox id="hasCustomContributionRates" label-text="\'Customise \' + $ctrl.formOptions.context.Forename + \'&rsquo;s contribution rates\'" name="hasCustomContributionRates" ng-change="$ctrl.toggleCustomRates($ctrl)" ng-model="$ctrl.pension.HasCustomContributionPercent" type="checkbox">\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Customise Contribution Rates For The Selected Group -->\n\t<fieldset class="fadeIn" ng-if="$ctrl.pension.HasCustomContributionPercent">\n\n\t\t<div class="form-field">\n\t\t\t<p class="is-small">\n\t\t\t\tFor workplace pension compliance, the employer contribution must be at least {{$ctrl.payeDetails.PensionEmployerPercentMinimum}}% and\n\t\t\t\tthe total contribution must be at least {{$ctrl.payeDetails.PensionEmployerPercentMinimum + $ctrl.payeDetails.PensionEmployeePercentMinimum}}%\n\t\t\t\tof {{$ctrl.formOptions.context.Forename}}\'s pensionable pay.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field-group">\n\n\t\t\t<!-- Employee Contribution -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-highlight primary compact">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="form-field-container l centered-contents">\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.pension.HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t<number-picker field-name="pensionEmployeePercent" heading="% Employee" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="$ctrl.pensionGroup.EmployeePercentMinimum" ng-model="$ctrl.pension.PensionEmployeePercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution" theme="{\'tertiary\': $ctrl.pensionWarningState}"></number-picker>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.pension.HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t<label class="required" for="pensionEmployeeFixedAmount">\n\t\t\t\t\t\t\t\t\t\t\tEmployee contribution:\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t<input class="monetise" min="0" name="pensionEmployeeFixedAmount" ng-class="{\'tertiary\': $ctrl.pensionWarningState }" ng-model="$ctrl.pension.PensionEmployeeFixedAmount" required type="number">\n\t\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionTeamContributionsAeForm.pensionEmployeeFixedAmount.$touched" ng-messages="pensionTeamContributionsAeForm.pensionEmployeeFixedAmount.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t<div class="toggle-control inline primary">\n\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\'active greyscale\': !$ctrl.pension.HasFixedEmployeeContribution\n\t\t\t\t\t\t\t\t}"> % Percentage</span>\n\t\t\t\t\t\t\t<a class="toggle-a is-small toggle-control-toggle primary {{$ctrl.pension.HasFixedEmployeeContribution ? \'active \': \'primary\'}}" href="" ng-click="$ctrl.toggleTeamMemberCustomEmployeeContributionType($ctrl.pension, $ctrl.pensionGroup)"></a>\n\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\'active greyscale\': $ctrl.pension.HasFixedEmployeeContribution\n\t\t\t\t\t\t\t\t}">\xA3 Fixed</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<footer class="form-field-footer">\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionTeamContributionsAeForm.pensionEmployeePercent.$dirty" ng-messages="pensionTeamContributionsAeForm.pensionEmployeePercent.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.pensionGroup.EmployeePercentMinimum}}%</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t\t<!-- Employer Contribution -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<div class="form-field-highlight primary compact">\n\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t<div class="form-field-container l centered-contents">\n\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.pension.HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t<number-picker field-name="pensionEmployerPercent" heading="% Employer" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="$ctrl.pensionGroup.EmployerPercentMinimum" ng-model="$ctrl.pension.PensionEmployerPercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution" theme="{\'tertiary\': $ctrl.pensionWarningState}"></number-picker>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.pension.HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t<label class="required" for="pensionEmployerFixedAmount">\n\t\t\t\t\t\t\t\t\t\t\t\tEmployer contribution:\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t<input class="monetise" min="0" name="pensionEmployerFixedAmount" ng-class="{\'tertiary\': $ctrl.pensionWarningState }" ng-model="$ctrl.pension.PensionEmployerFixedAmount" required type="number">\n\t\t\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionTeamContributionsAeForm.pensionEmployerFixedAmount.$touched" ng-messages="pensionTeamContributionsAeForm.pensionEmployerFixedAmount.$error" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-field-footer l">\n\t\t\t\t\t\t\t<div class="toggle-control inline primary">\n\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active greyscale\': !$ctrl.pension.HasFixedEmployerContribution\n\t\t\t\t\t\t\t\t\t}"> % Percentage</span>\n\t\t\t\t\t\t\t\t<a class="toggle-a is-small toggle-control-toggle primary {{$ctrl.pension.HasFixedEmployerContribution ? \'active \': \'primary\'}}" href="" ng-click="$ctrl.toggleTeamMemberCustomEmployerContributionType($ctrl.pension, $ctrl.pensionGroup)"></a>\n\t\t\t\t\t\t\t\t<span class="toggle-control-label" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'active greyscale\': $ctrl.pension.HasFixedEmployerContribution\n\t\t\t\t\t\t\t\t\t}">\xA3 Fixed</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<footer class="form-field-footer">\n\t\t\t\t\t<div class="form-errors fadeIn" ng-if="pensionTeamContributionsAeForm.pensionEmployerPercent.$dirty" ng-messages="pensionTeamContributionsAeForm.pensionEmployerPercent.$error" role="alert">\n\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.pensionGroup.EmployerPercentMinimum}}%</p>\n\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t</div>\n\t\t\t\t</footer>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<p class="form-note">\n\t\t\t<strong>Note:</strong>\n\t\t\t{{$ctrl.formOptions.context.Forename}} will still belong to the group &lsquo;{{$ctrl.pensionGroup.PensionGroupName}}&rsquo;\n\t\t\tbut they will have different contribution rates applied to their pension.\n\t\t</p>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t\t<div class="form-warning with-icon fadeIn tertiary" ng-if="$ctrl.pensionWarningState" ng-switch="$ctrl.pensionWarningState">\n\t\t\t\t<div class="form-warning-icon">\n\t\t\t\t<i class="icon-information"></i>\n\t\t\t</div>\n\t\t\t<div class="form-warning-content">\n\t\t\t\t<p ng-switch-when="percentage">\n\t\t\t\t\tThe contribution amounts you\u2019ve added mean the combined contribution will be lower than {{$ctrl.pensionGroup.totalPercent}}% of\n\t\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s pensionable pay. By clicking save you are consenting to paying less than the workplace pension minimum requirement.\n\t\t\t\t</p>\n\t\t\t\t<p ng-switch-when="fixed">\n\t\t\t\t\tAs at least one of the pension contributions are set to be a fixed value therefore compliance checks cannot be performed until payroll has been calculated.\n\t\t\t\t\tFixed value contributions can sometimes go below the minimum overall percentage set by The Pensions Regulator. If contributions go below the minimum,\n\t\t\t\t\tyou will receive a warning when you calculate payroll.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Feedback -->\n\t\t<form-feedback ng-if="pensionTeamContributionsAeForm.state === \'saved\'" state="pensionTeamContributionsAeForm.state">\n\t\t\t<p>\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution details have been updated\n\t\t\t</p>\n\t\t</form-feedback>\n\n\t\t<!-- Back -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack">Back</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="pensionTeamContributionsAeForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamContributionsAeForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a class="button tertiary-action" href="" ng-click="$ctrl.formOptions.skip()" ng-if="$ctrl.formOptions.canSkip">Skip</a>\n\t</fieldset>\n</form>\n\n<!-- Pension requires authorisation -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="false" fs-theme="primary" fs-title="Please &lsquo;Authorise&rsquo; this pension" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.pensionAuthorisationRequired">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tBefore you can edit groups and contribution levels, you need to &lsquo;Authorise&rsquo; this pension by clicking on the\n\t\t\t&quot;Authorise&quot; button on the company pension page. This will allow Paycircle to access the pension\n\t\t</p>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<a class="button primary primary-action" ui-sref="pensions.scheme.status({agencyProfileId: $ctrl.formOptions.agencyProfileId, agencyEmployerPensionId: $ctrl.pension.AgencyEmployerPensionID})">\n\t\t\tAuthorise pension now\n\t\t</a>\n\t</fs-actions>\n</form-state>\n\n<!-- No pension group -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Please select a pension group" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.noPensionGroup">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{$ctrl.formOptions.context.Forename}} hasn\'t been added to a pension group. Once added to a pension group you will be able to set\n\t\t\ttheir contribution rates.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Excluded -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Excluded from workplace pension" ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.excluded">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{$ctrl.formOptions.context.Forename}} has been excluded from the workplace pension.\n\t\t\tExcluded team members will still be assessed as normal,\n\t\t\tthey just won\'t ever be enrolled or be entitled to ask to join the pension.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === $ctrl.PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/team/contributions-non-ae/pension-team-contributions-non-ae.form.html','<loading-block ng-if="$ctrl.componentState === \'loading\'"></loading-block>\n\n<form name="pensionTeamContributionsNonAeForm" ng-submit="$ctrl.updateTeamMemberPension($ctrl, pensionTeamContributionsNonAeForm)" class="fadeIn" ng-if="$ctrl.componentState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<h6 class="strong">Contribution settings</h6>\n\t\t<p class="is-small">Select a contribution band, and {{$ctrl.formOptions.context.Forename}}\u2019s contribution amounts will be shown for each based on {{$ctrl.formOptions.context.Gender | personalise:\'his\'}} current pay information, or add custom contribution rates.</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\t\t\t\t<extended-radio name="hasCustomContributionRates" value="false" ng-model="$ctrl.pension.HasCustomContributionPercent" on-change="$ctrl.onContributionTypeChange($ctrl)">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Contribution band</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-field>\n\t\t\t\t\t\t<select class="l" name="contributionBand" id="contributionBand" ng-disabled="$ctrl.pension.HasCustomContributionPercent || $ctrl.pensionGroups.length === 1" ng-model="$ctrl.pensionGroup" ng-options="option as option.PensionGroupName for option in $ctrl.pensionGroups" required>\n\t\t\t\t\t\t\t<option value="" selected="selected" hidden disabled="disabled">Please select...</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</radio-field>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<pension-team-group form-options="$ctrl.formOptions" pension="$ctrl.pension" pension-group="$ctrl.pensionGroup"></pension-team-group>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t\t<extended-radio name="hasCustomContributionRates" value="true" ng-model="$ctrl.pension.HasCustomContributionPercent" on-change="$ctrl.onContributionTypeChange($ctrl)">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">Custom contribution rates</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\n\t\t\t\t\t\t<!-- Contribution type -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t<div class="toggle-block primary">\n\t\t\t\t\t\t\t\t\t<span class="toggle-block-label left" ng-class="{\'active\': !$ctrl.pension.HasFixedEmployeeContribution}"> % Percentage</span>\n\t\t\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.toggleTeamMemberCustomContributionType($ctrl)" class="toggle-block-toggle">\n\t\t\t\t\t\t\t\t\t\t<span class="toggle-c primary" ng-class="{\'active\' : $ctrl.pension.HasFixedEmployeeContribution }"></span>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<span class="toggle-block-label right" ng-class="{\'active\': $ctrl.pension.HasFixedEmployeeContribution}">\xA3 Fixed</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Contributions -->\n\t\t\t\t\t\t<div class="form-field-group">\n\n\t\t\t\t\t\t\t<!-- Employee Contribution -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="form-field-container l centered-contents">\n\t\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.pension.HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t\t\t\t<number-picker field-name="pensionEmployeePercent" heading="% Employee" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="$ctrl.pensionGroup.EmployeePercentMinimum" ng-model="$ctrl.pension.PensionEmployeePercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution"></number-picker>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.pension.HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="pensionEmployeeFixedAmount" class="required">Employee contribution:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="number" name="pensionEmployeeFixedAmount" class="monetise" ng-model="$ctrl.pension.PensionEmployeeFixedAmount" min="0" required>\n\t\t\t\t\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="pensionTeamContributionsNonAeForm.pensionEmployeeFixedAmount.$error" ng-if="pensionTeamContributionsNonAeForm.pensionEmployeeFixedAmount.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<footer class="form-field-footer">\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="pensionTeamContributionsNonAeForm.pensionEmployeePercent.$error" ng-if="pensionTeamContributionsNonAeForm.pensionEmployeePercent.$dirty" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.pensionGroup.EmployeePercentMinimum}}%</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Employer Contribution -->\n\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t\t\t\t<div class="form-field-container l centered-contents">\n\t\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="!$ctrl.pension.HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t\t\t<number-picker field-name="pensionEmployerPercent" heading="% Employer" is-editable="true" max="$root.CONFIG.pensionMaximumPercentageContribution" min="$ctrl.pensionGroup.EmployerPercentMinimum" ng-model="$ctrl.pension.PensionEmployerPercent" ng-pattern="$root.REGEX.decimalFourPlaces" sub-heading="contribution"></number-picker>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="fadeIn" ng-if="$ctrl.pension.HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="pensionEmployerFixedAmount" class="required">Employer contribution:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t\t\t<main class="form-field-main">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="number" name="pensionEmployerFixedAmount" class="monetise" ng-model="$ctrl.pension.PensionEmployerFixedAmount" min="0" required>\n\t\t\t\t\t\t\t\t\t\t\t\t</main>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="pensionTeamContributionsNonAeForm.pensionEmployerFixedAmount.$error" ng-if="pensionTeamContributionsNonAeForm.pensionEmployerFixedAmount.$touched" role="alert">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Please enter a positive number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<footer class="form-field-footer">\n\t\t\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-messages="pensionTeamContributionsNonAeForm.pensionEmployerPercent.$error" ng-if="pensionTeamContributionsNonAeForm.pensionEmployerPercent.$dirty" role="alert">\n\t\t\t\t\t\t\t\t\t\t<p ng-message="number">Please enter a valid number</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="required">Please enter an amount</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="min">Minimum of {{$ctrl.pensionGroup.EmployerPercentMinimum}}%</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="max">Maximum of {{$root.CONFIG.pensionMaximumPercentageContribution}}%</p>\n\t\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Please enter a valid number with no more than 4 decimal places</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</footer>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Salary sacrifice -->\n\t\t\t\t\t\t<div class="form-field">\n\t\t\t\t\t\t\t<header class="form-field-header">\n\t\t\t\t\t\t\t\t<label class="required" for="salary-sacrifice-true">Is this salary sacrifice?</label>\n\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t<div class="field">\n\t\t\t\t\t\t\t\t<div class="radio-list radio-list--inline is-not-spaced">\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input type="radio" name="salary-sacrifice-true" id="salary-sacrifice-true" class="b" ng-value="true" ng-model="$ctrl.pension.IsSalarySacrifice">\n\t\t\t\t\t\t\t\t\t\t<label for="salary-sacrifice-true">Yes</label>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t\t\t\t\t<input type="radio" name="salary-sacrifice-false" id="salary-sacrifice-false" class="b" ng-value="false" ng-model="$ctrl.pension.IsSalarySacrifice">\n\t\t\t\t\t\t\t\t\t\t<label for="salary-sacrifice-false">No</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset ng-if="::$ctrl.pension.PensionState !== $ctrl.PENSION_ENROLMENT_STATES.removed">\n\t\t<div class="form-intro">\n\t\t\t<p class="is-small">\n\t\t\t\tBy default, the first time you run payroll will be used as the date that {{$ctrl.formOptions.context.Forename}} joined this pension scheme. If you\u2019d like to add an earlier join date for {{$ctrl.formOptions.context.Forename}}, you can do so below.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<!-- Toggle -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<toggle-input field-name="hasEarlierJoinDate" field-model="$ctrl.hasEarlierJoinDate" field-label="Add earlier join date"></toggle-input>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Date -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.hasEarlierJoinDate">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label class="required" for="joinedDate">Join date:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<date-input-field field-id="joinedDate" field-required="true" field-value-iso="$ctrl.pension.PensionJoinedDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t\t<div class="form-errors fadeIn" ng-messages="pensionTeamContributionsNonAeForm.joinedDate.$error" ng-if="pensionTeamContributionsNonAeForm.joinedDate.$touched" role="alert">\n\t\t\t\t<p ng-message="required">Please enter the earlier join date</p>\n\t\t\t\t<p ng-message="date">Please enter a valid date, like this: dd/mm/yyyy</p>\n\t\t\t</div>\n\t\t\t<p class="form-message">\n\t\t\t\tPlease note that contributions can only be recorded for team members from the first time you run payroll and this start date is just for your records.\n\t\t\t</p>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamContributionsNonAeForm.state" disable-button="!pensionTeamContributionsNonAeForm.$valid"></submit-button>\n\t\t<a href="" ng-if="$ctrl.formOptions.canSkip" class="button tertiary-action" ng-click="$ctrl.formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Contributions saved" ng-if="$ctrl.componentState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small">{{$ctrl.formOptions.context.Forename}}\'s pension contribution settings have been saved and will be used when you next run payroll.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.componentState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/groups/pension-team-groups.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="pensionTeamGroupsForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateTeamMemberPension($ctrl, pensionTeamGroupsForm)" novalidate>\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h6 class="strong">Choose a group for {{$ctrl.formOptions.context.Forename}}</h6>\n\t\t\t<p class="s">\n\t\t\t\t{{$ctrl.formOptions.context.Forename}}\'s contribution amounts are shown for each group based\n\t\t\t\ton their current pay information. Select a group and click \'Save\' to add them to that group.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main extended-radio_wrapper">\n\n\t\t\t\t<extended-radio always-show-content="true" has-click-anywhere="true" id="pension-group-{{$index}}" name="pensionGroup" ng-model="$ctrl.pension.PensionGroupID" ng-repeat="pensionGroup in $ctrl.pensionGroups | orderBy:\'PensionGroupName\'" not-empty-guid theme="is-secondary has-hover" value="pensionGroup.PensionGroupID">\n\t\t\t\t\t<radio-label>\n\t\t\t\t\t\t<h6 class="is-medium is-greyscale-dark">{{pensionGroup.PensionGroupName}}</h6>\n\t\t\t\t\t</radio-label>\n\n\t\t\t\t\t<radio-content>\n\t\t\t\t\t\t<pension-team-group form-options="$ctrl.formOptions" pension-group="pensionGroup" pension="$ctrl.pension" theme="is-secondary"></pension-team-group>\n\t\t\t\t\t</radio-content>\n\t\t\t\t</extended-radio>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No groups -->\n\t\t<div class="form-field" ng-if="$ctrl.pensionGroups.length === 0">\n\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="There are no groups available in your pension">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small" ng-if="$ctrl.scheme.ConnectToProvider">You will need to create at least one pension group in your provider portal so you can add team members to it.\n\t\t\t\t\t\t<a class="underline tertiary" ng-href="{{$ctrl.scheme.PensionProviderWebsiteUrl}}" target="_blank">Go to your provider portal</a>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="is-small" ng-if="!$ctrl.scheme.ConnectToProvider">You will need to create at least one pension group so you can add team members to it.\n\t\t\t\t\t\t<a class="underline tertiary" ui-sref="pensions.scheme.settings({agencyProfileId: $ctrl.formOptions.agencyProfileId, agencyEmployerPensionId: $ctrl.formOptions.agencyEmployerPensionId})">Add pension group</a></p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<!-- Back -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack">Back</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="pensionTeamGroupsForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamGroupsForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Excluded -->\n<form-state form-options="$ctrl.formOptions" fs-icon="warning" fs-title="Excluded from workplace pension" ng-if="$ctrl.pageState === \'excluded\'">\n\t<fs-main>\n\t\t<p class="s">{{$ctrl.formOptions.context.Forename}} has been excluded from the workplace pension.\n\t\t\tExcluded team members will still be assessed as normal, they just won\'t ever be enrolled or be entitled to ask to join the pension.</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/team/manage-pensions/pension-team-manage-pensions.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<div ng-if="$ctrl.formState === \'ready\'" class="slide-in-form-content">\n\n\t<fieldset>\n\t\t<div class="form-intro">\n\t\t\t<p>Select a pension scheme to manage:</p>\n\t\t</div>\n\n\t\t<!-- Select pension -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-main pension-scheme-row_wrapper">\n\t\t\t\t<pension-scheme-row ng-repeat="pension in $ctrl.pensions" ng-model="$ctrl.selectedPension.AgencyEmployerPensionID" pension="pension" pension-index="$index" field-name="selectedPension">\n\t\t\t\t\t<pension-content>\n\t\t\t\t\t\t<div class="link-list">\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openPensionTeamFormByKey($ctrl, pension, \'pension-team-status\')" ng-if="pension.CanUpdatePensionStatus || pension.CanUpdatePensionStatusFull">Pension status</a>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openPensionTeamFormByKey($ctrl, pension, \'pension-team-bands\')" ng-if="pension.CanUpdatePensionBand">Pension band</a>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openPensionTeamFormByKey($ctrl, pension, \'pension-team-groups\')" ng-if="pension.CanUpdatePensionGroup">Pension group</a>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openPensionTeamFormByKey($ctrl, pension, \'pension-team-contributions-non-ae\')" ng-if="pension.CanUpdatePensionSetup">Pension contributions</a>\n\t\t\t\t\t\t\t<a href="" ng-click="$ctrl.openPensionTeamFormByKey($ctrl, pension, \'pension-team-contributions-ae\')" ng-if="pension.CanUpdatePensionContributions">Pension contributions</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</pension-content>\n\t\t\t\t</pension-scheme-row>\n\t\t\t</div>\n \t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t</fieldset>\n</div>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/postponement/pension-team-postponement.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionTeamPostponementForm" ng-submit="$ctrl.savePensionPostponement($ctrl, pensionTeamPostponementForm)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<div class="form-intro">\n\t\t<p class="s">\n\t\t\tNew team members are set to&nbsp;<ng-pluralize count="$ctrl.postponementSettings.NewStarterPostponementLength" when="{\'0\': \'not be postponed\', \'1\': \'postponed for 1\' + $ctrl.payPeriodTypeDescriptionSingular, \'other\': \'postponed for {} \' + $ctrl.payPeriodTypeDescriptionPlural}"></ng-pluralize>&nbsp;in your pension settings page. If you wish to postpone {{$ctrl.formOptions.context.Forename}} for a different number of {{$ctrl.postponementSettings.PayPeriodType | payPeriodTypeDescription:\'months\'}}, or not to postpone {{$ctrl.formOptions.context.Gender | personalise:\'him\'}} at all, you can customise {{$ctrl.formOptions.context.Gender | personalise:\'his\'}} postponement below.\n\t\t</p>\n\t</div>\n\n\t<fieldset>\n\n\t\t<!-- Customise? -->\n\t\t<div class="form-field">\n\t\t\t<div class="field">\n\t\t\t\t<input type="checkbox" id="checkboxField" name="checkboxField" ng-model="$ctrl.pension.HasCustomPostponement" label-text="\'Customise \' + $ctrl.formOptions.context.Forename + \'\\\'s postponement\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Postponement Options -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.HasCustomPostponement">\n\t\t\t<label for="postponeNewStarters">How long would you like to postpone {{$ctrl.formOptions.context.Gender | personalise:\'him\'}} for?</label>\n\t\t\t<div class="field">\n\t\t\t\t<select id="postponeNewStarters" name="postponeNewStarters" ng-model="$ctrl.pension.PensionPostpone" required>\n\t\t\t\t\t<option ng-value="option" ng-repeat="option in $ctrl.postponementLengthOptions" ng-pluralize count="option" when="{\'0\': \'No postponement\', \'1\': \'Postpone for 1 \' + $ctrl.payPeriodTypeDescriptionSingular, \'other\': \'Postpone for {} \' + $ctrl.payPeriodTypeDescriptionPlural}"></option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<p class="form-message">Note: this setting only applies to {{$ctrl.formOptions.context.Forename}}</p>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\n\t\t<!-- Close -->\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamPostponementForm.state" disable-button="!pensionTeamPostponementForm.$valid"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a href="" ng-if="$ctrl.formOptions.canSkip" class="button tertiary-action" ng-click="$ctrl.formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/remove/pension-team-remove.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionTeamRemoveForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.saveForm($ctrl, pensionTeamRemoveForm)">\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to remove {{$ctrl.formOptions.context.Forename}} from this pension?">\n\t\t<fs-main>\n\n\t\t\t<div ng-if="::$ctrl.isNonAeNotEnrolledView">\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tOnce you click \u2018Remove\u2019, {{::$ctrl.formOptions.context.Forename}} will be removed from the \u2018{{::$ctrl.teamMemberPension.PensionProviderName}}\u2019\n\t\t\t\t\tpension scheme. They can easily be added to again later from their profile or your Pensions area.\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div ng-if="::!$ctrl.isNonAeNotEnrolledView">\n\n\t\t\t\t<!-- Pension payments have been made -->\n\t\t\t\t<p class="is-small" ng-if="::$ctrl.teamMemberPension.CanArchiveFromPension">\n\t\t\t\t\t{{::$ctrl.formOptions.context.Forename}} will be removed from this pension with immediate effect and will no longer make\n\t\t\t\t\tcontributions. Their contribution history can always be viewed in the pension area in their profile, and they\n\t\t\t\t\tcan rejoin the pension at any time. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\n\t\t\t\t<!-- No pension payments have been made -->\n\t\t\t\t<p class="is-small" ng-if="::$ctrl.teamMemberPension.CanRemoveFromPension">\n\t\t\t\t\t{{::$ctrl.formOptions.context.Forename}} will be removed from this pension with immediate effect and will no longer make\n\t\t\t\t\tcontributions. Click \u2018Confirm\u2019 if you\u2019re happy to continue.\n\t\t\t\t</p>\n\n\t\t\t</div>\n\n\t\t\t<div class="form-summary less-margin" ng-if="!$ctrl.formOptions.context.IsInSetupMode">\n\t\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Payroll changes for pension elements">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tPlease note that if you\'ve added payroll changes to your current period or an in-progress supplementary\n\t\t\t\t\t\t\tpay run for {{$ctrl.formOptions.context.Forename}} using pension-related elements, and selected this pension scheme,\n\t\t\t\t\t\t\tthose changes will be deleted when you click \u2018Confirm\u2019.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</div>\n\n\t\t</fs-main>\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button disable-button="!pensionTeamRemoveForm.$valid" display-text="\'Confirm\'" state="pensionTeamRemoveForm.state"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n</form>\n\n<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Removed from pension" ng-if="$ctrl.pageState === \'saved\'">\n\t<fs-main>\n\t\t<p class="is-small" ng-if="::$ctrl.isNonAeNotEnrolledView">\n\t\t\t{{::$ctrl.formOptions.context.Forename}} has been removed from the \u2018{{::$ctrl.teamMemberPension.PensionProviderName}}\u2019 pension scheme.\n\t\t</p>\n\t\t<p class="is-small" ng-if="::!$ctrl.isNonAeNotEnrolledView">\n\t\t\t{{::$ctrl.formOptions.context.Forename}} has been removed from this pension scheme and their contributions have stopped.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('forms/pension/team/salary-sacrifice/pension-team-salary-sacrifice.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="pensionTeamSalarySacrificeForm" class="fadeIn" ng-submit="$ctrl.updateTeamMemberPension($ctrl, pensionTeamSalarySacrificeForm)" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<div class="form-intro">\n\t\t\t<h4>Salary sacrifice</h4>\n\t\t\t<p>{{$ctrl.formOptions.context.Forename}} is a member of \u2018{{$ctrl.pension.PensionGroupName}}\u2019 which is a salary sacrifice pension group. By default, {{$ctrl.formOptions.context.Gender | personalise:\'her\'}} contributions will be taken from {{$ctrl.formOptions.context.Gender | personalise:\'her\'}} gross pay and {{$ctrl.formOptions.company.Name}} will pay the total contributions each pay period.</p>\n\n\t\t\t<p>If you don\u2019t wish to use a salary sacrifice for {{$ctrl.formOptions.context.Forename}}\'s contributions, uncheck the box below. This change will only apply to {{$ctrl.formOptions.context.Forename}} and won\u2019t affect the pension group settings.</p>\n\t\t</div>\n\n\t\t<!-- Use salary sacrifice -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input type="checkbox" id="isSalarySacrifice" name="isSalarySacrifice" ng-model="$ctrl.pension.IsSalarySacrifice" label-text="\'Use salary sacrifice for \' + $ctrl.formOptions.context.Forename + \'\\\'s contributions\'" checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamSalarySacrificeForm.state" disable-button="pensionTeamSalarySacrificeForm.$invalid"></submit-button>\n\t\t<a href="" ng-if="$ctrl.formOptions.canSkip" class="button tertiary-action" ng-click="$ctrl.formOptions.skip()">Skip</a>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/scheme-ae/pension-team-scheme-ae.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="$ctrl.$form" ng-submit="$ctrl.updateTeamMemberPension($ctrl)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Select pension -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pension-0" class="l" ng-class="{\'required\': !$ctrl.selectedPension.PensionIsExcluded, \'disabled\': $ctrl.selectedPension.PensionIsExcluded }">Select a pension for {{$ctrl.formOptions.context.Forename}}:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main pension-scheme-row_wrapper">\n\t\t\t\t<pension-scheme-row field-disabled="!$ctrl.isPensionSwitchEnabled || $ctrl.selectedPension.PensionIsExcluded" field-name="selectedPension" field-required="!$ctrl.selectedPension.PensionIsExcluded" ng-model="$ctrl.selectedPension.AgencyEmployerPensionID" ng-repeat="pension in $ctrl.pensions" pension="pension" pension-index="$index"></pension-scheme-row>\n\t\t\t</div>\n \t\t</div>\n\n \t</fieldset>\n\n \t<fieldset class="form-fieldset-divider-top">\n\n \t\t<!-- Exclude from all pensions -->\n \t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input checkbox id="pensionIsExcluded" label-text="\'Exclude \' + $ctrl.formOptions.context.Forename + \' from all AE pensions\'" name="pensionIsExcluded" ng-disabled="!$ctrl.isPensionSwitchEnabled" ng-model="$ctrl.selectedPension.PensionIsExcluded" type="checkbox">\n\t\t\t</div>\n\t\t\t<p class="form-message" ng-if="$ctrl.selectedPension.IsAssessedAutomatically">Excluded team members will still be assessed as normal, they just won\'t ever be enrolled or be entitled to ask to join a pension.</p>\n\t\t\t<p class="form-message" ng-if="!$ctrl.selectedPension.IsAssessedAutomatically">You won\'t be able to enrol excluded team members and they won\'t be entitled to ask to join a pension.</p>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.selectedPension.PensionIsExcluded">\n\t\t\t<note note-title="Payroll changes for pension elements" note-theme="indifferent" note-icon="icon-support" note-dismiss="true">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">Please note that if you\'ve added payroll changes to your current period for {{$ctrl.formOptions.context.Forename}} using pension-related elements, and selected this pension scheme, those changes will be deleted when you click \'Save\'.</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="$ctrl.$form.state" disable-button="$ctrl.$form.$invalid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Pension not set up -->\n<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-title="Please set up your workplace pension" ng-if="$ctrl.pageState === \'no-pension\'">\n\t<fs-main>\n\t\t<p class="s">You need to <a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">set up your workplace pension</a> before you can start adding pension information to your team members. To start setting up your pension, <a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">visit your Pensions page</a> and follow the simple set up steps. It should only take ten minutes!</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/scheme-non-ae/pension-team-scheme-non-ae.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<form name="$ctrl.$form" ng-submit="$ctrl.updateTeamMembersInPension($ctrl)" class="fadeIn" ng-if="$ctrl.pageState === \'ready\'" novalidate>\n\n\t<fieldset>\n\n\t\t<!-- Select pension -->\n \t\t<div class="form-field">\n\t\t\t<header class="form-field-header">\n\t\t\t\t<label for="pension-0" class="is-large required">Select a pension for {{$ctrl.formOptions.context.Forename}}:</label>\n\t\t\t</header>\n\t\t\t<div class="form-field-main pension-scheme-row_wrapper">\n\t\t\t\t<pension-scheme-row field-name="selectedPension" field-required="true" ng-model="$ctrl.selectedPension.AgencyEmployerPensionID" ng-repeat="pension in $ctrl.pensions" pension="pension" pension-index="$index"></pension-scheme-row>\n\t\t\t</div>\n \t\t</div>\n\n \t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" ng-if="$ctrl.formOptions.canGoBack" class="button secondary-action" ng-click="$ctrl.formOptions.back()">Back</a>\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button display-text="$ctrl.formOptions.primaryButtonText" state="$ctrl.$form.state" disable-button="$ctrl.$form.$invalid"></submit-button>\n\t</fieldset>\n</form>\n\n<!-- Pension not set up -->\n<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-title="Please set up your workplace pension" ng-if="$ctrl.pageState === \'no-pension\'">\n\t<fs-main>\n\t\t<p class="s">You need to <a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">set up your workplace pension</a> before you can start adding pension information to your team members. To start setting up your pension, <a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">visit your Pensions page</a> and follow the simple set up steps. It should only take ten minutes!</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/pension/team/status/pension-team-status.form.html','<loading-block ng-if="$ctrl.pageState === \'loading\'"></loading-block>\n\n<!-- Update pension state (manual pensions only) -->\n<form class="fadeIn" name="pensionTeamStatusForm" ng-if="$ctrl.pageState === \'ready\'" ng-submit="$ctrl.updateTeamMemberPension($ctrl, pensionTeamStatusForm)" novalidate>\n\t<!-- Pension state -->\n\t<fieldset class="fadeIn" ng-disabled="$ctrl.pension.PensionIsExcluded && $ctrl.pension.IsAssessedAutomatically">\n\t\t<!-- Info (new starters only) -->\n\t\t<div class="form-section" ng-if="$ctrl.teamMemberCompany.IsStarter && $ctrl.pension.IsAssessedAutomatically">\n\t\t\t<div class="note">\n\t\t\t\t<p class="s">\n\t\t\t\t\tAs {{$ctrl.formOptions.context.Forename}} is a new starter {{$ctrl.formOptions.context.Gender | personalise:\'he\'}} will be assessed automatically, so you don\'t need to set {{$ctrl.formOptions.context.Gender | personalise:\'his\'}} pension status.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Reference number -->\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-header">\n\t\t\t\t<label for="pensionReference">Reference number:</label>\n\t\t\t</div>\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input class="l-alt" id="pensionReference" maxlength="32" name="pensionReference" ng-model="$ctrl.pension.ReferenceNumber" type="text">\n\t\t\t</div>\n\t\t\t<div class="form-field-footer">\n\t\t\t\t<p class="form-note">\n\t\t\t\t\tMaximum 32 characters\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pension Status -->\n\t\t<div class="form-field">\n\t\t\t<label class="l" ng-class="{required: !$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter}">\n\t\t\t\tWhat is {{$ctrl.formOptions.context.Forename}}\'s pension status?\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<div class="radio-list-50-50">\n\t\t\t\t\t<div class="radio-list-item" ng-if="$ctrl.pension.CanUpdatePensionStatusFull">\n\t\t\t\t\t\t<input class="b" id="pensionStateEnrolled" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.enrolled" type="radio">\n\t\t\t\t\t\t<label for="pensionStateEnrolled">Enrolled</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="pensionStateOptedIn" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.optedIn" type="radio">\n\t\t\t\t\t\t<label for="pensionStateOptedIn">Opted In</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="pensionStateJoined" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.joined" type="radio">\n\t\t\t\t\t\t<label for="pensionStateJoined">Joined</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="pensionStateCeased" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.ceased" type="radio">\n\t\t\t\t\t\t<label for="pensionStateCeased">Ceased Membership</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item">\n\t\t\t\t\t\t<input class="b" id="pensionStateOptedOut" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.optedOut" type="radio">\n\t\t\t\t\t\t<label for="pensionStateOptedOut">Opted Out</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="radio-list-item" ng-if="$ctrl.pension.CanUpdatePensionStatusFull">\n\t\t\t\t\t\t<input class="b" id="pensionStateNotEnrolled" name="pensionStatus" ng-model="$ctrl.pension.PensionState" ng-required="!$ctrl.pension.PensionIsExcluded && !$ctrl.teamMemberCompany.IsStarter" ng-value="$ctrl.PENSION_STATUSES.notEnrolled" type="radio">\n\t\t\t\t\t\t<label for="pensionStateNotEnrolled">Not enrolled</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Enrolment Date -->\n\t\t<div class="form-field fadeIn" ng-if="[\n\t\t\t\t$ctrl.PENSION_STATUSES.enrolled,\n\t\t\t\t$ctrl.PENSION_STATUSES.optedOut,\n\t\t\t\t$ctrl.PENSION_STATUSES.optedIn,\n\t\t\t\t$ctrl.PENSION_STATUSES.ceased\n\t\t\t].includes($ctrl.pension.PensionState)">\n\t\t\t<label class="required" for="enrolmentdate" ng-class="{disabled: $ctrl.pension.PensionIsExcluded}">\n\t\t\t\tEnrolment date:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field class="fadeIn" field-title="Enrolment date:" field-id="enrolmentdate" field-value-iso="$ctrl.pension.PensionEnrolledDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Opt Out Date -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_STATUSES.optedOut">\n\t\t\t<label class="required" for="optoutDate" ng-class="{disabled: $ctrl.pension.PensionIsExcluded}">\n\t\t\t\tOpt out date:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field class="fadeIn" field-title="Opt out date:" field-id="optoutDate" field-value-iso="$ctrl.pension.PensionOptOutDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Ceased Date -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_STATUSES.ceased">\n\t\t\t<label class="required" for="ceasedDate" ng-class="{disabled: $ctrl.pension.PensionIsExcluded}">\n\t\t\t\tCeased date:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field class="fadeIn" field-title="Ceased date:" field-id="ceasedDate" field-value-iso="$ctrl.pension.PensionCeaseDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Joined date -->\n\t\t<div class="form-field fadeIn" ng-if="$ctrl.pension.PensionState === $ctrl.PENSION_STATUSES.joined">\n\t\t\t<label class="required" for="joinedDate">\n\t\t\t\tJoined date:\n\t\t\t</label>\n\t\t\t<div class="field">\n\t\t\t\t<date-input-field class="fadeIn" field-title="Joined date:" field-id="joinedDate" field-value-iso="$ctrl.pension.PensionJoinedDateISO">\n\t\t\t\t</date-input-field>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset class="form-fieldset-divider-top" ng-if="$ctrl.pension.CanUpdatePensionStatusFull">\n\t\t<div class="form-field">\n\t\t\t<div class="form-field-main">\n\t\t\t\t<input id="PensionIsExcluded" label-text="\'Exclude \' + $ctrl.formOptions.context.Forename + \' from all AE pensions\'" name="PensionIsExcluded" ng-model="$ctrl.pension.PensionIsExcluded" type="checkbox" checkbox>\n\t\t\t</div>\n\t\t\t<p class="form-message" ng-if="$ctrl.pension.IsAssessedAutomatically">\n\t\t\t\tExcluded team members will still be assessed as normal, they just won\'t ever be enrolled or be entitled to ask to join a pension.\n\t\t\t</p>\n\t\t\t<p class="form-message" ng-if="!$ctrl.pension.IsAssessedAutomatically">\n\t\t\t\tYou won\'t be able to enrol excluded team members and they won\'t be entitled to ask to join a pension.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="form-field fadeIn" ng-if="!$ctrl.formOptions.context.IsInSetupMode && $ctrl.pension.PensionIsExcluded">\n\t\t\t<note note-dismiss="true" note-icon="icon-support" note-theme="indifferent" note-title="Payroll changes for pension elements">\n\t\t\t\t<note-content>\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tPlease note that if you\'ve added payroll changes to your current period or an in-progress supplementary pay run for {{$ctrl.formOptions.context.Forename}} using pension-related elements, and selected this pension scheme, those changes will be deleted when you click \'Save\'.\n\t\t\t\t\t</p>\n\t\t\t\t</note-content>\n\t\t\t</note>\n\t\t</div>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\n\t\t<!-- Back -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.back()" ng-if="$ctrl.formOptions.canGoBack">\n\t\t\tBack\n\t\t</a>\n\n\t\t<!-- Close -->\n\t\t<a class="button secondary-action" href="" ng-click="$ctrl.formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="pensionTeamStatusForm.$invalid" display-text="$ctrl.formOptions.primaryButtonText" state="pensionTeamStatusForm.state"></submit-button>\n\n\t\t<!-- Skip -->\n\t\t<a class="button tertiary-action" href="" ng-click="$ctrl.formOptions.skip()" ng-if="$ctrl.formOptions.canSkip">\n\t\t\tSkip\n\t\t</a>\n\t</fieldset>\n</form>\n\n<!-- Not manual pension -->\n<form-state form-options="$ctrl.formOptions" fs-title="Automatic pension" ng-if="$ctrl.pageState === \'not-manual\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tSince your workplace pension is handled automatically you cannot set pension states manually.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- Pension not set up -->\n<form-state form-options="$ctrl.formOptions" fs-icon="information" fs-title="Please set up your workplace pension" ng-if="$ctrl.pageState === \'no-pension\'">\n\t<fs-main>\n\t\t<p class="s">\n\t\t\tYou need to\n\t\t\t<a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">set up your workplace pension</a>\n\t\t\tbefore you can start adding pension information to your team members. To start setting up your pension,\n\t\t\t<a ui-sref="pensions.summary({agencyProfileId: $ctrl.formOptions.agencyProfileId})">visit your Pensions page</a>\n\t\t\tand follow the simple set up steps. It should only take ten minutes!\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="$ctrl.pageState === \'error\'" secondary-action-text="Ok, close this window" secondary-action="$ctrl.formOptions.closeForm()"></error-block>\n');
$templateCache.put('modules/security/components/password-input/password-input.component.html','<div class="password-input">\n\t<input compared-to="$ctrl.comparePassword" disable-autocomplete="{{$ctrl.disableAutocomplete}}" id="{{$ctrl.inputId}}" name="{{$ctrl.inputName}}" ng-change="$ctrl.onChangePassword()" ng-model="$ctrl.password" required type="{{$ctrl.inputType}}">\n\t<a aria-label="Toggle show password" class="is-greyscale password-input_toggle" href="" ng-click="$ctrl.toggleShowPassword()" ng-if="$ctrl.allowShowPassword">\n\t\t<i class="icon-{{$ctrl.inputType === \'text\' ? \'visible\' : \'hidden\'}} is-medium"></i>\n\t</a>\n</div>\n');
$templateCache.put('modules/security/components/password-strength-indicator/password-strength-indicator.component.html','<div class="password-strength-indicator fadeIn">\n\t<span class="password-strength-indicator-bar assertive"></span>\n\t<span class="password-strength-indicator-bar" ng-class="{\'indifferent\': passwordStrength > PASSWORD_STRENGTHS.weak}"></span>\n\t<span class="password-strength-indicator-bar" ng-class="{\'positive\': passwordStrength > PASSWORD_STRENGTHS.medium}"></span>\n\t\n\t<span class="password-strength-indicator-label" ng-switch="passwordStrength">\n\t\t<span pc-switch-when="PASSWORD_STRENGTHS.strong">Strong password</span>\n\t\t<span pc-switch-when="PASSWORD_STRENGTHS.medium">Could be stronger</span>\n\t\t<span ng-switch-default>Too weak</span>\n\t</span>\n</div>\n');
$templateCache.put('modules/security/forms/change-account-security-item/change-account-security-item.form.html','<loading-block ng-if="formState === FORM_STATES.loading"></loading-block>\n\n<form name="updateSecurityItemForm" ng-if="formState === FORM_STATES.ready" ng-submit="updateSecurityItem(updateSecurityItemForm)" ng-switch="vm.accountSecurityType">\n\t<div class="page-template-c_form-main">\n\t\t<fieldset>\n\t\t\t<!-- Current password entry - common to all account security types -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="password">\n\t\t\t\t\t\t{{vm.accountSecurityType === ACCOUNT_SECURITY_TYPES.password ? \'Current password\' : \'Password\'}}:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<password-input allow-show-password="true" disable-autocomplete="false" input-id="password" input-name="password" ng-change="onPasswordChange(updateSecurityItemForm)" ng-model="vm.securityItems.password"></password-input>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.password.$touched" ng-messages="updateSecurityItemForm.password.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter your current password\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="{{PASSWORD_INVALID}}">\n\t\t\t\t\t\tIncorrect password entered\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Specific security item, depending on context -->\n\t\t<!-- Change password mode -->\n\t\t<fieldset pc-switch-when="ACCOUNT_SECURITY_TYPES.password">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="newPassword">\n\t\t\t\t\t\tChoose a new password:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<validated-input-form-field allow-show-password="true" current-value="vm.securityItems.password" disable-autocomplete="true" field-name="Password" field-prompt="It must not be the same as your previous 12 passwords and must contain" input-name="newPassword" ng-model="vm.securityItems.newPassword" validation-type="{{INPUT_VALIDATION_TYPES.password}}">\n\t\t\t\t\t\t<vi-errors>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.newPassword.$invalid && updateSecurityItemForm.newPassword.$touched" ng-messages="updateSecurityItemForm.newPassword.$error">\n\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter a new password\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="form-field_error" ng-message="sameasexisting">\n\t\t\t\t\t\t\t\t\tThis must be different to your existing password\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</vi-errors>\n\t\t\t\t\t</validated-input-form-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- New password confirmation -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="confirmNewPassword">\n\t\t\t\t\t\tConfirm new password:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<password-input allow-show-password="true" compare-password="vm.securityItems.newPassword" disable-autocomplete="true" input-id="confirmNewPassword" input-name="confirmNewPassword"></password-input>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.confirmNewPassword.$invalid && updateSecurityItemForm.confirmNewPassword.$touched" ng-messages="updateSecurityItemForm.confirmNewPassword.$error">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease confirm your new password\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="comparison">\n\t\t\t\t\t\tPlease make sure your passwords match\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Change username mode -->\n\t\t<fieldset pc-switch-when="ACCOUNT_SECURITY_TYPES.username">\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="newUsername">\n\t\t\t\t\t\tChoose a new username:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<validated-input-form-field current-value="vm.securityItems.username" disable-autocomplete="true" field-footnote="Please note that your username is not case-sensitive" field-name="Username" field-prompt="Your unique username should contain" input-name="newUsername" ng-model="vm.securityItems.newUsername" validation-type="{{INPUT_VALIDATION_TYPES.username}}">\n\t\t\t\t\t\t<vi-errors>\n\t\t\t\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.newUsername.$invalid && updateSecurityItemForm.newUsername.$touched" ng-messages="updateSecurityItemForm.newUsername.$error">\n\t\t\t\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\t\t\t\tPlease enter a new username\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p ng-message="usernameCheck">\n\t\t\t\t\t\t\t\t\tThis username already exists\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p ng-message="sameasexisting">\n\t\t\t\t\t\t\t\t\tThis is the same as your existing username\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</vi-errors>\n\t\t\t\t\t</validated-input-form-field>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- New username confirmation -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="confirmNewUsername">\n\t\t\t\t\t\tConfirm new username:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input compared-to="vm.securityItems.newUsername" id="confirmNewUsername" name="confirmNewUsername" ng-model="vm.securityItems.confirmNewUsername" type="text">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.confirmNewUsername.$invalid && updateSecurityItemForm.confirmNewUsername.$touched" ng-messages="updateSecurityItemForm.confirmNewUsername.$error">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease confirm your new username\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="comparison">\n\t\t\t\t\t\tPlease make sure your usernames match\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</fieldset>\n\n\t\t<!-- Change recovery email address mode -->\n\t\t<fieldset pc-switch-when="ACCOUNT_SECURITY_TYPES.recoveryEmail">\n\n\t\t\t<!-- New recovery email address -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="newRecoveryEmail">\n\t\t\t\t\t\tNew recovery email address:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input compared-to="vm.securityItems.recoveryEmail" compared-to-mode="COMPARED_TO_MODES.checkNotEqual" disable-autocomplete="true" id="newRecoveryEmail" name="newRecoveryEmail" ng-model="vm.securityItems.newRecoveryEmail" required type="email">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.newRecoveryEmail.$invalid && updateSecurityItemForm.newRecoveryEmail.$touched" ng-messages="updateSecurityItemForm.newRecoveryEmail.$error">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease enter your new recovery email address\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="email">\n\t\t\t\t\t\tPlease enter a valid email address\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="comparison">\n\t\t\t\t\t\tThis must be different to your existing recovery email address\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Confirm recovery email address -->\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="form-field_label required" for="confirmNewRecoveryEmail">\n\t\t\t\t\t\tConfirm recovery email address:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input compared-to="vm.securityItems.newRecoveryEmail" id="confirmNewRecoveryEmail" name="confirmNewRecoveryEmail" ng-model="vm.securityItems.confirmNewRecoveryEmail" type="text">\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-errors fadeIn" ng-if="updateSecurityItemForm.confirmNewRecoveryEmail.$invalid && updateSecurityItemForm.confirmNewRecoveryEmail.$touched" ng-messages="updateSecurityItemForm.confirmNewRecoveryEmail.$error">\n\t\t\t\t\t<p ng-message="required">\n\t\t\t\t\t\tPlease confirm your new recovery email address\n\t\t\t\t\t</p>\n\t\t\t\t\t<p ng-message="comparison">\n\t\t\t\t\t\tPlease make sure your recovery email addresses match\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t</div>\n\n\t<div class="form-footer-block">\n\t\t<div class="form-footer-block-heading">\n\t\t\tCan\'t remember your current password?\n\t\t</div>\n\t\t<div class="form-footer-block-text">\n\t\t\tClick \u2018Cancel\u2019, sign out of your Payroll Portal, then click the forgotten password\n\t\t\tlink on the sign in page to reset your password.\n\t\t</div>\n\t</div>\n\n\t<div class="form-actions">\n\t\t<!-- Actions -->\n\t\t<fieldset class="form-style-b_actions has-space-between no-separator">\n\t\t\t<button class="button is-greyscale" ng-click="formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<submit-button disable-button="updateSecurityItemForm.$invalid" display-text="vm.saveButtonText" state="updateSecurityItemForm.state"></submit-button>\n\t\t</fieldset>\n\t</div>\n</form>\n\n<!-- Email exists -->\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="{{vm.successTitle}}" ng-if="formState === FORM_STATES.success">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\t{{vm.successMessage}}\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="formState === FORM_STATES.error"></error-block>\n');
$templateCache.put('modules/security/forms/link-accounts/link-accounts.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="linkAccountsForm" ng-submit="$ctrl.onSubmit(linkAccountsForm)">\n\t<!-- Step 1 Username -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.usernameView">\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">Enter the username for the account you\'d like to link.</p>\n\t\t\t</div>\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="linkedAccountUsername">\n\t\t\t\t\t\tUsername:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<input data-cy="account-security-link-account-linked-account-username" disable-autocomplete id="linkedAccountUsername" name="linkedAccountUsername" ng-change="$ctrl.onUsernameChange(linkAccountsForm.linkedAccountUsername)" ng-model="$ctrl.linkedAccountUsername" required type="text" username-check-type="$ctrl.USERNAME_CHECK_TYPES.failOnUsernameNotExists">\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="linkAccountsForm.linkedAccountUsername.$touched" ng-messages="linkAccountsForm.linkedAccountUsername.$error" role="alert">\n\t\t\t\t\t<p ng-message="required"> Please enter the username for this account</p>\n\t\t\t\t\t<p ng-message="sameAsExisting">This is your existing account</p>\n\t\t\t\t\t<p ng-message="alreadyLinked">This account has already been linked</p>\n\t\t\t\t\t<p ng-message="usernameCheck">Username not found</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\t\t<!-- Step1 Action buttons -->\n\t\t<fieldset class="form-actions">\n\t\t\t<!-- Actions -->\n\t\t\t<button class="secondary-action" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\tCancel\n\t\t\t</button>\n\t\t\t<button class="primary-action is-tertiary" ng-click="$ctrl.usernameViewSubmit()" ng-disabled="linkAccountsForm.$invalid" state="linkAccountsForm.state">\n\t\t\t\tContinue\n\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Step 2 Password -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.passwordView">\n\t\t<fieldset>\n\t\t\t<div class="form-intro">\n\t\t\t\t<p class="is-small">Enter the password for the account you\'d like to link.</p>\n\t\t\t</div>\n\n\t\t\t<div class="form-field">\n\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t<label class="required" for="linkedAccountPassword">\n\t\t\t\t\t\tPassword:\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t<password-input allow-show-password="true" disable-autocomplete="true" id="linkedAccountPassword" name="linkedAccountPassword" ng-change="$ctrl.onPasswordChange(linkAccountsForm)" ng-disabled="$ctrl.isDisabled" ng-model="$ctrl.linkedAccountPassword" ng-required="true">\n\t\t\t\t\t</password-input>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-errors fadeIn" ng-if="linkAccountsForm.linkedAccountPassword.$touched" ng-messages="linkAccountsForm.linkedAccountPassword.$error" role="alert">\n\t\t\t\t\t<p ng-message="required">Please enter the password for this account</p>\n\t\t\t\t\t<p ng-message="passwordInvalid">Password doesn\'t match username</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fieldset>\n\n\t\t<!-- Step 2 Action buttons -->\n\t\t<fieldset class="form-actions">\n\t\t\t<!-- Actions -->\n\t\t\t\t<button class="button is-greyscale" ng-click="$ctrl.formOptions.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t\t<button class="primary-action is-tertiary" ng-disabled="linkAccountsForm.$invalid || $ctrl.isDisabled" state="linkAccountsForm.state" type="submit">\n\t\t\t\t<i class="button_icon-pre" ng-class="$ctrl.isDisabled ? \'icon-loading spin\' : \'\'"></i> Link account\n\t\t\t\t</button>\n\t\t</fieldset>\n\t</div>\n\n\t<!-- Form State Account already linked -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.cantBeLinkedView">\n\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="There seems to be a problem with your submission">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThe account you\'re trying to link to is already associated with a different Access Identity account.\n\t\t\t\t\t\tThe association can be removed by clicking the \'Unlink Access Account\' action on your Admins page.\n\t\t\t\t\t\tIf you don\'t have permission to do this, please contact your system admin. Once that\'s done you can\n\t\t\t\t\t\treturn here and retry linking the account.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Form State Both accounts are not identity migrated -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.accountsNoneIdentity">\n\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="This account can\'t be linked">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tNeither the account you\'re currently logged into nor the account you\'re trying to link to have migrated\n\t\t\t\t\t\tto Access Identity yet. In order to use account linking you need to go through the Identity migration\n\t\t\t\t\t\tprocess for one of your accounts. Once you\'re logged back into that migrated account you can return here\n\t\t\t\t\t\tand retry linking to the other account.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t<!-- Form State Account not part of a company identity enabled -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.accountsAdminNoneIdentity">\n\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="This account can\'t be linked">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tThe Admin account you are attempting to link is not Access Identity enabled. To proceed with linking, the company or bureau must have Access Identity enabled. Once this is completed, you may return and attempt the linking process again.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n\n\t\t<!-- Form State Not same user -->\n\t\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.notSameUser">\n\t\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="warning" fs-show-close="true" fs-theme="tertiary" fs-title="This account can\'t be linked">\n\t\t\t\t<fs-main>\n\t\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\tThe account you entered is associated with a different user and cannot be linked. Please ensure you are linking accounts that belong to the same user.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</fs-main>\n\t\t\t</form-state>\n\t\t</div>\n\n\t<!-- Form State Success -->\n\t<div ng-if="$ctrl.formState === $ctrl.FORM_STATES.success">\n\t\t<form-state class="fadeIn" form-options="$ctrl.formOptions" fs-icon="tick" fs-show-close="true" fs-theme="primary" fs-title="Account linked successfully">\n\t\t\t<fs-main>\n\t\t\t\t<div class="form-state-section">\n\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\tYour account has been successfully linked and confirmation has been sent to your inbox.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</fs-main>\n\t\t</form-state>\n\t</div>\n</form>\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error"></error-block>');
$templateCache.put('modules/security/forms/password-reset/password-reset.form.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="passwordResetForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="sendPasswordReset(vm, passwordResetForm)" novalidate>\n\n\t<form-state fs-show-close="false" fs-title="Are you sure you wish to send a reset link?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThe email will be sent to {{vm.teamMember.Personal.EmailRecovery}}.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<a class="button secondary-action" href="" ng-click="formOptions.closeForm()">\n\t\t\tCancel\n\t\t</a>\n\t\t<submit-button disable-button="!passwordResetForm.$valid" display-text="\'Send\'" state="passwordResetForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Reset link sent" ng-if="pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tA password reset link has been sent to {{vm.teamMember.Personal.EmailRecovery}}.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- No recovery email -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="is-tertiary" fs-title="No recovery email address saved" ng-if="pageState === PAGE_STATES.noRecoveryEmail">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tTeam members must have a recovery email address in order to send a password reset link.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('modules/security/forms/unlink-accounts/unlink-accounts.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="unlinkAccountForm" ng-submit="$ctrl.unlinkAccount()">\n\t<!-- Step 1 Confirmation -->\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to unlink your account?" ng-if="$ctrl.formState === \'unlinkView\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tOnce you click \u2018Confirm\u2019 you\u2019ll no longer be able to access your account without logging in to it separately.\n\t\t\t\t</p>\n\t\t\t\t<br>\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="account-card">\n\t\t\t\t\t\t\t<div class="account-card_main">\n\t\t\t\t\t\t\t\t<div class="account-card_info">\n\t\t\t\t\t\t\t\t\t<p class="is-strong">\n\t\t\t\t\t\t\t\t\t\t{{ $ctrl.formOptions.linkedAccount.Username}}\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="is-small no-margin">\n\t\t\t\t\t\t\t\t\t\t{{ $ctrl.formOptions.linkedAccount.AccountEmailAddress}}\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<span class="tag l quarternary">{{$ctrl.formOptions.linkedAccount.AccountDetails.RoleType | roleTypeMeta:\'name\'}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</fs-main>\n\t\t\t<fs-actions>\n\t\t\t\t<button class="button secondary-action" href="" ng-click="$ctrl.closeForm()" type="button">\n\t\t\t\t\tCancel\n\t\t\t\t</button>\n\t\t\t\t<button class="primary-action is-tertiary" type="submit">\n\t\t\t\t\tConfirm\n\t\t\t\t</button>\n\t\t\t</fs-actions>\n\t\t</form-state>\n\n\t\t<!-- Step 2 Success -->\n\t\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Account unlinked successfully" fs-show-close="true" ng-if="$ctrl.formState === \'success\'">\n\t\t\t<fs-main>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour accounts have been unlinked and confirmation has been sent to your recovery email address.\n\t\t\t\t</p>\n\t\t\t</fs-main>\n\t\t</form-state>\n\n</form>\n\n<error-block ng-if="$ctrl.formState === $ctrl.FORM_STATES.error"></error-block>');
$templateCache.put('modules/security/forms/username-retrieval/username-retrieval.form.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<form class="fadeIn" name="usernameRetrievalForm" ng-if="pageState === PAGE_STATES.ready" ng-submit="sendUsernameRetrievalRequest(vm, usernameRetrievalForm)" novalidate>\n\n\t<form-state fs-show-close="false" fs-title="Are you sure you wish to send a retrieval link?">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tThe email will be sent to {{vm.teamMember.Personal.EmailRecovery}}.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n\t<fieldset class="form-actions">\n\t\t<button class="secondary-action" ng-click="formOptions.closeForm()" type="button">\n\t\t\tCancel\n\t\t</button>\n\t\t<submit-button disable-button="!usernameRetrievalForm.$valid" display-text="\'Send\'" state="usernameRetrievalForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<form-state form-options="formOptions" fs-icon="tick" fs-theme="positive" fs-title="Retrieval link sent" ng-if="pageState === PAGE_STATES.success">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tA username retrieval link has been sent to {{vm.teamMember.Personal.EmailRecovery}}.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<!-- No recovery email -->\n<form-state form-options="formOptions" fs-icon="warning" fs-theme="is-tertiary" fs-title="No recovery email address saved" ng-if="pageState === PAGE_STATES.noRecoveryEmail">\n\t<fs-main>\n\t\t<p class="is-small">\n\t\t\tTeam members must have a recovery email address in order to send a username retrieval link.\n\t\t</p>\n\t</fs-main>\n</form-state>\n\n<error-block ng-if="pageState === PAGE_STATES.error" secondary-action-text="Ok, close this window" secondary-action="formOptions.closeForm()"></error-block>\n');
$templateCache.put('features/app/data-importer/validation-results/validation-results-file-data/validation-results-file-data.component.html','<!-- Has results -->\n<div class="data-importer_section fadeIn" ng-show="$ctrl.fileData.filteredRows.length > 0">\n\n\t<div class="import-data-mapping-tables">\n\n\t\t<div class="import-data-mapping_header">\n\n\t\t\t<div class="import-data-mapping_header-details">\n\n\t\t\t\t\n\t\t\t\t<div class="import-data-mapping_header-item">\n\t\t\t\t\t<div class="import-data-mapping_header-checkbox">\n\t\t\t\t\t\t<input checkbox class="xs" data-cy="validation-results-recurring-payelements-ignore-all-rows-checkbox" id="isIgnoreAllRowsEnabled" label-text-class="is-small" label-text="\'Ignore all rows\'" name="isIgnoreAllRowsEnabled" ng-change="$ctrl.onToggleIgnoreAllRows({filteredRows: $ctrl.fileData.filteredRows, isIgnoreAllRowsEnabled: $ctrl.isIgnoreAllRowsEnabled})" ng-model="$ctrl.isIgnoreAllRowsEnabled" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="import-data-mapping_header-item" ng-if="$ctrl.activeValidationResultFilter.filterKey === $ctrl.VALIDATION_TYPE_LEVELS.warning">\n\t\t\t\t\t<p class="s">Click on the warning link for more information</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="table-shadow has-scrollbar">\n\t\t\t<div class="table-wrapper has-scrollbar">\n\t\t\t\t<table class="c import-data-mapping-table">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th class="column-header align-center" ng-if="$ctrl.activeValidationResultFilter.canIgnore">\n\t\t\t\t\t\t\t\tIgnore\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th class="column-header" ng-if="$ctrl.activeValidationResultFilter.hasActions">\n\t\t\t\t\t\t\t\tWarning\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th class="column-header" ng-if="$ctrl.activeValidationResultFilter.isTeamMemberMatched">\n\t\t\t\t\t\t\t\tTeam member\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th class="column-header" ng-repeat="column in $ctrl.fileData.Columns | filter:$ctrl.showHiddenColumnsFilter">\n\t\t\t\t\t\t\t\t{{::column.ImportMappingColumnText}}\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr dir-paginate="(rowIndex, row) in $ctrl.fileData.filteredRows = (\n\t\t\t\t\t\t\t\t$ctrl.fileData.Rows |\n\t\t\t\t\t\t\t\tfilter: $ctrl.activeValidationResultFilter.filter |\n\t\t\t\t\t\t\t\titemsPerPage : 10\n\t\t\t\t\t\t\t)" ng-class="{\n\t\t\t\t\t\t\t\t\'disabled\': row.Ignore\n\t\t\t\t\t\t\t}">\n\n\t\t\t\t\t\t\t<td class="align-center" ng-if="$ctrl.activeValidationResultFilter.canIgnore">\n\t\t\t\t\t\t\t\t<input class="pc-checkbox import-data-mapping-checkbox" data-cy="validation-results-recurring-payelements-ignore-row-checkbox" id="row-{{rowIndex}}" ng-change="$ctrl.onToggleIgnoreRow()" ng-model="row.Ignore" type="checkbox">\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<td ng-if="$ctrl.activeValidationResultFilter.hasActions">\n\t\t\t\t\t\t\t\t<div ng-repeat="\n\t\t\t\t\t\t\t\t\t\tvalidationResult in row.validationResults |\n\t\t\t\t\t\t\t\t\t\tfilter: $ctrl.validationActionsFilter\n\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t<span ng-if="!validationResult.isUpdated">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-warning m {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t<a class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'assertive\'}}" data-cy="validation-results-recurring-payelements-warning-link" href="" ng-click="$ctrl.onValidationAction(row, validationResult)" ng-if="!validationResult.isUpdated">\n\t\t\t\t\t\t\t\t\t\t\t{{validationResult.ValidationType.ValidationTypeText}}\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span ng-if="validationResult.isUpdated">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-check m {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}"></i>&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t<a class="underline {{row.Ignore ? \'is-greyscale is-disabled\' : \'positive\'}}" data-cy="validation-results-recurring-payelements-updated-link" href="" ng-click="$ctrl.onValidationAction(row, validationResult)">{{validationResult.ValidationType.ValidationTypeText}}</a>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<td ng-if="$ctrl.activeValidationResultFilter.isTeamMemberMatched">\n\t\t\t\t\t\t\t\t{{row.teamMember.name}}\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<td ng-class="{\'greyscale\': cell.isIgnored}" ng-if="$ctrl.hiddenColumnsArray.indexOf(cellIndex) === -1 || $ctrl.showHiddenColumns" ng-repeat="(cellIndex, cell) in row.cells">\n\t\t\t\t\t\t\t\t{{cell.value}}\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7">\n\t\t</dir-pagination-controls>\n\t</div>\n</div>\n');
$templateCache.put('features/app/data-importer/validation-results/validation-results-title/validation-results-title.component.html','<div class="data-importer_title">\n\t<div class="data-importer_title-bar">\n\t\t<h4>{{$ctrl.validationResultsTitle}}</h4>\n\t\t<p class="s">{{$ctrl.validationResultsMessage}}</p>\n\t</div>\n</div>');
$templateCache.put('features/app/data-importer/validation-results/validation-results-filter/validation-results-filter.component.html','<div class="data-importer_section">\n\t<nav class="tabs primary has-border-bottom">\n\t\t<a class="tabs-item has-counter-before" data-cy="validation-results-recurring-payelements-tab-{{validationResultFilter.filterKey}}" href="" ng-class="{\n\t\t\t\t\'active\': validationResultFilter.filterKey === $ctrl.activeValidationResultFilter.filterKey\n\t\t\t}" ng-click="$ctrl.onUpdateFilter({validationResultFilter: validationResultFilter})" ng-if="::validationResultFilter.total > 0 || (validationResultFilter.total === 0 && !validationResultFilter.isHiddenWhenEmpty)" ng-repeat="validationResultFilter in $ctrl.validationResultFilters">\n\t\t\t<span class="tag {{validationResultFilter.filterKey === $ctrl.activeValidationResultFilter.filterKey ? validationResultFilter.themeActive : validationResultFilter.theme}} tabs-item-counter-before {{validationResultFilter.filterKey === $ctrl.activeValidationResultFilter.filterKey ? \'inverse\' : \'\'}}" title="{{::validationResultFilter.total}}">{{::validationResultFilter.total}}</span>\n\t\t\t{{::validationResultFilter.title}}\n\t\t</a>\n\t</nav>\n</div>\n');
$templateCache.put('features/app/hr/policies/tabs/policiesHolidayView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="page-template-a-section" ng-if="pageState === \'ready\'">\n\n\t<div class="detail-blocks">\n\t\t<!-- Holiday policies  -->\n\t\t<detail-block db-details="vm.holidayDetailsBlock" db-can-edit="currentUser.Permissions.HR.canManagePolicies"></detail-block>\n\t</div>\n</section>\n\n<!-- \'No holiday policy\' placeholder -->\n<placeholder ng-if="pageState === \'holiday-policy-not-setup\'" placeholder-graphic-size="l" placeholder-graphic="no-pay-policies">\n\t<placeholder-title>{{::$root.currentUser.Permissions.HR.canManagePolicies ? \'Add a holiday policy\' : \'There is no holiday policy to display\'}}</placeholder-title>\n\t<placeholder-copy>\n\t\t<p>A holiday policy can be used to start tracking your team members\' holiday leave.</p>\n\t</placeholder-copy>\n\t<placeholder-primary-actions ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t<button class="is-primary" data-cy="add-holiday-policy" ng-click="openHolidayForm()">\n\t\t\t<i class="icon-plus"></i>&nbsp;Add policy\n\t\t</button>\n\t</placeholder-primary-actions>\n</placeholder>\n');
$templateCache.put('features/app/hr/policies/tabs/policiesTabView.html','<loading-block ng-if="pageState === PAGE_STATES.loading"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\t<!-- Filter bar (where applicable)-->\n\t<filter-bar filter-bar-options="vm.filterBarOptions" ng-if="vm.policyCategory === POLICY_CATEGORIES.pay && vm.policies.all.length !== 0"></filter-bar>\n\n\t<!-- Search bar -->\n    <search-bar action-selected="searchBarActionSelected" count="vm.policies.filtered.length" ng-if="vm.policies.all.length !== 0" options="vm.searchBarOptions">\n\t\t<sb-right-actions ng-if="$root.currentUser.Permissions.HR.canManagePolicies && vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t<button class="is-primary" ng-click="addPolicy(vm, UPDATE_POLICY_MODES.import)" type="button">\n                <i class="icon-plus button_icon-pre"></i>Import\n            </button>\n\t\t</sb-right-actions>\n\t</search-bar>\n\n\t<!-- Policy cards -->\n\t<div class="policy-cards" ng-if="vm.policies.all.length !== 0">\n\t\t<policy-card agency-profile-id="agencyProfileId" ng-repeat="policy in vm.policies.filtered = ( vm.policies.all | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) |\n                       orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse" on-update="refresh()" policy="policy" policies="vm.policies.all"></policy-card>\n\t</div>\n\n\t<!-- \'No policies\' placeholder -->\n    <placeholder ng-if="vm.policies.all.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-pay-policies">\n        <placeholder-title>{{::$root.currentUser.Permissions.HR.canManagePolicies ? \'Start adding \' + vm.policyCategory + \' policies\' : \'There are no \' + vm.policyCategory + \' policies to display\'}}</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p ng-if="vm.policyCategory === POLICY_CATEGORIES.pay">\n\t\t\t\tA pay policy can be used to assign pay points to team members, and set up their pay information.\n\t\t\t</p>\n\t\t\t<p ng-if="vm.policyCategory === POLICY_CATEGORIES.pension">\n\t\t\t\tPension policies can be used to calculate contributions for team members based on attributes such as job grade, length of service and department.\n\t\t\t</p>\n\t\t\t<p ng-if="vm.policyCategory === POLICY_CATEGORIES.parental">\n\t\t\t\tParental policies can be used to calculate maternity or paternity pay that supplements statutory payments for team members.\n\t\t\t</p>\n\t\t\t<p ng-if="vm.policyCategory === POLICY_CATEGORIES.sickness">\n\t\t\t\tSickness policies can be used to calculate sick pay that supplements statutory payments for team members.\n\t\t\t</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions ng-if="::$root.currentUser.Permissions.HR.canManagePolicies">\n\t\t\t<button class="is-primary" data-cy="import-{{vm.policyCategory}}-policy" ng-click="addPolicy(vm, UPDATE_POLICY_MODES.import)" ng-if="vm.policyCategory === POLICY_CATEGORIES.pay" type="button">\n                <i class="icon-plus button_icon-pre"></i>Import\n            </button>\n\t\t\t<button class="is-primary" data-cy="add-{{vm.policyCategory}}-policy" ng-click="addPolicy(vm)">\n                <i class="icon-plus"></i>&nbsp;Add policy\n            </button>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === PAGE_STATES.error"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/alerts/payroll-current-period-alerts.view.html','<loading-block ng-if="vm.alertsLoadingState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="vm.alertsLoadingState === \'ready\'">\n\n\t<!-- Has alerts -->\n\t<div ng-if="vm.payrollAlerts.alertsCount">\n\n\t\t<filter-bar filter-bar-options="vm.filterBarOptions" apply-filter-keys="applyFilter" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<search-bar options="vm.searchBarOptions" count="vm.payrollAlerts.alertsCount">\n\t\t\t<sb-actions>\n\t\t\t\t<div ng-switch="vm.alertDownloadState">\n\t\t\t\t\t<a href="" class="link-with-icon" ng-click="createAlertReportDownload(vm)" ng-switch-default><i class="icon-download"></i> Alerts report</a>\n\n\t\t\t\t\t<span ng-switch-when="loading">\n\t\t\t\t\t\t<circle-loader></circle-loader>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</sb-actions>\n\t\t</search-bar>\n\n\t\t<payroll-alerts-level agency-pay-period-id="vm.payPeriod.PayPeriodID" agency-profile-id="agencyProfileId" level="level" ng-repeat="level in vm.payrollAlerts.filteredLevels = (\n\t\t\t\tvm.payrollAlerts.levels |\n\t\t\t\tfilter : vm.searchBarOptions.search.string |\n\t\t\t\tfilter : vm.filterBarOptions.appliedFilter\n\t\t\t)" reload-alerts="reloadAlerts(vm)" search-bar-options="vm.searchBarOptions"></payroll-alerts-level>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.payrollAlerts.filteredLevels.length === 0"></empty-search>\n\t</div>\n\n\t<!-- No alerts -->\n\t<placeholder placeholder-graphic="alerts" placeholder-graphic-size="l" ng-if="!vm.payrollAlerts.alertsCount">\n\t\t<placeholder-title>No alerts for this pay period</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Everything\u2019s looking good to go as soon as you\u2019re happy to run payroll</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</section>\n\n<error-block has-gutter="true" ng-if="vm.alertsLoadingState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/changes/payroll-current-period-changes.view.html','<loading-block ng-if="vm.changesLoadingState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="vm.changesLoadingState === \'ready\'">\n\n\t<!-- Has team members -->\n\t<div ng-if="vm.teamMemberChanges.length">\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar action-selected="openRefreshSelectedChangesForm" count="vm.teamMemberChanges.length" options="vm.searchBarOptions"></search-bar>\n\n\t\t<!-- Adjustments List -->\n\t\t<div class="team-card-changes fadeIn" current-page="vm.searchBarOptions.currentPageNumber" data-cy="payroll-current-period-changes-team-card-{{teamMember.UserID | slugify}}" dir-paginate="teamMember in vm.filteredTeamMemberChanges = (\n\t\t\t\t\tvm.teamMemberChanges |\n\t\t\t\t\tfilter : vm.searchBarOptions.search.searchFilter : vm.searchBarOptions.search.isExactMatch\n\t\t\t\t) |\n\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t">\n\n\t\t\t<div class="team-card-changes_person">\n\t\t\t\t<avatar avatar-initial="{{teamMember.UserForename[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.UserID}}" class="team-card-changes_avatar"></avatar>\n\t\t\t\t<a class="team-card-changes_name" ui-sref="team.profile.overview({\n\t\t\t\t\t\tagencyProfileId: currentCompany.AgencyProfileID,\n\t\t\t\t\t\tuserId: teamMember.UserID\n\t\t\t\t\t})">{{::teamMember.UserForename}} {{::teamMember.UserSurname}}</a>\n\t\t\t</div>\n\n\t \t\t<!-- Team Member Adjustments -->\n\t\t\t<adjustments-list adjustment-detail-summary="teamMember" agency-profile-id="{{currentCompany.AgencyProfileID}}" callback="updateUserByUserId" can-update="$root.currentUser.Permissions.Payroll.canUpdateAdjustments && vm.payPeriod.ApprovalDateISO === \'\'" class="team-card-changes_changes" pay-period="vm.payPeriod" show-adjustments-count="false" theme="is-block" user-id="{{teamMember.UserID}}"></adjustments-list>\n\n\t\t\t<!-- Actions -->\n\t\t\t<dropdown-menu class="team-card-changes_actions" id="team-card-changes_actions" menu-icon="icon-setup" menu-show="menuShow" menu-size="l">\n\t\t\t\t<div class="dropdown-group" ng-if="::$root.currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t\t\t<a href="" id="team-card-payroll-{{index}}-action-add-change" ng-click="openAddAChangeForm(vm.payPeriod, teamMember.UserID)">Add a change</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t<a ui-sref="team.profile.overview({\n\t\t\t\t\t\t\tagencyProfileId: currentCompany.AgencyProfileID,\n\t\t\t\t\t\t\tuserId:teamMember.UserID\n\t\t\t\t\t\t})">View profile</a>\n\t\t\t\t</div>\n\t\t\t</dropdown-menu>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-if="vm.filteredTeamMemberChanges.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder ng-if="!vm.teamMemberChanges.length" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t<placeholder-title>No changes have been made yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you start adding changes they will start to appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions ng-if="::currentUser.Permissions.Payroll.canUpdateAdjustments">\n\t\t\t<a class="button is-primary" href="" ng-click="openAddAChangeForm(vm.payPeriod)">\n\t\t\t\t<i class="icon-plus"></i>\n\t\t\t\t<span>Add a change</span>\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n</section>\n\n<error-block has-gutter="true" ng-if="vm.changesLoadingState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/imports/payroll-current-period-imports.view.html','<loading-block ng-if="subPageState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="subPageState === \'ready\'">\n\n\t<!-- Has imports -->\n\t<div ng-if="vm.importHistoryItems.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="vm.filterBarOptions" apply-filter-keys="applyFilter" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar options="vm.searchBarOptions" count="vm.importHistoryItemsFiltered.length"></search-bar>\n\n\t\t<!-- Import Cards -->\n\t\t<div class="import-history-item_wrapper">\n\t\t\t<import-history-item agency-profile-id="agencyProfileId" import="import" on-update="refreshPayroll()" pay-period="vm.payPeriod" dir-paginate="import in vm.importHistoryItemsFiltered = ( vm.importHistoryItems | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse | itemsPerPage : vm.searchBarOptions.results.itemsPerPage" current-page="vm.searchBarOptions.currentPageNumber"></import-history-item>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.importHistoryItemsFiltered.length === 0"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No Imports -->\n\t<placeholder placeholder-graphic="import" placeholder-graphic-size="l" ng-if="!vm.importHistoryItems.length">\n\t\t<placeholder-title>Add the first import</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Upload your files and import payroll changes, leavers and salary changes.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a class="button primary" ui-sref="data-importer.my-files({\n\t\t\t\t\tagencyProfileId: agencyProfileId,\n\t\t\t\t\tagencyDocumentType: DOCUMENT_TYPES.periodImport\n\t\t\t\t})">\n\t\t\t\t<i class="icon-plus"></i>&nbsp;&nbsp;Import\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</section>\n\n<error-block ng-if="subPageState === \'error\'"></error-block>\n\n');
$templateCache.put('features/app/payroll/current-period/notes/payroll-current-period-notes.view.html','<loading-block ng-if="vm.notesLoadingState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="vm.notesLoadingState === \'ready\'">\n\n\t<div ng-if="vm.notes.length">\n\n\t\t<filter-bar filter-bar-options="vm.notesFilterBarOptions" apply-filter-keys="applyFilter" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<search-bar options="vm.notesSearchBarOptions" count="vm.filteredNotes.length"></search-bar>\n\n\t\t<div class="pay-period-note_wrapper rows">\n\t\t\t<pay-period-note note="note" refresh-notes="vm.refreshNotes()" refresh-tasks="vm.refreshTasks()" agency-pay-period-id="vm.payPeriod.PayPeriodID" agency-profile-id="vm.agencyProfileId" dir-paginate="note in vm.filteredNotes = ( vm.notes | filter : vm.notesSearchBarOptions.search.string  | filter : vm.notesFilterBarOptions.appliedFilter ) | orderBy : vm.notesSearchBarOptions.orderBy : vm.notesSearchBarOptions.results.reverse | itemsPerPage : vm.notesSearchBarOptions.results.itemsPerPage" current-page="vm.notesSearchBarOptions.currentPageNumber"></pay-period-note>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="vm.notesSearchBarOptions" ng-show="vm.filteredNotes.length === 0"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="vm.notesSearchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t</div>\n\n\t<placeholder placeholder-graphic="notes" placeholder-graphic-size="l" ng-if="!vm.notes.length">\n\t\t<placeholder-title>Add the first note</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Add notes and attach files to start collecting data for {{vm.payPeriod.PayPeriodDisplay}}</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a class="button primary" data-cy="payroll-current-period-add-note-button" href="" id="add-note-button" ng-click="vm.openAddPeriodNoteForm()">\n\t\t\t\t<i class="icon-plus"></i>&nbsp;&nbsp;Add note\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n</section>\n\n<error-block has-gutter="true" ng-if="vm.notesLoadingState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/tasks/payroll-current-period-tasks.view.html','<loading-block ng-if="vm.tasksLoadingState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="vm.tasksLoadingState === \'ready\'">\n\n\t<div ng-if="vm.tasks.all.length">\n\n\t\t<filter-bar filter-bar-options="vm.filterBarOptions" apply-filter-keys="applyFilter" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<search-bar options="vm.searchBarOptions" count="vm.tasks.filtered.length">\n\t\t\t<sb-actions>\n\t\t\t\t<div>\n\t\t\t\t\t<toggle-input field-label="Show complete" field-model="vm.showComplete" field-name="showComplete"></toggle-input>\n\t\t\t\t</div>\n\t\t\t</sb-actions>\n\t\t</search-bar>\n\n\t\t<div class="period-task-card_wrapper">\n\t\t\t<period-task-card task="task" agency-pay-period-id="vm.payPeriod.PayPeriodID" refresh-tasks="vm.refreshTasks()" update-tasks-count="vm.updateTasksCount()" ng-repeat="task in vm.tasks.filtered = ( vm.tasks.all | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter | tasksOrder: vm.showComplete)"></period-task-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.tasks.filtered.length === 0 && vm.searchBarOptions.search.string !== \'\'"></empty-search>\n\n\t\t<!-- All tasks completed -->\n\t\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="!vm.showComplete && vm.tasks.filtered.length === 0">\n\t\t\t<placeholder-title>All tasks have been completed</placeholder-title>\n\t\t</placeholder>\n\t</div>\n\n\t<placeholder placeholder-graphic="tasks" placeholder-graphic-size="l" ng-if="!vm.tasks.all.length">\n\t\t<placeholder-title>Add the first task</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Start adding tasks, assigning them to people and setting due dates</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a class="button primary" data-cy="payroll-current-period-add-task-button" href="" id="add-task-button" ng-click="vm.openAddPeriodTaskForm()">\n\t\t\t\t<i class="icon-plus"></i>&nbsp;&nbsp;Add task\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n</section>\n\n<error-block has-gutter="true" ng-if="vm.tasksLoadingState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/tax-updates/payroll-current-period-tax-updates.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section ng-if="pageState === \'ready\'" ng-switch="vm.taxUpdatesState">\n\t<!-- Checking -->\n\t<div ng-switch-when="checking">\n\t\t<loading-block size="l">\n\t\t\t<lb-description>Checking for tax updates...</lb-description>\n\t\t</loading-block>\n\t</div>\n\n\t<!-- Ready -->\n\t<div ng-switch-default>\n\n\t\t<div ng-if="vm.taxUpdates.length">\n\n\t\t\t<!-- Search Bar -->\n\t\t\t<search-bar count="vm.filteredTaxUpdates.length" options="vm.searchBarOptions"></search-bar>\n\n\t\t\t<!-- Tax Updates -->\n\t\t\t<section class="tax-info-update-cards {{vm.searchBarOptions.layout}}">\n\n\t\t\t\t<tax-info-update-card class="slideIn" dir-paginate="taxUpdate in vm.filteredTaxUpdates = (\n\t\t\t\t\t\tvm.taxUpdates |\n\t\t\t\t\t\tfilter : vm.filterBarOptions.appliedFilter |\n\t\t\t\t\t\tfilter : vm.searchBarOptions.search.searchFilter |\n\t\t\t\t\t\torderBy : taxUpdate.TaxInfoDateEffective : vm.searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t\t\t)" index="$index" refresh-tax-updates="refreshTaxUpdates()" tax-update="taxUpdate"></tax-info-update-card>\n\t\t\t</section>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="vm.filteredTaxUpdates.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t\t</div>\n\n\t\t<!-- No tax updates -->\n\t\t<placeholder ng-if="!vm.taxUpdates.length" placeholder-graphic-size="l" placeholder-graphic="tax-updates">\n\t\t\t<placeholder-title>No tax updates for this pay period</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>To get the latest tax updates from HMRC, click \'Get tax updates\' above</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- Failed -->\n\t<div ng-switch-when="failed">\n\t\t<info-block ib-theme="tertiary has-icon has-plain-type">\n\t\t\t<ib-header>\n\t\t\t\t<div class="info-block-icon-layout">\n\t\t\t\t\t<i class="icon-warning tertiary info-block-icon"></i>\n\t\t\t\t\t<h6 class="stronger">There\u2019s a problem with tax updates</h6>\n\t\t\t\t</div>\n\t\t\t</ib-header>\n\t\t\t<ib-main>\n\t\t\t\t<p class="is-small greyscale-darkened">\n\t\t\t\t\tTax updates aren\u2019t currently being received by Paycircle so your data may not be up to date. To fix the problem,\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.taxCodeUpdates" underline="true">read our troubleshooting guide to tax updates</support-article-link>\n\t\t\t\t</p>\n\t\t\t</ib-main>\n\t\t</info-block>\n\t</div>\n</section>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/team/payroll-current-period-team.view.html','<loading-block ng-if="pageState === \'loading\' || vm.teamLoadingState === \'loading\'"></loading-block>\n\n<section ng-if="pageState === \'ready\' && vm.teamLoadingState === \'ready\'">\n\n\t<!-- Has team members -->\n\t<div ng-if="vm.teamMembers.all.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar apply-filter-keys="vm.applyFilter" filter-bar-options="vm.filterBarOptions" preset-filter-key="{{vm.presetFilterKey}}"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar bulk-items="vm.teamMembers" options="vm.searchBarOptions">\n\t\t\t<sb-bulk-actions ng-if="currentUser.Permissions.Payroll.canUpdatePayslipNotes">\n\t\t\t\t<a data-cy="payroll-current-period-edit-payslip-note-bulk" href="" ng-click="openEditPayslipNotesForm(vm.teamMembers.filtered)">\n\t\t\t\t\tEdit payslip notes\n\t\t\t\t</a>\n\t\t\t\t<a data-cy="payroll-current-period-remove-payslip-note-bulk" href="" ng-click="openRemovePayslipNotesForm(vm.teamMembers.filtered)">\n\t\t\t\t\tRemove payslip notes\n\t\t\t\t</a>\n\t\t\t</sb-bulk-actions>\n\t\t</search-bar>\n\n\t\t<!-- Team Cards -->\n\t\t<section class="team-cards-payroll {{vm.searchBarOptions.layout}}">\n\n\t\t\t<team-card-payroll agency-profile-id="{{currentCompany.AgencyProfileID}}" bulk-items="vm.teamMembers" company="currentCompany" current-page="vm.searchBarOptions.currentPageNumber" dir-paginate="teamMember in vm.teamMembers.filtered = (\n\t\t\t\t\t\tvm.teamMembers.all |\n\t\t\t\t\t\tfilterBy : vm.searchBarOptions.search.filterOption.filterKeys : vm.searchBarOptions.search.string : vm.searchBarOptions.search.isExactMatch |\n\t\t\t\t\t\tfilter : vm.filterBarOptions.appliedFilter\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t\t" index="$index" on-update="refreshTeamMemberByUserId" pay-period="vm.payPeriod" search-bar-options="vm.searchBarOptions" team-member="teamMember"></team-card-payroll>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-if="vm.teamMembers.filtered.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No team members -->\n\t<section ng-if="!vm.teamMembers.all.length">\n\n\t\t<!-- Import adjustments -->\n\t\t<action-block ng-if="currentCompany.CanImportWithNoTeamMembers">\n\t\t\t<ab-main>\n\t\t\t\t<div>\n\t\t\t\t\t<p class="action-block_label">Current period</p>\n\t\t\t\t\t<h3 class="action-block_period-display">{{vm.payPeriod.PayPeriodDisplay}}</h3>\n\t\t\t\t</div>\n\t\t\t\t<h4>Import your changes for this period</h4>\n\t\t\t\t<p>Use the Paycircle Importer to upload, verify and import your changes for this period.</p>\n\t\t\t</ab-main>\n\t\t\t<ab-actions>\n\t\t\t\t<a class="button is-large is-primary" ui-sref="data-importer.my-files({\n\t\t\t\t\t\tagencyProfileId: currentCompany.AgencyProfileID,\n\t\t\t\t\t\tagencyDocumentType: DOCUMENT_TYPES.periodImport\n\t\t\t\t\t})">Import now</a>\n\t\t\t</ab-actions>\n\t\t</action-block>\n\n\t\t<!-- No team members -->\n\t\t<placeholder ng-if="!currentCompany.CanImportWithNoTeamMembers" placeholder-graphic-size="l" placeholder-graphic="team">\n\t\t\t<placeholder-title>No team members active on payroll</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p ng-if="currentUser.Permissions.isTeamVisible">This may be because they\u2019re all on hold or have been advanced a number of future periods.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-secondary-actions>\n\t\t\t\t<a href="" id="go-to-team" ng-if="currentUser.Permissions.isTeamVisible" ui-sref="team.members({\n\t\t\t\t\t\tagencyProfileId: currentCompany.AgencyProfileID\n\t\t\t\t\t})">Go to your Team area&nbsp;&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t\t</placeholder-secondary-actions>\n\t\t\t<placeholder-primary-actions ng-if="(vm.permissions.isCalculateVisible && !vm.isWorkflowActive) || (vm.isWorkflowActive && vm.workflowTemplate.IsCalculateAvailable)">\n\t\t\t\t<a class="button is-tertiary" href="" id="run-nil-payroll" ng-click="openCalculatePayrollForm(vm)"><i class="icon-chevron-right m"></i>&nbsp;Run nil payroll</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</section>\n\n</section>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\' || vm.teamLoadingState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/current-period/pensions/payroll-current-period-pensions.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Active pension with history -->\n\t<div ng-if="vm.company.HasPension && vm.logEntries.length > 0">\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar count="vm.logEntries.length" options="vm.searchBarOptions"></search-bar>\n\n\t\t<!-- Log Cards -->\n\t\t<section class="log-cards {{vm.searchBarOptions.layout}}">\n\t\t\t<log-card class="slideIn" dir-paginate="logEntry in filteredLogs = (\n\t\t\t\t\tvm.logEntries |\n\t\t\t\t\tfilter : vm.searchBarOptions.search.string |\n\t\t\t\t\torderBy : log.logMeta.dateUnix : vm.searchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t\t)" log="logEntry" show-log-actor="true"></log-card>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="filteredLogs.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t</div>\n\n\t<!-- Active pension with no history -->\n\t<placeholder ng-if="vm.company.HasPension && vm.logEntries.length === 0" placeholder-graphic-size="l" placeholder-graphic="no-pension-history">\n\t\t<placeholder-title>No history for this period</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>A history of changes to your pension schemes or team member pension settings that occur in this period will appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\t<!-- Inactive pension -->\n\t<placeholder ng-if="!vm.company.HasPension" placeholder-graphic-size="l" placeholder-graphic="no-pension-history">\n\t\t<placeholder-title>No pensions set up</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>The Pension module for {{vm.company.Name}} is turned on but a pension hasn\u2019t been added to your Pensions area yet.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a class="primary link-with-icon" href="" ui-sref="pensions.summary({\n\t\t\t\t\tagencyProfileId: vm.company.AgencyProfileID\n\t\t\t\t})">\n\t\t\t\t<span>Go to your Pensions area</span>\n\t\t\t\t<i class="icon-chevron-right"></i>\n\t\t\t</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n</section>\n\n');
$templateCache.put('features/app/payroll/history/pay-periods/payroll-history-pay-periods.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.payPeriods.all.length">\n\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions" ng-if="!$root.userHasRole([\'groupadminlite\', \'companyadministratorlite\'])"></filter-bar>\n\n\t\t\t<!-- Search bar -->\n\t\t\t<search-bar options="searchBarOptions" bulk-items="vm.payPeriods"></search-bar>\n\n\t\t\t<!-- Pay periods -->\n\t\t\t<div class="pay-period-card_wrapper fadeIn">\n\n\t\t\t\t<pay-period-card pay-period="payPeriod" agency-profile-id="agencyProfileId" refresh-periods="init()" dir-paginate="payPeriod in vm.payPeriods.filtered =\n\t\t\t\t\t\t( vm.payPeriods.all\n\t\t\t\t\t\t\t| filter : { PayPeriodDisplay: searchBarOptions.search.string }\n\t\t\t\t\t\t\t| filter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t)\n\t\t\t\t\t\t| orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t\t| itemsPerPage : searchBarOptions.results.itemsPerPage" current-page="searchBarOptions.currentPageNumber"></pay-period-card>\n\n\t\t\t</div>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="vm.payPeriods.filtered.length === 0"></empty-search>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\t</div>\n\n\t<!-- No history -->\n\t<placeholder placeholder-graphic="no-pay-periods" ng-if="!vm.payPeriods.all.length">\n\t\t<placeholder-title>You don\'t have any history yet.</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As soon as you approve your first period, your history will be shown here. If you have P32 figures available, you may wish to add details\n\t\t\t   for earlier tax periods in the current year.\n\t\t\t</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\t<div class="align-center" ng-if="!$root.userHasRole([\'groupadminlite\', \'companyadministratorlite\'])">\n\t\t<button class="is-medium-large is-white" ng-click="openHistoricPayPeriodForm(vm.payPeriods.all)" type="button">\n\t\t\t<i class="icon-add m button_icon-pre"></i>Add historic tax period\n\t\t</button>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>');
$templateCache.put('features/app/payroll/history/supplementary-pay-runs/payroll-history-supplementary-pay-runs.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-wrapper" ng-if="vm.supplementaryPayments.length">\n\n\t\t<!-- Main -->\n\t\t<main class="page-template-a-main">\n\n\t\t\t<!-- Search / Sorting -->\n\t\t\t<search-bar options="vm.searchBarOptions" count="vm.supplementaryPaymentsFiltered.length"></search-bar>\n\n\t\t\t<!-- Data set -->\n\t\t\t<section class="supplementary-payment-cards {{vm.searchBarOptions.layout}}">\n\n\t\t\t\t<supplementary-payment-card agency-profile-id="agencyProfileId" current-page="vm.searchBarOptions.currentPageNumber" dir-paginate="supplementaryPayment in vm.supplementaryPaymentsFiltered = (\n\t\t\t\t\t\t\tvm.supplementaryPayments |\n\t\t\t\t\t\t\tfilter : vm.searchBarOptions.search.string |\n\t\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t) |\n\t\t\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t\t\t" on-delete="refresh()" on-update="refresh()" payment="supplementaryPayment"></supplementary-payment-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.supplementaryPaymentsFiltered.length === 0"></empty-search>\n\t\t\t</section>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t\t</main>\n\t</div>\n\n\t<!-- No results -->\n\t<placeholder placeholder-graphic="supplementary-payments" ng-if="!vm.supplementaryPayments.length">\n\t\t<placeholder-title>No supplementary pay runs</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>You can add supplementary pay runs for team members, from the Team area. They will appear here so you can always access your supplementary documents.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/payroll/supplementary-pay-run/changes/supplementary-pay-run-changes.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Has team members -->\n\t<div ng-if="vm.teamMemberChanges.length">\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar count="vm.teamMemberChanges.length" options="vm.searchBarOptions"></search-bar>\n\n\t\t<!-- Adjustments List -->\n\t\t<div class="team-card-changes has-no-action-menu fadeIn" current-page="vm.searchBarOptions.currentPageNumber" dir-paginate="teamMember in vm.filteredTeamMemberChanges = (\n\t\t\t\t\tvm.teamMemberChanges |\n\t\t\t\t\tfilter : vm.searchBarOptions.search.searchFilter\n\t\t\t\t) |\n\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t">\n\n\t\t\t<div class="team-card-changes_person">\n\t\t\t\t<avatar avatar-initial="{{teamMember.UserForename[0]}}" avatar-size="is-medium" avatar-user-id="{{teamMember.UserID}}" class="team-card-changes_avatar"></avatar>\n\t\t\t\t<a class="team-card-changes_name" ui-sref="team.profile.overview({\n\t\t\t\t\t\tagencyProfileId: currentCompany.AgencyProfileID,\n\t\t\t\t\t\tuserId: teamMember.UserID\n\t\t\t\t\t})">\n\t\t\t\t\t{{::teamMember.UserForename}} {{::teamMember.UserSurname}}\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t \t\t<!-- Team Member Adjustments -->\n\t\t\t<adjustments-list adjustment-detail-summary="teamMember" agency-profile-id="{{currentCompany.AgencyProfileID}}" callback="updateUserByUserId" can-delete="false" class="team-card-changes_changes" pay-period="vm.payPeriod" theme="is-block" user-id="{{teamMember.UserID}}"></adjustments-list>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-if="vm.filteredTeamMemberChanges.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="vm.searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No team members -->\n\t<placeholder ng-if="!vm.teamMemberChanges.length" placeholder-graphic-size="l" placeholder-graphic="changes">\n\t\t<placeholder-title>No changes have been made yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you start adding changes they will start to appear here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n</section>\n\n');
$templateCache.put('features/app/payroll/supplementary-pay-run/receipts/supplementary-pay-run-receipts.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Reports -->\n<section class="page-template-c-section fadeIn" ng-if="pageState === \'ready\'">\n\n\t<ul class="check-list" ng-if="vm.payPeriod.IRMarkEPS !== \'\' || vm.payPeriod.IRMarkFPS !== \'\' || vm.payPeriod.IRMarkCIS300 !== \'\'">\n\t\t<li class="check-list-item" ng-if="vm.payPeriod.IRMarkEPS !== \'\'">\n\t\t\tEPS Reference (IR Mark): <strong>{{vm.payPeriod.IRMarkEPS}}</strong>\n\t\t</li>\n\t\t<li class="check-list-item" ng-if="vm.payPeriod.IRMarkFPS !== \'\'">\n\t\t\tFPS Reference (IR Mark): <strong>{{vm.payPeriod.IRMarkFPS}}</strong>\n\t\t</li>\n\t\t<li class="check-list-item" ng-if="vm.payPeriod.IRMarkCIS300 !== \'\'">\n\t\t\tCIS 300 (IR Mark): <strong>{{vm.payPeriod.IRMarkCIS300}}</strong>\n\t\t</li>\n\t</ul>\n\n\t<p class="s" ng-if="vm.payPeriod.IRMarkEPS === \'\' && vm.payPeriod.IRMarkFPS === \'\' && vm.payPeriod.IRMarkCIS300 === \'\'">\n\t\tThere are no submission receipts to show for this period.\n\t</p>\n\n</section>\n\n');
$templateCache.put('features/app/payroll/supplementary-pay-run/reports/supplementary-pay-run-reports.view.html','<!-- Reports -->\n<section class="page-template-c-section fadeIn" ng-if="vm.permissions.isReportsVisible">\n\n\t<div class="page-template-c-section" ng-if="vm.reports.length > 0">\n\n\t\t<!-- Preview Report Warning -->\n\t\t<div class="page-template-c-section" ng-if="vm.supplementaryPayment.SupplementaryPaymentState !== SUBMISSION_STATES.submitted">\n\t\t\t<p class="is-small is-strong">\n\t\t\t\t<span class="tertiary">WARNING:</span> These are draft reports. Please do not pay your team or HMRC using the data in these reports.\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="page-template-c-section">\n\t\t\t<div class="report-download-card_wrapper">\n\t\t\t\t<report-download-card agency-profile-id="currentCompany.AgencyProfileID" can-regenerate-bacs="false" ng-repeat="report in vm.reports | orderBy: [\'-CanDownload\', \'DisplayName\'] " on-update="init()" pay-period="vm.payPeriod" report="report" supplementary-payment-id="vm.supplementaryPayment.SupplementaryPaymentID"></report-download-card>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- No Reports -->\n\t<div class="page-template-c-section" ng-if="vm.reports.length === 0">\n\t\t<placeholder placeholder-graphic="generic-files">\n\t\t\t<placeholder-title>No reports available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>No reports are available as they haven\u2019t been assigned to or added for {{currentCompany.Name}} yet.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a class="link-with-icon is-primary" href="" ng-if="$root.currentUser.Permissions.CompanySettings.canAccessReports" ui-sref="settings.company.reports.custom({\n\t\t\t\t\t\tagencyProfileId: company.AgencyProfileID\n\t\t\t\t\t})">\n\t\t\t\t\tGo to report templates<i class="icon-chevron-right is-smedium"></i>\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n</section>\n');
$templateCache.put('features/app/pensions/scheme/history/pensions-scheme-history.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Search -->\n\t<search-bar count="filteredLogs.length" options="searchBarOptions"></search-bar>\n\n\t<!-- Log Cards -->\n\t<section class="log-cards {{searchBarOptions.layout}}">\n\n\t\t<log-card class="slideIn" dir-paginate="logEntry in filteredLogs = (\n\t\t\t\tlogEntries |\n\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\tfilter : filterBarOptions.appliedFilter |\n\t\t\t\torderBy : log.logMeta.dateUnix : searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage \n\t\t\t)" log="logEntry" show-log-actor="true"></log-card>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-show="filteredLogs.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t</section>\n\n\t<!-- Pagination -->\n\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\n</div>\n\n<!-- No history -->\n<div class="fadeIn" ng-if="pageState === \'no-history\'">\n\t<placeholder placeholder-graphic="no-pension-history">\n\t\t<placeholder-title>There\u2019s no information to show yet.</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p class="is-small">As soon as you have pension history it will show here.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/scheme/communications/pensions-scheme-communications.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Has mail log summaries -->\n\t<main ng-if="mailLogSummaries.length">\n\n\t\t<!-- Disclaimer  -->\n\t\t<section class="sub-page-template-a-section {{options.showDisclaimer ? \'fadeIn\' : \'fadeOut\'}}" ng-if="options.showDisclaimer">\n\t\t\t<div class="disclaimer-block indifferent">\n\t\t\t\t<p class="s"><i class="icon-support indifferent m"></i>Please note that any pension communications sent before your pension data was first run through the Paycircle platform will not be shown here</p>\n\t\t\t\t<div class="disclaimer-block-actions">\n\t\t\t\t\t<a href="" class="s" ng-click="hideDisclaimer()">Ok, got it</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<header class="sub-page-template-a-header">\n\t\t\t<h4>Track your pension communications</h4>\n\t\t\t<p>Paycircle automatically sends all of the correct pension communications to your team at the appropriate time. For compliance, all automated communications are stored here in the Communications Centre and can be viewed anytime.</p>\n\t\t</header>\n\n\t\t<!-- Communications timeline -->\n\t\t<section class="sub-page-template-a-section">\n\t\t\t<a href="" class="link-with-icon" ng-click="toggleShowTimeline()"><i class="icon-calendar"></i><span ng-if="!options.showTimeline">View</span><span ng-if="options.showTimeline">Hide</span>&nbsp;communications timeline</a>\n\t\t\t<span class="link-with-icon float-right"><i class="icon-email is-secondary"></i>Default pension communications email: &nbsp;&nbsp;<span class="tag align-with-text" ng-class="{ \'positive\' : pension.DefaultPensionRecipientEmail !== \'\', \'assertive\' : pension.DefaultPensionRecipientEmail === \'\'}">{{pension.DefaultPensionRecipientEmail === \'\' ? \'Inactive\' : \'Active\'}}</span></span>\n\t\t\t<communications-timeline agency-profile-id="agencyProfileId" agency-employer-pension-id="agencyEmployerPensionId" company-postponed="pension.HasPostponedStaging" class="hidden-phone" ng-if="options.showTimeline"></communications-timeline>\n\t\t\t<communications-timeline-mobile agency-profile-id="agencyProfileId" agency-employer-pension-id="agencyEmployerPensionId" company-postponed="pension.HasPostponedStaging" class="visible-phone" ng-if="options.showTimeline"></communications-timeline-mobile>\n\t\t</section>\n\n\t\t<!-- Mail Logs -->\n\t\t<main class="sub-page-template-a-main">\n\n\t\t\t<!-- Filter Bar -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search -->\n\t\t\t<search-bar options="searchBarOptions" count="filteredMailLogSummaries.length"></search-bar>\n\n\t\t\t<hr>\n\n\t\t\t<!-- Team Members -->\n\t\t\t<div class="tables-wrap" ng-show="filteredMailLogSummaries.length > 0">\n\t\t\t\t<table class="primary all-left">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>Team Member</th>\n\n\t\t\t\t\t\t\t<!-- SENT -->\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'sent\'">Pension Introduction</th>\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'sent\'">Postponement Notice</th>\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'sent\'">Assessment Status</th>\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'sent\'">Pension Summary</th>\n\n\t\t\t\t\t\t\t<!-- RECEIVED -->\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'received\'">Opt in / join notice</th>\n\t\t\t\t\t\t\t<th ng-if="searchBarOptions.custom === \'received\'">Opt out notice</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr dir-paginate="mailLogSummary in filteredMailLogSummaries = ( mailLogSummaries | filter:searchBarOptions.search.string | filter:filterBarOptions.appliedFilter ) | orderBy:searchBarOptions.orderBy:searchBarOptions.results.reverse | itemsPerPage:searchBarOptions.results.itemsPerPage">\n\n\t\t\t\t\t\t\t<!-- Team Member -->\n\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t<circle-loader ng-if="mailLogSummary.isLoading"></circle-loader>\n\t\t\t\t\t\t\t\t<div ng-if="!mailLogSummary.isLoading">\n\t\t\t\t\t\t\t\t\t<p class="strong"><span class="ellipsis">{{mailLogSummary.ContactForename}} {{mailLogSummary.ContactSurname}}</span></p>\n\t\t\t\t\t\t\t\t\t<p ng-if="mailLogSummary.ContactEmail !== \'\'" title="{{mailLogSummary.ContactEmail}}"><span class="ellipsis">{{mailLogSummary.ContactEmail}}</span>&nbsp;<a data-cy="pension-communications-row-{{$index}}-edit-email" href="" ng-click="openEmailAddressForm(mailLogSummary.UserID)" ng-if="::!currentUser.IsInPlayground && currentUser.Permissions.Team.canEditPersonalDetails">edit</a></p>\n\t\t\t\t\t\t\t\t\t<p ng-if="mailLogSummary.ContactEmail === \'\'"><span class="ellipsis"><em>No email</em></span>&nbsp;<a data-cy="pension-communications-row-{{$index}}-add-email" href="" ng-click="openEmailAddressForm(mailLogSummary.UserID)" ng-if="::!currentUser.IsInPlayground && currentUser.Permissions.Team.canEditPersonalDetails">add</a></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<!-- SENT -->\n\t\t\t\t\t\t\t<!-- Pension Introduction -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'sent\'">\n\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.PensionIntroduction" no-mails-text="None sent*"></worker-mail>\n\n\t\t\t\t\t\t\t\t<!-- Team member has email -->\n\t\t\t\t\t\t\t\t<div ng-if="mailLogSummary.hasEmailAddress">\n\t\t\t\t\t\t\t\t\t<a ui-sref="email-preview({agencyProfileId: agencyProfileId, mailtypeid: MAIL_TYPES.pensionIntroduction, userid: mailLogSummary.UserID, previewType: EMAIL_PREVIEW_TYPES.standard})" ng-if="::currentUser.Permissions.Pension.canUpdateTeamPensionComms">{{mailLogSummary.PensionIntroduction.length ? \'resend\' : \'send manually\'}}</a>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- No email & no mails -->\n\t\t\t\t\t\t\t\t<div ng-if="!mailLogSummary.hasEmailAddress && !mailLogSummary.PensionIntroduction.length">\n\t\t\t\t\t\t\t\t\t<a href="" ng-click="sendAndPreviewMail(mailLogSummary, mailLogSummaries, MAIL_TYPES.pensionIntroduction)" ng-if="!mailLogSummary.isLoadingMails && currentUser.Permissions.Pension.canUpdateTeamPensionComms">create &amp; view</a>\n\t\t\t\t\t\t\t\t\t<circle-loader class="s" ng-if="mailLogSummary.isLoadingMails"></circle-loader>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<!-- Postponement Notice -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'sent\'">\n\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.PostponementNotice"></worker-mail>\n\n\t\t\t\t\t\t\t\t<!-- Print -->\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<a ui-sref="document-preview({agencyProfileId: agencyProfileId, agencyEmployerPensionId: agencyEmployerPensionId, mailtypeid: MAIL_TYPES.postponementNotice, userid: mailLogSummary.UserID})" ng-f="mailLogSummary.PostponementNotice.Bounced">print</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<!-- Assessment Status -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'sent\'">\n\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.AssessmentStatus"></worker-mail>\n\n\t\t\t\t\t\t\t\t<!-- Print -->\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<a ui-sref="document-preview({agencyProfileId: agencyProfileId, agencyEmployerPensionId: agencyEmployerPensionId, mailtypeid: MAIL_TYPES.assessmentStatus, userid: mailLogSummary.UserID})" ng-if="mailLogSummary.AssessmentStatus.Bounced">print</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<!-- Compliance Follow-up -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'sent\'">\n\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.ComplianceFollowUp"></worker-mail>\n\n\t\t\t\t\t\t\t\t<!-- Print -->\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<a ui-sref="email-preview({agencyProfileId: agencyProfileId, mailtypeid: MAIL_TYPES.employeeGuide, userid: mailLogSummary.UserID, previewType: EMAIL_PREVIEW_TYPES.standard})" ng-if="mailLogSummary.EmployeeGuide.Count > 0 && mailLogSummary.Email !== \'\'">resend</a>\n\t\t\t\t\t\t\t\t\t<span class="divider-left" ng-if="mailLogSummary.EmployeeGuide.Bounced">&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t\t\t<a ui-sref="document-preview({agencyProfileId: agencyProfileId, agencyEmployerPensionId: agencyEmployerPensionId, mailtypeid: MAIL_TYPES.employeeGuide, userid: mailLogSummary.UserID})" ng-if="mailLogSummary.EmployeeGuide.Bounced">print</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\n\n\t\t\t\t\t\t\t<!-- RECEIVED -->\n\t\t\t\t\t\t\t<!-- Opt in join notice -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'received\'">\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.OptInJoinNotice" no-mails-text="Not received"></worker-mail>\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t<!-- Opt out notice -->\n\t\t\t\t\t\t\t<td ng-if="searchBarOptions.custom === \'received\'">\n\t\t\t\t\t\t\t\t<worker-mail agency-profile-id="agencyProfileId" mail-object="mailLogSummary.OptOutNotice" no-mails-text="Not received"></worker-mail>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredMailLogSummaries.length === 0"></empty-search>\n\n\t\t\t<div class="spacer xl"></div>\n\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\n\t\t\t<div class="spacer xl"></div>\n\n\t\t\t<div class="info-block quarternary">\n\t\t\t\t<p class="s">*As part of your employer duties you are obliged to tell your team about the workplace pension. For people already in the company, you may have done this when you set the pension up, but for new starters you can send it via Paycircle.</p>\n\t\t\t</div>\n\t\t</main>\n\t</main>\n\n\t<!-- No team members -->\n\t<placeholder placeholder-graphic="team" ng-if="!mailLogSummaries.length">\n\t\t<placeholder-title>You don\'t have any team members set up yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p class="s">Once your team has been set up, you will be able to see the communications that Paycircle automatically sends to your team regarding their workplace pension.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" class="button primary" ui-sref="team.members({agencyProfileId: agencyProfileId})">Go to team</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<!-- Error -->\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/scheme/settings/pensions-scheme-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Workplace Pension -->\n\t<div class="detail-blocks">\n\n\t\t<header class="detail-blocks-header" ng-if="pension.PensionAutomationDetails.ConnectToProvider">\n\t\t\t<p><span class="stronger">Please note:</span> your automation options mean that some of your settings aren\u2019t editable</p>\n\t\t</header>\n\n\t\t<!-- Pension provider -->\n\t\t<detail-block db-can-edit="pension.PensionProviderDetails.CanUpdateSettings" db-details="pension.providerDetails"></detail-block>\n\n\t\t<!-- Automation options -->\n\t\t<detail-block db-details="pension.automationDetails" ng-if="pension.PensionProviderDetails.PensionType === PENSION_TYPES.autoEnrolment"></detail-block>\n\n\t\t<!-- Staging and re-enrolment -->\n\t\t<detail-block db-details="pension.stagingDetails" ng-if="pension.PensionProviderDetails.PensionType === PENSION_TYPES.autoEnrolment"></detail-block>\n\n\t\t<!-- Pension settings -->\n\t\t<detail-block db-details="pension.pensionSettingsDetails" ng-if="!pension.PensionProviderDetails.IsGhostPension"></detail-block>\n\n\t\t<!-- Team postponement -->\n\t\t<detail-block db-details="pension.postponementDetails" ng-if="pension.PensionProviderDetails.PensionType === PENSION_TYPES.autoEnrolment"></detail-block>\n\n\t\t<!-- Groups (if present). This or policyDetails (below) should exist -->\n\t\t<detail-block db-can-edit="pension.PensionGroupDetails.CanUpdateSettings" db-details="pension.groupDetails" ng-if="!pension.PensionProviderDetails.IsGhostPension && pension.groupDetails">\n\t\t\t<db-html ng-if="pension.PensionGroupDetails.PensionGroups.length === 0">\n\n\t\t\t\t<note note-icon="icon-warning" note-theme="tertiary" note-title="There are no groups available in your pension">\n\t\t\t\t\t<note-content>\n\t\t\t\t\t\t<p class="is-small" ng-if="pension.PensionAutomationDetails.ConnectToProvider">\n\t\t\t\t\t\t\tYou will need to create at least one pension group in your provider portal so you can add team members to it.\n\t\t\t\t\t\t\t<a class="underline tertiary" ng-href="{{pension.PensionProviderDetails.PensionProviderWebsiteUrl}}" target="_blank">Go to your provider portal</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="is-small" ng-if="!pension.PensionAutomationDetails.ConnectToProvider">\n\t\t\t\t\t\t\tYou will need to create at least one pension group so you can add team members to it.\n\t\t\t\t\t\t\t<a class="underline tertiary" ng-click="openCompanyPensionGroupsForm(pension)" ng-if="pension.PensionGroupDetails.CanUpdateSettings">Add pension group</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</note-content>\n\t\t\t\t</note>\n\t\t\t</db-html>\n\t\t</detail-block>\n\n\t\t<!-- Policy info (if present). This or groupDetails (above) should exist -->\n\t\t<detail-block db-can-edit="false" db-details="pension.policyDetails" ng-if="!pension.PensionProviderDetails.IsGhostPension && pension.policyDetails"></detail-block>\n\t</div>\n\n</div>\n');
$templateCache.put('features/app/pensions/scheme/status/pensions-scheme-status.view.html','<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Team members -->\n\t<div class="sub-page-template-a-section" ng-if="pension.CanAddTeamMembers">\n\t\t<task-card task-theme="tertiary">\n\t\t\t<task-title>Add team members to this pension</task-title>\n\t\t\t<task-description>\n\t\t\t\t<span ng-switch="pension.PensionType">\n\t\t\t\t\t<span pc-switch-when="PENSION_TYPES.autoEnrolment">Once added, you can then edit their status, group and contributions. <support-article-link article-key="$root.URLS.paycircle.support.pensionSetup" theme="tertiary underline" position="left">Read more</support-article-link></span>\n\t\t\t\t\t<span pc-switch-when="PENSION_TYPES.nonAutoEnrolment">Once added, you can then edit their contribution band and contributions. </span>\n\t\t\t\t</span>\n\t\t\t</task-description>\n\t\t\t<task-action><a href="" class="button m-l tertiary" ng-click="openPensionTeamForm()">Add team members</a></task-action>\n\t\t</task-card>\n\t</div>\n\n\t<!-- Ungrouped team members -->\n\t<div class="sub-page-template-a-section" ng-if="pension.TotalIncompleteGroupRemoved > 0">\n\t\t<!-- Has groups -->\n\t\t<task-card task-theme="tertiary" ng-if="pension.PensionGroupCount > 0">\n\t\t\t<task-title>There&nbsp;<ng-pluralize count="pension.TotalIncompleteGroupRemoved" when="{\'1\': \'is 1 ungrouped team member\', \'other\': \'are {} ungrouped team members\'}"></ng-pluralize>&nbsp;due to groups being removed</task-title>\n\t\t\t<task-description>Add them to an alternative group or create a new group with your provider. <a ng-href="{{pension.PensionProviderWebsiteUrl}}" class="underline tertiary" target="_blank">View in {{pension.PensionProviderName}}</a></task-description>\n\t\t</task-card>\n\n\t\t<!-- No groups -->\n\t\t<task-card task-theme="tertiary" ng-if="pension.PensionGroupCount === 0">\n\t\t\t<task-title>There&nbsp;<ng-pluralize count="pension.TotalIncompleteGroupRemoved" when="{\'1\': \'is 1 ungrouped team member\', \'other\': \'are {} ungrouped team members\'}"></ng-pluralize>&nbsp;as there are no groups available in your pension</task-title>\n\t\t\t<task-description>Create at least one group in your provider portal so you can add team members to it. <a ng-href="{{pension.PensionProviderWebsiteUrl}}" class="underline tertiary" target="_blank">View in {{pension.PensionProviderName}}</a></task-description>\n\t\t</task-card>\n\t</div>\n\n\t<!-- Pension resubmission -->\n\t<div class="sub-page-template-a-section" ng-switch="pension.PensionSubmitState">\n\t\t<div pc-switch-when="PENSION_SUBMISSION_STATES.failed">\n\t\t\t<task-card task-id="pension-state-failed" task-theme="tertiary">\n\t\t\t\t<task-title>Your pension submission for {{pension.PayPeriodPreviousDisplay}} has failed</task-title>\n\n\t\t\t\t<!-- PensionSync -->\n\t\t\t\t<task-description ng-if="::pension.PensionProviderAPI === PENSION_PROVIDER_APIS.pensionSync"><a href="" ng-click="getURLRedirect(pension.PensionSyncSmtUrl)" class="underline tertiary">View your pension in PensionSync</a> to review the issue and click \'Re-submit\' once it has been resolved.&nbsp;<support-article-link article-key="pensionSubmissionTroubleshooting" theme="tertiary">View troubleshooting guide</support-article-link></task-description>\n\n\t\t\t\t<!-- NEST -->\n\t\t\t\t<task-description ng-if="::pension.PensionProviderAPI === PENSION_PROVIDER_APIS.nest"><a ng-href="{{pension.PensionProviderWebsiteUrl}}" class="underline tertiary" target="_blank">View your pension in {{pension.PensionProviderName}}</a> to review the issue and click \'Re-submit\' once it has been resolved.&nbsp;<support-article-link article-key="pensionSubmissionTroubleshooting" theme="tertiary">View troubleshooting guide</support-article-link></task-description>\n\n\t\t\t\t<!-- Everyone else -->\n\t\t\t\t<task-description ng-if="::pension.PensionProviderAPI !== PENSION_PROVIDER_APIS.pensionSync && pension.PensionProviderAPI !== PENSION_PROVIDER_APIS.nest">Read this&nbsp;<support-article-link article-key="pensionSubmissionTroubleshooting" theme="tertiary">troubleshooting guide to workplace pensions</support-article-link>&nbsp;to resolve the issue, then click \'Re-submit\'.</task-description>\n\n\t\t\t\t<task-action><a href="" class="button m-l" ng-click="openFailedPensionManuallySubmitWarningForm(pension)">Manually submit</a><a href="" class="button m-l tertiary" ng-click="resubmitPension(pension)">Re-submit</a></task-action>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<div pc-switch-when="PENSION_SUBMISSION_STATES.submitting">\n\t\t\t<task-card task-icon="loading spin" task-id="pension-state-submitting" task-theme="tertiary">\n\t\t\t\t<task-title>Your pension submission for {{pension.PayPeriodPreviousDisplay}} is pending</task-title>\n\t\t\t\t<task-description>This can take a while so please check back again shortly.</task-description>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<div pc-switch-when="PENSION_SUBMISSION_STATES.pending">\n\t\t\t<task-card task-icon="loading spin" task-id="pension-state-pending" task-theme="tertiary">\n\t\t\t\t<task-title>Your pension submission for {{pension.PayPeriodPreviousDisplay}} has been pending for more than 24 hours</task-title>\n\t\t\t\t<task-description>We recommend that you <a href="" ng-click="getURLRedirect(pension.PensionSyncSmtUrl)" class="underline tertiary">sign in to PensionSync</a> to review your pension status</task-description>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<div pc-switch-when="PENSION_SUBMISSION_STATES.requesting">\n\t\t\t<task-card task-id="pension-state-requesting" task-theme="tertiary">\n\t\t\t\t<task-title>\n\t\t\t\t\tAutomated pension submission for {{pension.PayPeriodPreviousDisplay}} scheduled for {{::pension.PensionSubmissionScheduledDateISO | datetimeformat:\'long-alt\'}}\n\t\t\t\t</task-title>\n\t\t\t\t<task-description>\n\t\t\t\t\tClick \u2018Submit now\u2019 if you need to make submissions right away\n\t\t\t\t</task-description>\n\t\t\t\t<task-action>\n\t\t\t\t\t<a href="" ng-click="resubmitPension()" class="button m-l tertiary" ng-class="{\'disabled\': pensionResubmittingState === \'loading\'}" ng-switch="pensionResubmittingState">\n\t\t\t\t\t\t<span class="fadeIn" ng-switch-when="loading"><i class="icon-loading spin"></i></span>\n\t\t\t\t\t\t<span class="fadeIn" ng-switch-default>Submit now</span>\n\t\t\t\t\t</a>\n\t\t\t\t</task-action>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<div pc-switch-when="PENSION_SUBMISSION_STATES.queued">\n\t\t\t<task-card task-id="pension-state-queued" task-theme="tertiary">\n\t\t\t\t<task-title>Your pension submission for {{pension.PayPeriodPreviousDisplay}} is queued</task-title>\n\t\t\t\t<task-description>Your pension is currently in a queued state and we will continue attempting to submit it automatically. <br> Alternatively, you may choose to cancel the queue or submit it now.</task-description>\n\t\t\t\t<task-action><a href="" class="button m-l" ng-click="openQueuedPensionCancelWarningForm(pension)">Cancel queue</a><a href="" class="button m-l tertiary" ng-click="resubmitPension(pension)">Submit now</a></task-action>\n\t\t\t</task-card>\n\t\t</div>\n\t</div>\n\n\t<!-- Authorisation -->\n\t<section class="sub-page-template-a-section" ng-switch="pension.PensionState">\n\n\t\t<!-- Unauthorised -->\n\t\t<div class="fadeIn" pc-switch-when="PENSION_STATES.unauthorised">\n\t\t\t<task-card task-id="pension-state-unauthorised" task-theme="tertiary">\n\t\t\t\t<task-title>\n\t\t\t\t\tAuthorise Paycircle to access your workplace pension\n\t\t\t\t</task-title>\n\n\t\t\t\t<task-description data-cy="pension-status-unauthorised-auto-authorisation-active" ng-if="pension.IsAutoAuthorisationActive">\n\t\t\t\t\tPaycircle has made <span data-cy="pension-status-unauthorised-authorisation-attempt-count">{{pension.AuthorisationAttemptCount}}</span> of <span data-cy="pension-status-unauthorised-authorisation-attempt-count-max">{{pension.AuthorisationAttemptCountMax}}</span> attempts to automatically authorise your scheme.\n\t\t\t\t\tClick \'Authorise\' to try again now. <br>\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionAuthorisation" theme="tertiary" underline="true">\n\t\t\t\t\t\tReasons why your scheme needs authorising\n\t\t\t\t\t</support-article-link>\n\t\t\t\t</task-description>\n\n\t\t\t\t<task-description data-cy="pension-status-unauthorised-auto-authorisation-inactive" ng-if="!pension.IsAutoAuthorisationActive">\n\t\t\t\t\tPaycircle is no longer attempting to automatically authorise your scheme and you will need to do so manually now.\n\t\t\t\t\tClick \'Authorise\' to try again now. <br>\n\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionAuthorisation" theme="tertiary" underline="true">\n\t\t\t\t\t\tReasons why your scheme needs authorising\n\t\t\t\t\t</support-article-link>\n\t\t\t\t</task-description>\n\n\t\t\t\t<task-action>\n\t\t\t\t\t<button class="m-l tertiary" data-cy="pension-status-unauthorised-authorise-action" ng-click="onUnauthorisedPensionAuthorise(pension)" type="button">\n\t\t\t\t\t\tAuthorise\n\t\t\t\t\t</button>\n\t\t\t\t</task-action>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<!-- Reauthorise -->\n\t\t<div class="fadeIn" pc-switch-when="PENSION_STATES.reauthorise">\n\t\t\t<task-card task-id="pension-state-reauthorised" task-theme="tertiary">\n\t\t\t\t<task-title>Re-authorise Paycircle to access your workplace pension</task-title>\n\t\t\t\t<task-description>This could be for a <support-article-link article-key="$root.URLS.paycircle.support.pensionAuthorisation" theme="tertiary" underline="true">number of reasons</support-article-link> - click \'Authorise\' to fix the issue.</task-description>\n\t\t\t\t<task-action><a href="" ng-click="getURLRedirect(pension.PensionSyncAuthUrl)" class="button m-l tertiary">Authorise</a></task-action>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<!-- Pending -->\n\t\t<div class="fadeIn" pc-switch-when="PENSION_STATES.pending">\n\t\t\t<task-card task-icon="loading spin" task-id="pension-state-pending" task-theme="tertiary">\n\t\t\t\t<task-title>Your authorisation is pending</task-title>\n\t\t\t\t<task-description>This can take up to half an hour so please check back again shortly.</task-description>\n\t\t\t</task-card>\n\t\t</div>\n\n\t\t<!-- Authorised -->\n\t\t<div class="fadeIn" pc-switch-when="PENSION_STATES.loading">\n\t\t\t<task-card task-icon="loading spin" task-id="pension-state-loading" task-theme="secondary">\n\t\t\t\t<task-title>Your pension is authorised and we\u2019re retrieving your group information</task-title>\n\t\t\t\t<task-description>This can take up to five minutes so please check back again shortly.</task-description>\n\t\t\t</task-card>\n\t\t</div>\n\t</section>\n\n\t<!-- Pension Overview -->\n\t<section class="sub-page-template-a-section fadeIn">\n\n\t\t<!-- Pension Overview -->\n\t\t<div class="stat-block f cards" ng-switch="pension.PensionType">\n\t\t\t<div class="stat-block__item secondary" pc-switch-when="PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalEnrolled}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description">Enrolled</p>\n\t\t\t</div>\n\n\t\t\t<div class="stat-block__item secondary" pc-switch-when="PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalJoined}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description">Opted in/Joined</p>\n\t\t\t</div>\n\n\t\t\t<div class="stat-block__item assertive" pc-switch-when="PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalCeased}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description">Opted out/Ceased</p>\n\t\t\t</div>\n\n\t\t\t<div class="stat-block__item greyscale" pc-switch-when="PENSION_TYPES.autoEnrolment">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalPostponed}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description">Postponed</p>\n\t\t\t</div>\n\n\t\t\t<div class="stat-block__item stat-block__item--split" pc-switch-when="PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-team-alt l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalInPension}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description"><ng-pluralize count="pension.TotalInPension" when="{\'1\': \'Team member\', \'other\': \'Team members\'}"></ng-pluralize>&nbsp;in the pension</p>\n\t\t\t</div>\n\n\t\t\t<div class="stat-block__item" ng-class="{\'stat-block__item--large\' : pension.PensionType === PENSION_TYPES.autoEnrolment, \'stat-block__item--split\' : pension.PensionType === PENSION_TYPES.nonAutoEnrolment}">\n\t\t\t\t<div class="stat-block__header">\n\t\t\t\t\t<div class="stat-block__icon"><i class="icon-money l"></i></div>\n\t\t\t\t\t<h2 class="stat-block__stat">{{pension.TotalContribution | monetise}}</h2>\n\t\t\t\t</div>\n\t\t\t\t<p class="stat-block__description">Total contributions since <a href="" ng-click="openContributionsSinceDateModal()" class="underline greyscale">{{pension.FirstContributionDateISO | dateformat}}</a></p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Last Pay Period Overview -->\n\t\t<div class="stat-block a" ng-if="pension.PreviousPayPeriod && pension.PensionType === PENSION_TYPES.autoEnrolment">\n\t\t\t<div class="stat-block__header">\n\t\t\t\t<h5 class="stat-block__title">Last pay period&nbsp;<span class="stat-block__title-highlight">{{pension.PreviousPayPeriod.PayPeriodDisplay}}</span></h5>\n\t\t\t\t<div class="stat-block__menu">\n\n\t\t\t\t\t<dropdown-menu class="stat-block-action-menu" menu-size="xl" menu-theme="primary" menu-align="right" menu-text="Download report" menu-on-open="getReportsForPensionScheme(vm, pension)">\n\t\t\t\t\t\t<div class="dropdown-group" ng-switch="vm.reportDownloadState">\n\t\t\t\t\t\t\t<div class="centered-contents fadeIn" ng-switch-when="loading">\n\t\t\t\t\t\t\t\t<circle-loader size="\'m\'"></circle-loader>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class="fadeIn" ng-switch-when="ready">\n\n\t\t\t\t\t\t\t\t<div ng-show="vm.pensionReports.length > 0">\n\t\t\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle">Pension report:</p>\n\t\t\t\t\t\t\t\t\t<report-export-item report="pensionReport" ng-repeat="pensionReport in vm.pensionReports = (vm.reports | reportCategories:\'pension-url\')"></report-export-item>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div ng-if="vm.pensionReports.length === 0">\n\t\t\t\t\t\t\t\t\t<p class="dropdown-menu-subtitle italic">No pension reports assigned to company</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</dropdown-menu>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="stat-block__stats">\n\t\t\t\t<div class="stat-block__item stat-block__item--large">\n\t\t\t\t\t<h4 class="stat-block__stat">{{pension.PreviousPayPeriod.TotalContribution | monetise}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Total Contribution</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item stat-block__item--large tertiary" ng-if="pension.PreviousPayPeriod.IsContributionChangeVisible">\n\t\t\t\t\t<h4 class="stat-block__stat"><i class="s" ng-class="{\'icon-chevron-up tertiary\' : pension.PreviousPayPeriod.ContributionChange >= 0, \'icon-chevron-down\': pension.PreviousPayPeriod.ContributionChange < 0}" ng-if="pension.PreviousPayPeriod.ContributionChange !==0"></i>{{ pension.PreviousPayPeriod.ContributionChange | monetise}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Contribution Change</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item">\n\t\t\t\t\t<h4 class="stat-block__stat">{{pension.PreviousPayPeriod.OptedIn}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Opted In</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item">\n\t\t\t\t\t<h4 class="stat-block__stat">{{pension.PreviousPayPeriod.OptedOut}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Opted Out</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item">\n\t\t\t\t\t<h4 class="stat-block__stat">{{pension.PreviousPayPeriod.Enrolled}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Enrolled</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="stat-block__item">\n\t\t\t\t\t<h4 class="stat-block__stat">{{pension.PreviousPayPeriod.Postponed}}</h4>\n\t\t\t\t\t<p class="stat-block__description">Postponed</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</section>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/pensions/scheme/team/pensions-scheme-team.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<header class="sub-page-template-a-header" ng-if="teamMembers.length > 0">\n\t\t<h4>Team Overview</h4>\n\t\t<p>Here you can find up-to-date contribution amounts for your team based upon their current pay information.</p>\n\t</header>\n\n\t<!-- Team -->\n\t<main class="sub-page-template-a-main" ng-if="teamMembers.all.length > 0">\n\n\t\t<!-- Filter -->\n\t\t<filter-bar apply-filter-keys="applyfilter" filter-bar-options="filterBarOptions" ng-if="::!pension.IsGhostPension"></filter-bar>\n\n\t\t<!-- Search -->\n\t\t<search-bar bulk-items="teamMembers" options="searchBarOptions"></search-bar>\n\n\t\t<!-- Team Cards -->\n\t\t<section class="team-cards {{searchBarOptions.layout}}">\n\n\t\t\t<team-card-pension agency-employer-pension-id="{{agencyEmployerPensionId}}" agency-profile-id="{{agencyProfileId}}" current-page="searchBarOptions.currentPageNumber" dir-paginate="teamMember in teamMembers.filtered = (\n\t\t\t\t\t\tteamMembers.all |\n\t\t\t\t\t\tfilter : searchBarOptions.search.searchFilter : searchBarOptions.search.isExactMatch |\n\t\t\t\t\t\tfilter : filterBarOptions.appliedFilter\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t" index="$index" is-ghost-pension="pension.IsGhostPension" on-update="init" pension-additional-post-id="{{teamMember.Pension.SalaryPolicyPostID}}" team-member="teamMember"></team-card-pension>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="teamMembers.filtered.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</main>\n\n\t<!-- No team members -->\n\t<div class="sub-page-template-a-section" ng-if="!teamMembers.all.length">\n\t\t<task-card task-theme="tertiary">\n\t\t\t<task-title>Add team members to this pension</task-title>\n\t\t\t<task-description>\n\t\t\t\t<span ng-switch="pension.PensionType">\n\t\t\t\t\t<span pc-switch-when="PENSION_TYPES.autoEnrolment">\n\t\t\t\t\t\tOnce added, you can then edit their status, group and contributions.\n\t\t\t\t\t\t<support-article-link article-key="$root.URLS.paycircle.support.pensionSetup" theme="tertiary" underline="true">Read more</support-article-link>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span pc-switch-when="PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\t\tOnce added, you can then edit their contribution band and contributions.\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\t\t\t</task-description>\n\t\t\t<task-action>\n\t\t\t\t<a class="button m-l tertiary" href="" ng-click="openPensionTeamForm()">Add team members</a>\n\t\t\t</task-action>\n\t\t</task-card>\n\t</div>\n\n\t<!-- Powered by Paycircle -->\n\t<powered-by-paycircle></powered-by-paycircle>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/access/authentication/settings-access-authentication.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<main class="sub-page-template-a-main">\n\n\t\t<div class="detail-blocks">\n\n\t\t\t<!-- Two-Factor Authentication -->\n\t\t\t<detail-block db-details="vm.twoFactorAuthentication" db-show-feedback="true">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small" ng-if="!vm.companyAuthentication.tfaIsEnabled">Enabling two-factor authentication for the <span class="stronger">users of the payroll portal</span> will give additional security of online accounts beyond logging in with just a username and password</p>\n\t\t\t\t\t<p class="is-small" ng-if="vm.companyAuthentication.tfaIsEnabled">Disabling two-factor authentication will remove this extra layer of security, you will only be asked for a password when you sign in. </p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\n\t\t\t<!-- Session timeout -->\n\t\t\t<detail-block db-details="vm.sessionTimeoutBlock" db-show-feedback="true">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small">Set the session duration before people are signed out of their accounts after a period of inactivity.</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\n\t\t\t<!-- Single sign-on -->\n\t\t\t<detail-block db-details="vm.ssoBlock" db-show-feedback="true">\n\t\t\t\t<db-feedback>\n\t\t\t\t\t<p class="is-small">Enable single sign-on so admins can authenticate themselves using their SSO ID.</p>\n\t\t\t\t</db-feedback>\n\t\t\t</detail-block>\n\t\t</div>\n\n\t</main>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/access/ip-management/settings-access-ip-management.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<main class="sub-page-template-a-main">\n\n\t\t<!-- Office Locations -->\n\t\t<div class="sub-page-template-a-section has-separator">\n\t\t\t<div class="sub-page-template-a-section-header">\n\t\t\t\t<div class="sub-page-template-a-section-title">Office Locations</div>\n\t\t\t\t<button class="primary inverse" ng-click="vm.openAddOfficeLocationsForm(vm)">Add office locations</button>\n\t\t\t</div>\n\n\t\t\t<div>\n\t\t\t\t<section class="office-location-cards cards" ng-if="vm.ipAddresses.length > 0">\n\t\t\t\t\t<office-location-card ng-repeat="ipAddress in vm.ipAddresses" ip-address="ipAddress" agency-profile-id="vm.agencyProfileId" refresh="vm.refresh"></office-location-card>\n\t\t\t\t</section>\n\n\t\t\t\t<!-- No office locations -->\n\t\t\t\t<placeholder placeholder-graphic="no-office-locations" placeholder-layout="is-horizontal" ng-if="vm.ipAddresses.length === 0">\n\t\t\t\t\t<placeholder-title>No Office locations</placeholder-title>\n\t\t\t\t\t<placeholder-copy>\n\t\t\t\t\t\t<p>Adding an office location will restrict access for anyone trying to access paycircle from outside of that location.</p>\n\t\t\t\t\t</placeholder-copy>\n\t\t\t\t</placeholder>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Remote locations -->\n\t\t<div class="sub-page-template-a-section has-separator">\n\t\t\t<div class="sub-page-template-a-section-header">\n\t\t\t\t<div class="sub-page-template-a-section-title">Remote Locations</div>\n\t\t\t\t<button class="primary inverse" ng-click="vm.openEditRemoteLocationsForm(vm)">Edit remote locations</button>\n\t\t\t</div>\n\n\t\t\t<div>\n\t\t\t\t<search-bar options="vm.searchBarOptions" bulk-items="vm.teamMemberAdmins"></search-bar>\n\n\t\t\t\t<section class="remote-location-cards" ng-class="vm.searchBarOptions.layout">\n\t\t\t\t\t<remote-location-card ng-repeat="teamMemberAdmin in vm.teamMemberAdmins.filtered = ( vm.teamMemberAdmins.all | filter : vm.searchBarOptions.search.string | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse )" team-member-admin="teamMemberAdmin" refresh="vm.refresh" agency-profile-id="vm.agencyProfileId"></remote-location-card>\n\t\t\t\t</section>\n\t\t\t</div>\n\t\t</div>\n\n\t</main>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/business-categories/category/settings-business-categories-category.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<!-- Search Bar -->\n\t<search-bar count="vm.activeBusinessCategory.BusinessCodes.length" ng-show="vm.activeBusinessCategory.BusinessCodes.length > 1" options="vm.searchBarOptions">\n\t\t<sb-right-actions>\n\t\t\t<a href="" class="button primary" ng-click="vm.openBusinessCodeForm(vm.activeBusinessCategory)">\n\t\t\t\t<i class="icon-plus"></i>Add new\n\t\t\t</a>\n\t\t</sb-right-actions>\n\t</search-bar>\n\n\t<div class="business-code-card_wrapper rows">\n\n\t\t<!-- Business codes -->\n\t\t<business-code-card agency-profile-id="vm.agencyProfileId" business-category="vm.activeBusinessCategory" business-code="businessCode" ng-if="vm.activeBusinessCategory.BusinessCodes.length > 1" ng-repeat="businessCode in vm.activeBusinessCategory.BusinessCodes |\n\t\t\t\tfilter : vm.searchBarOptions.search.string |\n\t\t\t\torderBy: [\'-IsUnallocatedBusinessCode\', vm.searchBarOptions.orderBy] : vm.searchBarOptions.results.reverse\n\t\t\t" refresh-departments="vm.refreshDepartments()" show-extras="true"></business-code-card>\n\n\t\t<!-- No business codes -->\n\t\t<placeholder placeholder-graphic="departments" ng-if="vm.activeBusinessCategory.BusinessCodes.length <= 1">\n\t\t\t<placeholder-title>Add your first {{vm.activeBusinessCategory.businessCategoryNameLower}}</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Once created, you\u2019ll be able to add team members to it.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" class="button primary" ng-click="vm.openBusinessCodeForm(vm.activeBusinessCategory)"><i class="icon-plus"></i>&nbsp;Add {{vm.activeBusinessCategory.businessCategoryNameLower}}</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>');
$templateCache.put('features/app/settings/business-categories/imports/settings-business-categories-imports.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Has imports -->\n\t<div class="page-template-a-main" ng-if="vm.importHistoryItems.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar apply-filter-keys="applyFilter" filter-bar-options="vm.filterBarOptionsImports" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar count="vm.importHistoryItemsFiltered.length" options="vm.searchBarOptionsImports"></search-bar>\n\n\t\t<!-- Import Cards -->\n\t\t<div class="import-history-item_wrapper">\n\t\t\t<import-history-item agency-profile-id="vm.agencyProfileId" current-page="vm.searchBarOptionsImports.currentPageNumber" dir-paginate="import in vm.importHistoryItemsFiltered = (\n\t\t\t\t\t\tvm.importHistoryItems |\n\t\t\t\t\t\tfilter : vm.searchBarOptionsImports.search.string |\n\t\t\t\t\t\tfilter : vm.filterBarOptionsImports.appliedFilter\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : vm.searchBarOptionsImports.orderBy : vm.searchBarOptionsImports.results.reverse |\n\t\t\t\t\titemsPerPage : vm.searchBarOptionsImports.results.itemsPerPage" import="import" on-update="vm.refresh()" pay-period="vm.payPeriod"></import-history-item>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-show="vm.importHistoryItemsFiltered.length === 0" search-bar-options="vm.searchBarOptionsImports"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No Imports -->\n\t<placeholder placeholder-graphic="import" placeholder-graphic-size="l" ng-if="!vm.importHistoryItems.length">\n\t\t<placeholder-title>You haven\u2019t imported any business categories</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Your import history will appear here</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\n<error-block ng-if="pageState === \'error\'"></error-block></div>');
$templateCache.put('features/app/settings/imports/settings/settings-imports-settings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<section class="page-template-a-section fadeIn" ng-if="pageState === \'ready\'">\n\t<div class="detail-blocks">\n\n\t\t<!-- Changes Import > Horizontal -->\n\t\t<detail-block db-details="vm.currentPeriodDetails" ng-if="!vm.isVertical">\n\t\t\t<db-html>\n\t\t\t\t<img alt="" src="images/graphics/horizontal-elements.png">\n\t\t\t\t<p class="s detail-block-html-value">Horizontal</p>\n\t\t\t\t<p class="s detail-block-html-description">The pay element data flows across in rows and there\'s a row for every element for every team member.</p>\n\t\t\t</db-html>\n\t\t</detail-block>\n\n\t\t<!-- Changes Import > Vertical -->\n\t\t<detail-block db-details="vm.currentPeriodDetails" ng-if="vm.isVertical">\n\t\t\t<db-html>\n\t\t\t\t<img alt="" src="images/graphics/vertical-elements.png">\n\t\t\t\t<p class="s detail-block-html-value">Vertical</p>\n\t\t\t\t<p class="s detail-block-html-description">The pay element data flows down in columns and there\'s (normally) a single row for each team member</p>\n\t\t\t</db-html>\n\t\t</detail-block>\n\n\t\t<!-- Team imports -->\n\t\t<detail-block db-details="vm.teamImportsDetails">\n\t\t\t<db-html>\n\t\t\t\t<p class="caption">Team members can be automatically set as casual workers when they\u2019re imported, and only appear on payroll when changes are imported for them.</p>\n\t\t\t</db-html>\n\t\t</detail-block>\n\t</div>\n</section>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/imports/mappings/settings-imports-mappings.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'" ng-switch="$root.currentCompany.CompanyType">\n\n\t<main class="page-template-a-main" ng-if="vm.importMappingTemplates.length > 0">\n\n\t\t<filter-bar filter-bar-options="vm.filterBarOptions"></filter-bar>\n\n\t\t<search-bar options="vm.searchBarOptions" count="vm.importMappingTemplatesFiltered.length">\n\t\t\t<sb-right-actions ng-if="$root.currentCompany.CompanyType === INTERFACE_TYPES.bureau">\n\t\t\t\t<a href="" ui-sref="data-importer.upload-file({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.DOCUMENT_TYPES.bureauMappingTemplate})" class="button is-primary">+ New template</a>\n\t\t\t</sb-right-actions>\n\t\t</search-bar>\n\n\t\t<div class="import-mapping-cards">\n\t\t\t<import-mapping-card ng-repeat="importMapping in vm.importMappingTemplatesFiltered = ( vm.importMappingTemplates | filter : vm.searchBarOptions.search.string | filter : vm.filterBarOptions.appliedFilter ) | orderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse" import-mapping="importMapping" refresh="vm.refresh()"></import-mapping-card>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="vm.searchBarOptions" ng-show="vm.importMappingTemplatesFiltered.length === 0"></empty-search>\n\t</main>\n\n\t<!-- No Import Mappings (Bureaus) -->\n\t<main class="page-template-a-main" ng-if="vm.importMappingTemplates.length === 0" pc-switch-when="INTERFACE_TYPES.bureau">\n\t\t<placeholder placeholder-graphic="no-mapping-templates">\n\t\t\t<placeholder-title>Start creating templates</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Map headers against a CSV file and create mapping templates which are available to all companies in your bureau.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ui-sref="data-importer.upload-file({agencyProfileId: vm.agencyProfileId, agencyDocumentType: vm.DOCUMENT_TYPES.bureauMappingTemplate})" class="button is-primary">+ New template</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</main>\n\n\t<!-- No Import Mappings (Companies) -->\n\t<main class="page-template-a-main" ng-if="vm.importMappingTemplates.length === 0" ng-switch-default>\n\t\t<placeholder placeholder-graphic="no-mapping-templates">\n\t\t\t<placeholder-title>No mappings saved</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As you save mappings while you&apos;re importing team or payroll data they will start to appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</main>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>');
$templateCache.put('features/app/settings/journals/imports/settings-journals-imports.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<!-- Has imports -->\n\t<div class="page-template-a-main" ng-if="vm.importHistoryItems.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar apply-filter-keys="applyFilter" filter-bar-options="vm.filterBarOptions" preset-filter-key="{{presetFilterKey}}"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar count="vm.importHistoryItemsFiltered.length" options="vm.searchBarOptions"></search-bar>\n\n\t\t<!-- Import Cards -->\n\t\t<div class="import-history-item_wrapper">\n\t\t\t<import-history-item agency-profile-id="vm.agencyProfileId" current-page="vm.searchBarOptions.currentPageNumber" dir-paginate="import in vm.importHistoryItemsFiltered = (\n\t\t\t\t\t\tvm.importHistoryItems |\n\t\t\t\t\t\tfilter : vm.searchBarOptions.search.string |\n\t\t\t\t\t\tfilter : vm.filterBarOptions.appliedFilter\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage" import="import" on-update="vm.refresh()" pay-period="vm.payPeriod"></import-history-item>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-show="vm.importHistoryItemsFiltered.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No Imports -->\n\t<placeholder placeholder-graphic="import" placeholder-graphic-size="l" ng-if="!vm.importHistoryItems.length">\n\t\t<placeholder-title>You haven\u2019t imported any nominal codes</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Your import history will appear here</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n\n\n<error-block ng-if="pageState === \'error\'"></error-block></div>');
$templateCache.put('features/app/settings/journals/nominal-codes/settings-journals-nominal-codes.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="page-template-d" ng-if="pageState === \'ready\'">\n\n\t<main class="page-template-d_container" ng-if="vm.nominalCodes.allocated.length">\n\n\t\t<section class="page-template-d_main">\n\n\t\t\t<search-bar count="vm.nominalCodes.allocatedFiltered.length" options="vm.searchBarOptions">\n\t\t\t\t<sb-right-actions>\n\t\t\t\t\t<div class="spaced-links">\n\n\t\t\t\t\t\t<div class="spaced-links__item has-border-left">\n\t\t\t\t\t\t\t<a class="strong" href="" ng-click="vm.openPreviewAndExportModal(vm)">\n\t\t\t\t\t\t\t\t<i class="icon-download has-margin-right"></i>Allocation report\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t<a class="strong" data-cy="edit-nominal-codes" href="" ng-click="vm.openAddNominalCodesForm(vm.nominalCodes.allocated, vm.isFinancialsIntegrated)">\n\t\t\t\t\t\t\t\t<i class="icon-edit has-margin-right"></i>Edit codes\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="spaced-links__item spaced-links__item--no-spacer">\n\t\t\t\t\t\t\t<a class="button primary" data-cy="create-nominal-codes" ui-sref="data-importer.select-import-file-type-xero({\n\t\t\t\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.xeroNominalCodes\n\t\t\t\t\t\t\t\t})">\n\t\t\t\t\t\t\t\tImport\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</sb-right-actions>\n\t\t\t</search-bar>\n\n\t\t\t<!-- Nominal codes -->\n\t\t\t<div class="nominal-codes" data-cy="nominal-codes">\n\t\t\t\t<div class="fadeIn" ng-repeat="nominalCode in vm.nominalCodes.allocatedFiltered = (\n\t\t\t\t\t\tvm.nominalCodes.allocated | filter : {\'NominalCodeNarrative\': vm.searchBarOptions.search.string }\n\t\t\t\t\t)">\n\n\t\t\t\t\t<div class="nominal-code" data-cy="nominal-code">\n\t\t\t\t\t\t<div class="nominal-code_header" ng-class="{\n\t\t\t\t\t\t\t\t\'is-expanded\': nominalCode.isActive\n\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t<!-- Has entries -->\n\t\t\t\t\t\t\t<a class="nominal-code_title" href="" ng-click="vm.toggleIsActive(nominalCode)">\n\t\t\t\t\t\t\t\t<i class="icon-chevron-{{nominalCode.isActive ? \'up\' : \'down\'}} is-medium nominal-code_header-icon"></i>\n\t\t\t\t\t\t\t\t<span class="nominal-code_description" data-cy="nominal-code-description">\n\t\t\t\t\t\t\t\t\t{{nominalCode.NominalCodeValue}} - {{nominalCode.NominalCodeNarrative}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class="tag is-inverse is-primary" ng-if="nominalCode.NominalCodeOverrideJournalCode" tooltip tooltip-position="top" tooltip-text="Payments to this nominal code will use the control account codes set against business categories, instead of employees\u2019 business category codes.">\n\t\t\t\t\t\t\t\t\tControl\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t<div class="nominal-code_header-secondary">\n\n\t\t\t\t\t\t\t\t<!-- Meta -->\n\t\t\t\t\t\t\t\t<div class="nominal-code_attributes">\n\t\t\t\t\t\t\t\t\t<div class="nominal-code_attribute" ng-if="nominalCode.NominalCodeProfitAndLoss && nominalCode.balanceSheetProfitAndLossEnabled">\n\t\t\t\t\t\t\t\t\t\tProfit and Loss\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="nominal-code_attribute" ng-if="nominalCode.NominalCodeBalanceSheet && nominalCode.balanceSheetProfitAndLossEnabled">\n\t\t\t\t\t\t\t\t\t\tBalance Sheet\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Add pay elements -->\n\t\t\t\t\t\t\t\t<a class="button is-white is-tiny is-strong fadeIn nominal-code_action-button" href="" ng-click="vm.moveActivePayElementsToNominalCodes(vm, nominalCode)" ng-show="vm.nominalCodes.entries.active.length > 0">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.nominalCodes.entries.active.length" when="{\n\t\t\t\t\t\t\t\t\t\t\t\'1\': \'Add 1 element\',\n\t\t\t\t\t\t\t\t\t\t\t\'other\': \'Add {} elements\'\n\t\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t<!-- Element count -->\n\t\t\t\t\t\t\t\t<span class="nominal-code_meta">\n\t\t\t\t\t\t\t\t\t<ng-pluralize count="nominalCode.NominalEntries.length" when="{\n\t\t\t\t\t\t\t\t\t\t\t\'1\': \'1 element\',\n\t\t\t\t\t\t\t\t\t\t\t\'other\': \'{} elements\'\n\t\t\t\t\t\t\t\t\t\t}"></ng-pluralize>\n\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t<!-- Delete -->\n\t\t\t\t\t\t\t\t<a aria-label="Delete nominal code" class="is-primary nominal-code_delete" href="" ng-click="vm.openDeleteNominalCodeForm(nominalCode, vm.nominalCodes.allocated)"><i class="icon-trash is-smedium"></i></a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="nominal-code_main fadeIn" ng-show="nominalCode.isActive">\n\t\t\t\t\t\t\t<div class="nominal-entry-tag-list" ng-if="nominalCode.NominalEntries.length > 0">\n\n\t\t\t\t\t\t\t\t<div class="nominal-entry-tag" ng-class="nominalEntry.theme" ng-repeat="nominalEntry in nominalCode.NominalEntries |\n\t\t\t\t\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\t\t\t\t\tNominalEntryArchived: false\n\t\t\t\t\t\t\t\t\t\t} |\n\t\t\t\t\t\t\t\t\t\torderBy: [\n\t\t\t\t\t\t\t\t\t\t\t\'category\',\n\t\t\t\t\t\t\t\t\t\t\t\'AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t\t\t\t\t\t]\n\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t<span class="nominal-entry-tag_name">\n\t\t\t\t\t\t\t\t\t\t{{nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<span class="nominal-entry-tag_tag">\n\t\t\t\t\t\t\t\t\t\t<span class="nominal-entry-tag_tag-cheese tag inverse" ng-if="nominalEntry.AgencyAdjustmentGroupEntry.IsBalanceSheet" tooltip tooltip-text="Balance Sheet">\n\t\t\t\t\t\t\t\t\t\t\tBS\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<span class="nominal-entry-tag_tag-cheese tag inverse" ng-if="!nominalEntry.AgencyAdjustmentGroupEntry.IsBalanceSheet" tooltip tooltip-text="Profit and Loss">\n\t\t\t\t\t\t\t\t\t\t\tPL\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t<a class="icon-close nominal-entry-tag_remove" href="" ng-click="vm.deleteNominalEntry(vm, nominalCode, nominalEntry)"></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Placeholder -->\n\t\t\t\t\t\t\t<p class="caption nominal-entry-tag_placeholder" ng-if="nominalCode.NominalEntries.length === 0">\n\t\t\t\t\t\t\t\tSelect elements and click &lsquo;Add elements&rsquo; to allocate them to this nominal code.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search ng-show="vm.nominalCodes.allocatedFiltered.length === 0" search-bar-options="vm.searchBarOptions"></empty-search>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<aside class="page-template-d_aside">\n\n\t\t\t<!-- Header -->\n\t\t\t<div class="page-template-d_aside-section" ng-if="vm.isHelperTextVisible">\n\t\t\t\t<p class="s italic">\n\t\t\t\t\tSelect elements then click the &lsquo;Add elements&rsquo; button for the nominal code you wish to allocate them to. <a href="" ng-click="vm.dismissHelperText(vm)">Dismiss</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<!-- Search -->\n\t\t\t<div class="page-template-d_aside-section">\n\t\t\t\t<input class="block" id="payElementsSearch" ng-model="vm.payElementsSearchTerm" placeholder="Search pay elements" type="search">\n\t\t\t</div>\n\n\t\t\t<!-- Tabs -->\n\t\t\t<div class="page-template-d_aside-section">\n\t\t\t\t<nav class="tabs" ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\t\t\t\t\t<a data-cy="{{::category.id}}" href="" ng-class="{\'active\': vm.activeCategory.key === category.key}" ng-click="vm.selectCategory(vm, category)" ng-repeat="category in vm.GROUP_ENTRY_CATEGORIES">{{category.name}}</a>\n\t\t\t\t</nav>\n\t\t\t</div>\n\n\t\t\t<!-- Results -->\n\t\t\t<div class="page-template-d_aside-section nominal-entry-list">\n\n\t\t\t\t<p class="nominal-entry-list_count is-small fadeIn" ng-if="vm.nominalCodes.entries.filtered.length > 0">\n\t\t\t\t\t{{vm.nominalCodes.entries.filtered.length}} unallocated\n\t\t\t\t</p>\n\n\t\t\t\t<div class="nominal-entry fadeIn" ng-class="nominalEntry.category | nominalEntryCategoryTheme" data-cy="{{::nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText | slugify}}" ng-repeat="nominalEntry in vm.nominalCodes.entries.filtered = (vm.nominalCodes.entries.unallocated |\n\t\t\t\t\t\tfilter: vm.payElementsSearchTerm |\n\t\t\t\t\t\tfilter: {\n\t\t\t\t\t\t\tcategory: vm.activeCategory.key\n\t\t\t\t\t\t}) |\n\t\t\t\t\t\torderBy : \'AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText\'\n\t\t\t\t\t">\n\t\t\t\t\t<label class="nominal-entry_label" for="{{nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText | slugify}}" ng-class="{\n\t\t\t\t\t\t\t\'is-active\': nominalEntry.isActive\n\t\t\t\t\t\t}">\n\t\t\t\t\t\t<span class="nominal-entry_text">\n\t\t\t\t\t\t\t<truncate text="nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText" truncate-amount="35"></truncate>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<div class="nominal-entry_tag">\n\t\t\t\t\t\t\t<span class="nominal-entry_tag-cheese tag inverse" ng-if="nominalEntry.AgencyAdjustmentGroupEntry.IsBalanceSheet" tooltip tooltip-position="left" tooltip-text="Balance Sheet">\n\t\t\t\t\t\t\t\tBS\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class="nominal-entry_tag-cheese tag inverse" ng-if="!nominalEntry.AgencyAdjustmentGroupEntry.IsBalanceSheet" tooltip tooltip-position="left" tooltip-text="Profit and Loss">\n\t\t\t\t\t\t\t\tPL\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\n\t\t\t\t\t<div class="nominal-entry_checkbox">\n\t\t\t\t\t\t<input checkbox-input checkbox-input-theme="{{nominalEntry.category | nominalEntryCategoryTheme | uncemify}}" class="a" id="{{nominalEntry.AgencyAdjustmentGroupEntry.AgencyAdjustmentGroupEntryText | slugify}}" ng-change="vm.populateActiveEntries(vm)" ng-model="nominalEntry.isActive" type="checkbox">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- All allocated -->\n\t\t\t\t<div class="nominal-entry-list_empty fadeIn" ng-if="vm.nominalCodes.entries.filtered.length === 0 && vm.payElementsSearchTerm === \'\'">\n\t\t\t\t\t<div class="nominal-entry-list_empty-icon">\n\t\t\t\t\t\t<icon-dot icon="icon-check" theme="secondary is-extra-large"></icon-dot>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="nominal-entry-list_empty-message">\n\t\t\t\t\t\t<h6>Fully allocated</h6>\n\t\t\t\t\t\t<p class="is-small">All {{vm.activeCategory.singular}} elements have been allocated to a nominal code</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<div class="nominal-entry-list_empty fadeIn" ng-if="vm.nominalCodes.entries.filtered.length === 0 && vm.payElementsSearchTerm !== \'\'">\n\t\t\t\t\t<div class="nominal-entry-list_empty-icon">\n\t\t\t\t\t\t<icon-dot icon="icon-warning" theme="primary is-extra-large"></icon-dot>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="nominal-entry-list_empty-message">\n\t\t\t\t\t\t<h6>No results found</h6>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</aside>\n\n\t</main>\n\n\t<!-- No Nominal Codes, journal framework editable -->\n\t<main class="page-template-a-main" ng-if="vm.nominalCodes.allocated.length === 0">\n\t\t<placeholder placeholder-graphic="add-journal-codes">\n\t\t\t<placeholder-title>Start adding nominal codes</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>\n\t\t\t\t\t<!--\n\t\t\t\t\tAdd codes manually, import them from CSV, or <a ui-sref="settings.company.journals.xero({agencyProfileId: vm.agencyProfileId})" class="underline">connect to Xero</a> so you can\n\t\t\t\t\timport your Chart of Accounts. You\u2019ll then be able to start allocating pay elements to your nominal codes.-->\n\t\t\t\t\tAdd them manually or import them from a CSV file. You\u2019ll then be able to start allocating pay elements to your nominal codes.\n\t\t\t\t</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a class="button primary" data-cy="create-nominal-codes" href="" ng-click="vm.openAddNominalCodesForm(vm.nominalCodes.allocated)">Add codes</a>\n\t\t\t\t<a class="button primary" data-cy="import-nominal-codes" ui-sref="data-importer.select-import-file-type-xero({\n\t\t\t\t\t\tagencyProfileId: vm.agencyProfileId,\n\t\t\t\t\t\tagencyDocumentType: vm.DOCUMENT_TYPES.xeroNominalCodes\n\t\t\t\t\t})">Import</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</main>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/journals/posts/settings-journals-posts.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<div class="page-template-a-main" ng-if="vm.journalPostGroups.length">\n\n\t\t<!-- Optional Search bar, sorting and layout (for large data sets) -->\n\t\t<search-bar options="vm.searchBarOptions" count="vm.journalPostGroupsFiltered.length"></search-bar>\n\n\t\t<div class="journal-post-card" dir-paginate="journalPostGroup in vm.journalPostGroupsFiltered = (\n\t\t\t\t\tvm.journalPostGroups |\n\t\t\t\t\tfilter : vm.searchBarOptions.search.string\n\t\t\t\t) |\n\t\t\t\torderBy : vm.searchBarOptions.orderBy : vm.searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : vm.searchBarOptions.results.itemsPerPage\n\t\t\t">\n\t\t\t<div class="journal-post-card_main" ng-class="{\n\t\t\t\t\t\'is-active\': journalPostGroup.isMenuOpen\n\t\t\t\t}">\n\t\t\t\t<div class="journal-post-card_label">\n\t\t\t\t\t<i class="icon-calendar journal-post-card_icon"></i>\n\t\t\t\t\t<span class="journal-post-card_description">{{journalPostGroup.JournalPostDescription}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="journal-post-card_other">\n\t\t\t\t\t<dropdown-menu class="journal-post-card_menu" data-cy="journal-post-card_menu-${index}" menu-icon="icon-setup" menu-show="journalPostGroup.isMenuOpen" menu-show-chevron="false" menu-size="l">\n\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t<a href="" ng-click="vm.openAddPostForm(journalPostGroup)">Add new post</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</dropdown-menu>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="journal-post-card_posts fadeIn" ng-show="journalPostGroup.isPostsVisible">\n\t\t\t\t<div class="journal-post-card_post-item" ng-repeat="journalPost in journalPostGroup.posts">\n\t\t\t\t\t<div class="journal-post-card_post-details">\n\t\t\t\t\t\t<icon-dot class="journal-post-card_post-icon" icon="{{journalPost.JournalPostState | journalPostIcon}}" theme="is-small is-font-large {{journalPost.JournalPostState | journalPostTheme}}"></icon-dot>\n\t\t\t\t\t\t<div class="journal-post-card_post-description">\n\t\t\t\t\t\t\t<p class="is-small">\n\t\t\t\t\t\t\t\t<span class="journal-post-card_post-state">{{journalPost | journalPostStateLabel}}</span> - {{journalPost.JournalPostActor}} on {{journalPost.JournalPostActionDateISO | dateformat:\'dateTimeAlt\'}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class="caption">\n\t\t\t\t\t\t\t\tSettings: \n\t\t\t\t\t\t\t\t<span ng-if="!journalPost.JournalPostOverrideTemporalData">When payroll was run</span>\n\t\t\t\t\t\t\t\t<span ng-if="journalPost.JournalPostOverrideTemporalData">As at {{journalPost.JournalPostActionDateISO | dateformat:\'dateTimeAlt\'}}</span>\n\t\t\t\t\t\t\t\t<a href="" ng-click="vm.openJournalPostTemporalDataForm(journalPostGroup)" ng-if="journalPost.canUpdatePost">\n\t\t\t\t\t\t\t\t\tedit\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Edit -->\n\t\t\t\t\t<div class="journal-post-card_post-actions" ng-if="journalPost.canUpdatePost">\n\t\t\t\t\t\t<a class="is-small journal-post-card_post-action" href="" ng-click="vm.openJournalDataPreview(vm, journalPost)">\n\t\t\t\t\t\t\t<i class="icon-visible is-medium has-margin-right"></i>Preview data\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a class="is-small journal-post-card_post-action" href="" ng-click="vm.openPostToAccountingIntegrationForm(journalPost)">\n\t\t\t\t\t\t\t<i class="icon-tick is-medium has-margin-right"></i>Post to {{vm.accountingIntegrationName}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- View -->\n\t\t\t\t\t<div class="journal-post-card_post-actions" ng-if="!journalPost.canUpdatePost">\n\t\t\t\t\t\t<a class="is-small journal-post-card_post-action" href="" ng-click="vm.openJournalDataPreview(vm, journalPost)">\n\t\t\t\t\t\t\t<i class="icon-visible is-medium has-margin-right"></i>View data\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="journal-post-card_footer">\n\t\t\t\t<span class="journal-post-card_footer-label" ng-if="journalPostGroup.posts.length === 0">No post history</span>\n\n\t\t\t\t<div ng-if="journalPostGroup.posts.length > 0">\n\t\t\t\t\t<a href="" ng-click="vm.toggleIsPostsVisible(journalPostGroup)">\n\t\t\t\t\t\t<i class="is-middle-aligned {{journalPostGroup.isPostsVisible ? \'icon-chevron-up\': \'icon-chevron-down\'}}"></i>\n\t\t\t\t\t\t<span class="is-small" ng-show="!journalPostGroup.isPostsVisible">\n\t\t\t\t\t\t\t<ng-pluralize count="journalPostGroup.posts.length" when="{1: \'{} post\', other: \'{} posts\'}"></ng-pluralize>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class="is-small" ng-show="journalPostGroup.isPostsVisible">\n\t\t\t\t\t\t\tHide posts\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\n\t</div>\n\n\t<!-- No post history -->\n\t<div class="page-template-a-main" ng-if="vm.journalPostGroups.length === 0">\n\t\t<placeholder placeholder-graphic="no-pay-periods">\n\t\t\t<placeholder-title>No pay runs available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Once your pay runs appear here you\u2019ll be able to post Journals to your accounting software.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/journals/business-categories/settings-journals-business-categories.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div ng-if="pageState === \'ready\'">\n\n\t<main class="page-template-a-main" ng-if="vm.businessCategories.length">\n\t\t<div class="page-template-a-action-bar-alt">\n\t\t\t<div class="page-template-a-action-bar-title">\n\t\t\t\t<p class="m">\n\t\t\t\t\t<ng-pluralize count="vm.businessCategories.length" when="{\'1\': \'1 category\', \'other\': \'{} categories\'}"></ng-pluralize>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<div class="page-template-a-action-bar-actions">\n\n\t\t\t\t<!-- Overrides disabled -->\n\t\t\t\t<a class="button is-clear" href="" ng-click="vm.openSubCodeOverridesForm(vm.businessCategories)" ng-if="!vm.businessCategoryOverride">\n\t\t\t\t\t<i class="icon-csv is-smedium has-margin-right"></i>Allow sub-code overrides\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Overrides enabled -->\n\t\t\t\t<p class="is-small" ng-if="vm.businessCategoryOverride">\n\t\t\t\t\t<i class="icon-csv is-primary is-smedium has-margin-right"></i>\n\t\t\t\t\t<span class="is-strong">Sub code overrides:</span>\n\t\t\t\t\t<span>{{vm.businessCategoryOverride.BusinessCategoryName}}</span>\n\t\t\t\t\t<a href="" ng-click="vm.openSubCodeOverridesForm(vm.businessCategories)">edit</a>\n\t\t\t\t</p>\n\n\t\t\t</div>\n\t\t</div>\n\t\t<business-category business-category="businessCategory" index="$index" ng-repeat="businessCategory in vm.businessCategories | orderBy: \'BusinessCategoryNumber\'" on-update="vm.onUpdateBusinessCategory"></business-category>\n\t</main>\n\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/pay-elements/additions/settings-pay-elements-additions.view.html','<main class="page-template-a-main">\n\n\t<!-- Search -->\n\t<search-bar options="payElementsAdditionsSearchBarOptions"></search-bar>\n\n\t<!-- Pay elements -->\n\t<div class="pay-element-categories">\n\t\t<div class="pay-element-category {{adjustmentGroupCategory.theme}}" ng-repeat="adjustmentGroupCategory in filteredAdjustmentGroupCategories = ( adjustmentGroup.GroupEntries | filter : additionsFilter | orderBy : [\'order\', \'Category\'] )">\n\t\t\t<a href="" class="pay-element-category-name" ng-click="toggleCategory(adjustmentGroupCategory)" ng-if="!isDeductions">{{adjustmentGroupCategory.CategoryName}} ({{filteredGroupEntries.length}})<i class="icon-chevron-{{adjustmentGroupCategory.isOpen ? \'up\' : \'down\'}}"></i></a>\n\t\t\t<div class="pay-element-category-group" ng-show="adjustmentGroupCategory.isOpen">\n\t\t\t\t<div class="pay-element-type-cards">\n\t\t\t\t\t<pay-element-type-card agency-profile-id="agencyProfileId" class="fadeIn" pay-element-type="groupEntry" has-actions="true" on-view-details="openPayElementModal" on-update="refreshPayElements" dir-paginate="groupEntry in filteredGroupEntries = ( adjustmentGroupCategory.GroupEntries | filter : payElementsAdditionsSearchBarOptions.search.string ) | orderBy : \'AgencyAdjustmentGroupEntryText\' : payElementsAdditionsSearchBarOptions.results.reverse | itemsPerPage : 200" ng-show="adjustmentGroupCategory.isOpen"></pay-element-type-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="pay-element-category-no-results fadeIn" ng-show="adjustmentGroupCategory.isOpen && !filteredGroupEntries.length">No {{adjustmentGroupCategory.CategoryName}} elements found</p>\n\t\t</div>\n\t</div>\n\n\t<!-- No search results -->\n\t<empty-search search-bar-options="payElementsAdditionsSearchBarOptions" ng-show="filteredAdjustmentGroupCategories.length === 0"></empty-search>\n\n\t<section class="page-template-a-section">\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t</section>\n</main>\n');
$templateCache.put('features/app/settings/pay-elements/bik/settings-pay-elements-bik.view.html','<main class="page-template-a-main">\n\t<!-- Pay elements -->\n\t<div ng-if="bikCategory">\n\n\t\t<!-- Search -->\t\n\t\t<search-bar options="payElementsBIKSearchBarOptions"></search-bar>\n\n\t\t<!-- Pay elements cards -->\n\t\t<div class="pay-element-categories">\n\t\t\t<div class="pay-element-category {{adjustmentGroupCategory.theme}}" ng-repeat="adjustmentGroupCategory in filteredAdjustmentGroupCategories = ( adjustmentGroup.GroupEntries | filter : schedulesFilter | orderBy : \'Category\' )">\n\t\t\t\t<div class="pay-element-category-group" ng-show="adjustmentGroupCategory.isOpen">\n\t\t\t\t\t<div class="pay-element-type-cards">\n\t\t\t\t\t\t<pay-element-type-card agency-profile-id="agencyProfileId" class="fadeIn" pay-element-type="groupEntry" has-actions="true" on-view-details="openPayElementModal" on-update="refreshPayElements" dir-paginate="groupEntry in filteredGroupEntries = ( adjustmentGroupCategory.GroupEntries | filter : payElementsBIKSearchBarOptions.search.string ) | orderBy : \'AgencyAdjustmentGroupEntryText\' : payElementsBIKSearchBarOptions.results.reverse | itemsPerPage : payElementsBIKSearchBarOptions.results.itemsPerPage" ng-show="adjustmentGroupCategory.isOpen">\n\t\t\t\t\t\t</pay-element-type-card>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="payElementsBIKSearchBarOptions" ng-show="adjustmentGroupCategory.isOpen && !filteredGroupEntries.length"></empty-search>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Pagination -->\n\t\t<section class="page-template-a-section">\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</section>\n\n\t</div>\n\t\n\t<!-- No pay elements -->\n\t<placeholder placeholder-graphic="no-pay-elements" ng-if="!bikCategory">\n\t\t<placeholder-title>No Benefit in Kind pay elements have been assigned to this company.</placeholder-title>\n\t</placeholder>\n</main>');
$templateCache.put('features/app/settings/pay-elements/cis/settings-pay-elements-cis.view.html','<main class="page-template-a-main">\n\n\t<!-- Search -->\n\t<search-bar options="payElementsCisSearchBarOptions"></search-bar>\n\n\t<!-- Pay elements -->\n\t<div class="pay-element-categories">\n\t\t<div class="pay-element-category primary" ng-repeat="adjustmentGroupCategory in adjustmentGroup.GroupEntriesCIS">\n\t\t\t<div class="pay-element-category-group">\n\t\t\t\t<div class="pay-element-type-cards">\n\t\t\t\t\t<pay-element-type-card agency-profile-id="agencyProfileId" class="fadeIn" pay-element-type="groupEntry" has-actions="true" on-view-details="openPayElementModal" on-update="refreshPayElements" ng-repeat="groupEntry in filteredGroupEntries = (adjustmentGroupCategory.GroupEntries | filter: payElementsCisSearchBarOptions.search.string)"></pay-element-type-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="pay-element-category-no-results fadeIn" ng-show="adjustmentGroupCategory.isOpen && !filteredGroupEntries.length">No {{adjustmentGroupCategory.Category}} elements found</p>\n\t\t</div>\n\t</div>\n\n\t<!-- No search results -->\n\t<empty-search search-bar-options="payElementsCisSearchBarOptions" ng-show="filteredGroupEntries.length === 0"></empty-search>\n\n\t<section class="page-template-a-section">\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t</section>\n</main>\n');
$templateCache.put('features/app/settings/pay-elements/core/settings-pay-elements-core.view.html','<main class="page-template-a-main">\n\n\t<!-- Search -->\n\t<search-bar options="payElementsCoreSearchBarOptions"></search-bar>\n\n\t<!-- Pay elements -->\n\t<div class="pay-element-categories">\n\t\t<div class="pay-element-category {{adjustmentGroupCategory.theme}}" ng-repeat="adjustmentGroupCategory in filteredAdjustmentGroupCategories = ( adjustmentGroup.GroupEntries | filter : corePayElementsFilter | orderBy : [\'order\', \'Category\'] )">\n\t\t\t<a href="" class="pay-element-category-name" ng-click="toggleCategory(adjustmentGroupCategory)" ng-if="!isDeductions">{{adjustmentGroupCategory.CategoryName}} ({{filteredGroupEntries.length}})<i class="icon-chevron-{{adjustmentGroupCategory.isOpen ? \'up\' : \'down\'}}"></i></a>\n\t\t\t<div class="pay-element-category-group" ng-show="adjustmentGroupCategory.isOpen">\n\t\t\t\t<div class="pay-element-type-cards">\n\t\t\t\t\t<pay-element-type-card agency-profile-id="agencyProfileId" class="fadeIn" pay-element-type="groupEntry" has-actions="true" on-view-details="openPayElementModal" on-update="refreshPayElements" dir-paginate="groupEntry in filteredGroupEntries = ( adjustmentGroupCategory.GroupEntries | filter : payElementsCoreSearchBarOptions.search.string) | orderBy : \'AgencyAdjustmentGroupEntryText\' : payElementsCoreSearchBarOptions.results.reverse | itemsPerPage : 200" ng-show="adjustmentGroupCategory.isOpen"></pay-element-type-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="pay-element-category-no-results fadeIn" ng-show="adjustmentGroupCategory.isOpen && !filteredGroupEntries.length">No {{adjustmentGroupCategory.CategoryName}} elements found</p>\n\t\t</div>\n\t</div>\n\n\t<!-- No search results -->\n\t<empty-search search-bar-options="payElementsCoreSearchBarOptions" ng-show="filteredAdjustmentGroupCategories.length === 0"></empty-search>\n\n\t<section class="page-template-a-section">\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t</section>\n</main>\n');
$templateCache.put('features/app/settings/pay-elements/deductions/settings-pay-elements-deductions.view.html','<main class="page-template-a-main">\n\n\t<!-- Search -->\n\t<search-bar options="payElementsDeductionsSearchBarOptions"></search-bar>\n\n\t<!-- Pay elements -->\n\t<div class="pay-element-categories">\n\t\t<div class="pay-element-category {{adjustmentGroupCategory.theme}}" ng-repeat="adjustmentGroupCategory in filteredAdjustmentGroupCategories = ( adjustmentGroup.GroupEntries | filter : deductionsFilter | orderBy : [\'order\', \'Category\'] )">\n\t\t\t<a href="" class="pay-element-category-name" ng-click="toggleCategory(adjustmentGroupCategory)">{{adjustmentGroupCategory.CategoryName}} ({{filteredGroupEntries.length}})<i class="icon-chevron-{{adjustmentGroupCategory.isOpen ? \'up\' : \'down\'}}"></i></a>\n\t\t\t<div class="pay-element-category-group" ng-show="adjustmentGroupCategory.isOpen">\n\t\t\t\t<div class="pay-element-type-cards">\n\t\t\t\t\t<pay-element-type-card agency-profile-id="agencyProfileId" class="fadeIn" pay-element-type="groupEntry" has-actions="true" on-view-details="openPayElementModal" on-update="refreshPayElements" dir-paginate="groupEntry in filteredGroupEntries = ( adjustmentGroupCategory.GroupEntries | filter : payElementsDeductionsSearchBarOptions.search.string | orderBy : \'AgencyAdjustmentGroupEntryText\' : payElementsDeductionsSearchBarOptions.results.reverse | itemsPerPage : 200 )"></pay-element-type-card>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<p class="pay-element-category-no-results fadeIn" ng-show="adjustmentGroupCategory.isOpen && !filteredGroupEntries.length">No {{adjustmentGroupCategory.CategoryName}} elements found</p>\n\t\t</div>\n\t</div>\n\n\t<!-- No search results -->\n\t<empty-search search-bar-options="payElementsDeductionsSearchBarOptions" ng-show="filteredAdjustmentGroupCategories.length === 0"></empty-search>\n\n\t<section class="page-template-a-section">\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t</section>\n</main>\n');
$templateCache.put('features/app/settings/pay-elements/disbursements/settings-pay-elements-disbursements.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main">\n\t<div ng-if="pageState === \'ready\'">\n\t\t<div class="page-template-a-wrapper" ng-if="disbursements.all.length">\n\t\t\t<section class="page-template-a-main-action">\n\t\t\t\t<a href="" class="button primary" ng-click="openAddDisbursementForm(company)"><i class="icon-plus"></i>&nbsp;Add disbursement</a>\n\t\t\t</section>\n\t\t\t<search-bar options="searchBarOptions" bulk-items="disbursements"></search-bar>\n\t\t\t<div class="disbursement-card_wrapper">\n\t\t\t\t<disbursement-card company="company" current-page="searchBarOptions.currentPageNumber" dir-paginate="disbursement in disbursements.filtered =\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\tdisbursements.all |\n\t\t\t\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t\t\t\t)" disbursement="disbursement" refresh-disbursements="refreshDisbursements()"></disbursement-card>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No disbursements -->\n\t\t<placeholder placeholder-graphic="no-disbursements" ng-if="!disbursements.all.length">\n\t\t\t<placeholder-title>Start adding disbursements</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Add bank details and manage BACS file settings for calculated and deduction pay elements.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ng-click="openAddDisbursementForm(company)" class="button primary"><i class="icon-plus"></i>&nbsp;Add disbursement</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n\t<!-- BACS file creation disabled -->\n\t<placeholder placeholder-graphic="no-disbursements" ng-if="pageState === \'bacs-file-creation-disabled\'">\n\t\t<placeholder-title>Enable BACS file creation</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Before you can begin adding disbursements, you first need to turn on BACS file creation in the payroll settings in your company settings area.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-secondary-actions>\n\t\t\t<a ui-sref="settings.company.overview({agencyProfileId: agencyProfileId})">Go to company settings&nbsp;<i class="icon-chevron-right"></i></a>\n\t\t</placeholder-secondary-actions>\n\t</placeholder>\n</main>\n');
$templateCache.put('features/app/settings/pay-elements/element-packs/settings-pay-elements-element-packs.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main" ng-if="pageState === \'ready\'">\n\n\t<div class="side-bar-menu_wrapper" ng-if="adjustmentGroups.length">\n\t\t<div class="side-bar-menu_menu">\n\t\t\t<header class="side-bar-menu_menu-header">\n\t\t\t\t<ng-pluralize count="adjustmentGroups.length" when="{\'1\': \'1 element pack\', \'other\': \'{} element packs\'}"></ng-pluralize>\n\t\t\t\t<a class="link-with-icon side-bar-menu_menu-header-action" href="" ng-click="openAddAdjustmentGroupForm(adjustmentGroups[0])" ng-if="$root.currentUser.Permissions.Admin.canManagePayElementPacks">\n\t\t\t\t\t<i class="icon-add"></i>New\n\t\t\t\t</a>\n\t\t\t</header>\n\n\t\t\t<div class="side-bar-item_wrapper">\n\n\t\t\t\t<side-bar-item heading="adjustmentGroup.AgencyAdjustmentGroupName" is-active="adjustmentGroup.AgencyAdjustmentGroupID === activeAdjustmentGroup.AgencyAdjustmentGroupID" ng-repeat="adjustmentGroup in adjustmentGroups" on-click="selectAdjustmentGroupById(adjustmentGroup.AgencyAdjustmentGroupID)" theme="is-primary">\n\t\t\t\t\t<side-bar-item-description>\n\n\t\t\t\t\t\t<ng-pluralize count="adjustmentGroup.NumberOfElementsVisible" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 element\',\n\t\t\t\t\t\t\t\t\'other\': \'{} elements\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\n\t\t\t\t\t</side-bar-item-description>\n\t\t\t\t</side-bar-item>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<loading-block ng-if="adjustmentGroupState === \'loading\'"></loading-block>\n\n\t\t<div class="side-bar-menu_main fadeIn" ng-if="activeAdjustmentGroup && adjustmentGroupState === \'ready\'">\n\t\t\t<header class="side-bar-menu_main-header">\n\t\t\t\t<h3 class="side-bar-menu_heading">{{activeAdjustmentGroup.AgencyAdjustmentGroupName}}&nbsp;<span class="tag indifferent-lighter" ng-if="activeAdjustmentGroup.AgencyAdjustmentGroupDefault">Default</span></h3>\n\t\t\t\t<p class="side-bar-menu_subheading">{{activeAdjustmentGroup.AgencyAdjustmentGroupDescription}}</p>\n\n\t\t\t\t<dropdown-menu class="side-bar-menu_main-actions" menu-size="l" menu-icon="icon-setup" ng-if="$root.currentUser.Permissions.Admin.canManagePayElementPacks">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="openUpdateAdjustmentGroupForm(activeAdjustmentGroup)">Edit settings</a>\n\t\t\t\t\t\t<a href="" ng-click="openDuplicateAdjustmentGroupForm(activeAdjustmentGroup)">Duplicate pack</a>\n\t\t\t\t\t\t<a href="" ng-if="!activeAdjustmentGroup.AgencyAdjustmentGroupDefault" ng-click="openSetDefaultAdjustmentGroupForm(activeAdjustmentGroup)">Set as default pack</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="openDeleteAdjustmentGroupForm(activeAdjustmentGroup)" class="assertive">Delete</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\n\t\t\t\t<!-- Summary / Actions -->\n\t\t\t\t<search-bar count="activeAdjustmentGroup.totalElementsVisible" options="searchBarOptions">\n\t\t\t\t\t<sb-right-actions>\n\t\t\t\t\t\t<div class="spaced-links" ng-if="$root.currentUser.Permissions.Admin.canManagePayElementPacks">\n\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t<a href="" ng-click="selectAllPayElements(activeAdjustmentGroup)">\n\t\t\t\t\t\t\t\t\tSelect all\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="spaced-links__item spaced-links__item--no-spacer">\n\t\t\t\t\t\t\t\t<a href="" ng-click="deselectAllPayElements(activeAdjustmentGroup)">\n\t\t\t\t\t\t\t\t\tClear all\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</sb-right-actions>\n\t\t\t\t</search-bar>\n\n\t\t\t</header>\n\n\t\t\t<!-- Pay elements -->\n\t\t\t<div class="feature-toggle-cards">\n\t\t\t\t<div class="feature-toggle-card-group {{adjustmentGroupCategory.theme}} {{adjustmentGroupCategory.AdjustmentGroupCategoryIsOpen ? \'is-open\' : \'is-closed\'}}" ng-repeat="adjustmentGroupCategory in activeAdjustmentGroup.GroupEntries | orderBy: [\'order\', \'Category\']">\n\t\t\t\t\t<div class="feature-toggle-card-group-detail">\n\t\t\t\t\t\t<header class="feature-toggle-card-group-detail-header">\n\t\t\t\t\t\t\t<a href="" class="feature-toggle-card-group-detail-header-description" ng-click="toggleAdjustmentGroupCategory(adjustmentGroupCategory)"><i class="icon-chevron-{{adjustmentGroupCategory.AdjustmentGroupCategoryIsOpen ? \'up\' : \'down\'}}"></i>&nbsp;{{adjustmentGroupCategory.CategoryName}} <span class="feature-toggle-card-group-detail-header-description-label">({{adjustmentGroupCategory.numberOfElementsVisible}} of {{adjustmentGroupCategory.GroupEntries.length}})</span></a>\n\t\t\t\t\t\t\t<div class="feature-toggle-card-group-detail-toggle fadeIn" ng-if="$root.currentUser.Permissions.Admin.canManagePayElementPacks && adjustmentGroupCategory.AdjustmentGroupCategoryIsOpen">\n\t\t\t\t\t\t\t\t<a href="" ng-click="toggleAdjustmentCategoryActions(adjustmentGroupCategory, true, activeAdjustmentGroup)" class="feature-toggle-card-group-detail-toggle-item is-greyscale">Select all</a>\n\t\t\t\t\t\t\t\t<a href="" ng-click="toggleAdjustmentCategoryActions(adjustmentGroupCategory, false, activeAdjustmentGroup)" class="feature-toggle-card-group-detail-toggle-item is-greyscale">Clear all</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="feature-toggle-card-items cards fadeIn" ng-show="adjustmentGroupCategory.AdjustmentGroupCategoryIsOpen">\n\t\t\t\t\t\t<button class="is-clear feature-toggle-card-item {{adjustmentType.IsDeduction ? \'assertive\' : \'positive\'}} {{adjustmentType.AgencyAdjustmentGroupEntryVisible ? \'is-active\' : \'not-active\'}}" ng-class="{ \'is-disabled\' : !$root.currentUser.Permissions.Admin.canManagePayElementPacks }" ng-click="$root.currentUser.Permissions.Admin.canManagePayElementPacks && toggleAdjustmentIsVisible(adjustmentType, adjustmentGroupCategory, activeAdjustmentGroup)" ng-repeat="adjustmentType in adjustmentGroupCategory.GroupEntries | orderBy : \'AgencyAdjustmentGroupEntryText\'" title="{{adjustmentType.AgencyAdjustmentGroupEntryText}}" type="button">\n\t\t\t\t\t\t\t{{adjustmentType.AgencyAdjustmentGroupEntryText}} <span ng-if="adjustmentType.hasChanged" class="marker s primary feature-toggle-card-item-marker" title="Changed"></span>\n\t\t\t\t\t\t\t<span class="feature-toggle-card-item-icon"><i class="icon-{{adjustmentType.AgencyAdjustmentGroupEntryVisible ? \'check\' : \'menu-close\'}}"></i></span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div ng-if="!adjustmentGroups.length">\n\n\t\t<placeholder placeholder-graphic="no-pay-element-packs">\n\t\t\t<placeholder-title>You don\'t have any pay element packs to show yet</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As pay element packs are added, they will appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n</main>\n\n<full-page-controls theme="{{savingState === \'saved\' ? \'is-primary\' : \'\'}}" ng-if="activeAdjustmentGroup.totalChangedAdjustmentTypes > 0">\n\n\t<fpc-secondary ng-if="savingState !== \'saved\'">\n\t\t<span class="tag primary inverse align-with-text">\n\t\t\t{{activeAdjustmentGroup.totalChangedAdjustmentTypes}}\n\t\t</span> &nbsp;\n\t\t<span class="is-white is-small">\n\t\t\t<ng-pluralize count="activeAdjustmentGroup.totalChangedAdjustmentTypes" when="{\n\t\t\t\t\t\'1\': \'pay element changed\',\n\t\t\t\t\t\'other\': \'pay elements changed\'\n\t\t\t\t}"></ng-pluralize>\n\t\t</span>\n\t</fpc-secondary>\n\n\t<fpc-tertiary ng-if="savingState !== \'saved\'">\n\t\t<button class="tertiary" ng-class="{\n\t\t\t\t\'success\': savingState === \'saved\'\n\t\t\t}" ng-click="updatePayElementsVisibility(activeAdjustmentGroup)" ng-disabled="activeAdjustmentGroup.state === \'saving\'" ng-if="$root.currentUser.Permissions.Admin.canManagePayElementPacks" type="button">\n\t\t\t<i class="icon-loading {{savingState === \'saving\' ? \'spin\' : \'\'}}"></i>&nbsp;Update element pack\n\t\t</button>\n\t</fpc-tertiary>\n\n\t<fpc-tertiary ng-if="savingState === \'saved\'">\n\t\t<icon-dot class="is-inline-block" icon="icon-check" theme="is-primary is-white"></icon-dot>\n\n\t\t<span class="is-white is-small">\n\t\t\t&nbsp;&nbsp;Pack updated!\n\t\t</span>\n\t</fpc-tertiary>\n\n\t<fpc-primary ng-if="savingState !== \'saved\'">\n\t\t<a href="" data-cy="settings-pay-elements-element-packs-button-clear-all-changes" ng-click="clearAllChanges(activeAdjustmentGroup)">\n\t\t\tClear all changes\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/pay-elements/link-elements/settings-pay-elements-link-elements.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div ng-if="linkElementDetails.LinkElements.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t<!-- Search bar -->\n\t\t<search-bar options="searchBarOptions" count="filteredLinkElements.length">\n\t\t\t<sb-right-actions>\n\t\t\t\t<a href="" class="button primary" ng-click="openLinkElementForm(linkElementDetails)" data-cy="add-link-element">+ Add link element</a>\n\t\t\t</sb-right-actions>\n\t\t</search-bar>\n\n\t\t<!-- Link elements -->\n\t\t<section>\n\n\t\t\t<div class="link-element-card_wrapper rows">\n\t\t\t\t<link-element-card agency-profile-id="agencyProfileId" dir-paginate="linkElement in filteredLinkElements = ( linkElementDetails.LinkElements | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" link-element="linkElement" link-element-group-id="linkElementDetails.LinkElementGroupID" on-update="refreshLinkElements">\n\t\t\t\t</link-element-card>\n\t\t\t</div>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-if="filteredLinkElements.length === 0">\n\t\t\t\t<a href="" class="button action fadeIn" ng-click="searchBarOptions.search.string = \'\'" ng-if="searchBarOptions.search.string !== \'\'">Clear search</a>\n\t\t\t</empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No results -->\n\t<placeholder placeholder-graphic="no-link-elements" ng-if="!linkElementDetails.LinkElements.length">\n\t\t<placeholder-title>Start adding link elements</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Link elements can be used to add recurring link rates for team members. Global rates can be set and managed in a single place. </p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="openLinkElementForm(linkElementDetails)" class="button primary" data-cy="add-link-element">+ Add link element</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/pay-elements/payslip-labels/settings-pay-elements-payslip-labels.view.html','<main class="page-template-a-main">\n\n\t<div ng-if="adjustmentLabels.length">\n\n\t\t<section class="page-template-a-main-action">\n\t\t\t<a href="" class="button primary" ng-click="openNewPayslipLabelForm()"><i class="icon-plus"></i>&nbsp;New payslip label</a>\n\t\t</section>\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="payslipLabelsFilterBarOptions"></filter-bar>\n\n\t\t<!-- Search -->\n\t\t<search-bar options="payslipLabelsSearchBarOptions" count="filteredAdjustmentLabels.length"></search-bar>\n\n\t\t<!-- Adjustment labels -->\n\t\t<div class="payslip-label-card_wrapper">\n\t\t\t<div class="payslip-label-card" dir-paginate="adjustmentLabel in filteredAdjustmentLabels =\n\t\t\t\t\t(\n\t\t\t\t\t\tadjustmentLabels |\n\t\t\t\t\t\tfilter : payslipLabelsSearchBarOptions.search.string |\n\t\t\t\t\t\tfilter : payslipLabelsFilterBarOptions.appliedFilter\n\t\t\t\t\t) |\n\t\t\t\t\torderBy : payslipLabelsSearchBarOptions.orderBy : payslipLabelsSearchBarOptions.results.reverse |\n\t\t\t\t\titemsPerPage : payslipLabelsSearchBarOptions.results.itemsPerPage\n\t\t\t\t" ng-class="{\n\t\t\t\t\t\'positive\': adjustmentLabel.Addition,\n\t\t\t\t\t\'assertive\': !adjustmentLabel.Addition\n\t\t\t\t}">\n\t\t\t\t<p class="payslip-label-card_label">\n\t\t\t\t\t<i class="icon-label payslip-label-card_label-icon"></i>\n\t\t\t\t\t{{adjustmentLabel.AgencyAdjustmentLabelText}}\n\t\t\t\t</p>\n\t\t\t\t<p class="payslip-label-card_original">\n\t\t\t\t\t<i class="payslip-label-card_original-icon" ng-class="{\n\t\t\t\t\t\t\t\'icon-add\': adjustmentLabel.Addition,\n\t\t\t\t\t\t\t\'icon-minus\': !adjustmentLabel.Addition\n\t\t\t\t\t\t}"></i>\n\t\t\t\t\t{{adjustmentLabel.AdjustmentText !== \'\' ? adjustmentLabel.AdjustmentText : \'Unknown adjustment\'}}\n\t\t\t\t</p>\n\t\t\t\t<p class="payslip-label-card_created-on">\n\t\t\t\t\tCreated on {{adjustmentLabel.CreatedDateISO | dateformat}}\n\t\t\t\t</p>\n\n\t\t\t\t<a href="" ng-click="openDeletePayslipLabelForm(adjustmentLabel)" class="payslip-label-card_delete">\n\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="payslipLabelsSearchBarOptions" ng-show="filteredAdjustmentLabels.length === 0"></empty-search>\n\n\t\t<section class="page-template-a-section">\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</section>\n\t</div>\n\n\t<!-- No adjustment labels -->\n\t<placeholder placeholder-graphic="no-payslip-labels" ng-if="!adjustmentLabels.length">\n\t\t<placeholder-title>You don\'t have any payslip labels yet</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As you add payslip labels they will appear here and become available when adding changes in Current payroll.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="openNewPayslipLabelForm()" class="button primary">Add payslip label</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</main>\n\n');
$templateCache.put('features/app/settings/reports/packs/settings-reports-packs.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main" ng-if="pageState === \'ready\'">\n\n\t<div class="side-bar-menu_wrapper" ng-if="vm.reportTemplateGroups.length">\n\t\t<div class="side-bar-menu_menu">\n\n\t\t\t<header class="side-bar-menu_menu-header">\n\t\t\t\t<ng-pluralize count="vm.reportTemplateGroups.length" when="{\'1\': \'1 pack\', \'other\': \'{} packs\'}"></ng-pluralize>\n\t\t\t\t<a class="link-with-icon side-bar-menu_menu-header-action" href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.new)">\n\t\t\t\t\t<i class="icon-add"></i>New\n\t\t\t\t</a>\n\t\t\t</header>\n\n\t\t\t<div class="side-bar-item_wrapper">\n\n\t\t\t\t<side-bar-item heading="reportGroup.ReportTemplateGroupName" is-active="reportGroup.ReportTemplateGroupID === vm.activeReportGroup.ReportTemplateGroupID" ng-repeat="reportGroup in vm.reportTemplateGroups | orderBy:\'!ReportTemplateGroupDefault\'" on-click="selectReportGroupById(vm, reportGroup.ReportTemplateGroupID)" theme="is-primary">\n\t\t\t\t\t<side-bar-item-description>\n\n\t\t\t\t\t\t<ng-pluralize count="reportGroup.NumberOfVisibleReports" when="{\n\t\t\t\t\t\t\t\t\'1\': \'1 template\',\n\t\t\t\t\t\t\t\t\'other\': \'{} templates\'\n\t\t\t\t\t\t\t}"></ng-pluralize>\n\n\t\t\t\t\t</side-bar-item-description>\n\t\t\t\t</side-bar-item>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<loading-block ng-if="reportGroupState === \'loading\'"></loading-block>\n\n\t\t<div class="side-bar-menu_main fadeIn" ng-if="vm.activeReportGroup && reportGroupState === \'ready\'">\n\t\t\t<header class="side-bar-menu_main-header">\n\t\t\t\t<h3 class="side-bar-menu_main-heading">\n\t\t\t\t\t{{vm.activeReportGroup.ReportTemplateGroupName}}&nbsp;\n\t\t\t\t\t<span class="tag indifferent-lighter" ng-if="vm.activeReportGroup.ReportTemplateGroupDefault">Default</span>\n\t\t\t\t</h3>\n\n\t\t\t\t<p class="side-bar-menu_main-subheading s">{{vm.activeReportGroup.ReportTemplateGroupDescription}}</p>\n\n\t\t\t\t<dropdown-menu class="side-bar-menu_main-actions" menu-size="l" menu-icon="icon-setup">\n\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t<a href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.update, vm.activeReportGroup)">\n\t\t\t\t\t\t\tEdit settings\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsCompanies, vm.activeReportGroup)">\n\t\t\t\t\t\t\tView companies\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.viewInheritorsGroups, vm.activeReportGroup)">\n\t\t\t\t\t\t\tView company groups\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.duplicate, vm.activeReportGroup)">\n\t\t\t\t\t\t\tDuplicate pack\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="dropdown-group" ng-if="!vm.activeReportGroup.ReportTemplateGroupDefault">\n\t\t\t\t\t\t<a class="assertive" href="" ng-click="openReportTemplateGroupForm(REPORT_TEMPLATE_GROUP_FORM_VIEWS.delete, vm.activeReportGroup)">\n\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</dropdown-menu>\n\t\t\t</header>\n\n\t\t\t<!-- Pay elements -->\n\t\t\t<div class="feature-toggle-cards">\n\t\t\t\t<div class="feature-toggle-card-group primary is-open">\n\t\t\t\t\t<div class="feature-toggle-card-group-detail">\n\t\t\t\t\t\t<header class="feature-toggle-card-group-detail-header">\n\t\t\t\t\t\t\t<search-bar options="searchBarOptions" count="vm.activeReportGroup.ReportTemplates.length">\n\t\t\t\t\t\t\t\t<sb-actions>\n\t\t\t\t\t\t\t\t\t<div class="spaced-links">\n\t\t\t\t\t\t\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="toggleReportTemplates(vm, true)">Select all</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="spaced-links__item spaced-links__item--no-spacer">\n\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="toggleReportTemplates(vm, false)">Clear all</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</sb-actions>\n\t\t\t\t\t\t\t</search-bar>\n\t\t\t\t\t\t</header>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="feature-toggle-card-items cards">\n\t\t\t\t\t\t<a href="" class="feature-toggle-card-item" ng-class="[reportTemplate.theme, {\'is-active\' : reportTemplate.isActiveInGroup, \'not-active\': !reportTemplate.isActiveInGroup}]" ng-click="toggleReportActiveState(vm, reportTemplate)" ng-repeat="reportTemplate in vm.activeReportGroup.ReportTemplates | filter : searchBarOptions.search.string | orderBy:\'ReportTemplateName\'" title="{{reportTemplate.ReportTemplateName}}">\n\t\t\t\t\t\t\t{{reportTemplate.ReportTemplateName}}\n\t\t\t\t\t\t\t<span class="feature-toggle-card-item-icon"><i ng-class="{\'icon-check\' : reportTemplate.isActiveInGroup, \'icon-menu-close\': !reportTemplate.isActiveInGroup }"></i></span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div ng-if="!vm.reportTemplateGroups.length">\n\n\t\t<placeholder placeholder-graphic="no-report-packs">\n\t\t\t<placeholder-title>You don\'t have any report packs to show yet</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As report packs are added, they will appear here.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n</main>\n\n<full-page-controls theme="{{savingState === \'saved\' ? \'is-primary\' : \'\'}}" ng-if="vm.numberOfChangedReportTemplates > 0">\n\n\t<fpc-secondary ng-if="savingState !== \'saved\'">\n\t\t<span class="tag primary inverse align-with-text">\n\t\t\t{{vm.numberOfChangedReportTemplates}}\n\t\t</span>&nbsp;\n\t\t<span class="is-white is-small">\n\t\t\t<ng-pluralize count="vm.numberOfChangedReportTemplates" when="{\n\t\t\t\t\t\'1\': \'report template changed\',\n\t\t\t\t\t\'other\': \'report templates changed\'\n\t\t\t\t}"></ng-pluralize>\n\t\t</span>\n\t</fpc-secondary>\n\n\t<fpc-tertiary ng-if="savingState !== \'saved\'">\n\t\t<button class="tertiary" ng-class="{\n\t\t\t\t\'success\': savingState === \'saved\'\n\t\t\t}" ng-click="updateReportTemplatePack(vm)" ng-disabled="vm.activeReportGroup.state === \'saving\'" type="button">\n\t\t\t<i class="icon-loading {{savingState === \'saving\' ? \'spin\' : \'\'}}"></i>&nbsp;Update report pack\n\t\t</button>\n\t</fpc-tertiary>\n\n\t<fpc-tertiary ng-if="savingState === \'saved\'">\n\t\t<icon-dot class="is-inline-block" icon="icon-check" theme="is-primary is-white"></icon-dot>\n\n\t\t<span class="is-white is-small">\n\t\t\t&nbsp;&nbsp;Pack updated!\n\t\t</span>\n\t</fpc-tertiary>\n\n\t<fpc-primary ng-if="savingState !== \'saved\'">\n\t\t<a href="" ng-click="clearAllChanges(vm)">\n\t\t\tClear all changes\n\t\t</a>\n\t</fpc-primary>\n\n</full-page-controls>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/settings/reports/templates/settings-reports-templates.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<main class="sub-page-template-a-main" ng-if="vm.reportTemplates.length > 0">\n\n\t\t<search-bar action-selected="searchBarActionSelected" count="vm.reportTemplates.length" options="vm.searchBarOptions" show-actions="REPORT_FILTER === REPORT_FILTERS.custom"></search-bar>\n\n\t\t<div class="report-template-card_wrapper cards">\n\t\t\t<report-template-card agency-profile-id="AGENCY_PROFILE_ID" ng-repeat="reportTemplate in vm.templatesFiltered = (vm.reportTemplates | filter : vm.searchBarOptions.search.string | orderBy: [\'+CanEditAndDeleteTemplate\', \'ReportTemplateName\'])" refresh-templates="init" report-template="reportTemplate"></report-template-card>\n\t\t</div>\n\n\t</main>\n\n\t<!-- No Reports -->\n\t<div class="sub-page-template-a-section" ng-if="vm.reportTemplates.length === 0">\n\t\t<placeholder placeholder-graphic="generic-files" ng-if="REPORT_FILTER === REPORT_FILTERS.custom">\n\t\t\t<placeholder-title>No templates added</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>No report templates are available as they haven\u2019t been assigned to or added for {{currentCompany.Name}} yet.</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a href="" ng-click="openReportTemplateForm()" class="button primary" ng-if="REPORT_FILTER === REPORT_FILTERS.custom"><i class="icon-plus"></i>&nbsp;New template</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\n\t\t<placeholder placeholder-graphic="generic-files" ng-if="REPORT_FILTER === REPORT_FILTERS.standard">\n\t\t\t<placeholder-title>No reports available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>No reports are available as they haven\u2019t been assigned to or added for {{currentCompany.Name}} yet.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n</div>\n\n<error-block ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profile-account.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\t\t\n\t<div class="detail-blocks">\n\n\t\t<!-- Login -->\n\t\t<detail-block db-details="vm.loginDetails" db-edit-text="\'Send password reset link\'" db-show-feedback="true">\n\t\t\t<db-feedback>\n\t\t\t\tThe information shown here is not editable and is shown for information only\n\t\t\t</db-feedback>\n\t\t</detail-block>\n\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n\n\n\n');
$templateCache.put('features/app/team/profile/tabs/profile-tax-status.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<current-tax-status ng-if="pageState === \'ready\'" team-member="teamMember"></current-tax-status>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\t<!-- Filter Bar -->\n\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t<!-- Search Bar -->\n\t<search-bar count="filteredTaxUpdates.length" options="searchBarOptions">\n\t\t<sb-right-actions ng-if="currentUser.Permissions.Team.canEditTaxStatus && !teamMember.isTeamMemberMovingPayrollsOutward">\n\t\t\t<div class="spaced-links is-centered-bottom">\n\t\t\t\t<div class="spaced-links__item">\n\t\t\t\t\t<button class="is-primary" ng-click="openAddTaxUpdateForm()">\n\t\t\t\t\t\t<i class="icon-add"></i>\n\t\t\t\t\t\tAdd update\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</sb-right-actions>\n\t</search-bar>\n\n\t<!-- Tax Updates -->\n\t<section class="tax-info-update-cards {{searchBarOptions.layout}}">\n\n\t\t<tax-info-update-card class="slideIn" dir-paginate="taxUpdate in filteredTaxUpdates = (\n\t\t\t\ttaxUpdates |\n\t\t\t\tfilter : filterBarOptions.appliedFilter |\n\t\t\t\tfilter : searchBarOptions.search.searchFilter |\n\t\t\t\torderBy : taxUpdate.TaxInfoDateEffective : searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t)" index="$index" refresh-tax-updates="refreshTaxUpdates()" tax-update="taxUpdate"></tax-info-update-card>\n\t</section>\n\n\t<!-- No search results -->\n\t<empty-search ng-show="filteredTaxUpdates.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\n\t<!-- Pagination -->\n\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n</div>\n\n<!-- No history -->\n<div class="fadeIn" ng-if="pageState === \'no-history\'">\n\t<placeholder placeholder-graphic="no-profile-history" placeholder-graphic-size="l">\n\t\t<placeholder-title>No tax status updates</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Once you start adding updates, or they\'re received from HMRC, they will appear here.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<button class="is-primary">\n\t\t\t\t<i class="icon-add"></i>\n\t\t\t\tAdd update\n\t\t\t</button>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'">\n</error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileDocumentsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="fadeIn" ng-if="documents.length > 0">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar count="filteredDocuments.length" options="searchBarOptions">\n\t\t\t<sb-right-actions>\n\t\t\t\t<div ng-if="!teamMember.isArchivedEmployment">\n\t\t\t\t\t<!-- Display as dropdown menu in mobile -->\n\t\t\t\t\t<dropdown-menu class="team-onboarding-card-action-menu fadeIn" menu-size="l" menu-icon="icon-setup" menu-show-chevron="false" ng-if="viewMode === VIEW_MODES.mobile">\n\t\t\t\t\t\t<div class="dropdown-group">\n\t\t\t\t\t\t\t<a href="" ng-click="openRegenerateDocumentsForm()" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation">Regenerate</a>\n\t\t\t\t\t\t\t<a href="" ng-click="openUploadDocumentsForm()">Upload</a>\n\t\t\t\t\t\t\t<a href="" ng-click="openPdfDownloadForm()" ng-if="!teamMember.IsLeaver && (!teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.Outward)">Download</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</dropdown-menu>\n\n\t\t\t\t\t<!-- Display as buttons for screens bigger than tablet -->\n\t\t\t\t\t<div ng-if="viewMode !== VIEW_MODES.mobile">\n\t\t\t\t\t\t<button class="is-white" data-cy="team-profile-documents-regenerate" ng-click="openRegenerateDocumentsForm()" ng-if="::$root.currentUser.Permissions.Team.canEditPayInformation" type="button">\n\t\t\t\t\t\t\t<i class="icon-loading n"></i> Regenerate\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="is-white" data-cy="team-profile-documents-upload" ng-click="openUploadDocumentsForm()" type="button">\n\t\t\t\t\t\t\t<i class="icon-upload n"></i> Upload\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="primary has-no-margin" data-cy="team-profile-documents-download" ng-click="openPdfDownloadForm()" ng-if="!teamMember.IsLeaver && (!teamMember.ExcludeFromPayroll && teamMember.Company.PayrollMoveStatus !== PAYROLL_MOVE_STATUSES.Outward)" type="button">\n\t\t\t\t\t\t\t<i class="icon-download n"></i> Download\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</sb-right-actions>\n\t\t</search-bar>\n\n\t\t<!-- Document Cards -->\n\t\t<section class="user-document-card_wrapper cards">\n\n\t\t\t<user-document-card agency-profile-id="agencyProfileId" dir-paginate="document in filteredDocuments = ( documents | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" document="document" document-index="$index" on-update="refreshDocuments" user-id="teamMember.Personal.UserID"></user-document-card>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search ng-show="filteredDocuments.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No Documents -->\n\t<div class="fadeIn" ng-if="!documents.length">\n\t\t<placeholder placeholder-graphic="no-search-results">\n\t\t\t<placeholder-title>There are no files available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Click &lsquo;Upload files&rsquo; to start uploading documents to appear here and in the employee portal profile</p>\n\t\t\t</placeholder-copy>\n\t\t\t<placeholder-primary-actions>\n\t\t\t\t<a class="link-with-icon primary button" href="" data-cy="profile-documents-button-upload-files" ng-click="openUploadDocumentsForm()" ng-if="!teamMember.isArchivedEmployment">\n\t\t\t\t\t<i class="icon-upload n"></i> Upload files\n\t\t\t\t</a>\n\t\t\t</placeholder-primary-actions>\n\t\t</placeholder>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileHistoryView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\t\t\n\t<!-- Filter Bar -->\n\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t<!-- Search Bar -->\n\t<search-bar count="logEntries.length" options="searchBarOptions"></search-bar>\n\n\t<!-- Log Cards -->\n\t<section class="log-cards {{searchBarOptions.layout}}">\n\n\t\t<!-- Logs -->\n\t\t<log-card class="slideIn" dir-paginate="logEntry in filteredLogs = (\n\t\t\t\tlogEntries |\n\t\t\t\tfilter : searchBarOptions.search.string |\n\t\t\t\tfilter : filterBarOptions.appliedFilter |\n\t\t\t\torderBy : log.logMeta.dateUnix : searchBarOptions.results.reverse |\n\t\t\t\titemsPerPage : searchBarOptions.results.itemsPerPage\n\t\t\t)" log="logEntry"></log-card>\n\n\t\t<!-- No search results -->\n\t\t<empty-search ng-show="filteredLogs.length === 0" search-bar-options="searchBarOptions"></empty-search>\n\t</section>\n\n\t<!-- Pagination -->\n\t<dir-pagination-controls boundary-links="true" direction-links="true" max-size="7"></dir-pagination-controls>\n\n</div>\n\n<!-- No history -->\n<div class="fadeIn" ng-if="pageState === \'no-history\'">\n\t<placeholder placeholder-graphic="no-profile-history">\n\t\t<placeholder-title>{{teamMember.Personal.Forename}} doesn\'t have any history</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>As updates are made their history will start to appear.</p>\n\t\t</placeholder-copy>\n\t</placeholder>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileHolidayView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn profile-policy" ng-if="pageState === \'ready\'">\n\t<header class="profile-policy__header">\n\t\t<div class="stat-block d">\n\t\t\t<div class="stat-block__item secondary">\n\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t\t<i class="icon-holiday stat-block__icon"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<figure class="stat-block__figure">{{userHoliday.Holidays.TotalHoliday}}</figure>\n\t\t\t\t</div>\n\t\t\t\t<span class="stat-block__label">Days total holiday</span>\n\t\t\t</div>\n\t\t\t<div class="stat-block__item stat-block__item--graph secondary">\n\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t<progress-ring class="stat-block__pie" pr-theme-complete="secondary" pr-percentage="userHoliday.daysTakenPercent" pr-size="small" pr-secondary-theme="greyscale"></progress-ring>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="stat-block__item secondary">\n\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t<figure class="stat-block__figure">{{userHoliday.daysTaken}}</figure>\n\t\t\t\t</div>\n\t\t\t\t<span class="stat-block__label">Days taken</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="spaced-links">\n\t\t\t<div class="spaced-links__item">\n\t\t\t\t<a ui-sref="hr.holiday-sickness({agencyProfileId: agencyProfileId})">\n\t\t\t\t\t<i class="icon-submission-history"></i> Go to tracker\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="spaced-links__item spaced-links__item--no-spacer">\n\t\t\t\t<a href="" ng-click="openEditHolidayPolicyForm()">\n\t\t\t\t\t<i class="icon-settings"></i> Edit policy\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="spaced-links__item" ng-if="pageState === \'ready\'">\n\t\t\t\t<a class="button primary" data-cy="holiday-add-leave" href="" ng-class="{\'disabled\': isAddHolidayLeaveDisabled}" ng-click="openAddLeaveForm()"><i class="icon-plus"></i>&nbsp;Add leave</a>\n\t\t\t</div>\n\t\t</div>\n\t</header>\n\n\t<main class="profile-policy__body">\n\t\t<section class="sub-page-template-a-section fadeIn" data-cy="holiday-integration-banner" ng-if="isEdpHolidayTopicEnabled">\n\t\t\t<notification-card theme="is-indifferent">\n\t\t\t\t<nc-description>\n\t\t\t\t\t<p><i class="icon-information m is-indifferent"></i>&nbsp;&nbsp;&nbsp;Holidays imported from a source system cannot be edited here. You can still add and manage holidays created in Paycircle.</p>\n\t\t\t\t</nc-description>\n\t\t\t</notification-card>\n\t\t</section>\n\n\t\t<!-- Has holiday -->\n\t\t<div ng-if="userHoliday.Holidays.HolidayDetails.length">\n\t\t\t<div class="profile-policy__filters">\n\t\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\t\t\t\t<search-bar options="searchBarOptions" count="filteredLeave.length"></search-bar>\n\t\t\t</div>\n\t\t\t<div class="profile-policy__leave-list {{searchBarOptions.layout}}">\n\t\t\t\t<leave-card callback="loadHoliday()" dir-paginate="leave in filteredLeave = ( userHoliday.Holidays.HolidayDetails | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" index="$index" is-integration-locked="leave.IsFromIntegration" leave="leave" leave-type="holiday" search-bar-options="searchBarOptions"></leave-card>\n\n\t\t\t\t<!-- No search results -->\n\t\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredLeave.length === 0"></empty-search>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- No holiday -->\n\t\t<div ng-if="!userHoliday.Holidays.HolidayDetails.length">\n\t\t\t<message-bar class="primary">{{teamMember.Personal.Forename}} doesn\'t have any leave scheduled.</message-bar>\n\t\t</div>\n\t</main>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileInformationView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<!-- Information -->\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div ng-if="!teamMember.IsInSetupMode">\n\n\t\t<!-- PAYE / CIS Subcontractor -->\n\t\t<div ng-if="!teamMember.isCompany">\n\n\t\t\t<!-- Leavers -->\n\t\t\t<section class="sub-page-template-a-section fadeIn" ng-if="teamMember.Company.IsLeaving || teamMember.Company.IsLeaver">\n\t\t\t\t<notification-card theme="is-quarternary">\n\t\t\t\t\t<nc-description>\n\t\t\t\t\t\t<p ng-if="teamMember.Company.IsLeaving">\n\t\t\t\t\t\t\t{{teamMember.Personal.Forename}} is leaving on\n\t\t\t\t\t\t\t<em>{{teamMember.Company.LeaveDateISO | dateformat}}</em>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p ng-if="teamMember.Company.IsLeaver">\n\t\t\t\t\t\t\t{{teamMember.Personal.Forename}} left on\n\t\t\t\t\t\t\t<em>{{teamMember.Company.LeaveDateISO | dateformat}}</em>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</nc-description>\n\t\t\t\t\t<nc-action ng-if="\n\t\t\t\t\t\t\tteamMember.Company.IsLeaving &&\n\t\t\t\t\t\t\t$root.currentUser.Permissions.Team.canManageLeavers\n\t\t\t\t\t">\n\t\t\t\t\t\t<a href="" ng-click="openUpdateLeaverStatusForm(true)">\n\t\t\t\t\t\t\tEdit leave date\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</nc-action>\n\t\t\t\t</notification-card>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<div>\n\t\t\t<!-- Personal -->\n\t\t\t<div class="detail-blocks accordion m" ng-if="vm.personal">\n\n\t\t\t\t<button class="is-clear detail-blocks-toggle clickable" data-cy="profile-information-toggle-personal" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.personal.showPersonal\n\t\t\t\t\t}" ng-click="vm.personal.showPersonal = !vm.personal.showPersonal" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tPersonal\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden detail-blocks" ng-class="{\'active\' : vm.personal.showPersonal } ">\n\n\t\t\t\t\t<!-- Personal details -->\n\t\t\t\t\t<detail-block db-details="vm.personal.personalDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t!teamMember.isArchivedEmployment &&\n\t\t\t\t\t\t\t!$root.currentCompany.IsPayslipManagerActive\n\t\t\t\t\t\t)" ng-if="vm.personal.contactDetails"></detail-block>\n\n\t\t\t\t\t<!-- Contact details -->\n\t\t\t\t\t<detail-block db-details="vm.personal.contactDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t!$root.currentCompany.IsPayslipManagerActive\n\t\t\t\t\t\t)" ng-if="vm.personal.contactDetails"></detail-block>\n\n\t\t\t\t\t<!-- Address -->\n\t\t\t\t\t<detail-block db-details="vm.personal.address" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t!$root.currentCompany.IsPayslipManagerActive\n\t\t\t\t\t\t)" ng-if="vm.personal.address"></detail-block>\n\n\t\t\t\t\t<!-- Bank -->\n\t\t\t\t\t<detail-block db-details="vm.personal.bankDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.personal.bankDetails"></detail-block>\n\n\t\t\t\t\t<!-- Passport -->\n\t\t\t\t\t<detail-block db-details="vm.personal.passportDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.personal.passportDetails"></detail-block>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Employment -->\n\t\t\t<div class="detail-blocks accordion m" ng-if="vm.employment">\n\t\t\t\t<button class="is-clear detail-blocks-toggle clickable" data-cy="profile-information-toggle-employment" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.employment.showEmployment\n\t\t\t\t\t}" ng-click="vm.employment.showEmployment = !vm.employment.showEmployment" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tEmployment\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden detail-blocks" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.employment.showEmployment\n\t\t\t\t\t}">\n\t\t\t\t\t<!-- New starter information -->\n\t\t\t\t\t<detail-block db-details="vm.employment.newStarterInformation" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditNewStarterInformation &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.employment.newStarterInformation"></detail-block>\n\n\t\t\t\t\t<!-- Year to dates\n\t\t\t\t\t\tCanUpdateYTDDetails is used to indicate that anybody should be able to update YTDs, i.e. when payroll hasn\'t been run yet\n\t\t\t\t\t\tThe permission would be to indicate that someone can bypass that restriction because they\'re an admin\n\t\t\t\t\t-->\n\t\t\t\t\t<detail-block db-details="vm.employment.yearToDates" db-can-edit="::(\n\t\t\t\t\t\t\t(teamMember.YTD.CanUpdateYTDDetails || currentUser.Permissions.Team.canUpdateYTDsPostSetup) &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t!teamMember.isArchivedEmployment\n\t\t\t\t\t\t)" ng-if="vm.employment.yearToDates"></detail-block>\n\n\t\t\t\t\t<!-- Company details -->\n\t\t\t\t\t<detail-block db-details="vm.employment.companyDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditCompanyDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward && !teamMember.isArchivedEmployment\n\t\t\t\t\t\t)" ng-if="vm.employment.companyDetails"></detail-block>\n\n\t\t\t\t\t<!-- Pay information (not applicable to off-payroll workers)-->\n\t\t\t\t\t<detail-block db-details="vm.employment.payInformation" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPayInformation &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.employment.payInformation"></detail-block>\n\n\t\t\t\t\t<!-- Continuous Employment -->\n\t\t\t\t\t<detail-block db-details="vm.employment.continuousEmployment" db-can-edit="::(currentUser.Permissions.Team.canEditContinuousEmployment && !teamMember.isTeamMemberMovingPayrollsOutward)" ng-if="vm.employment.continuousEmployment"></detail-block>\n\n\t\t\t\t\t<!-- Workplace Information -->\n\t\t\t\t\t<detail-block db-details="vm.employment.workplaceInformation" db-can-edit="::(currentUser.Permissions.Team.canEditCompanyDetails && !teamMember.isTeamMemberMovingPayrollsOutward)" ng-if="vm.employment.workplaceInformation"></detail-block>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Additional Posts -->\n\t\t\t<div class="detail-blocks accordion m" ng-if="vm.additionalPosts" ng-repeat="additionalPost in vm.additionalPosts">\n\t\t\t\t<button class="detail-blocks-accordion-toggle is-clear detail-blocks-toggle clickable" data-cy="profile-information-toggle-post-{{$index}}" ng-class="{\n\t\t\t\t\t\t\'active\' : additionalPost.showAdditionalPost\n\t\t\t\t\t}" ng-click="additionalPost.showAdditionalPost = !additionalPost.showAdditionalPost" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tEmployment - {{additionalPost.title}}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<div ng-if="additionalPost.post.HasLeft">\n\t\t\t\t\t\t<span class="tag tertiary highlight-on-hover" tooltip tooltip-position="left" tooltip-text="Leave date: {{additionalPost.post.LeaveDateISO | dateformat}}">Left post</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div ng-if="additionalPost.salaryPolicy.IneffectiveDateISO !== \'\' && additionalPost.salaryPolicy.SiblingPolicy !== null">\n\t\t\t\t\t\t<span class="tag primary highlight-on-hover" tooltip tooltip-position="left" tooltip-text="Update Effective From: {{additionalPost.salaryPolicy.SiblingPolicy.EffectiveDateISO | dateformat}}">Pending Update</span>\n\t\t\t\t\t</div>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-accordion-content">\n\t\t\t\t\t<div class="detail-blocks-accordion-action">\n\n\t\t\t\t\t\t<!-- Delete post option; available when policy isn\'t locked and hasn\'t been paid -->\n\t\t\t\t\t\t<a class="is-primary s is-strong" data-cy="profile-information-post-{{$index}}-delete-post" ng-if="\n\t\t\t\t\t\t\t\t!additionalPost.post.IsLocked &&\n\t\t\t\t\t\t\t\t!additionalPost.post.IsLeaving && \n\t\t\t\t\t\t\t\t!additionalPost.post.HasLeft\n\t\t\t\t\t\t\t" ng-click="openDeleteAdditionalPostForm(additionalPost.post)">\n\t\t\t\t\t\t\t<i class="icon-trash"></i>&nbsp;&nbsp;Delete post\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!-- Leave post option; available when the policy isn\'t locked, and not already leaving the post -->\n\t\t\t\t\t\t<a class="is-primary s is-strong" data-cy="profile-information-post-{{$index}}-leave-post" href="" ng-if="\n\t\t\t\t\t\t\t\tadditionalPost.post.IsLocked &&\n\t\t\t\t\t\t\t\t!additionalPost.post.IsLeaving && \n\t\t\t\t\t\t\t\t!additionalPost.post.HasLeft\n\t\t\t\t\t\t\t" ng-click="openLeaveAdditionalPostForm(additionalPost.post, teamMember, currentPayPeriod)">\n\t\t\t\t\t\t\t<i class="icon-leavers"></i>&nbsp;&nbsp;Leave post\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Is Leaving post notification, with \'Cancel\' option; if ineffective date is set and there\'s\n\t\t\t\t     no sibling policy (i.e. ineffective date corresponds to a policy update, not leaving post) -->\n\t\t\t\t<message-block action-fn="onCancelLeavingAdditionalPostClick(additionalPost.post)" action-icon="cross" action-text="Cancel" action-theme="is-tertiary-light" icon="leavers" ng-if="additionalPost.post.IsLeaving && additionalPost.post.LeaveDateISO !== \'\'" theme="tertiary is-inline is-strong">\n\t\t\t\t\t<p>{{teamMember.Personal.Forename}} is leaving this post (leave date: {{additionalPost.post.LeaveDateISO | dateformat}})</p>\n\t\t\t\t</message-block>\n\n\t\t\t\t<div class="detail-blocks-hidden detail-blocks" ng-class="{\n\t\t\t\t\t\t\'active\' : additionalPost.showAdditionalPost\n\t\t\t\t\t}">\n\t\t\t\t\t<!-- Company details -->\n\t\t\t\t\t<detail-block db-details="additionalPost.companyDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditCompanyDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t!teamMember.isArchivedEmployment &&\n\t\t\t\t\t\t\t((!additionalPost.post.IsLocked || additionalPost.salaryPolicy.State === 0) && !additionalPost.post.HasLeft)\n\t\t\t\t\t\t)" ng-if="additionalPost.companyDetails"></detail-block>\n\n\t\t\t\t\t<!-- Pay information (not applicable to off-payroll workers)-->\n\t\t\t\t\t<detail-block db-details="additionalPost.payInformation" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPayInformation &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward &&\n\t\t\t\t\t\t\t((!additionalPost.post.IsLocked || additionalPost.salaryPolicy.State === 0) && !additionalPost.post.HasLeft)\n\t\t\t\t\t\t)" ng-if="additionalPost.payInformation"></detail-block>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- CIS company -->\n\t\t\t<div class="detail-blocks accordion m" ng-if="vm.cisCompany">\n\n\t\t\t\t<button class="is-clear detail-blocks-toggle clickable" data-cy="profile-information-toggle-company" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.cisCompany.showCISCompany\n\t\t\t\t\t}" ng-click="vm.cisCompany.showCISCompany = !vm.cisCompany.showCISCompany" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tCompany\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden detail-blocks" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.cisCompany.showCISCompany\n\t\t\t\t\t}">\n\t\t\t\t\t<!-- Company details -->\n\t\t\t\t\t<detail-block db-details="vm.cisCompany.cisCompanyDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditCompanyDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.cisCompany.cisCompanyDetails"></detail-block>\n\n\t\t\t\t\t<!-- Company contact details -->\n\t\t\t\t\t<detail-block db-details="vm.cisCompany.cisCompanyContactDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.cisCompany.cisCompanyContactDetails"></detail-block>\n\n\t\t\t\t\t<!-- Payment details -->\n\t\t\t\t\t<detail-block db-details="vm.cisCompany.cisCompanyPaymentDetails" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPayInformation &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.cisCompany.cisCompanyPaymentDetails"></detail-block>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- CIS Subcontractor -->\n\t\t\t<div class="detail-blocks accordion m" ng-if="vm.cisSubContractor">\n\t\t\t\t<button class="is-clear detail-blocks-toggle clickable" data-cy="profile-information-toggle-subcontractor" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.cisSubContractor.showCISSubcontractor\n\t\t\t\t\t}" ng-click="vm.cisSubContractor.showCISSubcontractor = !vm.cisSubContractor.showCISSubcontractor" type="button">\n\t\t\t\t\t<div class="detail-blocks-toggle-icon">\n\t\t\t\t\t\t<i class="icon-up"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h5 class="detail-blocks-toggle-title">\n\t\t\t\t\t\tSubcontractor\n\t\t\t\t\t</h5>\n\t\t\t\t</button>\n\n\t\t\t\t<div class="detail-blocks-hidden detail-blocks" ng-class="{\n\t\t\t\t\t\t\'active\' : vm.cisSubContractor.showCISSubcontractor\n\t\t\t\t\t}">\n\t\t\t\t\t<!-- CIS Information -->\n\t\t\t\t\t<detail-block db-details="vm.cisSubContractor.cisInformation" db-can-edit="::(\n\t\t\t\t\t\t\tcurrentUser.Permissions.Team.canEditPersonalDetails &&\n\t\t\t\t\t\t\t!teamMember.isTeamMemberMovingPayrollsOutward\n\t\t\t\t\t\t)" ng-if="vm.cisSubContractor.cisInformation"></detail-block>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileOverviewView.html','<div class="sub-page-template-a fadeIn">\n\n\t<!-- Furlough -->\n\t<div class="sub-page-template-a-section" ng-if="teamMember.Company.IsFurloughed">\n\t\t<!-- Furlough -->\n\t\t<schedule-overview-card index="0" on-click="openFurloughForm(teamMember)" schedule="furloughSchedule"></schedule-overview-card>\n\t</div>\n\n\t<!-- In Setup Mode -->\n\t<div ng-if="teamMember.IsInSetupMode">\n\n\t\t<!-- In Progress -->\n\t\t<header class="sub-page-template-a-header" ng-if="!teamMember.TeamMemberSetupComplete">\n\n\t\t\t<!-- CIS -->\n\t\t\t<div ng-if="\n\t\t\t\tteamMember.Company.IsCISSubcontractor &&\n\t\t\t\t!teamMember.Company.IsOffPayrollWorker\n\t\t\t">\n\t\t\t\t<!-- Sole Trader / Partnership -->\n\t\t\t\t<div ng-if="!teamMember.isCompany">\n\t\t\t\t\t<h4 class="strong">Complete <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s profile set up before you approve payroll for {{currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t\t<p>Add <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s personal and CIS information to get them ready for payroll</p>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Limited / Trust -->\n\t\t\t\t<div ng-if="teamMember.isCompany">\n\t\t\t\t\t<h4 class="strong">Complete <truncate text="teamMember.CIS.BusinessDetails.TradingName" truncate-amount="30"></truncate>\'s profile set up before you approve payroll for {{currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t\t<p>Add <truncate text="teamMember.CIS.BusinessDetails.TradingName" truncate-amount="30"></truncate>\'s company and CIS information to get them ready for payroll</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Off payroll -->\n\t\t\t<div ng-if="teamMember.Company.IsOffPayrollWorker && !teamMember.Company.IsCISSubcontractor">\n\t\t\t\t<h4 class="strong">Complete <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s profile set up before you approve payroll for {{currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t<p>Add <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s personal and employment information to get them ready for payroll</p>\n\t\t\t</div>\n\n\t\t\t<!-- PAYE -->\n\t\t\t<div ng-if="!teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t<h4 class="strong">Complete <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s profile set up before you approve payroll for {{currentPayPeriod.PayPeriodDisplay}}</h4>\n\t\t\t\t<p>Add <truncate text="teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s personal, employment and pension information to get them ready for payroll</p>\n\t\t\t</div>\n\t\t</header>\n\n\t\t<!-- Complete / Awaiting Payroll Approval -->\n\t\t<header class="sub-page-template-a-header" ng-if="teamMember.TeamMemberSetupComplete">\n\t\t\t<h4 class="strong"><truncate text="teamMember.isCompany ? teamMember.CIS.BusinessDetails.TradingName : teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s profile is complete and ready for the {{currentPayPeriod.PayPeriodDisplay}} payroll</h4>\n\t\t\t<p>Once payroll has been approved you\'ll be able to see <truncate text="teamMember.isCompany ? teamMember.CIS.BusinessDetails.TradingName : teamMember.Personal.Forename" truncate-amount="30"></truncate>\'s full profile</p>\n\t\t</header>\n\n\t\t<!-- Set Up -->\n\t\t<section class="sub-page-template-a-section">\n\t\t\t<div class="progress-cards">\n\n\t\t\t\t<!-- Personal -->\n\t\t\t\t<progress-card icon="icon-setup-user" ng-if="teamMember.personalStepsGroups.length !== 0" on-progress-step-click="onProgressStepClick" progress-groups="teamMember.personalStepsGroups" team-member="teamMember" theme="primary" title="Personal">\n\t\t\t\t</progress-card>\n\n\t\t\t\t<!-- Employment (non-CIS) -->\n\t\t\t\t<progress-card icon="icon-company" ng-if="teamMember.employmentStepsGroups.length !== 0" on-progress-step-click="onProgressStepClick" on-progress-group-click="onProgressGroupClick" progress-groups="teamMember.employmentStepsGroups" show-footer="isSalaryChangeVisible(teamMember) || isWorkPatternVisible(teamMember)" team-member="teamMember" theme="quarternary" title="Employment" type="PROGRESS_CARD_TYPES.employment">\n\t\t\t\t\t<pc-footer>\n\t\t\t\t\t\t<div class="progress-card_group-main">\n\t\t\t\t\t\t\t<div class="progress-card_group-main-left">\n\t\t\t\t\t\t\t\t<a class="is-strong link-with-icon progress-card_footer-item has-margin-right" href="" ng-click="openViewWorkPatternForm()" ng-if="isWorkPatternVisible(teamMember)">\n\t\t\t\t\t\t\t\t\t<i class="is-medium icon-calendar"></i>\n\t\t\t\t\t\t\t\t\tView work pattern\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<a class="is-strong link-with-icon progress-card_footer-item" href="" ng-click="openSalaryChangeView()" ng-if="isSalaryChangeVisible(teamMember)">\n\t\t\t\t\t\t\t\t\t<i class="is-medium icon-salary-change"></i>\n\t\t\t\t\t\t\t\t\tView salary change\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="progress-card_group-progress progress-card_group-progress-right" ng-if="isSalaryChangeVisible(teamMember)">\n\t\t\t\t\t\t\t\t<span class="group-cta-cheese tag tertiary inverse is-medium no-wrap">Salary change</span>\n\t\t\t\t\t\t\t\t<span class="s stronger label-footer no-wrap">Effective: {{teamMember.Salary.SalaryChangeEffectiveDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</pc-footer>\n\t\t\t\t</progress-card>\n\n\t\t\t\t<!-- Company (CIS) -->\n\t\t\t\t<progress-card icon="icon-company" ng-if="teamMember.cisCompanyStepsGroups.length !== 0" on-progress-step-click="onProgressStepClick" progress-groups="teamMember.cisCompanyStepsGroups" team-member="teamMember" theme="primary" title="Company">\n\t\t\t\t</progress-card>\n\n\t\t\t\t<!-- CIS Information -->\n\t\t\t\t<progress-card icon="icon-company" ng-if="teamMember.cisInformationStepsGroups.length !== 0" on-progress-step-click="onProgressStepClick" progress-groups="teamMember.cisInformationStepsGroups" team-member="teamMember" theme="quarternary" title="CIS Information">\n\t\t\t\t</progress-card>\n\n\t\t\t\t<!-- Pension Information -->\n\t\t\t\t<progress-card icon="icon-money" ng-if="teamMember.pensionStepsGroups.length !== 0" on-progress-step-click="onProgressStepClick" on-progress-group-click="onProgressGroupClick" progress-groups="teamMember.pensionStepsGroups" show-footer="teamMember.CanAddToNonAEPension || teamMember.nonAePensions.length !== 0" team-member="teamMember" theme="secondary" title="Pension" type="PROGRESS_CARD_TYPES.pension">\n\t\t\t\t\t<!-- Footer, Non AE pensions, when CanAddToNonAEPension set (show-footer above) -->\n\t\t\t\t\t<pc-footer>\n\t\t\t\t\t\t<div class="progress-card_group-header">\n\t\t\t\t\t\t\t<div class="progress-card_group-title">Non-AE schemes</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-card_footer-tiles" ng-if="teamMember.nonAePensions.length !== 0">\n\t\t\t\t\t\t\t<div class="progress-card_tile is-secondary" ng-repeat="pension in teamMember.nonAePensions">\n\t\t\t\t\t\t\t\t<div class="progress-card_tile-actions">\n\t\t\t\t\t\t\t\t\t<a aria-label="Edit contributions" data-cy="profile-overview-edit-contributions" href="" class="progress-card_tile-action" ng-click="openPensionTeamContributionsNonAEForm(pension)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-edit"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a aria-label="Remove team member from pension" data-cy="profile-overview-remove from pension" href="" class="progress-card_tile-action" ng-click="openPensionTeamRemoveForm(pension)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon-trash"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<i class="icon-money l is-secondary"></i>\n\t\t\t\t\t\t\t\t<div class="progress-card_tile-info">\n\t\t\t\t\t\t\t\t\t<div class="progress-card_tile-info-heading">{{pension.PensionProviderName}}</div>\n\t\t\t\t\t\t\t\t\t<div class="progress-card_tile-info-text">{{pension.EmployerReference}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="progress-card_group-footer">\n\t\t\t\t\t\t\t<div class="progress-card_action" ng-if="teamMember.CanAddToNonAEPension">\n\t\t\t\t\t\t\t\t<a class="is-secondary-light" data-cy="profile-overview-add-non-ae-pension" href="" ng-click="openEditTeamMemberPensionNonAEWizard(teamMember, 0)">\n\t\t\t\t\t\t\t\t\t<i class="icon-add m"></i><span class="progress-card_action-text">&nbsp;&nbsp;Add non-AE scheme</span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</pc-footer>\n\t\t\t\t</progress-card>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<!-- Optional - Passport and Visa / Continuous employment / Workplace information -->\n\t\t<section class="sub-page-template-a-section" ng-if="teamMember.optionalDetails">\n\t\t\t<profile-data-block pdb-groups="teamMember.optionalDetails"></profile-data-block>\n\t\t</section>\n\n\t\t<!-- Delete team member -->\n\t\t<section class="sub-page-template-a-section has-separator is-split" ng-if="::\n\t\t\t!teamMember.Company.IsRestarter &&\n\t\t\t!teamMember.Company.isMovingPayrollsInwardPending &&\n\t\t\t(!$root.currentCompany.IsOffPayrollActive || $root.currentCompany.IsOffPayrollActive && !teamMember.CanSwitchToOffPayroll) &&\n\t\t\t!teamMember.Company.IsAdmin &&\n\t\t\tcurrentUser.Permissions.Team.canAddDeleteTeamMembers\n\t\t">\n\t\t\t<a class="link-with-icon greyscale" data-cy="profile-overview-delete-team-member" href="" ng-click="openDeleteTeamMemberForm()">\n\t\t\t\t<i class="icon-trash n"></i> Delete team member\n\t\t\t</a>\n\t\t</section>\n\n\t</div>\n\n\t<!-- Overview -->\n\t<div ng-if="!teamMember.IsInSetupMode">\n\n\t\t<!-- Pay / Pension / Information -->\n\t\t<section class="sub-page-template-a-section">\n\n\t\t\t<!-- Summary Cards -->\n\t\t\t<div class="summary-cards" ng-class="{\n\t\t\t\t\t\'two\': teamMember.Company.IsCISSubcontractor || teamMember.Company.IsOffPayrollWorker || !currentCompany.IsPensionActive\n\t\t\t\t}">\n\t\t\t\t<!-- Pay -->\n\t\t\t\t<div class="summary-card quarternary">\n\n\t\t\t\t\t<header class="summary-card-header">\n\t\t\t\t\t\t<i class="icon-wallet summary-card-header-icon"></i>\n\t\t\t\t\t\t<h3 class="summary-card-header-title">Pay</h3>\n\n\t\t\t\t\t\t<div class="summary-card-header-action" ng-if="teamMember.Payment.CanDownload">\n\t\t\t\t\t\t\t<a class="summary-card-header-action quarternary" href="" ng-click="downloadFile(teamMember.Payment.PayslipPDFURL)">\n\t\t\t\t\t\t\t\t{{teamMember.Payment.IsSupplementaryPayment ? \'Supplementary payslip\': \'Payslip\'}} <i class="icon-download"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="summary-card-main">\n\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t<h2 class="summary-card-main-title">{{teamMember.Payment.NetPayment | monetise}}</h2>\n\t\t\t\t\t\t\t<p class="summary-card-main-label">{{teamMember.Payment.PaymentDateDisplay}}</p>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<!-- Not CIS or off-payroll -->\n\t\t\t\t\t\t<div class="summary-card-figures-wrapper" ng-if="!teamMember.Company.IsCISSubcontractor && !teamMember.Company.IsOffPayrollWorker">\n\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Gross</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.GrossPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Tax</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.TaxPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">NI</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.EmployeeNIPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- CIS -->\n\t\t\t\t\t\t<div class="summary-card-figures-wrapper" ng-if="teamMember.Company.IsCISSubcontractor">\n\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">CIS Payments</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.GrossPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Cost of materials</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.TaxPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">CIS deduction ({{teamMember.CIS.DeductionRate | taxTreatment}})</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Payment.EmployeeNIPayment | monetise}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t\t<footer class="summary-card-footer">\n\t\t\t\t\t\t<a class="summary-card-footer-action quarternary" href="" ng-click="openPayStatementForm(teamMember.Payment.AgencyPayPeriodID)" ng-if="true">\n\t\t\t\t\t\t\tPay statement\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension -->\n\t\t\t\t<div class="summary-card" ng-class="teamMember.Pensions[teamMember.pensionIndex].class" ng-if="\n\t\t\t\t\t\tcurrentCompany.IsPensionActive &&\n\t\t\t\t\t\t!teamMember.Company.IsCISSubcontractor &&\n\t\t\t\t\t\t!teamMember.Company.IsOffPayrollWorker\n\t\t\t\t\t">\n\t\t\t\t\t<header class="summary-card-header">\n\t\t\t\t\t\t<i class="icon-money summary-card-header-icon"></i>\n\t\t\t\t\t\t<h3 class="summary-card-header-title">Pension</h3>\n\n\t\t\t\t\t\t<div class="summary-card-header-action" ng-if="::$root.currentCompany.HasPension && teamMember.Pensions.length > 1">\n\t\t\t\t\t\t\t<carousel-input current-index="teamMember.pensionIndex" max-index="teamMember.Pensions.length" theme="teamMember.Pensions[teamMember.pensionIndex].class"></carousel-input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="summary-card-main">\n\n\t\t\t\t\t\t<!-- Company has no pension -->\n\t\t\t\t\t\t<div ng-if="::!$root.currentCompany.HasPension">\n\t\t\t\t\t\t\t<p class="is-small is-greyscale">\n\t\t\t\t\t\t\t\tThe Pension module for {{::$root.currentCompany.Name}} is turned on but a pension hasn\u2019t been added yet.\n\t\t\t\t\t\t\t\t<a class="is-greyscale is-underline" ng-if="!userHasRole(\'departmentadmin\')" ui-sref="pensions.summary({agencyProfileId: agencyProfileId})">\n\t\t\t\t\t\t\t\t\tGo to your Pensions area to add your pension\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Company has pension -->\n\t\t\t\t\t\t<div ng-if="$root.currentCompany.HasPension">\n\n\t\t\t\t\t\t\t<div class="summary-card-detail fadeIn" ng-if="\n\t\t\t\t\t\t\t\t\tteamMember.Pensions[teamMember.pensionIndex].PensionState !== PENSION_ENROLMENT_STATES.excluded &&\n\t\t\t\t\t\t\t\t\tteamMember.Pensions[teamMember.pensionIndex].WorkplacePensionID !== CONFIG.guidEmpty\n\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t<pension-scheme-detail theme="teamMember.Pensions[teamMember.pensionIndex].class" ng-if="\n\t\t\t\t\t\t\t\t\t\t!teamMember.Pensions[teamMember.pensionIndex].IsInPensionSetupMode ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\tteamMember.Pensions[teamMember.pensionIndex].IsInPensionSetupMode &&\n\t\t\t\t\t\t\t\t\t\t\tteamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t" pension="teamMember.Pensions[teamMember.pensionIndex]">\n\t\t\t\t\t\t\t\t</pension-scheme-detail>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Active Pension -->\n\t\t\t\t\t\t\t<div ng-if="\n\t\t\t\t\t\t\t\t\t!teamMember.Pensions[teamMember.pensionIndex].IsInPensionSetupMode &&\n\t\t\t\t\t\t\t\t\t!teamMember.Pensions[teamMember.pensionIndex].IsGhostPension\n\t\t\t\t\t\t\t\t" ng-switch="teamMember.Pensions[teamMember.pensionIndex].PensionState">\n\n\t\t\t\t\t\t\t\t<!-- Above Age Limit -->\n\t\t\t\t\t\t\t\t<div pc-switch-when="PENSION_ENROLMENT_STATES.aboveAgeLimit">\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Above age limit</h2>\n\t\t\t\t\t\t\t\t\t\t<p class="summary-card-main-label">Not eligible for a pension</p>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Can Join / Can Opt In / Not Assessed -->\n\t\t\t\t\t\t\t\t<div pc-switch-when="[\n\t\t\t\t\t\t\t\t\tPENSION_ENROLMENT_STATES.canJoin,\n\t\t\t\t\t\t\t\t\tPENSION_ENROLMENT_STATES.canOptIn,\n\t\t\t\t\t\t\t\t\tPENSION_ENROLMENT_STATES.notAssessed\n\t\t\t\t\t\t\t\t]">\n\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header" ng-switch="teamMember.Pensions[teamMember.pensionIndex].PensionState">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title" pc-switch-when="PENSION_ENROLMENT_STATES.canJoin">\n\t\t\t\t\t\t\t\t\t\t\tCan join\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title" pc-switch-when="PENSION_ENROLMENT_STATES.canOptIn">\n\t\t\t\t\t\t\t\t\t\t\tCan opt in\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title" pc-switch-when="PENSION_ENROLMENT_STATES.notAssessed">\n\t\t\t\t\t\t\t\t\t\t\tNot assessed\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t\t\t<div class="summary-card-figures-wrapper">\n\t\t\t\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Next assessment</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{::currentPayPeriod.PayDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Excluded -->\n\t\t\t\t\t\t\t\t<div pc-switch-when="PENSION_ENROLMENT_STATES.excluded">\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Excluded</h2>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t<div class="summary-card-content">\n\t\t\t\t\t\t\t\t\t\t<p class="is-small greyscale">\n\t\t\t\t\t\t\t\t\t\t\t{{::teamMember.Personal.Forename}} has been excluded from all AE pensions.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Opted Out -->\n\t\t\t\t\t\t\t\t<div pc-switch-when="PENSION_ENROLMENT_STATES.optedOut">\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Opted Out</h2>\n\t\t\t\t\t\t\t\t\t\t<p class="summary-card-main-label">On {{teamMember.Pensions[teamMember.pensionIndex].PensionOptOutDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t\t\t<!--\n\t\t\t\t\t\t\t\t\t\tRefund figures are not accurate so will be addressed in a new ticket:\n\t\t\t\t\t\t\t\t\t\thttps://www.notion.so/paycircle/Pension-store-refund-details-so-they-can-be-retrieved-later-28166ce5fc704428ae0b864c900bda9e\n\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\tclass="summary-card-figures-wrapper"\n\t\t\t\t\t\t\t\t\t\tng-if="teamMember.Pensions[teamMember.pensionIndex].PensionRefundDateISO !== \'\'"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Refund issued</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Pensions[teamMember.pensionIndex].LastContributionAmount | monetise}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Refund date</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Pensions[teamMember.pensionIndex].PensionRefundDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t-->\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Ceased -->\n\t\t\t\t\t\t\t\t<div pc-switch-when="PENSION_ENROLMENT_STATES.ceased">\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Ceased</h2>\n\t\t\t\t\t\t\t\t\t\t<p class="summary-card-main-label">On {{teamMember.Pensions[teamMember.pensionIndex].PensionCeaseDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Postponed / Will Be Enrolled -->\n\t\t\t\t\t\t\t\t<div ng-switch="teamMember.Pensions[teamMember.pensionIndex].PensionState" pc-switch-when="[\n\t\t\t\t\t\t\t\t\t\tPENSION_ENROLMENT_STATES.postponed,\n\t\t\t\t\t\t\t\t\t\tPENSION_ENROLMENT_STATES.willBeEnrolled\n\t\t\t\t\t\t\t\t\t]">\n\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header" pc-switch-when="PENSION_ENROLMENT_STATES.postponed">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Postponed</h2>\n\t\t\t\t\t\t\t\t\t\t<p class="summary-card-main-label">Until {{teamMember.Pensions[teamMember.pensionIndex].PensionPostponeDateISO | dateformat}}</p>\n\t\t\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t\t\t<header class="summary-card-main-header" pc-switch-when="PENSION_ENROLMENT_STATES.willBeEnrolled">\n\t\t\t\t\t\t\t\t\t\t<h2 class="summary-card-main-title">Will be enrolled</h2>\n\t\t\t\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t\t\t\t<div class="summary-card-figures-wrapper">\n\t\t\t\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure" ng-if="teamMember.Pensions[teamMember.pensionIndex].PensionAssessmentDateISO !== \'\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Assessment date</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Pensions[teamMember.pensionIndex].PensionAssessmentDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Next assessment</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{::currentPayPeriod.PayDateISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Enrolled / Joined / Opted In / Voluntary / Re-Assessed -->\n\t\t\t\t\t\t\t\t<div ng-switch-default>\n\n\t\t\t\t\t\t\t\t\t<!-- Drop through to default here can happen when the pension corresponds to an additional post, when the pension\n\t\t\t\t\t\t\t\t\t\t may not have been assigned. That\'s perfecly valid, and requires a special message -->\n\t\t\t\t\t\t\t\t\t<div ng-if="teamMember.Pensions[teamMember.pensionIndex].WorkplacePensionID === CONFIG.guidEmpty">\n\t\t\t\t\t\t\t\t\t\t<div class="summary-card-info">\n\t\t\t\t\t\t\t\t\t\t\t{{teamMember.Personal.Forename}} hasn\u2019t been added to an AE pension scheme for their\n\t\t\t\t\t\t\t\t\t\t\t\u2018{{teamMember.Pensions[teamMember.pensionIndex].SalaryPolicyPostTitle}}\u2019 post.\n\t\t\t\t\t\t\t\t\t\t\tYou can do so by clicking on the \u2018Add team members\u2019 action for one of the AE schemes\n\t\t\t\t\t\t\t\t\t\t\tin your Pensions area.\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t<!-- Ensure there is a workplace pension ID, see comment above. This is just for the additional post, no pension scenario,\n\t\t\t\t\t\t\t\t\t\t when a pension record exists for an additional post that may not or ever become \'real\' -->\n\t\t\t\t\t\t\t\t\t<div class="summary-card-figures-wrapper" ng-if="teamMember.Pensions[teamMember.pensionIndex].WorkplacePensionID !== CONFIG.guidEmpty">\n\t\t\t\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Latest contribution</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Pensions[teamMember.pensionIndex].LastContributionAmount | monetise}}</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Employee contribution</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!teamMember.Pensions[teamMember.pensionIndex].HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{teamMember.Pensions[teamMember.pensionIndex].PensionEmployeePercent}}%\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Fixed Amount -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="teamMember.Pensions[teamMember.pensionIndex].HasFixedEmployeeContribution">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{teamMember.Pensions[teamMember.pensionIndex].PensionEmployeeFixedAmount | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Employer contribution</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="!teamMember.Pensions[teamMember.pensionIndex].HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{teamMember.Pensions[teamMember.pensionIndex].PensionEmployerPercent}}%\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Fixed Amount -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="teamMember.Pensions[teamMember.pensionIndex].HasFixedEmployerContribution">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{teamMember.Pensions[teamMember.pensionIndex].PensionEmployerFixedAmount | monetise}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Setup Mode -->\n\t\t\t\t\t\t\t<div ng-if="teamMember.Pensions[teamMember.pensionIndex].IsInPensionSetupMode">\n\n\t\t\t\t\t\t\t\t<!-- Non Ghost Pension -->\n\t\t\t\t\t\t\t\t<ul class="tick-list secondary" ng-if="!teamMember.Pensions[teamMember.pensionIndex].IsGhostPension">\n\t\t\t\t\t\t\t\t\t<li ng-if="!teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete">\n\t\t\t\t\t\t\t\t\t\t<a class="underline" href="" ng-click="openEditTeamMemberPensionWizard(teamMember.Pensions[teamMember.pensionIndex], 0)">\n\t\t\t\t\t\t\t\t\t\t\tPension\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'complete\': teamMember.Pensions[teamMember.pensionIndex].PensionSetupComplete,\n\t\t\t\t\t\t\t\t\t\t\'disabled\': !teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t<a href="" ng-class="{\'underline\': teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete}" ng-click="openEditTeamMemberPensionWizard(teamMember.Pensions[teamMember.pensionIndex], 1)">\n\t\t\t\t\t\t\t\t\t\t\tStatus\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'complete\': teamMember.Pensions[teamMember.pensionIndex].PensionGroupSetupComplete,\n\t\t\t\t\t\t\t\t\t\t\'disabled\': !teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t<a href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'underline\': teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t\t\t}" ng-click="openEditTeamMemberPensionWizard(teamMember.Pensions[teamMember.pensionIndex], 2)">\n\t\t\t\t\t\t\t\t\t\t\tGroup\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li ng-class="{\n\t\t\t\t\t\t\t\t\t\t\'complete\': teamMember.Pensions[teamMember.pensionIndex].PensionGroupSetupComplete,\n\t\t\t\t\t\t\t\t\t\t\'disabled\': !teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t}">\n\t\t\t\t\t\t\t\t\t\t<a href="" ng-class="{\'underline\': teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete}" ng-click="openEditTeamMemberPensionWizard(teamMember.Pensions[teamMember.pensionIndex], 3)">\n\t\t\t\t\t\t\t\t\t\t\tContributions\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\'complete\': teamMember.Pensions[teamMember.pensionIndex].PensionGroupSetupComplete,\n\t\t\t\t\t\t\t\t\t\t\t\'disabled\': !teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t\t}" ng-if="teamMember.Pensions[teamMember.pensionIndex].CanBeSalarySacrifice">\n\t\t\t\t\t\t\t\t\t\t<a href="" ng-class="{\n\t\t\t\t\t\t\t\t\t\t\t\t\'underline\': teamMember.Pensions[teamMember.pensionIndex].PensionSchemeSetupComplete\n\t\t\t\t\t\t\t\t\t\t\t}" ng-click="openEditTeamMemberPensionWizard(teamMember.Pensions[teamMember.pensionIndex], 4)">\n\t\t\t\t\t\t\t\t\t\t\tSalary sacrifice\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<!-- Ghost Pension -->\n\t\t\t\t\t\t\t\t<div class="summary-card-content" ng-if="teamMember.Pensions[teamMember.pensionIndex].IsGhostPension">\n\t\t\t\t\t\t\t\t\t<p class="s greyscale-darkened">\n\t\t\t\t\t\t\t\t\t\tTeam members are currently being assessed by a Ghost Pension.\n\t\t\t\t\t\t\t\t\t\tYou\u2019ll be notified when a team member becomes eligible and a pension provider needs to be selected.\n\t\t\t\t\t\t\t\t\t\t<a class="secondary underline" href="" ng-if="!userHasRole(\'departmentadmin\')" ui-sref="pensions.summary({agencyProfileId: agencyProfileId})">\n\t\t\t\t\t\t\t\t\t\t\tGo to your Pensions page\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t\t<footer class="summary-card-footer" ng-if="::$root.currentCompany.HasPension">\n\t\t\t\t\t\t<div class="summary-card-footer-icon fadeIn" ng-if="teamMember.Pensions[teamMember.pensionIndex].IsAdditionalPost">\n\t\t\t\t\t\t\t<icon-dot icon="icon-setup-user" theme="{{teamMember.Pensions[teamMember.pensionIndex].class}}" tooltip-position="left" tooltip-text="{{teamMember.Pensions[teamMember.pensionIndex].SalaryPolicyPostTitle}}"></icon-dot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a class="summary-card-footer-action" ng-class="teamMember.Pensions[teamMember.pensionIndex].class" ng-if="\n\t\t\t\t\t\t\t\t!teamMember.Pensions[teamMember.pensionIndex].IsInPensionSetupMode &&\n\t\t\t\t\t\t\t\tteamMember.Pensions[teamMember.pensionIndex].PensionSetupComplete\n\t\t\t\t\t\t\t" ui-sref="team.profile.pension">\n\t\t\t\t\t\t\tPension history\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</footer>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Information (non-CIS) -->\n\t\t\t\t<div class="summary-card primary" ng-if="!teamMember.Company.IsCISSubcontractor">\n\n\t\t\t\t\t<header class="summary-card-header">\n\t\t\t\t\t\t<i class="icon-setup-user summary-card-header-icon"></i>\n\t\t\t\t\t\t<h3 class="summary-card-header-title">Information</h3>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="summary-card-main">\n\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t<h2 class="summary-card-main-title">\n\n\t\t\t\t\t\t\t\t<!-- NI Number Pending -->\n\t\t\t\t\t\t\t\t<span ng-if="teamMember.Personal.NINumberPending">Waiting</span>\n\n\t\t\t\t\t\t\t\t<!-- NI Number -->\n\t\t\t\t\t\t\t\t<span ng-if="!teamMember.Personal.NINumberPending">{{teamMember.Personal.NINumber | checkEmpty}}</span>\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p class="summary-card-main-label">NI Number</p>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<div class="summary-card-figures-wrapper">\n\t\t\t\t\t\t\t<ul class="summary-card-figures inline" ng-switch="teamMember.Salary.SalaryType">\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Born</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Personal.DOBISO | dateformat}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Tax code</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Tax.TaxCode}}&nbsp;{{teamMember.Tax.TaxCodeM1W1 ? CONFIG.w1m1Label : \'\'}}</span>\n\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t<!-- Hourly -->\n\t\t\t\t\t\t\t\t<li class="summary-card-figure" pc-switch-when="PAYMENT_TYPES.hourly">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Hourly pay</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Salary.SalaryHourlyRate | monetise}}/hr, {{teamMember.Salary.SalaryHours}} hrs/week</span>\n\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t<!-- Salary -->\n\t\t\t\t\t\t\t\t<li class="summary-card-figure" pc-switch-when="PAYMENT_TYPES.salary">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Salary</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Salary.SalaryYearly | monetisedown}}</span>\n\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t<!-- Net -->\n\t\t\t\t\t\t\t\t<li class="summary-card-figure" pc-switch-when="PAYMENT_TYPES.net">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label">Net pay</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Salary.SalaryYearly | monetisedown}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t\t<footer class="summary-card-footer">\n\t\t\t\t\t\t<a class="summary-card-footer-action" ui-sref="team.profile.information">\n\t\t\t\t\t\t\tView information\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Information (CIS) -->\n\t\t\t\t<div class="summary-card tertiary" ng-if="teamMember.Company.IsCISSubcontractor">\n\n\t\t\t\t\t<header class="summary-card-header">\n\t\t\t\t\t\t<i class="icon-setup-user summary-card-header-icon"></i>\n\t\t\t\t\t\t<h3 class="summary-card-header-title">Information (CIS)</h3>\n\t\t\t\t\t</header>\n\n\t\t\t\t\t<main class="summary-card-main">\n\t\t\t\t\t\t<header class="summary-card-main-header">\n\t\t\t\t\t\t\t<h2 class="summary-card-main-title">{{teamMember.CIS.VerificationReference}}</h2>\n\t\t\t\t\t\t\t<p class="summary-card-main-label">Verification Number</p>\n\t\t\t\t\t\t</header>\n\n\t\t\t\t\t\t<div class="summary-card-figures-wrapper">\n\t\t\t\t\t\t\t<ul class="summary-card-figures">\n\t\t\t\t\t\t\t\t<li class="summary-card-figure">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label"><abbr title="Unique Tax Reference">UTR</abbr> for {{teamMember.Personal.Forename}}</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.Personal.UTRPending ? \'Waiting\' : teamMember.Personal.UTR}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li class="summary-card-figure" ng-if="teamMember.CIS.BusinessDetails.PartnershipUTR !== \'\'">\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-label"><abbr title="Unique Tax Reference">UTR</abbr> for partnership</span>\n\t\t\t\t\t\t\t\t\t<span class="summary-card-figure-value">{{teamMember.CIS.BusinessDetails.PartnershipUTR}}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</main>\n\n\t\t\t\t\t<footer class="summary-card-footer">\n\t\t\t\t\t\t<a class="summary-card-footer-action tertiary" ui-sref="team.profile.information">\n\t\t\t\t\t\t\tView information\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\t</div>\n</div>\n');
$templateCache.put('features/app/team/profile/tabs/profilePaymentsView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="fadeIn" ng-if="pageState === \'ready\'">\n\t\t\n\t<!-- Search bar -->\n\t<search-bar options="searchBarOptions" count="filteredPayments.length"></search-bar>\n\n\t<!-- Document Cards -->\n\t<section class="payment-cards {{searchBarOptions.layout}}">\n\n\t\t<payment-card agency-profile-id="{{agencyProfileId}}" user-id="{{userId}}" payment="payment" is-cis-payment="teamMember.Company.IsCISSubcontractor" dir-paginate="payment in filteredPayments = ( payments | filter : searchBarOptions.search.string ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage"></payment-card>\n\n\t\t<!-- No search results -->\n\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredPayments.length === 0"></empty-search>\n\t</section>\n\n\t<!-- Pagination -->\n\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n\n\n\n');
$templateCache.put('features/app/team/profile/tabs/profilePensionView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="side-bar-menu_wrapper">\n\n\t\t<!-- Pensions -->\n\t\t<div class="side-bar-menu_menu" ng-if="::vm.pensionPayments.length > 1">\n\t\t\t<header class="side-bar-menu_menu-header"><ng-pluralize count="vm.pensionCount" when="{\'1\': \'1 pension\', \'other\': \'{} pensions\'}"></ng-pluralize></header>\n\n\t\t\t<div class="side-bar-item_wrapper">\n\n\t\t\t\t<side-bar-item id="pension-{{$index}}" heading="\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\tpayment.PensionDetails.PensionType === PENSION_TYPES.autoEnrolment &&\n\t\t\t\t\t\t\tpayment.PensionDetails.PensionState !== PENSION_ENROLMENT_STATES.excluded\n\t\t\t\t\t\t) ||\n\t\t\t\t\t\tpayment.PensionDetails.PensionType === PENSION_TYPES.nonAutoEnrolment ?\n\t\t\t\t\t\tpayment.PensionDetails.PensionProviderName : \'AE Pension\'\n\t\t\t\t\t" is-active="payment === vm.activePayment" ng-repeat="payment in vm.pensionPayments" on-click="setActivePayment(vm, payment)" theme="is-primary">\n\t\t\t\t\t<side-bar-item-description>\n\t\t\t\t\t\t<span ng-if="(payment.PensionDetails.PensionType === PENSION_TYPES.autoEnrolment && payment.PensionDetails.PensionState !== PENSION_ENROLMENT_STATES.excluded) || payment.PensionDetails.PensionType === PENSION_TYPES.nonAutoEnrolment">\n\t\t\t\t\t\t\t{{::payment.PensionDetails.EmployerReference}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if="payment.PensionDetails.PensionType === PENSION_TYPES.autoEnrolment && payment.PensionDetails.PensionState === PENSION_ENROLMENT_STATES.excluded">\n\t\t\t\t\t\t\tExcluded\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</side-bar-item-description>\n\t\t\t\t</side-bar-item>\n\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Selected Role -->\n\t\t<div class="side-bar-menu_main" ng-if="vm.activePayment">\n\n\t\t\t<!-- In Pension -->\n\t\t\t<div class="fadeIn" ng-if="vm.activePayment.PensionDetails.PensionState !== PENSION_ENROLMENT_STATES.excluded">\n\t\t\t\t<header class="side-bar-menu_main-header has-no-border">\n\t\t\t\t\t<pension-scheme-detail pension="vm.activePayment.PensionDetails" show-labels="true" show-status="true" variant="is-media-borderless is-media-medium">\n\t\t\t\t\t\t<!-- Actions only available when the pension hasn\'t been deleted and has at least one available action -->\n\t\t\t\t\t\t<psd-action ng-if="canShowPensionActions()">\n\t\t\t\t\t\t\t<dropdown-menu menu-id="profile-pension-scheme-menu" menu-icon="icon-setup" menu-show-chevron="true" menu-show="menuShow" menu-size="l">\n\t\t\t\t\t\t\t\t<div class="dropdown-group" ng-if="canShowPensionSettingsMenu()">\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-status" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-status\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionStatus || vm.activePayment.PensionDetails.CanUpdatePensionStatusFull">Pension status</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-band" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-bands\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionBand">Pension band</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-group" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-groups\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionGroup">Pension group</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-contributions-non-ae" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-contributions-non-ae\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionSetup">Pension contributions</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-contributions-ae" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-contributions-ae\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionContributions">Pension contributions</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-pension-postponement" href="" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-postponement\')" ng-if="vm.activePayment.PensionDetails.CanUpdatePensionPostponement">Pension postponement</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-add-to-pension" href="" ng-click="openAddToPensionWizard(vm.activePayment.PensionDetails)" ng-if="vm.activePayment.PensionDetails.CanAddToPension">Add to pension</a>\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-rejoin" href="" ng-click="openPensionTeamContributionsNonAEForm(vm.activePayment.PensionDetails)" ng-if="vm.activePayment.PensionDetails.CanRejoinPension">Rejoin</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="dropdown-group" ng-if="canShowPensionRemoveMenu()">\n\t\t\t\t\t\t\t\t\t<a data-cy="profile-pension-scheme-menu-remove-from-pension" href="" class="assertive" ng-click="openSlideInForm(vm.activePayment.PensionDetails, \'pension-team-remove\')">Remove from pension</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</dropdown-menu>\n\t\t\t\t\t\t</psd-action>\n\t\t\t\t\t</pension-scheme-detail>\n\t\t\t\t</header>\n\n\t\t\t\t<section class="sub-page-template-a-section">\n\n\t\t\t\t\t<!-- Pension Status -->\n\t\t\t\t\t<section class="sub-page-template-a-section">\n\t\t\t\t\t\t<div class="pension-summary-block" ng-if="!vm.activePayment.PensionDetails.IsGhostPension && vm.activePayment.PensionDetails.PensionState !== PENSION_ENROLMENT_STATES.removed" ng-switch="vm.activePayment.PensionDetails.PensionType">\n\n\t\t\t\t\t\t\t<!-- Header, displaying additional post if applicable -->\n\t\t\t\t\t\t\t<div class="pension-summary-block_header" ng-if="vm.activePayment.PensionDetails.IsAdditionalPost">\n\t\t\t\t\t\t\t\t{{vm.activePayment.PensionDetails.SalaryPolicyPostTitle}}\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Items -->\n\t\t\t\t\t\t\t<div class="pension-summary-block_items">\n\t\t\t\t\t\t\t\t<!-- Group -->\n\t\t\t\t\t\t\t\t<div class="pension-summary-block_item">\n\t\t\t\t\t\t\t\t\t<i class="icon-group pension-summary-block_item-icon"></i>\n\t\t\t\t\t\t\t\t\t<div class="pension-summary-block_item-detail">\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-label fadeIn" pc-switch-when="PENSION_TYPES.autoEnrolment">{{vm.activePayment.PensionDetails.UsePensionPolicy ? \'Band\': \'Group\'}}</p>\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-label fadeIn" pc-switch-when="PENSION_TYPES.nonAutoEnrolment">Contribution band</p>\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-value">{{vm.activePayment.PensionDetails.PensionGroupName | checkEmpty:\'None\'}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Employee -->\n\t\t\t\t\t\t\t\t<div class="pension-summary-block_item">\n\t\t\t\t\t\t\t\t\t<i class="icon-user pension-summary-block_item-icon"></i>\n\t\t\t\t\t\t\t\t\t<div class="pension-summary-block_item-detail">\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-label">Employee contribution</p>\n\t\t\t\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-value" ng-if="!vm.activePayment.PensionDetails.HasFixedEmployeeContribution">{{vm.activePayment.PensionDetails.PensionEmployeePercent}}%</p>\n\t\t\t\t\t\t\t\t\t\t<!-- Fixed Amount -->\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-value" ng-if="vm.activePayment.PensionDetails.HasFixedEmployeeContribution">{{vm.activePayment.PensionDetails.PensionEmployeeFixedAmount | monetise}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- Employer -->\n\t\t\t\t\t\t\t\t<div class="pension-summary-block_item">\n\t\t\t\t\t\t\t\t\t<i class="icon-user pension-summary-block_item-icon"></i>\n\t\t\t\t\t\t\t\t\t<div class="pension-summary-block_item-detail">\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-label">Employer contribution</p>\n\t\t\t\t\t\t\t\t\t\t<!-- Percentage -->\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-value" ng-if="!vm.activePayment.PensionDetails.HasFixedEmployerContribution">{{vm.activePayment.PensionDetails.PensionEmployerPercent}}%</p>\n\t\t\t\t\t\t\t\t\t\t<!-- Fixed Amount -->\n\t\t\t\t\t\t\t\t\t\t<p class="pension-summary-block_item-value" ng-if="vm.activePayment.PensionDetails.HasFixedEmployerContribution">{{vm.activePayment.PensionDetails.PensionEmployerFixedAmount | monetise}}</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<note note-theme="basic" ng-if="vm.activePayment.PensionDetails.IsGhostPension">\n\t\t\t\t\t\t\t<note-content>\n\t\t\t\t\t\t\t\t<p class="s">\n\t\t\t\t\t\t\t\t\tAll team members are currently being assessed by a Ghost Pension. You\u2019ll be notified when a team member becomes eligible and a pension provider needs to be selected. <a href="" ui-sref="pensions.summary({agencyProfileId: agencyProfileId})" class="secondary underline">Go to your Pensions page</a>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</note-content>\n\t\t\t\t\t\t</note>\n\t\t\t\t\t</section>\n\t\t\t\t</section>\n\t\t\t</div>\n\n\t\t\t<!-- Pension Deleted -->\n\t\t\t<section class="sub-page-template-a-section" ng-if="vm.activePayment.PensionDetails.PensionState === PENSION_ENROLMENT_STATES.deleted">\n\t\t\t\t<message-bar theme="assertive is-align-left">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<span class="tag assertive inverse has-margin-right">Deleted</span>\n\t\t\t\t\t\t<span class="italic is-assertive-lightened">Pension deleted on {{vm.activePayment.PensionDetails.PensionDeletedDateISO | dateformat:\'long\'}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t</message-bar>\n\t\t\t</section>\n\n\t\t\t<!-- Excluded -->\n\t\t\t<section class="sub-page-template-a-section" ng-if="vm.activePayment.PensionDetails.PensionState === PENSION_ENROLMENT_STATES.excluded">\n\t\t\t\t<message-bar theme="greyscale is-align-left">\n\t\t\t\t\t<p><span class="tag greyscale inverse has-margin-right">Excluded</span>{{teamMember.Personal.Forename}} has been excluded from all AE pensions</p>\n\t\t\t\t\t<a data-cy="profile-pension-scheme-add-to-ae-pension" href="" ng-click="openAddToPensionWizard(vm.activePayment.PensionDetails)" class="primary message-bar-action" ng-if="vm.activePayment.PensionDetails.CanAddToPension">Add to AE pension <i class="icon-chevron-right"></i></a>\n\t\t\t\t</message-bar>\n\t\t\t</section>\n\n\t\t\t<!-- Removed -->\n\t\t\t<section class="sub-page-template-a-section" ng-if="vm.activePayment.PensionDetails.PensionState === PENSION_ENROLMENT_STATES.removed">\n\t\t\t\t<div class="message-bar indifferent is-align-left">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<span class="tag indifferent inverse has-margin-right">Removed</span>\n\t\t\t\t\t\t<span class="italic is-indifferent">Removed from pension on {{vm.activePayment.PensionDetails.PensionArchivedDateISO | dateformat}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<a class="indifferent message-bar-action" data-cy="profile-pension-scheme-rejoin" href="" ng-click="openPensionTeamContributionsNonAEForm(vm.activePayment.PensionDetails)" ng-if="vm.activePayment.PensionDetails.CanRejoinPension">Rejoin</a>\n\t\t\t\t</div>\n\t\t\t</section>\n\n\t\t\t<!-- Ceased -->\n\t\t\t<section class="sub-page-template-a-section" ng-if="vm.activePayment.PensionDetails.PensionCeasedContributions">\n\t\t\t\t<notification-card icon="cross">\n\t\t\t\t\t<nc-description>\n\t\t\t\t\t\t<p>Contribution payments stopped&nbsp;<em>Cease payments request sent on {{vm.activePayment.PensionDetails.PensionCeaseDateISO | dateformat:\'long\'}}</em></p>\n\t\t\t\t\t</nc-description>\n\t\t\t\t</notification-card>\n\t\t\t</section>\n\n\t\t\t<!-- Opted Out -->\n\t\t\t<section class="sub-page-template-a-section" ng-if="vm.activePayment.PensionDetails.PensionOptedOut">\n\t\t\t\t<notification-card icon="cross">\n\t\t\t\t\t<nc-description>\n\t\t\t\t\t\t<p>Contribution payments stopped&nbsp;<em>Opt out request sent on {{vm.activePayment.PensionDetails.PensionOptOutDateISO | dateformat:\'long\'}}</em></p>\n\t\t\t\t\t</nc-description>\n\t\t\t\t</notification-card>\n\t\t\t</section>\n\n\t\t\t<!-- Contributions -->\n\t\t\t<div class="contribution-cards" ng-if="!vm.activePayment.PensionDetails.IsGhostPension && !teamMember.isArchivedEmployment">\n\n\t\t\t\t<div ng-if="vm.activePayment.Payments.length > 0" class="contribution-card" ng-class="{\'isOpen\': payment.isOpen}" dir-paginate="payment in vm.activePayment.Payments | itemsPerPage:12">\n\t\t\t\t\t<header class="contribution-card-header" ng-click="payment.isOpen = !payment.isOpen">\n\t\t\t\t\t\t<h6 class="contribution-card-date">{{payment.PaymentDateISO | dateformat}}</h6>\n\t\t\t\t\t\t<h6 class="contribution-card-contribution">{{payment.TotalPensionPayment | monetise}}</h6>\n\t\t\t\t\t\t<a href="" class="contribution-card-toggle" aria-label="Toggle payment"><i ng-class="{\'icon-chevron-down\': !payment.isOpen, \'icon-chevron-up\': payment.isOpen}"></i></a>\n\t\t\t\t\t</header>\n\t\t\t\t\t<main class="contribution-card-main fadeIn" ng-if="payment.isOpen">\n\t\t\t\t\t\t<ul class="contribution-card-breakdown">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-label">You</span>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-value">{{payment.EmployeesPensionPayment | monetise}}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li ng-if="payment.GovernmentPensionPayment > 0">\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-label">Government</span>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-value">{{payment.GovernmentPensionPayment | monetise}}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-label">{{$root.currentCompany.Name}}</span>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-value">{{payment.EmployersPensionPayment | monetise}}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li ng-if="payment.HasPensionPaymentEmployersNISaving">\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-label">Employer NI savings ({{payment.PensionPaymentEmployersNISavingPercent}}%)</span>\n\t\t\t\t\t\t\t\t<span class="contribution-card-breakdown-value">{{payment.PensionPaymentEmployersNISaving | monetise}}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</main>\n\t\t\t\t\t<footer class="contribution-card-footer" ng-if="payment.CanDownload">\n\t\t\t\t\t\t<a data-cy="profile-pension-scheme-view-payslip" href="" ng-click="downloadFile(payment.PayslipPDFURL)" class="link-with-icon contribution-card-footer-action"><i class="icon-payslip"></i>View payslip</a>\n\t\t\t\t\t</footer>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="vm.activePayment.Payments.length === 0">\n\t\t\t\t\t<p class="greyscale italic is-small">\n\t\t\t\t\t\tContribution payments will appear after they\u2019re first included when payroll is run.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<!-- Pagination -->\n\t\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true"></dir-pagination-controls>\n\t\t</div>\n\t</div>\n\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('features/app/team/profile/tabs/profileSchedulesView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<div class="sub-page-template-a fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div class="fadeIn" ng-if="schedules.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t<!-- Search Bar -->\n\t\t<search-bar options="searchBarOptions" count="filteredSchedules.length"></search-bar>\n\n\t\t<!-- Adjustment oveview -->\n\t\t<section class="sub-page-template-a-section">\n\t\t\t<div class="schedule-overview-cards">\n\t\t\t\t<schedule-overview-card agency-profile-id="$root.currentCompany.AgencyProfileID" index="$index" ng-repeat="schedule in filteredSchedules = (\n\t\t\t\t\t\tschedules\n\t\t\t\t\t\t| filter : searchBarOptions.search.string\n\t\t\t\t\t\t| filter : filterBarOptions.appliedFilter\n\t\t\t\t\t\t| orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse\n\t\t\t\t\t)" on-click="scheduleOnClick(schedule)" on-update="scheduleOnUpdate(schedule)" schedule="schedule" team-member="teamMember"></schedule-overview-card>\n\t\t\t</div>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredSchedules.length === 0"></empty-search>\n\t\t</section>\n\t</div>\n\n\t<!-- No schedules -->\n\t<div class="fadeIn" ng-if="!schedules.length">\n\t\t<placeholder placeholder-graphic="no-schedules">\n\t\t\t<placeholder-title>{{teamMember.Personal.Forename}} doesn\'t have any schedules</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>As schedules are created they will start to appear.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</div>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n\n');
$templateCache.put('features/app/team/profile/tabs/profileSicknessView.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n\n<div class="sub-page-template-a fadeIn profile-policy" ng-if="pageState === \'ready\'">\n\t<header class="profile-policy__header">\n\t\t<div class="stat-block d">\n\t\t\t<div class="stat-block__item assertive">\n\t\t\t\t<div class="stat-block__content">\n\t\t\t\t\t<div class="stat-block__graphic">\n\t\t\t\t\t\t<i class="icon-sick stat-block__icon"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<figure class="stat-block__figure">{{summary.Sickness.TotalSickness}}</figure>\n\t\t\t\t</div>\n\t\t\t\t<span class="stat-block__label">Days sick leave</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="spaced-links">\n\t\t\t<div class="spaced-links__item">\n\t\t\t\t<a ui-sref="hr.holiday-sickness({agencyProfileId: agencyProfileId})">\n\t\t\t\t\t<i class="icon-submission-history"></i> Go to tracker\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="spaced-links__item spaced-links__item--no-spacer">\n\t\t\t\t<a href="" ng-click="openEditSicknessPolicyForm()">\n\t\t\t\t\t<i class="icon-settings"></i> Edit policy\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class="spaced-links__item" ng-if="pageState === \'ready\'">\n\t\t\t\t<a class="button primary" data-cy="sickness-add-leave" href="" ng-click="openAddLeaveForm()"><i class="icon-plus"></i>&nbsp;Add leave</a>\n\t\t\t</div>\n\t\t</div>\n\t</header>\n\n\t<main class="profile-policy__body">\n\t\t<div class="profile-policy__filters">\n\n\t\t\t<!-- Filter -->\n\t\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t\t<!-- Search -->\n\t\t\t<search-bar options="searchBarOptions" count="filteredLeave.length"></search-bar>\n\t\t</div>\n\t\t<div class="profile-policy__leave-list {{searchBarOptions.layout}}">\n\t\t\t<leave-card callback="loadSickness()" dir-paginate="leave in filteredLeave = ( summary.Sickness.SicknessDetails | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" index="$index" is-integration-locked="leave.IsFromIntegration" leave="leave" leave-type="sickness" search-bar-options="searchBarOptions"></leave-card>\n\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredLeave.length === 0"></empty-search>\n\t\t</div>\n\t</main>\n</div>\n\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');
$templateCache.put('forms/admin/companySettings/journals/department-sub-code-overrides/company-settings-department-sub-code-overrides.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="departmentSubCodesOverridesForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateNominalCodeOverrides($ctrl, departmentSubCodesOverridesForm)" novalidate>\n\n\t<fieldset>\n\t\t<div class="sub-code-override_card">\n\t\t\t<icon-dot class="sub-code-override_card-icon" icon="icon-group" theme="is-large is-primary"></icon-dot>\n\t\t\t<h6>{{$ctrl.formOptions.businessCode.BusinessCodeNarrative}}</h6>\n\t\t</div>\n\t</fieldset>\n\n\t<fieldset>\n\t\t\n\t\t<div class="sub-code-override_row" ng-repeat="(nominalCodeIndex, nominalCode) in $ctrl.nominalCodes | filter: {IsUnallocatedNominalCode: false} | orderBy: \'NominalCodeValue\'">\n\t\t\t<div class="sub-code-override_row-header">\n\t\t\t\t<div class="sub-code-override_row-label">\n\t\t\t\t\t<i class="icon-csv is-medium sub-code-override_row-icon"></i>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<h6>{{nominalCode.NominalCodeValue}}</h6>\n\t\t\t\t\t\t<p class="is-medium">{{nominalCode.NominalCodeNarrative}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Edit -->\n\t\t\t\t<a class="is-greyscale is-small sub-code-override_row-action" href="" ng-click="$ctrl.toggleIsOverrideActive($ctrl, nominalCode)" ng-if="!nominalCode.isOverrideActive">\n\t\t\t\t\t<i class="icon-edit is-smedium"></i>\n\t\t\t\t\tOverride\n\t\t\t\t</a>\n\n\t\t\t\t<!-- Delete -->\n\t\t\t\t<a class="is-greyscale is-small sub-code-override_row-action" href="" ng-click="$ctrl.toggleIsOverrideActive($ctrl, nominalCode)" ng-if="nominalCode.isOverrideActive">\n\t\t\t\t\t<i class="icon-trash is-smedium"></i>\n\t\t\t\t\tDelete override\n\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t<div class="sub-code-override_row-action-block fadeIn" ng-if="nominalCode.isOverrideActive" ng-switch="nominalCode.overrideType">\n\t\t\t\t<div class="sub-code-override_row-action-block-item" ng-if="$ctrl.pensions.length > 0" ng-show="!nominalCode.NominalCodeOverrideArchived">\n\n\t\t\t\t\t<div>\n\n\t\t\t\t\t\t<input class="b radio-card-input" id="singleOverride{{$index}}" name="overrideType{{$index}}" ng-change="$ctrl.reviewOverrideType(nominalCode, $ctrl)" ng-model="nominalCode.overrideType" ng-value="$ctrl.PENSION_OVERRIDE_TYPES.single" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="singleOverride{{$index}}">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Single override</span>\n\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t<input class="b" id="overridePerPensionScheme{{$index}}" name="overrideType{{$index}}" ng-change="$ctrl.reviewOverrideType(nominalCode, $ctrl)" ng-model="nominalCode.overrideType" ng-value="$ctrl.PENSION_OVERRIDE_TYPES.pension" required type="radio">\n\t\t\t\t\t\t<label class="radio-card-label" for="overridePerPensionScheme{{$index}}">\n\t\t\t\t\t\t\t<span class="radio-card-option-text">Override per pension scheme</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Single -->\n\t\t\t\t<div class="sub-code-override_row-action-block-item" pc-switch-when="$ctrl.PENSION_OVERRIDE_TYPES.single">\n\t\t\t\t\t\n\t\t\t\t\t<div class="sub-code-override_row-action-row" ng-repeat="nominalCodeOverride in nominalCode.NominalCodeOverrides | filter: {NominalCodeOverrideArchived: false} track by $index">\n\t\t\t\t\t\t<div class="sub-code-override_row-action-row-input">\n\t\t\t\t\t\t\t<label class="required sub-code-override_row-action-row-label" for="subCode{{nominalCodeIndex}}-{{$index}}">Sub-code:</label>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<input class="sub-code-override_row-action-row-input-field s" id="subCode{{nominalCodeIndex}}-{{$index}}" name="overrideCode{{nominalCodeIndex}}-{{$index}}" maxlength="128" ng-change="$ctrl.onNominalCodeOverrideChange(nominalCodeOverride)" ng-model="nominalCodeOverride.NominalCodeOverrideValue" ng-pattern="$root.REGEX.lettersAndNumbers" placeholder="Enter code" required type="text">\n\t\t\t\t\t\t\t\t<div class="sub-code-override_row-action-row-errors fadeIn" ng-if="\n\t\t\t\t\t\t\t\t\t\tdepartmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$touched\n\t\t\t\t\t\t\t\t\t\t&& departmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$invalid\n\t\t\t\t\t\t\t\t\t" ng-messages="departmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Letters and numbers only</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Enter a value</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Pension -->\n\t\t\t\t<div class="sub-code-override_row-action-block-item" pc-switch-when="$ctrl.PENSION_OVERRIDE_TYPES.pension">\n\n\t\t\t\t\t<div class="sub-code-override_row-action-row" ng-repeat="nominalCodeOverride in nominalCode.NominalCodeOverrides | filter: {NominalCodeOverrideArchived: false} | orderBy: [ \'pensionProviderName\', \'employerReference\', \'AgencyEmployerPensionID\' ] track by nominalCodeOverride.AgencyEmployerPensionID">\n\t\t\t\t\t\t<div class="sub-code-override_row-action-row-input">\n\t\t\t\t\t\t\t<div class="sub-code-override_row-action-row-label-container">\n\t\t\t\t\t\t\t\t<label class="required sub-code-override_row-action-row-label" for="pensionOverrideCode{{nominalCodeIndex}}-{{$index}}">\n\t\t\t\t\t\t\t\t\t{{nominalCodeOverride.pensionProviderName}}:\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<p class="is-medium" ng-if="nominalCodeOverride.employerReference">\n\t\t\t\t\t\t\t\t\t{{nominalCodeOverride.employerReference}}\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<input class="sub-code-override_row-action-row-input-field s" id="pensionOverrideCode{{nominalCodeIndex}}-{{$index}}" name="overrideCode{{nominalCodeIndex}}-{{$index}}" maxlength="128" ng-model="nominalCodeOverride.NominalCodeOverrideValue" ng-pattern="$root.REGEX.lettersAndNumbers" placeholder="Enter code" required type="text">\n\t\t\t\t\t\t\t\t<div class="sub-code-override_row-action-row-errors fadeIn" ng-if="\n\t\t\t\t\t\t\t\t\t\tdepartmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$touched\n\t\t\t\t\t\t\t\t\t\t&& departmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$invalid\n\t\t\t\t\t\t\t\t\t" ng-messages="departmentSubCodesOverridesForm[\'overrideCode\' + nominalCodeIndex + \'-\' + $index].$error" role="alert">\n\t\t\t\t\t\t\t\t\t<p ng-message="pattern">Letters and numbers only</p>\n\t\t\t\t\t\t\t\t\t<p ng-message="required">Enter a value</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if="$ctrl.nominalCodes.length === 0">\n\t\t\t<placeholder placeholder-graphic="add-journal-codes">\n\t\t\t\t<placeholder-title>No nominal codes available</placeholder-title>\n\t\t\t\t<placeholder-copy>\n\t\t\t\t\t<p>Once you\u2019ve added nominal codes they will be available here so you can add overrides for this business category.</p>\n\t\t\t\t</placeholder-copy>\n\t\t\t\t<placeholder-primary-actions>\n\t\t\t\t\t<a class="is-primary strong s" ui-sref="settings.company.journals.nominal-codes({agencyProfileId: $ctrl.formOptions.agencyProfileId})">\n\t\t\t\t\t\tGo to nominal codes <i class="icon-chevron-right is-smedium"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</placeholder-primary-actions>\n\t\t\t</placeholder>\n\t\t</div>\n\n\t</fieldset>\n\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\t\t<submit-button disable-button="!departmentSubCodesOverridesForm.$valid" display-text="$ctrl.formOptions.primaryButtonText" state="departmentSubCodesOverridesForm.state"></submit-button>\n\t</fieldset>\n</form>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/journals/sub-code-overrides/company-settings-sub-code-overrides.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="subCodesOverridesForm" ng-if="$ctrl.formState === \'ready\'" ng-submit="$ctrl.updateNominalCodeOverridesEnabled($ctrl, subCodesOverridesForm)" novalidate>\n\n\t<fieldset>\n\t\t<settings-row ng-model="$ctrl.isSubCodeOverridesEnabled" on-update="$ctrl.checkBusinessCategory($ctrl)" sr-field-name="is-sub-code-overrides-enabled" sr-icon="csv" sr-theme="primary">\n\t\t\t<sr-label>Allow sub-code overrides</sr-label>\n\t\t\t<sr-description>Turning this on means that you\u2019ll be able to add sub-code overrides for one of your business categories.</sr-description>\n\t\t\t<sr-content ng-if="$ctrl.isSubCodeOverridesEnabled">\n\n\t\t\t\t<!-- Radio Rows List -->\n\t\t\t\t<div class="form-field">\n\t\t\t\t\t<div class="form-field-header">\n\t\t\t\t\t\t<label class="required" for="business-category-0">Select business category:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-field-main">\n\t\t\t\t\t\t<div class="radio-rows-list">\n\t\t\t\t\t\t\t<div class="radio-row" ng-repeat="businessCategory in $ctrl.formOptions.businessCategories | orderBy: BusinessCategoryName">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="business-category-option-{{$index}}" name="businessCategories" ng-model="$ctrl.businessCategoryId" ng-value="businessCategory.BusinessCategoryID" type="radio">\n\t\t\t\t\t\t\t\t<label for="business-category-option-{{$index}}" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">{{businessCategory.BusinessCategoryName}}</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- Only for indicative purposes -->\n\t\t\t\t\t\t\t<div class="radio-row" ng-show="false">\n\t\t\t\t\t\t\t\t<input class="b radio-row-input" id="business-category-option-{{$index}}" name="businessCategories" ng-model="$ctrl.businessCategoryId" ng-value="$root.CONFIG.guidEmpty" type="radio">\n\t\t\t\t\t\t\t\t<label for="business-category-option-{{$index}}" class="radio-row-label">\n\t\t\t\t\t\t\t\t\t<p class="radio-row-title">None</p>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</sr-content>\n\t\t</settings-row>\n\t</fieldset>\n\n\t<!-- Actions -->\n\t<fieldset class="form-actions">\n\t\t<a href="" class="button secondary-action" ng-click="$ctrl.formOptions.closeForm()">Cancel</a>\n\n\t\t<!-- Save -->\n\t\t<submit-button disable-button="!subCodesOverridesForm.$valid || ($ctrl.isSubCodeOverridesEnabled && $ctrl.businessCategoryId === $root.CONFIG.guidEmpty)" display-text="$ctrl.formOptions.primaryButtonText" state="subCodesOverridesForm.state"></submit-button>\n\t</fieldset>\n\n</form>\n\n<div ng-if="$ctrl.formState === \'no-business-categories\'">\n\t<fs-main>\n\t\t<placeholder placeholder-graphic="team">\n\t\t\t<placeholder-title>No business categories available</placeholder-title>\n\t\t\t<placeholder-copy>\n\t\t\t\t<p>Once you\u2019ve added business categories in your company settings area you\u2019ll be able to allow sub-code overrides.</p>\n\t\t\t</placeholder-copy>\n\t\t</placeholder>\n\t</fs-main>\n\t<fs-actions>\n\t\t<button class="secondary-action" ng-click="$ctrl.setFormState(\'ready\')">Back</button>\n\t</fs-actions>\n</div>\n\n<error-block ng-if="$ctrl.formState === \'error\'" secondary-action="$ctrl.formOptions.closeForm()" secondary-action-text="Ok, close this window"></error-block>\n');
$templateCache.put('forms/admin/companySettings/p11d-submission/delete/company-settings-p11db-submission-delete.form.html','<loading-block ng-if="$ctrl.formState === \'loading\'"></loading-block>\n\n<form class="fadeIn" name="companySettingsP11dbSubmissionDeleteForm" ng-submit="$ctrl.deleteSubmission($ctrl)" novalidate>\n\t<form-state form-options="$ctrl.formOptions" fs-icon="question-mark" fs-show-close="false" fs-title="Are you sure you wish to delete this submission?" ng-if="$ctrl.pageState === \'ready\'">\n\t\t<fs-main>\n\t\t\t<div>\n\t\t\t\t<p class="is-small">\n\t\t\t\t\tYour submission for the tax year {{::$ctrl.taxYearDisplay}} will be removed from your submissions page and you will need to start again. Click \'Confirm\' if you are happy to continue.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</fs-main>\n\n\t\t<fs-actions>\n\t\t\t<a class="button secondary-action" href="" ng-click="$ctrl.cancel()">\n\t\t\t\tCancel\n\t\t\t</a>\n\t\t\t<submit-button display-text="\'Confirm\'" ng-if="$ctrl.isConfirmDeleteVisible"></submit-button>\n\t\t</fs-actions>\n\t</form-state>\n\n\t<form-state form-options="$ctrl.formOptions" fs-icon="tick" fs-title="Submission deleted" fs-show-close="true" ng-if="$ctrl.pageState === \'deleted\'">\n\t\t<fs-main>\n\t\t\t<p class="is-small">\n\t\t\t\tYour submission for tax year {{::$ctrl.taxYearDisplay}} has been removed.\n\t\t\t</p>\n\t\t</fs-main>\n\t</form-state>\n\n</form>\n\n');
$templateCache.put('features/app/team/profile/tabs/link-rates/profile-link-rates.view.html','<loading-block ng-if="pageState === \'loading\'"></loading-block>\n\n<main class="page-template-a-main fadeIn" ng-if="pageState === \'ready\'">\n\n\t<div ng-if="userPayElementDetails && userPayElementDetails.PayElements.length">\n\n\t\t<!-- Filter Bar -->\n\t\t<filter-bar filter-bar-options="filterBarOptions"></filter-bar>\n\n\t\t<!-- Search bar -->\n\t\t<search-bar options="searchBarOptions" count="filteredLinkRates.length">\n\t\t\t<sb-right-actions>\n\t\t\t\t<a href="" class="button primary" ng-click="openLinkRateForm(userPayElementDetails.PayElements)" data-cy="add-link-rate">+ Add link rate</a>\n\t\t\t</sb-right-actions>\n\t\t</search-bar>\n\n\t\t<!-- Link elements -->\n\t\t<section>\n\n\t\t\t<div class="link-rate-cards">\n\t\t\t\t<link-rate-card agency-profile-id="agencyProfileId" dir-paginate="linkRate in filteredLinkRates = ( userPayElementDetails.PayElements | filter : searchBarOptions.search.string | filter : filterBarOptions.appliedFilter ) | orderBy : searchBarOptions.orderBy : searchBarOptions.results.reverse | itemsPerPage : searchBarOptions.results.itemsPerPage" link-rate="linkRate" on-update="refreshLinkRates" user-id="userId">\n\t\t\t\t</link-rate-card>\n\t\t\t</div>\n\n\t\t\t<!-- No search results -->\n\t\t\t<empty-search search-bar-options="searchBarOptions" ng-show="filteredLinkRates.length === 0"></empty-search>\n\t\t</section>\n\n\t\t<!-- Pagination -->\n\t\t<dir-pagination-controls max-size="7" direction-links="true" boundary-links="true" on-page-change="searchBarOptions.onPageChange(newPageNumber)"></dir-pagination-controls>\n\t</div>\n\n\t<!-- No results -->\n\t<placeholder placeholder-graphic="no-link-elements" ng-if="!userPayElementDetails || !userPayElementDetails.PayElements.length">\n\t\t<placeholder-title>No link rates</placeholder-title>\n\t\t<placeholder-copy>\n\t\t\t<p>Once you&apos;ve added link rates they will appear here and also be available in your current period so you can add changes each pay period.</p>\n\t\t</placeholder-copy>\n\t\t<placeholder-primary-actions>\n\t\t\t<a href="" ng-click="openLinkRateForm()" class="button primary" data-cy="add-link-rate">+ Add link rate</a>\n\t\t</placeholder-primary-actions>\n\t</placeholder>\n</main>\n\n<!-- Error block if there are any issues when loading data -->\n<error-block has-gutter="true" ng-if="pageState === \'error\'"></error-block>\n');}]);